
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7add"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7add"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8Oe8o", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $669df503026dc065$export$ffb0004e005737fa, (v) => $669df503026dc065$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $669df503026dc065$export$34b9dba7ce09269b, (v) => $669df503026dc065$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $669df503026dc065$export$25062201e9e25d76, (v) => $669df503026dc065$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $669df503026dc065$export$ffb0004e005737fa;
var $669df503026dc065$export$34b9dba7ce09269b;
var $669df503026dc065$export$25062201e9e25d76;
"use strict";
var $669df503026dc065$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $669df503026dc065$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $669df503026dc065$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $669df503026dc065$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$669df503026dc065$export$ffb0004e005737fa = $669df503026dc065$var$REACT_FRAGMENT_TYPE;
$669df503026dc065$export$34b9dba7ce09269b = $669df503026dc065$var$jsxProd;
$669df503026dc065$export$25062201e9e25d76 = $669df503026dc065$var$jsxProd;

});

parcelRegister("cITiu", function(module, exports) {
'use strict';
function $94347cf79186e453$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($94347cf79186e453$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$94347cf79186e453$var$checkDCE();

module.exports = (parcelRequire("6QPdl"));

});
parcelRegister("6QPdl", function(module, exports) {
$parcel$export(module.exports, "createRoot", () => $4fcf5377eb083461$export$882461b6382ed46c, (v) => $4fcf5377eb083461$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $4fcf5377eb083461$export$757ceba2d55c277e, (v) => $4fcf5377eb083461$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $4fcf5377eb083461$export$83d89fbfd8236492, (v) => $4fcf5377eb083461$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $4fcf5377eb083461$export$882461b6382ed46c;
var $4fcf5377eb083461$export$757ceba2d55c277e;
var $4fcf5377eb083461$export$83d89fbfd8236492;

var $3ZMUU = parcelRequire("3ZMUU");
"use strict";

var $2tm1P = parcelRequire("2tm1P");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");
function $4fcf5377eb083461$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4fcf5377eb083461$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $4fcf5377eb083461$var$getNearestMountedFiber(fiber) {
    for(var node = fiber, nextNode = node; nextNode && !nextNode.alternate;)node = nextNode, 0 !== (node.flags & 4098) && (fiber = node.return), nextNode = node.return;
    for(; node.return;)node = node.return;
    return 3 === node.tag ? fiber : null;
}
function $4fcf5377eb083461$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $4fcf5377eb083461$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $4fcf5377eb083461$var$assertIsMounted(fiber) {
    if ($4fcf5377eb083461$var$getNearestMountedFiber(fiber) !== fiber) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(188));
}
function $4fcf5377eb083461$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $4fcf5377eb083461$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $4fcf5377eb083461$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $4fcf5377eb083461$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($4fcf5377eb083461$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $4fcf5377eb083461$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $4fcf5377eb083461$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
function $4fcf5377eb083461$var$traverseVisibleInstancesAndTextInstances(child, searchWithinHosts, fn, a, b, c) {
    for(; null !== child;){
        if ((5 === child.tag || 27 === child.tag || 6 === child.tag) && fn(child, a, b, c) || (22 !== child.tag || null === child.memoizedState) && (searchWithinHosts || 5 !== child.tag && 27 !== child.tag) && $4fcf5377eb083461$var$traverseVisibleInstancesAndTextInstances(child.child, searchWithinHosts, fn, a, b, c)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $4fcf5377eb083461$var$getFragmentParentInstanceOrContainerFiber(fiber) {
    for(fiber = fiber.return; null !== fiber;){
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) return fiber;
        fiber = fiber.return;
    }
    return null;
}
function $4fcf5377eb083461$var$fiberIsPortaledIntoHost(fiber) {
    var foundPortalParent = !1;
    for(fiber = fiber.return; null !== fiber;){
        4 === fiber.tag && (foundPortalParent = !0);
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) break;
        fiber = fiber.return;
    }
    return foundPortalParent;
}
function $4fcf5377eb083461$var$getFragmentInstanceOrTextInstanceSiblings(fiber) {
    var result = [
        null,
        null
    ], parentHostFiber = $4fcf5377eb083461$var$getFragmentParentInstanceOrContainerFiber(fiber);
    if (null === parentHostFiber) return result;
    $4fcf5377eb083461$var$findFragmentInstanceOrTextInstanceSiblings(result, fiber, parentHostFiber.child, {
        foundSelf: !1
    });
    return result;
}
function $4fcf5377eb083461$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child, state) {
    for(; null !== child;){
        if (child === self) state.foundSelf = !0;
        else if (5 === child.tag || 27 === child.tag || 6 === child.tag) {
            if (state.foundSelf) return result[1] = child, !0;
            result[0] = child;
        } else if ((22 !== child.tag || null === child.memoizedState) && $4fcf5377eb083461$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child.child, state)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $4fcf5377eb083461$var$getInstanceFromHostFiber(fiber) {
    switch(fiber.tag){
        case 5:
        case 27:
        case 6:
            return fiber.stateNode;
        case 3:
            return fiber.stateNode.containerInfo;
        default:
            throw Error($4fcf5377eb083461$var$formatProdErrorMessage(559));
    }
}
var $4fcf5377eb083461$var$searchTarget = null, $4fcf5377eb083461$var$searchBoundary = null;
function $4fcf5377eb083461$var$isFiberPrecedingCheck(child, target, boundary) {
    return child === boundary ? !0 : child === target ? ($4fcf5377eb083461$var$searchTarget = child, !0) : !1;
}
function $4fcf5377eb083461$var$isFiberFollowingCheck(child, target, boundary) {
    return child === boundary ? ($4fcf5377eb083461$var$searchBoundary = child, !1) : child === target ? (null !== $4fcf5377eb083461$var$searchBoundary && ($4fcf5377eb083461$var$searchTarget = child), !0) : !1;
}
function $4fcf5377eb083461$var$getParentForFragmentAncestors(inst) {
    if (null === inst) return null;
    do inst = null === inst ? null : inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag && 3 !== inst.tag);
    return inst ? inst : null;
}
function $4fcf5377eb083461$var$getLowestCommonAncestor(instA, instB, getParent) {
    for(var depthA = 0, tempA = instA; tempA; tempA = getParent(tempA))depthA++;
    tempA = 0;
    for(var tempB = instB; tempB; tempB = getParent(tempB))tempA++;
    for(; 0 < depthA - tempA;)instA = getParent(instA), depthA--;
    for(; 0 < tempA - depthA;)instB = getParent(instB), tempA--;
    for(; depthA--;){
        if (instA === instB || null !== instB && instA === instB.alternate) return instA;
        instA = getParent(instA);
        instB = getParent(instB);
    }
    return null;
}
var $4fcf5377eb083461$var$assign = Object.assign, $4fcf5377eb083461$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $4fcf5377eb083461$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $4fcf5377eb083461$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $4fcf5377eb083461$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $4fcf5377eb083461$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $4fcf5377eb083461$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $4fcf5377eb083461$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $4fcf5377eb083461$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $4fcf5377eb083461$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $4fcf5377eb083461$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $4fcf5377eb083461$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $4fcf5377eb083461$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $4fcf5377eb083461$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $4fcf5377eb083461$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $4fcf5377eb083461$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $4fcf5377eb083461$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $4fcf5377eb083461$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $4fcf5377eb083461$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $4fcf5377eb083461$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $4fcf5377eb083461$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $4fcf5377eb083461$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$4fcf5377eb083461$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $4fcf5377eb083461$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $4fcf5377eb083461$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $4fcf5377eb083461$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $4fcf5377eb083461$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $4fcf5377eb083461$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $4fcf5377eb083461$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $4fcf5377eb083461$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $4fcf5377eb083461$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $4fcf5377eb083461$var$REACT_ACTIVITY_TYPE:
            return "Activity";
        case $4fcf5377eb083461$var$REACT_VIEW_TRANSITION_TYPE:
            return "ViewTransition";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $4fcf5377eb083461$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $4fcf5377eb083461$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $4fcf5377eb083461$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $4fcf5377eb083461$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $4fcf5377eb083461$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $4fcf5377eb083461$var$getComponentNameFromType(type.type) || "Memo";
        case $4fcf5377eb083461$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $4fcf5377eb083461$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $4fcf5377eb083461$var$isArrayImpl = Array.isArray, $4fcf5377eb083461$var$ReactSharedInternals = $5FkrB.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $4fcf5377eb083461$var$ReactDOMSharedInternals = $aLeHs.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $4fcf5377eb083461$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $4fcf5377eb083461$var$valueStack = [], $4fcf5377eb083461$var$index = -1;
function $4fcf5377eb083461$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $4fcf5377eb083461$var$pop(cursor) {
    0 > $4fcf5377eb083461$var$index || (cursor.current = $4fcf5377eb083461$var$valueStack[$4fcf5377eb083461$var$index], $4fcf5377eb083461$var$valueStack[$4fcf5377eb083461$var$index] = null, $4fcf5377eb083461$var$index--);
}
function $4fcf5377eb083461$var$push(cursor, value) {
    $4fcf5377eb083461$var$index++;
    $4fcf5377eb083461$var$valueStack[$4fcf5377eb083461$var$index] = cursor.current;
    cursor.current = value;
}
var $4fcf5377eb083461$var$contextStackCursor = $4fcf5377eb083461$var$createCursor(null), $4fcf5377eb083461$var$contextFiberStackCursor = $4fcf5377eb083461$var$createCursor(null), $4fcf5377eb083461$var$rootInstanceStackCursor = $4fcf5377eb083461$var$createCursor(null), $4fcf5377eb083461$var$hostTransitionProviderCursor = $4fcf5377eb083461$var$createCursor(null);
function $4fcf5377eb083461$var$pushHostContainer(fiber, nextRootInstance) {
    $4fcf5377eb083461$var$push($4fcf5377eb083461$var$rootInstanceStackCursor, nextRootInstance);
    $4fcf5377eb083461$var$push($4fcf5377eb083461$var$contextFiberStackCursor, fiber);
    $4fcf5377eb083461$var$push($4fcf5377eb083461$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $4fcf5377eb083461$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $4fcf5377eb083461$var$getOwnHostContext(nextRootInstance), fiber = $4fcf5377eb083461$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $4fcf5377eb083461$var$pop($4fcf5377eb083461$var$contextStackCursor);
    $4fcf5377eb083461$var$push($4fcf5377eb083461$var$contextStackCursor, fiber);
}
function $4fcf5377eb083461$var$popHostContainer() {
    $4fcf5377eb083461$var$pop($4fcf5377eb083461$var$contextStackCursor);
    $4fcf5377eb083461$var$pop($4fcf5377eb083461$var$contextFiberStackCursor);
    $4fcf5377eb083461$var$pop($4fcf5377eb083461$var$rootInstanceStackCursor);
}
function $4fcf5377eb083461$var$pushHostContext(fiber) {
    var stateHook = fiber.memoizedState;
    null !== stateHook && ($4fcf5377eb083461$var$HostTransitionContext._currentValue = stateHook.memoizedState, $4fcf5377eb083461$var$push($4fcf5377eb083461$var$hostTransitionProviderCursor, fiber));
    stateHook = $4fcf5377eb083461$var$contextStackCursor.current;
    var JSCompiler_inline_result = $4fcf5377eb083461$var$getChildHostContextProd(stateHook, fiber.type);
    stateHook !== JSCompiler_inline_result && ($4fcf5377eb083461$var$push($4fcf5377eb083461$var$contextFiberStackCursor, fiber), $4fcf5377eb083461$var$push($4fcf5377eb083461$var$contextStackCursor, JSCompiler_inline_result));
}
function $4fcf5377eb083461$var$popHostContext(fiber) {
    $4fcf5377eb083461$var$contextFiberStackCursor.current === fiber && ($4fcf5377eb083461$var$pop($4fcf5377eb083461$var$contextStackCursor), $4fcf5377eb083461$var$pop($4fcf5377eb083461$var$contextFiberStackCursor));
    $4fcf5377eb083461$var$hostTransitionProviderCursor.current === fiber && ($4fcf5377eb083461$var$pop($4fcf5377eb083461$var$hostTransitionProviderCursor), $4fcf5377eb083461$var$HostTransitionContext._currentValue = $4fcf5377eb083461$var$sharedNotPendingObject);
}
var $4fcf5377eb083461$var$prefix, $4fcf5377eb083461$var$suffix;
function $4fcf5377eb083461$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $4fcf5377eb083461$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $4fcf5377eb083461$var$prefix = match && match[1] || "";
        $4fcf5377eb083461$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $4fcf5377eb083461$var$prefix + name + $4fcf5377eb083461$var$suffix;
}
var $4fcf5377eb083461$var$reentry = !1;
function $4fcf5377eb083461$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $4fcf5377eb083461$var$reentry) return "";
    $4fcf5377eb083461$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            Fake = !1;
                            try {
                                var prevProps = Object.getOwnPropertyDescriptor(fn.prototype, "props");
                                Object.defineProperty(fn.prototype, "props", {
                                    configurable: !0,
                                    set: function() {
                                        throw Error();
                                    }
                                });
                                Fake = !0;
                                new fn();
                            } finally{
                                Fake && (void 0 !== prevProps ? Object.defineProperty(fn.prototype, "props", prevProps) : delete fn.prototype.props);
                            }
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $4fcf5377eb083461$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $4fcf5377eb083461$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $4fcf5377eb083461$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $4fcf5377eb083461$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $4fcf5377eb083461$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $4fcf5377eb083461$var$describeBuiltInComponentFrame("Suspense Fallback") : $4fcf5377eb083461$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $4fcf5377eb083461$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $4fcf5377eb083461$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $4fcf5377eb083461$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $4fcf5377eb083461$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $4fcf5377eb083461$var$describeBuiltInComponentFrame("Activity");
        case 30:
            return $4fcf5377eb083461$var$describeBuiltInComponentFrame("ViewTransition");
        default:
            return "";
    }
}
function $4fcf5377eb083461$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $4fcf5377eb083461$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $4fcf5377eb083461$var$hasOwnProperty = Object.prototype.hasOwnProperty, $4fcf5377eb083461$var$scheduleCallback$3 = $2tm1P.unstable_scheduleCallback, $4fcf5377eb083461$var$cancelCallback$1 = $2tm1P.unstable_cancelCallback, $4fcf5377eb083461$var$shouldYield = $2tm1P.unstable_shouldYield, $4fcf5377eb083461$var$requestPaint = $2tm1P.unstable_requestPaint, $4fcf5377eb083461$var$now = $2tm1P.unstable_now, $4fcf5377eb083461$var$getCurrentPriorityLevel = $2tm1P.unstable_getCurrentPriorityLevel, $4fcf5377eb083461$var$ImmediatePriority = $2tm1P.unstable_ImmediatePriority, $4fcf5377eb083461$var$UserBlockingPriority = $2tm1P.unstable_UserBlockingPriority, $4fcf5377eb083461$var$NormalPriority$1 = $2tm1P.unstable_NormalPriority, $4fcf5377eb083461$var$LowPriority = $2tm1P.unstable_LowPriority, $4fcf5377eb083461$var$IdlePriority = $2tm1P.unstable_IdlePriority, $4fcf5377eb083461$var$log$1 = $2tm1P.log, $4fcf5377eb083461$var$unstable_setDisableYieldValue = $2tm1P.unstable_setDisableYieldValue, $4fcf5377eb083461$var$rendererID = null, $4fcf5377eb083461$var$injectedHook = null;
function $4fcf5377eb083461$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $4fcf5377eb083461$var$log$1 && $4fcf5377eb083461$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($4fcf5377eb083461$var$injectedHook && "function" === typeof $4fcf5377eb083461$var$injectedHook.setStrictMode) try {
        $4fcf5377eb083461$var$injectedHook.setStrictMode($4fcf5377eb083461$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $4fcf5377eb083461$var$clz32 = Math.clz32 ? Math.clz32 : $4fcf5377eb083461$var$clz32Fallback, $4fcf5377eb083461$var$log = Math.log, $4fcf5377eb083461$var$LN2 = Math.LN2;
function $4fcf5377eb083461$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($4fcf5377eb083461$var$log(x) / $4fcf5377eb083461$var$LN2 | 0) | 0;
}
var $4fcf5377eb083461$var$nextTransitionUpdateLane = 256, $4fcf5377eb083461$var$nextTransitionDeferredLane = 262144, $4fcf5377eb083461$var$nextRetryLane = 4194304;
function $4fcf5377eb083461$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & -lanes;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $4fcf5377eb083461$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $4fcf5377eb083461$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $4fcf5377eb083461$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $4fcf5377eb083461$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $4fcf5377eb083461$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $4fcf5377eb083461$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $4fcf5377eb083461$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $4fcf5377eb083461$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $4fcf5377eb083461$var$getEntangledLanes(root, renderLanes) {
    0 !== (renderLanes & 8) && (renderLanes |= renderLanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= renderLanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $4fcf5377eb083461$var$clz32(allEntangledLanes), lane = 1 << index$4;
        renderLanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    return renderLanes;
}
function $4fcf5377eb083461$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $4fcf5377eb083461$var$claimNextRetryLane() {
    var lane = $4fcf5377eb083461$var$nextRetryLane;
    $4fcf5377eb083461$var$nextRetryLane <<= 1;
    0 === ($4fcf5377eb083461$var$nextRetryLane & 62914560) && ($4fcf5377eb083461$var$nextRetryLane = 4194304);
    return lane;
}
function $4fcf5377eb083461$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $4fcf5377eb083461$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $4fcf5377eb083461$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $4fcf5377eb083461$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $4fcf5377eb083461$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $4fcf5377eb083461$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $4fcf5377eb083461$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $4fcf5377eb083461$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $4fcf5377eb083461$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $4fcf5377eb083461$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $4fcf5377eb083461$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $4fcf5377eb083461$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $4fcf5377eb083461$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $4fcf5377eb083461$var$resolveUpdatePriority() {
    var updatePriority = $4fcf5377eb083461$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $4fcf5377eb083461$var$getEventPriority(updatePriority.type);
}
function $4fcf5377eb083461$var$runWithPriority(priority, fn) {
    var previousPriority = $4fcf5377eb083461$var$ReactDOMSharedInternals.p;
    try {
        return $4fcf5377eb083461$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $4fcf5377eb083461$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $4fcf5377eb083461$var$randomKey = Math.random().toString(36).slice(2), $4fcf5377eb083461$var$internalInstanceKey = "__reactFiber$" + $4fcf5377eb083461$var$randomKey, $4fcf5377eb083461$var$internalPropsKey = "__reactProps$" + $4fcf5377eb083461$var$randomKey, $4fcf5377eb083461$var$internalContainerInstanceKey = "__reactContainer$" + $4fcf5377eb083461$var$randomKey, $4fcf5377eb083461$var$internalEventHandlersKey = "__reactEvents$" + $4fcf5377eb083461$var$randomKey, $4fcf5377eb083461$var$internalEventHandlerListenersKey = "__reactListeners$" + $4fcf5377eb083461$var$randomKey, $4fcf5377eb083461$var$internalEventHandlesSetKey = "__reactHandles$" + $4fcf5377eb083461$var$randomKey, $4fcf5377eb083461$var$internalRootNodeResourcesKey = "__reactResources$" + $4fcf5377eb083461$var$randomKey, $4fcf5377eb083461$var$internalHoistableMarker = "__reactMarker$" + $4fcf5377eb083461$var$randomKey, $4fcf5377eb083461$var$internalLoadPendingKey = "__reactLoad$" + $4fcf5377eb083461$var$randomKey;
function $4fcf5377eb083461$var$detachDeletedInstance(node) {
    delete node[$4fcf5377eb083461$var$internalInstanceKey];
    delete node[$4fcf5377eb083461$var$internalPropsKey];
    delete node[$4fcf5377eb083461$var$internalEventHandlerListenersKey];
    delete node[$4fcf5377eb083461$var$internalEventHandlesSetKey];
}
function $4fcf5377eb083461$var$getClosestInstanceFromNode(targetNode) {
    var targetInst;
    if (targetInst = targetNode[$4fcf5377eb083461$var$internalInstanceKey]) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$4fcf5377eb083461$var$internalContainerInstanceKey] || parentNode[$4fcf5377eb083461$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $4fcf5377eb083461$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$4fcf5377eb083461$var$internalInstanceKey]) return parentNode;
                targetNode = $4fcf5377eb083461$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $4fcf5377eb083461$var$getInstanceFromNode(node) {
    if (node = node[$4fcf5377eb083461$var$internalInstanceKey] || node[$4fcf5377eb083461$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $4fcf5377eb083461$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($4fcf5377eb083461$var$formatProdErrorMessage(33));
}
function $4fcf5377eb083461$var$getResourcesFromRoot(root) {
    var resources = root[$4fcf5377eb083461$var$internalRootNodeResourcesKey];
    resources || (resources = root[$4fcf5377eb083461$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $4fcf5377eb083461$var$markNodeAsHoistable(node) {
    node[$4fcf5377eb083461$var$internalHoistableMarker] = !0;
}
function $4fcf5377eb083461$var$clearPendingLoadOnNode(node) {
    node[$4fcf5377eb083461$var$internalLoadPendingKey] = void 0;
}
var $4fcf5377eb083461$var$allNativeEvents = new Set(), $4fcf5377eb083461$var$registrationNameDependencies = {};
function $4fcf5377eb083461$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $4fcf5377eb083461$var$registerDirectEvent(registrationName, dependencies);
    $4fcf5377eb083461$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $4fcf5377eb083461$var$registerDirectEvent(registrationName, dependencies) {
    $4fcf5377eb083461$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$4fcf5377eb083461$var$allNativeEvents.add(dependencies[registrationName]);
}
var $4fcf5377eb083461$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $4fcf5377eb083461$var$illegalAttributeNameCache = {}, $4fcf5377eb083461$var$validatedAttributeNameCache = {};
function $4fcf5377eb083461$var$isAttributeNameSafe(attributeName) {
    if ($4fcf5377eb083461$var$hasOwnProperty.call($4fcf5377eb083461$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($4fcf5377eb083461$var$hasOwnProperty.call($4fcf5377eb083461$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($4fcf5377eb083461$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $4fcf5377eb083461$var$validatedAttributeNameCache[attributeName] = !0;
    $4fcf5377eb083461$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $4fcf5377eb083461$var$viewTransitionMutationContext = !1;
function $4fcf5377eb083461$var$pushMutationContext() {
    var prev = $4fcf5377eb083461$var$viewTransitionMutationContext;
    $4fcf5377eb083461$var$viewTransitionMutationContext = !1;
    return prev;
}
function $4fcf5377eb083461$var$setValueForAttribute(node, name, value) {
    if ($4fcf5377eb083461$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, value);
        }
    }
}
function $4fcf5377eb083461$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, value);
    }
}
function $4fcf5377eb083461$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, value);
    }
}
function $4fcf5377eb083461$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $4fcf5377eb083461$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $4fcf5377eb083461$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $4fcf5377eb083461$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $4fcf5377eb083461$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $4fcf5377eb083461$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $4fcf5377eb083461$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $4fcf5377eb083461$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
var $4fcf5377eb083461$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $4fcf5377eb083461$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($4fcf5377eb083461$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $4fcf5377eb083461$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $4fcf5377eb083461$var$getToStringValue(value);
        } else element.value !== "" + $4fcf5377eb083461$var$getToStringValue(value) && (element.value = "" + $4fcf5377eb083461$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? "number" === type && element.value == value ? $4fcf5377eb083461$var$setDefaultValue(element, $4fcf5377eb083461$var$getToStringValue(element.value)) : $4fcf5377eb083461$var$setDefaultValue(element, $4fcf5377eb083461$var$getToStringValue(value)) : null != defaultValue ? $4fcf5377eb083461$var$setDefaultValue(element, $4fcf5377eb083461$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $4fcf5377eb083461$var$getToStringValue(name) : element.removeAttribute("name");
}
function $4fcf5377eb083461$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $4fcf5377eb083461$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $4fcf5377eb083461$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $4fcf5377eb083461$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $4fcf5377eb083461$var$track(element);
}
function $4fcf5377eb083461$var$setDefaultValue(node, value) {
    node.defaultValue !== "" + value && (node.defaultValue = "" + value);
}
function $4fcf5377eb083461$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $4fcf5377eb083461$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $4fcf5377eb083461$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $4fcf5377eb083461$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $4fcf5377eb083461$var$getToStringValue(defaultValue) : "";
}
function $4fcf5377eb083461$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(92));
            if ($4fcf5377eb083461$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $4fcf5377eb083461$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $4fcf5377eb083461$var$track(element);
}
function $4fcf5377eb083461$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $4fcf5377eb083461$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $4fcf5377eb083461$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $4fcf5377eb083461$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $4fcf5377eb083461$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "", $4fcf5377eb083461$var$viewTransitionMutationContext = !0);
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && ($4fcf5377eb083461$var$setValueForStyle(node, styleName$16, styleName), $4fcf5377eb083461$var$viewTransitionMutationContext = !0);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $4fcf5377eb083461$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $4fcf5377eb083461$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $4fcf5377eb083461$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "maskType",
        "mask-type"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $4fcf5377eb083461$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $4fcf5377eb083461$var$sanitizeURL(url) {
    return $4fcf5377eb083461$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $4fcf5377eb083461$var$noop$1() {}
var $4fcf5377eb083461$var$currentReplayingEvent = null;
function $4fcf5377eb083461$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $4fcf5377eb083461$var$restoreTarget = null, $4fcf5377eb083461$var$restoreQueue = null;
function $4fcf5377eb083461$var$restoreStateOfTarget(target) {
    var internalInstance = $4fcf5377eb083461$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$4fcf5377eb083461$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $4fcf5377eb083461$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $4fcf5377eb083461$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$4fcf5377eb083461$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(90));
                            $4fcf5377eb083461$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $4fcf5377eb083461$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $4fcf5377eb083461$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $4fcf5377eb083461$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $4fcf5377eb083461$var$isInsideEventHandler = !1;
function $4fcf5377eb083461$var$batchedUpdates$1(fn, a, b) {
    if ($4fcf5377eb083461$var$isInsideEventHandler) return fn(a, b);
    $4fcf5377eb083461$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($4fcf5377eb083461$var$isInsideEventHandler = !1, null !== $4fcf5377eb083461$var$restoreTarget || null !== $4fcf5377eb083461$var$restoreQueue) {
            if ($4fcf5377eb083461$var$flushSyncWork$1(), $4fcf5377eb083461$var$restoreTarget && (a = $4fcf5377eb083461$var$restoreTarget, fn = $4fcf5377eb083461$var$restoreQueue, $4fcf5377eb083461$var$restoreQueue = $4fcf5377eb083461$var$restoreTarget = null, $4fcf5377eb083461$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$4fcf5377eb083461$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $4fcf5377eb083461$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$4fcf5377eb083461$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $4fcf5377eb083461$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $4fcf5377eb083461$var$passiveBrowserEventsSupported = !1;
if ($4fcf5377eb083461$var$canUseDOM) try {
    var $4fcf5377eb083461$var$options = {};
    Object.defineProperty($4fcf5377eb083461$var$options, "passive", {
        get: function() {
            $4fcf5377eb083461$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $4fcf5377eb083461$var$options, $4fcf5377eb083461$var$options);
    window.removeEventListener("test", $4fcf5377eb083461$var$options, $4fcf5377eb083461$var$options);
} catch (e) {
    $4fcf5377eb083461$var$passiveBrowserEventsSupported = !1;
}
var $4fcf5377eb083461$var$root = null, $4fcf5377eb083461$var$startText = null, $4fcf5377eb083461$var$fallbackText = null;
function $4fcf5377eb083461$var$getData() {
    if ($4fcf5377eb083461$var$fallbackText) return $4fcf5377eb083461$var$fallbackText;
    var start, startValue = $4fcf5377eb083461$var$startText, startLength = startValue.length, end, endValue = "value" in $4fcf5377eb083461$var$root ? $4fcf5377eb083461$var$root.value : $4fcf5377eb083461$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $4fcf5377eb083461$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $4fcf5377eb083461$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $4fcf5377eb083461$var$functionThatReturnsTrue() {
    return !0;
}
function $4fcf5377eb083461$var$functionThatReturnsFalse() {
    return !1;
}
function $4fcf5377eb083461$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $4fcf5377eb083461$var$functionThatReturnsTrue : $4fcf5377eb083461$var$functionThatReturnsFalse;
        this.isPropagationStopped = $4fcf5377eb083461$var$functionThatReturnsFalse;
        return this;
    }
    $4fcf5377eb083461$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $4fcf5377eb083461$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $4fcf5377eb083461$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $4fcf5377eb083461$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $4fcf5377eb083461$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $4fcf5377eb083461$var$SyntheticEvent = $4fcf5377eb083461$var$createSyntheticEvent($4fcf5377eb083461$var$EventInterface), $4fcf5377eb083461$var$UIEventInterface = $4fcf5377eb083461$var$assign({}, $4fcf5377eb083461$var$EventInterface, {
    view: 0,
    detail: 0
}), $4fcf5377eb083461$var$SyntheticUIEvent = $4fcf5377eb083461$var$createSyntheticEvent($4fcf5377eb083461$var$UIEventInterface), $4fcf5377eb083461$var$lastMovementX, $4fcf5377eb083461$var$lastMovementY, $4fcf5377eb083461$var$lastMouseEvent, $4fcf5377eb083461$var$MouseEventInterface = $4fcf5377eb083461$var$assign({}, $4fcf5377eb083461$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $4fcf5377eb083461$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $4fcf5377eb083461$var$lastMouseEvent && ($4fcf5377eb083461$var$lastMouseEvent && "mousemove" === event.type ? ($4fcf5377eb083461$var$lastMovementX = event.screenX - $4fcf5377eb083461$var$lastMouseEvent.screenX, $4fcf5377eb083461$var$lastMovementY = event.screenY - $4fcf5377eb083461$var$lastMouseEvent.screenY) : $4fcf5377eb083461$var$lastMovementY = $4fcf5377eb083461$var$lastMovementX = 0, $4fcf5377eb083461$var$lastMouseEvent = event);
        return $4fcf5377eb083461$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $4fcf5377eb083461$var$lastMovementY;
    }
}), $4fcf5377eb083461$var$SyntheticMouseEvent = $4fcf5377eb083461$var$createSyntheticEvent($4fcf5377eb083461$var$MouseEventInterface), $4fcf5377eb083461$var$DragEventInterface = $4fcf5377eb083461$var$assign({}, $4fcf5377eb083461$var$MouseEventInterface, {
    dataTransfer: 0
}), $4fcf5377eb083461$var$SyntheticDragEvent = $4fcf5377eb083461$var$createSyntheticEvent($4fcf5377eb083461$var$DragEventInterface), $4fcf5377eb083461$var$FocusEventInterface = $4fcf5377eb083461$var$assign({}, $4fcf5377eb083461$var$UIEventInterface, {
    relatedTarget: 0
}), $4fcf5377eb083461$var$SyntheticFocusEvent = $4fcf5377eb083461$var$createSyntheticEvent($4fcf5377eb083461$var$FocusEventInterface), $4fcf5377eb083461$var$AnimationEventInterface = $4fcf5377eb083461$var$assign({}, $4fcf5377eb083461$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4fcf5377eb083461$var$SyntheticAnimationEvent = $4fcf5377eb083461$var$createSyntheticEvent($4fcf5377eb083461$var$AnimationEventInterface), $4fcf5377eb083461$var$ClipboardEventInterface = $4fcf5377eb083461$var$assign({}, $4fcf5377eb083461$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $4fcf5377eb083461$var$SyntheticClipboardEvent = $4fcf5377eb083461$var$createSyntheticEvent($4fcf5377eb083461$var$ClipboardEventInterface), $4fcf5377eb083461$var$CompositionEventInterface = $4fcf5377eb083461$var$assign({}, $4fcf5377eb083461$var$EventInterface, {
    data: 0
}), $4fcf5377eb083461$var$SyntheticCompositionEvent = $4fcf5377eb083461$var$createSyntheticEvent($4fcf5377eb083461$var$CompositionEventInterface), $4fcf5377eb083461$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $4fcf5377eb083461$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $4fcf5377eb083461$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $4fcf5377eb083461$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $4fcf5377eb083461$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $4fcf5377eb083461$var$getEventModifierState() {
    return $4fcf5377eb083461$var$modifierStateGetter;
}
var $4fcf5377eb083461$var$KeyboardEventInterface = $4fcf5377eb083461$var$assign({}, $4fcf5377eb083461$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $4fcf5377eb083461$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $4fcf5377eb083461$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $4fcf5377eb083461$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $4fcf5377eb083461$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $4fcf5377eb083461$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $4fcf5377eb083461$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $4fcf5377eb083461$var$SyntheticKeyboardEvent = $4fcf5377eb083461$var$createSyntheticEvent($4fcf5377eb083461$var$KeyboardEventInterface), $4fcf5377eb083461$var$PointerEventInterface = $4fcf5377eb083461$var$assign({}, $4fcf5377eb083461$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $4fcf5377eb083461$var$SyntheticPointerEvent = $4fcf5377eb083461$var$createSyntheticEvent($4fcf5377eb083461$var$PointerEventInterface), $4fcf5377eb083461$var$SubmitEventInterface = $4fcf5377eb083461$var$assign({}, $4fcf5377eb083461$var$EventInterface, {
    submitter: 0
}), $4fcf5377eb083461$var$SyntheticSubmitEvent = $4fcf5377eb083461$var$createSyntheticEvent($4fcf5377eb083461$var$SubmitEventInterface), $4fcf5377eb083461$var$TouchEventInterface = $4fcf5377eb083461$var$assign({}, $4fcf5377eb083461$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $4fcf5377eb083461$var$getEventModifierState
}), $4fcf5377eb083461$var$SyntheticTouchEvent = $4fcf5377eb083461$var$createSyntheticEvent($4fcf5377eb083461$var$TouchEventInterface), $4fcf5377eb083461$var$TransitionEventInterface = $4fcf5377eb083461$var$assign({}, $4fcf5377eb083461$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4fcf5377eb083461$var$SyntheticTransitionEvent = $4fcf5377eb083461$var$createSyntheticEvent($4fcf5377eb083461$var$TransitionEventInterface), $4fcf5377eb083461$var$WheelEventInterface = $4fcf5377eb083461$var$assign({}, $4fcf5377eb083461$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $4fcf5377eb083461$var$SyntheticWheelEvent = $4fcf5377eb083461$var$createSyntheticEvent($4fcf5377eb083461$var$WheelEventInterface), $4fcf5377eb083461$var$ToggleEventInterface = $4fcf5377eb083461$var$assign({}, $4fcf5377eb083461$var$EventInterface, {
    newState: 0,
    oldState: 0,
    source: 0
}), $4fcf5377eb083461$var$SyntheticToggleEvent = $4fcf5377eb083461$var$createSyntheticEvent($4fcf5377eb083461$var$ToggleEventInterface), $4fcf5377eb083461$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $4fcf5377eb083461$var$canUseCompositionEvent = $4fcf5377eb083461$var$canUseDOM && "CompositionEvent" in window, $4fcf5377eb083461$var$documentMode = null;
$4fcf5377eb083461$var$canUseDOM && "documentMode" in document && ($4fcf5377eb083461$var$documentMode = document.documentMode);
var $4fcf5377eb083461$var$canUseTextInputEvent = $4fcf5377eb083461$var$canUseDOM && "TextEvent" in window && !$4fcf5377eb083461$var$documentMode, $4fcf5377eb083461$var$useFallbackCompositionData = $4fcf5377eb083461$var$canUseDOM && (!$4fcf5377eb083461$var$canUseCompositionEvent || $4fcf5377eb083461$var$documentMode && 8 < $4fcf5377eb083461$var$documentMode && 11 >= $4fcf5377eb083461$var$documentMode), $4fcf5377eb083461$var$SPACEBAR_CHAR = String.fromCharCode(32), $4fcf5377eb083461$var$hasSpaceKeypress = !1;
function $4fcf5377eb083461$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $4fcf5377eb083461$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $4fcf5377eb083461$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $4fcf5377eb083461$var$isComposing = !1;
function $4fcf5377eb083461$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $4fcf5377eb083461$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $4fcf5377eb083461$var$hasSpaceKeypress = !0;
            return $4fcf5377eb083461$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $4fcf5377eb083461$var$SPACEBAR_CHAR && $4fcf5377eb083461$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $4fcf5377eb083461$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($4fcf5377eb083461$var$isComposing) return "compositionend" === domEventName || !$4fcf5377eb083461$var$canUseCompositionEvent && $4fcf5377eb083461$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $4fcf5377eb083461$var$getData(), $4fcf5377eb083461$var$fallbackText = $4fcf5377eb083461$var$startText = $4fcf5377eb083461$var$root = null, $4fcf5377eb083461$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $4fcf5377eb083461$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $4fcf5377eb083461$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $4fcf5377eb083461$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$4fcf5377eb083461$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $4fcf5377eb083461$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $4fcf5377eb083461$var$restoreTarget ? $4fcf5377eb083461$var$restoreQueue ? $4fcf5377eb083461$var$restoreQueue.push(target) : $4fcf5377eb083461$var$restoreQueue = [
        target
    ] : $4fcf5377eb083461$var$restoreTarget = target;
    inst = $4fcf5377eb083461$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $4fcf5377eb083461$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $4fcf5377eb083461$var$activeElement$1 = null, $4fcf5377eb083461$var$activeElementInst$1 = null;
function $4fcf5377eb083461$var$runEventInBatch(dispatchQueue) {
    $4fcf5377eb083461$var$processDispatchQueue(dispatchQueue, 0);
}
function $4fcf5377eb083461$var$getInstIfValueChanged(targetInst) {
    var targetNode = $4fcf5377eb083461$var$getNodeFromInstance(targetInst);
    if ($4fcf5377eb083461$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $4fcf5377eb083461$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $4fcf5377eb083461$var$isInputEventSupported = !1;
if ($4fcf5377eb083461$var$canUseDOM) {
    var $4fcf5377eb083461$var$JSCompiler_inline_result$jscomp$318;
    if ($4fcf5377eb083461$var$canUseDOM) {
        var $4fcf5377eb083461$var$isSupported$jscomp$inline_474 = "oninput" in document;
        if (!$4fcf5377eb083461$var$isSupported$jscomp$inline_474) {
            var $4fcf5377eb083461$var$element$jscomp$inline_475 = document.createElement("div");
            $4fcf5377eb083461$var$element$jscomp$inline_475.setAttribute("oninput", "return;");
            $4fcf5377eb083461$var$isSupported$jscomp$inline_474 = "function" === typeof $4fcf5377eb083461$var$element$jscomp$inline_475.oninput;
        }
        $4fcf5377eb083461$var$JSCompiler_inline_result$jscomp$318 = $4fcf5377eb083461$var$isSupported$jscomp$inline_474;
    } else $4fcf5377eb083461$var$JSCompiler_inline_result$jscomp$318 = !1;
    $4fcf5377eb083461$var$isInputEventSupported = $4fcf5377eb083461$var$JSCompiler_inline_result$jscomp$318 && (!document.documentMode || 9 < document.documentMode);
}
function $4fcf5377eb083461$var$stopWatchingForValueChange() {
    $4fcf5377eb083461$var$activeElement$1 && ($4fcf5377eb083461$var$activeElement$1.detachEvent("onpropertychange", $4fcf5377eb083461$var$handlePropertyChange), $4fcf5377eb083461$var$activeElementInst$1 = $4fcf5377eb083461$var$activeElement$1 = null);
}
function $4fcf5377eb083461$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $4fcf5377eb083461$var$getInstIfValueChanged($4fcf5377eb083461$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $4fcf5377eb083461$var$createAndAccumulateChangeEvent(dispatchQueue, $4fcf5377eb083461$var$activeElementInst$1, nativeEvent, $4fcf5377eb083461$var$getEventTarget(nativeEvent));
        $4fcf5377eb083461$var$batchedUpdates$1($4fcf5377eb083461$var$runEventInBatch, dispatchQueue);
    }
}
function $4fcf5377eb083461$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($4fcf5377eb083461$var$stopWatchingForValueChange(), $4fcf5377eb083461$var$activeElement$1 = target, $4fcf5377eb083461$var$activeElementInst$1 = targetInst, $4fcf5377eb083461$var$activeElement$1.attachEvent("onpropertychange", $4fcf5377eb083461$var$handlePropertyChange)) : "focusout" === domEventName && $4fcf5377eb083461$var$stopWatchingForValueChange();
}
function $4fcf5377eb083461$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $4fcf5377eb083461$var$getInstIfValueChanged($4fcf5377eb083461$var$activeElementInst$1);
}
function $4fcf5377eb083461$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $4fcf5377eb083461$var$getInstIfValueChanged(targetInst);
}
function $4fcf5377eb083461$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $4fcf5377eb083461$var$getInstIfValueChanged(targetInst);
}
function $4fcf5377eb083461$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $4fcf5377eb083461$var$objectIs = "function" === typeof Object.is ? Object.is : $4fcf5377eb083461$var$is;
function $4fcf5377eb083461$var$shallowEqual(objA, objB) {
    if ($4fcf5377eb083461$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$4fcf5377eb083461$var$hasOwnProperty.call(objB, currentKey) || !$4fcf5377eb083461$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $4fcf5377eb083461$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e$20) {
        return doc.body;
    }
}
function $4fcf5377eb083461$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $4fcf5377eb083461$var$getNodeForCharacterOffset(root, offset) {
    var node = $4fcf5377eb083461$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $4fcf5377eb083461$var$getLeafNode(node);
    }
}
function $4fcf5377eb083461$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $4fcf5377eb083461$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $4fcf5377eb083461$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $4fcf5377eb083461$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $4fcf5377eb083461$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $4fcf5377eb083461$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $4fcf5377eb083461$var$skipSelectionChangeEvent = $4fcf5377eb083461$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $4fcf5377eb083461$var$activeElement = null, $4fcf5377eb083461$var$activeElementInst = null, $4fcf5377eb083461$var$lastSelection = null, $4fcf5377eb083461$var$mouseDown = !1;
function $4fcf5377eb083461$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $4fcf5377eb083461$var$mouseDown || null == $4fcf5377eb083461$var$activeElement || $4fcf5377eb083461$var$activeElement !== $4fcf5377eb083461$var$getActiveElement(doc) || (doc = $4fcf5377eb083461$var$activeElement, "selectionStart" in doc && $4fcf5377eb083461$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $4fcf5377eb083461$var$lastSelection && $4fcf5377eb083461$var$shallowEqual($4fcf5377eb083461$var$lastSelection, doc) || ($4fcf5377eb083461$var$lastSelection = doc, doc = $4fcf5377eb083461$var$accumulateTwoPhaseListeners($4fcf5377eb083461$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $4fcf5377eb083461$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $4fcf5377eb083461$var$activeElement)));
}
function $4fcf5377eb083461$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $4fcf5377eb083461$var$vendorPrefixes = {
    animationend: $4fcf5377eb083461$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $4fcf5377eb083461$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $4fcf5377eb083461$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $4fcf5377eb083461$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $4fcf5377eb083461$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $4fcf5377eb083461$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $4fcf5377eb083461$var$makePrefixMap("Transition", "TransitionEnd")
}, $4fcf5377eb083461$var$prefixedEventNames = {}, $4fcf5377eb083461$var$style = {};
$4fcf5377eb083461$var$canUseDOM && ($4fcf5377eb083461$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $4fcf5377eb083461$var$vendorPrefixes.animationend.animation, delete $4fcf5377eb083461$var$vendorPrefixes.animationiteration.animation, delete $4fcf5377eb083461$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $4fcf5377eb083461$var$vendorPrefixes.transitionend.transition);
function $4fcf5377eb083461$var$getVendorPrefixedEventName(eventName) {
    if ($4fcf5377eb083461$var$prefixedEventNames[eventName]) return $4fcf5377eb083461$var$prefixedEventNames[eventName];
    if (!$4fcf5377eb083461$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $4fcf5377eb083461$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $4fcf5377eb083461$var$style) return $4fcf5377eb083461$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $4fcf5377eb083461$var$ANIMATION_END = $4fcf5377eb083461$var$getVendorPrefixedEventName("animationend"), $4fcf5377eb083461$var$ANIMATION_ITERATION = $4fcf5377eb083461$var$getVendorPrefixedEventName("animationiteration"), $4fcf5377eb083461$var$ANIMATION_START = $4fcf5377eb083461$var$getVendorPrefixedEventName("animationstart"), $4fcf5377eb083461$var$TRANSITION_RUN = $4fcf5377eb083461$var$getVendorPrefixedEventName("transitionrun"), $4fcf5377eb083461$var$TRANSITION_START = $4fcf5377eb083461$var$getVendorPrefixedEventName("transitionstart"), $4fcf5377eb083461$var$TRANSITION_CANCEL = $4fcf5377eb083461$var$getVendorPrefixedEventName("transitioncancel"), $4fcf5377eb083461$var$TRANSITION_END = $4fcf5377eb083461$var$getVendorPrefixedEventName("transitionend"), $4fcf5377eb083461$var$topLevelEventsToReactNames = new Map(), $4fcf5377eb083461$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$4fcf5377eb083461$var$simpleEventPluginEvents.push("scrollEnd");
function $4fcf5377eb083461$var$registerSimpleEvent(domEventName, reactName) {
    $4fcf5377eb083461$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $4fcf5377eb083461$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $4fcf5377eb083461$var$globalClientIdCounter$1 = 0;
function $4fcf5377eb083461$var$getViewTransitionName(props, instance) {
    if (null != props.name && "auto" !== props.name) return props.name;
    if (null !== instance.autoName) return instance.autoName;
    props = $4fcf5377eb083461$var$pendingEffectsRoot.identifierPrefix;
    var globalClientId = $4fcf5377eb083461$var$globalClientIdCounter$1++;
    props = "_" + props + "t_" + globalClientId.toString(32) + "_";
    return instance.autoName = props;
}
function $4fcf5377eb083461$var$getClassNameByType(classByType) {
    if (null == classByType || "string" === typeof classByType) return classByType;
    var className = null, activeTypes = $4fcf5377eb083461$var$pendingTransitionTypes;
    if (null !== activeTypes) for(var i = 0; i < activeTypes.length; i++){
        var match = classByType[activeTypes[i]];
        if (null != match) {
            if ("none" === match) return "none";
            className = null == className ? match : className + (" " + match);
        }
    }
    return null == className ? classByType.default : className;
}
function $4fcf5377eb083461$var$getViewTransitionClassName(defaultClass, eventClass) {
    defaultClass = $4fcf5377eb083461$var$getClassNameByType(defaultClass);
    eventClass = $4fcf5377eb083461$var$getClassNameByType(eventClass);
    return null == eventClass ? "auto" === defaultClass ? null : defaultClass : "auto" === eventClass ? null : eventClass;
}
var $4fcf5377eb083461$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $3ZMUU && "function" === typeof $3ZMUU.emit) {
        $3ZMUU.emit("uncaughtException", error);
        return;
    }
    console.error(error);
}, $4fcf5377eb083461$var$concurrentQueues = [], $4fcf5377eb083461$var$concurrentQueuesIndex = 0, $4fcf5377eb083461$var$concurrentlyUpdatedLanes = 0;
function $4fcf5377eb083461$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $4fcf5377eb083461$var$concurrentQueuesIndex, i = $4fcf5377eb083461$var$concurrentlyUpdatedLanes = $4fcf5377eb083461$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $4fcf5377eb083461$var$concurrentQueues[i];
        $4fcf5377eb083461$var$concurrentQueues[i++] = null;
        var queue = $4fcf5377eb083461$var$concurrentQueues[i];
        $4fcf5377eb083461$var$concurrentQueues[i++] = null;
        var update = $4fcf5377eb083461$var$concurrentQueues[i];
        $4fcf5377eb083461$var$concurrentQueues[i++] = null;
        var lane = $4fcf5377eb083461$var$concurrentQueues[i];
        $4fcf5377eb083461$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $4fcf5377eb083461$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $4fcf5377eb083461$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $4fcf5377eb083461$var$concurrentQueues[$4fcf5377eb083461$var$concurrentQueuesIndex++] = fiber;
    $4fcf5377eb083461$var$concurrentQueues[$4fcf5377eb083461$var$concurrentQueuesIndex++] = queue;
    $4fcf5377eb083461$var$concurrentQueues[$4fcf5377eb083461$var$concurrentQueuesIndex++] = update;
    $4fcf5377eb083461$var$concurrentQueues[$4fcf5377eb083461$var$concurrentQueuesIndex++] = lane;
    $4fcf5377eb083461$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $4fcf5377eb083461$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $4fcf5377eb083461$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $4fcf5377eb083461$var$getRootForUpdatedFiber(fiber);
}
function $4fcf5377eb083461$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $4fcf5377eb083461$var$enqueueUpdate$1(fiber, null, null, lane);
    return $4fcf5377eb083461$var$getRootForUpdatedFiber(fiber);
}
function $4fcf5377eb083461$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $4fcf5377eb083461$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $4fcf5377eb083461$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $4fcf5377eb083461$var$nestedUpdateCount) throw $4fcf5377eb083461$var$nestedUpdateCount = 0, $4fcf5377eb083461$var$rootWithNestedUpdates = null, Error($4fcf5377eb083461$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $4fcf5377eb083461$var$emptyContextObject = {};
function $4fcf5377eb083461$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $4fcf5377eb083461$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $4fcf5377eb083461$var$FiberNode(tag, pendingProps, key, mode);
}
function $4fcf5377eb083461$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $4fcf5377eb083461$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $4fcf5377eb083461$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 1206910976;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $4fcf5377eb083461$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 1206910978;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $4fcf5377eb083461$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof owner) $4fcf5377eb083461$var$shouldConstruct(owner) && (fiberTag = 1);
    else if ("string" === typeof owner) fiberTag = $4fcf5377eb083461$var$isHostHoistableType(type, pendingProps, $4fcf5377eb083461$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(owner){
        case $4fcf5377eb083461$var$REACT_ACTIVITY_TYPE:
            return type = $4fcf5377eb083461$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $4fcf5377eb083461$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $4fcf5377eb083461$var$REACT_FRAGMENT_TYPE:
            return $4fcf5377eb083461$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $4fcf5377eb083461$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $4fcf5377eb083461$var$REACT_PROFILER_TYPE:
            return type = $4fcf5377eb083461$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $4fcf5377eb083461$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $4fcf5377eb083461$var$REACT_SUSPENSE_TYPE:
            return type = $4fcf5377eb083461$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $4fcf5377eb083461$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $4fcf5377eb083461$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $4fcf5377eb083461$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $4fcf5377eb083461$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $4fcf5377eb083461$var$REACT_LEGACY_HIDDEN_TYPE:
        case $4fcf5377eb083461$var$REACT_VIEW_TRANSITION_TYPE:
            return type = mode | 32, type = $4fcf5377eb083461$var$createFiberImplClass(30, pendingProps, key, type), type.elementType = $4fcf5377eb083461$var$REACT_VIEW_TRANSITION_TYPE, type.lanes = lanes, type.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }, type;
        default:
            if ("object" === typeof owner && null !== owner) switch(owner.$$typeof){
                case $4fcf5377eb083461$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $4fcf5377eb083461$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $4fcf5377eb083461$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $4fcf5377eb083461$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $4fcf5377eb083461$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($4fcf5377eb083461$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $4fcf5377eb083461$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $4fcf5377eb083461$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $4fcf5377eb083461$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $4fcf5377eb083461$var$createFiberFromText(content, mode, lanes) {
    content = $4fcf5377eb083461$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $4fcf5377eb083461$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $4fcf5377eb083461$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $4fcf5377eb083461$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $4fcf5377eb083461$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $4fcf5377eb083461$var$CapturedStacks = new WeakMap();
function $4fcf5377eb083461$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $4fcf5377eb083461$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $4fcf5377eb083461$var$getStackByFiberInDevAndProd(source)
        };
        $4fcf5377eb083461$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $4fcf5377eb083461$var$getStackByFiberInDevAndProd(source)
    };
}
var $4fcf5377eb083461$var$forkStack = [], $4fcf5377eb083461$var$forkStackIndex = 0, $4fcf5377eb083461$var$treeForkProvider = null, $4fcf5377eb083461$var$treeForkCount = 0, $4fcf5377eb083461$var$idStack = [], $4fcf5377eb083461$var$idStackIndex = 0, $4fcf5377eb083461$var$treeContextProvider = null, $4fcf5377eb083461$var$treeContextId = 1, $4fcf5377eb083461$var$treeContextOverflow = "";
function $4fcf5377eb083461$var$pushTreeFork(workInProgress, totalChildren) {
    $4fcf5377eb083461$var$forkStack[$4fcf5377eb083461$var$forkStackIndex++] = $4fcf5377eb083461$var$treeForkCount;
    $4fcf5377eb083461$var$forkStack[$4fcf5377eb083461$var$forkStackIndex++] = $4fcf5377eb083461$var$treeForkProvider;
    $4fcf5377eb083461$var$treeForkProvider = workInProgress;
    $4fcf5377eb083461$var$treeForkCount = totalChildren;
}
function $4fcf5377eb083461$var$pushTreeId(workInProgress, totalChildren, index) {
    $4fcf5377eb083461$var$idStack[$4fcf5377eb083461$var$idStackIndex++] = $4fcf5377eb083461$var$treeContextId;
    $4fcf5377eb083461$var$idStack[$4fcf5377eb083461$var$idStackIndex++] = $4fcf5377eb083461$var$treeContextOverflow;
    $4fcf5377eb083461$var$idStack[$4fcf5377eb083461$var$idStackIndex++] = $4fcf5377eb083461$var$treeContextProvider;
    $4fcf5377eb083461$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $4fcf5377eb083461$var$treeContextId;
    workInProgress = $4fcf5377eb083461$var$treeContextOverflow;
    var baseLength = 32 - $4fcf5377eb083461$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $4fcf5377eb083461$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $4fcf5377eb083461$var$treeContextId = 1 << 32 - $4fcf5377eb083461$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $4fcf5377eb083461$var$treeContextOverflow = length + workInProgress;
    } else $4fcf5377eb083461$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $4fcf5377eb083461$var$treeContextOverflow = workInProgress;
}
function $4fcf5377eb083461$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($4fcf5377eb083461$var$pushTreeFork(workInProgress, 1), $4fcf5377eb083461$var$pushTreeId(workInProgress, 1, 0));
}
function $4fcf5377eb083461$var$popTreeContext(workInProgress) {
    for(; workInProgress === $4fcf5377eb083461$var$treeForkProvider;)$4fcf5377eb083461$var$treeForkProvider = $4fcf5377eb083461$var$forkStack[--$4fcf5377eb083461$var$forkStackIndex], $4fcf5377eb083461$var$forkStack[$4fcf5377eb083461$var$forkStackIndex] = null, $4fcf5377eb083461$var$treeForkCount = $4fcf5377eb083461$var$forkStack[--$4fcf5377eb083461$var$forkStackIndex], $4fcf5377eb083461$var$forkStack[$4fcf5377eb083461$var$forkStackIndex] = null;
    for(; workInProgress === $4fcf5377eb083461$var$treeContextProvider;)$4fcf5377eb083461$var$treeContextProvider = $4fcf5377eb083461$var$idStack[--$4fcf5377eb083461$var$idStackIndex], $4fcf5377eb083461$var$idStack[$4fcf5377eb083461$var$idStackIndex] = null, $4fcf5377eb083461$var$treeContextOverflow = $4fcf5377eb083461$var$idStack[--$4fcf5377eb083461$var$idStackIndex], $4fcf5377eb083461$var$idStack[$4fcf5377eb083461$var$idStackIndex] = null, $4fcf5377eb083461$var$treeContextId = $4fcf5377eb083461$var$idStack[--$4fcf5377eb083461$var$idStackIndex], $4fcf5377eb083461$var$idStack[$4fcf5377eb083461$var$idStackIndex] = null;
}
function $4fcf5377eb083461$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $4fcf5377eb083461$var$idStack[$4fcf5377eb083461$var$idStackIndex++] = $4fcf5377eb083461$var$treeContextId;
    $4fcf5377eb083461$var$idStack[$4fcf5377eb083461$var$idStackIndex++] = $4fcf5377eb083461$var$treeContextOverflow;
    $4fcf5377eb083461$var$idStack[$4fcf5377eb083461$var$idStackIndex++] = $4fcf5377eb083461$var$treeContextProvider;
    $4fcf5377eb083461$var$treeContextId = suspendedContext.id;
    $4fcf5377eb083461$var$treeContextOverflow = suspendedContext.overflow;
    $4fcf5377eb083461$var$treeContextProvider = workInProgress;
}
var $4fcf5377eb083461$var$hydrationParentFiber = null, $4fcf5377eb083461$var$nextHydratableInstance = null, $4fcf5377eb083461$var$isHydrating = !1, $4fcf5377eb083461$var$hydrationErrors = null, $4fcf5377eb083461$var$rootOrSingletonContext = !1, $4fcf5377eb083461$var$HydrationMismatchException = Error($4fcf5377eb083461$var$formatProdErrorMessage(519));
function $4fcf5377eb083461$var$throwOnHydrationMismatch(fiber) {
    var error = Error($4fcf5377eb083461$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $4fcf5377eb083461$var$queueHydrationError($4fcf5377eb083461$var$createCapturedValueAtFiber(error, fiber));
    throw $4fcf5377eb083461$var$HydrationMismatchException;
}
function $4fcf5377eb083461$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$4fcf5377eb083461$var$internalInstanceKey] = fiber;
    instance[$4fcf5377eb083461$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("cancel", instance);
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $4fcf5377eb083461$var$mediaEventTypes.length; type++)$4fcf5377eb083461$var$listenToNonDelegatedEvent($4fcf5377eb083461$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("error", instance);
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("invalid", instance);
            $4fcf5377eb083461$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("invalid", instance), $4fcf5377eb083461$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $4fcf5377eb083461$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($4fcf5377eb083461$var$listenToNonDelegatedEvent("beforetoggle", instance), $4fcf5377eb083461$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $4fcf5377eb083461$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $4fcf5377eb083461$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $4fcf5377eb083461$var$noop$1), instance = !0) : instance = !1;
    instance || $4fcf5377eb083461$var$throwOnHydrationMismatch(fiber, !0);
}
function $4fcf5377eb083461$var$popToNextHostParent(fiber) {
    for($4fcf5377eb083461$var$hydrationParentFiber = fiber.return; $4fcf5377eb083461$var$hydrationParentFiber;)switch($4fcf5377eb083461$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $4fcf5377eb083461$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $4fcf5377eb083461$var$rootOrSingletonContext = !0;
            return;
        default:
            $4fcf5377eb083461$var$hydrationParentFiber = $4fcf5377eb083461$var$hydrationParentFiber.return;
    }
}
function $4fcf5377eb083461$var$popHydrationState(fiber) {
    if (fiber !== $4fcf5377eb083461$var$hydrationParentFiber) return !1;
    if (!$4fcf5377eb083461$var$isHydrating) return $4fcf5377eb083461$var$popToNextHostParent(fiber), $4fcf5377eb083461$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $4fcf5377eb083461$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $4fcf5377eb083461$var$nextHydratableInstance && $4fcf5377eb083461$var$throwOnHydrationMismatch(fiber);
    $4fcf5377eb083461$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(317));
        $4fcf5377eb083461$var$nextHydratableInstance = $4fcf5377eb083461$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(317));
        $4fcf5377eb083461$var$nextHydratableInstance = $4fcf5377eb083461$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $4fcf5377eb083461$var$nextHydratableInstance, $4fcf5377eb083461$var$isSingletonScope(fiber.type) ? (fiber = $4fcf5377eb083461$var$previousHydratableOnEnteringScopedSingleton, $4fcf5377eb083461$var$previousHydratableOnEnteringScopedSingleton = null, $4fcf5377eb083461$var$nextHydratableInstance = fiber) : $4fcf5377eb083461$var$nextHydratableInstance = tag) : $4fcf5377eb083461$var$nextHydratableInstance = $4fcf5377eb083461$var$hydrationParentFiber ? $4fcf5377eb083461$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $4fcf5377eb083461$var$resetHydrationState() {
    $4fcf5377eb083461$var$nextHydratableInstance = $4fcf5377eb083461$var$hydrationParentFiber = null;
    $4fcf5377eb083461$var$isHydrating = !1;
}
function $4fcf5377eb083461$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $4fcf5377eb083461$var$hydrationErrors;
    null !== queuedErrors && (null === $4fcf5377eb083461$var$workInProgressRootRecoverableErrors ? $4fcf5377eb083461$var$workInProgressRootRecoverableErrors = queuedErrors : $4fcf5377eb083461$var$workInProgressRootRecoverableErrors.push.apply($4fcf5377eb083461$var$workInProgressRootRecoverableErrors, queuedErrors), $4fcf5377eb083461$var$hydrationErrors = null);
    return queuedErrors;
}
function $4fcf5377eb083461$var$queueHydrationError(error) {
    null === $4fcf5377eb083461$var$hydrationErrors ? $4fcf5377eb083461$var$hydrationErrors = [
        error
    ] : $4fcf5377eb083461$var$hydrationErrors.push(error);
}
var $4fcf5377eb083461$var$valueCursor = $4fcf5377eb083461$var$createCursor(null), $4fcf5377eb083461$var$currentlyRenderingFiber$1 = null, $4fcf5377eb083461$var$lastContextDependency = null;
function $4fcf5377eb083461$var$pushProvider(providerFiber, context, nextValue) {
    $4fcf5377eb083461$var$push($4fcf5377eb083461$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $4fcf5377eb083461$var$popProvider(context) {
    context._currentValue = $4fcf5377eb083461$var$valueCursor.current;
    $4fcf5377eb083461$var$pop($4fcf5377eb083461$var$valueCursor);
}
function $4fcf5377eb083461$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $4fcf5377eb083461$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $4fcf5377eb083461$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $4fcf5377eb083461$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else 13 === fiber.tag && null !== fiber.memoizedState && null === fiber.memoizedState.dehydrated ? (fiber.lanes |= renderLanes, nextFiber = fiber.alternate, null !== nextFiber && (nextFiber.lanes |= renderLanes), $4fcf5377eb083461$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress), nextFiber = fiber.child, nextFiber = null !== nextFiber ? nextFiber.sibling : null) : nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $4fcf5377eb083461$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $4fcf5377eb083461$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $4fcf5377eb083461$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($4fcf5377eb083461$var$HostTransitionContext) : current = [
                $4fcf5377eb083461$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $4fcf5377eb083461$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
    return null !== current;
}
function $4fcf5377eb083461$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$4fcf5377eb083461$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $4fcf5377eb083461$var$prepareToReadContext(workInProgress) {
    $4fcf5377eb083461$var$currentlyRenderingFiber$1 = workInProgress;
    $4fcf5377eb083461$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $4fcf5377eb083461$var$readContext(context) {
    return $4fcf5377eb083461$var$readContextForConsumer($4fcf5377eb083461$var$currentlyRenderingFiber$1, context);
}
function $4fcf5377eb083461$var$readContextDuringReconciliation(consumer, context) {
    null === $4fcf5377eb083461$var$currentlyRenderingFiber$1 && $4fcf5377eb083461$var$prepareToReadContext(consumer);
    return $4fcf5377eb083461$var$readContextForConsumer(consumer, context);
}
function $4fcf5377eb083461$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $4fcf5377eb083461$var$lastContextDependency) {
        if (null === consumer) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(308));
        $4fcf5377eb083461$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $4fcf5377eb083461$var$lastContextDependency = $4fcf5377eb083461$var$lastContextDependency.next = context;
    return value;
}
var $4fcf5377eb083461$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $4fcf5377eb083461$var$scheduleCallback$2 = $2tm1P.unstable_scheduleCallback, $4fcf5377eb083461$var$NormalPriority = $2tm1P.unstable_NormalPriority, $4fcf5377eb083461$var$CacheContext = {
    $$typeof: $4fcf5377eb083461$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $4fcf5377eb083461$var$createCache() {
    return {
        controller: new $4fcf5377eb083461$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $4fcf5377eb083461$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $4fcf5377eb083461$var$scheduleCallback$2($4fcf5377eb083461$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
function $4fcf5377eb083461$var$queueTransitionTypes(root, transitionTypes) {
    if (0 !== (root.pendingLanes & 4194048)) {
        var queued = root.transitionTypes;
        null === queued && (queued = root.transitionTypes = []);
        for(root = 0; root < transitionTypes.length; root++){
            var transitionType = transitionTypes[root];
            -1 === queued.indexOf(transitionType) && queued.push(transitionType);
        }
    }
}
var $4fcf5377eb083461$var$entangledTransitionTypes = null;
function $4fcf5377eb083461$var$claimQueuedTransitionTypes(root) {
    var claimed = root.transitionTypes;
    root.transitionTypes = null;
    return claimed;
}
var $4fcf5377eb083461$var$currentEntangledListeners = null, $4fcf5377eb083461$var$currentEntangledPendingCount = 0, $4fcf5377eb083461$var$currentEntangledLane = 0, $4fcf5377eb083461$var$currentEntangledActionThenable = null;
function $4fcf5377eb083461$var$entangleAsyncAction(transition, thenable) {
    if (null === $4fcf5377eb083461$var$currentEntangledListeners) {
        var entangledListeners = $4fcf5377eb083461$var$currentEntangledListeners = [];
        $4fcf5377eb083461$var$currentEntangledPendingCount = 0;
        $4fcf5377eb083461$var$currentEntangledLane = $4fcf5377eb083461$var$requestTransitionLane();
        $4fcf5377eb083461$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $4fcf5377eb083461$var$currentEntangledPendingCount++;
    thenable.then($4fcf5377eb083461$var$pingEngtangledActionScope, $4fcf5377eb083461$var$pingEngtangledActionScope);
    return thenable;
}
function $4fcf5377eb083461$var$pingEngtangledActionScope() {
    if (0 === --$4fcf5377eb083461$var$currentEntangledPendingCount && ($4fcf5377eb083461$var$entangledTransitionTypes = null, null !== $4fcf5377eb083461$var$currentEntangledListeners)) {
        null !== $4fcf5377eb083461$var$currentEntangledActionThenable && ($4fcf5377eb083461$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $4fcf5377eb083461$var$currentEntangledListeners;
        $4fcf5377eb083461$var$currentEntangledListeners = null;
        $4fcf5377eb083461$var$currentEntangledLane = 0;
        $4fcf5377eb083461$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $4fcf5377eb083461$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $4fcf5377eb083461$var$prevOnStartTransitionFinish = $4fcf5377eb083461$var$ReactSharedInternals.S;
$4fcf5377eb083461$var$ReactSharedInternals.S = function(transition, returnValue) {
    $4fcf5377eb083461$var$globalMostRecentTransitionTime = $4fcf5377eb083461$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $4fcf5377eb083461$var$entangleAsyncAction(transition, returnValue);
    if (null !== $4fcf5377eb083461$var$entangledTransitionTypes) for(var root$28 = $4fcf5377eb083461$var$firstScheduledRoot; null !== root$28;)$4fcf5377eb083461$var$queueTransitionTypes(root$28, $4fcf5377eb083461$var$entangledTransitionTypes), root$28 = root$28.next;
    root$28 = transition.types;
    if (null !== root$28) {
        for(var root$29 = $4fcf5377eb083461$var$firstScheduledRoot; null !== root$29;)$4fcf5377eb083461$var$queueTransitionTypes(root$29, root$28), root$29 = root$29.next;
        if (0 !== $4fcf5377eb083461$var$currentEntangledLane) {
            root$29 = $4fcf5377eb083461$var$entangledTransitionTypes;
            null === root$29 && (root$29 = $4fcf5377eb083461$var$entangledTransitionTypes = []);
            for(var i = 0; i < root$28.length; i++){
                var transitionType = root$28[i];
                -1 === root$29.indexOf(transitionType) && root$29.push(transitionType);
            }
        }
    }
    null !== $4fcf5377eb083461$var$prevOnStartTransitionFinish && $4fcf5377eb083461$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $4fcf5377eb083461$var$resumedCache = $4fcf5377eb083461$var$createCursor(null);
function $4fcf5377eb083461$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $4fcf5377eb083461$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $4fcf5377eb083461$var$workInProgressRoot.pooledCache;
}
function $4fcf5377eb083461$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $4fcf5377eb083461$var$push($4fcf5377eb083461$var$resumedCache, $4fcf5377eb083461$var$resumedCache.current) : $4fcf5377eb083461$var$push($4fcf5377eb083461$var$resumedCache, prevCachePool.pool);
}
function $4fcf5377eb083461$var$getSuspendedCache() {
    var cacheFromPool = $4fcf5377eb083461$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $4fcf5377eb083461$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $4fcf5377eb083461$var$SuspenseException = Error($4fcf5377eb083461$var$formatProdErrorMessage(460)), $4fcf5377eb083461$var$SuspenseyCommitException = Error($4fcf5377eb083461$var$formatProdErrorMessage(474)), $4fcf5377eb083461$var$SuspenseActionException = Error($4fcf5377eb083461$var$formatProdErrorMessage(542)), $4fcf5377eb083461$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $4fcf5377eb083461$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $4fcf5377eb083461$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($4fcf5377eb083461$var$noop$1, $4fcf5377eb083461$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            $4fcf5377eb083461$var$checkIfUseWrappedInAsyncCatch(thenableState);
            if (void 0 === thenableState && !("reason" in thenable)) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(600));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($4fcf5377eb083461$var$noop$1, $4fcf5377eb083461$var$noop$1);
            else {
                thenableState = $4fcf5377eb083461$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $4fcf5377eb083461$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $4fcf5377eb083461$var$suspendedThenable = thenable;
            throw $4fcf5377eb083461$var$SuspenseException;
    }
}
function $4fcf5377eb083461$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $4fcf5377eb083461$var$suspendedThenable = x, $4fcf5377eb083461$var$SuspenseException;
        throw x;
    }
}
var $4fcf5377eb083461$var$suspendedThenable = null;
function $4fcf5377eb083461$var$getSuspendedThenable() {
    if (null === $4fcf5377eb083461$var$suspendedThenable) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(459));
    var thenable = $4fcf5377eb083461$var$suspendedThenable;
    $4fcf5377eb083461$var$suspendedThenable = null;
    return thenable;
}
function $4fcf5377eb083461$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $4fcf5377eb083461$var$SuspenseException || rejectedReason === $4fcf5377eb083461$var$SuspenseActionException) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(483));
}
var $4fcf5377eb083461$var$thenableState$1 = null, $4fcf5377eb083461$var$thenableIndexCounter$1 = 0;
function $4fcf5377eb083461$var$unwrapThenable(thenable) {
    var index = $4fcf5377eb083461$var$thenableIndexCounter$1;
    $4fcf5377eb083461$var$thenableIndexCounter$1 += 1;
    null === $4fcf5377eb083461$var$thenableState$1 && ($4fcf5377eb083461$var$thenableState$1 = []);
    return $4fcf5377eb083461$var$trackUsedThenable($4fcf5377eb083461$var$thenableState$1, thenable, index);
}
function $4fcf5377eb083461$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $4fcf5377eb083461$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $4fcf5377eb083461$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($4fcf5377eb083461$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $4fcf5377eb083461$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null === currentFirstChild.key ? existingChildren.set(currentFirstChild.index, currentFirstChild) : existingChildren.set(currentFirstChild.key, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $4fcf5377eb083461$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 2, lastPlacedIndex) : newIndex;
        newFiber.flags |= 134217730;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 134217730);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $4fcf5377eb083461$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $4fcf5377eb083461$var$REACT_FRAGMENT_TYPE) return returnFiber = updateFragment(returnFiber, current, element.props.children, lanes, element.key), $4fcf5377eb083461$var$coerceRef(returnFiber, element), returnFiber;
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $4fcf5377eb083461$var$REACT_LAZY_TYPE && $4fcf5377eb083461$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $4fcf5377eb083461$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $4fcf5377eb083461$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $4fcf5377eb083461$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $4fcf5377eb083461$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $4fcf5377eb083461$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $4fcf5377eb083461$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $4fcf5377eb083461$var$REACT_ELEMENT_TYPE:
                    return lanes = $4fcf5377eb083461$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $4fcf5377eb083461$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $4fcf5377eb083461$var$REACT_PORTAL_TYPE:
                    return newChild = $4fcf5377eb083461$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $4fcf5377eb083461$var$REACT_LAZY_TYPE:
                    return newChild = $4fcf5377eb083461$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($4fcf5377eb083461$var$isArrayImpl(newChild) || $4fcf5377eb083461$var$getIteratorFn(newChild)) return newChild = $4fcf5377eb083461$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $4fcf5377eb083461$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $4fcf5377eb083461$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $4fcf5377eb083461$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $4fcf5377eb083461$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $4fcf5377eb083461$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $4fcf5377eb083461$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $4fcf5377eb083461$var$REACT_LAZY_TYPE:
                    return newChild = $4fcf5377eb083461$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($4fcf5377eb083461$var$isArrayImpl(newChild) || $4fcf5377eb083461$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $4fcf5377eb083461$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $4fcf5377eb083461$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $4fcf5377eb083461$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $4fcf5377eb083461$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $4fcf5377eb083461$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $4fcf5377eb083461$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $4fcf5377eb083461$var$REACT_LAZY_TYPE:
                    return newChild = $4fcf5377eb083461$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($4fcf5377eb083461$var$isArrayImpl(newChild) || $4fcf5377eb083461$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $4fcf5377eb083461$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $4fcf5377eb083461$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $4fcf5377eb083461$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $4fcf5377eb083461$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $4fcf5377eb083461$var$isHydrating && $4fcf5377eb083461$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $4fcf5377eb083461$var$isHydrating && $4fcf5377eb083461$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && (newFiber = nextOldFiber.alternate, null !== newFiber && oldFiber.delete(null === newFiber.key ? newIdx : newFiber.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $4fcf5377eb083461$var$isHydrating && $4fcf5377eb083461$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $4fcf5377eb083461$var$isHydrating && $4fcf5377eb083461$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $4fcf5377eb083461$var$isHydrating && $4fcf5377eb083461$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && (nextOldFiber = step.alternate, null !== nextOldFiber && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key)), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $4fcf5377eb083461$var$isHydrating && $4fcf5377eb083461$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $4fcf5377eb083461$var$REACT_FRAGMENT_TYPE && null === newChild.key && void 0 === newChild.props.ref && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $4fcf5377eb083461$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $4fcf5377eb083461$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        $4fcf5377eb083461$var$coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $4fcf5377eb083461$var$REACT_LAZY_TYPE && $4fcf5377eb083461$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $4fcf5377eb083461$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $4fcf5377eb083461$var$REACT_FRAGMENT_TYPE ? (lanes = $4fcf5377eb083461$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), $4fcf5377eb083461$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $4fcf5377eb083461$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $4fcf5377eb083461$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $4fcf5377eb083461$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $4fcf5377eb083461$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $4fcf5377eb083461$var$REACT_LAZY_TYPE:
                    return newChild = $4fcf5377eb083461$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($4fcf5377eb083461$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($4fcf5377eb083461$var$getIteratorFn(newChild)) {
                key = $4fcf5377eb083461$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $4fcf5377eb083461$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $4fcf5377eb083461$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $4fcf5377eb083461$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $4fcf5377eb083461$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $4fcf5377eb083461$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $4fcf5377eb083461$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $4fcf5377eb083461$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $4fcf5377eb083461$var$SuspenseException || x === $4fcf5377eb083461$var$SuspenseActionException) throw x;
            var fiber = $4fcf5377eb083461$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $4fcf5377eb083461$var$reconcileChildFibers = $4fcf5377eb083461$var$createChildReconciler(!0), $4fcf5377eb083461$var$mountChildFibers = $4fcf5377eb083461$var$createChildReconciler(!1), $4fcf5377eb083461$var$hasForceUpdate = !1;
function $4fcf5377eb083461$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $4fcf5377eb083461$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $4fcf5377eb083461$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $4fcf5377eb083461$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($4fcf5377eb083461$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $4fcf5377eb083461$var$getRootForUpdatedFiber(fiber);
        $4fcf5377eb083461$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $4fcf5377eb083461$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $4fcf5377eb083461$var$getRootForUpdatedFiber(fiber);
}
function $4fcf5377eb083461$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $4fcf5377eb083461$var$markRootEntangled(root, lane);
    }
}
function $4fcf5377eb083461$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $4fcf5377eb083461$var$didReadFromEntangledAsyncAction = !1;
function $4fcf5377eb083461$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($4fcf5377eb083461$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $4fcf5377eb083461$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $4fcf5377eb083461$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $4fcf5377eb083461$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $4fcf5377eb083461$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($4fcf5377eb083461$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $4fcf5377eb083461$var$currentEntangledLane && ($4fcf5377eb083461$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $4fcf5377eb083461$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $4fcf5377eb083461$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $4fcf5377eb083461$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $4fcf5377eb083461$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $4fcf5377eb083461$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$4fcf5377eb083461$var$callCallback(callbacks[updateQueue], context);
}
var $4fcf5377eb083461$var$currentTreeHiddenStackCursor = $4fcf5377eb083461$var$createCursor(null), $4fcf5377eb083461$var$prevEntangledRenderLanesCursor = $4fcf5377eb083461$var$createCursor(0);
function $4fcf5377eb083461$var$pushHiddenContext(fiber, context) {
    fiber = $4fcf5377eb083461$var$entangledRenderLanes;
    $4fcf5377eb083461$var$push($4fcf5377eb083461$var$prevEntangledRenderLanesCursor, fiber);
    $4fcf5377eb083461$var$push($4fcf5377eb083461$var$currentTreeHiddenStackCursor, context);
    $4fcf5377eb083461$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $4fcf5377eb083461$var$reuseHiddenContextOnStack() {
    $4fcf5377eb083461$var$push($4fcf5377eb083461$var$prevEntangledRenderLanesCursor, $4fcf5377eb083461$var$entangledRenderLanes);
    $4fcf5377eb083461$var$push($4fcf5377eb083461$var$currentTreeHiddenStackCursor, $4fcf5377eb083461$var$currentTreeHiddenStackCursor.current);
}
function $4fcf5377eb083461$var$popHiddenContext() {
    $4fcf5377eb083461$var$entangledRenderLanes = $4fcf5377eb083461$var$prevEntangledRenderLanesCursor.current;
    $4fcf5377eb083461$var$pop($4fcf5377eb083461$var$currentTreeHiddenStackCursor);
    $4fcf5377eb083461$var$pop($4fcf5377eb083461$var$prevEntangledRenderLanesCursor);
}
var $4fcf5377eb083461$var$suspenseHandlerStackCursor = $4fcf5377eb083461$var$createCursor(null), $4fcf5377eb083461$var$shellBoundary = null;
function $4fcf5377eb083461$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $4fcf5377eb083461$var$push($4fcf5377eb083461$var$suspenseStackCursor, $4fcf5377eb083461$var$suspenseStackCursor.current & 1);
    $4fcf5377eb083461$var$push($4fcf5377eb083461$var$suspenseHandlerStackCursor, handler);
    null === $4fcf5377eb083461$var$shellBoundary && (null === current || null !== $4fcf5377eb083461$var$currentTreeHiddenStackCursor.current ? $4fcf5377eb083461$var$shellBoundary = handler : null !== current.memoizedState && ($4fcf5377eb083461$var$shellBoundary = handler));
}
function $4fcf5377eb083461$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $4fcf5377eb083461$var$push($4fcf5377eb083461$var$suspenseStackCursor, $4fcf5377eb083461$var$suspenseStackCursor.current);
    $4fcf5377eb083461$var$push($4fcf5377eb083461$var$suspenseHandlerStackCursor, fiber);
    null === $4fcf5377eb083461$var$shellBoundary && ($4fcf5377eb083461$var$shellBoundary = fiber);
}
function $4fcf5377eb083461$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($4fcf5377eb083461$var$push($4fcf5377eb083461$var$suspenseStackCursor, $4fcf5377eb083461$var$suspenseStackCursor.current), $4fcf5377eb083461$var$push($4fcf5377eb083461$var$suspenseHandlerStackCursor, fiber), null === $4fcf5377eb083461$var$shellBoundary && ($4fcf5377eb083461$var$shellBoundary = fiber)) : $4fcf5377eb083461$var$reuseSuspenseHandlerOnStack();
}
function $4fcf5377eb083461$var$reuseSuspenseHandlerOnStack() {
    $4fcf5377eb083461$var$push($4fcf5377eb083461$var$suspenseStackCursor, $4fcf5377eb083461$var$suspenseStackCursor.current);
    $4fcf5377eb083461$var$push($4fcf5377eb083461$var$suspenseHandlerStackCursor, $4fcf5377eb083461$var$suspenseHandlerStackCursor.current);
}
function $4fcf5377eb083461$var$popSuspenseHandler(fiber) {
    $4fcf5377eb083461$var$pop($4fcf5377eb083461$var$suspenseHandlerStackCursor);
    $4fcf5377eb083461$var$shellBoundary === fiber && ($4fcf5377eb083461$var$shellBoundary = null);
    $4fcf5377eb083461$var$pop($4fcf5377eb083461$var$suspenseStackCursor);
}
var $4fcf5377eb083461$var$suspenseStackCursor = $4fcf5377eb083461$var$createCursor(0);
function $4fcf5377eb083461$var$pushSuspenseListContext(fiber, newContext) {
    $4fcf5377eb083461$var$push($4fcf5377eb083461$var$suspenseHandlerStackCursor, $4fcf5377eb083461$var$suspenseHandlerStackCursor.current);
    $4fcf5377eb083461$var$push($4fcf5377eb083461$var$suspenseStackCursor, newContext);
}
function $4fcf5377eb083461$var$popSuspenseListContext(fiber) {
    $4fcf5377eb083461$var$pop($4fcf5377eb083461$var$suspenseStackCursor);
    $4fcf5377eb083461$var$pop($4fcf5377eb083461$var$suspenseHandlerStackCursor);
    $4fcf5377eb083461$var$shellBoundary === fiber && ($4fcf5377eb083461$var$shellBoundary = null);
}
function $4fcf5377eb083461$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $4fcf5377eb083461$var$isSuspenseInstancePending(state) || $4fcf5377eb083461$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && "independent" !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $4fcf5377eb083461$var$renderLanes = 0, $4fcf5377eb083461$var$currentlyRenderingFiber = null, $4fcf5377eb083461$var$currentHook = null, $4fcf5377eb083461$var$workInProgressHook = null, $4fcf5377eb083461$var$didScheduleRenderPhaseUpdate = !1, $4fcf5377eb083461$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $4fcf5377eb083461$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $4fcf5377eb083461$var$localIdCounter = 0, $4fcf5377eb083461$var$thenableIndexCounter = 0, $4fcf5377eb083461$var$thenableState = null, $4fcf5377eb083461$var$globalClientIdCounter = 0;
function $4fcf5377eb083461$var$throwInvalidHookError() {
    throw Error($4fcf5377eb083461$var$formatProdErrorMessage(321));
}
function $4fcf5377eb083461$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$4fcf5377eb083461$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $4fcf5377eb083461$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $4fcf5377eb083461$var$renderLanes = nextRenderLanes;
    $4fcf5377eb083461$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $4fcf5377eb083461$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $4fcf5377eb083461$var$HooksDispatcherOnMount : $4fcf5377eb083461$var$HooksDispatcherOnUpdate;
    $4fcf5377eb083461$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $4fcf5377eb083461$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $4fcf5377eb083461$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $4fcf5377eb083461$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $4fcf5377eb083461$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $4fcf5377eb083461$var$finishRenderingHooks(current) {
    $4fcf5377eb083461$var$ReactSharedInternals.H = $4fcf5377eb083461$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $4fcf5377eb083461$var$currentHook && null !== $4fcf5377eb083461$var$currentHook.next;
    $4fcf5377eb083461$var$renderLanes = 0;
    $4fcf5377eb083461$var$workInProgressHook = $4fcf5377eb083461$var$currentHook = $4fcf5377eb083461$var$currentlyRenderingFiber = null;
    $4fcf5377eb083461$var$didScheduleRenderPhaseUpdate = !1;
    $4fcf5377eb083461$var$thenableIndexCounter = 0;
    $4fcf5377eb083461$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(300));
    null === current || $4fcf5377eb083461$var$didReceiveUpdate || (current = current.dependencies, null !== current && $4fcf5377eb083461$var$checkIfContextChanged(current) && ($4fcf5377eb083461$var$didReceiveUpdate = !0));
}
function $4fcf5377eb083461$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $4fcf5377eb083461$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $4fcf5377eb083461$var$didScheduleRenderPhaseUpdateDuringThisPass && ($4fcf5377eb083461$var$thenableState = null);
        $4fcf5377eb083461$var$thenableIndexCounter = 0;
        $4fcf5377eb083461$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $4fcf5377eb083461$var$workInProgressHook = $4fcf5377eb083461$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $4fcf5377eb083461$var$ReactSharedInternals.H = $4fcf5377eb083461$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($4fcf5377eb083461$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $4fcf5377eb083461$var$TransitionAwareHostComponent() {
    var dispatcher = $4fcf5377eb083461$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $4fcf5377eb083461$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $4fcf5377eb083461$var$currentHook ? $4fcf5377eb083461$var$currentHook.memoizedState : null) !== dispatcher && ($4fcf5377eb083461$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $4fcf5377eb083461$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $4fcf5377eb083461$var$localIdCounter;
    $4fcf5377eb083461$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $4fcf5377eb083461$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $4fcf5377eb083461$var$resetHooksOnUnwind(workInProgress) {
    if ($4fcf5377eb083461$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $4fcf5377eb083461$var$didScheduleRenderPhaseUpdate = !1;
    }
    $4fcf5377eb083461$var$renderLanes = 0;
    $4fcf5377eb083461$var$workInProgressHook = $4fcf5377eb083461$var$currentHook = $4fcf5377eb083461$var$currentlyRenderingFiber = null;
    $4fcf5377eb083461$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $4fcf5377eb083461$var$thenableIndexCounter = $4fcf5377eb083461$var$localIdCounter = 0;
    $4fcf5377eb083461$var$thenableState = null;
}
function $4fcf5377eb083461$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $4fcf5377eb083461$var$workInProgressHook ? $4fcf5377eb083461$var$currentlyRenderingFiber.memoizedState = $4fcf5377eb083461$var$workInProgressHook = hook : $4fcf5377eb083461$var$workInProgressHook = $4fcf5377eb083461$var$workInProgressHook.next = hook;
    return $4fcf5377eb083461$var$workInProgressHook;
}
function $4fcf5377eb083461$var$updateWorkInProgressHook() {
    if (null === $4fcf5377eb083461$var$currentHook) {
        var nextCurrentHook = $4fcf5377eb083461$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $4fcf5377eb083461$var$currentHook.next;
    var nextWorkInProgressHook = null === $4fcf5377eb083461$var$workInProgressHook ? $4fcf5377eb083461$var$currentlyRenderingFiber.memoizedState : $4fcf5377eb083461$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $4fcf5377eb083461$var$workInProgressHook = nextWorkInProgressHook, $4fcf5377eb083461$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $4fcf5377eb083461$var$currentlyRenderingFiber.alternate) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(467));
            throw Error($4fcf5377eb083461$var$formatProdErrorMessage(310));
        }
        $4fcf5377eb083461$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $4fcf5377eb083461$var$currentHook.memoizedState,
            baseState: $4fcf5377eb083461$var$currentHook.baseState,
            baseQueue: $4fcf5377eb083461$var$currentHook.baseQueue,
            queue: $4fcf5377eb083461$var$currentHook.queue,
            next: null
        };
        null === $4fcf5377eb083461$var$workInProgressHook ? $4fcf5377eb083461$var$currentlyRenderingFiber.memoizedState = $4fcf5377eb083461$var$workInProgressHook = nextCurrentHook : $4fcf5377eb083461$var$workInProgressHook = $4fcf5377eb083461$var$workInProgressHook.next = nextCurrentHook;
    }
    return $4fcf5377eb083461$var$workInProgressHook;
}
function $4fcf5377eb083461$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $4fcf5377eb083461$var$useThenable(thenable) {
    var index = $4fcf5377eb083461$var$thenableIndexCounter;
    $4fcf5377eb083461$var$thenableIndexCounter += 1;
    null === $4fcf5377eb083461$var$thenableState && ($4fcf5377eb083461$var$thenableState = []);
    thenable = $4fcf5377eb083461$var$trackUsedThenable($4fcf5377eb083461$var$thenableState, thenable, index);
    index = $4fcf5377eb083461$var$currentlyRenderingFiber;
    null === (null === $4fcf5377eb083461$var$workInProgressHook ? index.memoizedState : $4fcf5377eb083461$var$workInProgressHook.next) && (index = index.alternate, $4fcf5377eb083461$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $4fcf5377eb083461$var$HooksDispatcherOnMount : $4fcf5377eb083461$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $4fcf5377eb083461$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $4fcf5377eb083461$var$useThenable(usable);
        if (usable.$$typeof === $4fcf5377eb083461$var$REACT_RECOVERABLE_TYPE) return;
        if (usable.$$typeof === $4fcf5377eb083461$var$REACT_CONTEXT_TYPE) return $4fcf5377eb083461$var$readContext(usable);
    }
    throw Error($4fcf5377eb083461$var$formatProdErrorMessage(438, String(usable)));
}
function $4fcf5377eb083461$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $4fcf5377eb083461$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $4fcf5377eb083461$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $4fcf5377eb083461$var$createFunctionComponentUpdateQueue(), $4fcf5377eb083461$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $4fcf5377eb083461$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $4fcf5377eb083461$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $4fcf5377eb083461$var$updateReducer(reducer) {
    var hook = $4fcf5377eb083461$var$updateWorkInProgressHook();
    return $4fcf5377eb083461$var$updateReducerImpl(hook, $4fcf5377eb083461$var$currentHook, reducer);
}
function $4fcf5377eb083461$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$64 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($4fcf5377eb083461$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($4fcf5377eb083461$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $4fcf5377eb083461$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                else if (($4fcf5377eb083461$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $4fcf5377eb083461$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $4fcf5377eb083461$var$currentlyRenderingFiber.lanes |= revertLane, $4fcf5377eb083461$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $4fcf5377eb083461$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $4fcf5377eb083461$var$currentlyRenderingFiber.lanes |= updateLane, $4fcf5377eb083461$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$4fcf5377eb083461$var$objectIs(pendingQueue, hook.memoizedState) && ($4fcf5377eb083461$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$64 && (reducer = $4fcf5377eb083461$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $4fcf5377eb083461$var$rerenderReducer(reducer) {
    var hook = $4fcf5377eb083461$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $4fcf5377eb083461$var$objectIs(newState, hook.memoizedState) || ($4fcf5377eb083461$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $4fcf5377eb083461$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $4fcf5377eb083461$var$currentlyRenderingFiber, hook = $4fcf5377eb083461$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $4fcf5377eb083461$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$4fcf5377eb083461$var$objectIs(($4fcf5377eb083461$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $4fcf5377eb083461$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $4fcf5377eb083461$var$updateEffect($4fcf5377eb083461$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    subscribe = hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $4fcf5377eb083461$var$workInProgressHook && 0 !== ($4fcf5377eb083461$var$workInProgressHook.memoizedState.tag & 1);
    $4fcf5377eb083461$var$pushSimpleEffect(subscribe ? 9 : 8, {
        destroy: void 0
    }, $4fcf5377eb083461$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
    if (subscribe) {
        fiber.flags |= 2048;
        if (null === $4fcf5377eb083461$var$workInProgressRoot) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($4fcf5377eb083461$var$renderLanes & 127) || $4fcf5377eb083461$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $4fcf5377eb083461$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $4fcf5377eb083461$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $4fcf5377eb083461$var$createFunctionComponentUpdateQueue(), $4fcf5377eb083461$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $4fcf5377eb083461$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $4fcf5377eb083461$var$checkIfSnapshotChanged(inst) && $4fcf5377eb083461$var$forceStoreRerender(fiber);
}
function $4fcf5377eb083461$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $4fcf5377eb083461$var$checkIfSnapshotChanged(inst) && $4fcf5377eb083461$var$forceStoreRerender(fiber);
    });
}
function $4fcf5377eb083461$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$4fcf5377eb083461$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $4fcf5377eb083461$var$forceStoreRerender(fiber) {
    var root = $4fcf5377eb083461$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $4fcf5377eb083461$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $4fcf5377eb083461$var$mountStateImpl(initialState) {
    var hook = $4fcf5377eb083461$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($4fcf5377eb083461$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $4fcf5377eb083461$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $4fcf5377eb083461$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $4fcf5377eb083461$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $4fcf5377eb083461$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $4fcf5377eb083461$var$updateReducerImpl(hook, $4fcf5377eb083461$var$currentHook, "function" === typeof reducer ? reducer : $4fcf5377eb083461$var$basicStateReducer);
}
function $4fcf5377eb083461$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($4fcf5377eb083461$var$isRenderPhaseUpdate(fiber)) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $4fcf5377eb083461$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $4fcf5377eb083461$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $4fcf5377eb083461$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $4fcf5377eb083461$var$ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        $4fcf5377eb083461$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $4fcf5377eb083461$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $4fcf5377eb083461$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $4fcf5377eb083461$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $4fcf5377eb083461$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $4fcf5377eb083461$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$70) {
        $4fcf5377eb083461$var$onActionError(actionQueue, node, error$70);
    }
}
function $4fcf5377eb083461$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $4fcf5377eb083461$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $4fcf5377eb083461$var$onActionError(actionQueue, node, error);
    }) : $4fcf5377eb083461$var$onActionSuccess(actionQueue, node, returnValue);
}
function $4fcf5377eb083461$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $4fcf5377eb083461$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $4fcf5377eb083461$var$runActionStateAction(actionQueue, nextState)));
}
function $4fcf5377eb083461$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $4fcf5377eb083461$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $4fcf5377eb083461$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $4fcf5377eb083461$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $4fcf5377eb083461$var$mountActionState(action, initialStateProp) {
    if ($4fcf5377eb083461$var$isHydrating) {
        var ssrFormState = $4fcf5377eb083461$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $4fcf5377eb083461$var$currentlyRenderingFiber;
                if ($4fcf5377eb083461$var$isHydrating) {
                    if ($4fcf5377eb083461$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $4fcf5377eb083461$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $4fcf5377eb083461$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $4fcf5377eb083461$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $4fcf5377eb083461$var$nextHydratableInstance = $4fcf5377eb083461$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $4fcf5377eb083461$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $4fcf5377eb083461$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $4fcf5377eb083461$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $4fcf5377eb083461$var$dispatchSetState.bind(null, $4fcf5377eb083461$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $4fcf5377eb083461$var$mountStateImpl(!1);
    inRootOrSingleton = $4fcf5377eb083461$var$dispatchOptimisticSetState.bind(null, $4fcf5377eb083461$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $4fcf5377eb083461$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $4fcf5377eb083461$var$dispatchActionState.bind(null, $4fcf5377eb083461$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $4fcf5377eb083461$var$updateActionState(action) {
    var stateHook = $4fcf5377eb083461$var$updateWorkInProgressHook();
    return $4fcf5377eb083461$var$updateActionStateImpl(stateHook, $4fcf5377eb083461$var$currentHook, action);
}
function $4fcf5377eb083461$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $4fcf5377eb083461$var$updateReducerImpl(stateHook, currentStateHook, $4fcf5377eb083461$var$actionStateReducer)[0];
    stateHook = $4fcf5377eb083461$var$updateReducer($4fcf5377eb083461$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $4fcf5377eb083461$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $4fcf5377eb083461$var$SuspenseException) throw $4fcf5377eb083461$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $4fcf5377eb083461$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($4fcf5377eb083461$var$currentlyRenderingFiber.flags |= 2048, $4fcf5377eb083461$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $4fcf5377eb083461$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $4fcf5377eb083461$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $4fcf5377eb083461$var$rerenderActionState(action) {
    var stateHook = $4fcf5377eb083461$var$updateWorkInProgressHook(), currentStateHook = $4fcf5377eb083461$var$currentHook;
    if (null !== currentStateHook) return $4fcf5377eb083461$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $4fcf5377eb083461$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $4fcf5377eb083461$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $4fcf5377eb083461$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $4fcf5377eb083461$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $4fcf5377eb083461$var$createFunctionComponentUpdateQueue(), $4fcf5377eb083461$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $4fcf5377eb083461$var$updateRef() {
    return $4fcf5377eb083461$var$updateWorkInProgressHook().memoizedState;
}
function $4fcf5377eb083461$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $4fcf5377eb083461$var$mountWorkInProgressHook();
    $4fcf5377eb083461$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $4fcf5377eb083461$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $4fcf5377eb083461$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $4fcf5377eb083461$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $4fcf5377eb083461$var$currentHook && null !== deps && $4fcf5377eb083461$var$areHookInputsEqual(deps, $4fcf5377eb083461$var$currentHook.memoizedState.deps) ? hook.memoizedState = $4fcf5377eb083461$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($4fcf5377eb083461$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $4fcf5377eb083461$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $4fcf5377eb083461$var$mountEffect(create, deps) {
    $4fcf5377eb083461$var$mountEffectImpl(8390656, 8, create, deps);
}
function $4fcf5377eb083461$var$updateEffect(create, deps) {
    $4fcf5377eb083461$var$updateEffectImpl(2048, 8, create, deps);
}
function $4fcf5377eb083461$var$useEffectEventImpl(payload) {
    $4fcf5377eb083461$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $4fcf5377eb083461$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $4fcf5377eb083461$var$createFunctionComponentUpdateQueue(), $4fcf5377eb083461$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $4fcf5377eb083461$var$updateEvent(callback) {
    var ref = $4fcf5377eb083461$var$updateWorkInProgressHook().memoizedState;
    $4fcf5377eb083461$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($4fcf5377eb083461$var$executionContext & 2)) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $4fcf5377eb083461$var$updateInsertionEffect(create, deps) {
    return $4fcf5377eb083461$var$updateEffectImpl(4, 2, create, deps);
}
function $4fcf5377eb083461$var$updateLayoutEffect(create, deps) {
    return $4fcf5377eb083461$var$updateEffectImpl(4, 4, create, deps);
}
function $4fcf5377eb083461$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $4fcf5377eb083461$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $4fcf5377eb083461$var$updateEffectImpl(4, 4, $4fcf5377eb083461$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $4fcf5377eb083461$var$mountDebugValue() {}
function $4fcf5377eb083461$var$updateCallback(callback, deps) {
    var hook = $4fcf5377eb083461$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $4fcf5377eb083461$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $4fcf5377eb083461$var$updateMemo(nextCreate, deps) {
    var hook = $4fcf5377eb083461$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $4fcf5377eb083461$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($4fcf5377eb083461$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $4fcf5377eb083461$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $4fcf5377eb083461$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $4fcf5377eb083461$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($4fcf5377eb083461$var$renderLanes & 1073741824) && 0 === ($4fcf5377eb083461$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $4fcf5377eb083461$var$requestDeferredLane();
    $4fcf5377eb083461$var$currentlyRenderingFiber.lanes |= hook;
    $4fcf5377eb083461$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $4fcf5377eb083461$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($4fcf5377eb083461$var$objectIs(value, prevValue)) return value;
    if (null !== $4fcf5377eb083461$var$currentTreeHiddenStackCursor.current) return hook = $4fcf5377eb083461$var$mountDeferredValueImpl(hook, value, initialValue), $4fcf5377eb083461$var$objectIs(hook, prevValue) || ($4fcf5377eb083461$var$didReceiveUpdate = !0), hook;
    if (0 === ($4fcf5377eb083461$var$renderLanes & 106) || 0 !== ($4fcf5377eb083461$var$renderLanes & 1073741824) && 0 === ($4fcf5377eb083461$var$workInProgressRootRenderLanes & 261930)) return $4fcf5377eb083461$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $4fcf5377eb083461$var$requestDeferredLane();
    $4fcf5377eb083461$var$currentlyRenderingFiber.lanes |= hook;
    $4fcf5377eb083461$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $4fcf5377eb083461$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $4fcf5377eb083461$var$ReactDOMSharedInternals.p;
    $4fcf5377eb083461$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $4fcf5377eb083461$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $4fcf5377eb083461$var$ReactSharedInternals.T = currentTransition;
    $4fcf5377eb083461$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $4fcf5377eb083461$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $4fcf5377eb083461$var$chainThenableValue(returnValue, finishedState);
            $4fcf5377eb083461$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $4fcf5377eb083461$var$requestUpdateLane(fiber));
        } else $4fcf5377eb083461$var$dispatchSetStateInternal(fiber, queue, finishedState, $4fcf5377eb083461$var$requestUpdateLane(fiber));
    } catch (error) {
        $4fcf5377eb083461$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $4fcf5377eb083461$var$requestUpdateLane());
    } finally{
        $4fcf5377eb083461$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $4fcf5377eb083461$var$ReactSharedInternals.T = prevTransition;
    }
}
function $4fcf5377eb083461$var$noop() {}
function $4fcf5377eb083461$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(476));
    var queue = $4fcf5377eb083461$var$ensureFormComponentIsStateful(formFiber).queue;
    $4fcf5377eb083461$var$startTransition(formFiber, queue, pendingState, $4fcf5377eb083461$var$sharedNotPendingObject, null === action ? $4fcf5377eb083461$var$noop : function() {
        $4fcf5377eb083461$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $4fcf5377eb083461$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $4fcf5377eb083461$var$sharedNotPendingObject,
        baseState: $4fcf5377eb083461$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $4fcf5377eb083461$var$basicStateReducer,
            lastRenderedState: $4fcf5377eb083461$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $4fcf5377eb083461$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $4fcf5377eb083461$var$requestFormReset$1(formFiber) {
    var stateHook = $4fcf5377eb083461$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $4fcf5377eb083461$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $4fcf5377eb083461$var$requestUpdateLane());
}
function $4fcf5377eb083461$var$useHostTransitionStatus() {
    return $4fcf5377eb083461$var$readContext($4fcf5377eb083461$var$HostTransitionContext);
}
function $4fcf5377eb083461$var$updateId() {
    return $4fcf5377eb083461$var$updateWorkInProgressHook().memoizedState;
}
function $4fcf5377eb083461$var$updateRefresh() {
    return $4fcf5377eb083461$var$updateWorkInProgressHook().memoizedState;
}
function $4fcf5377eb083461$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $4fcf5377eb083461$var$requestUpdateLane();
                fiber = $4fcf5377eb083461$var$createUpdate(lane);
                var root$73 = $4fcf5377eb083461$var$enqueueUpdate(provider, fiber, lane);
                null !== root$73 && ($4fcf5377eb083461$var$scheduleUpdateOnFiber(root$73, provider, lane), $4fcf5377eb083461$var$entangleTransitions(root$73, provider, lane));
                provider = {
                    cache: $4fcf5377eb083461$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $4fcf5377eb083461$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $4fcf5377eb083461$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $4fcf5377eb083461$var$isRenderPhaseUpdate(fiber) ? $4fcf5377eb083461$var$enqueueRenderPhaseUpdate(queue, action) : (action = $4fcf5377eb083461$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($4fcf5377eb083461$var$scheduleUpdateOnFiber(action, fiber, lane), $4fcf5377eb083461$var$entangleTransitionUpdate(action, queue, lane)));
}
function $4fcf5377eb083461$var$dispatchSetState(fiber, queue, action) {
    var lane = $4fcf5377eb083461$var$requestUpdateLane();
    $4fcf5377eb083461$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $4fcf5377eb083461$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4fcf5377eb083461$var$isRenderPhaseUpdate(fiber)) $4fcf5377eb083461$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($4fcf5377eb083461$var$objectIs(eagerState, currentState)) return $4fcf5377eb083461$var$enqueueUpdate$1(fiber, queue, update, 0), null === $4fcf5377eb083461$var$workInProgressRoot && $4fcf5377eb083461$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $4fcf5377eb083461$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $4fcf5377eb083461$var$scheduleUpdateOnFiber(action, fiber, lane), $4fcf5377eb083461$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $4fcf5377eb083461$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $4fcf5377eb083461$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4fcf5377eb083461$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $4fcf5377eb083461$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $4fcf5377eb083461$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $4fcf5377eb083461$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $4fcf5377eb083461$var$currentlyRenderingFiber || null !== alternate && alternate === $4fcf5377eb083461$var$currentlyRenderingFiber;
}
function $4fcf5377eb083461$var$enqueueRenderPhaseUpdate(queue, update) {
    $4fcf5377eb083461$var$didScheduleRenderPhaseUpdateDuringThisPass = $4fcf5377eb083461$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $4fcf5377eb083461$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $4fcf5377eb083461$var$markRootEntangled(root, lane);
    }
}
var $4fcf5377eb083461$var$ContextOnlyDispatcher = {
    readContext: $4fcf5377eb083461$var$readContext,
    use: $4fcf5377eb083461$var$use,
    useCallback: $4fcf5377eb083461$var$throwInvalidHookError,
    useContext: $4fcf5377eb083461$var$throwInvalidHookError,
    useEffect: $4fcf5377eb083461$var$throwInvalidHookError,
    useImperativeHandle: $4fcf5377eb083461$var$throwInvalidHookError,
    useLayoutEffect: $4fcf5377eb083461$var$throwInvalidHookError,
    useInsertionEffect: $4fcf5377eb083461$var$throwInvalidHookError,
    useMemo: $4fcf5377eb083461$var$throwInvalidHookError,
    useReducer: $4fcf5377eb083461$var$throwInvalidHookError,
    useRef: $4fcf5377eb083461$var$throwInvalidHookError,
    useState: $4fcf5377eb083461$var$throwInvalidHookError,
    useDebugValue: $4fcf5377eb083461$var$throwInvalidHookError,
    useDeferredValue: $4fcf5377eb083461$var$throwInvalidHookError,
    useTransition: $4fcf5377eb083461$var$throwInvalidHookError,
    useSyncExternalStore: $4fcf5377eb083461$var$throwInvalidHookError,
    useId: $4fcf5377eb083461$var$throwInvalidHookError,
    useHostTransitionStatus: $4fcf5377eb083461$var$throwInvalidHookError,
    useFormState: $4fcf5377eb083461$var$throwInvalidHookError,
    useActionState: $4fcf5377eb083461$var$throwInvalidHookError,
    useOptimistic: $4fcf5377eb083461$var$throwInvalidHookError,
    useMemoCache: $4fcf5377eb083461$var$throwInvalidHookError,
    useCacheRefresh: $4fcf5377eb083461$var$throwInvalidHookError,
    useEffectEvent: $4fcf5377eb083461$var$throwInvalidHookError
}, $4fcf5377eb083461$var$HooksDispatcherOnMount = {
    readContext: $4fcf5377eb083461$var$readContext,
    use: $4fcf5377eb083461$var$use,
    useCallback: function(callback, deps) {
        $4fcf5377eb083461$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $4fcf5377eb083461$var$readContext,
    useEffect: $4fcf5377eb083461$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $4fcf5377eb083461$var$mountEffectImpl(4194308, 4, $4fcf5377eb083461$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $4fcf5377eb083461$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $4fcf5377eb083461$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $4fcf5377eb083461$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($4fcf5377eb083461$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $4fcf5377eb083461$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $4fcf5377eb083461$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $4fcf5377eb083461$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($4fcf5377eb083461$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $4fcf5377eb083461$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $4fcf5377eb083461$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $4fcf5377eb083461$var$dispatchReducerAction.bind(null, $4fcf5377eb083461$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $4fcf5377eb083461$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $4fcf5377eb083461$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $4fcf5377eb083461$var$dispatchSetState.bind(null, $4fcf5377eb083461$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $4fcf5377eb083461$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $4fcf5377eb083461$var$mountWorkInProgressHook();
        return $4fcf5377eb083461$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $4fcf5377eb083461$var$mountStateImpl(!1);
        stateHook = $4fcf5377eb083461$var$startTransition.bind(null, $4fcf5377eb083461$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $4fcf5377eb083461$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $4fcf5377eb083461$var$currentlyRenderingFiber, hook = $4fcf5377eb083461$var$mountWorkInProgressHook();
        if ($4fcf5377eb083461$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $4fcf5377eb083461$var$workInProgressRoot) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(349));
            0 !== ($4fcf5377eb083461$var$workInProgressRootRenderLanes & 127) || $4fcf5377eb083461$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $4fcf5377eb083461$var$mountEffect($4fcf5377eb083461$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $4fcf5377eb083461$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $4fcf5377eb083461$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $4fcf5377eb083461$var$mountWorkInProgressHook(), identifierPrefix = $4fcf5377eb083461$var$workInProgressRoot.identifierPrefix;
        if ($4fcf5377eb083461$var$isHydrating) {
            var JSCompiler_inline_result = $4fcf5377eb083461$var$treeContextOverflow;
            var idWithLeadingBit = $4fcf5377eb083461$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $4fcf5377eb083461$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $4fcf5377eb083461$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $4fcf5377eb083461$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $4fcf5377eb083461$var$useHostTransitionStatus,
    useFormState: $4fcf5377eb083461$var$mountActionState,
    useActionState: $4fcf5377eb083461$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $4fcf5377eb083461$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $4fcf5377eb083461$var$dispatchOptimisticSetState.bind(null, $4fcf5377eb083461$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $4fcf5377eb083461$var$useMemoCache,
    useCacheRefresh: function() {
        return $4fcf5377eb083461$var$mountWorkInProgressHook().memoizedState = $4fcf5377eb083461$var$refreshCache.bind(null, $4fcf5377eb083461$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $4fcf5377eb083461$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($4fcf5377eb083461$var$executionContext & 2)) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $4fcf5377eb083461$var$HooksDispatcherOnUpdate = {
    readContext: $4fcf5377eb083461$var$readContext,
    use: $4fcf5377eb083461$var$use,
    useCallback: $4fcf5377eb083461$var$updateCallback,
    useContext: $4fcf5377eb083461$var$readContext,
    useEffect: $4fcf5377eb083461$var$updateEffect,
    useImperativeHandle: $4fcf5377eb083461$var$updateImperativeHandle,
    useInsertionEffect: $4fcf5377eb083461$var$updateInsertionEffect,
    useLayoutEffect: $4fcf5377eb083461$var$updateLayoutEffect,
    useMemo: $4fcf5377eb083461$var$updateMemo,
    useReducer: $4fcf5377eb083461$var$updateReducer,
    useRef: $4fcf5377eb083461$var$updateRef,
    useState: function() {
        return $4fcf5377eb083461$var$updateReducer($4fcf5377eb083461$var$basicStateReducer);
    },
    useDebugValue: $4fcf5377eb083461$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $4fcf5377eb083461$var$updateWorkInProgressHook();
        return $4fcf5377eb083461$var$updateDeferredValueImpl(hook, $4fcf5377eb083461$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $4fcf5377eb083461$var$updateReducer($4fcf5377eb083461$var$basicStateReducer)[0], start = $4fcf5377eb083461$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $4fcf5377eb083461$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $4fcf5377eb083461$var$updateSyncExternalStore,
    useId: $4fcf5377eb083461$var$updateId,
    useHostTransitionStatus: $4fcf5377eb083461$var$useHostTransitionStatus,
    useFormState: $4fcf5377eb083461$var$updateActionState,
    useActionState: $4fcf5377eb083461$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $4fcf5377eb083461$var$updateWorkInProgressHook();
        return $4fcf5377eb083461$var$updateOptimisticImpl(hook, $4fcf5377eb083461$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $4fcf5377eb083461$var$useMemoCache,
    useCacheRefresh: $4fcf5377eb083461$var$updateRefresh,
    useEffectEvent: $4fcf5377eb083461$var$updateEvent
}, $4fcf5377eb083461$var$HooksDispatcherOnRerender = {
    readContext: $4fcf5377eb083461$var$readContext,
    use: $4fcf5377eb083461$var$use,
    useCallback: $4fcf5377eb083461$var$updateCallback,
    useContext: $4fcf5377eb083461$var$readContext,
    useEffect: $4fcf5377eb083461$var$updateEffect,
    useImperativeHandle: $4fcf5377eb083461$var$updateImperativeHandle,
    useInsertionEffect: $4fcf5377eb083461$var$updateInsertionEffect,
    useLayoutEffect: $4fcf5377eb083461$var$updateLayoutEffect,
    useMemo: $4fcf5377eb083461$var$updateMemo,
    useReducer: $4fcf5377eb083461$var$rerenderReducer,
    useRef: $4fcf5377eb083461$var$updateRef,
    useState: function() {
        return $4fcf5377eb083461$var$rerenderReducer($4fcf5377eb083461$var$basicStateReducer);
    },
    useDebugValue: $4fcf5377eb083461$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $4fcf5377eb083461$var$updateWorkInProgressHook();
        return null === $4fcf5377eb083461$var$currentHook ? $4fcf5377eb083461$var$mountDeferredValueImpl(hook, value, initialValue) : $4fcf5377eb083461$var$updateDeferredValueImpl(hook, $4fcf5377eb083461$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $4fcf5377eb083461$var$rerenderReducer($4fcf5377eb083461$var$basicStateReducer)[0], start = $4fcf5377eb083461$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $4fcf5377eb083461$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $4fcf5377eb083461$var$updateSyncExternalStore,
    useId: $4fcf5377eb083461$var$updateId,
    useHostTransitionStatus: $4fcf5377eb083461$var$useHostTransitionStatus,
    useFormState: $4fcf5377eb083461$var$rerenderActionState,
    useActionState: $4fcf5377eb083461$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $4fcf5377eb083461$var$updateWorkInProgressHook();
        if (null !== $4fcf5377eb083461$var$currentHook) return $4fcf5377eb083461$var$updateOptimisticImpl(hook, $4fcf5377eb083461$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $4fcf5377eb083461$var$useMemoCache,
    useCacheRefresh: $4fcf5377eb083461$var$updateRefresh,
    useEffectEvent: $4fcf5377eb083461$var$updateEvent
};
function $4fcf5377eb083461$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $4fcf5377eb083461$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $4fcf5377eb083461$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $4fcf5377eb083461$var$requestUpdateLane(), update = $4fcf5377eb083461$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $4fcf5377eb083461$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($4fcf5377eb083461$var$scheduleUpdateOnFiber(payload, inst, lane), $4fcf5377eb083461$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $4fcf5377eb083461$var$requestUpdateLane(), update = $4fcf5377eb083461$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $4fcf5377eb083461$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($4fcf5377eb083461$var$scheduleUpdateOnFiber(payload, inst, lane), $4fcf5377eb083461$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $4fcf5377eb083461$var$requestUpdateLane(), update = $4fcf5377eb083461$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $4fcf5377eb083461$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($4fcf5377eb083461$var$scheduleUpdateOnFiber(callback, inst, lane), $4fcf5377eb083461$var$entangleTransitions(callback, inst, lane));
    }
};
function $4fcf5377eb083461$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$4fcf5377eb083461$var$shallowEqual(oldProps, newProps) || !$4fcf5377eb083461$var$shallowEqual(oldState, newState) : !0;
}
function $4fcf5377eb083461$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $4fcf5377eb083461$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $4fcf5377eb083461$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $4fcf5377eb083461$var$assign({}, newProps));
        for(var propName$77 in Component)void 0 === newProps[propName$77] && (newProps[propName$77] = Component[propName$77]);
    }
    return newProps;
}
function $4fcf5377eb083461$var$defaultOnUncaughtError(error) {
    $4fcf5377eb083461$var$reportGlobalError(error);
}
function $4fcf5377eb083461$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $4fcf5377eb083461$var$defaultOnRecoverableError(error) {
    $4fcf5377eb083461$var$reportGlobalError(error);
}
function $4fcf5377eb083461$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$78) {
        setTimeout(function() {
            throw e$78;
        });
    }
}
function $4fcf5377eb083461$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$79) {
        setTimeout(function() {
            throw e$79;
        });
    }
}
function $4fcf5377eb083461$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $4fcf5377eb083461$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $4fcf5377eb083461$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $4fcf5377eb083461$var$createClassErrorUpdate(lane) {
    lane = $4fcf5377eb083461$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $4fcf5377eb083461$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $4fcf5377eb083461$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $4fcf5377eb083461$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $4fcf5377eb083461$var$legacyErrorBoundariesThatAlreadyFailed ? $4fcf5377eb083461$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $4fcf5377eb083461$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $4fcf5377eb083461$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $4fcf5377eb083461$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $4fcf5377eb083461$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                case 19:
                    return null === $4fcf5377eb083461$var$shellBoundary ? $4fcf5377eb083461$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $4fcf5377eb083461$var$workInProgressRootExitStatus && ($4fcf5377eb083461$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $4fcf5377eb083461$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $4fcf5377eb083461$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $4fcf5377eb083461$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $4fcf5377eb083461$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($4fcf5377eb083461$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $4fcf5377eb083461$var$attachPingListener(root, value, rootRenderLanes);
        $4fcf5377eb083461$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($4fcf5377eb083461$var$isHydrating) return returnFiber = $4fcf5377eb083461$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $4fcf5377eb083461$var$HydrationMismatchException && (root = Error($4fcf5377eb083461$var$formatProdErrorMessage(422), {
        cause: value
    }), $4fcf5377eb083461$var$queueHydrationError($4fcf5377eb083461$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $4fcf5377eb083461$var$HydrationMismatchException && (returnFiber = Error($4fcf5377eb083461$var$formatProdErrorMessage(423), {
        cause: value
    }), $4fcf5377eb083461$var$queueHydrationError($4fcf5377eb083461$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $4fcf5377eb083461$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $4fcf5377eb083461$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $4fcf5377eb083461$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $4fcf5377eb083461$var$workInProgressRootExitStatus && ($4fcf5377eb083461$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($4fcf5377eb083461$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $4fcf5377eb083461$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $4fcf5377eb083461$var$workInProgressRootConcurrentErrors ? $4fcf5377eb083461$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $4fcf5377eb083461$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $4fcf5377eb083461$var$workInProgressRootExitStatus && ($4fcf5377eb083461$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $4fcf5377eb083461$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $4fcf5377eb083461$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $4fcf5377eb083461$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                returnFiber = sourceFiber.type;
                wrapperError = sourceFiber.stateNode;
                if (0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $4fcf5377eb083461$var$legacyErrorBoundariesThatAlreadyFailed || !$4fcf5377eb083461$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $4fcf5377eb083461$var$createClassErrorUpdate(rootRenderLanes), $4fcf5377eb083461$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $4fcf5377eb083461$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
                break;
            case 22:
                if (null !== sourceFiber.memoizedState) return sourceFiber.flags |= 65536, !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $4fcf5377eb083461$var$SelectiveHydrationException = Error($4fcf5377eb083461$var$formatProdErrorMessage(461)), $4fcf5377eb083461$var$didReceiveUpdate = !1;
function $4fcf5377eb083461$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $4fcf5377eb083461$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $4fcf5377eb083461$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $4fcf5377eb083461$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $4fcf5377eb083461$var$prepareToReadContext(workInProgress);
    nextProps = $4fcf5377eb083461$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $4fcf5377eb083461$var$checkDidRenderIdHook();
    if (null !== current && !$4fcf5377eb083461$var$didReceiveUpdate) return $4fcf5377eb083461$var$bailoutHooks(current, workInProgress, renderLanes), $4fcf5377eb083461$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $4fcf5377eb083461$var$isHydrating && key && $4fcf5377eb083461$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $4fcf5377eb083461$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $4fcf5377eb083461$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$4fcf5377eb083461$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $4fcf5377eb083461$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $4fcf5377eb083461$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$4fcf5377eb083461$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $4fcf5377eb083461$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $4fcf5377eb083461$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $4fcf5377eb083461$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $4fcf5377eb083461$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($4fcf5377eb083461$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($4fcf5377eb083461$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $4fcf5377eb083461$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($4fcf5377eb083461$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $4fcf5377eb083461$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $4fcf5377eb083461$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $4fcf5377eb083461$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $4fcf5377eb083461$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $4fcf5377eb083461$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $4fcf5377eb083461$var$pushHiddenContext(workInProgress, prevState) : $4fcf5377eb083461$var$reuseHiddenContextOnStack(), $4fcf5377eb083461$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $4fcf5377eb083461$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($4fcf5377eb083461$var$pushTransition(workInProgress, prevState.cachePool), $4fcf5377eb083461$var$pushHiddenContext(workInProgress, prevState), $4fcf5377eb083461$var$reuseSuspenseHandlerOnStack(), workInProgress.memoizedState = null) : (null !== current && $4fcf5377eb083461$var$pushTransition(workInProgress, null), $4fcf5377eb083461$var$reuseHiddenContextOnStack(), $4fcf5377eb083461$var$reuseSuspenseHandlerOnStack());
    $4fcf5377eb083461$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $4fcf5377eb083461$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $4fcf5377eb083461$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $4fcf5377eb083461$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $4fcf5377eb083461$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $4fcf5377eb083461$var$pushTransition(workInProgress, null);
    $4fcf5377eb083461$var$reuseHiddenContextOnStack();
    $4fcf5377eb083461$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $4fcf5377eb083461$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $4fcf5377eb083461$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $4fcf5377eb083461$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $4fcf5377eb083461$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $4fcf5377eb083461$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $4fcf5377eb083461$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $4fcf5377eb083461$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $4fcf5377eb083461$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($4fcf5377eb083461$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $4fcf5377eb083461$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, current.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, $4fcf5377eb083461$var$bailoutOffscreenComponent(null, current);
            $4fcf5377eb083461$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $4fcf5377eb083461$var$nextHydratableInstance) ? (current = $4fcf5377eb083461$var$canHydrateHydrationBoundary(current, $4fcf5377eb083461$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $4fcf5377eb083461$var$treeContextProvider ? {
                    id: $4fcf5377eb083461$var$treeContextId,
                    overflow: $4fcf5377eb083461$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $4fcf5377eb083461$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $4fcf5377eb083461$var$hydrationParentFiber = workInProgress, $4fcf5377eb083461$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $4fcf5377eb083461$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $4fcf5377eb083461$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $4fcf5377eb083461$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $4fcf5377eb083461$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($4fcf5377eb083461$var$formatProdErrorMessage(558));
        } else if ($4fcf5377eb083461$var$didReceiveUpdate || $4fcf5377eb083461$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $4fcf5377eb083461$var$didReceiveUpdate || didSuspend) {
            if (null === $4fcf5377eb083461$var$currentTreeHiddenStackCursor.current) {
                nextProps = $4fcf5377eb083461$var$workInProgressRoot;
                if (null !== nextProps && (dehydrated = $4fcf5377eb083461$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $4fcf5377eb083461$var$enqueueConcurrentRenderForLane(current, dehydrated), $4fcf5377eb083461$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $4fcf5377eb083461$var$SelectiveHydrationException;
                $4fcf5377eb083461$var$renderDidSuspendDelayIfPossible();
            }
            workInProgress = $4fcf5377eb083461$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $4fcf5377eb083461$var$nextHydratableInstance = $4fcf5377eb083461$var$getNextHydratable(dehydrated.nextSibling), $4fcf5377eb083461$var$hydrationParentFiber = workInProgress, $4fcf5377eb083461$var$isHydrating = !0, $4fcf5377eb083461$var$hydrationErrors = null, $4fcf5377eb083461$var$rootOrSingletonContext = !1, null !== current && $4fcf5377eb083461$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $4fcf5377eb083461$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 134221824;
        return workInProgress;
    }
    current = $4fcf5377eb083461$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $4fcf5377eb083461$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $4fcf5377eb083461$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $4fcf5377eb083461$var$prepareToReadContext(workInProgress);
    Component = $4fcf5377eb083461$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $4fcf5377eb083461$var$checkDidRenderIdHook();
    if (null !== current && !$4fcf5377eb083461$var$didReceiveUpdate) return $4fcf5377eb083461$var$bailoutHooks(current, workInProgress, renderLanes), $4fcf5377eb083461$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $4fcf5377eb083461$var$isHydrating && nextProps && $4fcf5377eb083461$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $4fcf5377eb083461$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $4fcf5377eb083461$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $4fcf5377eb083461$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $4fcf5377eb083461$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $4fcf5377eb083461$var$finishRenderingHooks(current);
    Component = $4fcf5377eb083461$var$checkDidRenderIdHook();
    if (null !== current && !$4fcf5377eb083461$var$didReceiveUpdate) return $4fcf5377eb083461$var$bailoutHooks(current, workInProgress, renderLanes), $4fcf5377eb083461$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $4fcf5377eb083461$var$isHydrating && Component && $4fcf5377eb083461$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $4fcf5377eb083461$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $4fcf5377eb083461$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $4fcf5377eb083461$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $4fcf5377eb083461$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $4fcf5377eb083461$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $4fcf5377eb083461$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $4fcf5377eb083461$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $4fcf5377eb083461$var$readContext(contextType) : $4fcf5377eb083461$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($4fcf5377eb083461$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $4fcf5377eb083461$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $4fcf5377eb083461$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $4fcf5377eb083461$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $4fcf5377eb083461$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $4fcf5377eb083461$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $4fcf5377eb083461$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $4fcf5377eb083461$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $4fcf5377eb083461$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $4fcf5377eb083461$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $4fcf5377eb083461$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $4fcf5377eb083461$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($4fcf5377eb083461$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $4fcf5377eb083461$var$hasForceUpdate || $4fcf5377eb083461$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $4fcf5377eb083461$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $4fcf5377eb083461$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $4fcf5377eb083461$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $4fcf5377eb083461$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $4fcf5377eb083461$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $4fcf5377eb083461$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $4fcf5377eb083461$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $4fcf5377eb083461$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $4fcf5377eb083461$var$hasForceUpdate || null !== current && null !== current.dependencies && $4fcf5377eb083461$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($4fcf5377eb083461$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $4fcf5377eb083461$var$hasForceUpdate || $4fcf5377eb083461$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $4fcf5377eb083461$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $4fcf5377eb083461$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $4fcf5377eb083461$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $4fcf5377eb083461$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $4fcf5377eb083461$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $4fcf5377eb083461$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $4fcf5377eb083461$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $4fcf5377eb083461$var$resetHydrationState();
    workInProgress.flags |= 256;
    $4fcf5377eb083461$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $4fcf5377eb083461$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $4fcf5377eb083461$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $4fcf5377eb083461$var$getSuspendedCache()
    };
}
function $4fcf5377eb083461$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $4fcf5377eb083461$var$workInProgressDeferredLane);
    return current;
}
function $4fcf5377eb083461$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($4fcf5377eb083461$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($4fcf5377eb083461$var$isHydrating) {
            showFallback ? $4fcf5377eb083461$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $4fcf5377eb083461$var$reuseSuspenseHandlerOnStack();
            (current = $4fcf5377eb083461$var$nextHydratableInstance) ? (current = $4fcf5377eb083461$var$canHydrateHydrationBoundary(current, $4fcf5377eb083461$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $4fcf5377eb083461$var$treeContextProvider ? {
                    id: $4fcf5377eb083461$var$treeContextId,
                    overflow: $4fcf5377eb083461$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $4fcf5377eb083461$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $4fcf5377eb083461$var$hydrationParentFiber = workInProgress, $4fcf5377eb083461$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $4fcf5377eb083461$var$throwOnHydrationMismatch(workInProgress);
            $4fcf5377eb083461$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        didSuspend = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $4fcf5377eb083461$var$reuseSuspenseHandlerOnStack(), showFallback = workInProgress.mode, didSuspend = $4fcf5377eb083461$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: didSuspend
        }, showFallback), nextProps = $4fcf5377eb083461$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), didSuspend.return = workInProgress, nextProps.return = workInProgress, didSuspend.sibling = nextProps, workInProgress.child = didSuspend, nextProps = workInProgress.child, nextProps.memoizedState = $4fcf5377eb083461$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $4fcf5377eb083461$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $4fcf5377eb083461$var$SUSPENDED_MARKER, $4fcf5377eb083461$var$bailoutOffscreenComponent(null, nextProps);
        $4fcf5377eb083461$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $4fcf5377eb083461$var$mountSuspensePrimaryChildren(workInProgress, didSuspend);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated$96 = prevState.dehydrated;
        if (null !== dehydrated$96) return $4fcf5377eb083461$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, JSCompiler_temp, nextProps, dehydrated$96, prevState, renderLanes);
    }
    if (showFallback) return $4fcf5377eb083461$var$reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, didSuspend = workInProgress.mode, prevState = current.child, dehydrated$96 = prevState.sibling, nextProps = $4fcf5377eb083461$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 1206910976, null !== dehydrated$96 ? showFallback = $4fcf5377eb083461$var$createWorkInProgress(dehydrated$96, showFallback) : (showFallback = $4fcf5377eb083461$var$createFiberFromFragment(showFallback, didSuspend, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $4fcf5377eb083461$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, showFallback = current.child.memoizedState, null === showFallback ? showFallback = $4fcf5377eb083461$var$mountSuspenseOffscreenState(renderLanes) : (didSuspend = showFallback.cachePool, null !== didSuspend ? (prevState = $4fcf5377eb083461$var$CacheContext._currentValue, didSuspend = didSuspend.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : didSuspend) : didSuspend = $4fcf5377eb083461$var$getSuspendedCache(), showFallback = {
        baseLanes: showFallback.baseLanes | renderLanes,
        cachePool: didSuspend
    }), nextProps.memoizedState = showFallback, nextProps.childLanes = $4fcf5377eb083461$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $4fcf5377eb083461$var$SUSPENDED_MARKER, $4fcf5377eb083461$var$bailoutOffscreenComponent(current.child, nextProps);
    $4fcf5377eb083461$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $4fcf5377eb083461$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $4fcf5377eb083461$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $4fcf5377eb083461$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $4fcf5377eb083461$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $4fcf5377eb083461$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $4fcf5377eb083461$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $4fcf5377eb083461$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $4fcf5377eb083461$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $4fcf5377eb083461$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, didPrimaryChildrenDefer, nextProps, suspenseInstance, suspenseState, renderLanes) {
    if (didSuspend) {
        if (workInProgress.flags & 256) return $4fcf5377eb083461$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, $4fcf5377eb083461$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        if (null !== workInProgress.memoizedState) return $4fcf5377eb083461$var$reuseSuspenseHandlerOnStack(), workInProgress.child = current.child, workInProgress.flags |= 128, null;
        $4fcf5377eb083461$var$reuseSuspenseHandlerOnStack();
        suspenseInstance = nextProps.fallback;
        suspenseState = workInProgress.mode;
        nextProps = $4fcf5377eb083461$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, suspenseState);
        suspenseInstance = $4fcf5377eb083461$var$createFiberFromFragment(suspenseInstance, suspenseState, renderLanes, null);
        suspenseInstance.flags |= 2;
        nextProps.return = workInProgress;
        suspenseInstance.return = workInProgress;
        nextProps.sibling = suspenseInstance;
        workInProgress.child = nextProps;
        $4fcf5377eb083461$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        nextProps = workInProgress.child;
        nextProps.memoizedState = $4fcf5377eb083461$var$mountSuspenseOffscreenState(renderLanes);
        nextProps.childLanes = $4fcf5377eb083461$var$getRemainingWorkInPrimaryTree(current, didPrimaryChildrenDefer, renderLanes);
        workInProgress.memoizedState = $4fcf5377eb083461$var$SUSPENDED_MARKER;
        return $4fcf5377eb083461$var$bailoutOffscreenComponent(null, nextProps);
    }
    $4fcf5377eb083461$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    if ($4fcf5377eb083461$var$isSuspenseInstanceFallback(suspenseInstance)) {
        didPrimaryChildrenDefer = suspenseInstance.nextSibling && suspenseInstance.nextSibling.dataset;
        if (didPrimaryChildrenDefer) var digest = didPrimaryChildrenDefer.dgst;
        didPrimaryChildrenDefer = digest;
        "" !== didPrimaryChildrenDefer && (nextProps = Error($4fcf5377eb083461$var$formatProdErrorMessage(419)), nextProps.stack = "", nextProps.digest = didPrimaryChildrenDefer, $4fcf5377eb083461$var$queueHydrationError({
            value: nextProps,
            source: null,
            stack: null
        }));
        return $4fcf5377eb083461$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    $4fcf5377eb083461$var$didReceiveUpdate || $4fcf5377eb083461$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
    didPrimaryChildrenDefer = 0 !== (renderLanes & current.childLanes);
    if ($4fcf5377eb083461$var$didReceiveUpdate || didPrimaryChildrenDefer) {
        if (null !== $4fcf5377eb083461$var$currentTreeHiddenStackCursor.current) return $4fcf5377eb083461$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        didPrimaryChildrenDefer = $4fcf5377eb083461$var$workInProgressRoot;
        if (null !== didPrimaryChildrenDefer && (nextProps = $4fcf5377eb083461$var$getBumpedLaneForHydration(didPrimaryChildrenDefer, renderLanes), 0 !== nextProps && nextProps !== suspenseState.retryLane)) throw suspenseState.retryLane = nextProps, $4fcf5377eb083461$var$enqueueConcurrentRenderForLane(current, nextProps), $4fcf5377eb083461$var$scheduleUpdateOnFiber(didPrimaryChildrenDefer, current, nextProps), $4fcf5377eb083461$var$SelectiveHydrationException;
        $4fcf5377eb083461$var$isSuspenseInstancePending(suspenseInstance) || $4fcf5377eb083461$var$renderDidSuspendDelayIfPossible();
        return $4fcf5377eb083461$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    if ($4fcf5377eb083461$var$isSuspenseInstancePending(suspenseInstance)) return workInProgress.flags |= 192, workInProgress.child = current.child, null;
    current = suspenseState.treeContext;
    $4fcf5377eb083461$var$nextHydratableInstance = $4fcf5377eb083461$var$getNextHydratable(suspenseInstance.nextSibling);
    $4fcf5377eb083461$var$hydrationParentFiber = workInProgress;
    $4fcf5377eb083461$var$isHydrating = !0;
    $4fcf5377eb083461$var$hydrationErrors = null;
    $4fcf5377eb083461$var$rootOrSingletonContext = !1;
    null !== current && $4fcf5377eb083461$var$restoreSuspendedTreeContext(workInProgress, current);
    workInProgress = $4fcf5377eb083461$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children);
    workInProgress.flags |= 134221824;
    return workInProgress;
}
function $4fcf5377eb083461$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $4fcf5377eb083461$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $4fcf5377eb083461$var$findLastContentRow(firstChild) {
    for(var lastContentRow = null; null !== firstChild;){
        var currentRow = firstChild.alternate;
        null !== currentRow && null === $4fcf5377eb083461$var$findFirstSuspended(currentRow) && (lastContentRow = firstChild);
        firstChild = firstChild.sibling;
    }
    return lastContentRow;
}
function $4fcf5377eb083461$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $4fcf5377eb083461$var$reverseChildren(fiber) {
    var row = fiber.child;
    for(fiber.child = null; null !== row;){
        var nextRow = row.sibling;
        row.sibling = fiber.child;
        fiber.child = row;
        row = nextRow;
    }
}
function $4fcf5377eb083461$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $4fcf5377eb083461$var$suspenseStackCursor.current;
    if (workInProgress.flags & 128) return $4fcf5377eb083461$var$pushSuspenseListContext(workInProgress, suspenseContext), null;
    var shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $4fcf5377eb083461$var$pushSuspenseListContext(workInProgress, suspenseContext);
    "backwards" === revealOrder && null !== current ? ($4fcf5377eb083461$var$reverseChildren(current), $4fcf5377eb083461$var$reconcileChildren(current, workInProgress, nextProps, renderLanes), $4fcf5377eb083461$var$reverseChildren(current)) : $4fcf5377eb083461$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $4fcf5377eb083461$var$isHydrating ? $4fcf5377eb083461$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $4fcf5377eb083461$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $4fcf5377eb083461$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "backwards":
            renderLanes = $4fcf5377eb083461$var$findLastContentRow(workInProgress.child);
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null, $4fcf5377eb083461$var$reverseChildren(workInProgress));
            $4fcf5377eb083461$var$initSuspenseListRenderState(workInProgress, !0, revealOrder, null, tailMode, nextProps);
            break;
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $4fcf5377eb083461$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $4fcf5377eb083461$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $4fcf5377eb083461$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        case "independent":
            workInProgress.memoizedState = null;
            break;
        default:
            renderLanes = $4fcf5377eb083461$var$findLastContentRow(workInProgress.child), null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null), $4fcf5377eb083461$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
    }
    return workInProgress.child;
}
function $4fcf5377eb083461$var$updateContextProvider(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $4fcf5377eb083461$var$pushProvider(workInProgress, workInProgress.type, newProps.value);
    $4fcf5377eb083461$var$reconcileChildren(current, workInProgress, newProps.children, renderLanes);
    return workInProgress.child;
}
function $4fcf5377eb083461$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $4fcf5377eb083461$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($4fcf5377eb083461$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $4fcf5377eb083461$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $4fcf5377eb083461$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $4fcf5377eb083461$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $4fcf5377eb083461$var$checkIfContextChanged(current) ? !0 : !1;
}
function $4fcf5377eb083461$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $4fcf5377eb083461$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $4fcf5377eb083461$var$pushProvider(workInProgress, $4fcf5377eb083461$var$CacheContext, current.memoizedState.cache);
            $4fcf5377eb083461$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $4fcf5377eb083461$var$pushHostContext(workInProgress);
            break;
        case 4:
            $4fcf5377eb083461$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $4fcf5377eb083461$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $4fcf5377eb083461$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$108 = workInProgress.memoizedState;
            if (null !== state$108) {
                if (null !== state$108.dehydrated) return $4fcf5377eb083461$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                state$108 = $4fcf5377eb083461$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
                var primaryChildLanes = workInProgress.child.childLanes;
                if (state$108 || 0 !== (renderLanes & primaryChildLanes)) return $4fcf5377eb083461$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $4fcf5377eb083461$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $4fcf5377eb083461$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $4fcf5377eb083461$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            if (workInProgress.flags & 128) return $4fcf5377eb083461$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
            primaryChildLanes = 0 !== (current.flags & 128);
            state$108 = 0 !== (renderLanes & workInProgress.childLanes);
            state$108 || ($4fcf5377eb083461$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$108 = 0 !== (renderLanes & workInProgress.childLanes));
            if (primaryChildLanes) {
                if (state$108) return $4fcf5377eb083461$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            primaryChildLanes = workInProgress.memoizedState;
            null !== primaryChildLanes && (primaryChildLanes.rendering = null, primaryChildLanes.tail = null, primaryChildLanes.lastEffect = null);
            $4fcf5377eb083461$var$pushSuspenseListContext(workInProgress, $4fcf5377eb083461$var$suspenseStackCursor.current);
            if (state$108) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $4fcf5377eb083461$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $4fcf5377eb083461$var$pushProvider(workInProgress, $4fcf5377eb083461$var$CacheContext, current.memoizedState.cache);
    }
    return $4fcf5377eb083461$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $4fcf5377eb083461$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $4fcf5377eb083461$var$didReceiveUpdate = !0;
        else {
            if (!$4fcf5377eb083461$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $4fcf5377eb083461$var$didReceiveUpdate = !1, $4fcf5377eb083461$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $4fcf5377eb083461$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $4fcf5377eb083461$var$didReceiveUpdate = !1, $4fcf5377eb083461$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $4fcf5377eb083461$var$pushTreeId(workInProgress, $4fcf5377eb083461$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $4fcf5377eb083461$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $4fcf5377eb083461$var$shouldConstruct(current) ? (props = $4fcf5377eb083461$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $4fcf5377eb083461$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $4fcf5377eb083461$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $4fcf5377eb083461$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $4fcf5377eb083461$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $4fcf5377eb083461$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $4fcf5377eb083461$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $4fcf5377eb083461$var$REACT_CONTEXT_TYPE) {
                            workInProgress.tag = 10;
                            workInProgress.type = current;
                            workInProgress = $4fcf5377eb083461$var$updateContextProvider(null, workInProgress, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $4fcf5377eb083461$var$getComponentNameFromType(current) || current;
                    throw Error($4fcf5377eb083461$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $4fcf5377eb083461$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $4fcf5377eb083461$var$resolveClassComponentProps(props, workInProgress.pendingProps), $4fcf5377eb083461$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $4fcf5377eb083461$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $4fcf5377eb083461$var$cloneUpdateQueue(current, workInProgress);
                $4fcf5377eb083461$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $4fcf5377eb083461$var$pushProvider(workInProgress, $4fcf5377eb083461$var$CacheContext, props);
                props !== prevState.cache && $4fcf5377eb083461$var$propagateContextChanges(workInProgress, [
                    $4fcf5377eb083461$var$CacheContext
                ], renderLanes, !0);
                $4fcf5377eb083461$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $4fcf5377eb083461$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $4fcf5377eb083461$var$createCapturedValueAtFiber(Error($4fcf5377eb083461$var$formatProdErrorMessage(424)), workInProgress);
                        $4fcf5377eb083461$var$queueHydrationError($$typeof);
                        workInProgress = $4fcf5377eb083461$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $4fcf5377eb083461$var$nextHydratableInstance = $4fcf5377eb083461$var$getNextHydratable(current.firstChild);
                        $4fcf5377eb083461$var$hydrationParentFiber = workInProgress;
                        $4fcf5377eb083461$var$isHydrating = !0;
                        $4fcf5377eb083461$var$hydrationErrors = null;
                        $4fcf5377eb083461$var$rootOrSingletonContext = !0;
                        renderLanes = $4fcf5377eb083461$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 134221824, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $4fcf5377eb083461$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $4fcf5377eb083461$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $4fcf5377eb083461$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $4fcf5377eb083461$var$markRef(current, workInProgress), null === current ? (renderLanes = $4fcf5377eb083461$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $4fcf5377eb083461$var$isHydrating || (workInProgress.stateNode = $4fcf5377eb083461$var$createHoistableInstance(workInProgress.type, workInProgress.pendingProps, $4fcf5377eb083461$var$rootInstanceStackCursor.current, workInProgress)) : workInProgress.memoizedState = $4fcf5377eb083461$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $4fcf5377eb083461$var$pushHostContext(workInProgress), null === current && $4fcf5377eb083461$var$isHydrating && (props = workInProgress.stateNode = $4fcf5377eb083461$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $4fcf5377eb083461$var$rootInstanceStackCursor.current), $4fcf5377eb083461$var$hydrationParentFiber = workInProgress, $4fcf5377eb083461$var$rootOrSingletonContext = !0, $$typeof = $4fcf5377eb083461$var$nextHydratableInstance, $4fcf5377eb083461$var$isSingletonScope(workInProgress.type) ? ($4fcf5377eb083461$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $4fcf5377eb083461$var$nextHydratableInstance = $4fcf5377eb083461$var$getNextHydratable(props.firstChild)) : $4fcf5377eb083461$var$nextHydratableInstance = $$typeof), $4fcf5377eb083461$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $4fcf5377eb083461$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $4fcf5377eb083461$var$isHydrating) {
                if ($$typeof = props = $4fcf5377eb083461$var$nextHydratableInstance) props = $4fcf5377eb083461$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $4fcf5377eb083461$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $4fcf5377eb083461$var$hydrationParentFiber = workInProgress, $4fcf5377eb083461$var$nextHydratableInstance = $4fcf5377eb083461$var$getNextHydratable(props.firstChild), $4fcf5377eb083461$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $4fcf5377eb083461$var$throwOnHydrationMismatch(workInProgress);
            }
            $4fcf5377eb083461$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $4fcf5377eb083461$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $4fcf5377eb083461$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $4fcf5377eb083461$var$renderWithHooks(current, workInProgress, $4fcf5377eb083461$var$TransitionAwareHostComponent, null, null, renderLanes), $4fcf5377eb083461$var$HostTransitionContext._currentValue = $$typeof);
            $4fcf5377eb083461$var$markRef(current, workInProgress);
            $4fcf5377eb083461$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $4fcf5377eb083461$var$isHydrating) {
                if (current = renderLanes = $4fcf5377eb083461$var$nextHydratableInstance) renderLanes = $4fcf5377eb083461$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $4fcf5377eb083461$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $4fcf5377eb083461$var$hydrationParentFiber = workInProgress, $4fcf5377eb083461$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $4fcf5377eb083461$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $4fcf5377eb083461$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $4fcf5377eb083461$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $4fcf5377eb083461$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $4fcf5377eb083461$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $4fcf5377eb083461$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return props = workInProgress.pendingProps, $4fcf5377eb083461$var$markRef(current, workInProgress), $4fcf5377eb083461$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 8:
            return $4fcf5377eb083461$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $4fcf5377eb083461$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return $4fcf5377eb083461$var$updateContextProvider(current, workInProgress, renderLanes);
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $4fcf5377eb083461$var$prepareToReadContext(workInProgress), $$typeof = $4fcf5377eb083461$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $4fcf5377eb083461$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $4fcf5377eb083461$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $4fcf5377eb083461$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $4fcf5377eb083461$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $4fcf5377eb083461$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $4fcf5377eb083461$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $4fcf5377eb083461$var$prepareToReadContext(workInProgress), props = $4fcf5377eb083461$var$readContext($4fcf5377eb083461$var$CacheContext), null === current ? ($$typeof = $4fcf5377eb083461$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $4fcf5377eb083461$var$workInProgressRoot, prevState = $4fcf5377eb083461$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $4fcf5377eb083461$var$initializeUpdateQueue(workInProgress), $4fcf5377eb083461$var$pushProvider(workInProgress, $4fcf5377eb083461$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($4fcf5377eb083461$var$cloneUpdateQueue(current, workInProgress), $4fcf5377eb083461$var$processUpdateQueue(workInProgress, null, null, renderLanes), $4fcf5377eb083461$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $4fcf5377eb083461$var$pushProvider(workInProgress, $4fcf5377eb083461$var$CacheContext, props)) : (props = prevState.cache, $4fcf5377eb083461$var$pushProvider(workInProgress, $4fcf5377eb083461$var$CacheContext, props), props !== $$typeof.cache && $4fcf5377eb083461$var$propagateContextChanges(workInProgress, [
                $4fcf5377eb083461$var$CacheContext
            ], renderLanes, !0))), $4fcf5377eb083461$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 30:
            return null === workInProgress.stateNode && (workInProgress.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }), props = workInProgress.pendingProps, null != props.name && "auto" !== props.name ? workInProgress.flags |= null === current ? 18882560 : 18874368 : $4fcf5377eb083461$var$isHydrating && $4fcf5377eb083461$var$pushMaterializedTreeId(workInProgress), null !== current && current.memoizedProps.name !== props.name ? workInProgress.flags |= 4194816 : $4fcf5377eb083461$var$markRef(current, workInProgress), $4fcf5377eb083461$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($4fcf5377eb083461$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $4fcf5377eb083461$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $4fcf5377eb083461$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    var JSCompiler_temp;
    if (JSCompiler_temp = 0 !== (workInProgress.mode & 32)) JSCompiler_temp = null === oldProps ? $4fcf5377eb083461$var$maySuspendCommit(type, newProps) : $4fcf5377eb083461$var$maySuspendCommit(type, newProps) && (newProps.src !== oldProps.src || newProps.srcSet !== oldProps.srcSet);
    if (JSCompiler_temp) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($4fcf5377eb083461$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $4fcf5377eb083461$var$suspendedThenable = $4fcf5377eb083461$var$noopSuspenseyCommitThenable, $4fcf5377eb083461$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $4fcf5377eb083461$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$4fcf5377eb083461$var$preloadResource(resource)) {
        if ($4fcf5377eb083461$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $4fcf5377eb083461$var$suspendedThenable = $4fcf5377eb083461$var$noopSuspenseyCommitThenable, $4fcf5377eb083461$var$SuspenseyCommitException;
    }
}
function $4fcf5377eb083461$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $4fcf5377eb083461$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $4fcf5377eb083461$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $4fcf5377eb083461$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$4fcf5377eb083461$var$isHydrating) switch(renderState.tailMode){
        case "visible":
            break;
        case "collapsed":
            for(var tailNode = renderState.tail, lastTailNode = null; null !== tailNode;)null !== tailNode.alternate && (lastTailNode = tailNode), tailNode = tailNode.sibling;
            null === lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode.sibling = null;
            break;
        default:
            hasRenderedATailFallback = renderState.tail;
            for(tailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (tailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === tailNode ? renderState.tail = null : tailNode.sibling = null;
    }
}
function $4fcf5377eb083461$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags & 1206910976, subtreeFlags |= child$113.flags & 1206910976, child$113.return = completedWork, child$113 = child$113.sibling;
    else for(child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags, subtreeFlags |= child$113.flags, child$113.return = completedWork, child$113 = child$113.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $4fcf5377eb083461$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $4fcf5377eb083461$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $4fcf5377eb083461$var$bubbleProperties(workInProgress), null;
        case 1:
            return $4fcf5377eb083461$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $4fcf5377eb083461$var$popProvider($4fcf5377eb083461$var$CacheContext);
            $4fcf5377eb083461$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $4fcf5377eb083461$var$popHydrationState(workInProgress) ? $4fcf5377eb083461$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $4fcf5377eb083461$var$upgradeHydrationErrorsToRecoverable());
            $4fcf5377eb083461$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($4fcf5377eb083461$var$markUpdate(workInProgress), null !== nextResource ? ($4fcf5377eb083461$var$bubbleProperties(workInProgress), $4fcf5377eb083461$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($4fcf5377eb083461$var$bubbleProperties(workInProgress), $4fcf5377eb083461$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($4fcf5377eb083461$var$markUpdate(workInProgress), $4fcf5377eb083461$var$bubbleProperties(workInProgress), $4fcf5377eb083461$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($4fcf5377eb083461$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $4fcf5377eb083461$var$markUpdate(workInProgress), $4fcf5377eb083461$var$bubbleProperties(workInProgress), $4fcf5377eb083461$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $4fcf5377eb083461$var$popHostContext(workInProgress);
            renderLanes = $4fcf5377eb083461$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $4fcf5377eb083461$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(166));
                    $4fcf5377eb083461$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                current = $4fcf5377eb083461$var$contextStackCursor.current;
                $4fcf5377eb083461$var$popHydrationState(workInProgress) ? $4fcf5377eb083461$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $4fcf5377eb083461$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $4fcf5377eb083461$var$markUpdate(workInProgress));
            }
            $4fcf5377eb083461$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            return null;
        case 5:
            $4fcf5377eb083461$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $4fcf5377eb083461$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(166));
                    $4fcf5377eb083461$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                nextResource = $4fcf5377eb083461$var$contextStackCursor.current;
                if ($4fcf5377eb083461$var$popHydrationState(workInProgress)) $4fcf5377eb083461$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $4fcf5377eb083461$var$getOwnerDocumentFromRootContainer($4fcf5377eb083461$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$4fcf5377eb083461$var$internalInstanceKey] = workInProgress;
                    nextResource[$4fcf5377eb083461$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($4fcf5377eb083461$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $4fcf5377eb083461$var$markUpdate(workInProgress);
                }
            }
            $4fcf5377eb083461$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            $4fcf5377eb083461$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $4fcf5377eb083461$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(166));
                current = $4fcf5377eb083461$var$rootInstanceStackCursor.current;
                if ($4fcf5377eb083461$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $4fcf5377eb083461$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$4fcf5377eb083461$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $4fcf5377eb083461$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $4fcf5377eb083461$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $4fcf5377eb083461$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$4fcf5377eb083461$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $4fcf5377eb083461$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $4fcf5377eb083461$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(557));
                        current[$4fcf5377eb083461$var$internalInstanceKey] = workInProgress;
                    } else $4fcf5377eb083461$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $4fcf5377eb083461$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $4fcf5377eb083461$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $4fcf5377eb083461$var$popSuspenseHandler(workInProgress), workInProgress;
                    $4fcf5377eb083461$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(558));
            }
            $4fcf5377eb083461$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $4fcf5377eb083461$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(317));
                        type[$4fcf5377eb083461$var$internalInstanceKey] = workInProgress;
                    } else $4fcf5377eb083461$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $4fcf5377eb083461$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $4fcf5377eb083461$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $4fcf5377eb083461$var$popSuspenseHandler(workInProgress), workInProgress;
                    $4fcf5377eb083461$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $4fcf5377eb083461$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $4fcf5377eb083461$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $4fcf5377eb083461$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $4fcf5377eb083461$var$popHostContainer(), null === current && $4fcf5377eb083461$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), workInProgress.flags |= 67108864, $4fcf5377eb083461$var$bubbleProperties(workInProgress), null;
        case 10:
            return $4fcf5377eb083461$var$popProvider(workInProgress.type), $4fcf5377eb083461$var$bubbleProperties(workInProgress), null;
        case 19:
            $4fcf5377eb083461$var$popSuspenseListContext(workInProgress);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $4fcf5377eb083461$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $4fcf5377eb083461$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $4fcf5377eb083461$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $4fcf5377eb083461$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $4fcf5377eb083461$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $4fcf5377eb083461$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$4fcf5377eb083461$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $4fcf5377eb083461$var$pushSuspenseListContext(workInProgress, $4fcf5377eb083461$var$suspenseStackCursor.current & 1 | 2);
                            $4fcf5377eb083461$var$isHydrating && $4fcf5377eb083461$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $4fcf5377eb083461$var$now() > $4fcf5377eb083461$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $4fcf5377eb083461$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $4fcf5377eb083461$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $4fcf5377eb083461$var$scheduleRetryEffect(workInProgress, current), $4fcf5377eb083461$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "collapsed" !== newProps.tailMode && "visible" !== newProps.tailMode && !nextResource.alternate && !$4fcf5377eb083461$var$isHydrating) return $4fcf5377eb083461$var$bubbleProperties(workInProgress), null;
                    } else 2 * $4fcf5377eb083461$var$now() - newProps.renderingStartTime > $4fcf5377eb083461$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $4fcf5377eb083461$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) {
                current = newProps.tail;
                a: {
                    for(renderLanes = current; null !== renderLanes;){
                        if (null !== renderLanes.alternate) {
                            renderLanes = !1;
                            break a;
                        }
                        renderLanes = renderLanes.sibling;
                    }
                    renderLanes = !0;
                }
                newProps.rendering = current;
                newProps.tail = current.sibling;
                newProps.renderingStartTime = $4fcf5377eb083461$var$now();
                current.sibling = null;
                nextResource = $4fcf5377eb083461$var$suspenseStackCursor.current;
                nextResource = type ? nextResource & 1 | 2 : nextResource & 1;
                "visible" === newProps.tailMode || "collapsed" === newProps.tailMode || !renderLanes || $4fcf5377eb083461$var$isHydrating ? $4fcf5377eb083461$var$pushSuspenseListContext(workInProgress, nextResource) : (renderLanes = nextResource, $4fcf5377eb083461$var$push($4fcf5377eb083461$var$suspenseHandlerStackCursor, workInProgress), $4fcf5377eb083461$var$push($4fcf5377eb083461$var$suspenseStackCursor, renderLanes), null === $4fcf5377eb083461$var$shellBoundary && ($4fcf5377eb083461$var$shellBoundary = workInProgress));
                $4fcf5377eb083461$var$isHydrating && $4fcf5377eb083461$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                return current;
            }
            $4fcf5377eb083461$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $4fcf5377eb083461$var$popSuspenseHandler(workInProgress), $4fcf5377eb083461$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($4fcf5377eb083461$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $4fcf5377eb083461$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $4fcf5377eb083461$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $4fcf5377eb083461$var$pop($4fcf5377eb083461$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $4fcf5377eb083461$var$popProvider($4fcf5377eb083461$var$CacheContext), $4fcf5377eb083461$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return workInProgress.flags |= 33554432, $4fcf5377eb083461$var$bubbleProperties(workInProgress), null;
    }
    throw Error($4fcf5377eb083461$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $4fcf5377eb083461$var$unwindWork(current, workInProgress) {
    $4fcf5377eb083461$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $4fcf5377eb083461$var$popProvider($4fcf5377eb083461$var$CacheContext), $4fcf5377eb083461$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $4fcf5377eb083461$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $4fcf5377eb083461$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(340));
                $4fcf5377eb083461$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $4fcf5377eb083461$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(340));
                $4fcf5377eb083461$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $4fcf5377eb083461$var$popSuspenseListContext(workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, current = workInProgress.memoizedState, null !== current && (current.rendering = null, current.tail = null), workInProgress.flags |= 4, workInProgress) : null;
        case 4:
            return $4fcf5377eb083461$var$popHostContainer(), null;
        case 10:
            return $4fcf5377eb083461$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $4fcf5377eb083461$var$popSuspenseHandler(workInProgress), $4fcf5377eb083461$var$popHiddenContext(), null !== current && $4fcf5377eb083461$var$pop($4fcf5377eb083461$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $4fcf5377eb083461$var$popProvider($4fcf5377eb083461$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $4fcf5377eb083461$var$unwindInterruptedWork(current, interruptedWork) {
    $4fcf5377eb083461$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $4fcf5377eb083461$var$popProvider($4fcf5377eb083461$var$CacheContext);
            $4fcf5377eb083461$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $4fcf5377eb083461$var$popHostContext(interruptedWork);
            break;
        case 4:
            $4fcf5377eb083461$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $4fcf5377eb083461$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $4fcf5377eb083461$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $4fcf5377eb083461$var$popSuspenseListContext(interruptedWork);
            break;
        case 10:
            $4fcf5377eb083461$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $4fcf5377eb083461$var$popSuspenseHandler(interruptedWork);
            $4fcf5377eb083461$var$popHiddenContext();
            null !== current && $4fcf5377eb083461$var$pop($4fcf5377eb083461$var$resumedCache);
            break;
        case 24:
            $4fcf5377eb083461$var$popProvider($4fcf5377eb083461$var$CacheContext);
    }
}
function $4fcf5377eb083461$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $4fcf5377eb083461$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $4fcf5377eb083461$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $4fcf5377eb083461$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $4fcf5377eb083461$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $4fcf5377eb083461$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $4fcf5377eb083461$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $4fcf5377eb083461$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $4fcf5377eb083461$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $4fcf5377eb083461$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $4fcf5377eb083461$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $4fcf5377eb083461$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    var instance = current.stateNode, name = $4fcf5377eb083461$var$getViewTransitionName(current.memoizedProps, instance);
                    if (null === instance.ref || instance.ref.name !== name) instance.ref = $4fcf5377eb083461$var$createViewTransitionInstance(name);
                    instanceToUse = instance.ref;
                    break;
                case 7:
                    if (null === current.stateNode) {
                        var fragmentInstance = new $4fcf5377eb083461$var$FragmentInstance(current);
                        $4fcf5377eb083461$var$traverseVisibleInstancesAndTextInstances(current.child, !1, $4fcf5377eb083461$var$addFragmentHandleToFiber, fragmentInstance, void 0, void 0);
                        current.stateNode = fragmentInstance;
                    }
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $4fcf5377eb083461$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $4fcf5377eb083461$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $4fcf5377eb083461$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$148) {
            $4fcf5377eb083461$var$captureCommitPhaseError(current, nearestMountedAncestor, error$148);
        }
        else ref.current = null;
    }
}
function $4fcf5377eb083461$var$commitNewChildToFragmentInstances(fiber, parentFragmentInstances) {
    if ((5 === fiber.tag || 27 === fiber.tag || 6 === fiber.tag) && null === fiber.alternate && null !== parentFragmentInstances) for(var i = 0; i < parentFragmentInstances.length; i++)$4fcf5377eb083461$var$commitNewChildToFragmentInstance(fiber.stateNode, parentFragmentInstances[i]);
}
function $4fcf5377eb083461$var$commitFragmentInstanceInsertionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $4fcf5377eb083461$var$isFragmentInstanceParent(parent) && $4fcf5377eb083461$var$commitNewChildToFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($4fcf5377eb083461$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $4fcf5377eb083461$var$commitFragmentInstanceDeletionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $4fcf5377eb083461$var$isFragmentInstanceParent(parent) && $4fcf5377eb083461$var$deleteChildFromFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($4fcf5377eb083461$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $4fcf5377eb083461$var$isFragmentInstanceHostBoundary(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 27 === fiber.tag;
}
function $4fcf5377eb083461$var$isFragmentInstanceParent(fiber) {
    return fiber && 7 === fiber.tag && null !== fiber.stateNode;
}
function $4fcf5377eb083461$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $4fcf5377eb083461$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $4fcf5377eb083461$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $4fcf5377eb083461$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$4fcf5377eb083461$var$internalPropsKey] = newProps;
    } catch (error) {
        $4fcf5377eb083461$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $4fcf5377eb083461$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $4fcf5377eb083461$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $4fcf5377eb083461$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $4fcf5377eb083461$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $4fcf5377eb083461$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $4fcf5377eb083461$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(tag, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(tag), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $4fcf5377eb083461$var$noop$1)), $4fcf5377eb083461$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $4fcf5377eb083461$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($4fcf5377eb083461$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $4fcf5377eb083461$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null)), node = node.child, null !== node)) for($4fcf5377eb083461$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$4fcf5377eb083461$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $4fcf5377eb083461$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? parent.insertBefore(tag, before) : parent.appendChild(tag), $4fcf5377eb083461$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $4fcf5377eb083461$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($4fcf5377eb083461$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $4fcf5377eb083461$var$isSingletonScope(node.type) && (parent = node.stateNode)), node = node.child, null !== node)) for($4fcf5377eb083461$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$4fcf5377eb083461$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $4fcf5377eb083461$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $4fcf5377eb083461$var$setInitialProperties(singleton, type, props);
        singleton[$4fcf5377eb083461$var$internalInstanceKey] = finishedWork;
        singleton[$4fcf5377eb083461$var$internalPropsKey] = props;
    } catch (error) {
        $4fcf5377eb083461$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $4fcf5377eb083461$var$shouldStartViewTransition = !1, $4fcf5377eb083461$var$appearingViewTransitions = null;
function $4fcf5377eb083461$var$trackEnterViewTransitions(placement) {
    if (30 === placement.tag || 0 !== (placement.subtreeFlags & 33554432)) $4fcf5377eb083461$var$shouldStartViewTransition = !0;
}
var $4fcf5377eb083461$var$viewTransitionCancelableChildren = null;
function $4fcf5377eb083461$var$pushViewTransitionCancelableScope() {
    var prevChildren = $4fcf5377eb083461$var$viewTransitionCancelableChildren;
    $4fcf5377eb083461$var$viewTransitionCancelableChildren = null;
    return prevChildren;
}
var $4fcf5377eb083461$var$viewTransitionHostInstanceIdx = 0;
function $4fcf5377eb083461$var$applyViewTransitionToHostInstances(fiber, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    $4fcf5377eb083461$var$viewTransitionHostInstanceIdx = 0;
    return $4fcf5377eb083461$var$applyViewTransitionToHostInstancesRecursive(fiber.child, name, className, collectMeasurements, stopAtNestedViewTransitions);
}
function $4fcf5377eb083461$var$applyViewTransitionToHostInstancesRecursive(child, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== collectMeasurements) {
                var measurement = $4fcf5377eb083461$var$measureInstance(instance);
                collectMeasurements.push(measurement);
                measurement.view && (inViewport = !0);
            } else inViewport || $4fcf5377eb083461$var$measureInstance(instance).view && (inViewport = !0);
            $4fcf5377eb083461$var$shouldStartViewTransition = !0;
            $4fcf5377eb083461$var$applyViewTransitionName(instance, 0 === $4fcf5377eb083461$var$viewTransitionHostInstanceIdx ? name : name + "_" + $4fcf5377eb083461$var$viewTransitionHostInstanceIdx, className);
            $4fcf5377eb083461$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $4fcf5377eb083461$var$applyViewTransitionToHostInstancesRecursive(child.child, name, className, collectMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $4fcf5377eb083461$var$restoreViewTransitionOnHostInstances(child, stopAtNestedViewTransitions) {
    for(; null !== child;){
        if (5 === child.tag) $4fcf5377eb083461$var$restoreViewTransitionName(child.stateNode, child.memoizedProps);
        else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $4fcf5377eb083461$var$restoreViewTransitionOnHostInstances(child.child, stopAtNestedViewTransitions);
        child = child.sibling;
    }
}
function $4fcf5377eb083461$var$commitAppearingPairViewTransitions(placement) {
    if (0 !== (placement.subtreeFlags & 18874368)) for(placement = placement.child; null !== placement;){
        if (22 !== placement.tag || null === placement.memoizedState) {
            if ($4fcf5377eb083461$var$commitAppearingPairViewTransitions(placement), 30 === placement.tag && 0 !== (placement.flags & 18874368) && placement.stateNode.paired) {
                var props = placement.memoizedProps;
                if (null == props.name || "auto" === props.name) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(544));
                var name = props.name;
                props = $4fcf5377eb083461$var$getViewTransitionClassName(props.default, props.share);
                "none" !== props && ($4fcf5377eb083461$var$applyViewTransitionToHostInstances(placement, name, props, null, !1) || $4fcf5377eb083461$var$restoreViewTransitionOnHostInstances(placement.child, !1));
            }
        }
        placement = placement.sibling;
    }
}
function $4fcf5377eb083461$var$commitEnterViewTransitions(placement, gesture) {
    if (30 === placement.tag) {
        var state = placement.stateNode, props = placement.memoizedProps, name = $4fcf5377eb083461$var$getViewTransitionName(props, state), className = $4fcf5377eb083461$var$getViewTransitionClassName(props.default, state.paired ? props.share : props.enter);
        "none" !== className ? $4fcf5377eb083461$var$applyViewTransitionToHostInstances(placement, name, className, null, !1) ? ($4fcf5377eb083461$var$commitAppearingPairViewTransitions(placement), state.paired || gesture || $4fcf5377eb083461$var$scheduleViewTransitionEvent(placement, props.onEnter)) : $4fcf5377eb083461$var$restoreViewTransitionOnHostInstances(placement.child, !1) : $4fcf5377eb083461$var$commitAppearingPairViewTransitions(placement);
    } else if (0 !== (placement.subtreeFlags & 33554432)) for(placement = placement.child; null !== placement;)$4fcf5377eb083461$var$commitEnterViewTransitions(placement, gesture), placement = placement.sibling;
    else $4fcf5377eb083461$var$commitAppearingPairViewTransitions(placement);
}
function $4fcf5377eb083461$var$commitDeletedPairViewTransitions(deletion) {
    if (null !== $4fcf5377eb083461$var$appearingViewTransitions && 0 !== $4fcf5377eb083461$var$appearingViewTransitions.size) {
        var pairs = $4fcf5377eb083461$var$appearingViewTransitions;
        if (0 !== (deletion.subtreeFlags & 18874368)) for(deletion = deletion.child; null !== deletion;){
            if (22 !== deletion.tag || null === deletion.memoizedState) {
                if (30 === deletion.tag && 0 !== (deletion.flags & 18874368)) {
                    var props = deletion.memoizedProps, name = props.name;
                    if (null != name && "auto" !== name) {
                        var pair = pairs.get(name);
                        if (void 0 !== pair) {
                            var className = $4fcf5377eb083461$var$getViewTransitionClassName(props.default, props.share);
                            "none" !== className && ($4fcf5377eb083461$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $4fcf5377eb083461$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $4fcf5377eb083461$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
                            pairs.delete(name);
                            if (0 === pairs.size) break;
                        }
                    }
                }
                $4fcf5377eb083461$var$commitDeletedPairViewTransitions(deletion);
            }
            deletion = deletion.sibling;
        }
    }
}
function $4fcf5377eb083461$var$commitExitViewTransitions(deletion) {
    if (30 === deletion.tag) {
        var props = deletion.memoizedProps, name = $4fcf5377eb083461$var$getViewTransitionName(props, deletion.stateNode), pair = null !== $4fcf5377eb083461$var$appearingViewTransitions ? $4fcf5377eb083461$var$appearingViewTransitions.get(name) : void 0, className = $4fcf5377eb083461$var$getViewTransitionClassName(props.default, void 0 !== pair ? props.share : props.exit);
        "none" !== className && ($4fcf5377eb083461$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? void 0 !== pair ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $4fcf5377eb083461$var$appearingViewTransitions.delete(name), $4fcf5377eb083461$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $4fcf5377eb083461$var$scheduleViewTransitionEvent(deletion, props.onExit) : $4fcf5377eb083461$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
        null !== $4fcf5377eb083461$var$appearingViewTransitions && $4fcf5377eb083461$var$commitDeletedPairViewTransitions(deletion);
    } else if (0 !== (deletion.subtreeFlags & 33554432)) for(deletion = deletion.child; null !== deletion;)$4fcf5377eb083461$var$commitExitViewTransitions(deletion), deletion = deletion.sibling;
    else null !== $4fcf5377eb083461$var$appearingViewTransitions && $4fcf5377eb083461$var$commitDeletedPairViewTransitions(deletion);
}
function $4fcf5377eb083461$var$commitNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, name = $4fcf5377eb083461$var$getViewTransitionName(props, changedParent.stateNode);
            props = $4fcf5377eb083461$var$getViewTransitionClassName(props.default, props.update);
            changedParent.flags &= -5;
            "none" !== props && $4fcf5377eb083461$var$applyViewTransitionToHostInstances(changedParent, name, props, changedParent.memoizedState = [], !1);
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $4fcf5377eb083461$var$commitNestedViewTransitions(changedParent);
        changedParent = changedParent.sibling;
    }
}
function $4fcf5377eb083461$var$restorePairedViewTransitions(parent) {
    if (0 !== (parent.subtreeFlags & 18874368)) for(parent = parent.child; null !== parent;){
        if (22 !== parent.tag || null === parent.memoizedState) {
            if (30 === parent.tag && 0 !== (parent.flags & 18874368)) {
                var instance = parent.stateNode;
                null !== instance.paired && (instance.paired = null, $4fcf5377eb083461$var$restoreViewTransitionOnHostInstances(parent.child, !1));
            }
            $4fcf5377eb083461$var$restorePairedViewTransitions(parent);
        }
        parent = parent.sibling;
    }
}
function $4fcf5377eb083461$var$restoreEnterOrExitViewTransitions(fiber) {
    if (30 === fiber.tag) fiber.stateNode.paired = null, $4fcf5377eb083461$var$restoreViewTransitionOnHostInstances(fiber.child, !1), $4fcf5377eb083461$var$restorePairedViewTransitions(fiber);
    else if (0 !== (fiber.subtreeFlags & 33554432)) for(fiber = fiber.child; null !== fiber;)$4fcf5377eb083461$var$restoreEnterOrExitViewTransitions(fiber), fiber = fiber.sibling;
    else $4fcf5377eb083461$var$restorePairedViewTransitions(fiber);
}
function $4fcf5377eb083461$var$restoreNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;)30 === changedParent.tag ? $4fcf5377eb083461$var$restoreViewTransitionOnHostInstances(changedParent.child, !1) : 0 !== (changedParent.subtreeFlags & 33554432) && $4fcf5377eb083461$var$restoreNestedViewTransitions(changedParent), changedParent = changedParent.sibling;
}
function $4fcf5377eb083461$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== previousMeasurements && $4fcf5377eb083461$var$viewTransitionHostInstanceIdx < previousMeasurements.length) {
                var previousMeasurement = previousMeasurements[$4fcf5377eb083461$var$viewTransitionHostInstanceIdx], nextMeasurement = $4fcf5377eb083461$var$measureInstance(instance);
                if (previousMeasurement.view || nextMeasurement.view) inViewport = !0;
                var JSCompiler_temp;
                if (JSCompiler_temp = 0 === (parentViewTransition.flags & 4)) {
                    if (nextMeasurement.clip) JSCompiler_temp = !0;
                    else {
                        JSCompiler_temp = previousMeasurement.rect;
                        var newRect = nextMeasurement.rect;
                        JSCompiler_temp = JSCompiler_temp.y !== newRect.y || JSCompiler_temp.x !== newRect.x || JSCompiler_temp.height !== newRect.height || JSCompiler_temp.width !== newRect.width;
                    }
                }
                JSCompiler_temp && (parentViewTransition.flags |= 4);
                nextMeasurement.abs ? nextMeasurement = !previousMeasurement.abs : (previousMeasurement = previousMeasurement.rect, nextMeasurement = nextMeasurement.rect, nextMeasurement = previousMeasurement.height !== nextMeasurement.height || previousMeasurement.width !== nextMeasurement.width);
                nextMeasurement && (parentViewTransition.flags |= 32);
            } else parentViewTransition.flags |= 32;
            0 !== (parentViewTransition.flags & 4) && $4fcf5377eb083461$var$applyViewTransitionName(instance, 0 === $4fcf5377eb083461$var$viewTransitionHostInstanceIdx ? newName : newName + "_" + $4fcf5377eb083461$var$viewTransitionHostInstanceIdx, className);
            inViewport && 0 !== (parentViewTransition.flags & 4) || (null === $4fcf5377eb083461$var$viewTransitionCancelableChildren && ($4fcf5377eb083461$var$viewTransitionCancelableChildren = []), $4fcf5377eb083461$var$viewTransitionCancelableChildren.push(instance, 0 === $4fcf5377eb083461$var$viewTransitionHostInstanceIdx ? oldName : oldName + "_" + $4fcf5377eb083461$var$viewTransitionHostInstanceIdx, child.memoizedProps));
            $4fcf5377eb083461$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions ? parentViewTransition.flags |= child.flags & 32 : $4fcf5377eb083461$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child.child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $4fcf5377eb083461$var$measureNestedViewTransitions(changedParent, gesture) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, state = changedParent.stateNode, name = $4fcf5377eb083461$var$getViewTransitionName(props, state), className = $4fcf5377eb083461$var$getViewTransitionClassName(props.default, props.update);
            if (gesture) {
                state = state.clones;
                var previousMeasurements = null === state ? null : state.map($4fcf5377eb083461$var$measureClonedInstance);
            } else previousMeasurements = changedParent.memoizedState, changedParent.memoizedState = null;
            state = changedParent;
            var child = changedParent.child;
            $4fcf5377eb083461$var$viewTransitionHostInstanceIdx = 0;
            name = $4fcf5377eb083461$var$measureViewTransitionHostInstancesRecursive(state, child, name, name, className, previousMeasurements, !1);
            0 !== (changedParent.flags & 4) && name && (gesture || $4fcf5377eb083461$var$scheduleViewTransitionEvent(changedParent, props.onUpdate));
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $4fcf5377eb083461$var$measureNestedViewTransitions(changedParent, gesture);
        changedParent = changedParent.sibling;
    }
}
var $4fcf5377eb083461$var$offscreenSubtreeIsHidden = !1, $4fcf5377eb083461$var$offscreenSubtreeWasHidden = !1, $4fcf5377eb083461$var$offscreenDirectParentIsHidden = !1, $4fcf5377eb083461$var$needsFormReset = !1, $4fcf5377eb083461$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $4fcf5377eb083461$var$nextEffect = null, $4fcf5377eb083461$var$viewTransitionContextChanged = !1, $4fcf5377eb083461$var$inUpdateViewTransition = !1, $4fcf5377eb083461$var$rootViewTransitionAffected = !1, $4fcf5377eb083461$var$rootViewTransitionNameCanceled = !1;
function $4fcf5377eb083461$var$commitBeforeMutationEffects(root, firstChild, committedLanes) {
    root = root.containerInfo;
    $4fcf5377eb083461$var$eventsEnabled = $4fcf5377eb083461$var$_enabled;
    root = $4fcf5377eb083461$var$getActiveElementDeep(root);
    if ($4fcf5377eb083461$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$21) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $4fcf5377eb083461$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $4fcf5377eb083461$var$_enabled = !1;
    committedLanes = (committedLanes & 335544064) === committedLanes;
    $4fcf5377eb083461$var$nextEffect = firstChild;
    for(firstChild = committedLanes ? 9270 : 1024; null !== $4fcf5377eb083461$var$nextEffect;){
        root = $4fcf5377eb083461$var$nextEffect;
        if (committedLanes && (JSCompiler_temp = root.deletions, null !== JSCompiler_temp)) for(anchorOffset = 0; anchorOffset < JSCompiler_temp.length; anchorOffset++)committedLanes && $4fcf5377eb083461$var$commitExitViewTransitions(JSCompiler_temp[anchorOffset]);
        if (null === root.alternate && 0 !== (root.flags & 2)) committedLanes && $4fcf5377eb083461$var$trackEnterViewTransitions(root), $4fcf5377eb083461$var$commitBeforeMutationEffects_complete(committedLanes);
        else {
            if (22 === root.tag) {
                if (JSCompiler_temp = root.alternate, null !== root.memoizedState) {
                    null !== JSCompiler_temp && null === JSCompiler_temp.memoizedState && committedLanes && $4fcf5377eb083461$var$commitExitViewTransitions(JSCompiler_temp);
                    $4fcf5377eb083461$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                } else if (null !== JSCompiler_temp && null !== JSCompiler_temp.memoizedState) {
                    committedLanes && $4fcf5377eb083461$var$trackEnterViewTransitions(root);
                    $4fcf5377eb083461$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                }
            }
            JSCompiler_temp = root.child;
            0 !== (root.subtreeFlags & firstChild) && null !== JSCompiler_temp ? (JSCompiler_temp.return = root, $4fcf5377eb083461$var$nextEffect = JSCompiler_temp) : (committedLanes && $4fcf5377eb083461$var$commitNestedViewTransitions(root), $4fcf5377eb083461$var$commitBeforeMutationEffects_complete(committedLanes));
        }
    }
    $4fcf5377eb083461$var$appearingViewTransitions = null;
}
function $4fcf5377eb083461$var$commitBeforeMutationEffects_complete(isViewTransitionEligible$jscomp$0) {
    for(; null !== $4fcf5377eb083461$var$nextEffect;){
        var fiber = $4fcf5377eb083461$var$nextEffect, isViewTransitionEligible = isViewTransitionEligible$jscomp$0, current = fiber.alternate, flags = fiber.flags;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (flags & 1024) && null !== current) {
                    isViewTransitionEligible = void 0;
                    flags = current.memoizedProps;
                    current = current.memoizedState;
                    var instance = fiber.stateNode;
                    try {
                        var resolvedPrevProps = $4fcf5377eb083461$var$resolveClassComponentProps(fiber.type, flags);
                        isViewTransitionEligible = instance.getSnapshotBeforeUpdate(resolvedPrevProps, current);
                        instance.__reactInternalSnapshotBeforeUpdate = isViewTransitionEligible;
                    } catch (error) {
                        $4fcf5377eb083461$var$captureCommitPhaseError(fiber, fiber.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (flags & 1024)) {
                    if (current = fiber.stateNode.containerInfo, isViewTransitionEligible = current.nodeType, 9 === isViewTransitionEligible) $4fcf5377eb083461$var$clearContainerSparingly(current);
                    else if (1 === isViewTransitionEligible) switch(current.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $4fcf5377eb083461$var$clearContainerSparingly(current);
                            break;
                        default:
                            current.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            case 30:
                isViewTransitionEligible && null !== current && (isViewTransitionEligible = $4fcf5377eb083461$var$getViewTransitionName(current.memoizedProps, current.stateNode), flags = fiber.memoizedProps, flags = $4fcf5377eb083461$var$getViewTransitionClassName(flags.default, flags.update), "none" !== flags && $4fcf5377eb083461$var$applyViewTransitionToHostInstances(current, isViewTransitionEligible, flags, current.memoizedState = [], !0));
                break;
            default:
                if (0 !== (flags & 1024)) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(163));
        }
        current = fiber.sibling;
        if (null !== current) {
            current.return = fiber.return;
            $4fcf5377eb083461$var$nextEffect = current;
            break;
        }
        $4fcf5377eb083461$var$nextEffect = fiber.return;
    }
}
function $4fcf5377eb083461$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $4fcf5377eb083461$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $4fcf5377eb083461$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $4fcf5377eb083461$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $4fcf5377eb083461$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $4fcf5377eb083461$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$146) {
                        $4fcf5377eb083461$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$146);
                    }
                }
            }
            flags & 64 && $4fcf5377eb083461$var$commitClassCallbacks(finishedWork);
            flags & 512 && $4fcf5377eb083461$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $4fcf5377eb083461$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $4fcf5377eb083461$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $4fcf5377eb083461$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $4fcf5377eb083461$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $4fcf5377eb083461$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $4fcf5377eb083461$var$commitHostMount(finishedWork);
            flags & 512 && $4fcf5377eb083461$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $4fcf5377eb083461$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $4fcf5377eb083461$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $4fcf5377eb083461$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $4fcf5377eb083461$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $4fcf5377eb083461$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $4fcf5377eb083461$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $4fcf5377eb083461$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $4fcf5377eb083461$var$offscreenSubtreeIsHidden;
            if (!flags) {
                var newOffscreenSubtreeWasHidden = null !== current && null !== current.memoizedState || $4fcf5377eb083461$var$offscreenSubtreeWasHidden;
                current = $4fcf5377eb083461$var$offscreenSubtreeIsHidden;
                prevProps = $4fcf5377eb083461$var$offscreenSubtreeWasHidden;
                $4fcf5377eb083461$var$offscreenSubtreeIsHidden = flags;
                ($4fcf5377eb083461$var$offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden) && !prevProps ? (flags = 2, 0 !== (finishedWork.subtreeFlags & 8772) && (flags |= 1), $4fcf5377eb083461$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, flags)) : $4fcf5377eb083461$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $4fcf5377eb083461$var$offscreenSubtreeIsHidden = current;
                $4fcf5377eb083461$var$offscreenSubtreeWasHidden = prevProps;
            }
            break;
        case 30:
            $4fcf5377eb083461$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $4fcf5377eb083461$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 7:
            flags & 512 && $4fcf5377eb083461$var$safelyAttachRef(finishedWork, finishedWork.return);
        default:
            $4fcf5377eb083461$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $4fcf5377eb083461$var$hideOrUnhideAllChildren(parentFiber, isHidden) {
    for(parentFiber = parentFiber.child; null !== parentFiber;)$4fcf5377eb083461$var$hideOrUnhideAllChildrenOnFiber(parentFiber, isHidden), parentFiber = parentFiber.sibling;
}
function $4fcf5377eb083461$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden) {
    switch(fiber.tag){
        case 5:
        case 26:
            try {
                var instance = fiber.stateNode;
                if (isHidden) {
                    var style = instance.style;
                    "function" === typeof style.setProperty ? style.setProperty("display", "none", "important") : style.display = "none";
                } else {
                    var instance$jscomp$0 = fiber.stateNode, styleProp = fiber.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    instance$jscomp$0.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                }
            } catch (error) {
                $4fcf5377eb083461$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            $4fcf5377eb083461$var$hideOrUnhideNearestPortals(fiber, isHidden);
            break;
        case 6:
            try {
                fiber.stateNode.nodeValue = isHidden ? "" : fiber.memoizedProps, $4fcf5377eb083461$var$viewTransitionMutationContext = !0;
            } catch (error) {
                $4fcf5377eb083461$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 18:
            try {
                var instance$jscomp$1 = fiber.stateNode;
                isHidden ? $4fcf5377eb083461$var$hideOrUnhideDehydratedBoundary(instance$jscomp$1, !0) : $4fcf5377eb083461$var$hideOrUnhideDehydratedBoundary(fiber.stateNode, !1);
            } catch (error) {
                $4fcf5377eb083461$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 22:
        case 23:
            null === fiber.memoizedState && $4fcf5377eb083461$var$hideOrUnhideAllChildren(fiber, isHidden);
            break;
        default:
            $4fcf5377eb083461$var$hideOrUnhideAllChildren(fiber, isHidden);
    }
}
function $4fcf5377eb083461$var$hideOrUnhideNearestPortals(parentFiber, isHidden$jscomp$0) {
    if (parentFiber.subtreeFlags & 67108864) for(parentFiber = parentFiber.child; null !== parentFiber;){
        a: {
            var fiber = parentFiber, isHidden = isHidden$jscomp$0;
            switch(fiber.tag){
                case 4:
                    $4fcf5377eb083461$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden);
                    break a;
                case 22:
                    null === fiber.memoizedState && $4fcf5377eb083461$var$hideOrUnhideNearestPortals(fiber, isHidden);
                    break a;
                default:
                    $4fcf5377eb083461$var$hideOrUnhideNearestPortals(fiber, isHidden);
            }
        }
        parentFiber = parentFiber.sibling;
    }
}
function $4fcf5377eb083461$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $4fcf5377eb083461$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $4fcf5377eb083461$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $4fcf5377eb083461$var$hostParent = null, $4fcf5377eb083461$var$hostParentIsContainer = !1;
function $4fcf5377eb083461$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$4fcf5377eb083461$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $4fcf5377eb083461$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($4fcf5377eb083461$var$injectedHook && "function" === typeof $4fcf5377eb083461$var$injectedHook.onCommitFiberUnmount) try {
        $4fcf5377eb083461$var$injectedHook.onCommitFiberUnmount($4fcf5377eb083461$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $4fcf5377eb083461$var$offscreenSubtreeWasHidden || $4fcf5377eb083461$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $4fcf5377eb083461$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && !$4fcf5377eb083461$var$offscreenSubtreeWasHidden && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $4fcf5377eb083461$var$offscreenSubtreeWasHidden || $4fcf5377eb083461$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $4fcf5377eb083461$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            var prevHostParent = $4fcf5377eb083461$var$hostParent, prevHostParentIsContainer = $4fcf5377eb083461$var$hostParentIsContainer;
            $4fcf5377eb083461$var$isSingletonScope(deletedFiber.type) && ($4fcf5377eb083461$var$hostParent = deletedFiber.stateNode, $4fcf5377eb083461$var$hostParentIsContainer = !1);
            $4fcf5377eb083461$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $4fcf5377eb083461$var$releaseSingletonInstance(deletedFiber.stateNode, deletedFiber.type, deletedFiber.memoizedProps);
            $4fcf5377eb083461$var$hostParent = prevHostParent;
            $4fcf5377eb083461$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $4fcf5377eb083461$var$offscreenSubtreeWasHidden || $4fcf5377eb083461$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), $4fcf5377eb083461$var$commitFragmentInstanceDeletionEffects(deletedFiber);
        case 6:
            6 === deletedFiber.tag && $4fcf5377eb083461$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            prevHostParent = $4fcf5377eb083461$var$hostParent;
            prevHostParentIsContainer = $4fcf5377eb083461$var$hostParentIsContainer;
            $4fcf5377eb083461$var$hostParent = null;
            $4fcf5377eb083461$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $4fcf5377eb083461$var$hostParent = prevHostParent;
            $4fcf5377eb083461$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $4fcf5377eb083461$var$hostParent) {
                if ($4fcf5377eb083461$var$hostParentIsContainer) try {
                    (9 === $4fcf5377eb083461$var$hostParent.nodeType ? $4fcf5377eb083461$var$hostParent.body : "HTML" === $4fcf5377eb083461$var$hostParent.nodeName ? $4fcf5377eb083461$var$hostParent.ownerDocument.body : $4fcf5377eb083461$var$hostParent).removeChild(deletedFiber.stateNode), $4fcf5377eb083461$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $4fcf5377eb083461$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $4fcf5377eb083461$var$hostParent.removeChild(deletedFiber.stateNode), $4fcf5377eb083461$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $4fcf5377eb083461$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $4fcf5377eb083461$var$hostParent && ($4fcf5377eb083461$var$hostParentIsContainer ? (finishedRoot = $4fcf5377eb083461$var$hostParent, $4fcf5377eb083461$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $4fcf5377eb083461$var$retryIfBlockedOn(finishedRoot)) : $4fcf5377eb083461$var$clearHydrationBoundary($4fcf5377eb083461$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $4fcf5377eb083461$var$hostParent;
            prevHostParentIsContainer = $4fcf5377eb083461$var$hostParentIsContainer;
            $4fcf5377eb083461$var$hostParent = deletedFiber.stateNode.containerInfo;
            $4fcf5377eb083461$var$hostParentIsContainer = !0;
            $4fcf5377eb083461$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $4fcf5377eb083461$var$hostParent = prevHostParent;
            $4fcf5377eb083461$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $4fcf5377eb083461$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $4fcf5377eb083461$var$offscreenSubtreeWasHidden || $4fcf5377eb083461$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $4fcf5377eb083461$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $4fcf5377eb083461$var$offscreenSubtreeWasHidden || ($4fcf5377eb083461$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $4fcf5377eb083461$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $4fcf5377eb083461$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $4fcf5377eb083461$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $4fcf5377eb083461$var$offscreenSubtreeWasHidden = (prevHostParent = $4fcf5377eb083461$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $4fcf5377eb083461$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $4fcf5377eb083461$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        case 30:
            $4fcf5377eb083461$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $4fcf5377eb083461$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 7:
            $4fcf5377eb083461$var$offscreenSubtreeWasHidden || $4fcf5377eb083461$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $4fcf5377eb083461$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        default:
            $4fcf5377eb083461$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $4fcf5377eb083461$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $4fcf5377eb083461$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $4fcf5377eb083461$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $4fcf5377eb083461$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $4fcf5377eb083461$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $4fcf5377eb083461$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $4fcf5377eb083461$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $4fcf5377eb083461$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $4fcf5377eb083461$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($4fcf5377eb083461$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $4fcf5377eb083461$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $4fcf5377eb083461$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $4fcf5377eb083461$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $4fcf5377eb083461$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber, lanes) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($4fcf5377eb083461$var$isSingletonScope(parent.type)) {
                        $4fcf5377eb083461$var$hostParent = parent.stateNode;
                        $4fcf5377eb083461$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $4fcf5377eb083461$var$hostParent = parent.stateNode;
                    $4fcf5377eb083461$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $4fcf5377eb083461$var$hostParent = parent.stateNode.containerInfo;
                    $4fcf5377eb083461$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $4fcf5377eb083461$var$hostParent) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(160));
        $4fcf5377eb083461$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $4fcf5377eb083461$var$hostParent = null;
        $4fcf5377eb083461$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$4fcf5377eb083461$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0, lanes), parentFiber = parentFiber.sibling;
}
var $4fcf5377eb083461$var$currentHoistableRoot = null;
function $4fcf5377eb083461$var$commitMutationEffectsOnFiber(finishedWork, root, lanes) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            if (flags & 4 && (current = finishedWork.updateQueue, current = null !== current ? current.events : null, null !== current)) for(var ii = 0; ii < current.length; ii++){
                var _eventPayloads$ii2 = current[ii];
                _eventPayloads$ii2.ref.impl = _eventPayloads$ii2.nextImpl;
            }
            $4fcf5377eb083461$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $4fcf5377eb083461$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($4fcf5377eb083461$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $4fcf5377eb083461$var$commitHookEffectListMount(3, finishedWork), $4fcf5377eb083461$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $4fcf5377eb083461$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $4fcf5377eb083461$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($4fcf5377eb083461$var$offscreenSubtreeWasHidden || null === current || $4fcf5377eb083461$var$safelyDetachRef(current, current.return));
            flags & 64 && $4fcf5377eb083461$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (root = finishedWork.callbacks, null !== root && (lanes = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === lanes ? root : lanes.concat(root))));
            break;
        case 26:
            ii = $4fcf5377eb083461$var$currentHoistableRoot;
            $4fcf5377eb083461$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $4fcf5377eb083461$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($4fcf5377eb083461$var$offscreenSubtreeWasHidden || null === current || $4fcf5377eb083461$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                if (flags = null !== current ? current.memoizedState : null, lanes = finishedWork.memoizedState, null === current) {
                    if (null === lanes) {
                        if (null === finishedWork.stateNode) {
                            if ($4fcf5377eb083461$var$offscreenSubtreeIsHidden) finishedWork.stateNode = $4fcf5377eb083461$var$createHoistableInstance(finishedWork.type, finishedWork.memoizedProps, root.containerInfo, finishedWork);
                            else {
                                a: {
                                    root = finishedWork.type;
                                    lanes = finishedWork.memoizedProps;
                                    flags = ii.ownerDocument || ii;
                                    b: switch(root){
                                        case "title":
                                            current = flags.getElementsByTagName("title")[0];
                                            if (!current || current[$4fcf5377eb083461$var$internalHoistableMarker] || current[$4fcf5377eb083461$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === current.namespaceURI || current.hasAttribute("itemprop")) current = flags.createElement(root), flags.head.insertBefore(current, flags.querySelector("head > title"));
                                            $4fcf5377eb083461$var$setInitialProperties(current, root, lanes);
                                            current[$4fcf5377eb083461$var$internalInstanceKey] = finishedWork;
                                            $4fcf5377eb083461$var$markNodeAsHoistable(current);
                                            root = current;
                                            break a;
                                        case "link":
                                            if (ii = $4fcf5377eb083461$var$getHydratableHoistableCache("link", "href", flags).get(root + (lanes.href || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("href") === (null == lanes.href || "" === lanes.href ? null : lanes.href) && current.getAttribute("rel") === (null == lanes.rel ? null : lanes.rel) && current.getAttribute("title") === (null == lanes.title ? null : lanes.title) && current.getAttribute("crossorigin") === (null == lanes.crossOrigin ? null : lanes.crossOrigin)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $4fcf5377eb083461$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        case "meta":
                                            if (ii = $4fcf5377eb083461$var$getHydratableHoistableCache("meta", "content", flags).get(root + (lanes.content || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("content") === (null == lanes.content ? null : "" + lanes.content) && current.getAttribute("name") === (null == lanes.name ? null : lanes.name) && current.getAttribute("property") === (null == lanes.property ? null : lanes.property) && current.getAttribute("http-equiv") === (null == lanes.httpEquiv ? null : lanes.httpEquiv) && current.getAttribute("charset") === (null == lanes.charSet ? null : lanes.charSet)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $4fcf5377eb083461$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        default:
                                            throw Error($4fcf5377eb083461$var$formatProdErrorMessage(468, root));
                                    }
                                    current[$4fcf5377eb083461$var$internalInstanceKey] = finishedWork;
                                    $4fcf5377eb083461$var$markNodeAsHoistable(current);
                                    root = current;
                                }
                                finishedWork.stateNode = root;
                            }
                        } else $4fcf5377eb083461$var$offscreenSubtreeIsHidden || $4fcf5377eb083461$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $4fcf5377eb083461$var$acquireResource(ii, lanes, finishedWork.memoizedProps);
                } else flags !== lanes ? (null === flags ? (root = current.stateNode, null === root || $4fcf5377eb083461$var$offscreenSubtreeWasHidden || root.parentNode.removeChild(root)) : flags.count--, null === lanes ? $4fcf5377eb083461$var$offscreenSubtreeIsHidden || $4fcf5377eb083461$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode) : $4fcf5377eb083461$var$acquireResource(ii, lanes, finishedWork.memoizedProps)) : null === lanes && null !== finishedWork.stateNode && $4fcf5377eb083461$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $4fcf5377eb083461$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $4fcf5377eb083461$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($4fcf5377eb083461$var$offscreenSubtreeWasHidden || null === current || $4fcf5377eb083461$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $4fcf5377eb083461$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            ii = $4fcf5377eb083461$var$offscreenDirectParentIsHidden;
            $4fcf5377eb083461$var$offscreenDirectParentIsHidden = !1;
            $4fcf5377eb083461$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $4fcf5377eb083461$var$offscreenDirectParentIsHidden = ii;
            $4fcf5377eb083461$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($4fcf5377eb083461$var$offscreenSubtreeWasHidden || null === current || $4fcf5377eb083461$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                root = finishedWork.stateNode;
                try {
                    $4fcf5377eb083461$var$setTextContent(root, ""), $4fcf5377eb083461$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $4fcf5377eb083461$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, $4fcf5377eb083461$var$commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
            flags & 1024 && ($4fcf5377eb083461$var$needsFormReset = !0);
            break;
        case 6:
            $4fcf5377eb083461$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $4fcf5377eb083461$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(162));
                root = finishedWork.memoizedProps;
                lanes = finishedWork.stateNode;
                try {
                    lanes.nodeValue = root, $4fcf5377eb083461$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $4fcf5377eb083461$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $4fcf5377eb083461$var$viewTransitionMutationContext = !1;
            $4fcf5377eb083461$var$tagCaches = null;
            ii = $4fcf5377eb083461$var$currentHoistableRoot;
            $4fcf5377eb083461$var$currentHoistableRoot = $4fcf5377eb083461$var$getHoistableRoot(root.containerInfo);
            $4fcf5377eb083461$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $4fcf5377eb083461$var$currentHoistableRoot = ii;
            $4fcf5377eb083461$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $4fcf5377eb083461$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $4fcf5377eb083461$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $4fcf5377eb083461$var$needsFormReset && ($4fcf5377eb083461$var$needsFormReset = !1, $4fcf5377eb083461$var$recursivelyResetForms(finishedWork));
            $4fcf5377eb083461$var$viewTransitionMutationContext = !1;
            break;
        case 4:
            flags = $4fcf5377eb083461$var$offscreenDirectParentIsHidden;
            $4fcf5377eb083461$var$offscreenDirectParentIsHidden = $4fcf5377eb083461$var$offscreenSubtreeIsHidden;
            current = $4fcf5377eb083461$var$pushMutationContext();
            ii = $4fcf5377eb083461$var$currentHoistableRoot;
            $4fcf5377eb083461$var$currentHoistableRoot = $4fcf5377eb083461$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $4fcf5377eb083461$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $4fcf5377eb083461$var$commitReconciliationEffects(finishedWork);
            $4fcf5377eb083461$var$currentHoistableRoot = ii;
            $4fcf5377eb083461$var$viewTransitionMutationContext && $4fcf5377eb083461$var$inUpdateViewTransition && ($4fcf5377eb083461$var$rootViewTransitionAffected = !0);
            $4fcf5377eb083461$var$viewTransitionMutationContext = current;
            $4fcf5377eb083461$var$offscreenDirectParentIsHidden = flags;
            break;
        case 12:
            $4fcf5377eb083461$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $4fcf5377eb083461$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $4fcf5377eb083461$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $4fcf5377eb083461$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $4fcf5377eb083461$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 13:
            $4fcf5377eb083461$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $4fcf5377eb083461$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($4fcf5377eb083461$var$globalMostRecentFallbackTime = $4fcf5377eb083461$var$now());
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $4fcf5377eb083461$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 22:
            ii = null !== finishedWork.memoizedState;
            _eventPayloads$ii2 = null !== current && null !== current.memoizedState;
            var prevOffscreenSubtreeIsHidden = $4fcf5377eb083461$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $4fcf5377eb083461$var$offscreenSubtreeWasHidden, prevOffscreenDirectParentIsHidden$166 = $4fcf5377eb083461$var$offscreenDirectParentIsHidden;
            $4fcf5377eb083461$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || ii;
            $4fcf5377eb083461$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166 || ii;
            $4fcf5377eb083461$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _eventPayloads$ii2;
            $4fcf5377eb083461$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $4fcf5377eb083461$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $4fcf5377eb083461$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166;
            $4fcf5377eb083461$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $4fcf5377eb083461$var$commitReconciliationEffects(finishedWork);
            flags & 8192 && (root = finishedWork.stateNode, root._visibility = ii ? root._visibility & -2 : root._visibility | 1, !ii || null === current || _eventPayloads$ii2 || $4fcf5377eb083461$var$offscreenSubtreeIsHidden || $4fcf5377eb083461$var$offscreenSubtreeWasHidden || (root = _eventPayloads$ii2 || $4fcf5377eb083461$var$offscreenSubtreeWasHidden, lanes = $4fcf5377eb083461$var$offscreenSubtreeIsHidden, current = $4fcf5377eb083461$var$offscreenSubtreeWasHidden, $4fcf5377eb083461$var$offscreenSubtreeIsHidden = ii || $4fcf5377eb083461$var$offscreenSubtreeIsHidden, $4fcf5377eb083461$var$offscreenSubtreeWasHidden = root, $4fcf5377eb083461$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, 2), $4fcf5377eb083461$var$offscreenSubtreeIsHidden = lanes, $4fcf5377eb083461$var$offscreenSubtreeWasHidden = current), !ii && $4fcf5377eb083461$var$offscreenDirectParentIsHidden || $4fcf5377eb083461$var$hideOrUnhideAllChildren(finishedWork, ii));
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (lanes = root.retryQueue, null !== lanes && (root.retryQueue = null, $4fcf5377eb083461$var$attachSuspenseRetryListeners(finishedWork, lanes))));
            break;
        case 19:
            $4fcf5377eb083461$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $4fcf5377eb083461$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $4fcf5377eb083461$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 30:
            flags & 512 && ($4fcf5377eb083461$var$offscreenSubtreeWasHidden || null === current || $4fcf5377eb083461$var$safelyDetachRef(current, current.return));
            flags = $4fcf5377eb083461$var$pushMutationContext();
            ii = $4fcf5377eb083461$var$inUpdateViewTransition;
            _eventPayloads$ii2 = (lanes & 335544064) === lanes;
            prevOffscreenSubtreeIsHidden = finishedWork.memoizedProps;
            $4fcf5377eb083461$var$inUpdateViewTransition = _eventPayloads$ii2 && "none" !== $4fcf5377eb083461$var$getViewTransitionClassName(prevOffscreenSubtreeIsHidden.default, prevOffscreenSubtreeIsHidden.update);
            $4fcf5377eb083461$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $4fcf5377eb083461$var$commitReconciliationEffects(finishedWork);
            _eventPayloads$ii2 && null !== current && $4fcf5377eb083461$var$viewTransitionMutationContext && (finishedWork.flags |= 4);
            $4fcf5377eb083461$var$inUpdateViewTransition = ii;
            $4fcf5377eb083461$var$viewTransitionMutationContext = flags;
            break;
        case 21:
            break;
        case 7:
            flags & 512 && ($4fcf5377eb083461$var$offscreenSubtreeWasHidden || null === current || $4fcf5377eb083461$var$safelyDetachRef(current, current.return)), current && null !== current.stateNode && (current.stateNode._fragmentFiber = finishedWork);
        default:
            $4fcf5377eb083461$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes), $4fcf5377eb083461$var$commitReconciliationEffects(finishedWork);
    }
}
function $4fcf5377eb083461$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($4fcf5377eb083461$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            parentFiber = null;
            for(var parent = finishedWork.return; null !== parent;){
                if ($4fcf5377eb083461$var$isFragmentInstanceParent(parent)) {
                    var fragmentInstance = parent.stateNode;
                    null === parentFiber ? parentFiber = [
                        fragmentInstance
                    ] : parentFiber.push(fragmentInstance);
                }
                if ($4fcf5377eb083461$var$isFragmentInstanceHostBoundary(parent)) break;
                parent = parent.return;
            }
            var JSCompiler_inline_result = parentFiber;
            if (null == hostParentFiber) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent$jscomp$0 = hostParentFiber.stateNode, before = $4fcf5377eb083461$var$getHostSibling(finishedWork);
                    $4fcf5377eb083461$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0, JSCompiler_inline_result);
                    break;
                case 5:
                    var parent$149 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($4fcf5377eb083461$var$setTextContent(parent$149, ""), hostParentFiber.flags &= -33);
                    var before$150 = $4fcf5377eb083461$var$getHostSibling(finishedWork);
                    $4fcf5377eb083461$var$insertOrAppendPlacementNode(finishedWork, before$150, parent$149, JSCompiler_inline_result);
                    break;
                case 3:
                case 4:
                    var parent$151 = hostParentFiber.stateNode.containerInfo, before$152 = $4fcf5377eb083461$var$getHostSibling(finishedWork);
                    $4fcf5377eb083461$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$152, parent$151, JSCompiler_inline_result);
                    break;
                default:
                    throw Error($4fcf5377eb083461$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $4fcf5377eb083461$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $4fcf5377eb083461$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $4fcf5377eb083461$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && (fiber = fiber.stateNode, $4fcf5377eb083461$var$_enabled = !0, fiber.reset(), $4fcf5377eb083461$var$_enabled = !1);
        parentFiber = parentFiber.sibling;
    }
}
function $4fcf5377eb083461$var$recursivelyTraverseAfterMutationEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 9270) for(parentFiber = parentFiber.child; null !== parentFiber;)$4fcf5377eb083461$var$commitAfterMutationEffectsOnFiber(parentFiber, root), parentFiber = parentFiber.sibling;
    else $4fcf5377eb083461$var$measureNestedViewTransitions(parentFiber, !1);
}
function $4fcf5377eb083461$var$commitAfterMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate;
    if (null === current) $4fcf5377eb083461$var$commitEnterViewTransitions(finishedWork, !1);
    else switch(finishedWork.tag){
        case 3:
            $4fcf5377eb083461$var$rootViewTransitionNameCanceled = $4fcf5377eb083461$var$viewTransitionContextChanged = !1;
            $4fcf5377eb083461$var$pushViewTransitionCancelableScope();
            $4fcf5377eb083461$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            if (!$4fcf5377eb083461$var$viewTransitionContextChanged && !$4fcf5377eb083461$var$rootViewTransitionAffected) {
                finishedWork = $4fcf5377eb083461$var$viewTransitionCancelableChildren;
                if (null !== finishedWork) for(var i = 0; i < finishedWork.length; i += 3){
                    current = finishedWork[i];
                    var oldName = finishedWork[i + 1];
                    $4fcf5377eb083461$var$restoreViewTransitionName(current, finishedWork[i + 2]);
                    current = current.ownerDocument.documentElement;
                    null !== current && current.animate({
                        opacity: [
                            0,
                            0
                        ],
                        pointerEvents: [
                            "none",
                            "none"
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition-group(" + oldName + ")"
                    });
                }
                finishedWork = root.containerInfo;
                finishedWork = 9 === finishedWork.nodeType ? finishedWork.documentElement : finishedWork.ownerDocument.documentElement;
                null !== finishedWork && "" === finishedWork.style.viewTransitionName && (finishedWork.style.viewTransitionName = "none", finishedWork.animate({
                    opacity: [
                        0,
                        0
                    ],
                    pointerEvents: [
                        "none",
                        "none"
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition-group(root)"
                }), finishedWork.animate({
                    width: [
                        0,
                        0
                    ],
                    height: [
                        0,
                        0
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition"
                }));
                $4fcf5377eb083461$var$rootViewTransitionNameCanceled = !0;
            }
            $4fcf5377eb083461$var$viewTransitionCancelableChildren = null;
            break;
        case 5:
            $4fcf5377eb083461$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            break;
        case 4:
            i = $4fcf5377eb083461$var$viewTransitionContextChanged;
            $4fcf5377eb083461$var$viewTransitionContextChanged = !1;
            $4fcf5377eb083461$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $4fcf5377eb083461$var$viewTransitionContextChanged && ($4fcf5377eb083461$var$rootViewTransitionAffected = !0);
            $4fcf5377eb083461$var$viewTransitionContextChanged = i;
            break;
        case 22:
            null === finishedWork.memoizedState && (null !== current.memoizedState ? $4fcf5377eb083461$var$commitEnterViewTransitions(finishedWork, !1) : $4fcf5377eb083461$var$recursivelyTraverseAfterMutationEffects(root, finishedWork));
            break;
        case 30:
            i = $4fcf5377eb083461$var$viewTransitionContextChanged;
            oldName = $4fcf5377eb083461$var$pushViewTransitionCancelableScope();
            $4fcf5377eb083461$var$viewTransitionContextChanged = !1;
            $4fcf5377eb083461$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $4fcf5377eb083461$var$viewTransitionContextChanged && (finishedWork.flags |= 4);
            var props = finishedWork.memoizedProps, state = finishedWork.stateNode;
            root = $4fcf5377eb083461$var$getViewTransitionName(props, state);
            state = $4fcf5377eb083461$var$getViewTransitionName(current.memoizedProps, state);
            var className = $4fcf5377eb083461$var$getViewTransitionClassName(props.default, props.update);
            "none" === className ? root = !1 : (props = current.memoizedState, current.memoizedState = null, current = finishedWork.child, $4fcf5377eb083461$var$viewTransitionHostInstanceIdx = 0, root = $4fcf5377eb083461$var$measureViewTransitionHostInstancesRecursive(finishedWork, current, root, state, className, props, !0), $4fcf5377eb083461$var$viewTransitionHostInstanceIdx !== (null === props ? 0 : props.length) && (finishedWork.flags |= 32));
            0 !== (finishedWork.flags & 4) && root ? ($4fcf5377eb083461$var$scheduleViewTransitionEvent(finishedWork, finishedWork.memoizedProps.onUpdate), $4fcf5377eb083461$var$viewTransitionCancelableChildren = oldName) : null !== oldName && (oldName.push.apply(oldName, $4fcf5377eb083461$var$viewTransitionCancelableChildren), $4fcf5377eb083461$var$viewTransitionCancelableChildren = oldName);
            $4fcf5377eb083461$var$viewTransitionContextChanged = 0 !== (finishedWork.flags & 32) ? !0 : i;
            break;
        default:
            $4fcf5377eb083461$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
    }
}
function $4fcf5377eb083461$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$4fcf5377eb083461$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $4fcf5377eb083461$var$recursivelyTraverseDisappearLayoutEffects(parentFiber, layoutEffectTraversalFlags$jscomp$0) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber, layoutEffectTraversalFlags = layoutEffectTraversalFlags$jscomp$0;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $4fcf5377eb083461$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $4fcf5377eb083461$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 1:
                $4fcf5377eb083461$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $4fcf5377eb083461$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $4fcf5377eb083461$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $4fcf5377eb083461$var$releaseSingletonInstance(finishedWork.stateNode, finishedWork.type, finishedWork.memoizedProps);
            case 5:
                $4fcf5377eb083461$var$safelyDetachRef(finishedWork, finishedWork.return);
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $4fcf5377eb083461$var$commitFragmentInstanceDeletionEffects(finishedWork);
                $4fcf5377eb083461$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 6:
                $4fcf5377eb083461$var$commitFragmentInstanceDeletionEffects(finishedWork);
                break;
            case 26:
                $4fcf5377eb083461$var$safelyDetachRef(finishedWork, finishedWork.return);
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $4fcf5377eb083461$var$offscreenSubtreeWasHidden || instance.parentNode.removeChild(instance);
                $4fcf5377eb083461$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 22:
                null === finishedWork.memoizedState && $4fcf5377eb083461$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 30:
                $4fcf5377eb083461$var$safelyDetachRef(finishedWork, finishedWork.return);
                $4fcf5377eb083461$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 7:
                $4fcf5377eb083461$var$safelyDetachRef(finishedWork, finishedWork.return);
            default:
                $4fcf5377eb083461$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $4fcf5377eb083461$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, layoutEffectTraversalFlags) {
    layoutEffectTraversalFlags = 0 !== (parentFiber.subtreeFlags & 8772) ? layoutEffectTraversalFlags : layoutEffectTraversalFlags & -2;
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags, includeWorkInProgressEffects = 0 !== (layoutEffectTraversalFlags & 1);
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $4fcf5377eb083461$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $4fcf5377eb083461$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $4fcf5377eb083461$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $4fcf5377eb083461$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$4fcf5377eb083461$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $4fcf5377eb083461$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $4fcf5377eb083461$var$commitClassCallbacks(finishedWork);
                $4fcf5377eb083461$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $4fcf5377eb083461$var$commitHostSingletonAcquisition(finishedWork);
            case 5:
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $4fcf5377eb083461$var$commitFragmentInstanceInsertionEffects(finishedWork);
                $4fcf5377eb083461$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $4fcf5377eb083461$var$commitHostMount(finishedWork);
                $4fcf5377eb083461$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 6:
                $4fcf5377eb083461$var$commitFragmentInstanceInsertionEffects(finishedWork);
                break;
            case 26:
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $4fcf5377eb083461$var$offscreenSubtreeIsHidden || $4fcf5377eb083461$var$mountHoistable($4fcf5377eb083461$var$getHoistableRoot(instance.ownerDocument), finishedWork.type, instance);
                $4fcf5377eb083461$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $4fcf5377eb083461$var$commitHostMount(finishedWork);
                $4fcf5377eb083461$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $4fcf5377eb083461$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                break;
            case 31:
                $4fcf5377eb083461$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $4fcf5377eb083461$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $4fcf5377eb083461$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $4fcf5377eb083461$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $4fcf5377eb083461$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $4fcf5377eb083461$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                $4fcf5377eb083461$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $4fcf5377eb083461$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                $4fcf5377eb083461$var$safelyAttachRef(finishedWork, finishedWork.return);
            default:
                $4fcf5377eb083461$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $4fcf5377eb083461$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $4fcf5377eb083461$var$releaseCache(previousCache));
}
function $4fcf5377eb083461$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $4fcf5377eb083461$var$releaseCache(current));
}
function $4fcf5377eb083461$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    if (parentFiber.subtreeFlags & (isViewTransitionEligible ? 10262 : 10256)) for(parentFiber = parentFiber.child; null !== parentFiber;)$4fcf5377eb083461$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
    else isViewTransitionEligible && $4fcf5377eb083461$var$restoreNestedViewTransitions(parentFiber);
}
function $4fcf5377eb083461$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    isViewTransitionEligible && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && $4fcf5377eb083461$var$restoreEnterOrExitViewTransitions(finishedWork);
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $4fcf5377eb083461$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $4fcf5377eb083461$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $4fcf5377eb083461$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $4fcf5377eb083461$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            isViewTransitionEligible && $4fcf5377eb083461$var$rootViewTransitionNameCanceled && (finishedRoot = finishedRoot.containerInfo, finishedRoot = 9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, "root" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""), finishedRoot = finishedRoot.ownerDocument.documentElement, null !== finishedRoot && "none" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""));
            flags & 2048 && (flags = null, null !== finishedWork.alternate && (flags = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== flags && (finishedWork.refCount++, null != flags && $4fcf5377eb083461$var$releaseCache(flags)));
            break;
        case 12:
            if (flags & 2048) {
                $4fcf5377eb083461$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", flags.passiveEffectDuration, -0);
                } catch (error) {
                    $4fcf5377eb083461$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $4fcf5377eb083461$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $4fcf5377eb083461$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $4fcf5377eb083461$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? (isViewTransitionEligible && null !== id && null === id.memoizedState && $4fcf5377eb083461$var$restoreEnterOrExitViewTransitions(id), _finishedWork$memoize2._visibility & 2 ? $4fcf5377eb083461$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $4fcf5377eb083461$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork)) : (isViewTransitionEligible && null !== id && null !== id.memoizedState && $4fcf5377eb083461$var$restoreEnterOrExitViewTransitions(finishedWork), _finishedWork$memoize2._visibility & 2 ? $4fcf5377eb083461$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $4fcf5377eb083461$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1)));
            flags & 2048 && $4fcf5377eb083461$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $4fcf5377eb083461$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $4fcf5377eb083461$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        case 30:
            isViewTransitionEligible && (flags = finishedWork.alternate, null !== flags && ($4fcf5377eb083461$var$restoreViewTransitionOnHostInstances(flags.child, !0), $4fcf5377eb083461$var$restoreViewTransitionOnHostInstances(finishedWork.child, !0)));
            $4fcf5377eb083461$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        default:
            $4fcf5377eb083461$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $4fcf5377eb083461$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $4fcf5377eb083461$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $4fcf5377eb083461$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $4fcf5377eb083461$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $4fcf5377eb083461$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $4fcf5377eb083461$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $4fcf5377eb083461$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $4fcf5377eb083461$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $4fcf5377eb083461$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $4fcf5377eb083461$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $4fcf5377eb083461$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $4fcf5377eb083461$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $4fcf5377eb083461$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $4fcf5377eb083461$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $4fcf5377eb083461$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $4fcf5377eb083461$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $4fcf5377eb083461$var$suspenseyCommitFlag = 8192;
function $4fcf5377eb083461$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $4fcf5377eb083461$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$4fcf5377eb083461$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $4fcf5377eb083461$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $4fcf5377eb083461$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $4fcf5377eb083461$var$suspenseyCommitFlag && (null !== fiber.memoizedState ? $4fcf5377eb083461$var$suspendResource(suspendedState, $4fcf5377eb083461$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $4fcf5377eb083461$var$suspendInstance(suspendedState, fiber)));
            break;
        case 5:
            $4fcf5377eb083461$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $4fcf5377eb083461$var$suspenseyCommitFlag && (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $4fcf5377eb083461$var$suspendInstance(suspendedState, fiber));
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $4fcf5377eb083461$var$currentHoistableRoot;
            $4fcf5377eb083461$var$currentHoistableRoot = $4fcf5377eb083461$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $4fcf5377eb083461$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $4fcf5377eb083461$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $4fcf5377eb083461$var$suspenseyCommitFlag, $4fcf5377eb083461$var$suspenseyCommitFlag = 16777216, $4fcf5377eb083461$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $4fcf5377eb083461$var$suspenseyCommitFlag = previousHoistableRoot) : $4fcf5377eb083461$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        case 30:
            if (0 !== (fiber.flags & $4fcf5377eb083461$var$suspenseyCommitFlag) && (previousHoistableRoot = fiber.memoizedProps.name, null != previousHoistableRoot && "auto" !== previousHoistableRoot)) {
                var state = fiber.stateNode;
                state.paired = null;
                null === $4fcf5377eb083461$var$appearingViewTransitions && ($4fcf5377eb083461$var$appearingViewTransitions = new Map());
                $4fcf5377eb083461$var$appearingViewTransitions.set(previousHoistableRoot, state);
            }
            $4fcf5377eb083461$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        default:
            $4fcf5377eb083461$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $4fcf5377eb083461$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $4fcf5377eb083461$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $4fcf5377eb083461$var$nextEffect = childToDelete;
            $4fcf5377eb083461$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $4fcf5377eb083461$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$4fcf5377eb083461$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $4fcf5377eb083461$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $4fcf5377eb083461$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $4fcf5377eb083461$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $4fcf5377eb083461$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $4fcf5377eb083461$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $4fcf5377eb083461$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $4fcf5377eb083461$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $4fcf5377eb083461$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $4fcf5377eb083461$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $4fcf5377eb083461$var$nextEffect = childToDelete;
            $4fcf5377eb083461$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $4fcf5377eb083461$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $4fcf5377eb083461$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $4fcf5377eb083461$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $4fcf5377eb083461$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $4fcf5377eb083461$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $4fcf5377eb083461$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $4fcf5377eb083461$var$nextEffect;){
        var fiber = $4fcf5377eb083461$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $4fcf5377eb083461$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $4fcf5377eb083461$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $4fcf5377eb083461$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $4fcf5377eb083461$var$nextEffect;){
            cache = $4fcf5377eb083461$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $4fcf5377eb083461$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $4fcf5377eb083461$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $4fcf5377eb083461$var$nextEffect = sibling;
                break a;
            }
            $4fcf5377eb083461$var$nextEffect = returnFiber;
        }
    }
}
var $4fcf5377eb083461$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $4fcf5377eb083461$var$readContext($4fcf5377eb083461$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $4fcf5377eb083461$var$readContext($4fcf5377eb083461$var$CacheContext).controller.signal;
    }
}, $4fcf5377eb083461$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $4fcf5377eb083461$var$executionContext = 0, $4fcf5377eb083461$var$workInProgressRoot = null, $4fcf5377eb083461$var$workInProgress = null, $4fcf5377eb083461$var$workInProgressRootRenderLanes = 0, $4fcf5377eb083461$var$workInProgressSuspendedReason = 0, $4fcf5377eb083461$var$workInProgressThrownValue = null, $4fcf5377eb083461$var$workInProgressRootDidSkipSuspendedSiblings = !1, $4fcf5377eb083461$var$workInProgressRootIsPrerendering = !1, $4fcf5377eb083461$var$workInProgressRootDidAttachPingListener = !1, $4fcf5377eb083461$var$entangledRenderLanes = 0, $4fcf5377eb083461$var$workInProgressRootExitStatus = 0, $4fcf5377eb083461$var$workInProgressRootSkippedLanes = 0, $4fcf5377eb083461$var$workInProgressRootInterleavedUpdatedLanes = 0, $4fcf5377eb083461$var$workInProgressRootPingedLanes = 0, $4fcf5377eb083461$var$workInProgressDeferredLane = 0, $4fcf5377eb083461$var$workInProgressSuspendedRetryLanes = 0, $4fcf5377eb083461$var$workInProgressRootConcurrentErrors = null, $4fcf5377eb083461$var$workInProgressRootRecoverableErrors = null, $4fcf5377eb083461$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $4fcf5377eb083461$var$globalMostRecentFallbackTime = 0, $4fcf5377eb083461$var$globalMostRecentTransitionTime = 0, $4fcf5377eb083461$var$workInProgressRootRenderTargetTime = Infinity, $4fcf5377eb083461$var$workInProgressTransitions = null, $4fcf5377eb083461$var$legacyErrorBoundariesThatAlreadyFailed = null, $4fcf5377eb083461$var$pendingEffectsStatus = 0, $4fcf5377eb083461$var$pendingEffectsRoot = null, $4fcf5377eb083461$var$pendingFinishedWork = null, $4fcf5377eb083461$var$pendingEffectsLanes = 0, $4fcf5377eb083461$var$pendingEffectsRemainingLanes = 0, $4fcf5377eb083461$var$pendingPassiveTransitions = null, $4fcf5377eb083461$var$pendingRecoverableErrors = null, $4fcf5377eb083461$var$pendingViewTransition = null, $4fcf5377eb083461$var$pendingViewTransitionEvents = null, $4fcf5377eb083461$var$pendingTransitionTypes = null, $4fcf5377eb083461$var$nestedUpdateCount = 0, $4fcf5377eb083461$var$rootWithNestedUpdates = null;
function $4fcf5377eb083461$var$requestUpdateLane() {
    return 0 !== ($4fcf5377eb083461$var$executionContext & 2) && 0 !== $4fcf5377eb083461$var$workInProgressRootRenderLanes ? $4fcf5377eb083461$var$workInProgressRootRenderLanes & -$4fcf5377eb083461$var$workInProgressRootRenderLanes : null !== $4fcf5377eb083461$var$ReactSharedInternals.T ? $4fcf5377eb083461$var$requestTransitionLane() : $4fcf5377eb083461$var$resolveUpdatePriority();
}
function $4fcf5377eb083461$var$requestDeferredLane() {
    if (0 === $4fcf5377eb083461$var$workInProgressDeferredLane) {
        if (0 === ($4fcf5377eb083461$var$workInProgressRootRenderLanes & 536870912) || $4fcf5377eb083461$var$isHydrating) {
            var lane = $4fcf5377eb083461$var$nextTransitionDeferredLane;
            $4fcf5377eb083461$var$nextTransitionDeferredLane <<= 1;
            0 === ($4fcf5377eb083461$var$nextTransitionDeferredLane & 3932160) && ($4fcf5377eb083461$var$nextTransitionDeferredLane = 262144);
            $4fcf5377eb083461$var$workInProgressDeferredLane = lane;
        } else $4fcf5377eb083461$var$workInProgressDeferredLane = 536870912;
    }
    lane = $4fcf5377eb083461$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $4fcf5377eb083461$var$workInProgressDeferredLane;
}
function $4fcf5377eb083461$var$scheduleViewTransitionEvent(fiber, callback) {
    if (null != callback) {
        var state = fiber.stateNode, instance = state.ref;
        null === instance && (instance = state.ref = $4fcf5377eb083461$var$createViewTransitionInstance($4fcf5377eb083461$var$getViewTransitionName(fiber.memoizedProps, state)));
        null === $4fcf5377eb083461$var$pendingViewTransitionEvents && ($4fcf5377eb083461$var$pendingViewTransitionEvents = []);
        $4fcf5377eb083461$var$pendingViewTransitionEvents.push(callback.bind(null, instance));
    }
}
function $4fcf5377eb083461$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $4fcf5377eb083461$var$workInProgressRoot && (2 === $4fcf5377eb083461$var$workInProgressSuspendedReason || 9 === $4fcf5377eb083461$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $4fcf5377eb083461$var$prepareFreshStack(root, 0), $4fcf5377eb083461$var$markRootSuspended(root, $4fcf5377eb083461$var$workInProgressRootRenderLanes, $4fcf5377eb083461$var$workInProgressDeferredLane, !1);
    $4fcf5377eb083461$var$markRootUpdated$1(root, lane);
    if (0 === ($4fcf5377eb083461$var$executionContext & 2) || root !== $4fcf5377eb083461$var$workInProgressRoot) root === $4fcf5377eb083461$var$workInProgressRoot && (0 === ($4fcf5377eb083461$var$executionContext & 2) && ($4fcf5377eb083461$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $4fcf5377eb083461$var$workInProgressRootExitStatus && $4fcf5377eb083461$var$markRootSuspended(root, $4fcf5377eb083461$var$workInProgressRootRenderLanes, $4fcf5377eb083461$var$workInProgressDeferredLane, !1)), $4fcf5377eb083461$var$ensureRootIsScheduled(root);
}
function $4fcf5377eb083461$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($4fcf5377eb083461$var$executionContext & 6)) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $4fcf5377eb083461$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $4fcf5377eb083461$var$renderRootConcurrent(root$jscomp$0, lanes) : $4fcf5377eb083461$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $4fcf5377eb083461$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $4fcf5377eb083461$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$4fcf5377eb083461$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $4fcf5377eb083461$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $4fcf5377eb083461$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($4fcf5377eb083461$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $4fcf5377eb083461$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result && 6 !== JSCompiler_inline_result) {
                            if ($4fcf5377eb083461$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $4fcf5377eb083461$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $4fcf5377eb083461$var$workInProgressRootRecoverableErrors;
                            $4fcf5377eb083461$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $4fcf5377eb083461$var$workInProgressRootRecoverableErrors ? $4fcf5377eb083461$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $4fcf5377eb083461$var$workInProgressRootRecoverableErrors.push.apply($4fcf5377eb083461$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $4fcf5377eb083461$var$prepareFreshStack(root$jscomp$0, 0);
                $4fcf5377eb083461$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($4fcf5377eb083461$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes && (lanes & 62914560) !== lanes) break;
                    case 6:
                        $4fcf5377eb083461$var$markRootSuspended(shouldTimeSlice, lanes, $4fcf5377eb083461$var$workInProgressDeferredLane, !$4fcf5377eb083461$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $4fcf5377eb083461$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($4fcf5377eb083461$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $4fcf5377eb083461$var$globalMostRecentFallbackTime + 300 - $4fcf5377eb083461$var$now(), 10 < exitStatus)) {
                    $4fcf5377eb083461$var$markRootSuspended(shouldTimeSlice, lanes, $4fcf5377eb083461$var$workInProgressDeferredLane, !$4fcf5377eb083461$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $4fcf5377eb083461$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $4fcf5377eb083461$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $4fcf5377eb083461$var$scheduleTimeout($4fcf5377eb083461$var$completeRootWhenReady.bind(null, shouldTimeSlice, forceSync, $4fcf5377eb083461$var$workInProgressRootRecoverableErrors, $4fcf5377eb083461$var$workInProgressTransitions, $4fcf5377eb083461$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $4fcf5377eb083461$var$workInProgressDeferredLane, $4fcf5377eb083461$var$workInProgressRootInterleavedUpdatedLanes, $4fcf5377eb083461$var$workInProgressSuspendedRetryLanes, $4fcf5377eb083461$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $4fcf5377eb083461$var$completeRootWhenReady(shouldTimeSlice, forceSync, $4fcf5377eb083461$var$workInProgressRootRecoverableErrors, $4fcf5377eb083461$var$workInProgressTransitions, $4fcf5377eb083461$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $4fcf5377eb083461$var$workInProgressDeferredLane, $4fcf5377eb083461$var$workInProgressRootInterleavedUpdatedLanes, $4fcf5377eb083461$var$workInProgressSuspendedRetryLanes, $4fcf5377eb083461$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $4fcf5377eb083461$var$ensureRootIsScheduled(root$jscomp$0);
}
function $4fcf5377eb083461$var$completeRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    var subtreeFlags = finishedWork.subtreeFlags, isViewTransitionEligible = (lanes & 335544064) === lanes;
    suspendedCommitReason = null;
    if (isViewTransitionEligible || subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $4fcf5377eb083461$var$noop$1
        }, $4fcf5377eb083461$var$appearingViewTransitions = null, $4fcf5377eb083461$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason), isViewTransitionEligible && (subtreeFlags = suspendedCommitReason, isViewTransitionEligible = root.containerInfo, isViewTransitionEligible = (9 === isViewTransitionEligible.nodeType ? isViewTransitionEligible : isViewTransitionEligible.ownerDocument).__reactViewTransition, null != isViewTransitionEligible && (subtreeFlags.count++, subtreeFlags.waitingForViewTransition = !0, subtreeFlags = $4fcf5377eb083461$var$onUnsuspend.bind(subtreeFlags), isViewTransitionEligible.finished.then(subtreeFlags, subtreeFlags))), subtreeFlags = (lanes & 62914560) === lanes ? $4fcf5377eb083461$var$globalMostRecentFallbackTime - $4fcf5377eb083461$var$now() : (lanes & 4194048) === lanes ? $4fcf5377eb083461$var$globalMostRecentTransitionTime - $4fcf5377eb083461$var$now() : 0, subtreeFlags = $4fcf5377eb083461$var$waitForCommitToBeReady(suspendedCommitReason, subtreeFlags), null !== subtreeFlags) {
            $4fcf5377eb083461$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = subtreeFlags($4fcf5377eb083461$var$completeRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $4fcf5377eb083461$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $4fcf5377eb083461$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason);
}
function $4fcf5377eb083461$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$4fcf5377eb083461$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $4fcf5377eb083461$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes = $4fcf5377eb083461$var$getEntangledLanes(root, suspendedLanes);
    suspendedLanes &= ~$4fcf5377eb083461$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$4fcf5377eb083461$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $4fcf5377eb083461$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $4fcf5377eb083461$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $4fcf5377eb083461$var$flushSyncWork$1() {
    return 0 === ($4fcf5377eb083461$var$executionContext & 6) ? ($4fcf5377eb083461$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $4fcf5377eb083461$var$resetWorkInProgressStack() {
    if (null !== $4fcf5377eb083461$var$workInProgress) {
        if (0 === $4fcf5377eb083461$var$workInProgressSuspendedReason) var interruptedWork = $4fcf5377eb083461$var$workInProgress.return;
        else interruptedWork = $4fcf5377eb083461$var$workInProgress, $4fcf5377eb083461$var$lastContextDependency = $4fcf5377eb083461$var$currentlyRenderingFiber$1 = null, $4fcf5377eb083461$var$resetHooksOnUnwind(interruptedWork), $4fcf5377eb083461$var$thenableState$1 = null, $4fcf5377eb083461$var$thenableIndexCounter$1 = 0, interruptedWork = $4fcf5377eb083461$var$workInProgress;
        for(; null !== interruptedWork;)$4fcf5377eb083461$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $4fcf5377eb083461$var$workInProgress = null;
    }
}
function $4fcf5377eb083461$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $4fcf5377eb083461$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $4fcf5377eb083461$var$pendingEffectsLanes = 0;
    $4fcf5377eb083461$var$resetWorkInProgressStack();
    $4fcf5377eb083461$var$workInProgressRoot = root;
    $4fcf5377eb083461$var$workInProgress = timeoutHandle = $4fcf5377eb083461$var$createWorkInProgress(root.current, null);
    $4fcf5377eb083461$var$workInProgressRootRenderLanes = lanes;
    $4fcf5377eb083461$var$workInProgressSuspendedReason = 0;
    $4fcf5377eb083461$var$workInProgressThrownValue = null;
    $4fcf5377eb083461$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $4fcf5377eb083461$var$workInProgressRootIsPrerendering = $4fcf5377eb083461$var$checkIfRootIsPrerendering(root, lanes);
    $4fcf5377eb083461$var$workInProgressRootDidAttachPingListener = !1;
    $4fcf5377eb083461$var$workInProgressSuspendedRetryLanes = $4fcf5377eb083461$var$workInProgressDeferredLane = $4fcf5377eb083461$var$workInProgressRootPingedLanes = $4fcf5377eb083461$var$workInProgressRootInterleavedUpdatedLanes = $4fcf5377eb083461$var$workInProgressRootSkippedLanes = $4fcf5377eb083461$var$workInProgressRootExitStatus = 0;
    $4fcf5377eb083461$var$workInProgressRootRecoverableErrors = $4fcf5377eb083461$var$workInProgressRootConcurrentErrors = null;
    $4fcf5377eb083461$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    $4fcf5377eb083461$var$entangledRenderLanes = $4fcf5377eb083461$var$getEntangledLanes(root, lanes);
    $4fcf5377eb083461$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $4fcf5377eb083461$var$handleThrow(root, thrownValue) {
    $4fcf5377eb083461$var$currentlyRenderingFiber = null;
    $4fcf5377eb083461$var$ReactSharedInternals.H = $4fcf5377eb083461$var$ContextOnlyDispatcher;
    thrownValue === $4fcf5377eb083461$var$SuspenseException || thrownValue === $4fcf5377eb083461$var$SuspenseActionException ? (thrownValue = $4fcf5377eb083461$var$getSuspendedThenable(), $4fcf5377eb083461$var$workInProgressSuspendedReason = 3) : thrownValue === $4fcf5377eb083461$var$SuspenseyCommitException ? (thrownValue = $4fcf5377eb083461$var$getSuspendedThenable(), $4fcf5377eb083461$var$workInProgressSuspendedReason = 4) : $4fcf5377eb083461$var$workInProgressSuspendedReason = thrownValue === $4fcf5377eb083461$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $4fcf5377eb083461$var$workInProgressThrownValue = thrownValue;
    null === $4fcf5377eb083461$var$workInProgress && ($4fcf5377eb083461$var$workInProgressRootExitStatus = 1, $4fcf5377eb083461$var$logUncaughtError(root, $4fcf5377eb083461$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $4fcf5377eb083461$var$shouldRemainOnPreviousScreen() {
    var handler = $4fcf5377eb083461$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($4fcf5377eb083461$var$workInProgressRootRenderLanes & 4194048) === $4fcf5377eb083461$var$workInProgressRootRenderLanes ? null === $4fcf5377eb083461$var$shellBoundary ? !0 : !1 : ($4fcf5377eb083461$var$workInProgressRootRenderLanes & 62914560) === $4fcf5377eb083461$var$workInProgressRootRenderLanes || 0 !== ($4fcf5377eb083461$var$workInProgressRootRenderLanes & 536870912) ? handler === $4fcf5377eb083461$var$shellBoundary : !1;
}
function $4fcf5377eb083461$var$pushDispatcher() {
    var prevDispatcher = $4fcf5377eb083461$var$ReactSharedInternals.H;
    $4fcf5377eb083461$var$ReactSharedInternals.H = $4fcf5377eb083461$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $4fcf5377eb083461$var$ContextOnlyDispatcher : prevDispatcher;
}
function $4fcf5377eb083461$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $4fcf5377eb083461$var$ReactSharedInternals.A;
    $4fcf5377eb083461$var$ReactSharedInternals.A = $4fcf5377eb083461$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $4fcf5377eb083461$var$renderDidSuspendDelayIfPossible() {
    $4fcf5377eb083461$var$workInProgressRootExitStatus = 4;
    $4fcf5377eb083461$var$workInProgressRootDidSkipSuspendedSiblings || ($4fcf5377eb083461$var$workInProgressRootRenderLanes & 4194048) !== $4fcf5377eb083461$var$workInProgressRootRenderLanes && null !== $4fcf5377eb083461$var$suspenseHandlerStackCursor.current || ($4fcf5377eb083461$var$workInProgressRootIsPrerendering = !0);
    0 === ($4fcf5377eb083461$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($4fcf5377eb083461$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $4fcf5377eb083461$var$workInProgressRoot || $4fcf5377eb083461$var$markRootSuspended($4fcf5377eb083461$var$workInProgressRoot, $4fcf5377eb083461$var$workInProgressRootRenderLanes, $4fcf5377eb083461$var$workInProgressDeferredLane, !1);
}
function $4fcf5377eb083461$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $4fcf5377eb083461$var$executionContext;
    $4fcf5377eb083461$var$executionContext |= 2;
    var prevDispatcher = $4fcf5377eb083461$var$pushDispatcher(), prevAsyncDispatcher = $4fcf5377eb083461$var$pushAsyncDispatcher();
    if ($4fcf5377eb083461$var$workInProgressRoot !== root || $4fcf5377eb083461$var$workInProgressRootRenderLanes !== lanes) $4fcf5377eb083461$var$workInProgressTransitions = null, $4fcf5377eb083461$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $4fcf5377eb083461$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $4fcf5377eb083461$var$workInProgressSuspendedReason && null !== $4fcf5377eb083461$var$workInProgress) {
            var unitOfWork = $4fcf5377eb083461$var$workInProgress, thrownValue = $4fcf5377eb083461$var$workInProgressThrownValue;
            switch($4fcf5377eb083461$var$workInProgressSuspendedReason){
                case 8:
                    $4fcf5377eb083461$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $4fcf5377eb083461$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $4fcf5377eb083461$var$workInProgressSuspendedReason;
                    $4fcf5377eb083461$var$workInProgressSuspendedReason = 0;
                    $4fcf5377eb083461$var$workInProgressThrownValue = null;
                    $4fcf5377eb083461$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $4fcf5377eb083461$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $4fcf5377eb083461$var$workInProgressSuspendedReason, $4fcf5377eb083461$var$workInProgressSuspendedReason = 0, $4fcf5377eb083461$var$workInProgressThrownValue = null, $4fcf5377eb083461$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $4fcf5377eb083461$var$workLoopSync();
        exitStatus = $4fcf5377eb083461$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$184) {
        $4fcf5377eb083461$var$handleThrow(root, thrownValue$184);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $4fcf5377eb083461$var$lastContextDependency = $4fcf5377eb083461$var$currentlyRenderingFiber$1 = null;
    $4fcf5377eb083461$var$executionContext = prevExecutionContext;
    $4fcf5377eb083461$var$ReactSharedInternals.H = prevDispatcher;
    $4fcf5377eb083461$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $4fcf5377eb083461$var$workInProgress && ($4fcf5377eb083461$var$workInProgressRoot = null, $4fcf5377eb083461$var$workInProgressRootRenderLanes = 0, $4fcf5377eb083461$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $4fcf5377eb083461$var$workLoopSync() {
    for(; null !== $4fcf5377eb083461$var$workInProgress;)$4fcf5377eb083461$var$performUnitOfWork($4fcf5377eb083461$var$workInProgress);
}
function $4fcf5377eb083461$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $4fcf5377eb083461$var$executionContext;
    $4fcf5377eb083461$var$executionContext |= 2;
    var prevDispatcher = $4fcf5377eb083461$var$pushDispatcher(), prevAsyncDispatcher = $4fcf5377eb083461$var$pushAsyncDispatcher();
    $4fcf5377eb083461$var$workInProgressRoot !== root || $4fcf5377eb083461$var$workInProgressRootRenderLanes !== lanes ? ($4fcf5377eb083461$var$workInProgressTransitions = null, $4fcf5377eb083461$var$workInProgressRootRenderTargetTime = $4fcf5377eb083461$var$now() + 500, $4fcf5377eb083461$var$prepareFreshStack(root, lanes)) : $4fcf5377eb083461$var$workInProgressRootIsPrerendering = $4fcf5377eb083461$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $4fcf5377eb083461$var$workInProgressSuspendedReason && null !== $4fcf5377eb083461$var$workInProgress) {
            lanes = $4fcf5377eb083461$var$workInProgress;
            var thrownValue = $4fcf5377eb083461$var$workInProgressThrownValue;
            b: switch($4fcf5377eb083461$var$workInProgressSuspendedReason){
                case 1:
                    $4fcf5377eb083461$var$workInProgressSuspendedReason = 0;
                    $4fcf5377eb083461$var$workInProgressThrownValue = null;
                    $4fcf5377eb083461$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($4fcf5377eb083461$var$isThenableResolved(thrownValue)) {
                        $4fcf5377eb083461$var$workInProgressSuspendedReason = 0;
                        $4fcf5377eb083461$var$workInProgressThrownValue = null;
                        $4fcf5377eb083461$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $4fcf5377eb083461$var$workInProgressSuspendedReason && 9 !== $4fcf5377eb083461$var$workInProgressSuspendedReason || $4fcf5377eb083461$var$workInProgressRoot !== root || ($4fcf5377eb083461$var$workInProgressSuspendedReason = 7);
                        $4fcf5377eb083461$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $4fcf5377eb083461$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $4fcf5377eb083461$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $4fcf5377eb083461$var$isThenableResolved(thrownValue) ? ($4fcf5377eb083461$var$workInProgressSuspendedReason = 0, $4fcf5377eb083461$var$workInProgressThrownValue = null, $4fcf5377eb083461$var$replaySuspendedUnitOfWork(lanes)) : ($4fcf5377eb083461$var$workInProgressSuspendedReason = 0, $4fcf5377eb083461$var$workInProgressThrownValue = null, $4fcf5377eb083461$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($4fcf5377eb083461$var$workInProgress.tag){
                        case 26:
                            resource = $4fcf5377eb083461$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $4fcf5377eb083461$var$workInProgress;
                            if (resource ? $4fcf5377eb083461$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $4fcf5377eb083461$var$workInProgressSuspendedReason = 0;
                                $4fcf5377eb083461$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $4fcf5377eb083461$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($4fcf5377eb083461$var$workInProgress = returnFiber, $4fcf5377eb083461$var$completeUnitOfWork(returnFiber)) : $4fcf5377eb083461$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $4fcf5377eb083461$var$workInProgressSuspendedReason = 0;
                    $4fcf5377eb083461$var$workInProgressThrownValue = null;
                    $4fcf5377eb083461$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $4fcf5377eb083461$var$workInProgressSuspendedReason = 0;
                    $4fcf5377eb083461$var$workInProgressThrownValue = null;
                    $4fcf5377eb083461$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $4fcf5377eb083461$var$resetWorkInProgressStack();
                    $4fcf5377eb083461$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($4fcf5377eb083461$var$formatProdErrorMessage(462));
            }
        }
        $4fcf5377eb083461$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$186) {
        $4fcf5377eb083461$var$handleThrow(root, thrownValue$186);
    }
    while (1);
    $4fcf5377eb083461$var$lastContextDependency = $4fcf5377eb083461$var$currentlyRenderingFiber$1 = null;
    $4fcf5377eb083461$var$ReactSharedInternals.H = prevDispatcher;
    $4fcf5377eb083461$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $4fcf5377eb083461$var$executionContext = prevExecutionContext;
    if (null !== $4fcf5377eb083461$var$workInProgress) return 0;
    $4fcf5377eb083461$var$workInProgressRoot = null;
    $4fcf5377eb083461$var$workInProgressRootRenderLanes = 0;
    $4fcf5377eb083461$var$finishQueueingConcurrentUpdates();
    return $4fcf5377eb083461$var$workInProgressRootExitStatus;
}
function $4fcf5377eb083461$var$workLoopConcurrentByScheduler() {
    for(; null !== $4fcf5377eb083461$var$workInProgress && !$4fcf5377eb083461$var$shouldYield();)$4fcf5377eb083461$var$performUnitOfWork($4fcf5377eb083461$var$workInProgress);
}
function $4fcf5377eb083461$var$performUnitOfWork(unitOfWork) {
    var next = $4fcf5377eb083461$var$beginWork(unitOfWork.alternate, unitOfWork, $4fcf5377eb083461$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $4fcf5377eb083461$var$completeUnitOfWork(unitOfWork) : $4fcf5377eb083461$var$workInProgress = next;
}
function $4fcf5377eb083461$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $4fcf5377eb083461$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $4fcf5377eb083461$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $4fcf5377eb083461$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $4fcf5377eb083461$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $4fcf5377eb083461$var$resetHooksOnUnwind(next);
            var fiber = next;
            fiber === $4fcf5377eb083461$var$hydrationParentFiber && ($4fcf5377eb083461$var$isHydrating ? ($4fcf5377eb083461$var$popToNextHostParent(fiber), 5 === fiber.tag && null != fiber.stateNode && ($4fcf5377eb083461$var$nextHydratableInstance = fiber.stateNode)) : ($4fcf5377eb083461$var$popToNextHostParent(fiber), $4fcf5377eb083461$var$isHydrating = !0));
        default:
            $4fcf5377eb083461$var$unwindInterruptedWork(current, next), next = $4fcf5377eb083461$var$workInProgress = $4fcf5377eb083461$var$resetWorkInProgress(next, $4fcf5377eb083461$var$entangledRenderLanes), next = $4fcf5377eb083461$var$beginWork(current, next, $4fcf5377eb083461$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $4fcf5377eb083461$var$completeUnitOfWork(unitOfWork) : $4fcf5377eb083461$var$workInProgress = next;
}
function $4fcf5377eb083461$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $4fcf5377eb083461$var$lastContextDependency = $4fcf5377eb083461$var$currentlyRenderingFiber$1 = null;
    $4fcf5377eb083461$var$resetHooksOnUnwind(unitOfWork);
    $4fcf5377eb083461$var$thenableState$1 = null;
    $4fcf5377eb083461$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($4fcf5377eb083461$var$throwException(root, returnFiber, unitOfWork, thrownValue, $4fcf5377eb083461$var$workInProgressRootRenderLanes)) {
            $4fcf5377eb083461$var$workInProgressRootExitStatus = 1;
            $4fcf5377eb083461$var$logUncaughtError(root, $4fcf5377eb083461$var$createCapturedValueAtFiber(thrownValue, root.current));
            $4fcf5377eb083461$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $4fcf5377eb083461$var$workInProgress = returnFiber, error;
        $4fcf5377eb083461$var$workInProgressRootExitStatus = 1;
        $4fcf5377eb083461$var$logUncaughtError(root, $4fcf5377eb083461$var$createCapturedValueAtFiber(thrownValue, root.current));
        $4fcf5377eb083461$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($4fcf5377eb083461$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($4fcf5377eb083461$var$workInProgressRootIsPrerendering || 0 !== ($4fcf5377eb083461$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($4fcf5377eb083461$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $4fcf5377eb083461$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $4fcf5377eb083461$var$unwindUnitOfWork(unitOfWork, root);
    } else $4fcf5377eb083461$var$completeUnitOfWork(unitOfWork);
}
function $4fcf5377eb083461$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $4fcf5377eb083461$var$unwindUnitOfWork(completedWork, $4fcf5377eb083461$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $4fcf5377eb083461$var$completeWork(completedWork.alternate, completedWork, $4fcf5377eb083461$var$entangledRenderLanes);
        if (null !== next) {
            $4fcf5377eb083461$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $4fcf5377eb083461$var$workInProgress = completedWork;
            return;
        }
        $4fcf5377eb083461$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $4fcf5377eb083461$var$workInProgressRootExitStatus && ($4fcf5377eb083461$var$workInProgressRootExitStatus = 5);
}
function $4fcf5377eb083461$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $4fcf5377eb083461$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $4fcf5377eb083461$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $4fcf5377eb083461$var$workInProgress = unitOfWork;
            return;
        }
        $4fcf5377eb083461$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $4fcf5377eb083461$var$workInProgressRootExitStatus = 6;
    $4fcf5377eb083461$var$workInProgress = null;
}
function $4fcf5377eb083461$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState) {
    root.cancelPendingCommit = null;
    do $4fcf5377eb083461$var$flushPendingEffects();
    while (0 !== $4fcf5377eb083461$var$pendingEffectsStatus);
    if (0 !== ($4fcf5377eb083461$var$executionContext & 6)) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(177));
        root === $4fcf5377eb083461$var$workInProgressRoot && ($4fcf5377eb083461$var$workInProgress = $4fcf5377eb083461$var$workInProgressRoot = null, $4fcf5377eb083461$var$workInProgressRootRenderLanes = 0);
        $4fcf5377eb083461$var$pendingFinishedWork = finishedWork;
        $4fcf5377eb083461$var$pendingEffectsRoot = root;
        $4fcf5377eb083461$var$pendingEffectsLanes = lanes;
        $4fcf5377eb083461$var$pendingPassiveTransitions = transitions;
        $4fcf5377eb083461$var$pendingRecoverableErrors = recoverableErrors;
        $4fcf5377eb083461$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState);
    }
}
function $4fcf5377eb083461$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState) {
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    $4fcf5377eb083461$var$pendingEffectsRemainingLanes = remainingLanes;
    remainingLanes |= $4fcf5377eb083461$var$concurrentlyUpdatedLanes;
    $4fcf5377eb083461$var$markRootFinished(root, lanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    $4fcf5377eb083461$var$pendingViewTransitionEvents = null;
    (lanes & 335544064) === lanes ? ($4fcf5377eb083461$var$pendingTransitionTypes = $4fcf5377eb083461$var$claimQueuedTransitionTypes(root), spawnedLane = 10262) : ($4fcf5377eb083461$var$pendingTransitionTypes = null, spawnedLane = 10256);
    0 !== (finishedWork.subtreeFlags & spawnedLane) || 0 !== (finishedWork.flags & spawnedLane) ? (root.callbackNode = null, root.callbackPriority = 0, $4fcf5377eb083461$var$scheduleCallback$1($4fcf5377eb083461$var$NormalPriority$1, function() {
        $4fcf5377eb083461$var$flushPassiveEffects();
        return null;
    })) : (root.callbackNode = null, root.callbackPriority = 0);
    $4fcf5377eb083461$var$shouldStartViewTransition = !1;
    spawnedLane = 0 !== (finishedWork.flags & 13878);
    if (0 !== (finishedWork.subtreeFlags & 13878) || spawnedLane) {
        spawnedLane = $4fcf5377eb083461$var$ReactSharedInternals.T;
        $4fcf5377eb083461$var$ReactSharedInternals.T = null;
        updatedLanes = $4fcf5377eb083461$var$ReactDOMSharedInternals.p;
        $4fcf5377eb083461$var$ReactDOMSharedInternals.p = 2;
        suspendedRetryLanes = $4fcf5377eb083461$var$executionContext;
        $4fcf5377eb083461$var$executionContext |= 4;
        try {
            $4fcf5377eb083461$var$commitBeforeMutationEffects(root, finishedWork, lanes);
        } finally{
            $4fcf5377eb083461$var$executionContext = suspendedRetryLanes, $4fcf5377eb083461$var$ReactDOMSharedInternals.p = updatedLanes, $4fcf5377eb083461$var$ReactSharedInternals.T = spawnedLane;
        }
    }
    $4fcf5377eb083461$var$pendingEffectsStatus = 1;
    $4fcf5377eb083461$var$shouldStartViewTransition ? $4fcf5377eb083461$var$pendingViewTransition = $4fcf5377eb083461$var$startViewTransition(suspendedState, root.containerInfo, $4fcf5377eb083461$var$pendingTransitionTypes, $4fcf5377eb083461$var$flushMutationEffects, $4fcf5377eb083461$var$flushLayoutEffects, $4fcf5377eb083461$var$flushAfterMutationEffects, $4fcf5377eb083461$var$flushSpawnedWork, $4fcf5377eb083461$var$flushPassiveEffects, $4fcf5377eb083461$var$reportViewTransitionError, null, null) : ($4fcf5377eb083461$var$flushMutationEffects(), $4fcf5377eb083461$var$flushLayoutEffects(), $4fcf5377eb083461$var$flushSpawnedWork());
}
function $4fcf5377eb083461$var$reportViewTransitionError(error) {
    if (0 !== $4fcf5377eb083461$var$pendingEffectsStatus) {
        var onRecoverableError = $4fcf5377eb083461$var$pendingEffectsRoot.onRecoverableError;
        onRecoverableError(error, {
            componentStack: null
        });
    }
}
function $4fcf5377eb083461$var$flushAfterMutationEffects() {
    3 === $4fcf5377eb083461$var$pendingEffectsStatus && ($4fcf5377eb083461$var$pendingEffectsStatus = 0, $4fcf5377eb083461$var$commitAfterMutationEffectsOnFiber($4fcf5377eb083461$var$pendingFinishedWork, $4fcf5377eb083461$var$pendingEffectsRoot), $4fcf5377eb083461$var$pendingEffectsStatus = 4);
}
function $4fcf5377eb083461$var$flushMutationEffects() {
    if (1 === $4fcf5377eb083461$var$pendingEffectsStatus) {
        $4fcf5377eb083461$var$pendingEffectsStatus = 0;
        var root = $4fcf5377eb083461$var$pendingEffectsRoot, finishedWork = $4fcf5377eb083461$var$pendingFinishedWork, lanes = $4fcf5377eb083461$var$pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $4fcf5377eb083461$var$ReactSharedInternals.T;
            $4fcf5377eb083461$var$ReactSharedInternals.T = null;
            var previousPriority = $4fcf5377eb083461$var$ReactDOMSharedInternals.p;
            $4fcf5377eb083461$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $4fcf5377eb083461$var$executionContext;
            $4fcf5377eb083461$var$executionContext |= 4;
            try {
                $4fcf5377eb083461$var$inUpdateViewTransition = $4fcf5377eb083461$var$rootViewTransitionAffected = !1;
                $4fcf5377eb083461$var$commitMutationEffectsOnFiber(finishedWork, root, lanes);
                lanes = $4fcf5377eb083461$var$selectionInformation;
                var curFocusedElem = $4fcf5377eb083461$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $4fcf5377eb083461$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $4fcf5377eb083461$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $4fcf5377eb083461$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $4fcf5377eb083461$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $4fcf5377eb083461$var$_enabled = !!$4fcf5377eb083461$var$eventsEnabled;
                $4fcf5377eb083461$var$selectionInformation = $4fcf5377eb083461$var$eventsEnabled = null;
            } finally{
                $4fcf5377eb083461$var$executionContext = prevExecutionContext, $4fcf5377eb083461$var$ReactDOMSharedInternals.p = previousPriority, $4fcf5377eb083461$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $4fcf5377eb083461$var$pendingEffectsStatus = 2;
    }
}
function $4fcf5377eb083461$var$flushLayoutEffects() {
    if (2 === $4fcf5377eb083461$var$pendingEffectsStatus) {
        $4fcf5377eb083461$var$pendingEffectsStatus = 0;
        var root = $4fcf5377eb083461$var$pendingEffectsRoot, finishedWork = $4fcf5377eb083461$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $4fcf5377eb083461$var$ReactSharedInternals.T;
            $4fcf5377eb083461$var$ReactSharedInternals.T = null;
            var previousPriority = $4fcf5377eb083461$var$ReactDOMSharedInternals.p;
            $4fcf5377eb083461$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $4fcf5377eb083461$var$executionContext;
            $4fcf5377eb083461$var$executionContext |= 4;
            try {
                $4fcf5377eb083461$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $4fcf5377eb083461$var$executionContext = prevExecutionContext, $4fcf5377eb083461$var$ReactDOMSharedInternals.p = previousPriority, $4fcf5377eb083461$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $4fcf5377eb083461$var$pendingEffectsStatus = 3;
    }
}
function $4fcf5377eb083461$var$flushSpawnedWork() {
    if (4 === $4fcf5377eb083461$var$pendingEffectsStatus || 3 === $4fcf5377eb083461$var$pendingEffectsStatus) {
        $4fcf5377eb083461$var$pendingEffectsStatus = 0;
        var committedViewTransition = $4fcf5377eb083461$var$pendingViewTransition;
        $4fcf5377eb083461$var$pendingViewTransition = null;
        $4fcf5377eb083461$var$requestPaint();
        var root = $4fcf5377eb083461$var$pendingEffectsRoot, finishedWork = $4fcf5377eb083461$var$pendingFinishedWork, lanes = $4fcf5377eb083461$var$pendingEffectsLanes, recoverableErrors = $4fcf5377eb083461$var$pendingRecoverableErrors, passiveSubtreeMask = (lanes & 335544064) === lanes ? 10262 : 10256;
        0 !== (finishedWork.subtreeFlags & passiveSubtreeMask) || 0 !== (finishedWork.flags & passiveSubtreeMask) ? $4fcf5377eb083461$var$pendingEffectsStatus = 5 : ($4fcf5377eb083461$var$pendingEffectsStatus = 0, $4fcf5377eb083461$var$pendingFinishedWork = $4fcf5377eb083461$var$pendingEffectsRoot = null, $4fcf5377eb083461$var$releaseRootPooledCache(root, root.pendingLanes));
        passiveSubtreeMask = root.pendingLanes;
        0 === passiveSubtreeMask && ($4fcf5377eb083461$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $4fcf5377eb083461$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($4fcf5377eb083461$var$injectedHook && "function" === typeof $4fcf5377eb083461$var$injectedHook.onCommitFiberRoot) try {
            $4fcf5377eb083461$var$injectedHook.onCommitFiberRoot($4fcf5377eb083461$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $4fcf5377eb083461$var$ReactSharedInternals.T;
            passiveSubtreeMask = $4fcf5377eb083461$var$ReactDOMSharedInternals.p;
            $4fcf5377eb083461$var$ReactDOMSharedInternals.p = 2;
            $4fcf5377eb083461$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $4fcf5377eb083461$var$ReactSharedInternals.T = finishedWork, $4fcf5377eb083461$var$ReactDOMSharedInternals.p = passiveSubtreeMask;
            }
        }
        recoverableErrors = $4fcf5377eb083461$var$pendingViewTransitionEvents;
        onRecoverableError = $4fcf5377eb083461$var$pendingTransitionTypes;
        $4fcf5377eb083461$var$pendingTransitionTypes = null;
        if (null !== recoverableErrors && ($4fcf5377eb083461$var$pendingViewTransitionEvents = null, null === onRecoverableError && (onRecoverableError = []), null !== committedViewTransition)) for(recoverableError = 0; recoverableError < recoverableErrors.length; recoverableError++)finishedWork = (0, recoverableErrors[recoverableError])(onRecoverableError), void 0 !== finishedWork && committedViewTransition.finished.finally(finishedWork);
        0 !== ($4fcf5377eb083461$var$pendingEffectsLanes & 3) && $4fcf5377eb083461$var$flushPendingEffects();
        $4fcf5377eb083461$var$ensureRootIsScheduled(root);
        passiveSubtreeMask = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (passiveSubtreeMask & 42) ? root === $4fcf5377eb083461$var$rootWithNestedUpdates ? $4fcf5377eb083461$var$nestedUpdateCount++ : ($4fcf5377eb083461$var$nestedUpdateCount = 0, $4fcf5377eb083461$var$rootWithNestedUpdates = root) : ($4fcf5377eb083461$var$nestedUpdateCount = 0, $4fcf5377eb083461$var$rootWithNestedUpdates = null);
        $4fcf5377eb083461$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $4fcf5377eb083461$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $4fcf5377eb083461$var$releaseCache(remainingLanes)));
}
function $4fcf5377eb083461$var$flushPendingEffects() {
    null !== $4fcf5377eb083461$var$pendingViewTransition && ($4fcf5377eb083461$var$pendingViewTransition.skipTransition(), $4fcf5377eb083461$var$pendingViewTransition = null);
    $4fcf5377eb083461$var$flushMutationEffects();
    $4fcf5377eb083461$var$flushLayoutEffects();
    $4fcf5377eb083461$var$flushSpawnedWork();
    return $4fcf5377eb083461$var$flushPassiveEffects();
}
function $4fcf5377eb083461$var$flushPassiveEffects() {
    if (5 !== $4fcf5377eb083461$var$pendingEffectsStatus) return !1;
    var root = $4fcf5377eb083461$var$pendingEffectsRoot, remainingLanes = $4fcf5377eb083461$var$pendingEffectsRemainingLanes;
    $4fcf5377eb083461$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $4fcf5377eb083461$var$lanesToEventPriority($4fcf5377eb083461$var$pendingEffectsLanes), prevTransition = $4fcf5377eb083461$var$ReactSharedInternals.T, previousPriority = $4fcf5377eb083461$var$ReactDOMSharedInternals.p;
    try {
        $4fcf5377eb083461$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $4fcf5377eb083461$var$ReactSharedInternals.T = null;
        renderPriority = $4fcf5377eb083461$var$pendingPassiveTransitions;
        $4fcf5377eb083461$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $4fcf5377eb083461$var$pendingEffectsRoot, lanes = $4fcf5377eb083461$var$pendingEffectsLanes;
        $4fcf5377eb083461$var$pendingEffectsStatus = 0;
        $4fcf5377eb083461$var$pendingFinishedWork = $4fcf5377eb083461$var$pendingEffectsRoot = null;
        $4fcf5377eb083461$var$pendingEffectsLanes = 0;
        if (0 !== ($4fcf5377eb083461$var$executionContext & 6)) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(331));
        var prevExecutionContext = $4fcf5377eb083461$var$executionContext;
        $4fcf5377eb083461$var$executionContext |= 4;
        $4fcf5377eb083461$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $4fcf5377eb083461$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $4fcf5377eb083461$var$executionContext = prevExecutionContext;
        $4fcf5377eb083461$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($4fcf5377eb083461$var$injectedHook && "function" === typeof $4fcf5377eb083461$var$injectedHook.onPostCommitFiberRoot) try {
            $4fcf5377eb083461$var$injectedHook.onPostCommitFiberRoot($4fcf5377eb083461$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $4fcf5377eb083461$var$ReactDOMSharedInternals.p = previousPriority, $4fcf5377eb083461$var$ReactSharedInternals.T = prevTransition, $4fcf5377eb083461$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $4fcf5377eb083461$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $4fcf5377eb083461$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $4fcf5377eb083461$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $4fcf5377eb083461$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($4fcf5377eb083461$var$markRootUpdated$1(rootFiber, 2), $4fcf5377eb083461$var$ensureRootIsScheduled(rootFiber));
}
function $4fcf5377eb083461$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $4fcf5377eb083461$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $4fcf5377eb083461$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $4fcf5377eb083461$var$legacyErrorBoundariesThatAlreadyFailed || !$4fcf5377eb083461$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $4fcf5377eb083461$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $4fcf5377eb083461$var$createClassErrorUpdate(2);
                instance = $4fcf5377eb083461$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($4fcf5377eb083461$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $4fcf5377eb083461$var$markRootUpdated$1(instance, 2), $4fcf5377eb083461$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $4fcf5377eb083461$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $4fcf5377eb083461$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($4fcf5377eb083461$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $4fcf5377eb083461$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $4fcf5377eb083461$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $4fcf5377eb083461$var$workInProgressRoot === root && ($4fcf5377eb083461$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $4fcf5377eb083461$var$workInProgressRootExitStatus || 3 === $4fcf5377eb083461$var$workInProgressRootExitStatus && ($4fcf5377eb083461$var$workInProgressRootRenderLanes & 62914560) === $4fcf5377eb083461$var$workInProgressRootRenderLanes && 300 > $4fcf5377eb083461$var$now() - $4fcf5377eb083461$var$globalMostRecentFallbackTime ? 0 === ($4fcf5377eb083461$var$executionContext & 2) ? $4fcf5377eb083461$var$prepareFreshStack(root, 0) : $4fcf5377eb083461$var$workInProgressRootPingedLanes |= pingedLanes : $4fcf5377eb083461$var$workInProgressRootPingedLanes |= pingedLanes, $4fcf5377eb083461$var$workInProgressSuspendedRetryLanes === $4fcf5377eb083461$var$workInProgressRootRenderLanes && ($4fcf5377eb083461$var$workInProgressSuspendedRetryLanes = 0));
    $4fcf5377eb083461$var$ensureRootIsScheduled(root);
}
function $4fcf5377eb083461$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $4fcf5377eb083461$var$claimNextRetryLane());
    boundaryFiber = $4fcf5377eb083461$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($4fcf5377eb083461$var$markRootUpdated$1(boundaryFiber, retryLane), $4fcf5377eb083461$var$ensureRootIsScheduled(boundaryFiber));
}
function $4fcf5377eb083461$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $4fcf5377eb083461$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $4fcf5377eb083461$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($4fcf5377eb083461$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $4fcf5377eb083461$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $4fcf5377eb083461$var$scheduleCallback$1(priorityLevel, callback) {
    return $4fcf5377eb083461$var$scheduleCallback$3(priorityLevel, callback);
}
var $4fcf5377eb083461$var$firstScheduledRoot = null, $4fcf5377eb083461$var$lastScheduledRoot = null, $4fcf5377eb083461$var$didScheduleMicrotask = !1, $4fcf5377eb083461$var$mightHavePendingSyncWork = !1, $4fcf5377eb083461$var$isFlushingWork = !1, $4fcf5377eb083461$var$currentEventTransitionLane = 0;
function $4fcf5377eb083461$var$ensureRootIsScheduled(root) {
    root !== $4fcf5377eb083461$var$lastScheduledRoot && null === root.next && (null === $4fcf5377eb083461$var$lastScheduledRoot ? $4fcf5377eb083461$var$firstScheduledRoot = $4fcf5377eb083461$var$lastScheduledRoot = root : $4fcf5377eb083461$var$lastScheduledRoot = $4fcf5377eb083461$var$lastScheduledRoot.next = root);
    $4fcf5377eb083461$var$mightHavePendingSyncWork = !0;
    $4fcf5377eb083461$var$didScheduleMicrotask || ($4fcf5377eb083461$var$didScheduleMicrotask = !0, $4fcf5377eb083461$var$scheduleImmediateRootScheduleTask());
}
function $4fcf5377eb083461$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$4fcf5377eb083461$var$isFlushingWork && $4fcf5377eb083461$var$mightHavePendingSyncWork) {
        $4fcf5377eb083461$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$190 = $4fcf5377eb083461$var$firstScheduledRoot; null !== root$190;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$190.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$190.suspendedLanes, pingedLanes = root$190.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $4fcf5377eb083461$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $4fcf5377eb083461$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $4fcf5377eb083461$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $4fcf5377eb083461$var$getNextLanes(root$190, root$190 === $4fcf5377eb083461$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$190.cancelPendingCommit || -1 !== root$190.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $4fcf5377eb083461$var$checkIfRootIsPrerendering(root$190, JSCompiler_inline_result) || (didPerformSomeWork = !0, $4fcf5377eb083461$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                }
                root$190 = root$190.next;
            }
        }while (didPerformSomeWork);
        $4fcf5377eb083461$var$isFlushingWork = !1;
    }
}
function $4fcf5377eb083461$var$processRootScheduleInImmediateTask() {
    $4fcf5377eb083461$var$processRootScheduleInMicrotask();
}
function $4fcf5377eb083461$var$processRootScheduleInMicrotask() {
    $4fcf5377eb083461$var$mightHavePendingSyncWork = $4fcf5377eb083461$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $4fcf5377eb083461$var$currentEventTransitionLane && $4fcf5377eb083461$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $4fcf5377eb083461$var$currentEventTransitionLane);
    for(var currentTime = $4fcf5377eb083461$var$now(), prev = null, root = $4fcf5377eb083461$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $4fcf5377eb083461$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $4fcf5377eb083461$var$firstScheduledRoot = next : prev.next = next, null === next && ($4fcf5377eb083461$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $4fcf5377eb083461$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $4fcf5377eb083461$var$pendingEffectsStatus && 5 !== $4fcf5377eb083461$var$pendingEffectsStatus || $4fcf5377eb083461$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $4fcf5377eb083461$var$currentEventTransitionLane && ($4fcf5377eb083461$var$currentEventTransitionLane = 0);
}
function $4fcf5377eb083461$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $4fcf5377eb083461$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $4fcf5377eb083461$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $4fcf5377eb083461$var$workInProgressRoot;
    suspendedLanes = $4fcf5377eb083461$var$workInProgressRootRenderLanes;
    suspendedLanes = $4fcf5377eb083461$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $4fcf5377eb083461$var$workInProgressSuspendedReason || 9 === $4fcf5377eb083461$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $4fcf5377eb083461$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $4fcf5377eb083461$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $4fcf5377eb083461$var$cancelCallback$1(pingedLanes);
        switch($4fcf5377eb083461$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $4fcf5377eb083461$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $4fcf5377eb083461$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $4fcf5377eb083461$var$IdlePriority;
                break;
            default:
                suspendedLanes = $4fcf5377eb083461$var$NormalPriority$1;
        }
        pingedLanes = $4fcf5377eb083461$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $4fcf5377eb083461$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $4fcf5377eb083461$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $4fcf5377eb083461$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $4fcf5377eb083461$var$pendingEffectsStatus && 5 !== $4fcf5377eb083461$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($4fcf5377eb083461$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $4fcf5377eb083461$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $4fcf5377eb083461$var$getNextLanes(root, root === $4fcf5377eb083461$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $4fcf5377eb083461$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $4fcf5377eb083461$var$scheduleTaskForRootDuringMicrotask(root, $4fcf5377eb083461$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $4fcf5377eb083461$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $4fcf5377eb083461$var$performSyncWorkOnRoot(root, lanes) {
    if ($4fcf5377eb083461$var$flushPendingEffects()) return null;
    $4fcf5377eb083461$var$performWorkOnRoot(root, lanes, !0);
}
function $4fcf5377eb083461$var$scheduleImmediateRootScheduleTask() {
    $4fcf5377eb083461$var$scheduleMicrotask(function() {
        0 !== ($4fcf5377eb083461$var$executionContext & 6) ? $4fcf5377eb083461$var$scheduleCallback$3($4fcf5377eb083461$var$ImmediatePriority, $4fcf5377eb083461$var$processRootScheduleInImmediateTask) : $4fcf5377eb083461$var$processRootScheduleInMicrotask();
    });
}
function $4fcf5377eb083461$var$requestTransitionLane() {
    if (0 === $4fcf5377eb083461$var$currentEventTransitionLane) {
        var actionScopeLane = $4fcf5377eb083461$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $4fcf5377eb083461$var$nextTransitionUpdateLane, $4fcf5377eb083461$var$nextTransitionUpdateLane <<= 1, 0 === ($4fcf5377eb083461$var$nextTransitionUpdateLane & 261888) && ($4fcf5377eb083461$var$nextTransitionUpdateLane = 256));
        $4fcf5377eb083461$var$currentEventTransitionLane = actionScopeLane;
    }
    return $4fcf5377eb083461$var$currentEventTransitionLane;
}
function $4fcf5377eb083461$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $4fcf5377eb083461$var$sanitizeURL(actionProp);
}
function $4fcf5377eb083461$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $4fcf5377eb083461$var$coerceFormActionProp((nativeEventTarget[$4fcf5377eb083461$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$4fcf5377eb083461$var$internalPropsKey] || null) ? $4fcf5377eb083461$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $4fcf5377eb083461$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $4fcf5377eb083461$var$currentEventTransitionLane) {
                                var formData = new FormData(nativeEventTarget, submitter);
                                $4fcf5377eb083461$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = new FormData(nativeEventTarget, submitter), $4fcf5377eb083461$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $4fcf5377eb083461$var$i$jscomp$inline_1667 = 0; $4fcf5377eb083461$var$i$jscomp$inline_1667 < $4fcf5377eb083461$var$simpleEventPluginEvents.length; $4fcf5377eb083461$var$i$jscomp$inline_1667++){
    var $4fcf5377eb083461$var$eventName$jscomp$inline_1668 = $4fcf5377eb083461$var$simpleEventPluginEvents[$4fcf5377eb083461$var$i$jscomp$inline_1667], $4fcf5377eb083461$var$domEventName$jscomp$inline_1669 = $4fcf5377eb083461$var$eventName$jscomp$inline_1668.toLowerCase(), $4fcf5377eb083461$var$capitalizedEvent$jscomp$inline_1670 = $4fcf5377eb083461$var$eventName$jscomp$inline_1668[0].toUpperCase() + $4fcf5377eb083461$var$eventName$jscomp$inline_1668.slice(1);
    $4fcf5377eb083461$var$registerSimpleEvent($4fcf5377eb083461$var$domEventName$jscomp$inline_1669, "on" + $4fcf5377eb083461$var$capitalizedEvent$jscomp$inline_1670);
}
$4fcf5377eb083461$var$registerSimpleEvent($4fcf5377eb083461$var$ANIMATION_END, "onAnimationEnd");
$4fcf5377eb083461$var$registerSimpleEvent($4fcf5377eb083461$var$ANIMATION_ITERATION, "onAnimationIteration");
$4fcf5377eb083461$var$registerSimpleEvent($4fcf5377eb083461$var$ANIMATION_START, "onAnimationStart");
$4fcf5377eb083461$var$registerSimpleEvent("dblclick", "onDoubleClick");
$4fcf5377eb083461$var$registerSimpleEvent("focusin", "onFocus");
$4fcf5377eb083461$var$registerSimpleEvent("focusout", "onBlur");
$4fcf5377eb083461$var$registerSimpleEvent($4fcf5377eb083461$var$TRANSITION_RUN, "onTransitionRun");
$4fcf5377eb083461$var$registerSimpleEvent($4fcf5377eb083461$var$TRANSITION_START, "onTransitionStart");
$4fcf5377eb083461$var$registerSimpleEvent($4fcf5377eb083461$var$TRANSITION_CANCEL, "onTransitionCancel");
$4fcf5377eb083461$var$registerSimpleEvent($4fcf5377eb083461$var$TRANSITION_END, "onTransitionEnd");
$4fcf5377eb083461$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$4fcf5377eb083461$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$4fcf5377eb083461$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$4fcf5377eb083461$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$4fcf5377eb083461$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$4fcf5377eb083461$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$4fcf5377eb083461$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$4fcf5377eb083461$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$4fcf5377eb083461$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$4fcf5377eb083461$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $4fcf5377eb083461$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $4fcf5377eb083461$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($4fcf5377eb083461$var$mediaEventTypes));
function $4fcf5377eb083461$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $4fcf5377eb083461$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $4fcf5377eb083461$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $4fcf5377eb083461$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$4fcf5377eb083461$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$4fcf5377eb083461$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($4fcf5377eb083461$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $4fcf5377eb083461$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $4fcf5377eb083461$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $4fcf5377eb083461$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $4fcf5377eb083461$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$4fcf5377eb083461$var$listeningMarker]) {
        rootContainerElement[$4fcf5377eb083461$var$listeningMarker] = !0;
        $4fcf5377eb083461$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($4fcf5377eb083461$var$nonDelegatedEvents.has(domEventName) || $4fcf5377eb083461$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $4fcf5377eb083461$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$4fcf5377eb083461$var$listeningMarker] || (ownerDocument[$4fcf5377eb083461$var$listeningMarker] = !0, $4fcf5377eb083461$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $4fcf5377eb083461$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($4fcf5377eb083461$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $4fcf5377eb083461$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $4fcf5377eb083461$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $4fcf5377eb083461$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$4fcf5377eb083461$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $4fcf5377eb083461$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $4fcf5377eb083461$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $4fcf5377eb083461$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $4fcf5377eb083461$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $4fcf5377eb083461$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $4fcf5377eb083461$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $4fcf5377eb083461$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $4fcf5377eb083461$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $4fcf5377eb083461$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $4fcf5377eb083461$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $4fcf5377eb083461$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $4fcf5377eb083461$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $4fcf5377eb083461$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $4fcf5377eb083461$var$SyntheticTouchEvent;
                        break;
                    case $4fcf5377eb083461$var$ANIMATION_END:
                    case $4fcf5377eb083461$var$ANIMATION_ITERATION:
                    case $4fcf5377eb083461$var$ANIMATION_START:
                        SyntheticEventCtor = $4fcf5377eb083461$var$SyntheticAnimationEvent;
                        break;
                    case $4fcf5377eb083461$var$TRANSITION_END:
                        SyntheticEventCtor = $4fcf5377eb083461$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $4fcf5377eb083461$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $4fcf5377eb083461$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $4fcf5377eb083461$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $4fcf5377eb083461$var$SyntheticPointerEvent;
                        break;
                    case "submit":
                        SyntheticEventCtor = $4fcf5377eb083461$var$SyntheticSubmitEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $4fcf5377eb083461$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $4fcf5377eb083461$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($4fcf5377eb083461$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                SyntheticEventCtor = "mouseover" === domEventName || "pointerover" === domEventName;
                reactName = "mouseout" === domEventName || "pointerout" === domEventName;
                if (SyntheticEventCtor && nativeEvent !== $4fcf5377eb083461$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($4fcf5377eb083461$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$4fcf5377eb083461$var$internalContainerInstanceKey])) break a;
                if (reactName || SyntheticEventCtor) {
                    reactEventType = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (SyntheticEventCtor = nativeEventTarget.ownerDocument) ? SyntheticEventCtor.defaultView || SyntheticEventCtor.parentWindow : window;
                    if (reactName) {
                        if (SyntheticEventCtor = nativeEvent.relatedTarget || nativeEvent.toElement, reactName = targetInst, SyntheticEventCtor = SyntheticEventCtor ? $4fcf5377eb083461$var$getClosestInstanceFromNode(SyntheticEventCtor) : null, null !== SyntheticEventCtor && (accumulateTargetOnly = $4fcf5377eb083461$var$getNearestMountedFiber(SyntheticEventCtor), inCapturePhase = SyntheticEventCtor.tag, SyntheticEventCtor !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) SyntheticEventCtor = null;
                    } else reactName = null, SyntheticEventCtor = targetInst;
                    if (reactName !== SyntheticEventCtor) {
                        inCapturePhase = $4fcf5377eb083461$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $4fcf5377eb083461$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == reactName ? reactEventType : $4fcf5377eb083461$var$getNodeFromInstance(reactName);
                        lastHostComponent = null == SyntheticEventCtor ? reactEventType : $4fcf5377eb083461$var$getNodeFromInstance(SyntheticEventCtor);
                        reactEventType = new inCapturePhase(_instance, instance + "leave", reactName, nativeEvent, nativeEventTarget);
                        reactEventType.target = accumulateTargetOnly;
                        reactEventType.relatedTarget = lastHostComponent;
                        _instance = null;
                        $4fcf5377eb083461$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", SyntheticEventCtor, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        inCapturePhase = reactName && SyntheticEventCtor ? $4fcf5377eb083461$var$getLowestCommonAncestor(reactName, SyntheticEventCtor, $4fcf5377eb083461$var$getParent) : null;
                        null !== reactName && $4fcf5377eb083461$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactEventType, reactName, inCapturePhase, !1);
                        null !== SyntheticEventCtor && null !== accumulateTargetOnly && $4fcf5377eb083461$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, SyntheticEventCtor, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $4fcf5377eb083461$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $4fcf5377eb083461$var$getTargetInstForChangeEvent;
                else if ($4fcf5377eb083461$var$isTextInputElement(reactName)) {
                    if ($4fcf5377eb083461$var$isInputEventSupported) getTargetInstFunc = $4fcf5377eb083461$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $4fcf5377eb083461$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $4fcf5377eb083461$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $4fcf5377eb083461$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $4fcf5377eb083461$var$getTargetInstForChangeEvent) : getTargetInstFunc = $4fcf5377eb083461$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $4fcf5377eb083461$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            }
            handleEventFunc = targetInst ? $4fcf5377eb083461$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($4fcf5377eb083461$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $4fcf5377eb083461$var$activeElement = handleEventFunc, $4fcf5377eb083461$var$activeElementInst = targetInst, $4fcf5377eb083461$var$lastSelection = null;
                    break;
                case "focusout":
                    $4fcf5377eb083461$var$lastSelection = $4fcf5377eb083461$var$activeElementInst = $4fcf5377eb083461$var$activeElement = null;
                    break;
                case "mousedown":
                    $4fcf5377eb083461$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $4fcf5377eb083461$var$mouseDown = !1;
                    $4fcf5377eb083461$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($4fcf5377eb083461$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $4fcf5377eb083461$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($4fcf5377eb083461$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $4fcf5377eb083461$var$isComposing ? $4fcf5377eb083461$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($4fcf5377eb083461$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($4fcf5377eb083461$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $4fcf5377eb083461$var$isComposing && (fallbackData = $4fcf5377eb083461$var$getData()) : ($4fcf5377eb083461$var$root = nativeEventTarget, $4fcf5377eb083461$var$startText = "value" in $4fcf5377eb083461$var$root ? $4fcf5377eb083461$var$root.value : $4fcf5377eb083461$var$root.textContent, $4fcf5377eb083461$var$isComposing = !0)), handleEventFunc = $4fcf5377eb083461$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $4fcf5377eb083461$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $4fcf5377eb083461$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $4fcf5377eb083461$var$canUseTextInputEvent ? $4fcf5377eb083461$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $4fcf5377eb083461$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $4fcf5377eb083461$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $4fcf5377eb083461$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $4fcf5377eb083461$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $4fcf5377eb083461$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $4fcf5377eb083461$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $4fcf5377eb083461$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $4fcf5377eb083461$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($4fcf5377eb083461$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $4fcf5377eb083461$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($4fcf5377eb083461$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $4fcf5377eb083461$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $4fcf5377eb083461$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $4fcf5377eb083461$var$getListener(target, registrationName), null != stateNode && listeners.unshift($4fcf5377eb083461$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $4fcf5377eb083461$var$getListener(target, registrationName), null != stateNode && listeners.push($4fcf5377eb083461$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $4fcf5377eb083461$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $4fcf5377eb083461$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $4fcf5377eb083461$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($4fcf5377eb083461$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($4fcf5377eb083461$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $4fcf5377eb083461$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $4fcf5377eb083461$var$normalizeMarkupForTextOrAttribute(clientText);
    return $4fcf5377eb083461$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $4fcf5377eb083461$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            if ("string" === typeof value) "body" === tag || "textarea" === tag && "" === value || $4fcf5377eb083461$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) "body" !== tag && $4fcf5377eb083461$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "className":
            $4fcf5377eb083461$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $4fcf5377eb083461$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $4fcf5377eb083461$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $4fcf5377eb083461$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "data":
            if ("object" !== tag) {
                $4fcf5377eb083461$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $4fcf5377eb083461$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $4fcf5377eb083461$var$setProp(domElement, tag, "name", props.name, props, null), $4fcf5377eb083461$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $4fcf5377eb083461$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $4fcf5377eb083461$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($4fcf5377eb083461$var$setProp(domElement, tag, "encType", props.encType, props, null), $4fcf5377eb083461$var$setProp(domElement, tag, "method", props.method, props, null), $4fcf5377eb083461$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $4fcf5377eb083461$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $4fcf5377eb083461$var$noop$1);
            return;
        case "onScroll":
            null != value && $4fcf5377eb083461$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $4fcf5377eb083461$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $4fcf5377eb083461$var$sanitizeURL(value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "credentialless":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("toggle", domElement);
            $4fcf5377eb083461$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $4fcf5377eb083461$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $4fcf5377eb083461$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $4fcf5377eb083461$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $4fcf5377eb083461$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $4fcf5377eb083461$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $4fcf5377eb083461$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $4fcf5377eb083461$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $4fcf5377eb083461$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $4fcf5377eb083461$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $4fcf5377eb083461$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $4fcf5377eb083461$var$aliases.get(key) || key, $4fcf5377eb083461$var$setValueForAttribute(domElement, key, value);
            else return;
    }
    $4fcf5377eb083461$var$viewTransitionMutationContext = !0;
}
function $4fcf5377eb083461$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $4fcf5377eb083461$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "children":
            if ("string" === typeof value) $4fcf5377eb083461$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) $4fcf5377eb083461$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "onScroll":
            null != value && $4fcf5377eb083461$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $4fcf5377eb083461$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "onClick":
            null != value && (domElement.onclick = $4fcf5377eb083461$var$noop$1);
            return;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            return;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!$4fcf5377eb083461$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), prevValue = key.slice(2, props ? key.length - 7 : void 0), tag = domElement[$4fcf5377eb083461$var$internalPropsKey] || null, tag = null != tag ? tag[key] : null, "function" === typeof tag && domElement.removeEventListener(prevValue, tag, props), "function" === typeof value)) {
                    "function" !== typeof tag && null !== tag && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(prevValue, value, props);
                    break a;
                }
                $4fcf5377eb083461$var$viewTransitionMutationContext = !0;
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $4fcf5377eb083461$var$setValueForAttribute(domElement, key, value);
            }
            return;
    }
    $4fcf5377eb083461$var$viewTransitionMutationContext = !0;
}
function $4fcf5377eb083461$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("error", domElement);
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($4fcf5377eb083461$var$formatProdErrorMessage(137, tag));
                    default:
                        $4fcf5377eb083461$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $4fcf5377eb083461$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $4fcf5377eb083461$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$204 = props[hasSrc];
                if (null != propValue$204) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$204;
                        break;
                    case "type":
                        propValue = propValue$204;
                        break;
                    case "checked":
                        checked = propValue$204;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$204;
                        break;
                    case "value":
                        propKey = propValue$204;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$204;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$204) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $4fcf5377eb083461$var$setProp(domElement, tag, hasSrc, propValue$204, props, null);
                }
            }
            $4fcf5377eb083461$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $4fcf5377eb083461$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $4fcf5377eb083461$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $4fcf5377eb083461$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(91));
                    break;
                default:
                    $4fcf5377eb083461$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $4fcf5377eb083461$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $4fcf5377eb083461$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("toggle", domElement);
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("cancel", domElement);
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $4fcf5377eb083461$var$mediaEventTypes.length; hasSrc++)$4fcf5377eb083461$var$listenToNonDelegatedEvent($4fcf5377eb083461$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("error", domElement);
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $4fcf5377eb083461$var$listenToNonDelegatedEvent("error", domElement), $4fcf5377eb083461$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($4fcf5377eb083461$var$formatProdErrorMessage(137, tag));
                default:
                    $4fcf5377eb083461$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($4fcf5377eb083461$var$isCustomElement(tag)) {
                for(propValue$204 in props)props.hasOwnProperty(propValue$204) && (hasSrc = props[propValue$204], void 0 !== hasSrc && $4fcf5377eb083461$var$setPropOnCustomElement(domElement, tag, propValue$204, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $4fcf5377eb083461$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
var $4fcf5377eb083461$var$emptyProps = {};
function $4fcf5377eb083461$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $4fcf5377eb083461$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$221 in nextProps){
                var propKey = nextProps[propKey$221];
                lastProp = lastProps[propKey$221];
                if (nextProps.hasOwnProperty(propKey$221) && (null != propKey || null != lastProp)) switch(propKey$221){
                    case "type":
                        propKey !== lastProp && ($4fcf5377eb083461$var$viewTransitionMutationContext = !0);
                        type = propKey;
                        break;
                    case "name":
                        propKey !== lastProp && ($4fcf5377eb083461$var$viewTransitionMutationContext = !0);
                        name = propKey;
                        break;
                    case "checked":
                        propKey !== lastProp && ($4fcf5377eb083461$var$viewTransitionMutationContext = !0);
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        propKey !== lastProp && ($4fcf5377eb083461$var$viewTransitionMutationContext = !0);
                        defaultChecked = propKey;
                        break;
                    case "value":
                        propKey !== lastProp && ($4fcf5377eb083461$var$viewTransitionMutationContext = !0);
                        value = propKey;
                        break;
                    case "defaultValue":
                        propKey !== lastProp && ($4fcf5377eb083461$var$viewTransitionMutationContext = !0);
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $4fcf5377eb083461$var$setProp(domElement, tag, propKey$221, propKey, nextProps, lastProp);
                }
            }
            $4fcf5377eb083461$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$221 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $4fcf5377eb083461$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    type !== lastDefaultValue && ($4fcf5377eb083461$var$viewTransitionMutationContext = !0);
                    propKey$221 = type;
                    break;
                case "defaultValue":
                    type !== lastDefaultValue && ($4fcf5377eb083461$var$viewTransitionMutationContext = !0);
                    defaultValue = type;
                    break;
                case "multiple":
                    type !== lastDefaultValue && ($4fcf5377eb083461$var$viewTransitionMutationContext = !0), value = type;
                default:
                    type !== lastDefaultValue && $4fcf5377eb083461$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$221 ? $4fcf5377eb083461$var$updateOptions(domElement, !!lastProps, propKey$221, !1) : !!nextProps !== !!lastProps && (null != tag ? $4fcf5377eb083461$var$updateOptions(domElement, !!lastProps, tag, !0) : $4fcf5377eb083461$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$221 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $4fcf5377eb083461$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    name !== type && ($4fcf5377eb083461$var$viewTransitionMutationContext = !0);
                    propKey$221 = name;
                    break;
                case "defaultValue":
                    name !== type && ($4fcf5377eb083461$var$viewTransitionMutationContext = !0);
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $4fcf5377eb083461$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $4fcf5377eb083461$var$updateTextarea(domElement, propKey$221, propKey);
            return;
        case "option":
            for(var propKey$237 in lastProps)if (propKey$221 = lastProps[propKey$237], lastProps.hasOwnProperty(propKey$237) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$237)) switch(propKey$237){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $4fcf5377eb083461$var$setProp(domElement, tag, propKey$237, null, nextProps, propKey$221);
            }
            for(lastDefaultValue in nextProps)if (propKey$221 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    propKey$221 !== propKey && ($4fcf5377eb083461$var$viewTransitionMutationContext = !0);
                    domElement.selected = propKey$221 && "function" !== typeof propKey$221 && "symbol" !== typeof propKey$221;
                    break;
                default:
                    $4fcf5377eb083461$var$setProp(domElement, tag, lastDefaultValue, propKey$221, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$242 in lastProps)propKey$221 = lastProps[propKey$242], lastProps.hasOwnProperty(propKey$242) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$242) && $4fcf5377eb083461$var$setProp(domElement, tag, propKey$242, null, nextProps, propKey$221);
            for(checked in nextProps)if (propKey$221 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$221) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $4fcf5377eb083461$var$setProp(domElement, tag, checked, propKey$221, nextProps, propKey);
            }
            return;
        default:
            if ($4fcf5377eb083461$var$isCustomElement(tag)) {
                for(var propKey$247 in lastProps)propKey$221 = lastProps[propKey$247], lastProps.hasOwnProperty(propKey$247) && void 0 !== propKey$221 && !nextProps.hasOwnProperty(propKey$247) && $4fcf5377eb083461$var$setPropOnCustomElement(domElement, tag, propKey$247, void 0, nextProps, propKey$221);
                for(defaultChecked in nextProps)propKey$221 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$221 === propKey || void 0 === propKey$221 && void 0 === propKey || $4fcf5377eb083461$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$221, nextProps, propKey);
                return;
            }
    }
    for(var propKey$252 in lastProps)propKey$221 = lastProps[propKey$252], lastProps.hasOwnProperty(propKey$252) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$252) && $4fcf5377eb083461$var$setProp(domElement, tag, propKey$252, null, nextProps, propKey$221);
    for(lastProp in nextProps)propKey$221 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$221 === propKey || null == propKey$221 && null == propKey || $4fcf5377eb083461$var$setProp(domElement, tag, lastProp, propKey$221, nextProps, propKey);
}
function $4fcf5377eb083461$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $4fcf5377eb083461$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $4fcf5377eb083461$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $4fcf5377eb083461$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $4fcf5377eb083461$var$eventsEnabled = null, $4fcf5377eb083461$var$selectionInformation = null;
function $4fcf5377eb083461$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $4fcf5377eb083461$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $4fcf5377eb083461$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $4fcf5377eb083461$var$createHoistableInstance(type, props, rootContainerInstance, internalInstanceHandle) {
    rootContainerInstance = $4fcf5377eb083461$var$getOwnerDocumentFromRootContainer(rootContainerInstance).createElement(type);
    rootContainerInstance[$4fcf5377eb083461$var$internalInstanceKey] = internalInstanceHandle;
    rootContainerInstance[$4fcf5377eb083461$var$internalPropsKey] = props;
    $4fcf5377eb083461$var$setInitialProperties(rootContainerInstance, type, props);
    $4fcf5377eb083461$var$markNodeAsHoistable(rootContainerInstance);
    return rootContainerInstance;
}
function $4fcf5377eb083461$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $4fcf5377eb083461$var$currentPopstateTransitionEvent = null;
function $4fcf5377eb083461$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $4fcf5377eb083461$var$currentPopstateTransitionEvent) return !1;
        $4fcf5377eb083461$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $4fcf5377eb083461$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $4fcf5377eb083461$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $4fcf5377eb083461$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $4fcf5377eb083461$var$localPromise = "function" === typeof Promise ? Promise : void 0, $4fcf5377eb083461$var$localRequestAnimationFrame = "function" === typeof requestAnimationFrame ? requestAnimationFrame : $4fcf5377eb083461$var$scheduleTimeout, $4fcf5377eb083461$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $4fcf5377eb083461$var$localPromise ? function(callback) {
    return $4fcf5377eb083461$var$localPromise.resolve(null).then(callback).catch($4fcf5377eb083461$var$handleErrorInNextTick);
} : $4fcf5377eb083461$var$scheduleTimeout;
function $4fcf5377eb083461$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $4fcf5377eb083461$var$isSingletonScope(type) {
    return "head" === type;
}
function $4fcf5377eb083461$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $4fcf5377eb083461$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $4fcf5377eb083461$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $4fcf5377eb083461$var$clearSingletonPreambleContribution(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$4fcf5377eb083461$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $4fcf5377eb083461$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $4fcf5377eb083461$var$retryIfBlockedOn(hydrationInstance);
}
function $4fcf5377eb083461$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $4fcf5377eb083461$var$applyViewTransitionName(instance, name, className) {
    name = CSS.escape(name) !== name ? "r-" + btoa(name).replace(/=/g, "") : name;
    instance.style.viewTransitionName = name;
    null != className && (instance.style.viewTransitionClass = className);
    className = getComputedStyle(instance);
    if ("inline" === className.display) {
        name = instance.getClientRects();
        if (1 === name.length) var JSCompiler_inline_result = 1;
        else for(var i = JSCompiler_inline_result = 0; i < name.length; i++){
            var rect = name[i];
            0 < rect.width && 0 < rect.height && JSCompiler_inline_result++;
        }
        1 === JSCompiler_inline_result && (instance = instance.style, instance.display = 1 === name.length ? "inline-block" : "block", instance.marginTop = "-" + className.paddingTop, instance.marginBottom = "-" + className.paddingBottom);
    }
}
function $4fcf5377eb083461$var$restoreViewTransitionName(instance, props) {
    instance = instance.style;
    props = props.style;
    var viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionName") ? props.viewTransitionName : props.hasOwnProperty("view-transition-name") ? props["view-transition-name"] : null : null;
    instance.viewTransitionName = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionClass") ? props.viewTransitionClass : props.hasOwnProperty("view-transition-class") ? props["view-transition-class"] : null : null;
    instance.viewTransitionClass = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    "inline-block" === instance.display && (null == props ? instance.display = instance.margin = "" : (viewTransitionName = props.display, instance.display = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, viewTransitionName = props.margin, null != viewTransitionName ? instance.margin = viewTransitionName : (viewTransitionName = props.hasOwnProperty("marginTop") ? props.marginTop : props["margin-top"], instance.marginTop = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, props = props.hasOwnProperty("marginBottom") ? props.marginBottom : props["margin-bottom"], instance.marginBottom = null == props || "boolean" === typeof props ? "" : props)));
}
function $4fcf5377eb083461$var$createMeasurement(rect, computedStyle, element) {
    element = element.ownerDocument.defaultView;
    return {
        rect: rect,
        abs: "absolute" === computedStyle.position || "fixed" === computedStyle.position,
        clip: "none" !== computedStyle.clipPath || "visible" !== computedStyle.overflow || "none" !== computedStyle.filter || "none" !== computedStyle.mask || "none" !== computedStyle.mask || "0px" !== computedStyle.borderRadius,
        view: 0 <= rect.bottom && 0 <= rect.right && rect.top <= element.innerHeight && rect.left <= element.innerWidth
    };
}
function $4fcf5377eb083461$var$measureInstance(instance) {
    var rect = instance.getBoundingClientRect(), computedStyle = getComputedStyle(instance);
    return $4fcf5377eb083461$var$createMeasurement(rect, computedStyle, instance);
}
function $4fcf5377eb083461$var$measureClonedInstance(instance) {
    var measuredRect = instance.getBoundingClientRect();
    measuredRect = new DOMRect(measuredRect.x + 2e4, measuredRect.y + 2e4, measuredRect.width, measuredRect.height);
    var computedStyle = getComputedStyle(instance);
    return $4fcf5377eb083461$var$createMeasurement(measuredRect, computedStyle, instance);
}
function $4fcf5377eb083461$var$forceLayout(ownerDocument) {
    return ownerDocument.documentElement.clientHeight;
}
function $4fcf5377eb083461$var$waitForImageToLoad(resolve) {
    this.addEventListener("load", resolve);
    this.addEventListener("error", resolve);
}
function $4fcf5377eb083461$var$startViewTransition(suspendedState, rootContainer, transitionTypes, mutationCallback, layoutCallback, afterMutationCallback, spawnedWorkCallback, passiveCallback, errorCallback) {
    var ownerDocument = 9 === rootContainer.nodeType ? rootContainer : rootContainer.ownerDocument;
    try {
        var transition = ownerDocument.startViewTransition({
            update: function() {
                var ownerWindow = ownerDocument.defaultView, pendingNavigation = ownerWindow.navigation && ownerWindow.navigation.transition, previousFontLoadingStatus = ownerDocument.fonts.status;
                mutationCallback();
                var blockingPromises = [];
                "loaded" === previousFontLoadingStatus && ($4fcf5377eb083461$var$forceLayout(ownerDocument), "loading" === ownerDocument.fonts.status && blockingPromises.push(ownerDocument.fonts.ready));
                previousFontLoadingStatus = blockingPromises.length;
                if (null !== suspendedState) for(var suspenseyImages = suspendedState.suspenseyImages, imgBytes = 0, i = 0; i < suspenseyImages.length; i++){
                    var suspenseyImage = suspenseyImages[i];
                    if (!suspenseyImage.complete) {
                        var rect = suspenseyImage.getBoundingClientRect();
                        if (0 < rect.bottom && 0 < rect.right && rect.top < ownerWindow.innerHeight && rect.left < ownerWindow.innerWidth) {
                            imgBytes += $4fcf5377eb083461$var$estimateImageBytes(suspenseyImage);
                            if (imgBytes > $4fcf5377eb083461$var$estimatedBytesWithinLimit) {
                                blockingPromises.length = previousFontLoadingStatus;
                                break;
                            }
                            suspenseyImage = new Promise($4fcf5377eb083461$var$waitForImageToLoad.bind(suspenseyImage));
                            blockingPromises.push(suspenseyImage);
                        }
                    }
                }
                if (0 < blockingPromises.length) return ownerWindow = Promise.race([
                    Promise.all(blockingPromises),
                    new Promise(function(resolve) {
                        return setTimeout(resolve, 500);
                    })
                ]).then(layoutCallback, layoutCallback), (pendingNavigation ? Promise.allSettled([
                    pendingNavigation.finished,
                    ownerWindow
                ]) : ownerWindow).then(afterMutationCallback, afterMutationCallback);
                layoutCallback();
                if (pendingNavigation) return pendingNavigation.finished.then(afterMutationCallback, afterMutationCallback);
                afterMutationCallback();
            },
            types: transitionTypes
        });
        ownerDocument.__reactViewTransition = transition;
        var viewTransitionAnimations = [];
        transition.ready.then(function() {
            for(var animations = ownerDocument.documentElement.getAnimations({
                subtree: !0
            }), i = 0; i < animations.length; i++){
                var animation = animations[i], effect = animation.effect, pseudoElement = effect.pseudoElement;
                if (null != pseudoElement && pseudoElement.startsWith("::view-transition")) {
                    viewTransitionAnimations.push(animation);
                    animation = effect.getKeyframes();
                    for(var height = pseudoElement = void 0, unchangedDimensions = !0, j = 0; j < animation.length; j++){
                        var keyframe = animation[j], w = keyframe.width;
                        if (void 0 === pseudoElement) pseudoElement = w;
                        else if (pseudoElement !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        w = keyframe.height;
                        if (void 0 === height) height = w;
                        else if (height !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        delete keyframe.width;
                        delete keyframe.height;
                        "none" === keyframe.transform && delete keyframe.transform;
                    }
                    unchangedDimensions && void 0 !== pseudoElement && void 0 !== height && (effect.setKeyframes(animation), unchangedDimensions = getComputedStyle(effect.target, effect.pseudoElement), unchangedDimensions.width !== pseudoElement || unchangedDimensions.height !== height) && (unchangedDimensions = animation[0], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, unchangedDimensions = animation[animation.length - 1], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, effect.setKeyframes(animation));
                }
            }
            spawnedWorkCallback();
        }, function(error) {
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            try {
                if ("object" === typeof error && null !== error) switch(error.name){
                    case "InvalidStateError":
                        if ("View transition was skipped because document visibility state is hidden." === error.message || "Skipping view transition because document visibility state has become hidden." === error.message || "Skipping view transition because viewport size changed." === error.message || "Transition was aborted because of invalid state" === error.message) error = null;
                }
                null !== error && errorCallback(error);
            } finally{
                mutationCallback(), layoutCallback(), spawnedWorkCallback();
            }
        });
        transition.finished.finally(function() {
            for(var i = 0; i < viewTransitionAnimations.length; i++)viewTransitionAnimations[i].cancel();
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            passiveCallback();
        });
        return transition;
    } catch (x) {
        return mutationCallback(), layoutCallback(), spawnedWorkCallback(), null;
    }
}
function $4fcf5377eb083461$var$ViewTransitionPseudoElement(pseudo, name) {
    this._scope = document.documentElement;
    this._selector = "::view-transition-" + pseudo + "(" + name + ")";
}
$4fcf5377eb083461$var$ViewTransitionPseudoElement.prototype.animate = function(keyframes, options) {
    options = "number" === typeof options ? {
        duration: options
    } : $4fcf5377eb083461$var$assign({}, options);
    options.pseudoElement = this._selector;
    return this._scope.animate(keyframes, options);
};
$4fcf5377eb083461$var$ViewTransitionPseudoElement.prototype.getAnimations = function() {
    for(var scope = this._scope, selector = this._selector, animations = scope.getAnimations({
        subtree: !0
    }), result = [], i = 0; i < animations.length; i++){
        var effect = animations[i].effect;
        null !== effect && effect.target === scope && effect.pseudoElement === selector && result.push(animations[i]);
    }
    return result;
};
$4fcf5377eb083461$var$ViewTransitionPseudoElement.prototype.getComputedStyle = function() {
    return getComputedStyle(this._scope, this._selector);
};
function $4fcf5377eb083461$var$createViewTransitionInstance(name) {
    return {
        name: name,
        group: new $4fcf5377eb083461$var$ViewTransitionPseudoElement("group", name),
        imagePair: new $4fcf5377eb083461$var$ViewTransitionPseudoElement("image-pair", name),
        old: new $4fcf5377eb083461$var$ViewTransitionPseudoElement("old", name),
        new: new $4fcf5377eb083461$var$ViewTransitionPseudoElement("new", name)
    };
}
function $4fcf5377eb083461$var$FragmentInstance(fragmentFiber) {
    this._fragmentFiber = fragmentFiber;
    this._observers = this._eventListeners = null;
}
$4fcf5377eb083461$var$FragmentInstance.prototype.addEventListener = function(type, listener, optionsOrUseCapture) {
    var signal = null, cleanup = null;
    if (null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && (signal = optionsOrUseCapture.signal || null, null !== signal && signal.aborted)) return;
    null === this._eventListeners && (this._eventListeners = []);
    var listeners = this._eventListeners;
    if (-1 === $4fcf5377eb083461$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture)) {
        var fragmentInstance = this, attachedListener = listener;
        null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && !0 === optionsOrUseCapture.once && (attachedListener = function(event) {
            fragmentInstance.removeEventListener(type, listener, optionsOrUseCapture);
            "function" === typeof listener ? listener.call(this, event) : listener.handleEvent(event);
        });
        null !== signal && (cleanup = fragmentInstance.removeEventListener.bind(fragmentInstance, type, listener, optionsOrUseCapture), signal.addEventListener("abort", cleanup, {
            once: !0
        }), cleanup = signal.removeEventListener.bind(signal, "abort", cleanup));
        signal = $4fcf5377eb083461$var$getAttachOptions(optionsOrUseCapture);
        listeners.push({
            type: type,
            listener: listener,
            optionsOrUseCapture: optionsOrUseCapture,
            attachedListener: attachedListener,
            cleanup: cleanup
        });
        $4fcf5377eb083461$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $4fcf5377eb083461$var$addEventListenerToChild, type, attachedListener, signal);
    }
    this._eventListeners = listeners;
};
function $4fcf5377eb083461$var$addEventListenerToChild(child, type, listener, optionsOrUseCapture) {
    $4fcf5377eb083461$var$getInstanceFromHostFiber(child).addEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
$4fcf5377eb083461$var$FragmentInstance.prototype.removeEventListener = function(type, listener, optionsOrUseCapture) {
    var listeners = this._eventListeners;
    if (null !== listeners && (listener = $4fcf5377eb083461$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture), -1 !== listener)) {
        var _listeners$index = listeners[listener];
        optionsOrUseCapture = _listeners$index.attachedListener;
        var cleanup = _listeners$index.cleanup;
        _listeners$index = $4fcf5377eb083461$var$getAttachOptions(_listeners$index.optionsOrUseCapture);
        $4fcf5377eb083461$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $4fcf5377eb083461$var$removeEventListenerFromChild, type, optionsOrUseCapture, _listeners$index);
        listeners.splice(listener, 1);
        null !== cleanup && cleanup();
    }
};
function $4fcf5377eb083461$var$removeEventListenerFromChild(child, type, listener, optionsOrUseCapture) {
    $4fcf5377eb083461$var$getInstanceFromHostFiber(child).removeEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
function $4fcf5377eb083461$var$getAttachOptions(opts) {
    return null != opts && "boolean" !== typeof opts && (!0 === opts.once || opts.signal instanceof AbortSignal) ? {
        capture: opts.capture,
        passive: opts.passive
    } : opts;
}
function $4fcf5377eb083461$var$normalizeListenerOptions(opts) {
    return null == opts ? "c=0" : "boolean" === typeof opts ? "c=" + (opts ? "1" : "0") : "c=" + (opts.capture ? "1" : "0");
}
function $4fcf5377eb083461$var$indexOfEventListener(eventListeners, type, listener, optionsOrUseCapture) {
    if (0 === eventListeners.length) return -1;
    optionsOrUseCapture = $4fcf5377eb083461$var$normalizeListenerOptions(optionsOrUseCapture);
    for(var i = 0; i < eventListeners.length; i++){
        var item = eventListeners[i];
        if (item.type === type && item.listener === listener && $4fcf5377eb083461$var$normalizeListenerOptions(item.optionsOrUseCapture) === optionsOrUseCapture) return i;
    }
    return -1;
}
$4fcf5377eb083461$var$FragmentInstance.prototype.dispatchEvent = function(event) {
    var parentHostFiber = $4fcf5377eb083461$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return !0;
    parentHostFiber = $4fcf5377eb083461$var$getInstanceFromHostFiber(parentHostFiber);
    var eventListeners = this._eventListeners;
    if (null !== eventListeners && 0 < eventListeners.length || !event.bubbles) {
        var temp = 9 === parentHostFiber.nodeType ? parentHostFiber.createComment("") : document.createTextNode("");
        if (eventListeners) for(var i = 0; i < eventListeners.length; i++){
            var _eventListeners$i = eventListeners[i];
            temp.addEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $4fcf5377eb083461$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        }
        parentHostFiber.appendChild(temp);
        event = temp.dispatchEvent(event);
        if (eventListeners) for(i = 0; i < eventListeners.length; i++)_eventListeners$i = eventListeners[i], temp.removeEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $4fcf5377eb083461$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        parentHostFiber.removeChild(temp);
        return event;
    }
    return parentHostFiber.dispatchEvent(event);
};
$4fcf5377eb083461$var$FragmentInstance.prototype.focus = function(focusOptions) {
    $4fcf5377eb083461$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $4fcf5377eb083461$var$setFocusOnFiberIfFocusable, focusOptions, void 0, void 0);
};
function $4fcf5377eb083461$var$setFocusOnFiberIfFocusable(fiber, focusOptions) {
    if (6 === fiber.tag) return !1;
    fiber = $4fcf5377eb083461$var$getInstanceFromHostFiber(fiber);
    return $4fcf5377eb083461$var$setFocusIfFocusable(fiber, focusOptions);
}
$4fcf5377eb083461$var$FragmentInstance.prototype.focusLast = function(focusOptions) {
    var children = [];
    $4fcf5377eb083461$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $4fcf5377eb083461$var$collectChildren, children, void 0, void 0);
    for(var i = children.length - 1; 0 <= i && !$4fcf5377eb083461$var$setFocusOnFiberIfFocusable(children[i], focusOptions); i--);
};
function $4fcf5377eb083461$var$collectChildren(child, collection) {
    collection.push(child);
    return !1;
}
$4fcf5377eb083461$var$FragmentInstance.prototype.blur = function() {
    var parentHostFiber = $4fcf5377eb083461$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    null !== parentHostFiber && (parentHostFiber = $4fcf5377eb083461$var$getInstanceFromHostFiber(parentHostFiber), parentHostFiber = $4fcf5377eb083461$var$getOwnerDocumentFromRootContainer(parentHostFiber).activeElement, null !== parentHostFiber && $4fcf5377eb083461$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $4fcf5377eb083461$var$blurActiveElementWithinFragment, parentHostFiber, void 0, void 0));
};
function $4fcf5377eb083461$var$blurActiveElementWithinFragment(child, activeElement) {
    if (6 === child.tag) return !1;
    child = $4fcf5377eb083461$var$getInstanceFromHostFiber(child);
    return child === activeElement || child.contains(activeElement) ? (activeElement.blur(), !0) : !1;
}
$4fcf5377eb083461$var$FragmentInstance.prototype.observeUsing = function(observer) {
    null === this._observers && (this._observers = new Set());
    this._observers.add(observer);
    $4fcf5377eb083461$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $4fcf5377eb083461$var$observeChild, observer, void 0, void 0);
};
function $4fcf5377eb083461$var$observeChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $4fcf5377eb083461$var$getInstanceFromHostFiber(child);
    observer.observe(child);
    return !1;
}
$4fcf5377eb083461$var$FragmentInstance.prototype.unobserveUsing = function(observer) {
    var observers = this._observers;
    if (null !== observers && observers.has(observer)) {
        observers.delete(observer);
        $4fcf5377eb083461$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $4fcf5377eb083461$var$unobserveChild, observer, void 0, void 0);
        for(var i = observers = 0; i < $4fcf5377eb083461$var$pendingIntersectionUnobserves.length; i++){
            var pending = $4fcf5377eb083461$var$pendingIntersectionUnobserves[i];
            pending.fragmentInstance === this && pending.observer === observer ? observer.unobserve(pending.instance) : $4fcf5377eb083461$var$pendingIntersectionUnobserves[observers++] = pending;
        }
        $4fcf5377eb083461$var$pendingIntersectionUnobserves.length = observers;
    }
};
function $4fcf5377eb083461$var$unobserveChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $4fcf5377eb083461$var$getInstanceFromHostFiber(child);
    observer.unobserve(child);
    return !1;
}
var $4fcf5377eb083461$var$pendingIntersectionUnobserves = [], $4fcf5377eb083461$var$intersectionUnobserveScheduled = !1;
function $4fcf5377eb083461$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, instance) {
    $4fcf5377eb083461$var$pendingIntersectionUnobserves.push({
        fragmentInstance: fragmentInstance,
        observer: observer,
        instance: instance
    });
    $4fcf5377eb083461$var$intersectionUnobserveScheduled || ($4fcf5377eb083461$var$intersectionUnobserveScheduled = !0, $4fcf5377eb083461$var$requestPostPaintCallback(function() {
        $4fcf5377eb083461$var$intersectionUnobserveScheduled = !1;
        var pending = $4fcf5377eb083461$var$pendingIntersectionUnobserves;
        $4fcf5377eb083461$var$pendingIntersectionUnobserves = [];
        for(var i = 0; i < pending.length; i++){
            var item = pending[i];
            item.observer.unobserve(item.instance);
        }
    }));
}
$4fcf5377eb083461$var$FragmentInstance.prototype.getClientRects = function() {
    var rects = [];
    $4fcf5377eb083461$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $4fcf5377eb083461$var$collectClientRects, rects, void 0, void 0);
    return rects;
};
function $4fcf5377eb083461$var$collectClientRects(child, rects) {
    if (6 === child.tag) {
        child = child.stateNode;
        var range = child.ownerDocument.createRange();
        range.selectNodeContents(child);
        rects.push.apply(rects, range.getClientRects());
    } else child = $4fcf5377eb083461$var$getInstanceFromHostFiber(child), rects.push.apply(rects, child.getClientRects());
    return !1;
}
$4fcf5377eb083461$var$FragmentInstance.prototype.getRootNode = function(getRootNodeOptions) {
    var parentHostFiber = $4fcf5377eb083461$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    return null === parentHostFiber ? this : $4fcf5377eb083461$var$getInstanceFromHostFiber(parentHostFiber).getRootNode(getRootNodeOptions);
};
$4fcf5377eb083461$var$FragmentInstance.prototype.compareDocumentPosition = function(otherNode) {
    var parentHostFiber = $4fcf5377eb083461$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return Node.DOCUMENT_POSITION_DISCONNECTED;
    var children = [];
    $4fcf5377eb083461$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $4fcf5377eb083461$var$collectChildren, children, void 0, void 0);
    var parentHostInstance = $4fcf5377eb083461$var$getInstanceFromHostFiber(parentHostFiber);
    if (0 === children.length) {
        children = parentHostInstance;
        if ($4fcf5377eb083461$var$fiberIsPortaledIntoHost(this._fragmentFiber)) {
            a: {
                for(parentHostFiber = this._fragmentFiber.return; null !== parentHostFiber;){
                    if (4 === parentHostFiber.tag) {
                        parentHostFiber = parentHostFiber.stateNode.containerInfo;
                        break a;
                    }
                    if (3 === parentHostFiber.tag || 5 === parentHostFiber.tag || 27 === parentHostFiber.tag) break;
                    parentHostFiber = parentHostFiber.return;
                }
                parentHostFiber = null;
            }
            null != parentHostFiber && (children = parentHostFiber);
        }
        parentHostFiber = this._fragmentFiber;
        var result = parentHostInstance = children.compareDocumentPosition(otherNode);
        children === otherNode ? result = Node.DOCUMENT_POSITION_CONTAINS : parentHostInstance & Node.DOCUMENT_POSITION_CONTAINED_BY && (children = $4fcf5377eb083461$var$getFragmentInstanceOrTextInstanceSiblings(parentHostFiber)[1], null === children ? result = Node.DOCUMENT_POSITION_PRECEDING : (otherNode = $4fcf5377eb083461$var$getInstanceFromHostFiber(children).compareDocumentPosition(otherNode), result = 0 === otherNode || otherNode & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING));
        return result |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
    parentHostFiber = $4fcf5377eb083461$var$getInstanceFromHostFiber(children[0]);
    result = $4fcf5377eb083461$var$getInstanceFromHostFiber(children[children.length - 1]);
    var parentHostInstanceFromDOM = $4fcf5377eb083461$var$fiberIsPortaledIntoHost(this._fragmentFiber) ? parentHostFiber.parentElement : parentHostInstance;
    if (null == parentHostInstanceFromDOM) return Node.DOCUMENT_POSITION_DISCONNECTED;
    parentHostInstance = parentHostInstanceFromDOM.compareDocumentPosition(parentHostFiber) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    parentHostInstanceFromDOM = parentHostInstanceFromDOM.compareDocumentPosition(result) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    var firstResult = parentHostFiber.compareDocumentPosition(otherNode), lastResult = result.compareDocumentPosition(otherNode), otherNodeIsWithinFirstOrLastChild = firstResult & Node.DOCUMENT_POSITION_CONTAINED_BY || lastResult & Node.DOCUMENT_POSITION_CONTAINED_BY;
    lastResult = parentHostInstance && parentHostInstanceFromDOM && firstResult & Node.DOCUMENT_POSITION_FOLLOWING && lastResult & Node.DOCUMENT_POSITION_PRECEDING;
    parentHostFiber = parentHostInstance && parentHostFiber === otherNode || parentHostInstanceFromDOM && result === otherNode || otherNodeIsWithinFirstOrLastChild || lastResult ? Node.DOCUMENT_POSITION_CONTAINED_BY : !parentHostInstance && parentHostFiber === otherNode || !parentHostInstanceFromDOM && result === otherNode ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : firstResult;
    return parentHostFiber & Node.DOCUMENT_POSITION_DISCONNECTED || parentHostFiber & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || $4fcf5377eb083461$var$validateDocumentPositionWithFiberTree(parentHostFiber, this._fragmentFiber, children[0], children[children.length - 1], otherNode) ? parentHostFiber : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
};
function $4fcf5377eb083461$var$validateDocumentPositionWithFiberTree(documentPosition, fragmentFiber, precedingBoundaryFiber, followingBoundaryFiber, otherNode) {
    var otherFiber = $4fcf5377eb083461$var$getClosestInstanceFromNode(otherNode);
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        if (precedingBoundaryFiber = !!otherFiber) a: {
            for(; null !== otherFiber;){
                if (7 === otherFiber.tag && (otherFiber === fragmentFiber || otherFiber.alternate === fragmentFiber)) {
                    precedingBoundaryFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            precedingBoundaryFiber = !1;
        }
        return precedingBoundaryFiber;
    }
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINS) {
        if (null === otherFiber) return otherFiber = otherNode.ownerDocument, otherNode === otherFiber || otherNode === otherFiber.documentElement || otherNode === otherFiber.body;
        a: {
            otherFiber = fragmentFiber;
            for(fragmentFiber = $4fcf5377eb083461$var$getFragmentParentInstanceOrContainerFiber(fragmentFiber); null !== otherFiber;){
                if (!(5 !== otherFiber.tag && 3 !== otherFiber.tag && 27 !== otherFiber.tag || otherFiber !== fragmentFiber && otherFiber.alternate !== fragmentFiber)) {
                    otherFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            otherFiber = !1;
        }
        return otherFiber;
    }
    return documentPosition & Node.DOCUMENT_POSITION_PRECEDING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === precedingBoundaryFiber) && (fragmentFiber = $4fcf5377eb083461$var$getLowestCommonAncestor(precedingBoundaryFiber, otherFiber, $4fcf5377eb083461$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($4fcf5377eb083461$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $4fcf5377eb083461$var$isFiberPrecedingCheck, otherFiber, precedingBoundaryFiber), otherFiber = $4fcf5377eb083461$var$searchTarget, $4fcf5377eb083461$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : documentPosition & Node.DOCUMENT_POSITION_FOLLOWING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === followingBoundaryFiber) && (fragmentFiber = $4fcf5377eb083461$var$getLowestCommonAncestor(followingBoundaryFiber, otherFiber, $4fcf5377eb083461$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($4fcf5377eb083461$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $4fcf5377eb083461$var$isFiberFollowingCheck, otherFiber, followingBoundaryFiber), otherFiber = $4fcf5377eb083461$var$searchTarget, $4fcf5377eb083461$var$searchBoundary = $4fcf5377eb083461$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : !1;
}
function $4fcf5377eb083461$var$scrollTextNodeIntoView(textNode, resolvedAlignToTop) {
    var range = textNode.ownerDocument.createRange();
    range.selectNodeContents(textNode);
    textNode = range.getBoundingClientRect();
    window.scrollTo(window.scrollX + textNode.left, resolvedAlignToTop ? window.scrollY + textNode.top : window.scrollY + textNode.bottom - window.innerHeight);
}
$4fcf5377eb083461$var$FragmentInstance.prototype.scrollIntoView = function(alignToTop) {
    if ("object" === typeof alignToTop) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(566));
    var children = [];
    $4fcf5377eb083461$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $4fcf5377eb083461$var$collectChildren, children, void 0, void 0);
    var resolvedAlignToTop = !1 !== alignToTop;
    if (0 === children.length) {
        var hostSiblings = $4fcf5377eb083461$var$getFragmentInstanceOrTextInstanceSiblings(this._fragmentFiber);
        hostSiblings = resolvedAlignToTop ? hostSiblings[1] || hostSiblings[0] || $4fcf5377eb083461$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber) : hostSiblings[0] || hostSiblings[1];
        if (null === hostSiblings) return;
        if (6 === hostSiblings.tag) {
            alignToTop = $4fcf5377eb083461$var$getInstanceFromHostFiber(hostSiblings);
            $4fcf5377eb083461$var$scrollTextNodeIntoView(alignToTop, resolvedAlignToTop);
            return;
        }
        hostSiblings = $4fcf5377eb083461$var$getInstanceFromHostFiber(hostSiblings);
        if (9 !== hostSiblings.nodeType) {
            if (11 === hostSiblings.nodeType) {
                resolvedAlignToTop = "host" in hostSiblings ? hostSiblings.host : null;
                null !== resolvedAlignToTop && resolvedAlignToTop.scrollIntoView(alignToTop);
                return;
            }
            hostSiblings.scrollIntoView(alignToTop);
        }
    }
    for(hostSiblings = resolvedAlignToTop ? children.length - 1 : 0; hostSiblings !== (resolvedAlignToTop ? -1 : children.length);){
        var child = children[hostSiblings];
        6 === child.tag ? (child = $4fcf5377eb083461$var$getInstanceFromHostFiber(child), $4fcf5377eb083461$var$scrollTextNodeIntoView(child, resolvedAlignToTop)) : $4fcf5377eb083461$var$getInstanceFromHostFiber(child).scrollIntoView(alignToTop);
        hostSiblings += resolvedAlignToTop ? -1 : 1;
    }
};
function $4fcf5377eb083461$var$addFragmentHandleToFiber(child, fragmentInstance) {
    child = $4fcf5377eb083461$var$getInstanceFromHostFiber(child);
    $4fcf5377eb083461$var$addFragmentHandleToInstance(child, fragmentInstance);
    return !1;
}
function $4fcf5377eb083461$var$addFragmentHandleToInstance(instance, fragmentInstance) {
    null == instance.reactFragments && (instance.reactFragments = new Set());
    instance.reactFragments.add(fragmentInstance);
}
function $4fcf5377eb083461$var$commitNewChildToFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i$jscomp$0 = 0; i$jscomp$0 < eventListeners.length; i$jscomp$0++){
        var _eventListeners$i3 = eventListeners[i$jscomp$0];
        childInstance.addEventListener(_eventListeners$i3.type, _eventListeners$i3.attachedListener, $4fcf5377eb083461$var$getAttachOptions(_eventListeners$i3.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        for(var writeIdx = 0, i = 0; i < $4fcf5377eb083461$var$pendingIntersectionUnobserves.length; i++){
            var pending = $4fcf5377eb083461$var$pendingIntersectionUnobserves[i];
            if (pending.fragmentInstance !== fragmentInstance || pending.observer !== observer || pending.instance !== childInstance) $4fcf5377eb083461$var$pendingIntersectionUnobserves[writeIdx++] = pending;
        }
        $4fcf5377eb083461$var$pendingIntersectionUnobserves.length = writeIdx;
        observer.observe(childInstance);
    }), $4fcf5377eb083461$var$addFragmentHandleToInstance(childInstance, fragmentInstance));
}
function $4fcf5377eb083461$var$deleteChildFromFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i = 0; i < eventListeners.length; i++){
        var _eventListeners$i4 = eventListeners[i];
        childInstance.removeEventListener(_eventListeners$i4.type, _eventListeners$i4.attachedListener, $4fcf5377eb083461$var$getAttachOptions(_eventListeners$i4.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        "string" === typeof observer.rootMargin ? $4fcf5377eb083461$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, childInstance) : observer.unobserve(childInstance);
    }), null != childInstance.reactFragments && childInstance.reactFragments.delete(fragmentInstance));
}
function $4fcf5377eb083461$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $4fcf5377eb083461$var$clearContainerSparingly(node);
                $4fcf5377eb083461$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $4fcf5377eb083461$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$4fcf5377eb083461$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $4fcf5377eb083461$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $4fcf5377eb083461$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $4fcf5377eb083461$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $4fcf5377eb083461$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $4fcf5377eb083461$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $4fcf5377eb083461$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $4fcf5377eb083461$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $4fcf5377eb083461$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $4fcf5377eb083461$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $4fcf5377eb083461$var$previousHydratableOnEnteringScopedSingleton = null;
function $4fcf5377eb083461$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $4fcf5377eb083461$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $4fcf5377eb083461$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $4fcf5377eb083461$var$setFocusIfFocusable(node, focusOptions) {
    function handleFocus() {
        didFocus = !0;
    }
    if (node.ownerDocument.activeElement === node) return !0;
    var didFocus = !1;
    try {
        node.ownerDocument.addEventListener("focus", handleFocus, !0), (node.focus || HTMLElement.prototype.focus).call(node, focusOptions);
    } finally{
        node.ownerDocument.removeEventListener("focus", handleFocus, !0);
    }
    return didFocus;
}
function $4fcf5377eb083461$var$requestPostPaintCallback(callback) {
    $4fcf5377eb083461$var$localRequestAnimationFrame(function() {
        $4fcf5377eb083461$var$localRequestAnimationFrame(function(time) {
            return callback(time);
        });
    });
}
function $4fcf5377eb083461$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $4fcf5377eb083461$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($4fcf5377eb083461$var$formatProdErrorMessage(451));
    }
}
function $4fcf5377eb083461$var$releaseSingletonInstance(instance, type, props) {
    for(var propKey in props){
        var propValue = props[propKey];
        props.hasOwnProperty(propKey) && null != propValue && $4fcf5377eb083461$var$setProp(instance, type, propKey, null, $4fcf5377eb083461$var$emptyProps, propValue);
    }
    null != props.dangerouslySetInnerHTML && (instance.textContent = "");
    instance.onclick === $4fcf5377eb083461$var$noop$1 && (instance.onclick = null);
    $4fcf5377eb083461$var$detachDeletedInstance(instance);
}
function $4fcf5377eb083461$var$clearSingletonPreambleContribution(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $4fcf5377eb083461$var$detachDeletedInstance(instance);
}
var $4fcf5377eb083461$var$preloadPropsMap = new Map(), $4fcf5377eb083461$var$preconnectsSet = new Set();
function $4fcf5377eb083461$var$getHoistableRoot(container) {
    if ("function" === typeof container.getRootNode) {
        var rootNode = container.getRootNode();
        if (9 === rootNode.nodeType || 11 === rootNode.nodeType) return rootNode;
    }
    return 9 === container.nodeType ? container : container.ownerDocument;
}
var $4fcf5377eb083461$var$previousDispatcher = $4fcf5377eb083461$var$ReactDOMSharedInternals.d;
$4fcf5377eb083461$var$ReactDOMSharedInternals.d = {
    f: $4fcf5377eb083461$var$flushSyncWork,
    r: $4fcf5377eb083461$var$requestFormReset,
    D: $4fcf5377eb083461$var$prefetchDNS,
    C: $4fcf5377eb083461$var$preconnect,
    L: $4fcf5377eb083461$var$preload,
    m: $4fcf5377eb083461$var$preloadModule,
    X: $4fcf5377eb083461$var$preinitScript,
    S: $4fcf5377eb083461$var$preinitStyle,
    M: $4fcf5377eb083461$var$preinitModuleScript
};
function $4fcf5377eb083461$var$flushSyncWork() {
    var previousWasRendering = $4fcf5377eb083461$var$previousDispatcher.f(), wasRendering = $4fcf5377eb083461$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $4fcf5377eb083461$var$requestFormReset(form) {
    var formInst = $4fcf5377eb083461$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $4fcf5377eb083461$var$requestFormReset$1(formInst) : $4fcf5377eb083461$var$previousDispatcher.r(form);
}
var $4fcf5377eb083461$var$globalDocument = "undefined" === typeof document ? null : document;
function $4fcf5377eb083461$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $4fcf5377eb083461$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $4fcf5377eb083461$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $4fcf5377eb083461$var$preconnectsSet.has(limitedEscapedHref) || ($4fcf5377eb083461$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $4fcf5377eb083461$var$setInitialProperties(href, "link", rel), $4fcf5377eb083461$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $4fcf5377eb083461$var$prefetchDNS(href) {
    $4fcf5377eb083461$var$previousDispatcher.D(href);
    $4fcf5377eb083461$var$preconnectAs("dns-prefetch", href, null);
}
function $4fcf5377eb083461$var$preconnect(href, crossOrigin) {
    $4fcf5377eb083461$var$previousDispatcher.C(href, crossOrigin);
    $4fcf5377eb083461$var$preconnectAs("preconnect", href, crossOrigin);
}
function $4fcf5377eb083461$var$preload(href, as, options) {
    $4fcf5377eb083461$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $4fcf5377eb083461$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $4fcf5377eb083461$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $4fcf5377eb083461$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $4fcf5377eb083461$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $4fcf5377eb083461$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $4fcf5377eb083461$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $4fcf5377eb083461$var$getStyleKey(href);
                break;
            case "script":
                key = $4fcf5377eb083461$var$getScriptKey(href);
        }
        if (!($4fcf5377eb083461$var$preloadPropsMap.has(key) || (href = $4fcf5377eb083461$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $4fcf5377eb083461$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($4fcf5377eb083461$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($4fcf5377eb083461$var$getScriptSelectorFromKey(key))))) {
            var instance = ownerDocument.createElement("link");
            $4fcf5377eb083461$var$setInitialProperties(instance, "link", href);
            "style" === as && (instance[$4fcf5377eb083461$var$internalLoadPendingKey] = !0, instance.onload = instance.onerror = function() {
                $4fcf5377eb083461$var$clearPendingLoadOnNode(instance);
            });
            $4fcf5377eb083461$var$markNodeAsHoistable(instance);
            ownerDocument.head.appendChild(instance);
        }
    }
}
function $4fcf5377eb083461$var$preloadModule(href, options) {
    $4fcf5377eb083461$var$previousDispatcher.m(href, options);
    var ownerDocument = $4fcf5377eb083461$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $4fcf5377eb083461$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $4fcf5377eb083461$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $4fcf5377eb083461$var$getScriptKey(href);
        }
        if (!$4fcf5377eb083461$var$preloadPropsMap.has(key) && (href = $4fcf5377eb083461$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $4fcf5377eb083461$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($4fcf5377eb083461$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $4fcf5377eb083461$var$setInitialProperties(as, "link", href);
            $4fcf5377eb083461$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $4fcf5377eb083461$var$preinitStyle(href, precedence, options) {
    $4fcf5377eb083461$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $4fcf5377eb083461$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $4fcf5377eb083461$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $4fcf5377eb083461$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($4fcf5377eb083461$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $4fcf5377eb083461$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $4fcf5377eb083461$var$preloadPropsMap.get(key)) && $4fcf5377eb083461$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $4fcf5377eb083461$var$markNodeAsHoistable(link);
                $4fcf5377eb083461$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $4fcf5377eb083461$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $4fcf5377eb083461$var$preinitScript(src, options) {
    $4fcf5377eb083461$var$previousDispatcher.X(src, options);
    var ownerDocument = $4fcf5377eb083461$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $4fcf5377eb083461$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $4fcf5377eb083461$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($4fcf5377eb083461$var$getScriptSelectorFromKey(key)), resource || (src = $4fcf5377eb083461$var$assign({
            src: src,
            async: !0
        }, options), (options = $4fcf5377eb083461$var$preloadPropsMap.get(key)) && $4fcf5377eb083461$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $4fcf5377eb083461$var$markNodeAsHoistable(resource), $4fcf5377eb083461$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $4fcf5377eb083461$var$preinitModuleScript(src, options) {
    $4fcf5377eb083461$var$previousDispatcher.M(src, options);
    var ownerDocument = $4fcf5377eb083461$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $4fcf5377eb083461$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $4fcf5377eb083461$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($4fcf5377eb083461$var$getScriptSelectorFromKey(key)), resource || (src = $4fcf5377eb083461$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $4fcf5377eb083461$var$preloadPropsMap.get(key)) && $4fcf5377eb083461$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $4fcf5377eb083461$var$markNodeAsHoistable(resource), $4fcf5377eb083461$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $4fcf5377eb083461$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $4fcf5377eb083461$var$rootInstanceStackCursor.current) ? $4fcf5377eb083461$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = $4fcf5377eb083461$var$getStyleKey(pendingProps.href), currentProps = $4fcf5377eb083461$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $4fcf5377eb083461$var$getStyleKey(pendingProps.href);
                var styles$268 = $4fcf5377eb083461$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$269 = styles$268.get(type);
                resource$269 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$269 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$268.set(type, resource$269), (styles$268 = JSCompiler_inline_result.querySelector($4fcf5377eb083461$var$getStylesheetSelectorFromKey(type))) ? styles$268._p || (resource$269.instance = styles$268, resource$269.state.loading = 5) : (styles$268 = $4fcf5377eb083461$var$preloadPropsMap.get(type), styles$268 || (styles$268 = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $4fcf5377eb083461$var$preloadPropsMap.set(type, styles$268)), $4fcf5377eb083461$var$preloadStylesheet(JSCompiler_inline_result, type, styles$268, resource$269.state)));
                if (currentProps && null === currentResource) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(528, ""));
                return resource$269;
            }
            if (currentProps && null !== currentResource) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = $4fcf5377eb083461$var$getScriptKey(pendingProps), currentProps = $4fcf5377eb083461$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($4fcf5377eb083461$var$formatProdErrorMessage(444, type));
    }
}
function $4fcf5377eb083461$var$getStyleKey(href) {
    return 'href="' + $4fcf5377eb083461$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $4fcf5377eb083461$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $4fcf5377eb083461$var$stylesheetPropsFromRawProps(rawProps) {
    return $4fcf5377eb083461$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $4fcf5377eb083461$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    if (key = ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")) {
        if (!0 !== key[$4fcf5377eb083461$var$internalLoadPendingKey]) {
            state.loading = 1;
            return;
        }
    } else key = ownerDocument.createElement("link"), key[$4fcf5377eb083461$var$internalLoadPendingKey] = !0, key.onload = key.onerror = $4fcf5377eb083461$var$clearPendingLoadOnNode.bind(null, key), $4fcf5377eb083461$var$setInitialProperties(key, "link", preloadProps), $4fcf5377eb083461$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key);
    state.preload = key;
    key.addEventListener("load", function() {
        return state.loading |= 1;
    });
    key.addEventListener("error", function() {
        return state.loading |= 2;
    });
}
function $4fcf5377eb083461$var$getScriptKey(src) {
    return '[src="' + $4fcf5377eb083461$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $4fcf5377eb083461$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $4fcf5377eb083461$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $4fcf5377eb083461$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $4fcf5377eb083461$var$markNodeAsHoistable(instance), instance;
            var styleProps = $4fcf5377eb083461$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $4fcf5377eb083461$var$markNodeAsHoistable(instance);
            $4fcf5377eb083461$var$setInitialProperties(instance, "style", styleProps);
            $4fcf5377eb083461$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $4fcf5377eb083461$var$getStyleKey(props.href);
            var instance$274 = hoistableRoot.querySelector($4fcf5377eb083461$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$274) return resource.state.loading |= 4, resource.instance = instance$274, $4fcf5377eb083461$var$markNodeAsHoistable(instance$274), instance$274;
            instance = $4fcf5377eb083461$var$stylesheetPropsFromRawProps(props);
            (styleProps = $4fcf5377eb083461$var$preloadPropsMap.get(styleProps)) && $4fcf5377eb083461$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$274 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $4fcf5377eb083461$var$markNodeAsHoistable(instance$274);
            var linkInstance = instance$274;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $4fcf5377eb083461$var$setInitialProperties(instance$274, "link", instance);
            resource.state.loading |= 4;
            $4fcf5377eb083461$var$insertStylesheet(instance$274, props.precedence, hoistableRoot);
            return resource.instance = instance$274;
        case "script":
            instance$274 = $4fcf5377eb083461$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($4fcf5377eb083461$var$getScriptSelectorFromKey(instance$274))) return resource.instance = styleProps, $4fcf5377eb083461$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $4fcf5377eb083461$var$preloadPropsMap.get(instance$274)) instance = $4fcf5377eb083461$var$assign({}, props), $4fcf5377eb083461$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $4fcf5377eb083461$var$markNodeAsHoistable(styleProps);
            $4fcf5377eb083461$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($4fcf5377eb083461$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $4fcf5377eb083461$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $4fcf5377eb083461$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $4fcf5377eb083461$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $4fcf5377eb083461$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $4fcf5377eb083461$var$tagCaches = null;
function $4fcf5377eb083461$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $4fcf5377eb083461$var$tagCaches) {
        var cache = new Map();
        var caches = $4fcf5377eb083461$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $4fcf5377eb083461$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$4fcf5377eb083461$var$internalHoistableMarker] || node[$4fcf5377eb083461$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $4fcf5377eb083461$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $4fcf5377eb083461$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $4fcf5377eb083461$var$maySuspendCommit(type, props) {
    return "img" === type && null != props.src && "" !== props.src && null == props.onLoad && "lazy" !== props.loading;
}
function $4fcf5377eb083461$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $4fcf5377eb083461$var$estimateImageBytes(instance) {
    return (instance.width || 100) * (instance.height || 100) * ("number" === typeof devicePixelRatio ? devicePixelRatio : 1) * 0.25;
}
function $4fcf5377eb083461$var$suspendInstance(state, instance) {
    "function" === typeof instance.decode && (state.imgCount++, instance.complete || (state.imgBytes += $4fcf5377eb083461$var$estimateImageBytes(instance), state.suspenseyImages.push(instance)), state = $4fcf5377eb083461$var$onUnsuspendImg.bind(state), instance.decode().then(state, state));
}
function $4fcf5377eb083461$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $4fcf5377eb083461$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($4fcf5377eb083461$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $4fcf5377eb083461$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $4fcf5377eb083461$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $4fcf5377eb083461$var$stylesheetPropsFromRawProps(props);
            (key = $4fcf5377eb083461$var$preloadPropsMap.get(key)) && $4fcf5377eb083461$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $4fcf5377eb083461$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $4fcf5377eb083461$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $4fcf5377eb083461$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $4fcf5377eb083461$var$estimatedBytesWithinLimit = 0;
function $4fcf5377eb083461$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $4fcf5377eb083461$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $4fcf5377eb083461$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $4fcf5377eb083461$var$estimatedBytesWithinLimit && ($4fcf5377eb083461$var$estimatedBytesWithinLimit = 62500 * $4fcf5377eb083461$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $4fcf5377eb083461$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $4fcf5377eb083461$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $4fcf5377eb083461$var$checkIfFullyUnsuspended(state) {
    if (0 === state.count && (0 === state.imgCount || !state.waitingForImages)) {
        if (state.stylesheets) $4fcf5377eb083461$var$insertSuspendedStylesheets(state, state.stylesheets);
        else if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
        }
    }
}
function $4fcf5377eb083461$var$onUnsuspend() {
    this.count--;
    $4fcf5377eb083461$var$checkIfFullyUnsuspended(this);
}
function $4fcf5377eb083461$var$onUnsuspendImg() {
    this.imgCount--;
    $4fcf5377eb083461$var$checkIfFullyUnsuspended(this);
}
var $4fcf5377eb083461$var$precedencesByRoot = null;
function $4fcf5377eb083461$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $4fcf5377eb083461$var$precedencesByRoot = new Map(), resources.forEach($4fcf5377eb083461$var$insertStylesheetIntoRoot, state), $4fcf5377eb083461$var$precedencesByRoot = null, $4fcf5377eb083461$var$onUnsuspend.call(state));
}
function $4fcf5377eb083461$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $4fcf5377eb083461$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $4fcf5377eb083461$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $4fcf5377eb083461$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $4fcf5377eb083461$var$HostTransitionContext = {
    $$typeof: $4fcf5377eb083461$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $4fcf5377eb083461$var$sharedNotPendingObject,
    _currentValue2: $4fcf5377eb083461$var$sharedNotPendingObject,
    _threadCount: 0
};
function $4fcf5377eb083461$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $4fcf5377eb083461$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $4fcf5377eb083461$var$createLaneMap(0);
    this.hiddenUpdates = $4fcf5377eb083461$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.transitionTypes = null;
    this.incompleteTransitions = new Map();
}
function $4fcf5377eb083461$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $4fcf5377eb083461$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $4fcf5377eb083461$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $4fcf5377eb083461$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $4fcf5377eb083461$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $4fcf5377eb083461$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $4fcf5377eb083461$var$emptyContextObject;
    parentComponent = $4fcf5377eb083461$var$emptyContextObject;
    return parentComponent;
}
function $4fcf5377eb083461$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $4fcf5377eb083461$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $4fcf5377eb083461$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $4fcf5377eb083461$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($4fcf5377eb083461$var$scheduleUpdateOnFiber(element, rootFiber, lane), $4fcf5377eb083461$var$entangleTransitions(element, rootFiber, lane));
}
function $4fcf5377eb083461$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $4fcf5377eb083461$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $4fcf5377eb083461$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $4fcf5377eb083461$var$markRetryLaneImpl(fiber, retryLane);
}
function $4fcf5377eb083461$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $4fcf5377eb083461$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $4fcf5377eb083461$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $4fcf5377eb083461$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $4fcf5377eb083461$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $4fcf5377eb083461$var$requestUpdateLane();
        lane = $4fcf5377eb083461$var$getBumpedLaneForHydrationByLane(lane);
        var root = $4fcf5377eb083461$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $4fcf5377eb083461$var$scheduleUpdateOnFiber(root, fiber, lane);
        $4fcf5377eb083461$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $4fcf5377eb083461$var$_enabled = !0;
function $4fcf5377eb083461$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $4fcf5377eb083461$var$ReactSharedInternals.T;
    $4fcf5377eb083461$var$ReactSharedInternals.T = null;
    var previousPriority = $4fcf5377eb083461$var$ReactDOMSharedInternals.p;
    try {
        $4fcf5377eb083461$var$ReactDOMSharedInternals.p = 2, $4fcf5377eb083461$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $4fcf5377eb083461$var$ReactDOMSharedInternals.p = previousPriority, $4fcf5377eb083461$var$ReactSharedInternals.T = prevTransition;
    }
}
function $4fcf5377eb083461$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $4fcf5377eb083461$var$ReactSharedInternals.T;
    $4fcf5377eb083461$var$ReactSharedInternals.T = null;
    var previousPriority = $4fcf5377eb083461$var$ReactDOMSharedInternals.p;
    try {
        $4fcf5377eb083461$var$ReactDOMSharedInternals.p = 8, $4fcf5377eb083461$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $4fcf5377eb083461$var$ReactDOMSharedInternals.p = previousPriority, $4fcf5377eb083461$var$ReactSharedInternals.T = prevTransition;
    }
}
function $4fcf5377eb083461$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($4fcf5377eb083461$var$_enabled) {
        var blockedOn = $4fcf5377eb083461$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $4fcf5377eb083461$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $4fcf5377eb083461$var$return_targetInst, targetContainer), $4fcf5377eb083461$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($4fcf5377eb083461$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($4fcf5377eb083461$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $4fcf5377eb083461$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $4fcf5377eb083461$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $4fcf5377eb083461$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $4fcf5377eb083461$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $4fcf5377eb083461$var$ensureRootIsScheduled(fiber);
                                0 === ($4fcf5377eb083461$var$executionContext & 6) && ($4fcf5377eb083461$var$workInProgressRootRenderTargetTime = $4fcf5377eb083461$var$now() + 500, $4fcf5377eb083461$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $4fcf5377eb083461$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $4fcf5377eb083461$var$scheduleUpdateOnFiber(root, fiber, 2), $4fcf5377eb083461$var$flushSyncWork$1(), $4fcf5377eb083461$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $4fcf5377eb083461$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $4fcf5377eb083461$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $4fcf5377eb083461$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $4fcf5377eb083461$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $4fcf5377eb083461$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $4fcf5377eb083461$var$getEventTarget(nativeEvent);
    return $4fcf5377eb083461$var$findInstanceBlockingTarget(nativeEvent);
}
var $4fcf5377eb083461$var$return_targetInst = null;
function $4fcf5377eb083461$var$findInstanceBlockingTarget(targetNode) {
    $4fcf5377eb083461$var$return_targetInst = null;
    targetNode = $4fcf5377eb083461$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $4fcf5377eb083461$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $4fcf5377eb083461$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $4fcf5377eb083461$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $4fcf5377eb083461$var$return_targetInst = targetNode;
    return null;
}
function $4fcf5377eb083461$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "fullscreenerror":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "resize":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($4fcf5377eb083461$var$getCurrentPriorityLevel()){
                case $4fcf5377eb083461$var$ImmediatePriority:
                    return 2;
                case $4fcf5377eb083461$var$UserBlockingPriority:
                    return 8;
                case $4fcf5377eb083461$var$NormalPriority$1:
                case $4fcf5377eb083461$var$LowPriority:
                    return 32;
                case $4fcf5377eb083461$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $4fcf5377eb083461$var$hasScheduledReplayAttempt = !1, $4fcf5377eb083461$var$queuedFocus = null, $4fcf5377eb083461$var$queuedDrag = null, $4fcf5377eb083461$var$queuedMouse = null, $4fcf5377eb083461$var$queuedPointers = new Map(), $4fcf5377eb083461$var$queuedPointerCaptures = new Map(), $4fcf5377eb083461$var$queuedExplicitHydrationTargets = [], $4fcf5377eb083461$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $4fcf5377eb083461$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $4fcf5377eb083461$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $4fcf5377eb083461$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $4fcf5377eb083461$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $4fcf5377eb083461$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $4fcf5377eb083461$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $4fcf5377eb083461$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $4fcf5377eb083461$var$getInstanceFromNode(blockedOn), null !== blockedOn && $4fcf5377eb083461$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $4fcf5377eb083461$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $4fcf5377eb083461$var$queuedFocus = $4fcf5377eb083461$var$accumulateOrCreateContinuousQueuedReplayableEvent($4fcf5377eb083461$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $4fcf5377eb083461$var$queuedDrag = $4fcf5377eb083461$var$accumulateOrCreateContinuousQueuedReplayableEvent($4fcf5377eb083461$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $4fcf5377eb083461$var$queuedMouse = $4fcf5377eb083461$var$accumulateOrCreateContinuousQueuedReplayableEvent($4fcf5377eb083461$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $4fcf5377eb083461$var$queuedPointers.set(pointerId, $4fcf5377eb083461$var$accumulateOrCreateContinuousQueuedReplayableEvent($4fcf5377eb083461$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $4fcf5377eb083461$var$queuedPointerCaptures.set(pointerId, $4fcf5377eb083461$var$accumulateOrCreateContinuousQueuedReplayableEvent($4fcf5377eb083461$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $4fcf5377eb083461$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $4fcf5377eb083461$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $4fcf5377eb083461$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $4fcf5377eb083461$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $4fcf5377eb083461$var$runWithPriority(queuedTarget.priority, function() {
                        $4fcf5377eb083461$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $4fcf5377eb083461$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $4fcf5377eb083461$var$runWithPriority(queuedTarget.priority, function() {
                        $4fcf5377eb083461$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $4fcf5377eb083461$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $4fcf5377eb083461$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $4fcf5377eb083461$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $4fcf5377eb083461$var$currentReplayingEvent = null;
        } else return targetContainers = $4fcf5377eb083461$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $4fcf5377eb083461$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $4fcf5377eb083461$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $4fcf5377eb083461$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $4fcf5377eb083461$var$replayUnblockedEvents() {
    $4fcf5377eb083461$var$hasScheduledReplayAttempt = !1;
    null !== $4fcf5377eb083461$var$queuedFocus && $4fcf5377eb083461$var$attemptReplayContinuousQueuedEvent($4fcf5377eb083461$var$queuedFocus) && ($4fcf5377eb083461$var$queuedFocus = null);
    null !== $4fcf5377eb083461$var$queuedDrag && $4fcf5377eb083461$var$attemptReplayContinuousQueuedEvent($4fcf5377eb083461$var$queuedDrag) && ($4fcf5377eb083461$var$queuedDrag = null);
    null !== $4fcf5377eb083461$var$queuedMouse && $4fcf5377eb083461$var$attemptReplayContinuousQueuedEvent($4fcf5377eb083461$var$queuedMouse) && ($4fcf5377eb083461$var$queuedMouse = null);
    $4fcf5377eb083461$var$queuedPointers.forEach($4fcf5377eb083461$var$attemptReplayContinuousQueuedEventInMap);
    $4fcf5377eb083461$var$queuedPointerCaptures.forEach($4fcf5377eb083461$var$attemptReplayContinuousQueuedEventInMap);
}
function $4fcf5377eb083461$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $4fcf5377eb083461$var$hasScheduledReplayAttempt || ($4fcf5377eb083461$var$hasScheduledReplayAttempt = !0, $2tm1P.unstable_scheduleCallback($2tm1P.unstable_NormalPriority, $4fcf5377eb083461$var$replayUnblockedEvents)));
}
var $4fcf5377eb083461$var$lastScheduledReplayQueue = null;
function $4fcf5377eb083461$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $4fcf5377eb083461$var$lastScheduledReplayQueue !== formReplayingQueue && ($4fcf5377eb083461$var$lastScheduledReplayQueue = formReplayingQueue, $2tm1P.unstable_scheduleCallback($2tm1P.unstable_NormalPriority, function() {
        $4fcf5377eb083461$var$lastScheduledReplayQueue === formReplayingQueue && ($4fcf5377eb083461$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $4fcf5377eb083461$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $4fcf5377eb083461$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $4fcf5377eb083461$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $4fcf5377eb083461$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $4fcf5377eb083461$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $4fcf5377eb083461$var$queuedFocus && $4fcf5377eb083461$var$scheduleCallbackIfUnblocked($4fcf5377eb083461$var$queuedFocus, unblocked);
    null !== $4fcf5377eb083461$var$queuedDrag && $4fcf5377eb083461$var$scheduleCallbackIfUnblocked($4fcf5377eb083461$var$queuedDrag, unblocked);
    null !== $4fcf5377eb083461$var$queuedMouse && $4fcf5377eb083461$var$scheduleCallbackIfUnblocked($4fcf5377eb083461$var$queuedMouse, unblocked);
    $4fcf5377eb083461$var$queuedPointers.forEach(unblock);
    $4fcf5377eb083461$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $4fcf5377eb083461$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $4fcf5377eb083461$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $4fcf5377eb083461$var$queuedExplicitHydrationTargets.length && (i = $4fcf5377eb083461$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$4fcf5377eb083461$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $4fcf5377eb083461$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$4fcf5377eb083461$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $4fcf5377eb083461$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$4fcf5377eb083461$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $4fcf5377eb083461$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $4fcf5377eb083461$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $4fcf5377eb083461$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $4fcf5377eb083461$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$4fcf5377eb083461$var$ReactDOMHydrationRoot.prototype.render = $4fcf5377eb083461$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(409));
    var current = root.current, lane = $4fcf5377eb083461$var$requestUpdateLane();
    $4fcf5377eb083461$var$updateContainerImpl(current, lane, children, root, null, null);
};
$4fcf5377eb083461$var$ReactDOMHydrationRoot.prototype.unmount = $4fcf5377eb083461$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $4fcf5377eb083461$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $4fcf5377eb083461$var$flushSyncWork$1();
        container[$4fcf5377eb083461$var$internalContainerInstanceKey] = null;
    }
};
function $4fcf5377eb083461$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$4fcf5377eb083461$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $4fcf5377eb083461$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $4fcf5377eb083461$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $4fcf5377eb083461$var$queuedExplicitHydrationTargets[i].priority; i++);
        $4fcf5377eb083461$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $4fcf5377eb083461$var$attemptExplicitHydrationTarget(target);
    }
};
var $4fcf5377eb083461$var$isomorphicReactPackageVersion$jscomp$inline_2043 = $5FkrB.version;
if ("19.3.0" !== $4fcf5377eb083461$var$isomorphicReactPackageVersion$jscomp$inline_2043) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(527, $4fcf5377eb083461$var$isomorphicReactPackageVersion$jscomp$inline_2043, "19.3.0"));
$4fcf5377eb083461$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($4fcf5377eb083461$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $4fcf5377eb083461$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $4fcf5377eb083461$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $4fcf5377eb083461$var$internals$jscomp$inline_2586 = {
    bundleType: 0,
    version: "19.3.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $4fcf5377eb083461$var$ReactSharedInternals,
    reconcilerVersion: "19.3.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $4fcf5377eb083461$var$hook$jscomp$inline_2587 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$4fcf5377eb083461$var$hook$jscomp$inline_2587.isDisabled && $4fcf5377eb083461$var$hook$jscomp$inline_2587.supportsFiber) try {
        $4fcf5377eb083461$var$rendererID = $4fcf5377eb083461$var$hook$jscomp$inline_2587.inject($4fcf5377eb083461$var$internals$jscomp$inline_2586), $4fcf5377eb083461$var$injectedHook = $4fcf5377eb083461$var$hook$jscomp$inline_2587;
    } catch (err) {}
}
$4fcf5377eb083461$export$882461b6382ed46c = function(container, options) {
    if (!$4fcf5377eb083461$var$isValidContainer(container)) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $4fcf5377eb083461$var$defaultOnUncaughtError, onCaughtError = $4fcf5377eb083461$var$defaultOnCaughtError, onRecoverableError = $4fcf5377eb083461$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $4fcf5377eb083461$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $4fcf5377eb083461$var$defaultOnDefaultTransitionIndicator);
    container[$4fcf5377eb083461$var$internalContainerInstanceKey] = options.current;
    $4fcf5377eb083461$var$listenToAllSupportedEvents(container);
    return new $4fcf5377eb083461$var$ReactDOMRoot(options);
};
$4fcf5377eb083461$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$4fcf5377eb083461$var$isValidContainer(container)) throw Error($4fcf5377eb083461$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $4fcf5377eb083461$var$defaultOnUncaughtError, onCaughtError = $4fcf5377eb083461$var$defaultOnCaughtError, onRecoverableError = $4fcf5377eb083461$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $4fcf5377eb083461$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $4fcf5377eb083461$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $4fcf5377eb083461$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $4fcf5377eb083461$var$requestUpdateLane();
    isStrictMode = $4fcf5377eb083461$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $4fcf5377eb083461$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $4fcf5377eb083461$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $4fcf5377eb083461$var$markRootUpdated$1(initialChildren, options);
    $4fcf5377eb083461$var$ensureRootIsScheduled(initialChildren);
    container[$4fcf5377eb083461$var$internalContainerInstanceKey] = initialChildren.current;
    $4fcf5377eb083461$var$listenToAllSupportedEvents(container);
    return new $4fcf5377eb083461$var$ReactDOMHydrationRoot(initialChildren);
};
$4fcf5377eb083461$export$83d89fbfd8236492 = "19.3.0";

});
parcelRegister("3ZMUU", function(module, exports) {
// shim for using process in browser
var $2e8d0374c7e0ead2$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $2e8d0374c7e0ead2$var$cachedSetTimeout;
var $2e8d0374c7e0ead2$var$cachedClearTimeout;
function $2e8d0374c7e0ead2$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $2e8d0374c7e0ead2$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $2e8d0374c7e0ead2$var$cachedSetTimeout = setTimeout;
        else $2e8d0374c7e0ead2$var$cachedSetTimeout = $2e8d0374c7e0ead2$var$defaultSetTimout;
    } catch (e) {
        $2e8d0374c7e0ead2$var$cachedSetTimeout = $2e8d0374c7e0ead2$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $2e8d0374c7e0ead2$var$cachedClearTimeout = clearTimeout;
        else $2e8d0374c7e0ead2$var$cachedClearTimeout = $2e8d0374c7e0ead2$var$defaultClearTimeout;
    } catch (e) {
        $2e8d0374c7e0ead2$var$cachedClearTimeout = $2e8d0374c7e0ead2$var$defaultClearTimeout;
    }
})();
function $2e8d0374c7e0ead2$var$runTimeout(fun) {
    if ($2e8d0374c7e0ead2$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($2e8d0374c7e0ead2$var$cachedSetTimeout === $2e8d0374c7e0ead2$var$defaultSetTimout || !$2e8d0374c7e0ead2$var$cachedSetTimeout) && setTimeout) {
        $2e8d0374c7e0ead2$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $2e8d0374c7e0ead2$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $2e8d0374c7e0ead2$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $2e8d0374c7e0ead2$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $2e8d0374c7e0ead2$var$runClearTimeout(marker) {
    if ($2e8d0374c7e0ead2$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($2e8d0374c7e0ead2$var$cachedClearTimeout === $2e8d0374c7e0ead2$var$defaultClearTimeout || !$2e8d0374c7e0ead2$var$cachedClearTimeout) && clearTimeout) {
        $2e8d0374c7e0ead2$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $2e8d0374c7e0ead2$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $2e8d0374c7e0ead2$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $2e8d0374c7e0ead2$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $2e8d0374c7e0ead2$var$queue = [];
var $2e8d0374c7e0ead2$var$draining = false;
var $2e8d0374c7e0ead2$var$currentQueue;
var $2e8d0374c7e0ead2$var$queueIndex = -1;
function $2e8d0374c7e0ead2$var$cleanUpNextTick() {
    if (!$2e8d0374c7e0ead2$var$draining || !$2e8d0374c7e0ead2$var$currentQueue) return;
    $2e8d0374c7e0ead2$var$draining = false;
    if ($2e8d0374c7e0ead2$var$currentQueue.length) $2e8d0374c7e0ead2$var$queue = $2e8d0374c7e0ead2$var$currentQueue.concat($2e8d0374c7e0ead2$var$queue);
    else $2e8d0374c7e0ead2$var$queueIndex = -1;
    if ($2e8d0374c7e0ead2$var$queue.length) $2e8d0374c7e0ead2$var$drainQueue();
}
function $2e8d0374c7e0ead2$var$drainQueue() {
    if ($2e8d0374c7e0ead2$var$draining) return;
    var timeout = $2e8d0374c7e0ead2$var$runTimeout($2e8d0374c7e0ead2$var$cleanUpNextTick);
    $2e8d0374c7e0ead2$var$draining = true;
    var len = $2e8d0374c7e0ead2$var$queue.length;
    while(len){
        $2e8d0374c7e0ead2$var$currentQueue = $2e8d0374c7e0ead2$var$queue;
        $2e8d0374c7e0ead2$var$queue = [];
        while(++$2e8d0374c7e0ead2$var$queueIndex < len)if ($2e8d0374c7e0ead2$var$currentQueue) $2e8d0374c7e0ead2$var$currentQueue[$2e8d0374c7e0ead2$var$queueIndex].run();
        $2e8d0374c7e0ead2$var$queueIndex = -1;
        len = $2e8d0374c7e0ead2$var$queue.length;
    }
    $2e8d0374c7e0ead2$var$currentQueue = null;
    $2e8d0374c7e0ead2$var$draining = false;
    $2e8d0374c7e0ead2$var$runClearTimeout(timeout);
}
$2e8d0374c7e0ead2$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $2e8d0374c7e0ead2$var$queue.push(new $2e8d0374c7e0ead2$var$Item(fun, args));
    if ($2e8d0374c7e0ead2$var$queue.length === 1 && !$2e8d0374c7e0ead2$var$draining) $2e8d0374c7e0ead2$var$runTimeout($2e8d0374c7e0ead2$var$drainQueue);
};
// v8 likes predictible objects
function $2e8d0374c7e0ead2$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$2e8d0374c7e0ead2$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$2e8d0374c7e0ead2$var$process.title = 'browser';
$2e8d0374c7e0ead2$var$process.browser = true;
$2e8d0374c7e0ead2$var$process.env = {};
$2e8d0374c7e0ead2$var$process.argv = [];
$2e8d0374c7e0ead2$var$process.version = ''; // empty string to avoid regexp issues
$2e8d0374c7e0ead2$var$process.versions = {};
function $2e8d0374c7e0ead2$var$noop() {}
$2e8d0374c7e0ead2$var$process.on = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.addListener = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.once = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.off = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.removeListener = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.removeAllListeners = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.emit = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.prependListener = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.prependOnceListener = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.listeners = function(name) {
    return [];
};
$2e8d0374c7e0ead2$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$2e8d0374c7e0ead2$var$process.cwd = function() {
    return '/';
};
$2e8d0374c7e0ead2$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$2e8d0374c7e0ead2$var$process.umask = function() {
    return 0;
};

});

parcelRegister("2tm1P", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ecRR9"));

});
parcelRegister("ecRR9", function(module, exports) {
$parcel$export(module.exports, "unstable_now", () => $a57bf6682a94c2d3$export$c4744153514ff05d, (v) => $a57bf6682a94c2d3$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $a57bf6682a94c2d3$export$3e506c1ccc9cc1a7, (v) => $a57bf6682a94c2d3$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $a57bf6682a94c2d3$export$e26fe2ed2fa76875, (v) => $a57bf6682a94c2d3$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $a57bf6682a94c2d3$export$502329bbf4b505b1, (v) => $a57bf6682a94c2d3$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $a57bf6682a94c2d3$export$6e3807111c4874c4, (v) => $a57bf6682a94c2d3$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $a57bf6682a94c2d3$export$c27134553091fb3a, (v) => $a57bf6682a94c2d3$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $a57bf6682a94c2d3$export$33ee1acdc04fd2a2, (v) => $a57bf6682a94c2d3$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $a57bf6682a94c2d3$export$b00a404bbd5edef2, (v) => $a57bf6682a94c2d3$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $a57bf6682a94c2d3$export$d66a1c1c77bd778b, (v) => $a57bf6682a94c2d3$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $a57bf6682a94c2d3$export$d3dfb8e4810cb555, (v) => $a57bf6682a94c2d3$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $a57bf6682a94c2d3$export$72fdf0e06517287b, (v) => $a57bf6682a94c2d3$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $a57bf6682a94c2d3$export$816d2913ae6b83b1, (v) => $a57bf6682a94c2d3$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $a57bf6682a94c2d3$export$61bcfe829111a1d0, (v) => $a57bf6682a94c2d3$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $a57bf6682a94c2d3$export$7ee8c9beb337bc3f, (v) => $a57bf6682a94c2d3$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $a57bf6682a94c2d3$export$b5836b71941fa3ed, (v) => $a57bf6682a94c2d3$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $a57bf6682a94c2d3$export$cf845f2c119da08a, (v) => $a57bf6682a94c2d3$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a57bf6682a94c2d3$export$c4744153514ff05d;
var $a57bf6682a94c2d3$export$3e506c1ccc9cc1a7;
var $a57bf6682a94c2d3$export$e26fe2ed2fa76875;
var $a57bf6682a94c2d3$export$502329bbf4b505b1;
var $a57bf6682a94c2d3$export$6e3807111c4874c4;
var $a57bf6682a94c2d3$export$c27134553091fb3a;
var $a57bf6682a94c2d3$export$33ee1acdc04fd2a2;
var $a57bf6682a94c2d3$export$b00a404bbd5edef2;
var $a57bf6682a94c2d3$export$d66a1c1c77bd778b;
var $a57bf6682a94c2d3$export$d3dfb8e4810cb555;
var $a57bf6682a94c2d3$export$72fdf0e06517287b;
var $a57bf6682a94c2d3$export$816d2913ae6b83b1;
var $a57bf6682a94c2d3$export$61bcfe829111a1d0;
var $a57bf6682a94c2d3$export$7ee8c9beb337bc3f;
var $a57bf6682a94c2d3$export$b5836b71941fa3ed;
var $a57bf6682a94c2d3$export$cf845f2c119da08a;
"use strict";
function $a57bf6682a94c2d3$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $a57bf6682a94c2d3$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $a57bf6682a94c2d3$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $a57bf6682a94c2d3$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $a57bf6682a94c2d3$var$compare(left, last)) rightIndex < length && 0 > $a57bf6682a94c2d3$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $a57bf6682a94c2d3$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $a57bf6682a94c2d3$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$a57bf6682a94c2d3$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $a57bf6682a94c2d3$var$localPerformance = performance;
    $a57bf6682a94c2d3$export$c4744153514ff05d = function() {
        return $a57bf6682a94c2d3$var$localPerformance.now();
    };
} else {
    var $a57bf6682a94c2d3$var$localDate = Date, $a57bf6682a94c2d3$var$initialTime = $a57bf6682a94c2d3$var$localDate.now();
    $a57bf6682a94c2d3$export$c4744153514ff05d = function() {
        return $a57bf6682a94c2d3$var$localDate.now() - $a57bf6682a94c2d3$var$initialTime;
    };
}
var $a57bf6682a94c2d3$var$taskQueue = [], $a57bf6682a94c2d3$var$timerQueue = [], $a57bf6682a94c2d3$var$taskIdCounter = 1, $a57bf6682a94c2d3$var$currentTask = null, $a57bf6682a94c2d3$var$currentPriorityLevel = 3, $a57bf6682a94c2d3$var$isPerformingWork = !1, $a57bf6682a94c2d3$var$isHostCallbackScheduled = !1, $a57bf6682a94c2d3$var$isHostTimeoutScheduled = !1, $a57bf6682a94c2d3$var$needsPaint = !1, $a57bf6682a94c2d3$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $a57bf6682a94c2d3$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $a57bf6682a94c2d3$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $a57bf6682a94c2d3$var$advanceTimers(currentTime) {
    for(var timer = $a57bf6682a94c2d3$var$peek($a57bf6682a94c2d3$var$timerQueue); null !== timer;){
        if (null === timer.callback) $a57bf6682a94c2d3$var$pop($a57bf6682a94c2d3$var$timerQueue);
        else if (timer.startTime <= currentTime) $a57bf6682a94c2d3$var$pop($a57bf6682a94c2d3$var$timerQueue), timer.sortIndex = timer.expirationTime, $a57bf6682a94c2d3$var$push($a57bf6682a94c2d3$var$taskQueue, timer);
        else break;
        timer = $a57bf6682a94c2d3$var$peek($a57bf6682a94c2d3$var$timerQueue);
    }
}
function $a57bf6682a94c2d3$var$handleTimeout(currentTime) {
    $a57bf6682a94c2d3$var$isHostTimeoutScheduled = !1;
    $a57bf6682a94c2d3$var$advanceTimers(currentTime);
    if (!$a57bf6682a94c2d3$var$isHostCallbackScheduled) {
        if (null !== $a57bf6682a94c2d3$var$peek($a57bf6682a94c2d3$var$taskQueue)) $a57bf6682a94c2d3$var$isHostCallbackScheduled = !0, $a57bf6682a94c2d3$var$isMessageLoopRunning || ($a57bf6682a94c2d3$var$isMessageLoopRunning = !0, $a57bf6682a94c2d3$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $a57bf6682a94c2d3$var$peek($a57bf6682a94c2d3$var$timerQueue);
            null !== firstTimer && $a57bf6682a94c2d3$var$requestHostTimeout($a57bf6682a94c2d3$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $a57bf6682a94c2d3$var$isMessageLoopRunning = !1, $a57bf6682a94c2d3$var$taskTimeoutID = -1, $a57bf6682a94c2d3$var$frameInterval = 5, $a57bf6682a94c2d3$var$startTime = -1;
function $a57bf6682a94c2d3$var$shouldYieldToHost() {
    return $a57bf6682a94c2d3$var$needsPaint ? !0 : $a57bf6682a94c2d3$export$c4744153514ff05d() - $a57bf6682a94c2d3$var$startTime < $a57bf6682a94c2d3$var$frameInterval ? !1 : !0;
}
function $a57bf6682a94c2d3$var$performWorkUntilDeadline() {
    $a57bf6682a94c2d3$var$needsPaint = !1;
    if ($a57bf6682a94c2d3$var$isMessageLoopRunning) {
        var currentTime = $a57bf6682a94c2d3$export$c4744153514ff05d();
        $a57bf6682a94c2d3$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $a57bf6682a94c2d3$var$isHostCallbackScheduled = !1;
                $a57bf6682a94c2d3$var$isHostTimeoutScheduled && ($a57bf6682a94c2d3$var$isHostTimeoutScheduled = !1, $a57bf6682a94c2d3$var$localClearTimeout($a57bf6682a94c2d3$var$taskTimeoutID), $a57bf6682a94c2d3$var$taskTimeoutID = -1);
                $a57bf6682a94c2d3$var$isPerformingWork = !0;
                var previousPriorityLevel = $a57bf6682a94c2d3$var$currentPriorityLevel;
                try {
                    b: {
                        $a57bf6682a94c2d3$var$advanceTimers(currentTime);
                        for($a57bf6682a94c2d3$var$currentTask = $a57bf6682a94c2d3$var$peek($a57bf6682a94c2d3$var$taskQueue); null !== $a57bf6682a94c2d3$var$currentTask && !($a57bf6682a94c2d3$var$currentTask.expirationTime > currentTime && $a57bf6682a94c2d3$var$shouldYieldToHost());){
                            var callback = $a57bf6682a94c2d3$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $a57bf6682a94c2d3$var$currentTask.callback = null;
                                $a57bf6682a94c2d3$var$currentPriorityLevel = $a57bf6682a94c2d3$var$currentTask.priorityLevel;
                                var continuationCallback = callback($a57bf6682a94c2d3$var$currentTask.expirationTime <= currentTime);
                                currentTime = $a57bf6682a94c2d3$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $a57bf6682a94c2d3$var$currentTask.callback = continuationCallback;
                                    $a57bf6682a94c2d3$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $a57bf6682a94c2d3$var$currentTask === $a57bf6682a94c2d3$var$peek($a57bf6682a94c2d3$var$taskQueue) && $a57bf6682a94c2d3$var$pop($a57bf6682a94c2d3$var$taskQueue);
                                $a57bf6682a94c2d3$var$advanceTimers(currentTime);
                            } else $a57bf6682a94c2d3$var$pop($a57bf6682a94c2d3$var$taskQueue);
                            $a57bf6682a94c2d3$var$currentTask = $a57bf6682a94c2d3$var$peek($a57bf6682a94c2d3$var$taskQueue);
                        }
                        if (null !== $a57bf6682a94c2d3$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $a57bf6682a94c2d3$var$peek($a57bf6682a94c2d3$var$timerQueue);
                            null !== firstTimer && $a57bf6682a94c2d3$var$requestHostTimeout($a57bf6682a94c2d3$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $a57bf6682a94c2d3$var$currentTask = null, $a57bf6682a94c2d3$var$currentPriorityLevel = previousPriorityLevel, $a57bf6682a94c2d3$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $a57bf6682a94c2d3$var$schedulePerformWorkUntilDeadline() : $a57bf6682a94c2d3$var$isMessageLoopRunning = !1;
        }
    }
}
var $a57bf6682a94c2d3$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $a57bf6682a94c2d3$var$localSetImmediate) $a57bf6682a94c2d3$var$schedulePerformWorkUntilDeadline = function() {
    $a57bf6682a94c2d3$var$localSetImmediate($a57bf6682a94c2d3$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $a57bf6682a94c2d3$var$channel = new MessageChannel(), $a57bf6682a94c2d3$var$port = $a57bf6682a94c2d3$var$channel.port2;
    $a57bf6682a94c2d3$var$channel.port1.onmessage = $a57bf6682a94c2d3$var$performWorkUntilDeadline;
    $a57bf6682a94c2d3$var$schedulePerformWorkUntilDeadline = function() {
        $a57bf6682a94c2d3$var$port.postMessage(null);
    };
} else $a57bf6682a94c2d3$var$schedulePerformWorkUntilDeadline = function() {
    $a57bf6682a94c2d3$var$localSetTimeout($a57bf6682a94c2d3$var$performWorkUntilDeadline, 0);
};
function $a57bf6682a94c2d3$var$requestHostTimeout(callback, ms) {
    $a57bf6682a94c2d3$var$taskTimeoutID = $a57bf6682a94c2d3$var$localSetTimeout(function() {
        callback($a57bf6682a94c2d3$export$c4744153514ff05d());
    }, ms);
}
$a57bf6682a94c2d3$export$3e506c1ccc9cc1a7 = 5;
$a57bf6682a94c2d3$export$e26fe2ed2fa76875 = 1;
$a57bf6682a94c2d3$export$502329bbf4b505b1 = 4;
$a57bf6682a94c2d3$export$6e3807111c4874c4 = 3;
$a57bf6682a94c2d3$export$c27134553091fb3a = null;
$a57bf6682a94c2d3$export$33ee1acdc04fd2a2 = 2;
$a57bf6682a94c2d3$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$a57bf6682a94c2d3$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $a57bf6682a94c2d3$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$a57bf6682a94c2d3$export$d3dfb8e4810cb555 = function() {
    return $a57bf6682a94c2d3$var$currentPriorityLevel;
};
$a57bf6682a94c2d3$export$72fdf0e06517287b = function(eventHandler) {
    switch($a57bf6682a94c2d3$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $a57bf6682a94c2d3$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $a57bf6682a94c2d3$var$currentPriorityLevel;
    $a57bf6682a94c2d3$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $a57bf6682a94c2d3$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$a57bf6682a94c2d3$export$816d2913ae6b83b1 = function() {
    $a57bf6682a94c2d3$var$needsPaint = !0;
};
$a57bf6682a94c2d3$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $a57bf6682a94c2d3$var$currentPriorityLevel;
    $a57bf6682a94c2d3$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $a57bf6682a94c2d3$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$a57bf6682a94c2d3$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $a57bf6682a94c2d3$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $a57bf6682a94c2d3$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $a57bf6682a94c2d3$var$push($a57bf6682a94c2d3$var$timerQueue, priorityLevel), null === $a57bf6682a94c2d3$var$peek($a57bf6682a94c2d3$var$taskQueue) && priorityLevel === $a57bf6682a94c2d3$var$peek($a57bf6682a94c2d3$var$timerQueue) && ($a57bf6682a94c2d3$var$isHostTimeoutScheduled ? ($a57bf6682a94c2d3$var$localClearTimeout($a57bf6682a94c2d3$var$taskTimeoutID), $a57bf6682a94c2d3$var$taskTimeoutID = -1) : $a57bf6682a94c2d3$var$isHostTimeoutScheduled = !0, $a57bf6682a94c2d3$var$requestHostTimeout($a57bf6682a94c2d3$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $a57bf6682a94c2d3$var$push($a57bf6682a94c2d3$var$taskQueue, priorityLevel), $a57bf6682a94c2d3$var$isHostCallbackScheduled || $a57bf6682a94c2d3$var$isPerformingWork || ($a57bf6682a94c2d3$var$isHostCallbackScheduled = !0, $a57bf6682a94c2d3$var$isMessageLoopRunning || ($a57bf6682a94c2d3$var$isMessageLoopRunning = !0, $a57bf6682a94c2d3$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$a57bf6682a94c2d3$export$b5836b71941fa3ed = $a57bf6682a94c2d3$var$shouldYieldToHost;
$a57bf6682a94c2d3$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $a57bf6682a94c2d3$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $a57bf6682a94c2d3$var$currentPriorityLevel;
        $a57bf6682a94c2d3$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $a57bf6682a94c2d3$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("5FkrB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dOp82"));

});
parcelRegister("dOp82", function(module, exports) {
$parcel$export(module.exports, "Activity", () => $a0e36fe08c1d6b8a$export$9c16c1426311996d, (v) => $a0e36fe08c1d6b8a$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $a0e36fe08c1d6b8a$export$dca3b0875bd9a954, (v) => $a0e36fe08c1d6b8a$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $a0e36fe08c1d6b8a$export$16fa2f45be04daa8, (v) => $a0e36fe08c1d6b8a$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $a0e36fe08c1d6b8a$export$ffb0004e005737fa, (v) => $a0e36fe08c1d6b8a$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $a0e36fe08c1d6b8a$export$e2c29f18771995cb, (v) => $a0e36fe08c1d6b8a$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $a0e36fe08c1d6b8a$export$221d75b3f55bb0bd, (v) => $a0e36fe08c1d6b8a$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $a0e36fe08c1d6b8a$export$5f8d39834fd61797, (v) => $a0e36fe08c1d6b8a$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a0e36fe08c1d6b8a$export$74bf444e3cd11ea5, (v) => $a0e36fe08c1d6b8a$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "ViewTransition", () => $a0e36fe08c1d6b8a$export$8cdaa4703948c5e9, (v) => $a0e36fe08c1d6b8a$export$8cdaa4703948c5e9 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $a0e36fe08c1d6b8a$export$1ced07cd6b1985ce, (v) => $a0e36fe08c1d6b8a$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $a0e36fe08c1d6b8a$export$abd8e32b826d7ea7, (v) => $a0e36fe08c1d6b8a$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "addTransitionType", () => $a0e36fe08c1d6b8a$export$87c99536b1b8cdd8, (v) => $a0e36fe08c1d6b8a$export$87c99536b1b8cdd8 = v);
$parcel$export(module.exports, "cache", () => $a0e36fe08c1d6b8a$export$69a3209f1a06c04d, (v) => $a0e36fe08c1d6b8a$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $a0e36fe08c1d6b8a$export$8c538325882c7eec, (v) => $a0e36fe08c1d6b8a$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $a0e36fe08c1d6b8a$export$e530037191fcd5d7, (v) => $a0e36fe08c1d6b8a$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $a0e36fe08c1d6b8a$export$fd42f52fd3ae1109, (v) => $a0e36fe08c1d6b8a$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $a0e36fe08c1d6b8a$export$c8a8987d4410bf2d, (v) => $a0e36fe08c1d6b8a$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $a0e36fe08c1d6b8a$export$7d1e3a5e95ceca43, (v) => $a0e36fe08c1d6b8a$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $a0e36fe08c1d6b8a$export$257a8862b851cb5b, (v) => $a0e36fe08c1d6b8a$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $a0e36fe08c1d6b8a$export$a8257692ac88316c, (v) => $a0e36fe08c1d6b8a$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $a0e36fe08c1d6b8a$export$488013bae63b21da, (v) => $a0e36fe08c1d6b8a$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $a0e36fe08c1d6b8a$export$7c73462e0d25e514, (v) => $a0e36fe08c1d6b8a$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $a0e36fe08c1d6b8a$export$7568632d0d33d16d, (v) => $a0e36fe08c1d6b8a$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $a0e36fe08c1d6b8a$export$f93f40ac0ca7e3a8, (v) => $a0e36fe08c1d6b8a$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $a0e36fe08c1d6b8a$export$1f96ae73734a86cc, (v) => $a0e36fe08c1d6b8a$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $a0e36fe08c1d6b8a$export$9a47ced3238df325, (v) => $a0e36fe08c1d6b8a$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $a0e36fe08c1d6b8a$export$35808ee640e87ca7, (v) => $a0e36fe08c1d6b8a$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $a0e36fe08c1d6b8a$export$fae74005e78b1a27, (v) => $a0e36fe08c1d6b8a$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $a0e36fe08c1d6b8a$export$dc8fbce3eb94dc1e, (v) => $a0e36fe08c1d6b8a$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $a0e36fe08c1d6b8a$export$6a7bc4e911dc01cf, (v) => $a0e36fe08c1d6b8a$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $a0e36fe08c1d6b8a$export$6d9c69b0de29b591, (v) => $a0e36fe08c1d6b8a$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $a0e36fe08c1d6b8a$export$7f54fc3180508a52, (v) => $a0e36fe08c1d6b8a$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $a0e36fe08c1d6b8a$export$f680877a34711e37, (v) => $a0e36fe08c1d6b8a$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $a0e36fe08c1d6b8a$export$d5a552a76deda3c2, (v) => $a0e36fe08c1d6b8a$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $a0e36fe08c1d6b8a$export$aaabe4eda9ed9969, (v) => $a0e36fe08c1d6b8a$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $a0e36fe08c1d6b8a$export$e5c5a5f917a5871c, (v) => $a0e36fe08c1d6b8a$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $a0e36fe08c1d6b8a$export$1538c33de8887b59, (v) => $a0e36fe08c1d6b8a$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $a0e36fe08c1d6b8a$export$fca7f784ae7a249a, (v) => $a0e36fe08c1d6b8a$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $a0e36fe08c1d6b8a$export$13e3392192263954, (v) => $a0e36fe08c1d6b8a$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $a0e36fe08c1d6b8a$export$b8f5890fc79d6aca, (v) => $a0e36fe08c1d6b8a$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $a0e36fe08c1d6b8a$export$60241385465d0a34, (v) => $a0e36fe08c1d6b8a$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $a0e36fe08c1d6b8a$export$306c0aa65ff9ec16, (v) => $a0e36fe08c1d6b8a$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $a0e36fe08c1d6b8a$export$7b286972b8d8ccbf, (v) => $a0e36fe08c1d6b8a$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $a0e36fe08c1d6b8a$export$83d89fbfd8236492, (v) => $a0e36fe08c1d6b8a$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a0e36fe08c1d6b8a$export$9c16c1426311996d;
var $a0e36fe08c1d6b8a$export$dca3b0875bd9a954;
var $a0e36fe08c1d6b8a$export$16fa2f45be04daa8;
var $a0e36fe08c1d6b8a$export$ffb0004e005737fa;
var $a0e36fe08c1d6b8a$export$e2c29f18771995cb;
var $a0e36fe08c1d6b8a$export$221d75b3f55bb0bd;
var $a0e36fe08c1d6b8a$export$5f8d39834fd61797;
var $a0e36fe08c1d6b8a$export$74bf444e3cd11ea5;
var $a0e36fe08c1d6b8a$export$8cdaa4703948c5e9;
var $a0e36fe08c1d6b8a$export$1ced07cd6b1985ce;
var $a0e36fe08c1d6b8a$export$abd8e32b826d7ea7;
var $a0e36fe08c1d6b8a$export$87c99536b1b8cdd8;
var $a0e36fe08c1d6b8a$export$69a3209f1a06c04d;
var $a0e36fe08c1d6b8a$export$8c538325882c7eec;
var $a0e36fe08c1d6b8a$export$e530037191fcd5d7;
var $a0e36fe08c1d6b8a$export$fd42f52fd3ae1109;
var $a0e36fe08c1d6b8a$export$c8a8987d4410bf2d;
var $a0e36fe08c1d6b8a$export$7d1e3a5e95ceca43;
var $a0e36fe08c1d6b8a$export$257a8862b851cb5b;
var $a0e36fe08c1d6b8a$export$a8257692ac88316c;
var $a0e36fe08c1d6b8a$export$488013bae63b21da;
var $a0e36fe08c1d6b8a$export$7c73462e0d25e514;
var $a0e36fe08c1d6b8a$export$7568632d0d33d16d;
var $a0e36fe08c1d6b8a$export$f93f40ac0ca7e3a8;
var $a0e36fe08c1d6b8a$export$1f96ae73734a86cc;
var $a0e36fe08c1d6b8a$export$9a47ced3238df325;
var $a0e36fe08c1d6b8a$export$35808ee640e87ca7;
var $a0e36fe08c1d6b8a$export$fae74005e78b1a27;
var $a0e36fe08c1d6b8a$export$dc8fbce3eb94dc1e;
var $a0e36fe08c1d6b8a$export$6a7bc4e911dc01cf;
var $a0e36fe08c1d6b8a$export$6d9c69b0de29b591;
var $a0e36fe08c1d6b8a$export$7f54fc3180508a52;
var $a0e36fe08c1d6b8a$export$f680877a34711e37;
var $a0e36fe08c1d6b8a$export$d5a552a76deda3c2;
var $a0e36fe08c1d6b8a$export$aaabe4eda9ed9969;
var $a0e36fe08c1d6b8a$export$e5c5a5f917a5871c;
var $a0e36fe08c1d6b8a$export$1538c33de8887b59;
var $a0e36fe08c1d6b8a$export$fca7f784ae7a249a;
var $a0e36fe08c1d6b8a$export$13e3392192263954;
var $a0e36fe08c1d6b8a$export$b8f5890fc79d6aca;
var $a0e36fe08c1d6b8a$export$60241385465d0a34;
var $a0e36fe08c1d6b8a$export$306c0aa65ff9ec16;
var $a0e36fe08c1d6b8a$export$7b286972b8d8ccbf;
var $a0e36fe08c1d6b8a$export$83d89fbfd8236492;

var $3ZMUU = parcelRequire("3ZMUU");
"use strict";
var $a0e36fe08c1d6b8a$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $a0e36fe08c1d6b8a$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $a0e36fe08c1d6b8a$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $a0e36fe08c1d6b8a$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $a0e36fe08c1d6b8a$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $a0e36fe08c1d6b8a$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $a0e36fe08c1d6b8a$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $a0e36fe08c1d6b8a$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $a0e36fe08c1d6b8a$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $a0e36fe08c1d6b8a$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $a0e36fe08c1d6b8a$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $a0e36fe08c1d6b8a$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $a0e36fe08c1d6b8a$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $a0e36fe08c1d6b8a$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $a0e36fe08c1d6b8a$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $a0e36fe08c1d6b8a$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$a0e36fe08c1d6b8a$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $a0e36fe08c1d6b8a$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $a0e36fe08c1d6b8a$var$assign = Object.assign, $a0e36fe08c1d6b8a$var$emptyObject = {};
function $a0e36fe08c1d6b8a$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $a0e36fe08c1d6b8a$var$emptyObject;
    this.updater = updater || $a0e36fe08c1d6b8a$var$ReactNoopUpdateQueue;
}
$a0e36fe08c1d6b8a$var$Component.prototype.isReactComponent = {};
$a0e36fe08c1d6b8a$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$a0e36fe08c1d6b8a$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $a0e36fe08c1d6b8a$var$ComponentDummy() {}
$a0e36fe08c1d6b8a$var$ComponentDummy.prototype = $a0e36fe08c1d6b8a$var$Component.prototype;
function $a0e36fe08c1d6b8a$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $a0e36fe08c1d6b8a$var$emptyObject;
    this.updater = updater || $a0e36fe08c1d6b8a$var$ReactNoopUpdateQueue;
}
var $a0e36fe08c1d6b8a$var$pureComponentPrototype = $a0e36fe08c1d6b8a$var$PureComponent.prototype = new $a0e36fe08c1d6b8a$var$ComponentDummy();
$a0e36fe08c1d6b8a$var$pureComponentPrototype.constructor = $a0e36fe08c1d6b8a$var$PureComponent;
$a0e36fe08c1d6b8a$var$assign($a0e36fe08c1d6b8a$var$pureComponentPrototype, $a0e36fe08c1d6b8a$var$Component.prototype);
$a0e36fe08c1d6b8a$var$pureComponentPrototype.isPureReactComponent = !0;
var $a0e36fe08c1d6b8a$var$isArrayImpl = Array.isArray;
function $a0e36fe08c1d6b8a$var$noop() {}
var $a0e36fe08c1d6b8a$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $a0e36fe08c1d6b8a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $a0e36fe08c1d6b8a$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $a0e36fe08c1d6b8a$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $a0e36fe08c1d6b8a$var$cloneAndReplaceKey(oldElement, newKey) {
    return $a0e36fe08c1d6b8a$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $a0e36fe08c1d6b8a$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $a0e36fe08c1d6b8a$var$REACT_ELEMENT_TYPE;
}
function $a0e36fe08c1d6b8a$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $a0e36fe08c1d6b8a$var$userProvidedKeyEscapeRegex = /\/+/g;
function $a0e36fe08c1d6b8a$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $a0e36fe08c1d6b8a$var$escape("" + element.key) : index.toString(36);
}
function $a0e36fe08c1d6b8a$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($a0e36fe08c1d6b8a$var$noop, $a0e36fe08c1d6b8a$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $a0e36fe08c1d6b8a$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $a0e36fe08c1d6b8a$var$REACT_ELEMENT_TYPE:
                case $a0e36fe08c1d6b8a$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $a0e36fe08c1d6b8a$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $a0e36fe08c1d6b8a$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $a0e36fe08c1d6b8a$var$getElementKey(children, 0) : nameSoFar, $a0e36fe08c1d6b8a$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($a0e36fe08c1d6b8a$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $a0e36fe08c1d6b8a$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($a0e36fe08c1d6b8a$var$isValidElement(callback) && (callback = $a0e36fe08c1d6b8a$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($a0e36fe08c1d6b8a$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($a0e36fe08c1d6b8a$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $a0e36fe08c1d6b8a$var$getElementKey(nameSoFar, i), invokeCallback += $a0e36fe08c1d6b8a$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $a0e36fe08c1d6b8a$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $a0e36fe08c1d6b8a$var$getElementKey(nameSoFar, i++), invokeCallback += $a0e36fe08c1d6b8a$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $a0e36fe08c1d6b8a$var$mapIntoArray($a0e36fe08c1d6b8a$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $a0e36fe08c1d6b8a$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $a0e36fe08c1d6b8a$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $a0e36fe08c1d6b8a$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result, thenable = ctor();
        thenable.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject, void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error, void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
        });
        -1 === payload._status && (payload._status = 0, payload._result = thenable);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $a0e36fe08c1d6b8a$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $3ZMUU && "function" === typeof $3ZMUU.emit) {
        $3ZMUU.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $a0e36fe08c1d6b8a$var$startTransition(scope) {
    var prevTransition = $a0e36fe08c1d6b8a$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $a0e36fe08c1d6b8a$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $a0e36fe08c1d6b8a$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($a0e36fe08c1d6b8a$var$noop, $a0e36fe08c1d6b8a$var$reportGlobalError);
    } catch (error) {
        $a0e36fe08c1d6b8a$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $a0e36fe08c1d6b8a$var$ReactSharedInternals.T = prevTransition;
    }
}
function $a0e36fe08c1d6b8a$var$addTransitionType(type) {
    var transition = $a0e36fe08c1d6b8a$var$ReactSharedInternals.T;
    if (null !== transition) {
        var transitionTypes = transition.types;
        null === transitionTypes ? transition.types = [
            type
        ] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
    } else $a0e36fe08c1d6b8a$var$startTransition($a0e36fe08c1d6b8a$var$addTransitionType.bind(null, type));
}
var $a0e36fe08c1d6b8a$var$Children = {
    map: $a0e36fe08c1d6b8a$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $a0e36fe08c1d6b8a$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $a0e36fe08c1d6b8a$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $a0e36fe08c1d6b8a$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$a0e36fe08c1d6b8a$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$a0e36fe08c1d6b8a$export$9c16c1426311996d = $a0e36fe08c1d6b8a$var$REACT_ACTIVITY_TYPE;
$a0e36fe08c1d6b8a$export$dca3b0875bd9a954 = $a0e36fe08c1d6b8a$var$Children;
$a0e36fe08c1d6b8a$export$16fa2f45be04daa8 = $a0e36fe08c1d6b8a$var$Component;
$a0e36fe08c1d6b8a$export$ffb0004e005737fa = $a0e36fe08c1d6b8a$var$REACT_FRAGMENT_TYPE;
$a0e36fe08c1d6b8a$export$e2c29f18771995cb = $a0e36fe08c1d6b8a$var$REACT_PROFILER_TYPE;
$a0e36fe08c1d6b8a$export$221d75b3f55bb0bd = $a0e36fe08c1d6b8a$var$PureComponent;
$a0e36fe08c1d6b8a$export$5f8d39834fd61797 = $a0e36fe08c1d6b8a$var$REACT_STRICT_MODE_TYPE;
$a0e36fe08c1d6b8a$export$74bf444e3cd11ea5 = $a0e36fe08c1d6b8a$var$REACT_SUSPENSE_TYPE;
$a0e36fe08c1d6b8a$export$8cdaa4703948c5e9 = $a0e36fe08c1d6b8a$var$REACT_VIEW_TRANSITION_TYPE;
$a0e36fe08c1d6b8a$export$1ced07cd6b1985ce = $a0e36fe08c1d6b8a$var$ReactSharedInternals;
$a0e36fe08c1d6b8a$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $a0e36fe08c1d6b8a$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$a0e36fe08c1d6b8a$export$87c99536b1b8cdd8 = $a0e36fe08c1d6b8a$var$addTransitionType;
$a0e36fe08c1d6b8a$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$a0e36fe08c1d6b8a$export$8c538325882c7eec = function() {
    return null;
};
$a0e36fe08c1d6b8a$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $a0e36fe08c1d6b8a$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$a0e36fe08c1d6b8a$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $a0e36fe08c1d6b8a$var$ReactElement(element.type, key, props);
};
$a0e36fe08c1d6b8a$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $a0e36fe08c1d6b8a$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $a0e36fe08c1d6b8a$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$a0e36fe08c1d6b8a$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$a0e36fe08c1d6b8a$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $a0e36fe08c1d6b8a$var$ReactElement(type, key, props);
};
$a0e36fe08c1d6b8a$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$a0e36fe08c1d6b8a$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $a0e36fe08c1d6b8a$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$a0e36fe08c1d6b8a$export$a8257692ac88316c = $a0e36fe08c1d6b8a$var$isValidElement;
$a0e36fe08c1d6b8a$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $a0e36fe08c1d6b8a$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $a0e36fe08c1d6b8a$var$lazyInitializer
    };
};
$a0e36fe08c1d6b8a$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $a0e36fe08c1d6b8a$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$a0e36fe08c1d6b8a$export$7568632d0d33d16d = $a0e36fe08c1d6b8a$var$startTransition;
$a0e36fe08c1d6b8a$export$f93f40ac0ca7e3a8 = function() {
    return $a0e36fe08c1d6b8a$var$ReactSharedInternals.H.useCacheRefresh();
};
$a0e36fe08c1d6b8a$export$1f96ae73734a86cc = function(usable) {
    return $a0e36fe08c1d6b8a$var$ReactSharedInternals.H.use(usable);
};
$a0e36fe08c1d6b8a$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $a0e36fe08c1d6b8a$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$a0e36fe08c1d6b8a$export$35808ee640e87ca7 = function(callback, deps) {
    return $a0e36fe08c1d6b8a$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$a0e36fe08c1d6b8a$export$fae74005e78b1a27 = function(Context) {
    return $a0e36fe08c1d6b8a$var$ReactSharedInternals.H.useContext(Context);
};
$a0e36fe08c1d6b8a$export$dc8fbce3eb94dc1e = function() {};
$a0e36fe08c1d6b8a$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $a0e36fe08c1d6b8a$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$a0e36fe08c1d6b8a$export$6d9c69b0de29b591 = function(create, deps) {
    return $a0e36fe08c1d6b8a$var$ReactSharedInternals.H.useEffect(create, deps);
};
$a0e36fe08c1d6b8a$export$7f54fc3180508a52 = function(callback) {
    return $a0e36fe08c1d6b8a$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$a0e36fe08c1d6b8a$export$f680877a34711e37 = function() {
    return $a0e36fe08c1d6b8a$var$ReactSharedInternals.H.useId();
};
$a0e36fe08c1d6b8a$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $a0e36fe08c1d6b8a$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$a0e36fe08c1d6b8a$export$aaabe4eda9ed9969 = function(create, deps) {
    return $a0e36fe08c1d6b8a$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$a0e36fe08c1d6b8a$export$e5c5a5f917a5871c = function(create, deps) {
    return $a0e36fe08c1d6b8a$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$a0e36fe08c1d6b8a$export$1538c33de8887b59 = function(create, deps) {
    return $a0e36fe08c1d6b8a$var$ReactSharedInternals.H.useMemo(create, deps);
};
$a0e36fe08c1d6b8a$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $a0e36fe08c1d6b8a$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$a0e36fe08c1d6b8a$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $a0e36fe08c1d6b8a$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$a0e36fe08c1d6b8a$export$b8f5890fc79d6aca = function(initialValue) {
    return $a0e36fe08c1d6b8a$var$ReactSharedInternals.H.useRef(initialValue);
};
$a0e36fe08c1d6b8a$export$60241385465d0a34 = function(initialState) {
    return $a0e36fe08c1d6b8a$var$ReactSharedInternals.H.useState(initialState);
};
$a0e36fe08c1d6b8a$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $a0e36fe08c1d6b8a$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$a0e36fe08c1d6b8a$export$7b286972b8d8ccbf = function() {
    return $a0e36fe08c1d6b8a$var$ReactSharedInternals.H.useTransition();
};
$a0e36fe08c1d6b8a$export$83d89fbfd8236492 = "19.3.0";

});


parcelRegister("aLeHs", function(module, exports) {
'use strict';
function $7d59b24134129acf$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7d59b24134129acf$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7d59b24134129acf$var$checkDCE();

module.exports = (parcelRequire("kT5T9"));

});
parcelRegister("kT5T9", function(module, exports) {
$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $f34d830fff37132e$export$69ce8ef3fe5cead0, (v) => $f34d830fff37132e$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "browser", () => $f34d830fff37132e$export$3f2684e5d7cb1006, (v) => $f34d830fff37132e$export$3f2684e5d7cb1006 = v);
$parcel$export(module.exports, "createPortal", () => $f34d830fff37132e$export$d39a5bbd09211389, (v) => $f34d830fff37132e$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $f34d830fff37132e$export$cd75ccfd720a3cd4, (v) => $f34d830fff37132e$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $f34d830fff37132e$export$a0816fa17a9e79be, (v) => $f34d830fff37132e$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $f34d830fff37132e$export$7292efcadded39f3, (v) => $f34d830fff37132e$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $f34d830fff37132e$export$da407abadb9b8f86, (v) => $f34d830fff37132e$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $f34d830fff37132e$export$314cfea32580671c, (v) => $f34d830fff37132e$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $f34d830fff37132e$export$513ccb98c53b8039, (v) => $f34d830fff37132e$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $f34d830fff37132e$export$dbca993bc2d264a, (v) => $f34d830fff37132e$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $f34d830fff37132e$export$4797a8006f0655d0, (v) => $f34d830fff37132e$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $f34d830fff37132e$export$c78a37762a8d58e1, (v) => $f34d830fff37132e$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $f34d830fff37132e$export$606f11b2eb45ecc6, (v) => $f34d830fff37132e$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $f34d830fff37132e$export$f7e8a0bf92324b1e, (v) => $f34d830fff37132e$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $f34d830fff37132e$export$83d89fbfd8236492, (v) => $f34d830fff37132e$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f34d830fff37132e$export$69ce8ef3fe5cead0;
var $f34d830fff37132e$export$3f2684e5d7cb1006;
var $f34d830fff37132e$export$d39a5bbd09211389;
var $f34d830fff37132e$export$cd75ccfd720a3cd4;
var $f34d830fff37132e$export$a0816fa17a9e79be;
var $f34d830fff37132e$export$7292efcadded39f3;
var $f34d830fff37132e$export$da407abadb9b8f86;
var $f34d830fff37132e$export$314cfea32580671c;
var $f34d830fff37132e$export$513ccb98c53b8039;
var $f34d830fff37132e$export$dbca993bc2d264a;
var $f34d830fff37132e$export$4797a8006f0655d0;
var $f34d830fff37132e$export$c78a37762a8d58e1;
var $f34d830fff37132e$export$606f11b2eb45ecc6;
var $f34d830fff37132e$export$f7e8a0bf92324b1e;
var $f34d830fff37132e$export$83d89fbfd8236492;
"use strict";

var $5FkrB = parcelRequire("5FkrB");
function $f34d830fff37132e$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $f34d830fff37132e$var$noop() {}
var $f34d830fff37132e$var$Internals = {
    d: {
        f: $f34d830fff37132e$var$noop,
        r: function() {
            throw Error($f34d830fff37132e$var$formatProdErrorMessage(522));
        },
        D: $f34d830fff37132e$var$noop,
        C: $f34d830fff37132e$var$noop,
        L: $f34d830fff37132e$var$noop,
        m: $f34d830fff37132e$var$noop,
        X: $f34d830fff37132e$var$noop,
        S: $f34d830fff37132e$var$noop,
        M: $f34d830fff37132e$var$noop
    },
    p: 0,
    findDOMNode: null
}, $f34d830fff37132e$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $f34d830fff37132e$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $f34d830fff37132e$var$REACT_OPTIMISTIC_KEY = Symbol.for("react.optimistic_key");
function $f34d830fff37132e$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $f34d830fff37132e$var$REACT_PORTAL_TYPE,
        key: null == key ? null : key === $f34d830fff37132e$var$REACT_OPTIMISTIC_KEY ? $f34d830fff37132e$var$REACT_OPTIMISTIC_KEY : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $f34d830fff37132e$var$ReactSharedInternals = $5FkrB.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $f34d830fff37132e$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$f34d830fff37132e$export$69ce8ef3fe5cead0 = $f34d830fff37132e$var$Internals;
$f34d830fff37132e$export$3f2684e5d7cb1006 = function(reason) {
    return {
        $$typeof: $f34d830fff37132e$var$REACT_RECOVERABLE_TYPE,
        _reason: reason
    };
};
$f34d830fff37132e$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($f34d830fff37132e$var$formatProdErrorMessage(299));
    return $f34d830fff37132e$var$createPortal$1(children, container, null, key);
};
$f34d830fff37132e$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $f34d830fff37132e$var$ReactSharedInternals.T, previousUpdatePriority = $f34d830fff37132e$var$Internals.p;
    try {
        if ($f34d830fff37132e$var$ReactSharedInternals.T = null, $f34d830fff37132e$var$Internals.p = 2, fn) return fn();
    } finally{
        $f34d830fff37132e$var$ReactSharedInternals.T = previousTransition, $f34d830fff37132e$var$Internals.p = previousUpdatePriority, $f34d830fff37132e$var$Internals.d.f();
    }
};
$f34d830fff37132e$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $f34d830fff37132e$var$Internals.d.C(href, options));
};
$f34d830fff37132e$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $f34d830fff37132e$var$Internals.d.D(href);
};
$f34d830fff37132e$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $f34d830fff37132e$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $f34d830fff37132e$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $f34d830fff37132e$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$f34d830fff37132e$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $f34d830fff37132e$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $f34d830fff37132e$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                    fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
                });
            }
        } else null == options && $f34d830fff37132e$var$Internals.d.M(href);
    }
};
$f34d830fff37132e$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $f34d830fff37132e$var$getCrossOriginStringAs(as, options.crossOrigin);
        $f34d830fff37132e$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$f34d830fff37132e$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $f34d830fff37132e$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $f34d830fff37132e$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
            });
        } else $f34d830fff37132e$var$Internals.d.m(href);
    }
};
$f34d830fff37132e$export$4797a8006f0655d0 = function(form) {
    $f34d830fff37132e$var$Internals.d.r(form);
};
$f34d830fff37132e$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$f34d830fff37132e$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $f34d830fff37132e$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$f34d830fff37132e$export$f7e8a0bf92324b1e = function() {
    return $f34d830fff37132e$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$f34d830fff37132e$export$83d89fbfd8236492 = "19.3.0";

});




parcelRegister("6lN5g", function(module, exports) {
$parcel$export(module.exports, "themeStateDefaults", () => $49fac74827b8f0a3$export$9aedcfa7336a207);
/**
 * Can't evaluate typography feature flags at the module level,
 * it will always resolve to false when server side rendered or when flags are loaded async.
 */ function $49fac74827b8f0a3$var$getMotionDefault() {
    return 'motion';
}
var $49fac74827b8f0a3$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: 'shape',
    spacing: 'spacing',
    typography: 'typography',
    motion: $49fac74827b8f0a3$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};

});

parcelRegister("iYJcE", function(module, exports) {

var $4rHdx = parcelRequire("4rHdx");

var $1YVwW = parcelRequire("1YVwW");

var $ccaOk = parcelRequire("ccaOk");

var $lzFPZ = parcelRequire("lzFPZ");
function $dd10e4fe59ebf2c1$var$_slicedToArray(r, e) {
    return $4rHdx(r) || $1YVwW(r, e) || $ccaOk(r, e) || $lzFPZ();
}
module.exports = $dd10e4fe59ebf2c1$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4rHdx", function(module, exports) {
function $33cb35214efb072a$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $33cb35214efb072a$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1YVwW", function(module, exports) {
function $1718055c8ee40965$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $1718055c8ee40965$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ccaOk", function(module, exports) {

var $7Edli = parcelRequire("7Edli");
function $8e0efdd2cb2ea886$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7Edli(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7Edli(r, a) : void 0;
    }
}
module.exports = $8e0efdd2cb2ea886$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7Edli", function(module, exports) {
function $59169e612a7ccfc3$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $59169e612a7ccfc3$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("lzFPZ", function(module, exports) {
function $fb4d51eeedba6c65$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $fb4d51eeedba6c65$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("50U6m", function(module, exports) {
$parcel$export(module.exports, "fg", () => $3a687875757f8eea$export$b40ec24ac8275656);

var $i5SqG = parcelRequire("i5SqG");
function $3a687875757f8eea$export$b40ec24ac8275656(name) {
    return (0, $i5SqG.resolveBooleanFlag)(name);
}

});
parcelRegister("i5SqG", function(module, exports) {
$parcel$export(module.exports, "resolveBooleanFlag", () => $d2c2ea276273a3b9$export$6333b6aff9fc6275);

var $ISKn7 = parcelRequire("ISKn7");

var $kjcRI = parcelRequire("kjcRI");

var $9i3MK = parcelRequire("9i3MK");

var $iuNyR = parcelRequire("iuNyR");

var $e2P9b = parcelRequire("e2P9b");

var $lLIS3 = parcelRequire("lLIS3");
var $d2c2ea276273a3b9$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $9i3MK.ENV_ENABLE_PLATFORM_FF) || (0, $iuNyR.ENV_STORYBOOK_ENABLE_PLATFORM_FF);
function $d2c2ea276273a3b9$export$6333b6aff9fc6275(flagKey) {
    if ($d2c2ea276273a3b9$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $kjcRI.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $lLIS3.pkgName), flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = (0, $e2P9b.globalVar)[0, $lLIS3.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = (0, $e2P9b.globalVar)[0, $lLIS3.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $ISKn7.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = (0, $e2P9b.globalVar)[0, $lLIS3.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("ISKn7", function(module, exports) {
$parcel$export(module.exports, "default", () => $086e93c69a5d1ec0$export$2e2bcd8739ae039);
$parcel$export(module.exports, "CLIENT_VERSION", () => (parcelRequire("7HOhT")).CLIENT_VERSION);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $5rlAb = parcelRequire("5rlAb");

var $7HOhT = parcelRequire("7HOhT");



var $hiARP = parcelRequire("hiARP");
var $086e93c69a5d1ec0$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $086e93c69a5d1ec0$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$086e93c69a5d1ec0$var$_FeatureGates = $086e93c69a5d1ec0$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "client", new (0, $5rlAb.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$086e93c69a5d1ec0$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $086e93c69a5d1ec0$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $086e93c69a5d1ec0$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$086e93c69a5d1ec0$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $086e93c69a5d1ec0$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $086e93c69a5d1ec0$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "initializeCalled", $086e93c69a5d1ec0$var$_FeatureGates.client.initializeCalled.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "initializeCompleted", $086e93c69a5d1ec0$var$_FeatureGates.client.initializeCompleted.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "waitUntilInitializeCompleted", $086e93c69a5d1ec0$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "initialize", $086e93c69a5d1ec0$var$_FeatureGates.client.initialize.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "initializeWithProvider", $086e93c69a5d1ec0$var$_FeatureGates.client.initializeWithProvider.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "initializeFromValues", $086e93c69a5d1ec0$var$_FeatureGates.client.initializeFromValues.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "manuallyLogGateExposure", $086e93c69a5d1ec0$var$_FeatureGates.client.manuallyLogGateExposure.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "getExperiment", $086e93c69a5d1ec0$var$_FeatureGates.client.getExperiment.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "manuallyLogExperimentExposure", $086e93c69a5d1ec0$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "manuallyLogLayerExposure", $086e93c69a5d1ec0$var$_FeatureGates.client.manuallyLogLayerExposure.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "shutdownStatsig", $086e93c69a5d1ec0$var$_FeatureGates.client.shutdownStatsig.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "overrideGate", $086e93c69a5d1ec0$var$_FeatureGates.client.overrideGate.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "clearGateOverride", $086e93c69a5d1ec0$var$_FeatureGates.client.clearGateOverride.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "overrideConfig", $086e93c69a5d1ec0$var$_FeatureGates.client.overrideConfig.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "clearConfigOverride", $086e93c69a5d1ec0$var$_FeatureGates.client.clearConfigOverride.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "setOverrides", $086e93c69a5d1ec0$var$_FeatureGates.client.setOverrides.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "getOverrides", $086e93c69a5d1ec0$var$_FeatureGates.client.getOverrides.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "clearAllOverrides", $086e93c69a5d1ec0$var$_FeatureGates.client.clearAllOverrides.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "isCurrentUser", $086e93c69a5d1ec0$var$_FeatureGates.client.isCurrentUser.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "onGateUpdated", $086e93c69a5d1ec0$var$_FeatureGates.client.onGateUpdated.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "onExperimentValueUpdated", $086e93c69a5d1ec0$var$_FeatureGates.client.onExperimentValueUpdated.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "onAnyUpdated", $086e93c69a5d1ec0$var$_FeatureGates.client.onAnyUpdated.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "updateUser", $086e93c69a5d1ec0$var$_FeatureGates.client.updateUser.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "updateUserWithProvider", $086e93c69a5d1ec0$var$_FeatureGates.client.updateUserWithProvider.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "updateUserWithValues", $086e93c69a5d1ec0$var$_FeatureGates.client.updateUserWithValues.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "getPackageVersion", $086e93c69a5d1ec0$var$_FeatureGates.client.getPackageVersion.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "getTargetApp", $086e93c69a5d1ec0$var$_FeatureGates.client.getTargetApp.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "getLayer", $086e93c69a5d1ec0$var$_FeatureGates.client.getLayer.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "getLayerValue", $086e93c69a5d1ec0$var$_FeatureGates.client.getLayerValue.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
var $086e93c69a5d1ec0$var$boundFGJS = $086e93c69a5d1ec0$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $086e93c69a5d1ec0$var$FeatureGates;
    else {
        var $086e93c69a5d1ec0$var$_boundFGJS, $086e93c69a5d1ec0$var$_boundFGJS$getPackage;
        $086e93c69a5d1ec0$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $086e93c69a5d1ec0$var$boundVersion = (($086e93c69a5d1ec0$var$_boundFGJS = $086e93c69a5d1ec0$var$boundFGJS) === null || $086e93c69a5d1ec0$var$_boundFGJS === void 0 || ($086e93c69a5d1ec0$var$_boundFGJS$getPackage = $086e93c69a5d1ec0$var$_boundFGJS.getPackageVersion) === null || $086e93c69a5d1ec0$var$_boundFGJS$getPackage === void 0 ? void 0 : $086e93c69a5d1ec0$var$_boundFGJS$getPackage.call($086e93c69a5d1ec0$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($086e93c69a5d1ec0$var$boundVersion !== (0, $7HOhT.CLIENT_VERSION)) {
            var $086e93c69a5d1ec0$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($086e93c69a5d1ec0$var$boundVersion, " when module version ").concat((0, $7HOhT.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($086e93c69a5d1ec0$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $086e93c69a5d1ec0$export$2e2bcd8739ae039 = $086e93c69a5d1ec0$var$boundFGJS;

});
parcelRegister("9P61R", function(module, exports) {
function $726d8db65a256fd4$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $726d8db65a256fd4$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("arMYe", function(module, exports) {

var $l5tDI = parcelRequire("l5tDI");
function $79b2697ff32e0117$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $l5tDI(o.key), o);
    }
}
function $79b2697ff32e0117$var$_createClass(e, r, t) {
    return r && $79b2697ff32e0117$var$_defineProperties(e.prototype, r), t && $79b2697ff32e0117$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $79b2697ff32e0117$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("l5tDI", function(module, exports) {

var $ekGgq = parcelRequire("ekGgq");
var $f5a10e61d0aa9357$var$_typeof = $ekGgq.default;

var $hmjpV = parcelRequire("hmjpV");
function $f5a10e61d0aa9357$var$toPropertyKey(t) {
    var i = $hmjpV(t, "string");
    return "symbol" == $f5a10e61d0aa9357$var$_typeof(i) ? i : i + "";
}
module.exports = $f5a10e61d0aa9357$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ekGgq", function(module, exports) {
function $a6f3b7a9d572ec57$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $a6f3b7a9d572ec57$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $a6f3b7a9d572ec57$var$_typeof(o);
}
module.exports = $a6f3b7a9d572ec57$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hmjpV", function(module, exports) {

var $ekGgq = parcelRequire("ekGgq");
var $ca338d9498474816$var$_typeof = $ekGgq.default;
function $ca338d9498474816$var$toPrimitive(t, r) {
    if ("object" != $ca338d9498474816$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ca338d9498474816$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $ca338d9498474816$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("25nEq", function(module, exports) {

var $l5tDI = parcelRequire("l5tDI");
function $184e64fa7279c0f0$var$_defineProperty(e, r, t) {
    return (r = $l5tDI(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $184e64fa7279c0f0$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5rlAb", function(module, exports) {
$parcel$export(module.exports, "Client", () => $3f603739ccb347dd$export$1f2bb630327ac4b6);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");

var $5sFjq = parcelRequire("5sFjq");

var $kkQZA = parcelRequire("kkQZA");

var $eVlof = parcelRequire("eVlof");

var $48eYA = parcelRequire("48eYA");

var $9sCMD = parcelRequire("9sCMD");

var $hzt3R = parcelRequire("hzt3R");

var $2y8p6 = parcelRequire("2y8p6");

var $f0l1D = parcelRequire("f0l1D");

var $2usPa = parcelRequire("2usPa");

var $j3SRh = parcelRequire("j3SRh");

var $55r6R = parcelRequire("55r6R");

var $3yi6c = parcelRequire("3yi6c");

var $hiARP = parcelRequire("hiARP");

var $7HOhT = parcelRequire("7HOhT");
var $3f603739ccb347dd$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $3f603739ccb347dd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3f603739ccb347dd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3f603739ccb347dd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3f603739ccb347dd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3f603739ccb347dd$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $3f603739ccb347dd$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $3f603739ccb347dd$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $j3SRh.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscriptions", new (0, $5sFjq.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "dataAdapter", new (0, $2usPa.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $j3SRh.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $2y8p6.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 1;
                                    break;
                                }
                                if (!(0, $55r6R.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $2y8p6.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 1;
                                    break;
                                }
                                if (!(0, $55r6R.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $7HOhT.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $3f603739ccb347dd$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $7HOhT.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $hiARP.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $2y8p6.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 1;
                                    break;
                                }
                                if (!(0, $55r6R.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 1:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $2y8p6.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $hzt3R.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 1;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 1:
                                _context5.next = 2;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 2:
                                _context5.next = 3;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 1:
                                if (!this.initCompleted) {
                                    _context7.next = 2;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 2:
                                _context7.next = 3;
                                return this.initPromise;
                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $kkQZA.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $kkQZA.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $48eYA.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $55r6R.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $55r6R.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $3f603739ccb347dd$var$_objectSpread({}, clientOptions);
                                if (!clientOptions.localMode) {
                                    _context8.next = 2;
                                    break;
                                }
                                _context8.next = 1;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 1:
                                return _context8.abrupt("return");
                            case 2:
                                _context8.prev = 2;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $hzt3R.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $hzt3R.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 6;
                                break;
                            case 4:
                                _context8.prev = 4;
                                _t = _context8["catch"](2);
                                if (_t instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t === null || _t === void 0 ? void 0 : _t.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t;
                            case 6:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            2,
                            4
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $3f603739ccb347dd$var$_objectSpread($3f603739ccb347dd$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 2;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 2:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 6;
                                break;
                            case 4:
                                _context9.prev = 4;
                                _t2 = _context9["catch"](1);
                                if (_t2 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t2 === null || _t2 === void 0 ? void 0 : _t2.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t2;
                            case 6:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            4
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, _args0 = arguments, _t3;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $f0l1D.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $3f603739ccb347dd$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $3f603739ccb347dd$var$_objectSpread($3f603739ccb347dd$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $3f603739ccb347dd$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $hiARP.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(newClientOptions, $3f603739ccb347dd$var$_excluded);
                                frontendUser = (0, $3yi6c.toStatsigUser)(identifiers, customAttributes);
                                this.user = (0, $9sCMD.deepAssign)({}, initializeValues.user, frontendUser);
                                statsigOptions = $3f603739ccb347dd$var$_objectSpread($3f603739ccb347dd$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 1;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 2;
                                return this.statsigClient.initializeAsync();
                            case 2:
                                _context0.next = 5;
                                break;
                            case 3:
                                _context0.prev = 3;
                                _t3 = _context0["catch"](1);
                                if (_t3 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_t3 === null || _t3 === void 0 ? void 0 : _t3.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($3f603739ccb347dd$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 4;
                                return this.statsigClient.initializeAsync();
                            case 4:
                                this.initWithDefaults = true;
                                throw _t3;
                            case 5:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise, _t4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 1:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 2;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 2:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 3;
                                _context10.next = 4;
                                return this.initPromise;
                            case 4:
                                _context10.next = 6;
                                break;
                            case 5:
                                _context10.prev = 5;
                                _t4 = _context10["catch"](3);
                            case 6:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 1;
                                                    break;
                                                }
                                                _context1.next = 1;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 1:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 7:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            3,
                            5
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, frontendUser, _updateUserCompletion, _ref4, errMsg, success, errorMessage, _t5, _t6;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 2;
                                return initializeValuesPromise;
                            case 2:
                                initializeValues = _context11.sent;
                                frontendUser = (0, $3yi6c.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, $9sCMD.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
                                _context11.next = 4;
                                break;
                            case 3:
                                _context11.prev = 3;
                                _t5 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _t5 instanceof Error ? _t5.message : JSON.stringify(_t5);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _t5;
                            case 4:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 5;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 6;
                                    break;
                                }
                                _context11.next = 6;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 6:
                                _context11.next = 8;
                                break;
                            case 7:
                                _context11.prev = 7;
                                _t6 = _context11["catch"](5);
                                success = false;
                                errorMessage = String(_t6);
                            case 8:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 9;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 10;
                                break;
                            case 9:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 10:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            3
                        ],
                        [
                            5,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $7HOhT.CLIENT_VERSION;
            }
        },
        {
            key: "getTargetApp",
            value: function getTargetApp() {
                var _this$initOptions2;
                return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $eVlof.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $eVlof.Layer).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("1Vcia", function(module, exports) {

var $19a0g = parcelRequire("19a0g");
function $1664a63d282a7249$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $19a0g(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $1664a63d282a7249$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("19a0g", function(module, exports) {
function $0d5e64210d12b637$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $0d5e64210d12b637$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fL8KA", function(module, exports) {
function $b7920873e945f960$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $b7920873e945f960$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $b7920873e945f960$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $b7920873e945f960$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $b7920873e945f960$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6HG4S", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $4e1765f344e6d069$var$runtime = (parcelRequire("3F8qK"))();
module.exports = $4e1765f344e6d069$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $4e1765f344e6d069$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $4e1765f344e6d069$var$runtime;
    else Function("r", "regeneratorRuntime = r")($4e1765f344e6d069$var$runtime);
}

});
parcelRegister("3F8qK", function(module, exports) {

var $bqia9 = parcelRequire("bqia9");

var $7gzA9 = parcelRequire("7gzA9");

var $lLusz = parcelRequire("lLusz");

var $4NonZ = parcelRequire("4NonZ");

var $9vGAG = parcelRequire("9vGAG");

var $hpNe3 = parcelRequire("hpNe3");

var $9tdbO = parcelRequire("9tdbO");
function $2aabbd8f05fd3ff7$var$_regeneratorRuntime() {
    "use strict";
    var r = $7gzA9(), e = r.m($2aabbd8f05fd3ff7$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $9tdbO(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $2aabbd8f05fd3ff7$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $bqia9(r, e);
            },
            AsyncIterator: $9vGAG,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $4NonZ : $lLusz)(a(r), e, t, o, u);
            },
            keys: $hpNe3,
            values: $9tdbO
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $2aabbd8f05fd3ff7$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bqia9", function(module, exports) {
function $851036234af84f28$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $851036234af84f28$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("7gzA9", function(module, exports) {

var $hUrmo = parcelRequire("hUrmo");
function $54a5a0df995df3eb$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $hUrmo(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($hUrmo(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $hUrmo(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $hUrmo(u, "constructor", GeneratorFunctionPrototype), $hUrmo(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $hUrmo(GeneratorFunctionPrototype, o, "GeneratorFunction"), $hUrmo(u), $hUrmo(u, o, "Generator"), $hUrmo(u, n, function() {
        return this;
    }), $hUrmo(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $54a5a0df995df3eb$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $54a5a0df995df3eb$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hUrmo", function(module, exports) {
function $d09ce3cd3b11b6a7$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $d09ce3cd3b11b6a7$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        function o(r, n) {
            $d09ce3cd3b11b6a7$var$_regeneratorDefine(e, r, function(e) {
                return this._invoke(r, n, e);
            });
        }
        r ? i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $d09ce3cd3b11b6a7$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $d09ce3cd3b11b6a7$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("lLusz", function(module, exports) {

var $4NonZ = parcelRequire("4NonZ");
function $fd859d70a8e8e310$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $4NonZ(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $fd859d70a8e8e310$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4NonZ", function(module, exports) {

var $7gzA9 = parcelRequire("7gzA9");

var $9vGAG = parcelRequire("9vGAG");
function $37dea79562ac6e45$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $9vGAG($7gzA9().w(r, e, t, o), n || Promise);
}
module.exports = $37dea79562ac6e45$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9vGAG", function(module, exports) {

var $bqia9 = parcelRequire("bqia9");

var $hUrmo = parcelRequire("hUrmo");
function $6ec80beb59918165$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $bqia9 ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($hUrmo($6ec80beb59918165$var$AsyncIterator.prototype), $hUrmo($6ec80beb59918165$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $hUrmo(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $6ec80beb59918165$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("hpNe3", function(module, exports) {
function $cadaf4aad37cad9b$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $cadaf4aad37cad9b$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9tdbO", function(module, exports) {

var $ekGgq = parcelRequire("ekGgq");
var $6e510da695b3307a$var$_typeof = $ekGgq.default;
function $6e510da695b3307a$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($6e510da695b3307a$var$_typeof(e) + " is not iterable");
}
module.exports = $6e510da695b3307a$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("iFR7a", function(module, exports) {
"use strict";
var $d98541c52a8d8f29$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d98541c52a8d8f29$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d98541c52a8d8f29$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $i1p2j = parcelRequire("i1p2j");
module.exports.StatsigClient = $i1p2j.default;

$d98541c52a8d8f29$var$__exportStar((parcelRequire("dtn6l")), module.exports);
const $d98541c52a8d8f29$var$__STATSIG__ = Object.assign((0, (parcelRequire("dtn6l"))._getStatsigGlobal)(), {
    StatsigClient: $i1p2j.default
});
module.exports.default = $d98541c52a8d8f29$var$__STATSIG__;

});
parcelRegister("dtn6l", function(module, exports) {
"use strict";
var $9cefe737490148f0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9cefe737490148f0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9cefe737490148f0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("cNxHP")).Diagnostics;
    }
});

var $lT0oC = parcelRequire("lT0oC");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $lT0oC.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("fvY6A")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("cUOGL")).Storage;
    }
});

$9cefe737490148f0$var$__exportStar((parcelRequire("6zYf6")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("6ZtBQ")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("IwlSQ")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("hPIlK")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("cNxHP")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("audqG")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("a7dQ0")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("7A9u9")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("cpYjX")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("lUUuL")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("drWJh")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("fvY6A")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("g4vOj")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("4JLTD")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("4neZ1")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("am110")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("J5dlM")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("jjgcN")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("6OyqX")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("6cbWs")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("kS7H6")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("lbAhi")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("uj5Sb")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("dbFUm")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("4kZUp")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("bfSbh")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("9tDUz")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("fFtli")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("eEYg8")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("boH9C")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("3G1qf")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("8Nbnq")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("cUOGL")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("1I57i")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("fOOnv")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("12s6q")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("5G12m")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("71rjN")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("bhG9g")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("cd98p")), module.exports);
Object.assign((0, (parcelRequire("6zYf6"))._getStatsigGlobal)(), {
    Log: (parcelRequire("fvY6A")).Log,
    SDK_VERSION: (parcelRequire("9tDUz")).SDK_VERSION
});

});
parcelRegister("6zYf6", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $4ca4bde10f45d2ff$var$_a, $4ca4bde10f45d2ff$var$_b, $4ca4bde10f45d2ff$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $fvY6A = parcelRequire("fvY6A");
const $4ca4bde10f45d2ff$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $4ca4bde10f45d2ff$var$statsigGlobal;
    } catch (e) {
        return $4ca4bde10f45d2ff$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $4ca4bde10f45d2ff$var$_getStatsigGlobal;
const $4ca4bde10f45d2ff$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $4ca4bde10f45d2ff$var$_getStatsigGlobalFlag;
const $4ca4bde10f45d2ff$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $fvY6A.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $4ca4bde10f45d2ff$var$_getInstance;
const $4ca4bde10f45d2ff$var$GLOBAL_KEY = '__STATSIG__';
const $4ca4bde10f45d2ff$var$_window = typeof window !== 'undefined' ? window : {};
const $4ca4bde10f45d2ff$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $4ca4bde10f45d2ff$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $4ca4bde10f45d2ff$var$statsigGlobal = ($4ca4bde10f45d2ff$var$_c = ($4ca4bde10f45d2ff$var$_b = ($4ca4bde10f45d2ff$var$_a = $4ca4bde10f45d2ff$var$_window[$4ca4bde10f45d2ff$var$GLOBAL_KEY]) !== null && $4ca4bde10f45d2ff$var$_a !== void 0 ? $4ca4bde10f45d2ff$var$_a : $4ca4bde10f45d2ff$var$_global[$4ca4bde10f45d2ff$var$GLOBAL_KEY]) !== null && $4ca4bde10f45d2ff$var$_b !== void 0 ? $4ca4bde10f45d2ff$var$_b : $4ca4bde10f45d2ff$var$_globalThis[$4ca4bde10f45d2ff$var$GLOBAL_KEY]) !== null && $4ca4bde10f45d2ff$var$_c !== void 0 ? $4ca4bde10f45d2ff$var$_c : {
    instance: module.exports._getInstance
};
$4ca4bde10f45d2ff$var$_window[$4ca4bde10f45d2ff$var$GLOBAL_KEY] = $4ca4bde10f45d2ff$var$statsigGlobal;
$4ca4bde10f45d2ff$var$_global[$4ca4bde10f45d2ff$var$GLOBAL_KEY] = $4ca4bde10f45d2ff$var$statsigGlobal;
$4ca4bde10f45d2ff$var$_globalThis[$4ca4bde10f45d2ff$var$GLOBAL_KEY] = $4ca4bde10f45d2ff$var$statsigGlobal;

});
parcelRegister("fvY6A", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $b4b85fe3d12d0071$var$DEBUG = ' DEBUG ';
const $b4b85fe3d12d0071$var$_INFO = '  INFO ';
const $b4b85fe3d12d0071$var$_WARN = '  WARN ';
const $b4b85fe3d12d0071$var$ERROR = ' ERROR ';
function $b4b85fe3d12d0071$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $b4b85fe3d12d0071$var$Log {
    static info(...args) {
        if ($b4b85fe3d12d0071$var$Log.level >= module.exports.LogLevel.Info) console.info($b4b85fe3d12d0071$var$_INFO, ...$b4b85fe3d12d0071$var$addTag(args));
    }
    static debug(...args) {
        if ($b4b85fe3d12d0071$var$Log.level >= module.exports.LogLevel.Debug) console.debug($b4b85fe3d12d0071$var$DEBUG, ...$b4b85fe3d12d0071$var$addTag(args));
    }
    static warn(...args) {
        if ($b4b85fe3d12d0071$var$Log.level >= module.exports.LogLevel.Warn) console.warn($b4b85fe3d12d0071$var$_WARN, ...$b4b85fe3d12d0071$var$addTag(args));
    }
    static error(...args) {
        if ($b4b85fe3d12d0071$var$Log.level >= module.exports.LogLevel.Error) console.error($b4b85fe3d12d0071$var$ERROR, ...$b4b85fe3d12d0071$var$addTag(args));
    }
}
module.exports.Log = $b4b85fe3d12d0071$var$Log;
$b4b85fe3d12d0071$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("cNxHP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $951434f10e36012f$var$MARKER_MAP = new Map();
const $951434f10e36012f$var$ACT_START = 'start';
const $951434f10e36012f$var$ACT_END = 'end';
const $951434f10e36012f$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $951434f10e36012f$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $951434f10e36012f$var$_addMarker(sdkKey, $951434f10e36012f$var$_createMarker({}, $951434f10e36012f$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $951434f10e36012f$var$_addMarker(sdkKey, $951434f10e36012f$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $951434f10e36012f$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $951434f10e36012f$var$_addMarker(sdkKey, $951434f10e36012f$var$_createMarker(data, $951434f10e36012f$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $951434f10e36012f$var$_addMarker(sdkKey, $951434f10e36012f$var$_createMarker(data, $951434f10e36012f$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $951434f10e36012f$var$_addMarker(sdkKey, $951434f10e36012f$var$_createMarker({}, $951434f10e36012f$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $951434f10e36012f$var$_addMarker(sdkKey, $951434f10e36012f$var$_createMarker(data, $951434f10e36012f$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $951434f10e36012f$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $951434f10e36012f$var$_safeGetField(e, 'code'),
            name: $951434f10e36012f$var$_safeGetField(e, 'name'),
            message: $951434f10e36012f$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $951434f10e36012f$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $951434f10e36012f$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $951434f10e36012f$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $951434f10e36012f$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $951434f10e36012f$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $951434f10e36012f$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $951434f10e36012f$var$MARKER_MAP.set(sdkKey, markers);
}
function $951434f10e36012f$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("lT0oC", function(module, exports) {
"use strict";
var $feef0aade80dd3d6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $6ZtBQ = parcelRequire("6ZtBQ");

var $lUUuL = parcelRequire("lUUuL");

var $fvY6A = parcelRequire("fvY6A");

var $4JLTD = parcelRequire("4JLTD");

var $jjgcN = parcelRequire("jjgcN");

var $bfSbh = parcelRequire("bfSbh");

var $fFtli = parcelRequire("fFtli");

var $cUOGL = parcelRequire("cUOGL");

var $12s6q = parcelRequire("12s6q");

var $71rjN = parcelRequire("71rjN");
const $feef0aade80dd3d6$var$DEFAULT_QUEUE_SIZE = 100;
const $feef0aade80dd3d6$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $feef0aade80dd3d6$var$MAX_DEDUPER_KEYS = 1000;
const $feef0aade80dd3d6$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $feef0aade80dd3d6$var$MAX_FAILED_LOGS = 500;
const $feef0aade80dd3d6$var$QUICK_FLUSH_WINDOW_MS = 200;
const $feef0aade80dd3d6$var$EVENT_LOGGER_MAP = {};
class $feef0aade80dd3d6$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $feef0aade80dd3d6$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $feef0aade80dd3d6$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs();
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $fFtli.LoggingEnabledOption.disabled : $fFtli.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $fvY6A.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $feef0aade80dd3d6$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $12s6q.UrlConfiguration($4JLTD.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        if (this._loggingEnabled === 'disabled' && loggingEnabled !== 'disabled') {
            // load any pre consented events into memory
            const storageKey = this._getStorageKey();
            const events = (0, $cUOGL._getObjectFromStorage)(storageKey);
            if (events) this._queue.push(...events);
            $cUOGL.Storage.removeItem(storageKey);
        }
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $feef0aade80dd3d6$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $jjgcN._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        $feef0aade80dd3d6$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $71rjN._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $feef0aade80dd3d6$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $feef0aade80dd3d6$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs();
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $feef0aade80dd3d6$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $feef0aade80dd3d6$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $feef0aade80dd3d6$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $feef0aade80dd3d6$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$feef0aade80dd3d6$var$EventLogger._safeFlushAndForget(this._sdkKey), $feef0aade80dd3d6$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $jjgcN._isServerEnv)()) return false;
        if (!(0, $bfSbh._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $6ZtBQ._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $feef0aade80dd3d6$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $feef0aade80dd3d6$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $feef0aade80dd3d6$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === 'disabled') {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $71rjN._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $fvY6A.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $fvY6A.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $feef0aade80dd3d6$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$4JLTD.NetworkParam.EventCount]: String(events.length)
            },
            credentials: 'same-origin'
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $feef0aade80dd3d6$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            const savedEvents = this._getFailedLogsFromStorage(storageKey);
            (0, $cUOGL._setObjectInStorage)(storageKey, [
                ...savedEvents,
                ...events
            ]);
        } catch (_a) {
            $fvY6A.Log.warn('Unable to save failed logs to storage');
        }
    }
    _getFailedLogsFromStorage(storageKey) {
        let savedEvents = [];
        try {
            const retrieved = (0, $cUOGL._getObjectFromStorage)(storageKey);
            if (Array.isArray(retrieved)) savedEvents = retrieved;
            return savedEvents;
        } catch (_a) {
            return [];
        }
    }
    _retryFailedLogs() {
        const storageKey = this._getStorageKey();
        (()=>$feef0aade80dd3d6$var$__awaiter(this, void 0, void 0, function*() {
                if (!$cUOGL.Storage.isReady()) yield $cUOGL.Storage.isReadyResolver();
                const events = (0, $cUOGL._getObjectFromStorage)(storageKey);
                if (!events) return;
                $cUOGL.Storage.removeItem(storageKey);
                yield this._sendEvents(events);
            }))().catch(()=>{
            $fvY6A.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $lUUuL._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $fvY6A.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $jjgcN._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $feef0aade80dd3d6$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $feef0aade80dd3d6$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $feef0aade80dd3d6$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
}
module.exports.EventLogger = $feef0aade80dd3d6$var$EventLogger;

});
parcelRegister("6ZtBQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $lUUuL = parcelRequire("lUUuL");
function $516f68604f39036a$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $lUUuL._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $516f68604f39036a$var$_getUserStorageKey;
function $516f68604f39036a$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $516f68604f39036a$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $lUUuL._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $516f68604f39036a$var$_getStorageKey;

});
parcelRegister("lUUuL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $fOOnv = parcelRequire("fOOnv");
const $ff4aa6ade9a90e99$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $ff4aa6ade9a90e99$var$_DJB2;
const $ff4aa6ade9a90e99$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $ff4aa6ade9a90e99$var$_DJB2Object;
const $ff4aa6ade9a90e99$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $fOOnv._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $ff4aa6ade9a90e99$var$_getSortedObject;

});
parcelRegister("fOOnv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $b8429a94efe702e2$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $b8429a94efe702e2$var$_typeOf;
function $b8429a94efe702e2$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $b8429a94efe702e2$var$_isTypeMatch;

});



parcelRegister("4JLTD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("jjgcN", function(module, exports) {

var $3ZMUU = parcelRequire("3ZMUU");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $e0ec5cbb0c18f89e$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $e0ec5cbb0c18f89e$var$_getWindowSafe;
const $e0ec5cbb0c18f89e$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $e0ec5cbb0c18f89e$var$_getDocumentSafe;
const $e0ec5cbb0c18f89e$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $3ZMUU !== 'undefined' && $3ZMUU.versions != null && $3ZMUU.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $e0ec5cbb0c18f89e$var$_isServerEnv;
const $e0ec5cbb0c18f89e$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $e0ec5cbb0c18f89e$var$_addWindowEventListenerSafe;
const $e0ec5cbb0c18f89e$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $e0ec5cbb0c18f89e$var$_addDocumentEventListenerSafe;
const $e0ec5cbb0c18f89e$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $e0ec5cbb0c18f89e$var$_getCurrentPageUrlSafe;
const $e0ec5cbb0c18f89e$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $e0ec5cbb0c18f89e$var$_getUnloadEvent;

});

parcelRegister("bfSbh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $831b1fa1d6ab26dc$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $831b1fa1d6ab26dc$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $831b1fa1d6ab26dc$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $831b1fa1d6ab26dc$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $831b1fa1d6ab26dc$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $831b1fa1d6ab26dc$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $831b1fa1d6ab26dc$var$GATE_EXPOSURE_NAME || eventName === $831b1fa1d6ab26dc$var$CONFIG_EXPOSURE_NAME || eventName === $831b1fa1d6ab26dc$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $831b1fa1d6ab26dc$var$_isExposureEvent;
const $831b1fa1d6ab26dc$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $831b1fa1d6ab26dc$var$_createExposure($831b1fa1d6ab26dc$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $831b1fa1d6ab26dc$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $831b1fa1d6ab26dc$var$_createGateExposure;
function $831b1fa1d6ab26dc$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $831b1fa1d6ab26dc$var$_mapExposures;
const $831b1fa1d6ab26dc$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $831b1fa1d6ab26dc$var$_createExposure($831b1fa1d6ab26dc$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $831b1fa1d6ab26dc$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $831b1fa1d6ab26dc$var$_createConfigExposure;
const $831b1fa1d6ab26dc$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $831b1fa1d6ab26dc$var$_createExposure($831b1fa1d6ab26dc$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $831b1fa1d6ab26dc$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $831b1fa1d6ab26dc$var$_createLayerParameterExposure;
const $831b1fa1d6ab26dc$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("fFtli", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});

parcelRegister("cUOGL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $fvY6A = parcelRequire("fvY6A");

var $jjgcN = parcelRequire("jjgcN");
const $967208b68a686b58$var$inMemoryStore = {};
const $967208b68a686b58$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$967208b68a686b58$var$inMemoryStore[key] ? $967208b68a686b58$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $967208b68a686b58$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $967208b68a686b58$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($967208b68a686b58$var$inMemoryStore)
};
let $967208b68a686b58$var$_localStorageProvider = null;
try {
    const win = (0, $jjgcN._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $967208b68a686b58$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $fvY6A.Log.warn('Failed to setup localStorageProvider.');
}
let $967208b68a686b58$var$_main = $967208b68a686b58$var$_localStorageProvider !== null && $967208b68a686b58$var$_localStorageProvider !== void 0 ? $967208b68a686b58$var$_localStorageProvider : $967208b68a686b58$var$_inMemoryProvider;
let $967208b68a686b58$var$_current = $967208b68a686b58$var$_main;
function $967208b68a686b58$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($967208b68a686b58$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$967208b68a686b58$var$_current.isReady(),
    isReadyResolver: ()=>$967208b68a686b58$var$_current.isReadyResolver(),
    getProviderName: ()=>$967208b68a686b58$var$_current.getProviderName(),
    getItem: (key)=>$967208b68a686b58$var$_inMemoryBreaker(()=>$967208b68a686b58$var$_current.getItem(key)),
    setItem: (key, value)=>$967208b68a686b58$var$_inMemoryBreaker(()=>$967208b68a686b58$var$_current.setItem(key, value)),
    removeItem: (key)=>$967208b68a686b58$var$_current.removeItem(key),
    getAllKeys: ()=>$967208b68a686b58$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $967208b68a686b58$var$_main = newProvider;
        $967208b68a686b58$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $967208b68a686b58$var$_current = $967208b68a686b58$var$_inMemoryProvider;
        else $967208b68a686b58$var$_current = $967208b68a686b58$var$_main;
    }
};
function $967208b68a686b58$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    try {
        return JSON.parse(value !== null && value !== void 0 ? value : 'null');
    } catch (e) {
        $fvY6A.Log.error(`Failed to parse value for key "${key}"`);
        return null;
    }
}
module.exports._getObjectFromStorage = $967208b68a686b58$var$_getObjectFromStorage;
function $967208b68a686b58$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $967208b68a686b58$var$_setObjectInStorage;

});

parcelRegister("12s6q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $lUUuL = parcelRequire("lUUuL");

var $4JLTD = parcelRequire("4JLTD");
const $0c1bc6f7052054af$var$ENDPOINT_DNS_KEY_MAP = {
    [$4JLTD.Endpoint._initialize]: 'i',
    [$4JLTD.Endpoint._rgstr]: 'e',
    [$4JLTD.Endpoint._download_config_specs]: 'd'
};
class $0c1bc6f7052054af$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $0c1bc6f7052054af$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $4JLTD.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $lUUuL._DJB2)(this.customUrl + fallbacks);
    }
}
module.exports.UrlConfiguration = $0c1bc6f7052054af$var$UrlConfiguration;

});

parcelRegister("71rjN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $jjgcN = parcelRequire("jjgcN");
const $51cdd13d47b1548c$var$FOREGROUND = 'foreground';
const $51cdd13d47b1548c$var$BACKGROUND = 'background';
const $51cdd13d47b1548c$var$LISTENERS = [];
let $51cdd13d47b1548c$var$current = $51cdd13d47b1548c$var$FOREGROUND;
let $51cdd13d47b1548c$var$isUnloading = false;
const $51cdd13d47b1548c$var$_isCurrentlyVisible = ()=>{
    return $51cdd13d47b1548c$var$current === $51cdd13d47b1548c$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $51cdd13d47b1548c$var$_isCurrentlyVisible;
const $51cdd13d47b1548c$var$_isUnloading = ()=>$51cdd13d47b1548c$var$isUnloading;
module.exports._isUnloading = $51cdd13d47b1548c$var$_isUnloading;
const $51cdd13d47b1548c$var$_subscribeToVisiblityChanged = (listener)=>{
    $51cdd13d47b1548c$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $51cdd13d47b1548c$var$_subscribeToVisiblityChanged;
const $51cdd13d47b1548c$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $51cdd13d47b1548c$var$current) return;
    $51cdd13d47b1548c$var$current = visibility;
    $51cdd13d47b1548c$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $51cdd13d47b1548c$var$_notifyVisibilityChanged;
(0, $jjgcN._addWindowEventListenerSafe)('focus', ()=>{
    $51cdd13d47b1548c$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($51cdd13d47b1548c$var$FOREGROUND);
});
(0, $jjgcN._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($51cdd13d47b1548c$var$BACKGROUND));
(0, $jjgcN._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $51cdd13d47b1548c$var$FOREGROUND : $51cdd13d47b1548c$var$BACKGROUND);
});
(0, $jjgcN._addWindowEventListenerSafe)((0, $jjgcN._getUnloadEvent)(), ()=>{
    $51cdd13d47b1548c$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($51cdd13d47b1548c$var$BACKGROUND);
});

});


parcelRegister("9tDUz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.30.2';
let $6e65c810593ccaf7$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$6e65c810593ccaf7$var$metadata,
    add: (additions)=>{
        $6e65c810593ccaf7$var$metadata = Object.assign(Object.assign({}, $6e65c810593ccaf7$var$metadata), additions);
    }
};

});

parcelRegister("IwlSQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hPIlK", function(module, exports) {
"use strict";
var $cfb99a0123e1f5cd$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $fvY6A = parcelRequire("fvY6A");

var $lbAhi = parcelRequire("lbAhi");

var $8Nbnq = parcelRequire("8Nbnq");

var $cUOGL = parcelRequire("cUOGL");

var $1I57i = parcelRequire("1I57i");
const $cfb99a0123e1f5cd$var$CACHE_LIMIT = 10;
const $cfb99a0123e1f5cd$var$MAX_CACHE_WRITE_ATTEMPTS = 8;
class $cfb99a0123e1f5cd$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._cacheLimit = $cfb99a0123e1f5cd$var$CACHE_LIMIT;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $cfb99a0123e1f5cd$var$InMemoryCache();
    }
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $8Nbnq._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache, this._cacheLimit);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $8Nbnq._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $cfb99a0123e1f5cd$var$_makeDataAdapterResult('Bootstrap', data, null, normalized), this._cacheLimit);
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $lbAhi.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $cfb99a0123e1f5cd$var$__awaiter(this, void 0, void 0, function*() {
            if (!$cUOGL.Storage.isReady()) yield $cUOGL.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $fvY6A.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $cfb99a0123e1f5cd$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $8Nbnq._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }), this._cacheLimit);
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $cfb99a0123e1f5cd$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $fvY6A.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $1I57i._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $lbAhi.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $cfb99a0123e1f5cd$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $cfb99a0123e1f5cd$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result, this._cacheLimit);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $fvY6A.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $cUOGL.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($cUOGL.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $1I57i._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        const resultString = JSON.stringify(result);
        for(let i = 0; i < $cfb99a0123e1f5cd$var$MAX_CACHE_WRITE_ATTEMPTS; i++)try {
            $cUOGL.Storage.setItem(cacheKey, resultString);
            break;
        } catch (error) {
            if (!(error instanceof Error) || !(error.toString().includes('QuotaExceededError') || error.toString().includes('QUOTA_EXCEEDED_ERR')) || this._cacheLimit <= 1) throw error;
            this._cacheLimit = Math.ceil(this._cacheLimit / 2);
            this._runLocalStorageCacheEviction(cacheKey, this._cacheLimit - 1);
        }
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey, cacheLimit = this._cacheLimit) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $cUOGL._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictableKeys = $cfb99a0123e1f5cd$var$_getEvictableKeys(lastModifiedTimeMap, cacheLimit);
        for (const evictable of evictableKeys){
            delete lastModifiedTimeMap[evictable];
            $cUOGL.Storage.removeItem(evictable);
        }
        (0, $cUOGL._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $cfb99a0123e1f5cd$var$DataAdapterCore;
function $cfb99a0123e1f5cd$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $8Nbnq._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $cfb99a0123e1f5cd$var$_makeDataAdapterResult;
class $cfb99a0123e1f5cd$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $fvY6A.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value, cacheLimit) {
        const evictableKeys = $cfb99a0123e1f5cd$var$_getEvictableKeys(this._data, cacheLimit - 1);
        for (const evictable of evictableKeys)delete this._data[evictable];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $cfb99a0123e1f5cd$var$_getEvictableKeys(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return [];
    if (limit === 0) return keys;
    return keys.sort((keyA, keyB)=>{
        const valueA = data[keyA];
        const valueB = data[keyB];
        if (typeof valueA === 'object' && typeof valueB === 'object') return valueA.receivedAt - valueB.receivedAt;
        return valueA - valueB;
    }).slice(0, keys.length - limit);
}

});
parcelRegister("lbAhi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCookieName = module.exports.StableID = void 0;

var $6ZtBQ = parcelRequire("6ZtBQ");

var $fvY6A = parcelRequire("fvY6A");

var $jjgcN = parcelRequire("jjgcN");

var $cUOGL = parcelRequire("cUOGL");

var $5G12m = parcelRequire("5G12m");
const $f6c6c4187dbee940$var$PROMISE_MAP = {};
const $f6c6c4187dbee940$var$COOKIE_ENABLED_MAP = {};
const $f6c6c4187dbee940$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($f6c6c4187dbee940$var$DISABLED_MAP[sdkKey]) return null;
        if ($f6c6c4187dbee940$var$PROMISE_MAP[sdkKey] != null) return $f6c6c4187dbee940$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $f6c6c4187dbee940$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $f6c6c4187dbee940$var$PROMISE_MAP[sdkKey] = stableID;
            $f6c6c4187dbee940$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $f6c6c4187dbee940$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $5G12m.getUUID)();
        $f6c6c4187dbee940$var$_persistToStorage(stableID, sdkKey);
        $f6c6c4187dbee940$var$_persistToCookie(stableID, sdkKey);
        $f6c6c4187dbee940$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $f6c6c4187dbee940$var$PROMISE_MAP[sdkKey] = override;
        $f6c6c4187dbee940$var$_persistToStorage(override, sdkKey);
        $f6c6c4187dbee940$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $f6c6c4187dbee940$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $f6c6c4187dbee940$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $f6c6c4187dbee940$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $6ZtBQ._getStorageKey)(sdkKey)}`;
}
function $f6c6c4187dbee940$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $f6c6c4187dbee940$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $cUOGL._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $fvY6A.Log.warn('Failed to save StableID to storage');
    }
}
function $f6c6c4187dbee940$var$_loadFromStorage(sdkKey) {
    const storageKey = $f6c6c4187dbee940$var$_getStableIDStorageKey(sdkKey);
    return (0, $cUOGL._getObjectFromStorage)(storageKey);
}
function $f6c6c4187dbee940$var$_loadFromCookie(sdkKey) {
    if (!$f6c6c4187dbee940$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $jjgcN._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $f6c6c4187dbee940$var$getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $f6c6c4187dbee940$var$_persistToCookie(stableID, sdkKey) {
    if (!$f6c6c4187dbee940$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $jjgcN._getDocumentSafe)() == null) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$f6c6c4187dbee940$var$getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $f6c6c4187dbee940$var$getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $6ZtBQ._getStorageKey)(sdkKey)}`;
}
module.exports.getCookieName = $f6c6c4187dbee940$var$getCookieName;

});
parcelRegister("5G12m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $4221adf57cf05a89$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $4221adf57cf05a89$var$getUUID;

});


parcelRegister("8Nbnq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $lUUuL = parcelRequire("lUUuL");

var $fvY6A = parcelRequire("fvY6A");
function $666bb98ace10d484$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $fvY6A.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $666bb98ace10d484$var$_normalizeUser;
function $666bb98ace10d484$var$_getFullUserHash(user) {
    return user ? (0, $lUUuL._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $666bb98ace10d484$var$_getFullUserHash;

});

parcelRegister("1I57i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $fvY6A = parcelRequire("fvY6A");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $13edde94128756b8$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $fvY6A.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $13edde94128756b8$var$_typedJsonParse;

});


parcelRegister("audqG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("a7dQ0", function(module, exports) {
"use strict";
var $75d54abd189c1104$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $fvY6A = parcelRequire("fvY6A");

var $6OyqX = parcelRequire("6OyqX");

var $9tDUz = parcelRequire("9tDUz");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $75d54abd189c1104$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $75d54abd189c1104$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance, namePrefix) {
        try {
            const obj = instance;
            $75d54abd189c1104$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(namePrefix ? `${namePrefix}:${name}` : name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $75d54abd189c1104$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $fvY6A.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$75d54abd189c1104$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($75d54abd189c1104$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $75d54abd189c1104$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $6OyqX.SDKType._get(this._sdkKey);
                    const statsigMetadata = $9tDUz.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $75d54abd189c1104$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $75d54abd189c1104$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $75d54abd189c1104$var$ErrorBoundary;
function $75d54abd189c1104$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $75d54abd189c1104$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $75d54abd189c1104$var$UNKNOWN_ERROR;
    }
}
function $75d54abd189c1104$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $75d54abd189c1104$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.keys(options).forEach((key)=>{
        const option = key;
        const value = options[option];
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("6OyqX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $4f621f727d71eed4$var$SDK_CLIENT = {};
let $4f621f727d71eed4$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $4f621f727d71eed4$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($4f621f727d71eed4$var$suffix !== null && $4f621f727d71eed4$var$suffix !== void 0 ? $4f621f727d71eed4$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $4f621f727d71eed4$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$4f621f727d71eed4$var$suffix || $4f621f727d71eed4$var$suffix === '-react') $4f621f727d71eed4$var$suffix = '-' + binding;
    }
};

});


parcelRegister("7A9u9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cpYjX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("drWJh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("g4vOj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $bb35b1f34b6c714c$var$EXIST_KEYS = new Set([]);
const $bb35b1f34b6c714c$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $bb35b1f34b6c714c$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($bb35b1f34b6c714c$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($bb35b1f34b6c714c$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $bb35b1f34b6c714c$var$createMemoKey;

});

parcelRegister("4neZ1", function(module, exports) {
"use strict";
var $32f4eec2dcf9f3a5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $6zYf6 = parcelRequire("6zYf6");

var $6zYf6 = parcelRequire("6zYf6");

var $cNxHP = parcelRequire("cNxHP");

var $fvY6A = parcelRequire("fvY6A");

var $4JLTD = parcelRequire("4JLTD");

var $9zIz8 = parcelRequire("9zIz8");

var $cd98p = parcelRequire("cd98p");

var $6OyqX = parcelRequire("6OyqX");

var $jjgcN = parcelRequire("jjgcN");

var $6cbWs = parcelRequire("6cbWs");

var $lbAhi = parcelRequire("lbAhi");

var $dbFUm = parcelRequire("dbFUm");

var $9tDUz = parcelRequire("9tDUz");

var $fFtli = parcelRequire("fFtli");

var $71rjN = parcelRequire("71rjN");
const $32f4eec2dcf9f3a5$var$DEFAULT_TIMEOUT_MS = 10000;
const $32f4eec2dcf9f3a5$var$BACKOFF_BASE_MS = 500;
const $32f4eec2dcf9f3a5$var$BACKOFF_MAX_MS = 30000;
const $32f4eec2dcf9f3a5$var$RATE_LIMIT_WINDOW_MS = 1000;
const $32f4eec2dcf9f3a5$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $32f4eec2dcf9f3a5$var$LEAK_RATE = $32f4eec2dcf9f3a5$var$RATE_LIMIT_MAX_REQ_COUNT / $32f4eec2dcf9f3a5$var$RATE_LIMIT_WINDOW_MS;
const $32f4eec2dcf9f3a5$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $32f4eec2dcf9f3a5$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $32f4eec2dcf9f3a5$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $9zIz8.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$32f4eec2dcf9f3a5$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $32f4eec2dcf9f3a5$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $32f4eec2dcf9f3a5$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$32f4eec2dcf9f3a5$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $fvY6A.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            let reqTimedOut = false;
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $71rjN._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    priority: args.priority,
                    keepalive: keepalive
                };
                $32f4eec2dcf9f3a5$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                let timeoutId;
                response = yield Promise.race([
                    func(populatedUrl, config).finally(()=>clearTimeout(timeoutId)),
                    new Promise((_, reject)=>{
                        timeoutId = setTimeout(()=>{
                            reqTimedOut = true;
                            reject(new Error(`Timeout of ${this._timeout}ms expired.`));
                        }, this._timeout);
                    })
                ]);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $32f4eec2dcf9f3a5$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $32f4eec2dcf9f3a5$var$_getErrorMessage(error);
                const timedOut = $32f4eec2dcf9f3a5$var$_didTimeout(errorMessage !== null && errorMessage !== void 0 ? errorMessage : '', reqTimedOut);
                $32f4eec2dcf9f3a5$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$32f4eec2dcf9f3a5$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $dbFUm.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $fvY6A.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $32f4eec2dcf9f3a5$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $fFtli.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $fFtli.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $32f4eec2dcf9f3a5$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $32f4eec2dcf9f3a5$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $4JLTD.Endpoint._initialize || args.urlConfig.endpoint === $4JLTD.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$4JLTD.NetworkParam.SdkKey]: args.sdkKey,
            [$4JLTD.NetworkParam.SdkType]: $6OyqX.SDKType._get(args.sdkKey),
            [$4JLTD.NetworkParam.SdkVersion]: $9tDUz.SDK_VERSION,
            [$4JLTD.NetworkParam.Time]: String(Date.now()),
            [$4JLTD.NetworkParam.SessionID]: $6cbWs.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $jjgcN._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $6zYf6._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$4JLTD.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $fvY6A.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $32f4eec2dcf9f3a5$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$32f4eec2dcf9f3a5$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($fvY6A.Log.error);
                writer.close().catch($fvY6A.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$4JLTD.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $fvY6A.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $32f4eec2dcf9f3a5$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $32f4eec2dcf9f3a5$var$NetworkCore;
const $32f4eec2dcf9f3a5$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $fvY6A.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $32f4eec2dcf9f3a5$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $lbAhi.StableID.get(sdkKey);
    const sessionID = $6cbWs.SessionID.get(sdkKey);
    const sdkType = $6OyqX.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $9tDUz.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $32f4eec2dcf9f3a5$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $6zYf6._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $cd98p.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $fFtli.LogEventCompressionMode.Disabled:
            return false;
        case $fFtli.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $fFtli.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $32f4eec2dcf9f3a5$var$_getErrorMessage(error) {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $32f4eec2dcf9f3a5$var$_didTimeout(errorMsg, abortedByTimeout) {
    const timeout = errorMsg.includes('Timeout'); // probably not needed but just in case
    return timeout || abortedByTimeout;
}
function $32f4eec2dcf9f3a5$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $4JLTD.Endpoint._initialize) return;
    $cNxHP.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $32f4eec2dcf9f3a5$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $4JLTD.Endpoint._initialize) return;
    $cNxHP.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $cNxHP.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $32f4eec2dcf9f3a5$var$_exponentialBackoff(attempt) {
    return $32f4eec2dcf9f3a5$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($32f4eec2dcf9f3a5$var$BACKOFF_BASE_MS * (attempt * attempt), $32f4eec2dcf9f3a5$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("9zIz8", function(module, exports) {
"use strict";
var $6f89f3be547c87c2$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $9NOma = parcelRequire("9NOma");

var $lUUuL = parcelRequire("lUUuL");

var $fvY6A = parcelRequire("fvY6A");

var $cUOGL = parcelRequire("cUOGL");
const $6f89f3be547c87c2$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $6f89f3be547c87c2$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $6f89f3be547c87c2$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $6f89f3be547c87c2$var$DEFAULT_TTL_MS;
        $6f89f3be547c87c2$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $6f89f3be547c87c2$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $6f89f3be547c87c2$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $6f89f3be547c87c2$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$6f89f3be547c87c2$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $6f89f3be547c87c2$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $6f89f3be547c87c2$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $6f89f3be547c87c2$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $6f89f3be547c87c2$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $9NOma._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $6f89f3be547c87c2$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $6f89f3be547c87c2$var$NetworkFallbackResolver;
function $6f89f3be547c87c2$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $6f89f3be547c87c2$var$_isDomainFailure;
function $6f89f3be547c87c2$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $lUUuL._DJB2)(sdkKey)}`;
}
function $6f89f3be547c87c2$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $6f89f3be547c87c2$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $cUOGL.Storage.removeItem(hashKey);
        return;
    }
    $cUOGL.Storage.setItem(hashKey, JSON.stringify(info));
}
function $6f89f3be547c87c2$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $6f89f3be547c87c2$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $cUOGL.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $fvY6A.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $6f89f3be547c87c2$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("9NOma", function(module, exports) {
"use strict";
var $722fc069dd1cc14d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $722fc069dd1cc14d$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $722fc069dd1cc14d$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $722fc069dd1cc14d$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $722fc069dd1cc14d$var$MAX_START_LOOKUP = 200;
function $722fc069dd1cc14d$var$_fetchTxtRecords(networkFunc) {
    return $722fc069dd1cc14d$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($722fc069dd1cc14d$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $722fc069dd1cc14d$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $722fc069dd1cc14d$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $722fc069dd1cc14d$var$_fetchTxtRecords;
function $722fc069dd1cc14d$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $722fc069dd1cc14d$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $722fc069dd1cc14d$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});


parcelRegister("cd98p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $8e3dc8e27d017159$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $8e3dc8e27d017159$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $8e3dc8e27d017159$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("6cbWs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $6zYf6 = parcelRequire("6zYf6");

var $6ZtBQ = parcelRequire("6ZtBQ");

var $fvY6A = parcelRequire("fvY6A");

var $cUOGL = parcelRequire("cUOGL");

var $5G12m = parcelRequire("5G12m");
const $482d2078a26fb880$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $482d2078a26fb880$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $482d2078a26fb880$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($482d2078a26fb880$var$PROMISE_MAP[sdkKey] == null) $482d2078a26fb880$var$PROMISE_MAP[sdkKey] = $482d2078a26fb880$var$_loadSession(sdkKey);
        const session = $482d2078a26fb880$var$PROMISE_MAP[sdkKey];
        return $482d2078a26fb880$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $482d2078a26fb880$var$PROMISE_MAP[sdkKey] = $482d2078a26fb880$var$_overrideSessionId(override, sdkKey);
    }
};
function $482d2078a26fb880$var$_loadSession(sdkKey) {
    let data = $482d2078a26fb880$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $5G12m.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $482d2078a26fb880$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $482d2078a26fb880$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($482d2078a26fb880$var$_isIdle(data) || $482d2078a26fb880$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $5G12m.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    $482d2078a26fb880$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $482d2078a26fb880$var$_createSessionTimeout(sdkKey, $482d2078a26fb880$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $482d2078a26fb880$var$_createSessionTimeout(sdkKey, $482d2078a26fb880$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $482d2078a26fb880$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $6zYf6._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $482d2078a26fb880$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $482d2078a26fb880$var$MAX_SESSION_IDLE_TIME;
}
function $482d2078a26fb880$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $482d2078a26fb880$var$MAX_SESSION_AGE;
}
function $482d2078a26fb880$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $6ZtBQ._getStorageKey)(sdkKey)}`;
}
function $482d2078a26fb880$var$_persistToStorage(session, sdkKey) {
    const storageKey = $482d2078a26fb880$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $cUOGL._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $fvY6A.Log.warn('Failed to save SessionID');
    }
}
function $482d2078a26fb880$var$_loadFromStorage(sdkKey) {
    const storageKey = $482d2078a26fb880$var$_getSessionIDStorageKey(sdkKey);
    return (0, $cUOGL._getObjectFromStorage)(storageKey);
}

});

parcelRegister("dbFUm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});


parcelRegister("am110", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("J5dlM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kS7H6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $f31ed1b25fdb1fa1$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $f31ed1b25fdb1fa1$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $f31ed1b25fdb1fa1$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $f31ed1b25fdb1fa1$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $f31ed1b25fdb1fa1$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $f31ed1b25fdb1fa1$var$_fastApproxSizeOf;

});

parcelRegister("uj5Sb", function(module, exports) {
"use strict";
var $05b19d12b0b40110$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $6zYf6 = parcelRequire("6zYf6");

var $6zYf6 = parcelRequire("6zYf6");

var $a7dQ0 = parcelRequire("a7dQ0");

var $lT0oC = parcelRequire("lT0oC");

var $fvY6A = parcelRequire("fvY6A");

var $g4vOj = parcelRequire("g4vOj");

var $jjgcN = parcelRequire("jjgcN");

var $6cbWs = parcelRequire("6cbWs");

var $lbAhi = parcelRequire("lbAhi");

var $fFtli = parcelRequire("fFtli");

var $cUOGL = parcelRequire("cUOGL");
const $05b19d12b0b40110$var$MAX_MEMO_CACHE_SIZE = 3000;
class $05b19d12b0b40110$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($fvY6A.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $cUOGL.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $6cbWs.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $cUOGL.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $lbAhi.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $lbAhi.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $lT0oC.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $a7dQ0.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $cUOGL.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $05b19d12b0b40110$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $cUOGL.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $lbAhi.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($fFtli.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $05b19d12b0b40110$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $fvY6A.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $g4vOj.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $05b19d12b0b40110$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $05b19d12b0b40110$var$StatsigClientBase;
function $05b19d12b0b40110$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $jjgcN._isServerEnv)()) return;
    const statsigGlobal = (0, $6zYf6._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $fvY6A.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("4kZUp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("eEYg8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("boH9C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $fvY6A = parcelRequire("fvY6A");

var $fOOnv = parcelRequire("fOOnv");
function $84c36919a00c4c78$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $84c36919a00c4c78$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $84c36919a00c4c78$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $84c36919a00c4c78$var$_makeFeatureGate;
function $84c36919a00c4c78$var$_makeDynamicConfig(name, details, evaluation) {
    var _a, _b;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $84c36919a00c4c78$var$_makeEvaluation(name, details, evaluation, value)), {
        idType: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _b !== void 0 ? _b : null,
        get: $84c36919a00c4c78$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $84c36919a00c4c78$var$_makeDynamicConfig;
function $84c36919a00c4c78$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $84c36919a00c4c78$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $84c36919a00c4c78$var$_makeExperiment;
function $84c36919a00c4c78$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $84c36919a00c4c78$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $84c36919a00c4c78$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $84c36919a00c4c78$var$_makeLayer;
function $84c36919a00c4c78$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $84c36919a00c4c78$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $84c36919a00c4c78$var$_mergeOverride;
function $84c36919a00c4c78$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $fOOnv._isTypeMatch)(found, fallback)) {
            $fvY6A.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $84c36919a00c4c78$var$_makeTypedGet;

});

parcelRegister("3G1qf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("bhG9g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $8371fa073e270eba$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $8371fa073e270eba$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("i1p2j", function(module, exports) {
"use strict";
var $d1ebbdb02ace9f76$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dtn6l = parcelRequire("dtn6l");

var $i8QCG = parcelRequire("i8QCG");

var $e4Scn = parcelRequire("e4Scn");

var $9JsrP = parcelRequire("9JsrP");

var $j6Ssa = parcelRequire("j6Ssa");
class $d1ebbdb02ace9f76$var$StatsigClient extends $dtn6l.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $dtn6l._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $d1ebbdb02ace9f76$var$StatsigClient) return instance;
        $dtn6l.Log.warn((0, $dtn6l._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $d1ebbdb02ace9f76$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $dtn6l.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $e4Scn.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $j6Ssa.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($dtn6l.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($dtn6l.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($dtn6l.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($dtn6l.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($dtn6l.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($dtn6l.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $i8QCG.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $dtn6l.getUUID)();
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $dtn6l.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $d1ebbdb02ace9f76$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $dtn6l.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $dtn6l.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $d1ebbdb02ace9f76$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $d1ebbdb02ace9f76$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $dtn6l.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $dtn6l.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $dtn6l.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $dtn6l.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($dtn6l.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $dtn6l.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $dtn6l.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $dtn6l.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        let user = {};
        try {
            user = JSON.parse(JSON.stringify(this._user));
        } catch (_a) {
            $dtn6l.Log.error('Failed to parse user');
        }
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: user,
            errorBoundary: this._errorBoundary,
            session: $dtn6l.StatsigSession.get(this._sdkKey),
            stableID: $dtn6l.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $d1ebbdb02ace9f76$var$__awaiter(this, void 0, void 0, function*() {
            if (!$dtn6l.Storage.isReady()) yield $dtn6l.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $dtn6l.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $dtn6l.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a, _b, _c;
        const user = (0, $dtn6l._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) {
            const readyPromise = (_c = (_b = this.storageProvider).isReadyResolver) === null || _c === void 0 ? void 0 : _c.call(_b);
            if (readyPromise) readyPromise.then(()=>$dtn6l.StableID.setOverride(stableIdOverride, this._sdkKey), ()=>$dtn6l.StableID.setOverride(stableIdOverride, this._sdkKey));
            else $dtn6l.StableID.setOverride(stableIdOverride, this._sdkKey);
        }
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $dtn6l._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $dtn6l._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $dtn6l._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $dtn6l._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $dtn6l._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $dtn6l._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $dtn6l._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $dtn6l._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $dtn6l._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $dtn6l._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $9JsrP._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $9JsrP._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
}
module.exports.default = $d1ebbdb02ace9f76$var$StatsigClient;

});
parcelRegister("i8QCG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dtn6l = parcelRequire("dtn6l");

var $7btVL = parcelRequire("7btVL");

var $3UfIi = parcelRequire("3UfIi");
class $d351cb260e1921f6$var$EvaluationStore {
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, $dtn6l._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        var _a, _b;
        if (!result) return false;
        const values = (0, $dtn6l._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        const updatedLcut = (_a = values.time) !== null && _a !== void 0 ? _a : 0;
        if (updatedLcut < this._lcut) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        if (values.response_format === 'init-v2') this._values = new $3UfIi.V2InitializeContainer(values);
        else this._values = new $7btVL.V1InitializeContainer(values);
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $dtn6l.SDKFlags.setFlags(this._sdkKey, (_b = values.sdk_flags) !== null && _b !== void 0 ? _b : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        const res = this._values ? this._values.getGate(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfig(name) {
        const res = this._values ? this._values.getConfig(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfigList() {
        if (!this._values) return [];
        return this._values.getConfigList();
    }
    getLayer(name) {
        const res = this._values ? this._values.getLayer(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getParamStore(name) {
        const res = this._values ? this._values.getParamStore(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.getExposureMapping();
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(result) {
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $dtn6l.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            const userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((0, $dtn6l._getFullUserHash)(userForComparison) !== (0, $dtn6l._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $d351cb260e1921f6$var$EvaluationStore;

});
parcelRegister("7btVL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V1InitializeContainer = void 0;

var $dtn6l = parcelRequire("dtn6l");
class $53b0c713f248c7f9$var$V1InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        return this._getResultFromLookup(this._values.feature_gates, name);
    }
    getConfig(name) {
        return this._getResultFromLookup(this._values.dynamic_configs, name);
    }
    getLayer(name) {
        return this._getResultFromLookup(this._values.layer_configs, name);
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $dtn6l._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V1InitializeContainer = $53b0c713f248c7f9$var$V1InitializeContainer;

});

parcelRegister("3UfIi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V2InitializeContainer = void 0;

var $dtn6l = parcelRequire("dtn6l");
class $2d82ca689190c304$var$V2InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        var _a, _b, _c;
        const evalV2 = this._getResultFromLookup(this._values.feature_gates, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: evalV2.v === true,
            rule_id: (_a = evalV2.r) !== null && _a !== void 0 ? _a : 'default',
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : ''
        };
    }
    getConfig(name) {
        var _a, _b, _c, _d;
        const evalV2 = this._getResultFromLookup(this._values.dynamic_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : '',
            is_user_in_experiment: evalV2.ue === true ? true : false,
            passed: evalV2.p === true,
            group_name: (_d = evalV2.gn) !== null && _d !== void 0 ? _d : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID'
        };
    }
    getLayer(name) {
        var _a, _b, _c, _d, _e, _f;
        const evalV2 = this._getResultFromLookup(this._values.layer_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            is_user_in_experiment: evalV2.ue === true ? true : false,
            group_name: (_c = evalV2.gn) !== null && _c !== void 0 ? _c : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID',
            allocated_experiment_name: (_d = evalV2.ae) !== null && _d !== void 0 ? _d : '',
            explicit_parameters: (_e = evalV2.ep) !== null && _e !== void 0 ? _e : [],
            undelegated_secondary_exposures: (_f = evalV2.us) !== null && _f !== void 0 ? _f : [],
            parameter_rule_ids: evalV2.pr
        };
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $dtn6l._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V2InitializeContainer = $2d82ca689190c304$var$V2InitializeContainer;

});


parcelRegister("e4Scn", function(module, exports) {
"use strict";
var $a3fb7b1b9752a99a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dtn6l = parcelRequire("dtn6l");

var $7TiGk = parcelRequire("7TiGk");
class $a3fb7b1b9752a99a$var$StatsigNetwork extends $dtn6l.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $dtn6l.UrlConfiguration($dtn6l.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $a3fb7b1b9752a99a$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $dtn6l._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $a3fb7b1b9752a99a$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $7TiGk._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $a3fb7b1b9752a99a$var$StatsigNetwork;

});
parcelRegister("7TiGk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $dtn6l = parcelRequire("dtn6l");
const $5bec293bd088a842$var$MAX_DELTAS_SORT_DEPTH = 2;
function $5bec293bd088a842$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $dtn6l._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $5bec293bd088a842$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $5bec293bd088a842$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $dtn6l._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $5bec293bd088a842$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $5bec293bd088a842$var$_resolveDeltasResponse;
function $5bec293bd088a842$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $5bec293bd088a842$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $5bec293bd088a842$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $5bec293bd088a842$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $5bec293bd088a842$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $5bec293bd088a842$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("9JsrP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $dtn6l = parcelRequire("dtn6l");
const $715e622b11c913c1$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $715e622b11c913c1$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $715e622b11c913c1$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $dtn6l._isTypeMatch)(value, fallback);
}
function $715e622b11c913c1$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $715e622b11c913c1$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $715e622b11c913c1$var$_shouldLogExposure(options) ? undefined : $715e622b11c913c1$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $715e622b11c913c1$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $715e622b11c913c1$var$_shouldLogExposure(options) ? undefined : $715e622b11c913c1$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($715e622b11c913c1$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $715e622b11c913c1$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $715e622b11c913c1$var$_shouldLogExposure(options) ? undefined : $715e622b11c913c1$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($715e622b11c913c1$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $715e622b11c913c1$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $715e622b11c913c1$var$_shouldLogExposure(options) ? undefined : $715e622b11c913c1$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($715e622b11c913c1$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $715e622b11c913c1$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $dtn6l._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $715e622b11c913c1$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $715e622b11c913c1$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $715e622b11c913c1$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $715e622b11c913c1$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $715e622b11c913c1$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $715e622b11c913c1$var$_makeParamStoreGetter;

});

parcelRegister("j6Ssa", function(module, exports) {
"use strict";
var $de98d1245d1fdec6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $dtn6l = parcelRequire("dtn6l");

var $e4Scn = parcelRequire("e4Scn");
class $de98d1245d1fdec6$var$StatsigEvaluationsDataAdapter extends $dtn6l.DataAdapterCore {
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $e4Scn.default) this._network = network;
        else this._network = new $e4Scn.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $dtn6l._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $dtn6l._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $dtn6l.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $de98d1245d1fdec6$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $dtn6l._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$dtn6l.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $dtn6l._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $de98d1245d1fdec6$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("5sFjq", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f9f9d0f283704a1$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $hLfKH = parcelRequire("hLfKH");
function $3f9f9d0f283704a1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3f9f9d0f283704a1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3f9f9d0f283704a1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3f9f9d0f283704a1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3f9f9d0f283704a1$export$a66cbd9b2289cd78 = '@all-features';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $3f9f9d0f283704a1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $3f9f9d0f283704a1$var$_objectSpread($3f9f9d0f283704a1$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $3f9f9d0f283704a1$var$_objectSpread($3f9f9d0f283704a1$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $3f9f9d0f283704a1$var$_objectSpread($3f9f9d0f283704a1$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $3f9f9d0f283704a1$var$_objectSpread($3f9f9d0f283704a1$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($3f9f9d0f283704a1$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($3f9f9d0f283704a1$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($3f9f9d0f283704a1$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $3f9f9d0f283704a1$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});
parcelRegister("hLfKH", function(module, exports) {
'use strict';
var $cee30b8789895425$var$has = Object.prototype.hasOwnProperty, $cee30b8789895425$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $cee30b8789895425$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $cee30b8789895425$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $cee30b8789895425$var$Events().__proto__) $cee30b8789895425$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $cee30b8789895425$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $cee30b8789895425$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $cee30b8789895425$var$EE(fn, context || emitter, once), evt = $cee30b8789895425$var$prefix ? $cee30b8789895425$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $cee30b8789895425$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $cee30b8789895425$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $cee30b8789895425$var$EventEmitter() {
    this._events = new $cee30b8789895425$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $cee30b8789895425$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($cee30b8789895425$var$has.call(events, name)) names.push($cee30b8789895425$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $cee30b8789895425$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $cee30b8789895425$var$prefix ? $cee30b8789895425$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $cee30b8789895425$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $cee30b8789895425$var$prefix ? $cee30b8789895425$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $cee30b8789895425$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $cee30b8789895425$var$prefix ? $cee30b8789895425$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $cee30b8789895425$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $cee30b8789895425$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $cee30b8789895425$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $cee30b8789895425$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $cee30b8789895425$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $cee30b8789895425$var$prefix ? $cee30b8789895425$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $cee30b8789895425$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $cee30b8789895425$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $cee30b8789895425$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $cee30b8789895425$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $cee30b8789895425$var$prefix ? $cee30b8789895425$var$prefix + event : event;
        if (this._events[evt]) $cee30b8789895425$var$clearEvent(this, evt);
    } else {
        this._events = new $cee30b8789895425$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$cee30b8789895425$var$EventEmitter.prototype.off = $cee30b8789895425$var$EventEmitter.prototype.removeListener;
$cee30b8789895425$var$EventEmitter.prototype.addListener = $cee30b8789895425$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$cee30b8789895425$var$EventEmitter.prefixed = $cee30b8789895425$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$cee30b8789895425$var$EventEmitter.EventEmitter = $cee30b8789895425$var$EventEmitter;
module.exports = $cee30b8789895425$var$EventEmitter;

});


parcelRegister("kkQZA", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $ecdec8188da1c9fe$export$6dc24881a3d96325);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $j7bB3 = parcelRequire("j7bB3");

var $9VHw5 = parcelRequire("9VHw5");
var $ecdec8188da1c9fe$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $j7bB3.migrateEvaluationDetails)(experiment.details), (0, $9VHw5.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("j7bB3", function(module, exports) {
$parcel$export(module.exports, "migrateEvaluationDetails", () => $dea7aaa0993ce0b6$export$18ad168d3dbac899);

var $iYJcE = parcelRequire("iYJcE");

var $48eYA = parcelRequire("48eYA");
var $dea7aaa0993ce0b6$var$evaluationReasonMappings = Object.entries((0, $48eYA.EvaluationReason)).map(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $dea7aaa0993ce0b6$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $dea7aaa0993ce0b6$var$evaluationReasonMappings.find(function(_ref3) {
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 1), key = _ref4[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $48eYA.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};

});
parcelRegister("48eYA", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $302386bafd9817fa$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $302386bafd9817fa$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
}; // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});


parcelRegister("9VHw5", function(module, exports) {
$parcel$export(module.exports, "migrateSecondaryExposures", () => $73ab3161307c3c32$export$55fd683752d01e67);
var $73ab3161307c3c32$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});


parcelRegister("eVlof", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $add6fb2e41b0a16b$export$936d0764594b6eb3);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $j7bB3 = parcelRequire("j7bB3");

var $9VHw5 = parcelRequire("9VHw5");
var $add6fb2e41b0a16b$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $j7bB3.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $9VHw5.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $9VHw5.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("9sCMD", function(module, exports) {
$parcel$export(module.exports, "deepAssign", () => $6e34d02efd8a8e5b$export$1148cb79ceecd5fa);

var $ekGgq = parcelRequire("ekGgq");

var $iYJcE = parcelRequire("iYJcE");

var $fC8ib = parcelRequire("fC8ib");
function $6e34d02efd8a8e5b$export$1148cb79ceecd5fa(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return $6e34d02efd8a8e5b$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sources)));
    for(var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], src = _Object$entries$_i[1];
        var dst = target[key];
        var srcIsObj = src && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(src) === 'object' && !Array.isArray(src);
        var dstIsObj = dst && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(dst) === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $6e34d02efd8a8e5b$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $6e34d02efd8a8e5b$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sources)));
}

});
parcelRegister("fC8ib", function(module, exports) {

var $80rv2 = parcelRequire("80rv2");

var $2XfV2 = parcelRequire("2XfV2");

var $ccaOk = parcelRequire("ccaOk");

var $eo9uW = parcelRequire("eo9uW");
function $b5e0d6462918fd61$var$_toConsumableArray(r) {
    return $80rv2(r) || $2XfV2(r) || $ccaOk(r) || $eo9uW();
}
module.exports = $b5e0d6462918fd61$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("80rv2", function(module, exports) {

var $7Edli = parcelRequire("7Edli");
function $5d43a7b0c15e0a9e$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $7Edli(r);
}
module.exports = $5d43a7b0c15e0a9e$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2XfV2", function(module, exports) {
function $226d70a7652df90f$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $226d70a7652df90f$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eo9uW", function(module, exports) {
function $a79aacb7570835cb$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $a79aacb7570835cb$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("hzt3R", function(module, exports) {
$parcel$export(module.exports, "default", () => $ccac3f82e336f7d5$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $hiARP = parcelRequire("hiARP");

var $7HOhT = parcelRequire("7HOhT");

var $iIEZa = parcelRequire("iIEZa");
function $ccac3f82e336f7d5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ccac3f82e336f7d5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ccac3f82e336f7d5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ccac3f82e336f7d5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ccac3f82e336f7d5$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $ccac3f82e336f7d5$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $ccac3f82e336f7d5$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $ccac3f82e336f7d5$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $ccac3f82e336f7d5$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $ccac3f82e336f7d5$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $ccac3f82e336f7d5$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $ccac3f82e336f7d5$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $ccac3f82e336f7d5$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $ccac3f82e336f7d5$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $ccac3f82e336f7d5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(fetcherOptions) {
                    var targetApp, url, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 1;
                                _context.next = 2;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                                _context.prev = 3;
                                _t = _context["catch"](1);
                                if (!(_t instanceof Error)) {
                                    _context.next = 4;
                                    break;
                                }
                                throw _t;
                            case 4:
                                throw Error('Failed to retrieve client sdk key');
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 2;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                                _context2.prev = 3;
                                _t2 = _context2["catch"](1);
                                if (!(_t2 instanceof Error)) {
                                    _context2.next = 4;
                                    break;
                                }
                                throw _t2;
                            case 4:
                                throw Error('Failed to retrieve experiment values');
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 2;
                                    break;
                                }
                                _context3.next = 1;
                                return response.text();
                            case 1:
                                body = _context3.sent;
                                throw new (0, $iIEZa.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 2:
                                if (!(response.status === 204)) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new (0, $iIEZa.ResponseError)('Unexpected 204 response');
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return response.text();
                            case 1:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $ccac3f82e336f7d5$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $hiARP.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $hiARP.FeatureGateEnvironment).Production:
                        return $ccac3f82e336f7d5$export$18c93900db9358a4;
                    case (0, $hiARP.FeatureGateEnvironment).Staging:
                        return $ccac3f82e336f7d5$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $hiARP.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $hiARP.FeatureGateEnvironment).Development:
                        return $ccac3f82e336f7d5$export$f058dbf75c3bc647;
                    case (0, $hiARP.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $ccac3f82e336f7d5$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $ccac3f82e336f7d5$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $ccac3f82e336f7d5$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 1;
                                return fetch("".concat(baseUrl).concat(path), $ccac3f82e336f7d5$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $7HOhT.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 1:
                                response = _context5.sent;
                                _context5.next = 2;
                                return this.handleResponseError(response);
                            case 2:
                                _context5.next = 3;
                                return this.extractResponseBody(response);
                            case 3:
                                return _context5.abrupt("return", _context5.sent);
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $ccac3f82e336f7d5$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($ccac3f82e336f7d5$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($ccac3f82e336f7d5$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("hiARP", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $c980b728ce393d17$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $c980b728ce393d17$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $c980b728ce393d17$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
var $c980b728ce393d17$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
var $c980b728ce393d17$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});

parcelRegister("7HOhT", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $59c38ea379168cf9$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $59c38ea379168cf9$export$a59f8d67326bd1cb = "6.0.1";

});

parcelRegister("iIEZa", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $da0c20ebcdf51855$export$286baf652d0b1206);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $da0c20ebcdf51855$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $da0c20ebcdf51855$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $da0c20ebcdf51855$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($da0c20ebcdf51855$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $da0c20ebcdf51855$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ResponseError);
        return $da0c20ebcdf51855$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});
parcelRegister("kIXpt", function(module, exports) {

var $ekGgq = parcelRequire("ekGgq");
var $f1660048948b9f64$var$_typeof = $ekGgq.default;

var $ilz08 = parcelRequire("ilz08");
function $f1660048948b9f64$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $f1660048948b9f64$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $ilz08(t);
}
module.exports = $f1660048948b9f64$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ilz08", function(module, exports) {
function $d5b556b08c8aee39$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $d5b556b08c8aee39$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("cYPzS", function(module, exports) {
function $973318e0cb84a68c$var$_getPrototypeOf(t) {
    return module.exports = $973318e0cb84a68c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $973318e0cb84a68c$var$_getPrototypeOf(t);
}
module.exports = $973318e0cb84a68c$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eyuDe", function(module, exports) {

var $aMsoM = parcelRequire("aMsoM");
function $a98c007cb7076ed5$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $aMsoM(t, e);
}
module.exports = $a98c007cb7076ed5$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aMsoM", function(module, exports) {
function $7d946a7286a692c7$var$_setPrototypeOf(t, e) {
    return module.exports = $7d946a7286a692c7$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $7d946a7286a692c7$var$_setPrototypeOf(t, e);
}
module.exports = $7d946a7286a692c7$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("c7s0H", function(module, exports) {

var $cYPzS = parcelRequire("cYPzS");

var $aMsoM = parcelRequire("aMsoM");

var $eBlTh = parcelRequire("eBlTh");

var $lyIwl = parcelRequire("lyIwl");
function $8d2bddb8428cdada$var$_wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return module.exports = $8d2bddb8428cdada$var$_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !$eBlTh(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return $lyIwl(t, arguments, $cYPzS(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $aMsoM(Wrapper, t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $8d2bddb8428cdada$var$_wrapNativeSuper(t);
}
module.exports = $8d2bddb8428cdada$var$_wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("eBlTh", function(module, exports) {
function $aa15806f3ef01ea8$var$_isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
module.exports = $aa15806f3ef01ea8$var$_isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lyIwl", function(module, exports) {

var $agUgE = parcelRequire("agUgE");

var $aMsoM = parcelRequire("aMsoM");
function $fb1f4ecffe144cb9$var$_construct(t, e, r) {
    if ($agUgE()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $aMsoM(p, r.prototype), p;
}
module.exports = $fb1f4ecffe144cb9$var$_construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("agUgE", function(module, exports) {
function $77a70b912f3fa5ba$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $77a70b912f3fa5ba$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $77a70b912f3fa5ba$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("2y8p6", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $1db54690546f254d$export$d119b37e5f788b43);

var $25nEq = parcelRequire("25nEq");

var $c2e6M = parcelRequire("c2e6M");

var $hiARP = parcelRequire("hiARP");
function $1db54690546f254d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1db54690546f254d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1db54690546f254d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1db54690546f254d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1db54690546f254d$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $1db54690546f254d$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $c2e6M.isFedRamp)() ? (0, $hiARP.PerimeterType).FEDRAMP_MODERATE : (0, $hiARP.PerimeterType).COMMERCIAL
    }, options);
};

});
parcelRegister("c2e6M", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $8c309d9222a86dd8$export$64d6499adf9b2e51);

var $km6mj = parcelRequire("km6mj");
function $8c309d9222a86dd8$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $km6mj.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("km6mj", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $ed1acb7014ed705c$export$ce553301d55c2fd8);
var $ed1acb7014ed705c$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $ed1acb7014ed705c$export$f005e2e9f707cb5f = 'commercial';
var $ed1acb7014ed705c$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $ed1acb7014ed705c$export$a739cd5aac835909 = 'stg';
var $ed1acb7014ed705c$export$42dd0cdd351a4a9 = 'prod';
var $ed1acb7014ed705c$export$404582bc18fe4d9e = 'dev';

});



parcelRegister("f0l1D", function(module, exports) {
$parcel$export(module.exports, "migrateInitializationOptions", () => $aec72a525d87bbff$export$202946b690d26d22);

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");
var $aec72a525d87bbff$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $aec72a525d87bbff$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $aec72a525d87bbff$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $aec72a525d87bbff$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $aec72a525d87bbff$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $aec72a525d87bbff$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(options, $aec72a525d87bbff$var$_excluded);
    return $aec72a525d87bbff$var$_objectSpread($aec72a525d87bbff$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};

});

parcelRegister("2usPa", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $1d04be09211aff82$export$55fffef3474104af);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");
function $1d04be09211aff82$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1d04be09211aff82$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1d04be09211aff82$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1d04be09211aff82$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1d04be09211aff82$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $1d04be09211aff82$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $1d04be09211aff82$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1d04be09211aff82$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1d04be09211aff82$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $1d04be09211aff82$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoFetchDataAdapter);
        _this = $1d04be09211aff82$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $1d04be09211aff82$var$_objectSpread($1d04be09211aff82$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $1d04be09211aff82$var$_objectSpread($1d04be09211aff82$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $1d04be09211aff82$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $1d04be09211aff82$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));

});
parcelRegister("lwlXp", function(module, exports) {

var $6HP01 = parcelRequire("6HP01");
function $faad9e602d30b37d$var$_get() {
    return module.exports = $faad9e602d30b37d$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $6HP01(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $faad9e602d30b37d$var$_get.apply(null, arguments);
}
module.exports = $faad9e602d30b37d$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6HP01", function(module, exports) {

var $cYPzS = parcelRequire("cYPzS");
function $4e1e51a03226bd6a$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $cYPzS(t)););
    return t;
}
module.exports = $4e1e51a03226bd6a$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("j3SRh", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $de08d9d5ed18ea05$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $de08d9d5ed18ea05$export$bcb28fbac1def494);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $dtn6l = parcelRequire("dtn6l");
function $de08d9d5ed18ea05$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $de08d9d5ed18ea05$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $de08d9d5ed18ea05$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $de08d9d5ed18ea05$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $de08d9d5ed18ea05$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $de08d9d5ed18ea05$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $de08d9d5ed18ea05$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $de08d9d5ed18ea05$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $de08d9d5ed18ea05$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $de08d9d5ed18ea05$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $de08d9d5ed18ea05$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $de08d9d5ed18ea05$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $de08d9d5ed18ea05$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $de08d9d5ed18ea05$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $de08d9d5ed18ea05$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $de08d9d5ed18ea05$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PersistentOverrideAdapter);
        this._overrides = $de08d9d5ed18ea05$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $de08d9d5ed18ea05$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $de08d9d5ed18ea05$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $de08d9d5ed18ea05$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($de08d9d5ed18ea05$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.removeItem($de08d9d5ed18ea05$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $de08d9d5ed18ea05$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $de08d9d5ed18ea05$var$_objectSpread($de08d9d5ed18ea05$var$_objectSpread({}, $de08d9d5ed18ea05$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($de08d9d5ed18ea05$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($de08d9d5ed18ea05$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($de08d9d5ed18ea05$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($de08d9d5ed18ea05$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $de08d9d5ed18ea05$var$_objectSpread($de08d9d5ed18ea05$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $de08d9d5ed18ea05$var$_objectSpread($de08d9d5ed18ea05$var$_objectSpread({}, current.details), {}, {
                        reason: $de08d9d5ed18ea05$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($de08d9d5ed18ea05$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($de08d9d5ed18ea05$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($de08d9d5ed18ea05$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($de08d9d5ed18ea05$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($de08d9d5ed18ea05$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($de08d9d5ed18ea05$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $de08d9d5ed18ea05$var$makeEmptyStore();
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($de08d9d5ed18ea05$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $de08d9d5ed18ea05$var$_objectSpread($de08d9d5ed18ea05$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $de08d9d5ed18ea05$var$_objectSpread($de08d9d5ed18ea05$var$_objectSpread({}, current.details), {}, {
                        reason: $de08d9d5ed18ea05$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($de08d9d5ed18ea05$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $de08d9d5ed18ea05$var$_objectSpread($de08d9d5ed18ea05$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $de08d9d5ed18ea05$var$_objectSpread($de08d9d5ed18ea05$var$_objectSpread({}, current.details), {}, {
                        reason: $de08d9d5ed18ea05$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});

parcelRegister("55r6R", function(module, exports) {
$parcel$export(module.exports, "shallowEquals", () => $3b4272c6781d50f0$export$fa1c2bbf4100b8bc);

var $iYJcE = parcelRequire("iYJcE");
var $3b4272c6781d50f0$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};

});

parcelRegister("3yi6c", function(module, exports) {
$parcel$export(module.exports, "toStatsigUser", () => $2962962aef49b26f$export$3dad1db244472f32);

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");
var $2962962aef49b26f$var$_excluded = [
    "stableId"
];
function $2962962aef49b26f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2962962aef49b26f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2962962aef49b26f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2962962aef49b26f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2962962aef49b26f$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    var stableId = identifiers.stableId, otherIdentifiers = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(identifiers, $2962962aef49b26f$var$_excluded);
    var user = {
        customIDs: $2962962aef49b26f$var$_objectSpread($2962962aef49b26f$var$_objectSpread({}, otherIdentifiers), stableId !== undefined ? {
            stableID: stableId
        } : {}),
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};

});



parcelRegister("kjcRI", function(module, exports) {
$parcel$export(module.exports, "debug", () => $ec8f8fc8c8703c3d$export$1c9f709888824e05);
var $ec8f8fc8c8703c3d$var$_process, $ec8f8fc8c8703c3d$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $ec8f8fc8c8703c3d$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($ec8f8fc8c8703c3d$var$_process = globalThis.process) === null || $ec8f8fc8c8703c3d$var$_process === void 0 || ($ec8f8fc8c8703c3d$var$_process = $ec8f8fc8c8703c3d$var$_process.env) === null || $ec8f8fc8c8703c3d$var$_process === void 0 ? void 0 : $ec8f8fc8c8703c3d$var$_process.JEST_WORKER_ID) !== undefined;
var $ec8f8fc8c8703c3d$var$DEBUG_MODE = !$ec8f8fc8c8703c3d$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($ec8f8fc8c8703c3d$var$_process2 = globalThis.process) === null || $ec8f8fc8c8703c3d$var$_process2 === void 0 || ($ec8f8fc8c8703c3d$var$_process2 = $ec8f8fc8c8703c3d$var$_process2.env) === null || $ec8f8fc8c8703c3d$var$_process2 === void 0 ? void 0 : $ec8f8fc8c8703c3d$var$_process2.NODE_ENV) !== 'production';
var $ec8f8fc8c8703c3d$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$ec8f8fc8c8703c3d$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});

parcelRegister("9i3MK", function(module, exports) {
$parcel$export(module.exports, "ENV_ENABLE_PLATFORM_FF", () => $6c38bb2859beab5d$export$b574c24e1e6490f5);

var $lLIS3 = parcelRequire("lLIS3");
var $6c38bb2859beab5d$export$b574c24e1e6490f5 = (0, $lLIS3.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});
parcelRegister("lLIS3", function(module, exports) {
$parcel$export(module.exports, "PFF_GLOBAL_KEY", () => $fd90cb3103826b9d$export$7e41b1b2bdee3f98);
$parcel$export(module.exports, "pkgName", () => $fd90cb3103826b9d$export$407f05df8e3ce9f3);
$parcel$export(module.exports, "hasProcessEnv", () => $fd90cb3103826b9d$export$75f4a1454eff2805);

var $3ZMUU = parcelRequire("3ZMUU");
var $fd90cb3103826b9d$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $fd90cb3103826b9d$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
var $fd90cb3103826b9d$export$75f4a1454eff2805 = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';

});


parcelRegister("iuNyR", function(module, exports) {
$parcel$export(module.exports, "ENV_STORYBOOK_ENABLE_PLATFORM_FF", () => $d771792e1dd2dcb6$export$92f8b531feaeb23d);

var $lLIS3 = parcelRequire("lLIS3");
var $d771792e1dd2dcb6$export$92f8b531feaeb23d = (0, $lLIS3.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});

parcelRegister("e2P9b", function(module, exports) {
$parcel$export(module.exports, "globalVar", () => $a398ed5a30e3a949$export$54ea85357b4e0159);

var $lLIS3 = parcelRequire("lLIS3");
var $a398ed5a30e3a949$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $a398ed5a30e3a949$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$a398ed5a30e3a949$export$54ea85357b4e0159[0, $lLIS3.PFF_GLOBAL_KEY] = $a398ed5a30e3a949$export$54ea85357b4e0159[0, $lLIS3.PFF_GLOBAL_KEY] || $a398ed5a30e3a949$var$DEFAULT_PFF_GLOBAL;

});



parcelRegister("9AP5g", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $6fbf1a0fc3bf0ef0$export$4ef52930e33717cd);
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", () => $6fbf1a0fc3bf0ef0$export$cb374d25ded7f6ab);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $6fbf1a0fc3bf0ef0$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $6fbf1a0fc3bf0ef0$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $6fbf1a0fc3bf0ef0$export$352e418ed5b6193a);
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", () => $6fbf1a0fc3bf0ef0$export$dddac1532e822863);
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $6fbf1a0fc3bf0ef0$export$9d7b58831ae93caa);
var $6fbf1a0fc3bf0ef0$export$4ef52930e33717cd = 'data-theme';
var $6fbf1a0fc3bf0ef0$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $6fbf1a0fc3bf0ef0$export$a00eac3f8684bcd0 = 'data-color-mode';
var $6fbf1a0fc3bf0ef0$export$2112803007239c61 = 'data-contrast-mode';
var $6fbf1a0fc3bf0ef0$export$352e418ed5b6193a = 'data-custom-theme';
var $6fbf1a0fc3bf0ef0$export$6f0c6fb8c80fcc92 = 'ds';
var $6fbf1a0fc3bf0ef0$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $6fbf1a0fc3bf0ef0$export$dddac1532e822863 = "--".concat($6fbf1a0fc3bf0ef0$export$6f0c6fb8c80fcc92, "-token-not-found");
var $6fbf1a0fc3bf0ef0$export$9d7b58831ae93caa = "--".concat($6fbf1a0fc3bf0ef0$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("3ENxc", function(module, exports) {
$parcel$export(module.exports, "hash", () => $2a9b880a994ef4e4$export$d6af199866bfb566);
var $2a9b880a994ef4e4$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("7QpUe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $g2LBo = parcelRequire("g2LBo");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $g2LBo.bind;
    }
});

var $lcukj = parcelRequire("lcukj");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $lcukj.bindAll;
    }
});

});
parcelRegister("g2LBo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $bae1c2098f2dd253$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $bae1c2098f2dd253$var$bind;

});

parcelRegister("lcukj", function(module, exports) {
"use strict";
var $f6f23e2d6cc820f3$var$__assign = module.exports && module.exports.__assign || function() {
    $f6f23e2d6cc820f3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f6f23e2d6cc820f3$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $g2LBo = parcelRequire("g2LBo");
function $f6f23e2d6cc820f3$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $f6f23e2d6cc820f3$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $f6f23e2d6cc820f3$var$__assign($f6f23e2d6cc820f3$var$__assign({}, original), {
        options: $f6f23e2d6cc820f3$var$__assign($f6f23e2d6cc820f3$var$__assign({}, $f6f23e2d6cc820f3$var$toOptions(sharedOptions)), $f6f23e2d6cc820f3$var$toOptions(original.options))
    });
    return binding;
}
function $f6f23e2d6cc820f3$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $f6f23e2d6cc820f3$var$getBinding(original, sharedOptions);
        return (0, $g2LBo.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $f6f23e2d6cc820f3$var$bindAll;

});


parcelRegister("bDSDt", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("8dpxt").then(()=>parcelRequire('dBLpv'));

});
parcelRegister("iKwew", function(module, exports) {
"use strict";

function $da6586bd2e851bf4$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("F8oyc")).resolve(id));
}
module.exports = $da6586bd2e851bf4$var$load;

});
parcelRegister("F8oyc", function(module, exports) {
$parcel$export(module.exports, "register", () => $07ba578472346502$export$6503ec6e8aabbaf, (v) => $07ba578472346502$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $07ba578472346502$export$f7ad0328861e2f03, (v) => $07ba578472346502$export$f7ad0328861e2f03 = v);
var $07ba578472346502$export$6503ec6e8aabbaf;
var $07ba578472346502$export$f7ad0328861e2f03;
"use strict";
var $07ba578472346502$var$mapping = new Map();
function $07ba578472346502$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$07ba578472346502$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $07ba578472346502$var$resolve(id) {
    var resolved = $07ba578472346502$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$07ba578472346502$export$6503ec6e8aabbaf = $07ba578472346502$var$register;
$07ba578472346502$export$f7ad0328861e2f03 = $07ba578472346502$var$resolve;

});



parcelRegister("8SV4m", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("6mk2N").then(()=>parcelRequire('d9oU7'));

});

parcelRegister("3sbKi", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("aNqkA").then(()=>parcelRequire('hJxyI'));

});

parcelRegister("clWHD", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("lbEn5").then(()=>parcelRequire('7pXzE'));

});

parcelRegister("10OzB", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("i8ZQs").then(()=>parcelRequire('19VjI'));

});

parcelRegister("2hNfn", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("MbyqT").then(()=>parcelRequire('hOC60'));

});

parcelRegister("tvvg7", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("jPqVY").then(()=>parcelRequire('e8q7g'));

});

parcelRegister("8Ul61", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("fXI52").then(()=>parcelRequire('aYEHp'));

});

parcelRegister("fUMDb", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("hwaZz").then(()=>parcelRequire('c5rYc'));

});

parcelRegister("fONlQ", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("cUfjS").then(()=>parcelRequire('evOvQ'));

});

parcelRegister("89bQV", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("1QQmc").then(()=>parcelRequire('565l2'));

});

parcelRegister("5r8Y4", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("8g0D1").then(()=>parcelRequire('7cU8a'));

});

parcelRegister("9aLgs", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("8JRRA").then(()=>parcelRequire('d7lZx'));

});

parcelRegister("b3HFs", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("19czx").then(()=>parcelRequire('jyhWx'));

});

parcelRegister("1VnnL", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("8f3uh").then(()=>parcelRequire('all87'));

});

parcelRegister("2BLfh", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("lKdH4").then(()=>parcelRequire('dkaXG'));

});

parcelRegister("j7Ivm", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("iUl3e").then(()=>parcelRequire('JvPYp'));

});

parcelRegister("8OJT1", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("gi38D").then(()=>parcelRequire('9VvJj'));

});

parcelRegister("3ZSjy", function(module, exports) {
$parcel$export(module.exports, "AsyncMode", () => $2e91334b5860e1ff$export$2b8d127b894957b9, (v) => $2e91334b5860e1ff$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $2e91334b5860e1ff$export$cea3a54a6425200c, (v) => $2e91334b5860e1ff$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $2e91334b5860e1ff$export$a7c73072b1a182ae, (v) => $2e91334b5860e1ff$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $2e91334b5860e1ff$export$9f27bc3417b4524d, (v) => $2e91334b5860e1ff$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $2e91334b5860e1ff$export$db77ccec0bb4ccac, (v) => $2e91334b5860e1ff$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $2e91334b5860e1ff$export$8392c0c9d3dcbd35, (v) => $2e91334b5860e1ff$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $2e91334b5860e1ff$export$ffb0004e005737fa, (v) => $2e91334b5860e1ff$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $2e91334b5860e1ff$export$b624eff549462981, (v) => $2e91334b5860e1ff$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $2e91334b5860e1ff$export$7897aa7841a5380c, (v) => $2e91334b5860e1ff$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $2e91334b5860e1ff$export$602eac185826482c, (v) => $2e91334b5860e1ff$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $2e91334b5860e1ff$export$e2c29f18771995cb, (v) => $2e91334b5860e1ff$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $2e91334b5860e1ff$export$5f8d39834fd61797, (v) => $2e91334b5860e1ff$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $2e91334b5860e1ff$export$74bf444e3cd11ea5, (v) => $2e91334b5860e1ff$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $2e91334b5860e1ff$export$92387174baf9b227, (v) => $2e91334b5860e1ff$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $2e91334b5860e1ff$export$ec112efeb987d9c6, (v) => $2e91334b5860e1ff$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $2e91334b5860e1ff$export$b706b080d889d2c9, (v) => $2e91334b5860e1ff$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $2e91334b5860e1ff$export$5be5a87408f70ddc, (v) => $2e91334b5860e1ff$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $2e91334b5860e1ff$export$45a5e7f76e0caa8d, (v) => $2e91334b5860e1ff$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $2e91334b5860e1ff$export$455c2e768291efa6, (v) => $2e91334b5860e1ff$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $2e91334b5860e1ff$export$9522e17588c12572, (v) => $2e91334b5860e1ff$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $2e91334b5860e1ff$export$2110ac352bb060b9, (v) => $2e91334b5860e1ff$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $2e91334b5860e1ff$export$56885ab8b9c456ab, (v) => $2e91334b5860e1ff$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $2e91334b5860e1ff$export$d927fcb6adf8f9de, (v) => $2e91334b5860e1ff$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $2e91334b5860e1ff$export$b82d16f27459e05a, (v) => $2e91334b5860e1ff$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $2e91334b5860e1ff$export$522c17b4f5e123e8, (v) => $2e91334b5860e1ff$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $2e91334b5860e1ff$export$1aabd8a0274ecfd6, (v) => $2e91334b5860e1ff$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $2e91334b5860e1ff$export$9b621391a187a31a, (v) => $2e91334b5860e1ff$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $2e91334b5860e1ff$export$f5bbd400c2f4426f, (v) => $2e91334b5860e1ff$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2e91334b5860e1ff$export$2b8d127b894957b9;
var $2e91334b5860e1ff$export$cea3a54a6425200c;
var $2e91334b5860e1ff$export$a7c73072b1a182ae;
var $2e91334b5860e1ff$export$9f27bc3417b4524d;
var $2e91334b5860e1ff$export$db77ccec0bb4ccac;
var $2e91334b5860e1ff$export$8392c0c9d3dcbd35;
var $2e91334b5860e1ff$export$ffb0004e005737fa;
var $2e91334b5860e1ff$export$b624eff549462981;
var $2e91334b5860e1ff$export$7897aa7841a5380c;
var $2e91334b5860e1ff$export$602eac185826482c;
var $2e91334b5860e1ff$export$e2c29f18771995cb;
var $2e91334b5860e1ff$export$5f8d39834fd61797;
var $2e91334b5860e1ff$export$74bf444e3cd11ea5;
var $2e91334b5860e1ff$export$92387174baf9b227;
var $2e91334b5860e1ff$export$ec112efeb987d9c6;
var $2e91334b5860e1ff$export$b706b080d889d2c9;
var $2e91334b5860e1ff$export$5be5a87408f70ddc;
var $2e91334b5860e1ff$export$45a5e7f76e0caa8d;
var $2e91334b5860e1ff$export$455c2e768291efa6;
var $2e91334b5860e1ff$export$9522e17588c12572;
var $2e91334b5860e1ff$export$2110ac352bb060b9;
var $2e91334b5860e1ff$export$56885ab8b9c456ab;
var $2e91334b5860e1ff$export$d927fcb6adf8f9de;
var $2e91334b5860e1ff$export$b82d16f27459e05a;
var $2e91334b5860e1ff$export$522c17b4f5e123e8;
var $2e91334b5860e1ff$export$1aabd8a0274ecfd6;
var $2e91334b5860e1ff$export$9b621391a187a31a;
var $2e91334b5860e1ff$export$f5bbd400c2f4426f;
'use strict';
var $2e91334b5860e1ff$var$b = "function" === typeof Symbol && Symbol.for, $2e91334b5860e1ff$var$c = $2e91334b5860e1ff$var$b ? Symbol.for("react.element") : 60103, $2e91334b5860e1ff$var$d = $2e91334b5860e1ff$var$b ? Symbol.for("react.portal") : 60106, $2e91334b5860e1ff$var$e = $2e91334b5860e1ff$var$b ? Symbol.for("react.fragment") : 60107, $2e91334b5860e1ff$var$f = $2e91334b5860e1ff$var$b ? Symbol.for("react.strict_mode") : 60108, $2e91334b5860e1ff$var$g = $2e91334b5860e1ff$var$b ? Symbol.for("react.profiler") : 60114, $2e91334b5860e1ff$var$h = $2e91334b5860e1ff$var$b ? Symbol.for("react.provider") : 60109, $2e91334b5860e1ff$var$k = $2e91334b5860e1ff$var$b ? Symbol.for("react.context") : 60110, $2e91334b5860e1ff$var$l = $2e91334b5860e1ff$var$b ? Symbol.for("react.async_mode") : 60111, $2e91334b5860e1ff$var$m = $2e91334b5860e1ff$var$b ? Symbol.for("react.concurrent_mode") : 60111, $2e91334b5860e1ff$var$n = $2e91334b5860e1ff$var$b ? Symbol.for("react.forward_ref") : 60112, $2e91334b5860e1ff$var$p = $2e91334b5860e1ff$var$b ? Symbol.for("react.suspense") : 60113, $2e91334b5860e1ff$var$q = $2e91334b5860e1ff$var$b ? Symbol.for("react.suspense_list") : 60120, $2e91334b5860e1ff$var$r = $2e91334b5860e1ff$var$b ? Symbol.for("react.memo") : 60115, $2e91334b5860e1ff$var$t = $2e91334b5860e1ff$var$b ? Symbol.for("react.lazy") : 60116, $2e91334b5860e1ff$var$v = $2e91334b5860e1ff$var$b ? Symbol.for("react.block") : 60121, $2e91334b5860e1ff$var$w = $2e91334b5860e1ff$var$b ? Symbol.for("react.fundamental") : 60117, $2e91334b5860e1ff$var$x = $2e91334b5860e1ff$var$b ? Symbol.for("react.responder") : 60118, $2e91334b5860e1ff$var$y = $2e91334b5860e1ff$var$b ? Symbol.for("react.scope") : 60119;
function $2e91334b5860e1ff$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $2e91334b5860e1ff$var$c:
                switch(a = a.type, a){
                    case $2e91334b5860e1ff$var$l:
                    case $2e91334b5860e1ff$var$m:
                    case $2e91334b5860e1ff$var$e:
                    case $2e91334b5860e1ff$var$g:
                    case $2e91334b5860e1ff$var$f:
                    case $2e91334b5860e1ff$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2e91334b5860e1ff$var$k:
                            case $2e91334b5860e1ff$var$n:
                            case $2e91334b5860e1ff$var$t:
                            case $2e91334b5860e1ff$var$r:
                            case $2e91334b5860e1ff$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $2e91334b5860e1ff$var$d:
                return u;
        }
    }
}
function $2e91334b5860e1ff$var$A(a) {
    return $2e91334b5860e1ff$var$z(a) === $2e91334b5860e1ff$var$m;
}
$2e91334b5860e1ff$export$2b8d127b894957b9 = $2e91334b5860e1ff$var$l;
$2e91334b5860e1ff$export$cea3a54a6425200c = $2e91334b5860e1ff$var$m;
$2e91334b5860e1ff$export$a7c73072b1a182ae = $2e91334b5860e1ff$var$k;
$2e91334b5860e1ff$export$9f27bc3417b4524d = $2e91334b5860e1ff$var$h;
$2e91334b5860e1ff$export$db77ccec0bb4ccac = $2e91334b5860e1ff$var$c;
$2e91334b5860e1ff$export$8392c0c9d3dcbd35 = $2e91334b5860e1ff$var$n;
$2e91334b5860e1ff$export$ffb0004e005737fa = $2e91334b5860e1ff$var$e;
$2e91334b5860e1ff$export$b624eff549462981 = $2e91334b5860e1ff$var$t;
$2e91334b5860e1ff$export$7897aa7841a5380c = $2e91334b5860e1ff$var$r;
$2e91334b5860e1ff$export$602eac185826482c = $2e91334b5860e1ff$var$d;
$2e91334b5860e1ff$export$e2c29f18771995cb = $2e91334b5860e1ff$var$g;
$2e91334b5860e1ff$export$5f8d39834fd61797 = $2e91334b5860e1ff$var$f;
$2e91334b5860e1ff$export$74bf444e3cd11ea5 = $2e91334b5860e1ff$var$p;
$2e91334b5860e1ff$export$92387174baf9b227 = function(a) {
    return $2e91334b5860e1ff$var$A(a) || $2e91334b5860e1ff$var$z(a) === $2e91334b5860e1ff$var$l;
};
$2e91334b5860e1ff$export$ec112efeb987d9c6 = $2e91334b5860e1ff$var$A;
$2e91334b5860e1ff$export$b706b080d889d2c9 = function(a) {
    return $2e91334b5860e1ff$var$z(a) === $2e91334b5860e1ff$var$k;
};
$2e91334b5860e1ff$export$5be5a87408f70ddc = function(a) {
    return $2e91334b5860e1ff$var$z(a) === $2e91334b5860e1ff$var$h;
};
$2e91334b5860e1ff$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2e91334b5860e1ff$var$c;
};
$2e91334b5860e1ff$export$455c2e768291efa6 = function(a) {
    return $2e91334b5860e1ff$var$z(a) === $2e91334b5860e1ff$var$n;
};
$2e91334b5860e1ff$export$9522e17588c12572 = function(a) {
    return $2e91334b5860e1ff$var$z(a) === $2e91334b5860e1ff$var$e;
};
$2e91334b5860e1ff$export$2110ac352bb060b9 = function(a) {
    return $2e91334b5860e1ff$var$z(a) === $2e91334b5860e1ff$var$t;
};
$2e91334b5860e1ff$export$56885ab8b9c456ab = function(a) {
    return $2e91334b5860e1ff$var$z(a) === $2e91334b5860e1ff$var$r;
};
$2e91334b5860e1ff$export$d927fcb6adf8f9de = function(a) {
    return $2e91334b5860e1ff$var$z(a) === $2e91334b5860e1ff$var$d;
};
$2e91334b5860e1ff$export$b82d16f27459e05a = function(a) {
    return $2e91334b5860e1ff$var$z(a) === $2e91334b5860e1ff$var$g;
};
$2e91334b5860e1ff$export$522c17b4f5e123e8 = function(a) {
    return $2e91334b5860e1ff$var$z(a) === $2e91334b5860e1ff$var$f;
};
$2e91334b5860e1ff$export$1aabd8a0274ecfd6 = function(a) {
    return $2e91334b5860e1ff$var$z(a) === $2e91334b5860e1ff$var$p;
};
$2e91334b5860e1ff$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2e91334b5860e1ff$var$e || a === $2e91334b5860e1ff$var$m || a === $2e91334b5860e1ff$var$g || a === $2e91334b5860e1ff$var$f || a === $2e91334b5860e1ff$var$p || a === $2e91334b5860e1ff$var$q || "object" === typeof a && null !== a && (a.$$typeof === $2e91334b5860e1ff$var$t || a.$$typeof === $2e91334b5860e1ff$var$r || a.$$typeof === $2e91334b5860e1ff$var$h || a.$$typeof === $2e91334b5860e1ff$var$k || a.$$typeof === $2e91334b5860e1ff$var$n || a.$$typeof === $2e91334b5860e1ff$var$w || a.$$typeof === $2e91334b5860e1ff$var$x || a.$$typeof === $2e91334b5860e1ff$var$y || a.$$typeof === $2e91334b5860e1ff$var$v);
};
$2e91334b5860e1ff$export$f5bbd400c2f4426f = $2e91334b5860e1ff$var$z;

});

parcelRegister("ftB2S", function(module, exports) {
$parcel$export(module.exports, "filterProps", () => $b4464ce91a872efb$export$d697c39a2985a4c);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $b4464ce91a872efb$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "createIntlCache", () => $b4464ce91a872efb$export$51c4f4e973f2dc00);
$parcel$export(module.exports, "createFormatters", () => $b4464ce91a872efb$export$c3f4cd5551df13fd);
$parcel$export(module.exports, "getNamedFormat", () => $b4464ce91a872efb$export$4ee1db8ce44a209b);

var $l2Z7B = parcelRequire("l2Z7B");

var $9exF4 = parcelRequire("9exF4");

var $pW1k6 = parcelRequire("pW1k6");

var $lxO85 = parcelRequire("lxO85");
function $b4464ce91a872efb$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $b4464ce91a872efb$var$defaultErrorHandler = function(error) {};
var $b4464ce91a872efb$var$defaultWarnHandler = function(warning) {};
var $b4464ce91a872efb$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $b4464ce91a872efb$var$defaultErrorHandler,
    onWarn: $b4464ce91a872efb$var$defaultWarnHandler
};
function $b4464ce91a872efb$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $b4464ce91a872efb$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $b4464ce91a872efb$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $b4464ce91a872efb$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $pW1k6.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $l2Z7B.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $b4464ce91a872efb$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $pW1k6.strategies).variadic
    });
    var getNumberFormat = (0, $pW1k6.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $l2Z7B.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $b4464ce91a872efb$var$createFastMemoizeCache(cache.number),
        strategy: (0, $pW1k6.strategies).variadic
    });
    var getPluralRules = (0, $pW1k6.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $l2Z7B.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $b4464ce91a872efb$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $pW1k6.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $pW1k6.default)(function(message, locales, overrideFormats, opts) {
            return new (0, $9exF4.IntlMessageFormat)(message, locales, overrideFormats, (0, $l2Z7B.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $b4464ce91a872efb$var$createFastMemoizeCache(cache.message),
            strategy: (0, $pW1k6.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $pW1k6.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $l2Z7B.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $b4464ce91a872efb$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $pW1k6.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $pW1k6.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $l2Z7B.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $b4464ce91a872efb$var$createFastMemoizeCache(cache.list),
            strategy: (0, $pW1k6.strategies).variadic
        }),
        getDisplayNames: (0, $pW1k6.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $l2Z7B.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $b4464ce91a872efb$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $pW1k6.strategies).variadic
        })
    };
}
function $b4464ce91a872efb$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $lxO85.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("l2Z7B", function(module, exports) {
$parcel$export(module.exports, "__extends", () => $f529325f6b7626f5$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $f529325f6b7626f5$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $f529325f6b7626f5$export$3c9a16f847548506);
$parcel$export(module.exports, "__exportStar", () => $f529325f6b7626f5$export$f33643c0debef087);
$parcel$export(module.exports, "__spreadArrays", () => $f529325f6b7626f5$export$6388937ca91ccae8);
$parcel$export(module.exports, "__spreadArray", () => $f529325f6b7626f5$export$1216008129fb82ed);
$parcel$export(module.exports, "__importDefault", () => $f529325f6b7626f5$export$da59b14a69baef04);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $f529325f6b7626f5$var$extendStatics = function(d, b) {
    $f529325f6b7626f5$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f529325f6b7626f5$var$extendStatics(d, b);
};
function $f529325f6b7626f5$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f529325f6b7626f5$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f529325f6b7626f5$export$18ce0697a983be9b = function() {
    $f529325f6b7626f5$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f529325f6b7626f5$export$18ce0697a983be9b.apply(this, arguments);
};
function $f529325f6b7626f5$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f529325f6b7626f5$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f529325f6b7626f5$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f529325f6b7626f5$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f529325f6b7626f5$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f529325f6b7626f5$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $f529325f6b7626f5$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f529325f6b7626f5$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f529325f6b7626f5$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f529325f6b7626f5$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f529325f6b7626f5$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f529325f6b7626f5$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f529325f6b7626f5$export$45d3717a4c69092e(o, m, p);
}
function $f529325f6b7626f5$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f529325f6b7626f5$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f529325f6b7626f5$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f529325f6b7626f5$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f529325f6b7626f5$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f529325f6b7626f5$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f529325f6b7626f5$export$10c90e4f7922046c(v) {
    return this instanceof $f529325f6b7626f5$export$10c90e4f7922046c ? (this.v = v, this) : new $f529325f6b7626f5$export$10c90e4f7922046c(v);
}
function $f529325f6b7626f5$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f529325f6b7626f5$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f529325f6b7626f5$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f529325f6b7626f5$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $f529325f6b7626f5$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f529325f6b7626f5$export$19a8beecd37a4c45 === "function" ? $f529325f6b7626f5$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f529325f6b7626f5$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f529325f6b7626f5$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $f529325f6b7626f5$var$ownKeys = function(o) {
    $f529325f6b7626f5$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $f529325f6b7626f5$var$ownKeys(o);
};
function $f529325f6b7626f5$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $f529325f6b7626f5$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $f529325f6b7626f5$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $f529325f6b7626f5$var$__setModuleDefault(result, mod);
    return result;
}
function $f529325f6b7626f5$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f529325f6b7626f5$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f529325f6b7626f5$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f529325f6b7626f5$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f529325f6b7626f5$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f529325f6b7626f5$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f529325f6b7626f5$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $f529325f6b7626f5$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $f529325f6b7626f5$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $f529325f6b7626f5$export$2e2bcd8739ae039 = {
    __extends: $f529325f6b7626f5$export$a8ba968b8961cb8a,
    __assign: $f529325f6b7626f5$export$18ce0697a983be9b,
    __rest: $f529325f6b7626f5$export$3c9a16f847548506,
    __decorate: $f529325f6b7626f5$export$29e00dfd3077644b,
    __param: $f529325f6b7626f5$export$d5ad3fd78186038f,
    __esDecorate: $f529325f6b7626f5$export$3a84e1ae4e97e9b0,
    __runInitializers: $f529325f6b7626f5$export$d831c04e792af3d,
    __propKey: $f529325f6b7626f5$export$6a2a36740a146cb8,
    __setFunctionName: $f529325f6b7626f5$export$d1a06452d3489bc7,
    __metadata: $f529325f6b7626f5$export$f1db080c865becb9,
    __awaiter: $f529325f6b7626f5$export$1050f835b63b671e,
    __generator: $f529325f6b7626f5$export$67ebef60e6f28a6,
    __createBinding: $f529325f6b7626f5$export$45d3717a4c69092e,
    __exportStar: $f529325f6b7626f5$export$f33643c0debef087,
    __values: $f529325f6b7626f5$export$19a8beecd37a4c45,
    __read: $f529325f6b7626f5$export$8d051b38c9118094,
    __spread: $f529325f6b7626f5$export$afc72e2116322959,
    __spreadArrays: $f529325f6b7626f5$export$6388937ca91ccae8,
    __spreadArray: $f529325f6b7626f5$export$1216008129fb82ed,
    __await: $f529325f6b7626f5$export$10c90e4f7922046c,
    __asyncGenerator: $f529325f6b7626f5$export$e427f37a30a4de9b,
    __asyncDelegator: $f529325f6b7626f5$export$bbd80228419bb833,
    __asyncValues: $f529325f6b7626f5$export$e3b29a3d6162315f,
    __makeTemplateObject: $f529325f6b7626f5$export$4fb47efe1390b86f,
    __importStar: $f529325f6b7626f5$export$c21735bcef00d192,
    __importDefault: $f529325f6b7626f5$export$da59b14a69baef04,
    __classPrivateFieldGet: $f529325f6b7626f5$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f529325f6b7626f5$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f529325f6b7626f5$export$81fdc39f203e4e04,
    __addDisposableResource: $f529325f6b7626f5$export$88ac25d8e944e405,
    __disposeResources: $f529325f6b7626f5$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $f529325f6b7626f5$export$889dfb5d17574b0b
};

});

parcelRegister("9exF4", function(module, exports) {
$parcel$export(module.exports, "IntlMessageFormat", () => $6b8f88550973e494$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $l2Z7B = parcelRequire("l2Z7B");

var $6dpFj = parcelRequire("6dpFj");

var $pW1k6 = parcelRequire("pW1k6");

var $b1zcR = parcelRequire("b1zcR");
// -- MessageFormat --------------------------------------------------------
function $6b8f88550973e494$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $6b8f88550973e494$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $6b8f88550973e494$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $l2Z7B.__assign)({}, defaultConfig));
}
function $6b8f88550973e494$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $6b8f88550973e494$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $pW1k6.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $l2Z7B.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $6b8f88550973e494$var$createFastMemoizeCache(cache.number),
            strategy: (0, $pW1k6.strategies).variadic
        }),
        getDateTimeFormat: (0, $pW1k6.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $l2Z7B.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $6b8f88550973e494$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $pW1k6.strategies).variadic
        }),
        getPluralRules: (0, $pW1k6.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $l2Z7B.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $6b8f88550973e494$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $pW1k6.strategies).variadic
        })
    };
}
var $6b8f88550973e494$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $b1zcR.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $b1zcR.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            return {
                locale: _this.resolvedLocale.toString()
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale
            });
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $6b8f88550973e494$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $6b8f88550973e494$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $6dpFj.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("6dpFj", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("4VghZ")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("4VghZ")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("4VghZ")).isDateTimeSkeleton);
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("4VghZ")).isLiteralElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("4VghZ")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("4VghZ")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("4VghZ")).isPluralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("4VghZ")).isPoundElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("4VghZ")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("4VghZ")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("4VghZ")).isTimeElement);
$parcel$export(module.exports, "TYPE", () => (parcelRequire("4VghZ")).TYPE);
$parcel$export(module.exports, "parse", () => $4867dd96a90c056b$export$98e6a39c04603d36);

var $l2Z7B = parcelRequire("l2Z7B");

var $1qhWu = parcelRequire("1qhWu");

var $5DR7r = parcelRequire("5DR7r");

var $4VghZ = parcelRequire("4VghZ");
function $4867dd96a90c056b$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $4VghZ.isSelectElement)(el) || (0, $4VghZ.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $4867dd96a90c056b$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $4VghZ.isNumberElement)(el) && (0, $4VghZ.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $4VghZ.isDateElement)(el) || (0, $4VghZ.isTimeElement)(el)) && (0, $4VghZ.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $4VghZ.isTagElement)(el)) $4867dd96a90c056b$var$pruneLocation(el.children);
    });
}
function $4867dd96a90c056b$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $l2Z7B.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $5DR7r.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $1qhWu.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $4867dd96a90c056b$var$pruneLocation(result.val);
    return result.val;
}

});
parcelRegister("1qhWu", function(module, exports) {
$parcel$export(module.exports, "ErrorKind", () => $109623254d5d054c$export$896afd8541959ee5);
var $109623254d5d054c$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($109623254d5d054c$export$896afd8541959ee5 || ($109623254d5d054c$export$896afd8541959ee5 = {}));

});

parcelRegister("5DR7r", function(module, exports) {
$parcel$export(module.exports, "Parser", () => $41b9cca01985965f$export$7acfa6ed01010e37);

var $l2Z7B = parcelRequire("l2Z7B");

var $1qhWu = parcelRequire("1qhWu");

var $4VghZ = parcelRequire("4VghZ");

var $1tlBf = parcelRequire("1tlBf");
parcelRequire("3Uiry");
var $aYwqB = parcelRequire("aYwqB");
var $4f4OJ = parcelRequire("4f4OJ");

var $h8PxH = parcelRequire("h8PxH");
var $41b9cca01985965f$var$_a;
var $41b9cca01985965f$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $1tlBf.SPACE_SEPARATOR_REGEX).source, "*"));
var $41b9cca01985965f$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $1tlBf.SPACE_SEPARATOR_REGEX).source, "*$"));
function $41b9cca01985965f$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $41b9cca01985965f$var$hasNativeStartsWith = !!String.prototype.startsWith;
var $41b9cca01985965f$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $41b9cca01985965f$var$hasNativeFromEntries = !!Object.fromEntries;
var $41b9cca01985965f$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $41b9cca01985965f$var$hasTrimStart = !!String.prototype.trimStart;
var $41b9cca01985965f$var$hasTrimEnd = !!String.prototype.trimEnd;
var $41b9cca01985965f$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $41b9cca01985965f$var$isSafeInteger = $41b9cca01985965f$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $41b9cca01985965f$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $41b9cca01985965f$var$re = $41b9cca01985965f$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $41b9cca01985965f$var$REGEX_SUPPORTS_U_AND_Y = (($41b9cca01985965f$var$_a = $41b9cca01985965f$var$re.exec('a')) === null || $41b9cca01985965f$var$_a === void 0 ? void 0 : $41b9cca01985965f$var$_a[0]) === 'a';
} catch (_) {
    $41b9cca01985965f$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $41b9cca01985965f$var$startsWith = $41b9cca01985965f$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $41b9cca01985965f$var$fromCodePoint = $41b9cca01985965f$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $41b9cca01985965f$var$fromEntries = // native
$41b9cca01985965f$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $41b9cca01985965f$var$codePointAt = $41b9cca01985965f$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $41b9cca01985965f$var$trimStart = $41b9cca01985965f$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($41b9cca01985965f$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $41b9cca01985965f$var$trimEnd = $41b9cca01985965f$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($41b9cca01985965f$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $41b9cca01985965f$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $41b9cca01985965f$var$matchIdentifierAtIndex;
if ($41b9cca01985965f$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $41b9cca01985965f$var$IDENTIFIER_PREFIX_RE_1 = $41b9cca01985965f$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $41b9cca01985965f$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $41b9cca01985965f$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $41b9cca01985965f$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$41b9cca01985965f$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $41b9cca01985965f$var$codePointAt(s, index);
        if (c === undefined || $41b9cca01985965f$var$_isWhiteSpace(c) || $41b9cca01985965f$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $41b9cca01985965f$var$fromCodePoint.apply(void 0, match);
};
var $41b9cca01985965f$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $4VghZ.TYPE).pound,
                    location: $41b9cca01985965f$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $1qhWu.ErrorKind).UNMATCHED_CLOSING_TAG, $41b9cca01985965f$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $41b9cca01985965f$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $4VghZ.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $41b9cca01985965f$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$41b9cca01985965f$var$_isAlpha(this.char())) return this.error((0, $1qhWu.ErrorKind).INVALID_TAG, $41b9cca01985965f$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $1qhWu.ErrorKind).UNMATCHED_CLOSING_TAG, $41b9cca01985965f$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $1qhWu.ErrorKind).INVALID_TAG, $41b9cca01985965f$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $4VghZ.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $41b9cca01985965f$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $1qhWu.ErrorKind).UNCLOSED_TAG, $41b9cca01985965f$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $1qhWu.ErrorKind).INVALID_TAG, $41b9cca01985965f$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $41b9cca01985965f$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $41b9cca01985965f$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $4VghZ.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$41b9cca01985965f$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $41b9cca01985965f$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $41b9cca01985965f$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $1qhWu.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $1qhWu.ErrorKind).EMPTY_ARGUMENT, $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $1qhWu.ErrorKind).MALFORMED_ARGUMENT, $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $1qhWu.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $4VghZ.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $1qhWu.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $1qhWu.ErrorKind).MALFORMED_ARGUMENT, $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $41b9cca01985965f$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $41b9cca01985965f$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $1qhWu.ErrorKind).EXPECT_ARGUMENT_TYPE, $41b9cca01985965f$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $41b9cca01985965f$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $1qhWu.ErrorKind).EXPECT_ARGUMENT_STYLE, $41b9cca01985965f$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $41b9cca01985965f$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $41b9cca01985965f$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $41b9cca01985965f$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $4VghZ.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $1qhWu.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $h8PxH.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $4VghZ.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $aYwqB.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $4VghZ.TYPE).date : (0, $4VghZ.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $4VghZ.TYPE).number : argType === 'date' ? (0, $4VghZ.TYPE).date : (0, $4VghZ.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $1qhWu.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $41b9cca01985965f$var$createLocation(typeEndPosition_1, (0, $l2Z7B.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $1qhWu.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $41b9cca01985965f$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $1qhWu.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $1qhWu.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $4VghZ.TYPE).select,
                        value: value,
                        options: $41b9cca01985965f$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $4VghZ.TYPE).plural,
                        value: value,
                        options: $41b9cca01985965f$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $1qhWu.ErrorKind).INVALID_ARGUMENT_TYPE, $41b9cca01985965f$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $1qhWu.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $1qhWu.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $41b9cca01985965f$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $4f4OJ.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $1qhWu.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $4VghZ.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $4f4OJ.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $1qhWu.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $1qhWu.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $41b9cca01985965f$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $1qhWu.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $1qhWu.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $1qhWu.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $1qhWu.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $41b9cca01985965f$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $1qhWu.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $1qhWu.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $41b9cca01985965f$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $1qhWu.ErrorKind).MISSING_OTHER_CLAUSE, $41b9cca01985965f$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $41b9cca01985965f$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$41b9cca01985965f$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $41b9cca01985965f$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($41b9cca01985965f$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $41b9cca01985965f$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $41b9cca01985965f$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $41b9cca01985965f$var$_isAlphaOrSlash(codepoint) {
    return $41b9cca01985965f$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $41b9cca01985965f$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $41b9cca01985965f$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $41b9cca01985965f$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("4VghZ", function(module, exports) {
$parcel$export(module.exports, "TYPE", () => $39591ef6f138e77f$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $39591ef6f138e77f$export$906452485466fa53);
$parcel$export(module.exports, "isLiteralElement", () => $39591ef6f138e77f$export$cfa10c5697238752);
$parcel$export(module.exports, "isArgumentElement", () => $39591ef6f138e77f$export$4f55724281bdfaf9);
$parcel$export(module.exports, "isNumberElement", () => $39591ef6f138e77f$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $39591ef6f138e77f$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $39591ef6f138e77f$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $39591ef6f138e77f$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $39591ef6f138e77f$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isPoundElement", () => $39591ef6f138e77f$export$c0ece297bdd0c082);
$parcel$export(module.exports, "isTagElement", () => $39591ef6f138e77f$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $39591ef6f138e77f$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $39591ef6f138e77f$export$7680c41f1a55f4cf);
var $39591ef6f138e77f$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($39591ef6f138e77f$export$b87f371cbc396fcf || ($39591ef6f138e77f$export$b87f371cbc396fcf = {}));
var $39591ef6f138e77f$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($39591ef6f138e77f$export$906452485466fa53 || ($39591ef6f138e77f$export$906452485466fa53 = {}));
function $39591ef6f138e77f$export$cfa10c5697238752(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.literal;
}
function $39591ef6f138e77f$export$4f55724281bdfaf9(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.argument;
}
function $39591ef6f138e77f$export$e11187b219e191e1(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.number;
}
function $39591ef6f138e77f$export$32d811605da75f40(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.date;
}
function $39591ef6f138e77f$export$34ec46f596b1702f(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.time;
}
function $39591ef6f138e77f$export$dcfe1c11d168b5a1(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.select;
}
function $39591ef6f138e77f$export$6c796d116f0a4fbc(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.plural;
}
function $39591ef6f138e77f$export$c0ece297bdd0c082(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.pound;
}
function $39591ef6f138e77f$export$5c83de34745812b(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.tag;
}
function $39591ef6f138e77f$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $39591ef6f138e77f$export$906452485466fa53.number);
}
function $39591ef6f138e77f$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $39591ef6f138e77f$export$906452485466fa53.dateTime);
}
function $39591ef6f138e77f$export$f0ac572c1121c662(value) {
    return {
        type: $39591ef6f138e77f$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $39591ef6f138e77f$export$425e864b0ba114f1(value, style) {
    return {
        type: $39591ef6f138e77f$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("1tlBf", function(module, exports) {
$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $1129411e0a357551$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $1129411e0a357551$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $1129411e0a357551$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("3Uiry", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("aYwqB")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("4f4OJ")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("4f4OJ")).parseNumberSkeletonFromString);
parcelRequire("aYwqB");
parcelRequire("4f4OJ");

});
parcelRegister("aYwqB", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => $7fd8a98a97bb80b4$export$f7b99fb377fe69fa);
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $7fd8a98a97bb80b4$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $7fd8a98a97bb80b4$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($7fd8a98a97bb80b4$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("4f4OJ", function(module, exports) {
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => $316c4cc380cc14ac$export$71cee2f16fba2480);
$parcel$export(module.exports, "parseNumberSkeleton", () => $316c4cc380cc14ac$export$47c6f8480bda3e11);

var $l2Z7B = parcelRequire("l2Z7B");

var $cULFT = parcelRequire("cULFT");
function $316c4cc380cc14ac$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $cULFT.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $316c4cc380cc14ac$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $316c4cc380cc14ac$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $316c4cc380cc14ac$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $316c4cc380cc14ac$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $316c4cc380cc14ac$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $316c4cc380cc14ac$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($316c4cc380cc14ac$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $316c4cc380cc14ac$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $316c4cc380cc14ac$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$316c4cc380cc14ac$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $316c4cc380cc14ac$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $316c4cc380cc14ac$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $316c4cc380cc14ac$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $316c4cc380cc14ac$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, all), $316c4cc380cc14ac$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, all), $316c4cc380cc14ac$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($316c4cc380cc14ac$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($316c4cc380cc14ac$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($316c4cc380cc14ac$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($316c4cc380cc14ac$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, result), $316c4cc380cc14ac$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($316c4cc380cc14ac$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, result), $316c4cc380cc14ac$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $316c4cc380cc14ac$var$parseSign(token.stem);
        if (signOpts) result = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $316c4cc380cc14ac$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("cULFT", function(module, exports) {
$parcel$export(module.exports, "WHITE_SPACE_REGEX", () => $966fb236f7c5dc5f$export$2b8db14d8bcaece7);
// @generated from regex-gen.ts
var $966fb236f7c5dc5f$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("h8PxH", function(module, exports) {
$parcel$export(module.exports, "getBestPattern", () => $c7ab2a52b535161a$export$29c5368be8904d27);

var $bRAhB = parcelRequire("bRAhB");
function $c7ab2a52b535161a$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $c7ab2a52b535161a$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $c7ab2a52b535161a$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $bRAhB.timeData)[regionTag || ''] || (0, $bRAhB.timeData)[languageTag || ''] || (0, $bRAhB.timeData)["".concat(languageTag, "-001")] || (0, $bRAhB.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("bRAhB", function(module, exports) {
$parcel$export(module.exports, "timeData", () => $8a30c9f50c999ce6$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $8a30c9f50c999ce6$export$a8c9209db4084317 = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

});




parcelRegister("pW1k6", function(module, exports) {
$parcel$export(module.exports, "default", () => $04df578bb1e82bb6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "strategies", () => $04df578bb1e82bb6$export$c5491a8691a23b9e);
//
// Main
//
function $04df578bb1e82bb6$export$2e2bcd8739ae039(fn, options) {
    var cache = options && options.cache ? options.cache : $04df578bb1e82bb6$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $04df578bb1e82bb6$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $04df578bb1e82bb6$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $04df578bb1e82bb6$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $04df578bb1e82bb6$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $04df578bb1e82bb6$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $04df578bb1e82bb6$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $04df578bb1e82bb6$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $04df578bb1e82bb6$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $04df578bb1e82bb6$var$monadic : $04df578bb1e82bb6$var$variadic;
    return $04df578bb1e82bb6$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $04df578bb1e82bb6$var$strategyVariadic(fn, options) {
    return $04df578bb1e82bb6$var$assemble(fn, this, $04df578bb1e82bb6$var$variadic, options.cache.create(), options.serializer);
}
function $04df578bb1e82bb6$var$strategyMonadic(fn, options) {
    return $04df578bb1e82bb6$var$assemble(fn, this, $04df578bb1e82bb6$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $04df578bb1e82bb6$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $04df578bb1e82bb6$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$04df578bb1e82bb6$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$04df578bb1e82bb6$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $04df578bb1e82bb6$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $04df578bb1e82bb6$var$ObjectWithoutPrototypeCache();
    }
};
var $04df578bb1e82bb6$export$c5491a8691a23b9e = {
    variadic: $04df578bb1e82bb6$var$strategyVariadic,
    monadic: $04df578bb1e82bb6$var$strategyMonadic
};

});

parcelRegister("b1zcR", function(module, exports) {
$parcel$export(module.exports, "PART_TYPE", () => $806b18fc72f08d6f$export$49694c2877b44c57);
$parcel$export(module.exports, "isFormatXMLElementFn", () => $806b18fc72f08d6f$export$df0c12a2d414a163);
$parcel$export(module.exports, "formatToParts", () => $806b18fc72f08d6f$export$275d4a3bb5f66fda);
parcelRequire("6dpFj");
var $4VghZ = parcelRequire("4VghZ");

var $jpwqX = parcelRequire("jpwqX");
var $806b18fc72f08d6f$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($806b18fc72f08d6f$export$49694c2877b44c57 || ($806b18fc72f08d6f$export$49694c2877b44c57 = {}));
function $806b18fc72f08d6f$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $806b18fc72f08d6f$export$49694c2877b44c57.literal || part.type !== $806b18fc72f08d6f$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $806b18fc72f08d6f$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $806b18fc72f08d6f$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $4VghZ.isLiteralElement)(els[0])) return [
        {
            type: $806b18fc72f08d6f$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $4VghZ.isLiteralElement)(el)) {
            result.push({
                type: $806b18fc72f08d6f$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $4VghZ.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $806b18fc72f08d6f$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $jpwqX.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $4VghZ.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $806b18fc72f08d6f$export$49694c2877b44c57.literal : $806b18fc72f08d6f$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $4VghZ.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $4VghZ.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $806b18fc72f08d6f$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4VghZ.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $4VghZ.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $806b18fc72f08d6f$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4VghZ.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $4VghZ.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $806b18fc72f08d6f$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4VghZ.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$806b18fc72f08d6f$export$df0c12a2d414a163(formatFn)) throw new (0, $jpwqX.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $806b18fc72f08d6f$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $806b18fc72f08d6f$export$49694c2877b44c57.literal : $806b18fc72f08d6f$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $4VghZ.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $jpwqX.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $806b18fc72f08d6f$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $4VghZ.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $jpwqX.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $jpwqX.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $jpwqX.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $806b18fc72f08d6f$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $806b18fc72f08d6f$var$mergeLiteral(result);
}

});
parcelRegister("jpwqX", function(module, exports) {
$parcel$export(module.exports, "ErrorCode", () => $e21982ce468ea34f$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "FormatError", () => $e21982ce468ea34f$export$7369836851cc1329);
$parcel$export(module.exports, "InvalidValueError", () => $e21982ce468ea34f$export$565c3afc07dfa382);
$parcel$export(module.exports, "InvalidValueTypeError", () => $e21982ce468ea34f$export$cbc0db47c750f7c9);
$parcel$export(module.exports, "MissingValueError", () => $e21982ce468ea34f$export$8bfc137e4d23fdf0);

var $l2Z7B = parcelRequire("l2Z7B");
var $e21982ce468ea34f$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($e21982ce468ea34f$export$d4e71bc0b80dc0fb || ($e21982ce468ea34f$export$d4e71bc0b80dc0fb = {}));
var $e21982ce468ea34f$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $l2Z7B.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $e21982ce468ea34f$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $l2Z7B.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $e21982ce468ea34f$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($e21982ce468ea34f$export$7369836851cc1329);
var $e21982ce468ea34f$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $l2Z7B.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $e21982ce468ea34f$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($e21982ce468ea34f$export$7369836851cc1329);
var $e21982ce468ea34f$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $l2Z7B.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $e21982ce468ea34f$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($e21982ce468ea34f$export$7369836851cc1329);

});



parcelRegister("lxO85", function(module, exports) {
$parcel$export(module.exports, "IntlErrorCode", () => $faf390ae03ac8755$export$557d6acb76e8a244);
$parcel$export(module.exports, "IntlError", () => $faf390ae03ac8755$export$c016d36112f6ddf8);
$parcel$export(module.exports, "UnsupportedFormatterError", () => $faf390ae03ac8755$export$549f97e137a05c90);
$parcel$export(module.exports, "InvalidConfigError", () => $faf390ae03ac8755$export$3ca04dd7fb305893);
$parcel$export(module.exports, "MissingDataError", () => $faf390ae03ac8755$export$c1eaf877d81384b6);
$parcel$export(module.exports, "IntlFormatError", () => $faf390ae03ac8755$export$e3b7eee1dbc44895);
$parcel$export(module.exports, "MessageFormatError", () => $faf390ae03ac8755$export$74a601a3d3f31621);
$parcel$export(module.exports, "MissingTranslationError", () => $faf390ae03ac8755$export$2ddcb436d0aa3688);

var $l2Z7B = parcelRequire("l2Z7B");
var $faf390ae03ac8755$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($faf390ae03ac8755$export$557d6acb76e8a244 || ($faf390ae03ac8755$export$557d6acb76e8a244 = {}));
var $faf390ae03ac8755$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $l2Z7B.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, " \n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $faf390ae03ac8755$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $l2Z7B.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $faf390ae03ac8755$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($faf390ae03ac8755$export$c016d36112f6ddf8);
var $faf390ae03ac8755$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $l2Z7B.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $faf390ae03ac8755$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($faf390ae03ac8755$export$c016d36112f6ddf8);
var $faf390ae03ac8755$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $l2Z7B.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $faf390ae03ac8755$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($faf390ae03ac8755$export$c016d36112f6ddf8);
var $faf390ae03ac8755$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $l2Z7B.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        return _super.call(this, $faf390ae03ac8755$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, " \nLocale: ").concat(locale, "\n"), exception) || this;
    }
    return IntlFormatError;
}($faf390ae03ac8755$export$c016d36112f6ddf8);
var $faf390ae03ac8755$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $l2Z7B.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, " \nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, " \n"), locale, exception) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MessageFormatError;
}($faf390ae03ac8755$export$e3b7eee1dbc44895);
var $faf390ae03ac8755$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $l2Z7B.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $faf390ae03ac8755$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? 'default message' : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($faf390ae03ac8755$export$c016d36112f6ddf8);

});


parcelRegister("4Pn6z", function(module, exports) {
$parcel$export(module.exports, "Box", () => $383dd904a5a5e5b0$export$e71c4d32a2263218);
$parcel$export(module.exports, "default", () => $383dd904a5a5e5b0$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $b4wFT = parcelRequire("b4wFT");

var $8TPdI = parcelRequire("8TPdI");

var $fkV29 = parcelRequire("fkV29");

var $7xD7o = parcelRequire("7xD7o");

var $6ZsH1 = parcelRequire("6ZsH1");

var $6QWvX = parcelRequire("6QWvX");
var $383dd904a5a5e5b0$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $383dd904a5a5e5b0$var$_excluded2 = [
    "className"
];
var $383dd904a5a5e5b0$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $383dd904a5a5e5b0$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $383dd904a5a5e5b0$var$_excluded2);
    var resolvedStyles = (0, $6ZsH1.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $383dd904a5a5e5b0$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $8TPdI.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $fkV29.isSurfaceColorToken)(backgroundColor) && (0, $6QWvX.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $7xD7o.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $7xD7o.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $7xD7o.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $7xD7o.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $7xD7o.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $7xD7o.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $7xD7o.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $74Zh5.jsx)((0, $b4wFT.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$383dd904a5a5e5b0$export$2e2bcd8739ae039 = $383dd904a5a5e5b0$export$e71c4d32a2263218;
var $383dd904a5a5e5b0$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("kqp0i", function(module, exports) {
function $ede9a19b7e4a528d$var$_extends() {
    return module.exports = $ede9a19b7e4a528d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $ede9a19b7e4a528d$var$_extends.apply(null, arguments);
}
module.exports = $ede9a19b7e4a528d$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("74Zh5", function(module, exports) {
$parcel$export(module.exports, "css", () => $527870009e653bdb$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $527870009e653bdb$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ClassNames", () => $527870009e653bdb$export$9b9c0f9d9f3552b8);
$parcel$export(module.exports, "jsx", () => $527870009e653bdb$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("rxpl9")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("rxpl9")).w);

var $rxpl9 = parcelRequire("rxpl9");

var $5FkrB = parcelRequire("5FkrB");

var $eP8dQ = parcelRequire("eP8dQ");

var $5qnXH = parcelRequire("5qnXH");

var $ckRFu = parcelRequire("ckRFu");
parcelRequire("bR2Nz");
parcelRequire("kqp0i");
parcelRequire("1QNjI");

parcelRequire("knBeW");
var $527870009e653bdb$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $rxpl9.h).call(props, 'css')) return $5FkrB.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $rxpl9.E);
    createElementArgArray[1] = (0, $rxpl9.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $5FkrB.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($527870009e653bdb$export$c8a8987d4410bf2d || ($527870009e653bdb$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $527870009e653bdb$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $rxpl9.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $ckRFu.serializeStyles)([
        styles
    ], undefined, $5FkrB.useContext((0, $rxpl9.T)));
    if (!(0, $rxpl9.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $5FkrB.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $5FkrB.useRef();
    (0, $5qnXH.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $5qnXH.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $eP8dQ.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $527870009e653bdb$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $ckRFu.serializeStyles)(args);
}
function $527870009e653bdb$export$d25ddfdf17c3ad3e() {
    var insertable = $527870009e653bdb$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $527870009e653bdb$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $527870009e653bdb$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $eP8dQ.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $527870009e653bdb$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $5qnXH.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $eP8dQ.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $rxpl9.i) && res !== undefined) rules += res;
        }
        if (!(0, $rxpl9.i)) return rules;
    });
    if (!(0, $rxpl9.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $5FkrB.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $527870009e653bdb$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $rxpl9.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $rxpl9.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $ckRFu.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $eP8dQ.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $rxpl9.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $527870009e653bdb$var$merge(cache.registered, css, $527870009e653bdb$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $5FkrB.useContext((0, $rxpl9.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $5FkrB.createElement($5FkrB.Fragment, null, /*#__PURE__*/ $5FkrB.createElement($527870009e653bdb$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("rxpl9", function(module, exports) {
$parcel$export(module.exports, "a", () => $052c6fce9badda23$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $052c6fce9badda23$export$23f2a1d2818174ef);
$parcel$export(module.exports, "w", () => $052c6fce9badda23$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $052c6fce9badda23$export$971d5caa766a69d7);
$parcel$export(module.exports, "b", () => $052c6fce9badda23$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "h", () => $052c6fce9badda23$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $052c6fce9badda23$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $052c6fce9badda23$export$a9c23c6ac3fc3eca);

var $5FkrB = parcelRequire("5FkrB");

var $bR2Nz = parcelRequire("bR2Nz");

var $d1G9Q = parcelRequire("d1G9Q");

var $1QNjI = parcelRequire("1QNjI");

var $7XQ8u = parcelRequire("7XQ8u");

var $eP8dQ = parcelRequire("eP8dQ");

var $ckRFu = parcelRequire("ckRFu");

var $5qnXH = parcelRequire("5qnXH");
var $052c6fce9badda23$export$407448d2b89b1813 = false;
var $052c6fce9badda23$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $052c6fce9badda23$var$EmotionCacheContext = /* #__PURE__ */ $5FkrB.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $bR2Nz.default)({
    key: 'css'
}) : null);
var $052c6fce9badda23$export$e7094788287c5e9b = $052c6fce9badda23$var$EmotionCacheContext.Provider;
var $052c6fce9badda23$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $5FkrB.useContext)($052c6fce9badda23$var$EmotionCacheContext);
};
var $052c6fce9badda23$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $5FkrB.useContext)($052c6fce9badda23$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$052c6fce9badda23$export$23f2a1d2818174ef) $052c6fce9badda23$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $5FkrB.useContext)($052c6fce9badda23$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $bR2Nz.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $5FkrB.createElement($052c6fce9badda23$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $052c6fce9badda23$export$971d5caa766a69d7 = /* #__PURE__ */ $5FkrB.createContext({});
var $052c6fce9badda23$export$3b14a55fb2447963 = function useTheme() {
    return $5FkrB.useContext($052c6fce9badda23$export$971d5caa766a69d7);
};
var $052c6fce9badda23$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $d1G9Q.default)({}, outerTheme, theme);
};
var $052c6fce9badda23$var$createCacheWithTheme = /* #__PURE__ */ (0, $1QNjI.default)(function(outerTheme) {
    return (0, $1QNjI.default)(function(theme) {
        return $052c6fce9badda23$var$getTheme(outerTheme, theme);
    });
});
var $052c6fce9badda23$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $5FkrB.useContext($052c6fce9badda23$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $052c6fce9badda23$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $5FkrB.createElement($052c6fce9badda23$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $052c6fce9badda23$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $5FkrB.forwardRef(function render(props, ref) {
        var theme = $5FkrB.useContext($052c6fce9badda23$export$971d5caa766a69d7);
        return /*#__PURE__*/ $5FkrB.createElement(Component, (0, $d1G9Q.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $7XQ8u.default)(WithTheme, Component);
}
var $052c6fce9badda23$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $052c6fce9badda23$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $052c6fce9badda23$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($052c6fce9badda23$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$052c6fce9badda23$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $052c6fce9badda23$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $eP8dQ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $5qnXH.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $eP8dQ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$052c6fce9badda23$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $5FkrB.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $052c6fce9badda23$var$Emotion = /* #__PURE__ */ $052c6fce9badda23$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$052c6fce9badda23$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $eP8dQ.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $ckRFu.serializeStyles)(registeredStyles, undefined, $5FkrB.useContext($052c6fce9badda23$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($052c6fce9badda23$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $052c6fce9badda23$var$typePropName && !$052c6fce9badda23$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $5FkrB.createElement($5FkrB.Fragment, null, /*#__PURE__*/ $5FkrB.createElement($052c6fce9badda23$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $5FkrB.createElement(WrappedComponent, newProps));
});
var $052c6fce9badda23$export$a9c23c6ac3fc3eca = $052c6fce9badda23$var$Emotion;

});
parcelRegister("bR2Nz", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a16d0b2f64d987f$export$2e2bcd8739ae039);

var $ftm4c = parcelRequire("ftm4c");

var $fPB28 = parcelRequire("fPB28");

var $1QNjI = parcelRequire("1QNjI");

var $7VhhO = parcelRequire("7VhhO");
var $8a16d0b2f64d987f$var$isBrowser = typeof document !== 'undefined';
var $8a16d0b2f64d987f$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fPB28.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fPB28.token)(character)) break;
        (0, $fPB28.next)();
    }
    return (0, $fPB28.slice)(begin, (0, $fPB28.position));
};
var $8a16d0b2f64d987f$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fPB28.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fPB28.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $8a16d0b2f64d987f$var$identifierWithPointTracking((0, $fPB28.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fPB28.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fPB28.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fPB28.from)(character);
    }
    while (character = (0, $fPB28.next)());
    return parsed;
};
var $8a16d0b2f64d987f$var$getRules = function getRules(value, points) {
    return (0, $fPB28.dealloc)($8a16d0b2f64d987f$var$toRules((0, $fPB28.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $8a16d0b2f64d987f$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $8a16d0b2f64d987f$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$8a16d0b2f64d987f$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $8a16d0b2f64d987f$var$fixedElements.set(element, true);
    var points = [];
    var rules = $8a16d0b2f64d987f$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $8a16d0b2f64d987f$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $8a16d0b2f64d987f$var$prefix(value, length) {
    switch((0, $fPB28.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fPB28.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fPB28.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fPB28.WEBKIT) + value + (0, $fPB28.MOZ) + value + (0, $fPB28.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fPB28.WEBKIT) + value + (0, $fPB28.MS) + value + value;
        // order
        case 6165:
            return (0, $fPB28.WEBKIT) + value + (0, $fPB28.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $fPB28.WEBKIT) + value + (0, $fPB28.replace)(value, /(\w+).+(:[^]+)/, (0, $fPB28.WEBKIT) + 'box-$1$2' + (0, $fPB28.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $fPB28.WEBKIT) + value + (0, $fPB28.MS) + 'flex-item-' + (0, $fPB28.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $fPB28.WEBKIT) + value + (0, $fPB28.MS) + 'flex-line-pack' + (0, $fPB28.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $fPB28.WEBKIT) + value + (0, $fPB28.MS) + (0, $fPB28.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $fPB28.WEBKIT) + value + (0, $fPB28.MS) + (0, $fPB28.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $fPB28.WEBKIT) + 'box-' + (0, $fPB28.replace)(value, '-grow', '') + (0, $fPB28.WEBKIT) + value + (0, $fPB28.MS) + (0, $fPB28.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $fPB28.WEBKIT) + (0, $fPB28.replace)(value, /([^-])(transform)/g, '$1' + (0, $fPB28.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $fPB28.replace)((0, $fPB28.replace)((0, $fPB28.replace)(value, /(zoom-|grab)/, (0, $fPB28.WEBKIT) + '$1'), /(image-set)/, (0, $fPB28.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fPB28.replace)(value, /(image-set\([^]*)/, (0, $fPB28.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $fPB28.replace)((0, $fPB28.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fPB28.WEBKIT) + 'box-pack:$3' + (0, $fPB28.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $fPB28.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fPB28.replace)(value, /(.+)-inline(.+)/, (0, $fPB28.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fPB28.strlen)(value) - 1 - length > 6) switch((0, $fPB28.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fPB28.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fPB28.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $fPB28.WEBKIT) + '$2-$3' + '$1' + (0, $fPB28.MOZ) + ((0, $fPB28.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fPB28.indexof)(value, 'stretch') ? $8a16d0b2f64d987f$var$prefix((0, $fPB28.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fPB28.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fPB28.charat)(value, (0, $fPB28.strlen)(value) - 3 - (~(0, $fPB28.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $fPB28.replace)(value, ':', ':' + (0, $fPB28.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fPB28.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $fPB28.WEBKIT) + ((0, $fPB28.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $fPB28.WEBKIT) + '$2$3' + '$1' + (0, $fPB28.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fPB28.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fPB28.WEBKIT) + value + (0, $fPB28.MS) + (0, $fPB28.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $fPB28.WEBKIT) + value + (0, $fPB28.MS) + (0, $fPB28.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fPB28.WEBKIT) + value + (0, $fPB28.MS) + (0, $fPB28.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $fPB28.WEBKIT) + value + (0, $fPB28.MS) + value + value;
    }
    return value;
}
var $8a16d0b2f64d987f$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fPB28.DECLARATION:
                element["return"] = $8a16d0b2f64d987f$var$prefix(element.value, element.length);
                break;
            case 0, $fPB28.KEYFRAMES:
                return (0, $fPB28.serialize)([
                    (0, $fPB28.copy)(element, {
                        value: (0, $fPB28.replace)(element.value, '@', '@' + (0, $fPB28.WEBKIT))
                    })
                ], callback);
            case 0, $fPB28.RULESET:
                if (element.length) return (0, $fPB28.combine)(element.props, function(value) {
                    switch((0, $fPB28.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $fPB28.serialize)([
                                (0, $fPB28.copy)(element, {
                                    props: [
                                        (0, $fPB28.replace)(value, /:(read-\w+)/, ':' + (0, $fPB28.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $fPB28.serialize)([
                                (0, $fPB28.copy)(element, {
                                    props: [
                                        (0, $fPB28.replace)(value, /:(plac\w+)/, ':' + (0, $fPB28.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $fPB28.copy)(element, {
                                    props: [
                                        (0, $fPB28.replace)(value, /:(plac\w+)/, ':' + (0, $fPB28.MOZ) + '$1')
                                    ]
                                }),
                                (0, $fPB28.copy)(element, {
                                    props: [
                                        (0, $fPB28.replace)(value, /:(plac\w+)/, (0, $fPB28.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $8a16d0b2f64d987f$var$getServerStylisCache = $8a16d0b2f64d987f$var$isBrowser ? undefined : (0, $1QNjI.default)(function() {
    return (0, $7VhhO.default)(function() {
        return {};
    });
});
var $8a16d0b2f64d987f$var$defaultStylisPlugins = [
    $8a16d0b2f64d987f$var$prefixer
];
var $8a16d0b2f64d987f$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($8a16d0b2f64d987f$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $8a16d0b2f64d987f$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($8a16d0b2f64d987f$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $8a16d0b2f64d987f$var$compat,
        $8a16d0b2f64d987f$var$removeLabel
    ];
    if (!$8a16d0b2f64d987f$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $fPB28.stringify),
            (0, $fPB28.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $fPB28.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $fPB28.serialize)((0, $fPB28.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $fPB28.stringify)
        ];
        var _serializer = (0, $fPB28.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $fPB28.serialize)((0, $fPB28.compile)(styles), _serializer);
        };
        var serverStylisCache = $8a16d0b2f64d987f$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $ftm4c.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("ftm4c", function(module, exports) {
$parcel$export(module.exports, "StyleSheet", () => $b43aae75ea7ee4fd$export$9d753cd7ae895cce);
var $b43aae75ea7ee4fd$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $b43aae75ea7ee4fd$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $b43aae75ea7ee4fd$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $b43aae75ea7ee4fd$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$b43aae75ea7ee4fd$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($b43aae75ea7ee4fd$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $b43aae75ea7ee4fd$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("fPB28", function(module, exports) {
$parcel$export(module.exports, "MS", () => $b868588574af2763$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $b868588574af2763$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $b868588574af2763$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $b868588574af2763$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $b868588574af2763$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $b868588574af2763$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $b868588574af2763$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $b868588574af2763$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $b868588574af2763$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $b868588574af2763$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $b868588574af2763$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $b868588574af2763$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $b868588574af2763$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $b868588574af2763$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $b868588574af2763$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $b868588574af2763$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $b868588574af2763$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $b868588574af2763$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $b868588574af2763$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $b868588574af2763$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $b868588574af2763$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $b868588574af2763$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $b868588574af2763$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $b868588574af2763$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $b868588574af2763$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $b868588574af2763$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $b868588574af2763$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $b868588574af2763$export$38bcb760f1d4871c);
var $b868588574af2763$export$71ad59f2e432cfe8 = "-ms-";
var $b868588574af2763$export$2c0f367103c8d01c = "-moz-";
var $b868588574af2763$export$39dfd62a25e0fe93 = "-webkit-";
var $b868588574af2763$export$a29989082612d0d9 = "comm";
var $b868588574af2763$export$aa3a2e812ca8570d = "rule";
var $b868588574af2763$export$527d108ccf083c2b = "decl";
var $b868588574af2763$export$d3d35020fa5b54f0 = "@page";
var $b868588574af2763$export$500415a86c544f73 = "@media";
var $b868588574af2763$export$a763edbf796b780a = "@import";
var $b868588574af2763$export$2790aeb8b4e5c826 = "@charset";
var $b868588574af2763$export$1cc683e23b84b133 = "@viewport";
var $b868588574af2763$export$9447a5efea57e862 = "@supports";
var $b868588574af2763$export$ef011b4e114b1fba = "@document";
var $b868588574af2763$export$6aad947bda0f3f46 = "@namespace";
var $b868588574af2763$export$b44a8529a35fcb60 = "@keyframes";
var $b868588574af2763$export$2c16de31893252e6 = "@font-face";
var $b868588574af2763$export$3d846dd52e150c6f = "@counter-style";
var $b868588574af2763$export$22314bfbb57653fe = "@font-feature-values";
var $b868588574af2763$export$d773506282b3cfe6 = "@layer";
var $b868588574af2763$export$2335f513bbd82c6d = Math.abs;
var $b868588574af2763$export$6788812c4e6611e6 = String.fromCharCode;
var $b868588574af2763$export$e6e34fd1f2686227 = Object.assign;
function $b868588574af2763$export$d6af199866bfb566(e, r) {
    return $b868588574af2763$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $b868588574af2763$export$a9db5e087081082d(e, 0)) << 2 ^ $b868588574af2763$export$a9db5e087081082d(e, 1)) << 2 ^ $b868588574af2763$export$a9db5e087081082d(e, 2)) << 2 ^ $b868588574af2763$export$a9db5e087081082d(e, 3) : 0;
}
function $b868588574af2763$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $b868588574af2763$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $b868588574af2763$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $b868588574af2763$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $b868588574af2763$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $b868588574af2763$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $b868588574af2763$export$36776f635604f274(e) {
    return e.length;
}
function $b868588574af2763$export$f9084667e487ed46(e) {
    return e.length;
}
function $b868588574af2763$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $b868588574af2763$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $b868588574af2763$export$53f1d5ea8de3d7c = 1;
var $b868588574af2763$export$4e0c71f277ca26b3 = 1;
var $b868588574af2763$export$f24224f1c91d8156 = 0;
var $b868588574af2763$export$5880b8b5730aff45 = 0;
var $b868588574af2763$export$c0306caf338ac095 = 0;
var $b868588574af2763$export$30a86d91af8ff6e6 = "";
function $b868588574af2763$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $b868588574af2763$export$53f1d5ea8de3d7c,
        column: $b868588574af2763$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $b868588574af2763$export$784d13d8ee351f07(e, r) {
    return $b868588574af2763$export$e6e34fd1f2686227($b868588574af2763$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $b868588574af2763$export$eba6f6f03b0a92e7() {
    return $b868588574af2763$export$c0306caf338ac095;
}
function $b868588574af2763$export$232faf9add678146() {
    $b868588574af2763$export$c0306caf338ac095 = $b868588574af2763$export$5880b8b5730aff45 > 0 ? $b868588574af2763$export$a9db5e087081082d($b868588574af2763$export$30a86d91af8ff6e6, --$b868588574af2763$export$5880b8b5730aff45) : 0;
    if ($b868588574af2763$export$4e0c71f277ca26b3--, $b868588574af2763$export$c0306caf338ac095 === 10) $b868588574af2763$export$4e0c71f277ca26b3 = 1, $b868588574af2763$export$53f1d5ea8de3d7c--;
    return $b868588574af2763$export$c0306caf338ac095;
}
function $b868588574af2763$export$48cfd1e771a65c4f() {
    $b868588574af2763$export$c0306caf338ac095 = $b868588574af2763$export$5880b8b5730aff45 < $b868588574af2763$export$f24224f1c91d8156 ? $b868588574af2763$export$a9db5e087081082d($b868588574af2763$export$30a86d91af8ff6e6, $b868588574af2763$export$5880b8b5730aff45++) : 0;
    if ($b868588574af2763$export$4e0c71f277ca26b3++, $b868588574af2763$export$c0306caf338ac095 === 10) $b868588574af2763$export$4e0c71f277ca26b3 = 1, $b868588574af2763$export$53f1d5ea8de3d7c++;
    return $b868588574af2763$export$c0306caf338ac095;
}
function $b868588574af2763$export$4d3fb11e950abb9e() {
    return $b868588574af2763$export$a9db5e087081082d($b868588574af2763$export$30a86d91af8ff6e6, $b868588574af2763$export$5880b8b5730aff45);
}
function $b868588574af2763$export$e88cb2efb12ae807() {
    return $b868588574af2763$export$5880b8b5730aff45;
}
function $b868588574af2763$export$58adb3bec8346d0f(e, r) {
    return $b868588574af2763$export$2f35ab04d2335697($b868588574af2763$export$30a86d91af8ff6e6, e, r);
}
function $b868588574af2763$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $b868588574af2763$export$2de70f21292aac9e(e) {
    return $b868588574af2763$export$53f1d5ea8de3d7c = $b868588574af2763$export$4e0c71f277ca26b3 = 1, $b868588574af2763$export$f24224f1c91d8156 = $b868588574af2763$export$36776f635604f274($b868588574af2763$export$30a86d91af8ff6e6 = e), $b868588574af2763$export$5880b8b5730aff45 = 0, [];
}
function $b868588574af2763$export$45918ac1574455b1(e) {
    return $b868588574af2763$export$30a86d91af8ff6e6 = "", e;
}
function $b868588574af2763$export$410ac95b9ec204b8(e) {
    return $b868588574af2763$export$87c2784dc9fc4ab($b868588574af2763$export$58adb3bec8346d0f($b868588574af2763$export$5880b8b5730aff45 - 1, $b868588574af2763$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $b868588574af2763$export$660b2ee2d4fb4eff(e) {
    return $b868588574af2763$export$45918ac1574455b1($b868588574af2763$export$5f8c09e3ae6f64e1($b868588574af2763$export$2de70f21292aac9e(e)));
}
function $b868588574af2763$export$7af1228ff777d175(e) {
    while($b868588574af2763$export$c0306caf338ac095 = $b868588574af2763$export$4d3fb11e950abb9e())if ($b868588574af2763$export$c0306caf338ac095 < 33) $b868588574af2763$export$48cfd1e771a65c4f();
    else break;
    return $b868588574af2763$export$9e1725a4cfeada27(e) > 2 || $b868588574af2763$export$9e1725a4cfeada27($b868588574af2763$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $b868588574af2763$export$5f8c09e3ae6f64e1(e) {
    while($b868588574af2763$export$48cfd1e771a65c4f())switch($b868588574af2763$export$9e1725a4cfeada27($b868588574af2763$export$c0306caf338ac095)){
        case 0:
            $b868588574af2763$export$10d8903dec122b9d($b868588574af2763$export$c2ab62c7bf24634($b868588574af2763$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $b868588574af2763$export$10d8903dec122b9d($b868588574af2763$export$410ac95b9ec204b8($b868588574af2763$export$c0306caf338ac095), e);
            break;
        default:
            $b868588574af2763$export$10d8903dec122b9d($b868588574af2763$export$6788812c4e6611e6($b868588574af2763$export$c0306caf338ac095), e);
    }
    return e;
}
function $b868588574af2763$export$955ba06d119e085e(e, r) {
    while(--r && $b868588574af2763$export$48cfd1e771a65c4f())if ($b868588574af2763$export$c0306caf338ac095 < 48 || $b868588574af2763$export$c0306caf338ac095 > 102 || $b868588574af2763$export$c0306caf338ac095 > 57 && $b868588574af2763$export$c0306caf338ac095 < 65 || $b868588574af2763$export$c0306caf338ac095 > 70 && $b868588574af2763$export$c0306caf338ac095 < 97) break;
    return $b868588574af2763$export$58adb3bec8346d0f(e, $b868588574af2763$export$e88cb2efb12ae807() + (r < 6 && $b868588574af2763$export$4d3fb11e950abb9e() == 32 && $b868588574af2763$export$48cfd1e771a65c4f() == 32));
}
function $b868588574af2763$export$c889f2fcc19dbf12(e) {
    while($b868588574af2763$export$48cfd1e771a65c4f())switch($b868588574af2763$export$c0306caf338ac095){
        case e:
            return $b868588574af2763$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $b868588574af2763$export$c889f2fcc19dbf12($b868588574af2763$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $b868588574af2763$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $b868588574af2763$export$48cfd1e771a65c4f();
            break;
    }
    return $b868588574af2763$export$5880b8b5730aff45;
}
function $b868588574af2763$export$4254d4e2b3745c4c(e, r) {
    while($b868588574af2763$export$48cfd1e771a65c4f())if (e + $b868588574af2763$export$c0306caf338ac095 === 57) break;
    else if (e + $b868588574af2763$export$c0306caf338ac095 === 84 && $b868588574af2763$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $b868588574af2763$export$58adb3bec8346d0f(r, $b868588574af2763$export$5880b8b5730aff45 - 1) + "*" + $b868588574af2763$export$6788812c4e6611e6(e === 47 ? e : $b868588574af2763$export$48cfd1e771a65c4f());
}
function $b868588574af2763$export$c2ab62c7bf24634(e) {
    while(!$b868588574af2763$export$9e1725a4cfeada27($b868588574af2763$export$4d3fb11e950abb9e()))$b868588574af2763$export$48cfd1e771a65c4f();
    return $b868588574af2763$export$58adb3bec8346d0f(e, $b868588574af2763$export$5880b8b5730aff45);
}
function $b868588574af2763$export$ef7acd7185315e22(e) {
    return $b868588574af2763$export$45918ac1574455b1($b868588574af2763$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $b868588574af2763$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $b868588574af2763$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $b868588574af2763$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $b868588574af2763$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($b868588574af2763$export$f8e21b1e77979a08(j += $b868588574af2763$export$77ad94ebf1c2b9ed($b868588574af2763$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $b868588574af2763$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $b868588574af2763$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $b868588574af2763$export$955ba06d119e085e($b868588574af2763$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($b868588574af2763$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $b868588574af2763$export$10d8903dec122b9d($b868588574af2763$export$4a34f930e789283c($b868588574af2763$export$4254d4e2b3745c4c($b868588574af2763$export$48cfd1e771a65c4f(), $b868588574af2763$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $b868588574af2763$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $b868588574af2763$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $b868588574af2763$export$36776f635604f274(j) - l) $b868588574af2763$export$10d8903dec122b9d(p > 32 ? $b868588574af2763$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $b868588574af2763$export$f8483753829ec8f3($b868588574af2763$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $b868588574af2763$export$10d8903dec122b9d(y = $b868588574af2763$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $b868588574af2763$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $b868588574af2763$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $b868588574af2763$export$98e6a39c04603d36(e, y, y, n && $b868588574af2763$export$10d8903dec122b9d($b868588574af2763$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $b868588574af2763$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $b868588574af2763$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $b868588574af2763$export$232faf9add678146() == 125) continue;
            }
            switch(j += $b868588574af2763$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($b868588574af2763$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($b868588574af2763$export$4d3fb11e950abb9e() === 45) j += $b868588574af2763$export$410ac95b9ec204b8($b868588574af2763$export$48cfd1e771a65c4f());
                    v = $b868588574af2763$export$4d3fb11e950abb9e(), o = l = $b868588574af2763$export$36776f635604f274(g = j += $b868588574af2763$export$c2ab62c7bf24634($b868588574af2763$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $b868588574af2763$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $b868588574af2763$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $b868588574af2763$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $b868588574af2763$export$2f35ab04d2335697(e, v + 1, v = $b868588574af2763$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $b868588574af2763$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $b868588574af2763$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $b868588574af2763$export$35059013cd4a06db(e, r, a, s === 0 ? $b868588574af2763$export$aa3a2e812ca8570d : i, f, o, l);
}
function $b868588574af2763$export$4a34f930e789283c(e, r, a) {
    return $b868588574af2763$export$35059013cd4a06db(e, r, a, $b868588574af2763$export$a29989082612d0d9, $b868588574af2763$export$6788812c4e6611e6($b868588574af2763$export$eba6f6f03b0a92e7()), $b868588574af2763$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $b868588574af2763$export$f8483753829ec8f3(e, r, a, n) {
    return $b868588574af2763$export$35059013cd4a06db(e, r, a, $b868588574af2763$export$527d108ccf083c2b, $b868588574af2763$export$2f35ab04d2335697(e, 0, n), $b868588574af2763$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $b868588574af2763$export$82e9f45cca5ba907(n, c, s) {
    switch($b868588574af2763$export$d6af199866bfb566(n, c)){
        case 5103:
            return $b868588574af2763$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $b868588574af2763$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$2c0f367103c8d01c + n + $b868588574af2763$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($b868588574af2763$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $b868588574af2763$export$39dfd62a25e0fe93 + "box-$1$2" + $b868588574af2763$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + "flex-item-" + $b868588574af2763$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$b868588574af2763$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $b868588574af2763$export$71ad59f2e432cfe8 + "grid-row-" + $b868588574af2763$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + "flex-line-pack" + $b868588574af2763$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $b868588574af2763$export$39dfd62a25e0fe93 + "box-" + $b868588574af2763$export$77ad94ebf1c2b9ed(n, "-grow", "") + $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $b868588574af2763$export$39dfd62a25e0fe93 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $b868588574af2763$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $b868588574af2763$export$77ad94ebf1c2b9ed($b868588574af2763$export$77ad94ebf1c2b9ed($b868588574af2763$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $b868588574af2763$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $b868588574af2763$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $b868588574af2763$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $b868588574af2763$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $b868588574af2763$export$77ad94ebf1c2b9ed($b868588574af2763$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $b868588574af2763$export$39dfd62a25e0fe93 + "box-pack:$3" + $b868588574af2763$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $b868588574af2763$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$b868588574af2763$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $b868588574af2763$export$71ad59f2e432cfe8 + "grid-column-align" + $b868588574af2763$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $b868588574af2763$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$b868588574af2763$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $b868588574af2763$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$b868588574af2763$export$f8e21b1e77979a08(s, "span") ? $b868588574af2763$export$4659b591c19bdf3d(s, /\d+/) : +$b868588574af2763$export$4659b591c19bdf3d(s, /\d+/) - +$b868588574af2763$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $b868588574af2763$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed($b868588574af2763$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $b868588574af2763$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $b868588574af2763$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($b868588574af2763$export$36776f635604f274(n) - 1 - c > 6) switch($b868588574af2763$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($b868588574af2763$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $b868588574af2763$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $b868588574af2763$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $b868588574af2763$export$2c0f367103c8d01c + ($b868588574af2763$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$b868588574af2763$export$f8e21b1e77979a08(n, "stretch") ? $b868588574af2763$export$82e9f45cca5ba907($b868588574af2763$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $b868588574af2763$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $b868588574af2763$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $b868588574af2763$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($b868588574af2763$export$a9db5e087081082d(n, c + 6) === 121) return $b868588574af2763$export$77ad94ebf1c2b9ed(n, ":", ":" + $b868588574af2763$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($b868588574af2763$export$a9db5e087081082d(n, $b868588574af2763$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $b868588574af2763$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $b868588574af2763$export$39dfd62a25e0fe93 + ($b868588574af2763$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $b868588574af2763$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $b868588574af2763$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $b868588574af2763$export$77ad94ebf1c2b9ed(n, ":", ":" + $b868588574af2763$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $b868588574af2763$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $b868588574af2763$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $b868588574af2763$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $b868588574af2763$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $b868588574af2763$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $b868588574af2763$export$a763edbf796b780a:
        case $b868588574af2763$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $b868588574af2763$export$a29989082612d0d9:
            return "";
        case $b868588574af2763$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $b868588574af2763$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $b868588574af2763$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $b868588574af2763$export$36776f635604f274(a = $b868588574af2763$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $b868588574af2763$export$5a7767152ae0305f(e) {
    var r = $b868588574af2763$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $b868588574af2763$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $b868588574af2763$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $b868588574af2763$export$527d108ccf083c2b:
                n.return = $b868588574af2763$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $b868588574af2763$export$b44a8529a35fcb60:
                return $b868588574af2763$export$dfdc1655ccc5b9cb([
                    $b868588574af2763$export$784d13d8ee351f07(n, {
                        value: $b868588574af2763$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $b868588574af2763$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $b868588574af2763$export$aa3a2e812ca8570d:
                if (n.length) return $b868588574af2763$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($b868588574af2763$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $b868588574af2763$export$dfdc1655ccc5b9cb([
                                $b868588574af2763$export$784d13d8ee351f07(n, {
                                    props: [
                                        $b868588574af2763$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $b868588574af2763$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $b868588574af2763$export$dfdc1655ccc5b9cb([
                                $b868588574af2763$export$784d13d8ee351f07(n, {
                                    props: [
                                        $b868588574af2763$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $b868588574af2763$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $b868588574af2763$export$784d13d8ee351f07(n, {
                                    props: [
                                        $b868588574af2763$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $b868588574af2763$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $b868588574af2763$export$784d13d8ee351f07(n, {
                                    props: [
                                        $b868588574af2763$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $b868588574af2763$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $b868588574af2763$export$76a88f7de6507443(e) {
    switch(e.type){
        case $b868588574af2763$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $b868588574af2763$export$1be1fc439b849fdf($b868588574af2763$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($b868588574af2763$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $b868588574af2763$export$2f35ab04d2335697(r, 1, $b868588574af2763$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $b868588574af2763$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $b868588574af2763$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $b868588574af2763$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("1QNjI", function(module, exports) {
$parcel$export(module.exports, "default", () => $1590e71a06f1c94c$export$2e2bcd8739ae039);
var $1590e71a06f1c94c$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("7VhhO", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c4b43fa4ca9ca56$export$2e2bcd8739ae039);
function $5c4b43fa4ca9ca56$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("d1G9Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $97bc1202558212af$export$2e2bcd8739ae039);
function $97bc1202558212af$export$2e2bcd8739ae039() {
    return $97bc1202558212af$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $97bc1202558212af$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("7XQ8u", function(module, exports) {
$parcel$export(module.exports, "default", () => $5cc67c33c01a8707$export$2e2bcd8739ae039);

var $knBeW = parcelRequire("knBeW");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $5cc67c33c01a8707$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($knBeW)))(targetComponent, sourceComponent);
};

});
parcelRegister("knBeW", function(module, exports) {
'use strict';

var $8gfMx = parcelRequire("8gfMx");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $ed62d7b2a7b04291$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $ed62d7b2a7b04291$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $ed62d7b2a7b04291$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $ed62d7b2a7b04291$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $ed62d7b2a7b04291$var$TYPE_STATICS = {};
$ed62d7b2a7b04291$var$TYPE_STATICS[$8gfMx.ForwardRef] = $ed62d7b2a7b04291$var$FORWARD_REF_STATICS;
$ed62d7b2a7b04291$var$TYPE_STATICS[$8gfMx.Memo] = $ed62d7b2a7b04291$var$MEMO_STATICS;
function $ed62d7b2a7b04291$var$getStatics(component) {
    // React v16.11 and below
    if ($8gfMx.isMemo(component)) return $ed62d7b2a7b04291$var$MEMO_STATICS;
     // React v16.12 and above
    return $ed62d7b2a7b04291$var$TYPE_STATICS[component['$$typeof']] || $ed62d7b2a7b04291$var$REACT_STATICS;
}
var $ed62d7b2a7b04291$var$defineProperty = Object.defineProperty;
var $ed62d7b2a7b04291$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $ed62d7b2a7b04291$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $ed62d7b2a7b04291$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $ed62d7b2a7b04291$var$getPrototypeOf = Object.getPrototypeOf;
var $ed62d7b2a7b04291$var$objectPrototype = Object.prototype;
function $ed62d7b2a7b04291$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($ed62d7b2a7b04291$var$objectPrototype) {
            var inheritedComponent = $ed62d7b2a7b04291$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $ed62d7b2a7b04291$var$objectPrototype) $ed62d7b2a7b04291$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $ed62d7b2a7b04291$var$getOwnPropertyNames(sourceComponent);
        if ($ed62d7b2a7b04291$var$getOwnPropertySymbols) keys = keys.concat($ed62d7b2a7b04291$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $ed62d7b2a7b04291$var$getStatics(targetComponent);
        var sourceStatics = $ed62d7b2a7b04291$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$ed62d7b2a7b04291$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $ed62d7b2a7b04291$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $ed62d7b2a7b04291$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $ed62d7b2a7b04291$var$hoistNonReactStatics;

});
parcelRegister("8gfMx", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3ZSjy"));

});



parcelRegister("eP8dQ", function(module, exports) {
$parcel$export(module.exports, "getRegisteredStyles", () => $acac34e4571973dc$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $acac34e4571973dc$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $acac34e4571973dc$export$6f077d94b33a01aa);
var $acac34e4571973dc$var$isBrowser = typeof document !== 'undefined';
function $acac34e4571973dc$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $acac34e4571973dc$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $acac34e4571973dc$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $acac34e4571973dc$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $acac34e4571973dc$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$acac34e4571973dc$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$acac34e4571973dc$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("ckRFu", function(module, exports) {
$parcel$export(module.exports, "serializeStyles", () => $8fb0fbaac7a2e807$export$6321afa313b251b5);

var $1gJfi = parcelRequire("1gJfi");

var $aLo9l = parcelRequire("aLo9l");

var $7VhhO = parcelRequire("7VhhO");
var $8fb0fbaac7a2e807$var$isDevelopment = false;
var $8fb0fbaac7a2e807$var$hyphenateRegex = /[A-Z]|^ms/g;
var $8fb0fbaac7a2e807$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $8fb0fbaac7a2e807$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $8fb0fbaac7a2e807$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $8fb0fbaac7a2e807$var$processStyleName = /* #__PURE__ */ (0, $7VhhO.default)(function(styleName) {
    return $8fb0fbaac7a2e807$var$isCustomProperty(styleName) ? styleName : styleName.replace($8fb0fbaac7a2e807$var$hyphenateRegex, '-$&').toLowerCase();
});
var $8fb0fbaac7a2e807$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($8fb0fbaac7a2e807$var$animationRegex, function(match, p1, p2) {
                $8fb0fbaac7a2e807$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $8fb0fbaac7a2e807$var$cursor
                };
                return p1;
            });
    }
    if ((0, $aLo9l.default)[key] !== 1 && !$8fb0fbaac7a2e807$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $8fb0fbaac7a2e807$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $8fb0fbaac7a2e807$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $8fb0fbaac7a2e807$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $8fb0fbaac7a2e807$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $8fb0fbaac7a2e807$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $8fb0fbaac7a2e807$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $8fb0fbaac7a2e807$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $8fb0fbaac7a2e807$var$cursor;
                var result = interpolation(mergedProps);
                $8fb0fbaac7a2e807$var$cursor = previousCursor;
                return $8fb0fbaac7a2e807$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $8fb0fbaac7a2e807$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $8fb0fbaac7a2e807$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($8fb0fbaac7a2e807$var$isProcessableValue(asString)) string += $8fb0fbaac7a2e807$var$processStyleName(key) + ":" + $8fb0fbaac7a2e807$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $8fb0fbaac7a2e807$var$isDevelopment) throw new Error($8fb0fbaac7a2e807$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($8fb0fbaac7a2e807$var$isProcessableValue(value[_i])) string += $8fb0fbaac7a2e807$var$processStyleName(key) + ":" + $8fb0fbaac7a2e807$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $8fb0fbaac7a2e807$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $8fb0fbaac7a2e807$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $8fb0fbaac7a2e807$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $8fb0fbaac7a2e807$var$cursor;
function $8fb0fbaac7a2e807$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $8fb0fbaac7a2e807$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $8fb0fbaac7a2e807$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $8fb0fbaac7a2e807$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $8fb0fbaac7a2e807$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $8fb0fbaac7a2e807$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $1gJfi.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $8fb0fbaac7a2e807$var$cursor
    };
}

});
parcelRegister("1gJfi", function(module, exports) {
$parcel$export(module.exports, "default", () => $0eca61e9ec9ac574$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $0eca61e9ec9ac574$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("aLo9l", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d6106d35293dee3$export$2e2bcd8739ae039);
var $7d6106d35293dee3$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("5qnXH", function(module, exports) {
$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $3f31f7cc4627f3ab$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $3f31f7cc4627f3ab$export$811a713a7276cb9d);

var $5FkrB = parcelRequire("5FkrB");
var $3f31f7cc4627f3ab$var$isBrowser = typeof document !== 'undefined';
var $3f31f7cc4627f3ab$var$syncFallback = function syncFallback(create) {
    return create();
};
var $3f31f7cc4627f3ab$var$useInsertionEffect = $5FkrB.useInsertionEffect ? $5FkrB.useInsertionEffect : false;
var $3f31f7cc4627f3ab$export$db21c7ffa21794e7 = !$3f31f7cc4627f3ab$var$isBrowser ? $3f31f7cc4627f3ab$var$syncFallback : $3f31f7cc4627f3ab$var$useInsertionEffect || $3f31f7cc4627f3ab$var$syncFallback;
var $3f31f7cc4627f3ab$export$811a713a7276cb9d = $3f31f7cc4627f3ab$var$useInsertionEffect || $5FkrB.useLayoutEffect;

});



parcelRegister("b4wFT", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", () => $80f969ecef0a6dd3$export$1ca2a26fecb070ae);

var $5FkrB = parcelRequire("5FkrB");
var $80f969ecef0a6dd3$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');

});

parcelRegister("8TPdI", function(module, exports) {
$parcel$export(module.exports, "backgroundColorStylesMap", () => $67ab31073ee582e2$export$e7af83bafe7f9e63);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $caG2g = parcelRequire("caG2g");

var $dborj = parcelRequire("dborj");
var $67ab31073ee582e2$export$e7af83bafe7f9e63 = (0, $dborj.getSerializedStylesMap)('backgroundColor', (0, $caG2g.backgroundColorMap));

});
parcelRegister("caG2g", function(module, exports) {
$parcel$export(module.exports, "backgroundColorMap", () => $8dc706905367b55f$export$d1d79bf68ac056bd);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::71312351a600925eaa13076fadee1c45>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::d88dceee1459b4e9e492bb497e903575>>
 */ var $8dc706905367b55f$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.code.added.highlight': "var(--ds-background-code-added-highlight, #DCFFF1)",
    'color.background.code.added.line': "var(--ds-background-code-added-line, #BAF3DB66)",
    'color.background.code.default': "var(--ds-background-code-default, #FFFFFF)",
    'color.background.code.gutter': "var(--ds-background-code-gutter, #F0F1F2)",
    'color.background.code.highlight': "var(--ds-background-code-highlight, #F0F1F2)",
    'color.background.code.removed.highlight': "var(--ds-background-code-removed-highlight, #FFECEB)",
    'color.background.code.removed.line': "var(--ds-background-code-removed-line, #FFD5D266)",
    'color.background.disabled': "var(--ds-background-disabled, #0515240F)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.subtle': "var(--ds-background-danger-subtle, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.subtle': "var(--ds-background-warning-subtle, #FBD779)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.subtle': "var(--ds-background-success-subtle, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.subtle': "var(--ds-background-discovery-subtle, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.subtle': "var(--ds-background-information-subtle, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.rovo.background.brand.bold': "var(--ds-rovo-background-brand-bold, #000000)",
    'color.rovo.background.brand.bold.hovered': "var(--ds-rovo-background-brand-bold-hovered, #1E1F21)",
    'color.rovo.background.brand.bold.pressed': "var(--ds-rovo-background-brand-bold-pressed, #292A2E)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};

});

parcelRegister("dborj", function(module, exports) {
$parcel$export(module.exports, "getSerializedStylesMap", () => $998f42a130fbeae1$export$ca0f9c2de39ffed7);

var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");
var $998f42a130fbeae1$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, tokenName) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[tokenName] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[tokenName]));
        return emotionSpacingMap;
    }, {});
};

});


parcelRegister("fkV29", function(module, exports) {
$parcel$export(module.exports, "isSurfaceColorToken", () => $b2a4f70032c022c9$export$5e65a44e5b6ecadb);

var $bNSrV = parcelRequire("bNSrV");
var $b2a4f70032c022c9$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return (0, $bNSrV.surfaceColorMap)[color] !== undefined;
};

});
parcelRegister("bNSrV", function(module, exports) {
$parcel$export(module.exports, "surfaceColorMap", () => $897e81d2d87bc94a$export$41a358c9c2356760);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed4525fa607a8b619e2905e50f8c3b50>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::d88dceee1459b4e9e492bb497e903575>>
 */ var $897e81d2d87bc94a$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};

});


parcelRegister("7xD7o", function(module, exports) {
$parcel$export(module.exports, "paddingStylesMap", () => $57d9f58cb1b2d3e5$export$e615f061ca585a6c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $jts3Q = parcelRequire("jts3Q");

var $aWY4P = parcelRequire("aWY4P");
var $57d9f58cb1b2d3e5$export$e615f061ca585a6c = (0, $jts3Q.createSpacingStylesMap)((0, $aWY4P.positiveSpaceMap));

});
parcelRegister("jts3Q", function(module, exports) {
$parcel$export(module.exports, "createSpacingStylesMap", () => $e2d67e15cd1ab1f5$export$f2bee1f59203ac70);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dborj = parcelRequire("dborj");
var $e2d67e15cd1ab1f5$var$spacingProperties = [
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'gap',
    'rowGap',
    'columnGap'
];
var $e2d67e15cd1ab1f5$export$f2bee1f59203ac70 = function createSpacingStylesMap(tokenMap) {
    return $e2d67e15cd1ab1f5$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
        styleMap[spacingProperty] = (0, $dborj.getSerializedStylesMap)(spacingProperty, tokenMap);
        return styleMap;
    }, {});
};

});

parcelRegister("aWY4P", function(module, exports) {
$parcel$export(module.exports, "positiveSpaceMap", () => $7f8dec2ce46e417e$export$958d0ae7f2977ae4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::40ae4d14447bdc898f255059f8589afd>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::535518e7add48ef24f526d0904f70060>>
 */ var $7f8dec2ce46e417e$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};

});


parcelRegister("6ZsH1", function(module, exports) {
$parcel$export(module.exports, "parseXcss", () => $516eb2651ecf48d7$export$a9c84988c8f81f2d);

var $fC8ib = parcelRequire("fC8ib");

var $3PTbW = parcelRequire("3PTbW");
function $516eb2651ecf48d7$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $516eb2651ecf48d7$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $516eb2651ecf48d7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $516eb2651ecf48d7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $516eb2651ecf48d7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $516eb2651ecf48d7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $516eb2651ecf48d7$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $516eb2651ecf48d7$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $516eb2651ecf48d7$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref = objArgs || {}, styles = _ref[0, $3PTbW.uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};

});
parcelRegister("3PTbW", function(module, exports) {
$parcel$export(module.exports, "uniqueSymbol", () => $2cb0f26ccdd4ec7a$export$43e479c916cb4ada);
var $2cb0f26ccdd4ec7a$export$43e479c916cb4ada = Symbol('UNSAFE_INTERNAL_styles');

});


parcelRegister("6QWvX", function(module, exports) {
$parcel$export(module.exports, "surfaceColorStylesMap", () => $4fd4fd23995134cc$export$ff257d957d48c421);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $9AP5g = parcelRequire("9AP5g");

var $dborj = parcelRequire("dborj");

var $bNSrV = parcelRequire("bNSrV");
var $4fd4fd23995134cc$export$ff257d957d48c421 = (0, $dborj.getSerializedStylesMap)((0, $9AP5g.CURRENT_SURFACE_CSS_VAR), (0, $bNSrV.surfaceColorMap));

});


parcelRegister("2kuK2", function(module, exports) {
$parcel$export(module.exports, "Flex", () => $1b254ba6a068f2f1$export$f51f4c4ede09e011);

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $6ZsH1 = parcelRequire("6ZsH1");

var $6Lg0d = parcelRequire("6Lg0d");
var $1b254ba6a068f2f1$var$justifyContentMap = {
    start: (0, $74Zh5.css)({
        justifyContent: 'start'
    }),
    center: (0, $74Zh5.css)({
        justifyContent: 'center'
    }),
    end: (0, $74Zh5.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $74Zh5.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $74Zh5.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $74Zh5.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $74Zh5.css)({
        justifyContent: 'stretch'
    })
};
var $1b254ba6a068f2f1$var$flexDirectionMap = {
    column: (0, $74Zh5.css)({
        flexDirection: 'column'
    }),
    row: (0, $74Zh5.css)({
        flexDirection: 'row'
    })
};
var $1b254ba6a068f2f1$var$flexWrapMap = {
    wrap: (0, $74Zh5.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $74Zh5.css)({
        flexWrap: 'nowrap'
    })
};
var $1b254ba6a068f2f1$var$alignItemsMap = {
    start: (0, $74Zh5.css)({
        alignItems: 'start'
    }),
    center: (0, $74Zh5.css)({
        alignItems: 'center'
    }),
    baseline: (0, $74Zh5.css)({
        alignItems: 'baseline'
    }),
    end: (0, $74Zh5.css)({
        alignItems: 'end'
    }),
    stretch: (0, $74Zh5.css)({
        alignItems: 'stretch'
    })
};
var $1b254ba6a068f2f1$var$baseStyles = (0, $74Zh5.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
var $1b254ba6a068f2f1$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, id = _ref.id;
    var resolvedStyles = (0, $6ZsH1.parseXcss)(xcss);
    return (0, $74Zh5.jsx)(Component, {
        id: id,
        role: role,
        className: resolvedStyles.static,
        css: [
            $1b254ba6a068f2f1$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $6Lg0d.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $6Lg0d.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $6Lg0d.spaceStylesMap).rowGap[rowGap],
            alignItems && $1b254ba6a068f2f1$var$alignItemsMap[alignItems],
            direction && $1b254ba6a068f2f1$var$flexDirectionMap[direction],
            justifyContent && $1b254ba6a068f2f1$var$justifyContentMap[justifyContent],
            wrap && $1b254ba6a068f2f1$var$flexWrapMap[wrap]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(resolvedStyles.emotion || [])),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$1b254ba6a068f2f1$export$f51f4c4ede09e011.displayName = 'Flex';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$1b254ba6a068f2f1$export$2e2bcd8739ae039 = $1b254ba6a068f2f1$export$f51f4c4ede09e011;

});
parcelRegister("6Lg0d", function(module, exports) {
$parcel$export(module.exports, "spaceStylesMap", () => $4ec38ba4046986ab$export$bf46c3f9eeafc71f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $jts3Q = parcelRequire("jts3Q");

var $aWY4P = parcelRequire("aWY4P");
var $4ec38ba4046986ab$export$bf46c3f9eeafc71f = (0, $jts3Q.createSpacingStylesMap)((0, $aWY4P.positiveSpaceMap));

});


parcelRegister("gDiFE", function(module, exports) {
$parcel$export(module.exports, "xcss", () => $c1bec583fa49072f$export$f6c783d06584602c);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $74Zh5 = parcelRequire("74Zh5");

var $cYEIA = parcelRequire("cYEIA");

var $3PTbW = parcelRequire("3PTbW");

var $3ZMUU = parcelRequire("3ZMUU");
var $c1bec583fa49072f$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU.env) === 'object' && false;
};
var $c1bec583fa49072f$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $c1bec583fa49072f$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $c1bec583fa49072f$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($c1bec583fa49072f$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && $c1bec583fa49072f$var$safeSelectors.test(key)) {
            styleObj[key] = $c1bec583fa49072f$var$_transformStyles(value);
            return;
        }
        if ($c1bec583fa49072f$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($c1bec583fa49072f$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in (0, $cYEIA.tokensMap))) return;
        var tokenValue = (0, $cYEIA.tokensMap)[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $c1bec583fa49072f$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $c1bec583fa49072f$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $3PTbW.uniqueSymbol), (0, $74Zh5.css)(transformedStyles));
};
function $c1bec583fa49072f$export$f6c783d06584602c(style) {
    return $c1bec583fa49072f$var$baseXcss(style);
}

});
parcelRegister("cYEIA", function(module, exports) {
$parcel$export(module.exports, "tokensMap", () => $972aac682c1ca9c0$export$9a199fbafee0014e);

var $6EyqR = parcelRequire("6EyqR");

var $caG2g = parcelRequire("caG2g");

var $jPLJI = parcelRequire("jPLJI");

var $1Y8x8 = parcelRequire("1Y8x8");

var $4FBpX = parcelRequire("4FBpX");

var $9kviN = parcelRequire("9kviN");

var $48dE5 = parcelRequire("48dE5");

var $ktlcX = parcelRequire("ktlcX");

var $2myjr = parcelRequire("2myjr");

var $1JUg4 = parcelRequire("1JUg4");

var $dLDO7 = parcelRequire("dLDO7");

var $aWY4P = parcelRequire("aWY4P");

var $jEJfN = parcelRequire("jEJfN");

var $6jMrz = parcelRequire("6jMrz");
var $972aac682c1ca9c0$export$9a199fbafee0014e = {
    backgroundColor: (0, $caG2g.backgroundColorMap),
    blockSize: (0, $9kviN.dimensionMap),
    borderBlockColor: (0, $jPLJI.borderColorMap),
    borderBlockEndColor: (0, $jPLJI.borderColorMap),
    borderBlockEndWidth: (0, $4FBpX.borderWidthMap),
    borderBlockStartColor: (0, $jPLJI.borderColorMap),
    borderBlockStartWidth: (0, $4FBpX.borderWidthMap),
    borderBlockWidth: (0, $4FBpX.borderWidthMap),
    borderBottomColor: (0, $jPLJI.borderColorMap),
    borderBottomLeftRadius: (0, $1Y8x8.borderRadiusMap),
    borderBottomRightRadius: (0, $1Y8x8.borderRadiusMap),
    borderBottomWidth: (0, $4FBpX.borderWidthMap),
    borderColor: (0, $jPLJI.borderColorMap),
    borderEndEndRadius: (0, $1Y8x8.borderRadiusMap),
    borderEndStartRadius: (0, $1Y8x8.borderRadiusMap),
    borderInlineColor: (0, $jPLJI.borderColorMap),
    borderInlineEndColor: (0, $jPLJI.borderColorMap),
    borderInlineEndWidth: (0, $4FBpX.borderWidthMap),
    borderInlineStartColor: (0, $jPLJI.borderColorMap),
    borderInlineStartWidth: (0, $4FBpX.borderWidthMap),
    borderInlineWidth: (0, $4FBpX.borderWidthMap),
    borderLeftColor: (0, $jPLJI.borderColorMap),
    borderLeftWidth: (0, $4FBpX.borderWidthMap),
    borderRadius: (0, $1Y8x8.borderRadiusMap),
    borderRightColor: (0, $jPLJI.borderColorMap),
    borderRightWidth: (0, $4FBpX.borderWidthMap),
    borderStartEndRadius: (0, $1Y8x8.borderRadiusMap),
    borderStartStartRadius: (0, $1Y8x8.borderRadiusMap),
    borderTopColor: (0, $jPLJI.borderColorMap),
    borderTopLeftRadius: (0, $1Y8x8.borderRadiusMap),
    borderTopRightRadius: (0, $1Y8x8.borderRadiusMap),
    borderTopWidth: (0, $4FBpX.borderWidthMap),
    borderWidth: (0, $4FBpX.borderWidthMap),
    bottom: (0, $6EyqR.allSpaceMap),
    boxShadow: (0, $jEJfN.shadowMap),
    color: (0, $6jMrz.textColorMap),
    columnGap: (0, $aWY4P.positiveSpaceMap),
    font: (0, $48dE5.fontMap),
    fontFamily: (0, $ktlcX.fontFamilyMap),
    fontWeight: (0, $2myjr.fontWeightMap),
    gap: (0, $aWY4P.positiveSpaceMap),
    height: (0, $9kviN.dimensionMap),
    inlineSize: (0, $9kviN.dimensionMap),
    inset: (0, $6EyqR.allSpaceMap),
    insetBlock: (0, $6EyqR.allSpaceMap),
    insetBlockEnd: (0, $6EyqR.allSpaceMap),
    insetBlockStart: (0, $6EyqR.allSpaceMap),
    insetInline: (0, $6EyqR.allSpaceMap),
    insetInlineEnd: (0, $6EyqR.allSpaceMap),
    insetInlineStart: (0, $6EyqR.allSpaceMap),
    left: (0, $6EyqR.allSpaceMap),
    margin: (0, $6EyqR.allSpaceMap),
    marginBlock: (0, $6EyqR.allSpaceMap),
    marginBlockEnd: (0, $6EyqR.allSpaceMap),
    marginBlockStart: (0, $6EyqR.allSpaceMap),
    marginBottom: (0, $6EyqR.allSpaceMap),
    marginInline: (0, $6EyqR.allSpaceMap),
    marginInlineEnd: (0, $6EyqR.allSpaceMap),
    marginInlineStart: (0, $6EyqR.allSpaceMap),
    marginLeft: (0, $6EyqR.allSpaceMap),
    marginRight: (0, $6EyqR.allSpaceMap),
    marginTop: (0, $6EyqR.allSpaceMap),
    maxBlockSize: (0, $9kviN.dimensionMap),
    maxHeight: (0, $9kviN.dimensionMap),
    maxInlineSize: (0, $9kviN.dimensionMap),
    maxWidth: (0, $9kviN.dimensionMap),
    minBlockSize: (0, $9kviN.dimensionMap),
    minHeight: (0, $9kviN.dimensionMap),
    minInlineSize: (0, $9kviN.dimensionMap),
    minWidth: (0, $9kviN.dimensionMap),
    opacity: (0, $dLDO7.opacityMap),
    outlineColor: (0, $jPLJI.borderColorMap),
    outlineOffset: (0, $6EyqR.allSpaceMap),
    outlineWidth: (0, $4FBpX.borderWidthMap),
    padding: (0, $aWY4P.positiveSpaceMap),
    paddingBlock: (0, $aWY4P.positiveSpaceMap),
    paddingBlockEnd: (0, $aWY4P.positiveSpaceMap),
    paddingBlockStart: (0, $aWY4P.positiveSpaceMap),
    paddingBottom: (0, $aWY4P.positiveSpaceMap),
    paddingInline: (0, $aWY4P.positiveSpaceMap),
    paddingInlineEnd: (0, $aWY4P.positiveSpaceMap),
    paddingInlineStart: (0, $aWY4P.positiveSpaceMap),
    paddingLeft: (0, $aWY4P.positiveSpaceMap),
    paddingRight: (0, $aWY4P.positiveSpaceMap),
    paddingTop: (0, $aWY4P.positiveSpaceMap),
    right: (0, $6EyqR.allSpaceMap),
    rowGap: (0, $aWY4P.positiveSpaceMap),
    top: (0, $6EyqR.allSpaceMap),
    width: (0, $9kviN.dimensionMap),
    zIndex: (0, $1JUg4.layerMap)
};

});
parcelRegister("6EyqR", function(module, exports) {
$parcel$export(module.exports, "allSpaceMap", () => $4d8130069ac5fc0a$export$632685d741f3dbbf);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4193602efb8ae1ec92457e1d4ae51cd6>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::535518e7add48ef24f526d0904f70060>>
 */ var $4d8130069ac5fc0a$export$632685d741f3dbbf = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)",
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};

});

parcelRegister("jPLJI", function(module, exports) {
$parcel$export(module.exports, "borderColorMap", () => $e707cf33336581e8$export$1531ad5bb3fbedac);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d6795e6c2d3e9cfa47c92243c08ae4b7>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::d88dceee1459b4e9e492bb497e903575>>
 */ var $e707cf33336581e8$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.lime.subtle': "var(--ds-border-accent-lime-subtle, #B3DF72)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.red.subtle': "var(--ds-border-accent-red-subtle, #FD9891)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.orange.subtle': "var(--ds-border-accent-orange-subtle, #FBC828)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.yellow.subtle': "var(--ds-border-accent-yellow-subtle, #EED12B)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.green.subtle': "var(--ds-border-accent-green-subtle, #7EE2B8)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.teal.subtle': "var(--ds-border-accent-teal-subtle, #9DD9EE)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.blue.subtle': "var(--ds-border-accent-blue-subtle, #8FB8F6)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.purple.subtle': "var(--ds-border-accent-purple-subtle, #D8A0F7)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.magenta.subtle': "var(--ds-border-accent-magenta-subtle, #F797D2)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.accent.gray.subtle': "var(--ds-border-accent-gray-subtle, #B7B9BE)",
    'color.border.code': "var(--ds-border-code, #0B120E24)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.input.search': "var(--ds-border-input-search, #0B120E24)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.danger.subtle': "var(--ds-border-danger-subtle, #FD9891)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.warning.subtle': "var(--ds-border-warning-subtle, #FBC828)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.success.subtle': "var(--ds-border-success-subtle, #B3DF72)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.discovery.subtle': "var(--ds-border-discovery-subtle, #D8A0F7)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.information.subtle': "var(--ds-border-information-subtle, #8FB8F6)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};

});

parcelRegister("1Y8x8", function(module, exports) {
$parcel$export(module.exports, "borderRadiusMap", () => $16f203950a8620fa$export$3c0a6c3e64bb180d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::75649f8b704acb878c98303f7bc82aee>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::8817f4073995e5dc9c2bb766316632d6>>
 */ var $16f203950a8620fa$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};

});

parcelRegister("4FBpX", function(module, exports) {
$parcel$export(module.exports, "borderWidthMap", () => $3668042176e82b6a$export$e1b83c5210c471b8);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee12747fee6f7445e430f52ee1f7b86>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::8817f4073995e5dc9c2bb766316632d6>>
 */ var $3668042176e82b6a$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};

});

parcelRegister("9kviN", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", () => $6cae434102897d67$export$6ccdbebca2ee545f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9183c00a6ce1b53a46530f6f0a7883ea>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 */ var $6cae434102897d67$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};

});

parcelRegister("48dE5", function(module, exports) {
$parcel$export(module.exports, "fontMap", () => $30227e8124f7c739$export$6ffa317d5e70375);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e931a3b15648861e85392c4c0721fbb>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ var $30227e8124f7c739$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});

parcelRegister("ktlcX", function(module, exports) {
$parcel$export(module.exports, "fontFamilyMap", () => $ee76f787c5411183$export$3c7e9587132614b4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d46fa1415e9618559c3725b5d922ea57>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ var $ee76f787c5411183$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});

parcelRegister("2myjr", function(module, exports) {
$parcel$export(module.exports, "fontWeightMap", () => $1b8840a190717aae$export$303e322c6b1ed114);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45dd1de71dbd395ec11ae36c4fe5f287>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ var $1b8840a190717aae$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};

});

parcelRegister("1JUg4", function(module, exports) {
$parcel$export(module.exports, "layerMap", () => $1445a21ee4715a13$export$b5f31a7e431d2eab);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::05a468f2941874c14b7f39734d626517>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ var $1445a21ee4715a13$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};

});

parcelRegister("dLDO7", function(module, exports) {
$parcel$export(module.exports, "opacityMap", () => $a05e8b0df7ef2eeb$export$daf94a976c798b4f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::545d97aba13f974a270ba2cd2ff822f3>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::d88dceee1459b4e9e492bb497e903575>>
 */ var $a05e8b0df7ef2eeb$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};

});

parcelRegister("jEJfN", function(module, exports) {
$parcel$export(module.exports, "shadowMap", () => $e4f4db3638948fed$export$7aff6e7ba39bb774);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2dff63237da1147ef0df80b09b97f21>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::d88dceee1459b4e9e492bb497e903575>>
 */ var $e4f4db3638948fed$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};

});

parcelRegister("6jMrz", function(module, exports) {
$parcel$export(module.exports, "textColorMap", () => $499a1855aed0db86$export$8473307aa00d6ea1);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e58d26d0330bf7f203d8df2ca83bc15>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::d88dceee1459b4e9e492bb497e903575>>
 */ var $499a1855aed0db86$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.code.accent.1': "var(--ds-text-code-accent-1, #943D73)",
    'color.text.code.accent.2': "var(--ds-text-code-accent-2, #1558BC)",
    'color.text.code.comments': "var(--ds-text-code-comments, #505258)",
    'color.text.code.default': "var(--ds-text-code-default, #505258)",
    'color.text.code.functions': "var(--ds-text-code-functions, #216E4E)",
    'color.text.code.gutter': "var(--ds-text-code-gutter, #6B6E76)",
    'color.text.code.keywords': "var(--ds-text-code-keywords, #AE2E24)",
    'color.text.code.numbers': "var(--ds-text-code-numbers, #7F5F01)",
    'color.text.code.operators': "var(--ds-text-code-operators, #292A2E)",
    'color.text.code.strings': "var(--ds-text-code-strings, #4C6B1F)",
    'color.text.code.tags': "var(--ds-text-code-tags, #9E4C00)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};

});



parcelRegister("9ztDu", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f7e5f007cf95a87$export$2e2bcd8739ae039);
/* spinner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $eqVaP = parcelRequire("eqVaP");

var $fKJ1H = parcelRequire("fKJ1H");
/**
 * Returns the appropriate circle stroke color.
 */ function $6f7e5f007cf95a87$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
var $6f7e5f007cf95a87$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $6f7e5f007cf95a87$var$loadIn = null;
var $6f7e5f007cf95a87$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o511hrf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $6f7e5f007cf95a87$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $6f7e5f007cf95a87$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $fKJ1H.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $6f7e5f007cf95a87$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $eqVaP.default));
    $6f7e5f007cf95a87$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $970q7.default)([
            $6f7e5f007cf95a87$var$styles.wrapperStyles,
            $6f7e5f007cf95a87$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $970q7.default)([
            $6f7e5f007cf95a87$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $970q7.default)([
            $6f7e5f007cf95a87$var$styles.circleStyles
        ])
    })));
}));
var $6f7e5f007cf95a87$export$2e2bcd8739ae039 = $6f7e5f007cf95a87$var$Spinner;

});
parcelRegister("970q7", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a2517f1a964148b$export$2e2bcd8739ae039);
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $6a2517f1a964148b$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $6a2517f1a964148b$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $6a2517f1a964148b$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("eqVaP", function(module, exports) {
$parcel$export(module.exports, "default", () => $a81fd7e45a8c2ef5$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
var $a81fd7e45a8c2ef5$var$interactionContext = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $a81fd7e45a8c2ef5$export$2e2bcd8739ae039 = $a81fd7e45a8c2ef5$var$interactionContext;

});

parcelRegister("fKJ1H", function(module, exports) {
$parcel$export(module.exports, "presetSizes", () => $b77e143823b2f7d8$export$4e9f1640bbe7a1a8);
var $b77e143823b2f7d8$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("3hvsM", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4bJqP"));

});
parcelRegister("4bJqP", function(module, exports) {
$parcel$export(module.exports, "unstable_now", () => $30cb6e4b156fa063$export$c4744153514ff05d, (v) => $30cb6e4b156fa063$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $30cb6e4b156fa063$export$3e506c1ccc9cc1a7, (v) => $30cb6e4b156fa063$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $30cb6e4b156fa063$export$e26fe2ed2fa76875, (v) => $30cb6e4b156fa063$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $30cb6e4b156fa063$export$502329bbf4b505b1, (v) => $30cb6e4b156fa063$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $30cb6e4b156fa063$export$6e3807111c4874c4, (v) => $30cb6e4b156fa063$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $30cb6e4b156fa063$export$c27134553091fb3a, (v) => $30cb6e4b156fa063$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $30cb6e4b156fa063$export$33ee1acdc04fd2a2, (v) => $30cb6e4b156fa063$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $30cb6e4b156fa063$export$b00a404bbd5edef2, (v) => $30cb6e4b156fa063$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $30cb6e4b156fa063$export$8352ce38b91d0c62, (v) => $30cb6e4b156fa063$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $30cb6e4b156fa063$export$d66a1c1c77bd778b, (v) => $30cb6e4b156fa063$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $30cb6e4b156fa063$export$d3dfb8e4810cb555, (v) => $30cb6e4b156fa063$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $30cb6e4b156fa063$export$839f9183b0465a69, (v) => $30cb6e4b156fa063$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $30cb6e4b156fa063$export$72fdf0e06517287b, (v) => $30cb6e4b156fa063$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $30cb6e4b156fa063$export$4b844e58a3e414b4, (v) => $30cb6e4b156fa063$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $30cb6e4b156fa063$export$816d2913ae6b83b1, (v) => $30cb6e4b156fa063$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $30cb6e4b156fa063$export$61bcfe829111a1d0, (v) => $30cb6e4b156fa063$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $30cb6e4b156fa063$export$7ee8c9beb337bc3f, (v) => $30cb6e4b156fa063$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $30cb6e4b156fa063$export$b5836b71941fa3ed, (v) => $30cb6e4b156fa063$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $30cb6e4b156fa063$export$cf845f2c119da08a, (v) => $30cb6e4b156fa063$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $30cb6e4b156fa063$export$c4744153514ff05d;
var $30cb6e4b156fa063$export$3e506c1ccc9cc1a7;
var $30cb6e4b156fa063$export$e26fe2ed2fa76875;
var $30cb6e4b156fa063$export$502329bbf4b505b1;
var $30cb6e4b156fa063$export$6e3807111c4874c4;
var $30cb6e4b156fa063$export$c27134553091fb3a;
var $30cb6e4b156fa063$export$33ee1acdc04fd2a2;
var $30cb6e4b156fa063$export$b00a404bbd5edef2;
var $30cb6e4b156fa063$export$8352ce38b91d0c62;
var $30cb6e4b156fa063$export$d66a1c1c77bd778b;
var $30cb6e4b156fa063$export$d3dfb8e4810cb555;
var $30cb6e4b156fa063$export$839f9183b0465a69;
var $30cb6e4b156fa063$export$72fdf0e06517287b;
var $30cb6e4b156fa063$export$4b844e58a3e414b4;
var $30cb6e4b156fa063$export$816d2913ae6b83b1;
var $30cb6e4b156fa063$export$61bcfe829111a1d0;
var $30cb6e4b156fa063$export$7ee8c9beb337bc3f;
var $30cb6e4b156fa063$export$b5836b71941fa3ed;
var $30cb6e4b156fa063$export$cf845f2c119da08a;
'use strict';
function $30cb6e4b156fa063$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $30cb6e4b156fa063$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $30cb6e4b156fa063$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $30cb6e4b156fa063$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $30cb6e4b156fa063$var$g(C, c)) n < e && 0 > $30cb6e4b156fa063$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $30cb6e4b156fa063$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $30cb6e4b156fa063$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $30cb6e4b156fa063$var$l = performance;
    $30cb6e4b156fa063$export$c4744153514ff05d = function() {
        return $30cb6e4b156fa063$var$l.now();
    };
} else {
    var $30cb6e4b156fa063$var$p = Date, $30cb6e4b156fa063$var$q = $30cb6e4b156fa063$var$p.now();
    $30cb6e4b156fa063$export$c4744153514ff05d = function() {
        return $30cb6e4b156fa063$var$p.now() - $30cb6e4b156fa063$var$q;
    };
}
var $30cb6e4b156fa063$var$r = [], $30cb6e4b156fa063$var$t = [], $30cb6e4b156fa063$var$u = 1, $30cb6e4b156fa063$var$v = null, $30cb6e4b156fa063$var$y = 3, $30cb6e4b156fa063$var$z = !1, $30cb6e4b156fa063$var$A = !1, $30cb6e4b156fa063$var$B = !1, $30cb6e4b156fa063$var$D = "function" === typeof setTimeout ? setTimeout : null, $30cb6e4b156fa063$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $30cb6e4b156fa063$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $30cb6e4b156fa063$var$G(a) {
    for(var b = $30cb6e4b156fa063$var$h($30cb6e4b156fa063$var$t); null !== b;){
        if (null === b.callback) $30cb6e4b156fa063$var$k($30cb6e4b156fa063$var$t);
        else if (b.startTime <= a) $30cb6e4b156fa063$var$k($30cb6e4b156fa063$var$t), b.sortIndex = b.expirationTime, $30cb6e4b156fa063$var$f($30cb6e4b156fa063$var$r, b);
        else break;
        b = $30cb6e4b156fa063$var$h($30cb6e4b156fa063$var$t);
    }
}
function $30cb6e4b156fa063$var$H(a) {
    $30cb6e4b156fa063$var$B = !1;
    $30cb6e4b156fa063$var$G(a);
    if (!$30cb6e4b156fa063$var$A) {
        if (null !== $30cb6e4b156fa063$var$h($30cb6e4b156fa063$var$r)) $30cb6e4b156fa063$var$A = !0, $30cb6e4b156fa063$var$I($30cb6e4b156fa063$var$J);
        else {
            var b = $30cb6e4b156fa063$var$h($30cb6e4b156fa063$var$t);
            null !== b && $30cb6e4b156fa063$var$K($30cb6e4b156fa063$var$H, b.startTime - a);
        }
    }
}
function $30cb6e4b156fa063$var$J(a, b) {
    $30cb6e4b156fa063$var$A = !1;
    $30cb6e4b156fa063$var$B && ($30cb6e4b156fa063$var$B = !1, $30cb6e4b156fa063$var$E($30cb6e4b156fa063$var$L), $30cb6e4b156fa063$var$L = -1);
    $30cb6e4b156fa063$var$z = !0;
    var c = $30cb6e4b156fa063$var$y;
    try {
        $30cb6e4b156fa063$var$G(b);
        for($30cb6e4b156fa063$var$v = $30cb6e4b156fa063$var$h($30cb6e4b156fa063$var$r); null !== $30cb6e4b156fa063$var$v && (!($30cb6e4b156fa063$var$v.expirationTime > b) || a && !$30cb6e4b156fa063$var$M());){
            var d = $30cb6e4b156fa063$var$v.callback;
            if ("function" === typeof d) {
                $30cb6e4b156fa063$var$v.callback = null;
                $30cb6e4b156fa063$var$y = $30cb6e4b156fa063$var$v.priorityLevel;
                var e = d($30cb6e4b156fa063$var$v.expirationTime <= b);
                b = $30cb6e4b156fa063$export$c4744153514ff05d();
                "function" === typeof e ? $30cb6e4b156fa063$var$v.callback = e : $30cb6e4b156fa063$var$v === $30cb6e4b156fa063$var$h($30cb6e4b156fa063$var$r) && $30cb6e4b156fa063$var$k($30cb6e4b156fa063$var$r);
                $30cb6e4b156fa063$var$G(b);
            } else $30cb6e4b156fa063$var$k($30cb6e4b156fa063$var$r);
            $30cb6e4b156fa063$var$v = $30cb6e4b156fa063$var$h($30cb6e4b156fa063$var$r);
        }
        if (null !== $30cb6e4b156fa063$var$v) var w = !0;
        else {
            var m = $30cb6e4b156fa063$var$h($30cb6e4b156fa063$var$t);
            null !== m && $30cb6e4b156fa063$var$K($30cb6e4b156fa063$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $30cb6e4b156fa063$var$v = null, $30cb6e4b156fa063$var$y = c, $30cb6e4b156fa063$var$z = !1;
    }
}
var $30cb6e4b156fa063$var$N = !1, $30cb6e4b156fa063$var$O = null, $30cb6e4b156fa063$var$L = -1, $30cb6e4b156fa063$var$P = 5, $30cb6e4b156fa063$var$Q = -1;
function $30cb6e4b156fa063$var$M() {
    return $30cb6e4b156fa063$export$c4744153514ff05d() - $30cb6e4b156fa063$var$Q < $30cb6e4b156fa063$var$P ? !1 : !0;
}
function $30cb6e4b156fa063$var$R() {
    if (null !== $30cb6e4b156fa063$var$O) {
        var a = $30cb6e4b156fa063$export$c4744153514ff05d();
        $30cb6e4b156fa063$var$Q = a;
        var b = !0;
        try {
            b = $30cb6e4b156fa063$var$O(!0, a);
        } finally{
            b ? $30cb6e4b156fa063$var$S() : ($30cb6e4b156fa063$var$N = !1, $30cb6e4b156fa063$var$O = null);
        }
    } else $30cb6e4b156fa063$var$N = !1;
}
var $30cb6e4b156fa063$var$S;
if ("function" === typeof $30cb6e4b156fa063$var$F) $30cb6e4b156fa063$var$S = function() {
    $30cb6e4b156fa063$var$F($30cb6e4b156fa063$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $30cb6e4b156fa063$var$T = new MessageChannel, $30cb6e4b156fa063$var$U = $30cb6e4b156fa063$var$T.port2;
    $30cb6e4b156fa063$var$T.port1.onmessage = $30cb6e4b156fa063$var$R;
    $30cb6e4b156fa063$var$S = function() {
        $30cb6e4b156fa063$var$U.postMessage(null);
    };
} else $30cb6e4b156fa063$var$S = function() {
    $30cb6e4b156fa063$var$D($30cb6e4b156fa063$var$R, 0);
};
function $30cb6e4b156fa063$var$I(a) {
    $30cb6e4b156fa063$var$O = a;
    $30cb6e4b156fa063$var$N || ($30cb6e4b156fa063$var$N = !0, $30cb6e4b156fa063$var$S());
}
function $30cb6e4b156fa063$var$K(a, b) {
    $30cb6e4b156fa063$var$L = $30cb6e4b156fa063$var$D(function() {
        a($30cb6e4b156fa063$export$c4744153514ff05d());
    }, b);
}
$30cb6e4b156fa063$export$3e506c1ccc9cc1a7 = 5;
$30cb6e4b156fa063$export$e26fe2ed2fa76875 = 1;
$30cb6e4b156fa063$export$502329bbf4b505b1 = 4;
$30cb6e4b156fa063$export$6e3807111c4874c4 = 3;
$30cb6e4b156fa063$export$c27134553091fb3a = null;
$30cb6e4b156fa063$export$33ee1acdc04fd2a2 = 2;
$30cb6e4b156fa063$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$30cb6e4b156fa063$export$8352ce38b91d0c62 = function() {
    $30cb6e4b156fa063$var$A || $30cb6e4b156fa063$var$z || ($30cb6e4b156fa063$var$A = !0, $30cb6e4b156fa063$var$I($30cb6e4b156fa063$var$J));
};
$30cb6e4b156fa063$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $30cb6e4b156fa063$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$30cb6e4b156fa063$export$d3dfb8e4810cb555 = function() {
    return $30cb6e4b156fa063$var$y;
};
$30cb6e4b156fa063$export$839f9183b0465a69 = function() {
    return $30cb6e4b156fa063$var$h($30cb6e4b156fa063$var$r);
};
$30cb6e4b156fa063$export$72fdf0e06517287b = function(a) {
    switch($30cb6e4b156fa063$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $30cb6e4b156fa063$var$y;
    }
    var c = $30cb6e4b156fa063$var$y;
    $30cb6e4b156fa063$var$y = b;
    try {
        return a();
    } finally{
        $30cb6e4b156fa063$var$y = c;
    }
};
$30cb6e4b156fa063$export$4b844e58a3e414b4 = function() {};
$30cb6e4b156fa063$export$816d2913ae6b83b1 = function() {};
$30cb6e4b156fa063$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $30cb6e4b156fa063$var$y;
    $30cb6e4b156fa063$var$y = a;
    try {
        return b();
    } finally{
        $30cb6e4b156fa063$var$y = c;
    }
};
$30cb6e4b156fa063$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $30cb6e4b156fa063$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $30cb6e4b156fa063$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $30cb6e4b156fa063$var$f($30cb6e4b156fa063$var$t, a), null === $30cb6e4b156fa063$var$h($30cb6e4b156fa063$var$r) && a === $30cb6e4b156fa063$var$h($30cb6e4b156fa063$var$t) && ($30cb6e4b156fa063$var$B ? ($30cb6e4b156fa063$var$E($30cb6e4b156fa063$var$L), $30cb6e4b156fa063$var$L = -1) : $30cb6e4b156fa063$var$B = !0, $30cb6e4b156fa063$var$K($30cb6e4b156fa063$var$H, c - d))) : (a.sortIndex = e, $30cb6e4b156fa063$var$f($30cb6e4b156fa063$var$r, a), $30cb6e4b156fa063$var$A || $30cb6e4b156fa063$var$z || ($30cb6e4b156fa063$var$A = !0, $30cb6e4b156fa063$var$I($30cb6e4b156fa063$var$J)));
    return a;
};
$30cb6e4b156fa063$export$b5836b71941fa3ed = $30cb6e4b156fa063$var$M;
$30cb6e4b156fa063$export$cf845f2c119da08a = function(a) {
    var b = $30cb6e4b156fa063$var$y;
    return function() {
        var c = $30cb6e4b156fa063$var$y;
        $30cb6e4b156fa063$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $30cb6e4b156fa063$var$y = c;
        }
    };
};

});


parcelRegister("gNUZr", function(module, exports) {
$parcel$export(module.exports, "createHook", () => $c3bd6dfdb3d51ec8$export$e7f733c8fc2b8a24);
$parcel$export(module.exports, "createActionsHook", () => $c3bd6dfdb3d51ec8$export$7c643e1d6648e418);
$parcel$export(module.exports, "createStateHook", () => $c3bd6dfdb3d51ec8$export$6e4e5611de132e85);

var $5FkrB = parcelRequire("5FkrB");

var $h209R = parcelRequire("h209R");

var $h0ORH = parcelRequire("h0ORH");

var $czK0u = parcelRequire("czK0u");
const $c3bd6dfdb3d51ec8$var$EMPTY_SELECTOR = ()=>undefined;
const $c3bd6dfdb3d51ec8$var$DEFAULT_SELECTOR = (state)=>state;
function $c3bd6dfdb3d51ec8$export$e7f733c8fc2b8a24(Store, _temp) {
    let { selector: selector } = _temp === void 0 ? {} : _temp;
    return function useSweetState(propsArg) {
        const { retrieveStore: retrieveStore } = (0, $5FkrB.useContext)((0, $h0ORH.Context));
        const { storeState: storeState, actions: actions } = retrieveStore(Store);
        const hasPropsArg = propsArg !== undefined;
        const propsArgRef = (0, $5FkrB.useRef)(propsArg);
        propsArgRef.current = propsArg;
        const stateSelector = (0, $5FkrB.useMemo)(()=>selector ? (0, $czK0u.getSelectorInstance)(selector, storeState, hasPropsArg) : selector === null ? $c3bd6dfdb3d51ec8$var$EMPTY_SELECTOR : $c3bd6dfdb3d51ec8$var$DEFAULT_SELECTOR, [
            hasPropsArg,
            storeState
        ]);
        const forceUpdate = (0, $5FkrB.useState)({})[1];
        const getSnapshot = (0, $5FkrB.useCallback)(()=>{
            // parent scope has changed and notify was explicitly triggered by the container
            // we need to force the hook to re-render to listen new storeState
            if (retrieveStore(Store).storeState !== storeState) forceUpdate({});
            const state = storeState.getState();
            return stateSelector(state, propsArgRef.current);
        }, [
            retrieveStore,
            storeState,
            stateSelector,
            forceUpdate
        ]);
        const currentState = (0, $h209R.useSyncExternalStore)(storeState.subscribe, getSnapshot, getSnapshot);
        return [
            currentState,
            actions
        ];
    };
}
function $c3bd6dfdb3d51ec8$export$7c643e1d6648e418(Store) {
    const useHook = $c3bd6dfdb3d51ec8$export$e7f733c8fc2b8a24(Store, {
        selector: null
    });
    return function useSweetStateActions() {
        return useHook()[1];
    };
}
function $c3bd6dfdb3d51ec8$export$6e4e5611de132e85(Store, _temp2) {
    let { selector: selector } = _temp2 === void 0 ? {} : _temp2;
    const useHook = $c3bd6dfdb3d51ec8$export$e7f733c8fc2b8a24(Store, {
        selector: selector
    });
    return function useSweetStateState(propsArg) {
        return useHook(propsArg)[0];
    };
}

});
parcelRegister("h209R", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cZxCB"));

});
parcelRegister("cZxCB", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStore", () => $97554319fd766d9f$export$306c0aa65ff9ec16, (v) => $97554319fd766d9f$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $97554319fd766d9f$export$306c0aa65ff9ec16;
"use strict";

var $5FkrB = parcelRequire("5FkrB");
function $97554319fd766d9f$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $97554319fd766d9f$var$objectIs = "function" === typeof Object.is ? Object.is : $97554319fd766d9f$var$is, $97554319fd766d9f$var$useState = $5FkrB.useState, $97554319fd766d9f$var$useEffect = $5FkrB.useEffect, $97554319fd766d9f$var$useLayoutEffect = $5FkrB.useLayoutEffect, $97554319fd766d9f$var$useDebugValue = $5FkrB.useDebugValue;
function $97554319fd766d9f$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $97554319fd766d9f$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $97554319fd766d9f$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $97554319fd766d9f$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $97554319fd766d9f$var$useEffect(function() {
        $97554319fd766d9f$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $97554319fd766d9f$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $97554319fd766d9f$var$useDebugValue(value);
    return value;
}
function $97554319fd766d9f$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$97554319fd766d9f$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $97554319fd766d9f$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $97554319fd766d9f$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $97554319fd766d9f$var$useSyncExternalStore$1 : $97554319fd766d9f$var$useSyncExternalStore$2;
$97554319fd766d9f$export$306c0aa65ff9ec16 = void 0 !== $5FkrB.useSyncExternalStore ? $5FkrB.useSyncExternalStore : $97554319fd766d9f$var$shim;

});


parcelRegister("h0ORH", function(module, exports) {
$parcel$export(module.exports, "Context", () => $c629e488311fc925$export$841858b892ce1f4c);

var $5FkrB = parcelRequire("5FkrB");

var $8i0MQ = parcelRequire("8i0MQ");
const $c629e488311fc925$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext({
    globalRegistry: (0, $8i0MQ.defaultRegistry),
    retrieveStore: (Store)=>(0, $8i0MQ.defaultRegistry).getStore(Store)
}, ()=>0);

});
parcelRegister("8i0MQ", function(module, exports) {
$parcel$export(module.exports, "StoreRegistry", () => $60909d64c4d3805d$export$acb47f32da33501e);
$parcel$export(module.exports, "defaultRegistry", () => $60909d64c4d3805d$export$9d726ae4880b1060);

var $3anWS = parcelRequire("3anWS");

var $7qpgv = parcelRequire("7qpgv");

var $5wOUy = parcelRequire("5wOUy");
const $60909d64c4d3805d$export$e4d628ba0054221b = '__global__';
class $60909d64c4d3805d$export$acb47f32da33501e {
    constructor(defaultScope){
        var _this = this;
        if (defaultScope === void 0) defaultScope = $60909d64c4d3805d$export$e4d628ba0054221b;
        this.stores = new Map();
        this.initStore = (key, Store, config)=>{
            const { initialState: initialState, actions: actions } = Store;
            if (Store.containedBy && !config.contained(Store)) {
                const err = new Error(`Store ${Store.key} should be contained by a container but it is used globally. ` + `While it might still work, it will likely cause unexpected behaviours.`);
                if ((0, $3anWS.default).scheduling()) Promise.reject(err);
                else throw err;
            }
            const storeState = (0, $5wOUy.default)(key, initialState);
            let boundActions;
            const store = {
                storeState: storeState,
                // these are used only when container-less, so we generate them on-demand
                get actions () {
                    if (!boundActions) boundActions = (0, $7qpgv.bindActions)(actions, storeState, config);
                    return boundActions;
                }
            };
            this.stores.set(key, store);
            return store;
        };
        this.hasStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.has(key);
        };
        this.getStore = function(Store, scopeId, config) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            if (config === void 0) config = {
                props: ()=>({}),
                contained: ()=>false
            };
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.get(key) || config && _this.initStore(key, Store, config);
        };
        this.deleteStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            _this.stores.delete(key);
        };
        this.generateKey = (Store, scopeId)=>`${Store.key}@${scopeId}`;
        this.defaultScope = defaultScope;
    }
}
const $60909d64c4d3805d$export$9d726ae4880b1060 = new $60909d64c4d3805d$export$acb47f32da33501e();

});
parcelRegister("3anWS", function(module, exports) {
$parcel$export(module.exports, "default", () => $24e4e1fa0485bf7c$export$2e2bcd8739ae039);
const $24e4e1fa0485bf7c$var$supports = {
    scheduling () {
        return typeof window !== 'undefined' && typeof MessageChannel === 'function';
    }
};
var $24e4e1fa0485bf7c$export$2e2bcd8739ae039 = $24e4e1fa0485bf7c$var$supports;

});

parcelRegister("7qpgv", function(module, exports) {
$parcel$export(module.exports, "bindActions", () => $567e8f4619a691de$export$5ee1d46cd0883a22);

var $8IUIa = parcelRequire("8IUIa");
const $567e8f4619a691de$var$namedMutator = (storeState, actionName)=>function() {
        storeState.mutator.actionName = actionName;
        return storeState.mutator(...arguments);
    };
const $567e8f4619a691de$var$warnings = new WeakMap();
const $567e8f4619a691de$export$5f944353e69b9bf3 = (storeState, actionFn, actionKey, config, actions)=>{
    const callThunk = (instance, thunkFn, actionName)=>thunkFn({
            setState: (0, $8IUIa.default).devtools ? $567e8f4619a691de$var$namedMutator(instance.storeState, actionName) : instance.storeState.mutator,
            getState: instance.storeState.getState,
            get actions () {
                if (!$567e8f4619a691de$var$warnings.has(actionFn)) $567e8f4619a691de$var$warnings.set(actionFn, console.warn(`react-sweet-state 'actions' property has been deprecated and will be removed in the next mayor. ` + `Please check action '${actionName}' of Store '${instance.storeState.key}' and use 'dispatch' instead`));
                return actions;
            },
            dispatch: (tFn)=>callThunk(instance, tFn, `${actionName}.dispatch`)
        }, config.props());
    return function() {
        return callThunk({
            storeState: storeState,
            actions: actions
        }, actionFn(...arguments), actionKey);
    };
};
const $567e8f4619a691de$export$5ee1d46cd0883a22 = function bindActions(actions, storeState, config, boundActions) {
    if (boundActions === void 0) boundActions = null;
    return Object.keys(actions).reduce((acc, k)=>{
        acc[k] = $567e8f4619a691de$export$5f944353e69b9bf3(storeState, actions[k], k, config, boundActions || acc);
        return acc;
    }, {});
};

});
parcelRegister("8IUIa", function(module, exports) {
$parcel$export(module.exports, "default", () => $659e6c773637eb0b$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
const $659e6c773637eb0b$var$defaultMutator = (prevState, partialState)=>{
    // Merge the partial state and the previous state.
    return Object.assign({}, prevState, partialState);
};
const $659e6c773637eb0b$var$defaults = {
    batchUpdates: 'useSyncExternalStore' in (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))),
    devtools: false,
    middlewares: new Set(),
    mutator: $659e6c773637eb0b$var$defaultMutator
};
var $659e6c773637eb0b$export$2e2bcd8739ae039 = $659e6c773637eb0b$var$defaults;

});


parcelRegister("5wOUy", function(module, exports) {
$parcel$export(module.exports, "default", () => $40676ed4f7792fba$export$2e2bcd8739ae039);

var $7Vo5b = parcelRequire("7Vo5b");

var $7lZpM = parcelRequire("7lZpM");

var $8IUIa = parcelRequire("8IUIa");

var $6dx62 = parcelRequire("6dx62");
function $40676ed4f7792fba$var$createStoreState(key, initialState) {
    let listeners = new Set();
    let currentState = initialState;
    const storeState = {
        key: key,
        getState () {
            return currentState;
        },
        setState (nextState) {
            currentState = nextState; // Instead of notifying all handlers immediately, we wait next tick
            // so multiple actions affecting the same store gets combined
            (0, $6dx62.default)(storeState.notify);
        },
        resetState () {
            storeState.setState(initialState);
        },
        notify () {
            for (const listener of listeners)listener(storeState.getState());
        },
        subscribe (listener) {
            listeners.add(listener);
            return function unsubscribe() {
                listeners.delete(listener);
            };
        },
        listeners () {
            return listeners;
        }
    };
    storeState.mutator = (0, $7Vo5b.default)(storeState, (0, $8IUIa.default).middlewares);
    return storeState;
}
var $40676ed4f7792fba$export$2e2bcd8739ae039 = (0, $7lZpM.default)($40676ed4f7792fba$var$createStoreState);

});
parcelRegister("7Vo5b", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c50899a0dea3342$export$2e2bcd8739ae039);

var $8IUIa = parcelRequire("8IUIa");

var $fFj9N = parcelRequire("fFj9N");
const $5c50899a0dea3342$var$applyMiddleware = (storeState, middlewares)=>Array.from(middlewares).concat((0, $fFj9N.default)).reduceRight((next, mw)=>mw(storeState)(next), (0, $8IUIa.default).mutator);
var $5c50899a0dea3342$export$2e2bcd8739ae039 = $5c50899a0dea3342$var$applyMiddleware;

});
parcelRegister("fFj9N", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6798b84ef80633c$export$2e2bcd8739ae039);

var $6Qh0T = parcelRequire("6Qh0T");
const $b6798b84ef80633c$var$updateMiddleware = (storeState)=>(next)=>(arg)=>{
            let output;
            const state = storeState.getState();
            const nextState = next(state, arg, (out)=>{
                output = out;
            });
            if (!(0, $6Qh0T.default)(nextState, state)) storeState.setState(nextState);
            return output;
        };
var $b6798b84ef80633c$export$2e2bcd8739ae039 = $b6798b84ef80633c$var$updateMiddleware;

});
parcelRegister("6Qh0T", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fb4cbecfc4ff1e8$export$2e2bcd8739ae039);
// Mostly copied from fbjs/packages/fbjs/src/core/shallowEqual.js
// enhanced with keys cache as might get called multiple times with same args
const $4fb4cbecfc4ff1e8$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $4fb4cbecfc4ff1e8$var$CACHE = new WeakMap();
function $4fb4cbecfc4ff1e8$export$2e2bcd8739ae039(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (Array.isArray(objA) && Array.isArray(objB)) {
        // do array comparison
        if (objA.length !== objB.length) return false;
        for(let i = 0; i < objA.length; i++){
            if (objA[i] !== objB[i]) return false;
        }
        return true;
    } else {
        // Handle Date, RegExp, String, Number, ... and complex objects
        const strA = '' + objA;
        const strB = '' + objB;
        if (strA !== strB || strA[0] === '[' && strA !== '[object Object]') return false;
         // do object comparison
        let keysA;
        if ($4fb4cbecfc4ff1e8$var$CACHE.has(objA)) keysA = $4fb4cbecfc4ff1e8$var$CACHE.get(objA);
        else {
            keysA = Object.keys(objA);
            $4fb4cbecfc4ff1e8$var$CACHE.set(objA, keysA);
        }
        let keysB;
        if ($4fb4cbecfc4ff1e8$var$CACHE.has(objB)) keysB = $4fb4cbecfc4ff1e8$var$CACHE.get(objB);
        else {
            keysB = Object.keys(objB);
            $4fb4cbecfc4ff1e8$var$CACHE.set(objB, keysB);
        }
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(let i = 0; i < keysA.length; i++){
            if (!$4fb4cbecfc4ff1e8$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
        }
        return true;
    }
}

});



parcelRegister("7lZpM", function(module, exports) {
$parcel$export(module.exports, "default", () => $55aa2244d18072e9$export$2e2bcd8739ae039);

var $8IUIa = parcelRequire("8IUIa");
const $55aa2244d18072e9$var$connectDevTools = (storeState, config)=>{
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(Object.assign({
        name: `Store ${storeState.key}`,
        serialize: true,
        trace: true
    }, config));
    devTools.init(storeState.getState());
    devTools.subscribe((message)=>{
        if (message.type === 'DISPATCH') switch(message.payload.type){
            case 'RESET':
                storeState.resetState();
                devTools.init(storeState.getState());
                return;
            case 'COMMIT':
                devTools.init(storeState.getState());
                return;
            case 'ROLLBACK':
                storeState.setState(JSON.parse(message.state));
                devTools.init(storeState.getState());
                return;
            case 'JUMP_TO_STATE':
            case 'JUMP_TO_ACTION':
                storeState.setState(JSON.parse(message.state));
                return;
        }
        else if (message.type === 'ACTION') {
            let action = JSON.parse(message.payload);
            storeState.setState(action.payload);
        }
    });
    return devTools;
};
const $55aa2244d18072e9$var$withDevtools = (createStoreState)=>function() {
        const storeState = createStoreState(...arguments);
        if ((0, $8IUIa.default).devtools && window && window.__REDUX_DEVTOOLS_EXTENSION__) {
            const origMutator = storeState.mutator;
            let devTools;
            const devtoolMutator = (arg)=>{
                const result = origMutator(arg);
                try {
                    if (!devTools) {
                        const config = typeof (0, $8IUIa.default).devtools === 'function' ? (0, $8IUIa.default).devtools(storeState) : {};
                        devTools = $55aa2244d18072e9$var$connectDevTools(storeState, config);
                    }
                    devTools.send({
                        type: storeState.mutator.actionName,
                        payload: arg
                    }, storeState.getState(), {}, storeState.key);
                } catch (err) {
                /* ignore devtools errors */ }
                return result;
            };
            storeState.mutator = devtoolMutator;
        }
        return storeState;
    };
var $55aa2244d18072e9$export$2e2bcd8739ae039 = $55aa2244d18072e9$var$withDevtools;

});

parcelRegister("6dx62", function(module, exports) {
$parcel$export(module.exports, "default", () => $486da13a078d111a$export$2e2bcd8739ae039);

var $8IUIa = parcelRequire("8IUIa");

var $6lPP6 = parcelRequire("6lPP6");

var $3anWS = parcelRequire("3anWS");
const $486da13a078d111a$var$QUEUE = [];
let $486da13a078d111a$var$scheduled;
function $486da13a078d111a$export$2e2bcd8739ae039(fn) {
    // if we are in node/tests or feature disabled, make updates sync batched
    if (!(0, $8IUIa.default).batchUpdates || !(0, $3anWS.default).scheduling()) return (0, $6lPP6.batch)(()=>fn()); // Add to queue if not already there
    // so we avoid multiple notifications to same store listeners
    if (!$486da13a078d111a$var$QUEUE.includes(fn)) $486da13a078d111a$var$QUEUE.push(fn); // if something already started schedule, skip
    if ($486da13a078d111a$var$scheduled) return;
    $486da13a078d111a$var$scheduled = (0, $6lPP6.batch)(()=>{
        let queueFn;
        while(queueFn = $486da13a078d111a$var$QUEUE.shift())queueFn();
        $486da13a078d111a$var$scheduled = null;
    });
}

});
parcelRegister("6lPP6", function(module, exports) {
$parcel$export(module.exports, "batch", () => $49fce73d954fc894$export$712ea50be43a7858);
/* eslint-disable import/no-unresolved */ 
var $aLeHs = parcelRequire("aLeHs");

var $3hvsM = parcelRequire("3hvsM");

var $8IUIa = parcelRequire("8IUIa");

var $3anWS = parcelRequire("3anWS");
let $49fce73d954fc894$var$isInsideBatchedSchedule = false;
function $49fce73d954fc894$export$712ea50be43a7858(fn) {
    // if we are in node/tests or nested schedule
    if (!(0, $8IUIa.default).batchUpdates || !(0, $3anWS.default).scheduling() || $49fce73d954fc894$var$isInsideBatchedSchedule) return (0, $aLeHs.unstable_batchedUpdates)(fn);
    $49fce73d954fc894$var$isInsideBatchedSchedule = true; // Use ImmediatePriority as it has -1ms timeout
    // https://github.com/facebook/react/blob/main/packages/scheduler/src/forks/Scheduler.js#L65
    return (0, $3hvsM.unstable_scheduleCallback)((0, $3hvsM.unstable_ImmediatePriority), function scheduleBatchedUpdates() {
        (0, $aLeHs.unstable_batchedUpdates)(fn);
        $49fce73d954fc894$var$isInsideBatchedSchedule = false;
    });
}

});





parcelRegister("czK0u", function(module, exports) {
$parcel$export(module.exports, "createSelector", () => $927c70ef7a7597a6$export$595d22ed68ca2841);
$parcel$export(module.exports, "getSelectorInstance", () => $927c70ef7a7597a6$export$38d24f3c60944dd5);

var $bvyk1 = parcelRequire("bvyk1");
function $927c70ef7a7597a6$export$595d22ed68ca2841() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    const resultFunc = funcs.pop();
    const dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    const memoizedResultFunc = (0, $bvyk1.default)(function() {
        return resultFunc.apply(null, arguments);
    }); // this memoisation is optimised for 2 arguments (state, props)
    const selector = (0, $bvyk1.default)(function() {
        // calculate all dependencies results
        const params = [];
        for(let i = 0; i < dependencies.length; i++)params.push(dependencies[i].apply(null, arguments));
         // then call the final func with all them as arguments
        return memoizedResultFunc.apply(null, params);
    }, true); // expose so we can create per scope selectors
    // API compatible with reselect@^4
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    return selector;
}
function $927c70ef7a7597a6$export$d2c200d79fc82f8c(selector) {
    const isReselector = typeof selector.resultFunc === 'function' && Array.isArray(selector.dependencies);
    const dependencies = isReselector ? selector.dependencies : [
        (s)=>s,
        (_, p)=>p
    ];
    const resultFunc = isReselector ? selector.resultFunc : selector;
    return $927c70ef7a7597a6$export$595d22ed68ca2841(dependencies, resultFunc);
}
const $927c70ef7a7597a6$var$cache = new WeakMap();
function $927c70ef7a7597a6$export$38d24f3c60944dd5(selector, storeState, hasProps) {
    if (!hasProps) {
        if (!$927c70ef7a7597a6$var$cache.has(storeState)) $927c70ef7a7597a6$var$cache.set(storeState, new WeakMap());
        const scopeSelectors = $927c70ef7a7597a6$var$cache.get(storeState);
        if (!scopeSelectors.has(selector)) scopeSelectors.set(selector, $927c70ef7a7597a6$export$d2c200d79fc82f8c(selector));
        return scopeSelectors.get(selector);
    }
    return $927c70ef7a7597a6$export$d2c200d79fc82f8c(selector);
}

});
parcelRegister("bvyk1", function(module, exports) {
$parcel$export(module.exports, "default", () => $860d3699eb69e62e$export$2e2bcd8739ae039);

var $6Qh0T = parcelRequire("6Qh0T");
function $860d3699eb69e62e$var$exactEqual(objA, objB) {
    return objA === objB;
}
function $860d3699eb69e62e$var$areArgumentsEqual(propsMode, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false; // If propsMode and 2 arguments, means it is an input selector
    // and we check for shallow equality on 2nd one to optimise props
    if (propsMode && prev.length === 2) return prev[0] === next[0] && (0, $6Qh0T.default)(prev[1], next[1]);
    for(let i = 0; i < prev.length; i++){
        if (!$860d3699eb69e62e$var$exactEqual(prev[i], next[i])) return false;
    }
    return true;
}
function $860d3699eb69e62e$export$2e2bcd8739ae039(resultFn, propsMode) {
    if (propsMode === void 0) propsMode = false;
    let lastArgs = [];
    let lastResult;
    let calledOnce = false;
    const result = function result() {
        if (calledOnce && $860d3699eb69e62e$var$areArgumentsEqual(propsMode, arguments, lastArgs)) return lastResult;
        const nextResult = resultFn.apply(this, arguments);
        if (!propsMode && (0, $6Qh0T.default)(nextResult, lastResult)) return lastResult;
        lastResult = nextResult;
        calledOnce = true;
        lastArgs = arguments;
        return lastResult;
    };
    return result;
}

});



parcelRegister("dWq0h", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $a264dce57acd4232$export$26ae5ca175b4ec5a);

var $5FkrB = parcelRequire("5FkrB");

var $8vJ0V = parcelRequire("8vJ0V");

var $h0ORH = parcelRequire("h0ORH");

var $7qpgv = parcelRequire("7qpgv");
var $8i0MQ = parcelRequire("8i0MQ");

var $6Qh0T = parcelRequire("6Qh0T");
const $a264dce57acd4232$var$_excluded = [
    "children"
], $a264dce57acd4232$var$_excluded2 = [
    "scope",
    "isGlobal"
];
function $a264dce57acd4232$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $a264dce57acd4232$var$noop = ()=>()=>{};
function $a264dce57acd4232$export$26ae5ca175b4ec5a(StoreOrOptions, _temp) {
    if (StoreOrOptions === void 0) StoreOrOptions = {};
    let { onInit: _onInit = $a264dce57acd4232$var$noop, onUpdate: onUpdate = $a264dce57acd4232$var$noop, onCleanup: onCleanup = $a264dce57acd4232$var$noop, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    if ('key' in StoreOrOptions) {
        const Store = StoreOrOptions;
        const dn = displayName || `Container(${Store.key.split('__')[0]})`;
        return $a264dce57acd4232$var$createFunctionContainer({
            displayName: dn,
            // compat fields
            override: {
                Store: Store,
                handlers: Object.assign({}, _onInit !== $a264dce57acd4232$var$noop && {
                    onInit: ()=>_onInit()
                }, onCleanup !== $a264dce57acd4232$var$noop && {
                    onDestroy: ()=>onCleanup()
                }, onUpdate !== $a264dce57acd4232$var$noop && {
                    onContainerUpdate: ()=>onUpdate()
                })
            }
        });
    }
    return $a264dce57acd4232$var$createFunctionContainer(StoreOrOptions);
}
function $a264dce57acd4232$var$useRegistry(scope, isGlobal, _ref) {
    let { globalRegistry: globalRegistry } = _ref;
    return (0, $5FkrB.useMemo)(()=>{
        const isLocal = !scope && !isGlobal;
        return isLocal ? new (0, $8i0MQ.StoreRegistry)('__local__') : globalRegistry;
    }, [
        scope,
        isGlobal,
        globalRegistry
    ]);
}
function $a264dce57acd4232$var$useContainedStore(scope, registry, propsRef, check, override) {
    // Store contained scopes in a map, but throwing it away on scope change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const containedStores = (0, $5FkrB.useMemo)(()=>new Map(), [
        scope
    ]);
    const getContainedStore = (0, $5FkrB.useCallback)((Store)=>{
        let containedStore = containedStores.get(Store); // first time it gets called we add store to contained map bound
        // so we can provide props to actions (only triggered by children)
        if (!containedStore) {
            const isExisting = registry.hasStore(Store, scope);
            const config = {
                props: ()=>propsRef.current.sub,
                contained: check
            };
            const { storeState: storeState } = registry.getStore(Store, scope, config);
            const actions = (0, $7qpgv.bindActions)(Store.actions, storeState, config);
            const handlers = (0, $7qpgv.bindActions)(Object.assign({}, Store.handlers, override == null ? void 0 : override.handlers), storeState, config, actions);
            containedStore = {
                storeState: storeState,
                actions: actions,
                handlers: handlers,
                unsubscribe: undefined
            };
            containedStores.set(Store, containedStore); // Signal store is contained and ready now, so by the time
            // consumers subscribe we already have updated the store (if needed).
            // Also if override maintain legacy behaviour, triggered on every mount
            if (!isExisting || override) handlers.onInit == null || handlers.onInit();
        }
        return containedStore;
    }, [
        containedStores,
        scope,
        registry,
        propsRef,
        check,
        override
    ]);
    return [
        containedStores,
        getContainedStore
    ];
}
function $a264dce57acd4232$var$useApi(check, getContainedStore, _ref2) {
    let { globalRegistry: globalRegistry, retrieveStore: retrieveStore } = _ref2;
    const retrieveRef = (0, $5FkrB.useRef)();
    retrieveRef.current = (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store); // This api is "frozen", as changing it will trigger re-render across all consumers
    // so we link retrieveStore dynamically and manually call notify() on scope change
    return (0, $5FkrB.useMemo)(()=>({
            globalRegistry: globalRegistry,
            retrieveStore: (s)=>retrieveRef.current(s)
        }), [
        globalRegistry
    ]);
}
function $a264dce57acd4232$var$createFunctionContainer(_temp2) {
    let { displayName: displayName, override: override } = _temp2 === void 0 ? {} : _temp2;
    const check = (store)=>override ? store === override.Store : store.containedBy === FunctionContainer;
    function FunctionContainer(props) {
        const { children: children } = props, restProps = $a264dce57acd4232$var$_objectWithoutPropertiesLoose(props, $a264dce57acd4232$var$_excluded);
        const { scope: scope, isGlobal: isGlobal } = restProps, subProps = $a264dce57acd4232$var$_objectWithoutPropertiesLoose(restProps, $a264dce57acd4232$var$_excluded2);
        const ctx = (0, $5FkrB.useContext)((0, $h0ORH.Context));
        const registry = $a264dce57acd4232$var$useRegistry(scope, isGlobal, ctx); // Store props in a ref to avoid re-binding actions when they change and re-rendering all
        // consumers unnecessarily. The update is handled by an effect on the component instead
        const propsRef = (0, $5FkrB.useRef)({
            prev: null,
            next: restProps,
            sub: subProps
        });
        propsRef.current = {
            prev: propsRef.current.next,
            next: restProps,
            sub: subProps // TODO remove on next major
        };
        const [containedStores, getContainedStore] = $a264dce57acd4232$var$useContainedStore(scope, registry, propsRef, check, override); // Use a stable object as is passed as value to context Provider
        const api = $a264dce57acd4232$var$useApi(check, getContainedStore, ctx); // This listens for custom props change, and so we trigger container update actions
        // before the re-render gets to consumers (hence why side effect on render).
        // We do not use React hooks because num of restProps might change and react will throws
        if (!(0, $6Qh0T.default)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach((_ref3)=>{
            let { handlers: handlers } = _ref3;
            handlers.onContainerUpdate == null || handlers.onContainerUpdate(propsRef.current.next, propsRef.current.prev);
        });
         // Every time we add/remove a contained store, we ensure we are subscribed to the updates
        // as an effect to properly handle strict mode
        (0, $5FkrB.useEffect)(()=>{
            containedStores.forEach((containedStore)=>{
                if (!containedStore.unsubscribe) {
                    const unsub = containedStore.storeState.subscribe(()=>containedStore.handlers.onUpdate == null ? void 0 : containedStore.handlers.onUpdate());
                    containedStore.unsubscribe = ()=>{
                        unsub();
                        containedStore.unsubscribe = undefined;
                    };
                }
            });
        }, [
            containedStores,
            containedStores.size
        ]); // We support renderding "bootstrap" containers without children with override API
        // so in this case we call getCS to initialize the store globally asap
        if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
         // This listens for scope change or component unmount, to notify all consumers
        // so all work is done on cleanup
        (0, $5FkrB.useEffect)(()=>{
            return ()=>{
                containedStores.forEach((_ref4, Store)=>{
                    let { storeState: storeState, handlers: handlers, unsubscribe: unsubscribe } = _ref4;
                    // Detatch container from subscription
                    unsubscribe == null || unsubscribe(); // Trigger a forced update on all subscribers as we opted out from context
                    // Some might have already re-rendered naturally, but we "force update" all anyway.
                    // This is sub-optimal as if there are other containers with the same
                    // old scope id we will re-render those too, but still better than context
                    storeState.notify(); // Given unsubscription is handled by useSyncExternalStore, we have no control on when
                    // React decides to do it. So we schedule on next tick to run last
                    Promise.resolve().then(()=>{
                        var _registry$getStore;
                        if (!storeState.listeners().size && // ensure registry has not already created a new store with same scope
                        storeState === ((_registry$getStore = registry.getStore(Store, scope, null)) == null ? void 0 : _registry$getStore.storeState)) {
                            handlers.onDestroy == null || handlers.onDestroy(); // We only delete scoped stores, as global shall persist and local are auto-deleted
                            if (!isGlobal) registry.deleteStore(Store, scope);
                        }
                    });
                }); // no need to reset containedStores as the map is already bound to scope
            };
        }, [
            registry,
            scope,
            isGlobal,
            containedStores
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $h0ORH.Context).Provider, {
            value: api
        }, children);
    }
    FunctionContainer.displayName = displayName || `Container`;
    FunctionContainer.propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).node,
        scope: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).string,
        isGlobal: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).bool
    };
    return FunctionContainer;
}

});
parcelRegister("8vJ0V", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $632422cfaa3e0ff5$var$ReactIs, $632422cfaa3e0ff5$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("6u0Zy"))();

});
parcelRegister("6u0Zy", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $7XPdg = parcelRequire("7XPdg");
function $4b8650625e933407$var$emptyFunction() {}
function $4b8650625e933407$var$emptyFunctionWithReset() {}
$4b8650625e933407$var$emptyFunctionWithReset.resetWarningCache = $4b8650625e933407$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $7XPdg) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $4b8650625e933407$var$emptyFunctionWithReset,
        resetWarningCache: $4b8650625e933407$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("7XPdg", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $5cc5c4e4ae50b046$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $5cc5c4e4ae50b046$var$ReactPropTypesSecret;

});




parcelRegister("1uA8D", function(module, exports) {
$parcel$export(module.exports, "createStore", () => $1164a01562ee8563$export$f51a9068ac82ea43);

var $1TyI7 = parcelRequire("1TyI7");
function $1164a01562ee8563$var$createKey(initialState, actions, name) {
    const src = !name ? Object.keys(actions).reduce((acc, k)=>acc + actions[k].toString(), '') : '';
    return [
        name,
        (0, $1TyI7.default)(src + JSON.stringify(initialState))
    ].filter(Boolean).join('__');
}
function $1164a01562ee8563$export$f51a9068ac82ea43(_ref) {
    let { name: name = '', initialState: initialState, actions: actions, containedBy: containedBy, handlers: handlers = {} } = _ref;
    let key;
    return {
        get key () {
            // lazy evaluate key on first access
            return key || (key = $1164a01562ee8563$var$createKey(initialState, actions, name));
        },
        initialState: initialState,
        actions: actions,
        containedBy: containedBy,
        handlers: handlers
    };
}

});
parcelRegister("1TyI7", function(module, exports) {
$parcel$export(module.exports, "default", () => $1615da4702e70caf$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $1615da4702e70caf$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});


parcelRegister("5zmEe", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv);

var $7V87c = parcelRequire("7V87c");

var $3ZMUU = parcelRequire("3ZMUU");
function isNodeEnv() {
    return !(0, $7V87c.isBrowserBundle)() && Object.prototype.toString.call(typeof $3ZMUU !== "undefined" ? $3ZMUU : 0) === "[object process]";
}
function dynamicRequire(mod, request) {
    return mod.require(request);
}
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch  {}
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, "process");
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch  {}
    return mod;
}

});
parcelRegister("7V87c", function(module, exports) {
$parcel$export(module.exports, "isBrowserBundle", () => $5c4426c0b9a98751$export$2928c40372e623c0);
function $5c4426c0b9a98751$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
function $5c4426c0b9a98751$export$8ad33f488b1ab046() {
    /*! __SENTRY_SDK_SOURCE__ */ return "npm";
}

});


parcelRegister("25LTq", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $4KWu0 = parcelRequire("4KWu0");

var $5K3ZQ = parcelRequire("5K3ZQ");

var $ckdh5 = parcelRequire("ckdh5");

var $y39T9 = parcelRequire("y39T9");

var $ivt7H = parcelRequire("ivt7H");

var $fyn9D = parcelRequire("fyn9D");

var $d33W7 = parcelRequire("d33W7");

var $aewmo = parcelRequire("aewmo");

var $aqgZ8 = parcelRequire("aqgZ8");

var $dOSrX = parcelRequire("dOSrX");

var $5wLxm = parcelRequire("5wLxm");

var $2YUNs = parcelRequire("2YUNs");

var $kSXzG = parcelRequire("kSXzG");

var $2ZTbI = parcelRequire("2ZTbI");

var $2JysJ = parcelRequire("2JysJ");

var $aOpjI = parcelRequire("aOpjI");

var $aK1wS = parcelRequire("aK1wS");

var $c0ahv = parcelRequire("c0ahv");

var $kfJmY = parcelRequire("kfJmY");

var $lln5F = parcelRequire("lln5F");

var $e3FcP = parcelRequire("e3FcP");

var $82wbm = parcelRequire("82wbm");

var $lyqaT = parcelRequire("lyqaT");

var $3uEjM = parcelRequire("3uEjM");

var $aBj8W = parcelRequire("aBj8W");

var $6lKwf = parcelRequire("6lKwf");

var $44Knx = parcelRequire("44Knx");

var $chEXN = parcelRequire("chEXN");

var $3y8q6 = parcelRequire("3y8q6");

var $eM0tn = parcelRequire("eM0tn");

var $ivDYu = parcelRequire("ivDYu");

var $aHFbi = parcelRequire("aHFbi");

var $5vlAD = parcelRequire("5vlAD");

var $7it17 = parcelRequire("7it17");

var $HDJnZ = parcelRequire("HDJnZ");

var $6l4Z5 = parcelRequire("6l4Z5");

var $iHwWw = parcelRequire("iHwWw");

var $88CzX = parcelRequire("88CzX");

var $dGSc0 = parcelRequire("dGSc0");

var $lWhcW = parcelRequire("lWhcW");

var $ktZhU = parcelRequire("ktZhU");

var $5xQO6 = parcelRequire("5xQO6");

var $7O6Z7 = parcelRequire("7O6Z7");

var $ceuzm = parcelRequire("ceuzm");

var $clLeB = parcelRequire("clLeB");

var $5nIsa = parcelRequire("5nIsa");

var $fB38a = parcelRequire("fB38a");

var $1Sd23 = parcelRequire("1Sd23");

var $8hCvI = parcelRequire("8hCvI");

var $3zGA3 = parcelRequire("3zGA3");

var $gQqIQ = parcelRequire("gQqIQ");

var $hTNHq = parcelRequire("hTNHq");

var $jvpIz = parcelRequire("jvpIz");

var $ctbAP = parcelRequire("ctbAP");

var $bXWmW = parcelRequire("bXWmW");

var $iJap7 = parcelRequire("iJap7");

var $8TUca = parcelRequire("8TUca");

var $kKz9d = parcelRequire("kKz9d");

var $h2lAT = parcelRequire("h2lAT");

var $f8jvI = parcelRequire("f8jvI");

var $QGp01 = parcelRequire("QGp01");

var $2hjz6 = parcelRequire("2hjz6");

var $dwO73 = parcelRequire("dwO73");

var $9KkJX = parcelRequire("9KkJX");

var $1vY2x = parcelRequire("1vY2x");

var $iiHl2 = parcelRequire("iiHl2");

var $64Mtt = parcelRequire("64Mtt");

var $6R0PE = parcelRequire("6R0PE");

var $jfxi0 = parcelRequire("jfxi0");

var $eeKAh = parcelRequire("eeKAh");

var $h8PJh = parcelRequire("h8PJh");

var $9VAI8 = parcelRequire("9VAI8");

var $frZkF = parcelRequire("frZkF");

var $47jLQ = parcelRequire("47jLQ");

var $hHN24 = parcelRequire("hHN24");

var $2Ojx4 = parcelRequire("2Ojx4");

var $2UjBX = parcelRequire("2UjBX");

var $cBTtm = parcelRequire("cBTtm");

var $kP4C3 = parcelRequire("kP4C3");

var $k8mK7 = parcelRequire("k8mK7");

var $giJRi = parcelRequire("giJRi");

var $b5gRO = parcelRequire("b5gRO");

var $9ZVkJ = parcelRequire("9ZVkJ");

var $knlYV = parcelRequire("knlYV");

var $k8x0o = parcelRequire("k8x0o");

var $bRW4e = parcelRequire("bRW4e");

var $91S1B = parcelRequire("91S1B");

var $gSEzQ = parcelRequire("gSEzQ");

var $cgTZX = parcelRequire("cgTZX");

var $5mc1N = parcelRequire("5mc1N");

var $2Qk3n = parcelRequire("2Qk3n");

var $gXfFT = parcelRequire("gXfFT");

var $1eeiu = parcelRequire("1eeiu");

var $ccsii = parcelRequire("ccsii");

var $jI0wg = parcelRequire("jI0wg");

var $040Dp = parcelRequire("040Dp");

var $esm0I = parcelRequire("esm0I");

var $jSAP5 = parcelRequire("jSAP5");

var $gpDY4 = parcelRequire("gpDY4");

var $b5qWi = parcelRequire("b5qWi");

var $5JHrG = parcelRequire("5JHrG");

var $hj0Jl = parcelRequire("hj0Jl");

var $bf9G5 = parcelRequire("bf9G5");

var $igulC = parcelRequire("igulC");

var $efgke = parcelRequire("efgke");

var $4x2Gl = parcelRequire("4x2Gl");

var $aUl7w = parcelRequire("aUl7w");

var $dL8qX = parcelRequire("dL8qX");

var $2NcBk = parcelRequire("2NcBk");

var $k1LZl = parcelRequire("k1LZl");

var $6zlry = parcelRequire("6zlry");

var $kHfIQ = parcelRequire("kHfIQ");

var $g8Glr = parcelRequire("g8Glr");

var $dFamO = parcelRequire("dFamO");

var $20yzn = parcelRequire("20yzn");

var $5ydSt = parcelRequire("5ydSt");

var $jHjIi = parcelRequire("jHjIi");

var $ebmC5 = parcelRequire("ebmC5");

var $eLMe1 = parcelRequire("eLMe1");

var $fxVZv = parcelRequire("fxVZv");

var $9Fabw = parcelRequire("9Fabw");

var $jl6r7 = parcelRequire("jl6r7");

var $cG6fZ = parcelRequire("cG6fZ");

var $4LBZA = parcelRequire("4LBZA");

var $2t0Z7 = parcelRequire("2t0Z7");

var $jV7hg = parcelRequire("jV7hg");

var $iyFot = parcelRequire("iyFot");

var $2sm2V = parcelRequire("2sm2V");

var $jR1Dv = parcelRequire("jR1Dv");

var $2ZrfN = parcelRequire("2ZrfN");

var $kCHEV = parcelRequire("kCHEV");

var $65lWX = parcelRequire("65lWX");

var $lAn2C = parcelRequire("lAn2C");

var $4q9hx = parcelRequire("4q9hx");

var $iGwGT = parcelRequire("iGwGT");

var $jK6Ba = parcelRequire("jK6Ba");

var $fIlsR = parcelRequire("fIlsR");

var $1L2sM = parcelRequire("1L2sM");

var $cx0Sh = parcelRequire("cx0Sh");

var $3MHSz = parcelRequire("3MHSz");

var $gU6V8 = parcelRequire("gU6V8");

var $bTcEr = parcelRequire("bTcEr");

var $hUV0Y = parcelRequire("hUV0Y");

var $kAeXb = parcelRequire("kAeXb");

var $6woCN = parcelRequire("6woCN");

var $1DVRT = parcelRequire("1DVRT");

var $QBqQc = parcelRequire("QBqQc");

var $foGB0 = parcelRequire("foGB0");

var $1M0QG = parcelRequire("1M0QG");

var $btfMK = parcelRequire("btfMK");

var $23smo = parcelRequire("23smo");

var $jvpRD = parcelRequire("jvpRD");

var $97cmn = parcelRequire("97cmn");

var $8IXO6 = parcelRequire("8IXO6");

var $by1rx = parcelRequire("by1rx");

var $6ki8f = parcelRequire("6ki8f");

var $1AuHE = parcelRequire("1AuHE");
module.exports.registerSpanErrorInstrumentation = $4KWu0.registerSpanErrorInstrumentation;
module.exports.getCapturedScopesOnSpan = $5K3ZQ.getCapturedScopesOnSpan;
module.exports.markSpanAsTracerProviderSpan = $5K3ZQ.markSpanAsTracerProviderSpan;
module.exports.markSpanForOtelSourceInference = $5K3ZQ.markSpanForOtelSourceInference;
module.exports.markSpanSourceAsExplicit = $5K3ZQ.markSpanSourceAsExplicit;
module.exports.setCapturedScopesOnSpan = $5K3ZQ.setCapturedScopesOnSpan;
module.exports.spanIsTracerProviderSpan = $5K3ZQ.spanIsTracerProviderSpan;
module.exports.spanShouldInferOtelSource = $5K3ZQ.spanShouldInferOtelSource;
module.exports.spanSourceWasExplicitlySet = $5K3ZQ.spanSourceWasExplicitlySet;
module.exports.TRACING_DEFAULTS = $ckdh5.TRACING_DEFAULTS;
module.exports.startIdleSpan = $ckdh5.startIdleSpan;
module.exports.SentrySpan = $y39T9.SentrySpan;
module.exports._INTERNAL_setDeferSegmentSpanCapture = $ivt7H._INTERNAL_setDeferSegmentSpanCapture;
module.exports.SentryNonRecordingSpan = $fyn9D.SentryNonRecordingSpan;
module.exports.SPAN_STATUS_ERROR = $d33W7.SPAN_STATUS_ERROR;
module.exports.SPAN_STATUS_OK = $d33W7.SPAN_STATUS_OK;
module.exports.SPAN_STATUS_UNSET = $d33W7.SPAN_STATUS_UNSET;
module.exports.getSpanStatusFromHttpCode = $d33W7.getSpanStatusFromHttpCode;
module.exports.setHttpStatus = $d33W7.setHttpStatus;
module.exports.SUPPRESS_TRACING_KEY = $aewmo.SUPPRESS_TRACING_KEY;
module.exports._INTERNAL_startInactiveSpan = $aewmo._INTERNAL_startInactiveSpan;
module.exports.continueTrace = $aewmo.continueTrace;
module.exports.isTracingSuppressed = $aewmo.isTracingSuppressed;
module.exports.spanIsIgnored = $aewmo.spanIsIgnored;
module.exports.startInactiveSpan = $aewmo.startInactiveSpan;
module.exports.startNewTrace = $aewmo.startNewTrace;
module.exports.startSpan = $aewmo.startSpan;
module.exports.startSpanManual = $aewmo.startSpanManual;
module.exports.suppressTracing = $aewmo.suppressTracing;
module.exports.withActiveSpan = $aewmo.withActiveSpan;
module.exports.bindScopeToEmitter = $aqgZ8.bindScopeToEmitter;
module.exports.getDynamicSamplingContextFromClient = $dOSrX.getDynamicSamplingContextFromClient;
module.exports.getDynamicSamplingContextFromScope = $dOSrX.getDynamicSamplingContextFromScope;
module.exports.getDynamicSamplingContextFromSpan = $dOSrX.getDynamicSamplingContextFromSpan;
module.exports.spanToBaggageHeader = $dOSrX.spanToBaggageHeader;
module.exports.setMeasurement = $5wLxm.setMeasurement;
module.exports.timedEventsToMeasurements = $5wLxm.timedEventsToMeasurements;
module.exports.sampleSpan = $2YUNs.sampleSpan;
module.exports.logSpanEnd = $kSXzG.logSpanEnd;
module.exports.logSpanStart = $kSXzG.logSpanStart;
module.exports.captureSpan = $2ZTbI.captureSpan;
module.exports.safeSetSpanJSONAttributes = $2ZTbI.safeSetSpanJSONAttributes;
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $2JysJ.GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = $2JysJ.SEMANTIC_ATTRIBUTE_CACHE_HIT;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = $2JysJ.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = $2JysJ.SEMANTIC_ATTRIBUTE_CACHE_KEY;
module.exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = $2JysJ.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
module.exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = $2JysJ.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
module.exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = $2JysJ.SEMANTIC_ATTRIBUTE_PROFILE_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = $2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = $2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = $2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = $2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = $2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = $2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_OP;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = $2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = $2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = $2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = $2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = $2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = $2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = $2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = $2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = $2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = $2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE = $2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE;
module.exports.SEMANTIC_ATTRIBUTE_URL_FULL = $2JysJ.SEMANTIC_ATTRIBUTE_URL_FULL;
module.exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = $2JysJ.SEMANTIC_ATTRIBUTE_USER_EMAIL;
module.exports.SEMANTIC_ATTRIBUTE_USER_ID = $2JysJ.SEMANTIC_ATTRIBUTE_USER_ID;
module.exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = $2JysJ.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
module.exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = $2JysJ.SEMANTIC_ATTRIBUTE_USER_USERNAME;
module.exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = $2JysJ.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;
module.exports.createEventEnvelope = $aOpjI.createEventEnvelope;
module.exports.createSessionEnvelope = $aOpjI.createSessionEnvelope;
module.exports.createSpanEnvelope = $aOpjI.createSpanEnvelope;
module.exports.addEventProcessor = $aK1wS.addEventProcessor;
module.exports.captureEvent = $aK1wS.captureEvent;
module.exports.captureException = $aK1wS.captureException;
module.exports.captureMessage = $aK1wS.captureMessage;
module.exports.captureSession = $aK1wS.captureSession;
module.exports.close = $aK1wS.close;
module.exports.endSession = $aK1wS.endSession;
module.exports.flush = $aK1wS.flush;
module.exports.isEnabled = $aK1wS.isEnabled;
module.exports.isInitialized = $aK1wS.isInitialized;
module.exports.lastEventId = $aK1wS.lastEventId;
module.exports.setAttribute = $aK1wS.setAttribute;
module.exports.setAttributes = $aK1wS.setAttributes;
module.exports.setContext = $aK1wS.setContext;
module.exports.setConversationId = $aK1wS.setConversationId;
module.exports.setExtra = $aK1wS.setExtra;
module.exports.setExtras = $aK1wS.setExtras;
module.exports.setTag = $aK1wS.setTag;
module.exports.setTags = $aK1wS.setTags;
module.exports.setUser = $aK1wS.setUser;
module.exports.startSession = $aK1wS.startSession;
module.exports.captureCheckIn = $c0ahv.captureCheckIn;
module.exports.withMonitor = $c0ahv.withMonitor;
module.exports.getClient = $kfJmY.getClient;
module.exports.getCurrentScope = $kfJmY.getCurrentScope;
module.exports.getExternalPropagationContext = $kfJmY.getExternalPropagationContext;
module.exports.getGlobalScope = $kfJmY.getGlobalScope;
module.exports.getIsolationScope = $kfJmY.getIsolationScope;
module.exports.getTraceContextFromScope = $kfJmY.getTraceContextFromScope;
module.exports.hasExternalPropagationContext = $kfJmY.hasExternalPropagationContext;
module.exports.registerExternalPropagationContext = $kfJmY.registerExternalPropagationContext;
module.exports.withIsolationScope = $kfJmY.withIsolationScope;
module.exports.withScope = $kfJmY.withScope;
module.exports.getDefaultCurrentScope = $lln5F.getDefaultCurrentScope;
module.exports.getDefaultIsolationScope = $lln5F.getDefaultIsolationScope;
module.exports.getAsyncContextStrategy = $e3FcP.getAsyncContextStrategy;
module.exports.setAsyncContextStrategy = $e3FcP.setAsyncContextStrategy;
module.exports._INTERNAL_createTracingChannelBinding = $82wbm._INTERNAL_createTracingChannelBinding;
module.exports.waitForTracingChannelBinding = $82wbm.waitForTracingChannelBinding;
module.exports.getGlobalSingleton = $lyqaT.getGlobalSingleton;
module.exports.getMainCarrier = $lyqaT.getMainCarrier;
module.exports.closeSession = $3uEjM.closeSession;
module.exports.makeSession = $3uEjM.makeSession;
module.exports.updateSession = $3uEjM.updateSession;
module.exports.Scope = $aBj8W.Scope;
module.exports.notifyEventProcessors = $6lKwf.notifyEventProcessors;
module.exports.SENTRY_API_VERSION = $44Knx.SENTRY_API_VERSION;
module.exports.getEnvelopeEndpointWithUrlEncodedAuth = $44Knx.getEnvelopeEndpointWithUrlEncodedAuth;
module.exports.getReportDialogEndpoint = $44Knx.getReportDialogEndpoint;
module.exports.Client = $chEXN.Client;
module.exports.initAndBind = $3y8q6.initAndBind;
module.exports.setCurrentClient = $3y8q6.setCurrentClient;
module.exports.createTransport = $eM0tn.createTransport;
module.exports.makeOfflineTransport = $ivDYu.makeOfflineTransport;
module.exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = $aHFbi.MULTIPLEXED_TRANSPORT_EXTRA_KEY;
module.exports.makeMultiplexedTransport = $aHFbi.makeMultiplexedTransport;
module.exports.addIntegration = $5vlAD.addIntegration;
module.exports.defineIntegration = $5vlAD.defineIntegration;
module.exports.extendIntegration = $5vlAD.extendIntegration;
module.exports.getIntegrationsToSetup = $5vlAD.getIntegrationsToSetup;
module.exports.installedIntegrations = $5vlAD.installedIntegrations;
module.exports._INTERNAL_clearAiProviderSkips = $7it17._INTERNAL_clearAiProviderSkips;
module.exports._INTERNAL_shouldSkipAiProviderWrapping = $7it17._INTERNAL_shouldSkipAiProviderWrapping;
module.exports._INTERNAL_skipAiProviderWrapping = $7it17._INTERNAL_skipAiProviderWrapping;
module.exports._INTERNAL_filterKeyValueData = $HDJnZ.filterKeyValueData;
module.exports._INTERNAL_filterCookies = $6l4Z5.filterCookies;
module.exports._INTERNAL_filterQueryParams = $iHwWw.filterQueryParams;
module.exports.envToBool = $88CzX.envToBool;
module.exports.applyScopeDataToEvent = $dGSc0.applyScopeDataToEvent;
module.exports.getCombinedScopeData = $dGSc0.getCombinedScopeData;
module.exports.mergeScopeData = $dGSc0.mergeScopeData;
module.exports.prepareEvent = $lWhcW.prepareEvent;
module.exports.createCheckInEnvelope = $ktZhU.createCheckInEnvelope;
module.exports.hasSpansEnabled = $5xQO6.hasSpansEnabled;
module.exports.isStreamedBeforeSendSpanCallback = $7O6Z7.isStreamedBeforeSendSpanCallback;
module.exports.withStreamedSpan = $7O6Z7.withStreamedSpan;
module.exports.isSentryRequestUrl = $ceuzm.isSentryRequestUrl;
module.exports.handleCallbackErrors = $clLeB.handleCallbackErrors;
module.exports.fmt = $5nIsa.fmt;
module.exports.parameterize = $5nIsa.parameterize;
module.exports.handleTunnelRequest = $fB38a.handleTunnelRequest;
module.exports.addAutoIpAddressToSession = $1Sd23.addAutoIpAddressToSession;
module.exports.addAutoIpAddressToUser = $1Sd23.addAutoIpAddressToUser;
module.exports.INTERNAL_getSegmentSpan = $8hCvI.INTERNAL_getSegmentSpan;
module.exports.addChildSpanToSpan = $8hCvI.addChildSpanToSpan;
module.exports.convertSpanLinksForEnvelope = $8hCvI.convertSpanLinksForEnvelope;
module.exports.getActiveSpan = $8hCvI.getActiveSpan;
module.exports.getRootSpan = $8hCvI.getRootSpan;
module.exports.getSpanDescendants = $8hCvI.getSpanDescendants;
module.exports.getStatusMessage = $8hCvI.getStatusMessage;
module.exports.spanIsSampled = $8hCvI.spanIsSampled;
module.exports.spanIsSentrySpan = $8hCvI.spanIsSentrySpan;
module.exports.spanTimeInputToSeconds = $8hCvI.spanTimeInputToSeconds;
module.exports.spanToJSON = $8hCvI.spanToJSON;
module.exports.spanToStreamedSpanJSON = $8hCvI.spanToStreamedSpanJSON;
module.exports.spanToTraceContext = $8hCvI.spanToTraceContext;
module.exports.spanToTraceHeader = $8hCvI.spanToTraceHeader;
module.exports.updateSpanName = $8hCvI.updateSpanName;
module.exports._INTERNAL_setSpanForScope = $3zGA3._setSpanForScope;
module.exports.parseSampleRate = $gQqIQ.parseSampleRate;
module.exports.applySdkMetadata = $hTNHq.applySdkMetadata;
module.exports.getTraceData = $jvpIz.getTraceData;
module.exports.shouldPropagateTraceForUrl = $ctbAP.shouldPropagateTraceForUrl;
module.exports.getTraceMetaTags = $bXWmW.getTraceMetaTags;
module.exports.debounce = $iJap7.debounce;
module.exports.uniq = $8TUca.uniq;
module.exports.derefWeakRef = $kKz9d.derefWeakRef;
module.exports.makeWeakRef = $kKz9d.makeWeakRef;
module.exports.shouldIgnoreSpan = $h2lAT.shouldIgnoreSpan;
module.exports.MAX_BODY_BYTE_LENGTH = $f8jvI.MAX_BODY_BYTE_LENGTH;
module.exports.captureBodyFromWinterCGRequest = $f8jvI.captureBodyFromWinterCGRequest;
module.exports.extractQueryParamsFromUrl = $f8jvI.extractQueryParamsFromUrl;
module.exports.getMaxBodyByteLength = $f8jvI.getMaxBodyByteLength;
module.exports.headersToDict = $f8jvI.headersToDict;
module.exports.httpHeadersToSpanAttributes = $f8jvI.httpHeadersToSpanAttributes;
module.exports.httpRequestToRequestData = $f8jvI.httpRequestToRequestData;
module.exports.winterCGHeadersToDict = $f8jvI.winterCGHeadersToDict;
module.exports.winterCGRequestToRequestData = $f8jvI.winterCGRequestToRequestData;
module.exports.DEFAULT_ENVIRONMENT = $QGp01.DEFAULT_ENVIRONMENT;
module.exports.DEV_ENVIRONMENT = $QGp01.DEV_ENVIRONMENT;
module.exports.SPAN_KIND = $2hjz6.SPAN_KIND;
module.exports.spanKindToName = $2hjz6.spanKindToName;
module.exports.addBreadcrumb = $dwO73.addBreadcrumb;
module.exports.functionToStringIntegration = $9KkJX.functionToStringIntegration;
module.exports.eventFiltersIntegration = $1vY2x.eventFiltersIntegration;
module.exports.inboundFiltersIntegration = $1vY2x.inboundFiltersIntegration;
module.exports.linkedErrorsIntegration = $iiHl2.linkedErrorsIntegration;
module.exports.moduleMetadataIntegration = $64Mtt.moduleMetadataIntegration;
module.exports.requestDataIntegration = $6R0PE.requestDataIntegration;
module.exports.captureConsoleIntegration = $jfxi0.captureConsoleIntegration;
module.exports.dedupeIntegration = $eeKAh.dedupeIntegration;
module.exports.extraErrorDataIntegration = $h8PJh.extraErrorDataIntegration;
module.exports.rewriteFramesIntegration = $9VAI8.rewriteFramesIntegration;
module.exports.instrumentSupabaseClient = $frZkF.instrumentSupabaseClient;
module.exports.supabaseIntegration = $frZkF.supabaseIntegration;
module.exports.zodErrorsIntegration = $47jLQ.zodErrorsIntegration;
module.exports.thirdPartyErrorFilterIntegration = $hHN24.thirdPartyErrorFilterIntegration;
module.exports.consoleIntegration = $2Ojx4.consoleIntegration;
module.exports.featureFlagsIntegration = $2UjBX.featureFlagsIntegration;
module.exports.growthbookIntegration = $cBTtm.growthbookIntegration;
module.exports.conversationIdIntegration = $kP4C3.conversationIdIntegration;
module.exports.profiler = $k8mK7.profiler;
module.exports._INTERNAL_getTracingHeadersForFetchRequest = $giJRi._INTERNAL_getTracingHeadersForFetchRequest;
module.exports.instrumentFetchRequest = $giJRi.instrumentFetchRequest;
module.exports.captureFeedback = $b5gRO.captureFeedback;
module.exports._INTERNAL_captureLog = $9ZVkJ._INTERNAL_captureLog;
module.exports._INTERNAL_captureSerializedLog = $9ZVkJ._INTERNAL_captureSerializedLog;
module.exports._INTERNAL_flushLogsBuffer = $9ZVkJ._INTERNAL_flushLogsBuffer;
module.exports.logger = $knlYV;
module.exports.consoleLoggingIntegration = $k8x0o.consoleLoggingIntegration;
module.exports._INTERNAL_captureMetric = $bRW4e._INTERNAL_captureMetric;
module.exports._INTERNAL_captureSerializedMetric = $bRW4e._INTERNAL_captureSerializedMetric;
module.exports._INTERNAL_flushMetricsBuffer = $bRW4e._INTERNAL_flushMetricsBuffer;
module.exports.metrics = $91S1B;
module.exports.createConsolaReporter = $gSEzQ.createConsolaReporter;
module.exports.LAST_STEP_ONLY_USAGE_KEYS = $cgTZX.LAST_STEP_ONLY_USAGE_KEYS;
module.exports.addVercelAiProcessors = $cgTZX.addVercelAiProcessors;
module.exports.getProviderMetadataAttributes = $cgTZX.getProviderMetadataAttributes;
module.exports.getTruncatedJsonString = $5mc1N.getTruncatedJsonString;
module.exports.resolveAIRecordingOptions = $5mc1N.resolveAIRecordingOptions;
module.exports.shouldEnableTruncation = $5mc1N.shouldEnableTruncation;
module.exports.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = $2Qk3n.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MODEL_ATTRIBUTE = $2Qk3n.GEN_AI_REQUEST_MODEL_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = $2Qk3n.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE;
module.exports._INTERNAL_cleanupToolCallSpanContext = $gXfFT._INTERNAL_cleanupToolCallSpanContext;
module.exports._INTERNAL_getSpanContextForToolCallId = $gXfFT._INTERNAL_getSpanContextForToolCallId;
module.exports._INTERNAL_toolCallSpanContextMap = $1eeiu.toolCallSpanContextMap;
module.exports.addOpenAiRequestAttributes = $ccsii.addRequestAttributes;
module.exports.extractOpenAiRequestAttributes = $ccsii.extractRequestAttributes;
module.exports.instrumentOpenAiClient = $ccsii.instrumentOpenAiClient;
module.exports.addOpenAiResponseAttributes = $jI0wg.addResponseAttributes;
module.exports.extractOpenAiRequestParameters = $jI0wg.extractRequestParameters;
module.exports.instrumentOpenAiStream = $040Dp.instrumentStream;
module.exports.OPENAI_INTEGRATION_NAME = $esm0I.OPENAI_INTEGRATION_NAME;
module.exports.addAnthropicRequestAttributes = $jSAP5.addPrivateRequestAttributes;
module.exports.addAnthropicResponseAttributes = $jSAP5.addResponseAttributes;
module.exports.extractAnthropicRequestAttributes = $jSAP5.extractRequestAttributes;
module.exports.instrumentAnthropicAiClient = $jSAP5.instrumentAnthropicAiClient;
module.exports.instrumentAsyncIterableStream = $gpDY4.instrumentAsyncIterableStream;
module.exports.instrumentMessageStream = $gpDY4.instrumentMessageStream;
module.exports.ANTHROPIC_AI_INTEGRATION_NAME = $b5qWi.ANTHROPIC_AI_INTEGRATION_NAME;
module.exports.addGoogleGenAIRequestAttributes = $5JHrG.addPrivateRequestAttributes;
module.exports.addGoogleGenAIResponseAttributes = $5JHrG.addResponseAttributes;
module.exports.extractGoogleGenAIRequestAttributes = $5JHrG.extractRequestAttributes;
module.exports.instrumentGoogleGenAIClient = $5JHrG.instrumentGoogleGenAIClient;
module.exports.instrumentGoogleGenAIStream = $hj0Jl.instrumentStream;
module.exports.GOOGLE_GENAI_INTEGRATION_NAME = $bf9G5.GOOGLE_GENAI_INTEGRATION_NAME;
module.exports.createLangChainCallbackHandler = $igulC.createLangChainCallbackHandler;
module.exports._INTERNAL_getLangChainEmbeddingsSpanOptions = $efgke._INTERNAL_getLangChainEmbeddingsSpanOptions;
module.exports.instrumentLangChainEmbeddings = $efgke.instrumentLangChainEmbeddings;
module.exports._INTERNAL_mergeLangChainCallbackHandler = $4x2Gl._INTERNAL_mergeLangChainCallbackHandler;
module.exports.LANGCHAIN_INTEGRATION_NAME = $aUl7w.LANGCHAIN_INTEGRATION_NAME;
module.exports._INTERNAL_getLangGraphCreateAgentSpanOptions = $dL8qX._INTERNAL_getLangGraphCreateAgentSpanOptions;
module.exports.instrumentCompiledGraphInvoke = $dL8qX.instrumentCompiledGraphInvoke;
module.exports.instrumentCreateReactAgent = $dL8qX.instrumentCreateReactAgent;
module.exports.instrumentLangGraph = $dL8qX.instrumentLangGraph;
module.exports.instrumentStateGraph = $dL8qX.instrumentStateGraph;
module.exports.instrumentStateGraphCompile = $dL8qX.instrumentStateGraphCompile;
module.exports.extractAgentNameFromParams = $2NcBk.extractAgentNameFromParams;
module.exports.extractLLMFromParams = $2NcBk.extractLLMFromParams;
module.exports.wrapToolsWithSpans = $2NcBk.wrapToolsWithSpans;
module.exports.LANGGRAPH_INTEGRATION_NAME = $k1LZl.LANGGRAPH_INTEGRATION_NAME;
module.exports.instrumentWorkersAiClient = $6zlry.instrumentWorkersAiClient;
module.exports.SpanBuffer = $kHfIQ.SpanBuffer;
module.exports.hasSpanStreamingEnabled = $g8Glr.hasSpanStreamingEnabled;
module.exports.spanStreamingIntegration = $dFamO.spanStreamingIntegration;
module.exports._INTERNAL_FLAG_BUFFER_SIZE = $20yzn._INTERNAL_FLAG_BUFFER_SIZE;
module.exports._INTERNAL_MAX_FLAGS_PER_SPAN = $20yzn._INTERNAL_MAX_FLAGS_PER_SPAN;
module.exports._INTERNAL_addFeatureFlagToActiveSpan = $20yzn._INTERNAL_addFeatureFlagToActiveSpan;
module.exports._INTERNAL_copyFlagsFromScopeToEvent = $20yzn._INTERNAL_copyFlagsFromScopeToEvent;
module.exports._INTERNAL_insertFlagToScope = $20yzn._INTERNAL_insertFlagToScope;
module.exports.applyAggregateErrorsToEvent = $5ydSt.applyAggregateErrorsToEvent;
module.exports.getBreadcrumbLogLevelFromHttpStatusCode = $jHjIi.getBreadcrumbLogLevelFromHttpStatusCode;
module.exports.dsnFromString = $ebmC5.dsnFromString;
module.exports.dsnToString = $ebmC5.dsnToString;
module.exports.makeDsn = $ebmC5.makeDsn;
module.exports.SentryError = $eLMe1.SentryError;
module.exports.GLOBAL_OBJ = $fxVZv.GLOBAL_OBJ;
module.exports.addConsoleInstrumentationFilter = $9Fabw.addConsoleInstrumentationFilter;
module.exports.addConsoleInstrumentationHandler = $9Fabw.addConsoleInstrumentationHandler;
module.exports.addFetchEndInstrumentationHandler = $jl6r7.addFetchEndInstrumentationHandler;
module.exports.addFetchInstrumentationHandler = $jl6r7.addFetchInstrumentationHandler;
module.exports.addGlobalErrorInstrumentationHandler = $cG6fZ.addGlobalErrorInstrumentationHandler;
module.exports.addGlobalUnhandledRejectionInstrumentationHandler = $4LBZA.addGlobalUnhandledRejectionInstrumentationHandler;
module.exports.addHandler = $2t0Z7.addHandler;
module.exports.maybeInstrument = $2t0Z7.maybeInstrument;
module.exports.resetInstrumentationHandlers = $2t0Z7.resetInstrumentationHandlers;
module.exports.triggerHandlers = $2t0Z7.triggerHandlers;
module.exports.isDOMError = $jV7hg.isDOMError;
module.exports.isDOMException = $jV7hg.isDOMException;
module.exports.isElement = $jV7hg.isElement;
module.exports.isError = $jV7hg.isError;
module.exports.isErrorEvent = $jV7hg.isErrorEvent;
module.exports.isEvent = $jV7hg.isEvent;
module.exports.isInstanceOf = $jV7hg.isInstanceOf;
module.exports.isObjectLike = $jV7hg.isObjectLike;
module.exports.isParameterizedString = $jV7hg.isParameterizedString;
module.exports.isPlainObject = $jV7hg.isPlainObject;
module.exports.isPrimitive = $jV7hg.isPrimitive;
module.exports.isRegExp = $jV7hg.isRegExp;
module.exports.isString = $jV7hg.isString;
module.exports.isSyntheticEvent = $jV7hg.isSyntheticEvent;
module.exports.isThenable = $jV7hg.isThenable;
module.exports.isVueViewModel = $jV7hg.isVueViewModel;
module.exports.isBrowser = $iyFot.isBrowser;
module.exports.CONSOLE_LEVELS = $2sm2V.CONSOLE_LEVELS;
module.exports.consoleSandbox = $2sm2V.consoleSandbox;
module.exports.debug = $2sm2V.debug;
module.exports.originalConsoleMethods = $2sm2V.originalConsoleMethods;
module.exports.addContextToFrame = $jR1Dv.addContextToFrame;
module.exports.addExceptionMechanism = $jR1Dv.addExceptionMechanism;
module.exports.addExceptionTypeValue = $jR1Dv.addExceptionTypeValue;
module.exports.checkOrSetAlreadyCaught = $jR1Dv.checkOrSetAlreadyCaught;
module.exports.getEventDescription = $jR1Dv.getEventDescription;
module.exports.isAlreadyCaptured = $jR1Dv.isAlreadyCaptured;
module.exports.parseSemver = $jR1Dv.parseSemver;
module.exports.uuid4 = $jR1Dv.uuid4;
module.exports.normalize = $2ZrfN.normalize;
module.exports.normalizeToSize = $2ZrfN.normalizeToSize;
module.exports.normalizeUrlToBase = $2ZrfN.normalizeUrlToBase;
module.exports.setNormalizeStringifier = $2ZrfN.setNormalizeStringifier;
module.exports.setNormalizationDepthOverrideHint = $kCHEV.setNormalizationDepthOverrideHint;
module.exports.setSkipNormalizationHint = $kCHEV.setSkipNormalizationHint;
module.exports.addNonEnumerableProperty = $65lWX.addNonEnumerableProperty;
module.exports.convertToPlainObject = $65lWX.convertToPlainObject;
module.exports.dropUndefinedKeys = $65lWX.dropUndefinedKeys;
module.exports.extractExceptionKeysForMessage = $65lWX.extractExceptionKeysForMessage;
module.exports.fill = $65lWX.fill;
module.exports.getOriginalFunction = $65lWX.getOriginalFunction;
module.exports.markFunctionWrapped = $65lWX.markFunctionWrapped;
module.exports.objectify = $65lWX.objectify;
module.exports.basename = $lAn2C.basename;
module.exports.dirname = $lAn2C.dirname;
module.exports.isAbsolute = $lAn2C.isAbsolute;
module.exports.join = $lAn2C.join;
module.exports.normalizePath = $lAn2C.normalizePath;
module.exports.relative = $lAn2C.relative;
module.exports.resolve = $lAn2C.resolve;
module.exports.SENTRY_BUFFER_FULL_ERROR = $4q9hx.SENTRY_BUFFER_FULL_ERROR;
module.exports.makePromiseBuffer = $4q9hx.makePromiseBuffer;
module.exports.severityLevelFromString = $iGwGT.severityLevelFromString;
module.exports.replaceExports = $jK6Ba.replaceExports;
module.exports.UNKNOWN_FUNCTION = $fIlsR.UNKNOWN_FUNCTION;
module.exports.createStackParser = $fIlsR.createStackParser;
module.exports.getFramesFromEvent = $fIlsR.getFramesFromEvent;
module.exports.getFunctionName = $fIlsR.getFunctionName;
module.exports.stackParserFromStackParserOptions = $fIlsR.stackParserFromStackParserOptions;
module.exports.stripSentryFramesAndReverse = $fIlsR.stripSentryFramesAndReverse;
module.exports.isMatchingPattern = $1L2sM.isMatchingPattern;
module.exports.safeJoin = $1L2sM.safeJoin;
module.exports.snipLine = $1L2sM.snipLine;
module.exports.stringMatchesSomePattern = $1L2sM.stringMatchesSomePattern;
module.exports.stringify = $1L2sM.stringify;
module.exports.truncate = $1L2sM.truncate;
module.exports.isNativeFunction = $cx0Sh.isNativeFunction;
module.exports.supportsDOMError = $cx0Sh.supportsDOMError;
module.exports.supportsDOMException = $cx0Sh.supportsDOMException;
module.exports.supportsErrorEvent = $cx0Sh.supportsErrorEvent;
module.exports.supportsFetch = $cx0Sh.supportsFetch;
module.exports.supportsHistory = $cx0Sh.supportsHistory;
module.exports.supportsNativeFetch = $cx0Sh.supportsNativeFetch;
module.exports.supportsReferrerPolicy = $cx0Sh.supportsReferrerPolicy;
module.exports.supportsReportingObserver = $cx0Sh.supportsReportingObserver;
module.exports.SyncPromise = $3MHSz.SyncPromise;
module.exports.rejectedSyncPromise = $3MHSz.rejectedSyncPromise;
module.exports.resolvedSyncPromise = $3MHSz.resolvedSyncPromise;
module.exports.browserPerformanceTimeOrigin = $gU6V8.browserPerformanceTimeOrigin;
module.exports.dateTimestampInSeconds = $gU6V8.dateTimestampInSeconds;
module.exports.timestampInSeconds = $gU6V8.timestampInSeconds;
module.exports.TRACEPARENT_REGEXP = $bTcEr.TRACEPARENT_REGEXP;
module.exports.extractTraceparentData = $bTcEr.extractTraceparentData;
module.exports.generateSentryTraceHeader = $bTcEr.generateSentryTraceHeader;
module.exports.generateTraceparentHeader = $bTcEr.generateTraceparentHeader;
module.exports.isContinuingTrace = $bTcEr.isContinuingTrace;
module.exports.propagationContextFromHeaders = $bTcEr.propagationContextFromHeaders;
module.exports.shouldContinueTrace = $bTcEr.shouldContinueTrace;
module.exports.getSDKSource = $hUV0Y.getSDKSource;
module.exports.isBrowserBundle = $hUV0Y.isBrowserBundle;
module.exports.addItemToEnvelope = $kAeXb.addItemToEnvelope;
module.exports.createAttachmentEnvelopeItem = $kAeXb.createAttachmentEnvelopeItem;
module.exports.createEnvelope = $kAeXb.createEnvelope;
module.exports.createEventEnvelopeHeaders = $kAeXb.createEventEnvelopeHeaders;
module.exports.createSpanEnvelopeItem = $kAeXb.createSpanEnvelopeItem;
module.exports.envelopeContainsItemType = $kAeXb.envelopeContainsItemType;
module.exports.envelopeItemTypeToDataCategory = $kAeXb.envelopeItemTypeToDataCategory;
module.exports.forEachEnvelopeItem = $kAeXb.forEachEnvelopeItem;
module.exports.getSdkMetadataForEnvelopeHeader = $kAeXb.getSdkMetadataForEnvelopeHeader;
module.exports.parseEnvelope = $kAeXb.parseEnvelope;
module.exports.serializeEnvelope = $kAeXb.serializeEnvelope;
module.exports.createClientReportEnvelope = $6woCN.createClientReportEnvelope;
module.exports.DEFAULT_RETRY_AFTER = $1DVRT.DEFAULT_RETRY_AFTER;
module.exports.disabledUntil = $1DVRT.disabledUntil;
module.exports.isRateLimited = $1DVRT.isRateLimited;
module.exports.parseRetryAfterHeader = $1DVRT.parseRetryAfterHeader;
module.exports.updateRateLimits = $1DVRT.updateRateLimits;
module.exports.MAX_BAGGAGE_STRING_LENGTH = $QBqQc.MAX_BAGGAGE_STRING_LENGTH;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX = $QBqQc.SENTRY_BAGGAGE_KEY_PREFIX;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = $QBqQc.SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
module.exports.baggageHeaderToDynamicSamplingContext = $QBqQc.baggageHeaderToDynamicSamplingContext;
module.exports.dynamicSamplingContextToSentryBaggageHeader = $QBqQc.dynamicSamplingContextToSentryBaggageHeader;
module.exports.mergeBaggageHeaders = $QBqQc.mergeBaggageHeaders;
module.exports.objectToBaggageHeader = $QBqQc.objectToBaggageHeader;
module.exports.parseBaggageHeader = $QBqQc.parseBaggageHeader;
module.exports.getHttpSpanDetailsFromUrlObject = $foGB0.getHttpSpanDetailsFromUrlObject;
module.exports.getSanitizedUrlString = $foGB0.getSanitizedUrlString;
module.exports.getSanitizedUrlStringFromUrlObject = $foGB0.getSanitizedUrlStringFromUrlObject;
module.exports.isURLObjectRelative = $foGB0.isURLObjectRelative;
module.exports.parseStringToURLObject = $foGB0.parseStringToURLObject;
module.exports.parseUrl = $foGB0.parseUrl;
module.exports.stripDataUrlContent = $foGB0.stripDataUrlContent;
module.exports.stripUrlQueryAndFragment = $foGB0.stripUrlQueryAndFragment;
module.exports._INTERNAL_enhanceErrorWithSentryInfo = $1M0QG._enhanceErrorWithSentryInfo;
module.exports.eventFromMessage = $1M0QG.eventFromMessage;
module.exports.eventFromUnknownInput = $1M0QG.eventFromUnknownInput;
module.exports.exceptionFromError = $1M0QG.exceptionFromError;
module.exports.parseStackFrames = $1M0QG.parseStackFrames;
module.exports.LRUMap = $btfMK.LRUMap;
module.exports.generateSpanId = $23smo.generateSpanId;
module.exports.generateTraceId = $23smo.generateTraceId;
module.exports.SDK_VERSION = $jvpRD.SDK_VERSION;
module.exports.getDebugImagesForResources = $97cmn.getDebugImagesForResources;
module.exports.getFilenameToDebugIdMap = $97cmn.getFilenameToDebugIdMap;
module.exports.getFilenameToMetadataMap = $8IXO6.getFilenameToMetadataMap;
module.exports.escapeStringForRegex = $by1rx.escapeStringForRegex;
module.exports._INTERNAL_safeDateNow = $6ki8f.safeDateNow;
module.exports._INTERNAL_safeMathRandom = $6ki8f.safeMathRandom;
module.exports._INTERNAL_withRandomSafeContext = $6ki8f.withRandomSafeContext;
module.exports.getComponentName = $1AuHE.getComponentName;
module.exports.getLocationHref = $1AuHE.getLocationHref;
module.exports.htmlTreeAsString = $1AuHE.htmlTreeAsString;

});
parcelRegister("4KWu0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1GyI0 = parcelRequire("1GyI0");

var $cG6fZ = parcelRequire("cG6fZ");

var $4LBZA = parcelRequire("4LBZA");

var $2sm2V = parcelRequire("2sm2V");

var $8hCvI = parcelRequire("8hCvI");

var $d33W7 = parcelRequire("d33W7");
let $3768d2ce35ff9690$var$errorsInstrumented = false;
function $3768d2ce35ff9690$var$registerSpanErrorInstrumentation() {
    if ($3768d2ce35ff9690$var$errorsInstrumented) return;
    function errorCallback() {
        const activeSpan = $8hCvI.getActiveSpan();
        const rootSpan = activeSpan && $8hCvI.getRootSpan(activeSpan);
        if (rootSpan) {
            const message = "internal_error";
            $1GyI0.DEBUG_BUILD && $2sm2V.debug.log(`[Tracing] Root span: ${message} -> Global error occurred`);
            rootSpan.setStatus({
                code: $d33W7.SPAN_STATUS_ERROR,
                message: message
            });
        }
    }
    $3768d2ce35ff9690$var$errorsInstrumented = true;
    $cG6fZ.addGlobalErrorInstrumentationHandler(errorCallback);
    $4LBZA.addGlobalUnhandledRejectionInstrumentationHandler(errorCallback);
}
module.exports.registerSpanErrorInstrumentation = $3768d2ce35ff9690$var$registerSpanErrorInstrumentation;

});
parcelRegister("1GyI0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $13a4a3271041f1ef$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
module.exports.DEBUG_BUILD = $13a4a3271041f1ef$var$DEBUG_BUILD;

});

parcelRegister("cG6fZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fxVZv = parcelRequire("fxVZv");

var $2t0Z7 = parcelRequire("2t0Z7");
let $93ae42c1826927e2$var$_oldOnErrorHandler = null;
function $93ae42c1826927e2$var$addGlobalErrorInstrumentationHandler(handler) {
    const type = "error";
    $2t0Z7.addHandler(type, handler);
    $2t0Z7.maybeInstrument(type, $93ae42c1826927e2$var$instrumentError);
}
function $93ae42c1826927e2$var$instrumentError() {
    $93ae42c1826927e2$var$_oldOnErrorHandler = $fxVZv.GLOBAL_OBJ.onerror;
    $fxVZv.GLOBAL_OBJ.onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        $2t0Z7.triggerHandlers("error", handlerData);
        if ($93ae42c1826927e2$var$_oldOnErrorHandler) return $93ae42c1826927e2$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    $fxVZv.GLOBAL_OBJ.onerror.__SENTRY_INSTRUMENTED__ = true;
}
module.exports.addGlobalErrorInstrumentationHandler = $93ae42c1826927e2$var$addGlobalErrorInstrumentationHandler;

});
parcelRegister("fxVZv", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $b516ebe1b4ef842c$var$GLOBAL_OBJ = globalThis;
module.exports.GLOBAL_OBJ = $b516ebe1b4ef842c$var$GLOBAL_OBJ;

});

parcelRegister("2t0Z7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1GyI0 = parcelRequire("1GyI0");

var $2sm2V = parcelRequire("2sm2V");

var $fIlsR = parcelRequire("fIlsR");
const $1cbf0dc6a5fb43a8$var$handlers = {};
const $1cbf0dc6a5fb43a8$var$instrumented = {};
function $1cbf0dc6a5fb43a8$var$addHandler(type, handler) {
    $1cbf0dc6a5fb43a8$var$handlers[type] = $1cbf0dc6a5fb43a8$var$handlers[type] || [];
    $1cbf0dc6a5fb43a8$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $1cbf0dc6a5fb43a8$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
function $1cbf0dc6a5fb43a8$var$resetInstrumentationHandlers() {
    Object.keys($1cbf0dc6a5fb43a8$var$handlers).forEach((key)=>{
        $1cbf0dc6a5fb43a8$var$handlers[key] = void 0;
    });
}
function $1cbf0dc6a5fb43a8$var$maybeInstrument(type, instrumentFn) {
    if (!$1cbf0dc6a5fb43a8$var$instrumented[type]) {
        $1cbf0dc6a5fb43a8$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            $1GyI0.DEBUG_BUILD && $2sm2V.debug.error(`Error while instrumenting ${type}`, e);
        }
    }
}
function $1cbf0dc6a5fb43a8$var$triggerHandlers(type, data) {
    const typeHandlers = type && $1cbf0dc6a5fb43a8$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${$fIlsR.getFunctionName(handler)}
Error:`, e);
    }
}
module.exports.addHandler = $1cbf0dc6a5fb43a8$var$addHandler;
module.exports.maybeInstrument = $1cbf0dc6a5fb43a8$var$maybeInstrument;
module.exports.resetInstrumentationHandlers = $1cbf0dc6a5fb43a8$var$resetInstrumentationHandlers;
module.exports.triggerHandlers = $1cbf0dc6a5fb43a8$var$triggerHandlers;

});
parcelRegister("2sm2V", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lyqaT = parcelRequire("lyqaT");

var $1GyI0 = parcelRequire("1GyI0");

var $fxVZv = parcelRequire("fxVZv");
const $1c9f4c381a580b98$var$CONSOLE_LEVELS = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
const $1c9f4c381a580b98$var$PREFIX = "Sentry Logger ";
const $1c9f4c381a580b98$var$originalConsoleMethods = {};
function $1c9f4c381a580b98$var$consoleSandbox(callback) {
    if (!("console" in $fxVZv.GLOBAL_OBJ)) return callback();
    const console = $fxVZv.GLOBAL_OBJ.console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($1c9f4c381a580b98$var$originalConsoleMethods);
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $1c9f4c381a580b98$var$originalConsoleMethods[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $1c9f4c381a580b98$var$enable() {
    $1c9f4c381a580b98$var$_getLoggerSettings().enabled = true;
}
function $1c9f4c381a580b98$var$disable() {
    $1c9f4c381a580b98$var$_getLoggerSettings().enabled = false;
}
function $1c9f4c381a580b98$var$isEnabled() {
    return $1c9f4c381a580b98$var$_getLoggerSettings().enabled;
}
function $1c9f4c381a580b98$var$log(...args) {
    $1c9f4c381a580b98$var$_maybeLog("log", ...args);
}
function $1c9f4c381a580b98$var$warn(...args) {
    $1c9f4c381a580b98$var$_maybeLog("warn", ...args);
}
function $1c9f4c381a580b98$var$error(...args) {
    $1c9f4c381a580b98$var$_maybeLog("error", ...args);
}
function $1c9f4c381a580b98$var$_maybeLog(level, ...args) {
    if (!$1GyI0.DEBUG_BUILD) return;
    if ($1c9f4c381a580b98$var$isEnabled()) $1c9f4c381a580b98$var$consoleSandbox(()=>{
        $fxVZv.GLOBAL_OBJ.console[level](`${$1c9f4c381a580b98$var$PREFIX}[${level}]:`, ...args);
    });
}
function $1c9f4c381a580b98$var$_getLoggerSettings() {
    if (!$1GyI0.DEBUG_BUILD) return {
        enabled: false
    };
    return $lyqaT.getGlobalSingleton("loggerSettings", ()=>({
            enabled: false
        }));
}
const $1c9f4c381a580b98$var$debug = {
    enable: /** Enable logging. */ $1c9f4c381a580b98$var$enable,
    disable: /** Disable logging. */ $1c9f4c381a580b98$var$disable,
    isEnabled: /** Check if logging is enabled. */ $1c9f4c381a580b98$var$isEnabled,
    log: /** Log a message. */ $1c9f4c381a580b98$var$log,
    warn: /** Log a warning. */ $1c9f4c381a580b98$var$warn,
    error: /** Log an error. */ $1c9f4c381a580b98$var$error
};
module.exports.CONSOLE_LEVELS = $1c9f4c381a580b98$var$CONSOLE_LEVELS;
module.exports.consoleSandbox = $1c9f4c381a580b98$var$consoleSandbox;
module.exports.debug = $1c9f4c381a580b98$var$debug;
module.exports.originalConsoleMethods = $1c9f4c381a580b98$var$originalConsoleMethods;

});
parcelRegister("lyqaT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jvpRD = parcelRequire("jvpRD");

var $fxVZv = parcelRequire("fxVZv");
function $fb1113ac602f4892$var$getMainCarrier() {
    $fb1113ac602f4892$var$getSentryCarrier($fxVZv.GLOBAL_OBJ);
    return $fxVZv.GLOBAL_OBJ;
}
function $fb1113ac602f4892$var$getSentryCarrier(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.version = __SENTRY__.version || $jvpRD.SDK_VERSION;
    return __SENTRY__[$jvpRD.SDK_VERSION] = __SENTRY__[$jvpRD.SDK_VERSION] || {};
}
function $fb1113ac602f4892$var$getGlobalSingleton(name, creator, obj = $fxVZv.GLOBAL_OBJ) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[$jvpRD.SDK_VERSION] = __SENTRY__[$jvpRD.SDK_VERSION] || {};
    return carrier[name] || (carrier[name] = creator());
}
module.exports.getGlobalSingleton = $fb1113ac602f4892$var$getGlobalSingleton;
module.exports.getMainCarrier = $fb1113ac602f4892$var$getMainCarrier;
module.exports.getSentryCarrier = $fb1113ac602f4892$var$getSentryCarrier;

});
parcelRegister("jvpRD", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $e334f9a362646210$var$SDK_VERSION = "10.75.1";
module.exports.SDK_VERSION = $e334f9a362646210$var$SDK_VERSION;

});



parcelRegister("fIlsR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $b70b9d7d5c2c98ef$var$STACKTRACE_FRAME_LIMIT = 50;
const $b70b9d7d5c2c98ef$var$UNKNOWN_FUNCTION = "?";
const $b70b9d7d5c2c98ef$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $b70b9d7d5c2c98ef$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function $b70b9d7d5c2c98ef$var$createStackParser(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            if (line.length > 1024) line = line.slice(0, 1024);
            const cleanedLine = $b70b9d7d5c2c98ef$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($b70b9d7d5c2c98ef$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $b70b9d7d5c2c98ef$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $b70b9d7d5c2c98ef$var$stripSentryFramesAndReverse(frames.slice(framesToPop));
    };
}
function $b70b9d7d5c2c98ef$var$stackParserFromStackParserOptions(stackParser) {
    if (Array.isArray(stackParser)) return $b70b9d7d5c2c98ef$var$createStackParser(...stackParser);
    return stackParser;
}
function $b70b9d7d5c2c98ef$var$stripSentryFramesAndReverse(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    if (/sentryWrapped/.test($b70b9d7d5c2c98ef$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    localStack.reverse();
    if ($b70b9d7d5c2c98ef$var$STRIP_FRAME_REGEXP.test($b70b9d7d5c2c98ef$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        if ($b70b9d7d5c2c98ef$var$STRIP_FRAME_REGEXP.test($b70b9d7d5c2c98ef$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $b70b9d7d5c2c98ef$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $b70b9d7d5c2c98ef$var$getLastStackFrame(localStack).filename,
            function: frame.function || $b70b9d7d5c2c98ef$var$UNKNOWN_FUNCTION
        }));
}
function $b70b9d7d5c2c98ef$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $b70b9d7d5c2c98ef$var$defaultFunctionName = "<anonymous>";
function $b70b9d7d5c2c98ef$var$getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== "function") return $b70b9d7d5c2c98ef$var$defaultFunctionName;
        return fn.name || $b70b9d7d5c2c98ef$var$defaultFunctionName;
    } catch  {
        return $b70b9d7d5c2c98ef$var$defaultFunctionName;
    }
}
function $b70b9d7d5c2c98ef$var$getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            exception.values.forEach((value)=>{
                if (value.stacktrace.frames) frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return void 0;
        }
    }
    return void 0;
}
function $b70b9d7d5c2c98ef$var$normalizeStackTracePath(path) {
    let filename = path?.startsWith("file://") ? path.slice(7) : path;
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}
module.exports.UNKNOWN_FUNCTION = $b70b9d7d5c2c98ef$var$UNKNOWN_FUNCTION;
module.exports.createStackParser = $b70b9d7d5c2c98ef$var$createStackParser;
module.exports.getFramesFromEvent = $b70b9d7d5c2c98ef$var$getFramesFromEvent;
module.exports.getFunctionName = $b70b9d7d5c2c98ef$var$getFunctionName;
module.exports.normalizeStackTracePath = $b70b9d7d5c2c98ef$var$normalizeStackTracePath;
module.exports.stackParserFromStackParserOptions = $b70b9d7d5c2c98ef$var$stackParserFromStackParserOptions;
module.exports.stripSentryFramesAndReverse = $b70b9d7d5c2c98ef$var$stripSentryFramesAndReverse;

});



parcelRegister("4LBZA", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fxVZv = parcelRequire("fxVZv");

var $2t0Z7 = parcelRequire("2t0Z7");
let $378905b32cebefc1$var$_oldOnUnhandledRejectionHandler = null;
function $378905b32cebefc1$var$addGlobalUnhandledRejectionInstrumentationHandler(handler) {
    const type = "unhandledrejection";
    $2t0Z7.addHandler(type, handler);
    $2t0Z7.maybeInstrument(type, $378905b32cebefc1$var$instrumentUnhandledRejection);
}
function $378905b32cebefc1$var$instrumentUnhandledRejection() {
    $378905b32cebefc1$var$_oldOnUnhandledRejectionHandler = $fxVZv.GLOBAL_OBJ.onunhandledrejection;
    $fxVZv.GLOBAL_OBJ.onunhandledrejection = function(e) {
        const handlerData = e;
        $2t0Z7.triggerHandlers("unhandledrejection", handlerData);
        if ($378905b32cebefc1$var$_oldOnUnhandledRejectionHandler) return $378905b32cebefc1$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    $fxVZv.GLOBAL_OBJ.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}
module.exports.addGlobalUnhandledRejectionInstrumentationHandler = $378905b32cebefc1$var$addGlobalUnhandledRejectionInstrumentationHandler;

});

parcelRegister("8hCvI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $e3FcP = parcelRequire("e3FcP");

var $ary0D = parcelRequire("ary0D");

var $lyqaT = parcelRequire("lyqaT");

var $kfJmY = parcelRequire("kfJmY");

var $2JysJ = parcelRequire("2JysJ");

var $d33W7 = parcelRequire("d33W7");

var $5K3ZQ = parcelRequire("5K3ZQ");

var $65lWX = parcelRequire("65lWX");

var $23smo = parcelRequire("23smo");

var $gU6V8 = parcelRequire("gU6V8");

var $bTcEr = parcelRequire("bTcEr");

var $2sm2V = parcelRequire("2sm2V");

var $3zGA3 = parcelRequire("3zGA3");
const $607dc8a6e47d8596$var$TRACE_FLAG_NONE = 0;
const $607dc8a6e47d8596$var$TRACE_FLAG_SAMPLED = 1;
let $607dc8a6e47d8596$var$hasShownSpanDropWarning = false;
function $607dc8a6e47d8596$var$spanToTransactionTraceContext(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $607dc8a6e47d8596$var$spanToJSON(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
function $607dc8a6e47d8596$var$spanToTraceContext(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    const parent_span_id = isRemote ? spanId : $607dc8a6e47d8596$var$spanToJSON(span).parent_span_id;
    const scope = $5K3ZQ.getCapturedScopesOnSpan(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || $23smo.generateSpanId() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
function $607dc8a6e47d8596$var$spanToTraceHeader(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $607dc8a6e47d8596$var$spanIsSampled(span);
    return $bTcEr.generateSentryTraceHeader(traceId, spanId, sampled);
}
function $607dc8a6e47d8596$var$spanToTraceparentHeader(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $607dc8a6e47d8596$var$spanIsSampled(span);
    return $bTcEr.generateTraceparentHeader(traceId, spanId, sampled);
}
function $607dc8a6e47d8596$var$convertSpanLinksForEnvelope(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $607dc8a6e47d8596$var$TRACE_FLAG_SAMPLED,
            attributes: attributes,
            ...restContext
        }));
    else return void 0;
}
function $607dc8a6e47d8596$var$getStreamedSpanLinks(links) {
    if (links?.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $607dc8a6e47d8596$var$TRACE_FLAG_SAMPLED,
            attributes: attributes
        }));
    else return void 0;
}
function $607dc8a6e47d8596$var$spanTimeInputToSeconds(input) {
    if (typeof input === "number") return $607dc8a6e47d8596$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $607dc8a6e47d8596$var$ensureTimestampInSeconds(input.getTime());
    return $gU6V8.timestampInSeconds();
}
function $607dc8a6e47d8596$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $607dc8a6e47d8596$var$spanToJSON(span) {
    if ($607dc8a6e47d8596$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($607dc8a6e47d8596$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $607dc8a6e47d8596$var$getOtelParentSpanId(span),
            start_timestamp: $607dc8a6e47d8596$var$spanTimeInputToSeconds(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $607dc8a6e47d8596$var$spanTimeInputToSeconds(endTime) || void 0,
            status: $607dc8a6e47d8596$var$getStatusMessage(status),
            op: attributes[$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: $607dc8a6e47d8596$var$convertSpanLinksForEnvelope(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $607dc8a6e47d8596$var$spanToStreamedSpanJSON(span) {
    if ($607dc8a6e47d8596$var$spanIsSentrySpan(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($607dc8a6e47d8596$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $607dc8a6e47d8596$var$getOtelParentSpanId(span),
            start_timestamp: $607dc8a6e47d8596$var$spanTimeInputToSeconds(startTime),
            end_timestamp: $607dc8a6e47d8596$var$spanTimeInputToSeconds(endTime),
            is_segment: span === $607dc8a6e47d8596$var$INTERNAL_getSegmentSpan(span),
            status: $607dc8a6e47d8596$var$getSimpleStatus(status),
            attributes: $607dc8a6e47d8596$var$addStatusMessageAttribute(attributes, status),
            links: $607dc8a6e47d8596$var$getStreamedSpanLinks(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: "",
        end_timestamp: 0,
        status: "ok",
        is_segment: span === $607dc8a6e47d8596$var$INTERNAL_getSegmentSpan(span)
    };
}
function $607dc8a6e47d8596$var$getOtelParentSpanId(span) {
    return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? span.parentSpanContext?.spanId : void 0;
}
function $607dc8a6e47d8596$var$streamedSpanJsonToSerializedSpan(spanJson) {
    return {
        ...spanJson,
        attributes: $ary0D.serializeAttributes(spanJson.attributes),
        links: spanJson.links?.map((link)=>({
                ...link,
                attributes: $ary0D.serializeAttributes(link.attributes)
            }))
    };
}
function $607dc8a6e47d8596$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
function $607dc8a6e47d8596$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
function $607dc8a6e47d8596$var$spanIsSampled(span) {
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $607dc8a6e47d8596$var$TRACE_FLAG_SAMPLED;
}
function $607dc8a6e47d8596$var$getStatusMessage(status) {
    if (!status || status.code === $d33W7.SPAN_STATUS_UNSET) return void 0;
    if (status.code === $d33W7.SPAN_STATUS_OK) return "ok";
    return status.message || "internal_error";
}
function $607dc8a6e47d8596$var$getSimpleStatus(status) {
    return !status || status.code === $d33W7.SPAN_STATUS_OK || status.code === $d33W7.SPAN_STATUS_UNSET || status.message === "cancelled" ? "ok" : "error";
}
function $607dc8a6e47d8596$var$addStatusMessageAttribute(attributes, status) {
    const statusMessage = $607dc8a6e47d8596$var$getSimpleStatus(status) === "error" ? status?.message : void 0;
    return {
        ...statusMessage && {
            [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE]: statusMessage
        },
        ...attributes
    };
}
const $607dc8a6e47d8596$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $607dc8a6e47d8596$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
function $607dc8a6e47d8596$var$addChildSpanToSpan(span, childSpan) {
    const rootSpan = span[$607dc8a6e47d8596$var$ROOT_SPAN_FIELD] || span;
    $65lWX.addNonEnumerableProperty(childSpan, $607dc8a6e47d8596$var$ROOT_SPAN_FIELD, rootSpan);
    if (!$607dc8a6e47d8596$var$spanIsSampled(span)) return;
    if (!span.isRecording() && !rootSpan.isRecording()) return;
    if (span[$607dc8a6e47d8596$var$CHILD_SPANS_FIELD]) span[$607dc8a6e47d8596$var$CHILD_SPANS_FIELD].add(childSpan);
    else $65lWX.addNonEnumerableProperty(span, $607dc8a6e47d8596$var$CHILD_SPANS_FIELD, /* @__PURE__ */ new Set([
        childSpan
    ]));
}
function $607dc8a6e47d8596$var$removeChildSpanFromSpan(span, childSpan) {
    if (span[$607dc8a6e47d8596$var$CHILD_SPANS_FIELD]) span[$607dc8a6e47d8596$var$CHILD_SPANS_FIELD].delete(childSpan);
}
function $607dc8a6e47d8596$var$getSpanDescendants(span) {
    const resultSet = /* @__PURE__ */ new Set();
    function addSpanChildren(span2) {
        if (resultSet.has(span2)) return;
        else if ($607dc8a6e47d8596$var$spanIsSampled(span2)) {
            resultSet.add(span2);
            const childSpans = span2[$607dc8a6e47d8596$var$CHILD_SPANS_FIELD] ? Array.from(span2[$607dc8a6e47d8596$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
const $607dc8a6e47d8596$var$getRootSpan = $607dc8a6e47d8596$var$INTERNAL_getSegmentSpan;
function $607dc8a6e47d8596$var$INTERNAL_getSegmentSpan(span) {
    return span[$607dc8a6e47d8596$var$ROOT_SPAN_FIELD] || span;
}
function $607dc8a6e47d8596$var$getActiveSpan() {
    const carrier$1 = $lyqaT.getMainCarrier();
    const acs = $e3FcP.getAsyncContextStrategy(carrier$1);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return $3zGA3._getSpanForScope($kfJmY.getCurrentScope());
}
function $607dc8a6e47d8596$var$showSpanDropWarning() {
    if (!$607dc8a6e47d8596$var$hasShownSpanDropWarning) {
        $2sm2V.consoleSandbox(()=>{
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.");
        });
        $607dc8a6e47d8596$var$hasShownSpanDropWarning = true;
    }
}
function $607dc8a6e47d8596$var$updateSpanName(span, name) {
    span.updateName(name);
    span.setAttributes({
        [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "custom",
        [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME]: name
    });
}
module.exports.INTERNAL_getSegmentSpan = $607dc8a6e47d8596$var$INTERNAL_getSegmentSpan;
module.exports.TRACE_FLAG_NONE = $607dc8a6e47d8596$var$TRACE_FLAG_NONE;
module.exports.TRACE_FLAG_SAMPLED = $607dc8a6e47d8596$var$TRACE_FLAG_SAMPLED;
module.exports.addChildSpanToSpan = $607dc8a6e47d8596$var$addChildSpanToSpan;
module.exports.addStatusMessageAttribute = $607dc8a6e47d8596$var$addStatusMessageAttribute;
module.exports.convertSpanLinksForEnvelope = $607dc8a6e47d8596$var$convertSpanLinksForEnvelope;
module.exports.getActiveSpan = $607dc8a6e47d8596$var$getActiveSpan;
module.exports.getRootSpan = $607dc8a6e47d8596$var$getRootSpan;
module.exports.getSimpleStatus = $607dc8a6e47d8596$var$getSimpleStatus;
module.exports.getSpanDescendants = $607dc8a6e47d8596$var$getSpanDescendants;
module.exports.getStatusMessage = $607dc8a6e47d8596$var$getStatusMessage;
module.exports.getStreamedSpanLinks = $607dc8a6e47d8596$var$getStreamedSpanLinks;
module.exports.removeChildSpanFromSpan = $607dc8a6e47d8596$var$removeChildSpanFromSpan;
module.exports.showSpanDropWarning = $607dc8a6e47d8596$var$showSpanDropWarning;
module.exports.spanIsSampled = $607dc8a6e47d8596$var$spanIsSampled;
module.exports.spanIsSentrySpan = $607dc8a6e47d8596$var$spanIsSentrySpan;
module.exports.spanTimeInputToSeconds = $607dc8a6e47d8596$var$spanTimeInputToSeconds;
module.exports.spanToJSON = $607dc8a6e47d8596$var$spanToJSON;
module.exports.spanToStreamedSpanJSON = $607dc8a6e47d8596$var$spanToStreamedSpanJSON;
module.exports.spanToTraceContext = $607dc8a6e47d8596$var$spanToTraceContext;
module.exports.spanToTraceHeader = $607dc8a6e47d8596$var$spanToTraceHeader;
module.exports.spanToTraceparentHeader = $607dc8a6e47d8596$var$spanToTraceparentHeader;
module.exports.spanToTransactionTraceContext = $607dc8a6e47d8596$var$spanToTransactionTraceContext;
module.exports.streamedSpanJsonToSerializedSpan = $607dc8a6e47d8596$var$streamedSpanJsonToSerializedSpan;
module.exports.updateSpanName = $607dc8a6e47d8596$var$updateSpanName;

});
parcelRegister("e3FcP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lyqaT = parcelRequire("lyqaT");

var $l0AFa = parcelRequire("l0AFa");
function $a3c14f21f503daa1$var$setAsyncContextStrategy(strategy) {
    const registry = $lyqaT.getMainCarrier();
    const sentry = $lyqaT.getSentryCarrier(registry);
    sentry.acs = strategy;
}
function $a3c14f21f503daa1$var$getAsyncContextStrategy(carrier$1) {
    const sentry = $lyqaT.getSentryCarrier(carrier$1);
    if (sentry.acs) return sentry.acs;
    return $l0AFa.getStackAsyncContextStrategy();
}
module.exports.getAsyncContextStrategy = $a3c14f21f503daa1$var$getAsyncContextStrategy;
module.exports.setAsyncContextStrategy = $a3c14f21f503daa1$var$setAsyncContextStrategy;

});
parcelRegister("l0AFa", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lln5F = parcelRequire("lln5F");

var $aBj8W = parcelRequire("aBj8W");

var $fK9TE = parcelRequire("fK9TE");

var $jV7hg = parcelRequire("jV7hg");

var $lyqaT = parcelRequire("lyqaT");
class $f4b609975f0c2f26$var$AsyncContextStack {
    constructor(scope$1, isolationScope){
        let assignedScope;
        if (!scope$1) assignedScope = new $aBj8W.Scope();
        else assignedScope = scope$1;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new $aBj8W.Scope();
        else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ($jV7hg.isThenable(maybePromiseResult)) return $fK9TE.chainAndCopyPromiseLike(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
function $f4b609975f0c2f26$var$getAsyncContextStack() {
    const registry = $lyqaT.getMainCarrier();
    const sentry = $lyqaT.getSentryCarrier(registry);
    return sentry.stack = sentry.stack || new $f4b609975f0c2f26$var$AsyncContextStack($lln5F.getDefaultCurrentScope(), $lln5F.getDefaultIsolationScope());
}
function $f4b609975f0c2f26$var$withScope(callback) {
    return $f4b609975f0c2f26$var$getAsyncContextStack().withScope(callback);
}
function $f4b609975f0c2f26$var$withSetScope(scope, callback) {
    const stack = $f4b609975f0c2f26$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $f4b609975f0c2f26$var$withIsolationScope(callback) {
    return $f4b609975f0c2f26$var$getAsyncContextStack().withScope(()=>{
        return callback($f4b609975f0c2f26$var$getAsyncContextStack().getIsolationScope());
    });
}
function $f4b609975f0c2f26$var$getStackAsyncContextStrategy() {
    return {
        withIsolationScope: $f4b609975f0c2f26$var$withIsolationScope,
        withScope: $f4b609975f0c2f26$var$withScope,
        withSetScope: $f4b609975f0c2f26$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $f4b609975f0c2f26$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$f4b609975f0c2f26$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$f4b609975f0c2f26$var$getAsyncContextStack().getIsolationScope()
    };
}
module.exports.AsyncContextStack = $f4b609975f0c2f26$var$AsyncContextStack;
module.exports.getStackAsyncContextStrategy = $f4b609975f0c2f26$var$getStackAsyncContextStrategy;

});
parcelRegister("lln5F", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lyqaT = parcelRequire("lyqaT");

var $aBj8W = parcelRequire("aBj8W");
function $f89d786e258527f9$var$getDefaultCurrentScope() {
    return $lyqaT.getGlobalSingleton("defaultCurrentScope", ()=>new $aBj8W.Scope());
}
function $f89d786e258527f9$var$getDefaultIsolationScope() {
    return $lyqaT.getGlobalSingleton("defaultIsolationScope", ()=>new $aBj8W.Scope());
}
module.exports.getDefaultCurrentScope = $f89d786e258527f9$var$getDefaultCurrentScope;
module.exports.getDefaultIsolationScope = $f89d786e258527f9$var$getDefaultIsolationScope;

});
parcelRegister("aBj8W", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1GyI0 = parcelRequire("1GyI0");

var $3uEjM = parcelRequire("3uEjM");

var $2sm2V = parcelRequire("2sm2V");

var $jV7hg = parcelRequire("jV7hg");

var $aupof = parcelRequire("aupof");

var $jR1Dv = parcelRequire("jR1Dv");

var $23smo = parcelRequire("23smo");

var $6ki8f = parcelRequire("6ki8f");

var $3zGA3 = parcelRequire("3zGA3");

var $1L2sM = parcelRequire("1L2sM");

var $gU6V8 = parcelRequire("gU6V8");
const $7b7c3588d35b1274$var$DEFAULT_MAX_BREADCRUMBS = 100;
class $7b7c3588d35b1274$var$Scope {
    // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: $23smo.generateTraceId(),
            sampleRand: $6ki8f.safeMathRandom()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $7b7c3588d35b1274$var$Scope();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        $3zGA3._setSpanForScope(newScope, $3zGA3._getSpanForScope(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        this._user = user || {
            email: void 0,
            id: void 0,
            ip_address: void 0,
            username: void 0
        };
        if (this._session) $3uEjM.updateSession(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || void 0;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param newAttributes - The attributes to set on the scope, as key-value pairs.
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: 150,
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param key - The attribute key.
   * @param value - The attribute value.
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', 150);
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $7b7c3588d35b1274$var$Scope ? scopeToMerge.getScopeData() : $jV7hg.isPlainObject(scopeToMerge) ? captureContext : void 0;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   *
   * @deprecated This method will be removed in v11. To reset scope state, re-initialize the SDK or run
   * your code in a fresh scope via `withScope` instead.
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = void 0;
        this._transactionName = void 0;
        this._fingerprint = void 0;
        this._session = void 0;
        this._conversationId = void 0;
        $3zGA3._setSpanForScope(this, void 0);
        this._attachments = [];
        this.setPropagationContext({
            traceId: $23smo.generateTraceId(),
            sampleRand: $6ki8f.safeMathRandom()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $7b7c3588d35b1274$var$DEFAULT_MAX_BREADCRUMBS;
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: $gU6V8.dateTimestampInSeconds(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? $1L2sM.truncate(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: $3zGA3._getSpanForScope(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = $aupof.merge(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || $jR1Dv.uuid4();
        if (!this._client) {
            $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || $jR1Dv.uuid4();
        if (!this._client) {
            $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || $jR1Dv.uuid4();
        if (!this._client) {
            $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
module.exports.Scope = $7b7c3588d35b1274$var$Scope;

});
parcelRegister("3uEjM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jR1Dv = parcelRequire("jR1Dv");

var $gU6V8 = parcelRequire("gU6V8");
function $28b372c71d362fbd$var$makeSession(context) {
    const startingTime = $gU6V8.timestampInSeconds();
    const session = {
        sid: $jR1Dv.uuid4(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$28b372c71d362fbd$var$sessionToJSON(session)
    };
    if (context) $28b372c71d362fbd$var$updateSession(session, context);
    return session;
}
function $28b372c71d362fbd$var$updateSession(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || $gU6V8.timestampInSeconds();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) session.sid = context.sid.length === 32 ? context.sid : $jR1Dv.uuid4();
    if (context.init !== void 0) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = void 0;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
function $28b372c71d362fbd$var$closeSession(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $28b372c71d362fbd$var$updateSession(session, context);
}
function $28b372c71d362fbd$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1e3).toISOString(),
        timestamp: new Date(session.timestamp * 1e3).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}
module.exports.closeSession = $28b372c71d362fbd$var$closeSession;
module.exports.makeSession = $28b372c71d362fbd$var$makeSession;
module.exports.updateSession = $28b372c71d362fbd$var$updateSession;

});
parcelRegister("jR1Dv", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $65lWX = parcelRequire("65lWX");

var $6ki8f = parcelRequire("6ki8f");

var $1L2sM = parcelRequire("1L2sM");

var $fxVZv = parcelRequire("fxVZv");
function $e7443c78457d9d51$var$getCrypto() {
    const gbl = $fxVZv.GLOBAL_OBJ;
    return gbl.crypto || gbl.msCrypto;
}
let $e7443c78457d9d51$var$emptyUuid;
function $e7443c78457d9d51$var$getRandomByte() {
    return $6ki8f.safeMathRandom() * 16;
}
function $e7443c78457d9d51$var$uuid4(crypto = $e7443c78457d9d51$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) return $6ki8f.withRandomSafeContext(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch  {}
    if (!$e7443c78457d9d51$var$emptyUuid) $e7443c78457d9d51$var$emptyUuid = "10000000100040008000100000000000";
    return $e7443c78457d9d51$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($e7443c78457d9d51$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $e7443c78457d9d51$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
function $e7443c78457d9d51$var$getEventDescription(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $e7443c78457d9d51$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $e7443c78457d9d51$var$addExceptionTypeValue(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $e7443c78457d9d51$var$addExceptionMechanism(event, newMechanism) {
    const firstException = $e7443c78457d9d51$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
const $e7443c78457d9d51$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $e7443c78457d9d51$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
function $e7443c78457d9d51$var$parseSemver(input) {
    const match = input.match($e7443c78457d9d51$var$SEMVER_REGEXP) || [];
    const major = $e7443c78457d9d51$var$_parseInt(match[1]);
    const minor = $e7443c78457d9d51$var$_parseInt(match[2]);
    const patch = $e7443c78457d9d51$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? void 0 : major,
        minor: isNaN(minor) ? void 0 : minor,
        patch: isNaN(patch) ? void 0 : patch,
        prerelease: match[4]
    };
}
function $e7443c78457d9d51$var$addContextToFrame(lines, frame, linesOfContext = 5) {
    if (frame.lineno === void 0) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>$1L2sM.snipLine(line, 0));
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    frame.context_line = $1L2sM.snipLine(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>$1L2sM.snipLine(line, 0));
}
function $e7443c78457d9d51$var$checkOrSetAlreadyCaught(exception) {
    if ($e7443c78457d9d51$var$isAlreadyCaptured(exception)) return true;
    try {
        $65lWX.addNonEnumerableProperty(exception, "__sentry_captured__", true);
    } catch  {}
    return false;
}
function $e7443c78457d9d51$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {}
}
module.exports.addContextToFrame = $e7443c78457d9d51$var$addContextToFrame;
module.exports.addExceptionMechanism = $e7443c78457d9d51$var$addExceptionMechanism;
module.exports.addExceptionTypeValue = $e7443c78457d9d51$var$addExceptionTypeValue;
module.exports.checkOrSetAlreadyCaught = $e7443c78457d9d51$var$checkOrSetAlreadyCaught;
module.exports.getEventDescription = $e7443c78457d9d51$var$getEventDescription;
module.exports.isAlreadyCaptured = $e7443c78457d9d51$var$isAlreadyCaptured;
module.exports.parseSemver = $e7443c78457d9d51$var$parseSemver;
module.exports.uuid4 = $e7443c78457d9d51$var$uuid4;

});
parcelRegister("65lWX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1GyI0 = parcelRequire("1GyI0");

var $2sm2V = parcelRequire("2sm2V");

var $jV7hg = parcelRequire("jV7hg");
function $46e43c81015db474$var$fill(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    if (typeof wrapped === "function") $46e43c81015db474$var$markFunctionWrapped(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.log(`Failed to replace method "${name}" in object`, source);
    }
}
function $46e43c81015db474$var$addNonEnumerableProperty(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
function $46e43c81015db474$var$markFunctionWrapped(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $46e43c81015db474$var$addNonEnumerableProperty(wrapped, "__sentry_original__", original);
    } catch  {}
}
function $46e43c81015db474$var$wrapMethod(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($46e43c81015db474$var$getOriginalFunction(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $46e43c81015db474$var$markFunctionWrapped(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
function $46e43c81015db474$var$getOriginalFunction(func) {
    return func.__sentry_original__;
}
function $46e43c81015db474$var$convertToPlainObject(value) {
    if ($jV7hg.isError(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$46e43c81015db474$var$getOwnProperties(value)
    };
    if ($jV7hg.isEvent(value)) {
        const { type: type, target: target, currentTarget: currentTarget, detail: detail } = value;
        return {
            type: type,
            target: target,
            currentTarget: currentTarget,
            ...detail ? {
                detail: detail
            } : {},
            ...$46e43c81015db474$var$getOwnProperties(value)
        };
    }
    return value;
}
function $46e43c81015db474$var$getOwnProperties(obj) {
    if ($jV7hg.isObjectLike(obj)) return Object.fromEntries(Object.entries(obj));
    return {};
}
function $46e43c81015db474$var$extractExceptionKeysForMessage(exception) {
    const keys = Object.keys($46e43c81015db474$var$convertToPlainObject(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function $46e43c81015db474$var$dropUndefinedKeys(inputValue) {
    const memoizationMap = /* @__PURE__ */ new Map();
    return $46e43c81015db474$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $46e43c81015db474$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) return memoVal;
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($46e43c81015db474$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($46e43c81015db474$var$isPojo(inputValue)) {
        const returnValue = {};
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== void 0) returnValue[key] = $46e43c81015db474$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    return inputValue;
}
function $46e43c81015db474$var$isPojo(input) {
    const constructor = input.constructor;
    return constructor === Object || constructor === void 0;
}
function $46e43c81015db474$var$objectify(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == void 0:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case $jV7hg.isPrimitive(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
module.exports.addNonEnumerableProperty = $46e43c81015db474$var$addNonEnumerableProperty;
module.exports.convertToPlainObject = $46e43c81015db474$var$convertToPlainObject;
module.exports.dropUndefinedKeys = $46e43c81015db474$var$dropUndefinedKeys;
module.exports.extractExceptionKeysForMessage = $46e43c81015db474$var$extractExceptionKeysForMessage;
module.exports.fill = $46e43c81015db474$var$fill;
module.exports.getOriginalFunction = $46e43c81015db474$var$getOriginalFunction;
module.exports.markFunctionWrapped = $46e43c81015db474$var$markFunctionWrapped;
module.exports.objectify = $46e43c81015db474$var$objectify;
module.exports.wrapMethod = $46e43c81015db474$var$wrapMethod;

});
parcelRegister("jV7hg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $e808fc5bfe6e4f87$var$objectToString = Object.prototype.toString;
function $e808fc5bfe6e4f87$var$isError(wat) {
    switch($e808fc5bfe6e4f87$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $e808fc5bfe6e4f87$var$isInstanceOf(wat, Error);
    }
}
function $e808fc5bfe6e4f87$var$isBuiltin(wat, className) {
    return $e808fc5bfe6e4f87$var$objectToString.call(wat) === `[object ${className}]`;
}
function $e808fc5bfe6e4f87$var$isErrorEvent(wat) {
    return $e808fc5bfe6e4f87$var$isBuiltin(wat, "ErrorEvent");
}
function $e808fc5bfe6e4f87$var$isDOMError(wat) {
    return $e808fc5bfe6e4f87$var$isBuiltin(wat, "DOMError");
}
function $e808fc5bfe6e4f87$var$isDOMException(wat) {
    return $e808fc5bfe6e4f87$var$isBuiltin(wat, "DOMException");
}
function $e808fc5bfe6e4f87$var$isString(wat) {
    return $e808fc5bfe6e4f87$var$isBuiltin(wat, "String");
}
function $e808fc5bfe6e4f87$var$isParameterizedString(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function $e808fc5bfe6e4f87$var$isPrimitive(wat) {
    return wat === null || $e808fc5bfe6e4f87$var$isParameterizedString(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function $e808fc5bfe6e4f87$var$isPlainObject(wat) {
    return $e808fc5bfe6e4f87$var$isBuiltin(wat, "Object");
}
function $e808fc5bfe6e4f87$var$isObjectLike(wat) {
    return typeof wat === "object" && wat !== null;
}
function $e808fc5bfe6e4f87$var$isEvent(wat) {
    return typeof Event !== "undefined" && $e808fc5bfe6e4f87$var$isInstanceOf(wat, Event);
}
function $e808fc5bfe6e4f87$var$isElement(wat) {
    return typeof Element !== "undefined" && $e808fc5bfe6e4f87$var$isInstanceOf(wat, Element);
}
function $e808fc5bfe6e4f87$var$isRegExp(wat) {
    return $e808fc5bfe6e4f87$var$isBuiltin(wat, "RegExp");
}
function $e808fc5bfe6e4f87$var$isThenable(wat) {
    return Boolean(wat?.then && typeof wat.then === "function");
}
function $e808fc5bfe6e4f87$var$isSyntheticEvent(wat) {
    return $e808fc5bfe6e4f87$var$isPlainObject(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $e808fc5bfe6e4f87$var$isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
function $e808fc5bfe6e4f87$var$isVueViewModel(wat) {
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function $e808fc5bfe6e4f87$var$isRequest(request) {
    return typeof Request !== "undefined" && $e808fc5bfe6e4f87$var$isInstanceOf(request, Request);
}
module.exports.isDOMError = $e808fc5bfe6e4f87$var$isDOMError;
module.exports.isDOMException = $e808fc5bfe6e4f87$var$isDOMException;
module.exports.isElement = $e808fc5bfe6e4f87$var$isElement;
module.exports.isError = $e808fc5bfe6e4f87$var$isError;
module.exports.isErrorEvent = $e808fc5bfe6e4f87$var$isErrorEvent;
module.exports.isEvent = $e808fc5bfe6e4f87$var$isEvent;
module.exports.isInstanceOf = $e808fc5bfe6e4f87$var$isInstanceOf;
module.exports.isObjectLike = $e808fc5bfe6e4f87$var$isObjectLike;
module.exports.isParameterizedString = $e808fc5bfe6e4f87$var$isParameterizedString;
module.exports.isPlainObject = $e808fc5bfe6e4f87$var$isPlainObject;
module.exports.isPrimitive = $e808fc5bfe6e4f87$var$isPrimitive;
module.exports.isRegExp = $e808fc5bfe6e4f87$var$isRegExp;
module.exports.isRequest = $e808fc5bfe6e4f87$var$isRequest;
module.exports.isString = $e808fc5bfe6e4f87$var$isString;
module.exports.isSyntheticEvent = $e808fc5bfe6e4f87$var$isSyntheticEvent;
module.exports.isThenable = $e808fc5bfe6e4f87$var$isThenable;
module.exports.isVueViewModel = $e808fc5bfe6e4f87$var$isVueViewModel;

});


parcelRegister("6ki8f", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fxVZv = parcelRequire("fxVZv");
let $49b2acf3d9838c9f$var$RESOLVED_RUNNER;
function $49b2acf3d9838c9f$var$withRandomSafeContext(cb) {
    if ($49b2acf3d9838c9f$var$RESOLVED_RUNNER !== void 0) return $49b2acf3d9838c9f$var$RESOLVED_RUNNER ? $49b2acf3d9838c9f$var$RESOLVED_RUNNER(cb) : cb();
    const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = $fxVZv.GLOBAL_OBJ;
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $49b2acf3d9838c9f$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $49b2acf3d9838c9f$var$RESOLVED_RUNNER(cb);
    }
    $49b2acf3d9838c9f$var$RESOLVED_RUNNER = null;
    return cb();
}
function $49b2acf3d9838c9f$var$safeMathRandom() {
    return $49b2acf3d9838c9f$var$withRandomSafeContext(()=>Math.random());
}
function $49b2acf3d9838c9f$var$safeDateNow() {
    return $49b2acf3d9838c9f$var$withRandomSafeContext(()=>Date.now());
}
module.exports.safeDateNow = $49b2acf3d9838c9f$var$safeDateNow;
module.exports.safeMathRandom = $49b2acf3d9838c9f$var$safeMathRandom;
module.exports.withRandomSafeContext = $49b2acf3d9838c9f$var$withRandomSafeContext;

});

parcelRegister("1L2sM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jV7hg = parcelRequire("jV7hg");

var $2ZrfN = parcelRequire("2ZrfN");
function $147c175f0563bcf5$var$stringify(value, fallback = "[unserializable]") {
    if (typeof value === "string") return value;
    try {
        return JSON.stringify(value);
    } catch  {
        return typeof fallback === "function" ? fallback(value) : fallback;
    }
}
function $147c175f0563bcf5$var$truncate(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function $147c175f0563bcf5$var$snipLine(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $147c175f0563bcf5$var$safeJoin(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if ($jV7hg.isPrimitive(value)) output.push(String(value));
        else if (value instanceof Error) output.push(value.message ? `${value.name}: ${value.message}` : value.name);
        else output.push($2ZrfN.stringifyValue(void 0, value));
    }
    return output.join(delimiter);
}
function $147c175f0563bcf5$var$isMatchingPattern(value, pattern, requireExactStringMatch = false) {
    if (!$jV7hg.isString(value)) return false;
    if ($jV7hg.isRegExp(pattern)) return pattern.test(value);
    if ($jV7hg.isString(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
function $147c175f0563bcf5$var$stringMatchesSomePattern(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($147c175f0563bcf5$var$isMatchingPattern(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}
module.exports.isMatchingPattern = $147c175f0563bcf5$var$isMatchingPattern;
module.exports.safeJoin = $147c175f0563bcf5$var$safeJoin;
module.exports.snipLine = $147c175f0563bcf5$var$snipLine;
module.exports.stringMatchesSomePattern = $147c175f0563bcf5$var$stringMatchesSomePattern;
module.exports.stringify = $147c175f0563bcf5$var$stringify;
module.exports.truncate = $147c175f0563bcf5$var$truncate;

});
parcelRegister("2ZrfN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kCHEV = parcelRequire("kCHEV");

var $65lWX = parcelRequire("65lWX");

var $fIlsR = parcelRequire("fIlsR");
let $22d66b5450f85a94$var$stringifier;
function $22d66b5450f85a94$var$setNormalizeStringifier(newStringifier) {
    $22d66b5450f85a94$var$stringifier = newStringifier;
}
function $22d66b5450f85a94$var$normalize(input, depth = 100, maxProperties = Infinity) {
    try {
        return $22d66b5450f85a94$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
function $22d66b5450f85a94$var$normalizeToSize(object, depth = 3, maxSize = 102400) {
    const normalized = $22d66b5450f85a94$var$normalize(object, depth);
    if ($22d66b5450f85a94$var$jsonSize(normalized) > maxSize) return $22d66b5450f85a94$var$normalizeToSize(object, depth - 1, maxSize);
    return normalized;
}
function $22d66b5450f85a94$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $22d66b5450f85a94$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $22d66b5450f85a94$var$stringifyValue(key, value);
    if (!stringified.startsWith("[object ")) return stringified;
    if ($kCHEV.hasSkipNormalizationHint(value)) return value;
    const overrideDepth = $kCHEV.getNormalizationDepthOverrideHint(value);
    const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
    if (remainingDepth === 0) return stringified.replace("object ", "");
    if (memoize(value)) return "[Circular ~]";
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        return $22d66b5450f85a94$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {}
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    const visitable = $65lWX.convertToPlainObject(value);
    for(const visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $22d66b5450f85a94$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function $22d66b5450f85a94$var$stringifyValue(key, value) {
    try {
        if ($22d66b5450f85a94$var$stringifier) {
            const stringified = $22d66b5450f85a94$var$stringifier(value);
            if (stringified) return stringified;
        }
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${$fIlsR.getFunctionName(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        const objName = $22d66b5450f85a94$var$getConstructorName(value);
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $22d66b5450f85a94$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
function $22d66b5450f85a94$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function $22d66b5450f85a94$var$jsonSize(value) {
    return $22d66b5450f85a94$var$utf8Length(JSON.stringify(value));
}
function $22d66b5450f85a94$var$normalizeUrlToBase(url, basePath) {
    const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {}
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
function $22d66b5450f85a94$var$memoBuilder() {
    const inner = /* @__PURE__ */ new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}
module.exports.normalize = $22d66b5450f85a94$var$normalize;
module.exports.normalizeToSize = $22d66b5450f85a94$var$normalizeToSize;
module.exports.normalizeUrlToBase = $22d66b5450f85a94$var$normalizeUrlToBase;
module.exports.setNormalizeStringifier = $22d66b5450f85a94$var$setNormalizeStringifier;
module.exports.stringifyValue = $22d66b5450f85a94$var$stringifyValue;

});
parcelRegister("kCHEV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $65lWX = parcelRequire("65lWX");
const $f039390dcb3daffc$var$SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const $f039390dcb3daffc$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function $f039390dcb3daffc$var$setSkipNormalizationHint(obj) {
    $65lWX.addNonEnumerableProperty(obj, $f039390dcb3daffc$var$SENTRY_SKIP_NORMALIZATION, true);
}
function $f039390dcb3daffc$var$setNormalizationDepthOverrideHint(obj, depth) {
    $65lWX.addNonEnumerableProperty(obj, $f039390dcb3daffc$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function $f039390dcb3daffc$var$hasSkipNormalizationHint(value) {
    return Boolean(value[$f039390dcb3daffc$var$SENTRY_SKIP_NORMALIZATION]);
}
function $f039390dcb3daffc$var$getNormalizationDepthOverrideHint(value) {
    const v = value[$f039390dcb3daffc$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : void 0;
}
module.exports.getNormalizationDepthOverrideHint = $f039390dcb3daffc$var$getNormalizationDepthOverrideHint;
module.exports.hasSkipNormalizationHint = $f039390dcb3daffc$var$hasSkipNormalizationHint;
module.exports.setNormalizationDepthOverrideHint = $f039390dcb3daffc$var$setNormalizationDepthOverrideHint;
module.exports.setSkipNormalizationHint = $f039390dcb3daffc$var$setSkipNormalizationHint;

});




parcelRegister("gU6V8", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6ki8f = parcelRequire("6ki8f");

var $fxVZv = parcelRequire("fxVZv");
const $c4e73e94eef79ff4$var$ONE_SECOND_IN_MS = 1e3;
function $c4e73e94eef79ff4$var$dateTimestampInSeconds() {
    return $6ki8f.safeDateNow() / $c4e73e94eef79ff4$var$ONE_SECOND_IN_MS;
}
function $c4e73e94eef79ff4$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = $fxVZv.GLOBAL_OBJ;
    if (!performance?.now || !performance.timeOrigin) return $c4e73e94eef79ff4$var$dateTimestampInSeconds;
    const timeOrigin = performance.timeOrigin;
    return ()=>{
        return (timeOrigin + $6ki8f.withRandomSafeContext(()=>performance.now())) / $c4e73e94eef79ff4$var$ONE_SECOND_IN_MS;
    };
}
let $c4e73e94eef79ff4$var$_cachedTimestampInSeconds;
function $c4e73e94eef79ff4$var$timestampInSeconds() {
    const func = $c4e73e94eef79ff4$var$_cachedTimestampInSeconds ?? ($c4e73e94eef79ff4$var$_cachedTimestampInSeconds = $c4e73e94eef79ff4$var$createUnixTimestampInSecondsFunc());
    return func();
}
let $c4e73e94eef79ff4$var$cachedTimeOrigin = null;
function $c4e73e94eef79ff4$var$getBrowserTimeOrigin() {
    const { performance: performance } = $fxVZv.GLOBAL_OBJ;
    if (!performance?.now) return void 0;
    const threshold = 3e5;
    const performanceNow = $6ki8f.withRandomSafeContext(()=>performance.now());
    const dateNow = $6ki8f.safeDateNow();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === "number") {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    return dateNow - performanceNow;
}
function $c4e73e94eef79ff4$var$browserPerformanceTimeOrigin() {
    if ($c4e73e94eef79ff4$var$cachedTimeOrigin === null) $c4e73e94eef79ff4$var$cachedTimeOrigin = $c4e73e94eef79ff4$var$getBrowserTimeOrigin();
    return $c4e73e94eef79ff4$var$cachedTimeOrigin;
}
module.exports.browserPerformanceTimeOrigin = $c4e73e94eef79ff4$var$browserPerformanceTimeOrigin;
module.exports.dateTimestampInSeconds = $c4e73e94eef79ff4$var$dateTimestampInSeconds;
module.exports.timestampInSeconds = $c4e73e94eef79ff4$var$timestampInSeconds;

});


parcelRegister("aupof", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $7a3066a740e02848$var$merge(initialObj, mergeObj, levels = 2) {
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    const output = {
        ...initialObj
    };
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $7a3066a740e02848$var$merge(output[key], mergeObj[key], levels - 1);
    return output;
}
module.exports.merge = $7a3066a740e02848$var$merge;

});

parcelRegister("23smo", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jR1Dv = parcelRequire("jR1Dv");
function $17f1dc51332afa1f$var$generateTraceId() {
    return $jR1Dv.uuid4();
}
function $17f1dc51332afa1f$var$generateSpanId() {
    return $jR1Dv.uuid4().substring(16);
}
module.exports.generateSpanId = $17f1dc51332afa1f$var$generateSpanId;
module.exports.generateTraceId = $17f1dc51332afa1f$var$generateTraceId;

});

parcelRegister("3zGA3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $65lWX = parcelRequire("65lWX");

var $kKz9d = parcelRequire("kKz9d");
const $29a5ab90299de680$var$SCOPE_SPAN_FIELD = "_sentrySpan";
function $29a5ab90299de680$var$_setSpanForScope(scope, span) {
    if (span) $65lWX.addNonEnumerableProperty(scope, $29a5ab90299de680$var$SCOPE_SPAN_FIELD, $kKz9d.makeWeakRef(span));
    else delete scope[$29a5ab90299de680$var$SCOPE_SPAN_FIELD];
}
function $29a5ab90299de680$var$_getSpanForScope(scope) {
    return $kKz9d.derefWeakRef(scope[$29a5ab90299de680$var$SCOPE_SPAN_FIELD]);
}
module.exports._getSpanForScope = $29a5ab90299de680$var$_getSpanForScope;
module.exports._setSpanForScope = $29a5ab90299de680$var$_setSpanForScope;

});
parcelRegister("kKz9d", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fxVZv = parcelRequire("fxVZv");
function $f1b35e1c005f2a7a$var$makeWeakRef(value) {
    try {
        const WeakRefImpl = $fxVZv.GLOBAL_OBJ.WeakRef;
        if (typeof WeakRefImpl === "function") return new WeakRefImpl(value);
    } catch  {}
    return value;
}
function $f1b35e1c005f2a7a$var$derefWeakRef(ref) {
    if (!ref) return void 0;
    if (typeof ref === "object" && "deref" in ref && typeof ref.deref === "function") try {
        return ref.deref();
    } catch  {
        return void 0;
    }
    return ref;
}
module.exports.derefWeakRef = $f1b35e1c005f2a7a$var$derefWeakRef;
module.exports.makeWeakRef = $f1b35e1c005f2a7a$var$makeWeakRef;

});




parcelRegister("fK9TE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $b762d423369ae9c5$var$isActualPromise = (p)=>p instanceof Promise && !p[$b762d423369ae9c5$var$kChainedCopy];
const $b762d423369ae9c5$var$kChainedCopy = /* @__PURE__ */ Symbol("chained PromiseLike");
const $b762d423369ae9c5$var$chainAndCopyPromiseLike = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    return $b762d423369ae9c5$var$isActualPromise(chained) && $b762d423369ae9c5$var$isActualPromise(original) ? chained : $b762d423369ae9c5$var$copyProps(original, chained);
};
const $b762d423369ae9c5$var$copyProps = (original, chained)=>{
    if (!chained) return original;
    let mutated = false;
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === "function") Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$b762d423369ae9c5$var$kChainedCopy]: true
    });
    return chained;
};
module.exports.chainAndCopyPromiseLike = $b762d423369ae9c5$var$chainAndCopyPromiseLike;

});



parcelRegister("ary0D", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jV7hg = parcelRequire("jV7hg");
function $79a6ce84f06aeb10$var$isAttributeObject(maybeObj) {
    return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
function $79a6ce84f06aeb10$var$attributeValueToTypedAttributeValue(rawValue, useFallback) {
    const { value: value, unit: unit } = $79a6ce84f06aeb10$var$isAttributeObject(rawValue) ? rawValue : {
        value: rawValue,
        unit: void 0
    };
    const attributeValue = $79a6ce84f06aeb10$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === "string" ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === "skip-undefined" && value === void 0) return;
    let stringValue = "";
    try {
        stringValue = JSON.stringify(value) ?? "";
    } catch  {}
    return {
        value: stringValue,
        type: "string",
        ...checkedUnit
    };
}
function $79a6ce84f06aeb10$var$serializeAttributes(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $79a6ce84f06aeb10$var$attributeValueToTypedAttributeValue(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
function $79a6ce84f06aeb10$var$estimateTypedAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        weight += key.length * 2;
        weight += attr.type.length * 2;
        weight += (attr.unit?.length ?? 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) weight += $79a6ce84f06aeb10$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ($jV7hg.isPrimitive(val)) weight += $79a6ce84f06aeb10$var$estimatePrimitiveSizeInBytes(val);
        else weight += 100;
    }
    return weight;
}
function $79a6ce84f06aeb10$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "boolean") return 4;
    else if (typeof value === "number") return 8;
    return 0;
}
function $79a6ce84f06aeb10$var$getTypedAttributeValue(value) {
    if (Array.isArray(value)) return {
        value: value,
        type: "array"
    };
    const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
    if (primitiveType) return {
        value: value,
        type: primitiveType
    };
}
module.exports.attributeValueToTypedAttributeValue = $79a6ce84f06aeb10$var$attributeValueToTypedAttributeValue;
module.exports.estimateTypedAttributesSizeInBytes = $79a6ce84f06aeb10$var$estimateTypedAttributesSizeInBytes;
module.exports.isAttributeObject = $79a6ce84f06aeb10$var$isAttributeObject;
module.exports.serializeAttributes = $79a6ce84f06aeb10$var$serializeAttributes;

});

parcelRegister("kfJmY", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $e3FcP = parcelRequire("e3FcP");

var $lyqaT = parcelRequire("lyqaT");

var $aBj8W = parcelRequire("aBj8W");

var $23smo = parcelRequire("23smo");
let $ebe866cac96a68e9$var$_externalPropagationContextProvider;
function $ebe866cac96a68e9$var$registerExternalPropagationContext(fn) {
    $ebe866cac96a68e9$var$_externalPropagationContextProvider = fn;
}
function $ebe866cac96a68e9$var$getExternalPropagationContext() {
    return $ebe866cac96a68e9$var$_externalPropagationContextProvider?.();
}
function $ebe866cac96a68e9$var$hasExternalPropagationContext() {
    return $ebe866cac96a68e9$var$_externalPropagationContextProvider !== void 0;
}
function $ebe866cac96a68e9$var$getCurrentScope() {
    const carrier$1 = $lyqaT.getMainCarrier();
    const acs = $e3FcP.getAsyncContextStrategy(carrier$1);
    return acs.getCurrentScope();
}
function $ebe866cac96a68e9$var$getIsolationScope() {
    const carrier$1 = $lyqaT.getMainCarrier();
    const acs = $e3FcP.getAsyncContextStrategy(carrier$1);
    return acs.getIsolationScope();
}
function $ebe866cac96a68e9$var$getGlobalScope() {
    return $lyqaT.getGlobalSingleton("globalScope", ()=>new $aBj8W.Scope());
}
function $ebe866cac96a68e9$var$withScope(...rest) {
    const carrier$1 = $lyqaT.getMainCarrier();
    const acs = $e3FcP.getAsyncContextStrategy(carrier$1);
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
function $ebe866cac96a68e9$var$withIsolationScope(...rest) {
    const carrier$1 = $lyqaT.getMainCarrier();
    const acs = $e3FcP.getAsyncContextStrategy(carrier$1);
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
function $ebe866cac96a68e9$var$getClient() {
    return $ebe866cac96a68e9$var$getCurrentScope().getClient();
}
function $ebe866cac96a68e9$var$getTraceContextFromScope(scope) {
    const externalContext = $ebe866cac96a68e9$var$getExternalPropagationContext();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext$1 = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext$1;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || $23smo.generateSpanId()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}
module.exports.getClient = $ebe866cac96a68e9$var$getClient;
module.exports.getCurrentScope = $ebe866cac96a68e9$var$getCurrentScope;
module.exports.getExternalPropagationContext = $ebe866cac96a68e9$var$getExternalPropagationContext;
module.exports.getGlobalScope = $ebe866cac96a68e9$var$getGlobalScope;
module.exports.getIsolationScope = $ebe866cac96a68e9$var$getIsolationScope;
module.exports.getTraceContextFromScope = $ebe866cac96a68e9$var$getTraceContextFromScope;
module.exports.hasExternalPropagationContext = $ebe866cac96a68e9$var$hasExternalPropagationContext;
module.exports.registerExternalPropagationContext = $ebe866cac96a68e9$var$registerExternalPropagationContext;
module.exports.withIsolationScope = $ebe866cac96a68e9$var$withIsolationScope;
module.exports.withScope = $ebe866cac96a68e9$var$withScope;

});

parcelRegister("2JysJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = "sentry.source";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = "sentry.sample_rate";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = "sentry.previous_trace_sample_rate";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_OP = "sentry.op";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = "sentry.origin";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE = "sentry.status.message";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = "sentry.idle_span_finish_reason";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = "sentry.measurement_unit";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = "sentry.measurement_value";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = "sentry.release";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = "sentry.environment";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = "sentry.segment.name";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = "sentry.segment.id";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = "sentry.sdk.name";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = "sentry.sdk.version";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = "sentry.sdk.integrations";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_USER_ID = "user.id";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_USER_EMAIL = "user.email";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = "user.ip_address";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_USER_USERNAME = "user.name";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = "sentry.custom_span_name";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_PROFILE_ID = "sentry.profile_id";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = "sentry.exclusive_time";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_CACHE_HIT = "cache.hit";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_CACHE_KEY = "cache.key";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = "cache.item_size";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = "http.request.method";
const $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_URL_FULL = "url.full";
const $1fda8444f5599856$var$SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = "sentry.link.type";
const $1fda8444f5599856$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $1fda8444f5599856$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_CACHE_HIT;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_CACHE_KEY;
module.exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
module.exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
module.exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_PROFILE_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_OP;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE;
module.exports.SEMANTIC_ATTRIBUTE_URL_FULL = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_URL_FULL;
module.exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_USER_EMAIL;
module.exports.SEMANTIC_ATTRIBUTE_USER_ID = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_USER_ID;
module.exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
module.exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = $1fda8444f5599856$var$SEMANTIC_ATTRIBUTE_USER_USERNAME;
module.exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = $1fda8444f5599856$var$SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;

});

parcelRegister("d33W7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $97fe9be03a1b797b$var$SPAN_STATUS_UNSET = 0;
const $97fe9be03a1b797b$var$SPAN_STATUS_OK = 1;
const $97fe9be03a1b797b$var$SPAN_STATUS_ERROR = 2;
function $97fe9be03a1b797b$var$getSpanStatusFromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $97fe9be03a1b797b$var$SPAN_STATUS_OK
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $97fe9be03a1b797b$var$SPAN_STATUS_ERROR,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $97fe9be03a1b797b$var$SPAN_STATUS_ERROR,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $97fe9be03a1b797b$var$SPAN_STATUS_ERROR,
                message: "not_found"
            };
        case 409:
            return {
                code: $97fe9be03a1b797b$var$SPAN_STATUS_ERROR,
                message: "already_exists"
            };
        case 413:
            return {
                code: $97fe9be03a1b797b$var$SPAN_STATUS_ERROR,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $97fe9be03a1b797b$var$SPAN_STATUS_ERROR,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $97fe9be03a1b797b$var$SPAN_STATUS_ERROR,
                message: "cancelled"
            };
        default:
            return {
                code: $97fe9be03a1b797b$var$SPAN_STATUS_ERROR,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $97fe9be03a1b797b$var$SPAN_STATUS_ERROR,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $97fe9be03a1b797b$var$SPAN_STATUS_ERROR,
                message: "unavailable"
            };
        case 504:
            return {
                code: $97fe9be03a1b797b$var$SPAN_STATUS_ERROR,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $97fe9be03a1b797b$var$SPAN_STATUS_ERROR,
                message: "internal_error"
            };
    }
    return {
        code: $97fe9be03a1b797b$var$SPAN_STATUS_ERROR,
        message: "internal_error"
    };
}
function $97fe9be03a1b797b$var$setHttpStatus(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $97fe9be03a1b797b$var$getSpanStatusFromHttpCode(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}
module.exports.SPAN_STATUS_ERROR = $97fe9be03a1b797b$var$SPAN_STATUS_ERROR;
module.exports.SPAN_STATUS_OK = $97fe9be03a1b797b$var$SPAN_STATUS_OK;
module.exports.SPAN_STATUS_UNSET = $97fe9be03a1b797b$var$SPAN_STATUS_UNSET;
module.exports.getSpanStatusFromHttpCode = $97fe9be03a1b797b$var$getSpanStatusFromHttpCode;
module.exports.setHttpStatus = $97fe9be03a1b797b$var$setHttpStatus;

});

parcelRegister("5K3ZQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $65lWX = parcelRequire("65lWX");

var $kKz9d = parcelRequire("kKz9d");
const $42e4593b8e1336e9$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $42e4593b8e1336e9$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
const $42e4593b8e1336e9$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceInference");
const $42e4593b8e1336e9$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceExplicitlySet");
const $42e4593b8e1336e9$var$TRACER_PROVIDER_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.tracerProviderSpan");
function $42e4593b8e1336e9$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        $65lWX.addNonEnumerableProperty(span, $42e4593b8e1336e9$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, $kKz9d.makeWeakRef(isolationScope));
        $65lWX.addNonEnumerableProperty(span, $42e4593b8e1336e9$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
function $42e4593b8e1336e9$var$getCapturedScopesOnSpan(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$42e4593b8e1336e9$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: $kKz9d.derefWeakRef(spanWithScopes[$42e4593b8e1336e9$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}
function $42e4593b8e1336e9$var$markSpanForOtelSourceInference(span) {
    $65lWX.addNonEnumerableProperty(span, $42e4593b8e1336e9$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD, true);
}
function $42e4593b8e1336e9$var$spanShouldInferOtelSource(span) {
    return span[$42e4593b8e1336e9$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD] === true;
}
function $42e4593b8e1336e9$var$markSpanSourceAsExplicit(span) {
    $65lWX.addNonEnumerableProperty(span, $42e4593b8e1336e9$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD, true);
}
function $42e4593b8e1336e9$var$spanSourceWasExplicitlySet(span) {
    return span[$42e4593b8e1336e9$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD] === true;
}
function $42e4593b8e1336e9$var$markSpanAsTracerProviderSpan(span) {
    $65lWX.addNonEnumerableProperty(span, $42e4593b8e1336e9$var$TRACER_PROVIDER_SPAN_FIELD, true);
}
function $42e4593b8e1336e9$var$spanIsTracerProviderSpan(span) {
    return span[$42e4593b8e1336e9$var$TRACER_PROVIDER_SPAN_FIELD] === true;
}
module.exports.getCapturedScopesOnSpan = $42e4593b8e1336e9$var$getCapturedScopesOnSpan;
module.exports.markSpanAsTracerProviderSpan = $42e4593b8e1336e9$var$markSpanAsTracerProviderSpan;
module.exports.markSpanForOtelSourceInference = $42e4593b8e1336e9$var$markSpanForOtelSourceInference;
module.exports.markSpanSourceAsExplicit = $42e4593b8e1336e9$var$markSpanSourceAsExplicit;
module.exports.setCapturedScopesOnSpan = $42e4593b8e1336e9$var$setCapturedScopesOnSpan;
module.exports.spanIsTracerProviderSpan = $42e4593b8e1336e9$var$spanIsTracerProviderSpan;
module.exports.spanShouldInferOtelSource = $42e4593b8e1336e9$var$spanShouldInferOtelSource;
module.exports.spanSourceWasExplicitlySet = $42e4593b8e1336e9$var$spanSourceWasExplicitlySet;

});

parcelRegister("bTcEr", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2sm2V = parcelRequire("2sm2V");

var $QBqQc = parcelRequire("QBqQc");

var $ebmC5 = parcelRequire("ebmC5");

var $gQqIQ = parcelRequire("gQqIQ");

var $23smo = parcelRequire("23smo");

var $6ki8f = parcelRequire("6ki8f");
const $8a7ea507c742c4b4$var$TRACEPARENT_REGEXP = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
function $8a7ea507c742c4b4$var$extractTraceparentData(traceparent) {
    if (!traceparent) return void 0;
    const matches = traceparent.match($8a7ea507c742c4b4$var$TRACEPARENT_REGEXP);
    if (!matches) return void 0;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
function $8a7ea507c742c4b4$var$isContinuingTrace(propagationContext) {
    return !!propagationContext.parentSpanId || !!propagationContext.dsc;
}
function $8a7ea507c742c4b4$var$propagationContextFromHeaders(sentryTrace, baggage$1) {
    const traceparentData = $8a7ea507c742c4b4$var$extractTraceparentData(sentryTrace);
    const dynamicSamplingContext = $QBqQc.baggageHeaderToDynamicSamplingContext(baggage$1);
    if (!traceparentData?.traceId) return {
        traceId: $23smo.generateTraceId(),
        sampleRand: $6ki8f.safeMathRandom()
    };
    const sampleRand = $8a7ea507c742c4b4$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
        sampleRand
    };
}
function $8a7ea507c742c4b4$var$generateSentryTraceHeader(traceId = $23smo.generateTraceId(), spanId = $23smo.generateSpanId(), sampled) {
    let sampledString = "";
    if (sampled !== void 0) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
function $8a7ea507c742c4b4$var$generateTraceparentHeader(traceId = $23smo.generateTraceId(), spanId = $23smo.generateSpanId(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? "01" : "00"}`;
}
function $8a7ea507c742c4b4$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    const parsedSampleRand = $gQqIQ.parseSampleRate(dsc?.sample_rand);
    if (parsedSampleRand !== void 0) return parsedSampleRand;
    const parsedSampleRate = $gQqIQ.parseSampleRate(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== void 0) return traceparentData.parentSampled ? // Returns a sample rand with positive sampling decision [0, sampleRate)
    $6ki8f.safeMathRandom() * parsedSampleRate : // Returns a sample rand with negative sampling decision [sampleRate, 1)
    parsedSampleRate + $6ki8f.safeMathRandom() * (1 - parsedSampleRate);
    else return $6ki8f.safeMathRandom();
}
function $8a7ea507c742c4b4$var$shouldContinueTrace(client, baggageOrgId) {
    const clientOrgId = $ebmC5.extractOrgIdFromClient(client);
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        $2sm2V.debug.log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false;
    if (strictTraceContinuation) {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            $2sm2V.debug.log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}
module.exports.TRACEPARENT_REGEXP = $8a7ea507c742c4b4$var$TRACEPARENT_REGEXP;
module.exports.extractTraceparentData = $8a7ea507c742c4b4$var$extractTraceparentData;
module.exports.generateSentryTraceHeader = $8a7ea507c742c4b4$var$generateSentryTraceHeader;
module.exports.generateTraceparentHeader = $8a7ea507c742c4b4$var$generateTraceparentHeader;
module.exports.isContinuingTrace = $8a7ea507c742c4b4$var$isContinuingTrace;
module.exports.propagationContextFromHeaders = $8a7ea507c742c4b4$var$propagationContextFromHeaders;
module.exports.shouldContinueTrace = $8a7ea507c742c4b4$var$shouldContinueTrace;

});
parcelRegister("QBqQc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1GyI0 = parcelRequire("1GyI0");

var $2sm2V = parcelRequire("2sm2V");

var $jV7hg = parcelRequire("jV7hg");
const $09e1e4a48306bf21$var$SENTRY_BAGGAGE_KEY_PREFIX = "sentry-";
const $09e1e4a48306bf21$var$SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;
const $09e1e4a48306bf21$var$MAX_BAGGAGE_STRING_LENGTH = 8192;
function $09e1e4a48306bf21$var$baggageHeaderToDynamicSamplingContext(baggageHeader) {
    const baggageObject = $09e1e4a48306bf21$var$parseBaggageHeader(baggageHeader);
    if (!baggageObject) return void 0;
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($09e1e4a48306bf21$var$SENTRY_BAGGAGE_KEY_PREFIX)) {
            const nonPrefixedKey = key.slice($09e1e4a48306bf21$var$SENTRY_BAGGAGE_KEY_PREFIX.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return void 0;
}
function $09e1e4a48306bf21$var$dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext) {
    if (!dynamicSamplingContext) return void 0;
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$09e1e4a48306bf21$var$SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $09e1e4a48306bf21$var$objectToBaggageHeader(sentryPrefixedDSC);
}
function $09e1e4a48306bf21$var$parseBaggageHeader(baggageHeader) {
    if (!baggageHeader || !$jV7hg.isString(baggageHeader) && !Array.isArray(baggageHeader)) return void 0;
    if (Array.isArray(baggageHeader)) return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $09e1e4a48306bf21$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $09e1e4a48306bf21$var$baggageHeaderToObject(baggageHeader);
}
function $09e1e4a48306bf21$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf("=");
        if (eqIdx === -1) return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
function $09e1e4a48306bf21$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) return void 0;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $09e1e4a48306bf21$var$MAX_BAGGAGE_STRING_LENGTH) {
            $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}
function $09e1e4a48306bf21$var$mergeBaggageHeaders(existing, incoming) {
    if (!existing) return incoming;
    const existingEntries = $09e1e4a48306bf21$var$parseBaggageHeader(existing);
    const incomingEntries = $09e1e4a48306bf21$var$parseBaggageHeader(incoming);
    if (!incomingEntries) return existing;
    const merged = {};
    let hasNewSentryEntries = false;
    const newSentryEntries = {};
    const newNonSentryEntries = {};
    for (const [key, value] of Object.entries(incomingEntries))if (key.startsWith($09e1e4a48306bf21$var$SENTRY_BAGGAGE_KEY_PREFIX)) {
        newSentryEntries[key] = value;
        hasNewSentryEntries = true;
    } else newNonSentryEntries[key] = value;
    if (existingEntries) {
        for (const [key, value] of Object.entries(existingEntries))if (!hasNewSentryEntries || !key.startsWith($09e1e4a48306bf21$var$SENTRY_BAGGAGE_KEY_PREFIX)) merged[key] = value;
    }
    if (hasNewSentryEntries) Object.assign(merged, newSentryEntries);
    for (const [key, value] of Object.entries(newNonSentryEntries))merged[key] ?? (merged[key] = value);
    return $09e1e4a48306bf21$var$objectToBaggageHeader(merged);
}
module.exports.MAX_BAGGAGE_STRING_LENGTH = $09e1e4a48306bf21$var$MAX_BAGGAGE_STRING_LENGTH;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX = $09e1e4a48306bf21$var$SENTRY_BAGGAGE_KEY_PREFIX;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = $09e1e4a48306bf21$var$SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
module.exports.baggageHeaderToDynamicSamplingContext = $09e1e4a48306bf21$var$baggageHeaderToDynamicSamplingContext;
module.exports.dynamicSamplingContextToSentryBaggageHeader = $09e1e4a48306bf21$var$dynamicSamplingContextToSentryBaggageHeader;
module.exports.mergeBaggageHeaders = $09e1e4a48306bf21$var$mergeBaggageHeaders;
module.exports.objectToBaggageHeader = $09e1e4a48306bf21$var$objectToBaggageHeader;
module.exports.parseBaggageHeader = $09e1e4a48306bf21$var$parseBaggageHeader;

});

parcelRegister("ebmC5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1GyI0 = parcelRequire("1GyI0");

var $2sm2V = parcelRequire("2sm2V");
const $a533a251375c6c67$var$ORG_ID_REGEX = /^o(\d+)\./;
const $a533a251375c6c67$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $a533a251375c6c67$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
function $a533a251375c6c67$var$dsnToString(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
function $a533a251375c6c67$var$dsnFromString(str) {
    const match = $a533a251375c6c67$var$DSN_REGEX.exec(str);
    if (!match) {
        $2sm2V.consoleSandbox(()=>{
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return void 0;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $a533a251375c6c67$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $a533a251375c6c67$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $a533a251375c6c67$var$validateDsn(dsn) {
    if (!$1GyI0.DEBUG_BUILD) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            $2sm2V.debug.error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        $2sm2V.debug.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$a533a251375c6c67$var$isValidProtocol(protocol)) {
        $2sm2V.debug.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        $2sm2V.debug.error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
function $a533a251375c6c67$var$extractOrgIdFromDsnHost(host) {
    const match = host.match($a533a251375c6c67$var$ORG_ID_REGEX);
    return match?.[1];
}
function $a533a251375c6c67$var$extractOrgIdFromClient(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $a533a251375c6c67$var$extractOrgIdFromDsnHost(host);
    return org_id;
}
function $a533a251375c6c67$var$makeDsn(from) {
    const components = typeof from === "string" ? $a533a251375c6c67$var$dsnFromString(from) : $a533a251375c6c67$var$dsnFromComponents(from);
    if (!components || !$a533a251375c6c67$var$validateDsn(components)) return void 0;
    return components;
}
module.exports.dsnFromString = $a533a251375c6c67$var$dsnFromString;
module.exports.dsnToString = $a533a251375c6c67$var$dsnToString;
module.exports.extractOrgIdFromClient = $a533a251375c6c67$var$extractOrgIdFromClient;
module.exports.extractOrgIdFromDsnHost = $a533a251375c6c67$var$extractOrgIdFromDsnHost;
module.exports.makeDsn = $a533a251375c6c67$var$makeDsn;

});

parcelRegister("gQqIQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $c4363b2dc9724ef6$var$parseSampleRate(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return void 0;
    return rate;
}
module.exports.parseSampleRate = $c4363b2dc9724ef6$var$parseSampleRate;

});




parcelRegister("ckdh5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kfJmY = parcelRequire("kfJmY");

var $1GyI0 = parcelRequire("1GyI0");

var $2JysJ = parcelRequire("2JysJ");

var $2sm2V = parcelRequire("2sm2V");

var $5xQO6 = parcelRequire("5xQO6");

var $h2lAT = parcelRequire("h2lAT");

var $3zGA3 = parcelRequire("3zGA3");

var $8hCvI = parcelRequire("8hCvI");

var $gU6V8 = parcelRequire("gU6V8");

var $fyn9D = parcelRequire("fyn9D");

var $y39T9 = parcelRequire("y39T9");

var $d33W7 = parcelRequire("d33W7");

var $aewmo = parcelRequire("aewmo");

var $5K3ZQ = parcelRequire("5K3ZQ");
const $8f91a659d7ea2848$var$TRACING_DEFAULTS = {
    idleTimeout: 1e3,
    finalTimeout: 3e4,
    childSpanTimeout: 15e3
};
const $8f91a659d7ea2848$var$FINISH_REASON_HEARTBEAT_FAILED = "heartbeatFailed";
const $8f91a659d7ea2848$var$FINISH_REASON_IDLE_TIMEOUT = "idleTimeout";
const $8f91a659d7ea2848$var$FINISH_REASON_FINAL_TIMEOUT = "finalTimeout";
const $8f91a659d7ea2848$var$FINISH_REASON_EXTERNAL_FINISH = "externalFinish";
function $8f91a659d7ea2848$var$startIdleSpan(startSpanOptions, options = {}) {
    const activities = /* @__PURE__ */ new Map();
    let _finished = false;
    let _idleTimeoutID;
    let _childSpanTimeoutID;
    let _finishReason = $8f91a659d7ea2848$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $8f91a659d7ea2848$var$TRACING_DEFAULTS.idleTimeout, finalTimeout: finalTimeout = $8f91a659d7ea2848$var$TRACING_DEFAULTS.finalTimeout, childSpanTimeout: childSpanTimeout = $8f91a659d7ea2848$var$TRACING_DEFAULTS.childSpanTimeout, beforeSpanEnd: beforeSpanEnd, trimIdleSpanEndTimestamp: trimIdleSpanEndTimestamp = true } = options;
    const client = $kfJmY.getClient();
    const scope = $kfJmY.getCurrentScope();
    if (!client || !$5xQO6.hasSpansEnabled()) {
        const span2 = new $fyn9D.SentryNonRecordingSpan({
            traceId: scope.getPropagationContext().traceId
        });
        $5K3ZQ.setCapturedScopesOnSpan(span2, scope, $kfJmY.getIsolationScope());
        return span2;
    }
    const previousActiveSpan = $8hCvI.getActiveSpan();
    const span = $8f91a659d7ea2848$var$_startIdleSpan(startSpanOptions);
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            if ($fyn9D.spanIsNonRecordingSpan(thisArg)) return;
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || $gU6V8.timestampInSeconds();
            const spanEndTimestamp = $8hCvI.spanTimeInputToSeconds(timestamp);
            const spans = $8hCvI.getSpanDescendants(span).filter((child)=>child !== span);
            const spanJson = $8hCvI.spanToJSON(span);
            if (!spans.length || !trimIdleSpanEndTimestamp) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const ignoreSpans = client.getOptions().ignoreSpans;
            const latestSpanEndTimestamp = spans?.reduce((acc, current)=>{
                const currentSpanJson = $8hCvI.spanToJSON(current);
                if (!currentSpanJson.timestamp) return acc;
                if (ignoreSpans && $h2lAT.shouldIgnoreSpan({
                    description: currentSpanJson.description,
                    op: currentSpanJson.op,
                    attributes: currentSpanJson.data
                }, ignoreSpans)) return acc;
                return acc ? Math.max(acc, currentSpanJson.timestamp) : currentSpanJson.timestamp;
            }, void 0);
            const spanStartTimestamp = spanJson.start_timestamp;
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1e3 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = void 0;
        }
    }
    function _cancelChildSpanTimeout() {
        if (_childSpanTimeoutID) {
            clearTimeout(_childSpanTimeoutID);
            _childSpanTimeoutID = void 0;
        }
    }
    function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $8f91a659d7ea2848$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    function _restartChildSpanTimeout(endTimestamp) {
        _cancelChildSpanTimeout();
        _childSpanTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $8f91a659d7ea2848$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = $gU6V8.timestampInSeconds();
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1e3);
    }
    function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = $gU6V8.timestampInSeconds();
            _restartIdleTimeout(endTimestamp + idleTimeout / 1e3);
            _cancelChildSpanTimeout();
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        $3zGA3._setSpanForScope(scope, previousActiveSpan);
        const spanJSON = $8hCvI.spanToJSON(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        if (!startTimestamp) return;
        const attributes = spanJSON.data;
        if (!attributes[$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON]) span.setAttribute($2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON, _finishReason);
        const currentStatus = spanJSON.status;
        if (!currentStatus || currentStatus === "unknown") span.setStatus({
            code: $d33W7.SPAN_STATUS_OK
        });
        $2sm2V.debug.log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = $8hCvI.getSpanDescendants(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: $d33W7.SPAN_STATUS_ERROR,
                    message: "cancelled"
                });
                childSpan.end(endTimestamp);
                $1GyI0.DEBUG_BUILD && $2sm2V.debug.log("[Tracing] Cancelling span since span ended early", JSON.stringify(childSpan, void 0, 2));
            }
            const childSpanJSON = $8hCvI.spanToJSON(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1e3;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if ($1GyI0.DEBUG_BUILD) {
                const stringifiedSpan = JSON.stringify(childSpan, void 0, 2);
                if (!spanStartedBeforeIdleSpanEnd) $2sm2V.debug.log("[Tracing] Discarding span since it happened after idle span was finished", stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) $2sm2V.debug.log("[Tracing] Discarding span since it finished after idle span final timeout", stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                $8hCvI.removeChildSpanFromSpan(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute("sentry.idle_span_discarded_spans", discardedSpans);
    }
    _cleanupHooks.push(client.on("spanStart", (startedSpan)=>{
        if (_finished || startedSpan === span || !!$8hCvI.spanToJSON(startedSpan).timestamp || startedSpan instanceof $y39T9.SentrySpan && startedSpan.isStandaloneSpan()) return;
        const allSpans = $8hCvI.getSpanDescendants(span);
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("spanEnd", (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("idleSpanEnableAutoFinish", (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: $d33W7.SPAN_STATUS_ERROR,
                message: "deadline_exceeded"
            });
            _finishReason = $8f91a659d7ea2848$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $8f91a659d7ea2848$var$_startIdleSpan(options) {
    const span = $aewmo.startInactiveSpan(options);
    $3zGA3._setSpanForScope($kfJmY.getCurrentScope(), span);
    $1GyI0.DEBUG_BUILD && $2sm2V.debug.log("[Tracing] Started span is an idle span");
    return span;
}
module.exports.TRACING_DEFAULTS = $8f91a659d7ea2848$var$TRACING_DEFAULTS;
module.exports.startIdleSpan = $8f91a659d7ea2848$var$startIdleSpan;

});
parcelRegister("5xQO6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kfJmY = parcelRequire("kfJmY");
function $4098ff3942666ce6$var$hasSpansEnabled(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || $kfJmY.getClient()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
module.exports.hasSpansEnabled = $4098ff3942666ce6$var$hasSpansEnabled;

});

parcelRegister("h2lAT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1GyI0 = parcelRequire("1GyI0");

var $2sm2V = parcelRequire("2sm2V");

var $1L2sM = parcelRequire("1L2sM");
function $c6735fb21940134b$var$logIgnoredSpan(droppedSpan) {
    $2sm2V.debug.log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
function $c6735fb21940134b$var$shouldIgnoreSpan(span, ignoreSpans) {
    if (!ignoreSpans?.length) return false;
    for (const pattern of ignoreSpans){
        if ($c6735fb21940134b$var$isStringOrRegExp(pattern)) {
            if (span.description && $1L2sM.isMatchingPattern(span.description, pattern)) {
                $1GyI0.DEBUG_BUILD && $c6735fb21940134b$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && $1L2sM.isMatchingPattern(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && $1L2sM.isMatchingPattern(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>$c6735fb21940134b$var$_matchesAttributeValue(span.attributes?.[key], valuePattern)) : true;
        if (nameMatches && opMatches && attrsMatch) {
            $1GyI0.DEBUG_BUILD && $c6735fb21940134b$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function $c6735fb21940134b$var$_matchesAttributeValue(actual, pat) {
    if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) return $1L2sM.isMatchingPattern(actual, pat);
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    return actual === pat;
}
function $c6735fb21940134b$var$reparentChildSpans(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $c6735fb21940134b$var$isStringOrRegExp(value) {
    return typeof value === "string" || value instanceof RegExp;
}
module.exports.reparentChildSpans = $c6735fb21940134b$var$reparentChildSpans;
module.exports.shouldIgnoreSpan = $c6735fb21940134b$var$shouldIgnoreSpan;

});

parcelRegister("fyn9D", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $65lWX = parcelRequire("65lWX");

var $23smo = parcelRequire("23smo");

var $8hCvI = parcelRequire("8hCvI");
const $b52bfdfaaa395721$var$NON_RECORDING_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.nonRecordingSpan");
class $b52bfdfaaa395721$var$SentryNonRecordingSpan {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || $23smo.generateTraceId();
        this._spanId = spanContext.spanId || $23smo.generateSpanId();
        this.dropReason = spanContext.dropReason;
        $65lWX.addNonEnumerableProperty(this, $b52bfdfaaa395721$var$NON_RECORDING_SPAN_FIELD, true);
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: $8hCvI.TRACE_FLAG_NONE
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
}
function $b52bfdfaaa395721$var$spanIsNonRecordingSpan(span) {
    return !!span && span[$b52bfdfaaa395721$var$NON_RECORDING_SPAN_FIELD] === true;
}
module.exports.SentryNonRecordingSpan = $b52bfdfaaa395721$var$SentryNonRecordingSpan;
module.exports.spanIsNonRecordingSpan = $b52bfdfaaa395721$var$spanIsNonRecordingSpan;

});

parcelRegister("y39T9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kfJmY = parcelRequire("kfJmY");

var $1GyI0 = parcelRequire("1GyI0");

var $aOpjI = parcelRequire("aOpjI");

var $2JysJ = parcelRequire("2JysJ");

var $2sm2V = parcelRequire("2sm2V");

var $23smo = parcelRequire("23smo");

var $8hCvI = parcelRequire("8hCvI");

var $gU6V8 = parcelRequire("gU6V8");

var $dOSrX = parcelRequire("dOSrX");

var $kSXzG = parcelRequire("kSXzG");

var $5wLxm = parcelRequire("5wLxm");

var $3i3WC = parcelRequire("3i3WC");

var $g8Glr = parcelRequire("g8Glr");

var $5K3ZQ = parcelRequire("5K3ZQ");
const $0665a04d235cbb09$var$MAX_SPAN_COUNT = 1e3;
class $0665a04d235cbb09$var$SentrySpan {
    /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || $23smo.generateTraceId();
        this._spanId = spanContext.spanId || $23smo.generateSpanId();
        this._startTime = spanContext.startTimestamp || $gU6V8.timestampInSeconds();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "manual",
            [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_OP]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._frozen) return this;
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._frozen) return this;
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? $8hCvI.TRACE_FLAG_SAMPLED : $8hCvI.TRACE_FLAG_NONE
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (this._frozen) return this;
        if (value === void 0) delete this._attributes[key];
        else this._attributes[key] = value;
        if (key === $2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE && value !== void 0 && $5K3ZQ.spanShouldInferOtelSource(this)) $5K3ZQ.markSpanSourceAsExplicit(this);
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        if (this._frozen) return;
        this._startTime = $8hCvI.spanTimeInputToSeconds(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        if (this._frozen) return this;
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        if (this._frozen) return this;
        this._name = name;
        if (!$5K3ZQ.spanShouldInferOtelSource(this)) this.setAttribute($2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        if (this._endTime) {
            this._frozen = $5K3ZQ.spanIsTracerProviderSpan(this);
            return;
        }
        this._endTime = $8hCvI.spanTimeInputToSeconds(endTimestamp);
        $kSXzG.logSpanEnd(this);
        this._onSpanEnded();
        this._frozen = $5K3ZQ.spanIsTracerProviderSpan(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: $8hCvI.getStatusMessage(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            profile_id: this._attributes[$2JysJ.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._attributes[$2JysJ.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
            measurements: $5wLxm.timedEventsToMeasurements(this._events),
            is_segment: this._isStandaloneSpan && $8hCvI.getRootSpan(this) === this || void 0,
            segment_id: this._isStandaloneSpan ? $8hCvI.getRootSpan(this).spanContext().spanId : void 0,
            links: $8hCvI.convertSpanLinksForEnvelope(this._links)
        };
    }
    /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ getStreamedSpanJSON() {
        return {
            name: this._name ?? "",
            span_id: this._spanId,
            trace_id: this._traceId,
            parent_span_id: this._parentSpanId,
            start_timestamp: this._startTime,
            // just in case _endTime is not set, we use the start time (i.e. duration 0)
            end_timestamp: this._endTime ?? this._startTime,
            is_segment: this._isStandaloneSpan || this === $8hCvI.getRootSpan(this),
            status: $8hCvI.getSimpleStatus(this._status),
            attributes: $8hCvI.addStatusMessageAttribute(this._attributes, this._status),
            links: $8hCvI.getStreamedSpanLinks(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        if (this._frozen) return this;
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.log("[Tracing] Adding an event to span:", name);
        const time$1 = $0665a04d235cbb09$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || $gU6V8.timestampInSeconds();
        const attributes = $0665a04d235cbb09$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: $8hCvI.spanTimeInputToSeconds(time$1),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = $kfJmY.getClient();
        if (client) {
            client.emit("spanEnd", this);
            if (!this._isStandaloneSpan) client.emit("afterSpanEnd", this);
        }
        const rootSpan = $8hCvI.getRootSpan(this);
        const isSegmentSpan = this._isStandaloneSpan || this === rootSpan;
        if (this._isStandaloneSpan) {
            if (this._sampled) $0665a04d235cbb09$var$sendSpanEnvelope($aOpjI.createSpanEnvelope([
                this
            ], client));
            else {
                $1GyI0.DEBUG_BUILD && $2sm2V.debug.log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        }
        if (!isSegmentSpan) {
            const strategy2 = $3i3WC.getSegmentSpanCaptureStrategy();
            if (strategy2) {
                const scope2 = $5K3ZQ.getCapturedScopesOnSpan(this).scope || $kfJmY.getCurrentScope();
                strategy2.onChildSpanEnded(this, rootSpan, (options)=>this._convertSpanToTransaction(options), scope2);
            }
            return;
        }
        if (client && $g8Glr.hasSpanStreamingEnabled(client)) {
            client.emit("afterSegmentSpanEnd", this);
            return;
        }
        const scope = $5K3ZQ.getCapturedScopesOnSpan(this).scope || $kfJmY.getCurrentScope();
        const strategy = $3i3WC.getSegmentSpanCaptureStrategy();
        if (strategy) strategy.onSegmentSpanEnded((options)=>this._convertSpanToTransaction(options), scope);
        else {
            const transactionEvent = this._convertSpanToTransaction();
            if (transactionEvent) scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction(options = {}) {
        if (!$0665a04d235cbb09$var$isFullFinishedSpan($8hCvI.spanToJSON(this))) return void 0;
        if (!this._name) {
            $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = $5K3ZQ.getCapturedScopesOnSpan(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return void 0;
        options.onSpanCaptured?.(this);
        const spans = [];
        for (const descendant of $8hCvI.getSpanDescendants(this)){
            if (descendant === this || $0665a04d235cbb09$var$isStandaloneSpan(descendant) || options.isSpanAlreadyCaptured?.(descendant)) continue;
            const spanJSON = $8hCvI.spanToJSON(descendant);
            if (!$0665a04d235cbb09$var$isFullFinishedSpan(spanJSON)) continue;
            options.onSpanCaptured?.(descendant);
            spans.push(spanJSON);
        }
        const source = this._attributes[$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        delete this._attributes[$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        let hasGenAiSpans = false;
        spans.forEach((span)=>{
            delete span.data[$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
            if (span.op?.startsWith("gen_ai.")) hasGenAiSpans = true;
        });
        const transaction = {
            contexts: {
                trace: $8hCvI.spanToTransactionTraceContext(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $0665a04d235cbb09$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $0665a04d235cbb09$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: $dOSrX.getDynamicSamplingContextFromSpan(this),
                hasGenAiSpans: hasGenAiSpans
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = $5wLxm.timedEventsToMeasurements(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            $1GyI0.DEBUG_BUILD && $2sm2V.debug.log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, void 0, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $0665a04d235cbb09$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
function $0665a04d235cbb09$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
function $0665a04d235cbb09$var$isStandaloneSpan(span) {
    return span instanceof $0665a04d235cbb09$var$SentrySpan && span.isStandaloneSpan();
}
function $0665a04d235cbb09$var$sendSpanEnvelope(envelope) {
    const client = $kfJmY.getClient();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    client.sendEnvelope(envelope);
}
module.exports.SentrySpan = $0665a04d235cbb09$var$SentrySpan;

});
parcelRegister("aOpjI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dOSrX = parcelRequire("dOSrX");

var $7O6Z7 = parcelRequire("7O6Z7");

var $ebmC5 = parcelRequire("ebmC5");

var $kAeXb = parcelRequire("kAeXb");

var $6ki8f = parcelRequire("6ki8f");

var $h2lAT = parcelRequire("h2lAT");

var $8hCvI = parcelRequire("8hCvI");
function $7df23652d5dfbc36$var$_enhanceEventWithSdkInfo(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : void 0
    };
    return event;
}
function $7df23652d5dfbc36$var$createSessionEnvelope(session, dsn$1, metadata, tunnel) {
    const sdkInfo = $kAeXb.getSdkMetadataForEnvelopeHeader(metadata);
    const envelopeHeaders = {
        sent_at: new Date($6ki8f.safeDateNow()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn$1 && {
            dsn: $ebmC5.dsnToString(dsn$1)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return $kAeXb.createEnvelope(envelopeHeaders, [
        envelopeItem
    ]);
}
function $7df23652d5dfbc36$var$createEventEnvelope(event, dsn, metadata, tunnel) {
    const sdkInfo = $kAeXb.getSdkMetadataForEnvelopeHeader(metadata);
    const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $7df23652d5dfbc36$var$_enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = $kAeXb.createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return $kAeXb.createEnvelope(envelopeHeaders, [
        eventItem
    ]);
}
function $7df23652d5dfbc36$var$createSpanEnvelope(spans, client) {
    function dscHasRequiredProps(dsc2) {
        return !!dsc2.trace_id && !!dsc2.public_key;
    }
    const dsc = $dOSrX.getDynamicSamplingContextFromSpan(spans[0]);
    const dsn$1 = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date($6ki8f.safeDateNow()).toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn$1 && {
            dsn: $ebmC5.dsnToString(dsn$1)
        }
    };
    const { beforeSendSpan: beforeSendSpan$1, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>{
        const json = $8hCvI.spanToJSON(span);
        return !$h2lAT.shouldIgnoreSpan({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent("before_send", "span", droppedSpans);
    const convertToSpanJSON = beforeSendSpan$1 ? (span)=>{
        const spanJson = $8hCvI.spanToJSON(span);
        const processedSpan = !$7O6Z7.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? beforeSendSpan$1(spanJson) : spanJson;
        if (!processedSpan) {
            $8hCvI.showSpanDropWarning();
            return spanJson;
        }
        return processedSpan;
    } : $8hCvI.spanToJSON;
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push($kAeXb.createSpanEnvelopeItem(spanJson));
    }
    return $kAeXb.createEnvelope(headers, items);
}
module.exports._enhanceEventWithSdkInfo = $7df23652d5dfbc36$var$_enhanceEventWithSdkInfo;
module.exports.createEventEnvelope = $7df23652d5dfbc36$var$createEventEnvelope;
module.exports.createSessionEnvelope = $7df23652d5dfbc36$var$createSessionEnvelope;
module.exports.createSpanEnvelope = $7df23652d5dfbc36$var$createSpanEnvelope;

});
parcelRegister("dOSrX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $QGp01 = parcelRequire("QGp01");

var $kfJmY = parcelRequire("kfJmY");

var $2JysJ = parcelRequire("2JysJ");

var $QBqQc = parcelRequire("QBqQc");

var $ebmC5 = parcelRequire("ebmC5");

var $5xQO6 = parcelRequire("5xQO6");

var $65lWX = parcelRequire("65lWX");

var $8hCvI = parcelRequire("8hCvI");

var $fyn9D = parcelRequire("fyn9D");

var $5K3ZQ = parcelRequire("5K3ZQ");
const $a0fa2e7ab625b7c4$var$FROZEN_DSC_FIELD = "_frozenDsc";
function $a0fa2e7ab625b7c4$var$freezeDscOnSpan(span, dsc) {
    const spanWithMaybeDsc = span;
    $65lWX.addNonEnumerableProperty(spanWithMaybeDsc, $a0fa2e7ab625b7c4$var$FROZEN_DSC_FIELD, dsc);
}
function $a0fa2e7ab625b7c4$var$getDynamicSamplingContextFromClient(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = {
        environment: options.environment || $QGp01.DEFAULT_ENVIRONMENT,
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: $ebmC5.extractOrgIdFromClient(client)
    };
    client.emit("createDsc", dsc);
    return dsc;
}
function $a0fa2e7ab625b7c4$var$getDynamicSamplingContextFromScope(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $a0fa2e7ab625b7c4$var$getDynamicSamplingContextFromClient(propagationContext.traceId, client);
}
function $a0fa2e7ab625b7c4$var$getDynamicSamplingContextFromSpan(span) {
    const client = $kfJmY.getClient();
    if (!client) return {};
    const rootSpan = $8hCvI.getRootSpan(span);
    const rootSpanJson = $8hCvI.spanToJSON(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? rootSpanAttributes[$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc2) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc2.sample_rate = `${rootSpanSampleRate}`;
        return dsc2;
    }
    const frozenDsc = rootSpan[$a0fa2e7ab625b7c4$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    const isNonRecordingRoot = $fyn9D.spanIsNonRecordingSpan(rootSpan);
    const isIgnoredRoot = isNonRecordingRoot && rootSpan.dropReason === "ignored";
    if (isNonRecordingRoot && (!$5xQO6.hasSpansEnabled(client.getOptions()) || isIgnoredRoot)) {
        const capturedScope = $5K3ZQ.getCapturedScopesOnSpan(rootSpan).scope;
        if (capturedScope) {
            const dsc2 = {
                ...$a0fa2e7ab625b7c4$var$getDynamicSamplingContextFromScope(client, capturedScope)
            };
            if (isIgnoredRoot) dsc2.sampled = "false";
            return applyLocalSampleRateToDsc(dsc2);
        }
    }
    const traceStateDsc = traceState?.get("sentry.dsc");
    const dscOnTraceState = traceStateDsc && $QBqQc.baggageHeaderToDynamicSamplingContext(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    const dsc = $a0fa2e7ab625b7c4$var$getDynamicSamplingContextFromClient(span.spanContext().traceId, client);
    const source = rootSpanAttributes[$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] ?? rootSpanAttributes["sentry.segment.name.source"];
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    if ($5xQO6.hasSpansEnabled()) {
        dsc.sampled = String($8hCvI.spanIsSampled(rootSpan));
        dsc.sample_rand = // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        $5K3ZQ.getCapturedScopesOnSpan(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
function $a0fa2e7ab625b7c4$var$spanToBaggageHeader(span) {
    const dsc = $a0fa2e7ab625b7c4$var$getDynamicSamplingContextFromSpan(span);
    return $QBqQc.dynamicSamplingContextToSentryBaggageHeader(dsc);
}
module.exports.freezeDscOnSpan = $a0fa2e7ab625b7c4$var$freezeDscOnSpan;
module.exports.getDynamicSamplingContextFromClient = $a0fa2e7ab625b7c4$var$getDynamicSamplingContextFromClient;
module.exports.getDynamicSamplingContextFromScope = $a0fa2e7ab625b7c4$var$getDynamicSamplingContextFromScope;
module.exports.getDynamicSamplingContextFromSpan = $a0fa2e7ab625b7c4$var$getDynamicSamplingContextFromSpan;
module.exports.spanToBaggageHeader = $a0fa2e7ab625b7c4$var$spanToBaggageHeader;

});
parcelRegister("QGp01", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $09e5bfa3dfe7f5e6$var$DEFAULT_ENVIRONMENT = "production";
const $09e5bfa3dfe7f5e6$var$DEV_ENVIRONMENT = "development";
module.exports.DEFAULT_ENVIRONMENT = $09e5bfa3dfe7f5e6$var$DEFAULT_ENVIRONMENT;
module.exports.DEV_ENVIRONMENT = $09e5bfa3dfe7f5e6$var$DEV_ENVIRONMENT;

});


parcelRegister("7O6Z7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $65lWX = parcelRequire("65lWX");
function $5af29eee6f3dff4a$var$withStreamedSpan(callback) {
    $65lWX.addNonEnumerableProperty(callback, "_streamed", true);
    return callback;
}
function $5af29eee6f3dff4a$var$isStreamedBeforeSendSpanCallback(callback) {
    return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
}
module.exports.isStreamedBeforeSendSpanCallback = $5af29eee6f3dff4a$var$isStreamedBeforeSendSpanCallback;
module.exports.withStreamedSpan = $5af29eee6f3dff4a$var$withStreamedSpan;

});

parcelRegister("kAeXb", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lyqaT = parcelRequire("lyqaT");

var $ebmC5 = parcelRequire("ebmC5");

var $2ZrfN = parcelRequire("2ZrfN");

var $6ki8f = parcelRequire("6ki8f");

var $fxVZv = parcelRequire("fxVZv");
function $efc2c4e5547271ee$var$createEnvelope(headers, items = []) {
    return [
        headers,
        items
    ];
}
function $efc2c4e5547271ee$var$addItemToEnvelope(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
function $efc2c4e5547271ee$var$forEachEnvelopeItem(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
function $efc2c4e5547271ee$var$envelopeContainsItemType(envelope, types) {
    return $efc2c4e5547271ee$var$forEachEnvelopeItem(envelope, (_, type)=>types.includes(type));
}
function $efc2c4e5547271ee$var$encodeUTF8(input) {
    const carrier$1 = $lyqaT.getSentryCarrier($fxVZv.GLOBAL_OBJ);
    return carrier$1.encodePolyfill ? carrier$1.encodePolyfill(input) : new TextEncoder().encode(input);
}
function $efc2c4e5547271ee$var$decodeUTF8(input) {
    const carrier$1 = $lyqaT.getSentryCarrier($fxVZv.GLOBAL_OBJ);
    return carrier$1.decodePolyfill ? carrier$1.decodePolyfill(input) : new TextDecoder().decode(input);
}
function $efc2c4e5547271ee$var$serializeEnvelope(envelope) {
    const [envHeaders, items] = envelope;
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $efc2c4e5547271ee$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $efc2c4e5547271ee$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`
${JSON.stringify(itemHeaders)}
`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                stringifiedPayload = JSON.stringify($2ZrfN.normalize(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $efc2c4e5547271ee$var$concatBuffers(parts);
}
function $efc2c4e5547271ee$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
function $efc2c4e5547271ee$var$parseEnvelope(env) {
    let buffer = typeof env === "string" ? $efc2c4e5547271ee$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(10);
        if (i < 0) i = buffer.length;
        return JSON.parse($efc2c4e5547271ee$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : void 0;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
function $efc2c4e5547271ee$var$createSpanEnvelopeItem(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
function $efc2c4e5547271ee$var$createAttachmentEnvelopeItem(attachment) {
    const buffer = typeof attachment.data === "string" ? $efc2c4e5547271ee$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $efc2c4e5547271ee$var$DATA_CATEGORY_OVERRIDES = {
    sessions: "session",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    raw_security: "security",
    log: "log_item",
    trace_metric: "metric"
};
function $efc2c4e5547271ee$var$_isOverriddenType(type) {
    return type in $efc2c4e5547271ee$var$DATA_CATEGORY_OVERRIDES;
}
function $efc2c4e5547271ee$var$envelopeItemTypeToDataCategory(type) {
    return $efc2c4e5547271ee$var$_isOverriddenType(type) ? $efc2c4e5547271ee$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
function $efc2c4e5547271ee$var$getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
function $efc2c4e5547271ee$var$createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn$1) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date($6ki8f.safeDateNow()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn$1 && {
            dsn: $ebmC5.dsnToString(dsn$1)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}
module.exports.addItemToEnvelope = $efc2c4e5547271ee$var$addItemToEnvelope;
module.exports.createAttachmentEnvelopeItem = $efc2c4e5547271ee$var$createAttachmentEnvelopeItem;
module.exports.createEnvelope = $efc2c4e5547271ee$var$createEnvelope;
module.exports.createEventEnvelopeHeaders = $efc2c4e5547271ee$var$createEventEnvelopeHeaders;
module.exports.createSpanEnvelopeItem = $efc2c4e5547271ee$var$createSpanEnvelopeItem;
module.exports.envelopeContainsItemType = $efc2c4e5547271ee$var$envelopeContainsItemType;
module.exports.envelopeItemTypeToDataCategory = $efc2c4e5547271ee$var$envelopeItemTypeToDataCategory;
module.exports.forEachEnvelopeItem = $efc2c4e5547271ee$var$forEachEnvelopeItem;
module.exports.getSdkMetadataForEnvelopeHeader = $efc2c4e5547271ee$var$getSdkMetadataForEnvelopeHeader;
module.exports.parseEnvelope = $efc2c4e5547271ee$var$parseEnvelope;
module.exports.serializeEnvelope = $efc2c4e5547271ee$var$serializeEnvelope;

});


parcelRegister("kSXzG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1GyI0 = parcelRequire("1GyI0");

var $2sm2V = parcelRequire("2sm2V");

var $8hCvI = parcelRequire("8hCvI");
function $f347101037564474$var$logSpanStart(span) {
    if (!$1GyI0.DEBUG_BUILD) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = $8hCvI.spanToJSON(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = $8hCvI.spanIsSampled(span);
    const rootSpan = $8hCvI.getRootSpan(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op2, description: description2 } = $8hCvI.spanToJSON(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op2) infoParts.push(`root op: ${op2}`);
        if (description2) infoParts.push(`root description: ${description2}`);
    }
    $2sm2V.debug.log(`${header}
  ${infoParts.join("\n  ")}`);
}
function $f347101037564474$var$logSpanEnd(span) {
    if (!$1GyI0.DEBUG_BUILD) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = $8hCvI.spanToJSON(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = $8hCvI.getRootSpan(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    $2sm2V.debug.log(msg);
}
module.exports.logSpanEnd = $f347101037564474$var$logSpanEnd;
module.exports.logSpanStart = $f347101037564474$var$logSpanStart;

});

parcelRegister("5wLxm", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1GyI0 = parcelRequire("1GyI0");

var $2JysJ = parcelRequire("2JysJ");

var $2sm2V = parcelRequire("2sm2V");

var $8hCvI = parcelRequire("8hCvI");
function $4064d0cc253fbe74$var$setMeasurement(name, value, unit, activeSpan = $8hCvI.getActiveSpan()) {
    const rootSpan = activeSpan && $8hCvI.getRootSpan(activeSpan);
    if (rootSpan) {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE]: value,
            [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT]: unit
        });
    }
}
function $4064d0cc253fbe74$var$timedEventsToMeasurements(events) {
    if (!events || events.length === 0) return void 0;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
        const value = attributes[$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}
module.exports.setMeasurement = $4064d0cc253fbe74$var$setMeasurement;
module.exports.timedEventsToMeasurements = $4064d0cc253fbe74$var$timedEventsToMeasurements;

});

parcelRegister("3i3WC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lyqaT = parcelRequire("lyqaT");
function $26561cd910e3f0ff$var$setSegmentSpanCaptureStrategy(strategy) {
    $lyqaT.getSentryCarrier($lyqaT.getMainCarrier()).segmentSpanCaptureStrategy = strategy;
}
function $26561cd910e3f0ff$var$getSegmentSpanCaptureStrategy() {
    return $lyqaT.getSentryCarrier($lyqaT.getMainCarrier()).segmentSpanCaptureStrategy;
}
module.exports.getSegmentSpanCaptureStrategy = $26561cd910e3f0ff$var$getSegmentSpanCaptureStrategy;
module.exports.setSegmentSpanCaptureStrategy = $26561cd910e3f0ff$var$setSegmentSpanCaptureStrategy;

});

parcelRegister("g8Glr", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $bbfe3d84fb503dbd$var$hasSpanStreamingEnabled(client) {
    return client.getOptions().traceLifecycle === "stream";
}
module.exports.hasSpanStreamingEnabled = $bbfe3d84fb503dbd$var$hasSpanStreamingEnabled;

});


parcelRegister("aewmo", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $e3FcP = parcelRequire("e3FcP");

var $lyqaT = parcelRequire("lyqaT");

var $kfJmY = parcelRequire("kfJmY");

var $1GyI0 = parcelRequire("1GyI0");

var $2JysJ = parcelRequire("2JysJ");

var $QBqQc = parcelRequire("QBqQc");

var $2sm2V = parcelRequire("2sm2V");

var $clLeB = parcelRequire("clLeB");

var $5xQO6 = parcelRequire("5xQO6");

var $h2lAT = parcelRequire("h2lAT");

var $g8Glr = parcelRequire("g8Glr");

var $gQqIQ = parcelRequire("gQqIQ");

var $23smo = parcelRequire("23smo");

var $6ki8f = parcelRequire("6ki8f");

var $3zGA3 = parcelRequire("3zGA3");

var $8hCvI = parcelRequire("8hCvI");

var $bTcEr = parcelRequire("bTcEr");

var $dOSrX = parcelRequire("dOSrX");

var $kSXzG = parcelRequire("kSXzG");

var $2YUNs = parcelRequire("2YUNs");

var $fyn9D = parcelRequire("fyn9D");

var $y39T9 = parcelRequire("y39T9");

var $d33W7 = parcelRequire("d33W7");

var $5K3ZQ = parcelRequire("5K3ZQ");
const $77345039f43d936d$var$SUPPRESS_TRACING_KEY = "__SENTRY_SUPPRESS_TRACING__";
function $77345039f43d936d$var$startSpan(options, callback) {
    const acs = $77345039f43d936d$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $77345039f43d936d$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return $kfJmY.withScope(customForkedScope, ()=>{
        const wrapper = $77345039f43d936d$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = $kfJmY.getCurrentScope();
            const parentSpan = $77345039f43d936d$var$getParentSpan(scope, customParentSpan);
            const client = $kfJmY.getClient();
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $77345039f43d936d$var$startMissingRequiredParentSpan(scope, client) : $77345039f43d936d$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$77345039f43d936d$var$spanIsIgnored(activeSpan) || !parentSpan) $3zGA3._setSpanForScope(scope, activeSpan);
            return $clLeB.handleCallbackErrors(()=>callback(activeSpan), ()=>{
                const { status: status } = $8hCvI.spanToJSON(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: $d33W7.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
function $77345039f43d936d$var$startSpanManual(options, callback) {
    const acs = $77345039f43d936d$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $77345039f43d936d$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return $kfJmY.withScope(customForkedScope, ()=>{
        const wrapper = $77345039f43d936d$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = $kfJmY.getCurrentScope();
            const parentSpan = $77345039f43d936d$var$getParentSpan(scope, customParentSpan);
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $77345039f43d936d$var$startMissingRequiredParentSpan(scope, $kfJmY.getClient()) : $77345039f43d936d$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$77345039f43d936d$var$spanIsIgnored(activeSpan) || !parentSpan) $3zGA3._setSpanForScope(scope, activeSpan);
            return $clLeB.handleCallbackErrors(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                const { status: status } = $8hCvI.spanToJSON(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: $d33W7.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
            });
        });
    });
}
function $77345039f43d936d$var$startInactiveSpan(options) {
    const acs = $77345039f43d936d$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    return $77345039f43d936d$var$_startInactiveSpanImpl(options);
}
function $77345039f43d936d$var$_INTERNAL_startInactiveSpan(options) {
    return $77345039f43d936d$var$_startInactiveSpanImpl(options);
}
function $77345039f43d936d$var$_startInactiveSpanImpl(options) {
    const spanArguments = $77345039f43d936d$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    const wrapper = options.scope ? (callback)=>$kfJmY.withScope(options.scope, callback) : customParentSpan !== void 0 ? (callback)=>$77345039f43d936d$var$withActiveSpan(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = $kfJmY.getCurrentScope();
        const parentSpan = $77345039f43d936d$var$getParentSpan(scope, customParentSpan);
        const client = $kfJmY.getClient();
        const missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) return $77345039f43d936d$var$startMissingRequiredParentSpan(scope, client);
        return $77345039f43d936d$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
const $77345039f43d936d$var$continueTrace = (options, callback)=>{
    const carrier$1 = $lyqaT.getMainCarrier();
    const acs = $e3FcP.getAsyncContextStrategy(carrier$1);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage$1 } = options;
    const client = $kfJmY.getClient();
    const incomingDsc = $QBqQc.baggageHeaderToDynamicSamplingContext(baggage$1);
    if (client && !$bTcEr.shouldContinueTrace(client, incomingDsc?.org_id)) return $77345039f43d936d$var$startNewTrace(callback);
    return $kfJmY.withScope((scope)=>{
        const propagationContext = $bTcEr.propagationContextFromHeaders(sentryTrace, baggage$1);
        scope.setPropagationContext(propagationContext);
        $3zGA3._setSpanForScope(scope, void 0);
        return callback();
    });
};
function $77345039f43d936d$var$withActiveSpan(span, callback) {
    const acs = $77345039f43d936d$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return $kfJmY.withScope((scope)=>{
        $3zGA3._setSpanForScope(scope, span || void 0);
        return callback(scope);
    });
}
function $77345039f43d936d$var$suppressTracing(callback) {
    const acs = $77345039f43d936d$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return $kfJmY.withScope((scope)=>{
        scope.setSDKProcessingMetadata({
            [$77345039f43d936d$var$SUPPRESS_TRACING_KEY]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$77345039f43d936d$var$SUPPRESS_TRACING_KEY]: void 0
        });
        return res;
    });
}
function $77345039f43d936d$var$isTracingSuppressed(scope = $kfJmY.getCurrentScope()) {
    const acs = $77345039f43d936d$var$getAcs();
    if (acs.isTracingSuppressed) return acs.isTracingSuppressed(scope);
    return scope.getScopeData().sdkProcessingMetadata[$77345039f43d936d$var$SUPPRESS_TRACING_KEY] === true;
}
function $77345039f43d936d$var$startNewTrace(callback) {
    const acs = $77345039f43d936d$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return $kfJmY.withScope((scope)=>{
        scope.setPropagationContext({
            traceId: $23smo.generateTraceId(),
            sampleRand: $6ki8f.safeMathRandom()
        });
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $77345039f43d936d$var$withActiveSpan(null, callback);
    });
}
function $77345039f43d936d$var$startMissingRequiredParentSpan(scope, client) {
    client?.recordDroppedEvent("no_parent_span", "span");
    const span = new $fyn9D.SentryNonRecordingSpan({
        traceId: scope.getPropagationContext().traceId
    });
    $5K3ZQ.setCapturedScopesOnSpan(span, scope, $kfJmY.getIsolationScope());
    return span;
}
function $77345039f43d936d$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    const isolationScope = $kfJmY.getIsolationScope();
    if (!$5xQO6.hasSpansEnabled()) {
        const scopePropagationContext = scope.getPropagationContext();
        const traceId = parentSpan ? parentSpan.spanContext().traceId : scopePropagationContext.traceId;
        const span2 = new $fyn9D.SentryNonRecordingSpan({
            traceId: traceId
        });
        if (parentSpan && !forceTransaction) $8hCvI.addChildSpanToSpan(parentSpan, span2);
        $5K3ZQ.setCapturedScopesOnSpan(span2, scope, isolationScope);
        return span2;
    }
    const client = $kfJmY.getClient();
    if ($77345039f43d936d$var$_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!$77345039f43d936d$var$isTracingSuppressed(scope)) client?.recordDroppedEvent("ignored", "span");
        const ignoredSpan = new $fyn9D.SentryNonRecordingSpan({
            dropReason: "ignored",
            traceId: parentSpan?.spanContext().traceId ?? scope.getPropagationContext().traceId
        });
        if (parentSpan && !forceTransaction) $8hCvI.addChildSpanToSpan(parentSpan, ignoredSpan);
        $5K3ZQ.setCapturedScopesOnSpan(ignoredSpan, scope, isolationScope);
        return ignoredSpan;
    }
    let span;
    if (parentSpan && !forceTransaction) {
        span = $77345039f43d936d$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope);
        $8hCvI.addChildSpanToSpan(parentSpan, span);
    } else if (parentSpan) {
        const dsc = $dOSrX.getDynamicSamplingContextFromSpan(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = $8hCvI.spanIsSampled(parentSpan);
        span = $77345039f43d936d$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, isolationScope, parentSampled);
        $dOSrX.freezeDscOnSpan(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = scope.getPropagationContext();
        span = $77345039f43d936d$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, isolationScope, parentSampled);
        if (dsc) $dOSrX.freezeDscOnSpan(span, dsc);
    }
    $kSXzG.logSpanStart(span);
    return span;
}
function $77345039f43d936d$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = $8hCvI.spanTimeInputToSeconds(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $77345039f43d936d$var$getAcs() {
    const carrier$1 = $lyqaT.getMainCarrier();
    return $e3FcP.getAsyncContextStrategy(carrier$1);
}
function $77345039f43d936d$var$_startRootSpan(spanArguments, scope, isolationScope, parentSampled) {
    const client = $kfJmY.getClient();
    const options = client?.getOptions() || {};
    const { name: name = "" } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    client?.emit("beforeSampling", mutableSpanSamplingData, {
        decision: false
    });
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const _isTracingSuppressed = $77345039f43d936d$var$isTracingSuppressed(scope);
    const [sampled, sampleRate, localSampleRateWasApplied] = _isTracingSuppressed ? [
        false
    ] : $2YUNs.sampleSpan(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        normalizedRequest: isolationScope.getScopeData().sdkProcessingMetadata.normalizedRequest,
        parentSampleRate: $gQqIQ.parseSampleRate(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new $y39T9.SentrySpan({
        ...spanArguments,
        attributes: {
            [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "custom",
            [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]: sampleRate !== void 0 && localSampleRateWasApplied ? sampleRate : void 0,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client && !_isTracingSuppressed) {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", $g8Glr.hasSpanStreamingEnabled(client) ? "span" : "transaction");
    }
    $5K3ZQ.setCapturedScopesOnSpan(rootSpan, scope, isolationScope);
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
function $77345039f43d936d$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const _isTracingSuppressed = $77345039f43d936d$var$isTracingSuppressed(scope);
    const sampled = _isTracingSuppressed ? false : $8hCvI.spanIsSampled(parentSpan);
    const childSpan = sampled ? new $y39T9.SentrySpan({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new $fyn9D.SentryNonRecordingSpan({
        traceId: traceId
    });
    $8hCvI.addChildSpanToSpan(parentSpan, childSpan);
    $5K3ZQ.setCapturedScopesOnSpan(childSpan, scope, isolationScope);
    const client = $kfJmY.getClient();
    if (!client) return childSpan;
    if ($g8Glr.hasSpanStreamingEnabled(client) && $fyn9D.spanIsNonRecordingSpan(childSpan)) {
        if ($fyn9D.spanIsNonRecordingSpan(parentSpan) && parentSpan.dropReason) {
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, "span");
        } else if (!_isTracingSuppressed) {
            childSpan.dropReason = "sample_rate";
            client.recordDroppedEvent("sample_rate", "span");
        }
    }
    client.emit("spanStart", childSpan);
    if (spanArguments.endTimestamp) {
        client.emit("spanEnd", childSpan);
        client.emit("afterSpanEnd", childSpan);
    }
    return childSpan;
}
function $77345039f43d936d$var$getParentSpan(scope, customParentSpan) {
    if (customParentSpan) return customParentSpan;
    if (customParentSpan === null) return void 0;
    const span = $3zGA3._getSpanForScope(scope);
    if (!span) return void 0;
    const client = $kfJmY.getClient();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return $8hCvI.getRootSpan(span);
    return span;
}
function $77345039f43d936d$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== void 0 ? (callback)=>{
        return $77345039f43d936d$var$withActiveSpan(parentSpan, callback);
    } : (callback)=>callback();
}
function $77345039f43d936d$var$_shouldIgnoreStreamedSpan(client, spanArguments) {
    const ignoreSpans = client?.getOptions().ignoreSpans;
    if (!client || !$g8Glr.hasSpanStreamingEnabled(client) || !ignoreSpans?.length) return false;
    return $h2lAT.shouldIgnoreSpan({
        description: spanArguments.name || "",
        op: spanArguments.attributes?.[$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_OP] || spanArguments.op,
        attributes: spanArguments.attributes
    }, ignoreSpans);
}
function $77345039f43d936d$var$spanIsIgnored(span) {
    return $fyn9D.spanIsNonRecordingSpan(span) && span.dropReason === "ignored";
}
module.exports.SUPPRESS_TRACING_KEY = $77345039f43d936d$var$SUPPRESS_TRACING_KEY;
module.exports._INTERNAL_startInactiveSpan = $77345039f43d936d$var$_INTERNAL_startInactiveSpan;
module.exports.continueTrace = $77345039f43d936d$var$continueTrace;
module.exports.isTracingSuppressed = $77345039f43d936d$var$isTracingSuppressed;
module.exports.spanIsIgnored = $77345039f43d936d$var$spanIsIgnored;
module.exports.startInactiveSpan = $77345039f43d936d$var$startInactiveSpan;
module.exports.startNewTrace = $77345039f43d936d$var$startNewTrace;
module.exports.startSpan = $77345039f43d936d$var$startSpan;
module.exports.startSpanManual = $77345039f43d936d$var$startSpanManual;
module.exports.suppressTracing = $77345039f43d936d$var$suppressTracing;
module.exports.withActiveSpan = $77345039f43d936d$var$withActiveSpan;

});
parcelRegister("clLeB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fK9TE = parcelRequire("fK9TE");

var $jV7hg = parcelRequire("jV7hg");
function $8fdc15fa881416b6$var$handleCallbackErrors(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $8fdc15fa881416b6$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
function $8fdc15fa881416b6$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ($jV7hg.isThenable(value)) return $fK9TE.chainAndCopyPromiseLike(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    onFinally();
    onSuccess(value);
    return value;
}
module.exports.handleCallbackErrors = $8fdc15fa881416b6$var$handleCallbackErrors;

});

parcelRegister("2YUNs", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1GyI0 = parcelRequire("1GyI0");

var $2sm2V = parcelRequire("2sm2V");

var $5xQO6 = parcelRequire("5xQO6");

var $gQqIQ = parcelRequire("gQqIQ");
function $22bd3dfdf11c5d8e$var$sampleSpan(options, samplingContext, sampleRand) {
    if (!$5xQO6.hasSpansEnabled(options)) return [
        false
    ];
    let localSampleRateWasApplied = void 0;
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== void 0) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    const parsedSampleRate = $gQqIQ.parseSampleRate(sampleRate);
    if (parsedSampleRate === void 0) {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    if (!parsedSampleRate) {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    const shouldSample = sampleRand < parsedSampleRate;
    if (!shouldSample) $1GyI0.DEBUG_BUILD && $2sm2V.debug.log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}
module.exports.sampleSpan = $22bd3dfdf11c5d8e$var$sampleSpan;

});



parcelRegister("ivt7H", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iJap7 = parcelRequire("iJap7");

var $3i3WC = parcelRequire("3i3WC");
const $d791b68534d3e817$var$CAPTURED_SPANS = /* @__PURE__ */ new WeakSet();
const $d791b68534d3e817$var$isSpanAlreadyCaptured = (span)=>$d791b68534d3e817$var$CAPTURED_SPANS.has(span);
const $d791b68534d3e817$var$markSpanCaptured = (span)=>{
    $d791b68534d3e817$var$CAPTURED_SPANS.add(span);
};
const $d791b68534d3e817$var$CLIENT_QUEUES = /* @__PURE__ */ new WeakMap();
function $d791b68534d3e817$var$_INTERNAL_setDeferSegmentSpanCapture(client) {
    if (!$3i3WC.getSegmentSpanCaptureStrategy()) $3i3WC.setSegmentSpanCaptureStrategy($d791b68534d3e817$var$deferredSegmentSpanCaptureStrategy);
    if ($d791b68534d3e817$var$CLIENT_QUEUES.has(client)) return;
    const pendingCaptures = /* @__PURE__ */ new Set();
    const debouncedDrain = $iJap7.debounce(()=>{
        const captures = [
            ...pendingCaptures
        ];
        pendingCaptures.clear();
        for (const capture of captures)capture();
    }, 1, {
        maxWait: 100
    });
    client.on("flush", ()=>{
        debouncedDrain.flush();
    });
    $d791b68534d3e817$var$CLIENT_QUEUES.set(client, (capture)=>{
        pendingCaptures.add(capture);
        debouncedDrain();
    });
}
const $d791b68534d3e817$var$deferredSegmentSpanCaptureStrategy = {
    onSegmentSpanEnded (convert, scope) {
        const client = scope.getClient();
        const enqueue = client && $d791b68534d3e817$var$CLIENT_QUEUES.get(client);
        if (!enqueue) {
            const transactionEvent = convert();
            if (transactionEvent) client?.captureEvent(transactionEvent);
            return;
        }
        enqueue(()=>{
            const transactionEvent = convert({
                isSpanAlreadyCaptured: $d791b68534d3e817$var$isSpanAlreadyCaptured,
                onSpanCaptured: $d791b68534d3e817$var$markSpanCaptured
            });
            if (transactionEvent) client.captureEvent(transactionEvent);
        });
    },
    onChildSpanEnded (span, rootSpan, convert, scope) {
        if ($d791b68534d3e817$var$CAPTURED_SPANS.has(span) || !$d791b68534d3e817$var$CAPTURED_SPANS.has(rootSpan)) return;
        const client = scope.getClient();
        const enqueue = client && $d791b68534d3e817$var$CLIENT_QUEUES.get(client);
        const captureOrphan = ()=>{
            const transactionEvent = convert({
                isSpanAlreadyCaptured: $d791b68534d3e817$var$isSpanAlreadyCaptured,
                onSpanCaptured: $d791b68534d3e817$var$markSpanCaptured
            });
            if (transactionEvent?.contexts?.trace?.data) transactionEvent.contexts.trace.data["sentry.parent_span_already_sent"] = true;
            if (transactionEvent) client?.captureEvent(transactionEvent);
        };
        if (enqueue) enqueue(captureOrphan);
        else captureOrphan();
    }
};
module.exports._INTERNAL_setDeferSegmentSpanCapture = $d791b68534d3e817$var$_INTERNAL_setDeferSegmentSpanCapture;

});
parcelRegister("iJap7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $da247ffc794e1d4b$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options?.maxWait ? Math.max(options.maxWait, wait) : 0;
    const setTimeoutImpl = options?.setTimeoutImpl || setTimeout;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== void 0 && clearTimeout(timerId);
        maxTimerId !== void 0 && clearTimeout(maxTimerId);
        timerId = maxTimerId = void 0;
    }
    function flush() {
        if (timerId !== void 0 || maxTimerId !== void 0) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeoutImpl(invokeFunc, wait);
        if (maxWait && maxTimerId === void 0) maxTimerId = setTimeoutImpl(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
module.exports.debounce = $da247ffc794e1d4b$var$debounce;

});


parcelRegister("aqgZ8", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kfJmY = parcelRequire("kfJmY");
const $796981f2683f4c7b$var$ADD_LISTENER_METHODS = [
    "addListener",
    "on",
    "once",
    "prependListener",
    "prependOnceListener",
    "addEventListener"
];
const $796981f2683f4c7b$var$REMOVE_LISTENER_METHODS = [
    "removeListener",
    "off",
    "removeEventListener"
];
const $796981f2683f4c7b$var$SCOPE_BOUND_LISTENERS = /* @__PURE__ */ Symbol("SentryScopeBoundListeners");
let $796981f2683f4c7b$var$registeringWrapper;
function $796981f2683f4c7b$var$isReentrantWrapperRegistration(listener) {
    return $796981f2683f4c7b$var$registeringWrapper !== void 0 && (listener === $796981f2683f4c7b$var$registeringWrapper || listener.listener === $796981f2683f4c7b$var$registeringWrapper);
}
function $796981f2683f4c7b$var$bindScopeToEmitter(emitter, scope = $kfJmY.getCurrentScope()) {
    const ee = emitter;
    if ($796981f2683f4c7b$var$getPatchMap(ee)) return emitter;
    $796981f2683f4c7b$var$createPatchMap(ee);
    for (const methodName of $796981f2683f4c7b$var$ADD_LISTENER_METHODS){
        if (typeof ee[methodName] !== "function") continue;
        ee[methodName] = $796981f2683f4c7b$var$patchAddListener(ee, ee[methodName], scope);
    }
    for (const methodName of $796981f2683f4c7b$var$REMOVE_LISTENER_METHODS){
        if (typeof ee[methodName] !== "function") continue;
        ee[methodName] = $796981f2683f4c7b$var$patchRemoveListener(ee, ee[methodName]);
    }
    if (typeof ee.removeAllListeners === "function") ee.removeAllListeners = $796981f2683f4c7b$var$patchRemoveAllListeners(ee, ee.removeAllListeners);
    return emitter;
}
function $796981f2683f4c7b$var$bindListenerToScope(listener, scope) {
    return function(...args) {
        return $kfJmY.withScope(scope, ()=>listener.apply(this, args));
    };
}
function $796981f2683f4c7b$var$isBoundListener(listener) {
    return typeof listener === "function";
}
function $796981f2683f4c7b$var$patchAddListener(ee, original, scope) {
    return function(...args) {
        const event = args[0];
        const listener = args[1];
        const rest = args.slice(2);
        if (!$796981f2683f4c7b$var$isBoundListener(listener) || $796981f2683f4c7b$var$isReentrantWrapperRegistration(listener)) return original.apply(this, args);
        const map = $796981f2683f4c7b$var$getPatchMap(ee) || $796981f2683f4c7b$var$createPatchMap(ee);
        let listeners = map.get(event);
        if (!listeners) {
            listeners = /* @__PURE__ */ new WeakMap();
            map.set(event, listeners);
        }
        let boundListener = listeners.get(listener);
        if (!boundListener) {
            boundListener = $796981f2683f4c7b$var$bindListenerToScope(listener, scope);
            listeners.set(listener, boundListener);
        }
        const previous = $796981f2683f4c7b$var$registeringWrapper;
        $796981f2683f4c7b$var$registeringWrapper = boundListener;
        try {
            return original.call(this, event, boundListener, ...rest);
        } finally{
            $796981f2683f4c7b$var$registeringWrapper = previous;
        }
    };
}
function $796981f2683f4c7b$var$patchRemoveListener(ee, original) {
    return function(...args) {
        const event = args[0];
        const listener = args[1];
        const rest = args.slice(2);
        const boundListener = $796981f2683f4c7b$var$isBoundListener(listener) ? $796981f2683f4c7b$var$getPatchMap(ee)?.get(event)?.get(listener) : void 0;
        if (!boundListener) return original.apply(this, args);
        return original.call(this, event, boundListener, ...rest);
    };
}
function $796981f2683f4c7b$var$patchRemoveAllListeners(ee, original) {
    return function(...args) {
        const map = $796981f2683f4c7b$var$getPatchMap(ee);
        if (map) {
            if (args.length === 0) $796981f2683f4c7b$var$createPatchMap(ee);
            else {
                const event = args[0];
                map.delete(event);
            }
        }
        return original.apply(this, args);
    };
}
function $796981f2683f4c7b$var$createPatchMap(ee) {
    const map = /* @__PURE__ */ new Map();
    ee[$796981f2683f4c7b$var$SCOPE_BOUND_LISTENERS] = map;
    return map;
}
function $796981f2683f4c7b$var$getPatchMap(ee) {
    return ee[$796981f2683f4c7b$var$SCOPE_BOUND_LISTENERS];
}
module.exports.bindScopeToEmitter = $796981f2683f4c7b$var$bindScopeToEmitter;

});

parcelRegister("2ZTbI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2JysJ = parcelRequire("2JysJ");

var $dGSc0 = parcelRequire("dGSc0");

var $8hCvI = parcelRequire("8hCvI");

var $5K3ZQ = parcelRequire("5K3ZQ");

var $7O6Z7 = parcelRequire("7O6Z7");

var $2CVCb = parcelRequire("2CVCb");

var $QGp01 = parcelRequire("QGp01");

var $3tmPs = parcelRequire("3tmPs");
function $22ec16747b2596c3$var$captureSpan(span, client) {
    const spanJSON = $8hCvI.spanToStreamedSpanJSON(span);
    const segmentSpan = $8hCvI.INTERNAL_getSegmentSpan(span);
    const serializedSegmentSpan = $8hCvI.spanToStreamedSpanJSON(segmentSpan);
    const { isolationScope: spanIsolationScope, scope: spanScope } = $5K3ZQ.getCapturedScopesOnSpan(span);
    const finalScopeData = $dGSc0.getCombinedScopeData(spanIsolationScope, spanScope);
    $22ec16747b2596c3$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, finalScopeData);
    const spanKind = span.kind;
    client.emit("preprocessSpan", spanJSON, {
        spanKind: spanKind
    });
    if (spanJSON.is_segment) {
        $22ec16747b2596c3$var$applyScopeToSegmentSpan(spanJSON, finalScopeData);
        $22ec16747b2596c3$var$applySdkMetadataToSegmentSpan(spanJSON, client);
        client.emit("processSegmentSpan", spanJSON);
    }
    client.emit("processSpan", spanJSON);
    const { beforeSendSpan: beforeSendSpan$1 } = client.getOptions();
    const processedSpan = beforeSendSpan$1 && $7O6Z7.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? $22ec16747b2596c3$var$applyBeforeSendSpanCallback(spanJSON, beforeSendSpan$1) : spanJSON;
    const spanNameSource = processedSpan.attributes?.[$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    if (spanJSON.is_segment && spanNameSource) $22ec16747b2596c3$var$safeSetSpanJSONAttributes(processedSpan, {
        ["sentry.segment.name.source"]: spanNameSource
    });
    return {
        ...$8hCvI.streamedSpanJsonToSerializedSpan(processedSpan),
        _segmentSpan: segmentSpan
    };
}
function $22ec16747b2596c3$var$applyScopeToSegmentSpan(segmentSpanJSON, scopeData) {
    const contextAttributes = $2CVCb.scopeContextsToSpanAttributes(scopeData.contexts);
    $22ec16747b2596c3$var$safeSetSpanJSONAttributes(segmentSpanJSON, contextAttributes);
}
function $22ec16747b2596c3$var$safeSetSpanJSONAttributes(spanJSON, newAttributes) {
    const originalAttributes = spanJSON.attributes ?? (spanJSON.attributes = {});
    Object.entries(newAttributes).forEach(([key, value])=>{
        if (value != null && !(key in originalAttributes)) originalAttributes[key] = value;
    });
}
function $22ec16747b2596c3$var$applySdkMetadataToSegmentSpan(segmentSpanJSON, client) {
    const integrationNames = client.getIntegrationNames();
    if (!integrationNames.length) return;
    $22ec16747b2596c3$var$safeSetSpanJSONAttributes(segmentSpanJSON, {
        [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS]: integrationNames
    });
}
function $22ec16747b2596c3$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, scopeData) {
    const sdk = client.getSdkMetadata();
    const { release: release, environment: environment } = client.getOptions();
    $22ec16747b2596c3$var$safeSetSpanJSONAttributes(spanJSON, {
        [$3tmPs.SENTRY_TRACE_LIFECYCLE]: "stream",
        [$3tmPs.SENTRY_SEGMENT_NAME]: serializedSegmentSpan.name,
        [$3tmPs.SENTRY_SEGMENT_ID]: serializedSegmentSpan.span_id,
        [$3tmPs.SENTRY_SDK_NAME]: sdk?.sdk?.name,
        [$3tmPs.SENTRY_SDK_VERSION]: sdk?.sdk?.version,
        [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE]: release,
        [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT]: environment || $QGp01.DEFAULT_ENVIRONMENT,
        [$2JysJ.SEMANTIC_ATTRIBUTE_USER_ID]: scopeData.user?.id,
        [$2JysJ.SEMANTIC_ATTRIBUTE_USER_EMAIL]: scopeData.user?.email,
        [$2JysJ.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: scopeData.user?.ip_address,
        [$2JysJ.SEMANTIC_ATTRIBUTE_USER_USERNAME]: scopeData.user?.username,
        ...scopeData.attributes
    });
}
function $22ec16747b2596c3$var$applyBeforeSendSpanCallback(span, beforeSendSpan) {
    const modifedSpan = beforeSendSpan(span);
    if (!modifedSpan) {
        $8hCvI.showSpanDropWarning();
        return span;
    }
    return modifedSpan;
}
module.exports.applyBeforeSendSpanCallback = $22ec16747b2596c3$var$applyBeforeSendSpanCallback;
module.exports.captureSpan = $22ec16747b2596c3$var$captureSpan;
module.exports.safeSetSpanJSONAttributes = $22ec16747b2596c3$var$safeSetSpanJSONAttributes;

});
parcelRegister("dGSc0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kfJmY = parcelRequire("kfJmY");

var $dOSrX = parcelRequire("dOSrX");

var $aupof = parcelRequire("aupof");

var $8hCvI = parcelRequire("8hCvI");
function $9f793c1eaab04b49$var$applyScopeDataToEvent(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    $9f793c1eaab04b49$var$applyDataToEvent(event, data);
    if (span) $9f793c1eaab04b49$var$applySpanToEvent(event, span);
    $9f793c1eaab04b49$var$applyFingerprintToEvent(event, fingerprint);
    $9f793c1eaab04b49$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $9f793c1eaab04b49$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
function $9f793c1eaab04b49$var$mergeScopeData(data, mergeData) {
    const { extra: extra, tags: tags, attributes: attributes, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $9f793c1eaab04b49$var$mergeAndOverwriteScopeData(data, "extra", extra);
    $9f793c1eaab04b49$var$mergeAndOverwriteScopeData(data, "tags", tags);
    $9f793c1eaab04b49$var$mergeAndOverwriteScopeData(data, "attributes", attributes);
    $9f793c1eaab04b49$var$mergeAndOverwriteScopeData(data, "user", user);
    $9f793c1eaab04b49$var$mergeAndOverwriteScopeData(data, "contexts", contexts);
    data.sdkProcessingMetadata = $aupof.merge(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
function $9f793c1eaab04b49$var$mergeAndOverwriteScopeData(data, prop, mergeVal) {
    data[prop] = $aupof.merge(data[prop], mergeVal, 1);
}
function $9f793c1eaab04b49$var$getCombinedScopeData(isolationScope, currentScope) {
    const scopeData = $kfJmY.getGlobalScope().getScopeData();
    isolationScope && $9f793c1eaab04b49$var$mergeScopeData(scopeData, isolationScope.getScopeData());
    currentScope && $9f793c1eaab04b49$var$mergeScopeData(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $9f793c1eaab04b49$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $9f793c1eaab04b49$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : void 0;
}
function $9f793c1eaab04b49$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $9f793c1eaab04b49$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: $8hCvI.spanToTraceContext(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: $dOSrX.getDynamicSamplingContextFromSpan(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = $8hCvI.getRootSpan(span);
    const transactionName = $8hCvI.spanToJSON(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
function $9f793c1eaab04b49$var$applyFingerprintToEvent(event, fingerprint) {
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    if (!event.fingerprint.length) delete event.fingerprint;
}
module.exports.applyScopeDataToEvent = $9f793c1eaab04b49$var$applyScopeDataToEvent;
module.exports.getCombinedScopeData = $9f793c1eaab04b49$var$getCombinedScopeData;
module.exports.mergeAndOverwriteScopeData = $9f793c1eaab04b49$var$mergeAndOverwriteScopeData;
module.exports.mergeScopeData = $9f793c1eaab04b49$var$mergeScopeData;

});

parcelRegister("2CVCb", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $1e9bd27c119f3e21$var$scopeContextsToSpanAttributes(contexts) {
    const attrs = {};
    const { response: response, profile: profile, cloud_resource: cloud_resource, culture: culture, state: state } = contexts;
    if (response) {
        if (response.status_code != null) attrs["http.response.status_code"] = response.status_code;
        if (response.body_size != null) attrs["http.response.body.size"] = response.body_size;
    }
    if (profile) {
        if (profile.profile_id) attrs["sentry.profile_id"] = profile.profile_id;
        if (profile.profiler_id) attrs["sentry.profiler_id"] = profile.profiler_id;
    }
    if (cloud_resource) {
        for (const [key, value] of Object.entries(cloud_resource))if (value != null) attrs[key] = value;
    }
    if (culture) {
        if (culture.locale) attrs["culture.locale"] = culture.locale;
        if (culture.timezone) attrs["culture.timezone"] = culture.timezone;
    }
    if (state?.state && typeof state.state.type === "string") attrs["state.type"] = state.state.type;
    const angular = contexts["angular"];
    if (angular) {
        const version = angular["version"];
        if (typeof version === "string" || typeof version === "number") attrs["angular.version"] = version;
    }
    const react = contexts["react"];
    if (react) {
        const version = react["version"];
        if (typeof version === "string" || typeof version === "number") attrs["react.version"] = version;
    }
    return attrs;
}
module.exports.scopeContextsToSpanAttributes = $1e9bd27c119f3e21$var$scopeContextsToSpanAttributes;

});

parcelRegister("3tmPs", function(module, exports) {
// This file is a compatibility shim for bundlers (e.g. webpack 4) that do not
// support the package.json `exports` field for resolving subpath exports.

module.exports = (parcelRequire("8YfwI"));

});
parcelRegister("8YfwI", function(module, exports) {
$parcel$export(module.exports, "AI_CITATIONS", () => $687ff8957497b063$export$b60c5e9f9b7b58bd, (v) => $687ff8957497b063$export$b60c5e9f9b7b58bd = v);
$parcel$export(module.exports, "AI_COMPLETION_TOKENS_USED", () => $687ff8957497b063$export$cc06afd6de7f2c10, (v) => $687ff8957497b063$export$cc06afd6de7f2c10 = v);
$parcel$export(module.exports, "AI_DOCUMENTS", () => $687ff8957497b063$export$ced6746028fe2cc, (v) => $687ff8957497b063$export$ced6746028fe2cc = v);
$parcel$export(module.exports, "AI_FINISH_REASON", () => $687ff8957497b063$export$e6f4aa4f4fcb6da8, (v) => $687ff8957497b063$export$e6f4aa4f4fcb6da8 = v);
$parcel$export(module.exports, "AI_FREQUENCY_PENALTY", () => $687ff8957497b063$export$f02d892201cd8d36, (v) => $687ff8957497b063$export$f02d892201cd8d36 = v);
$parcel$export(module.exports, "AI_FUNCTION_CALL", () => $687ff8957497b063$export$f277a7ef9e273960, (v) => $687ff8957497b063$export$f277a7ef9e273960 = v);
$parcel$export(module.exports, "AI_GENERATION_ID", () => $687ff8957497b063$export$1a8c212c3becaa80, (v) => $687ff8957497b063$export$1a8c212c3becaa80 = v);
$parcel$export(module.exports, "AI_INPUT_MESSAGES", () => $687ff8957497b063$export$721b137086c68a47, (v) => $687ff8957497b063$export$721b137086c68a47 = v);
$parcel$export(module.exports, "AI_IS_SEARCH_REQUIRED", () => $687ff8957497b063$export$6afde2bb69d9aa86, (v) => $687ff8957497b063$export$6afde2bb69d9aa86 = v);
$parcel$export(module.exports, "AI_METADATA", () => $687ff8957497b063$export$eadb4b562c974031, (v) => $687ff8957497b063$export$eadb4b562c974031 = v);
$parcel$export(module.exports, "AI_MODEL_ID", () => $687ff8957497b063$export$22a90f0ac1eee843, (v) => $687ff8957497b063$export$22a90f0ac1eee843 = v);
$parcel$export(module.exports, "AI_MODEL_PROVIDER", () => $687ff8957497b063$export$a727f215a0be1dad, (v) => $687ff8957497b063$export$a727f215a0be1dad = v);
$parcel$export(module.exports, "AI_PIPELINE_NAME", () => $687ff8957497b063$export$536bc61b34d995e5, (v) => $687ff8957497b063$export$536bc61b34d995e5 = v);
$parcel$export(module.exports, "AI_PREAMBLE", () => $687ff8957497b063$export$c43ea6115b380e62, (v) => $687ff8957497b063$export$c43ea6115b380e62 = v);
$parcel$export(module.exports, "AI_PRESENCE_PENALTY", () => $687ff8957497b063$export$d2a16e26bada7cf1, (v) => $687ff8957497b063$export$d2a16e26bada7cf1 = v);
$parcel$export(module.exports, "AI_PROMPT_TOKENS_USED", () => $687ff8957497b063$export$604eb1bd2278163b, (v) => $687ff8957497b063$export$604eb1bd2278163b = v);
$parcel$export(module.exports, "AI_RAW_PROMPTING", () => $687ff8957497b063$export$2f8568696c5aa352, (v) => $687ff8957497b063$export$2f8568696c5aa352 = v);
$parcel$export(module.exports, "AI_RESPONSES", () => $687ff8957497b063$export$ccc8efd7dd31d3a9, (v) => $687ff8957497b063$export$ccc8efd7dd31d3a9 = v);
$parcel$export(module.exports, "AI_RESPONSE_FORMAT", () => $687ff8957497b063$export$e176bf5dc45e40df, (v) => $687ff8957497b063$export$e176bf5dc45e40df = v);
$parcel$export(module.exports, "AI_SEARCH_QUERIES", () => $687ff8957497b063$export$c4ea01fd53f64e16, (v) => $687ff8957497b063$export$c4ea01fd53f64e16 = v);
$parcel$export(module.exports, "AI_SEARCH_RESULTS", () => $687ff8957497b063$export$bb5e6f2f31a15da9, (v) => $687ff8957497b063$export$bb5e6f2f31a15da9 = v);
$parcel$export(module.exports, "AI_SEED", () => $687ff8957497b063$export$1762c11b666b026a, (v) => $687ff8957497b063$export$1762c11b666b026a = v);
$parcel$export(module.exports, "AI_STREAMING", () => $687ff8957497b063$export$14ddd4b729910100, (v) => $687ff8957497b063$export$14ddd4b729910100 = v);
$parcel$export(module.exports, "AI_TAGS", () => $687ff8957497b063$export$5311d7c8e1f8eabb, (v) => $687ff8957497b063$export$5311d7c8e1f8eabb = v);
$parcel$export(module.exports, "AI_TEMPERATURE", () => $687ff8957497b063$export$2b748b9eca00828b, (v) => $687ff8957497b063$export$2b748b9eca00828b = v);
$parcel$export(module.exports, "AI_TEXTS", () => $687ff8957497b063$export$5af25308c11addea, (v) => $687ff8957497b063$export$5af25308c11addea = v);
$parcel$export(module.exports, "AI_TOOLS", () => $687ff8957497b063$export$28f78b3b1663cb92, (v) => $687ff8957497b063$export$28f78b3b1663cb92 = v);
$parcel$export(module.exports, "AI_TOOL_CALLS", () => $687ff8957497b063$export$a1d3f09f0f1f066f, (v) => $687ff8957497b063$export$a1d3f09f0f1f066f = v);
$parcel$export(module.exports, "AI_TOP_K", () => $687ff8957497b063$export$322bd4ea9f163663, (v) => $687ff8957497b063$export$322bd4ea9f163663 = v);
$parcel$export(module.exports, "AI_TOP_P", () => $687ff8957497b063$export$95711b9e669edad8, (v) => $687ff8957497b063$export$95711b9e669edad8 = v);
$parcel$export(module.exports, "AI_TOTAL_COST", () => $687ff8957497b063$export$5924d7d72384626a, (v) => $687ff8957497b063$export$5924d7d72384626a = v);
$parcel$export(module.exports, "AI_TOTAL_TOKENS_USED", () => $687ff8957497b063$export$db3b1b877a4ce4db, (v) => $687ff8957497b063$export$db3b1b877a4ce4db = v);
$parcel$export(module.exports, "AI_WARNINGS", () => $687ff8957497b063$export$a434a3e8afec2879, (v) => $687ff8957497b063$export$a434a3e8afec2879 = v);
$parcel$export(module.exports, "ANGULAR_VERSION", () => $687ff8957497b063$export$fe00bb20636d42af, (v) => $687ff8957497b063$export$fe00bb20636d42af = v);
$parcel$export(module.exports, "APP_APP_BUILD", () => $687ff8957497b063$export$712aa698b7ee271e, (v) => $687ff8957497b063$export$712aa698b7ee271e = v);
$parcel$export(module.exports, "APP_APP_IDENTIFIER", () => $687ff8957497b063$export$1fac638b11ec16d9, (v) => $687ff8957497b063$export$1fac638b11ec16d9 = v);
$parcel$export(module.exports, "APP_APP_NAME", () => $687ff8957497b063$export$d132016ea64058e3, (v) => $687ff8957497b063$export$d132016ea64058e3 = v);
$parcel$export(module.exports, "APP_APP_START_TIME", () => $687ff8957497b063$export$53f2f47ec3b2f9ed, (v) => $687ff8957497b063$export$53f2f47ec3b2f9ed = v);
$parcel$export(module.exports, "APP_APP_VERSION", () => $687ff8957497b063$export$9f80c4b11053cef1, (v) => $687ff8957497b063$export$9f80c4b11053cef1 = v);
$parcel$export(module.exports, "APP_BUILD", () => $687ff8957497b063$export$5f7a08466d84e877, (v) => $687ff8957497b063$export$5f7a08466d84e877 = v);
$parcel$export(module.exports, "APP_IDENTIFIER", () => $687ff8957497b063$export$2cea7f14750b8c19, (v) => $687ff8957497b063$export$2cea7f14750b8c19 = v);
$parcel$export(module.exports, "APP_IN_FOREGROUND", () => $687ff8957497b063$export$34c59270f032a6c6, (v) => $687ff8957497b063$export$34c59270f032a6c6 = v);
$parcel$export(module.exports, "APP_NAME", () => $687ff8957497b063$export$5b6c28c7dca07ad7, (v) => $687ff8957497b063$export$5b6c28c7dca07ad7 = v);
$parcel$export(module.exports, "APP_START_COLD", () => $687ff8957497b063$export$1dc8ae58b58d6c50, (v) => $687ff8957497b063$export$1dc8ae58b58d6c50 = v);
$parcel$export(module.exports, "APP_START_TIME", () => $687ff8957497b063$export$ba267414e3c0d822, (v) => $687ff8957497b063$export$ba267414e3c0d822 = v);
$parcel$export(module.exports, "APP_START_TYPE", () => $687ff8957497b063$export$71b176005902b99e, (v) => $687ff8957497b063$export$71b176005902b99e = v);
$parcel$export(module.exports, "APP_START_WARM", () => $687ff8957497b063$export$5c5b5a3c245a0079, (v) => $687ff8957497b063$export$5c5b5a3c245a0079 = v);
$parcel$export(module.exports, "APP_VERSION", () => $687ff8957497b063$export$8ee1df3c6367a60, (v) => $687ff8957497b063$export$8ee1df3c6367a60 = v);
$parcel$export(module.exports, "APP_VITALS_FRAMES_DELAY_VALUE", () => $687ff8957497b063$export$e8c7802ae95beccf, (v) => $687ff8957497b063$export$e8c7802ae95beccf = v);
$parcel$export(module.exports, "APP_VITALS_FRAMES_FROZEN_COUNT", () => $687ff8957497b063$export$bb237734da4d464, (v) => $687ff8957497b063$export$bb237734da4d464 = v);
$parcel$export(module.exports, "APP_VITALS_FRAMES_SLOW_COUNT", () => $687ff8957497b063$export$cdaaf6d1fdcba0b6, (v) => $687ff8957497b063$export$cdaaf6d1fdcba0b6 = v);
$parcel$export(module.exports, "APP_VITALS_FRAMES_TOTAL_COUNT", () => $687ff8957497b063$export$36223ebd4a30e9f5, (v) => $687ff8957497b063$export$36223ebd4a30e9f5 = v);
$parcel$export(module.exports, "APP_VITALS_START_COLD_VALUE", () => $687ff8957497b063$export$8feaa177bb7941e2, (v) => $687ff8957497b063$export$8feaa177bb7941e2 = v);
$parcel$export(module.exports, "APP_VITALS_START_PREWARMED", () => $687ff8957497b063$export$e1ca25240db91d68, (v) => $687ff8957497b063$export$e1ca25240db91d68 = v);
$parcel$export(module.exports, "APP_VITALS_START_REASON", () => $687ff8957497b063$export$404a223fd1ada08b, (v) => $687ff8957497b063$export$404a223fd1ada08b = v);
$parcel$export(module.exports, "APP_VITALS_START_SCREEN", () => $687ff8957497b063$export$53362079310c68, (v) => $687ff8957497b063$export$53362079310c68 = v);
$parcel$export(module.exports, "APP_VITALS_START_TYPE", () => $687ff8957497b063$export$3efb5af0ac379f77, (v) => $687ff8957497b063$export$3efb5af0ac379f77 = v);
$parcel$export(module.exports, "APP_VITALS_START_WARM_VALUE", () => $687ff8957497b063$export$2c10c1ca0612c46d, (v) => $687ff8957497b063$export$2c10c1ca0612c46d = v);
$parcel$export(module.exports, "APP_VITALS_TTFD_VALUE", () => $687ff8957497b063$export$bbb86ad4d6654da6, (v) => $687ff8957497b063$export$bbb86ad4d6654da6 = v);
$parcel$export(module.exports, "APP_VITALS_TTID_VALUE", () => $687ff8957497b063$export$ad6896f00a2b1076, (v) => $687ff8957497b063$export$ad6896f00a2b1076 = v);
$parcel$export(module.exports, "ART_GC_BLOCKING_COUNT", () => $687ff8957497b063$export$300f39d8506a273d, (v) => $687ff8957497b063$export$300f39d8506a273d = v);
$parcel$export(module.exports, "ART_GC_BLOCKING_TIME", () => $687ff8957497b063$export$ecaa0e7f4773ddc7, (v) => $687ff8957497b063$export$ecaa0e7f4773ddc7 = v);
$parcel$export(module.exports, "ART_GC_PRE_OOME_COUNT", () => $687ff8957497b063$export$74b78acb4c54c06b, (v) => $687ff8957497b063$export$74b78acb4c54c06b = v);
$parcel$export(module.exports, "ART_GC_TOTAL_COUNT", () => $687ff8957497b063$export$b15b2c133bc50e33, (v) => $687ff8957497b063$export$b15b2c133bc50e33 = v);
$parcel$export(module.exports, "ART_GC_TOTAL_TIME", () => $687ff8957497b063$export$5f1381d9ae1b1c95, (v) => $687ff8957497b063$export$5f1381d9ae1b1c95 = v);
$parcel$export(module.exports, "ART_GC_WAITING_TIME", () => $687ff8957497b063$export$c170b7ff277132ea, (v) => $687ff8957497b063$export$c170b7ff277132ea = v);
$parcel$export(module.exports, "ART_MEMORY_FREE", () => $687ff8957497b063$export$9459a5df93695e45, (v) => $687ff8957497b063$export$9459a5df93695e45 = v);
$parcel$export(module.exports, "ART_MEMORY_FREE_UNTIL_GC", () => $687ff8957497b063$export$a7902bd57492ebe8, (v) => $687ff8957497b063$export$a7902bd57492ebe8 = v);
$parcel$export(module.exports, "ART_MEMORY_FREE_UNTIL_OOME", () => $687ff8957497b063$export$d2ace0da59da09b7, (v) => $687ff8957497b063$export$d2ace0da59da09b7 = v);
$parcel$export(module.exports, "ART_MEMORY_MAX", () => $687ff8957497b063$export$c15dd8d2461e0aeb, (v) => $687ff8957497b063$export$c15dd8d2461e0aeb = v);
$parcel$export(module.exports, "ART_MEMORY_TOTAL", () => $687ff8957497b063$export$5405b0a98e00e538, (v) => $687ff8957497b063$export$5405b0a98e00e538 = v);
$parcel$export(module.exports, "ATTRIBUTE_METADATA", () => $687ff8957497b063$export$bd393bbb84b309d3, (v) => $687ff8957497b063$export$bd393bbb84b309d3 = v);
$parcel$export(module.exports, "ATTRIBUTE_TYPE", () => $687ff8957497b063$export$96f586f8837b86ae, (v) => $687ff8957497b063$export$96f586f8837b86ae = v);
$parcel$export(module.exports, "AWS_CLOUDWATCH_LOGS_LOG_GROUP", () => $687ff8957497b063$export$5d9f28f388f552d2, (v) => $687ff8957497b063$export$5d9f28f388f552d2 = v);
$parcel$export(module.exports, "AWS_CLOUDWATCH_LOGS_LOG_STREAM", () => $687ff8957497b063$export$b3d2f68e0e769504, (v) => $687ff8957497b063$export$b3d2f68e0e769504 = v);
$parcel$export(module.exports, "AWS_CLOUDWATCH_LOGS_URL", () => $687ff8957497b063$export$2c98412ed43013e8, (v) => $687ff8957497b063$export$2c98412ed43013e8 = v);
$parcel$export(module.exports, "AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS", () => $687ff8957497b063$export$a7bd794d11c19f1b, (v) => $687ff8957497b063$export$a7bd794d11c19f1b = v);
$parcel$export(module.exports, "AWS_DYNAMODB_CONSISTENT_READ", () => $687ff8957497b063$export$df4227832b83fdd0, (v) => $687ff8957497b063$export$df4227832b83fdd0 = v);
$parcel$export(module.exports, "AWS_DYNAMODB_CONSUMED_CAPACITY", () => $687ff8957497b063$export$f131a6d8fbc0534f, (v) => $687ff8957497b063$export$f131a6d8fbc0534f = v);
$parcel$export(module.exports, "AWS_DYNAMODB_COUNT", () => $687ff8957497b063$export$9bdc66d4a70e7e3a, (v) => $687ff8957497b063$export$9bdc66d4a70e7e3a = v);
$parcel$export(module.exports, "AWS_DYNAMODB_EXCLUSIVE_START_TABLE", () => $687ff8957497b063$export$bfbbc3cbcaa90e98, (v) => $687ff8957497b063$export$bfbbc3cbcaa90e98 = v);
$parcel$export(module.exports, "AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES", () => $687ff8957497b063$export$3565fa72459aa4d6, (v) => $687ff8957497b063$export$3565fa72459aa4d6 = v);
$parcel$export(module.exports, "AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES", () => $687ff8957497b063$export$bb67a834ae4bffdc, (v) => $687ff8957497b063$export$bb67a834ae4bffdc = v);
$parcel$export(module.exports, "AWS_DYNAMODB_INDEX_NAME", () => $687ff8957497b063$export$4a06c859a283f06, (v) => $687ff8957497b063$export$4a06c859a283f06 = v);
$parcel$export(module.exports, "AWS_DYNAMODB_ITEM_COLLECTION_METRICS", () => $687ff8957497b063$export$68324fac2038d0f2, (v) => $687ff8957497b063$export$68324fac2038d0f2 = v);
$parcel$export(module.exports, "AWS_DYNAMODB_LIMIT", () => $687ff8957497b063$export$5e1bd62ffd2786fb, (v) => $687ff8957497b063$export$5e1bd62ffd2786fb = v);
$parcel$export(module.exports, "AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES", () => $687ff8957497b063$export$bfdf2261058f56b, (v) => $687ff8957497b063$export$bfdf2261058f56b = v);
$parcel$export(module.exports, "AWS_DYNAMODB_PROJECTION", () => $687ff8957497b063$export$23bf57842d9d53df, (v) => $687ff8957497b063$export$23bf57842d9d53df = v);
$parcel$export(module.exports, "AWS_DYNAMODB_PROVISIONED_READ_CAPACITY", () => $687ff8957497b063$export$bfbd7e060eeb4d35, (v) => $687ff8957497b063$export$bfbd7e060eeb4d35 = v);
$parcel$export(module.exports, "AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY", () => $687ff8957497b063$export$82eb6cccda27c3ff, (v) => $687ff8957497b063$export$82eb6cccda27c3ff = v);
$parcel$export(module.exports, "AWS_DYNAMODB_SCANNED_COUNT", () => $687ff8957497b063$export$8ea68734d455808f, (v) => $687ff8957497b063$export$8ea68734d455808f = v);
$parcel$export(module.exports, "AWS_DYNAMODB_SCAN_FORWARD", () => $687ff8957497b063$export$40050e29324d44ee, (v) => $687ff8957497b063$export$40050e29324d44ee = v);
$parcel$export(module.exports, "AWS_DYNAMODB_SEGMENT", () => $687ff8957497b063$export$5cd7541006d9f467, (v) => $687ff8957497b063$export$5cd7541006d9f467 = v);
$parcel$export(module.exports, "AWS_DYNAMODB_SELECT", () => $687ff8957497b063$export$81c017edd95d692e, (v) => $687ff8957497b063$export$81c017edd95d692e = v);
$parcel$export(module.exports, "AWS_DYNAMODB_TABLE_COUNT", () => $687ff8957497b063$export$120b3897a58cf903, (v) => $687ff8957497b063$export$120b3897a58cf903 = v);
$parcel$export(module.exports, "AWS_DYNAMODB_TABLE_NAMES", () => $687ff8957497b063$export$d4a9de43b4b1076c, (v) => $687ff8957497b063$export$d4a9de43b4b1076c = v);
$parcel$export(module.exports, "AWS_DYNAMODB_TOTAL_SEGMENTS", () => $687ff8957497b063$export$f37f4f9022f1ab17, (v) => $687ff8957497b063$export$f37f4f9022f1ab17 = v);
$parcel$export(module.exports, "AWS_EXTENDED_REQUEST_ID", () => $687ff8957497b063$export$66ac18da14747cfb, (v) => $687ff8957497b063$export$66ac18da14747cfb = v);
$parcel$export(module.exports, "AWS_KINESIS_STREAM_NAME", () => $687ff8957497b063$export$9e49b833525ca49d, (v) => $687ff8957497b063$export$9e49b833525ca49d = v);
$parcel$export(module.exports, "AWS_LAMBDA_AWS_REQUEST_ID", () => $687ff8957497b063$export$b084fea5b3097227, (v) => $687ff8957497b063$export$b084fea5b3097227 = v);
$parcel$export(module.exports, "AWS_LAMBDA_EXECUTION_DURATION_IN_MILLIS", () => $687ff8957497b063$export$e09cd8615652e8d0, (v) => $687ff8957497b063$export$e09cd8615652e8d0 = v);
$parcel$export(module.exports, "AWS_LAMBDA_FUNCTION_NAME", () => $687ff8957497b063$export$a43a60ec723a90ee, (v) => $687ff8957497b063$export$a43a60ec723a90ee = v);
$parcel$export(module.exports, "AWS_LAMBDA_FUNCTION_VERSION", () => $687ff8957497b063$export$34cc955357266287, (v) => $687ff8957497b063$export$34cc955357266287 = v);
$parcel$export(module.exports, "AWS_LAMBDA_INVOKED_ARN", () => $687ff8957497b063$export$d9dd218693ea9bba, (v) => $687ff8957497b063$export$d9dd218693ea9bba = v);
$parcel$export(module.exports, "AWS_LAMBDA_INVOKED_FUNCTION_ARN", () => $687ff8957497b063$export$c9649b7156282a2f, (v) => $687ff8957497b063$export$c9649b7156282a2f = v);
$parcel$export(module.exports, "AWS_LAMBDA_REMAINING_TIME_IN_MILLIS", () => $687ff8957497b063$export$daa8ce1f8adc553e, (v) => $687ff8957497b063$export$daa8ce1f8adc553e = v);
$parcel$export(module.exports, "AWS_LOG_GROUP_NAMES", () => $687ff8957497b063$export$cb93c7b05db202cf, (v) => $687ff8957497b063$export$cb93c7b05db202cf = v);
$parcel$export(module.exports, "AWS_LOG_STREAM_NAMES", () => $687ff8957497b063$export$930f9bd3cc2e5b3d, (v) => $687ff8957497b063$export$930f9bd3cc2e5b3d = v);
$parcel$export(module.exports, "AWS_REQUEST_EXTENDED_ID", () => $687ff8957497b063$export$48c6d4c44afdc0b, (v) => $687ff8957497b063$export$48c6d4c44afdc0b = v);
$parcel$export(module.exports, "AWS_REQUEST_ID", () => $687ff8957497b063$export$c78d41789fe4b1e4, (v) => $687ff8957497b063$export$c78d41789fe4b1e4 = v);
$parcel$export(module.exports, "AWS_S3_BUCKET", () => $687ff8957497b063$export$f462d9921f1f7332, (v) => $687ff8957497b063$export$f462d9921f1f7332 = v);
$parcel$export(module.exports, "AWS_SECRETSMANAGER_SECRET_ARN", () => $687ff8957497b063$export$bc71f8df9a45e243, (v) => $687ff8957497b063$export$bc71f8df9a45e243 = v);
$parcel$export(module.exports, "AWS_SNS_TOPIC_ARN", () => $687ff8957497b063$export$ed840ec4a5f5d053, (v) => $687ff8957497b063$export$ed840ec4a5f5d053 = v);
$parcel$export(module.exports, "AWS_STEP_FUNCTIONS_ACTIVITY_ARN", () => $687ff8957497b063$export$c1a559a4f74a5e8e, (v) => $687ff8957497b063$export$c1a559a4f74a5e8e = v);
$parcel$export(module.exports, "AWS_STEP_FUNCTIONS_STATE_MACHINE_ARN", () => $687ff8957497b063$export$d1c007424092e3f5, (v) => $687ff8957497b063$export$d1c007424092e3f5 = v);
$parcel$export(module.exports, "BLOCKED_MAIN_THREAD", () => $687ff8957497b063$export$9ebb466ce954c49c, (v) => $687ff8957497b063$export$9ebb466ce954c49c = v);
$parcel$export(module.exports, "BROWSER_NAME", () => $687ff8957497b063$export$e9aafc7348984403, (v) => $687ff8957497b063$export$e9aafc7348984403 = v);
$parcel$export(module.exports, "BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START", () => $687ff8957497b063$export$faaa46964f075237, (v) => $687ff8957497b063$export$faaa46964f075237 = v);
$parcel$export(module.exports, "BROWSER_PERFORMANCE_TIME_ORIGIN", () => $687ff8957497b063$export$d28c4b3cc4431a87, (v) => $687ff8957497b063$export$d28c4b3cc4431a87 = v);
$parcel$export(module.exports, "BROWSER_REPORT_TYPE", () => $687ff8957497b063$export$734b017b330c8fe6, (v) => $687ff8957497b063$export$734b017b330c8fe6 = v);
$parcel$export(module.exports, "BROWSER_SCRIPT_INVOKER", () => $687ff8957497b063$export$683ebdc48ba3758d, (v) => $687ff8957497b063$export$683ebdc48ba3758d = v);
$parcel$export(module.exports, "BROWSER_SCRIPT_INVOKER_TYPE", () => $687ff8957497b063$export$be0263971250ef44, (v) => $687ff8957497b063$export$be0263971250ef44 = v);
$parcel$export(module.exports, "BROWSER_SCRIPT_SOURCE_CHAR_POSITION", () => $687ff8957497b063$export$36a0cbc35c405232, (v) => $687ff8957497b063$export$36a0cbc35c405232 = v);
$parcel$export(module.exports, "BROWSER_VERSION", () => $687ff8957497b063$export$469f7765ba335497, (v) => $687ff8957497b063$export$469f7765ba335497 = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_CLS_REPORT_EVENT", () => $687ff8957497b063$export$fe6fe2b7af051610, (v) => $687ff8957497b063$export$fe6fe2b7af051610 = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_CLS_SOURCE_KEY", () => $687ff8957497b063$export$8345821877c4dfad, (v) => $687ff8957497b063$export$8345821877c4dfad = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_CLS_SOURCE_KEY_BASE", () => $687ff8957497b063$export$f6c188a7e02335cf, (v) => $687ff8957497b063$export$f6c188a7e02335cf = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_CLS_VALUE", () => $687ff8957497b063$export$aaf709a8971e825f, (v) => $687ff8957497b063$export$aaf709a8971e825f = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_FCP_VALUE", () => $687ff8957497b063$export$def01b82f8c092f7, (v) => $687ff8957497b063$export$def01b82f8c092f7 = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_FP_VALUE", () => $687ff8957497b063$export$23d4264c606a73a6, (v) => $687ff8957497b063$export$23d4264c606a73a6 = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_INP_VALUE", () => $687ff8957497b063$export$af9ece53bb92f66b, (v) => $687ff8957497b063$export$af9ece53bb92f66b = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_ELEMENT", () => $687ff8957497b063$export$25421625a565b69, (v) => $687ff8957497b063$export$25421625a565b69 = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_ID", () => $687ff8957497b063$export$ab0c90d873e69ccb, (v) => $687ff8957497b063$export$ab0c90d873e69ccb = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_LOAD_TIME", () => $687ff8957497b063$export$538c05cc8cb2a2bb, (v) => $687ff8957497b063$export$538c05cc8cb2a2bb = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_RENDER_TIME", () => $687ff8957497b063$export$f86df4de196e1a7c, (v) => $687ff8957497b063$export$f86df4de196e1a7c = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_REPORT_EVENT", () => $687ff8957497b063$export$51e8aa8c0d65e7b8, (v) => $687ff8957497b063$export$51e8aa8c0d65e7b8 = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_SIZE", () => $687ff8957497b063$export$99023486ecc470bd, (v) => $687ff8957497b063$export$99023486ecc470bd = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_URL", () => $687ff8957497b063$export$2f6c85eaf382e81, (v) => $687ff8957497b063$export$2f6c85eaf382e81 = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_VALUE", () => $687ff8957497b063$export$1158d57c0aed42be, (v) => $687ff8957497b063$export$1158d57c0aed42be = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_TTFB_REQUEST_TIME", () => $687ff8957497b063$export$d85c4f947ab776e3, (v) => $687ff8957497b063$export$d85c4f947ab776e3 = v);
$parcel$export(module.exports, "BROWSER_WEB_VITAL_TTFB_VALUE", () => $687ff8957497b063$export$813ef8386d874918, (v) => $687ff8957497b063$export$813ef8386d874918 = v);
$parcel$export(module.exports, "CACHE_HIT", () => $687ff8957497b063$export$7c2f74ff9251f64, (v) => $687ff8957497b063$export$7c2f74ff9251f64 = v);
$parcel$export(module.exports, "CACHE_ITEM_SIZE", () => $687ff8957497b063$export$993f84dab107b880, (v) => $687ff8957497b063$export$993f84dab107b880 = v);
$parcel$export(module.exports, "CACHE_KEY", () => $687ff8957497b063$export$7b9c2315e94d8d2f, (v) => $687ff8957497b063$export$7b9c2315e94d8d2f = v);
$parcel$export(module.exports, "CACHE_OPERATION", () => $687ff8957497b063$export$f01e5cd42b9ec146, (v) => $687ff8957497b063$export$f01e5cd42b9ec146 = v);
$parcel$export(module.exports, "CACHE_TTL", () => $687ff8957497b063$export$987f6b4367434b55, (v) => $687ff8957497b063$export$987f6b4367434b55 = v);
$parcel$export(module.exports, "CACHE_WRITE", () => $687ff8957497b063$export$d9d145585d5022bb, (v) => $687ff8957497b063$export$d9d145585d5022bb = v);
$parcel$export(module.exports, "CHANNEL", () => $687ff8957497b063$export$44ffba16bd48dac6, (v) => $687ff8957497b063$export$44ffba16bd48dac6 = v);
$parcel$export(module.exports, "CLIENT_ADDRESS", () => $687ff8957497b063$export$3134892c5d2e251a, (v) => $687ff8957497b063$export$3134892c5d2e251a = v);
$parcel$export(module.exports, "CLIENT_PORT", () => $687ff8957497b063$export$8495028d10296058, (v) => $687ff8957497b063$export$8495028d10296058 = v);
$parcel$export(module.exports, "CLOUDFLARE_D1_DURATION", () => $687ff8957497b063$export$d6d0e4fcf46d490c, (v) => $687ff8957497b063$export$d6d0e4fcf46d490c = v);
$parcel$export(module.exports, "CLOUDFLARE_D1_QUERY_TYPE", () => $687ff8957497b063$export$658dced473c19301, (v) => $687ff8957497b063$export$658dced473c19301 = v);
$parcel$export(module.exports, "CLOUDFLARE_D1_ROWS_READ", () => $687ff8957497b063$export$97b0f9c3fbe64076, (v) => $687ff8957497b063$export$97b0f9c3fbe64076 = v);
$parcel$export(module.exports, "CLOUDFLARE_D1_ROWS_WRITTEN", () => $687ff8957497b063$export$cf2c95ed5efbe9eb, (v) => $687ff8957497b063$export$cf2c95ed5efbe9eb = v);
$parcel$export(module.exports, "CLOUDFLARE_DURABLE_OBJECT_QUERY_BINDINGS", () => $687ff8957497b063$export$880007904f61a388, (v) => $687ff8957497b063$export$880007904f61a388 = v);
$parcel$export(module.exports, "CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_READ", () => $687ff8957497b063$export$3e903b72d4d9e07d, (v) => $687ff8957497b063$export$3e903b72d4d9e07d = v);
$parcel$export(module.exports, "CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_WRITTEN", () => $687ff8957497b063$export$34da07180e0e56af, (v) => $687ff8957497b063$export$34da07180e0e56af = v);
$parcel$export(module.exports, "CLOUDFLARE_R2_BUCKET", () => $687ff8957497b063$export$c49aafdaeb061953, (v) => $687ff8957497b063$export$c49aafdaeb061953 = v);
$parcel$export(module.exports, "CLOUDFLARE_R2_OPERATION", () => $687ff8957497b063$export$ceb762c61de2f17f, (v) => $687ff8957497b063$export$ceb762c61de2f17f = v);
$parcel$export(module.exports, "CLOUDFLARE_R2_REQUEST_DELIMITER", () => $687ff8957497b063$export$a5f54ccfb28c0caf, (v) => $687ff8957497b063$export$a5f54ccfb28c0caf = v);
$parcel$export(module.exports, "CLOUDFLARE_R2_REQUEST_KEY", () => $687ff8957497b063$export$1c86a56857b024db, (v) => $687ff8957497b063$export$1c86a56857b024db = v);
$parcel$export(module.exports, "CLOUDFLARE_R2_REQUEST_PART_NUMBER", () => $687ff8957497b063$export$7598f3464be47440, (v) => $687ff8957497b063$export$7598f3464be47440 = v);
$parcel$export(module.exports, "CLOUDFLARE_R2_REQUEST_PREFIX", () => $687ff8957497b063$export$b673289c971fc0ae, (v) => $687ff8957497b063$export$b673289c971fc0ae = v);
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_ATTEMPT", () => $687ff8957497b063$export$98b23f3e6f0c2a6f, (v) => $687ff8957497b063$export$98b23f3e6f0c2a6f = v);
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_RETRIES_BACKOFF", () => $687ff8957497b063$export$6ddeaf0498614ebb, (v) => $687ff8957497b063$export$6ddeaf0498614ebb = v);
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_RETRIES_DELAY", () => $687ff8957497b063$export$97b78f78d64a7232, (v) => $687ff8957497b063$export$97b78f78d64a7232 = v);
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_RETRIES_LIMIT", () => $687ff8957497b063$export$5147715be870fff7, (v) => $687ff8957497b063$export$5147715be870fff7 = v);
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_TIMEOUT", () => $687ff8957497b063$export$5276bb46e6096fba, (v) => $687ff8957497b063$export$5276bb46e6096fba = v);
$parcel$export(module.exports, "CLOUD_ACCOUNT_ID", () => $687ff8957497b063$export$cbcbc1f67a937cf3, (v) => $687ff8957497b063$export$cbcbc1f67a937cf3 = v);
$parcel$export(module.exports, "CLOUD_AVAILABILITY_ZONE", () => $687ff8957497b063$export$226a2381b8f0cf78, (v) => $687ff8957497b063$export$226a2381b8f0cf78 = v);
$parcel$export(module.exports, "CLOUD_PLATFORM", () => $687ff8957497b063$export$fd35512cae286064, (v) => $687ff8957497b063$export$fd35512cae286064 = v);
$parcel$export(module.exports, "CLOUD_PROVIDER", () => $687ff8957497b063$export$de9bbf95ab1d81e, (v) => $687ff8957497b063$export$de9bbf95ab1d81e = v);
$parcel$export(module.exports, "CLOUD_REGION", () => $687ff8957497b063$export$47fb20e8d18d7d15, (v) => $687ff8957497b063$export$47fb20e8d18d7d15 = v);
$parcel$export(module.exports, "CLOUD_RESOURCE_ID", () => $687ff8957497b063$export$9db7964e4b8cb849, (v) => $687ff8957497b063$export$9db7964e4b8cb849 = v);
$parcel$export(module.exports, "CLS", () => $687ff8957497b063$export$7139adf9d3bace41, (v) => $687ff8957497b063$export$7139adf9d3bace41 = v);
$parcel$export(module.exports, "CLS_SOURCE_KEY", () => $687ff8957497b063$export$8ac3d09060e7f25d, (v) => $687ff8957497b063$export$8ac3d09060e7f25d = v);
$parcel$export(module.exports, "CLS_SOURCE_KEY_BASE", () => $687ff8957497b063$export$dad0e4778ea23971, (v) => $687ff8957497b063$export$dad0e4778ea23971 = v);
$parcel$export(module.exports, "CODE_FILEPATH", () => $687ff8957497b063$export$c14d903ccf9385a8, (v) => $687ff8957497b063$export$c14d903ccf9385a8 = v);
$parcel$export(module.exports, "CODE_FILE_PATH", () => $687ff8957497b063$export$934cded0041affd7, (v) => $687ff8957497b063$export$934cded0041affd7 = v);
$parcel$export(module.exports, "CODE_FUNCTION", () => $687ff8957497b063$export$6386da1dcba88c9d, (v) => $687ff8957497b063$export$6386da1dcba88c9d = v);
$parcel$export(module.exports, "CODE_FUNCTION_NAME", () => $687ff8957497b063$export$a3371797e606e2, (v) => $687ff8957497b063$export$a3371797e606e2 = v);
$parcel$export(module.exports, "CODE_LINENO", () => $687ff8957497b063$export$a5bbef0af83b23e5, (v) => $687ff8957497b063$export$a5bbef0af83b23e5 = v);
$parcel$export(module.exports, "CODE_LINE_NUMBER", () => $687ff8957497b063$export$91ed1f55874222a6, (v) => $687ff8957497b063$export$91ed1f55874222a6 = v);
$parcel$export(module.exports, "CODE_NAMESPACE", () => $687ff8957497b063$export$23de81068d2aed1b, (v) => $687ff8957497b063$export$23de81068d2aed1b = v);
$parcel$export(module.exports, "CONNECTIONTYPE", () => $687ff8957497b063$export$d738320e1fba9e9d, (v) => $687ff8957497b063$export$d738320e1fba9e9d = v);
$parcel$export(module.exports, "CONNECTION_RTT", () => $687ff8957497b063$export$2eacdea75497e8a5, (v) => $687ff8957497b063$export$2eacdea75497e8a5 = v);
$parcel$export(module.exports, "CULTURE_CALENDAR", () => $687ff8957497b063$export$2bc3ea101f86c1d2, (v) => $687ff8957497b063$export$2bc3ea101f86c1d2 = v);
$parcel$export(module.exports, "CULTURE_DISPLAY_NAME", () => $687ff8957497b063$export$c54e27e8d90ee081, (v) => $687ff8957497b063$export$c54e27e8d90ee081 = v);
$parcel$export(module.exports, "CULTURE_IS_24_HOUR_FORMAT", () => $687ff8957497b063$export$4943adcec371c2a6, (v) => $687ff8957497b063$export$4943adcec371c2a6 = v);
$parcel$export(module.exports, "CULTURE_LOCALE", () => $687ff8957497b063$export$f000a5900d0480c2, (v) => $687ff8957497b063$export$f000a5900d0480c2 = v);
$parcel$export(module.exports, "CULTURE_TIMEZONE", () => $687ff8957497b063$export$8f5234893868273b, (v) => $687ff8957497b063$export$8f5234893868273b = v);
$parcel$export(module.exports, "DB_COLLECTION_NAME", () => $687ff8957497b063$export$1a35518f6e81e8c7, (v) => $687ff8957497b063$export$1a35518f6e81e8c7 = v);
$parcel$export(module.exports, "DB_DRIVER_NAME", () => $687ff8957497b063$export$a2d90911eaae60fc, (v) => $687ff8957497b063$export$a2d90911eaae60fc = v);
$parcel$export(module.exports, "DB_NAME", () => $687ff8957497b063$export$3c22ff8b64b8f565, (v) => $687ff8957497b063$export$3c22ff8b64b8f565 = v);
$parcel$export(module.exports, "DB_NAMESPACE", () => $687ff8957497b063$export$b8019c0e2a5b5f0f, (v) => $687ff8957497b063$export$b8019c0e2a5b5f0f = v);
$parcel$export(module.exports, "DB_OPERATION", () => $687ff8957497b063$export$8c11477e471467c8, (v) => $687ff8957497b063$export$8c11477e471467c8 = v);
$parcel$export(module.exports, "DB_OPERATION_BATCH_SIZE", () => $687ff8957497b063$export$92a96f6363488aee, (v) => $687ff8957497b063$export$92a96f6363488aee = v);
$parcel$export(module.exports, "DB_OPERATION_NAME", () => $687ff8957497b063$export$f91beb6088f9ded9, (v) => $687ff8957497b063$export$f91beb6088f9ded9 = v);
$parcel$export(module.exports, "DB_QUERY_PARAMETER_KEY", () => $687ff8957497b063$export$78bc7224576bf289, (v) => $687ff8957497b063$export$78bc7224576bf289 = v);
$parcel$export(module.exports, "DB_QUERY_PARAMETER_KEY_BASE", () => $687ff8957497b063$export$a8027e0ea0d93ca, (v) => $687ff8957497b063$export$a8027e0ea0d93ca = v);
$parcel$export(module.exports, "DB_QUERY_SUMMARY", () => $687ff8957497b063$export$5e59d3aea52e5037, (v) => $687ff8957497b063$export$5e59d3aea52e5037 = v);
$parcel$export(module.exports, "DB_QUERY_TEXT", () => $687ff8957497b063$export$47e408be0da7933f, (v) => $687ff8957497b063$export$47e408be0da7933f = v);
$parcel$export(module.exports, "DB_REDIS_CONNECTION", () => $687ff8957497b063$export$d5772b934ca13e57, (v) => $687ff8957497b063$export$d5772b934ca13e57 = v);
$parcel$export(module.exports, "DB_REDIS_KEY", () => $687ff8957497b063$export$36e47f6a5777561d, (v) => $687ff8957497b063$export$36e47f6a5777561d = v);
$parcel$export(module.exports, "DB_REDIS_PARAMETERS", () => $687ff8957497b063$export$e768cbc99cd68acf, (v) => $687ff8957497b063$export$e768cbc99cd68acf = v);
$parcel$export(module.exports, "DB_RESPONSE_STATUS_CODE", () => $687ff8957497b063$export$dfcc6c69df1343f2, (v) => $687ff8957497b063$export$dfcc6c69df1343f2 = v);
$parcel$export(module.exports, "DB_SQL_BINDINGS", () => $687ff8957497b063$export$69b0a5d9226b5211, (v) => $687ff8957497b063$export$69b0a5d9226b5211 = v);
$parcel$export(module.exports, "DB_STATEMENT", () => $687ff8957497b063$export$da010a4f4fc971ae, (v) => $687ff8957497b063$export$da010a4f4fc971ae = v);
$parcel$export(module.exports, "DB_STORED_PROCEDURE_NAME", () => $687ff8957497b063$export$5d515b35be0601a0, (v) => $687ff8957497b063$export$5d515b35be0601a0 = v);
$parcel$export(module.exports, "DB_SYSTEM", () => $687ff8957497b063$export$3e1b1037a315c5ca, (v) => $687ff8957497b063$export$3e1b1037a315c5ca = v);
$parcel$export(module.exports, "DB_SYSTEM_NAME", () => $687ff8957497b063$export$847fdd494825f0fb, (v) => $687ff8957497b063$export$847fdd494825f0fb = v);
$parcel$export(module.exports, "DB_USER", () => $687ff8957497b063$export$a9d76f26c6c730a9, (v) => $687ff8957497b063$export$a9d76f26c6c730a9 = v);
$parcel$export(module.exports, "DEVICEMEMORY", () => $687ff8957497b063$export$de03f86d1c9866ca, (v) => $687ff8957497b063$export$de03f86d1c9866ca = v);
$parcel$export(module.exports, "DEVICE_ARCHS", () => $687ff8957497b063$export$65798ecab7eef8c, (v) => $687ff8957497b063$export$65798ecab7eef8c = v);
$parcel$export(module.exports, "DEVICE_BATTERY_LEVEL", () => $687ff8957497b063$export$22aa61f48b9c79a0, (v) => $687ff8957497b063$export$22aa61f48b9c79a0 = v);
$parcel$export(module.exports, "DEVICE_BATTERY_TEMPERATURE", () => $687ff8957497b063$export$69f5fb98f5aed812, (v) => $687ff8957497b063$export$69f5fb98f5aed812 = v);
$parcel$export(module.exports, "DEVICE_BOOT_TIME", () => $687ff8957497b063$export$bdea5d1006fd280a, (v) => $687ff8957497b063$export$bdea5d1006fd280a = v);
$parcel$export(module.exports, "DEVICE_BRAND", () => $687ff8957497b063$export$f63a7230c5b1d609, (v) => $687ff8957497b063$export$f63a7230c5b1d609 = v);
$parcel$export(module.exports, "DEVICE_CHARGING", () => $687ff8957497b063$export$6f25e59b05bb8e17, (v) => $687ff8957497b063$export$6f25e59b05bb8e17 = v);
$parcel$export(module.exports, "DEVICE_CHIPSET", () => $687ff8957497b063$export$a56ad13c4afc7421, (v) => $687ff8957497b063$export$a56ad13c4afc7421 = v);
$parcel$export(module.exports, "DEVICE_CLASS", () => $687ff8957497b063$export$d9ce89ce8912bf12, (v) => $687ff8957497b063$export$d9ce89ce8912bf12 = v);
$parcel$export(module.exports, "DEVICE_CONNECTION_TYPE", () => $687ff8957497b063$export$17094e5f380e4162, (v) => $687ff8957497b063$export$17094e5f380e4162 = v);
$parcel$export(module.exports, "DEVICE_CPU_DESCRIPTION", () => $687ff8957497b063$export$28a0ffdf747973a0, (v) => $687ff8957497b063$export$28a0ffdf747973a0 = v);
$parcel$export(module.exports, "DEVICE_EXTERNAL_FREE_STORAGE", () => $687ff8957497b063$export$5480ae1ba5d50bb9, (v) => $687ff8957497b063$export$5480ae1ba5d50bb9 = v);
$parcel$export(module.exports, "DEVICE_EXTERNAL_STORAGE_SIZE", () => $687ff8957497b063$export$edc72ee4a17f5152, (v) => $687ff8957497b063$export$edc72ee4a17f5152 = v);
$parcel$export(module.exports, "DEVICE_FAMILY", () => $687ff8957497b063$export$19e4df138d354f8b, (v) => $687ff8957497b063$export$19e4df138d354f8b = v);
$parcel$export(module.exports, "DEVICE_FREE_MEMORY", () => $687ff8957497b063$export$92b0d20fa482b4b2, (v) => $687ff8957497b063$export$92b0d20fa482b4b2 = v);
$parcel$export(module.exports, "DEVICE_FREE_STORAGE", () => $687ff8957497b063$export$3f638a793d61933f, (v) => $687ff8957497b063$export$3f638a793d61933f = v);
$parcel$export(module.exports, "DEVICE_ID", () => $687ff8957497b063$export$3f511731cc3687d4, (v) => $687ff8957497b063$export$3f511731cc3687d4 = v);
$parcel$export(module.exports, "DEVICE_LOCALE", () => $687ff8957497b063$export$692b08741d6b6265, (v) => $687ff8957497b063$export$692b08741d6b6265 = v);
$parcel$export(module.exports, "DEVICE_LOW_MEMORY", () => $687ff8957497b063$export$cf67f8cb2324428e, (v) => $687ff8957497b063$export$cf67f8cb2324428e = v);
$parcel$export(module.exports, "DEVICE_LOW_POWER_MODE", () => $687ff8957497b063$export$9d4197c1ffc5f359, (v) => $687ff8957497b063$export$9d4197c1ffc5f359 = v);
$parcel$export(module.exports, "DEVICE_MANUFACTURER", () => $687ff8957497b063$export$509634fbff540e75, (v) => $687ff8957497b063$export$509634fbff540e75 = v);
$parcel$export(module.exports, "DEVICE_MEMORY_ESTIMATED_CAPACITY", () => $687ff8957497b063$export$ccbc4fdff4b5eff5, (v) => $687ff8957497b063$export$ccbc4fdff4b5eff5 = v);
$parcel$export(module.exports, "DEVICE_MEMORY_SIZE", () => $687ff8957497b063$export$e0cb371ca548b1d6, (v) => $687ff8957497b063$export$e0cb371ca548b1d6 = v);
$parcel$export(module.exports, "DEVICE_MODEL", () => $687ff8957497b063$export$3c39026d09026bc2, (v) => $687ff8957497b063$export$3c39026d09026bc2 = v);
$parcel$export(module.exports, "DEVICE_MODEL_ID", () => $687ff8957497b063$export$bf9e8248cb72cf00, (v) => $687ff8957497b063$export$bf9e8248cb72cf00 = v);
$parcel$export(module.exports, "DEVICE_NAME", () => $687ff8957497b063$export$1054f22a72121d0f, (v) => $687ff8957497b063$export$1054f22a72121d0f = v);
$parcel$export(module.exports, "DEVICE_ONLINE", () => $687ff8957497b063$export$723b8a59dad2e467, (v) => $687ff8957497b063$export$723b8a59dad2e467 = v);
$parcel$export(module.exports, "DEVICE_ORIENTATION", () => $687ff8957497b063$export$160081ff141bac8e, (v) => $687ff8957497b063$export$160081ff141bac8e = v);
$parcel$export(module.exports, "DEVICE_PROCESSOR_COUNT", () => $687ff8957497b063$export$194f62c84d27310, (v) => $687ff8957497b063$export$194f62c84d27310 = v);
$parcel$export(module.exports, "DEVICE_PROCESSOR_FREQUENCY", () => $687ff8957497b063$export$7ed866d57b018d09, (v) => $687ff8957497b063$export$7ed866d57b018d09 = v);
$parcel$export(module.exports, "DEVICE_SCREEN_DENSITY", () => $687ff8957497b063$export$d50bae4562e03e5, (v) => $687ff8957497b063$export$d50bae4562e03e5 = v);
$parcel$export(module.exports, "DEVICE_SCREEN_DPI", () => $687ff8957497b063$export$649ea67a18fe8e8b, (v) => $687ff8957497b063$export$649ea67a18fe8e8b = v);
$parcel$export(module.exports, "DEVICE_SCREEN_HEIGHT_PIXELS", () => $687ff8957497b063$export$136a5c1b43caaccd, (v) => $687ff8957497b063$export$136a5c1b43caaccd = v);
$parcel$export(module.exports, "DEVICE_SCREEN_WIDTH_PIXELS", () => $687ff8957497b063$export$e33a28ea554b6ddc, (v) => $687ff8957497b063$export$e33a28ea554b6ddc = v);
$parcel$export(module.exports, "DEVICE_SIMULATOR", () => $687ff8957497b063$export$acbe2d25ac76ea64, (v) => $687ff8957497b063$export$acbe2d25ac76ea64 = v);
$parcel$export(module.exports, "DEVICE_STORAGE_SIZE", () => $687ff8957497b063$export$793c13e17d7e5e2b, (v) => $687ff8957497b063$export$793c13e17d7e5e2b = v);
$parcel$export(module.exports, "DEVICE_THERMAL_STATE", () => $687ff8957497b063$export$a5617e33b89fd956, (v) => $687ff8957497b063$export$a5617e33b89fd956 = v);
$parcel$export(module.exports, "DEVICE_TIMEZONE", () => $687ff8957497b063$export$b51f82164fa31e07, (v) => $687ff8957497b063$export$b51f82164fa31e07 = v);
$parcel$export(module.exports, "DEVICE_USABLE_MEMORY", () => $687ff8957497b063$export$f2ef55183c04d202, (v) => $687ff8957497b063$export$f2ef55183c04d202 = v);
$parcel$export(module.exports, "DIST", () => $687ff8957497b063$export$7c98fc0c48a16b1c, (v) => $687ff8957497b063$export$7c98fc0c48a16b1c = v);
$parcel$export(module.exports, "EFFECTIVECONNECTIONTYPE", () => $687ff8957497b063$export$f0511e328234ae83, (v) => $687ff8957497b063$export$f0511e328234ae83 = v);
$parcel$export(module.exports, "ENVIRONMENT", () => $687ff8957497b063$export$be46596bc6608f3b, (v) => $687ff8957497b063$export$be46596bc6608f3b = v);
$parcel$export(module.exports, "ERROR_TYPE", () => $687ff8957497b063$export$f215947b3d76a6b7, (v) => $687ff8957497b063$export$f215947b3d76a6b7 = v);
$parcel$export(module.exports, "EVENT_ID", () => $687ff8957497b063$export$89bbc91416db6670, (v) => $687ff8957497b063$export$89bbc91416db6670 = v);
$parcel$export(module.exports, "EVENT_NAME", () => $687ff8957497b063$export$b4b5eff8a8712c89, (v) => $687ff8957497b063$export$b4b5eff8a8712c89 = v);
$parcel$export(module.exports, "EXCEPTION_ESCAPED", () => $687ff8957497b063$export$f455969a57ab8a03, (v) => $687ff8957497b063$export$f455969a57ab8a03 = v);
$parcel$export(module.exports, "EXCEPTION_MESSAGE", () => $687ff8957497b063$export$13f2f8f42af49cec, (v) => $687ff8957497b063$export$13f2f8f42af49cec = v);
$parcel$export(module.exports, "EXCEPTION_STACKTRACE", () => $687ff8957497b063$export$cd357afe2ffdd2c3, (v) => $687ff8957497b063$export$cd357afe2ffdd2c3 = v);
$parcel$export(module.exports, "EXCEPTION_TYPE", () => $687ff8957497b063$export$d9ca2a279a11be5e, (v) => $687ff8957497b063$export$d9ca2a279a11be5e = v);
$parcel$export(module.exports, "FAAS_COLDSTART", () => $687ff8957497b063$export$bbd59a8c7efad4c9, (v) => $687ff8957497b063$export$bbd59a8c7efad4c9 = v);
$parcel$export(module.exports, "FAAS_CRON", () => $687ff8957497b063$export$8413282a17f1cda5, (v) => $687ff8957497b063$export$8413282a17f1cda5 = v);
$parcel$export(module.exports, "FAAS_DURATION_IN_MS", () => $687ff8957497b063$export$30d19ddc7705e7e8, (v) => $687ff8957497b063$export$30d19ddc7705e7e8 = v);
$parcel$export(module.exports, "FAAS_ENTRY_POINT", () => $687ff8957497b063$export$64a4f09e2444b3d, (v) => $687ff8957497b063$export$64a4f09e2444b3d = v);
$parcel$export(module.exports, "FAAS_EXECUTION", () => $687ff8957497b063$export$645b039fe163809e, (v) => $687ff8957497b063$export$645b039fe163809e = v);
$parcel$export(module.exports, "FAAS_ID", () => $687ff8957497b063$export$b23ef8b8ffa607e1, (v) => $687ff8957497b063$export$b23ef8b8ffa607e1 = v);
$parcel$export(module.exports, "FAAS_IDENTITY", () => $687ff8957497b063$export$8bf64516740c1369, (v) => $687ff8957497b063$export$8bf64516740c1369 = v);
$parcel$export(module.exports, "FAAS_INVOCATION_ID", () => $687ff8957497b063$export$9a0dc8e612f3e10b, (v) => $687ff8957497b063$export$9a0dc8e612f3e10b = v);
$parcel$export(module.exports, "FAAS_INVOKED_NAME", () => $687ff8957497b063$export$abe90fedb3dddda2, (v) => $687ff8957497b063$export$abe90fedb3dddda2 = v);
$parcel$export(module.exports, "FAAS_INVOKED_PROVIDER", () => $687ff8957497b063$export$4a19da9c85ed2ade, (v) => $687ff8957497b063$export$4a19da9c85ed2ade = v);
$parcel$export(module.exports, "FAAS_INVOKED_REGION", () => $687ff8957497b063$export$5e091479f094bdbc, (v) => $687ff8957497b063$export$5e091479f094bdbc = v);
$parcel$export(module.exports, "FAAS_NAME", () => $687ff8957497b063$export$d70909b5aa96a79a, (v) => $687ff8957497b063$export$d70909b5aa96a79a = v);
$parcel$export(module.exports, "FAAS_TIME", () => $687ff8957497b063$export$651d142a8017d83d, (v) => $687ff8957497b063$export$651d142a8017d83d = v);
$parcel$export(module.exports, "FAAS_TRIGGER", () => $687ff8957497b063$export$44382a010a9f7fcf, (v) => $687ff8957497b063$export$44382a010a9f7fcf = v);
$parcel$export(module.exports, "FAAS_VERSION", () => $687ff8957497b063$export$807abfdc6b7b9338, (v) => $687ff8957497b063$export$807abfdc6b7b9338 = v);
$parcel$export(module.exports, "FCP", () => $687ff8957497b063$export$31881d07f2569218, (v) => $687ff8957497b063$export$31881d07f2569218 = v);
$parcel$export(module.exports, "FLAG_EVALUATION_KEY", () => $687ff8957497b063$export$e5bbf306deb709a6, (v) => $687ff8957497b063$export$e5bbf306deb709a6 = v);
$parcel$export(module.exports, "FLAG_EVALUATION_KEY_BASE", () => $687ff8957497b063$export$aa8721167c5c8d2d, (v) => $687ff8957497b063$export$aa8721167c5c8d2d = v);
$parcel$export(module.exports, "FP", () => $687ff8957497b063$export$757b93e5b3adc7cb, (v) => $687ff8957497b063$export$757b93e5b3adc7cb = v);
$parcel$export(module.exports, "FRAMES_DELAY", () => $687ff8957497b063$export$f869eaa92db1dc9b, (v) => $687ff8957497b063$export$f869eaa92db1dc9b = v);
$parcel$export(module.exports, "FRAMES_FROZEN", () => $687ff8957497b063$export$5d1d761e41c32d9e, (v) => $687ff8957497b063$export$5d1d761e41c32d9e = v);
$parcel$export(module.exports, "FRAMES_FROZEN_RATE", () => $687ff8957497b063$export$8aec72d9491f9399, (v) => $687ff8957497b063$export$8aec72d9491f9399 = v);
$parcel$export(module.exports, "FRAMES_SLOW", () => $687ff8957497b063$export$5562635d2be2ab25, (v) => $687ff8957497b063$export$5562635d2be2ab25 = v);
$parcel$export(module.exports, "FRAMES_SLOW_RATE", () => $687ff8957497b063$export$2dc31837ce6f7a3d, (v) => $687ff8957497b063$export$2dc31837ce6f7a3d = v);
$parcel$export(module.exports, "FRAMES_TOTAL", () => $687ff8957497b063$export$b561df15f64d32e3, (v) => $687ff8957497b063$export$b561df15f64d32e3 = v);
$parcel$export(module.exports, "FS_ERROR", () => $687ff8957497b063$export$181f78b28f2ffa57, (v) => $687ff8957497b063$export$181f78b28f2ffa57 = v);
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_EVENT_ID", () => $687ff8957497b063$export$6c97c77b89571c75, (v) => $687ff8957497b063$export$6c97c77b89571c75 = v);
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_EVENT_TYPE", () => $687ff8957497b063$export$51e431eaf1f9bf58, (v) => $687ff8957497b063$export$51e431eaf1f9bf58 = v);
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_ID", () => $687ff8957497b063$export$71429c7ef7cb7063, (v) => $687ff8957497b063$export$71429c7ef7cb7063 = v);
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_RESOURCE", () => $687ff8957497b063$export$99905d7583a6e8ac, (v) => $687ff8957497b063$export$99905d7583a6e8ac = v);
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_SOURCE", () => $687ff8957497b063$export$b6c4be74fd0c06bd, (v) => $687ff8957497b063$export$b6c4be74fd0c06bd = v);
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_SPECVERSION", () => $687ff8957497b063$export$fd23e5b8d261a89, (v) => $687ff8957497b063$export$fd23e5b8d261a89 = v);
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_TIME", () => $687ff8957497b063$export$25fabc9b3d1dd567, (v) => $687ff8957497b063$export$25fabc9b3d1dd567 = v);
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_TIMESTAMP", () => $687ff8957497b063$export$41507f7b07dad151, (v) => $687ff8957497b063$export$41507f7b07dad151 = v);
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_TYPE", () => $687ff8957497b063$export$1352f3699c35dd73, (v) => $687ff8957497b063$export$1352f3699c35dd73 = v);
$parcel$export(module.exports, "GCP_PROJECT_ID", () => $687ff8957497b063$export$fd6c9d5c74d943ac, (v) => $687ff8957497b063$export$fd6c9d5c74d943ac = v);
$parcel$export(module.exports, "GEN_AI_AGENT_NAME", () => $687ff8957497b063$export$c29634e3cf41e479, (v) => $687ff8957497b063$export$c29634e3cf41e479 = v);
$parcel$export(module.exports, "GEN_AI_CONTEXT_UTILIZATION", () => $687ff8957497b063$export$e6a60882cce7a085, (v) => $687ff8957497b063$export$e6a60882cce7a085 = v);
$parcel$export(module.exports, "GEN_AI_CONTEXT_WINDOW_SIZE", () => $687ff8957497b063$export$6773c9098ba5e194, (v) => $687ff8957497b063$export$6773c9098ba5e194 = v);
$parcel$export(module.exports, "GEN_AI_CONVERSATION_ID", () => $687ff8957497b063$export$6ee6b62f50047686, (v) => $687ff8957497b063$export$6ee6b62f50047686 = v);
$parcel$export(module.exports, "GEN_AI_COST_CACHE_CREATION_INPUT_TOKENS", () => $687ff8957497b063$export$efac052bb3661242, (v) => $687ff8957497b063$export$efac052bb3661242 = v);
$parcel$export(module.exports, "GEN_AI_COST_CACHE_READ_INPUT_TOKENS", () => $687ff8957497b063$export$7ccd63b9ca955862, (v) => $687ff8957497b063$export$7ccd63b9ca955862 = v);
$parcel$export(module.exports, "GEN_AI_COST_INPUT_TOKENS", () => $687ff8957497b063$export$50921df5a58cb3ef, (v) => $687ff8957497b063$export$50921df5a58cb3ef = v);
$parcel$export(module.exports, "GEN_AI_COST_OUTPUT_TOKENS", () => $687ff8957497b063$export$8e48efc7acb57a97, (v) => $687ff8957497b063$export$8e48efc7acb57a97 = v);
$parcel$export(module.exports, "GEN_AI_COST_REASONING_OUTPUT_TOKENS", () => $687ff8957497b063$export$cea9121727113f77, (v) => $687ff8957497b063$export$cea9121727113f77 = v);
$parcel$export(module.exports, "GEN_AI_COST_TOTAL_TOKENS", () => $687ff8957497b063$export$bed35ff7f9af3aaa, (v) => $687ff8957497b063$export$bed35ff7f9af3aaa = v);
$parcel$export(module.exports, "GEN_AI_EMBEDDINGS_INPUT", () => $687ff8957497b063$export$6b729e898b9067ce, (v) => $687ff8957497b063$export$6b729e898b9067ce = v);
$parcel$export(module.exports, "GEN_AI_FUNCTION_ID", () => $687ff8957497b063$export$984fbab9b52f7e24, (v) => $687ff8957497b063$export$984fbab9b52f7e24 = v);
$parcel$export(module.exports, "GEN_AI_INPUT_MESSAGES", () => $687ff8957497b063$export$9ea17906a87ada6f, (v) => $687ff8957497b063$export$9ea17906a87ada6f = v);
$parcel$export(module.exports, "GEN_AI_OPERATION_NAME", () => $687ff8957497b063$export$394b443aaff3ef92, (v) => $687ff8957497b063$export$394b443aaff3ef92 = v);
$parcel$export(module.exports, "GEN_AI_OPERATION_TYPE", () => $687ff8957497b063$export$6ddc374adbc06720, (v) => $687ff8957497b063$export$6ddc374adbc06720 = v);
$parcel$export(module.exports, "GEN_AI_OUTPUT_MESSAGES", () => $687ff8957497b063$export$ab8c7ebc9add56b2, (v) => $687ff8957497b063$export$ab8c7ebc9add56b2 = v);
$parcel$export(module.exports, "GEN_AI_PIPELINE_NAME", () => $687ff8957497b063$export$40ecc5bcd633d1ee, (v) => $687ff8957497b063$export$40ecc5bcd633d1ee = v);
$parcel$export(module.exports, "GEN_AI_PROMPT", () => $687ff8957497b063$export$86a8df7fff52fc69, (v) => $687ff8957497b063$export$86a8df7fff52fc69 = v);
$parcel$export(module.exports, "GEN_AI_PROMPT_NAME", () => $687ff8957497b063$export$cf2115d46768f4c5, (v) => $687ff8957497b063$export$cf2115d46768f4c5 = v);
$parcel$export(module.exports, "GEN_AI_PROVIDER_NAME", () => $687ff8957497b063$export$3d7e036e195764db, (v) => $687ff8957497b063$export$3d7e036e195764db = v);
$parcel$export(module.exports, "GEN_AI_REQUEST_AVAILABLE_TOOLS", () => $687ff8957497b063$export$60c1d11221608cee, (v) => $687ff8957497b063$export$60c1d11221608cee = v);
$parcel$export(module.exports, "GEN_AI_REQUEST_FREQUENCY_PENALTY", () => $687ff8957497b063$export$bc3cef164abbc42c, (v) => $687ff8957497b063$export$bc3cef164abbc42c = v);
$parcel$export(module.exports, "GEN_AI_REQUEST_MAX_TOKENS", () => $687ff8957497b063$export$43f9afb62cd79dec, (v) => $687ff8957497b063$export$43f9afb62cd79dec = v);
$parcel$export(module.exports, "GEN_AI_REQUEST_MESSAGES", () => $687ff8957497b063$export$a5ab4ffc4765f75f, (v) => $687ff8957497b063$export$a5ab4ffc4765f75f = v);
$parcel$export(module.exports, "GEN_AI_REQUEST_MODEL", () => $687ff8957497b063$export$ccf46db9ab1743ec, (v) => $687ff8957497b063$export$ccf46db9ab1743ec = v);
$parcel$export(module.exports, "GEN_AI_REQUEST_PRESENCE_PENALTY", () => $687ff8957497b063$export$76c1c247342d776, (v) => $687ff8957497b063$export$76c1c247342d776 = v);
$parcel$export(module.exports, "GEN_AI_REQUEST_REASONING_EFFORT", () => $687ff8957497b063$export$92f5944f0b02c9fb, (v) => $687ff8957497b063$export$92f5944f0b02c9fb = v);
$parcel$export(module.exports, "GEN_AI_REQUEST_SEED", () => $687ff8957497b063$export$867eeefcb1c95b27, (v) => $687ff8957497b063$export$867eeefcb1c95b27 = v);
$parcel$export(module.exports, "GEN_AI_REQUEST_STOP_SEQUENCES", () => $687ff8957497b063$export$5ada4697ae6aa17e, (v) => $687ff8957497b063$export$5ada4697ae6aa17e = v);
$parcel$export(module.exports, "GEN_AI_REQUEST_TEMPERATURE", () => $687ff8957497b063$export$427122300e8d54d0, (v) => $687ff8957497b063$export$427122300e8d54d0 = v);
$parcel$export(module.exports, "GEN_AI_REQUEST_TOP_K", () => $687ff8957497b063$export$bcea8881375c352f, (v) => $687ff8957497b063$export$bcea8881375c352f = v);
$parcel$export(module.exports, "GEN_AI_REQUEST_TOP_P", () => $687ff8957497b063$export$b867715f9a0c04e9, (v) => $687ff8957497b063$export$b867715f9a0c04e9 = v);
$parcel$export(module.exports, "GEN_AI_RESPONSE_FINISH_REASONS", () => $687ff8957497b063$export$69878a39cbdbe097, (v) => $687ff8957497b063$export$69878a39cbdbe097 = v);
$parcel$export(module.exports, "GEN_AI_RESPONSE_ID", () => $687ff8957497b063$export$584c61a1b769552d, (v) => $687ff8957497b063$export$584c61a1b769552d = v);
$parcel$export(module.exports, "GEN_AI_RESPONSE_MODEL", () => $687ff8957497b063$export$8169ebcb0b0331dd, (v) => $687ff8957497b063$export$8169ebcb0b0331dd = v);
$parcel$export(module.exports, "GEN_AI_RESPONSE_STREAMING", () => $687ff8957497b063$export$2c9713b624877853, (v) => $687ff8957497b063$export$2c9713b624877853 = v);
$parcel$export(module.exports, "GEN_AI_RESPONSE_TEXT", () => $687ff8957497b063$export$45942692aeb454e0, (v) => $687ff8957497b063$export$45942692aeb454e0 = v);
$parcel$export(module.exports, "GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK", () => $687ff8957497b063$export$8e5efeaa031210cd, (v) => $687ff8957497b063$export$8e5efeaa031210cd = v);
$parcel$export(module.exports, "GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN", () => $687ff8957497b063$export$35a62769ee05a05a, (v) => $687ff8957497b063$export$35a62769ee05a05a = v);
$parcel$export(module.exports, "GEN_AI_RESPONSE_TOKENS_PER_SECOND", () => $687ff8957497b063$export$8ea4f7e986ca4b06, (v) => $687ff8957497b063$export$8ea4f7e986ca4b06 = v);
$parcel$export(module.exports, "GEN_AI_RESPONSE_TOOL_CALLS", () => $687ff8957497b063$export$d2fd9ecaff0285a4, (v) => $687ff8957497b063$export$d2fd9ecaff0285a4 = v);
$parcel$export(module.exports, "GEN_AI_SYSTEM", () => $687ff8957497b063$export$a6c8e656a4f9bb67, (v) => $687ff8957497b063$export$a6c8e656a4f9bb67 = v);
$parcel$export(module.exports, "GEN_AI_SYSTEM_INSTRUCTIONS", () => $687ff8957497b063$export$352a8075b163d53, (v) => $687ff8957497b063$export$352a8075b163d53 = v);
$parcel$export(module.exports, "GEN_AI_SYSTEM_MESSAGE", () => $687ff8957497b063$export$426d7b90ba5d79db, (v) => $687ff8957497b063$export$426d7b90ba5d79db = v);
$parcel$export(module.exports, "GEN_AI_TOOL_CALL_ARGUMENTS", () => $687ff8957497b063$export$f5a1ee40934d19ce, (v) => $687ff8957497b063$export$f5a1ee40934d19ce = v);
$parcel$export(module.exports, "GEN_AI_TOOL_CALL_RESULT", () => $687ff8957497b063$export$1ba812a9756622ce, (v) => $687ff8957497b063$export$1ba812a9756622ce = v);
$parcel$export(module.exports, "GEN_AI_TOOL_DEFINITIONS", () => $687ff8957497b063$export$351120039c36e03, (v) => $687ff8957497b063$export$351120039c36e03 = v);
$parcel$export(module.exports, "GEN_AI_TOOL_DESCRIPTION", () => $687ff8957497b063$export$d42aa25ca09e17c4, (v) => $687ff8957497b063$export$d42aa25ca09e17c4 = v);
$parcel$export(module.exports, "GEN_AI_TOOL_INPUT", () => $687ff8957497b063$export$d268db29b88a4286, (v) => $687ff8957497b063$export$d268db29b88a4286 = v);
$parcel$export(module.exports, "GEN_AI_TOOL_MESSAGE", () => $687ff8957497b063$export$c5deb6018f2d6251, (v) => $687ff8957497b063$export$c5deb6018f2d6251 = v);
$parcel$export(module.exports, "GEN_AI_TOOL_NAME", () => $687ff8957497b063$export$e06baa3034409453, (v) => $687ff8957497b063$export$e06baa3034409453 = v);
$parcel$export(module.exports, "GEN_AI_TOOL_OUTPUT", () => $687ff8957497b063$export$646fdb5910ce3931, (v) => $687ff8957497b063$export$646fdb5910ce3931 = v);
$parcel$export(module.exports, "GEN_AI_TOOL_TYPE", () => $687ff8957497b063$export$662e3d2d4361e29b, (v) => $687ff8957497b063$export$662e3d2d4361e29b = v);
$parcel$export(module.exports, "GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS", () => $687ff8957497b063$export$1de3962f221ba441, (v) => $687ff8957497b063$export$1de3962f221ba441 = v);
$parcel$export(module.exports, "GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS", () => $687ff8957497b063$export$a4b3f0f5499c8738, (v) => $687ff8957497b063$export$a4b3f0f5499c8738 = v);
$parcel$export(module.exports, "GEN_AI_USAGE_COMPLETION_TOKENS", () => $687ff8957497b063$export$1aecdac6cecbdc5b, (v) => $687ff8957497b063$export$1aecdac6cecbdc5b = v);
$parcel$export(module.exports, "GEN_AI_USAGE_INPUT_TOKENS", () => $687ff8957497b063$export$2eb2ab35b317a103, (v) => $687ff8957497b063$export$2eb2ab35b317a103 = v);
$parcel$export(module.exports, "GEN_AI_USAGE_INPUT_TOKENS_CACHED", () => $687ff8957497b063$export$c7e14ea195ede241, (v) => $687ff8957497b063$export$c7e14ea195ede241 = v);
$parcel$export(module.exports, "GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE", () => $687ff8957497b063$export$41ac034e7b9725a2, (v) => $687ff8957497b063$export$41ac034e7b9725a2 = v);
$parcel$export(module.exports, "GEN_AI_USAGE_OUTPUT_TOKENS", () => $687ff8957497b063$export$9e521119d7751e37, (v) => $687ff8957497b063$export$9e521119d7751e37 = v);
$parcel$export(module.exports, "GEN_AI_USAGE_OUTPUT_TOKENS_REASONING", () => $687ff8957497b063$export$cbac8f541a64a150, (v) => $687ff8957497b063$export$cbac8f541a64a150 = v);
$parcel$export(module.exports, "GEN_AI_USAGE_PROMPT_TOKENS", () => $687ff8957497b063$export$93dd08efa94c9dd4, (v) => $687ff8957497b063$export$93dd08efa94c9dd4 = v);
$parcel$export(module.exports, "GEN_AI_USAGE_REASONING_OUTPUT_TOKENS", () => $687ff8957497b063$export$183e3523dac20bca, (v) => $687ff8957497b063$export$183e3523dac20bca = v);
$parcel$export(module.exports, "GEN_AI_USAGE_TOTAL_TOKENS", () => $687ff8957497b063$export$3867ca1d8381d4e3, (v) => $687ff8957497b063$export$3867ca1d8381d4e3 = v);
$parcel$export(module.exports, "GRAPHQL_DOCUMENT", () => $687ff8957497b063$export$11febcf9917c0057, (v) => $687ff8957497b063$export$11febcf9917c0057 = v);
$parcel$export(module.exports, "GRAPHQL_OPERATION_NAME", () => $687ff8957497b063$export$88ae1ee0c0a63398, (v) => $687ff8957497b063$export$88ae1ee0c0a63398 = v);
$parcel$export(module.exports, "GRAPHQL_OPERATION_TYPE", () => $687ff8957497b063$export$d5bd986d1f283f29, (v) => $687ff8957497b063$export$d5bd986d1f283f29 = v);
$parcel$export(module.exports, "HARDWARECONCURRENCY", () => $687ff8957497b063$export$fc4a2d238535d998, (v) => $687ff8957497b063$export$fc4a2d238535d998 = v);
$parcel$export(module.exports, "HTTP_CLIENT_IP", () => $687ff8957497b063$export$57e53a60bf563f41, (v) => $687ff8957497b063$export$57e53a60bf563f41 = v);
$parcel$export(module.exports, "HTTP_DECODED_RESPONSE_CONTENT_LENGTH", () => $687ff8957497b063$export$ffdb1464deb0eedb, (v) => $687ff8957497b063$export$ffdb1464deb0eedb = v);
$parcel$export(module.exports, "HTTP_FLAVOR", () => $687ff8957497b063$export$b52670c950fd640, (v) => $687ff8957497b063$export$b52670c950fd640 = v);
$parcel$export(module.exports, "HTTP_FRAGMENT", () => $687ff8957497b063$export$c499fd8f1db3d18e, (v) => $687ff8957497b063$export$c499fd8f1db3d18e = v);
$parcel$export(module.exports, "HTTP_HOST", () => $687ff8957497b063$export$b2ee2242301eff05, (v) => $687ff8957497b063$export$b2ee2242301eff05 = v);
$parcel$export(module.exports, "HTTP_METHOD", () => $687ff8957497b063$export$2ebf9f7586f16841, (v) => $687ff8957497b063$export$2ebf9f7586f16841 = v);
$parcel$export(module.exports, "HTTP_QUERY", () => $687ff8957497b063$export$6e9ffd608b3e828b, (v) => $687ff8957497b063$export$6e9ffd608b3e828b = v);
$parcel$export(module.exports, "HTTP_REQUEST_BODY_DATA", () => $687ff8957497b063$export$b960c5a73a722e6c, (v) => $687ff8957497b063$export$b960c5a73a722e6c = v);
$parcel$export(module.exports, "HTTP_REQUEST_CONNECTION_END", () => $687ff8957497b063$export$a7a850351369c77e, (v) => $687ff8957497b063$export$a7a850351369c77e = v);
$parcel$export(module.exports, "HTTP_REQUEST_CONNECT_START", () => $687ff8957497b063$export$b18bca78f4736a94, (v) => $687ff8957497b063$export$b18bca78f4736a94 = v);
$parcel$export(module.exports, "HTTP_REQUEST_DOMAIN_LOOKUP_END", () => $687ff8957497b063$export$61a0059f562fb6c2, (v) => $687ff8957497b063$export$61a0059f562fb6c2 = v);
$parcel$export(module.exports, "HTTP_REQUEST_DOMAIN_LOOKUP_START", () => $687ff8957497b063$export$7dc0d5aefb816d91, (v) => $687ff8957497b063$export$7dc0d5aefb816d91 = v);
$parcel$export(module.exports, "HTTP_REQUEST_FETCH_START", () => $687ff8957497b063$export$58f6db56c841bef6, (v) => $687ff8957497b063$export$58f6db56c841bef6 = v);
$parcel$export(module.exports, "HTTP_REQUEST_HEADER_KEY", () => $687ff8957497b063$export$97a3da679f509d5, (v) => $687ff8957497b063$export$97a3da679f509d5 = v);
$parcel$export(module.exports, "HTTP_REQUEST_HEADER_KEY_BASE", () => $687ff8957497b063$export$c387ec65fd1c2638, (v) => $687ff8957497b063$export$c387ec65fd1c2638 = v);
$parcel$export(module.exports, "HTTP_REQUEST_METHOD", () => $687ff8957497b063$export$4d9db82211f308a4, (v) => $687ff8957497b063$export$4d9db82211f308a4 = v);
$parcel$export(module.exports, "HTTP_REQUEST_REDIRECT_END", () => $687ff8957497b063$export$ee4948a3be025123, (v) => $687ff8957497b063$export$ee4948a3be025123 = v);
$parcel$export(module.exports, "HTTP_REQUEST_REDIRECT_START", () => $687ff8957497b063$export$e0021eb2979cddaa, (v) => $687ff8957497b063$export$e0021eb2979cddaa = v);
$parcel$export(module.exports, "HTTP_REQUEST_REQUEST_START", () => $687ff8957497b063$export$7c0ac0c19a45beac, (v) => $687ff8957497b063$export$7c0ac0c19a45beac = v);
$parcel$export(module.exports, "HTTP_REQUEST_RESEND_COUNT", () => $687ff8957497b063$export$6c32e9d84f534ee, (v) => $687ff8957497b063$export$6c32e9d84f534ee = v);
$parcel$export(module.exports, "HTTP_REQUEST_RESPONSE_END", () => $687ff8957497b063$export$d1f9fbdb211dd29b, (v) => $687ff8957497b063$export$d1f9fbdb211dd29b = v);
$parcel$export(module.exports, "HTTP_REQUEST_RESPONSE_START", () => $687ff8957497b063$export$45e7eea99a17d6e4, (v) => $687ff8957497b063$export$45e7eea99a17d6e4 = v);
$parcel$export(module.exports, "HTTP_REQUEST_SAME_ORIGIN", () => $687ff8957497b063$export$20ea34e16c0aa64f, (v) => $687ff8957497b063$export$20ea34e16c0aa64f = v);
$parcel$export(module.exports, "HTTP_REQUEST_SECURE_CONNECTION_START", () => $687ff8957497b063$export$8365b0f03557fae9, (v) => $687ff8957497b063$export$8365b0f03557fae9 = v);
$parcel$export(module.exports, "HTTP_REQUEST_TIME_TO_FIRST_BYTE", () => $687ff8957497b063$export$49ebbb9621675650, (v) => $687ff8957497b063$export$49ebbb9621675650 = v);
$parcel$export(module.exports, "HTTP_REQUEST_WORKER_START", () => $687ff8957497b063$export$842be66a901f093, (v) => $687ff8957497b063$export$842be66a901f093 = v);
$parcel$export(module.exports, "HTTP_RESPONSE_BODY_SIZE", () => $687ff8957497b063$export$a9f5a6cb28adccb1, (v) => $687ff8957497b063$export$a9f5a6cb28adccb1 = v);
$parcel$export(module.exports, "HTTP_RESPONSE_CONTENT_LENGTH", () => $687ff8957497b063$export$57b055d4bc586d67, (v) => $687ff8957497b063$export$57b055d4bc586d67 = v);
$parcel$export(module.exports, "HTTP_RESPONSE_HEADER_CONTENT_LENGTH", () => $687ff8957497b063$export$3ddfd660caa7bf7a, (v) => $687ff8957497b063$export$3ddfd660caa7bf7a = v);
$parcel$export(module.exports, "HTTP_RESPONSE_HEADER_KEY", () => $687ff8957497b063$export$fa7e1f5305153b3d, (v) => $687ff8957497b063$export$fa7e1f5305153b3d = v);
$parcel$export(module.exports, "HTTP_RESPONSE_HEADER_KEY_BASE", () => $687ff8957497b063$export$5674ce9d013eb7bd, (v) => $687ff8957497b063$export$5674ce9d013eb7bd = v);
$parcel$export(module.exports, "HTTP_RESPONSE_SIZE", () => $687ff8957497b063$export$6e8dc14cff6ccf72, (v) => $687ff8957497b063$export$6e8dc14cff6ccf72 = v);
$parcel$export(module.exports, "HTTP_RESPONSE_STATUS_CODE", () => $687ff8957497b063$export$afd59480458e1b57, (v) => $687ff8957497b063$export$afd59480458e1b57 = v);
$parcel$export(module.exports, "HTTP_RESPONSE_TRANSFER_SIZE", () => $687ff8957497b063$export$48e61fb9bccccba9, (v) => $687ff8957497b063$export$48e61fb9bccccba9 = v);
$parcel$export(module.exports, "HTTP_ROUTE", () => $687ff8957497b063$export$d3e674514dd3a3e1, (v) => $687ff8957497b063$export$d3e674514dd3a3e1 = v);
$parcel$export(module.exports, "HTTP_SCHEME", () => $687ff8957497b063$export$97ad02b50c60ef68, (v) => $687ff8957497b063$export$97ad02b50c60ef68 = v);
$parcel$export(module.exports, "HTTP_SERVER_NAME", () => $687ff8957497b063$export$61d053b1b63e82c4, (v) => $687ff8957497b063$export$61d053b1b63e82c4 = v);
$parcel$export(module.exports, "HTTP_SERVER_REQUEST_TIME_IN_QUEUE", () => $687ff8957497b063$export$54256cce0d674dea, (v) => $687ff8957497b063$export$54256cce0d674dea = v);
$parcel$export(module.exports, "HTTP_STATUS_CODE", () => $687ff8957497b063$export$8c01f0f407bcc5ca, (v) => $687ff8957497b063$export$8c01f0f407bcc5ca = v);
$parcel$export(module.exports, "HTTP_TARGET", () => $687ff8957497b063$export$be3f46982f6c7160, (v) => $687ff8957497b063$export$be3f46982f6c7160 = v);
$parcel$export(module.exports, "HTTP_URL", () => $687ff8957497b063$export$778e4213e2788579, (v) => $687ff8957497b063$export$778e4213e2788579 = v);
$parcel$export(module.exports, "HTTP_USER_AGENT", () => $687ff8957497b063$export$8b48ca3594d2b172, (v) => $687ff8957497b063$export$8b48ca3594d2b172 = v);
$parcel$export(module.exports, "ID", () => $687ff8957497b063$export$8be180ec26319f9f, (v) => $687ff8957497b063$export$8be180ec26319f9f = v);
$parcel$export(module.exports, "INP", () => $687ff8957497b063$export$60eccaddefa8fc1c, (v) => $687ff8957497b063$export$60eccaddefa8fc1c = v);
$parcel$export(module.exports, "JSONRPC_PROTOCOL_VERSION", () => $687ff8957497b063$export$c99ce4fe37484d84, (v) => $687ff8957497b063$export$c99ce4fe37484d84 = v);
$parcel$export(module.exports, "JSONRPC_REQUEST_ID", () => $687ff8957497b063$export$fdf432fcac7d8f37, (v) => $687ff8957497b063$export$fdf432fcac7d8f37 = v);
$parcel$export(module.exports, "JVM_GC_ACTION", () => $687ff8957497b063$export$4c21cc9cdf2f5dbd, (v) => $687ff8957497b063$export$4c21cc9cdf2f5dbd = v);
$parcel$export(module.exports, "JVM_GC_NAME", () => $687ff8957497b063$export$dcc1eab7f3f31816, (v) => $687ff8957497b063$export$dcc1eab7f3f31816 = v);
$parcel$export(module.exports, "JVM_MEMORY_POOL_NAME", () => $687ff8957497b063$export$dcb7f1379b2b8f86, (v) => $687ff8957497b063$export$dcb7f1379b2b8f86 = v);
$parcel$export(module.exports, "JVM_MEMORY_TYPE", () => $687ff8957497b063$export$53416edeea4c2d74, (v) => $687ff8957497b063$export$53416edeea4c2d74 = v);
$parcel$export(module.exports, "JVM_THREAD_DAEMON", () => $687ff8957497b063$export$69f7e5d2b74c5c9e, (v) => $687ff8957497b063$export$69f7e5d2b74c5c9e = v);
$parcel$export(module.exports, "JVM_THREAD_STATE", () => $687ff8957497b063$export$8e104aed582a26bc, (v) => $687ff8957497b063$export$8e104aed582a26bc = v);
$parcel$export(module.exports, "KOA_NAME", () => $687ff8957497b063$export$577047501949be9, (v) => $687ff8957497b063$export$577047501949be9 = v);
$parcel$export(module.exports, "KOA_TYPE", () => $687ff8957497b063$export$c4c45b599a2c15e, (v) => $687ff8957497b063$export$c4c45b599a2c15e = v);
$parcel$export(module.exports, "LCP", () => $687ff8957497b063$export$361cb541700d648e, (v) => $687ff8957497b063$export$361cb541700d648e = v);
$parcel$export(module.exports, "LCP_ELEMENT", () => $687ff8957497b063$export$974f160e11f25731, (v) => $687ff8957497b063$export$974f160e11f25731 = v);
$parcel$export(module.exports, "LCP_ID", () => $687ff8957497b063$export$7162f5c702b95903, (v) => $687ff8957497b063$export$7162f5c702b95903 = v);
$parcel$export(module.exports, "LCP_LOADTIME", () => $687ff8957497b063$export$a034d066a9090500, (v) => $687ff8957497b063$export$a034d066a9090500 = v);
$parcel$export(module.exports, "LCP_RENDERTIME", () => $687ff8957497b063$export$70938021e43e047c, (v) => $687ff8957497b063$export$70938021e43e047c = v);
$parcel$export(module.exports, "LCP_SIZE", () => $687ff8957497b063$export$5f6ac460012a73bb, (v) => $687ff8957497b063$export$5f6ac460012a73bb = v);
$parcel$export(module.exports, "LCP_URL", () => $687ff8957497b063$export$d8e498c1c670bcbf, (v) => $687ff8957497b063$export$d8e498c1c670bcbf = v);
$parcel$export(module.exports, "LOGGER_NAME", () => $687ff8957497b063$export$cc1a78a24d947903, (v) => $687ff8957497b063$export$cc1a78a24d947903 = v);
$parcel$export(module.exports, "MCP_CANCELLED_REASON", () => $687ff8957497b063$export$d29b927e0bb0ffea, (v) => $687ff8957497b063$export$d29b927e0bb0ffea = v);
$parcel$export(module.exports, "MCP_CANCELLED_REQUEST_ID", () => $687ff8957497b063$export$b3999cacef245779, (v) => $687ff8957497b063$export$b3999cacef245779 = v);
$parcel$export(module.exports, "MCP_CLIENT_NAME", () => $687ff8957497b063$export$ff168b5f9cf9dcf6, (v) => $687ff8957497b063$export$ff168b5f9cf9dcf6 = v);
$parcel$export(module.exports, "MCP_CLIENT_TITLE", () => $687ff8957497b063$export$2ab876a45bd6e64, (v) => $687ff8957497b063$export$2ab876a45bd6e64 = v);
$parcel$export(module.exports, "MCP_CLIENT_VERSION", () => $687ff8957497b063$export$cb8027e4395c6c0e, (v) => $687ff8957497b063$export$cb8027e4395c6c0e = v);
$parcel$export(module.exports, "MCP_LIFECYCLE_PHASE", () => $687ff8957497b063$export$f5303d1bac3c2660, (v) => $687ff8957497b063$export$f5303d1bac3c2660 = v);
$parcel$export(module.exports, "MCP_LOGGING_DATA_TYPE", () => $687ff8957497b063$export$6c463c5f3b00f64, (v) => $687ff8957497b063$export$6c463c5f3b00f64 = v);
$parcel$export(module.exports, "MCP_LOGGING_LEVEL", () => $687ff8957497b063$export$e25d553065457cab, (v) => $687ff8957497b063$export$e25d553065457cab = v);
$parcel$export(module.exports, "MCP_LOGGING_LOGGER", () => $687ff8957497b063$export$15d24c154ea8a56f, (v) => $687ff8957497b063$export$15d24c154ea8a56f = v);
$parcel$export(module.exports, "MCP_LOGGING_MESSAGE", () => $687ff8957497b063$export$e5065789a6c415d0, (v) => $687ff8957497b063$export$e5065789a6c415d0 = v);
$parcel$export(module.exports, "MCP_METHOD_NAME", () => $687ff8957497b063$export$62662c561d7c7835, (v) => $687ff8957497b063$export$62662c561d7c7835 = v);
$parcel$export(module.exports, "MCP_PROGRESS_CURRENT", () => $687ff8957497b063$export$218f394557fb0a5a, (v) => $687ff8957497b063$export$218f394557fb0a5a = v);
$parcel$export(module.exports, "MCP_PROGRESS_MESSAGE", () => $687ff8957497b063$export$2a5ff6de5448ecdf, (v) => $687ff8957497b063$export$2a5ff6de5448ecdf = v);
$parcel$export(module.exports, "MCP_PROGRESS_PERCENTAGE", () => $687ff8957497b063$export$9d23f3030ed2597e, (v) => $687ff8957497b063$export$9d23f3030ed2597e = v);
$parcel$export(module.exports, "MCP_PROGRESS_TOKEN", () => $687ff8957497b063$export$a26ff217a6124160, (v) => $687ff8957497b063$export$a26ff217a6124160 = v);
$parcel$export(module.exports, "MCP_PROGRESS_TOTAL", () => $687ff8957497b063$export$c8072f5fcfdb5b77, (v) => $687ff8957497b063$export$c8072f5fcfdb5b77 = v);
$parcel$export(module.exports, "MCP_PROMPT_NAME", () => $687ff8957497b063$export$c4e4b74f1ccf3d96, (v) => $687ff8957497b063$export$c4e4b74f1ccf3d96 = v);
$parcel$export(module.exports, "MCP_PROMPT_RESULT_DESCRIPTION", () => $687ff8957497b063$export$328519d02a26ac41, (v) => $687ff8957497b063$export$328519d02a26ac41 = v);
$parcel$export(module.exports, "MCP_PROMPT_RESULT_MESSAGE_CONTENT", () => $687ff8957497b063$export$d2061b291c43d045, (v) => $687ff8957497b063$export$d2061b291c43d045 = v);
$parcel$export(module.exports, "MCP_PROMPT_RESULT_MESSAGE_COUNT", () => $687ff8957497b063$export$d1f04dfd3d695286, (v) => $687ff8957497b063$export$d1f04dfd3d695286 = v);
$parcel$export(module.exports, "MCP_PROMPT_RESULT_MESSAGE_ROLE", () => $687ff8957497b063$export$234fbd86ea0f0bd8, (v) => $687ff8957497b063$export$234fbd86ea0f0bd8 = v);
$parcel$export(module.exports, "MCP_PROTOCOL_READY", () => $687ff8957497b063$export$e795000978a75b12, (v) => $687ff8957497b063$export$e795000978a75b12 = v);
$parcel$export(module.exports, "MCP_PROTOCOL_VERSION", () => $687ff8957497b063$export$9f4683b4d1018ace, (v) => $687ff8957497b063$export$9f4683b4d1018ace = v);
$parcel$export(module.exports, "MCP_REQUEST_ARGUMENT_KEY", () => $687ff8957497b063$export$e431b042fcdb1d63, (v) => $687ff8957497b063$export$e431b042fcdb1d63 = v);
$parcel$export(module.exports, "MCP_REQUEST_ARGUMENT_KEY_BASE", () => $687ff8957497b063$export$a453239171ac9a23, (v) => $687ff8957497b063$export$a453239171ac9a23 = v);
$parcel$export(module.exports, "MCP_REQUEST_ARGUMENT_NAME", () => $687ff8957497b063$export$3a7726a976c18d5f, (v) => $687ff8957497b063$export$3a7726a976c18d5f = v);
$parcel$export(module.exports, "MCP_REQUEST_ARGUMENT_URI", () => $687ff8957497b063$export$7eca7a6c06843b93, (v) => $687ff8957497b063$export$7eca7a6c06843b93 = v);
$parcel$export(module.exports, "MCP_REQUEST_ID", () => $687ff8957497b063$export$f25c55f83e5b0672, (v) => $687ff8957497b063$export$f25c55f83e5b0672 = v);
$parcel$export(module.exports, "MCP_RESOURCE_PROTOCOL", () => $687ff8957497b063$export$9562bfac4eb079cb, (v) => $687ff8957497b063$export$9562bfac4eb079cb = v);
$parcel$export(module.exports, "MCP_RESOURCE_URI", () => $687ff8957497b063$export$c276d164ff91d2f7, (v) => $687ff8957497b063$export$c276d164ff91d2f7 = v);
$parcel$export(module.exports, "MCP_SERVER_NAME", () => $687ff8957497b063$export$2f3e0574f1a99754, (v) => $687ff8957497b063$export$2f3e0574f1a99754 = v);
$parcel$export(module.exports, "MCP_SERVER_TITLE", () => $687ff8957497b063$export$15eecaab68167880, (v) => $687ff8957497b063$export$15eecaab68167880 = v);
$parcel$export(module.exports, "MCP_SERVER_VERSION", () => $687ff8957497b063$export$513c47f6e194086a, (v) => $687ff8957497b063$export$513c47f6e194086a = v);
$parcel$export(module.exports, "MCP_SESSION_ID", () => $687ff8957497b063$export$a3f464c4d5cd9096, (v) => $687ff8957497b063$export$a3f464c4d5cd9096 = v);
$parcel$export(module.exports, "MCP_TOOL_NAME", () => $687ff8957497b063$export$ed366a03a2330b03, (v) => $687ff8957497b063$export$ed366a03a2330b03 = v);
$parcel$export(module.exports, "MCP_TOOL_RESULT_CONTENT", () => $687ff8957497b063$export$9b802c784f235e1d, (v) => $687ff8957497b063$export$9b802c784f235e1d = v);
$parcel$export(module.exports, "MCP_TOOL_RESULT_CONTENT_COUNT", () => $687ff8957497b063$export$add0fc8b8c5726a4, (v) => $687ff8957497b063$export$add0fc8b8c5726a4 = v);
$parcel$export(module.exports, "MCP_TOOL_RESULT_IS_ERROR", () => $687ff8957497b063$export$e7f32463f5bfd554, (v) => $687ff8957497b063$export$e7f32463f5bfd554 = v);
$parcel$export(module.exports, "MCP_TRANSPORT", () => $687ff8957497b063$export$f9346f394edf26a, (v) => $687ff8957497b063$export$f9346f394edf26a = v);
$parcel$export(module.exports, "MDC_KEY", () => $687ff8957497b063$export$16b917774e73ef92, (v) => $687ff8957497b063$export$16b917774e73ef92 = v);
$parcel$export(module.exports, "MDC_KEY_BASE", () => $687ff8957497b063$export$15d2b60bf3b65454, (v) => $687ff8957497b063$export$15d2b60bf3b65454 = v);
$parcel$export(module.exports, "MESSAGING_BATCH_MESSAGE_COUNT", () => $687ff8957497b063$export$db55eca5af256142, (v) => $687ff8957497b063$export$db55eca5af256142 = v);
$parcel$export(module.exports, "MESSAGING_DESTINATION", () => $687ff8957497b063$export$967c74f8b1f3d35, (v) => $687ff8957497b063$export$967c74f8b1f3d35 = v);
$parcel$export(module.exports, "MESSAGING_DESTINATION_CONNECTION", () => $687ff8957497b063$export$7c33ae67962515d1, (v) => $687ff8957497b063$export$7c33ae67962515d1 = v);
$parcel$export(module.exports, "MESSAGING_DESTINATION_NAME", () => $687ff8957497b063$export$9c69839b2d93489b, (v) => $687ff8957497b063$export$9c69839b2d93489b = v);
$parcel$export(module.exports, "MESSAGING_MESSAGE_BODY_SIZE", () => $687ff8957497b063$export$be22d22d4b6cf5d8, (v) => $687ff8957497b063$export$be22d22d4b6cf5d8 = v);
$parcel$export(module.exports, "MESSAGING_MESSAGE_CONVERSATION_ID", () => $687ff8957497b063$export$c529961b911626ac, (v) => $687ff8957497b063$export$c529961b911626ac = v);
$parcel$export(module.exports, "MESSAGING_MESSAGE_ENVELOPE_SIZE", () => $687ff8957497b063$export$e39c4b15d2881f5, (v) => $687ff8957497b063$export$e39c4b15d2881f5 = v);
$parcel$export(module.exports, "MESSAGING_MESSAGE_ID", () => $687ff8957497b063$export$a8ca145161313e7, (v) => $687ff8957497b063$export$a8ca145161313e7 = v);
$parcel$export(module.exports, "MESSAGING_MESSAGE_RECEIVE_LATENCY", () => $687ff8957497b063$export$3c1204d03918d076, (v) => $687ff8957497b063$export$3c1204d03918d076 = v);
$parcel$export(module.exports, "MESSAGING_MESSAGE_RETRY_COUNT", () => $687ff8957497b063$export$eaac3f141165e288, (v) => $687ff8957497b063$export$eaac3f141165e288 = v);
$parcel$export(module.exports, "MESSAGING_OPERATION_NAME", () => $687ff8957497b063$export$4c7e6934714150e6, (v) => $687ff8957497b063$export$4c7e6934714150e6 = v);
$parcel$export(module.exports, "MESSAGING_OPERATION_TYPE", () => $687ff8957497b063$export$6f71f9711d666eb4, (v) => $687ff8957497b063$export$6f71f9711d666eb4 = v);
$parcel$export(module.exports, "MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY", () => $687ff8957497b063$export$2a3cd2bb71fb63a4, (v) => $687ff8957497b063$export$2a3cd2bb71fb63a4 = v);
$parcel$export(module.exports, "MESSAGING_SYSTEM", () => $687ff8957497b063$export$55478a0b7d2ae98f, (v) => $687ff8957497b063$export$55478a0b7d2ae98f = v);
$parcel$export(module.exports, "METHOD", () => $687ff8957497b063$export$bed10c4da9b8eb0a, (v) => $687ff8957497b063$export$bed10c4da9b8eb0a = v);
$parcel$export(module.exports, "MIDDLEWARE_NAME", () => $687ff8957497b063$export$a82607b6424c06c8, (v) => $687ff8957497b063$export$a82607b6424c06c8 = v);
$parcel$export(module.exports, "NAVIGATION_ORIGIN", () => $687ff8957497b063$export$6b081f3484c7f4e5, (v) => $687ff8957497b063$export$6b081f3484c7f4e5 = v);
$parcel$export(module.exports, "NAVIGATION_ROUTE_ID", () => $687ff8957497b063$export$b7754d85fd39406c, (v) => $687ff8957497b063$export$b7754d85fd39406c = v);
$parcel$export(module.exports, "NAVIGATION_TYPE", () => $687ff8957497b063$export$492856c046eb4728, (v) => $687ff8957497b063$export$492856c046eb4728 = v);
$parcel$export(module.exports, "NEL_ELAPSED_TIME", () => $687ff8957497b063$export$c1678a2059fbe906, (v) => $687ff8957497b063$export$c1678a2059fbe906 = v);
$parcel$export(module.exports, "NEL_PHASE", () => $687ff8957497b063$export$6d384a0bc1011c34, (v) => $687ff8957497b063$export$6d384a0bc1011c34 = v);
$parcel$export(module.exports, "NEL_REFERRER", () => $687ff8957497b063$export$1499a7dbfc01e7d4, (v) => $687ff8957497b063$export$1499a7dbfc01e7d4 = v);
$parcel$export(module.exports, "NEL_SAMPLING_FUNCTION", () => $687ff8957497b063$export$cfcbff40019f0ff1, (v) => $687ff8957497b063$export$cfcbff40019f0ff1 = v);
$parcel$export(module.exports, "NEL_TYPE", () => $687ff8957497b063$export$27157b5f68e583af, (v) => $687ff8957497b063$export$27157b5f68e583af = v);
$parcel$export(module.exports, "NETWORK_CONNECTION_EFFECTIVE_TYPE", () => $687ff8957497b063$export$54bf5ed61532925d, (v) => $687ff8957497b063$export$54bf5ed61532925d = v);
$parcel$export(module.exports, "NETWORK_CONNECTION_RTT", () => $687ff8957497b063$export$60ed0786292ace08, (v) => $687ff8957497b063$export$60ed0786292ace08 = v);
$parcel$export(module.exports, "NETWORK_CONNECTION_TYPE", () => $687ff8957497b063$export$d770bfb8345e146, (v) => $687ff8957497b063$export$d770bfb8345e146 = v);
$parcel$export(module.exports, "NETWORK_LOCAL_ADDRESS", () => $687ff8957497b063$export$bb73817f1290ad28, (v) => $687ff8957497b063$export$bb73817f1290ad28 = v);
$parcel$export(module.exports, "NETWORK_LOCAL_PORT", () => $687ff8957497b063$export$f201c980f2b75802, (v) => $687ff8957497b063$export$f201c980f2b75802 = v);
$parcel$export(module.exports, "NETWORK_PEER_ADDRESS", () => $687ff8957497b063$export$b40e970572afd0ee, (v) => $687ff8957497b063$export$b40e970572afd0ee = v);
$parcel$export(module.exports, "NETWORK_PEER_PORT", () => $687ff8957497b063$export$8850630a3d343488, (v) => $687ff8957497b063$export$8850630a3d343488 = v);
$parcel$export(module.exports, "NETWORK_PROTOCOL_NAME", () => $687ff8957497b063$export$fd0a39a918d6516f, (v) => $687ff8957497b063$export$fd0a39a918d6516f = v);
$parcel$export(module.exports, "NETWORK_PROTOCOL_VERSION", () => $687ff8957497b063$export$e68ef41f8e0335bf, (v) => $687ff8957497b063$export$e68ef41f8e0335bf = v);
$parcel$export(module.exports, "NETWORK_TRANSPORT", () => $687ff8957497b063$export$5bff09650e762829, (v) => $687ff8957497b063$export$5bff09650e762829 = v);
$parcel$export(module.exports, "NETWORK_TYPE", () => $687ff8957497b063$export$21c1adce0e067f37, (v) => $687ff8957497b063$export$21c1adce0e067f37 = v);
$parcel$export(module.exports, "NET_HOST_IP", () => $687ff8957497b063$export$fed6ce86f48c84bc, (v) => $687ff8957497b063$export$fed6ce86f48c84bc = v);
$parcel$export(module.exports, "NET_HOST_NAME", () => $687ff8957497b063$export$500c2675137ac16e, (v) => $687ff8957497b063$export$500c2675137ac16e = v);
$parcel$export(module.exports, "NET_HOST_PORT", () => $687ff8957497b063$export$402c7728623fd8df, (v) => $687ff8957497b063$export$402c7728623fd8df = v);
$parcel$export(module.exports, "NET_PEER_IP", () => $687ff8957497b063$export$15417259f4c0fe6b, (v) => $687ff8957497b063$export$15417259f4c0fe6b = v);
$parcel$export(module.exports, "NET_PEER_NAME", () => $687ff8957497b063$export$2b3b7f579a727f45, (v) => $687ff8957497b063$export$2b3b7f579a727f45 = v);
$parcel$export(module.exports, "NET_PEER_PORT", () => $687ff8957497b063$export$514832a0b029734b, (v) => $687ff8957497b063$export$514832a0b029734b = v);
$parcel$export(module.exports, "NET_PROTOCOL_NAME", () => $687ff8957497b063$export$b0522e6a14dec1a4, (v) => $687ff8957497b063$export$b0522e6a14dec1a4 = v);
$parcel$export(module.exports, "NET_PROTOCOL_VERSION", () => $687ff8957497b063$export$659ea19f71a7ee0b, (v) => $687ff8957497b063$export$659ea19f71a7ee0b = v);
$parcel$export(module.exports, "NET_SOCK_FAMILY", () => $687ff8957497b063$export$1b61d972db315e73, (v) => $687ff8957497b063$export$1b61d972db315e73 = v);
$parcel$export(module.exports, "NET_SOCK_HOST_ADDR", () => $687ff8957497b063$export$fb2970ee11a479ee, (v) => $687ff8957497b063$export$fb2970ee11a479ee = v);
$parcel$export(module.exports, "NET_SOCK_HOST_PORT", () => $687ff8957497b063$export$920aceb2a8fad77e, (v) => $687ff8957497b063$export$920aceb2a8fad77e = v);
$parcel$export(module.exports, "NET_SOCK_PEER_ADDR", () => $687ff8957497b063$export$48f8f6fbc999d187, (v) => $687ff8957497b063$export$48f8f6fbc999d187 = v);
$parcel$export(module.exports, "NET_SOCK_PEER_NAME", () => $687ff8957497b063$export$eed590fa00a8223b, (v) => $687ff8957497b063$export$eed590fa00a8223b = v);
$parcel$export(module.exports, "NET_SOCK_PEER_PORT", () => $687ff8957497b063$export$f2e5bb5cd4a130da, (v) => $687ff8957497b063$export$f2e5bb5cd4a130da = v);
$parcel$export(module.exports, "NET_TRANSPORT", () => $687ff8957497b063$export$779ef03d633a9086, (v) => $687ff8957497b063$export$779ef03d633a9086 = v);
$parcel$export(module.exports, "OS_BUILD", () => $687ff8957497b063$export$d98b87c8d53d0dbc, (v) => $687ff8957497b063$export$d98b87c8d53d0dbc = v);
$parcel$export(module.exports, "OS_BUILD_ID", () => $687ff8957497b063$export$ca719aa57653a0a7, (v) => $687ff8957497b063$export$ca719aa57653a0a7 = v);
$parcel$export(module.exports, "OS_DESCRIPTION", () => $687ff8957497b063$export$74b19c5f48270c05, (v) => $687ff8957497b063$export$74b19c5f48270c05 = v);
$parcel$export(module.exports, "OS_KERNEL_VERSION", () => $687ff8957497b063$export$c351affe7e8098cb, (v) => $687ff8957497b063$export$c351affe7e8098cb = v);
$parcel$export(module.exports, "OS_NAME", () => $687ff8957497b063$export$be7cd6b3ae3ae765, (v) => $687ff8957497b063$export$be7cd6b3ae3ae765 = v);
$parcel$export(module.exports, "OS_RAW_DESCRIPTION", () => $687ff8957497b063$export$ec182524c4c57275, (v) => $687ff8957497b063$export$ec182524c4c57275 = v);
$parcel$export(module.exports, "OS_ROOTED", () => $687ff8957497b063$export$9e45758246a85b07, (v) => $687ff8957497b063$export$9e45758246a85b07 = v);
$parcel$export(module.exports, "OS_THEME", () => $687ff8957497b063$export$9fa5d5f0144954cb, (v) => $687ff8957497b063$export$9fa5d5f0144954cb = v);
$parcel$export(module.exports, "OS_TYPE", () => $687ff8957497b063$export$e66ba5bc4b978023, (v) => $687ff8957497b063$export$e66ba5bc4b978023 = v);
$parcel$export(module.exports, "OS_VERSION", () => $687ff8957497b063$export$2306e23cc611a36d, (v) => $687ff8957497b063$export$2306e23cc611a36d = v);
$parcel$export(module.exports, "OTEL_KIND", () => $687ff8957497b063$export$144f8c1fe01428db, (v) => $687ff8957497b063$export$144f8c1fe01428db = v);
$parcel$export(module.exports, "OTEL_SCOPE_NAME", () => $687ff8957497b063$export$f303b2744d52121c, (v) => $687ff8957497b063$export$f303b2744d52121c = v);
$parcel$export(module.exports, "OTEL_SCOPE_VERSION", () => $687ff8957497b063$export$866b2dbc7bf18ce6, (v) => $687ff8957497b063$export$866b2dbc7bf18ce6 = v);
$parcel$export(module.exports, "OTEL_STATUS_CODE", () => $687ff8957497b063$export$b4c85774878b4841, (v) => $687ff8957497b063$export$b4c85774878b4841 = v);
$parcel$export(module.exports, "OTEL_STATUS_DESCRIPTION", () => $687ff8957497b063$export$1c967a71bc9a3077, (v) => $687ff8957497b063$export$1c967a71bc9a3077 = v);
$parcel$export(module.exports, "PARAMS_KEY", () => $687ff8957497b063$export$5e3884a35a19eb90, (v) => $687ff8957497b063$export$5e3884a35a19eb90 = v);
$parcel$export(module.exports, "PARAMS_KEY_BASE", () => $687ff8957497b063$export$6e7ff99bb3259573, (v) => $687ff8957497b063$export$6e7ff99bb3259573 = v);
$parcel$export(module.exports, "PERFORMANCE_ACTIVATIONSTART", () => $687ff8957497b063$export$7c932cba2d9e7a7, (v) => $687ff8957497b063$export$7c932cba2d9e7a7 = v);
$parcel$export(module.exports, "PERFORMANCE_TIMEORIGIN", () => $687ff8957497b063$export$94091942edce0667, (v) => $687ff8957497b063$export$94091942edce0667 = v);
$parcel$export(module.exports, "PREVIOUS_ROUTE", () => $687ff8957497b063$export$3671a8a524706a9d, (v) => $687ff8957497b063$export$3671a8a524706a9d = v);
$parcel$export(module.exports, "PROCESS_COMMAND_ARGS", () => $687ff8957497b063$export$c288888dc82d233f, (v) => $687ff8957497b063$export$c288888dc82d233f = v);
$parcel$export(module.exports, "PROCESS_EXECUTABLE_NAME", () => $687ff8957497b063$export$8ff188536cebc35, (v) => $687ff8957497b063$export$8ff188536cebc35 = v);
$parcel$export(module.exports, "PROCESS_PID", () => $687ff8957497b063$export$6407d78968c0eabe, (v) => $687ff8957497b063$export$6407d78968c0eabe = v);
$parcel$export(module.exports, "PROCESS_RUNTIME_DESCRIPTION", () => $687ff8957497b063$export$43e9fb9ec28d9743, (v) => $687ff8957497b063$export$43e9fb9ec28d9743 = v);
$parcel$export(module.exports, "PROCESS_RUNTIME_ENGINE_NAME", () => $687ff8957497b063$export$26f31d5c5c201739, (v) => $687ff8957497b063$export$26f31d5c5c201739 = v);
$parcel$export(module.exports, "PROCESS_RUNTIME_ENGINE_VERSION", () => $687ff8957497b063$export$bff85124d2d35b93, (v) => $687ff8957497b063$export$bff85124d2d35b93 = v);
$parcel$export(module.exports, "PROCESS_RUNTIME_NAME", () => $687ff8957497b063$export$495c671ed5a6408c, (v) => $687ff8957497b063$export$495c671ed5a6408c = v);
$parcel$export(module.exports, "PROCESS_RUNTIME_VERSION", () => $687ff8957497b063$export$54b3d4d5548c35c3, (v) => $687ff8957497b063$export$54b3d4d5548c35c3 = v);
$parcel$export(module.exports, "QUERY_KEY", () => $687ff8957497b063$export$2954db6444fe1fa8, (v) => $687ff8957497b063$export$2954db6444fe1fa8 = v);
$parcel$export(module.exports, "QUERY_KEY_BASE", () => $687ff8957497b063$export$15c1c974d16dd678, (v) => $687ff8957497b063$export$15c1c974d16dd678 = v);
$parcel$export(module.exports, "REACT_VERSION", () => $687ff8957497b063$export$9be2ae89a1eac217, (v) => $687ff8957497b063$export$9be2ae89a1eac217 = v);
$parcel$export(module.exports, "RELEASE", () => $687ff8957497b063$export$5c698591c0e586a2, (v) => $687ff8957497b063$export$5c698591c0e586a2 = v);
$parcel$export(module.exports, "REMIX_ACTION_FORM_DATA_KEY", () => $687ff8957497b063$export$b711f2bb9c9a848a, (v) => $687ff8957497b063$export$b711f2bb9c9a848a = v);
$parcel$export(module.exports, "REMIX_ACTION_FORM_DATA_KEY_BASE", () => $687ff8957497b063$export$1d3a8501efd30213, (v) => $687ff8957497b063$export$1d3a8501efd30213 = v);
$parcel$export(module.exports, "REPLAY_ID", () => $687ff8957497b063$export$cebaf684ced5a2c9, (v) => $687ff8957497b063$export$cebaf684ced5a2c9 = v);
$parcel$export(module.exports, "RESOURCE_DEPLOYMENT_ENVIRONMENT", () => $687ff8957497b063$export$d4c658ecdcb7c78c, (v) => $687ff8957497b063$export$d4c658ecdcb7c78c = v);
$parcel$export(module.exports, "RESOURCE_DEPLOYMENT_ENVIRONMENT_NAME", () => $687ff8957497b063$export$b1b162b01baeb044, (v) => $687ff8957497b063$export$b1b162b01baeb044 = v);
$parcel$export(module.exports, "RESOURCE_RENDER_BLOCKING_STATUS", () => $687ff8957497b063$export$8be2d593d7f88ed8, (v) => $687ff8957497b063$export$8be2d593d7f88ed8 = v);
$parcel$export(module.exports, "ROUTE", () => $687ff8957497b063$export$dbd0a3528a97ccc0, (v) => $687ff8957497b063$export$dbd0a3528a97ccc0 = v);
$parcel$export(module.exports, "RPC_GRPC_STATUS_CODE", () => $687ff8957497b063$export$66581dc6d3d083d1, (v) => $687ff8957497b063$export$66581dc6d3d083d1 = v);
$parcel$export(module.exports, "RPC_METHOD", () => $687ff8957497b063$export$e545f99e7abcc499, (v) => $687ff8957497b063$export$e545f99e7abcc499 = v);
$parcel$export(module.exports, "RPC_RESPONSE_STATUS_CODE", () => $687ff8957497b063$export$7e1af5787f8c4aaa, (v) => $687ff8957497b063$export$7e1af5787f8c4aaa = v);
$parcel$export(module.exports, "RPC_SERVICE", () => $687ff8957497b063$export$186c94c351c54768, (v) => $687ff8957497b063$export$186c94c351c54768 = v);
$parcel$export(module.exports, "RPC_SYSTEM", () => $687ff8957497b063$export$2e3fd8dfcb16fe0c, (v) => $687ff8957497b063$export$2e3fd8dfcb16fe0c = v);
$parcel$export(module.exports, "RPC_SYSTEM_NAME", () => $687ff8957497b063$export$7eeeceaa1dbd7cd5, (v) => $687ff8957497b063$export$7eeeceaa1dbd7cd5 = v);
$parcel$export(module.exports, "RUNTIME_BUILD", () => $687ff8957497b063$export$9d5bffdff936d554, (v) => $687ff8957497b063$export$9d5bffdff936d554 = v);
$parcel$export(module.exports, "RUNTIME_NAME", () => $687ff8957497b063$export$dc3a801c9a2c5b79, (v) => $687ff8957497b063$export$dc3a801c9a2c5b79 = v);
$parcel$export(module.exports, "RUNTIME_RAW_DESCRIPTION", () => $687ff8957497b063$export$27933a9557f87e98, (v) => $687ff8957497b063$export$27933a9557f87e98 = v);
$parcel$export(module.exports, "RUNTIME_VERSION", () => $687ff8957497b063$export$eefa737b40a0d535, (v) => $687ff8957497b063$export$eefa737b40a0d535 = v);
$parcel$export(module.exports, "SCORE_KEY", () => $687ff8957497b063$export$92740ffbcb02553b, (v) => $687ff8957497b063$export$92740ffbcb02553b = v);
$parcel$export(module.exports, "SCORE_KEY_BASE", () => $687ff8957497b063$export$500e89753f9f1008, (v) => $687ff8957497b063$export$500e89753f9f1008 = v);
$parcel$export(module.exports, "SCORE_RATIO_KEY", () => $687ff8957497b063$export$d91a18e47fdddefd, (v) => $687ff8957497b063$export$d91a18e47fdddefd = v);
$parcel$export(module.exports, "SCORE_RATIO_KEY_BASE", () => $687ff8957497b063$export$eccbe6f20884ea7f, (v) => $687ff8957497b063$export$eccbe6f20884ea7f = v);
$parcel$export(module.exports, "SCORE_TOTAL", () => $687ff8957497b063$export$9e24f11d79141afb, (v) => $687ff8957497b063$export$9e24f11d79141afb = v);
$parcel$export(module.exports, "SCORE_WEIGHT_KEY", () => $687ff8957497b063$export$f0b96ad9586f8887, (v) => $687ff8957497b063$export$f0b96ad9586f8887 = v);
$parcel$export(module.exports, "SCORE_WEIGHT_KEY_BASE", () => $687ff8957497b063$export$8a92ed5d436a85c6, (v) => $687ff8957497b063$export$8a92ed5d436a85c6 = v);
$parcel$export(module.exports, "SENTRY_ACTION", () => $687ff8957497b063$export$edd59acdf7e86a71, (v) => $687ff8957497b063$export$edd59acdf7e86a71 = v);
$parcel$export(module.exports, "SENTRY_BROWSER_NAME", () => $687ff8957497b063$export$ae81a1ae71952d50, (v) => $687ff8957497b063$export$ae81a1ae71952d50 = v);
$parcel$export(module.exports, "SENTRY_BROWSER_VERSION", () => $687ff8957497b063$export$6101470cd57eac1b, (v) => $687ff8957497b063$export$6101470cd57eac1b = v);
$parcel$export(module.exports, "SENTRY_CANCELLATION_REASON", () => $687ff8957497b063$export$452c0aee9673fe67, (v) => $687ff8957497b063$export$452c0aee9673fe67 = v);
$parcel$export(module.exports, "SENTRY_CATEGORY", () => $687ff8957497b063$export$773dddd1e8667756, (v) => $687ff8957497b063$export$773dddd1e8667756 = v);
$parcel$export(module.exports, "SENTRY_CLIENT_SAMPLE_RATE", () => $687ff8957497b063$export$98815f8579a64a90, (v) => $687ff8957497b063$export$98815f8579a64a90 = v);
$parcel$export(module.exports, "SENTRY_DESCRIPTION", () => $687ff8957497b063$export$7bc4e27428665019, (v) => $687ff8957497b063$export$7bc4e27428665019 = v);
$parcel$export(module.exports, "SENTRY_DIST", () => $687ff8957497b063$export$e7d7477fa9057ee2, (v) => $687ff8957497b063$export$e7d7477fa9057ee2 = v);
$parcel$export(module.exports, "SENTRY_DOMAIN", () => $687ff8957497b063$export$1f4267a3fc018448, (v) => $687ff8957497b063$export$1f4267a3fc018448 = v);
$parcel$export(module.exports, "SENTRY_DSC_ENVIRONMENT", () => $687ff8957497b063$export$c171cae150389952, (v) => $687ff8957497b063$export$c171cae150389952 = v);
$parcel$export(module.exports, "SENTRY_DSC_PROJECT_ID", () => $687ff8957497b063$export$d9bb35e957b22c72, (v) => $687ff8957497b063$export$d9bb35e957b22c72 = v);
$parcel$export(module.exports, "SENTRY_DSC_PUBLIC_KEY", () => $687ff8957497b063$export$b3508a2c95f74e3d, (v) => $687ff8957497b063$export$b3508a2c95f74e3d = v);
$parcel$export(module.exports, "SENTRY_DSC_RELEASE", () => $687ff8957497b063$export$20bb272f4d21532d, (v) => $687ff8957497b063$export$20bb272f4d21532d = v);
$parcel$export(module.exports, "SENTRY_DSC_SAMPLED", () => $687ff8957497b063$export$d7e64fbd0102ce90, (v) => $687ff8957497b063$export$d7e64fbd0102ce90 = v);
$parcel$export(module.exports, "SENTRY_DSC_SAMPLE_RATE", () => $687ff8957497b063$export$c17eae7e86dbba3c, (v) => $687ff8957497b063$export$c17eae7e86dbba3c = v);
$parcel$export(module.exports, "SENTRY_DSC_TRACE_ID", () => $687ff8957497b063$export$349603c0a9165744, (v) => $687ff8957497b063$export$349603c0a9165744 = v);
$parcel$export(module.exports, "SENTRY_DSC_TRANSACTION", () => $687ff8957497b063$export$4dadf693741f0283, (v) => $687ff8957497b063$export$4dadf693741f0283 = v);
$parcel$export(module.exports, "SENTRY_ENVIRONMENT", () => $687ff8957497b063$export$6377864d12f7eeb3, (v) => $687ff8957497b063$export$6377864d12f7eeb3 = v);
$parcel$export(module.exports, "SENTRY_EXCLUSIVE_TIME", () => $687ff8957497b063$export$ba081af9585ed4, (v) => $687ff8957497b063$export$ba081af9585ed4 = v);
$parcel$export(module.exports, "SENTRY_GRAPHQL_OPERATION", () => $687ff8957497b063$export$7841dacb241485d0, (v) => $687ff8957497b063$export$7841dacb241485d0 = v);
$parcel$export(module.exports, "SENTRY_GROUP", () => $687ff8957497b063$export$52c7044cf6301362, (v) => $687ff8957497b063$export$52c7044cf6301362 = v);
$parcel$export(module.exports, "SENTRY_HTTP_PREFETCH", () => $687ff8957497b063$export$56ea1c9e44590e20, (v) => $687ff8957497b063$export$56ea1c9e44590e20 = v);
$parcel$export(module.exports, "SENTRY_IDLE_SPAN_FINISH_REASON", () => $687ff8957497b063$export$7626e389d05f4c36, (v) => $687ff8957497b063$export$7626e389d05f4c36 = v);
$parcel$export(module.exports, "SENTRY_IS_REMOTE", () => $687ff8957497b063$export$5e0a48187329b2e7, (v) => $687ff8957497b063$export$5e0a48187329b2e7 = v);
$parcel$export(module.exports, "SENTRY_KIND", () => $687ff8957497b063$export$c322b150d7667841, (v) => $687ff8957497b063$export$c322b150d7667841 = v);
$parcel$export(module.exports, "SENTRY_MAIN_THREAD", () => $687ff8957497b063$export$4a4797d3c962f753, (v) => $687ff8957497b063$export$4a4797d3c962f753 = v);
$parcel$export(module.exports, "SENTRY_MESSAGE_PARAMETER_KEY", () => $687ff8957497b063$export$767524d5e72e2645, (v) => $687ff8957497b063$export$767524d5e72e2645 = v);
$parcel$export(module.exports, "SENTRY_MESSAGE_TEMPLATE", () => $687ff8957497b063$export$497354ca7b0ee666, (v) => $687ff8957497b063$export$497354ca7b0ee666 = v);
$parcel$export(module.exports, "SENTRY_METRIC_SOURCE", () => $687ff8957497b063$export$cbdc4ad11118116a, (v) => $687ff8957497b063$export$cbdc4ad11118116a = v);
$parcel$export(module.exports, "SENTRY_MOBILE", () => $687ff8957497b063$export$5b890de778c4c2fe, (v) => $687ff8957497b063$export$5b890de778c4c2fe = v);
$parcel$export(module.exports, "SENTRY_MODULE_KEY", () => $687ff8957497b063$export$a78d9803b5e0a83e, (v) => $687ff8957497b063$export$a78d9803b5e0a83e = v);
$parcel$export(module.exports, "SENTRY_MODULE_KEY_BASE", () => $687ff8957497b063$export$df1b536467b3992a, (v) => $687ff8957497b063$export$df1b536467b3992a = v);
$parcel$export(module.exports, "SENTRY_NEXTJS_SSR_FUNCTION_ROUTE", () => $687ff8957497b063$export$73104a329e205998, (v) => $687ff8957497b063$export$73104a329e205998 = v);
$parcel$export(module.exports, "SENTRY_NEXTJS_SSR_FUNCTION_TYPE", () => $687ff8957497b063$export$5740e3da55330b0a, (v) => $687ff8957497b063$export$5740e3da55330b0a = v);
$parcel$export(module.exports, "SENTRY_NORMALIZED_DB_QUERY", () => $687ff8957497b063$export$8dcc2d92ff6d65da, (v) => $687ff8957497b063$export$8dcc2d92ff6d65da = v);
$parcel$export(module.exports, "SENTRY_NORMALIZED_DB_QUERY_HASH", () => $687ff8957497b063$export$e5f1321e53e24810, (v) => $687ff8957497b063$export$e5f1321e53e24810 = v);
$parcel$export(module.exports, "SENTRY_NORMALIZED_DESCRIPTION", () => $687ff8957497b063$export$56dd3098cbca7c8a, (v) => $687ff8957497b063$export$56dd3098cbca7c8a = v);
$parcel$export(module.exports, "SENTRY_OBSERVED_TIMESTAMP_NANOS", () => $687ff8957497b063$export$aa7aff70e4380665, (v) => $687ff8957497b063$export$aa7aff70e4380665 = v);
$parcel$export(module.exports, "SENTRY_OP", () => $687ff8957497b063$export$dacb7d452aa6bcaf, (v) => $687ff8957497b063$export$dacb7d452aa6bcaf = v);
$parcel$export(module.exports, "SENTRY_ORIGIN", () => $687ff8957497b063$export$15dfc6c5e8f9baf6, (v) => $687ff8957497b063$export$15dfc6c5e8f9baf6 = v);
$parcel$export(module.exports, "SENTRY_PLATFORM", () => $687ff8957497b063$export$91ad03bba7909fb5, (v) => $687ff8957497b063$export$91ad03bba7909fb5 = v);
$parcel$export(module.exports, "SENTRY_PROFILER_ID", () => $687ff8957497b063$export$86128e6c0ab71d64, (v) => $687ff8957497b063$export$86128e6c0ab71d64 = v);
$parcel$export(module.exports, "SENTRY_PROFILE_ID", () => $687ff8957497b063$export$745b60c4819aec1d, (v) => $687ff8957497b063$export$745b60c4819aec1d = v);
$parcel$export(module.exports, "SENTRY_RELEASE", () => $687ff8957497b063$export$d2c893bfac1da9a1, (v) => $687ff8957497b063$export$d2c893bfac1da9a1 = v);
$parcel$export(module.exports, "SENTRY_REPLAY_ID", () => $687ff8957497b063$export$1c14ad02f9534b19, (v) => $687ff8957497b063$export$1c14ad02f9534b19 = v);
$parcel$export(module.exports, "SENTRY_REPLAY_IS_BUFFERING", () => $687ff8957497b063$export$db3cb63e0594d014, (v) => $687ff8957497b063$export$db3cb63e0594d014 = v);
$parcel$export(module.exports, "SENTRY_REPORT_EVENT", () => $687ff8957497b063$export$a65c9a0eba2c222d, (v) => $687ff8957497b063$export$a65c9a0eba2c222d = v);
$parcel$export(module.exports, "SENTRY_SDK_INTEGRATIONS", () => $687ff8957497b063$export$68dbcca9c0e339ec, (v) => $687ff8957497b063$export$68dbcca9c0e339ec = v);
$parcel$export(module.exports, "SENTRY_SDK_NAME", () => $687ff8957497b063$export$d59b669d4bb3f006, (v) => $687ff8957497b063$export$d59b669d4bb3f006 = v);
$parcel$export(module.exports, "SENTRY_SDK_VERSION", () => $687ff8957497b063$export$4d88d347aa9667fc, (v) => $687ff8957497b063$export$4d88d347aa9667fc = v);
$parcel$export(module.exports, "SENTRY_SEGMENT_ID", () => $687ff8957497b063$export$9943ffdcaa4bc506, (v) => $687ff8957497b063$export$9943ffdcaa4bc506 = v);
$parcel$export(module.exports, "SENTRY_SEGMENT_NAME", () => $687ff8957497b063$export$d4f25b923533dbba, (v) => $687ff8957497b063$export$d4f25b923533dbba = v);
$parcel$export(module.exports, "SENTRY_SERVER_SAMPLE_RATE", () => $687ff8957497b063$export$35f3396a1cdeea45, (v) => $687ff8957497b063$export$35f3396a1cdeea45 = v);
$parcel$export(module.exports, "SENTRY_SOURCE", () => $687ff8957497b063$export$80e399da474bc98d, (v) => $687ff8957497b063$export$80e399da474bc98d = v);
$parcel$export(module.exports, "SENTRY_SPAN_SOURCE", () => $687ff8957497b063$export$e01809e2dbceac35, (v) => $687ff8957497b063$export$e01809e2dbceac35 = v);
$parcel$export(module.exports, "SENTRY_STATUS", () => $687ff8957497b063$export$41900d5c4e8a9c68, (v) => $687ff8957497b063$export$41900d5c4e8a9c68 = v);
$parcel$export(module.exports, "SENTRY_STATUS_CODE", () => $687ff8957497b063$export$362bb1cb0bb5ca03, (v) => $687ff8957497b063$export$362bb1cb0bb5ca03 = v);
$parcel$export(module.exports, "SENTRY_STATUS_MESSAGE", () => $687ff8957497b063$export$6803ac54f919d9cc, (v) => $687ff8957497b063$export$6803ac54f919d9cc = v);
$parcel$export(module.exports, "SENTRY_SVELTEKIT_NAVIGATION_FROM", () => $687ff8957497b063$export$72f5b47540331169, (v) => $687ff8957497b063$export$72f5b47540331169 = v);
$parcel$export(module.exports, "SENTRY_SVELTEKIT_NAVIGATION_TO", () => $687ff8957497b063$export$6c61a8c9aa5305cb, (v) => $687ff8957497b063$export$6c61a8c9aa5305cb = v);
$parcel$export(module.exports, "SENTRY_SVELTEKIT_NAVIGATION_TYPE", () => $687ff8957497b063$export$6b5244c457b68e65, (v) => $687ff8957497b063$export$6b5244c457b68e65 = v);
$parcel$export(module.exports, "SENTRY_THREAD_ID", () => $687ff8957497b063$export$b7bd0c9a886f3414, (v) => $687ff8957497b063$export$b7bd0c9a886f3414 = v);
$parcel$export(module.exports, "SENTRY_TIMESTAMP_SEQUENCE", () => $687ff8957497b063$export$6b77f2bacac7c93d, (v) => $687ff8957497b063$export$6b77f2bacac7c93d = v);
$parcel$export(module.exports, "SENTRY_TRACE_LIFECYCLE", () => $687ff8957497b063$export$ddbc15c0e8e8a7ea, (v) => $687ff8957497b063$export$ddbc15c0e8e8a7ea = v);
$parcel$export(module.exports, "SENTRY_TRACE_PARENT_SPAN_ID", () => $687ff8957497b063$export$feb4fe753df28a82, (v) => $687ff8957497b063$export$feb4fe753df28a82 = v);
$parcel$export(module.exports, "SENTRY_TRACE_STATUS", () => $687ff8957497b063$export$d6267756132e2175, (v) => $687ff8957497b063$export$d6267756132e2175 = v);
$parcel$export(module.exports, "SENTRY_TRANSACTION", () => $687ff8957497b063$export$570ac5a3fd7e6cc6, (v) => $687ff8957497b063$export$570ac5a3fd7e6cc6 = v);
$parcel$export(module.exports, "SENTRY_USER_EMAIL", () => $687ff8957497b063$export$5b9a0015e1c530ed, (v) => $687ff8957497b063$export$5b9a0015e1c530ed = v);
$parcel$export(module.exports, "SENTRY_USER_GEO_CITY", () => $687ff8957497b063$export$8bbff71c84508218, (v) => $687ff8957497b063$export$8bbff71c84508218 = v);
$parcel$export(module.exports, "SENTRY_USER_GEO_COUNTRY_CODE", () => $687ff8957497b063$export$b55aa07a514a2430, (v) => $687ff8957497b063$export$b55aa07a514a2430 = v);
$parcel$export(module.exports, "SENTRY_USER_GEO_REGION", () => $687ff8957497b063$export$9927ad09f7c084dc, (v) => $687ff8957497b063$export$9927ad09f7c084dc = v);
$parcel$export(module.exports, "SENTRY_USER_GEO_SUBDIVISION", () => $687ff8957497b063$export$52a07a35ff8ec6b6, (v) => $687ff8957497b063$export$52a07a35ff8ec6b6 = v);
$parcel$export(module.exports, "SENTRY_USER_ID", () => $687ff8957497b063$export$a10d277c42e6cae3, (v) => $687ff8957497b063$export$a10d277c42e6cae3 = v);
$parcel$export(module.exports, "SENTRY_USER_IP", () => $687ff8957497b063$export$cdc0ce5c66182801, (v) => $687ff8957497b063$export$cdc0ce5c66182801 = v);
$parcel$export(module.exports, "SENTRY_USER_USERNAME", () => $687ff8957497b063$export$2504d4bd698dd962, (v) => $687ff8957497b063$export$2504d4bd698dd962 = v);
$parcel$export(module.exports, "SERVER_ADDRESS", () => $687ff8957497b063$export$9dc86f3b876e96ef, (v) => $687ff8957497b063$export$9dc86f3b876e96ef = v);
$parcel$export(module.exports, "SERVER_NAME", () => $687ff8957497b063$export$70ff7865f52549ae, (v) => $687ff8957497b063$export$70ff7865f52549ae = v);
$parcel$export(module.exports, "SERVER_PORT", () => $687ff8957497b063$export$f77b53a42be6e6fd, (v) => $687ff8957497b063$export$f77b53a42be6e6fd = v);
$parcel$export(module.exports, "SERVICE_NAME", () => $687ff8957497b063$export$818eb7ab11414506, (v) => $687ff8957497b063$export$818eb7ab11414506 = v);
$parcel$export(module.exports, "SERVICE_VERSION", () => $687ff8957497b063$export$829ef6b2e59d984d, (v) => $687ff8957497b063$export$829ef6b2e59d984d = v);
$parcel$export(module.exports, "SESSION_ID", () => $687ff8957497b063$export$b30f4cb52c088a26, (v) => $687ff8957497b063$export$b30f4cb52c088a26 = v);
$parcel$export(module.exports, "STALL_PERCENTAGE", () => $687ff8957497b063$export$335eace0ff1771cd, (v) => $687ff8957497b063$export$335eace0ff1771cd = v);
$parcel$export(module.exports, "STALL_TOTAL_TIME", () => $687ff8957497b063$export$374d88a2025416ac, (v) => $687ff8957497b063$export$374d88a2025416ac = v);
$parcel$export(module.exports, "STATE_TYPE", () => $687ff8957497b063$export$bb7a91303551eb37, (v) => $687ff8957497b063$export$bb7a91303551eb37 = v);
$parcel$export(module.exports, "THREAD_ID", () => $687ff8957497b063$export$f132ea291a7db56b, (v) => $687ff8957497b063$export$f132ea291a7db56b = v);
$parcel$export(module.exports, "THREAD_NAME", () => $687ff8957497b063$export$f0abd4170bbd2468, (v) => $687ff8957497b063$export$f0abd4170bbd2468 = v);
$parcel$export(module.exports, "TIMBER_TAG", () => $687ff8957497b063$export$50d00a157dc08581, (v) => $687ff8957497b063$export$50d00a157dc08581 = v);
$parcel$export(module.exports, "TIME_TO_FULL_DISPLAY", () => $687ff8957497b063$export$484576567a98833f, (v) => $687ff8957497b063$export$484576567a98833f = v);
$parcel$export(module.exports, "TIME_TO_INITIAL_DISPLAY", () => $687ff8957497b063$export$ec9e491e475d0c97, (v) => $687ff8957497b063$export$ec9e491e475d0c97 = v);
$parcel$export(module.exports, "TRANSACTION", () => $687ff8957497b063$export$a86c59c10992220f, (v) => $687ff8957497b063$export$a86c59c10992220f = v);
$parcel$export(module.exports, "TRPC_PROCEDURE_PATH", () => $687ff8957497b063$export$e12f06597e992fde, (v) => $687ff8957497b063$export$e12f06597e992fde = v);
$parcel$export(module.exports, "TRPC_PROCEDURE_TYPE", () => $687ff8957497b063$export$7ec54678ba28ea59, (v) => $687ff8957497b063$export$7ec54678ba28ea59 = v);
$parcel$export(module.exports, "TTFB", () => $687ff8957497b063$export$433ba14c16717110, (v) => $687ff8957497b063$export$433ba14c16717110 = v);
$parcel$export(module.exports, "TTFB_REQUESTTIME", () => $687ff8957497b063$export$309ee349b8a537f, (v) => $687ff8957497b063$export$309ee349b8a537f = v);
$parcel$export(module.exports, "TYPE", () => $687ff8957497b063$export$b87f371cbc396fcf, (v) => $687ff8957497b063$export$b87f371cbc396fcf = v);
$parcel$export(module.exports, "UI_COMPONENT_NAME", () => $687ff8957497b063$export$60050fc49fe0e7e2, (v) => $687ff8957497b063$export$60050fc49fe0e7e2 = v);
$parcel$export(module.exports, "UI_CONTRIBUTES_TO_TTFD", () => $687ff8957497b063$export$348c8e2b37f276cd, (v) => $687ff8957497b063$export$348c8e2b37f276cd = v);
$parcel$export(module.exports, "UI_CONTRIBUTES_TO_TTID", () => $687ff8957497b063$export$7f47e8a8b2d97cb2, (v) => $687ff8957497b063$export$7f47e8a8b2d97cb2 = v);
$parcel$export(module.exports, "UI_ELEMENT_HEIGHT", () => $687ff8957497b063$export$50d5adc4b543ce95, (v) => $687ff8957497b063$export$50d5adc4b543ce95 = v);
$parcel$export(module.exports, "UI_ELEMENT_ID", () => $687ff8957497b063$export$9221f1d2c934d9f, (v) => $687ff8957497b063$export$9221f1d2c934d9f = v);
$parcel$export(module.exports, "UI_ELEMENT_IDENTIFIER", () => $687ff8957497b063$export$3a56578b3ae09a02, (v) => $687ff8957497b063$export$3a56578b3ae09a02 = v);
$parcel$export(module.exports, "UI_ELEMENT_LOAD_TIME", () => $687ff8957497b063$export$e47b8dab9466c895, (v) => $687ff8957497b063$export$e47b8dab9466c895 = v);
$parcel$export(module.exports, "UI_ELEMENT_PAINT_TYPE", () => $687ff8957497b063$export$4ca52f75cf4889c5, (v) => $687ff8957497b063$export$4ca52f75cf4889c5 = v);
$parcel$export(module.exports, "UI_ELEMENT_RENDER_TIME", () => $687ff8957497b063$export$7343d7d72195067f, (v) => $687ff8957497b063$export$7343d7d72195067f = v);
$parcel$export(module.exports, "UI_ELEMENT_TYPE", () => $687ff8957497b063$export$f334f32f8d4d8063, (v) => $687ff8957497b063$export$f334f32f8d4d8063 = v);
$parcel$export(module.exports, "UI_ELEMENT_URL", () => $687ff8957497b063$export$c7bf2089e89a217c, (v) => $687ff8957497b063$export$c7bf2089e89a217c = v);
$parcel$export(module.exports, "UI_ELEMENT_WIDTH", () => $687ff8957497b063$export$f514f97553a434b2, (v) => $687ff8957497b063$export$f514f97553a434b2 = v);
$parcel$export(module.exports, "URL", () => $687ff8957497b063$export$61abde59b50deb8e, (v) => $687ff8957497b063$export$61abde59b50deb8e = v);
$parcel$export(module.exports, "URL_DOMAIN", () => $687ff8957497b063$export$5a5ce44f9fb51f93, (v) => $687ff8957497b063$export$5a5ce44f9fb51f93 = v);
$parcel$export(module.exports, "URL_FRAGMENT", () => $687ff8957497b063$export$7044ea8d89b6f59d, (v) => $687ff8957497b063$export$7044ea8d89b6f59d = v);
$parcel$export(module.exports, "URL_FULL", () => $687ff8957497b063$export$40eacf1a072c9dbd, (v) => $687ff8957497b063$export$40eacf1a072c9dbd = v);
$parcel$export(module.exports, "URL_PATH", () => $687ff8957497b063$export$4c1fa0ac0eff2ac, (v) => $687ff8957497b063$export$4c1fa0ac0eff2ac = v);
$parcel$export(module.exports, "URL_PATH_PARAMETER_KEY", () => $687ff8957497b063$export$5bee9450fe31dde1, (v) => $687ff8957497b063$export$5bee9450fe31dde1 = v);
$parcel$export(module.exports, "URL_PATH_PARAMETER_KEY_BASE", () => $687ff8957497b063$export$d0b571fb4406d953, (v) => $687ff8957497b063$export$d0b571fb4406d953 = v);
$parcel$export(module.exports, "URL_PORT", () => $687ff8957497b063$export$258b370e6c2b85d5, (v) => $687ff8957497b063$export$258b370e6c2b85d5 = v);
$parcel$export(module.exports, "URL_QUERY", () => $687ff8957497b063$export$dc5e5523da291a4b, (v) => $687ff8957497b063$export$dc5e5523da291a4b = v);
$parcel$export(module.exports, "URL_SAME_ORIGIN", () => $687ff8957497b063$export$fd5a8904ab5abfe0, (v) => $687ff8957497b063$export$fd5a8904ab5abfe0 = v);
$parcel$export(module.exports, "URL_SCHEME", () => $687ff8957497b063$export$1350d8937b0f26fb, (v) => $687ff8957497b063$export$1350d8937b0f26fb = v);
$parcel$export(module.exports, "URL_TEMPLATE", () => $687ff8957497b063$export$2a045f777fb349a8, (v) => $687ff8957497b063$export$2a045f777fb349a8 = v);
$parcel$export(module.exports, "USER_AGENT_ORIGINAL", () => $687ff8957497b063$export$8bb874585539a88f, (v) => $687ff8957497b063$export$8bb874585539a88f = v);
$parcel$export(module.exports, "USER_EMAIL", () => $687ff8957497b063$export$17d3a50785727199, (v) => $687ff8957497b063$export$17d3a50785727199 = v);
$parcel$export(module.exports, "USER_FULL_NAME", () => $687ff8957497b063$export$2931c570009689e, (v) => $687ff8957497b063$export$2931c570009689e = v);
$parcel$export(module.exports, "USER_GEO_CITY", () => $687ff8957497b063$export$199cbcedee735a43, (v) => $687ff8957497b063$export$199cbcedee735a43 = v);
$parcel$export(module.exports, "USER_GEO_COUNTRY_CODE", () => $687ff8957497b063$export$4ba5bf9d4e3ed862, (v) => $687ff8957497b063$export$4ba5bf9d4e3ed862 = v);
$parcel$export(module.exports, "USER_GEO_REGION", () => $687ff8957497b063$export$674c01ec2f0b89c3, (v) => $687ff8957497b063$export$674c01ec2f0b89c3 = v);
$parcel$export(module.exports, "USER_GEO_SUBDIVISION", () => $687ff8957497b063$export$bda1686739fd61c7, (v) => $687ff8957497b063$export$bda1686739fd61c7 = v);
$parcel$export(module.exports, "USER_HASH", () => $687ff8957497b063$export$8d804148f485d54c, (v) => $687ff8957497b063$export$8d804148f485d54c = v);
$parcel$export(module.exports, "USER_ID", () => $687ff8957497b063$export$212a8f1ea37518bd, (v) => $687ff8957497b063$export$212a8f1ea37518bd = v);
$parcel$export(module.exports, "USER_IP_ADDRESS", () => $687ff8957497b063$export$c9ac0fee28245883, (v) => $687ff8957497b063$export$c9ac0fee28245883 = v);
$parcel$export(module.exports, "USER_NAME", () => $687ff8957497b063$export$77078610759fe5f6, (v) => $687ff8957497b063$export$77078610759fe5f6 = v);
$parcel$export(module.exports, "USER_ROLES", () => $687ff8957497b063$export$7c6317deeec7a6c1, (v) => $687ff8957497b063$export$7c6317deeec7a6c1 = v);
$parcel$export(module.exports, "VERCEL_BRANCH", () => $687ff8957497b063$export$877ebf2e4ad81f03, (v) => $687ff8957497b063$export$877ebf2e4ad81f03 = v);
$parcel$export(module.exports, "VERCEL_BUILD_ID", () => $687ff8957497b063$export$70b2343945496e1f, (v) => $687ff8957497b063$export$70b2343945496e1f = v);
$parcel$export(module.exports, "VERCEL_DEPLOYMENT_ID", () => $687ff8957497b063$export$8415b56d2c6d2b1d, (v) => $687ff8957497b063$export$8415b56d2c6d2b1d = v);
$parcel$export(module.exports, "VERCEL_DESTINATION", () => $687ff8957497b063$export$cc81114a03caab18, (v) => $687ff8957497b063$export$cc81114a03caab18 = v);
$parcel$export(module.exports, "VERCEL_EDGE_TYPE", () => $687ff8957497b063$export$bc14eb892daceb23, (v) => $687ff8957497b063$export$bc14eb892daceb23 = v);
$parcel$export(module.exports, "VERCEL_ENTRYPOINT", () => $687ff8957497b063$export$3c973217450c3e9d, (v) => $687ff8957497b063$export$3c973217450c3e9d = v);
$parcel$export(module.exports, "VERCEL_EXECUTION_REGION", () => $687ff8957497b063$export$582c0b730ff1ddb9, (v) => $687ff8957497b063$export$582c0b730ff1ddb9 = v);
$parcel$export(module.exports, "VERCEL_ID", () => $687ff8957497b063$export$b3edfb545b65f1c5, (v) => $687ff8957497b063$export$b3edfb545b65f1c5 = v);
$parcel$export(module.exports, "VERCEL_JA3_DIGEST", () => $687ff8957497b063$export$2593317d8731841c, (v) => $687ff8957497b063$export$2593317d8731841c = v);
$parcel$export(module.exports, "VERCEL_JA4_DIGEST", () => $687ff8957497b063$export$8bb5bc1732aa41f, (v) => $687ff8957497b063$export$8bb5bc1732aa41f = v);
$parcel$export(module.exports, "VERCEL_LOG_TYPE", () => $687ff8957497b063$export$74a79c98b110b5b9, (v) => $687ff8957497b063$export$74a79c98b110b5b9 = v);
$parcel$export(module.exports, "VERCEL_PATH", () => $687ff8957497b063$export$26461b03281b4db4, (v) => $687ff8957497b063$export$26461b03281b4db4 = v);
$parcel$export(module.exports, "VERCEL_PROJECT_ID", () => $687ff8957497b063$export$eaea590d6d3dd93c, (v) => $687ff8957497b063$export$eaea590d6d3dd93c = v);
$parcel$export(module.exports, "VERCEL_PROJECT_NAME", () => $687ff8957497b063$export$af45365f70099379, (v) => $687ff8957497b063$export$af45365f70099379 = v);
$parcel$export(module.exports, "VERCEL_PROXY_CACHE_ID", () => $687ff8957497b063$export$a49e732d34d5ba9b, (v) => $687ff8957497b063$export$a49e732d34d5ba9b = v);
$parcel$export(module.exports, "VERCEL_PROXY_CLIENT_IP", () => $687ff8957497b063$export$7c147fe246bc8bd3, (v) => $687ff8957497b063$export$7c147fe246bc8bd3 = v);
$parcel$export(module.exports, "VERCEL_PROXY_HOST", () => $687ff8957497b063$export$e5111b6070e1ee9e, (v) => $687ff8957497b063$export$e5111b6070e1ee9e = v);
$parcel$export(module.exports, "VERCEL_PROXY_LAMBDA_REGION", () => $687ff8957497b063$export$591cbfd403f8c8d, (v) => $687ff8957497b063$export$591cbfd403f8c8d = v);
$parcel$export(module.exports, "VERCEL_PROXY_METHOD", () => $687ff8957497b063$export$b1388db955bbb885, (v) => $687ff8957497b063$export$b1388db955bbb885 = v);
$parcel$export(module.exports, "VERCEL_PROXY_PATH", () => $687ff8957497b063$export$e898d0e9e211abd9, (v) => $687ff8957497b063$export$e898d0e9e211abd9 = v);
$parcel$export(module.exports, "VERCEL_PROXY_PATH_TYPE", () => $687ff8957497b063$export$ab6fee0e8a6ee069, (v) => $687ff8957497b063$export$ab6fee0e8a6ee069 = v);
$parcel$export(module.exports, "VERCEL_PROXY_PATH_TYPE_VARIANT", () => $687ff8957497b063$export$9786ad94c199ffbb, (v) => $687ff8957497b063$export$9786ad94c199ffbb = v);
$parcel$export(module.exports, "VERCEL_PROXY_REFERER", () => $687ff8957497b063$export$269890524eed693b, (v) => $687ff8957497b063$export$269890524eed693b = v);
$parcel$export(module.exports, "VERCEL_PROXY_REGION", () => $687ff8957497b063$export$2ec623a8212d6b64, (v) => $687ff8957497b063$export$2ec623a8212d6b64 = v);
$parcel$export(module.exports, "VERCEL_PROXY_RESPONSE_BYTE_SIZE", () => $687ff8957497b063$export$30e7673b01ff994e, (v) => $687ff8957497b063$export$30e7673b01ff994e = v);
$parcel$export(module.exports, "VERCEL_PROXY_SCHEME", () => $687ff8957497b063$export$9ea93477840812bf, (v) => $687ff8957497b063$export$9ea93477840812bf = v);
$parcel$export(module.exports, "VERCEL_PROXY_STATUS_CODE", () => $687ff8957497b063$export$a6da0c365670c430, (v) => $687ff8957497b063$export$a6da0c365670c430 = v);
$parcel$export(module.exports, "VERCEL_PROXY_TIMESTAMP", () => $687ff8957497b063$export$7986b22da43f2885, (v) => $687ff8957497b063$export$7986b22da43f2885 = v);
$parcel$export(module.exports, "VERCEL_PROXY_USER_AGENT", () => $687ff8957497b063$export$a9f943c7ceb3b42f, (v) => $687ff8957497b063$export$a9f943c7ceb3b42f = v);
$parcel$export(module.exports, "VERCEL_PROXY_VERCEL_CACHE", () => $687ff8957497b063$export$dfe49501efcdffce, (v) => $687ff8957497b063$export$dfe49501efcdffce = v);
$parcel$export(module.exports, "VERCEL_PROXY_VERCEL_ID", () => $687ff8957497b063$export$be465f50c92eb01d, (v) => $687ff8957497b063$export$be465f50c92eb01d = v);
$parcel$export(module.exports, "VERCEL_PROXY_WAF_ACTION", () => $687ff8957497b063$export$c138d1796bb34999, (v) => $687ff8957497b063$export$c138d1796bb34999 = v);
$parcel$export(module.exports, "VERCEL_PROXY_WAF_RULE_ID", () => $687ff8957497b063$export$85a0016690a0ccf2, (v) => $687ff8957497b063$export$85a0016690a0ccf2 = v);
$parcel$export(module.exports, "VERCEL_REQUEST_ID", () => $687ff8957497b063$export$883acab36ede4bfa, (v) => $687ff8957497b063$export$883acab36ede4bfa = v);
$parcel$export(module.exports, "VERCEL_SOURCE", () => $687ff8957497b063$export$9cfc88d203f9cdf1, (v) => $687ff8957497b063$export$9cfc88d203f9cdf1 = v);
$parcel$export(module.exports, "VERCEL_STATUS_CODE", () => $687ff8957497b063$export$b3c6c599110d7bab, (v) => $687ff8957497b063$export$b3c6c599110d7bab = v);
$parcel$export(module.exports, "_AWS_KINESIS_STREAM_NAME", () => $687ff8957497b063$export$247839c65766758, (v) => $687ff8957497b063$export$247839c65766758 = v);
$parcel$export(module.exports, "_AWS_REQUEST_ID", () => $687ff8957497b063$export$f4d52b02df927d54, (v) => $687ff8957497b063$export$f4d52b02df927d54 = v);
$parcel$export(module.exports, "_HTTP_REQUEST_METHOD", () => $687ff8957497b063$export$df30ee8c5b5f1989, (v) => $687ff8957497b063$export$df30ee8c5b5f1989 = v);
$parcel$export(module.exports, "_SENTRY_SEGMENT_ID", () => $687ff8957497b063$export$268a117c860fca6d, (v) => $687ff8957497b063$export$268a117c860fca6d = v);
var $687ff8957497b063$export$b60c5e9f9b7b58bd;
var $687ff8957497b063$export$cc06afd6de7f2c10;
var $687ff8957497b063$export$ced6746028fe2cc;
var $687ff8957497b063$export$e6f4aa4f4fcb6da8;
var $687ff8957497b063$export$f02d892201cd8d36;
var $687ff8957497b063$export$f277a7ef9e273960;
var $687ff8957497b063$export$1a8c212c3becaa80;
var $687ff8957497b063$export$721b137086c68a47;
var $687ff8957497b063$export$6afde2bb69d9aa86;
var $687ff8957497b063$export$eadb4b562c974031;
var $687ff8957497b063$export$22a90f0ac1eee843;
var $687ff8957497b063$export$a727f215a0be1dad;
var $687ff8957497b063$export$536bc61b34d995e5;
var $687ff8957497b063$export$c43ea6115b380e62;
var $687ff8957497b063$export$d2a16e26bada7cf1;
var $687ff8957497b063$export$604eb1bd2278163b;
var $687ff8957497b063$export$2f8568696c5aa352;
var $687ff8957497b063$export$ccc8efd7dd31d3a9;
var $687ff8957497b063$export$e176bf5dc45e40df;
var $687ff8957497b063$export$c4ea01fd53f64e16;
var $687ff8957497b063$export$bb5e6f2f31a15da9;
var $687ff8957497b063$export$1762c11b666b026a;
var $687ff8957497b063$export$14ddd4b729910100;
var $687ff8957497b063$export$5311d7c8e1f8eabb;
var $687ff8957497b063$export$2b748b9eca00828b;
var $687ff8957497b063$export$5af25308c11addea;
var $687ff8957497b063$export$28f78b3b1663cb92;
var $687ff8957497b063$export$a1d3f09f0f1f066f;
var $687ff8957497b063$export$322bd4ea9f163663;
var $687ff8957497b063$export$95711b9e669edad8;
var $687ff8957497b063$export$5924d7d72384626a;
var $687ff8957497b063$export$db3b1b877a4ce4db;
var $687ff8957497b063$export$a434a3e8afec2879;
var $687ff8957497b063$export$fe00bb20636d42af;
var $687ff8957497b063$export$712aa698b7ee271e;
var $687ff8957497b063$export$1fac638b11ec16d9;
var $687ff8957497b063$export$d132016ea64058e3;
var $687ff8957497b063$export$53f2f47ec3b2f9ed;
var $687ff8957497b063$export$9f80c4b11053cef1;
var $687ff8957497b063$export$5f7a08466d84e877;
var $687ff8957497b063$export$2cea7f14750b8c19;
var $687ff8957497b063$export$34c59270f032a6c6;
var $687ff8957497b063$export$5b6c28c7dca07ad7;
var $687ff8957497b063$export$1dc8ae58b58d6c50;
var $687ff8957497b063$export$ba267414e3c0d822;
var $687ff8957497b063$export$71b176005902b99e;
var $687ff8957497b063$export$5c5b5a3c245a0079;
var $687ff8957497b063$export$8ee1df3c6367a60;
var $687ff8957497b063$export$e8c7802ae95beccf;
var $687ff8957497b063$export$bb237734da4d464;
var $687ff8957497b063$export$cdaaf6d1fdcba0b6;
var $687ff8957497b063$export$36223ebd4a30e9f5;
var $687ff8957497b063$export$8feaa177bb7941e2;
var $687ff8957497b063$export$e1ca25240db91d68;
var $687ff8957497b063$export$404a223fd1ada08b;
var $687ff8957497b063$export$53362079310c68;
var $687ff8957497b063$export$3efb5af0ac379f77;
var $687ff8957497b063$export$2c10c1ca0612c46d;
var $687ff8957497b063$export$bbb86ad4d6654da6;
var $687ff8957497b063$export$ad6896f00a2b1076;
var $687ff8957497b063$export$300f39d8506a273d;
var $687ff8957497b063$export$ecaa0e7f4773ddc7;
var $687ff8957497b063$export$74b78acb4c54c06b;
var $687ff8957497b063$export$b15b2c133bc50e33;
var $687ff8957497b063$export$5f1381d9ae1b1c95;
var $687ff8957497b063$export$c170b7ff277132ea;
var $687ff8957497b063$export$9459a5df93695e45;
var $687ff8957497b063$export$a7902bd57492ebe8;
var $687ff8957497b063$export$d2ace0da59da09b7;
var $687ff8957497b063$export$c15dd8d2461e0aeb;
var $687ff8957497b063$export$5405b0a98e00e538;
var $687ff8957497b063$export$bd393bbb84b309d3;
var $687ff8957497b063$export$96f586f8837b86ae;
var $687ff8957497b063$export$5d9f28f388f552d2;
var $687ff8957497b063$export$b3d2f68e0e769504;
var $687ff8957497b063$export$2c98412ed43013e8;
var $687ff8957497b063$export$a7bd794d11c19f1b;
var $687ff8957497b063$export$df4227832b83fdd0;
var $687ff8957497b063$export$f131a6d8fbc0534f;
var $687ff8957497b063$export$9bdc66d4a70e7e3a;
var $687ff8957497b063$export$bfbbc3cbcaa90e98;
var $687ff8957497b063$export$3565fa72459aa4d6;
var $687ff8957497b063$export$bb67a834ae4bffdc;
var $687ff8957497b063$export$4a06c859a283f06;
var $687ff8957497b063$export$68324fac2038d0f2;
var $687ff8957497b063$export$5e1bd62ffd2786fb;
var $687ff8957497b063$export$bfdf2261058f56b;
var $687ff8957497b063$export$23bf57842d9d53df;
var $687ff8957497b063$export$bfbd7e060eeb4d35;
var $687ff8957497b063$export$82eb6cccda27c3ff;
var $687ff8957497b063$export$8ea68734d455808f;
var $687ff8957497b063$export$40050e29324d44ee;
var $687ff8957497b063$export$5cd7541006d9f467;
var $687ff8957497b063$export$81c017edd95d692e;
var $687ff8957497b063$export$120b3897a58cf903;
var $687ff8957497b063$export$d4a9de43b4b1076c;
var $687ff8957497b063$export$f37f4f9022f1ab17;
var $687ff8957497b063$export$66ac18da14747cfb;
var $687ff8957497b063$export$9e49b833525ca49d;
var $687ff8957497b063$export$b084fea5b3097227;
var $687ff8957497b063$export$e09cd8615652e8d0;
var $687ff8957497b063$export$a43a60ec723a90ee;
var $687ff8957497b063$export$34cc955357266287;
var $687ff8957497b063$export$d9dd218693ea9bba;
var $687ff8957497b063$export$c9649b7156282a2f;
var $687ff8957497b063$export$daa8ce1f8adc553e;
var $687ff8957497b063$export$cb93c7b05db202cf;
var $687ff8957497b063$export$930f9bd3cc2e5b3d;
var $687ff8957497b063$export$48c6d4c44afdc0b;
var $687ff8957497b063$export$c78d41789fe4b1e4;
var $687ff8957497b063$export$f462d9921f1f7332;
var $687ff8957497b063$export$bc71f8df9a45e243;
var $687ff8957497b063$export$ed840ec4a5f5d053;
var $687ff8957497b063$export$c1a559a4f74a5e8e;
var $687ff8957497b063$export$d1c007424092e3f5;
var $687ff8957497b063$export$9ebb466ce954c49c;
var $687ff8957497b063$export$e9aafc7348984403;
var $687ff8957497b063$export$faaa46964f075237;
var $687ff8957497b063$export$d28c4b3cc4431a87;
var $687ff8957497b063$export$734b017b330c8fe6;
var $687ff8957497b063$export$683ebdc48ba3758d;
var $687ff8957497b063$export$be0263971250ef44;
var $687ff8957497b063$export$36a0cbc35c405232;
var $687ff8957497b063$export$469f7765ba335497;
var $687ff8957497b063$export$fe6fe2b7af051610;
var $687ff8957497b063$export$8345821877c4dfad;
var $687ff8957497b063$export$f6c188a7e02335cf;
var $687ff8957497b063$export$aaf709a8971e825f;
var $687ff8957497b063$export$def01b82f8c092f7;
var $687ff8957497b063$export$23d4264c606a73a6;
var $687ff8957497b063$export$af9ece53bb92f66b;
var $687ff8957497b063$export$25421625a565b69;
var $687ff8957497b063$export$ab0c90d873e69ccb;
var $687ff8957497b063$export$538c05cc8cb2a2bb;
var $687ff8957497b063$export$f86df4de196e1a7c;
var $687ff8957497b063$export$51e8aa8c0d65e7b8;
var $687ff8957497b063$export$99023486ecc470bd;
var $687ff8957497b063$export$2f6c85eaf382e81;
var $687ff8957497b063$export$1158d57c0aed42be;
var $687ff8957497b063$export$d85c4f947ab776e3;
var $687ff8957497b063$export$813ef8386d874918;
var $687ff8957497b063$export$7c2f74ff9251f64;
var $687ff8957497b063$export$993f84dab107b880;
var $687ff8957497b063$export$7b9c2315e94d8d2f;
var $687ff8957497b063$export$f01e5cd42b9ec146;
var $687ff8957497b063$export$987f6b4367434b55;
var $687ff8957497b063$export$d9d145585d5022bb;
var $687ff8957497b063$export$44ffba16bd48dac6;
var $687ff8957497b063$export$3134892c5d2e251a;
var $687ff8957497b063$export$8495028d10296058;
var $687ff8957497b063$export$d6d0e4fcf46d490c;
var $687ff8957497b063$export$658dced473c19301;
var $687ff8957497b063$export$97b0f9c3fbe64076;
var $687ff8957497b063$export$cf2c95ed5efbe9eb;
var $687ff8957497b063$export$880007904f61a388;
var $687ff8957497b063$export$3e903b72d4d9e07d;
var $687ff8957497b063$export$34da07180e0e56af;
var $687ff8957497b063$export$c49aafdaeb061953;
var $687ff8957497b063$export$ceb762c61de2f17f;
var $687ff8957497b063$export$a5f54ccfb28c0caf;
var $687ff8957497b063$export$1c86a56857b024db;
var $687ff8957497b063$export$7598f3464be47440;
var $687ff8957497b063$export$b673289c971fc0ae;
var $687ff8957497b063$export$98b23f3e6f0c2a6f;
var $687ff8957497b063$export$6ddeaf0498614ebb;
var $687ff8957497b063$export$97b78f78d64a7232;
var $687ff8957497b063$export$5147715be870fff7;
var $687ff8957497b063$export$5276bb46e6096fba;
var $687ff8957497b063$export$cbcbc1f67a937cf3;
var $687ff8957497b063$export$226a2381b8f0cf78;
var $687ff8957497b063$export$fd35512cae286064;
var $687ff8957497b063$export$de9bbf95ab1d81e;
var $687ff8957497b063$export$47fb20e8d18d7d15;
var $687ff8957497b063$export$9db7964e4b8cb849;
var $687ff8957497b063$export$7139adf9d3bace41;
var $687ff8957497b063$export$8ac3d09060e7f25d;
var $687ff8957497b063$export$dad0e4778ea23971;
var $687ff8957497b063$export$c14d903ccf9385a8;
var $687ff8957497b063$export$934cded0041affd7;
var $687ff8957497b063$export$6386da1dcba88c9d;
var $687ff8957497b063$export$a3371797e606e2;
var $687ff8957497b063$export$a5bbef0af83b23e5;
var $687ff8957497b063$export$91ed1f55874222a6;
var $687ff8957497b063$export$23de81068d2aed1b;
var $687ff8957497b063$export$d738320e1fba9e9d;
var $687ff8957497b063$export$2eacdea75497e8a5;
var $687ff8957497b063$export$2bc3ea101f86c1d2;
var $687ff8957497b063$export$c54e27e8d90ee081;
var $687ff8957497b063$export$4943adcec371c2a6;
var $687ff8957497b063$export$f000a5900d0480c2;
var $687ff8957497b063$export$8f5234893868273b;
var $687ff8957497b063$export$1a35518f6e81e8c7;
var $687ff8957497b063$export$a2d90911eaae60fc;
var $687ff8957497b063$export$3c22ff8b64b8f565;
var $687ff8957497b063$export$b8019c0e2a5b5f0f;
var $687ff8957497b063$export$8c11477e471467c8;
var $687ff8957497b063$export$92a96f6363488aee;
var $687ff8957497b063$export$f91beb6088f9ded9;
var $687ff8957497b063$export$78bc7224576bf289;
var $687ff8957497b063$export$a8027e0ea0d93ca;
var $687ff8957497b063$export$5e59d3aea52e5037;
var $687ff8957497b063$export$47e408be0da7933f;
var $687ff8957497b063$export$d5772b934ca13e57;
var $687ff8957497b063$export$36e47f6a5777561d;
var $687ff8957497b063$export$e768cbc99cd68acf;
var $687ff8957497b063$export$dfcc6c69df1343f2;
var $687ff8957497b063$export$69b0a5d9226b5211;
var $687ff8957497b063$export$da010a4f4fc971ae;
var $687ff8957497b063$export$5d515b35be0601a0;
var $687ff8957497b063$export$3e1b1037a315c5ca;
var $687ff8957497b063$export$847fdd494825f0fb;
var $687ff8957497b063$export$a9d76f26c6c730a9;
var $687ff8957497b063$export$de03f86d1c9866ca;
var $687ff8957497b063$export$65798ecab7eef8c;
var $687ff8957497b063$export$22aa61f48b9c79a0;
var $687ff8957497b063$export$69f5fb98f5aed812;
var $687ff8957497b063$export$bdea5d1006fd280a;
var $687ff8957497b063$export$f63a7230c5b1d609;
var $687ff8957497b063$export$6f25e59b05bb8e17;
var $687ff8957497b063$export$a56ad13c4afc7421;
var $687ff8957497b063$export$d9ce89ce8912bf12;
var $687ff8957497b063$export$17094e5f380e4162;
var $687ff8957497b063$export$28a0ffdf747973a0;
var $687ff8957497b063$export$5480ae1ba5d50bb9;
var $687ff8957497b063$export$edc72ee4a17f5152;
var $687ff8957497b063$export$19e4df138d354f8b;
var $687ff8957497b063$export$92b0d20fa482b4b2;
var $687ff8957497b063$export$3f638a793d61933f;
var $687ff8957497b063$export$3f511731cc3687d4;
var $687ff8957497b063$export$692b08741d6b6265;
var $687ff8957497b063$export$cf67f8cb2324428e;
var $687ff8957497b063$export$9d4197c1ffc5f359;
var $687ff8957497b063$export$509634fbff540e75;
var $687ff8957497b063$export$ccbc4fdff4b5eff5;
var $687ff8957497b063$export$e0cb371ca548b1d6;
var $687ff8957497b063$export$3c39026d09026bc2;
var $687ff8957497b063$export$bf9e8248cb72cf00;
var $687ff8957497b063$export$1054f22a72121d0f;
var $687ff8957497b063$export$723b8a59dad2e467;
var $687ff8957497b063$export$160081ff141bac8e;
var $687ff8957497b063$export$194f62c84d27310;
var $687ff8957497b063$export$7ed866d57b018d09;
var $687ff8957497b063$export$d50bae4562e03e5;
var $687ff8957497b063$export$649ea67a18fe8e8b;
var $687ff8957497b063$export$136a5c1b43caaccd;
var $687ff8957497b063$export$e33a28ea554b6ddc;
var $687ff8957497b063$export$acbe2d25ac76ea64;
var $687ff8957497b063$export$793c13e17d7e5e2b;
var $687ff8957497b063$export$a5617e33b89fd956;
var $687ff8957497b063$export$b51f82164fa31e07;
var $687ff8957497b063$export$f2ef55183c04d202;
var $687ff8957497b063$export$7c98fc0c48a16b1c;
var $687ff8957497b063$export$f0511e328234ae83;
var $687ff8957497b063$export$be46596bc6608f3b;
var $687ff8957497b063$export$f215947b3d76a6b7;
var $687ff8957497b063$export$89bbc91416db6670;
var $687ff8957497b063$export$b4b5eff8a8712c89;
var $687ff8957497b063$export$f455969a57ab8a03;
var $687ff8957497b063$export$13f2f8f42af49cec;
var $687ff8957497b063$export$cd357afe2ffdd2c3;
var $687ff8957497b063$export$d9ca2a279a11be5e;
var $687ff8957497b063$export$bbd59a8c7efad4c9;
var $687ff8957497b063$export$8413282a17f1cda5;
var $687ff8957497b063$export$30d19ddc7705e7e8;
var $687ff8957497b063$export$64a4f09e2444b3d;
var $687ff8957497b063$export$645b039fe163809e;
var $687ff8957497b063$export$b23ef8b8ffa607e1;
var $687ff8957497b063$export$8bf64516740c1369;
var $687ff8957497b063$export$9a0dc8e612f3e10b;
var $687ff8957497b063$export$abe90fedb3dddda2;
var $687ff8957497b063$export$4a19da9c85ed2ade;
var $687ff8957497b063$export$5e091479f094bdbc;
var $687ff8957497b063$export$d70909b5aa96a79a;
var $687ff8957497b063$export$651d142a8017d83d;
var $687ff8957497b063$export$44382a010a9f7fcf;
var $687ff8957497b063$export$807abfdc6b7b9338;
var $687ff8957497b063$export$31881d07f2569218;
var $687ff8957497b063$export$e5bbf306deb709a6;
var $687ff8957497b063$export$aa8721167c5c8d2d;
var $687ff8957497b063$export$757b93e5b3adc7cb;
var $687ff8957497b063$export$f869eaa92db1dc9b;
var $687ff8957497b063$export$5d1d761e41c32d9e;
var $687ff8957497b063$export$8aec72d9491f9399;
var $687ff8957497b063$export$5562635d2be2ab25;
var $687ff8957497b063$export$2dc31837ce6f7a3d;
var $687ff8957497b063$export$b561df15f64d32e3;
var $687ff8957497b063$export$181f78b28f2ffa57;
var $687ff8957497b063$export$6c97c77b89571c75;
var $687ff8957497b063$export$51e431eaf1f9bf58;
var $687ff8957497b063$export$71429c7ef7cb7063;
var $687ff8957497b063$export$99905d7583a6e8ac;
var $687ff8957497b063$export$b6c4be74fd0c06bd;
var $687ff8957497b063$export$fd23e5b8d261a89;
var $687ff8957497b063$export$25fabc9b3d1dd567;
var $687ff8957497b063$export$41507f7b07dad151;
var $687ff8957497b063$export$1352f3699c35dd73;
var $687ff8957497b063$export$fd6c9d5c74d943ac;
var $687ff8957497b063$export$c29634e3cf41e479;
var $687ff8957497b063$export$e6a60882cce7a085;
var $687ff8957497b063$export$6773c9098ba5e194;
var $687ff8957497b063$export$6ee6b62f50047686;
var $687ff8957497b063$export$efac052bb3661242;
var $687ff8957497b063$export$7ccd63b9ca955862;
var $687ff8957497b063$export$50921df5a58cb3ef;
var $687ff8957497b063$export$8e48efc7acb57a97;
var $687ff8957497b063$export$cea9121727113f77;
var $687ff8957497b063$export$bed35ff7f9af3aaa;
var $687ff8957497b063$export$6b729e898b9067ce;
var $687ff8957497b063$export$984fbab9b52f7e24;
var $687ff8957497b063$export$9ea17906a87ada6f;
var $687ff8957497b063$export$394b443aaff3ef92;
var $687ff8957497b063$export$6ddc374adbc06720;
var $687ff8957497b063$export$ab8c7ebc9add56b2;
var $687ff8957497b063$export$40ecc5bcd633d1ee;
var $687ff8957497b063$export$86a8df7fff52fc69;
var $687ff8957497b063$export$cf2115d46768f4c5;
var $687ff8957497b063$export$3d7e036e195764db;
var $687ff8957497b063$export$60c1d11221608cee;
var $687ff8957497b063$export$bc3cef164abbc42c;
var $687ff8957497b063$export$43f9afb62cd79dec;
var $687ff8957497b063$export$a5ab4ffc4765f75f;
var $687ff8957497b063$export$ccf46db9ab1743ec;
var $687ff8957497b063$export$76c1c247342d776;
var $687ff8957497b063$export$92f5944f0b02c9fb;
var $687ff8957497b063$export$867eeefcb1c95b27;
var $687ff8957497b063$export$5ada4697ae6aa17e;
var $687ff8957497b063$export$427122300e8d54d0;
var $687ff8957497b063$export$bcea8881375c352f;
var $687ff8957497b063$export$b867715f9a0c04e9;
var $687ff8957497b063$export$69878a39cbdbe097;
var $687ff8957497b063$export$584c61a1b769552d;
var $687ff8957497b063$export$8169ebcb0b0331dd;
var $687ff8957497b063$export$2c9713b624877853;
var $687ff8957497b063$export$45942692aeb454e0;
var $687ff8957497b063$export$8e5efeaa031210cd;
var $687ff8957497b063$export$35a62769ee05a05a;
var $687ff8957497b063$export$8ea4f7e986ca4b06;
var $687ff8957497b063$export$d2fd9ecaff0285a4;
var $687ff8957497b063$export$a6c8e656a4f9bb67;
var $687ff8957497b063$export$352a8075b163d53;
var $687ff8957497b063$export$426d7b90ba5d79db;
var $687ff8957497b063$export$f5a1ee40934d19ce;
var $687ff8957497b063$export$1ba812a9756622ce;
var $687ff8957497b063$export$351120039c36e03;
var $687ff8957497b063$export$d42aa25ca09e17c4;
var $687ff8957497b063$export$d268db29b88a4286;
var $687ff8957497b063$export$c5deb6018f2d6251;
var $687ff8957497b063$export$e06baa3034409453;
var $687ff8957497b063$export$646fdb5910ce3931;
var $687ff8957497b063$export$662e3d2d4361e29b;
var $687ff8957497b063$export$1de3962f221ba441;
var $687ff8957497b063$export$a4b3f0f5499c8738;
var $687ff8957497b063$export$1aecdac6cecbdc5b;
var $687ff8957497b063$export$2eb2ab35b317a103;
var $687ff8957497b063$export$c7e14ea195ede241;
var $687ff8957497b063$export$41ac034e7b9725a2;
var $687ff8957497b063$export$9e521119d7751e37;
var $687ff8957497b063$export$cbac8f541a64a150;
var $687ff8957497b063$export$93dd08efa94c9dd4;
var $687ff8957497b063$export$183e3523dac20bca;
var $687ff8957497b063$export$3867ca1d8381d4e3;
var $687ff8957497b063$export$11febcf9917c0057;
var $687ff8957497b063$export$88ae1ee0c0a63398;
var $687ff8957497b063$export$d5bd986d1f283f29;
var $687ff8957497b063$export$fc4a2d238535d998;
var $687ff8957497b063$export$57e53a60bf563f41;
var $687ff8957497b063$export$ffdb1464deb0eedb;
var $687ff8957497b063$export$b52670c950fd640;
var $687ff8957497b063$export$c499fd8f1db3d18e;
var $687ff8957497b063$export$b2ee2242301eff05;
var $687ff8957497b063$export$2ebf9f7586f16841;
var $687ff8957497b063$export$6e9ffd608b3e828b;
var $687ff8957497b063$export$b960c5a73a722e6c;
var $687ff8957497b063$export$a7a850351369c77e;
var $687ff8957497b063$export$b18bca78f4736a94;
var $687ff8957497b063$export$61a0059f562fb6c2;
var $687ff8957497b063$export$7dc0d5aefb816d91;
var $687ff8957497b063$export$58f6db56c841bef6;
var $687ff8957497b063$export$97a3da679f509d5;
var $687ff8957497b063$export$c387ec65fd1c2638;
var $687ff8957497b063$export$4d9db82211f308a4;
var $687ff8957497b063$export$ee4948a3be025123;
var $687ff8957497b063$export$e0021eb2979cddaa;
var $687ff8957497b063$export$7c0ac0c19a45beac;
var $687ff8957497b063$export$6c32e9d84f534ee;
var $687ff8957497b063$export$d1f9fbdb211dd29b;
var $687ff8957497b063$export$45e7eea99a17d6e4;
var $687ff8957497b063$export$20ea34e16c0aa64f;
var $687ff8957497b063$export$8365b0f03557fae9;
var $687ff8957497b063$export$49ebbb9621675650;
var $687ff8957497b063$export$842be66a901f093;
var $687ff8957497b063$export$a9f5a6cb28adccb1;
var $687ff8957497b063$export$57b055d4bc586d67;
var $687ff8957497b063$export$3ddfd660caa7bf7a;
var $687ff8957497b063$export$fa7e1f5305153b3d;
var $687ff8957497b063$export$5674ce9d013eb7bd;
var $687ff8957497b063$export$6e8dc14cff6ccf72;
var $687ff8957497b063$export$afd59480458e1b57;
var $687ff8957497b063$export$48e61fb9bccccba9;
var $687ff8957497b063$export$d3e674514dd3a3e1;
var $687ff8957497b063$export$97ad02b50c60ef68;
var $687ff8957497b063$export$61d053b1b63e82c4;
var $687ff8957497b063$export$54256cce0d674dea;
var $687ff8957497b063$export$8c01f0f407bcc5ca;
var $687ff8957497b063$export$be3f46982f6c7160;
var $687ff8957497b063$export$778e4213e2788579;
var $687ff8957497b063$export$8b48ca3594d2b172;
var $687ff8957497b063$export$8be180ec26319f9f;
var $687ff8957497b063$export$60eccaddefa8fc1c;
var $687ff8957497b063$export$c99ce4fe37484d84;
var $687ff8957497b063$export$fdf432fcac7d8f37;
var $687ff8957497b063$export$4c21cc9cdf2f5dbd;
var $687ff8957497b063$export$dcc1eab7f3f31816;
var $687ff8957497b063$export$dcb7f1379b2b8f86;
var $687ff8957497b063$export$53416edeea4c2d74;
var $687ff8957497b063$export$69f7e5d2b74c5c9e;
var $687ff8957497b063$export$8e104aed582a26bc;
var $687ff8957497b063$export$577047501949be9;
var $687ff8957497b063$export$c4c45b599a2c15e;
var $687ff8957497b063$export$361cb541700d648e;
var $687ff8957497b063$export$974f160e11f25731;
var $687ff8957497b063$export$7162f5c702b95903;
var $687ff8957497b063$export$a034d066a9090500;
var $687ff8957497b063$export$70938021e43e047c;
var $687ff8957497b063$export$5f6ac460012a73bb;
var $687ff8957497b063$export$d8e498c1c670bcbf;
var $687ff8957497b063$export$cc1a78a24d947903;
var $687ff8957497b063$export$d29b927e0bb0ffea;
var $687ff8957497b063$export$b3999cacef245779;
var $687ff8957497b063$export$ff168b5f9cf9dcf6;
var $687ff8957497b063$export$2ab876a45bd6e64;
var $687ff8957497b063$export$cb8027e4395c6c0e;
var $687ff8957497b063$export$f5303d1bac3c2660;
var $687ff8957497b063$export$6c463c5f3b00f64;
var $687ff8957497b063$export$e25d553065457cab;
var $687ff8957497b063$export$15d24c154ea8a56f;
var $687ff8957497b063$export$e5065789a6c415d0;
var $687ff8957497b063$export$62662c561d7c7835;
var $687ff8957497b063$export$218f394557fb0a5a;
var $687ff8957497b063$export$2a5ff6de5448ecdf;
var $687ff8957497b063$export$9d23f3030ed2597e;
var $687ff8957497b063$export$a26ff217a6124160;
var $687ff8957497b063$export$c8072f5fcfdb5b77;
var $687ff8957497b063$export$c4e4b74f1ccf3d96;
var $687ff8957497b063$export$328519d02a26ac41;
var $687ff8957497b063$export$d2061b291c43d045;
var $687ff8957497b063$export$d1f04dfd3d695286;
var $687ff8957497b063$export$234fbd86ea0f0bd8;
var $687ff8957497b063$export$e795000978a75b12;
var $687ff8957497b063$export$9f4683b4d1018ace;
var $687ff8957497b063$export$e431b042fcdb1d63;
var $687ff8957497b063$export$a453239171ac9a23;
var $687ff8957497b063$export$3a7726a976c18d5f;
var $687ff8957497b063$export$7eca7a6c06843b93;
var $687ff8957497b063$export$f25c55f83e5b0672;
var $687ff8957497b063$export$9562bfac4eb079cb;
var $687ff8957497b063$export$c276d164ff91d2f7;
var $687ff8957497b063$export$2f3e0574f1a99754;
var $687ff8957497b063$export$15eecaab68167880;
var $687ff8957497b063$export$513c47f6e194086a;
var $687ff8957497b063$export$a3f464c4d5cd9096;
var $687ff8957497b063$export$ed366a03a2330b03;
var $687ff8957497b063$export$9b802c784f235e1d;
var $687ff8957497b063$export$add0fc8b8c5726a4;
var $687ff8957497b063$export$e7f32463f5bfd554;
var $687ff8957497b063$export$f9346f394edf26a;
var $687ff8957497b063$export$16b917774e73ef92;
var $687ff8957497b063$export$15d2b60bf3b65454;
var $687ff8957497b063$export$db55eca5af256142;
var $687ff8957497b063$export$967c74f8b1f3d35;
var $687ff8957497b063$export$7c33ae67962515d1;
var $687ff8957497b063$export$9c69839b2d93489b;
var $687ff8957497b063$export$be22d22d4b6cf5d8;
var $687ff8957497b063$export$c529961b911626ac;
var $687ff8957497b063$export$e39c4b15d2881f5;
var $687ff8957497b063$export$a8ca145161313e7;
var $687ff8957497b063$export$3c1204d03918d076;
var $687ff8957497b063$export$eaac3f141165e288;
var $687ff8957497b063$export$4c7e6934714150e6;
var $687ff8957497b063$export$6f71f9711d666eb4;
var $687ff8957497b063$export$2a3cd2bb71fb63a4;
var $687ff8957497b063$export$55478a0b7d2ae98f;
var $687ff8957497b063$export$bed10c4da9b8eb0a;
var $687ff8957497b063$export$a82607b6424c06c8;
var $687ff8957497b063$export$6b081f3484c7f4e5;
var $687ff8957497b063$export$b7754d85fd39406c;
var $687ff8957497b063$export$492856c046eb4728;
var $687ff8957497b063$export$c1678a2059fbe906;
var $687ff8957497b063$export$6d384a0bc1011c34;
var $687ff8957497b063$export$1499a7dbfc01e7d4;
var $687ff8957497b063$export$cfcbff40019f0ff1;
var $687ff8957497b063$export$27157b5f68e583af;
var $687ff8957497b063$export$54bf5ed61532925d;
var $687ff8957497b063$export$60ed0786292ace08;
var $687ff8957497b063$export$d770bfb8345e146;
var $687ff8957497b063$export$bb73817f1290ad28;
var $687ff8957497b063$export$f201c980f2b75802;
var $687ff8957497b063$export$b40e970572afd0ee;
var $687ff8957497b063$export$8850630a3d343488;
var $687ff8957497b063$export$fd0a39a918d6516f;
var $687ff8957497b063$export$e68ef41f8e0335bf;
var $687ff8957497b063$export$5bff09650e762829;
var $687ff8957497b063$export$21c1adce0e067f37;
var $687ff8957497b063$export$fed6ce86f48c84bc;
var $687ff8957497b063$export$500c2675137ac16e;
var $687ff8957497b063$export$402c7728623fd8df;
var $687ff8957497b063$export$15417259f4c0fe6b;
var $687ff8957497b063$export$2b3b7f579a727f45;
var $687ff8957497b063$export$514832a0b029734b;
var $687ff8957497b063$export$b0522e6a14dec1a4;
var $687ff8957497b063$export$659ea19f71a7ee0b;
var $687ff8957497b063$export$1b61d972db315e73;
var $687ff8957497b063$export$fb2970ee11a479ee;
var $687ff8957497b063$export$920aceb2a8fad77e;
var $687ff8957497b063$export$48f8f6fbc999d187;
var $687ff8957497b063$export$eed590fa00a8223b;
var $687ff8957497b063$export$f2e5bb5cd4a130da;
var $687ff8957497b063$export$779ef03d633a9086;
var $687ff8957497b063$export$d98b87c8d53d0dbc;
var $687ff8957497b063$export$ca719aa57653a0a7;
var $687ff8957497b063$export$74b19c5f48270c05;
var $687ff8957497b063$export$c351affe7e8098cb;
var $687ff8957497b063$export$be7cd6b3ae3ae765;
var $687ff8957497b063$export$ec182524c4c57275;
var $687ff8957497b063$export$9e45758246a85b07;
var $687ff8957497b063$export$9fa5d5f0144954cb;
var $687ff8957497b063$export$e66ba5bc4b978023;
var $687ff8957497b063$export$2306e23cc611a36d;
var $687ff8957497b063$export$144f8c1fe01428db;
var $687ff8957497b063$export$f303b2744d52121c;
var $687ff8957497b063$export$866b2dbc7bf18ce6;
var $687ff8957497b063$export$b4c85774878b4841;
var $687ff8957497b063$export$1c967a71bc9a3077;
var $687ff8957497b063$export$5e3884a35a19eb90;
var $687ff8957497b063$export$6e7ff99bb3259573;
var $687ff8957497b063$export$7c932cba2d9e7a7;
var $687ff8957497b063$export$94091942edce0667;
var $687ff8957497b063$export$3671a8a524706a9d;
var $687ff8957497b063$export$c288888dc82d233f;
var $687ff8957497b063$export$8ff188536cebc35;
var $687ff8957497b063$export$6407d78968c0eabe;
var $687ff8957497b063$export$43e9fb9ec28d9743;
var $687ff8957497b063$export$26f31d5c5c201739;
var $687ff8957497b063$export$bff85124d2d35b93;
var $687ff8957497b063$export$495c671ed5a6408c;
var $687ff8957497b063$export$54b3d4d5548c35c3;
var $687ff8957497b063$export$2954db6444fe1fa8;
var $687ff8957497b063$export$15c1c974d16dd678;
var $687ff8957497b063$export$9be2ae89a1eac217;
var $687ff8957497b063$export$5c698591c0e586a2;
var $687ff8957497b063$export$b711f2bb9c9a848a;
var $687ff8957497b063$export$1d3a8501efd30213;
var $687ff8957497b063$export$cebaf684ced5a2c9;
var $687ff8957497b063$export$d4c658ecdcb7c78c;
var $687ff8957497b063$export$b1b162b01baeb044;
var $687ff8957497b063$export$8be2d593d7f88ed8;
var $687ff8957497b063$export$dbd0a3528a97ccc0;
var $687ff8957497b063$export$66581dc6d3d083d1;
var $687ff8957497b063$export$e545f99e7abcc499;
var $687ff8957497b063$export$7e1af5787f8c4aaa;
var $687ff8957497b063$export$186c94c351c54768;
var $687ff8957497b063$export$2e3fd8dfcb16fe0c;
var $687ff8957497b063$export$7eeeceaa1dbd7cd5;
var $687ff8957497b063$export$9d5bffdff936d554;
var $687ff8957497b063$export$dc3a801c9a2c5b79;
var $687ff8957497b063$export$27933a9557f87e98;
var $687ff8957497b063$export$eefa737b40a0d535;
var $687ff8957497b063$export$92740ffbcb02553b;
var $687ff8957497b063$export$500e89753f9f1008;
var $687ff8957497b063$export$d91a18e47fdddefd;
var $687ff8957497b063$export$eccbe6f20884ea7f;
var $687ff8957497b063$export$9e24f11d79141afb;
var $687ff8957497b063$export$f0b96ad9586f8887;
var $687ff8957497b063$export$8a92ed5d436a85c6;
var $687ff8957497b063$export$edd59acdf7e86a71;
var $687ff8957497b063$export$ae81a1ae71952d50;
var $687ff8957497b063$export$6101470cd57eac1b;
var $687ff8957497b063$export$452c0aee9673fe67;
var $687ff8957497b063$export$773dddd1e8667756;
var $687ff8957497b063$export$98815f8579a64a90;
var $687ff8957497b063$export$7bc4e27428665019;
var $687ff8957497b063$export$e7d7477fa9057ee2;
var $687ff8957497b063$export$1f4267a3fc018448;
var $687ff8957497b063$export$c171cae150389952;
var $687ff8957497b063$export$d9bb35e957b22c72;
var $687ff8957497b063$export$b3508a2c95f74e3d;
var $687ff8957497b063$export$20bb272f4d21532d;
var $687ff8957497b063$export$d7e64fbd0102ce90;
var $687ff8957497b063$export$c17eae7e86dbba3c;
var $687ff8957497b063$export$349603c0a9165744;
var $687ff8957497b063$export$4dadf693741f0283;
var $687ff8957497b063$export$6377864d12f7eeb3;
var $687ff8957497b063$export$ba081af9585ed4;
var $687ff8957497b063$export$7841dacb241485d0;
var $687ff8957497b063$export$52c7044cf6301362;
var $687ff8957497b063$export$56ea1c9e44590e20;
var $687ff8957497b063$export$7626e389d05f4c36;
var $687ff8957497b063$export$5e0a48187329b2e7;
var $687ff8957497b063$export$c322b150d7667841;
var $687ff8957497b063$export$4a4797d3c962f753;
var $687ff8957497b063$export$767524d5e72e2645;
var $687ff8957497b063$export$497354ca7b0ee666;
var $687ff8957497b063$export$cbdc4ad11118116a;
var $687ff8957497b063$export$5b890de778c4c2fe;
var $687ff8957497b063$export$a78d9803b5e0a83e;
var $687ff8957497b063$export$df1b536467b3992a;
var $687ff8957497b063$export$73104a329e205998;
var $687ff8957497b063$export$5740e3da55330b0a;
var $687ff8957497b063$export$8dcc2d92ff6d65da;
var $687ff8957497b063$export$e5f1321e53e24810;
var $687ff8957497b063$export$56dd3098cbca7c8a;
var $687ff8957497b063$export$aa7aff70e4380665;
var $687ff8957497b063$export$dacb7d452aa6bcaf;
var $687ff8957497b063$export$15dfc6c5e8f9baf6;
var $687ff8957497b063$export$91ad03bba7909fb5;
var $687ff8957497b063$export$86128e6c0ab71d64;
var $687ff8957497b063$export$745b60c4819aec1d;
var $687ff8957497b063$export$d2c893bfac1da9a1;
var $687ff8957497b063$export$1c14ad02f9534b19;
var $687ff8957497b063$export$db3cb63e0594d014;
var $687ff8957497b063$export$a65c9a0eba2c222d;
var $687ff8957497b063$export$68dbcca9c0e339ec;
var $687ff8957497b063$export$d59b669d4bb3f006;
var $687ff8957497b063$export$4d88d347aa9667fc;
var $687ff8957497b063$export$9943ffdcaa4bc506;
var $687ff8957497b063$export$d4f25b923533dbba;
var $687ff8957497b063$export$35f3396a1cdeea45;
var $687ff8957497b063$export$80e399da474bc98d;
var $687ff8957497b063$export$e01809e2dbceac35;
var $687ff8957497b063$export$41900d5c4e8a9c68;
var $687ff8957497b063$export$362bb1cb0bb5ca03;
var $687ff8957497b063$export$6803ac54f919d9cc;
var $687ff8957497b063$export$72f5b47540331169;
var $687ff8957497b063$export$6c61a8c9aa5305cb;
var $687ff8957497b063$export$6b5244c457b68e65;
var $687ff8957497b063$export$b7bd0c9a886f3414;
var $687ff8957497b063$export$6b77f2bacac7c93d;
var $687ff8957497b063$export$ddbc15c0e8e8a7ea;
var $687ff8957497b063$export$feb4fe753df28a82;
var $687ff8957497b063$export$d6267756132e2175;
var $687ff8957497b063$export$570ac5a3fd7e6cc6;
var $687ff8957497b063$export$5b9a0015e1c530ed;
var $687ff8957497b063$export$8bbff71c84508218;
var $687ff8957497b063$export$b55aa07a514a2430;
var $687ff8957497b063$export$9927ad09f7c084dc;
var $687ff8957497b063$export$52a07a35ff8ec6b6;
var $687ff8957497b063$export$a10d277c42e6cae3;
var $687ff8957497b063$export$cdc0ce5c66182801;
var $687ff8957497b063$export$2504d4bd698dd962;
var $687ff8957497b063$export$9dc86f3b876e96ef;
var $687ff8957497b063$export$70ff7865f52549ae;
var $687ff8957497b063$export$f77b53a42be6e6fd;
var $687ff8957497b063$export$818eb7ab11414506;
var $687ff8957497b063$export$829ef6b2e59d984d;
var $687ff8957497b063$export$b30f4cb52c088a26;
var $687ff8957497b063$export$335eace0ff1771cd;
var $687ff8957497b063$export$374d88a2025416ac;
var $687ff8957497b063$export$bb7a91303551eb37;
var $687ff8957497b063$export$f132ea291a7db56b;
var $687ff8957497b063$export$f0abd4170bbd2468;
var $687ff8957497b063$export$50d00a157dc08581;
var $687ff8957497b063$export$484576567a98833f;
var $687ff8957497b063$export$ec9e491e475d0c97;
var $687ff8957497b063$export$a86c59c10992220f;
var $687ff8957497b063$export$e12f06597e992fde;
var $687ff8957497b063$export$7ec54678ba28ea59;
var $687ff8957497b063$export$433ba14c16717110;
var $687ff8957497b063$export$309ee349b8a537f;
var $687ff8957497b063$export$b87f371cbc396fcf;
var $687ff8957497b063$export$60050fc49fe0e7e2;
var $687ff8957497b063$export$348c8e2b37f276cd;
var $687ff8957497b063$export$7f47e8a8b2d97cb2;
var $687ff8957497b063$export$50d5adc4b543ce95;
var $687ff8957497b063$export$9221f1d2c934d9f;
var $687ff8957497b063$export$3a56578b3ae09a02;
var $687ff8957497b063$export$e47b8dab9466c895;
var $687ff8957497b063$export$4ca52f75cf4889c5;
var $687ff8957497b063$export$7343d7d72195067f;
var $687ff8957497b063$export$f334f32f8d4d8063;
var $687ff8957497b063$export$c7bf2089e89a217c;
var $687ff8957497b063$export$f514f97553a434b2;
var $687ff8957497b063$export$61abde59b50deb8e;
var $687ff8957497b063$export$5a5ce44f9fb51f93;
var $687ff8957497b063$export$7044ea8d89b6f59d;
var $687ff8957497b063$export$40eacf1a072c9dbd;
var $687ff8957497b063$export$4c1fa0ac0eff2ac;
var $687ff8957497b063$export$5bee9450fe31dde1;
var $687ff8957497b063$export$d0b571fb4406d953;
var $687ff8957497b063$export$258b370e6c2b85d5;
var $687ff8957497b063$export$dc5e5523da291a4b;
var $687ff8957497b063$export$fd5a8904ab5abfe0;
var $687ff8957497b063$export$1350d8937b0f26fb;
var $687ff8957497b063$export$2a045f777fb349a8;
var $687ff8957497b063$export$8bb874585539a88f;
var $687ff8957497b063$export$17d3a50785727199;
var $687ff8957497b063$export$2931c570009689e;
var $687ff8957497b063$export$199cbcedee735a43;
var $687ff8957497b063$export$4ba5bf9d4e3ed862;
var $687ff8957497b063$export$674c01ec2f0b89c3;
var $687ff8957497b063$export$bda1686739fd61c7;
var $687ff8957497b063$export$8d804148f485d54c;
var $687ff8957497b063$export$212a8f1ea37518bd;
var $687ff8957497b063$export$c9ac0fee28245883;
var $687ff8957497b063$export$77078610759fe5f6;
var $687ff8957497b063$export$7c6317deeec7a6c1;
var $687ff8957497b063$export$877ebf2e4ad81f03;
var $687ff8957497b063$export$70b2343945496e1f;
var $687ff8957497b063$export$8415b56d2c6d2b1d;
var $687ff8957497b063$export$cc81114a03caab18;
var $687ff8957497b063$export$bc14eb892daceb23;
var $687ff8957497b063$export$3c973217450c3e9d;
var $687ff8957497b063$export$582c0b730ff1ddb9;
var $687ff8957497b063$export$b3edfb545b65f1c5;
var $687ff8957497b063$export$2593317d8731841c;
var $687ff8957497b063$export$8bb5bc1732aa41f;
var $687ff8957497b063$export$74a79c98b110b5b9;
var $687ff8957497b063$export$26461b03281b4db4;
var $687ff8957497b063$export$eaea590d6d3dd93c;
var $687ff8957497b063$export$af45365f70099379;
var $687ff8957497b063$export$a49e732d34d5ba9b;
var $687ff8957497b063$export$7c147fe246bc8bd3;
var $687ff8957497b063$export$e5111b6070e1ee9e;
var $687ff8957497b063$export$591cbfd403f8c8d;
var $687ff8957497b063$export$b1388db955bbb885;
var $687ff8957497b063$export$e898d0e9e211abd9;
var $687ff8957497b063$export$ab6fee0e8a6ee069;
var $687ff8957497b063$export$9786ad94c199ffbb;
var $687ff8957497b063$export$269890524eed693b;
var $687ff8957497b063$export$2ec623a8212d6b64;
var $687ff8957497b063$export$30e7673b01ff994e;
var $687ff8957497b063$export$9ea93477840812bf;
var $687ff8957497b063$export$a6da0c365670c430;
var $687ff8957497b063$export$7986b22da43f2885;
var $687ff8957497b063$export$a9f943c7ceb3b42f;
var $687ff8957497b063$export$dfe49501efcdffce;
var $687ff8957497b063$export$be465f50c92eb01d;
var $687ff8957497b063$export$c138d1796bb34999;
var $687ff8957497b063$export$85a0016690a0ccf2;
var $687ff8957497b063$export$883acab36ede4bfa;
var $687ff8957497b063$export$9cfc88d203f9cdf1;
var $687ff8957497b063$export$b3c6c599110d7bab;
var $687ff8957497b063$export$247839c65766758;
var $687ff8957497b063$export$f4d52b02df927d54;
var $687ff8957497b063$export$df30ee8c5b5f1989;
var $687ff8957497b063$export$268a117c860fca6d;
"use strict";
const $687ff8957497b063$var$AI_CITATIONS = "ai.citations", $687ff8957497b063$var$AI_COMPLETION_TOKENS_USED = "ai.completion_tokens.used", $687ff8957497b063$var$AI_DOCUMENTS = "ai.documents", $687ff8957497b063$var$AI_FINISH_REASON = "ai.finish_reason", $687ff8957497b063$var$AI_FREQUENCY_PENALTY = "ai.frequency_penalty", $687ff8957497b063$var$AI_FUNCTION_CALL = "ai.function_call", $687ff8957497b063$var$AI_GENERATION_ID = "ai.generation_id", $687ff8957497b063$var$AI_INPUT_MESSAGES = "ai.input_messages", $687ff8957497b063$var$AI_IS_SEARCH_REQUIRED = "ai.is_search_required", $687ff8957497b063$var$AI_METADATA = "ai.metadata", $687ff8957497b063$var$AI_MODEL_ID = "ai.model_id", $687ff8957497b063$var$AI_MODEL_PROVIDER = "ai.model.provider", $687ff8957497b063$var$AI_PIPELINE_NAME = "ai.pipeline.name", $687ff8957497b063$var$AI_PREAMBLE = "ai.preamble", $687ff8957497b063$var$AI_PRESENCE_PENALTY = "ai.presence_penalty", $687ff8957497b063$var$AI_PROMPT_TOKENS_USED = "ai.prompt_tokens.used", $687ff8957497b063$var$AI_RAW_PROMPTING = "ai.raw_prompting", $687ff8957497b063$var$AI_RESPONSES = "ai.responses", $687ff8957497b063$var$AI_RESPONSE_FORMAT = "ai.response_format", $687ff8957497b063$var$AI_SEARCH_QUERIES = "ai.search_queries", $687ff8957497b063$var$AI_SEARCH_RESULTS = "ai.search_results", $687ff8957497b063$var$AI_SEED = "ai.seed", $687ff8957497b063$var$AI_STREAMING = "ai.streaming", $687ff8957497b063$var$AI_TAGS = "ai.tags", $687ff8957497b063$var$AI_TEMPERATURE = "ai.temperature", $687ff8957497b063$var$AI_TEXTS = "ai.texts", $687ff8957497b063$var$AI_TOOLS = "ai.tools", $687ff8957497b063$var$AI_TOOL_CALLS = "ai.tool_calls", $687ff8957497b063$var$AI_TOP_K = "ai.top_k", $687ff8957497b063$var$AI_TOP_P = "ai.top_p", $687ff8957497b063$var$AI_TOTAL_COST = "ai.total_cost", $687ff8957497b063$var$AI_TOTAL_TOKENS_USED = "ai.total_tokens.used", $687ff8957497b063$var$AI_WARNINGS = "ai.warnings", $687ff8957497b063$var$ANGULAR_VERSION = "angular.version", $687ff8957497b063$var$APP_APP_BUILD = "app.app_build", $687ff8957497b063$var$APP_APP_IDENTIFIER = "app.app_identifier", $687ff8957497b063$var$APP_APP_NAME = "app.app_name", $687ff8957497b063$var$APP_APP_START_TIME = "app.app_start_time", $687ff8957497b063$var$APP_APP_VERSION = "app.app_version", $687ff8957497b063$var$APP_BUILD = "app.build", $687ff8957497b063$var$APP_IDENTIFIER = "app.identifier", $687ff8957497b063$var$APP_IN_FOREGROUND = "app.in_foreground", $687ff8957497b063$var$APP_NAME = "app.name", $687ff8957497b063$var$APP_START_COLD = "app_start_cold", $687ff8957497b063$var$APP_START_TIME = "app.start_time", $687ff8957497b063$var$APP_START_TYPE = "app_start_type", $687ff8957497b063$var$APP_START_WARM = "app_start_warm", $687ff8957497b063$var$APP_VERSION = "app.version", $687ff8957497b063$var$APP_VITALS_FRAMES_DELAY_VALUE = "app.vitals.frames.delay.value", $687ff8957497b063$var$APP_VITALS_FRAMES_FROZEN_COUNT = "app.vitals.frames.frozen.count", $687ff8957497b063$var$APP_VITALS_FRAMES_SLOW_COUNT = "app.vitals.frames.slow.count", $687ff8957497b063$var$APP_VITALS_FRAMES_TOTAL_COUNT = "app.vitals.frames.total.count", $687ff8957497b063$var$APP_VITALS_START_COLD_VALUE = "app.vitals.start.cold.value", $687ff8957497b063$var$APP_VITALS_START_PREWARMED = "app.vitals.start.prewarmed", $687ff8957497b063$var$APP_VITALS_START_REASON = "app.vitals.start.reason", $687ff8957497b063$var$APP_VITALS_START_SCREEN = "app.vitals.start.screen", $687ff8957497b063$var$APP_VITALS_START_TYPE = "app.vitals.start.type", $687ff8957497b063$var$APP_VITALS_START_WARM_VALUE = "app.vitals.start.warm.value", $687ff8957497b063$var$APP_VITALS_TTFD_VALUE = "app.vitals.ttfd.value", $687ff8957497b063$var$APP_VITALS_TTID_VALUE = "app.vitals.ttid.value", $687ff8957497b063$var$ART_GC_BLOCKING_COUNT = "art.gc.blocking_count", $687ff8957497b063$var$ART_GC_BLOCKING_TIME = "art.gc.blocking_time", $687ff8957497b063$var$ART_GC_PRE_OOME_COUNT = "art.gc.pre_oome_count", $687ff8957497b063$var$ART_GC_TOTAL_COUNT = "art.gc.total_count", $687ff8957497b063$var$ART_GC_TOTAL_TIME = "art.gc.total_time", $687ff8957497b063$var$ART_GC_WAITING_TIME = "art.gc.waiting_time", $687ff8957497b063$var$ART_MEMORY_FREE = "art.memory.free", $687ff8957497b063$var$ART_MEMORY_FREE_UNTIL_GC = "art.memory.free_until_gc", $687ff8957497b063$var$ART_MEMORY_FREE_UNTIL_OOME = "art.memory.free_until_oome", $687ff8957497b063$var$ART_MEMORY_MAX = "art.memory.max", $687ff8957497b063$var$ART_MEMORY_TOTAL = "art.memory.total", $687ff8957497b063$var$AWS_CLOUDWATCH_LOGS_LOG_GROUP = "aws.cloudwatch.logs.log_group", $687ff8957497b063$var$AWS_CLOUDWATCH_LOGS_LOG_STREAM = "aws.cloudwatch.logs.log_stream", $687ff8957497b063$var$AWS_CLOUDWATCH_LOGS_URL = "aws.cloudwatch.logs.url", $687ff8957497b063$var$AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS = "aws.dynamodb.attribute_definitions", $687ff8957497b063$var$AWS_DYNAMODB_CONSISTENT_READ = "aws.dynamodb.consistent_read", $687ff8957497b063$var$AWS_DYNAMODB_CONSUMED_CAPACITY = "aws.dynamodb.consumed_capacity", $687ff8957497b063$var$AWS_DYNAMODB_COUNT = "aws.dynamodb.count", $687ff8957497b063$var$AWS_DYNAMODB_EXCLUSIVE_START_TABLE = "aws.dynamodb.exclusive_start_table", $687ff8957497b063$var$AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES = "aws.dynamodb.global_secondary_indexes", $687ff8957497b063$var$AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES = "aws.dynamodb.global_secondary_index_updates", $687ff8957497b063$var$AWS_DYNAMODB_INDEX_NAME = "aws.dynamodb.index_name", $687ff8957497b063$var$AWS_DYNAMODB_ITEM_COLLECTION_METRICS = "aws.dynamodb.item_collection_metrics", $687ff8957497b063$var$AWS_DYNAMODB_LIMIT = "aws.dynamodb.limit", $687ff8957497b063$var$AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES = "aws.dynamodb.local_secondary_indexes", $687ff8957497b063$var$AWS_DYNAMODB_PROJECTION = "aws.dynamodb.projection", $687ff8957497b063$var$AWS_DYNAMODB_PROVISIONED_READ_CAPACITY = "aws.dynamodb.provisioned_read_capacity", $687ff8957497b063$var$AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY = "aws.dynamodb.provisioned_write_capacity", $687ff8957497b063$var$AWS_DYNAMODB_SCANNED_COUNT = "aws.dynamodb.scanned_count", $687ff8957497b063$var$AWS_DYNAMODB_SCAN_FORWARD = "aws.dynamodb.scan_forward", $687ff8957497b063$var$AWS_DYNAMODB_SEGMENT = "aws.dynamodb.segment", $687ff8957497b063$var$AWS_DYNAMODB_SELECT = "aws.dynamodb.select", $687ff8957497b063$var$AWS_DYNAMODB_TABLE_COUNT = "aws.dynamodb.table_count", $687ff8957497b063$var$AWS_DYNAMODB_TABLE_NAMES = "aws.dynamodb.table_names", $687ff8957497b063$var$AWS_DYNAMODB_TOTAL_SEGMENTS = "aws.dynamodb.total_segments", $687ff8957497b063$var$AWS_EXTENDED_REQUEST_ID = "aws.extended_request_id", $687ff8957497b063$var$AWS_KINESIS_STREAM_NAME = "aws.kinesis.stream_name", $687ff8957497b063$var$_AWS_KINESIS_STREAM_NAME = "aws.kinesis.stream.name", $687ff8957497b063$var$AWS_LAMBDA_AWS_REQUEST_ID = "aws.lambda.aws_request_id", $687ff8957497b063$var$AWS_LAMBDA_EXECUTION_DURATION_IN_MILLIS = "aws.lambda.execution_duration_in_millis", $687ff8957497b063$var$AWS_LAMBDA_FUNCTION_NAME = "aws.lambda.function_name", $687ff8957497b063$var$AWS_LAMBDA_FUNCTION_VERSION = "aws.lambda.function_version", $687ff8957497b063$var$AWS_LAMBDA_INVOKED_ARN = "aws.lambda.invoked_arn", $687ff8957497b063$var$AWS_LAMBDA_INVOKED_FUNCTION_ARN = "aws.lambda.invoked_function_arn", $687ff8957497b063$var$AWS_LAMBDA_REMAINING_TIME_IN_MILLIS = "aws.lambda.remaining_time_in_millis", $687ff8957497b063$var$AWS_LOG_GROUP_NAMES = "aws.log.group.names", $687ff8957497b063$var$AWS_LOG_STREAM_NAMES = "aws.log.stream.names", $687ff8957497b063$var$AWS_REQUEST_EXTENDED_ID = "aws.request.extended_id", $687ff8957497b063$var$AWS_REQUEST_ID = "aws.request_id", $687ff8957497b063$var$_AWS_REQUEST_ID = "aws.request.id", $687ff8957497b063$var$AWS_S3_BUCKET = "aws.s3.bucket", $687ff8957497b063$var$AWS_SECRETSMANAGER_SECRET_ARN = "aws.secretsmanager.secret.arn", $687ff8957497b063$var$AWS_SNS_TOPIC_ARN = "aws.sns.topic.arn", $687ff8957497b063$var$AWS_STEP_FUNCTIONS_ACTIVITY_ARN = "aws.step_functions.activity.arn", $687ff8957497b063$var$AWS_STEP_FUNCTIONS_STATE_MACHINE_ARN = "aws.step_functions.state_machine.arn", $687ff8957497b063$var$BLOCKED_MAIN_THREAD = "blocked_main_thread", $687ff8957497b063$var$BROWSER_NAME = "browser.name", $687ff8957497b063$var$BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START = "browser.performance.navigation.activation_start", $687ff8957497b063$var$BROWSER_PERFORMANCE_TIME_ORIGIN = "browser.performance.time_origin", $687ff8957497b063$var$BROWSER_REPORT_TYPE = "browser.report.type", $687ff8957497b063$var$BROWSER_SCRIPT_INVOKER = "browser.script.invoker", $687ff8957497b063$var$BROWSER_SCRIPT_INVOKER_TYPE = "browser.script.invoker_type", $687ff8957497b063$var$BROWSER_SCRIPT_SOURCE_CHAR_POSITION = "browser.script.source_char_position", $687ff8957497b063$var$BROWSER_VERSION = "browser.version", $687ff8957497b063$var$BROWSER_WEB_VITAL_CLS_REPORT_EVENT = "browser.web_vital.cls.report_event", $687ff8957497b063$var$BROWSER_WEB_VITAL_CLS_SOURCE_KEY = "browser.web_vital.cls.source.<key>", $687ff8957497b063$var$BROWSER_WEB_VITAL_CLS_SOURCE_KEY_BASE = "browser.web_vital.cls.source", $687ff8957497b063$var$BROWSER_WEB_VITAL_CLS_VALUE = "browser.web_vital.cls.value", $687ff8957497b063$var$BROWSER_WEB_VITAL_FCP_VALUE = "browser.web_vital.fcp.value", $687ff8957497b063$var$BROWSER_WEB_VITAL_FP_VALUE = "browser.web_vital.fp.value", $687ff8957497b063$var$BROWSER_WEB_VITAL_INP_VALUE = "browser.web_vital.inp.value", $687ff8957497b063$var$BROWSER_WEB_VITAL_LCP_ELEMENT = "browser.web_vital.lcp.element", $687ff8957497b063$var$BROWSER_WEB_VITAL_LCP_ID = "browser.web_vital.lcp.id", $687ff8957497b063$var$BROWSER_WEB_VITAL_LCP_LOAD_TIME = "browser.web_vital.lcp.load_time", $687ff8957497b063$var$BROWSER_WEB_VITAL_LCP_RENDER_TIME = "browser.web_vital.lcp.render_time", $687ff8957497b063$var$BROWSER_WEB_VITAL_LCP_REPORT_EVENT = "browser.web_vital.lcp.report_event", $687ff8957497b063$var$BROWSER_WEB_VITAL_LCP_SIZE = "browser.web_vital.lcp.size", $687ff8957497b063$var$BROWSER_WEB_VITAL_LCP_URL = "browser.web_vital.lcp.url", $687ff8957497b063$var$BROWSER_WEB_VITAL_LCP_VALUE = "browser.web_vital.lcp.value", $687ff8957497b063$var$BROWSER_WEB_VITAL_TTFB_REQUEST_TIME = "browser.web_vital.ttfb.request_time", $687ff8957497b063$var$BROWSER_WEB_VITAL_TTFB_VALUE = "browser.web_vital.ttfb.value", $687ff8957497b063$var$CACHE_HIT = "cache.hit", $687ff8957497b063$var$CACHE_ITEM_SIZE = "cache.item_size", $687ff8957497b063$var$CACHE_KEY = "cache.key", $687ff8957497b063$var$CACHE_OPERATION = "cache.operation", $687ff8957497b063$var$CACHE_TTL = "cache.ttl", $687ff8957497b063$var$CACHE_WRITE = "cache.write", $687ff8957497b063$var$CHANNEL = "channel", $687ff8957497b063$var$CLIENT_ADDRESS = "client.address", $687ff8957497b063$var$CLIENT_PORT = "client.port", $687ff8957497b063$var$CLOUDFLARE_D1_DURATION = "cloudflare.d1.duration", $687ff8957497b063$var$CLOUDFLARE_D1_QUERY_TYPE = "cloudflare.d1.query_type", $687ff8957497b063$var$CLOUDFLARE_D1_ROWS_READ = "cloudflare.d1.rows_read", $687ff8957497b063$var$CLOUDFLARE_D1_ROWS_WRITTEN = "cloudflare.d1.rows_written", $687ff8957497b063$var$CLOUDFLARE_DURABLE_OBJECT_QUERY_BINDINGS = "cloudflare.durable_object.query.bindings", $687ff8957497b063$var$CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_READ = "cloudflare.durable_object.response.rows_read", $687ff8957497b063$var$CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_WRITTEN = "cloudflare.durable_object.response.rows_written", $687ff8957497b063$var$CLOUDFLARE_R2_BUCKET = "cloudflare.r2.bucket", $687ff8957497b063$var$CLOUDFLARE_R2_OPERATION = "cloudflare.r2.operation", $687ff8957497b063$var$CLOUDFLARE_R2_REQUEST_DELIMITER = "cloudflare.r2.request.delimiter", $687ff8957497b063$var$CLOUDFLARE_R2_REQUEST_KEY = "cloudflare.r2.request.key", $687ff8957497b063$var$CLOUDFLARE_R2_REQUEST_PART_NUMBER = "cloudflare.r2.request.part_number", $687ff8957497b063$var$CLOUDFLARE_R2_REQUEST_PREFIX = "cloudflare.r2.request.prefix", $687ff8957497b063$var$CLOUDFLARE_WORKFLOW_ATTEMPT = "cloudflare.workflow.attempt", $687ff8957497b063$var$CLOUDFLARE_WORKFLOW_RETRIES_BACKOFF = "cloudflare.workflow.retries.backoff", $687ff8957497b063$var$CLOUDFLARE_WORKFLOW_RETRIES_DELAY = "cloudflare.workflow.retries.delay", $687ff8957497b063$var$CLOUDFLARE_WORKFLOW_RETRIES_LIMIT = "cloudflare.workflow.retries.limit", $687ff8957497b063$var$CLOUDFLARE_WORKFLOW_TIMEOUT = "cloudflare.workflow.timeout", $687ff8957497b063$var$CLOUD_ACCOUNT_ID = "cloud.account.id", $687ff8957497b063$var$CLOUD_AVAILABILITY_ZONE = "cloud.availability_zone", $687ff8957497b063$var$CLOUD_PLATFORM = "cloud.platform", $687ff8957497b063$var$CLOUD_PROVIDER = "cloud.provider", $687ff8957497b063$var$CLOUD_REGION = "cloud.region", $687ff8957497b063$var$CLOUD_RESOURCE_ID = "cloud.resource_id", $687ff8957497b063$var$CLS = "cls", $687ff8957497b063$var$CLS_SOURCE_KEY = "cls.source.<key>", $687ff8957497b063$var$CLS_SOURCE_KEY_BASE = "cls.source", $687ff8957497b063$var$CODE_FILEPATH = "code.filepath", $687ff8957497b063$var$CODE_FILE_PATH = "code.file.path", $687ff8957497b063$var$CODE_FUNCTION = "code.function", $687ff8957497b063$var$CODE_FUNCTION_NAME = "code.function.name", $687ff8957497b063$var$CODE_LINENO = "code.lineno", $687ff8957497b063$var$CODE_LINE_NUMBER = "code.line.number", $687ff8957497b063$var$CODE_NAMESPACE = "code.namespace", $687ff8957497b063$var$CONNECTIONTYPE = "connectionType", $687ff8957497b063$var$CONNECTION_RTT = "connection.rtt", $687ff8957497b063$var$CULTURE_CALENDAR = "culture.calendar", $687ff8957497b063$var$CULTURE_DISPLAY_NAME = "culture.display_name", $687ff8957497b063$var$CULTURE_IS_24_HOUR_FORMAT = "culture.is_24_hour_format", $687ff8957497b063$var$CULTURE_LOCALE = "culture.locale", $687ff8957497b063$var$CULTURE_TIMEZONE = "culture.timezone", $687ff8957497b063$var$DB_COLLECTION_NAME = "db.collection.name", $687ff8957497b063$var$DB_DRIVER_NAME = "db.driver.name", $687ff8957497b063$var$DB_NAME = "db.name", $687ff8957497b063$var$DB_NAMESPACE = "db.namespace", $687ff8957497b063$var$DB_OPERATION = "db.operation", $687ff8957497b063$var$DB_OPERATION_BATCH_SIZE = "db.operation.batch.size", $687ff8957497b063$var$DB_OPERATION_NAME = "db.operation.name", $687ff8957497b063$var$DB_QUERY_PARAMETER_KEY = "db.query.parameter.<key>", $687ff8957497b063$var$DB_QUERY_PARAMETER_KEY_BASE = "db.query.parameter", $687ff8957497b063$var$DB_QUERY_SUMMARY = "db.query.summary", $687ff8957497b063$var$DB_QUERY_TEXT = "db.query.text", $687ff8957497b063$var$DB_REDIS_CONNECTION = "db.redis.connection", $687ff8957497b063$var$DB_REDIS_KEY = "db.redis.key", $687ff8957497b063$var$DB_REDIS_PARAMETERS = "db.redis.parameters", $687ff8957497b063$var$DB_RESPONSE_STATUS_CODE = "db.response.status_code", $687ff8957497b063$var$DB_SQL_BINDINGS = "db.sql.bindings", $687ff8957497b063$var$DB_STATEMENT = "db.statement", $687ff8957497b063$var$DB_STORED_PROCEDURE_NAME = "db.stored_procedure.name", $687ff8957497b063$var$DB_SYSTEM = "db.system", $687ff8957497b063$var$DB_SYSTEM_NAME = "db.system.name", $687ff8957497b063$var$DB_USER = "db.user", $687ff8957497b063$var$DEVICEMEMORY = "deviceMemory", $687ff8957497b063$var$DEVICE_ARCHS = "device.archs", $687ff8957497b063$var$DEVICE_BATTERY_LEVEL = "device.battery_level", $687ff8957497b063$var$DEVICE_BATTERY_TEMPERATURE = "device.battery_temperature", $687ff8957497b063$var$DEVICE_BOOT_TIME = "device.boot_time", $687ff8957497b063$var$DEVICE_BRAND = "device.brand", $687ff8957497b063$var$DEVICE_CHARGING = "device.charging", $687ff8957497b063$var$DEVICE_CHIPSET = "device.chipset", $687ff8957497b063$var$DEVICE_CLASS = "device.class", $687ff8957497b063$var$DEVICE_CONNECTION_TYPE = "device.connection_type", $687ff8957497b063$var$DEVICE_CPU_DESCRIPTION = "device.cpu_description", $687ff8957497b063$var$DEVICE_EXTERNAL_FREE_STORAGE = "device.external_free_storage", $687ff8957497b063$var$DEVICE_EXTERNAL_STORAGE_SIZE = "device.external_storage_size", $687ff8957497b063$var$DEVICE_FAMILY = "device.family", $687ff8957497b063$var$DEVICE_FREE_MEMORY = "device.free_memory", $687ff8957497b063$var$DEVICE_FREE_STORAGE = "device.free_storage", $687ff8957497b063$var$DEVICE_ID = "device.id", $687ff8957497b063$var$DEVICE_LOCALE = "device.locale", $687ff8957497b063$var$DEVICE_LOW_MEMORY = "device.low_memory", $687ff8957497b063$var$DEVICE_LOW_POWER_MODE = "device.low_power_mode", $687ff8957497b063$var$DEVICE_MANUFACTURER = "device.manufacturer", $687ff8957497b063$var$DEVICE_MEMORY_ESTIMATED_CAPACITY = "device.memory.estimated_capacity", $687ff8957497b063$var$DEVICE_MEMORY_SIZE = "device.memory_size", $687ff8957497b063$var$DEVICE_MODEL = "device.model", $687ff8957497b063$var$DEVICE_MODEL_ID = "device.model_id", $687ff8957497b063$var$DEVICE_NAME = "device.name", $687ff8957497b063$var$DEVICE_ONLINE = "device.online", $687ff8957497b063$var$DEVICE_ORIENTATION = "device.orientation", $687ff8957497b063$var$DEVICE_PROCESSOR_COUNT = "device.processor_count", $687ff8957497b063$var$DEVICE_PROCESSOR_FREQUENCY = "device.processor_frequency", $687ff8957497b063$var$DEVICE_SCREEN_DENSITY = "device.screen_density", $687ff8957497b063$var$DEVICE_SCREEN_DPI = "device.screen_dpi", $687ff8957497b063$var$DEVICE_SCREEN_HEIGHT_PIXELS = "device.screen_height_pixels", $687ff8957497b063$var$DEVICE_SCREEN_WIDTH_PIXELS = "device.screen_width_pixels", $687ff8957497b063$var$DEVICE_SIMULATOR = "device.simulator", $687ff8957497b063$var$DEVICE_STORAGE_SIZE = "device.storage_size", $687ff8957497b063$var$DEVICE_THERMAL_STATE = "device.thermal_state", $687ff8957497b063$var$DEVICE_TIMEZONE = "device.timezone", $687ff8957497b063$var$DEVICE_USABLE_MEMORY = "device.usable_memory", $687ff8957497b063$var$DIST = "dist", $687ff8957497b063$var$EFFECTIVECONNECTIONTYPE = "effectiveConnectionType", $687ff8957497b063$var$ENVIRONMENT = "environment", $687ff8957497b063$var$ERROR_TYPE = "error.type", $687ff8957497b063$var$EVENT_ID = "event.id", $687ff8957497b063$var$EVENT_NAME = "event.name", $687ff8957497b063$var$EXCEPTION_ESCAPED = "exception.escaped", $687ff8957497b063$var$EXCEPTION_MESSAGE = "exception.message", $687ff8957497b063$var$EXCEPTION_STACKTRACE = "exception.stacktrace", $687ff8957497b063$var$EXCEPTION_TYPE = "exception.type", $687ff8957497b063$var$FAAS_COLDSTART = "faas.coldstart", $687ff8957497b063$var$FAAS_CRON = "faas.cron", $687ff8957497b063$var$FAAS_DURATION_IN_MS = "faas.duration_in_ms", $687ff8957497b063$var$FAAS_ENTRY_POINT = "faas.entry_point", $687ff8957497b063$var$FAAS_EXECUTION = "faas.execution", $687ff8957497b063$var$FAAS_ID = "faas.id", $687ff8957497b063$var$FAAS_IDENTITY = "faas.identity", $687ff8957497b063$var$FAAS_INVOCATION_ID = "faas.invocation_id", $687ff8957497b063$var$FAAS_INVOKED_NAME = "faas.invoked_name", $687ff8957497b063$var$FAAS_INVOKED_PROVIDER = "faas.invoked_provider", $687ff8957497b063$var$FAAS_INVOKED_REGION = "faas.invoked_region", $687ff8957497b063$var$FAAS_NAME = "faas.name", $687ff8957497b063$var$FAAS_TIME = "faas.time", $687ff8957497b063$var$FAAS_TRIGGER = "faas.trigger", $687ff8957497b063$var$FAAS_VERSION = "faas.version", $687ff8957497b063$var$FCP = "fcp", $687ff8957497b063$var$FLAG_EVALUATION_KEY = "flag.evaluation.<key>", $687ff8957497b063$var$FLAG_EVALUATION_KEY_BASE = "flag.evaluation", $687ff8957497b063$var$FP = "fp", $687ff8957497b063$var$FRAMES_DELAY = "frames.delay", $687ff8957497b063$var$FRAMES_FROZEN = "frames.frozen", $687ff8957497b063$var$FRAMES_FROZEN_RATE = "frames_frozen_rate", $687ff8957497b063$var$FRAMES_SLOW = "frames.slow", $687ff8957497b063$var$FRAMES_SLOW_RATE = "frames_slow_rate", $687ff8957497b063$var$FRAMES_TOTAL = "frames.total", $687ff8957497b063$var$FS_ERROR = "fs_error", $687ff8957497b063$var$GCP_FUNCTION_CONTEXT_EVENT_ID = "gcp.function.context.event_id", $687ff8957497b063$var$GCP_FUNCTION_CONTEXT_EVENT_TYPE = "gcp.function.context.event_type", $687ff8957497b063$var$GCP_FUNCTION_CONTEXT_ID = "gcp.function.context.id", $687ff8957497b063$var$GCP_FUNCTION_CONTEXT_RESOURCE = "gcp.function.context.resource", $687ff8957497b063$var$GCP_FUNCTION_CONTEXT_SOURCE = "gcp.function.context.source", $687ff8957497b063$var$GCP_FUNCTION_CONTEXT_SPECVERSION = "gcp.function.context.specversion", $687ff8957497b063$var$GCP_FUNCTION_CONTEXT_TIME = "gcp.function.context.time", $687ff8957497b063$var$GCP_FUNCTION_CONTEXT_TIMESTAMP = "gcp.function.context.timestamp", $687ff8957497b063$var$GCP_FUNCTION_CONTEXT_TYPE = "gcp.function.context.type", $687ff8957497b063$var$GCP_PROJECT_ID = "gcp.project.id", $687ff8957497b063$var$GEN_AI_AGENT_NAME = "gen_ai.agent.name", $687ff8957497b063$var$GEN_AI_CONTEXT_UTILIZATION = "gen_ai.context.utilization", $687ff8957497b063$var$GEN_AI_CONTEXT_WINDOW_SIZE = "gen_ai.context.window_size", $687ff8957497b063$var$GEN_AI_CONVERSATION_ID = "gen_ai.conversation.id", $687ff8957497b063$var$GEN_AI_COST_CACHE_CREATION_INPUT_TOKENS = "gen_ai.cost.cache_creation.input_tokens", $687ff8957497b063$var$GEN_AI_COST_CACHE_READ_INPUT_TOKENS = "gen_ai.cost.cache_read.input_tokens", $687ff8957497b063$var$GEN_AI_COST_INPUT_TOKENS = "gen_ai.cost.input_tokens", $687ff8957497b063$var$GEN_AI_COST_OUTPUT_TOKENS = "gen_ai.cost.output_tokens", $687ff8957497b063$var$GEN_AI_COST_REASONING_OUTPUT_TOKENS = "gen_ai.cost.reasoning.output_tokens", $687ff8957497b063$var$GEN_AI_COST_TOTAL_TOKENS = "gen_ai.cost.total_tokens", $687ff8957497b063$var$GEN_AI_EMBEDDINGS_INPUT = "gen_ai.embeddings.input", $687ff8957497b063$var$GEN_AI_FUNCTION_ID = "gen_ai.function_id", $687ff8957497b063$var$GEN_AI_INPUT_MESSAGES = "gen_ai.input.messages", $687ff8957497b063$var$GEN_AI_OPERATION_NAME = "gen_ai.operation.name", $687ff8957497b063$var$GEN_AI_OPERATION_TYPE = "gen_ai.operation.type", $687ff8957497b063$var$GEN_AI_OUTPUT_MESSAGES = "gen_ai.output.messages", $687ff8957497b063$var$GEN_AI_PIPELINE_NAME = "gen_ai.pipeline.name", $687ff8957497b063$var$GEN_AI_PROMPT = "gen_ai.prompt", $687ff8957497b063$var$GEN_AI_PROMPT_NAME = "gen_ai.prompt.name", $687ff8957497b063$var$GEN_AI_PROVIDER_NAME = "gen_ai.provider.name", $687ff8957497b063$var$GEN_AI_REQUEST_AVAILABLE_TOOLS = "gen_ai.request.available_tools", $687ff8957497b063$var$GEN_AI_REQUEST_FREQUENCY_PENALTY = "gen_ai.request.frequency_penalty", $687ff8957497b063$var$GEN_AI_REQUEST_MAX_TOKENS = "gen_ai.request.max_tokens", $687ff8957497b063$var$GEN_AI_REQUEST_MESSAGES = "gen_ai.request.messages", $687ff8957497b063$var$GEN_AI_REQUEST_MODEL = "gen_ai.request.model", $687ff8957497b063$var$GEN_AI_REQUEST_PRESENCE_PENALTY = "gen_ai.request.presence_penalty", $687ff8957497b063$var$GEN_AI_REQUEST_REASONING_EFFORT = "gen_ai.request.reasoning_effort", $687ff8957497b063$var$GEN_AI_REQUEST_SEED = "gen_ai.request.seed", $687ff8957497b063$var$GEN_AI_REQUEST_STOP_SEQUENCES = "gen_ai.request.stop_sequences", $687ff8957497b063$var$GEN_AI_REQUEST_TEMPERATURE = "gen_ai.request.temperature", $687ff8957497b063$var$GEN_AI_REQUEST_TOP_K = "gen_ai.request.top_k", $687ff8957497b063$var$GEN_AI_REQUEST_TOP_P = "gen_ai.request.top_p", $687ff8957497b063$var$GEN_AI_RESPONSE_FINISH_REASONS = "gen_ai.response.finish_reasons", $687ff8957497b063$var$GEN_AI_RESPONSE_ID = "gen_ai.response.id", $687ff8957497b063$var$GEN_AI_RESPONSE_MODEL = "gen_ai.response.model", $687ff8957497b063$var$GEN_AI_RESPONSE_STREAMING = "gen_ai.response.streaming", $687ff8957497b063$var$GEN_AI_RESPONSE_TEXT = "gen_ai.response.text", $687ff8957497b063$var$GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK = "gen_ai.response.time_to_first_chunk", $687ff8957497b063$var$GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN = "gen_ai.response.time_to_first_token", $687ff8957497b063$var$GEN_AI_RESPONSE_TOKENS_PER_SECOND = "gen_ai.response.tokens_per_second", $687ff8957497b063$var$GEN_AI_RESPONSE_TOOL_CALLS = "gen_ai.response.tool_calls", $687ff8957497b063$var$GEN_AI_SYSTEM = "gen_ai.system", $687ff8957497b063$var$GEN_AI_SYSTEM_INSTRUCTIONS = "gen_ai.system_instructions", $687ff8957497b063$var$GEN_AI_SYSTEM_MESSAGE = "gen_ai.system.message", $687ff8957497b063$var$GEN_AI_TOOL_CALL_ARGUMENTS = "gen_ai.tool.call.arguments", $687ff8957497b063$var$GEN_AI_TOOL_CALL_RESULT = "gen_ai.tool.call.result", $687ff8957497b063$var$GEN_AI_TOOL_DEFINITIONS = "gen_ai.tool.definitions", $687ff8957497b063$var$GEN_AI_TOOL_DESCRIPTION = "gen_ai.tool.description", $687ff8957497b063$var$GEN_AI_TOOL_INPUT = "gen_ai.tool.input", $687ff8957497b063$var$GEN_AI_TOOL_MESSAGE = "gen_ai.tool.message", $687ff8957497b063$var$GEN_AI_TOOL_NAME = "gen_ai.tool.name", $687ff8957497b063$var$GEN_AI_TOOL_OUTPUT = "gen_ai.tool.output", $687ff8957497b063$var$GEN_AI_TOOL_TYPE = "gen_ai.tool.type", $687ff8957497b063$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS = "gen_ai.usage.cache_creation.input_tokens", $687ff8957497b063$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS = "gen_ai.usage.cache_read.input_tokens", $687ff8957497b063$var$GEN_AI_USAGE_COMPLETION_TOKENS = "gen_ai.usage.completion_tokens", $687ff8957497b063$var$GEN_AI_USAGE_INPUT_TOKENS = "gen_ai.usage.input_tokens", $687ff8957497b063$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED = "gen_ai.usage.input_tokens.cached", $687ff8957497b063$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE = "gen_ai.usage.input_tokens.cache_write", $687ff8957497b063$var$GEN_AI_USAGE_OUTPUT_TOKENS = "gen_ai.usage.output_tokens", $687ff8957497b063$var$GEN_AI_USAGE_OUTPUT_TOKENS_REASONING = "gen_ai.usage.output_tokens.reasoning", $687ff8957497b063$var$GEN_AI_USAGE_PROMPT_TOKENS = "gen_ai.usage.prompt_tokens", $687ff8957497b063$var$GEN_AI_USAGE_REASONING_OUTPUT_TOKENS = "gen_ai.usage.reasoning.output_tokens", $687ff8957497b063$var$GEN_AI_USAGE_TOTAL_TOKENS = "gen_ai.usage.total_tokens", $687ff8957497b063$var$GRAPHQL_DOCUMENT = "graphql.document", $687ff8957497b063$var$GRAPHQL_OPERATION_NAME = "graphql.operation.name", $687ff8957497b063$var$GRAPHQL_OPERATION_TYPE = "graphql.operation.type", $687ff8957497b063$var$HARDWARECONCURRENCY = "hardwareConcurrency", $687ff8957497b063$var$HTTP_CLIENT_IP = "http.client_ip", $687ff8957497b063$var$HTTP_DECODED_RESPONSE_CONTENT_LENGTH = "http.decoded_response_content_length", $687ff8957497b063$var$HTTP_FLAVOR = "http.flavor", $687ff8957497b063$var$HTTP_FRAGMENT = "http.fragment", $687ff8957497b063$var$HTTP_HOST = "http.host", $687ff8957497b063$var$HTTP_METHOD = "http.method", $687ff8957497b063$var$HTTP_QUERY = "http.query", $687ff8957497b063$var$HTTP_REQUEST_BODY_DATA = "http.request.body.data", $687ff8957497b063$var$HTTP_REQUEST_CONNECTION_END = "http.request.connection_end", $687ff8957497b063$var$HTTP_REQUEST_CONNECT_START = "http.request.connect_start", $687ff8957497b063$var$HTTP_REQUEST_DOMAIN_LOOKUP_END = "http.request.domain_lookup_end", $687ff8957497b063$var$HTTP_REQUEST_DOMAIN_LOOKUP_START = "http.request.domain_lookup_start", $687ff8957497b063$var$HTTP_REQUEST_FETCH_START = "http.request.fetch_start", $687ff8957497b063$var$HTTP_REQUEST_HEADER_KEY = "http.request.header.<key>", $687ff8957497b063$var$HTTP_REQUEST_HEADER_KEY_BASE = "http.request.header", $687ff8957497b063$var$HTTP_REQUEST_METHOD = "http.request.method", $687ff8957497b063$var$_HTTP_REQUEST_METHOD = "http.request_method", $687ff8957497b063$var$HTTP_REQUEST_REDIRECT_END = "http.request.redirect_end", $687ff8957497b063$var$HTTP_REQUEST_REDIRECT_START = "http.request.redirect_start", $687ff8957497b063$var$HTTP_REQUEST_REQUEST_START = "http.request.request_start", $687ff8957497b063$var$HTTP_REQUEST_RESEND_COUNT = "http.request.resend_count", $687ff8957497b063$var$HTTP_REQUEST_RESPONSE_END = "http.request.response_end", $687ff8957497b063$var$HTTP_REQUEST_RESPONSE_START = "http.request.response_start", $687ff8957497b063$var$HTTP_REQUEST_SAME_ORIGIN = "http.request.same_origin", $687ff8957497b063$var$HTTP_REQUEST_SECURE_CONNECTION_START = "http.request.secure_connection_start", $687ff8957497b063$var$HTTP_REQUEST_TIME_TO_FIRST_BYTE = "http.request.time_to_first_byte", $687ff8957497b063$var$HTTP_REQUEST_WORKER_START = "http.request.worker_start", $687ff8957497b063$var$HTTP_RESPONSE_BODY_SIZE = "http.response.body.size", $687ff8957497b063$var$HTTP_RESPONSE_CONTENT_LENGTH = "http.response_content_length", $687ff8957497b063$var$HTTP_RESPONSE_HEADER_CONTENT_LENGTH = "http.response.header.content-length", $687ff8957497b063$var$HTTP_RESPONSE_HEADER_KEY = "http.response.header.<key>", $687ff8957497b063$var$HTTP_RESPONSE_HEADER_KEY_BASE = "http.response.header", $687ff8957497b063$var$HTTP_RESPONSE_SIZE = "http.response.size", $687ff8957497b063$var$HTTP_RESPONSE_STATUS_CODE = "http.response.status_code", $687ff8957497b063$var$HTTP_RESPONSE_TRANSFER_SIZE = "http.response_transfer_size", $687ff8957497b063$var$HTTP_ROUTE = "http.route", $687ff8957497b063$var$HTTP_SCHEME = "http.scheme", $687ff8957497b063$var$HTTP_SERVER_NAME = "http.server_name", $687ff8957497b063$var$HTTP_SERVER_REQUEST_TIME_IN_QUEUE = "http.server.request.time_in_queue", $687ff8957497b063$var$HTTP_STATUS_CODE = "http.status_code", $687ff8957497b063$var$HTTP_TARGET = "http.target", $687ff8957497b063$var$HTTP_URL = "http.url", $687ff8957497b063$var$HTTP_USER_AGENT = "http.user_agent", $687ff8957497b063$var$ID = "id", $687ff8957497b063$var$INP = "inp", $687ff8957497b063$var$JSONRPC_PROTOCOL_VERSION = "jsonrpc.protocol.version", $687ff8957497b063$var$JSONRPC_REQUEST_ID = "jsonrpc.request.id", $687ff8957497b063$var$JVM_GC_ACTION = "jvm.gc.action", $687ff8957497b063$var$JVM_GC_NAME = "jvm.gc.name", $687ff8957497b063$var$JVM_MEMORY_POOL_NAME = "jvm.memory.pool.name", $687ff8957497b063$var$JVM_MEMORY_TYPE = "jvm.memory.type", $687ff8957497b063$var$JVM_THREAD_DAEMON = "jvm.thread.daemon", $687ff8957497b063$var$JVM_THREAD_STATE = "jvm.thread.state", $687ff8957497b063$var$KOA_NAME = "koa.name", $687ff8957497b063$var$KOA_TYPE = "koa.type", $687ff8957497b063$var$LCP = "lcp", $687ff8957497b063$var$LCP_ELEMENT = "lcp.element", $687ff8957497b063$var$LCP_ID = "lcp.id", $687ff8957497b063$var$LCP_LOADTIME = "lcp.loadTime", $687ff8957497b063$var$LCP_RENDERTIME = "lcp.renderTime", $687ff8957497b063$var$LCP_SIZE = "lcp.size", $687ff8957497b063$var$LCP_URL = "lcp.url", $687ff8957497b063$var$LOGGER_NAME = "logger.name", $687ff8957497b063$var$MCP_CANCELLED_REASON = "mcp.cancelled.reason", $687ff8957497b063$var$MCP_CANCELLED_REQUEST_ID = "mcp.cancelled.request_id", $687ff8957497b063$var$MCP_CLIENT_NAME = "mcp.client.name", $687ff8957497b063$var$MCP_CLIENT_TITLE = "mcp.client.title", $687ff8957497b063$var$MCP_CLIENT_VERSION = "mcp.client.version", $687ff8957497b063$var$MCP_LIFECYCLE_PHASE = "mcp.lifecycle.phase", $687ff8957497b063$var$MCP_LOGGING_DATA_TYPE = "mcp.logging.data_type", $687ff8957497b063$var$MCP_LOGGING_LEVEL = "mcp.logging.level", $687ff8957497b063$var$MCP_LOGGING_LOGGER = "mcp.logging.logger", $687ff8957497b063$var$MCP_LOGGING_MESSAGE = "mcp.logging.message", $687ff8957497b063$var$MCP_METHOD_NAME = "mcp.method.name", $687ff8957497b063$var$MCP_PROGRESS_CURRENT = "mcp.progress.current", $687ff8957497b063$var$MCP_PROGRESS_MESSAGE = "mcp.progress.message", $687ff8957497b063$var$MCP_PROGRESS_PERCENTAGE = "mcp.progress.percentage", $687ff8957497b063$var$MCP_PROGRESS_TOKEN = "mcp.progress.token", $687ff8957497b063$var$MCP_PROGRESS_TOTAL = "mcp.progress.total", $687ff8957497b063$var$MCP_PROMPT_NAME = "mcp.prompt.name", $687ff8957497b063$var$MCP_PROMPT_RESULT_DESCRIPTION = "mcp.prompt.result.description", $687ff8957497b063$var$MCP_PROMPT_RESULT_MESSAGE_CONTENT = "mcp.prompt.result.message_content", $687ff8957497b063$var$MCP_PROMPT_RESULT_MESSAGE_COUNT = "mcp.prompt.result.message_count", $687ff8957497b063$var$MCP_PROMPT_RESULT_MESSAGE_ROLE = "mcp.prompt.result.message_role", $687ff8957497b063$var$MCP_PROTOCOL_READY = "mcp.protocol.ready", $687ff8957497b063$var$MCP_PROTOCOL_VERSION = "mcp.protocol.version", $687ff8957497b063$var$MCP_REQUEST_ARGUMENT_KEY = "mcp.request.argument.<key>", $687ff8957497b063$var$MCP_REQUEST_ARGUMENT_KEY_BASE = "mcp.request.argument", $687ff8957497b063$var$MCP_REQUEST_ARGUMENT_NAME = "mcp.request.argument.name", $687ff8957497b063$var$MCP_REQUEST_ARGUMENT_URI = "mcp.request.argument.uri", $687ff8957497b063$var$MCP_REQUEST_ID = "mcp.request.id", $687ff8957497b063$var$MCP_RESOURCE_PROTOCOL = "mcp.resource.protocol", $687ff8957497b063$var$MCP_RESOURCE_URI = "mcp.resource.uri", $687ff8957497b063$var$MCP_SERVER_NAME = "mcp.server.name", $687ff8957497b063$var$MCP_SERVER_TITLE = "mcp.server.title", $687ff8957497b063$var$MCP_SERVER_VERSION = "mcp.server.version", $687ff8957497b063$var$MCP_SESSION_ID = "mcp.session.id", $687ff8957497b063$var$MCP_TOOL_NAME = "mcp.tool.name", $687ff8957497b063$var$MCP_TOOL_RESULT_CONTENT = "mcp.tool.result.content", $687ff8957497b063$var$MCP_TOOL_RESULT_CONTENT_COUNT = "mcp.tool.result.content_count", $687ff8957497b063$var$MCP_TOOL_RESULT_IS_ERROR = "mcp.tool.result.is_error", $687ff8957497b063$var$MCP_TRANSPORT = "mcp.transport", $687ff8957497b063$var$MDC_KEY = "mdc.<key>", $687ff8957497b063$var$MDC_KEY_BASE = "mdc", $687ff8957497b063$var$MESSAGING_BATCH_MESSAGE_COUNT = "messaging.batch.message_count", $687ff8957497b063$var$MESSAGING_DESTINATION = "messaging.destination", $687ff8957497b063$var$MESSAGING_DESTINATION_CONNECTION = "messaging.destination.connection", $687ff8957497b063$var$MESSAGING_DESTINATION_NAME = "messaging.destination.name", $687ff8957497b063$var$MESSAGING_MESSAGE_BODY_SIZE = "messaging.message.body.size", $687ff8957497b063$var$MESSAGING_MESSAGE_CONVERSATION_ID = "messaging.message.conversation_id", $687ff8957497b063$var$MESSAGING_MESSAGE_ENVELOPE_SIZE = "messaging.message.envelope.size", $687ff8957497b063$var$MESSAGING_MESSAGE_ID = "messaging.message.id", $687ff8957497b063$var$MESSAGING_MESSAGE_RECEIVE_LATENCY = "messaging.message.receive.latency", $687ff8957497b063$var$MESSAGING_MESSAGE_RETRY_COUNT = "messaging.message.retry.count", $687ff8957497b063$var$MESSAGING_OPERATION_NAME = "messaging.operation.name", $687ff8957497b063$var$MESSAGING_OPERATION_TYPE = "messaging.operation.type", $687ff8957497b063$var$MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY = "messaging.rabbitmq.destination.routing_key", $687ff8957497b063$var$MESSAGING_SYSTEM = "messaging.system", $687ff8957497b063$var$METHOD = "method", $687ff8957497b063$var$MIDDLEWARE_NAME = "middleware.name", $687ff8957497b063$var$NAVIGATION_ORIGIN = "navigation.origin", $687ff8957497b063$var$NAVIGATION_ROUTE_ID = "navigation.route.id", $687ff8957497b063$var$NAVIGATION_TYPE = "navigation.type", $687ff8957497b063$var$NEL_ELAPSED_TIME = "nel.elapsed_time", $687ff8957497b063$var$NEL_PHASE = "nel.phase", $687ff8957497b063$var$NEL_REFERRER = "nel.referrer", $687ff8957497b063$var$NEL_SAMPLING_FUNCTION = "nel.sampling_function", $687ff8957497b063$var$NEL_TYPE = "nel.type", $687ff8957497b063$var$NETWORK_CONNECTION_EFFECTIVE_TYPE = "network.connection.effective_type", $687ff8957497b063$var$NETWORK_CONNECTION_RTT = "network.connection.rtt", $687ff8957497b063$var$NETWORK_CONNECTION_TYPE = "network.connection.type", $687ff8957497b063$var$NETWORK_LOCAL_ADDRESS = "network.local.address", $687ff8957497b063$var$NETWORK_LOCAL_PORT = "network.local.port", $687ff8957497b063$var$NETWORK_PEER_ADDRESS = "network.peer.address", $687ff8957497b063$var$NETWORK_PEER_PORT = "network.peer.port", $687ff8957497b063$var$NETWORK_PROTOCOL_NAME = "network.protocol.name", $687ff8957497b063$var$NETWORK_PROTOCOL_VERSION = "network.protocol.version", $687ff8957497b063$var$NETWORK_TRANSPORT = "network.transport", $687ff8957497b063$var$NETWORK_TYPE = "network.type", $687ff8957497b063$var$NET_HOST_IP = "net.host.ip", $687ff8957497b063$var$NET_HOST_NAME = "net.host.name", $687ff8957497b063$var$NET_HOST_PORT = "net.host.port", $687ff8957497b063$var$NET_PEER_IP = "net.peer.ip", $687ff8957497b063$var$NET_PEER_NAME = "net.peer.name", $687ff8957497b063$var$NET_PEER_PORT = "net.peer.port", $687ff8957497b063$var$NET_PROTOCOL_NAME = "net.protocol.name", $687ff8957497b063$var$NET_PROTOCOL_VERSION = "net.protocol.version", $687ff8957497b063$var$NET_SOCK_FAMILY = "net.sock.family", $687ff8957497b063$var$NET_SOCK_HOST_ADDR = "net.sock.host.addr", $687ff8957497b063$var$NET_SOCK_HOST_PORT = "net.sock.host.port", $687ff8957497b063$var$NET_SOCK_PEER_ADDR = "net.sock.peer.addr", $687ff8957497b063$var$NET_SOCK_PEER_NAME = "net.sock.peer.name", $687ff8957497b063$var$NET_SOCK_PEER_PORT = "net.sock.peer.port", $687ff8957497b063$var$NET_TRANSPORT = "net.transport", $687ff8957497b063$var$OS_BUILD = "os.build", $687ff8957497b063$var$OS_BUILD_ID = "os.build_id", $687ff8957497b063$var$OS_DESCRIPTION = "os.description", $687ff8957497b063$var$OS_KERNEL_VERSION = "os.kernel_version", $687ff8957497b063$var$OS_NAME = "os.name", $687ff8957497b063$var$OS_RAW_DESCRIPTION = "os.raw_description", $687ff8957497b063$var$OS_ROOTED = "os.rooted", $687ff8957497b063$var$OS_THEME = "os.theme", $687ff8957497b063$var$OS_TYPE = "os.type", $687ff8957497b063$var$OS_VERSION = "os.version", $687ff8957497b063$var$OTEL_KIND = "otel.kind", $687ff8957497b063$var$OTEL_SCOPE_NAME = "otel.scope.name", $687ff8957497b063$var$OTEL_SCOPE_VERSION = "otel.scope.version", $687ff8957497b063$var$OTEL_STATUS_CODE = "otel.status_code", $687ff8957497b063$var$OTEL_STATUS_DESCRIPTION = "otel.status_description", $687ff8957497b063$var$PARAMS_KEY = "params.<key>", $687ff8957497b063$var$PARAMS_KEY_BASE = "params", $687ff8957497b063$var$PERFORMANCE_ACTIVATIONSTART = "performance.activationStart", $687ff8957497b063$var$PERFORMANCE_TIMEORIGIN = "performance.timeOrigin", $687ff8957497b063$var$PREVIOUS_ROUTE = "previous_route", $687ff8957497b063$var$PROCESS_COMMAND_ARGS = "process.command_args", $687ff8957497b063$var$PROCESS_EXECUTABLE_NAME = "process.executable.name", $687ff8957497b063$var$PROCESS_PID = "process.pid", $687ff8957497b063$var$PROCESS_RUNTIME_DESCRIPTION = "process.runtime.description", $687ff8957497b063$var$PROCESS_RUNTIME_ENGINE_NAME = "process.runtime.engine.name", $687ff8957497b063$var$PROCESS_RUNTIME_ENGINE_VERSION = "process.runtime.engine.version", $687ff8957497b063$var$PROCESS_RUNTIME_NAME = "process.runtime.name", $687ff8957497b063$var$PROCESS_RUNTIME_VERSION = "process.runtime.version", $687ff8957497b063$var$QUERY_KEY = "query.<key>", $687ff8957497b063$var$QUERY_KEY_BASE = "query", $687ff8957497b063$var$REACT_VERSION = "react.version", $687ff8957497b063$var$RELEASE = "release", $687ff8957497b063$var$REMIX_ACTION_FORM_DATA_KEY = "remix.action_form_data.<key>", $687ff8957497b063$var$REMIX_ACTION_FORM_DATA_KEY_BASE = "remix.action_form_data", $687ff8957497b063$var$REPLAY_ID = "replay_id", $687ff8957497b063$var$RESOURCE_DEPLOYMENT_ENVIRONMENT = "resource.deployment.environment", $687ff8957497b063$var$RESOURCE_DEPLOYMENT_ENVIRONMENT_NAME = "resource.deployment.environment.name", $687ff8957497b063$var$RESOURCE_RENDER_BLOCKING_STATUS = "resource.render_blocking_status", $687ff8957497b063$var$ROUTE = "route", $687ff8957497b063$var$RPC_GRPC_STATUS_CODE = "rpc.grpc.status_code", $687ff8957497b063$var$RPC_METHOD = "rpc.method", $687ff8957497b063$var$RPC_RESPONSE_STATUS_CODE = "rpc.response.status_code", $687ff8957497b063$var$RPC_SERVICE = "rpc.service", $687ff8957497b063$var$RPC_SYSTEM = "rpc.system", $687ff8957497b063$var$RPC_SYSTEM_NAME = "rpc.system.name", $687ff8957497b063$var$RUNTIME_BUILD = "runtime.build", $687ff8957497b063$var$RUNTIME_NAME = "runtime.name", $687ff8957497b063$var$RUNTIME_RAW_DESCRIPTION = "runtime.raw_description", $687ff8957497b063$var$RUNTIME_VERSION = "runtime.version", $687ff8957497b063$var$SCORE_KEY = "score.<key>", $687ff8957497b063$var$SCORE_KEY_BASE = "score", $687ff8957497b063$var$SCORE_RATIO_KEY = "score.ratio.<key>", $687ff8957497b063$var$SCORE_RATIO_KEY_BASE = "score.ratio", $687ff8957497b063$var$SCORE_TOTAL = "score.total", $687ff8957497b063$var$SCORE_WEIGHT_KEY = "score.weight.<key>", $687ff8957497b063$var$SCORE_WEIGHT_KEY_BASE = "score.weight", $687ff8957497b063$var$SENTRY_ACTION = "sentry.action", $687ff8957497b063$var$SENTRY_BROWSER_NAME = "sentry.browser.name", $687ff8957497b063$var$SENTRY_BROWSER_VERSION = "sentry.browser.version", $687ff8957497b063$var$SENTRY_CANCELLATION_REASON = "sentry.cancellation_reason", $687ff8957497b063$var$SENTRY_CATEGORY = "sentry.category", $687ff8957497b063$var$SENTRY_CLIENT_SAMPLE_RATE = "sentry.client_sample_rate", $687ff8957497b063$var$SENTRY_DESCRIPTION = "sentry.description", $687ff8957497b063$var$SENTRY_DIST = "sentry.dist", $687ff8957497b063$var$SENTRY_DOMAIN = "sentry.domain", $687ff8957497b063$var$SENTRY_DSC_ENVIRONMENT = "sentry.dsc.environment", $687ff8957497b063$var$SENTRY_DSC_PROJECT_ID = "sentry.dsc.project_id", $687ff8957497b063$var$SENTRY_DSC_PUBLIC_KEY = "sentry.dsc.public_key", $687ff8957497b063$var$SENTRY_DSC_RELEASE = "sentry.dsc.release", $687ff8957497b063$var$SENTRY_DSC_SAMPLED = "sentry.dsc.sampled", $687ff8957497b063$var$SENTRY_DSC_SAMPLE_RATE = "sentry.dsc.sample_rate", $687ff8957497b063$var$SENTRY_DSC_TRACE_ID = "sentry.dsc.trace_id", $687ff8957497b063$var$SENTRY_DSC_TRANSACTION = "sentry.dsc.transaction", $687ff8957497b063$var$SENTRY_ENVIRONMENT = "sentry.environment", $687ff8957497b063$var$SENTRY_EXCLUSIVE_TIME = "sentry.exclusive_time", $687ff8957497b063$var$SENTRY_GRAPHQL_OPERATION = "sentry.graphql.operation", $687ff8957497b063$var$SENTRY_GROUP = "sentry.group", $687ff8957497b063$var$SENTRY_HTTP_PREFETCH = "sentry.http.prefetch", $687ff8957497b063$var$SENTRY_IDLE_SPAN_FINISH_REASON = "sentry.idle_span_finish_reason", $687ff8957497b063$var$SENTRY_IS_REMOTE = "sentry.is_remote", $687ff8957497b063$var$SENTRY_KIND = "sentry.kind", $687ff8957497b063$var$SENTRY_MAIN_THREAD = "sentry.main_thread", $687ff8957497b063$var$SENTRY_MESSAGE_PARAMETER_KEY = "sentry.message.parameter.<key>", $687ff8957497b063$var$SENTRY_MESSAGE_TEMPLATE = "sentry.message.template", $687ff8957497b063$var$SENTRY_METRIC_SOURCE = "sentry.metric.source", $687ff8957497b063$var$SENTRY_MOBILE = "sentry.mobile", $687ff8957497b063$var$SENTRY_MODULE_KEY = "sentry.module.<key>", $687ff8957497b063$var$SENTRY_MODULE_KEY_BASE = "sentry.module", $687ff8957497b063$var$SENTRY_NEXTJS_SSR_FUNCTION_ROUTE = "sentry.nextjs.ssr.function.route", $687ff8957497b063$var$SENTRY_NEXTJS_SSR_FUNCTION_TYPE = "sentry.nextjs.ssr.function.type", $687ff8957497b063$var$SENTRY_NORMALIZED_DB_QUERY = "sentry.normalized_db_query", $687ff8957497b063$var$SENTRY_NORMALIZED_DB_QUERY_HASH = "sentry.normalized_db_query.hash", $687ff8957497b063$var$SENTRY_NORMALIZED_DESCRIPTION = "sentry.normalized_description", $687ff8957497b063$var$SENTRY_OBSERVED_TIMESTAMP_NANOS = "sentry.observed_timestamp_nanos", $687ff8957497b063$var$SENTRY_OP = "sentry.op", $687ff8957497b063$var$SENTRY_ORIGIN = "sentry.origin", $687ff8957497b063$var$SENTRY_PLATFORM = "sentry.platform", $687ff8957497b063$var$SENTRY_PROFILER_ID = "sentry.profiler_id", $687ff8957497b063$var$SENTRY_PROFILE_ID = "sentry.profile_id", $687ff8957497b063$var$SENTRY_RELEASE = "sentry.release", $687ff8957497b063$var$SENTRY_REPLAY_ID = "sentry.replay_id", $687ff8957497b063$var$SENTRY_REPLAY_IS_BUFFERING = "sentry.replay_is_buffering", $687ff8957497b063$var$SENTRY_REPORT_EVENT = "sentry.report_event", $687ff8957497b063$var$SENTRY_SDK_INTEGRATIONS = "sentry.sdk.integrations", $687ff8957497b063$var$SENTRY_SDK_NAME = "sentry.sdk.name", $687ff8957497b063$var$SENTRY_SDK_VERSION = "sentry.sdk.version", $687ff8957497b063$var$SENTRY_SEGMENT_ID = "sentry.segment.id", $687ff8957497b063$var$_SENTRY_SEGMENT_ID = "sentry.segment_id", $687ff8957497b063$var$SENTRY_SEGMENT_NAME = "sentry.segment.name", $687ff8957497b063$var$SENTRY_SERVER_SAMPLE_RATE = "sentry.server_sample_rate", $687ff8957497b063$var$SENTRY_SOURCE = "sentry.source", $687ff8957497b063$var$SENTRY_SPAN_SOURCE = "sentry.span.source", $687ff8957497b063$var$SENTRY_STATUS = "sentry.status", $687ff8957497b063$var$SENTRY_STATUS_CODE = "sentry.status_code", $687ff8957497b063$var$SENTRY_STATUS_MESSAGE = "sentry.status.message", $687ff8957497b063$var$SENTRY_SVELTEKIT_NAVIGATION_FROM = "sentry.sveltekit.navigation.from", $687ff8957497b063$var$SENTRY_SVELTEKIT_NAVIGATION_TO = "sentry.sveltekit.navigation.to", $687ff8957497b063$var$SENTRY_SVELTEKIT_NAVIGATION_TYPE = "sentry.sveltekit.navigation.type", $687ff8957497b063$var$SENTRY_THREAD_ID = "sentry.thread.id", $687ff8957497b063$var$SENTRY_TIMESTAMP_SEQUENCE = "sentry.timestamp.sequence", $687ff8957497b063$var$SENTRY_TRACE_LIFECYCLE = "sentry.trace_lifecycle", $687ff8957497b063$var$SENTRY_TRACE_PARENT_SPAN_ID = "sentry.trace.parent_span_id", $687ff8957497b063$var$SENTRY_TRACE_STATUS = "sentry.trace.status", $687ff8957497b063$var$SENTRY_TRANSACTION = "sentry.transaction", $687ff8957497b063$var$SENTRY_USER_EMAIL = "sentry.user.email", $687ff8957497b063$var$SENTRY_USER_GEO_CITY = "sentry.user.geo.city", $687ff8957497b063$var$SENTRY_USER_GEO_COUNTRY_CODE = "sentry.user.geo.country_code", $687ff8957497b063$var$SENTRY_USER_GEO_REGION = "sentry.user.geo.region", $687ff8957497b063$var$SENTRY_USER_GEO_SUBDIVISION = "sentry.user.geo.subdivision", $687ff8957497b063$var$SENTRY_USER_ID = "sentry.user.id", $687ff8957497b063$var$SENTRY_USER_IP = "sentry.user.ip", $687ff8957497b063$var$SENTRY_USER_USERNAME = "sentry.user.username", $687ff8957497b063$var$SERVER_ADDRESS = "server.address", $687ff8957497b063$var$SERVER_NAME = "server_name", $687ff8957497b063$var$SERVER_PORT = "server.port", $687ff8957497b063$var$SERVICE_NAME = "service.name", $687ff8957497b063$var$SERVICE_VERSION = "service.version", $687ff8957497b063$var$SESSION_ID = "session.id", $687ff8957497b063$var$STALL_PERCENTAGE = "stall_percentage", $687ff8957497b063$var$STALL_TOTAL_TIME = "stall_total_time", $687ff8957497b063$var$STATE_TYPE = "state.type", $687ff8957497b063$var$THREAD_ID = "thread.id", $687ff8957497b063$var$THREAD_NAME = "thread.name", $687ff8957497b063$var$TIMBER_TAG = "timber.tag", $687ff8957497b063$var$TIME_TO_FULL_DISPLAY = "time_to_full_display", $687ff8957497b063$var$TIME_TO_INITIAL_DISPLAY = "time_to_initial_display", $687ff8957497b063$var$TRANSACTION = "transaction", $687ff8957497b063$var$TRPC_PROCEDURE_PATH = "trpc.procedure_path", $687ff8957497b063$var$TRPC_PROCEDURE_TYPE = "trpc.procedure_type", $687ff8957497b063$var$TTFB = "ttfb", $687ff8957497b063$var$TTFB_REQUESTTIME = "ttfb.requestTime", $687ff8957497b063$var$TYPE = "type", $687ff8957497b063$var$UI_COMPONENT_NAME = "ui.component_name", $687ff8957497b063$var$UI_CONTRIBUTES_TO_TTFD = "ui.contributes_to_ttfd", $687ff8957497b063$var$UI_CONTRIBUTES_TO_TTID = "ui.contributes_to_ttid", $687ff8957497b063$var$UI_ELEMENT_HEIGHT = "ui.element.height", $687ff8957497b063$var$UI_ELEMENT_ID = "ui.element.id", $687ff8957497b063$var$UI_ELEMENT_IDENTIFIER = "ui.element.identifier", $687ff8957497b063$var$UI_ELEMENT_LOAD_TIME = "ui.element.load_time", $687ff8957497b063$var$UI_ELEMENT_PAINT_TYPE = "ui.element.paint_type", $687ff8957497b063$var$UI_ELEMENT_RENDER_TIME = "ui.element.render_time", $687ff8957497b063$var$UI_ELEMENT_TYPE = "ui.element.type", $687ff8957497b063$var$UI_ELEMENT_URL = "ui.element.url", $687ff8957497b063$var$UI_ELEMENT_WIDTH = "ui.element.width", $687ff8957497b063$var$URL = "url", $687ff8957497b063$var$URL_DOMAIN = "url.domain", $687ff8957497b063$var$URL_FRAGMENT = "url.fragment", $687ff8957497b063$var$URL_FULL = "url.full", $687ff8957497b063$var$URL_PATH = "url.path", $687ff8957497b063$var$URL_PATH_PARAMETER_KEY = "url.path.parameter.<key>", $687ff8957497b063$var$URL_PATH_PARAMETER_KEY_BASE = "url.path.parameter", $687ff8957497b063$var$URL_PORT = "url.port", $687ff8957497b063$var$URL_QUERY = "url.query", $687ff8957497b063$var$URL_SAME_ORIGIN = "url.same_origin", $687ff8957497b063$var$URL_SCHEME = "url.scheme", $687ff8957497b063$var$URL_TEMPLATE = "url.template", $687ff8957497b063$var$USER_AGENT_ORIGINAL = "user_agent.original", $687ff8957497b063$var$USER_EMAIL = "user.email", $687ff8957497b063$var$USER_FULL_NAME = "user.full_name", $687ff8957497b063$var$USER_GEO_CITY = "user.geo.city", $687ff8957497b063$var$USER_GEO_COUNTRY_CODE = "user.geo.country_code", $687ff8957497b063$var$USER_GEO_REGION = "user.geo.region", $687ff8957497b063$var$USER_GEO_SUBDIVISION = "user.geo.subdivision", $687ff8957497b063$var$USER_HASH = "user.hash", $687ff8957497b063$var$USER_ID = "user.id", $687ff8957497b063$var$USER_IP_ADDRESS = "user.ip_address", $687ff8957497b063$var$USER_NAME = "user.name", $687ff8957497b063$var$USER_ROLES = "user.roles", $687ff8957497b063$var$VERCEL_BRANCH = "vercel.branch", $687ff8957497b063$var$VERCEL_BUILD_ID = "vercel.build_id", $687ff8957497b063$var$VERCEL_DEPLOYMENT_ID = "vercel.deployment_id", $687ff8957497b063$var$VERCEL_DESTINATION = "vercel.destination", $687ff8957497b063$var$VERCEL_EDGE_TYPE = "vercel.edge_type", $687ff8957497b063$var$VERCEL_ENTRYPOINT = "vercel.entrypoint", $687ff8957497b063$var$VERCEL_EXECUTION_REGION = "vercel.execution_region", $687ff8957497b063$var$VERCEL_ID = "vercel.id", $687ff8957497b063$var$VERCEL_JA3_DIGEST = "vercel.ja3_digest", $687ff8957497b063$var$VERCEL_JA4_DIGEST = "vercel.ja4_digest", $687ff8957497b063$var$VERCEL_LOG_TYPE = "vercel.log_type", $687ff8957497b063$var$VERCEL_PATH = "vercel.path", $687ff8957497b063$var$VERCEL_PROJECT_ID = "vercel.project_id", $687ff8957497b063$var$VERCEL_PROJECT_NAME = "vercel.project_name", $687ff8957497b063$var$VERCEL_PROXY_CACHE_ID = "vercel.proxy.cache_id", $687ff8957497b063$var$VERCEL_PROXY_CLIENT_IP = "vercel.proxy.client_ip", $687ff8957497b063$var$VERCEL_PROXY_HOST = "vercel.proxy.host", $687ff8957497b063$var$VERCEL_PROXY_LAMBDA_REGION = "vercel.proxy.lambda_region", $687ff8957497b063$var$VERCEL_PROXY_METHOD = "vercel.proxy.method", $687ff8957497b063$var$VERCEL_PROXY_PATH = "vercel.proxy.path", $687ff8957497b063$var$VERCEL_PROXY_PATH_TYPE = "vercel.proxy.path_type", $687ff8957497b063$var$VERCEL_PROXY_PATH_TYPE_VARIANT = "vercel.proxy.path_type_variant", $687ff8957497b063$var$VERCEL_PROXY_REFERER = "vercel.proxy.referer", $687ff8957497b063$var$VERCEL_PROXY_REGION = "vercel.proxy.region", $687ff8957497b063$var$VERCEL_PROXY_RESPONSE_BYTE_SIZE = "vercel.proxy.response_byte_size", $687ff8957497b063$var$VERCEL_PROXY_SCHEME = "vercel.proxy.scheme", $687ff8957497b063$var$VERCEL_PROXY_STATUS_CODE = "vercel.proxy.status_code", $687ff8957497b063$var$VERCEL_PROXY_TIMESTAMP = "vercel.proxy.timestamp", $687ff8957497b063$var$VERCEL_PROXY_USER_AGENT = "vercel.proxy.user_agent", $687ff8957497b063$var$VERCEL_PROXY_VERCEL_CACHE = "vercel.proxy.vercel_cache", $687ff8957497b063$var$VERCEL_PROXY_VERCEL_ID = "vercel.proxy.vercel_id", $687ff8957497b063$var$VERCEL_PROXY_WAF_ACTION = "vercel.proxy.waf_action", $687ff8957497b063$var$VERCEL_PROXY_WAF_RULE_ID = "vercel.proxy.waf_rule_id", $687ff8957497b063$var$VERCEL_REQUEST_ID = "vercel.request_id", $687ff8957497b063$var$VERCEL_SOURCE = "vercel.source", $687ff8957497b063$var$VERCEL_STATUS_CODE = "vercel.status_code", $687ff8957497b063$var$ATTRIBUTE_TYPE = {
    "ai.citations": "string[]",
    "ai.completion_tokens.used": "integer",
    "ai.documents": "string[]",
    "ai.finish_reason": "string",
    "ai.frequency_penalty": "double",
    "ai.function_call": "string",
    "ai.generation_id": "string",
    "ai.input_messages": "string",
    "ai.is_search_required": "boolean",
    "ai.metadata": "string",
    "ai.model_id": "string",
    "ai.model.provider": "string",
    "ai.pipeline.name": "string",
    "ai.preamble": "string",
    "ai.presence_penalty": "double",
    "ai.prompt_tokens.used": "integer",
    "ai.raw_prompting": "boolean",
    "ai.responses": "string[]",
    "ai.response_format": "string",
    "ai.search_queries": "string[]",
    "ai.search_results": "string[]",
    "ai.seed": "string",
    "ai.streaming": "boolean",
    "ai.tags": "string",
    "ai.temperature": "double",
    "ai.texts": "string[]",
    "ai.tools": "string[]",
    "ai.tool_calls": "string[]",
    "ai.top_k": "integer",
    "ai.top_p": "double",
    "ai.total_cost": "double",
    "ai.total_tokens.used": "integer",
    "ai.warnings": "string[]",
    "angular.version": "string",
    "app.app_build": "string",
    "app.app_identifier": "string",
    "app.app_name": "string",
    "app.app_start_time": "string",
    "app.app_version": "string",
    "app.build": "string",
    "app.identifier": "string",
    "app.in_foreground": "boolean",
    "app.name": "string",
    app_start_cold: "double",
    "app.start_time": "string",
    app_start_type: "string",
    app_start_warm: "double",
    "app.version": "string",
    "app.vitals.frames.delay.value": "integer",
    "app.vitals.frames.frozen.count": "integer",
    "app.vitals.frames.slow.count": "integer",
    "app.vitals.frames.total.count": "integer",
    "app.vitals.start.cold.value": "double",
    "app.vitals.start.prewarmed": "boolean",
    "app.vitals.start.reason": "string",
    "app.vitals.start.screen": "string",
    "app.vitals.start.type": "string",
    "app.vitals.start.warm.value": "double",
    "app.vitals.ttfd.value": "double",
    "app.vitals.ttid.value": "double",
    "art.gc.blocking_count": "integer",
    "art.gc.blocking_time": "double",
    "art.gc.pre_oome_count": "integer",
    "art.gc.total_count": "integer",
    "art.gc.total_time": "double",
    "art.gc.waiting_time": "double",
    "art.memory.free": "integer",
    "art.memory.free_until_gc": "integer",
    "art.memory.free_until_oome": "integer",
    "art.memory.max": "integer",
    "art.memory.total": "integer",
    "aws.cloudwatch.logs.log_group": "string",
    "aws.cloudwatch.logs.log_stream": "string",
    "aws.cloudwatch.logs.url": "string",
    "aws.dynamodb.attribute_definitions": "string[]",
    "aws.dynamodb.consistent_read": "boolean",
    "aws.dynamodb.consumed_capacity": "string[]",
    "aws.dynamodb.count": "integer",
    "aws.dynamodb.exclusive_start_table": "string",
    "aws.dynamodb.global_secondary_indexes": "string[]",
    "aws.dynamodb.global_secondary_index_updates": "string[]",
    "aws.dynamodb.index_name": "string",
    "aws.dynamodb.item_collection_metrics": "string",
    "aws.dynamodb.limit": "integer",
    "aws.dynamodb.local_secondary_indexes": "string[]",
    "aws.dynamodb.projection": "string",
    "aws.dynamodb.provisioned_read_capacity": "double",
    "aws.dynamodb.provisioned_write_capacity": "double",
    "aws.dynamodb.scanned_count": "integer",
    "aws.dynamodb.scan_forward": "boolean",
    "aws.dynamodb.segment": "integer",
    "aws.dynamodb.select": "string",
    "aws.dynamodb.table_count": "integer",
    "aws.dynamodb.table_names": "string[]",
    "aws.dynamodb.total_segments": "integer",
    "aws.extended_request_id": "string",
    "aws.kinesis.stream_name": "string",
    "aws.kinesis.stream.name": "string",
    "aws.lambda.aws_request_id": "string",
    "aws.lambda.execution_duration_in_millis": "double",
    "aws.lambda.function_name": "string",
    "aws.lambda.function_version": "string",
    "aws.lambda.invoked_arn": "string",
    "aws.lambda.invoked_function_arn": "string",
    "aws.lambda.remaining_time_in_millis": "double",
    "aws.log.group.names": "string[]",
    "aws.log.stream.names": "string[]",
    "aws.request.extended_id": "string",
    "aws.request_id": "string",
    "aws.request.id": "string",
    "aws.s3.bucket": "string",
    "aws.secretsmanager.secret.arn": "string",
    "aws.sns.topic.arn": "string",
    "aws.step_functions.activity.arn": "string",
    "aws.step_functions.state_machine.arn": "string",
    blocked_main_thread: "boolean",
    "browser.name": "string",
    "browser.performance.navigation.activation_start": "double",
    "browser.performance.time_origin": "double",
    "browser.report.type": "string",
    "browser.script.invoker": "string",
    "browser.script.invoker_type": "string",
    "browser.script.source_char_position": "integer",
    "browser.version": "string",
    "browser.web_vital.cls.report_event": "string",
    "browser.web_vital.cls.source.<key>": "string",
    "browser.web_vital.cls.value": "double",
    "browser.web_vital.fcp.value": "double",
    "browser.web_vital.fp.value": "double",
    "browser.web_vital.inp.value": "double",
    "browser.web_vital.lcp.element": "string",
    "browser.web_vital.lcp.id": "string",
    "browser.web_vital.lcp.load_time": "integer",
    "browser.web_vital.lcp.render_time": "integer",
    "browser.web_vital.lcp.report_event": "string",
    "browser.web_vital.lcp.size": "integer",
    "browser.web_vital.lcp.url": "string",
    "browser.web_vital.lcp.value": "double",
    "browser.web_vital.ttfb.request_time": "double",
    "browser.web_vital.ttfb.value": "double",
    "cache.hit": "boolean",
    "cache.item_size": "integer",
    "cache.key": "string[]",
    "cache.operation": "string",
    "cache.ttl": "integer",
    "cache.write": "boolean",
    channel: "string",
    "client.address": "string",
    "client.port": "integer",
    "cloudflare.d1.duration": "integer",
    "cloudflare.d1.query_type": "string",
    "cloudflare.d1.rows_read": "integer",
    "cloudflare.d1.rows_written": "integer",
    "cloudflare.durable_object.query.bindings": "integer",
    "cloudflare.durable_object.response.rows_read": "integer",
    "cloudflare.durable_object.response.rows_written": "integer",
    "cloudflare.r2.bucket": "string",
    "cloudflare.r2.operation": "string",
    "cloudflare.r2.request.delimiter": "string",
    "cloudflare.r2.request.key": "string",
    "cloudflare.r2.request.part_number": "integer",
    "cloudflare.r2.request.prefix": "string",
    "cloudflare.workflow.attempt": "integer",
    "cloudflare.workflow.retries.backoff": "string",
    "cloudflare.workflow.retries.delay": "string",
    "cloudflare.workflow.retries.limit": "integer",
    "cloudflare.workflow.timeout": "string",
    "cloud.account.id": "string",
    "cloud.availability_zone": "string",
    "cloud.platform": "string",
    "cloud.provider": "string",
    "cloud.region": "string",
    "cloud.resource_id": "string",
    cls: "double",
    "cls.source.<key>": "string",
    "code.filepath": "string",
    "code.file.path": "string",
    "code.function": "string",
    "code.function.name": "string",
    "code.lineno": "integer",
    "code.line.number": "integer",
    "code.namespace": "string",
    connectionType: "string",
    "connection.rtt": "integer",
    "culture.calendar": "string",
    "culture.display_name": "string",
    "culture.is_24_hour_format": "boolean",
    "culture.locale": "string",
    "culture.timezone": "string",
    "db.collection.name": "string",
    "db.driver.name": "string",
    "db.name": "string",
    "db.namespace": "string",
    "db.operation": "string",
    "db.operation.batch.size": "integer",
    "db.operation.name": "string",
    "db.query.parameter.<key>": "string",
    "db.query.summary": "string",
    "db.query.text": "string",
    "db.redis.connection": "string",
    "db.redis.key": "string",
    "db.redis.parameters": "string[]",
    "db.response.status_code": "string",
    "db.sql.bindings": "string[]",
    "db.statement": "string",
    "db.stored_procedure.name": "string",
    "db.system": "string",
    "db.system.name": "string",
    "db.user": "string",
    deviceMemory: "string",
    "device.archs": "string[]",
    "device.battery_level": "double",
    "device.battery_temperature": "double",
    "device.boot_time": "string",
    "device.brand": "string",
    "device.charging": "boolean",
    "device.chipset": "string",
    "device.class": "string",
    "device.connection_type": "string",
    "device.cpu_description": "string",
    "device.external_free_storage": "integer",
    "device.external_storage_size": "integer",
    "device.family": "string",
    "device.free_memory": "integer",
    "device.free_storage": "integer",
    "device.id": "string",
    "device.locale": "string",
    "device.low_memory": "boolean",
    "device.low_power_mode": "boolean",
    "device.manufacturer": "string",
    "device.memory.estimated_capacity": "integer",
    "device.memory_size": "integer",
    "device.model": "string",
    "device.model_id": "string",
    "device.name": "string",
    "device.online": "boolean",
    "device.orientation": "string",
    "device.processor_count": "integer",
    "device.processor_frequency": "double",
    "device.screen_density": "double",
    "device.screen_dpi": "integer",
    "device.screen_height_pixels": "integer",
    "device.screen_width_pixels": "integer",
    "device.simulator": "boolean",
    "device.storage_size": "integer",
    "device.thermal_state": "string",
    "device.timezone": "string",
    "device.usable_memory": "integer",
    dist: "string",
    effectiveConnectionType: "string",
    environment: "string",
    "error.type": "string",
    "event.id": "integer",
    "event.name": "string",
    "exception.escaped": "boolean",
    "exception.message": "string",
    "exception.stacktrace": "string",
    "exception.type": "string",
    "faas.coldstart": "boolean",
    "faas.cron": "string",
    "faas.duration_in_ms": "integer",
    "faas.entry_point": "string",
    "faas.execution": "string",
    "faas.id": "string",
    "faas.identity": "string",
    "faas.invocation_id": "string",
    "faas.invoked_name": "string",
    "faas.invoked_provider": "string",
    "faas.invoked_region": "string",
    "faas.name": "string",
    "faas.time": "string",
    "faas.trigger": "string",
    "faas.version": "string",
    fcp: "double",
    "flag.evaluation.<key>": "boolean",
    fp: "double",
    "frames.delay": "integer",
    "frames.frozen": "integer",
    frames_frozen_rate: "double",
    "frames.slow": "integer",
    frames_slow_rate: "double",
    "frames.total": "integer",
    fs_error: "string",
    "gcp.function.context.event_id": "string",
    "gcp.function.context.event_type": "string",
    "gcp.function.context.id": "string",
    "gcp.function.context.resource": "string",
    "gcp.function.context.source": "string",
    "gcp.function.context.specversion": "string",
    "gcp.function.context.time": "string",
    "gcp.function.context.timestamp": "string",
    "gcp.function.context.type": "string",
    "gcp.project.id": "string",
    "gen_ai.agent.name": "string",
    "gen_ai.context.utilization": "double",
    "gen_ai.context.window_size": "integer",
    "gen_ai.conversation.id": "string",
    "gen_ai.cost.cache_creation.input_tokens": "double",
    "gen_ai.cost.cache_read.input_tokens": "double",
    "gen_ai.cost.input_tokens": "double",
    "gen_ai.cost.output_tokens": "double",
    "gen_ai.cost.reasoning.output_tokens": "double",
    "gen_ai.cost.total_tokens": "double",
    "gen_ai.embeddings.input": "string",
    "gen_ai.function_id": "string",
    "gen_ai.input.messages": "string",
    "gen_ai.operation.name": "string",
    "gen_ai.operation.type": "string",
    "gen_ai.output.messages": "string",
    "gen_ai.pipeline.name": "string",
    "gen_ai.prompt": "string",
    "gen_ai.prompt.name": "string",
    "gen_ai.provider.name": "string",
    "gen_ai.request.available_tools": "string",
    "gen_ai.request.frequency_penalty": "double",
    "gen_ai.request.max_tokens": "integer",
    "gen_ai.request.messages": "string",
    "gen_ai.request.model": "string",
    "gen_ai.request.presence_penalty": "double",
    "gen_ai.request.reasoning_effort": "string",
    "gen_ai.request.seed": "string",
    "gen_ai.request.stop_sequences": "string[]",
    "gen_ai.request.temperature": "double",
    "gen_ai.request.top_k": "integer",
    "gen_ai.request.top_p": "double",
    "gen_ai.response.finish_reasons": "string",
    "gen_ai.response.id": "string",
    "gen_ai.response.model": "string",
    "gen_ai.response.streaming": "boolean",
    "gen_ai.response.text": "string",
    "gen_ai.response.time_to_first_chunk": "double",
    "gen_ai.response.time_to_first_token": "double",
    "gen_ai.response.tokens_per_second": "double",
    "gen_ai.response.tool_calls": "string",
    "gen_ai.system": "string",
    "gen_ai.system_instructions": "string",
    "gen_ai.system.message": "string",
    "gen_ai.tool.call.arguments": "string",
    "gen_ai.tool.call.result": "string",
    "gen_ai.tool.definitions": "string",
    "gen_ai.tool.description": "string",
    "gen_ai.tool.input": "string",
    "gen_ai.tool.message": "string",
    "gen_ai.tool.name": "string",
    "gen_ai.tool.output": "string",
    "gen_ai.tool.type": "string",
    "gen_ai.usage.cache_creation.input_tokens": "integer",
    "gen_ai.usage.cache_read.input_tokens": "integer",
    "gen_ai.usage.completion_tokens": "integer",
    "gen_ai.usage.input_tokens": "integer",
    "gen_ai.usage.input_tokens.cached": "integer",
    "gen_ai.usage.input_tokens.cache_write": "integer",
    "gen_ai.usage.output_tokens": "integer",
    "gen_ai.usage.output_tokens.reasoning": "integer",
    "gen_ai.usage.prompt_tokens": "integer",
    "gen_ai.usage.reasoning.output_tokens": "integer",
    "gen_ai.usage.total_tokens": "integer",
    "graphql.document": "string",
    "graphql.operation.name": "string",
    "graphql.operation.type": "string",
    hardwareConcurrency: "string",
    "http.client_ip": "string",
    "http.decoded_response_content_length": "integer",
    "http.flavor": "string",
    "http.fragment": "string",
    "http.host": "string",
    "http.method": "string",
    "http.query": "string",
    "http.request.body.data": "string",
    "http.request.connection_end": "double",
    "http.request.connect_start": "double",
    "http.request.domain_lookup_end": "double",
    "http.request.domain_lookup_start": "double",
    "http.request.fetch_start": "double",
    "http.request.header.<key>": "string[]",
    "http.request.method": "string",
    "http.request_method": "string",
    "http.request.redirect_end": "double",
    "http.request.redirect_start": "double",
    "http.request.request_start": "double",
    "http.request.resend_count": "integer",
    "http.request.response_end": "double",
    "http.request.response_start": "double",
    "http.request.same_origin": "boolean",
    "http.request.secure_connection_start": "double",
    "http.request.time_to_first_byte": "double",
    "http.request.worker_start": "double",
    "http.response.body.size": "integer",
    "http.response_content_length": "integer",
    "http.response.header.content-length": "string",
    "http.response.header.<key>": "string[]",
    "http.response.size": "integer",
    "http.response.status_code": "integer",
    "http.response_transfer_size": "integer",
    "http.route": "string",
    "http.scheme": "string",
    "http.server_name": "string",
    "http.server.request.time_in_queue": "double",
    "http.status_code": "integer",
    "http.target": "string",
    "http.url": "string",
    "http.user_agent": "string",
    id: "string",
    inp: "double",
    "jsonrpc.protocol.version": "string",
    "jsonrpc.request.id": "string",
    "jvm.gc.action": "string",
    "jvm.gc.name": "string",
    "jvm.memory.pool.name": "string",
    "jvm.memory.type": "string",
    "jvm.thread.daemon": "boolean",
    "jvm.thread.state": "string",
    "koa.name": "string",
    "koa.type": "string",
    lcp: "double",
    "lcp.element": "string",
    "lcp.id": "string",
    "lcp.loadTime": "integer",
    "lcp.renderTime": "integer",
    "lcp.size": "integer",
    "lcp.url": "string",
    "logger.name": "string",
    "mcp.cancelled.reason": "string",
    "mcp.cancelled.request_id": "string",
    "mcp.client.name": "string",
    "mcp.client.title": "string",
    "mcp.client.version": "string",
    "mcp.lifecycle.phase": "string",
    "mcp.logging.data_type": "string",
    "mcp.logging.level": "string",
    "mcp.logging.logger": "string",
    "mcp.logging.message": "string",
    "mcp.method.name": "string",
    "mcp.progress.current": "integer",
    "mcp.progress.message": "string",
    "mcp.progress.percentage": "double",
    "mcp.progress.token": "string",
    "mcp.progress.total": "integer",
    "mcp.prompt.name": "string",
    "mcp.prompt.result.description": "string",
    "mcp.prompt.result.message_content": "string",
    "mcp.prompt.result.message_count": "integer",
    "mcp.prompt.result.message_role": "string",
    "mcp.protocol.ready": "integer",
    "mcp.protocol.version": "string",
    "mcp.request.argument.<key>": "string",
    "mcp.request.argument.name": "string",
    "mcp.request.argument.uri": "string",
    "mcp.request.id": "string",
    "mcp.resource.protocol": "string",
    "mcp.resource.uri": "string",
    "mcp.server.name": "string",
    "mcp.server.title": "string",
    "mcp.server.version": "string",
    "mcp.session.id": "string",
    "mcp.tool.name": "string",
    "mcp.tool.result.content": "string",
    "mcp.tool.result.content_count": "integer",
    "mcp.tool.result.is_error": "boolean",
    "mcp.transport": "string",
    "mdc.<key>": "string",
    "messaging.batch.message_count": "integer",
    "messaging.destination": "string",
    "messaging.destination.connection": "string",
    "messaging.destination.name": "string",
    "messaging.message.body.size": "integer",
    "messaging.message.conversation_id": "string",
    "messaging.message.envelope.size": "integer",
    "messaging.message.id": "string",
    "messaging.message.receive.latency": "integer",
    "messaging.message.retry.count": "integer",
    "messaging.operation.name": "string",
    "messaging.operation.type": "string",
    "messaging.rabbitmq.destination.routing_key": "string",
    "messaging.system": "string",
    method: "string",
    "middleware.name": "string",
    "navigation.origin": "string",
    "navigation.route.id": "string",
    "navigation.type": "string",
    "nel.elapsed_time": "integer",
    "nel.phase": "string",
    "nel.referrer": "string",
    "nel.sampling_function": "double",
    "nel.type": "string",
    "network.connection.effective_type": "string",
    "network.connection.rtt": "integer",
    "network.connection.type": "string",
    "network.local.address": "string",
    "network.local.port": "integer",
    "network.peer.address": "string",
    "network.peer.port": "integer",
    "network.protocol.name": "string",
    "network.protocol.version": "string",
    "network.transport": "string",
    "network.type": "string",
    "net.host.ip": "string",
    "net.host.name": "string",
    "net.host.port": "integer",
    "net.peer.ip": "string",
    "net.peer.name": "string",
    "net.peer.port": "integer",
    "net.protocol.name": "string",
    "net.protocol.version": "string",
    "net.sock.family": "string",
    "net.sock.host.addr": "string",
    "net.sock.host.port": "integer",
    "net.sock.peer.addr": "string",
    "net.sock.peer.name": "string",
    "net.sock.peer.port": "integer",
    "net.transport": "string",
    "os.build": "string",
    "os.build_id": "string",
    "os.description": "string",
    "os.kernel_version": "string",
    "os.name": "string",
    "os.raw_description": "string",
    "os.rooted": "boolean",
    "os.theme": "string",
    "os.type": "string",
    "os.version": "string",
    "otel.kind": "string",
    "otel.scope.name": "string",
    "otel.scope.version": "string",
    "otel.status_code": "string",
    "otel.status_description": "string",
    "params.<key>": "string",
    "performance.activationStart": "double",
    "performance.timeOrigin": "double",
    previous_route: "string",
    "process.command_args": "string[]",
    "process.executable.name": "string",
    "process.pid": "integer",
    "process.runtime.description": "string",
    "process.runtime.engine.name": "string",
    "process.runtime.engine.version": "string",
    "process.runtime.name": "string",
    "process.runtime.version": "string",
    "query.<key>": "string",
    "react.version": "string",
    release: "string",
    "remix.action_form_data.<key>": "string",
    replay_id: "string",
    "resource.deployment.environment": "string",
    "resource.deployment.environment.name": "string",
    "resource.render_blocking_status": "string",
    route: "string",
    "rpc.grpc.status_code": "integer",
    "rpc.method": "string",
    "rpc.response.status_code": "string",
    "rpc.service": "string",
    "rpc.system": "string",
    "rpc.system.name": "string",
    "runtime.build": "string",
    "runtime.name": "string",
    "runtime.raw_description": "string",
    "runtime.version": "string",
    "score.<key>": "double",
    "score.ratio.<key>": "double",
    "score.total": "double",
    "score.weight.<key>": "double",
    "sentry.action": "string",
    "sentry.browser.name": "string",
    "sentry.browser.version": "string",
    "sentry.cancellation_reason": "string",
    "sentry.category": "string",
    "sentry.client_sample_rate": "double",
    "sentry.description": "string",
    "sentry.dist": "string",
    "sentry.domain": "string",
    "sentry.dsc.environment": "string",
    "sentry.dsc.project_id": "string",
    "sentry.dsc.public_key": "string",
    "sentry.dsc.release": "string",
    "sentry.dsc.sampled": "boolean",
    "sentry.dsc.sample_rate": "string",
    "sentry.dsc.trace_id": "string",
    "sentry.dsc.transaction": "string",
    "sentry.environment": "string",
    "sentry.exclusive_time": "double",
    "sentry.graphql.operation": "string",
    "sentry.group": "string",
    "sentry.http.prefetch": "boolean",
    "sentry.idle_span_finish_reason": "string",
    "sentry.is_remote": "boolean",
    "sentry.kind": "string",
    "sentry.main_thread": "boolean",
    "sentry.message.parameter.<key>": "string",
    "sentry.message.template": "string",
    "sentry.metric.source": "string",
    "sentry.mobile": "boolean",
    "sentry.module.<key>": "string",
    "sentry.nextjs.ssr.function.route": "string",
    "sentry.nextjs.ssr.function.type": "string",
    "sentry.normalized_db_query": "string",
    "sentry.normalized_db_query.hash": "string",
    "sentry.normalized_description": "string",
    "sentry.observed_timestamp_nanos": "string",
    "sentry.op": "string",
    "sentry.origin": "string",
    "sentry.platform": "string",
    "sentry.profiler_id": "string",
    "sentry.profile_id": "string",
    "sentry.release": "string",
    "sentry.replay_id": "string",
    "sentry.replay_is_buffering": "boolean",
    "sentry.report_event": "string",
    "sentry.sdk.integrations": "string[]",
    "sentry.sdk.name": "string",
    "sentry.sdk.version": "string",
    "sentry.segment.id": "string",
    "sentry.segment_id": "string",
    "sentry.segment.name": "string",
    "sentry.server_sample_rate": "double",
    "sentry.source": "string",
    "sentry.span.source": "string",
    "sentry.status": "string",
    "sentry.status_code": "integer",
    "sentry.status.message": "string",
    "sentry.sveltekit.navigation.from": "string",
    "sentry.sveltekit.navigation.to": "string",
    "sentry.sveltekit.navigation.type": "string",
    "sentry.thread.id": "integer",
    "sentry.timestamp.sequence": "integer",
    "sentry.trace_lifecycle": "string",
    "sentry.trace.parent_span_id": "string",
    "sentry.trace.status": "string",
    "sentry.transaction": "string",
    "sentry.user.email": "string",
    "sentry.user.geo.city": "string",
    "sentry.user.geo.country_code": "string",
    "sentry.user.geo.region": "string",
    "sentry.user.geo.subdivision": "string",
    "sentry.user.id": "string",
    "sentry.user.ip": "string",
    "sentry.user.username": "string",
    "server.address": "string",
    server_name: "string",
    "server.port": "integer",
    "service.name": "string",
    "service.version": "string",
    "session.id": "string",
    stall_percentage: "double",
    stall_total_time: "double",
    "state.type": "string",
    "thread.id": "integer",
    "thread.name": "string",
    "timber.tag": "string",
    time_to_full_display: "double",
    time_to_initial_display: "double",
    transaction: "string",
    "trpc.procedure_path": "string",
    "trpc.procedure_type": "string",
    ttfb: "double",
    "ttfb.requestTime": "double",
    type: "string",
    "ui.component_name": "string",
    "ui.contributes_to_ttfd": "boolean",
    "ui.contributes_to_ttid": "boolean",
    "ui.element.height": "integer",
    "ui.element.id": "string",
    "ui.element.identifier": "string",
    "ui.element.load_time": "double",
    "ui.element.paint_type": "string",
    "ui.element.render_time": "double",
    "ui.element.type": "string",
    "ui.element.url": "string",
    "ui.element.width": "integer",
    url: "string",
    "url.domain": "string",
    "url.fragment": "string",
    "url.full": "string",
    "url.path": "string",
    "url.path.parameter.<key>": "string",
    "url.port": "integer",
    "url.query": "string",
    "url.same_origin": "boolean",
    "url.scheme": "string",
    "url.template": "string",
    "user_agent.original": "string",
    "user.email": "string",
    "user.full_name": "string",
    "user.geo.city": "string",
    "user.geo.country_code": "string",
    "user.geo.region": "string",
    "user.geo.subdivision": "string",
    "user.hash": "string",
    "user.id": "string",
    "user.ip_address": "string",
    "user.name": "string",
    "user.roles": "string[]",
    "vercel.branch": "string",
    "vercel.build_id": "string",
    "vercel.deployment_id": "string",
    "vercel.destination": "string",
    "vercel.edge_type": "string",
    "vercel.entrypoint": "string",
    "vercel.execution_region": "string",
    "vercel.id": "string",
    "vercel.ja3_digest": "string",
    "vercel.ja4_digest": "string",
    "vercel.log_type": "string",
    "vercel.path": "string",
    "vercel.project_id": "string",
    "vercel.project_name": "string",
    "vercel.proxy.cache_id": "string",
    "vercel.proxy.client_ip": "string",
    "vercel.proxy.host": "string",
    "vercel.proxy.lambda_region": "string",
    "vercel.proxy.method": "string",
    "vercel.proxy.path": "string",
    "vercel.proxy.path_type": "string",
    "vercel.proxy.path_type_variant": "string",
    "vercel.proxy.referer": "string",
    "vercel.proxy.region": "string",
    "vercel.proxy.response_byte_size": "integer",
    "vercel.proxy.scheme": "string",
    "vercel.proxy.status_code": "integer",
    "vercel.proxy.timestamp": "integer",
    "vercel.proxy.user_agent": "string[]",
    "vercel.proxy.vercel_cache": "string",
    "vercel.proxy.vercel_id": "string",
    "vercel.proxy.waf_action": "string",
    "vercel.proxy.waf_rule_id": "string",
    "vercel.request_id": "string",
    "vercel.source": "string",
    "vercel.status_code": "integer"
}, $687ff8957497b063$var$ATTRIBUTE_METADATA = {
    "ai.citations": {
        brief: "References or sources cited by the AI model in its response.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Citation 1",
            "Citation 2"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.completion_tokens.used": {
        brief: "The number of tokens used to respond to the message.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 10,
        deprecation: {
            replacement: "gen_ai.usage.output_tokens"
        },
        aliases: [
            "gen_ai.usage.output_tokens",
            "gen_ai.usage.completion_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.documents": {
        brief: "Documents or content chunks used as context for the AI model.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "document1.txt",
            "document2.pdf"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.finish_reason": {
        brief: "The reason why the model stopped generating.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "COMPLETE",
        deprecation: {
            replacement: "gen_ai.response.finish_reasons"
        },
        aliases: [
            "gen_ai.response.finish_reasons"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.frequency_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. The higher the value, the stronger a penalty is applied to previously present tokens, proportional to how many times they have already appeared in the prompt or prior generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        deprecation: {
            replacement: "gen_ai.request.frequency_penalty"
        },
        aliases: [
            "gen_ai.request.frequency_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.function_call": {
        brief: "For an AI model call, the function that was called. This is deprecated for OpenAI, and replaced by tool_calls",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "function_name",
        deprecation: {
            replacement: "gen_ai.tool.name"
        },
        aliases: [
            "gen_ai.tool.name",
            "mcp.tool.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.generation_id": {
        brief: "Unique identifier for the completion.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gen_123abc",
        deprecation: {
            replacement: "gen_ai.response.id"
        },
        aliases: [
            "gen_ai.response.id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.input_messages": {
        brief: "The input messages sent to the model",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "gen_ai.request.messages"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    65,
                    119
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.is_search_required": {
        brief: "Boolean indicating if the model needs to perform a search.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.metadata": {
        brief: "Extra metadata passed to an AI pipeline step.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"user_id": 123, "session_id": "abc123"}',
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.model_id": {
        brief: "The vendor-specific ID of the model used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gpt-4",
        deprecation: {
            replacement: "gen_ai.response.model"
        },
        aliases: [
            "gen_ai.response.model"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.model.provider": {
        brief: "The provider of the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "openai",
        deprecation: {
            replacement: "gen_ai.provider.name"
        },
        aliases: [
            "gen_ai.provider.name",
            "gen_ai.system"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.pipeline.name": {
        brief: "The name of the AI pipeline.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Autofix Pipeline",
        deprecation: {
            replacement: "gen_ai.pipeline.name"
        },
        aliases: [
            "gen_ai.pipeline.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    53,
                    76,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.preamble": {
        brief: "For an AI model call, the preamble parameter. Preambles are a part of the prompt used to adjust the model's overall behavior and conversation style.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "You are now a clown.",
        deprecation: {
            replacement: "gen_ai.system_instructions"
        },
        aliases: [
            "gen_ai.system_instructions"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.presence_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. Similar to frequency_penalty, except that this penalty is applied equally to all tokens that have already appeared, regardless of their exact frequencies.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        deprecation: {
            replacement: "gen_ai.request.presence_penalty"
        },
        aliases: [
            "gen_ai.request.presence_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.prompt_tokens.used": {
        brief: "The number of tokens used to process just the prompt.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 20,
        deprecation: {
            replacement: "gen_ai.usage.input_tokens"
        },
        aliases: [
            "gen_ai.usage.prompt_tokens",
            "gen_ai.usage.input_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.raw_prompting": {
        brief: "When enabled, the user\u2019s prompt will be sent to the model without any pre-processing.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.responses": {
        brief: "The response messages sent back by the AI model.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "hello",
            "world"
        ],
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    65,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.response_format": {
        brief: "For an AI model call, the format of the response",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "json_object",
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.search_queries": {
        brief: "Queries used to search for relevant context or documents.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "climate change effects",
            "renewable energy"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.search_results": {
        brief: "Results returned from search queries for context.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "search_result_1, search_result_2"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.seed": {
        brief: "The seed, ideally models given the same seed and same other parameters will produce the exact same output.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        deprecation: {
            replacement: "gen_ai.request.seed"
        },
        aliases: [
            "gen_ai.request.seed"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.streaming": {
        brief: "Whether the request was streamed back.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {
            replacement: "gen_ai.response.streaming"
        },
        aliases: [
            "gen_ai.response.streaming"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.tags": {
        brief: "Tags that describe an AI pipeline step.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"executed_function": "add_integers"}',
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.temperature": {
        brief: "For an AI model call, the temperature parameter. Temperature essentially means how random the output will be.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .1,
        deprecation: {
            replacement: "gen_ai.request.temperature"
        },
        aliases: [
            "gen_ai.request.temperature"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.texts": {
        brief: "Raw text inputs provided to the model.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Hello, how are you?",
            "What is the capital of France?"
        ],
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "gen_ai.input.messages"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.tools": {
        brief: "For an AI model call, the functions that are available",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "function_1",
            "function_2"
        ],
        deprecation: {
            replacement: "gen_ai.tool.definitions"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    65,
                    127
                ]
            }
        ]
    },
    "ai.tool_calls": {
        brief: "For an AI model call, the tool calls that were made.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "tool_call_1",
            "tool_call_2"
        ],
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    65
                ]
            }
        ]
    },
    "ai.top_k": {
        brief: "Limits the model to only consider the K most likely next tokens, where K is an integer (e.g., top_k=20 means only the 20 highest probability tokens are considered).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 35,
        deprecation: {
            replacement: "gen_ai.request.top_k"
        },
        aliases: [
            "gen_ai.request.top_k"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.top_p": {
        brief: "Limits the model to only consider tokens whose cumulative probability mass adds up to p, where p is a float between 0 and 1 (e.g., top_p=0.7 means only tokens that sum up to 70% of the probability mass are considered).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .7,
        deprecation: {
            replacement: "gen_ai.request.top_p"
        },
        aliases: [
            "gen_ai.request.top_p"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.total_cost": {
        brief: "The total cost for the tokens used.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        deprecation: {
            replacement: "gen_ai.cost.total_tokens"
        },
        aliases: [
            "gen_ai.cost.total_tokens"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    53
                ]
            }
        ]
    },
    "ai.total_tokens.used": {
        brief: "The total number of tokens used to process the prompt.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 30,
        deprecation: {
            replacement: "gen_ai.usage.total_tokens"
        },
        aliases: [
            "gen_ai.usage.total_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.warnings": {
        brief: "Warning messages generated during model execution.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Token limit exceeded"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "angular.version": {
        brief: "The version of the Angular framework",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "17.1.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    367
                ],
                description: "Added angular.version attribute"
            }
        ]
    },
    "app.app_build": {
        brief: "Internal build identifier, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        deprecation: {
            replacement: "app.build",
            reason: "Deprecated in favor of app.build"
        },
        aliases: [
            "app.build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_build in favor of app.build"
            }
        ]
    },
    "app.app_identifier": {
        brief: "Version-independent application identifier, often a dotted bundle ID.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "com.example.myapp",
        deprecation: {
            replacement: "app.identifier",
            reason: "Deprecated in favor of app.identifier"
        },
        aliases: [
            "app.identifier"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_identifier in favor of app.identifier"
            }
        ]
    },
    "app.app_name": {
        brief: "Human readable application name, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "My App",
        deprecation: {
            replacement: "app.name",
            reason: "Deprecated in favor of app.name"
        },
        aliases: [
            "app.name"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_name in favor of app.name"
            }
        ]
    },
    "app.app_start_time": {
        brief: "Formatted UTC timestamp when the user started the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2025-01-01T00:00:00.000Z",
        deprecation: {
            replacement: "app.start_time",
            reason: "Deprecated in favor of app.start_time"
        },
        aliases: [
            "app.start_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_start_time in favor of app.start_time"
            }
        ]
    },
    "app.app_version": {
        brief: "Human readable application version, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        deprecation: {
            replacement: "app.version",
            reason: "Deprecated in favor of app.version"
        },
        aliases: [
            "app.version"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_version in favor of app.version"
            }
        ]
    },
    "app.build": {
        brief: "Internal build identifier, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        aliases: [
            "app.app_build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.build attribute"
            }
        ]
    },
    "app.identifier": {
        brief: "Version-independent application identifier, often a dotted bundle ID.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "com.example.myapp",
        aliases: [
            "app.app_identifier"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.identifier attribute"
            }
        ]
    },
    "app.in_foreground": {
        brief: "Whether the application is currently in the foreground.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.in_foreground attribute"
            }
        ]
    },
    "app.name": {
        brief: "Human readable application name, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "My App",
        aliases: [
            "app.app_name"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.name attribute"
            }
        ]
    },
    app_start_cold: {
        brief: "The duration of a cold app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.start.cold.value",
            reason: "Replaced by app.vitals.start.cold.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.cold.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    323
                ],
                description: "Added and deprecated in favor of app.vitals.start.cold.value"
            }
        ]
    },
    "app.start_time": {
        brief: "Formatted UTC timestamp when the user started the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2025-01-01T00:00:00.000Z",
        aliases: [
            "app.app_start_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.start_time attribute"
            }
        ]
    },
    app_start_type: {
        brief: "Mobile app start variant. Either cold or warm.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cold",
        deprecation: {
            replacement: "app.vitals.start.type",
            reason: "Replaced by app.vitals.start.type to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.start.type"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    app_start_warm: {
        brief: "The duration of a warm app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.start.warm.value",
            reason: "Replaced by app.vitals.start.warm.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.warm.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    323
                ],
                description: "Added and deprecated in favor of app.vitals.start.warm.value"
            }
        ]
    },
    "app.version": {
        brief: "Human readable application version, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        aliases: [
            "app.app_version"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.version attribute"
            }
        ]
    },
    "app.vitals.frames.delay.value": {
        brief: "The sum of all delayed frame durations in seconds during the lifetime of the span. For more information see [frames delay](https://develop.sentry.dev/sdk/performance/frames-delay/).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5,
        aliases: [
            "frames.delay"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.delay.value to replace frames.delay"
            }
        ]
    },
    "app.vitals.frames.frozen.count": {
        brief: "The number of frozen frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        aliases: [
            "frames.frozen"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.frozen.count to replace frames.frozen"
            }
        ]
    },
    "app.vitals.frames.slow.count": {
        brief: "The number of slow frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        aliases: [
            "frames.slow"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.slow.count to replace frames.slow"
            }
        ]
    },
    "app.vitals.frames.total.count": {
        brief: "The number of total frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 60,
        aliases: [
            "frames.total"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.total.count to replace frames.total"
            }
        ]
    },
    "app.vitals.start.cold.value": {
        brief: "The duration of a cold app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "app_start_cold"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.cold.value attribute"
            }
        ]
    },
    "app.vitals.start.prewarmed": {
        brief: "Whether the app start was prewarmed.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    379
                ],
                description: "Added app.vitals.start.prewarmed attribute"
            }
        ]
    },
    "app.vitals.start.reason": {
        brief: "The reason that triggered the app start.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "push",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    353
                ],
                description: "Added app.vitals.start.reason attribute"
            }
        ]
    },
    "app.vitals.start.screen": {
        brief: "The screen that is rendered when the app start is complete. This is the screen the user first sees and can interact with after launch. The absence of this attribute on the app start span indicates a background app start where no UI was rendered.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MainActivity",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    353
                ],
                description: "Added app.vitals.start.screen attribute"
            }
        ]
    },
    "app.vitals.start.type": {
        brief: "The type of app start, for example `cold` or `warm`",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cold",
        aliases: [
            "app_start_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.type attribute"
            }
        ]
    },
    "app.vitals.start.warm.value": {
        brief: "The duration of a warm app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "app_start_warm"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.warm.value attribute"
            }
        ]
    },
    "app.vitals.ttfd.value": {
        brief: "The duration of time to full display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "time_to_full_display"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.ttfd.value attribute"
            }
        ]
    },
    "app.vitals.ttid.value": {
        brief: "The duration of time to initial display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "time_to_initial_display"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.ttid.value attribute"
            }
        ]
    },
    "art.gc.blocking_count": {
        brief: "Total number of blocking (stop-the-world) garbage collections performed by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.blocking_count attribute"
            }
        ]
    },
    "art.gc.blocking_time": {
        brief: "Total time spent in blocking (stop-the-world) garbage collections by the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 11.873,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.blocking_time attribute"
            }
        ]
    },
    "art.gc.pre_oome_count": {
        brief: "Total number of garbage collections triggered as a last resort before an OutOfMemoryError by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 0,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.pre_oome_count attribute"
            }
        ]
    },
    "art.gc.total_count": {
        brief: "Total number of garbage collections performed by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.total_count attribute"
            }
        ]
    },
    "art.gc.total_time": {
        brief: "Total time spent in garbage collection by the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 11.807,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.total_time attribute"
            }
        ]
    },
    "art.gc.waiting_time": {
        brief: "Total time threads spent waiting for garbage collection to complete in the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8.054,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.waiting_time attribute"
            }
        ]
    },
    "art.memory.free": {
        brief: "Free memory available to the process as reported by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3181568,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free attribute"
            }
        ]
    },
    "art.memory.free_until_gc": {
        brief: "Free memory available before a garbage collection would be triggered by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3181568,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free_until_gc attribute"
            }
        ]
    },
    "art.memory.free_until_oome": {
        brief: "Free memory available before an OutOfMemoryError would be thrown by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 196083712,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free_until_oome attribute"
            }
        ]
    },
    "art.memory.max": {
        brief: "Maximum memory the process is allowed to use as reported by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 201326592,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.max attribute"
            }
        ]
    },
    "art.memory.total": {
        brief: "Total memory currently allocated to the process by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 7774208,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.total attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.log_group": {
        brief: "The name of the CloudWatch Logs log group",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/aws/lambda/my-function",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.log_group attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.log_stream": {
        brief: "The name of the CloudWatch Logs log stream",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024/01/01/[$LATEST]abcdef1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.log_stream attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.url": {
        brief: "The URL to the CloudWatch Logs log group",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://console.aws.amazon.com/cloudwatch/home?region=us-east-1#logsV2:log-groups/log-group/my-log-group",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.url attribute"
            }
        ]
    },
    "aws.dynamodb.attribute_definitions": {
        brief: "The JSON-serialized value of each item in the `AttributeDefinitions` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "AttributeName": "string", "AttributeType": "string" }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.attribute_definitions attribute"
            }
        ]
    },
    "aws.dynamodb.consistent_read": {
        brief: "The value of the `ConsistentRead` request parameter.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.consistent_read attribute"
            }
        ]
    },
    "aws.dynamodb.consumed_capacity": {
        brief: "The JSON-serialized value of each item in the `ConsumedCapacity` response field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "CapacityUnits": number, "GlobalSecondaryIndexes": { "string" : { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number } }, "LocalSecondaryIndexes": { "string" : { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number } }, "ReadCapacityUnits": number, "Table": { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number }, "TableName": "string", "WriteCapacityUnits": number }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.consumed_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.count": {
        brief: "The value of the `Count` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.count attribute"
            }
        ]
    },
    "aws.dynamodb.exclusive_start_table": {
        brief: "The value of the `ExclusiveStartTableName` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Users",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.exclusive_start_table attribute"
            }
        ]
    },
    "aws.dynamodb.global_secondary_indexes": {
        brief: "The JSON-serialized value of each item of the `GlobalSecondaryIndexes` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "IndexName": "string", "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" }, "ProvisionedThroughput": { "ReadCapacityUnits": number, "WriteCapacityUnits": number } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.global_secondary_indexes attribute"
            }
        ]
    },
    "aws.dynamodb.global_secondary_index_updates": {
        brief: "The JSON-serialized value of each item in the `GlobalSecondaryIndexUpdates` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "Create": { "IndexName": "string", "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" }, "ProvisionedThroughput": { "ReadCapacityUnits": number, "WriteCapacityUnits": number } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.global_secondary_index_updates attribute"
            }
        ]
    },
    "aws.dynamodb.index_name": {
        brief: "The value of the `IndexName` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "name_to_group",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.index_name attribute"
            }
        ]
    },
    "aws.dynamodb.item_collection_metrics": {
        brief: "The JSON-serialized value of the `ItemCollectionMetrics` response field.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '{ "string" : [ { "ItemCollectionKey": { "string" : { "B": blob, "BOOL": boolean, "BS": [ blob ], "L": [ "AttributeValue" ], "M": { "string" : "AttributeValue" }, "N": "string", "NS": [ "string" ], "NULL": boolean, "S": "string", "SS": [ "string" ] } }, "SizeEstimateRangeGB": [ number ] } ] }',
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.item_collection_metrics attribute"
            }
        ]
    },
    "aws.dynamodb.limit": {
        brief: "The value of the `Limit` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.limit attribute"
            }
        ]
    },
    "aws.dynamodb.local_secondary_indexes": {
        brief: "The JSON-serialized value of each item of the `LocalSecondaryIndexes` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "IndexArn": "string", "IndexName": "string", "IndexSizeBytes": number, "ItemCount": number, "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.local_secondary_indexes attribute"
            }
        ]
    },
    "aws.dynamodb.projection": {
        brief: "The value of the `ProjectionExpression` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Title, Price, Color",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.projection attribute"
            }
        ]
    },
    "aws.dynamodb.provisioned_read_capacity": {
        brief: "The value of the `ProvisionedThroughput.ReadCapacityUnits` request parameter.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.provisioned_read_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.provisioned_write_capacity": {
        brief: "The value of the `ProvisionedThroughput.WriteCapacityUnits` request parameter.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.provisioned_write_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.scanned_count": {
        brief: "The value of the `ScannedCount` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.scanned_count attribute"
            }
        ]
    },
    "aws.dynamodb.scan_forward": {
        brief: "The value of the `ScanIndexForward` request parameter.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.scan_forward attribute"
            }
        ]
    },
    "aws.dynamodb.segment": {
        brief: "The value of the `Segment` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.segment attribute"
            }
        ]
    },
    "aws.dynamodb.select": {
        brief: "The value of the `Select` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ALL_ATTRIBUTES",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.select attribute"
            }
        ]
    },
    "aws.dynamodb.table_count": {
        brief: "The number of items in the `TableNames` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 20,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.table_count attribute"
            }
        ]
    },
    "aws.dynamodb.table_names": {
        brief: "The keys in the `RequestItems` object field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "Users",
            "Cats"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.table_names attribute"
            }
        ]
    },
    "aws.dynamodb.total_segments": {
        brief: "The value of the `TotalSegments` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.total_segments attribute"
            }
        ]
    },
    "aws.extended_request_id": {
        brief: "The AWS extended request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "wzHcyEWfmOGDIE5QOhTAqFDoDWP3y8IUvpNINCwL9N4TEHbUw0/gZJ+VZTmCNCWR7fezEN3eCiQ=",
        aliases: [
            "aws.request.extended_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.extended_request_id attribute"
            }
        ]
    },
    "aws.kinesis.stream_name": {
        brief: "The name of the AWS Kinesis stream the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "some-stream-name",
        aliases: [
            "aws.kinesis.stream.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.kinesis.stream_name attribute"
            }
        ]
    },
    "aws.kinesis.stream.name": {
        brief: "The name of the AWS Kinesis stream the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "some-stream-name",
        deprecation: {
            replacement: "aws.kinesis.stream_name",
            reason: "This attribute is being deprecated in favor of aws.kinesis.stream_name, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.kinesis.stream_name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.kinesis.stream.name attribute, deprecated in favor of aws.kinesis.stream_name"
            }
        ]
    },
    "aws.lambda.aws_request_id": {
        brief: "The AWS request ID as received by the Lambda function runtime",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "8476a536-e9f4-11e8-9739-2dfe598c3fcd",
        deprecation: {
            replacement: "faas.invocation_id",
            reason: "This attribute is being deprecated in favor of faas.invocation_id"
        },
        aliases: [
            "faas.invocation_id",
            "faas.execution"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ],
                description: "Deprecated aws.lambda.aws_request_id in favor of faas.invocation_id"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.aws_request_id attribute"
            }
        ]
    },
    "aws.lambda.execution_duration_in_millis": {
        brief: "The execution duration of the Lambda function invocation in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.execution_duration_in_millis attribute"
            }
        ]
    },
    "aws.lambda.function_name": {
        brief: "The name of the Lambda function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-function",
        deprecation: {
            replacement: "faas.name",
            reason: "Use the OTel-aligned faas.name attribute instead"
        },
        aliases: [
            "faas.name"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ],
                description: "Deprecated aws.lambda.function_name in favor of faas.name"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.function_name attribute"
            }
        ]
    },
    "aws.lambda.function_version": {
        brief: "The version of the Lambda function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "$LATEST",
        deprecation: {
            replacement: "faas.version",
            reason: "Use the OTel-aligned faas.version attribute instead"
        },
        aliases: [
            "faas.version"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ],
                description: "Deprecated aws.lambda.function_version in favor of faas.version"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.function_version attribute"
            }
        ]
    },
    "aws.lambda.invoked_arn": {
        brief: "The full ARN of the Lambda function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:lambda:us-east-1:123456789012:function:my-function",
        aliases: [
            "aws.lambda.invoked_function_arn"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.lambda.invoked_function_arn": {
        brief: "The full ARN of the Lambda function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "arn:aws:lambda:us-east-1:123456789012:function:my-function",
        deprecation: {
            replacement: "aws.lambda.invoked_arn",
            reason: "This attribute is being deprecated in favor of aws.lambda.invoked_arn"
        },
        aliases: [
            "aws.lambda.invoked_arn"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ],
                description: "Deprecated aws.lambda.invoked_function_arn in favor of aws.lambda.invoked_arn"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.invoked_function_arn attribute"
            }
        ]
    },
    "aws.lambda.remaining_time_in_millis": {
        brief: "The remaining time in milliseconds before the Lambda function times out",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5e3,
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.remaining_time_in_millis attribute"
            }
        ]
    },
    "aws.log.group.names": {
        brief: "The name(s) of the AWS log group(s) an application is writing to.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "/aws/lambda/my-function",
            "opentelemetry-service"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.log.stream.names": {
        brief: "The name(s) of the AWS log stream(s) an application is writing to.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "logs/main/10838bed-421f-43ef-870a-f43feacbbb5b"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.request.extended_id": {
        brief: "The AWS extended request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wzHcyEWfmOGDIE5QOhTAqFDoDWP3y8IUvpNINCwL9N4TEHbUw0/gZJ+VZTmCNCWR7fezEN3eCiQ=",
        deprecation: {
            replacement: "aws.extended_request_id",
            reason: "This attribute is being deprecated in favor of aws.extended_request_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.extended_request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request.extended_id attribute, deprecated in favor of aws.extended_request_id"
            }
        ]
    },
    "aws.request_id": {
        brief: "The AWS request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "79b9da39-b7ae-508a-a6bc-864b2829c622",
        aliases: [
            "aws.request.id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request_id attribute"
            }
        ]
    },
    "aws.request.id": {
        brief: "The AWS request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "79b9da39-b7ae-508a-a6bc-864b2829c622",
        deprecation: {
            replacement: "aws.request_id",
            reason: "This attribute is being deprecated in favor of aws.request_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request.id attribute, deprecated in favor of aws.request_id"
            }
        ]
    },
    "aws.s3.bucket": {
        brief: "The S3 bucket name the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ot-demo-test",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.s3.bucket attribute"
            }
        ]
    },
    "aws.secretsmanager.secret.arn": {
        brief: "The ARN of the Secret stored in Secrets Manager.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:secretsmanager:us-east-1:123456789012:secret:SecretName-6RandomCharacters",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.secretsmanager.secret.arn attribute"
            }
        ]
    },
    "aws.sns.topic.arn": {
        brief: "The ARN of the AWS SNS Topic. An Amazon SNS topic is a logical access point that acts as a communication channel.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:sns:us-east-1:123456789012:mystack-mytopic-NZJ5JSMVGFIE",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.sns.topic.arn attribute"
            }
        ]
    },
    "aws.step_functions.activity.arn": {
        brief: "The ARN of the AWS Step Functions Activity.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:states:us-east-1:123456789012:activity:get-greeting",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.step_functions.activity.arn attribute"
            }
        ]
    },
    "aws.step_functions.state_machine.arn": {
        brief: "The ARN of the AWS Step Functions State Machine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:states:us-east-1:123456789012:stateMachine:myStateMachine:1",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.step_functions.state_machine.arn attribute"
            }
        ]
    },
    blocked_main_thread: {
        brief: "Whether the main thread was blocked by the span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.name": {
        brief: "The name of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Chrome",
        aliases: [
            "sentry.browser.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127,
                    139
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.performance.navigation.activation_start": {
        brief: "The time between initiating a navigation to a page and the browser activating the page",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.983,
        aliases: [
            "performance.activationStart"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added browser.performance.navigation.activation_start attribute"
            }
        ]
    },
    "browser.performance.time_origin": {
        brief: "The browser's performance.timeOrigin timestamp representing the time when the pageload was initiated",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1776185678886e-3,
        aliases: [
            "performance.timeOrigin"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added browser.performance.time_origin attribute attribute"
            }
        ]
    },
    "browser.report.type": {
        brief: "A browser report sent via reporting API..",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "network-error",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "browser.script.invoker": {
        brief: "How a script was called in the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Window.requestAnimationFrame",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.script.invoker_type": {
        brief: "Browser script entry point type.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "event-listener",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.script.source_char_position": {
        brief: "A number representing the script character position of the script.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 678,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.version": {
        brief: "The version of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.0.6099.130",
        aliases: [
            "sentry.browser.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    59,
                    127,
                    139
                ]
            }
        ]
    },
    "browser.web_vital.cls.report_event": {
        brief: "The event that caused the SDK to report CLS (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "navigation",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    319
                ],
                description: "Added browser.web_vital.cls.report_event attribute"
            }
        ]
    },
    "browser.web_vital.cls.source.<key>": {
        brief: "The HTML elements or components responsible for the layout shift. <key> is a numeric index from 1 to N",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "body > div#app",
        aliases: [
            "cls.source.<key>"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    234
                ]
            }
        ]
    },
    "browser.web_vital.cls.value": {
        brief: "The value of the recorded Cumulative Layout Shift (CLS) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .2361,
        aliases: [
            "cls"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.cls.value attribute"
            }
        ]
    },
    "browser.web_vital.fcp.value": {
        brief: "The time it takes for the browser to render the first piece of meaningful content on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 547.6951,
        aliases: [
            "fcp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.fp.value": {
        brief: "The time in milliseconds it takes for the browser to render the first pixel on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 477.1926,
        aliases: [
            "fp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.inp.value": {
        brief: "The value of the recorded Interaction to Next Paint (INP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        aliases: [
            "inp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.inp.value attribute"
            }
        ]
    },
    "browser.web_vital.lcp.element": {
        brief: "The HTML element selector or component name for which LCP was reported",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "body > div#app > div#container > div",
        aliases: [
            "lcp.element"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.id": {
        brief: "The id of the dom element responsible for the largest contentful paint",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#gero",
        aliases: [
            "lcp.id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.load_time": {
        brief: "The time it took for the LCP element to be loaded",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1402,
        aliases: [
            "lcp.loadTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.render_time": {
        brief: "The time it took for the LCP element to be rendered",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1685,
        aliases: [
            "lcp.renderTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.report_event": {
        brief: "The event that caused the SDK to report LCP (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pagehide",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    319
                ],
                description: "Added browser.web_vital.lcp.report_event attribute"
            }
        ]
    },
    "browser.web_vital.lcp.size": {
        brief: "The size of the largest contentful paint element",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1024,
        aliases: [
            "lcp.size"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.url": {
        brief: "The url of the dom element responsible for the largest contentful paint",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/static/img.png",
        aliases: [
            "lcp.url"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.value": {
        brief: "The value of the recorded Largest Contentful Paint (LCP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2500,
        aliases: [
            "lcp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.lcp.value attribute"
            }
        ]
    },
    "browser.web_vital.ttfb.request_time": {
        brief: "The time it takes for the server to process the initial request and send the first byte of a response to the user's browser",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1554.5814,
        aliases: [
            "ttfb.requestTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.ttfb.value": {
        brief: "The value of the recorded Time To First Byte (TTFB) web vital in Milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 194.3322,
        aliases: [
            "ttfb"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "cache.hit": {
        brief: "If the cache was hit during this span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.item_size": {
        brief: "The size of the requested item in the cache. In bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 58,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.key": {
        brief: "The key of the cache accessed.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "my-cache-key",
            "my-other-cache-key"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.operation": {
        brief: "The operation being performed on the cache.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "get",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.ttl": {
        brief: "The ttl of the cache in seconds",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 120,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.write": {
        brief: "If the cache operation resulted in a write to the cache.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    channel: {
        brief: "The channel name that is being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "mail",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "client.address": {
        brief: "Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        aliases: [
            "http.client_ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "client.port": {
        brief: "Client port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 5432,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.duration": {
        brief: "The duration of a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 543,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.query_type": {
        brief: "The type of query executed in a Cloudflare D1 operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "run",
        deprecation: {
            replacement: "db.operation.name"
        },
        aliases: [
            "db.operation.name",
            "db.operation"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.d1.query_type attribute"
            }
        ]
    },
    "cloudflare.d1.rows_read": {
        brief: "The number of rows read in a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.rows_written": {
        brief: "The number of rows written in a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.durable_object.query.bindings": {
        brief: "The number of bound parameters passed to the SQL exec call.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.query.bindings attribute"
            }
        ]
    },
    "cloudflare.durable_object.response.rows_read": {
        brief: "The number of rows read by a Cloudflare Durable Object SQL operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.response.rows_read attribute"
            }
        ]
    },
    "cloudflare.durable_object.response.rows_written": {
        brief: "The number of rows written by a Cloudflare Durable Object SQL operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.response.rows_written attribute"
            }
        ]
    },
    "cloudflare.r2.bucket": {
        brief: "The name of the Cloudflare R2 bucket binding",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MY_BUCKET",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.bucket attribute"
            }
        ]
    },
    "cloudflare.r2.operation": {
        brief: "The R2 API operation being performed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GetObject",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.operation attribute"
            }
        ]
    },
    "cloudflare.r2.request.delimiter": {
        brief: "The delimiter used to group objects in an R2 list operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.delimiter attribute"
            }
        ]
    },
    "cloudflare.r2.request.key": {
        brief: "The object key used in the R2 operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-file.txt",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.key attribute"
            }
        ]
    },
    "cloudflare.r2.request.part_number": {
        brief: "The part number in a multipart upload operation",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.part_number attribute"
            }
        ]
    },
    "cloudflare.r2.request.prefix": {
        brief: "The prefix used to filter objects in an R2 list operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "images/",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.prefix attribute"
            }
        ]
    },
    "cloudflare.workflow.attempt": {
        brief: "The current attempt number for a Cloudflare Workflow step",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.attempt attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.backoff": {
        brief: "The backoff strategy for Cloudflare Workflow step retries",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "exponential",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.backoff attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.delay": {
        brief: "The delay between Cloudflare Workflow step retries",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "5 seconds",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.delay attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.limit": {
        brief: "The maximum number of retries for a Cloudflare Workflow step",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.limit attribute"
            }
        ]
    },
    "cloudflare.workflow.timeout": {
        brief: "The timeout duration for a Cloudflare Workflow step",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1 minute",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.timeout attribute"
            }
        ]
    },
    "cloud.account.id": {
        brief: "The cloud account ID the resource is assigned to",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "123456789012",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.account.id attribute"
            }
        ]
    },
    "cloud.availability_zone": {
        brief: "Cloud regions often have multiple, isolated locations known as zones to increase availability",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "us-east-1c",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.availability_zone attribute"
            }
        ]
    },
    "cloud.platform": {
        brief: "The cloud platform in use",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws_lambda",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.platform attribute"
            }
        ]
    },
    "cloud.provider": {
        brief: "Name of the cloud provider",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.provider attribute"
            }
        ]
    },
    "cloud.region": {
        brief: "The geographical region the resource is running",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "us-east-1",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.region attribute"
            }
        ]
    },
    "cloud.resource_id": {
        brief: "Cloud provider-specific native identifier of the monitored cloud resource",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:lambda:REGION:ACCOUNT_ID:function:my-function",
        aliases: [
            "faas.id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    475
                ],
                description: "Added faas.id as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ],
        additionalContext: [
            "This can be an identifier for a resource in AWS, GCP, or Azure. There may be some overlap in values found here with other attributes. For instance, an AWS lambda ARN may be found here as well as in `aws.lambda.invoked_arn`. OTEL recommends setting them alongside each other."
        ]
    },
    cls: {
        brief: "The value of the recorded Cumulative Layout Shift (CLS) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .2361,
        deprecation: {
            replacement: "browser.web_vital.cls.value",
            reason: "The CLS web vital is now recorded as a browser.web_vital.cls.value attribute."
        },
        aliases: [
            "browser.web_vital.cls.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "cls.source.<key>": {
        brief: "The HTML elements or components responsible for the layout shift. <key> is a numeric index from 1 to N",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "body > div#app",
        deprecation: {
            replacement: "browser.web_vital.cls.source.<key>",
            reason: "The CLS source is now recorded as a browser.web_vital.cls.source.<key> attribute."
        },
        aliases: [
            "browser.web_vital.cls.source.<key>"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    234
                ]
            }
        ]
    },
    "code.filepath": {
        brief: "The source code file name that identifies the code unit as uniquely as possible (preferably an absolute file path).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/app/myapplication/http/handler/server.py",
        deprecation: {
            replacement: "code.file.path"
        },
        aliases: [
            "code.file.path"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.file.path": {
        brief: "The source code file name that identifies the code unit as uniquely as possible (preferably an absolute file path).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/app/myapplication/http/handler/server.py",
        aliases: [
            "code.filepath"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "code.function": {
        brief: "The method or function name, or equivalent (usually rightmost part of the code unit's name).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "server_request",
        aliases: [
            "code.function.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.function.name": {
        brief: "The method or function fully-qualified name without arguments.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "server_request",
        aliases: [
            "code.function"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.lineno": {
        brief: "The line number in code.filepath best representing the operation. It SHOULD point within the code unit named in code.function",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 42,
        deprecation: {
            replacement: "code.line.number"
        },
        aliases: [
            "code.line.number"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.line.number": {
        brief: "The line number in code.filepath best representing the operation. It SHOULD point within the code unit named in code.function",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 42,
        aliases: [
            "code.lineno"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.namespace": {
        brief: "The 'namespace' within which code.function is defined. Usually the qualified class or module name, such that code.namespace + some separator + code.function form a unique identifier for the code unit.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http.handler",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    connectionType: {
        brief: "Specifies the type of the current connection (e.g. wifi, ethernet, cellular , etc).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wifi",
        deprecation: {
            replacement: "network.connection.type",
            reason: "Old namespace-less attribute, to be replaced with network.connection.type for span-first future"
        },
        aliases: [
            "network.connection.type",
            "device.connection_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "connection.rtt": {
        brief: "Specifies the estimated effective round-trip time of the current connection, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        deprecation: {
            replacement: "network.connection.rtt",
            reason: "Old attribute name (no official namespace), to be replaced with network.connection.rtt for span-first future"
        },
        aliases: [
            "network.connection.rtt"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "culture.calendar": {
        brief: "The calendar system used by the culture.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GregorianCalendar",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.display_name": {
        brief: "Human readable name of the culture.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "English (United States)",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.is_24_hour_format": {
        brief: "Whether the culture uses 24-hour time format.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.locale": {
        brief: "The locale identifier following RFC 4646.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "en-US",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.timezone": {
        brief: "The timezone of the culture, as a geographic timezone identifier.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Europe/Vienna",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "db.collection.name": {
        brief: "The name of a collection (table, container) within the database.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "users",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.driver.name": {
        brief: "The name of the driver used for the database connection.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "psycopg2",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    297
                ],
                description: "Added db.driver.name attribute"
            }
        ]
    },
    "db.name": {
        brief: "The name of the database being accessed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "customers",
        deprecation: {
            replacement: "db.namespace"
        },
        aliases: [
            "db.namespace"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.namespace": {
        brief: "The name of the database being accessed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "customers",
        aliases: [
            "db.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.operation": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT",
        deprecation: {
            replacement: "db.operation.name"
        },
        aliases: [
            "db.operation.name",
            "cloudflare.d1.query_type"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.operation.batch.size": {
        brief: "The number of queries included in a batch operation. Operations are only considered batches when they contain two or more operations, and so db.operation.batch.size SHOULD never be 1.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    407
                ],
                description: "Added db.operation.batch.size attribute"
            }
        ]
    },
    "db.operation.name": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT",
        aliases: [
            "db.operation",
            "cloudflare.d1.query_type"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.query.parameter.<key>": {
        brief: "A query parameter used in db.query.text, with <key> being the parameter name, and the attribute value being a string representation of the parameter value.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "db.query.parameter.foo='123'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103,
                    127
                ]
            }
        ]
    },
    "db.query.summary": {
        brief: "A shortened representation of operation(s) in the full query. This attribute must be low-cardinality and should only contain the operation table names.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT users",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    208
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.query.text": {
        brief: "The database parameterized query being executed. Any parameter values (filters, insertion values, etc) should be replaced with parameter placeholders. If applicable, use `db.query.parameter.<key>` to add the parameter value.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT * FROM users WHERE id = $1",
        aliases: [
            "db.statement"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    208
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.redis.connection": {
        brief: "The redis connection name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-redis-instance",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.redis.key": {
        brief: "The key the Redis command is operating on.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user:2047:city",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    326
                ],
                description: "Added db.redis.key attribute"
            }
        ]
    },
    "db.redis.parameters": {
        brief: "The array of command parameters given to a redis command.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "test",
            "*"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "db.response.status_code": {
        brief: "Database response status code. The status code returned by the database. Usually it represents an error code, but may also represent partial success, warning, or differentiate between various types of successful outcomes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ORA-17002",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    462
                ],
                description: "Added db.response.status_code attribute"
            }
        ]
    },
    "db.sql.bindings": {
        brief: "The array of query bindings.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "1",
            "foo"
        ],
        deprecation: {
            replacement: "db.query.parameter.<key>",
            reason: "Instead of adding every binding in the db.sql.bindings attribute, add them as individual entires with db.query.parameter.<key>."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.statement": {
        brief: "The database statement being executed.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT * FROM users",
        deprecation: {
            replacement: "db.query.text"
        },
        aliases: [
            "db.query.text"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.stored_procedure.name": {
        brief: "The name of a stored procedure being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GetUserById",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    398
                ]
            }
        ]
    },
    "db.system": {
        brief: "An identifier for the database management system (DBMS) product being used. See [OpenTelemetry docs](https://github.com/open-telemetry/semantic-conventions/blob/main/docs/database/database-spans.md#notes-and-well-known-identifiers-for-dbsystem) for a list of well-known identifiers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "postgresql",
        deprecation: {
            replacement: "db.system.name"
        },
        aliases: [
            "db.system.name"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199,
                    224
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.system.name": {
        brief: "An identifier for the database management system (DBMS) product being used. See [OpenTelemetry docs](https://github.com/open-telemetry/semantic-conventions/blob/main/docs/database/database-spans.md#notes-and-well-known-identifiers-for-dbsystem) for a list of well-known identifiers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "postgresql",
        aliases: [
            "db.system"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.user": {
        brief: "The database user.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "fancy_user",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    deviceMemory: {
        brief: "The estimated total memory capacity of the device, only a rough estimation in gigabytes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "8 GB",
        deprecation: {
            replacement: "device.memory.estimated_capacity",
            reason: "Old namespace-less attribute, to be replaced with device.memory.estimated_capacity for span-first future"
        },
        aliases: [
            "device.memory.estimated_capacity"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "device.archs": {
        brief: "The CPU architectures of the device.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "arm64-v8a",
            "armeabi-v7a",
            "armeabi"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.archs attribute"
            }
        ]
    },
    "device.battery_level": {
        brief: "The battery level of the device as a percentage (0-100).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.battery_level attribute"
            }
        ]
    },
    "device.battery_temperature": {
        brief: "The battery temperature of the device in Celsius.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 25,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.battery_temperature attribute"
            }
        ]
    },
    "device.boot_time": {
        brief: "A formatted UTC timestamp when the system was booted.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2018-02-08T12:52:12Z",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.boot_time attribute"
            }
        ]
    },
    "device.brand": {
        brief: "The brand of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Apple",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.charging": {
        brief: "Whether the device was charging or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.charging attribute"
            }
        ]
    },
    "device.chipset": {
        brief: "The chipset of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Qualcomm SM8550",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.chipset attribute"
            }
        ]
    },
    "device.class": {
        brief: "The classification of the device. For example, `low`, `medium`, or `high`. Typically inferred by Relay - SDKs generally do not need to set this directly.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "medium",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.class attribute"
            }
        ]
    },
    "device.connection_type": {
        brief: "The internet connection type currently being used by the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wifi",
        deprecation: {
            replacement: "network.connection.type",
            reason: "This attribute is being deprecated in favor of network.connection.type"
        },
        aliases: [
            "network.connection.type",
            "connectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added and deprecated device.connection_type in favor of network.connection.type"
            }
        ]
    },
    "device.cpu_description": {
        brief: "A description of the CPU of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Intel(R) Core(TM)2 Quad CPU Q6600 @ 2.40GHz",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.cpu_description attribute"
            }
        ]
    },
    "device.external_free_storage": {
        brief: "External storage free size in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 67108864e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.external_free_storage attribute"
            }
        ]
    },
    "device.external_storage_size": {
        brief: "External storage total size in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 134217728e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.external_storage_size attribute"
            }
        ]
    },
    "device.family": {
        brief: "The family of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "iPhone",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.free_memory": {
        brief: "Free system memory in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2147483648,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.free_memory attribute"
            }
        ]
    },
    "device.free_storage": {
        brief: "Free device storage in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 107374182400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.free_storage attribute"
            }
        ]
    },
    "device.id": {
        brief: "Unique device identifier.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.id attribute"
            }
        ]
    },
    "device.locale": {
        brief: "The locale of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "en-US",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.locale attribute"
            }
        ]
    },
    "device.low_memory": {
        brief: "Whether the device was low on memory.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.low_memory attribute"
            }
        ]
    },
    "device.low_power_mode": {
        brief: "Whether the device is in Low Power Mode.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    314
                ],
                description: "Added device.low_power_mode attribute"
            }
        ]
    },
    "device.manufacturer": {
        brief: "The manufacturer of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Google",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.manufacturer attribute"
            }
        ]
    },
    "device.memory.estimated_capacity": {
        brief: "The estimated total memory capacity of the device, only a rough estimation in gigabytes. Browsers report estimations in buckets of powers of 2, mostly capped at 8 GB",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8,
        aliases: [
            "deviceMemory"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281
                ],
                description: "Added attribute device.memory.estimated_capacity to be used instead of deviceMemory"
            }
        ]
    },
    "device.memory_size": {
        brief: "Total system memory available in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 17179869184,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.memory_size attribute"
            }
        ]
    },
    "device.model": {
        brief: "The model of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "iPhone 15 Pro Max",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.model_id": {
        brief: "An internal hardware revision to identify the device exactly.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "N861AP",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.model_id attribute"
            }
        ]
    },
    "device.name": {
        brief: "The name of the device. On mobile, this is the user-assigned device name. On servers and desktops, this is typically the hostname.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "localhost",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.name attribute"
            }
        ]
    },
    "device.online": {
        brief: "Whether the device was online or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.online attribute"
            }
        ]
    },
    "device.orientation": {
        brief: 'The orientation of the device, either "portrait" or "landscape".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "portrait",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.orientation attribute"
            }
        ]
    },
    "device.processor_count": {
        brief: 'Number of "logical processors".',
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8,
        aliases: [
            "hardwareConcurrency"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added and deprecated attribute device.processor_count in favor of device.cpu.logical_core_count"
            }
        ]
    },
    "device.processor_frequency": {
        brief: "Processor frequency in MHz.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.processor_frequency attribute"
            }
        ]
    },
    "device.screen_density": {
        brief: "The screen density of the device.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2.625,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_density attribute"
            }
        ]
    },
    "device.screen_dpi": {
        brief: "The screen density in dots-per-inch (DPI) of the device.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 420,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_dpi attribute"
            }
        ]
    },
    "device.screen_height_pixels": {
        brief: "The height of the device screen in pixels.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_height_pixels attribute"
            }
        ]
    },
    "device.screen_width_pixels": {
        brief: "The width of the device screen in pixels.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1080,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_width_pixels attribute"
            }
        ]
    },
    "device.simulator": {
        brief: "Whether the device is a simulator or an actual device.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.simulator attribute"
            }
        ]
    },
    "device.storage_size": {
        brief: "Total device storage in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 274877906944,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.storage_size attribute"
            }
        ]
    },
    "device.thermal_state": {
        brief: "The thermal state of the device. Based on Apple's `ProcessInfo.ThermalState` enum: `nominal`, `fair`, `serious`, or `critical`.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "nominal",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.thermal_state attribute"
            }
        ]
    },
    "device.timezone": {
        brief: "The timezone of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Europe/Vienna",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.timezone attribute"
            }
        ]
    },
    "device.usable_memory": {
        brief: "Memory usable for the app in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2147483648,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.usable_memory attribute"
            }
        ]
    },
    dist: {
        brief: "The sentry dist.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        deprecation: {
            replacement: "sentry.dist",
            reason: "This attribute is being deprecated in favor of sentry.dist."
        },
        aliases: [
            "sentry.dist"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    489
                ],
                description: "Added dist attribute"
            }
        ]
    },
    effectiveConnectionType: {
        brief: "Specifies the estimated effective type of the current connection (e.g. slow-2g, 2g, 3g, 4g).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "4g",
        deprecation: {
            replacement: "network.connection.effective_type",
            reason: "Old namespace-less attribute, to be replaced with network.connection.effective_type for span-first future"
        },
        aliases: [
            "network.connection.effective_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    environment: {
        brief: "The sentry environment.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        aliases: [
            "sentry.environment"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "error.type": {
        brief: "Describes a class of error the operation ended with.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "timeout",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "event.id": {
        brief: "The unique identifier for this event (log record)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234567890,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    101
                ]
            }
        ]
    },
    "event.name": {
        brief: "The name that uniquely identifies this event (log record)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Process Payload",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    101,
                    127
                ]
            }
        ]
    },
    "exception.escaped": {
        brief: "SHOULD be set to true if the exception event is recorded at a point where it is known that the exception is escaping the scope of the span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.message": {
        brief: "The error message.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ENOENT: no such file or directory",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.stacktrace": {
        brief: "A stacktrace as a string in the natural representation for the language runtime. The representation is to be determined and documented by each language SIG.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: `Exception in thread "main" java.lang.RuntimeException: Test exception
 at com.example.GenerateTrace.methodB(GenerateTrace.java:13)
 at com.example.GenerateTrace.methodA(GenerateTrace.java:9)
 at com.example.GenerateTrace.main(GenerateTrace.java:5)`,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.type": {
        brief: "The type of the exception (its fully-qualified class name, if applicable). The dynamic type of the exception should be preferred over the static type in languages that support it.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "OSError",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.coldstart": {
        brief: "A boolean that is true if the serverless function is executed for the first time (aka cold-start).",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.cron": {
        brief: "A string containing the schedule period as Cron Expression.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "0/5 * * * ? *",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.duration_in_ms": {
        brief: "The duration a function took to run, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 120,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "faas.entry_point": {
        brief: "The code that's run when the cloud provider invokes your function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my_main_function",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403,
                    415
                ]
            }
        ]
    },
    "faas.execution": {
        brief: "The execution ID of the current function execution.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "af9d5aa4-a685-4c5f-a22b-444f80b3cc28",
        deprecation: {
            replacement: "faas.invocation_id",
            reason: "This attribute is being deprecated in favor of faas.invocation_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "faas.invocation_id",
            "aws.lambda.aws_request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution attribute, deprecated in favor of faas.invocation_id"
            }
        ]
    },
    "faas.id": {
        brief: "The unique ID of the single function that this runtime instance executes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "arn:aws:lambda:REGION:ACCOUNT_ID:function:my-function",
        deprecation: {
            replacement: "cloud.resource_id",
            reason: "This attribute is being deprecated in favor of cloud.resource_id, which is the OTel-aligned replacement (renamed in OTel semantic conventions v1.19.0)."
        },
        aliases: [
            "cloud.resource_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    475
                ],
                description: "Added faas.id attribute, deprecated in favor of cloud.resource_id"
            }
        ]
    },
    "faas.identity": {
        brief: "The Service Account (GCP), IAM Execution Role (AWS), or Managed Identity (Azure) used by the serverless function when interacting with other cloud services",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "name@project.iam.gserviceaccount.com (GCP), arn:aws:iam::123456789012:role/role-name (AWS), 00000000-0000-0000-0000-000000000000 (Azure)",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "faas.invocation_id": {
        brief: "The invocation ID of the current function invocation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "af9d5aa4-a685-4c5f-a22b-444f80b3cc28",
        aliases: [
            "aws.lambda.aws_request_id",
            "faas.execution"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ]
            }
        ]
    },
    "faas.invoked_name": {
        brief: "The name of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "my-function",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_name attribute"
            }
        ]
    },
    "faas.invoked_provider": {
        brief: "The cloud provider of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_provider attribute"
            }
        ]
    },
    "faas.invoked_region": {
        brief: "The cloud region of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "eu-central-1",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_region attribute"
            }
        ]
    },
    "faas.name": {
        brief: "The name of the serverless function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "my_function",
        aliases: [
            "aws.lambda.function_name"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403,
                    415
                ]
            }
        ]
    },
    "faas.time": {
        brief: "A string containing the function invocation time in the ISO 8601 format expressed in UTC.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2020-01-23T13:47:06Z",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.trigger": {
        brief: "Type of the trigger which caused this function invocation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "timer",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.version": {
        brief: "The version of the function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "$LATEST",
        aliases: [
            "aws.lambda.function_version"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ]
            }
        ]
    },
    fcp: {
        brief: "The time it takes for the browser to render the first piece of meaningful content on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 547.6951,
        deprecation: {
            replacement: "browser.web_vital.fcp.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.fcp.value"
        },
        aliases: [
            "browser.web_vital.fcp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "flag.evaluation.<key>": {
        brief: "An instance of a feature flag evaluation. The value of this attribute is the boolean representing the evaluation result. The <key> suffix is the name of the feature flag.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "flag.evaluation.is_new_ui=true",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    fp: {
        brief: "The time it takes for the browser to render the first pixel on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 477.1926,
        deprecation: {
            replacement: "browser.web_vital.fp.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.fp.value"
        },
        aliases: [
            "browser.web_vital.fp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "frames.delay": {
        brief: "The sum of all delayed frame durations in seconds during the lifetime of the span. For more information see [frames delay](https://develop.sentry.dev/sdk/performance/frames-delay/).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5,
        deprecation: {
            replacement: "app.vitals.frames.delay.value",
            reason: "Replaced by app.vitals.frames.delay.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.delay.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.delay.value"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "frames.frozen": {
        brief: "The number of frozen frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        deprecation: {
            replacement: "app.vitals.frames.frozen.count",
            reason: "Replaced by app.vitals.frames.frozen.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.frozen.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.frozen.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    frames_frozen_rate: {
        brief: "The rate of frozen frames, or `app_vitals.frames.frozen.count` divided by `app_vitals.frames.total.count`. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added frames_frozen_rate attribute"
            }
        ]
    },
    "frames.slow": {
        brief: "The number of slow frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        deprecation: {
            replacement: "app.vitals.frames.slow.count",
            reason: "Replaced by app.vitals.frames.slow.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.slow.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.slow.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    frames_slow_rate: {
        brief: "The rate of slow frames, or `app_vitals.frames.slow.count` divided by `app_vitals.frames.total.count`. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added frames_slow_rate attribute"
            }
        ]
    },
    "frames.total": {
        brief: "The number of total frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 60,
        deprecation: {
            replacement: "app.vitals.frames.total.count",
            reason: "Replaced by app.vitals.frames.total.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.total.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.total.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    fs_error: {
        brief: "The error message of a file system error.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ENOENT: no such file or directory",
        deprecation: {
            replacement: "error.type",
            reason: "This attribute is not part of the OpenTelemetry specification and error.type fits much better."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gcp.function.context.event_id": {
        brief: "The event ID from the legacy GCP Cloud Function context (1st gen)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.event_id attribute"
            }
        ]
    },
    "gcp.function.context.event_type": {
        brief: "The type of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "google.pubsub.topic.publish",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.event_type attribute"
            }
        ]
    },
    "gcp.function.context.id": {
        brief: "The unique event ID from the GCP CloudEvents context (2nd gen Cloud Functions)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.id attribute"
            }
        ]
    },
    "gcp.function.context.resource": {
        brief: "The resource that triggered the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "projects/my-project/topics/my-topic",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.resource attribute"
            }
        ]
    },
    "gcp.function.context.source": {
        brief: "The source of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "//pubsub.googleapis.com/projects/my-project/topics/my-topic",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.source attribute"
            }
        ]
    },
    "gcp.function.context.specversion": {
        brief: "The CloudEvents specification version of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.specversion attribute"
            }
        ]
    },
    "gcp.function.context.time": {
        brief: "The timestamp of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024-01-01T00:00:00.000Z",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.time attribute"
            }
        ]
    },
    "gcp.function.context.timestamp": {
        brief: "The legacy timestamp of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024-01-01T00:00:00.000Z",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.timestamp attribute"
            }
        ]
    },
    "gcp.function.context.type": {
        brief: "The type of the GCP Cloud Function event context",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cloud_functions.context",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.type attribute"
            }
        ]
    },
    "gcp.project.id": {
        brief: "The ID of the project in GCP that this resource is associated with",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-project-123",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "gen_ai.agent.name": {
        brief: "The name of the agent being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ResearchAssistant",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.context.utilization": {
        brief: "The fraction of the model context window utilized by this generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .75,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    315
                ],
                description: "Added gen_ai.context.utilization attribute"
            }
        ]
    },
    "gen_ai.context.window_size": {
        brief: "The maximum context window size supported by the model for this generation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 128e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    315
                ],
                description: "Added gen_ai.context.window_size attribute"
            }
        ]
    },
    "gen_ai.conversation.id": {
        brief: "The unique identifier for a conversation (session, thread), used to store and correlate messages within this conversation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "conv_5j66UpCpwteGg4YSxUnt7lPY",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    250
                ]
            }
        ]
    },
    "gen_ai.cost.cache_creation.input_tokens": {
        brief: "The cost of input tokens written to cache in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.cache_creation.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.cache_creation.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.cache_creation.input_tokens.",
            "This is a subset of gen_ai.cost.input_tokens, not an independent cost. Do not sum this with gen_ai.cost.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.cache_read.input_tokens": {
        brief: "The cost of cached input tokens in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.cache_read.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.cache_read.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.cache_read.input_tokens.",
            "This is a subset of gen_ai.cost.input_tokens, not an independent cost. Do not sum this with gen_ai.cost.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.input_tokens": {
        brief: "The total cost of all input tokens in USD (includes cached and cache creation tokens).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 123.45,
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.input_tokens.",
            "This is the total cost of all input tokens, including cached and cache creation tokens at their respective rates. For the cached portion, see gen_ai.cost.cache_read.input_tokens. For the cache creation portion, see gen_ai.cost.cache_creation.input_tokens."
        ]
    },
    "gen_ai.cost.output_tokens": {
        brief: "The total cost of all output tokens in USD (includes reasoning tokens).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 123.45,
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.output_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.output_tokens.",
            "This is the total cost of all output tokens, including reasoning tokens at their respective rate. For the reasoning portion, see gen_ai.cost.reasoning.output_tokens."
        ]
    },
    "gen_ai.cost.reasoning.output_tokens": {
        brief: "The cost of reasoning output tokens in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.reasoning.output_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.reasoning.output_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.reasoning.output_tokens.",
            "This is a subset of gen_ai.cost.output_tokens, not an independent cost. Do not sum this with gen_ai.cost.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.total_tokens": {
        brief: "The total cost for the tokens used.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        aliases: [
            "ai.total_cost"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    126
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.total_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.total_tokens."
        ]
    },
    "gen_ai.embeddings.input": {
        brief: "The input to the embeddings model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "What's the weather in Paris?",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    195
                ]
            }
        ]
    },
    "gen_ai.function_id": {
        brief: "Framework-specific tracing label for the execution of a function or other unit of execution in a generative AI system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-awesome-function",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    308
                ],
                description: "Added gen_ai.function_id attribute"
            }
        ]
    },
    "gen_ai.input.messages": {
        brief: 'The messages passed to the model. It has to be a stringified version of an array of objects. The `role` attribute of each object must be `"user"`, `"assistant"`, `"tool"`, or `"system"`. For messages of the role `"tool"`, the `content` can be a string or an arbitrary object with information about the tool call. For other messages the `content` can be either a string or a list of objects in the format `{type: "text", text:"..."}`.',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "user", "parts": [{"type": "text", "content": "Weather in Paris?"}]}, {"role": "assistant", "parts": [{"type": "tool_call", "id": "call_VSPygqKTWdrhaFErNvMV18Yl", "name": "get_weather", "arguments": {"location": "Paris"}}]}, {"role": "tool", "parts": [{"type": "tool_call_response", "id": "call_VSPygqKTWdrhaFErNvMV18Yl", "result": "rainy, 57\xB0F"}]}]',
        aliases: [
            "ai.texts"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.operation.name": {
        brief: "The name of the operation being performed. It has the following list of well-known values: 'chat', 'create_agent', 'embeddings', 'execute_tool', 'generate_content', 'invoke_agent', 'text_completion'. If one of them applies, then that value MUST be used. Otherwise a custom value MAY be used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "chat",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    225
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.operation.type": {
        brief: "The type of AI operation. Must be one of 'agent' (invoke_agent and create_agent spans), 'ai_client' (any LLM call), 'tool' (execute_tool spans), 'handoff' (handoff spans), 'other' (input and output processors, skill loading, guardrails etc.) . Added during ingestion based on span.op and gen_ai.operation.type. Used to filter and aggregate data in the UI",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "tool",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    257
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    113,
                    127
                ]
            }
        ]
    },
    "gen_ai.output.messages": {
        brief: "The model's response messages. It has to be a stringified version of an array of message objects, which can include text responses and tool calls.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "assistant", "parts": [{"type": "text", "content": "The weather in Paris is currently rainy with a temperature of 57\xB0F."}], "finish_reason": "stop"}]',
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.pipeline.name": {
        brief: "Name of the AI pipeline or chain being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Autofix Pipeline",
        aliases: [
            "ai.pipeline.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76,
                    127
                ]
            }
        ]
    },
    "gen_ai.prompt": {
        brief: "The input messages sent to the model",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        deprecation: {
            reason: "Deprecated from OTEL, use gen_ai.input.messages with the new format instead."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    74,
                    108,
                    119
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gen_ai.prompt.name": {
        brief: "The name of the prompt that uniquely identifies it.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Prompt names may reveal user behavior patterns or sensitive operations"
        },
        isInOtel: !0,
        visibility: "public",
        example: "summarize_text",
        aliases: [
            "mcp.prompt.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added gen_ai.prompt.name attribute"
            }
        ]
    },
    "gen_ai.provider.name": {
        brief: "The Generative AI provider as identified by the client or server instrumentation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "openai",
        aliases: [
            "ai.model.provider",
            "gen_ai.system"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            }
        ]
    },
    "gen_ai.request.available_tools": {
        brief: "The available tools for the model. It has to be a stringified version of an array of objects.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"name": "get_weather", "description": "Get the weather for a given location"}, {"name": "get_news", "description": "Get the news for a given topic"}]',
        deprecation: {
            replacement: "gen_ai.tool.definitions"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.frequency_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. The higher the value, the stronger a penalty is applied to previously present tokens, proportional to how many times they have already appeared in the prompt or prior generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .5,
        aliases: [
            "ai.frequency_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.max_tokens": {
        brief: "The maximum number of tokens to generate in the response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2048,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.request.messages": {
        brief: 'The messages passed to the model. It has to be a stringified version of an array of objects. The `role` attribute of each object must be `"user"`, `"assistant"`, `"tool"`, or `"system"`. For messages of the role `"tool"`, the `content` can be a string or an arbitrary object with information about the tool call. For other messages the `content` can be either a string or a list of objects in the format `{type: "text", text:"..."}`.',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "system", "content": "Generate a random number."}, {"role": "user", "content": [{"text": "Generate a random number between 0 and 10.", "type": "text"}]}, {"role": "tool", "content": {"toolCallId": "1", "toolName": "Weather", "output": "rainy"}}]',
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "ai.input_messages"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74,
                    108,
                    119,
                    122
                ]
            }
        ]
    },
    "gen_ai.request.model": {
        brief: "The model identifier being used for the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gpt-4-turbo-preview",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.presence_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. Similar to frequency_penalty, except that this penalty is applied equally to all tokens that have already appeared, regardless of their exact frequencies.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .5,
        aliases: [
            "ai.presence_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.reasoning_effort": {
        brief: "Constrains the effort on reasoning for reasoning models. Supported values vary by provider.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "high",
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    334
                ],
                description: "Added gen_ai.request.reasoning_effort attribute"
            }
        ]
    },
    "gen_ai.request.seed": {
        brief: "The seed, ideally models given the same seed and same other parameters will produce the exact same output.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1234567890",
        aliases: [
            "ai.seed"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.stop_sequences": {
        brief: "List of sequences that the model will use to stop generating further tokens.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "forest",
            "lived"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added gen_ai.request.stop_sequences attribute"
            }
        ]
    },
    "gen_ai.request.temperature": {
        brief: "For an AI model call, the temperature parameter. Temperature essentially means how random the output will be.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .1,
        aliases: [
            "ai.temperature"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.top_k": {
        brief: "Limits the model to only consider the K most likely next tokens, where K is an integer (e.g., top_k=20 means only the 20 highest probability tokens are considered).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 35,
        aliases: [
            "ai.top_k"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.top_p": {
        brief: "Limits the model to only consider tokens whose cumulative probability mass adds up to p, where p is a float between 0 and 1 (e.g., top_p=0.7 means only tokens that sum up to 70% of the probability mass are considered).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .7,
        aliases: [
            "ai.top_p"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.response.finish_reasons": {
        brief: "The reason why the model stopped generating.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "COMPLETE",
        aliases: [
            "ai.finish_reason"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.response.id": {
        brief: "Unique identifier for the completion.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gen_123abc",
        aliases: [
            "ai.generation_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.response.model": {
        brief: "The vendor-specific ID of the model used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gpt-4",
        aliases: [
            "ai.model_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gen_ai.response.streaming": {
        brief: "Whether or not the AI model call's response was streamed back asynchronously",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        aliases: [
            "ai.streaming"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76
                ]
            }
        ]
    },
    "gen_ai.response.text": {
        brief: "The model's response text messages. It has to be a stringified version of an array of response text messages.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '["The weather in Paris is rainy and overcast, with temperatures around 57\xB0F", "The weather in London is sunny and warm, with temperatures around 65\xB0F"]',
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.response.time_to_first_chunk": {
        brief: "Time in seconds when the first response content chunk arrived in streaming responses.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .6853435,
        aliases: [
            "gen_ai.response.time_to_first_token"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.response.time_to_first_chunk attribute"
            }
        ]
    },
    "gen_ai.response.time_to_first_token": {
        brief: "Time in seconds when the first response content chunk arrived in streaming responses.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .6853435,
        deprecation: {
            replacement: "gen_ai.response.time_to_first_chunk"
        },
        aliases: [
            "gen_ai.response.time_to_first_chunk"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.response.time_to_first_chunk"
            },
            {
                version: "0.4.0",
                prs: [
                    227
                ]
            }
        ]
    },
    "gen_ai.response.tokens_per_second": {
        brief: "The total output tokens per seconds throughput",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12345.67,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    66
                ]
            }
        ]
    },
    "gen_ai.response.tool_calls": {
        brief: "The tool calls in the model's response. It has to be a stringified version of an array of objects.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"name": "get_weather", "arguments": {"location": "Paris"}}]',
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.system": {
        brief: "The provider of the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "openai",
        deprecation: {
            replacement: "gen_ai.provider.name"
        },
        aliases: [
            "ai.model.provider",
            "gen_ai.provider.name"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.system_instructions": {
        brief: "The system instructions passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "You are a helpful assistant",
        aliases: [
            "ai.preamble"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.system.message": {
        brief: "The system instructions passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "You are a helpful assistant",
        deprecation: {
            replacement: "gen_ai.system_instructions"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.tool.call.arguments": {
        brief: "The arguments of the tool call. It has to be a stringified version of the arguments to the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '{"location": "Paris"}',
        aliases: [
            "gen_ai.tool.input"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.call.result": {
        brief: "The result of the tool call. It has to be a stringified version of the result of the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "rainy, 57\xB0F",
        aliases: [
            "gen_ai.tool.output",
            "gen_ai.tool.message",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.definitions": {
        brief: "The list of source system tool definitions available to the GenAI agent or model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"type": "function", "name": "get_current_weather", "description": "Get the current weather in a given location", "parameters": {"type": "object", "properties": {"location": {"type": "string", "description": "The city and state, e.g. San Francisco, CA"}, "unit": {"type": "string", "enum": ["celsius", "fahrenheit"]}}, "required": ["location", "unit"]}}]',
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.description": {
        brief: "The description of the tool being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Searches the web for current information about a topic",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.tool.input": {
        brief: "The input of the tool being used. It has to be a stringified version of the input to the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"location": "Paris"}',
        deprecation: {
            replacement: "gen_ai.tool.call.arguments"
        },
        aliases: [
            "gen_ai.tool.call.arguments"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.tool.message": {
        brief: "The response from a tool or function call passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rainy, 57\xB0F",
        deprecation: {
            replacement: "gen_ai.tool.call.result"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.output",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.tool.name": {
        brief: "Name of the tool utilized by the agent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Flights",
        aliases: [
            "ai.function_call",
            "mcp.tool.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.tool.output": {
        brief: "The output of the tool being used. It has to be a stringified version of the output of the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rainy, 57\xB0F",
        deprecation: {
            replacement: "gen_ai.tool.call.result"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.message",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.tool.type": {
        brief: "The type of tool being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "function",
        deprecation: {
            reason: "The gen_ai.tool.type attribute is deprecated and should no longer be set."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.usage.cache_creation.input_tokens": {
        brief: "The number of tokens written to the cache when processing the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 100,
        aliases: [
            "gen_ai.usage.input_tokens.cache_write"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.cache_creation.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.cache_read.input_tokens": {
        brief: "The number of cached tokens used to process the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 50,
        aliases: [
            "gen_ai.usage.input_tokens.cached"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.cache_read.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.input_tokens, not an independent count. Do not sum this with gen_ai.usage.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.completion_tokens": {
        brief: "The number of tokens used in the GenAI response (completion).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        deprecation: {
            replacement: "gen_ai.usage.output_tokens"
        },
        aliases: [
            "ai.completion_tokens.used",
            "gen_ai.usage.output_tokens"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.input_tokens": {
        brief: "The number of tokens used to process the AI input (prompt) including cached input tokens.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        aliases: [
            "ai.prompt_tokens.used",
            "gen_ai.usage.prompt_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Update additional_context to reference gen_ai.usage.cache_read.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    261
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This count includes cached input tokens. gen_ai.usage.cache_read.input_tokens is a subset of this value, not an independent count \u2014 do not sum them together."
        ]
    },
    "gen_ai.usage.input_tokens.cached": {
        brief: "The number of cached tokens used to process the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        deprecation: {
            replacement: "gen_ai.usage.cache_read.input_tokens"
        },
        aliases: [
            "gen_ai.usage.cache_read.input_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.cache_read.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.input_tokens, not an independent count. Do not sum this with gen_ai.usage.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.input_tokens.cache_write": {
        brief: "The number of tokens written to the cache when processing the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        deprecation: {
            replacement: "gen_ai.usage.cache_creation.input_tokens"
        },
        aliases: [
            "gen_ai.usage.cache_creation.input_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.cache_creation.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    217,
                    228
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.output_tokens": {
        brief: "The number of tokens used for creating the AI output (including reasoning tokens).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        aliases: [
            "ai.completion_tokens.used",
            "gen_ai.usage.completion_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Update additional_context to reference gen_ai.usage.reasoning.output_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    261
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This count includes reasoning tokens. gen_ai.usage.reasoning.output_tokens is a subset of this value, not an independent count \u2014 do not sum them together."
        ]
    },
    "gen_ai.usage.output_tokens.reasoning": {
        brief: "The number of tokens used for reasoning to create the AI output.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 75,
        deprecation: {
            replacement: "gen_ai.usage.reasoning.output_tokens"
        },
        aliases: [
            "gen_ai.usage.reasoning.output_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.reasoning.output_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.output_tokens, not an independent count. Do not sum this with gen_ai.usage.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.prompt_tokens": {
        brief: "The number of tokens used in the GenAI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 20,
        deprecation: {
            replacement: "gen_ai.usage.input_tokens"
        },
        aliases: [
            "ai.prompt_tokens.used",
            "gen_ai.usage.input_tokens"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.reasoning.output_tokens": {
        brief: "The number of tokens used for reasoning to create the AI output.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 75,
        aliases: [
            "gen_ai.usage.output_tokens.reasoning"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.reasoning.output_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.output_tokens, not an independent count. Do not sum this with gen_ai.usage.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.total_tokens": {
        brief: "The total number of tokens used to process the prompt. (input tokens plus output todkens)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 20,
        aliases: [
            "ai.total_tokens.used"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is the sum of gen_ai.usage.input_tokens and gen_ai.usage.output_tokens. Do not sum this with either of them \u2014 they are already included."
        ]
    },
    "graphql.document": {
        brief: "The GraphQL document being executed.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "The document may contain sensitive information in arguments or variables. Instrumentation should redact sensitive information when possible."
        },
        isInOtel: !0,
        visibility: "public",
        example: "query findBookById { bookById(id: ?) { name } }",
        changelog: [
            {
                version: "0.7.0",
                description: "Adds the `graphql.document` attribute to track the GraphQL document being executed."
            }
        ]
    },
    "graphql.operation.name": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "findBookById",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "graphql.operation.type": {
        brief: "The type of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "query",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    hardwareConcurrency: {
        brief: "The number of logical CPU cores available.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "14",
        deprecation: {
            replacement: "device.processor_count",
            reason: "Old namespace-less attribute, to be replaced with device.processor_count for span-first future"
        },
        aliases: [
            "device.processor_count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281,
                    300
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "http.client_ip": {
        brief: "Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "client.address"
        },
        aliases: [
            "client.address"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.decoded_response_content_length": {
        brief: "The decoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 456,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.flavor": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        deprecation: {
            replacement: "network.protocol.version"
        },
        aliases: [
            "network.protocol.version",
            "net.protocol.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.fragment": {
        brief: "The fragments present in the URI. Note that this contains the leading # character, while the `url.fragment` attribute does not.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#details",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "http.host": {
        brief: "The domain name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "Deprecated, use one of `server.address` or `client.address`, depending on the usage"
        },
        aliases: [
            "server.address",
            "client.address",
            "http.server_name",
            "net.host.name",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "http.request.method",
            "http.request_method",
            "method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.query": {
        brief: "The query string present in the URL. Note that this contains the leading ? character, while the `url.query` attribute does not.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Query string values can contain sensitive information. Clients should attempt to scrub parameters that might contain sensitive information."
        },
        isInOtel: !1,
        visibility: "public",
        example: "?foo=bar&bar=baz",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.body.data": {
        brief: "HTTP request body data. Can be given as string or structural data of any format.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    336
                ],
                description: "Added http.request.body.data attribute"
            }
        ]
    },
    "http.request.connection_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser finishes establishing the connection to the server to retrieve the resource. The timestamp value includes the time interval to establish the transport connection, as well as other time intervals such as TLS handshake and SOCKS authentication.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955515e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.connect_start": {
        brief: "The UNIX timestamp representing the time immediately before the user agent starts establishing the connection to the server to retrieve the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555111e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.domain_lookup_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser finishes the domain-name lookup for the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555201e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.domain_lookup_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts the domain name lookup for the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555322e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.fetch_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts to fetch the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555389e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.header.<key>": {
        brief: "HTTP request headers, <key> being the normalized HTTP Header name (lowercase), the value being the header values.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.request.header.custom-header=['foo', 'bar']",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    201,
                    204
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "http.request.method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GET",
        aliases: [
            "method",
            "http.method",
            "http.request_method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request_method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "method",
            "http.method",
            "http.request.method"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    343
                ],
                description: "Added http.request_method attribute"
            }
        ]
    },
    "http.request.redirect_end": {
        brief: "The UNIX timestamp representing the timestamp immediately after receiving the last byte of the response of the last redirect",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829558502e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    130,
                    134
                ]
            }
        ]
    },
    "http.request.redirect_start": {
        brief: "The UNIX timestamp representing the start time of the fetch which that initiates the redirect.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555495e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.request_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts requesting the resource from the server, cache, or local resource. If the transport connection fails and the browser retires the request, the value returned will be the start of the retry request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955551e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.resend_count": {
        brief: "The ordinal number of request resending attempt (for any reason, including redirects).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.response_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser receives the last byte of the resource or immediately before the transport connection is closed, whichever comes first.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955589e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.response_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts requesting the resource from the server, cache, or local resource. If the transport connection fails and the browser retires the request, the value returned will be the start of the retry request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 17328295557e-1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.same_origin": {
        brief: "Indicates that a URL has the same origin as the current page's origin in the browser.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        aliases: [
            "url.same_origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    456
                ],
                description: "Added http.request.same_origin attribute"
            }
        ]
    },
    "http.request.secure_connection_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts the handshake process to secure the current connection. If a secure connection is not used, the property returns zero.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955573e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.time_to_first_byte": {
        brief: "The time in seconds from the browser's timeorigin to when the first byte of the request's response was received. See https://web.dev/articles/ttfb#measure-resource-requests",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.032,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    131
                ]
            }
        ]
    },
    "http.request.worker_start": {
        brief: "The UNIX timestamp representing the timestamp immediately before dispatching the FetchEvent if a Service Worker thread is already running, or immediately before starting the Service Worker thread if it is not already running.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955368e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    130,
                    134
                ]
            }
        ]
    },
    "http.response.body.size": {
        brief: "The encoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 123,
        aliases: [
            "http.response_content_length",
            "http.response.header.content-length"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    106
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response_content_length": {
        brief: "The encoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 123,
        deprecation: {
            replacement: "http.response.body.size"
        },
        aliases: [
            "http.response.body.size",
            "http.response.header.content-length"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    106
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.header.content-length": {
        brief: "The size of the message body sent to the recipient (in bytes)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http.response.header.custom-header=['foo', 'bar']",
        aliases: [
            "http.response_content_length",
            "http.response.body.size"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.header.<key>": {
        brief: "HTTP response headers, <key> being the normalized HTTP Header name (lowercase), the value being the header values.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.response.header.custom-header=['foo', 'bar']",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    201,
                    204
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "http.response.size": {
        brief: "The transfer size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 456,
        aliases: [
            "http.response_transfer_size"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.status_code": {
        brief: "The status code of the HTTP response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 404,
        aliases: [
            "http.status_code"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response_transfer_size": {
        brief: "The transfer size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 456,
        deprecation: {
            replacement: "http.response.size"
        },
        aliases: [
            "http.response.size"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.route": {
        brief: "The matched route, that is, the path template in the format used by the respective server framework.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "url.template"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.scheme": {
        brief: "The URI scheme component identifying the used protocol.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https",
        deprecation: {
            replacement: "url.scheme"
        },
        aliases: [
            "url.scheme"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.server_name": {
        brief: "The server domain name",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address"
        },
        aliases: [
            "server.address",
            "net.host.name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.server.request.time_in_queue": {
        brief: "The time in milliseconds the request spent in the server queue before processing began. Measured from the X-Request-Start header set by reverse proxies (e.g., Nginx, HAProxy, Heroku) to when the application started handling the request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    267
                ]
            }
        ]
    },
    "http.status_code": {
        brief: "The status code of the HTTP response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 404,
        deprecation: {
            replacement: "http.response.status_code"
        },
        aliases: [
            "http.response.status_code"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.target": {
        brief: "The pathname and query string of the URL.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.path",
            reason: "This attribute is being deprecated in favor of url.path and url.query"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.url": {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.full"
        },
        aliases: [
            "url.full",
            "url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.user_agent": {
        brief: "Value of the HTTP User-Agent header sent by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1",
        deprecation: {
            replacement: "user_agent.original"
        },
        aliases: [
            "user_agent.original"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    id: {
        brief: "A unique identifier for the span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "f47ac10b58cc4372a5670e02b2c3d479",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    inp: {
        brief: "The value of the recorded Interaction to Next Paint (INP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        deprecation: {
            replacement: "browser.web_vital.inp.value",
            reason: "The INP web vital is now recorded as a browser.web_vital.inp.value attribute."
        },
        aliases: [
            "browser.web_vital.inp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "jsonrpc.protocol.version": {
        brief: "The version of the JSON-RPC protocol used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2.0",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added jsonrpc.protocol.version attribute"
            }
        ]
    },
    "jsonrpc.request.id": {
        brief: "The JSON-RPC request identifier. Unique within the session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1",
        aliases: [
            "mcp.request.id"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added jsonrpc.request.id attribute"
            }
        ]
    },
    "jvm.gc.action": {
        brief: "Name of the garbage collector action.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "end of minor GC",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.gc.name": {
        brief: "Name of the garbage collector.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Young Generation",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.memory.pool.name": {
        brief: "Name of the memory pool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Old Gen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.memory.type": {
        brief: "Name of the memory pool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Old Gen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.thread.daemon": {
        brief: "Whether the thread is daemon or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.thread.state": {
        brief: "State of the thread.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "blocked",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "koa.name": {
        brief: "The name of the Koa middleware or matched route that handled the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        deprecation: {
            reason: "No single replacement. SDKs should use http.route for router layers and code.function.name for middleware layers instead."
        },
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    490
                ],
                description: "Added koa.name attribute as deprecated"
            }
        ]
    },
    "koa.type": {
        brief: "The type of the Koa layer that handled the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "router",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    471
                ],
                description: "Added koa.type attribute"
            }
        ]
    },
    lcp: {
        brief: "The value of the recorded Largest Contentful Paint (LCP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2500,
        deprecation: {
            replacement: "browser.web_vital.lcp.value",
            reason: "The LCP web vital is now recorded as a browser.web_vital.lcp.value attribute."
        },
        aliases: [
            "browser.web_vital.lcp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "lcp.element": {
        brief: "The dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "img",
        deprecation: {
            replacement: "browser.web_vital.lcp.element",
            reason: "The LCP element is now recorded as a browser.web_vital.lcp.element attribute."
        },
        aliases: [
            "browser.web_vital.lcp.element"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.id": {
        brief: "The id of the dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#hero",
        deprecation: {
            replacement: "browser.web_vital.lcp.id",
            reason: "The LCP id is now recorded as a browser.web_vital.lcp.id attribute."
        },
        aliases: [
            "browser.web_vital.lcp.id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.loadTime": {
        brief: "The time it took for the LCP element to be loaded",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1402,
        deprecation: {
            replacement: "browser.web_vital.lcp.load_time",
            reason: "The LCP load time is now recorded as a browser.web_vital.lcp.load_time attribute."
        },
        aliases: [
            "browser.web_vital.lcp.load_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "lcp.renderTime": {
        brief: "The time it took for the LCP element to be rendered",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1685,
        deprecation: {
            replacement: "browser.web_vital.lcp.render_time",
            reason: "The LCP render time is now recorded as a browser.web_vital.lcp.render_time attribute."
        },
        aliases: [
            "browser.web_vital.lcp.render_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "lcp.size": {
        brief: "The size of the largest contentful paint element.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234,
        deprecation: {
            replacement: "browser.web_vital.lcp.size",
            reason: "The LCP size is now recorded as a browser.web_vital.lcp.size attribute."
        },
        aliases: [
            "browser.web_vital.lcp.size"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.url": {
        brief: "The url of the dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com",
        deprecation: {
            replacement: "browser.web_vital.lcp.url",
            reason: "The LCP url is now recorded as a browser.web_vital.lcp.url attribute."
        },
        aliases: [
            "browser.web_vital.lcp.url"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "logger.name": {
        brief: "The name of the logger that generated this event.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "myLogger",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "mcp.cancelled.reason": {
        brief: "Reason for the cancellation of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Cancellation reasons may contain user-specific or sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "User cancelled the request",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.cancelled.request_id": {
        brief: "Request ID of the cancelled MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.name": {
        brief: "Name of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "claude-desktop",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.title": {
        brief: "Display title of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Client titles may reveal user-specific application configurations or custom setups"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Claude Desktop",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.version": {
        brief: "Version of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.lifecycle.phase": {
        brief: "Lifecycle phase indicator for MCP operations.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "initialization_complete",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.data_type": {
        brief: "Data type of the logged message content.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "string",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.level": {
        brief: "Log level for MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "info",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.logger": {
        brief: "Logger name for MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Logger names may be user-defined and could contain sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "mcp_server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.message": {
        brief: "Log message content from MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Log messages can contain user data"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Tool execution completed successfully",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.method.name": {
        brief: "The name of the MCP request or notification method being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tools/call",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.current": {
        brief: "Current progress value of an MCP operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.message": {
        brief: "Progress message describing the current state of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Progress messages may contain user-specific or sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Processing 50 of 100 items",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.percentage": {
        brief: "Calculated progress percentage of an MCP operation. Computed from current/total * 100.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.token": {
        brief: "Token for tracking progress of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "progress-token-123",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.total": {
        brief: "Total progress target value of an MCP operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.name": {
        brief: "Name of the MCP prompt template being used.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Prompt names may reveal user behavior patterns or sensitive operations"
        },
        isInOtel: !1,
        visibility: "public",
        example: "summarize",
        deprecation: {
            replacement: "gen_ai.prompt.name",
            reason: "OTel uses gen_ai.prompt.name for MCP prompt names"
        },
        aliases: [
            "gen_ai.prompt.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.prompt.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.description": {
        brief: "Description of the prompt result.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "A summary of the requested information",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_content": {
        brief: "Content of the message in the prompt result. Used for single message results only.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Please provide a summary of the document",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_count": {
        brief: "Number of messages in the prompt result.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_role": {
        brief: "Role of the message in the prompt result. Used for single message results only.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.protocol.ready": {
        brief: "Protocol readiness indicator for MCP session. Non-zero value indicates the protocol is ready.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.protocol.version": {
        brief: "MCP protocol version used in the session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2024-11-05",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.argument.<key>": {
        brief: "MCP request argument with dynamic key suffix. The <key> is replaced with the actual argument name. The value is a JSON-stringified representation of the argument value.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Arguments contain user input"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "mcp.request.argument.query='weather in Paris'",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    176
                ]
            }
        ]
    },
    "mcp.request.argument.name": {
        brief: "Name argument from prompts/get MCP request.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Prompt names can contain user input"
        },
        isInOtel: !1,
        visibility: "public",
        example: "summarize",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.argument.uri": {
        brief: "URI argument from resources/read MCP request.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "URIs can contain user file paths"
        },
        isInOtel: !1,
        visibility: "public",
        example: "file:///path/to/resource",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.id": {
        brief: "JSON-RPC request identifier for the MCP request. Unique within the MCP session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        deprecation: {
            replacement: "jsonrpc.request.id",
            reason: "OTel models MCP as JSON-RPC, uses jsonrpc.request.id"
        },
        aliases: [
            "jsonrpc.request.id"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of jsonrpc.request.id"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.resource.protocol": {
        brief: "Protocol of the resource URI being accessed, extracted from the URI.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "file",
        deprecation: {
            replacement: "network.protocol.name",
            reason: "OTel uses the generic network.protocol.name attribute"
        },
        aliases: [
            "network.protocol.name",
            "net.protocol.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of network.protocol.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.resource.uri": {
        brief: "The resource URI being accessed in an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "URIs can contain sensitive file paths"
        },
        isInOtel: !0,
        visibility: "public",
        example: "file:///path/to/file.txt",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.name": {
        brief: "Name of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sentry-mcp-server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.title": {
        brief: "Display title of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Server titles may reveal user-specific application configurations or custom setups"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Sentry MCP Server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.version": {
        brief: "Version of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "0.1.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.session.id": {
        brief: "Identifier for the MCP session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "550e8400-e29b-41d4-a716-446655440000",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.name": {
        brief: "Name of the MCP tool being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "calculator",
        deprecation: {
            replacement: "gen_ai.tool.name",
            reason: "OTel uses gen_ai.tool.name for MCP tool names"
        },
        aliases: [
            "gen_ai.tool.name",
            "ai.function_call"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.tool.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.result.content": {
        brief: "The content of the tool result.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Tool results can contain user data"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"output": "rainy", "toolCallId": "1"}',
        deprecation: {
            replacement: "gen_ai.tool.call.result",
            reason: "OTel uses gen_ai.tool.call.result for MCP tool results"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.message",
            "gen_ai.tool.output"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.tool.call.result"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    164
                ]
            }
        ]
    },
    "mcp.tool.result.content_count": {
        brief: "Number of content items in the tool result.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.result.is_error": {
        brief: "Whether a tool execution resulted in an error.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        deprecation: {
            replacement: "error.type",
            reason: "OTel uses error.type set to 'tool_error' when isError is true. Cannot be automatically backfilled due to type mismatch (boolean vs string)."
        },
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of error.type"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.transport": {
        brief: "Transport method used for MCP communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stdio",
        deprecation: {
            replacement: "network.transport",
            reason: "OTel uses the generic network.transport attribute"
        },
        aliases: [
            "network.transport",
            "net.transport"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of network.transport"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mdc.<key>": {
        brief: "Attributes from the Mapped Diagnostic Context (MDC) present at the moment the log record was created. The MDC is supported by all the most popular logging solutions in the Java ecosystem, and it's usually implemented as a thread-local map that stores context for e.g. a specific request.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "mdc.some_key='some_value'",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    176
                ]
            }
        ]
    },
    "messaging.batch.message_count": {
        brief: "The number of messages sent, received, or processed in the scope of the batching operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    341
                ],
                description: "Added messaging.batch.message_count attribute"
            }
        ]
    },
    "messaging.destination": {
        brief: "The message destination name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "BestTopic",
        deprecation: {
            replacement: "messaging.destination.name",
            reason: "This attribute is being deprecated in favor of messaging.destination.name, which is the OTel-aligned replacement."
        },
        aliases: [
            "messaging.destination.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added messaging.destination attribute, deprecated in favor of messaging.destination.name"
            }
        ]
    },
    "messaging.destination.connection": {
        brief: "The message destination connection.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "BestTopic",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.destination.name": {
        brief: "The message destination name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "BestTopic",
        aliases: [
            "messaging.destination"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added messaging.destination as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.body.size": {
        brief: "The size of the message body in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 839,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.conversation_id": {
        brief: 'The conversation ID identifying the conversation to which the message belongs, represented as a string. Sometimes called "Correlation ID".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "MyConversationId",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added messaging.message.conversation_id attribute"
            }
        ]
    },
    "messaging.message.envelope.size": {
        brief: "The size of the message body and metadata in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1045,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.id": {
        brief: "A value used by the messaging system as an identifier for the message, represented as a string.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "f47ac10b58cc4372a5670e02b2c3d479",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.receive.latency": {
        brief: "The latency between when the message was published and received.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732847252,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.retry.count": {
        brief: "The amount of attempts to send the message.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.operation.name": {
        brief: "The name of the messaging operation being performed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "send",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added messaging.operation.name attribute"
            }
        ]
    },
    "messaging.operation.type": {
        brief: "A string identifying the type of the messaging operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "create",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    51,
                    127
                ]
            }
        ]
    },
    "messaging.rabbitmq.destination.routing_key": {
        brief: "RabbitMQ message routing key.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "myKey",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added messaging.rabbitmq.destination.routing_key attribute"
            }
        ]
    },
    "messaging.system": {
        brief: "The messaging system as identified by the client instrumentation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "activemq",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    method: {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "http.request.method",
            "http.request_method",
            "http.method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "middleware.name": {
        brief: "The name of the middleware.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AuthenticationMiddleware",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    336
                ],
                description: "Added middleware.name attribute"
            }
        ]
    },
    "navigation.origin": {
        brief: "The origin of the navigation (usually client side router navigations). Should preferrably parameterized template (like url.template) or a URL path otherwise.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "sentry.sveltekit.navigation.from"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added navigation.origin attribute"
            }
        ]
    },
    "navigation.route.id": {
        brief: "The identifier of the matched client-side route, as assigned by the routing framework (e.g., vue-router name, react-router id).",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AboutView",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added navigation.route.id attribute"
            }
        ]
    },
    "navigation.type": {
        brief: "The type of navigation done by a client-side router.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "router.push",
        aliases: [
            "sentry.sveltekit.navigation.type"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added new deprecated alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "nel.elapsed_time": {
        brief: "The elapsed number of milliseconds between the start of the resource fetch and when it was completed or aborted by the user agent.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            }
        ]
    },
    "nel.phase": {
        brief: 'If request failed, the phase of its network error. If request succeeded, "application".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "application",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "nel.referrer": {
        brief: "request's referrer, as determined by the referrer policy associated with its client.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/foo?bar=baz",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "nel.sampling_function": {
        brief: "The sampling function used to determine if the request should be sampled.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            }
        ]
    },
    "nel.type": {
        brief: 'If request failed, the type of its network error. If request succeeded, "ok".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dns.unreachable",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "network.connection.effective_type": {
        brief: "Specifies the effective type of the current connection (e.g. slow-2g, 2g, 3g, 4g).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "4g",
        aliases: [
            "effectiveConnectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.effective_type to be used instead of effectiveConnectionType"
            }
        ]
    },
    "network.connection.rtt": {
        brief: "Specifies the estimated effective round-trip time of the current connection, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        aliases: [
            "connection.rtt"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.rtt to be used instead of connection.rtt"
            }
        ]
    },
    "network.connection.type": {
        brief: "Specifies the type of the current connection (e.g. wifi, ethernet, cellular , etc).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "wifi",
        aliases: [
            "device.connection_type",
            "connectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.type to be used instead of connectionType"
            }
        ]
    },
    "network.local.address": {
        brief: "Local address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "10.1.2.80",
        aliases: [
            "net.host.ip",
            "net.sock.host.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.local.port": {
        brief: "Local port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 65400,
        aliases: [
            "net.sock.host.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.peer.address": {
        brief: "Peer address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "10.1.2.80",
        aliases: [
            "net.peer.ip",
            "net.sock.peer.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.peer.port": {
        brief: "Peer port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 65400,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.protocol.name": {
        brief: "OSI application layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http",
        aliases: [
            "net.protocol.name",
            "mcp.resource.protocol"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.protocol.version": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        aliases: [
            "http.flavor",
            "net.protocol.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.transport": {
        brief: "OSI transport layer or inter-process communication method.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tcp",
        aliases: [
            "net.transport",
            "mcp.transport"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.type": {
        brief: "OSI network layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ipv4",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.ip": {
        brief: "Local address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.local.address"
        },
        aliases: [
            "network.local.address",
            "net.sock.host.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.name": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address"
        },
        aliases: [
            "server.address",
            "http.server_name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        deprecation: {
            replacement: "server.port"
        },
        aliases: [
            "server.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.ip": {
        brief: "Peer address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.peer.address"
        },
        aliases: [
            "network.peer.address",
            "net.sock.peer.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.name": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "Deprecated, use server.address on client spans and client.address on server spans."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.port": {
        brief: "Peer port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        deprecation: {
            replacement: "server.port",
            reason: "Deprecated, use server.port on client spans and client.port on server spans."
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.protocol.name": {
        brief: "OSI application layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http",
        deprecation: {
            replacement: "network.protocol.name"
        },
        aliases: [
            "network.protocol.name",
            "mcp.resource.protocol"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.protocol.version": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        deprecation: {
            replacement: "network.protocol.version"
        },
        aliases: [
            "network.protocol.version",
            "http.flavor"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.family": {
        brief: "OSI transport and network layer",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "inet",
        deprecation: {
            replacement: "network.transport",
            reason: "Deprecated, use network.transport and network.type."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.host.addr": {
        brief: "Local address of the network connection mapping to Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/var/my.sock",
        deprecation: {
            replacement: "network.local.address"
        },
        aliases: [
            "network.local.address",
            "net.host.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.host.port": {
        brief: "Local port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 8080,
        deprecation: {
            replacement: "network.local.port"
        },
        aliases: [
            "network.local.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.addr": {
        brief: "Peer address of the network connection - IP address",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.peer.address"
        },
        aliases: [
            "network.peer.address",
            "net.peer.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.name": {
        brief: "Peer address of the network connection - Unix domain socket name",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/var/my.sock",
        deprecation: {
            reason: "Deprecated from OTEL, no replacement at this time"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    119,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.port": {
        brief: "Peer port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 8080,
        deprecation: {
            replacement: "network.peer.port"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.transport": {
        brief: "OSI transport layer or inter-process communication method.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tcp",
        deprecation: {
            replacement: "network.transport"
        },
        aliases: [
            "network.transport",
            "mcp.transport"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.build": {
        brief: "The build ID of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        deprecation: {
            replacement: "os.build_id"
        },
        aliases: [
            "os.build_id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.build attribute, deprecated in favor of os.build_id"
            }
        ]
    },
    "os.build_id": {
        brief: "The build ID of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1234567890",
        aliases: [
            "os.build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.build as alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.description": {
        brief: "Human readable (not intended to be parsed) OS version information, like e.g. reported by ver or lsb_release -a commands.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Ubuntu 18.04.1 LTS",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.kernel_version": {
        brief: "An independent kernel version string. Typically the entire output of the `uname` syscall.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "20.2.0",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.kernel_version attribute"
            }
        ]
    },
    "os.name": {
        brief: "Human readable operating system name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Ubuntu",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.raw_description": {
        brief: "An unprocessed description string obtained by the operating system. For some well-known runtimes, Sentry will attempt to parse `name` and `version` from this string, if they are not explicitly given.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Ubuntu 22.04.4 LTS (Jammy Jellyfish)",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.raw_description attribute"
            }
        ]
    },
    "os.rooted": {
        brief: "Whether the operating system has been jailbroken or rooted.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.rooted attribute"
            }
        ]
    },
    "os.theme": {
        brief: "Whether the OS runs in dark mode or light mode.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dark",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.theme attribute"
            }
        ]
    },
    "os.type": {
        brief: "The operating system type.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "linux",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.version": {
        brief: "The version of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "18.04.2",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.kind": {
        brief: "The span kind (https://opentelemetry.io/docs/concepts/signals/traces/#span-kind). Deprecated, use `sentry.kind` instead.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SERVER",
        deprecation: {
            replacement: "sentry.kind",
            reason: "Deprecated in favor of sentry.kind"
        },
        aliases: [
            "sentry.kind"
        ],
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    440
                ],
                description: "Added otel.kind attribute"
            }
        ]
    },
    "otel.scope.name": {
        brief: "The name of the instrumentation scope - (InstrumentationScope.Name in OTLP).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "io.opentelemetry.contrib.mongodb",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.scope.version": {
        brief: "The version of the instrumentation scope - (InstrumentationScope.Version in OTLP).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2.4.5",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.status_code": {
        brief: "Name of the code, either \u201COK\u201D or \u201CERROR\u201D. MUST NOT be set if the status code is UNSET.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "OK",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.status_description": {
        brief: "Description of the Status if it has a value, otherwise not set.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "resource not found",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "params.<key>": {
        brief: "Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "params.id='123'",
        aliases: [
            "url.path.parameter.<key>"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "performance.activationStart": {
        brief: "The time between initiating a navigation to a page and the browser activating the page",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.983,
        deprecation: {
            replacement: "browser.performance.navigation.activation_start",
            reason: "The activationStart is now recorded as the browser.performance.navigation.activation_start attribute."
        },
        aliases: [
            "browser.performance.navigation.activation_start"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added performance.activationStart attribute"
            }
        ]
    },
    "performance.timeOrigin": {
        brief: "The browser's performance.timeOrigin timestamp representing the time when the pageload was initiated",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1776185678886e-3,
        deprecation: {
            replacement: "browser.performance.time_origin",
            reason: "The timeOrigin is now recorded as the browser.performance.time_origin attribute."
        },
        aliases: [
            "browser.performance.time_origin"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added performance.timeOrigin attribute"
            }
        ]
    },
    previous_route: {
        brief: "Also used by mobile SDKs to indicate the previous route in the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "HomeScreen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.command_args": {
        brief: "All the command arguments (including the command/executable itself) as received by the process.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "cmd/otecol",
            "--config=config.yaml"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    327
                ],
                description: "Added process.command_args attribute"
            }
        ]
    },
    "process.executable.name": {
        brief: "The name of the executable that started the process.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "getsentry",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.pid": {
        brief: "The process ID of the running process.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 12345,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.description": {
        brief: "An additional description about the runtime of the process, for example a specific vendor customization of the runtime environment. Equivalent to `raw_description` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Eclipse OpenJ9 VM openj9-0.21.0",
        aliases: [
            "runtime.raw_description"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.engine.name": {
        brief: "The name of the runtime engine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "v8",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.engine.version": {
        brief: "The version of the runtime engine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "12.9.202.13-rusty",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.name": {
        brief: "The name of the runtime. Equivalent to `name` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "node",
        aliases: [
            "runtime.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.version": {
        brief: "The version of the runtime of this process, as returned by the runtime without modification. Equivalent to `version` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "18.04.2",
        aliases: [
            "runtime.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "query.<key>": {
        brief: "An item in a query string. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "query.id='123'",
        deprecation: {
            replacement: "url.query",
            reason: "Instead of sending items individually in query.<key>, they should be sent all together with url.query."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "react.version": {
        brief: "The version of the React framework",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18.2.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    368
                ],
                description: "Added react.version attribute"
            }
        ]
    },
    release: {
        brief: "The sentry release.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.release"
        },
        aliases: [
            "sentry.release"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "remix.action_form_data.<key>": {
        brief: "Remix form data, <key> being the form data key, the value being the form data value.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.response.header.text='test'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    replay_id: {
        brief: "The id of the sentry replay.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        deprecation: {
            replacement: "sentry.replay_id"
        },
        aliases: [
            "sentry.replay_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "resource.deployment.environment": {
        brief: "The software deployment environment name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    266
                ]
            }
        ]
    },
    "resource.deployment.environment.name": {
        brief: "The software deployment environment name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    196
                ]
            }
        ]
    },
    "resource.render_blocking_status": {
        brief: "The render blocking status of the resource.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "non-blocking",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    route: {
        brief: "The matched route, that is, the path template in the format used by the respective server framework. Also used by mobile SDKs to indicate the current route in the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "App\\Controller::indexAction",
        deprecation: {
            replacement: "http.route"
        },
        aliases: [
            "http.route"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.grpc.status_code": {
        brief: "The numeric status code of the gRPC request.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.method": {
        brief: "The fully-qualified logical name of the method from the RPC interface perspective.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "com.example.ExampleService/exampleMethod",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    351
                ],
                description: "Added rpc.method attribute"
            }
        ]
    },
    "rpc.response.status_code": {
        brief: "Status code of the RPC returned by the RPC server or generated by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "DEADLINE_EXCEEDED",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    352
                ],
                description: "Added rpc.response.status_code attribute"
            }
        ]
    },
    "rpc.service": {
        brief: "The full (logical) name of the service being called, including its package name, if applicable.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "myService.BestService",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.system": {
        brief: "A string identifying the remoting system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws-api",
        deprecation: {
            replacement: "rpc.system.name",
            reason: "This attribute is being deprecated in favor of rpc.system.name, which is the OTel-aligned replacement."
        },
        aliases: [
            "rpc.system.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added rpc.system attribute, deprecated in favor of rpc.system.name"
            }
        ]
    },
    "rpc.system.name": {
        brief: "A string identifying the remoting system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws-api",
        aliases: [
            "rpc.system"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added rpc.system.name attribute"
            }
        ]
    },
    "runtime.build": {
        brief: "The application build string, when it is separate from the version.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stable",
        deprecation: {
            reason: "The runtime.* namespace is deprecated in favor of process.runtime.*. No direct OTel equivalent exists for this attribute."
        },
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.build attribute"
            }
        ]
    },
    "runtime.name": {
        brief: "The name of the runtime. For example node, CPython, or rustc.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "node",
        deprecation: {
            replacement: "process.runtime.name",
            reason: "Prefer OTel-aligned process.runtime.name"
        },
        aliases: [
            "process.runtime.name"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.name attribute in favor of process.runtime.name"
            }
        ]
    },
    "runtime.raw_description": {
        brief: "Unprocessed description string as obtained from the runtime. Used to extract name and version for well-known runtimes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Eclipse OpenJ9 VM openj9-0.21.0",
        deprecation: {
            replacement: "process.runtime.description",
            reason: "Prefer OTel-aligned process.runtime.description"
        },
        aliases: [
            "process.runtime.description"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.raw_description attribute in favor of process.runtime.description"
            }
        ]
    },
    "runtime.version": {
        brief: "The version of the runtime.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18.04.2",
        deprecation: {
            replacement: "process.runtime.version",
            reason: "Prefer OTel-aligned process.runtime.version"
        },
        aliases: [
            "process.runtime.version"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.version attribute in favor of process.runtime.version"
            }
        ]
    },
    "score.<key>": {
        brief: "The weighted performance score for a web vital. This is defined as `score.weight.<key>` * `score.ratio.<key>`.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.cls=0.1723",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.<key> attribute"
            }
        ]
    },
    "score.ratio.<key>": {
        brief: "The score for a web vital, normalized to a number between 0 and 1.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.ratio.inp=0.7748",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.ratio.<key> attribute"
            }
        ]
    },
    "score.total": {
        brief: "The total performance score of a span. This is the sum of individual weighted web vital scores (see `score.<key>`).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.total attribute"
            }
        ]
    },
    "score.weight.<key>": {
        brief: "The relative weight of a web vital in a span's performance score.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.weight.fcp=0.25",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.weight.<key> attribute"
            }
        ]
    },
    "sentry.action": {
        brief: "Used as a generic attribute representing the action depending on the type of span. For instance, this is the database query operation for DB spans, and the request method for HTTP spans.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.browser.name": {
        brief: "The name of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Chrome",
        deprecation: {
            replacement: "browser.name"
        },
        aliases: [
            "browser.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    139
                ]
            }
        ]
    },
    "sentry.browser.version": {
        brief: "The version of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.0.6099.130",
        deprecation: {
            replacement: "browser.version"
        },
        aliases: [
            "browser.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    139
                ]
            }
        ]
    },
    "sentry.cancellation_reason": {
        brief: "The reason why a span ended early.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "document.hidden",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.category": {
        brief: "The high-level category of a span, derived from the span operation or span attributes. This categorizes spans by their general purpose (e.g., database, HTTP, UI). Known values include: 'ai', 'ai.pipeline', 'app', 'browser', 'cache', 'console', 'db', 'event', 'file', 'function.aws', 'function.azure', 'function.gcp', 'function.nextjs', 'function.remix', 'graphql', 'grpc', 'http', 'measure', 'middleware', 'navigation', 'pageload', 'queue', 'resource', 'rpc', 'serialize', 'subprocess', 'template', 'topic', 'ui', 'ui.angular', 'ui.ember', 'ui.react', 'ui.svelte', 'ui.vue', 'view', 'websocket'.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "db",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    218
                ]
            }
        ]
    },
    "sentry.client_sample_rate": {
        brief: "Rate at which a span was sampled in the SDK.",
        type: "double",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    102
                ]
            }
        ]
    },
    "sentry.description": {
        brief: "The human-readable description of a span.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "index view query",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    135
                ]
            }
        ]
    },
    "sentry.dist": {
        brief: "The sentry dist.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        aliases: [
            "dist"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    489
                ],
                description: "Added dist as an alias"
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.domain": {
        brief: "Used as a generic attribute representing the domain depending on the type of span. For instance, this is the collection/table name for database spans, and the server address for HTTP spans.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "example.com",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.dsc.environment": {
        brief: "The environment from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "prod",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.project_id": {
        brief: "The ID of the project where the trace originated (i.e. the project of the SDK that started the trace). Propagated through the dynamic sampling context and set by Relay during ingestion.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "12345",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    358
                ],
                description: "Add sentry.dsc.project_id as an attribute"
            }
        ]
    },
    "sentry.dsc.public_key": {
        brief: "The public key from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "c51734c603c4430eb57cb0a5728a479d",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.release": {
        brief: "The release identifier from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "frontend@e8211be71b214afab5b85de4b4c54be3714952bb",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.sampled": {
        brief: "Whether the event was sampled according to the dynamic sampling context.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: !0,
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.sample_rate": {
        brief: "The sample rate from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "1.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.trace_id": {
        brief: "The trace ID from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "047372980460430cbc78d9779df33a46",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.transaction": {
        brief: "The transaction name from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "/issues/errors-outages/",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.environment": {
        brief: "The sentry environment.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        aliases: [
            "environment"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.exclusive_time": {
        brief: "The exclusive time duration of the span in milliseconds.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    160
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.graphql.operation": {
        brief: "Indicates the type of graphql operation, emitted by the Javascript SDK.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "getUserById",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.group": {
        brief: "Stores the hash of `sentry.normalized_description`. This is primarily used for grouping spans in the product end.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.http.prefetch": {
        brief: "If an http request was a prefetch request.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.idle_span_finish_reason": {
        brief: "The reason why an idle span ended early.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "idleTimeout",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.is_remote": {
        brief: "Indicates whether a span's parent is remote.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.kind": {
        brief: "Used to clarify the relationship between parents and children, or to distinguish between spans, e.g. a `server` and `client` span with the same name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "server",
        aliases: [
            "otel.kind"
        ],
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.main_thread": {
        brief: "Whether the span or event occurred on the main thread. Computed by Relay and should not be set by SDKs.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.message.parameter.<key>": {
        brief: "A parameter used in the message template. <key> can either be the number that represent the parameter's position in the template string (sentry.message.parameter.0, sentry.message.parameter.1, etc) or the parameter's name (sentry.message.parameter.item_id, sentry.message.parameter.user_id, etc)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sentry.message.parameter.0='123'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.message.template": {
        brief: "The parameterized template string.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Hello, {name}!",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.metric.source": {
        brief: "The provenance of a metric.  For example, this can be set to indicate if a metric was generated by Relay from a span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "span",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    476
                ],
                description: "Added sentry.metric.source attribute"
            }
        ]
    },
    "sentry.mobile": {
        brief: "Whether the application is using a mobile SDK. Computed by Relay and should not be set by SDKs.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.module.<key>": {
        brief: "A module that was loaded in the process. The key is the name of the module.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "sentry.module.brianium/paratest='v7.7.0'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "sentry.nextjs.ssr.function.route": {
        brief: "A parameterized route for a function in Next.js that contributes to Server-Side Rendering. Should be present on spans that track such functions when the file location of the function is known.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/posts/[id]/layout",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    54,
                    106
                ]
            }
        ]
    },
    "sentry.nextjs.ssr.function.type": {
        brief: "A descriptor for a for a function in Next.js that contributes to Server-Side Rendering. Should be present on spans that track such functions.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "generateMetadata",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    54,
                    106
                ]
            }
        ]
    },
    "sentry.normalized_db_query": {
        brief: "The normalized version of `db.query.text`.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT .. FROM sentry_project WHERE (project_id = %s)",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    194
                ]
            }
        ]
    },
    "sentry.normalized_db_query.hash": {
        brief: "The hash of `sentry.normalized_db_query`.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    200
                ]
            }
        ]
    },
    "sentry.normalized_description": {
        brief: "Used as a generic attribute representing the normalized `sentry.description`. This refers to the legacy use case of `sentry.description` where it holds relevant data depending on the type of span (e.g. database query, resource url, http request description, etc).",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT .. FROM sentry_project WHERE (project_id = %s)",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.observed_timestamp_nanos": {
        brief: "The timestamp at which an envelope was received by Relay, in nanoseconds.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1544712660300000000",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    174
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    137
                ]
            }
        ]
    },
    "sentry.op": {
        brief: "The operation of a span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "http.client",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.origin": {
        brief: "The origin of the instrumentation (e.g. span, log, etc.)",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "auto.http.otel.fastify",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.platform": {
        brief: "The sdk platform that generated the event.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "php",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.profiler_id": {
        brief: "The id of the currently running profiler (continuous profiling)",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18779b64dd35d1a538e7ce2dd2d3fad3",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    242
                ]
            }
        ]
    },
    "sentry.profile_id": {
        brief: "The ID of the Sentry profile the span is associated with. This is only meaningful for transaction-based profiling.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    344
                ],
                description: "Added sentry.profile_id attribute"
            }
        ]
    },
    "sentry.release": {
        brief: "The sentry release.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "7.0.0",
        aliases: [
            "service.version",
            "release"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.replay_id": {
        brief: "The id of the sentry replay.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        aliases: [
            "replay_id"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.replay_is_buffering": {
        brief: "A sentinel attribute on log events indicating whether the current Session Replay is being buffered (onErrorSampleRate).",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.report_event": {
        brief: "(Deprecated) The event that caused the SDK to report CLS or LCP (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pagehide",
        deprecation: {
            reason: "The report event is now recorded as a browser.web_vital.lcp.report_event or browser.web_vital.cls.report_event attribute. No backfill required."
        },
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    320
                ],
                description: "Added sentry.report_event attribute"
            }
        ]
    },
    "sentry.sdk.integrations": {
        brief: "A list of names identifying enabled integrations. The list shouldhave all enabled integrations, including default integrations. Defaultintegrations are included because different SDK releases may contain differentdefault integrations.",
        type: "string[]",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "InboundFilters",
            "FunctionToString",
            "BrowserApiErrors",
            "Breadcrumbs"
        ],
        changelog: [
            {
                version: "0.0.0",
                prs: [
                    42
                ]
            }
        ]
    },
    "sentry.sdk.name": {
        brief: "The sentry sdk name.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "@sentry/react",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.sdk.version": {
        brief: "The sentry sdk version.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "7.0.0",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.segment.id": {
        brief: "The segment ID of a span",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "051581bf3cb55c13",
        aliases: [
            "sentry.segment_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    107,
                    124
                ]
            }
        ]
    },
    "sentry.segment_id": {
        brief: "The segment ID of a span",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "051581bf3cb55c13",
        deprecation: {
            replacement: "sentry.segment.id"
        },
        aliases: [
            "sentry.segment.id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    124
                ]
            }
        ]
    },
    "sentry.segment.name": {
        brief: "The segment name of a span",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /user",
        aliases: [
            "sentry.transaction",
            "transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Added sentry.transaction and transaction aliases"
            },
            {
                version: "0.1.0",
                prs: [
                    104
                ]
            }
        ]
    },
    "sentry.server_sample_rate": {
        brief: "Rate at which a span was sampled in Relay.",
        type: "double",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    102
                ]
            }
        ]
    },
    "sentry.source": {
        brief: "The source of a span, also referred to as transaction source. Known values are:  `'custom'`, `'url'`, `'route'`, `'component'`, `'view'`, `'task'`. '`source`' describes a parametrized route, while `'url'` describes the full URL, potentially containing identifiers.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "route",
        deprecation: {
            replacement: "sentry.span.source",
            reason: "This attribute is being deprecated in favor of sentry.span.source"
        },
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.span.source": {
        brief: "The source of a span, also referred to as transaction source. Known values are:  `'custom'`, `'url'`, `'route'`, `'component'`, `'view'`, `'task'`. '`source`' describes a parametrized route, while `'url'` describes the full URL, potentially containing identifiers.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "route",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    214
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.status": {
        brief: `The span's status (either "ok" or "error"). Older SDKs may set this to a more specific error, but this behaviour is deprecated.`,
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ok",
        changelog: [
            {
                version: "0.14.0",
                prs: [
                    453
                ]
            }
        ]
    },
    "sentry.status_code": {
        brief: "The HTTP status code used in Sentry Insights. Typically set by Sentry during ingestion, rather than by clients.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    223,
                    228
                ]
            }
        ]
    },
    "sentry.status.message": {
        brief: "The from OTLP extracted status message.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "foobar",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.sveltekit.navigation.from": {
        brief: "the navigation origin (sveltekit router)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/home",
        deprecation: {
            replacement: "navigation.origin",
            reason: "Use the more generic attribute instead"
        },
        aliases: [
            "navigation.origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.from attribute"
            }
        ]
    },
    "sentry.sveltekit.navigation.to": {
        brief: "the navigation destination",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        deprecation: {
            reason: "the navigation destination is already covered by url.* attributes"
        },
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.to attribute"
            }
        ]
    },
    "sentry.sveltekit.navigation.type": {
        brief: "The type of navigation event emitted from the sveltekit client router",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "link",
        deprecation: {
            replacement: "navigation.type",
            reason: "Use the more generic attribute instead"
        },
        aliases: [
            "navigation.type"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.type attribute"
            }
        ]
    },
    "sentry.thread.id": {
        brief: "Current \u201Cmanaged\u201D thread ID.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 56,
        deprecation: {
            replacement: "thread.id",
            reason: "This attribute is being deprecated in favor of the OTel-standard thread.id"
        },
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    451
                ]
            }
        ]
    },
    "sentry.timestamp.sequence": {
        brief: "A sequencing counter for deterministic ordering of logs or metrics when timestamps share the same integer millisecond. Starts at 0 on SDK initialization, increments by 1 for each captured item, and resets to 0 when the integer millisecond of the current item differs from the previous one.",
        type: "integer",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: 0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    262
                ]
            }
        ]
    },
    "sentry.trace_lifecycle": {
        brief: "Indicates the chosen trace lifecycle mode of the SDK (stream or static)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stream",
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    442
                ],
                description: "Added sentry.trace_lifecycle attribute"
            }
        ]
    },
    "sentry.trace.parent_span_id": {
        brief: "The span id of the span that was active when the log was collected. This should not be set if there was no active span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "b0e6f15b45c36b12",
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    287
                ],
                description: "Deprecate `sentry.trace.parent_span_id`"
            },
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.trace.status": {
        brief: `The segment's status (either "ok" or "error"). Older SDKs may set this to a more specific error, but this behaviour is deprecated.`,
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ok",
        changelog: [
            {
                version: "0.14.0",
                prs: [
                    453
                ]
            }
        ]
    },
    "sentry.transaction": {
        brief: "The sentry transaction (segment name).",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /",
        deprecation: {
            replacement: "sentry.segment.name",
            reason: "This attribute is being deprecated in favor of sentry.segment.name"
        },
        aliases: [
            "sentry.segment.name",
            "transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Deprecated sentry.transaction in favor of sentry.segment.name"
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.user.email": {
        brief: "User email address.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.email"
        },
        aliases: [
            "user.email"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.city": {
        brief: "Human readable city name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.city"
        },
        aliases: [
            "user.geo.city"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.country_code": {
        brief: "Two-letter country code (ISO 3166-1 alpha-2).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.country_code"
        },
        aliases: [
            "user.geo.country_code"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.region": {
        brief: "Human readable region name or code.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.region"
        },
        aliases: [
            "user.geo.region"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.subdivision": {
        brief: "Human readable subdivision name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.subdivision"
        },
        aliases: [
            "user.geo.subdivision"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.id": {
        brief: "Unique identifier of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.id"
        },
        aliases: [
            "user.id"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.ip": {
        brief: "The IP address of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.ip_address"
        },
        aliases: [
            "user.ip_address"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.username": {
        brief: "Short name or login/username of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.name"
        },
        aliases: [
            "user.name"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "server.address": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        aliases: [
            "http.server_name",
            "net.host.name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    server_name: {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "This attribute is being deprecated in favor of server.address, which is the OTel-aligned replacement."
        },
        aliases: [
            "server.address",
            "http.server_name",
            "net.host.name",
            "http.host"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    477
                ],
                description: "Added server_name attribute, deprecated in favor of server.address"
            }
        ]
    },
    "server.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        aliases: [
            "net.host.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "service.name": {
        brief: "Logical name of the service.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "omegastar",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "service.version": {
        brief: "The version string of the service API or implementation. The format is not defined by these conventions.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "5.0.0",
        aliases: [
            "sentry.release"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "session.id": {
        brief: "A unique id identifying the active session at the time of setting this attribute",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "00112233-4455-6677-8899-aabbccddeeff",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    412
                ],
                description: "Added session.id attribute"
            }
        ]
    },
    stall_percentage: {
        brief: "The fraction of time the app was stalled. Only applies to React Native. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added stall_percentage attribute"
            }
        ]
    },
    stall_total_time: {
        brief: "The combined duration of all stalls in milliseconds. Only applies to React Native. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added stall_total_time attribute"
            }
        ]
    },
    "state.type": {
        brief: "The type of state management library",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "redux",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    365
                ],
                description: "Added state.type attribute"
            }
        ]
    },
    "thread.id": {
        brief: "Current \u201Cmanaged\u201D thread ID.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 56,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "thread.name": {
        brief: "Current thread name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "main",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "timber.tag": {
        brief: "The log tag provided by the timber logging framework.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MyTag",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    183
                ]
            }
        ]
    },
    time_to_full_display: {
        brief: "The duration of time to full display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.ttfd.value",
            reason: "Replaced by app.vitals.ttfd.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.ttfd.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added and deprecated in favor of app.vitals.ttfd.value"
            }
        ]
    },
    time_to_initial_display: {
        brief: "The duration of time to initial display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.ttid.value",
            reason: "Replaced by app.vitals.ttid.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.ttid.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added and deprecated in favor of app.vitals.ttid.value"
            }
        ]
    },
    transaction: {
        brief: "The sentry transaction (segment name).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /",
        deprecation: {
            replacement: "sentry.segment.name"
        },
        aliases: [
            "sentry.segment.name",
            "sentry.transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Updated transaction deprecation replacement to sentry.segment.name"
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "trpc.procedure_path": {
        brief: "The path of the tRPC procedure being called",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user.getById",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    370
                ],
                description: "Added trpc.procedure_path attribute"
            }
        ]
    },
    "trpc.procedure_type": {
        brief: "The type of the tRPC procedure",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "query",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    370
                ],
                description: "Added trpc.procedure_type attribute"
            }
        ]
    },
    ttfb: {
        brief: "The value of the recorded Time To First Byte (TTFB) web vital in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 194,
        deprecation: {
            replacement: "browser.web_vital.ttfb.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.ttfb.value"
        },
        aliases: [
            "browser.web_vital.ttfb.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "ttfb.requestTime": {
        brief: "The time it takes for the server to process the initial request and send the first byte of a response to the user's browser",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1554.5814,
        deprecation: {
            replacement: "browser.web_vital.ttfb.request_time",
            reason: "This attribute is being deprecated in favor of browser.web_vital.ttfb.request_time"
        },
        aliases: [
            "browser.web_vital.ttfb.request_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    type: {
        brief: "More granular type of the operation happening.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "fetch",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.component_name": {
        brief: "The name of the associated component.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "HomeButton",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.contributes_to_ttfd": {
        brief: "Whether the span execution contributed to the TTFD (time to fully drawn) metric.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.contributes_to_ttid": {
        brief: "Whether the span execution contributed to the TTID (time to initial display) metric.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.element.height": {
        brief: "The height of the UI element (for Html in pixels)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 256,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.height attribute"
            }
        ]
    },
    "ui.element.id": {
        brief: "The id of the UI element",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "btn-login",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.id attribute"
            }
        ]
    },
    "ui.element.identifier": {
        brief: "The identifier used to measure the UI element timing",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "heroImage",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.identifier attribute"
            }
        ]
    },
    "ui.element.load_time": {
        brief: "The loading time of a UI element (from time origin to finished loading)",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 998.2234,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.load_time attribute"
            }
        ]
    },
    "ui.element.paint_type": {
        brief: "The type of element paint. Can either be 'image-paint' or 'text-paint'",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "image-paint",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.paint_type attribute"
            }
        ]
    },
    "ui.element.render_time": {
        brief: "The rendering time of the UI element (from time origin to finished rendering)",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1023.1124,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.render_time attribute"
            }
        ]
    },
    "ui.element.type": {
        brief: "type of the UI element",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "img",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.type attribute"
            }
        ]
    },
    "ui.element.url": {
        brief: "The URL of the UI element (e.g. an img src)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://assets.myapp.com/hero.png",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.url attribute"
            }
        ]
    },
    "ui.element.width": {
        brief: "The width of the UI element (for HTML in pixels)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 512,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.width attribute"
            }
        ]
    },
    url: {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.full"
        },
        aliases: [
            "url.full",
            "http.url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.domain": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.fragment": {
        brief: "The fragments present in the URI. Note that this does not contain the leading # character, while the `http.fragment` attribute does.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "details",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.full": {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        aliases: [
            "http.url",
            "url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.path": {
        brief: "The URI path component.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/foo",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.path.parameter.<key>": {
        brief: "Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "url.path.parameter.id='123'",
        aliases: [
            "params.<key>"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "url.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.query": {
        brief: "The query string present in the URL. Note that this does not contain the leading ? character, while the `http.query` attribute does.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Query string values can contain sensitive information. Clients should attempt to scrub parameters that might contain sensitive information."
        },
        isInOtel: !0,
        visibility: "public",
        example: "foo=bar&bar=baz",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.same_origin": {
        brief: "Indicates that a URL has the same origin as the current page's origin in the browser.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {
            replacement: "http.request.same_origin",
            reason: "This attribute is being deprecated in favor of http.request.same_origin."
        },
        aliases: [
            "http.request.same_origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    456
                ],
                description: "Added url.same_origin attribute, deprecated in favor of http.request.same_origin"
            }
        ]
    },
    "url.scheme": {
        brief: "The URI scheme component identifying the used protocol.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https",
        aliases: [
            "http.scheme"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.template": {
        brief: "The low-cardinality template of an absolute path reference.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "http.route"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "user_agent.original": {
        brief: "Value of the HTTP User-Agent header sent by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1",
        aliases: [
            "http.user_agent"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "user.email": {
        brief: "User email address.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "test@example.com",
        aliases: [
            "sentry.user.email"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.full_name": {
        brief: "User's full name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "John Smith",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.city": {
        brief: "Human readable city name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Toronto",
        aliases: [
            "sentry.user.geo.city"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.country_code": {
        brief: "Two-letter country code (ISO 3166-1 alpha-2).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "CA",
        aliases: [
            "sentry.user.geo.country_code"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.region": {
        brief: "Human readable region name or code.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Canada",
        aliases: [
            "sentry.user.geo.region"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.subdivision": {
        brief: "Human readable subdivision name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Ontario",
        aliases: [
            "sentry.user.geo.subdivision"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.hash": {
        brief: "Unique user hash to correlate information for a user in anonymized form.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "8ae4c2993e0f4f3b8b2d1b1f3b5e8f4d",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.id": {
        brief: "Unique identifier of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "S-1-5-21-202424912787-2692429404-2351956786-1000",
        aliases: [
            "sentry.user.id"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.ip_address": {
        brief: "The IP address of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "192.168.1.1",
        aliases: [
            "sentry.user.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    75
                ]
            }
        ]
    },
    "user.name": {
        brief: "Short name or login/username of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "j.smith",
        aliases: [
            "sentry.user.username"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.roles": {
        brief: "Array of user roles at the time of the event.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "admin",
            "editor"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "vercel.branch": {
        brief: "Git branch name for Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "main",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.build_id": {
        brief: "Identifier for the Vercel build (only present on build logs)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "bld_cotnkcr76",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.deployment_id": {
        brief: "Identifier for the Vercel deployment",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dpl_233NRGRjVZX1caZrXWtz5g1TAksD",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.destination": {
        brief: "Origin of the external content in Vercel (only on external logs)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://vitals.vercel-insights.com/v1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.edge_type": {
        brief: "Type of edge runtime in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "edge-function",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.entrypoint": {
        brief: "Entrypoint for the request in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "api/index.js",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.execution_region": {
        brief: "Region where the request is executed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.id": {
        brief: "Unique identifier for the log entry in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1573817187330377061717300000",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.ja3_digest": {
        brief: "JA3 fingerprint digest of Vercel request",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "769,47-53-5-10-49161-49162-49171-49172-50-56-19-4,0-10-11,23-24-25,0",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.ja4_digest": {
        brief: "JA4 fingerprint digest",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "t13d1516h2_8daaf6152771_02713d6af862",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.log_type": {
        brief: "Vercel log output type",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stdout",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.path": {
        brief: "Function or dynamic path of the request in Vercel.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/dynamic/[route].json",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    349
                ],
                description: "Added vercel.path attribute"
            }
        ]
    },
    "vercel.project_id": {
        brief: "Identifier for the Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gdufoJxB6b9b1fEqr1jUtFkyavUU",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.project_name": {
        brief: "Name of the Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.cache_id": {
        brief: "Original request ID when request is served from cache",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pdx1::v8g4b-1744143786684-93dafbc0f70d",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.client_ip": {
        brief: "Client IP address",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.75.16.101",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.host": {
        brief: "Hostname of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "test.vercel.app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.lambda_region": {
        brief: "Region where lambda function executed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.method": {
        brief: "HTTP method of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path": {
        brief: "Request path with query parameters",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/dynamic/some-value.json?route=some-value",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path_type": {
        brief: "How the request was served based on its path and project configuration",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "func",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path_type_variant": {
        brief: "Variant of the path type",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "api",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.referer": {
        brief: "Referer of the request",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "*.vercel.app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.region": {
        brief: "Region where the request is processed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.response_byte_size": {
        brief: "Size of the response in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1024,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.scheme": {
        brief: "Protocol of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.status_code": {
        brief: "HTTP status code of the proxy request",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.timestamp": {
        brief: "Unix timestamp when the proxy request was made",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1573817250172,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.user_agent": {
        brief: "User agent strings of the request",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Mozilla/5.0..."
        ],
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.vercel_cache": {
        brief: "Cache status sent to the browser",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "REVALIDATED",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.vercel_id": {
        brief: "Vercel-specific identifier",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1::abc123",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.waf_action": {
        brief: "Action taken by firewall rules",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "deny",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.waf_rule_id": {
        brief: "ID of the firewall rule that matched",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rule_gAHz8jtSB1Gy",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.request_id": {
        brief: "Identifier of the Vercel request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "643af4e3-975a-4cc7-9e7a-1eda11539d90",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.source": {
        brief: "Origin of the Vercel log (build, edge, lambda, static, external, or firewall)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "build",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.status_code": {
        brief: "HTTP status code of the request (-1 means no response returned and the lambda crashed)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    }
};
$687ff8957497b063$export$b60c5e9f9b7b58bd = $687ff8957497b063$var$AI_CITATIONS, $687ff8957497b063$export$cc06afd6de7f2c10 = $687ff8957497b063$var$AI_COMPLETION_TOKENS_USED, $687ff8957497b063$export$ced6746028fe2cc = $687ff8957497b063$var$AI_DOCUMENTS, $687ff8957497b063$export$e6f4aa4f4fcb6da8 = $687ff8957497b063$var$AI_FINISH_REASON, $687ff8957497b063$export$f02d892201cd8d36 = $687ff8957497b063$var$AI_FREQUENCY_PENALTY, $687ff8957497b063$export$f277a7ef9e273960 = $687ff8957497b063$var$AI_FUNCTION_CALL, $687ff8957497b063$export$1a8c212c3becaa80 = $687ff8957497b063$var$AI_GENERATION_ID, $687ff8957497b063$export$721b137086c68a47 = $687ff8957497b063$var$AI_INPUT_MESSAGES, $687ff8957497b063$export$6afde2bb69d9aa86 = $687ff8957497b063$var$AI_IS_SEARCH_REQUIRED, $687ff8957497b063$export$eadb4b562c974031 = $687ff8957497b063$var$AI_METADATA, $687ff8957497b063$export$22a90f0ac1eee843 = $687ff8957497b063$var$AI_MODEL_ID, $687ff8957497b063$export$a727f215a0be1dad = $687ff8957497b063$var$AI_MODEL_PROVIDER, $687ff8957497b063$export$536bc61b34d995e5 = $687ff8957497b063$var$AI_PIPELINE_NAME, $687ff8957497b063$export$c43ea6115b380e62 = $687ff8957497b063$var$AI_PREAMBLE, $687ff8957497b063$export$d2a16e26bada7cf1 = $687ff8957497b063$var$AI_PRESENCE_PENALTY, $687ff8957497b063$export$604eb1bd2278163b = $687ff8957497b063$var$AI_PROMPT_TOKENS_USED, $687ff8957497b063$export$2f8568696c5aa352 = $687ff8957497b063$var$AI_RAW_PROMPTING, $687ff8957497b063$export$ccc8efd7dd31d3a9 = $687ff8957497b063$var$AI_RESPONSES, $687ff8957497b063$export$e176bf5dc45e40df = $687ff8957497b063$var$AI_RESPONSE_FORMAT, $687ff8957497b063$export$c4ea01fd53f64e16 = $687ff8957497b063$var$AI_SEARCH_QUERIES, $687ff8957497b063$export$bb5e6f2f31a15da9 = $687ff8957497b063$var$AI_SEARCH_RESULTS, $687ff8957497b063$export$1762c11b666b026a = $687ff8957497b063$var$AI_SEED, $687ff8957497b063$export$14ddd4b729910100 = $687ff8957497b063$var$AI_STREAMING, $687ff8957497b063$export$5311d7c8e1f8eabb = $687ff8957497b063$var$AI_TAGS, $687ff8957497b063$export$2b748b9eca00828b = $687ff8957497b063$var$AI_TEMPERATURE, $687ff8957497b063$export$5af25308c11addea = $687ff8957497b063$var$AI_TEXTS, $687ff8957497b063$export$28f78b3b1663cb92 = $687ff8957497b063$var$AI_TOOLS, $687ff8957497b063$export$a1d3f09f0f1f066f = $687ff8957497b063$var$AI_TOOL_CALLS, $687ff8957497b063$export$322bd4ea9f163663 = $687ff8957497b063$var$AI_TOP_K, $687ff8957497b063$export$95711b9e669edad8 = $687ff8957497b063$var$AI_TOP_P, $687ff8957497b063$export$5924d7d72384626a = $687ff8957497b063$var$AI_TOTAL_COST, $687ff8957497b063$export$db3b1b877a4ce4db = $687ff8957497b063$var$AI_TOTAL_TOKENS_USED, $687ff8957497b063$export$a434a3e8afec2879 = $687ff8957497b063$var$AI_WARNINGS, $687ff8957497b063$export$fe00bb20636d42af = $687ff8957497b063$var$ANGULAR_VERSION, $687ff8957497b063$export$712aa698b7ee271e = $687ff8957497b063$var$APP_APP_BUILD, $687ff8957497b063$export$1fac638b11ec16d9 = $687ff8957497b063$var$APP_APP_IDENTIFIER, $687ff8957497b063$export$d132016ea64058e3 = $687ff8957497b063$var$APP_APP_NAME, $687ff8957497b063$export$53f2f47ec3b2f9ed = $687ff8957497b063$var$APP_APP_START_TIME, $687ff8957497b063$export$9f80c4b11053cef1 = $687ff8957497b063$var$APP_APP_VERSION, $687ff8957497b063$export$5f7a08466d84e877 = $687ff8957497b063$var$APP_BUILD, $687ff8957497b063$export$2cea7f14750b8c19 = $687ff8957497b063$var$APP_IDENTIFIER, $687ff8957497b063$export$34c59270f032a6c6 = $687ff8957497b063$var$APP_IN_FOREGROUND, $687ff8957497b063$export$5b6c28c7dca07ad7 = $687ff8957497b063$var$APP_NAME, $687ff8957497b063$export$1dc8ae58b58d6c50 = $687ff8957497b063$var$APP_START_COLD, $687ff8957497b063$export$ba267414e3c0d822 = $687ff8957497b063$var$APP_START_TIME, $687ff8957497b063$export$71b176005902b99e = $687ff8957497b063$var$APP_START_TYPE, $687ff8957497b063$export$5c5b5a3c245a0079 = $687ff8957497b063$var$APP_START_WARM, $687ff8957497b063$export$8ee1df3c6367a60 = $687ff8957497b063$var$APP_VERSION, $687ff8957497b063$export$e8c7802ae95beccf = $687ff8957497b063$var$APP_VITALS_FRAMES_DELAY_VALUE, $687ff8957497b063$export$bb237734da4d464 = $687ff8957497b063$var$APP_VITALS_FRAMES_FROZEN_COUNT, $687ff8957497b063$export$cdaaf6d1fdcba0b6 = $687ff8957497b063$var$APP_VITALS_FRAMES_SLOW_COUNT, $687ff8957497b063$export$36223ebd4a30e9f5 = $687ff8957497b063$var$APP_VITALS_FRAMES_TOTAL_COUNT, $687ff8957497b063$export$8feaa177bb7941e2 = $687ff8957497b063$var$APP_VITALS_START_COLD_VALUE, $687ff8957497b063$export$e1ca25240db91d68 = $687ff8957497b063$var$APP_VITALS_START_PREWARMED, $687ff8957497b063$export$404a223fd1ada08b = $687ff8957497b063$var$APP_VITALS_START_REASON, $687ff8957497b063$export$53362079310c68 = $687ff8957497b063$var$APP_VITALS_START_SCREEN, $687ff8957497b063$export$3efb5af0ac379f77 = $687ff8957497b063$var$APP_VITALS_START_TYPE, $687ff8957497b063$export$2c10c1ca0612c46d = $687ff8957497b063$var$APP_VITALS_START_WARM_VALUE, $687ff8957497b063$export$bbb86ad4d6654da6 = $687ff8957497b063$var$APP_VITALS_TTFD_VALUE, $687ff8957497b063$export$ad6896f00a2b1076 = $687ff8957497b063$var$APP_VITALS_TTID_VALUE, $687ff8957497b063$export$300f39d8506a273d = $687ff8957497b063$var$ART_GC_BLOCKING_COUNT, $687ff8957497b063$export$ecaa0e7f4773ddc7 = $687ff8957497b063$var$ART_GC_BLOCKING_TIME, $687ff8957497b063$export$74b78acb4c54c06b = $687ff8957497b063$var$ART_GC_PRE_OOME_COUNT, $687ff8957497b063$export$b15b2c133bc50e33 = $687ff8957497b063$var$ART_GC_TOTAL_COUNT, $687ff8957497b063$export$5f1381d9ae1b1c95 = $687ff8957497b063$var$ART_GC_TOTAL_TIME, $687ff8957497b063$export$c170b7ff277132ea = $687ff8957497b063$var$ART_GC_WAITING_TIME, $687ff8957497b063$export$9459a5df93695e45 = $687ff8957497b063$var$ART_MEMORY_FREE, $687ff8957497b063$export$a7902bd57492ebe8 = $687ff8957497b063$var$ART_MEMORY_FREE_UNTIL_GC, $687ff8957497b063$export$d2ace0da59da09b7 = $687ff8957497b063$var$ART_MEMORY_FREE_UNTIL_OOME, $687ff8957497b063$export$c15dd8d2461e0aeb = $687ff8957497b063$var$ART_MEMORY_MAX, $687ff8957497b063$export$5405b0a98e00e538 = $687ff8957497b063$var$ART_MEMORY_TOTAL, $687ff8957497b063$export$bd393bbb84b309d3 = $687ff8957497b063$var$ATTRIBUTE_METADATA, $687ff8957497b063$export$96f586f8837b86ae = $687ff8957497b063$var$ATTRIBUTE_TYPE, $687ff8957497b063$export$5d9f28f388f552d2 = $687ff8957497b063$var$AWS_CLOUDWATCH_LOGS_LOG_GROUP, $687ff8957497b063$export$b3d2f68e0e769504 = $687ff8957497b063$var$AWS_CLOUDWATCH_LOGS_LOG_STREAM, $687ff8957497b063$export$2c98412ed43013e8 = $687ff8957497b063$var$AWS_CLOUDWATCH_LOGS_URL, $687ff8957497b063$export$a7bd794d11c19f1b = $687ff8957497b063$var$AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS, $687ff8957497b063$export$df4227832b83fdd0 = $687ff8957497b063$var$AWS_DYNAMODB_CONSISTENT_READ, $687ff8957497b063$export$f131a6d8fbc0534f = $687ff8957497b063$var$AWS_DYNAMODB_CONSUMED_CAPACITY, $687ff8957497b063$export$9bdc66d4a70e7e3a = $687ff8957497b063$var$AWS_DYNAMODB_COUNT, $687ff8957497b063$export$bfbbc3cbcaa90e98 = $687ff8957497b063$var$AWS_DYNAMODB_EXCLUSIVE_START_TABLE, $687ff8957497b063$export$3565fa72459aa4d6 = $687ff8957497b063$var$AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES, $687ff8957497b063$export$bb67a834ae4bffdc = $687ff8957497b063$var$AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES, $687ff8957497b063$export$4a06c859a283f06 = $687ff8957497b063$var$AWS_DYNAMODB_INDEX_NAME, $687ff8957497b063$export$68324fac2038d0f2 = $687ff8957497b063$var$AWS_DYNAMODB_ITEM_COLLECTION_METRICS, $687ff8957497b063$export$5e1bd62ffd2786fb = $687ff8957497b063$var$AWS_DYNAMODB_LIMIT, $687ff8957497b063$export$bfdf2261058f56b = $687ff8957497b063$var$AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES, $687ff8957497b063$export$23bf57842d9d53df = $687ff8957497b063$var$AWS_DYNAMODB_PROJECTION, $687ff8957497b063$export$bfbd7e060eeb4d35 = $687ff8957497b063$var$AWS_DYNAMODB_PROVISIONED_READ_CAPACITY, $687ff8957497b063$export$82eb6cccda27c3ff = $687ff8957497b063$var$AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY, $687ff8957497b063$export$8ea68734d455808f = $687ff8957497b063$var$AWS_DYNAMODB_SCANNED_COUNT, $687ff8957497b063$export$40050e29324d44ee = $687ff8957497b063$var$AWS_DYNAMODB_SCAN_FORWARD, $687ff8957497b063$export$5cd7541006d9f467 = $687ff8957497b063$var$AWS_DYNAMODB_SEGMENT, $687ff8957497b063$export$81c017edd95d692e = $687ff8957497b063$var$AWS_DYNAMODB_SELECT, $687ff8957497b063$export$120b3897a58cf903 = $687ff8957497b063$var$AWS_DYNAMODB_TABLE_COUNT, $687ff8957497b063$export$d4a9de43b4b1076c = $687ff8957497b063$var$AWS_DYNAMODB_TABLE_NAMES, $687ff8957497b063$export$f37f4f9022f1ab17 = $687ff8957497b063$var$AWS_DYNAMODB_TOTAL_SEGMENTS, $687ff8957497b063$export$66ac18da14747cfb = $687ff8957497b063$var$AWS_EXTENDED_REQUEST_ID, $687ff8957497b063$export$9e49b833525ca49d = $687ff8957497b063$var$AWS_KINESIS_STREAM_NAME, $687ff8957497b063$export$b084fea5b3097227 = $687ff8957497b063$var$AWS_LAMBDA_AWS_REQUEST_ID, $687ff8957497b063$export$e09cd8615652e8d0 = $687ff8957497b063$var$AWS_LAMBDA_EXECUTION_DURATION_IN_MILLIS, $687ff8957497b063$export$a43a60ec723a90ee = $687ff8957497b063$var$AWS_LAMBDA_FUNCTION_NAME, $687ff8957497b063$export$34cc955357266287 = $687ff8957497b063$var$AWS_LAMBDA_FUNCTION_VERSION, $687ff8957497b063$export$d9dd218693ea9bba = $687ff8957497b063$var$AWS_LAMBDA_INVOKED_ARN, $687ff8957497b063$export$c9649b7156282a2f = $687ff8957497b063$var$AWS_LAMBDA_INVOKED_FUNCTION_ARN, $687ff8957497b063$export$daa8ce1f8adc553e = $687ff8957497b063$var$AWS_LAMBDA_REMAINING_TIME_IN_MILLIS, $687ff8957497b063$export$cb93c7b05db202cf = $687ff8957497b063$var$AWS_LOG_GROUP_NAMES, $687ff8957497b063$export$930f9bd3cc2e5b3d = $687ff8957497b063$var$AWS_LOG_STREAM_NAMES, $687ff8957497b063$export$48c6d4c44afdc0b = $687ff8957497b063$var$AWS_REQUEST_EXTENDED_ID, $687ff8957497b063$export$c78d41789fe4b1e4 = $687ff8957497b063$var$AWS_REQUEST_ID, $687ff8957497b063$export$f462d9921f1f7332 = $687ff8957497b063$var$AWS_S3_BUCKET, $687ff8957497b063$export$bc71f8df9a45e243 = $687ff8957497b063$var$AWS_SECRETSMANAGER_SECRET_ARN, $687ff8957497b063$export$ed840ec4a5f5d053 = $687ff8957497b063$var$AWS_SNS_TOPIC_ARN, $687ff8957497b063$export$c1a559a4f74a5e8e = $687ff8957497b063$var$AWS_STEP_FUNCTIONS_ACTIVITY_ARN, $687ff8957497b063$export$d1c007424092e3f5 = $687ff8957497b063$var$AWS_STEP_FUNCTIONS_STATE_MACHINE_ARN, $687ff8957497b063$export$9ebb466ce954c49c = $687ff8957497b063$var$BLOCKED_MAIN_THREAD, $687ff8957497b063$export$e9aafc7348984403 = $687ff8957497b063$var$BROWSER_NAME, $687ff8957497b063$export$faaa46964f075237 = $687ff8957497b063$var$BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START, $687ff8957497b063$export$d28c4b3cc4431a87 = $687ff8957497b063$var$BROWSER_PERFORMANCE_TIME_ORIGIN, $687ff8957497b063$export$734b017b330c8fe6 = $687ff8957497b063$var$BROWSER_REPORT_TYPE, $687ff8957497b063$export$683ebdc48ba3758d = $687ff8957497b063$var$BROWSER_SCRIPT_INVOKER, $687ff8957497b063$export$be0263971250ef44 = $687ff8957497b063$var$BROWSER_SCRIPT_INVOKER_TYPE, $687ff8957497b063$export$36a0cbc35c405232 = $687ff8957497b063$var$BROWSER_SCRIPT_SOURCE_CHAR_POSITION, $687ff8957497b063$export$469f7765ba335497 = $687ff8957497b063$var$BROWSER_VERSION, $687ff8957497b063$export$fe6fe2b7af051610 = $687ff8957497b063$var$BROWSER_WEB_VITAL_CLS_REPORT_EVENT, $687ff8957497b063$export$8345821877c4dfad = $687ff8957497b063$var$BROWSER_WEB_VITAL_CLS_SOURCE_KEY, $687ff8957497b063$export$f6c188a7e02335cf = $687ff8957497b063$var$BROWSER_WEB_VITAL_CLS_SOURCE_KEY_BASE, $687ff8957497b063$export$aaf709a8971e825f = $687ff8957497b063$var$BROWSER_WEB_VITAL_CLS_VALUE, $687ff8957497b063$export$def01b82f8c092f7 = $687ff8957497b063$var$BROWSER_WEB_VITAL_FCP_VALUE, $687ff8957497b063$export$23d4264c606a73a6 = $687ff8957497b063$var$BROWSER_WEB_VITAL_FP_VALUE, $687ff8957497b063$export$af9ece53bb92f66b = $687ff8957497b063$var$BROWSER_WEB_VITAL_INP_VALUE, $687ff8957497b063$export$25421625a565b69 = $687ff8957497b063$var$BROWSER_WEB_VITAL_LCP_ELEMENT, $687ff8957497b063$export$ab0c90d873e69ccb = $687ff8957497b063$var$BROWSER_WEB_VITAL_LCP_ID, $687ff8957497b063$export$538c05cc8cb2a2bb = $687ff8957497b063$var$BROWSER_WEB_VITAL_LCP_LOAD_TIME, $687ff8957497b063$export$f86df4de196e1a7c = $687ff8957497b063$var$BROWSER_WEB_VITAL_LCP_RENDER_TIME, $687ff8957497b063$export$51e8aa8c0d65e7b8 = $687ff8957497b063$var$BROWSER_WEB_VITAL_LCP_REPORT_EVENT, $687ff8957497b063$export$99023486ecc470bd = $687ff8957497b063$var$BROWSER_WEB_VITAL_LCP_SIZE, $687ff8957497b063$export$2f6c85eaf382e81 = $687ff8957497b063$var$BROWSER_WEB_VITAL_LCP_URL, $687ff8957497b063$export$1158d57c0aed42be = $687ff8957497b063$var$BROWSER_WEB_VITAL_LCP_VALUE, $687ff8957497b063$export$d85c4f947ab776e3 = $687ff8957497b063$var$BROWSER_WEB_VITAL_TTFB_REQUEST_TIME, $687ff8957497b063$export$813ef8386d874918 = $687ff8957497b063$var$BROWSER_WEB_VITAL_TTFB_VALUE, $687ff8957497b063$export$7c2f74ff9251f64 = $687ff8957497b063$var$CACHE_HIT, $687ff8957497b063$export$993f84dab107b880 = $687ff8957497b063$var$CACHE_ITEM_SIZE, $687ff8957497b063$export$7b9c2315e94d8d2f = $687ff8957497b063$var$CACHE_KEY, $687ff8957497b063$export$f01e5cd42b9ec146 = $687ff8957497b063$var$CACHE_OPERATION, $687ff8957497b063$export$987f6b4367434b55 = $687ff8957497b063$var$CACHE_TTL, $687ff8957497b063$export$d9d145585d5022bb = $687ff8957497b063$var$CACHE_WRITE, $687ff8957497b063$export$44ffba16bd48dac6 = $687ff8957497b063$var$CHANNEL, $687ff8957497b063$export$3134892c5d2e251a = $687ff8957497b063$var$CLIENT_ADDRESS, $687ff8957497b063$export$8495028d10296058 = $687ff8957497b063$var$CLIENT_PORT, $687ff8957497b063$export$d6d0e4fcf46d490c = $687ff8957497b063$var$CLOUDFLARE_D1_DURATION, $687ff8957497b063$export$658dced473c19301 = $687ff8957497b063$var$CLOUDFLARE_D1_QUERY_TYPE, $687ff8957497b063$export$97b0f9c3fbe64076 = $687ff8957497b063$var$CLOUDFLARE_D1_ROWS_READ, $687ff8957497b063$export$cf2c95ed5efbe9eb = $687ff8957497b063$var$CLOUDFLARE_D1_ROWS_WRITTEN, $687ff8957497b063$export$880007904f61a388 = $687ff8957497b063$var$CLOUDFLARE_DURABLE_OBJECT_QUERY_BINDINGS, $687ff8957497b063$export$3e903b72d4d9e07d = $687ff8957497b063$var$CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_READ, $687ff8957497b063$export$34da07180e0e56af = $687ff8957497b063$var$CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_WRITTEN, $687ff8957497b063$export$c49aafdaeb061953 = $687ff8957497b063$var$CLOUDFLARE_R2_BUCKET, $687ff8957497b063$export$ceb762c61de2f17f = $687ff8957497b063$var$CLOUDFLARE_R2_OPERATION, $687ff8957497b063$export$a5f54ccfb28c0caf = $687ff8957497b063$var$CLOUDFLARE_R2_REQUEST_DELIMITER, $687ff8957497b063$export$1c86a56857b024db = $687ff8957497b063$var$CLOUDFLARE_R2_REQUEST_KEY, $687ff8957497b063$export$7598f3464be47440 = $687ff8957497b063$var$CLOUDFLARE_R2_REQUEST_PART_NUMBER, $687ff8957497b063$export$b673289c971fc0ae = $687ff8957497b063$var$CLOUDFLARE_R2_REQUEST_PREFIX, $687ff8957497b063$export$98b23f3e6f0c2a6f = $687ff8957497b063$var$CLOUDFLARE_WORKFLOW_ATTEMPT, $687ff8957497b063$export$6ddeaf0498614ebb = $687ff8957497b063$var$CLOUDFLARE_WORKFLOW_RETRIES_BACKOFF, $687ff8957497b063$export$97b78f78d64a7232 = $687ff8957497b063$var$CLOUDFLARE_WORKFLOW_RETRIES_DELAY, $687ff8957497b063$export$5147715be870fff7 = $687ff8957497b063$var$CLOUDFLARE_WORKFLOW_RETRIES_LIMIT, $687ff8957497b063$export$5276bb46e6096fba = $687ff8957497b063$var$CLOUDFLARE_WORKFLOW_TIMEOUT, $687ff8957497b063$export$cbcbc1f67a937cf3 = $687ff8957497b063$var$CLOUD_ACCOUNT_ID, $687ff8957497b063$export$226a2381b8f0cf78 = $687ff8957497b063$var$CLOUD_AVAILABILITY_ZONE, $687ff8957497b063$export$fd35512cae286064 = $687ff8957497b063$var$CLOUD_PLATFORM, $687ff8957497b063$export$de9bbf95ab1d81e = $687ff8957497b063$var$CLOUD_PROVIDER, $687ff8957497b063$export$47fb20e8d18d7d15 = $687ff8957497b063$var$CLOUD_REGION, $687ff8957497b063$export$9db7964e4b8cb849 = $687ff8957497b063$var$CLOUD_RESOURCE_ID, $687ff8957497b063$export$7139adf9d3bace41 = "cls", $687ff8957497b063$export$8ac3d09060e7f25d = $687ff8957497b063$var$CLS_SOURCE_KEY, $687ff8957497b063$export$dad0e4778ea23971 = $687ff8957497b063$var$CLS_SOURCE_KEY_BASE, $687ff8957497b063$export$c14d903ccf9385a8 = $687ff8957497b063$var$CODE_FILEPATH, $687ff8957497b063$export$934cded0041affd7 = $687ff8957497b063$var$CODE_FILE_PATH, $687ff8957497b063$export$6386da1dcba88c9d = $687ff8957497b063$var$CODE_FUNCTION, $687ff8957497b063$export$a3371797e606e2 = $687ff8957497b063$var$CODE_FUNCTION_NAME, $687ff8957497b063$export$a5bbef0af83b23e5 = $687ff8957497b063$var$CODE_LINENO, $687ff8957497b063$export$91ed1f55874222a6 = $687ff8957497b063$var$CODE_LINE_NUMBER, $687ff8957497b063$export$23de81068d2aed1b = $687ff8957497b063$var$CODE_NAMESPACE, $687ff8957497b063$export$d738320e1fba9e9d = $687ff8957497b063$var$CONNECTIONTYPE, $687ff8957497b063$export$2eacdea75497e8a5 = $687ff8957497b063$var$CONNECTION_RTT, $687ff8957497b063$export$2bc3ea101f86c1d2 = $687ff8957497b063$var$CULTURE_CALENDAR, $687ff8957497b063$export$c54e27e8d90ee081 = $687ff8957497b063$var$CULTURE_DISPLAY_NAME, $687ff8957497b063$export$4943adcec371c2a6 = $687ff8957497b063$var$CULTURE_IS_24_HOUR_FORMAT, $687ff8957497b063$export$f000a5900d0480c2 = $687ff8957497b063$var$CULTURE_LOCALE, $687ff8957497b063$export$8f5234893868273b = $687ff8957497b063$var$CULTURE_TIMEZONE, $687ff8957497b063$export$1a35518f6e81e8c7 = $687ff8957497b063$var$DB_COLLECTION_NAME, $687ff8957497b063$export$a2d90911eaae60fc = $687ff8957497b063$var$DB_DRIVER_NAME, $687ff8957497b063$export$3c22ff8b64b8f565 = $687ff8957497b063$var$DB_NAME, $687ff8957497b063$export$b8019c0e2a5b5f0f = $687ff8957497b063$var$DB_NAMESPACE, $687ff8957497b063$export$8c11477e471467c8 = $687ff8957497b063$var$DB_OPERATION, $687ff8957497b063$export$92a96f6363488aee = $687ff8957497b063$var$DB_OPERATION_BATCH_SIZE, $687ff8957497b063$export$f91beb6088f9ded9 = $687ff8957497b063$var$DB_OPERATION_NAME, $687ff8957497b063$export$78bc7224576bf289 = $687ff8957497b063$var$DB_QUERY_PARAMETER_KEY, $687ff8957497b063$export$a8027e0ea0d93ca = $687ff8957497b063$var$DB_QUERY_PARAMETER_KEY_BASE, $687ff8957497b063$export$5e59d3aea52e5037 = $687ff8957497b063$var$DB_QUERY_SUMMARY, $687ff8957497b063$export$47e408be0da7933f = $687ff8957497b063$var$DB_QUERY_TEXT, $687ff8957497b063$export$d5772b934ca13e57 = $687ff8957497b063$var$DB_REDIS_CONNECTION, $687ff8957497b063$export$36e47f6a5777561d = $687ff8957497b063$var$DB_REDIS_KEY, $687ff8957497b063$export$e768cbc99cd68acf = $687ff8957497b063$var$DB_REDIS_PARAMETERS, $687ff8957497b063$export$dfcc6c69df1343f2 = $687ff8957497b063$var$DB_RESPONSE_STATUS_CODE, $687ff8957497b063$export$69b0a5d9226b5211 = $687ff8957497b063$var$DB_SQL_BINDINGS, $687ff8957497b063$export$da010a4f4fc971ae = $687ff8957497b063$var$DB_STATEMENT, $687ff8957497b063$export$5d515b35be0601a0 = $687ff8957497b063$var$DB_STORED_PROCEDURE_NAME, $687ff8957497b063$export$3e1b1037a315c5ca = $687ff8957497b063$var$DB_SYSTEM, $687ff8957497b063$export$847fdd494825f0fb = $687ff8957497b063$var$DB_SYSTEM_NAME, $687ff8957497b063$export$a9d76f26c6c730a9 = $687ff8957497b063$var$DB_USER, $687ff8957497b063$export$de03f86d1c9866ca = $687ff8957497b063$var$DEVICEMEMORY, $687ff8957497b063$export$65798ecab7eef8c = $687ff8957497b063$var$DEVICE_ARCHS, $687ff8957497b063$export$22aa61f48b9c79a0 = $687ff8957497b063$var$DEVICE_BATTERY_LEVEL, $687ff8957497b063$export$69f5fb98f5aed812 = $687ff8957497b063$var$DEVICE_BATTERY_TEMPERATURE, $687ff8957497b063$export$bdea5d1006fd280a = $687ff8957497b063$var$DEVICE_BOOT_TIME, $687ff8957497b063$export$f63a7230c5b1d609 = $687ff8957497b063$var$DEVICE_BRAND, $687ff8957497b063$export$6f25e59b05bb8e17 = $687ff8957497b063$var$DEVICE_CHARGING, $687ff8957497b063$export$a56ad13c4afc7421 = $687ff8957497b063$var$DEVICE_CHIPSET, $687ff8957497b063$export$d9ce89ce8912bf12 = $687ff8957497b063$var$DEVICE_CLASS, $687ff8957497b063$export$17094e5f380e4162 = $687ff8957497b063$var$DEVICE_CONNECTION_TYPE, $687ff8957497b063$export$28a0ffdf747973a0 = $687ff8957497b063$var$DEVICE_CPU_DESCRIPTION, $687ff8957497b063$export$5480ae1ba5d50bb9 = $687ff8957497b063$var$DEVICE_EXTERNAL_FREE_STORAGE, $687ff8957497b063$export$edc72ee4a17f5152 = $687ff8957497b063$var$DEVICE_EXTERNAL_STORAGE_SIZE, $687ff8957497b063$export$19e4df138d354f8b = $687ff8957497b063$var$DEVICE_FAMILY, $687ff8957497b063$export$92b0d20fa482b4b2 = $687ff8957497b063$var$DEVICE_FREE_MEMORY, $687ff8957497b063$export$3f638a793d61933f = $687ff8957497b063$var$DEVICE_FREE_STORAGE, $687ff8957497b063$export$3f511731cc3687d4 = $687ff8957497b063$var$DEVICE_ID, $687ff8957497b063$export$692b08741d6b6265 = $687ff8957497b063$var$DEVICE_LOCALE, $687ff8957497b063$export$cf67f8cb2324428e = $687ff8957497b063$var$DEVICE_LOW_MEMORY, $687ff8957497b063$export$9d4197c1ffc5f359 = $687ff8957497b063$var$DEVICE_LOW_POWER_MODE, $687ff8957497b063$export$509634fbff540e75 = $687ff8957497b063$var$DEVICE_MANUFACTURER, $687ff8957497b063$export$ccbc4fdff4b5eff5 = $687ff8957497b063$var$DEVICE_MEMORY_ESTIMATED_CAPACITY, $687ff8957497b063$export$e0cb371ca548b1d6 = $687ff8957497b063$var$DEVICE_MEMORY_SIZE, $687ff8957497b063$export$3c39026d09026bc2 = $687ff8957497b063$var$DEVICE_MODEL, $687ff8957497b063$export$bf9e8248cb72cf00 = $687ff8957497b063$var$DEVICE_MODEL_ID, $687ff8957497b063$export$1054f22a72121d0f = $687ff8957497b063$var$DEVICE_NAME, $687ff8957497b063$export$723b8a59dad2e467 = $687ff8957497b063$var$DEVICE_ONLINE, $687ff8957497b063$export$160081ff141bac8e = $687ff8957497b063$var$DEVICE_ORIENTATION, $687ff8957497b063$export$194f62c84d27310 = $687ff8957497b063$var$DEVICE_PROCESSOR_COUNT, $687ff8957497b063$export$7ed866d57b018d09 = $687ff8957497b063$var$DEVICE_PROCESSOR_FREQUENCY, $687ff8957497b063$export$d50bae4562e03e5 = $687ff8957497b063$var$DEVICE_SCREEN_DENSITY, $687ff8957497b063$export$649ea67a18fe8e8b = $687ff8957497b063$var$DEVICE_SCREEN_DPI, $687ff8957497b063$export$136a5c1b43caaccd = $687ff8957497b063$var$DEVICE_SCREEN_HEIGHT_PIXELS, $687ff8957497b063$export$e33a28ea554b6ddc = $687ff8957497b063$var$DEVICE_SCREEN_WIDTH_PIXELS, $687ff8957497b063$export$acbe2d25ac76ea64 = $687ff8957497b063$var$DEVICE_SIMULATOR, $687ff8957497b063$export$793c13e17d7e5e2b = $687ff8957497b063$var$DEVICE_STORAGE_SIZE, $687ff8957497b063$export$a5617e33b89fd956 = $687ff8957497b063$var$DEVICE_THERMAL_STATE, $687ff8957497b063$export$b51f82164fa31e07 = $687ff8957497b063$var$DEVICE_TIMEZONE, $687ff8957497b063$export$f2ef55183c04d202 = $687ff8957497b063$var$DEVICE_USABLE_MEMORY, $687ff8957497b063$export$7c98fc0c48a16b1c = $687ff8957497b063$var$DIST, $687ff8957497b063$export$f0511e328234ae83 = $687ff8957497b063$var$EFFECTIVECONNECTIONTYPE, $687ff8957497b063$export$be46596bc6608f3b = $687ff8957497b063$var$ENVIRONMENT, $687ff8957497b063$export$f215947b3d76a6b7 = $687ff8957497b063$var$ERROR_TYPE, $687ff8957497b063$export$89bbc91416db6670 = $687ff8957497b063$var$EVENT_ID, $687ff8957497b063$export$b4b5eff8a8712c89 = $687ff8957497b063$var$EVENT_NAME, $687ff8957497b063$export$f455969a57ab8a03 = $687ff8957497b063$var$EXCEPTION_ESCAPED, $687ff8957497b063$export$13f2f8f42af49cec = $687ff8957497b063$var$EXCEPTION_MESSAGE, $687ff8957497b063$export$cd357afe2ffdd2c3 = $687ff8957497b063$var$EXCEPTION_STACKTRACE, $687ff8957497b063$export$d9ca2a279a11be5e = $687ff8957497b063$var$EXCEPTION_TYPE, $687ff8957497b063$export$bbd59a8c7efad4c9 = $687ff8957497b063$var$FAAS_COLDSTART, $687ff8957497b063$export$8413282a17f1cda5 = $687ff8957497b063$var$FAAS_CRON, $687ff8957497b063$export$30d19ddc7705e7e8 = $687ff8957497b063$var$FAAS_DURATION_IN_MS, $687ff8957497b063$export$64a4f09e2444b3d = $687ff8957497b063$var$FAAS_ENTRY_POINT, $687ff8957497b063$export$645b039fe163809e = $687ff8957497b063$var$FAAS_EXECUTION, $687ff8957497b063$export$b23ef8b8ffa607e1 = $687ff8957497b063$var$FAAS_ID, $687ff8957497b063$export$8bf64516740c1369 = $687ff8957497b063$var$FAAS_IDENTITY, $687ff8957497b063$export$9a0dc8e612f3e10b = $687ff8957497b063$var$FAAS_INVOCATION_ID, $687ff8957497b063$export$abe90fedb3dddda2 = $687ff8957497b063$var$FAAS_INVOKED_NAME, $687ff8957497b063$export$4a19da9c85ed2ade = $687ff8957497b063$var$FAAS_INVOKED_PROVIDER, $687ff8957497b063$export$5e091479f094bdbc = $687ff8957497b063$var$FAAS_INVOKED_REGION, $687ff8957497b063$export$d70909b5aa96a79a = $687ff8957497b063$var$FAAS_NAME, $687ff8957497b063$export$651d142a8017d83d = $687ff8957497b063$var$FAAS_TIME, $687ff8957497b063$export$44382a010a9f7fcf = $687ff8957497b063$var$FAAS_TRIGGER, $687ff8957497b063$export$807abfdc6b7b9338 = $687ff8957497b063$var$FAAS_VERSION, $687ff8957497b063$export$31881d07f2569218 = "fcp", $687ff8957497b063$export$e5bbf306deb709a6 = $687ff8957497b063$var$FLAG_EVALUATION_KEY, $687ff8957497b063$export$aa8721167c5c8d2d = $687ff8957497b063$var$FLAG_EVALUATION_KEY_BASE, $687ff8957497b063$export$757b93e5b3adc7cb = "fp", $687ff8957497b063$export$f869eaa92db1dc9b = $687ff8957497b063$var$FRAMES_DELAY, $687ff8957497b063$export$5d1d761e41c32d9e = $687ff8957497b063$var$FRAMES_FROZEN, $687ff8957497b063$export$8aec72d9491f9399 = $687ff8957497b063$var$FRAMES_FROZEN_RATE, $687ff8957497b063$export$5562635d2be2ab25 = $687ff8957497b063$var$FRAMES_SLOW, $687ff8957497b063$export$2dc31837ce6f7a3d = $687ff8957497b063$var$FRAMES_SLOW_RATE, $687ff8957497b063$export$b561df15f64d32e3 = $687ff8957497b063$var$FRAMES_TOTAL, $687ff8957497b063$export$181f78b28f2ffa57 = $687ff8957497b063$var$FS_ERROR, $687ff8957497b063$export$6c97c77b89571c75 = $687ff8957497b063$var$GCP_FUNCTION_CONTEXT_EVENT_ID, $687ff8957497b063$export$51e431eaf1f9bf58 = $687ff8957497b063$var$GCP_FUNCTION_CONTEXT_EVENT_TYPE, $687ff8957497b063$export$71429c7ef7cb7063 = $687ff8957497b063$var$GCP_FUNCTION_CONTEXT_ID, $687ff8957497b063$export$99905d7583a6e8ac = $687ff8957497b063$var$GCP_FUNCTION_CONTEXT_RESOURCE, $687ff8957497b063$export$b6c4be74fd0c06bd = $687ff8957497b063$var$GCP_FUNCTION_CONTEXT_SOURCE, $687ff8957497b063$export$fd23e5b8d261a89 = $687ff8957497b063$var$GCP_FUNCTION_CONTEXT_SPECVERSION, $687ff8957497b063$export$25fabc9b3d1dd567 = $687ff8957497b063$var$GCP_FUNCTION_CONTEXT_TIME, $687ff8957497b063$export$41507f7b07dad151 = $687ff8957497b063$var$GCP_FUNCTION_CONTEXT_TIMESTAMP, $687ff8957497b063$export$1352f3699c35dd73 = $687ff8957497b063$var$GCP_FUNCTION_CONTEXT_TYPE, $687ff8957497b063$export$fd6c9d5c74d943ac = $687ff8957497b063$var$GCP_PROJECT_ID, $687ff8957497b063$export$c29634e3cf41e479 = $687ff8957497b063$var$GEN_AI_AGENT_NAME, $687ff8957497b063$export$e6a60882cce7a085 = $687ff8957497b063$var$GEN_AI_CONTEXT_UTILIZATION, $687ff8957497b063$export$6773c9098ba5e194 = $687ff8957497b063$var$GEN_AI_CONTEXT_WINDOW_SIZE, $687ff8957497b063$export$6ee6b62f50047686 = $687ff8957497b063$var$GEN_AI_CONVERSATION_ID, $687ff8957497b063$export$efac052bb3661242 = $687ff8957497b063$var$GEN_AI_COST_CACHE_CREATION_INPUT_TOKENS, $687ff8957497b063$export$7ccd63b9ca955862 = $687ff8957497b063$var$GEN_AI_COST_CACHE_READ_INPUT_TOKENS, $687ff8957497b063$export$50921df5a58cb3ef = $687ff8957497b063$var$GEN_AI_COST_INPUT_TOKENS, $687ff8957497b063$export$8e48efc7acb57a97 = $687ff8957497b063$var$GEN_AI_COST_OUTPUT_TOKENS, $687ff8957497b063$export$cea9121727113f77 = $687ff8957497b063$var$GEN_AI_COST_REASONING_OUTPUT_TOKENS, $687ff8957497b063$export$bed35ff7f9af3aaa = $687ff8957497b063$var$GEN_AI_COST_TOTAL_TOKENS, $687ff8957497b063$export$6b729e898b9067ce = $687ff8957497b063$var$GEN_AI_EMBEDDINGS_INPUT, $687ff8957497b063$export$984fbab9b52f7e24 = $687ff8957497b063$var$GEN_AI_FUNCTION_ID, $687ff8957497b063$export$9ea17906a87ada6f = $687ff8957497b063$var$GEN_AI_INPUT_MESSAGES, $687ff8957497b063$export$394b443aaff3ef92 = $687ff8957497b063$var$GEN_AI_OPERATION_NAME, $687ff8957497b063$export$6ddc374adbc06720 = $687ff8957497b063$var$GEN_AI_OPERATION_TYPE, $687ff8957497b063$export$ab8c7ebc9add56b2 = $687ff8957497b063$var$GEN_AI_OUTPUT_MESSAGES, $687ff8957497b063$export$40ecc5bcd633d1ee = $687ff8957497b063$var$GEN_AI_PIPELINE_NAME, $687ff8957497b063$export$86a8df7fff52fc69 = $687ff8957497b063$var$GEN_AI_PROMPT, $687ff8957497b063$export$cf2115d46768f4c5 = $687ff8957497b063$var$GEN_AI_PROMPT_NAME, $687ff8957497b063$export$3d7e036e195764db = $687ff8957497b063$var$GEN_AI_PROVIDER_NAME, $687ff8957497b063$export$60c1d11221608cee = $687ff8957497b063$var$GEN_AI_REQUEST_AVAILABLE_TOOLS, $687ff8957497b063$export$bc3cef164abbc42c = $687ff8957497b063$var$GEN_AI_REQUEST_FREQUENCY_PENALTY, $687ff8957497b063$export$43f9afb62cd79dec = $687ff8957497b063$var$GEN_AI_REQUEST_MAX_TOKENS, $687ff8957497b063$export$a5ab4ffc4765f75f = $687ff8957497b063$var$GEN_AI_REQUEST_MESSAGES, $687ff8957497b063$export$ccf46db9ab1743ec = $687ff8957497b063$var$GEN_AI_REQUEST_MODEL, $687ff8957497b063$export$76c1c247342d776 = $687ff8957497b063$var$GEN_AI_REQUEST_PRESENCE_PENALTY, $687ff8957497b063$export$92f5944f0b02c9fb = $687ff8957497b063$var$GEN_AI_REQUEST_REASONING_EFFORT, $687ff8957497b063$export$867eeefcb1c95b27 = $687ff8957497b063$var$GEN_AI_REQUEST_SEED, $687ff8957497b063$export$5ada4697ae6aa17e = $687ff8957497b063$var$GEN_AI_REQUEST_STOP_SEQUENCES, $687ff8957497b063$export$427122300e8d54d0 = $687ff8957497b063$var$GEN_AI_REQUEST_TEMPERATURE, $687ff8957497b063$export$bcea8881375c352f = $687ff8957497b063$var$GEN_AI_REQUEST_TOP_K, $687ff8957497b063$export$b867715f9a0c04e9 = $687ff8957497b063$var$GEN_AI_REQUEST_TOP_P, $687ff8957497b063$export$69878a39cbdbe097 = $687ff8957497b063$var$GEN_AI_RESPONSE_FINISH_REASONS, $687ff8957497b063$export$584c61a1b769552d = $687ff8957497b063$var$GEN_AI_RESPONSE_ID, $687ff8957497b063$export$8169ebcb0b0331dd = $687ff8957497b063$var$GEN_AI_RESPONSE_MODEL, $687ff8957497b063$export$2c9713b624877853 = $687ff8957497b063$var$GEN_AI_RESPONSE_STREAMING, $687ff8957497b063$export$45942692aeb454e0 = $687ff8957497b063$var$GEN_AI_RESPONSE_TEXT, $687ff8957497b063$export$8e5efeaa031210cd = $687ff8957497b063$var$GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK, $687ff8957497b063$export$35a62769ee05a05a = $687ff8957497b063$var$GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN, $687ff8957497b063$export$8ea4f7e986ca4b06 = $687ff8957497b063$var$GEN_AI_RESPONSE_TOKENS_PER_SECOND, $687ff8957497b063$export$d2fd9ecaff0285a4 = $687ff8957497b063$var$GEN_AI_RESPONSE_TOOL_CALLS, $687ff8957497b063$export$a6c8e656a4f9bb67 = $687ff8957497b063$var$GEN_AI_SYSTEM, $687ff8957497b063$export$352a8075b163d53 = $687ff8957497b063$var$GEN_AI_SYSTEM_INSTRUCTIONS, $687ff8957497b063$export$426d7b90ba5d79db = $687ff8957497b063$var$GEN_AI_SYSTEM_MESSAGE, $687ff8957497b063$export$f5a1ee40934d19ce = $687ff8957497b063$var$GEN_AI_TOOL_CALL_ARGUMENTS, $687ff8957497b063$export$1ba812a9756622ce = $687ff8957497b063$var$GEN_AI_TOOL_CALL_RESULT, $687ff8957497b063$export$351120039c36e03 = $687ff8957497b063$var$GEN_AI_TOOL_DEFINITIONS, $687ff8957497b063$export$d42aa25ca09e17c4 = $687ff8957497b063$var$GEN_AI_TOOL_DESCRIPTION, $687ff8957497b063$export$d268db29b88a4286 = $687ff8957497b063$var$GEN_AI_TOOL_INPUT, $687ff8957497b063$export$c5deb6018f2d6251 = $687ff8957497b063$var$GEN_AI_TOOL_MESSAGE, $687ff8957497b063$export$e06baa3034409453 = $687ff8957497b063$var$GEN_AI_TOOL_NAME, $687ff8957497b063$export$646fdb5910ce3931 = $687ff8957497b063$var$GEN_AI_TOOL_OUTPUT, $687ff8957497b063$export$662e3d2d4361e29b = $687ff8957497b063$var$GEN_AI_TOOL_TYPE, $687ff8957497b063$export$1de3962f221ba441 = $687ff8957497b063$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS, $687ff8957497b063$export$a4b3f0f5499c8738 = $687ff8957497b063$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS, $687ff8957497b063$export$1aecdac6cecbdc5b = $687ff8957497b063$var$GEN_AI_USAGE_COMPLETION_TOKENS, $687ff8957497b063$export$2eb2ab35b317a103 = $687ff8957497b063$var$GEN_AI_USAGE_INPUT_TOKENS, $687ff8957497b063$export$c7e14ea195ede241 = $687ff8957497b063$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED, $687ff8957497b063$export$41ac034e7b9725a2 = $687ff8957497b063$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE, $687ff8957497b063$export$9e521119d7751e37 = $687ff8957497b063$var$GEN_AI_USAGE_OUTPUT_TOKENS, $687ff8957497b063$export$cbac8f541a64a150 = $687ff8957497b063$var$GEN_AI_USAGE_OUTPUT_TOKENS_REASONING, $687ff8957497b063$export$93dd08efa94c9dd4 = $687ff8957497b063$var$GEN_AI_USAGE_PROMPT_TOKENS, $687ff8957497b063$export$183e3523dac20bca = $687ff8957497b063$var$GEN_AI_USAGE_REASONING_OUTPUT_TOKENS, $687ff8957497b063$export$3867ca1d8381d4e3 = $687ff8957497b063$var$GEN_AI_USAGE_TOTAL_TOKENS, $687ff8957497b063$export$11febcf9917c0057 = $687ff8957497b063$var$GRAPHQL_DOCUMENT, $687ff8957497b063$export$88ae1ee0c0a63398 = $687ff8957497b063$var$GRAPHQL_OPERATION_NAME, $687ff8957497b063$export$d5bd986d1f283f29 = $687ff8957497b063$var$GRAPHQL_OPERATION_TYPE, $687ff8957497b063$export$fc4a2d238535d998 = $687ff8957497b063$var$HARDWARECONCURRENCY, $687ff8957497b063$export$57e53a60bf563f41 = $687ff8957497b063$var$HTTP_CLIENT_IP, $687ff8957497b063$export$ffdb1464deb0eedb = $687ff8957497b063$var$HTTP_DECODED_RESPONSE_CONTENT_LENGTH, $687ff8957497b063$export$b52670c950fd640 = $687ff8957497b063$var$HTTP_FLAVOR, $687ff8957497b063$export$c499fd8f1db3d18e = $687ff8957497b063$var$HTTP_FRAGMENT, $687ff8957497b063$export$b2ee2242301eff05 = $687ff8957497b063$var$HTTP_HOST, $687ff8957497b063$export$2ebf9f7586f16841 = $687ff8957497b063$var$HTTP_METHOD, $687ff8957497b063$export$6e9ffd608b3e828b = $687ff8957497b063$var$HTTP_QUERY, $687ff8957497b063$export$b960c5a73a722e6c = $687ff8957497b063$var$HTTP_REQUEST_BODY_DATA, $687ff8957497b063$export$a7a850351369c77e = $687ff8957497b063$var$HTTP_REQUEST_CONNECTION_END, $687ff8957497b063$export$b18bca78f4736a94 = $687ff8957497b063$var$HTTP_REQUEST_CONNECT_START, $687ff8957497b063$export$61a0059f562fb6c2 = $687ff8957497b063$var$HTTP_REQUEST_DOMAIN_LOOKUP_END, $687ff8957497b063$export$7dc0d5aefb816d91 = $687ff8957497b063$var$HTTP_REQUEST_DOMAIN_LOOKUP_START, $687ff8957497b063$export$58f6db56c841bef6 = $687ff8957497b063$var$HTTP_REQUEST_FETCH_START, $687ff8957497b063$export$97a3da679f509d5 = $687ff8957497b063$var$HTTP_REQUEST_HEADER_KEY, $687ff8957497b063$export$c387ec65fd1c2638 = $687ff8957497b063$var$HTTP_REQUEST_HEADER_KEY_BASE, $687ff8957497b063$export$4d9db82211f308a4 = $687ff8957497b063$var$HTTP_REQUEST_METHOD, $687ff8957497b063$export$ee4948a3be025123 = $687ff8957497b063$var$HTTP_REQUEST_REDIRECT_END, $687ff8957497b063$export$e0021eb2979cddaa = $687ff8957497b063$var$HTTP_REQUEST_REDIRECT_START, $687ff8957497b063$export$7c0ac0c19a45beac = $687ff8957497b063$var$HTTP_REQUEST_REQUEST_START, $687ff8957497b063$export$6c32e9d84f534ee = $687ff8957497b063$var$HTTP_REQUEST_RESEND_COUNT, $687ff8957497b063$export$d1f9fbdb211dd29b = $687ff8957497b063$var$HTTP_REQUEST_RESPONSE_END, $687ff8957497b063$export$45e7eea99a17d6e4 = $687ff8957497b063$var$HTTP_REQUEST_RESPONSE_START, $687ff8957497b063$export$20ea34e16c0aa64f = $687ff8957497b063$var$HTTP_REQUEST_SAME_ORIGIN, $687ff8957497b063$export$8365b0f03557fae9 = $687ff8957497b063$var$HTTP_REQUEST_SECURE_CONNECTION_START, $687ff8957497b063$export$49ebbb9621675650 = $687ff8957497b063$var$HTTP_REQUEST_TIME_TO_FIRST_BYTE, $687ff8957497b063$export$842be66a901f093 = $687ff8957497b063$var$HTTP_REQUEST_WORKER_START, $687ff8957497b063$export$a9f5a6cb28adccb1 = $687ff8957497b063$var$HTTP_RESPONSE_BODY_SIZE, $687ff8957497b063$export$57b055d4bc586d67 = $687ff8957497b063$var$HTTP_RESPONSE_CONTENT_LENGTH, $687ff8957497b063$export$3ddfd660caa7bf7a = $687ff8957497b063$var$HTTP_RESPONSE_HEADER_CONTENT_LENGTH, $687ff8957497b063$export$fa7e1f5305153b3d = $687ff8957497b063$var$HTTP_RESPONSE_HEADER_KEY, $687ff8957497b063$export$5674ce9d013eb7bd = $687ff8957497b063$var$HTTP_RESPONSE_HEADER_KEY_BASE, $687ff8957497b063$export$6e8dc14cff6ccf72 = $687ff8957497b063$var$HTTP_RESPONSE_SIZE, $687ff8957497b063$export$afd59480458e1b57 = $687ff8957497b063$var$HTTP_RESPONSE_STATUS_CODE, $687ff8957497b063$export$48e61fb9bccccba9 = $687ff8957497b063$var$HTTP_RESPONSE_TRANSFER_SIZE, $687ff8957497b063$export$d3e674514dd3a3e1 = $687ff8957497b063$var$HTTP_ROUTE, $687ff8957497b063$export$97ad02b50c60ef68 = $687ff8957497b063$var$HTTP_SCHEME, $687ff8957497b063$export$61d053b1b63e82c4 = $687ff8957497b063$var$HTTP_SERVER_NAME, $687ff8957497b063$export$54256cce0d674dea = $687ff8957497b063$var$HTTP_SERVER_REQUEST_TIME_IN_QUEUE, $687ff8957497b063$export$8c01f0f407bcc5ca = $687ff8957497b063$var$HTTP_STATUS_CODE, $687ff8957497b063$export$be3f46982f6c7160 = $687ff8957497b063$var$HTTP_TARGET, $687ff8957497b063$export$778e4213e2788579 = $687ff8957497b063$var$HTTP_URL, $687ff8957497b063$export$8b48ca3594d2b172 = $687ff8957497b063$var$HTTP_USER_AGENT, $687ff8957497b063$export$8be180ec26319f9f = "id", $687ff8957497b063$export$60eccaddefa8fc1c = "inp", $687ff8957497b063$export$c99ce4fe37484d84 = $687ff8957497b063$var$JSONRPC_PROTOCOL_VERSION, $687ff8957497b063$export$fdf432fcac7d8f37 = $687ff8957497b063$var$JSONRPC_REQUEST_ID, $687ff8957497b063$export$4c21cc9cdf2f5dbd = $687ff8957497b063$var$JVM_GC_ACTION, $687ff8957497b063$export$dcc1eab7f3f31816 = $687ff8957497b063$var$JVM_GC_NAME, $687ff8957497b063$export$dcb7f1379b2b8f86 = $687ff8957497b063$var$JVM_MEMORY_POOL_NAME, $687ff8957497b063$export$53416edeea4c2d74 = $687ff8957497b063$var$JVM_MEMORY_TYPE, $687ff8957497b063$export$69f7e5d2b74c5c9e = $687ff8957497b063$var$JVM_THREAD_DAEMON, $687ff8957497b063$export$8e104aed582a26bc = $687ff8957497b063$var$JVM_THREAD_STATE, $687ff8957497b063$export$577047501949be9 = $687ff8957497b063$var$KOA_NAME, $687ff8957497b063$export$c4c45b599a2c15e = $687ff8957497b063$var$KOA_TYPE, $687ff8957497b063$export$361cb541700d648e = "lcp", $687ff8957497b063$export$974f160e11f25731 = $687ff8957497b063$var$LCP_ELEMENT, $687ff8957497b063$export$7162f5c702b95903 = $687ff8957497b063$var$LCP_ID, $687ff8957497b063$export$a034d066a9090500 = $687ff8957497b063$var$LCP_LOADTIME, $687ff8957497b063$export$70938021e43e047c = $687ff8957497b063$var$LCP_RENDERTIME, $687ff8957497b063$export$5f6ac460012a73bb = $687ff8957497b063$var$LCP_SIZE, $687ff8957497b063$export$d8e498c1c670bcbf = $687ff8957497b063$var$LCP_URL, $687ff8957497b063$export$cc1a78a24d947903 = $687ff8957497b063$var$LOGGER_NAME, $687ff8957497b063$export$d29b927e0bb0ffea = $687ff8957497b063$var$MCP_CANCELLED_REASON, $687ff8957497b063$export$b3999cacef245779 = $687ff8957497b063$var$MCP_CANCELLED_REQUEST_ID, $687ff8957497b063$export$ff168b5f9cf9dcf6 = $687ff8957497b063$var$MCP_CLIENT_NAME, $687ff8957497b063$export$2ab876a45bd6e64 = $687ff8957497b063$var$MCP_CLIENT_TITLE, $687ff8957497b063$export$cb8027e4395c6c0e = $687ff8957497b063$var$MCP_CLIENT_VERSION, $687ff8957497b063$export$f5303d1bac3c2660 = $687ff8957497b063$var$MCP_LIFECYCLE_PHASE, $687ff8957497b063$export$6c463c5f3b00f64 = $687ff8957497b063$var$MCP_LOGGING_DATA_TYPE, $687ff8957497b063$export$e25d553065457cab = $687ff8957497b063$var$MCP_LOGGING_LEVEL, $687ff8957497b063$export$15d24c154ea8a56f = $687ff8957497b063$var$MCP_LOGGING_LOGGER, $687ff8957497b063$export$e5065789a6c415d0 = $687ff8957497b063$var$MCP_LOGGING_MESSAGE, $687ff8957497b063$export$62662c561d7c7835 = $687ff8957497b063$var$MCP_METHOD_NAME, $687ff8957497b063$export$218f394557fb0a5a = $687ff8957497b063$var$MCP_PROGRESS_CURRENT, $687ff8957497b063$export$2a5ff6de5448ecdf = $687ff8957497b063$var$MCP_PROGRESS_MESSAGE, $687ff8957497b063$export$9d23f3030ed2597e = $687ff8957497b063$var$MCP_PROGRESS_PERCENTAGE, $687ff8957497b063$export$a26ff217a6124160 = $687ff8957497b063$var$MCP_PROGRESS_TOKEN, $687ff8957497b063$export$c8072f5fcfdb5b77 = $687ff8957497b063$var$MCP_PROGRESS_TOTAL, $687ff8957497b063$export$c4e4b74f1ccf3d96 = $687ff8957497b063$var$MCP_PROMPT_NAME, $687ff8957497b063$export$328519d02a26ac41 = $687ff8957497b063$var$MCP_PROMPT_RESULT_DESCRIPTION, $687ff8957497b063$export$d2061b291c43d045 = $687ff8957497b063$var$MCP_PROMPT_RESULT_MESSAGE_CONTENT, $687ff8957497b063$export$d1f04dfd3d695286 = $687ff8957497b063$var$MCP_PROMPT_RESULT_MESSAGE_COUNT, $687ff8957497b063$export$234fbd86ea0f0bd8 = $687ff8957497b063$var$MCP_PROMPT_RESULT_MESSAGE_ROLE, $687ff8957497b063$export$e795000978a75b12 = $687ff8957497b063$var$MCP_PROTOCOL_READY, $687ff8957497b063$export$9f4683b4d1018ace = $687ff8957497b063$var$MCP_PROTOCOL_VERSION, $687ff8957497b063$export$e431b042fcdb1d63 = $687ff8957497b063$var$MCP_REQUEST_ARGUMENT_KEY, $687ff8957497b063$export$a453239171ac9a23 = $687ff8957497b063$var$MCP_REQUEST_ARGUMENT_KEY_BASE, $687ff8957497b063$export$3a7726a976c18d5f = $687ff8957497b063$var$MCP_REQUEST_ARGUMENT_NAME, $687ff8957497b063$export$7eca7a6c06843b93 = $687ff8957497b063$var$MCP_REQUEST_ARGUMENT_URI, $687ff8957497b063$export$f25c55f83e5b0672 = $687ff8957497b063$var$MCP_REQUEST_ID, $687ff8957497b063$export$9562bfac4eb079cb = $687ff8957497b063$var$MCP_RESOURCE_PROTOCOL, $687ff8957497b063$export$c276d164ff91d2f7 = $687ff8957497b063$var$MCP_RESOURCE_URI, $687ff8957497b063$export$2f3e0574f1a99754 = $687ff8957497b063$var$MCP_SERVER_NAME, $687ff8957497b063$export$15eecaab68167880 = $687ff8957497b063$var$MCP_SERVER_TITLE, $687ff8957497b063$export$513c47f6e194086a = $687ff8957497b063$var$MCP_SERVER_VERSION, $687ff8957497b063$export$a3f464c4d5cd9096 = $687ff8957497b063$var$MCP_SESSION_ID, $687ff8957497b063$export$ed366a03a2330b03 = $687ff8957497b063$var$MCP_TOOL_NAME, $687ff8957497b063$export$9b802c784f235e1d = $687ff8957497b063$var$MCP_TOOL_RESULT_CONTENT, $687ff8957497b063$export$add0fc8b8c5726a4 = $687ff8957497b063$var$MCP_TOOL_RESULT_CONTENT_COUNT, $687ff8957497b063$export$e7f32463f5bfd554 = $687ff8957497b063$var$MCP_TOOL_RESULT_IS_ERROR, $687ff8957497b063$export$f9346f394edf26a = $687ff8957497b063$var$MCP_TRANSPORT, $687ff8957497b063$export$16b917774e73ef92 = $687ff8957497b063$var$MDC_KEY, $687ff8957497b063$export$15d2b60bf3b65454 = "mdc", $687ff8957497b063$export$db55eca5af256142 = $687ff8957497b063$var$MESSAGING_BATCH_MESSAGE_COUNT, $687ff8957497b063$export$967c74f8b1f3d35 = $687ff8957497b063$var$MESSAGING_DESTINATION, $687ff8957497b063$export$7c33ae67962515d1 = $687ff8957497b063$var$MESSAGING_DESTINATION_CONNECTION, $687ff8957497b063$export$9c69839b2d93489b = $687ff8957497b063$var$MESSAGING_DESTINATION_NAME, $687ff8957497b063$export$be22d22d4b6cf5d8 = $687ff8957497b063$var$MESSAGING_MESSAGE_BODY_SIZE, $687ff8957497b063$export$c529961b911626ac = $687ff8957497b063$var$MESSAGING_MESSAGE_CONVERSATION_ID, $687ff8957497b063$export$e39c4b15d2881f5 = $687ff8957497b063$var$MESSAGING_MESSAGE_ENVELOPE_SIZE, $687ff8957497b063$export$a8ca145161313e7 = $687ff8957497b063$var$MESSAGING_MESSAGE_ID, $687ff8957497b063$export$3c1204d03918d076 = $687ff8957497b063$var$MESSAGING_MESSAGE_RECEIVE_LATENCY, $687ff8957497b063$export$eaac3f141165e288 = $687ff8957497b063$var$MESSAGING_MESSAGE_RETRY_COUNT, $687ff8957497b063$export$4c7e6934714150e6 = $687ff8957497b063$var$MESSAGING_OPERATION_NAME, $687ff8957497b063$export$6f71f9711d666eb4 = $687ff8957497b063$var$MESSAGING_OPERATION_TYPE, $687ff8957497b063$export$2a3cd2bb71fb63a4 = $687ff8957497b063$var$MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY, $687ff8957497b063$export$55478a0b7d2ae98f = $687ff8957497b063$var$MESSAGING_SYSTEM, $687ff8957497b063$export$bed10c4da9b8eb0a = $687ff8957497b063$var$METHOD, $687ff8957497b063$export$a82607b6424c06c8 = $687ff8957497b063$var$MIDDLEWARE_NAME, $687ff8957497b063$export$6b081f3484c7f4e5 = $687ff8957497b063$var$NAVIGATION_ORIGIN, $687ff8957497b063$export$b7754d85fd39406c = $687ff8957497b063$var$NAVIGATION_ROUTE_ID, $687ff8957497b063$export$492856c046eb4728 = $687ff8957497b063$var$NAVIGATION_TYPE, $687ff8957497b063$export$c1678a2059fbe906 = $687ff8957497b063$var$NEL_ELAPSED_TIME, $687ff8957497b063$export$6d384a0bc1011c34 = $687ff8957497b063$var$NEL_PHASE, $687ff8957497b063$export$1499a7dbfc01e7d4 = $687ff8957497b063$var$NEL_REFERRER, $687ff8957497b063$export$cfcbff40019f0ff1 = $687ff8957497b063$var$NEL_SAMPLING_FUNCTION, $687ff8957497b063$export$27157b5f68e583af = $687ff8957497b063$var$NEL_TYPE, $687ff8957497b063$export$54bf5ed61532925d = $687ff8957497b063$var$NETWORK_CONNECTION_EFFECTIVE_TYPE, $687ff8957497b063$export$60ed0786292ace08 = $687ff8957497b063$var$NETWORK_CONNECTION_RTT, $687ff8957497b063$export$d770bfb8345e146 = $687ff8957497b063$var$NETWORK_CONNECTION_TYPE, $687ff8957497b063$export$bb73817f1290ad28 = $687ff8957497b063$var$NETWORK_LOCAL_ADDRESS, $687ff8957497b063$export$f201c980f2b75802 = $687ff8957497b063$var$NETWORK_LOCAL_PORT, $687ff8957497b063$export$b40e970572afd0ee = $687ff8957497b063$var$NETWORK_PEER_ADDRESS, $687ff8957497b063$export$8850630a3d343488 = $687ff8957497b063$var$NETWORK_PEER_PORT, $687ff8957497b063$export$fd0a39a918d6516f = $687ff8957497b063$var$NETWORK_PROTOCOL_NAME, $687ff8957497b063$export$e68ef41f8e0335bf = $687ff8957497b063$var$NETWORK_PROTOCOL_VERSION, $687ff8957497b063$export$5bff09650e762829 = $687ff8957497b063$var$NETWORK_TRANSPORT, $687ff8957497b063$export$21c1adce0e067f37 = $687ff8957497b063$var$NETWORK_TYPE, $687ff8957497b063$export$fed6ce86f48c84bc = $687ff8957497b063$var$NET_HOST_IP, $687ff8957497b063$export$500c2675137ac16e = $687ff8957497b063$var$NET_HOST_NAME, $687ff8957497b063$export$402c7728623fd8df = $687ff8957497b063$var$NET_HOST_PORT, $687ff8957497b063$export$15417259f4c0fe6b = $687ff8957497b063$var$NET_PEER_IP, $687ff8957497b063$export$2b3b7f579a727f45 = $687ff8957497b063$var$NET_PEER_NAME, $687ff8957497b063$export$514832a0b029734b = $687ff8957497b063$var$NET_PEER_PORT, $687ff8957497b063$export$b0522e6a14dec1a4 = $687ff8957497b063$var$NET_PROTOCOL_NAME, $687ff8957497b063$export$659ea19f71a7ee0b = $687ff8957497b063$var$NET_PROTOCOL_VERSION, $687ff8957497b063$export$1b61d972db315e73 = $687ff8957497b063$var$NET_SOCK_FAMILY, $687ff8957497b063$export$fb2970ee11a479ee = $687ff8957497b063$var$NET_SOCK_HOST_ADDR, $687ff8957497b063$export$920aceb2a8fad77e = $687ff8957497b063$var$NET_SOCK_HOST_PORT, $687ff8957497b063$export$48f8f6fbc999d187 = $687ff8957497b063$var$NET_SOCK_PEER_ADDR, $687ff8957497b063$export$eed590fa00a8223b = $687ff8957497b063$var$NET_SOCK_PEER_NAME, $687ff8957497b063$export$f2e5bb5cd4a130da = $687ff8957497b063$var$NET_SOCK_PEER_PORT, $687ff8957497b063$export$779ef03d633a9086 = $687ff8957497b063$var$NET_TRANSPORT, $687ff8957497b063$export$d98b87c8d53d0dbc = $687ff8957497b063$var$OS_BUILD, $687ff8957497b063$export$ca719aa57653a0a7 = $687ff8957497b063$var$OS_BUILD_ID, $687ff8957497b063$export$74b19c5f48270c05 = $687ff8957497b063$var$OS_DESCRIPTION, $687ff8957497b063$export$c351affe7e8098cb = $687ff8957497b063$var$OS_KERNEL_VERSION, $687ff8957497b063$export$be7cd6b3ae3ae765 = $687ff8957497b063$var$OS_NAME, $687ff8957497b063$export$ec182524c4c57275 = $687ff8957497b063$var$OS_RAW_DESCRIPTION, $687ff8957497b063$export$9e45758246a85b07 = $687ff8957497b063$var$OS_ROOTED, $687ff8957497b063$export$9fa5d5f0144954cb = $687ff8957497b063$var$OS_THEME, $687ff8957497b063$export$e66ba5bc4b978023 = $687ff8957497b063$var$OS_TYPE, $687ff8957497b063$export$2306e23cc611a36d = $687ff8957497b063$var$OS_VERSION, $687ff8957497b063$export$144f8c1fe01428db = $687ff8957497b063$var$OTEL_KIND, $687ff8957497b063$export$f303b2744d52121c = $687ff8957497b063$var$OTEL_SCOPE_NAME, $687ff8957497b063$export$866b2dbc7bf18ce6 = $687ff8957497b063$var$OTEL_SCOPE_VERSION, $687ff8957497b063$export$b4c85774878b4841 = $687ff8957497b063$var$OTEL_STATUS_CODE, $687ff8957497b063$export$1c967a71bc9a3077 = $687ff8957497b063$var$OTEL_STATUS_DESCRIPTION, $687ff8957497b063$export$5e3884a35a19eb90 = $687ff8957497b063$var$PARAMS_KEY, $687ff8957497b063$export$6e7ff99bb3259573 = $687ff8957497b063$var$PARAMS_KEY_BASE, $687ff8957497b063$export$7c932cba2d9e7a7 = $687ff8957497b063$var$PERFORMANCE_ACTIVATIONSTART, $687ff8957497b063$export$94091942edce0667 = $687ff8957497b063$var$PERFORMANCE_TIMEORIGIN, $687ff8957497b063$export$3671a8a524706a9d = $687ff8957497b063$var$PREVIOUS_ROUTE, $687ff8957497b063$export$c288888dc82d233f = $687ff8957497b063$var$PROCESS_COMMAND_ARGS, $687ff8957497b063$export$8ff188536cebc35 = $687ff8957497b063$var$PROCESS_EXECUTABLE_NAME, $687ff8957497b063$export$6407d78968c0eabe = $687ff8957497b063$var$PROCESS_PID, $687ff8957497b063$export$43e9fb9ec28d9743 = $687ff8957497b063$var$PROCESS_RUNTIME_DESCRIPTION, $687ff8957497b063$export$26f31d5c5c201739 = $687ff8957497b063$var$PROCESS_RUNTIME_ENGINE_NAME, $687ff8957497b063$export$bff85124d2d35b93 = $687ff8957497b063$var$PROCESS_RUNTIME_ENGINE_VERSION, $687ff8957497b063$export$495c671ed5a6408c = $687ff8957497b063$var$PROCESS_RUNTIME_NAME, $687ff8957497b063$export$54b3d4d5548c35c3 = $687ff8957497b063$var$PROCESS_RUNTIME_VERSION, $687ff8957497b063$export$2954db6444fe1fa8 = $687ff8957497b063$var$QUERY_KEY, $687ff8957497b063$export$15c1c974d16dd678 = $687ff8957497b063$var$QUERY_KEY_BASE, $687ff8957497b063$export$9be2ae89a1eac217 = $687ff8957497b063$var$REACT_VERSION, $687ff8957497b063$export$5c698591c0e586a2 = $687ff8957497b063$var$RELEASE, $687ff8957497b063$export$b711f2bb9c9a848a = $687ff8957497b063$var$REMIX_ACTION_FORM_DATA_KEY, $687ff8957497b063$export$1d3a8501efd30213 = $687ff8957497b063$var$REMIX_ACTION_FORM_DATA_KEY_BASE, $687ff8957497b063$export$cebaf684ced5a2c9 = $687ff8957497b063$var$REPLAY_ID, $687ff8957497b063$export$d4c658ecdcb7c78c = $687ff8957497b063$var$RESOURCE_DEPLOYMENT_ENVIRONMENT, $687ff8957497b063$export$b1b162b01baeb044 = $687ff8957497b063$var$RESOURCE_DEPLOYMENT_ENVIRONMENT_NAME, $687ff8957497b063$export$8be2d593d7f88ed8 = $687ff8957497b063$var$RESOURCE_RENDER_BLOCKING_STATUS, $687ff8957497b063$export$dbd0a3528a97ccc0 = $687ff8957497b063$var$ROUTE, $687ff8957497b063$export$66581dc6d3d083d1 = $687ff8957497b063$var$RPC_GRPC_STATUS_CODE, $687ff8957497b063$export$e545f99e7abcc499 = $687ff8957497b063$var$RPC_METHOD, $687ff8957497b063$export$7e1af5787f8c4aaa = $687ff8957497b063$var$RPC_RESPONSE_STATUS_CODE, $687ff8957497b063$export$186c94c351c54768 = $687ff8957497b063$var$RPC_SERVICE, $687ff8957497b063$export$2e3fd8dfcb16fe0c = $687ff8957497b063$var$RPC_SYSTEM, $687ff8957497b063$export$7eeeceaa1dbd7cd5 = $687ff8957497b063$var$RPC_SYSTEM_NAME, $687ff8957497b063$export$9d5bffdff936d554 = $687ff8957497b063$var$RUNTIME_BUILD, $687ff8957497b063$export$dc3a801c9a2c5b79 = $687ff8957497b063$var$RUNTIME_NAME, $687ff8957497b063$export$27933a9557f87e98 = $687ff8957497b063$var$RUNTIME_RAW_DESCRIPTION, $687ff8957497b063$export$eefa737b40a0d535 = $687ff8957497b063$var$RUNTIME_VERSION, $687ff8957497b063$export$92740ffbcb02553b = $687ff8957497b063$var$SCORE_KEY, $687ff8957497b063$export$500e89753f9f1008 = $687ff8957497b063$var$SCORE_KEY_BASE, $687ff8957497b063$export$d91a18e47fdddefd = $687ff8957497b063$var$SCORE_RATIO_KEY, $687ff8957497b063$export$eccbe6f20884ea7f = $687ff8957497b063$var$SCORE_RATIO_KEY_BASE, $687ff8957497b063$export$9e24f11d79141afb = $687ff8957497b063$var$SCORE_TOTAL, $687ff8957497b063$export$f0b96ad9586f8887 = $687ff8957497b063$var$SCORE_WEIGHT_KEY, $687ff8957497b063$export$8a92ed5d436a85c6 = $687ff8957497b063$var$SCORE_WEIGHT_KEY_BASE, $687ff8957497b063$export$edd59acdf7e86a71 = $687ff8957497b063$var$SENTRY_ACTION, $687ff8957497b063$export$ae81a1ae71952d50 = $687ff8957497b063$var$SENTRY_BROWSER_NAME, $687ff8957497b063$export$6101470cd57eac1b = $687ff8957497b063$var$SENTRY_BROWSER_VERSION, $687ff8957497b063$export$452c0aee9673fe67 = $687ff8957497b063$var$SENTRY_CANCELLATION_REASON, $687ff8957497b063$export$773dddd1e8667756 = $687ff8957497b063$var$SENTRY_CATEGORY, $687ff8957497b063$export$98815f8579a64a90 = $687ff8957497b063$var$SENTRY_CLIENT_SAMPLE_RATE, $687ff8957497b063$export$7bc4e27428665019 = $687ff8957497b063$var$SENTRY_DESCRIPTION, $687ff8957497b063$export$e7d7477fa9057ee2 = $687ff8957497b063$var$SENTRY_DIST, $687ff8957497b063$export$1f4267a3fc018448 = $687ff8957497b063$var$SENTRY_DOMAIN, $687ff8957497b063$export$c171cae150389952 = $687ff8957497b063$var$SENTRY_DSC_ENVIRONMENT, $687ff8957497b063$export$d9bb35e957b22c72 = $687ff8957497b063$var$SENTRY_DSC_PROJECT_ID, $687ff8957497b063$export$b3508a2c95f74e3d = $687ff8957497b063$var$SENTRY_DSC_PUBLIC_KEY, $687ff8957497b063$export$20bb272f4d21532d = $687ff8957497b063$var$SENTRY_DSC_RELEASE, $687ff8957497b063$export$d7e64fbd0102ce90 = $687ff8957497b063$var$SENTRY_DSC_SAMPLED, $687ff8957497b063$export$c17eae7e86dbba3c = $687ff8957497b063$var$SENTRY_DSC_SAMPLE_RATE, $687ff8957497b063$export$349603c0a9165744 = $687ff8957497b063$var$SENTRY_DSC_TRACE_ID, $687ff8957497b063$export$4dadf693741f0283 = $687ff8957497b063$var$SENTRY_DSC_TRANSACTION, $687ff8957497b063$export$6377864d12f7eeb3 = $687ff8957497b063$var$SENTRY_ENVIRONMENT, $687ff8957497b063$export$ba081af9585ed4 = $687ff8957497b063$var$SENTRY_EXCLUSIVE_TIME, $687ff8957497b063$export$7841dacb241485d0 = $687ff8957497b063$var$SENTRY_GRAPHQL_OPERATION, $687ff8957497b063$export$52c7044cf6301362 = $687ff8957497b063$var$SENTRY_GROUP, $687ff8957497b063$export$56ea1c9e44590e20 = $687ff8957497b063$var$SENTRY_HTTP_PREFETCH, $687ff8957497b063$export$7626e389d05f4c36 = $687ff8957497b063$var$SENTRY_IDLE_SPAN_FINISH_REASON, $687ff8957497b063$export$5e0a48187329b2e7 = $687ff8957497b063$var$SENTRY_IS_REMOTE, $687ff8957497b063$export$c322b150d7667841 = $687ff8957497b063$var$SENTRY_KIND, $687ff8957497b063$export$4a4797d3c962f753 = $687ff8957497b063$var$SENTRY_MAIN_THREAD, $687ff8957497b063$export$767524d5e72e2645 = $687ff8957497b063$var$SENTRY_MESSAGE_PARAMETER_KEY, $687ff8957497b063$export$497354ca7b0ee666 = $687ff8957497b063$var$SENTRY_MESSAGE_TEMPLATE, $687ff8957497b063$export$cbdc4ad11118116a = $687ff8957497b063$var$SENTRY_METRIC_SOURCE, $687ff8957497b063$export$5b890de778c4c2fe = $687ff8957497b063$var$SENTRY_MOBILE, $687ff8957497b063$export$a78d9803b5e0a83e = $687ff8957497b063$var$SENTRY_MODULE_KEY, $687ff8957497b063$export$df1b536467b3992a = $687ff8957497b063$var$SENTRY_MODULE_KEY_BASE, $687ff8957497b063$export$73104a329e205998 = $687ff8957497b063$var$SENTRY_NEXTJS_SSR_FUNCTION_ROUTE, $687ff8957497b063$export$5740e3da55330b0a = $687ff8957497b063$var$SENTRY_NEXTJS_SSR_FUNCTION_TYPE, $687ff8957497b063$export$8dcc2d92ff6d65da = $687ff8957497b063$var$SENTRY_NORMALIZED_DB_QUERY, $687ff8957497b063$export$e5f1321e53e24810 = $687ff8957497b063$var$SENTRY_NORMALIZED_DB_QUERY_HASH, $687ff8957497b063$export$56dd3098cbca7c8a = $687ff8957497b063$var$SENTRY_NORMALIZED_DESCRIPTION, $687ff8957497b063$export$aa7aff70e4380665 = $687ff8957497b063$var$SENTRY_OBSERVED_TIMESTAMP_NANOS, $687ff8957497b063$export$dacb7d452aa6bcaf = $687ff8957497b063$var$SENTRY_OP, $687ff8957497b063$export$15dfc6c5e8f9baf6 = $687ff8957497b063$var$SENTRY_ORIGIN, $687ff8957497b063$export$91ad03bba7909fb5 = $687ff8957497b063$var$SENTRY_PLATFORM, $687ff8957497b063$export$86128e6c0ab71d64 = $687ff8957497b063$var$SENTRY_PROFILER_ID, $687ff8957497b063$export$745b60c4819aec1d = $687ff8957497b063$var$SENTRY_PROFILE_ID, $687ff8957497b063$export$d2c893bfac1da9a1 = $687ff8957497b063$var$SENTRY_RELEASE, $687ff8957497b063$export$1c14ad02f9534b19 = $687ff8957497b063$var$SENTRY_REPLAY_ID, $687ff8957497b063$export$db3cb63e0594d014 = $687ff8957497b063$var$SENTRY_REPLAY_IS_BUFFERING, $687ff8957497b063$export$a65c9a0eba2c222d = $687ff8957497b063$var$SENTRY_REPORT_EVENT, $687ff8957497b063$export$68dbcca9c0e339ec = $687ff8957497b063$var$SENTRY_SDK_INTEGRATIONS, $687ff8957497b063$export$d59b669d4bb3f006 = $687ff8957497b063$var$SENTRY_SDK_NAME, $687ff8957497b063$export$4d88d347aa9667fc = $687ff8957497b063$var$SENTRY_SDK_VERSION, $687ff8957497b063$export$9943ffdcaa4bc506 = $687ff8957497b063$var$SENTRY_SEGMENT_ID, $687ff8957497b063$export$d4f25b923533dbba = $687ff8957497b063$var$SENTRY_SEGMENT_NAME, $687ff8957497b063$export$35f3396a1cdeea45 = $687ff8957497b063$var$SENTRY_SERVER_SAMPLE_RATE, $687ff8957497b063$export$80e399da474bc98d = $687ff8957497b063$var$SENTRY_SOURCE, $687ff8957497b063$export$e01809e2dbceac35 = $687ff8957497b063$var$SENTRY_SPAN_SOURCE, $687ff8957497b063$export$41900d5c4e8a9c68 = $687ff8957497b063$var$SENTRY_STATUS, $687ff8957497b063$export$362bb1cb0bb5ca03 = $687ff8957497b063$var$SENTRY_STATUS_CODE, $687ff8957497b063$export$6803ac54f919d9cc = $687ff8957497b063$var$SENTRY_STATUS_MESSAGE, $687ff8957497b063$export$72f5b47540331169 = $687ff8957497b063$var$SENTRY_SVELTEKIT_NAVIGATION_FROM, $687ff8957497b063$export$6c61a8c9aa5305cb = $687ff8957497b063$var$SENTRY_SVELTEKIT_NAVIGATION_TO, $687ff8957497b063$export$6b5244c457b68e65 = $687ff8957497b063$var$SENTRY_SVELTEKIT_NAVIGATION_TYPE, $687ff8957497b063$export$b7bd0c9a886f3414 = $687ff8957497b063$var$SENTRY_THREAD_ID, $687ff8957497b063$export$6b77f2bacac7c93d = $687ff8957497b063$var$SENTRY_TIMESTAMP_SEQUENCE, $687ff8957497b063$export$ddbc15c0e8e8a7ea = $687ff8957497b063$var$SENTRY_TRACE_LIFECYCLE, $687ff8957497b063$export$feb4fe753df28a82 = $687ff8957497b063$var$SENTRY_TRACE_PARENT_SPAN_ID, $687ff8957497b063$export$d6267756132e2175 = $687ff8957497b063$var$SENTRY_TRACE_STATUS, $687ff8957497b063$export$570ac5a3fd7e6cc6 = $687ff8957497b063$var$SENTRY_TRANSACTION, $687ff8957497b063$export$5b9a0015e1c530ed = $687ff8957497b063$var$SENTRY_USER_EMAIL, $687ff8957497b063$export$8bbff71c84508218 = $687ff8957497b063$var$SENTRY_USER_GEO_CITY, $687ff8957497b063$export$b55aa07a514a2430 = $687ff8957497b063$var$SENTRY_USER_GEO_COUNTRY_CODE, $687ff8957497b063$export$9927ad09f7c084dc = $687ff8957497b063$var$SENTRY_USER_GEO_REGION, $687ff8957497b063$export$52a07a35ff8ec6b6 = $687ff8957497b063$var$SENTRY_USER_GEO_SUBDIVISION, $687ff8957497b063$export$a10d277c42e6cae3 = $687ff8957497b063$var$SENTRY_USER_ID, $687ff8957497b063$export$cdc0ce5c66182801 = $687ff8957497b063$var$SENTRY_USER_IP, $687ff8957497b063$export$2504d4bd698dd962 = $687ff8957497b063$var$SENTRY_USER_USERNAME, $687ff8957497b063$export$9dc86f3b876e96ef = $687ff8957497b063$var$SERVER_ADDRESS, $687ff8957497b063$export$70ff7865f52549ae = $687ff8957497b063$var$SERVER_NAME, $687ff8957497b063$export$f77b53a42be6e6fd = $687ff8957497b063$var$SERVER_PORT, $687ff8957497b063$export$818eb7ab11414506 = $687ff8957497b063$var$SERVICE_NAME, $687ff8957497b063$export$829ef6b2e59d984d = $687ff8957497b063$var$SERVICE_VERSION, $687ff8957497b063$export$b30f4cb52c088a26 = $687ff8957497b063$var$SESSION_ID, $687ff8957497b063$export$335eace0ff1771cd = $687ff8957497b063$var$STALL_PERCENTAGE, $687ff8957497b063$export$374d88a2025416ac = $687ff8957497b063$var$STALL_TOTAL_TIME, $687ff8957497b063$export$bb7a91303551eb37 = $687ff8957497b063$var$STATE_TYPE, $687ff8957497b063$export$f132ea291a7db56b = $687ff8957497b063$var$THREAD_ID, $687ff8957497b063$export$f0abd4170bbd2468 = $687ff8957497b063$var$THREAD_NAME, $687ff8957497b063$export$50d00a157dc08581 = $687ff8957497b063$var$TIMBER_TAG, $687ff8957497b063$export$484576567a98833f = $687ff8957497b063$var$TIME_TO_FULL_DISPLAY, $687ff8957497b063$export$ec9e491e475d0c97 = $687ff8957497b063$var$TIME_TO_INITIAL_DISPLAY, $687ff8957497b063$export$a86c59c10992220f = $687ff8957497b063$var$TRANSACTION, $687ff8957497b063$export$e12f06597e992fde = $687ff8957497b063$var$TRPC_PROCEDURE_PATH, $687ff8957497b063$export$7ec54678ba28ea59 = $687ff8957497b063$var$TRPC_PROCEDURE_TYPE, $687ff8957497b063$export$433ba14c16717110 = $687ff8957497b063$var$TTFB, $687ff8957497b063$export$309ee349b8a537f = $687ff8957497b063$var$TTFB_REQUESTTIME, $687ff8957497b063$export$b87f371cbc396fcf = $687ff8957497b063$var$TYPE, $687ff8957497b063$export$60050fc49fe0e7e2 = $687ff8957497b063$var$UI_COMPONENT_NAME, $687ff8957497b063$export$348c8e2b37f276cd = $687ff8957497b063$var$UI_CONTRIBUTES_TO_TTFD, $687ff8957497b063$export$7f47e8a8b2d97cb2 = $687ff8957497b063$var$UI_CONTRIBUTES_TO_TTID, $687ff8957497b063$export$50d5adc4b543ce95 = $687ff8957497b063$var$UI_ELEMENT_HEIGHT, $687ff8957497b063$export$9221f1d2c934d9f = $687ff8957497b063$var$UI_ELEMENT_ID, $687ff8957497b063$export$3a56578b3ae09a02 = $687ff8957497b063$var$UI_ELEMENT_IDENTIFIER, $687ff8957497b063$export$e47b8dab9466c895 = $687ff8957497b063$var$UI_ELEMENT_LOAD_TIME, $687ff8957497b063$export$4ca52f75cf4889c5 = $687ff8957497b063$var$UI_ELEMENT_PAINT_TYPE, $687ff8957497b063$export$7343d7d72195067f = $687ff8957497b063$var$UI_ELEMENT_RENDER_TIME, $687ff8957497b063$export$f334f32f8d4d8063 = $687ff8957497b063$var$UI_ELEMENT_TYPE, $687ff8957497b063$export$c7bf2089e89a217c = $687ff8957497b063$var$UI_ELEMENT_URL, $687ff8957497b063$export$f514f97553a434b2 = $687ff8957497b063$var$UI_ELEMENT_WIDTH, $687ff8957497b063$export$61abde59b50deb8e = "url", $687ff8957497b063$export$5a5ce44f9fb51f93 = $687ff8957497b063$var$URL_DOMAIN, $687ff8957497b063$export$7044ea8d89b6f59d = $687ff8957497b063$var$URL_FRAGMENT, $687ff8957497b063$export$40eacf1a072c9dbd = $687ff8957497b063$var$URL_FULL, $687ff8957497b063$export$4c1fa0ac0eff2ac = $687ff8957497b063$var$URL_PATH, $687ff8957497b063$export$5bee9450fe31dde1 = $687ff8957497b063$var$URL_PATH_PARAMETER_KEY, $687ff8957497b063$export$d0b571fb4406d953 = $687ff8957497b063$var$URL_PATH_PARAMETER_KEY_BASE, $687ff8957497b063$export$258b370e6c2b85d5 = $687ff8957497b063$var$URL_PORT, $687ff8957497b063$export$dc5e5523da291a4b = $687ff8957497b063$var$URL_QUERY, $687ff8957497b063$export$fd5a8904ab5abfe0 = $687ff8957497b063$var$URL_SAME_ORIGIN, $687ff8957497b063$export$1350d8937b0f26fb = $687ff8957497b063$var$URL_SCHEME, $687ff8957497b063$export$2a045f777fb349a8 = $687ff8957497b063$var$URL_TEMPLATE, $687ff8957497b063$export$8bb874585539a88f = $687ff8957497b063$var$USER_AGENT_ORIGINAL, $687ff8957497b063$export$17d3a50785727199 = $687ff8957497b063$var$USER_EMAIL, $687ff8957497b063$export$2931c570009689e = $687ff8957497b063$var$USER_FULL_NAME, $687ff8957497b063$export$199cbcedee735a43 = $687ff8957497b063$var$USER_GEO_CITY, $687ff8957497b063$export$4ba5bf9d4e3ed862 = $687ff8957497b063$var$USER_GEO_COUNTRY_CODE, $687ff8957497b063$export$674c01ec2f0b89c3 = $687ff8957497b063$var$USER_GEO_REGION, $687ff8957497b063$export$bda1686739fd61c7 = $687ff8957497b063$var$USER_GEO_SUBDIVISION, $687ff8957497b063$export$8d804148f485d54c = $687ff8957497b063$var$USER_HASH, $687ff8957497b063$export$212a8f1ea37518bd = $687ff8957497b063$var$USER_ID, $687ff8957497b063$export$c9ac0fee28245883 = $687ff8957497b063$var$USER_IP_ADDRESS, $687ff8957497b063$export$77078610759fe5f6 = $687ff8957497b063$var$USER_NAME, $687ff8957497b063$export$7c6317deeec7a6c1 = $687ff8957497b063$var$USER_ROLES, $687ff8957497b063$export$877ebf2e4ad81f03 = $687ff8957497b063$var$VERCEL_BRANCH, $687ff8957497b063$export$70b2343945496e1f = $687ff8957497b063$var$VERCEL_BUILD_ID, $687ff8957497b063$export$8415b56d2c6d2b1d = $687ff8957497b063$var$VERCEL_DEPLOYMENT_ID, $687ff8957497b063$export$cc81114a03caab18 = $687ff8957497b063$var$VERCEL_DESTINATION, $687ff8957497b063$export$bc14eb892daceb23 = $687ff8957497b063$var$VERCEL_EDGE_TYPE, $687ff8957497b063$export$3c973217450c3e9d = $687ff8957497b063$var$VERCEL_ENTRYPOINT, $687ff8957497b063$export$582c0b730ff1ddb9 = $687ff8957497b063$var$VERCEL_EXECUTION_REGION, $687ff8957497b063$export$b3edfb545b65f1c5 = $687ff8957497b063$var$VERCEL_ID, $687ff8957497b063$export$2593317d8731841c = $687ff8957497b063$var$VERCEL_JA3_DIGEST, $687ff8957497b063$export$8bb5bc1732aa41f = $687ff8957497b063$var$VERCEL_JA4_DIGEST, $687ff8957497b063$export$74a79c98b110b5b9 = $687ff8957497b063$var$VERCEL_LOG_TYPE, $687ff8957497b063$export$26461b03281b4db4 = $687ff8957497b063$var$VERCEL_PATH, $687ff8957497b063$export$eaea590d6d3dd93c = $687ff8957497b063$var$VERCEL_PROJECT_ID, $687ff8957497b063$export$af45365f70099379 = $687ff8957497b063$var$VERCEL_PROJECT_NAME, $687ff8957497b063$export$a49e732d34d5ba9b = $687ff8957497b063$var$VERCEL_PROXY_CACHE_ID, $687ff8957497b063$export$7c147fe246bc8bd3 = $687ff8957497b063$var$VERCEL_PROXY_CLIENT_IP, $687ff8957497b063$export$e5111b6070e1ee9e = $687ff8957497b063$var$VERCEL_PROXY_HOST, $687ff8957497b063$export$591cbfd403f8c8d = $687ff8957497b063$var$VERCEL_PROXY_LAMBDA_REGION, $687ff8957497b063$export$b1388db955bbb885 = $687ff8957497b063$var$VERCEL_PROXY_METHOD, $687ff8957497b063$export$e898d0e9e211abd9 = $687ff8957497b063$var$VERCEL_PROXY_PATH, $687ff8957497b063$export$ab6fee0e8a6ee069 = $687ff8957497b063$var$VERCEL_PROXY_PATH_TYPE, $687ff8957497b063$export$9786ad94c199ffbb = $687ff8957497b063$var$VERCEL_PROXY_PATH_TYPE_VARIANT, $687ff8957497b063$export$269890524eed693b = $687ff8957497b063$var$VERCEL_PROXY_REFERER, $687ff8957497b063$export$2ec623a8212d6b64 = $687ff8957497b063$var$VERCEL_PROXY_REGION, $687ff8957497b063$export$30e7673b01ff994e = $687ff8957497b063$var$VERCEL_PROXY_RESPONSE_BYTE_SIZE, $687ff8957497b063$export$9ea93477840812bf = $687ff8957497b063$var$VERCEL_PROXY_SCHEME, $687ff8957497b063$export$a6da0c365670c430 = $687ff8957497b063$var$VERCEL_PROXY_STATUS_CODE, $687ff8957497b063$export$7986b22da43f2885 = $687ff8957497b063$var$VERCEL_PROXY_TIMESTAMP, $687ff8957497b063$export$a9f943c7ceb3b42f = $687ff8957497b063$var$VERCEL_PROXY_USER_AGENT, $687ff8957497b063$export$dfe49501efcdffce = $687ff8957497b063$var$VERCEL_PROXY_VERCEL_CACHE, $687ff8957497b063$export$be465f50c92eb01d = $687ff8957497b063$var$VERCEL_PROXY_VERCEL_ID, $687ff8957497b063$export$c138d1796bb34999 = $687ff8957497b063$var$VERCEL_PROXY_WAF_ACTION, $687ff8957497b063$export$85a0016690a0ccf2 = $687ff8957497b063$var$VERCEL_PROXY_WAF_RULE_ID, $687ff8957497b063$export$883acab36ede4bfa = $687ff8957497b063$var$VERCEL_REQUEST_ID, $687ff8957497b063$export$9cfc88d203f9cdf1 = $687ff8957497b063$var$VERCEL_SOURCE, $687ff8957497b063$export$b3c6c599110d7bab = $687ff8957497b063$var$VERCEL_STATUS_CODE, $687ff8957497b063$export$247839c65766758 = $687ff8957497b063$var$_AWS_KINESIS_STREAM_NAME, $687ff8957497b063$export$f4d52b02df927d54 = $687ff8957497b063$var$_AWS_REQUEST_ID, $687ff8957497b063$export$df30ee8c5b5f1989 = $687ff8957497b063$var$_HTTP_REQUEST_METHOD, $687ff8957497b063$export$268a117c860fca6d = $687ff8957497b063$var$_SENTRY_SEGMENT_ID; //# sourceMappingURL=attributes.cjs.map

});



parcelRegister("aK1wS", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kfJmY = parcelRequire("kfJmY");

var $1GyI0 = parcelRequire("1GyI0");

var $3uEjM = parcelRequire("3uEjM");

var $2sm2V = parcelRequire("2sm2V");

var $lWhcW = parcelRequire("lWhcW");

var $dGSc0 = parcelRequire("dGSc0");

var $fxVZv = parcelRequire("fxVZv");
function $7d1f62f12f5702ae$var$captureException(exception, hint) {
    return $kfJmY.getCurrentScope().captureException(exception, $lWhcW.parseEventHintOrCaptureContext(hint));
}
function $7d1f62f12f5702ae$var$captureMessage(message, captureContext) {
    const level = typeof captureContext === "string" ? captureContext : void 0;
    const hint = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : void 0;
    return $kfJmY.getCurrentScope().captureMessage(message, level, hint);
}
function $7d1f62f12f5702ae$var$captureEvent(event, hint) {
    return $kfJmY.getCurrentScope().captureEvent(event, hint);
}
function $7d1f62f12f5702ae$var$setContext(name, context) {
    $kfJmY.getIsolationScope().setContext(name, context);
}
function $7d1f62f12f5702ae$var$setExtras(extras) {
    $kfJmY.getIsolationScope().setExtras(extras);
}
function $7d1f62f12f5702ae$var$setExtra(key, extra) {
    $kfJmY.getIsolationScope().setExtra(key, extra);
}
function $7d1f62f12f5702ae$var$setTags(tags) {
    $kfJmY.getIsolationScope().setTags(tags);
}
function $7d1f62f12f5702ae$var$setTag(key, value) {
    $kfJmY.getIsolationScope().setTag(key, value);
}
function $7d1f62f12f5702ae$var$setAttributes(attributes) {
    $kfJmY.getIsolationScope().setAttributes(attributes);
}
function $7d1f62f12f5702ae$var$setAttribute(key, value) {
    $kfJmY.getIsolationScope().setAttribute(key, value);
}
function $7d1f62f12f5702ae$var$setUser(user) {
    $kfJmY.getIsolationScope().setUser(user);
}
function $7d1f62f12f5702ae$var$setConversationId(conversationId) {
    $kfJmY.getIsolationScope().setConversationId(conversationId);
}
function $7d1f62f12f5702ae$var$lastEventId() {
    return $kfJmY.getIsolationScope().lastEventId();
}
async function $7d1f62f12f5702ae$var$flush(timeout) {
    const client = $kfJmY.getClient();
    if (client) return client.flush(timeout);
    $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
async function $7d1f62f12f5702ae$var$close(timeout) {
    const client = $kfJmY.getClient();
    if (client) return client.close(timeout);
    $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
function $7d1f62f12f5702ae$var$isInitialized() {
    return !!$kfJmY.getClient();
}
function $7d1f62f12f5702ae$var$isEnabled() {
    const client = $kfJmY.getClient();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
function $7d1f62f12f5702ae$var$addEventProcessor(callback) {
    $kfJmY.getIsolationScope().addEventProcessor(callback);
}
function $7d1f62f12f5702ae$var$startSession(context) {
    const isolationScope = $kfJmY.getIsolationScope();
    const { user: user } = $dGSc0.getCombinedScopeData(isolationScope, $kfJmY.getCurrentScope());
    const { userAgent: userAgent } = $fxVZv.GLOBAL_OBJ.navigator || {};
    const session$1 = $3uEjM.makeSession({
        user: user,
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === "ok") $3uEjM.updateSession(currentSession, {
        status: "exited"
    });
    $7d1f62f12f5702ae$var$endSession();
    isolationScope.setSession(session$1);
    return session$1;
}
function $7d1f62f12f5702ae$var$endSession() {
    const isolationScope = $kfJmY.getIsolationScope();
    const currentScope = $kfJmY.getCurrentScope();
    const session$1 = currentScope.getSession() || isolationScope.getSession();
    if (session$1) $3uEjM.closeSession(session$1);
    $7d1f62f12f5702ae$var$_sendSessionUpdate();
    isolationScope.setSession();
}
function $7d1f62f12f5702ae$var$_sendSessionUpdate() {
    const isolationScope = $kfJmY.getIsolationScope();
    const client = $kfJmY.getClient();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
function $7d1f62f12f5702ae$var$captureSession(end = false) {
    if (end) {
        $7d1f62f12f5702ae$var$endSession();
        return;
    }
    $7d1f62f12f5702ae$var$_sendSessionUpdate();
}
module.exports.addEventProcessor = $7d1f62f12f5702ae$var$addEventProcessor;
module.exports.captureEvent = $7d1f62f12f5702ae$var$captureEvent;
module.exports.captureException = $7d1f62f12f5702ae$var$captureException;
module.exports.captureMessage = $7d1f62f12f5702ae$var$captureMessage;
module.exports.captureSession = $7d1f62f12f5702ae$var$captureSession;
module.exports.close = $7d1f62f12f5702ae$var$close;
module.exports.endSession = $7d1f62f12f5702ae$var$endSession;
module.exports.flush = $7d1f62f12f5702ae$var$flush;
module.exports.isEnabled = $7d1f62f12f5702ae$var$isEnabled;
module.exports.isInitialized = $7d1f62f12f5702ae$var$isInitialized;
module.exports.lastEventId = $7d1f62f12f5702ae$var$lastEventId;
module.exports.setAttribute = $7d1f62f12f5702ae$var$setAttribute;
module.exports.setAttributes = $7d1f62f12f5702ae$var$setAttributes;
module.exports.setContext = $7d1f62f12f5702ae$var$setContext;
module.exports.setConversationId = $7d1f62f12f5702ae$var$setConversationId;
module.exports.setExtra = $7d1f62f12f5702ae$var$setExtra;
module.exports.setExtras = $7d1f62f12f5702ae$var$setExtras;
module.exports.setTag = $7d1f62f12f5702ae$var$setTag;
module.exports.setTags = $7d1f62f12f5702ae$var$setTags;
module.exports.setUser = $7d1f62f12f5702ae$var$setUser;
module.exports.startSession = $7d1f62f12f5702ae$var$startSession;

});
parcelRegister("lWhcW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $QGp01 = parcelRequire("QGp01");

var $6lKwf = parcelRequire("6lKwf");

var $aBj8W = parcelRequire("aBj8W");

var $97cmn = parcelRequire("97cmn");

var $jR1Dv = parcelRequire("jR1Dv");

var $2ZrfN = parcelRequire("2ZrfN");

var $dGSc0 = parcelRequire("dGSc0");

var $1L2sM = parcelRequire("1L2sM");

var $3MHSz = parcelRequire("3MHSz");

var $gU6V8 = parcelRequire("gU6V8");
function $ff8c5cdbd47b8f30$var$prepareEvent(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || $jR1Dv.uuid4(),
        timestamp: event.timestamp || $gU6V8.dateTimestampInSeconds()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $ff8c5cdbd47b8f30$var$applyClientOptions(prepared, options);
    $ff8c5cdbd47b8f30$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    if (event.type === void 0) $ff8c5cdbd47b8f30$var$applyDebugIds(prepared, options.stackParser);
    const finalScope = $ff8c5cdbd47b8f30$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) $jR1Dv.addExceptionMechanism(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    const data = $dGSc0.getCombinedScopeData(isolationScope, finalScope);
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    $dGSc0.applyScopeDataToEvent(prepared, data);
    const eventProcessors$1 = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const isInternalException = hint.data && hint.data.__sentry__ === true;
    const result = isInternalException ? $3MHSz.resolvedSyncPromise(prepared) : $6lKwf.notifyEventProcessors(eventProcessors$1, prepared, hint);
    return result.then((evt)=>{
        if (evt) $ff8c5cdbd47b8f30$var$applyDebugMeta(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $ff8c5cdbd47b8f30$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
function $ff8c5cdbd47b8f30$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength } = options;
    event.environment = event.environment || environment || $QGp01.DEFAULT_ENVIRONMENT;
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url && maxValueLength) request.url = $1L2sM.truncate(request.url, maxValueLength);
    if (maxValueLength) event.exception?.values?.forEach((exception)=>{
        if (exception.value) exception.value = $1L2sM.truncate(exception.value, maxValueLength);
    });
}
function $ff8c5cdbd47b8f30$var$applyDebugIds(event, stackParser) {
    const filenameDebugIdMap = $97cmn.getFilenameToDebugIdMap(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
function $ff8c5cdbd47b8f30$var$applyDebugMeta(event) {
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
function $ff8c5cdbd47b8f30$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
function $ff8c5cdbd47b8f30$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: $2ZrfN.normalize(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: $2ZrfN.normalize(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: $2ZrfN.normalize(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: $2ZrfN.normalize(event.extra, depth, maxBreadth)
        }
    };
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        if (event.contexts.trace.data) normalized.contexts.trace.data = $2ZrfN.normalize(event.contexts.trace.data, depth, maxBreadth);
    }
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: $2ZrfN.normalize(span.data, depth, maxBreadth)
            }
        };
    });
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = $2ZrfN.normalize(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $ff8c5cdbd47b8f30$var$getFinalScope(scope$1, captureContext) {
    if (!captureContext) return scope$1;
    const finalScope = scope$1 ? scope$1.clone() : new $aBj8W.Scope();
    finalScope.update(captureContext);
    return finalScope;
}
function $ff8c5cdbd47b8f30$var$parseEventHintOrCaptureContext(hint) {
    if (!hint) return void 0;
    if ($ff8c5cdbd47b8f30$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($ff8c5cdbd47b8f30$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $ff8c5cdbd47b8f30$var$hintIsScopeOrFunction(hint) {
    return hint instanceof $aBj8W.Scope || typeof hint === "function";
}
const $ff8c5cdbd47b8f30$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "propagationContext"
];
function $ff8c5cdbd47b8f30$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$ff8c5cdbd47b8f30$var$captureContextKeys.includes(key));
}
module.exports.applyClientOptions = $ff8c5cdbd47b8f30$var$applyClientOptions;
module.exports.applyDebugIds = $ff8c5cdbd47b8f30$var$applyDebugIds;
module.exports.applyDebugMeta = $ff8c5cdbd47b8f30$var$applyDebugMeta;
module.exports.parseEventHintOrCaptureContext = $ff8c5cdbd47b8f30$var$parseEventHintOrCaptureContext;
module.exports.prepareEvent = $ff8c5cdbd47b8f30$var$prepareEvent;

});
parcelRegister("6lKwf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1GyI0 = parcelRequire("1GyI0");

var $2sm2V = parcelRequire("2sm2V");

var $jV7hg = parcelRequire("jV7hg");

var $3MHSz = parcelRequire("3MHSz");
function $49f8c9f9f3e9e755$var$notifyEventProcessors(processors, event, hint, index = 0) {
    try {
        const result = $49f8c9f9f3e9e755$var$_notifyEventProcessors(event, hint, processors, index);
        return $jV7hg.isThenable(result) ? result : $3MHSz.resolvedSyncPromise(result);
    } catch (error) {
        return $3MHSz.rejectedSyncPromise(error);
    }
}
function $49f8c9f9f3e9e755$var$_notifyEventProcessors(event, hint, processors, index) {
    const processor = processors[index];
    if (!event || !processor) return event;
    const result = processor({
        ...event
    }, hint);
    $1GyI0.DEBUG_BUILD && result === null && $2sm2V.debug.log(`Event processor "${processor.id || "?"}" dropped event`);
    if ($jV7hg.isThenable(result)) return result.then((final)=>$49f8c9f9f3e9e755$var$_notifyEventProcessors(final, hint, processors, index + 1));
    return $49f8c9f9f3e9e755$var$_notifyEventProcessors(result, hint, processors, index + 1);
}
module.exports.notifyEventProcessors = $49f8c9f9f3e9e755$var$notifyEventProcessors;

});
parcelRegister("3MHSz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jV7hg = parcelRequire("jV7hg");
const $2c17e44c51e80b2e$var$STATE_PENDING = 0;
const $2c17e44c51e80b2e$var$STATE_RESOLVED = 1;
const $2c17e44c51e80b2e$var$STATE_REJECTED = 2;
function $2c17e44c51e80b2e$var$resolvedSyncPromise(value) {
    return new $2c17e44c51e80b2e$var$SyncPromise((resolve)=>{
        resolve(value);
    });
}
function $2c17e44c51e80b2e$var$rejectedSyncPromise(reason) {
    return new $2c17e44c51e80b2e$var$SyncPromise((_, reject)=>{
        reject(reason);
    });
}
class $2c17e44c51e80b2e$var$SyncPromise {
    constructor(executor){
        this._state = $2c17e44c51e80b2e$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $2c17e44c51e80b2e$var$SyncPromise((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $2c17e44c51e80b2e$var$SyncPromise((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $2c17e44c51e80b2e$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $2c17e44c51e80b2e$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $2c17e44c51e80b2e$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $2c17e44c51e80b2e$var$STATE_PENDING) return;
            if ($jV7hg.isThenable(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($2c17e44c51e80b2e$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($2c17e44c51e80b2e$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}
module.exports.SyncPromise = $2c17e44c51e80b2e$var$SyncPromise;
module.exports.rejectedSyncPromise = $2c17e44c51e80b2e$var$rejectedSyncPromise;
module.exports.resolvedSyncPromise = $2c17e44c51e80b2e$var$resolvedSyncPromise;

});


parcelRegister("97cmn", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fIlsR = parcelRequire("fIlsR");

var $fxVZv = parcelRequire("fxVZv");
let $6a2e5aef84433f6e$var$parsedStackResults;
let $6a2e5aef84433f6e$var$lastSentryKeysCount;
let $6a2e5aef84433f6e$var$lastNativeKeysCount;
let $6a2e5aef84433f6e$var$cachedFilenameDebugIds;
function $6a2e5aef84433f6e$var$getFilenameToDebugIdMap(stackParser) {
    const sentryDebugIdMap = $fxVZv.GLOBAL_OBJ._sentryDebugIds;
    const nativeDebugIdMap = $fxVZv.GLOBAL_OBJ._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    if ($6a2e5aef84433f6e$var$cachedFilenameDebugIds && sentryDebugIdKeys.length === $6a2e5aef84433f6e$var$lastSentryKeysCount && nativeDebugIdKeys.length === $6a2e5aef84433f6e$var$lastNativeKeysCount) return $6a2e5aef84433f6e$var$cachedFilenameDebugIds;
    $6a2e5aef84433f6e$var$lastSentryKeysCount = sentryDebugIdKeys.length;
    $6a2e5aef84433f6e$var$lastNativeKeysCount = nativeDebugIdKeys.length;
    $6a2e5aef84433f6e$var$cachedFilenameDebugIds = {};
    if (!$6a2e5aef84433f6e$var$parsedStackResults) $6a2e5aef84433f6e$var$parsedStackResults = {};
    const processDebugIds = (debugIdKeys, debugIdMap)=>{
        for (const key of debugIdKeys){
            const debugId = debugIdMap[key];
            const result = $6a2e5aef84433f6e$var$parsedStackResults?.[key];
            if (result && $6a2e5aef84433f6e$var$cachedFilenameDebugIds && debugId) {
                $6a2e5aef84433f6e$var$cachedFilenameDebugIds[result[0]] = debugId;
                if ($6a2e5aef84433f6e$var$parsedStackResults) $6a2e5aef84433f6e$var$parsedStackResults[key] = [
                    result[0],
                    debugId
                ];
            } else if (debugId) {
                const parsedStack = stackParser(key);
                for(let i = parsedStack.length - 1; i >= 0; i--){
                    const stackFrame = parsedStack[i];
                    const filename = stackFrame?.filename;
                    if (filename && $6a2e5aef84433f6e$var$cachedFilenameDebugIds && $6a2e5aef84433f6e$var$parsedStackResults) {
                        $6a2e5aef84433f6e$var$cachedFilenameDebugIds[filename] = debugId;
                        $6a2e5aef84433f6e$var$parsedStackResults[key] = [
                            filename,
                            debugId
                        ];
                        break;
                    }
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return $6a2e5aef84433f6e$var$cachedFilenameDebugIds;
}
function $6a2e5aef84433f6e$var$getDebugImagesForResources(stackParser, resource_paths) {
    const filenameDebugIdMap = $6a2e5aef84433f6e$var$getFilenameToDebugIdMap(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths){
        const normalizedPath = $fIlsR.normalizeStackTracePath(path);
        if (normalizedPath && filenameDebugIdMap[normalizedPath]) images.push({
            type: "sourcemap",
            code_file: path,
            debug_id: filenameDebugIdMap[normalizedPath]
        });
    }
    return images;
}
module.exports.getDebugImagesForResources = $6a2e5aef84433f6e$var$getDebugImagesForResources;
module.exports.getFilenameToDebugIdMap = $6a2e5aef84433f6e$var$getFilenameToDebugIdMap;

});



parcelRegister("c0ahv", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kfJmY = parcelRequire("kfJmY");

var $1GyI0 = parcelRequire("1GyI0");

var $aewmo = parcelRequire("aewmo");

var $2sm2V = parcelRequire("2sm2V");

var $jV7hg = parcelRequire("jV7hg");

var $jR1Dv = parcelRequire("jR1Dv");

var $gU6V8 = parcelRequire("gU6V8");

var $bTcEr = parcelRequire("bTcEr");
function $8bcd75ce6f23e5a6$var$withMonitor(monitorSlug, callback, upsertMonitorConfig) {
    function runCallback() {
        const checkInId = $8bcd75ce6f23e5a6$var$captureCheckIn({
            monitorSlug: monitorSlug,
            status: "in_progress"
        }, upsertMonitorConfig);
        const now = $gU6V8.timestampInSeconds();
        function finishCheckIn(status) {
            $8bcd75ce6f23e5a6$var$captureCheckIn({
                monitorSlug: monitorSlug,
                status: status,
                checkInId: checkInId,
                duration: $gU6V8.timestampInSeconds() - now
            });
        }
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ($jV7hg.isThenable(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn("ok");
            return r;
        }, (e)=>{
            finishCheckIn("error");
            throw e;
        });
        finishCheckIn("ok");
        return maybePromiseResult;
    }
    const oldPropagationContext = {
        ...$kfJmY.getCurrentScope().getPropagationContext()
    };
    return $kfJmY.withIsolationScope(()=>{
        if (upsertMonitorConfig?.isolateTrace) return $aewmo.startNewTrace(runCallback);
        const scope = $kfJmY.getCurrentScope();
        if (!$bTcEr.isContinuingTrace(scope.getPropagationContext())) scope.setPropagationContext(oldPropagationContext);
        return runCallback();
    });
}
function $8bcd75ce6f23e5a6$var$captureCheckIn(checkIn, upsertMonitorConfig) {
    const scope = $kfJmY.getCurrentScope();
    const client = $kfJmY.getClient();
    if (!client) $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return $jR1Dv.uuid4();
}
module.exports.captureCheckIn = $8bcd75ce6f23e5a6$var$captureCheckIn;
module.exports.withMonitor = $8bcd75ce6f23e5a6$var$withMonitor;

});

parcelRegister("82wbm", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lyqaT = parcelRequire("lyqaT");

var $3zGA3 = parcelRequire("3zGA3");

var $aRuEF = parcelRequire("aRuEF");

var $e3FcP = parcelRequire("e3FcP");
function $5da7795d0af5f7ea$var$waitForTracingChannelBinding(callback, retries = 1) {
    const binding = $e3FcP.getAsyncContextStrategy($lyqaT.getMainCarrier()).getTracingChannelBinding?.();
    if (binding) {
        callback();
        return;
    }
    if (!retries) return;
    $aRuEF.safeUnref(setTimeout(()=>{
        $5da7795d0af5f7ea$var$waitForTracingChannelBinding(callback, retries - 1);
    }, 1));
}
function $5da7795d0af5f7ea$var$_INTERNAL_createTracingChannelBinding(asyncLocalStorage, getScopes) {
    return {
        asyncLocalStorage: asyncLocalStorage,
        getStoreWithActiveSpan: (span)=>{
            const { scope: scope, isolationScope: isolationScope } = getScopes();
            const activeScope = scope.clone();
            $3zGA3._setSpanForScope(activeScope, span);
            return {
                scope: activeScope,
                isolationScope: isolationScope
            };
        }
    };
}
module.exports._INTERNAL_createTracingChannelBinding = $5da7795d0af5f7ea$var$_INTERNAL_createTracingChannelBinding;
module.exports.waitForTracingChannelBinding = $5da7795d0af5f7ea$var$waitForTracingChannelBinding;

});
parcelRegister("aRuEF", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $7e86a20819d768fb$var$safeUnref(timer) {
    if (typeof timer === "object" && typeof timer.unref === "function") timer.unref();
    return timer;
}
module.exports.safeUnref = $7e86a20819d768fb$var$safeUnref;

});


parcelRegister("44Knx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ebmC5 = parcelRequire("ebmC5");
const $2f7b82f47b50fec5$var$SENTRY_API_VERSION = "7";
function $2f7b82f47b50fec5$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
function $2f7b82f47b50fec5$var$_getIngestEndpoint(dsn) {
    return `${$2f7b82f47b50fec5$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
function $2f7b82f47b50fec5$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $2f7b82f47b50fec5$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
function $2f7b82f47b50fec5$var$getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$2f7b82f47b50fec5$var$_getIngestEndpoint(dsn)}?${$2f7b82f47b50fec5$var$_encodedAuth(dsn, sdkInfo)}`;
}
function $2f7b82f47b50fec5$var$getReportDialogEndpoint(dsnLike, dialogOptions) {
    const dsn$1 = $ebmC5.makeDsn(dsnLike);
    if (!dsn$1) return "";
    const endpoint = `${$2f7b82f47b50fec5$var$getBaseApiEndpoint(dsn$1)}embed/error-page/`;
    let encodedOptions = `dsn=${$ebmC5.dsnToString(dsn$1)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}
module.exports.SENTRY_API_VERSION = $2f7b82f47b50fec5$var$SENTRY_API_VERSION;
module.exports.getEnvelopeEndpointWithUrlEncodedAuth = $2f7b82f47b50fec5$var$getEnvelopeEndpointWithUrlEncodedAuth;
module.exports.getReportDialogEndpoint = $2f7b82f47b50fec5$var$getReportDialogEndpoint;

});

parcelRegister("chEXN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $44Knx = parcelRequire("44Knx");

var $QGp01 = parcelRequire("QGp01");

var $kfJmY = parcelRequire("kfJmY");

var $1GyI0 = parcelRequire("1GyI0");

var $aOpjI = parcelRequire("aOpjI");

var $5vlAD = parcelRequire("5vlAD");

var $9ZVkJ = parcelRequire("9ZVkJ");

var $bRW4e = parcelRequire("bRW4e");

var $3uEjM = parcelRequire("3uEjM");

var $dOSrX = parcelRequire("dOSrX");

var $7O6Z7 = parcelRequire("7O6Z7");

var $8Ra93 = parcelRequire("8Ra93");

var $eM0tn = parcelRequire("eM0tn");

var $6woCN = parcelRequire("6woCN");

var $2sm2V = parcelRequire("2sm2V");

var $ebmC5 = parcelRequire("ebmC5");

var $kAeXb = parcelRequire("kAeXb");

var $1MOT2 = parcelRequire("1MOT2");

var $jV7hg = parcelRequire("jV7hg");

var $aupof = parcelRequire("aupof");

var $jR1Dv = parcelRequire("jR1Dv");

var $gQqIQ = parcelRequire("gQqIQ");

var $lWhcW = parcelRequire("lWhcW");

var $4q9hx = parcelRequire("4q9hx");

var $6ki8f = parcelRequire("6ki8f");

var $h2lAT = parcelRequire("h2lAT");

var $8hCvI = parcelRequire("8hCvI");

var $aRuEF = parcelRequire("aRuEF");

var $bg9SP = parcelRequire("bg9SP");

var $8LBn0 = parcelRequire("8LBn0");
const $8f16d90aa3967da1$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $8f16d90aa3967da1$var$MISSING_RELEASE_FOR_SESSION_ERROR = "Discarded session because of missing or non-string release";
const $8f16d90aa3967da1$var$INTERNAL_ERROR_SYMBOL = /* @__PURE__ */ Symbol.for("SentryInternalError");
const $8f16d90aa3967da1$var$DO_NOT_SEND_EVENT_SYMBOL = /* @__PURE__ */ Symbol.for("SentryDoNotSendEventError");
const $8f16d90aa3967da1$var$DEFAULT_FLUSH_INTERVAL = 5e3;
function $8f16d90aa3967da1$var$_makeInternalError(message) {
    return {
        message: message,
        [$8f16d90aa3967da1$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $8f16d90aa3967da1$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$8f16d90aa3967da1$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $8f16d90aa3967da1$var$_isInternalError(error) {
    return $jV7hg.isObjectLike(error) && $8f16d90aa3967da1$var$INTERNAL_ERROR_SYMBOL in error;
}
function $8f16d90aa3967da1$var$_isDoNotSendEventError(error) {
    return $jV7hg.isObjectLike(error) && $8f16d90aa3967da1$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
function $8f16d90aa3967da1$var$setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
    let weight = 0;
    let flushTimeout;
    let isTimerActive = false;
    client.on(flushHook, ()=>{
        weight = 0;
        clearTimeout(flushTimeout);
        isTimerActive = false;
    });
    client.on(afterCaptureHook, (item)=>{
        weight += estimateSizeFn(item);
        if (weight >= 8e5) flushFn(client);
        else if (!isTimerActive) {
            const flushInterval = client.getOptions()._flushInterval ?? $8f16d90aa3967da1$var$DEFAULT_FLUSH_INTERVAL;
            if (flushInterval > 0) {
                isTimerActive = true;
                flushTimeout = $aRuEF.safeUnref(setTimeout(()=>{
                    flushFn(client);
                }, flushInterval));
            }
        }
    });
    client.on("flush", ()=>{
        flushFn(client);
    });
}
class $8f16d90aa3967da1$var$Client {
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        this._promiseBuffer = $4q9hx.makePromiseBuffer(options.transportOptions?.bufferSize ?? $eM0tn.DEFAULT_TRANSPORT_BUFFER_SIZE);
        this._dataCollection = $8LBn0.resolveDataCollectionOptions(options);
        if (options.dsn) this._dsn = $ebmC5.makeDsn(options.dsn);
        else $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = $44Knx.getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : void 0);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        this._options.enableLogs = this._options.enableLogs ?? this._options._experiments?.enableLogs ?? true;
        if (this._options.enableLogs) $8f16d90aa3967da1$var$setupWeightBasedFlushing(this, "afterCaptureLog", "flushLogs", $8f16d90aa3967da1$var$estimateLogSizeInBytes, $9ZVkJ._INTERNAL_flushLogsBuffer);
        const enableMetrics = this._options.enableMetrics ?? this._options._experiments?.enableMetrics ?? true;
        if (enableMetrics) $8f16d90aa3967da1$var$setupWeightBasedFlushing(this, "afterCaptureMetric", "flushMetrics", $8f16d90aa3967da1$var$estimateMetricSizeInBytes, $bRW4e._INTERNAL_flushMetricsBuffer);
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = $jR1Dv.uuid4();
        if ($jR1Dv.checkOrSetAlreadyCaught(exception)) {
            $1GyI0.DEBUG_BUILD && $2sm2V.debug.log($8f16d90aa3967da1$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(()=>this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)).then((res)=>res), "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: $jR1Dv.uuid4(),
            ...hint
        };
        const eventMessage = $jV7hg.isParameterizedString(message) ? message : String(message);
        const isMessage = $jV7hg.isPrimitive(message);
        const promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(()=>promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)), isMessage ? "unknown" : "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = $jR1Dv.uuid4();
        if (hint?.originalException && $jR1Dv.checkOrSetAlreadyCaught(hint.originalException)) {
            $1GyI0.DEBUG_BUILD && $2sm2V.debug.log($8f16d90aa3967da1$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        const dataCategory = $8f16d90aa3967da1$var$getDataCategoryByType(event.type);
        this._process(()=>this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope), dataCategory);
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session$1) {
        this.sendSession(session$1);
        $3uEjM.updateSession(session$1, {
            init: false
        });
    }
    /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the resolved data collection configuration.
   */ getDataCollectionOptions() {
        return this._dataCollection;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async flush(timeout) {
        const transport = this._transport;
        this.emit("flush");
        if (!transport) return true;
        const clientFinished = await this._isClientDoneProcessing(timeout);
        const transportFlushed = await transport.flush(timeout);
        return clientFinished && transportFlushed;
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async close(timeout) {
        const result = await this.flush(timeout);
        this.getOptions().enabled = false;
        this.emit("close");
        return result;
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith("Spotlight"))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the names of all installed integrations.
   */ getIntegrationNames() {
        return Object.keys(this._integrations);
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration$1) {
        const isAlreadyInstalled = this._integrations[integration$1.name];
        if (!isAlreadyInstalled && integration$1.beforeSetup) integration$1.beforeSetup(this);
        $5vlAD.setupIntegration(this, integration$1, this._integrations);
        if (!isAlreadyInstalled) $5vlAD.afterSetupIntegrations(this, [
            integration$1
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        const genAiSpanItem = $8Ra93.extractGenAiSpansFromEvent(event, this);
        let env = $aOpjI.createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = $kAeXb.addItemToEnvelope(env, $kAeXb.createAttachmentEnvelopeItem(attachment));
        if (genAiSpanItem) env = $kAeXb.addItemToEnvelope(env, genAiSpanItem);
        this.sendEnvelope(env).then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse));
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        const { release: clientReleaseOption, environment: clientEnvironmentOption = $QGp01.DEFAULT_ENVIRONMENT } = this._options;
        if ("aggregates" in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn($8f16d90aa3967da1$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn($8f16d90aa3967da1$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit("beforeSendSession", session);
        const env = $aOpjI.createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            const key = `${reason}:${category}`;
            $1GyI0.DEBUG_BUILD && $2sm2V.debug.log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hookCallbacks = this._hooks[hook] = this._hooks[hook] || /* @__PURE__ */ new Set();
        const uniqueCallback = (...args)=>callback(...args);
        hookCallbacks.add(uniqueCallback);
        return ()=>{
            hookCallbacks.delete(uniqueCallback);
        };
    }
    /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) try {
            return await this._transport.send(envelope);
        } catch (reason) {
            $1GyI0.DEBUG_BUILD && $2sm2V.debug.error("Error while sending envelope:", reason);
            return {};
        }
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.error("Transport disabled");
        return {};
    }
    /**
   * Register a cleanup function to be called when the client is disposed.
   * This is useful for integrations that need to clean up global state.
   *
   * NOTE: This is a no-op in the base `Client` class. Subclasses like `ServerRuntimeClient`
   * override this method to actually register and execute cleanup callbacks.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    registerCleanup(callback) {}
    /**
   * Disposes of the client and releases all resources.
   *
   * Subclasses should override this method to clean up their own resources, including invoking
   * any callbacks registered via {@link Client.registerCleanup}. The base implementation is a
   * no-op and does NOT execute registered cleanup callbacks.
   *
   * After calling dispose(), the client should not be used anymore.
   */ dispose() {}
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = $5vlAD.setupIntegrations(this, integrations);
        $5vlAD.afterSetupIntegrations(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session$1, event) {
        let crashed = event.level === "fatal";
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            crashed = false;
            for (const ex of exceptions)if (ex.mechanism?.handled === false) {
                crashed = true;
                break;
            }
        }
        const sessionNonTerminal = session$1.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session$1.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            $3uEjM.updateSession(session$1, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session$1.errors || Number(errored || crashed)
            });
            this.captureSession(session$1);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ async _isClientDoneProcessing(timeout) {
        let ticked = 0;
        while(!timeout || ticked < timeout){
            await new Promise((resolve)=>setTimeout(resolve, 1));
            if (!this._numProcessing) return true;
            ticked++;
        }
        return false;
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== void 0;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = this.getIntegrationNames();
        if (!hint.integrations && integrations.length) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return $lWhcW.prepareEvent(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit("postprocessEvent", evt, hint);
            evt.contexts = {
                trace: {
                    ...evt.contexts?.trace,
                    ...$kfJmY.getTraceContextFromScope(currentScope)
                },
                ...evt.contexts
            };
            const dynamicSamplingContext$1 = $dOSrX.getDynamicSamplingContextFromScope(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext$1,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = $kfJmY.getCurrentScope(), isolationScope = $kfJmY.getIsolationScope()) {
        if ($1GyI0.DEBUG_BUILD && $8f16d90aa3967da1$var$isErrorEvent(event)) $2sm2V.debug.log(`Captured error event \`${$1MOT2.getPossibleEventMessages(event)[0] || "<unknown>"}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if ($1GyI0.DEBUG_BUILD) {
                if ($8f16d90aa3967da1$var$_isDoNotSendEventError(reason)) $2sm2V.debug.log(reason.message);
                else if ($8f16d90aa3967da1$var$_isInternalError(reason)) $2sm2V.debug.warn(reason.message);
                else $2sm2V.debug.warn(reason);
            }
            return void 0;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $8f16d90aa3967da1$var$isTransactionEvent(event);
        const isError = $8f16d90aa3967da1$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        const parsedSampleRate = typeof sampleRate === "undefined" ? void 0 : $gQqIQ.parseSampleRate(sampleRate);
        const dataCategory = $8f16d90aa3967da1$var$getDataCategoryByType(event.type);
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory);
                throw $8f16d90aa3967da1$var$_makeDoNotSendEventError("An event processor returned `null`, will not send event.");
            }
            const isInternalException = hint.data?.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $8f16d90aa3967da1$var$processBeforeSend(this, options, prepared, hint);
            return $8f16d90aa3967da1$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw $8f16d90aa3967da1$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isError && typeof parsedSampleRate === "number" && $6ki8f.safeMathRandom() > parsedSampleRate) {
                this.recordDroppedEvent("sample_rate", "error");
                throw $8f16d90aa3967da1$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`);
            }
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($8f16d90aa3967da1$var$_isDoNotSendEventError(reason) || $8f16d90aa3967da1$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                mechanism: {
                    handled: false,
                    type: "internal"
                },
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $8f16d90aa3967da1$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(taskProducer, dataCategory) {
        this._numProcessing++;
        this._promiseBuffer.add(taskProducer).then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            if (reason === $4q9hx.SENTRY_BUFFER_FULL_ERROR) this.recordDroppedEvent("queue_overflow", dataCategory);
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.log("Flushing outcomes...");
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            $1GyI0.DEBUG_BUILD && $2sm2V.debug.log("No outcomes to send");
            return;
        }
        if (!this._dsn) {
            $1GyI0.DEBUG_BUILD && $2sm2V.debug.log("No dsn provided, will not send outcomes");
            return;
        }
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.log("Sending outcomes:", outcomes);
        const envelope = $6woCN.createClientReportEnvelope(outcomes, this._options.tunnel && $ebmC5.dsnToString(this._dsn));
        this.sendEnvelope(envelope);
    }
}
function $8f16d90aa3967da1$var$getDataCategoryByType(type) {
    return type === "replay_event" ? "replay" : type || "error";
}
function $8f16d90aa3967da1$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ($jV7hg.isThenable(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!$jV7hg.isPlainObject(event) && event !== null) throw $8f16d90aa3967da1$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $8f16d90aa3967da1$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!$jV7hg.isPlainObject(beforeSendResult) && beforeSendResult !== null) throw $8f16d90aa3967da1$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
function $8f16d90aa3967da1$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, ignoreSpans: ignoreSpans } = options;
    const beforeSendSpan$1 = !$7O6Z7.isStreamedBeforeSendSpanCallback(options.beforeSendSpan) && options.beforeSendSpan;
    let processedEvent = event;
    if ($8f16d90aa3967da1$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($8f16d90aa3967da1$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan$1 || ignoreSpans) {
            const rootSpanJson = $bg9SP.convertTransactionEventToSpanJson(processedEvent);
            if (ignoreSpans?.length && $h2lAT.shouldIgnoreSpan({
                description: rootSpanJson.description,
                op: rootSpanJson.op,
                attributes: rootSpanJson.data
            }, ignoreSpans)) return null;
            if (beforeSendSpan$1) {
                const processedRootSpanJson = beforeSendSpan$1(rootSpanJson);
                if (!processedRootSpanJson) $8hCvI.showSpanDropWarning();
                else processedEvent = $aupof.merge(event, $bg9SP.convertSpanJsonToTransactionEvent(processedRootSpanJson));
            }
            if (processedEvent.spans) {
                const processedSpans = [];
                const initialSpans = processedEvent.spans;
                for (const span of initialSpans){
                    if (ignoreSpans?.length && $h2lAT.shouldIgnoreSpan({
                        description: span.description,
                        op: span.op,
                        attributes: span.data
                    }, ignoreSpans)) {
                        $h2lAT.reparentChildSpans(initialSpans, span);
                        continue;
                    }
                    if (beforeSendSpan$1) {
                        const processedSpan = beforeSendSpan$1(span);
                        if (!processedSpan) {
                            $8hCvI.showSpanDropWarning();
                            processedSpans.push(span);
                        } else processedSpans.push(processedSpan);
                    } else processedSpans.push(span);
                }
                const droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent("before_send", "span", droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $8f16d90aa3967da1$var$isErrorEvent(event) {
    return event.type === void 0;
}
function $8f16d90aa3967da1$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
function $8f16d90aa3967da1$var$estimateMetricSizeInBytes(metric) {
    let weight = 0;
    if (metric.name) weight += metric.name.length * 2;
    weight += 8;
    return weight + $8f16d90aa3967da1$var$estimateAttributesSizeInBytes(metric.attributes);
}
function $8f16d90aa3967da1$var$estimateLogSizeInBytes(log) {
    let weight = 0;
    if (log.message) weight += log.message.length * 2;
    return weight + $8f16d90aa3967da1$var$estimateAttributesSizeInBytes(log.attributes);
}
function $8f16d90aa3967da1$var$estimateAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    Object.values(attributes).forEach((value)=>{
        if (Array.isArray(value)) weight += value.length * $8f16d90aa3967da1$var$estimatePrimitiveSizeInBytes(value[0]);
        else if ($jV7hg.isPrimitive(value)) weight += $8f16d90aa3967da1$var$estimatePrimitiveSizeInBytes(value);
        else weight += 100;
    });
    return weight;
}
function $8f16d90aa3967da1$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "number") return 8;
    else if (typeof value === "boolean") return 4;
    return 0;
}
module.exports.Client = $8f16d90aa3967da1$var$Client;

});
parcelRegister("5vlAD", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kfJmY = parcelRequire("kfJmY");

var $1GyI0 = parcelRequire("1GyI0");

var $2sm2V = parcelRequire("2sm2V");
const $4020985005668b0a$var$installedIntegrations = [];
function $4020985005668b0a$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
function $4020985005668b0a$var$getIntegrationsToSetup(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $4020985005668b0a$var$filterDuplicates(integrations);
}
function $4020985005668b0a$var$setupIntegrations(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        if (integration?.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach((integration)=>{
        if (integration) $4020985005668b0a$var$setupIntegration(client, integration, integrationIndex);
    });
    return integrationIndex;
}
function $4020985005668b0a$var$afterSetupIntegrations(client, integrations) {
    for (const integration of integrations)if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
function $4020985005668b0a$var$setupIntegration(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    if (!$4020985005668b0a$var$installedIntegrations.includes(integration.name) && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $4020985005668b0a$var$installedIntegrations.push(integration.name);
    }
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        "processSpan",
        "processSegmentSpan"
    ].forEach((hook)=>{
        const callback = integration[hook];
        if (typeof callback === "function") client.on(hook, (span)=>callback.call(integration, span, client));
    });
    $1GyI0.DEBUG_BUILD && $2sm2V.debug.log(`Integration installed: ${integration.name}`);
}
function $4020985005668b0a$var$addIntegration(integration) {
    const client = $kfJmY.getClient();
    if (!client) {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
function $4020985005668b0a$var$defineIntegration(fn) {
    return fn;
}
function $4020985005668b0a$var$extendIntegration(integration, extendedIntegration) {
    const wrappedIntegration = {
        ...integration,
        ...extendedIntegration
    };
    for(const key in extendedIntegration){
        const baseValue = integration[key];
        const extendedValue = extendedIntegration[key];
        if (typeof baseValue === "function" && typeof extendedValue === "function") {
            const wrappedFunction = new Proxy(baseValue, {
                apply: (target, thisArg, args)=>{
                    Reflect.apply(target, thisArg, args);
                    return Reflect.apply(extendedValue, thisArg, args);
                }
            });
            wrappedIntegration[key] = wrappedFunction;
        }
    }
    return wrappedIntegration;
}
module.exports.addIntegration = $4020985005668b0a$var$addIntegration;
module.exports.afterSetupIntegrations = $4020985005668b0a$var$afterSetupIntegrations;
module.exports.defineIntegration = $4020985005668b0a$var$defineIntegration;
module.exports.extendIntegration = $4020985005668b0a$var$extendIntegration;
module.exports.getIntegrationsToSetup = $4020985005668b0a$var$getIntegrationsToSetup;
module.exports.installedIntegrations = $4020985005668b0a$var$installedIntegrations;
module.exports.setupIntegration = $4020985005668b0a$var$setupIntegration;
module.exports.setupIntegrations = $4020985005668b0a$var$setupIntegrations;

});

parcelRegister("9ZVkJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ary0D = parcelRequire("ary0D");

var $lyqaT = parcelRequire("lyqaT");

var $kfJmY = parcelRequire("kfJmY");

var $1GyI0 = parcelRequire("1GyI0");

var $2sm2V = parcelRequire("2sm2V");

var $jV7hg = parcelRequire("jV7hg");

var $dGSc0 = parcelRequire("dGSc0");

var $3zGA3 = parcelRequire("3zGA3");

var $gU6V8 = parcelRequire("gU6V8");

var $hHf0g = parcelRequire("hHf0g");

var $acNC4 = parcelRequire("acNC4");

var $cZm3s = parcelRequire("cZm3s");

var $lNP0h = parcelRequire("lNP0h");
const $747648c0c5a2bfa1$var$MAX_LOG_BUFFER_SIZE = 100;
function $747648c0c5a2bfa1$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
function $747648c0c5a2bfa1$var$_INTERNAL_captureSerializedLog(client, serializedLog) {
    const bufferMap = $747648c0c5a2bfa1$var$_getBufferMap();
    const logBuffer = $747648c0c5a2bfa1$var$_INTERNAL_getLogBuffer(client);
    if (logBuffer === void 0) bufferMap.set(client, [
        serializedLog
    ]);
    else if (logBuffer.length >= $747648c0c5a2bfa1$var$MAX_LOG_BUFFER_SIZE) {
        $747648c0c5a2bfa1$var$_INTERNAL_flushLogsBuffer(client, logBuffer);
        bufferMap.set(client, [
            serializedLog
        ]);
    } else bufferMap.set(client, [
        ...logBuffer,
        serializedLog
    ]);
}
function $747648c0c5a2bfa1$var$_INTERNAL_captureLog(beforeLog, currentScope = $kfJmY.getCurrentScope(), captureSerializedLog = $747648c0c5a2bfa1$var$_INTERNAL_captureSerializedLog) {
    const client = currentScope?.getClient() ?? $kfJmY.getClient();
    if (!client) {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn("No client available to capture log.");
        return;
    }
    const { release: release, environment: environment, enableLogs: enableLogs = true, beforeSendLog: beforeSendLog } = client.getOptions();
    if (!enableLogs) {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn("logging option not enabled, log will not be captured.");
        return;
    }
    const [, traceContext] = $acNC4._getTraceInfoFromScope(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: { id: id, email: email, username: username }, attributes: scopeAttributes = {} } = $dGSc0.getCombinedScopeData($kfJmY.getIsolationScope(), currentScope);
    $747648c0c5a2bfa1$var$setLogAttribute(processedLogAttributes, "user.id", id, false);
    $747648c0c5a2bfa1$var$setLogAttribute(processedLogAttributes, "user.email", email, false);
    $747648c0c5a2bfa1$var$setLogAttribute(processedLogAttributes, "user.name", username, false);
    $747648c0c5a2bfa1$var$setLogAttribute(processedLogAttributes, "sentry.release", release);
    $747648c0c5a2bfa1$var$setLogAttribute(processedLogAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $747648c0c5a2bfa1$var$setLogAttribute(processedLogAttributes, "sentry.sdk.name", name);
    $747648c0c5a2bfa1$var$setLogAttribute(processedLogAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $747648c0c5a2bfa1$var$setLogAttribute(processedLogAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $747648c0c5a2bfa1$var$setLogAttribute(processedLogAttributes, "sentry._internal.replay_is_buffering", true);
    const beforeLogMessage = beforeLog.message;
    if ($jV7hg.isParameterizedString(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        if (__sentry_template_values__?.length) processedLogAttributes["sentry.message.template"] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = $3zGA3._getSpanForScope(currentScope);
    $747648c0c5a2bfa1$var$setLogAttribute(processedLogAttributes, "sentry.trace.parent_span_id", span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit("beforeCaptureLog", processedLog);
    const log = beforeSendLog ? $2sm2V.consoleSandbox(()=>beforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent("before_send", "log_item", 1);
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn("beforeSendLog returned null, log will not be captured.");
        return;
    }
    const { level: level, message: message, attributes: logAttributes = {}, severityNumber: severityNumber } = log;
    const timestamp = $gU6V8.timestampInSeconds();
    const sequenceAttr = $hHf0g.getSequenceAttribute(timestamp);
    const serializedLog = {
        timestamp: timestamp,
        level: level,
        body: $747648c0c5a2bfa1$var$_removeLoneSurrogates(String(message)),
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? $cZm3s.SEVERITY_TEXT_TO_SEVERITY_NUMBER[level],
        attributes: $747648c0c5a2bfa1$var$sanitizeLogAttributes({
            ...$ary0D.serializeAttributes(scopeAttributes),
            ...$ary0D.serializeAttributes(logAttributes, true),
            [sequenceAttr.key]: sequenceAttr.value
        })
    };
    captureSerializedLog(client, serializedLog);
    client.emit("afterCaptureLog", log);
}
function $747648c0c5a2bfa1$var$_INTERNAL_flushLogsBuffer(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $747648c0c5a2bfa1$var$_INTERNAL_getLogBuffer(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope$1 = $lNP0h.createLogEnvelope(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $747648c0c5a2bfa1$var$_getBufferMap().set(client, []);
    client.emit("flushLogs");
    client.sendEnvelope(envelope$1);
}
function $747648c0c5a2bfa1$var$_INTERNAL_getLogBuffer(client) {
    return $747648c0c5a2bfa1$var$_getBufferMap().get(client);
}
function $747648c0c5a2bfa1$var$_getBufferMap() {
    return $lyqaT.getGlobalSingleton("clientToLogBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}
function $747648c0c5a2bfa1$var$sanitizeLogAttributes(attributes) {
    const sanitized = {};
    for (const [key, attr] of Object.entries(attributes)){
        const sanitizedKey = $747648c0c5a2bfa1$var$_removeLoneSurrogates(key);
        if (attr.type === "string") sanitized[sanitizedKey] = {
            ...attr,
            value: $747648c0c5a2bfa1$var$_removeLoneSurrogates(attr.value)
        };
        else sanitized[sanitizedKey] = attr;
    }
    return sanitized;
}
function $747648c0c5a2bfa1$var$_removeLoneSurrogates(str) {
    const strObj = Object(str);
    const isWellFormed = strObj["isWellFormed"];
    const toWellFormed = strObj["toWellFormed"];
    if (typeof isWellFormed === "function" && typeof toWellFormed === "function") return isWellFormed.call(str) ? str : toWellFormed.call(str);
    return str;
}
module.exports._INTERNAL_captureLog = $747648c0c5a2bfa1$var$_INTERNAL_captureLog;
module.exports._INTERNAL_captureSerializedLog = $747648c0c5a2bfa1$var$_INTERNAL_captureSerializedLog;
module.exports._INTERNAL_flushLogsBuffer = $747648c0c5a2bfa1$var$_INTERNAL_flushLogsBuffer;
module.exports._INTERNAL_getLogBuffer = $747648c0c5a2bfa1$var$_INTERNAL_getLogBuffer;
module.exports._removeLoneSurrogates = $747648c0c5a2bfa1$var$_removeLoneSurrogates;

});
parcelRegister("hHf0g", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $ce22172b399a36c3$var$SEQUENCE_ATTR_KEY = "sentry.timestamp.sequence";
let $ce22172b399a36c3$var$_sequenceNumber = 0;
let $ce22172b399a36c3$var$_previousTimestampMs;
function $ce22172b399a36c3$var$getSequenceAttribute(timestampInSeconds) {
    const nowMs = Math.floor(timestampInSeconds * 1e3);
    if ($ce22172b399a36c3$var$_previousTimestampMs !== void 0 && nowMs !== $ce22172b399a36c3$var$_previousTimestampMs) $ce22172b399a36c3$var$_sequenceNumber = 0;
    const value = $ce22172b399a36c3$var$_sequenceNumber;
    $ce22172b399a36c3$var$_sequenceNumber++;
    $ce22172b399a36c3$var$_previousTimestampMs = nowMs;
    return {
        key: $ce22172b399a36c3$var$SEQUENCE_ATTR_KEY,
        value: {
            value: value,
            type: "integer"
        }
    };
}
module.exports.getSequenceAttribute = $ce22172b399a36c3$var$getSequenceAttribute;

});

parcelRegister("acNC4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kfJmY = parcelRequire("kfJmY");

var $dOSrX = parcelRequire("dOSrX");

var $8hCvI = parcelRequire("8hCvI");
function $76e18278d77b2ad9$var$_getTraceInfoFromScope(client, scope) {
    if (!scope) return [
        void 0,
        void 0
    ];
    return $kfJmY.withScope(scope, ()=>{
        const span = $8hCvI.getActiveSpan();
        const traceContext = span ? $8hCvI.spanToTraceContext(span) : $kfJmY.getTraceContextFromScope(scope);
        const dynamicSamplingContext$1 = span ? $dOSrX.getDynamicSamplingContextFromSpan(span) : $dOSrX.getDynamicSamplingContextFromScope(client, scope);
        return [
            dynamicSamplingContext$1,
            traceContext
        ];
    });
}
module.exports._getTraceInfoFromScope = $76e18278d77b2ad9$var$_getTraceInfoFromScope;

});

parcelRegister("cZm3s", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $974c4a2de66faae4$var$SEVERITY_TEXT_TO_SEVERITY_NUMBER = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};
module.exports.SEVERITY_TEXT_TO_SEVERITY_NUMBER = $974c4a2de66faae4$var$SEVERITY_TEXT_TO_SEVERITY_NUMBER;

});

parcelRegister("lNP0h", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ebmC5 = parcelRequire("ebmC5");

var $kAeXb = parcelRequire("kAeXb");

var $iyFot = parcelRequire("iyFot");
function $fdf5bcd252d75aca$var$createLogContainerEnvelopeItem(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "log",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.log+json"
        },
        {
            version: 2,
            ...$iyFot.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
function $fdf5bcd252d75aca$var$createLogEnvelope(logs, metadata, tunnel, dsn$1, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $ebmC5.dsnToString(dsn$1);
    return $kAeXb.createEnvelope(headers, [
        $fdf5bcd252d75aca$var$createLogContainerEnvelopeItem(logs, inferUserData)
    ]);
}
module.exports.createLogContainerEnvelopeItem = $fdf5bcd252d75aca$var$createLogContainerEnvelopeItem;
module.exports.createLogEnvelope = $fdf5bcd252d75aca$var$createLogEnvelope;

});
parcelRegister("iyFot", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bmJ5B = parcelRequire("bmJ5B");

var $fxVZv = parcelRequire("fxVZv");
function $d82b82ed05ecc1a9$var$isBrowser() {
    return typeof window !== "undefined" && (!$bmJ5B.isNodeEnv() || $d82b82ed05ecc1a9$var$isElectronNodeRenderer());
}
function $d82b82ed05ecc1a9$var$isElectronNodeRenderer() {
    const process = $fxVZv.GLOBAL_OBJ.process;
    return process?.type === "renderer";
}
module.exports.isBrowser = $d82b82ed05ecc1a9$var$isBrowser;

});
parcelRegister("bmJ5B", function(module, exports) {

var $3ZMUU = parcelRequire("3ZMUU");
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hUV0Y = parcelRequire("hUV0Y");
function isNodeEnv() {
    return !$hUV0Y.isBrowserBundle() && Object.prototype.toString.call(typeof $3ZMUU !== "undefined" ? $3ZMUU : 0) === "[object process]";
}
function dynamicRequire(mod, request) {
    return mod.require(request);
}
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch  {}
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, "process");
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch  {}
    return mod;
}
exports.isNodeEnv = isNodeEnv;
exports.loadModule = loadModule;

});
parcelRegister("hUV0Y", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $d0b3e4937f35a6e8$var$isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
function $d0b3e4937f35a6e8$var$getSDKSource() {
    /*! __SENTRY_SDK_SOURCE__ */ return "npm";
}
module.exports.getSDKSource = $d0b3e4937f35a6e8$var$getSDKSource;
module.exports.isBrowserBundle = $d0b3e4937f35a6e8$var$isBrowserBundle;

});





parcelRegister("bRW4e", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ary0D = parcelRequire("ary0D");

var $lyqaT = parcelRequire("lyqaT");

var $kfJmY = parcelRequire("kfJmY");

var $1GyI0 = parcelRequire("1GyI0");

var $2sm2V = parcelRequire("2sm2V");

var $dGSc0 = parcelRequire("dGSc0");

var $3zGA3 = parcelRequire("3zGA3");

var $gU6V8 = parcelRequire("gU6V8");

var $hHf0g = parcelRequire("hHf0g");

var $acNC4 = parcelRequire("acNC4");

var $hg2Xy = parcelRequire("hg2Xy");
const $8a41afe0e684e988$var$MAX_METRIC_BUFFER_SIZE = 1e3;
function $8a41afe0e684e988$var$setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
function $8a41afe0e684e988$var$_INTERNAL_captureSerializedMetric(client, serializedMetric) {
    const bufferMap = $8a41afe0e684e988$var$_getBufferMap();
    const metricBuffer = $8a41afe0e684e988$var$_INTERNAL_getMetricBuffer(client);
    if (metricBuffer === void 0) bufferMap.set(client, [
        serializedMetric
    ]);
    else if (metricBuffer.length >= $8a41afe0e684e988$var$MAX_METRIC_BUFFER_SIZE) {
        $8a41afe0e684e988$var$_INTERNAL_flushMetricsBuffer(client, metricBuffer);
        bufferMap.set(client, [
            serializedMetric
        ]);
    } else bufferMap.set(client, [
        ...metricBuffer,
        serializedMetric
    ]);
}
function $8a41afe0e684e988$var$_enrichMetricAttributes(beforeMetric, client, user) {
    const { release: release, environment: environment } = client.getOptions();
    const processedMetricAttributes = {
        ...beforeMetric.attributes
    };
    $8a41afe0e684e988$var$setMetricAttribute(processedMetricAttributes, "user.id", user.id, false);
    $8a41afe0e684e988$var$setMetricAttribute(processedMetricAttributes, "user.email", user.email, false);
    $8a41afe0e684e988$var$setMetricAttribute(processedMetricAttributes, "user.name", user.username, false);
    $8a41afe0e684e988$var$setMetricAttribute(processedMetricAttributes, "sentry.release", release);
    $8a41afe0e684e988$var$setMetricAttribute(processedMetricAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $8a41afe0e684e988$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.name", name);
    $8a41afe0e684e988$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $8a41afe0e684e988$var$setMetricAttribute(processedMetricAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $8a41afe0e684e988$var$setMetricAttribute(processedMetricAttributes, "sentry._internal.replay_is_buffering", true);
    return {
        ...beforeMetric,
        attributes: processedMetricAttributes
    };
}
function $8a41afe0e684e988$var$_buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
    const [, traceContext] = $acNC4._getTraceInfoFromScope(client, currentScope);
    const span = $3zGA3._getSpanForScope(currentScope);
    const traceId = span ? span.spanContext().traceId : traceContext?.trace_id;
    const spanId = span ? span.spanContext().spanId : void 0;
    const timestamp = $gU6V8.timestampInSeconds();
    const sequenceAttr = $hHf0g.getSequenceAttribute(timestamp);
    return {
        timestamp: timestamp,
        trace_id: traceId ?? "",
        span_id: spanId,
        name: metric.name,
        type: metric.type,
        unit: metric.unit,
        value: metric.value,
        attributes: {
            ...$ary0D.serializeAttributes(scopeAttributes),
            ...$ary0D.serializeAttributes(metric.attributes, "skip-undefined"),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
}
function $8a41afe0e684e988$var$_INTERNAL_captureMetric(beforeMetric, options) {
    const currentScope = options?.scope ?? $kfJmY.getCurrentScope();
    const captureSerializedMetric = options?.captureSerializedMetric ?? $8a41afe0e684e988$var$_INTERNAL_captureSerializedMetric;
    const client = currentScope?.getClient() ?? $kfJmY.getClient();
    if (!client) {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn("No client available to capture metric.");
        return;
    }
    const { _experiments: _experiments, enableMetrics: enableMetrics, beforeSendMetric: beforeSendMetric } = client.getOptions();
    const metricsEnabled = enableMetrics ?? _experiments?.enableMetrics ?? true;
    if (!metricsEnabled) {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn("metrics option not enabled, metric will not be captured.");
        return;
    }
    const { user: user, attributes: scopeAttributes } = $dGSc0.getCombinedScopeData($kfJmY.getIsolationScope(), currentScope);
    const enrichedMetric = $8a41afe0e684e988$var$_enrichMetricAttributes(beforeMetric, client, user);
    client.emit("processMetric", enrichedMetric);
    const beforeSendCallback = beforeSendMetric || _experiments?.beforeSendMetric;
    const processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
    if (!processedMetric) {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.log("`beforeSendMetric` returned `null`, will not send metric.");
        return;
    }
    const serializedMetric = $8a41afe0e684e988$var$_buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
    $1GyI0.DEBUG_BUILD && $2sm2V.debug.log("[Metric]", serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit("afterCaptureMetric", processedMetric);
}
function $8a41afe0e684e988$var$_INTERNAL_flushMetricsBuffer(client, maybeMetricBuffer) {
    const metricBuffer = maybeMetricBuffer ?? $8a41afe0e684e988$var$_INTERNAL_getMetricBuffer(client) ?? [];
    if (metricBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope$1 = $hg2Xy.createMetricEnvelope(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $8a41afe0e684e988$var$_getBufferMap().set(client, []);
    client.emit("flushMetrics");
    client.sendEnvelope(envelope$1);
}
function $8a41afe0e684e988$var$_INTERNAL_getMetricBuffer(client) {
    return $8a41afe0e684e988$var$_getBufferMap().get(client);
}
function $8a41afe0e684e988$var$_getBufferMap() {
    return $lyqaT.getGlobalSingleton("clientToMetricBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}
module.exports._INTERNAL_captureMetric = $8a41afe0e684e988$var$_INTERNAL_captureMetric;
module.exports._INTERNAL_captureSerializedMetric = $8a41afe0e684e988$var$_INTERNAL_captureSerializedMetric;
module.exports._INTERNAL_flushMetricsBuffer = $8a41afe0e684e988$var$_INTERNAL_flushMetricsBuffer;
module.exports._INTERNAL_getMetricBuffer = $8a41afe0e684e988$var$_INTERNAL_getMetricBuffer;

});
parcelRegister("hg2Xy", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ebmC5 = parcelRequire("ebmC5");

var $kAeXb = parcelRequire("kAeXb");

var $iyFot = parcelRequire("iyFot");
function $c9063a04df0c245d$var$createMetricContainerEnvelopeItem(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "trace_metric",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.trace-metric+json"
        },
        {
            version: 2,
            ...$iyFot.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
function $c9063a04df0c245d$var$createMetricEnvelope(metrics, metadata, tunnel, dsn$1, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $ebmC5.dsnToString(dsn$1);
    return $kAeXb.createEnvelope(headers, [
        $c9063a04df0c245d$var$createMetricContainerEnvelopeItem(metrics, inferUserData)
    ]);
}
module.exports.createMetricContainerEnvelopeItem = $c9063a04df0c245d$var$createMetricContainerEnvelopeItem;
module.exports.createMetricEnvelope = $c9063a04df0c245d$var$createMetricEnvelope;

});


parcelRegister("8Ra93", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iyFot = parcelRequire("iyFot");

var $g8Glr = parcelRequire("g8Glr");

var $hMBcl = parcelRequire("hMBcl");
function $672b2495b1b12901$var$extractGenAiSpansFromEvent(event, client) {
    if (event.type !== "transaction" || !event.spans?.length || !event.sdkProcessingMetadata?.hasGenAiSpans || client.getOptions().streamGenAiSpans === false || $g8Glr.hasSpanStreamingEnabled(client)) return void 0;
    const genAiSpans = [];
    const remainingSpans = [];
    for (const span of event.spans)if (span.op?.startsWith("gen_ai.")) genAiSpans.push($hMBcl.spanJsonToSerializedStreamedSpan(span));
    else remainingSpans.push(span);
    if (genAiSpans.length === 0) return void 0;
    event.spans = remainingSpans;
    const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
    return [
        {
            type: "span",
            item_count: genAiSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        {
            version: 2,
            ...$iyFot.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: genAiSpans
        }
    ];
}
module.exports.extractGenAiSpansFromEvent = $672b2495b1b12901$var$extractGenAiSpansFromEvent;

});
parcelRegister("hMBcl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8hCvI = parcelRequire("8hCvI");
function $cf23c6204398503a$var$spanJsonToSerializedStreamedSpan(span) {
    const streamedSpan = {
        trace_id: span.trace_id,
        span_id: span.span_id,
        parent_span_id: span.parent_span_id,
        name: span.description || "",
        start_timestamp: span.start_timestamp,
        end_timestamp: span.timestamp || span.start_timestamp,
        status: !span.status || span.status === "ok" || span.status === "cancelled" ? "ok" : "error",
        is_segment: false,
        attributes: {
            ...span.data
        },
        links: span.links
    };
    return $8hCvI.streamedSpanJsonToSerializedSpan(streamedSpan);
}
module.exports.spanJsonToSerializedStreamedSpan = $cf23c6204398503a$var$spanJsonToSerializedStreamedSpan;

});


parcelRegister("eM0tn", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1GyI0 = parcelRequire("1GyI0");

var $2sm2V = parcelRequire("2sm2V");

var $kAeXb = parcelRequire("kAeXb");

var $4q9hx = parcelRequire("4q9hx");

var $1DVRT = parcelRequire("1DVRT");
const $ac15ea4240c6fb00$var$DEFAULT_TRANSPORT_BUFFER_SIZE = 64;
function $ac15ea4240c6fb00$var$createTransport(options, makeRequest, buffer = $4q9hx.makePromiseBuffer(options.bufferSize || $ac15ea4240c6fb00$var$DEFAULT_TRANSPORT_BUFFER_SIZE)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope$1) {
        const filteredEnvelopeItems = [];
        $kAeXb.forEachEnvelopeItem(envelope$1, (item, type)=>{
            const dataCategory = $kAeXb.envelopeItemTypeToDataCategory(type);
            if ($1DVRT.isRateLimited(rateLimits, dataCategory)) options.recordDroppedEvent("ratelimit_backoff", dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        if (filteredEnvelopeItems.length === 0) return Promise.resolve({});
        const filteredEnvelope = $kAeXb.createEnvelope(envelope$1[0], filteredEnvelopeItems);
        const recordEnvelopeLoss = (reason)=>{
            if ($kAeXb.envelopeContainsItemType(filteredEnvelope, [
                "client_report"
            ])) {
                $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn(`Dropping client report. Will not send outcomes (reason: ${reason}).`);
                return;
            }
            $kAeXb.forEachEnvelopeItem(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, $kAeXb.envelopeItemTypeToDataCategory(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: $kAeXb.serializeEnvelope(filteredEnvelope)
            }).then((response)=>{
                if (response.statusCode === 413) {
                    $1GyI0.DEBUG_BUILD && $2sm2V.debug.error("Sentry responded with status code 413. Envelope was discarded due to exceeding size limits.");
                    recordEnvelopeLoss("send_error");
                    return response;
                }
                if ($1GyI0.DEBUG_BUILD && response.statusCode !== void 0 && (response.statusCode < 200 || response.statusCode >= 300)) $2sm2V.debug.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = $1DVRT.updateRateLimits(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                $1GyI0.DEBUG_BUILD && $2sm2V.debug.error("Encountered error running transport request:", error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === $4q9hx.SENTRY_BUFFER_FULL_ERROR) {
                $1GyI0.DEBUG_BUILD && $2sm2V.debug.error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return Promise.resolve({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
module.exports.DEFAULT_TRANSPORT_BUFFER_SIZE = $ac15ea4240c6fb00$var$DEFAULT_TRANSPORT_BUFFER_SIZE;
module.exports.createTransport = $ac15ea4240c6fb00$var$createTransport;

});
parcelRegister("4q9hx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3MHSz = parcelRequire("3MHSz");

var $aRuEF = parcelRequire("aRuEF");
const $3380ca57a11b67f7$var$SENTRY_BUFFER_FULL_ERROR = /* @__PURE__ */ Symbol.for("SentryBufferFullError");
function $3380ca57a11b67f7$var$makePromiseBuffer(limit = 100) {
    const buffer = /* @__PURE__ */ new Set();
    function isReady() {
        return buffer.size < limit;
    }
    function remove(task) {
        buffer.delete(task);
    }
    function add(taskProducer) {
        if (!isReady()) return $3MHSz.rejectedSyncPromise($3380ca57a11b67f7$var$SENTRY_BUFFER_FULL_ERROR);
        const task = taskProducer();
        buffer.add(task);
        task.then(()=>remove(task), ()=>remove(task));
        return task;
    }
    function drain(timeout) {
        if (!buffer.size) return $3MHSz.resolvedSyncPromise(true);
        const drainPromise = Promise.allSettled(Array.from(buffer)).then(()=>true);
        if (!timeout) return drainPromise;
        const promises = [
            drainPromise,
            new Promise((resolve)=>$aRuEF.safeUnref(setTimeout(()=>resolve(false), timeout)))
        ];
        return Promise.race(promises);
    }
    return {
        get $ () {
            return Array.from(buffer);
        },
        add: add,
        drain: drain
    };
}
module.exports.SENTRY_BUFFER_FULL_ERROR = $3380ca57a11b67f7$var$SENTRY_BUFFER_FULL_ERROR;
module.exports.makePromiseBuffer = $3380ca57a11b67f7$var$makePromiseBuffer;

});

parcelRegister("1DVRT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6ki8f = parcelRequire("6ki8f");
const $1326526274d8bdc6$var$DEFAULT_RETRY_AFTER = 60000;
function $1326526274d8bdc6$var$parseRetryAfterHeader(header, now = $6ki8f.safeDateNow()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1e3;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $1326526274d8bdc6$var$DEFAULT_RETRY_AFTER;
}
function $1326526274d8bdc6$var$disabledUntil(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
function $1326526274d8bdc6$var$isRateLimited(limits, dataCategory, now = $6ki8f.safeDateNow()) {
    return $1326526274d8bdc6$var$disabledUntil(limits, dataCategory) > now;
}
function $1326526274d8bdc6$var$updateRateLimits(limits, { statusCode: statusCode, headers: headers }, now = $6ki8f.safeDateNow()) {
    const updatedRateLimits = {
        ...limits
    };
    const rateLimitHeader = headers?.["x-sentry-rate-limits"];
    const retryAfterHeader = headers?.["retry-after"];
    if (rateLimitHeader) for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1e3;
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $1326526274d8bdc6$var$parseRetryAfterHeader(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}
module.exports.DEFAULT_RETRY_AFTER = $1326526274d8bdc6$var$DEFAULT_RETRY_AFTER;
module.exports.disabledUntil = $1326526274d8bdc6$var$disabledUntil;
module.exports.isRateLimited = $1326526274d8bdc6$var$isRateLimited;
module.exports.parseRetryAfterHeader = $1326526274d8bdc6$var$parseRetryAfterHeader;
module.exports.updateRateLimits = $1326526274d8bdc6$var$updateRateLimits;

});


parcelRegister("6woCN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kAeXb = parcelRequire("kAeXb");

var $gU6V8 = parcelRequire("gU6V8");
function $4bf8d52df62992a9$var$createClientReportEnvelope(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || $gU6V8.dateTimestampInSeconds(),
            discarded_events: discarded_events
        }
    ];
    return $kAeXb.createEnvelope(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}
module.exports.createClientReportEnvelope = $4bf8d52df62992a9$var$createClientReportEnvelope;

});

parcelRegister("1MOT2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $14d1bf3440e5ee6e$var$getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch  {}
    return possibleMessages;
}
module.exports.getPossibleEventMessages = $14d1bf3440e5ee6e$var$getPossibleEventMessages;

});

parcelRegister("bg9SP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2JysJ = parcelRequire("2JysJ");
function $8328dafa56b3de2e$var$convertTransactionEventToSpanJson(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? "",
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? "",
        origin: origin,
        profile_id: data?.[$2JysJ.SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: data?.[$2JysJ.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    };
}
function $8328dafa56b3de2e$var$convertSpanJsonToTransactionEvent(span) {
    return {
        type: "transaction",
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [$2JysJ.SEMANTIC_ATTRIBUTE_PROFILE_ID]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [$2JysJ.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}
module.exports.convertSpanJsonToTransactionEvent = $8328dafa56b3de2e$var$convertSpanJsonToTransactionEvent;
module.exports.convertTransactionEventToSpanJson = $8328dafa56b3de2e$var$convertTransactionEventToSpanJson;

});

parcelRegister("8LBn0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kxICp = parcelRequire("kxICp");
const $661fb374ebe8ed5a$var$DEFAULTS = {
    userInfo: true,
    cookies: true,
    httpHeaders: {
        request: true,
        response: true
    },
    httpBodies: [
        "incomingRequest",
        "outgoingRequest",
        "incomingResponse",
        "outgoingResponse"
    ],
    urlQueryParams: true,
    graphQL: {
        document: true,
        variables: true
    },
    genAI: {
        inputs: true,
        outputs: true
    },
    databaseQueryData: true,
    stackFrameVariables: true,
    frameContextLines: 5
};
function $661fb374ebe8ed5a$var$isCollectBehavior(value) {
    return typeof value === "boolean" || "allow" in value || "deny" in value;
}
function $661fb374ebe8ed5a$var$resolveHttpHeaders(httpHeaders, base) {
    if (httpHeaders === void 0) return {
        ...base.httpHeaders
    };
    if ($661fb374ebe8ed5a$var$isCollectBehavior(httpHeaders)) return {
        request: httpHeaders,
        response: httpHeaders
    };
    return {
        request: httpHeaders.request ?? base.httpHeaders.request,
        response: httpHeaders.response ?? base.httpHeaders.response
    };
}
function $661fb374ebe8ed5a$var$resolveDataCollectionOptions(options) {
    const base = options.dataCollection != null ? $661fb374ebe8ed5a$var$DEFAULTS : $kxICp.defaultPiiToCollectionOptions(options.sendDefaultPii);
    const dc = options.dataCollection ?? {};
    return {
        userInfo: dc.userInfo ?? base.userInfo,
        cookies: dc.cookies ?? base.cookies,
        httpHeaders: $661fb374ebe8ed5a$var$resolveHttpHeaders(dc.httpHeaders, base),
        httpBodies: dc.httpBodies ?? base.httpBodies,
        // oxlint-disable-next-line typescript/no-deprecated
        urlQueryParams: dc.urlQueryParams ?? dc.queryParams ?? base.urlQueryParams,
        graphQL: {
            document: dc.graphQL?.document ?? base.graphQL.document,
            variables: dc.graphQL?.variables ?? base.graphQL.variables
        },
        genAI: {
            inputs: dc.genAI?.inputs ?? base.genAI.inputs,
            outputs: dc.genAI?.outputs ?? base.genAI.outputs
        },
        databaseQueryData: dc.databaseQueryData ?? base.databaseQueryData,
        stackFrameVariables: dc.stackFrameVariables ?? base.stackFrameVariables,
        frameContextLines: dc.frameContextLines ?? base.frameContextLines
    };
}
module.exports.resolveDataCollectionOptions = $661fb374ebe8ed5a$var$resolveDataCollectionOptions;

});
parcelRegister("kxICp", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $j1UWZ = parcelRequire("j1UWZ");
function $ef4980070ac9a4da$var$defaultPiiToCollectionOptions(sendDefaultPii) {
    return sendDefaultPii === true ? {
        userInfo: true,
        cookies: true,
        httpHeaders: {
            request: true,
            response: true
        },
        httpBodies: [
            "incomingRequest",
            "outgoingRequest",
            "incomingResponse",
            "outgoingResponse"
        ],
        urlQueryParams: true,
        graphQL: {
            document: true,
            variables: true
        },
        genAI: {
            inputs: true,
            outputs: true
        },
        databaseQueryData: true,
        stackFrameVariables: true,
        frameContextLines: 7
    } : {
        userInfo: false,
        cookies: {
            deny: $j1UWZ.PII_HEADER_SNIPPETS
        },
        httpHeaders: {
            request: {
                deny: $j1UWZ.PII_HEADER_SNIPPETS
            },
            response: {
                deny: $j1UWZ.PII_HEADER_SNIPPETS
            }
        },
        httpBodies: [],
        urlQueryParams: {
            deny: $j1UWZ.PII_HEADER_SNIPPETS
        },
        // The GraphQL document has literal values redacted at collection time, so it was historically
        // always attached regardless of `sendDefaultPii`; keep it on to preserve that behavior.
        graphQL: {
            document: true,
            variables: true
        },
        genAI: {
            inputs: false,
            outputs: false
        },
        // Database query values were only sent with `sendDefaultPii: true` (e.g. Supabase gated on it),
        // so map the legacy "off" state to `false`.
        databaseQueryData: false,
        stackFrameVariables: true,
        frameContextLines: 7
    };
}
module.exports.defaultPiiToCollectionOptions = $ef4980070ac9a4da$var$defaultPiiToCollectionOptions;

});
parcelRegister("j1UWZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $ddaa497e2eb58809$var$FILTERED_VALUE = "[Filtered]";
const $ddaa497e2eb58809$var$PII_HEADER_SNIPPETS = [
    "forwarded",
    "-ip",
    "remote-",
    "via",
    "-user"
];
const $ddaa497e2eb58809$var$SENSITIVE_KEY_SNIPPETS = [
    "auth",
    "token",
    "secret",
    "session",
    // for the user_session cookie
    "password",
    "passwd",
    "pwd",
    "key",
    "jwt",
    "bearer",
    "sso",
    "saml",
    "csrf",
    "xsrf",
    "credentials",
    "sid",
    "identity",
    // Always treat cookie headers as sensitive in case individual key-value cookie pairs cannot properly be extracted
    "set-cookie",
    "cookie"
];
const $ddaa497e2eb58809$var$SENSITIVE_COOKIE_NAME_SNIPPETS = [
    // Express / Connect default session cookie
    ".sid",
    // Opaque session ids (PHPSESSID, ASPSESSIONID*, BIGipServer*, *sessid*, …)
    "sessid",
    // Laravel etc. "remember me" tokens
    "remember",
    // OIDC / OAuth auxiliary (`oauth*` covered by header snippet `auth`)
    "oidc",
    "pkce",
    "nonce",
    // RFC 6265bis high-security cookie name prefixes
    "__secure-",
    "__host-",
    // Load balancer / CDN sticky-session cookies (opaque routing tokens)
    "awsalb",
    "awselb",
    "akamai",
    // BaaS / IdP session cookies (names often omit "session")
    "__stripe",
    "cognito",
    "firebase",
    "supabase",
    "sb-",
    // Step-up / MFA cookies
    "mfa",
    "2fa"
];
module.exports.FILTERED_VALUE = $ddaa497e2eb58809$var$FILTERED_VALUE;
module.exports.PII_HEADER_SNIPPETS = $ddaa497e2eb58809$var$PII_HEADER_SNIPPETS;
module.exports.SENSITIVE_COOKIE_NAME_SNIPPETS = $ddaa497e2eb58809$var$SENSITIVE_COOKIE_NAME_SNIPPETS;
module.exports.SENSITIVE_KEY_SNIPPETS = $ddaa497e2eb58809$var$SENSITIVE_KEY_SNIPPETS;

});




parcelRegister("3y8q6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kfJmY = parcelRequire("kfJmY");

var $1GyI0 = parcelRequire("1GyI0");

var $2sm2V = parcelRequire("2sm2V");
function $295b1422b04b6081$var$initAndBind(clientClass, options) {
    if (options.debug === true) {
        if ($1GyI0.DEBUG_BUILD) $2sm2V.debug.enable();
        else $2sm2V.consoleSandbox(()=>{
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = $kfJmY.getCurrentScope();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $295b1422b04b6081$var$setCurrentClient(client);
    client.init();
    return client;
}
function $295b1422b04b6081$var$setCurrentClient(client) {
    $kfJmY.getCurrentScope().setClient(client);
}
module.exports.initAndBind = $295b1422b04b6081$var$initAndBind;
module.exports.setCurrentClient = $295b1422b04b6081$var$setCurrentClient;

});

parcelRegister("ivDYu", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1GyI0 = parcelRequire("1GyI0");

var $2sm2V = parcelRequire("2sm2V");

var $kAeXb = parcelRequire("kAeXb");

var $6ki8f = parcelRequire("6ki8f");

var $1DVRT = parcelRequire("1DVRT");

var $aRuEF = parcelRequire("aRuEF");
const $d79a215ed398b4ce$var$MIN_DELAY = 100;
const $d79a215ed398b4ce$var$START_DELAY = 5e3;
const $d79a215ed398b4ce$var$MAX_DELAY = 36e5;
function $d79a215ed398b4ce$var$makeOfflineTransport(createTransport) {
    function log(...args) {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.log("[Offline]:", ...args);
    }
    return (options)=>{
        const transport = createTransport(options);
        if (!options.createStore) throw new Error("No `createStore` function was provided");
        const store = options.createStore(options);
        let retryDelay = $d79a215ed398b4ce$var$START_DELAY;
        let flushTimer;
        function shouldQueue(env, error, retryDelay2) {
            if ($kAeXb.envelopeContainsItemType(env, [
                "client_report"
            ])) return false;
            if (options.shouldStore) return options.shouldStore(env, error, retryDelay2);
            return true;
        }
        function flushIn(delay) {
            if (flushTimer) clearTimeout(flushTimer);
            flushTimer = $aRuEF.safeUnref(setTimeout(async ()=>{
                flushTimer = void 0;
                const found = await store.shift();
                if (found) {
                    log("Attempting to send previously queued event");
                    found[0].sent_at = new Date($6ki8f.safeDateNow()).toISOString();
                    send(found, true).catch((e)=>{
                        log("Failed to retry sending", e);
                    });
                }
            }, delay));
        }
        function flushWithBackOff() {
            if (flushTimer) return;
            flushIn(retryDelay);
            retryDelay = Math.min(retryDelay * 2, $d79a215ed398b4ce$var$MAX_DELAY);
        }
        async function send(envelope$1, isRetry = false) {
            if (!isRetry && $kAeXb.envelopeContainsItemType(envelope$1, [
                "replay_event",
                "replay_recording"
            ])) {
                await store.push(envelope$1);
                flushIn($d79a215ed398b4ce$var$MIN_DELAY);
                return {};
            }
            try {
                if (options.shouldSend && await options.shouldSend(envelope$1) === false) throw new Error("Envelope not sent because `shouldSend` callback returned false");
                const result = await transport.send(envelope$1);
                let delay = $d79a215ed398b4ce$var$MIN_DELAY;
                if (result) {
                    if (result.headers?.["retry-after"]) delay = $1DVRT.parseRetryAfterHeader(result.headers["retry-after"]);
                    else if (result.headers?.["x-sentry-rate-limits"]) delay = 6e4;
                    else if ((result.statusCode || 0) >= 400) return result;
                }
                flushIn(delay);
                retryDelay = $d79a215ed398b4ce$var$START_DELAY;
                return result;
            } catch (e) {
                if (await shouldQueue(envelope$1, e, retryDelay)) {
                    if (isRetry) await store.unshift(envelope$1);
                    else await store.push(envelope$1);
                    flushWithBackOff();
                    log("Error sending. Event queued.", e);
                    return {};
                } else throw e;
            }
        }
        if (options.flushAtStartup) flushWithBackOff();
        return {
            send: send,
            flush: (timeout)=>{
                if (timeout === void 0) {
                    retryDelay = $d79a215ed398b4ce$var$START_DELAY;
                    flushIn($d79a215ed398b4ce$var$MIN_DELAY);
                }
                return transport.flush(timeout);
            }
        };
    };
}
module.exports.MIN_DELAY = $d79a215ed398b4ce$var$MIN_DELAY;
module.exports.START_DELAY = $d79a215ed398b4ce$var$START_DELAY;
module.exports.makeOfflineTransport = $d79a215ed398b4ce$var$makeOfflineTransport;

});

parcelRegister("aHFbi", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $44Knx = parcelRequire("44Knx");

var $ebmC5 = parcelRequire("ebmC5");

var $kAeXb = parcelRequire("kAeXb");
const $7caddd49c72c9a8c$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY = "MULTIPLEXED_TRANSPORT_EXTRA_KEY";
function $7caddd49c72c9a8c$var$eventFromEnvelope(env, types) {
    let event;
    $kAeXb.forEachEnvelopeItem(env, (item, type)=>{
        if (types.includes(type)) event = Array.isArray(item) ? item[1] : void 0;
        return !!event;
    });
    return event;
}
function $7caddd49c72c9a8c$var$makeOverrideReleaseTransport(createTransport, release) {
    return (options)=>{
        const transport = createTransport(options);
        return {
            ...transport,
            send: async (envelope)=>{
                const event = $7caddd49c72c9a8c$var$eventFromEnvelope(envelope, [
                    "event",
                    "transaction",
                    "profile",
                    "replay_event"
                ]);
                if (event) event.release = release;
                return transport.send(envelope);
            }
        };
    };
}
function $7caddd49c72c9a8c$var$overrideDsn(envelope$1, dsn) {
    return $kAeXb.createEnvelope(dsn ? {
        ...envelope$1[0],
        dsn: dsn
    } : envelope$1[0], envelope$1[1]);
}
function $7caddd49c72c9a8c$var$makeMultiplexedTransport(createTransport, matcher) {
    return (options)=>{
        const fallbackTransport = createTransport(options);
        const otherTransports = /* @__PURE__ */ new Map();
        const actualMatcher = matcher || ((args)=>{
            const event = args.getEvent();
            if (event?.extra?.[$7caddd49c72c9a8c$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY] && Array.isArray(event.extra[$7caddd49c72c9a8c$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY])) return event.extra[$7caddd49c72c9a8c$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY];
            return [];
        });
        function getTransport(dsn$1, release) {
            const key = release ? `${dsn$1}:${release}` : dsn$1;
            let transport = otherTransports.get(key);
            if (!transport) {
                const validatedDsn = $ebmC5.dsnFromString(dsn$1);
                if (!validatedDsn) return void 0;
                const url = $44Knx.getEnvelopeEndpointWithUrlEncodedAuth(validatedDsn, options.tunnel);
                transport = release ? $7caddd49c72c9a8c$var$makeOverrideReleaseTransport(createTransport, release)({
                    ...options,
                    url: url
                }) : createTransport({
                    ...options,
                    url: url
                });
                otherTransports.set(key, transport);
            }
            return [
                dsn$1,
                transport
            ];
        }
        async function send(envelope) {
            function getEvent(types) {
                const eventTypes = types?.length ? types : [
                    "event"
                ];
                return $7caddd49c72c9a8c$var$eventFromEnvelope(envelope, eventTypes);
            }
            const transports = actualMatcher({
                envelope: envelope,
                getEvent: getEvent
            }).map((result)=>{
                if (typeof result === "string") return getTransport(result, void 0);
                else return getTransport(result.dsn, result.release);
            }).filter((t)=>!!t);
            const transportsWithFallback = transports.length ? transports : [
                [
                    "",
                    fallbackTransport
                ]
            ];
            const results = await Promise.all(transportsWithFallback.map(([dsn, transport])=>transport.send($7caddd49c72c9a8c$var$overrideDsn(envelope, dsn))));
            return results[0];
        }
        async function flush(timeout) {
            const allTransports = [
                ...otherTransports.values(),
                fallbackTransport
            ];
            const results = await Promise.all(allTransports.map((transport)=>transport.flush(timeout)));
            return results.every((r)=>r);
        }
        return {
            send: send,
            flush: flush
        };
    };
}
module.exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = $7caddd49c72c9a8c$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY;
module.exports.eventFromEnvelope = $7caddd49c72c9a8c$var$eventFromEnvelope;
module.exports.makeMultiplexedTransport = $7caddd49c72c9a8c$var$makeMultiplexedTransport;

});

parcelRegister("7it17", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1GyI0 = parcelRequire("1GyI0");

var $2sm2V = parcelRequire("2sm2V");
const $5500b906384789a2$var$SKIPPED_AI_PROVIDERS = /* @__PURE__ */ new Set();
function $5500b906384789a2$var$_INTERNAL_skipAiProviderWrapping(modules) {
    modules.forEach((module)=>{
        $5500b906384789a2$var$SKIPPED_AI_PROVIDERS.add(module);
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.log(`AI provider "${module}" wrapping will be skipped`);
    });
}
function $5500b906384789a2$var$_INTERNAL_shouldSkipAiProviderWrapping(module) {
    return $5500b906384789a2$var$SKIPPED_AI_PROVIDERS.has(module);
}
function $5500b906384789a2$var$_INTERNAL_clearAiProviderSkips() {
    $5500b906384789a2$var$SKIPPED_AI_PROVIDERS.clear();
    $1GyI0.DEBUG_BUILD && $2sm2V.debug.log("Cleared AI provider skip registrations");
}
module.exports._INTERNAL_clearAiProviderSkips = $5500b906384789a2$var$_INTERNAL_clearAiProviderSkips;
module.exports._INTERNAL_shouldSkipAiProviderWrapping = $5500b906384789a2$var$_INTERNAL_shouldSkipAiProviderWrapping;
module.exports._INTERNAL_skipAiProviderWrapping = $5500b906384789a2$var$_INTERNAL_skipAiProviderWrapping;

});

parcelRegister("HDJnZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $j1UWZ = parcelRequire("j1UWZ");
function $0832d605992d5fdd$var$isSensitiveKey(lower, denySnippets) {
    return denySnippets.some((snippet)=>lower.includes(snippet));
}
function $0832d605992d5fdd$var$filterKeyValueData(data, behavior, additionalDenyTerms) {
    if (behavior === false) return {};
    const denySnippets = additionalDenyTerms != null ? [
        ...$j1UWZ.SENSITIVE_KEY_SNIPPETS,
        ...additionalDenyTerms
    ] : $j1UWZ.SENSITIVE_KEY_SNIPPETS;
    const result = {};
    if (behavior === true) {
        for (const key of Object.keys(data))result[key] = $0832d605992d5fdd$var$isSensitiveKey(key.toLowerCase(), denySnippets) ? $j1UWZ.FILTERED_VALUE : data[key];
        return result;
    }
    if ("deny" in behavior) {
        const lowerTerms2 = behavior.deny.map((t)=>t.toLowerCase());
        for (const key of Object.keys(data)){
            const lower = key.toLowerCase();
            const isDenied = $0832d605992d5fdd$var$isSensitiveKey(lower, denySnippets) || lowerTerms2.some((term)=>lower.includes(term));
            result[key] = isDenied ? $j1UWZ.FILTERED_VALUE : data[key];
        }
        return result;
    }
    const lowerTerms = behavior.allow.map((t)=>t.toLowerCase());
    for (const key of Object.keys(data)){
        const lower = key.toLowerCase();
        if ($0832d605992d5fdd$var$isSensitiveKey(lower, denySnippets)) result[key] = $j1UWZ.FILTERED_VALUE;
        else {
            const isAllowed = lowerTerms.some((term)=>lower.includes(term));
            result[key] = isAllowed ? data[key] : $j1UWZ.FILTERED_VALUE;
        }
    }
    return result;
}
module.exports.filterKeyValueData = $0832d605992d5fdd$var$filterKeyValueData;

});

parcelRegister("6l4Z5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jUOx9 = parcelRequire("jUOx9");

var $j1UWZ = parcelRequire("j1UWZ");

var $HDJnZ = parcelRequire("HDJnZ");
function $49d892095223856b$var$filterCookies(cookieString, behavior) {
    if (behavior === false) return {};
    try {
        const parsed = $jUOx9.parseCookie(cookieString);
        if (Object.keys(parsed).length === 0) return {};
        return $HDJnZ.filterKeyValueData(parsed, behavior, $j1UWZ.SENSITIVE_COOKIE_NAME_SNIPPETS);
    } catch  {
        return $j1UWZ.FILTERED_VALUE;
    }
}
module.exports.filterCookies = $49d892095223856b$var$filterCookies;

});
parcelRegister("jUOx9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $e7fa723d945b97fc$var$parseCookie(str) {
    const obj = {};
    let index = 0;
    while(index < str.length){
        const eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) break;
        let endIdx = str.indexOf(";", index);
        if (endIdx === -1) endIdx = str.length;
        else if (endIdx < eqIdx) {
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const key = str.slice(index, eqIdx).trim();
        if (void 0 === obj[key]) {
            let val = str.slice(eqIdx + 1, endIdx).trim();
            if (val.charCodeAt(0) === 34) val = val.slice(1, -1);
            try {
                obj[key] = val.indexOf("%") !== -1 ? decodeURIComponent(val) : val;
            } catch  {
                obj[key] = val;
            }
        }
        index = endIdx + 1;
    }
    return obj;
}
module.exports.parseCookie = $e7fa723d945b97fc$var$parseCookie;

});


parcelRegister("iHwWw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $j1UWZ = parcelRequire("j1UWZ");

var $HDJnZ = parcelRequire("HDJnZ");
function $d9d5cbed652b3a02$var$filterQueryParams(queryString, behavior) {
    if (behavior === false) return {};
    try {
        const params = new URLSearchParams(queryString);
        const parsed = {};
        params.forEach((value, key)=>{
            parsed[key] = value;
        });
        if (Object.keys(parsed).length === 0) return {};
        return $HDJnZ.filterKeyValueData(parsed, behavior);
    } catch  {
        return $j1UWZ.FILTERED_VALUE;
    }
}
module.exports.filterQueryParams = $d9d5cbed652b3a02$var$filterQueryParams;

});

parcelRegister("88CzX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $5eccff0e79937203$var$FALSY_ENV_VALUES = /* @__PURE__ */ new Set([
    "false",
    "f",
    "n",
    "no",
    "off",
    "0"
]);
const $5eccff0e79937203$var$TRUTHY_ENV_VALUES = /* @__PURE__ */ new Set([
    "true",
    "t",
    "y",
    "yes",
    "on",
    "1"
]);
function $5eccff0e79937203$var$envToBool(value, options) {
    const normalized = String(value).toLowerCase();
    if ($5eccff0e79937203$var$FALSY_ENV_VALUES.has(normalized)) return false;
    if ($5eccff0e79937203$var$TRUTHY_ENV_VALUES.has(normalized)) return true;
    return options?.strict ? null : Boolean(value);
}
module.exports.FALSY_ENV_VALUES = $5eccff0e79937203$var$FALSY_ENV_VALUES;
module.exports.TRUTHY_ENV_VALUES = $5eccff0e79937203$var$TRUTHY_ENV_VALUES;
module.exports.envToBool = $5eccff0e79937203$var$envToBool;

});

parcelRegister("ktZhU", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ebmC5 = parcelRequire("ebmC5");

var $kAeXb = parcelRequire("kAeXb");

var $6ki8f = parcelRequire("6ki8f");
function $ee960e977730ef10$var$createCheckInEnvelope(checkIn, dynamicSamplingContext, metadata, tunnel, dsn$1) {
    const headers = {
        sent_at: new Date($6ki8f.safeDateNow()).toISOString()
    };
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $ebmC5.dsnToString(dsn$1);
    if (dynamicSamplingContext) headers.trace = dynamicSamplingContext;
    const item = $ee960e977730ef10$var$createCheckInEnvelopeItem(checkIn);
    return $kAeXb.createEnvelope(headers, [
        item
    ]);
}
function $ee960e977730ef10$var$createCheckInEnvelopeItem(checkIn) {
    const checkInHeaders = {
        type: "check_in"
    };
    return [
        checkInHeaders,
        checkIn
    ];
}
module.exports.createCheckInEnvelope = $ee960e977730ef10$var$createCheckInEnvelope;

});

parcelRegister("ceuzm", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $foGB0 = parcelRequire("foGB0");
function $8e7e8146d8dd4f42$var$isSentryRequestUrl(url, client) {
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    return $8e7e8146d8dd4f42$var$checkDsn(url, dsn) || $8e7e8146d8dd4f42$var$checkTunnel(url, tunnel);
}
function $8e7e8146d8dd4f42$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $8e7e8146d8dd4f42$var$removeTrailingSlash(url) === $8e7e8146d8dd4f42$var$removeTrailingSlash(tunnel);
}
function $8e7e8146d8dd4f42$var$checkDsn(url$1, dsn) {
    const urlParts = $foGB0.parseStringToURLObject(url$1);
    if (!urlParts || $foGB0.isURLObjectRelative(urlParts)) return false;
    if (!dsn) return false;
    return $8e7e8146d8dd4f42$var$hostnameMatchesDsnHost(urlParts.hostname, dsn.host) && /(^|&|\?)sentry_key=/.test(urlParts.search);
}
function $8e7e8146d8dd4f42$var$hostnameMatchesDsnHost(hostname, dsnHost) {
    return hostname === dsnHost || dsnHost.length > 0 && hostname.endsWith(`.${dsnHost}`);
}
function $8e7e8146d8dd4f42$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}
module.exports.isSentryRequestUrl = $8e7e8146d8dd4f42$var$isSentryRequestUrl;

});
parcelRegister("foGB0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3tmPs = parcelRequire("3tmPs");

var $2JysJ = parcelRequire("2JysJ");
const $b35a2390e9ca2adb$var$DEFAULT_BASE_URL = "thismessage:/";
function $b35a2390e9ca2adb$var$isURLObjectRelative(url) {
    return "isRelative" in url;
}
function $b35a2390e9ca2adb$var$parseStringToURLObject(url, urlBase) {
    const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    const base = urlBase ?? (isRelative ? $b35a2390e9ca2adb$var$DEFAULT_BASE_URL : void 0);
    try {
        if ("canParse" in URL && !URL.canParse(url, base)) return void 0;
        const fullUrlObject = new URL(url, base);
        if (isRelative) return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {}
    return void 0;
}
function $b35a2390e9ca2adb$var$getSanitizedUrlStringFromUrlObject(url) {
    if ($b35a2390e9ca2adb$var$isURLObjectRelative(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function $b35a2390e9ca2adb$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? "GET";
    const route = routeName ? routeName : urlObject ? kind === "client" ? $b35a2390e9ca2adb$var$getSanitizedUrlStringFromUrlObject(urlObject) : urlObject.pathname : "/";
    return `${method} ${route}`;
}
function $b35a2390e9ca2adb$var$getHttpSpanDetailsFromUrlObject(urlObject, kind, spanOrigin, request, routeName) {
    const attributes$1 = {
        [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "url"
    };
    if (routeName) {
        attributes$1[kind === "server" ? "http.route" : "url.template"] = routeName;
        attributes$1[$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
    }
    if (request?.method) attributes$1[$2JysJ.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes$1["url.query"] = urlObject.search;
        if (urlObject.hash) attributes$1["url.fragment"] = urlObject.hash;
        if (urlObject.pathname) {
            attributes$1["url.path"] = urlObject.pathname;
            if (urlObject.pathname === "/") attributes$1[$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
        }
        if (!$b35a2390e9ca2adb$var$isURLObjectRelative(urlObject)) {
            attributes$1[$3tmPs.URL_FULL] = urlObject.href;
            if (urlObject.port) attributes$1["url.port"] = urlObject.port;
            if (urlObject.protocol) attributes$1["url.scheme"] = urlObject.protocol;
            if (urlObject.hostname) attributes$1[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
        }
    }
    return [
        $b35a2390e9ca2adb$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes$1
    ];
}
function $b35a2390e9ca2adb$var$parseUrl(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
function $b35a2390e9ca2adb$var$stripUrlQueryAndFragment(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
function $b35a2390e9ca2adb$var$getSanitizedUrlString(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}
function $b35a2390e9ca2adb$var$stripDataUrlContent(url, includeDataPrefix = true) {
    if (url.startsWith("data:")) {
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : "text/plain";
        const isBase64 = url.includes(";base64,");
        const dataStart = url.indexOf(",");
        let dataPrefix = "";
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
    }
    return url;
}
module.exports.getHttpSpanDetailsFromUrlObject = $b35a2390e9ca2adb$var$getHttpSpanDetailsFromUrlObject;
module.exports.getSanitizedUrlString = $b35a2390e9ca2adb$var$getSanitizedUrlString;
module.exports.getSanitizedUrlStringFromUrlObject = $b35a2390e9ca2adb$var$getSanitizedUrlStringFromUrlObject;
module.exports.isURLObjectRelative = $b35a2390e9ca2adb$var$isURLObjectRelative;
module.exports.parseStringToURLObject = $b35a2390e9ca2adb$var$parseStringToURLObject;
module.exports.parseUrl = $b35a2390e9ca2adb$var$parseUrl;
module.exports.stripDataUrlContent = $b35a2390e9ca2adb$var$stripDataUrlContent;
module.exports.stripUrlQueryAndFragment = $b35a2390e9ca2adb$var$stripUrlQueryAndFragment;

});


parcelRegister("5nIsa", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $3eb1953e37d15bb2$var$parameterize(strings, ...values) {
    const formatted = new String(String.raw(strings, ...values));
    formatted.__sentry_template_string__ = strings.join("\0").replace(/%/g, "%%").replace(/\0/g, "%s");
    formatted.__sentry_template_values__ = values;
    return formatted;
}
const $3eb1953e37d15bb2$var$fmt = $3eb1953e37d15bb2$var$parameterize;
module.exports.fmt = $3eb1953e37d15bb2$var$fmt;
module.exports.parameterize = $3eb1953e37d15bb2$var$parameterize;

});

parcelRegister("fB38a", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $44Knx = parcelRequire("44Knx");

var $2sm2V = parcelRequire("2sm2V");

var $ebmC5 = parcelRequire("ebmC5");

var $kAeXb = parcelRequire("kAeXb");
async function $b5acbd689381c888$var$handleTunnelRequest(options) {
    const { request: request, allowedDsns: allowedDsns } = options;
    if (allowedDsns.length === 0) return new Response("Tunnel not configured", {
        status: 500
    });
    const body = new Uint8Array(await request.arrayBuffer());
    let envelopeHeader;
    try {
        [envelopeHeader] = $kAeXb.parseEnvelope(body);
    } catch  {
        return new Response("Invalid envelope", {
            status: 400
        });
    }
    if (!envelopeHeader) return new Response("Invalid envelope: missing header", {
        status: 400
    });
    const dsn$1 = envelopeHeader.dsn;
    if (!dsn$1) return new Response("Invalid envelope: missing DSN", {
        status: 400
    });
    const isAllowed = allowedDsns.some((allowed)=>allowed === dsn$1);
    if (!isAllowed) {
        $2sm2V.debug.warn(`Sentry tunnel: rejected request with unauthorized DSN (${dsn$1})`);
        return new Response("DSN not allowed", {
            status: 403
        });
    }
    const dsnComponents = $ebmC5.makeDsn(dsn$1);
    if (!dsnComponents) {
        $2sm2V.debug.warn(`Could not extract DSN Components from: ${dsn$1}`);
        return new Response("Invalid DSN", {
            status: 403
        });
    }
    const sentryIngestUrl = $44Knx.getEnvelopeEndpointWithUrlEncodedAuth(dsnComponents);
    try {
        return await fetch(sentryIngestUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-sentry-envelope"
            },
            body: body
        });
    } catch (error) {
        $2sm2V.debug.error("Sentry tunnel: failed to forward envelope", error);
        return new Response("Failed to forward envelope to Sentry", {
            status: 500
        });
    }
}
module.exports.handleTunnelRequest = $b5acbd689381c888$var$handleTunnelRequest;

});

parcelRegister("1Sd23", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $15d4f18367318415$var$addAutoIpAddressToUser(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === void 0) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: "{{auto}}"
    };
}
function $15d4f18367318415$var$addAutoIpAddressToSession(session) {
    if ("aggregates" in session) {
        if (session.attrs?.["ip_address"] === void 0) session.attrs = {
            ...session.attrs,
            ip_address: "{{auto}}"
        };
    } else if (session.ipAddress === void 0) session.ipAddress = "{{auto}}";
}
module.exports.addAutoIpAddressToSession = $15d4f18367318415$var$addAutoIpAddressToSession;
module.exports.addAutoIpAddressToUser = $15d4f18367318415$var$addAutoIpAddressToUser;

});

parcelRegister("hTNHq", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jvpRD = parcelRequire("jvpRD");
function $d07e1ffb8d40a825$var$applySdkMetadata(options, name, names = [
    name
], source = "npm") {
    const sdk = (options._metadata = options._metadata || {}).sdk = options._metadata.sdk || {};
    if (!sdk.name) {
        sdk.name = `sentry.javascript.${name}`;
        sdk.packages = names.map((name2)=>({
                name: `${source}:@sentry/${name2}`,
                version: $jvpRD.SDK_VERSION
            }));
        sdk.version = $jvpRD.SDK_VERSION;
    }
}
module.exports.applySdkMetadata = $d07e1ffb8d40a825$var$applySdkMetadata;

});

parcelRegister("jvpIz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $e3FcP = parcelRequire("e3FcP");

var $lyqaT = parcelRequire("lyqaT");

var $kfJmY = parcelRequire("kfJmY");

var $aK1wS = parcelRequire("aK1wS");

var $2sm2V = parcelRequire("2sm2V");

var $8hCvI = parcelRequire("8hCvI");

var $5xQO6 = parcelRequire("5xQO6");

var $fyn9D = parcelRequire("fyn9D");

var $dOSrX = parcelRequire("dOSrX");

var $QBqQc = parcelRequire("QBqQc");

var $bTcEr = parcelRequire("bTcEr");
function $e334dca06369a3d2$var$getTraceData(options = {}) {
    const client = options.client || $kfJmY.getClient();
    if (!$aK1wS.isEnabled() || !client) return {};
    const carrier$1 = $lyqaT.getMainCarrier();
    const acs = $e3FcP.getAsyncContextStrategy(carrier$1);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = options.scope || $kfJmY.getCurrentScope();
    const span = options.span || $8hCvI.getActiveSpan();
    const isTwpPlaceholder = $fyn9D.spanIsNonRecordingSpan(span) && !$5xQO6.hasSpansEnabled(client.getOptions());
    if (!span && $kfJmY.hasExternalPropagationContext()) return {};
    const sentryTrace = span && !isTwpPlaceholder ? $8hCvI.spanToTraceHeader(span) : $e334dca06369a3d2$var$scopeToTraceHeader(scope);
    const dsc = span ? $dOSrX.getDynamicSamplingContextFromSpan(span) : $dOSrX.getDynamicSamplingContextFromScope(client, scope);
    const baggage$1 = $QBqQc.dynamicSamplingContextToSentryBaggageHeader(dsc);
    const isValidSentryTraceHeader = $bTcEr.TRACEPARENT_REGEXP.test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        $2sm2V.debug.warn("Invalid sentry-trace data. Cannot generate trace data");
        return {};
    }
    const traceData = {
        "sentry-trace": sentryTrace,
        baggage: baggage$1
    };
    if (options.propagateTraceparent) traceData.traceparent = span && !isTwpPlaceholder ? $8hCvI.spanToTraceparentHeader(span) : $e334dca06369a3d2$var$scopeToTraceparentHeader(scope);
    return traceData;
}
function $e334dca06369a3d2$var$scopeToTraceHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return $bTcEr.generateSentryTraceHeader(traceId, propagationSpanId, sampled);
}
function $e334dca06369a3d2$var$scopeToTraceparentHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return $bTcEr.generateTraceparentHeader(traceId, propagationSpanId, sampled);
}
module.exports.getTraceData = $e334dca06369a3d2$var$getTraceData;

});

parcelRegister("ctbAP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1GyI0 = parcelRequire("1GyI0");

var $2sm2V = parcelRequire("2sm2V");

var $1L2sM = parcelRequire("1L2sM");
const $91412f9dbd2c08de$var$NOT_PROPAGATED_MESSAGE = "[Tracing] Not injecting trace data for url because it does not match tracePropagationTargets:";
function $91412f9dbd2c08de$var$shouldPropagateTraceForUrl(url, tracePropagationTargets, decisionMap) {
    if (typeof url !== "string" || !tracePropagationTargets) return true;
    const cachedDecision = decisionMap?.get(url);
    if (cachedDecision !== void 0) {
        $1GyI0.DEBUG_BUILD && !cachedDecision && $2sm2V.debug.log($91412f9dbd2c08de$var$NOT_PROPAGATED_MESSAGE, url);
        return cachedDecision;
    }
    const decision = $1L2sM.stringMatchesSomePattern(url, tracePropagationTargets);
    decisionMap?.set(url, decision);
    $1GyI0.DEBUG_BUILD && !decision && $2sm2V.debug.log($91412f9dbd2c08de$var$NOT_PROPAGATED_MESSAGE, url);
    return decision;
}
module.exports.shouldPropagateTraceForUrl = $91412f9dbd2c08de$var$shouldPropagateTraceForUrl;

});

parcelRegister("bXWmW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jvpIz = parcelRequire("jvpIz");
function $8b627b437663bb33$var$getTraceMetaTags(traceData$1) {
    return Object.entries(traceData$1 || $jvpIz.getTraceData()).map(([key, value])=>`<meta name="${key}" content="${value}"/>`).join("");
}
module.exports.getTraceMetaTags = $8b627b437663bb33$var$getTraceMetaTags;

});

parcelRegister("8TUca", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $67af0cff3b24b6f4$var$uniq(input) {
    return Array.from(new Set(input));
}
module.exports.uniq = $67af0cff3b24b6f4$var$uniq;

});

parcelRegister("f8jvI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1GyI0 = parcelRequire("1GyI0");

var $2sm2V = parcelRequire("2sm2V");

var $kxICp = parcelRequire("kxICp");

var $j1UWZ = parcelRequire("j1UWZ");

var $HDJnZ = parcelRequire("HDJnZ");

var $aRuEF = parcelRequire("aRuEF");
const $b046bcc314859bc2$var$MAX_BODY_BYTE_LENGTH = 1048576;
const $b046bcc314859bc2$var$TEXT_CONTENT_TYPES = [
    "text/",
    "application/json",
    "application/x-www-form-urlencoded",
    "application/xml",
    "application/graphql"
];
function $b046bcc314859bc2$var$getMaxBodyByteLength(maxRequestBodySize) {
    if (maxRequestBodySize === "small") return 1e3;
    if (maxRequestBodySize === "medium") return 1e4;
    return $b046bcc314859bc2$var$MAX_BODY_BYTE_LENGTH;
}
function $b046bcc314859bc2$var$winterCGHeadersToDict(winterCGHeaders) {
    const headers = {};
    try {
        winterCGHeaders.forEach((value, key)=>{
            if (typeof value === "string") headers[key] = value;
        });
    } catch  {}
    return headers;
}
function $b046bcc314859bc2$var$headersToDict(reqHeaders) {
    const headers = /* @__PURE__ */ Object.create(null);
    try {
        Object.entries(reqHeaders).forEach(([key, value])=>{
            if (typeof value === "string") headers[key] = value;
            else if (typeof value === "number") headers[key] = String(value);
        });
    } catch  {}
    return headers;
}
function $b046bcc314859bc2$var$winterCGRequestToRequestData(req) {
    const headers = $b046bcc314859bc2$var$winterCGHeadersToDict(req.headers);
    return {
        method: req.method,
        url: req.url,
        query_string: $b046bcc314859bc2$var$extractQueryParamsFromUrl(req.url),
        headers: headers
    };
}
function $b046bcc314859bc2$var$isTextualContentType(contentType) {
    if (!contentType) return false;
    const lowerContentType = contentType.toLowerCase();
    return $b046bcc314859bc2$var$TEXT_CONTENT_TYPES.some((type)=>lowerContentType.includes(type));
}
async function $b046bcc314859bc2$var$captureBodyFromWinterCGRequest(request, isolationScope, maxRequestBodySize) {
    try {
        const contentType = request.headers.get("content-type");
        if (!$b046bcc314859bc2$var$isTextualContentType(contentType)) {
            $1GyI0.DEBUG_BUILD && $2sm2V.debug.log("Skipping body capture for non-textual content type:", contentType);
            return;
        }
        if (!request.body) return;
        const contentLength = request.headers.get("content-length");
        const maxBodySize = $b046bcc314859bc2$var$getMaxBodyByteLength(maxRequestBodySize);
        if (contentLength) {
            const length = parseInt(contentLength, 10);
            if (!isNaN(length) && length > $b046bcc314859bc2$var$MAX_BODY_BYTE_LENGTH) {
                $1GyI0.DEBUG_BUILD && $2sm2V.debug.log("Skipping body capture: body too large", length);
                return;
            }
        }
        const clonedRequest = request.clone();
        const bodyPromise = clonedRequest.text();
        const timeoutPromise = new Promise((resolve)=>{
            $aRuEF.safeUnref(setTimeout(()=>resolve(null), 2e3));
        });
        const body = await Promise.race([
            bodyPromise,
            timeoutPromise
        ]);
        if (body === null) {
            $1GyI0.DEBUG_BUILD && $2sm2V.debug.log("Timeout reading request body");
            return;
        }
        if (!body) return;
        const encoder = new TextEncoder();
        const bytes = encoder.encode(body);
        const bodyByteLength = bytes.length;
        let truncatedBody;
        if (bodyByteLength > maxBodySize) {
            const decoder = new TextDecoder();
            truncatedBody = `${decoder.decode(bytes.slice(0, maxBodySize - 3))}...`;
        } else truncatedBody = body;
        isolationScope.setSDKProcessingMetadata({
            normalizedRequest: {
                data: truncatedBody
            }
        });
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.log("Captured request body:", bodyByteLength, "bytes");
    } catch (error) {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.error("Error capturing request body:", error);
    }
}
function $b046bcc314859bc2$var$httpRequestToRequestData(request) {
    const headers = request.headers || {};
    const forwardedHost = typeof headers["x-forwarded-host"] === "string" ? headers["x-forwarded-host"] : void 0;
    const host = forwardedHost || (typeof headers.host === "string" ? headers.host : void 0);
    const forwardedProto = typeof headers["x-forwarded-proto"] === "string" ? headers["x-forwarded-proto"] : void 0;
    const protocol = forwardedProto || request.protocol || (request.socket?.encrypted ? "https" : "http");
    const url = request.url || "";
    const absoluteUrl = $b046bcc314859bc2$var$getAbsoluteUrl({
        url: url,
        host: host,
        protocol: protocol
    });
    const data = request.body || void 0;
    const cookies = request.cookies;
    return {
        url: absoluteUrl,
        method: request.method,
        query_string: $b046bcc314859bc2$var$extractQueryParamsFromUrl(url),
        headers: $b046bcc314859bc2$var$headersToDict(headers),
        cookies: cookies,
        data: data
    };
}
function $b046bcc314859bc2$var$getAbsoluteUrl({ url: url, protocol: protocol, host: host }) {
    if (url?.startsWith("http")) return url;
    if (url && host) return `${protocol}://${host}${url}`;
    return void 0;
}
function $b046bcc314859bc2$var$httpHeadersToSpanAttributes(headers, dataCollection = false, lifecycle = "request") {
    const resolvedDataCollection = typeof dataCollection === "boolean" ? $kxICp.defaultPiiToCollectionOptions(dataCollection) : dataCollection;
    const headerBehavior = lifecycle === "request" ? resolvedDataCollection.httpHeaders.request : resolvedDataCollection.httpHeaders.response;
    const cookieBehavior = resolvedDataCollection.cookies;
    const prefix = `http.${lifecycle}.header.`;
    const spanAttributes = {};
    try {
        const regularHeaders = {};
        for (const [key, value] of Object.entries(headers)){
            if (value == null) continue;
            const lowerKey = key.toLowerCase();
            const isCookieHeader = lowerKey === "cookie" || lowerKey === "set-cookie";
            if (isCookieHeader) {
                if (cookieBehavior === false) continue;
                if (typeof value === "string" && value !== "") {
                    const parsed = $b046bcc314859bc2$var$parseCookieHeader(value, lowerKey === "set-cookie");
                    const filtered = $HDJnZ.filterKeyValueData(parsed, cookieBehavior, $j1UWZ.SENSITIVE_COOKIE_NAME_SNIPPETS);
                    for (const [cookieKey, cookieValue] of Object.entries(filtered))spanAttributes[`${prefix}${$b046bcc314859bc2$var$normalizeAttributeKey(lowerKey)}.${$b046bcc314859bc2$var$normalizeAttributeKey(cookieKey)}`] = cookieValue;
                } else spanAttributes[`${prefix}${$b046bcc314859bc2$var$normalizeAttributeKey(lowerKey)}`] = $j1UWZ.FILTERED_VALUE;
            } else {
                if (headerBehavior === false) continue;
                if (Array.isArray(value)) regularHeaders[lowerKey] = value.map((v)=>v != null ? String(v) : v).join(";");
                else if (typeof value === "string") regularHeaders[lowerKey] = value;
            }
        }
        if (headerBehavior !== false) {
            const filtered = $HDJnZ.filterKeyValueData(regularHeaders, headerBehavior);
            for (const [headerKey, headerValue] of Object.entries(filtered))spanAttributes[`${prefix}${$b046bcc314859bc2$var$normalizeAttributeKey(headerKey)}`] = headerValue;
        }
    } catch  {}
    return spanAttributes;
}
function $b046bcc314859bc2$var$normalizeAttributeKey(key) {
    return key.replace(/-/g, "_");
}
function $b046bcc314859bc2$var$parseCookieHeader(value, isSetCookie) {
    const semicolonIndex = value.indexOf(";");
    const cookieString = isSetCookie && semicolonIndex !== -1 ? value.substring(0, semicolonIndex) : value;
    const cookies = isSetCookie ? [
        cookieString
    ] : cookieString.split("; ");
    const result = {};
    for (const cookie of cookies){
        const equalSignIndex = cookie.indexOf("=");
        const cookieKey = (equalSignIndex !== -1 ? cookie.substring(0, equalSignIndex) : cookie).toLowerCase();
        const cookieValue = equalSignIndex !== -1 ? cookie.substring(equalSignIndex + 1) : "";
        result[cookieKey] = cookieValue;
    }
    return result;
}
function $b046bcc314859bc2$var$extractQueryParamsFromUrl(url) {
    if (!url) return;
    try {
        const queryParams = new URL(url, "http://s.io").search.slice(1);
        return queryParams.length ? queryParams : void 0;
    } catch  {
        return void 0;
    }
}
module.exports.MAX_BODY_BYTE_LENGTH = $b046bcc314859bc2$var$MAX_BODY_BYTE_LENGTH;
module.exports.captureBodyFromWinterCGRequest = $b046bcc314859bc2$var$captureBodyFromWinterCGRequest;
module.exports.extractQueryParamsFromUrl = $b046bcc314859bc2$var$extractQueryParamsFromUrl;
module.exports.getMaxBodyByteLength = $b046bcc314859bc2$var$getMaxBodyByteLength;
module.exports.headersToDict = $b046bcc314859bc2$var$headersToDict;
module.exports.httpHeadersToSpanAttributes = $b046bcc314859bc2$var$httpHeadersToSpanAttributes;
module.exports.httpRequestToRequestData = $b046bcc314859bc2$var$httpRequestToRequestData;
module.exports.winterCGHeadersToDict = $b046bcc314859bc2$var$winterCGHeadersToDict;
module.exports.winterCGRequestToRequestData = $b046bcc314859bc2$var$winterCGRequestToRequestData;

});

parcelRegister("2hjz6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $1a8c58869f15873f$var$SPAN_KIND = {
    INTERNAL: 0,
    SERVER: 1,
    CLIENT: 2,
    PRODUCER: 3,
    CONSUMER: 4
};
const $1a8c58869f15873f$var$SPAN_KIND_NAME = {
    [$1a8c58869f15873f$var$SPAN_KIND.INTERNAL]: "INTERNAL",
    [$1a8c58869f15873f$var$SPAN_KIND.SERVER]: "SERVER",
    [$1a8c58869f15873f$var$SPAN_KIND.CLIENT]: "CLIENT",
    [$1a8c58869f15873f$var$SPAN_KIND.PRODUCER]: "PRODUCER",
    [$1a8c58869f15873f$var$SPAN_KIND.CONSUMER]: "CONSUMER"
};
function $1a8c58869f15873f$var$spanKindToName(kind) {
    return $1a8c58869f15873f$var$SPAN_KIND_NAME[kind];
}
module.exports.SPAN_KIND = $1a8c58869f15873f$var$SPAN_KIND;
module.exports.spanKindToName = $1a8c58869f15873f$var$spanKindToName;

});

parcelRegister("dwO73", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kfJmY = parcelRequire("kfJmY");

var $2sm2V = parcelRequire("2sm2V");

var $gU6V8 = parcelRequire("gU6V8");
const $9d9522de96003dbc$var$DEFAULT_BREADCRUMBS = 100;
function $9d9522de96003dbc$var$addBreadcrumb(breadcrumb, hint) {
    const client = $kfJmY.getClient();
    const isolationScope = $kfJmY.getIsolationScope();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $9d9522de96003dbc$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = $gU6V8.dateTimestampInSeconds();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? $2sm2V.consoleSandbox(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}
module.exports.addBreadcrumb = $9d9522de96003dbc$var$addBreadcrumb;

});

parcelRegister("9KkJX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kfJmY = parcelRequire("kfJmY");

var $5vlAD = parcelRequire("5vlAD");

var $65lWX = parcelRequire("65lWX");
const $71887f8496cb46e6$var$INTEGRATION_NAME = "FunctionToString";
const $71887f8496cb46e6$var$SETUP_CLIENTS = /* @__PURE__ */ new WeakMap();
const $71887f8496cb46e6$var$_functionToStringIntegration = ()=>{
    return {
        name: $71887f8496cb46e6$var$INTEGRATION_NAME,
        setupOnce () {
            const originalFunctionToString = Function.prototype.toString;
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = $65lWX.getOriginalFunction(this);
                    let unwrappedFunction;
                    try {
                        if ($71887f8496cb46e6$var$SETUP_CLIENTS.has($kfJmY.getClient()) && originalFunction !== void 0) unwrappedFunction = originalFunction;
                    } catch  {}
                    return originalFunctionToString.apply(unwrappedFunction ?? this, args);
                };
            } catch  {}
        },
        setup (client) {
            $71887f8496cb46e6$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
const $71887f8496cb46e6$var$functionToStringIntegration = $5vlAD.defineIntegration($71887f8496cb46e6$var$_functionToStringIntegration);
module.exports.functionToStringIntegration = $71887f8496cb46e6$var$functionToStringIntegration;

});

parcelRegister("1vY2x", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1GyI0 = parcelRequire("1GyI0");

var $5vlAD = parcelRequire("5vlAD");

var $2sm2V = parcelRequire("2sm2V");

var $1MOT2 = parcelRequire("1MOT2");

var $jR1Dv = parcelRequire("jR1Dv");

var $1L2sM = parcelRequire("1L2sM");
const $11a7425d5ca76525$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
    /^Cannot redefine property: googletag$/,
    // This is thrown when google tag manager is used in combination with an ad blocker
    /^Can't find variable: gmo$/,
    // Error from Google Search App https://issuetracker.google.com/issues/396043331
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    // Random error that happens but not actionable or noticeable to end-users.
    /can't redefine non-configurable property "solana"/,
    // Probably a browser extension or custom browser (Brave) throwing this error
    /vv\(\)\.getRestrictions is not a function/,
    // Error thrown by GTM, seemingly not affecting end-users
    /Can't find variable: _AutofillCallbackHandler/,
    // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
    /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
    // unactionable error from CEFSharp, a .NET library that embeds chromium in .NET apps
    /Java exception was raised during method invocation$/,
    // error from Facebook Mobile browser (https://github.com/getsentry/sentry-javascript/issues/15065, https://github.com/getsentry/sentry-javascript/issues/23733)
    /Java object is gone$/
];
const $11a7425d5ca76525$var$INTEGRATION_NAME = "EventFilters";
const $11a7425d5ca76525$var$eventFiltersIntegration = $5vlAD.defineIntegration((options = {})=>{
    let mergedOptions;
    return {
        name: $11a7425d5ca76525$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $11a7425d5ca76525$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $11a7425d5ca76525$var$_mergeOptions(options, clientOptions);
            }
            return $11a7425d5ca76525$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
const $11a7425d5ca76525$var$inboundFiltersIntegration = $5vlAD.defineIntegration((options = {})=>{
    return {
        ...$11a7425d5ca76525$var$eventFiltersIntegration(options),
        name: "InboundFilters"
    };
});
function $11a7425d5ca76525$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $11a7425d5ca76525$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $11a7425d5ca76525$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        if ($11a7425d5ca76525$var$_isIgnoredError(event, options.ignoreErrors)) {
            $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn(`Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${$jR1Dv.getEventDescription(event)}`);
            return true;
        }
        if ($11a7425d5ca76525$var$_isUselessError(event)) {
            $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn(`Event dropped due to not having an error message, error type or stacktrace.
Event: ${$jR1Dv.getEventDescription(event)}`);
            return true;
        }
        if ($11a7425d5ca76525$var$_isDeniedUrl(event, options.denyUrls)) {
            $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn(`Event dropped due to being matched by \`denyUrls\` option.
Event: ${$jR1Dv.getEventDescription(event)}.
Url: ${$11a7425d5ca76525$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$11a7425d5ca76525$var$_isAllowedUrl(event, options.allowUrls)) {
            $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn(`Event dropped due to not being matched by \`allowUrls\` option.
Event: ${$jR1Dv.getEventDescription(event)}.
Url: ${$11a7425d5ca76525$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === "transaction") {
        if ($11a7425d5ca76525$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn(`Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${$jR1Dv.getEventDescription(event)}`);
            return true;
        }
    }
    return false;
}
function $11a7425d5ca76525$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return $1MOT2.getPossibleEventMessages(event).some((message)=>$1L2sM.stringMatchesSomePattern(message, ignoreErrors));
}
function $11a7425d5ca76525$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? $1L2sM.stringMatchesSomePattern(name, ignoreTransactions) : false;
}
function $11a7425d5ca76525$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $11a7425d5ca76525$var$_getEventFilterUrl(event);
    return !url ? false : $1L2sM.stringMatchesSomePattern(url, denyUrls);
}
function $11a7425d5ca76525$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $11a7425d5ca76525$var$_getEventFilterUrl(event);
    return !url ? true : $1L2sM.stringMatchesSomePattern(url, allowUrls);
}
function $11a7425d5ca76525$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $11a7425d5ca76525$var$_getEventFilterUrl(event) {
    try {
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === void 0 && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $11a7425d5ca76525$var$_getLastValidUrl(frames) : null;
    } catch  {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.error(`Cannot extract url for event ${$jR1Dv.getEventDescription(event)}`);
        return null;
    }
}
function $11a7425d5ca76525$var$_isUselessError(event) {
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}
module.exports.eventFiltersIntegration = $11a7425d5ca76525$var$eventFiltersIntegration;
module.exports.inboundFiltersIntegration = $11a7425d5ca76525$var$inboundFiltersIntegration;

});

parcelRegister("iiHl2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5vlAD = parcelRequire("5vlAD");

var $5ydSt = parcelRequire("5ydSt");

var $1M0QG = parcelRequire("1M0QG");
const $d52b8684e2d8abe4$var$DEFAULT_KEY = "cause";
const $d52b8684e2d8abe4$var$DEFAULT_LIMIT = 5;
const $d52b8684e2d8abe4$var$INTEGRATION_NAME = "LinkedErrors";
const $d52b8684e2d8abe4$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $d52b8684e2d8abe4$var$DEFAULT_LIMIT;
    const key = options.key || $d52b8684e2d8abe4$var$DEFAULT_KEY;
    return {
        name: $d52b8684e2d8abe4$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options2 = client.getOptions();
            $5ydSt.applyAggregateErrorsToEvent($1M0QG.exceptionFromError, options2.stackParser, key, limit, event, hint);
        }
    };
};
const $d52b8684e2d8abe4$var$linkedErrorsIntegration = $5vlAD.defineIntegration($d52b8684e2d8abe4$var$_linkedErrorsIntegration);
module.exports.linkedErrorsIntegration = $d52b8684e2d8abe4$var$linkedErrorsIntegration;

});
parcelRegister("5ydSt", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jV7hg = parcelRequire("jV7hg");
function $40aae481c3a2c685$var$applyAggregateErrorsToEvent(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !$jV7hg.isError(hint.originalException)) return;
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : void 0;
    if (originalException) event.exception.values = $40aae481c3a2c685$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $40aae481c3a2c685$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    if ($jV7hg.isError(error[key])) {
        $40aae481c3a2c685$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $40aae481c3a2c685$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $40aae481c3a2c685$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    if ($40aae481c3a2c685$var$isExceptionGroup(error)) error.errors.forEach((childError, i)=>{
        if ($jV7hg.isError(childError)) {
            $40aae481c3a2c685$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $40aae481c3a2c685$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $40aae481c3a2c685$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $40aae481c3a2c685$var$isExceptionGroup(error) {
    return Array.isArray(error.errors);
}
function $40aae481c3a2c685$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error) {
    exception.mechanism = {
        handled: true,
        type: "auto.core.linked_errors",
        ...$40aae481c3a2c685$var$isExceptionGroup(error) && {
            is_exception_group: true
        },
        ...exception.mechanism,
        exception_id: exceptionId
    };
}
function $40aae481c3a2c685$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = {
        handled: true,
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
module.exports.applyAggregateErrorsToEvent = $40aae481c3a2c685$var$applyAggregateErrorsToEvent;

});

parcelRegister("1M0QG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jV7hg = parcelRequire("jV7hg");

var $jR1Dv = parcelRequire("jR1Dv");

var $2ZrfN = parcelRequire("2ZrfN");

var $65lWX = parcelRequire("65lWX");
function $14aaeeb3708501eb$var$parseStackFrames(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
function $14aaeeb3708501eb$var$hasSentryFetchUrlHost(error) {
    return $jV7hg.isError(error) && "__sentry_fetch_url_host__" in error && typeof error.__sentry_fetch_url_host__ === "string";
}
function $14aaeeb3708501eb$var$_enhanceErrorWithSentryInfo(error) {
    if ($14aaeeb3708501eb$var$hasSentryFetchUrlHost(error)) return `${error.message} (${error.__sentry_fetch_url_host__})`;
    return error.message;
}
function $14aaeeb3708501eb$var$exceptionFromError(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: $14aaeeb3708501eb$var$_enhanceErrorWithSentryInfo(error)
    };
    const frames = $14aaeeb3708501eb$var$parseStackFrames(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $14aaeeb3708501eb$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if ($jV7hg.isError(value)) return value;
    }
    return void 0;
}
function $14aaeeb3708501eb$var$getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    const keys = $65lWX.extractExceptionKeysForMessage(exception);
    if ($jV7hg.isErrorEvent(exception)) return `Event \`ErrorEvent\` captured as exception with message \`${exception.message}\``;
    const className = $14aaeeb3708501eb$var$getObjectClassName(exception);
    return `${className && className !== "Object" ? `'${className}'` : "Object"} captured as exception with keys: ${keys}`;
}
function $14aaeeb3708501eb$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch  {}
}
function $14aaeeb3708501eb$var$getException(client, mechanism, exception, hint) {
    if ($jV7hg.isError(exception)) return [
        exception,
        void 0
    ];
    mechanism.synthetic = true;
    if ($jV7hg.isPlainObject(exception)) {
        const normalizeDepth = client?.getOptions().normalizeDepth;
        const extras = {
            ["__serialized__"]: $2ZrfN.normalizeToSize(exception, normalizeDepth)
        };
        const errorFromProp = $14aaeeb3708501eb$var$getErrorPropertyFromObject(exception);
        if (errorFromProp) return [
            errorFromProp,
            extras
        ];
        const message = $14aaeeb3708501eb$var$getMessageForObject(exception);
        const ex2 = hint?.syntheticException || new Error(message);
        ex2.message = message;
        return [
            ex2,
            extras
        ];
    }
    const ex = hint?.syntheticException || new Error(exception);
    ex.message = `${exception}`;
    return [
        ex,
        void 0
    ];
}
function $14aaeeb3708501eb$var$eventFromUnknownInput(client, stackParser, exception, hint) {
    const providedMechanism = hint?.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    const [ex, extras] = $14aaeeb3708501eb$var$getException(client, mechanism, exception, hint);
    const event = {
        exception: {
            values: [
                $14aaeeb3708501eb$var$exceptionFromError(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    $jR1Dv.addExceptionTypeValue(event, void 0, void 0);
    $jR1Dv.addExceptionMechanism(event, mechanism);
    return {
        ...event,
        event_id: hint?.event_id
    };
}
function $14aaeeb3708501eb$var$eventFromMessage(stackParser, message, level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint?.event_id,
        level: level
    };
    if (attachStacktrace && hint?.syntheticException) {
        const frames = $14aaeeb3708501eb$var$parseStackFrames(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
            $jR1Dv.addExceptionMechanism(event, {
                synthetic: true
            });
        }
    }
    if ($jV7hg.isParameterizedString(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
module.exports._enhanceErrorWithSentryInfo = $14aaeeb3708501eb$var$_enhanceErrorWithSentryInfo;
module.exports.eventFromMessage = $14aaeeb3708501eb$var$eventFromMessage;
module.exports.eventFromUnknownInput = $14aaeeb3708501eb$var$eventFromUnknownInput;
module.exports.exceptionFromError = $14aaeeb3708501eb$var$exceptionFromError;
module.exports.parseStackFrames = $14aaeeb3708501eb$var$parseStackFrames;

});


parcelRegister("64Mtt", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5vlAD = parcelRequire("5vlAD");

var $8IXO6 = parcelRequire("8IXO6");

var $kAeXb = parcelRequire("kAeXb");
const $46c8b7d1653a88e3$var$moduleMetadataIntegration = $5vlAD.defineIntegration(()=>{
    return {
        name: "ModuleMetadata",
        setup (client) {
            client.on("beforeEnvelope", (envelope$1)=>{
                $kAeXb.forEachEnvelopeItem(envelope$1, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : void 0;
                        if (event) {
                            $8IXO6.stripMetadataFromStackFrames(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on("applyFrameMetadata", (event)=>{
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                $8IXO6.addMetadataToStackFrames(stackParser, event);
            });
        }
    };
});
module.exports.moduleMetadataIntegration = $46c8b7d1653a88e3$var$moduleMetadataIntegration;

});
parcelRegister("8IXO6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fxVZv = parcelRequire("fxVZv");
const $65a0d3380e39716f$var$filenameMetadataMap = /* @__PURE__ */ new Map();
const $65a0d3380e39716f$var$parsedStacks = /* @__PURE__ */ new Set();
function $65a0d3380e39716f$var$getFilenameToMetadataMap(parser) {
    if (!$fxVZv.GLOBAL_OBJ._sentryModuleMetadata) return {};
    const filenameMap = {};
    for (const stack of Object.keys($fxVZv.GLOBAL_OBJ._sentryModuleMetadata)){
        const metadata = $fxVZv.GLOBAL_OBJ._sentryModuleMetadata[stack];
        const frames = parser(stack);
        for (const frame of frames.reverse())if (frame.filename) {
            filenameMap[frame.filename] = metadata;
            break;
        }
    }
    return filenameMap;
}
function $65a0d3380e39716f$var$ensureMetadataStacksAreParsed(parser) {
    if (!$fxVZv.GLOBAL_OBJ._sentryModuleMetadata) return;
    for (const stack of Object.keys($fxVZv.GLOBAL_OBJ._sentryModuleMetadata)){
        const metadata = $fxVZv.GLOBAL_OBJ._sentryModuleMetadata[stack];
        if ($65a0d3380e39716f$var$parsedStacks.has(stack)) continue;
        $65a0d3380e39716f$var$parsedStacks.add(stack);
        const frames = parser(stack);
        for (const frame of frames.reverse())if (frame.filename) {
            $65a0d3380e39716f$var$filenameMetadataMap.set(frame.filename, metadata);
            break;
        }
    }
}
function $65a0d3380e39716f$var$getMetadataForUrl(parser, filename) {
    $65a0d3380e39716f$var$ensureMetadataStacksAreParsed(parser);
    return $65a0d3380e39716f$var$filenameMetadataMap.get(filename);
}
function $65a0d3380e39716f$var$addMetadataToStackFrames(parser, event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (!frame.filename || frame.module_metadata) return;
            const metadata = $65a0d3380e39716f$var$getMetadataForUrl(parser, frame.filename);
            if (metadata) frame.module_metadata = metadata;
        });
    });
}
function $65a0d3380e39716f$var$stripMetadataFromStackFrames(event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            delete frame.module_metadata;
        });
    });
}
module.exports.addMetadataToStackFrames = $65a0d3380e39716f$var$addMetadataToStackFrames;
module.exports.getFilenameToMetadataMap = $65a0d3380e39716f$var$getFilenameToMetadataMap;
module.exports.getMetadataForUrl = $65a0d3380e39716f$var$getMetadataForUrl;
module.exports.stripMetadataFromStackFrames = $65a0d3380e39716f$var$stripMetadataFromStackFrames;

});


parcelRegister("6R0PE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kfJmY = parcelRequire("kfJmY");

var $5vlAD = parcelRequire("5vlAD");

var $2JysJ = parcelRequire("2JysJ");

var $jUOx9 = parcelRequire("jUOx9");

var $f8jvI = parcelRequire("f8jvI");

var $gH4ZB = parcelRequire("gH4ZB");

var $2ZTbI = parcelRequire("2ZTbI");

var $3tmPs = parcelRequire("3tmPs");
const $4fd85689a16485be$var$INTEGRATION_NAME = "RequestData";
const $4fd85689a16485be$var$_requestDataIntegration = (options = {})=>{
    function resolveIncludeAndDataCollection(client) {
        const dc = client.getDataCollectionOptions();
        const dataCollection = {
            ...dc,
            ...options.include?.cookies === true && dc.cookies === false && {
                cookies: true
            },
            ...options.include?.headers === true && dc.httpHeaders.request === false && {
                httpHeaders: {
                    ...dc.httpHeaders,
                    request: true
                }
            }
        };
        return {
            dataCollection: dataCollection,
            include: {
                cookies: dataCollection.cookies !== false,
                // Always attach body data that's already on the scope — dataCollection.httpBodies gates write-time, not read-time
                data: true,
                headers: dataCollection.httpHeaders.request !== false,
                ip: dataCollection.userInfo,
                query_string: dataCollection.urlQueryParams !== false,
                // No dataCollection equivalent — URL is always included
                url: true,
                ...options.include
            }
        };
    }
    return {
        name: $4fd85689a16485be$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const { sdkProcessingMetadata: sdkProcessingMetadata = {} } = event;
            const { normalizedRequest: normalizedRequest, ipAddress: ipAddress } = sdkProcessingMetadata;
            const { include: include } = resolveIncludeAndDataCollection(client);
            if (normalizedRequest) $4fd85689a16485be$var$addNormalizedRequestDataToEvent(event, normalizedRequest, {
                ipAddress: ipAddress
            }, include);
            return event;
        },
        processSegmentSpan (span, client) {
            const { sdkProcessingMetadata: sdkProcessingMetadata = {} } = $kfJmY.getIsolationScope().getScopeData();
            const { normalizedRequest: normalizedRequest, ipAddress: ipAddress } = sdkProcessingMetadata;
            if (!normalizedRequest) return;
            const { include: include, dataCollection: dataCollection } = resolveIncludeAndDataCollection(client);
            $4fd85689a16485be$var$addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, include, dataCollection);
        }
    };
};
const $4fd85689a16485be$var$requestDataIntegration = $5vlAD.defineIntegration($4fd85689a16485be$var$_requestDataIntegration);
function $4fd85689a16485be$var$addNormalizedRequestDataToEvent(event, req, additionalData, include) {
    event.request = {
        ...event.request,
        ...$4fd85689a16485be$var$extractNormalizedRequestData(req, include)
    };
    if (include.ip) {
        const ip = req.headers && $gH4ZB.getClientIPAddress(req.headers) || additionalData.ipAddress;
        if (ip) event.user = {
            ...event.user,
            ip_address: ip
        };
    }
}
function $4fd85689a16485be$var$addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, include, dataCollection) {
    const requestData = $4fd85689a16485be$var$extractNormalizedRequestData(normalizedRequest, include);
    const attributes$1 = {};
    if (requestData.url) attributes$1[$3tmPs.URL_FULL] = requestData.url;
    if (requestData.method) attributes$1["http.request.method"] = requestData.method;
    if (requestData.query_string) attributes$1[$3tmPs.URL_QUERY] = $4fd85689a16485be$var$normalizeQueryString(requestData.query_string);
    $2ZTbI.safeSetSpanJSONAttributes(span, attributes$1);
    if (requestData.cookies && Object.keys(requestData.cookies).length > 0) {
        const cookieString = Object.entries(requestData.cookies).map(([name, value])=>`${name}=${value}`).join("; ");
        const cookieAttributes = $f8jvI.httpHeadersToSpanAttributes({
            cookie: cookieString
        }, dataCollection, "request");
        $2ZTbI.safeSetSpanJSONAttributes(span, cookieAttributes);
    }
    if (requestData.headers) {
        const headerAttributes = $f8jvI.httpHeadersToSpanAttributes(requestData.headers, dataCollection, "request");
        $2ZTbI.safeSetSpanJSONAttributes(span, headerAttributes);
    }
    if (requestData.data != null) {
        const serialized = typeof requestData.data === "string" ? requestData.data : JSON.stringify(requestData.data);
        if (serialized) $2ZTbI.safeSetSpanJSONAttributes(span, {
            "http.request.body.data": serialized
        });
    }
    if (include.ip) {
        const ip = normalizedRequest.headers && $gH4ZB.getClientIPAddress(normalizedRequest.headers) || ipAddress || void 0;
        if (ip) $2ZTbI.safeSetSpanJSONAttributes(span, {
            [$2JysJ.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: ip
        });
    }
}
function $4fd85689a16485be$var$extractNormalizedRequestData(normalizedRequest, include) {
    const requestData = {};
    const headers = {
        ...normalizedRequest.headers
    };
    if (include.headers) {
        requestData.headers = headers;
        if (!include.cookies) delete headers.cookie;
        if (!include.ip) {
            const ipHeaderNamesLower = new Set($gH4ZB.ipHeaderNames.map((name)=>name.toLowerCase()));
            for (const key of Object.keys(headers))if (ipHeaderNamesLower.has(key.toLowerCase())) delete headers[key];
        }
    }
    requestData.method = normalizedRequest.method;
    if (include.url) requestData.url = normalizedRequest.url;
    if (include.cookies) {
        const cookies = normalizedRequest.cookies || (headers?.cookie ? $jUOx9.parseCookie(headers.cookie) : void 0);
        requestData.cookies = cookies || {};
    }
    if (include.query_string) requestData.query_string = normalizedRequest.query_string;
    if (include.data) requestData.data = normalizedRequest.data;
    return requestData;
}
function $4fd85689a16485be$var$normalizeQueryString(queryString) {
    if (typeof queryString === "string") return queryString || void 0;
    const pairs = Array.isArray(queryString) ? queryString : Object.entries(queryString);
    const result = pairs.map(([key, value])=>`${key}=${value}`).join("&");
    return result || void 0;
}
module.exports.requestDataIntegration = $4fd85689a16485be$var$requestDataIntegration;

});
parcelRegister("gH4ZB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $c27488ecffc36178$var$ipHeaderNames = [
    "X-Client-IP",
    "X-Forwarded-For",
    "Fly-Client-IP",
    "CF-Connecting-IP",
    "Fastly-Client-Ip",
    "True-Client-Ip",
    "X-Real-IP",
    "X-Cluster-Client-IP",
    "X-Forwarded",
    "Forwarded-For",
    "Forwarded",
    "X-Vercel-Forwarded-For"
];
function $c27488ecffc36178$var$getClientIPAddress(headers) {
    const lowerCaseHeaders = {};
    for (const key of Object.keys(headers))lowerCaseHeaders[key.toLowerCase()] = headers[key];
    const headerValues = $c27488ecffc36178$var$ipHeaderNames.map((headerName)=>{
        const rawValue = lowerCaseHeaders[headerName.toLowerCase()];
        const value = Array.isArray(rawValue) ? rawValue.join(";") : rawValue;
        if (headerName === "Forwarded") return $c27488ecffc36178$var$parseForwardedHeader(value);
        return value?.split(",").map((v)=>v.trim());
    });
    const flattenedHeaderValues = headerValues.reduce((acc, val)=>{
        if (!val) return acc;
        return acc.concat(val);
    }, []);
    const ipAddress = flattenedHeaderValues.find((ip)=>ip !== null && $c27488ecffc36178$var$isIP(ip));
    return ipAddress || null;
}
function $c27488ecffc36178$var$parseForwardedHeader(value) {
    if (!value) return null;
    for (const part of value.split(";")){
        if (part.startsWith("for=")) return part.slice(4);
    }
    return null;
}
function $c27488ecffc36178$var$isIP(str) {
    const regex = /(?:^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$)|(?:^(?:(?:[a-fA-F\d]{1,4}:){7}(?:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,2}|:)|(?:[a-fA-F\d]{1,4}:){4}(?:(?::[a-fA-F\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,3}|:)|(?:[a-fA-F\d]{1,4}:){3}(?:(?::[a-fA-F\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,4}|:)|(?:[a-fA-F\d]{1,4}:){2}(?:(?::[a-fA-F\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,5}|:)|(?:[a-fA-F\d]{1,4}:){1}(?:(?::[a-fA-F\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,6}|:)|(?::(?:(?::[a-fA-F\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,7}|:)))(?:%[0-9a-zA-Z]{1,})?$)/;
    return regex.test(str);
}
module.exports.getClientIPAddress = $c27488ecffc36178$var$getClientIPAddress;
module.exports.ipHeaderNames = $c27488ecffc36178$var$ipHeaderNames;

});


parcelRegister("jfxi0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kfJmY = parcelRequire("kfJmY");

var $aK1wS = parcelRequire("aK1wS");

var $9Fabw = parcelRequire("9Fabw");

var $5vlAD = parcelRequire("5vlAD");

var $2sm2V = parcelRequire("2sm2V");

var $jR1Dv = parcelRequire("jR1Dv");

var $iGwGT = parcelRequire("iGwGT");

var $1L2sM = parcelRequire("1L2sM");

var $fxVZv = parcelRequire("fxVZv");
const $e0393d9ac5e42131$var$INTEGRATION_NAME = "CaptureConsole";
const $e0393d9ac5e42131$var$_captureConsoleIntegration = (options = {})=>{
    const levels = options.levels || $2sm2V.CONSOLE_LEVELS;
    const handled = options.handled ?? true;
    return {
        name: $e0393d9ac5e42131$var$INTEGRATION_NAME,
        setup (client) {
            if (!("console" in $fxVZv.GLOBAL_OBJ)) return;
            $9Fabw.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($kfJmY.getClient() !== client || !levels.includes(level)) return;
                $e0393d9ac5e42131$var$consoleHandler(args, level, handled);
            });
        }
    };
};
const $e0393d9ac5e42131$var$captureConsoleIntegration = $5vlAD.defineIntegration($e0393d9ac5e42131$var$_captureConsoleIntegration);
function $e0393d9ac5e42131$var$consoleHandler(args, level, handled) {
    const severityLevel = $iGwGT.severityLevelFromString(level);
    const syntheticException = new Error();
    const captureContext = {
        level: $iGwGT.severityLevelFromString(level),
        extra: {
            arguments: args
        }
    };
    $kfJmY.withScope((scope)=>{
        scope.addEventProcessor((event)=>{
            event.logger = "console";
            $jR1Dv.addExceptionMechanism(event, {
                handled: handled,
                type: "auto.core.capture_console"
            });
            return event;
        });
        if (level === "assert") {
            if (!args[0]) {
                const message2 = `Assertion failed: ${$1L2sM.safeJoin(args.slice(1), " ") || "console.assert"}`;
                scope.setExtra("arguments", args.slice(1));
                scope.captureMessage(message2, severityLevel, {
                    captureContext: captureContext,
                    syntheticException: syntheticException
                });
            }
            return;
        }
        const error = args.find((arg)=>arg instanceof Error);
        if (error) {
            $aK1wS.captureException(error, captureContext);
            return;
        }
        const message = $1L2sM.safeJoin(args, " ");
        scope.captureMessage(message, severityLevel, {
            captureContext: captureContext,
            syntheticException: syntheticException
        });
    });
}
module.exports.captureConsoleIntegration = $e0393d9ac5e42131$var$captureConsoleIntegration;

});
parcelRegister("9Fabw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1GyI0 = parcelRequire("1GyI0");

var $2sm2V = parcelRequire("2sm2V");

var $65lWX = parcelRequire("65lWX");

var $1L2sM = parcelRequire("1L2sM");

var $fxVZv = parcelRequire("fxVZv");

var $2t0Z7 = parcelRequire("2t0Z7");
const $708fd7e26bb1f4e0$var$_filter = /* @__PURE__ */ new Set([]);
function $708fd7e26bb1f4e0$var$addConsoleInstrumentationHandler(handler) {
    const type = "console";
    const removeHandler = $2t0Z7.addHandler(type, handler);
    $2t0Z7.maybeInstrument(type, $708fd7e26bb1f4e0$var$instrumentConsole);
    return removeHandler;
}
function $708fd7e26bb1f4e0$var$addConsoleInstrumentationFilter(filter) {
    for (const f of filter)$708fd7e26bb1f4e0$var$_filter.add(f);
    return ()=>{
        for (const f of filter)$708fd7e26bb1f4e0$var$_filter.delete(f);
    };
}
const $708fd7e26bb1f4e0$var$instrumentedLevels = /* @__PURE__ */ new Set();
function $708fd7e26bb1f4e0$var$instrumentConsole() {
    if (!("console" in $fxVZv.GLOBAL_OBJ)) return;
    $2sm2V.CONSOLE_LEVELS.forEach(function(level) {
        if ($708fd7e26bb1f4e0$var$instrumentedLevels.has(level) || !(level in $fxVZv.GLOBAL_OBJ.console)) return;
        $708fd7e26bb1f4e0$var$instrumentedLevels.add(level);
        $65lWX.fill($fxVZv.GLOBAL_OBJ.console, level, function(originalConsoleMethod) {
            $2sm2V.originalConsoleMethods[level] = originalConsoleMethod;
            return function(...args) {
                const firstArg = args[0];
                const log = $2sm2V.originalConsoleMethods[level];
                const isFiltered = $708fd7e26bb1f4e0$var$_filter.size && typeof firstArg === "string" && $1L2sM.stringMatchesSomePattern(firstArg, $708fd7e26bb1f4e0$var$_filter);
                if (!isFiltered) $2t0Z7.triggerHandlers("console", {
                    args: args,
                    level: level
                });
                if (!isFiltered || $1GyI0.DEBUG_BUILD && $2sm2V.debug.isEnabled()) log?.apply($fxVZv.GLOBAL_OBJ.console, args);
            };
        });
    });
}
module.exports.addConsoleInstrumentationFilter = $708fd7e26bb1f4e0$var$addConsoleInstrumentationFilter;
module.exports.addConsoleInstrumentationHandler = $708fd7e26bb1f4e0$var$addConsoleInstrumentationHandler;
module.exports.instrumentConsole = $708fd7e26bb1f4e0$var$instrumentConsole;

});

parcelRegister("iGwGT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $d9a581ef32c7195a$var$severityLevelFromString(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}
module.exports.severityLevelFromString = $d9a581ef32c7195a$var$severityLevelFromString;

});


parcelRegister("eeKAh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1GyI0 = parcelRequire("1GyI0");

var $5vlAD = parcelRequire("5vlAD");

var $2sm2V = parcelRequire("2sm2V");

var $fIlsR = parcelRequire("fIlsR");
const $a5d682203fce2b75$var$INTEGRATION_NAME = "Dedupe";
const $a5d682203fce2b75$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $a5d682203fce2b75$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            if (currentEvent.type) return currentEvent;
            try {
                if ($a5d682203fce2b75$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch  {}
            return previousEvent = currentEvent;
        }
    };
};
const $a5d682203fce2b75$var$dedupeIntegration = $5vlAD.defineIntegration($a5d682203fce2b75$var$_dedupeIntegration);
function $a5d682203fce2b75$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($a5d682203fce2b75$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($a5d682203fce2b75$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $a5d682203fce2b75$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    if (!currentMessage && !previousMessage) return false;
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$a5d682203fce2b75$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$a5d682203fce2b75$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $a5d682203fce2b75$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $a5d682203fce2b75$var$_getExceptionFromEvent(previousEvent);
    const currentException = $a5d682203fce2b75$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$a5d682203fce2b75$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$a5d682203fce2b75$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $a5d682203fce2b75$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $fIlsR.getFramesFromEvent(currentEvent);
    let previousFrames = $fIlsR.getFramesFromEvent(previousEvent);
    if (!currentFrames && !previousFrames) return true;
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    if (previousFrames.length !== currentFrames.length) return false;
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $a5d682203fce2b75$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    if (!currentFingerprint && !previousFingerprint) return true;
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch  {
        return false;
    }
}
function $a5d682203fce2b75$var$_getExceptionFromEvent(event) {
    return event.exception?.values?.[0];
}
module.exports._shouldDropEvent = $a5d682203fce2b75$var$_shouldDropEvent;
module.exports.dedupeIntegration = $a5d682203fce2b75$var$dedupeIntegration;

});

parcelRegister("h8PJh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1GyI0 = parcelRequire("1GyI0");

var $5vlAD = parcelRequire("5vlAD");

var $2sm2V = parcelRequire("2sm2V");

var $jV7hg = parcelRequire("jV7hg");

var $2ZrfN = parcelRequire("2ZrfN");

var $kCHEV = parcelRequire("kCHEV");

var $1L2sM = parcelRequire("1L2sM");
const $c7ab4f5fef188021$var$INTEGRATION_NAME = "ExtraErrorData";
const $c7ab4f5fef188021$var$_extraErrorDataIntegration = (options = {})=>{
    const { depth: depth = 3, captureErrorCause: captureErrorCause = true } = options;
    return {
        name: $c7ab4f5fef188021$var$INTEGRATION_NAME,
        processEvent (event, hint, client) {
            const { maxValueLength: maxValueLength } = client.getOptions();
            return $c7ab4f5fef188021$var$_enhanceEventWithErrorData(event, hint, depth, captureErrorCause, maxValueLength);
        }
    };
};
const $c7ab4f5fef188021$var$extraErrorDataIntegration = $5vlAD.defineIntegration($c7ab4f5fef188021$var$_extraErrorDataIntegration);
function $c7ab4f5fef188021$var$_enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause, maxValueLength) {
    if (!hint.originalException || !$jV7hg.isError(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = $c7ab4f5fef188021$var$_extractErrorData(hint.originalException, captureErrorCause, maxValueLength);
    if (errorData) {
        const contexts = {
            ...event.contexts
        };
        const normalizedErrorData = $2ZrfN.normalize(errorData, depth);
        if ($jV7hg.isPlainObject(normalizedErrorData)) {
            $kCHEV.setSkipNormalizationHint(normalizedErrorData);
            contexts[exceptionName] = normalizedErrorData;
        }
        return {
            ...event,
            contexts: contexts
        };
    }
    return event;
}
function $c7ab4f5fef188021$var$_extractErrorData(error, captureErrorCause, maxValueLength) {
    try {
        const nativeKeys = [
            "name",
            "message",
            "stack",
            "line",
            "column",
            "fileName",
            "lineNumber",
            "columnNumber",
            "toJSON"
        ];
        const extraErrorInfo = {};
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = $jV7hg.isError(value) || typeof value === "string" ? maxValueLength ? $1L2sM.truncate(`${value}`, maxValueLength) : `${value}` : value;
        }
        if (captureErrorCause && error.cause !== void 0) {
            if ($jV7hg.isError(error.cause)) {
                const errorName = error.cause.name || error.cause.constructor.name;
                extraErrorInfo.cause = {
                    [errorName]: $c7ab4f5fef188021$var$_extractErrorData(error.cause, false, maxValueLength)
                };
            } else extraErrorInfo.cause = error.cause;
        }
        if (typeof error.toJSON === "function") {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = $jV7hg.isError(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.error("Unable to extract extra data from the Error object:", oO);
    }
    return null;
}
module.exports.extraErrorDataIntegration = $c7ab4f5fef188021$var$extraErrorDataIntegration;

});

parcelRegister("9VAI8", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5vlAD = parcelRequire("5vlAD");

var $lAn2C = parcelRequire("lAn2C");

var $fxVZv = parcelRequire("fxVZv");
const $73a5e9f21440f811$var$INTEGRATION_NAME = "RewriteFrames";
const $73a5e9f21440f811$var$rewriteFramesIntegration = $5vlAD.defineIntegration((options = {})=>{
    const root = options.root;
    const prefix = options.prefix || "app:///";
    const isBrowser = "window" in $fxVZv.GLOBAL_OBJ && !!$fxVZv.GLOBAL_OBJ.window;
    const iteratee = options.iteratee || $73a5e9f21440f811$var$generateIteratee({
        isBrowser: isBrowser,
        root: root,
        prefix: prefix
    });
    function _processExceptionsEvent(event) {
        try {
            return {
                ...event,
                exception: {
                    ...event.exception,
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map((value)=>({
                            ...value,
                            ...value.stacktrace && {
                                stacktrace: _processStacktrace(value.stacktrace)
                            }
                        }))
                }
            };
        } catch  {
            return event;
        }
    }
    function _processStacktrace(stacktrace) {
        return {
            ...stacktrace,
            frames: stacktrace?.frames?.map((f)=>iteratee(f))
        };
    }
    return {
        name: $73a5e9f21440f811$var$INTEGRATION_NAME,
        processEvent (originalEvent) {
            let processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = _processExceptionsEvent(processedEvent);
            return processedEvent;
        }
    };
});
function $73a5e9f21440f811$var$generateIteratee({ isBrowser: isBrowser, root: root, prefix: prefix }) {
    return (frame)=>{
        if (!frame.filename) return frame;
        const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes("\\") && !frame.filename.includes("/");
        const startsWithSlash = /^\//.test(frame.filename);
        if (isBrowser) {
            if (root) {
                const oldFilename = frame.filename;
                if (oldFilename.indexOf(root) === 0) frame.filename = oldFilename.replace(root, prefix);
            }
        } else if (isWindowsFrame || startsWithSlash) {
            const filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, "").replace(/\\/g, "/") : frame.filename;
            const base = root ? $lAn2C.relative(root, filename) : $lAn2C.basename(filename);
            frame.filename = `${prefix}${base}`;
        }
        return frame;
    };
}
module.exports.generateIteratee = $73a5e9f21440f811$var$generateIteratee;
module.exports.rewriteFramesIntegration = $73a5e9f21440f811$var$rewriteFramesIntegration;

});
parcelRegister("lAn2C", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $fb6ed540f67f7bf7$var$normalizeArray(parts, allowAboveRoot) {
    let up = 0;
    for(let i = parts.length - 1; i >= 0; i--){
        const last = parts[i];
        if (last === ".") parts.splice(i, 1);
        else if (last === "..") {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    if (allowAboveRoot) for(; up--; up)parts.unshift("..");
    return parts;
}
const $fb6ed540f67f7bf7$var$splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
function $fb6ed540f67f7bf7$var$splitPath(filename) {
    const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
    const parts = $fb6ed540f67f7bf7$var$splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
function $fb6ed540f67f7bf7$var$resolve(...args) {
    let resolvedPath = "";
    let resolvedAbsolute = false;
    for(let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        const path = i >= 0 ? args[i] : "/";
        if (!path) continue;
        resolvedPath = `${path}/${resolvedPath}`;
        resolvedAbsolute = path.charAt(0) === "/";
    }
    resolvedPath = $fb6ed540f67f7bf7$var$normalizeArray(resolvedPath.split("/").filter((p)=>!!p), !resolvedAbsolute).join("/");
    return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
}
function $fb6ed540f67f7bf7$var$trim(arr) {
    let start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== "") break;
    }
    let end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== "") break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
function $fb6ed540f67f7bf7$var$relative(from, to) {
    from = $fb6ed540f67f7bf7$var$resolve(from).slice(1);
    to = $fb6ed540f67f7bf7$var$resolve(to).slice(1);
    const fromParts = $fb6ed540f67f7bf7$var$trim(from.split("/"));
    const toParts = $fb6ed540f67f7bf7$var$trim(to.split("/"));
    const length = Math.min(fromParts.length, toParts.length);
    let samePartsLength = length;
    for(let i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    let outputParts = [];
    for(let i = samePartsLength; i < fromParts.length; i++)outputParts.push("..");
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join("/");
}
function $fb6ed540f67f7bf7$var$normalizePath(path) {
    const isPathAbsolute = $fb6ed540f67f7bf7$var$isAbsolute(path);
    const trailingSlash = path.slice(-1) === "/";
    let normalizedPath = $fb6ed540f67f7bf7$var$normalizeArray(path.split("/").filter((p)=>!!p), !isPathAbsolute).join("/");
    if (!normalizedPath && !isPathAbsolute) normalizedPath = ".";
    if (normalizedPath && trailingSlash) normalizedPath += "/";
    return (isPathAbsolute ? "/" : "") + normalizedPath;
}
function $fb6ed540f67f7bf7$var$isAbsolute(path) {
    return path.charAt(0) === "/";
}
function $fb6ed540f67f7bf7$var$join(...args) {
    return $fb6ed540f67f7bf7$var$normalizePath(args.join("/"));
}
function $fb6ed540f67f7bf7$var$dirname(path) {
    const result = $fb6ed540f67f7bf7$var$splitPath(path);
    const root = result[0] || "";
    let dir = result[1];
    if (!root && !dir) return ".";
    if (dir) dir = dir.slice(0, dir.length - 1);
    return root + dir;
}
function $fb6ed540f67f7bf7$var$basename(path, ext) {
    let f = $fb6ed540f67f7bf7$var$splitPath(path)[2] || "";
    if (ext && f.slice(ext.length * -1) === ext) f = f.slice(0, f.length - ext.length);
    return f;
}
module.exports.basename = $fb6ed540f67f7bf7$var$basename;
module.exports.dirname = $fb6ed540f67f7bf7$var$dirname;
module.exports.isAbsolute = $fb6ed540f67f7bf7$var$isAbsolute;
module.exports.join = $fb6ed540f67f7bf7$var$join;
module.exports.normalizePath = $fb6ed540f67f7bf7$var$normalizePath;
module.exports.relative = $fb6ed540f67f7bf7$var$relative;
module.exports.resolve = $fb6ed540f67f7bf7$var$resolve;

});


parcelRegister("frZkF", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dwO73 = parcelRequire("dwO73");

var $kfJmY = parcelRequire("kfJmY");

var $1GyI0 = parcelRequire("1GyI0");

var $aK1wS = parcelRequire("aK1wS");

var $5vlAD = parcelRequire("5vlAD");

var $2JysJ = parcelRequire("2JysJ");

var $2sm2V = parcelRequire("2sm2V");

var $jR1Dv = parcelRequire("jR1Dv");

var $jV7hg = parcelRequire("jV7hg");

var $d33W7 = parcelRequire("d33W7");

var $aewmo = parcelRequire("aewmo");
const $b3f8f3f59d6c1203$var$AUTH_OPERATIONS_TO_INSTRUMENT = [
    "reauthenticate",
    "signInAnonymously",
    "signInWithOAuth",
    "signInWithIdToken",
    "signInWithOtp",
    "signInWithPassword",
    "signInWithSSO",
    "signOut",
    "signUp",
    "verifyOtp"
];
const $b3f8f3f59d6c1203$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT = [
    "createUser",
    "deleteUser",
    "listUsers",
    "getUserById",
    "updateUserById",
    "inviteUserByEmail"
];
const $b3f8f3f59d6c1203$var$FILTER_MAPPINGS = {
    eq: "eq",
    neq: "neq",
    gt: "gt",
    gte: "gte",
    lt: "lt",
    lte: "lte",
    like: "like",
    "like(all)": "likeAllOf",
    "like(any)": "likeAnyOf",
    ilike: "ilike",
    "ilike(all)": "ilikeAllOf",
    "ilike(any)": "ilikeAnyOf",
    is: "is",
    in: "in",
    cs: "contains",
    cd: "containedBy",
    sr: "rangeGt",
    nxl: "rangeGte",
    sl: "rangeLt",
    nxr: "rangeLte",
    adj: "rangeAdjacent",
    ov: "overlaps",
    fts: "",
    plfts: "plain",
    phfts: "phrase",
    wfts: "websearch",
    not: "not"
};
const $b3f8f3f59d6c1203$var$DB_OPERATIONS_TO_INSTRUMENT = [
    "select",
    "insert",
    "upsert",
    "update",
    "delete"
];
function $b3f8f3f59d6c1203$var$markAsInstrumented(fn) {
    try {
        fn.__SENTRY_INSTRUMENTED__ = true;
    } catch  {}
}
function $b3f8f3f59d6c1203$var$isInstrumented(fn) {
    try {
        return fn.__SENTRY_INSTRUMENTED__;
    } catch  {
        return false;
    }
}
function $b3f8f3f59d6c1203$var$getMutationBodyPayloadForTelemetry(rawBody, plainBody) {
    if (Object.keys(plainBody).length > 0) return plainBody;
    if (Array.isArray(rawBody) && rawBody.length > 0) return rawBody;
    return void 0;
}
function $b3f8f3f59d6c1203$var$hasMutationBodyForDescription(rawBody, plainBody) {
    return $b3f8f3f59d6c1203$var$getMutationBodyPayloadForTelemetry(rawBody, plainBody) !== void 0;
}
function $b3f8f3f59d6c1203$var$getHeader(headers, name) {
    if (!headers) return void 0;
    if (typeof headers.get === "function") return headers.get(name) ?? void 0;
    const plainHeaders = headers;
    const lowerCaseName = name.toLowerCase();
    const key = Object.keys(plainHeaders).find((headerName)=>headerName.toLowerCase() === lowerCaseName);
    return key !== void 0 ? plainHeaders[key] : void 0;
}
function $b3f8f3f59d6c1203$var$extractOperation(method, headers = {}) {
    switch(method){
        case "GET":
            return "select";
        case "POST":
            if ($b3f8f3f59d6c1203$var$getHeader(headers, "Prefer")?.includes("resolution=")) return "upsert";
            else return "insert";
        case "PATCH":
            return "update";
        case "DELETE":
            return "delete";
        default:
            return "<unknown-op>";
    }
}
function $b3f8f3f59d6c1203$var$translateFiltersIntoMethods(key, query) {
    if (query === "" || query === "*") return "select(*)";
    if (key === "select") return `select(${query})`;
    if (key === "or" || key.endsWith(".or")) return `${key}${query}`;
    const [filter, ...value] = query.split(".");
    let method;
    if (filter?.startsWith("fts")) method = "textSearch";
    else if (filter?.startsWith("plfts")) method = "textSearch[plain]";
    else if (filter?.startsWith("phfts")) method = "textSearch[phrase]";
    else if (filter?.startsWith("wfts")) method = "textSearch[websearch]";
    else method = filter && $b3f8f3f59d6c1203$var$FILTER_MAPPINGS[filter] || "filter";
    return `${method}(${key}, ${value.join(".")})`;
}
function $b3f8f3f59d6c1203$var$instrumentAuthOperation(operation, isAdmin = false) {
    return new Proxy(operation, {
        apply (target, thisArg, argumentsList) {
            return $aewmo.startSpan({
                name: `auth ${isAdmin ? "(admin) " : ""}${operation.name}`,
                attributes: {
                    [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.db.supabase",
                    [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "db",
                    "db.system": "postgresql",
                    "db.operation": `auth.${isAdmin ? "admin." : ""}${operation.name}`
                }
            }, (span)=>{
                return Reflect.apply(target, thisArg, argumentsList).then((res)=>{
                    if ($jV7hg.isObjectLike(res) && "error" in res && res.error) {
                        span.setStatus({
                            code: $d33W7.SPAN_STATUS_ERROR
                        });
                        $aK1wS.captureException(res.error, {
                            mechanism: {
                                handled: false,
                                type: "auto.db.supabase.auth"
                            }
                        });
                    } else span.setStatus({
                        code: $d33W7.SPAN_STATUS_OK
                    });
                    span.end();
                    return res;
                }).catch((err)=>{
                    span.setStatus({
                        code: $d33W7.SPAN_STATUS_ERROR
                    });
                    span.end();
                    $aK1wS.captureException(err, {
                        mechanism: {
                            handled: false,
                            type: "auto.db.supabase.auth"
                        }
                    });
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
}
function $b3f8f3f59d6c1203$var$instrumentSupabaseAuthClient(supabaseClientInstance) {
    const auth = supabaseClientInstance.auth;
    if (!auth || $b3f8f3f59d6c1203$var$isInstrumented(supabaseClientInstance.auth)) return;
    for (const operation of $b3f8f3f59d6c1203$var$AUTH_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth[operation] === "function") supabaseClientInstance.auth[operation] = $b3f8f3f59d6c1203$var$instrumentAuthOperation(authOperation);
    }
    for (const operation of $b3f8f3f59d6c1203$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth.admin[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth.admin[operation] === "function") supabaseClientInstance.auth.admin[operation] = $b3f8f3f59d6c1203$var$instrumentAuthOperation(authOperation, true);
    }
    $b3f8f3f59d6c1203$var$markAsInstrumented(supabaseClientInstance.auth);
}
function $b3f8f3f59d6c1203$var$instrumentSupabaseClientConstructor(SupabaseClient, _options) {
    if ($b3f8f3f59d6c1203$var$isInstrumented(SupabaseClient.prototype.from)) return;
    SupabaseClient.prototype.from = new Proxy(SupabaseClient.prototype.from, {
        apply (target, thisArg, argumentsList) {
            const rv = Reflect.apply(target, thisArg, argumentsList);
            const PostgRESTQueryBuilder = rv.constructor;
            $b3f8f3f59d6c1203$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder, _options);
            return rv;
        }
    });
    $b3f8f3f59d6c1203$var$markAsInstrumented(SupabaseClient.prototype.from);
}
function $b3f8f3f59d6c1203$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder, _options) {
    if ($b3f8f3f59d6c1203$var$isInstrumented(PostgRESTFilterBuilder.prototype.then)) return;
    PostgRESTFilterBuilder.prototype.then = new Proxy(PostgRESTFilterBuilder.prototype.then, {
        apply (target, thisArg, argumentsList) {
            const operations = $b3f8f3f59d6c1203$var$DB_OPERATIONS_TO_INSTRUMENT;
            const typedThis = thisArg;
            const operation = $b3f8f3f59d6c1203$var$extractOperation(typedThis.method, typedThis.headers);
            if (!operations.includes(operation)) return Reflect.apply(target, thisArg, argumentsList);
            if (!typedThis?.url?.pathname || typeof typedThis.url.pathname !== "string") return Reflect.apply(target, thisArg, argumentsList);
            const pathParts = typedThis.url.pathname.split("/");
            const table = pathParts.length > 0 ? pathParts[pathParts.length - 1] : "";
            const queryItems = [];
            for (const [key, value] of typedThis.url.searchParams.entries())queryItems.push($b3f8f3f59d6c1203$var$translateFiltersIntoMethods(key, value));
            const body = /* @__PURE__ */ Object.create(null);
            if ($jV7hg.isPlainObject(typedThis.body)) for (const [key, value] of Object.entries(typedThis.body))body[key] = value;
            const client = $kfJmY.getClient();
            const shouldSendData = _options.sendOperationData ?? client?.getDataCollectionOptions().databaseQueryData === true;
            const bodyPayload = $b3f8f3f59d6c1203$var$getMutationBodyPayloadForTelemetry(typedThis.body, body);
            const mutationPart = operation === "select" ? "" : `${operation}${$b3f8f3f59d6c1203$var$hasMutationBodyForDescription(typedThis.body, body) ? "(...) " : ""}`;
            const queryPart = shouldSendData ? queryItems.join(" ") : queryItems.length > 0 ? "[redacted]" : "";
            const descriptionMiddle = [
                mutationPart.trimEnd(),
                queryPart
            ].filter(Boolean).join(" ");
            const description = descriptionMiddle ? `${descriptionMiddle} from(${table})` : `from(${table})`;
            const attributes = {
                "db.table": table,
                "db.schema": typedThis.schema,
                "db.url": typedThis.url.origin,
                "db.sdk": $b3f8f3f59d6c1203$var$getHeader(typedThis.headers, "X-Client-Info"),
                "db.system": "postgresql",
                "db.operation": operation,
                [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.db.supabase",
                [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "db"
            };
            if (queryItems.length && shouldSendData) attributes["db.query"] = queryItems;
            if (bodyPayload !== void 0 && shouldSendData) attributes["db.body"] = bodyPayload;
            return $aewmo.startSpan({
                name: description,
                attributes: attributes
            }, (span)=>{
                return Reflect.apply(target, thisArg, []).then((res)=>{
                    if (span) {
                        if (res && typeof res === "object" && "status" in res) $d33W7.setHttpStatus(span, res.status || 500);
                        span.end();
                    }
                    if (res?.error) {
                        const err = new Error(res.error.message);
                        if (res.error.code) err.code = res.error.code;
                        if (res.error.details) err.details = res.error.details;
                        const supabaseContext = {};
                        if (queryItems.length && shouldSendData) supabaseContext.query = queryItems;
                        if (bodyPayload !== void 0 && shouldSendData) supabaseContext.body = bodyPayload;
                        $aK1wS.captureException(err, (scope)=>{
                            scope.addEventProcessor((e)=>{
                                $jR1Dv.addExceptionMechanism(e, {
                                    handled: false,
                                    type: "auto.db.supabase.postgres"
                                });
                                return e;
                            });
                            scope.setContext("supabase", supabaseContext);
                            return scope;
                        });
                    }
                    const breadcrumb = {
                        type: "supabase",
                        category: `db.${operation}`,
                        message: description
                    };
                    const data = {};
                    if (queryItems.length && shouldSendData) data.query = queryItems;
                    if (bodyPayload !== void 0 && shouldSendData) data.body = bodyPayload;
                    if (Object.keys(data).length) breadcrumb.data = data;
                    $dwO73.addBreadcrumb(breadcrumb);
                    return res;
                }, (err)=>{
                    if (span) {
                        $d33W7.setHttpStatus(span, 500);
                        span.end();
                    }
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
    $b3f8f3f59d6c1203$var$markAsInstrumented(PostgRESTFilterBuilder.prototype.then);
}
function $b3f8f3f59d6c1203$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder, _options) {
    for (const operation of $b3f8f3f59d6c1203$var$DB_OPERATIONS_TO_INSTRUMENT){
        if ($b3f8f3f59d6c1203$var$isInstrumented(PostgRESTQueryBuilder.prototype[operation])) continue;
        PostgRESTQueryBuilder.prototype[operation] = new Proxy(PostgRESTQueryBuilder.prototype[operation], {
            apply (target, thisArg, argumentsList) {
                const rv = Reflect.apply(target, thisArg, argumentsList);
                const PostgRESTFilterBuilder = rv.constructor;
                $1GyI0.DEBUG_BUILD && $2sm2V.debug.log(`Instrumenting ${operation} operation's PostgRESTFilterBuilder`);
                $b3f8f3f59d6c1203$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder, _options);
                return rv;
            }
        });
        $b3f8f3f59d6c1203$var$markAsInstrumented(PostgRESTQueryBuilder.prototype[operation]);
    }
}
const $b3f8f3f59d6c1203$var$instrumentSupabaseClient = (supabaseClient, options = {})=>{
    if (!supabaseClient) {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn("Supabase integration was not installed because no Supabase client was provided.");
        return;
    }
    const SupabaseClientConstructor = supabaseClient.constructor === Function ? supabaseClient : supabaseClient.constructor;
    $b3f8f3f59d6c1203$var$instrumentSupabaseClientConstructor(SupabaseClientConstructor, options);
    $b3f8f3f59d6c1203$var$instrumentSupabaseAuthClient(supabaseClient);
};
const $b3f8f3f59d6c1203$var$INTEGRATION_NAME = "Supabase";
const $b3f8f3f59d6c1203$var$_supabaseIntegration = (supabaseClient, options)=>{
    return {
        setupOnce () {
            $b3f8f3f59d6c1203$var$instrumentSupabaseClient(supabaseClient, options);
        },
        name: $b3f8f3f59d6c1203$var$INTEGRATION_NAME
    };
};
const $b3f8f3f59d6c1203$var$supabaseIntegration = $5vlAD.defineIntegration((options)=>{
    return $b3f8f3f59d6c1203$var$_supabaseIntegration(options.supabaseClient, {
        sendOperationData: options.sendOperationData
    });
});
module.exports.DB_OPERATIONS_TO_INSTRUMENT = $b3f8f3f59d6c1203$var$DB_OPERATIONS_TO_INSTRUMENT;
module.exports.FILTER_MAPPINGS = $b3f8f3f59d6c1203$var$FILTER_MAPPINGS;
module.exports.extractOperation = $b3f8f3f59d6c1203$var$extractOperation;
module.exports.getHeader = $b3f8f3f59d6c1203$var$getHeader;
module.exports.instrumentSupabaseClient = $b3f8f3f59d6c1203$var$instrumentSupabaseClient;
module.exports.supabaseIntegration = $b3f8f3f59d6c1203$var$supabaseIntegration;
module.exports.translateFiltersIntoMethods = $b3f8f3f59d6c1203$var$translateFiltersIntoMethods;

});

parcelRegister("47jLQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5vlAD = parcelRequire("5vlAD");

var $jV7hg = parcelRequire("jV7hg");

var $1L2sM = parcelRequire("1L2sM");
const $2ff726ea0ebfbf2c$var$DEFAULT_LIMIT = 10;
const $2ff726ea0ebfbf2c$var$INTEGRATION_NAME = "ZodErrors";
function $2ff726ea0ebfbf2c$var$originalExceptionIsZodError(originalException) {
    return $jV7hg.isError(originalException) && originalException.name === "ZodError" && Array.isArray(originalException.issues);
}
function $2ff726ea0ebfbf2c$var$flattenIssue(issue) {
    return {
        ...issue,
        path: "path" in issue && Array.isArray(issue.path) ? issue.path.join(".") : void 0,
        keys: "keys" in issue ? JSON.stringify(issue.keys) : void 0,
        unionErrors: "unionErrors" in issue ? JSON.stringify(issue.unionErrors) : void 0
    };
}
function $2ff726ea0ebfbf2c$var$flattenIssuePath(path) {
    return path.map((p)=>{
        if (typeof p === "number") return "<array>";
        else return p;
    }).join(".");
}
function $2ff726ea0ebfbf2c$var$formatIssueMessage(zodError) {
    const errorKeyMap = /* @__PURE__ */ new Set();
    for (const iss of zodError.issues){
        const issuePath = $2ff726ea0ebfbf2c$var$flattenIssuePath(iss.path);
        if (issuePath.length > 0) errorKeyMap.add(issuePath);
    }
    const errorKeys = Array.from(errorKeyMap);
    if (errorKeys.length === 0) {
        let rootExpectedType = "variable";
        if (zodError.issues.length > 0) {
            const iss = zodError.issues[0];
            if (iss !== void 0 && "expected" in iss && typeof iss.expected === "string") rootExpectedType = iss.expected;
        }
        return `Failed to validate ${rootExpectedType}`;
    }
    return `Failed to validate keys: ${$1L2sM.truncate(errorKeys.join(", "), 100)}`;
}
function $2ff726ea0ebfbf2c$var$applyZodErrorsToEvent(limit, saveZodIssuesAsAttachment = false, event, hint) {
    if (!event.exception?.values || !hint.originalException || !$2ff726ea0ebfbf2c$var$originalExceptionIsZodError(hint.originalException) || hint.originalException.issues.length === 0) return event;
    try {
        const issuesToFlatten = saveZodIssuesAsAttachment ? hint.originalException.issues : hint.originalException.issues.slice(0, limit);
        const flattenedIssues = issuesToFlatten.map($2ff726ea0ebfbf2c$var$flattenIssue);
        if (saveZodIssuesAsAttachment) {
            if (!Array.isArray(hint.attachments)) hint.attachments = [];
            hint.attachments.push({
                filename: "zod_issues.json",
                data: JSON.stringify({
                    issues: flattenedIssues
                })
            });
        }
        return {
            ...event,
            exception: {
                ...event.exception,
                values: [
                    {
                        ...event.exception.values[0],
                        value: $2ff726ea0ebfbf2c$var$formatIssueMessage(hint.originalException)
                    },
                    ...event.exception.values.slice(1)
                ]
            },
            extra: {
                ...event.extra,
                "zoderror.issues": flattenedIssues.slice(0, limit)
            }
        };
    } catch (e) {
        return {
            ...event,
            extra: {
                ...event.extra,
                "zoderrors sentry integration parse error": {
                    message: "an exception was thrown while processing ZodError within applyZodErrorsToEvent()",
                    error: e instanceof Error ? `${e.name}: ${e.message}
${e.stack}` : "unknown"
                }
            }
        };
    }
}
const $2ff726ea0ebfbf2c$var$_zodErrorsIntegration = (options = {})=>{
    const limit = options.limit ?? $2ff726ea0ebfbf2c$var$DEFAULT_LIMIT;
    return {
        name: $2ff726ea0ebfbf2c$var$INTEGRATION_NAME,
        processEvent (originalEvent, hint) {
            const processedEvent = $2ff726ea0ebfbf2c$var$applyZodErrorsToEvent(limit, options.saveZodIssuesAsAttachment, originalEvent, hint);
            return processedEvent;
        }
    };
};
const $2ff726ea0ebfbf2c$var$zodErrorsIntegration = $5vlAD.defineIntegration($2ff726ea0ebfbf2c$var$_zodErrorsIntegration);
module.exports.applyZodErrorsToEvent = $2ff726ea0ebfbf2c$var$applyZodErrorsToEvent;
module.exports.flattenIssue = $2ff726ea0ebfbf2c$var$flattenIssue;
module.exports.flattenIssuePath = $2ff726ea0ebfbf2c$var$flattenIssuePath;
module.exports.formatIssueMessage = $2ff726ea0ebfbf2c$var$formatIssueMessage;
module.exports.zodErrorsIntegration = $2ff726ea0ebfbf2c$var$zodErrorsIntegration;

});

parcelRegister("hHN24", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5vlAD = parcelRequire("5vlAD");

var $8IXO6 = parcelRequire("8IXO6");

var $kAeXb = parcelRequire("kAeXb");

var $fIlsR = parcelRequire("fIlsR");

var $fxVZv = parcelRequire("fxVZv");
const $ce3c7ca4b49ed7fd$var$thirdPartyErrorFilterIntegration = $5vlAD.defineIntegration((options)=>{
    return {
        name: "ThirdPartyErrorsFilter",
        setup (client) {
            client.on("beforeEnvelope", (envelope$1)=>{
                $kAeXb.forEachEnvelopeItem(envelope$1, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : void 0;
                        if (event) {
                            $8IXO6.stripMetadataFromStackFrames(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on("applyFrameMetadata", (event)=>{
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                $8IXO6.addMetadataToStackFrames(stackParser, event);
            });
        },
        preprocessEvent (event) {
            if (options.ignoreSentryInternalFrames && ($fxVZv.GLOBAL_OBJ._sentryWrappedDepth ?? 0) > 0) event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                insideSentryWrapped: true
            };
        },
        processEvent (event) {
            const insideSentryWrapped = options.ignoreSentryInternalFrames ? event.sdkProcessingMetadata?.insideSentryWrapped === true && event.exception?.values?.length === 1 : false;
            const frameKeys = $ce3c7ca4b49ed7fd$var$getBundleKeysForAllFramesWithFilenames(event, options.ignoreSentryInternalFrames, insideSentryWrapped);
            if (frameKeys) {
                const arrayMethod = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "apply-tag-if-contains-third-party-frames" ? "some" : "every";
                const behaviourApplies = frameKeys[arrayMethod]((keys)=>!keys.some((key)=>options.filterKeys.includes(key)));
                if (behaviourApplies) {
                    const shouldDrop = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "drop-error-if-exclusively-contains-third-party-frames";
                    if (shouldDrop) return null;
                    else event.tags = {
                        ...event.tags,
                        third_party_code: true
                    };
                }
            }
            return event;
        }
    };
});
function $ce3c7ca4b49ed7fd$var$isSentryInternalFrame(frame, frameIndex, insideSentryWrapped) {
    if (frameIndex !== 0) return false;
    if (insideSentryWrapped && $ce3c7ca4b49ed7fd$var$isLikelyMinifiedSentryWrappedFrame(frame)) return true;
    if (frame.function === "sentryWrapped") return true;
    if (!frame.context_line || !frame.filename) return false;
    if (!frame.filename.includes("sentry") || !frame.filename.includes("helpers") || // Filename would look something like this: 'node_modules/@sentry/browser/build/npm/esm/helpers.js'
    !frame.context_line.includes($ce3c7ca4b49ed7fd$var$SENTRY_INTERNAL_FN_APPLY)) return false;
    if (frame.pre_context) {
        const len = frame.pre_context.length;
        for(let i = 0; i < len; i++){
            if (frame.pre_context[i]?.includes($ce3c7ca4b49ed7fd$var$SENTRY_INTERNAL_COMMENT)) return true;
        }
    }
    return false;
}
function $ce3c7ca4b49ed7fd$var$getBundleKeysForAllFramesWithFilenames(event, ignoreSentryInternalFrames, insideSentryWrapped) {
    const frames = $fIlsR.getFramesFromEvent(event);
    if (!frames) return void 0;
    return frames.filter((frame, index)=>{
        if (!frame.filename) return false;
        if (frame.lineno == null && frame.colno == null && frame.instruction_addr == null) return false;
        return !ignoreSentryInternalFrames || !$ce3c7ca4b49ed7fd$var$isSentryInternalFrame(frame, index, !!insideSentryWrapped);
    }).map((frame)=>{
        if (!frame.module_metadata) return [];
        return Object.keys(frame.module_metadata).filter((key)=>key.startsWith($ce3c7ca4b49ed7fd$var$BUNDLER_PLUGIN_APP_KEY_PREFIX)).map((key)=>key.slice($ce3c7ca4b49ed7fd$var$BUNDLER_PLUGIN_APP_KEY_PREFIX.length));
    });
}
function $ce3c7ca4b49ed7fd$var$isLikelyMinifiedSentryWrappedFrame(frame) {
    return !frame.context_line && !frame.pre_context && !!frame.function && frame.function.length <= 2;
}
const $ce3c7ca4b49ed7fd$var$BUNDLER_PLUGIN_APP_KEY_PREFIX = "_sentryBundlerPluginAppKey:";
const $ce3c7ca4b49ed7fd$var$SENTRY_INTERNAL_COMMENT = "Attempt to invoke user-land function";
const $ce3c7ca4b49ed7fd$var$SENTRY_INTERNAL_FN_APPLY = "fn.apply(this, wrappedArguments)";
module.exports.thirdPartyErrorFilterIntegration = $ce3c7ca4b49ed7fd$var$thirdPartyErrorFilterIntegration;

});

parcelRegister("2Ojx4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dwO73 = parcelRequire("dwO73");

var $kfJmY = parcelRequire("kfJmY");

var $9Fabw = parcelRequire("9Fabw");

var $5vlAD = parcelRequire("5vlAD");

var $2sm2V = parcelRequire("2sm2V");

var $iGwGT = parcelRequire("iGwGT");

var $1L2sM = parcelRequire("1L2sM");

var $fxVZv = parcelRequire("fxVZv");
const $20bf66ff4e6911b7$var$INTEGRATION_NAME = "Console";
const $20bf66ff4e6911b7$var$consoleIntegration = $5vlAD.defineIntegration((options = {})=>{
    const levels = new Set(options.levels || $2sm2V.CONSOLE_LEVELS);
    return {
        name: $20bf66ff4e6911b7$var$INTEGRATION_NAME,
        setup (client) {
            const unsubscribe = $9Fabw.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($kfJmY.getClient() !== client || !levels.has(level)) return;
                $20bf66ff4e6911b7$var$addConsoleBreadcrumb(level, args);
            });
            client.registerCleanup(unsubscribe);
            if (options.filter) {
                const unsubscribe2 = $9Fabw.addConsoleInstrumentationFilter(options.filter);
                client.registerCleanup(unsubscribe2);
            }
        }
    };
});
function $20bf66ff4e6911b7$var$addConsoleBreadcrumb(level, args) {
    const breadcrumb = {
        category: "console",
        data: {
            arguments: args,
            logger: "console"
        },
        level: $iGwGT.severityLevelFromString(level),
        message: $20bf66ff4e6911b7$var$formatConsoleArgs(args)
    };
    if (level === "assert") {
        if (args[0] === false) {
            const assertionArgs = args.slice(1);
            breadcrumb.message = assertionArgs.length > 0 ? `Assertion failed: ${$20bf66ff4e6911b7$var$formatConsoleArgs(assertionArgs)}` : "Assertion failed";
            breadcrumb.data.arguments = assertionArgs;
        } else return;
    }
    $dwO73.addBreadcrumb(breadcrumb, {
        input: args,
        level: level
    });
}
function $20bf66ff4e6911b7$var$formatConsoleArgs(values) {
    return "util" in $fxVZv.GLOBAL_OBJ && typeof $fxVZv.GLOBAL_OBJ.util.format === "function" ? $fxVZv.GLOBAL_OBJ.util.format(...values) : $1L2sM.safeJoin(values, " ");
}
module.exports.addConsoleBreadcrumb = $20bf66ff4e6911b7$var$addConsoleBreadcrumb;
module.exports.consoleIntegration = $20bf66ff4e6911b7$var$consoleIntegration;

});

parcelRegister("2UjBX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5vlAD = parcelRequire("5vlAD");

var $20yzn = parcelRequire("20yzn");
const $21e00619e6bb2e8e$var$featureFlagsIntegration = $5vlAD.defineIntegration(()=>{
    return {
        name: "FeatureFlags",
        processEvent (event, _hint, _client) {
            return $20yzn._INTERNAL_copyFlagsFromScopeToEvent(event);
        },
        addFeatureFlag (name, value) {
            $20yzn._INTERNAL_insertFlagToScope(name, value);
            $20yzn._INTERNAL_addFeatureFlagToActiveSpan(name, value);
        }
    };
});
module.exports.featureFlagsIntegration = $21e00619e6bb2e8e$var$featureFlagsIntegration;

});
parcelRegister("20yzn", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kfJmY = parcelRequire("kfJmY");

var $1GyI0 = parcelRequire("1GyI0");

var $2sm2V = parcelRequire("2sm2V");

var $8hCvI = parcelRequire("8hCvI");
const $176665a4023260f7$var$_INTERNAL_FLAG_BUFFER_SIZE = 100;
const $176665a4023260f7$var$_INTERNAL_MAX_FLAGS_PER_SPAN = 10;
const $176665a4023260f7$var$SPAN_FLAG_ATTRIBUTE_PREFIX = "flag.evaluation.";
function $176665a4023260f7$var$_INTERNAL_copyFlagsFromScopeToEvent(event) {
    if (event.type) return event;
    const scope = $kfJmY.getCurrentScope();
    const flagContext = scope.getScopeData().contexts.flags;
    const flagBuffer = flagContext ? flagContext.values : [];
    if (!flagBuffer.length) return event;
    if (event.contexts === void 0) event.contexts = {};
    event.contexts.flags = {
        values: [
            ...flagBuffer
        ]
    };
    return event;
}
function $176665a4023260f7$var$_INTERNAL_insertFlagToScope(name, value, maxSize = $176665a4023260f7$var$_INTERNAL_FLAG_BUFFER_SIZE) {
    const scopeContexts = $kfJmY.getCurrentScope().getScopeData().contexts;
    if (!scopeContexts.flags) scopeContexts.flags = {
        values: []
    };
    const flags = scopeContexts.flags.values;
    $176665a4023260f7$var$_INTERNAL_insertToFlagBuffer(flags, name, value, maxSize);
}
function $176665a4023260f7$var$_INTERNAL_insertToFlagBuffer(flags, name, value, maxSize) {
    if (typeof value !== "boolean") return;
    if (flags.length > maxSize) {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.error(`[Feature Flags] insertToFlagBuffer called on a buffer larger than maxSize=${maxSize}`);
        return;
    }
    const index = flags.findIndex((f)=>f.flag === name);
    if (index !== -1) flags.splice(index, 1);
    if (flags.length === maxSize) flags.shift();
    flags.push({
        flag: name,
        result: value
    });
}
function $176665a4023260f7$var$_INTERNAL_addFeatureFlagToActiveSpan(name, value, maxFlagsPerSpan = $176665a4023260f7$var$_INTERNAL_MAX_FLAGS_PER_SPAN) {
    if (typeof value !== "boolean") return;
    const span = $8hCvI.getActiveSpan();
    if (!span) return;
    const attributes = $8hCvI.spanToJSON(span).data;
    if (`${$176665a4023260f7$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}` in attributes) {
        span.setAttribute(`${$176665a4023260f7$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
        return;
    }
    const numOfAddedFlags = Object.keys(attributes).filter((key)=>key.startsWith($176665a4023260f7$var$SPAN_FLAG_ATTRIBUTE_PREFIX)).length;
    if (numOfAddedFlags < maxFlagsPerSpan) span.setAttribute(`${$176665a4023260f7$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
}
module.exports._INTERNAL_FLAG_BUFFER_SIZE = $176665a4023260f7$var$_INTERNAL_FLAG_BUFFER_SIZE;
module.exports._INTERNAL_MAX_FLAGS_PER_SPAN = $176665a4023260f7$var$_INTERNAL_MAX_FLAGS_PER_SPAN;
module.exports._INTERNAL_addFeatureFlagToActiveSpan = $176665a4023260f7$var$_INTERNAL_addFeatureFlagToActiveSpan;
module.exports._INTERNAL_copyFlagsFromScopeToEvent = $176665a4023260f7$var$_INTERNAL_copyFlagsFromScopeToEvent;
module.exports._INTERNAL_insertFlagToScope = $176665a4023260f7$var$_INTERNAL_insertFlagToScope;
module.exports._INTERNAL_insertToFlagBuffer = $176665a4023260f7$var$_INTERNAL_insertToFlagBuffer;

});


parcelRegister("cBTtm", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5vlAD = parcelRequire("5vlAD");

var $20yzn = parcelRequire("20yzn");

var $65lWX = parcelRequire("65lWX");
const $92e3f86a88d8f1fb$var$growthbookIntegration = $5vlAD.defineIntegration(({ growthbookClass: growthbookClass })=>{
    return {
        name: "GrowthBook",
        setupOnce () {
            const proto = growthbookClass.prototype;
            if (typeof proto.isOn === "function") $65lWX.fill(proto, "isOn", $92e3f86a88d8f1fb$var$_wrapAndCaptureBooleanResult);
            if (typeof proto.getFeatureValue === "function") $65lWX.fill(proto, "getFeatureValue", $92e3f86a88d8f1fb$var$_wrapAndCaptureBooleanResult);
        },
        processEvent (event, _hint, _client) {
            return $20yzn._INTERNAL_copyFlagsFromScopeToEvent(event);
        }
    };
});
function $92e3f86a88d8f1fb$var$_wrapAndCaptureBooleanResult(original) {
    return function(...args) {
        const flagName = args[0];
        const result = original.apply(this, args);
        if (typeof flagName === "string" && typeof result === "boolean") {
            $20yzn._INTERNAL_insertFlagToScope(flagName, result);
            $20yzn._INTERNAL_addFeatureFlagToActiveSpan(flagName, result);
        }
        return result;
    };
}
module.exports.growthbookIntegration = $92e3f86a88d8f1fb$var$growthbookIntegration;

});

parcelRegister("kP4C3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kfJmY = parcelRequire("kfJmY");

var $5vlAD = parcelRequire("5vlAD");

var $2JysJ = parcelRequire("2JysJ");

var $8hCvI = parcelRequire("8hCvI");
const $f28c2614da609193$var$INTEGRATION_NAME = "ConversationId";
const $f28c2614da609193$var$_conversationIdIntegration = ()=>{
    return {
        name: $f28c2614da609193$var$INTEGRATION_NAME,
        setup (client) {
            client.on("spanStart", (span)=>{
                const scopeData = $kfJmY.getCurrentScope().getScopeData();
                const isolationScopeData = $kfJmY.getIsolationScope().getScopeData();
                const conversationId = scopeData.conversationId || isolationScopeData.conversationId;
                if (conversationId) {
                    const { op: op, data: attributes, description: name } = $8hCvI.spanToJSON(span);
                    if (!op?.startsWith("gen_ai.") && !attributes["ai.operationId"] && !name?.startsWith("ai.")) return;
                    span.setAttribute($2JysJ.GEN_AI_CONVERSATION_ID_ATTRIBUTE, conversationId);
                }
            });
        }
    };
};
const $f28c2614da609193$var$conversationIdIntegration = $5vlAD.defineIntegration($f28c2614da609193$var$_conversationIdIntegration);
module.exports.conversationIdIntegration = $f28c2614da609193$var$conversationIdIntegration;

});

parcelRegister("k8mK7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kfJmY = parcelRequire("kfJmY");

var $1GyI0 = parcelRequire("1GyI0");

var $2sm2V = parcelRequire("2sm2V");
function $ea863241748ce3b9$var$isProfilingIntegrationWithProfiler(integration) {
    return !!integration && typeof integration["_profiler"] !== "undefined" && typeof integration["_profiler"]["start"] === "function" && typeof integration["_profiler"]["stop"] === "function";
}
function $ea863241748ce3b9$var$startProfiler() {
    const client = $kfJmY.getClient();
    if (!client) {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn("No Sentry client available, profiling is not started");
        return;
    }
    const integration = client.getIntegrationByName("ProfilingIntegration");
    if (!integration) {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn("ProfilingIntegration is not available");
        return;
    }
    if (!$ea863241748ce3b9$var$isProfilingIntegrationWithProfiler(integration)) {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn("Profiler is not available on profiling integration.");
        return;
    }
    integration._profiler.start();
}
function $ea863241748ce3b9$var$stopProfiler() {
    const client = $kfJmY.getClient();
    if (!client) {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn("No Sentry client available, profiling is not started");
        return;
    }
    const integration = client.getIntegrationByName("ProfilingIntegration");
    if (!integration) {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn("ProfilingIntegration is not available");
        return;
    }
    if (!$ea863241748ce3b9$var$isProfilingIntegrationWithProfiler(integration)) {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn("Profiler is not available on profiling integration.");
        return;
    }
    integration._profiler.stop();
}
const $ea863241748ce3b9$var$profiler = {
    startProfiler: $ea863241748ce3b9$var$startProfiler,
    stopProfiler: $ea863241748ce3b9$var$stopProfiler
};
module.exports.profiler = $ea863241748ce3b9$var$profiler;

});

parcelRegister("giJRi", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3tmPs = parcelRequire("3tmPs");

var $kfJmY = parcelRequire("kfJmY");

var $2JysJ = parcelRequire("2JysJ");

var $8hCvI = parcelRequire("8hCvI");

var $d33W7 = parcelRequire("d33W7");

var $jV7hg = parcelRequire("jV7hg");

var $5xQO6 = parcelRequire("5xQO6");

var $fyn9D = parcelRequire("fyn9D");

var $QBqQc = parcelRequire("QBqQc");

var $g8Glr = parcelRequire("g8Glr");

var $aewmo = parcelRequire("aewmo");

var $jvpIz = parcelRequire("jvpIz");

var $foGB0 = parcelRequire("foGB0");
function $bde1e65cfa85cdce$var$instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOriginOrOptions) {
    if (!handlerData.fetchData) return void 0;
    const { method: method, url: url } = handlerData.fetchData;
    const shouldCreateSpanResult = $5xQO6.hasSpansEnabled() && shouldCreateSpan(url);
    if (handlerData.endTimestamp) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span2 = spans[spanId];
        if (span2) {
            if (shouldCreateSpanResult) {
                $bde1e65cfa85cdce$var$endSpan(span2, handlerData);
                $bde1e65cfa85cdce$var$_callOnRequestSpanEnd(span2, handlerData, spanOriginOrOptions);
            }
            delete spans[spanId];
        }
        return void 0;
    }
    const { spanOrigin: spanOrigin = "auto.http.browser", propagateTraceparent: propagateTraceparent = false } = typeof spanOriginOrOptions === "object" ? spanOriginOrOptions : {
        spanOrigin: spanOriginOrOptions
    };
    const client = $kfJmY.getClient();
    const hasParent = !!$8hCvI.getActiveSpan();
    const shouldEmitSpan = hasParent || !!client && $g8Glr.hasSpanStreamingEnabled(client);
    const span = shouldCreateSpanResult && shouldEmitSpan ? $aewmo.startInactiveSpan($bde1e65cfa85cdce$var$getSpanStartOptions(url, method, spanOrigin)) : new $fyn9D.SentryNonRecordingSpan();
    const spanForTraceHeaders = $aewmo.spanIsIgnored(span) && hasParent ? void 0 : span;
    if (shouldCreateSpanResult && !shouldEmitSpan) client?.recordDroppedEvent("no_parent_span", "span");
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        const options = {
            ...handlerData.args[1] || {}
        };
        const headers = $bde1e65cfa85cdce$var$_INTERNAL_getTracingHeadersForFetchRequest(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        $5xQO6.hasSpansEnabled() && shouldEmitSpan ? spanForTraceHeaders : void 0, propagateTraceparent);
        if (headers) {
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    if (client) {
        const fetchHint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: handlerData.startTimestamp,
            endTimestamp: handlerData.endTimestamp
        };
        client.emit("beforeOutgoingRequestSpan", span, fetchHint);
    }
    return span;
}
function $bde1e65cfa85cdce$var$_callOnRequestSpanEnd(span, handlerData, spanOriginOrOptions) {
    const onRequestSpanEnd = typeof spanOriginOrOptions === "object" && spanOriginOrOptions !== null ? spanOriginOrOptions.onRequestSpanEnd : void 0;
    onRequestSpanEnd?.(span, {
        headers: handlerData.response?.headers,
        error: handlerData.error
    });
}
function $bde1e65cfa85cdce$var$_INTERNAL_getTracingHeadersForFetchRequest(request, fetchOptionsObj, span, propagateTraceparent) {
    const traceHeaders = $jvpIz.getTraceData({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    const sentryTrace = traceHeaders["sentry-trace"];
    const baggage = traceHeaders.baggage;
    const traceparent = traceHeaders.traceparent;
    if (!sentryTrace) return void 0;
    const originalHeaders = fetchOptionsObj.headers || ($jV7hg.isRequest(request) ? request.headers : void 0);
    if (!originalHeaders) return {
        "sentry-trace": sentryTrace,
        ...baggage && {
            baggage: baggage
        },
        ...traceparent && {
            traceparent: traceparent
        }
    };
    else if ($bde1e65cfa85cdce$var$isHeaders(originalHeaders)) {
        const newHeaders = new Headers(originalHeaders);
        if (!newHeaders.get("sentry-trace")) newHeaders.set("sentry-trace", sentryTrace);
        if (propagateTraceparent && traceparent && !newHeaders.get("traceparent")) newHeaders.set("traceparent", traceparent);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get("baggage");
            if (!prevBaggageHeader) newHeaders.set("baggage", baggage);
            else if (!$bde1e65cfa85cdce$var$baggageHeaderHasSentryBaggageValues(prevBaggageHeader)) newHeaders.set("baggage", `${prevBaggageHeader},${baggage}`);
        }
        return newHeaders;
    } else if ($bde1e65cfa85cdce$var$isHeadersInitTupleArray(originalHeaders)) {
        const newHeaders = [
            ...originalHeaders
        ];
        if (!newHeaders.find((header)=>header[0] === "sentry-trace")) newHeaders.push([
            "sentry-trace",
            sentryTrace
        ]);
        if (propagateTraceparent && traceparent && !newHeaders.find((header)=>header[0] === "traceparent")) newHeaders.push([
            "traceparent",
            traceparent
        ]);
        const prevBaggageHeaderWithSentryValues = originalHeaders.find((header)=>header[0] === "baggage" && typeof header[1] === "string" && $bde1e65cfa85cdce$var$baggageHeaderHasSentryBaggageValues(header[1]));
        if (baggage && !prevBaggageHeaderWithSentryValues) newHeaders.push([
            "baggage",
            baggage
        ]);
        return newHeaders;
    } else {
        const existingSentryTraceHeader = "sentry-trace" in originalHeaders ? originalHeaders["sentry-trace"] : void 0;
        const existingTraceparentHeader = "traceparent" in originalHeaders ? originalHeaders.traceparent : void 0;
        const existingBaggageHeader = "baggage" in originalHeaders ? originalHeaders.baggage : void 0;
        const newBaggageHeaders = existingBaggageHeader ? Array.isArray(existingBaggageHeader) ? [
            ...existingBaggageHeader
        ] : [
            existingBaggageHeader
        ] : [];
        const prevBaggageHeaderWithSentryValues = existingBaggageHeader && (Array.isArray(existingBaggageHeader) ? existingBaggageHeader.find((headerItem)=>$bde1e65cfa85cdce$var$baggageHeaderHasSentryBaggageValues(headerItem)) : $bde1e65cfa85cdce$var$baggageHeaderHasSentryBaggageValues(existingBaggageHeader));
        if (baggage && !prevBaggageHeaderWithSentryValues) newBaggageHeaders.push(baggage);
        const newHeaders = Object.assign({}, originalHeaders, {
            "sentry-trace": existingSentryTraceHeader ?? sentryTrace,
            ...newBaggageHeaders.length > 0 && {
                baggage: newBaggageHeaders.join(",")
            }
        });
        if (propagateTraceparent && traceparent && !existingTraceparentHeader) newHeaders.traceparent = traceparent;
        return newHeaders;
    }
}
function $bde1e65cfa85cdce$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        $d33W7.setHttpStatus(span, handlerData.response.status);
        const contentLength = handlerData.response?.headers?.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: $d33W7.SPAN_STATUS_ERROR,
        message: "internal_error"
    });
    span.end();
}
function $bde1e65cfa85cdce$var$baggageHeaderHasSentryBaggageValues(baggageHeader) {
    if (typeof baggageHeader !== "string") return false;
    return baggageHeader.split(",").some((baggageEntry)=>baggageEntry.trim().startsWith($QBqQc.SENTRY_BAGGAGE_KEY_PREFIX));
}
function $bde1e65cfa85cdce$var$isHeaders(headers) {
    return typeof Headers !== "undefined" && $jV7hg.isInstanceOf(headers, Headers);
}
function $bde1e65cfa85cdce$var$isHeadersInitTupleArray(headers) {
    if (!Array.isArray(headers)) return false;
    return headers.every((item)=>Array.isArray(item) && item.length === 2 && typeof item[0] === "string");
}
function $bde1e65cfa85cdce$var$getSpanStartOptions(url$1, method, spanOrigin) {
    if (url$1.startsWith("data:")) {
        const sanitizedUrl2 = $foGB0.stripDataUrlContent(url$1);
        return {
            name: `${method} ${sanitizedUrl2}`,
            attributes: $bde1e65cfa85cdce$var$getFetchSpanAttributes(url$1, void 0, method, spanOrigin)
        };
    }
    const parsedUrl = $foGB0.parseStringToURLObject(url$1);
    const sanitizedUrl = parsedUrl ? $foGB0.getSanitizedUrlStringFromUrlObject(parsedUrl) : url$1;
    return {
        name: `${method} ${sanitizedUrl}`,
        attributes: $bde1e65cfa85cdce$var$getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin)
    };
}
function $bde1e65cfa85cdce$var$getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin) {
    const attributes$1 = {
        url: $foGB0.stripDataUrlContent(url$1),
        type: "fetch",
        "http.method": method,
        [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "http.client"
    };
    if (parsedUrl) {
        if (!$foGB0.isURLObjectRelative(parsedUrl)) {
            attributes$1[$3tmPs.HTTP_URL] = $foGB0.stripDataUrlContent(parsedUrl.href);
            attributes$1[$3tmPs.URL_FULL] = $foGB0.stripDataUrlContent(parsedUrl.href);
            attributes$1["server.address"] = parsedUrl.host;
        }
        if (parsedUrl.search) attributes$1["http.query"] = parsedUrl.search;
        if (parsedUrl.hash) attributes$1["http.fragment"] = parsedUrl.hash;
    }
    return attributes$1;
}
module.exports._INTERNAL_getTracingHeadersForFetchRequest = $bde1e65cfa85cdce$var$_INTERNAL_getTracingHeadersForFetchRequest;
module.exports._callOnRequestSpanEnd = $bde1e65cfa85cdce$var$_callOnRequestSpanEnd;
module.exports.instrumentFetchRequest = $bde1e65cfa85cdce$var$instrumentFetchRequest;

});

parcelRegister("b5gRO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kfJmY = parcelRequire("kfJmY");
function $811d3ec57d92f63c$var$captureFeedback(params, hint = {}, scope = $kfJmY.getCurrentScope()) {
    const { message: message, name: name, email: email, url: url, source: source, associatedEventId: associatedEventId, tags: tags } = params;
    const feedbackEvent = {
        contexts: {
            feedback: {
                contact_email: email,
                name: name,
                message: message,
                url: url,
                source: source,
                associated_event_id: associatedEventId
            }
        },
        type: "feedback",
        level: "info",
        tags: tags
    };
    const client = scope?.getClient() || $kfJmY.getClient();
    if (client) client.emit("beforeSendFeedback", feedbackEvent, hint);
    const eventId = scope.captureEvent(feedbackEvent, hint);
    return eventId;
}
module.exports.captureFeedback = $811d3ec57d92f63c$var$captureFeedback;

});

parcelRegister("knlYV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9ZVkJ = parcelRequire("9ZVkJ");

var $5nIsa = parcelRequire("5nIsa");
function $ed5701b48876cc49$var$captureLog(level, message, attributes, scope, severityNumber) {
    $9ZVkJ._INTERNAL_captureLog({
        level: level,
        message: message,
        attributes: attributes,
        severityNumber: severityNumber
    }, scope);
}
function $ed5701b48876cc49$var$trace(message, attributes, { scope: scope } = {}) {
    $ed5701b48876cc49$var$captureLog("trace", message, attributes, scope);
}
function $ed5701b48876cc49$var$debug(message, attributes, { scope: scope } = {}) {
    $ed5701b48876cc49$var$captureLog("debug", message, attributes, scope);
}
function $ed5701b48876cc49$var$info(message, attributes, { scope: scope } = {}) {
    $ed5701b48876cc49$var$captureLog("info", message, attributes, scope);
}
function $ed5701b48876cc49$var$warn(message, attributes, { scope: scope } = {}) {
    $ed5701b48876cc49$var$captureLog("warn", message, attributes, scope);
}
function $ed5701b48876cc49$var$error(message, attributes, { scope: scope } = {}) {
    $ed5701b48876cc49$var$captureLog("error", message, attributes, scope);
}
function $ed5701b48876cc49$var$fatal(message, attributes, { scope: scope } = {}) {
    $ed5701b48876cc49$var$captureLog("fatal", message, attributes, scope);
}
module.exports.fmt = $5nIsa.fmt;
module.exports.debug = $ed5701b48876cc49$var$debug;
module.exports.error = $ed5701b48876cc49$var$error;
module.exports.fatal = $ed5701b48876cc49$var$fatal;
module.exports.info = $ed5701b48876cc49$var$info;
module.exports.trace = $ed5701b48876cc49$var$trace;
module.exports.warn = $ed5701b48876cc49$var$warn;

});

parcelRegister("k8x0o", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kfJmY = parcelRequire("kfJmY");

var $1GyI0 = parcelRequire("1GyI0");

var $9Fabw = parcelRequire("9Fabw");

var $5vlAD = parcelRequire("5vlAD");

var $2JysJ = parcelRequire("2JysJ");

var $2sm2V = parcelRequire("2sm2V");

var $jV7hg = parcelRequire("jV7hg");

var $2ZrfN = parcelRequire("2ZrfN");

var $9ZVkJ = parcelRequire("9ZVkJ");

var $7oEbL = parcelRequire("7oEbL");
const $ea8e28272400a712$var$INTEGRATION_NAME = "ConsoleLogs";
const $ea8e28272400a712$var$DEFAULT_ATTRIBUTES = {
    [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.log.console"
};
const $ea8e28272400a712$var$_consoleLoggingIntegration = (options = {})=>{
    const levels = options.levels || $2sm2V.CONSOLE_LEVELS;
    return {
        name: $ea8e28272400a712$var$INTEGRATION_NAME,
        setup (client) {
            const { enableLogs: enableLogs, normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = client.getOptions();
            if (!enableLogs) {
                $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn("`enableLogs` is not enabled, ConsoleLogs integration disabled");
                return;
            }
            const unsubscribe = $9Fabw.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($kfJmY.getClient() !== client || !levels.includes(level)) return;
                const firstArg = args[0];
                const followingArgs = args.slice(1);
                if (level === "assert") {
                    if (!firstArg) {
                        const assertionMessage = followingArgs.length > 0 ? `Assertion failed: ${$7oEbL.formatConsoleArgs(followingArgs, normalizeDepth, normalizeMaxBreadth)}` : "Assertion failed";
                        $9ZVkJ._INTERNAL_captureLog({
                            level: "error",
                            message: assertionMessage,
                            attributes: $ea8e28272400a712$var$DEFAULT_ATTRIBUTES
                        });
                    }
                    return;
                }
                const isLevelLog = level === "log";
                const attributes = {
                    ...$ea8e28272400a712$var$DEFAULT_ATTRIBUTES
                };
                if ($jV7hg.isPlainObject(firstArg)) {
                    Object.assign(attributes, $2ZrfN.normalize(firstArg, normalizeDepth, normalizeMaxBreadth));
                    const remainingArgsStartIndex = typeof args[1] === "string" ? 2 : 1;
                    const remainingArgs = args.slice(remainingArgsStartIndex);
                    remainingArgs.forEach((arg, index)=>{
                        attributes[`sentry.message.parameter.${index}`] = $2ZrfN.normalize(arg, normalizeDepth, normalizeMaxBreadth);
                    });
                } else {
                    const shouldGenerateTemplate = followingArgs.length > 0 && typeof firstArg === "string" && !$7oEbL.hasConsoleSubstitutions(firstArg);
                    if (shouldGenerateTemplate) {
                        const templateAttrs = $7oEbL.createConsoleTemplateAttributes(firstArg, followingArgs);
                        for (const [key, value] of Object.entries(templateAttrs))attributes[key] = key.startsWith("sentry.message.parameter.") ? $2ZrfN.normalize(value, normalizeDepth, normalizeMaxBreadth) : value;
                    }
                }
                $9ZVkJ._INTERNAL_captureLog({
                    level: isLevelLog ? "info" : level,
                    message: $7oEbL.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth),
                    severityNumber: isLevelLog ? 10 : void 0,
                    attributes: attributes
                });
            });
            client.registerCleanup(unsubscribe);
        }
    };
};
const $ea8e28272400a712$var$consoleLoggingIntegration = $5vlAD.defineIntegration($ea8e28272400a712$var$_consoleLoggingIntegration);
module.exports.consoleLoggingIntegration = $ea8e28272400a712$var$consoleLoggingIntegration;

});
parcelRegister("7oEbL", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jV7hg = parcelRequire("jV7hg");

var $2ZrfN = parcelRequire("2ZrfN");

var $fxVZv = parcelRequire("fxVZv");
function $5629f2f263a66dc6$var$formatConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return "util" in $fxVZv.GLOBAL_OBJ && typeof $fxVZv.GLOBAL_OBJ.util.format === "function" ? $fxVZv.GLOBAL_OBJ.util.format(...values) : $5629f2f263a66dc6$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth);
}
function $5629f2f263a66dc6$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return values.map((value)=>$jV7hg.isPrimitive(value) ? String(value) : JSON.stringify($2ZrfN.normalize(value, normalizeDepth, normalizeMaxBreadth))).join(" ");
}
function $5629f2f263a66dc6$var$hasConsoleSubstitutions(str) {
    return /%[sdifocO]/.test(str);
}
function $5629f2f263a66dc6$var$createConsoleTemplateAttributes(firstArg, followingArgs) {
    const attributes = {};
    const template = new Array(followingArgs.length).fill("{}").join(" ");
    attributes["sentry.message.template"] = `${firstArg} ${template}`;
    followingArgs.forEach((arg, index)=>{
        attributes[`sentry.message.parameter.${index}`] = arg;
    });
    return attributes;
}
module.exports.createConsoleTemplateAttributes = $5629f2f263a66dc6$var$createConsoleTemplateAttributes;
module.exports.formatConsoleArgs = $5629f2f263a66dc6$var$formatConsoleArgs;
module.exports.hasConsoleSubstitutions = $5629f2f263a66dc6$var$hasConsoleSubstitutions;
module.exports.safeJoinConsoleArgs = $5629f2f263a66dc6$var$safeJoinConsoleArgs;

});


parcelRegister("91S1B", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bRW4e = parcelRequire("bRW4e");
function $692e1d47bd90ada7$var$captureMetric(type, name, value, options) {
    $bRW4e._INTERNAL_captureMetric({
        type: type,
        name: name,
        value: value,
        unit: options?.unit,
        attributes: options?.attributes
    }, {
        scope: options?.scope
    });
}
function $692e1d47bd90ada7$var$count(name, value = 1, options) {
    $692e1d47bd90ada7$var$captureMetric("counter", name, value, options);
}
function $692e1d47bd90ada7$var$gauge(name, value, options) {
    $692e1d47bd90ada7$var$captureMetric("gauge", name, value, options);
}
function $692e1d47bd90ada7$var$distribution(name, value, options) {
    $692e1d47bd90ada7$var$captureMetric("distribution", name, value, options);
}
module.exports.count = $692e1d47bd90ada7$var$count;
module.exports.distribution = $692e1d47bd90ada7$var$distribution;
module.exports.gauge = $692e1d47bd90ada7$var$gauge;

});

parcelRegister("gSEzQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kfJmY = parcelRequire("kfJmY");

var $9ZVkJ = parcelRequire("9ZVkJ");

var $7oEbL = parcelRequire("7oEbL");

var $jV7hg = parcelRequire("jV7hg");

var $2ZrfN = parcelRequire("2ZrfN");
const $c4a12a3c9fa7e484$var$DEFAULT_CAPTURED_LEVELS = [
    "trace",
    "debug",
    "info",
    "warn",
    "error",
    "fatal"
];
function $c4a12a3c9fa7e484$var$createConsolaReporter(options = {}) {
    const levels = new Set(options.levels ?? $c4a12a3c9fa7e484$var$DEFAULT_CAPTURED_LEVELS);
    const providedClient = options.client;
    return {
        log (logObj) {
            const { type: type, level: level, message: consolaMessage, args: args, tag: tag, date: _date, ...rest } = logObj;
            const client = providedClient || $kfJmY.getClient();
            if (!client) return;
            const logSeverityLevel = $c4a12a3c9fa7e484$var$getLogSeverityLevel(type, level);
            if (!levels.has(logSeverityLevel)) return;
            const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = client.getOptions();
            const attributes = {};
            for (const [key, value] of Object.entries(rest))attributes[key] = $2ZrfN.normalize(value, normalizeDepth, normalizeMaxBreadth);
            attributes["sentry.origin"] = "auto.log.consola";
            if (tag) attributes["consola.tag"] = tag;
            if (type) attributes["consola.type"] = type;
            if (level != null && typeof level === "number") attributes["consola.level"] = level;
            const extractionResult = $c4a12a3c9fa7e484$var$processExtractedAttributes($c4a12a3c9fa7e484$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth), normalizeDepth, normalizeMaxBreadth);
            if (extractionResult?.attributes) Object.assign(attributes, extractionResult.attributes);
            $9ZVkJ._INTERNAL_captureLog({
                level: logSeverityLevel,
                message: extractionResult?.message || consolaMessage || args && $7oEbL.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth) || "",
                attributes: attributes
            });
        }
    };
}
const $c4a12a3c9fa7e484$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP = {
    // Consola built-in types
    silent: "trace",
    fatal: "fatal",
    error: "error",
    warn: "warn",
    log: "info",
    info: "info",
    success: "info",
    fail: "error",
    ready: "info",
    start: "info",
    box: "info",
    debug: "debug",
    trace: "trace",
    verbose: "debug",
    // Custom types that might exist
    critical: "fatal",
    notice: "info"
};
const $c4a12a3c9fa7e484$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP = {
    0: "fatal",
    // Fatal and Error
    1: "warn",
    // Warnings
    2: "info",
    // Normal logs
    3: "info",
    // Informational logs, success, fail, ready, start, ...
    4: "debug",
    // Debug logs
    5: "trace"
};
function $c4a12a3c9fa7e484$var$getLogSeverityLevel(type, level) {
    if (type === "verbose") return "debug";
    if (type === "silent") return "trace";
    if (type) {
        const mappedLevel = $c4a12a3c9fa7e484$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP[type];
        if (mappedLevel) return mappedLevel;
    }
    if (typeof level === "number") {
        const mappedLevel = $c4a12a3c9fa7e484$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP[level];
        if (mappedLevel) return mappedLevel;
    }
    return "info";
}
function $c4a12a3c9fa7e484$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth) {
    if (!args?.length) return {
        message: ""
    };
    const message = $7oEbL.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth);
    const firstArg = args[0];
    if ($jV7hg.isPlainObject(firstArg)) {
        const remainingArgsStartIndex = typeof args[1] === "string" ? 2 : 1;
        const remainingArgs = args.slice(remainingArgsStartIndex);
        return {
            message: message,
            // Object content from first arg is added as attributes
            attributes: firstArg,
            // Add remaining args as message parameters
            messageParameters: remainingArgs
        };
    } else {
        const followingArgs = args.slice(1);
        const shouldAddTemplateAttr = followingArgs.length > 0 && typeof firstArg === "string" && !$7oEbL.hasConsoleSubstitutions(firstArg);
        return {
            message: message,
            messageTemplate: shouldAddTemplateAttr ? firstArg : void 0,
            messageParameters: shouldAddTemplateAttr ? followingArgs : void 0
        };
    }
}
function $c4a12a3c9fa7e484$var$processExtractedAttributes(extractionResult, normalizeDepth, normalizeMaxBreadth) {
    const { message: message, attributes: attributes, messageTemplate: messageTemplate, messageParameters: messageParameters } = extractionResult;
    const messageParamAttributes = {};
    if (messageTemplate && messageParameters) {
        const templateAttrs = $7oEbL.createConsoleTemplateAttributes(messageTemplate, messageParameters);
        for (const [key, value] of Object.entries(templateAttrs))messageParamAttributes[key] = key.startsWith("sentry.message.parameter.") ? $2ZrfN.normalize(value, normalizeDepth, normalizeMaxBreadth) : value;
    } else if (messageParameters && messageParameters.length > 0) messageParameters.forEach((arg, index)=>{
        messageParamAttributes[`sentry.message.parameter.${index}`] = $2ZrfN.normalize(arg, normalizeDepth, normalizeMaxBreadth);
    });
    return {
        message: message,
        attributes: {
            ...$2ZrfN.normalize(attributes, normalizeDepth, normalizeMaxBreadth),
            ...messageParamAttributes
        }
    };
}
module.exports.createConsolaReporter = $c4a12a3c9fa7e484$var$createConsolaReporter;

});

parcelRegister("cgTZX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kfJmY = parcelRequire("kfJmY");

var $2JysJ = parcelRequire("2JysJ");

var $5mc1N = parcelRequire("5mc1N");

var $7it17 = parcelRequire("7it17");

var $8hCvI = parcelRequire("8hCvI");

var $2glvn = parcelRequire("2glvn");

var $2Qk3n = parcelRequire("2Qk3n");

var $1eeiu = parcelRequire("1eeiu");

var $g8Glr = parcelRequire("g8Glr");

var $gXfFT = parcelRequire("gXfFT");

var $aGmMO = parcelRequire("aGmMO");
function $8ef26abee498fe2a$var$onVercelAiSpanStart(span) {
    const { data: attributes, description: name } = $8hCvI.spanToJSON(span);
    if (!name) return;
    if (attributes[$aGmMO.AI_TOOL_CALL_NAME_ATTRIBUTE] && attributes[$aGmMO.AI_TOOL_CALL_ID_ATTRIBUTE] && name === "ai.toolCall") {
        $8ef26abee498fe2a$var$processToolCallSpan(span, attributes);
        return;
    }
    if (!attributes[$aGmMO.AI_OPERATION_ID_ATTRIBUTE] && !name.startsWith("ai.")) return;
    if ($1eeiu.SPAN_TO_OPERATION_NAME.get(name) === "generate_content") $7it17._INTERNAL_skipAiProviderWrapping([
        $2glvn.WORKERS_AI_INTEGRATION_NAME
    ]);
    const client = $kfJmY.getClient();
    const integration = client?.getIntegrationByName("VercelAI");
    const enableTruncation = $5mc1N.shouldEnableTruncation(integration?.options?.enableTruncation);
    $8ef26abee498fe2a$var$processGenerateSpan(span, name, attributes, enableTruncation);
}
function $8ef26abee498fe2a$var$vercelAiEventProcessor(event) {
    if (event.type === "transaction" && event.spans) {
        const tokenAccumulator = /* @__PURE__ */ new Map();
        for (const span of event.spans){
            $8ef26abee498fe2a$var$processEndedVercelAiSpan(span);
            $gXfFT.accumulateTokensForParent(span, tokenAccumulator);
        }
        $gXfFT.applyToolDescriptionsAndTokens(event.spans, tokenAccumulator);
        const trace = event.contexts?.trace;
        if (trace?.op === "gen_ai.invoke_agent") $gXfFT.applyAccumulatedTokens(trace, tokenAccumulator);
    }
    return event;
}
function $8ef26abee498fe2a$var$normalizeFinishReason(finishReason) {
    if (typeof finishReason !== "string") return "stop";
    switch(finishReason){
        case "tool-calls":
            return "tool_call";
        case "stop":
        case "length":
        case "content_filter":
        case "error":
            return finishReason;
        default:
            return finishReason;
    }
}
function $8ef26abee498fe2a$var$buildOutputMessages(attributes) {
    const responseText = attributes[$aGmMO.AI_RESPONSE_TEXT_ATTRIBUTE];
    const responseToolCalls = attributes[$aGmMO.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
    const finishReason = attributes[$aGmMO.AI_RESPONSE_FINISH_REASON_ATTRIBUTE];
    if (responseText == null && responseToolCalls == null) return;
    const parts = [];
    if (typeof responseText === "string" && responseText.length > 0) parts.push({
        type: "text",
        content: responseText
    });
    if (responseToolCalls != null) try {
        const toolCalls = typeof responseToolCalls === "string" ? JSON.parse(responseToolCalls) : responseToolCalls;
        if (Array.isArray(toolCalls)) {
            for (const toolCall of toolCalls){
                const args = toolCall.input ?? toolCall.args;
                parts.push({
                    type: "tool_call",
                    id: toolCall.toolCallId,
                    name: toolCall.toolName,
                    // Handle undefined args: JSON.stringify(undefined) returns undefined, not a string,
                    // which would cause the property to be omitted from the final JSON output
                    arguments: typeof args === "string" ? args : JSON.stringify(args ?? {})
                });
            }
            delete attributes[$aGmMO.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
        }
    } catch  {}
    if (parts.length > 0) {
        const outputMessage = {
            role: "assistant",
            parts: parts,
            finish_reason: $8ef26abee498fe2a$var$normalizeFinishReason(finishReason)
        };
        attributes[$2Qk3n.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE] = JSON.stringify([
            outputMessage
        ]);
        delete attributes[$aGmMO.AI_RESPONSE_TEXT_ATTRIBUTE];
    }
}
function $8ef26abee498fe2a$var$processVercelAiSpanAttributes(attributes) {
    $8ef26abee498fe2a$var$renameAttributeKey(attributes, $aGmMO.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE, $2Qk3n.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
    $8ef26abee498fe2a$var$renameAttributeKey(attributes, $aGmMO.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE, $2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $8ef26abee498fe2a$var$renameAttributeKey(attributes, $aGmMO.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE, $2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE);
    $8ef26abee498fe2a$var$renameAttributeKey(attributes, "ai.usage.inputTokens", $2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $8ef26abee498fe2a$var$renameAttributeKey(attributes, "ai.usage.outputTokens", $2Qk3n.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
    $8ef26abee498fe2a$var$renameAttributeKey(attributes, $aGmMO.AI_USAGE_TOKENS_ATTRIBUTE, $2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $8ef26abee498fe2a$var$renameAttributeKey(attributes, "ai.response.avgOutputTokensPerSecond", "ai.response.avgCompletionTokensPerSecond");
    const inputTokensAreCacheInclusive = Object.keys(attributes).some((key)=>key.startsWith($aGmMO.AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX));
    if (!inputTokensAreCacheInclusive && typeof attributes[$2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === "number" && typeof attributes[$2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE] === "number") attributes[$2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = attributes[$2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] + attributes[$2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE];
    if (typeof attributes[$2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === "number") {
        const outputTokens = typeof attributes[$2Qk3n.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] === "number" ? attributes[$2Qk3n.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] : 0;
        attributes[$2Qk3n.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = outputTokens + attributes[$2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    }
    if (attributes[$aGmMO.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[$aGmMO.AI_PROMPT_TOOLS_ATTRIBUTE])) attributes[$aGmMO.AI_PROMPT_TOOLS_ATTRIBUTE] = $gXfFT.convertAvailableToolsToJsonString(attributes[$aGmMO.AI_PROMPT_TOOLS_ATTRIBUTE]);
    if (attributes[$aGmMO.OPERATION_NAME_ATTRIBUTE]) {
        const rawOperationName = attributes[$aGmMO.AI_OPERATION_ID_ATTRIBUTE] ? attributes[$aGmMO.AI_OPERATION_ID_ATTRIBUTE] : attributes[$aGmMO.OPERATION_NAME_ATTRIBUTE];
        const operationName = $1eeiu.SPAN_TO_OPERATION_NAME.get(rawOperationName) ?? rawOperationName;
        attributes[$2Qk3n.GEN_AI_OPERATION_NAME_ATTRIBUTE] = operationName;
        delete attributes[$aGmMO.OPERATION_NAME_ATTRIBUTE];
    }
    $8ef26abee498fe2a$var$renameAttributeKey(attributes, $aGmMO.AI_PROMPT_MESSAGES_ATTRIBUTE, $2Qk3n.GEN_AI_INPUT_MESSAGES_ATTRIBUTE);
    $8ef26abee498fe2a$var$buildOutputMessages(attributes);
    $8ef26abee498fe2a$var$renameAttributeKey(attributes, $aGmMO.AI_RESPONSE_OBJECT_ATTRIBUTE, "gen_ai.response.object");
    $8ef26abee498fe2a$var$renameAttributeKey(attributes, $aGmMO.AI_PROMPT_TOOLS_ATTRIBUTE, "gen_ai.request.available_tools");
    $8ef26abee498fe2a$var$renameAttributeKey(attributes, $aGmMO.AI_TOOL_CALL_ARGS_ATTRIBUTE, $2Qk3n.GEN_AI_TOOL_INPUT_ATTRIBUTE);
    $8ef26abee498fe2a$var$renameAttributeKey(attributes, $aGmMO.AI_TOOL_CALL_RESULT_ATTRIBUTE, $2Qk3n.GEN_AI_TOOL_OUTPUT_ATTRIBUTE);
    $8ef26abee498fe2a$var$renameAttributeKey(attributes, $aGmMO.AI_SCHEMA_ATTRIBUTE, "gen_ai.request.schema");
    $8ef26abee498fe2a$var$renameAttributeKey(attributes, $aGmMO.AI_MODEL_ID_ATTRIBUTE, $2Qk3n.GEN_AI_REQUEST_MODEL_ATTRIBUTE);
    if (Array.isArray(attributes[$aGmMO.AI_VALUES_ATTRIBUTE])) {
        const parsed = attributes[$aGmMO.AI_VALUES_ATTRIBUTE].map((v)=>{
            try {
                return JSON.parse(v);
            } catch  {
                return v;
            }
        });
        attributes[$2Qk3n.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = parsed.length === 1 ? parsed[0] : JSON.stringify(parsed);
    }
    $8ef26abee498fe2a$var$addProviderMetadataToAttributes(attributes);
    for (const key of Object.keys(attributes)){
        if (Array.isArray(attributes[key])) attributes[key] = JSON.stringify(attributes[key]);
        if (key.startsWith("ai.")) $8ef26abee498fe2a$var$renameAttributeKey(attributes, key, `vercel.${key}`);
    }
}
function $8ef26abee498fe2a$var$processEndedVercelAiSpan(span) {
    const { data: attributes, origin: origin } = span;
    if (origin !== "auto.vercelai.otel") return;
    if (span.status && span.status !== "ok") span.status = "internal_error";
    $8ef26abee498fe2a$var$processVercelAiSpanAttributes(attributes);
}
function $8ef26abee498fe2a$var$processVercelAiStreamedSpan(span) {
    const attributes = span.attributes;
    if (attributes?.[$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN] !== "auto.vercelai.otel") return;
    $8ef26abee498fe2a$var$processVercelAiSpanAttributes(attributes);
    if (attributes[$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_OP] === "gen_ai.execute_tool" && span.parent_span_id) {
        const descriptions = $1eeiu.toolDescriptionMap.get(span.parent_span_id);
        if (descriptions) {
            const toolName = attributes[$2Qk3n.GEN_AI_TOOL_NAME_ATTRIBUTE];
            if (typeof toolName === "string") {
                const desc = descriptions.get(toolName);
                if (desc) attributes[$2Qk3n.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = desc;
            }
        }
    }
    $1eeiu.toolDescriptionMap.delete(span.span_id);
}
function $8ef26abee498fe2a$var$renameAttributeKey(attributes, oldKey, newKey) {
    if (attributes[oldKey] != null) {
        attributes[newKey] = attributes[oldKey];
        delete attributes[oldKey];
    }
}
function $8ef26abee498fe2a$var$processToolCallSpan(span, attributes) {
    span.setAttribute($2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.vercelai.otel");
    span.setAttribute($2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_OP, "gen_ai.execute_tool");
    span.setAttribute($2Qk3n.GEN_AI_OPERATION_NAME_ATTRIBUTE, "execute_tool");
    $8ef26abee498fe2a$var$renameAttributeKey(attributes, $aGmMO.AI_TOOL_CALL_NAME_ATTRIBUTE, $2Qk3n.GEN_AI_TOOL_NAME_ATTRIBUTE);
    $8ef26abee498fe2a$var$renameAttributeKey(attributes, $aGmMO.AI_TOOL_CALL_ID_ATTRIBUTE, $2Qk3n.GEN_AI_TOOL_CALL_ID_ATTRIBUTE);
    const toolCallId = attributes[$2Qk3n.GEN_AI_TOOL_CALL_ID_ATTRIBUTE];
    if (typeof toolCallId === "string") $1eeiu.toolCallSpanContextMap.set(toolCallId, span.spanContext());
    if (!attributes[$2Qk3n.GEN_AI_TOOL_TYPE_ATTRIBUTE]) span.setAttribute($2Qk3n.GEN_AI_TOOL_TYPE_ATTRIBUTE, "function");
    const toolName = attributes[$2Qk3n.GEN_AI_TOOL_NAME_ATTRIBUTE];
    if (toolName) span.updateName(`execute_tool ${toolName}`);
}
function $8ef26abee498fe2a$var$processGenerateSpan(span, name, attributes, enableTruncation) {
    span.setAttribute($2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.vercelai.otel");
    const nameWthoutAi = name.replace("ai.", "");
    span.setAttribute("ai.pipeline.name", nameWthoutAi);
    span.updateName(nameWthoutAi);
    const functionId = attributes[$aGmMO.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE];
    if (functionId && typeof functionId === "string") span.setAttribute("gen_ai.function_id", functionId);
    $gXfFT.requestMessagesFromPrompt(span, attributes, enableTruncation);
    if (attributes[$aGmMO.AI_MODEL_ID_ATTRIBUTE] && !attributes[$2Qk3n.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]) span.setAttribute($2Qk3n.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, attributes[$aGmMO.AI_MODEL_ID_ATTRIBUTE]);
    span.setAttribute("ai.streaming", name.includes("stream"));
    const operationName = $1eeiu.SPAN_TO_OPERATION_NAME.get(name);
    if (operationName) span.setAttribute($2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_OP, `gen_ai.${operationName}`);
    else if (name.startsWith("ai.stream")) span.setAttribute($2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_OP, "ai.run");
    if (operationName === "invoke_agent") {
        if (functionId && typeof functionId === "string") span.updateName(`invoke_agent ${functionId}`);
        else span.updateName("invoke_agent");
        return;
    }
    const modelId = attributes[$aGmMO.AI_MODEL_ID_ATTRIBUTE];
    if (modelId && operationName) span.updateName(`${operationName} ${modelId}`);
    const client = $kfJmY.getClient();
    if (client && $g8Glr.hasSpanStreamingEnabled(client) && attributes[$aGmMO.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[$aGmMO.AI_PROMPT_TOOLS_ATTRIBUTE])) {
        const descriptions = /* @__PURE__ */ new Map();
        for (const toolStr of attributes[$aGmMO.AI_PROMPT_TOOLS_ATTRIBUTE])try {
            const parsed = typeof toolStr === "string" ? JSON.parse(toolStr) : toolStr;
            if (parsed?.name && parsed?.description) descriptions.set(parsed.name, parsed.description);
        } catch  {}
        if (descriptions.size > 0) {
            const parentSpanId = $8hCvI.spanToJSON(span).parent_span_id;
            if (parentSpanId) $1eeiu.toolDescriptionMap.set(parentSpanId, descriptions);
        }
    }
}
const $8ef26abee498fe2a$var$CLIENTS_WITH_VERCEL_AI_PROCESSORS = /* @__PURE__ */ new WeakSet();
function $8ef26abee498fe2a$var$addVercelAiProcessors(client) {
    if ($8ef26abee498fe2a$var$CLIENTS_WITH_VERCEL_AI_PROCESSORS.has(client)) return;
    $8ef26abee498fe2a$var$CLIENTS_WITH_VERCEL_AI_PROCESSORS.add(client);
    client.on("spanStart", $8ef26abee498fe2a$var$onVercelAiSpanStart);
    client.addEventProcessor(Object.assign($8ef26abee498fe2a$var$vercelAiEventProcessor, {
        id: "VercelAiEventProcessor"
    }));
    client.on("processSpan", (span)=>{
        $8ef26abee498fe2a$var$processVercelAiStreamedSpan(span);
    });
}
function $8ef26abee498fe2a$var$getProviderMetadataAttributes(providerMetadata) {
    const attributes = {};
    if (!providerMetadata || typeof providerMetadata !== "object") return attributes;
    const metadata = providerMetadata;
    const openaiMetadata = metadata.openai ?? metadata.azure;
    if (openaiMetadata) {
        $8ef26abee498fe2a$var$setAttributeIfDefined(attributes, $2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, openaiMetadata.cachedPromptTokens);
        $8ef26abee498fe2a$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.reasoning", openaiMetadata.reasoningTokens);
        $8ef26abee498fe2a$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.prediction_accepted", openaiMetadata.acceptedPredictionTokens);
        $8ef26abee498fe2a$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.prediction_rejected", openaiMetadata.rejectedPredictionTokens);
        $8ef26abee498fe2a$var$setAttributeIfDefined(attributes, $2Qk3n.GEN_AI_CONVERSATION_ID_ATTRIBUTE, openaiMetadata.responseId);
    }
    if (metadata.anthropic) {
        const cachedInputTokens = metadata.anthropic.usage?.cache_read_input_tokens ?? metadata.anthropic.cacheReadInputTokens;
        $8ef26abee498fe2a$var$setAttributeIfDefined(attributes, $2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, cachedInputTokens);
        const cacheWriteInputTokens = metadata.anthropic.usage?.cache_creation_input_tokens ?? metadata.anthropic.cacheCreationInputTokens;
        $8ef26abee498fe2a$var$setAttributeIfDefined(attributes, $2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE, cacheWriteInputTokens);
    }
    if (metadata.bedrock?.usage) {
        $8ef26abee498fe2a$var$setAttributeIfDefined(attributes, $2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, metadata.bedrock.usage.cacheReadInputTokens);
        $8ef26abee498fe2a$var$setAttributeIfDefined(attributes, $2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE, metadata.bedrock.usage.cacheWriteInputTokens);
    }
    if (metadata.deepseek) {
        $8ef26abee498fe2a$var$setAttributeIfDefined(attributes, $2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, metadata.deepseek.promptCacheHitTokens);
        $8ef26abee498fe2a$var$setAttributeIfDefined(attributes, "gen_ai.usage.input_tokens.cache_miss", metadata.deepseek.promptCacheMissTokens);
    }
    const googleUsage = (metadata.google ?? metadata.vertex)?.usageMetadata;
    if (googleUsage && typeof googleUsage.thoughtsTokenCount === "number" && googleUsage.thoughtsTokenCount > 0) {
        attributes[$2Qk3n.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = (googleUsage.candidatesTokenCount ?? 0) + googleUsage.thoughtsTokenCount;
        $8ef26abee498fe2a$var$setAttributeIfDefined(attributes, $2Qk3n.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, googleUsage.totalTokenCount);
        $8ef26abee498fe2a$var$setAttributeIfDefined(attributes, "gen_ai.usage.reasoning.output_tokens", googleUsage.thoughtsTokenCount);
    }
    return attributes;
}
const $8ef26abee498fe2a$var$LAST_STEP_ONLY_USAGE_KEYS = /* @__PURE__ */ new Set([
    $2Qk3n.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE,
    $2Qk3n.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE,
    "gen_ai.usage.reasoning.output_tokens"
]);
function $8ef26abee498fe2a$var$addProviderMetadataToAttributes(attributes) {
    const providerMetadata = attributes[$aGmMO.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE];
    if (!providerMetadata) return;
    const lastStepOnly = attributes[$2Qk3n.GEN_AI_OPERATION_NAME_ATTRIBUTE] === "invoke_agent";
    try {
        const derived = $8ef26abee498fe2a$var$getProviderMetadataAttributes(JSON.parse(providerMetadata));
        for (const [key, value] of Object.entries(derived)){
            if (key === $2Qk3n.GEN_AI_CONVERSATION_ID_ATTRIBUTE && attributes[key]) continue;
            if (lastStepOnly && $8ef26abee498fe2a$var$LAST_STEP_ONLY_USAGE_KEYS.has(key)) continue;
            attributes[key] = value;
        }
    } catch  {}
}
function $8ef26abee498fe2a$var$setAttributeIfDefined(attributes, key, value) {
    if (value != null) attributes[key] = value;
}
module.exports.LAST_STEP_ONLY_USAGE_KEYS = $8ef26abee498fe2a$var$LAST_STEP_ONLY_USAGE_KEYS;
module.exports.addVercelAiProcessors = $8ef26abee498fe2a$var$addVercelAiProcessors;
module.exports.getProviderMetadataAttributes = $8ef26abee498fe2a$var$getProviderMetadataAttributes;
module.exports.processVercelAiSpanAttributes = $8ef26abee498fe2a$var$processVercelAiSpanAttributes;

});
parcelRegister("5mc1N", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kfJmY = parcelRequire("kfJmY");

var $g8Glr = parcelRequire("g8Glr");

var $jV7hg = parcelRequire("jV7hg");

var $2Qk3n = parcelRequire("2Qk3n");

var $jBz6V = parcelRequire("jBz6V");
function $0101aecfddfac253$var$resolveAIRecordingOptions(options) {
    const genAI = $kfJmY.getClient()?.getDataCollectionOptions().genAI;
    return {
        ...options,
        recordInputs: options?.recordInputs ?? genAI?.inputs ?? false,
        recordOutputs: options?.recordOutputs ?? genAI?.outputs ?? false
    };
}
function $0101aecfddfac253$var$shouldEnableTruncation(enableTruncation) {
    if (enableTruncation !== void 0) return enableTruncation;
    const client = $kfJmY.getClient();
    if (!client) return true;
    return !$g8Glr.hasSpanStreamingEnabled(client) && client.getOptions().streamGenAiSpans === false;
}
function $0101aecfddfac253$var$buildMethodPath(currentPath, prop) {
    return currentPath ? `${currentPath}.${prop}` : prop;
}
function $0101aecfddfac253$var$setTokenUsageAttributes(span, promptTokens, completionTokens, cachedInputTokens, cachedOutputTokens) {
    if (promptTokens !== void 0) span.setAttributes({
        [$2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE]: promptTokens
    });
    if (completionTokens !== void 0) span.setAttributes({
        [$2Qk3n.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE]: completionTokens
    });
    if (promptTokens !== void 0 || completionTokens !== void 0 || cachedInputTokens !== void 0 || cachedOutputTokens !== void 0) {
        const totalTokens = (promptTokens ?? 0) + (completionTokens ?? 0) + (cachedInputTokens ?? 0) + (cachedOutputTokens ?? 0);
        span.setAttributes({
            [$2Qk3n.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE]: totalTokens
        });
    }
}
function $0101aecfddfac253$var$endStreamSpan(span, state, recordOutputs) {
    if (!span.isRecording()) return;
    const attrs = {
        [$2Qk3n.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE]: true
    };
    if (state.responseId) attrs[$2Qk3n.GEN_AI_RESPONSE_ID_ATTRIBUTE] = state.responseId;
    if (state.responseModel) attrs[$2Qk3n.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = state.responseModel;
    if (state.promptTokens !== void 0) attrs[$2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = state.promptTokens;
    if (state.completionTokens !== void 0) attrs[$2Qk3n.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = state.completionTokens;
    if (state.totalTokens !== void 0) attrs[$2Qk3n.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = state.totalTokens;
    else if (state.promptTokens !== void 0 || state.completionTokens !== void 0 || state.cacheCreationInputTokens !== void 0 || state.cacheReadInputTokens !== void 0) attrs[$2Qk3n.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = (state.promptTokens ?? 0) + (state.completionTokens ?? 0) + (state.cacheCreationInputTokens ?? 0) + (state.cacheReadInputTokens ?? 0);
    if (state.finishReasons.length) attrs[$2Qk3n.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(state.finishReasons);
    if (recordOutputs && state.responseTexts.length) attrs[$2Qk3n.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = state.responseTexts.join("");
    if (recordOutputs && state.toolCalls.length) attrs[$2Qk3n.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(state.toolCalls);
    span.setAttributes(attrs);
    span.end();
}
function $0101aecfddfac253$var$getTruncatedJsonString(value) {
    if (typeof value === "string") return $jBz6V.truncateGenAiStringInput(value);
    try {
        return JSON.stringify(Array.isArray(value) ? $jBz6V.truncateGenAiMessages(value) : value);
    } catch  {
        return "[unserializable]";
    }
}
function $0101aecfddfac253$var$extractSystemInstructions(messages) {
    if (!Array.isArray(messages)) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemMessageIndex = messages.findIndex((msg)=>msg && typeof msg === "object" && "role" in msg && msg.role === "system");
    if (systemMessageIndex === -1) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemMessage = messages[systemMessageIndex];
    const systemContent = typeof systemMessage.content === "string" ? systemMessage.content : systemMessage.content !== void 0 ? JSON.stringify(systemMessage.content) : void 0;
    if (!systemContent) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemInstructions = JSON.stringify([
        {
            type: "text",
            content: systemContent
        }
    ]);
    const filteredMessages = [
        ...messages.slice(0, systemMessageIndex),
        ...messages.slice(systemMessageIndex + 1)
    ];
    return {
        systemInstructions: systemInstructions,
        filteredMessages: filteredMessages
    };
}
async function $0101aecfddfac253$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise) {
    const [instrumentedResult, originalWrapper] = await Promise.all([
        instrumentedPromise,
        originalWithResponse
    ]);
    if (originalWrapper && typeof originalWrapper === "object" && "data" in originalWrapper) return {
        ...originalWrapper,
        data: instrumentedResult
    };
    return instrumentedResult;
}
function $0101aecfddfac253$var$wrapPromiseWithMethods(originalPromiseLike, instrumentedPromise) {
    if (!$jV7hg.isThenable(originalPromiseLike)) return instrumentedPromise;
    return new Proxy(originalPromiseLike, {
        get (target, prop) {
            const useInstrumentedPromise = prop in Promise.prototype || prop === Symbol.toStringTag;
            const source = useInstrumentedPromise ? instrumentedPromise : target;
            const value = Reflect.get(source, prop);
            if (prop === "withResponse" && typeof value === "function") return function wrappedWithResponse() {
                const originalWithResponse = value.call(target);
                return $0101aecfddfac253$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise);
            };
            return typeof value === "function" ? value.bind(source) : value;
        }
    });
}
module.exports.buildMethodPath = $0101aecfddfac253$var$buildMethodPath;
module.exports.endStreamSpan = $0101aecfddfac253$var$endStreamSpan;
module.exports.extractSystemInstructions = $0101aecfddfac253$var$extractSystemInstructions;
module.exports.getTruncatedJsonString = $0101aecfddfac253$var$getTruncatedJsonString;
module.exports.resolveAIRecordingOptions = $0101aecfddfac253$var$resolveAIRecordingOptions;
module.exports.setTokenUsageAttributes = $0101aecfddfac253$var$setTokenUsageAttributes;
module.exports.shouldEnableTruncation = $0101aecfddfac253$var$shouldEnableTruncation;
module.exports.wrapPromiseWithMethods = $0101aecfddfac253$var$wrapPromiseWithMethods;

});
parcelRegister("2Qk3n", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $211ffe5313807cd2$var$GEN_AI_PROMPT_ATTRIBUTE = "gen_ai.prompt";
const $211ffe5313807cd2$var$GEN_AI_SYSTEM_ATTRIBUTE = "gen_ai.system";
const $211ffe5313807cd2$var$GEN_AI_REQUEST_MODEL_ATTRIBUTE = "gen_ai.request.model";
const $211ffe5313807cd2$var$GEN_AI_REQUEST_STREAM_ATTRIBUTE = "gen_ai.request.stream";
const $211ffe5313807cd2$var$GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = "gen_ai.request.temperature";
const $211ffe5313807cd2$var$GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = "gen_ai.request.max_tokens";
const $211ffe5313807cd2$var$GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = "gen_ai.request.frequency_penalty";
const $211ffe5313807cd2$var$GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = "gen_ai.request.presence_penalty";
const $211ffe5313807cd2$var$GEN_AI_REQUEST_TOP_P_ATTRIBUTE = "gen_ai.request.top_p";
const $211ffe5313807cd2$var$GEN_AI_REQUEST_TOP_K_ATTRIBUTE = "gen_ai.request.top_k";
const $211ffe5313807cd2$var$GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = "gen_ai.request.encoding_format";
const $211ffe5313807cd2$var$GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = "gen_ai.request.dimensions";
const $211ffe5313807cd2$var$GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = "gen_ai.response.finish_reasons";
const $211ffe5313807cd2$var$GEN_AI_RESPONSE_MODEL_ATTRIBUTE = "gen_ai.response.model";
const $211ffe5313807cd2$var$GEN_AI_RESPONSE_ID_ATTRIBUTE = "gen_ai.response.id";
const $211ffe5313807cd2$var$GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = "gen_ai.response.stop_reason";
const $211ffe5313807cd2$var$GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.input_tokens";
const $211ffe5313807cd2$var$GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.output_tokens";
const $211ffe5313807cd2$var$GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = "gen_ai.usage.total_tokens";
const $211ffe5313807cd2$var$GEN_AI_OPERATION_NAME_ATTRIBUTE = "gen_ai.operation.name";
const $211ffe5313807cd2$var$GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = "sentry.sdk_meta.gen_ai.input.messages.original_length";
const $211ffe5313807cd2$var$GEN_AI_INPUT_MESSAGES_ATTRIBUTE = "gen_ai.input.messages";
const $211ffe5313807cd2$var$GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = "gen_ai.output.messages";
const $211ffe5313807cd2$var$GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = "gen_ai.system_instructions";
const $211ffe5313807cd2$var$GEN_AI_RESPONSE_TEXT_ATTRIBUTE = "gen_ai.response.text";
const $211ffe5313807cd2$var$GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = "gen_ai.request.available_tools";
const $211ffe5313807cd2$var$GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = "gen_ai.response.streaming";
const $211ffe5313807cd2$var$GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = "gen_ai.response.tool_calls";
const $211ffe5313807cd2$var$GEN_AI_AGENT_NAME_ATTRIBUTE = "gen_ai.agent.name";
const $211ffe5313807cd2$var$GEN_AI_PIPELINE_NAME_ATTRIBUTE = "gen_ai.pipeline.name";
const $211ffe5313807cd2$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";
const $211ffe5313807cd2$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.cache_creation_input_tokens";
const $211ffe5313807cd2$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.cache_read_input_tokens";
const $211ffe5313807cd2$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = "gen_ai.usage.input_tokens.cache_write";
const $211ffe5313807cd2$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = "gen_ai.usage.input_tokens.cached";
const $211ffe5313807cd2$var$GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = "gen_ai.invoke_agent";
const $211ffe5313807cd2$var$GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = "gen_ai.embeddings.input";
const $211ffe5313807cd2$var$GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = "gen_ai.embeddings";
const $211ffe5313807cd2$var$GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = "gen_ai.execute_tool";
const $211ffe5313807cd2$var$GEN_AI_TOOL_NAME_ATTRIBUTE = "gen_ai.tool.name";
const $211ffe5313807cd2$var$GEN_AI_TOOL_CALL_ID_ATTRIBUTE = "gen_ai.tool.call.id";
const $211ffe5313807cd2$var$GEN_AI_TOOL_TYPE_ATTRIBUTE = "gen_ai.tool.type";
const $211ffe5313807cd2$var$GEN_AI_TOOL_INPUT_ATTRIBUTE = "gen_ai.tool.input";
const $211ffe5313807cd2$var$GEN_AI_TOOL_OUTPUT_ATTRIBUTE = "gen_ai.tool.output";
const $211ffe5313807cd2$var$GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = "gen_ai.tool.description";
module.exports.GEN_AI_AGENT_NAME_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_AGENT_NAME_ATTRIBUTE;
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE;
module.exports.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_INPUT_MESSAGES_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_INPUT_MESSAGES_ATTRIBUTE;
module.exports.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE;
module.exports.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_OPERATION_NAME_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_OPERATION_NAME_ATTRIBUTE;
module.exports.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE;
module.exports.GEN_AI_PIPELINE_NAME_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_PIPELINE_NAME_ATTRIBUTE;
module.exports.GEN_AI_PROMPT_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_PROMPT_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MODEL_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_REQUEST_MODEL_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_STREAM_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_REQUEST_STREAM_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TOP_K_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_REQUEST_TOP_K_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TOP_P_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_REQUEST_TOP_P_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_ID_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_RESPONSE_ID_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_MODEL_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_RESPONSE_MODEL_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_RESPONSE_STREAMING_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_TEXT_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_RESPONSE_TEXT_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_SYSTEM_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE;
module.exports.GEN_AI_TOOL_CALL_ID_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_TOOL_CALL_ID_ATTRIBUTE;
module.exports.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE;
module.exports.GEN_AI_TOOL_INPUT_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_TOOL_INPUT_ATTRIBUTE;
module.exports.GEN_AI_TOOL_NAME_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_TOOL_NAME_ATTRIBUTE;
module.exports.GEN_AI_TOOL_OUTPUT_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_TOOL_OUTPUT_ATTRIBUTE;
module.exports.GEN_AI_TOOL_TYPE_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_TOOL_TYPE_ATTRIBUTE;
module.exports.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE;
module.exports.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = $211ffe5313807cd2$var$GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE;

});

parcelRegister("jBz6V", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $knQ1Y = parcelRequire("knQ1Y");
const $e45cb54b499da9da$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = 2e4;
const $e45cb54b499da9da$var$utf8Bytes = (text)=>{
    return new TextEncoder().encode(text).length;
};
const $e45cb54b499da9da$var$jsonBytes = (value)=>{
    return $e45cb54b499da9da$var$utf8Bytes(JSON.stringify(value));
};
function $e45cb54b499da9da$var$truncateTextByBytes(text, maxBytes) {
    if ($e45cb54b499da9da$var$utf8Bytes(text) <= maxBytes) return text;
    let low = 0;
    let high = text.length;
    let bestFit = "";
    while(low <= high){
        const mid = Math.floor((low + high) / 2);
        const candidate = text.slice(0, mid);
        const byteSize = $e45cb54b499da9da$var$utf8Bytes(candidate);
        if (byteSize <= maxBytes) {
            bestFit = candidate;
            low = mid + 1;
        } else high = mid - 1;
    }
    return bestFit;
}
function $e45cb54b499da9da$var$getItemText(item) {
    if (typeof item === "string") return item;
    if ("text" in item && typeof item.text === "string") return item.text;
    return "";
}
function $e45cb54b499da9da$var$withItemText(item, text) {
    if (typeof item === "string") return text;
    return {
        ...item,
        text: text
    };
}
function $e45cb54b499da9da$var$isContentMessage(message) {
    return message !== null && typeof message === "object" && "content" in message && typeof message.content === "string";
}
function $e45cb54b499da9da$var$isContentArrayMessage(message) {
    return message !== null && typeof message === "object" && "content" in message && Array.isArray(message.content);
}
function $e45cb54b499da9da$var$isPartsMessage(message) {
    return message !== null && typeof message === "object" && "parts" in message && Array.isArray(message.parts) && message.parts.length > 0;
}
function $e45cb54b499da9da$var$truncateContentMessage(message, maxBytes) {
    const emptyMessage = {
        ...message,
        content: ""
    };
    const overhead = $e45cb54b499da9da$var$jsonBytes(emptyMessage);
    const availableForContent = maxBytes - overhead;
    if (availableForContent <= 0) return [];
    const truncatedContent = $e45cb54b499da9da$var$truncateTextByBytes(message.content, availableForContent);
    return [
        {
            ...message,
            content: truncatedContent
        }
    ];
}
function $e45cb54b499da9da$var$getArrayItems(message) {
    if ("parts" in message && Array.isArray(message.parts)) return {
        key: "parts",
        items: message.parts
    };
    if ("content" in message && Array.isArray(message.content)) return {
        key: "content",
        items: message.content
    };
    return {
        key: null,
        items: []
    };
}
function $e45cb54b499da9da$var$truncateArrayMessage(message, maxBytes) {
    const { key: key, items: items } = $e45cb54b499da9da$var$getArrayItems(message);
    if (key === null || items.length === 0) return [];
    const emptyItems = items.map((item)=>$e45cb54b499da9da$var$withItemText(item, ""));
    const overhead = $e45cb54b499da9da$var$jsonBytes({
        ...message,
        [key]: emptyItems
    });
    let remainingBytes = maxBytes - overhead;
    if (remainingBytes <= 0) return [];
    const includedItems = [];
    for (const item of items){
        const text = $e45cb54b499da9da$var$getItemText(item);
        const textSize = $e45cb54b499da9da$var$utf8Bytes(text);
        if (textSize <= remainingBytes) {
            includedItems.push(item);
            remainingBytes -= textSize;
        } else if (includedItems.length === 0) {
            const truncated = $e45cb54b499da9da$var$truncateTextByBytes(text, remainingBytes);
            if (truncated) includedItems.push($e45cb54b499da9da$var$withItemText(item, truncated));
            break;
        } else break;
    }
    if (includedItems.length <= 0) return [];
    else return [
        {
            ...message,
            [key]: includedItems
        }
    ];
}
function $e45cb54b499da9da$var$truncateSingleMessage(message, maxBytes) {
    if (!message) return [];
    if (typeof message === "string") {
        const truncated = $e45cb54b499da9da$var$truncateTextByBytes(message, maxBytes);
        return truncated ? [
            truncated
        ] : [];
    }
    if (typeof message !== "object") return [];
    if ($e45cb54b499da9da$var$isContentMessage(message)) return $e45cb54b499da9da$var$truncateContentMessage(message, maxBytes);
    if ($e45cb54b499da9da$var$isContentArrayMessage(message) || $e45cb54b499da9da$var$isPartsMessage(message)) return $e45cb54b499da9da$var$truncateArrayMessage(message, maxBytes);
    return [];
}
function $e45cb54b499da9da$var$stripInlineMediaFromMessages(messages) {
    const stripped = messages.map((message)=>{
        let newMessage = void 0;
        if (!!message && typeof message === "object") {
            if ($e45cb54b499da9da$var$isContentArrayMessage(message)) newMessage = {
                ...message,
                content: $e45cb54b499da9da$var$stripInlineMediaFromMessages(message.content)
            };
            else if ("content" in message && $knQ1Y.isContentMedia(message.content)) newMessage = {
                ...message,
                content: $knQ1Y.stripInlineMediaFromSingleMessage(message.content)
            };
            if ($e45cb54b499da9da$var$isPartsMessage(message)) newMessage = {
                // might have to strip content AND parts
                ...newMessage ?? message,
                parts: $e45cb54b499da9da$var$stripInlineMediaFromMessages(message.parts)
            };
            if ($knQ1Y.isContentMedia(newMessage)) newMessage = $knQ1Y.stripInlineMediaFromSingleMessage(newMessage);
            else if ($knQ1Y.isContentMedia(message)) newMessage = $knQ1Y.stripInlineMediaFromSingleMessage(message);
        }
        return newMessage ?? message;
    });
    return stripped;
}
function $e45cb54b499da9da$var$truncateMessagesByBytes(messages, maxBytes) {
    if (!Array.isArray(messages) || messages.length === 0) return messages;
    const effectiveMaxBytes = maxBytes - 2;
    const lastMessage = messages[messages.length - 1];
    const stripped = $e45cb54b499da9da$var$stripInlineMediaFromMessages([
        lastMessage
    ]);
    const strippedMessage = stripped[0];
    const messageBytes = $e45cb54b499da9da$var$jsonBytes(strippedMessage);
    if (messageBytes <= effectiveMaxBytes) return stripped;
    return $e45cb54b499da9da$var$truncateSingleMessage(strippedMessage, effectiveMaxBytes);
}
function $e45cb54b499da9da$var$truncateGenAiMessages(messages) {
    return $e45cb54b499da9da$var$truncateMessagesByBytes(messages, $e45cb54b499da9da$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
function $e45cb54b499da9da$var$truncateGenAiStringInput(input) {
    return $e45cb54b499da9da$var$truncateTextByBytes(input, $e45cb54b499da9da$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
module.exports.DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = $e45cb54b499da9da$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT;
module.exports.truncateGenAiMessages = $e45cb54b499da9da$var$truncateGenAiMessages;
module.exports.truncateGenAiStringInput = $e45cb54b499da9da$var$truncateGenAiStringInput;

});
parcelRegister("knQ1Y", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $ed6e50dd2fe670a5$var$isContentMedia(part) {
    if (!part || typeof part !== "object") return false;
    return $ed6e50dd2fe670a5$var$isContentMediaSource(part) || $ed6e50dd2fe670a5$var$hasInlineData(part) || $ed6e50dd2fe670a5$var$hasImageUrl(part) || $ed6e50dd2fe670a5$var$hasInputAudio(part) || $ed6e50dd2fe670a5$var$hasFileData(part) || $ed6e50dd2fe670a5$var$hasMediaTypeData(part) || $ed6e50dd2fe670a5$var$hasVercelFileData(part) || $ed6e50dd2fe670a5$var$hasVercelImageData(part) || $ed6e50dd2fe670a5$var$hasBlobOrBase64Type(part) || $ed6e50dd2fe670a5$var$hasB64Json(part) || $ed6e50dd2fe670a5$var$hasImageGenerationResult(part) || $ed6e50dd2fe670a5$var$hasDataUri(part);
}
function $ed6e50dd2fe670a5$var$hasImageUrl(part) {
    if (!("image_url" in part)) return false;
    if (typeof part.image_url === "string") return part.image_url.startsWith("data:");
    return $ed6e50dd2fe670a5$var$hasNestedImageUrl(part);
}
function $ed6e50dd2fe670a5$var$hasNestedImageUrl(part) {
    return "image_url" in part && !!part.image_url && typeof part.image_url === "object" && "url" in part.image_url && typeof part.image_url.url === "string" && part.image_url.url.startsWith("data:");
}
function $ed6e50dd2fe670a5$var$isContentMediaSource(part) {
    return "type" in part && typeof part.type === "string" && "source" in part && $ed6e50dd2fe670a5$var$isContentMedia(part.source);
}
function $ed6e50dd2fe670a5$var$hasInlineData(part) {
    return "inlineData" in part && !!part.inlineData && typeof part.inlineData === "object" && "data" in part.inlineData && typeof part.inlineData.data === "string";
}
function $ed6e50dd2fe670a5$var$hasInputAudio(part) {
    return "type" in part && part.type === "input_audio" && "input_audio" in part && !!part.input_audio && typeof part.input_audio === "object" && "data" in part.input_audio && typeof part.input_audio.data === "string";
}
function $ed6e50dd2fe670a5$var$hasFileData(part) {
    return "type" in part && part.type === "file" && "file" in part && !!part.file && typeof part.file === "object" && "file_data" in part.file && typeof part.file.file_data === "string";
}
function $ed6e50dd2fe670a5$var$hasMediaTypeData(part) {
    return "media_type" in part && typeof part.media_type === "string" && "data" in part;
}
function $ed6e50dd2fe670a5$var$hasVercelFileData(part) {
    return "type" in part && part.type === "file" && "mediaType" in part && typeof part.mediaType === "string" && "data" in part && typeof part.data === "string" && // Only strip base64/binary data, not HTTP/HTTPS URLs which should be preserved as references
    !part.data.startsWith("http://") && !part.data.startsWith("https://");
}
function $ed6e50dd2fe670a5$var$hasVercelImageData(part) {
    return "type" in part && part.type === "image" && "image" in part && typeof part.image === "string" && // Only strip base64/data URIs, not HTTP/HTTPS URLs which should be preserved as references
    !part.image.startsWith("http://") && !part.image.startsWith("https://");
}
function $ed6e50dd2fe670a5$var$hasBlobOrBase64Type(part) {
    return "type" in part && (part.type === "blob" || part.type === "base64");
}
function $ed6e50dd2fe670a5$var$hasB64Json(part) {
    return "b64_json" in part;
}
function $ed6e50dd2fe670a5$var$hasImageGenerationResult(part) {
    return "type" in part && "result" in part && part.type === "image_generation";
}
function $ed6e50dd2fe670a5$var$hasDataUri(part) {
    return "uri" in part && typeof part.uri === "string" && part.uri.startsWith("data:");
}
const $ed6e50dd2fe670a5$var$REMOVED_STRING = "[Blob substitute]";
const $ed6e50dd2fe670a5$var$MEDIA_FIELDS = [
    "image_url",
    "data",
    "content",
    "b64_json",
    "result",
    "uri",
    "image"
];
function $ed6e50dd2fe670a5$var$stripInlineMediaFromSingleMessage(part) {
    const strip = {
        ...part
    };
    if ($ed6e50dd2fe670a5$var$isContentMedia(strip.source)) strip.source = $ed6e50dd2fe670a5$var$stripInlineMediaFromSingleMessage(strip.source);
    if ($ed6e50dd2fe670a5$var$hasInlineData(part)) strip.inlineData = {
        ...part.inlineData,
        data: $ed6e50dd2fe670a5$var$REMOVED_STRING
    };
    if ($ed6e50dd2fe670a5$var$hasNestedImageUrl(part)) strip.image_url = {
        ...part.image_url,
        url: $ed6e50dd2fe670a5$var$REMOVED_STRING
    };
    if ($ed6e50dd2fe670a5$var$hasInputAudio(part)) strip.input_audio = {
        ...part.input_audio,
        data: $ed6e50dd2fe670a5$var$REMOVED_STRING
    };
    if ($ed6e50dd2fe670a5$var$hasFileData(part)) strip.file = {
        ...part.file,
        file_data: $ed6e50dd2fe670a5$var$REMOVED_STRING
    };
    for (const field of $ed6e50dd2fe670a5$var$MEDIA_FIELDS)if (typeof strip[field] === "string") strip[field] = $ed6e50dd2fe670a5$var$REMOVED_STRING;
    return strip;
}
module.exports.isContentMedia = $ed6e50dd2fe670a5$var$isContentMedia;
module.exports.stripInlineMediaFromSingleMessage = $ed6e50dd2fe670a5$var$stripInlineMediaFromSingleMessage;

});



parcelRegister("2glvn", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $1a5dc1d6d3477a1f$var$WORKERS_AI_PROVIDER_NAME = "cloudflare.workers_ai";
const $1a5dc1d6d3477a1f$var$WORKERS_AI_ORIGIN = "auto.ai.cloudflare.workers_ai";
const $1a5dc1d6d3477a1f$var$WORKERS_AI_INTEGRATION_NAME = "WorkersAI";
module.exports.WORKERS_AI_INTEGRATION_NAME = $1a5dc1d6d3477a1f$var$WORKERS_AI_INTEGRATION_NAME;
module.exports.WORKERS_AI_ORIGIN = $1a5dc1d6d3477a1f$var$WORKERS_AI_ORIGIN;
module.exports.WORKERS_AI_PROVIDER_NAME = $1a5dc1d6d3477a1f$var$WORKERS_AI_PROVIDER_NAME;

});

parcelRegister("1eeiu", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $0e52306147ba90fe$var$toolCallSpanContextMap = /* @__PURE__ */ new Map();
const $0e52306147ba90fe$var$toolDescriptionMap = /* @__PURE__ */ new Map();
const $0e52306147ba90fe$var$SPAN_TO_OPERATION_NAME = /* @__PURE__ */ new Map([
    [
        "ai.generateText",
        "invoke_agent"
    ],
    [
        "ai.streamText",
        "invoke_agent"
    ],
    [
        "ai.generateObject",
        "invoke_agent"
    ],
    [
        "ai.streamObject",
        "invoke_agent"
    ],
    [
        "ai.generateText.doGenerate",
        "generate_content"
    ],
    [
        "ai.streamText.doStream",
        "generate_content"
    ],
    [
        "ai.generateObject.doGenerate",
        "generate_content"
    ],
    [
        "ai.streamObject.doStream",
        "generate_content"
    ],
    [
        "ai.embed.doEmbed",
        "embeddings"
    ],
    [
        "ai.embedMany.doEmbed",
        "embeddings"
    ],
    [
        "ai.rerank.doRerank",
        "rerank"
    ],
    [
        "ai.toolCall",
        "execute_tool"
    ]
]);
module.exports.SPAN_TO_OPERATION_NAME = $0e52306147ba90fe$var$SPAN_TO_OPERATION_NAME;
module.exports.toolCallSpanContextMap = $0e52306147ba90fe$var$toolCallSpanContextMap;
module.exports.toolDescriptionMap = $0e52306147ba90fe$var$toolDescriptionMap;

});

parcelRegister("gXfFT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2Qk3n = parcelRequire("2Qk3n");

var $5mc1N = parcelRequire("5mc1N");

var $1L2sM = parcelRequire("1L2sM");

var $1eeiu = parcelRequire("1eeiu");

var $aGmMO = parcelRequire("aGmMO");
function $c57e50b70dd84c17$var$accumulateTokensForParent(span, tokenAccumulator) {
    const parentSpanId = span.parent_span_id;
    if (!parentSpanId) return;
    const inputTokens = span.data[$2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    const outputTokens = span.data[$2Qk3n.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE];
    if (typeof inputTokens === "number" || typeof outputTokens === "number") {
        const existing = tokenAccumulator.get(parentSpanId) || {
            inputTokens: 0,
            outputTokens: 0
        };
        if (typeof inputTokens === "number") existing.inputTokens += inputTokens;
        if (typeof outputTokens === "number") existing.outputTokens += outputTokens;
        tokenAccumulator.set(parentSpanId, existing);
    }
}
function $c57e50b70dd84c17$var$applyAccumulatedTokens(spanOrTrace, tokenAccumulator) {
    const accumulated = tokenAccumulator.get(spanOrTrace.span_id);
    if (!accumulated || !spanOrTrace.data) return;
    if (accumulated.inputTokens > 0) spanOrTrace.data[$2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = accumulated.inputTokens;
    if (accumulated.outputTokens > 0) spanOrTrace.data[$2Qk3n.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = accumulated.outputTokens;
    if (accumulated.inputTokens > 0 || accumulated.outputTokens > 0) spanOrTrace.data["gen_ai.usage.total_tokens"] = accumulated.inputTokens + accumulated.outputTokens;
}
function $c57e50b70dd84c17$var$buildToolDescriptionMap(spans) {
    const toolDescriptions = /* @__PURE__ */ new Map();
    for (const span of spans){
        const availableTools = span.data[$2Qk3n.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE];
        if (typeof availableTools !== "string") continue;
        try {
            const tools = JSON.parse(availableTools);
            for (const tool of tools)if (tool.name && tool.description && !toolDescriptions.has(tool.name)) toolDescriptions.set(tool.name, tool.description);
        } catch  {}
    }
    return toolDescriptions;
}
function $c57e50b70dd84c17$var$applyToolDescriptionsAndTokens(spans, tokenAccumulator) {
    const toolDescriptions = $c57e50b70dd84c17$var$buildToolDescriptionMap(spans);
    for (const span of spans){
        if (span.op === "gen_ai.execute_tool") {
            const toolName = span.data[$2Qk3n.GEN_AI_TOOL_NAME_ATTRIBUTE];
            if (typeof toolName === "string") {
                const description = toolDescriptions.get(toolName);
                if (description) span.data[$2Qk3n.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = description;
            }
        }
        if (span.op === "gen_ai.invoke_agent") $c57e50b70dd84c17$var$applyAccumulatedTokens(span, tokenAccumulator);
    }
}
function $c57e50b70dd84c17$var$_INTERNAL_getSpanContextForToolCallId(toolCallId) {
    return $1eeiu.toolCallSpanContextMap.get(toolCallId);
}
function $c57e50b70dd84c17$var$_INTERNAL_cleanupToolCallSpanContext(toolCallId) {
    $1eeiu.toolCallSpanContextMap.delete(toolCallId);
}
function $c57e50b70dd84c17$var$convertAvailableToolsToJsonString(tools) {
    const toolObjects = tools.map((tool)=>{
        if (typeof tool === "string") try {
            return JSON.parse(tool);
        } catch  {
            return tool;
        }
        return tool;
    });
    return JSON.stringify(toolObjects);
}
function $c57e50b70dd84c17$var$filterMessagesArray(input) {
    return input.filter((m)=>!!m && typeof m === "object" && "role" in m && "content" in m);
}
function $c57e50b70dd84c17$var$convertUserInputToMessagesFormat(userInput) {
    try {
        const p = JSON.parse(userInput);
        if (!!p && typeof p === "object") {
            let { messages: messages } = p;
            const { prompt: prompt, system: system } = p;
            const result = [];
            if (typeof system === "string") result.push({
                role: "system",
                content: system
            });
            if (typeof messages === "string") try {
                messages = JSON.parse(messages);
            } catch  {}
            if (Array.isArray(messages)) {
                result.push(...$c57e50b70dd84c17$var$filterMessagesArray(messages));
                return result;
            }
            if (Array.isArray(prompt)) {
                result.push(...$c57e50b70dd84c17$var$filterMessagesArray(prompt));
                return result;
            }
            if (typeof prompt === "string") result.push({
                role: "user",
                content: prompt
            });
            if (result.length > 0) return result;
        }
    } catch  {}
    return [];
}
function $c57e50b70dd84c17$var$requestMessagesFromPrompt(span, attributes, enableTruncation) {
    if (typeof attributes[$aGmMO.AI_PROMPT_ATTRIBUTE] === "string" && !attributes[$2Qk3n.GEN_AI_INPUT_MESSAGES_ATTRIBUTE] && !attributes[$aGmMO.AI_PROMPT_MESSAGES_ATTRIBUTE]) {
        const userInput = attributes[$aGmMO.AI_PROMPT_ATTRIBUTE];
        const messages = $c57e50b70dd84c17$var$convertUserInputToMessagesFormat(userInput);
        if (messages.length) {
            const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $5mc1N.extractSystemInstructions(messages);
            if (systemInstructions) span.setAttribute($2Qk3n.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
            const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
            const messagesJson = enableTruncation ? $5mc1N.getTruncatedJsonString(filteredMessages) : $1L2sM.stringify(filteredMessages);
            span.setAttributes({
                [$aGmMO.AI_PROMPT_ATTRIBUTE]: messagesJson,
                [$2Qk3n.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
                [$2Qk3n.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
            });
        }
    } else if (typeof attributes[$aGmMO.AI_PROMPT_MESSAGES_ATTRIBUTE] === "string") {
        const originalMessagesJson = attributes[$aGmMO.AI_PROMPT_MESSAGES_ATTRIBUTE];
        try {
            const messages = JSON.parse(originalMessagesJson);
            if (Array.isArray(messages)) {
                const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $5mc1N.extractSystemInstructions(messages);
                if (systemInstructions) span.setAttribute($2Qk3n.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
                const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
                const messagesJson = !enableTruncation && filteredMessages === messages ? originalMessagesJson : enableTruncation ? $5mc1N.getTruncatedJsonString(filteredMessages) : $1L2sM.stringify(filteredMessages);
                span.setAttributes({
                    [$aGmMO.AI_PROMPT_MESSAGES_ATTRIBUTE]: messagesJson,
                    [$2Qk3n.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
                    [$2Qk3n.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
                });
            }
        } catch  {}
    }
}
module.exports._INTERNAL_cleanupToolCallSpanContext = $c57e50b70dd84c17$var$_INTERNAL_cleanupToolCallSpanContext;
module.exports._INTERNAL_getSpanContextForToolCallId = $c57e50b70dd84c17$var$_INTERNAL_getSpanContextForToolCallId;
module.exports.accumulateTokensForParent = $c57e50b70dd84c17$var$accumulateTokensForParent;
module.exports.applyAccumulatedTokens = $c57e50b70dd84c17$var$applyAccumulatedTokens;
module.exports.applyToolDescriptionsAndTokens = $c57e50b70dd84c17$var$applyToolDescriptionsAndTokens;
module.exports.convertAvailableToolsToJsonString = $c57e50b70dd84c17$var$convertAvailableToolsToJsonString;
module.exports.convertUserInputToMessagesFormat = $c57e50b70dd84c17$var$convertUserInputToMessagesFormat;
module.exports.requestMessagesFromPrompt = $c57e50b70dd84c17$var$requestMessagesFromPrompt;

});
parcelRegister("aGmMO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $7c6f8080b9a283bb$var$OPERATION_NAME_ATTRIBUTE = "operation.name";
const $7c6f8080b9a283bb$var$AI_OPERATION_ID_ATTRIBUTE = "ai.operationId";
const $7c6f8080b9a283bb$var$AI_PROMPT_ATTRIBUTE = "ai.prompt";
const $7c6f8080b9a283bb$var$AI_SCHEMA_ATTRIBUTE = "ai.schema";
const $7c6f8080b9a283bb$var$AI_RESPONSE_OBJECT_ATTRIBUTE = "ai.response.object";
const $7c6f8080b9a283bb$var$AI_VALUES_ATTRIBUTE = "ai.values";
const $7c6f8080b9a283bb$var$AI_RESPONSE_TEXT_ATTRIBUTE = "ai.response.text";
const $7c6f8080b9a283bb$var$AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = "ai.response.toolCalls";
const $7c6f8080b9a283bb$var$AI_RESPONSE_FINISH_REASON_ATTRIBUTE = "ai.response.finishReason";
const $7c6f8080b9a283bb$var$AI_PROMPT_MESSAGES_ATTRIBUTE = "ai.prompt.messages";
const $7c6f8080b9a283bb$var$AI_PROMPT_TOOLS_ATTRIBUTE = "ai.prompt.tools";
const $7c6f8080b9a283bb$var$AI_MODEL_ID_ATTRIBUTE = "ai.model.id";
const $7c6f8080b9a283bb$var$AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = "ai.response.providerMetadata";
const $7c6f8080b9a283bb$var$AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = "ai.usage.cachedInputTokens";
const $7c6f8080b9a283bb$var$AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX = "ai.usage.inputTokenDetails.";
const $7c6f8080b9a283bb$var$AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = "ai.telemetry.functionId";
const $7c6f8080b9a283bb$var$AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = "ai.usage.completionTokens";
const $7c6f8080b9a283bb$var$AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = "ai.usage.promptTokens";
const $7c6f8080b9a283bb$var$AI_USAGE_TOKENS_ATTRIBUTE = "ai.usage.tokens";
const $7c6f8080b9a283bb$var$AI_TOOL_CALL_NAME_ATTRIBUTE = "ai.toolCall.name";
const $7c6f8080b9a283bb$var$AI_TOOL_CALL_ID_ATTRIBUTE = "ai.toolCall.id";
const $7c6f8080b9a283bb$var$AI_TOOL_CALL_ARGS_ATTRIBUTE = "ai.toolCall.args";
const $7c6f8080b9a283bb$var$AI_TOOL_CALL_RESULT_ATTRIBUTE = "ai.toolCall.result";
module.exports.AI_MODEL_ID_ATTRIBUTE = $7c6f8080b9a283bb$var$AI_MODEL_ID_ATTRIBUTE;
module.exports.AI_OPERATION_ID_ATTRIBUTE = $7c6f8080b9a283bb$var$AI_OPERATION_ID_ATTRIBUTE;
module.exports.AI_PROMPT_ATTRIBUTE = $7c6f8080b9a283bb$var$AI_PROMPT_ATTRIBUTE;
module.exports.AI_PROMPT_MESSAGES_ATTRIBUTE = $7c6f8080b9a283bb$var$AI_PROMPT_MESSAGES_ATTRIBUTE;
module.exports.AI_PROMPT_TOOLS_ATTRIBUTE = $7c6f8080b9a283bb$var$AI_PROMPT_TOOLS_ATTRIBUTE;
module.exports.AI_RESPONSE_FINISH_REASON_ATTRIBUTE = $7c6f8080b9a283bb$var$AI_RESPONSE_FINISH_REASON_ATTRIBUTE;
module.exports.AI_RESPONSE_OBJECT_ATTRIBUTE = $7c6f8080b9a283bb$var$AI_RESPONSE_OBJECT_ATTRIBUTE;
module.exports.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = $7c6f8080b9a283bb$var$AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE;
module.exports.AI_RESPONSE_TEXT_ATTRIBUTE = $7c6f8080b9a283bb$var$AI_RESPONSE_TEXT_ATTRIBUTE;
module.exports.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = $7c6f8080b9a283bb$var$AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
module.exports.AI_SCHEMA_ATTRIBUTE = $7c6f8080b9a283bb$var$AI_SCHEMA_ATTRIBUTE;
module.exports.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = $7c6f8080b9a283bb$var$AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE;
module.exports.AI_TOOL_CALL_ARGS_ATTRIBUTE = $7c6f8080b9a283bb$var$AI_TOOL_CALL_ARGS_ATTRIBUTE;
module.exports.AI_TOOL_CALL_ID_ATTRIBUTE = $7c6f8080b9a283bb$var$AI_TOOL_CALL_ID_ATTRIBUTE;
module.exports.AI_TOOL_CALL_NAME_ATTRIBUTE = $7c6f8080b9a283bb$var$AI_TOOL_CALL_NAME_ATTRIBUTE;
module.exports.AI_TOOL_CALL_RESULT_ATTRIBUTE = $7c6f8080b9a283bb$var$AI_TOOL_CALL_RESULT_ATTRIBUTE;
module.exports.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = $7c6f8080b9a283bb$var$AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = $7c6f8080b9a283bb$var$AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX = $7c6f8080b9a283bb$var$AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX;
module.exports.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = $7c6f8080b9a283bb$var$AI_USAGE_PROMPT_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_TOKENS_ATTRIBUTE = $7c6f8080b9a283bb$var$AI_USAGE_TOKENS_ATTRIBUTE;
module.exports.AI_VALUES_ATTRIBUTE = $7c6f8080b9a283bb$var$AI_VALUES_ATTRIBUTE;
module.exports.OPERATION_NAME_ATTRIBUTE = $7c6f8080b9a283bb$var$OPERATION_NAME_ATTRIBUTE;

});



parcelRegister("ccsii", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1GyI0 = parcelRequire("1GyI0");

var $2JysJ = parcelRequire("2JysJ");

var $2sm2V = parcelRequire("2sm2V");

var $1L2sM = parcelRequire("1L2sM");

var $d33W7 = parcelRequire("d33W7");

var $aewmo = parcelRequire("aewmo");

var $2Qk3n = parcelRequire("2Qk3n");

var $5mc1N = parcelRequire("5mc1N");

var $esm0I = parcelRequire("esm0I");

var $040Dp = parcelRequire("040Dp");

var $jI0wg = parcelRequire("jI0wg");
function $8e1c8da8d2523651$var$extractAvailableTools(params) {
    const tools = Array.isArray(params.tools) ? params.tools : [];
    const hasWebSearchOptions = params.web_search_options && typeof params.web_search_options === "object";
    const webSearchOptions = hasWebSearchOptions ? [
        {
            type: "web_search_options",
            ...params.web_search_options
        }
    ] : [];
    const availableTools = [
        ...tools,
        ...webSearchOptions
    ];
    if (availableTools.length === 0) return void 0;
    try {
        return JSON.stringify(availableTools);
    } catch (error) {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.error("Failed to serialize OpenAI tools:", error);
        return void 0;
    }
}
function $8e1c8da8d2523651$var$extractRequestAttributes(args, operationName) {
    const attributes = {
        [$2Qk3n.GEN_AI_SYSTEM_ATTRIBUTE]: "openai",
        [$2Qk3n.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.openai"
    };
    if (args.length > 0 && typeof args[0] === "object" && args[0] !== null) {
        const params = args[0];
        const availableTools = $8e1c8da8d2523651$var$extractAvailableTools(params);
        if (availableTools) attributes[$2Qk3n.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = availableTools;
        Object.assign(attributes, $jI0wg.extractRequestParameters(params));
    } else attributes[$2Qk3n.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = "unknown";
    return attributes;
}
function $8e1c8da8d2523651$var$addRequestAttributes(span, params, operationName, enableTruncation) {
    if (operationName === "embeddings" && "input" in params) {
        const input = params.input;
        if (input == null) return;
        if (typeof input === "string" && input.length === 0) return;
        if (Array.isArray(input) && input.length === 0) return;
        span.setAttribute($2Qk3n.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE, typeof input === "string" ? input : JSON.stringify(input));
        return;
    }
    const src = "input" in params ? params.input : "messages" in params ? params.messages : void 0;
    if (!src) return;
    if (Array.isArray(src) && src.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $5mc1N.extractSystemInstructions(src);
    if (systemInstructions) span.setAttribute($2Qk3n.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
    span.setAttribute($2Qk3n.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $5mc1N.getTruncatedJsonString(filteredMessages) : $1L2sM.stringify(filteredMessages));
    if (Array.isArray(filteredMessages)) span.setAttribute($2Qk3n.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredMessages.length);
    else span.setAttribute($2Qk3n.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, 1);
}
function $8e1c8da8d2523651$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return function instrumentedCall(...args) {
        const operationName = instrumentedMethod.operation || "unknown";
        const requestAttributes = $8e1c8da8d2523651$var$extractRequestAttributes(args, operationName);
        const model = requestAttributes[$2Qk3n.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || "unknown";
        const params = args[0];
        const isStreamRequested = params && typeof params === "object" && params.stream === true;
        const spanConfig = {
            name: `${operationName} ${model}`,
            op: `gen_ai.${operationName}`,
            attributes: requestAttributes
        };
        if (isStreamRequested) {
            let originalResult2;
            const instrumentedPromise2 = $aewmo.startSpanManual(spanConfig, (span)=>{
                originalResult2 = originalMethod.apply(context, args);
                if (options.recordInputs && params) $8e1c8da8d2523651$var$addRequestAttributes(span, params, operationName, $5mc1N.shouldEnableTruncation(options.enableTruncation));
                return (async ()=>{
                    try {
                        const result = await originalResult2;
                        return $040Dp.instrumentStream(result, span, options.recordOutputs ?? false);
                    } catch (error) {
                        span.setStatus({
                            code: $d33W7.SPAN_STATUS_ERROR,
                            message: "internal_error"
                        });
                        span.end();
                        throw error;
                    }
                })();
            });
            return $5mc1N.wrapPromiseWithMethods(originalResult2, instrumentedPromise2);
        }
        let originalResult;
        const instrumentedPromise = $aewmo.startSpan(spanConfig, (span)=>{
            originalResult = originalMethod.apply(context, args);
            if (options.recordInputs && params) $8e1c8da8d2523651$var$addRequestAttributes(span, params, operationName, $5mc1N.shouldEnableTruncation(options.enableTruncation));
            return originalResult.then((result)=>{
                $jI0wg.addResponseAttributes(span, result, options.recordOutputs);
                return result;
            });
        });
        return $5mc1N.wrapPromiseWithMethods(originalResult, instrumentedPromise);
    };
}
function $8e1c8da8d2523651$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get (obj, prop) {
            const value = obj[prop];
            const methodPath = $5mc1N.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $esm0I.OPENAI_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) return $8e1c8da8d2523651$var$instrumentMethod(value, methodPath, instrumentedMethod, obj, options);
            if (typeof value === "function") return value.bind(obj);
            if (value && typeof value === "object") return $8e1c8da8d2523651$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $8e1c8da8d2523651$var$instrumentOpenAiClient(client, options) {
    return $8e1c8da8d2523651$var$createDeepProxy(client, "", $5mc1N.resolveAIRecordingOptions(options));
}
module.exports.addRequestAttributes = $8e1c8da8d2523651$var$addRequestAttributes;
module.exports.extractRequestAttributes = $8e1c8da8d2523651$var$extractRequestAttributes;
module.exports.instrumentOpenAiClient = $8e1c8da8d2523651$var$instrumentOpenAiClient;

});
parcelRegister("esm0I", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $a864c10ea7575d5f$var$OPENAI_INTEGRATION_NAME = "OpenAI";
const $a864c10ea7575d5f$var$OPENAI_METHOD_REGISTRY = {
    "responses.create": {
        operation: "chat"
    },
    "chat.completions.create": {
        operation: "chat"
    },
    "embeddings.create": {
        operation: "embeddings"
    },
    // Conversations API - for conversation state management
    // https://platform.openai.com/docs/guides/conversation-state
    "conversations.create": {
        operation: "chat"
    }
};
const $a864c10ea7575d5f$var$RESPONSES_TOOL_CALL_EVENT_TYPES = [
    "response.output_item.added",
    "response.function_call_arguments.delta",
    "response.function_call_arguments.done",
    "response.output_item.done"
];
const $a864c10ea7575d5f$var$RESPONSE_EVENT_TYPES = [
    "response.created",
    "response.in_progress",
    "response.failed",
    "response.completed",
    "response.incomplete",
    "response.queued",
    "response.output_text.delta",
    ...$a864c10ea7575d5f$var$RESPONSES_TOOL_CALL_EVENT_TYPES
];
module.exports.OPENAI_INTEGRATION_NAME = $a864c10ea7575d5f$var$OPENAI_INTEGRATION_NAME;
module.exports.OPENAI_METHOD_REGISTRY = $a864c10ea7575d5f$var$OPENAI_METHOD_REGISTRY;
module.exports.RESPONSES_TOOL_CALL_EVENT_TYPES = $a864c10ea7575d5f$var$RESPONSES_TOOL_CALL_EVENT_TYPES;
module.exports.RESPONSE_EVENT_TYPES = $a864c10ea7575d5f$var$RESPONSE_EVENT_TYPES;

});

parcelRegister("040Dp", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aK1wS = parcelRequire("aK1wS");

var $d33W7 = parcelRequire("d33W7");

var $5mc1N = parcelRequire("5mc1N");

var $esm0I = parcelRequire("esm0I");

var $jI0wg = parcelRequire("jI0wg");
function $00c0ddde657e0f6d$var$processChatCompletionToolCalls(toolCalls, state) {
    for (const toolCall of toolCalls){
        const index = toolCall.index;
        if (index === void 0 || !toolCall.function) continue;
        if (!(index in state.chatCompletionToolCalls)) state.chatCompletionToolCalls[index] = {
            ...toolCall,
            function: {
                name: toolCall.function.name,
                arguments: toolCall.function.arguments || ""
            }
        };
        else {
            const existingToolCall = state.chatCompletionToolCalls[index];
            if (toolCall.function.arguments && existingToolCall?.function) existingToolCall.function.arguments += toolCall.function.arguments;
        }
    }
}
function $00c0ddde657e0f6d$var$processChatCompletionChunk(chunk, state, recordOutputs) {
    state.responseId = chunk.id ?? state.responseId;
    state.responseModel = chunk.model ?? state.responseModel;
    if (chunk.usage) {
        state.promptTokens = chunk.usage.prompt_tokens;
        state.completionTokens = chunk.usage.completion_tokens;
        state.totalTokens = chunk.usage.total_tokens;
    }
    for (const choice of chunk.choices ?? []){
        if (recordOutputs) {
            if (choice.delta?.content) state.responseTexts.push(choice.delta.content);
            if (choice.delta?.tool_calls) $00c0ddde657e0f6d$var$processChatCompletionToolCalls(choice.delta.tool_calls, state);
        }
        if (choice.finish_reason) state.finishReasons.push(choice.finish_reason);
    }
}
function $00c0ddde657e0f6d$var$processResponsesApiEvent(streamEvent, state, recordOutputs, span) {
    if (!(streamEvent && typeof streamEvent === "object")) {
        state.eventTypes.push("unknown:non-object");
        return;
    }
    if (streamEvent instanceof Error) {
        span.setStatus({
            code: $d33W7.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        $aK1wS.captureException(streamEvent, {
            mechanism: {
                handled: false,
                type: "auto.ai.openai.stream-response"
            }
        });
        return;
    }
    if (!("type" in streamEvent)) return;
    const event = streamEvent;
    if (!$esm0I.RESPONSE_EVENT_TYPES.includes(event.type)) {
        state.eventTypes.push(event.type);
        return;
    }
    if (recordOutputs) {
        if (event.type === "response.output_item.done" && "item" in event) state.responsesApiToolCalls.push(event.item);
        if (event.type === "response.output_text.delta" && "delta" in event && event.delta) {
            state.responseTexts.push(event.delta);
            return;
        }
    }
    if ("response" in event) {
        const { response: response } = event;
        state.responseId = response.id ?? state.responseId;
        state.responseModel = response.model ?? state.responseModel;
        if (response.usage) {
            state.promptTokens = response.usage.input_tokens;
            state.completionTokens = response.usage.output_tokens;
            state.totalTokens = response.usage.total_tokens;
        }
        if (response.status) state.finishReasons.push(response.status);
        if (recordOutputs && response.output_text) state.responseTexts.push(response.output_text);
    }
}
async function* $00c0ddde657e0f6d$var$instrumentStream(stream, span, recordOutputs) {
    const state = {
        eventTypes: [],
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        totalTokens: void 0,
        chatCompletionToolCalls: {},
        responsesApiToolCalls: []
    };
    try {
        for await (const event of stream){
            if ($jI0wg.isChatCompletionChunk(event)) $00c0ddde657e0f6d$var$processChatCompletionChunk(event, state, recordOutputs);
            else if ($jI0wg.isResponsesApiStreamEvent(event)) $00c0ddde657e0f6d$var$processResponsesApiEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        const allToolCalls = [
            ...Object.values(state.chatCompletionToolCalls),
            ...state.responsesApiToolCalls
        ];
        $5mc1N.endStreamSpan(span, {
            ...state,
            toolCalls: allToolCalls
        }, recordOutputs);
    }
}
module.exports.instrumentStream = $00c0ddde657e0f6d$var$instrumentStream;

});
parcelRegister("jI0wg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2Qk3n = parcelRequire("2Qk3n");
function $e59287822464ff8c$var$isResponsesApiStreamEvent(event) {
    return event !== null && typeof event === "object" && "type" in event && typeof event.type === "string" && event.type.startsWith("response.");
}
function $e59287822464ff8c$var$isChatCompletionChunk(event) {
    return event !== null && typeof event === "object" && "object" in event && event.object === "chat.completion.chunk";
}
function $e59287822464ff8c$var$addResponseAttributes(span, result, recordOutputs) {
    if (!result || typeof result !== "object") return;
    const response = result;
    const attrs = {};
    if (typeof response.id === "string") attrs[$2Qk3n.GEN_AI_RESPONSE_ID_ATTRIBUTE] = response.id;
    if (typeof response.model === "string") attrs[$2Qk3n.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = response.model;
    if (response.object === "conversation" && typeof response.id === "string") attrs[$2Qk3n.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = response.id;
    if (response.usage && typeof response.usage === "object") {
        const usage = response.usage;
        const inputTokens = usage.prompt_tokens ?? usage.input_tokens;
        if (typeof inputTokens === "number") attrs[$2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = inputTokens;
        const outputTokens = usage.completion_tokens ?? usage.output_tokens;
        if (typeof outputTokens === "number") attrs[$2Qk3n.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = outputTokens;
        if (typeof usage.total_tokens === "number") attrs[$2Qk3n.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = usage.total_tokens;
    }
    if (Array.isArray(response.choices)) {
        const choices = response.choices;
        const finishReasons = choices.map((choice)=>choice.finish_reason).filter((reason)=>typeof reason === "string");
        if (finishReasons.length > 0) attrs[$2Qk3n.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(finishReasons);
        if (recordOutputs) {
            const responseTexts = choices.map((choice)=>{
                const message = choice.message;
                return message?.content || "";
            });
            attrs[$2Qk3n.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = JSON.stringify(responseTexts);
            const toolCalls = choices.map((choice)=>{
                const message = choice.message;
                return message?.tool_calls;
            }).filter((calls)=>Array.isArray(calls) && calls.length > 0).flat();
            if (toolCalls.length > 0) attrs[$2Qk3n.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(toolCalls);
        }
    }
    if (typeof response.status === "string") {
        if (!attrs[$2Qk3n.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE]) attrs[$2Qk3n.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify([
            response.status
        ]);
    }
    if (recordOutputs) {
        if (typeof response.output_text === "string" && !attrs[$2Qk3n.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]) attrs[$2Qk3n.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = response.output_text;
        if (Array.isArray(response.output) && response.output.length > 0 && !attrs[$2Qk3n.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]) {
            const functionCalls = response.output.filter((item)=>item?.type === "function_call");
            if (functionCalls.length > 0) attrs[$2Qk3n.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(functionCalls);
        }
    }
    span.setAttributes(attrs);
}
function $e59287822464ff8c$var$extractConversationId(params) {
    if ("conversation" in params && typeof params.conversation === "string") return params.conversation;
    if ("previous_response_id" in params && typeof params.previous_response_id === "string") return params.previous_response_id;
    return void 0;
}
function $e59287822464ff8c$var$extractRequestParameters(params) {
    const attributes = {
        [$2Qk3n.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: params.model ?? "unknown"
    };
    if ("temperature" in params) attributes[$2Qk3n.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
    if ("top_p" in params) attributes[$2Qk3n.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
    if ("frequency_penalty" in params) attributes[$2Qk3n.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
    if ("presence_penalty" in params) attributes[$2Qk3n.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = params.presence_penalty;
    if ("stream" in params) attributes[$2Qk3n.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
    if ("encoding_format" in params) attributes[$2Qk3n.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = params.encoding_format;
    if ("dimensions" in params) attributes[$2Qk3n.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = params.dimensions;
    const conversationId = $e59287822464ff8c$var$extractConversationId(params);
    if (conversationId) attributes[$2Qk3n.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = conversationId;
    return attributes;
}
module.exports.addResponseAttributes = $e59287822464ff8c$var$addResponseAttributes;
module.exports.extractRequestParameters = $e59287822464ff8c$var$extractRequestParameters;
module.exports.isChatCompletionChunk = $e59287822464ff8c$var$isChatCompletionChunk;
module.exports.isResponsesApiStreamEvent = $e59287822464ff8c$var$isResponsesApiStreamEvent;

});



parcelRegister("jSAP5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2JysJ = parcelRequire("2JysJ");

var $d33W7 = parcelRequire("d33W7");

var $aewmo = parcelRequire("aewmo");

var $2Qk3n = parcelRequire("2Qk3n");

var $5mc1N = parcelRequire("5mc1N");

var $b5qWi = parcelRequire("b5qWi");

var $gpDY4 = parcelRequire("gpDY4");

var $5gpss = parcelRequire("5gpss");
let $e78f9fc118bfd5a0$var$suppressDelegatedCreate = false;
const $e78f9fc118bfd5a0$var$INSTRUMENTED_METHODS = /* @__PURE__ */ new WeakSet();
function $e78f9fc118bfd5a0$var$extractRequestAttributes(args, methodPath, operationName) {
    const attributes = {
        [$2Qk3n.GEN_AI_SYSTEM_ATTRIBUTE]: "anthropic",
        [$2Qk3n.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.anthropic"
    };
    if (args.length > 0 && typeof args[0] === "object" && args[0] !== null) {
        const params = args[0];
        if (params.tools && Array.isArray(params.tools)) attributes[$2Qk3n.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(params.tools);
        attributes[$2Qk3n.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = params.model ?? "unknown";
        if ("temperature" in params) attributes[$2Qk3n.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
        if ("top_p" in params) attributes[$2Qk3n.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
        if ("stream" in params) attributes[$2Qk3n.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
        if ("top_k" in params) attributes[$2Qk3n.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = params.top_k;
        if ("frequency_penalty" in params) attributes[$2Qk3n.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
        if ("max_tokens" in params) attributes[$2Qk3n.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = params.max_tokens;
    } else if (methodPath === "models.retrieve" || methodPath === "models.get") attributes[$2Qk3n.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = args[0];
    else attributes[$2Qk3n.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = "unknown";
    return attributes;
}
function $e78f9fc118bfd5a0$var$addPrivateRequestAttributes(span, params, enableTruncation) {
    const messages = $5gpss.messagesFromParams(params);
    $5gpss.setMessagesAttribute(span, messages, enableTruncation);
    if ("prompt" in params) span.setAttributes({
        [$2Qk3n.GEN_AI_PROMPT_ATTRIBUTE]: JSON.stringify(params.prompt)
    });
}
function $e78f9fc118bfd5a0$var$addContentAttributes(span, response) {
    if ("content" in response) {
        if (Array.isArray(response.content)) {
            span.setAttributes({
                [$2Qk3n.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.content.map((item)=>item.text).filter((text)=>!!text).join("")
            });
            const toolCalls = [];
            for (const item of response.content)if (item.type === "tool_use" || item.type === "server_tool_use") toolCalls.push(item);
            if (toolCalls.length > 0) span.setAttributes({
                [$2Qk3n.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(toolCalls)
            });
        }
    }
    if ("completion" in response) span.setAttributes({
        [$2Qk3n.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.completion
    });
    if ("input_tokens" in response) span.setAttributes({
        [$2Qk3n.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: JSON.stringify(response.input_tokens)
    });
}
function $e78f9fc118bfd5a0$var$addMetadataAttributes(span, response) {
    if ("id" in response && "model" in response) {
        span.setAttributes({
            [$2Qk3n.GEN_AI_RESPONSE_ID_ATTRIBUTE]: response.id,
            [$2Qk3n.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]: response.model
        });
        if ("usage" in response && response.usage) $5mc1N.setTokenUsageAttributes(span, response.usage.input_tokens, response.usage.output_tokens, response.usage.cache_creation_input_tokens, response.usage.cache_read_input_tokens);
    }
}
function $e78f9fc118bfd5a0$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== "object") return;
    if ("type" in response && response.type === "error") {
        $5gpss.handleResponseError(span, response);
        return;
    }
    if (recordOutputs) $e78f9fc118bfd5a0$var$addContentAttributes(span, response);
    $e78f9fc118bfd5a0$var$addMetadataAttributes(span, response);
}
function $e78f9fc118bfd5a0$var$handleStreamingError(error, span) {
    if (span.isRecording()) {
        span.setStatus({
            code: $d33W7.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        span.end();
    }
    throw error;
}
function $e78f9fc118bfd5a0$var$handleStreamingRequest(target, invocationThis, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod) {
    const model = requestAttributes[$2Qk3n.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
    const spanConfig = {
        name: `${operationName} ${model}`,
        op: `gen_ai.${operationName}`,
        attributes: requestAttributes
    };
    if (isStreamRequested && !isStreamingMethod) {
        let originalResult;
        const instrumentedPromise = $aewmo.startSpanManual(spanConfig, (span)=>{
            originalResult = target.apply(invocationThis, args);
            if (options.recordInputs && params) $e78f9fc118bfd5a0$var$addPrivateRequestAttributes(span, params, $5mc1N.shouldEnableTruncation(options.enableTruncation));
            return (async ()=>{
                try {
                    const result = await originalResult;
                    return $gpDY4.instrumentAsyncIterableStream(result, span, options.recordOutputs ?? false);
                } catch (error) {
                    return $e78f9fc118bfd5a0$var$handleStreamingError(error, span);
                }
            })();
        });
        return $5mc1N.wrapPromiseWithMethods(originalResult, instrumentedPromise);
    } else return $aewmo.startSpanManual(spanConfig, (span)=>{
        try {
            if (options.recordInputs && params) $e78f9fc118bfd5a0$var$addPrivateRequestAttributes(span, params, $5mc1N.shouldEnableTruncation(options.enableTruncation));
            $e78f9fc118bfd5a0$var$suppressDelegatedCreate = true;
            const messageStream = target.apply(invocationThis, args);
            $e78f9fc118bfd5a0$var$suppressDelegatedCreate = false;
            return $gpDY4.instrumentMessageStream(messageStream, span, options.recordOutputs ?? false);
        } catch (error) {
            $e78f9fc118bfd5a0$var$suppressDelegatedCreate = false;
            return $e78f9fc118bfd5a0$var$handleStreamingError(error, span);
        }
    });
}
function $e78f9fc118bfd5a0$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            const invocationThis = thisArg !== void 0 ? thisArg : context;
            const isStreamingMethod = instrumentedMethod.streaming === true;
            if (!isStreamingMethod && $e78f9fc118bfd5a0$var$suppressDelegatedCreate) return target.apply(invocationThis, args);
            const operationName = instrumentedMethod.operation || "unknown";
            const requestAttributes = $e78f9fc118bfd5a0$var$extractRequestAttributes(args, methodPath, operationName);
            const model = requestAttributes[$2Qk3n.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
            const params = typeof args[0] === "object" ? args[0] : void 0;
            const isStreamRequested = Boolean(params?.stream);
            if (isStreamRequested || isStreamingMethod) return $e78f9fc118bfd5a0$var$handleStreamingRequest(target, invocationThis, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod);
            let originalResult;
            const instrumentedPromise = $aewmo.startSpan({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                originalResult = target.apply(invocationThis, args);
                if (options.recordInputs && params) $e78f9fc118bfd5a0$var$addPrivateRequestAttributes(span, params, $5mc1N.shouldEnableTruncation(options.enableTruncation));
                return originalResult.then((result)=>{
                    $e78f9fc118bfd5a0$var$addResponseAttributes(span, result, options.recordOutputs);
                    return result;
                });
            });
            return $5mc1N.wrapPromiseWithMethods(originalResult, instrumentedPromise);
        }
    });
}
function $e78f9fc118bfd5a0$var$instrumentClientInPlace(client, options) {
    for (const methodPath of Object.keys($b5qWi.ANTHROPIC_METHOD_REGISTRY)){
        const segments = methodPath.split(".");
        const methodName = segments.pop();
        let owner = client;
        for (const segment of segments)owner = owner?.[segment];
        if (!owner || typeof owner[methodName] !== "function") continue;
        const originalMethod = owner[methodName];
        if ($e78f9fc118bfd5a0$var$INSTRUMENTED_METHODS.has(originalMethod)) continue;
        const instrumented = $e78f9fc118bfd5a0$var$instrumentMethod(originalMethod, methodPath, $b5qWi.ANTHROPIC_METHOD_REGISTRY[methodPath], owner, options);
        $e78f9fc118bfd5a0$var$INSTRUMENTED_METHODS.add(instrumented);
        owner[methodName] = instrumented;
    }
    return client;
}
function $e78f9fc118bfd5a0$var$instrumentAnthropicAiClient(anthropicAiClient, options) {
    return $e78f9fc118bfd5a0$var$instrumentClientInPlace(anthropicAiClient, $5mc1N.resolveAIRecordingOptions(options));
}
module.exports.addPrivateRequestAttributes = $e78f9fc118bfd5a0$var$addPrivateRequestAttributes;
module.exports.addResponseAttributes = $e78f9fc118bfd5a0$var$addResponseAttributes;
module.exports.extractRequestAttributes = $e78f9fc118bfd5a0$var$extractRequestAttributes;
module.exports.instrumentAnthropicAiClient = $e78f9fc118bfd5a0$var$instrumentAnthropicAiClient;

});
parcelRegister("b5qWi", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $81250eeed4ae61c8$var$ANTHROPIC_AI_INTEGRATION_NAME = "Anthropic_AI";
const $81250eeed4ae61c8$var$ANTHROPIC_METHOD_REGISTRY = {
    "messages.create": {
        operation: "chat"
    },
    "messages.stream": {
        operation: "chat",
        streaming: true
    },
    "messages.countTokens": {
        operation: "chat"
    },
    "models.get": {
        operation: "models"
    },
    "completions.create": {
        operation: "chat"
    },
    "models.retrieve": {
        operation: "models"
    },
    "beta.messages.create": {
        operation: "chat"
    }
};
module.exports.ANTHROPIC_AI_INTEGRATION_NAME = $81250eeed4ae61c8$var$ANTHROPIC_AI_INTEGRATION_NAME;
module.exports.ANTHROPIC_METHOD_REGISTRY = $81250eeed4ae61c8$var$ANTHROPIC_METHOD_REGISTRY;

});

parcelRegister("gpDY4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aK1wS = parcelRequire("aK1wS");

var $d33W7 = parcelRequire("d33W7");

var $5mc1N = parcelRequire("5mc1N");

var $5gpss = parcelRequire("5gpss");
function $bf2dfbedc822be6a$var$isErrorEvent(event, span) {
    if ("type" in event && typeof event.type === "string") {
        if (event.type === "error") {
            span.setStatus({
                code: $d33W7.SPAN_STATUS_ERROR,
                message: $5gpss.mapAnthropicErrorToStatusMessage(event.error?.type)
            });
            return true;
        }
    }
    return false;
}
function $bf2dfbedc822be6a$var$handleMessageMetadata(event, state) {
    if (event.type === "message_delta") {
        if (event.usage && typeof event.usage.output_tokens === "number") state.completionTokens = event.usage.output_tokens;
        if (event.delta?.stop_reason) state.finishReasons.push(event.delta.stop_reason);
    }
    if (event.message) {
        const message = event.message;
        if (message.id) state.responseId = message.id;
        if (message.model) state.responseModel = message.model;
        if (message.usage) {
            if (typeof message.usage.input_tokens === "number") state.promptTokens = message.usage.input_tokens;
            if (typeof message.usage.cache_creation_input_tokens === "number") state.cacheCreationInputTokens = message.usage.cache_creation_input_tokens;
            if (typeof message.usage.cache_read_input_tokens === "number") state.cacheReadInputTokens = message.usage.cache_read_input_tokens;
        }
    }
}
function $bf2dfbedc822be6a$var$handleContentBlockStart(event, state) {
    if (event.type !== "content_block_start" || typeof event.index !== "number" || !event.content_block) return;
    if (event.content_block.type === "tool_use" || event.content_block.type === "server_tool_use") state.activeToolBlocks[event.index] = {
        id: event.content_block.id,
        name: event.content_block.name,
        inputJsonParts: []
    };
}
function $bf2dfbedc822be6a$var$handleContentBlockDelta(event, state, recordOutputs) {
    if (event.type !== "content_block_delta" || !event.delta) return;
    if (typeof event.index === "number" && "partial_json" in event.delta && typeof event.delta.partial_json === "string") {
        const active = state.activeToolBlocks[event.index];
        if (active) active.inputJsonParts.push(event.delta.partial_json);
    }
    if (recordOutputs && typeof event.delta.text === "string") state.responseTexts.push(event.delta.text);
}
function $bf2dfbedc822be6a$var$handleContentBlockStop(event, state) {
    if (event.type !== "content_block_stop" || typeof event.index !== "number") return;
    const active = state.activeToolBlocks[event.index];
    if (!active) return;
    const raw = active.inputJsonParts.join("");
    let parsedInput;
    try {
        parsedInput = raw ? JSON.parse(raw) : {};
    } catch  {
        parsedInput = {
            __unparsed: raw
        };
    }
    state.toolCalls.push({
        type: "tool_use",
        id: active.id,
        name: active.name,
        input: parsedInput
    });
    delete state.activeToolBlocks[event.index];
}
function $bf2dfbedc822be6a$var$processEvent(event, state, recordOutputs, span) {
    if (!(event && typeof event === "object")) return;
    const isError = $bf2dfbedc822be6a$var$isErrorEvent(event, span);
    if (isError) return;
    $bf2dfbedc822be6a$var$handleMessageMetadata(event, state);
    $bf2dfbedc822be6a$var$handleContentBlockStart(event, state);
    $bf2dfbedc822be6a$var$handleContentBlockDelta(event, state, recordOutputs);
    $bf2dfbedc822be6a$var$handleContentBlockStop(event, state);
}
async function* $bf2dfbedc822be6a$var$instrumentAsyncIterableStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        cacheCreationInputTokens: void 0,
        cacheReadInputTokens: void 0,
        toolCalls: [],
        activeToolBlocks: {}
    };
    try {
        for await (const event of stream){
            $bf2dfbedc822be6a$var$processEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        $5mc1N.endStreamSpan(span, state, recordOutputs);
    }
}
function $bf2dfbedc822be6a$var$instrumentMessageStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        cacheCreationInputTokens: void 0,
        cacheReadInputTokens: void 0,
        toolCalls: [],
        activeToolBlocks: {}
    };
    stream.on("streamEvent", (event)=>{
        $bf2dfbedc822be6a$var$processEvent(event, state, recordOutputs, span);
    });
    stream.on("message", ()=>{
        $5mc1N.endStreamSpan(span, state, recordOutputs);
    });
    stream.on("error", (error)=>{
        $aK1wS.captureException(error, {
            mechanism: {
                handled: false,
                type: "auto.ai.anthropic.stream_error"
            }
        });
        if (span.isRecording()) {
            span.setStatus({
                code: $d33W7.SPAN_STATUS_ERROR,
                message: "internal_error"
            });
            span.end();
        }
    });
    return stream;
}
module.exports.instrumentAsyncIterableStream = $bf2dfbedc822be6a$var$instrumentAsyncIterableStream;
module.exports.instrumentMessageStream = $bf2dfbedc822be6a$var$instrumentMessageStream;

});
parcelRegister("5gpss", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aK1wS = parcelRequire("aK1wS");

var $1L2sM = parcelRequire("1L2sM");

var $d33W7 = parcelRequire("d33W7");

var $2Qk3n = parcelRequire("2Qk3n");

var $5mc1N = parcelRequire("5mc1N");
function $3d5231ca5a812b90$var$setMessagesAttribute(span, messages, enableTruncation) {
    if (Array.isArray(messages) && messages.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $5mc1N.extractSystemInstructions(messages);
    if (systemInstructions) span.setAttributes({
        [$2Qk3n.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE]: systemInstructions
    });
    const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 1;
    span.setAttributes({
        [$2Qk3n.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $5mc1N.getTruncatedJsonString(filteredMessages) : $1L2sM.stringify(filteredMessages),
        [$2Qk3n.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
    });
}
const $3d5231ca5a812b90$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS = {
    invalid_request_error: "invalid_argument",
    authentication_error: "unauthenticated",
    permission_error: "permission_denied",
    not_found_error: "not_found",
    request_too_large: "failed_precondition",
    rate_limit_error: "resource_exhausted",
    api_error: "internal_error",
    overloaded_error: "unavailable"
};
function $3d5231ca5a812b90$var$mapAnthropicErrorToStatusMessage(errorType) {
    if (!errorType) return "internal_error";
    return $3d5231ca5a812b90$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS[errorType] || "internal_error";
}
function $3d5231ca5a812b90$var$handleResponseError(span, response) {
    if (response.error) {
        span.setStatus({
            code: $d33W7.SPAN_STATUS_ERROR,
            message: $3d5231ca5a812b90$var$mapAnthropicErrorToStatusMessage(response.error.type)
        });
        $aK1wS.captureException(response.error, {
            mechanism: {
                handled: false,
                type: "auto.ai.anthropic.anthropic_error"
            }
        });
    }
}
function $3d5231ca5a812b90$var$messagesFromParams(params) {
    const { system: system, messages: messages, input: input } = params;
    const systemMessages = typeof system === "string" ? [
        {
            role: "system",
            content: params.system
        }
    ] : [];
    const inputParamMessages = Array.isArray(input) ? input : input != null ? [
        input
    ] : void 0;
    const messagesParamMessages = Array.isArray(messages) ? messages : messages != null ? [
        messages
    ] : [];
    const userMessages = inputParamMessages ?? messagesParamMessages;
    return [
        ...systemMessages,
        ...userMessages
    ];
}
module.exports.handleResponseError = $3d5231ca5a812b90$var$handleResponseError;
module.exports.mapAnthropicErrorToStatusMessage = $3d5231ca5a812b90$var$mapAnthropicErrorToStatusMessage;
module.exports.messagesFromParams = $3d5231ca5a812b90$var$messagesFromParams;
module.exports.setMessagesAttribute = $3d5231ca5a812b90$var$setMessagesAttribute;

});



parcelRegister("5JHrG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2JysJ = parcelRequire("2JysJ");

var $1L2sM = parcelRequire("1L2sM");

var $d33W7 = parcelRequire("d33W7");

var $aewmo = parcelRequire("aewmo");

var $clLeB = parcelRequire("clLeB");

var $2Qk3n = parcelRequire("2Qk3n");

var $5mc1N = parcelRequire("5mc1N");

var $bf9G5 = parcelRequire("bf9G5");

var $hj0Jl = parcelRequire("hj0Jl");

var $t7EkP = parcelRequire("t7EkP");
function $42d2db1423c3193c$var$extractModel(params, context) {
    if ("model" in params && typeof params.model === "string") return params.model;
    if (context && typeof context === "object") {
        const contextObj = context;
        if ("model" in contextObj && typeof contextObj.model === "string") return contextObj.model;
        if ("modelVersion" in contextObj && typeof contextObj.modelVersion === "string") return contextObj.modelVersion;
    }
    return "unknown";
}
function $42d2db1423c3193c$var$extractConfigAttributes(config) {
    const attributes = {};
    if ("temperature" in config && typeof config.temperature === "number") attributes[$2Qk3n.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = config.temperature;
    if ("topP" in config && typeof config.topP === "number") attributes[$2Qk3n.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = config.topP;
    if ("topK" in config && typeof config.topK === "number") attributes[$2Qk3n.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = config.topK;
    if ("maxOutputTokens" in config && typeof config.maxOutputTokens === "number") attributes[$2Qk3n.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = config.maxOutputTokens;
    if ("frequencyPenalty" in config && typeof config.frequencyPenalty === "number") attributes[$2Qk3n.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = config.frequencyPenalty;
    if ("presencePenalty" in config && typeof config.presencePenalty === "number") attributes[$2Qk3n.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = config.presencePenalty;
    return attributes;
}
function $42d2db1423c3193c$var$extractRequestAttributes(operationName, params, context) {
    const attributes = {
        [$2Qk3n.GEN_AI_SYSTEM_ATTRIBUTE]: $bf9G5.GOOGLE_GENAI_SYSTEM_NAME,
        [$2Qk3n.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.google_genai"
    };
    if (params) {
        attributes[$2Qk3n.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = $42d2db1423c3193c$var$extractModel(params, context);
        if ("config" in params && typeof params.config === "object" && params.config) {
            const config = params.config;
            Object.assign(attributes, $42d2db1423c3193c$var$extractConfigAttributes(config));
            if ("tools" in config && Array.isArray(config.tools)) {
                const functionDeclarations = config.tools.flatMap((tool)=>tool.functionDeclarations);
                attributes[$2Qk3n.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(functionDeclarations);
            }
        }
    } else attributes[$2Qk3n.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = $42d2db1423c3193c$var$extractModel({}, context);
    return attributes;
}
function $42d2db1423c3193c$var$addPrivateRequestAttributes(span, params, operationName, enableTruncation) {
    if (operationName === "embeddings") {
        const contents = params.contents;
        if (contents != null) span.setAttribute($2Qk3n.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE, typeof contents === "string" ? contents : JSON.stringify(contents));
        return;
    }
    const messages = [];
    if ("config" in params && params.config && typeof params.config === "object" && "systemInstruction" in params.config && params.config.systemInstruction) messages.push(...$t7EkP.contentUnionToMessages(params.config.systemInstruction, "system"));
    if ("history" in params) messages.push(...$t7EkP.contentUnionToMessages(params.history, "user"));
    if ("contents" in params) messages.push(...$t7EkP.contentUnionToMessages(params.contents, "user"));
    if ("message" in params) messages.push(...$t7EkP.contentUnionToMessages(params.message, "user"));
    if (Array.isArray(messages) && messages.length) {
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $5mc1N.extractSystemInstructions(messages);
        if (systemInstructions) span.setAttribute($2Qk3n.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        span.setAttributes({
            [$2Qk3n.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength,
            [$2Qk3n.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $5mc1N.getTruncatedJsonString(filteredMessages) : $1L2sM.stringify(filteredMessages)
        });
    }
}
function $42d2db1423c3193c$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== "object") return;
    if (response.modelVersion) span.setAttribute($2Qk3n.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, response.modelVersion);
    if (response.usageMetadata && typeof response.usageMetadata === "object") {
        const usage = response.usageMetadata;
        if (typeof usage.promptTokenCount === "number") span.setAttributes({
            [$2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE]: usage.promptTokenCount
        });
        if (typeof usage.candidatesTokenCount === "number") span.setAttributes({
            [$2Qk3n.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE]: usage.candidatesTokenCount
        });
        if (typeof usage.totalTokenCount === "number") span.setAttributes({
            [$2Qk3n.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE]: usage.totalTokenCount
        });
    }
    if (recordOutputs && Array.isArray(response.candidates) && response.candidates.length > 0) {
        const responseTexts = response.candidates.map((candidate)=>{
            if (candidate.content?.parts && Array.isArray(candidate.content.parts)) return candidate.content.parts.map((part)=>typeof part.text === "string" ? part.text : "").filter((text)=>text.length > 0).join("");
            return "";
        }).filter((text)=>text.length > 0);
        if (responseTexts.length > 0) span.setAttributes({
            [$2Qk3n.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: responseTexts.join("")
        });
    }
    if (recordOutputs && response.functionCalls) {
        const functionCalls = response.functionCalls;
        if (Array.isArray(functionCalls) && functionCalls.length > 0) span.setAttributes({
            [$2Qk3n.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(functionCalls)
        });
    }
}
function $42d2db1423c3193c$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    const isEmbeddings = instrumentedMethod.operation === "embeddings";
    return new Proxy(originalMethod, {
        apply (target, _, args) {
            const operationName = instrumentedMethod.operation || "unknown";
            const params = args[0];
            const requestAttributes = $42d2db1423c3193c$var$extractRequestAttributes(operationName, params, context);
            const model = requestAttributes[$2Qk3n.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
            if (instrumentedMethod.streaming) return $aewmo.startSpanManual({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, async (span)=>{
                try {
                    if (options.recordInputs && params) $42d2db1423c3193c$var$addPrivateRequestAttributes(span, params, operationName, $5mc1N.shouldEnableTruncation(options.enableTruncation));
                    const stream = await target.apply(context, args);
                    return $hj0Jl.instrumentStream(stream, span, Boolean(options.recordOutputs));
                } catch (error) {
                    span.setStatus({
                        code: $d33W7.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    span.end();
                    throw error;
                }
            });
            return $aewmo.startSpan({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                if (options.recordInputs && params) $42d2db1423c3193c$var$addPrivateRequestAttributes(span, params, operationName, $5mc1N.shouldEnableTruncation(options.enableTruncation));
                return $clLeB.handleCallbackErrors(()=>target.apply(context, args), ()=>{}, ()=>{}, (result)=>{
                    if (!isEmbeddings) $42d2db1423c3193c$var$addResponseAttributes(span, result, options.recordOutputs);
                });
            });
        }
    });
}
function $42d2db1423c3193c$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get: (t, prop, receiver)=>{
            const value = Reflect.get(t, prop, receiver);
            const methodPath = $5mc1N.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $bf9G5.GOOGLE_GENAI_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) {
                const wrappedMethod = instrumentedMethod.operation ? $42d2db1423c3193c$var$instrumentMethod(value, methodPath, instrumentedMethod, t, options) : value.bind(t);
                if (!instrumentedMethod.proxyResultPath) return wrappedMethod;
                return function(...args) {
                    const result = wrappedMethod(...args);
                    if (result && typeof result === "object") return $42d2db1423c3193c$var$createDeepProxy(result, instrumentedMethod.proxyResultPath, options);
                    return result;
                };
            }
            if (typeof value === "function") return value.bind(t);
            if (value && typeof value === "object") return $42d2db1423c3193c$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $42d2db1423c3193c$var$instrumentGoogleGenAIClient(client, options) {
    return $42d2db1423c3193c$var$createDeepProxy(client, "", $5mc1N.resolveAIRecordingOptions(options));
}
module.exports.addPrivateRequestAttributes = $42d2db1423c3193c$var$addPrivateRequestAttributes;
module.exports.addResponseAttributes = $42d2db1423c3193c$var$addResponseAttributes;
module.exports.extractModel = $42d2db1423c3193c$var$extractModel;
module.exports.extractRequestAttributes = $42d2db1423c3193c$var$extractRequestAttributes;
module.exports.instrumentGoogleGenAIClient = $42d2db1423c3193c$var$instrumentGoogleGenAIClient;

});
parcelRegister("bf9G5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $82f89a36754700d8$var$GOOGLE_GENAI_INTEGRATION_NAME = "Google_GenAI";
const $82f89a36754700d8$var$GOOGLE_GENAI_METHOD_REGISTRY = {
    "models.generateContent": {
        operation: "generate_content"
    },
    "models.generateContentStream": {
        operation: "generate_content",
        streaming: true
    },
    "models.embedContent": {
        operation: "embeddings"
    },
    "chats.create": {
        proxyResultPath: "chat"
    },
    "chat.sendMessage": {
        operation: "chat"
    },
    "chat.sendMessageStream": {
        operation: "chat",
        streaming: true
    }
};
const $82f89a36754700d8$var$GOOGLE_GENAI_SYSTEM_NAME = "google_genai";
module.exports.GOOGLE_GENAI_INTEGRATION_NAME = $82f89a36754700d8$var$GOOGLE_GENAI_INTEGRATION_NAME;
module.exports.GOOGLE_GENAI_METHOD_REGISTRY = $82f89a36754700d8$var$GOOGLE_GENAI_METHOD_REGISTRY;
module.exports.GOOGLE_GENAI_SYSTEM_NAME = $82f89a36754700d8$var$GOOGLE_GENAI_SYSTEM_NAME;

});

parcelRegister("hj0Jl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aK1wS = parcelRequire("aK1wS");

var $d33W7 = parcelRequire("d33W7");

var $5mc1N = parcelRequire("5mc1N");
function $c994c7093d80dabe$var$isErrorChunk(chunk, span) {
    const feedback = chunk?.promptFeedback;
    if (feedback?.blockReason) {
        const message = feedback.blockReasonMessage ?? feedback.blockReason;
        span.setStatus({
            code: $d33W7.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        $aK1wS.captureException(`Content blocked: ${message}`, {
            mechanism: {
                handled: false,
                type: "auto.ai.google_genai"
            }
        });
        return true;
    }
    return false;
}
function $c994c7093d80dabe$var$handleResponseMetadata(chunk, state) {
    if (typeof chunk.responseId === "string") state.responseId = chunk.responseId;
    if (typeof chunk.modelVersion === "string") state.responseModel = chunk.modelVersion;
    const usage = chunk.usageMetadata;
    if (usage) {
        if (typeof usage.promptTokenCount === "number") state.promptTokens = usage.promptTokenCount;
        if (typeof usage.candidatesTokenCount === "number") state.completionTokens = usage.candidatesTokenCount;
        if (typeof usage.totalTokenCount === "number") state.totalTokens = usage.totalTokenCount;
    }
}
function $c994c7093d80dabe$var$handleCandidateContent(chunk, state, recordOutputs) {
    if (Array.isArray(chunk.functionCalls)) state.toolCalls.push(...chunk.functionCalls);
    for (const candidate of chunk.candidates ?? []){
        if (candidate?.finishReason && !state.finishReasons.includes(candidate.finishReason)) state.finishReasons.push(candidate.finishReason);
        for (const part of candidate?.content?.parts ?? []){
            if (recordOutputs && part.text) state.responseTexts.push(part.text);
            if (part.functionCall) state.toolCalls.push({
                type: "function",
                id: part.functionCall.id,
                name: part.functionCall.name,
                arguments: part.functionCall.args
            });
        }
    }
}
function $c994c7093d80dabe$var$processChunk(chunk, state, recordOutputs, span) {
    if (!chunk || $c994c7093d80dabe$var$isErrorChunk(chunk, span)) return;
    $c994c7093d80dabe$var$handleResponseMetadata(chunk, state);
    $c994c7093d80dabe$var$handleCandidateContent(chunk, state, recordOutputs);
}
async function* $c994c7093d80dabe$var$instrumentStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        toolCalls: []
    };
    try {
        for await (const chunk of stream){
            $c994c7093d80dabe$var$processChunk(chunk, state, recordOutputs, span);
            yield chunk;
        }
    } finally{
        $5mc1N.endStreamSpan(span, state, recordOutputs);
    }
}
module.exports.instrumentStream = $c994c7093d80dabe$var$instrumentStream;

});

parcelRegister("t7EkP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $0578a497abacfed1$var$contentUnionToMessages(content, role = "user") {
    if (typeof content === "string") return [
        {
            role: role,
            content: content
        }
    ];
    if (Array.isArray(content)) return content.flatMap((content2)=>$0578a497abacfed1$var$contentUnionToMessages(content2, role));
    if (typeof content !== "object" || !content) return [];
    if ("role" in content && typeof content.role === "string") return [
        content
    ];
    if ("parts" in content) return [
        {
            ...content,
            role: role
        }
    ];
    return [
        {
            role: role,
            content: content
        }
    ];
}
module.exports.contentUnionToMessages = $0578a497abacfed1$var$contentUnionToMessages;

});


parcelRegister("igulC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2JysJ = parcelRequire("2JysJ");

var $d33W7 = parcelRequire("d33W7");

var $aewmo = parcelRequire("aewmo");

var $2Qk3n = parcelRequire("2Qk3n");

var $5mc1N = parcelRequire("5mc1N");

var $aUl7w = parcelRequire("aUl7w");

var $4x2Gl = parcelRequire("4x2Gl");
function $d4c14309237188f4$var$createLangChainCallbackHandler(options = {}) {
    const { recordInputs: recordInputs, recordOutputs: recordOutputs } = $5mc1N.resolveAIRecordingOptions(options);
    const enableTruncation = $5mc1N.shouldEnableTruncation(options.enableTruncation);
    const spanMap = /* @__PURE__ */ new Map();
    const exitSpan = (runId)=>{
        const span = spanMap.get(runId);
        if (span?.isRecording()) {
            span.end();
            spanMap.delete(runId);
        }
    };
    const handler = {
        // Required LangChain BaseCallbackHandler properties
        lc_serializable: false,
        lc_namespace: [
            "langchain_core",
            "callbacks",
            "sentry"
        ],
        lc_secrets: void 0,
        lc_attributes: void 0,
        lc_aliases: void 0,
        lc_serializable_keys: void 0,
        lc_id: [
            "langchain_core",
            "callbacks",
            "sentry"
        ],
        lc_kwargs: {},
        name: "SentryCallbackHandler",
        // BaseCallbackHandlerInput boolean flags
        ignoreLLM: false,
        ignoreChain: false,
        ignoreAgent: false,
        ignoreRetriever: false,
        ignoreCustomEvent: false,
        raiseError: false,
        awaitHandlers: true,
        handleLLMStart (llm, prompts, runId, _parentRunId, _extraParams, tags, metadata, _runName) {
            const invocationParams = $4x2Gl.getInvocationParams(tags);
            const attributes = $4x2Gl.extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, metadata);
            const modelName = attributes[$2Qk3n.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[$2Qk3n.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            $aewmo.startSpanManual({
                name: `${operationName} ${modelName}`,
                op: "gen_ai.chat",
                attributes: {
                    ...$4x2Gl.getAgentNameFromMetadata(metadata),
                    ...attributes,
                    [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.chat"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chat Model Start Handler
        handleChatModelStart (llm, messages, runId, _parentRunId, extraParams, tags, metadata, _runName) {
            const invocationParams = $4x2Gl.getInvocationParams(tags);
            const attributes = $4x2Gl.extractChatModelRequestAttributes(llm, messages, recordInputs, enableTruncation, invocationParams, metadata);
            const toolDefsJson = $4x2Gl.extractToolDefinitions(extraParams);
            if (toolDefsJson) attributes[$2Qk3n.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = toolDefsJson;
            const modelName = attributes[$2Qk3n.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[$2Qk3n.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            $aewmo.startSpanManual({
                name: `${operationName} ${modelName}`,
                op: "gen_ai.chat",
                attributes: {
                    ...$4x2Gl.getAgentNameFromMetadata(metadata),
                    ...attributes,
                    [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.chat"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // LLM End Handler - note: handleLLMEnd with capital LLM (used by both LLMs and chat models!)
        handleLLMEnd (output, runId, _parentRunId, _tags, _extraParams) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                const attributes = $4x2Gl.extractLlmResponseAttributes(output, recordOutputs);
                if (attributes) span.setAttributes(attributes);
                exitSpan(runId);
            }
        },
        // LLM Error Handler - note: handleLLMError with capital LLM
        handleLLMError (_error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $d33W7.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
        },
        // Chain Start Handler
        handleChainStart (chain, inputs, runId, _parentRunId, _tags, metadata, _runType, runName) {
            if (metadata?.__sentry_langgraph__) return;
            const chainName = runName || chain.name || "unknown_chain";
            const attributes = {
                [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.langchain",
                "langchain.chain.name": chainName
            };
            if (recordInputs) attributes["langchain.chain.inputs"] = JSON.stringify(inputs);
            $aewmo.startSpanManual({
                name: `chain ${chainName}`,
                op: "gen_ai.invoke_agent",
                attributes: {
                    ...attributes,
                    [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.invoke_agent"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chain End Handler
        handleChainEnd (outputs, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                if (recordOutputs) span.setAttributes({
                    "langchain.chain.outputs": JSON.stringify(outputs)
                });
                exitSpan(runId);
            }
        },
        // Chain Error Handler
        handleChainError (_error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $d33W7.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
        },
        // Tool Start Handler
        handleToolStart (tool, input, runId, _parentRunId, _tags, metadata, runName) {
            if (metadata?.__sentry_langgraph__) return;
            const toolName = runName || tool.name || "unknown_tool";
            const attributes = {
                ...$4x2Gl.getAgentNameFromMetadata(metadata),
                [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $aUl7w.LANGCHAIN_ORIGIN,
                [$2Qk3n.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "execute_tool",
                [$2Qk3n.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName
            };
            if (recordInputs) attributes[$2Qk3n.GEN_AI_TOOL_INPUT_ATTRIBUTE] = input;
            $aewmo.startSpanManual({
                name: `execute_tool ${toolName}`,
                op: "gen_ai.execute_tool",
                attributes: {
                    ...attributes,
                    [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.execute_tool"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Tool End Handler
        handleToolEnd (output, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                if (recordOutputs) {
                    const outputObj = output;
                    const content = outputObj && typeof outputObj === "object" && "content" in outputObj ? outputObj.content : output;
                    span.setAttributes({
                        [$2Qk3n.GEN_AI_TOOL_OUTPUT_ATTRIBUTE]: typeof content === "string" ? content : JSON.stringify(content)
                    });
                }
                exitSpan(runId);
            }
        },
        // Tool Error Handler
        handleToolError (_error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $d33W7.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
        },
        // LangChain BaseCallbackHandler required methods
        copy () {
            return handler;
        },
        toJSON () {
            return {
                lc: 1,
                type: "not_implemented",
                id: handler.lc_id
            };
        },
        toJSONNotImplemented () {
            return {
                lc: 1,
                type: "not_implemented",
                id: handler.lc_id
            };
        }
    };
    return handler;
}
module.exports.createLangChainCallbackHandler = $d4c14309237188f4$var$createLangChainCallbackHandler;

});
parcelRegister("aUl7w", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $7f0f84617676eae5$var$LANGCHAIN_INTEGRATION_NAME = "LangChain";
const $7f0f84617676eae5$var$LANGCHAIN_ORIGIN = "auto.ai.langchain";
const $7f0f84617676eae5$var$ROLE_MAP = {
    human: "user",
    ai: "assistant",
    assistant: "assistant",
    system: "system",
    function: "function",
    tool: "tool"
};
module.exports.LANGCHAIN_INTEGRATION_NAME = $7f0f84617676eae5$var$LANGCHAIN_INTEGRATION_NAME;
module.exports.LANGCHAIN_ORIGIN = $7f0f84617676eae5$var$LANGCHAIN_ORIGIN;
module.exports.ROLE_MAP = $7f0f84617676eae5$var$ROLE_MAP;

});

parcelRegister("4x2Gl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2JysJ = parcelRequire("2JysJ");

var $1L2sM = parcelRequire("1L2sM");

var $2Qk3n = parcelRequire("2Qk3n");

var $knQ1Y = parcelRequire("knQ1Y");

var $5mc1N = parcelRequire("5mc1N");

var $aUl7w = parcelRequire("aUl7w");
const $34cc53173337967b$var$setIfDefined = (target, key, value)=>{
    if (value != null) target[key] = value;
};
const $34cc53173337967b$var$setNumberIfDefined = (target, key, value)=>{
    const n = Number(value);
    if (!Number.isNaN(n)) target[key] = n;
};
function $34cc53173337967b$var$normalizeContent(v) {
    if (Array.isArray(v)) try {
        const stripped = v.map((part)=>part && typeof part === "object" && $knQ1Y.isContentMedia(part) ? $knQ1Y.stripInlineMediaFromSingleMessage(part) : part);
        return JSON.stringify(stripped);
    } catch  {
        return String(v);
    }
    return $1L2sM.stringify(v, String);
}
function $34cc53173337967b$var$normalizeMessageRole(role) {
    const normalized = role.toLowerCase();
    return $aUl7w.ROLE_MAP[normalized] ?? normalized;
}
function $34cc53173337967b$var$normalizeRoleNameFromCtor(name) {
    if (name.includes("System")) return "system";
    if (name.includes("Human")) return "user";
    if (name.includes("AI") || name.includes("Assistant")) return "assistant";
    if (name.includes("Function")) return "function";
    if (name.includes("Tool")) return "tool";
    return "user";
}
function $34cc53173337967b$var$getInvocationParams(tags) {
    if (!tags || Array.isArray(tags)) return void 0;
    return tags.invocation_params;
}
function $34cc53173337967b$var$normalizeLangChainMessages(messages) {
    return messages.map((message)=>{
        const maybeGetType = message._getType;
        if (typeof maybeGetType === "function") {
            const messageType = maybeGetType.call(message);
            return {
                role: $34cc53173337967b$var$normalizeMessageRole(messageType),
                content: $34cc53173337967b$var$normalizeContent(message.content)
            };
        }
        if (message.lc === 1 && message.kwargs) {
            const id = message.id;
            const messageType = Array.isArray(id) && id.length > 0 ? id[id.length - 1] : "";
            const role = typeof messageType === "string" ? $34cc53173337967b$var$normalizeRoleNameFromCtor(messageType) : "user";
            return {
                role: $34cc53173337967b$var$normalizeMessageRole(role),
                content: $34cc53173337967b$var$normalizeContent(message.kwargs?.content)
            };
        }
        if (message.type) {
            const role = String(message.type).toLowerCase();
            return {
                role: $34cc53173337967b$var$normalizeMessageRole(role),
                content: $34cc53173337967b$var$normalizeContent(message.content)
            };
        }
        if (message.role) return {
            role: $34cc53173337967b$var$normalizeMessageRole(String(message.role)),
            content: $34cc53173337967b$var$normalizeContent(message.content)
        };
        const ctor = message.constructor?.name;
        if (ctor && ctor !== "Object") return {
            role: $34cc53173337967b$var$normalizeMessageRole($34cc53173337967b$var$normalizeRoleNameFromCtor(ctor)),
            content: $34cc53173337967b$var$normalizeContent(message.content)
        };
        return {
            role: "user",
            content: $34cc53173337967b$var$normalizeContent(message.content)
        };
    });
}
function $34cc53173337967b$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata) {
    const attrs = {};
    const kwargs = "kwargs" in serialized ? serialized.kwargs : void 0;
    const temperature = invocationParams?.temperature ?? langSmithMetadata?.ls_temperature ?? kwargs?.temperature;
    $34cc53173337967b$var$setNumberIfDefined(attrs, $2Qk3n.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE, temperature);
    const maxTokens = invocationParams?.max_tokens ?? langSmithMetadata?.ls_max_tokens ?? kwargs?.max_tokens;
    $34cc53173337967b$var$setNumberIfDefined(attrs, $2Qk3n.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE, maxTokens);
    const topP = invocationParams?.top_p ?? kwargs?.top_p;
    $34cc53173337967b$var$setNumberIfDefined(attrs, $2Qk3n.GEN_AI_REQUEST_TOP_P_ATTRIBUTE, topP);
    const frequencyPenalty = invocationParams?.frequency_penalty;
    $34cc53173337967b$var$setNumberIfDefined(attrs, $2Qk3n.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE, frequencyPenalty);
    const presencePenalty = invocationParams?.presence_penalty;
    $34cc53173337967b$var$setNumberIfDefined(attrs, $2Qk3n.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE, presencePenalty);
    if (invocationParams && "stream" in invocationParams) $34cc53173337967b$var$setIfDefined(attrs, $2Qk3n.GEN_AI_REQUEST_STREAM_ATTRIBUTE, Boolean(invocationParams.stream));
    return attrs;
}
function $34cc53173337967b$var$baseRequestAttributes(system, modelName, serialized, invocationParams, langSmithMetadata) {
    return {
        [$2Qk3n.GEN_AI_SYSTEM_ATTRIBUTE]: $1L2sM.stringify(system ?? "langchain", String),
        [$2Qk3n.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "chat",
        [$2Qk3n.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: $1L2sM.stringify(modelName, String),
        [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $aUl7w.LANGCHAIN_ORIGIN,
        ...$34cc53173337967b$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata)
    };
}
function $34cc53173337967b$var$extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider;
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? "unknown";
    const attrs = $34cc53173337967b$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(prompts) && prompts.length > 0) {
        $34cc53173337967b$var$setIfDefined(attrs, $2Qk3n.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, prompts.length);
        const messages = prompts.map((p)=>({
                role: "user",
                content: p
            }));
        $34cc53173337967b$var$setIfDefined(attrs, $2Qk3n.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $5mc1N.getTruncatedJsonString(messages) : $1L2sM.stringify(messages));
    }
    return attrs;
}
function $34cc53173337967b$var$extractChatModelRequestAttributes(llm, langChainMessages, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider ?? llm.id?.[2];
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? "unknown";
    const attrs = $34cc53173337967b$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(langChainMessages) && langChainMessages.length > 0) {
        const normalized = $34cc53173337967b$var$normalizeLangChainMessages(langChainMessages.flat());
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $5mc1N.extractSystemInstructions(normalized);
        if (systemInstructions) $34cc53173337967b$var$setIfDefined(attrs, $2Qk3n.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        $34cc53173337967b$var$setIfDefined(attrs, $2Qk3n.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredLength);
        $34cc53173337967b$var$setIfDefined(attrs, $2Qk3n.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $5mc1N.getTruncatedJsonString(filteredMessages) : $1L2sM.stringify(filteredMessages));
    }
    return attrs;
}
function $34cc53173337967b$var$addToolCallsAttributes(generations, attrs) {
    const toolCalls = [];
    const flatGenerations = generations.flat();
    for (const gen of flatGenerations){
        const msg = gen.message;
        const msgToolCalls = msg?.tool_calls;
        if (Array.isArray(msgToolCalls) && msgToolCalls.length > 0) toolCalls.push(...msgToolCalls);
        else {
            const content = gen.message?.content;
            if (Array.isArray(content)) for (const item of content){
                const t = item;
                if (t.type === "tool_use") toolCalls.push(t);
            }
        }
    }
    if (toolCalls.length > 0) $34cc53173337967b$var$setIfDefined(attrs, $2Qk3n.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, $1L2sM.stringify(toolCalls, String));
}
function $34cc53173337967b$var$addTokenUsageAttributes(llmOutput, attrs) {
    if (!llmOutput) return;
    const tokenUsage = llmOutput.tokenUsage;
    const anthropicUsage = llmOutput.usage;
    if (tokenUsage) {
        $34cc53173337967b$var$setNumberIfDefined(attrs, $2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, tokenUsage.promptTokens);
        $34cc53173337967b$var$setNumberIfDefined(attrs, $2Qk3n.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, tokenUsage.completionTokens);
        $34cc53173337967b$var$setNumberIfDefined(attrs, $2Qk3n.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, tokenUsage.totalTokens);
    } else if (anthropicUsage) {
        $34cc53173337967b$var$setNumberIfDefined(attrs, $2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.input_tokens);
        $34cc53173337967b$var$setNumberIfDefined(attrs, $2Qk3n.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, anthropicUsage.output_tokens);
        const input = Number(anthropicUsage.input_tokens);
        const output = Number(anthropicUsage.output_tokens);
        const total = (Number.isNaN(input) ? 0 : input) + (Number.isNaN(output) ? 0 : output);
        if (total > 0) $34cc53173337967b$var$setNumberIfDefined(attrs, $2Qk3n.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, total);
        if (anthropicUsage.cache_creation_input_tokens !== void 0) $34cc53173337967b$var$setNumberIfDefined(attrs, $2Qk3n.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.cache_creation_input_tokens);
        if (anthropicUsage.cache_read_input_tokens !== void 0) $34cc53173337967b$var$setNumberIfDefined(attrs, $2Qk3n.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.cache_read_input_tokens);
    }
}
function $34cc53173337967b$var$extractLlmResponseAttributes(llmResult, recordOutputs) {
    if (!llmResult) return;
    const attrs = {};
    if (Array.isArray(llmResult.generations)) {
        const finishReasons = llmResult.generations.flat().map((g)=>{
            if (g.generationInfo?.finish_reason) return g.generationInfo.finish_reason;
            if (g.generation_info?.finish_reason) return g.generation_info.finish_reason;
            return null;
        }).filter((r)=>typeof r === "string");
        if (finishReasons.length > 0) $34cc53173337967b$var$setIfDefined(attrs, $2Qk3n.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, $1L2sM.stringify(finishReasons, String));
        $34cc53173337967b$var$addToolCallsAttributes(llmResult.generations, attrs);
        if (recordOutputs) {
            const texts = llmResult.generations.flat().map((gen)=>gen.text ?? gen.message?.content).filter((t)=>typeof t === "string");
            if (texts.length > 0) $34cc53173337967b$var$setIfDefined(attrs, $2Qk3n.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, $1L2sM.stringify(texts, String));
        }
    }
    $34cc53173337967b$var$addTokenUsageAttributes(llmResult.llmOutput, attrs);
    const llmOutput = llmResult.llmOutput;
    const firstGeneration = llmResult.generations?.[0]?.[0];
    const v1Message = firstGeneration?.message;
    const modelName = llmOutput?.model_name ?? llmOutput?.model ?? v1Message?.response_metadata?.model_name;
    if (modelName) $34cc53173337967b$var$setIfDefined(attrs, $2Qk3n.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, modelName);
    const responseId = llmOutput?.id ?? v1Message?.id;
    if (responseId) $34cc53173337967b$var$setIfDefined(attrs, $2Qk3n.GEN_AI_RESPONSE_ID_ATTRIBUTE, responseId);
    const stopReason = llmOutput?.stop_reason ?? v1Message?.response_metadata?.finish_reason;
    if (stopReason) $34cc53173337967b$var$setIfDefined(attrs, $2Qk3n.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE, $1L2sM.stringify(stopReason, String));
    return attrs;
}
function $34cc53173337967b$var$getAgentNameFromMetadata(metadata) {
    const attrs = {};
    const agentName = metadata?.lc_agent_name;
    if (typeof agentName === "string") attrs[$2Qk3n.GEN_AI_AGENT_NAME_ATTRIBUTE] = agentName;
    return attrs;
}
function $34cc53173337967b$var$extractToolDefinitions(extraParams) {
    const tools = extraParams?.invocation_params?.tools ?? extraParams?.options?.tools;
    if (!Array.isArray(tools) || tools.length === 0) return void 0;
    const toolDefs = tools.map((tool)=>{
        const fn = tool.function;
        return {
            type: "function",
            name: tool.name ?? fn?.name ?? "",
            description: tool.description ?? fn?.description
        };
    });
    return JSON.stringify(toolDefs);
}
function $34cc53173337967b$var$isCallbackManager(value) {
    if (!value || typeof value !== "object") return false;
    const candidate = value;
    return typeof candidate.addHandler === "function" && typeof candidate.copy === "function";
}
function $34cc53173337967b$var$isSentryHandler(handler) {
    return typeof handler === "object" && handler?.name === "SentryCallbackHandler";
}
function $34cc53173337967b$var$containsSentryHandler(handlers) {
    return handlers.some($34cc53173337967b$var$isSentryHandler);
}
function $34cc53173337967b$var$_INTERNAL_mergeLangChainCallbackHandler(existing, sentryHandler) {
    if (!existing) return [
        sentryHandler
    ];
    if ($34cc53173337967b$var$isCallbackManager(existing)) {
        if ($34cc53173337967b$var$containsSentryHandler(existing.handlers ?? [])) return existing;
        const copied = existing.copy();
        copied.addHandler(sentryHandler, true);
        return copied;
    }
    const handlers = Array.isArray(existing) ? existing : [
        existing
    ];
    if ($34cc53173337967b$var$containsSentryHandler(handlers)) return existing;
    return [
        ...handlers,
        sentryHandler
    ];
}
module.exports._INTERNAL_mergeLangChainCallbackHandler = $34cc53173337967b$var$_INTERNAL_mergeLangChainCallbackHandler;
module.exports.extractChatModelRequestAttributes = $34cc53173337967b$var$extractChatModelRequestAttributes;
module.exports.extractLLMRequestAttributes = $34cc53173337967b$var$extractLLMRequestAttributes;
module.exports.extractLlmResponseAttributes = $34cc53173337967b$var$extractLlmResponseAttributes;
module.exports.extractToolDefinitions = $34cc53173337967b$var$extractToolDefinitions;
module.exports.getAgentNameFromMetadata = $34cc53173337967b$var$getAgentNameFromMetadata;
module.exports.getInvocationParams = $34cc53173337967b$var$getInvocationParams;
module.exports.normalizeLangChainMessages = $34cc53173337967b$var$normalizeLangChainMessages;

});


parcelRegister("efgke", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2JysJ = parcelRequire("2JysJ");

var $aewmo = parcelRequire("aewmo");

var $2Qk3n = parcelRequire("2Qk3n");

var $5mc1N = parcelRequire("5mc1N");

var $aUl7w = parcelRequire("aUl7w");
function $a5ef21456dfd7b05$var$inferSystemFromInstance(instance) {
    const name = instance.constructor?.name ?? "";
    if (name.includes("OpenAI")) return "openai";
    if (name.includes("Google")) return "google_genai";
    if (name.includes("Mistral")) return "mistralai";
    if (name.includes("Vertex")) return "google_vertexai";
    if (name.includes("Bedrock")) return "aws_bedrock";
    if (name.includes("Ollama")) return "ollama";
    if (name.includes("Cloudflare")) return "cloudflare";
    if (name.includes("Cohere")) return "cohere";
    return "langchain";
}
function $a5ef21456dfd7b05$var$extractEmbeddingAttributes(instance) {
    const embeddingsInstance = instance ?? {};
    const attributes = {
        [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $aUl7w.LANGCHAIN_ORIGIN,
        [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $2Qk3n.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
        [$2Qk3n.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "embeddings",
        [$2Qk3n.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: embeddingsInstance.model ?? "unknown"
    };
    attributes[$2Qk3n.GEN_AI_SYSTEM_ATTRIBUTE] = $a5ef21456dfd7b05$var$inferSystemFromInstance(embeddingsInstance);
    if ("dimensions" in embeddingsInstance) attributes[$2Qk3n.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = embeddingsInstance.dimensions;
    if ("encodingFormat" in embeddingsInstance) attributes[$2Qk3n.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = embeddingsInstance.encodingFormat;
    return attributes;
}
function $a5ef21456dfd7b05$var$_INTERNAL_getLangChainEmbeddingsSpanOptions(instance, input, options = {}) {
    const { recordInputs: recordInputs } = $5mc1N.resolveAIRecordingOptions(options);
    const attributes = $a5ef21456dfd7b05$var$extractEmbeddingAttributes(instance);
    const modelName = attributes[$2Qk3n.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || "unknown";
    if (recordInputs && input != null) attributes[$2Qk3n.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = typeof input === "string" ? input : JSON.stringify(input);
    return {
        name: `embeddings ${modelName}`,
        op: $2Qk3n.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
        attributes: attributes
    };
}
function $a5ef21456dfd7b05$var$instrumentEmbeddingMethod(originalMethod, options = {}) {
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            return $aewmo.startSpan($a5ef21456dfd7b05$var$_INTERNAL_getLangChainEmbeddingsSpanOptions(thisArg, args[0], options), ()=>{
                return Reflect.apply(target, thisArg, args);
            });
        }
    });
}
function $a5ef21456dfd7b05$var$instrumentLangChainEmbeddings(instance, options) {
    const embeddingsInstance = instance;
    if (typeof embeddingsInstance.embedQuery === "function") embeddingsInstance.embedQuery = $a5ef21456dfd7b05$var$instrumentEmbeddingMethod(embeddingsInstance.embedQuery, options);
    if (typeof embeddingsInstance.embedDocuments === "function") embeddingsInstance.embedDocuments = $a5ef21456dfd7b05$var$instrumentEmbeddingMethod(embeddingsInstance.embedDocuments, options);
    return instance;
}
module.exports._INTERNAL_getLangChainEmbeddingsSpanOptions = $a5ef21456dfd7b05$var$_INTERNAL_getLangChainEmbeddingsSpanOptions;
module.exports.instrumentEmbeddingMethod = $a5ef21456dfd7b05$var$instrumentEmbeddingMethod;
module.exports.instrumentLangChainEmbeddings = $a5ef21456dfd7b05$var$instrumentLangChainEmbeddings;

});

parcelRegister("dL8qX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2JysJ = parcelRequire("2JysJ");

var $1L2sM = parcelRequire("1L2sM");

var $d33W7 = parcelRequire("d33W7");

var $aewmo = parcelRequire("aewmo");

var $2Qk3n = parcelRequire("2Qk3n");

var $5mc1N = parcelRequire("5mc1N");

var $igulC = parcelRequire("igulC");

var $4x2Gl = parcelRequire("4x2Gl");

var $k1LZl = parcelRequire("k1LZl");

var $2NcBk = parcelRequire("2NcBk");
let $a04634eb433f8ead$var$_insideCreateReactAgent = false;
const $a04634eb433f8ead$var$SENTRY_PATCHED = "__sentry_patched__";
function $a04634eb433f8ead$var$_INTERNAL_getLangGraphCreateAgentSpanOptions(agentName) {
    const attributes = {
        [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $k1LZl.LANGGRAPH_ORIGIN,
        [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.create_agent",
        [$2Qk3n.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "create_agent"
    };
    if (agentName) attributes[$2Qk3n.GEN_AI_AGENT_NAME_ATTRIBUTE] = agentName;
    return {
        op: "gen_ai.create_agent",
        name: agentName ? `create_agent ${agentName}` : "create_agent",
        attributes: attributes
    };
}
function $a04634eb433f8ead$var$instrumentStateGraphCompile(originalCompile, options) {
    if (Object.prototype.hasOwnProperty.call(originalCompile, $a04634eb433f8ead$var$SENTRY_PATCHED)) return originalCompile;
    const sentryHandler = $igulC.createLangChainCallbackHandler(options);
    const wrapped = new Proxy(originalCompile, {
        apply (target, thisArg, args) {
            if ($a04634eb433f8ead$var$_insideCreateReactAgent) return Reflect.apply(target, thisArg, args);
            return $aewmo.startSpan($a04634eb433f8ead$var$_INTERNAL_getLangGraphCreateAgentSpanOptions(), (span)=>{
                try {
                    const compiledGraph = Reflect.apply(target, thisArg, args);
                    const compileOptions = args.length > 0 ? args[0] : {};
                    if (compileOptions?.name && typeof compileOptions.name === "string") {
                        span.setAttribute($2Qk3n.GEN_AI_AGENT_NAME_ATTRIBUTE, compileOptions.name);
                        span.updateName(`create_agent ${compileOptions.name}`);
                    }
                    const originalInvoke = compiledGraph.invoke;
                    if (originalInvoke && typeof originalInvoke === "function") compiledGraph.invoke = $a04634eb433f8ead$var$instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, options, void 0, sentryHandler);
                    return compiledGraph;
                } catch (error) {
                    span.setStatus({
                        code: $d33W7.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    throw error;
                }
            });
        }
    });
    Object.defineProperty(wrapped, $a04634eb433f8ead$var$SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
function $a04634eb433f8ead$var$instrumentCompiledGraphInvoke(originalInvoke, graphInstance, compileOptions, options, llm, sentryCallbackHandler) {
    return new Proxy(originalInvoke, {
        apply (target, thisArg, args) {
            const modelName = llm?.modelName ?? llm?.model;
            return $aewmo.startSpan({
                op: "gen_ai.invoke_agent",
                name: "invoke_agent",
                attributes: {
                    [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $k1LZl.LANGGRAPH_ORIGIN,
                    [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $2Qk3n.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE,
                    [$2Qk3n.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "invoke_agent"
                }
            }, async (span)=>{
                try {
                    const graphName = compileOptions?.name;
                    if (graphName && typeof graphName === "string") {
                        span.setAttribute($2Qk3n.GEN_AI_PIPELINE_NAME_ATTRIBUTE, graphName);
                        span.setAttribute($2Qk3n.GEN_AI_AGENT_NAME_ATTRIBUTE, graphName);
                        span.updateName(`invoke_agent ${graphName}`);
                    }
                    if (modelName) span.setAttribute($2Qk3n.GEN_AI_REQUEST_MODEL_ATTRIBUTE, modelName);
                    const config = args.length > 1 ? args[1] : void 0;
                    const configurable = config?.configurable;
                    const threadId = configurable?.thread_id;
                    if (threadId && typeof threadId === "string") span.setAttribute($2Qk3n.GEN_AI_CONVERSATION_ID_ATTRIBUTE, threadId);
                    if (sentryCallbackHandler) {
                        const invokeConfig = args[1] ?? {};
                        args[1] = invokeConfig;
                        const existingMetadata = invokeConfig.metadata ?? {};
                        invokeConfig.metadata = {
                            ...existingMetadata,
                            __sentry_langgraph__: true,
                            ...typeof graphName === "string" ? {
                                lc_agent_name: graphName
                            } : {}
                        };
                        invokeConfig.callbacks = $4x2Gl._INTERNAL_mergeLangChainCallbackHandler(invokeConfig.callbacks, sentryCallbackHandler);
                    }
                    const tools = $2NcBk.extractToolsFromCompiledGraph(graphInstance);
                    if (tools) span.setAttribute($2Qk3n.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE, JSON.stringify(tools));
                    const recordInputs = options.recordInputs;
                    const recordOutputs = options.recordOutputs;
                    const inputMessages = args.length > 0 ? args[0]?.messages ?? [] : [];
                    if (inputMessages && recordInputs) {
                        const normalizedMessages = $4x2Gl.normalizeLangChainMessages(inputMessages);
                        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $5mc1N.extractSystemInstructions(normalizedMessages);
                        if (systemInstructions) span.setAttribute($2Qk3n.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
                        const enableTruncation = $5mc1N.shouldEnableTruncation(options.enableTruncation);
                        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
                        span.setAttributes({
                            [$2Qk3n.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $5mc1N.getTruncatedJsonString(filteredMessages) : $1L2sM.stringify(filteredMessages),
                            [$2Qk3n.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
                        });
                    }
                    const result = await Reflect.apply(target, thisArg, args);
                    if (recordOutputs) $2NcBk.setResponseAttributes(span, inputMessages ?? null, result);
                    return result;
                } catch (error) {
                    span.setStatus({
                        code: $d33W7.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    throw error;
                }
            });
        }
    });
}
function $a04634eb433f8ead$var$instrumentCreateReactAgent(originalCreateReactAgent, options) {
    if (Object.prototype.hasOwnProperty.call(originalCreateReactAgent, $a04634eb433f8ead$var$SENTRY_PATCHED)) return originalCreateReactAgent;
    const resolvedOptions = $5mc1N.resolveAIRecordingOptions(options);
    const sentryHandler = $igulC.createLangChainCallbackHandler(resolvedOptions);
    const wrapped = new Proxy(originalCreateReactAgent, {
        apply (target, thisArg, args) {
            const llm = $2NcBk.extractLLMFromParams(args);
            const agentName = $2NcBk.extractAgentNameFromParams(args);
            const params = args[0];
            if (params && Array.isArray(params.tools) && params.tools.length > 0) $2NcBk.wrapToolsWithSpans(params.tools, resolvedOptions, agentName ?? void 0);
            $a04634eb433f8ead$var$_insideCreateReactAgent = true;
            let compiledGraph;
            try {
                compiledGraph = Reflect.apply(target, thisArg, args);
            } finally{
                $a04634eb433f8ead$var$_insideCreateReactAgent = false;
            }
            const originalInvoke = compiledGraph.invoke;
            if (originalInvoke && typeof originalInvoke === "function") {
                const compileOptions = {};
                if (agentName) compileOptions.name = agentName;
                compiledGraph.invoke = $a04634eb433f8ead$var$instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, resolvedOptions, llm, sentryHandler);
            }
            return compiledGraph;
        }
    });
    Object.defineProperty(wrapped, $a04634eb433f8ead$var$SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
function $a04634eb433f8ead$var$instrumentStateGraph(stateGraph, options) {
    stateGraph.compile = $a04634eb433f8ead$var$instrumentStateGraphCompile(stateGraph.compile, $5mc1N.resolveAIRecordingOptions(options));
    return stateGraph;
}
const $a04634eb433f8ead$var$instrumentLangGraph = $a04634eb433f8ead$var$instrumentStateGraph;
module.exports._INTERNAL_getLangGraphCreateAgentSpanOptions = $a04634eb433f8ead$var$_INTERNAL_getLangGraphCreateAgentSpanOptions;
module.exports.instrumentCompiledGraphInvoke = $a04634eb433f8ead$var$instrumentCompiledGraphInvoke;
module.exports.instrumentCreateReactAgent = $a04634eb433f8ead$var$instrumentCreateReactAgent;
module.exports.instrumentLangGraph = $a04634eb433f8ead$var$instrumentLangGraph;
module.exports.instrumentStateGraph = $a04634eb433f8ead$var$instrumentStateGraph;
module.exports.instrumentStateGraphCompile = $a04634eb433f8ead$var$instrumentStateGraphCompile;

});
parcelRegister("k1LZl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $e94920236370a926$var$LANGGRAPH_INTEGRATION_NAME = "LangGraph";
const $e94920236370a926$var$LANGGRAPH_ORIGIN = "auto.ai.langgraph";
module.exports.LANGGRAPH_INTEGRATION_NAME = $e94920236370a926$var$LANGGRAPH_INTEGRATION_NAME;
module.exports.LANGGRAPH_ORIGIN = $e94920236370a926$var$LANGGRAPH_ORIGIN;

});

parcelRegister("2NcBk", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2JysJ = parcelRequire("2JysJ");

var $d33W7 = parcelRequire("d33W7");

var $aewmo = parcelRequire("aewmo");

var $2Qk3n = parcelRequire("2Qk3n");

var $4x2Gl = parcelRequire("4x2Gl");

var $k1LZl = parcelRequire("k1LZl");
function $2089eeb22c0327cf$var$extractLLMFromParams(args) {
    const arg = args[0];
    if (typeof arg !== "object" || !arg || !("llm" in arg) || !arg.llm || typeof arg.llm !== "object") return null;
    const llm = arg.llm;
    if (typeof llm.modelName !== "string" && typeof llm.model !== "string") return null;
    return llm;
}
function $2089eeb22c0327cf$var$extractAgentNameFromParams(args) {
    const arg = args[0];
    if (typeof arg === "object" && !!arg && "name" in arg && typeof arg.name === "string") return arg.name;
    return null;
}
function $2089eeb22c0327cf$var$wrapToolsWithSpans(tools, options, agentName) {
    const SENTRY_WRAPPED = "__sentry_tool_wrapped__";
    for (const tool of tools){
        if (!tool || typeof tool !== "object") continue;
        const t = tool;
        const originalInvoke = t.invoke;
        if (typeof originalInvoke !== "function" || Object.prototype.hasOwnProperty.call(t, SENTRY_WRAPPED)) continue;
        const toolName = typeof t.name === "string" ? t.name : "unknown_tool";
        const toolDescription = typeof t.description === "string" ? t.description : void 0;
        const wrappedInvoke = new Proxy(originalInvoke, {
            apply (target, thisArg, args) {
                const spanAttributes = {
                    [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $k1LZl.LANGGRAPH_ORIGIN,
                    [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $2Qk3n.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
                    [$2Qk3n.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "execute_tool",
                    [$2Qk3n.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName,
                    [$2Qk3n.GEN_AI_TOOL_TYPE_ATTRIBUTE]: "function"
                };
                const callConfig = args[1];
                const callAgentName = callConfig?.metadata?.lc_agent_name ?? agentName;
                if (typeof callAgentName === "string") spanAttributes[$2Qk3n.GEN_AI_AGENT_NAME_ATTRIBUTE] = callAgentName;
                if (toolDescription) spanAttributes[$2Qk3n.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = toolDescription;
                const input = args[0];
                if (typeof input === "object" && !!input) {
                    if ("id" in input && typeof input.id === "string") spanAttributes[$2Qk3n.GEN_AI_TOOL_CALL_ID_ATTRIBUTE] = input.id;
                    if (options.recordInputs) {
                        const toolArgs = "args" in input && typeof input.args === "object" ? input.args : input;
                        try {
                            spanAttributes[$2Qk3n.GEN_AI_TOOL_INPUT_ATTRIBUTE] = JSON.stringify(toolArgs);
                        } catch  {}
                    }
                }
                return $aewmo.startSpan({
                    op: $2Qk3n.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
                    name: `execute_tool ${toolName}`,
                    attributes: spanAttributes
                }, async (span)=>{
                    try {
                        const result = await Reflect.apply(target, thisArg, args);
                        if (options.recordOutputs) try {
                            const resultObj = result;
                            const content = resultObj && typeof resultObj === "object" && "content" in resultObj ? resultObj.content : result;
                            span.setAttribute($2Qk3n.GEN_AI_TOOL_OUTPUT_ATTRIBUTE, typeof content === "string" ? content : JSON.stringify(content));
                        } catch  {}
                        return result;
                    } catch (error) {
                        span.setStatus({
                            code: $d33W7.SPAN_STATUS_ERROR,
                            message: "internal_error"
                        });
                        throw error;
                    }
                });
            }
        });
        t.invoke = wrappedInvoke;
        Object.defineProperty(t, SENTRY_WRAPPED, {
            value: true,
            enumerable: false
        });
    }
    return tools;
}
function $2089eeb22c0327cf$var$extractToolCalls(messages) {
    if (!messages || messages.length === 0) return null;
    const toolCalls = [];
    for (const message of messages)if (message && typeof message === "object") {
        const msgToolCalls = message.tool_calls;
        if (msgToolCalls && Array.isArray(msgToolCalls)) toolCalls.push(...msgToolCalls);
    }
    return toolCalls.length > 0 ? toolCalls : null;
}
function $2089eeb22c0327cf$var$extractTokenUsageFromMessage(message) {
    const msg = message;
    let inputTokens = 0;
    let outputTokens = 0;
    let totalTokens = 0;
    if (msg.usage_metadata && typeof msg.usage_metadata === "object") {
        const usage = msg.usage_metadata;
        if (typeof usage.input_tokens === "number") inputTokens = usage.input_tokens;
        if (typeof usage.output_tokens === "number") outputTokens = usage.output_tokens;
        if (typeof usage.total_tokens === "number") totalTokens = usage.total_tokens;
        return {
            inputTokens: inputTokens,
            outputTokens: outputTokens,
            totalTokens: totalTokens
        };
    }
    if (msg.response_metadata && typeof msg.response_metadata === "object") {
        const metadata = msg.response_metadata;
        if (metadata.tokenUsage && typeof metadata.tokenUsage === "object") {
            const tokenUsage = metadata.tokenUsage;
            if (typeof tokenUsage.promptTokens === "number") inputTokens = tokenUsage.promptTokens;
            if (typeof tokenUsage.completionTokens === "number") outputTokens = tokenUsage.completionTokens;
            if (typeof tokenUsage.totalTokens === "number") totalTokens = tokenUsage.totalTokens;
        }
    }
    return {
        inputTokens: inputTokens,
        outputTokens: outputTokens,
        totalTokens: totalTokens
    };
}
function $2089eeb22c0327cf$var$extractModelMetadata(span, message) {
    const msg = message;
    if (msg.response_metadata && typeof msg.response_metadata === "object") {
        const metadata = msg.response_metadata;
        if (metadata.model_name && typeof metadata.model_name === "string") span.setAttribute($2Qk3n.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, metadata.model_name);
        if (metadata.finish_reason && typeof metadata.finish_reason === "string") span.setAttribute($2Qk3n.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, [
            metadata.finish_reason
        ]);
    }
}
function $2089eeb22c0327cf$var$extractToolsFromCompiledGraph(compiledGraph) {
    if (!compiledGraph.builder?.nodes?.tools?.runnable?.tools) return null;
    const tools = compiledGraph.builder?.nodes?.tools?.runnable?.tools;
    if (!tools || !Array.isArray(tools) || tools.length === 0) return null;
    return tools.map((tool)=>({
            name: tool.lc_kwargs?.name,
            description: tool.lc_kwargs?.description,
            schema: tool.lc_kwargs?.schema
        }));
}
function $2089eeb22c0327cf$var$setResponseAttributes(span, inputMessages, result) {
    const resultObj = result;
    const outputMessages = resultObj?.messages;
    if (!outputMessages || !Array.isArray(outputMessages)) return;
    const inputCount = inputMessages?.length ?? 0;
    const newMessages = outputMessages.length > inputCount ? outputMessages.slice(inputCount) : [];
    if (newMessages.length === 0) return;
    const toolCalls = $2089eeb22c0327cf$var$extractToolCalls(newMessages);
    if (toolCalls) span.setAttribute($2Qk3n.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, JSON.stringify(toolCalls));
    const normalizedNewMessages = $4x2Gl.normalizeLangChainMessages(newMessages);
    span.setAttribute($2Qk3n.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, JSON.stringify(normalizedNewMessages));
    let totalInputTokens = 0;
    let totalOutputTokens = 0;
    let totalTokens = 0;
    for (const message of newMessages){
        const tokens = $2089eeb22c0327cf$var$extractTokenUsageFromMessage(message);
        totalInputTokens += tokens.inputTokens;
        totalOutputTokens += tokens.outputTokens;
        totalTokens += tokens.totalTokens;
        $2089eeb22c0327cf$var$extractModelMetadata(span, message);
    }
    if (totalInputTokens > 0) span.setAttribute($2Qk3n.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, totalInputTokens);
    if (totalOutputTokens > 0) span.setAttribute($2Qk3n.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, totalOutputTokens);
    if (totalTokens > 0) span.setAttribute($2Qk3n.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, totalTokens);
}
module.exports.extractAgentNameFromParams = $2089eeb22c0327cf$var$extractAgentNameFromParams;
module.exports.extractLLMFromParams = $2089eeb22c0327cf$var$extractLLMFromParams;
module.exports.extractModelMetadata = $2089eeb22c0327cf$var$extractModelMetadata;
module.exports.extractTokenUsageFromMessage = $2089eeb22c0327cf$var$extractTokenUsageFromMessage;
module.exports.extractToolCalls = $2089eeb22c0327cf$var$extractToolCalls;
module.exports.extractToolsFromCompiledGraph = $2089eeb22c0327cf$var$extractToolsFromCompiledGraph;
module.exports.setResponseAttributes = $2089eeb22c0327cf$var$setResponseAttributes;
module.exports.wrapToolsWithSpans = $2089eeb22c0327cf$var$wrapToolsWithSpans;

});


parcelRegister("6zlry", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jV7hg = parcelRequire("jV7hg");

var $d33W7 = parcelRequire("d33W7");

var $aewmo = parcelRequire("aewmo");

var $7it17 = parcelRequire("7it17");

var $5mc1N = parcelRequire("5mc1N");

var $2glvn = parcelRequire("2glvn");

var $9iub6 = parcelRequire("9iub6");

var $lFvBt = parcelRequire("lFvBt");
function $4c86a5324ebf92b9$var$isReadableStream(value) {
    return $jV7hg.isObjectLike(value) && typeof value.pipeThrough === "function" && typeof value.getReader === "function";
}
function $4c86a5324ebf92b9$var$instrumentRun(originalRun, context, options) {
    return function instrumentedRun(...args) {
        if ($7it17._INTERNAL_shouldSkipAiProviderWrapping($2glvn.WORKERS_AI_INTEGRATION_NAME)) return originalRun.apply(context, args);
        const [model, inputs, runOptions] = args;
        const operationName = $lFvBt.getOperationName(inputs);
        const requestAttributes = $lFvBt.extractRequestAttributes(model, inputs, operationName);
        const modelName = typeof model === "string" ? model : "unknown";
        const isStreamRequested = !!inputs && typeof inputs === "object" && inputs.stream === true;
        const returnsRawResponse = !!runOptions && typeof runOptions === "object" && (runOptions.returnRawResponse === true || runOptions.websocket === true);
        const spanConfig = {
            name: `${operationName} ${modelName}`,
            op: `gen_ai.${operationName}`,
            attributes: requestAttributes
        };
        if (isStreamRequested && !returnsRawResponse) return $aewmo.startSpanManual(spanConfig, (span)=>{
            const handleError = (error)=>{
                span.setStatus({
                    code: $d33W7.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                span.end();
                throw error;
            };
            let originalResult;
            try {
                originalResult = originalRun.apply(context, args);
            } catch (error) {
                return handleError(error);
            }
            if (options.recordInputs) $lFvBt.addRequestAttributes(span, inputs, operationName, $5mc1N.shouldEnableTruncation(options.enableTruncation));
            return originalResult.then((result)=>{
                if ($4c86a5324ebf92b9$var$isReadableStream(result)) return $9iub6.instrumentWorkersAiStream(result, span, options.recordOutputs);
                $lFvBt.addResponseAttributes(span, result, options.recordOutputs);
                span.end();
                return result;
            }, handleError);
        });
        return $aewmo.startSpan(spanConfig, (span)=>{
            const originalResult = originalRun.apply(context, args);
            if (options.recordInputs) $lFvBt.addRequestAttributes(span, inputs, operationName, $5mc1N.shouldEnableTruncation(options.enableTruncation));
            return originalResult.then((result)=>{
                if (!returnsRawResponse) $lFvBt.addResponseAttributes(span, result, options.recordOutputs);
                return result;
            });
        });
    };
}
function $4c86a5324ebf92b9$var$instrumentWorkersAiClient(client, options) {
    const resolvedOptions = $5mc1N.resolveAIRecordingOptions(options);
    const instrumented = new Proxy(client, {
        get (target, prop, receiver) {
            const value = Reflect.get(target, prop, receiver);
            if (prop === "run" && typeof value === "function") return $4c86a5324ebf92b9$var$instrumentRun(value, target, resolvedOptions);
            return typeof value === "function" ? value.bind(target) : value;
        }
    });
    return instrumented;
}
module.exports.instrumentWorkersAiClient = $4c86a5324ebf92b9$var$instrumentWorkersAiClient;

});
parcelRegister("9iub6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d33W7 = parcelRequire("d33W7");

var $5mc1N = parcelRequire("5mc1N");

var $lFvBt = parcelRequire("lFvBt");
function $6c4d3436763c3f93$var$accumulateStreamingToolCalls(toolCalls, accumulator) {
    for (const toolCall of toolCalls){
        const name = toolCall.function?.name ?? toolCall.name;
        const args = toolCall.function?.arguments ?? toolCall.arguments;
        if (name == null && args == null) continue;
        const index = toolCall.index ?? 0;
        const existing = accumulator[index];
        if (!existing) accumulator[index] = {
            index: index,
            id: toolCall.id,
            type: toolCall.type,
            function: {
                name: name,
                arguments: args ?? ""
            }
        };
        else if (existing.function) {
            if (name && !existing.function.name) existing.function.name = name;
            if (args) existing.function.arguments = `${existing.function.arguments ?? ""}${args}`;
        }
    }
}
function $6c4d3436763c3f93$var$processLine(line, state, recordOutputs, toolCallAccumulator) {
    const trimmed = line.trim();
    if (!trimmed.startsWith("data:")) return;
    const data = trimmed.slice(5).trim();
    if (!data || data === "[DONE]") return;
    let parsed;
    try {
        parsed = JSON.parse(data);
    } catch  {
        return;
    }
    if (parsed.usage) {
        if (typeof parsed.usage.prompt_tokens === "number") state.promptTokens = parsed.usage.prompt_tokens;
        if (typeof parsed.usage.completion_tokens === "number") state.completionTokens = parsed.usage.completion_tokens;
        if (typeof parsed.usage.total_tokens === "number") state.totalTokens = parsed.usage.total_tokens;
    }
    if (recordOutputs && typeof parsed.response === "string") state.responseTexts.push(parsed.response);
    if (recordOutputs && Array.isArray(parsed.tool_calls) && parsed.tool_calls.length > 0) state.toolCalls.push(...parsed.tool_calls);
    if (Array.isArray(parsed.choices)) for (const choice of parsed.choices){
        if (recordOutputs && typeof choice.delta?.content === "string" && choice.delta.content) state.responseTexts.push(choice.delta.content);
        if (recordOutputs && Array.isArray(choice.delta?.tool_calls)) $6c4d3436763c3f93$var$accumulateStreamingToolCalls(choice.delta.tool_calls, toolCallAccumulator);
        if (typeof choice.finish_reason === "string") state.finishReasons.push(choice.finish_reason);
    }
}
function $6c4d3436763c3f93$var$instrumentWorkersAiStream(stream, span, recordOutputs) {
    const reader = stream.getReader();
    const decoder = new TextDecoder();
    const state = {
        responseId: "",
        responseModel: "",
        finishReasons: [],
        responseTexts: [],
        toolCalls: [],
        promptTokens: void 0,
        completionTokens: void 0,
        totalTokens: void 0
    };
    const toolCallAccumulator = {};
    let buffer = "";
    let spanEnded = false;
    const finish = ()=>{
        if (spanEnded) return;
        spanEnded = true;
        if (recordOutputs) {
            const accumulatedToolCalls = Object.values(toolCallAccumulator);
            if (accumulatedToolCalls.length > 0) state.toolCalls.push(...accumulatedToolCalls);
            $lFvBt.setOutputMessagesAttribute(span, {
                responseText: state.responseTexts.join(""),
                toolCalls: state.toolCalls
            });
        }
        $5mc1N.endStreamSpan(span, state, recordOutputs);
    };
    const flushBuffer = (isDone)=>{
        const lines = buffer.split("\n");
        buffer = isDone ? "" : lines.pop() ?? "";
        for (const line of lines)$6c4d3436763c3f93$var$processLine(line, state, recordOutputs, toolCallAccumulator);
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await reader.read();
                if (done) {
                    buffer += decoder.decode();
                    flushBuffer(true);
                    finish();
                    controller.close();
                    return;
                }
                buffer += decoder.decode(value, {
                    stream: true
                });
                flushBuffer(false);
                controller.enqueue(value);
            } catch (error) {
                span.setStatus({
                    code: $d33W7.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                finish();
                controller.error(error);
            }
        },
        async cancel (reason) {
            finish();
            await reader.cancel(reason);
        }
    });
}
module.exports.instrumentWorkersAiStream = $6c4d3436763c3f93$var$instrumentWorkersAiStream;

});
parcelRegister("lFvBt", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3tmPs = parcelRequire("3tmPs");

var $2JysJ = parcelRequire("2JysJ");

var $2Qk3n = parcelRequire("2Qk3n");

var $5mc1N = parcelRequire("5mc1N");

var $1L2sM = parcelRequire("1L2sM");

var $2glvn = parcelRequire("2glvn");
function $fc65f114fffdd9ca$var$getOperationName(inputs) {
    if (inputs && typeof inputs === "object") {
        if ("messages" in inputs || "prompt" in inputs) return "chat";
        if ("text" in inputs) return "embeddings";
    }
    return "chat";
}
function $fc65f114fffdd9ca$var$extractRequestAttributes(model, inputs, operationName) {
    const attributes$1 = {
        [$3tmPs.GEN_AI_PROVIDER_NAME]: $2glvn.WORKERS_AI_PROVIDER_NAME,
        [$3tmPs.GEN_AI_OPERATION_NAME]: operationName,
        [$2JysJ.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $2glvn.WORKERS_AI_ORIGIN,
        [$3tmPs.GEN_AI_REQUEST_MODEL]: typeof model === "string" ? model : "unknown"
    };
    if (inputs && typeof inputs === "object") {
        const params = inputs;
        if (typeof params.temperature === "number") attributes$1[$3tmPs.GEN_AI_REQUEST_TEMPERATURE] = params.temperature;
        if (typeof params.max_tokens === "number") attributes$1[$3tmPs.GEN_AI_REQUEST_MAX_TOKENS] = params.max_tokens;
        if (typeof params.top_p === "number") attributes$1[$3tmPs.GEN_AI_REQUEST_TOP_P] = params.top_p;
        if (typeof params.top_k === "number") attributes$1[$3tmPs.GEN_AI_REQUEST_TOP_K] = params.top_k;
        if (typeof params.frequency_penalty === "number") attributes$1[$3tmPs.GEN_AI_REQUEST_FREQUENCY_PENALTY] = params.frequency_penalty;
        if (typeof params.presence_penalty === "number") attributes$1[$3tmPs.GEN_AI_REQUEST_PRESENCE_PENALTY] = params.presence_penalty;
        if (params.stream === true) attributes$1[$2Qk3n.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = true;
    }
    return attributes$1;
}
function $fc65f114fffdd9ca$var$addRequestAttributes(span, inputs, operationName, enableTruncation) {
    if (!inputs || typeof inputs !== "object") return;
    const params = inputs;
    if (operationName === "embeddings") {
        const text = params.text;
        if (text == null || typeof text === "string" && text.length === 0 || Array.isArray(text) && text.length === 0) return;
        span.setAttribute($3tmPs.GEN_AI_EMBEDDINGS_INPUT, typeof text === "string" ? text : JSON.stringify(text));
        return;
    }
    const src = params.messages ?? params.prompt;
    if (src == null || Array.isArray(src) && src.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $5mc1N.extractSystemInstructions(src);
    if (systemInstructions) span.setAttribute($3tmPs.GEN_AI_SYSTEM_INSTRUCTIONS, systemInstructions);
    span.setAttribute($3tmPs.GEN_AI_INPUT_MESSAGES, enableTruncation ? $5mc1N.getTruncatedJsonString(filteredMessages) : $1L2sM.stringify(filteredMessages));
    span.setAttribute($2Qk3n.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, Array.isArray(filteredMessages) ? filteredMessages.length : 1);
}
function $fc65f114fffdd9ca$var$setOutputMessagesAttribute(span, { responseText: responseText, toolCalls: toolCalls }) {
    const parts = [];
    if (typeof responseText === "string" && responseText.length > 0) parts.push({
        type: "text",
        content: responseText
    });
    if (Array.isArray(toolCalls)) for (const toolCall of toolCalls){
        if (!toolCall || typeof toolCall !== "object") continue;
        const call = toolCall;
        const name = call.function?.name ?? call.name;
        const args = call.function?.arguments ?? call.arguments;
        parts.push({
            type: "tool_call",
            id: call.id,
            name: name,
            arguments: typeof args === "string" ? args : JSON.stringify(args ?? {})
        });
    }
    if (parts.length > 0) span.setAttribute($2Qk3n.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE, JSON.stringify([
        {
            role: "assistant",
            parts: parts
        }
    ]));
}
function $fc65f114fffdd9ca$var$addResponseAttributes(span, result, recordOutputs) {
    if (!result || typeof result !== "object" || // Raw `Response` objects (from `returnRawResponse`/`websocket`) cannot be introspected without consuming them.
    typeof Response !== "undefined" && result instanceof Response) return;
    const response = result;
    if (response.usage) $5mc1N.setTokenUsageAttributes(span, response.usage.prompt_tokens, response.usage.completion_tokens);
    if (recordOutputs) {
        let responseText;
        if (typeof response.response === "string") {
            responseText = response.response;
            span.setAttribute($2Qk3n.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, response.response);
        } else if (response.response != null) {
            responseText = JSON.stringify(response.response);
            span.setAttribute($2Qk3n.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, responseText);
        }
        const toolCalls = Array.isArray(response.tool_calls) && response.tool_calls.length > 0 ? response.tool_calls : void 0;
        if (toolCalls) span.setAttribute($2Qk3n.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, JSON.stringify(toolCalls));
        $fc65f114fffdd9ca$var$setOutputMessagesAttribute(span, {
            responseText: responseText,
            toolCalls: toolCalls
        });
    }
}
module.exports.addRequestAttributes = $fc65f114fffdd9ca$var$addRequestAttributes;
module.exports.addResponseAttributes = $fc65f114fffdd9ca$var$addResponseAttributes;
module.exports.extractRequestAttributes = $fc65f114fffdd9ca$var$extractRequestAttributes;
module.exports.getOperationName = $fc65f114fffdd9ca$var$getOperationName;
module.exports.setOutputMessagesAttribute = $fc65f114fffdd9ca$var$setOutputMessagesAttribute;

});



parcelRegister("kHfIQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1GyI0 = parcelRequire("1GyI0");

var $2sm2V = parcelRequire("2sm2V");

var $aRuEF = parcelRequire("aRuEF");

var $dOSrX = parcelRequire("dOSrX");

var $gqgJp = parcelRequire("gqgJp");

var $i3WRf = parcelRequire("i3WRf");
const $f11404e84f6adb9f$var$MAX_SPANS_PER_ENVELOPE = 1e3;
const $f11404e84f6adb9f$var$MAX_TRACE_WEIGHT_IN_BYTES = 5e6;
class $f11404e84f6adb9f$var$SpanBuffer {
    constructor(client, options){
        this._traceBuckets = /* @__PURE__ */ new Map();
        this._client = client;
        const { maxSpanLimit: maxSpanLimit, flushInterval: flushInterval, maxTraceWeightInBytes: maxTraceWeightInBytes } = options ?? {};
        this._maxSpanLimit = maxSpanLimit && maxSpanLimit > 0 && maxSpanLimit <= $f11404e84f6adb9f$var$MAX_SPANS_PER_ENVELOPE ? maxSpanLimit : $f11404e84f6adb9f$var$MAX_SPANS_PER_ENVELOPE;
        this._flushInterval = flushInterval && flushInterval > 0 ? flushInterval : 5e3;
        this._maxTraceWeight = maxTraceWeightInBytes && maxTraceWeightInBytes > 0 ? maxTraceWeightInBytes : $f11404e84f6adb9f$var$MAX_TRACE_WEIGHT_IN_BYTES;
        this._client.on("flush", ()=>{
            this.drain();
        });
        this._client.on("close", ()=>{
            this._traceBuckets.forEach((bucket)=>{
                clearTimeout(bucket.timeout);
            });
            this._traceBuckets.clear();
        });
    }
    /**
   * Add a span to the buffer.
   */ add(spanJSON) {
        const traceId = spanJSON.trace_id;
        let bucket = this._traceBuckets.get(traceId);
        if (!bucket) {
            bucket = {
                spans: /* @__PURE__ */ new Set(),
                size: 0,
                timeout: $aRuEF.safeUnref(setTimeout(()=>{
                    this.flush(traceId);
                }, this._flushInterval))
            };
            this._traceBuckets.set(traceId, bucket);
        }
        bucket.spans.add(spanJSON);
        bucket.size += $i3WRf.estimateSerializedSpanSizeInBytes(spanJSON);
        if (bucket.spans.size >= this._maxSpanLimit || bucket.size >= this._maxTraceWeight) this.flush(traceId);
    }
    /**
   * Drain and flush all buffered traces.
   */ drain() {
        if (!this._traceBuckets.size) return;
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.log(`Flushing span tree map with ${this._traceBuckets.size} traces`);
        this._traceBuckets.forEach((_, traceId)=>{
            this.flush(traceId);
        });
    }
    /**
   * Flush spans of a specific trace.
   * In contrast to {@link SpanBuffer.drain}, this method does not flush all traces, but only the one with the given traceId.
   */ flush(traceId) {
        const bucket = this._traceBuckets.get(traceId);
        if (!bucket) return;
        if (!bucket.spans.size) {
            this._removeTrace(traceId);
            return;
        }
        const spans = Array.from(bucket.spans);
        const segmentSpan = spans[0]?._segmentSpan;
        if (!segmentSpan) {
            $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn("No segment span reference found on span JSON, cannot compute DSC");
            this._removeTrace(traceId);
            return;
        }
        const dsc = $dOSrX.getDynamicSamplingContextFromSpan(segmentSpan);
        const cleanedSpans = spans.map((spanJSON)=>{
            const { _segmentSpan: _segmentSpan, ...cleanSpanJSON } = spanJSON;
            return cleanSpanJSON;
        });
        const envelope$1 = $gqgJp.createStreamedSpanEnvelope(cleanedSpans, dsc, this._client);
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.log(`Sending span envelope for trace ${traceId} with ${cleanedSpans.length} spans`);
        this._client.sendEnvelope(envelope$1).then(null, (reason)=>{
            $1GyI0.DEBUG_BUILD && $2sm2V.debug.error("Error while sending streamed span envelope:", reason);
        });
        this._removeTrace(traceId);
    }
    _removeTrace(traceId) {
        const bucket = this._traceBuckets.get(traceId);
        if (bucket) clearTimeout(bucket.timeout);
        this._traceBuckets.delete(traceId);
    }
}
module.exports.SpanBuffer = $f11404e84f6adb9f$var$SpanBuffer;

});
parcelRegister("gqgJp", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ebmC5 = parcelRequire("ebmC5");

var $kAeXb = parcelRequire("kAeXb");

var $iyFot = parcelRequire("iyFot");

var $6ki8f = parcelRequire("6ki8f");
function $bf4c0d902a668dc0$var$createStreamedSpanEnvelope(serializedSpans, dsc, client) {
    const options = client.getOptions();
    const dsn$1 = client.getDsn();
    const tunnel = options.tunnel;
    const sdk = $kAeXb.getSdkMetadataForEnvelopeHeader(options._metadata);
    const headers = {
        sent_at: new Date($6ki8f.safeDateNow()).toISOString(),
        ...$bf4c0d902a668dc0$var$dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...sdk && {
            sdk: sdk
        },
        ...!!tunnel && dsn$1 && {
            dsn: $ebmC5.dsnToString(dsn$1)
        }
    };
    const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
    const spanContainer = [
        {
            type: "span",
            item_count: serializedSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        {
            version: 2,
            ...$iyFot.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: serializedSpans
        }
    ];
    return $kAeXb.createEnvelope(headers, [
        spanContainer
    ]);
}
function $bf4c0d902a668dc0$var$dscHasRequiredProps(dsc) {
    return !!dsc.trace_id && !!dsc.public_key;
}
module.exports.createStreamedSpanEnvelope = $bf4c0d902a668dc0$var$createStreamedSpanEnvelope;

});

parcelRegister("i3WRf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ary0D = parcelRequire("ary0D");
function $d26629c29032fc63$var$estimateSerializedSpanSizeInBytes(span) {
    let weight = 156;
    weight += span.name.length * 2;
    weight += $ary0D.estimateTypedAttributesSizeInBytes(span.attributes);
    if (span.links && span.links.length > 0) {
        const firstLink = span.links[0];
        const attributes$1 = firstLink?.attributes;
        const linkWeight = 100 + (attributes$1 ? $ary0D.estimateTypedAttributesSizeInBytes(attributes$1) : 0);
        weight += linkWeight * span.links.length;
    }
    return weight;
}
module.exports.estimateSerializedSpanSizeInBytes = $d26629c29032fc63$var$estimateSerializedSpanSizeInBytes;

});


parcelRegister("dFamO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1GyI0 = parcelRequire("1GyI0");

var $5vlAD = parcelRequire("5vlAD");

var $7O6Z7 = parcelRequire("7O6Z7");

var $2ZTbI = parcelRequire("2ZTbI");

var $g8Glr = parcelRequire("g8Glr");

var $kHfIQ = parcelRequire("kHfIQ");

var $2sm2V = parcelRequire("2sm2V");

var $8hCvI = parcelRequire("8hCvI");
const $9f27255586aa14fe$var$spanStreamingIntegration = $5vlAD.defineIntegration(()=>{
    return {
        name: "SpanStreaming",
        setup (client) {
            const initialMessage = "SpanStreaming integration requires";
            const fallbackMsg = "Falling back to static trace lifecycle.";
            const clientOptions = client.getOptions();
            if (!$g8Glr.hasSpanStreamingEnabled(client)) {
                clientOptions.traceLifecycle = "static";
                $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn(`${initialMessage} \`traceLifecycle\` to be set to "stream"! ${fallbackMsg}`);
                return;
            }
            const beforeSendSpan$1 = clientOptions.beforeSendSpan;
            if (beforeSendSpan$1 && !$7O6Z7.isStreamedBeforeSendSpanCallback(beforeSendSpan$1)) {
                clientOptions.traceLifecycle = "static";
                $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn(`${initialMessage} a beforeSendSpan callback using \`withStreamedSpan\`! ${fallbackMsg}`);
                return;
            }
            const buffer = new $kHfIQ.SpanBuffer(client);
            client.on("afterSpanEnd", (span)=>{
                if (!$8hCvI.spanIsSampled(span)) return;
                buffer.add($2ZTbI.captureSpan(span, client));
            });
        }
    };
});
module.exports.spanStreamingIntegration = $9f27255586aa14fe$var$spanStreamingIntegration;

});

parcelRegister("jHjIi", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $e5715326d4958721$var$getBreadcrumbLogLevelFromHttpStatusCode(statusCode) {
    if (statusCode === void 0) return void 0;
    else if (statusCode >= 400 && statusCode < 500) return "warning";
    else if (statusCode >= 500) return "error";
    else return void 0;
}
module.exports.getBreadcrumbLogLevelFromHttpStatusCode = $e5715326d4958721$var$getBreadcrumbLogLevelFromHttpStatusCode;

});

parcelRegister("eLMe1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
class $ac0add03193c33d7$var$SentryError extends Error {
    constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.logLevel = logLevel;
    }
}
module.exports.SentryError = $ac0add03193c33d7$var$SentryError;

});

parcelRegister("jl6r7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kfJmY = parcelRequire("kfJmY");

var $jV7hg = parcelRequire("jV7hg");

var $65lWX = parcelRequire("65lWX");

var $cx0Sh = parcelRequire("cx0Sh");

var $gU6V8 = parcelRequire("gU6V8");

var $fxVZv = parcelRequire("fxVZv");

var $2t0Z7 = parcelRequire("2t0Z7");
function $e144f8a50e55149e$var$addFetchInstrumentationHandler(handler, skipNativeFetchCheck) {
    const type = "fetch";
    const removeHandler = $2t0Z7.addHandler(type, handler);
    $2t0Z7.maybeInstrument(type, ()=>$e144f8a50e55149e$var$instrumentFetch(void 0, skipNativeFetchCheck));
    return removeHandler;
}
function $e144f8a50e55149e$var$addFetchEndInstrumentationHandler(handler) {
    const type = "fetch-body-resolved";
    const removeHandler = $2t0Z7.addHandler(type, handler);
    $2t0Z7.maybeInstrument(type, ()=>$e144f8a50e55149e$var$instrumentFetch($e144f8a50e55149e$var$streamHandler));
    return removeHandler;
}
function $e144f8a50e55149e$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !$cx0Sh.supportsNativeFetch()) return;
    $65lWX.fill($fxVZv.GLOBAL_OBJ, "fetch", function(originalFetch) {
        return function(...args) {
            const virtualError = new Error();
            const { method: method, url: url } = $e144f8a50e55149e$var$parseFetchArgs(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: $gU6V8.timestampInSeconds() * 1e3,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $e144f8a50e55149e$var$getHeadersFromFetchArgs(args)
            };
            if (!onFetchResolved) $2t0Z7.triggerHandlers("fetch", {
                ...handlerData
            });
            return originalFetch.apply($fxVZv.GLOBAL_OBJ, args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else $2t0Z7.triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: $gU6V8.timestampInSeconds() * 1e3,
                    response: response
                });
                return response;
            }, (error)=>{
                $2t0Z7.triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: $gU6V8.timestampInSeconds() * 1e3,
                    error: error
                });
                if ($jV7hg.isError(error) && error.stack === void 0) {
                    error.stack = virtualError.stack;
                    $65lWX.addNonEnumerableProperty(error, "framesToPop", 1);
                }
                const client = $kfJmY.getClient();
                const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? "always";
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && $jV7hg.isError(error) && error.name === "TypeError" && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) try {
                    const url2 = new URL(handlerData.fetchData.url);
                    const hostname = url2.host;
                    if (enhanceOption === "always") error.message = `${error.message} (${hostname})`;
                    else $65lWX.addNonEnumerableProperty(error, "__sentry_fetch_url_host__", hostname);
                } catch  {}
                throw error;
            });
        };
    });
}
async function $e144f8a50e55149e$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{});
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{});
                }, 5e3);
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{});
    }
}
function $e144f8a50e55149e$var$streamHandler(response) {
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    $e144f8a50e55149e$var$resolveResponse(clonedResponseForResolving, ()=>{
        $2t0Z7.triggerHandlers("fetch-body-resolved", {
            endTimestamp: $gU6V8.timestampInSeconds() * 1e3,
            response: response
        });
    });
}
function $e144f8a50e55149e$var$hasProp(obj, prop) {
    return $jV7hg.isObjectLike(obj) && !!obj[prop];
}
function $e144f8a50e55149e$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($e144f8a50e55149e$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
function $e144f8a50e55149e$var$parseFetchArgs(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $e144f8a50e55149e$var$getUrlFromResource(resource),
            method: $e144f8a50e55149e$var$hasProp(options, "method") ? String(options.method).toUpperCase() : // Request object as first argument
            $jV7hg.isRequest(resource) && $e144f8a50e55149e$var$hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $e144f8a50e55149e$var$getUrlFromResource(arg),
        method: $e144f8a50e55149e$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
function $e144f8a50e55149e$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ($jV7hg.isRequest(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {}
    return;
}
module.exports.addFetchEndInstrumentationHandler = $e144f8a50e55149e$var$addFetchEndInstrumentationHandler;
module.exports.addFetchInstrumentationHandler = $e144f8a50e55149e$var$addFetchInstrumentationHandler;
module.exports.parseFetchArgs = $e144f8a50e55149e$var$parseFetchArgs;

});
parcelRegister("cx0Sh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1GyI0 = parcelRequire("1GyI0");

var $2sm2V = parcelRequire("2sm2V");

var $fxVZv = parcelRequire("fxVZv");
const $91f93ec176c14f2f$var$WINDOW = $fxVZv.GLOBAL_OBJ;
function $91f93ec176c14f2f$var$supportsErrorEvent() {
    try {
        new ErrorEvent("");
        return true;
    } catch  {
        return false;
    }
}
function $91f93ec176c14f2f$var$supportsDOMError() {
    try {
        new DOMError("");
        return true;
    } catch  {
        return false;
    }
}
function $91f93ec176c14f2f$var$supportsDOMException() {
    try {
        new DOMException("");
        return true;
    } catch  {
        return false;
    }
}
function $91f93ec176c14f2f$var$supportsHistory() {
    return "history" in $91f93ec176c14f2f$var$WINDOW && !!$91f93ec176c14f2f$var$WINDOW.history;
}
const $91f93ec176c14f2f$var$supportsFetch = $91f93ec176c14f2f$var$_isFetchSupported;
function $91f93ec176c14f2f$var$_isFetchSupported() {
    if (!("fetch" in $91f93ec176c14f2f$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("data:,");
        new Response();
        return true;
    } catch  {
        return false;
    }
}
function $91f93ec176c14f2f$var$isNativeFunction(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $91f93ec176c14f2f$var$supportsNativeFetch() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$91f93ec176c14f2f$var$_isFetchSupported()) return false;
    if ($91f93ec176c14f2f$var$isNativeFunction($91f93ec176c14f2f$var$WINDOW.fetch)) return true;
    let result = false;
    const doc = $91f93ec176c14f2f$var$WINDOW.document;
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) result = $91f93ec176c14f2f$var$isNativeFunction(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        $1GyI0.DEBUG_BUILD && $2sm2V.debug.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $91f93ec176c14f2f$var$supportsReportingObserver() {
    return "ReportingObserver" in $91f93ec176c14f2f$var$WINDOW;
}
function $91f93ec176c14f2f$var$supportsReferrerPolicy() {
    if (!$91f93ec176c14f2f$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch  {
        return false;
    }
}
module.exports.isNativeFunction = $91f93ec176c14f2f$var$isNativeFunction;
module.exports.supportsDOMError = $91f93ec176c14f2f$var$supportsDOMError;
module.exports.supportsDOMException = $91f93ec176c14f2f$var$supportsDOMException;
module.exports.supportsErrorEvent = $91f93ec176c14f2f$var$supportsErrorEvent;
module.exports.supportsFetch = $91f93ec176c14f2f$var$supportsFetch;
module.exports.supportsHistory = $91f93ec176c14f2f$var$supportsHistory;
module.exports.supportsNativeFetch = $91f93ec176c14f2f$var$supportsNativeFetch;
module.exports.supportsReferrerPolicy = $91f93ec176c14f2f$var$supportsReferrerPolicy;
module.exports.supportsReportingObserver = $91f93ec176c14f2f$var$supportsReportingObserver;

});


parcelRegister("jK6Ba", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $e5f76e84b37f752d$var$replaceExports(exports1, exportName, wrappedConstructor) {
    const original = exports1[exportName];
    if (typeof original !== "function") return;
    try {
        exports1[exportName] = wrappedConstructor;
    } catch  {
        Object.defineProperty(exports1, exportName, {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
    if (exports1.default === original) try {
        exports1.default = wrappedConstructor;
    } catch  {
        Object.defineProperty(exports1, "default", {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
}
module.exports.replaceExports = $e5f76e84b37f752d$var$replaceExports;

});

parcelRegister("btfMK", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
class $859ea5c6324802e3$var$LRUMap {
    constructor(_maxSize){
        this._maxSize = _maxSize;
        this._cache = /* @__PURE__ */ new Map();
    }
    /** Get the current size of the cache */ get size() {
        return this._cache.size;
    }
    /** Get an entry or undefined if it was not in the cache. Re-inserts to update the recently used order */ get(key) {
        const value = this._cache.get(key);
        if (value === void 0) return void 0;
        this._cache.delete(key);
        this._cache.set(key, value);
        return value;
    }
    /** Insert an entry and evict an older entry if we've reached maxSize */ set(key, value) {
        if (this._cache.size >= this._maxSize) {
            const nextKey = this._cache.keys().next().value;
            this._cache.delete(nextKey);
        }
        this._cache.set(key, value);
    }
    /** Remove an entry and return the entry if it was in the cache */ remove(key) {
        const value = this._cache.get(key);
        if (value) this._cache.delete(key);
        return value;
    }
    /** Clear all entries */ clear() {
        this._cache.clear();
    }
    /** Get all the keys */ keys() {
        return Array.from(this._cache.keys());
    }
    /** Get all the values */ values() {
        const values = [];
        this._cache.forEach((value)=>values.push(value));
        return values;
    }
}
module.exports.LRUMap = $859ea5c6324802e3$var$LRUMap;

});

parcelRegister("by1rx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $8683fd47453a914a$var$escapeStringForRegex(regexString) {
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
module.exports.escapeStringForRegex = $8683fd47453a914a$var$escapeStringForRegex;

});

parcelRegister("1AuHE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jV7hg = parcelRequire("jV7hg");

var $fxVZv = parcelRequire("fxVZv");
const $1280f838ccc5ae10$var$WINDOW = $fxVZv.GLOBAL_OBJ;
const $1280f838ccc5ae10$var$DEFAULT_MAX_STRING_LENGTH = 80;
function $1280f838ccc5ae10$var$htmlTreeAsString(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $1280f838ccc5ae10$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $1280f838ccc5ae10$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $1280f838ccc5ae10$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    if ($1280f838ccc5ae10$var$WINDOW.HTMLElement) {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && $jV7hg.isString(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
function $1280f838ccc5ae10$var$getLocationHref() {
    try {
        return $1280f838ccc5ae10$var$WINDOW.document.location.href;
    } catch  {
        return "";
    }
}
function $1280f838ccc5ae10$var$getComponentName(elem, maxTraverseHeight = 5) {
    if (!$1280f838ccc5ae10$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}
module.exports.getComponentName = $1280f838ccc5ae10$var$getComponentName;
module.exports.getLocationHref = $1280f838ccc5ae10$var$getLocationHref;
module.exports.htmlTreeAsString = $1280f838ccc5ae10$var$htmlTreeAsString;

});


parcelRegister("dLGML", function(module, exports) {
$parcel$export(module.exports, "useCallbackOne", () => $a060da77483cc5d3$export$33752cf3ee811995);

var $5FkrB = parcelRequire("5FkrB");
function $a060da77483cc5d3$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $a060da77483cc5d3$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $5FkrB.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $5FkrB.useRef)(true);
    var committed = (0, $5FkrB.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $a060da77483cc5d3$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $5FkrB.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $a060da77483cc5d3$export$33752cf3ee811995(callback, inputs) {
    return $a060da77483cc5d3$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $a060da77483cc5d3$export$1538c33de8887b59 = $a060da77483cc5d3$export$b6feb8998cd9b342;
var $a060da77483cc5d3$export$35808ee640e87ca7 = $a060da77483cc5d3$export$33752cf3ee811995;

});

parcelRegister("iyyOp", function(module, exports) {
$parcel$export(module.exports, "default", () => $d82667e77467cbe0$export$2e2bcd8739ae039);

var $46PbR = parcelRequire("46PbR");
var $d82667e77467cbe0$export$2e2bcd8739ae039 = (0, $46PbR.default);

});
parcelRegister("46PbR", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fdf6e45620f1c96$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
var $2fdf6e45620f1c96$var$AnalyticsNextContext = (0, $5FkrB.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $2fdf6e45620f1c96$export$2e2bcd8739ae039 = $2fdf6e45620f1c96$var$AnalyticsNextContext;

});


parcelRegister("grMmj", function(module, exports) {
"use strict";
var $bf94ae067b2b0f38$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bf94ae067b2b0f38$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $bf94ae067b2b0f38$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("9KQ0P")).Diagnostics;
    }
});

var $jy0Ff = parcelRequire("jy0Ff");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $jy0Ff.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("ekewr")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("jS2zt")).Storage;
    }
});

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("lJw3W")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("62RBj")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("hnVlx")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("jMmDh")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("9KQ0P")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("6yz2S")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("eZSY0")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("dmOG6")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("3PlSU")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("9iLPp")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("55qzU")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("ekewr")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("fwXVh")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("inXWh")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("6zg9m")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("6DBHb")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("iaO1m")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("koANL")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("fLKwt")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("9owgm")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("geNcE")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("5QBCY")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("9d3om")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("c9Q9s")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("9fgfE")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("9CGjT")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("jG7m1")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("9wYYG")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("8kghQ")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("jx6uN")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("czUqv")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("1uCWc")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("jS2zt")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("2yT54")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("gyGFp")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("4T6Mp")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("jrU5L")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("f28Qb")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("bp4vf")), module.exports);

$bf94ae067b2b0f38$var$__exportStar((parcelRequire("dsrrO")), module.exports);
Object.assign((0, (parcelRequire("lJw3W"))._getStatsigGlobal)(), {
    Log: (parcelRequire("ekewr")).Log,
    SDK_VERSION: (parcelRequire("jG7m1")).SDK_VERSION
});

});
parcelRegister("lJw3W", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $fd26abe22dcc0aee$var$_a, $fd26abe22dcc0aee$var$_b, $fd26abe22dcc0aee$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $ekewr = parcelRequire("ekewr");
const $fd26abe22dcc0aee$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $fd26abe22dcc0aee$var$statsigGlobal;
    } catch (e) {
        return $fd26abe22dcc0aee$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $fd26abe22dcc0aee$var$_getStatsigGlobal;
const $fd26abe22dcc0aee$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $fd26abe22dcc0aee$var$_getStatsigGlobalFlag;
const $fd26abe22dcc0aee$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $ekewr.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $fd26abe22dcc0aee$var$_getInstance;
const $fd26abe22dcc0aee$var$GLOBAL_KEY = '__STATSIG__';
const $fd26abe22dcc0aee$var$_window = typeof window !== 'undefined' ? window : {};
const $fd26abe22dcc0aee$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $fd26abe22dcc0aee$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $fd26abe22dcc0aee$var$statsigGlobal = ($fd26abe22dcc0aee$var$_c = ($fd26abe22dcc0aee$var$_b = ($fd26abe22dcc0aee$var$_a = $fd26abe22dcc0aee$var$_window[$fd26abe22dcc0aee$var$GLOBAL_KEY]) !== null && $fd26abe22dcc0aee$var$_a !== void 0 ? $fd26abe22dcc0aee$var$_a : $fd26abe22dcc0aee$var$_global[$fd26abe22dcc0aee$var$GLOBAL_KEY]) !== null && $fd26abe22dcc0aee$var$_b !== void 0 ? $fd26abe22dcc0aee$var$_b : $fd26abe22dcc0aee$var$_globalThis[$fd26abe22dcc0aee$var$GLOBAL_KEY]) !== null && $fd26abe22dcc0aee$var$_c !== void 0 ? $fd26abe22dcc0aee$var$_c : {
    instance: module.exports._getInstance
};
$fd26abe22dcc0aee$var$_window[$fd26abe22dcc0aee$var$GLOBAL_KEY] = $fd26abe22dcc0aee$var$statsigGlobal;
$fd26abe22dcc0aee$var$_global[$fd26abe22dcc0aee$var$GLOBAL_KEY] = $fd26abe22dcc0aee$var$statsigGlobal;
$fd26abe22dcc0aee$var$_globalThis[$fd26abe22dcc0aee$var$GLOBAL_KEY] = $fd26abe22dcc0aee$var$statsigGlobal;

});
parcelRegister("ekewr", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $a6de32c051885b87$var$DEBUG = ' DEBUG ';
const $a6de32c051885b87$var$_INFO = '  INFO ';
const $a6de32c051885b87$var$_WARN = '  WARN ';
const $a6de32c051885b87$var$ERROR = ' ERROR ';
function $a6de32c051885b87$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $a6de32c051885b87$var$Log {
    static info(...args) {
        if ($a6de32c051885b87$var$Log.level >= module.exports.LogLevel.Info) console.info($a6de32c051885b87$var$_INFO, ...$a6de32c051885b87$var$addTag(args));
    }
    static debug(...args) {
        if ($a6de32c051885b87$var$Log.level >= module.exports.LogLevel.Debug) console.debug($a6de32c051885b87$var$DEBUG, ...$a6de32c051885b87$var$addTag(args));
    }
    static warn(...args) {
        if ($a6de32c051885b87$var$Log.level >= module.exports.LogLevel.Warn) console.warn($a6de32c051885b87$var$_WARN, ...$a6de32c051885b87$var$addTag(args));
    }
    static error(...args) {
        if ($a6de32c051885b87$var$Log.level >= module.exports.LogLevel.Error) console.error($a6de32c051885b87$var$ERROR, ...$a6de32c051885b87$var$addTag(args));
    }
}
module.exports.Log = $a6de32c051885b87$var$Log;
$a6de32c051885b87$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("9KQ0P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $71a0c186ed21a72e$var$MARKER_MAP = new Map();
const $71a0c186ed21a72e$var$ACT_START = 'start';
const $71a0c186ed21a72e$var$ACT_END = 'end';
const $71a0c186ed21a72e$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $71a0c186ed21a72e$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $71a0c186ed21a72e$var$_addMarker(sdkKey, $71a0c186ed21a72e$var$_createMarker({}, $71a0c186ed21a72e$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $71a0c186ed21a72e$var$_addMarker(sdkKey, $71a0c186ed21a72e$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $71a0c186ed21a72e$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $71a0c186ed21a72e$var$_addMarker(sdkKey, $71a0c186ed21a72e$var$_createMarker(data, $71a0c186ed21a72e$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $71a0c186ed21a72e$var$_addMarker(sdkKey, $71a0c186ed21a72e$var$_createMarker(data, $71a0c186ed21a72e$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $71a0c186ed21a72e$var$_addMarker(sdkKey, $71a0c186ed21a72e$var$_createMarker({}, $71a0c186ed21a72e$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $71a0c186ed21a72e$var$_addMarker(sdkKey, $71a0c186ed21a72e$var$_createMarker(data, $71a0c186ed21a72e$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $71a0c186ed21a72e$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $71a0c186ed21a72e$var$_safeGetField(e, 'code'),
            name: $71a0c186ed21a72e$var$_safeGetField(e, 'name'),
            message: $71a0c186ed21a72e$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $71a0c186ed21a72e$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $71a0c186ed21a72e$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $71a0c186ed21a72e$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $71a0c186ed21a72e$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $71a0c186ed21a72e$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $71a0c186ed21a72e$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $71a0c186ed21a72e$var$MARKER_MAP.set(sdkKey, markers);
}
function $71a0c186ed21a72e$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("jy0Ff", function(module, exports) {
"use strict";
var $e3b1b53bd7884213$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $gWc3k = parcelRequire("gWc3k");

var $62RBj = parcelRequire("62RBj");

var $hrfZ6 = parcelRequire("hrfZ6");

var $6SZgG = parcelRequire("6SZgG");

var $9iLPp = parcelRequire("9iLPp");

var $ekewr = parcelRequire("ekewr");

var $inXWh = parcelRequire("inXWh");

var $koKY1 = parcelRequire("koKY1");

var $koANL = parcelRequire("koANL");

var $9CGjT = parcelRequire("9CGjT");

var $9wYYG = parcelRequire("9wYYG");

var $jS2zt = parcelRequire("jS2zt");

var $4T6Mp = parcelRequire("4T6Mp");

var $f28Qb = parcelRequire("f28Qb");
const $e3b1b53bd7884213$var$MAX_DEDUPER_KEYS = 1000;
const $e3b1b53bd7884213$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $e3b1b53bd7884213$var$EVENT_LOGGER_MAP = {};
class $e3b1b53bd7884213$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $e3b1b53bd7884213$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    constructor(_sdkKey, _emitter, _network, _options, _errorBoundary){
        var _a;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._errorBoundary = _errorBoundary;
        this._pendingEvents = null;
        this._batchQueue = null;
        this._flushCoordinator = null;
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._isShuttingDown = false;
        this._storageKey = null;
        this._pendingCompressionMode = null;
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $9wYYG.LoggingEnabledOption.disabled : $9wYYG.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $ekewr.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $4T6Mp.UrlConfiguration($inXWh.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLogEventCompressionMode(mode) {
        if (this._flushCoordinator) this._flushCoordinator.setLogEventCompressionMode(mode);
        else this._pendingCompressionMode = mode;
    }
    setLoggingEnabled(loggingEnabled) {
        const wasDisabled = this._loggingEnabled === 'disabled';
        const isNowEnabled = loggingEnabled !== 'disabled';
        this._loggingEnabled = loggingEnabled;
        if (this._flushCoordinator) this._flushCoordinator.setLoggingEnabled(loggingEnabled);
        if (wasDisabled && isNowEnabled) {
            const events = this._loadStoredEvents();
            $ekewr.Log.debug(`Loaded ${events.length} stored event(s) from storage`);
            if (events.length > 0) {
                events.forEach((event)=>{
                    this._initFlushCoordinator().addEvent(event);
                });
                this.flush().catch((error)=>{
                    $ekewr.Log.warn('Failed to flush events after enabling logging:', error);
                });
            }
        }
    }
    enqueue(event) {
        var _a;
        if (!this._shouldLogEvent(event)) return;
        const normalizedEvent = this._normalizeEvent(event);
        if (this._loggingEnabled === 'disabled') {
            this._storeEventToStorage(normalizedEvent);
            return;
        }
        this._initFlushCoordinator().addEvent(normalizedEvent);
        (_a = this._flushCoordinator) === null || _a === void 0 || _a.checkQuickFlush();
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $koANL._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        const flushCoordinator = this._initFlushCoordinator();
        $e3b1b53bd7884213$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $f28Qb._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $e3b1b53bd7884213$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') flushCoordinator.startScheduledFlushCycle();
        });
        flushCoordinator.loadAndRetryShutdownFailedEvents().catch((error)=>{
            $ekewr.Log.warn('Failed to load failed shutdown events:', error);
        });
        flushCoordinator.startScheduledFlushCycle();
    }
    stop() {
        return $e3b1b53bd7884213$var$__awaiter(this, void 0, void 0, function*() {
            this._isShuttingDown = true;
            if (this._flushCoordinator) yield this._flushCoordinator.processShutdown();
            delete $e3b1b53bd7884213$var$EVENT_LOGGER_MAP[this._sdkKey];
            this._flushCoordinator = null;
            this._pendingEvents = null;
            this._batchQueue = null;
        });
    }
    flush() {
        return $e3b1b53bd7884213$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._flushCoordinator) return;
            return this._flushCoordinator.processManualFlush();
        });
    }
    appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        const checks = Object.assign({}, this._nonExposedChecks);
        this._nonExposedChecks = {};
        const event = this._normalizeEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: checks
            }
        });
        if (!this._flushCoordinator) return;
        this._flushCoordinator.addEvent(event);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $koANL._isServerEnv)()) return false;
        if (!(0, $9CGjT._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $62RBj._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $e3b1b53bd7884213$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $e3b1b53bd7884213$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $koANL._getCurrentPageUrlSafe)();
    }
    _getStorageKey() {
        if (!this._storageKey) this._storageKey = `statsig.pending_events.${(0, $9iLPp._DJB2)(this._sdkKey)}`;
        return this._storageKey;
    }
    _initFlushCoordinator() {
        var _a, _b;
        if (this._flushCoordinator) return this._flushCoordinator;
        const batchSize = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $hrfZ6.EventRetryConstants.DEFAULT_BATCH_SIZE;
        this._pendingEvents = new $koKY1.PendingEvents(batchSize);
        this._batchQueue = new $gWc3k.BatchQueue(batchSize);
        this._flushCoordinator = new $6SZgG.FlushCoordinator(this._batchQueue, this._pendingEvents, ()=>this.appendAndResetNonExposedChecks(), this._sdkKey, this._network, this._emitter, this._logEventUrlConfig, this._options, this._loggingEnabled, this._errorBoundary);
        if (this._pendingCompressionMode) {
            this._flushCoordinator.setLogEventCompressionMode(this._pendingCompressionMode);
            this._pendingCompressionMode = null;
        }
        return this._flushCoordinator;
    }
    _storeEventToStorage(event) {
        const storageKey = this._getStorageKey();
        try {
            let existingEvents = this._getEventsFromStorage(storageKey);
            existingEvents.push(event);
            if (existingEvents.length > $hrfZ6.EventRetryConstants.MAX_LOCAL_STORAGE) existingEvents = existingEvents.slice(-$hrfZ6.EventRetryConstants.MAX_LOCAL_STORAGE);
            (0, $jS2zt._setObjectInStorage)(storageKey, existingEvents);
        } catch (error) {
            $ekewr.Log.warn('Unable to save events to storage');
        }
    }
    _getEventsFromStorage(storageKey) {
        try {
            const events = (0, $jS2zt._getObjectFromStorage)(storageKey);
            if (Array.isArray(events)) return events;
            return [];
        } catch (_a) {
            return [];
        }
    }
    _loadStoredEvents() {
        const storageKey = this._getStorageKey();
        const events = this._getEventsFromStorage(storageKey);
        if (events.length > 0) $jS2zt.Storage.removeItem(storageKey);
        return events;
    }
    _normalizeEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        return Object.assign(Object.assign({}, event), extras);
    }
}
module.exports.EventLogger = $e3b1b53bd7884213$var$EventLogger;

});
parcelRegister("gWc3k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BatchQueue = void 0;

var $ighdb = parcelRequire("ighdb");

var $hrfZ6 = parcelRequire("hrfZ6");
class $c54b69889e904eba$var$BatchQueue {
    constructor(batchSize = $hrfZ6.EventRetryConstants.DEFAULT_BATCH_SIZE){
        this._batches = [];
        this._batchSize = batchSize;
    }
    batchSize() {
        return this._batchSize;
    }
    requeueBatch(batch) {
        return this._enqueueBatch(batch);
    }
    hasFullBatch() {
        return this._batches.some((batch)=>batch.events.length >= this._batchSize);
    }
    takeNextBatch() {
        return this._batches.shift();
    }
    takeAllBatches() {
        const batches = this._batches;
        this._batches = [];
        return batches;
    }
    createBatches(events) {
        let i = 0;
        let droppedCount = 0;
        while(i < events.length){
            const chunk = events.slice(i, i + this._batchSize);
            droppedCount += this._enqueueBatch(new $ighdb.EventBatch(chunk));
            i += this._batchSize;
        }
        return droppedCount;
    }
    _enqueueBatch(batch) {
        this._batches.push(batch);
        let droppedEventCount = 0;
        while(this._batches.length > $hrfZ6.EventRetryConstants.MAX_PENDING_BATCHES){
            const dropped = this._batches.shift();
            if (dropped) droppedEventCount += dropped.events.length;
        }
        return droppedEventCount;
    }
}
module.exports.BatchQueue = $c54b69889e904eba$var$BatchQueue;

});
parcelRegister("ighdb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventBatch = void 0;
class $d4b7127c44db4222$var$EventBatch {
    constructor(events){
        this.attempts = 0;
        this.createdAt = Date.now();
        this.events = events;
    }
    incrementAttempts() {
        this.attempts++;
    }
}
module.exports.EventBatch = $d4b7127c44db4222$var$EventBatch;

});

parcelRegister("hrfZ6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventRetryConstants = void 0;
module.exports.EventRetryConstants = {
    MAX_RETRY_ATTEMPTS: 5,
    DEFAULT_BATCH_SIZE: 100,
    MAX_PENDING_BATCHES: 30,
    TICK_INTERVAL_MS: 1000,
    QUICK_FLUSH_WINDOW_MS: 200,
    MAX_LOCAL_STORAGE: 500,
    get MAX_QUEUED_EVENTS () {
        return this.DEFAULT_BATCH_SIZE * this.MAX_PENDING_BATCHES;
    }
};

});


parcelRegister("62RBj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $9iLPp = parcelRequire("9iLPp");
function $466c81fd6d92542a$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $9iLPp._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $466c81fd6d92542a$var$_getUserStorageKey;
function $466c81fd6d92542a$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $466c81fd6d92542a$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $9iLPp._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $466c81fd6d92542a$var$_getStorageKey;

});
parcelRegister("9iLPp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $gyGFp = parcelRequire("gyGFp");
const $6c5ae528498888f3$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $6c5ae528498888f3$var$_DJB2;
const $6c5ae528498888f3$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $6c5ae528498888f3$var$_DJB2Object;
const $6c5ae528498888f3$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $gyGFp._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $6c5ae528498888f3$var$_getSortedObject;

});
parcelRegister("gyGFp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $c0e0eb1096818a4d$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $c0e0eb1096818a4d$var$_typeOf;
function $c0e0eb1096818a4d$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $c0e0eb1096818a4d$var$_isTypeMatch;

});



parcelRegister("6SZgG", function(module, exports) {
"use strict";
var $50374fc353b8cda0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlushCoordinator = void 0;

var $hrfZ6 = parcelRequire("hrfZ6");

var $befYm = parcelRequire("befYm");

var $ahIzA = parcelRequire("ahIzA");

var $jl9zF = parcelRequire("jl9zF");

var $9iLPp = parcelRequire("9iLPp");

var $ekewr = parcelRequire("ekewr");

var $6zg9m = parcelRequire("6zg9m");

var $9owgm = parcelRequire("9owgm");

var $jS2zt = parcelRequire("jS2zt");
class $50374fc353b8cda0$var$FlushCoordinator {
    constructor(batchQueue, pendingEvents, onPrepareFlush, // For Event Sender
    sdkKey, network, emitter, logEventUrlConfig, options, loggingEnabled, errorBoundary){
        this._cooldownTimer = null;
        this._maxIntervalTimer = null;
        this._hasRunQuickFlush = false;
        this._currentFlushPromise = null;
        this._creationTime = Date.now();
        this._isShuttingDown = false;
        this._storageKey = null;
        this._flushInterval = new $ahIzA.FlushInterval();
        this._batchQueue = batchQueue;
        this._pendingEvents = pendingEvents;
        this._onPrepareFlush = onPrepareFlush;
        this._errorBoundary = errorBoundary;
        this._sdkKey = sdkKey;
        this._eventSender = new $befYm.EventSender(sdkKey, network, emitter, logEventUrlConfig, options, loggingEnabled);
    }
    setLoggingEnabled(loggingEnabled) {
        this._eventSender.setLoggingEnabled(loggingEnabled);
    }
    setLogEventCompressionMode(mode) {
        this._eventSender.setLogEventCompressionMode(mode);
    }
    startScheduledFlushCycle() {
        this._scheduleNextFlush();
    }
    stopScheduledFlushCycle() {
        this._clearAllTimers();
    }
    addEvent(event) {
        this._pendingEvents.addToPendingEventsQueue(event);
        if (this._currentFlushPromise) return;
        if (this._pendingEvents.hasEventsForFullBatch()) this.processLimitFlush();
    }
    processManualFlush() {
        return $50374fc353b8cda0$var$__awaiter(this, void 0, void 0, function*() {
            if (this._currentFlushPromise) yield this._currentFlushPromise;
            this._currentFlushPromise = this._executeFlush($jl9zF.FlushType.Manual).finally(()=>{
                this._currentFlushPromise = null;
                this._scheduleNextFlush();
            });
            return this._currentFlushPromise;
        });
    }
    processShutdown() {
        return $50374fc353b8cda0$var$__awaiter(this, void 0, void 0, function*() {
            this._isShuttingDown = true;
            this._clearAllTimers();
            if (this._currentFlushPromise) yield this._currentFlushPromise;
            this._currentFlushPromise = this._executeFlush($jl9zF.FlushType.Shutdown).catch((error)=>{
                $ekewr.Log.error(`Error during shutdown flush: ${error}`);
            }).finally(()=>{
                this._currentFlushPromise = null;
            });
            return this._currentFlushPromise;
        });
    }
    _executeFlush(flushType) {
        return $50374fc353b8cda0$var$__awaiter(this, void 0, void 0, function*() {
            this._clearAllTimers();
            try {
                this._prepareQueueForFlush(flushType);
                const batches = this._batchQueue.takeAllBatches();
                if (batches.length === 0) return;
                yield Promise.all(batches.map((batch)=>this._processOneBatch(batch, flushType)));
            } finally{
                if (!this._isShuttingDown) this._scheduleNextFlush();
            }
        });
    }
    checkQuickFlush() {
        if (this._hasRunQuickFlush) return;
        if (Date.now() - this._creationTime > $hrfZ6.EventRetryConstants.QUICK_FLUSH_WINDOW_MS) return;
        this._hasRunQuickFlush = true;
        setTimeout(()=>{
            this.processManualFlush().catch((error)=>{
                $ekewr.Log.warn('Quick flush failed:', error);
            });
        }, $hrfZ6.EventRetryConstants.QUICK_FLUSH_WINDOW_MS);
    }
    _attemptScheduledFlush() {
        if (this._currentFlushPromise) {
            this._scheduleNextFlush();
            return;
        }
        const shouldFlushBySize = this.containsAtLeastOneFullBatch();
        const shouldFlushByTime = this._flushInterval.hasReachedMaxInterval();
        if (!shouldFlushBySize && !shouldFlushByTime) {
            this._scheduleNoopPollTick();
            return;
        }
        this._flushInterval.markFlushAttempt();
        let flushType;
        if (shouldFlushBySize) flushType = $jl9zF.FlushType.ScheduledFullBatch;
        else flushType = $jl9zF.FlushType.ScheduledMaxTime;
        this._currentFlushPromise = this._processNextBatch(flushType).then(()=>{
        //This discards boolean result. Main goal here is to track completion
        }).catch((error)=>{
            $ekewr.Log.error('Error during scheduled flush:', error);
        }).finally(()=>{
            this._currentFlushPromise = null;
            this._scheduleNextFlush();
        });
    }
    processLimitFlush() {
        if (!this._flushInterval.hasCompletelyRecoveredFromBackoff()) return;
        if (this._currentFlushPromise) return;
        this._currentFlushPromise = this._processLimitFlushInternal().catch((error)=>{
            $ekewr.Log.error(`Error during limit flush`, error);
        }).finally(()=>{
            this._currentFlushPromise = null;
            this._scheduleNextFlush();
        });
    }
    _processLimitFlushInternal() {
        return $50374fc353b8cda0$var$__awaiter(this, void 0, void 0, function*() {
            const success = yield this._processNextBatch($jl9zF.FlushType.Limit);
            if (!success) return;
            while(this._flushInterval.hasCompletelyRecoveredFromBackoff() && this.containsAtLeastOneFullBatch()){
                const success = yield this._processNextBatch($jl9zF.FlushType.Limit);
                if (!success) break;
            }
        });
    }
    _scheduleNextFlush() {
        this._clearAllTimers();
        if (this._isShuttingDown) return;
        const cooldownDelay = Math.max(0, this._flushInterval.getTimeUntilNextFlush());
        this._cooldownTimer = setTimeout(()=>{
            this._cooldownTimer = null;
            $9owgm.StatsigSession.checkForIdleSession(this._sdkKey);
            this._attemptScheduledFlush();
        }, cooldownDelay);
        const maxIntervalDelay = Math.max(0, this._flushInterval.getTimeTillMaxInterval());
        this._maxIntervalTimer = setTimeout(()=>{
            this._maxIntervalTimer = null;
            $9owgm.StatsigSession.checkForIdleSession(this._sdkKey);
            this._attemptScheduledFlush();
        }, maxIntervalDelay);
    }
    _clearAllTimers() {
        if (this._cooldownTimer !== null) {
            clearTimeout(this._cooldownTimer);
            this._cooldownTimer = null;
        }
        if (this._maxIntervalTimer !== null) {
            clearTimeout(this._maxIntervalTimer);
            this._maxIntervalTimer = null;
        }
    }
    _scheduleNoopPollTick() {
        this._clearAllTimers();
        if (this._isShuttingDown) return;
        this._cooldownTimer = setTimeout(()=>{
            this._cooldownTimer = null;
            $9owgm.StatsigSession.checkForIdleSession(this._sdkKey);
            this._attemptScheduledFlush();
        }, $hrfZ6.EventRetryConstants.TICK_INTERVAL_MS);
        const maxIntervalDelay = Math.max(0, this._flushInterval.getTimeTillMaxInterval());
        this._maxIntervalTimer = setTimeout(()=>{
            this._maxIntervalTimer = null;
            $9owgm.StatsigSession.checkForIdleSession(this._sdkKey);
            this._attemptScheduledFlush();
        }, maxIntervalDelay);
    }
    _processNextBatch(flushType) {
        return $50374fc353b8cda0$var$__awaiter(this, void 0, void 0, function*() {
            this._prepareQueueForFlush(flushType);
            const batch = this._batchQueue.takeNextBatch();
            if (!batch) return false;
            return this._processOneBatch(batch, flushType);
        });
    }
    _processOneBatch(batch, flushType) {
        return $50374fc353b8cda0$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this._eventSender.sendBatch(batch);
            if (result.success) {
                this._flushInterval.adjustForSuccess();
                return true;
            }
            this._flushInterval.adjustForFailure();
            this._handleFailure(batch, flushType, result.statusCode);
            return false;
        });
    }
    _prepareQueueForFlush(flushType) {
        this._onPrepareFlush();
        const droppedCount = this.convertPendingEventsToBatches();
        if (droppedCount > 0) {
            $ekewr.Log.warn(`Dropped ${droppedCount} events`);
            this._errorBoundary.logDroppedEvents(droppedCount, `Batch queue limit reached`, {
                loggingInterval: this._flushInterval.getCurrentIntervalMs(),
                batchSize: this._batchQueue.batchSize(),
                maxPendingBatches: $hrfZ6.EventRetryConstants.MAX_PENDING_BATCHES,
                flushType: flushType,
                retries: 'dropped before batching'
            });
        }
    }
    containsAtLeastOneFullBatch() {
        return this._pendingEvents.hasEventsForFullBatch() || this._batchQueue.hasFullBatch();
    }
    convertPendingEventsToBatches() {
        if (this._pendingEvents.isEmpty()) return 0;
        const allEvents = this._pendingEvents.takeAll();
        return this._batchQueue.createBatches(allEvents);
    }
    _handleFailure(batch, flushType, statusCode) {
        if (flushType === $jl9zF.FlushType.Shutdown) {
            $ekewr.Log.warn(`${flushType} flush failed during shutdown. ` + `${batch.events.length} event(s) will be saved to storage for retry in next session.`);
            this._saveShutdownFailedEventsToStorage(batch.events);
            return;
        }
        if (!$6zg9m.RETRYABLE_CODES.has(statusCode)) {
            $ekewr.Log.warn(`${flushType} flush failed after ${batch.attempts} attempt(s). ` + `${batch.events.length} event(s) will be dropped. Non-retryable error: ${statusCode}`);
            this._errorBoundary.logEventRequestFailure(batch.events.length, `non-retryable error`, flushType, statusCode, batch.attempts);
            return;
        }
        if (batch.attempts >= $hrfZ6.EventRetryConstants.MAX_RETRY_ATTEMPTS) {
            $ekewr.Log.warn(`${flushType} flush failed after ${batch.attempts} attempt(s). ` + `${batch.events.length} event(s) will be dropped.`);
            this._errorBoundary.logEventRequestFailure(batch.events.length, `max retry attempts exceeded`, flushType, statusCode, batch.attempts);
            return;
        }
        batch.incrementAttempts();
        const droppedCount = this._batchQueue.requeueBatch(batch);
        if (droppedCount > 0) {
            $ekewr.Log.warn(`Failed to requeue batch : dropped ${droppedCount} events due to full queue`);
            this._errorBoundary.logDroppedEvents(droppedCount, `Batch queue limit reached`, {
                loggingInterval: this._flushInterval.getCurrentIntervalMs(),
                batchSize: this._batchQueue.batchSize(),
                maxPendingBatches: $hrfZ6.EventRetryConstants.MAX_PENDING_BATCHES,
                flushType: flushType,
                retries: batch.attempts
            });
        }
    }
    loadAndRetryShutdownFailedEvents() {
        return $50374fc353b8cda0$var$__awaiter(this, void 0, void 0, function*() {
            const storageKey = this._getStorageKey();
            try {
                if (!$jS2zt.Storage.isReady()) yield $jS2zt.Storage.isReadyResolver();
                const events = this._getShutdownFailedEventsFromStorage(storageKey);
                if (events.length === 0) return;
                $ekewr.Log.debug(`Loading ${events.length} failed shutdown event(s) from storage for retry`);
                $jS2zt.Storage.removeItem(storageKey);
                events.forEach((event)=>{
                    this.addEvent(event);
                });
                yield this.processManualFlush();
            } catch (error) {
                $ekewr.Log.warn('Failed to load and retry failed shutdown events:', error);
            }
        });
    }
    _getStorageKey() {
        if (!this._storageKey) this._storageKey = `statsig.failed_shutdown_events.${(0, $9iLPp._DJB2)(this._sdkKey)}`;
        return this._storageKey;
    }
    _saveShutdownFailedEventsToStorage(events) {
        const storageKey = this._getStorageKey();
        try {
            const existingEvents = this._getShutdownFailedEventsFromStorage(storageKey);
            let allEvents = [
                ...existingEvents,
                ...events
            ];
            if (allEvents.length > $hrfZ6.EventRetryConstants.MAX_LOCAL_STORAGE) allEvents = allEvents.slice(-$hrfZ6.EventRetryConstants.MAX_LOCAL_STORAGE);
            (0, $jS2zt._setObjectInStorage)(storageKey, allEvents);
            $ekewr.Log.debug(`Saved ${events.length} failed shutdown event(s) to storage (total stored: ${allEvents.length})`);
        } catch (error) {
            $ekewr.Log.warn('Unable to save failed shutdown events to storage:', error);
        }
    }
    _getShutdownFailedEventsFromStorage(storageKey) {
        try {
            const events = (0, $jS2zt._getObjectFromStorage)(storageKey);
            if (Array.isArray(events)) return events;
            return [];
        } catch (_a) {
            return [];
        }
    }
}
module.exports.FlushCoordinator = $50374fc353b8cda0$var$FlushCoordinator;

});
parcelRegister("befYm", function(module, exports) {
"use strict";
var $82cd6451d8489218$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventSender = void 0;

var $ekewr = parcelRequire("ekewr");

var $inXWh = parcelRequire("inXWh");

var $f28Qb = parcelRequire("f28Qb");
class $82cd6451d8489218$var$EventSender {
    constructor(sdkKey, network, emitter, logEventUrlConfig, options, loggingEnabled){
        this._sdkKey = sdkKey;
        this._network = network;
        this._emitter = emitter;
        this._options = options;
        this._logEventUrlConfig = logEventUrlConfig;
        this._loggingEnabled = loggingEnabled;
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(enabled) {
        this._loggingEnabled = enabled;
    }
    sendBatch(batch) {
        return $82cd6451d8489218$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                const isClosing = (0, $f28Qb._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: batch.events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(batch) : yield this._sendEventsViaPost(batch);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: batch.events
                    });
                    return response;
                }
                return {
                    success: false,
                    statusCode: response.statusCode
                };
            } catch (error) {
                $ekewr.Log.warn('Failed to send batch:', error);
                return {
                    success: false,
                    statusCode: -1
                };
            }
        });
    }
    _sendEventsViaPost(batch) {
        return $82cd6451d8489218$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(batch));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300,
                statusCode: code
            };
        });
    }
    _sendEventsViaBeacon(batch) {
        const success = this._network.beacon(this._getRequestData(batch));
        return {
            success: success,
            statusCode: success ? 200 : -1
        };
    }
    _getRequestData(batch) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: batch.events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$inXWh.NetworkParam.EventCount]: String(batch.events.length)
            },
            headers: {
                'statsig-event-count': String(batch.events.length),
                'statsig-retry-count': String(batch.attempts)
            },
            credentials: 'same-origin'
        };
    }
}
module.exports.EventSender = $82cd6451d8489218$var$EventSender;

});
parcelRegister("inXWh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("f28Qb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $koANL = parcelRequire("koANL");
const $af1de67907943299$var$FOREGROUND = 'foreground';
const $af1de67907943299$var$BACKGROUND = 'background';
const $af1de67907943299$var$LISTENERS = [];
let $af1de67907943299$var$current = $af1de67907943299$var$FOREGROUND;
let $af1de67907943299$var$isUnloading = false;
const $af1de67907943299$var$_isCurrentlyVisible = ()=>{
    return $af1de67907943299$var$current === $af1de67907943299$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $af1de67907943299$var$_isCurrentlyVisible;
const $af1de67907943299$var$_isUnloading = ()=>$af1de67907943299$var$isUnloading;
module.exports._isUnloading = $af1de67907943299$var$_isUnloading;
const $af1de67907943299$var$_subscribeToVisiblityChanged = (listener)=>{
    $af1de67907943299$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $af1de67907943299$var$_subscribeToVisiblityChanged;
const $af1de67907943299$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $af1de67907943299$var$current) return;
    $af1de67907943299$var$current = visibility;
    $af1de67907943299$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $af1de67907943299$var$_notifyVisibilityChanged;
(0, $koANL._addWindowEventListenerSafe)('focus', ()=>{
    $af1de67907943299$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($af1de67907943299$var$FOREGROUND);
});
(0, $koANL._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($af1de67907943299$var$BACKGROUND));
(0, $koANL._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $af1de67907943299$var$FOREGROUND : $af1de67907943299$var$BACKGROUND);
});
(0, $koANL._addWindowEventListenerSafe)((0, $koANL._getUnloadEvent)(), ()=>{
    $af1de67907943299$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($af1de67907943299$var$BACKGROUND);
});

});
parcelRegister("koANL", function(module, exports) {

var $3ZMUU = parcelRequire("3ZMUU");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._cloneObject = module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;

var $ekewr = parcelRequire("ekewr");
const $ed929892e8fc728c$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $ed929892e8fc728c$var$_getWindowSafe;
const $ed929892e8fc728c$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $ed929892e8fc728c$var$_getDocumentSafe;
const $ed929892e8fc728c$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $3ZMUU !== 'undefined' && $3ZMUU.versions != null && $3ZMUU.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $ed929892e8fc728c$var$_isServerEnv;
const $ed929892e8fc728c$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $ed929892e8fc728c$var$_addWindowEventListenerSafe;
const $ed929892e8fc728c$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $ed929892e8fc728c$var$_addDocumentEventListenerSafe;
const $ed929892e8fc728c$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $ed929892e8fc728c$var$_getCurrentPageUrlSafe;
const $ed929892e8fc728c$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $ed929892e8fc728c$var$_getUnloadEvent;
const $ed929892e8fc728c$var$_cloneObject = (tag, obj)=>{
    try {
        return JSON.parse(JSON.stringify(obj));
    } catch (error) {
        $ekewr.Log.error(`Failed to clone object ${tag}`);
        return null;
    }
};
module.exports._cloneObject = $ed929892e8fc728c$var$_cloneObject;

});



parcelRegister("ahIzA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlushInterval = void 0;
const $77ce1132cb487bd8$var$MIN_FLUSH_INTERVAL_MS = 1000;
const $77ce1132cb487bd8$var$MAX_FLUSH_INTERVAL_MS = 60000;
class $77ce1132cb487bd8$var$FlushInterval {
    constructor(){
        this._currentIntervalMs = $77ce1132cb487bd8$var$MIN_FLUSH_INTERVAL_MS;
        this._lastFlushAttemptTime = Date.now();
    }
    getCurrentIntervalMs() {
        return this._currentIntervalMs;
    }
    markFlushAttempt() {
        this._lastFlushAttemptTime = Date.now();
    }
    getTimeSinceLastAttempt() {
        return Date.now() - this._lastFlushAttemptTime;
    }
    hasReachedMaxInterval() {
        return this.getTimeSinceLastAttempt() >= $77ce1132cb487bd8$var$MAX_FLUSH_INTERVAL_MS;
    }
    getTimeTillMaxInterval() {
        return $77ce1132cb487bd8$var$MAX_FLUSH_INTERVAL_MS - this.getTimeSinceLastAttempt();
    }
    hasCompletelyRecoveredFromBackoff() {
        return this._currentIntervalMs <= $77ce1132cb487bd8$var$MIN_FLUSH_INTERVAL_MS;
    }
    adjustForSuccess() {
        const current = this._currentIntervalMs;
        if (current === $77ce1132cb487bd8$var$MIN_FLUSH_INTERVAL_MS) return;
        this._currentIntervalMs = Math.max($77ce1132cb487bd8$var$MIN_FLUSH_INTERVAL_MS, Math.floor(current / 2));
    }
    adjustForFailure() {
        const current = this._currentIntervalMs;
        this._currentIntervalMs = Math.min($77ce1132cb487bd8$var$MAX_FLUSH_INTERVAL_MS, current * 2);
    }
    getTimeUntilNextFlush() {
        return this.getCurrentIntervalMs() - this.getTimeSinceLastAttempt();
    }
}
module.exports.FlushInterval = $77ce1132cb487bd8$var$FlushInterval;

});

parcelRegister("jl9zF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlushType = void 0;
/* eslint-disable no-restricted-syntax */ var $e14767beba4cbc7e$var$FlushType;
(function(FlushType) {
    FlushType["ScheduledMaxTime"] = "scheduled:max_time";
    FlushType["ScheduledFullBatch"] = "scheduled:full_batch";
    FlushType["Limit"] = "limit";
    FlushType["Manual"] = "manual";
    FlushType["Shutdown"] = "shutdown";
})($e14767beba4cbc7e$var$FlushType || (module.exports.FlushType = $e14767beba4cbc7e$var$FlushType = {}));

});

parcelRegister("6zg9m", function(module, exports) {
"use strict";
var $4c8289ffe614a149$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = module.exports.RETRYABLE_CODES = void 0;

var $lJw3W = parcelRequire("lJw3W");

var $lJw3W = parcelRequire("lJw3W");

var $9KQ0P = parcelRequire("9KQ0P");

var $ekewr = parcelRequire("ekewr");

var $inXWh = parcelRequire("inXWh");

var $5DFqU = parcelRequire("5DFqU");

var $dsrrO = parcelRequire("dsrrO");

var $fLKwt = parcelRequire("fLKwt");

var $koANL = parcelRequire("koANL");

var $9owgm = parcelRequire("9owgm");

var $5QBCY = parcelRequire("5QBCY");

var $c9Q9s = parcelRequire("c9Q9s");

var $jG7m1 = parcelRequire("jG7m1");

var $9wYYG = parcelRequire("9wYYG");

var $f28Qb = parcelRequire("f28Qb");
const $4c8289ffe614a149$var$DEFAULT_TIMEOUT_MS = 10000;
const $4c8289ffe614a149$var$BACKOFF_BASE_MS = 500;
const $4c8289ffe614a149$var$BACKOFF_MAX_MS = 30000;
const $4c8289ffe614a149$var$RATE_LIMIT_WINDOW_MS = 1000;
const $4c8289ffe614a149$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $4c8289ffe614a149$var$LEAK_RATE = $4c8289ffe614a149$var$RATE_LIMIT_MAX_REQ_COUNT / $4c8289ffe614a149$var$RATE_LIMIT_WINDOW_MS;
module.exports.RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $4c8289ffe614a149$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $4c8289ffe614a149$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $5DFqU.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$4c8289ffe614a149$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $4c8289ffe614a149$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $4c8289ffe614a149$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$4c8289ffe614a149$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $ekewr.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            let reqTimedOut = false;
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $f28Qb._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    priority: args.priority,
                    keepalive: keepalive
                };
                $4c8289ffe614a149$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                let timeoutId;
                response = yield Promise.race([
                    func(populatedUrl, config).finally(()=>clearTimeout(timeoutId)),
                    new Promise((_, reject)=>{
                        timeoutId = setTimeout(()=>{
                            reqTimedOut = true;
                            reject(new Error(`Timeout of ${this._timeout}ms expired.`));
                        }, this._timeout);
                    })
                ]);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $4c8289ffe614a149$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $4c8289ffe614a149$var$_getErrorMessage(error);
                const timedOut = $4c8289ffe614a149$var$_didTimeout(errorMessage !== null && errorMessage !== void 0 ? errorMessage : '', reqTimedOut);
                $4c8289ffe614a149$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !module.exports.RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $c9Q9s.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $ekewr.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $4c8289ffe614a149$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $9wYYG.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $9wYYG.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $4c8289ffe614a149$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $4c8289ffe614a149$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $inXWh.Endpoint._initialize || args.urlConfig.endpoint === $inXWh.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$inXWh.NetworkParam.SdkKey]: args.sdkKey,
            [$inXWh.NetworkParam.SdkType]: $fLKwt.SDKType._get(args.sdkKey),
            [$inXWh.NetworkParam.SdkVersion]: $jG7m1.SDK_VERSION,
            [$inXWh.NetworkParam.Time]: String(Date.now()),
            [$inXWh.NetworkParam.SessionID]: $9owgm.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $koANL._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $lJw3W._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$inXWh.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $ekewr.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $4c8289ffe614a149$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$4c8289ffe614a149$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($ekewr.Log.error);
                writer.close().catch($ekewr.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$inXWh.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $ekewr.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $4c8289ffe614a149$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $4c8289ffe614a149$var$NetworkCore;
const $4c8289ffe614a149$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $ekewr.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $4c8289ffe614a149$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $5QBCY.StableID.get(sdkKey);
    const sessionID = $9owgm.SessionID.get(sdkKey);
    const sdkType = $fLKwt.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $jG7m1.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $4c8289ffe614a149$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $lJw3W._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $dsrrO.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $9wYYG.LogEventCompressionMode.Disabled:
            return false;
        case $9wYYG.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $9wYYG.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $4c8289ffe614a149$var$_getErrorMessage(error) {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $4c8289ffe614a149$var$_didTimeout(errorMsg, abortedByTimeout) {
    const timeout = errorMsg.includes('Timeout'); // probably not needed but just in case
    return timeout || abortedByTimeout;
}
function $4c8289ffe614a149$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $inXWh.Endpoint._initialize) return;
    $9KQ0P.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $4c8289ffe614a149$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $inXWh.Endpoint._initialize) return;
    $9KQ0P.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $9KQ0P.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $4c8289ffe614a149$var$_exponentialBackoff(attempt) {
    return $4c8289ffe614a149$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($4c8289ffe614a149$var$BACKOFF_BASE_MS * (attempt * attempt), $4c8289ffe614a149$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("5DFqU", function(module, exports) {
"use strict";
var $41b0bbfccb49aac2$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $lrt32 = parcelRequire("lrt32");

var $9iLPp = parcelRequire("9iLPp");

var $ekewr = parcelRequire("ekewr");

var $jS2zt = parcelRequire("jS2zt");
const $41b0bbfccb49aac2$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $41b0bbfccb49aac2$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $41b0bbfccb49aac2$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $41b0bbfccb49aac2$var$DEFAULT_TTL_MS;
        $41b0bbfccb49aac2$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $41b0bbfccb49aac2$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $41b0bbfccb49aac2$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $41b0bbfccb49aac2$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$41b0bbfccb49aac2$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $41b0bbfccb49aac2$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $41b0bbfccb49aac2$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $41b0bbfccb49aac2$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $41b0bbfccb49aac2$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $lrt32._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $41b0bbfccb49aac2$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $41b0bbfccb49aac2$var$NetworkFallbackResolver;
function $41b0bbfccb49aac2$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $41b0bbfccb49aac2$var$_isDomainFailure;
function $41b0bbfccb49aac2$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $9iLPp._DJB2)(sdkKey)}`;
}
function $41b0bbfccb49aac2$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $41b0bbfccb49aac2$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $jS2zt.Storage.removeItem(hashKey);
        return;
    }
    $jS2zt.Storage.setItem(hashKey, JSON.stringify(info));
}
function $41b0bbfccb49aac2$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $41b0bbfccb49aac2$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $jS2zt.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $ekewr.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $41b0bbfccb49aac2$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("lrt32", function(module, exports) {
"use strict";
var $f9c2a6e56ecaa917$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $f9c2a6e56ecaa917$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $f9c2a6e56ecaa917$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $f9c2a6e56ecaa917$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $f9c2a6e56ecaa917$var$MAX_START_LOOKUP = 200;
function $f9c2a6e56ecaa917$var$_fetchTxtRecords(networkFunc) {
    return $f9c2a6e56ecaa917$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($f9c2a6e56ecaa917$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $f9c2a6e56ecaa917$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $f9c2a6e56ecaa917$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $f9c2a6e56ecaa917$var$_fetchTxtRecords;
function $f9c2a6e56ecaa917$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $f9c2a6e56ecaa917$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $f9c2a6e56ecaa917$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});

parcelRegister("jS2zt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $ekewr = parcelRequire("ekewr");

var $koANL = parcelRequire("koANL");
const $03bbb1c67bf64eab$var$inMemoryStore = {};
const $03bbb1c67bf64eab$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$03bbb1c67bf64eab$var$inMemoryStore[key] ? $03bbb1c67bf64eab$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $03bbb1c67bf64eab$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $03bbb1c67bf64eab$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($03bbb1c67bf64eab$var$inMemoryStore)
};
let $03bbb1c67bf64eab$var$_localStorageProvider = null;
try {
    const win = (0, $koANL._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $03bbb1c67bf64eab$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $ekewr.Log.warn('Failed to setup localStorageProvider.');
}
let $03bbb1c67bf64eab$var$_main = $03bbb1c67bf64eab$var$_localStorageProvider !== null && $03bbb1c67bf64eab$var$_localStorageProvider !== void 0 ? $03bbb1c67bf64eab$var$_localStorageProvider : $03bbb1c67bf64eab$var$_inMemoryProvider;
let $03bbb1c67bf64eab$var$_current = $03bbb1c67bf64eab$var$_main;
function $03bbb1c67bf64eab$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($03bbb1c67bf64eab$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$03bbb1c67bf64eab$var$_current.isReady(),
    isReadyResolver: ()=>$03bbb1c67bf64eab$var$_current.isReadyResolver(),
    getProviderName: ()=>$03bbb1c67bf64eab$var$_current.getProviderName(),
    getItem: (key)=>$03bbb1c67bf64eab$var$_inMemoryBreaker(()=>$03bbb1c67bf64eab$var$_current.getItem(key)),
    setItem: (key, value)=>$03bbb1c67bf64eab$var$_inMemoryBreaker(()=>$03bbb1c67bf64eab$var$_current.setItem(key, value)),
    removeItem: (key)=>$03bbb1c67bf64eab$var$_current.removeItem(key),
    getAllKeys: ()=>$03bbb1c67bf64eab$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $03bbb1c67bf64eab$var$_main = newProvider;
        $03bbb1c67bf64eab$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $03bbb1c67bf64eab$var$_current = $03bbb1c67bf64eab$var$_inMemoryProvider;
        else $03bbb1c67bf64eab$var$_current = $03bbb1c67bf64eab$var$_main;
    }
};
function $03bbb1c67bf64eab$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    try {
        return JSON.parse(value !== null && value !== void 0 ? value : 'null');
    } catch (e) {
        $ekewr.Log.error(`Failed to parse value for key "${key}"`);
        return null;
    }
}
module.exports._getObjectFromStorage = $03bbb1c67bf64eab$var$_getObjectFromStorage;
function $03bbb1c67bf64eab$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $03bbb1c67bf64eab$var$_setObjectInStorage;

});


parcelRegister("dsrrO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $9cc32e6a54c466b3$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $9cc32e6a54c466b3$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $9cc32e6a54c466b3$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("fLKwt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $b7af55411d8c27c3$var$SDK_CLIENT = {};
let $b7af55411d8c27c3$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $b7af55411d8c27c3$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($b7af55411d8c27c3$var$suffix !== null && $b7af55411d8c27c3$var$suffix !== void 0 ? $b7af55411d8c27c3$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $b7af55411d8c27c3$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$b7af55411d8c27c3$var$suffix || $b7af55411d8c27c3$var$suffix === '-react') $b7af55411d8c27c3$var$suffix = '-' + binding;
    }
};

});

parcelRegister("9owgm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $62RBj = parcelRequire("62RBj");

var $ekewr = parcelRequire("ekewr");

var $jS2zt = parcelRequire("jS2zt");

var $jrU5L = parcelRequire("jrU5L");

var $f28Qb = parcelRequire("f28Qb");
const $6d6f61ac2bb8a9e9$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $6d6f61ac2bb8a9e9$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $6d6f61ac2bb8a9e9$var$PERSIST_THROTTLE_MS = 15000;
const $6d6f61ac2bb8a9e9$var$SESSION_MAP = {};
(0, $f28Qb._subscribeToVisiblityChanged)((visibility)=>{
    if (visibility === 'background') Object.values($6d6f61ac2bb8a9e9$var$SESSION_MAP).forEach((session)=>$6d6f61ac2bb8a9e9$var$_persistNow(session));
});
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey, bumpSession = true)=>{
        if ($6d6f61ac2bb8a9e9$var$SESSION_MAP[sdkKey] == null) $6d6f61ac2bb8a9e9$var$SESSION_MAP[sdkKey] = $6d6f61ac2bb8a9e9$var$_loadOrCreateSharedSession(sdkKey);
        const session = $6d6f61ac2bb8a9e9$var$SESSION_MAP[sdkKey];
        return $6d6f61ac2bb8a9e9$var$_maybeBumpSession(session, bumpSession);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        const now = Date.now();
        const session = {
            data: {
                sessionID: override,
                startTime: now,
                lastUpdate: now
            },
            sdkKey: sdkKey,
            lastPersistedAt: Date.now(),
            storageKey: $6d6f61ac2bb8a9e9$var$_getSessionIDStorageKey(sdkKey)
        };
        $6d6f61ac2bb8a9e9$var$_persistNow(session);
        $6d6f61ac2bb8a9e9$var$SESSION_MAP[sdkKey] = session;
    },
    checkForIdleSession: (sdkKey)=>{
        const session = $6d6f61ac2bb8a9e9$var$SESSION_MAP[sdkKey];
        if (!session) return;
        const sessionExpired = $6d6f61ac2bb8a9e9$var$_checkForExpiredSession(session);
        if (sessionExpired) $6d6f61ac2bb8a9e9$var$_persistNow(session);
    }
};
function $6d6f61ac2bb8a9e9$var$_maybeBumpSession(session, allowSessionBump) {
    const now = Date.now();
    const sessionExpired = $6d6f61ac2bb8a9e9$var$_checkForExpiredSession(session);
    if (sessionExpired) $6d6f61ac2bb8a9e9$var$_persistNow(session);
    else if (allowSessionBump) {
        session.data.lastUpdate = now;
        $6d6f61ac2bb8a9e9$var$_persistThrottled(session);
    }
    return session;
}
function $6d6f61ac2bb8a9e9$var$_checkForExpiredSession(session) {
    var _a;
    const data = session.data;
    const sessionExpired = $6d6f61ac2bb8a9e9$var$_isIdle(data) || $6d6f61ac2bb8a9e9$var$_hasRunTooLong(data);
    if (sessionExpired) {
        session.data = $6d6f61ac2bb8a9e9$var$_newSessionData();
        (_a = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(session.sdkKey)) === null || _a === void 0 || _a.$emt({
            name: 'session_expired'
        });
    }
    return sessionExpired;
}
function $6d6f61ac2bb8a9e9$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $6d6f61ac2bb8a9e9$var$MAX_SESSION_IDLE_TIME;
}
function $6d6f61ac2bb8a9e9$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $6d6f61ac2bb8a9e9$var$MAX_SESSION_AGE;
}
function $6d6f61ac2bb8a9e9$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $62RBj._getStorageKey)(sdkKey)}`;
}
function $6d6f61ac2bb8a9e9$var$_persistNow(session) {
    try {
        (0, $jS2zt._setObjectInStorage)(session.storageKey, session.data);
        session.lastPersistedAt = Date.now();
    } catch (e) {
        $ekewr.Log.warn('Failed to save SessionID');
    }
}
function $6d6f61ac2bb8a9e9$var$_persistThrottled(session) {
    const now = Date.now();
    if (now - session.lastPersistedAt > $6d6f61ac2bb8a9e9$var$PERSIST_THROTTLE_MS) $6d6f61ac2bb8a9e9$var$_persistNow(session);
}
function $6d6f61ac2bb8a9e9$var$_loadSessionFromStorage(storageKey) {
    const data = (0, $jS2zt._getObjectFromStorage)(storageKey);
    return data;
}
function $6d6f61ac2bb8a9e9$var$_loadOrCreateSharedSession(sdkKey) {
    const storageKey = $6d6f61ac2bb8a9e9$var$_getSessionIDStorageKey(sdkKey);
    const existing = $6d6f61ac2bb8a9e9$var$_loadSessionFromStorage(storageKey);
    if (existing && existing.sessionID && existing.startTime && existing.lastUpdate) return {
        data: existing,
        sdkKey: sdkKey,
        lastPersistedAt: 0,
        storageKey: storageKey
    };
    return {
        data: $6d6f61ac2bb8a9e9$var$_newSessionData(),
        sdkKey: sdkKey,
        lastPersistedAt: 0,
        storageKey: storageKey
    };
}
function $6d6f61ac2bb8a9e9$var$_newSessionData() {
    return {
        sessionID: (0, $jrU5L.getUUID)(),
        startTime: Date.now(),
        lastUpdate: Date.now()
    };
}

});
parcelRegister("jrU5L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $e28c0c9ed67e9c3f$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $e28c0c9ed67e9c3f$var$getUUID;

});


parcelRegister("5QBCY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCookieName = module.exports.StableID = void 0;

var $62RBj = parcelRequire("62RBj");

var $ekewr = parcelRequire("ekewr");

var $koANL = parcelRequire("koANL");

var $jS2zt = parcelRequire("jS2zt");

var $jrU5L = parcelRequire("jrU5L");
const $441eff28a0780415$var$PROMISE_MAP = {};
const $441eff28a0780415$var$COOKIE_ENABLED_MAP = {};
const $441eff28a0780415$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($441eff28a0780415$var$DISABLED_MAP[sdkKey]) return null;
        if ($441eff28a0780415$var$PROMISE_MAP[sdkKey] != null) return $441eff28a0780415$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $441eff28a0780415$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $441eff28a0780415$var$PROMISE_MAP[sdkKey] = stableID;
            $441eff28a0780415$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $441eff28a0780415$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $jrU5L.getUUID)();
        $441eff28a0780415$var$_persistToStorage(stableID, sdkKey);
        $441eff28a0780415$var$_persistToCookie(stableID, sdkKey);
        $441eff28a0780415$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $441eff28a0780415$var$PROMISE_MAP[sdkKey] = override;
        $441eff28a0780415$var$_persistToStorage(override, sdkKey);
        $441eff28a0780415$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $441eff28a0780415$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $441eff28a0780415$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $441eff28a0780415$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $62RBj._getStorageKey)(sdkKey)}`;
}
function $441eff28a0780415$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $441eff28a0780415$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $jS2zt._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $ekewr.Log.warn('Failed to save StableID to storage');
    }
}
function $441eff28a0780415$var$_loadFromStorage(sdkKey) {
    const storageKey = $441eff28a0780415$var$_getStableIDStorageKey(sdkKey);
    return (0, $jS2zt._getObjectFromStorage)(storageKey);
}
function $441eff28a0780415$var$_loadFromCookie(sdkKey) {
    if (!$441eff28a0780415$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $koANL._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $441eff28a0780415$var$getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $441eff28a0780415$var$_persistToCookie(stableID, sdkKey) {
    if (!$441eff28a0780415$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $koANL._getDocumentSafe)() == null) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$441eff28a0780415$var$getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $441eff28a0780415$var$getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $62RBj._getStorageKey)(sdkKey)}`;
}
module.exports.getCookieName = $441eff28a0780415$var$getCookieName;

});

parcelRegister("c9Q9s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});

parcelRegister("jG7m1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.32.0';
let $e537a4fa875cb823$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$e537a4fa875cb823$var$metadata,
    add: (additions)=>{
        $e537a4fa875cb823$var$metadata = Object.assign(Object.assign({}, $e537a4fa875cb823$var$metadata), additions);
    }
};

});

parcelRegister("9wYYG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});



parcelRegister("koKY1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PendingEvents = void 0;

var $ekewr = parcelRequire("ekewr");
class $ed9a7b3d14f78689$var$PendingEvents {
    constructor(batchSize){
        this._pendingEvents = [];
        this._batchSize = batchSize;
    }
    addToPendingEventsQueue(event) {
        this._pendingEvents.push(event);
        $ekewr.Log.debug('Enqueued Event:', event);
    }
    hasEventsForFullBatch() {
        return this._pendingEvents.length >= this._batchSize;
    }
    takeAll() {
        const events = this._pendingEvents;
        this._pendingEvents = [];
        return events;
    }
    isEmpty() {
        return this._pendingEvents.length === 0;
    }
}
module.exports.PendingEvents = $ed9a7b3d14f78689$var$PendingEvents;

});

parcelRegister("9CGjT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $70187d861745b8cc$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $70187d861745b8cc$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $70187d861745b8cc$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $70187d861745b8cc$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $70187d861745b8cc$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $70187d861745b8cc$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $70187d861745b8cc$var$GATE_EXPOSURE_NAME || eventName === $70187d861745b8cc$var$CONFIG_EXPOSURE_NAME || eventName === $70187d861745b8cc$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $70187d861745b8cc$var$_isExposureEvent;
const $70187d861745b8cc$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $70187d861745b8cc$var$_createExposure($70187d861745b8cc$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $70187d861745b8cc$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $70187d861745b8cc$var$_createGateExposure;
function $70187d861745b8cc$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $70187d861745b8cc$var$_mapExposures;
const $70187d861745b8cc$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $70187d861745b8cc$var$_createExposure($70187d861745b8cc$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $70187d861745b8cc$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $70187d861745b8cc$var$_createConfigExposure;
const $70187d861745b8cc$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $70187d861745b8cc$var$_createExposure($70187d861745b8cc$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $70187d861745b8cc$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $70187d861745b8cc$var$_createLayerParameterExposure;
const $70187d861745b8cc$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("4T6Mp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $9iLPp = parcelRequire("9iLPp");

var $inXWh = parcelRequire("inXWh");
const $38f18ed23fdc18f9$var$ENDPOINT_DNS_KEY_MAP = {
    [$inXWh.Endpoint._initialize]: 'i',
    [$inXWh.Endpoint._rgstr]: 'e',
    [$inXWh.Endpoint._download_config_specs]: 'd'
};
class $38f18ed23fdc18f9$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $38f18ed23fdc18f9$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $inXWh.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $9iLPp._DJB2)(this.customUrl + fallbacks);
    }
}
module.exports.UrlConfiguration = $38f18ed23fdc18f9$var$UrlConfiguration;

});


parcelRegister("hnVlx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrecomputedEvaluationsContextHandle = void 0;

var $ekewr = parcelRequire("ekewr");

var $koANL = parcelRequire("koANL");

var $9owgm = parcelRequire("9owgm");

var $5QBCY = parcelRequire("5QBCY");
/**
 * A handle to the PrecomputedEvaluationsContext that computes fields lazily on access.
 * This avoids unnecessary computation (e.g., cloning the user) when only certain fields are needed.
 * The handle is created once and reused; individual getters fetch current values on each access.
 */ class $03442571548228a9$var$PrecomputedEvaluationsContextHandle {
    constructor(sdkKey, getOptions, getErrorBoundary, getValues, getUser, getSdkInstanceID){
        this._sdkKey = sdkKey;
        this._getOptions = getOptions;
        this._getErrorBoundary = getErrorBoundary;
        this._getValues = getValues;
        this._getUser = getUser;
        this._getSdkInstanceID = getSdkInstanceID;
    }
    get sdkKey() {
        return this._sdkKey;
    }
    get options() {
        return this._getOptions();
    }
    get errorBoundary() {
        return this._getErrorBoundary();
    }
    get values() {
        return this._getValues();
    }
    get user() {
        let user = (0, $koANL._cloneObject)('StatsigUser', this._getUser());
        if (user == null) {
            $ekewr.Log.error('Failed to clone user');
            user = {};
        }
        return user;
    }
    /**
     * Gets the current session.
     * @param {boolean} [bumpSession=true] - Whether to bump/update the session timing. Set to false to read without affecting session state.
     */ getSession(bumpSession = true) {
        return $9owgm.StatsigSession.get(this._sdkKey, bumpSession);
    }
    get stableID() {
        return $5QBCY.StableID.get(this._sdkKey);
    }
    get sdkInstanceID() {
        return this._getSdkInstanceID();
    }
    /**
     * Returns the full PrecomputedEvaluationsContext object.
     * Use this when you need all fields at once.
     * @param {boolean} [bumpSession=true] - Whether to bump the session when building the context.
     */ toContext(bumpSession = true) {
        return {
            sdkKey: this.sdkKey,
            options: this.options,
            values: this.values,
            user: this.user,
            errorBoundary: this.errorBoundary,
            session: this.getSession(bumpSession),
            stableID: this.stableID,
            sdkInstanceID: this.sdkInstanceID
        };
    }
}
module.exports.PrecomputedEvaluationsContextHandle = $03442571548228a9$var$PrecomputedEvaluationsContextHandle;

});

parcelRegister("jMmDh", function(module, exports) {
"use strict";
var $e6640e6467dd1d8c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $ekewr = parcelRequire("ekewr");

var $5QBCY = parcelRequire("5QBCY");

var $1uCWc = parcelRequire("1uCWc");

var $jS2zt = parcelRequire("jS2zt");

var $2yT54 = parcelRequire("2yT54");
const $e6640e6467dd1d8c$var$CACHE_LIMIT = 10;
const $e6640e6467dd1d8c$var$MAX_CACHE_WRITE_ATTEMPTS = 8;
class $e6640e6467dd1d8c$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._cacheLimit = $e6640e6467dd1d8c$var$CACHE_LIMIT;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $e6640e6467dd1d8c$var$InMemoryCache();
    }
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $1uCWc._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache, this._cacheLimit);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $1uCWc._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $e6640e6467dd1d8c$var$_makeDataAdapterResult('Bootstrap', data, null, normalized), this._cacheLimit);
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $5QBCY.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $e6640e6467dd1d8c$var$__awaiter(this, void 0, void 0, function*() {
            if (!$jS2zt.Storage.isReady()) yield $jS2zt.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $ekewr.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $e6640e6467dd1d8c$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $1uCWc._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }), this._cacheLimit);
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $e6640e6467dd1d8c$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $ekewr.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $2yT54._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $5QBCY.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $e6640e6467dd1d8c$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $e6640e6467dd1d8c$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result, this._cacheLimit);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $ekewr.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $jS2zt.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($jS2zt.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $2yT54._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        const resultString = JSON.stringify(result);
        for(let i = 0; i < $e6640e6467dd1d8c$var$MAX_CACHE_WRITE_ATTEMPTS; i++)try {
            $jS2zt.Storage.setItem(cacheKey, resultString);
            break;
        } catch (error) {
            if (!(error instanceof Error) || !(error.toString().includes('QuotaExceededError') || error.toString().includes('QUOTA_EXCEEDED_ERR')) || this._cacheLimit <= 1) throw error;
            this._cacheLimit = Math.ceil(this._cacheLimit / 2);
            this._runLocalStorageCacheEviction(cacheKey, this._cacheLimit - 1);
        }
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey, cacheLimit = this._cacheLimit) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $jS2zt._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictableKeys = $e6640e6467dd1d8c$var$_getEvictableKeys(lastModifiedTimeMap, cacheLimit);
        for (const evictable of evictableKeys){
            delete lastModifiedTimeMap[evictable];
            $jS2zt.Storage.removeItem(evictable);
        }
        (0, $jS2zt._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $e6640e6467dd1d8c$var$DataAdapterCore;
function $e6640e6467dd1d8c$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $1uCWc._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $e6640e6467dd1d8c$var$_makeDataAdapterResult;
class $e6640e6467dd1d8c$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $ekewr.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value, cacheLimit) {
        const evictableKeys = $e6640e6467dd1d8c$var$_getEvictableKeys(this._data, cacheLimit - 1);
        for (const evictable of evictableKeys)delete this._data[evictable];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $e6640e6467dd1d8c$var$_getEvictableKeys(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return [];
    if (limit === 0) return keys;
    return keys.sort((keyA, keyB)=>{
        const valueA = data[keyA];
        const valueB = data[keyB];
        if (typeof valueA === 'object' && typeof valueB === 'object') return valueA.receivedAt - valueB.receivedAt;
        return valueA - valueB;
    }).slice(0, keys.length - limit);
}

});
parcelRegister("1uCWc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnitIDFromUser = module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $9iLPp = parcelRequire("9iLPp");

var $ekewr = parcelRequire("ekewr");

var $koANL = parcelRequire("koANL");
function $1166cc0225fccedb$var$_normalizeUser(original, options, fallbackEnvironment) {
    const copy = (0, $koANL._cloneObject)('StatsigUser', original);
    if (copy == null) {
        $ekewr.Log.error('Failed to clone user');
        return {
            statsigEnvironment: undefined
        };
    }
    if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
    else if (fallbackEnvironment != null) copy.statsigEnvironment = {
        tier: fallbackEnvironment
    };
    return copy;
}
module.exports._normalizeUser = $1166cc0225fccedb$var$_normalizeUser;
function $1166cc0225fccedb$var$_getFullUserHash(user) {
    return user ? (0, $9iLPp._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $1166cc0225fccedb$var$_getFullUserHash;
function $1166cc0225fccedb$var$_getUnitIDFromUser(user, idType) {
    var _a, _b, _c;
    if (typeof idType !== 'string') return user.userID;
    const lowered = idType.toLowerCase();
    if (lowered !== 'userid') return (_b = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a[idType]) !== null && _b !== void 0 ? _b : (_c = user.customIDs) === null || _c === void 0 ? void 0 : _c[lowered];
    return user.userID;
}
module.exports._getUnitIDFromUser = $1166cc0225fccedb$var$_getUnitIDFromUser;

});

parcelRegister("2yT54", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $ekewr = parcelRequire("ekewr");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $1dd97ba0b101f964$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $ekewr.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $1dd97ba0b101f964$var$_typedJsonParse;

});


parcelRegister("6yz2S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eZSY0", function(module, exports) {
"use strict";
var $aeb16671e6c5a535$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $ekewr = parcelRequire("ekewr");

var $fLKwt = parcelRequire("fLKwt");

var $jG7m1 = parcelRequire("jG7m1");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $aeb16671e6c5a535$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $aeb16671e6c5a535$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance, namePrefix) {
        try {
            const obj = instance;
            $aeb16671e6c5a535$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(namePrefix ? `${namePrefix}:${name}` : name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    logDroppedEvents(count, reason, metadata) {
        const extra = {
            eventCount: String(count)
        };
        if (metadata) Object.keys(metadata).forEach((key)=>{
            extra[key] = String(metadata[key]);
        });
        this._onError(`statsig::log_event_dropped_event_count`, new Error(reason), true, extra);
    }
    logEventRequestFailure(count, reason, flushType, statusCode, retries) {
        const extra = {
            eventCount: String(count),
            flushType: flushType,
            statusCode: String(statusCode),
            reason: reason,
            retries: String(retries)
        };
        this._onError(`statsig::log_event_failed`, new Error(reason), true, extra);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $aeb16671e6c5a535$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error, bypassDedupe = false, extra) {
        try {
            $ekewr.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$aeb16671e6c5a535$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($aeb16671e6c5a535$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $aeb16671e6c5a535$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (!bypassDedupe && this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $fLKwt.SDKType._get(this._sdkKey);
                    const statsigMetadata = $jG7m1.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $aeb16671e6c5a535$var$_getDescription(unwrapped);
                    const body = Object.assign(Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $aeb16671e6c5a535$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    })), extra !== null && extra !== void 0 ? extra : {});
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $aeb16671e6c5a535$var$ErrorBoundary;
function $aeb16671e6c5a535$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $aeb16671e6c5a535$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $aeb16671e6c5a535$var$UNKNOWN_ERROR;
    }
}
function $aeb16671e6c5a535$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $aeb16671e6c5a535$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.keys(options).forEach((key)=>{
        const option = key;
        const value = options[option];
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});

parcelRegister("dmOG6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3PlSU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("55qzU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fwXVh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $b4e8539c68e341d7$var$EXIST_KEYS = new Set([]);
const $b4e8539c68e341d7$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $b4e8539c68e341d7$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($b4e8539c68e341d7$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($b4e8539c68e341d7$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $b4e8539c68e341d7$var$createMemoKey;

});

parcelRegister("6DBHb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iaO1m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("geNcE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $bd241ed81753e376$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $bd241ed81753e376$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $bd241ed81753e376$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $bd241ed81753e376$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $bd241ed81753e376$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $bd241ed81753e376$var$_fastApproxSizeOf;

});

parcelRegister("9d3om", function(module, exports) {
"use strict";
var $6b47f582267b361a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $lJw3W = parcelRequire("lJw3W");

var $lJw3W = parcelRequire("lJw3W");

var $eZSY0 = parcelRequire("eZSY0");

var $jy0Ff = parcelRequire("jy0Ff");

var $ekewr = parcelRequire("ekewr");

var $fwXVh = parcelRequire("fwXVh");

var $koANL = parcelRequire("koANL");

var $9owgm = parcelRequire("9owgm");

var $5QBCY = parcelRequire("5QBCY");

var $9wYYG = parcelRequire("9wYYG");

var $jS2zt = parcelRequire("jS2zt");
const $6b47f582267b361a$var$MAX_MEMO_CACHE_SIZE = 3000;
class $6b47f582267b361a$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($ekewr.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $jS2zt.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $9owgm.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $jS2zt.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $5QBCY.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $5QBCY.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._errorBoundary = new $eZSY0.ErrorBoundary(sdkKey, options, emitter);
        this._logger = new $jy0Ff.EventLogger(sdkKey, emitter, network, options, this._errorBoundary);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $jS2zt.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $6b47f582267b361a$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $jS2zt.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $5QBCY.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($9wYYG.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $6b47f582267b361a$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $ekewr.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $fwXVh.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $6b47f582267b361a$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $6b47f582267b361a$var$StatsigClientBase;
function $6b47f582267b361a$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $koANL._isServerEnv)()) return;
    const statsigGlobal = (0, $lJw3W._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $ekewr.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("9fgfE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("8kghQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jx6uN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $ekewr = parcelRequire("ekewr");

var $gyGFp = parcelRequire("gyGFp");
function $e3862351e9fdb0f8$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $e3862351e9fdb0f8$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $e3862351e9fdb0f8$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $e3862351e9fdb0f8$var$_makeFeatureGate;
function $e3862351e9fdb0f8$var$_makeDynamicConfig(name, details, evaluation) {
    var _a, _b;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $e3862351e9fdb0f8$var$_makeEvaluation(name, details, evaluation, value)), {
        idType: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _b !== void 0 ? _b : null,
        get: $e3862351e9fdb0f8$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $e3862351e9fdb0f8$var$_makeDynamicConfig;
function $e3862351e9fdb0f8$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $e3862351e9fdb0f8$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $e3862351e9fdb0f8$var$_makeExperiment;
function $e3862351e9fdb0f8$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $e3862351e9fdb0f8$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $e3862351e9fdb0f8$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $e3862351e9fdb0f8$var$_makeLayer;
function $e3862351e9fdb0f8$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $e3862351e9fdb0f8$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $e3862351e9fdb0f8$var$_mergeOverride;
function $e3862351e9fdb0f8$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $gyGFp._isTypeMatch)(found, fallback)) {
            $ekewr.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $e3862351e9fdb0f8$var$_makeTypedGet;

});

parcelRegister("czUqv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("bp4vf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $84d585af46e0ed7a$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $84d585af46e0ed7a$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("lsgol", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $f9e8ed8665cc0109$export$badac9ada3a0bdf9);

var $5FkrB = parcelRequire("5FkrB");

var $hvYLl = parcelRequire("hvYLl");

var $728oi = parcelRequire("728oi");

var $15fNX = parcelRequire("15fNX");
var $f9e8ed8665cc0109$var$NOOP = function NOOP() {
    return void 0;
};
var $f9e8ed8665cc0109$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $f9e8ed8665cc0109$var$EMPTY_MODIFIERS = [];
function $f9e8ed8665cc0109$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $f9e8ed8665cc0109$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $5FkrB.useContext((0, $hvYLl.ManagerReferenceNodeContext));
    var _React$useState = $5FkrB.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $5FkrB.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $5FkrB.useEffect(function() {
        (0, $728oi.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $5FkrB.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $15fNX.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $5FkrB.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $f9e8ed8665cc0109$var$NOOP,
            update: update || $f9e8ed8665cc0109$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $728oi.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("hvYLl", function(module, exports) {
$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $cc0477161a7a3c78$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $cc0477161a7a3c78$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $cc0477161a7a3c78$export$d0d38e7dec7a1a61);

var $5FkrB = parcelRequire("5FkrB");
var $cc0477161a7a3c78$export$3dbd3405086fec7b = $5FkrB.createContext();
var $cc0477161a7a3c78$export$cbabb21c2529b130 = $5FkrB.createContext();
function $cc0477161a7a3c78$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $5FkrB.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $5FkrB.useRef(false);
    $5FkrB.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $5FkrB.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $5FkrB.createElement($cc0477161a7a3c78$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $5FkrB.createElement($cc0477161a7a3c78$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("728oi", function(module, exports) {
$parcel$export(module.exports, "unwrapArray", () => $51ef3a8e2c42379b$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $51ef3a8e2c42379b$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $51ef3a8e2c42379b$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $51ef3a8e2c42379b$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $51ef3a8e2c42379b$export$700979bc83e7db82);

var $5FkrB = parcelRequire("5FkrB");
var $51ef3a8e2c42379b$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $51ef3a8e2c42379b$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $51ef3a8e2c42379b$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $51ef3a8e2c42379b$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $51ef3a8e2c42379b$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $51ef3a8e2c42379b$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $5FkrB.useLayoutEffect : $5FkrB.useEffect;

});

parcelRegister("15fNX", function(module, exports) {
$parcel$export(module.exports, "usePopper", () => $0ca28497a8a04ea7$export$f4d5bf230a36dd6e);

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $hTJWj = parcelRequire("hTJWj");

var $dcrmD = parcelRequire("dcrmD");

var $728oi = parcelRequire("728oi");
var $0ca28497a8a04ea7$var$EMPTY_MODIFIERS = [];
var $0ca28497a8a04ea7$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $5FkrB.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $0ca28497a8a04ea7$var$EMPTY_MODIFIERS
    };
    var _React$useState = $5FkrB.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $5FkrB.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $aLeHs.flushSync(function() {
                    setState({
                        styles: (0, $728oi.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $728oi.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $5FkrB.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($dcrmD)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $5FkrB.useRef();
    (0, $728oi.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $728oi.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $hTJWj.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("hTJWj", function(module, exports) {
$parcel$export(module.exports, "createPopper", () => $d07b3555e5780154$export$8f7491d57c8f97a9);

var $gqwtB = parcelRequire("gqwtB");

var $AYfmq = parcelRequire("AYfmq");

var $jiyhn = parcelRequire("jiyhn");

var $8xQBR = parcelRequire("8xQBR");

var $95K1c = parcelRequire("95K1c");

var $lexRm = parcelRequire("lexRm");

var $euI62 = parcelRequire("euI62");

var $hlR4d = parcelRequire("hlR4d");

var $1ISmI = parcelRequire("1ISmI");

var $hoRGB = parcelRequire("hoRGB");


var $d07b3555e5780154$export$d34966752335dd47 = [
    (0, $AYfmq.default),
    (0, $jiyhn.default),
    (0, $8xQBR.default),
    (0, $95K1c.default),
    (0, $lexRm.default),
    (0, $euI62.default),
    (0, $hlR4d.default),
    (0, $1ISmI.default),
    (0, $hoRGB.default)
];
var $d07b3555e5780154$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $gqwtB.popperGenerator)({
    defaultModifiers: $d07b3555e5780154$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gqwtB", function(module, exports) {
$parcel$export(module.exports, "popperGenerator", () => $bf58442f71e0a59e$export$ed5e13716264f202);

var $4b52x = parcelRequire("4b52x");

var $cI2gV = parcelRequire("cI2gV");

var $h2klf = parcelRequire("h2klf");

var $b40rk = parcelRequire("b40rk");

var $aUEAQ = parcelRequire("aUEAQ");

var $jp2vh = parcelRequire("jp2vh");

var $45WlR = parcelRequire("45WlR");


var $lxsPK = parcelRequire("lxsPK");
var $bf58442f71e0a59e$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $bf58442f71e0a59e$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $bf58442f71e0a59e$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $bf58442f71e0a59e$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $bf58442f71e0a59e$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $lxsPK.isElement)(reference) ? (0, $h2klf.default)(reference) : reference.contextElement ? (0, $h2klf.default)(reference.contextElement) : [],
                    popper: (0, $h2klf.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $aUEAQ.default)((0, $45WlR.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$bf58442f71e0a59e$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $4b52x.default)(reference, (0, $b40rk.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $cI2gV.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $jp2vh.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$bf58442f71e0a59e$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $bf58442f71e0a59e$export$8f7491d57c8f97a9 = /*#__PURE__*/ $bf58442f71e0a59e$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("4b52x", function(module, exports) {
$parcel$export(module.exports, "default", () => $30ac1953654104c9$export$2e2bcd8739ae039);

var $5SX2j = parcelRequire("5SX2j");

var $hMsdL = parcelRequire("hMsdL");

var $bFqu3 = parcelRequire("bFqu3");

var $lxsPK = parcelRequire("lxsPK");

var $8iNOc = parcelRequire("8iNOc");

var $2vuXD = parcelRequire("2vuXD");

var $jCpkw = parcelRequire("jCpkw");

var $kDvUD = parcelRequire("kDvUD");
function $30ac1953654104c9$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $kDvUD.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $kDvUD.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $30ac1953654104c9$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $lxsPK.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $lxsPK.isHTMLElement)(offsetParent) && $30ac1953654104c9$var$isElementScaled(offsetParent);
    var documentElement = (0, $2vuXD.default)(offsetParent);
    var rect = (0, $5SX2j.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $bFqu3.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $jCpkw.default)(documentElement)) scroll = (0, $hMsdL.default)(offsetParent);
        if ((0, $lxsPK.isHTMLElement)(offsetParent)) {
            offsets = (0, $5SX2j.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $8iNOc.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("5SX2j", function(module, exports) {
$parcel$export(module.exports, "default", () => $448fca4b88e71bae$export$2e2bcd8739ae039);

var $lxsPK = parcelRequire("lxsPK");

var $kDvUD = parcelRequire("kDvUD");

var $jqcF0 = parcelRequire("jqcF0");

var $gNwrE = parcelRequire("gNwrE");
function $448fca4b88e71bae$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $lxsPK.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $kDvUD.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $kDvUD.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $lxsPK.isElement)(element) ? (0, $jqcF0.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $gNwrE.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("lxsPK", function(module, exports) {
$parcel$export(module.exports, "isElement", () => $fae30bcfba640a43$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $fae30bcfba640a43$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $fae30bcfba640a43$export$af51f0f06c0f328a);

var $jqcF0 = parcelRequire("jqcF0");
function $fae30bcfba640a43$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $jqcF0.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $fae30bcfba640a43$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $jqcF0.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $fae30bcfba640a43$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $jqcF0.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("jqcF0", function(module, exports) {
$parcel$export(module.exports, "default", () => $e23a441bbff67a45$export$2e2bcd8739ae039);
function $e23a441bbff67a45$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("kDvUD", function(module, exports) {
$parcel$export(module.exports, "max", () => $f060345502b6b7d0$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $f060345502b6b7d0$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $f060345502b6b7d0$export$2077e0241d6afd3c);
var $f060345502b6b7d0$export$8960430cfd85939f = Math.max;
var $f060345502b6b7d0$export$96ec731ed4dcb222 = Math.min;
var $f060345502b6b7d0$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("gNwrE", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3aa63da5ec3538b$export$2e2bcd8739ae039);

var $fttMi = parcelRequire("fttMi");
function $c3aa63da5ec3538b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $fttMi.default)());
}

});
parcelRegister("fttMi", function(module, exports) {
$parcel$export(module.exports, "default", () => $b440a9b7db95e092$export$2e2bcd8739ae039);
function $b440a9b7db95e092$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("hMsdL", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf1ccf76c8705f19$export$2e2bcd8739ae039);

var $9U1SB = parcelRequire("9U1SB");

var $jqcF0 = parcelRequire("jqcF0");

var $lxsPK = parcelRequire("lxsPK");

var $lK3r3 = parcelRequire("lK3r3");
function $cf1ccf76c8705f19$export$2e2bcd8739ae039(node) {
    if (node === (0, $jqcF0.default)(node) || !(0, $lxsPK.isHTMLElement)(node)) return (0, $9U1SB.default)(node);
    else return (0, $lK3r3.default)(node);
}

});
parcelRegister("9U1SB", function(module, exports) {
$parcel$export(module.exports, "default", () => $735acd4717b89a9b$export$2e2bcd8739ae039);

var $jqcF0 = parcelRequire("jqcF0");
function $735acd4717b89a9b$export$2e2bcd8739ae039(node) {
    var win = (0, $jqcF0.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("lK3r3", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd408f0f7fc6f904$export$2e2bcd8739ae039);
function $fd408f0f7fc6f904$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("bFqu3", function(module, exports) {
$parcel$export(module.exports, "default", () => $87e8112f115e0ba7$export$2e2bcd8739ae039);
function $87e8112f115e0ba7$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("8iNOc", function(module, exports) {
$parcel$export(module.exports, "default", () => $60b6a422aa1d7c27$export$2e2bcd8739ae039);

var $5SX2j = parcelRequire("5SX2j");

var $2vuXD = parcelRequire("2vuXD");

var $9U1SB = parcelRequire("9U1SB");
function $60b6a422aa1d7c27$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $5SX2j.default)((0, $2vuXD.default)(element)).left + (0, $9U1SB.default)(element).scrollLeft;
}

});
parcelRegister("2vuXD", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d367e31a7efd199$export$2e2bcd8739ae039);

var $lxsPK = parcelRequire("lxsPK");
function $1d367e31a7efd199$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $lxsPK.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("jCpkw", function(module, exports) {
$parcel$export(module.exports, "default", () => $e48536f1c83ff3f8$export$2e2bcd8739ae039);

var $hEE65 = parcelRequire("hEE65");
function $e48536f1c83ff3f8$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $hEE65.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("hEE65", function(module, exports) {
$parcel$export(module.exports, "default", () => $cda54693c6d70b8e$export$2e2bcd8739ae039);

var $jqcF0 = parcelRequire("jqcF0");
function $cda54693c6d70b8e$export$2e2bcd8739ae039(element) {
    return (0, $jqcF0.default)(element).getComputedStyle(element);
}

});



parcelRegister("cI2gV", function(module, exports) {
$parcel$export(module.exports, "default", () => $940b5b44ec492788$export$2e2bcd8739ae039);

var $5SX2j = parcelRequire("5SX2j");
function $940b5b44ec492788$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $5SX2j.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("h2klf", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6726702709c9e29$export$2e2bcd8739ae039);

var $ef0ZL = parcelRequire("ef0ZL");

var $ljRpf = parcelRequire("ljRpf");

var $jqcF0 = parcelRequire("jqcF0");

var $jCpkw = parcelRequire("jCpkw");
function $c6726702709c9e29$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $ef0ZL.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $jqcF0.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $jCpkw.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($c6726702709c9e29$export$2e2bcd8739ae039((0, $ljRpf.default)(target)));
}

});
parcelRegister("ef0ZL", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5e33d0134a56fa3$export$2e2bcd8739ae039);

var $ljRpf = parcelRequire("ljRpf");

var $jCpkw = parcelRequire("jCpkw");

var $bFqu3 = parcelRequire("bFqu3");

var $lxsPK = parcelRequire("lxsPK");
function $a5e33d0134a56fa3$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $bFqu3.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $lxsPK.isHTMLElement)(node) && (0, $jCpkw.default)(node)) return node;
    return $a5e33d0134a56fa3$export$2e2bcd8739ae039((0, $ljRpf.default)(node));
}

});
parcelRegister("ljRpf", function(module, exports) {
$parcel$export(module.exports, "default", () => $f854ccb3f447e492$export$2e2bcd8739ae039);

var $bFqu3 = parcelRequire("bFqu3");

var $2vuXD = parcelRequire("2vuXD");

var $lxsPK = parcelRequire("lxsPK");
function $f854ccb3f447e492$export$2e2bcd8739ae039(element) {
    if ((0, $bFqu3.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $lxsPK.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $2vuXD.default)(element) // fallback
    );
}

});



parcelRegister("b40rk", function(module, exports) {
$parcel$export(module.exports, "default", () => $80e068c783f2bee0$export$2e2bcd8739ae039);

var $jqcF0 = parcelRequire("jqcF0");

var $bFqu3 = parcelRequire("bFqu3");

var $hEE65 = parcelRequire("hEE65");

var $lxsPK = parcelRequire("lxsPK");

var $aADW2 = parcelRequire("aADW2");

var $ljRpf = parcelRequire("ljRpf");

var $fttMi = parcelRequire("fttMi");
function $80e068c783f2bee0$var$getTrueOffsetParent(element) {
    if (!(0, $lxsPK.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $hEE65.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $80e068c783f2bee0$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $fttMi.default)());
    var isIE = /Trident/i.test((0, $fttMi.default)());
    if (isIE && (0, $lxsPK.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $hEE65.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $ljRpf.default)(element);
    if ((0, $lxsPK.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $lxsPK.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $bFqu3.default)(currentNode)) < 0){
        var css = (0, $hEE65.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $80e068c783f2bee0$export$2e2bcd8739ae039(element) {
    var window = (0, $jqcF0.default)(element);
    var offsetParent = $80e068c783f2bee0$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $aADW2.default)(offsetParent) && (0, $hEE65.default)(offsetParent).position === 'static')offsetParent = $80e068c783f2bee0$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $bFqu3.default)(offsetParent) === 'html' || (0, $bFqu3.default)(offsetParent) === 'body' && (0, $hEE65.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $80e068c783f2bee0$var$getContainingBlock(element) || window;
}

});
parcelRegister("aADW2", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b5c3e787e434546$export$2e2bcd8739ae039);

var $bFqu3 = parcelRequire("bFqu3");
function $7b5c3e787e434546$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $bFqu3.default)(element)) >= 0;
}

});


parcelRegister("aUEAQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f1e9f55695d8404$export$2e2bcd8739ae039);

var $eeoSb = parcelRequire("eeoSb");
function $7f1e9f55695d8404$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $7f1e9f55695d8404$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $7f1e9f55695d8404$var$order(modifiers); // order based on phase
    return (0, $eeoSb.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("eeoSb", function(module, exports) {
$parcel$export(module.exports, "top", () => $02ac7a7efb891b05$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $02ac7a7efb891b05$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $02ac7a7efb891b05$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $02ac7a7efb891b05$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $02ac7a7efb891b05$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $02ac7a7efb891b05$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $02ac7a7efb891b05$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $02ac7a7efb891b05$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $02ac7a7efb891b05$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $02ac7a7efb891b05$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $02ac7a7efb891b05$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $02ac7a7efb891b05$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $02ac7a7efb891b05$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $02ac7a7efb891b05$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $02ac7a7efb891b05$export$d087d3878fdf71d5);
var $02ac7a7efb891b05$export$1e95b668f3b82d = 'top';
var $02ac7a7efb891b05$export$40e543e69a8b3fbb = 'bottom';
var $02ac7a7efb891b05$export$79ffe56a765070d2 = 'right';
var $02ac7a7efb891b05$export$eabcd2c8791e7bf4 = 'left';
var $02ac7a7efb891b05$export$dfb5619354ba860 = 'auto';
var $02ac7a7efb891b05$export$aec2ce47c367b8c3 = [
    $02ac7a7efb891b05$export$1e95b668f3b82d,
    $02ac7a7efb891b05$export$40e543e69a8b3fbb,
    $02ac7a7efb891b05$export$79ffe56a765070d2,
    $02ac7a7efb891b05$export$eabcd2c8791e7bf4
];
var $02ac7a7efb891b05$export$b3571188c770cc5a = 'start';
var $02ac7a7efb891b05$export$bd5df0f255a350f8 = 'end';
var $02ac7a7efb891b05$export$390fd549c5303b4d = 'clippingParents';
var $02ac7a7efb891b05$export$d7b7311ec04a3e8f = 'viewport';
var $02ac7a7efb891b05$export$ae5ab1c730825774 = 'popper';
var $02ac7a7efb891b05$export$ca50aac9f3ba507f = 'reference';
var $02ac7a7efb891b05$export$368f9a87e87fa4e1 = /*#__PURE__*/ $02ac7a7efb891b05$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $02ac7a7efb891b05$export$b3571188c770cc5a,
        placement + "-" + $02ac7a7efb891b05$export$bd5df0f255a350f8
    ]);
}, []);
var $02ac7a7efb891b05$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($02ac7a7efb891b05$export$aec2ce47c367b8c3, [
    $02ac7a7efb891b05$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $02ac7a7efb891b05$export$b3571188c770cc5a,
        placement + "-" + $02ac7a7efb891b05$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $02ac7a7efb891b05$export$421679a7c3d56e = 'beforeRead';
var $02ac7a7efb891b05$export$aafa59e2e03f2942 = 'read';
var $02ac7a7efb891b05$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $02ac7a7efb891b05$export$c65e99957a05207c = 'beforeMain';
var $02ac7a7efb891b05$export$f22da7240b7add18 = 'main';
var $02ac7a7efb891b05$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $02ac7a7efb891b05$export$8d4d2d70e7d46032 = 'beforeWrite';
var $02ac7a7efb891b05$export$68d8715fc104d294 = 'write';
var $02ac7a7efb891b05$export$70a6e5159acce2e6 = 'afterWrite';
var $02ac7a7efb891b05$export$d087d3878fdf71d5 = [
    $02ac7a7efb891b05$export$421679a7c3d56e,
    $02ac7a7efb891b05$export$aafa59e2e03f2942,
    $02ac7a7efb891b05$export$6964f6c886723980,
    $02ac7a7efb891b05$export$c65e99957a05207c,
    $02ac7a7efb891b05$export$f22da7240b7add18,
    $02ac7a7efb891b05$export$bab79516f2d662fe,
    $02ac7a7efb891b05$export$8d4d2d70e7d46032,
    $02ac7a7efb891b05$export$68d8715fc104d294,
    $02ac7a7efb891b05$export$70a6e5159acce2e6
];

});


parcelRegister("jp2vh", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2024b46b66a297d$export$2e2bcd8739ae039);
function $e2024b46b66a297d$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("45WlR", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fb4e4733e092ed9$export$2e2bcd8739ae039);
function $2fb4e4733e092ed9$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("AYfmq", function(module, exports) {
$parcel$export(module.exports, "default", () => $06f218a851c306cc$export$2e2bcd8739ae039);

var $jqcF0 = parcelRequire("jqcF0");
var $06f218a851c306cc$var$passive = {
    passive: true
};
function $06f218a851c306cc$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $jqcF0.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $06f218a851c306cc$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $06f218a851c306cc$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $06f218a851c306cc$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $06f218a851c306cc$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $06f218a851c306cc$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $06f218a851c306cc$var$effect,
    data: {}
};

});

parcelRegister("jiyhn", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0ca49ea984cd711$export$2e2bcd8739ae039);

var $59O1l = parcelRequire("59O1l");
function $e0ca49ea984cd711$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $59O1l.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e0ca49ea984cd711$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $e0ca49ea984cd711$var$popperOffsets,
    data: {}
};

});
parcelRegister("59O1l", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c149818943b8402$export$2e2bcd8739ae039);

var $5DtdC = parcelRequire("5DtdC");

var $j73B1 = parcelRequire("j73B1");

var $9WY3v = parcelRequire("9WY3v");

var $eeoSb = parcelRequire("eeoSb");
function $3c149818943b8402$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $5DtdC.default)(placement) : null;
    var variation = placement ? (0, $j73B1.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $eeoSb.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $eeoSb.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $eeoSb.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $eeoSb.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $9WY3v.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $eeoSb.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $eeoSb.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("5DtdC", function(module, exports) {
$parcel$export(module.exports, "default", () => $41a74276d1437cf3$export$2e2bcd8739ae039);

function $41a74276d1437cf3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("j73B1", function(module, exports) {
$parcel$export(module.exports, "default", () => $dea175e1fbb039f4$export$2e2bcd8739ae039);
function $dea175e1fbb039f4$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("9WY3v", function(module, exports) {
$parcel$export(module.exports, "default", () => $73e81d9ee133d820$export$2e2bcd8739ae039);
function $73e81d9ee133d820$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("8xQBR", function(module, exports) {
$parcel$export(module.exports, "default", () => $638a36f4ddb5d6c8$export$2e2bcd8739ae039);

var $eeoSb = parcelRequire("eeoSb");

var $b40rk = parcelRequire("b40rk");

var $jqcF0 = parcelRequire("jqcF0");

var $2vuXD = parcelRequire("2vuXD");

var $hEE65 = parcelRequire("hEE65");

var $5DtdC = parcelRequire("5DtdC");

var $j73B1 = parcelRequire("j73B1");

var $kDvUD = parcelRequire("kDvUD");
var $638a36f4ddb5d6c8$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $638a36f4ddb5d6c8$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $kDvUD.round)(x * dpr) / dpr || 0,
        y: (0, $kDvUD.round)(y * dpr) / dpr || 0
    };
}
function $638a36f4ddb5d6c8$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $eeoSb.left);
    var sideY = (0, $eeoSb.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $b40rk.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $jqcF0.default)(popper)) {
            offsetParent = (0, $2vuXD.default)(popper);
            if ((0, $hEE65.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $eeoSb.top) || (placement === (0, $eeoSb.left) || placement === (0, $eeoSb.right)) && variation === (0, $eeoSb.end)) {
            sideY = (0, $eeoSb.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $eeoSb.left) || (placement === (0, $eeoSb.top) || placement === (0, $eeoSb.bottom)) && variation === (0, $eeoSb.end)) {
            sideX = (0, $eeoSb.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $638a36f4ddb5d6c8$var$unsetSides);
    var _ref4 = roundOffsets === true ? $638a36f4ddb5d6c8$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $jqcF0.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $638a36f4ddb5d6c8$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $5DtdC.default)(state.placement),
        variation: (0, $j73B1.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $638a36f4ddb5d6c8$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $638a36f4ddb5d6c8$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $638a36f4ddb5d6c8$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $638a36f4ddb5d6c8$var$computeStyles,
    data: {}
};

});

parcelRegister("95K1c", function(module, exports) {
$parcel$export(module.exports, "default", () => $69e846f9616ad096$export$2e2bcd8739ae039);

var $bFqu3 = parcelRequire("bFqu3");

var $lxsPK = parcelRequire("lxsPK");
// and applies them to the HTMLElements such as popper and arrow
function $69e846f9616ad096$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $lxsPK.isHTMLElement)(element) || !(0, $bFqu3.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $69e846f9616ad096$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $lxsPK.isHTMLElement)(element) || !(0, $bFqu3.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $69e846f9616ad096$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $69e846f9616ad096$var$applyStyles,
    effect: $69e846f9616ad096$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("lexRm", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7552b997e91c31f$export$2e2bcd8739ae039);

var $5DtdC = parcelRequire("5DtdC");

var $eeoSb = parcelRequire("eeoSb");
function $f7552b997e91c31f$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $5DtdC.default)(placement);
    var invertDistance = [
        (0, $eeoSb.left),
        (0, $eeoSb.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $eeoSb.left),
        (0, $eeoSb.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $f7552b997e91c31f$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $eeoSb.placements).reduce(function(acc, placement) {
        acc[placement] = $f7552b997e91c31f$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $f7552b997e91c31f$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $f7552b997e91c31f$var$offset
};

});

parcelRegister("euI62", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8d612a7f4de3fca$export$2e2bcd8739ae039);

var $41KCE = parcelRequire("41KCE");

var $5DtdC = parcelRequire("5DtdC");

var $8eKAj = parcelRequire("8eKAj");

var $a9NCa = parcelRequire("a9NCa");

var $1ybP7 = parcelRequire("1ybP7");

var $eeoSb = parcelRequire("eeoSb");

var $j73B1 = parcelRequire("j73B1");
function $a8d612a7f4de3fca$var$getExpandedFallbackPlacements(placement) {
    if ((0, $5DtdC.default)(placement) === (0, $eeoSb.auto)) return [];
    var oppositePlacement = (0, $41KCE.default)(placement);
    return [
        (0, $8eKAj.default)(placement),
        oppositePlacement,
        (0, $8eKAj.default)(oppositePlacement)
    ];
}
function $a8d612a7f4de3fca$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $5DtdC.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $41KCE.default)(preferredPlacement)
    ] : $a8d612a7f4de3fca$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $5DtdC.default)(placement) === (0, $eeoSb.auto) ? (0, $1ybP7.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $5DtdC.default)(placement);
        var isStartVariation = (0, $j73B1.default)(placement) === (0, $eeoSb.start);
        var isVertical = [
            (0, $eeoSb.top),
            (0, $eeoSb.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $a9NCa.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $eeoSb.right) : (0, $eeoSb.left) : isStartVariation ? (0, $eeoSb.bottom) : (0, $eeoSb.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $41KCE.default)(mainVariationSide);
        var altVariationSide = (0, $41KCE.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $a8d612a7f4de3fca$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $a8d612a7f4de3fca$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("41KCE", function(module, exports) {
$parcel$export(module.exports, "default", () => $2eeb6ba489107ea4$export$2e2bcd8739ae039);
var $2eeb6ba489107ea4$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $2eeb6ba489107ea4$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $2eeb6ba489107ea4$var$hash[matched];
    });
}

});

parcelRegister("8eKAj", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ff3c44405c30b93$export$2e2bcd8739ae039);
var $5ff3c44405c30b93$var$hash = {
    start: 'end',
    end: 'start'
};
function $5ff3c44405c30b93$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $5ff3c44405c30b93$var$hash[matched];
    });
}

});

parcelRegister("a9NCa", function(module, exports) {
$parcel$export(module.exports, "default", () => $76513b0dab162e77$export$2e2bcd8739ae039);

var $KtIU2 = parcelRequire("KtIU2");

var $2vuXD = parcelRequire("2vuXD");

var $5SX2j = parcelRequire("5SX2j");

var $59O1l = parcelRequire("59O1l");

var $dyjBZ = parcelRequire("dyjBZ");

var $eeoSb = parcelRequire("eeoSb");

var $lxsPK = parcelRequire("lxsPK");

var $1kKwt = parcelRequire("1kKwt");

var $737LB = parcelRequire("737LB");
function $76513b0dab162e77$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $eeoSb.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $eeoSb.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $eeoSb.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $1kKwt.default)(typeof padding !== 'number' ? padding : (0, $737LB.default)(padding, (0, $eeoSb.basePlacements)));
    var altContext = elementContext === (0, $eeoSb.popper) ? (0, $eeoSb.reference) : (0, $eeoSb.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $KtIU2.default)((0, $lxsPK.isElement)(element) ? element : element.contextElement || (0, $2vuXD.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $5SX2j.default)(state.elements.reference);
    var popperOffsets = (0, $59O1l.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $dyjBZ.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $eeoSb.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $eeoSb.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $eeoSb.right),
                (0, $eeoSb.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $eeoSb.top),
                (0, $eeoSb.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("KtIU2", function(module, exports) {
$parcel$export(module.exports, "default", () => $08bb5a68a7569dd1$export$2e2bcd8739ae039);

var $eeoSb = parcelRequire("eeoSb");

var $cUoeH = parcelRequire("cUoeH");

var $bxSZJ = parcelRequire("bxSZJ");

var $h2klf = parcelRequire("h2klf");

var $b40rk = parcelRequire("b40rk");

var $2vuXD = parcelRequire("2vuXD");

var $hEE65 = parcelRequire("hEE65");

var $lxsPK = parcelRequire("lxsPK");

var $5SX2j = parcelRequire("5SX2j");

var $ljRpf = parcelRequire("ljRpf");

var $kIXW4 = parcelRequire("kIXW4");

var $bFqu3 = parcelRequire("bFqu3");

var $dyjBZ = parcelRequire("dyjBZ");

var $kDvUD = parcelRequire("kDvUD");
function $08bb5a68a7569dd1$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $5SX2j.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $08bb5a68a7569dd1$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $eeoSb.viewport) ? (0, $dyjBZ.default)((0, $cUoeH.default)(element, strategy)) : (0, $lxsPK.isElement)(clippingParent) ? $08bb5a68a7569dd1$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $dyjBZ.default)((0, $bxSZJ.default)((0, $2vuXD.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $08bb5a68a7569dd1$var$getClippingParents(element) {
    var clippingParents = (0, $h2klf.default)((0, $ljRpf.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $hEE65.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $lxsPK.isHTMLElement)(element) ? (0, $b40rk.default)(element) : element;
    if (!(0, $lxsPK.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $lxsPK.isElement)(clippingParent) && (0, $kIXW4.default)(clippingParent, clipperElement) && (0, $bFqu3.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $08bb5a68a7569dd1$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $08bb5a68a7569dd1$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $08bb5a68a7569dd1$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $kDvUD.max)(rect.top, accRect.top);
        accRect.right = (0, $kDvUD.min)(rect.right, accRect.right);
        accRect.bottom = (0, $kDvUD.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $kDvUD.max)(rect.left, accRect.left);
        return accRect;
    }, $08bb5a68a7569dd1$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("cUoeH", function(module, exports) {
$parcel$export(module.exports, "default", () => $965d83c411363a82$export$2e2bcd8739ae039);

var $jqcF0 = parcelRequire("jqcF0");

var $2vuXD = parcelRequire("2vuXD");

var $8iNOc = parcelRequire("8iNOc");

var $gNwrE = parcelRequire("gNwrE");
function $965d83c411363a82$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $jqcF0.default)(element);
    var html = (0, $2vuXD.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $gNwrE.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $8iNOc.default)(element),
        y: y
    };
}

});

parcelRegister("bxSZJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $867d6f9773686e85$export$2e2bcd8739ae039);

var $2vuXD = parcelRequire("2vuXD");

var $hEE65 = parcelRequire("hEE65");

var $8iNOc = parcelRequire("8iNOc");

var $9U1SB = parcelRequire("9U1SB");

var $kDvUD = parcelRequire("kDvUD");
function $867d6f9773686e85$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $2vuXD.default)(element);
    var winScroll = (0, $9U1SB.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $kDvUD.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $kDvUD.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $8iNOc.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $hEE65.default)(body || html).direction === 'rtl') x += (0, $kDvUD.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("kIXW4", function(module, exports) {
$parcel$export(module.exports, "default", () => $f16668aaebdec374$export$2e2bcd8739ae039);

var $lxsPK = parcelRequire("lxsPK");
function $f16668aaebdec374$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $lxsPK.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("dyjBZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ddda9cf12580473$export$2e2bcd8739ae039);
function $9ddda9cf12580473$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("1kKwt", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f8bbf2cee5893df$export$2e2bcd8739ae039);

var $dGQny = parcelRequire("dGQny");
function $0f8bbf2cee5893df$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $dGQny.default)(), paddingObject);
}

});
parcelRegister("dGQny", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f77d3f4875fb909$export$2e2bcd8739ae039);
function $9f77d3f4875fb909$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("737LB", function(module, exports) {
$parcel$export(module.exports, "default", () => $521ed68a58dda134$export$2e2bcd8739ae039);
function $521ed68a58dda134$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("1ybP7", function(module, exports) {
$parcel$export(module.exports, "default", () => $12122352a478c0c2$export$2e2bcd8739ae039);

var $j73B1 = parcelRequire("j73B1");

var $eeoSb = parcelRequire("eeoSb");

var $a9NCa = parcelRequire("a9NCa");

var $5DtdC = parcelRequire("5DtdC");
function $12122352a478c0c2$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $eeoSb.placements) : _options$allowedAutoP;
    var variation = (0, $j73B1.default)(placement);
    var placements = variation ? flipVariations ? (0, $eeoSb.variationPlacements) : (0, $eeoSb.variationPlacements).filter(function(placement) {
        return (0, $j73B1.default)(placement) === variation;
    }) : (0, $eeoSb.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $a9NCa.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $5DtdC.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("hlR4d", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca1d8fd29157d544$export$2e2bcd8739ae039);

var $eeoSb = parcelRequire("eeoSb");

var $5DtdC = parcelRequire("5DtdC");

var $9WY3v = parcelRequire("9WY3v");

var $2x9Hn = parcelRequire("2x9Hn");

var $b5qu5 = parcelRequire("b5qu5");

var $cI2gV = parcelRequire("cI2gV");

var $b40rk = parcelRequire("b40rk");

var $a9NCa = parcelRequire("a9NCa");

var $j73B1 = parcelRequire("j73B1");

var $dGQny = parcelRequire("dGQny");

var $kDvUD = parcelRequire("kDvUD");
function $ca1d8fd29157d544$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $a9NCa.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $5DtdC.default)(state.placement);
    var variation = (0, $j73B1.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $9WY3v.default)(basePlacement);
    var altAxis = (0, $2x9Hn.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $eeoSb.top) : (0, $eeoSb.left);
        var altSide = mainAxis === 'y' ? (0, $eeoSb.bottom) : (0, $eeoSb.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $eeoSb.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $eeoSb.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $cI2gV.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $dGQny.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $b5qu5.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $b40rk.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $b5qu5.within)(tether ? (0, $kDvUD.min)(min, tetherMin) : min, offset, tether ? (0, $kDvUD.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $eeoSb.top) : (0, $eeoSb.left);
        var _altSide = mainAxis === 'x' ? (0, $eeoSb.bottom) : (0, $eeoSb.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $eeoSb.top),
            (0, $eeoSb.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $b5qu5.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $b5qu5.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ca1d8fd29157d544$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $ca1d8fd29157d544$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("2x9Hn", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d862fcd66e44014$export$2e2bcd8739ae039);
function $1d862fcd66e44014$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("b5qu5", function(module, exports) {
$parcel$export(module.exports, "within", () => $8124b495417018b8$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $8124b495417018b8$export$86c8af6d3ef0b4a);

var $kDvUD = parcelRequire("kDvUD");
function $8124b495417018b8$export$f28d906d67a997f3(min, value, max) {
    return (0, $kDvUD.max)(min, (0, $kDvUD.min)(value, max));
}
function $8124b495417018b8$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $8124b495417018b8$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("1ISmI", function(module, exports) {
$parcel$export(module.exports, "default", () => $14141253d5c51d60$export$2e2bcd8739ae039);

var $5DtdC = parcelRequire("5DtdC");

var $cI2gV = parcelRequire("cI2gV");

var $kIXW4 = parcelRequire("kIXW4");

var $b40rk = parcelRequire("b40rk");

var $9WY3v = parcelRequire("9WY3v");

var $b5qu5 = parcelRequire("b5qu5");

var $1kKwt = parcelRequire("1kKwt");

var $737LB = parcelRequire("737LB");

var $eeoSb = parcelRequire("eeoSb");
var $14141253d5c51d60$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $1kKwt.default)(typeof padding !== 'number' ? padding : (0, $737LB.default)(padding, (0, $eeoSb.basePlacements)));
};
function $14141253d5c51d60$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $5DtdC.default)(state.placement);
    var axis = (0, $9WY3v.default)(basePlacement);
    var isVertical = [
        (0, $eeoSb.left),
        (0, $eeoSb.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $14141253d5c51d60$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $cI2gV.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $eeoSb.top) : (0, $eeoSb.left);
    var maxProp = axis === 'y' ? (0, $eeoSb.bottom) : (0, $eeoSb.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $b40rk.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $b5qu5.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $14141253d5c51d60$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $kIXW4.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $14141253d5c51d60$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $14141253d5c51d60$var$arrow,
    effect: $14141253d5c51d60$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("hoRGB", function(module, exports) {
$parcel$export(module.exports, "default", () => $caae528698324902$export$2e2bcd8739ae039);

var $eeoSb = parcelRequire("eeoSb");

var $a9NCa = parcelRequire("a9NCa");
function $caae528698324902$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $caae528698324902$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $eeoSb.top),
        (0, $eeoSb.right),
        (0, $eeoSb.bottom),
        (0, $eeoSb.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $caae528698324902$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $a9NCa.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $a9NCa.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $caae528698324902$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $caae528698324902$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $caae528698324902$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $caae528698324902$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $caae528698324902$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $caae528698324902$var$hide
};

});


parcelRegister("dcrmD", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $99c19f4408065da5$var$hasElementType = typeof Element !== 'undefined';
var $99c19f4408065da5$var$hasMap = typeof Map === 'function';
var $99c19f4408065da5$var$hasSet = typeof Set === 'function';
var $99c19f4408065da5$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $99c19f4408065da5$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$99c19f4408065da5$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($99c19f4408065da5$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$99c19f4408065da5$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($99c19f4408065da5$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($99c19f4408065da5$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($99c19f4408065da5$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$99c19f4408065da5$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $99c19f4408065da5$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});



parcelRegister("afMOk", function(module, exports) {
$parcel$export(module.exports, "default", () => $77712ae8b5d25352$export$2e2bcd8739ae039);
var $77712ae8b5d25352$var$isProduction = true;
var $77712ae8b5d25352$var$prefix = 'Invariant failed';
function $77712ae8b5d25352$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($77712ae8b5d25352$var$isProduction) throw new Error($77712ae8b5d25352$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($77712ae8b5d25352$var$prefix, ": ").concat(provided) : $77712ae8b5d25352$var$prefix;
    throw new Error(value);
}

});

parcelRegister("6eqzM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::03f86cbf4091cea96938f1feb145f315>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4898aa5267f26f35$var$_react = $4898aa5267f26f35$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $4898aa5267f26f35$var$_UNSAFE_baseNew = $4898aa5267f26f35$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $4898aa5267f26f35$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Close".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4898aa5267f26f35$var$CloseIcon = (props)=>/*#__PURE__*/ $4898aa5267f26f35$var$_react.default.createElement($4898aa5267f26f35$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2.5 13.5 8 8m5.5-5.5L8 8m0 0L2.5 2.5M8 8l5.5 5.5"/>`
    }, props));
$4898aa5267f26f35$var$CloseIcon.displayName = 'CloseIcon';
var $4898aa5267f26f35$var$_default = module.exports.default = $4898aa5267f26f35$var$CloseIcon;

});
parcelRegister("bPdWt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("jpq6X")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("jpq6X")).Icon);

var $jpq6X = parcelRequire("jpq6X");

});
parcelRegister("jpq6X", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $e2149b474c781d8d$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $e2149b474c781d8d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $5Y2Mt = parcelRequire("5Y2Mt");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $e2149b474c781d8d$var$commonSVGStyles = (0, $74Zh5.css)({
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: 'currentColor'
    }
});
var $e2149b474c781d8d$var$svgStyles = (0, $74Zh5.css)({
    color: 'currentColor',
    verticalAlign: 'bottom'
});
var $e2149b474c781d8d$var$iconStyles = (0, $74Zh5.css)({
    display: 'inline-block',
    boxSizing: 'border-box',
    flexShrink: 0,
    lineHeight: 1,
    paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
    paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
});
var $e2149b474c781d8d$var$utilityIconStyles = (0, $74Zh5.css)({
    lineHeight: "var(--ds-space-150, 12px)"
});
var $e2149b474c781d8d$var$scaleStyles = (0, $74Zh5.css)({
    width: 'inherit',
    height: 'inherit'
});
/**
 * For windows high contrast mode
 */ var $e2149b474c781d8d$var$baseHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        color: 'CanvasText',
        filter: 'grayscale(1)'
    }
});
var $e2149b474c781d8d$var$scaleSize = (0, $74Zh5.css)({
    width: 'inherit',
    height: 'inherit'
});
var $e2149b474c781d8d$var$sizeMap = {
    core: {
        none: (0, $74Zh5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $74Zh5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $74Zh5.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $74Zh5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $74Zh5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $e2149b474c781d8d$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $e2149b474c781d8d$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $e2149b474c781d8d$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $5Y2Mt.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return (0, $74Zh5.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $e2149b474c781d8d$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core'];
    var viewBoxPadding;
    if (props.type === 'utility') {
        var _props$spacing;
        viewBoxPadding = $e2149b474c781d8d$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : 'none'];
    } else {
        var _props$spacing2;
        viewBoxPadding = $e2149b474c781d8d$var$paddingMap['core'][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : 'none'];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = "\n<filter id=\"ds-newIconOpacityFilter\">\n  <feFlood flood-color=\"var(--ds-icon-disabled)\" />\n  <feComposite in2=\"SourceGraphic\" operator=\"in\" />\n</filter>\n<g filter=\"url(#ds-newIconOpacityFilter)\">\n  ".concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $74Zh5.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $e2149b474c781d8d$var$iconStyles,
            $e2149b474c781d8d$var$baseHcmStyles,
            shouldScale && $e2149b474c781d8d$var$scaleStyles,
            props.type === 'utility' && $e2149b474c781d8d$var$utilityIconStyles
        ]
    }, (0, $74Zh5.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $e2149b474c781d8d$var$commonSVGStyles,
            $e2149b474c781d8d$var$svgStyles,
            shouldScale ? $e2149b474c781d8d$var$scaleSize : props.type === 'utility' ? $e2149b474c781d8d$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : 'none'] : $e2149b474c781d8d$var$sizeMap['core'][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : 'none']
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $e2149b474c781d8d$export$2e2bcd8739ae039 = $e2149b474c781d8d$export$f04a61298a47a40f;

});
parcelRegister("5Y2Mt", function(module, exports) {
$parcel$export(module.exports, "fg", () => $4584b692e0bf28ba$export$b40ec24ac8275656);

var $3lNzr = parcelRequire("3lNzr");
function $4584b692e0bf28ba$export$ba05d765b8392e5e(flagResolver) {
    (0, $3lNzr.setBooleanResolver)(flagResolver);
}
function $4584b692e0bf28ba$export$470e5c2be1411c89(name) {
    return (0, $3lNzr.resolveBooleanFlag)(name);
}
function $4584b692e0bf28ba$export$b40ec24ac8275656(name) {
    return (0, $3lNzr.resolveBooleanFlag)(name);
}

});
parcelRegister("3lNzr", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $2709c8f7e7bb8045$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $2709c8f7e7bb8045$export$6333b6aff9fc6275);

var $fv8wc = parcelRequire("fv8wc");

var $3ZMUU = parcelRequire("3ZMUU");
var $2709c8f7e7bb8045$var$pkgName = '@atlaskit/platform-feature-flags';
var $2709c8f7e7bb8045$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $2709c8f7e7bb8045$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $2709c8f7e7bb8045$var$ENV_ENABLE_PLATFORM_FF = $2709c8f7e7bb8045$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $2709c8f7e7bb8045$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $2709c8f7e7bb8045$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $2709c8f7e7bb8045$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $2709c8f7e7bb8045$var$ENV_ENABLE_PLATFORM_FF || $2709c8f7e7bb8045$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $2709c8f7e7bb8045$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $2709c8f7e7bb8045$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$2709c8f7e7bb8045$var$globalVar[$2709c8f7e7bb8045$export$7e41b1b2bdee3f98] = $2709c8f7e7bb8045$var$globalVar[$2709c8f7e7bb8045$export$7e41b1b2bdee3f98] || $2709c8f7e7bb8045$var$DEFAULT_PFF_GLOBAL;
function $2709c8f7e7bb8045$export$f2b591175b3e424c(resolver) {
    $2709c8f7e7bb8045$var$globalVar[$2709c8f7e7bb8045$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $2709c8f7e7bb8045$export$6333b6aff9fc6275(flagKey) {
    if ($2709c8f7e7bb8045$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $fv8wc.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $2709c8f7e7bb8045$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $2709c8f7e7bb8045$var$globalVar[$2709c8f7e7bb8045$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("fv8wc", function(module, exports) {
$parcel$export(module.exports, "debug", () => $b4905bd7c6b84ead$export$1c9f709888824e05);
var $b4905bd7c6b84ead$var$_ref, $b4905bd7c6b84ead$var$_process, $b4905bd7c6b84ead$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $b4905bd7c6b84ead$var$TESTS_MODE = ($b4905bd7c6b84ead$var$_ref = (globalThis === null || globalThis === void 0 || ($b4905bd7c6b84ead$var$_process = globalThis.process) === null || $b4905bd7c6b84ead$var$_process === void 0 || ($b4905bd7c6b84ead$var$_process = $b4905bd7c6b84ead$var$_process.env) === null || $b4905bd7c6b84ead$var$_process === void 0 ? void 0 : $b4905bd7c6b84ead$var$_process.JEST_WORKER_ID) !== undefined, $b4905bd7c6b84ead$var$_ref !== void 0) ? $b4905bd7c6b84ead$var$_ref : false;
var $b4905bd7c6b84ead$var$DEBUG_MODE = !$b4905bd7c6b84ead$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($b4905bd7c6b84ead$var$_process2 = globalThis.process) === null || $b4905bd7c6b84ead$var$_process2 === void 0 || ($b4905bd7c6b84ead$var$_process2 = $b4905bd7c6b84ead$var$_process2.env) === null || $b4905bd7c6b84ead$var$_process2 === void 0 ? void 0 : $b4905bd7c6b84ead$var$_process2.NODE_ENV) !== 'production';
var $b4905bd7c6b84ead$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$b4905bd7c6b84ead$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});






parcelRegister("aBp15", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bfe67a5a24a2dcfb0853d331aeb2068>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7b80c3d6520e58ce$var$_react = $7b80c3d6520e58ce$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $7b80c3d6520e58ce$var$_UNSAFE_baseNew = $7b80c3d6520e58ce$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $7b80c3d6520e58ce$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7b80c3d6520e58ce$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $7b80c3d6520e58ce$var$_react.default.createElement($7b80c3d6520e58ce$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m3 13 9.25-9.25m-6.5-.5h7v7"/>`
    }, props));
$7b80c3d6520e58ce$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
var $7b80c3d6520e58ce$var$_default = module.exports.default = $7b80c3d6520e58ce$var$ArrowUpRightIcon;

});

parcelRegister("exnso", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8cb0749e395cf6d25ab2f6745905850>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a95657d5bf2b1720$var$_react = $a95657d5bf2b1720$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $a95657d5bf2b1720$var$_UNSAFE_baseNew = $a95657d5bf2b1720$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $a95657d5bf2b1720$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a95657d5bf2b1720$var$DownloadIcon = (props)=>/*#__PURE__*/ $a95657d5bf2b1720$var$_react.default.createElement($a95657d5bf2b1720$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 1v8.75m-4-3.5 4 4 4-4"/>`
    }, props));
$a95657d5bf2b1720$var$DownloadIcon.displayName = 'DownloadIcon';
var $a95657d5bf2b1720$var$_default = module.exports.default = $a95657d5bf2b1720$var$DownloadIcon;

});

parcelRegister("ln0Ih", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d611fb3947c00fee344914368e144168>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8ec4c98b0af414e$var$_react = $f8ec4c98b0af414e$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $f8ec4c98b0af414e$var$_UNSAFE_baseNew = $f8ec4c98b0af414e$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $f8ec4c98b0af414e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Location".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f8ec4c98b0af414e$var$LocationIcon = (props)=>/*#__PURE__*/ $f8ec4c98b0af414e$var$_react.default.createElement($f8ec4c98b0af414e$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M3.677 8.982 8 15.25l4.323-6.268C14.725 5.5 12.232.75 8 .75c-4.231 0-6.725 4.749-4.323 8.232Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M9.75 6a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"/>`
    }, props));
$f8ec4c98b0af414e$var$LocationIcon.displayName = 'LocationIcon';
var $f8ec4c98b0af414e$var$_default = module.exports.default = $f8ec4c98b0af414e$var$LocationIcon;

});

parcelRegister("jfDBU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28198ce9e0c3202094e2855b88c09086>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e03e24db334664c9$var$_react = $e03e24db334664c9$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $e03e24db334664c9$var$_UNSAFE_baseNew = $e03e24db334664c9$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $e03e24db334664c9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e03e24db334664c9$var$AddIcon = (props)=>/*#__PURE__*/ $e03e24db334664c9$var$_react.default.createElement($e03e24db334664c9$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 8h7M8 8H1m7 0V1m0 7v7"/>`
    }, props));
$e03e24db334664c9$var$AddIcon.displayName = 'AddIcon';
var $e03e24db334664c9$var$_default = module.exports.default = $e03e24db334664c9$var$AddIcon;

});

parcelRegister("ldiUp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8eff4e7c48a4dd161566c1dd735476d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7197ac65ba3f230$var$_react = $f7197ac65ba3f230$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $f7197ac65ba3f230$var$_UNSAFE_baseNew = $f7197ac65ba3f230$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $f7197ac65ba3f230$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7197ac65ba3f230$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $f7197ac65ba3f230$var$_react.default.createElement($f7197ac65ba3f230$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15 8H2.25m4.5-5-5 5 5 5"/>`
    }, props));
$f7197ac65ba3f230$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $f7197ac65ba3f230$var$_default = module.exports.default = $f7197ac65ba3f230$var$ArrowLeftIcon;

});

parcelRegister("5GKWl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a0af1361c1c47b464cd1f3e8c2b50c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4245494da0fe5130$var$_react = $4245494da0fe5130$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $4245494da0fe5130$var$_UNSAFE_baseNew = $4245494da0fe5130$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $4245494da0fe5130$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4245494da0fe5130$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $4245494da0fe5130$var$_react.default.createElement($4245494da0fe5130$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
    }, props));
$4245494da0fe5130$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $4245494da0fe5130$var$_default = module.exports.default = $4245494da0fe5130$var$ArrowRightIcon;

});

parcelRegister("5mlBi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f57cdfdfff00f4122214ded49823394f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e6fc33902ea2145$var$_react = $3e6fc33902ea2145$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $3e6fc33902ea2145$var$_UNSAFE_baseNew = $3e6fc33902ea2145$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $3e6fc33902ea2145$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e6fc33902ea2145$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $3e6fc33902ea2145$var$_react.default.createElement($3e6fc33902ea2145$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 15V2.25m-5 4.5 5-5 5 5"/>`
    }, props));
$3e6fc33902ea2145$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $3e6fc33902ea2145$var$_default = module.exports.default = $3e6fc33902ea2145$var$ArrowUpIcon;

});

parcelRegister("bE62y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::209317c625743d387bf26edea0c296a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87a81d9353dfd9e5$var$_react = $87a81d9353dfd9e5$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $87a81d9353dfd9e5$var$_UNSAFE_baseNew = $87a81d9353dfd9e5$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $87a81d9353dfd9e5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87a81d9353dfd9e5$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $87a81d9353dfd9e5$var$_react.default.createElement($87a81d9353dfd9e5$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$87a81d9353dfd9e5$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $87a81d9353dfd9e5$var$_default = module.exports.default = $87a81d9353dfd9e5$var$CheckMarkIcon;

});

parcelRegister("4AP9B", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f4494144da7877c599489a550534c1d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3582344d7fa5dcf3$var$_react = $3582344d7fa5dcf3$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $3582344d7fa5dcf3$var$_UNSAFE_baseNew = $3582344d7fa5dcf3$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $3582344d7fa5dcf3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3582344d7fa5dcf3$var$SuccessIcon = (props)=>/*#__PURE__*/ $3582344d7fa5dcf3$var$_react.default.createElement($3582344d7fa5dcf3$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$3582344d7fa5dcf3$var$SuccessIcon.displayName = 'SuccessIcon';
var $3582344d7fa5dcf3$var$_default = module.exports.default = $3582344d7fa5dcf3$var$SuccessIcon;

});

parcelRegister("eC7kC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::33c5439f087752870260bcf48e3a4598>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa3a4d38428adcec$var$_react = $aa3a4d38428adcec$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $aa3a4d38428adcec$var$_UNSAFE_baseNew = $aa3a4d38428adcec$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $aa3a4d38428adcec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: completed items, productivity emoji category. Completed task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aa3a4d38428adcec$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $aa3a4d38428adcec$var$_react.default.createElement($aa3a4d38428adcec$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.25 8 2.5 3 5-6M8 .75a7.25 7.25 0 1 0 0 14.5A7.25 7.25 0 0 0 8 .75Z"/>`
    }, props));
$aa3a4d38428adcec$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $aa3a4d38428adcec$var$_default = module.exports.default = $aa3a4d38428adcec$var$CheckCircleIcon;

});

parcelRegister("5Y5FQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c58509c5f883b07cf4640f47a045782>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4586f51195fee032$var$_react = $4586f51195fee032$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $4586f51195fee032$var$_UNSAFE_baseNew = $4586f51195fee032$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $4586f51195fee032$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4586f51195fee032$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $4586f51195fee032$var$_react.default.createElement($4586f51195fee032$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 4.5 8.25 6.75 6 9 3.75 6.75 1.5 4.5"/>`,
        type: 'utility'
    }, props));
$4586f51195fee032$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $4586f51195fee032$var$_default = module.exports.default = $4586f51195fee032$var$ChevronDownIcon;

});

parcelRegister("447N2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53517bd082840f7b30aeaa6b952f5491>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f5d940f7dfc484b$var$_react = $2f5d940f7dfc484b$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $2f5d940f7dfc484b$var$_UNSAFE_baseNew = $2f5d940f7dfc484b$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $2f5d940f7dfc484b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2f5d940f7dfc484b$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $2f5d940f7dfc484b$var$_react.default.createElement($2f5d940f7dfc484b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$2f5d940f7dfc484b$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $2f5d940f7dfc484b$var$_default = module.exports.default = $2f5d940f7dfc484b$var$ChevronLeftIcon;

});

parcelRegister("jiU5J", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9bfbdf898b5516a0a7c630d609b6042>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e0db35598b898136$var$_react = $e0db35598b898136$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $e0db35598b898136$var$_UNSAFE_baseNew = $e0db35598b898136$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $e0db35598b898136$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronRight".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e0db35598b898136$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $e0db35598b898136$var$_react.default.createElement($e0db35598b898136$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.5 10.5 9 6 4.5 1.5"/>`,
        type: 'utility'
    }, props));
$e0db35598b898136$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $e0db35598b898136$var$_default = module.exports.default = $e0db35598b898136$var$ChevronRightIcon;

});

parcelRegister("cS1ic", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f998c57d427ae10203b04c2186c5e29c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $95eb87dfd7aaf542$var$_react = $95eb87dfd7aaf542$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $95eb87dfd7aaf542$var$_UNSAFE_baseNew = $95eb87dfd7aaf542$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $95eb87dfd7aaf542$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronUp".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for accordions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $95eb87dfd7aaf542$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $95eb87dfd7aaf542$var$_react.default.createElement($95eb87dfd7aaf542$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 7.5 6 3 1.5 7.5"/>`,
        type: 'utility'
    }, props));
$95eb87dfd7aaf542$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $95eb87dfd7aaf542$var$_default = module.exports.default = $95eb87dfd7aaf542$var$ChevronUpIcon;

});

parcelRegister("gxkfx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ba7502fd657c116f257aba05875c56e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c09f6f8967b695b2$var$_react = $c09f6f8967b695b2$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $c09f6f8967b695b2$var$_UNSAFE_baseNew = $c09f6f8967b695b2$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $c09f6f8967b695b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c09f6f8967b695b2$var$CopyIcon = (props)=>/*#__PURE__*/ $c09f6f8967b695b2$var$_react.default.createElement($c09f6f8967b695b2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
    }, props));
$c09f6f8967b695b2$var$CopyIcon.displayName = 'CopyIcon';
var $c09f6f8967b695b2$var$_default = module.exports.default = $c09f6f8967b695b2$var$CopyIcon;

});

parcelRegister("dI7Bp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d48c51235c7072e6617b637653c3f4fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9fb5481de0946722$var$_react = $9fb5481de0946722$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $9fb5481de0946722$var$_UNSAFE_baseNew = $9fb5481de0946722$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $9fb5481de0946722$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9fb5481de0946722$var$EditIcon = (props)=>/*#__PURE__*/ $9fb5481de0946722$var$_react.default.createElement($9fb5481de0946722$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.751H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V10m-.75-5 1.116-1.116a1.25 1.25 0 0 0 0-1.768l-.732-.732a1.25 1.25 0 0 0-1.768 0L11 2.5M13.5 5 9.479 9.021c-.15.15-.336.26-.54.318l-3.189.911.911-3.189a1.25 1.25 0 0 1 .318-.54L11 2.5M13.5 5 11 2.5"/>`
    }, props));
$9fb5481de0946722$var$EditIcon.displayName = 'EditIcon';
var $9fb5481de0946722$var$_default = module.exports.default = $9fb5481de0946722$var$EditIcon;

});

parcelRegister("b37du", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ccc84bee668fd63ce995277b659b1b62>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $80b592924604b138$var$_react = $80b592924604b138$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $80b592924604b138$var$_UNSAFE_baseNew = $80b592924604b138$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $80b592924604b138$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ContentWrapRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for right aligning media and content with wrapping enabled.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $80b592924604b138$var$ContentWrapRightIcon = (props)=>/*#__PURE__*/ $80b592924604b138$var$_react.default.createElement($80b592924604b138$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 1.75h14M1 14.25h14M1 5.917h6m-6 4.166h6m6.625.167h-3.25a.625.625 0 0 1-.625-.625v-3.25c0-.345.28-.625.625-.625h3.25c.345 0 .625.28.625.625v3.25c0 .345-.28.625-.625.625Z"/>`
    }, props));
$80b592924604b138$var$ContentWrapRightIcon.displayName = 'ContentWrapRightIcon';
var $80b592924604b138$var$_default = module.exports.default = $80b592924604b138$var$ContentWrapRightIcon;

});

parcelRegister("93YpG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db48d6c22f8d07c19434865c237f982>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $699341ac301ccbcd$var$_react = $699341ac301ccbcd$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $699341ac301ccbcd$var$_UNSAFE_baseNew = $699341ac301ccbcd$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $699341ac301ccbcd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $699341ac301ccbcd$var$InformationIcon = (props)=>/*#__PURE__*/ $699341ac301ccbcd$var$_react.default.createElement($699341ac301ccbcd$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$699341ac301ccbcd$var$InformationIcon.displayName = 'InformationIcon';
var $699341ac301ccbcd$var$_default = module.exports.default = $699341ac301ccbcd$var$InformationIcon;

});

parcelRegister("bWJYo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4362663ac35e79a0a9cff3b383986020>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b28c5c2dc2db7c8$var$_react = $8b28c5c2dc2db7c8$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $8b28c5c2dc2db7c8$var$_UNSAFE_baseNew = $8b28c5c2dc2db7c8$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $8b28c5c2dc2db7c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Grid".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: spaces in Confluence, and grid view, all content in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8b28c5c2dc2db7c8$var$GridIcon = (props)=>/*#__PURE__*/ $8b28c5c2dc2db7c8$var$_react.default.createElement($8b28c5c2dc2db7c8$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 1.75H3c-.69 0-1.25.56-1.25 1.25v5M8 1.75h5c.69 0 1.25.56 1.25 1.25v5M8 1.75v12.5m0 0h5c.69 0 1.25-.56 1.25-1.25V8M8 14.25H3c-.69 0-1.25-.56-1.25-1.25V8m0 0h12.5"/>`
    }, props));
$8b28c5c2dc2db7c8$var$GridIcon.displayName = 'GridIcon';
var $8b28c5c2dc2db7c8$var$_default = module.exports.default = $8b28c5c2dc2db7c8$var$GridIcon;

});

parcelRegister("cJnPm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a48a035a6b6ee27b8a00a2b1992b2cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $944c2ba5b5fba3a7$var$_react = $944c2ba5b5fba3a7$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $944c2ba5b5fba3a7$var$_UNSAFE_baseNew = $944c2ba5b5fba3a7$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $944c2ba5b5fba3a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Clock".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: recent, time input, sprint time remaining. Overdue task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $944c2ba5b5fba3a7$var$ClockIcon = (props)=>/*#__PURE__*/ $944c2ba5b5fba3a7$var$_react.default.createElement($944c2ba5b5fba3a7$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 3.25V8l2.5 2m4.75-2A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Z"/>`
    }, props));
$944c2ba5b5fba3a7$var$ClockIcon.displayName = 'ClockIcon';
var $944c2ba5b5fba3a7$var$_default = module.exports.default = $944c2ba5b5fba3a7$var$ClockIcon;

});

parcelRegister("czNKk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6f2df9b6d4b219d15d7e01ad6e3eb71a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $927f5782c5ac6ee5$var$_react = $927f5782c5ac6ee5$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $927f5782c5ac6ee5$var$_UNSAFE_baseNew = $927f5782c5ac6ee5$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $927f5782c5ac6ee5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Heart".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: emoji symbols in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $927f5782c5ac6ee5$var$HeartIcon = (props)=>/*#__PURE__*/ $927f5782c5ac6ee5$var$_react.default.createElement($927f5782c5ac6ee5$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 14.5a.6.6 0 0 1-.245-.061 1.5 1.5 0 0 1-.244-.123q-1.917-1.225-3.324-2.567-1.408-1.348-2.176-2.764-.76-1.422-.761-2.873 0-.905.286-1.654.291-.756.808-1.307A3.6 3.6 0 0 1 5.036 2q1 0 1.754.51.754.511 1.21 1.349A3.76 3.76 0 0 1 9.217 2.51Q9.97 2 10.964 2q.801 0 1.488.3.694.3 1.204.85.516.552.802 1.308.292.749.292 1.654 0 1.45-.768 2.873-.761 1.416-2.169 2.765-1.4 1.342-3.317 2.566a1.4 1.4 0 0 1-.251.123A.6.6 0 0 1 8 14.5Z"/>`
    }, props));
$927f5782c5ac6ee5$var$HeartIcon.displayName = 'HeartIcon';
var $927f5782c5ac6ee5$var$_default = module.exports.default = $927f5782c5ac6ee5$var$HeartIcon;

});

parcelRegister("4YUxz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8547c3f91abc335ca9c5bbfd88dd7340>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a089fca738cfe99$var$_react = $3a089fca738cfe99$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $3a089fca738cfe99$var$_UNSAFE_baseNew = $3a089fca738cfe99$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $3a089fca738cfe99$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Error".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a089fca738cfe99$var$ErrorIcon = (props)=>/*#__PURE__*/ $3a089fca738cfe99$var$_react.default.createElement($3a089fca738cfe99$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.604a2 2 0 0 1 2.828 0l5.982 5.982a2 2 0 0 1 0 2.828l-5.982 5.983a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM7.25 9V3.75h1.5V9zM8 12.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$3a089fca738cfe99$var$ErrorIcon.displayName = 'ErrorIcon';
var $3a089fca738cfe99$var$_default = module.exports.default = $3a089fca738cfe99$var$ErrorIcon;

});

parcelRegister("ie0cB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ebc22958da752d07e6dcf81116f518ec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d449b0f30f542f2d$var$_react = $d449b0f30f542f2d$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $d449b0f30f542f2d$var$_UNSAFE_baseNew = $d449b0f30f542f2d$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $d449b0f30f542f2d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Upload".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for upload in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d449b0f30f542f2d$var$UploadIcon = (props)=>/*#__PURE__*/ $d449b0f30f542f2d$var$_react.default.createElement($d449b0f30f542f2d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 11V2.25m-4 3.5 4-4 4 4"/>`
    }, props));
$d449b0f30f542f2d$var$UploadIcon.displayName = 'UploadIcon';
var $d449b0f30f542f2d$var$_default = module.exports.default = $d449b0f30f542f2d$var$UploadIcon;

});

parcelRegister("86XB8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2e33235fde7b24564b92256907cba586>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e7d1d2803548c47$var$_react = $5e7d1d2803548c47$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $5e7d1d2803548c47$var$_UNSAFE_baseNew = $5e7d1d2803548c47$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $5e7d1d2803548c47$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Filter".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5e7d1d2803548c47$var$FilterIcon = (props)=>/*#__PURE__*/ $5e7d1d2803548c47$var$_react.default.createElement($5e7d1d2803548c47$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M3 8h10M1 2.75h14M5 13.25h6"/>`
    }, props));
$5e7d1d2803548c47$var$FilterIcon.displayName = 'FilterIcon';
var $5e7d1d2803548c47$var$_default = module.exports.default = $5e7d1d2803548c47$var$FilterIcon;

});

parcelRegister("kmK71", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00d261b1bfdc09ff1b2f03c198e27896>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ed39a1aa5907c07c$var$_react = $ed39a1aa5907c07c$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $ed39a1aa5907c07c$var$_UNSAFE_baseNew = $ed39a1aa5907c07c$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $ed39a1aa5907c07c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Image".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: images, image upload.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ed39a1aa5907c07c$var$ImageIcon = (props)=>/*#__PURE__*/ $ed39a1aa5907c07c$var$_react.default.createElement($ed39a1aa5907c07c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.75 5.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path fill="currentcolor" fill-rule="evenodd" d="M5.75 6.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 14.25h9c.69 0 1.25-.56 1.25-1.25v-2M4 14.25H3c-.69 0-1.25-.56-1.25-1.25V3c0-.69.56-1.25 1.25-1.25h10c.69 0 1.25.56 1.25 1.25v8M4 14.25 10 7l4.25 4m-7.5-5.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"/>`
    }, props));
$ed39a1aa5907c07c$var$ImageIcon.displayName = 'ImageIcon';
var $ed39a1aa5907c07c$var$_default = module.exports.default = $ed39a1aa5907c07c$var$ImageIcon;

});

parcelRegister("bgEmk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::af316a11070150755855d308e4656f28>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83407ed11bdd347f$var$_react = $83407ed11bdd347f$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $83407ed11bdd347f$var$_UNSAFE_baseNew = $83407ed11bdd347f$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $83407ed11bdd347f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83407ed11bdd347f$var$LinkIcon = (props)=>/*#__PURE__*/ $83407ed11bdd347f$var$_react.default.createElement($83407ed11bdd347f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
    }, props));
$83407ed11bdd347f$var$LinkIcon.displayName = 'LinkIcon';
var $83407ed11bdd347f$var$_default = module.exports.default = $83407ed11bdd347f$var$LinkIcon;

});

parcelRegister("4cYNL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce7319a8e7b6756c4415855e934f6695>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $310772594f388aaa$var$_react = $310772594f388aaa$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $310772594f388aaa$var$_UNSAFE_baseNew = $310772594f388aaa$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $310772594f388aaa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ZoomIn".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for zooming in of an object or view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $310772594f388aaa$var$ZoomInIcon = (props)=>/*#__PURE__*/ $310772594f388aaa$var$_react.default.createElement($310772594f388aaa$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m14.5 14.5-3.788-3.788m0 0a5.25 5.25 0 1 0-7.425-7.425 5.25 5.25 0 0 0 7.425 7.425ZM4 7h3m3 0H7m0 0V4m0 3v3"/>`
    }, props));
$310772594f388aaa$var$ZoomInIcon.displayName = 'ZoomInIcon';
var $310772594f388aaa$var$_default = module.exports.default = $310772594f388aaa$var$ZoomInIcon;

});

parcelRegister("zmEJd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f96a81b9e560eaf29acabc60a3927a4c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $06a4d7fd7781c8d0$var$_react = $06a4d7fd7781c8d0$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $06a4d7fd7781c8d0$var$_UNSAFE_baseNew = $06a4d7fd7781c8d0$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $06a4d7fd7781c8d0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ZoomOut".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for zooming out of an object or view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $06a4d7fd7781c8d0$var$ZoomOutIcon = (props)=>/*#__PURE__*/ $06a4d7fd7781c8d0$var$_react.default.createElement($06a4d7fd7781c8d0$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m14.5 14.5-3.788-3.788m0 0a5.25 5.25 0 1 0-7.425-7.425 5.25 5.25 0 0 0 7.425 7.425ZM4 7h6"/>`
    }, props));
$06a4d7fd7781c8d0$var$ZoomOutIcon.displayName = 'ZoomOutIcon';
var $06a4d7fd7781c8d0$var$_default = module.exports.default = $06a4d7fd7781c8d0$var$ZoomOutIcon;

});

parcelRegister("3sJq9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9176a30c0755d77947ceea47f5dcd51a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28573839a119ea3b$var$_react = $28573839a119ea3b$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $28573839a119ea3b$var$_UNSAFE_baseNew = $28573839a119ea3b$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $28573839a119ea3b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Menu".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for accessing the menu in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $28573839a119ea3b$var$MenuIcon = (props)=>/*#__PURE__*/ $28573839a119ea3b$var$_react.default.createElement($28573839a119ea3b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1 13.25h14M1 8h14M1 2.75h14"/>`
    }, props));
$28573839a119ea3b$var$MenuIcon.displayName = 'MenuIcon';
var $28573839a119ea3b$var$_default = module.exports.default = $28573839a119ea3b$var$MenuIcon;

});

parcelRegister("iQYaZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed4cbb05f695c79bf1a6c2a07fef2f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db9bc30d273e3ad9$var$_react = $db9bc30d273e3ad9$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $db9bc30d273e3ad9$var$_UNSAFE_baseNew = $db9bc30d273e3ad9$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $db9bc30d273e3ad9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ShowMoreVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus, traditionally on mobile.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db9bc30d273e3ad9$var$ShowMoreVerticalIcon = (props)=>/*#__PURE__*/ $db9bc30d273e3ad9$var$_react.default.createElement($db9bc30d273e3ad9$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 1.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0 6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0 6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path stroke="currentcolor" stroke-width="1.5" d="M8.75 1.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm0 6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm0 6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"/>`
    }, props));
$db9bc30d273e3ad9$var$ShowMoreVerticalIcon.displayName = 'ShowMoreVerticalIcon';
var $db9bc30d273e3ad9$var$_default = module.exports.default = $db9bc30d273e3ad9$var$ShowMoreVerticalIcon;

});

parcelRegister("acHUo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b38d718ca9f4aa1019c5485273ebd51>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76dd15b85043362c$var$_react = $76dd15b85043362c$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $76dd15b85043362c$var$_UNSAFE_baseNew = $76dd15b85043362c$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $76dd15b85043362c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AlignLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text left, align content left, summary.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76dd15b85043362c$var$AlignLeftIcon = (props)=>/*#__PURE__*/ $76dd15b85043362c$var$_react.default.createElement($76dd15b85043362c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1 2.75h14M1 13.25h7M1 8h14"/>`
    }, props));
$76dd15b85043362c$var$AlignLeftIcon.displayName = 'AlignLeftIcon';
var $76dd15b85043362c$var$_default = module.exports.default = $76dd15b85043362c$var$AlignLeftIcon;

});

parcelRegister("lEjQC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::10497e41582acb6b3539681c38bd8368>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc2cbac28e9f2a19$var$_react = $fc2cbac28e9f2a19$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $fc2cbac28e9f2a19$var$_UNSAFE_baseNew = $fc2cbac28e9f2a19$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $fc2cbac28e9f2a19$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc2cbac28e9f2a19$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $fc2cbac28e9f2a19$var$_react.default.createElement($fc2cbac28e9f2a19$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6C6.25 5 7 4.25 8 4.25S9.75 5 9.75 6C9.75 7.5 8 7.5 8 8.75v.75M15.25 8A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Z"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$fc2cbac28e9f2a19$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $fc2cbac28e9f2a19$var$_default = module.exports.default = $fc2cbac28e9f2a19$var$QuestionCircleIcon;

});

parcelRegister("1qAa4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53a1e2fd011260ddfe6bcff1f1f84f50>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $10a4450ae982de07$var$_react = $10a4450ae982de07$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $10a4450ae982de07$var$_UNSAFE_baseNew = $10a4450ae982de07$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $10a4450ae982de07$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding a object or panel.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $10a4450ae982de07$var$RefreshIcon = (props)=>/*#__PURE__*/ $10a4450ae982de07$var$_react.default.createElement($10a4450ae982de07$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6V1.75H2m5.5 12.48c-3.218-.254-5.75-2.447-5.75-5.73 0-3.368 2.42-4.921 4-6.29m4 7.77v4.25H14M8.5 1.75c3.218.255 5.75 2.447 5.75 5.73 0 3.352-2.397 4.906-3.977 6.27"/>`
    }, props));
$10a4450ae982de07$var$RefreshIcon.displayName = 'RefreshIcon';
var $10a4450ae982de07$var$_default = module.exports.default = $10a4450ae982de07$var$RefreshIcon;

});

parcelRegister("e3tIz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aaf30f230bb1e005401a7fdb410093c0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a3b865d95a4ae262$var$_react = $a3b865d95a4ae262$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $a3b865d95a4ae262$var$_UNSAFE_baseNew = $a3b865d95a4ae262$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $a3b865d95a4ae262$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a3b865d95a4ae262$var$SearchIcon = (props)=>/*#__PURE__*/ $a3b865d95a4ae262$var$_react.default.createElement($a3b865d95a4ae262$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m14.5 14.5-3.788-3.788m0 0a5.25 5.25 0 1 0-7.425-7.425 5.25 5.25 0 0 0 7.425 7.425Z"/>`
    }, props));
$a3b865d95a4ae262$var$SearchIcon.displayName = 'SearchIcon';
var $a3b865d95a4ae262$var$_default = module.exports.default = $a3b865d95a4ae262$var$SearchIcon;

});

parcelRegister("gmX7n", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c415ea6f37a3ed0eb78bc36e015407f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $beac8f0680f54250$var$_react = $beac8f0680f54250$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $beac8f0680f54250$var$_UNSAFE_baseNew = $beac8f0680f54250$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $beac8f0680f54250$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $beac8f0680f54250$var$SettingsIcon = (props)=>/*#__PURE__*/ $beac8f0680f54250$var$_react.default.createElement($beac8f0680f54250$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75.75 5.687 3.302a.625.625 0 0 1-.667.378l-2.674-.388-1.25 2.166L2.72 7.625a.625.625 0 0 1 0 .75l-1.624 2.168 1.25 2.165 2.674-.388a.625.625 0 0 1 .667.378L6.75 15.25h2.5l1.063-2.552a.625.625 0 0 1 .667-.378l2.674.388 1.25-2.165-1.623-2.168a.625.625 0 0 1 0-.75l1.623-2.167-1.25-2.166-2.674.388a.625.625 0 0 1-.667-.378L9.25.75z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.25 8a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"/>`
    }, props));
$beac8f0680f54250$var$SettingsIcon.displayName = 'SettingsIcon';
var $beac8f0680f54250$var$_default = module.exports.default = $beac8f0680f54250$var$SettingsIcon;

});

parcelRegister("ecMhW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::530cf6124b77e826fb9d0e1e695d5d78>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a577a4bc55f01779$var$_react = $a577a4bc55f01779$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $a577a4bc55f01779$var$_UNSAFE_baseNew = $a577a4bc55f01779$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $a577a4bc55f01779$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a577a4bc55f01779$var$ShareIcon = (props)=>/*#__PURE__*/ $a577a4bc55f01779$var$_react.default.createElement($a577a4bc55f01779$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.434 11.717a1.75 1.75 0 1 0 3.131 1.566 1.75 1.75 0 0 0-3.13-1.566Zm0 0L5.316 8.783m0 0a1.74 1.74 0 0 0 0-1.566m0 1.566a1.75 1.75 0 1 1 0-1.566m0 0 5.118-2.934m0 0a1.75 1.75 0 1 0 3.13-1.566 1.75 1.75 0 0 0-3.13 1.566Z"/>`
    }, props));
$a577a4bc55f01779$var$ShareIcon.displayName = 'ShareIcon';
var $a577a4bc55f01779$var$_default = module.exports.default = $a577a4bc55f01779$var$ShareIcon;

});

parcelRegister("8heaH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63d7759306dd75de9f8738c35cafb7b3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $606ae76cd3e8422e$var$_react = $606ae76cd3e8422e$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $606ae76cd3e8422e$var$_UNSAFE_baseNew = $606ae76cd3e8422e$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $606ae76cd3e8422e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "StarUnstarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starring or favoriting objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $606ae76cd3e8422e$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $606ae76cd3e8422e$var$_react.default.createElement($606ae76cd3e8422e$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8 11.25.424-.618L8 10.34l-.424.29zm-4.375 3-.724-.194a.75.75 0 0 0 1.148.813zM5 9.125l.724.194.125-.463-.369-.307zM1.25 6l-.058-.748A.75.75 0 0 0 .77 6.576zm4.875-.375.058.748.472-.037.17-.442zM8 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.875 4.875-.7.27.17.441.472.037zM14.75 6l.48.576a.75.75 0 0 0-.423-1.324zM11 9.125l-.48-.576-.369.307.125.463zm1.375 5.125-.424.619a.75.75 0 0 0 1.148-.813zm-4.8-3.618-4.374 3 .848 1.237 4.375-3zM4.35 14.444 5.724 9.32l-1.448-.388L2.9 14.056zM5.48 8.55 1.73 5.424.77 6.576l3.75 3.125zM1.308 6.748l4.875-.375-.116-1.496-4.875.375zm5.517-.854L8.7 1.02 7.3.481 5.425 5.356zM7.3 1.02l1.875 4.875 1.4-.538L8.7.48zm2.517 5.354 4.876.375.114-1.496-4.874-.375zm4.453-.95L10.52 8.55l.96 1.152 3.75-3.125zM10.276 9.32l1.375 5.125 1.448-.388-1.375-5.125zm2.523 4.313-4.375-3-.848 1.237 4.375 3z"/>`
    }, props));
$606ae76cd3e8422e$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
var $606ae76cd3e8422e$var$_default = module.exports.default = $606ae76cd3e8422e$var$StarUnstarredIcon;

});

parcelRegister("9ujTo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84516badc93a96e757d14d99cc61886d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e8658a21861dc13$var$_react = $6e8658a21861dc13$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $6e8658a21861dc13$var$_UNSAFE_baseNew = $6e8658a21861dc13$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $6e8658a21861dc13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6e8658a21861dc13$var$StarStarredIcon = (props)=>/*#__PURE__*/ $6e8658a21861dc13$var$_react.default.createElement($6e8658a21861dc13$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8 11.25-4.375 3L5 9.125 1.25 6l4.875-.375L8 .75l1.875 4.875L14.75 6 11 9.125l1.375 5.125z"/><path fill="currentcolor" d="m8 11.25.424-.618L8 10.34l-.424.29zm-4.375 3-.724-.194a.75.75 0 0 0 1.148.813zM5 9.125l.724.194.125-.463-.369-.307zM1.25 6l-.058-.748A.75.75 0 0 0 .77 6.576zm4.875-.375.058.748.472-.037.17-.442zM8 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.875 4.875-.7.27.17.441.472.037zM14.75 6l.48.576a.75.75 0 0 0-.423-1.324zM11 9.125l-.48-.576-.369.307.125.463zm1.375 5.125-.424.618a.75.75 0 0 0 1.148-.812zm-4.8-3.618-4.374 3 .848 1.236 4.375-3zM4.35 14.444 5.724 9.32l-1.448-.388L2.9 14.056zM5.48 8.55 1.73 5.424.77 6.576l3.75 3.125zM1.308 6.748l4.875-.375-.116-1.496-4.875.375zm5.517-.854L8.7 1.02 7.3.481 5.425 5.356zM7.3 1.02l1.875 4.875 1.4-.538L8.7.48zm2.517 5.354 4.876.375.114-1.496-4.874-.375zm4.453-.95L10.52 8.55l.96 1.152 3.75-3.125zM10.276 9.32l1.375 5.125 1.448-.388-1.375-5.125zm2.523 4.313-4.375-3-.848 1.236 4.375 3z"/>`
    }, props));
$6e8658a21861dc13$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $6e8658a21861dc13$var$_default = module.exports.default = $6e8658a21861dc13$var$StarStarredIcon;

});

parcelRegister("72WPR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e9ea8e93d14ecb2cc0f36d0ba6200033>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52165bcd947d3285$var$_react = $52165bcd947d3285$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $52165bcd947d3285$var$_UNSAFE_baseNew = $52165bcd947d3285$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $52165bcd947d3285$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $52165bcd947d3285$var$WarningIcon = (props)=>/*#__PURE__*/ $52165bcd947d3285$var$_react.default.createElement($52165bcd947d3285$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.757-1.395 2.76-1.395 3.516 0l5.9 10.878C16.381 13.38 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$52165bcd947d3285$var$WarningIcon.displayName = 'WarningIcon';
var $52165bcd947d3285$var$_default = module.exports.default = $52165bcd947d3285$var$WarningIcon;

});

parcelRegister("k6VkH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("jOPGt")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("jOPGt")).Icon);

var $jOPGt = parcelRequire("jOPGt");

});
parcelRegister("jOPGt", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $e6dac7366be8d5a7$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $e6dac7366be8d5a7$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jVtIB = parcelRequire("jVtIB");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $e6dac7366be8d5a7$var$svgStyles = null;
var $e6dac7366be8d5a7$var$iconStyles = null;
var $e6dac7366be8d5a7$var$smallIconStyles = null;
var $e6dac7366be8d5a7$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $e6dac7366be8d5a7$var$baseHcmStyles = null;
var $e6dac7366be8d5a7$var$scaleSize = null;
var $e6dac7366be8d5a7$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $e6dac7366be8d5a7$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $e6dac7366be8d5a7$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $e6dac7366be8d5a7$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $e6dac7366be8d5a7$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $jVtIB.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $jVtIB.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $e6dac7366be8d5a7$var$coreSizeSmall[spacing] : $e6dac7366be8d5a7$var$coreSizeMedium[spacing]
        ])
    }));
});
var $e6dac7366be8d5a7$export$2e2bcd8739ae039 = $e6dac7366be8d5a7$export$f04a61298a47a40f;

});
parcelRegister("jVtIB", function(module, exports) {
$parcel$export(module.exports, "default", () => $e81a64a416e0ffb4$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $e81a64a416e0ffb4$var$ATOMIC_GROUP_LENGTH = 5;
function $e81a64a416e0ffb4$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $e81a64a416e0ffb4$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("acaID", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $76c356eb56776581$export$4ef52930e33717cd);
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", () => $76c356eb56776581$export$cb374d25ded7f6ab);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $76c356eb56776581$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $76c356eb56776581$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $76c356eb56776581$export$352e418ed5b6193a);
var $76c356eb56776581$export$4ef52930e33717cd = 'data-theme';
var $76c356eb56776581$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $76c356eb56776581$export$a00eac3f8684bcd0 = 'data-color-mode';
var $76c356eb56776581$export$2112803007239c61 = 'data-contrast-mode';
var $76c356eb56776581$export$352e418ed5b6193a = 'data-custom-theme';
var $76c356eb56776581$export$6f0c6fb8c80fcc92 = 'ds';
var $76c356eb56776581$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $76c356eb56776581$export$dddac1532e822863 = "--".concat($76c356eb56776581$export$6f0c6fb8c80fcc92, "-token-not-found");
var $76c356eb56776581$export$9d7b58831ae93caa = "--".concat($76c356eb56776581$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("8Cx0K", function(module, exports) {
$parcel$export(module.exports, "themeStateDefaults", () => $646b7aa87f879ddb$export$9aedcfa7336a207);

var $aptQa = parcelRequire("aptQa");
/**
 * Can't evaluate typography feature flags at the module level,
 * it will always resolve to false when server side rendered or when flags are loaded async.
 */ function $646b7aa87f879ddb$var$getShapeDefault() {
    if ((0, $aptQa.fg)('platform-dst-shape-theme-default')) return 'shape';
    return undefined;
}
function $646b7aa87f879ddb$var$getMotionDefault() {
    if ((0, $aptQa.fg)('platform-dst-motion-theme-default')) return 'motion';
    return undefined;
}
var $646b7aa87f879ddb$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: $646b7aa87f879ddb$var$getShapeDefault,
    spacing: 'spacing',
    typography: 'typography',
    motion: $646b7aa87f879ddb$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};

});
parcelRegister("aptQa", function(module, exports) {
$parcel$export(module.exports, "fg", () => $794362e40c7e58d8$export$b40ec24ac8275656);

var $gnCnf = parcelRequire("gnCnf");
function $794362e40c7e58d8$export$ba05d765b8392e5e(flagResolver) {
    (0, $gnCnf.setBooleanResolver)(flagResolver);
}
function $794362e40c7e58d8$export$470e5c2be1411c89(name) {
    return (0, $gnCnf.resolveBooleanFlag)(name);
}
function $794362e40c7e58d8$export$b40ec24ac8275656(name) {
    return (0, $gnCnf.resolveBooleanFlag)(name);
}

});
parcelRegister("gnCnf", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $becc8f9c9b48731b$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $becc8f9c9b48731b$export$6333b6aff9fc6275);

var $9dOvm = parcelRequire("9dOvm");

var $6IKyZ = parcelRequire("6IKyZ");

var $3ZMUU = parcelRequire("3ZMUU");
var $becc8f9c9b48731b$var$pkgName = '@atlaskit/platform-feature-flags';
var $becc8f9c9b48731b$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $becc8f9c9b48731b$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $becc8f9c9b48731b$var$ENV_ENABLE_PLATFORM_FF = $becc8f9c9b48731b$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $becc8f9c9b48731b$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $becc8f9c9b48731b$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $becc8f9c9b48731b$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $becc8f9c9b48731b$var$ENV_ENABLE_PLATFORM_FF || $becc8f9c9b48731b$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $becc8f9c9b48731b$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $becc8f9c9b48731b$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$becc8f9c9b48731b$var$globalVar[$becc8f9c9b48731b$export$7e41b1b2bdee3f98] = $becc8f9c9b48731b$var$globalVar[$becc8f9c9b48731b$export$7e41b1b2bdee3f98] || $becc8f9c9b48731b$var$DEFAULT_PFF_GLOBAL;
function $becc8f9c9b48731b$export$f2b591175b3e424c(resolver) {
    $becc8f9c9b48731b$var$globalVar[$becc8f9c9b48731b$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $becc8f9c9b48731b$export$6333b6aff9fc6275(flagKey) {
    if ($becc8f9c9b48731b$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $6IKyZ.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $becc8f9c9b48731b$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $becc8f9c9b48731b$var$globalVar[$becc8f9c9b48731b$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $becc8f9c9b48731b$var$globalVar[$becc8f9c9b48731b$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $9dOvm.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $becc8f9c9b48731b$var$globalVar[$becc8f9c9b48731b$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("9dOvm", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b6c8129f5a844c6$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $1Odth = parcelRequire("1Odth");

var $89UMm = parcelRequire("89UMm");



var $6b6c8129f5a844c6$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $6b6c8129f5a844c6$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$6b6c8129f5a844c6$var$_FeatureGates = $6b6c8129f5a844c6$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "client", new (0, $1Odth.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$6b6c8129f5a844c6$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $6b6c8129f5a844c6$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $6b6c8129f5a844c6$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$6b6c8129f5a844c6$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $6b6c8129f5a844c6$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $6b6c8129f5a844c6$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "initializeCalled", $6b6c8129f5a844c6$var$_FeatureGates.client.initializeCalled.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "initializeCompleted", $6b6c8129f5a844c6$var$_FeatureGates.client.initializeCompleted.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "waitUntilInitializeCompleted", $6b6c8129f5a844c6$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "initialize", $6b6c8129f5a844c6$var$_FeatureGates.client.initialize.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "initializeWithProvider", $6b6c8129f5a844c6$var$_FeatureGates.client.initializeWithProvider.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "initializeFromValues", $6b6c8129f5a844c6$var$_FeatureGates.client.initializeFromValues.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "manuallyLogGateExposure", $6b6c8129f5a844c6$var$_FeatureGates.client.manuallyLogGateExposure.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "getExperiment", $6b6c8129f5a844c6$var$_FeatureGates.client.getExperiment.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "manuallyLogExperimentExposure", $6b6c8129f5a844c6$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "manuallyLogLayerExposure", $6b6c8129f5a844c6$var$_FeatureGates.client.manuallyLogLayerExposure.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "shutdownStatsig", $6b6c8129f5a844c6$var$_FeatureGates.client.shutdownStatsig.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "overrideGate", $6b6c8129f5a844c6$var$_FeatureGates.client.overrideGate.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "clearGateOverride", $6b6c8129f5a844c6$var$_FeatureGates.client.clearGateOverride.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "overrideConfig", $6b6c8129f5a844c6$var$_FeatureGates.client.overrideConfig.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "clearConfigOverride", $6b6c8129f5a844c6$var$_FeatureGates.client.clearConfigOverride.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "setOverrides", $6b6c8129f5a844c6$var$_FeatureGates.client.setOverrides.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "getOverrides", $6b6c8129f5a844c6$var$_FeatureGates.client.getOverrides.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "clearAllOverrides", $6b6c8129f5a844c6$var$_FeatureGates.client.clearAllOverrides.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "isCurrentUser", $6b6c8129f5a844c6$var$_FeatureGates.client.isCurrentUser.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "onGateUpdated", $6b6c8129f5a844c6$var$_FeatureGates.client.onGateUpdated.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "onExperimentValueUpdated", $6b6c8129f5a844c6$var$_FeatureGates.client.onExperimentValueUpdated.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "onAnyUpdated", $6b6c8129f5a844c6$var$_FeatureGates.client.onAnyUpdated.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "updateUser", $6b6c8129f5a844c6$var$_FeatureGates.client.updateUser.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "updateUserWithProvider", $6b6c8129f5a844c6$var$_FeatureGates.client.updateUserWithProvider.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "updateUserWithValues", $6b6c8129f5a844c6$var$_FeatureGates.client.updateUserWithValues.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "getPackageVersion", $6b6c8129f5a844c6$var$_FeatureGates.client.getPackageVersion.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "getTargetApp", $6b6c8129f5a844c6$var$_FeatureGates.client.getTargetApp.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "getLayer", $6b6c8129f5a844c6$var$_FeatureGates.client.getLayer.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "getLayerValue", $6b6c8129f5a844c6$var$_FeatureGates.client.getLayerValue.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
var $6b6c8129f5a844c6$var$boundFGJS = $6b6c8129f5a844c6$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $6b6c8129f5a844c6$var$FeatureGates;
    else {
        var $6b6c8129f5a844c6$var$_boundFGJS, $6b6c8129f5a844c6$var$_boundFGJS$getPackage;
        $6b6c8129f5a844c6$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $6b6c8129f5a844c6$var$boundVersion = (($6b6c8129f5a844c6$var$_boundFGJS = $6b6c8129f5a844c6$var$boundFGJS) === null || $6b6c8129f5a844c6$var$_boundFGJS === void 0 || ($6b6c8129f5a844c6$var$_boundFGJS$getPackage = $6b6c8129f5a844c6$var$_boundFGJS.getPackageVersion) === null || $6b6c8129f5a844c6$var$_boundFGJS$getPackage === void 0 ? void 0 : $6b6c8129f5a844c6$var$_boundFGJS$getPackage.call($6b6c8129f5a844c6$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($6b6c8129f5a844c6$var$boundVersion !== (0, $89UMm.CLIENT_VERSION)) {
            var $6b6c8129f5a844c6$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($6b6c8129f5a844c6$var$boundVersion, " when module version ").concat((0, $89UMm.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($6b6c8129f5a844c6$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $6b6c8129f5a844c6$export$2e2bcd8739ae039 = $6b6c8129f5a844c6$var$boundFGJS;

});
parcelRegister("1Odth", function(module, exports) {
$parcel$export(module.exports, "Client", () => $1514e90f383af0c2$export$1f2bb630327ac4b6);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $5ZlPZ = parcelRequire("5ZlPZ");

var $guzUG = parcelRequire("guzUG");

var $gnEZW = parcelRequire("gnEZW");

var $knFmu = parcelRequire("knFmu");

var $kgfMl = parcelRequire("kgfMl");

var $lSU5S = parcelRequire("lSU5S");

var $aZyWe = parcelRequire("aZyWe");

var $9A4g1 = parcelRequire("9A4g1");

var $g5oCJ = parcelRequire("g5oCJ");

var $3sxkV = parcelRequire("3sxkV");

var $89UMm = parcelRequire("89UMm");
var $1514e90f383af0c2$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $1514e90f383af0c2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1514e90f383af0c2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1514e90f383af0c2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1514e90f383af0c2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1514e90f383af0c2$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $1514e90f383af0c2$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $1514e90f383af0c2$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $9A4g1.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscriptions", new (0, $guzUG.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "dataAdapter", new (0, $aZyWe.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $9A4g1.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $3sxkV.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 1;
                                    break;
                                }
                                if (!(0, $3sxkV.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $3sxkV.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 1;
                                    break;
                                }
                                if (!(0, $3sxkV.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $89UMm.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $1514e90f383af0c2$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $89UMm.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $g5oCJ.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $3sxkV.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 1;
                                    break;
                                }
                                if (!(0, $3sxkV.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 1:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $3sxkV.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $lSU5S.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 1;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 1:
                                _context5.next = 2;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 2:
                                _context5.next = 3;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 1:
                                if (!this.initCompleted) {
                                    _context7.next = 2;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 2:
                                _context7.next = 3;
                                return this.initPromise;
                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $gnEZW.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $gnEZW.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $kgfMl.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $3sxkV.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $3sxkV.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $1514e90f383af0c2$var$_objectSpread({}, clientOptions);
                                if (!clientOptions.localMode) {
                                    _context8.next = 2;
                                    break;
                                }
                                _context8.next = 1;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 1:
                                return _context8.abrupt("return");
                            case 2:
                                _context8.prev = 2;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $lSU5S.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $lSU5S.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 6;
                                break;
                            case 4:
                                _context8.prev = 4;
                                _t = _context8["catch"](2);
                                if (_t instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t === null || _t === void 0 ? void 0 : _t.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t;
                            case 6:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            2,
                            4
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $1514e90f383af0c2$var$_objectSpread($1514e90f383af0c2$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 2;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 2:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 6;
                                break;
                            case 4:
                                _context9.prev = 4;
                                _t2 = _context9["catch"](1);
                                if (_t2 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t2 === null || _t2 === void 0 ? void 0 : _t2.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t2;
                            case 6:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            4
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, _args0 = arguments, _t3;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $3sxkV.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $1514e90f383af0c2$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $1514e90f383af0c2$var$_objectSpread($1514e90f383af0c2$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $1514e90f383af0c2$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $g5oCJ.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(newClientOptions, $1514e90f383af0c2$var$_excluded);
                                frontendUser = (0, $3sxkV.toStatsigUser)(identifiers, customAttributes);
                                this.user = (0, $3sxkV.deepAssign)({}, initializeValues.user, frontendUser);
                                statsigOptions = $1514e90f383af0c2$var$_objectSpread($1514e90f383af0c2$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $5ZlPZ.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $5ZlPZ.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 1;
                                this.statsigClient = new (0, $5ZlPZ.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 2;
                                return this.statsigClient.initializeAsync();
                            case 2:
                                _context0.next = 5;
                                break;
                            case 3:
                                _context0.prev = 3;
                                _t3 = _context0["catch"](1);
                                if (_t3 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_t3 === null || _t3 === void 0 ? void 0 : _t3.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $5ZlPZ.StatsigClient)($1514e90f383af0c2$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 4;
                                return this.statsigClient.initializeAsync();
                            case 4:
                                this.initWithDefaults = true;
                                throw _t3;
                            case 5:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise, _t4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 1:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 2;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 2:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 3;
                                _context10.next = 4;
                                return this.initPromise;
                            case 4:
                                _context10.next = 6;
                                break;
                            case 5:
                                _context10.prev = 5;
                                _t4 = _context10["catch"](3);
                            case 6:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 1;
                                                    break;
                                                }
                                                _context1.next = 1;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 1:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 7:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            3,
                            5
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, frontendUser, _updateUserCompletion, _ref4, errMsg, success, errorMessage, _t5, _t6;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 2;
                                return initializeValuesPromise;
                            case 2:
                                initializeValues = _context11.sent;
                                frontendUser = (0, $3sxkV.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, $3sxkV.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
                                _context11.next = 4;
                                break;
                            case 3:
                                _context11.prev = 3;
                                _t5 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _t5 instanceof Error ? _t5.message : JSON.stringify(_t5);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _t5;
                            case 4:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 5;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 6;
                                    break;
                                }
                                _context11.next = 6;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 6:
                                _context11.next = 8;
                                break;
                            case 7:
                                _context11.prev = 7;
                                _t6 = _context11["catch"](5);
                                success = false;
                                errorMessage = String(_t6);
                            case 8:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 9;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 10;
                                break;
                            case 9:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 10:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            3
                        ],
                        [
                            5,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $89UMm.CLIENT_VERSION;
            }
        },
        {
            key: "getTargetApp",
            value: function getTargetApp() {
                var _this$initOptions2;
                return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $knFmu.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $knFmu.Layer).fromLayer((0, $5ZlPZ._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("5ZlPZ", function(module, exports) {
"use strict";
var $45c396bf0a10faa5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $45c396bf0a10faa5$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $45c396bf0a10faa5$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $2WXlk = parcelRequire("2WXlk");
module.exports.StatsigClient = $2WXlk.default;

$45c396bf0a10faa5$var$__exportStar((parcelRequire("grMmj")), module.exports);
const $45c396bf0a10faa5$var$__STATSIG__ = Object.assign((0, (parcelRequire("grMmj"))._getStatsigGlobal)(), {
    StatsigClient: $2WXlk.default
});
module.exports.default = $45c396bf0a10faa5$var$__STATSIG__;

});
parcelRegister("2WXlk", function(module, exports) {
"use strict";
var $225f07d89529943f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $grMmj = parcelRequire("grMmj");

var $6VKtm = parcelRequire("6VKtm");

var $8MPqR = parcelRequire("8MPqR");

var $5Iqpo = parcelRequire("5Iqpo");

var $frgpS = parcelRequire("frgpS");
class $225f07d89529943f$var$StatsigClient extends $grMmj.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $grMmj._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $225f07d89529943f$var$StatsigClient) return instance;
        $grMmj.Log.warn((0, $grMmj._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $225f07d89529943f$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $grMmj.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $8MPqR.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $frgpS.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($grMmj.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($grMmj.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($grMmj.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($grMmj.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($grMmj.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($grMmj.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $6VKtm.default(sdkKey, options !== null && options !== void 0 ? options : null);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $grMmj.getUUID)();
        this._contextHandle = new $grMmj.PrecomputedEvaluationsContextHandle(sdkKey, ()=>this._options, ()=>this._errorBoundary, ()=>this._store.getValues(), ()=>this._user, ()=>this._sdkInstanceID);
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $grMmj.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $225f07d89529943f$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $grMmj.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $grMmj.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $225f07d89529943f$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $225f07d89529943f$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $grMmj.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $grMmj.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $grMmj.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $grMmj.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($grMmj.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $grMmj.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $grMmj.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $grMmj.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        let user = (0, $grMmj._cloneObject)('StatsigUser', this._user);
        if (user == null) {
            $grMmj.Log.error('Failed to clone user');
            user = {};
        }
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: user,
            errorBoundary: this._errorBoundary,
            session: $grMmj.StatsigSession.get(this._sdkKey),
            stableID: $grMmj.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves a context handle that computes fields lazily on access.
     * This is more efficient than getContext() when you only need certain fields,
     *
     * @returns {PrecomputedEvaluationsContextHandle} A handle with lazy getters for context fields.
     */ getContextHandle() {
        return this._contextHandle;
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $225f07d89529943f$var$__awaiter(this, void 0, void 0, function*() {
            if (!$grMmj.Storage.isReady()) yield $grMmj.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $grMmj.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $grMmj.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a, _b, _c;
        const user = (0, $grMmj._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) {
            const readyPromise = (_c = (_b = this.storageProvider).isReadyResolver) === null || _c === void 0 ? void 0 : _c.call(_b);
            if (readyPromise) readyPromise.then(()=>$grMmj.StableID.setOverride(stableIdOverride, this._sdkKey), ()=>$grMmj.StableID.setOverride(stableIdOverride, this._sdkKey));
            else $grMmj.StableID.setOverride(stableIdOverride, this._sdkKey);
        }
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        this._checkUserHasIdForEvaluation(evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type, name, 'Gate');
        this._checkInitializationStatus(details.reason);
        const gate = (0, $grMmj._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $grMmj._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        this._checkUserHasIdForEvaluation(evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type, name, 'Dynamic config');
        this._checkInitializationStatus(details.reason);
        const config = (0, $grMmj._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $grMmj._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        this._checkUserHasIdForEvaluation(evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type, name, 'Experiment');
        this._checkInitializationStatus(details.reason);
        const experiment = (0, $grMmj._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $grMmj._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $grMmj._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $grMmj._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $grMmj._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $grMmj._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $5Iqpo._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $5Iqpo._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
    _checkUserHasIdForEvaluation(idType, name, type) {
        if (!idType) return;
        if (!(0, $grMmj._getUnitIDFromUser)(this._user, idType)) $grMmj.Log.warn(`The user does not have the required id_type "${idType}" for ${type} "${name}"`);
    }
    _checkInitializationStatus(reason) {
        if (reason === 'Uninitialized' || reason.startsWith('Loading')) $grMmj.Log.warn(`SDK initialization has not completed. Reason: ${reason}`);
    }
}
module.exports.default = $225f07d89529943f$var$StatsigClient;

});
parcelRegister("6VKtm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $grMmj = parcelRequire("grMmj");

var $dONAz = parcelRequire("dONAz");

var $68NcP = parcelRequire("68NcP");
class $50bc1d743ebf757b$var$EvaluationStore {
    constructor(_sdkKey, _options){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._valuesForExternalUse = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._valuesForExternalUse = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        // we do not give out the actual _values object to avoid mutating it
        return this._valuesForExternalUse;
    }
    setValues(result, user) {
        var _a, _b;
        if (!result) return false;
        const values = (0, $grMmj._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        const updatedLcut = (_a = values.time) !== null && _a !== void 0 ? _a : 0;
        if (updatedLcut < this._lcut) return true;
        this._valuesForExternalUse = (0, $grMmj._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        if (values.response_format === 'init-v2') this._values = new $68NcP.V2InitializeContainer(values);
        else this._values = new $dONAz.V1InitializeContainer(values);
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $grMmj.SDKFlags.setFlags(this._sdkKey, (_b = values.sdk_flags) !== null && _b !== void 0 ? _b : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        const res = this._values ? this._values.getGate(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfig(name) {
        const res = this._values ? this._values.getConfig(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfigList() {
        if (!this._values) return [];
        return this._values.getConfigList();
    }
    getLayer(name) {
        const res = this._values ? this._values.getLayer(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getParamStore(name) {
        const res = this._values ? this._values.getParamStore(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.getExposureMapping();
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(result) {
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b, _c;
        const stableID = $grMmj.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            let bootstrapUser = values['user'];
            let userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((_c = this._options) === null || _c === void 0 ? void 0 : _c.disableStableID) {
                userForComparison = Object.assign(Object.assign({}, userForComparison), {
                    customIDs: Object.assign(Object.assign({}, userForComparison.customIDs), {
                        stableID: undefined
                    })
                });
                bootstrapUser = Object.assign(Object.assign({}, bootstrapUser), {
                    customIDs: Object.assign(Object.assign({}, bootstrapUser.customIDs), {
                        stableID: undefined
                    })
                });
            }
            if ((0, $grMmj._getFullUserHash)(userForComparison) !== (0, $grMmj._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $50bc1d743ebf757b$var$EvaluationStore;

});
parcelRegister("dONAz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V1InitializeContainer = void 0;

var $grMmj = parcelRequire("grMmj");
class $a0f6692bf0a013b6$var$V1InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        return this._getResultFromLookup(this._values.feature_gates, name);
    }
    getConfig(name) {
        return this._getResultFromLookup(this._values.dynamic_configs, name);
    }
    getLayer(name) {
        return this._getResultFromLookup(this._values.layer_configs, name);
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $grMmj._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V1InitializeContainer = $a0f6692bf0a013b6$var$V1InitializeContainer;

});

parcelRegister("68NcP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V2InitializeContainer = void 0;

var $grMmj = parcelRequire("grMmj");
class $4789a8afc064e951$var$V2InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        var _a, _b, _c;
        const evalV2 = this._getResultFromLookup(this._values.feature_gates, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: evalV2.v === true,
            rule_id: (_a = evalV2.r) !== null && _a !== void 0 ? _a : 'default',
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : ''
        };
    }
    getConfig(name) {
        var _a, _b, _c, _d;
        const evalV2 = this._getResultFromLookup(this._values.dynamic_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : '',
            is_user_in_experiment: evalV2.ue === true ? true : false,
            passed: evalV2.p === true,
            group_name: (_d = evalV2.gn) !== null && _d !== void 0 ? _d : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID'
        };
    }
    getLayer(name) {
        var _a, _b, _c, _d, _e, _f;
        const evalV2 = this._getResultFromLookup(this._values.layer_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            is_user_in_experiment: evalV2.ue === true ? true : false,
            group_name: (_c = evalV2.gn) !== null && _c !== void 0 ? _c : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID',
            allocated_experiment_name: (_d = evalV2.ae) !== null && _d !== void 0 ? _d : '',
            explicit_parameters: (_e = evalV2.ep) !== null && _e !== void 0 ? _e : [],
            undelegated_secondary_exposures: (_f = evalV2.us) !== null && _f !== void 0 ? _f : [],
            parameter_rule_ids: evalV2.pr
        };
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $grMmj._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V2InitializeContainer = $4789a8afc064e951$var$V2InitializeContainer;

});


parcelRegister("8MPqR", function(module, exports) {
"use strict";
var $665ab3cf99e4dedf$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $grMmj = parcelRequire("grMmj");

var $d7YRp = parcelRequire("d7YRp");
class $665ab3cf99e4dedf$var$StatsigNetwork extends $grMmj.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $grMmj.UrlConfiguration($grMmj.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $665ab3cf99e4dedf$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $grMmj._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $665ab3cf99e4dedf$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $d7YRp._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $665ab3cf99e4dedf$var$StatsigNetwork;

});
parcelRegister("d7YRp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $grMmj = parcelRequire("grMmj");
const $98eb2371598e8e23$var$MAX_DELTAS_SORT_DEPTH = 2;
function $98eb2371598e8e23$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $grMmj._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $98eb2371598e8e23$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $98eb2371598e8e23$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $grMmj._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $98eb2371598e8e23$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $98eb2371598e8e23$var$_resolveDeltasResponse;
function $98eb2371598e8e23$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $98eb2371598e8e23$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $98eb2371598e8e23$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $98eb2371598e8e23$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $98eb2371598e8e23$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $98eb2371598e8e23$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("5Iqpo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $grMmj = parcelRequire("grMmj");
const $42958bfbd7113803$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $42958bfbd7113803$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $42958bfbd7113803$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $grMmj._isTypeMatch)(value, fallback);
}
function $42958bfbd7113803$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $42958bfbd7113803$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $42958bfbd7113803$var$_shouldLogExposure(options) ? undefined : $42958bfbd7113803$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $42958bfbd7113803$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $42958bfbd7113803$var$_shouldLogExposure(options) ? undefined : $42958bfbd7113803$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($42958bfbd7113803$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $42958bfbd7113803$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $42958bfbd7113803$var$_shouldLogExposure(options) ? undefined : $42958bfbd7113803$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($42958bfbd7113803$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $42958bfbd7113803$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $42958bfbd7113803$var$_shouldLogExposure(options) ? undefined : $42958bfbd7113803$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($42958bfbd7113803$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $42958bfbd7113803$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $grMmj._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $42958bfbd7113803$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $42958bfbd7113803$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $42958bfbd7113803$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $42958bfbd7113803$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $42958bfbd7113803$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $42958bfbd7113803$var$_makeParamStoreGetter;

});

parcelRegister("frgpS", function(module, exports) {
"use strict";
var $b3d61c9504191470$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $grMmj = parcelRequire("grMmj");

var $8MPqR = parcelRequire("8MPqR");
class $b3d61c9504191470$var$StatsigEvaluationsDataAdapter extends $grMmj.DataAdapterCore {
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $8MPqR.default) this._network = network;
        else this._network = new $8MPqR.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $grMmj._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $grMmj._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $grMmj.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $b3d61c9504191470$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $grMmj._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$grMmj.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $grMmj._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $b3d61c9504191470$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("guzUG", function(module, exports) {
$parcel$export(module.exports, "default", () => $c01b4e4fd6ad81bc$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $hLfKH = parcelRequire("hLfKH");
function $c01b4e4fd6ad81bc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c01b4e4fd6ad81bc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c01b4e4fd6ad81bc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c01b4e4fd6ad81bc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c01b4e4fd6ad81bc$export$a66cbd9b2289cd78 = '@all-features';
var $c01b4e4fd6ad81bc$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $c01b4e4fd6ad81bc$var$_objectSpread($c01b4e4fd6ad81bc$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $c01b4e4fd6ad81bc$var$_objectSpread($c01b4e4fd6ad81bc$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $c01b4e4fd6ad81bc$var$_objectSpread($c01b4e4fd6ad81bc$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $c01b4e4fd6ad81bc$var$_objectSpread($c01b4e4fd6ad81bc$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($c01b4e4fd6ad81bc$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($c01b4e4fd6ad81bc$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($c01b4e4fd6ad81bc$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $c01b4e4fd6ad81bc$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("gnEZW", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $bece98b50d9303e1$export$6dc24881a3d96325);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $3sxkV = parcelRequire("3sxkV");
var $bece98b50d9303e1$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $3sxkV.migrateEvaluationDetails)(experiment.details), (0, $3sxkV.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("3sxkV", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $284dd888d93e9bb1$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $284dd888d93e9bb1$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $284dd888d93e9bb1$export$3dad1db244472f32);
$parcel$export(module.exports, "deepAssign", () => $284dd888d93e9bb1$export$1148cb79ceecd5fa);
$parcel$export(module.exports, "migrateInitializationOptions", () => $284dd888d93e9bb1$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $284dd888d93e9bb1$export$18ad168d3dbac899);
$parcel$export(module.exports, "migrateSecondaryExposures", () => $284dd888d93e9bb1$export$55fd683752d01e67);

var $ekGgq = parcelRequire("ekGgq");

var $fC8ib = parcelRequire("fC8ib");

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $bMACw = parcelRequire("bMACw");

var $kgfMl = parcelRequire("kgfMl");

var $g5oCJ = parcelRequire("g5oCJ");
var $284dd888d93e9bb1$var$_excluded = [
    "stableId"
], $284dd888d93e9bb1$var$_excluded2 = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $284dd888d93e9bb1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $284dd888d93e9bb1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $284dd888d93e9bb1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $284dd888d93e9bb1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $284dd888d93e9bb1$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $284dd888d93e9bb1$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $bMACw.isFedRamp)() ? (0, $g5oCJ.PerimeterType).FEDRAMP_MODERATE : (0, $g5oCJ.PerimeterType).COMMERCIAL
    }, options);
};
var $284dd888d93e9bb1$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $284dd888d93e9bb1$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    var stableId = identifiers.stableId, otherIdentifiers = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(identifiers, $284dd888d93e9bb1$var$_excluded);
    var user = {
        customIDs: $284dd888d93e9bb1$var$_objectSpread($284dd888d93e9bb1$var$_objectSpread({}, otherIdentifiers), stableId !== undefined ? {
            stableID: stableId
        } : {}),
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
function $284dd888d93e9bb1$export$1148cb79ceecd5fa(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return $284dd888d93e9bb1$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sources)));
    for(var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], src = _Object$entries$_i[1];
        var dst = target[key];
        var srcIsObj = src && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(src) === 'object' && !Array.isArray(src);
        var dstIsObj = dst && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(dst) === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $284dd888d93e9bb1$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $284dd888d93e9bb1$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sources)));
}
var $284dd888d93e9bb1$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(options, $284dd888d93e9bb1$var$_excluded2);
    return $284dd888d93e9bb1$var$_objectSpread($284dd888d93e9bb1$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $284dd888d93e9bb1$var$evaluationReasonMappings = Object.entries((0, $kgfMl.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $284dd888d93e9bb1$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $284dd888d93e9bb1$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $kgfMl.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $284dd888d93e9bb1$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("bMACw", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $89409569cf3ed887$export$64d6499adf9b2e51);

var $34GCX = parcelRequire("34GCX");
function $89409569cf3ed887$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $34GCX.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("34GCX", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $23d2cfb88aec5702$export$ce553301d55c2fd8);
var $23d2cfb88aec5702$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $23d2cfb88aec5702$export$f005e2e9f707cb5f = 'commercial';
var $23d2cfb88aec5702$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $23d2cfb88aec5702$export$a739cd5aac835909 = 'stg';
var $23d2cfb88aec5702$export$42dd0cdd351a4a9 = 'prod';
var $23d2cfb88aec5702$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("kgfMl", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $ec018a9ac5ddfa0e$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $ec018a9ac5ddfa0e$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
}; // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("g5oCJ", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $bb6036bae4cfc158$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $bb6036bae4cfc158$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $bb6036bae4cfc158$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
var $bb6036bae4cfc158$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
var $bb6036bae4cfc158$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("knFmu", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $ed660a3563e5c443$export$936d0764594b6eb3);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $3sxkV = parcelRequire("3sxkV");
var $ed660a3563e5c443$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $3sxkV.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $3sxkV.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $3sxkV.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("lSU5S", function(module, exports) {
$parcel$export(module.exports, "default", () => $feea2733aaae4efb$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $g5oCJ = parcelRequire("g5oCJ");

var $89UMm = parcelRequire("89UMm");

var $3OdZR = parcelRequire("3OdZR");
function $feea2733aaae4efb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $feea2733aaae4efb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $feea2733aaae4efb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $feea2733aaae4efb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $feea2733aaae4efb$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $feea2733aaae4efb$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $feea2733aaae4efb$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $feea2733aaae4efb$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $feea2733aaae4efb$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $feea2733aaae4efb$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $feea2733aaae4efb$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $feea2733aaae4efb$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $feea2733aaae4efb$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $feea2733aaae4efb$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $feea2733aaae4efb$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(fetcherOptions) {
                    var targetApp, url, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 1;
                                _context.next = 2;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                                _context.prev = 3;
                                _t = _context["catch"](1);
                                if (!(_t instanceof Error)) {
                                    _context.next = 4;
                                    break;
                                }
                                throw _t;
                            case 4:
                                throw Error('Failed to retrieve client sdk key');
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 2;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                                _context2.prev = 3;
                                _t2 = _context2["catch"](1);
                                if (!(_t2 instanceof Error)) {
                                    _context2.next = 4;
                                    break;
                                }
                                throw _t2;
                            case 4:
                                throw Error('Failed to retrieve experiment values');
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 2;
                                    break;
                                }
                                _context3.next = 1;
                                return response.text();
                            case 1:
                                body = _context3.sent;
                                throw new (0, $3OdZR.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 2:
                                if (!(response.status === 204)) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new (0, $3OdZR.ResponseError)('Unexpected 204 response');
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return response.text();
                            case 1:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $feea2733aaae4efb$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $g5oCJ.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $g5oCJ.FeatureGateEnvironment).Production:
                        return $feea2733aaae4efb$export$18c93900db9358a4;
                    case (0, $g5oCJ.FeatureGateEnvironment).Staging:
                        return $feea2733aaae4efb$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $g5oCJ.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $g5oCJ.FeatureGateEnvironment).Development:
                        return $feea2733aaae4efb$export$f058dbf75c3bc647;
                    case (0, $g5oCJ.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $feea2733aaae4efb$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $feea2733aaae4efb$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $feea2733aaae4efb$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 1;
                                return fetch("".concat(baseUrl).concat(path), $feea2733aaae4efb$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $89UMm.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 1:
                                response = _context5.sent;
                                _context5.next = 2;
                                return this.handleResponseError(response);
                            case 2:
                                _context5.next = 3;
                                return this.extractResponseBody(response);
                            case 3:
                                return _context5.abrupt("return", _context5.sent);
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $feea2733aaae4efb$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($feea2733aaae4efb$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($feea2733aaae4efb$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("89UMm", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $5f0b3520a40f2cb0$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $5f0b3520a40f2cb0$export$a59f8d67326bd1cb = "5.8.0";

});

parcelRegister("3OdZR", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $2c60e611fa966a23$export$286baf652d0b1206);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $2c60e611fa966a23$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $2c60e611fa966a23$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $2c60e611fa966a23$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2c60e611fa966a23$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $2c60e611fa966a23$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ResponseError);
        return $2c60e611fa966a23$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});


parcelRegister("aZyWe", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $800ab3e485f9d56f$export$55fffef3474104af);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $5ZlPZ = parcelRequire("5ZlPZ");
function $800ab3e485f9d56f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $800ab3e485f9d56f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $800ab3e485f9d56f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $800ab3e485f9d56f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $800ab3e485f9d56f$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $800ab3e485f9d56f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $800ab3e485f9d56f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($800ab3e485f9d56f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $800ab3e485f9d56f$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $800ab3e485f9d56f$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoFetchDataAdapter);
        _this = $800ab3e485f9d56f$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $5ZlPZ.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $800ab3e485f9d56f$var$_objectSpread($800ab3e485f9d56f$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $5ZlPZ._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $800ab3e485f9d56f$var$_objectSpread($800ab3e485f9d56f$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $5ZlPZ._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $5ZlPZ._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $5ZlPZ.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $800ab3e485f9d56f$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $800ab3e485f9d56f$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $5ZlPZ.DataAdapterCore));

});

parcelRegister("9A4g1", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $6f9ac74d14e5e0d5$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $6f9ac74d14e5e0d5$export$bcb28fbac1def494);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $grMmj = parcelRequire("grMmj");
function $6f9ac74d14e5e0d5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6f9ac74d14e5e0d5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6f9ac74d14e5e0d5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6f9ac74d14e5e0d5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6f9ac74d14e5e0d5$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $6f9ac74d14e5e0d5$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $6f9ac74d14e5e0d5$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $6f9ac74d14e5e0d5$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $6f9ac74d14e5e0d5$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $6f9ac74d14e5e0d5$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $6f9ac74d14e5e0d5$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $6f9ac74d14e5e0d5$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $6f9ac74d14e5e0d5$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $6f9ac74d14e5e0d5$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $6f9ac74d14e5e0d5$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $6f9ac74d14e5e0d5$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PersistentOverrideAdapter);
        this._overrides = $6f9ac74d14e5e0d5$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $6f9ac74d14e5e0d5$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $6f9ac74d14e5e0d5$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $6f9ac74d14e5e0d5$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($6f9ac74d14e5e0d5$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($6f9ac74d14e5e0d5$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $6f9ac74d14e5e0d5$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $grMmj._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $6f9ac74d14e5e0d5$var$_objectSpread($6f9ac74d14e5e0d5$var$_objectSpread({}, $6f9ac74d14e5e0d5$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($6f9ac74d14e5e0d5$var$djb2MapKey((0, $grMmj._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($6f9ac74d14e5e0d5$var$djb2MapKey((0, $grMmj._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($6f9ac74d14e5e0d5$var$djb2MapKey((0, $grMmj._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($6f9ac74d14e5e0d5$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $6f9ac74d14e5e0d5$var$_objectSpread($6f9ac74d14e5e0d5$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $6f9ac74d14e5e0d5$var$_objectSpread($6f9ac74d14e5e0d5$var$_objectSpread({}, current.details), {}, {
                        reason: $6f9ac74d14e5e0d5$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($6f9ac74d14e5e0d5$var$djb2MapKey((0, $grMmj._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($6f9ac74d14e5e0d5$var$djb2MapKey((0, $grMmj._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($6f9ac74d14e5e0d5$var$djb2MapKey((0, $grMmj._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($6f9ac74d14e5e0d5$var$djb2MapKey((0, $grMmj._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($6f9ac74d14e5e0d5$var$djb2MapKey((0, $grMmj._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($6f9ac74d14e5e0d5$var$djb2MapKey((0, $grMmj._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $6f9ac74d14e5e0d5$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($6f9ac74d14e5e0d5$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $6f9ac74d14e5e0d5$var$_objectSpread($6f9ac74d14e5e0d5$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $grMmj._makeTypedGet)(current.name, overridden),
                    details: $6f9ac74d14e5e0d5$var$_objectSpread($6f9ac74d14e5e0d5$var$_objectSpread({}, current.details), {}, {
                        reason: $6f9ac74d14e5e0d5$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($6f9ac74d14e5e0d5$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $6f9ac74d14e5e0d5$var$_objectSpread($6f9ac74d14e5e0d5$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $grMmj._makeTypedGet)(current.name, overridden),
                    details: $6f9ac74d14e5e0d5$var$_objectSpread($6f9ac74d14e5e0d5$var$_objectSpread({}, current.details), {}, {
                        reason: $6f9ac74d14e5e0d5$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("6IKyZ", function(module, exports) {
$parcel$export(module.exports, "debug", () => $4e4af8aa876a7cdf$export$1c9f709888824e05);
var $4e4af8aa876a7cdf$var$_process, $4e4af8aa876a7cdf$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $4e4af8aa876a7cdf$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($4e4af8aa876a7cdf$var$_process = globalThis.process) === null || $4e4af8aa876a7cdf$var$_process === void 0 || ($4e4af8aa876a7cdf$var$_process = $4e4af8aa876a7cdf$var$_process.env) === null || $4e4af8aa876a7cdf$var$_process === void 0 ? void 0 : $4e4af8aa876a7cdf$var$_process.JEST_WORKER_ID) !== undefined;
var $4e4af8aa876a7cdf$var$DEBUG_MODE = !$4e4af8aa876a7cdf$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($4e4af8aa876a7cdf$var$_process2 = globalThis.process) === null || $4e4af8aa876a7cdf$var$_process2 === void 0 || ($4e4af8aa876a7cdf$var$_process2 = $4e4af8aa876a7cdf$var$_process2.env) === null || $4e4af8aa876a7cdf$var$_process2 === void 0 ? void 0 : $4e4af8aa876a7cdf$var$_process2.NODE_ENV) !== 'production';
var $4e4af8aa876a7cdf$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$4e4af8aa876a7cdf$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("aLvfY", function(module, exports) {
$parcel$export(module.exports, "hash", () => $7d668a15f366479f$export$d6af199866bfb566);
var $7d668a15f366479f$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("18gtv", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("43F4j").then(()=>parcelRequire('eSd2V'));

});

parcelRegister("bSqvq", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("2gk8p").then(()=>parcelRequire('W1rDa'));

});

parcelRegister("iUd27", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("5zYym").then(()=>parcelRequire('drVd1'));

});

parcelRegister("18Y4O", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("jC6So").then(()=>parcelRequire('doJ5B'));

});

parcelRegister("58sFO", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("lmRPu").then(()=>parcelRequire('1L7tS'));

});

parcelRegister("6ayJ7", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("YHixg").then(()=>parcelRequire('8S4nI'));

});

parcelRegister("fkCaU", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("fiQk2").then(()=>parcelRequire('7evTs'));

});

parcelRegister("kZOiD", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("edIX4").then(()=>parcelRequire('1Xi9i'));

});

parcelRegister("dtbTA", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("lkIOg").then(()=>parcelRequire('dAVgQ'));

});

parcelRegister("QSzo8", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("fl7xb").then(()=>parcelRequire('c49zb'));

});

parcelRegister("6pzKK", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("c84H4").then(()=>parcelRequire('a97Au'));

});

parcelRegister("45Zis", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fb72d4a32455831$export$2e2bcd8739ae039);
var $2fb72d4a32455831$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $2fb72d4a32455831$export$2e2bcd8739ae039 = $2fb72d4a32455831$var$rafSchd;

});

parcelRegister("lAD7C", function(module, exports) {
function $fb7b4e90f3581f68$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
module.exports = $fb7b4e90f3581f68$var$_taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gENTG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7f51491040268dbfa9258c45e59f2b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c207164c875990c8$var$_react = $c207164c875990c8$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $c207164c875990c8$var$_baseNew = $c207164c875990c8$var$_interopRequireDefault((parcelRequire("kAFi5")));
function $c207164c875990c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c207164c875990c8$var$PersonIcon = (props)=>/*#__PURE__*/ $c207164c875990c8$var$_react.default.createElement($c207164c875990c8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 15v-2.25a3 3 0 0 0-3-3h-4.5a3 3 0 0 0-3 3V15m8.5-11a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
    }, props));
$c207164c875990c8$var$PersonIcon.displayName = 'PersonIcon';
var $c207164c875990c8$var$_default = module.exports.default = $c207164c875990c8$var$PersonIcon;

});
parcelRegister("kAFi5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("6iTyl")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("6iTyl")).Icon);

var $6iTyl = parcelRequire("6iTyl");

});
parcelRegister("6iTyl", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $496f84277c701194$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $496f84277c701194$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $c8Tt7 = parcelRequire("c8Tt7");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $496f84277c701194$var$commonSVGStyles = (0, $74Zh5.css)({
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: 'currentColor'
    }
});
var $496f84277c701194$var$svgStyles = (0, $74Zh5.css)({
    color: 'currentColor',
    verticalAlign: 'bottom'
});
var $496f84277c701194$var$iconStyles = (0, $74Zh5.css)({
    display: 'inline-block',
    boxSizing: 'border-box',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
    paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
});
var $496f84277c701194$var$utilityIconStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-150, 12px)"
});
var $496f84277c701194$var$scaleStyles = (0, $74Zh5.css)({
    width: 'inherit',
    height: 'inherit'
});
/**
 * For windows high contrast mode
 */ var $496f84277c701194$var$baseHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        color: 'CanvasText',
        filter: 'grayscale(1)'
    }
});
var $496f84277c701194$var$scaleSize = (0, $74Zh5.css)({
    width: 'inherit',
    height: 'inherit'
});
var $496f84277c701194$var$sizeMap = {
    core: {
        none: (0, $74Zh5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $74Zh5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $74Zh5.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $74Zh5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $74Zh5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $496f84277c701194$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $496f84277c701194$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $496f84277c701194$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $c8Tt7.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return (0, $74Zh5.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $496f84277c701194$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core'];
    var viewBoxPadding;
    if (props.type === 'utility') {
        var _props$spacing;
        viewBoxPadding = $496f84277c701194$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : 'none'];
    } else {
        var _props$spacing2;
        viewBoxPadding = $496f84277c701194$var$paddingMap['core'][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : 'none'];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = "\n<filter id=\"ds-newIconOpacityFilter\">\n  <feFlood flood-color=\"var(--ds-icon-disabled)\" />\n  <feComposite in2=\"SourceGraphic\" operator=\"in\" />\n</filter>\n<g filter=\"url(#ds-newIconOpacityFilter)\">\n  ".concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $74Zh5.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $496f84277c701194$var$iconStyles,
            $496f84277c701194$var$baseHcmStyles,
            shouldScale && $496f84277c701194$var$scaleStyles,
            props.type === 'utility' && $496f84277c701194$var$utilityIconStyles
        ]
    }, (0, $74Zh5.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $496f84277c701194$var$commonSVGStyles,
            $496f84277c701194$var$svgStyles,
            shouldScale ? $496f84277c701194$var$scaleSize : props.type === 'utility' ? $496f84277c701194$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : 'none'] : $496f84277c701194$var$sizeMap['core'][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : 'none']
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $496f84277c701194$export$2e2bcd8739ae039 = $496f84277c701194$export$f04a61298a47a40f;

});
parcelRegister("c8Tt7", function(module, exports) {
$parcel$export(module.exports, "fg", () => $8d71424a661c8672$export$b40ec24ac8275656);

var $8NvoV = parcelRequire("8NvoV");
function $8d71424a661c8672$export$ba05d765b8392e5e(flagResolver) {
    (0, $8NvoV.setBooleanResolver)(flagResolver);
}
function $8d71424a661c8672$export$470e5c2be1411c89(name) {
    return (0, $8NvoV.resolveBooleanFlag)(name);
}
function $8d71424a661c8672$export$b40ec24ac8275656(name) {
    return (0, $8NvoV.resolveBooleanFlag)(name);
}

});
parcelRegister("8NvoV", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $667b41e5613b3245$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $667b41e5613b3245$export$6333b6aff9fc6275);

var $9dOvm = parcelRequire("9dOvm");

var $1VML5 = parcelRequire("1VML5");

var $3ZMUU = parcelRequire("3ZMUU");
var $667b41e5613b3245$var$pkgName = '@atlaskit/platform-feature-flags';
var $667b41e5613b3245$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $667b41e5613b3245$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $667b41e5613b3245$var$ENV_ENABLE_PLATFORM_FF = $667b41e5613b3245$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $667b41e5613b3245$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $667b41e5613b3245$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $667b41e5613b3245$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $667b41e5613b3245$var$ENV_ENABLE_PLATFORM_FF || $667b41e5613b3245$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $667b41e5613b3245$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $667b41e5613b3245$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$667b41e5613b3245$var$globalVar[$667b41e5613b3245$export$7e41b1b2bdee3f98] = $667b41e5613b3245$var$globalVar[$667b41e5613b3245$export$7e41b1b2bdee3f98] || $667b41e5613b3245$var$DEFAULT_PFF_GLOBAL;
function $667b41e5613b3245$export$f2b591175b3e424c(resolver) {
    $667b41e5613b3245$var$globalVar[$667b41e5613b3245$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $667b41e5613b3245$export$6333b6aff9fc6275(flagKey) {
    if ($667b41e5613b3245$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $1VML5.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $667b41e5613b3245$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $667b41e5613b3245$var$globalVar[$667b41e5613b3245$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $667b41e5613b3245$var$globalVar[$667b41e5613b3245$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $9dOvm.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $667b41e5613b3245$var$globalVar[$667b41e5613b3245$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("1VML5", function(module, exports) {
$parcel$export(module.exports, "debug", () => $1680efb7957e8f86$export$1c9f709888824e05);
var $1680efb7957e8f86$var$_process, $1680efb7957e8f86$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $1680efb7957e8f86$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($1680efb7957e8f86$var$_process = globalThis.process) === null || $1680efb7957e8f86$var$_process === void 0 || ($1680efb7957e8f86$var$_process = $1680efb7957e8f86$var$_process.env) === null || $1680efb7957e8f86$var$_process === void 0 ? void 0 : $1680efb7957e8f86$var$_process.JEST_WORKER_ID) !== undefined;
var $1680efb7957e8f86$var$DEBUG_MODE = !$1680efb7957e8f86$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($1680efb7957e8f86$var$_process2 = globalThis.process) === null || $1680efb7957e8f86$var$_process2 === void 0 || ($1680efb7957e8f86$var$_process2 = $1680efb7957e8f86$var$_process2.env) === null || $1680efb7957e8f86$var$_process2 === void 0 ? void 0 : $1680efb7957e8f86$var$_process2.NODE_ENV) !== 'production';
var $1680efb7957e8f86$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$1680efb7957e8f86$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});






parcelRegister("fjELu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2684071cf01d70a$var$_react = $b2684071cf01d70a$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $7m1ty = parcelRequire("7m1ty");

var $b2684071cf01d70a$var$_person = $b2684071cf01d70a$var$_interopRequireDefault((parcelRequire("gENTG")));
function $b2684071cf01d70a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b2684071cf01d70a$var$PersonIcon = (props)=>/*#__PURE__*/ $b2684071cf01d70a$var$_react.default.createElement($7m1ty.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $b2684071cf01d70a$var$_person.default
    }));
$b2684071cf01d70a$var$PersonIcon.displayName = 'PersonIcon';
var $b2684071cf01d70a$var$_default = module.exports.default = $b2684071cf01d70a$var$PersonIcon;

});
parcelRegister("7m1ty", function(module, exports) {
$parcel$export(module.exports, "IconFacade", () => $55abbb8236b48e91$export$3cfb73f70dfca966);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $c8Tt7 = parcelRequire("c8Tt7");

var $9d9mx = parcelRequire("9d9mx");
var $55abbb8236b48e91$var$_excluded = [
    "dangerouslySetGlyph"
];
var $55abbb8236b48e91$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
var $55abbb8236b48e91$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $5FkrB.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $55abbb8236b48e91$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : 'medium';
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $c8Tt7.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (size === 'small' || size === 'medium')) {
        if (props.iconType === 'utility') {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
                spacing: (0, $c8Tt7.fg)('platform-visual-refresh-icons-facade-button-fix') ? $55abbb8236b48e91$var$sizeSpacingMap['utility'][size] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
                spacing: $55abbb8236b48e91$var$sizeSpacingMap['core'][size],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9d9mx.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});

});
parcelRegister("9d9mx", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $6b4c972a7ce3c858$export$f04a61298a47a40f);

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $3eBhS = parcelRequire("3eBhS");

var $fNB8Z = parcelRequire("fNB8Z");
function $6b4c972a7ce3c858$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6b4c972a7ce3c858$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6b4c972a7ce3c858$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6b4c972a7ce3c858$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $6b4c972a7ce3c858$var$iconStyles = (0, $74Zh5.css)({
    display: 'inline-block',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> svg': $6b4c972a7ce3c858$var$_objectSpread($6b4c972a7ce3c858$var$_objectSpread({}, (0, $3eBhS.commonSVGStyles)), {}, {
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    })
});
/**
 * For windows high contrast mode
 */ var $6b4c972a7ce3c858$var$baseHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            filter: 'grayscale(1)',
            '--icon-primary-color': 'CanvasText',
            // foreground
            '--icon-secondary-color': 'Canvas' // background
        }
    }
});
var $6b4c972a7ce3c858$var$primaryEqualsSecondaryHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            '--icon-primary-color': 'Canvas' // foreground
        }
    }
});
var $6b4c972a7ce3c858$var$secondaryTransparentHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            '--icon-secondary-color': 'transparent' // background
        }
    }
});
var $6b4c972a7ce3c858$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $74Zh5.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $3eBhS.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $74Zh5.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor || (0, $fNB8Z.getBackground)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $6b4c972a7ce3c858$var$iconStyles,
            $6b4c972a7ce3c858$var$baseHcmStyles,
            primaryColor === secondaryColor && $6b4c972a7ce3c858$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $6b4c972a7ce3c858$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $74Zh5.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                '> svg': dimensions
            })
        ]
    }));
});
var $6b4c972a7ce3c858$export$2e2bcd8739ae039 = $6b4c972a7ce3c858$export$f04a61298a47a40f;

});
parcelRegister("3eBhS", function(module, exports) {
$parcel$export(module.exports, "commonSVGStyles", () => $25af9a65d34ebc51$export$16374db1c3e6dfba);
$parcel$export(module.exports, "getIconSize", () => $25af9a65d34ebc51$export$3eb7d6130acfda37);

var $d4aiZ = parcelRequire("d4aiZ");

var $74Zh5 = parcelRequire("74Zh5");
var $25af9a65d34ebc51$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $25af9a65d34ebc51$var$smallStyles = (0, $74Zh5.css)((0, $d4aiZ.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $25af9a65d34ebc51$var$mediumStyles = (0, $74Zh5.css)((0, $d4aiZ.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $25af9a65d34ebc51$var$largeStyles = (0, $74Zh5.css)((0, $d4aiZ.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $25af9a65d34ebc51$var$xlargeStyles = (0, $74Zh5.css)((0, $d4aiZ.dimensions).xlarge);
var $25af9a65d34ebc51$export$ef0ad74202575b64 = {
    small: $25af9a65d34ebc51$var$smallStyles,
    medium: $25af9a65d34ebc51$var$mediumStyles,
    large: $25af9a65d34ebc51$var$largeStyles,
    xlarge: $25af9a65d34ebc51$var$xlargeStyles
};
var $25af9a65d34ebc51$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $d4aiZ.dimensions)[size];
    return undefined;
};

});
parcelRegister("d4aiZ", function(module, exports) {
$parcel$export(module.exports, "dimensions", () => $9833a482098f67bb$export$62ad7b0c781000e9);
var $9833a482098f67bb$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
var $9833a482098f67bb$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
var $9833a482098f67bb$export$62ad7b0c781000e9 = {
    small: {
        width: $9833a482098f67bb$export$c647cb0ee6e282fe.small,
        height: $9833a482098f67bb$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $9833a482098f67bb$export$c647cb0ee6e282fe.medium,
        height: $9833a482098f67bb$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $9833a482098f67bb$export$c647cb0ee6e282fe.large,
        height: $9833a482098f67bb$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $9833a482098f67bb$export$c647cb0ee6e282fe.xlarge,
        height: $9833a482098f67bb$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("fNB8Z", function(module, exports) {
$parcel$export(module.exports, "getBackground", () => $b8083eaafc730cc5$export$18cb9425622d4e06);
var $b8083eaafc730cc5$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});




parcelRegister("3w44K", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08061a6d953c7d73b57c2e6e0bdac389>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28f78592181d8380$var$_react = $28f78592181d8380$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $28f78592181d8380$var$_baseNew = $28f78592181d8380$var$_interopRequireDefault((parcelRequire("kAFi5")));
function $28f78592181d8380$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $28f78592181d8380$var$ReleaseIcon = (props)=>/*#__PURE__*/ $28f78592181d8380$var$_react.default.createElement($28f78592181d8380$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M.75 7.75V7a.75.75 0 0 0-.75.75zm14.5 0 .646.382A.75.75 0 0 0 15.25 7zm-12.5-3V4a.75.75 0 0 0-.75.75zm6.25 0 .648-.378A.75.75 0 0 0 9 4zm-4.25-2V2H4v.75zm1.5 0H7V2h-.75zm6.113 9.886.646.382zm2.241-5.268-2.887 4.886 1.292.764 2.887-4.886zM11.287 12.5H2V14h9.287zM1.5 12V7.75H0V12zM.75 8.5h2V7h-2zm2.75-.75v-3H2v3zm-.75.75h8V7h-8zm8 0h4.5V7h-4.5zM8.352 5.128l1.75 3 1.296-.756-1.75-3zM2.75 5.5h2V4h-2zm2.75-.75v-2H4v2zM4.75 3.5h1.5V2h-1.5zm0 2h1.5V4h-1.5zm1.5 0H9V4H6.25zM5.5 2.75v2H7v-2zM2 12.5a.5.5 0 0 1-.5-.5H0a2 2 0 0 0 2 2zm9.717-.246a.5.5 0 0 1-.43.246V14a2 2 0 0 0 1.722-.982z"/>`
    }, props));
$28f78592181d8380$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $28f78592181d8380$var$_default = module.exports.default = $28f78592181d8380$var$ReleaseIcon;

});

parcelRegister("7EoFn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $591f670c7fd4f4ae$var$_react = $591f670c7fd4f4ae$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $7m1ty = parcelRequire("7m1ty");

var $591f670c7fd4f4ae$var$_release = $591f670c7fd4f4ae$var$_interopRequireDefault((parcelRequire("3w44K")));
function $591f670c7fd4f4ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $591f670c7fd4f4ae$var$ShipIcon = (props)=>/*#__PURE__*/ $591f670c7fd4f4ae$var$_react.default.createElement($7m1ty.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 12h8v-2H6zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4z"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6zm4 0V7H7.999c.005 0 .002.003.002.005V8h2z"/><path fill-rule="nonzero" d="M4.5 17h13.994l1.002-3H4.14zm-2.495-4.012A.862.862 0 0 1 2.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.15 1.15 0 0 1-1.118-.988z"/></g></svg>`
    }, props, {
        newIcon: $591f670c7fd4f4ae$var$_release.default
    }));
$591f670c7fd4f4ae$var$ShipIcon.displayName = 'ShipIcon';
var $591f670c7fd4f4ae$var$_default = module.exports.default = $591f670c7fd4f4ae$var$ShipIcon;

});

parcelRegister("69J3E", function(module, exports) {
$parcel$export(module.exports, "default", () => $47b688e257f5d676$export$2e2bcd8739ae039);

var $49WdW = parcelRequire("49WdW");

var $47b688e257f5d676$export$2e2bcd8739ae039 = (0, $49WdW.default);

});
parcelRegister("49WdW", function(module, exports) {
$parcel$export(module.exports, "default", () => $30752ab56a6a5229$export$2e2bcd8739ae039);

var $kuWQN = parcelRequire("kuWQN");

var $d1G9Q = parcelRequire("d1G9Q");

var $5FkrB = parcelRequire("5FkrB");

var $77PHu = parcelRequire("77PHu");

var $1Pqk6 = parcelRequire("1Pqk6");
var $30752ab56a6a5229$var$FocusLockCombination = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $77PHu.default), (0, $d1G9Q.default)({
        sideCar: (0, $1Pqk6.default),
        ref: ref
    }, props));
});
var $30752ab56a6a5229$var$_ref = (0, $77PHu.default).propTypes || {}, $30752ab56a6a5229$var$sideCar = $30752ab56a6a5229$var$_ref.sideCar, $30752ab56a6a5229$var$propTypes = (0, $kuWQN.default)($30752ab56a6a5229$var$_ref, [
    "sideCar"
]);
$30752ab56a6a5229$var$FocusLockCombination.propTypes = {};
var $30752ab56a6a5229$export$2e2bcd8739ae039 = $30752ab56a6a5229$var$FocusLockCombination;

});
parcelRegister("kuWQN", function(module, exports) {
$parcel$export(module.exports, "default", () => $eec4427b8bcf239c$export$2e2bcd8739ae039);
function $eec4427b8bcf239c$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("77PHu", function(module, exports) {
$parcel$export(module.exports, "default", () => $53014a7bddb695f5$export$2e2bcd8739ae039);

var $d1G9Q = parcelRequire("d1G9Q");

var $5FkrB = parcelRequire("5FkrB");


var $a9Isk = parcelRequire("a9Isk");

var $8X9rs = parcelRequire("8X9rs");

var $h6OtI = parcelRequire("h6OtI");

var $ljihP = parcelRequire("ljihP");

var $g4LL1 = parcelRequire("g4LL1");
var $53014a7bddb695f5$var$emptyArray = [];
var $53014a7bddb695f5$var$FocusLock = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _useState = (0, $5FkrB.useState)(), realObserved = _useState[0], setObserved = _useState[1];
    var observed = (0, $5FkrB.useRef)();
    var isActive = (0, $5FkrB.useRef)(false);
    var originalFocusedElement = (0, $5FkrB.useRef)(null);
    var _useState2 = (0, $5FkrB.useState)({}), update = _useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $53014a7bddb695f5$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _useState3 = (0, $5FkrB.useState)({}), id = _useState3[0];
    var onActivation = (0, $5FkrB.useCallback)(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = (0, $5FkrB.useCallback)(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = (0, $5FkrB.useCallback)(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = (0, $5FkrB.useCallback)(function(event) {
        if (isActive.current) (0, $ljihP.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $ljihP.mediumBlur).useMedium;
    var setObserveNode = (0, $5FkrB.useCallback)(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $d1G9Q.default)((_extends2 = {}, _extends2[0, $a9Isk.FOCUS_DISABLED] = disabled && 'disabled', _extends2[0, $a9Isk.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $8X9rs.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = (0, $5FkrB.useMemo)(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            get active () {
                return isActive.current;
            }
        };
    }, [
        disabled,
        isActive,
        shards,
        observed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, hasLeadingGuards && [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $h6OtI.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $h6OtI.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(SideCar, {
        id: id,
        sideCar: (0, $ljihP.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions,
        noFocusGuards: noFocusGuards
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, (0, $d1G9Q.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $g4LL1.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $h6OtI.hiddenGuard)
    }));
});
$53014a7bddb695f5$var$FocusLock.propTypes = {};
var $53014a7bddb695f5$export$2e2bcd8739ae039 = $53014a7bddb695f5$var$FocusLock;

});
parcelRegister("a9Isk", function(module, exports) {
$parcel$export(module.exports, "FOCUS_GROUP", () => $764d3aac8890a574$export$4f9a06cb7441a087);
$parcel$export(module.exports, "FOCUS_DISABLED", () => $764d3aac8890a574$export$aeda8252e54b50f7);
$parcel$export(module.exports, "FOCUS_ALLOW", () => $764d3aac8890a574$export$54ecf528c58f9ef6);
$parcel$export(module.exports, "FOCUS_AUTO", () => $764d3aac8890a574$export$70e9b4a1820af101);
$parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", () => $764d3aac8890a574$export$134ebef29fd94853);
/**
 * defines a focus group
 */ var $764d3aac8890a574$export$4f9a06cb7441a087 = 'data-focus-lock';
var $764d3aac8890a574$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $764d3aac8890a574$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $764d3aac8890a574$export$70e9b4a1820af101 = 'data-autofocus-inside';
var $764d3aac8890a574$export$134ebef29fd94853 = 'data-no-autofocus';

});

parcelRegister("8X9rs", function(module, exports) {
$parcel$export(module.exports, "useMergeRefs", () => $684b28614ec143a7$export$74665b213cb5c4cf);

var $5FkrB = parcelRequire("5FkrB");

var $eurAs = parcelRequire("eurAs");

var $kdfIQ = parcelRequire("kdfIQ");
var $684b28614ec143a7$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $5FkrB.useLayoutEffect : $5FkrB.useEffect;
var $684b28614ec143a7$var$currentValues = new WeakMap();
function $684b28614ec143a7$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $kdfIQ.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $eurAs.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $684b28614ec143a7$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $684b28614ec143a7$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $eurAs.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $eurAs.assignRef)(ref, current_1);
            });
        }
        $684b28614ec143a7$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("eurAs", function(module, exports) {
$parcel$export(module.exports, "assignRef", () => $a8c944370e1d2a09$export$d734136a7b018efe);
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $a8c944370e1d2a09$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("kdfIQ", function(module, exports) {
$parcel$export(module.exports, "useCallbackRef", () => $eb7137ab9f133859$export$25bec8c6f54ee79a);

var $5FkrB = parcelRequire("5FkrB");
function $eb7137ab9f133859$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $5FkrB.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("h6OtI", function(module, exports) {
$parcel$export(module.exports, "hiddenGuard", () => $c74a27259105fd78$export$b8c7b07253306600);

var $5FkrB = parcelRequire("5FkrB");

var $c74a27259105fd78$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $c74a27259105fd78$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $c74a27259105fd78$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $c74a27259105fd78$export$b8c7b07253306600
    }));
};
$c74a27259105fd78$var$InFocusGuard.propTypes = {};
var $c74a27259105fd78$export$2e2bcd8739ae039 = $c74a27259105fd78$var$InFocusGuard;

});

parcelRegister("ljihP", function(module, exports) {
$parcel$export(module.exports, "mediumFocus", () => $f8398ea4b64234e0$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $f8398ea4b64234e0$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $f8398ea4b64234e0$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $f8398ea4b64234e0$export$892cbf28e5518020);

var $6QSj6 = parcelRequire("6QSj6");
var $f8398ea4b64234e0$export$5733e022b1d538cb = (0, $6QSj6.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $f8398ea4b64234e0$export$b3e9a9312f73723c = (0, $6QSj6.createMedium)();
var $f8398ea4b64234e0$export$3a1d52767cbc07b8 = (0, $6QSj6.createMedium)();
var $f8398ea4b64234e0$export$892cbf28e5518020 = (0, $6QSj6.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});
parcelRegister("6QSj6", function(module, exports) {
$parcel$export(module.exports, "createMedium", () => $4fd1b9ad472e40cb$export$9ffbfcaf067b02c6);
$parcel$export(module.exports, "createSidecarMedium", () => $4fd1b9ad472e40cb$export$e13ec7dd7a14088d);

var $l2Z7B = parcelRequire("l2Z7B");
function $4fd1b9ad472e40cb$var$ItoI(a) {
    return a;
}
function $4fd1b9ad472e40cb$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $4fd1b9ad472e40cb$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $4fd1b9ad472e40cb$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $4fd1b9ad472e40cb$var$ItoI;
    return $4fd1b9ad472e40cb$var$innerCreateMedium(defaults, middleware);
}
function $4fd1b9ad472e40cb$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $4fd1b9ad472e40cb$var$innerCreateMedium(null);
    medium.options = (0, $l2Z7B.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});


parcelRegister("g4LL1", function(module, exports) {
$parcel$export(module.exports, "focusScope", () => $bb4210ad376d9407$export$f5272e9b1168239c);

var $5FkrB = parcelRequire("5FkrB");
var $bb4210ad376d9407$export$f5272e9b1168239c = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);

});


parcelRegister("1Pqk6", function(module, exports) {
$parcel$export(module.exports, "default", () => $154ef9172a209d8a$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");


var $i7ZOa = parcelRequire("i7ZOa");

var $3LvY8 = parcelRequire("3LvY8");
var $gWC5V = parcelRequire("gWC5V");
var $738X1 = parcelRequire("738X1");
var $chs63 = parcelRequire("chs63");
var $75ruL = parcelRequire("75ruL");
var $4YVKI = parcelRequire("4YVKI");parcelRequire("cHP2I");
var $i8qpR = parcelRequire("i8qpR");

var $65prp = parcelRequire("65prp");

var $ljihP = parcelRequire("ljihP");
var $154ef9172a209d8a$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $154ef9172a209d8a$var$isFreeFocus = function isFreeFocus() {
    return $154ef9172a209d8a$var$focusOnBody() || (0, $75ruL.focusIsHidden)();
};
var $154ef9172a209d8a$var$lastActiveTrap = null;
var $154ef9172a209d8a$var$lastActiveFocus = null;
var $154ef9172a209d8a$var$tryRestoreFocus = function tryRestoreFocus() {
    return null;
};
var $154ef9172a209d8a$var$lastPortaledElement = null;
var $154ef9172a209d8a$var$focusWasOutsideWindow = false;
var $154ef9172a209d8a$var$windowFocused = false;
var $154ef9172a209d8a$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $154ef9172a209d8a$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($154ef9172a209d8a$var$lastActiveTrap.whiteList || $154ef9172a209d8a$var$defaultWhitelist)(activeElement);
};
var $154ef9172a209d8a$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $154ef9172a209d8a$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $154ef9172a209d8a$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $154ef9172a209d8a$var$lastPortaledElement && $154ef9172a209d8a$var$lastPortaledElement.portaledElement === element;
};
function $154ef9172a209d8a$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $154ef9172a209d8a$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($154ef9172a209d8a$var$focusWasOutsideWindow);
    return $154ef9172a209d8a$var$focusWasOutsideWindow === 'meanwhile';
};
var $154ef9172a209d8a$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $154ef9172a209d8a$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $154ef9172a209d8a$var$checkInHost(activeElement, area, area);
    });
};
var $154ef9172a209d8a$var$getNodeFocusables = function getNodeFocusables(nodes) {
    return (0, $4YVKI.getFocusableNodes)(nodes, new Map());
};
var $154ef9172a209d8a$var$isNotFocusable = function isNotFocusable(node) {
    return !$154ef9172a209d8a$var$getNodeFocusables([
        node.parentNode
    ]).some(function(el) {
        return el.node === node;
    });
};
var $154ef9172a209d8a$var$activateTrap = function activateTrap() {
    var result = false;
    if ($154ef9172a209d8a$var$lastActiveTrap) {
        var _lastActiveTrap = $154ef9172a209d8a$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions, noFocusGuards = _lastActiveTrap.noFocusGuards;
        var workingNode = observed || $154ef9172a209d8a$var$lastPortaledElement && $154ef9172a209d8a$var$lastPortaledElement.portaledElement;
        if ($154ef9172a209d8a$var$focusOnBody() && $154ef9172a209d8a$var$lastActiveFocus && $154ef9172a209d8a$var$lastActiveFocus !== document.body) {
            if (!document.body.contains($154ef9172a209d8a$var$lastActiveFocus) || $154ef9172a209d8a$var$isNotFocusable($154ef9172a209d8a$var$lastActiveFocus)) {
                var newTarget = $154ef9172a209d8a$var$tryRestoreFocus();
                if (newTarget) newTarget.focus();
            }
        }
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $65prp.extractRef)).filter(Boolean));
            var shouldForceRestoreFocus = function shouldForceRestoreFocus() {
                if (!$154ef9172a209d8a$var$focusWasOutside(crossFrame) || !noFocusGuards || !$154ef9172a209d8a$var$lastActiveFocus || $154ef9172a209d8a$var$windowFocused) return false;
                var nodes = $154ef9172a209d8a$var$getNodeFocusables(workingArea);
                var lastIndex = nodes.findIndex(function(_ref) {
                    var node = _ref.node;
                    return node === $154ef9172a209d8a$var$lastActiveFocus;
                });
                return lastIndex === 0 || lastIndex === nodes.length - 1;
            };
            if (!activeElement || $154ef9172a209d8a$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || shouldForceRestoreFocus() || !$154ef9172a209d8a$var$isFreeFocus() || !$154ef9172a209d8a$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $chs63.focusInside)(workingArea) || activeElement && $154ef9172a209d8a$var$withinHost(activeElement, workingArea) || $154ef9172a209d8a$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$154ef9172a209d8a$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $i8qpR.moveFocusInside)(workingArea, $154ef9172a209d8a$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $154ef9172a209d8a$var$lastPortaledElement = {};
                        }
                    }
                    $154ef9172a209d8a$var$lastActiveFocus = document && document.activeElement;
                    if ($154ef9172a209d8a$var$lastActiveFocus !== document.body) $154ef9172a209d8a$var$tryRestoreFocus = (0, $3LvY8.captureFocusRestore)($154ef9172a209d8a$var$lastActiveFocus);
                    $154ef9172a209d8a$var$focusWasOutsideWindow = false;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $gWC5V.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref2) {
                    var node = _ref2.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref3) {
                        var guard = _ref3.guard, node = _ref3.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref4) {
                        var node = _ref4.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $154ef9172a209d8a$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $154ef9172a209d8a$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $154ef9172a209d8a$var$onTrap = function onTrap(event) {
    if ($154ef9172a209d8a$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $154ef9172a209d8a$var$onBlur = function onBlur() {
    return (0, $65prp.deferAction)($154ef9172a209d8a$var$activateTrap);
};
var $154ef9172a209d8a$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $154ef9172a209d8a$var$recordPortal(currentNode, source);
};
var $154ef9172a209d8a$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $154ef9172a209d8a$var$FocusTrap = function FocusTrap(_ref5) {
    var children = _ref5.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        onBlur: $154ef9172a209d8a$var$onBlur,
        onFocus: $154ef9172a209d8a$var$onFocus
    }, children);
};
$154ef9172a209d8a$var$FocusTrap.propTypes = {};
var $154ef9172a209d8a$var$onWindowFocus = function onWindowFocus() {
    $154ef9172a209d8a$var$windowFocused = true;
};
var $154ef9172a209d8a$var$onWindowBlur = function onWindowBlur() {
    $154ef9172a209d8a$var$windowFocused = false;
    $154ef9172a209d8a$var$focusWasOutsideWindow = 'just';
    (0, $65prp.deferAction)(function() {
        $154ef9172a209d8a$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $154ef9172a209d8a$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $154ef9172a209d8a$var$onTrap);
    document.addEventListener('focusout', $154ef9172a209d8a$var$onBlur);
    window.addEventListener('focus', $154ef9172a209d8a$var$onWindowFocus);
    window.addEventListener('blur', $154ef9172a209d8a$var$onWindowBlur);
};
var $154ef9172a209d8a$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $154ef9172a209d8a$var$onTrap);
    document.removeEventListener('focusout', $154ef9172a209d8a$var$onBlur);
    window.removeEventListener('focus', $154ef9172a209d8a$var$onWindowFocus);
    window.removeEventListener('blur', $154ef9172a209d8a$var$onWindowBlur);
};
function $154ef9172a209d8a$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref6) {
        var disabled = _ref6.disabled;
        return !disabled;
    });
}
var $154ef9172a209d8a$var$focusLockAPI = {
    moveFocusInside: (0, $i8qpR.moveFocusInside),
    focusInside: (0, $chs63.focusInside),
    focusNextElement: (0, $738X1.focusNextElement),
    focusPrevElement: (0, $738X1.focusPrevElement),
    focusFirstElement: (0, $738X1.focusFirstElement),
    focusLastElement: (0, $738X1.focusLastElement),
    captureFocusRestore: (0, $3LvY8.captureFocusRestore)
};
function $154ef9172a209d8a$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$154ef9172a209d8a$var$lastActiveTrap) $154ef9172a209d8a$var$attachHandler();
    var lastTrap = $154ef9172a209d8a$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $154ef9172a209d8a$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref7) {
            var id = _ref7.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $154ef9172a209d8a$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($154ef9172a209d8a$var$focusLockAPI);
        $154ef9172a209d8a$var$activateTrap(true);
        (0, $65prp.deferAction)($154ef9172a209d8a$var$activateTrap);
    } else {
        $154ef9172a209d8a$var$detachHandler();
        $154ef9172a209d8a$var$lastActiveFocus = null;
    }
}
(0, $ljihP.mediumFocus).assignSyncMedium($154ef9172a209d8a$var$onFocus);
(0, $ljihP.mediumBlur).assignMedium($154ef9172a209d8a$var$onBlur);
(0, $ljihP.mediumEffect).assignMedium(function(cb) {
    return cb($154ef9172a209d8a$var$focusLockAPI);
});
var $154ef9172a209d8a$export$2e2bcd8739ae039 = (0, $i7ZOa.default)($154ef9172a209d8a$var$reducePropsToState, $154ef9172a209d8a$var$handleStateChangeOnClient)($154ef9172a209d8a$var$FocusWatcher);

});
parcelRegister("i7ZOa", function(module, exports) {
$parcel$export(module.exports, "default", () => $d328d346166c2227$export$2e2bcd8739ae039);

var $3opc4 = parcelRequire("3opc4");

var $jpOKD = parcelRequire("jpOKD");

var $5FkrB = parcelRequire("5FkrB");
function $d328d346166c2227$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $3opc4.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $5FkrB.PureComponent));
        (0, $jpOKD.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $d328d346166c2227$export$2e2bcd8739ae039 = $d328d346166c2227$var$withSideEffect;

});
parcelRegister("3opc4", function(module, exports) {
$parcel$export(module.exports, "default", () => $278727eb54862fdd$export$2e2bcd8739ae039);

var $5h2NW = parcelRequire("5h2NW");
function $278727eb54862fdd$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $5h2NW.default)(t, o);
}

});
parcelRegister("5h2NW", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d70b73588f4b16a$export$2e2bcd8739ae039);
function $3d70b73588f4b16a$export$2e2bcd8739ae039(t, e) {
    return $3d70b73588f4b16a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $3d70b73588f4b16a$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("jpOKD", function(module, exports) {
$parcel$export(module.exports, "default", () => $e227b838dc112aad$export$2e2bcd8739ae039);

var $9ngsp = parcelRequire("9ngsp");
function $e227b838dc112aad$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $9ngsp.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("9ngsp", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d33071d8186e866$export$2e2bcd8739ae039);

var $4bFFZ = parcelRequire("4bFFZ");

var $gSxx7 = parcelRequire("gSxx7");
function $6d33071d8186e866$export$2e2bcd8739ae039(t) {
    var i = (0, $gSxx7.default)(t, "string");
    return "symbol" == (0, $4bFFZ.default)(i) ? i : i + "";
}

});
parcelRegister("4bFFZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $30c8848c4f74b91f$export$2e2bcd8739ae039);
function $30c8848c4f74b91f$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $30c8848c4f74b91f$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $30c8848c4f74b91f$export$2e2bcd8739ae039(o);
}

});

parcelRegister("gSxx7", function(module, exports) {
$parcel$export(module.exports, "default", () => $032bcd3793381cce$export$2e2bcd8739ae039);

var $4bFFZ = parcelRequire("4bFFZ");
function $032bcd3793381cce$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $4bFFZ.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $4bFFZ.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("3LvY8", function(module, exports) {
$parcel$export(module.exports, "captureFocusRestore", () => $2bde8f3efaf2ecc9$export$d357db6e554ff59a);

var $4YVKI = parcelRequire("4YVKI");
function $2bde8f3efaf2ecc9$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === 'undefined') return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $2bde8f3efaf2ecc9$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $2bde8f3efaf2ecc9$var$weakRef(currentElement),
            parent: $2bde8f3efaf2ecc9$var$weakRef(currentElement.parentElement),
            left: $2bde8f3efaf2ecc9$var$weakRef(currentElement.previousElementSibling),
            right: $2bde8f3efaf2ecc9$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $2bde8f3efaf2ecc9$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $2bde8f3efaf2ecc9$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $4YVKI.getTabbableNodes)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $2bde8f3efaf2ecc9$export$d357db6e554ff59a = function(targetElement) {
    var location = $2bde8f3efaf2ecc9$export$5061a7725be48ff9(targetElement);
    return function() {
        return $2bde8f3efaf2ecc9$var$restoreFocusTo(location);
    };
};

});
parcelRegister("4YVKI", function(module, exports) {
$parcel$export(module.exports, "filterAutoFocusable", () => $3a09907090b85585$export$2f70373d403a5d2b);
$parcel$export(module.exports, "getTabbableNodes", () => $3a09907090b85585$export$3738e313571e2ad2);
$parcel$export(module.exports, "getFocusableNodes", () => $3a09907090b85585$export$493d05a3a8e6532d);
$parcel$export(module.exports, "parentAutofocusables", () => $3a09907090b85585$export$dc26309a71d1ce47);
$parcel$export(module.exports, "contains", () => $3a09907090b85585$export$2344b14b097df817);

var $ady3j = parcelRequire("ady3j");

var $k3Vqr = parcelRequire("k3Vqr");

var $2Tuzr = parcelRequire("2Tuzr");

var $gfzXb = parcelRequire("gfzXb");
var $3a09907090b85585$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $ady3j.toArray)(nodes).filter(function(node) {
        return (0, $k3Vqr.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $k3Vqr.notHiddenInput)(node);
    });
};
var $3a09907090b85585$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $ady3j.toArray)(nodes).filter(function(node) {
        return (0, $k3Vqr.isAutoFocusAllowedCached)(cache, node);
    });
};
var $3a09907090b85585$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $2Tuzr.orderByTabIndex)($3a09907090b85585$export$6266a5cd5915dc33((0, $gfzXb.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $3a09907090b85585$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $2Tuzr.orderByTabIndex)($3a09907090b85585$export$6266a5cd5915dc33((0, $gfzXb.getFocusables)(topNodes), visibilityCache), false);
};
var $3a09907090b85585$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $3a09907090b85585$export$6266a5cd5915dc33((0, $gfzXb.getParentAutofocusables)(topNode), visibilityCache);
};
var $3a09907090b85585$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $3a09907090b85585$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $ady3j.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $3a09907090b85585$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $3a09907090b85585$export$2344b14b097df817(child, element);
        });
    }
};

});
parcelRegister("ady3j", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $770588658e9e371c$export$45b10814cc054894);
$parcel$export(module.exports, "asArray", () => $770588658e9e371c$export$75093a47a9fa838d);
$parcel$export(module.exports, "getFirst", () => $770588658e9e371c$export$bcd7afcd904dce14);
/*
IE11 support
 */ var $770588658e9e371c$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $770588658e9e371c$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $770588658e9e371c$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

});

parcelRegister("k3Vqr", function(module, exports) {
$parcel$export(module.exports, "isVisibleCached", () => $e9b0a1fc8596c084$export$3c9dc299685ad160);
$parcel$export(module.exports, "isAutoFocusAllowedCached", () => $e9b0a1fc8596c084$export$bcaa50628f6a736e);
$parcel$export(module.exports, "getDataset", () => $e9b0a1fc8596c084$export$698b339b0c8edae3);
$parcel$export(module.exports, "isRadioElement", () => $e9b0a1fc8596c084$export$9d74f6fbc6f469d0);
$parcel$export(module.exports, "notHiddenInput", () => $e9b0a1fc8596c084$export$8197b0ea56b3b055);
$parcel$export(module.exports, "isGuard", () => $e9b0a1fc8596c084$export$d94b8b58ec2f30eb);
$parcel$export(module.exports, "isNotAGuard", () => $e9b0a1fc8596c084$export$602e5a0d338d7750);
$parcel$export(module.exports, "isDefined", () => $e9b0a1fc8596c084$export$4e62c701997796c1);

var $a9Isk = parcelRequire("a9Isk");
var $e9b0a1fc8596c084$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $e9b0a1fc8596c084$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $e9b0a1fc8596c084$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $e9b0a1fc8596c084$var$isInert = function(node) {
    return node.hasAttribute('inert');
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $e9b0a1fc8596c084$var$isVisibleUncached = function(node, checkParent) {
    return !node || $e9b0a1fc8596c084$var$isTopNode(node) || !$e9b0a1fc8596c084$var$isElementHidden(node) && !$e9b0a1fc8596c084$var$isInert(node) && checkParent($e9b0a1fc8596c084$var$getParentNode(node));
};
var $e9b0a1fc8596c084$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $e9b0a1fc8596c084$var$isVisibleUncached(node, $e9b0a1fc8596c084$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $e9b0a1fc8596c084$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$e9b0a1fc8596c084$var$isTopNode(node) ? $e9b0a1fc8596c084$export$b8550e27de209d85(node) ? checkParent($e9b0a1fc8596c084$var$getParentNode(node)) : false : true;
};
var $e9b0a1fc8596c084$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $e9b0a1fc8596c084$var$isAutoFocusAllowedUncached(node, $e9b0a1fc8596c084$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $e9b0a1fc8596c084$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $e9b0a1fc8596c084$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === 'BUTTON';
};
var $e9b0a1fc8596c084$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === 'INPUT';
};
var $e9b0a1fc8596c084$export$9d74f6fbc6f469d0 = function(node) {
    return $e9b0a1fc8596c084$export$88a6ceeed5737ba3(node) && node.type === 'radio';
};
var $e9b0a1fc8596c084$export$8197b0ea56b3b055 = function(node) {
    return !(($e9b0a1fc8596c084$export$88a6ceeed5737ba3(node) || $e9b0a1fc8596c084$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
};
var $e9b0a1fc8596c084$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $a9Isk.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var $e9b0a1fc8596c084$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $e9b0a1fc8596c084$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $e9b0a1fc8596c084$export$602e5a0d338d7750 = function(node) {
    return !$e9b0a1fc8596c084$export$d94b8b58ec2f30eb(node);
};
var $e9b0a1fc8596c084$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};

});

parcelRegister("2Tuzr", function(module, exports) {
$parcel$export(module.exports, "orderByTabIndex", () => $21b86e87d5f46a98$export$cb40ee071f0d5226);

var $ady3j = parcelRequire("ady3j");
var $21b86e87d5f46a98$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $21b86e87d5f46a98$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) return 0;
    }
    return node.tabIndex;
};
var $21b86e87d5f46a98$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $ady3j.toArray)(nodes).map(function(node, index) {
        var tabIndex = $21b86e87d5f46a98$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($21b86e87d5f46a98$export$350ee6c095d98996);
};

});

parcelRegister("gfzXb", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $bd49efae73506932$export$f6768025e418420e);
$parcel$export(module.exports, "getParentAutofocusables", () => $bd49efae73506932$export$853fa94d922e78b9);

var $a9Isk = parcelRequire("a9Isk");

var $ady3j = parcelRequire("ady3j");

var $lHtVL = parcelRequire("lHtVL");
var $bd49efae73506932$var$queryTabbables = (0, $lHtVL.tabbables).join(',');
var $bd49efae73506932$var$queryGuardTabbables = "".concat($bd49efae73506932$var$queryTabbables, ", [data-focus-guard]");
var $bd49efae73506932$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $ady3j.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $bd49efae73506932$var$queryGuardTabbables : $bd49efae73506932$var$queryTabbables) ? [
            child
        ] : [], $bd49efae73506932$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $bd49efae73506932$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $bd49efae73506932$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $bd49efae73506932$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $bd49efae73506932$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $bd49efae73506932$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $ady3j.toArray)(parent.parentNode.querySelectorAll($bd49efae73506932$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $bd49efae73506932$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $a9Isk.FOCUS_AUTO), "]"));
    return (0, $ady3j.toArray)(parentFocus).map(function(node) {
        return $bd49efae73506932$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRegister("lHtVL", function(module, exports) {
$parcel$export(module.exports, "tabbables", () => $fcc4d4b8545dd10c$export$8555f4622e95784);
/**
 * list of the object to be considered as focusable
 */ var $fcc4d4b8545dd10c$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];

});




parcelRegister("gWC5V", function(module, exports) {
$parcel$export(module.exports, "expandFocusableNodes", () => $c55f9cebdb24174a$export$f89ac71e91767111);

var $hwzGt = parcelRequire("hwzGt");

var $k3Vqr = parcelRequire("k3Vqr");

var $eRdn6 = parcelRequire("eRdn6");

var $2Tuzr = parcelRequire("2Tuzr");

var $gfzXb = parcelRequire("gfzXb");
var $c55f9cebdb24174a$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $hwzGt.getAllAffectedNodes)(topNode).filter((0, $k3Vqr.isNotAGuard));
    var commonParent = (0, $eRdn6.getTopCommonParent)(topNode, topNode, entries);
    var outerNodes = (0, $2Tuzr.orderByTabIndex)((0, $gfzXb.getFocusables)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $gfzXb.getFocusables)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $k3Vqr.isGuard)(node)
        };
    });
};

});
parcelRegister("hwzGt", function(module, exports) {
$parcel$export(module.exports, "getAllAffectedNodes", () => $cc211af334b43a48$export$7e87c4720b9b279b);

var $a9Isk = parcelRequire("a9Isk");

var $ady3j = parcelRequire("ady3j");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $cc211af334b43a48$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $cc211af334b43a48$var$getTopParent = function(node) {
    return node.parentNode ? $cc211af334b43a48$var$getTopParent(node.parentNode) : node;
};
var $cc211af334b43a48$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $ady3j.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $a9Isk.FOCUS_GROUP));
        acc.push.apply(acc, group ? $cc211af334b43a48$var$filterNested((0, $ady3j.toArray)($cc211af334b43a48$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $a9Isk.FOCUS_GROUP), "=\"").concat(group, "\"]:not([").concat((0, $a9Isk.FOCUS_DISABLED), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

});

parcelRegister("eRdn6", function(module, exports) {
$parcel$export(module.exports, "getTopCommonParent", () => $ad10633a795569ac$export$a9a7252b5f2e280e);
$parcel$export(module.exports, "allParentAutofocusables", () => $ad10633a795569ac$export$8f99714c70a37db1);

var $4YVKI = parcelRequire("4YVKI");

var $ady3j = parcelRequire("ady3j");
var $ad10633a795569ac$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $ad10633a795569ac$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $ad10633a795569ac$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $ad10633a795569ac$var$getParents(nodeA);
    var parentsB = $ad10633a795569ac$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $ad10633a795569ac$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $ady3j.asArray)(baseActiveElement);
    var leftEntries = (0, $ady3j.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $ad10633a795569ac$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $ad10633a795569ac$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $4YVKI.contains)(common, topCommon)) topCommon = common;
                else topCommon = $ad10633a795569ac$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $ad10633a795569ac$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $4YVKI.parentAutofocusables)(node, visibilityCache));
    }, []);
};

});


parcelRegister("738X1", function(module, exports) {
$parcel$export(module.exports, "focusNextElement", () => $521fc1b3da6a3f71$export$3b0237e8566c8d65);
$parcel$export(module.exports, "focusPrevElement", () => $521fc1b3da6a3f71$export$33b47db07a82b2fb);
$parcel$export(module.exports, "focusFirstElement", () => $521fc1b3da6a3f71$export$2a791d8097a66406);
$parcel$export(module.exports, "focusLastElement", () => $521fc1b3da6a3f71$export$6a79073ddabfd6c3);

var $4E2yD = parcelRequire("4E2yD");

var $4YVKI = parcelRequire("4YVKI");

var $ady3j = parcelRequire("ady3j");
var $521fc1b3da6a3f71$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = (0, $ady3j.asArray)(scope);
    if (shards.every(function(shard) {
        return !(0, $4YVKI.contains)(shard, element);
    })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables ? (0, $4YVKI.getTabbableNodes)(shards, new Map()) : (0, $4YVKI.getFocusableNodes)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $521fc1b3da6a3f71$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $4YVKI.getTabbableNodes)((0, $ady3j.asArray)(shards), new Map()) : (0, $4YVKI.getFocusableNodes)((0, $ady3j.asArray)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $521fc1b3da6a3f71$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $521fc1b3da6a3f71$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $521fc1b3da6a3f71$var$defaultOptions(options);
    var solution = $521fc1b3da6a3f71$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $4E2yD.focusOn)(target.node, newOptions.focusOptions);
};
var $521fc1b3da6a3f71$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $521fc1b3da6a3f71$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $521fc1b3da6a3f71$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $521fc1b3da6a3f71$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $521fc1b3da6a3f71$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $521fc1b3da6a3f71$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $4E2yD.focusOn)(node.node, options.focusOptions);
};
var $521fc1b3da6a3f71$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $521fc1b3da6a3f71$var$pickBoundary(scope, options, 'first');
};
var $521fc1b3da6a3f71$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $521fc1b3da6a3f71$var$pickBoundary(scope, options, 'last');
};

});
parcelRegister("4E2yD", function(module, exports) {
$parcel$export(module.exports, "focusOn", () => $361ce1b8c2cd8208$export$c12b3da842c43a8);
var $361ce1b8c2cd8208$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};

});


parcelRegister("chs63", function(module, exports) {
$parcel$export(module.exports, "focusInside", () => $8f0cddf89bdfad1b$export$20115f8da7baa6fa);

var $4YVKI = parcelRequire("4YVKI");

var $hwzGt = parcelRequire("hwzGt");

var $ady3j = parcelRequire("ady3j");

var $dSYXr = parcelRequire("dSYXr");
var $8f0cddf89bdfad1b$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $8f0cddf89bdfad1b$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $ady3j.toArray)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $8f0cddf89bdfad1b$var$focusInFrame(node, activeElement);
    }));
};
var $8f0cddf89bdfad1b$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $dSYXr.getActiveElement)((0, $ady3j.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $hwzGt.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $4YVKI.contains)(node, activeElement) || $8f0cddf89bdfad1b$var$focusInsideIframe(node, activeElement);
    });
};

});
parcelRegister("dSYXr", function(module, exports) {
$parcel$export(module.exports, "getActiveElement", () => $a1bf9a6baf43edf3$export$cd4e5573fbe2b576);
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $3yce2 = parcelRequire("3yce2");
var $a1bf9a6baf43edf3$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $a1bf9a6baf43edf3$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $3yce2.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $a1bf9a6baf43edf3$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};

});
parcelRegister("3yce2", function(module, exports) {
$parcel$export(module.exports, "safeProbe", () => $295e07c6e2e5c92a$export$78d20aae35adef88);
var $295e07c6e2e5c92a$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

});



parcelRegister("75ruL", function(module, exports) {
$parcel$export(module.exports, "focusIsHidden", () => $528e54078796510d$export$be6b21806d3fd485);

var $a9Isk = parcelRequire("a9Isk");

var $4YVKI = parcelRequire("4YVKI");

var $ady3j = parcelRequire("ady3j");

var $dSYXr = parcelRequire("dSYXr");
var $528e54078796510d$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $dSYXr.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $ady3j.toArray)(inDocument.querySelectorAll("[".concat((0, $a9Isk.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $4YVKI.contains)(node, activeElement);
    });
};

});

parcelRegister("cHP2I", function(module, exports) {
$parcel$export(module.exports, "moveFocusInside", () => (parcelRequire("i8qpR")).moveFocusInside);

var $a9Isk = parcelRequire("a9Isk");

var $chs63 = parcelRequire("chs63");

var $75ruL = parcelRequire("75ruL");


var $gWC5V = parcelRequire("gWC5V");

var $i8qpR = parcelRequire("i8qpR");

var $3LvY8 = parcelRequire("3LvY8");

var $738X1 = parcelRequire("738X1");

var $4YVKI = parcelRequire("4YVKI");
/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $94011839a8ef1fc4$export$1a988e7317c65621 = $a9Isk;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $94011839a8ef1fc4$var$deprecated_default_moveFocusInside = (0, $i8qpR.moveFocusInside);
var $94011839a8ef1fc4$export$2e2bcd8739ae039 //
 = $94011839a8ef1fc4$var$deprecated_default_moveFocusInside;

});
parcelRegister("i8qpR", function(module, exports) {
$parcel$export(module.exports, "moveFocusInside", () => $d33d77039de67bde$export$cd599851e879a025);

var $4E2yD = parcelRequire("4E2yD");

var $401iO = parcelRequire("401iO");
var $d33d77039de67bde$var$guardCount = 0;
var $d33d77039de67bde$var$lockDisabled = false;
var $d33d77039de67bde$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $401iO.focusSolver)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($d33d77039de67bde$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($d33d77039de67bde$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $d33d77039de67bde$var$lockDisabled = true;
            setTimeout(function() {
                $d33d77039de67bde$var$lockDisabled = false;
            }, 1);
            return;
        }
        $d33d77039de67bde$var$guardCount++;
        (0, $4E2yD.focusOn)(focusable.node, options.focusOptions);
        $d33d77039de67bde$var$guardCount--;
    }
};

});
parcelRegister("401iO", function(module, exports) {
$parcel$export(module.exports, "focusSolver", () => $2e982c204732a835$export$305758c744b57f6f);

var $3LNgr = parcelRequire("3LNgr");

var $4YVKI = parcelRequire("4YVKI");

var $hwzGt = parcelRequire("hwzGt");

var $ady3j = parcelRequire("ady3j");

var $eunIZ = parcelRequire("eunIZ");

var $dSYXr = parcelRequire("dSYXr");

var $k3Vqr = parcelRequire("k3Vqr");

var $eRdn6 = parcelRequire("eRdn6");
var $2e982c204732a835$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $k3Vqr.isDefined));
};
var $2e982c204732a835$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $dSYXr.getActiveElement)((0, $ady3j.asArray)(topNode).length > 0 ? document : (0, $ady3j.getFirst)(topNode).ownerDocument);
    var entries = (0, $hwzGt.getAllAffectedNodes)(topNode).filter((0, $k3Vqr.isNotAGuard));
    var commonParent = (0, $eRdn6.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $4YVKI.getFocusableNodes)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $k3Vqr.isNotAGuard)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $4YVKI.getFocusableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $2e982c204732a835$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $3LNgr.newFocus)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $3LNgr.NEW_FOCUS)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $eunIZ.pickAutofocus)(anyFocusable, innerTabbable, (0, $eRdn6.allParentAutofocusables)(entries, visibilityCache)) || (0, $eunIZ.pickAutofocus)(anyFocusable, innerFocusables, (0, $eRdn6.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

});
parcelRegister("3LNgr", function(module, exports) {
$parcel$export(module.exports, "NEW_FOCUS", () => $2bebf9b6d8246224$export$85710b12cf912438);
$parcel$export(module.exports, "newFocus", () => $2bebf9b6d8246224$export$65842178e9bb4205);

var $cLEEN = parcelRequire("cLEEN");

var $lqX84 = parcelRequire("lqX84");

var $k3Vqr = parcelRequire("k3Vqr");
var $2bebf9b6d8246224$export$85710b12cf912438 = 'NEW_FOCUS';
var $2bebf9b6d8246224$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $k3Vqr.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $2bebf9b6d8246224$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $2bebf9b6d8246224$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $cLEEN.correctNodes)(outerNodes);
    var currentFocusableIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var previousFocusableIndex = lastNode ? correctedNodes.indexOf(lastNode) : currentFocusableIndex;
    var tabbableNodes = correctedNodes.filter(function(node) {
        return node.tabIndex >= 0;
    });
    var currentTabbableIndex = activeElement !== undefined ? tabbableNodes.indexOf(activeElement) : -1;
    var previousTabbableIndex = lastNode ? tabbableNodes.indexOf(lastNode) : currentTabbableIndex;
    var focusIndexDiff = currentTabbableIndex >= 0 && previousTabbableIndex >= 0 ? previousTabbableIndex - currentTabbableIndex : previousFocusableIndex - currentFocusableIndex;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $lqX84.pickFocusable)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $lqX84.pickFocusable)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(focusIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

});
parcelRegister("cLEEN", function(module, exports) {
$parcel$export(module.exports, "correctNode", () => $94b96979054b176f$export$5261662167ad7ced);
$parcel$export(module.exports, "correctNodes", () => $94b96979054b176f$export$4a5a72a7124e45f9);

var $k3Vqr = parcelRequire("k3Vqr");
var $94b96979054b176f$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $k3Vqr.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $94b96979054b176f$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $k3Vqr.isRadioElement)(node) && node.name) return $94b96979054b176f$var$findSelectedRadio(node, nodes);
    return node;
};
var $94b96979054b176f$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($94b96979054b176f$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

});

parcelRegister("lqX84", function(module, exports) {
$parcel$export(module.exports, "pickFirstFocus", () => $f9a9e480c51d51f0$export$f4e86cfa0679b9cc);
$parcel$export(module.exports, "pickFocusable", () => $f9a9e480c51d51f0$export$e06728ee87c96122);

var $cLEEN = parcelRequire("cLEEN");
var $f9a9e480c51d51f0$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $cLEEN.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $f9a9e480c51d51f0$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $cLEEN.correctNode)(node, nodes));
};

});


parcelRegister("eunIZ", function(module, exports) {
$parcel$export(module.exports, "pickAutofocus", () => $a8c6453a3667ca33$export$cfb742983e257555);

var $4YVKI = parcelRequire("4YVKI");

var $lqX84 = parcelRequire("lqX84");

var $k3Vqr = parcelRequire("k3Vqr");
var $a8c6453a3667ca33$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $k3Vqr.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $a8c6453a3667ca33$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $4YVKI.filterAutoFocusable)(nodes.filter($a8c6453a3667ca33$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $lqX84.pickFirstFocus)(autoFocusable);
    return (0, $lqX84.pickFirstFocus)((0, $4YVKI.filterAutoFocusable)(orderedNodes));
};

});




parcelRegister("65prp", function(module, exports) {
$parcel$export(module.exports, "deferAction", () => $46e6f1c10d391412$export$6523025722806278);
$parcel$export(module.exports, "extractRef", () => $46e6f1c10d391412$export$c613fed06e332533);
function $46e6f1c10d391412$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $46e6f1c10d391412$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $46e6f1c10d391412$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});




parcelRegister("3FlkA", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $c6xho = parcelRequire("c6xho");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $2ab5bf555a107c00$var$_interopRequireDefault($c6xho).default;
    }
});

var $epxCz = parcelRequire("epxCz");
Object.defineProperty(module.exports, 'TouchScrollable', {
    enumerable: true,
    get: function get() {
        return $epxCz.TouchScrollable;
    }
});
function $2ab5bf555a107c00$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("c6xho", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8cffdc2bd0697df9$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5FkrB = parcelRequire("5FkrB");
var $8cffdc2bd0697df9$var$_react2 = $8cffdc2bd0697df9$var$_interopRequireDefault($5FkrB);

var $61SNt = parcelRequire("61SNt");

var $epxCz = parcelRequire("epxCz");

var $4dm8g = parcelRequire("4dm8g");
var $8cffdc2bd0697df9$var$_withLockSheet2 = $8cffdc2bd0697df9$var$_interopRequireDefault($4dm8g);

var $8KBm9 = parcelRequire("8KBm9");
var $8cffdc2bd0697df9$var$_withTouchListeners2 = $8cffdc2bd0697df9$var$_interopRequireDefault($8KBm9);

var $jmnQv = parcelRequire("jmnQv");
function $8cffdc2bd0697df9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8cffdc2bd0697df9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8cffdc2bd0697df9$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8cffdc2bd0697df9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $8cffdc2bd0697df9$var$ScrollLock = function(_PureComponent) {
    $8cffdc2bd0697df9$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $8cffdc2bd0697df9$var$_classCallCheck(this, ScrollLock);
        return $8cffdc2bd0697df9$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $8cffdc2bd0697df9$var$_createClass(ScrollLock, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$61SNt.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return children ? $8cffdc2bd0697df9$var$_react2.default.createElement($epxCz.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($5FkrB.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $8cffdc2bd0697df9$var$compose = (0, $jmnQv.pipe)($8cffdc2bd0697df9$var$_withTouchListeners2.default, $8cffdc2bd0697df9$var$_withLockSheet2.default);
var $8cffdc2bd0697df9$var$SheetLock = $8cffdc2bd0697df9$var$compose($8cffdc2bd0697df9$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $8cffdc2bd0697df9$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $8cffdc2bd0697df9$var$_react2.default.createElement($8cffdc2bd0697df9$var$SheetLock, props) : props.children;
};
$8cffdc2bd0697df9$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
module.exports.default = $8cffdc2bd0697df9$var$LockToggle;

});
parcelRegister("61SNt", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});

parcelRegister("epxCz", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TouchScrollable = undefined;
var $a7dd7aedb3dfffe8$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $a7dd7aedb3dfffe8$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5FkrB = parcelRequire("5FkrB");

var $61SNt = parcelRequire("61SNt");

var $jmnQv = parcelRequire("jmnQv");
function $a7dd7aedb3dfffe8$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $a7dd7aedb3dfffe8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a7dd7aedb3dfffe8$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a7dd7aedb3dfffe8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $a7dd7aedb3dfffe8$var$TouchScrollable = module.exports.TouchScrollable = function(_PureComponent) {
    $a7dd7aedb3dfffe8$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $a7dd7aedb3dfffe8$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $a7dd7aedb3dfffe8$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $a7dd7aedb3dfffe8$var$_possibleConstructorReturn(_this, _ret);
    }
    $a7dd7aedb3dfffe8$var$_createClass(TouchScrollable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$61SNt.canUseEventListeners) return;
                this.scrollableArea.addEventListener('touchstart', $jmnQv.preventInertiaScroll, $jmnQv.listenerOptions);
                this.scrollableArea.addEventListener('touchmove', $jmnQv.allowTouchMove, $jmnQv.listenerOptions);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!$61SNt.canUseEventListeners) return;
                this.scrollableArea.removeEventListener('touchstart', $jmnQv.preventInertiaScroll, $jmnQv.listenerOptions);
                this.scrollableArea.removeEventListener('touchmove', $jmnQv.allowTouchMove, $jmnQv.listenerOptions);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, rest = $a7dd7aedb3dfffe8$var$_objectWithoutProperties(_props, [
                    'children'
                ]);
                return typeof children === 'function' ? children(this.getScrollableArea) : (0, $5FkrB.cloneElement)(children, $a7dd7aedb3dfffe8$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($5FkrB.PureComponent);

});
parcelRegister("jmnQv", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipe = module.exports.listenerOptions = undefined;
module.exports.preventTouchMove = $e18291ad983e38c7$var$preventTouchMove;
module.exports.allowTouchMove = $e18291ad983e38c7$var$allowTouchMove;
module.exports.preventInertiaScroll = $e18291ad983e38c7$var$preventInertiaScroll;
module.exports.isTouchDevice = $e18291ad983e38c7$var$isTouchDevice;
module.exports.camelToKebab = $e18291ad983e38c7$var$camelToKebab;
module.exports.parse = $e18291ad983e38c7$var$parse;
module.exports.getPadding = $e18291ad983e38c7$var$getPadding;
module.exports.getWindowHeight = $e18291ad983e38c7$var$getWindowHeight;
module.exports.getDocumentHeight = $e18291ad983e38c7$var$getDocumentHeight;
module.exports.makeStyleTag = $e18291ad983e38c7$var$makeStyleTag;
module.exports.injectStyles = $e18291ad983e38c7$var$injectStyles;
module.exports.insertStyleTag = $e18291ad983e38c7$var$insertStyleTag;

var $61SNt = parcelRequire("61SNt");
var $e18291ad983e38c7$var$listenerOptions = module.exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $e18291ad983e38c7$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $e18291ad983e38c7$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $e18291ad983e38c7$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $e18291ad983e38c7$var$isTouchDevice() {
    if (!$61SNt.canUseDOM) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $e18291ad983e38c7$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $e18291ad983e38c7$var$parse(val) {
    return isNaN(val) ? val : val + 'px';
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $e18291ad983e38c7$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $e18291ad983e38c7$var$pipe = module.exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($e18291ad983e38c7$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $e18291ad983e38c7$var$getPadding() {
    if (!$61SNt.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $e18291ad983e38c7$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($61SNt.canUseDOM) return window.innerHeight * multiplier;
}
function $e18291ad983e38c7$var$getDocumentHeight() {
    if ($61SNt.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $e18291ad983e38c7$var$makeStyleTag() {
    if (!$61SNt.canUseDOM) return;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    tag.setAttribute('data-react-scrolllock', '');
    return tag;
}
function $e18291ad983e38c7$var$injectStyles(tag, css) {
    if (!$61SNt.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $e18291ad983e38c7$var$insertStyleTag(tag) {
    if (!$61SNt.canUseDOM) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}

});


parcelRegister("4dm8g", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $31198b58f382798e$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $31198b58f382798e$var$withLockSheet;

var $5FkrB = parcelRequire("5FkrB");
var $31198b58f382798e$var$_react2 = $31198b58f382798e$var$_interopRequireDefault($5FkrB);

var $jmnQv = parcelRequire("jmnQv");
function $31198b58f382798e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $31198b58f382798e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $31198b58f382798e$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $31198b58f382798e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $31198b58f382798e$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $31198b58f382798e$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $31198b58f382798e$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $31198b58f382798e$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $jmnQv.makeStyleTag)();
                if (!sheet) return;
                (0, $jmnQv.injectStyles)(sheet, styles);
                (0, $jmnQv.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $jmnQv.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $jmnQv.getPadding)() : null;
                var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                return styles;
            }, _temp), $31198b58f382798e$var$_possibleConstructorReturn(_this, _ret);
        }
        $31198b58f382798e$var$_createClass(SheetProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: 'removeSheet',
                value: function removeSheet() {
                    if (!this.sheet) return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $31198b58f382798e$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($5FkrB.PureComponent);
}

});

parcelRegister("8KBm9", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $65ef98c39640e000$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $65ef98c39640e000$var$withTouchListeners;

var $5FkrB = parcelRequire("5FkrB");
var $65ef98c39640e000$var$_react2 = $65ef98c39640e000$var$_interopRequireDefault($5FkrB);

var $61SNt = parcelRequire("61SNt");

var $jmnQv = parcelRequire("jmnQv");
function $65ef98c39640e000$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $65ef98c39640e000$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $65ef98c39640e000$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $65ef98c39640e000$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $65ef98c39640e000$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $65ef98c39640e000$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $65ef98c39640e000$var$_classCallCheck(this, TouchProvider);
            return $65ef98c39640e000$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $65ef98c39640e000$var$_createClass(TouchProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!$61SNt.canUseDOM || !(0, $jmnQv.isTouchDevice)()) return;
                    document.addEventListener('touchmove', $jmnQv.preventTouchMove, $jmnQv.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!$61SNt.canUseDOM || !(0, $jmnQv.isTouchDevice)()) return;
                    document.removeEventListener('touchmove', $jmnQv.preventTouchMove, $jmnQv.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $65ef98c39640e000$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($5FkrB.PureComponent);
}

});



parcelRegister("7KfP5", function(module, exports) {
$parcel$export(module.exports, "Buffer", () => $5a391a6961854a1b$export$a143d493d941bafc, (v) => $5a391a6961854a1b$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $5a391a6961854a1b$export$e4cf37d7f6fb9e0a, (v) => $5a391a6961854a1b$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $5a391a6961854a1b$export$f99ded8fe4b79145, (v) => $5a391a6961854a1b$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $5a391a6961854a1b$export$599f31c3813fae4d, (v) => $5a391a6961854a1b$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $5a391a6961854a1b$export$a143d493d941bafc;
var $5a391a6961854a1b$export$e4cf37d7f6fb9e0a;
var $5a391a6961854a1b$export$f99ded8fe4b79145;
var $5a391a6961854a1b$export$599f31c3813fae4d;
'use strict';

var $dgRjT = parcelRequire("dgRjT");

var $ixcFU = parcelRequire("ixcFU");
var $5a391a6961854a1b$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$5a391a6961854a1b$export$a143d493d941bafc = $5a391a6961854a1b$var$Buffer;
$5a391a6961854a1b$export$e4cf37d7f6fb9e0a = $5a391a6961854a1b$var$SlowBuffer;
$5a391a6961854a1b$export$f99ded8fe4b79145 = 50;
var $5a391a6961854a1b$var$K_MAX_LENGTH = 0x7fffffff;
$5a391a6961854a1b$export$599f31c3813fae4d = $5a391a6961854a1b$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $5a391a6961854a1b$var$Buffer.TYPED_ARRAY_SUPPORT = $5a391a6961854a1b$var$typedArraySupport();
if (!$5a391a6961854a1b$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $5a391a6961854a1b$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($5a391a6961854a1b$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$5a391a6961854a1b$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($5a391a6961854a1b$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$5a391a6961854a1b$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $5a391a6961854a1b$var$createBuffer(length) {
    if (length > $5a391a6961854a1b$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $5a391a6961854a1b$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $5a391a6961854a1b$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $5a391a6961854a1b$var$allocUnsafe(arg);
    }
    return $5a391a6961854a1b$var$from(arg, encodingOrOffset, length);
}
$5a391a6961854a1b$var$Buffer.poolSize = 8192; // not used by this implementation
function $5a391a6961854a1b$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $5a391a6961854a1b$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $5a391a6961854a1b$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($5a391a6961854a1b$var$isInstance(value, ArrayBuffer) || value && $5a391a6961854a1b$var$isInstance(value.buffer, ArrayBuffer)) return $5a391a6961854a1b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($5a391a6961854a1b$var$isInstance(value, SharedArrayBuffer) || value && $5a391a6961854a1b$var$isInstance(value.buffer, SharedArrayBuffer))) return $5a391a6961854a1b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $5a391a6961854a1b$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $5a391a6961854a1b$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $5a391a6961854a1b$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $5a391a6961854a1b$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $5a391a6961854a1b$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($5a391a6961854a1b$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($5a391a6961854a1b$var$Buffer, Uint8Array);
function $5a391a6961854a1b$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $5a391a6961854a1b$var$alloc(size, fill, encoding) {
    $5a391a6961854a1b$var$assertSize(size);
    if (size <= 0) return $5a391a6961854a1b$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $5a391a6961854a1b$var$createBuffer(size).fill(fill, encoding) : $5a391a6961854a1b$var$createBuffer(size).fill(fill);
    return $5a391a6961854a1b$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $5a391a6961854a1b$var$Buffer.alloc = function(size, fill, encoding) {
    return $5a391a6961854a1b$var$alloc(size, fill, encoding);
};
function $5a391a6961854a1b$var$allocUnsafe(size) {
    $5a391a6961854a1b$var$assertSize(size);
    return $5a391a6961854a1b$var$createBuffer(size < 0 ? 0 : $5a391a6961854a1b$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $5a391a6961854a1b$var$Buffer.allocUnsafe = function(size) {
    return $5a391a6961854a1b$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $5a391a6961854a1b$var$Buffer.allocUnsafeSlow = function(size) {
    return $5a391a6961854a1b$var$allocUnsafe(size);
};
function $5a391a6961854a1b$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$5a391a6961854a1b$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $5a391a6961854a1b$var$byteLength(string, encoding) | 0;
    var buf = $5a391a6961854a1b$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $5a391a6961854a1b$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $5a391a6961854a1b$var$checked(array.length) | 0;
    var buf = $5a391a6961854a1b$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $5a391a6961854a1b$var$fromArrayView(arrayView) {
    if ($5a391a6961854a1b$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $5a391a6961854a1b$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $5a391a6961854a1b$var$fromArrayLike(arrayView);
}
function $5a391a6961854a1b$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $5a391a6961854a1b$var$Buffer.prototype);
    return buf;
}
function $5a391a6961854a1b$var$fromObject(obj) {
    if ($5a391a6961854a1b$var$Buffer.isBuffer(obj)) {
        var len = $5a391a6961854a1b$var$checked(obj.length) | 0;
        var buf = $5a391a6961854a1b$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $5a391a6961854a1b$var$numberIsNaN(obj.length)) return $5a391a6961854a1b$var$createBuffer(0);
        return $5a391a6961854a1b$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $5a391a6961854a1b$var$fromArrayLike(obj.data);
}
function $5a391a6961854a1b$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $5a391a6961854a1b$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $5a391a6961854a1b$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $5a391a6961854a1b$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $5a391a6961854a1b$var$Buffer.alloc(+length);
}
$5a391a6961854a1b$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $5a391a6961854a1b$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$5a391a6961854a1b$var$Buffer.compare = function compare(a, b) {
    if ($5a391a6961854a1b$var$isInstance(a, Uint8Array)) a = $5a391a6961854a1b$var$Buffer.from(a, a.offset, a.byteLength);
    if ($5a391a6961854a1b$var$isInstance(b, Uint8Array)) b = $5a391a6961854a1b$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$5a391a6961854a1b$var$Buffer.isBuffer(a) || !$5a391a6961854a1b$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$5a391a6961854a1b$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$5a391a6961854a1b$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $5a391a6961854a1b$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $5a391a6961854a1b$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($5a391a6961854a1b$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $5a391a6961854a1b$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$5a391a6961854a1b$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $5a391a6961854a1b$var$byteLength(string, encoding) {
    if ($5a391a6961854a1b$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $5a391a6961854a1b$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $5a391a6961854a1b$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $5a391a6961854a1b$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $5a391a6961854a1b$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$5a391a6961854a1b$var$Buffer.byteLength = $5a391a6961854a1b$var$byteLength;
function $5a391a6961854a1b$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $5a391a6961854a1b$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $5a391a6961854a1b$var$utf8Slice(this, start, end);
        case 'ascii':
            return $5a391a6961854a1b$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $5a391a6961854a1b$var$latin1Slice(this, start, end);
        case 'base64':
            return $5a391a6961854a1b$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $5a391a6961854a1b$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$5a391a6961854a1b$var$Buffer.prototype._isBuffer = true;
function $5a391a6961854a1b$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$5a391a6961854a1b$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$5a391a6961854a1b$var$swap(this, i, i + 1);
    return this;
};
$5a391a6961854a1b$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $5a391a6961854a1b$var$swap(this, i, i + 3);
        $5a391a6961854a1b$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$5a391a6961854a1b$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $5a391a6961854a1b$var$swap(this, i, i + 7);
        $5a391a6961854a1b$var$swap(this, i + 1, i + 6);
        $5a391a6961854a1b$var$swap(this, i + 2, i + 5);
        $5a391a6961854a1b$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$5a391a6961854a1b$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $5a391a6961854a1b$var$utf8Slice(this, 0, length);
    return $5a391a6961854a1b$var$slowToString.apply(this, arguments);
};
$5a391a6961854a1b$var$Buffer.prototype.toLocaleString = $5a391a6961854a1b$var$Buffer.prototype.toString;
$5a391a6961854a1b$var$Buffer.prototype.equals = function equals(b) {
    if (!$5a391a6961854a1b$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $5a391a6961854a1b$var$Buffer.compare(this, b) === 0;
};
$5a391a6961854a1b$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $5a391a6961854a1b$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($5a391a6961854a1b$var$customInspectSymbol) $5a391a6961854a1b$var$Buffer.prototype[$5a391a6961854a1b$var$customInspectSymbol] = $5a391a6961854a1b$var$Buffer.prototype.inspect;
$5a391a6961854a1b$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($5a391a6961854a1b$var$isInstance(target, Uint8Array)) target = $5a391a6961854a1b$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$5a391a6961854a1b$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $5a391a6961854a1b$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset; // Coerce to Number.
    if ($5a391a6961854a1b$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $5a391a6961854a1b$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($5a391a6961854a1b$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $5a391a6961854a1b$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF; // Search for a byte value [0-255]
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $5a391a6961854a1b$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $5a391a6961854a1b$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$5a391a6961854a1b$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$5a391a6961854a1b$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $5a391a6961854a1b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$5a391a6961854a1b$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $5a391a6961854a1b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $5a391a6961854a1b$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($5a391a6961854a1b$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $5a391a6961854a1b$var$utf8Write(buf, string, offset, length) {
    return $5a391a6961854a1b$var$blitBuffer($5a391a6961854a1b$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $5a391a6961854a1b$var$asciiWrite(buf, string, offset, length) {
    return $5a391a6961854a1b$var$blitBuffer($5a391a6961854a1b$var$asciiToBytes(string), buf, offset, length);
}
function $5a391a6961854a1b$var$base64Write(buf, string, offset, length) {
    return $5a391a6961854a1b$var$blitBuffer($5a391a6961854a1b$var$base64ToBytes(string), buf, offset, length);
}
function $5a391a6961854a1b$var$ucs2Write(buf, string, offset, length) {
    return $5a391a6961854a1b$var$blitBuffer($5a391a6961854a1b$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$5a391a6961854a1b$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $5a391a6961854a1b$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $5a391a6961854a1b$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $5a391a6961854a1b$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $5a391a6961854a1b$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $5a391a6961854a1b$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$5a391a6961854a1b$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $5a391a6961854a1b$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $dgRjT.fromByteArray(buf);
    else return $dgRjT.fromByteArray(buf.slice(start, end));
}
function $5a391a6961854a1b$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $5a391a6961854a1b$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $5a391a6961854a1b$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $5a391a6961854a1b$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $5a391a6961854a1b$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $5a391a6961854a1b$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $5a391a6961854a1b$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $5a391a6961854a1b$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $5a391a6961854a1b$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $5a391a6961854a1b$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $5a391a6961854a1b$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$5a391a6961854a1b$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $5a391a6961854a1b$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $5a391a6961854a1b$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$5a391a6961854a1b$var$Buffer.prototype.readUintLE = $5a391a6961854a1b$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$5a391a6961854a1b$var$Buffer.prototype.readUintBE = $5a391a6961854a1b$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$5a391a6961854a1b$var$Buffer.prototype.readUint8 = $5a391a6961854a1b$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$5a391a6961854a1b$var$Buffer.prototype.readUint16LE = $5a391a6961854a1b$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$5a391a6961854a1b$var$Buffer.prototype.readUint16BE = $5a391a6961854a1b$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$5a391a6961854a1b$var$Buffer.prototype.readUint32LE = $5a391a6961854a1b$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$5a391a6961854a1b$var$Buffer.prototype.readUint32BE = $5a391a6961854a1b$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$5a391a6961854a1b$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5a391a6961854a1b$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5a391a6961854a1b$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$5a391a6961854a1b$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5a391a6961854a1b$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5a391a6961854a1b$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$5a391a6961854a1b$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$5a391a6961854a1b$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 4, this.length);
    return $ixcFU.read(this, offset, true, 23, 4);
};
$5a391a6961854a1b$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 4, this.length);
    return $ixcFU.read(this, offset, false, 23, 4);
};
$5a391a6961854a1b$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 8, this.length);
    return $ixcFU.read(this, offset, true, 52, 8);
};
$5a391a6961854a1b$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 8, this.length);
    return $ixcFU.read(this, offset, false, 52, 8);
};
function $5a391a6961854a1b$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$5a391a6961854a1b$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$5a391a6961854a1b$var$Buffer.prototype.writeUintLE = $5a391a6961854a1b$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5a391a6961854a1b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5a391a6961854a1b$var$Buffer.prototype.writeUintBE = $5a391a6961854a1b$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5a391a6961854a1b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5a391a6961854a1b$var$Buffer.prototype.writeUint8 = $5a391a6961854a1b$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$5a391a6961854a1b$var$Buffer.prototype.writeUint16LE = $5a391a6961854a1b$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5a391a6961854a1b$var$Buffer.prototype.writeUint16BE = $5a391a6961854a1b$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5a391a6961854a1b$var$Buffer.prototype.writeUint32LE = $5a391a6961854a1b$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$5a391a6961854a1b$var$Buffer.prototype.writeUint32BE = $5a391a6961854a1b$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$5a391a6961854a1b$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $5a391a6961854a1b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5a391a6961854a1b$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $5a391a6961854a1b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5a391a6961854a1b$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$5a391a6961854a1b$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5a391a6961854a1b$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5a391a6961854a1b$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$5a391a6961854a1b$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $5a391a6961854a1b$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $5a391a6961854a1b$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
    $ixcFU.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$5a391a6961854a1b$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $5a391a6961854a1b$var$writeFloat(this, value, offset, true, noAssert);
};
$5a391a6961854a1b$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $5a391a6961854a1b$var$writeFloat(this, value, offset, false, noAssert);
};
function $5a391a6961854a1b$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157e+308);
    $ixcFU.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$5a391a6961854a1b$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $5a391a6961854a1b$var$writeDouble(this, value, offset, true, noAssert);
};
$5a391a6961854a1b$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $5a391a6961854a1b$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$5a391a6961854a1b$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$5a391a6961854a1b$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$5a391a6961854a1b$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$5a391a6961854a1b$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $5a391a6961854a1b$var$Buffer.isBuffer(val) ? val : $5a391a6961854a1b$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $5a391a6961854a1b$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $5a391a6961854a1b$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($5a391a6961854a1b$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $5a391a6961854a1b$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $5a391a6961854a1b$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $5a391a6961854a1b$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $5a391a6961854a1b$var$base64ToBytes(str) {
    return $dgRjT.toByteArray($5a391a6961854a1b$var$base64clean(str));
}
function $5a391a6961854a1b$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $5a391a6961854a1b$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $5a391a6961854a1b$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $5a391a6961854a1b$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("dgRjT", function(module, exports) {
$parcel$export(module.exports, "toByteArray", () => $9a96212d3d126b36$export$d622b2ad8d90c771, (v) => $9a96212d3d126b36$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $9a96212d3d126b36$export$6100ba28696e12de, (v) => $9a96212d3d126b36$export$6100ba28696e12de = v);
var $9a96212d3d126b36$export$a48f0734ac7c2329;
var $9a96212d3d126b36$export$d622b2ad8d90c771;
var $9a96212d3d126b36$export$6100ba28696e12de;
'use strict';
$9a96212d3d126b36$export$a48f0734ac7c2329 = $9a96212d3d126b36$var$byteLength;
$9a96212d3d126b36$export$d622b2ad8d90c771 = $9a96212d3d126b36$var$toByteArray;
$9a96212d3d126b36$export$6100ba28696e12de = $9a96212d3d126b36$var$fromByteArray;
var $9a96212d3d126b36$var$lookup = [];
var $9a96212d3d126b36$var$revLookup = [];
var $9a96212d3d126b36$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $9a96212d3d126b36$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $9a96212d3d126b36$var$i = 0, $9a96212d3d126b36$var$len = $9a96212d3d126b36$var$code.length; $9a96212d3d126b36$var$i < $9a96212d3d126b36$var$len; ++$9a96212d3d126b36$var$i){
    $9a96212d3d126b36$var$lookup[$9a96212d3d126b36$var$i] = $9a96212d3d126b36$var$code[$9a96212d3d126b36$var$i];
    $9a96212d3d126b36$var$revLookup[$9a96212d3d126b36$var$code.charCodeAt($9a96212d3d126b36$var$i)] = $9a96212d3d126b36$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$9a96212d3d126b36$var$revLookup['-'.charCodeAt(0)] = 62;
$9a96212d3d126b36$var$revLookup['_'.charCodeAt(0)] = 63;
function $9a96212d3d126b36$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $9a96212d3d126b36$var$byteLength(b64) {
    var lens = $9a96212d3d126b36$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $9a96212d3d126b36$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $9a96212d3d126b36$var$toByteArray(b64) {
    var tmp;
    var lens = $9a96212d3d126b36$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $9a96212d3d126b36$var$Arr($9a96212d3d126b36$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $9a96212d3d126b36$var$revLookup[b64.charCodeAt(i)] << 18 | $9a96212d3d126b36$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $9a96212d3d126b36$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $9a96212d3d126b36$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $9a96212d3d126b36$var$revLookup[b64.charCodeAt(i)] << 2 | $9a96212d3d126b36$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $9a96212d3d126b36$var$revLookup[b64.charCodeAt(i)] << 10 | $9a96212d3d126b36$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $9a96212d3d126b36$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $9a96212d3d126b36$var$tripletToBase64(num) {
    return $9a96212d3d126b36$var$lookup[num >> 18 & 0x3F] + $9a96212d3d126b36$var$lookup[num >> 12 & 0x3F] + $9a96212d3d126b36$var$lookup[num >> 6 & 0x3F] + $9a96212d3d126b36$var$lookup[num & 0x3F];
}
function $9a96212d3d126b36$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($9a96212d3d126b36$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $9a96212d3d126b36$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($9a96212d3d126b36$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($9a96212d3d126b36$var$lookup[tmp >> 2] + $9a96212d3d126b36$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($9a96212d3d126b36$var$lookup[tmp >> 10] + $9a96212d3d126b36$var$lookup[tmp >> 4 & 0x3F] + $9a96212d3d126b36$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("ixcFU", function(module, exports) {
$parcel$export(module.exports, "read", () => $d7e5240a5359e1f9$export$aafa59e2e03f2942, (v) => $d7e5240a5359e1f9$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $d7e5240a5359e1f9$export$68d8715fc104d294, (v) => $d7e5240a5359e1f9$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $d7e5240a5359e1f9$export$aafa59e2e03f2942;
var $d7e5240a5359e1f9$export$68d8715fc104d294;
$d7e5240a5359e1f9$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$d7e5240a5359e1f9$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("8kEM5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11bb746989e6f2f05a6a45e4a2d4e804>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $610fd1f4fd211056$var$_react = $610fd1f4fd211056$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $610fd1f4fd211056$var$_baseNew = $610fd1f4fd211056$var$_interopRequireDefault((parcelRequire("4HGDC")));
function $610fd1f4fd211056$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $610fd1f4fd211056$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $610fd1f4fd211056$var$_react.default.createElement($610fd1f4fd211056$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 4.5 8.25 6.75 6 9 3.75 6.75 1.5 4.5"/>`,
        type: 'utility'
    }, props));
$610fd1f4fd211056$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $610fd1f4fd211056$var$_default = module.exports.default = $610fd1f4fd211056$var$ChevronDownIcon;

});
parcelRegister("4HGDC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("bCh0R")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("bCh0R")).Icon);

var $bCh0R = parcelRequire("bCh0R");

});
parcelRegister("bCh0R", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $875070b3dad420e8$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $875070b3dad420e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $dVGJk = parcelRequire("dVGJk");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $875070b3dad420e8$var$commonSVGStyles = (0, $74Zh5.css)({
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: 'currentColor'
    }
});
var $875070b3dad420e8$var$svgStyles = (0, $74Zh5.css)({
    color: 'currentColor',
    verticalAlign: 'bottom'
});
var $875070b3dad420e8$var$iconStyles = (0, $74Zh5.css)({
    display: 'inline-block',
    boxSizing: 'border-box',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
    paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
});
var $875070b3dad420e8$var$utilityIconStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-150, 12px)"
});
var $875070b3dad420e8$var$scaleStyles = (0, $74Zh5.css)({
    width: 'inherit',
    height: 'inherit'
});
/**
 * For windows high contrast mode
 */ var $875070b3dad420e8$var$baseHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        color: 'CanvasText',
        filter: 'grayscale(1)'
    }
});
var $875070b3dad420e8$var$scaleSize = (0, $74Zh5.css)({
    width: 'inherit',
    height: 'inherit'
});
var $875070b3dad420e8$var$sizeMap = {
    core: {
        none: (0, $74Zh5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $74Zh5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $74Zh5.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $74Zh5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $74Zh5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $875070b3dad420e8$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $875070b3dad420e8$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $875070b3dad420e8$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $dVGJk.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return (0, $74Zh5.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $875070b3dad420e8$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core'];
    var viewBoxPadding;
    if (props.type === 'utility') {
        var _props$spacing;
        viewBoxPadding = $875070b3dad420e8$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : 'none'];
    } else {
        var _props$spacing2;
        viewBoxPadding = $875070b3dad420e8$var$paddingMap['core'][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : 'none'];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = "\n<filter id=\"ds-newIconOpacityFilter\">\n  <feFlood flood-color=\"var(--ds-icon-disabled)\" />\n  <feComposite in2=\"SourceGraphic\" operator=\"in\" />\n</filter>\n<g filter=\"url(#ds-newIconOpacityFilter)\">\n  ".concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $74Zh5.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $875070b3dad420e8$var$iconStyles,
            $875070b3dad420e8$var$baseHcmStyles,
            shouldScale && $875070b3dad420e8$var$scaleStyles,
            props.type === 'utility' && $875070b3dad420e8$var$utilityIconStyles
        ]
    }, (0, $74Zh5.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $875070b3dad420e8$var$commonSVGStyles,
            $875070b3dad420e8$var$svgStyles,
            shouldScale ? $875070b3dad420e8$var$scaleSize : props.type === 'utility' ? $875070b3dad420e8$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : 'none'] : $875070b3dad420e8$var$sizeMap['core'][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : 'none']
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $875070b3dad420e8$export$2e2bcd8739ae039 = $875070b3dad420e8$export$f04a61298a47a40f;

});
parcelRegister("dVGJk", function(module, exports) {
$parcel$export(module.exports, "fg", () => $a241be86ed169352$export$b40ec24ac8275656);

var $e12PD = parcelRequire("e12PD");
function $a241be86ed169352$export$ba05d765b8392e5e(flagResolver) {
    (0, $e12PD.setBooleanResolver)(flagResolver);
}
function $a241be86ed169352$export$470e5c2be1411c89(name) {
    return (0, $e12PD.resolveBooleanFlag)(name);
}
function $a241be86ed169352$export$b40ec24ac8275656(name) {
    return (0, $e12PD.resolveBooleanFlag)(name);
}

});
parcelRegister("e12PD", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $a3435b09c67d965b$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $a3435b09c67d965b$export$6333b6aff9fc6275);

var $9dOvm = parcelRequire("9dOvm");

var $h973G = parcelRequire("h973G");

var $3ZMUU = parcelRequire("3ZMUU");
var $a3435b09c67d965b$var$pkgName = '@atlaskit/platform-feature-flags';
var $a3435b09c67d965b$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $a3435b09c67d965b$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $a3435b09c67d965b$var$ENV_ENABLE_PLATFORM_FF = $a3435b09c67d965b$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $a3435b09c67d965b$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $a3435b09c67d965b$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $a3435b09c67d965b$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $a3435b09c67d965b$var$ENV_ENABLE_PLATFORM_FF || $a3435b09c67d965b$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $a3435b09c67d965b$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $a3435b09c67d965b$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$a3435b09c67d965b$var$globalVar[$a3435b09c67d965b$export$7e41b1b2bdee3f98] = $a3435b09c67d965b$var$globalVar[$a3435b09c67d965b$export$7e41b1b2bdee3f98] || $a3435b09c67d965b$var$DEFAULT_PFF_GLOBAL;
function $a3435b09c67d965b$export$f2b591175b3e424c(resolver) {
    $a3435b09c67d965b$var$globalVar[$a3435b09c67d965b$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $a3435b09c67d965b$export$6333b6aff9fc6275(flagKey) {
    if ($a3435b09c67d965b$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $h973G.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $a3435b09c67d965b$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $a3435b09c67d965b$var$globalVar[$a3435b09c67d965b$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $a3435b09c67d965b$var$globalVar[$a3435b09c67d965b$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $9dOvm.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $a3435b09c67d965b$var$globalVar[$a3435b09c67d965b$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("h973G", function(module, exports) {
$parcel$export(module.exports, "debug", () => $c7b8c09689548c2d$export$1c9f709888824e05);
var $c7b8c09689548c2d$var$_process, $c7b8c09689548c2d$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $c7b8c09689548c2d$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($c7b8c09689548c2d$var$_process = globalThis.process) === null || $c7b8c09689548c2d$var$_process === void 0 || ($c7b8c09689548c2d$var$_process = $c7b8c09689548c2d$var$_process.env) === null || $c7b8c09689548c2d$var$_process === void 0 ? void 0 : $c7b8c09689548c2d$var$_process.JEST_WORKER_ID) !== undefined;
var $c7b8c09689548c2d$var$DEBUG_MODE = !$c7b8c09689548c2d$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($c7b8c09689548c2d$var$_process2 = globalThis.process) === null || $c7b8c09689548c2d$var$_process2 === void 0 || ($c7b8c09689548c2d$var$_process2 = $c7b8c09689548c2d$var$_process2.env) === null || $c7b8c09689548c2d$var$_process2 === void 0 ? void 0 : $c7b8c09689548c2d$var$_process2.NODE_ENV) !== 'production';
var $c7b8c09689548c2d$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$c7b8c09689548c2d$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});






parcelRegister("kINa4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f15e0d2b1a71c23a$var$_react = $f15e0d2b1a71c23a$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $47gXd = parcelRequire("47gXd");

var $f15e0d2b1a71c23a$var$_chevronDown = $f15e0d2b1a71c23a$var$_interopRequireDefault((parcelRequire("8kEM5")));
function $f15e0d2b1a71c23a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f15e0d2b1a71c23a$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $f15e0d2b1a71c23a$var$_react.default.createElement($47gXd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $f15e0d2b1a71c23a$var$_chevronDown.default,
        iconType: "utility"
    }));
$f15e0d2b1a71c23a$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $f15e0d2b1a71c23a$var$_default = module.exports.default = $f15e0d2b1a71c23a$var$ChevronDownIcon;

});
parcelRegister("47gXd", function(module, exports) {
$parcel$export(module.exports, "IconFacade", () => $2ff4f79ec0708ec4$export$3cfb73f70dfca966);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $dVGJk = parcelRequire("dVGJk");

var $juN94 = parcelRequire("juN94");
var $2ff4f79ec0708ec4$var$_excluded = [
    "dangerouslySetGlyph"
];
var $2ff4f79ec0708ec4$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
var $2ff4f79ec0708ec4$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $5FkrB.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $2ff4f79ec0708ec4$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : 'medium';
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $dVGJk.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (size === 'small' || size === 'medium')) {
        if (props.iconType === 'utility') {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
                spacing: (0, $dVGJk.fg)('platform-visual-refresh-icons-facade-button-fix') ? $2ff4f79ec0708ec4$var$sizeSpacingMap['utility'][size] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
                spacing: $2ff4f79ec0708ec4$var$sizeSpacingMap['core'][size],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $juN94.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});

});
parcelRegister("juN94", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $e316f0e4b02f2334$export$f04a61298a47a40f);

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $1b631 = parcelRequire("1b631");

var $cw16F = parcelRequire("cw16F");
function $e316f0e4b02f2334$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e316f0e4b02f2334$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e316f0e4b02f2334$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e316f0e4b02f2334$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $e316f0e4b02f2334$var$iconStyles = (0, $74Zh5.css)({
    display: 'inline-block',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> svg': $e316f0e4b02f2334$var$_objectSpread($e316f0e4b02f2334$var$_objectSpread({}, (0, $1b631.commonSVGStyles)), {}, {
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    })
});
/**
 * For windows high contrast mode
 */ var $e316f0e4b02f2334$var$baseHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            filter: 'grayscale(1)',
            '--icon-primary-color': 'CanvasText',
            // foreground
            '--icon-secondary-color': 'Canvas' // background
        }
    }
});
var $e316f0e4b02f2334$var$primaryEqualsSecondaryHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            '--icon-primary-color': 'Canvas' // foreground
        }
    }
});
var $e316f0e4b02f2334$var$secondaryTransparentHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            '--icon-secondary-color': 'transparent' // background
        }
    }
});
var $e316f0e4b02f2334$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $74Zh5.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $1b631.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $74Zh5.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor || (0, $cw16F.getBackground)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $e316f0e4b02f2334$var$iconStyles,
            $e316f0e4b02f2334$var$baseHcmStyles,
            primaryColor === secondaryColor && $e316f0e4b02f2334$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $e316f0e4b02f2334$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $74Zh5.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                '> svg': dimensions
            })
        ]
    }));
});
var $e316f0e4b02f2334$export$2e2bcd8739ae039 = $e316f0e4b02f2334$export$f04a61298a47a40f;

});
parcelRegister("1b631", function(module, exports) {
$parcel$export(module.exports, "commonSVGStyles", () => $0dbb82789c1a2c80$export$16374db1c3e6dfba);
$parcel$export(module.exports, "sizeStyleMap", () => $0dbb82789c1a2c80$export$ef0ad74202575b64);
$parcel$export(module.exports, "getIconSize", () => $0dbb82789c1a2c80$export$3eb7d6130acfda37);

var $iAlRz = parcelRequire("iAlRz");

var $74Zh5 = parcelRequire("74Zh5");
var $0dbb82789c1a2c80$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $0dbb82789c1a2c80$var$smallStyles = (0, $74Zh5.css)((0, $iAlRz.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $0dbb82789c1a2c80$var$mediumStyles = (0, $74Zh5.css)((0, $iAlRz.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $0dbb82789c1a2c80$var$largeStyles = (0, $74Zh5.css)((0, $iAlRz.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $0dbb82789c1a2c80$var$xlargeStyles = (0, $74Zh5.css)((0, $iAlRz.dimensions).xlarge);
var $0dbb82789c1a2c80$export$ef0ad74202575b64 = {
    small: $0dbb82789c1a2c80$var$smallStyles,
    medium: $0dbb82789c1a2c80$var$mediumStyles,
    large: $0dbb82789c1a2c80$var$largeStyles,
    xlarge: $0dbb82789c1a2c80$var$xlargeStyles
};
var $0dbb82789c1a2c80$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $iAlRz.dimensions)[size];
    return undefined;
};

});
parcelRegister("iAlRz", function(module, exports) {
$parcel$export(module.exports, "dimensions", () => $d87c8c5068a95233$export$62ad7b0c781000e9);
var $d87c8c5068a95233$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
var $d87c8c5068a95233$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
var $d87c8c5068a95233$export$62ad7b0c781000e9 = {
    small: {
        width: $d87c8c5068a95233$export$c647cb0ee6e282fe.small,
        height: $d87c8c5068a95233$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $d87c8c5068a95233$export$c647cb0ee6e282fe.medium,
        height: $d87c8c5068a95233$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $d87c8c5068a95233$export$c647cb0ee6e282fe.large,
        height: $d87c8c5068a95233$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $d87c8c5068a95233$export$c647cb0ee6e282fe.xlarge,
        height: $d87c8c5068a95233$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("cw16F", function(module, exports) {
$parcel$export(module.exports, "getBackground", () => $0259f4fbaa42ad65$export$18cb9425622d4e06);
var $0259f4fbaa42ad65$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});




parcelRegister("agyC9", function(module, exports) {
$parcel$export(module.exports, "Reference", () => $77963faf785db48a$export$e0be378c32fb70a7);

var $5FkrB = parcelRequire("5FkrB");

var $6JvGg = parcelRequire("6JvGg");

var $hvYLl = parcelRequire("hvYLl");

var $728oi = parcelRequire("728oi");
function $77963faf785db48a$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $5FkrB.useContext((0, $hvYLl.ManagerReferenceNodeSetterContext));
    var refHandler = $5FkrB.useCallback(function(node) {
        (0, $728oi.setRef)(innerRef, node);
        (0, $728oi.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $5FkrB.useEffect(function() {
        return function() {
            return (0, $728oi.setRef)(innerRef, null);
        };
    }, []);
    $5FkrB.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6JvGg)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $728oi.unwrapArray)(children)({
        ref: refHandler
    });
}

});
parcelRegister("6JvGg", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $4e6f8530dbdc4e71$var$__DEV__ = false;
var $4e6f8530dbdc4e71$var$warning = function() {};
if ($4e6f8530dbdc4e71$var$__DEV__) {
    var $4e6f8530dbdc4e71$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $4e6f8530dbdc4e71$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $4e6f8530dbdc4e71$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $4e6f8530dbdc4e71$var$warning;

});


parcelRegister("cvlyC", function(module, exports) {
$parcel$export(module.exports, "default", () => $91a91a1bf1b7e1c6$export$2e2bcd8739ae039);
var $91a91a1bf1b7e1c6$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $91a91a1bf1b7e1c6$var$isEqual(first, second) {
    if (first === second) return true;
    if ($91a91a1bf1b7e1c6$var$safeIsNaN(first) && $91a91a1bf1b7e1c6$var$safeIsNaN(second)) return true;
    return false;
}
function $91a91a1bf1b7e1c6$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$91a91a1bf1b7e1c6$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $91a91a1bf1b7e1c6$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $91a91a1bf1b7e1c6$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});

parcelRegister("6ILNo", function(module, exports) {
$parcel$export(module.exports, "getIn", () => $4e4bed591426b6a1$export$c52e5867d5879e24);
$parcel$export(module.exports, "createForm", () => $4e4bed591426b6a1$export$f681a8129d2e9d28);

var $d1G9Q = parcelRequire("d1G9Q");

var $kuWQN = parcelRequire("kuWQN");
//      
var $4e4bed591426b6a1$var$charCodeOfDot = ".".charCodeAt(0);
var $4e4bed591426b6a1$var$reEscapeChar = /\\(\\)?/g;
var $4e4bed591426b6a1$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $4e4bed591426b6a1$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $4e4bed591426b6a1$var$charCodeOfDot) result.push("");
    string.replace($4e4bed591426b6a1$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($4e4bed591426b6a1$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $4e4bed591426b6a1$var$keysCache = {};
var $4e4bed591426b6a1$var$keysRegex = /[.[\]]+/;
var $4e4bed591426b6a1$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($4e4bed591426b6a1$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $4e4bed591426b6a1$var$keysCache[key] = key.split($4e4bed591426b6a1$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $4e4bed591426b6a1$var$keysCache[key] = $4e4bed591426b6a1$var$stringToPath(key);
    }
    return $4e4bed591426b6a1$var$keysCache[key];
};
//      
var $4e4bed591426b6a1$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $4e4bed591426b6a1$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $4e4bed591426b6a1$var$_toPropertyKey(arg) {
    var key = $4e4bed591426b6a1$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $4e4bed591426b6a1$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $4e4bed591426b6a1$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $kuWQN.default)(current, [
                key
            ].map($4e4bed591426b6a1$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $d1G9Q.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $4e4bed591426b6a1$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $4e4bed591426b6a1$var$setInRecursor(state, 0, $4e4bed591426b6a1$var$toPath(key), value1, destroyArrays);
};
var $4e4bed591426b6a1$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $4e4bed591426b6a1$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $4e4bed591426b6a1$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $4e4bed591426b6a1$export$c52e5867d5879e24(values, name);
    var error = $4e4bed591426b6a1$export$c52e5867d5879e24(errors, name);
    if (error && error[$4e4bed591426b6a1$export$735bebc8ffabf28a]) error = error[$4e4bed591426b6a1$export$735bebc8ffabf28a];
    var submitError = submitErrors && $4e4bed591426b6a1$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $4e4bed591426b6a1$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($4e4bed591426b6a1$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $4e4bed591426b6a1$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $4e4bed591426b6a1$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $4e4bed591426b6a1$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$4e4bed591426b6a1$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $4e4bed591426b6a1$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $4e4bed591426b6a1$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $4e4bed591426b6a1$var$subscriptionFilter(result, state, previousState, subscription, $4e4bed591426b6a1$export$41e855cb628c1b55, $4e4bed591426b6a1$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $4e4bed591426b6a1$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $4e4bed591426b6a1$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $4e4bed591426b6a1$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $4e4bed591426b6a1$var$subscriptionFilter(result, state, previousState, subscription, $4e4bed591426b6a1$export$f1ff97b9d1c7a3c3, $4e4bed591426b6a1$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $4e4bed591426b6a1$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$4e4bed591426b6a1$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $4e4bed591426b6a1$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $4e4bed591426b6a1$export$83d89fbfd8236492 = "4.20.10";
var $4e4bed591426b6a1$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $4e4bed591426b6a1$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $4e4bed591426b6a1$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $4e4bed591426b6a1$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $4e4bed591426b6a1$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $4e4bed591426b6a1$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $4e4bed591426b6a1$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $4e4bed591426b6a1$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($4e4bed591426b6a1$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $4e4bed591426b6a1$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $d1G9Q.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $d1G9Q.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $4e4bed591426b6a1$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $4e4bed591426b6a1$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $d1G9Q.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $d1G9Q.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $d1G9Q.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $4e4bed591426b6a1$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $4e4bed591426b6a1$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $4e4bed591426b6a1$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $4e4bed591426b6a1$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $4e4bed591426b6a1$export$e6bdf135a54e021b,
                    shallowEqual: $4e4bed591426b6a1$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $d1G9Q.default)({}, state.formState.values)); // clone to avoid writing
            if ($4e4bed591426b6a1$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($4e4bed591426b6a1$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $4e4bed591426b6a1$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $4e4bed591426b6a1$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $d1G9Q.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $d1G9Q.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $4e4bed591426b6a1$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $4e4bed591426b6a1$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $4e4bed591426b6a1$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$4e4bed591426b6a1$export$735bebc8ffabf28a]) {
                    var existing = $4e4bed591426b6a1$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$4e4bed591426b6a1$export$735bebc8ffabf28a] = error[$4e4bed591426b6a1$export$735bebc8ffabf28a];
                    merged = $4e4bed591426b6a1$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$4e4bed591426b6a1$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$4e4bed591426b6a1$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $d1G9Q.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $4e4bed591426b6a1$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $4e4bed591426b6a1$var$notify(fieldSubscriber, fieldState, lastFieldState, $4e4bed591426b6a1$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $4e4bed591426b6a1$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $d1G9Q.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($4e4bed591426b6a1$export$c52e5867d5879e24(formState.values, key), $4e4bed591426b6a1$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($4e4bed591426b6a1$export$c52e5867d5879e24(formState.values, key), $4e4bed591426b6a1$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$4e4bed591426b6a1$var$hasAnyError(formState.errors) && !(formState.submitErrors && $4e4bed591426b6a1$var$hasAnyError(formState.submitErrors));
        var nextFormState = $4e4bed591426b6a1$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $4e4bed591426b6a1$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $4e4bed591426b6a1$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $4e4bed591426b6a1$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $4e4bed591426b6a1$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $4e4bed591426b6a1$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $4e4bed591426b6a1$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $4e4bed591426b6a1$var$notify(state.subscribers, nextFormState, lastFormState, $4e4bed591426b6a1$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $d1G9Q.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($4e4bed591426b6a1$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $d1G9Q.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $d1G9Q.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($4e4bed591426b6a1$export$c52e5867d5879e24(formState.values, key), $4e4bed591426b6a1$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $4e4bed591426b6a1$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $4e4bed591426b6a1$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $4e4bed591426b6a1$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $4e4bed591426b6a1$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $4e4bed591426b6a1$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $4e4bed591426b6a1$export$c52e5867d5879e24(state.formState.values, name) === $4e4bed591426b6a1$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $4e4bed591426b6a1$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $4e4bed591426b6a1$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $4e4bed591426b6a1$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $4e4bed591426b6a1$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $4e4bed591426b6a1$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $4e4bed591426b6a1$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $d1G9Q.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $d1G9Q.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $d1G9Q.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $4e4bed591426b6a1$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$4e4bed591426b6a1$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $d1G9Q.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $4e4bed591426b6a1$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $4e4bed591426b6a1$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $4e4bed591426b6a1$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $4e4bed591426b6a1$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("jOmHm", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6c44b4368aad9af$export$2e2bcd8739ae039);

var $6ILNo = parcelRequire("6ILNo");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $e6c44b4368aad9af$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $e6c44b4368aad9af$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($e6c44b4368aad9af$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $e6c44b4368aad9af$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $6ILNo.getIn)(errors, input.name);
    });
};
//      
var $e6c44b4368aad9af$var$noop = function noop() {};
var $e6c44b4368aad9af$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $e6c44b4368aad9af$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $e6c44b4368aad9af$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $e6c44b4368aad9af$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $e6c44b4368aad9af$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($e6c44b4368aad9af$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$e6c44b4368aad9af$export$2e2bcd8739ae039 = $e6c44b4368aad9af$var$createDecorator;

});

parcelRegister("117fZ", function(module, exports) {

var $dZPHh = parcelRequire("dZPHh");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $0bdb8386e438bed3$var$set(object, path, value) {
    return object == null ? object : $dZPHh(object, path, value);
}
module.exports = $0bdb8386e438bed3$var$set;

});
parcelRegister("dZPHh", function(module, exports) {

var $3vX86 = parcelRequire("3vX86");

var $33EWK = parcelRequire("33EWK");

var $kgLdF = parcelRequire("kgLdF");

var $lIhLB = parcelRequire("lIhLB");

var $WbaOC = parcelRequire("WbaOC");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $a30912d0deb5c62a$var$baseSet(object, path, value, customizer) {
    if (!$lIhLB(object)) return object;
    path = $33EWK(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $WbaOC(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $lIhLB(objValue) ? objValue : $kgLdF(path[index + 1]) ? [] : {};
        }
        $3vX86(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $a30912d0deb5c62a$var$baseSet;

});
parcelRegister("3vX86", function(module, exports) {

var $dJvo4 = parcelRequire("dJvo4");

var $grAle = parcelRequire("grAle");
/** Used for built-in method references. */ var $28f22245a6137b2a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $28f22245a6137b2a$var$hasOwnProperty = $28f22245a6137b2a$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $28f22245a6137b2a$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($28f22245a6137b2a$var$hasOwnProperty.call(object, key) && $grAle(objValue, value)) || value === undefined && !(key in object)) $dJvo4(object, key, value);
}
module.exports = $28f22245a6137b2a$var$assignValue;

});
parcelRegister("dJvo4", function(module, exports) {

var $hDKHs = parcelRequire("hDKHs");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $9ff7d3288d835e7f$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $hDKHs) $hDKHs(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $9ff7d3288d835e7f$var$baseAssignValue;

});
parcelRegister("hDKHs", function(module, exports) {

var $76YAf = parcelRequire("76YAf");
var $03506c9c1b01a400$var$defineProperty = function() {
    try {
        var func = $76YAf(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $03506c9c1b01a400$var$defineProperty;

});
parcelRegister("76YAf", function(module, exports) {

var $2dbaL = parcelRequire("2dbaL");

var $1CRtL = parcelRequire("1CRtL");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $52d8169341102371$var$getNative(object, key) {
    var value = $1CRtL(object, key);
    return $2dbaL(value) ? value : undefined;
}
module.exports = $52d8169341102371$var$getNative;

});
parcelRegister("2dbaL", function(module, exports) {

var $78AO6 = parcelRequire("78AO6");

var $ccj3g = parcelRequire("ccj3g");

var $lIhLB = parcelRequire("lIhLB");

var $1DbD2 = parcelRequire("1DbD2");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $19c57656b708725a$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $19c57656b708725a$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $19c57656b708725a$var$funcProto = Function.prototype, $19c57656b708725a$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $19c57656b708725a$var$funcToString = $19c57656b708725a$var$funcProto.toString;
/** Used to check objects for own properties. */ var $19c57656b708725a$var$hasOwnProperty = $19c57656b708725a$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $19c57656b708725a$var$reIsNative = RegExp('^' + $19c57656b708725a$var$funcToString.call($19c57656b708725a$var$hasOwnProperty).replace($19c57656b708725a$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $19c57656b708725a$var$baseIsNative(value) {
    if (!$lIhLB(value) || $ccj3g(value)) return false;
    var pattern = $78AO6(value) ? $19c57656b708725a$var$reIsNative : $19c57656b708725a$var$reIsHostCtor;
    return pattern.test($1DbD2(value));
}
module.exports = $19c57656b708725a$var$baseIsNative;

});
parcelRegister("78AO6", function(module, exports) {

var $7Vpf7 = parcelRequire("7Vpf7");

var $lIhLB = parcelRequire("lIhLB");
/** `Object#toString` result references. */ var $5325d4e3f7b9e6cb$var$asyncTag = '[object AsyncFunction]', $5325d4e3f7b9e6cb$var$funcTag = '[object Function]', $5325d4e3f7b9e6cb$var$genTag = '[object GeneratorFunction]', $5325d4e3f7b9e6cb$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $5325d4e3f7b9e6cb$var$isFunction(value) {
    if (!$lIhLB(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $7Vpf7(value);
    return tag == $5325d4e3f7b9e6cb$var$funcTag || tag == $5325d4e3f7b9e6cb$var$genTag || tag == $5325d4e3f7b9e6cb$var$asyncTag || tag == $5325d4e3f7b9e6cb$var$proxyTag;
}
module.exports = $5325d4e3f7b9e6cb$var$isFunction;

});
parcelRegister("7Vpf7", function(module, exports) {

var $fb7PP = parcelRequire("fb7PP");

var $5mW7B = parcelRequire("5mW7B");

var $38atd = parcelRequire("38atd");
/** `Object#toString` result references. */ var $5c516ff9b4ec4333$var$nullTag = '[object Null]', $5c516ff9b4ec4333$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $5c516ff9b4ec4333$var$symToStringTag = $fb7PP ? $fb7PP.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $5c516ff9b4ec4333$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $5c516ff9b4ec4333$var$undefinedTag : $5c516ff9b4ec4333$var$nullTag;
    return $5c516ff9b4ec4333$var$symToStringTag && $5c516ff9b4ec4333$var$symToStringTag in Object(value) ? $5mW7B(value) : $38atd(value);
}
module.exports = $5c516ff9b4ec4333$var$baseGetTag;

});
parcelRegister("fb7PP", function(module, exports) {

var $iXqsg = parcelRequire("iXqsg");
/** Built-in value references. */ var $b0cdf5f82c284b2b$var$Symbol = $iXqsg.Symbol;
module.exports = $b0cdf5f82c284b2b$var$Symbol;

});
parcelRegister("iXqsg", function(module, exports) {

var $2eo3w = parcelRequire("2eo3w");
/** Detect free variable `self`. */ var $dcd24212e9610d38$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $dcd24212e9610d38$var$root = $2eo3w || $dcd24212e9610d38$var$freeSelf || Function('return this')();
module.exports = $dcd24212e9610d38$var$root;

});
parcelRegister("2eo3w", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $19ff8c897068d84b$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $19ff8c897068d84b$var$freeGlobal;

});



parcelRegister("5mW7B", function(module, exports) {

var $fb7PP = parcelRequire("fb7PP");
/** Used for built-in method references. */ var $3e8c179708a8a55c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3e8c179708a8a55c$var$hasOwnProperty = $3e8c179708a8a55c$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3e8c179708a8a55c$var$nativeObjectToString = $3e8c179708a8a55c$var$objectProto.toString;
/** Built-in value references. */ var $3e8c179708a8a55c$var$symToStringTag = $fb7PP ? $fb7PP.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $3e8c179708a8a55c$var$getRawTag(value) {
    var isOwn = $3e8c179708a8a55c$var$hasOwnProperty.call(value, $3e8c179708a8a55c$var$symToStringTag), tag = value[$3e8c179708a8a55c$var$symToStringTag];
    try {
        value[$3e8c179708a8a55c$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $3e8c179708a8a55c$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$3e8c179708a8a55c$var$symToStringTag] = tag;
        else delete value[$3e8c179708a8a55c$var$symToStringTag];
    }
    return result;
}
module.exports = $3e8c179708a8a55c$var$getRawTag;

});

parcelRegister("38atd", function(module, exports) {
/** Used for built-in method references. */ var $247a3d9d42b555d0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $247a3d9d42b555d0$var$nativeObjectToString = $247a3d9d42b555d0$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $247a3d9d42b555d0$var$objectToString(value) {
    return $247a3d9d42b555d0$var$nativeObjectToString.call(value);
}
module.exports = $247a3d9d42b555d0$var$objectToString;

});


parcelRegister("lIhLB", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $fceb7d20fd150820$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $fceb7d20fd150820$var$isObject;

});


parcelRegister("ccj3g", function(module, exports) {

var $lUx9l = parcelRequire("lUx9l");
/** Used to detect methods masquerading as native. */ var $8e1562442cf48937$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($lUx9l && $lUx9l.keys && $lUx9l.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $8e1562442cf48937$var$isMasked(func) {
    return !!$8e1562442cf48937$var$maskSrcKey && $8e1562442cf48937$var$maskSrcKey in func;
}
module.exports = $8e1562442cf48937$var$isMasked;

});
parcelRegister("lUx9l", function(module, exports) {

var $iXqsg = parcelRequire("iXqsg");
/** Used to detect overreaching core-js shims. */ var $ff388ac2014073b4$var$coreJsData = $iXqsg["__core-js_shared__"];
module.exports = $ff388ac2014073b4$var$coreJsData;

});


parcelRegister("1DbD2", function(module, exports) {
/** Used for built-in method references. */ var $13027427a864304f$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $13027427a864304f$var$funcToString = $13027427a864304f$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $13027427a864304f$var$toSource(func) {
    if (func != null) {
        try {
            return $13027427a864304f$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $13027427a864304f$var$toSource;

});


parcelRegister("1CRtL", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $12f2d2e13527409c$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $12f2d2e13527409c$var$getValue;

});




parcelRegister("grAle", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $bf8b5b9aa9842838$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $bf8b5b9aa9842838$var$eq;

});


parcelRegister("33EWK", function(module, exports) {

var $4vMNO = parcelRequire("4vMNO");

var $agaje = parcelRequire("agaje");

var $9vTjC = parcelRequire("9vTjC");

var $duo48 = parcelRequire("duo48");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $23a16a070edeb957$var$castPath(value, object) {
    if ($4vMNO(value)) return value;
    return $agaje(value, object) ? [
        value
    ] : $9vTjC($duo48(value));
}
module.exports = $23a16a070edeb957$var$castPath;

});
parcelRegister("4vMNO", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $348fe9d38102b495$var$isArray = Array.isArray;
module.exports = $348fe9d38102b495$var$isArray;

});

parcelRegister("agaje", function(module, exports) {

var $4vMNO = parcelRequire("4vMNO");

var $3sIvm = parcelRequire("3sIvm");
/** Used to match property names within property paths. */ var $7783653137015a52$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $7783653137015a52$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $7783653137015a52$var$isKey(value, object) {
    if ($4vMNO(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $3sIvm(value)) return true;
    return $7783653137015a52$var$reIsPlainProp.test(value) || !$7783653137015a52$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $7783653137015a52$var$isKey;

});
parcelRegister("3sIvm", function(module, exports) {

var $7Vpf7 = parcelRequire("7Vpf7");

var $9Msco = parcelRequire("9Msco");
/** `Object#toString` result references. */ var $2856825500e2bbb2$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $2856825500e2bbb2$var$isSymbol(value) {
    return typeof value == 'symbol' || $9Msco(value) && $7Vpf7(value) == $2856825500e2bbb2$var$symbolTag;
}
module.exports = $2856825500e2bbb2$var$isSymbol;

});
parcelRegister("9Msco", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $71ee7875aed49df0$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $71ee7875aed49df0$var$isObjectLike;

});



parcelRegister("9vTjC", function(module, exports) {

var $03RV2 = parcelRequire("03RV2");
/** Used to match property names within property paths. */ var $6ed1eacd5e09b7fb$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $6ed1eacd5e09b7fb$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $6ed1eacd5e09b7fb$var$stringToPath = $03RV2(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($6ed1eacd5e09b7fb$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($6ed1eacd5e09b7fb$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $6ed1eacd5e09b7fb$var$stringToPath;

});
parcelRegister("03RV2", function(module, exports) {

var $dIO46 = parcelRequire("dIO46");
/** Used as the maximum memoize cache size. */ var $00ba1b22d1fcd440$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $00ba1b22d1fcd440$var$memoizeCapped(func) {
    var result = $dIO46(func, function(key) {
        if (cache.size === $00ba1b22d1fcd440$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $00ba1b22d1fcd440$var$memoizeCapped;

});
parcelRegister("dIO46", function(module, exports) {

var $fbj5d = parcelRequire("fbj5d");
/** Error message constants. */ var $9fd638579fffdec8$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $9fd638579fffdec8$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($9fd638579fffdec8$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($9fd638579fffdec8$var$memoize.Cache || $fbj5d);
    return memoized;
}
// Expose `MapCache`.
$9fd638579fffdec8$var$memoize.Cache = $fbj5d;
module.exports = $9fd638579fffdec8$var$memoize;

});
parcelRegister("fbj5d", function(module, exports) {

var $er8Pk = parcelRequire("er8Pk");

var $ghz8V = parcelRequire("ghz8V");

var $iQpci = parcelRequire("iQpci");

var $h9SOd = parcelRequire("h9SOd");

var $h2NgB = parcelRequire("h2NgB");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $b0d6af9660a8fa69$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$b0d6af9660a8fa69$var$MapCache.prototype.clear = $er8Pk;
$b0d6af9660a8fa69$var$MapCache.prototype['delete'] = $ghz8V;
$b0d6af9660a8fa69$var$MapCache.prototype.get = $iQpci;
$b0d6af9660a8fa69$var$MapCache.prototype.has = $h9SOd;
$b0d6af9660a8fa69$var$MapCache.prototype.set = $h2NgB;
module.exports = $b0d6af9660a8fa69$var$MapCache;

});
parcelRegister("er8Pk", function(module, exports) {

var $30Ct0 = parcelRequire("30Ct0");

var $jcImH = parcelRequire("jcImH");

var $45eKn = parcelRequire("45eKn");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $a82a6f262cf8e66a$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $30Ct0,
        'map': new ($45eKn || $jcImH),
        'string': new $30Ct0
    };
}
module.exports = $a82a6f262cf8e66a$var$mapCacheClear;

});
parcelRegister("30Ct0", function(module, exports) {

var $871ZP = parcelRequire("871ZP");

var $lcs46 = parcelRequire("lcs46");

var $imrLk = parcelRequire("imrLk");

var $g3QR4 = parcelRequire("g3QR4");

var $6a9Ih = parcelRequire("6a9Ih");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $230f35e322a45463$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$230f35e322a45463$var$Hash.prototype.clear = $871ZP;
$230f35e322a45463$var$Hash.prototype['delete'] = $lcs46;
$230f35e322a45463$var$Hash.prototype.get = $imrLk;
$230f35e322a45463$var$Hash.prototype.has = $g3QR4;
$230f35e322a45463$var$Hash.prototype.set = $6a9Ih;
module.exports = $230f35e322a45463$var$Hash;

});
parcelRegister("871ZP", function(module, exports) {

var $Fnv0I = parcelRequire("Fnv0I");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $5e8086945122e336$var$hashClear() {
    this.__data__ = $Fnv0I ? $Fnv0I(null) : {};
    this.size = 0;
}
module.exports = $5e8086945122e336$var$hashClear;

});
parcelRegister("Fnv0I", function(module, exports) {

var $76YAf = parcelRequire("76YAf");
/* Built-in method references that are verified to be native. */ var $07c60ee53783fc5a$var$nativeCreate = $76YAf(Object, 'create');
module.exports = $07c60ee53783fc5a$var$nativeCreate;

});


parcelRegister("lcs46", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $f6f07d19c3518e08$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $f6f07d19c3518e08$var$hashDelete;

});

parcelRegister("imrLk", function(module, exports) {

var $Fnv0I = parcelRequire("Fnv0I");
/** Used to stand-in for `undefined` hash values. */ var $d5dfd11c59d2c646$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $d5dfd11c59d2c646$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d5dfd11c59d2c646$var$hasOwnProperty = $d5dfd11c59d2c646$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d5dfd11c59d2c646$var$hashGet(key) {
    var data = this.__data__;
    if ($Fnv0I) {
        var result = data[key];
        return result === $d5dfd11c59d2c646$var$HASH_UNDEFINED ? undefined : result;
    }
    return $d5dfd11c59d2c646$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $d5dfd11c59d2c646$var$hashGet;

});

parcelRegister("g3QR4", function(module, exports) {

var $Fnv0I = parcelRequire("Fnv0I");
/** Used for built-in method references. */ var $bb15ed13a7a39f75$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bb15ed13a7a39f75$var$hasOwnProperty = $bb15ed13a7a39f75$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $bb15ed13a7a39f75$var$hashHas(key) {
    var data = this.__data__;
    return $Fnv0I ? data[key] !== undefined : $bb15ed13a7a39f75$var$hasOwnProperty.call(data, key);
}
module.exports = $bb15ed13a7a39f75$var$hashHas;

});

parcelRegister("6a9Ih", function(module, exports) {

var $Fnv0I = parcelRequire("Fnv0I");
/** Used to stand-in for `undefined` hash values. */ var $47cb361097e4c3d1$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $47cb361097e4c3d1$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $Fnv0I && value === undefined ? $47cb361097e4c3d1$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $47cb361097e4c3d1$var$hashSet;

});


parcelRegister("jcImH", function(module, exports) {

var $dZMET = parcelRequire("dZMET");

var $gb5sH = parcelRequire("gb5sH");

var $2Xzdc = parcelRequire("2Xzdc");

var $2AHOZ = parcelRequire("2AHOZ");

var $f4ae7 = parcelRequire("f4ae7");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dfb18d52eff00d4f$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$dfb18d52eff00d4f$var$ListCache.prototype.clear = $dZMET;
$dfb18d52eff00d4f$var$ListCache.prototype['delete'] = $gb5sH;
$dfb18d52eff00d4f$var$ListCache.prototype.get = $2Xzdc;
$dfb18d52eff00d4f$var$ListCache.prototype.has = $2AHOZ;
$dfb18d52eff00d4f$var$ListCache.prototype.set = $f4ae7;
module.exports = $dfb18d52eff00d4f$var$ListCache;

});
parcelRegister("dZMET", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $a306b76d367e196d$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $a306b76d367e196d$var$listCacheClear;

});

parcelRegister("gb5sH", function(module, exports) {

var $98eF4 = parcelRequire("98eF4");
/** Used for built-in method references. */ var $bc71e907d1372534$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $bc71e907d1372534$var$splice = $bc71e907d1372534$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $bc71e907d1372534$var$listCacheDelete(key) {
    var data = this.__data__, index = $98eF4(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $bc71e907d1372534$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $bc71e907d1372534$var$listCacheDelete;

});
parcelRegister("98eF4", function(module, exports) {

var $grAle = parcelRequire("grAle");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6a603bdd9bd9966a$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($grAle(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $6a603bdd9bd9966a$var$assocIndexOf;

});


parcelRegister("2Xzdc", function(module, exports) {

var $98eF4 = parcelRequire("98eF4");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $227c67cd1b4f8791$var$listCacheGet(key) {
    var data = this.__data__, index = $98eF4(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $227c67cd1b4f8791$var$listCacheGet;

});

parcelRegister("2AHOZ", function(module, exports) {

var $98eF4 = parcelRequire("98eF4");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1e30ef9a508c80f8$var$listCacheHas(key) {
    return $98eF4(this.__data__, key) > -1;
}
module.exports = $1e30ef9a508c80f8$var$listCacheHas;

});

parcelRegister("f4ae7", function(module, exports) {

var $98eF4 = parcelRequire("98eF4");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $af7f298b23a242dd$var$listCacheSet(key, value) {
    var data = this.__data__, index = $98eF4(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $af7f298b23a242dd$var$listCacheSet;

});


parcelRegister("45eKn", function(module, exports) {

var $76YAf = parcelRequire("76YAf");

var $iXqsg = parcelRequire("iXqsg");
/* Built-in method references that are verified to be native. */ var $2f931183d41ede7b$var$Map = $76YAf($iXqsg, 'Map');
module.exports = $2f931183d41ede7b$var$Map;

});


parcelRegister("ghz8V", function(module, exports) {

var $fBn3P = parcelRequire("fBn3P");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $bda97e8629d9498e$var$mapCacheDelete(key) {
    var result = $fBn3P(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $bda97e8629d9498e$var$mapCacheDelete;

});
parcelRegister("fBn3P", function(module, exports) {

var $cb3FS = parcelRequire("cb3FS");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $b5bc331d15b80d9a$var$getMapData(map, key) {
    var data = map.__data__;
    return $cb3FS(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $b5bc331d15b80d9a$var$getMapData;

});
parcelRegister("cb3FS", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $8dd95cc91ec8ca20$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $8dd95cc91ec8ca20$var$isKeyable;

});



parcelRegister("iQpci", function(module, exports) {

var $fBn3P = parcelRequire("fBn3P");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $db80a0fe29114b26$var$mapCacheGet(key) {
    return $fBn3P(this, key).get(key);
}
module.exports = $db80a0fe29114b26$var$mapCacheGet;

});

parcelRegister("h9SOd", function(module, exports) {

var $fBn3P = parcelRequire("fBn3P");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c7ddcad68e67f10e$var$mapCacheHas(key) {
    return $fBn3P(this, key).has(key);
}
module.exports = $c7ddcad68e67f10e$var$mapCacheHas;

});

parcelRegister("h2NgB", function(module, exports) {

var $fBn3P = parcelRequire("fBn3P");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $c688d6f400c62922$var$mapCacheSet(key, value) {
    var data = $fBn3P(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $c688d6f400c62922$var$mapCacheSet;

});





parcelRegister("duo48", function(module, exports) {

var $e6Inr = parcelRequire("e6Inr");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $9d20bea3e35643ef$var$toString(value) {
    return value == null ? '' : $e6Inr(value);
}
module.exports = $9d20bea3e35643ef$var$toString;

});
parcelRegister("e6Inr", function(module, exports) {

var $fb7PP = parcelRequire("fb7PP");

var $9hIZV = parcelRequire("9hIZV");

var $4vMNO = parcelRequire("4vMNO");

var $3sIvm = parcelRequire("3sIvm");
/** Used as references for various `Number` constants. */ var $a4540c9db65dd028$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $a4540c9db65dd028$var$symbolProto = $fb7PP ? $fb7PP.prototype : undefined, $a4540c9db65dd028$var$symbolToString = $a4540c9db65dd028$var$symbolProto ? $a4540c9db65dd028$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $a4540c9db65dd028$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($4vMNO(value)) // Recursively convert values (susceptible to call stack limits).
    return $9hIZV(value, $a4540c9db65dd028$var$baseToString) + '';
    if ($3sIvm(value)) return $a4540c9db65dd028$var$symbolToString ? $a4540c9db65dd028$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$a4540c9db65dd028$var$INFINITY ? '-0' : result;
}
module.exports = $a4540c9db65dd028$var$baseToString;

});
parcelRegister("9hIZV", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $6c289b397fa4796d$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $6c289b397fa4796d$var$arrayMap;

});




parcelRegister("kgLdF", function(module, exports) {
/** Used as references for various `Number` constants. */ var $ec19ee111509a6fd$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $ec19ee111509a6fd$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $ec19ee111509a6fd$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $ec19ee111509a6fd$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $ec19ee111509a6fd$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $ec19ee111509a6fd$var$isIndex;

});

parcelRegister("WbaOC", function(module, exports) {

var $3sIvm = parcelRequire("3sIvm");
/** Used as references for various `Number` constants. */ var $0aee15b4faea61c9$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $0aee15b4faea61c9$var$toKey(value) {
    if (typeof value == 'string' || $3sIvm(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$0aee15b4faea61c9$var$INFINITY ? '-0' : result;
}
module.exports = $0aee15b4faea61c9$var$toKey;

});



parcelRegister("coPW0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9070030c07639d18$var$_react = $9070030c07639d18$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $9070030c07639d18$var$_baseNew = $9070030c07639d18$var$_interopRequireDefault((parcelRequire("iU83E")));
function $9070030c07639d18$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9070030c07639d18$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $9070030c07639d18$var$_react.default.createElement($9070030c07639d18$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$9070030c07639d18$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $9070030c07639d18$var$_default = module.exports.default = $9070030c07639d18$var$StatusErrorIcon;

});
parcelRegister("iU83E", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("4nGyL")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("4nGyL")).Icon);

var $4nGyL = parcelRequire("4nGyL");

});
parcelRegister("4nGyL", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $330a52ddfdf2f1f0$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $330a52ddfdf2f1f0$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $atP8S = parcelRequire("atP8S");

var $kpGHk = parcelRequire("kpGHk");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $330a52ddfdf2f1f0$var$svgStyles = null;
var $330a52ddfdf2f1f0$var$iconStyles = null;
var $330a52ddfdf2f1f0$var$utilityIconStyles = null;
var $330a52ddfdf2f1f0$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $330a52ddfdf2f1f0$var$baseHcmStyles = null;
var $330a52ddfdf2f1f0$var$scaleSize = null;
var $330a52ddfdf2f1f0$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $330a52ddfdf2f1f0$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $330a52ddfdf2f1f0$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $330a52ddfdf2f1f0$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $330a52ddfdf2f1f0$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $330a52ddfdf2f1f0$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $kpGHk.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $5FkrB.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = $330a52ddfdf2f1f0$var$baseSizeMap[type];
    var viewBoxPadding = $330a52ddfdf2f1f0$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $atP8S.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $atP8S.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $330a52ddfdf2f1f0$var$utilSizes[spacing] : size === 'small' ? $330a52ddfdf2f1f0$var$coreSizeSmall[spacing] : $330a52ddfdf2f1f0$var$coreSizeMedium[spacing]
        ])
    }));
});
var $330a52ddfdf2f1f0$export$2e2bcd8739ae039 = $330a52ddfdf2f1f0$export$f04a61298a47a40f;

});
parcelRegister("atP8S", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a1448997f80ef3a$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $7a1448997f80ef3a$var$ATOMIC_GROUP_LENGTH = 5;
function $7a1448997f80ef3a$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $7a1448997f80ef3a$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("kpGHk", function(module, exports) {
$parcel$export(module.exports, "fg", () => $edc743577025f0ed$export$b40ec24ac8275656);

var $bgGsc = parcelRequire("bgGsc");
function $edc743577025f0ed$export$ba05d765b8392e5e(flagResolver) {
    (0, $bgGsc.setBooleanResolver)(flagResolver);
}
function $edc743577025f0ed$export$470e5c2be1411c89(name) {
    return (0, $bgGsc.resolveBooleanFlag)(name);
}
function $edc743577025f0ed$export$b40ec24ac8275656(name) {
    return (0, $bgGsc.resolveBooleanFlag)(name);
}

});
parcelRegister("bgGsc", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $83421ec1dabdd0b6$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $83421ec1dabdd0b6$export$6333b6aff9fc6275);

var $9dOvm = parcelRequire("9dOvm");

var $GBqn1 = parcelRequire("GBqn1");

var $3ZMUU = parcelRequire("3ZMUU");
var $83421ec1dabdd0b6$var$pkgName = '@atlaskit/platform-feature-flags';
var $83421ec1dabdd0b6$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $83421ec1dabdd0b6$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $83421ec1dabdd0b6$var$ENV_ENABLE_PLATFORM_FF = $83421ec1dabdd0b6$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $83421ec1dabdd0b6$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $83421ec1dabdd0b6$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $83421ec1dabdd0b6$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $83421ec1dabdd0b6$var$ENV_ENABLE_PLATFORM_FF || $83421ec1dabdd0b6$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $83421ec1dabdd0b6$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $83421ec1dabdd0b6$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$83421ec1dabdd0b6$var$globalVar[$83421ec1dabdd0b6$export$7e41b1b2bdee3f98] = $83421ec1dabdd0b6$var$globalVar[$83421ec1dabdd0b6$export$7e41b1b2bdee3f98] || $83421ec1dabdd0b6$var$DEFAULT_PFF_GLOBAL;
function $83421ec1dabdd0b6$export$f2b591175b3e424c(resolver) {
    $83421ec1dabdd0b6$var$globalVar[$83421ec1dabdd0b6$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $83421ec1dabdd0b6$export$6333b6aff9fc6275(flagKey) {
    if ($83421ec1dabdd0b6$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $GBqn1.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $83421ec1dabdd0b6$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $83421ec1dabdd0b6$var$globalVar[$83421ec1dabdd0b6$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $83421ec1dabdd0b6$var$globalVar[$83421ec1dabdd0b6$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $9dOvm.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $83421ec1dabdd0b6$var$globalVar[$83421ec1dabdd0b6$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("GBqn1", function(module, exports) {
$parcel$export(module.exports, "debug", () => $0800f40ce05b2454$export$1c9f709888824e05);
var $0800f40ce05b2454$var$_process, $0800f40ce05b2454$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $0800f40ce05b2454$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($0800f40ce05b2454$var$_process = globalThis.process) === null || $0800f40ce05b2454$var$_process === void 0 || ($0800f40ce05b2454$var$_process = $0800f40ce05b2454$var$_process.env) === null || $0800f40ce05b2454$var$_process === void 0 ? void 0 : $0800f40ce05b2454$var$_process.JEST_WORKER_ID) !== undefined;
var $0800f40ce05b2454$var$DEBUG_MODE = !$0800f40ce05b2454$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($0800f40ce05b2454$var$_process2 = globalThis.process) === null || $0800f40ce05b2454$var$_process2 === void 0 || ($0800f40ce05b2454$var$_process2 = $0800f40ce05b2454$var$_process2.env) === null || $0800f40ce05b2454$var$_process2 === void 0 ? void 0 : $0800f40ce05b2454$var$_process2.NODE_ENV) !== 'production';
var $0800f40ce05b2454$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$0800f40ce05b2454$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});






parcelRegister("1yYLz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12381a59acec3ae6$var$_react = $12381a59acec3ae6$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $3aULa = parcelRequire("3aULa");
function $12381a59acec3ae6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $12381a59acec3ae6$var$ErrorIcon = (props)=>/*#__PURE__*/ $12381a59acec3ae6$var$_react.default.createElement($3aULa.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$12381a59acec3ae6$var$ErrorIcon.displayName = 'ErrorIcon';
var $12381a59acec3ae6$var$_default = module.exports.default = $12381a59acec3ae6$var$ErrorIcon;

});
parcelRegister("3aULa", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $24fe558eef75aa21$export$f04a61298a47a40f);
/* icon.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $atP8S = parcelRequire("atP8S");
function $24fe558eef75aa21$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $24fe558eef75aa21$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $24fe558eef75aa21$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $24fe558eef75aa21$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $24fe558eef75aa21$var$iconStyles = null;
var $24fe558eef75aa21$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $24fe558eef75aa21$var$baseHcmStyles = null;
var $24fe558eef75aa21$var$primaryEqualsSecondaryHcmStyles = null;
var $24fe558eef75aa21$var$secondaryTransparentHcmStyles = null;
var $24fe558eef75aa21$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $5FkrB.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $24fe558eef75aa21$var$_objectSpread($24fe558eef75aa21$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $atP8S.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $24fe558eef75aa21$var$sizeStyles[size]
        ])
    }));
});
var $24fe558eef75aa21$export$2e2bcd8739ae039 = $24fe558eef75aa21$export$f04a61298a47a40f;

});


parcelRegister("bQGRN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a05cd728458b3b6$var$_react = $8a05cd728458b3b6$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $8a05cd728458b3b6$var$_baseNew = $8a05cd728458b3b6$var$_interopRequireDefault((parcelRequire("iU83E")));
function $8a05cd728458b3b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8a05cd728458b3b6$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $8a05cd728458b3b6$var$_react.default.createElement($8a05cd728458b3b6$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$8a05cd728458b3b6$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $8a05cd728458b3b6$var$_default = module.exports.default = $8a05cd728458b3b6$var$StatusSuccessIcon;

});

parcelRegister("6AF9r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4cc606ace6e56886$var$_react = $4cc606ace6e56886$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $3aULa = parcelRequire("3aULa");
function $4cc606ace6e56886$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4cc606ace6e56886$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $4cc606ace6e56886$var$_react.default.createElement($3aULa.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props));
$4cc606ace6e56886$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $4cc606ace6e56886$var$_default = module.exports.default = $4cc606ace6e56886$var$EditorSuccessIcon;

});

parcelRegister("8dIct", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1b6fc123789ae26535b6e4ca13d1b4ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $018b625e5fce7336$var$_react = $018b625e5fce7336$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $018b625e5fce7336$var$_UNSAFE_baseNew = $018b625e5fce7336$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $018b625e5fce7336$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $018b625e5fce7336$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $018b625e5fce7336$var$_react.default.createElement($018b625e5fce7336$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.25 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path stroke="currentcolor" stroke-width="1.5" d="M2.25 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"/>`
    }, props));
$018b625e5fce7336$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $018b625e5fce7336$var$_default = module.exports.default = $018b625e5fce7336$var$ShowMoreHorizontalIcon;

});

parcelRegister("igbF4", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4b2c45ac4fec9db$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $d4b2c45ac4fec9db$var$n() {
    return $d4b2c45ac4fec9db$var$n = Object.assign ? Object.assign.bind() : function(r) {
        for(var n = 1; n < arguments.length; n++){
            var e = arguments[n];
            for(var t in e)Object.prototype.hasOwnProperty.call(e, t) && (r[t] = e[t]);
        }
        return r;
    }, $d4b2c45ac4fec9db$var$n.apply(this, arguments);
}
var $d4b2c45ac4fec9db$var$e = [
    "children",
    "options"
], $d4b2c45ac4fec9db$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
}, $d4b2c45ac4fec9db$var$u = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce(function(r, n) {
    return r[n.toLowerCase()] = n, r;
}, {
    class: "className",
    for: "htmlFor"
}), $d4b2c45ac4fec9db$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $d4b2c45ac4fec9db$var$i = [
    "style",
    "script",
    "pre"
], $d4b2c45ac4fec9db$var$o = [
    "src",
    "href",
    "data",
    "formAction",
    "srcDoc",
    "action"
], $d4b2c45ac4fec9db$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $d4b2c45ac4fec9db$var$f = /\n{2,}$/, $d4b2c45ac4fec9db$var$l = /^(\s*>[\s\S]*?)(?=\n\n|$)/, $d4b2c45ac4fec9db$var$_ = /^ *> ?/gm, $d4b2c45ac4fec9db$var$d = /^(?:\[!([^\]]*)\]\n)?([\s\S]*)/, $d4b2c45ac4fec9db$var$s = /^ {2,}\n/, $d4b2c45ac4fec9db$var$v = /^(?:([-*_])( *\1){2,}) *(?:\n *)+\n/, $d4b2c45ac4fec9db$var$p = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $d4b2c45ac4fec9db$var$y = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $d4b2c45ac4fec9db$var$h = /^(`+)((?:\\`|(?!\1)`|[^`])+)\1/, $d4b2c45ac4fec9db$var$g = /^(?:\n *)*\n/, $d4b2c45ac4fec9db$var$m = /\r\n?/g, $d4b2c45ac4fec9db$var$k = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $d4b2c45ac4fec9db$var$x = /^\[\^([^\]]+)]/, $d4b2c45ac4fec9db$var$q = /\f/g, $d4b2c45ac4fec9db$var$b = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $d4b2c45ac4fec9db$var$S = /^\s*?\[(x|\s)\]/, $d4b2c45ac4fec9db$var$z = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $d4b2c45ac4fec9db$var$$ = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $d4b2c45ac4fec9db$var$E = /^([^\n]+)\n *(=|-)\2{2,} *\n/, $d4b2c45ac4fec9db$var$A = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $d4b2c45ac4fec9db$var$R = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $d4b2c45ac4fec9db$var$B = /^<!--[\s\S]*?(?:-->)/, $d4b2c45ac4fec9db$var$L = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $d4b2c45ac4fec9db$var$O = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $d4b2c45ac4fec9db$var$j = /^\{.*\}$/, $d4b2c45ac4fec9db$var$C = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $d4b2c45ac4fec9db$var$I = /^<([^ >]+[:@\/][^ >]+)>/, $d4b2c45ac4fec9db$var$T = /-([a-z])?/gi, $d4b2c45ac4fec9db$var$M = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $d4b2c45ac4fec9db$var$w = /^[^\n]+(?:  \n|\n{2,})/, $d4b2c45ac4fec9db$var$D = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $d4b2c45ac4fec9db$var$F = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $d4b2c45ac4fec9db$var$P = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $d4b2c45ac4fec9db$var$Z = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $d4b2c45ac4fec9db$var$N = /\t/g, $d4b2c45ac4fec9db$var$G = /(^ *\||\| *$)/g, $d4b2c45ac4fec9db$var$U = /^ *:-+: *$/, $d4b2c45ac4fec9db$var$V = /^ *:-+ *$/, $d4b2c45ac4fec9db$var$H = /^ *-+: *$/, $d4b2c45ac4fec9db$var$Q = function(r) {
    return "(?=[\\s\\S]+?\\1" + (r ? "\\1" : "") + ")";
}, $d4b2c45ac4fec9db$var$W = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|\\\\\\1|[\\s\\S])+?)", $d4b2c45ac4fec9db$var$J = RegExp("^([*_])\\1" + $d4b2c45ac4fec9db$var$Q(1) + $d4b2c45ac4fec9db$var$W + "\\1\\1(?!\\1)"), $d4b2c45ac4fec9db$var$K = RegExp("^([*_])" + $d4b2c45ac4fec9db$var$Q(0) + $d4b2c45ac4fec9db$var$W + "\\1(?!\\1)"), $d4b2c45ac4fec9db$var$X = RegExp("^(==)" + $d4b2c45ac4fec9db$var$Q(0) + $d4b2c45ac4fec9db$var$W + "\\1"), $d4b2c45ac4fec9db$var$Y = RegExp("^(~~)" + $d4b2c45ac4fec9db$var$Q(0) + $d4b2c45ac4fec9db$var$W + "\\1"), $d4b2c45ac4fec9db$var$rr = /^(:[a-zA-Z0-9-_]+:)/, $d4b2c45ac4fec9db$var$nr = /^\\([^0-9A-Za-z\s])/, $d4b2c45ac4fec9db$var$er = /\\([^0-9A-Za-z\s])/g, $d4b2c45ac4fec9db$var$tr = /^[\s\S](?:(?!  \n|[0-9]\.|http)[^=*_~\-\n:<`\\\[!])*/, $d4b2c45ac4fec9db$var$ur = /^\n+/, $d4b2c45ac4fec9db$var$ar = /^([ \t]*)/, $d4b2c45ac4fec9db$var$ir = /(?:^|\n)( *)$/, $d4b2c45ac4fec9db$var$or = "(?:\\d+\\.)", $d4b2c45ac4fec9db$var$cr = "(?:[*+-])";
function $d4b2c45ac4fec9db$var$fr(r) {
    return "( *)(" + (1 === r ? $d4b2c45ac4fec9db$var$or : $d4b2c45ac4fec9db$var$cr) + ") +";
}
var $d4b2c45ac4fec9db$var$lr = $d4b2c45ac4fec9db$var$fr(1), $d4b2c45ac4fec9db$var$_r = $d4b2c45ac4fec9db$var$fr(2);
function $d4b2c45ac4fec9db$var$dr(r) {
    return RegExp("^" + (1 === r ? $d4b2c45ac4fec9db$var$lr : $d4b2c45ac4fec9db$var$_r));
}
var $d4b2c45ac4fec9db$var$sr = $d4b2c45ac4fec9db$var$dr(1), $d4b2c45ac4fec9db$var$vr = $d4b2c45ac4fec9db$var$dr(2);
function $d4b2c45ac4fec9db$var$pr(r) {
    return RegExp("^" + (1 === r ? $d4b2c45ac4fec9db$var$lr : $d4b2c45ac4fec9db$var$_r) + "[^\\n]*(?:\\n(?!\\1" + (1 === r ? $d4b2c45ac4fec9db$var$or : $d4b2c45ac4fec9db$var$cr) + " )[^\\n]*)*(\\n|$)", "gm");
}
var $d4b2c45ac4fec9db$var$yr = $d4b2c45ac4fec9db$var$pr(1), $d4b2c45ac4fec9db$var$hr = $d4b2c45ac4fec9db$var$pr(2);
function $d4b2c45ac4fec9db$var$gr(r) {
    var n = 1 === r ? $d4b2c45ac4fec9db$var$or : $d4b2c45ac4fec9db$var$cr;
    return RegExp("^( *)(" + n + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n + " (?!" + n + " ))\\n*|\\s*\\n*$)");
}
var $d4b2c45ac4fec9db$var$mr = $d4b2c45ac4fec9db$var$gr(1), $d4b2c45ac4fec9db$var$kr = $d4b2c45ac4fec9db$var$gr(2);
function $d4b2c45ac4fec9db$var$xr(r, n) {
    var e = 1 === n, t = e ? $d4b2c45ac4fec9db$var$mr : $d4b2c45ac4fec9db$var$kr, u = e ? $d4b2c45ac4fec9db$var$yr : $d4b2c45ac4fec9db$var$hr, a = e ? $d4b2c45ac4fec9db$var$sr : $d4b2c45ac4fec9db$var$vr;
    return {
        t: function(r) {
            return a.test(r);
        },
        u: $d4b2c45ac4fec9db$var$jr(function(r, n) {
            var e = $d4b2c45ac4fec9db$var$ir.exec(n.prevCapture);
            return e && (n.list || !n.inline && !n.simple) ? t.exec(r = e[1] + r) : null;
        }),
        i: 1,
        o: function(r, n, t) {
            var i = e ? +r[2] : void 0, o = r[0].replace($d4b2c45ac4fec9db$var$f, "\n").match(u), c = !1;
            return {
                items: o.map(function(r, e) {
                    var u = a.exec(r)[0].length, i = RegExp("^ {1," + u + "}", "gm"), f = r.replace(i, "").replace(a, ""), l = e === o.length - 1, _ = -1 !== f.indexOf("\n\n") || l && c;
                    c = _;
                    var d, s = t.inline, v = t.list;
                    t.list = !0, _ ? (t.inline = !1, d = $d4b2c45ac4fec9db$var$zr(f) + "\n\n") : (t.inline = !0, d = $d4b2c45ac4fec9db$var$zr(f));
                    var p = n(d, t);
                    return t.inline = s, t.list = v, p;
                }),
                ordered: e,
                start: i
            };
        },
        l: function(n, e, t) {
            return r(n.ordered ? "ol" : "ul", {
                key: t.key,
                start: "20" === n.type ? n.start : void 0
            }, n.items.map(function(n, u) {
                return r("li", {
                    key: u
                }, e(n, t));
            }));
        }
    };
}
var $d4b2c45ac4fec9db$var$qr = RegExp("^\\[((?:\\[[^\\[\\]]*(?:\\[[^\\[\\]]*\\][^\\[\\]]*)*\\]|[^\\[\\]])*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $d4b2c45ac4fec9db$var$br = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/;
function $d4b2c45ac4fec9db$var$Sr(r) {
    return "string" == typeof r;
}
function $d4b2c45ac4fec9db$var$zr(r) {
    for(var n = r.length; n > 0 && r[n - 1] <= " ";)n--;
    return r.slice(0, n);
}
function $d4b2c45ac4fec9db$var$$r(r, n) {
    return r.startsWith(n);
}
function $d4b2c45ac4fec9db$var$Er(r, n, e) {
    if (Array.isArray(e)) {
        for(var t = 0; t < e.length; t++)if ($d4b2c45ac4fec9db$var$$r(r, e[t])) return !0;
        return !1;
    }
    return e(r, n);
}
function $d4b2c45ac4fec9db$export$c383cdd2a518017a(r) {
    return r.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $d4b2c45ac4fec9db$var$Rr(r) {
    return $d4b2c45ac4fec9db$var$H.test(r) ? "right" : $d4b2c45ac4fec9db$var$U.test(r) ? "center" : $d4b2c45ac4fec9db$var$V.test(r) ? "left" : null;
}
function $d4b2c45ac4fec9db$var$Br(r, n, e, t) {
    var u = e.inTable;
    e.inTable = !0;
    var a = [
        []
    ], i = "";
    function o() {
        if (i) {
            var r = a[a.length - 1];
            r.push.apply(r, n(i, e)), i = "";
        }
    }
    return r.trim().split(/(`[^`]*`|\\\||\|)/).filter(Boolean).forEach(function(r, n, e) {
        "|" === r.trim() && (o(), t) ? 0 !== n && n !== e.length - 1 && a.push([]) : i += r;
    }), o(), e.inTable = u, a;
}
function $d4b2c45ac4fec9db$var$Lr(r, n, e) {
    e.inline = !0;
    var t = r[2] ? r[2].replace($d4b2c45ac4fec9db$var$G, "").split("|").map($d4b2c45ac4fec9db$var$Rr) : [], u = r[3] ? function(r, n, e) {
        return r.trim().split("\n").map(function(r) {
            return $d4b2c45ac4fec9db$var$Br(r, n, e, !0);
        });
    }(r[3], n, e) : [], a = $d4b2c45ac4fec9db$var$Br(r[1], n, e, !!u.length);
    return e.inline = !1, u.length ? {
        align: t,
        cells: u,
        header: a,
        type: "25"
    } : {
        children: a,
        type: "21"
    };
}
function $d4b2c45ac4fec9db$var$Or(r, n) {
    return null == r.align[n] ? {} : {
        textAlign: r.align[n]
    };
}
function $d4b2c45ac4fec9db$var$jr(r) {
    return r.inline = 1, r;
}
function $d4b2c45ac4fec9db$var$Cr(r) {
    return $d4b2c45ac4fec9db$var$jr(function(n, e) {
        return e.inline ? r.exec(n) : null;
    });
}
function $d4b2c45ac4fec9db$var$Ir(r) {
    return $d4b2c45ac4fec9db$var$jr(function(n, e) {
        return e.inline || e.simple ? r.exec(n) : null;
    });
}
function $d4b2c45ac4fec9db$var$Tr(r) {
    return function(n, e) {
        return e.inline || e.simple ? null : r.exec(n);
    };
}
function $d4b2c45ac4fec9db$var$Mr(r) {
    return $d4b2c45ac4fec9db$var$jr(function(n) {
        return r.exec(n);
    });
}
var $d4b2c45ac4fec9db$var$wr = /(javascript|vbscript|data(?!:image)):/i;
function $d4b2c45ac4fec9db$export$3e2338ea76b578c9(r) {
    try {
        var n = decodeURIComponent(r).replace(/[^A-Za-z0-9/:]/g, "");
        if ($d4b2c45ac4fec9db$var$wr.test(n)) return null;
    } catch (r) {
        return null;
    }
    return r;
}
function $d4b2c45ac4fec9db$var$Fr(r) {
    return r ? r.replace($d4b2c45ac4fec9db$var$er, "$1") : r;
}
function $d4b2c45ac4fec9db$var$Pr(r, n, e) {
    var t = e.inline || !1, u = e.simple || !1;
    e.inline = !0, e.simple = !0;
    var a = r(n, e);
    return e.inline = t, e.simple = u, a;
}
function $d4b2c45ac4fec9db$var$Zr(r, n, e) {
    var t = e.inline || !1, u = e.simple || !1;
    e.inline = !1, e.simple = !0;
    var a = r(n, e);
    return e.inline = t, e.simple = u, a;
}
function $d4b2c45ac4fec9db$var$Nr(r, n, e) {
    var t = e.inline || !1;
    e.inline = !1;
    var u = r(n, e);
    return e.inline = t, u;
}
var $d4b2c45ac4fec9db$var$Gr = function(r, n, e) {
    return {
        children: $d4b2c45ac4fec9db$var$Pr(n, r[2], e)
    };
};
function $d4b2c45ac4fec9db$var$Ur() {
    return {};
}
function $d4b2c45ac4fec9db$var$Vr() {
    return null;
}
function $d4b2c45ac4fec9db$var$Hr() {
    return [].slice.call(arguments).filter(Boolean).join(" ");
}
function $d4b2c45ac4fec9db$var$Qr(r, n, e) {
    for(var t = r, u = n.split("."); u.length && void 0 !== (t = t[u[0]]);)u.shift();
    return t || e;
}
function $d4b2c45ac4fec9db$var$Wr(r, n) {
    var e = $d4b2c45ac4fec9db$var$Qr(n, r);
    return e ? "function" == typeof e || "object" == typeof e && "render" in e ? e : $d4b2c45ac4fec9db$var$Qr(n, r + ".component", r) : r;
}
function $d4b2c45ac4fec9db$export$69f434acfbdb0b32(e, t) {
    var f;
    void 0 === e && (e = ""), void 0 === t && (t = {}), t.overrides = t.overrides || {}, t.namedCodesToUnicode = t.namedCodesToUnicode ? $d4b2c45ac4fec9db$var$n({}, $d4b2c45ac4fec9db$var$a, t.namedCodesToUnicode) : $d4b2c45ac4fec9db$var$a;
    var G = t.slugify || $d4b2c45ac4fec9db$export$c383cdd2a518017a, U = t.sanitizer || $d4b2c45ac4fec9db$export$3e2338ea76b578c9, V = t.createElement || $5FkrB.createElement, H = [
        $d4b2c45ac4fec9db$var$l,
        $d4b2c45ac4fec9db$var$p,
        $d4b2c45ac4fec9db$var$y,
        t.enforceAtxHeadings ? $d4b2c45ac4fec9db$var$$ : $d4b2c45ac4fec9db$var$z,
        $d4b2c45ac4fec9db$var$E,
        $d4b2c45ac4fec9db$var$M,
        $d4b2c45ac4fec9db$var$mr,
        $d4b2c45ac4fec9db$var$kr
    ], Q = [].concat(H, [
        $d4b2c45ac4fec9db$var$w,
        $d4b2c45ac4fec9db$var$A,
        $d4b2c45ac4fec9db$var$B,
        $d4b2c45ac4fec9db$var$O
    ]);
    function W(r, n) {
        for(var e = 0; e < r.length; e++)if (r[e].test(n)) return !0;
        return !1;
    }
    function er(r, e) {
        var u = $d4b2c45ac4fec9db$var$Qr(t.overrides, r + ".props", {});
        return V.apply(void 0, [
            $d4b2c45ac4fec9db$var$Wr(r, t.overrides),
            $d4b2c45ac4fec9db$var$n({}, e, u, {
                className: $d4b2c45ac4fec9db$var$Hr(null == e ? void 0 : e.className, u.className) || void 0
            })
        ].concat([].slice.call(arguments, 2)));
    }
    function ir(r) {
        r = r.replace($d4b2c45ac4fec9db$var$b, "");
        var n = !1;
        t.forceInline ? n = !0 : t.forceBlock || (n = !1 === $d4b2c45ac4fec9db$var$Z.test(r));
        for(var e = dr(_r(n ? r : $d4b2c45ac4fec9db$var$zr(r).replace($d4b2c45ac4fec9db$var$ur, "") + "\n\n", {
            inline: n
        })); $d4b2c45ac4fec9db$var$Sr(e[e.length - 1]) && !e[e.length - 1].trim();)e.pop();
        if (null === t.wrapper) return e;
        var u, a = t.wrapper || (n ? "span" : "div");
        if (e.length > 1 || t.forceWrapper) u = e;
        else {
            if (1 === e.length) return "string" == typeof (u = e[0]) ? er("span", {
                key: "outer"
            }, u) : u;
            u = null;
        }
        return V(a, {
            key: "outer"
        }, u);
    }
    function or(r, n) {
        if (!n || !n.trim()) return null;
        var e = n.match($d4b2c45ac4fec9db$var$c);
        return e ? e.reduce(function(n, e) {
            var t = e.indexOf("=");
            if (-1 !== t) {
                var a = (function(r) {
                    return -1 !== r.indexOf("-") && null === r.match($d4b2c45ac4fec9db$var$L) && (r = r.replace($d4b2c45ac4fec9db$var$T, function(r, n) {
                        return n.toUpperCase();
                    })), r;
                })(e.slice(0, t)).trim(), i = function(r) {
                    var n = r[0];
                    return ('"' === n || "'" === n) && r.length >= 2 && r[r.length - 1] === n ? r.slice(1, -1) : r;
                }(e.slice(t + 1).trim()), c = $d4b2c45ac4fec9db$var$u[a] || a;
                if ("ref" === c) return n;
                var f = n[c] = function(r, n, e, t) {
                    return "style" === n ? (function(r) {
                        var n = [], e = "", t = !1, u = !1, a = "";
                        if (!r) return n;
                        for(var i = 0; i < r.length; i++){
                            var o = r[i];
                            if ('"' !== o && "'" !== o || t || (u ? o === a && (u = !1, a = "") : (u = !0, a = o)), "(" === o && e.endsWith("url") ? t = !0 : ")" === o && t && (t = !1), ";" !== o || u || t) e += o;
                            else {
                                var c = e.trim();
                                if (c) {
                                    var f = c.indexOf(":");
                                    if (f > 0) {
                                        var l = c.slice(0, f).trim(), _ = c.slice(f + 1).trim();
                                        n.push([
                                            l,
                                            _
                                        ]);
                                    }
                                }
                                e = "";
                            }
                        }
                        var d = e.trim();
                        if (d) {
                            var s = d.indexOf(":");
                            if (s > 0) {
                                var v = d.slice(0, s).trim(), p = d.slice(s + 1).trim();
                                n.push([
                                    v,
                                    p
                                ]);
                            }
                        }
                        return n;
                    })(e).reduce(function(n, e) {
                        var u = e[0], a = e[1];
                        return n[u.replace(/(-[a-z])/g, function(r) {
                            return r[1].toUpperCase();
                        })] = t(a, r, u), n;
                    }, {}) : -1 !== $d4b2c45ac4fec9db$var$o.indexOf(n) ? t($d4b2c45ac4fec9db$var$Fr(e), r, n) : (e.match($d4b2c45ac4fec9db$var$j) && (e = $d4b2c45ac4fec9db$var$Fr(e.slice(1, e.length - 1))), "true" === e || "false" !== e && e);
                }(r, a, i, U);
                "string" == typeof f && ($d4b2c45ac4fec9db$var$A.test(f) || $d4b2c45ac4fec9db$var$O.test(f)) && (n[c] = ir(f.trim()));
            } else "style" !== e && (n[$d4b2c45ac4fec9db$var$u[e] || e] = !0);
            return n;
        }, {}) : null;
    }
    var cr = [], fr = {}, lr = ((f = {})[0] = {
        t: [
            ">"
        ],
        u: $d4b2c45ac4fec9db$var$Tr($d4b2c45ac4fec9db$var$l),
        i: 1,
        o: function(r, n, e) {
            var t = r[0].replace($d4b2c45ac4fec9db$var$_, "").match($d4b2c45ac4fec9db$var$d);
            return {
                alert: t[1],
                children: n(t[2], e)
            };
        },
        l: function(r, n, e) {
            var t = {
                key: e.key
            };
            return r.alert && (t.className = "markdown-alert-" + G(r.alert.toLowerCase(), $d4b2c45ac4fec9db$export$c383cdd2a518017a), r.children.unshift({
                attrs: {},
                children: [
                    {
                        type: "27",
                        text: r.alert
                    }
                ],
                noInnerParse: !0,
                type: "11",
                tag: "header"
            })), er("blockquote", t, n(r.children, e));
        }
    }, f[1] = {
        t: [
            "  "
        ],
        u: $d4b2c45ac4fec9db$var$Mr($d4b2c45ac4fec9db$var$s),
        i: 1,
        o: $d4b2c45ac4fec9db$var$Ur,
        l: function(r, n, e) {
            return er("br", {
                key: e.key
            });
        }
    }, f[2] = {
        t: [
            "--",
            "__",
            "**",
            "- ",
            "* ",
            "_ "
        ],
        u: $d4b2c45ac4fec9db$var$Tr($d4b2c45ac4fec9db$var$v),
        i: 1,
        o: $d4b2c45ac4fec9db$var$Ur,
        l: function(r, n, e) {
            return er("hr", {
                key: e.key
            });
        }
    }, f[3] = {
        t: [
            "    "
        ],
        u: $d4b2c45ac4fec9db$var$Tr($d4b2c45ac4fec9db$var$y),
        i: 0,
        o: function(r) {
            return {
                lang: void 0,
                text: $d4b2c45ac4fec9db$var$Fr($d4b2c45ac4fec9db$var$zr(r[0].replace(/^ {4}/gm, "")))
            };
        },
        l: function(r, e, t) {
            return er("pre", {
                key: t.key
            }, er("code", $d4b2c45ac4fec9db$var$n({}, r.attrs, {
                className: r.lang ? "lang-" + r.lang : ""
            }), r.text));
        }
    }, f[4] = {
        t: [
            "```",
            "~~~"
        ],
        u: $d4b2c45ac4fec9db$var$Tr($d4b2c45ac4fec9db$var$p),
        i: 0,
        o: function(r) {
            return {
                attrs: or("code", r[3] || ""),
                lang: r[2] || void 0,
                text: r[4],
                type: "3"
            };
        }
    }, f[5] = {
        t: [
            "`"
        ],
        u: $d4b2c45ac4fec9db$var$Ir($d4b2c45ac4fec9db$var$h),
        i: 3,
        o: function(r) {
            return {
                text: $d4b2c45ac4fec9db$var$Fr(r[2])
            };
        },
        l: function(r, n, e) {
            return er("code", {
                key: e.key
            }, r.text);
        }
    }, f[6] = {
        t: [
            "[^"
        ],
        u: $d4b2c45ac4fec9db$var$Tr($d4b2c45ac4fec9db$var$k),
        i: 0,
        o: function(r) {
            return cr.push({
                footnote: r[2],
                identifier: r[1]
            }), {};
        },
        l: $d4b2c45ac4fec9db$var$Vr
    }, f[7] = {
        t: [
            "[^"
        ],
        u: $d4b2c45ac4fec9db$var$Cr($d4b2c45ac4fec9db$var$x),
        i: 1,
        o: function(r) {
            return {
                target: "#" + G(r[1], $d4b2c45ac4fec9db$export$c383cdd2a518017a),
                text: r[1]
            };
        },
        l: function(r, n, e) {
            return er("a", {
                key: e.key,
                href: U(r.target, "a", "href")
            }, er("sup", {
                key: e.key
            }, r.text));
        }
    }, f[8] = {
        t: [
            "[ ]",
            "[x]"
        ],
        u: $d4b2c45ac4fec9db$var$Cr($d4b2c45ac4fec9db$var$S),
        i: 1,
        o: function(r) {
            return {
                completed: "x" === r[1].toLowerCase()
            };
        },
        l: function(r, n, e) {
            return er("input", {
                checked: r.completed,
                key: e.key,
                readOnly: !0,
                type: "checkbox"
            });
        }
    }, f[9] = {
        t: [
            "#"
        ],
        u: $d4b2c45ac4fec9db$var$Tr(t.enforceAtxHeadings ? $d4b2c45ac4fec9db$var$$ : $d4b2c45ac4fec9db$var$z),
        i: 1,
        o: function(r, n, e) {
            return {
                children: $d4b2c45ac4fec9db$var$Pr(n, r[2], e),
                id: G(r[2], $d4b2c45ac4fec9db$export$c383cdd2a518017a),
                level: r[1].length
            };
        },
        l: function(r, n, e) {
            return er("h" + r.level, {
                id: r.id,
                key: e.key
            }, n(r.children, e));
        }
    }, f[10] = {
        t: function(r) {
            var n = r.indexOf("\n");
            return n > 0 && n < r.length - 1 && ("=" === r[n + 1] || "-" === r[n + 1]);
        },
        u: $d4b2c45ac4fec9db$var$Tr($d4b2c45ac4fec9db$var$E),
        i: 1,
        o: function(r, n, e) {
            return {
                children: $d4b2c45ac4fec9db$var$Pr(n, r[1], e),
                level: "=" === r[2] ? 1 : 2,
                type: "9"
            };
        }
    }, f[11] = {
        t: [
            "<"
        ],
        u: $d4b2c45ac4fec9db$var$Mr($d4b2c45ac4fec9db$var$A),
        i: 1,
        o: function(r, n, e) {
            var t = r[3].match($d4b2c45ac4fec9db$var$ar), u = RegExp("^" + t[1], "gm"), a = r[3].replace(u, ""), o = W(Q, a) ? $d4b2c45ac4fec9db$var$Nr : $d4b2c45ac4fec9db$var$Pr, c = r[1].toLowerCase(), f = -1 !== $d4b2c45ac4fec9db$var$i.indexOf(c), l = (f ? c : r[1]).trim(), _ = {
                attrs: or(l, r[2]),
                noInnerParse: f,
                tag: l
            };
            if (e.inAnchor = e.inAnchor || "a" === c, f) _.text = r[3];
            else {
                var d = e.inHTML;
                e.inHTML = !0, _.children = o(n, a, e), e.inHTML = d;
            }
            return e.inAnchor = !1, _;
        },
        l: function(r, e, t) {
            return er(r.tag, $d4b2c45ac4fec9db$var$n({
                key: t.key
            }, r.attrs), r.text || (r.children ? e(r.children, t) : ""));
        }
    }, f[13] = {
        t: [
            "<"
        ],
        u: $d4b2c45ac4fec9db$var$Mr($d4b2c45ac4fec9db$var$O),
        i: 1,
        o: function(r) {
            var n = r[1].trim();
            return {
                attrs: or(n, r[2] || ""),
                tag: n
            };
        },
        l: function(r, e, t) {
            return er(r.tag, $d4b2c45ac4fec9db$var$n({}, r.attrs, {
                key: t.key
            }));
        }
    }, f[12] = {
        t: [
            "\x3c!--"
        ],
        u: $d4b2c45ac4fec9db$var$Mr($d4b2c45ac4fec9db$var$B),
        i: 1,
        o: function() {
            return {};
        },
        l: $d4b2c45ac4fec9db$var$Vr
    }, f[14] = {
        t: [
            "!["
        ],
        u: $d4b2c45ac4fec9db$var$Ir($d4b2c45ac4fec9db$var$br),
        i: 1,
        o: function(r) {
            return {
                alt: $d4b2c45ac4fec9db$var$Fr(r[1]),
                target: $d4b2c45ac4fec9db$var$Fr(r[2]),
                title: $d4b2c45ac4fec9db$var$Fr(r[3])
            };
        },
        l: function(r, n, e) {
            return er("img", {
                key: e.key,
                alt: r.alt || void 0,
                title: r.title || void 0,
                src: U(r.target, "img", "src")
            });
        }
    }, f[15] = {
        t: [
            "["
        ],
        u: $d4b2c45ac4fec9db$var$Cr($d4b2c45ac4fec9db$var$qr),
        i: 3,
        o: function(r, n, e) {
            return {
                children: $d4b2c45ac4fec9db$var$Zr(n, r[1], e),
                target: $d4b2c45ac4fec9db$var$Fr(r[2]),
                title: $d4b2c45ac4fec9db$var$Fr(r[3])
            };
        },
        l: function(r, n, e) {
            return er("a", {
                key: e.key,
                href: U(r.target, "a", "href"),
                title: r.title
            }, n(r.children, e));
        }
    }, f[16] = {
        t: [
            "<"
        ],
        u: $d4b2c45ac4fec9db$var$Cr($d4b2c45ac4fec9db$var$I),
        i: 0,
        o: function(r) {
            var n = r[1], e = !1;
            return -1 !== n.indexOf("@") && -1 === n.indexOf("//") && (e = !0, n = n.replace("mailto:", "")), {
                children: [
                    {
                        text: n,
                        type: "27"
                    }
                ],
                target: e ? "mailto:" + n : n,
                type: "15"
            };
        }
    }, f[17] = {
        t: function(r, n) {
            return !n.inAnchor && !t.disableAutoLink && ($d4b2c45ac4fec9db$var$$r(r, "http://") || $d4b2c45ac4fec9db$var$$r(r, "https://"));
        },
        u: $d4b2c45ac4fec9db$var$Cr($d4b2c45ac4fec9db$var$C),
        i: 0,
        o: function(r) {
            return {
                children: [
                    {
                        text: r[1],
                        type: "27"
                    }
                ],
                target: r[1],
                title: void 0,
                type: "15"
            };
        }
    }, f[20] = $d4b2c45ac4fec9db$var$xr(er, 1), f[33] = $d4b2c45ac4fec9db$var$xr(er, 2), f[19] = {
        t: [
            "\n"
        ],
        u: $d4b2c45ac4fec9db$var$Tr($d4b2c45ac4fec9db$var$g),
        i: 3,
        o: $d4b2c45ac4fec9db$var$Ur,
        l: function() {
            return "\n";
        }
    }, f[21] = {
        u: $d4b2c45ac4fec9db$var$jr(function(r, n) {
            if (n.inline || n.simple || n.inHTML && -1 === r.indexOf("\n\n") && -1 === n.prevCapture.indexOf("\n\n")) return null;
            for(var e = "", t = 0;;){
                var u = r.indexOf("\n", t), a = r.slice(t, -1 === u ? void 0 : u + 1);
                if (W(H, a)) break;
                if (e += a, -1 === u || !a.trim()) break;
                t = u + 1;
            }
            var i = $d4b2c45ac4fec9db$var$zr(e);
            return "" === i ? null : [
                e,
                ,
                i
            ];
        }),
        i: 3,
        o: $d4b2c45ac4fec9db$var$Gr,
        l: function(r, n, e) {
            return er("p", {
                key: e.key
            }, n(r.children, e));
        }
    }, f[22] = {
        t: [
            "["
        ],
        u: $d4b2c45ac4fec9db$var$Cr($d4b2c45ac4fec9db$var$D),
        i: 0,
        o: function(r) {
            return fr[r[1]] = {
                target: r[2],
                title: r[4]
            }, {};
        },
        l: $d4b2c45ac4fec9db$var$Vr
    }, f[23] = {
        t: [
            "!["
        ],
        u: $d4b2c45ac4fec9db$var$Ir($d4b2c45ac4fec9db$var$F),
        i: 0,
        o: function(r) {
            return {
                alt: r[1] ? $d4b2c45ac4fec9db$var$Fr(r[1]) : void 0,
                ref: r[2]
            };
        },
        l: function(r, n, e) {
            return fr[r.ref] ? er("img", {
                key: e.key,
                alt: r.alt,
                src: U(fr[r.ref].target, "img", "src"),
                title: fr[r.ref].title
            }) : null;
        }
    }, f[24] = {
        t: function(r) {
            return "[" === r[0] && -1 === r.indexOf("](");
        },
        u: $d4b2c45ac4fec9db$var$Cr($d4b2c45ac4fec9db$var$P),
        i: 0,
        o: function(r, n, e) {
            return {
                children: n(r[1], e),
                fallbackChildren: r[0],
                ref: r[2]
            };
        },
        l: function(r, n, e) {
            return fr[r.ref] ? er("a", {
                key: e.key,
                href: U(fr[r.ref].target, "a", "href"),
                title: fr[r.ref].title
            }, n(r.children, e)) : er("span", {
                key: e.key
            }, r.fallbackChildren);
        }
    }, f[25] = {
        t: [
            "|"
        ],
        u: $d4b2c45ac4fec9db$var$Tr($d4b2c45ac4fec9db$var$M),
        i: 1,
        o: $d4b2c45ac4fec9db$var$Lr,
        l: function(r, n, e) {
            var t = r;
            return er("table", {
                key: e.key
            }, er("thead", null, er("tr", null, t.header.map(function(r, u) {
                return er("th", {
                    key: u,
                    style: $d4b2c45ac4fec9db$var$Or(t, u)
                }, n(r, e));
            }))), er("tbody", null, t.cells.map(function(r, u) {
                return er("tr", {
                    key: u
                }, r.map(function(r, u) {
                    return er("td", {
                        key: u,
                        style: $d4b2c45ac4fec9db$var$Or(t, u)
                    }, n(r, e));
                }));
            })));
        }
    }, f[27] = {
        u: $d4b2c45ac4fec9db$var$jr(function(r, n) {
            var e;
            return $d4b2c45ac4fec9db$var$$r(r, ":") && (e = $d4b2c45ac4fec9db$var$rr.exec(r)), e || $d4b2c45ac4fec9db$var$tr.exec(r);
        }),
        i: 4,
        o: function(r) {
            var n = r[0];
            return {
                text: -1 === n.indexOf("&") ? n : n.replace($d4b2c45ac4fec9db$var$R, function(r, n) {
                    return t.namedCodesToUnicode[n] || r;
                })
            };
        },
        l: function(r) {
            return r.text;
        }
    }, f[28] = {
        t: [
            "**",
            "__"
        ],
        u: $d4b2c45ac4fec9db$var$Ir($d4b2c45ac4fec9db$var$J),
        i: 2,
        o: function(r, n, e) {
            return {
                children: n(r[2], e)
            };
        },
        l: function(r, n, e) {
            return er("strong", {
                key: e.key
            }, n(r.children, e));
        }
    }, f[29] = {
        t: function(r) {
            var n = r[0];
            return ("*" === n || "_" === n) && r[1] !== n;
        },
        u: $d4b2c45ac4fec9db$var$Ir($d4b2c45ac4fec9db$var$K),
        i: 3,
        o: function(r, n, e) {
            return {
                children: n(r[2], e)
            };
        },
        l: function(r, n, e) {
            return er("em", {
                key: e.key
            }, n(r.children, e));
        }
    }, f[30] = {
        t: [
            "\\"
        ],
        u: $d4b2c45ac4fec9db$var$Ir($d4b2c45ac4fec9db$var$nr),
        i: 1,
        o: function(r) {
            return {
                text: r[1],
                type: "27"
            };
        }
    }, f[31] = {
        t: [
            "=="
        ],
        u: $d4b2c45ac4fec9db$var$Ir($d4b2c45ac4fec9db$var$X),
        i: 3,
        o: $d4b2c45ac4fec9db$var$Gr,
        l: function(r, n, e) {
            return er("mark", {
                key: e.key
            }, n(r.children, e));
        }
    }, f[32] = {
        t: [
            "~~"
        ],
        u: $d4b2c45ac4fec9db$var$Ir($d4b2c45ac4fec9db$var$Y),
        i: 3,
        o: $d4b2c45ac4fec9db$var$Gr,
        l: function(r, n, e) {
            return er("del", {
                key: e.key
            }, n(r.children, e));
        }
    }, f);
    !0 === t.disableParsingRawHTML && (delete lr[11], delete lr[13]);
    var _r = function(r) {
        var n = Object.keys(r);
        function e(t, u) {
            var a = [];
            if (u.prevCapture = u.prevCapture || "", t.trim()) for(; t;)for(var i = 0; i < n.length;){
                var o = n[i], c = r[o];
                if (!c.t || $d4b2c45ac4fec9db$var$Er(t, u, c.t)) {
                    var f = c.u(t, u);
                    if (f && f[0]) {
                        t = t.substring(f[0].length);
                        var l = c.o(f, e, u);
                        u.prevCapture += f[0], l.type || (l.type = o), a.push(l);
                        break;
                    }
                    i++;
                } else i++;
            }
            return u.prevCapture = "", a;
        }
        return n.sort(function(n, e) {
            return r[n].i - r[e].i || (n < e ? -1 : 1);
        }), function(r, n) {
            return e(function(r) {
                return r.replace($d4b2c45ac4fec9db$var$m, "\n").replace($d4b2c45ac4fec9db$var$q, "").replace($d4b2c45ac4fec9db$var$N, "    ");
            }(r), n);
        };
    }(lr), dr = function(r, n) {
        return function e(t, u) {
            if (void 0 === u && (u = {}), Array.isArray(t)) {
                for(var a = u.key, i = [], o = !1, c = 0; c < t.length; c++){
                    u.key = c;
                    var f = e(t[c], u), l = $d4b2c45ac4fec9db$var$Sr(f);
                    l && o ? i[i.length - 1] += f : null !== f && i.push(f), o = l;
                }
                return u.key = a, i;
            }
            return function(e, t, u) {
                var a = r[e.type].l;
                return n ? n(function() {
                    return a(e, t, u);
                }, e, t, u) : a(e, t, u);
            }(t, e, u);
        };
    }(lr, t.renderRule), sr = ir(e);
    return cr.length ? er("div", null, sr, er("footer", {
        key: "footer"
    }, cr.map(function(r) {
        return er("div", {
            id: G(r.identifier, $d4b2c45ac4fec9db$export$c383cdd2a518017a),
            key: r.identifier
        }, r.identifier, dr(_r(r.footnote, {
            inline: !0
        })));
    }))) : sr;
}
function $d4b2c45ac4fec9db$export$2e2bcd8739ae039(n) {
    var t = n.children, u = n.options, a = function(r, n) {
        if (null == r) return {};
        var e, t, u = {}, a = Object.keys(r);
        for(t = 0; t < a.length; t++)n.indexOf(e = a[t]) >= 0 || (u[e] = r[e]);
        return u;
    }(n, $d4b2c45ac4fec9db$var$e);
    return $5FkrB.cloneElement($d4b2c45ac4fec9db$export$69f434acfbdb0b32(null == t ? "" : t, u), a);
}

});

parcelRegister("dujqE", function(module, exports) {
function $9d1d25da55f1f0c6$var$_readOnlyError(r) {
    throw new TypeError('"' + r + '" is read-only');
}
module.exports = $9d1d25da55f1f0c6$var$_readOnlyError, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("k8BjC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("1hAE6")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("1hAE6")).Icon);

var $1hAE6 = parcelRequire("1hAE6");

});
parcelRegister("1hAE6", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $0ef3ce11fb651b22$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $0ef3ce11fb651b22$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $0ef3ce11fb651b22$var$svgStyles = null;
var $0ef3ce11fb651b22$var$iconStyles = null;
var $0ef3ce11fb651b22$var$smallIconStyles = null;
var $0ef3ce11fb651b22$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $0ef3ce11fb651b22$var$baseHcmStyles = null;
var $0ef3ce11fb651b22$var$scaleSize = null;
var $0ef3ce11fb651b22$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $0ef3ce11fb651b22$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $0ef3ce11fb651b22$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $0ef3ce11fb651b22$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $0ef3ce11fb651b22$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $kplgf.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $kplgf.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $0ef3ce11fb651b22$var$coreSizeSmall[spacing] : $0ef3ce11fb651b22$var$coreSizeMedium[spacing]
        ])
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$0ef3ce11fb651b22$export$2e2bcd8739ae039 = $0ef3ce11fb651b22$export$f04a61298a47a40f;

});
parcelRegister("kplgf", function(module, exports) {
$parcel$export(module.exports, "default", () => $edb6a277c1786f75$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $edb6a277c1786f75$var$ATOMIC_GROUP_LENGTH = 5;
function $edb6a277c1786f75$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $edb6a277c1786f75$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("6I9SI", function(module, exports) {
$parcel$export(module.exports, "autoUpdate", () => $4e2e846094f3694a$export$deee3a793edee05f);

var $4qENO = parcelRequire("4qENO");
var $jUtdR = parcelRequire("jUtdR");

var $jUtdR = parcelRequire("jUtdR");

var $lCfwu = parcelRequire("lCfwu");
function $4e2e846094f3694a$var$getCssDimensions(element) {
    const css = (0, $lCfwu.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $lCfwu.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $jUtdR.round)(width) !== offsetWidth || (0, $jUtdR.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $4e2e846094f3694a$var$unwrapElement(element) {
    return !(0, $lCfwu.isElement)(element) ? element.contextElement : element;
}
function $4e2e846094f3694a$var$getScale(element) {
    const domElement = $4e2e846094f3694a$var$unwrapElement(element);
    if (!(0, $lCfwu.isHTMLElement)(domElement)) return (0, $jUtdR.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $4e2e846094f3694a$var$getCssDimensions(domElement);
    let x = ($ ? (0, $jUtdR.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $jUtdR.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $4e2e846094f3694a$var$noOffsets = /*#__PURE__*/ (0, $jUtdR.createCoords)(0);
function $4e2e846094f3694a$var$getVisualOffsets(element) {
    const win = (0, $lCfwu.getWindow)(element);
    if (!(0, $lCfwu.isWebKit)() || !win.visualViewport) return $4e2e846094f3694a$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $4e2e846094f3694a$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $lCfwu.getWindow)(element)) return false;
    return isFixed;
}
function $4e2e846094f3694a$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $4e2e846094f3694a$var$unwrapElement(element);
    let scale = (0, $jUtdR.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $lCfwu.isElement)(offsetParent)) scale = $4e2e846094f3694a$var$getScale(offsetParent);
        } else scale = $4e2e846094f3694a$var$getScale(element);
    }
    const visualOffsets = $4e2e846094f3694a$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $4e2e846094f3694a$var$getVisualOffsets(domElement) : (0, $jUtdR.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $lCfwu.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $lCfwu.isElement)(offsetParent) ? (0, $lCfwu.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $lCfwu.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $4e2e846094f3694a$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $lCfwu.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $lCfwu.getWindow)(currentIFrame);
            currentIFrame = (0, $lCfwu.getFrameElement)(currentWin);
        }
    }
    return (0, $jUtdR.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $4e2e846094f3694a$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $lCfwu.getNodeScroll)(element).scrollLeft;
    if (!rect) return $4e2e846094f3694a$var$getBoundingClientRect((0, $lCfwu.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $4e2e846094f3694a$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $4e2e846094f3694a$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $4e2e846094f3694a$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $lCfwu.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $lCfwu.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $jUtdR.createCoords)(1);
    const offsets = (0, $jUtdR.createCoords)(0);
    const isOffsetParentAnElement = (0, $lCfwu.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $lCfwu.getNodeName)(offsetParent) !== 'body' || (0, $lCfwu.isOverflowElement)(documentElement)) scroll = (0, $lCfwu.getNodeScroll)(offsetParent);
        if ((0, $lCfwu.isHTMLElement)(offsetParent)) {
            const offsetRect = $4e2e846094f3694a$var$getBoundingClientRect(offsetParent);
            scale = $4e2e846094f3694a$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $4e2e846094f3694a$var$getHTMLOffset(documentElement, scroll) : (0, $jUtdR.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $4e2e846094f3694a$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $4e2e846094f3694a$var$getDocumentRect(element) {
    const html = (0, $lCfwu.getDocumentElement)(element);
    const scroll = (0, $lCfwu.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $jUtdR.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $jUtdR.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $4e2e846094f3694a$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $lCfwu.getComputedStyle)(body).direction === 'rtl') x += (0, $jUtdR.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $4e2e846094f3694a$var$SCROLLBAR_MAX = 25;
function $4e2e846094f3694a$var$getViewportRect(element, strategy) {
    const win = (0, $lCfwu.getWindow)(element);
    const html = (0, $lCfwu.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $lCfwu.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $4e2e846094f3694a$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $4e2e846094f3694a$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $4e2e846094f3694a$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
const $4e2e846094f3694a$var$absoluteOrFixed = /*#__PURE__*/ new Set([
    'absolute',
    'fixed'
]);
// Returns the inner client rect, subtracting scrollbars if present.
function $4e2e846094f3694a$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $4e2e846094f3694a$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $lCfwu.isHTMLElement)(element) ? $4e2e846094f3694a$var$getScale(element) : (0, $jUtdR.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $4e2e846094f3694a$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $4e2e846094f3694a$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $4e2e846094f3694a$var$getDocumentRect((0, $lCfwu.getDocumentElement)(element));
    else if ((0, $lCfwu.isElement)(clippingAncestor)) rect = $4e2e846094f3694a$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $4e2e846094f3694a$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $jUtdR.rectToClientRect)(rect);
}
function $4e2e846094f3694a$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $lCfwu.getParentNode)(element);
    if (parentNode === stopNode || !(0, $lCfwu.isElement)(parentNode) || (0, $lCfwu.isLastTraversableNode)(parentNode)) return false;
    return (0, $lCfwu.getComputedStyle)(parentNode).position === 'fixed' || $4e2e846094f3694a$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $4e2e846094f3694a$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $lCfwu.getOverflowAncestors)(element, [], false).filter((el)=>(0, $lCfwu.isElement)(el) && (0, $lCfwu.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $lCfwu.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $lCfwu.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $lCfwu.isElement)(currentNode) && !(0, $lCfwu.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $lCfwu.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $lCfwu.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && $4e2e846094f3694a$var$absoluteOrFixed.has(currentContainingBlockComputedStyle.position) || (0, $lCfwu.isOverflowElement)(currentNode) && !currentNodeIsContaining && $4e2e846094f3694a$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $lCfwu.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $4e2e846094f3694a$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $lCfwu.isTopLayer)(element) ? [] : $4e2e846094f3694a$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $4e2e846094f3694a$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $jUtdR.max)(rect.top, accRect.top);
        accRect.right = (0, $jUtdR.min)(rect.right, accRect.right);
        accRect.bottom = (0, $jUtdR.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $jUtdR.max)(rect.left, accRect.left);
        return accRect;
    }, $4e2e846094f3694a$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $4e2e846094f3694a$var$getDimensions(element) {
    const { width: width, height: height } = $4e2e846094f3694a$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $4e2e846094f3694a$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $lCfwu.isHTMLElement)(offsetParent);
    const documentElement = (0, $lCfwu.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $4e2e846094f3694a$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $jUtdR.createCoords)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $4e2e846094f3694a$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $lCfwu.getNodeName)(offsetParent) !== 'body' || (0, $lCfwu.isOverflowElement)(documentElement)) scroll = (0, $lCfwu.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $4e2e846094f3694a$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $4e2e846094f3694a$var$getHTMLOffset(documentElement, scroll) : (0, $jUtdR.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $4e2e846094f3694a$var$isStaticPositioned(element) {
    return (0, $lCfwu.getComputedStyle)(element).position === 'static';
}
function $4e2e846094f3694a$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $lCfwu.isHTMLElement)(element) || (0, $lCfwu.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $lCfwu.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $4e2e846094f3694a$var$getOffsetParent(element, polyfill) {
    const win = (0, $lCfwu.getWindow)(element);
    if ((0, $lCfwu.isTopLayer)(element)) return win;
    if (!(0, $lCfwu.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $lCfwu.getParentNode)(element);
        while(svgOffsetParent && !(0, $lCfwu.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $lCfwu.isElement)(svgOffsetParent) && !$4e2e846094f3694a$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $lCfwu.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $4e2e846094f3694a$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $lCfwu.isTableElement)(offsetParent) && $4e2e846094f3694a$var$isStaticPositioned(offsetParent))offsetParent = $4e2e846094f3694a$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $lCfwu.isLastTraversableNode)(offsetParent) && $4e2e846094f3694a$var$isStaticPositioned(offsetParent) && !(0, $lCfwu.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $lCfwu.getContainingBlock)(element) || win;
}
const $4e2e846094f3694a$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $4e2e846094f3694a$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $4e2e846094f3694a$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $4e2e846094f3694a$var$isRTL(element) {
    return (0, $lCfwu.getComputedStyle)(element).direction === 'rtl';
}
const $4e2e846094f3694a$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $4e2e846094f3694a$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $lCfwu.getDocumentElement,
    getClippingRect: $4e2e846094f3694a$var$getClippingRect,
    getOffsetParent: $4e2e846094f3694a$var$getOffsetParent,
    getElementRects: $4e2e846094f3694a$var$getElementRects,
    getClientRects: $4e2e846094f3694a$var$getClientRects,
    getDimensions: $4e2e846094f3694a$var$getDimensions,
    getScale: $4e2e846094f3694a$var$getScale,
    isElement: $lCfwu.isElement,
    isRTL: $4e2e846094f3694a$var$isRTL
};
function $4e2e846094f3694a$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $4e2e846094f3694a$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $lCfwu.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $jUtdR.floor)(top);
        const insetRight = (0, $jUtdR.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $jUtdR.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $jUtdR.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $jUtdR.max)(0, (0, $jUtdR.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$4e2e846094f3694a$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $4e2e846094f3694a$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $4e2e846094f3694a$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $lCfwu.getOverflowAncestors)(referenceEl) : [],
        ...(0, $lCfwu.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $4e2e846094f3694a$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $4e2e846094f3694a$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $4e2e846094f3694a$var$getBoundingClientRect(reference);
        if (prevRefRect && !$4e2e846094f3694a$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $4e2e846094f3694a$export$37b6bde19b108ecc = (0, $4qENO.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $4e2e846094f3694a$export$cc800923e997bb8 = (0, $4qENO.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $4e2e846094f3694a$export$91fb6ecbd551914 = (0, $4qENO.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $4e2e846094f3694a$export$fba63a578e423eb = (0, $4qENO.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $4e2e846094f3694a$export$8a83211c878a3f1f = (0, $4qENO.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $4e2e846094f3694a$export$346677f925de839c = (0, $4qENO.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $4e2e846094f3694a$export$fe8985bb6374093c = (0, $4qENO.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $4e2e846094f3694a$export$f2120bbfa5450bd2 = (0, $4qENO.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $4e2e846094f3694a$export$18c8ad048e32c7d5 = (0, $4qENO.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $4e2e846094f3694a$export$7bf07e38f3dc4b69 = (0, $4qENO.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $4e2e846094f3694a$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $4e2e846094f3694a$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $4qENO.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("4qENO", function(module, exports) {
$parcel$export(module.exports, "computePosition", () => $33993daa3d6e1e95$export$48a53dcb22e581d0);
$parcel$export(module.exports, "detectOverflow", () => $33993daa3d6e1e95$export$37b6bde19b108ecc);
$parcel$export(module.exports, "arrow", () => $33993daa3d6e1e95$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $33993daa3d6e1e95$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $33993daa3d6e1e95$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $33993daa3d6e1e95$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $33993daa3d6e1e95$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $33993daa3d6e1e95$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $33993daa3d6e1e95$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $33993daa3d6e1e95$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $33993daa3d6e1e95$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("jUtdR")).rectToClientRect);

var $jUtdR = parcelRequire("jUtdR");
function $33993daa3d6e1e95$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $jUtdR.getSideAxis)(placement);
    const alignmentAxis = (0, $jUtdR.getAlignmentAxis)(placement);
    const alignLength = (0, $jUtdR.getAxisLength)(alignmentAxis);
    const side = (0, $jUtdR.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $jUtdR.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $33993daa3d6e1e95$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $33993daa3d6e1e95$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $33993daa3d6e1e95$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $33993daa3d6e1e95$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $jUtdR.evaluate)(options, state);
    const paddingObject = (0, $jUtdR.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $jUtdR.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $jUtdR.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $33993daa3d6e1e95$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $jUtdR.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $jUtdR.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $jUtdR.getAlignmentAxis)(placement);
            const length = (0, $jUtdR.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $jUtdR.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $jUtdR.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $jUtdR.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $jUtdR.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $33993daa3d6e1e95$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $jUtdR.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $jUtdR.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $jUtdR.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $jUtdR.getAlignment)(placement) === alignment || (autoAlignment ? (0, $jUtdR.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $33993daa3d6e1e95$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $jUtdR.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $jUtdR.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $jUtdR.placements) ? $33993daa3d6e1e95$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $33993daa3d6e1e95$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $jUtdR.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $jUtdR.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $jUtdR.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $jUtdR.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $33993daa3d6e1e95$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $jUtdR.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $jUtdR.getSide)(placement);
            const initialSideAxis = (0, $jUtdR.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $jUtdR.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $jUtdR.getOppositePlacement)(initialPlacement)
            ] : (0, $jUtdR.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $jUtdR.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $33993daa3d6e1e95$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $jUtdR.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $jUtdR.getSideAxis)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $jUtdR.getSideAxis)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $jUtdR.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $33993daa3d6e1e95$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $33993daa3d6e1e95$var$isAnySideFullyClipped(overflow) {
    return (0, $jUtdR.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $33993daa3d6e1e95$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $jUtdR.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $33993daa3d6e1e95$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $33993daa3d6e1e95$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $33993daa3d6e1e95$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $33993daa3d6e1e95$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $33993daa3d6e1e95$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $33993daa3d6e1e95$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $33993daa3d6e1e95$var$getBoundingRect(rects) {
    const minX = (0, $jUtdR.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $jUtdR.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $jUtdR.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $jUtdR.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $33993daa3d6e1e95$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $jUtdR.rectToClientRect)($33993daa3d6e1e95$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $33993daa3d6e1e95$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $jUtdR.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $33993daa3d6e1e95$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $jUtdR.rectToClientRect)($33993daa3d6e1e95$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $jUtdR.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $jUtdR.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $jUtdR.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $jUtdR.getSide)(placement) === 'left';
                    const maxRight = (0, $jUtdR.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $jUtdR.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $33993daa3d6e1e95$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $33993daa3d6e1e95$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $jUtdR.getSide)(placement);
    const alignment = (0, $jUtdR.getAlignment)(placement);
    const isVertical = (0, $jUtdR.getSideAxis)(placement) === 'y';
    const mainAxisMulti = $33993daa3d6e1e95$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $jUtdR.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $33993daa3d6e1e95$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $33993daa3d6e1e95$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $33993daa3d6e1e95$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $jUtdR.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $33993daa3d6e1e95$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $jUtdR.getSideAxis)((0, $jUtdR.getSide)(placement));
            const mainAxis = (0, $jUtdR.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $jUtdR.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $jUtdR.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $33993daa3d6e1e95$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $jUtdR.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $jUtdR.getSideAxis)(placement);
            const mainAxis = (0, $jUtdR.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $jUtdR.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $33993daa3d6e1e95$var$originSides.has((0, $jUtdR.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $33993daa3d6e1e95$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $jUtdR.evaluate)(options, state);
            const overflow = await $33993daa3d6e1e95$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $jUtdR.getSide)(placement);
            const alignment = (0, $jUtdR.getAlignment)(placement);
            const isYAxis = (0, $jUtdR.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $jUtdR.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $jUtdR.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $jUtdR.max)(overflow.left, 0);
                const xMax = (0, $jUtdR.max)(overflow.right, 0);
                const yMin = (0, $jUtdR.max)(overflow.top, 0);
                const yMax = (0, $jUtdR.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $jUtdR.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $jUtdR.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("jUtdR", function(module, exports) {
$parcel$export(module.exports, "sides", () => $e7e9ea41d02eb0ae$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $e7e9ea41d02eb0ae$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $e7e9ea41d02eb0ae$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $e7e9ea41d02eb0ae$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $e7e9ea41d02eb0ae$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $e7e9ea41d02eb0ae$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $e7e9ea41d02eb0ae$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $e7e9ea41d02eb0ae$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $e7e9ea41d02eb0ae$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $e7e9ea41d02eb0ae$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $e7e9ea41d02eb0ae$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $e7e9ea41d02eb0ae$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $e7e9ea41d02eb0ae$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $e7e9ea41d02eb0ae$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $e7e9ea41d02eb0ae$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $e7e9ea41d02eb0ae$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $e7e9ea41d02eb0ae$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $e7e9ea41d02eb0ae$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $e7e9ea41d02eb0ae$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $e7e9ea41d02eb0ae$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $e7e9ea41d02eb0ae$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $e7e9ea41d02eb0ae$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $e7e9ea41d02eb0ae$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $e7e9ea41d02eb0ae$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $e7e9ea41d02eb0ae$export$803cd8101b6c182b = /*#__PURE__*/ $e7e9ea41d02eb0ae$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $e7e9ea41d02eb0ae$export$27b07d8a310ed8b5[0], side + "-" + $e7e9ea41d02eb0ae$export$27b07d8a310ed8b5[1]), []);
const $e7e9ea41d02eb0ae$export$96ec731ed4dcb222 = Math.min;
const $e7e9ea41d02eb0ae$export$8960430cfd85939f = Math.max;
const $e7e9ea41d02eb0ae$export$2077e0241d6afd3c = Math.round;
const $e7e9ea41d02eb0ae$export$a3fe094919f356fd = Math.floor;
const $e7e9ea41d02eb0ae$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $e7e9ea41d02eb0ae$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $e7e9ea41d02eb0ae$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $e7e9ea41d02eb0ae$export$7d15b64cf5a3a4c4(start, value, end) {
    return $e7e9ea41d02eb0ae$export$8960430cfd85939f(start, $e7e9ea41d02eb0ae$export$96ec731ed4dcb222(value, end));
}
function $e7e9ea41d02eb0ae$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $e7e9ea41d02eb0ae$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $e7e9ea41d02eb0ae$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $e7e9ea41d02eb0ae$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $e7e9ea41d02eb0ae$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
const $e7e9ea41d02eb0ae$var$yAxisSides = /*#__PURE__*/ new Set([
    'top',
    'bottom'
]);
function $e7e9ea41d02eb0ae$export$f28e8f882010718a(placement) {
    return $e7e9ea41d02eb0ae$var$yAxisSides.has($e7e9ea41d02eb0ae$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $e7e9ea41d02eb0ae$export$2b57e0052a6d6d4c(placement) {
    return $e7e9ea41d02eb0ae$export$8a000a963141ac32($e7e9ea41d02eb0ae$export$f28e8f882010718a(placement));
}
function $e7e9ea41d02eb0ae$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $e7e9ea41d02eb0ae$export$f0989780f32bfcda(placement);
    const alignmentAxis = $e7e9ea41d02eb0ae$export$2b57e0052a6d6d4c(placement);
    const length = $e7e9ea41d02eb0ae$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $e7e9ea41d02eb0ae$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $e7e9ea41d02eb0ae$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $e7e9ea41d02eb0ae$export$496432a3699e50b1(placement) {
    const oppositePlacement = $e7e9ea41d02eb0ae$export$9c5e28bad23365fa(placement);
    return [
        $e7e9ea41d02eb0ae$export$2b182c584985588b(placement),
        oppositePlacement,
        $e7e9ea41d02eb0ae$export$2b182c584985588b(oppositePlacement)
    ];
}
function $e7e9ea41d02eb0ae$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$e7e9ea41d02eb0ae$var$oppositeAlignmentMap[alignment]);
}
const $e7e9ea41d02eb0ae$var$lrPlacement = [
    'left',
    'right'
];
const $e7e9ea41d02eb0ae$var$rlPlacement = [
    'right',
    'left'
];
const $e7e9ea41d02eb0ae$var$tbPlacement = [
    'top',
    'bottom'
];
const $e7e9ea41d02eb0ae$var$btPlacement = [
    'bottom',
    'top'
];
function $e7e9ea41d02eb0ae$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $e7e9ea41d02eb0ae$var$rlPlacement : $e7e9ea41d02eb0ae$var$lrPlacement;
            return isStart ? $e7e9ea41d02eb0ae$var$lrPlacement : $e7e9ea41d02eb0ae$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $e7e9ea41d02eb0ae$var$tbPlacement : $e7e9ea41d02eb0ae$var$btPlacement;
        default:
            return [];
    }
}
function $e7e9ea41d02eb0ae$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $e7e9ea41d02eb0ae$export$f0989780f32bfcda(placement);
    let list = $e7e9ea41d02eb0ae$var$getSideList($e7e9ea41d02eb0ae$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($e7e9ea41d02eb0ae$export$2b182c584985588b));
    }
    return list;
}
function $e7e9ea41d02eb0ae$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$e7e9ea41d02eb0ae$var$oppositeSideMap[side]);
}
function $e7e9ea41d02eb0ae$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $e7e9ea41d02eb0ae$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $e7e9ea41d02eb0ae$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $e7e9ea41d02eb0ae$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("lCfwu", function(module, exports) {
$parcel$export(module.exports, "getNodeName", () => $fbc93020b6eaf48c$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $fbc93020b6eaf48c$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $fbc93020b6eaf48c$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $fbc93020b6eaf48c$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $fbc93020b6eaf48c$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isOverflowElement", () => $fbc93020b6eaf48c$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $fbc93020b6eaf48c$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $fbc93020b6eaf48c$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $fbc93020b6eaf48c$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $fbc93020b6eaf48c$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $fbc93020b6eaf48c$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $fbc93020b6eaf48c$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $fbc93020b6eaf48c$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $fbc93020b6eaf48c$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $fbc93020b6eaf48c$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $fbc93020b6eaf48c$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $fbc93020b6eaf48c$export$7bf1f8740e3e34af);
function $fbc93020b6eaf48c$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $fbc93020b6eaf48c$export$651544f548703224(node) {
    if ($fbc93020b6eaf48c$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $fbc93020b6eaf48c$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $fbc93020b6eaf48c$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($fbc93020b6eaf48c$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $fbc93020b6eaf48c$export$8ee0fc9ee280b4ee(value) {
    if (!$fbc93020b6eaf48c$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $fbc93020b6eaf48c$export$38b2d434cce3ea22(value).Node;
}
function $fbc93020b6eaf48c$export$45a5e7f76e0caa8d(value) {
    if (!$fbc93020b6eaf48c$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $fbc93020b6eaf48c$export$38b2d434cce3ea22(value).Element;
}
function $fbc93020b6eaf48c$export$1b3bfaa9684536aa(value) {
    if (!$fbc93020b6eaf48c$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $fbc93020b6eaf48c$export$38b2d434cce3ea22(value).HTMLElement;
}
function $fbc93020b6eaf48c$export$af51f0f06c0f328a(value) {
    if (!$fbc93020b6eaf48c$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $fbc93020b6eaf48c$export$38b2d434cce3ea22(value).ShadowRoot;
}
const $fbc93020b6eaf48c$var$invalidOverflowDisplayValues = /*#__PURE__*/ new Set([
    'inline',
    'contents'
]);
function $fbc93020b6eaf48c$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $fbc93020b6eaf48c$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !$fbc93020b6eaf48c$var$invalidOverflowDisplayValues.has(display);
}
const $fbc93020b6eaf48c$var$tableElements = /*#__PURE__*/ new Set([
    'table',
    'td',
    'th'
]);
function $fbc93020b6eaf48c$export$71535ffaa902797f(element) {
    return $fbc93020b6eaf48c$var$tableElements.has($fbc93020b6eaf48c$export$651544f548703224(element));
}
const $fbc93020b6eaf48c$var$topLayerSelectors = [
    ':popover-open',
    ':modal'
];
function $fbc93020b6eaf48c$export$89e651af02346cd4(element) {
    return $fbc93020b6eaf48c$var$topLayerSelectors.some((selector)=>{
        try {
            return element.matches(selector);
        } catch (_e) {
            return false;
        }
    });
}
const $fbc93020b6eaf48c$var$transformProperties = [
    'transform',
    'translate',
    'scale',
    'rotate',
    'perspective'
];
const $fbc93020b6eaf48c$var$willChangeValues = [
    'transform',
    'translate',
    'scale',
    'rotate',
    'perspective',
    'filter'
];
const $fbc93020b6eaf48c$var$containValues = [
    'paint',
    'layout',
    'strict',
    'content'
];
function $fbc93020b6eaf48c$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $fbc93020b6eaf48c$export$78551043582a6a98();
    const css = $fbc93020b6eaf48c$export$45a5e7f76e0caa8d(elementOrCss) ? $fbc93020b6eaf48c$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $fbc93020b6eaf48c$var$transformProperties.some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || $fbc93020b6eaf48c$var$willChangeValues.some((value)=>(css.willChange || '').includes(value)) || $fbc93020b6eaf48c$var$containValues.some((value)=>(css.contain || '').includes(value));
}
function $fbc93020b6eaf48c$export$940d8225183e1404(element) {
    let currentNode = $fbc93020b6eaf48c$export$4e12058fc4d51d56(element);
    while($fbc93020b6eaf48c$export$1b3bfaa9684536aa(currentNode) && !$fbc93020b6eaf48c$export$d1162fb0b6d4cd51(currentNode)){
        if ($fbc93020b6eaf48c$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($fbc93020b6eaf48c$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $fbc93020b6eaf48c$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $fbc93020b6eaf48c$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
const $fbc93020b6eaf48c$var$lastTraversableNodeNames = /*#__PURE__*/ new Set([
    'html',
    'body',
    '#document'
]);
function $fbc93020b6eaf48c$export$d1162fb0b6d4cd51(node) {
    return $fbc93020b6eaf48c$var$lastTraversableNodeNames.has($fbc93020b6eaf48c$export$651544f548703224(node));
}
function $fbc93020b6eaf48c$export$3735103072e4a80(element) {
    return $fbc93020b6eaf48c$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $fbc93020b6eaf48c$export$dc8fc79fa2800137(element) {
    if ($fbc93020b6eaf48c$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $fbc93020b6eaf48c$export$4e12058fc4d51d56(node) {
    if ($fbc93020b6eaf48c$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $fbc93020b6eaf48c$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $fbc93020b6eaf48c$export$e495491855dc5418(node);
    return $fbc93020b6eaf48c$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $fbc93020b6eaf48c$export$7cd01a57c8ca906c(node) {
    const parentNode = $fbc93020b6eaf48c$export$4e12058fc4d51d56(node);
    if ($fbc93020b6eaf48c$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($fbc93020b6eaf48c$export$1b3bfaa9684536aa(parentNode) && $fbc93020b6eaf48c$export$989e911fa9af580a(parentNode)) return parentNode;
    return $fbc93020b6eaf48c$export$7cd01a57c8ca906c(parentNode);
}
function $fbc93020b6eaf48c$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $fbc93020b6eaf48c$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $fbc93020b6eaf48c$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $fbc93020b6eaf48c$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $fbc93020b6eaf48c$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $fbc93020b6eaf48c$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $fbc93020b6eaf48c$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $fbc93020b6eaf48c$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("lhDQM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("04bWN")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("04bWN")).Icon);

var $04bWN = parcelRequire("04bWN");

});
parcelRegister("04bWN", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $00c9a45ad1a2a4a7$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $00c9a45ad1a2a4a7$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $7NBLq = parcelRequire("7NBLq");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $00c9a45ad1a2a4a7$var$svgStyles = null;
var $00c9a45ad1a2a4a7$var$iconStyles = null;
var $00c9a45ad1a2a4a7$var$smallIconStyles = null;
var $00c9a45ad1a2a4a7$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $00c9a45ad1a2a4a7$var$baseHcmStyles = null;
var $00c9a45ad1a2a4a7$var$scaleSize = null;
var $00c9a45ad1a2a4a7$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $00c9a45ad1a2a4a7$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $00c9a45ad1a2a4a7$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $00c9a45ad1a2a4a7$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $00c9a45ad1a2a4a7$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $7NBLq.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $7NBLq.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $00c9a45ad1a2a4a7$var$coreSizeSmall[spacing] : $00c9a45ad1a2a4a7$var$coreSizeMedium[spacing]
        ])
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$00c9a45ad1a2a4a7$export$2e2bcd8739ae039 = $00c9a45ad1a2a4a7$export$f04a61298a47a40f;

});
parcelRegister("7NBLq", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ada671d22b5e56e$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $5ada671d22b5e56e$var$ATOMIC_GROUP_LENGTH = 5;
function $5ada671d22b5e56e$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $5ada671d22b5e56e$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("lnqhJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("9xOmG")).default);
$parcel$export(module.exports, "ModalTransition", () => (parcelRequire("4dmfM")).default);
$parcel$export(module.exports, "ModalHeader", () => (parcelRequire("9Ayri")).default);
$parcel$export(module.exports, "ModalTitle", () => (parcelRequire("9Bq1o")).default);
$parcel$export(module.exports, "ModalBody", () => (parcelRequire("7FyjL")).default);
$parcel$export(module.exports, "ModalFooter", () => (parcelRequire("bhMlj")).default);
$parcel$export(module.exports, "CloseButton", () => (parcelRequire("3aP8P")).CloseButton);
$parcel$export(module.exports, "useModal", () => (parcelRequire("2td33")).useModal);

var $9xOmG = parcelRequire("9xOmG");

var $4dmfM = parcelRequire("4dmfM");

var $9Ayri = parcelRequire("9Ayri");

var $9Bq1o = parcelRequire("9Bq1o");

var $7FyjL = parcelRequire("7FyjL");

var $bhMlj = parcelRequire("bhMlj");

var $3aP8P = parcelRequire("3aP8P");

var $2td33 = parcelRequire("2td33");

});
parcelRegister("9xOmG", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f2e438a9235242f$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $69J3E = parcelRequire("69J3E");

var $3FlkA = parcelRequire("3FlkA");

var $ijhrq = parcelRequire("ijhrq");

var $3l6Hs = parcelRequire("3l6Hs");

var $6qCqe = parcelRequire("6qCqe");

var $5PqYO = parcelRequire("5PqYO");

var $eQzrx = parcelRequire("eQzrx");

var $6bqMl = parcelRequire("6bqMl");

var $H74DA = parcelRequire("H74DA");

var $6MmJQ = parcelRequire("6MmJQ");

var $60tyR = parcelRequire("60tyR");

var $deUvr = parcelRequire("deUvr");
var $6f2e438a9235242f$var$fillScreenStyles = (0, $74Zh5.css)({
    width: '100vw',
    height: '100vh',
    position: 'fixed',
    insetBlockStart: "var(--ds-space-0, 0)",
    insetInlineStart: "var(--ds-space-0, 0)",
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch'
});
var $6f2e438a9235242f$var$allowlistElements = function allowlistElements(element, callback) {
    // Allow focus to reach elements outside the modal:
    // if AUI dialog is allowListed and visible
    if (!!document.querySelector('.aui-blanket:not([hidden])')) return false;
    // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $6f2e438a9235242f$var$ModalWrapper = function ModalWrapper(props) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, focusLockAllowlist = props.focusLockAllowlist, _props$shouldCloseOnE = props.shouldCloseOnEscapePress, shouldCloseOnEscapePress = _props$shouldCloseOnE === void 0 ? true : _props$shouldCloseOnE, _props$shouldCloseOnO = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _props$shouldCloseOnO === void 0 ? true : _props$shouldCloseOnO, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, _props$shouldReturnFo = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo === void 0 ? true : _props$shouldReturnFo, stackIndexOverride = props.stackIndex, providedOnClose = props.onClose, _props$onStackChange = props.onStackChange, onStackChange = _props$onStackChange === void 0 ? (0, $6qCqe.default) : _props$onStackChange, isBlanketHidden = props.isBlanketHidden, children = props.children, height = props.height, width = props.width, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, label = props.label, testId = props.testId;
    var calculatedStackIndex = (0, $60tyR.default)({
        onStackChange: onStackChange
    });
    var stackIndex = stackIndexOverride || calculatedStackIndex;
    var isForeground = stackIndex === 0;
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    var autoFocusLock = typeof autoFocus === 'boolean' ? autoFocus : false;
    var onCloseHandler = (0, $ijhrq.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, $6qCqe.default),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: "@atlaskit/modal-dialog",
        packageVersion: "13.4.0"
    });
    var onBlanketClicked = (0, $5FkrB.useCallback)(function(e) {
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    var allowListCallback = (0, $5FkrB.useCallback)(function(element) {
        return $6f2e438a9235242f$var$allowlistElements(element, focusLockAllowlist);
    }, [
        focusLockAllowlist
    ]);
    (0, $deUvr.default)();
    var modalDialogWithBlanket = (0, $74Zh5.jsx)((0, $3l6Hs.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && "".concat(testId, "--blanket")
    }, (0, $74Zh5.jsx)((0, $6MmJQ.default), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete,
        hasProvidedOnClose: Boolean(providedOnClose)
    }, children));
    var returnFocus = true;
    var onDeactivation;
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = function onDeactivation() {
        window.setTimeout(function() {
            var _shouldReturnFocus$cu;
            (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return (0, $74Zh5.jsx)((0, $5PqYO.Layering), {
        isDisabled: false
    }, (0, $74Zh5.jsx)((0, $6bqMl.default), {
        zIndex: (0, $H74DA.layers).modal()
    }, (0, $74Zh5.jsx)((0, $eQzrx.default), null, function(fadeInProps) {
        return (0, $74Zh5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, fadeInProps, {
            css: $6f2e438a9235242f$var$fillScreenStyles,
            "aria-hidden": !isForeground
        }), (0, $74Zh5.jsx)((0, $69J3E.default), {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3FlkA))), null), shouldScrollInViewport ? (0, $74Zh5.jsx)((0, $3FlkA.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket));
    })));
};
var $6f2e438a9235242f$export$2e2bcd8739ae039 = $6f2e438a9235242f$var$ModalWrapper;

});
parcelRegister("ijhrq", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $d54787db068fe266$export$a4687b0234b40e28);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $h0OAL = parcelRequire("h0OAL");

var $b6wQg = parcelRequire("b6wQg");
function $d54787db068fe266$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d54787db068fe266$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d54787db068fe266$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d54787db068fe266$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d54787db068fe266$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $h0OAL.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $b6wQg.useTrackedRef)(analyticsData);
    var fnRef = (0, $b6wQg.useTrackedRef)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $d54787db068fe266$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("h0OAL", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $c629ae4a42f07e5a$export$5bf35293e545f20c);

var $dLGML = parcelRequire("dLGML");

var $4rPfW = parcelRequire("4rPfW");

var $l8CIV = parcelRequire("l8CIV");
function $c629ae4a42f07e5a$export$5bf35293e545f20c() {
    var analyticsContext = (0, $l8CIV.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $4rPfW.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("4rPfW", function(module, exports) {
$parcel$export(module.exports, "default", () => $33d17171e94b4e72$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $bc7q5 = parcelRequire("bc7q5");
function $33d17171e94b4e72$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $33d17171e94b4e72$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $33d17171e94b4e72$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($33d17171e94b4e72$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $33d17171e94b4e72$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $33d17171e94b4e72$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $33d17171e94b4e72$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $33d17171e94b4e72$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $33d17171e94b4e72$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $33d17171e94b4e72$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $bc7q5.default));

});
parcelRegister("bc7q5", function(module, exports) {
$parcel$export(module.exports, "default", () => $826692188de79168$export$2e2bcd8739ae039);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $826692188de79168$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $826692188de79168$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $826692188de79168$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $826692188de79168$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $826692188de79168$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $826692188de79168$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $826692188de79168$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $826692188de79168$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $826692188de79168$var$_objectSpread($826692188de79168$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("l8CIV", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $f638620dd2640057$export$d1f587f82ad51c4);

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $f638620dd2640057$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};

});


parcelRegister("b6wQg", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $8159bafcb7f117ba$export$1d27a74659855e44);

var $5FkrB = parcelRequire("5FkrB");
var $8159bafcb7f117ba$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("3l6Hs", function(module, exports) {
$parcel$export(module.exports, "default", () => $26e887b9f7bae754$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $jY1dw = parcelRequire("jY1dw");
var $6YKKQ = parcelRequire("6YKKQ");

var $hO1fo = parcelRequire("hO1fo");

var $bzBzM = parcelRequire("bzBzM");

var $3GGfT = parcelRequire("3GGfT");

function $26e887b9f7bae754$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $26e887b9f7bae754$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $26e887b9f7bae754$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $26e887b9f7bae754$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $26e887b9f7bae754$var$packageName = "@atlaskit/blanket";
var $26e887b9f7bae754$var$packageVersion = "0.0.0-development";
var $26e887b9f7bae754$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $26e887b9f7bae754$var$packageName,
    packageVersion: $26e887b9f7bae754$var$packageVersion
};
var $26e887b9f7bae754$var$baseStyles = null;
var $26e887b9f7bae754$var$shouldAllowClickThroughStyles = null;
var $26e887b9f7bae754$var$invisibleStyles = null;
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ var $26e887b9f7bae754$var$Blanket = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function Blanket(_ref, ref) {
    var _ref$shouldAllowClick = _ref.shouldAllowClickThrough, shouldAllowClickThrough = _ref$shouldAllowClick === void 0 ? false : _ref$shouldAllowClick, _ref$isTinted = _ref.isTinted, isTinted = _ref$isTinted === void 0 ? false : _ref$isTinted, _ref$onBlanketClicked = _ref.onBlanketClicked, onBlanketClicked = _ref$onBlanketClicked === void 0 ? (0, $bzBzM.default) : _ref$onBlanketClicked, testId = _ref.testId, children = _ref.children, analyticsContext = _ref.analyticsContext;
    var mouseDownTarget = (0, $5FkrB.useRef)(null);
    var onBlanketClickedWithAnalytics = (0, $hO1fo.usePlatformLeafEventHandler)($26e887b9f7bae754$var$_objectSpread({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext
    }, $26e887b9f7bae754$var$analyticsAttributes));
    var blanketClickOutsideChildren = (0, $5FkrB.useCallback)(function(e) {
        return e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined;
    }, [
        onBlanketClickedWithAnalytics
    ]);
    var onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    var onMouseDown = (0, $5FkrB.useCallback)(function(e) {
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $jY1dw.default)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk705f _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk1j28"
        ]),
        style: {
            "--_10avjlk": (0, $6YKKQ.default)("var(--ds-blanket, ".concat((0, $3GGfT.N100A), ")"))
        }
    }, children);
}));
$26e887b9f7bae754$var$Blanket.displayName = 'Blanket';
var $26e887b9f7bae754$export$2e2bcd8739ae039 = $26e887b9f7bae754$var$Blanket;

});
parcelRegister("jY1dw", function(module, exports) {
$parcel$export(module.exports, "default", () => $e894909735e2e7b5$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $e894909735e2e7b5$var$ATOMIC_GROUP_LENGTH = 5;
function $e894909735e2e7b5$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $e894909735e2e7b5$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("6YKKQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $514c9d26260034b4$export$2e2bcd8739ae039);
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $514c9d26260034b4$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("hO1fo", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $cf6812dd852c5bdc$export$a4687b0234b40e28);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $3zwUi = parcelRequire("3zwUi");

var $YTRzE = parcelRequire("YTRzE");
function $cf6812dd852c5bdc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cf6812dd852c5bdc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cf6812dd852c5bdc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cf6812dd852c5bdc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cf6812dd852c5bdc$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $3zwUi.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $YTRzE.useTrackedRef)(analyticsData);
    var fnRef = (0, $YTRzE.useTrackedRef)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $cf6812dd852c5bdc$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("3zwUi", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $299e2aa46606cd36$export$5bf35293e545f20c);

var $dLGML = parcelRequire("dLGML");

var $iNIMD = parcelRequire("iNIMD");

var $exRaS = parcelRequire("exRaS");
function $299e2aa46606cd36$export$5bf35293e545f20c() {
    var analyticsContext = (0, $exRaS.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $iNIMD.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("iNIMD", function(module, exports) {
$parcel$export(module.exports, "default", () => $daff8aaaa3c7b417$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $cdVWh = parcelRequire("cdVWh");
function $daff8aaaa3c7b417$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $daff8aaaa3c7b417$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $daff8aaaa3c7b417$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($daff8aaaa3c7b417$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $daff8aaaa3c7b417$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $daff8aaaa3c7b417$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $daff8aaaa3c7b417$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $daff8aaaa3c7b417$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $daff8aaaa3c7b417$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $daff8aaaa3c7b417$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $cdVWh.default));

});
parcelRegister("cdVWh", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e63a46f8902db3d$export$2e2bcd8739ae039);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $8e63a46f8902db3d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8e63a46f8902db3d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8e63a46f8902db3d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8e63a46f8902db3d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8e63a46f8902db3d$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $8e63a46f8902db3d$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $8e63a46f8902db3d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $8e63a46f8902db3d$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $8e63a46f8902db3d$var$_objectSpread($8e63a46f8902db3d$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("exRaS", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $a96d651ae8b1a23b$export$d1f587f82ad51c4);

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $a96d651ae8b1a23b$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};

});


parcelRegister("YTRzE", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $0b70eff58250ff9a$export$1d27a74659855e44);

var $5FkrB = parcelRequire("5FkrB");
var $0b70eff58250ff9a$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("bzBzM", function(module, exports) {
$parcel$export(module.exports, "default", () => $86d01c6a1c1fa572$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $86d01c6a1c1fa572$export$2e2bcd8739ae039() {}

});

parcelRegister("3GGfT", function(module, exports) {
$parcel$export(module.exports, "N100A", () => $2af6125e25d1cf3c$export$486ab785e4bac3c6);
// Reds
var $2af6125e25d1cf3c$export$4b84fd0e2c617bd = '#FFEBE6';
var $2af6125e25d1cf3c$export$b34b069eff244586 = '#FFBDAD';
var $2af6125e25d1cf3c$export$be802dd0d8b57f35 = '#FF8F73';
var $2af6125e25d1cf3c$export$60847d42f9da92a6 = '#FF7452';
var $2af6125e25d1cf3c$export$4a7404f376229999 = '#FF5630';
var $2af6125e25d1cf3c$export$2010d0fb4295b346 = '#DE350B';
var $2af6125e25d1cf3c$export$2837b5a1a71d5c02 = '#BF2600';
var $2af6125e25d1cf3c$export$8d9596b529bbb9cf = '#FFFAE6';
var $2af6125e25d1cf3c$export$41060a744ab0b7ae = '#FFF0B3';
var $2af6125e25d1cf3c$export$1cc05bbbf340e559 = '#FFE380';
var $2af6125e25d1cf3c$export$5aae31392d72caaa = '#FFC400';
var $2af6125e25d1cf3c$export$c6930421db9fa514 = '#FFAB00';
var $2af6125e25d1cf3c$export$59619663aa6500fb = '#FF991F';
var $2af6125e25d1cf3c$export$874739ea9e379ab6 = '#FF8B00';
var $2af6125e25d1cf3c$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $2af6125e25d1cf3c$export$69a3bf21b9686c2b = '#ABF5D1';
var $2af6125e25d1cf3c$export$afbce1382ec95f73 = '#79F2C0';
var $2af6125e25d1cf3c$export$747d86715d4175de = '#57D9A3';
var $2af6125e25d1cf3c$export$940e1f69e873f202 = '#36B37E';
var $2af6125e25d1cf3c$export$a49394138f7b8e85 = '#00875A';
var $2af6125e25d1cf3c$export$6fa04827ac68a4fb = '#006644';
var $2af6125e25d1cf3c$export$226de0355ed012f8 = '#DEEBFF';
var $2af6125e25d1cf3c$export$8c13c2ee36917869 = '#B3D4FF';
var $2af6125e25d1cf3c$export$ecfc1dff386a3e7a = '#4C9AFF';
var $2af6125e25d1cf3c$export$215b7063051591f1 = '#2684FF';
var $2af6125e25d1cf3c$export$e62e8919cca44969 = '#0065FF';
var $2af6125e25d1cf3c$export$b3de0ae08da2ce64 = '#0052CC';
var $2af6125e25d1cf3c$export$a6ee3d71bc067634 = '#0747A6';
var $2af6125e25d1cf3c$export$67f15409e87642a1 = '#669DF1';
var $2af6125e25d1cf3c$export$f0539dbc42dbb067 = '#8FB8F6';
var $2af6125e25d1cf3c$export$363e4475840015bb = '#EAE6FF';
var $2af6125e25d1cf3c$export$4b0a4417ed59760f = '#C0B6F2';
var $2af6125e25d1cf3c$export$6011520a64d9a187 = '#998DD9';
var $2af6125e25d1cf3c$export$a7175d4e9206bc80 = '#8777D9';
var $2af6125e25d1cf3c$export$b48405b95304b5a1 = '#6554C0';
var $2af6125e25d1cf3c$export$c71e4279dd54a18d = '#5243AA';
var $2af6125e25d1cf3c$export$147899de772240ec = '#403294';
var $2af6125e25d1cf3c$export$2cf711fe14c66f06 = '#E6FCFF';
var $2af6125e25d1cf3c$export$7a8f4d33f6f9772c = '#B3F5FF';
var $2af6125e25d1cf3c$export$776c9c497ef08533 = '#79E2F2';
var $2af6125e25d1cf3c$export$69cb3ca10c1e330e = '#00C7E6';
var $2af6125e25d1cf3c$export$9dc1ef0f3f48059b = '#00B8D9';
var $2af6125e25d1cf3c$export$7c835c78b6fcdef8 = '#00A3BF';
var $2af6125e25d1cf3c$export$6036577f95c3877e = '#008DA6';
var $2af6125e25d1cf3c$export$29a4f05edc054374 = '#FFFFFF';
var $2af6125e25d1cf3c$export$e655ef011c4aa1a2 = '#FAFBFC';
var $2af6125e25d1cf3c$export$9fdfb749e33cdf97 = '#F4F5F7';
var $2af6125e25d1cf3c$export$3e51e8f1440314ba = '#EBECF0';
var $2af6125e25d1cf3c$export$1ce2d1575d444ceb = '#DFE1E6';
var $2af6125e25d1cf3c$export$8754fc7e6d8b3000 = '#C1C7D0';
var $2af6125e25d1cf3c$export$c2e91cbeada39b8b = '#B3BAC5';
var $2af6125e25d1cf3c$export$5f71e19f3a7ad9de = '#A5ADBA';
var $2af6125e25d1cf3c$export$eaa8c8a70ac22806 = '#97A0AF';
var $2af6125e25d1cf3c$export$7c87d337fb91a97d = '#8993A4';
var $2af6125e25d1cf3c$export$d6447c357493214f = '#7A869A';
var $2af6125e25d1cf3c$export$f563ee71e9ee74cd = '#6B778C';
var $2af6125e25d1cf3c$export$e2ef2124cf4024b1 = '#5E6C84';
var $2af6125e25d1cf3c$export$eece5f492e429f08 = '#505F79';
var $2af6125e25d1cf3c$export$c39c0fe0f26207ae = '#42526E';
var $2af6125e25d1cf3c$export$7090862dc3038a9f = '#344563';
var $2af6125e25d1cf3c$export$ad0bacf983b7ddaa = '#253858';
var $2af6125e25d1cf3c$export$7d61b15e0da132af = '#172B4D';
var $2af6125e25d1cf3c$export$fbda843f0a27fe96 = '#091E42';
var $2af6125e25d1cf3c$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $2af6125e25d1cf3c$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $2af6125e25d1cf3c$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $2af6125e25d1cf3c$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $2af6125e25d1cf3c$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $2af6125e25d1cf3c$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $2af6125e25d1cf3c$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $2af6125e25d1cf3c$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $2af6125e25d1cf3c$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $2af6125e25d1cf3c$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $2af6125e25d1cf3c$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $2af6125e25d1cf3c$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $2af6125e25d1cf3c$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $2af6125e25d1cf3c$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $2af6125e25d1cf3c$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $2af6125e25d1cf3c$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $2af6125e25d1cf3c$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $2af6125e25d1cf3c$export$2f6319cf7d736c2a = '#E6EDFA';
var $2af6125e25d1cf3c$export$95126bc8884d6634 = '#DCE5F5';
var $2af6125e25d1cf3c$export$8338d8c35d44ff1 = '#CED9EB';
var $2af6125e25d1cf3c$export$5368d76ae4fbbda7 = '#B8C7E0';
var $2af6125e25d1cf3c$export$9f0a771d16ec8d36 = '#ABBBD6';
var $2af6125e25d1cf3c$export$abcf8c38338b4aa5 = '#9FB0CC';
var $2af6125e25d1cf3c$export$97e81faa16a182c7 = '#8C9CB8';
var $2af6125e25d1cf3c$export$bfe21c59123ecf33 = '#7988A3';
var $2af6125e25d1cf3c$export$ee82aa2ea6a1558 = '#67758F';
var $2af6125e25d1cf3c$export$682927c6ed76be02 = '#56637A';
var $2af6125e25d1cf3c$export$91fd9994c5be9757 = '#455166';
var $2af6125e25d1cf3c$export$d281fbfe3cff2df6 = '#3B475C';
var $2af6125e25d1cf3c$export$3902c91d8b98a753 = '#313D52';
var $2af6125e25d1cf3c$export$8e8133c1ba5845b5 = '#283447';
var $2af6125e25d1cf3c$export$33ff357f6620b39 = '#202B3D';
var $2af6125e25d1cf3c$export$633847cf062b69e0 = '#1B2638';
var $2af6125e25d1cf3c$export$9776a6e503bdbf76 = '#121A29';
var $2af6125e25d1cf3c$export$6c813d5160dff5db = '#0E1624';
var $2af6125e25d1cf3c$export$3d4f271a500072a = '#0D1424';
var $2af6125e25d1cf3c$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $2af6125e25d1cf3c$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $2af6125e25d1cf3c$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $2af6125e25d1cf3c$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $2af6125e25d1cf3c$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $2af6125e25d1cf3c$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $2af6125e25d1cf3c$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $2af6125e25d1cf3c$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $2af6125e25d1cf3c$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $2af6125e25d1cf3c$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $2af6125e25d1cf3c$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $2af6125e25d1cf3c$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $2af6125e25d1cf3c$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $2af6125e25d1cf3c$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $2af6125e25d1cf3c$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $2af6125e25d1cf3c$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $2af6125e25d1cf3c$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $2af6125e25d1cf3c$export$d2adc5dedf09fced = '#292A2E';
var $2af6125e25d1cf3c$export$f51762073d2bb381 = '#94C748';
var $2af6125e25d1cf3c$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("6qCqe", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ae2f99d0bf03fb2$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $4ae2f99d0bf03fb2$export$2e2bcd8739ae039() {}

});

parcelRegister("5PqYO", function(module, exports) {
$parcel$export(module.exports, "LevelContext", () => $43e6a4c88bc90207$export$650d12d3c2ddb8fc);
$parcel$export(module.exports, "TopLevelContext", () => $43e6a4c88bc90207$export$48b383b280e20440);
$parcel$export(module.exports, "Layering", () => $43e6a4c88bc90207$export$7c885f891c940977);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $89MP8 = parcelRequire("89MP8");

var $6dPv3 = parcelRequire("6dPv3");
function $43e6a4c88bc90207$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $43e6a4c88bc90207$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $43e6a4c88bc90207$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $43e6a4c88bc90207$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $43e6a4c88bc90207$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $5FkrB.createContext)(0);
var $43e6a4c88bc90207$export$48b383b280e20440 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    topLevelRef: {
        current: null
    },
    layerList: {
        current: null
    },
    setTopLevel: (0, $89MP8.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $43e6a4c88bc90207$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $5FkrB.useContext)($43e6a4c88bc90207$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel, topLevelRef = _useContext.topLevelRef, layerList = _useContext.layerList;
    // This is not unstable, it will run once for ref creation.
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var id = (0, $5FkrB.useRef)((0, $6dPv3.fg)('layering-top-level-use-array') ? Math.random().toString(36) : '');
    if (!(0, $6dPv3.fg)('layering-top-level-use-array')) {
        if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    }
    if (!(0, $6dPv3.fg)('layering-top-level-use-array')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5FkrB.useEffect)(function() {
        return function() {
            // avoid immediate cleanup using setTimeout when component unmount
            // this will make sure non-top layer components can get the correct top level value
            // when multiple layers trigger onClose in sequence
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel,
        topLevelRef
    ]);
    if ((0, $6dPv3.fg)('layering-top-level-use-array')) // Remove eslint error on FG cleanup
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5FkrB.useEffect)(function() {
        var safeLayerList = layerList === null || layerList === void 0 ? void 0 : layerList.current;
        var safeId = id.current;
        if (!safeLayerList) return;
        safeLayerList.push(safeId);
        return function() {
            var index = safeLayerList.indexOf(safeId);
            if (index > -1) safeLayerList.splice(index, 1);
        };
    }, [
        layerList,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($43e6a4c88bc90207$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $43e6a4c88bc90207$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $5FkrB.useRef)(0);
    var layerList = (0, $5FkrB.useRef)([]);
    var value = (0, $5FkrB.useMemo)(function() {
        return $43e6a4c88bc90207$var$_objectSpread({
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        }, (0, $6dPv3.fg)('layering-top-level-use-array') ? {
            layerList: layerList
        } : {});
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($43e6a4c88bc90207$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $43e6a4c88bc90207$export$7c885f891c940977 = function Layering(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $5FkrB.useContext)($43e6a4c88bc90207$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($43e6a4c88bc90207$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($43e6a4c88bc90207$var$LayeringProvider, null, content);
};

});
parcelRegister("89MP8", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f050961c7fd08c3$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $5f050961c7fd08c3$export$2e2bcd8739ae039() {}

});

parcelRegister("6dPv3", function(module, exports) {
$parcel$export(module.exports, "fg", () => $487be7cd66c35bb3$export$b40ec24ac8275656);

var $3LaE6 = parcelRequire("3LaE6");
function $487be7cd66c35bb3$export$ba05d765b8392e5e(flagResolver) {
    (0, $3LaE6.setBooleanResolver)(flagResolver);
}
function $487be7cd66c35bb3$export$470e5c2be1411c89(name) {
    return (0, $3LaE6.resolveBooleanFlag)(name);
}
function $487be7cd66c35bb3$export$b40ec24ac8275656(name) {
    return (0, $3LaE6.resolveBooleanFlag)(name);
}

});
parcelRegister("3LaE6", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $2bce04f15bf7d167$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $2bce04f15bf7d167$export$6333b6aff9fc6275);

var $jZlo3 = parcelRequire("jZlo3");

var $jHaSP = parcelRequire("jHaSP");

var $3ZMUU = parcelRequire("3ZMUU");
var $2bce04f15bf7d167$var$pkgName = '@atlaskit/platform-feature-flags';
var $2bce04f15bf7d167$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $2bce04f15bf7d167$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $2bce04f15bf7d167$var$ENV_ENABLE_PLATFORM_FF = $2bce04f15bf7d167$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $2bce04f15bf7d167$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $2bce04f15bf7d167$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $2bce04f15bf7d167$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $2bce04f15bf7d167$var$ENV_ENABLE_PLATFORM_FF || $2bce04f15bf7d167$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $2bce04f15bf7d167$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $2bce04f15bf7d167$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$2bce04f15bf7d167$var$globalVar[$2bce04f15bf7d167$export$7e41b1b2bdee3f98] = $2bce04f15bf7d167$var$globalVar[$2bce04f15bf7d167$export$7e41b1b2bdee3f98] || $2bce04f15bf7d167$var$DEFAULT_PFF_GLOBAL;
function $2bce04f15bf7d167$export$f2b591175b3e424c(resolver) {
    $2bce04f15bf7d167$var$globalVar[$2bce04f15bf7d167$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $2bce04f15bf7d167$export$6333b6aff9fc6275(flagKey) {
    if ($2bce04f15bf7d167$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $jHaSP.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $2bce04f15bf7d167$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $2bce04f15bf7d167$var$globalVar[$2bce04f15bf7d167$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $2bce04f15bf7d167$var$globalVar[$2bce04f15bf7d167$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $jZlo3.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $2bce04f15bf7d167$var$globalVar[$2bce04f15bf7d167$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("jZlo3", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8d44dd74978c315$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $5o85S = parcelRequire("5o85S");

var $an40Y = parcelRequire("an40Y");



var $e8d44dd74978c315$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $e8d44dd74978c315$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$e8d44dd74978c315$var$_FeatureGates = $e8d44dd74978c315$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "client", new (0, $5o85S.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$e8d44dd74978c315$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $e8d44dd74978c315$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $e8d44dd74978c315$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$e8d44dd74978c315$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $e8d44dd74978c315$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $e8d44dd74978c315$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "initializeCalled", $e8d44dd74978c315$var$_FeatureGates.client.initializeCalled.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "initializeCompleted", $e8d44dd74978c315$var$_FeatureGates.client.initializeCompleted.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "waitUntilInitializeCompleted", $e8d44dd74978c315$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "initialize", $e8d44dd74978c315$var$_FeatureGates.client.initialize.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "initializeWithProvider", $e8d44dd74978c315$var$_FeatureGates.client.initializeWithProvider.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "initializeFromValues", $e8d44dd74978c315$var$_FeatureGates.client.initializeFromValues.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "manuallyLogGateExposure", $e8d44dd74978c315$var$_FeatureGates.client.manuallyLogGateExposure.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "getExperiment", $e8d44dd74978c315$var$_FeatureGates.client.getExperiment.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "manuallyLogExperimentExposure", $e8d44dd74978c315$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "manuallyLogLayerExposure", $e8d44dd74978c315$var$_FeatureGates.client.manuallyLogLayerExposure.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "shutdownStatsig", $e8d44dd74978c315$var$_FeatureGates.client.shutdownStatsig.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "overrideGate", $e8d44dd74978c315$var$_FeatureGates.client.overrideGate.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "clearGateOverride", $e8d44dd74978c315$var$_FeatureGates.client.clearGateOverride.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "overrideConfig", $e8d44dd74978c315$var$_FeatureGates.client.overrideConfig.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "clearConfigOverride", $e8d44dd74978c315$var$_FeatureGates.client.clearConfigOverride.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "setOverrides", $e8d44dd74978c315$var$_FeatureGates.client.setOverrides.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "getOverrides", $e8d44dd74978c315$var$_FeatureGates.client.getOverrides.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "clearAllOverrides", $e8d44dd74978c315$var$_FeatureGates.client.clearAllOverrides.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "isCurrentUser", $e8d44dd74978c315$var$_FeatureGates.client.isCurrentUser.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "onGateUpdated", $e8d44dd74978c315$var$_FeatureGates.client.onGateUpdated.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "onExperimentValueUpdated", $e8d44dd74978c315$var$_FeatureGates.client.onExperimentValueUpdated.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "onAnyUpdated", $e8d44dd74978c315$var$_FeatureGates.client.onAnyUpdated.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "updateUser", $e8d44dd74978c315$var$_FeatureGates.client.updateUser.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "updateUserWithProvider", $e8d44dd74978c315$var$_FeatureGates.client.updateUserWithProvider.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "updateUserWithValues", $e8d44dd74978c315$var$_FeatureGates.client.updateUserWithValues.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "getPackageVersion", $e8d44dd74978c315$var$_FeatureGates.client.getPackageVersion.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "getTargetApp", $e8d44dd74978c315$var$_FeatureGates.client.getTargetApp.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "getLayer", $e8d44dd74978c315$var$_FeatureGates.client.getLayer.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "getLayerValue", $e8d44dd74978c315$var$_FeatureGates.client.getLayerValue.bind($e8d44dd74978c315$var$_FeatureGates.client));
var $e8d44dd74978c315$var$boundFGJS = $e8d44dd74978c315$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $e8d44dd74978c315$var$FeatureGates;
    else {
        var $e8d44dd74978c315$var$_boundFGJS, $e8d44dd74978c315$var$_boundFGJS$getPackage;
        $e8d44dd74978c315$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $e8d44dd74978c315$var$boundVersion = (($e8d44dd74978c315$var$_boundFGJS = $e8d44dd74978c315$var$boundFGJS) === null || $e8d44dd74978c315$var$_boundFGJS === void 0 || ($e8d44dd74978c315$var$_boundFGJS$getPackage = $e8d44dd74978c315$var$_boundFGJS.getPackageVersion) === null || $e8d44dd74978c315$var$_boundFGJS$getPackage === void 0 ? void 0 : $e8d44dd74978c315$var$_boundFGJS$getPackage.call($e8d44dd74978c315$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($e8d44dd74978c315$var$boundVersion !== (0, $an40Y.CLIENT_VERSION)) {
            var $e8d44dd74978c315$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($e8d44dd74978c315$var$boundVersion, " when module version ").concat((0, $an40Y.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($e8d44dd74978c315$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $e8d44dd74978c315$export$2e2bcd8739ae039 = $e8d44dd74978c315$var$boundFGJS;

});
parcelRegister("5o85S", function(module, exports) {
$parcel$export(module.exports, "Client", () => $3ec578e11f6ee57a$export$1f2bb630327ac4b6);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iOj5B = parcelRequire("iOj5B");

var $e7NgS = parcelRequire("e7NgS");

var $iwBvv = parcelRequire("iwBvv");

var $oWFzP = parcelRequire("oWFzP");

var $fDQ0p = parcelRequire("fDQ0p");

var $gwO2H = parcelRequire("gwO2H");

var $cyIRe = parcelRequire("cyIRe");

var $iMRG8 = parcelRequire("iMRG8");

var $jLH8B = parcelRequire("jLH8B");

var $edtOW = parcelRequire("edtOW");

var $an40Y = parcelRequire("an40Y");
var $3ec578e11f6ee57a$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $3ec578e11f6ee57a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3ec578e11f6ee57a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3ec578e11f6ee57a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3ec578e11f6ee57a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3ec578e11f6ee57a$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $3ec578e11f6ee57a$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $3ec578e11f6ee57a$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $iMRG8.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscriptions", new (0, $e7NgS.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "dataAdapter", new (0, $cyIRe.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $iMRG8.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $edtOW.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 1;
                                    break;
                                }
                                if (!(0, $edtOW.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $edtOW.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 1;
                                    break;
                                }
                                if (!(0, $edtOW.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $an40Y.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $3ec578e11f6ee57a$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $an40Y.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $jLH8B.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $edtOW.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 1;
                                    break;
                                }
                                if (!(0, $edtOW.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 1:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $edtOW.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $gwO2H.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 1;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 1:
                                _context5.next = 2;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 2:
                                _context5.next = 3;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 1:
                                if (!this.initCompleted) {
                                    _context7.next = 2;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 2:
                                _context7.next = 3;
                                return this.initPromise;
                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $iwBvv.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $iwBvv.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $fDQ0p.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $edtOW.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $edtOW.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $3ec578e11f6ee57a$var$_objectSpread({}, clientOptions);
                                if (!clientOptions.localMode) {
                                    _context8.next = 2;
                                    break;
                                }
                                _context8.next = 1;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 1:
                                return _context8.abrupt("return");
                            case 2:
                                _context8.prev = 2;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $gwO2H.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $gwO2H.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 6;
                                break;
                            case 4:
                                _context8.prev = 4;
                                _t = _context8["catch"](2);
                                if (_t instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t === null || _t === void 0 ? void 0 : _t.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t;
                            case 6:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            2,
                            4
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $3ec578e11f6ee57a$var$_objectSpread($3ec578e11f6ee57a$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 2;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 2:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 6;
                                break;
                            case 4:
                                _context9.prev = 4;
                                _t2 = _context9["catch"](1);
                                if (_t2 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t2 === null || _t2 === void 0 ? void 0 : _t2.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t2;
                            case 6:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            4
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, _args0 = arguments, _t3;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $edtOW.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $3ec578e11f6ee57a$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $3ec578e11f6ee57a$var$_objectSpread($3ec578e11f6ee57a$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $3ec578e11f6ee57a$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $jLH8B.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(newClientOptions, $3ec578e11f6ee57a$var$_excluded);
                                frontendUser = (0, $edtOW.toStatsigUser)(identifiers, customAttributes);
                                this.user = (0, $edtOW.deepAssign)({}, initializeValues.user, frontendUser);
                                statsigOptions = $3ec578e11f6ee57a$var$_objectSpread($3ec578e11f6ee57a$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iOj5B.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iOj5B.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 1;
                                this.statsigClient = new (0, $iOj5B.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 2;
                                return this.statsigClient.initializeAsync();
                            case 2:
                                _context0.next = 5;
                                break;
                            case 3:
                                _context0.prev = 3;
                                _t3 = _context0["catch"](1);
                                if (_t3 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_t3 === null || _t3 === void 0 ? void 0 : _t3.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iOj5B.StatsigClient)($3ec578e11f6ee57a$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 4;
                                return this.statsigClient.initializeAsync();
                            case 4:
                                this.initWithDefaults = true;
                                throw _t3;
                            case 5:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise, _t4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 1:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 2;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 2:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 3;
                                _context10.next = 4;
                                return this.initPromise;
                            case 4:
                                _context10.next = 6;
                                break;
                            case 5:
                                _context10.prev = 5;
                                _t4 = _context10["catch"](3);
                            case 6:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 1;
                                                    break;
                                                }
                                                _context1.next = 1;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 1:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 7:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            3,
                            5
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, frontendUser, _updateUserCompletion, _ref4, errMsg, success, errorMessage, _t5, _t6;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 2;
                                return initializeValuesPromise;
                            case 2:
                                initializeValues = _context11.sent;
                                frontendUser = (0, $edtOW.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, $edtOW.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
                                _context11.next = 4;
                                break;
                            case 3:
                                _context11.prev = 3;
                                _t5 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _t5 instanceof Error ? _t5.message : JSON.stringify(_t5);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _t5;
                            case 4:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 5;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 6;
                                    break;
                                }
                                _context11.next = 6;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 6:
                                _context11.next = 8;
                                break;
                            case 7:
                                _context11.prev = 7;
                                _t6 = _context11["catch"](5);
                                success = false;
                                errorMessage = String(_t6);
                            case 8:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 9;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 10;
                                break;
                            case 9:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 10:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            3
                        ],
                        [
                            5,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $an40Y.CLIENT_VERSION;
            }
        },
        {
            key: "getTargetApp",
            value: function getTargetApp() {
                var _this$initOptions2;
                return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $oWFzP.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $oWFzP.Layer).fromLayer((0, $iOj5B._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("iOj5B", function(module, exports) {
"use strict";
var $db1bb43e6e1f6d9a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $db1bb43e6e1f6d9a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $db1bb43e6e1f6d9a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $eBkTV = parcelRequire("eBkTV");
module.exports.StatsigClient = $eBkTV.default;

$db1bb43e6e1f6d9a$var$__exportStar((parcelRequire("buH38")), module.exports);
const $db1bb43e6e1f6d9a$var$__STATSIG__ = Object.assign((0, (parcelRequire("buH38"))._getStatsigGlobal)(), {
    StatsigClient: $eBkTV.default
});
module.exports.default = $db1bb43e6e1f6d9a$var$__STATSIG__;

});
parcelRegister("buH38", function(module, exports) {
"use strict";
var $85e3e3ce73d3221a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $85e3e3ce73d3221a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $85e3e3ce73d3221a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("jUxUa")).Diagnostics;
    }
});

var $7zZzY = parcelRequire("7zZzY");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $7zZzY.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("fogBN")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("j7aLw")).Storage;
    }
});

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("lEKhf")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("jUwr4")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("eUtax")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("8ShCc")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("jUxUa")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("3Dpi8")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("ctRBw")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("5Ux73")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("k6TO4")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("8G0fX")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("e2oUT")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("fogBN")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("E7Ll7")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("31J1W")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("azV1Q")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("dbgqg")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("600JO")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("ldgOi")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("jsyRv")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("iqii8")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("l4DW6")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("hCAQu")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("2Pm72")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("kl1By")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("kdRer")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("bX5bD")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("bi6ve")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("arnMz")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("6sOnd")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("eEMMa")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("8bfzg")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("iFqY0")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("j7aLw")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("4u95a")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("eXxwK")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("dUjjm")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("95OeL")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("eNzGC")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("cuJ0o")), module.exports);

$85e3e3ce73d3221a$var$__exportStar((parcelRequire("aTHwN")), module.exports);
Object.assign((0, (parcelRequire("lEKhf"))._getStatsigGlobal)(), {
    Log: (parcelRequire("fogBN")).Log,
    SDK_VERSION: (parcelRequire("bi6ve")).SDK_VERSION
});

});
parcelRegister("lEKhf", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $fc413b133753f80b$var$_a, $fc413b133753f80b$var$_b, $fc413b133753f80b$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $fogBN = parcelRequire("fogBN");
const $fc413b133753f80b$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $fc413b133753f80b$var$statsigGlobal;
    } catch (e) {
        return $fc413b133753f80b$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $fc413b133753f80b$var$_getStatsigGlobal;
const $fc413b133753f80b$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $fc413b133753f80b$var$_getStatsigGlobalFlag;
const $fc413b133753f80b$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $fogBN.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $fc413b133753f80b$var$_getInstance;
const $fc413b133753f80b$var$GLOBAL_KEY = '__STATSIG__';
const $fc413b133753f80b$var$_window = typeof window !== 'undefined' ? window : {};
const $fc413b133753f80b$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $fc413b133753f80b$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $fc413b133753f80b$var$statsigGlobal = ($fc413b133753f80b$var$_c = ($fc413b133753f80b$var$_b = ($fc413b133753f80b$var$_a = $fc413b133753f80b$var$_window[$fc413b133753f80b$var$GLOBAL_KEY]) !== null && $fc413b133753f80b$var$_a !== void 0 ? $fc413b133753f80b$var$_a : $fc413b133753f80b$var$_global[$fc413b133753f80b$var$GLOBAL_KEY]) !== null && $fc413b133753f80b$var$_b !== void 0 ? $fc413b133753f80b$var$_b : $fc413b133753f80b$var$_globalThis[$fc413b133753f80b$var$GLOBAL_KEY]) !== null && $fc413b133753f80b$var$_c !== void 0 ? $fc413b133753f80b$var$_c : {
    instance: module.exports._getInstance
};
$fc413b133753f80b$var$_window[$fc413b133753f80b$var$GLOBAL_KEY] = $fc413b133753f80b$var$statsigGlobal;
$fc413b133753f80b$var$_global[$fc413b133753f80b$var$GLOBAL_KEY] = $fc413b133753f80b$var$statsigGlobal;
$fc413b133753f80b$var$_globalThis[$fc413b133753f80b$var$GLOBAL_KEY] = $fc413b133753f80b$var$statsigGlobal;

});
parcelRegister("fogBN", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $b345fb01ac1eab69$var$DEBUG = ' DEBUG ';
const $b345fb01ac1eab69$var$_INFO = '  INFO ';
const $b345fb01ac1eab69$var$_WARN = '  WARN ';
const $b345fb01ac1eab69$var$ERROR = ' ERROR ';
function $b345fb01ac1eab69$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $b345fb01ac1eab69$var$Log {
    static info(...args) {
        if ($b345fb01ac1eab69$var$Log.level >= module.exports.LogLevel.Info) console.info($b345fb01ac1eab69$var$_INFO, ...$b345fb01ac1eab69$var$addTag(args));
    }
    static debug(...args) {
        if ($b345fb01ac1eab69$var$Log.level >= module.exports.LogLevel.Debug) console.debug($b345fb01ac1eab69$var$DEBUG, ...$b345fb01ac1eab69$var$addTag(args));
    }
    static warn(...args) {
        if ($b345fb01ac1eab69$var$Log.level >= module.exports.LogLevel.Warn) console.warn($b345fb01ac1eab69$var$_WARN, ...$b345fb01ac1eab69$var$addTag(args));
    }
    static error(...args) {
        if ($b345fb01ac1eab69$var$Log.level >= module.exports.LogLevel.Error) console.error($b345fb01ac1eab69$var$ERROR, ...$b345fb01ac1eab69$var$addTag(args));
    }
}
module.exports.Log = $b345fb01ac1eab69$var$Log;
$b345fb01ac1eab69$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("jUxUa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $e7ed8c15af9a8d38$var$MARKER_MAP = new Map();
const $e7ed8c15af9a8d38$var$ACT_START = 'start';
const $e7ed8c15af9a8d38$var$ACT_END = 'end';
const $e7ed8c15af9a8d38$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $e7ed8c15af9a8d38$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $e7ed8c15af9a8d38$var$_addMarker(sdkKey, $e7ed8c15af9a8d38$var$_createMarker({}, $e7ed8c15af9a8d38$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $e7ed8c15af9a8d38$var$_addMarker(sdkKey, $e7ed8c15af9a8d38$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $e7ed8c15af9a8d38$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $e7ed8c15af9a8d38$var$_addMarker(sdkKey, $e7ed8c15af9a8d38$var$_createMarker(data, $e7ed8c15af9a8d38$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $e7ed8c15af9a8d38$var$_addMarker(sdkKey, $e7ed8c15af9a8d38$var$_createMarker(data, $e7ed8c15af9a8d38$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $e7ed8c15af9a8d38$var$_addMarker(sdkKey, $e7ed8c15af9a8d38$var$_createMarker({}, $e7ed8c15af9a8d38$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $e7ed8c15af9a8d38$var$_addMarker(sdkKey, $e7ed8c15af9a8d38$var$_createMarker(data, $e7ed8c15af9a8d38$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $e7ed8c15af9a8d38$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $e7ed8c15af9a8d38$var$_safeGetField(e, 'code'),
            name: $e7ed8c15af9a8d38$var$_safeGetField(e, 'name'),
            message: $e7ed8c15af9a8d38$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $e7ed8c15af9a8d38$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $e7ed8c15af9a8d38$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $e7ed8c15af9a8d38$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $e7ed8c15af9a8d38$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $e7ed8c15af9a8d38$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $e7ed8c15af9a8d38$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $e7ed8c15af9a8d38$var$MARKER_MAP.set(sdkKey, markers);
}
function $e7ed8c15af9a8d38$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("7zZzY", function(module, exports) {
"use strict";
var $584b91a082f1c450$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $cArei = parcelRequire("cArei");

var $jUwr4 = parcelRequire("jUwr4");

var $aOMEY = parcelRequire("aOMEY");

var $jR5hx = parcelRequire("jR5hx");

var $8G0fX = parcelRequire("8G0fX");

var $fogBN = parcelRequire("fogBN");

var $31J1W = parcelRequire("31J1W");

var $dxWOs = parcelRequire("dxWOs");

var $ldgOi = parcelRequire("ldgOi");

var $bX5bD = parcelRequire("bX5bD");

var $arnMz = parcelRequire("arnMz");

var $j7aLw = parcelRequire("j7aLw");

var $dUjjm = parcelRequire("dUjjm");

var $eNzGC = parcelRequire("eNzGC");
const $584b91a082f1c450$var$MAX_DEDUPER_KEYS = 1000;
const $584b91a082f1c450$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $584b91a082f1c450$var$EVENT_LOGGER_MAP = {};
class $584b91a082f1c450$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $584b91a082f1c450$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    constructor(_sdkKey, _emitter, _network, _options, _errorBoundary){
        var _a;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._errorBoundary = _errorBoundary;
        this._pendingEvents = null;
        this._batchQueue = null;
        this._flushCoordinator = null;
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._isShuttingDown = false;
        this._storageKey = null;
        this._pendingCompressionMode = null;
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $arnMz.LoggingEnabledOption.disabled : $arnMz.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $fogBN.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $dUjjm.UrlConfiguration($31J1W.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLogEventCompressionMode(mode) {
        if (this._flushCoordinator) this._flushCoordinator.setLogEventCompressionMode(mode);
        else this._pendingCompressionMode = mode;
    }
    setLoggingEnabled(loggingEnabled) {
        const wasDisabled = this._loggingEnabled === 'disabled';
        const isNowEnabled = loggingEnabled !== 'disabled';
        this._loggingEnabled = loggingEnabled;
        if (this._flushCoordinator) this._flushCoordinator.setLoggingEnabled(loggingEnabled);
        if (wasDisabled && isNowEnabled) {
            const events = this._loadStoredEvents();
            $fogBN.Log.debug(`Loaded ${events.length} stored event(s) from storage`);
            if (events.length > 0) {
                events.forEach((event)=>{
                    this._initFlushCoordinator().addEvent(event);
                });
                this.flush().catch((error)=>{
                    $fogBN.Log.warn('Failed to flush events after enabling logging:', error);
                });
            }
        }
    }
    enqueue(event) {
        var _a;
        if (!this._shouldLogEvent(event)) return;
        const normalizedEvent = this._normalizeEvent(event);
        if (this._loggingEnabled === 'disabled') {
            this._storeEventToStorage(normalizedEvent);
            return;
        }
        this._initFlushCoordinator().addEvent(normalizedEvent);
        (_a = this._flushCoordinator) === null || _a === void 0 || _a.checkQuickFlush();
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $ldgOi._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        const flushCoordinator = this._initFlushCoordinator();
        $584b91a082f1c450$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $eNzGC._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $584b91a082f1c450$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') flushCoordinator.startScheduledFlushCycle();
        });
        flushCoordinator.loadAndRetryShutdownFailedEvents().catch((error)=>{
            $fogBN.Log.warn('Failed to load failed shutdown events:', error);
        });
        flushCoordinator.startScheduledFlushCycle();
    }
    stop() {
        return $584b91a082f1c450$var$__awaiter(this, void 0, void 0, function*() {
            this._isShuttingDown = true;
            if (this._flushCoordinator) yield this._flushCoordinator.processShutdown();
            delete $584b91a082f1c450$var$EVENT_LOGGER_MAP[this._sdkKey];
            this._flushCoordinator = null;
            this._pendingEvents = null;
            this._batchQueue = null;
        });
    }
    flush() {
        return $584b91a082f1c450$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._flushCoordinator) return;
            return this._flushCoordinator.processManualFlush();
        });
    }
    appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        const checks = Object.assign({}, this._nonExposedChecks);
        this._nonExposedChecks = {};
        const event = this._normalizeEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: checks
            }
        });
        if (!this._flushCoordinator) return;
        this._flushCoordinator.addEvent(event);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $ldgOi._isServerEnv)()) return false;
        if (!(0, $bX5bD._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $jUwr4._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $584b91a082f1c450$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $584b91a082f1c450$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $ldgOi._getCurrentPageUrlSafe)();
    }
    _getStorageKey() {
        if (!this._storageKey) this._storageKey = `statsig.pending_events.${(0, $8G0fX._DJB2)(this._sdkKey)}`;
        return this._storageKey;
    }
    _initFlushCoordinator() {
        var _a, _b;
        if (this._flushCoordinator) return this._flushCoordinator;
        const batchSize = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $aOMEY.EventRetryConstants.DEFAULT_BATCH_SIZE;
        this._pendingEvents = new $dxWOs.PendingEvents(batchSize);
        this._batchQueue = new $cArei.BatchQueue(batchSize);
        this._flushCoordinator = new $jR5hx.FlushCoordinator(this._batchQueue, this._pendingEvents, ()=>this.appendAndResetNonExposedChecks(), this._sdkKey, this._network, this._emitter, this._logEventUrlConfig, this._options, this._loggingEnabled, this._errorBoundary);
        if (this._pendingCompressionMode) {
            this._flushCoordinator.setLogEventCompressionMode(this._pendingCompressionMode);
            this._pendingCompressionMode = null;
        }
        return this._flushCoordinator;
    }
    _storeEventToStorage(event) {
        const storageKey = this._getStorageKey();
        try {
            let existingEvents = this._getEventsFromStorage(storageKey);
            existingEvents.push(event);
            if (existingEvents.length > $aOMEY.EventRetryConstants.MAX_LOCAL_STORAGE) existingEvents = existingEvents.slice(-$aOMEY.EventRetryConstants.MAX_LOCAL_STORAGE);
            (0, $j7aLw._setObjectInStorage)(storageKey, existingEvents);
        } catch (error) {
            $fogBN.Log.warn('Unable to save events to storage');
        }
    }
    _getEventsFromStorage(storageKey) {
        try {
            const events = (0, $j7aLw._getObjectFromStorage)(storageKey);
            if (Array.isArray(events)) return events;
            return [];
        } catch (_a) {
            return [];
        }
    }
    _loadStoredEvents() {
        const storageKey = this._getStorageKey();
        const events = this._getEventsFromStorage(storageKey);
        if (events.length > 0) $j7aLw.Storage.removeItem(storageKey);
        return events;
    }
    _normalizeEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        return Object.assign(Object.assign({}, event), extras);
    }
}
module.exports.EventLogger = $584b91a082f1c450$var$EventLogger;

});
parcelRegister("cArei", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BatchQueue = void 0;

var $OtKOc = parcelRequire("OtKOc");

var $aOMEY = parcelRequire("aOMEY");
class $929df809686e968d$var$BatchQueue {
    constructor(batchSize = $aOMEY.EventRetryConstants.DEFAULT_BATCH_SIZE){
        this._batches = [];
        this._batchSize = batchSize;
    }
    batchSize() {
        return this._batchSize;
    }
    requeueBatch(batch) {
        return this._enqueueBatch(batch);
    }
    hasFullBatch() {
        return this._batches.some((batch)=>batch.events.length >= this._batchSize);
    }
    takeNextBatch() {
        return this._batches.shift();
    }
    takeAllBatches() {
        const batches = this._batches;
        this._batches = [];
        return batches;
    }
    createBatches(events) {
        let i = 0;
        let droppedCount = 0;
        while(i < events.length){
            const chunk = events.slice(i, i + this._batchSize);
            droppedCount += this._enqueueBatch(new $OtKOc.EventBatch(chunk));
            i += this._batchSize;
        }
        return droppedCount;
    }
    _enqueueBatch(batch) {
        this._batches.push(batch);
        let droppedEventCount = 0;
        while(this._batches.length > $aOMEY.EventRetryConstants.MAX_PENDING_BATCHES){
            const dropped = this._batches.shift();
            if (dropped) droppedEventCount += dropped.events.length;
        }
        return droppedEventCount;
    }
}
module.exports.BatchQueue = $929df809686e968d$var$BatchQueue;

});
parcelRegister("OtKOc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventBatch = void 0;
class $097bc0258f590218$var$EventBatch {
    constructor(events){
        this.attempts = 0;
        this.createdAt = Date.now();
        this.events = events;
    }
    incrementAttempts() {
        this.attempts++;
    }
}
module.exports.EventBatch = $097bc0258f590218$var$EventBatch;

});

parcelRegister("aOMEY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventRetryConstants = void 0;
module.exports.EventRetryConstants = {
    MAX_RETRY_ATTEMPTS: 5,
    DEFAULT_BATCH_SIZE: 100,
    MAX_PENDING_BATCHES: 30,
    TICK_INTERVAL_MS: 1000,
    QUICK_FLUSH_WINDOW_MS: 200,
    MAX_LOCAL_STORAGE: 500,
    get MAX_QUEUED_EVENTS () {
        return this.DEFAULT_BATCH_SIZE * this.MAX_PENDING_BATCHES;
    }
};

});


parcelRegister("jUwr4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $8G0fX = parcelRequire("8G0fX");
function $e7ec6855e0c8a968$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $8G0fX._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $e7ec6855e0c8a968$var$_getUserStorageKey;
function $e7ec6855e0c8a968$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $e7ec6855e0c8a968$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $8G0fX._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $e7ec6855e0c8a968$var$_getStorageKey;

});
parcelRegister("8G0fX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $eXxwK = parcelRequire("eXxwK");
const $651271e766137727$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $651271e766137727$var$_DJB2;
const $651271e766137727$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $651271e766137727$var$_DJB2Object;
const $651271e766137727$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $eXxwK._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $651271e766137727$var$_getSortedObject;

});
parcelRegister("eXxwK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $ae40952f3950ab09$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $ae40952f3950ab09$var$_typeOf;
function $ae40952f3950ab09$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $ae40952f3950ab09$var$_isTypeMatch;

});



parcelRegister("jR5hx", function(module, exports) {
"use strict";
var $e7471067641d1ae2$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlushCoordinator = void 0;

var $aOMEY = parcelRequire("aOMEY");

var $lxpyB = parcelRequire("lxpyB");

var $khv30 = parcelRequire("khv30");

var $9CyTv = parcelRequire("9CyTv");

var $8G0fX = parcelRequire("8G0fX");

var $fogBN = parcelRequire("fogBN");

var $azV1Q = parcelRequire("azV1Q");

var $iqii8 = parcelRequire("iqii8");

var $j7aLw = parcelRequire("j7aLw");
class $e7471067641d1ae2$var$FlushCoordinator {
    constructor(batchQueue, pendingEvents, onPrepareFlush, // For Event Sender
    sdkKey, network, emitter, logEventUrlConfig, options, loggingEnabled, errorBoundary){
        this._cooldownTimer = null;
        this._maxIntervalTimer = null;
        this._hasRunQuickFlush = false;
        this._currentFlushPromise = null;
        this._creationTime = Date.now();
        this._isShuttingDown = false;
        this._storageKey = null;
        this._flushInterval = new $khv30.FlushInterval();
        this._batchQueue = batchQueue;
        this._pendingEvents = pendingEvents;
        this._onPrepareFlush = onPrepareFlush;
        this._errorBoundary = errorBoundary;
        this._sdkKey = sdkKey;
        this._eventSender = new $lxpyB.EventSender(sdkKey, network, emitter, logEventUrlConfig, options, loggingEnabled);
    }
    setLoggingEnabled(loggingEnabled) {
        this._eventSender.setLoggingEnabled(loggingEnabled);
    }
    setLogEventCompressionMode(mode) {
        this._eventSender.setLogEventCompressionMode(mode);
    }
    startScheduledFlushCycle() {
        this._scheduleNextFlush();
    }
    stopScheduledFlushCycle() {
        this._clearAllTimers();
    }
    addEvent(event) {
        this._pendingEvents.addToPendingEventsQueue(event);
        if (this._currentFlushPromise) return;
        if (this._pendingEvents.hasEventsForFullBatch()) this.processLimitFlush();
    }
    processManualFlush() {
        return $e7471067641d1ae2$var$__awaiter(this, void 0, void 0, function*() {
            if (this._currentFlushPromise) yield this._currentFlushPromise;
            this._currentFlushPromise = this._executeFlush($9CyTv.FlushType.Manual).finally(()=>{
                this._currentFlushPromise = null;
                this._scheduleNextFlush();
            });
            return this._currentFlushPromise;
        });
    }
    processShutdown() {
        return $e7471067641d1ae2$var$__awaiter(this, void 0, void 0, function*() {
            this._isShuttingDown = true;
            this._clearAllTimers();
            if (this._currentFlushPromise) yield this._currentFlushPromise;
            this._currentFlushPromise = this._executeFlush($9CyTv.FlushType.Shutdown).catch((error)=>{
                $fogBN.Log.error(`Error during shutdown flush: ${error}`);
            }).finally(()=>{
                this._currentFlushPromise = null;
            });
            return this._currentFlushPromise;
        });
    }
    _executeFlush(flushType) {
        return $e7471067641d1ae2$var$__awaiter(this, void 0, void 0, function*() {
            this._clearAllTimers();
            try {
                this._prepareQueueForFlush(flushType);
                const batches = this._batchQueue.takeAllBatches();
                if (batches.length === 0) return;
                yield Promise.all(batches.map((batch)=>this._processOneBatch(batch, flushType)));
            } finally{
                if (!this._isShuttingDown) this._scheduleNextFlush();
            }
        });
    }
    checkQuickFlush() {
        if (this._hasRunQuickFlush) return;
        if (Date.now() - this._creationTime > $aOMEY.EventRetryConstants.QUICK_FLUSH_WINDOW_MS) return;
        this._hasRunQuickFlush = true;
        setTimeout(()=>{
            this.processManualFlush().catch((error)=>{
                $fogBN.Log.warn('Quick flush failed:', error);
            });
        }, $aOMEY.EventRetryConstants.QUICK_FLUSH_WINDOW_MS);
    }
    _attemptScheduledFlush() {
        if (this._currentFlushPromise) {
            this._scheduleNextFlush();
            return;
        }
        const shouldFlushBySize = this.containsAtLeastOneFullBatch();
        const shouldFlushByTime = this._flushInterval.hasReachedMaxInterval();
        if (!shouldFlushBySize && !shouldFlushByTime) {
            this._scheduleNoopPollTick();
            return;
        }
        this._flushInterval.markFlushAttempt();
        let flushType;
        if (shouldFlushBySize) flushType = $9CyTv.FlushType.ScheduledFullBatch;
        else flushType = $9CyTv.FlushType.ScheduledMaxTime;
        this._currentFlushPromise = this._processNextBatch(flushType).then(()=>{
        //This discards boolean result. Main goal here is to track completion
        }).catch((error)=>{
            $fogBN.Log.error('Error during scheduled flush:', error);
        }).finally(()=>{
            this._currentFlushPromise = null;
            this._scheduleNextFlush();
        });
    }
    processLimitFlush() {
        if (!this._flushInterval.hasCompletelyRecoveredFromBackoff()) return;
        if (this._currentFlushPromise) return;
        this._currentFlushPromise = this._processLimitFlushInternal().catch((error)=>{
            $fogBN.Log.error(`Error during limit flush`, error);
        }).finally(()=>{
            this._currentFlushPromise = null;
            this._scheduleNextFlush();
        });
    }
    _processLimitFlushInternal() {
        return $e7471067641d1ae2$var$__awaiter(this, void 0, void 0, function*() {
            const success = yield this._processNextBatch($9CyTv.FlushType.Limit);
            if (!success) return;
            while(this._flushInterval.hasCompletelyRecoveredFromBackoff() && this.containsAtLeastOneFullBatch()){
                const success = yield this._processNextBatch($9CyTv.FlushType.Limit);
                if (!success) break;
            }
        });
    }
    _scheduleNextFlush() {
        this._clearAllTimers();
        if (this._isShuttingDown) return;
        const cooldownDelay = Math.max(0, this._flushInterval.getTimeUntilNextFlush());
        this._cooldownTimer = setTimeout(()=>{
            this._cooldownTimer = null;
            $iqii8.StatsigSession.checkForIdleSession(this._sdkKey);
            this._attemptScheduledFlush();
        }, cooldownDelay);
        const maxIntervalDelay = Math.max(0, this._flushInterval.getTimeTillMaxInterval());
        this._maxIntervalTimer = setTimeout(()=>{
            this._maxIntervalTimer = null;
            $iqii8.StatsigSession.checkForIdleSession(this._sdkKey);
            this._attemptScheduledFlush();
        }, maxIntervalDelay);
    }
    _clearAllTimers() {
        if (this._cooldownTimer !== null) {
            clearTimeout(this._cooldownTimer);
            this._cooldownTimer = null;
        }
        if (this._maxIntervalTimer !== null) {
            clearTimeout(this._maxIntervalTimer);
            this._maxIntervalTimer = null;
        }
    }
    _scheduleNoopPollTick() {
        this._clearAllTimers();
        if (this._isShuttingDown) return;
        this._cooldownTimer = setTimeout(()=>{
            this._cooldownTimer = null;
            $iqii8.StatsigSession.checkForIdleSession(this._sdkKey);
            this._attemptScheduledFlush();
        }, $aOMEY.EventRetryConstants.TICK_INTERVAL_MS);
        const maxIntervalDelay = Math.max(0, this._flushInterval.getTimeTillMaxInterval());
        this._maxIntervalTimer = setTimeout(()=>{
            this._maxIntervalTimer = null;
            $iqii8.StatsigSession.checkForIdleSession(this._sdkKey);
            this._attemptScheduledFlush();
        }, maxIntervalDelay);
    }
    _processNextBatch(flushType) {
        return $e7471067641d1ae2$var$__awaiter(this, void 0, void 0, function*() {
            this._prepareQueueForFlush(flushType);
            const batch = this._batchQueue.takeNextBatch();
            if (!batch) return false;
            return this._processOneBatch(batch, flushType);
        });
    }
    _processOneBatch(batch, flushType) {
        return $e7471067641d1ae2$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this._eventSender.sendBatch(batch);
            if (result.success) {
                this._flushInterval.adjustForSuccess();
                return true;
            }
            this._flushInterval.adjustForFailure();
            this._handleFailure(batch, flushType, result.statusCode);
            return false;
        });
    }
    _prepareQueueForFlush(flushType) {
        this._onPrepareFlush();
        const droppedCount = this.convertPendingEventsToBatches();
        if (droppedCount > 0) {
            $fogBN.Log.warn(`Dropped ${droppedCount} events`);
            this._errorBoundary.logDroppedEvents(droppedCount, `Batch queue limit reached`, {
                loggingInterval: this._flushInterval.getCurrentIntervalMs(),
                batchSize: this._batchQueue.batchSize(),
                maxPendingBatches: $aOMEY.EventRetryConstants.MAX_PENDING_BATCHES,
                flushType: flushType,
                retries: 'dropped before batching'
            });
        }
    }
    containsAtLeastOneFullBatch() {
        return this._pendingEvents.hasEventsForFullBatch() || this._batchQueue.hasFullBatch();
    }
    convertPendingEventsToBatches() {
        if (this._pendingEvents.isEmpty()) return 0;
        const allEvents = this._pendingEvents.takeAll();
        return this._batchQueue.createBatches(allEvents);
    }
    _handleFailure(batch, flushType, statusCode) {
        if (flushType === $9CyTv.FlushType.Shutdown) {
            $fogBN.Log.warn(`${flushType} flush failed during shutdown. ` + `${batch.events.length} event(s) will be saved to storage for retry in next session.`);
            this._saveShutdownFailedEventsToStorage(batch.events);
            return;
        }
        if (!$azV1Q.RETRYABLE_CODES.has(statusCode)) {
            $fogBN.Log.warn(`${flushType} flush failed after ${batch.attempts} attempt(s). ` + `${batch.events.length} event(s) will be dropped. Non-retryable error: ${statusCode}`);
            this._errorBoundary.logEventRequestFailure(batch.events.length, `non-retryable error`, flushType, statusCode, batch.attempts);
            return;
        }
        if (batch.attempts >= $aOMEY.EventRetryConstants.MAX_RETRY_ATTEMPTS) {
            $fogBN.Log.warn(`${flushType} flush failed after ${batch.attempts} attempt(s). ` + `${batch.events.length} event(s) will be dropped.`);
            this._errorBoundary.logEventRequestFailure(batch.events.length, `max retry attempts exceeded`, flushType, statusCode, batch.attempts);
            return;
        }
        batch.incrementAttempts();
        const droppedCount = this._batchQueue.requeueBatch(batch);
        if (droppedCount > 0) {
            $fogBN.Log.warn(`Failed to requeue batch : dropped ${droppedCount} events due to full queue`);
            this._errorBoundary.logDroppedEvents(droppedCount, `Batch queue limit reached`, {
                loggingInterval: this._flushInterval.getCurrentIntervalMs(),
                batchSize: this._batchQueue.batchSize(),
                maxPendingBatches: $aOMEY.EventRetryConstants.MAX_PENDING_BATCHES,
                flushType: flushType,
                retries: batch.attempts
            });
        }
    }
    loadAndRetryShutdownFailedEvents() {
        return $e7471067641d1ae2$var$__awaiter(this, void 0, void 0, function*() {
            const storageKey = this._getStorageKey();
            try {
                if (!$j7aLw.Storage.isReady()) yield $j7aLw.Storage.isReadyResolver();
                const events = this._getShutdownFailedEventsFromStorage(storageKey);
                if (events.length === 0) return;
                $fogBN.Log.debug(`Loading ${events.length} failed shutdown event(s) from storage for retry`);
                $j7aLw.Storage.removeItem(storageKey);
                events.forEach((event)=>{
                    this.addEvent(event);
                });
                yield this.processManualFlush();
            } catch (error) {
                $fogBN.Log.warn('Failed to load and retry failed shutdown events:', error);
            }
        });
    }
    _getStorageKey() {
        if (!this._storageKey) this._storageKey = `statsig.failed_shutdown_events.${(0, $8G0fX._DJB2)(this._sdkKey)}`;
        return this._storageKey;
    }
    _saveShutdownFailedEventsToStorage(events) {
        const storageKey = this._getStorageKey();
        try {
            const existingEvents = this._getShutdownFailedEventsFromStorage(storageKey);
            let allEvents = [
                ...existingEvents,
                ...events
            ];
            if (allEvents.length > $aOMEY.EventRetryConstants.MAX_LOCAL_STORAGE) allEvents = allEvents.slice(-$aOMEY.EventRetryConstants.MAX_LOCAL_STORAGE);
            (0, $j7aLw._setObjectInStorage)(storageKey, allEvents);
            $fogBN.Log.debug(`Saved ${events.length} failed shutdown event(s) to storage (total stored: ${allEvents.length})`);
        } catch (error) {
            $fogBN.Log.warn('Unable to save failed shutdown events to storage:', error);
        }
    }
    _getShutdownFailedEventsFromStorage(storageKey) {
        try {
            const events = (0, $j7aLw._getObjectFromStorage)(storageKey);
            if (Array.isArray(events)) return events;
            return [];
        } catch (_a) {
            return [];
        }
    }
}
module.exports.FlushCoordinator = $e7471067641d1ae2$var$FlushCoordinator;

});
parcelRegister("lxpyB", function(module, exports) {
"use strict";
var $fae0812d06eecd4a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventSender = void 0;

var $fogBN = parcelRequire("fogBN");

var $31J1W = parcelRequire("31J1W");

var $eNzGC = parcelRequire("eNzGC");
class $fae0812d06eecd4a$var$EventSender {
    constructor(sdkKey, network, emitter, logEventUrlConfig, options, loggingEnabled){
        this._sdkKey = sdkKey;
        this._network = network;
        this._emitter = emitter;
        this._options = options;
        this._logEventUrlConfig = logEventUrlConfig;
        this._loggingEnabled = loggingEnabled;
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(enabled) {
        this._loggingEnabled = enabled;
    }
    sendBatch(batch) {
        return $fae0812d06eecd4a$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                const isClosing = (0, $eNzGC._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: batch.events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(batch) : yield this._sendEventsViaPost(batch);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: batch.events
                    });
                    return response;
                }
                return {
                    success: false,
                    statusCode: response.statusCode
                };
            } catch (error) {
                $fogBN.Log.warn('Failed to send batch:', error);
                return {
                    success: false,
                    statusCode: -1
                };
            }
        });
    }
    _sendEventsViaPost(batch) {
        return $fae0812d06eecd4a$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(batch));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300,
                statusCode: code
            };
        });
    }
    _sendEventsViaBeacon(batch) {
        const success = this._network.beacon(this._getRequestData(batch));
        return {
            success: success,
            statusCode: success ? 200 : -1
        };
    }
    _getRequestData(batch) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: batch.events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$31J1W.NetworkParam.EventCount]: String(batch.events.length)
            },
            headers: {
                'statsig-event-count': String(batch.events.length),
                'statsig-retry-count': String(batch.attempts)
            },
            credentials: 'same-origin'
        };
    }
}
module.exports.EventSender = $fae0812d06eecd4a$var$EventSender;

});
parcelRegister("31J1W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("eNzGC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $ldgOi = parcelRequire("ldgOi");
const $ac6152e029a65402$var$FOREGROUND = 'foreground';
const $ac6152e029a65402$var$BACKGROUND = 'background';
const $ac6152e029a65402$var$LISTENERS = [];
let $ac6152e029a65402$var$current = $ac6152e029a65402$var$FOREGROUND;
let $ac6152e029a65402$var$isUnloading = false;
const $ac6152e029a65402$var$_isCurrentlyVisible = ()=>{
    return $ac6152e029a65402$var$current === $ac6152e029a65402$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $ac6152e029a65402$var$_isCurrentlyVisible;
const $ac6152e029a65402$var$_isUnloading = ()=>$ac6152e029a65402$var$isUnloading;
module.exports._isUnloading = $ac6152e029a65402$var$_isUnloading;
const $ac6152e029a65402$var$_subscribeToVisiblityChanged = (listener)=>{
    $ac6152e029a65402$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $ac6152e029a65402$var$_subscribeToVisiblityChanged;
const $ac6152e029a65402$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $ac6152e029a65402$var$current) return;
    $ac6152e029a65402$var$current = visibility;
    $ac6152e029a65402$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $ac6152e029a65402$var$_notifyVisibilityChanged;
(0, $ldgOi._addWindowEventListenerSafe)('focus', ()=>{
    $ac6152e029a65402$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($ac6152e029a65402$var$FOREGROUND);
});
(0, $ldgOi._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($ac6152e029a65402$var$BACKGROUND));
(0, $ldgOi._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $ac6152e029a65402$var$FOREGROUND : $ac6152e029a65402$var$BACKGROUND);
});
(0, $ldgOi._addWindowEventListenerSafe)((0, $ldgOi._getUnloadEvent)(), ()=>{
    $ac6152e029a65402$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($ac6152e029a65402$var$BACKGROUND);
});

});
parcelRegister("ldgOi", function(module, exports) {

var $3ZMUU = parcelRequire("3ZMUU");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._cloneObject = module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;

var $fogBN = parcelRequire("fogBN");
const $f717da07269f3b4a$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $f717da07269f3b4a$var$_getWindowSafe;
const $f717da07269f3b4a$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $f717da07269f3b4a$var$_getDocumentSafe;
const $f717da07269f3b4a$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $3ZMUU !== 'undefined' && $3ZMUU.versions != null && $3ZMUU.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $f717da07269f3b4a$var$_isServerEnv;
const $f717da07269f3b4a$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $f717da07269f3b4a$var$_addWindowEventListenerSafe;
const $f717da07269f3b4a$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $f717da07269f3b4a$var$_addDocumentEventListenerSafe;
const $f717da07269f3b4a$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $f717da07269f3b4a$var$_getCurrentPageUrlSafe;
const $f717da07269f3b4a$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $f717da07269f3b4a$var$_getUnloadEvent;
const $f717da07269f3b4a$var$_cloneObject = (tag, obj)=>{
    try {
        return JSON.parse(JSON.stringify(obj));
    } catch (error) {
        $fogBN.Log.error(`Failed to clone object ${tag}`);
        return null;
    }
};
module.exports._cloneObject = $f717da07269f3b4a$var$_cloneObject;

});



parcelRegister("khv30", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlushInterval = void 0;
const $ec3d7a91c29927e8$var$MIN_FLUSH_INTERVAL_MS = 1000;
const $ec3d7a91c29927e8$var$MAX_FLUSH_INTERVAL_MS = 60000;
class $ec3d7a91c29927e8$var$FlushInterval {
    constructor(){
        this._currentIntervalMs = $ec3d7a91c29927e8$var$MIN_FLUSH_INTERVAL_MS;
        this._lastFlushAttemptTime = Date.now();
    }
    getCurrentIntervalMs() {
        return this._currentIntervalMs;
    }
    markFlushAttempt() {
        this._lastFlushAttemptTime = Date.now();
    }
    getTimeSinceLastAttempt() {
        return Date.now() - this._lastFlushAttemptTime;
    }
    hasReachedMaxInterval() {
        return this.getTimeSinceLastAttempt() >= $ec3d7a91c29927e8$var$MAX_FLUSH_INTERVAL_MS;
    }
    getTimeTillMaxInterval() {
        return $ec3d7a91c29927e8$var$MAX_FLUSH_INTERVAL_MS - this.getTimeSinceLastAttempt();
    }
    hasCompletelyRecoveredFromBackoff() {
        return this._currentIntervalMs <= $ec3d7a91c29927e8$var$MIN_FLUSH_INTERVAL_MS;
    }
    adjustForSuccess() {
        const current = this._currentIntervalMs;
        if (current === $ec3d7a91c29927e8$var$MIN_FLUSH_INTERVAL_MS) return;
        this._currentIntervalMs = Math.max($ec3d7a91c29927e8$var$MIN_FLUSH_INTERVAL_MS, Math.floor(current / 2));
    }
    adjustForFailure() {
        const current = this._currentIntervalMs;
        this._currentIntervalMs = Math.min($ec3d7a91c29927e8$var$MAX_FLUSH_INTERVAL_MS, current * 2);
    }
    getTimeUntilNextFlush() {
        return this.getCurrentIntervalMs() - this.getTimeSinceLastAttempt();
    }
}
module.exports.FlushInterval = $ec3d7a91c29927e8$var$FlushInterval;

});

parcelRegister("9CyTv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlushType = void 0;
/* eslint-disable no-restricted-syntax */ var $7012baf3ed338e68$var$FlushType;
(function(FlushType) {
    FlushType["ScheduledMaxTime"] = "scheduled:max_time";
    FlushType["ScheduledFullBatch"] = "scheduled:full_batch";
    FlushType["Limit"] = "limit";
    FlushType["Manual"] = "manual";
    FlushType["Shutdown"] = "shutdown";
})($7012baf3ed338e68$var$FlushType || (module.exports.FlushType = $7012baf3ed338e68$var$FlushType = {}));

});

parcelRegister("azV1Q", function(module, exports) {
"use strict";
var $7b3969029e29c8f4$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = module.exports.RETRYABLE_CODES = void 0;

var $lEKhf = parcelRequire("lEKhf");

var $lEKhf = parcelRequire("lEKhf");

var $jUxUa = parcelRequire("jUxUa");

var $fogBN = parcelRequire("fogBN");

var $31J1W = parcelRequire("31J1W");

var $dzhQN = parcelRequire("dzhQN");

var $aTHwN = parcelRequire("aTHwN");

var $jsyRv = parcelRequire("jsyRv");

var $ldgOi = parcelRequire("ldgOi");

var $iqii8 = parcelRequire("iqii8");

var $hCAQu = parcelRequire("hCAQu");

var $kl1By = parcelRequire("kl1By");

var $bi6ve = parcelRequire("bi6ve");

var $arnMz = parcelRequire("arnMz");

var $eNzGC = parcelRequire("eNzGC");
const $7b3969029e29c8f4$var$DEFAULT_TIMEOUT_MS = 10000;
const $7b3969029e29c8f4$var$BACKOFF_BASE_MS = 500;
const $7b3969029e29c8f4$var$BACKOFF_MAX_MS = 30000;
const $7b3969029e29c8f4$var$RATE_LIMIT_WINDOW_MS = 1000;
const $7b3969029e29c8f4$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $7b3969029e29c8f4$var$LEAK_RATE = $7b3969029e29c8f4$var$RATE_LIMIT_MAX_REQ_COUNT / $7b3969029e29c8f4$var$RATE_LIMIT_WINDOW_MS;
module.exports.RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $7b3969029e29c8f4$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $7b3969029e29c8f4$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $dzhQN.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$7b3969029e29c8f4$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $7b3969029e29c8f4$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $7b3969029e29c8f4$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$7b3969029e29c8f4$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $fogBN.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            let reqTimedOut = false;
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $eNzGC._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    priority: args.priority,
                    keepalive: keepalive
                };
                $7b3969029e29c8f4$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                let timeoutId;
                response = yield Promise.race([
                    func(populatedUrl, config).finally(()=>clearTimeout(timeoutId)),
                    new Promise((_, reject)=>{
                        timeoutId = setTimeout(()=>{
                            reqTimedOut = true;
                            reject(new Error(`Timeout of ${this._timeout}ms expired.`));
                        }, this._timeout);
                    })
                ]);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $7b3969029e29c8f4$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $7b3969029e29c8f4$var$_getErrorMessage(error);
                const timedOut = $7b3969029e29c8f4$var$_didTimeout(errorMessage !== null && errorMessage !== void 0 ? errorMessage : '', reqTimedOut);
                $7b3969029e29c8f4$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !module.exports.RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $kl1By.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $fogBN.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $7b3969029e29c8f4$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $arnMz.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $arnMz.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $7b3969029e29c8f4$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $7b3969029e29c8f4$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $31J1W.Endpoint._initialize || args.urlConfig.endpoint === $31J1W.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$31J1W.NetworkParam.SdkKey]: args.sdkKey,
            [$31J1W.NetworkParam.SdkType]: $jsyRv.SDKType._get(args.sdkKey),
            [$31J1W.NetworkParam.SdkVersion]: $bi6ve.SDK_VERSION,
            [$31J1W.NetworkParam.Time]: String(Date.now()),
            [$31J1W.NetworkParam.SessionID]: $iqii8.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $ldgOi._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $lEKhf._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$31J1W.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $fogBN.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $7b3969029e29c8f4$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$7b3969029e29c8f4$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($fogBN.Log.error);
                writer.close().catch($fogBN.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$31J1W.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $fogBN.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $7b3969029e29c8f4$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $7b3969029e29c8f4$var$NetworkCore;
const $7b3969029e29c8f4$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $fogBN.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $7b3969029e29c8f4$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $hCAQu.StableID.get(sdkKey);
    const sessionID = $iqii8.SessionID.get(sdkKey);
    const sdkType = $jsyRv.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $bi6ve.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $7b3969029e29c8f4$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $lEKhf._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $aTHwN.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $arnMz.LogEventCompressionMode.Disabled:
            return false;
        case $arnMz.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $arnMz.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $7b3969029e29c8f4$var$_getErrorMessage(error) {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $7b3969029e29c8f4$var$_didTimeout(errorMsg, abortedByTimeout) {
    const timeout = errorMsg.includes('Timeout'); // probably not needed but just in case
    return timeout || abortedByTimeout;
}
function $7b3969029e29c8f4$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $31J1W.Endpoint._initialize) return;
    $jUxUa.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $7b3969029e29c8f4$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $31J1W.Endpoint._initialize) return;
    $jUxUa.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $jUxUa.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $7b3969029e29c8f4$var$_exponentialBackoff(attempt) {
    return $7b3969029e29c8f4$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($7b3969029e29c8f4$var$BACKOFF_BASE_MS * (attempt * attempt), $7b3969029e29c8f4$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("dzhQN", function(module, exports) {
"use strict";
var $9e0c640326b697b9$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $8oeIL = parcelRequire("8oeIL");

var $8G0fX = parcelRequire("8G0fX");

var $fogBN = parcelRequire("fogBN");

var $j7aLw = parcelRequire("j7aLw");
const $9e0c640326b697b9$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $9e0c640326b697b9$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $9e0c640326b697b9$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $9e0c640326b697b9$var$DEFAULT_TTL_MS;
        $9e0c640326b697b9$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $9e0c640326b697b9$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $9e0c640326b697b9$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $9e0c640326b697b9$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$9e0c640326b697b9$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $9e0c640326b697b9$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $9e0c640326b697b9$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $9e0c640326b697b9$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $9e0c640326b697b9$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $8oeIL._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $9e0c640326b697b9$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $9e0c640326b697b9$var$NetworkFallbackResolver;
function $9e0c640326b697b9$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $9e0c640326b697b9$var$_isDomainFailure;
function $9e0c640326b697b9$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $8G0fX._DJB2)(sdkKey)}`;
}
function $9e0c640326b697b9$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $9e0c640326b697b9$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $j7aLw.Storage.removeItem(hashKey);
        return;
    }
    $j7aLw.Storage.setItem(hashKey, JSON.stringify(info));
}
function $9e0c640326b697b9$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $9e0c640326b697b9$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $j7aLw.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $fogBN.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $9e0c640326b697b9$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("8oeIL", function(module, exports) {
"use strict";
var $61bbfbe788fde02e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $61bbfbe788fde02e$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $61bbfbe788fde02e$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $61bbfbe788fde02e$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $61bbfbe788fde02e$var$MAX_START_LOOKUP = 200;
function $61bbfbe788fde02e$var$_fetchTxtRecords(networkFunc) {
    return $61bbfbe788fde02e$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($61bbfbe788fde02e$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $61bbfbe788fde02e$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $61bbfbe788fde02e$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $61bbfbe788fde02e$var$_fetchTxtRecords;
function $61bbfbe788fde02e$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $61bbfbe788fde02e$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $61bbfbe788fde02e$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});

parcelRegister("j7aLw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $fogBN = parcelRequire("fogBN");

var $ldgOi = parcelRequire("ldgOi");
const $dea7058f0a829afe$var$inMemoryStore = {};
const $dea7058f0a829afe$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$dea7058f0a829afe$var$inMemoryStore[key] ? $dea7058f0a829afe$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $dea7058f0a829afe$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $dea7058f0a829afe$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($dea7058f0a829afe$var$inMemoryStore)
};
let $dea7058f0a829afe$var$_localStorageProvider = null;
try {
    const win = (0, $ldgOi._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $dea7058f0a829afe$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $fogBN.Log.warn('Failed to setup localStorageProvider.');
}
let $dea7058f0a829afe$var$_main = $dea7058f0a829afe$var$_localStorageProvider !== null && $dea7058f0a829afe$var$_localStorageProvider !== void 0 ? $dea7058f0a829afe$var$_localStorageProvider : $dea7058f0a829afe$var$_inMemoryProvider;
let $dea7058f0a829afe$var$_current = $dea7058f0a829afe$var$_main;
function $dea7058f0a829afe$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($dea7058f0a829afe$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$dea7058f0a829afe$var$_current.isReady(),
    isReadyResolver: ()=>$dea7058f0a829afe$var$_current.isReadyResolver(),
    getProviderName: ()=>$dea7058f0a829afe$var$_current.getProviderName(),
    getItem: (key)=>$dea7058f0a829afe$var$_inMemoryBreaker(()=>$dea7058f0a829afe$var$_current.getItem(key)),
    setItem: (key, value)=>$dea7058f0a829afe$var$_inMemoryBreaker(()=>$dea7058f0a829afe$var$_current.setItem(key, value)),
    removeItem: (key)=>$dea7058f0a829afe$var$_current.removeItem(key),
    getAllKeys: ()=>$dea7058f0a829afe$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $dea7058f0a829afe$var$_main = newProvider;
        $dea7058f0a829afe$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $dea7058f0a829afe$var$_current = $dea7058f0a829afe$var$_inMemoryProvider;
        else $dea7058f0a829afe$var$_current = $dea7058f0a829afe$var$_main;
    }
};
function $dea7058f0a829afe$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    try {
        return JSON.parse(value !== null && value !== void 0 ? value : 'null');
    } catch (e) {
        $fogBN.Log.error(`Failed to parse value for key "${key}"`);
        return null;
    }
}
module.exports._getObjectFromStorage = $dea7058f0a829afe$var$_getObjectFromStorage;
function $dea7058f0a829afe$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $dea7058f0a829afe$var$_setObjectInStorage;

});


parcelRegister("aTHwN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $7ef0ce31ae35f466$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $7ef0ce31ae35f466$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $7ef0ce31ae35f466$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("jsyRv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $e2abacb2a697d4dc$var$SDK_CLIENT = {};
let $e2abacb2a697d4dc$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $e2abacb2a697d4dc$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($e2abacb2a697d4dc$var$suffix !== null && $e2abacb2a697d4dc$var$suffix !== void 0 ? $e2abacb2a697d4dc$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $e2abacb2a697d4dc$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$e2abacb2a697d4dc$var$suffix || $e2abacb2a697d4dc$var$suffix === '-react') $e2abacb2a697d4dc$var$suffix = '-' + binding;
    }
};

});

parcelRegister("iqii8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $jUwr4 = parcelRequire("jUwr4");

var $fogBN = parcelRequire("fogBN");

var $j7aLw = parcelRequire("j7aLw");

var $95OeL = parcelRequire("95OeL");

var $eNzGC = parcelRequire("eNzGC");
const $d698d802eef5ec9d$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $d698d802eef5ec9d$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $d698d802eef5ec9d$var$PERSIST_THROTTLE_MS = 15000;
const $d698d802eef5ec9d$var$SESSION_MAP = {};
(0, $eNzGC._subscribeToVisiblityChanged)((visibility)=>{
    if (visibility === 'background') Object.values($d698d802eef5ec9d$var$SESSION_MAP).forEach((session)=>$d698d802eef5ec9d$var$_persistNow(session));
});
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey, bumpSession = true)=>{
        if ($d698d802eef5ec9d$var$SESSION_MAP[sdkKey] == null) $d698d802eef5ec9d$var$SESSION_MAP[sdkKey] = $d698d802eef5ec9d$var$_loadOrCreateSharedSession(sdkKey);
        const session = $d698d802eef5ec9d$var$SESSION_MAP[sdkKey];
        return $d698d802eef5ec9d$var$_maybeBumpSession(session, bumpSession);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        const now = Date.now();
        const session = {
            data: {
                sessionID: override,
                startTime: now,
                lastUpdate: now
            },
            sdkKey: sdkKey,
            lastPersistedAt: Date.now(),
            storageKey: $d698d802eef5ec9d$var$_getSessionIDStorageKey(sdkKey)
        };
        $d698d802eef5ec9d$var$_persistNow(session);
        $d698d802eef5ec9d$var$SESSION_MAP[sdkKey] = session;
    },
    checkForIdleSession: (sdkKey)=>{
        const session = $d698d802eef5ec9d$var$SESSION_MAP[sdkKey];
        if (!session) return;
        const sessionExpired = $d698d802eef5ec9d$var$_checkForExpiredSession(session);
        if (sessionExpired) $d698d802eef5ec9d$var$_persistNow(session);
    }
};
function $d698d802eef5ec9d$var$_maybeBumpSession(session, allowSessionBump) {
    const now = Date.now();
    const sessionExpired = $d698d802eef5ec9d$var$_checkForExpiredSession(session);
    if (sessionExpired) $d698d802eef5ec9d$var$_persistNow(session);
    else if (allowSessionBump) {
        session.data.lastUpdate = now;
        $d698d802eef5ec9d$var$_persistThrottled(session);
    }
    return session;
}
function $d698d802eef5ec9d$var$_checkForExpiredSession(session) {
    var _a;
    const data = session.data;
    const sessionExpired = $d698d802eef5ec9d$var$_isIdle(data) || $d698d802eef5ec9d$var$_hasRunTooLong(data);
    if (sessionExpired) {
        session.data = $d698d802eef5ec9d$var$_newSessionData();
        (_a = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(session.sdkKey)) === null || _a === void 0 || _a.$emt({
            name: 'session_expired'
        });
    }
    return sessionExpired;
}
function $d698d802eef5ec9d$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $d698d802eef5ec9d$var$MAX_SESSION_IDLE_TIME;
}
function $d698d802eef5ec9d$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $d698d802eef5ec9d$var$MAX_SESSION_AGE;
}
function $d698d802eef5ec9d$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $jUwr4._getStorageKey)(sdkKey)}`;
}
function $d698d802eef5ec9d$var$_persistNow(session) {
    try {
        (0, $j7aLw._setObjectInStorage)(session.storageKey, session.data);
        session.lastPersistedAt = Date.now();
    } catch (e) {
        $fogBN.Log.warn('Failed to save SessionID');
    }
}
function $d698d802eef5ec9d$var$_persistThrottled(session) {
    const now = Date.now();
    if (now - session.lastPersistedAt > $d698d802eef5ec9d$var$PERSIST_THROTTLE_MS) $d698d802eef5ec9d$var$_persistNow(session);
}
function $d698d802eef5ec9d$var$_loadSessionFromStorage(storageKey) {
    const data = (0, $j7aLw._getObjectFromStorage)(storageKey);
    return data;
}
function $d698d802eef5ec9d$var$_loadOrCreateSharedSession(sdkKey) {
    const storageKey = $d698d802eef5ec9d$var$_getSessionIDStorageKey(sdkKey);
    const existing = $d698d802eef5ec9d$var$_loadSessionFromStorage(storageKey);
    if (existing && existing.sessionID && existing.startTime && existing.lastUpdate) return {
        data: existing,
        sdkKey: sdkKey,
        lastPersistedAt: 0,
        storageKey: storageKey
    };
    return {
        data: $d698d802eef5ec9d$var$_newSessionData(),
        sdkKey: sdkKey,
        lastPersistedAt: 0,
        storageKey: storageKey
    };
}
function $d698d802eef5ec9d$var$_newSessionData() {
    return {
        sessionID: (0, $95OeL.getUUID)(),
        startTime: Date.now(),
        lastUpdate: Date.now()
    };
}

});
parcelRegister("95OeL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $69eb8cbf3e958634$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $69eb8cbf3e958634$var$getUUID;

});


parcelRegister("hCAQu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCookieName = module.exports.StableID = void 0;

var $jUwr4 = parcelRequire("jUwr4");

var $fogBN = parcelRequire("fogBN");

var $ldgOi = parcelRequire("ldgOi");

var $j7aLw = parcelRequire("j7aLw");

var $95OeL = parcelRequire("95OeL");
const $cd42910c446ad746$var$PROMISE_MAP = {};
const $cd42910c446ad746$var$COOKIE_ENABLED_MAP = {};
const $cd42910c446ad746$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($cd42910c446ad746$var$DISABLED_MAP[sdkKey]) return null;
        if ($cd42910c446ad746$var$PROMISE_MAP[sdkKey] != null) return $cd42910c446ad746$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $cd42910c446ad746$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $cd42910c446ad746$var$PROMISE_MAP[sdkKey] = stableID;
            $cd42910c446ad746$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $cd42910c446ad746$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $95OeL.getUUID)();
        $cd42910c446ad746$var$_persistToStorage(stableID, sdkKey);
        $cd42910c446ad746$var$_persistToCookie(stableID, sdkKey);
        $cd42910c446ad746$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $cd42910c446ad746$var$PROMISE_MAP[sdkKey] = override;
        $cd42910c446ad746$var$_persistToStorage(override, sdkKey);
        $cd42910c446ad746$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $cd42910c446ad746$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $cd42910c446ad746$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $cd42910c446ad746$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $jUwr4._getStorageKey)(sdkKey)}`;
}
function $cd42910c446ad746$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $cd42910c446ad746$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $j7aLw._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $fogBN.Log.warn('Failed to save StableID to storage');
    }
}
function $cd42910c446ad746$var$_loadFromStorage(sdkKey) {
    const storageKey = $cd42910c446ad746$var$_getStableIDStorageKey(sdkKey);
    return (0, $j7aLw._getObjectFromStorage)(storageKey);
}
function $cd42910c446ad746$var$_loadFromCookie(sdkKey) {
    if (!$cd42910c446ad746$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $ldgOi._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $cd42910c446ad746$var$getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $cd42910c446ad746$var$_persistToCookie(stableID, sdkKey) {
    if (!$cd42910c446ad746$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $ldgOi._getDocumentSafe)() == null) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$cd42910c446ad746$var$getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $cd42910c446ad746$var$getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $jUwr4._getStorageKey)(sdkKey)}`;
}
module.exports.getCookieName = $cd42910c446ad746$var$getCookieName;

});

parcelRegister("kl1By", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});

parcelRegister("bi6ve", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.32.0';
let $83866b7a49f4d2aa$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$83866b7a49f4d2aa$var$metadata,
    add: (additions)=>{
        $83866b7a49f4d2aa$var$metadata = Object.assign(Object.assign({}, $83866b7a49f4d2aa$var$metadata), additions);
    }
};

});

parcelRegister("arnMz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});



parcelRegister("dxWOs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PendingEvents = void 0;

var $fogBN = parcelRequire("fogBN");
class $9dcbfa6cfeb14eb6$var$PendingEvents {
    constructor(batchSize){
        this._pendingEvents = [];
        this._batchSize = batchSize;
    }
    addToPendingEventsQueue(event) {
        this._pendingEvents.push(event);
        $fogBN.Log.debug('Enqueued Event:', event);
    }
    hasEventsForFullBatch() {
        return this._pendingEvents.length >= this._batchSize;
    }
    takeAll() {
        const events = this._pendingEvents;
        this._pendingEvents = [];
        return events;
    }
    isEmpty() {
        return this._pendingEvents.length === 0;
    }
}
module.exports.PendingEvents = $9dcbfa6cfeb14eb6$var$PendingEvents;

});

parcelRegister("bX5bD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $8b393a5c6e27c58f$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $8b393a5c6e27c58f$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $8b393a5c6e27c58f$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $8b393a5c6e27c58f$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $8b393a5c6e27c58f$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $8b393a5c6e27c58f$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $8b393a5c6e27c58f$var$GATE_EXPOSURE_NAME || eventName === $8b393a5c6e27c58f$var$CONFIG_EXPOSURE_NAME || eventName === $8b393a5c6e27c58f$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $8b393a5c6e27c58f$var$_isExposureEvent;
const $8b393a5c6e27c58f$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $8b393a5c6e27c58f$var$_createExposure($8b393a5c6e27c58f$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $8b393a5c6e27c58f$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $8b393a5c6e27c58f$var$_createGateExposure;
function $8b393a5c6e27c58f$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $8b393a5c6e27c58f$var$_mapExposures;
const $8b393a5c6e27c58f$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $8b393a5c6e27c58f$var$_createExposure($8b393a5c6e27c58f$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $8b393a5c6e27c58f$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $8b393a5c6e27c58f$var$_createConfigExposure;
const $8b393a5c6e27c58f$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $8b393a5c6e27c58f$var$_createExposure($8b393a5c6e27c58f$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $8b393a5c6e27c58f$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $8b393a5c6e27c58f$var$_createLayerParameterExposure;
const $8b393a5c6e27c58f$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("dUjjm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $8G0fX = parcelRequire("8G0fX");

var $31J1W = parcelRequire("31J1W");
const $a1ff7c1e36b8f681$var$ENDPOINT_DNS_KEY_MAP = {
    [$31J1W.Endpoint._initialize]: 'i',
    [$31J1W.Endpoint._rgstr]: 'e',
    [$31J1W.Endpoint._download_config_specs]: 'd'
};
class $a1ff7c1e36b8f681$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $a1ff7c1e36b8f681$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $31J1W.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $8G0fX._DJB2)(this.customUrl + fallbacks);
    }
}
module.exports.UrlConfiguration = $a1ff7c1e36b8f681$var$UrlConfiguration;

});


parcelRegister("eUtax", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrecomputedEvaluationsContextHandle = void 0;

var $fogBN = parcelRequire("fogBN");

var $ldgOi = parcelRequire("ldgOi");

var $iqii8 = parcelRequire("iqii8");

var $hCAQu = parcelRequire("hCAQu");
/**
 * A handle to the PrecomputedEvaluationsContext that computes fields lazily on access.
 * This avoids unnecessary computation (e.g., cloning the user) when only certain fields are needed.
 * The handle is created once and reused; individual getters fetch current values on each access.
 */ class $adacec0506b35ef2$var$PrecomputedEvaluationsContextHandle {
    constructor(sdkKey, getOptions, getErrorBoundary, getValues, getUser, getSdkInstanceID){
        this._sdkKey = sdkKey;
        this._getOptions = getOptions;
        this._getErrorBoundary = getErrorBoundary;
        this._getValues = getValues;
        this._getUser = getUser;
        this._getSdkInstanceID = getSdkInstanceID;
    }
    get sdkKey() {
        return this._sdkKey;
    }
    get options() {
        return this._getOptions();
    }
    get errorBoundary() {
        return this._getErrorBoundary();
    }
    get values() {
        return this._getValues();
    }
    get user() {
        let user = (0, $ldgOi._cloneObject)('StatsigUser', this._getUser());
        if (user == null) {
            $fogBN.Log.error('Failed to clone user');
            user = {};
        }
        return user;
    }
    /**
     * Gets the current session.
     * @param {boolean} [bumpSession=true] - Whether to bump/update the session timing. Set to false to read without affecting session state.
     */ getSession(bumpSession = true) {
        return $iqii8.StatsigSession.get(this._sdkKey, bumpSession);
    }
    get stableID() {
        return $hCAQu.StableID.get(this._sdkKey);
    }
    get sdkInstanceID() {
        return this._getSdkInstanceID();
    }
    /**
     * Returns the full PrecomputedEvaluationsContext object.
     * Use this when you need all fields at once.
     * @param {boolean} [bumpSession=true] - Whether to bump the session when building the context.
     */ toContext(bumpSession = true) {
        return {
            sdkKey: this.sdkKey,
            options: this.options,
            values: this.values,
            user: this.user,
            errorBoundary: this.errorBoundary,
            session: this.getSession(bumpSession),
            stableID: this.stableID,
            sdkInstanceID: this.sdkInstanceID
        };
    }
}
module.exports.PrecomputedEvaluationsContextHandle = $adacec0506b35ef2$var$PrecomputedEvaluationsContextHandle;

});

parcelRegister("8ShCc", function(module, exports) {
"use strict";
var $676107da34279585$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $fogBN = parcelRequire("fogBN");

var $hCAQu = parcelRequire("hCAQu");

var $iFqY0 = parcelRequire("iFqY0");

var $j7aLw = parcelRequire("j7aLw");

var $4u95a = parcelRequire("4u95a");
const $676107da34279585$var$CACHE_LIMIT = 10;
const $676107da34279585$var$MAX_CACHE_WRITE_ATTEMPTS = 8;
class $676107da34279585$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._cacheLimit = $676107da34279585$var$CACHE_LIMIT;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $676107da34279585$var$InMemoryCache();
    }
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $iFqY0._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache, this._cacheLimit);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $iFqY0._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $676107da34279585$var$_makeDataAdapterResult('Bootstrap', data, null, normalized), this._cacheLimit);
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $hCAQu.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $676107da34279585$var$__awaiter(this, void 0, void 0, function*() {
            if (!$j7aLw.Storage.isReady()) yield $j7aLw.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $fogBN.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $676107da34279585$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $iFqY0._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }), this._cacheLimit);
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $676107da34279585$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $fogBN.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $4u95a._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $hCAQu.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $676107da34279585$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $676107da34279585$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result, this._cacheLimit);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $fogBN.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $j7aLw.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($j7aLw.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $4u95a._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        const resultString = JSON.stringify(result);
        for(let i = 0; i < $676107da34279585$var$MAX_CACHE_WRITE_ATTEMPTS; i++)try {
            $j7aLw.Storage.setItem(cacheKey, resultString);
            break;
        } catch (error) {
            if (!(error instanceof Error) || !(error.toString().includes('QuotaExceededError') || error.toString().includes('QUOTA_EXCEEDED_ERR')) || this._cacheLimit <= 1) throw error;
            this._cacheLimit = Math.ceil(this._cacheLimit / 2);
            this._runLocalStorageCacheEviction(cacheKey, this._cacheLimit - 1);
        }
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey, cacheLimit = this._cacheLimit) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $j7aLw._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictableKeys = $676107da34279585$var$_getEvictableKeys(lastModifiedTimeMap, cacheLimit);
        for (const evictable of evictableKeys){
            delete lastModifiedTimeMap[evictable];
            $j7aLw.Storage.removeItem(evictable);
        }
        (0, $j7aLw._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $676107da34279585$var$DataAdapterCore;
function $676107da34279585$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $iFqY0._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $676107da34279585$var$_makeDataAdapterResult;
class $676107da34279585$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $fogBN.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value, cacheLimit) {
        const evictableKeys = $676107da34279585$var$_getEvictableKeys(this._data, cacheLimit - 1);
        for (const evictable of evictableKeys)delete this._data[evictable];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $676107da34279585$var$_getEvictableKeys(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return [];
    if (limit === 0) return keys;
    return keys.sort((keyA, keyB)=>{
        const valueA = data[keyA];
        const valueB = data[keyB];
        if (typeof valueA === 'object' && typeof valueB === 'object') return valueA.receivedAt - valueB.receivedAt;
        return valueA - valueB;
    }).slice(0, keys.length - limit);
}

});
parcelRegister("iFqY0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnitIDFromUser = module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $8G0fX = parcelRequire("8G0fX");

var $fogBN = parcelRequire("fogBN");

var $ldgOi = parcelRequire("ldgOi");
function $d970f9600c068fd4$var$_normalizeUser(original, options, fallbackEnvironment) {
    const copy = (0, $ldgOi._cloneObject)('StatsigUser', original);
    if (copy == null) {
        $fogBN.Log.error('Failed to clone user');
        return {
            statsigEnvironment: undefined
        };
    }
    if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
    else if (fallbackEnvironment != null) copy.statsigEnvironment = {
        tier: fallbackEnvironment
    };
    return copy;
}
module.exports._normalizeUser = $d970f9600c068fd4$var$_normalizeUser;
function $d970f9600c068fd4$var$_getFullUserHash(user) {
    return user ? (0, $8G0fX._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $d970f9600c068fd4$var$_getFullUserHash;
function $d970f9600c068fd4$var$_getUnitIDFromUser(user, idType) {
    var _a, _b, _c;
    if (typeof idType !== 'string') return user.userID;
    const lowered = idType.toLowerCase();
    if (lowered !== 'userid') return (_b = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a[idType]) !== null && _b !== void 0 ? _b : (_c = user.customIDs) === null || _c === void 0 ? void 0 : _c[lowered];
    return user.userID;
}
module.exports._getUnitIDFromUser = $d970f9600c068fd4$var$_getUnitIDFromUser;

});

parcelRegister("4u95a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $fogBN = parcelRequire("fogBN");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $34410256afceb6c3$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $fogBN.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $34410256afceb6c3$var$_typedJsonParse;

});


parcelRegister("3Dpi8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ctRBw", function(module, exports) {
"use strict";
var $9161c624a507b12f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $fogBN = parcelRequire("fogBN");

var $jsyRv = parcelRequire("jsyRv");

var $bi6ve = parcelRequire("bi6ve");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $9161c624a507b12f$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $9161c624a507b12f$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance, namePrefix) {
        try {
            const obj = instance;
            $9161c624a507b12f$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(namePrefix ? `${namePrefix}:${name}` : name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    logDroppedEvents(count, reason, metadata) {
        const extra = {
            eventCount: String(count)
        };
        if (metadata) Object.keys(metadata).forEach((key)=>{
            extra[key] = String(metadata[key]);
        });
        this._onError(`statsig::log_event_dropped_event_count`, new Error(reason), true, extra);
    }
    logEventRequestFailure(count, reason, flushType, statusCode, retries) {
        const extra = {
            eventCount: String(count),
            flushType: flushType,
            statusCode: String(statusCode),
            reason: reason,
            retries: String(retries)
        };
        this._onError(`statsig::log_event_failed`, new Error(reason), true, extra);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $9161c624a507b12f$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error, bypassDedupe = false, extra) {
        try {
            $fogBN.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$9161c624a507b12f$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($9161c624a507b12f$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $9161c624a507b12f$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (!bypassDedupe && this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $jsyRv.SDKType._get(this._sdkKey);
                    const statsigMetadata = $bi6ve.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $9161c624a507b12f$var$_getDescription(unwrapped);
                    const body = Object.assign(Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $9161c624a507b12f$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    })), extra !== null && extra !== void 0 ? extra : {});
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $9161c624a507b12f$var$ErrorBoundary;
function $9161c624a507b12f$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $9161c624a507b12f$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $9161c624a507b12f$var$UNKNOWN_ERROR;
    }
}
function $9161c624a507b12f$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $9161c624a507b12f$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.keys(options).forEach((key)=>{
        const option = key;
        const value = options[option];
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});

parcelRegister("5Ux73", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("k6TO4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("e2oUT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("E7Ll7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $0789c20563630e49$var$EXIST_KEYS = new Set([]);
const $0789c20563630e49$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $0789c20563630e49$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($0789c20563630e49$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($0789c20563630e49$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $0789c20563630e49$var$createMemoKey;

});

parcelRegister("dbgqg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("600JO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("l4DW6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $f578f32b4970af08$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $f578f32b4970af08$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $f578f32b4970af08$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $f578f32b4970af08$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $f578f32b4970af08$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $f578f32b4970af08$var$_fastApproxSizeOf;

});

parcelRegister("2Pm72", function(module, exports) {
"use strict";
var $20f17f4307cdea50$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $lEKhf = parcelRequire("lEKhf");

var $lEKhf = parcelRequire("lEKhf");

var $ctRBw = parcelRequire("ctRBw");

var $7zZzY = parcelRequire("7zZzY");

var $fogBN = parcelRequire("fogBN");

var $E7Ll7 = parcelRequire("E7Ll7");

var $ldgOi = parcelRequire("ldgOi");

var $iqii8 = parcelRequire("iqii8");

var $hCAQu = parcelRequire("hCAQu");

var $arnMz = parcelRequire("arnMz");

var $j7aLw = parcelRequire("j7aLw");
const $20f17f4307cdea50$var$MAX_MEMO_CACHE_SIZE = 3000;
class $20f17f4307cdea50$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($fogBN.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $j7aLw.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $iqii8.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $j7aLw.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $hCAQu.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $hCAQu.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._errorBoundary = new $ctRBw.ErrorBoundary(sdkKey, options, emitter);
        this._logger = new $7zZzY.EventLogger(sdkKey, emitter, network, options, this._errorBoundary);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $j7aLw.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $20f17f4307cdea50$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $j7aLw.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $hCAQu.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($arnMz.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $20f17f4307cdea50$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $fogBN.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $E7Ll7.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $20f17f4307cdea50$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $20f17f4307cdea50$var$StatsigClientBase;
function $20f17f4307cdea50$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $ldgOi._isServerEnv)()) return;
    const statsigGlobal = (0, $lEKhf._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $fogBN.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("kdRer", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("6sOnd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eEMMa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $fogBN = parcelRequire("fogBN");

var $eXxwK = parcelRequire("eXxwK");
function $aabaa2fff9aa763b$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $aabaa2fff9aa763b$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $aabaa2fff9aa763b$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $aabaa2fff9aa763b$var$_makeFeatureGate;
function $aabaa2fff9aa763b$var$_makeDynamicConfig(name, details, evaluation) {
    var _a, _b;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $aabaa2fff9aa763b$var$_makeEvaluation(name, details, evaluation, value)), {
        idType: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _b !== void 0 ? _b : null,
        get: $aabaa2fff9aa763b$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $aabaa2fff9aa763b$var$_makeDynamicConfig;
function $aabaa2fff9aa763b$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $aabaa2fff9aa763b$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $aabaa2fff9aa763b$var$_makeExperiment;
function $aabaa2fff9aa763b$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $aabaa2fff9aa763b$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $aabaa2fff9aa763b$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $aabaa2fff9aa763b$var$_makeLayer;
function $aabaa2fff9aa763b$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $aabaa2fff9aa763b$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $aabaa2fff9aa763b$var$_mergeOverride;
function $aabaa2fff9aa763b$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $eXxwK._isTypeMatch)(found, fallback)) {
            $fogBN.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $aabaa2fff9aa763b$var$_makeTypedGet;

});

parcelRegister("8bfzg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cuJ0o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $0258f46d7c581aa5$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $0258f46d7c581aa5$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("eBkTV", function(module, exports) {
"use strict";
var $aa14bbe2b6916af2$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $buH38 = parcelRequire("buH38");

var $g7iC4 = parcelRequire("g7iC4");

var $6KsI0 = parcelRequire("6KsI0");

var $1hjgU = parcelRequire("1hjgU");

var $QHuiV = parcelRequire("QHuiV");
class $aa14bbe2b6916af2$var$StatsigClient extends $buH38.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $buH38._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $aa14bbe2b6916af2$var$StatsigClient) return instance;
        $buH38.Log.warn((0, $buH38._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $aa14bbe2b6916af2$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $buH38.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $6KsI0.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $QHuiV.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($buH38.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($buH38.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($buH38.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($buH38.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($buH38.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($buH38.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $g7iC4.default(sdkKey, options !== null && options !== void 0 ? options : null);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $buH38.getUUID)();
        this._contextHandle = new $buH38.PrecomputedEvaluationsContextHandle(sdkKey, ()=>this._options, ()=>this._errorBoundary, ()=>this._store.getValues(), ()=>this._user, ()=>this._sdkInstanceID);
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $buH38.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $aa14bbe2b6916af2$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $buH38.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $buH38.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $aa14bbe2b6916af2$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $aa14bbe2b6916af2$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $buH38.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $buH38.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $buH38.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $buH38.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($buH38.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $buH38.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $buH38.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $buH38.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        let user = (0, $buH38._cloneObject)('StatsigUser', this._user);
        if (user == null) {
            $buH38.Log.error('Failed to clone user');
            user = {};
        }
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: user,
            errorBoundary: this._errorBoundary,
            session: $buH38.StatsigSession.get(this._sdkKey),
            stableID: $buH38.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves a context handle that computes fields lazily on access.
     * This is more efficient than getContext() when you only need certain fields,
     *
     * @returns {PrecomputedEvaluationsContextHandle} A handle with lazy getters for context fields.
     */ getContextHandle() {
        return this._contextHandle;
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $aa14bbe2b6916af2$var$__awaiter(this, void 0, void 0, function*() {
            if (!$buH38.Storage.isReady()) yield $buH38.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $buH38.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $buH38.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a, _b, _c;
        const user = (0, $buH38._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) {
            const readyPromise = (_c = (_b = this.storageProvider).isReadyResolver) === null || _c === void 0 ? void 0 : _c.call(_b);
            if (readyPromise) readyPromise.then(()=>$buH38.StableID.setOverride(stableIdOverride, this._sdkKey), ()=>$buH38.StableID.setOverride(stableIdOverride, this._sdkKey));
            else $buH38.StableID.setOverride(stableIdOverride, this._sdkKey);
        }
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        this._checkUserHasIdForEvaluation(evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type, name, 'Gate');
        this._checkInitializationStatus(details.reason);
        const gate = (0, $buH38._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $buH38._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        this._checkUserHasIdForEvaluation(evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type, name, 'Dynamic config');
        this._checkInitializationStatus(details.reason);
        const config = (0, $buH38._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $buH38._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        this._checkUserHasIdForEvaluation(evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type, name, 'Experiment');
        this._checkInitializationStatus(details.reason);
        const experiment = (0, $buH38._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $buH38._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $buH38._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $buH38._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $buH38._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $buH38._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $1hjgU._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $1hjgU._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
    _checkUserHasIdForEvaluation(idType, name, type) {
        if (!idType) return;
        if (!(0, $buH38._getUnitIDFromUser)(this._user, idType)) $buH38.Log.warn(`The user does not have the required id_type "${idType}" for ${type} "${name}"`);
    }
    _checkInitializationStatus(reason) {
        if (reason === 'Uninitialized' || reason.startsWith('Loading')) $buH38.Log.warn(`SDK initialization has not completed. Reason: ${reason}`);
    }
}
module.exports.default = $aa14bbe2b6916af2$var$StatsigClient;

});
parcelRegister("g7iC4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $buH38 = parcelRequire("buH38");

var $8hJNs = parcelRequire("8hJNs");

var $fa3Nl = parcelRequire("fa3Nl");
class $bbbbbcf8abd5d645$var$EvaluationStore {
    constructor(_sdkKey, _options){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._valuesForExternalUse = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._valuesForExternalUse = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        // we do not give out the actual _values object to avoid mutating it
        return this._valuesForExternalUse;
    }
    setValues(result, user) {
        var _a, _b;
        if (!result) return false;
        const values = (0, $buH38._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        const updatedLcut = (_a = values.time) !== null && _a !== void 0 ? _a : 0;
        if (updatedLcut < this._lcut) return true;
        this._valuesForExternalUse = (0, $buH38._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        if (values.response_format === 'init-v2') this._values = new $fa3Nl.V2InitializeContainer(values);
        else this._values = new $8hJNs.V1InitializeContainer(values);
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $buH38.SDKFlags.setFlags(this._sdkKey, (_b = values.sdk_flags) !== null && _b !== void 0 ? _b : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        const res = this._values ? this._values.getGate(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfig(name) {
        const res = this._values ? this._values.getConfig(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfigList() {
        if (!this._values) return [];
        return this._values.getConfigList();
    }
    getLayer(name) {
        const res = this._values ? this._values.getLayer(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getParamStore(name) {
        const res = this._values ? this._values.getParamStore(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.getExposureMapping();
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(result) {
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b, _c;
        const stableID = $buH38.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            let bootstrapUser = values['user'];
            let userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((_c = this._options) === null || _c === void 0 ? void 0 : _c.disableStableID) {
                userForComparison = Object.assign(Object.assign({}, userForComparison), {
                    customIDs: Object.assign(Object.assign({}, userForComparison.customIDs), {
                        stableID: undefined
                    })
                });
                bootstrapUser = Object.assign(Object.assign({}, bootstrapUser), {
                    customIDs: Object.assign(Object.assign({}, bootstrapUser.customIDs), {
                        stableID: undefined
                    })
                });
            }
            if ((0, $buH38._getFullUserHash)(userForComparison) !== (0, $buH38._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $bbbbbcf8abd5d645$var$EvaluationStore;

});
parcelRegister("8hJNs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V1InitializeContainer = void 0;

var $buH38 = parcelRequire("buH38");
class $60836f8b8899b53d$var$V1InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        return this._getResultFromLookup(this._values.feature_gates, name);
    }
    getConfig(name) {
        return this._getResultFromLookup(this._values.dynamic_configs, name);
    }
    getLayer(name) {
        return this._getResultFromLookup(this._values.layer_configs, name);
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $buH38._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V1InitializeContainer = $60836f8b8899b53d$var$V1InitializeContainer;

});

parcelRegister("fa3Nl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V2InitializeContainer = void 0;

var $buH38 = parcelRequire("buH38");
class $b09abbc98cf20fd0$var$V2InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        var _a, _b, _c;
        const evalV2 = this._getResultFromLookup(this._values.feature_gates, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: evalV2.v === true,
            rule_id: (_a = evalV2.r) !== null && _a !== void 0 ? _a : 'default',
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : ''
        };
    }
    getConfig(name) {
        var _a, _b, _c, _d;
        const evalV2 = this._getResultFromLookup(this._values.dynamic_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : '',
            is_user_in_experiment: evalV2.ue === true ? true : false,
            passed: evalV2.p === true,
            group_name: (_d = evalV2.gn) !== null && _d !== void 0 ? _d : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID'
        };
    }
    getLayer(name) {
        var _a, _b, _c, _d, _e, _f;
        const evalV2 = this._getResultFromLookup(this._values.layer_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            is_user_in_experiment: evalV2.ue === true ? true : false,
            group_name: (_c = evalV2.gn) !== null && _c !== void 0 ? _c : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID',
            allocated_experiment_name: (_d = evalV2.ae) !== null && _d !== void 0 ? _d : '',
            explicit_parameters: (_e = evalV2.ep) !== null && _e !== void 0 ? _e : [],
            undelegated_secondary_exposures: (_f = evalV2.us) !== null && _f !== void 0 ? _f : [],
            parameter_rule_ids: evalV2.pr
        };
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $buH38._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V2InitializeContainer = $b09abbc98cf20fd0$var$V2InitializeContainer;

});


parcelRegister("6KsI0", function(module, exports) {
"use strict";
var $4e9d4eebb0e13b6b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $buH38 = parcelRequire("buH38");

var $a1Jyv = parcelRequire("a1Jyv");
class $4e9d4eebb0e13b6b$var$StatsigNetwork extends $buH38.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $buH38.UrlConfiguration($buH38.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $4e9d4eebb0e13b6b$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $buH38._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $4e9d4eebb0e13b6b$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $a1Jyv._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $4e9d4eebb0e13b6b$var$StatsigNetwork;

});
parcelRegister("a1Jyv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $buH38 = parcelRequire("buH38");
const $74cd55bcfc842cc9$var$MAX_DELTAS_SORT_DEPTH = 2;
function $74cd55bcfc842cc9$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $buH38._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $74cd55bcfc842cc9$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $74cd55bcfc842cc9$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $buH38._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $74cd55bcfc842cc9$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $74cd55bcfc842cc9$var$_resolveDeltasResponse;
function $74cd55bcfc842cc9$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $74cd55bcfc842cc9$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $74cd55bcfc842cc9$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $74cd55bcfc842cc9$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $74cd55bcfc842cc9$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $74cd55bcfc842cc9$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("1hjgU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $buH38 = parcelRequire("buH38");
const $0ee653eff463efc7$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $0ee653eff463efc7$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $0ee653eff463efc7$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $buH38._isTypeMatch)(value, fallback);
}
function $0ee653eff463efc7$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $0ee653eff463efc7$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $0ee653eff463efc7$var$_shouldLogExposure(options) ? undefined : $0ee653eff463efc7$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $0ee653eff463efc7$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $0ee653eff463efc7$var$_shouldLogExposure(options) ? undefined : $0ee653eff463efc7$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($0ee653eff463efc7$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $0ee653eff463efc7$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $0ee653eff463efc7$var$_shouldLogExposure(options) ? undefined : $0ee653eff463efc7$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($0ee653eff463efc7$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $0ee653eff463efc7$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $0ee653eff463efc7$var$_shouldLogExposure(options) ? undefined : $0ee653eff463efc7$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($0ee653eff463efc7$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $0ee653eff463efc7$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $buH38._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $0ee653eff463efc7$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $0ee653eff463efc7$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $0ee653eff463efc7$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $0ee653eff463efc7$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $0ee653eff463efc7$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $0ee653eff463efc7$var$_makeParamStoreGetter;

});

parcelRegister("QHuiV", function(module, exports) {
"use strict";
var $09e69735d920f219$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $buH38 = parcelRequire("buH38");

var $6KsI0 = parcelRequire("6KsI0");
class $09e69735d920f219$var$StatsigEvaluationsDataAdapter extends $buH38.DataAdapterCore {
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $6KsI0.default) this._network = network;
        else this._network = new $6KsI0.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $buH38._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $buH38._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $buH38.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $09e69735d920f219$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $buH38._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$buH38.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $buH38._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $09e69735d920f219$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("e7NgS", function(module, exports) {
$parcel$export(module.exports, "default", () => $a487f0619ffafb0f$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $hLfKH = parcelRequire("hLfKH");
function $a487f0619ffafb0f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a487f0619ffafb0f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a487f0619ffafb0f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a487f0619ffafb0f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a487f0619ffafb0f$export$a66cbd9b2289cd78 = '@all-features';
var $a487f0619ffafb0f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $a487f0619ffafb0f$var$_objectSpread($a487f0619ffafb0f$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $a487f0619ffafb0f$var$_objectSpread($a487f0619ffafb0f$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $a487f0619ffafb0f$var$_objectSpread($a487f0619ffafb0f$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $a487f0619ffafb0f$var$_objectSpread($a487f0619ffafb0f$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($a487f0619ffafb0f$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($a487f0619ffafb0f$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($a487f0619ffafb0f$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $a487f0619ffafb0f$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("iwBvv", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $d7c84f488ef006df$export$6dc24881a3d96325);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $edtOW = parcelRequire("edtOW");
var $d7c84f488ef006df$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $edtOW.migrateEvaluationDetails)(experiment.details), (0, $edtOW.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("edtOW", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $a5996959142470ab$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $a5996959142470ab$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $a5996959142470ab$export$3dad1db244472f32);
$parcel$export(module.exports, "deepAssign", () => $a5996959142470ab$export$1148cb79ceecd5fa);
$parcel$export(module.exports, "migrateInitializationOptions", () => $a5996959142470ab$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $a5996959142470ab$export$18ad168d3dbac899);
$parcel$export(module.exports, "migrateSecondaryExposures", () => $a5996959142470ab$export$55fd683752d01e67);

var $ekGgq = parcelRequire("ekGgq");

var $fC8ib = parcelRequire("fC8ib");

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $hRiFb = parcelRequire("hRiFb");

var $fDQ0p = parcelRequire("fDQ0p");

var $jLH8B = parcelRequire("jLH8B");
var $a5996959142470ab$var$_excluded = [
    "stableId"
], $a5996959142470ab$var$_excluded2 = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $a5996959142470ab$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a5996959142470ab$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a5996959142470ab$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a5996959142470ab$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a5996959142470ab$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $a5996959142470ab$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $hRiFb.isFedRamp)() ? (0, $jLH8B.PerimeterType).FEDRAMP_MODERATE : (0, $jLH8B.PerimeterType).COMMERCIAL
    }, options);
};
var $a5996959142470ab$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $a5996959142470ab$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    var stableId = identifiers.stableId, otherIdentifiers = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(identifiers, $a5996959142470ab$var$_excluded);
    var user = {
        customIDs: $a5996959142470ab$var$_objectSpread($a5996959142470ab$var$_objectSpread({}, otherIdentifiers), stableId !== undefined ? {
            stableID: stableId
        } : {}),
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
function $a5996959142470ab$export$1148cb79ceecd5fa(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return $a5996959142470ab$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sources)));
    for(var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], src = _Object$entries$_i[1];
        var dst = target[key];
        var srcIsObj = src && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(src) === 'object' && !Array.isArray(src);
        var dstIsObj = dst && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(dst) === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $a5996959142470ab$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $a5996959142470ab$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sources)));
}
var $a5996959142470ab$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(options, $a5996959142470ab$var$_excluded2);
    return $a5996959142470ab$var$_objectSpread($a5996959142470ab$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $a5996959142470ab$var$evaluationReasonMappings = Object.entries((0, $fDQ0p.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $a5996959142470ab$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $a5996959142470ab$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $fDQ0p.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $a5996959142470ab$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("hRiFb", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $d005dd0ddc6c8e9b$export$64d6499adf9b2e51);

var $fNNeG = parcelRequire("fNNeG");
function $d005dd0ddc6c8e9b$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $fNNeG.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("fNNeG", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $b8119fd0653feb22$export$ce553301d55c2fd8);
var $b8119fd0653feb22$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $b8119fd0653feb22$export$f005e2e9f707cb5f = 'commercial';
var $b8119fd0653feb22$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $b8119fd0653feb22$export$a739cd5aac835909 = 'stg';
var $b8119fd0653feb22$export$42dd0cdd351a4a9 = 'prod';
var $b8119fd0653feb22$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("fDQ0p", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $b632d6c71a1941fc$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $b632d6c71a1941fc$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
}; // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("jLH8B", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $e643de58afdb7025$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $e643de58afdb7025$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $e643de58afdb7025$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
var $e643de58afdb7025$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
var $e643de58afdb7025$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("oWFzP", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $04afc090a62e6592$export$936d0764594b6eb3);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $edtOW = parcelRequire("edtOW");
var $04afc090a62e6592$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $edtOW.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $edtOW.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $edtOW.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("gwO2H", function(module, exports) {
$parcel$export(module.exports, "default", () => $c08673e2ec4692df$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $jLH8B = parcelRequire("jLH8B");

var $an40Y = parcelRequire("an40Y");

var $1HkPh = parcelRequire("1HkPh");
function $c08673e2ec4692df$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c08673e2ec4692df$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c08673e2ec4692df$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c08673e2ec4692df$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c08673e2ec4692df$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $c08673e2ec4692df$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $c08673e2ec4692df$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $c08673e2ec4692df$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $c08673e2ec4692df$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $c08673e2ec4692df$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $c08673e2ec4692df$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $c08673e2ec4692df$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $c08673e2ec4692df$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $c08673e2ec4692df$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $c08673e2ec4692df$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(fetcherOptions) {
                    var targetApp, url, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 1;
                                _context.next = 2;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                                _context.prev = 3;
                                _t = _context["catch"](1);
                                if (!(_t instanceof Error)) {
                                    _context.next = 4;
                                    break;
                                }
                                throw _t;
                            case 4:
                                throw Error('Failed to retrieve client sdk key');
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 2;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                                _context2.prev = 3;
                                _t2 = _context2["catch"](1);
                                if (!(_t2 instanceof Error)) {
                                    _context2.next = 4;
                                    break;
                                }
                                throw _t2;
                            case 4:
                                throw Error('Failed to retrieve experiment values');
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 2;
                                    break;
                                }
                                _context3.next = 1;
                                return response.text();
                            case 1:
                                body = _context3.sent;
                                throw new (0, $1HkPh.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 2:
                                if (!(response.status === 204)) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new (0, $1HkPh.ResponseError)('Unexpected 204 response');
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return response.text();
                            case 1:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $c08673e2ec4692df$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $jLH8B.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $jLH8B.FeatureGateEnvironment).Production:
                        return $c08673e2ec4692df$export$18c93900db9358a4;
                    case (0, $jLH8B.FeatureGateEnvironment).Staging:
                        return $c08673e2ec4692df$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $jLH8B.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $jLH8B.FeatureGateEnvironment).Development:
                        return $c08673e2ec4692df$export$f058dbf75c3bc647;
                    case (0, $jLH8B.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $c08673e2ec4692df$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $c08673e2ec4692df$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $c08673e2ec4692df$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 1;
                                return fetch("".concat(baseUrl).concat(path), $c08673e2ec4692df$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $an40Y.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 1:
                                response = _context5.sent;
                                _context5.next = 2;
                                return this.handleResponseError(response);
                            case 2:
                                _context5.next = 3;
                                return this.extractResponseBody(response);
                            case 3:
                                return _context5.abrupt("return", _context5.sent);
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $c08673e2ec4692df$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($c08673e2ec4692df$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($c08673e2ec4692df$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("an40Y", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $78cf2a9a1a6ba7be$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $78cf2a9a1a6ba7be$export$a59f8d67326bd1cb = "5.8.0";

});

parcelRegister("1HkPh", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $13c9f63382ae0148$export$286baf652d0b1206);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $13c9f63382ae0148$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $13c9f63382ae0148$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $13c9f63382ae0148$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($13c9f63382ae0148$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $13c9f63382ae0148$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ResponseError);
        return $13c9f63382ae0148$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});


parcelRegister("cyIRe", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $924b74c5bfbcde0b$export$55fffef3474104af);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iOj5B = parcelRequire("iOj5B");
function $924b74c5bfbcde0b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $924b74c5bfbcde0b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $924b74c5bfbcde0b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $924b74c5bfbcde0b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $924b74c5bfbcde0b$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $924b74c5bfbcde0b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $924b74c5bfbcde0b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($924b74c5bfbcde0b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $924b74c5bfbcde0b$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $924b74c5bfbcde0b$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoFetchDataAdapter);
        _this = $924b74c5bfbcde0b$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iOj5B.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $924b74c5bfbcde0b$var$_objectSpread($924b74c5bfbcde0b$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iOj5B._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $924b74c5bfbcde0b$var$_objectSpread($924b74c5bfbcde0b$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iOj5B._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iOj5B._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iOj5B.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $924b74c5bfbcde0b$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $924b74c5bfbcde0b$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iOj5B.DataAdapterCore));

});

parcelRegister("iMRG8", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $0387961536103856$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $0387961536103856$export$bcb28fbac1def494);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $buH38 = parcelRequire("buH38");
function $0387961536103856$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0387961536103856$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0387961536103856$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0387961536103856$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0387961536103856$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $0387961536103856$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $0387961536103856$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $0387961536103856$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $0387961536103856$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $0387961536103856$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $0387961536103856$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $0387961536103856$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $0387961536103856$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $0387961536103856$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $0387961536103856$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $0387961536103856$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PersistentOverrideAdapter);
        this._overrides = $0387961536103856$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $0387961536103856$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $0387961536103856$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $0387961536103856$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($0387961536103856$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($0387961536103856$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $0387961536103856$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $buH38._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $0387961536103856$var$_objectSpread($0387961536103856$var$_objectSpread({}, $0387961536103856$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($0387961536103856$var$djb2MapKey((0, $buH38._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($0387961536103856$var$djb2MapKey((0, $buH38._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($0387961536103856$var$djb2MapKey((0, $buH38._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($0387961536103856$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $0387961536103856$var$_objectSpread($0387961536103856$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $0387961536103856$var$_objectSpread($0387961536103856$var$_objectSpread({}, current.details), {}, {
                        reason: $0387961536103856$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($0387961536103856$var$djb2MapKey((0, $buH38._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($0387961536103856$var$djb2MapKey((0, $buH38._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($0387961536103856$var$djb2MapKey((0, $buH38._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($0387961536103856$var$djb2MapKey((0, $buH38._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($0387961536103856$var$djb2MapKey((0, $buH38._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($0387961536103856$var$djb2MapKey((0, $buH38._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $0387961536103856$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($0387961536103856$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $0387961536103856$var$_objectSpread($0387961536103856$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $buH38._makeTypedGet)(current.name, overridden),
                    details: $0387961536103856$var$_objectSpread($0387961536103856$var$_objectSpread({}, current.details), {}, {
                        reason: $0387961536103856$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($0387961536103856$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $0387961536103856$var$_objectSpread($0387961536103856$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $buH38._makeTypedGet)(current.name, overridden),
                    details: $0387961536103856$var$_objectSpread($0387961536103856$var$_objectSpread({}, current.details), {}, {
                        reason: $0387961536103856$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("jHaSP", function(module, exports) {
$parcel$export(module.exports, "debug", () => $e56a79a94b802af7$export$1c9f709888824e05);
var $e56a79a94b802af7$var$_process, $e56a79a94b802af7$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $e56a79a94b802af7$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($e56a79a94b802af7$var$_process = globalThis.process) === null || $e56a79a94b802af7$var$_process === void 0 || ($e56a79a94b802af7$var$_process = $e56a79a94b802af7$var$_process.env) === null || $e56a79a94b802af7$var$_process === void 0 ? void 0 : $e56a79a94b802af7$var$_process.JEST_WORKER_ID) !== undefined;
var $e56a79a94b802af7$var$DEBUG_MODE = !$e56a79a94b802af7$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($e56a79a94b802af7$var$_process2 = globalThis.process) === null || $e56a79a94b802af7$var$_process2 === void 0 || ($e56a79a94b802af7$var$_process2 = $e56a79a94b802af7$var$_process2.env) === null || $e56a79a94b802af7$var$_process2 === void 0 ? void 0 : $e56a79a94b802af7$var$_process2.NODE_ENV) !== 'production';
var $e56a79a94b802af7$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$e56a79a94b802af7$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("eQzrx", function(module, exports) {
$parcel$export(module.exports, "default", () => $acf16a4a4d0cc0ac$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $e8xVq = parcelRequire("e8xVq");
var $acf16a4a4d0cc0ac$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $acf16a4a4d0cc0ac$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $acf16a4a4d0cc0ac$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e8xVq.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $acf16a4a4d0cc0ac$export$2e2bcd8739ae039 = $acf16a4a4d0cc0ac$var$FadeIn;

});
parcelRegister("e8xVq", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4ac20e7f0433359$export$2e2bcd8739ae039);
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $jY1dw = parcelRequire("jY1dw");

var $7uyb0 = parcelRequire("7uyb0");

var $fF5v2 = parcelRequire("fF5v2");

var $euZA7 = parcelRequire("euZA7");

var $ZdqJG = parcelRequire("ZdqJG");

var $8xij1 = parcelRequire("8xij1");
var $a4ac20e7f0433359$var$zoomIn = null;
var $a4ac20e7f0433359$var$zoomOut = null;
var $a4ac20e7f0433359$var$fadeIn = null;
var $a4ac20e7f0433359$var$fadeOut = null;
var $a4ac20e7f0433359$var$fadeInFromTop = null;
var $a4ac20e7f0433359$var$fadeOutFromTop = null;
var $a4ac20e7f0433359$var$fadeInFromLeft = null;
var $a4ac20e7f0433359$var$fadeOutFromLeft = null;
var $a4ac20e7f0433359$var$fadeInFromBottom = null;
var $a4ac20e7f0433359$var$fadeOutFromBottom = null;
var $a4ac20e7f0433359$var$fadeInFromRight = null;
var $a4ac20e7f0433359$var$fadeOutFromRight = null;
var $a4ac20e7f0433359$var$fadeInFromTopConstant = null;
var $a4ac20e7f0433359$var$fadeOutFromTopConstant = null;
var $a4ac20e7f0433359$var$fadeInFromLeftConstant = null;
var $a4ac20e7f0433359$var$fadeOutFromLeftConstant = null;
var $a4ac20e7f0433359$var$fadeInFromBottomConstant = null;
var $a4ac20e7f0433359$var$fadeOutFromBottomConstant = null;
var $a4ac20e7f0433359$var$fadeInFromRightConstant = null;
var $a4ac20e7f0433359$var$fadeOutFromRightConstant = null;
var $a4ac20e7f0433359$var$slideInFromTop = null;
var $a4ac20e7f0433359$var$slideOutFromTop = null;
var $a4ac20e7f0433359$var$slideInFromRight = null;
var $a4ac20e7f0433359$var$slideOutFromRight = null;
var $a4ac20e7f0433359$var$slideInFromBottom = null;
var $a4ac20e7f0433359$var$slideOutFromBottom = null;
var $a4ac20e7f0433359$var$slideInFromLeft = null;
var $a4ac20e7f0433359$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $a4ac20e7f0433359$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $8xij1.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $ZdqJG.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $euZA7.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $5FkrB.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $7uyb0.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $fF5v2.exitingDurations)[duration] : (0, $fF5v2.durations)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $jY1dw.default)([
            (0, $jY1dw.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $jY1dw.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $jY1dw.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $jY1dw.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $jY1dw.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $jY1dw.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $jY1dw.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $jY1dw.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $jY1dw.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $jY1dw.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $jY1dw.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $jY1dw.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $jY1dw.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $jY1dw.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $jY1dw.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $jY1dw.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $jY1dw.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $jY1dw.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $jY1dw.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $jY1dw.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $jY1dw.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $jY1dw.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $jY1dw.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $jY1dw.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $jY1dw.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $jY1dw.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $jY1dw.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $jY1dw.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $jY1dw.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $jY1dw.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $jY1dw.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $jY1dw.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $jY1dw.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $jY1dw.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $jY1dw.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $jY1dw.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $jY1dw.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $jY1dw.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $jY1dw.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $jY1dw.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $jY1dw.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $jY1dw.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $jY1dw.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $jY1dw.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $jY1dw.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $jY1dw.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $jY1dw.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $jY1dw.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $jY1dw.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $jY1dw.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $jY1dw.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $a4ac20e7f0433359$export$2e2bcd8739ae039 = $a4ac20e7f0433359$var$EnteringMotion;

});
parcelRegister("7uyb0", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $5745d88094d541bd$export$b7baf7667a68d87c);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
var $5745d88094d541bd$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $5745d88094d541bd$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$5745d88094d541bd$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $5745d88094d541bd$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $5FkrB.useState)($5745d88094d541bd$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        if (!$5745d88094d541bd$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $7QpUe.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $5745d88094d541bd$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $5745d88094d541bd$export$ff7706047246b98b = function prefersReducedMotion() {
    return $5745d88094d541bd$export$f0f789643ba5a83c;
};

});

parcelRegister("fF5v2", function(module, exports) {
$parcel$export(module.exports, "durations", () => $02f145fdbc85e8b6$export$38b928a7167ce124);
$parcel$export(module.exports, "exitingDurations", () => $02f145fdbc85e8b6$export$30fa1a2e62ae150c);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $02f145fdbc85e8b6$export$368bacef0dacbe05 = 25;
var $02f145fdbc85e8b6$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $02f145fdbc85e8b6$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $02f145fdbc85e8b6$export$30fa1a2e62ae150c = {
    none: $02f145fdbc85e8b6$export$38b928a7167ce124.none,
    small: $02f145fdbc85e8b6$export$38b928a7167ce124.small * $02f145fdbc85e8b6$var$EXITING_MOTION_MULTIPLIER,
    medium: $02f145fdbc85e8b6$export$38b928a7167ce124.medium * $02f145fdbc85e8b6$var$EXITING_MOTION_MULTIPLIER,
    large: $02f145fdbc85e8b6$export$38b928a7167ce124.large * $02f145fdbc85e8b6$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("euZA7", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", () => $a8e3a2d318bbb5aa$export$4f34107a2b00f39c);

var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $a8e3a2d318bbb5aa$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $a8e3a2d318bbb5aa$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $a8e3a2d318bbb5aa$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $a8e3a2d318bbb5aa$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $a8e3a2d318bbb5aa$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("ZdqJG", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $0b801d951e70b6a9$export$3b6f38abbdcbd000);
$parcel$export(module.exports, "default", () => $0b801d951e70b6a9$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $0b801d951e70b6a9$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $0b801d951e70b6a9$var$ExitingContext = /*#__PURE__*/ (0, $5FkrB.createContext)($0b801d951e70b6a9$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $0b801d951e70b6a9$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0b801d951e70b6a9$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($0b801d951e70b6a9$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $0b801d951e70b6a9$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $0b801d951e70b6a9$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $0b801d951e70b6a9$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $0b801d951e70b6a9$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $0b801d951e70b6a9$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $0b801d951e70b6a9$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $0b801d951e70b6a9$var$childrenToArray(previousChildren);
    var current = $0b801d951e70b6a9$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $0b801d951e70b6a9$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $0b801d951e70b6a9$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $0b801d951e70b6a9$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $0b801d951e70b6a9$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $0b801d951e70b6a9$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)($0b801d951e70b6a9$var$ExitingContext);
};
$0b801d951e70b6a9$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $0b801d951e70b6a9$export$2e2bcd8739ae039 = $0b801d951e70b6a9$var$ExitingPersistence;

});

parcelRegister("8xij1", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $636f9af14908446f$export$25c7213fc07ec080);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $4chVs = parcelRequire("4chVs");

var $dnMEm = parcelRequire("dnMEm");

var $2Yzny = parcelRequire("2Yzny");
var $636f9af14908446f$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $4chVs.default)
    };
});
var $636f9af14908446f$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $2Yzny.useUniqueId)();
    var context = (0, $5FkrB.useContext)($636f9af14908446f$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $636f9af14908446f$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $dnMEm.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($636f9af14908446f$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $636f9af14908446f$export$2e2bcd8739ae039 = $636f9af14908446f$var$StaggeredEntrance;

});
parcelRegister("4chVs", function(module, exports) {
$parcel$export(module.exports, "default", () => $30e63019a2fc37b7$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $30e63019a2fc37b7$export$2e2bcd8739ae039() {}

});

parcelRegister("dnMEm", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $9be32935cadfca3c$export$e5c5a5f917a5871c);

var $5FkrB = parcelRequire("5FkrB");
var $9be32935cadfca3c$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);

});

parcelRegister("2Yzny", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $22aca0dd9ceab63d$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $22aca0dd9ceab63d$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("6bqMl", function(module, exports) {
$parcel$export(module.exports, "default", () => $48088ada20eaf5c1$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $3FOwN = parcelRequire("3FOwN");

var $hwn2J = parcelRequire("hwn2J");

var $f6E9k = parcelRequire("f6E9k");

var $3dF2S = parcelRequire("3dF2S");

var $2PsRr = parcelRequire("2PsRr");
function $48088ada20eaf5c1$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $3dF2S.default)(mountStrategy);
    (0, $2PsRr.default)(zIndex);
    return !(0, $3FOwN.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $hwn2J.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f6E9k.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("3FOwN", function(module, exports) {
$parcel$export(module.exports, "fg", () => $2acc653e62dcfd4a$export$b40ec24ac8275656);

var $f1KPV = parcelRequire("f1KPV");
function $2acc653e62dcfd4a$export$ba05d765b8392e5e(flagResolver) {
    (0, $f1KPV.setBooleanResolver)(flagResolver);
}
function $2acc653e62dcfd4a$export$470e5c2be1411c89(name) {
    return (0, $f1KPV.resolveBooleanFlag)(name);
}
function $2acc653e62dcfd4a$export$b40ec24ac8275656(name) {
    return (0, $f1KPV.resolveBooleanFlag)(name);
}

});
parcelRegister("f1KPV", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $af0b47c9b6b408a3$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $af0b47c9b6b408a3$export$6333b6aff9fc6275);

var $jZlo3 = parcelRequire("jZlo3");

var $7ePZM = parcelRequire("7ePZM");

var $3ZMUU = parcelRequire("3ZMUU");
var $af0b47c9b6b408a3$var$pkgName = '@atlaskit/platform-feature-flags';
var $af0b47c9b6b408a3$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $af0b47c9b6b408a3$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $af0b47c9b6b408a3$var$ENV_ENABLE_PLATFORM_FF = $af0b47c9b6b408a3$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $af0b47c9b6b408a3$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $af0b47c9b6b408a3$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $af0b47c9b6b408a3$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $af0b47c9b6b408a3$var$ENV_ENABLE_PLATFORM_FF || $af0b47c9b6b408a3$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $af0b47c9b6b408a3$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $af0b47c9b6b408a3$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$af0b47c9b6b408a3$var$globalVar[$af0b47c9b6b408a3$export$7e41b1b2bdee3f98] = $af0b47c9b6b408a3$var$globalVar[$af0b47c9b6b408a3$export$7e41b1b2bdee3f98] || $af0b47c9b6b408a3$var$DEFAULT_PFF_GLOBAL;
function $af0b47c9b6b408a3$export$f2b591175b3e424c(resolver) {
    $af0b47c9b6b408a3$var$globalVar[$af0b47c9b6b408a3$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $af0b47c9b6b408a3$export$6333b6aff9fc6275(flagKey) {
    if ($af0b47c9b6b408a3$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $7ePZM.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $af0b47c9b6b408a3$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $af0b47c9b6b408a3$var$globalVar[$af0b47c9b6b408a3$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $af0b47c9b6b408a3$var$globalVar[$af0b47c9b6b408a3$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $jZlo3.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $af0b47c9b6b408a3$var$globalVar[$af0b47c9b6b408a3$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("7ePZM", function(module, exports) {
$parcel$export(module.exports, "debug", () => $54522c669f83d498$export$1c9f709888824e05);
var $54522c669f83d498$var$_process, $54522c669f83d498$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $54522c669f83d498$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($54522c669f83d498$var$_process = globalThis.process) === null || $54522c669f83d498$var$_process === void 0 || ($54522c669f83d498$var$_process = $54522c669f83d498$var$_process.env) === null || $54522c669f83d498$var$_process === void 0 ? void 0 : $54522c669f83d498$var$_process.JEST_WORKER_ID) !== undefined;
var $54522c669f83d498$var$DEBUG_MODE = !$54522c669f83d498$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($54522c669f83d498$var$_process2 = globalThis.process) === null || $54522c669f83d498$var$_process2 === void 0 || ($54522c669f83d498$var$_process2 = $54522c669f83d498$var$_process2.env) === null || $54522c669f83d498$var$_process2 === void 0 ? void 0 : $54522c669f83d498$var$_process2.NODE_ENV) !== 'production';
var $54522c669f83d498$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$54522c669f83d498$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("hwn2J", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc174cac925bf305$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $eOz1e = parcelRequire("eOz1e");
function $cc174cac925bf305$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $5FkrB.useMemo)(function() {
        return (0, $eOz1e.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $eOz1e.appendPortalContainerIfNotAppended)(container);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            (0, $eOz1e.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $aLeHs.createPortal)(children, container);
}

});
parcelRegister("eOz1e", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $ac90e6339746de43$export$26ae5ca175b4ec5a);
$parcel$export(module.exports, "removePortalContainer", () => $ac90e6339746de43$export$da99f98bf3fe55b3);
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $ac90e6339746de43$export$c582005add11e141);
$parcel$export(module.exports, "createAtlaskitPortal", () => $ac90e6339746de43$export$fef014d7cef9e543);
$parcel$export(module.exports, "createPortalParent", () => $ac90e6339746de43$export$95029ca7aca2989e);

var $1fcwm = parcelRequire("1fcwm");
var $ac90e6339746de43$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $1fcwm.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $ac90e6339746de43$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $ac90e6339746de43$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $1fcwm.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $1fcwm.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $ac90e6339746de43$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $ac90e6339746de43$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $ac90e6339746de43$var$getPortalParent().removeChild(container);
};
var $ac90e6339746de43$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $ac90e6339746de43$var$getPortalParent().appendChild(container);
};
var $ac90e6339746de43$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $ac90e6339746de43$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($ac90e6339746de43$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $1fcwm.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};
var $ac90e6339746de43$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($ac90e6339746de43$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $1fcwm.portalParentSelector));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $1fcwm.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody2 = $ac90e6339746de43$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

});
parcelRegister("1fcwm", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", () => $0e80e78bca266346$export$e4c79eb95c23a0da);
$parcel$export(module.exports, "portalParentSelector", () => $0e80e78bca266346$export$72f415121273627e);
$parcel$export(module.exports, "portalClassName", () => $0e80e78bca266346$export$13f57c02915787b3);
var $0e80e78bca266346$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $0e80e78bca266346$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $0e80e78bca266346$export$13f57c02915787b3 = 'atlaskit-portal';

});



parcelRegister("f6E9k", function(module, exports) {
$parcel$export(module.exports, "default", () => $aff68f6a72c56fe1$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $afobQ = parcelRequire("afobQ");

var $eOz1e = parcelRequire("eOz1e");
function $aff68f6a72c56fe1$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $afobQ.useIsomorphicLayoutEffect)(function() {
        var tempPortalContainer = (0, $eOz1e.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $eOz1e.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Suspense), {
        fallback: null
    }, children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $aLeHs.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("afobQ", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $775e11c111bb481a$export$700979bc83e7db82);

var $5FkrB = parcelRequire("5FkrB");
var $775e11c111bb481a$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5FkrB.useLayoutEffect) : (0, $5FkrB.useEffect);

});


parcelRegister("3dF2S", function(module, exports) {
$parcel$export(module.exports, "default", () => $25826cbe9373f77e$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $afobQ = parcelRequire("afobQ");
var $25826cbe9373f77e$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $afobQ.useIsomorphicLayoutEffect) : (0, $5FkrB.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $25826cbe9373f77e$export$2e2bcd8739ae039 = $25826cbe9373f77e$var$useIsSubsequentRender;

});

parcelRegister("2PsRr", function(module, exports) {
$parcel$export(module.exports, "default", () => $20f6bb5d1e5698a9$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $cAcoQ = parcelRequire("cAcoQ");

var $hpyO2 = parcelRequire("hpyO2");
var $20f6bb5d1e5698a9$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $5FkrB.useEffect)(function() {
        (0, $hpyO2.default)((0, $cAcoQ.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $hpyO2.default)((0, $cAcoQ.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $20f6bb5d1e5698a9$export$2e2bcd8739ae039 = $20f6bb5d1e5698a9$var$useFirePortalEvent;

});
parcelRegister("cAcoQ", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", () => $92927723834e2e13$export$ed5835cc67e87f72);
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", () => $92927723834e2e13$export$80816bd900e5bd00);
var $92927723834e2e13$export$ed5835cc67e87f72 = 'akPortalMount';
var $92927723834e2e13$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("hpyO2", function(module, exports) {
$parcel$export(module.exports, "default", () => $cacfc534fbeae109$export$2e2bcd8739ae039);
var $cacfc534fbeae109$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $cacfc534fbeae109$var$getLayerName = function getLayerName(zIndex) {
    return $cacfc534fbeae109$var$zIndexToName.hasOwnProperty(zIndex) ? $cacfc534fbeae109$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $cacfc534fbeae109$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $cacfc534fbeae109$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $cacfc534fbeae109$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $cacfc534fbeae109$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("H74DA", function(module, exports) {
$parcel$export(module.exports, "layers", () => $081980f9c15950d3$export$7be255094ccdc533);

var $lOXpB = parcelRequire("lOXpB");

var $dSRcG = parcelRequire("dSRcG");
var $081980f9c15950d3$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $081980f9c15950d3$export$c93026a968943f95 = 'light';
var $081980f9c15950d3$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $081980f9c15950d3$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $081980f9c15950d3$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $081980f9c15950d3$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $dSRcG.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $081980f9c15950d3$export$6d8204c2cb2e06b8() / 4;
    (0, $lOXpB.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $081980f9c15950d3$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $081980f9c15950d3$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $081980f9c15950d3$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $lOXpB.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $081980f9c15950d3$export$ba1d834b86d72a09 = $081980f9c15950d3$export$a1b3edb637fb4f35;
var $081980f9c15950d3$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $dSRcG.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $dSRcG.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $dSRcG.N30A), ")")
            }
        }
    };
};

});
parcelRegister("lOXpB", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe2c5a79f16ba3bd$export$2e2bcd8739ae039);

var $4jKk3 = parcelRequire("4jKk3");

var $3ZMUU = parcelRequire("3ZMUU");
function $fe2c5a79f16ba3bd$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $4jKk3.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $fe2c5a79f16ba3bd$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $3ZMUU;
}

});
parcelRegister("4jKk3", function(module, exports) {
$parcel$export(module.exports, "default", () => $324cde792ef3e561$export$2e2bcd8739ae039);
/* eslint-disable no-console */ var $324cde792ef3e561$var$printed = {};
function $324cde792ef3e561$export$2e2bcd8739ae039(message) {
    if ($324cde792ef3e561$var$printed[message]) return;
    $324cde792ef3e561$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});


parcelRegister("dSRcG", function(module, exports) {
$parcel$export(module.exports, "R400", () => $a1b9969db91895a9$export$2010d0fb4295b346);
$parcel$export(module.exports, "B200", () => $a1b9969db91895a9$export$215b7063051591f1);
$parcel$export(module.exports, "N0", () => $a1b9969db91895a9$export$29a4f05edc054374);
$parcel$export(module.exports, "N30", () => $a1b9969db91895a9$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N500", () => $a1b9969db91895a9$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N800", () => $a1b9969db91895a9$export$7d61b15e0da132af);
$parcel$export(module.exports, "N900", () => $a1b9969db91895a9$export$fbda843f0a27fe96);
$parcel$export(module.exports, "N20A", () => $a1b9969db91895a9$export$8d43898f60b96a82);
$parcel$export(module.exports, "N30A", () => $a1b9969db91895a9$export$920c0d5c49070351);
$parcel$export(module.exports, "N60A", () => $a1b9969db91895a9$export$d2d3bedfb276cac0);
// Reds
var $a1b9969db91895a9$export$4b84fd0e2c617bd = '#FFEBE6';
var $a1b9969db91895a9$export$b34b069eff244586 = '#FFBDAD';
var $a1b9969db91895a9$export$be802dd0d8b57f35 = '#FF8F73';
var $a1b9969db91895a9$export$60847d42f9da92a6 = '#FF7452';
var $a1b9969db91895a9$export$4a7404f376229999 = '#FF5630';
var $a1b9969db91895a9$export$2010d0fb4295b346 = '#DE350B';
var $a1b9969db91895a9$export$2837b5a1a71d5c02 = '#BF2600';
var $a1b9969db91895a9$export$8d9596b529bbb9cf = '#FFFAE6';
var $a1b9969db91895a9$export$41060a744ab0b7ae = '#FFF0B3';
var $a1b9969db91895a9$export$1cc05bbbf340e559 = '#FFE380';
var $a1b9969db91895a9$export$5aae31392d72caaa = '#FFC400';
var $a1b9969db91895a9$export$c6930421db9fa514 = '#FFAB00';
var $a1b9969db91895a9$export$59619663aa6500fb = '#FF991F';
var $a1b9969db91895a9$export$874739ea9e379ab6 = '#FF8B00';
var $a1b9969db91895a9$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $a1b9969db91895a9$export$69a3bf21b9686c2b = '#ABF5D1';
var $a1b9969db91895a9$export$afbce1382ec95f73 = '#79F2C0';
var $a1b9969db91895a9$export$747d86715d4175de = '#57D9A3';
var $a1b9969db91895a9$export$940e1f69e873f202 = '#36B37E';
var $a1b9969db91895a9$export$a49394138f7b8e85 = '#00875A';
var $a1b9969db91895a9$export$6fa04827ac68a4fb = '#006644';
var $a1b9969db91895a9$export$226de0355ed012f8 = '#DEEBFF';
var $a1b9969db91895a9$export$8c13c2ee36917869 = '#B3D4FF';
var $a1b9969db91895a9$export$ecfc1dff386a3e7a = '#4C9AFF';
var $a1b9969db91895a9$export$215b7063051591f1 = '#2684FF';
var $a1b9969db91895a9$export$e62e8919cca44969 = '#0065FF';
var $a1b9969db91895a9$export$b3de0ae08da2ce64 = '#0052CC';
var $a1b9969db91895a9$export$a6ee3d71bc067634 = '#0747A6';
var $a1b9969db91895a9$export$67f15409e87642a1 = '#669DF1';
var $a1b9969db91895a9$export$f0539dbc42dbb067 = '#8FB8F6';
var $a1b9969db91895a9$export$363e4475840015bb = '#EAE6FF';
var $a1b9969db91895a9$export$4b0a4417ed59760f = '#C0B6F2';
var $a1b9969db91895a9$export$6011520a64d9a187 = '#998DD9';
var $a1b9969db91895a9$export$a7175d4e9206bc80 = '#8777D9';
var $a1b9969db91895a9$export$b48405b95304b5a1 = '#6554C0';
var $a1b9969db91895a9$export$c71e4279dd54a18d = '#5243AA';
var $a1b9969db91895a9$export$147899de772240ec = '#403294';
var $a1b9969db91895a9$export$2cf711fe14c66f06 = '#E6FCFF';
var $a1b9969db91895a9$export$7a8f4d33f6f9772c = '#B3F5FF';
var $a1b9969db91895a9$export$776c9c497ef08533 = '#79E2F2';
var $a1b9969db91895a9$export$69cb3ca10c1e330e = '#00C7E6';
var $a1b9969db91895a9$export$9dc1ef0f3f48059b = '#00B8D9';
var $a1b9969db91895a9$export$7c835c78b6fcdef8 = '#00A3BF';
var $a1b9969db91895a9$export$6036577f95c3877e = '#008DA6';
var $a1b9969db91895a9$export$29a4f05edc054374 = '#FFFFFF';
var $a1b9969db91895a9$export$e655ef011c4aa1a2 = '#FAFBFC';
var $a1b9969db91895a9$export$9fdfb749e33cdf97 = '#F4F5F7';
var $a1b9969db91895a9$export$3e51e8f1440314ba = '#EBECF0';
var $a1b9969db91895a9$export$1ce2d1575d444ceb = '#DFE1E6';
var $a1b9969db91895a9$export$8754fc7e6d8b3000 = '#C1C7D0';
var $a1b9969db91895a9$export$c2e91cbeada39b8b = '#B3BAC5';
var $a1b9969db91895a9$export$5f71e19f3a7ad9de = '#A5ADBA';
var $a1b9969db91895a9$export$eaa8c8a70ac22806 = '#97A0AF';
var $a1b9969db91895a9$export$7c87d337fb91a97d = '#8993A4';
var $a1b9969db91895a9$export$d6447c357493214f = '#7A869A';
var $a1b9969db91895a9$export$f563ee71e9ee74cd = '#6B778C';
var $a1b9969db91895a9$export$e2ef2124cf4024b1 = '#5E6C84';
var $a1b9969db91895a9$export$eece5f492e429f08 = '#505F79';
var $a1b9969db91895a9$export$c39c0fe0f26207ae = '#42526E';
var $a1b9969db91895a9$export$7090862dc3038a9f = '#344563';
var $a1b9969db91895a9$export$ad0bacf983b7ddaa = '#253858';
var $a1b9969db91895a9$export$7d61b15e0da132af = '#172B4D';
var $a1b9969db91895a9$export$fbda843f0a27fe96 = '#091E42';
var $a1b9969db91895a9$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $a1b9969db91895a9$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $a1b9969db91895a9$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $a1b9969db91895a9$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $a1b9969db91895a9$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $a1b9969db91895a9$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $a1b9969db91895a9$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $a1b9969db91895a9$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $a1b9969db91895a9$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $a1b9969db91895a9$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $a1b9969db91895a9$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $a1b9969db91895a9$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $a1b9969db91895a9$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $a1b9969db91895a9$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $a1b9969db91895a9$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $a1b9969db91895a9$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $a1b9969db91895a9$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $a1b9969db91895a9$export$2f6319cf7d736c2a = '#E6EDFA';
var $a1b9969db91895a9$export$95126bc8884d6634 = '#DCE5F5';
var $a1b9969db91895a9$export$8338d8c35d44ff1 = '#CED9EB';
var $a1b9969db91895a9$export$5368d76ae4fbbda7 = '#B8C7E0';
var $a1b9969db91895a9$export$9f0a771d16ec8d36 = '#ABBBD6';
var $a1b9969db91895a9$export$abcf8c38338b4aa5 = '#9FB0CC';
var $a1b9969db91895a9$export$97e81faa16a182c7 = '#8C9CB8';
var $a1b9969db91895a9$export$bfe21c59123ecf33 = '#7988A3';
var $a1b9969db91895a9$export$ee82aa2ea6a1558 = '#67758F';
var $a1b9969db91895a9$export$682927c6ed76be02 = '#56637A';
var $a1b9969db91895a9$export$91fd9994c5be9757 = '#455166';
var $a1b9969db91895a9$export$d281fbfe3cff2df6 = '#3B475C';
var $a1b9969db91895a9$export$3902c91d8b98a753 = '#313D52';
var $a1b9969db91895a9$export$8e8133c1ba5845b5 = '#283447';
var $a1b9969db91895a9$export$33ff357f6620b39 = '#202B3D';
var $a1b9969db91895a9$export$633847cf062b69e0 = '#1B2638';
var $a1b9969db91895a9$export$9776a6e503bdbf76 = '#121A29';
var $a1b9969db91895a9$export$6c813d5160dff5db = '#0E1624';
var $a1b9969db91895a9$export$3d4f271a500072a = '#0D1424';
var $a1b9969db91895a9$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $a1b9969db91895a9$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $a1b9969db91895a9$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $a1b9969db91895a9$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $a1b9969db91895a9$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $a1b9969db91895a9$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $a1b9969db91895a9$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $a1b9969db91895a9$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $a1b9969db91895a9$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $a1b9969db91895a9$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $a1b9969db91895a9$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $a1b9969db91895a9$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $a1b9969db91895a9$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $a1b9969db91895a9$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $a1b9969db91895a9$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $a1b9969db91895a9$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $a1b9969db91895a9$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $a1b9969db91895a9$export$d2adc5dedf09fced = '#292A2E';
var $a1b9969db91895a9$export$f51762073d2bb381 = '#94C748';
var $a1b9969db91895a9$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("6MmJQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ef8dd21c0783dce$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $hd7HS = parcelRequire("hd7HS");

var $9mRRr = parcelRequire("9mRRr");

var $hbl7m = parcelRequire("hbl7m");

var $8Bx3d = parcelRequire("8Bx3d");

var $ek5jW = parcelRequire("ek5jW");

var $eQzrx = parcelRequire("eQzrx");
parcelRequire("5K9q2");
var $e8Olt = parcelRequire("e8Olt");

var $5Rrqa = parcelRequire("5Rrqa");

var $dSRcG = parcelRequire("dSRcG");

var $3CioX = parcelRequire("3CioX");

var $bwuZo = parcelRequire("bwuZo");

var $a8XWo = parcelRequire("a8XWo");

var $lDqpZ = parcelRequire("lDqpZ");

var $kLhYg = parcelRequire("kLhYg");

var $8KNdU = parcelRequire("8KNdU");

var $3dEWA = parcelRequire("3dEWA");

var $lGXDD = parcelRequire("lGXDD");
var $4ef8dd21c0783dce$var$dialogStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    display: 'flex',
    width: '100%',
    maxWidth: '100vw',
    height: '100%',
    minHeight: 0,
    maxHeight: '100vh',
    // Flex-grow set to 0 to prevent this element from filling its parent flexbox container
    flex: '0 1 auto',
    flexDirection: 'column',
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $dSRcG.N0), ")"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: "var(--ds-text, ".concat((0, $dSRcG.N900), ")")
}, (0, $3CioX.CURRENT_SURFACE_CSS_VAR), "var(--ds-surface-overlay, ".concat((0, $dSRcG.N0), ")")), "pointerEvents", 'auto'), (0, $5Rrqa.media).above.xs, {
    width: 'var(--modal-dialog-width)',
    maxWidth: 'inherit',
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 0 0 1px ".concat((0, $dSRcG.N30A), ", 0 2px 1px ").concat((0, $dSRcG.N30A), ", 0 0 20px -6px ").concat((0, $dSRcG.N60A)), ")"),
    marginInlineEnd: 'inherit',
    marginInlineStart: 'inherit'
}), '& > form:only-child', {
    display: 'inherit',
    maxHeight: 'inherit',
    flexDirection: 'inherit'
}));
var $4ef8dd21c0783dce$var$viewportScrollStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    /**
   * This ensures that the element fills the viewport on mobile
   * while also allowing it to overflow if its height is larger than
   * the viewport.
   */ minHeight: '100vh',
    maxHeight: 'none'
}, (0, $5Rrqa.media).above.xs, {
    minHeight: 'var(--modal-dialog-height)'
}));
var $4ef8dd21c0783dce$var$bodyScrollStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $5Rrqa.media).above.xs, {
    height: 'var(--modal-dialog-height)',
    maxHeight: 'inherit'
}));
var $4ef8dd21c0783dce$var$ModalDialog = function ModalDialog(props) {
    var _props$width = props.width, width = _props$width === void 0 ? 'medium' : _props$width, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, shouldCloseOnEscapePress = props.shouldCloseOnEscapePress, autoFocus = props.autoFocus, stackIndex = props.stackIndex, onClose = props.onClose, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, height = props.height, hasProvidedOnClose = props.hasProvidedOnClose, children = props.children, label = props.label, testId = props.testId;
    var id = (0, $hbl7m.useId)();
    var titleId = "modal-dialog-title-".concat(id);
    (0, $5FkrB.useEffect)(function() {
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $e8Olt.combine)((0, $lDqpZ.disableDraggingToCrossOriginIFramesForElement)(), (0, $8KNdU.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $kLhYg.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    (0, $9mRRr.default)((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(autoFocus) === 'object' ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(autoFocus) === 'object');
    var _useOnMotionFinish = (0, $a8XWo.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    }), _useOnMotionFinish2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useOnMotionFinish, 2), motionRef = _useOnMotionFinish2[0], onMotionFinish = _useOnMotionFinish2[1];
    var modalDialogContext = (0, $5FkrB.useMemo)(function() {
        return {
            testId: testId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose
        };
    }, [
        testId,
        titleId,
        onClose,
        hasProvidedOnClose
    ]);
    (0, $ek5jW.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    var _useLayering = (0, $ek5jW.useLayering)(), currentLevel = _useLayering.currentLevel;
    return (0, $74Zh5.jsx)((0, $lGXDD.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: testId
    }, (0, $74Zh5.jsx)((0, $bwuZo.ModalContext).Provider, {
        value: modalDialogContext
    }, (0, $74Zh5.jsx)((0, $bwuZo.ScrollContext).Provider, {
        value: shouldScrollInViewport
    }, (0, $74Zh5.jsx)((0, $eQzrx.default), {
        entranceDirection: "bottom",
        onFinish: onMotionFinish
    }, function(bottomFadeInProps) {
        return (0, $74Zh5.jsx)((0, $8Bx3d.default), null, (0, $74Zh5.jsx)("section", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, bottomFadeInProps, {
            "aria-label": label,
            ref: (0, $hd7HS.default)([
                bottomFadeInProps.ref,
                motionRef
            ]),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-width': (0, $3dEWA.dialogWidth)(width),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-height': (0, $3dEWA.dialogHeight)(height)
            },
            css: [
                $4ef8dd21c0783dce$var$dialogStyles,
                shouldScrollInViewport ? $4ef8dd21c0783dce$var$viewportScrollStyles : $4ef8dd21c0783dce$var$bodyScrollStyles
            ],
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": testId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true,
            "data-ds--level": currentLevel
        }), children));
    }))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4ef8dd21c0783dce$export$2e2bcd8739ae039 = $4ef8dd21c0783dce$var$ModalDialog;

});
parcelRegister("hd7HS", function(module, exports) {
$parcel$export(module.exports, "default", () => $c879a0f5ae67f2a4$export$2e2bcd8739ae039);
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $c879a0f5ae67f2a4$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("9mRRr", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d1ff2cb9950775a$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $6d1ff2cb9950775a$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $5FkrB.useRef)(true);
    (0, $5FkrB.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("hbl7m", function(module, exports) {
$parcel$export(module.exports, "useId", () => $c823d84ade0d3550$export$f680877a34711e37);
$parcel$export(module.exports, "useIdSeed", () => $c823d84ade0d3550$export$6ee17796e3d70de2);

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $5fJka = parcelRequire("5fJka");
var $c823d84ade0d3550$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $c823d84ade0d3550$var$react18UseId = ($c823d84ade0d3550$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $c823d84ade0d3550$var$_React$useId !== void 0 ? $c823d84ade0d3550$var$_React$useId : undefined;
function $c823d84ade0d3550$export$f680877a34711e37() {
    if ($c823d84ade0d3550$var$react18UseId && (0, $5fJka.fg)('platform-dst-react-18-use-id')) return $c823d84ade0d3550$var$react18UseId();
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $c823d84ade0d3550$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($c823d84ade0d3550$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $c823d84ade0d3550$export$6ee17796e3d70de2() {
    if ($c823d84ade0d3550$var$react18UseId && (0, $5fJka.fg)('platform-dst-react-18-use-id')) {
        var uid = $c823d84ade0d3550$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $b5lkZ.useUIDSeed)();
}

});
parcelRegister("b5lkZ", function(module, exports) {
$parcel$export(module.exports, "useUID", () => $8120b68af314e225$export$87d05f07e65211f1);
$parcel$export(module.exports, "useUIDSeed", () => $8120b68af314e225$export$bb5ca5fba6fb4f1f);

var $5FkrB = parcelRequire("5FkrB");

var $bDoJR = parcelRequire("bDoJR");
var $8120b68af314e225$var$generateUID = function(context) {
    var quartz = context || (0, $bDoJR.counter);
    var prefix = (0, $bDoJR.getPrefix)(quartz);
    var id = (0, $bDoJR.getId)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $8120b68af314e225$var$useUIDState = function() {
    var context = (0, $5FkrB.useContext)((0, $bDoJR.source));
    var uid = (0, $5FkrB.useState)(function() {
        return $8120b68af314e225$var$generateUID(context);
    })[0];
    return uid;
};
var $8120b68af314e225$export$87d05f07e65211f1 = function() {
    var uid = $8120b68af314e225$var$useUIDState().uid;
    return uid;
};
var $8120b68af314e225$export$bb5ca5fba6fb4f1f = function() {
    var gen = $8120b68af314e225$var$useUIDState().gen;
    return gen;
};

});
parcelRegister("bDoJR", function(module, exports) {
$parcel$export(module.exports, "counter", () => $878686cdae50c4f9$export$e575061ef2a070eb);
$parcel$export(module.exports, "source", () => $878686cdae50c4f9$export$b4d5da5f34fb77ad);
$parcel$export(module.exports, "getId", () => $878686cdae50c4f9$export$218c8c3169c024d2);
$parcel$export(module.exports, "getPrefix", () => $878686cdae50c4f9$export$36e24695f02d4503);

var $5FkrB = parcelRequire("5FkrB");

var $k4xEj = parcelRequire("k4xEj");
var $878686cdae50c4f9$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = '';
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $k4xEj.generateUID)()
    };
};
var $878686cdae50c4f9$export$e575061ef2a070eb = $878686cdae50c4f9$export$1921362e86c73c88();
var $878686cdae50c4f9$export$b4d5da5f34fb77ad = $5FkrB.createContext($878686cdae50c4f9$export$1921362e86c73c88());
var $878686cdae50c4f9$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $878686cdae50c4f9$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : '';
};

});
parcelRegister("k4xEj", function(module, exports) {
$parcel$export(module.exports, "generateUID", () => $e9ce486011a08a46$export$bdbb4cbb3078e58d);
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $e9ce486011a08a46$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === 'number' || typeof item === 'string') return index ? "idx-".concat(index) : "val-".concat(item);
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
var $e9ce486011a08a46$export$e2a22331486dcca0 = $e9ce486011a08a46$export$bdbb4cbb3078e58d();

});



parcelRegister("5fJka", function(module, exports) {
$parcel$export(module.exports, "fg", () => $3d3182e79ed0b5e5$export$b40ec24ac8275656);

var $kyp8a = parcelRequire("kyp8a");
function $3d3182e79ed0b5e5$export$ba05d765b8392e5e(flagResolver) {
    (0, $kyp8a.setBooleanResolver)(flagResolver);
}
function $3d3182e79ed0b5e5$export$470e5c2be1411c89(name) {
    return (0, $kyp8a.resolveBooleanFlag)(name);
}
function $3d3182e79ed0b5e5$export$b40ec24ac8275656(name) {
    return (0, $kyp8a.resolveBooleanFlag)(name);
}

});
parcelRegister("kyp8a", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $ef6a7a0c7d1b8e94$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $ef6a7a0c7d1b8e94$export$6333b6aff9fc6275);

var $jZlo3 = parcelRequire("jZlo3");

var $87htz = parcelRequire("87htz");

var $3ZMUU = parcelRequire("3ZMUU");
var $ef6a7a0c7d1b8e94$var$pkgName = '@atlaskit/platform-feature-flags';
var $ef6a7a0c7d1b8e94$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $ef6a7a0c7d1b8e94$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $ef6a7a0c7d1b8e94$var$ENV_ENABLE_PLATFORM_FF = $ef6a7a0c7d1b8e94$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $ef6a7a0c7d1b8e94$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $ef6a7a0c7d1b8e94$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $ef6a7a0c7d1b8e94$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $ef6a7a0c7d1b8e94$var$ENV_ENABLE_PLATFORM_FF || $ef6a7a0c7d1b8e94$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $ef6a7a0c7d1b8e94$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $ef6a7a0c7d1b8e94$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$ef6a7a0c7d1b8e94$var$globalVar[$ef6a7a0c7d1b8e94$export$7e41b1b2bdee3f98] = $ef6a7a0c7d1b8e94$var$globalVar[$ef6a7a0c7d1b8e94$export$7e41b1b2bdee3f98] || $ef6a7a0c7d1b8e94$var$DEFAULT_PFF_GLOBAL;
function $ef6a7a0c7d1b8e94$export$f2b591175b3e424c(resolver) {
    $ef6a7a0c7d1b8e94$var$globalVar[$ef6a7a0c7d1b8e94$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $ef6a7a0c7d1b8e94$export$6333b6aff9fc6275(flagKey) {
    if ($ef6a7a0c7d1b8e94$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $87htz.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $ef6a7a0c7d1b8e94$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $ef6a7a0c7d1b8e94$var$globalVar[$ef6a7a0c7d1b8e94$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $ef6a7a0c7d1b8e94$var$globalVar[$ef6a7a0c7d1b8e94$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $jZlo3.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $ef6a7a0c7d1b8e94$var$globalVar[$ef6a7a0c7d1b8e94$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("87htz", function(module, exports) {
$parcel$export(module.exports, "debug", () => $5e8c888a81594d86$export$1c9f709888824e05);
var $5e8c888a81594d86$var$_process, $5e8c888a81594d86$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $5e8c888a81594d86$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($5e8c888a81594d86$var$_process = globalThis.process) === null || $5e8c888a81594d86$var$_process === void 0 || ($5e8c888a81594d86$var$_process = $5e8c888a81594d86$var$_process.env) === null || $5e8c888a81594d86$var$_process === void 0 ? void 0 : $5e8c888a81594d86$var$_process.JEST_WORKER_ID) !== undefined;
var $5e8c888a81594d86$var$DEBUG_MODE = !$5e8c888a81594d86$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($5e8c888a81594d86$var$_process2 = globalThis.process) === null || $5e8c888a81594d86$var$_process2 === void 0 || ($5e8c888a81594d86$var$_process2 = $5e8c888a81594d86$var$_process2.env) === null || $5e8c888a81594d86$var$_process2 === void 0 ? void 0 : $5e8c888a81594d86$var$_process2.NODE_ENV) !== 'production';
var $5e8c888a81594d86$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$5e8c888a81594d86$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("8Bx3d", function(module, exports) {
$parcel$export(module.exports, "default", () => $643b6aaa49cdd4cc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
var $643b6aaa49cdd4cc$var$BORDER_WIDTH = 2;
var $643b6aaa49cdd4cc$var$baseFocusOutsideStyles = (0, $74Zh5.css)({
    outline: "var(--ds-border-width-focused, 2px)".concat(" solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $643b6aaa49cdd4cc$var$BORDER_WIDTH
});
var $643b6aaa49cdd4cc$var$baseInsetStyles = (0, $74Zh5.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$643b6aaa49cdd4cc$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
var $643b6aaa49cdd4cc$var$focusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $643b6aaa49cdd4cc$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $643b6aaa49cdd4cc$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: "var(--ds-border-width, 1px)".concat(" solid")
        }
    }
});
var $643b6aaa49cdd4cc$var$insetFocusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $643b6aaa49cdd4cc$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $643b6aaa49cdd4cc$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: "var(--ds-border-width, 1px)".concat(" solid"),
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $643b6aaa49cdd4cc$var$FocusRing = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $643b6aaa49cdd4cc$var$baseInsetStyles : $643b6aaa49cdd4cc$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $643b6aaa49cdd4cc$var$insetFocusRingStyles : $643b6aaa49cdd4cc$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $74Zh5.jsx)((0, $74Zh5.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $5FkrB.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $5FkrB.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$643b6aaa49cdd4cc$var$FocusRing.displayName = 'FocusRing';
var $643b6aaa49cdd4cc$export$2e2bcd8739ae039 = $643b6aaa49cdd4cc$var$FocusRing;

});

parcelRegister("ek5jW", function(module, exports) {
$parcel$export(module.exports, "useCloseOnEscapePress", () => $a6d70f80828fba36$export$4a4bf067ea9e7886);
$parcel$export(module.exports, "useLayering", () => $a6d70f80828fba36$export$c8b4d54e03dee6ed);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $6dPv3 = parcelRequire("6dPv3");

var $5PqYO = parcelRequire("5PqYO");
function $a6d70f80828fba36$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a6d70f80828fba36$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a6d70f80828fba36$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a6d70f80828fba36$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a6d70f80828fba36$var$ESCAPE = 'Escape';
function $a6d70f80828fba36$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var _useLayering = $a6d70f80828fba36$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $a6d70f80828fba36$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $a6d70f80828fba36$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $5FkrB.useContext)((0, $5PqYO.LevelContext));
    var _useContext = (0, $5FkrB.useContext)((0, $5PqYO.TopLevelContext)), topLevelRef = _useContext.topLevelRef, layerList = _useContext.layerList;
    var isLayerDisabled = (0, $5FkrB.useCallback)(function() {
        if ((0, $6dPv3.fg)('layering-top-level-use-array')) {
            var _layerList$current$le, _layerList$current;
            return ((_layerList$current$le = layerList === null || layerList === void 0 || (_layerList$current = layerList.current) === null || _layerList$current === void 0 ? void 0 : _layerList$current.length) !== null && _layerList$current$le !== void 0 ? _layerList$current$le : 0) !== currentLevel;
        }
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef,
        layerList
    ]);
    return $a6d70f80828fba36$var$_objectSpread({
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    }, (0, $6dPv3.fg)('layering-top-level-use-array') ? {
        layerList: layerList
    } : {});
}

});

parcelRegister("5K9q2", function(module, exports) {
$parcel$export(module.exports, "combine", () => (parcelRequire("e8Olt")).combine);

var $e8Olt = parcelRequire("e8Olt");

});
parcelRegister("e8Olt", function(module, exports) {
$parcel$export(module.exports, "combine", () => $a4b8dd9b41f4d155$export$1be1fc439b849fdf);
/** Create a new combined function that will call all the provided functions */ function $a4b8dd9b41f4d155$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function cleanup() {
        fns.forEach(function(fn) {
            return fn();
        });
    };
}

});


parcelRegister("5Rrqa", function(module, exports) {
$parcel$export(module.exports, "media", () => $44472c3c5911af74$export$987d49ffe1b0900f);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $44472c3c5911af74$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
var $44472c3c5911af74$export$c881183ca713c214 = $44472c3c5911af74$export$987d49ffe1b0900f;

});

parcelRegister("3CioX", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $2a2331d9b9f69826$export$9d7b58831ae93caa);
var $2a2331d9b9f69826$export$4ef52930e33717cd = 'data-theme';
var $2a2331d9b9f69826$export$a00eac3f8684bcd0 = 'data-color-mode';
var $2a2331d9b9f69826$export$2112803007239c61 = 'data-contrast-mode';
var $2a2331d9b9f69826$export$352e418ed5b6193a = 'data-custom-theme';
var $2a2331d9b9f69826$export$6f0c6fb8c80fcc92 = 'ds';
var $2a2331d9b9f69826$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $2a2331d9b9f69826$export$dddac1532e822863 = "--".concat($2a2331d9b9f69826$export$6f0c6fb8c80fcc92, "-token-not-found");
var $2a2331d9b9f69826$export$9d7b58831ae93caa = "--".concat($2a2331d9b9f69826$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("bwuZo", function(module, exports) {
$parcel$export(module.exports, "ModalContext", () => $863ab8af7c66a185$export$ab57792b9b6974a6);
$parcel$export(module.exports, "ScrollContext", () => $863ab8af7c66a185$export$dece24112a937f92);

var $5FkrB = parcelRequire("5FkrB");
var $863ab8af7c66a185$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $863ab8af7c66a185$export$dece24112a937f92 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});

parcelRegister("a8XWo", function(module, exports) {
$parcel$export(module.exports, "default", () => $762925b9b37c47b8$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $762925b9b37c47b8$export$2e2bcd8739ae039(_ref) {
    var onOpenComplete = _ref.onOpenComplete, onCloseComplete = _ref.onCloseComplete;
    var motionRef = (0, $5FkrB.useRef)(null);
    var onMotionFinish = (0, $5FkrB.useCallback)(function(state) {
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("lDqpZ", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", () => $fc01bb97daef4f06$export$ec28e97c7d8b1b35);

var $7QpUe = parcelRequire("7QpUe");
parcelRequire("5K9q2");
var $e8Olt = parcelRequire("e8Olt");
parcelRequire("2tDld");
var $bGJkn = parcelRequire("bGJkn");

var $bhh1k = parcelRequire("bhh1k");
function $fc01bb97daef4f06$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var unbindEvents = (0, $7QpUe.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $bGJkn.monitorForElements)({
        onGenerateDragPreview: function onGenerateDragPreview() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $e8Olt.combine)(unbindEvents, unbindMonitor);
}
function $fc01bb97daef4f06$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $7QpUe.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener(event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
var $fc01bb97daef4f06$var$api = (0, $bhh1k.makeFixForAdapter)({
    watchForInteractionStart: $fc01bb97daef4f06$var$watchForInteractionStart,
    watchForInteractionEnd: $fc01bb97daef4f06$var$watchForInteractionEnd
});
function $fc01bb97daef4f06$export$ec28e97c7d8b1b35() {
    return $fc01bb97daef4f06$var$api.registerUsage();
}

});
parcelRegister("2tDld", function(module, exports) {
$parcel$export(module.exports, "monitorForElements", () => (parcelRequire("bGJkn")).monitorForElements);

var $bGJkn = parcelRequire("bGJkn");
 // Payload for the draggable being dragged

});
parcelRegister("bGJkn", function(module, exports) {
$parcel$export(module.exports, "monitorForElements", () => $8826c719998eb2c8$export$59a074bac4c54f54);

var $iYJcE = parcelRequire("iYJcE");

var $7QpUe = parcelRequire("7QpUe");

var $7gDgy = parcelRequire("7gDgy");

var $5L2w0 = parcelRequire("5L2w0");

var $9nBvn = parcelRequire("9nBvn");

var $e8Olt = parcelRequire("e8Olt");

var $km8Dk = parcelRequire("km8Dk");

var $ltTu1 = parcelRequire("ltTu1");

var $biQMN = parcelRequire("biQMN");

var $aLSXp = parcelRequire("aLSXp");

var $80qBI = parcelRequire("80qBI");

var $1PaDh = parcelRequire("1PaDh");

var $cnNGH = parcelRequire("cnNGH");
var $8826c719998eb2c8$var$draggableRegistry = new WeakMap();
function $8826c719998eb2c8$var$addToRegistry(args) {
    $8826c719998eb2c8$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $8826c719998eb2c8$var$draggableRegistry.delete(args.element);
    };
}
var $8826c719998eb2c8$var$honeyPotFix = (0, $5L2w0.makeHoneyPotFix)();
var $8826c719998eb2c8$var$adapter = (0, $9nBvn.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount: function mount(api) {
        /**  Binding event listeners the `document` rather than `window` so that
     * this adapter always gets preference over the text adapter.
     * `document` is the first `EventTarget` under `window`
     * https://twitter.com/alexandereardon/status/1604658588311465985
     */ return (0, $e8Olt.combine)($8826c719998eb2c8$var$honeyPotFix.bindEvents(), (0, $7QpUe.bind)(document, {
            type: 'dragstart',
            listener: function listener(event) {
                var _entry$dragHandle, _entry$getInitialData, _entry$getInitialData2, _entry$dragHandle2, _entry$getInitialData3, _entry$getInitialData4;
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                var target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return;
                // see if the thing being dragged is owned by us
                var entry = $8826c719998eb2c8$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return;
                /**
         * A text selection drag _can_ have the `draggable` element be
         * the `event.target` if the user is dragging the text selection
         * from the `draggable`.
         *
         * To know if the `draggable` is being dragged, we look at whether any
         * `"text/plain"` data is being dragged. If it is, then a text selection
         * drag is occurring.
         *
         * This behaviour has been validated on:
         *
         * - Chrome@128 on Android@14
         * - Chrome@128 on iOS@17.6.1
         * - Chrome@128 on Windows@11
         * - Chrome@128 on MacOS@14.6.1
         * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
         * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
         *
         * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
         * but unfortunately ProseMirror is always setting `""` as the dragged text
         *
         * Note: Unfortunately editor is (heavily) leaning on the current functionality today
         * and unwinding it will be a decent amount of effort. So for now, a text selection
         * where the `event.target` is a `draggable` element will still trigger the
         * element adapter.
         *
         * // Future state:
         * if(event.dataTransfer.getData(textMediaType)) {
         * 	return;
         * }
         *
         */ var input = (0, $aLSXp.getInput)(event);
                var feedback = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle = entry.dragHandle) !== null && _entry$dragHandle !== void 0 ? _entry$dragHandle : null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    var over = (0, $7gDgy.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return;
                    }
                }
                /**
         *  **Goal**
         *  Pass information to other applications
         *
         * **Approach**
         *  Put data into the native data store
         *
         *  **What about the native adapter?**
         *  When the element adapter puts native data into the native data store
         *  the native adapter is not triggered in the current window,
         *  but a native adapter in an external window _can_ be triggered
         *
         *  **Why bake this into core?**
         *  This functionality could be pulled out and exposed inside of
         *  `onGenerateDragPreview`. But decided to make it a part of the
         *  base API as it felt like a common enough use case and ended
         *  up being a similar amount of code to include this function as
         *  it was to expose the hook for it
         */ var nativeData = (_entry$getInitialData = (_entry$getInitialData2 = entry.getInitialDataForExternal) === null || _entry$getInitialData2 === void 0 ? void 0 : _entry$getInitialData2.call(entry, feedback)) !== null && _entry$getInitialData !== void 0 ? _entry$getInitialData : null;
                if (nativeData) for(var _i = 0, _Object$entries = Object.entries(nativeData); _i < _Object$entries.length; _i++){
                    var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], data = _Object$entries$_i[1];
                    event.dataTransfer.setData(key, data !== null && data !== void 0 ? data : '');
                }
                /**
         *  📱 For Android devices, a drag operation will not start unless
         * "text/plain" or "text/uri-list" data exists in the native data store
         * https://twitter.com/alexandereardon/status/1732189803754713424
         *
         * Tested on:
         * Device: Google Pixel 5
         * Android version: 14 (November 5, 2023)
         * Chrome version: 120.0
         */ if ((0, $biQMN.isAndroid)() && !event.dataTransfer.types.includes((0, $80qBI.textMediaType)) && !event.dataTransfer.types.includes((0, $1PaDh.URLMediaType))) event.dataTransfer.setData((0, $80qBI.textMediaType), (0, $biQMN.androidFallbackText));
                /**
         * 1. Must set any media type for `iOS15` to work
         * 2. We are also doing adding data so that the native adapter
         * can know that the element adapter has handled this drag
         *
         * We used to wrap this `setData()` in a `try/catch` for Firefox,
         * but it looks like that was not needed.
         *
         * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
         *
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
         * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
         *
         * // just checking a few more combinations to be super safe
         *
         * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
         * - ✅ Chrome@78 (Oct 2019) on Windows 10
         * - ✅ Safari@14.1 on macOS Big Sur
         */ event.dataTransfer.setData((0, $cnNGH.elementAdapterNativeDataKey), '');
                var payload = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle2 = entry.dragHandle) !== null && _entry$dragHandle2 !== void 0 ? _entry$dragHandle2 : null,
                    data: (_entry$getInitialData3 = (_entry$getInitialData4 = entry.getInitialData) === null || _entry$getInitialData4 === void 0 ? void 0 : _entry$getInitialData4.call(entry, feedback)) !== null && _entry$getInitialData3 !== void 0 ? _entry$getInitialData3 : {}
                };
                var dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: function dispatchEventToSource(_ref) {
        var _draggableRegistry$ge, _draggableRegistry$ge2;
        var eventName = _ref.eventName, payload = _ref.payload;
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        (_draggableRegistry$ge = $8826c719998eb2c8$var$draggableRegistry.get(payload.source.element)) === null || _draggableRegistry$ge === void 0 || (_draggableRegistry$ge2 = _draggableRegistry$ge[eventName]) === null || _draggableRegistry$ge2 === void 0 || _draggableRegistry$ge2.call(_draggableRegistry$ge, // I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $8826c719998eb2c8$var$honeyPotFix.getOnPostDispatch()
});
var $8826c719998eb2c8$export$e7140b68045b5036 = $8826c719998eb2c8$var$adapter.dropTarget;
var $8826c719998eb2c8$export$59a074bac4c54f54 = $8826c719998eb2c8$var$adapter.monitor;
function $8826c719998eb2c8$export$c746a5152d4ba26c(args) {
    var existing;
    var cleanup = (0, $e8Olt.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $8826c719998eb2c8$var$adapter.registerUsage(), $8826c719998eb2c8$var$addToRegistry(args), (0, $ltTu1.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, $km8Dk.once)(cleanup);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrag()`) on for a `draggable()` */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForElements()` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForElements` */ 

});
parcelRegister("7gDgy", function(module, exports) {
$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => $54a87c760438b170$export$81d0353f25f5dd);

var $iYJcE = parcelRequire("iYJcE");

var $hkM1W = parcelRequire("hkM1W");
function $54a87c760438b170$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    var _document$elementsFro = document.elementsFromPoint(client.x, client.y), _document$elementsFro2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_document$elementsFro, 2), top = _document$elementsFro2[0], second = _document$elementsFro2[1];
    if (!top) return null;
    if ((0, $hkM1W.isHoneyPotElement)(top)) return second !== null && second !== void 0 ? second : null;
    return top;
}

});
parcelRegister("hkM1W", function(module, exports) {
$parcel$export(module.exports, "isHoneyPotElement", () => $0341b3ddd6763892$export$821bdcd739a2706b);

var $h80K6 = parcelRequire("h80K6");
function $0341b3ddd6763892$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $h80K6.honeyPotDataAttribute));
}

});
parcelRegister("h80K6", function(module, exports) {
$parcel$export(module.exports, "honeyPotDataAttribute", () => $c783c27d10438509$export$6eafea55f7947469);
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
var $c783c27d10438509$export$6eafea55f7947469 = 'data-pdnd-honey-pot';

});



parcelRegister("5L2w0", function(module, exports) {
$parcel$export(module.exports, "makeHoneyPotFix", () => $43134b05e8e727ac$export$8ecad27c959e89e0);

var $25nEq = parcelRequire("25nEq");

var $7QpUe = parcelRequire("7QpUe");

var $leSXk = parcelRequire("leSXk");

var $h80K6 = parcelRequire("h80K6");
function $43134b05e8e727ac$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $43134b05e8e727ac$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $43134b05e8e727ac$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $43134b05e8e727ac$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $43134b05e8e727ac$var$honeyPotSize = 2;
var $43134b05e8e727ac$var$halfHoneyPotSize = $43134b05e8e727ac$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $43134b05e8e727ac$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $43134b05e8e727ac$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $43134b05e8e727ac$var$halfHoneyPotSize,
        y: point.y - $43134b05e8e727ac$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $43134b05e8e727ac$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $43134b05e8e727ac$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $43134b05e8e727ac$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $43134b05e8e727ac$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $43134b05e8e727ac$var$getHoneyPotRectFor(_ref) {
    var client = _ref.client;
    var point = $43134b05e8e727ac$var$preventGoingForwardsOffScreen($43134b05e8e727ac$var$preventGoingBackwardsOffScreen($43134b05e8e727ac$var$pullBackByHalfHoneyPotSize($43134b05e8e727ac$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $43134b05e8e727ac$var$honeyPotSize,
        height: $43134b05e8e727ac$var$honeyPotSize
    });
}
function $43134b05e8e727ac$var$getRectStyles(_ref2) {
    var clientRect = _ref2.clientRect;
    return {
        left: "".concat(clientRect.left, "px"),
        top: "".concat(clientRect.top, "px"),
        width: "".concat(clientRect.width, "px"),
        height: "".concat(clientRect.height, "px")
    };
}
function $43134b05e8e727ac$var$isWithin(_ref3) {
    var client = _ref3.client, clientRect = _ref3.clientRect;
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $43134b05e8e727ac$var$mountHoneyPot(_ref4) {
    var initial = _ref4.initial;
    var element = document.createElement('div');
    element.setAttribute((0, $h80K6.honeyPotDataAttribute), 'true');
    // can shift during the drag thanks to Firefox
    var clientRect = $43134b05e8e727ac$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, $43134b05e8e727ac$var$_objectSpread($43134b05e8e727ac$var$_objectSpread({
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        position: 'fixed',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box'
    }, $43134b05e8e727ac$var$getRectStyles({
        clientRect: clientRect
    })), {}, {
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        // Want to make sure the honey pot is top of everything else.
        // Don't need to worry about native drag previews, as they will
        // have been rendered (and removed) before the honey pot is rendered
        zIndex: (0, $leSXk.maxZIndex)
    }));
    document.body.appendChild(element);
    /**
   *  🦊 In firefox we can get `"pointermove"` events after the drag
   * has started, which is a spec violation.
   * The final `"pointermove"` will reveal where the "depressed" position
   * is for our honey pot fix.
   */ var unbindPointerMove = (0, $7QpUe.bind)(window, {
        type: 'pointermove',
        listener: function listener(event) {
            var client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $43134b05e8e727ac$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $43134b05e8e727ac$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish(_ref5) {
        var current = _ref5.current;
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($43134b05e8e727ac$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        var unbindPostDragEvents = (0, $7QpUe.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $43134b05e8e727ac$export$8ecad27c959e89e0() {
    var latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $7QpUe.bind)(window, {
            type: 'pointermove',
            listener: function listener(event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        var finish = null;
        return function onPostEvent(_ref6) {
            var eventName = _ref6.eventName, payload = _ref6.payload;
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                var input = payload.location.initial.input;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                var initial = latestPointerMove !== null && latestPointerMove !== void 0 ? latestPointerMove : {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $43134b05e8e727ac$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                var _finish;
                var _input = payload.location.current.input;
                (_finish = finish) === null || _finish === void 0 || _finish({
                    current: {
                        x: _input.clientX,
                        y: _input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
parcelRegister("leSXk", function(module, exports) {
$parcel$export(module.exports, "maxZIndex", () => $f76588e528a5a0d3$export$7d0a15ee70427305);
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
var $f76588e528a5a0d3$export$7d0a15ee70427305 = 2147483647;

});


parcelRegister("9nBvn", function(module, exports) {
$parcel$export(module.exports, "makeAdapter", () => $6d435abe78eb4b78$export$2aa3a33160990d96);

var $5cDvs = parcelRequire("5cDvs");

var $gYb4y = parcelRequire("gYb4y");

var $fr8Ap = parcelRequire("fr8Ap");

var $lEK4n = parcelRequire("lEK4n");
function $6d435abe78eb4b78$export$2aa3a33160990d96(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount, dispatchEventToSource = _ref.dispatchEventToSource, onPostDispatch = _ref.onPostDispatch, defaultDropEffect = _ref.defaultDropEffect;
    var monitorAPI = (0, $lEK4n.makeMonitor)();
    var dropTargetAPI = (0, $fr8Ap.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource === null || dispatchEventToSource === void 0 || dispatchEventToSource(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch === null || onPostDispatch === void 0 || onPostDispatch(args);
    }
    function start(_ref2) {
        var event = _ref2.event, dragType = _ref2.dragType;
        (0, $5cDvs.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            var api = {
                canStart: (0, $5cDvs.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $gYb4y.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("5cDvs", function(module, exports) {
$parcel$export(module.exports, "lifecycle", () => $3c9cb7dcd23027ef$export$3efdceeb8ca25c51);

var $fC8ib = parcelRequire("fC8ib");

var $7QpUe = parcelRequire("7QpUe");

var $7gDgy = parcelRequire("7gDgy");

var $hkM1W = parcelRequire("hkM1W");

var $0ZEbX = parcelRequire("0ZEbX");

var $cbFTR = parcelRequire("cbFTR");

var $aLSXp = parcelRequire("aLSXp");

var $237DC = parcelRequire("237DC");
var $3c9cb7dcd23027ef$var$globalState = {
    isActive: false
};
function $3c9cb7dcd23027ef$var$canStart() {
    return !$3c9cb7dcd23027ef$var$globalState.isActive;
}
function $3c9cb7dcd23027ef$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $3c9cb7dcd23027ef$var$hasHierarchyChanged(_ref) {
    var current = _ref.current, next = _ref.next;
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(var i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $3c9cb7dcd23027ef$var$start(_ref2) {
    var event = _ref2.event, dragType = _ref2.dragType, getDropTargetsOver = _ref2.getDropTargetsOver, dispatchEvent = _ref2.dispatchEvent;
    if (!$3c9cb7dcd23027ef$var$canStart()) return;
    var initial = $3c9cb7dcd23027ef$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $3c9cb7dcd23027ef$var$globalState.isActive = true;
    var state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $3c9cb7dcd23027ef$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    var dispatch = (0, $237DC.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        var hasChanged = $3c9cb7dcd23027ef$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        var input = (0, $aLSXp.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        var target = (0, $hkM1W.isHoneyPotElement)(event.target) ? (0, $7gDgy.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        var nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $3c9cb7dcd23027ef$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $3c9cb7dcd23027ef$var$globalState.isActive = false;
        unbindEvents();
    }
    var unbindEvents = (0, $7QpUe.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener: function listener(event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                if (!(0, $0ZEbX.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
       * At this point we don't know if a drag is being cancelled,
       * or if a drag is leaving the `window`.
       *
       * Both have:
       *   1. "dragleave" (with `relatedTarget: null`)
       *   2. "dragend" (a "dragend" can occur when outside the `window`)
       *
       * **Clearing drop targets**
       *
       * For either case we are clearing the the drop targets
       *
       * - cancelling: we clear drop targets in `"dragend"` anyway
       * - leaving the `window`: we clear the drop targets (to clear stickiness)
       *
       * **Leaving the window and finishing the drag**
       *
       * _internal drags_
       *
       * - The drag continues when the user is outside the `window`
       *   and can resume if the user drags back over the `window`,
       *   or end when the user drops in an external `window`.
       * - We will get a `"dragend"`, or we can listen for other
       *   events to determine the drag is finished when the user re-enters the `window`).
       *
       * _external drags_
       *
       * - We conclude the drag operation.
       * - We have no idea if the user will drag back over the `window`,
       *   or if the drag ends elsewhere.
       * - We will create a new drag if the user re-enters the `window`.
       *
       * **Not updating `input`**
       *
       * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
       * Workaround: intentionally not updating `input` in "dragleave"
       * rather than the users current input values
       * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
       * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
       **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener: function listener(event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $aLSXp.getInput)(event)
                };
                /** If there are no drop targets, then we will get
       * a "drop" event if:
       * - `preventUnhandled()` is being used
       * - there is an unmanaged drop target (eg another library)
       * In these cases, it's up to the consumer
       * to handle the drop if it's not over one of our drop targets
       * - `preventUnhandled()` will cancel the "drop"
       * - unmanaged drop targets can handle the "drop" how they want to
       * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $3c9cb7dcd23027ef$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener: function listener(event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $aLSXp.getInput)(event)
                };
                cancel();
            }
        }
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((0, $cbFTR.getBindingsForBrokenDrags)({
        onDragEnd: cancel
    }))), // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $3c9cb7dcd23027ef$var$getNativeSetDragImage(event)
    });
}
function $3c9cb7dcd23027ef$var$setDropEffectOnEvent(_ref3) {
    var _current$;
    var event = _ref3.event, current = _ref3.current;
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    var innerMost = (_current$ = current[0]) === null || _current$ === void 0 ? void 0 : _current$.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $3c9cb7dcd23027ef$var$getStartLocation(_ref4) {
    var event = _ref4.event, dragType = _ref4.dragType, getDropTargetsOver = _ref4.getDropTargetsOver;
    var input = (0, $aLSXp.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    var dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
var $3c9cb7dcd23027ef$export$3efdceeb8ca25c51 = {
    canStart: $3c9cb7dcd23027ef$var$canStart,
    start: $3c9cb7dcd23027ef$var$start
};

});
parcelRegister("0ZEbX", function(module, exports) {
$parcel$export(module.exports, "isLeavingWindow", () => $002fd2101cea5902$export$57d220c74e84a273);

var $jgAIx = parcelRequire("jgAIx");

var $jk30z = parcelRequire("jk30z");

var $9x9D5 = parcelRequire("9x9D5");

var $51LJd = parcelRequire("51LJd");
function $002fd2101cea5902$export$57d220c74e84a273(_ref) {
    var dragLeave = _ref.dragLeave;
    var type = dragLeave.type, relatedTarget = dragLeave.relatedTarget;
    if (type !== 'dragleave') return false;
    if ((0, $jk30z.isSafari)()) return (0, $9x9D5.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   * (foreign element)
   */ if ((0, $jgAIx.isFirefox)()) return (0, $51LJd.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is `null` *(standard check)*
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("jgAIx", function(module, exports) {
$parcel$export(module.exports, "isFirefox", () => $e06bfe44d3a76242$export$b7d78993b74f766d);

var $km8Dk = parcelRequire("km8Dk");
var $e06bfe44d3a76242$export$b7d78993b74f766d = (0, $km8Dk.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});
parcelRegister("km8Dk", function(module, exports) {
$parcel$export(module.exports, "once", () => $ed1c8f2187431700$export$d2de3aaeafa91619);
/** Provide a function that you only ever want to be called a single time */ function $ed1c8f2187431700$export$d2de3aaeafa91619(fn) {
    var cache = null;
    return function wrapped() {
        if (!cache) {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});


parcelRegister("jk30z", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $e11237ebcba662c7$export$95df08bae54cb4df);

var $km8Dk = parcelRequire("km8Dk");
var $e11237ebcba662c7$export$95df08bae54cb4df = (0, $km8Dk.once)(function isSafari() {
    var _navigator = navigator, userAgent = _navigator.userAgent;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("9x9D5", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindowInSafari", () => $6f0eaa4e3d149253$export$de68634bd94ed596);
$parcel$export(module.exports, "isLeavingWindowInSafari", () => $6f0eaa4e3d149253$export$f21837c338005454);

var $7QpUe = parcelRequire("7QpUe");

var $jk30z = parcelRequire("jk30z");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
var $6f0eaa4e3d149253$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $6f0eaa4e3d149253$export$de68634bd94ed596(_ref) {
    var dragEnter = _ref.dragEnter;
    if (!(0, $jk30z.isSafari)()) return false;
    return dragEnter.hasOwnProperty($6f0eaa4e3d149253$var$symbols.isEnteringWindow);
}
function $6f0eaa4e3d149253$export$f21837c338005454(_ref2) {
    var dragLeave = _ref2.dragLeave;
    if (!(0, $jk30z.isSafari)()) return false;
    return dragLeave.hasOwnProperty($6f0eaa4e3d149253$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $jk30z.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    var state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragstart',
            listener: function listener() {
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: function listener(event) {
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                event[$6f0eaa4e3d149253$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    event[$6f0eaa4e3d149253$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});

parcelRegister("51LJd", function(module, exports) {
$parcel$export(module.exports, "isFromAnotherWindow", () => $3a92119ad8e5a946$export$e46810fef53b5b0e);
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $3a92119ad8e5a946$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $3a92119ad8e5a946$export$e46810fef53b5b0e(eventTarget) {
    return $3a92119ad8e5a946$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});


parcelRegister("cbFTR", function(module, exports) {
$parcel$export(module.exports, "getBindingsForBrokenDrags", () => $8df703960cd6b824$export$ac5e5b0daf997b2);
function $8df703960cd6b824$export$ac5e5b0daf997b2(_ref) {
    var onDragEnd = _ref.onDragEnd;
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            }()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("aLSXp", function(module, exports) {
$parcel$export(module.exports, "getInput", () => $02061454bb4b203a$export$7c112ceec8941e67);
function $02061454bb4b203a$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("237DC", function(module, exports) {
$parcel$export(module.exports, "makeDispatch", () => $17e1c9562ae209a6$export$9f13ecc44e83d682);

var $45Zis = parcelRequire("45Zis");
var $17e1c9562ae209a6$var$scheduleOnDrag = (0, $45Zis.default)(function(fn) {
    return fn();
});
var $17e1c9562ae209a6$var$dragStart = function() {
    var scheduled = null;
    function schedule(fn) {
        var frameId = requestAnimationFrame(function() {
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
}();
function $17e1c9562ae209a6$export$9f13ecc44e83d682(_ref) {
    var source = _ref.source, initial = _ref.initial, dispatchEvent = _ref.dispatchEvent;
    var previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    var dispatch = {
        start: function start(_ref2) {
            var nativeSetDragImage = _ref2.nativeSetDragImage;
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            var location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $17e1c9562ae209a6$var$dragStart.schedule(function() {
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate: function dragUpdate(_ref3) {
            var current = _ref3.current;
            $17e1c9562ae209a6$var$dragStart.flush();
            $17e1c9562ae209a6$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag: function drag(_ref4) {
            var current = _ref4.current;
            $17e1c9562ae209a6$var$scheduleOnDrag(function() {
                $17e1c9562ae209a6$var$dragStart.flush();
                var location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop: function drop(_ref5) {
            var current = _ref5.current, updatedSourcePayload = _ref5.updatedSourcePayload;
            $17e1c9562ae209a6$var$dragStart.flush();
            $17e1c9562ae209a6$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload !== null && updatedSourcePayload !== void 0 ? updatedSourcePayload : source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});


parcelRegister("gYb4y", function(module, exports) {
$parcel$export(module.exports, "register", () => $c5aad6b5e1850488$export$6503ec6e8aabbaf);
// Extending `Map` to allow us to link Key and Values together
var $c5aad6b5e1850488$var$ledger = new Map();
function $c5aad6b5e1850488$var$registerUsage(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount;
    var entry = $c5aad6b5e1850488$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    var initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $c5aad6b5e1850488$var$ledger.set(typeKey, initial);
    return initial;
}
function $c5aad6b5e1850488$export$6503ec6e8aabbaf(args) {
    var entry = $c5aad6b5e1850488$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $c5aad6b5e1850488$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("fr8Ap", function(module, exports) {
$parcel$export(module.exports, "makeDropTarget", () => $b3d009add3926a42$export$47d10e7bd9c81890);

var $25nEq = parcelRequire("25nEq");

var $fC8ib = parcelRequire("fC8ib");

var $e8Olt = parcelRequire("e8Olt");

var $km8Dk = parcelRequire("km8Dk");

var $ltTu1 = parcelRequire("ltTu1");
function $b3d009add3926a42$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b3d009add3926a42$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b3d009add3926a42$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b3d009add3926a42$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b3d009add3926a42$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $b3d009add3926a42$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $b3d009add3926a42$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b3d009add3926a42$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b3d009add3926a42$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b3d009add3926a42$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $b3d009add3926a42$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $b3d009add3926a42$export$47d10e7bd9c81890(_ref) {
    var typeKey = _ref.typeKey, defaultDropEffect = _ref.defaultDropEffect;
    var registry = new WeakMap();
    var dropTargetDataAtt = "data-drop-target-for-".concat(typeKey);
    var dropTargetSelector = "[".concat(dropTargetDataAtt, "]");
    function addToRegistry(args) {
        registry.set(args.element, args);
        return function() {
            return registry.delete(args.element);
        };
    }
    function dropTargetForConsumers(args) {
        var existing;
        var cleanup = (0, $e8Olt.combine)((0, $ltTu1.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $km8Dk.once)(cleanup);
    }
    function getActualDropTargets(_ref2) {
        var _args$getData, _args$getData2, _args$getDropEffect, _args$getDropEffect2;
        var source = _ref2.source, target = _ref2.target, input = _ref2.input, _ref2$result = _ref2.result, result = _ref2$result === void 0 ? [] : _ref2$result;
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        var closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        var args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        var feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        var data = (_args$getData = (_args$getData2 = args.getData) === null || _args$getData2 === void 0 ? void 0 : _args$getData2.call(args, feedback)) !== null && _args$getData !== void 0 ? _args$getData : {};
        var dropEffect = (_args$getDropEffect = (_args$getDropEffect2 = args.getDropEffect) === null || _args$getDropEffect2 === void 0 ? void 0 : _args$getDropEffect2.call(args, feedback)) !== null && _args$getDropEffect !== void 0 ? _args$getDropEffect : defaultDropEffect;
        var record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result), [
                record
            ])
        });
    }
    function notifyCurrent(_ref3) {
        var eventName = _ref3.eventName, payload = _ref3.payload;
        var _iterator = $b3d009add3926a42$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _entry$eventName;
                var record = _step.value;
                var entry = registry.get(record.element);
                var args = $b3d009add3926a42$var$_objectSpread($b3d009add3926a42$var$_objectSpread({}, payload), {}, {
                    self: record
                });
                entry === null || entry === void 0 || (_entry$eventName = entry[eventName]) === null || _entry$eventName === void 0 || _entry$eventName.call(entry, // I cannot seem to get the types right here.
                // TS doesn't seem to like that one event can need `nativeSetDragImage`
                // @ts-expect-error
                args);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    var actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: function onDropTargetChange(_ref4) {
            var payload = _ref4.payload;
            var isCurrent = new Set(payload.location.current.dropTargets.map(function(record) {
                return record.element;
            }));
            var visited = new Set();
            var _iterator2 = $b3d009add3926a42$var$_createForOfIteratorHelper(payload.location.previous.dropTargets), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _entry$onDropTargetCh;
                    var record = _step2.value;
                    visited.add(record.element);
                    var entry = registry.get(record.element);
                    var isOver = isCurrent.has(record.element);
                    var args = $b3d009add3926a42$var$_objectSpread($b3d009add3926a42$var$_objectSpread({}, payload), {}, {
                        self: record
                    });
                    entry === null || entry === void 0 || (_entry$onDropTargetCh = entry.onDropTargetChange) === null || _entry$onDropTargetCh === void 0 || _entry$onDropTargetCh.call(entry, args);
                    // if we cannot find the drop target in the current array, then it has been left
                    if (!isOver) {
                        var _entry$onDragLeave;
                        entry === null || entry === void 0 || (_entry$onDragLeave = entry.onDragLeave) === null || _entry$onDragLeave === void 0 || _entry$onDragLeave.call(entry, args);
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var _iterator3 = $b3d009add3926a42$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var _entry$onDropTargetCh2, _entry$onDragEnter;
                    var _record = _step3.value;
                    // already published an update to this drop target
                    if (visited.has(_record.element)) continue;
                    // at this point we have a new drop target that is being entered into
                    var _args = $b3d009add3926a42$var$_objectSpread($b3d009add3926a42$var$_objectSpread({}, payload), {}, {
                        self: _record
                    });
                    var _entry = registry.get(_record.element);
                    _entry === null || _entry === void 0 || (_entry$onDropTargetCh2 = _entry.onDropTargetChange) === null || _entry$onDropTargetCh2 === void 0 || _entry$onDropTargetCh2.call(_entry, _args);
                    _entry === null || _entry === void 0 || (_entry$onDragEnter = _entry.onDragEnter) === null || _entry$onDragEnter === void 0 || _entry$onDragEnter.call(_entry, _args);
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver(_ref5) {
        var source = _ref5.source, target = _ref5.target, input = _ref5.input, current = _ref5.current;
        var actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        var lastCaptureOrdered = $b3d009add3926a42$var$copyReverse(current);
        var actualCaptureOrdered = $b3d009add3926a42$var$copyReverse(actual);
        var resultCaptureOrdered = [];
        for(var index = 0; index < lastCaptureOrdered.length; index++){
            var _argsForLast$getIsSti;
            var last = lastCaptureOrdered[index];
            var fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            var parent = resultCaptureOrdered[index - 1];
            var lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if ((parent === null || parent === void 0 ? void 0 : parent.element) !== (lastParent === null || lastParent === void 0 ? void 0 : lastParent.element)) break;
            // We need to check whether the old drop target can still be dropped on
            var argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            var feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!((_argsForLast$getIsSti = argsForLast.getIsSticky) !== null && _argsForLast$getIsSti !== void 0 && _argsForLast$getIsSti.call(argsForLast, feedback))) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push($b3d009add3926a42$var$_objectSpread($b3d009add3926a42$var$_objectSpread({}, last), {}, {
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            }));
        }
        // return bubble ordered result
        return $b3d009add3926a42$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("ltTu1", function(module, exports) {
$parcel$export(module.exports, "addAttribute", () => $fa3758357cc1682d$export$5dcb5c23b6ba980a);
function $fa3758357cc1682d$export$5dcb5c23b6ba980a(element, _ref) {
    var attribute = _ref.attribute, value = _ref.value;
    element.setAttribute(attribute, value);
    return function() {
        return element.removeAttribute(attribute);
    };
}

});


parcelRegister("lEK4n", function(module, exports) {
$parcel$export(module.exports, "makeMonitor", () => $fc4111dbb1bd2779$export$5dd4ed888d5b12ca);

var $25nEq = parcelRequire("25nEq");

var $km8Dk = parcelRequire("km8Dk");
function $fc4111dbb1bd2779$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $fc4111dbb1bd2779$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $fc4111dbb1bd2779$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $fc4111dbb1bd2779$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $fc4111dbb1bd2779$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $fc4111dbb1bd2779$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $fc4111dbb1bd2779$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fc4111dbb1bd2779$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fc4111dbb1bd2779$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fc4111dbb1bd2779$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fc4111dbb1bd2779$export$5dd4ed888d5b12ca() {
    var registry = new Set();
    var dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        var entry = $fc4111dbb1bd2779$var$_objectSpread({}, args);
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $km8Dk.once)(cleanup);
    }
    function dispatchEvent(_ref) {
        var eventName = _ref.eventName, payload = _ref.payload;
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            var _iterator = $fc4111dbb1bd2779$var$_createForOfIteratorHelper(registry), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var monitor = _step.value;
                    tryAddToActive(monitor);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        var active = Array.from(dragging.active);
        for(var _i = 0, _active = active; _i < _active.length; _i++){
            var _monitor = _active[_i];
            // A monitor can be removed by another monitor during an event.
            // We need to check that the monitor is still registered before calling it
            if (dragging.active.has(_monitor)) {
                var _monitor$eventName;
                // @ts-expect-error: I cannot get this type working!
                (_monitor$eventName = _monitor[eventName]) === null || _monitor$eventName === void 0 || _monitor$eventName.call(_monitor, payload);
            }
        }
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("biQMN", function(module, exports) {
$parcel$export(module.exports, "isAndroid", () => $83aa5257eebd27ef$export$a11b0059900ceec8);
$parcel$export(module.exports, "androidFallbackText", () => $83aa5257eebd27ef$export$aceb3ed8b7f7bd2c);

var $km8Dk = parcelRequire("km8Dk");
var $83aa5257eebd27ef$export$a11b0059900ceec8 = (0, $km8Dk.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
var $83aa5257eebd27ef$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

parcelRegister("80qBI", function(module, exports) {
$parcel$export(module.exports, "textMediaType", () => $5d42f67763bf2ba0$export$fd3d00026297c0ad);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $5d42f67763bf2ba0$export$fd3d00026297c0ad = 'text/plain';

});

parcelRegister("1PaDh", function(module, exports) {
$parcel$export(module.exports, "URLMediaType", () => $1542cd4277bf7822$export$4c44a460f123106);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $1542cd4277bf7822$export$4c44a460f123106 = 'text/uri-list';

});

parcelRegister("cnNGH", function(module, exports) {
$parcel$export(module.exports, "elementAdapterNativeDataKey", () => $903e2cf6ee508b2e$export$c9c4cc54e73b125d);
/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ var $903e2cf6ee508b2e$export$c9c4cc54e73b125d = 'application/vnd.pdnd';

});



parcelRegister("bhh1k", function(module, exports) {
$parcel$export(module.exports, "makeFixForAdapter", () => $835e7c21e8d6b7cc$export$a74bff2507e6126b);

var $fC8ib = parcelRequire("fC8ib");
parcelRequire("5K9q2");
var $e8Olt = parcelRequire("e8Olt");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $835e7c21e8d6b7cc$var$setStyle(el, _ref) {
    var property = _ref.property, rule = _ref.rule, _ref$priority = _ref.priority, priority = _ref$priority === void 0 ? '' : _ref$priority;
    var originalValue = el.style.getPropertyValue(property);
    var originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $835e7c21e8d6b7cc$var$hasSameOrigin(href1, href2) {
    var url1;
    var url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (error) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $835e7c21e8d6b7cc$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith('data:')) return false;
    return !$835e7c21e8d6b7cc$var$hasSameOrigin(window.location.href, iframe.src);
}
var $835e7c21e8d6b7cc$var$registry = new Map();
function $835e7c21e8d6b7cc$var$applyFix(watchForEndOfInteraction) {
    var iframes = Array.from(document.querySelectorAll('iframe')).filter($835e7c21e8d6b7cc$var$isIframeOnAnotherDomain);
    var cleanups = iframes.map(function(iframe) {
        var entry = $835e7c21e8d6b7cc$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $835e7c21e8d6b7cc$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $835e7c21e8d6b7cc$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $835e7c21e8d6b7cc$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $e8Olt.combine).apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(cleanups))();
    }
    var cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $835e7c21e8d6b7cc$export$a74bff2507e6126b(_ref2) {
    var watchForInteractionStart = _ref2.watchForInteractionStart, watchForInteractionEnd = _ref2.watchForInteractionEnd;
    var registrationCount = 0;
    var stopWatchingInteractionStart = null;
    function start() {
        $835e7c21e8d6b7cc$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            var _stopWatchingInteract;
            registrationCount--;
            if (registrationCount !== 0) return;
            (_stopWatchingInteract = stopWatchingInteractionStart) === null || _stopWatchingInteract === void 0 || _stopWatchingInteract();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

});


parcelRegister("kLhYg", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", () => $f1d623140326d5fe$export$27d79116d3a4e7d5);
parcelRequire("7fyYd");
var $d5aIg = parcelRequire("d5aIg");

var $bhh1k = parcelRequire("bhh1k");
function $f1d623140326d5fe$var$watchForInteractionStart(_ref) {
    var start = _ref.start;
    return (0, $d5aIg.monitorForExternal)({
        onDragStart: function onDragStart() {
            start();
        }
    });
}
function $f1d623140326d5fe$var$watchForInteractionEnd(_ref2) {
    var stop = _ref2.stop;
    return (0, $d5aIg.monitorForExternal)({
        onDrop: function onDrop() {
            stop();
        }
    });
}
var $f1d623140326d5fe$var$api = (0, $bhh1k.makeFixForAdapter)({
    watchForInteractionStart: $f1d623140326d5fe$var$watchForInteractionStart,
    watchForInteractionEnd: $f1d623140326d5fe$var$watchForInteractionEnd
});
function $f1d623140326d5fe$export$27d79116d3a4e7d5() {
    return $f1d623140326d5fe$var$api.registerUsage();
}

});
parcelRegister("7fyYd", function(module, exports) {
$parcel$export(module.exports, "monitorForExternal", () => (parcelRequire("d5aIg")).monitorForExternal);

var $d5aIg = parcelRequire("d5aIg");
 // The data that is being dragged

});
parcelRegister("d5aIg", function(module, exports) {
$parcel$export(module.exports, "monitorForExternal", () => $98640d5511e19e0a$export$bb1740f3194979c1);

var $fC8ib = parcelRequire("fC8ib");

var $7QpUe = parcelRequire("7QpUe");

var $9nBvn = parcelRequire("9nBvn");

var $biQMN = parcelRequire("biQMN");

var $7S0j4 = parcelRequire("7S0j4");

var $cbFTR = parcelRequire("cbFTR");

var $80qBI = parcelRequire("80qBI");

var $cnNGH = parcelRequire("cnNGH");
function $98640d5511e19e0a$export$a8e56a860d7957c7(_ref) {
    var type = _ref.type, value = _ref.value;
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $cnNGH.elementAdapterNativeDataKey)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $80qBI.textMediaType) && value === (0, $biQMN.androidFallbackText)) return false;
    return true;
}
function $98640d5511e19e0a$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter(function(type) {
        return $98640d5511e19e0a$export$a8e56a860d7957c7({
            type: type,
            value: transfer.getData(type)
        });
    });
}
function $98640d5511e19e0a$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter(function(item) {
        return item.kind === 'file' || $98640d5511e19e0a$export$a8e56a860d7957c7({
            type: item.type,
            value: dataTransfer.getData(item.type)
        });
    });
}
var $98640d5511e19e0a$var$didDragStartLocally = false;
var $98640d5511e19e0a$var$adapter = (0, $9nBvn.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $7QpUe.bind)(window, {
            type: 'dragenter',
            listener: function listener(event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($98640d5511e19e0a$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $7S0j4.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                var types = $98640d5511e19e0a$export$8c257a3856120a77(event.dataTransfer);
                if (!types.length) return;
                var locked = {
                    types: types,
                    items: [],
                    getStringData: function getStringData() {
                        return null;
                    }
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload: function getDropPayload(event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            var items = $98640d5511e19e0a$export$8d28cfecded8dcab(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            var nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData: function getStringData(mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    var value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!$98640d5511e19e0a$export$a8e56a860d7957c7({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function $98640d5511e19e0a$export$9edc779df9a85289(args) {
    // not removing unused events, just leaning on the type system
    return $98640d5511e19e0a$var$adapter.dropTarget(args);
}
function $98640d5511e19e0a$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return $98640d5511e19e0a$var$adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $98640d5511e19e0a$var$adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    var idle = {
        type: 'idle'
    };
    var state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $98640d5511e19e0a$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $7QpUe.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((0, $cbFTR.getBindingsForBrokenDrags)({
            onDragEnd: clear
        }))), // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $7QpUe.bind)(window, {
        type: 'dragstart',
        listener: function listener() {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $98640d5511e19e0a$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})(); /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 

});
parcelRegister("7S0j4", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindow", () => $5badd072613d29de$export$d1c6f249e893cdf4);

var $jgAIx = parcelRequire("jgAIx");

var $jk30z = parcelRequire("jk30z");

var $9x9D5 = parcelRequire("9x9D5");

var $51LJd = parcelRequire("51LJd");
function $5badd072613d29de$export$d1c6f249e893cdf4(_ref) {
    var dragEnter = _ref.dragEnter;
    var type = dragEnter.type, relatedTarget = dragEnter.relatedTarget;
    if (type !== 'dragenter') return false;
    if ((0, $jk30z.isSafari)()) return (0, $9x9D5.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is the `iframe` element in the parent `window`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is an element inside the child `iframe`
   * (foreign element)
   */ if ((0, $jgAIx.isFirefox)()) return (0, $51LJd.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is `null` *(standard check)*
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is the `iframe` element in the parent `window`
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});




parcelRegister("8KNdU", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", () => $65f8cd54b0500ec2$export$9c0606fcefb5d1e2);

var $7QpUe = parcelRequire("7QpUe");
parcelRequire("5K9q2");
var $e8Olt = parcelRequire("e8Olt");
parcelRequire("aedQW");
var $keWrp = parcelRequire("keWrp");

var $bhh1k = parcelRequire("bhh1k");
function $65f8cd54b0500ec2$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var frameId = null;
    var unbindEvents = (0, $7QpUe.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener: function listener() {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(function() {
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $keWrp.monitorForTextSelection)({
        onDragStart: function onDragStart() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $e8Olt.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $65f8cd54b0500ec2$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $7QpUe.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener() {
            // A text selection drag will only start when there is
            // an active text selection.
            var selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
var $65f8cd54b0500ec2$var$api = (0, $bhh1k.makeFixForAdapter)({
    watchForInteractionStart: $65f8cd54b0500ec2$var$watchForInteractionStart,
    watchForInteractionEnd: $65f8cd54b0500ec2$var$watchForInteractionEnd
});
function $65f8cd54b0500ec2$export$9c0606fcefb5d1e2() {
    return $65f8cd54b0500ec2$var$api.registerUsage();
}

});
parcelRegister("aedQW", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", () => (parcelRequire("keWrp")).monitorForTextSelection);

var $keWrp = parcelRequire("keWrp");
 // Payload for the text selection being dragged

});
parcelRegister("keWrp", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", () => $ebc2729cd4c93fa2$export$2e178e3647f5e6e9);

var $7QpUe = parcelRequire("7QpUe");

var $5L2w0 = parcelRequire("5L2w0");

var $9nBvn = parcelRequire("9nBvn");

var $e8Olt = parcelRequire("e8Olt");

var $jk30z = parcelRequire("jk30z");

var $lx484 = parcelRequire("lx484");

var $80qBI = parcelRequire("80qBI");

var $cnNGH = parcelRequire("cnNGH");
function $ebc2729cd4c93fa2$var$findTextNode(event) {
    var _event$dataTransfer;
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $jk30z.isSafari)()) return null;
    /**
   * According to the spec, `event.target` should be the `Text` node that
   * the drag started from when dragging a text selection.
   *
   * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
   *
   * However, in Safari the closest `HTMLElement` is returned.
   * So we need to figure out if text is dragging ourselves.
   *
   * → https://bugs.webkit.org/show_bug.cgi?id=268959
   */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!((_event$dataTransfer = event.dataTransfer) !== null && _event$dataTransfer !== void 0 && _event$dataTransfer.getData((0, $80qBI.textMediaType)))) return null;
    /**
   * Grab the first Text node and use that.
   * Only doing a single level search as that is all we need for this bug.
   */ var text = Array.from(event.target.childNodes).find(function(node) {
        return node.nodeType === Node.TEXT_NODE;
    });
    return text !== null && text !== void 0 ? text : null;
}
var $ebc2729cd4c93fa2$var$honeyPotFix = (0, $5L2w0.makeHoneyPotFix)();
var $ebc2729cd4c93fa2$var$adapter = (0, $9nBvn.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $e8Olt.combine)($ebc2729cd4c93fa2$var$honeyPotFix.bindEvents(), (0, $7QpUe.bind)(window, {
            type: 'dragstart',
            listener: function listener(event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $cnNGH.elementAdapterNativeDataKey))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $80qBI.textMediaType))) return;
                var target = $ebc2729cd4c93fa2$var$findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                var payload = {
                    // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target: target,
                    plain: event.dataTransfer.getData((0, $80qBI.textMediaType)),
                    HTML: event.dataTransfer.getData((0, $lx484.HTMLMediaType))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: $ebc2729cd4c93fa2$var$honeyPotFix.getOnPostDispatch()
});
function $ebc2729cd4c93fa2$export$9bfaa8eb182300d1(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $ebc2729cd4c93fa2$var$adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $ebc2729cd4c93fa2$var$adapter.registerUsage();
})();
function $ebc2729cd4c93fa2$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $ebc2729cd4c93fa2$var$adapter.monitor(args);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Argument given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Argument given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 

});
parcelRegister("lx484", function(module, exports) {
$parcel$export(module.exports, "HTMLMediaType", () => $facfe2010f4b17ca$export$338a9f6c7a1f02b0);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $facfe2010f4b17ca$export$338a9f6c7a1f02b0 = 'text/html';

});




parcelRegister("3dEWA", function(module, exports) {
$parcel$export(module.exports, "dialogWidth", () => $2582589a0b2ae018$export$a3da89b899389ed8);
$parcel$export(module.exports, "dialogHeight", () => $2582589a0b2ae018$export$ceba93bf0bdd16f2);
var $2582589a0b2ae018$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};
var $2582589a0b2ae018$export$a3da89b899389ed8 = function dialogWidth(input) {
    if (!input) return 'auto';
    var isWidthName = $2582589a0b2ae018$export$7e3df82ee760448c.values.indexOf(input.toString()) !== -1;
    var widthName = isWidthName && input;
    if (widthName) return "".concat($2582589a0b2ae018$export$7e3df82ee760448c.widths[widthName], "px");
    return typeof input === 'number' ? "".concat(input, "px") : input;
};
var $2582589a0b2ae018$export$ceba93bf0bdd16f2 = function dialogHeight(input) {
    if (!input) return 'auto';
    return typeof input === 'number' ? "".concat(input, "px") : input;
};

});

parcelRegister("lGXDD", function(module, exports) {
$parcel$export(module.exports, "default", () => $fcabc821ed842c5c$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $2HK8I = parcelRequire("2HK8I");

var $fF5v2 = parcelRequire("fF5v2");

var $5Rrqa = parcelRequire("5Rrqa");

var $H74DA = parcelRequire("H74DA");
var $fcabc821ed842c5c$var$gutter = 60;
var $fcabc821ed842c5c$var$maxWidthDimensions = "calc(100vw - ".concat($fcabc821ed842c5c$var$gutter * 2, "px)");
var $fcabc821ed842c5c$var$maxHeightDimensions = "calc(100vh - ".concat($fcabc821ed842c5c$var$gutter * 2 - 1, "px)");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
var $fcabc821ed842c5c$var$positionerStyles = (0, $74Zh5.css)({
    display: 'flex',
    width: '100%',
    maxWidth: '100%',
    height: '100%',
    position: 'fixed',
    zIndex: (0, $H74DA.layers).modal(),
    flexDirection: 'column',
    insetBlockStart: 0,
    insetInlineStart: 0
});
var $fcabc821ed842c5c$var$viewportScrollStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    height: 'auto',
    position: 'relative'
}, (0, $5Rrqa.media).above.xs, {
    margin: "".concat($fcabc821ed842c5c$var$gutter, "px auto"),
    pointerEvents: 'none'
}));
var $fcabc821ed842c5c$var$bodyScrollStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $5Rrqa.media).above.xs, {
    maxWidth: $fcabc821ed842c5c$var$maxWidthDimensions,
    maxHeight: $fcabc821ed842c5c$var$maxHeightDimensions,
    position: 'absolute',
    insetBlockStart: "".concat($fcabc821ed842c5c$var$gutter, "px"),
    insetInlineEnd: 0,
    insetInlineStart: 0,
    marginInlineEnd: 'auto',
    marginInlineStart: 'auto',
    pointerEvents: 'none'
}));
var $fcabc821ed842c5c$var$stackTransitionStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    transitionDuration: "".concat((0, $fF5v2.durations).medium, "ms"),
    transitionProperty: 'transform',
    transitionTimingFunction: (0, $2HK8I.easeInOut),
    /**
   * Duplicated from @atlaskit/motion/accessibility
   * because @repo/internal/styles/consistent-style-ordering
   * doesn't work well with object spreading.
   */ '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
});
var $fcabc821ed842c5c$var$stackTransformStyles = (0, $74Zh5.css)({
    transform: 'translateY(var(--modal-dialog-translate-y))'
});
var $fcabc821ed842c5c$var$stackIdleStyles = (0, $74Zh5.css)({
    transform: 'none'
});
var $fcabc821ed842c5c$var$Positioner = function Positioner(props) {
    var children = props.children, stackIndex = props.stackIndex, shouldScrollInViewport = props.shouldScrollInViewport, testId = props.testId;
    return (0, $74Zh5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-translate-y': "calc(".concat(stackIndex, "px * ", "var(--ds-space-100, 8px)", ")")
        },
        css: [
            $fcabc821ed842c5c$var$positionerStyles,
            $fcabc821ed842c5c$var$stackTransitionStyles,
            /* We only want to apply transform on modals shifting to the back of the stack. */ stackIndex > 0 ? $fcabc821ed842c5c$var$stackTransformStyles : $fcabc821ed842c5c$var$stackIdleStyles,
            shouldScrollInViewport ? $fcabc821ed842c5c$var$viewportScrollStyles : $fcabc821ed842c5c$var$bodyScrollStyles
        ],
        "data-testid": testId && "".concat(testId, "--positioner")
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fcabc821ed842c5c$export$2e2bcd8739ae039 = $fcabc821ed842c5c$var$Positioner;

});
parcelRegister("2HK8I", function(module, exports) {
$parcel$export(module.exports, "easeInOut", () => $1f836347f90924f9$export$c07234257a03d5e9);
var $1f836347f90924f9$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
var $1f836347f90924f9$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
var $1f836347f90924f9$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
var $1f836347f90924f9$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
var $1f836347f90924f9$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
var $1f836347f90924f9$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
var $1f836347f90924f9$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

});



parcelRegister("60tyR", function(module, exports) {
$parcel$export(module.exports, "default", () => $45f9ac6b886497d2$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $1kPX3 = parcelRequire("1kPX3");

var $ciDfW = parcelRequire("ciDfW");

var $bLMGO = parcelRequire("bLMGO");

var $ZdqJG = parcelRequire("ZdqJG");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ var $45f9ac6b886497d2$var$modalStackRegister = [];
function $45f9ac6b886497d2$export$2e2bcd8739ae039(_ref) {
    var onStackChange = _ref.onStackChange;
    var _useExitingPersistenc = (0, $ZdqJG.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting;
    var _useStateRef = (0, $bLMGO.default)(0), _useStateRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useStateRef, 2), stackIndexRef = _useStateRef2[0], setStackIndex = _useStateRef2[1];
    var currentStackIndex = stackIndexRef.current;
    var previousStackIndex = (0, $ciDfW.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    var updateStack = (0, $1kPX3.default)(function() {
        var newStackIndex = $45f9ac6b886497d2$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $5FkrB.useEffect)(function() {
        var currentStackIndex = $45f9ac6b886497d2$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $45f9ac6b886497d2$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $45f9ac6b886497d2$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $45f9ac6b886497d2$var$modalStackRegister.forEach(function(cb) {
            return cb();
        });
    }, [
        updateStack,
        isExiting
    ]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            var currentStackIndex = $45f9ac6b886497d2$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $45f9ac6b886497d2$var$modalStackRegister.splice(currentStackIndex, 1);
                $45f9ac6b886497d2$var$modalStackRegister.forEach(function(cb) {
                    return cb();
                });
            }
        };
    }, [
        updateStack
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("1kPX3", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f8ff52f3e6d1f22$export$2e2bcd8739ae039);

var $amMBV = parcelRequire("amMBV");
function $0f8ff52f3e6d1f22$export$2e2bcd8739ae039(callback) {
    var ref = (0, $amMBV.default)(function() {
        return callback;
    });
    return ref.current;
}

});
parcelRegister("amMBV", function(module, exports) {
$parcel$export(module.exports, "default", () => $78c1aa829ab850be$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
var $78c1aa829ab850be$var$uniqueReferencedValue = {};
function $78c1aa829ab850be$export$2e2bcd8739ae039(initializer) {
    var ref = (0, $5FkrB.useRef)($78c1aa829ab850be$var$uniqueReferencedValue);
    if (ref.current === $78c1aa829ab850be$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});


parcelRegister("ciDfW", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f459deb6f880ccf$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $8f459deb6f880ccf$export$2e2bcd8739ae039(value) {
    var ref = (0, $5FkrB.useRef)();
    (0, $5FkrB.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("bLMGO", function(module, exports) {
$parcel$export(module.exports, "default", () => $8919da37d02870d7$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $8919da37d02870d7$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $5FkrB.useState)(initialState), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueRef = (0, $5FkrB.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});


parcelRegister("deUvr", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a386a1d7fb2b3ec$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $9a386a1d7fb2b3ec$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $9a386a1d7fb2b3ec$export$2e2bcd8739ae039() {
    var _useState = (0, $5FkrB.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), scrollTopOffset = _useState2[0], setScrollTopOffset = _useState2[1];
    (0, $5FkrB.useLayoutEffect)(function() {
        setScrollTopOffset($9a386a1d7fb2b3ec$var$getScrollDistance());
    }, []);
    var onWindowScroll = (0, $5FkrB.useCallback)(function() {
        if ($9a386a1d7fb2b3ec$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});


parcelRegister("4dmfM", function(module, exports) {
$parcel$export(module.exports, "default", () => $3119a3635b07e652$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $ZdqJG = parcelRequire("ZdqJG");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $3119a3635b07e652$var$ModalTransition = function ModalTransition(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ZdqJG.default), {
        appear: true
    }, props.children);
};
var $3119a3635b07e652$export$2e2bcd8739ae039 = $3119a3635b07e652$var$ModalTransition;

});

parcelRegister("9Ayri", function(module, exports) {
$parcel$export(module.exports, "default", () => $6fb230c2df2e6028$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $2B91F = parcelRequire("2B91F");
var $aDxXf = parcelRequire("aDxXf");
var $e255n = parcelRequire("e255n");

var $3aP8P = parcelRequire("3aP8P");

var $2td33 = parcelRequire("2td33");
var $6fb230c2df2e6028$var$headerStyles = (0, $74Zh5.css)({
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBlockEnd: "calc(-1 * ".concat("var(--ds-border-width-outline, 2px)", ")"),
    paddingBlockEnd: "var(--ds-space-200, 16px)",
    paddingBlockStart: "var(--ds-space-300, 24px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
var $6fb230c2df2e6028$var$gridStyles = (0, $e255n.xcss)({
    width: '100%'
});
var $6fb230c2df2e6028$var$closeContainerStyles = (0, $e255n.xcss)({
    gridArea: 'close'
});
var $6fb230c2df2e6028$var$titleContainerStyles = (0, $e255n.xcss)({
    gridArea: 'title'
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $6fb230c2df2e6028$var$ModalHeader = function ModalHeader(props) {
    var children = props.children, userDefinedTestId = props.testId, _props$hasCloseButton = props.hasCloseButton, hasCloseButton = _props$hasCloseButton === void 0 ? false : _props$hasCloseButton;
    var _useModal = (0, $2td33.useModal)(), hasProvidedOnClose = _useModal.hasProvidedOnClose, onClose = _useModal.onClose, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--header");
    // Only show if an onClose was provided for the modal dialog
    var shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return (0, $74Zh5.jsx)("div", {
        css: $6fb230c2df2e6028$var$headerStyles,
        "data-testid": testId
    }, shouldShowCloseButton ? (0, $74Zh5.jsx)((0, $aDxXf.default), {
        gap: "space.200",
        templateAreas: [
            'title close'
        ],
        xcss: $6fb230c2df2e6028$var$gridStyles
    }, (0, $74Zh5.jsx)((0, $2B91F.default), {
        xcss: $6fb230c2df2e6028$var$titleContainerStyles,
        justifyContent: "start",
        alignItems: "center"
    }, children), (0, $74Zh5.jsx)((0, $2B91F.default), {
        xcss: $6fb230c2df2e6028$var$closeContainerStyles,
        justifyContent: "end"
    }, (0, $74Zh5.jsx)((0, $3aP8P.CloseButton), {
        onClick: onClose,
        testId: modalTestId
    }))) : children);
};
var $6fb230c2df2e6028$export$2e2bcd8739ae039 = $6fb230c2df2e6028$var$ModalHeader;

});
parcelRegister("2B91F", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e4609d211929a23$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $lmNh5 = parcelRequire("lmNh5");

var $e255n = parcelRequire("e255n");
var $1e4609d211929a23$var$justifyContentMap = {
    start: (0, $74Zh5.css)({
        justifyContent: 'start'
    }),
    center: (0, $74Zh5.css)({
        justifyContent: 'center'
    }),
    end: (0, $74Zh5.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $74Zh5.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $74Zh5.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $74Zh5.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $74Zh5.css)({
        justifyContent: 'stretch'
    })
};
var $1e4609d211929a23$var$flexDirectionMap = {
    column: (0, $74Zh5.css)({
        flexDirection: 'column'
    }),
    row: (0, $74Zh5.css)({
        flexDirection: 'row'
    })
};
var $1e4609d211929a23$var$flexWrapMap = {
    wrap: (0, $74Zh5.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $74Zh5.css)({
        flexWrap: 'nowrap'
    })
};
var $1e4609d211929a23$var$alignItemsMap = {
    start: (0, $74Zh5.css)({
        alignItems: 'start'
    }),
    center: (0, $74Zh5.css)({
        alignItems: 'center'
    }),
    baseline: (0, $74Zh5.css)({
        alignItems: 'baseline'
    }),
    end: (0, $74Zh5.css)({
        alignItems: 'end'
    }),
    stretch: (0, $74Zh5.css)({
        alignItems: 'stretch'
    })
};
var $1e4609d211929a23$var$baseStyles = (0, $74Zh5.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $1e4609d211929a23$var$Flex = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, id = _ref.id;
    var resolvedStyles = (0, $e255n.parseXcss)(xcss);
    return (0, $74Zh5.jsx)(Component, {
        id: id,
        role: role,
        className: resolvedStyles.static,
        css: [
            $1e4609d211929a23$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $lmNh5.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $lmNh5.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $lmNh5.spaceStylesMap).rowGap[rowGap],
            alignItems && $1e4609d211929a23$var$alignItemsMap[alignItems],
            direction && $1e4609d211929a23$var$flexDirectionMap[direction],
            justifyContent && $1e4609d211929a23$var$justifyContentMap[justifyContent],
            wrap && $1e4609d211929a23$var$flexWrapMap[wrap]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(resolvedStyles.emotion || [])),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$1e4609d211929a23$var$Flex.displayName = 'Flex';
var $1e4609d211929a23$export$2e2bcd8739ae039 = $1e4609d211929a23$var$Flex;

});
parcelRegister("lmNh5", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", () => $f8e1dffa19542231$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $f8e1dffa19542231$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $f8e1dffa19542231$export$632685d741f3dbbf);
$parcel$export(module.exports, "opacityMap", () => $f8e1dffa19542231$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $f8e1dffa19542231$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $f8e1dffa19542231$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $f8e1dffa19542231$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $f8e1dffa19542231$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $f8e1dffa19542231$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $f8e1dffa19542231$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $f8e1dffa19542231$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "fontMap", () => $f8e1dffa19542231$export$6ffa317d5e70375);
$parcel$export(module.exports, "fontWeightMap", () => $f8e1dffa19542231$export$303e322c6b1ed114);
$parcel$export(module.exports, "fontFamilyMap", () => $f8e1dffa19542231$export$3c7e9587132614b4);
$parcel$export(module.exports, "spaceStylesMap", () => $f8e1dffa19542231$export$bf46c3f9eeafc71f);

var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $4EY2U = parcelRequire("4EY2U");
function $f8e1dffa19542231$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f8e1dffa19542231$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f8e1dffa19542231$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f8e1dffa19542231$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f8e1dffa19542231$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $f8e1dffa19542231$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $f8e1dffa19542231$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $f8e1dffa19542231$export$632685d741f3dbbf = $f8e1dffa19542231$var$_objectSpread($f8e1dffa19542231$var$_objectSpread({}, $f8e1dffa19542231$export$958d0ae7f2977ae4), $f8e1dffa19542231$export$d2dc61f58390201c);
var $f8e1dffa19542231$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $f8e1dffa19542231$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $f8e1dffa19542231$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $f8e1dffa19542231$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $f8e1dffa19542231$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $f8e1dffa19542231$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $f8e1dffa19542231$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $f8e1dffa19542231$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B778C)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $f8e1dffa19542231$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $f8e1dffa19542231$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    // @deprecated
    'border.width.0': "var(--ds-border-width-0, 0px)",
    // @deprecated
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    // @deprecated
    'border.width.outline': "var(--ds-border-width-outline, 2px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $f8e1dffa19542231$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)",
    // @deprecated
    'border.radius': "var(--ds-border-radius, 3px)",
    // @deprecated
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    // @deprecated
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    // @deprecated
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    // @deprecated
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    // @deprecated
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    // @deprecated
    'border.radius.circle': "var(--ds-border-radius-circle, 9999px)"
};
var $f8e1dffa19542231$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $f8e1dffa19542231$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $f8e1dffa19542231$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $f8e1dffa19542231$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $f8e1dffa19542231$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $f8e1dffa19542231$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $f8e1dffa19542231$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $f8e1dffa19542231$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $f8e1dffa19542231$export$e615f061ca585a6c = $f8e1dffa19542231$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $f8e1dffa19542231$export$ca0f9c2de39ffed7(spacingProperty, $f8e1dffa19542231$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $f8e1dffa19542231$export$bf46c3f9eeafc71f = $f8e1dffa19542231$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $f8e1dffa19542231$export$ca0f9c2de39ffed7(spacingProperty, $f8e1dffa19542231$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $f8e1dffa19542231$export$e7af83bafe7f9e63 = $f8e1dffa19542231$export$ca0f9c2de39ffed7('backgroundColor', $f8e1dffa19542231$export$d1d79bf68ac056bd);
var $f8e1dffa19542231$export$3a1bcba60b23d7f0 = $f8e1dffa19542231$export$ca0f9c2de39ffed7('color', $f8e1dffa19542231$export$8473307aa00d6ea1);
var $f8e1dffa19542231$export$45f3f4fe16f9f7d5 = $f8e1dffa19542231$export$ca0f9c2de39ffed7('fontWeight', $f8e1dffa19542231$export$303e322c6b1ed114);
var $f8e1dffa19542231$export$68cc305da27dbaa4 = $f8e1dffa19542231$export$ca0f9c2de39ffed7('fontFamily', $f8e1dffa19542231$export$3c7e9587132614b4);
var $f8e1dffa19542231$export$128f10c238242f83 = $f8e1dffa19542231$export$ca0f9c2de39ffed7('font', $f8e1dffa19542231$export$6ffa317d5e70375);
var $f8e1dffa19542231$export$219d364c0da35ae4 = $f8e1dffa19542231$export$ca0f9c2de39ffed7('font', $f8e1dffa19542231$export$236bfe3a33ef1292);
var $f8e1dffa19542231$export$38845ca010b93505 = $f8e1dffa19542231$export$ca0f9c2de39ffed7('fontWeight', $f8e1dffa19542231$export$855cfd311192d666);
var $f8e1dffa19542231$export$ff257d957d48c421 = $f8e1dffa19542231$export$ca0f9c2de39ffed7((0, $4EY2U.CURRENT_SURFACE_CSS_VAR), $f8e1dffa19542231$export$41a358c9c2356760);
var $f8e1dffa19542231$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $f8e1dffa19542231$export$41a358c9c2356760[color] !== undefined;
};
var $f8e1dffa19542231$export$7001ce64d9ff7c7f = $f8e1dffa19542231$export$ca0f9c2de39ffed7('font', $f8e1dffa19542231$export$b805719bc8cb376);

});
parcelRegister("4EY2U", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $364979b5125caa6f$export$9d7b58831ae93caa);
var $364979b5125caa6f$export$4ef52930e33717cd = 'data-theme';
var $364979b5125caa6f$export$a00eac3f8684bcd0 = 'data-color-mode';
var $364979b5125caa6f$export$2112803007239c61 = 'data-contrast-mode';
var $364979b5125caa6f$export$352e418ed5b6193a = 'data-custom-theme';
var $364979b5125caa6f$export$6f0c6fb8c80fcc92 = 'ds';
var $364979b5125caa6f$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $364979b5125caa6f$export$dddac1532e822863 = "--".concat($364979b5125caa6f$export$6f0c6fb8c80fcc92, "-token-not-found");
var $364979b5125caa6f$export$9d7b58831ae93caa = "--".concat($364979b5125caa6f$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("e255n", function(module, exports) {
$parcel$export(module.exports, "parseXcss", () => $a37532879cf89adc$export$a9c84988c8f81f2d);
$parcel$export(module.exports, "xcss", () => $a37532879cf89adc$export$f6c783d06584602c);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $74Zh5 = parcelRequire("74Zh5");

var $lmNh5 = parcelRequire("lmNh5");

var $3ZMUU = parcelRequire("3ZMUU");
function $a37532879cf89adc$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $a37532879cf89adc$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $a37532879cf89adc$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $a37532879cf89adc$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $a37532879cf89adc$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $a37532879cf89adc$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $a37532879cf89adc$export$9a199fbafee0014e = {
    backgroundColor: (0, $lmNh5.backgroundColorMap),
    blockSize: (0, $lmNh5.dimensionMap),
    borderBlockColor: (0, $lmNh5.borderColorMap),
    borderBlockEndColor: (0, $lmNh5.borderColorMap),
    borderBlockEndWidth: (0, $lmNh5.borderWidthMap),
    borderBlockStartColor: (0, $lmNh5.borderColorMap),
    borderBlockStartWidth: (0, $lmNh5.borderWidthMap),
    borderBlockWidth: (0, $lmNh5.borderWidthMap),
    borderBottomColor: (0, $lmNh5.borderColorMap),
    borderBottomLeftRadius: (0, $lmNh5.borderRadiusMap),
    borderBottomRightRadius: (0, $lmNh5.borderRadiusMap),
    borderBottomWidth: (0, $lmNh5.borderWidthMap),
    borderColor: (0, $lmNh5.borderColorMap),
    borderEndEndRadius: (0, $lmNh5.borderRadiusMap),
    borderEndStartRadius: (0, $lmNh5.borderRadiusMap),
    borderInlineColor: (0, $lmNh5.borderColorMap),
    borderInlineEndColor: (0, $lmNh5.borderColorMap),
    borderInlineEndWidth: (0, $lmNh5.borderWidthMap),
    borderInlineStartColor: (0, $lmNh5.borderColorMap),
    borderInlineStartWidth: (0, $lmNh5.borderWidthMap),
    borderInlineWidth: (0, $lmNh5.borderWidthMap),
    borderLeftColor: (0, $lmNh5.borderColorMap),
    borderLeftWidth: (0, $lmNh5.borderWidthMap),
    borderRadius: (0, $lmNh5.borderRadiusMap),
    borderRightColor: (0, $lmNh5.borderColorMap),
    borderRightWidth: (0, $lmNh5.borderWidthMap),
    borderStartEndRadius: (0, $lmNh5.borderRadiusMap),
    borderStartStartRadius: (0, $lmNh5.borderRadiusMap),
    borderTopColor: (0, $lmNh5.borderColorMap),
    borderTopLeftRadius: (0, $lmNh5.borderRadiusMap),
    borderTopRightRadius: (0, $lmNh5.borderRadiusMap),
    borderTopWidth: (0, $lmNh5.borderWidthMap),
    borderWidth: (0, $lmNh5.borderWidthMap),
    bottom: (0, $lmNh5.allSpaceMap),
    boxShadow: (0, $lmNh5.shadowMap),
    color: (0, $lmNh5.textColorMap),
    columnGap: (0, $lmNh5.positiveSpaceMap),
    font: (0, $lmNh5.fontMap),
    fontFamily: (0, $lmNh5.fontFamilyMap),
    fontWeight: (0, $lmNh5.fontWeightMap),
    gap: (0, $lmNh5.positiveSpaceMap),
    height: (0, $lmNh5.dimensionMap),
    inlineSize: (0, $lmNh5.dimensionMap),
    inset: (0, $lmNh5.allSpaceMap),
    insetBlock: (0, $lmNh5.allSpaceMap),
    insetBlockEnd: (0, $lmNh5.allSpaceMap),
    insetBlockStart: (0, $lmNh5.allSpaceMap),
    insetInline: (0, $lmNh5.allSpaceMap),
    insetInlineEnd: (0, $lmNh5.allSpaceMap),
    insetInlineStart: (0, $lmNh5.allSpaceMap),
    left: (0, $lmNh5.allSpaceMap),
    margin: (0, $lmNh5.allSpaceMap),
    marginBlock: (0, $lmNh5.allSpaceMap),
    marginBlockEnd: (0, $lmNh5.allSpaceMap),
    marginBlockStart: (0, $lmNh5.allSpaceMap),
    marginBottom: (0, $lmNh5.allSpaceMap),
    marginInline: (0, $lmNh5.allSpaceMap),
    marginInlineEnd: (0, $lmNh5.allSpaceMap),
    marginInlineStart: (0, $lmNh5.allSpaceMap),
    marginLeft: (0, $lmNh5.allSpaceMap),
    marginRight: (0, $lmNh5.allSpaceMap),
    marginTop: (0, $lmNh5.allSpaceMap),
    maxBlockSize: (0, $lmNh5.dimensionMap),
    maxHeight: (0, $lmNh5.dimensionMap),
    maxInlineSize: (0, $lmNh5.dimensionMap),
    maxWidth: (0, $lmNh5.dimensionMap),
    minBlockSize: (0, $lmNh5.dimensionMap),
    minHeight: (0, $lmNh5.dimensionMap),
    minInlineSize: (0, $lmNh5.dimensionMap),
    minWidth: (0, $lmNh5.dimensionMap),
    opacity: (0, $lmNh5.opacityMap),
    outlineColor: (0, $lmNh5.borderColorMap),
    outlineOffset: (0, $lmNh5.allSpaceMap),
    outlineWidth: (0, $lmNh5.borderWidthMap),
    padding: (0, $lmNh5.positiveSpaceMap),
    paddingBlock: (0, $lmNh5.positiveSpaceMap),
    paddingBlockEnd: (0, $lmNh5.positiveSpaceMap),
    paddingBlockStart: (0, $lmNh5.positiveSpaceMap),
    paddingBottom: (0, $lmNh5.positiveSpaceMap),
    paddingInline: (0, $lmNh5.positiveSpaceMap),
    paddingInlineEnd: (0, $lmNh5.positiveSpaceMap),
    paddingInlineStart: (0, $lmNh5.positiveSpaceMap),
    paddingLeft: (0, $lmNh5.positiveSpaceMap),
    paddingRight: (0, $lmNh5.positiveSpaceMap),
    paddingTop: (0, $lmNh5.positiveSpaceMap),
    right: (0, $lmNh5.allSpaceMap),
    rowGap: (0, $lmNh5.positiveSpaceMap),
    top: (0, $lmNh5.allSpaceMap),
    width: (0, $lmNh5.dimensionMap),
    zIndex: (0, $lmNh5.layerMap)
};
var $a37532879cf89adc$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $a37532879cf89adc$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU.env) === 'object' && false;
};
var $a37532879cf89adc$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $a37532879cf89adc$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $a37532879cf89adc$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($a37532879cf89adc$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && $a37532879cf89adc$var$safeSelectors.test(key)) {
            styleObj[key] = $a37532879cf89adc$var$_transformStyles(value);
            return;
        }
        if ($a37532879cf89adc$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($a37532879cf89adc$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $a37532879cf89adc$export$9a199fbafee0014e)) return;
        var tokenValue = $a37532879cf89adc$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $a37532879cf89adc$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $a37532879cf89adc$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $a37532879cf89adc$var$uniqueSymbol, (0, $74Zh5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $a37532879cf89adc$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $a37532879cf89adc$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $a37532879cf89adc$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$a37532879cf89adc$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $a37532879cf89adc$export$f6c783d06584602c(style) {
    return $a37532879cf89adc$var$baseXcss(style);
}

});


parcelRegister("aDxXf", function(module, exports) {
$parcel$export(module.exports, "default", () => $7be7e28e6f379df4$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $lmNh5 = parcelRequire("lmNh5");

var $e255n = parcelRequire("e255n");
var $7be7e28e6f379df4$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
var $7be7e28e6f379df4$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
var $7be7e28e6f379df4$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
var $7be7e28e6f379df4$var$justifyContentMap = {
    start: (0, $74Zh5.css)({
        justifyContent: 'start'
    }),
    center: (0, $74Zh5.css)({
        justifyContent: 'center'
    }),
    end: (0, $74Zh5.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $74Zh5.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $74Zh5.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $74Zh5.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $74Zh5.css)({
        justifyContent: 'stretch'
    })
};
var $7be7e28e6f379df4$var$justifyItemsMap = {
    start: (0, $74Zh5.css)({
        justifyItems: 'start'
    }),
    center: (0, $74Zh5.css)({
        justifyItems: 'center'
    }),
    end: (0, $74Zh5.css)({
        justifyItems: 'end'
    }),
    stretch: (0, $74Zh5.css)({
        justifyItems: 'stretch'
    })
};
var $7be7e28e6f379df4$var$alignContentMap = {
    start: (0, $74Zh5.css)({
        alignContent: 'start'
    }),
    center: (0, $74Zh5.css)({
        alignContent: 'center'
    }),
    end: (0, $74Zh5.css)({
        alignContent: 'end'
    }),
    'space-between': (0, $74Zh5.css)({
        alignContent: 'space-between'
    }),
    'space-around': (0, $74Zh5.css)({
        alignContent: 'space-around'
    }),
    'space-evenly': (0, $74Zh5.css)({
        alignContent: 'space-evenly'
    }),
    stretch: (0, $74Zh5.css)({
        alignContent: 'stretch'
    })
};
var $7be7e28e6f379df4$var$alignItemsMap = {
    start: (0, $74Zh5.css)({
        alignItems: 'start'
    }),
    center: (0, $74Zh5.css)({
        alignItems: 'center'
    }),
    baseline: (0, $74Zh5.css)({
        alignItems: 'baseline'
    }),
    end: (0, $74Zh5.css)({
        alignItems: 'end'
    })
};
var $7be7e28e6f379df4$var$baseStyles = (0, $74Zh5.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: "var(".concat($7be7e28e6f379df4$var$gridTemplateAreasVar, ")"),
    gridTemplateColumns: "var(".concat($7be7e28e6f379df4$var$gridTemplateColumnsVar, ")"),
    gridTemplateRows: "var(".concat($7be7e28e6f379df4$var$gridTemplateRowsVar, ")")
});
var $7be7e28e6f379df4$var$gridAutoFlowMap = {
    row: (0, $74Zh5.css)({
        gridAutoFlow: 'row'
    }),
    column: (0, $74Zh5.css)({
        gridAutoFlow: 'column'
    }),
    dense: (0, $74Zh5.css)({
        gridAutoFlow: 'dense'
    }),
    'row dense': (0, $74Zh5.css)({
        gridAutoFlow: 'row dense'
    }),
    'column dense': (0, $74Zh5.css)({
        gridAutoFlow: 'column dense'
    })
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ var $7be7e28e6f379df4$var$Grid = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignItems, alignContent = _ref.alignContent, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, id = _ref.id, role = _ref.role, testId = _ref.testId, autoFlow = _ref.autoFlow, gridTemplateAreas = _ref.templateAreas, gridTemplateRows = _ref.templateRows, gridTemplateColumns = _ref.templateColumns, xcss = _ref.xcss;
    var Component = as || 'div';
    var resolvedStyles = (0, $e255n.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ var style = (0, $5FkrB.useMemo)(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $7be7e28e6f379df4$var$gridTemplateAreasVar, gridTemplateAreas ? gridTemplateAreas.map(function(str) {
            return "\"".concat(str, "\"");
        }).join('\n') || 'initial' : 'initial'), $7be7e28e6f379df4$var$gridTemplateColumnsVar, gridTemplateColumns || 'initial'), $7be7e28e6f379df4$var$gridTemplateRowsVar, gridTemplateRows || 'initial');
    }, [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return (0, $74Zh5.jsx)(Component, {
        id: id,
        role: role,
        style: style,
        className: resolvedStyles.static,
        css: [
            $7be7e28e6f379df4$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $lmNh5.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $lmNh5.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $lmNh5.spaceStylesMap).rowGap[rowGap],
            alignItems && $7be7e28e6f379df4$var$alignItemsMap[alignItems],
            alignContent && $7be7e28e6f379df4$var$alignContentMap[alignContent],
            justifyContent && $7be7e28e6f379df4$var$justifyContentMap[justifyContent],
            autoFlow && $7be7e28e6f379df4$var$gridAutoFlowMap[autoFlow]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(resolvedStyles.emotion || [])),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$7be7e28e6f379df4$var$Grid.displayName = 'Grid';
var $7be7e28e6f379df4$export$2e2bcd8739ae039 = $7be7e28e6f379df4$var$Grid;

});

parcelRegister("3aP8P", function(module, exports) {
$parcel$export(module.exports, "CloseButton", () => $24f9f9e3d473509c$export$de65de8213222d10);

var $5FkrB = parcelRequire("5FkrB");

var $kxUqQ = parcelRequire("kxUqQ");

var $dQOjl = parcelRequire("dQOjl");
var $24f9f9e3d473509c$export$de65de8213222d10 = function CloseButton(_ref) {
    var label = _ref.label, onClick = _ref.onClick, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kxUqQ.default), {
        testId: testId && "".concat(testId, "--close-button"),
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dQOjl))),
        label: label || 'Close Modal',
        onClick: onClick
    });
};

});
parcelRegister("kxUqQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef52a9f3c2b023c6$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $5GRVe = parcelRequire("5GRVe");

var $5mMUQ = parcelRequire("5mMUQ");

var $9KR88 = parcelRequire("9KR88");

var $5ZsYZ = parcelRequire("5ZsYZ");

var $fxDXf = parcelRequire("fxDXf");

var $7zyz1 = parcelRequire("7zyz1");
var $ef52a9f3c2b023c6$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $ef52a9f3c2b023c6$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $ef52a9f3c2b023c6$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $ef52a9f3c2b023c6$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $ef52a9f3c2b023c6$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5ZsYZ.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fxDXf.default), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7zyz1.default), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9KR88.default), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5mMUQ.default), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5ZsYZ.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $5GRVe.default)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fxDXf.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7zyz1.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9KR88.default), null, label)));
    });
}));
$ef52a9f3c2b023c6$var$IconButton.displayName = 'IconButton';
var $ef52a9f3c2b023c6$export$2e2bcd8739ae039 = $ef52a9f3c2b023c6$var$IconButton;

});
parcelRegister("5GRVe", function(module, exports) {
$parcel$export(module.exports, "default", () => $424ab3c86c00d660$export$2e2bcd8739ae039);
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $424ab3c86c00d660$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("5mMUQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e84f37e1f856085$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $f8h2T = parcelRequire("f8h2T");

var $6qCqe = parcelRequire("6qCqe");

var $Bg0zQ = parcelRequire("Bg0zQ");

var $fGJry = parcelRequire("fGJry");

var $4hd7w = parcelRequire("4hd7w");

var $ZdqJG = parcelRequire("ZdqJG");
var $eQzrx = parcelRequire("eQzrx");

var $3SFik = parcelRequire("3SFik");

var $6bqMl = parcelRequire("6bqMl");

var $H74DA = parcelRequire("H74DA");

var $esE7Z = parcelRequire("esE7Z");

var $5sp2R = parcelRequire("5sp2R");

var $2hND8 = parcelRequire("2hND8");

var $eqvOo = parcelRequire("eqvOo");

var $37Jbg = parcelRequire("37Jbg");
function $3e84f37e1f856085$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3e84f37e1f856085$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3e84f37e1f856085$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3e84f37e1f856085$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3e84f37e1f856085$var$tooltipZIndex = (0, $H74DA.layers).tooltip();
var $3e84f37e1f856085$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "20.0.4"
};
// Inverts motion direction
var $3e84f37e1f856085$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $3e84f37e1f856085$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $3e84f37e1f856085$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $eqvOo.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $6qCqe.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $6qCqe.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn;
    var tooltipPosition = position === 'mouse' ? mousePosition : position;
    var onShowHandler = (0, $f8h2T.usePlatformLeafSyntheticEventHandler)($3e84f37e1f856085$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $3e84f37e1f856085$var$analyticsAttributes));
    var onHideHandler = (0, $f8h2T.usePlatformLeafSyntheticEventHandler)($3e84f37e1f856085$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $3e84f37e1f856085$var$analyticsAttributes));
    var apiRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $5FkrB.useRef)(null);
    var containerRef = (0, $5FkrB.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $5FkrB.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $fGJry.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $fGJry.default)(onShowHandler);
    var onHideHandlerStable = (0, $fGJry.default)(onHideHandler);
    var delayStable = (0, $fGJry.default)(delay);
    var canAppearStable = (0, $fGJry.default)(canAppear);
    var hasCalledShowHandler = (0, $5FkrB.useRef)(false);
    var start = (0, $5FkrB.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $5FkrB.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $5FkrB.useRef)(false);
    (0, $5FkrB.useEffect)(function() {
        return (0, $esE7Z.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $5FkrB.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        var api = (0, $5sp2R.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $Bg0zQ.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $5FkrB.useEffect)(function() {
        if (state === 'hide') return 0, $6qCqe.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $37Jbg.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === 'mouse' ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $37Jbg.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $5FkrB.useCallback)(function() {
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $5FkrB.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    (0, $4hd7w.useNotifyOpenLayerObserver)({
        isOpen: shouldRenderTooltipPopup
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current4;
        if (position === 'mouse' && (_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.mousePosition) {
            var _apiRef$current5;
            return (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 ? void 0 : _apiRef$current5.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $2hND8.default)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $5FkrB.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children($3e84f37e1f856085$var$_objectSpread($3e84f37e1f856085$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6bqMl.default), {
        zIndex: $3e84f37e1f856085$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3SFik.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === 'mouse' ? undefined : $3e84f37e1f856085$var$invertedDirection[$3e84f37e1f856085$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ZdqJG.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $eQzrx.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $3e84f37e1f856085$var$_objectSpread($3e84f37e1f856085$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$3e84f37e1f856085$var$Tooltip.displayName = 'Tooltip';
var $3e84f37e1f856085$export$2e2bcd8739ae039 = $3e84f37e1f856085$var$Tooltip;

});
parcelRegister("f8h2T", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $b044d3486e251a8e$export$1a04351537078b55);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $h0OAL = parcelRequire("h0OAL");

var $b6wQg = parcelRequire("b6wQg");
function $b044d3486e251a8e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b044d3486e251a8e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b044d3486e251a8e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b044d3486e251a8e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b044d3486e251a8e$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $h0OAL.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $b6wQg.useTrackedRef)(analyticsData);
    var fnRef = (0, $b6wQg.useTrackedRef)(fn);
    var handler = (0, $5FkrB.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $b044d3486e251a8e$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("Bg0zQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $06ffdfbb98a81f21$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $5fJka = parcelRequire("5fJka");

var $3Wvr5 = parcelRequire("3Wvr5");
function $06ffdfbb98a81f21$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $3Wvr5.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled && (0, $5fJka.fg)('platform_only_attach_escape_handler_on_view')) return;
        return (0, $7QpUe.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("3Wvr5", function(module, exports) {
$parcel$export(module.exports, "ESCAPE", () => $2def2c5ccca2ee64$export$2bb790b9008907b4);
/**
 * Character key codes which can be used in keyboard events.
 */ var $2def2c5ccca2ee64$export$390330c10ff2b9a1 = 'ArrowUp';
var $2def2c5ccca2ee64$export$a80636c6f41931fe = 'ArrowDown';
var $2def2c5ccca2ee64$export$4af703091671bc = 'Home';
var $2def2c5ccca2ee64$export$e2bc30913faa5db7 = 'End';
var $2def2c5ccca2ee64$export$10f6869ed0a7d75b = 'Tab';
var $2def2c5ccca2ee64$export$8152f929a25a0ff4 = 'Enter';
var $2def2c5ccca2ee64$export$e51a3576c045c8d5 = 'Space';
var $2def2c5ccca2ee64$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("fGJry", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6be075dbc35dcc6$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $b6be075dbc35dcc6$export$2e2bcd8739ae039(value) {
    var ref = (0, $5FkrB.useRef)(value);
    (0, $5FkrB.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("4hd7w", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $31d2ed5c6099e068$export$469bb693f11edc7f);

var $5FkrB = parcelRequire("5FkrB");

var $9YIly = parcelRequire("9YIly");

var $is4d5 = parcelRequire("is4d5");
function $31d2ed5c6099e068$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $9YIly.OpenLayerObserverContext));
    var namespace = (0, $is4d5.useOpenLayerObserverNamespace)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose
    ]);
}

});
parcelRegister("9YIly", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $743c1dfb46a6e2e8$export$5fbf4d7fae6cdc00);

var $5FkrB = parcelRequire("5FkrB");
var $743c1dfb46a6e2e8$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});

parcelRegister("is4d5", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $d6ee1b8a7dfb219a$export$1d57e79091cc3046);

var $5FkrB = parcelRequire("5FkrB");

var $lDg0w = parcelRequire("lDg0w");
function $d6ee1b8a7dfb219a$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $lDg0w.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("lDg0w", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $fbf9a837d172e763$export$644a49f3b8c50fcd);

var $5FkrB = parcelRequire("5FkrB");
var $fbf9a837d172e763$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});



parcelRegister("3SFik", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $2d36727918589a7b$export$badac9ada3a0bdf9);

var $fC8ib = parcelRequire("fC8ib");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $lsgol = parcelRequire("lsgol");

var $gXYDi = parcelRequire("gXYDi");

// Export types from PopperJS / React Popper
var $2d36727918589a7b$var$viewportPadding = 5;
var $2d36727918589a7b$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $2d36727918589a7b$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $2d36727918589a7b$var$defaultChildrenFn() {
    return null;
}
var $2d36727918589a7b$var$defaultOffset = [
    0,
    8
];
function $2d36727918589a7b$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $2d36727918589a7b$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $2d36727918589a7b$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $5FkrB.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $2d36727918589a7b$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $gXYDi.getMaxSizeModifiers)({
            viewportPadding: $2d36727918589a7b$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($2d36727918589a7b$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $5FkrB.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $lsgol.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("gXYDi", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", () => $c5a130760dfad3e7$export$6d8c2b45c99d6e3f);

var $iYJcE = parcelRequire("iYJcE");
function $c5a130760dfad3e7$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});


parcelRegister("esE7Z", function(module, exports) {
$parcel$export(module.exports, "register", () => $a872cec7ab1db00b$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $7QpUe = parcelRequire("7QpUe");
var $a872cec7ab1db00b$var$registrations = new Set();
var $a872cec7ab1db00b$var$cleanupEndEventListeners = null;
function $a872cec7ab1db00b$var$onDragStart() {
    if ($a872cec7ab1db00b$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $a872cec7ab1db00b$var$cleanupEndEventListeners = (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragend',
            listener: $a872cec7ab1db00b$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $a872cec7ab1db00b$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $a872cec7ab1db00b$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($a872cec7ab1db00b$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $a872cec7ab1db00b$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $a872cec7ab1db00b$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $a872cec7ab1db00b$var$cleanupEndEventListeners = null;
    var clone = Array.from($a872cec7ab1db00b$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $a872cec7ab1db00b$var$bindStartEvents() {
    return (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $a872cec7ab1db00b$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $a872cec7ab1db00b$var$onDragStart
        }
    ]);
}
var $a872cec7ab1db00b$var$cleanupStartEventListeners = null;
function $a872cec7ab1db00b$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$a872cec7ab1db00b$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $a872cec7ab1db00b$var$cleanupStartEventListeners = $a872cec7ab1db00b$var$bindStartEvents();
    $a872cec7ab1db00b$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $a872cec7ab1db00b$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $a872cec7ab1db00b$var$registrations.delete(registration);
        if ($a872cec7ab1db00b$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $a872cec7ab1db00b$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $a872cec7ab1db00b$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("5sp2R", function(module, exports) {
$parcel$export(module.exports, "show", () => $3f92febc2f10d6a2$export$57bf213be019eeb0);

var $gqyYV = parcelRequire("gqyYV");
// This file is a singleton for managing tooltips
var $3f92febc2f10d6a2$var$active = null;
function $3f92febc2f10d6a2$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($3f92febc2f10d6a2$var$active && $3f92febc2f10d6a2$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $gqyYV.clearScheduled)();
            $3f92febc2f10d6a2$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $gqyYV.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $gqyYV.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $gqyYV.scheduleTimeout)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($3f92febc2f10d6a2$var$active && $3f92febc2f10d6a2$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($3f92febc2f10d6a2$var$active) {
            (0, $gqyYV.clearScheduled)();
            $3f92febc2f10d6a2$var$active.entry.hide({
                isImmediate: true
            });
            $3f92febc2f10d6a2$var$active.entry.done();
            $3f92febc2f10d6a2$var$active = null;
        }
        // this tooltip is now the active tooltip
        $3f92febc2f10d6a2$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $gqyYV.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("gqyYV", function(module, exports) {
$parcel$export(module.exports, "clearScheduled", () => $bf5a35ac4e2f18a4$export$eaf678f6f93f5250);
$parcel$export(module.exports, "scheduleTimeout", () => $bf5a35ac4e2f18a4$export$5f4d6617421d489b);
var $bf5a35ac4e2f18a4$var$delayId = null;
function $bf5a35ac4e2f18a4$export$eaf678f6f93f5250() {
    if ($bf5a35ac4e2f18a4$var$delayId != null) {
        window.clearTimeout($bf5a35ac4e2f18a4$var$delayId);
        $bf5a35ac4e2f18a4$var$delayId = null;
    }
}
function $bf5a35ac4e2f18a4$export$5f4d6617421d489b(fn, delay) {
    $bf5a35ac4e2f18a4$export$eaf678f6f93f5250();
    $bf5a35ac4e2f18a4$var$delayId = window.setTimeout(function() {
        $bf5a35ac4e2f18a4$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("2hND8", function(module, exports) {
$parcel$export(module.exports, "default", () => $1aa3aad41915ad32$export$2e2bcd8739ae039);

var $hbl7m = parcelRequire("hbl7m");
function $1aa3aad41915ad32$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $hbl7m.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});

parcelRegister("eqvOo", function(module, exports) {
$parcel$export(module.exports, "default", () => $a80c2b91439509b8$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $jY1dw = parcelRequire("jY1dw");
var $6YKKQ = parcelRequire("6YKKQ");

var $dSRcG = parcelRequire("dSRcG");

var $3GpPz = parcelRequire("3GpPz");
function $a80c2b91439509b8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a80c2b91439509b8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a80c2b91439509b8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a80c2b91439509b8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a80c2b91439509b8$var$baseStyles = null;
var $a80c2b91439509b8$var$truncateStyles = null;
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $a80c2b91439509b8$var$TooltipContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $5FkrB.createElement((0, $3GpPz.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $jY1dw.default)([
            "_2rko1sit _11c8dcr7 _vchhusvi _p12fp3fh _bfhkpioe _syaz1i9p _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        style: $a80c2b91439509b8$var$_objectSpread($a80c2b91439509b8$var$_objectSpread({}, style), {}, {
            "--_yr7xfv": (0, $6YKKQ.default)("var(--ds-background-neutral-bold, ".concat((0, $dSRcG.N800), ")")),
            "--_ywovvi": (0, $6YKKQ.default)("var(--ds-text-inverse, ".concat((0, $dSRcG.N0), ")"))
        })
    }, children);
});
$a80c2b91439509b8$var$TooltipContainer.displayName = 'TooltipContainer';
var $a80c2b91439509b8$export$2e2bcd8739ae039 = $a80c2b91439509b8$var$TooltipContainer;

});
parcelRegister("3GpPz", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ae954d03fcd170a$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $H74DA = parcelRequire("H74DA");
function $2ae954d03fcd170a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2ae954d03fcd170a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2ae954d03fcd170a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2ae954d03fcd170a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2ae954d03fcd170a$var$VAR_PRIMITIVE_ZINDEX = 'tooltipPrimitiveZindex';
var $2ae954d03fcd170a$var$primitiveStyles = (0, $74Zh5.css)({
    zindex: "var(".concat($2ae954d03fcd170a$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
/**
 * The lower level component for rendering a tooltip.
 */ var $2ae954d03fcd170a$var$TooltipPrimitive = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $2ae954d03fcd170a$var$_objectSpread($2ae954d03fcd170a$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $2ae954d03fcd170a$var$VAR_PRIMITIVE_ZINDEX, (0, $H74DA.layers).tooltip()));
    return (0, $74Zh5.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $74Zh5.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $2ae954d03fcd170a$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$2ae954d03fcd170a$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $2ae954d03fcd170a$export$2e2bcd8739ae039 = $2ae954d03fcd170a$var$TooltipPrimitive;

});


parcelRegister("37Jbg", function(module, exports) {
$parcel$export(module.exports, "getMousePosition", () => $24651280b677bee9$export$642213d516a9b928);
function $24651280b677bee9$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("9KR88", function(module, exports) {
$parcel$export(module.exports, "default", () => $71a19f81200847a5$export$2e2bcd8739ae039);
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden

var $5FkrB = parcelRequire("5FkrB");

var $jY1dw = parcelRequire("jY1dw");
var $71a19f81200847a5$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $71a19f81200847a5$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $jY1dw.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c"
        ])
    }, children);
};
var $71a19f81200847a5$export$2e2bcd8739ae039 = $71a19f81200847a5$var$VisuallyHidden;

});

parcelRegister("5ZsYZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $45c9219f22f72e10$export$2e2bcd8739ae039);
/* button-base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $jY1dw = parcelRequire("jY1dw");

var $5FkrB = parcelRequire("5FkrB");

var $lJnLZ = parcelRequire("lJnLZ");

var $5GRVe = parcelRequire("5GRVe");

var $4KvIl = parcelRequire("4KvIl");

var $i7Fu5 = parcelRequire("i7Fu5");

var $legyX = parcelRequire("legyX");

var $hp0B0 = parcelRequire("hp0B0");

var $9KR88 = parcelRequire("9KR88");

var $lLoMC = parcelRequire("lLoMC");

var $a11no = parcelRequire("a11no");

var $13yI1 = parcelRequire("13yI1");
var $45c9219f22f72e10$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $45c9219f22f72e10$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $45c9219f22f72e10$var$LOADING_LABEL = ', Loading';
var $45c9219f22f72e10$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhk1fvb _syaz1lh4 _aetrglyw _irr31fvb _30l31lh4 _1di61fvb _9h8h1lh4",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko14q2",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $45c9219f22f72e10$var$defaultStyles = {
    root: "_bfhk1j54 _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhksm61 _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr3yw9d _30l310s3 _1di6ih13 _9h8h10s3",
    interactiveRefreshed: "_irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
var $45c9219f22f72e10$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $45c9219f22f72e10$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $45c9219f22f72e10$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $45c9219f22f72e10$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $45c9219f22f72e10$var$subtleStyles = {
    root: "_bfhkqtfy _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhkqtfy _syaz1gjq _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    interactiveRefreshed: "_irr34mfv _30l31gjq _1di619qy _9h8h1gjq"
};
var $45c9219f22f72e10$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _30l31pke _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $45c9219f22f72e10$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $45c9219f22f72e10$var$_excluded);
    var localRef = (0, $5FkrB.useRef)(null);
    var splitButtonContext = (0, $lLoMC.useSplitButtonContext)();
    var loadingLabelId = (0, $i7Fu5.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton && (0, $legyX.fg)('platform-component-visual-refresh') ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $4KvIl.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $45c9219f22f72e10$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $hp0B0.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $5GRVe.default)([
            localRef,
            ref
        ]),
        xcss: (0, $lJnLZ.cx)($45c9219f22f72e10$var$styles.base, appearance === 'default' && ((0, $legyX.fg)('platform-component-visual-refresh') ? $45c9219f22f72e10$var$defaultStyles.rootRefreshed : $45c9219f22f72e10$var$defaultStyles.root), appearance === 'default' && isInteractive && ((0, $legyX.fg)('platform-component-visual-refresh') ? $45c9219f22f72e10$var$defaultStyles.interactiveRefreshed : $45c9219f22f72e10$var$defaultStyles.interactive), appearance === 'primary' && $45c9219f22f72e10$var$primaryStyles.root, appearance === 'primary' && isInteractive && $45c9219f22f72e10$var$primaryStyles.interactive, appearance === 'warning' && $45c9219f22f72e10$var$warningStyles.root, appearance === 'warning' && isInteractive && $45c9219f22f72e10$var$warningStyles.interactive, appearance === 'danger' && $45c9219f22f72e10$var$dangerStyles.root, appearance === 'danger' && isInteractive && $45c9219f22f72e10$var$dangerStyles.interactive, appearance === 'discovery' && $45c9219f22f72e10$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $45c9219f22f72e10$var$discoveryStyles.interactive, appearance === 'subtle' && ((0, $legyX.fg)('platform-component-visual-refresh') ? $45c9219f22f72e10$var$subtleStyles.rootRefreshed : $45c9219f22f72e10$var$subtleStyles.root), appearance === 'subtle' && isInteractive && ((0, $legyX.fg)('platform-component-visual-refresh') ? $45c9219f22f72e10$var$subtleStyles.interactiveRefreshed : $45c9219f22f72e10$var$subtleStyles.interactive), $45c9219f22f72e10$var$styles.linkDecorationUnset, isSelected && ((0, $legyX.fg)('platform-component-visual-refresh') ? $45c9219f22f72e10$var$selectedStyles.rootRefreshed : $45c9219f22f72e10$var$selectedStyles.root), isSelected && isSplitButton && $45c9219f22f72e10$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $45c9219f22f72e10$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $45c9219f22f72e10$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $45c9219f22f72e10$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $45c9219f22f72e10$var$selectedStyles.discovery, isDisabled && $45c9219f22f72e10$var$styles.disabled, isCircle && !isSplitButton && $45c9219f22f72e10$var$styles.circle, spacing === 'compact' && $45c9219f22f72e10$var$styles.spacingCompact, hasIconBefore && $45c9219f22f72e10$var$styles.buttonIconBefore, shouldFitContainer && $45c9219f22f72e10$var$styles.fullWidth, hasIconAfter && $45c9219f22f72e10$var$styles.buttonIconAfter, isIconButton && $45c9219f22f72e10$var$styles.iconButton, isIconButton && spacing === 'compact' && $45c9219f22f72e10$var$styles.iconButtonCompact, isLoading && $45c9219f22f72e10$var$styles.loading, isSplitButton && $45c9219f22f72e10$var$styles.splitButton, isNavigationSplitButton && $45c9219f22f72e10$var$styles.navigationSplitButton),
        isDisabled: isEffectivelyDisabled,
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($45c9219f22f72e10$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $a11no.default)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        className: (0, $jY1dw.default)([
            $45c9219f22f72e10$var$styles.loadingOverlay
        ])
    }, (0, $13yI1.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9KR88.default), {
        id: loadingLabelId
    }, $45c9219f22f72e10$var$LOADING_LABEL)));
});
var $45c9219f22f72e10$export$2e2bcd8739ae039 = $45c9219f22f72e10$var$ButtonBase;

});
parcelRegister("lJnLZ", function(module, exports) {
$parcel$export(module.exports, "cx", () => $fd203dcc00df7a72$export$a274e22fb40f762e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("5FkrB");


var $3MXhF = parcelRequire("3MXhF");
var $fd203dcc00df7a72$var$_createStrictAPI = (0, $3MXhF.createStrictAPI)(), $fd203dcc00df7a72$var$XCSSProp = $fd203dcc00df7a72$var$_createStrictAPI.XCSSProp, $fd203dcc00df7a72$export$dbf350e5966cf602 = $fd203dcc00df7a72$var$_createStrictAPI.css, $fd203dcc00df7a72$export$eb1ecd84a24ee424 = $fd203dcc00df7a72$var$_createStrictAPI.cssMap, $fd203dcc00df7a72$export$a274e22fb40f762e = $fd203dcc00df7a72$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means products only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 
});
parcelRegister("3MXhF", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", () => $2c23d756c2f334c0$export$39716b4af53f4ad);

var $3b7RK = parcelRequire("3b7RK");

var $8ZA5t = parcelRequire("8ZA5t");
function $2c23d756c2f334c0$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $3b7RK.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $3b7RK.createStrictSetupError)();
        },
        cx: $8ZA5t.cx,
        XCSSProp () {
            throw (0, $3b7RK.createStrictSetupError)();
        }
    };
}

});
parcelRegister("3b7RK", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", () => $2508803491060c17$export$c4df1cb0c2b4d77c);
const $2508803491060c17$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $2508803491060c17$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("8ZA5t", function(module, exports) {
$parcel$export(module.exports, "cx", () => $68c00368982c5264$export$a274e22fb40f762e);

var $jY1dw = parcelRequire("jY1dw");
const $68c00368982c5264$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $jY1dw.default)(actualStyles);
};

});



parcelRegister("4KvIl", function(module, exports) {
$parcel$export(module.exports, "default", () => $37540f1c2a76f1e4$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $37540f1c2a76f1e4$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $5FkrB.useRef)(true);
    (0, $5FkrB.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("i7Fu5", function(module, exports) {
$parcel$export(module.exports, "useId", () => $d3190f5d250054f5$export$f680877a34711e37);

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $cwpsr = parcelRequire("cwpsr");
var $d3190f5d250054f5$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $d3190f5d250054f5$var$react18UseId = ($d3190f5d250054f5$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $d3190f5d250054f5$var$_React$useId !== void 0 ? $d3190f5d250054f5$var$_React$useId : undefined;
function $d3190f5d250054f5$export$f680877a34711e37() {
    if ($d3190f5d250054f5$var$react18UseId && (0, $cwpsr.fg)('platform-dst-react-18-use-id')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $d3190f5d250054f5$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $d3190f5d250054f5$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($d3190f5d250054f5$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $d3190f5d250054f5$export$6ee17796e3d70de2() {
    if ($d3190f5d250054f5$var$react18UseId && (0, $cwpsr.fg)('platform-dst-react-18-use-id')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $d3190f5d250054f5$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $b5lkZ.useUIDSeed)();
}

});
parcelRegister("cwpsr", function(module, exports) {
$parcel$export(module.exports, "fg", () => $91dc388fdbb0f5d1$export$b40ec24ac8275656);

var $lVV2x = parcelRequire("lVV2x");
function $91dc388fdbb0f5d1$export$ba05d765b8392e5e(flagResolver) {
    (0, $lVV2x.setBooleanResolver)(flagResolver);
}
function $91dc388fdbb0f5d1$export$470e5c2be1411c89(name) {
    return (0, $lVV2x.resolveBooleanFlag)(name);
}
function $91dc388fdbb0f5d1$export$b40ec24ac8275656(name) {
    return (0, $lVV2x.resolveBooleanFlag)(name);
}

});
parcelRegister("lVV2x", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $ff7b2ac460a9559c$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $ff7b2ac460a9559c$export$6333b6aff9fc6275);

var $jZlo3 = parcelRequire("jZlo3");

var $3sd9H = parcelRequire("3sd9H");

var $3ZMUU = parcelRequire("3ZMUU");
var $ff7b2ac460a9559c$var$pkgName = '@atlaskit/platform-feature-flags';
var $ff7b2ac460a9559c$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $ff7b2ac460a9559c$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $ff7b2ac460a9559c$var$ENV_ENABLE_PLATFORM_FF = $ff7b2ac460a9559c$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $ff7b2ac460a9559c$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $ff7b2ac460a9559c$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $ff7b2ac460a9559c$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $ff7b2ac460a9559c$var$ENV_ENABLE_PLATFORM_FF || $ff7b2ac460a9559c$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $ff7b2ac460a9559c$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $ff7b2ac460a9559c$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$ff7b2ac460a9559c$var$globalVar[$ff7b2ac460a9559c$export$7e41b1b2bdee3f98] = $ff7b2ac460a9559c$var$globalVar[$ff7b2ac460a9559c$export$7e41b1b2bdee3f98] || $ff7b2ac460a9559c$var$DEFAULT_PFF_GLOBAL;
function $ff7b2ac460a9559c$export$f2b591175b3e424c(resolver) {
    $ff7b2ac460a9559c$var$globalVar[$ff7b2ac460a9559c$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $ff7b2ac460a9559c$export$6333b6aff9fc6275(flagKey) {
    if ($ff7b2ac460a9559c$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $3sd9H.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $ff7b2ac460a9559c$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $ff7b2ac460a9559c$var$globalVar[$ff7b2ac460a9559c$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $ff7b2ac460a9559c$var$globalVar[$ff7b2ac460a9559c$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $jZlo3.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $ff7b2ac460a9559c$var$globalVar[$ff7b2ac460a9559c$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("3sd9H", function(module, exports) {
$parcel$export(module.exports, "debug", () => $283e3108fd1eb37a$export$1c9f709888824e05);
var $283e3108fd1eb37a$var$_process, $283e3108fd1eb37a$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $283e3108fd1eb37a$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($283e3108fd1eb37a$var$_process = globalThis.process) === null || $283e3108fd1eb37a$var$_process === void 0 || ($283e3108fd1eb37a$var$_process = $283e3108fd1eb37a$var$_process.env) === null || $283e3108fd1eb37a$var$_process === void 0 ? void 0 : $283e3108fd1eb37a$var$_process.JEST_WORKER_ID) !== undefined;
var $283e3108fd1eb37a$var$DEBUG_MODE = !$283e3108fd1eb37a$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($283e3108fd1eb37a$var$_process2 = globalThis.process) === null || $283e3108fd1eb37a$var$_process2 === void 0 || ($283e3108fd1eb37a$var$_process2 = $283e3108fd1eb37a$var$_process2.env) === null || $283e3108fd1eb37a$var$_process2 === void 0 ? void 0 : $283e3108fd1eb37a$var$_process2.NODE_ENV) !== 'production';
var $283e3108fd1eb37a$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$283e3108fd1eb37a$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("legyX", function(module, exports) {
$parcel$export(module.exports, "fg", () => $f747c0cfcf677ed7$export$b40ec24ac8275656);

var $lzAam = parcelRequire("lzAam");
function $f747c0cfcf677ed7$export$ba05d765b8392e5e(flagResolver) {
    (0, $lzAam.setBooleanResolver)(flagResolver);
}
function $f747c0cfcf677ed7$export$470e5c2be1411c89(name) {
    return (0, $lzAam.resolveBooleanFlag)(name);
}
function $f747c0cfcf677ed7$export$b40ec24ac8275656(name) {
    return (0, $lzAam.resolveBooleanFlag)(name);
}

});
parcelRegister("lzAam", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $fb48ebac5cd00706$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $fb48ebac5cd00706$export$6333b6aff9fc6275);

var $jZlo3 = parcelRequire("jZlo3");

var $58gBl = parcelRequire("58gBl");

var $3ZMUU = parcelRequire("3ZMUU");
var $fb48ebac5cd00706$var$pkgName = '@atlaskit/platform-feature-flags';
var $fb48ebac5cd00706$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $fb48ebac5cd00706$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $fb48ebac5cd00706$var$ENV_ENABLE_PLATFORM_FF = $fb48ebac5cd00706$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $fb48ebac5cd00706$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $fb48ebac5cd00706$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $fb48ebac5cd00706$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $fb48ebac5cd00706$var$ENV_ENABLE_PLATFORM_FF || $fb48ebac5cd00706$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $fb48ebac5cd00706$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $fb48ebac5cd00706$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$fb48ebac5cd00706$var$globalVar[$fb48ebac5cd00706$export$7e41b1b2bdee3f98] = $fb48ebac5cd00706$var$globalVar[$fb48ebac5cd00706$export$7e41b1b2bdee3f98] || $fb48ebac5cd00706$var$DEFAULT_PFF_GLOBAL;
function $fb48ebac5cd00706$export$f2b591175b3e424c(resolver) {
    $fb48ebac5cd00706$var$globalVar[$fb48ebac5cd00706$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $fb48ebac5cd00706$export$6333b6aff9fc6275(flagKey) {
    if ($fb48ebac5cd00706$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $58gBl.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $fb48ebac5cd00706$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $fb48ebac5cd00706$var$globalVar[$fb48ebac5cd00706$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $fb48ebac5cd00706$var$globalVar[$fb48ebac5cd00706$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $jZlo3.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $fb48ebac5cd00706$var$globalVar[$fb48ebac5cd00706$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("58gBl", function(module, exports) {
$parcel$export(module.exports, "debug", () => $3bca93cb4c4c0d28$export$1c9f709888824e05);
var $3bca93cb4c4c0d28$var$_process, $3bca93cb4c4c0d28$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $3bca93cb4c4c0d28$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($3bca93cb4c4c0d28$var$_process = globalThis.process) === null || $3bca93cb4c4c0d28$var$_process === void 0 || ($3bca93cb4c4c0d28$var$_process = $3bca93cb4c4c0d28$var$_process.env) === null || $3bca93cb4c4c0d28$var$_process === void 0 ? void 0 : $3bca93cb4c4c0d28$var$_process.JEST_WORKER_ID) !== undefined;
var $3bca93cb4c4c0d28$var$DEBUG_MODE = !$3bca93cb4c4c0d28$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($3bca93cb4c4c0d28$var$_process2 = globalThis.process) === null || $3bca93cb4c4c0d28$var$_process2 === void 0 || ($3bca93cb4c4c0d28$var$_process2 = $3bca93cb4c4c0d28$var$_process2.env) === null || $3bca93cb4c4c0d28$var$_process2 === void 0 ? void 0 : $3bca93cb4c4c0d28$var$_process2.NODE_ENV) !== 'production';
var $3bca93cb4c4c0d28$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$3bca93cb4c4c0d28$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("hp0B0", function(module, exports) {
$parcel$export(module.exports, "default", () => $cab53bcd13330d54$export$2e2bcd8739ae039);
/* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $8ZA5t = parcelRequire("8ZA5t");

var $ijhrq = parcelRequire("ijhrq");

var $9PIsK = parcelRequire("9PIsK");

var $eEFdc = parcelRequire("eEFdc");

var $d1i5w = parcelRequire("d1i5w");
var $cab53bcd13330d54$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $cab53bcd13330d54$var$_excluded2 = [
    "className"
];
var $cab53bcd13330d54$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $cab53bcd13330d54$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $9PIsK.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $cab53bcd13330d54$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $eEFdc.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $ijhrq.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "14.2.2",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $cab53bcd13330d54$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement((0, $d1i5w.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "button",
        style: style
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $8ZA5t.cx)($cab53bcd13330d54$var$styles.root, isDisabled && $cab53bcd13330d54$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $cab53bcd13330d54$export$2e2bcd8739ae039 = $cab53bcd13330d54$var$Pressable;

});
parcelRegister("9PIsK", function(module, exports) {
$parcel$export(module.exports, "default", () => $728b5dd98ca29270$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $728b5dd98ca29270$export$2e2bcd8739ae039() {}

});

parcelRegister("eEFdc", function(module, exports) {
$parcel$export(module.exports, "default", () => $aab4c4eb7d8dc10b$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
var $aab4c4eb7d8dc10b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});

parcelRegister("d1i5w", function(module, exports) {
$parcel$export(module.exports, "default", () => $97a96649e208e7dc$export$2e2bcd8739ae039);
/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $jY1dw = parcelRequire("jY1dw");
var $6YKKQ = parcelRequire("6YKKQ");
var $97a96649e208e7dc$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $97a96649e208e7dc$var$_excluded2 = [
    "className"
];
function $97a96649e208e7dc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $97a96649e208e7dc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $97a96649e208e7dc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $97a96649e208e7dc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $97a96649e208e7dc$var$focusRingStyles = null;
var $97a96649e208e7dc$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $97a96649e208e7dc$var$Focusable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $97a96649e208e7dc$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $97a96649e208e7dc$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $jY1dw.default)([
            "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y",
            isInset && "_1ah3115h _2mwq115h",
            xcss
        ]),
        "data-testid": testId,
        style: $97a96649e208e7dc$var$_objectSpread($97a96649e208e7dc$var$_objectSpread({}, style), {}, {
            "--_1203r2w": (0, $6YKKQ.default)("calc(0px - ".concat("var(--ds-border-width-outline, 2px)", ")"))
        })
    }), children);
});
var $97a96649e208e7dc$export$2e2bcd8739ae039 = $97a96649e208e7dc$var$Focusable;

});


parcelRegister("lLoMC", function(module, exports) {
$parcel$export(module.exports, "useSplitButtonContext", () => $fd81362b6246f0fa$export$47e2c6fdb142d947);

var $5FkrB = parcelRequire("5FkrB");
var $fd81362b6246f0fa$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $fd81362b6246f0fa$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $5FkrB.useContext)($fd81362b6246f0fa$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("a11no", function(module, exports) {
$parcel$export(module.exports, "default", () => $74ab10ad3aa1e7bb$export$2e2bcd8739ae039);
function $74ab10ad3aa1e7bb$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $74ab10ad3aa1e7bb$var$tabKeyCode = 9;
function $74ab10ad3aa1e7bb$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $74ab10ad3aa1e7bb$var$tabKeyCode) return;
    $74ab10ad3aa1e7bb$var$abort(event);
}
function $74ab10ad3aa1e7bb$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $74ab10ad3aa1e7bb$var$abort,
        onMouseUpCapture: $74ab10ad3aa1e7bb$var$abort,
        onKeyDownCapture: $74ab10ad3aa1e7bb$var$onKey,
        onKeyUpCapture: $74ab10ad3aa1e7bb$var$onKey,
        onTouchStartCapture: $74ab10ad3aa1e7bb$var$abort,
        onTouchEndCapture: $74ab10ad3aa1e7bb$var$abort,
        onPointerDownCapture: $74ab10ad3aa1e7bb$var$abort,
        onPointerUpCapture: $74ab10ad3aa1e7bb$var$abort,
        onClickCapture: $74ab10ad3aa1e7bb$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $74ab10ad3aa1e7bb$var$abort
    } : events;
}

});

parcelRegister("13yI1", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c50febf2596508c$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $6hfNg = parcelRequire("6hfNg");
function $0c50febf2596508c$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $0c50febf2596508c$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $0c50febf2596508c$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6hfNg.default), {
        size: $0c50febf2596508c$var$getIconSpacing(spacing),
        appearance: $0c50febf2596508c$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});
parcelRegister("6hfNg", function(module, exports) {
$parcel$export(module.exports, "default", () => $492094e1d40d4ca9$export$2e2bcd8739ae039);
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $jY1dw = parcelRequire("jY1dw");

var $5FkrB = parcelRequire("5FkrB");

var $jlsmZ = parcelRequire("jlsmZ");

var $dSRcG = parcelRequire("dSRcG");

var $2oN5i = parcelRequire("2oN5i");
/**
 * Returns the appropriate circle stroke color.
 */ function $492094e1d40d4ca9$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $dSRcG.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $dSRcG.N0), ")");
}
var $492094e1d40d4ca9$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $492094e1d40d4ca9$var$loadIn = null;
var $492094e1d40d4ca9$var$styles = {
    rotateStyles: "_y44v1ozz _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_y44v1a7z _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $492094e1d40d4ca9$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $492094e1d40d4ca9$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $2oN5i.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $492094e1d40d4ca9$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $jlsmZ.default));
    $492094e1d40d4ca9$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $jY1dw.default)([
            $492094e1d40d4ca9$var$styles.wrapperStyles,
            $492094e1d40d4ca9$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $jY1dw.default)([
            $492094e1d40d4ca9$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $jY1dw.default)([
            $492094e1d40d4ca9$var$styles.circleStyles
        ])
    })));
}));
var $492094e1d40d4ca9$export$2e2bcd8739ae039 = $492094e1d40d4ca9$var$Spinner;

});
parcelRegister("jlsmZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e155fc231254215f$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
var $e155fc231254215f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});

parcelRegister("2oN5i", function(module, exports) {
$parcel$export(module.exports, "presetSizes", () => $1bf3e5ce047ce5c4$export$4e9f1640bbe7a1a8);
var $1bf3e5ce047ce5c4$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("fxDXf", function(module, exports) {
$parcel$export(module.exports, "default", () => $b508ee3c22103f11$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $jY1dw = parcelRequire("jY1dw");

var $5FkrB = parcelRequire("5FkrB");
var $b508ee3c22103f11$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $b508ee3c22103f11$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        className: (0, $jY1dw.default)([
            $b508ee3c22103f11$var$styles.common,
            type === 'text' && $b508ee3c22103f11$var$styles.text,
            type === 'icon' && $b508ee3c22103f11$var$styles.icon,
            isLoading && $b508ee3c22103f11$var$styles.fade,
            position === 'before' && $b508ee3c22103f11$var$styles.beforeIcon,
            position === 'after' && $b508ee3c22103f11$var$styles.afterIcon
        ])
    }, children);
};
var $b508ee3c22103f11$export$2e2bcd8739ae039 = $b508ee3c22103f11$var$Content;

});

parcelRegister("7zyz1", function(module, exports) {
$parcel$export(module.exports, "default", () => $58369cf6c8ceabe1$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $58369cf6c8ceabe1$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $58369cf6c8ceabe1$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, $58369cf6c8ceabe1$var$isIconRenderProp(Icon) ? Icon({
        label: '',
        color: 'currentColor'
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, {
        label: "",
        color: 'currentColor'
    }));
};
var $58369cf6c8ceabe1$export$2e2bcd8739ae039 = $58369cf6c8ceabe1$var$IconRenderer;

});


parcelRegister("dQOjl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e25fa526c0658720d6f2766d6bdbde06>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1572865ee472039$var$_react = $a1572865ee472039$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $a1572865ee472039$var$_close = $a1572865ee472039$var$_interopRequireDefault((parcelRequire("dY7ZR")));

var $a1572865ee472039$var$_cross = $a1572865ee472039$var$_interopRequireDefault((parcelRequire("2gDpX")));
function $a1572865ee472039$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1572865ee472039$var$CloseIcon = (props)=>/*#__PURE__*/ $a1572865ee472039$var$_react.default.createElement($a1572865ee472039$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $a1572865ee472039$var$_cross.default
    }, props));
$a1572865ee472039$var$CloseIcon.Name = 'CloseIconMigration';
var $a1572865ee472039$var$_default = module.exports.default = $a1572865ee472039$var$CloseIcon;

});
parcelRegister("dY7ZR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13d0fc846b6bef3d8e704c9e8e0a2026>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2b714f30c762d84$var$_react = $a2b714f30c762d84$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $a2b714f30c762d84$var$_baseNew = $a2b714f30c762d84$var$_interopRequireDefault((parcelRequire("g471E")));
function $a2b714f30c762d84$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Close".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a2b714f30c762d84$var$CloseIcon = (props)=>/*#__PURE__*/ $a2b714f30c762d84$var$_react.default.createElement($a2b714f30c762d84$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m9.06 8 4.97-4.97-1.06-1.06L8 6.94 3.03 1.97 1.97 3.03 6.94 8l-4.97 4.97 1.06 1.06L8 9.06l4.97 4.97 1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$a2b714f30c762d84$var$CloseIcon.displayName = 'CloseIcon';
var $a2b714f30c762d84$var$_default = module.exports.default = $a2b714f30c762d84$var$CloseIcon;

});
parcelRegister("g471E", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("lnzKb")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("lnzKb")).Icon);

var $lnzKb = parcelRequire("lnzKb");

});
parcelRegister("lnzKb", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $f90778f181fc87c1$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $f90778f181fc87c1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $5fJka = parcelRequire("5fJka");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $f90778f181fc87c1$var$commonSVGStyles = (0, $74Zh5.css)({
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: 'currentColor'
    }
});
var $f90778f181fc87c1$var$svgStyles = (0, $74Zh5.css)({
    color: 'currentColor',
    verticalAlign: 'bottom'
});
var $f90778f181fc87c1$var$iconStyles = (0, $74Zh5.css)({
    display: 'inline-block',
    boxSizing: 'border-box',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
    paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
});
var $f90778f181fc87c1$var$utilityIconStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-150, 12px)"
});
var $f90778f181fc87c1$var$scaleStyles = (0, $74Zh5.css)({
    width: 'inherit',
    height: 'inherit'
});
/**
 * For windows high contrast mode
 */ var $f90778f181fc87c1$var$baseHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        color: 'CanvasText',
        filter: 'grayscale(1)'
    }
});
var $f90778f181fc87c1$var$scaleSize = (0, $74Zh5.css)({
    width: 'inherit',
    height: 'inherit'
});
var $f90778f181fc87c1$var$sizeMap = {
    core: {
        none: (0, $74Zh5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $74Zh5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $74Zh5.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $74Zh5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $74Zh5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $f90778f181fc87c1$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $f90778f181fc87c1$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $f90778f181fc87c1$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $5fJka.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return (0, $74Zh5.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $f90778f181fc87c1$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core'];
    var viewBoxPadding;
    if (props.type === 'utility') {
        var _props$spacing;
        viewBoxPadding = $f90778f181fc87c1$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : 'none'];
    } else {
        var _props$spacing2;
        viewBoxPadding = $f90778f181fc87c1$var$paddingMap['core'][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : 'none'];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return (0, $74Zh5.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        css: [
            $f90778f181fc87c1$var$iconStyles,
            $f90778f181fc87c1$var$baseHcmStyles,
            shouldScale && $f90778f181fc87c1$var$scaleStyles,
            props.type === 'utility' && $f90778f181fc87c1$var$utilityIconStyles
        ]
    }, (0, $74Zh5.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $f90778f181fc87c1$var$commonSVGStyles,
            $f90778f181fc87c1$var$svgStyles,
            shouldScale ? $f90778f181fc87c1$var$scaleSize : props.type === 'utility' ? $f90778f181fc87c1$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : 'none'] : $f90778f181fc87c1$var$sizeMap['core'][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : 'none']
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $f90778f181fc87c1$export$2e2bcd8739ae039 = $f90778f181fc87c1$export$f04a61298a47a40f;

});



parcelRegister("2gDpX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1a6ba6e5daa4a994$var$_react = $1a6ba6e5daa4a994$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $0X9jl = parcelRequire("0X9jl");

var $1a6ba6e5daa4a994$var$_close = $1a6ba6e5daa4a994$var$_interopRequireDefault((parcelRequire("dY7ZR")));
function $1a6ba6e5daa4a994$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1a6ba6e5daa4a994$var$CrossIcon = (props)=>/*#__PURE__*/ $1a6ba6e5daa4a994$var$_react.default.createElement($0X9jl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props, {
        newIcon: $1a6ba6e5daa4a994$var$_close.default
    }));
$1a6ba6e5daa4a994$var$CrossIcon.displayName = 'CrossIcon';
var $1a6ba6e5daa4a994$var$_default = module.exports.default = $1a6ba6e5daa4a994$var$CrossIcon;

});
parcelRegister("0X9jl", function(module, exports) {
$parcel$export(module.exports, "IconFacade", () => $002de1ff0bc21e58$export$3cfb73f70dfca966);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $5fJka = parcelRequire("5fJka");

var $1Rj5x = parcelRequire("1Rj5x");
var $002de1ff0bc21e58$var$_excluded = [
    "dangerouslySetGlyph"
];
var $002de1ff0bc21e58$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
var $002de1ff0bc21e58$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $5FkrB.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $002de1ff0bc21e58$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : 'medium';
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $5fJka.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (size === 'small' || size === 'medium')) {
        if (props.iconType === 'utility') {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
                spacing: (0, $5fJka.fg)('platform-visual-refresh-icons-facade-button-fix') ? $002de1ff0bc21e58$var$sizeSpacingMap['utility'][size] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
                spacing: $002de1ff0bc21e58$var$sizeSpacingMap['core'][size],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1Rj5x.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});

});
parcelRegister("1Rj5x", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $15a98c3aa6523ac9$export$f04a61298a47a40f);

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $ffzGa = parcelRequire("ffzGa");

var $iy6m4 = parcelRequire("iy6m4");
function $15a98c3aa6523ac9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $15a98c3aa6523ac9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $15a98c3aa6523ac9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $15a98c3aa6523ac9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $15a98c3aa6523ac9$var$iconStyles = (0, $74Zh5.css)({
    display: 'inline-block',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> svg': $15a98c3aa6523ac9$var$_objectSpread($15a98c3aa6523ac9$var$_objectSpread({}, (0, $ffzGa.commonSVGStyles)), {}, {
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    })
});
/**
 * For windows high contrast mode
 */ var $15a98c3aa6523ac9$var$baseHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            filter: 'grayscale(1)',
            '--icon-primary-color': 'CanvasText',
            // foreground
            '--icon-secondary-color': 'Canvas' // background
        }
    }
});
var $15a98c3aa6523ac9$var$primaryEqualsSecondaryHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            '--icon-primary-color': 'Canvas' // foreground
        }
    }
});
var $15a98c3aa6523ac9$var$secondaryTransparentHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            '--icon-secondary-color': 'transparent' // background
        }
    }
});
var $15a98c3aa6523ac9$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $74Zh5.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $ffzGa.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $74Zh5.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor || (0, $iy6m4.getBackground)(),
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $15a98c3aa6523ac9$var$iconStyles,
            $15a98c3aa6523ac9$var$baseHcmStyles,
            primaryColor === secondaryColor && $15a98c3aa6523ac9$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $15a98c3aa6523ac9$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $74Zh5.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                '> svg': dimensions
            })
        ]
    }));
});
var $15a98c3aa6523ac9$export$2e2bcd8739ae039 = $15a98c3aa6523ac9$export$f04a61298a47a40f;

});
parcelRegister("ffzGa", function(module, exports) {
$parcel$export(module.exports, "commonSVGStyles", () => $b1a3eed6ffefb9ab$export$16374db1c3e6dfba);
$parcel$export(module.exports, "getIconSize", () => $b1a3eed6ffefb9ab$export$3eb7d6130acfda37);

var $k9xkr = parcelRequire("k9xkr");

var $74Zh5 = parcelRequire("74Zh5");
var $b1a3eed6ffefb9ab$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $b1a3eed6ffefb9ab$var$smallStyles = (0, $74Zh5.css)((0, $k9xkr.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $b1a3eed6ffefb9ab$var$mediumStyles = (0, $74Zh5.css)((0, $k9xkr.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $b1a3eed6ffefb9ab$var$largeStyles = (0, $74Zh5.css)((0, $k9xkr.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $b1a3eed6ffefb9ab$var$xlargeStyles = (0, $74Zh5.css)((0, $k9xkr.dimensions).xlarge);
var $b1a3eed6ffefb9ab$export$ef0ad74202575b64 = {
    small: $b1a3eed6ffefb9ab$var$smallStyles,
    medium: $b1a3eed6ffefb9ab$var$mediumStyles,
    large: $b1a3eed6ffefb9ab$var$largeStyles,
    xlarge: $b1a3eed6ffefb9ab$var$xlargeStyles
};
var $b1a3eed6ffefb9ab$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $k9xkr.dimensions)[size];
    return undefined;
};

});
parcelRegister("k9xkr", function(module, exports) {
$parcel$export(module.exports, "dimensions", () => $eabe8045da22f240$export$62ad7b0c781000e9);
var $eabe8045da22f240$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
var $eabe8045da22f240$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
var $eabe8045da22f240$export$62ad7b0c781000e9 = {
    small: {
        width: $eabe8045da22f240$export$c647cb0ee6e282fe.small,
        height: $eabe8045da22f240$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $eabe8045da22f240$export$c647cb0ee6e282fe.medium,
        height: $eabe8045da22f240$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $eabe8045da22f240$export$c647cb0ee6e282fe.large,
        height: $eabe8045da22f240$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $eabe8045da22f240$export$c647cb0ee6e282fe.xlarge,
        height: $eabe8045da22f240$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("iy6m4", function(module, exports) {
$parcel$export(module.exports, "getBackground", () => $d81054f0ea4b1866$export$18cb9425622d4e06);
var $d81054f0ea4b1866$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});






parcelRegister("2td33", function(module, exports) {
$parcel$export(module.exports, "useModal", () => $1cc8694e54deb3bc$export$33ffd74ebf07f060);

var $5FkrB = parcelRequire("5FkrB");

var $bwuZo = parcelRequire("bwuZo");
var $1cc8694e54deb3bc$export$33ffd74ebf07f060 = function useModal() {
    var modalContext = (0, $5FkrB.useContext)((0, $bwuZo.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});


parcelRegister("9Bq1o", function(module, exports) {
$parcel$export(module.exports, "default", () => $6fdbc114bff1abaa$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");

var $g6NAb = parcelRequire("g6NAb");

var $dOHNL = parcelRequire("dOHNL");

var $dSRcG = parcelRequire("dSRcG");

var $2td33 = parcelRequire("2td33");
var $6fdbc114bff1abaa$var$iconColor = {
    danger: "var(--ds-icon-danger, ".concat((0, $dSRcG.R400), ")"),
    warning: "var(--ds-icon-warning, #D97008)"
};
var $6fdbc114bff1abaa$var$iconStyles = (0, $74Zh5.css)({
    flex: '0 0 auto',
    // The following properties have been added purely to avoid a global style override in Jira breaking alignment between the icon and title text.
    // https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-legacy-frontend/jira-atlaskit-module/src/main/resources/jira-atlaskit-module/css/adg3-general-overrides.less?at=master#24
    // When the override is removed, these can be removed.
    color: 'inherit',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'inherit',
    fontStyle: 'inherit',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontWeight: 'inherit',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    letterSpacing: 'inherit',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'inherit'
});
var $6fdbc114bff1abaa$var$titleStyles = (0, $74Zh5.css)({
    display: 'flex',
    minWidth: 0,
    margin: "var(--ds-space-0, 0px)",
    gap: "var(--ds-space-100, 8px)",
    font: "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
var $6fdbc114bff1abaa$var$textStyles = (0, $74Zh5.css)({
    minWidth: 0,
    /**
   * This ensures that the element fills the whole header space
   * and its content does not overflow (since flex items don't
   * shrink past its content size by default).
   */ flex: '1 1 auto',
    wordWrap: 'break-word'
});
var $6fdbc114bff1abaa$var$truncatedTextStyles = (0, $74Zh5.css)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
var $6fdbc114bff1abaa$var$TitleIcon = function TitleIcon(_ref) {
    var appearance = _ref.appearance;
    var Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($g6NAb))) : (0, (/*@__PURE__*/$parcel$interopDefault($dOHNL)));
    return (0, $74Zh5.jsx)("span", {
        css: $6fdbc114bff1abaa$var$iconStyles
    }, (0, $74Zh5.jsx)(Icon, {
        label: appearance,
        color: $6fdbc114bff1abaa$var$iconColor[appearance],
        spacing: "spacious"
    }));
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $6fdbc114bff1abaa$var$ModalTitle = function ModalTitle(props) {
    var appearance = props.appearance, children = props.children, _props$isMultiline = props.isMultiline, isMultiline = _props$isMultiline === void 0 ? true : _props$isMultiline, userDefinedTestId = props.testId;
    var _useModal = (0, $2td33.useModal)(), titleId = _useModal.titleId, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--title");
    return(// eslint-disable-next-line @atlaskit/design-system/use-heading
    (0, $74Zh5.jsx)("h1", {
        css: $6fdbc114bff1abaa$var$titleStyles,
        "data-testid": testId
    }, appearance && (0, $74Zh5.jsx)($6fdbc114bff1abaa$var$TitleIcon, {
        appearance: appearance
    }), (0, $74Zh5.jsx)("span", {
        id: titleId,
        css: [
            $6fdbc114bff1abaa$var$textStyles,
            !isMultiline && $6fdbc114bff1abaa$var$truncatedTextStyles
        ],
        "data-testid": testId && "".concat(testId, "-text")
    }, children)));
};
var $6fdbc114bff1abaa$export$2e2bcd8739ae039 = $6fdbc114bff1abaa$var$ModalTitle;

});
parcelRegister("g6NAb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a36a65999ae3c13d3a1917b5e2b052e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bba3aaee00089d4d$var$_react = $bba3aaee00089d4d$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $bba3aaee00089d4d$var$_error = $bba3aaee00089d4d$var$_interopRequireDefault((parcelRequire("2di5f")));

var $bba3aaee00089d4d$var$_error2 = $bba3aaee00089d4d$var$_interopRequireDefault((parcelRequire("23r95")));
function $bba3aaee00089d4d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bba3aaee00089d4d$var$ErrorIcon = (props)=>/*#__PURE__*/ $bba3aaee00089d4d$var$_react.default.createElement($bba3aaee00089d4d$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $bba3aaee00089d4d$var$_error2.default
    }, props));
$bba3aaee00089d4d$var$ErrorIcon.Name = 'ErrorIconMigration';
var $bba3aaee00089d4d$var$_default = module.exports.default = $bba3aaee00089d4d$var$ErrorIcon;

});
parcelRegister("2di5f", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::257fef37d04db299e24e95484ff9b12f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $19cad2b3a12f00c6$var$_react = $19cad2b3a12f00c6$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $19cad2b3a12f00c6$var$_baseNew = $19cad2b3a12f00c6$var$_interopRequireDefault((parcelRequire("g471E")));
function $19cad2b3a12f00c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Error".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $19cad2b3a12f00c6$var$ErrorIcon = (props)=>/*#__PURE__*/ $19cad2b3a12f00c6$var$_react.default.createElement($19cad2b3a12f00c6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.604a2 2 0 0 1 2.828 0l5.982 5.982a2 2 0 0 1 0 2.828l-5.982 5.983a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM7.25 9V3.75h1.5V9zM8 12.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$19cad2b3a12f00c6$var$ErrorIcon.displayName = 'ErrorIcon';
var $19cad2b3a12f00c6$var$_default = module.exports.default = $19cad2b3a12f00c6$var$ErrorIcon;

});

parcelRegister("23r95", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17f0eb1c35d045f0$var$_react = $17f0eb1c35d045f0$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $0X9jl = parcelRequire("0X9jl");

var $17f0eb1c35d045f0$var$_error = $17f0eb1c35d045f0$var$_interopRequireDefault((parcelRequire("2di5f")));
function $17f0eb1c35d045f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $17f0eb1c35d045f0$var$ErrorIcon = (props)=>/*#__PURE__*/ $17f0eb1c35d045f0$var$_react.default.createElement($0X9jl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $17f0eb1c35d045f0$var$_error.default
    }));
$17f0eb1c35d045f0$var$ErrorIcon.displayName = 'ErrorIcon';
var $17f0eb1c35d045f0$var$_default = module.exports.default = $17f0eb1c35d045f0$var$ErrorIcon;

});


parcelRegister("dOHNL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::783ce92761ea23bbb39745cb99e4a6be>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0f1ebf580fdcc58$var$_react = $a0f1ebf580fdcc58$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $a0f1ebf580fdcc58$var$_warning = $a0f1ebf580fdcc58$var$_interopRequireDefault((parcelRequire("huCdT")));

var $a0f1ebf580fdcc58$var$_warning2 = $a0f1ebf580fdcc58$var$_interopRequireDefault((parcelRequire("fY37a")));
function $a0f1ebf580fdcc58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a0f1ebf580fdcc58$var$WarningIcon = (props)=>/*#__PURE__*/ $a0f1ebf580fdcc58$var$_react.default.createElement($a0f1ebf580fdcc58$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $a0f1ebf580fdcc58$var$_warning2.default
    }, props));
$a0f1ebf580fdcc58$var$WarningIcon.Name = 'WarningIconMigration';
var $a0f1ebf580fdcc58$var$_default = module.exports.default = $a0f1ebf580fdcc58$var$WarningIcon;

});
parcelRegister("huCdT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1447c2d9394cec1fac504fd0d225fa23>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cbc2e3512191778a$var$_react = $cbc2e3512191778a$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $cbc2e3512191778a$var$_baseNew = $cbc2e3512191778a$var$_interopRequireDefault((parcelRequire("g471E")));
function $cbc2e3512191778a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cbc2e3512191778a$var$WarningIcon = (props)=>/*#__PURE__*/ $cbc2e3512191778a$var$_react.default.createElement($cbc2e3512191778a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.169c.757-1.396 2.76-1.396 3.516 0l5.9 10.878C16.381 13.379 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$cbc2e3512191778a$var$WarningIcon.displayName = 'WarningIcon';
var $cbc2e3512191778a$var$_default = module.exports.default = $cbc2e3512191778a$var$WarningIcon;

});

parcelRegister("fY37a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9fee0180e753f5e$var$_react = $b9fee0180e753f5e$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $0X9jl = parcelRequire("0X9jl");

var $b9fee0180e753f5e$var$_warning = $b9fee0180e753f5e$var$_interopRequireDefault((parcelRequire("huCdT")));
function $b9fee0180e753f5e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b9fee0180e753f5e$var$WarningIcon = (props)=>/*#__PURE__*/ $b9fee0180e753f5e$var$_react.default.createElement($0X9jl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $b9fee0180e753f5e$var$_warning.default
    }));
$b9fee0180e753f5e$var$WarningIcon.displayName = 'WarningIcon';
var $b9fee0180e753f5e$var$_default = module.exports.default = $b9fee0180e753f5e$var$WarningIcon;

});



parcelRegister("7FyjL", function(module, exports) {
$parcel$export(module.exports, "default", () => $5956fb8d0e7a0c50$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $3FlkA = parcelRequire("3FlkA");

var $5fJka = parcelRequire("5fJka");

var $2td33 = parcelRequire("2td33");

var $7R1rZ = parcelRequire("7R1rZ");

var $27ytc = parcelRequire("27ytc");
var $5956fb8d0e7a0c50$var$bodyStyles = (0, $74Zh5.css)({
    /* This ensures the body fills the whole space between header and footer. */ flex: '1 1 auto'
});
var $5956fb8d0e7a0c50$var$fontStyles = (0, $74Zh5.css)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
/**
 * Adding the padding here avoids cropping the keyline on its sides.
 * The combined vertical spacing is maintained by subtracting the
 * keyline height from header and footer using negative margins.
 */ var $5956fb8d0e7a0c50$var$bodyScrollStyles = (0, $74Zh5.css)({
    paddingBlock: "var(--ds-border-width-outline, 2px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * Keylines will not be shown if scrolling in viewport so we do
 * not account for them in this case.
 */ var $5956fb8d0e7a0c50$var$viewportScrollStyles = (0, $74Zh5.css)({
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $5956fb8d0e7a0c50$var$ModalBody = function ModalBody(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $2td33.useModal)(), modalTestId = _useModal.testId;
    var shouldScrollInViewport = (0, $27ytc.default)();
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--body");
    return shouldScrollInViewport ? (0, $74Zh5.jsx)("div", {
        css: [
            $5956fb8d0e7a0c50$var$bodyStyles,
            $5956fb8d0e7a0c50$var$viewportScrollStyles,
            (0, $5fJka.fg)('platform_ads_explicit_font_styles') && $5956fb8d0e7a0c50$var$fontStyles
        ],
        "data-testid": testId
    }, children) : (0, $74Zh5.jsx)((0, $3FlkA.TouchScrollable), null, (0, $74Zh5.jsx)((0, $7R1rZ.default), {
        testId: userDefinedTestId || modalTestId
    }, (0, $74Zh5.jsx)("div", {
        css: [
            $5956fb8d0e7a0c50$var$bodyStyles,
            $5956fb8d0e7a0c50$var$bodyScrollStyles,
            (0, $5fJka.fg)('platform_ads_explicit_font_styles') && $5956fb8d0e7a0c50$var$fontStyles
        ],
        "data-testid": testId
    }, children)));
};
var $5956fb8d0e7a0c50$export$2e2bcd8739ae039 = $5956fb8d0e7a0c50$var$ModalBody;

});
parcelRegister("7R1rZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b7e9baa2f3a5c96$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $7QpUe = parcelRequire("7QpUe");

var $45Zis = parcelRequire("45Zis");

var $hd7HS = parcelRequire("hd7HS");

var $6qCqe = parcelRequire("6qCqe");

var $1kPX3 = parcelRequire("1kPX3");

var $8Bx3d = parcelRequire("8Bx3d");

var $5Rrqa = parcelRequire("5Rrqa");

var $dSRcG = parcelRequire("dSRcG");
var $5b7e9baa2f3a5c96$var$keylineColor = "var(--ds-border, ".concat((0, $dSRcG.N30), ")");
var $5b7e9baa2f3a5c96$var$baseStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    display: 'inherit',
    margin: "var(--ds-space-0, 0px)",
    flex: 'inherit',
    flexDirection: 'inherit',
    flexGrow: 1,
    overflowX: 'hidden',
    overflowY: 'auto'
}, (0, $5Rrqa.media).above.xs, {
    height: 'unset',
    overflowY: 'auto'
}));
var $5b7e9baa2f3a5c96$var$keylineHeight = 2;
var $5b7e9baa2f3a5c96$var$topKeylineStyles = (0, $74Zh5.css)({
    borderBlockStart: "var(--ds-border-width-outline, 2px)".concat(" solid ", $5b7e9baa2f3a5c96$var$keylineColor)
});
var $5b7e9baa2f3a5c96$var$bottomKeylineStyles = (0, $74Zh5.css)({
    borderBlockEnd: "var(--ds-border-width-outline, 2px)".concat(" solid ", $5b7e9baa2f3a5c96$var$keylineColor)
});
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ var $5b7e9baa2f3a5c96$var$ScrollContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, children = _ref.children;
    var scrollableRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), showTopKeyline = _useState2[0], setTopKeyline = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), showBottomKeyline = _useState4[0], setBottomKeyline = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), showContentFocus = _useState6[0], setContentFocus = _useState6[1];
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $5FkrB.useEffect)(function() {
        var schedule = (0, $45Zis.default)(function() {
            var target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    var setLazyKeylines = (0, $1kPX3.default)((0, $45Zis.default)(function() {
        var target = scrollableRef.current;
        if (target) {
            var scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $5b7e9baa2f3a5c96$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $5b7e9baa2f3a5c96$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $5FkrB.useEffect)(function() {
        var target = scrollableRef.current;
        setLazyKeylines();
        var unbindWindowEvent = (0, $7QpUe.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        var unbindTargetEvent = target ? (0, $7QpUe.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $6qCqe.default);
        return function() {
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return (0, $74Zh5.jsx)((0, $8Bx3d.default), {
        isInset: true
    }, (0, $74Zh5.jsx)("div", {
        // tabindex is allowed here so that keyboard users can scroll content
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        "data-testid": testId && "".concat(testId, "--scrollable"),
        ref: (0, $hd7HS.default)([
            ref,
            scrollableRef
        ]),
        css: [
            $5b7e9baa2f3a5c96$var$baseStyles,
            showTopKeyline && $5b7e9baa2f3a5c96$var$topKeylineStyles,
            showBottomKeyline && $5b7e9baa2f3a5c96$var$bottomKeylineStyles
        ]
    }, children));
});
$5b7e9baa2f3a5c96$var$ScrollContainer.displayName = 'ScrollContainer';
var $5b7e9baa2f3a5c96$export$2e2bcd8739ae039 = $5b7e9baa2f3a5c96$var$ScrollContainer;

});

parcelRegister("27ytc", function(module, exports) {
$parcel$export(module.exports, "default", () => $18b6f939cbfe7197$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $bwuZo = parcelRequire("bwuZo");
function $18b6f939cbfe7197$export$2e2bcd8739ae039() {
    var shouldScrollInViewport = (0, $5FkrB.useContext)((0, $bwuZo.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});


parcelRegister("bhMlj", function(module, exports) {
$parcel$export(module.exports, "default", () => $8376c81df8fe94b6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");

var $2td33 = parcelRequire("2td33");
var $8376c81df8fe94b6$var$footerStyles = (0, $74Zh5.css)({
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: "var(--ds-space-100, 8px)",
    marginBlockStart: "calc(-1 * ".concat("var(--ds-border-width-outline, 2px)", ")"),
    paddingBlockEnd: "var(--ds-space-300, 24px)",
    paddingBlockStart: "var(--ds-space-200, 16px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $8376c81df8fe94b6$var$ModalFooter = function ModalFooter(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $2td33.useModal)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--footer");
    return (0, $74Zh5.jsx)("div", {
        css: $8376c81df8fe94b6$var$footerStyles,
        "data-testid": testId
    }, children);
};
var $8376c81df8fe94b6$export$2e2bcd8739ae039 = $8376c81df8fe94b6$var$ModalFooter;

});


parcelRegister("427nl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("2CKum")).default);
$parcel$export(module.exports, "LinkButton", () => (parcelRequire("3WRgz")).default);
$parcel$export(module.exports, "IconButton", () => (parcelRequire("lyGTA")).default);
$parcel$export(module.exports, "LinkIconButton", () => (parcelRequire("b1PNV")).default);
$parcel$export(module.exports, "SplitButton", () => (parcelRequire("c0yaC")).SplitButton);

var $2CKum = parcelRequire("2CKum");

var $3WRgz = parcelRequire("3WRgz");

var $lyGTA = parcelRequire("lyGTA");

var $b1PNV = parcelRequire("b1PNV");

var $c0yaC = parcelRequire("c0yaC");

});
parcelRegister("2CKum", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e93311623e425b4$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $1C5BS = parcelRequire("1C5BS");

var $gGtQh = parcelRequire("gGtQh");
var $1e93311623e425b4$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $1e93311623e425b4$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $1e93311623e425b4$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isLoading = _ref.isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $1e93311623e425b4$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $1e93311623e425b4$var$_excluded2);
    var baseProps = (0, $gGtQh.default)({
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: 'button',
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1C5BS.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        "aria-label": baseProps['aria-label'],
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "Button"
    }), baseProps.children);
}));
$1e93311623e425b4$var$Button.displayName = 'Button';
var $1e93311623e425b4$export$2e2bcd8739ae039 = $1e93311623e425b4$var$Button;

});
parcelRegister("1C5BS", function(module, exports) {
$parcel$export(module.exports, "default", () => $12cdb10bcb916007$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $cmfNk = parcelRequire("cmfNk");

var $h1LyZ = parcelRequire("h1LyZ");

var $dLn3G = parcelRequire("dLn3G");

var $hkJI5 = parcelRequire("hkJI5");

var $d7pIx = parcelRequire("d7pIx");
var $12cdb10bcb916007$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $12cdb10bcb916007$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $12cdb10bcb916007$var$focusRingStyles = (0, $74Zh5.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $hkJI5.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $hkJI5.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $hkJI5.borderWidthMap)['border.width.outline']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $12cdb10bcb916007$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
var $12cdb10bcb916007$var$enabledStyles = (0, $74Zh5.css)({
    cursor: 'pointer'
});
var $12cdb10bcb916007$var$disabledStyles = (0, $74Zh5.css)({
    cursor: 'not-allowed'
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $12cdb10bcb916007$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $h1LyZ.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $12cdb10bcb916007$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $dLn3G.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $cmfNk.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "13.6.0",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $12cdb10bcb916007$var$_excluded2);
    var resolvedStyles = (0, $d7pIx.parseXcss)(xcss);
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
    (0, $74Zh5.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $12cdb10bcb916007$var$baseStyles,
            $12cdb10bcb916007$var$focusRingStyles,
            isDisabled ? $12cdb10bcb916007$var$disabledStyles : $12cdb10bcb916007$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $hkJI5.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $hkJI5.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $hkJI5.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $hkJI5.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $hkJI5.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $hkJI5.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $hkJI5.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $hkJI5.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children));
});
var $12cdb10bcb916007$export$2e2bcd8739ae039 = $12cdb10bcb916007$var$Pressable;

});
parcelRegister("cmfNk", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $8ff3ca9578ff378c$export$a4687b0234b40e28);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $hQ6Uq = parcelRequire("hQ6Uq");

var $aFyjd = parcelRequire("aFyjd");
function $8ff3ca9578ff378c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8ff3ca9578ff378c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8ff3ca9578ff378c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8ff3ca9578ff378c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8ff3ca9578ff378c$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $hQ6Uq.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $aFyjd.useTrackedRef)(analyticsData);
    var fnRef = (0, $aFyjd.useTrackedRef)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $8ff3ca9578ff378c$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("hQ6Uq", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $cfcca6fd3e1ba90a$export$5bf35293e545f20c);

var $dLGML = parcelRequire("dLGML");

var $dyWaF = parcelRequire("dyWaF");

var $ePFpc = parcelRequire("ePFpc");
function $cfcca6fd3e1ba90a$export$5bf35293e545f20c() {
    var analyticsContext = (0, $ePFpc.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $dyWaF.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("dyWaF", function(module, exports) {
$parcel$export(module.exports, "default", () => $9dfb92eba949427e$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5VbcN = parcelRequire("5VbcN");
function $9dfb92eba949427e$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $9dfb92eba949427e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $9dfb92eba949427e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9dfb92eba949427e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $9dfb92eba949427e$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $9dfb92eba949427e$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $9dfb92eba949427e$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $9dfb92eba949427e$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $9dfb92eba949427e$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $9dfb92eba949427e$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $5VbcN.default));

});
parcelRegister("5VbcN", function(module, exports) {
$parcel$export(module.exports, "default", () => $44faf7c6995638d8$export$2e2bcd8739ae039);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $44faf7c6995638d8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $44faf7c6995638d8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $44faf7c6995638d8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $44faf7c6995638d8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $44faf7c6995638d8$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $44faf7c6995638d8$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $44faf7c6995638d8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $44faf7c6995638d8$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $44faf7c6995638d8$var$_objectSpread($44faf7c6995638d8$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("ePFpc", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $acc5f258667171ce$export$d1f587f82ad51c4);

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $acc5f258667171ce$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};

});


parcelRegister("aFyjd", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $7c4858bfffb8599c$export$1d27a74659855e44);

var $5FkrB = parcelRequire("5FkrB");
var $7c4858bfffb8599c$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("h1LyZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6576cc46a999172$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $c6576cc46a999172$export$2e2bcd8739ae039() {}

});

parcelRegister("dLn3G", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0518d0d78f6619b$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
var $a0518d0d78f6619b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});

parcelRegister("hkJI5", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", () => $c9e7c30141c6e39c$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $c9e7c30141c6e39c$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $c9e7c30141c6e39c$export$632685d741f3dbbf);
$parcel$export(module.exports, "opacityMap", () => $c9e7c30141c6e39c$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $c9e7c30141c6e39c$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $c9e7c30141c6e39c$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $c9e7c30141c6e39c$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $c9e7c30141c6e39c$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $c9e7c30141c6e39c$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $c9e7c30141c6e39c$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $c9e7c30141c6e39c$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "fontMap", () => $c9e7c30141c6e39c$export$6ffa317d5e70375);
$parcel$export(module.exports, "fontWeightMap", () => $c9e7c30141c6e39c$export$303e322c6b1ed114);
$parcel$export(module.exports, "fontFamilyMap", () => $c9e7c30141c6e39c$export$3c7e9587132614b4);
$parcel$export(module.exports, "paddingStylesMap", () => $c9e7c30141c6e39c$export$e615f061ca585a6c);
$parcel$export(module.exports, "backgroundColorStylesMap", () => $c9e7c30141c6e39c$export$e7af83bafe7f9e63);
$parcel$export(module.exports, "surfaceColorStylesMap", () => $c9e7c30141c6e39c$export$ff257d957d48c421);
$parcel$export(module.exports, "isSurfaceColorToken", () => $c9e7c30141c6e39c$export$5e65a44e5b6ecadb);

var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $4tSBK = parcelRequire("4tSBK");
function $c9e7c30141c6e39c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c9e7c30141c6e39c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c9e7c30141c6e39c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c9e7c30141c6e39c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c9e7c30141c6e39c$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $c9e7c30141c6e39c$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $c9e7c30141c6e39c$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $c9e7c30141c6e39c$export$632685d741f3dbbf = $c9e7c30141c6e39c$var$_objectSpread($c9e7c30141c6e39c$var$_objectSpread({}, $c9e7c30141c6e39c$export$958d0ae7f2977ae4), $c9e7c30141c6e39c$export$d2dc61f58390201c);
var $c9e7c30141c6e39c$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $c9e7c30141c6e39c$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $c9e7c30141c6e39c$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $c9e7c30141c6e39c$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $c9e7c30141c6e39c$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $c9e7c30141c6e39c$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $c9e7c30141c6e39c$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $c9e7c30141c6e39c$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $c9e7c30141c6e39c$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $c9e7c30141c6e39c$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $c9e7c30141c6e39c$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $c9e7c30141c6e39c$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $c9e7c30141c6e39c$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $c9e7c30141c6e39c$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $c9e7c30141c6e39c$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $c9e7c30141c6e39c$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $c9e7c30141c6e39c$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $c9e7c30141c6e39c$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $c9e7c30141c6e39c$export$e615f061ca585a6c = $c9e7c30141c6e39c$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $c9e7c30141c6e39c$export$ca0f9c2de39ffed7(spacingProperty, $c9e7c30141c6e39c$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $c9e7c30141c6e39c$export$bf46c3f9eeafc71f = $c9e7c30141c6e39c$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $c9e7c30141c6e39c$export$ca0f9c2de39ffed7(spacingProperty, $c9e7c30141c6e39c$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $c9e7c30141c6e39c$export$e7af83bafe7f9e63 = $c9e7c30141c6e39c$export$ca0f9c2de39ffed7('backgroundColor', $c9e7c30141c6e39c$export$d1d79bf68ac056bd);
var $c9e7c30141c6e39c$export$3a1bcba60b23d7f0 = $c9e7c30141c6e39c$export$ca0f9c2de39ffed7('color', $c9e7c30141c6e39c$export$8473307aa00d6ea1);
var $c9e7c30141c6e39c$export$45f3f4fe16f9f7d5 = $c9e7c30141c6e39c$export$ca0f9c2de39ffed7('fontWeight', $c9e7c30141c6e39c$export$303e322c6b1ed114);
var $c9e7c30141c6e39c$export$68cc305da27dbaa4 = $c9e7c30141c6e39c$export$ca0f9c2de39ffed7('fontFamily', $c9e7c30141c6e39c$export$3c7e9587132614b4);
var $c9e7c30141c6e39c$export$128f10c238242f83 = $c9e7c30141c6e39c$export$ca0f9c2de39ffed7('font', $c9e7c30141c6e39c$export$6ffa317d5e70375);
var $c9e7c30141c6e39c$export$219d364c0da35ae4 = $c9e7c30141c6e39c$export$ca0f9c2de39ffed7('font', $c9e7c30141c6e39c$export$236bfe3a33ef1292);
var $c9e7c30141c6e39c$export$38845ca010b93505 = $c9e7c30141c6e39c$export$ca0f9c2de39ffed7('fontWeight', $c9e7c30141c6e39c$export$855cfd311192d666);
var $c9e7c30141c6e39c$export$ff257d957d48c421 = $c9e7c30141c6e39c$export$ca0f9c2de39ffed7((0, $4tSBK.CURRENT_SURFACE_CSS_VAR), $c9e7c30141c6e39c$export$41a358c9c2356760);
var $c9e7c30141c6e39c$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $c9e7c30141c6e39c$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("4tSBK", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $34343ad623b21121$export$9d7b58831ae93caa);
var $34343ad623b21121$export$4ef52930e33717cd = 'data-theme';
var $34343ad623b21121$export$a00eac3f8684bcd0 = 'data-color-mode';
var $34343ad623b21121$export$2112803007239c61 = 'data-contrast-mode';
var $34343ad623b21121$export$352e418ed5b6193a = 'data-custom-theme';
var $34343ad623b21121$export$2faeed762aac6741 = 'light';
var $34343ad623b21121$export$6f0c6fb8c80fcc92 = 'ds';
var $34343ad623b21121$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $34343ad623b21121$export$dddac1532e822863 = "--".concat($34343ad623b21121$export$6f0c6fb8c80fcc92, "-token-not-found");
var $34343ad623b21121$export$9d7b58831ae93caa = "--".concat($34343ad623b21121$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("d7pIx", function(module, exports) {
$parcel$export(module.exports, "parseXcss", () => $98cfe0bf6fbc0454$export$a9c84988c8f81f2d);
$parcel$export(module.exports, "xcss", () => $98cfe0bf6fbc0454$export$f6c783d06584602c);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $74Zh5 = parcelRequire("74Zh5");

var $hkJI5 = parcelRequire("hkJI5");

var $3ZMUU = parcelRequire("3ZMUU");
function $98cfe0bf6fbc0454$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $98cfe0bf6fbc0454$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $98cfe0bf6fbc0454$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $98cfe0bf6fbc0454$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $98cfe0bf6fbc0454$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $98cfe0bf6fbc0454$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $98cfe0bf6fbc0454$export$9a199fbafee0014e = {
    backgroundColor: (0, $hkJI5.backgroundColorMap),
    blockSize: (0, $hkJI5.dimensionMap),
    borderBlockColor: (0, $hkJI5.borderColorMap),
    borderBlockEndColor: (0, $hkJI5.borderColorMap),
    borderBlockEndWidth: (0, $hkJI5.borderWidthMap),
    borderBlockStartColor: (0, $hkJI5.borderColorMap),
    borderBlockStartWidth: (0, $hkJI5.borderWidthMap),
    borderBlockWidth: (0, $hkJI5.borderWidthMap),
    borderBottomColor: (0, $hkJI5.borderColorMap),
    borderBottomLeftRadius: (0, $hkJI5.borderRadiusMap),
    borderBottomRightRadius: (0, $hkJI5.borderRadiusMap),
    borderBottomWidth: (0, $hkJI5.borderWidthMap),
    borderColor: (0, $hkJI5.borderColorMap),
    borderEndEndRadius: (0, $hkJI5.borderRadiusMap),
    borderEndStartRadius: (0, $hkJI5.borderRadiusMap),
    borderInlineColor: (0, $hkJI5.borderColorMap),
    borderInlineEndColor: (0, $hkJI5.borderColorMap),
    borderInlineEndWidth: (0, $hkJI5.borderWidthMap),
    borderInlineStartColor: (0, $hkJI5.borderColorMap),
    borderInlineStartWidth: (0, $hkJI5.borderWidthMap),
    borderInlineWidth: (0, $hkJI5.borderWidthMap),
    borderLeftColor: (0, $hkJI5.borderColorMap),
    borderLeftWidth: (0, $hkJI5.borderWidthMap),
    borderRadius: (0, $hkJI5.borderRadiusMap),
    borderRightColor: (0, $hkJI5.borderColorMap),
    borderRightWidth: (0, $hkJI5.borderWidthMap),
    borderStartEndRadius: (0, $hkJI5.borderRadiusMap),
    borderStartStartRadius: (0, $hkJI5.borderRadiusMap),
    borderTopColor: (0, $hkJI5.borderColorMap),
    borderTopLeftRadius: (0, $hkJI5.borderRadiusMap),
    borderTopRightRadius: (0, $hkJI5.borderRadiusMap),
    borderTopWidth: (0, $hkJI5.borderWidthMap),
    borderWidth: (0, $hkJI5.borderWidthMap),
    bottom: (0, $hkJI5.allSpaceMap),
    boxShadow: (0, $hkJI5.shadowMap),
    color: (0, $hkJI5.textColorMap),
    columnGap: (0, $hkJI5.positiveSpaceMap),
    font: (0, $hkJI5.fontMap),
    fontFamily: (0, $hkJI5.fontFamilyMap),
    fontWeight: (0, $hkJI5.fontWeightMap),
    gap: (0, $hkJI5.positiveSpaceMap),
    height: (0, $hkJI5.dimensionMap),
    inlineSize: (0, $hkJI5.dimensionMap),
    inset: (0, $hkJI5.allSpaceMap),
    insetBlock: (0, $hkJI5.allSpaceMap),
    insetBlockEnd: (0, $hkJI5.allSpaceMap),
    insetBlockStart: (0, $hkJI5.allSpaceMap),
    insetInline: (0, $hkJI5.allSpaceMap),
    insetInlineEnd: (0, $hkJI5.allSpaceMap),
    insetInlineStart: (0, $hkJI5.allSpaceMap),
    left: (0, $hkJI5.allSpaceMap),
    margin: (0, $hkJI5.allSpaceMap),
    marginBlock: (0, $hkJI5.allSpaceMap),
    marginBlockEnd: (0, $hkJI5.allSpaceMap),
    marginBlockStart: (0, $hkJI5.allSpaceMap),
    marginBottom: (0, $hkJI5.allSpaceMap),
    marginInline: (0, $hkJI5.allSpaceMap),
    marginInlineEnd: (0, $hkJI5.allSpaceMap),
    marginInlineStart: (0, $hkJI5.allSpaceMap),
    marginLeft: (0, $hkJI5.allSpaceMap),
    marginRight: (0, $hkJI5.allSpaceMap),
    marginTop: (0, $hkJI5.allSpaceMap),
    maxBlockSize: (0, $hkJI5.dimensionMap),
    maxHeight: (0, $hkJI5.dimensionMap),
    maxInlineSize: (0, $hkJI5.dimensionMap),
    maxWidth: (0, $hkJI5.dimensionMap),
    minBlockSize: (0, $hkJI5.dimensionMap),
    minHeight: (0, $hkJI5.dimensionMap),
    minInlineSize: (0, $hkJI5.dimensionMap),
    minWidth: (0, $hkJI5.dimensionMap),
    opacity: (0, $hkJI5.opacityMap),
    outlineColor: (0, $hkJI5.borderColorMap),
    outlineOffset: (0, $hkJI5.positiveSpaceMap),
    outlineWidth: (0, $hkJI5.borderWidthMap),
    padding: (0, $hkJI5.positiveSpaceMap),
    paddingBlock: (0, $hkJI5.positiveSpaceMap),
    paddingBlockEnd: (0, $hkJI5.positiveSpaceMap),
    paddingBlockStart: (0, $hkJI5.positiveSpaceMap),
    paddingBottom: (0, $hkJI5.positiveSpaceMap),
    paddingInline: (0, $hkJI5.positiveSpaceMap),
    paddingInlineEnd: (0, $hkJI5.positiveSpaceMap),
    paddingInlineStart: (0, $hkJI5.positiveSpaceMap),
    paddingLeft: (0, $hkJI5.positiveSpaceMap),
    paddingRight: (0, $hkJI5.positiveSpaceMap),
    paddingTop: (0, $hkJI5.positiveSpaceMap),
    right: (0, $hkJI5.allSpaceMap),
    rowGap: (0, $hkJI5.positiveSpaceMap),
    top: (0, $hkJI5.allSpaceMap),
    width: (0, $hkJI5.dimensionMap),
    zIndex: (0, $hkJI5.layerMap)
};
var $98cfe0bf6fbc0454$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $98cfe0bf6fbc0454$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU.env) === 'object' && false;
};
var $98cfe0bf6fbc0454$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $98cfe0bf6fbc0454$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $98cfe0bf6fbc0454$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($98cfe0bf6fbc0454$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && $98cfe0bf6fbc0454$var$safeSelectors.test(key)) {
            styleObj[key] = $98cfe0bf6fbc0454$var$_transformStyles(value);
            return;
        }
        if ($98cfe0bf6fbc0454$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($98cfe0bf6fbc0454$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $98cfe0bf6fbc0454$export$9a199fbafee0014e)) return;
        var tokenValue = $98cfe0bf6fbc0454$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $98cfe0bf6fbc0454$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $98cfe0bf6fbc0454$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $98cfe0bf6fbc0454$var$uniqueSymbol, (0, $74Zh5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $98cfe0bf6fbc0454$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $98cfe0bf6fbc0454$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $98cfe0bf6fbc0454$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$98cfe0bf6fbc0454$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $98cfe0bf6fbc0454$export$f6c783d06584602c(style) {
    return $98cfe0bf6fbc0454$var$baseXcss(style);
}

});


parcelRegister("gGtQh", function(module, exports) {
$parcel$export(module.exports, "default", () => $c257b79ae3ca396d$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $dGLWv = parcelRequire("dGLWv");

var $dIzAm = parcelRequire("dIzAm");

var $kBPlY = parcelRequire("kBPlY");
/**
 * __Use default button base__
 *
 * A React hook that accepts a set of default Button props,
 * and processes them to return consistent base props for usage
 * across Button and LinkButton variants.
 *
 * @private
 */ var $c257b79ae3ca396d$var$useDefaultButton = function useDefaultButton(_ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, autoFocus = _ref.autoFocus, buttonType = _ref.buttonType, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, ref = _ref.ref, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId;
    var baseProps = (0, $kBPlY.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dGLWv.default), {
            type: "icon",
            position: "before",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dIzAm.default), {
            icon: iconBefore
        })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dGLWv.default), {
            isLoading: isLoading
        }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dGLWv.default), {
            type: "icon",
            position: "after",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dIzAm.default), {
            icon: iconAfter
        }))),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter)
    });
    return baseProps;
};
var $c257b79ae3ca396d$export$2e2bcd8739ae039 = $c257b79ae3ca396d$var$useDefaultButton;

});
parcelRegister("dGLWv", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f746300b23efb9f$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $ayeN2 = parcelRequire("ayeN2");
var $d7pIx = parcelRequire("d7pIx");
var $9f746300b23efb9f$var$textStyles = (0, $d7pIx.xcss)({
    // content can grow and shrink
    flexGrow: 1,
    flexShrink: 1,
    // ellipsis for overflow text
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
var $9f746300b23efb9f$var$iconStyles = (0, $d7pIx.xcss)({
    display: 'flex',
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'center',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    userSelect: 'none'
});
var $9f746300b23efb9f$var$commonStyles = (0, $d7pIx.xcss)({
    transition: 'opacity 0.3s'
});
var $9f746300b23efb9f$var$fadeStyles = (0, $d7pIx.xcss)({
    opacity: 0
});
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $9f746300b23efb9f$var$beforeIconStyles = (0, $d7pIx.xcss)({
    // @ts-ignore
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    // @ts-ignore
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)"
});
var $9f746300b23efb9f$var$afterIconStyles = (0, $d7pIx.xcss)({
    // @ts-ignore
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    // @ts-ignore
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)"
});
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $9f746300b23efb9f$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ayeN2.default), {
        as: "span",
        xcss: [
            $9f746300b23efb9f$var$commonStyles
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(type === 'text' ? [
            $9f746300b23efb9f$var$textStyles
        ] : [
            $9f746300b23efb9f$var$iconStyles
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(isLoading ? [
            $9f746300b23efb9f$var$fadeStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(position === 'before' ? [
            $9f746300b23efb9f$var$beforeIconStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(position === 'after' ? [
            $9f746300b23efb9f$var$afterIconStyles
        ] : []))
    }, children);
};
var $9f746300b23efb9f$export$2e2bcd8739ae039 = $9f746300b23efb9f$var$Content;

});
parcelRegister("ayeN2", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ae88d55a31a3e47$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $ldA2L = parcelRequire("ldA2L");

var $hkJI5 = parcelRequire("hkJI5");

var $d7pIx = parcelRequire("d7pIx");
var $7ae88d55a31a3e47$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $7ae88d55a31a3e47$var$_excluded2 = [
    "className"
];
var $7ae88d55a31a3e47$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $7ae88d55a31a3e47$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $7ae88d55a31a3e47$var$_excluded2);
    var resolvedStyles = (0, $d7pIx.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $7ae88d55a31a3e47$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $hkJI5.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $hkJI5.isSurfaceColorToken)(backgroundColor) && (0, $hkJI5.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $hkJI5.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $hkJI5.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $hkJI5.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $hkJI5.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $hkJI5.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $hkJI5.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $hkJI5.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $74Zh5.jsx)((0, $ldA2L.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $7ae88d55a31a3e47$export$2e2bcd8739ae039 = $7ae88d55a31a3e47$export$e71c4d32a2263218;
var $7ae88d55a31a3e47$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("ldA2L", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", () => $f726c55c5c02a95b$export$1ca2a26fecb070ae);

var $5FkrB = parcelRequire("5FkrB");
var $f726c55c5c02a95b$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $f726c55c5c02a95b$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($f726c55c5c02a95b$export$1ca2a26fecb070ae);
};
$f726c55c5c02a95b$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});



parcelRegister("dIzAm", function(module, exports) {
$parcel$export(module.exports, "default", () => $9fcafcf53a02502f$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $9fcafcf53a02502f$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $9fcafcf53a02502f$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, $9fcafcf53a02502f$var$isIconRenderProp(Icon) ? Icon({
        label: '',
        color: 'currentColor'
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, {
        label: "",
        color: 'currentColor'
    }));
};
var $9fcafcf53a02502f$export$2e2bcd8739ae039 = $9fcafcf53a02502f$var$IconRenderer;

});

parcelRegister("kBPlY", function(module, exports) {
$parcel$export(module.exports, "default", () => $f00f19134f4b6309$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $jrKPH = parcelRequire("jrKPH");

var $8ijNL = parcelRequire("8ijNL");

var $aEouc = parcelRequire("aEouc");

var $7Nmik = parcelRequire("7Nmik");

var $ayeN2 = parcelRequire("ayeN2");
var $d7pIx = parcelRequire("d7pIx");

var $h0N4L = parcelRequire("h0N4L");

var $eFlHW = parcelRequire("eFlHW");

var $7OBJ1 = parcelRequire("7OBJ1");

var $ctTCB = parcelRequire("ctTCB");

var $979NR = parcelRequire("979NR");

var $d6tze = parcelRequire("d6tze");
function $f00f19134f4b6309$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f00f19134f4b6309$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f00f19134f4b6309$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f00f19134f4b6309$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// If updating `buttonStyles`, also update `buttonStylesWithRem`.
var $f00f19134f4b6309$var$buttonStyles = (0, $d7pIx.xcss)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    width: 'auto',
    maxWidth: '100%',
    position: 'relative',
    alignItems: 'baseline',
    justifyContent: 'center',
    columnGap: 'space.050',
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width.0',
    flexShrink: 0,
    height: "".concat(32 / 14, "em"),
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    paddingBlock: 'space.075',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    textAlign: 'center',
    transition: 'background 0.1s ease-out',
    verticalAlign: 'middle',
    '::after': {
        borderRadius: 'inherit',
        inset: 'space.0',
        borderStyle: 'solid',
        borderWidth: "var(--ds-border-width, 1px)",
        pointerEvents: 'none',
        position: 'absolute'
    }
});
var $f00f19134f4b6309$var$buttonStylesWithRem = (0, $d7pIx.xcss)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    width: 'auto',
    maxWidth: '100%',
    position: 'relative',
    alignItems: 'baseline',
    justifyContent: 'center',
    columnGap: 'space.050',
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width.0',
    flexShrink: 0,
    height: '2rem',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    paddingBlock: 'space.075',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    textAlign: 'center',
    transition: 'background 0.1s ease-out',
    verticalAlign: 'middle',
    '::after': {
        borderRadius: 'inherit',
        inset: 'space.0',
        borderStyle: 'solid',
        borderWidth: "var(--ds-border-width, 1px)",
        pointerEvents: 'none',
        position: 'absolute'
    }
});
var $f00f19134f4b6309$var$defaultInteractiveStyles = (0, $d7pIx.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-hovered, #091e4214)",
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($h0N4L.N500, ")")
    },
    ':active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-neutral-pressed, ".concat($h0N4L.B75, ")"),
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($h0N4L.B400, ")")
    }
});
var $f00f19134f4b6309$var$defaultInteractiveRefreshedStyles = (0, $d7pIx.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: 'color.text.subtle'
    }
});
var $f00f19134f4b6309$var$defaultStyles = (0, $d7pIx.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    background: "var(--ds-background-neutral, ".concat($h0N4L.N20A, ")"),
    // @ts-expect-error — using tokens for explicit fallback usage.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values --  -- Ignored via go/DSP-18766
    color: "var(--ds-text, ".concat($h0N4L.N500, ")"),
    ':visited': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($h0N4L.N500, ")")
    }
});
var $f00f19134f4b6309$var$defaultRefreshedStyles = (0, $d7pIx.xcss)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: 'color.text.subtle',
    '::after': {
        content: '""',
        borderColor: 'color.border'
    },
    ':visited': {
        color: 'color.text.subtle'
    }
});
var $f00f19134f4b6309$var$primaryStyles = (0, $d7pIx.xcss)({
    background: "var(--ds-background-brand-bold, #0052CC)",
    // @ts-expect-error
    color: "var(--ds-text-inverse, #FFFFFF)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)"
    }
});
var $f00f19134f4b6309$var$primaryInteractiveStyles = (0, $d7pIx.xcss)({
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-hovered, #0065FF)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-pressed, #0747A6)"
    }
});
var $f00f19134f4b6309$var$warningStyles = (0, $d7pIx.xcss)({
    background: "var(--ds-background-warning-bold, #FFAB00)",
    // @ts-expect-error
    color: "var(--ds-text-warning-inverse, #172B4D)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)"
    }
});
var $f00f19134f4b6309$var$warningInteractiveStyles = (0, $d7pIx.xcss)({
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-hovered, #FFC400)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-pressed, #FF991F)"
    }
});
var $f00f19134f4b6309$var$dangerStyles = (0, $d7pIx.xcss)({
    background: "var(--ds-background-danger-bold, #DE350B)",
    color: 'color.text.inverse',
    ':visited': {
        color: 'color.text.inverse'
    }
});
var $f00f19134f4b6309$var$dangerInteractiveStyles = (0, $d7pIx.xcss)({
    ':hover': {
        color: 'color.text.inverse',
        background: "var(--ds-background-danger-bold-hovered, #FF5630)"
    },
    ':active': {
        color: 'color.text.inverse',
        background: "var(--ds-background-danger-bold-pressed, #BF2600)"
    }
});
var $f00f19134f4b6309$var$discoveryStyles = (0, $d7pIx.xcss)({
    background: "var(--ds-background-discovery-bold, #5243AA)",
    color: 'color.text.inverse',
    ':visited': {
        color: 'color.text.inverse'
    }
});
var $f00f19134f4b6309$var$discoveryInteractiveStyles = (0, $d7pIx.xcss)({
    ':hover': {
        color: 'color.text.inverse',
        background: "var(--ds-background-discovery-bold-hovered, #8777D9)"
    },
    ':active': {
        color: 'color.text.inverse',
        background: "var(--ds-background-discovery-bold-pressed, #5243AA)"
    }
});
var $f00f19134f4b6309$var$subtleStyles = (0, $d7pIx.xcss)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    // @ts-expect-error
    color: "var(--ds-text, #42526E)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $f00f19134f4b6309$var$subtleRefreshedStyles = (0, $d7pIx.xcss)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    color: 'color.text.subtle',
    ':visited': {
        color: 'color.text.subtle'
    }
});
var $f00f19134f4b6309$var$subtleInteractiveStyles = (0, $d7pIx.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $f00f19134f4b6309$var$subtleInteractiveRefreshedStyles = (0, $d7pIx.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        color: 'color.text.subtle'
    }
});
// Required due to Jira's AUI CSS reset: https://product-fabric.atlassian.net/browse/DSP-15687
var $f00f19134f4b6309$var$linkDecorationUnsetStyles = (0, $d7pIx.xcss)({
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'none'
    },
    ':active': {
        textDecoration: 'none'
    },
    ':focus': {
        textDecoration: 'none'
    }
});
var $f00f19134f4b6309$var$disabledStyles = (0, $d7pIx.xcss)({
    cursor: 'not-allowed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-disabled, ".concat($h0N4L.N20A, ")"),
    // @ts-expect-error
    color: "var(--ds-text-disabled, #091E424F)",
    ':hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-disabled, ".concat($h0N4L.N20A, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    ':active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-disabled, ".concat($h0N4L.N20A, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    '::after': {
        content: 'none'
    }
});
var $f00f19134f4b6309$var$selectedStyles = (0, $d7pIx.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($h0N4L.N700, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($h0N4L.N20, ")"),
    ':visited': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($h0N4L.N20, ")")
    }
});
var $f00f19134f4b6309$var$selectedRefreshedStyles = (0, $d7pIx.xcss)({
    background: "var(--ds-background-selected, #E9F2FF)",
    color: 'color.text.selected',
    '::after': {
        content: '""',
        borderColor: 'color.border.selected'
    },
    ':visited': {
        color: 'color.text.selected'
    }
});
var $f00f19134f4b6309$var$selectedInsideSplitButtonStyles = (0, $d7pIx.xcss)({
    // This is 2 so it appears above the split button divider when selected.
    // See split-button.tsx.
    // @ts-expect-error — We need a local zindex just for button.
    zIndex: 2
});
var $f00f19134f4b6309$var$selectedInteractiveStyles = (0, $d7pIx.xcss)({
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($h0N4L.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected-hovered, ".concat($h0N4L.N700, ")")
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($h0N4L.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected-pressed, ".concat($h0N4L.N700, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $f00f19134f4b6309$var$selectedWarningStyles = (0, $d7pIx.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($h0N4L.Y400, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($h0N4L.N800, ")"),
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($h0N4L.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($h0N4L.Y400, ")")
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($h0N4L.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($h0N4L.Y400, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $f00f19134f4b6309$var$selectedDangerStyles = (0, $d7pIx.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($h0N4L.R500, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($h0N4L.N20, ")"),
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($h0N4L.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($h0N4L.R500, ")")
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($h0N4L.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($h0N4L.R500, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $f00f19134f4b6309$var$selectedDiscoveryStyles = (0, $d7pIx.xcss)({
    background: "var(--ds-background-selected, #403294)",
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($h0N4L.N20, ")"),
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($h0N4L.N20, ")"),
        background: "var(--ds-background-selected, #403294)"
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($h0N4L.N20, ")"),
        background: "var(--ds-background-selected, #403294)"
    }
});
// If updating `spacingCompactStyles`, also update `spacingCompactStylesWithRem`.
var $f00f19134f4b6309$var$spacingCompactStyles = (0, $d7pIx.xcss)({
    columnGap: 'space.050',
    height: "".concat(24 / 14, "em"),
    paddingBlock: 'space.025',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    verticalAlign: 'middle'
});
var $f00f19134f4b6309$var$spacingCompactStylesWithRem = (0, $d7pIx.xcss)({
    columnGap: 'space.050',
    height: '1.5rem',
    paddingBlock: 'space.025',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    verticalAlign: 'middle'
});
var $f00f19134f4b6309$var$circleStyles = (0, $d7pIx.xcss)({
    borderRadius: 'border.radius.circle'
});
var $f00f19134f4b6309$var$fullWidthStyles = (0, $d7pIx.xcss)({
    width: '100%'
});
var $f00f19134f4b6309$var$loadingStyles = (0, $d7pIx.xcss)({
    cursor: 'progress'
});
// If updating `iconButtonStyles`, also update `iconButtonStylesWithRem`.
var $f00f19134f4b6309$var$iconButtonStyles = (0, $d7pIx.xcss)({
    height: "".concat(32 / 14, "em"),
    width: "".concat(32 / 14, "em"),
    paddingInlineEnd: 'space.0',
    paddingInlineStart: 'space.0'
});
var $f00f19134f4b6309$var$iconButtonStylesWithRem = (0, $d7pIx.xcss)({
    height: '2rem',
    width: '2rem',
    paddingInlineEnd: 'space.0',
    paddingInlineStart: 'space.0'
});
// If updating `iconButtonCompactStyles`, also update `iconButtonCompactStylesWithRem`.
var $f00f19134f4b6309$var$iconButtonCompactStyles = (0, $d7pIx.xcss)({
    width: "".concat(24 / 14, "em"),
    height: "".concat(24 / 14, "em")
});
var $f00f19134f4b6309$var$iconButtonCompactStylesWithRem = (0, $d7pIx.xcss)({
    width: '1.5rem',
    height: '1.5rem'
});
var $f00f19134f4b6309$var$buttonIconBeforeStyles = (0, $d7pIx.xcss)({
    paddingInlineStart: 'space.100'
});
var $f00f19134f4b6309$var$buttonIconAfterStyles = (0, $d7pIx.xcss)({
    paddingInlineEnd: 'space.100'
});
var $f00f19134f4b6309$var$splitButtonStyles = (0, $d7pIx.xcss)({
    ':focus-visible': {
        zIndex: 'card'
    }
});
var $f00f19134f4b6309$var$navigationSplitButtonStyles = (0, $d7pIx.xcss)({
    width: '24px',
    backgroundColor: 'color.background.neutral.subtle',
    paddingInlineEnd: 'space.075',
    paddingInlineStart: 'space.075'
});
var $f00f19134f4b6309$var$loadingOverlayStyles = (0, $d7pIx.xcss)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    insetBlockEnd: 'space.0',
    insetBlockStart: 'space.0',
    insetInlineEnd: 'space.0',
    insetInlineStart: 'space.0'
});
/**
 * __Use button base__
 *
 * A React hook that accepts a set of common Button props,
 * and processes them to return consistent base props for usage
 * across various Button components.
 *
 * It also:
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $f00f19134f4b6309$var$useButtonBase = function useButtonBase(_ref) {
    var _ref$appearance = _ref.appearance, propAppearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, children = _ref.children, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, ref = _ref.ref, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, testId = _ref.testId, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy;
    var localRef = (0, $5FkrB.useRef)(null);
    var splitButtonContext = (0, $7OBJ1.useSplitButtonContext)();
    var loadingLabelId = (0, $aEouc.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton && (0, $7Nmik.fg)('platform-component-visual-refresh') ? 'subtle' : (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || propAppearance;
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $8ijNL.default)(localRef, autoFocus);
    return $f00f19134f4b6309$var$_objectSpread({
        ref: (0, $jrKPH.default)([
            localRef,
            ref
        ]),
        xcss: [
            (0, $7Nmik.fg)('platform_dst_button_replace_em_with_rem') ? $f00f19134f4b6309$var$buttonStylesWithRem : $f00f19134f4b6309$var$buttonStyles,
            appearance === 'default' && ((0, $7Nmik.fg)('platform-component-visual-refresh') ? $f00f19134f4b6309$var$defaultRefreshedStyles : $f00f19134f4b6309$var$defaultStyles),
            appearance === 'default' && isInteractive && ((0, $7Nmik.fg)('platform-component-visual-refresh') ? $f00f19134f4b6309$var$defaultInteractiveRefreshedStyles : $f00f19134f4b6309$var$defaultInteractiveStyles),
            appearance === 'primary' && $f00f19134f4b6309$var$primaryStyles,
            appearance === 'primary' && isInteractive && $f00f19134f4b6309$var$primaryInteractiveStyles,
            appearance === 'warning' && $f00f19134f4b6309$var$warningStyles,
            appearance === 'warning' && isInteractive && $f00f19134f4b6309$var$warningInteractiveStyles,
            appearance === 'danger' && $f00f19134f4b6309$var$dangerStyles,
            appearance === 'danger' && isInteractive && $f00f19134f4b6309$var$dangerInteractiveStyles,
            appearance === 'discovery' && $f00f19134f4b6309$var$discoveryStyles,
            appearance === 'discovery' && isInteractive && $f00f19134f4b6309$var$discoveryInteractiveStyles,
            appearance === 'subtle' && ((0, $7Nmik.fg)('platform-component-visual-refresh') ? $f00f19134f4b6309$var$subtleRefreshedStyles : $f00f19134f4b6309$var$subtleStyles),
            appearance === 'subtle' && isInteractive && ((0, $7Nmik.fg)('platform-component-visual-refresh') ? $f00f19134f4b6309$var$subtleInteractiveRefreshedStyles : $f00f19134f4b6309$var$subtleInteractiveStyles),
            $f00f19134f4b6309$var$linkDecorationUnsetStyles,
            isSelected && ((0, $7Nmik.fg)('platform-component-visual-refresh') ? $f00f19134f4b6309$var$selectedRefreshedStyles : $f00f19134f4b6309$var$selectedStyles),
            isSelected && isSplitButton && $f00f19134f4b6309$var$selectedInsideSplitButtonStyles,
            isSelected && isInteractive && $f00f19134f4b6309$var$selectedInteractiveStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'danger' && $f00f19134f4b6309$var$selectedDangerStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'warning' && $f00f19134f4b6309$var$selectedWarningStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'discovery' && $f00f19134f4b6309$var$selectedDiscoveryStyles,
            isDisabled && $f00f19134f4b6309$var$disabledStyles,
            isCircle && !isSplitButton && $f00f19134f4b6309$var$circleStyles,
            spacing === 'compact' && ((0, $7Nmik.fg)('platform_dst_button_replace_em_with_rem') ? $f00f19134f4b6309$var$spacingCompactStylesWithRem : $f00f19134f4b6309$var$spacingCompactStyles),
            hasIconBefore && $f00f19134f4b6309$var$buttonIconBeforeStyles,
            hasIconAfter && $f00f19134f4b6309$var$buttonIconAfterStyles,
            isIconButton && ((0, $7Nmik.fg)('platform_dst_button_replace_em_with_rem') ? $f00f19134f4b6309$var$iconButtonStylesWithRem : $f00f19134f4b6309$var$iconButtonStyles),
            isIconButton && spacing === 'compact' && ((0, $7Nmik.fg)('platform_dst_button_replace_em_with_rem') ? $f00f19134f4b6309$var$iconButtonCompactStylesWithRem : $f00f19134f4b6309$var$iconButtonCompactStyles),
            shouldFitContainer && $f00f19134f4b6309$var$fullWidthStyles,
            isLoading && $f00f19134f4b6309$var$loadingStyles,
            isSplitButton && $f00f19134f4b6309$var$splitButtonStyles,
            isNavigationSplitButton && $f00f19134f4b6309$var$navigationSplitButtonStyles
        ],
        isDisabled: isEffectivelyDisabled,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7OBJ1.SplitButtonContext).Provider, {
            value: undefined
        }, children, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ayeN2.default), {
            as: "span",
            xcss: $f00f19134f4b6309$var$loadingOverlayStyles
        }, (0, $d6tze.default)({
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected,
            testId: testId
        })) : null, isLoading && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $eFlHW.default), {
            id: loadingLabelId
        }, (0, $979NR.LOADING_LABEL))),
        'aria-label': isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat((0, $979NR.LOADING_LABEL)) : ariaLabel,
        'aria-labelledby': isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy
    }, (0, $ctTCB.default)(isEffectivelyDisabled, {
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }));
};
var $f00f19134f4b6309$export$2e2bcd8739ae039 = $f00f19134f4b6309$var$useButtonBase;

});
parcelRegister("jrKPH", function(module, exports) {
$parcel$export(module.exports, "default", () => $e284ddf8ef95e2b6$export$2e2bcd8739ae039);
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $e284ddf8ef95e2b6$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("8ijNL", function(module, exports) {
$parcel$export(module.exports, "default", () => $609f5d604ea802ae$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $609f5d604ea802ae$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $5FkrB.useRef)(true);
    (0, $5FkrB.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("aEouc", function(module, exports) {
$parcel$export(module.exports, "useId", () => $7c10a2415bf78b99$export$f680877a34711e37);

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $78pe3 = parcelRequire("78pe3");
var $7c10a2415bf78b99$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $7c10a2415bf78b99$var$react18UseId = ($7c10a2415bf78b99$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $7c10a2415bf78b99$var$_React$useId !== void 0 ? $7c10a2415bf78b99$var$_React$useId : undefined;
function $7c10a2415bf78b99$export$f680877a34711e37() {
    if ($7c10a2415bf78b99$var$react18UseId && (0, $78pe3.fg)('platform.design-system-team.react-18-use-id_mn8q4')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $7c10a2415bf78b99$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $7c10a2415bf78b99$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($7c10a2415bf78b99$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $7c10a2415bf78b99$export$6ee17796e3d70de2() {
    if ($7c10a2415bf78b99$var$react18UseId && (0, $78pe3.fg)('platform.design-system-team.react-18-use-id_mn8q4')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $7c10a2415bf78b99$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $b5lkZ.useUIDSeed)();
}

});
parcelRegister("78pe3", function(module, exports) {
$parcel$export(module.exports, "fg", () => $531cd90a97e4b6a1$export$b40ec24ac8275656);

var $bMcax = parcelRequire("bMcax");
function $531cd90a97e4b6a1$export$ba05d765b8392e5e(flagResolver) {
    (0, $bMcax.setBooleanResolver)(flagResolver);
}
function $531cd90a97e4b6a1$export$470e5c2be1411c89(name) {
    return (0, $bMcax.resolveBooleanFlag)(name);
}
function $531cd90a97e4b6a1$export$b40ec24ac8275656(name) {
    return (0, $bMcax.resolveBooleanFlag)(name);
}

});
parcelRegister("bMcax", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $892d9de8a657669a$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $892d9de8a657669a$export$6333b6aff9fc6275);

var $jZlo3 = parcelRequire("jZlo3");

var $gj07O = parcelRequire("gj07O");

var $3ZMUU = parcelRequire("3ZMUU");
var $892d9de8a657669a$var$pkgName = '@atlaskit/platform-feature-flags';
var $892d9de8a657669a$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $892d9de8a657669a$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $892d9de8a657669a$var$ENV_ENABLE_PLATFORM_FF = $892d9de8a657669a$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $892d9de8a657669a$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $892d9de8a657669a$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $892d9de8a657669a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $892d9de8a657669a$var$ENV_ENABLE_PLATFORM_FF || $892d9de8a657669a$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $892d9de8a657669a$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $892d9de8a657669a$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$892d9de8a657669a$var$globalVar[$892d9de8a657669a$export$7e41b1b2bdee3f98] = $892d9de8a657669a$var$globalVar[$892d9de8a657669a$export$7e41b1b2bdee3f98] || $892d9de8a657669a$var$DEFAULT_PFF_GLOBAL;
function $892d9de8a657669a$export$f2b591175b3e424c(resolver) {
    $892d9de8a657669a$var$globalVar[$892d9de8a657669a$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $892d9de8a657669a$export$6333b6aff9fc6275(flagKey) {
    if ($892d9de8a657669a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $gj07O.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $892d9de8a657669a$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $892d9de8a657669a$var$globalVar[$892d9de8a657669a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $892d9de8a657669a$var$globalVar[$892d9de8a657669a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $jZlo3.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $892d9de8a657669a$var$globalVar[$892d9de8a657669a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("gj07O", function(module, exports) {
$parcel$export(module.exports, "debug", () => $bdee8487dc67a036$export$1c9f709888824e05);
var $bdee8487dc67a036$var$_process, $bdee8487dc67a036$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $bdee8487dc67a036$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($bdee8487dc67a036$var$_process = globalThis.process) === null || $bdee8487dc67a036$var$_process === void 0 || ($bdee8487dc67a036$var$_process = $bdee8487dc67a036$var$_process.env) === null || $bdee8487dc67a036$var$_process === void 0 ? void 0 : $bdee8487dc67a036$var$_process.JEST_WORKER_ID) !== undefined;
var $bdee8487dc67a036$var$DEBUG_MODE = !$bdee8487dc67a036$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($bdee8487dc67a036$var$_process2 = globalThis.process) === null || $bdee8487dc67a036$var$_process2 === void 0 || ($bdee8487dc67a036$var$_process2 = $bdee8487dc67a036$var$_process2.env) === null || $bdee8487dc67a036$var$_process2 === void 0 ? void 0 : $bdee8487dc67a036$var$_process2.NODE_ENV) !== 'production';
var $bdee8487dc67a036$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$bdee8487dc67a036$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("7Nmik", function(module, exports) {
$parcel$export(module.exports, "fg", () => $5ace674743a4ed1a$export$b40ec24ac8275656);

var $hvxZd = parcelRequire("hvxZd");
function $5ace674743a4ed1a$export$ba05d765b8392e5e(flagResolver) {
    (0, $hvxZd.setBooleanResolver)(flagResolver);
}
function $5ace674743a4ed1a$export$470e5c2be1411c89(name) {
    return (0, $hvxZd.resolveBooleanFlag)(name);
}
function $5ace674743a4ed1a$export$b40ec24ac8275656(name) {
    return (0, $hvxZd.resolveBooleanFlag)(name);
}

});
parcelRegister("hvxZd", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $cbefb1e9ca303488$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $cbefb1e9ca303488$export$6333b6aff9fc6275);

var $jZlo3 = parcelRequire("jZlo3");

var $cQ7M8 = parcelRequire("cQ7M8");

var $3ZMUU = parcelRequire("3ZMUU");
var $cbefb1e9ca303488$var$pkgName = '@atlaskit/platform-feature-flags';
var $cbefb1e9ca303488$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $cbefb1e9ca303488$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $cbefb1e9ca303488$var$ENV_ENABLE_PLATFORM_FF = $cbefb1e9ca303488$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $cbefb1e9ca303488$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $cbefb1e9ca303488$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $cbefb1e9ca303488$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $cbefb1e9ca303488$var$ENV_ENABLE_PLATFORM_FF || $cbefb1e9ca303488$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $cbefb1e9ca303488$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $cbefb1e9ca303488$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$cbefb1e9ca303488$var$globalVar[$cbefb1e9ca303488$export$7e41b1b2bdee3f98] = $cbefb1e9ca303488$var$globalVar[$cbefb1e9ca303488$export$7e41b1b2bdee3f98] || $cbefb1e9ca303488$var$DEFAULT_PFF_GLOBAL;
function $cbefb1e9ca303488$export$f2b591175b3e424c(resolver) {
    $cbefb1e9ca303488$var$globalVar[$cbefb1e9ca303488$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $cbefb1e9ca303488$export$6333b6aff9fc6275(flagKey) {
    if ($cbefb1e9ca303488$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $cQ7M8.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $cbefb1e9ca303488$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $cbefb1e9ca303488$var$globalVar[$cbefb1e9ca303488$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $cbefb1e9ca303488$var$globalVar[$cbefb1e9ca303488$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $jZlo3.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $cbefb1e9ca303488$var$globalVar[$cbefb1e9ca303488$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("cQ7M8", function(module, exports) {
$parcel$export(module.exports, "debug", () => $95905f611f90bc48$export$1c9f709888824e05);
var $95905f611f90bc48$var$_process, $95905f611f90bc48$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $95905f611f90bc48$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($95905f611f90bc48$var$_process = globalThis.process) === null || $95905f611f90bc48$var$_process === void 0 || ($95905f611f90bc48$var$_process = $95905f611f90bc48$var$_process.env) === null || $95905f611f90bc48$var$_process === void 0 ? void 0 : $95905f611f90bc48$var$_process.JEST_WORKER_ID) !== undefined;
var $95905f611f90bc48$var$DEBUG_MODE = !$95905f611f90bc48$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($95905f611f90bc48$var$_process2 = globalThis.process) === null || $95905f611f90bc48$var$_process2 === void 0 || ($95905f611f90bc48$var$_process2 = $95905f611f90bc48$var$_process2.env) === null || $95905f611f90bc48$var$_process2 === void 0 ? void 0 : $95905f611f90bc48$var$_process2.NODE_ENV) !== 'production';
var $95905f611f90bc48$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$95905f611f90bc48$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("h0N4L", function(module, exports) {
$parcel$export(module.exports, "R500", () => $c62881328c28048a$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y400", () => $c62881328c28048a$export$59619663aa6500fb);
$parcel$export(module.exports, "B75", () => $c62881328c28048a$export$8c13c2ee36917869);
$parcel$export(module.exports, "B200", () => $c62881328c28048a$export$215b7063051591f1);
$parcel$export(module.exports, "B400", () => $c62881328c28048a$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "N0", () => $c62881328c28048a$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $c62881328c28048a$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N500", () => $c62881328c28048a$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N700", () => $c62881328c28048a$export$ad0bacf983b7ddaa);
$parcel$export(module.exports, "N800", () => $c62881328c28048a$export$7d61b15e0da132af);
$parcel$export(module.exports, "N20A", () => $c62881328c28048a$export$8d43898f60b96a82);
$parcel$export(module.exports, "N30A", () => $c62881328c28048a$export$920c0d5c49070351);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $c62881328c28048a$export$4b84fd0e2c617bd = '#FFEBE6';
var $c62881328c28048a$export$b34b069eff244586 = '#FFBDAD';
var $c62881328c28048a$export$be802dd0d8b57f35 = '#FF8F73';
var $c62881328c28048a$export$60847d42f9da92a6 = '#FF7452';
var $c62881328c28048a$export$4a7404f376229999 = '#FF5630';
var $c62881328c28048a$export$2010d0fb4295b346 = '#DE350B';
var $c62881328c28048a$export$2837b5a1a71d5c02 = '#BF2600';
var $c62881328c28048a$export$8d9596b529bbb9cf = '#FFFAE6';
var $c62881328c28048a$export$41060a744ab0b7ae = '#FFF0B3';
var $c62881328c28048a$export$1cc05bbbf340e559 = '#FFE380';
var $c62881328c28048a$export$5aae31392d72caaa = '#FFC400';
var $c62881328c28048a$export$c6930421db9fa514 = '#FFAB00';
var $c62881328c28048a$export$59619663aa6500fb = '#FF991F';
var $c62881328c28048a$export$874739ea9e379ab6 = '#FF8B00';
var $c62881328c28048a$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $c62881328c28048a$export$69a3bf21b9686c2b = '#ABF5D1';
var $c62881328c28048a$export$afbce1382ec95f73 = '#79F2C0';
var $c62881328c28048a$export$747d86715d4175de = '#57D9A3';
var $c62881328c28048a$export$940e1f69e873f202 = '#36B37E';
var $c62881328c28048a$export$a49394138f7b8e85 = '#00875A';
var $c62881328c28048a$export$6fa04827ac68a4fb = '#006644';
var $c62881328c28048a$export$226de0355ed012f8 = '#DEEBFF';
var $c62881328c28048a$export$8c13c2ee36917869 = '#B3D4FF';
var $c62881328c28048a$export$ecfc1dff386a3e7a = '#4C9AFF';
var $c62881328c28048a$export$215b7063051591f1 = '#2684FF';
var $c62881328c28048a$export$e62e8919cca44969 = '#0065FF';
var $c62881328c28048a$export$b3de0ae08da2ce64 = '#0052CC';
var $c62881328c28048a$export$a6ee3d71bc067634 = '#0747A6';
var $c62881328c28048a$export$67f15409e87642a1 = '#669DF1';
var $c62881328c28048a$export$f0539dbc42dbb067 = '#8FB8F6';
var $c62881328c28048a$export$363e4475840015bb = '#EAE6FF';
var $c62881328c28048a$export$4b0a4417ed59760f = '#C0B6F2';
var $c62881328c28048a$export$6011520a64d9a187 = '#998DD9';
var $c62881328c28048a$export$a7175d4e9206bc80 = '#8777D9';
var $c62881328c28048a$export$b48405b95304b5a1 = '#6554C0';
var $c62881328c28048a$export$c71e4279dd54a18d = '#5243AA';
var $c62881328c28048a$export$147899de772240ec = '#403294';
var $c62881328c28048a$export$2cf711fe14c66f06 = '#E6FCFF';
var $c62881328c28048a$export$7a8f4d33f6f9772c = '#B3F5FF';
var $c62881328c28048a$export$776c9c497ef08533 = '#79E2F2';
var $c62881328c28048a$export$69cb3ca10c1e330e = '#00C7E6';
var $c62881328c28048a$export$9dc1ef0f3f48059b = '#00B8D9';
var $c62881328c28048a$export$7c835c78b6fcdef8 = '#00A3BF';
var $c62881328c28048a$export$6036577f95c3877e = '#008DA6';
var $c62881328c28048a$export$29a4f05edc054374 = '#FFFFFF';
var $c62881328c28048a$export$e655ef011c4aa1a2 = '#FAFBFC';
var $c62881328c28048a$export$9fdfb749e33cdf97 = '#F4F5F7';
var $c62881328c28048a$export$3e51e8f1440314ba = '#EBECF0';
var $c62881328c28048a$export$1ce2d1575d444ceb = '#DFE1E6';
var $c62881328c28048a$export$8754fc7e6d8b3000 = '#C1C7D0';
var $c62881328c28048a$export$c2e91cbeada39b8b = '#B3BAC5';
var $c62881328c28048a$export$5f71e19f3a7ad9de = '#A5ADBA';
var $c62881328c28048a$export$eaa8c8a70ac22806 = '#97A0AF';
var $c62881328c28048a$export$7c87d337fb91a97d = '#8993A4';
var $c62881328c28048a$export$d6447c357493214f = '#7A869A';
var $c62881328c28048a$export$f563ee71e9ee74cd = '#6B778C';
var $c62881328c28048a$export$e2ef2124cf4024b1 = '#5E6C84';
var $c62881328c28048a$export$eece5f492e429f08 = '#505F79';
var $c62881328c28048a$export$c39c0fe0f26207ae = '#42526E';
var $c62881328c28048a$export$7090862dc3038a9f = '#344563';
var $c62881328c28048a$export$ad0bacf983b7ddaa = '#253858';
var $c62881328c28048a$export$7d61b15e0da132af = '#172B4D';
var $c62881328c28048a$export$fbda843f0a27fe96 = '#091E42';
var $c62881328c28048a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $c62881328c28048a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $c62881328c28048a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $c62881328c28048a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $c62881328c28048a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $c62881328c28048a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $c62881328c28048a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $c62881328c28048a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $c62881328c28048a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $c62881328c28048a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $c62881328c28048a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $c62881328c28048a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $c62881328c28048a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $c62881328c28048a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $c62881328c28048a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $c62881328c28048a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $c62881328c28048a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $c62881328c28048a$export$2f6319cf7d736c2a = '#E6EDFA';
var $c62881328c28048a$export$95126bc8884d6634 = '#DCE5F5';
var $c62881328c28048a$export$8338d8c35d44ff1 = '#CED9EB';
var $c62881328c28048a$export$5368d76ae4fbbda7 = '#B8C7E0';
var $c62881328c28048a$export$9f0a771d16ec8d36 = '#ABBBD6';
var $c62881328c28048a$export$abcf8c38338b4aa5 = '#9FB0CC';
var $c62881328c28048a$export$97e81faa16a182c7 = '#8C9CB8';
var $c62881328c28048a$export$bfe21c59123ecf33 = '#7988A3';
var $c62881328c28048a$export$ee82aa2ea6a1558 = '#67758F';
var $c62881328c28048a$export$682927c6ed76be02 = '#56637A';
var $c62881328c28048a$export$91fd9994c5be9757 = '#455166';
var $c62881328c28048a$export$d281fbfe3cff2df6 = '#3B475C';
var $c62881328c28048a$export$3902c91d8b98a753 = '#313D52';
var $c62881328c28048a$export$8e8133c1ba5845b5 = '#283447';
var $c62881328c28048a$export$33ff357f6620b39 = '#202B3D';
var $c62881328c28048a$export$633847cf062b69e0 = '#1B2638';
var $c62881328c28048a$export$9776a6e503bdbf76 = '#121A29';
var $c62881328c28048a$export$6c813d5160dff5db = '#0E1624';
var $c62881328c28048a$export$3d4f271a500072a = '#0D1424';
var $c62881328c28048a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $c62881328c28048a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $c62881328c28048a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $c62881328c28048a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $c62881328c28048a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $c62881328c28048a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $c62881328c28048a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $c62881328c28048a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $c62881328c28048a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $c62881328c28048a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $c62881328c28048a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $c62881328c28048a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $c62881328c28048a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $c62881328c28048a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $c62881328c28048a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $c62881328c28048a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $c62881328c28048a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $c62881328c28048a$export$d2adc5dedf09fced = '#292A2E';
var $c62881328c28048a$export$f51762073d2bb381 = '#94C748';
var $c62881328c28048a$export$95e26d54def96891 = '#B3DF72';

});

parcelRegister("eFlHW", function(module, exports) {
$parcel$export(module.exports, "default", () => $aad5bbc09cbbbc8e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
var $aad5bbc09cbbbc8e$var$visuallyHiddenStyles = (0, $74Zh5.css)({
    width: '1px',
    height: '1px',
    padding: '0',
    position: 'absolute',
    border: '0',
    clip: 'rect(1px, 1px, 1px, 1px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $aad5bbc09cbbbc8e$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return (0, $74Zh5.jsx)("span", {
        id: id,
        "data-testid": testId,
        css: $aad5bbc09cbbbc8e$var$visuallyHiddenStyles,
        role: role
    }, children);
};
var $aad5bbc09cbbbc8e$export$2e2bcd8739ae039 = $aad5bbc09cbbbc8e$var$VisuallyHidden;

});

parcelRegister("7OBJ1", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContext", () => $5b0a775cbcd0fa5c$export$4b86304b2c0d7e71);
$parcel$export(module.exports, "useSplitButtonContext", () => $5b0a775cbcd0fa5c$export$47e2c6fdb142d947);

var $5FkrB = parcelRequire("5FkrB");
var $5b0a775cbcd0fa5c$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $5b0a775cbcd0fa5c$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $5FkrB.useContext)($5b0a775cbcd0fa5c$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("ctTCB", function(module, exports) {
$parcel$export(module.exports, "default", () => $916356c7ef4debc8$export$2e2bcd8739ae039);
function $916356c7ef4debc8$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $916356c7ef4debc8$var$tabKeyCode = 9;
function $916356c7ef4debc8$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $916356c7ef4debc8$var$tabKeyCode) return;
    $916356c7ef4debc8$var$abort(event);
}
function $916356c7ef4debc8$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $916356c7ef4debc8$var$abort,
        onMouseUpCapture: $916356c7ef4debc8$var$abort,
        onKeyDownCapture: $916356c7ef4debc8$var$onKey,
        onKeyUpCapture: $916356c7ef4debc8$var$onKey,
        onTouchStartCapture: $916356c7ef4debc8$var$abort,
        onTouchEndCapture: $916356c7ef4debc8$var$abort,
        onPointerDownCapture: $916356c7ef4debc8$var$abort,
        onPointerUpCapture: $916356c7ef4debc8$var$abort,
        onClickCapture: $916356c7ef4debc8$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $916356c7ef4debc8$var$abort
    } : events;
}

});

parcelRegister("979NR", function(module, exports) {
$parcel$export(module.exports, "LOADING_LABEL", () => $6a2c5f361181b6fd$export$d4c5499dc806c969);
var $6a2c5f361181b6fd$export$d4c5499dc806c969 = ', Loading';

});

parcelRegister("d6tze", function(module, exports) {
$parcel$export(module.exports, "default", () => $98a2c558f2ae3cfa$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $9F9ad = parcelRequire("9F9ad");
function $98a2c558f2ae3cfa$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $98a2c558f2ae3cfa$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $98a2c558f2ae3cfa$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9F9ad.default), {
        size: $98a2c558f2ae3cfa$var$getIconSpacing(spacing),
        appearance: $98a2c558f2ae3cfa$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});
parcelRegister("9F9ad", function(module, exports) {
$parcel$export(module.exports, "default", () => $708f0d2567535014$export$2e2bcd8739ae039);
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $jY1dw = parcelRequire("jY1dw");

var $5FkrB = parcelRequire("5FkrB");

var $dLn3G = parcelRequire("dLn3G");

var $h0N4L = parcelRequire("h0N4L");

var $4zd3K = parcelRequire("4zd3K");
/**
 * Returns the appropriate circle stroke color.
 */ function $708f0d2567535014$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $h0N4L.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $h0N4L.N0), ")");
}
var $708f0d2567535014$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $708f0d2567535014$var$loadIn = null;
var $708f0d2567535014$var$styles = {
    rotateStyles: "_y44v1ozz _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_y44v1a7z _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $708f0d2567535014$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $708f0d2567535014$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $4zd3K.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $708f0d2567535014$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $dLn3G.default));
    $708f0d2567535014$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $jY1dw.default)([
            $708f0d2567535014$var$styles.wrapperStyles,
            $708f0d2567535014$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $jY1dw.default)([
            $708f0d2567535014$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $jY1dw.default)([
            $708f0d2567535014$var$styles.circleStyles
        ])
    })));
}));
var $708f0d2567535014$export$2e2bcd8739ae039 = $708f0d2567535014$var$Spinner;

});
parcelRegister("4zd3K", function(module, exports) {
$parcel$export(module.exports, "presetSizes", () => $35348fa7b9e29036$export$4e9f1640bbe7a1a8);
var $35348fa7b9e29036$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});






parcelRegister("3WRgz", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e001b78fddcc5d8$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $59LlV = parcelRequire("59LlV");

var $gGtQh = parcelRequire("gGtQh");
var $2e001b78fddcc5d8$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "href",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId"
], $2e001b78fddcc5d8$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $2e001b78fddcc5d8$var$LinkButtonBase = function LinkButtonBase(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], autoFocus = _ref.autoFocus, children = _ref.children, href = _ref.href, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $2e001b78fddcc5d8$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $2e001b78fddcc5d8$var$_excluded2);
    var baseProps = (0, $gGtQh.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: 'link',
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $59LlV.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        "aria-label": baseProps['aria-label'],
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        testId: testId,
        href: baseProps.isDisabled ? undefined : href,
        role: baseProps.isDisabled ? 'link' : undefined,
        "aria-disabled": baseProps.isDisabled === true ? true : undefined,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LinkButton"
    }), baseProps.children);
};
// Workarounds to support generic types with forwardRef + memo
var $2e001b78fddcc5d8$var$WithRef = /*#__PURE__*/ (0, $5FkrB.forwardRef)($2e001b78fddcc5d8$var$LinkButtonBase);
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ var $2e001b78fddcc5d8$var$LinkButton = /*#__PURE__*/ (0, $5FkrB.memo)($2e001b78fddcc5d8$var$WithRef);
var $2e001b78fddcc5d8$export$2e2bcd8739ae039 = $2e001b78fddcc5d8$var$LinkButton;

});
parcelRegister("59LlV", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c128641fee713e3$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $ekGgq = parcelRequire("ekGgq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $afMOk = parcelRequire("afMOk");

var $cmfNk = parcelRequire("cmfNk");

var $ivFqH = parcelRequire("ivFqH");

var $h1LyZ = parcelRequire("h1LyZ");

var $iqQs4 = parcelRequire("iqQs4");

var $dLn3G = parcelRequire("dLn3G");

var $eFlHW = parcelRequire("eFlHW");

var $hkJI5 = parcelRequire("hkJI5");

var $d7pIx = parcelRequire("d7pIx");
var $3c128641fee713e3$var$_excluded = [
    "href",
    "children",
    "backgroundColor",
    "newWindowLabel",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss"
], $3c128641fee713e3$var$_excluded2 = [
    "className"
];
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $3c128641fee713e3$var$focusRingStyles = (0, $74Zh5.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $hkJI5.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $hkJI5.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $hkJI5.borderWidthMap)['border.width.outline']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $3c128641fee713e3$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    textDecoration: 'underline'
});
var $3c128641fee713e3$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $3c128641fee713e3$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
var $3c128641fee713e3$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $3c128641fee713e3$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, backgroundColor = _ref.backgroundColor, newWindowLabel = _ref.newWindowLabel, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $h1LyZ.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $3c128641fee713e3$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $dLn3G.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $iqQs4.useId)();
    var onClick = (0, $cmfNk.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@atlaskit/primitives",
        packageVersion: "13.6.0",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $3c128641fee713e3$var$_excluded2);
    var resolvedStyles = (0, $d7pIx.parseXcss)(xcss);
    var RouterLink = (0, $ivFqH.default)();
    var isExternal = typeof href === 'string' && $3c128641fee713e3$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $3c128641fee713e3$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(href) === 'object';
    (0, $afMOk.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : 'a';
    return (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // @ts-expect-error
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel ? newWindowLabel : $3c128641fee713e3$var$OPENS_NEW_WINDOW_LABEL) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        css: [
            $3c128641fee713e3$var$baseStyles,
            $3c128641fee713e3$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $hkJI5.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $hkJI5.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $hkJI5.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $hkJI5.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $hkJI5.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $hkJI5.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $hkJI5.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $hkJI5.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && (0, $74Zh5.jsx)((0, $eFlHW.default), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel ? newWindowLabel : $3c128641fee713e3$var$OPENS_NEW_WINDOW_LABEL)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $3c128641fee713e3$var$Anchor = /*#__PURE__*/ (0, $5FkrB.forwardRef)($3c128641fee713e3$var$AnchorNoRef);
var $3c128641fee713e3$export$2e2bcd8739ae039 = $3c128641fee713e3$var$Anchor;

});
parcelRegister("ivFqH", function(module, exports) {
$parcel$export(module.exports, "default", () => $d79b424db91dd030$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $dXQy6 = parcelRequire("dXQy6");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $d79b424db91dd030$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $5FkrB.useContext)((0, $dXQy6.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
};
var $d79b424db91dd030$export$2e2bcd8739ae039 = $d79b424db91dd030$var$useRouterLink;

});
parcelRegister("dXQy6", function(module, exports) {
$parcel$export(module.exports, "RouterLinkProviderContext", () => $a2a98c30de0c2e1a$export$2931e0ee690eee88);

var $5FkrB = parcelRequire("5FkrB");
var $a2a98c30de0c2e1a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $5FkrB.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $a2a98c30de0c2e1a$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($a2a98c30de0c2e1a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $a2a98c30de0c2e1a$export$2e2bcd8739ae039 = $a2a98c30de0c2e1a$var$RouterLinkProvider;

});


parcelRegister("iqQs4", function(module, exports) {
$parcel$export(module.exports, "useId", () => $d6b35781c966d2af$export$f680877a34711e37);

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $6sLXl = parcelRequire("6sLXl");
var $d6b35781c966d2af$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $d6b35781c966d2af$var$react18UseId = ($d6b35781c966d2af$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $d6b35781c966d2af$var$_React$useId !== void 0 ? $d6b35781c966d2af$var$_React$useId : undefined;
function $d6b35781c966d2af$export$f680877a34711e37() {
    if ($d6b35781c966d2af$var$react18UseId && (0, $6sLXl.fg)('platform.design-system-team.react-18-use-id_mn8q4')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $d6b35781c966d2af$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $d6b35781c966d2af$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($d6b35781c966d2af$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $d6b35781c966d2af$export$6ee17796e3d70de2() {
    if ($d6b35781c966d2af$var$react18UseId && (0, $6sLXl.fg)('platform.design-system-team.react-18-use-id_mn8q4')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $d6b35781c966d2af$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $b5lkZ.useUIDSeed)();
}

});
parcelRegister("6sLXl", function(module, exports) {
$parcel$export(module.exports, "fg", () => $4b4a8eb0da0bf4c5$export$b40ec24ac8275656);

var $hXZOF = parcelRequire("hXZOF");
function $4b4a8eb0da0bf4c5$export$ba05d765b8392e5e(flagResolver) {
    (0, $hXZOF.setBooleanResolver)(flagResolver);
}
function $4b4a8eb0da0bf4c5$export$470e5c2be1411c89(name) {
    return (0, $hXZOF.resolveBooleanFlag)(name);
}
function $4b4a8eb0da0bf4c5$export$b40ec24ac8275656(name) {
    return (0, $hXZOF.resolveBooleanFlag)(name);
}

});
parcelRegister("hXZOF", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $d147e5c7f301cf70$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $d147e5c7f301cf70$export$6333b6aff9fc6275);

var $jZlo3 = parcelRequire("jZlo3");

var $gEx2l = parcelRequire("gEx2l");

var $3ZMUU = parcelRequire("3ZMUU");
var $d147e5c7f301cf70$var$pkgName = '@atlaskit/platform-feature-flags';
var $d147e5c7f301cf70$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $d147e5c7f301cf70$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $d147e5c7f301cf70$var$ENV_ENABLE_PLATFORM_FF = $d147e5c7f301cf70$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $d147e5c7f301cf70$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $d147e5c7f301cf70$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $d147e5c7f301cf70$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $d147e5c7f301cf70$var$ENV_ENABLE_PLATFORM_FF || $d147e5c7f301cf70$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $d147e5c7f301cf70$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $d147e5c7f301cf70$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$d147e5c7f301cf70$var$globalVar[$d147e5c7f301cf70$export$7e41b1b2bdee3f98] = $d147e5c7f301cf70$var$globalVar[$d147e5c7f301cf70$export$7e41b1b2bdee3f98] || $d147e5c7f301cf70$var$DEFAULT_PFF_GLOBAL;
function $d147e5c7f301cf70$export$f2b591175b3e424c(resolver) {
    $d147e5c7f301cf70$var$globalVar[$d147e5c7f301cf70$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $d147e5c7f301cf70$export$6333b6aff9fc6275(flagKey) {
    if ($d147e5c7f301cf70$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $gEx2l.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $d147e5c7f301cf70$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $d147e5c7f301cf70$var$globalVar[$d147e5c7f301cf70$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $d147e5c7f301cf70$var$globalVar[$d147e5c7f301cf70$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $jZlo3.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $d147e5c7f301cf70$var$globalVar[$d147e5c7f301cf70$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("gEx2l", function(module, exports) {
$parcel$export(module.exports, "debug", () => $c1fa023345bb1013$export$1c9f709888824e05);
var $c1fa023345bb1013$var$_process, $c1fa023345bb1013$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $c1fa023345bb1013$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($c1fa023345bb1013$var$_process = globalThis.process) === null || $c1fa023345bb1013$var$_process === void 0 || ($c1fa023345bb1013$var$_process = $c1fa023345bb1013$var$_process.env) === null || $c1fa023345bb1013$var$_process === void 0 ? void 0 : $c1fa023345bb1013$var$_process.JEST_WORKER_ID) !== undefined;
var $c1fa023345bb1013$var$DEBUG_MODE = !$c1fa023345bb1013$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($c1fa023345bb1013$var$_process2 = globalThis.process) === null || $c1fa023345bb1013$var$_process2 === void 0 || ($c1fa023345bb1013$var$_process2 = $c1fa023345bb1013$var$_process2.env) === null || $c1fa023345bb1013$var$_process2 === void 0 ? void 0 : $c1fa023345bb1013$var$_process2.NODE_ENV) !== 'production';
var $c1fa023345bb1013$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$c1fa023345bb1013$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});






parcelRegister("lyGTA", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb1e0c1d2dd49e6a$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $1C5BS = parcelRequire("1C5BS");

var $1oVT1 = parcelRequire("1oVT1");

var $fmio1 = parcelRequire("fmio1");
var $fb1e0c1d2dd49e6a$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $fb1e0c1d2dd49e6a$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $fb1e0c1d2dd49e6a$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isLoading = _ref.isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $fb1e0c1d2dd49e6a$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $fb1e0c1d2dd49e6a$var$_excluded2);
    /**
   * TODO: At some stage I'll look into re-using more logic across 'default' and 'icon'
   * buttons. It's currently duplicated and mostly the same.
   */ var baseProps = (0, $fmio1.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: 'button',
        icon: icon,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        label: label,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shape: shape,
        spacing: spacing,
        testId: testId
    });
    if (!isTooltipDisabled) {
        var _tooltip$content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1oVT1.default), {
            content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
            testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
            position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
            delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
            onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
            onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
            mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
            analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
            strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
            tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
            truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
            component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
            hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
            hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
            ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents
        }, function(triggerProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1C5BS.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
                // Top level props
                "aria-labelledby": baseProps['aria-labelledby'],
                type: type,
                testId: testId,
                componentName: "IconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                onMouseOver: function onMouseOver(e) {
                    var _triggerProps$onMouse, _saferRest$onMouseOve;
                    (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                    (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
                },
                onMouseOut: function onMouseOut(e) {
                    var _triggerProps$onMouse2, _saferRest$onMouseOut;
                    (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                    (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
                },
                onMouseMove: function onMouseMove(e) {
                    var _triggerProps$onMouse3, _saferRest$onMouseMov;
                    (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                    (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
                },
                onMouseDown: function onMouseDown(e) {
                    var _triggerProps$onMouse4, _saferRest$onMouseDow;
                    (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                    (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
                },
                onFocus: function onFocus(e) {
                    var _triggerProps$onFocus, _saferRest$onFocus;
                    (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                    (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
                },
                onBlur: function onBlur(e) {
                    var _triggerProps$onBlur, _saferRest$onBlur;
                    (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                    (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
                },
                onClick: function onClick(event, analyticsEvent) {
                    var _baseProps$onClick, _triggerProps$onClick;
                    baseProps === null || baseProps === void 0 || (_baseProps$onClick = baseProps.onClick) === null || _baseProps$onClick === void 0 || _baseProps$onClick.call(baseProps, event, analyticsEvent);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
                },
                ref: function ref(_ref2) {
                    var _triggerProps$ref;
                    baseProps.ref(_ref2);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$ref = triggerProps.ref) === null || _triggerProps$ref === void 0 || _triggerProps$ref.call(triggerProps, _ref2);
                },
                xcss: baseProps.xcss,
                isDisabled: baseProps.isDisabled,
                onMouseDownCapture: baseProps.onMouseDownCapture,
                onMouseUpCapture: baseProps.onMouseUpCapture,
                onKeyDownCapture: baseProps.onKeyDownCapture,
                onKeyUpCapture: baseProps.onKeyUpCapture,
                onTouchStartCapture: baseProps.onTouchStartCapture,
                onTouchEndCapture: baseProps.onTouchEndCapture,
                onPointerDownCapture: baseProps.onPointerDownCapture,
                onPointerUpCapture: baseProps.onPointerUpCapture,
                onClickCapture: baseProps.onClickCapture
            }), baseProps.children);
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1C5BS.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }), baseProps.children);
}));
$fb1e0c1d2dd49e6a$var$IconButton.displayName = 'IconButton';
var $fb1e0c1d2dd49e6a$export$2e2bcd8739ae039 = $fb1e0c1d2dd49e6a$var$IconButton;

});
parcelRegister("1oVT1", function(module, exports) {
$parcel$export(module.exports, "default", () => $1054ef677ee15d9a$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $l3edN = parcelRequire("l3edN");

var $35QIf = parcelRequire("35QIf");

var $h5mrR = parcelRequire("h5mrR");

var $1AQ59 = parcelRequire("1AQ59");

var $ky91o = parcelRequire("ky91o");

var $8mpiS = parcelRequire("8mpiS");
var $6b2cA = parcelRequire("6b2cA");

var $68Vmu = parcelRequire("68Vmu");

var $9tRs0 = parcelRequire("9tRs0");

var $7LfsS = parcelRequire("7LfsS");

var $6PYYg = parcelRequire("6PYYg");

var $c0Z2u = parcelRequire("c0Z2u");

var $9Nvet = parcelRequire("9Nvet");

var $fArWw = parcelRequire("fArWw");

var $059LA = parcelRequire("059LA");
function $1054ef677ee15d9a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1054ef677ee15d9a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1054ef677ee15d9a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1054ef677ee15d9a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1054ef677ee15d9a$var$tooltipZIndex = (0, $7LfsS.layers).tooltip();
var $1054ef677ee15d9a$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "19.2.0"
};
// Inverts motion direction
var $1054ef677ee15d9a$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $1054ef677ee15d9a$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $1054ef677ee15d9a$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $fArWw.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $35QIf.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $35QIf.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn;
    var tooltipPosition = position === 'mouse' ? mousePosition : position;
    var onShowHandler = (0, $l3edN.usePlatformLeafSyntheticEventHandler)($1054ef677ee15d9a$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $1054ef677ee15d9a$var$analyticsAttributes));
    var onHideHandler = (0, $l3edN.usePlatformLeafSyntheticEventHandler)($1054ef677ee15d9a$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $1054ef677ee15d9a$var$analyticsAttributes));
    var apiRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $5FkrB.useRef)(null);
    var containerRef = (0, $5FkrB.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $5FkrB.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $1AQ59.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $1AQ59.default)(onShowHandler);
    var onHideHandlerStable = (0, $1AQ59.default)(onHideHandler);
    var delayStable = (0, $1AQ59.default)(delay);
    var canAppearStable = (0, $1AQ59.default)(canAppear);
    var hasCalledShowHandler = (0, $5FkrB.useRef)(false);
    var start = (0, $5FkrB.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $5FkrB.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $5FkrB.useRef)(false);
    (0, $5FkrB.useEffect)(function() {
        return (0, $6PYYg.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $5FkrB.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        var api = (0, $c0Z2u.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $h5mrR.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $5FkrB.useEffect)(function() {
        if (state === 'hide') return 0, $35QIf.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $059LA.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === 'mouse' ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $059LA.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $5FkrB.useCallback)(function() {
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $5FkrB.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    (0, $ky91o.useNotifyOpenLayerObserver)({
        isOpen: shouldRenderTooltipPopup
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current4;
        if (position === 'mouse' && (_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.mousePosition) {
            var _apiRef$current5;
            return (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 ? void 0 : _apiRef$current5.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $9Nvet.default)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $5FkrB.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children($1054ef677ee15d9a$var$_objectSpread($1054ef677ee15d9a$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9tRs0.default), {
        zIndex: $1054ef677ee15d9a$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $68Vmu.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === 'mouse' ? undefined : $1054ef677ee15d9a$var$invertedDirection[$1054ef677ee15d9a$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8mpiS.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6b2cA.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $1054ef677ee15d9a$var$_objectSpread($1054ef677ee15d9a$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$1054ef677ee15d9a$var$Tooltip.displayName = 'Tooltip';
var $1054ef677ee15d9a$export$2e2bcd8739ae039 = $1054ef677ee15d9a$var$Tooltip;

});
parcelRegister("l3edN", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $f534e8dbc52fc7bb$export$1a04351537078b55);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $hQ6Uq = parcelRequire("hQ6Uq");

var $aFyjd = parcelRequire("aFyjd");
function $f534e8dbc52fc7bb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f534e8dbc52fc7bb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f534e8dbc52fc7bb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f534e8dbc52fc7bb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f534e8dbc52fc7bb$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $hQ6Uq.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $aFyjd.useTrackedRef)(analyticsData);
    var fnRef = (0, $aFyjd.useTrackedRef)(fn);
    var handler = (0, $5FkrB.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $f534e8dbc52fc7bb$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("35QIf", function(module, exports) {
$parcel$export(module.exports, "default", () => $240aba59e88a9193$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $240aba59e88a9193$export$2e2bcd8739ae039() {}

});

parcelRegister("h5mrR", function(module, exports) {
$parcel$export(module.exports, "default", () => $c704511645c66547$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $g8ZSm = parcelRequire("g8ZSm");
function $c704511645c66547$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $g8ZSm.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});
parcelRegister("g8ZSm", function(module, exports) {
$parcel$export(module.exports, "ESCAPE", () => $bc0d63f3467e10e4$export$2bb790b9008907b4);
/**
 * Character key codes which can be used in keyboard events.
 */ var $bc0d63f3467e10e4$export$390330c10ff2b9a1 = 'ArrowUp';
var $bc0d63f3467e10e4$export$a80636c6f41931fe = 'ArrowDown';
var $bc0d63f3467e10e4$export$4af703091671bc = 'Home';
var $bc0d63f3467e10e4$export$e2bc30913faa5db7 = 'End';
var $bc0d63f3467e10e4$export$10f6869ed0a7d75b = 'Tab';
var $bc0d63f3467e10e4$export$8152f929a25a0ff4 = 'Enter';
var $bc0d63f3467e10e4$export$e51a3576c045c8d5 = 'Space';
var $bc0d63f3467e10e4$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("1AQ59", function(module, exports) {
$parcel$export(module.exports, "default", () => $12918da117d80e5a$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $12918da117d80e5a$export$2e2bcd8739ae039(value) {
    var ref = (0, $5FkrB.useRef)(value);
    (0, $5FkrB.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("ky91o", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $ef5dfb15b62858cd$export$469bb693f11edc7f);

var $5FkrB = parcelRequire("5FkrB");

var $lz6Tj = parcelRequire("lz6Tj");
function $ef5dfb15b62858cd$export$469bb693f11edc7f() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$isOpen = _ref.isOpen, isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen;
    var context = (0, $5FkrB.useContext)((0, $lz6Tj.OpenLayerObserverContext));
    (0, $5FkrB.useEffect)(function() {
        if (context === null) return;
        if (!isOpen) return;
        context.increment();
        return function() {
            context.decrement();
        };
    }, [
        context,
        isOpen
    ]);
}

});
parcelRegister("lz6Tj", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $fb323646d507eb7f$export$5fbf4d7fae6cdc00);

var $5FkrB = parcelRequire("5FkrB");
var $fb323646d507eb7f$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});


parcelRegister("8mpiS", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $616401909694f17d$export$3b6f38abbdcbd000);
$parcel$export(module.exports, "default", () => $616401909694f17d$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $6Nr26 = parcelRequire("6Nr26");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $616401909694f17d$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $616401909694f17d$var$ExitingContext = /*#__PURE__*/ (0, $5FkrB.createContext)($616401909694f17d$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $616401909694f17d$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $616401909694f17d$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($616401909694f17d$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $616401909694f17d$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $616401909694f17d$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $616401909694f17d$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $616401909694f17d$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $616401909694f17d$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $616401909694f17d$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $6Nr26.isReducedMotion)()) return children;
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $616401909694f17d$var$childrenToArray(previousChildren);
    var current = $616401909694f17d$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $616401909694f17d$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $616401909694f17d$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $616401909694f17d$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $616401909694f17d$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $616401909694f17d$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)($616401909694f17d$var$ExitingContext);
};
$616401909694f17d$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $616401909694f17d$export$2e2bcd8739ae039 = $616401909694f17d$var$ExitingPersistence;

});
parcelRegister("6Nr26", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $4f2c49d95740b230$export$b7baf7667a68d87c);
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", () => $4f2c49d95740b230$export$f0f789643ba5a83c);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
var $4f2c49d95740b230$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $4f2c49d95740b230$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$4f2c49d95740b230$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $4f2c49d95740b230$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $5FkrB.useState)($4f2c49d95740b230$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        if (!$4f2c49d95740b230$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $7QpUe.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $4f2c49d95740b230$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $4f2c49d95740b230$export$ff7706047246b98b = function prefersReducedMotion() {
    return $4f2c49d95740b230$export$f0f789643ba5a83c;
};

});


parcelRegister("6b2cA", function(module, exports) {
$parcel$export(module.exports, "default", () => $47f57a688da58420$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $9qQZg = parcelRequire("9qQZg");
function $47f57a688da58420$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $47f57a688da58420$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $47f57a688da58420$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $47f57a688da58420$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $47f57a688da58420$var$directionMotions = {
    proportional: {
        bottom: 'translate3d(0, calc(5% + 4px), 0)',
        left: 'translate3d(calc(-5% - 4px), 0, 0)',
        right: 'translate3d(calc(5% + 4px), 0, 0)',
        top: 'translate3d(0, calc(-5% - 4px), 0)'
    },
    constant: {
        bottom: 'translate3d(0, 4px, 0)',
        left: 'translate3d(-4px, 0, 0)',
        right: 'translate3d(4px, 0, 0)',
        top: 'translate3d(0, -4px, 0)'
    }
};
var $47f57a688da58420$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
var $47f57a688da58420$export$8497679fcaaeceb = function fadeInAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'proportional';
    return {
        from: $47f57a688da58420$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $47f57a688da58420$var$directionMotions[distance][direction]
        }),
        '50%': {
            opacity: 1
        },
        to: {
            transform: direction !== undefined ? 'none' : undefined
        }
    };
};
var $47f57a688da58420$export$c9190c6659ea755b = function fadeOutAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'proportional';
    return {
        from: {
            opacity: 1,
            transform: direction !== undefined ? 'translate3d(0, 0, 0)' : undefined
        },
        to: $47f57a688da58420$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $47f57a688da58420$var$directionMotions[distance][direction]
        })
    };
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $47f57a688da58420$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection && $47f57a688da58420$var$invertedDirection[entranceDirection];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9qQZg.default), {
        duration: duration,
        enteringAnimation: $47f57a688da58420$export$8497679fcaaeceb(entranceDirection, distance),
        exitingAnimation: $47f57a688da58420$export$c9190c6659ea755b(exitDirection || invertedEntranceDirection, distance),
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $47f57a688da58420$export$2e2bcd8739ae039 = $47f57a688da58420$var$FadeIn;

});
parcelRegister("9qQZg", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ddfa4e3575a375f$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $6Nr26 = parcelRequire("6Nr26");

var $84ukS = parcelRequire("84ukS");

var $lFUuG = parcelRequire("lFUuG");

var $8mpiS = parcelRequire("8mpiS");

var $iEgoa = parcelRequire("iEgoa");
function $6ddfa4e3575a375f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6ddfa4e3575a375f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6ddfa4e3575a375f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6ddfa4e3575a375f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $6ddfa4e3575a375f$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $iEgoa.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $8mpiS.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $lFUuG.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $5FkrB.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        setTimeout(function() {
            if (state === 'exiting') onExitFinished && onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion && onFinishMotion(state);
        }, isExiting ? (0, $84ukS.exitingDurations)[duration] : (0, $84ukS.durations)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $74Zh5.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return children({
            ref: staggered.ref,
            className: hasAnimationStyles ? cx(css($6ddfa4e3575a375f$var$_objectSpread($6ddfa4e3575a375f$var$_objectSpread({}, (0, $6Nr26.reduceMotionAsPerUserPreference)), {}, {
                animationDelay: "".concat(delay, "ms"),
                animationFillMode: 'backwards',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                animationName: (0, $74Zh5.keyframes)(enteringAnimation),
                animationPlayState: 'running'
            })), paused && css({
                animationPlayState: 'paused'
            }), duration === 'small' && css({
                animationDuration: '100ms'
            }), duration === 'medium' && css({
                animationDuration: '350ms'
            }), duration === 'large' && css({
                animationDuration: '700ms'
            }), isExiting && duration === 'small' && css({
                animationDuration: '50ms'
            }), isExiting && duration === 'medium' && css({
                animationDuration: '175ms'
            }), isExiting && duration === 'large' && css({
                animationDuration: '350ms'
            }), isExiting && css({
                animationDelay: '0ms',
                animationFillMode: 'forwards',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                animationName: (0, $74Zh5.keyframes)(exitingAnimation)
            }), !isExiting && animationTimingFunction === 'linear' && css({
                animationTimingFunction: 'cubic-bezier(0,0,1,1)'
            }), !isExiting && animationTimingFunction === 'ease-out' && css({
                animationTimingFunction: 'cubic-bezier(0.2,0,0,1)'
            }), !isExiting && animationTimingFunction === 'ease-in' && css({
                animationTimingFunction: 'cubic-bezier(0.8,0,0,0.8)'
            }), !isExiting && animationTimingFunction === 'ease-in-out' && css({
                animationTimingFunction: 'cubic-bezier(0.15,1,0.3,1)'
            }), isExiting && animationTimingFunction === 'linear' && css({
                animationTimingFunction: 'cubic-bezier(0,0,1,1)'
            }), isExiting && animationTimingFunctionExiting === 'ease-out' && css({
                animationTimingFunction: 'cubic-bezier(0.2,0,0,1)'
            }), isExiting && animationTimingFunctionExiting === 'ease-in' && css({
                animationTimingFunction: 'cubic-bezier(0.8,0,0,0.8)'
            }), isExiting && animationTimingFunctionExiting === 'ease-in-out' && css({
                animationTimingFunction: 'cubic-bezier(0.15,1,0.3,1)'
            })) : ''
        }, state);
    });
};
var $6ddfa4e3575a375f$export$2e2bcd8739ae039 = $6ddfa4e3575a375f$var$EnteringMotion;

});
parcelRegister("84ukS", function(module, exports) {
$parcel$export(module.exports, "durations", () => $5e063a8358c0ee84$export$38b928a7167ce124);
$parcel$export(module.exports, "exitingDurations", () => $5e063a8358c0ee84$export$30fa1a2e62ae150c);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $5e063a8358c0ee84$export$368bacef0dacbe05 = 25;
var $5e063a8358c0ee84$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $5e063a8358c0ee84$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $5e063a8358c0ee84$export$30fa1a2e62ae150c = {
    none: $5e063a8358c0ee84$export$38b928a7167ce124.none,
    small: $5e063a8358c0ee84$export$38b928a7167ce124.small * $5e063a8358c0ee84$var$EXITING_MOTION_MULTIPLIER,
    medium: $5e063a8358c0ee84$export$38b928a7167ce124.medium * $5e063a8358c0ee84$var$EXITING_MOTION_MULTIPLIER,
    large: $5e063a8358c0ee84$export$38b928a7167ce124.large * $5e063a8358c0ee84$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("lFUuG", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", () => $fc793fcb48f10308$export$4f34107a2b00f39c);

var $5FkrB = parcelRequire("5FkrB");
var $fc793fcb48f10308$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $fc793fcb48f10308$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $fc793fcb48f10308$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $fc793fcb48f10308$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $fc793fcb48f10308$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("iEgoa", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $d938ace8734493b4$export$25c7213fc07ec080);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $35QIf = parcelRequire("35QIf");

var $9lKHn = parcelRequire("9lKHn");

var $d64hN = parcelRequire("d64hN");
var $d938ace8734493b4$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $35QIf.default)
    };
});
var $d938ace8734493b4$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $d64hN.useUniqueId)();
    var context = (0, $5FkrB.useContext)($d938ace8734493b4$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $d938ace8734493b4$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $9lKHn.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($d938ace8734493b4$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $d938ace8734493b4$export$2e2bcd8739ae039 = $d938ace8734493b4$var$StaggeredEntrance;

});
parcelRegister("9lKHn", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $6cea4c9af6e5d926$export$e5c5a5f917a5871c);

var $5FkrB = parcelRequire("5FkrB");
var $6cea4c9af6e5d926$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);

});

parcelRegister("d64hN", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $988f2907c4571c63$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $988f2907c4571c63$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("68Vmu", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $478ffc45aa8bcd08$export$badac9ada3a0bdf9);

var $fC8ib = parcelRequire("fC8ib");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $lsgol = parcelRequire("lsgol");

var $aGJmD = parcelRequire("aGJmD");

// Export types from PopperJS / React Popper
var $478ffc45aa8bcd08$var$viewportPadding = 5;
var $478ffc45aa8bcd08$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $478ffc45aa8bcd08$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $478ffc45aa8bcd08$var$defaultChildrenFn() {
    return null;
}
var $478ffc45aa8bcd08$var$defaultOffset = [
    0,
    8
];
function $478ffc45aa8bcd08$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $478ffc45aa8bcd08$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $478ffc45aa8bcd08$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $5FkrB.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $478ffc45aa8bcd08$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $aGJmD.getMaxSizeModifiers)({
            viewportPadding: $478ffc45aa8bcd08$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($478ffc45aa8bcd08$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $5FkrB.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $lsgol.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("aGJmD", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", () => $7c8103f6c17731d3$export$6d8c2b45c99d6e3f);

var $iYJcE = parcelRequire("iYJcE");
function $7c8103f6c17731d3$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});


parcelRegister("9tRs0", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e7048b39b194fc7$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $6Nzew = parcelRequire("6Nzew");

var $5ZOby = parcelRequire("5ZOby");

var $fHqna = parcelRequire("fHqna");

var $f3GCr = parcelRequire("f3GCr");

var $5hdNS = parcelRequire("5hdNS");
function $6e7048b39b194fc7$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $f3GCr.default)(mountStrategy);
    (0, $5hdNS.default)(zIndex);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return !(0, $6Nzew.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5ZOby.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fHqna.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("6Nzew", function(module, exports) {
$parcel$export(module.exports, "fg", () => $4f32a63ed644c072$export$b40ec24ac8275656);

var $4tDFX = parcelRequire("4tDFX");
function $4f32a63ed644c072$export$ba05d765b8392e5e(flagResolver) {
    (0, $4tDFX.setBooleanResolver)(flagResolver);
}
function $4f32a63ed644c072$export$470e5c2be1411c89(name) {
    return (0, $4tDFX.resolveBooleanFlag)(name);
}
function $4f32a63ed644c072$export$b40ec24ac8275656(name) {
    return (0, $4tDFX.resolveBooleanFlag)(name);
}

});
parcelRegister("4tDFX", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $3428a5a857324a96$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $3428a5a857324a96$export$6333b6aff9fc6275);

var $jZlo3 = parcelRequire("jZlo3");

var $FjWUm = parcelRequire("FjWUm");

var $3ZMUU = parcelRequire("3ZMUU");
var $3428a5a857324a96$var$pkgName = '@atlaskit/platform-feature-flags';
var $3428a5a857324a96$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $3428a5a857324a96$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $3428a5a857324a96$var$ENV_ENABLE_PLATFORM_FF = $3428a5a857324a96$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $3428a5a857324a96$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $3428a5a857324a96$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $3428a5a857324a96$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $3428a5a857324a96$var$ENV_ENABLE_PLATFORM_FF || $3428a5a857324a96$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $3428a5a857324a96$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $3428a5a857324a96$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$3428a5a857324a96$var$globalVar[$3428a5a857324a96$export$7e41b1b2bdee3f98] = $3428a5a857324a96$var$globalVar[$3428a5a857324a96$export$7e41b1b2bdee3f98] || $3428a5a857324a96$var$DEFAULT_PFF_GLOBAL;
function $3428a5a857324a96$export$f2b591175b3e424c(resolver) {
    $3428a5a857324a96$var$globalVar[$3428a5a857324a96$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $3428a5a857324a96$export$6333b6aff9fc6275(flagKey) {
    if ($3428a5a857324a96$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $FjWUm.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $3428a5a857324a96$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $3428a5a857324a96$var$globalVar[$3428a5a857324a96$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $3428a5a857324a96$var$globalVar[$3428a5a857324a96$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $jZlo3.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $3428a5a857324a96$var$globalVar[$3428a5a857324a96$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("FjWUm", function(module, exports) {
$parcel$export(module.exports, "debug", () => $07c34dee9aa26ac3$export$1c9f709888824e05);
var $07c34dee9aa26ac3$var$_process, $07c34dee9aa26ac3$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $07c34dee9aa26ac3$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($07c34dee9aa26ac3$var$_process = globalThis.process) === null || $07c34dee9aa26ac3$var$_process === void 0 || ($07c34dee9aa26ac3$var$_process = $07c34dee9aa26ac3$var$_process.env) === null || $07c34dee9aa26ac3$var$_process === void 0 ? void 0 : $07c34dee9aa26ac3$var$_process.JEST_WORKER_ID) !== undefined;
var $07c34dee9aa26ac3$var$DEBUG_MODE = !$07c34dee9aa26ac3$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($07c34dee9aa26ac3$var$_process2 = globalThis.process) === null || $07c34dee9aa26ac3$var$_process2 === void 0 || ($07c34dee9aa26ac3$var$_process2 = $07c34dee9aa26ac3$var$_process2.env) === null || $07c34dee9aa26ac3$var$_process2 === void 0 ? void 0 : $07c34dee9aa26ac3$var$_process2.NODE_ENV) !== 'production';
var $07c34dee9aa26ac3$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$07c34dee9aa26ac3$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("5ZOby", function(module, exports) {
$parcel$export(module.exports, "default", () => $45d994097c0cb25f$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $3rpKi = parcelRequire("3rpKi");
function $45d994097c0cb25f$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $5FkrB.useMemo)(function() {
        return (0, $3rpKi.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $3rpKi.appendPortalContainerIfNotAppended)(container);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            (0, $3rpKi.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $aLeHs.createPortal)(children, container);
}

});
parcelRegister("3rpKi", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $2817dd4a3ed21424$export$26ae5ca175b4ec5a);
$parcel$export(module.exports, "removePortalContainer", () => $2817dd4a3ed21424$export$da99f98bf3fe55b3);
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $2817dd4a3ed21424$export$c582005add11e141);
$parcel$export(module.exports, "createAtlaskitPortal", () => $2817dd4a3ed21424$export$fef014d7cef9e543);
$parcel$export(module.exports, "createPortalParent", () => $2817dd4a3ed21424$export$95029ca7aca2989e);

var $k0fne = parcelRequire("k0fne");
var $2817dd4a3ed21424$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $k0fne.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $2817dd4a3ed21424$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $2817dd4a3ed21424$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $k0fne.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $k0fne.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $2817dd4a3ed21424$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $2817dd4a3ed21424$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $2817dd4a3ed21424$var$getPortalParent().removeChild(container);
};
var $2817dd4a3ed21424$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $2817dd4a3ed21424$var$getPortalParent().appendChild(container);
};
var $2817dd4a3ed21424$export$842dfe7a9f24298 = function isDocumentDefined() {
    return document !== undefined;
};
var $2817dd4a3ed21424$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($2817dd4a3ed21424$export$842dfe7a9f24298()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $k0fne.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $2817dd4a3ed21424$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($2817dd4a3ed21424$export$842dfe7a9f24298()) {
        var parentElement = document.querySelector((0, $k0fne.portalParentSelector));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $k0fne.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody2 = $2817dd4a3ed21424$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};

});
parcelRegister("k0fne", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", () => $e8ffbba2ed2914bd$export$e4c79eb95c23a0da);
$parcel$export(module.exports, "portalParentSelector", () => $e8ffbba2ed2914bd$export$72f415121273627e);
$parcel$export(module.exports, "portalClassName", () => $e8ffbba2ed2914bd$export$13f57c02915787b3);
var $e8ffbba2ed2914bd$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $e8ffbba2ed2914bd$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $e8ffbba2ed2914bd$export$13f57c02915787b3 = 'atlaskit-portal';

});



parcelRegister("fHqna", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6df543a8bbb9b47$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $6Nzew = parcelRequire("6Nzew");

var $iY9wj = parcelRequire("iY9wj");

var $3rpKi = parcelRequire("3rpKi");
function $b6df543a8bbb9b47$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $iY9wj.useIsomorphicLayoutEffect)(function() {
        var tempPortalContainer = (0, $3rpKi.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $3rpKi.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * Conditionally wrap ALL portal children with Suspense behind a feature gate for safe rollout.
   *
   * This is here because in React 18 concurrent, if you suspend from _within_ a portal to a
   * suspense boundary _outside_ a portal, our portal gets in an infinite loop of re-rendering.
   */ var conditionallySuspendedChildren = (0, $6Nzew.fg)('platform_design_system_suspend_portal_children') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Suspense), {
        fallback: null
    }, children) : children;
    return atlaskitPortal ? /*#__PURE__*/ (0, $aLeHs.createPortal)(conditionallySuspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("iY9wj", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $dcf53716d60b6394$export$700979bc83e7db82);

var $5FkrB = parcelRequire("5FkrB");
var $dcf53716d60b6394$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5FkrB.useLayoutEffect) : (0, $5FkrB.useEffect);

});


parcelRegister("f3GCr", function(module, exports) {
$parcel$export(module.exports, "default", () => $af68321895c2b1d3$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $iY9wj = parcelRequire("iY9wj");
var $af68321895c2b1d3$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $iY9wj.useIsomorphicLayoutEffect) : (0, $5FkrB.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $af68321895c2b1d3$export$2e2bcd8739ae039 = $af68321895c2b1d3$var$useIsSubsequentRender;

});

parcelRegister("5hdNS", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d793f62db63638d$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $aUMqx = parcelRequire("aUMqx");

var $d5d6Y = parcelRequire("d5d6Y");
var $3d793f62db63638d$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $5FkrB.useEffect)(function() {
        (0, $d5d6Y.default)((0, $aUMqx.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $d5d6Y.default)((0, $aUMqx.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $3d793f62db63638d$export$2e2bcd8739ae039 = $3d793f62db63638d$var$useFirePortalEvent;

});
parcelRegister("aUMqx", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", () => $7f24b2f43b273b98$export$ed5835cc67e87f72);
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", () => $7f24b2f43b273b98$export$80816bd900e5bd00);
var $7f24b2f43b273b98$export$ed5835cc67e87f72 = 'akPortalMount';
var $7f24b2f43b273b98$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("d5d6Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $9865e9a93466f458$export$2e2bcd8739ae039);
var $9865e9a93466f458$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $9865e9a93466f458$var$getLayerName = function getLayerName(zIndex) {
    return $9865e9a93466f458$var$zIndexToName.hasOwnProperty(zIndex) ? $9865e9a93466f458$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $9865e9a93466f458$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $9865e9a93466f458$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $9865e9a93466f458$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $9865e9a93466f458$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("7LfsS", function(module, exports) {
$parcel$export(module.exports, "layers", () => $5a68eb2a4c95efce$export$7be255094ccdc533);

var $dGpXj = parcelRequire("dGpXj");

var $h0N4L = parcelRequire("h0N4L");
var $5a68eb2a4c95efce$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $5a68eb2a4c95efce$export$c93026a968943f95 = 'light';
var $5a68eb2a4c95efce$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $5a68eb2a4c95efce$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $5a68eb2a4c95efce$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $5a68eb2a4c95efce$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $h0N4L.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $5a68eb2a4c95efce$export$6d8204c2cb2e06b8() / 4;
    (0, $dGpXj.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $5a68eb2a4c95efce$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $5a68eb2a4c95efce$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $5a68eb2a4c95efce$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $dGpXj.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $5a68eb2a4c95efce$export$ba1d834b86d72a09 = $5a68eb2a4c95efce$export$a1b3edb637fb4f35;
var $5a68eb2a4c95efce$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $h0N4L.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $h0N4L.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $h0N4L.N30A), ")")
            }
        }
    };
};

});
parcelRegister("dGpXj", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f6354daacc73bfd$export$2e2bcd8739ae039);

var $hm4Q3 = parcelRequire("hm4Q3");

var $3ZMUU = parcelRequire("3ZMUU");
function $9f6354daacc73bfd$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $hm4Q3.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $9f6354daacc73bfd$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $3ZMUU;
}

});
parcelRegister("hm4Q3", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca283e96b1f46976$export$2e2bcd8739ae039);
/* eslint-disable no-console */ var $ca283e96b1f46976$var$printed = {};
function $ca283e96b1f46976$export$2e2bcd8739ae039(message) {
    if ($ca283e96b1f46976$var$printed[message]) return;
    $ca283e96b1f46976$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});



parcelRegister("6PYYg", function(module, exports) {
$parcel$export(module.exports, "register", () => $4fa6cd0af20a1572$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $7QpUe = parcelRequire("7QpUe");
var $4fa6cd0af20a1572$var$registrations = new Set();
var $4fa6cd0af20a1572$var$cleanupEndEventListeners = null;
function $4fa6cd0af20a1572$var$onDragStart() {
    if ($4fa6cd0af20a1572$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $4fa6cd0af20a1572$var$cleanupEndEventListeners = (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragend',
            listener: $4fa6cd0af20a1572$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $4fa6cd0af20a1572$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $4fa6cd0af20a1572$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($4fa6cd0af20a1572$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $4fa6cd0af20a1572$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $4fa6cd0af20a1572$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $4fa6cd0af20a1572$var$cleanupEndEventListeners = null;
    var clone = Array.from($4fa6cd0af20a1572$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $4fa6cd0af20a1572$var$bindStartEvents() {
    return (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $4fa6cd0af20a1572$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $4fa6cd0af20a1572$var$onDragStart
        }
    ]);
}
var $4fa6cd0af20a1572$var$cleanupStartEventListeners = null;
function $4fa6cd0af20a1572$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$4fa6cd0af20a1572$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $4fa6cd0af20a1572$var$cleanupStartEventListeners = $4fa6cd0af20a1572$var$bindStartEvents();
    $4fa6cd0af20a1572$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $4fa6cd0af20a1572$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $4fa6cd0af20a1572$var$registrations.delete(registration);
        if ($4fa6cd0af20a1572$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $4fa6cd0af20a1572$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $4fa6cd0af20a1572$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("c0Z2u", function(module, exports) {
$parcel$export(module.exports, "show", () => $8bf4d54073dfb8d7$export$57bf213be019eeb0);

var $bgGR3 = parcelRequire("bgGR3");
// This file is a singleton for managing tooltips
var $8bf4d54073dfb8d7$var$active = null;
function $8bf4d54073dfb8d7$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($8bf4d54073dfb8d7$var$active && $8bf4d54073dfb8d7$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $bgGR3.clearScheduled)();
            $8bf4d54073dfb8d7$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $bgGR3.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $bgGR3.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $bgGR3.scheduleTimeout)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($8bf4d54073dfb8d7$var$active && $8bf4d54073dfb8d7$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($8bf4d54073dfb8d7$var$active) {
            (0, $bgGR3.clearScheduled)();
            $8bf4d54073dfb8d7$var$active.entry.hide({
                isImmediate: true
            });
            $8bf4d54073dfb8d7$var$active.entry.done();
            $8bf4d54073dfb8d7$var$active = null;
        }
        // this tooltip is now the active tooltip
        $8bf4d54073dfb8d7$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $bgGR3.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("bgGR3", function(module, exports) {
$parcel$export(module.exports, "clearScheduled", () => $83426e5de6197765$export$eaf678f6f93f5250);
$parcel$export(module.exports, "scheduleTimeout", () => $83426e5de6197765$export$5f4d6617421d489b);
var $83426e5de6197765$var$delayId = null;
function $83426e5de6197765$export$eaf678f6f93f5250() {
    if ($83426e5de6197765$var$delayId != null) {
        window.clearTimeout($83426e5de6197765$var$delayId);
        $83426e5de6197765$var$delayId = null;
    }
}
function $83426e5de6197765$export$5f4d6617421d489b(fn, delay) {
    $83426e5de6197765$export$eaf678f6f93f5250();
    $83426e5de6197765$var$delayId = window.setTimeout(function() {
        $83426e5de6197765$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("9Nvet", function(module, exports) {
$parcel$export(module.exports, "default", () => $7220eac72dce661d$export$2e2bcd8739ae039);

var $7P37d = parcelRequire("7P37d");
function $7220eac72dce661d$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $7P37d.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});
parcelRegister("7P37d", function(module, exports) {
$parcel$export(module.exports, "useIdSeed", () => $5b1fb67ed92ea032$export$6ee17796e3d70de2);

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $cGwag = parcelRequire("cGwag");
var $5b1fb67ed92ea032$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $5b1fb67ed92ea032$var$react18UseId = ($5b1fb67ed92ea032$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $5b1fb67ed92ea032$var$_React$useId !== void 0 ? $5b1fb67ed92ea032$var$_React$useId : undefined;
function $5b1fb67ed92ea032$export$f680877a34711e37() {
    if ($5b1fb67ed92ea032$var$react18UseId && (0, $cGwag.fg)('platform.design-system-team.react-18-use-id_mn8q4')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $5b1fb67ed92ea032$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $5b1fb67ed92ea032$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($5b1fb67ed92ea032$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $5b1fb67ed92ea032$export$6ee17796e3d70de2() {
    if ($5b1fb67ed92ea032$var$react18UseId && (0, $cGwag.fg)('platform.design-system-team.react-18-use-id_mn8q4')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $5b1fb67ed92ea032$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $b5lkZ.useUIDSeed)();
}

});
parcelRegister("cGwag", function(module, exports) {
$parcel$export(module.exports, "fg", () => $93c25b7a7de1f297$export$b40ec24ac8275656);

var $4TfXd = parcelRequire("4TfXd");
function $93c25b7a7de1f297$export$ba05d765b8392e5e(flagResolver) {
    (0, $4TfXd.setBooleanResolver)(flagResolver);
}
function $93c25b7a7de1f297$export$470e5c2be1411c89(name) {
    return (0, $4TfXd.resolveBooleanFlag)(name);
}
function $93c25b7a7de1f297$export$b40ec24ac8275656(name) {
    return (0, $4TfXd.resolveBooleanFlag)(name);
}

});
parcelRegister("4TfXd", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $38f8aca3031a7530$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $38f8aca3031a7530$export$6333b6aff9fc6275);

var $jZlo3 = parcelRequire("jZlo3");

var $lbgrH = parcelRequire("lbgrH");

var $3ZMUU = parcelRequire("3ZMUU");
var $38f8aca3031a7530$var$pkgName = '@atlaskit/platform-feature-flags';
var $38f8aca3031a7530$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $38f8aca3031a7530$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $38f8aca3031a7530$var$ENV_ENABLE_PLATFORM_FF = $38f8aca3031a7530$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $38f8aca3031a7530$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $38f8aca3031a7530$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $38f8aca3031a7530$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $38f8aca3031a7530$var$ENV_ENABLE_PLATFORM_FF || $38f8aca3031a7530$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $38f8aca3031a7530$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $38f8aca3031a7530$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$38f8aca3031a7530$var$globalVar[$38f8aca3031a7530$export$7e41b1b2bdee3f98] = $38f8aca3031a7530$var$globalVar[$38f8aca3031a7530$export$7e41b1b2bdee3f98] || $38f8aca3031a7530$var$DEFAULT_PFF_GLOBAL;
function $38f8aca3031a7530$export$f2b591175b3e424c(resolver) {
    $38f8aca3031a7530$var$globalVar[$38f8aca3031a7530$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $38f8aca3031a7530$export$6333b6aff9fc6275(flagKey) {
    if ($38f8aca3031a7530$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $lbgrH.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $38f8aca3031a7530$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $38f8aca3031a7530$var$globalVar[$38f8aca3031a7530$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $38f8aca3031a7530$var$globalVar[$38f8aca3031a7530$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $jZlo3.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $38f8aca3031a7530$var$globalVar[$38f8aca3031a7530$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("lbgrH", function(module, exports) {
$parcel$export(module.exports, "debug", () => $f6b761d6b749a438$export$1c9f709888824e05);
var $f6b761d6b749a438$var$_process, $f6b761d6b749a438$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $f6b761d6b749a438$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($f6b761d6b749a438$var$_process = globalThis.process) === null || $f6b761d6b749a438$var$_process === void 0 || ($f6b761d6b749a438$var$_process = $f6b761d6b749a438$var$_process.env) === null || $f6b761d6b749a438$var$_process === void 0 ? void 0 : $f6b761d6b749a438$var$_process.JEST_WORKER_ID) !== undefined;
var $f6b761d6b749a438$var$DEBUG_MODE = !$f6b761d6b749a438$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($f6b761d6b749a438$var$_process2 = globalThis.process) === null || $f6b761d6b749a438$var$_process2 === void 0 || ($f6b761d6b749a438$var$_process2 = $f6b761d6b749a438$var$_process2.env) === null || $f6b761d6b749a438$var$_process2 === void 0 ? void 0 : $f6b761d6b749a438$var$_process2.NODE_ENV) !== 'production';
var $f6b761d6b749a438$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$f6b761d6b749a438$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});





parcelRegister("fArWw", function(module, exports) {
$parcel$export(module.exports, "default", () => $b58fe4aba84c5818$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $jY1dw = parcelRequire("jY1dw");
var $6YKKQ = parcelRequire("6YKKQ");

var $h0N4L = parcelRequire("h0N4L");

var $Sw95I = parcelRequire("Sw95I");
function $b58fe4aba84c5818$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b58fe4aba84c5818$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b58fe4aba84c5818$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b58fe4aba84c5818$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b58fe4aba84c5818$var$baseStyles = null;
var $b58fe4aba84c5818$var$truncateStyles = null;
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $b58fe4aba84c5818$var$TooltipContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $5FkrB.createElement((0, $Sw95I.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $jY1dw.default)([
            "_2rko1sit _11c8qk37 _vchhusvi _p12fp3fh _bfhkpioe _syaz1i9p _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        style: $b58fe4aba84c5818$var$_objectSpread($b58fe4aba84c5818$var$_objectSpread({}, style), {}, {
            "--_yr7xfv": (0, $6YKKQ.default)("var(--ds-background-neutral-bold, ".concat((0, $h0N4L.N800), ")")),
            "--_ywovvi": (0, $6YKKQ.default)("var(--ds-text-inverse, ".concat((0, $h0N4L.N0), ")"))
        })
    }, children);
});
$b58fe4aba84c5818$var$TooltipContainer.displayName = 'TooltipContainer';
var $b58fe4aba84c5818$export$2e2bcd8739ae039 = $b58fe4aba84c5818$var$TooltipContainer;

});
parcelRegister("Sw95I", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a3dfab6ab7dbac4$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $7LfsS = parcelRequire("7LfsS");
function $0a3dfab6ab7dbac4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0a3dfab6ab7dbac4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0a3dfab6ab7dbac4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0a3dfab6ab7dbac4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0a3dfab6ab7dbac4$var$VAR_PRIMITIVE_ZINDEX = 'tooltipPrimitiveZindex';
var $0a3dfab6ab7dbac4$var$primitiveStyles = (0, $74Zh5.css)({
    zindex: "var(".concat($0a3dfab6ab7dbac4$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
/**
 * The lower level component for rendering a tooltip.
 */ var $0a3dfab6ab7dbac4$var$TooltipPrimitive = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $0a3dfab6ab7dbac4$var$_objectSpread($0a3dfab6ab7dbac4$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $0a3dfab6ab7dbac4$var$VAR_PRIMITIVE_ZINDEX, (0, $7LfsS.layers).tooltip()));
    return (0, $74Zh5.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $74Zh5.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $0a3dfab6ab7dbac4$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$0a3dfab6ab7dbac4$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $0a3dfab6ab7dbac4$export$2e2bcd8739ae039 = $0a3dfab6ab7dbac4$var$TooltipPrimitive;

});


parcelRegister("059LA", function(module, exports) {
$parcel$export(module.exports, "getMousePosition", () => $00f80b2c515c307e$export$642213d516a9b928);
function $00f80b2c515c307e$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("fmio1", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2e72c460fbdbe2d$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $eFlHW = parcelRequire("eFlHW");

var $dGLWv = parcelRequire("dGLWv");

var $dIzAm = parcelRequire("dIzAm");

var $kBPlY = parcelRequire("kBPlY");
/**
 * __Use icon button__
 *
 * A React hook that accepts a set of icon Button props,
 * and processes them to return consistent base props for usage
 * across IconButton and LinkIconButton variants.
 *
 * @private
 */ var $b2e72c460fbdbe2d$var$useIconButton = function useIconButton(_ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, autoFocus = _ref.autoFocus, buttonType = _ref.buttonType, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, label = _ref.label, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, ref = _ref.ref, shape = _ref.shape, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId;
    var isCircle = shape === 'circle';
    var baseProps = (0, $kBPlY.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dGLWv.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dIzAm.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $eFlHW.default), null, label)),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: isCircle,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return baseProps;
};
var $b2e72c460fbdbe2d$export$2e2bcd8739ae039 = $b2e72c460fbdbe2d$var$useIconButton;

});


parcelRegister("b1PNV", function(module, exports) {
$parcel$export(module.exports, "default", () => $8077f8ee52f2006a$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $59LlV = parcelRequire("59LlV");

var $1oVT1 = parcelRequire("1oVT1");

var $fmio1 = parcelRequire("fmio1");
var $8077f8ee52f2006a$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "href",
    "icon",
    "interactionName",
    "isDisabled",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip"
], $8077f8ee52f2006a$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $8077f8ee52f2006a$var$LinkIconButtonBase = function LinkIconButtonBase(_ref, ref) {
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, href = _ref.href, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $8077f8ee52f2006a$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $8077f8ee52f2006a$var$_excluded2);
    var baseProps = (0, $fmio1.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: 'link',
        icon: icon,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shape: shape,
        spacing: spacing,
        testId: testId
    });
    if (!isTooltipDisabled) {
        var _tooltip$content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1oVT1.default), {
            content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
            testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
            position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
            delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
            onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
            onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
            mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
            analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
            strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
            tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
            truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
            component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
            hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
            hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
            ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents
        }, function(triggerProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $59LlV.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
                "aria-labelledby": baseProps['aria-labelledby'],
                testId: testId,
                componentName: "LinkIconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                onMouseOver: function onMouseOver(e) {
                    var _triggerProps$onMouse, _saferRest$onMouseOve;
                    (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                    (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
                },
                onMouseOut: function onMouseOut(e) {
                    var _triggerProps$onMouse2, _saferRest$onMouseOut;
                    (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                    (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
                },
                onMouseMove: function onMouseMove(e) {
                    var _triggerProps$onMouse3, _saferRest$onMouseMov;
                    (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                    (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
                },
                onMouseDown: function onMouseDown(e) {
                    var _triggerProps$onMouse4, _saferRest$onMouseDow;
                    (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                    (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
                },
                onFocus: function onFocus(e) {
                    var _triggerProps$onFocus, _saferRest$onFocus;
                    (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                    (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
                },
                onBlur: function onBlur(e) {
                    var _triggerProps$onBlur, _saferRest$onBlur;
                    (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                    (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
                },
                onClick: function onClick(event, analyticsEvent) {
                    var _baseProps$onClick, _triggerProps$onClick;
                    baseProps === null || baseProps === void 0 || (_baseProps$onClick = baseProps.onClick) === null || _baseProps$onClick === void 0 || _baseProps$onClick.call(baseProps, event, analyticsEvent);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
                },
                ref: function ref(_ref2) {
                    var _triggerProps$ref;
                    baseProps.ref(_ref2);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$ref = triggerProps.ref) === null || _triggerProps$ref === void 0 || _triggerProps$ref.call(triggerProps, _ref2);
                },
                xcss: baseProps.xcss,
                onMouseDownCapture: baseProps.onMouseDownCapture,
                onMouseUpCapture: baseProps.onMouseUpCapture,
                onKeyDownCapture: baseProps.onKeyDownCapture,
                onKeyUpCapture: baseProps.onKeyUpCapture,
                onTouchStartCapture: baseProps.onTouchStartCapture,
                onTouchEndCapture: baseProps.onTouchEndCapture,
                onPointerDownCapture: baseProps.onPointerDownCapture,
                onPointerUpCapture: baseProps.onPointerUpCapture,
                onClickCapture: baseProps.onClickCapture,
                href: baseProps.isDisabled ? undefined : href,
                role: baseProps.isDisabled ? 'link' : undefined,
                "aria-disabled": baseProps.isDisabled === true ? true : undefined
            }), baseProps.children);
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $59LlV.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        testId: testId,
        href: baseProps.isDisabled ? undefined : href,
        role: baseProps.isDisabled ? 'link' : undefined,
        "aria-disabled": baseProps.isDisabled === true ? true : undefined,
        componentName: "LinkIconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }), baseProps.children);
};
// Workarounds to support generic types with forwardRef + memo
var $8077f8ee52f2006a$var$WithRef = /*#__PURE__*/ (0, $5FkrB.forwardRef)($8077f8ee52f2006a$var$LinkIconButtonBase);
/**
 * __Link Icon Button__
 *
 * Renders a link in the style of an icon button.
 *
 * - [Examples](https://atlassian.design/components/button/link-icon-button/examples)
 * - [Code](https://atlassian.design/components/button/link-icon-button/code)
 * - [Usage](https://atlassian.design/components/button/link-icon-button/usage)
 */ var $8077f8ee52f2006a$var$LinkIconButton = /*#__PURE__*/ (0, $5FkrB.memo)($8077f8ee52f2006a$var$WithRef);
var $8077f8ee52f2006a$export$2e2bcd8739ae039 = $8077f8ee52f2006a$var$LinkIconButton;

});

parcelRegister("c0yaC", function(module, exports) {
$parcel$export(module.exports, "SplitButton", () => $8bdffda66d351be4$export$651ad66661acd392);

var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $7Nmik = parcelRequire("7Nmik");

var $7OBJ1 = parcelRequire("7OBJ1");

var $7RmFb = parcelRequire("7RmFb");
function $8bdffda66d351be4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8bdffda66d351be4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8bdffda66d351be4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8bdffda66d351be4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8bdffda66d351be4$var$baseDividerStyles = (0, $74Zh5.css)({
    width: "var(--ds-border-width, 1px)",
    position: 'relative',
    // This is 1 so it appears above buttons by default.
    // When buttons are selected they have a zIndex of 2 applied.
    // See use-button-base.tsx.
    zIndex: 1
});
var $8bdffda66d351be4$var$dividerDisabledStyles = (0, $74Zh5.css)({
    backgroundColor: "var(--ds-text-disabled, #091E4224)",
    cursor: 'not-allowed',
    opacity: 0.51
});
var $8bdffda66d351be4$var$dividerDisabledRefreshedStyles = (0, $74Zh5.css)({
    backgroundColor: "var(--ds-border-disabled, #091E4224)",
    cursor: 'not-allowed'
});
var $8bdffda66d351be4$var$dividerAppearance = {
    default: (0, $74Zh5.css)({
        backgroundColor: "var(--ds-text, #172B4D)",
        opacity: 0.51
    }),
    primary: (0, $74Zh5.css)({
        backgroundColor: "var(--ds-text-inverse, #FFF)",
        opacity: 0.64
    }),
    navigation: (0, $74Zh5.css)({
        height: '16px',
        margin: "var(--ds-space-100, 8px)".concat(" -0.5px"),
        backgroundColor: "var(--ds-text-subtle, #0052cc)",
        opacity: 0.62
    })
};
var $8bdffda66d351be4$var$dividerRefreshedAppearance = $8bdffda66d351be4$var$_objectSpread($8bdffda66d351be4$var$_objectSpread({}, $8bdffda66d351be4$var$dividerAppearance), {}, {
    default: (0, $74Zh5.css)({
        backgroundColor: "var(--ds-border, #091E4224)"
    }),
    primary: (0, $74Zh5.css)({
        backgroundColor: "var(--ds-border-inverse, #FFF)",
        opacity: 0.64
    })
});
var $8bdffda66d351be4$var$dividerRefreshedOffsetStyles = (0, $74Zh5.css)({
    marginInline: "calc(0px - ".concat("var(--ds-border-width, 1px)", ")")
});
var $8bdffda66d351be4$var$dividerHeight = {
    default: (0, $74Zh5.css)({
        height: "".concat(32 / 14, "em")
    }),
    compact: (0, $74Zh5.css)({
        height: "".concat(24 / 14, "em")
    })
};
var $8bdffda66d351be4$var$dividerHeightWithRem = {
    default: (0, $74Zh5.css)({
        height: '2rem'
    }),
    compact: (0, $74Zh5.css)({
        height: '1.5rem'
    })
};
var $8bdffda66d351be4$var$defaultDividerHeight = {
    // The divider height is calculated by subtracting twice the border width from the button height.
    // This ensures the divider does not intersect with the button's border, avoiding visual issues
    // caused by overlapping alpha colors (color.border) at the intersection.
    default: (0, $74Zh5.css)({
        height: "calc(".concat(32 / 14, "em - ", "var(--ds-border-width, 1px)", " - ", "var(--ds-border-width, 1px)", ")")
    }),
    compact: (0, $74Zh5.css)({
        height: "calc(".concat(24 / 14, "em - ", "var(--ds-border-width, 1px)", " - ", "var(--ds-border-width, 1px)", ")")
    })
};
var $8bdffda66d351be4$var$defaultDividerHeightWithRem = {
    // The divider height is calculated by subtracting twice the border width from the button height.
    // This ensures the divider does not intersect with the button's border, avoiding visual issues
    // caused by overlapping alpha colors (color.border) at the intersection.
    default: (0, $74Zh5.css)({
        height: "calc(2rem - ".concat("var(--ds-border-width, 1px)", " - ", "var(--ds-border-width, 1px)", ")")
    }),
    compact: (0, $74Zh5.css)({
        height: "calc(1.5rem - ".concat("var(--ds-border-width, 1px)", " - ", "var(--ds-border-width, 1px)", ")")
    })
};
var $8bdffda66d351be4$export$2e0a83ec2e27ecbb = function Divider(_ref) {
    var appearance = _ref.appearance, spacing = _ref.spacing, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled;
    // Pulling these out of the below `css` prop to avoid nested ternaries
    var defaultDividerHeightStyles = (0, $7Nmik.fg)('platform_dst_button_replace_em_with_rem') ? $8bdffda66d351be4$var$defaultDividerHeightWithRem : $8bdffda66d351be4$var$defaultDividerHeight;
    var dividerHeightStyles = (0, $7Nmik.fg)('platform_dst_button_replace_em_with_rem') ? $8bdffda66d351be4$var$dividerHeightWithRem : $8bdffda66d351be4$var$dividerHeight;
    return(// I find it funny to provide a div for Divider
    (0, $74Zh5.jsx)("div", {
        css: [
            $8bdffda66d351be4$var$baseDividerStyles,
            appearance === 'default' && !isDisabled && (0, $7Nmik.fg)('platform-component-visual-refresh') ? defaultDividerHeightStyles[spacing] : dividerHeightStyles[spacing],
            isDisabled && ((0, $7Nmik.fg)('platform-component-visual-refresh') ? $8bdffda66d351be4$var$dividerDisabledRefreshedStyles : $8bdffda66d351be4$var$dividerDisabledStyles),
            !isDisabled && ((0, $7Nmik.fg)('platform-component-visual-refresh') ? $8bdffda66d351be4$var$dividerRefreshedAppearance[appearance] : $8bdffda66d351be4$var$dividerAppearance[appearance]),
            (0, $7Nmik.fg)('platform-component-visual-refresh') && $8bdffda66d351be4$var$dividerRefreshedOffsetStyles
        ]
    }));
};
var $8bdffda66d351be4$var$splitButtonStyles = (0, $74Zh5.css)({
    display: 'inline-flex',
    position: 'relative',
    alignItems: 'center',
    whiteSpace: 'nowrap'
});
var $8bdffda66d351be4$var$primaryButtonStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    'button,a': {
        borderEndEndRadius: 0,
        borderStartEndRadius: 0
    }
});
var $8bdffda66d351be4$var$secondaryButtonStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    'button,a': {
        borderEndStartRadius: 0,
        borderStartStartRadius: 0
    }
});
var $8bdffda66d351be4$var$defaultAppearanceContainerStyles = (0, $74Zh5.css)({
    borderRadius: "var(--ds-border-radius, 3px)",
    outlineColor: "var(--ds-border, #091E4224)",
    outlineOffset: "calc(0px - ".concat("var(--ds-border-width, 1px)", ")"),
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width, 1px)"
});
var $8bdffda66d351be4$export$994ba1b4c598f7 = function SplitButtonContainer(_ref2) {
    var appearance = _ref2.appearance, children = _ref2.children, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled;
    return (0, $74Zh5.jsx)("div", {
        css: [
            appearance === 'default' && !isDisabled && (0, $7Nmik.fg)('platform-component-visual-refresh') && $8bdffda66d351be4$var$defaultAppearanceContainerStyles,
            $8bdffda66d351be4$var$splitButtonStyles
        ]
    }, children);
};
var $8bdffda66d351be4$export$651ad66661acd392 = function SplitButton(_ref3) {
    var children = _ref3.children, _ref3$appearance = _ref3.appearance, appearance = _ref3$appearance === void 0 ? 'default' : _ref3$appearance, _ref3$spacing = _ref3.spacing, spacing = _ref3$spacing === void 0 ? 'default' : _ref3$spacing, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? false : _ref3$isDisabled;
    var _getActions = (0, $7RmFb.getActions)(children), PrimaryAction = _getActions.PrimaryAction, SecondaryAction = _getActions.SecondaryAction;
    return (0, $74Zh5.jsx)($8bdffda66d351be4$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled
    }, (0, $74Zh5.jsx)((0, $7OBJ1.SplitButtonContext).Provider, {
        value: {
            appearance: appearance,
            spacing: spacing,
            isDisabled: isDisabled
        }
    }, (0, $74Zh5.jsx)("div", {
        css: $8bdffda66d351be4$var$primaryButtonStyles
    }, PrimaryAction), (0, $74Zh5.jsx)($8bdffda66d351be4$export$2e0a83ec2e27ecbb, {
        appearance: appearance,
        spacing: spacing,
        isDisabled: isDisabled
    }), (0, $74Zh5.jsx)("div", {
        css: $8bdffda66d351be4$var$secondaryButtonStyles
    }, SecondaryAction)));
};
var $8bdffda66d351be4$export$e3ca81100b492e15 = function SplitButtonWithSlots(_ref4) {
    var primaryAction = _ref4.primaryAction, secondaryAction = _ref4.secondaryAction, _ref4$appearance = _ref4.appearance, appearance = _ref4$appearance === void 0 ? 'default' : _ref4$appearance, _ref4$spacing = _ref4.spacing, spacing = _ref4$spacing === void 0 ? 'default' : _ref4$spacing, _ref4$isDisabled = _ref4.isDisabled, isDisabled = _ref4$isDisabled === void 0 ? false : _ref4$isDisabled;
    return (0, $74Zh5.jsx)($8bdffda66d351be4$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled
    }, (0, $74Zh5.jsx)((0, $7OBJ1.SplitButtonContext).Provider, {
        value: {
            appearance: appearance,
            spacing: spacing,
            isDisabled: isDisabled
        }
    }, (0, $74Zh5.jsx)("div", {
        css: $8bdffda66d351be4$var$primaryButtonStyles
    }, primaryAction), (0, $74Zh5.jsx)($8bdffda66d351be4$export$2e0a83ec2e27ecbb, {
        appearance: appearance,
        spacing: spacing,
        isDisabled: isDisabled
    }), (0, $74Zh5.jsx)("div", {
        css: $8bdffda66d351be4$var$secondaryButtonStyles
    }, secondaryAction)));
};

});
parcelRegister("7RmFb", function(module, exports) {
$parcel$export(module.exports, "getActions", () => $5b8f101d545dd71b$export$fe3955935f564b31);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $3ZMUU = parcelRequire("3ZMUU");
var $5b8f101d545dd71b$export$fe3955935f564b31 = function getActions(children) {
    var _Children$toArray = (0, $5FkrB.Children).toArray(children), _Children$toArray2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Children$toArray, 2), PrimaryAction = _Children$toArray2[0], SecondaryAction = _Children$toArray2[1];
    typeof $3ZMUU;
    return {
        PrimaryAction: PrimaryAction,
        SecondaryAction: SecondaryAction
    };
};

});



parcelRegister("4qBHc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3396d4b8d139bb82$var$Environment;
(function(Environment) {
    Environment["TEST"] = "test";
    Environment["LOCAL"] = "local";
    Environment["DEV"] = "dev";
    Environment["STAGE"] = "stage";
    Environment["PROD"] = "prod";
})($3396d4b8d139bb82$var$Environment = module.exports.Environment || (module.exports.Environment = {}));
var $3396d4b8d139bb82$var$XIDItemType;
(function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
})($3396d4b8d139bb82$var$XIDItemType = module.exports.XIDItemType || (module.exports.XIDItemType = {}));
var $3396d4b8d139bb82$var$XIDState;
(function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
})($3396d4b8d139bb82$var$XIDState = module.exports.XIDState || (module.exports.XIDState = {}));
var $3396d4b8d139bb82$var$XIDGenerateMode;
(function(XIDGenerateMode) {
    XIDGenerateMode["XC_ONLY"] = "XC_ONLY";
    XIDGenerateMode["UID_ONLY"] = "UID_ONLY";
    XIDGenerateMode["CACHE_ONLY"] = "CACHE_ONLY";
    XIDGenerateMode["XC_UID"] = "XC_UID";
    XIDGenerateMode["CACHE_XC_UID"] = "CACHE_XC_UID";
})($3396d4b8d139bb82$var$XIDGenerateMode = module.exports.XIDGenerateMode || (module.exports.XIDGenerateMode = {}));

});

parcelRegister("7UOcZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $5c34b5b787a35ef6$export$2e2bcd8739ae039);

var $1lpW0 = parcelRequire("1lpW0");

var $7Apz3 = parcelRequire("7Apz3");

var $a301b = parcelRequire("a301b");
// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var $5c34b5b787a35ef6$var$setTimeoutFunc = setTimeout;
function $5c34b5b787a35ef6$var$isArray(x) {
    return Boolean(x && typeof x.length !== 'undefined');
}
function $5c34b5b787a35ef6$var$noop() {}
// Polyfill for Function.prototype.bind
function $5c34b5b787a35ef6$var$bind(fn, thisArg) {
    return function() {
        fn.apply(thisArg, arguments);
    };
}
/**
 * @constructor
 * @param {Function} fn
 */ function $5c34b5b787a35ef6$var$Promise(fn) {
    if (!(this instanceof $5c34b5b787a35ef6$var$Promise)) throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('not a function');
    /** @type {!number} */ this._state = 0;
    /** @type {!boolean} */ this._handled = false;
    /** @type {Promise|undefined} */ this._value = undefined;
    /** @type {!Array<!Function>} */ this._deferreds = [];
    $5c34b5b787a35ef6$var$doResolve(fn, this);
}
function $5c34b5b787a35ef6$var$handle(self, deferred) {
    while(self._state === 3)self = self._value;
    if (self._state === 0) {
        self._deferreds.push(deferred);
        return;
    }
    self._handled = true;
    $5c34b5b787a35ef6$var$Promise._immediateFn(function() {
        var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
        if (cb === null) {
            (self._state === 1 ? $5c34b5b787a35ef6$var$resolve : $5c34b5b787a35ef6$var$reject)(deferred.promise, self._value);
            return;
        }
        var ret;
        try {
            ret = cb(self._value);
        } catch (e) {
            $5c34b5b787a35ef6$var$reject(deferred.promise, e);
            return;
        }
        $5c34b5b787a35ef6$var$resolve(deferred.promise, ret);
    });
}
function $5c34b5b787a35ef6$var$resolve(self, newValue) {
    try {
        // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
        if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
        if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
            var then = newValue.then;
            if (newValue instanceof $5c34b5b787a35ef6$var$Promise) {
                self._state = 3;
                self._value = newValue;
                $5c34b5b787a35ef6$var$finale(self);
                return;
            } else if (typeof then === 'function') {
                $5c34b5b787a35ef6$var$doResolve($5c34b5b787a35ef6$var$bind(then, newValue), self);
                return;
            }
        }
        self._state = 1;
        self._value = newValue;
        $5c34b5b787a35ef6$var$finale(self);
    } catch (e) {
        $5c34b5b787a35ef6$var$reject(self, e);
    }
}
function $5c34b5b787a35ef6$var$reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    $5c34b5b787a35ef6$var$finale(self);
}
function $5c34b5b787a35ef6$var$finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) $5c34b5b787a35ef6$var$Promise._immediateFn(function() {
        if (!self._handled) $5c34b5b787a35ef6$var$Promise._unhandledRejectionFn(self._value);
    });
    for(var i = 0, len = self._deferreds.length; i < len; i++)$5c34b5b787a35ef6$var$handle(self, self._deferreds[i]);
    self._deferreds = null;
}
/**
 * @constructor
 */ function $5c34b5b787a35ef6$var$Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
}
/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */ function $5c34b5b787a35ef6$var$doResolve(fn, self) {
    var done = false;
    try {
        fn(function(value) {
            if (done) return;
            done = true;
            $5c34b5b787a35ef6$var$resolve(self, value);
        }, function(reason) {
            if (done) return;
            done = true;
            $5c34b5b787a35ef6$var$reject(self, reason);
        });
    } catch (ex) {
        if (done) return;
        done = true;
        $5c34b5b787a35ef6$var$reject(self, ex);
    }
}
$5c34b5b787a35ef6$var$Promise.prototype['catch'] = function(onRejected) {
    return this.then(null, onRejected);
};
$5c34b5b787a35ef6$var$Promise.prototype.then = function(onFulfilled, onRejected) {
    // @ts-ignore
    var prom = new this.constructor($5c34b5b787a35ef6$var$noop);
    $5c34b5b787a35ef6$var$handle(this, new $5c34b5b787a35ef6$var$Handler(onFulfilled, onRejected, prom));
    return prom;
};
$5c34b5b787a35ef6$var$Promise.prototype['finally'] = (0, $1lpW0.default);
$5c34b5b787a35ef6$var$Promise.all = function(arr) {
    return new $5c34b5b787a35ef6$var$Promise(function(resolve, reject) {
        if (!$5c34b5b787a35ef6$var$isArray(arr)) return reject(new TypeError('Promise.all accepts an array'));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            try {
                if (val && (typeof val === 'object' || typeof val === 'function')) {
                    var then = val.then;
                    if (typeof then === 'function') {
                        then.call(val, function(val) {
                            res(i, val);
                        }, reject);
                        return;
                    }
                }
                args[i] = val;
                if (--remaining === 0) resolve(args);
            } catch (ex) {
                reject(ex);
            }
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
};
$5c34b5b787a35ef6$var$Promise.any = (0, $a301b.default);
$5c34b5b787a35ef6$var$Promise.allSettled = (0, $7Apz3.default);
$5c34b5b787a35ef6$var$Promise.resolve = function(value) {
    if (value && typeof value === 'object' && value.constructor === $5c34b5b787a35ef6$var$Promise) return value;
    return new $5c34b5b787a35ef6$var$Promise(function(resolve) {
        resolve(value);
    });
};
$5c34b5b787a35ef6$var$Promise.reject = function(value) {
    return new $5c34b5b787a35ef6$var$Promise(function(resolve, reject) {
        reject(value);
    });
};
$5c34b5b787a35ef6$var$Promise.race = function(arr) {
    return new $5c34b5b787a35ef6$var$Promise(function(resolve, reject) {
        if (!$5c34b5b787a35ef6$var$isArray(arr)) return reject(new TypeError('Promise.race accepts an array'));
        for(var i = 0, len = arr.length; i < len; i++)$5c34b5b787a35ef6$var$Promise.resolve(arr[i]).then(resolve, reject);
    });
};
// Use polyfill for setImmediate for performance gains
$5c34b5b787a35ef6$var$Promise._immediateFn = // @ts-ignore
typeof setImmediate === 'function' && function(fn) {
    // @ts-ignore
    setImmediate(fn);
} || function(fn) {
    $5c34b5b787a35ef6$var$setTimeoutFunc(fn, 0);
};
$5c34b5b787a35ef6$var$Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
};
var $5c34b5b787a35ef6$export$2e2bcd8739ae039 = $5c34b5b787a35ef6$var$Promise;

});
parcelRegister("1lpW0", function(module, exports) {
$parcel$export(module.exports, "default", () => $0fabdea6eb005102$export$2e2bcd8739ae039);
/**
 * @this {Promise}
 */ function $0fabdea6eb005102$var$finallyConstructor(callback) {
    var constructor = this.constructor;
    return this.then(function(value) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            return value;
        });
    }, function(reason) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            // @ts-ignore
            return constructor.reject(reason);
        });
    });
}
var $0fabdea6eb005102$export$2e2bcd8739ae039 = $0fabdea6eb005102$var$finallyConstructor;

});

parcelRegister("7Apz3", function(module, exports) {
$parcel$export(module.exports, "default", () => $585fb9c186935d92$export$2e2bcd8739ae039);
function $585fb9c186935d92$var$allSettled(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== 'undefined')) return reject(new TypeError(typeof arr + ' ' + arr + ' is not iterable(cannot read property Symbol(Symbol.iterator))'));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            if (val && (typeof val === 'object' || typeof val === 'function')) {
                var then = val.then;
                if (typeof then === 'function') {
                    then.call(val, function(val) {
                        res(i, val);
                    }, function(e) {
                        args[i] = {
                            status: 'rejected',
                            reason: e
                        };
                        if (--remaining === 0) resolve(args);
                    });
                    return;
                }
            }
            args[i] = {
                status: 'fulfilled',
                value: val
            };
            if (--remaining === 0) resolve(args);
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
}
var $585fb9c186935d92$export$2e2bcd8739ae039 = $585fb9c186935d92$var$allSettled;

});

parcelRegister("a301b", function(module, exports) {
$parcel$export(module.exports, "default", () => $750a32cd72385239$export$2e2bcd8739ae039);
/**
 * @constructor
 */ function $750a32cd72385239$var$AggregateError(errors, message) {
    this.name = 'AggregateError', this.errors = errors;
    this.message = message || '';
}
$750a32cd72385239$var$AggregateError.prototype = Error.prototype;
function $750a32cd72385239$var$any(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== 'undefined')) return reject(new TypeError('Promise.any accepts an array'));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return reject();
        var rejectionReasons = [];
        for(var i = 0; i < args.length; i++)try {
            P.resolve(args[i]).then(resolve).catch(function(error) {
                rejectionReasons.push(error);
                if (rejectionReasons.length === args.length) reject(new $750a32cd72385239$var$AggregateError(rejectionReasons, 'All promises were rejected'));
            });
        } catch (ex) {
            reject(ex);
        }
    });
}
var $750a32cd72385239$export$2e2bcd8739ae039 = $750a32cd72385239$var$any;

});


parcelRegister("bAhZ8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $86f101f6cbb0f65e$var$_react = $86f101f6cbb0f65e$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $86f101f6cbb0f65e$var$_spinner = $86f101f6cbb0f65e$var$_interopRequireDefault((parcelRequire("98ZMc")));
function $86f101f6cbb0f65e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $86f101f6cbb0f65e$var$LoadingSpinner = function LoadingSpinner() {
    return /*#__PURE__*/ $86f101f6cbb0f65e$var$_react["default"].createElement("div", {
        style: $86f101f6cbb0f65e$var$spinnerStyles
    }, /*#__PURE__*/ $86f101f6cbb0f65e$var$_react["default"].createElement($86f101f6cbb0f65e$var$_spinner["default"], {
        interactionName: "load",
        size: "xlarge"
    }));
};
var $86f101f6cbb0f65e$var$_default = module.exports["default"] = $86f101f6cbb0f65e$var$LoadingSpinner;
var $86f101f6cbb0f65e$var$spinnerStyles = {
    position: 'fixed',
    left: '50%',
    top: '350px'
};

});
parcelRegister("98ZMc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("QCI6S")).default);

var $QCI6S = parcelRequire("QCI6S");

});
parcelRegister("QCI6S", function(module, exports) {
$parcel$export(module.exports, "default", () => $09e2e288466f605e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $dLn3G = parcelRequire("dLn3G");

var $kfcAZ = parcelRequire("kfcAZ");

var $iwXJJ = parcelRequire("iwXJJ");
/**
 * Returns the appropriate circle stroke color.
 */ function $09e2e288466f605e$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $kfcAZ.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $kfcAZ.N0), ")");
}
var $09e2e288466f605e$var$rotate = (0, $74Zh5.keyframes)({
    to: {
        transform: 'rotate(360deg)'
    }
});
var $09e2e288466f605e$var$rotateStyles = (0, $74Zh5.css)({
    animation: "".concat($09e2e288466f605e$var$rotate, " 0.86s infinite"),
    animationTimingFunction: 'cubic-bezier(0.4, 0.15, 0.6, 0.85)',
    transformOrigin: 'center'
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $09e2e288466f605e$var$loadIn = (0, $74Zh5.keyframes)({
    from: {
        transform: 'rotate(50deg)',
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: 'rotate(230deg)',
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $09e2e288466f605e$var$loadInStyles = (0, $74Zh5.css)({
    animation: "".concat($09e2e288466f605e$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: 'forwards',
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $09e2e288466f605e$var$wrapperStyles = (0, $74Zh5.css)({
    display: 'inline-flex',
    /**
   * Align better inline with text.
   */ verticalAlign: 'middle'
});
var $09e2e288466f605e$var$circleStyles = (0, $74Zh5.css)({
    fill: 'none',
    strokeDasharray: 60,
    strokeDashoffset: 'inherit',
    strokeLinecap: 'round',
    strokeWidth: 1.5,
    '@media screen and (forced-colors: active)': {
        filter: 'grayscale(100%)',
        stroke: 'CanvasText'
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $09e2e288466f605e$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $09e2e288466f605e$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $iwXJJ.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $09e2e288466f605e$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $dLn3G.default));
    $09e2e288466f605e$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $74Zh5.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $09e2e288466f605e$var$wrapperStyles,
            $09e2e288466f605e$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $74Zh5.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $09e2e288466f605e$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none'
    }, (0, $74Zh5.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $09e2e288466f605e$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $09e2e288466f605e$export$2e2bcd8739ae039 = $09e2e288466f605e$var$Spinner;

});
parcelRegister("kfcAZ", function(module, exports) {
$parcel$export(module.exports, "N0", () => $ebcefa9befae152b$export$29a4f05edc054374);
$parcel$export(module.exports, "N500", () => $ebcefa9befae152b$export$c39c0fe0f26207ae);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $ebcefa9befae152b$export$4b84fd0e2c617bd = '#FFEBE6';
var $ebcefa9befae152b$export$b34b069eff244586 = '#FFBDAD';
var $ebcefa9befae152b$export$be802dd0d8b57f35 = '#FF8F73';
var $ebcefa9befae152b$export$60847d42f9da92a6 = '#FF7452';
var $ebcefa9befae152b$export$4a7404f376229999 = '#FF5630';
var $ebcefa9befae152b$export$2010d0fb4295b346 = '#DE350B';
var $ebcefa9befae152b$export$2837b5a1a71d5c02 = '#BF2600';
var $ebcefa9befae152b$export$8d9596b529bbb9cf = '#FFFAE6';
var $ebcefa9befae152b$export$41060a744ab0b7ae = '#FFF0B3';
var $ebcefa9befae152b$export$1cc05bbbf340e559 = '#FFE380';
var $ebcefa9befae152b$export$5aae31392d72caaa = '#FFC400';
var $ebcefa9befae152b$export$c6930421db9fa514 = '#FFAB00';
var $ebcefa9befae152b$export$59619663aa6500fb = '#FF991F';
var $ebcefa9befae152b$export$874739ea9e379ab6 = '#FF8B00';
var $ebcefa9befae152b$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $ebcefa9befae152b$export$69a3bf21b9686c2b = '#ABF5D1';
var $ebcefa9befae152b$export$afbce1382ec95f73 = '#79F2C0';
var $ebcefa9befae152b$export$747d86715d4175de = '#57D9A3';
var $ebcefa9befae152b$export$940e1f69e873f202 = '#36B37E';
var $ebcefa9befae152b$export$a49394138f7b8e85 = '#00875A';
var $ebcefa9befae152b$export$6fa04827ac68a4fb = '#006644';
var $ebcefa9befae152b$export$226de0355ed012f8 = '#DEEBFF';
var $ebcefa9befae152b$export$8c13c2ee36917869 = '#B3D4FF';
var $ebcefa9befae152b$export$ecfc1dff386a3e7a = '#4C9AFF';
var $ebcefa9befae152b$export$215b7063051591f1 = '#2684FF';
var $ebcefa9befae152b$export$e62e8919cca44969 = '#0065FF';
var $ebcefa9befae152b$export$b3de0ae08da2ce64 = '#0052CC';
var $ebcefa9befae152b$export$a6ee3d71bc067634 = '#0747A6';
var $ebcefa9befae152b$export$67f15409e87642a1 = '#669DF1';
var $ebcefa9befae152b$export$f0539dbc42dbb067 = '#8FB8F6';
var $ebcefa9befae152b$export$363e4475840015bb = '#EAE6FF';
var $ebcefa9befae152b$export$4b0a4417ed59760f = '#C0B6F2';
var $ebcefa9befae152b$export$6011520a64d9a187 = '#998DD9';
var $ebcefa9befae152b$export$a7175d4e9206bc80 = '#8777D9';
var $ebcefa9befae152b$export$b48405b95304b5a1 = '#6554C0';
var $ebcefa9befae152b$export$c71e4279dd54a18d = '#5243AA';
var $ebcefa9befae152b$export$147899de772240ec = '#403294';
var $ebcefa9befae152b$export$2cf711fe14c66f06 = '#E6FCFF';
var $ebcefa9befae152b$export$7a8f4d33f6f9772c = '#B3F5FF';
var $ebcefa9befae152b$export$776c9c497ef08533 = '#79E2F2';
var $ebcefa9befae152b$export$69cb3ca10c1e330e = '#00C7E6';
var $ebcefa9befae152b$export$9dc1ef0f3f48059b = '#00B8D9';
var $ebcefa9befae152b$export$7c835c78b6fcdef8 = '#00A3BF';
var $ebcefa9befae152b$export$6036577f95c3877e = '#008DA6';
var $ebcefa9befae152b$export$29a4f05edc054374 = '#FFFFFF';
var $ebcefa9befae152b$export$e655ef011c4aa1a2 = '#FAFBFC';
var $ebcefa9befae152b$export$9fdfb749e33cdf97 = '#F4F5F7';
var $ebcefa9befae152b$export$3e51e8f1440314ba = '#EBECF0';
var $ebcefa9befae152b$export$1ce2d1575d444ceb = '#DFE1E6';
var $ebcefa9befae152b$export$8754fc7e6d8b3000 = '#C1C7D0';
var $ebcefa9befae152b$export$c2e91cbeada39b8b = '#B3BAC5';
var $ebcefa9befae152b$export$5f71e19f3a7ad9de = '#A5ADBA';
var $ebcefa9befae152b$export$eaa8c8a70ac22806 = '#97A0AF';
var $ebcefa9befae152b$export$7c87d337fb91a97d = '#8993A4';
var $ebcefa9befae152b$export$d6447c357493214f = '#7A869A';
var $ebcefa9befae152b$export$f563ee71e9ee74cd = '#6B778C';
var $ebcefa9befae152b$export$e2ef2124cf4024b1 = '#5E6C84';
var $ebcefa9befae152b$export$eece5f492e429f08 = '#505F79';
var $ebcefa9befae152b$export$c39c0fe0f26207ae = '#42526E';
var $ebcefa9befae152b$export$7090862dc3038a9f = '#344563';
var $ebcefa9befae152b$export$ad0bacf983b7ddaa = '#253858';
var $ebcefa9befae152b$export$7d61b15e0da132af = '#172B4D';
var $ebcefa9befae152b$export$fbda843f0a27fe96 = '#091E42';
var $ebcefa9befae152b$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $ebcefa9befae152b$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $ebcefa9befae152b$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $ebcefa9befae152b$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $ebcefa9befae152b$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $ebcefa9befae152b$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $ebcefa9befae152b$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $ebcefa9befae152b$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $ebcefa9befae152b$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $ebcefa9befae152b$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $ebcefa9befae152b$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $ebcefa9befae152b$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $ebcefa9befae152b$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $ebcefa9befae152b$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $ebcefa9befae152b$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $ebcefa9befae152b$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $ebcefa9befae152b$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $ebcefa9befae152b$export$2f6319cf7d736c2a = '#E6EDFA';
var $ebcefa9befae152b$export$95126bc8884d6634 = '#DCE5F5';
var $ebcefa9befae152b$export$8338d8c35d44ff1 = '#CED9EB';
var $ebcefa9befae152b$export$5368d76ae4fbbda7 = '#B8C7E0';
var $ebcefa9befae152b$export$9f0a771d16ec8d36 = '#ABBBD6';
var $ebcefa9befae152b$export$abcf8c38338b4aa5 = '#9FB0CC';
var $ebcefa9befae152b$export$97e81faa16a182c7 = '#8C9CB8';
var $ebcefa9befae152b$export$bfe21c59123ecf33 = '#7988A3';
var $ebcefa9befae152b$export$ee82aa2ea6a1558 = '#67758F';
var $ebcefa9befae152b$export$682927c6ed76be02 = '#56637A';
var $ebcefa9befae152b$export$91fd9994c5be9757 = '#455166';
var $ebcefa9befae152b$export$d281fbfe3cff2df6 = '#3B475C';
var $ebcefa9befae152b$export$3902c91d8b98a753 = '#313D52';
var $ebcefa9befae152b$export$8e8133c1ba5845b5 = '#283447';
var $ebcefa9befae152b$export$33ff357f6620b39 = '#202B3D';
var $ebcefa9befae152b$export$633847cf062b69e0 = '#1B2638';
var $ebcefa9befae152b$export$9776a6e503bdbf76 = '#121A29';
var $ebcefa9befae152b$export$6c813d5160dff5db = '#0E1624';
var $ebcefa9befae152b$export$3d4f271a500072a = '#0D1424';
var $ebcefa9befae152b$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $ebcefa9befae152b$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $ebcefa9befae152b$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $ebcefa9befae152b$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $ebcefa9befae152b$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $ebcefa9befae152b$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $ebcefa9befae152b$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $ebcefa9befae152b$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $ebcefa9befae152b$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $ebcefa9befae152b$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $ebcefa9befae152b$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $ebcefa9befae152b$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $ebcefa9befae152b$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $ebcefa9befae152b$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $ebcefa9befae152b$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $ebcefa9befae152b$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $ebcefa9befae152b$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $ebcefa9befae152b$export$d2adc5dedf09fced = '#292A2E';
var $ebcefa9befae152b$export$f51762073d2bb381 = '#94C748';
var $ebcefa9befae152b$export$95e26d54def96891 = '#B3DF72';

});

parcelRegister("iwXJJ", function(module, exports) {
$parcel$export(module.exports, "presetSizes", () => $d7d98d9eb3c243a0$export$4e9f1640bbe7a1a8);
var $d7d98d9eb3c243a0$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("6JfQX", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e633e29480db1dc$export$2e2bcd8739ae039);

var $g41Mq = parcelRequire("g41Mq");

var $2XSqJ = parcelRequire("2XSqJ");

var $aZ1fh = parcelRequire("aZ1fh");
function $4e633e29480db1dc$var$v4(options, buf, offset) {
    if ((0, $g41Mq.default).randomUUID && !buf && !options) return (0, $g41Mq.default).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $2XSqJ.default)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $aZ1fh.unsafeStringify)(rnds);
}
var $4e633e29480db1dc$export$2e2bcd8739ae039 = $4e633e29480db1dc$var$v4;

});
parcelRegister("g41Mq", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb1e66910c70589f$export$2e2bcd8739ae039);
const $bb1e66910c70589f$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $bb1e66910c70589f$export$2e2bcd8739ae039 = {
    randomUUID: $bb1e66910c70589f$var$randomUUID
};

});

parcelRegister("2XSqJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $228b5021bd25790a$export$2e2bcd8739ae039);
let $228b5021bd25790a$var$getRandomValues;
const $228b5021bd25790a$var$rnds8 = new Uint8Array(16);
function $228b5021bd25790a$export$2e2bcd8739ae039() {
    if (!$228b5021bd25790a$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $228b5021bd25790a$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $228b5021bd25790a$var$getRandomValues($228b5021bd25790a$var$rnds8);
}

});

parcelRegister("aZ1fh", function(module, exports) {
$parcel$export(module.exports, "unsafeStringify", () => $7ff09135a273f813$export$8fb373d660548968);

var $j24O5 = parcelRequire("j24O5");
const $7ff09135a273f813$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$7ff09135a273f813$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $7ff09135a273f813$export$8fb373d660548968(arr, offset = 0) {
    return ($7ff09135a273f813$var$byteToHex[arr[offset + 0]] + $7ff09135a273f813$var$byteToHex[arr[offset + 1]] + $7ff09135a273f813$var$byteToHex[arr[offset + 2]] + $7ff09135a273f813$var$byteToHex[arr[offset + 3]] + '-' + $7ff09135a273f813$var$byteToHex[arr[offset + 4]] + $7ff09135a273f813$var$byteToHex[arr[offset + 5]] + '-' + $7ff09135a273f813$var$byteToHex[arr[offset + 6]] + $7ff09135a273f813$var$byteToHex[arr[offset + 7]] + '-' + $7ff09135a273f813$var$byteToHex[arr[offset + 8]] + $7ff09135a273f813$var$byteToHex[arr[offset + 9]] + '-' + $7ff09135a273f813$var$byteToHex[arr[offset + 10]] + $7ff09135a273f813$var$byteToHex[arr[offset + 11]] + $7ff09135a273f813$var$byteToHex[arr[offset + 12]] + $7ff09135a273f813$var$byteToHex[arr[offset + 13]] + $7ff09135a273f813$var$byteToHex[arr[offset + 14]] + $7ff09135a273f813$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $7ff09135a273f813$var$stringify(arr, offset = 0) {
    const uuid = $7ff09135a273f813$export$8fb373d660548968(arr, offset);
    if (!(0, $j24O5.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $7ff09135a273f813$export$2e2bcd8739ae039 = $7ff09135a273f813$var$stringify;

});
parcelRegister("j24O5", function(module, exports) {
$parcel$export(module.exports, "default", () => $ddb1eebf7c062598$export$2e2bcd8739ae039);

var $5n5xm = parcelRequire("5n5xm");
function $ddb1eebf7c062598$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $5n5xm.default).test(uuid);
}
var $ddb1eebf7c062598$export$2e2bcd8739ae039 = $ddb1eebf7c062598$var$validate;

});
parcelRegister("5n5xm", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e936542e888e8b2$export$2e2bcd8739ae039);
var $3e936542e888e8b2$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

});




parcelRegister("lSdkB", function(module, exports) {
$parcel$export(module.exports, "extract", () => $fec8fb70a184cf01$export$f9380c9a627682d3, (v) => $fec8fb70a184cf01$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $fec8fb70a184cf01$export$98e6a39c04603d36, (v) => $fec8fb70a184cf01$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $fec8fb70a184cf01$export$fac44ee5b035f737, (v) => $fec8fb70a184cf01$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $fec8fb70a184cf01$export$7a5253c0f62e0150, (v) => $fec8fb70a184cf01$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $fec8fb70a184cf01$export$a8c1621ea79325d3, (v) => $fec8fb70a184cf01$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $fec8fb70a184cf01$export$357523c63a2253b9, (v) => $fec8fb70a184cf01$export$357523c63a2253b9 = v);
$parcel$export(module.exports, "exclude", () => $fec8fb70a184cf01$export$44c361b8ec72ef7f, (v) => $fec8fb70a184cf01$export$44c361b8ec72ef7f = v);
var $fec8fb70a184cf01$export$f9380c9a627682d3;
var $fec8fb70a184cf01$export$98e6a39c04603d36;
var $fec8fb70a184cf01$export$fac44ee5b035f737;
var $fec8fb70a184cf01$export$7a5253c0f62e0150;
var $fec8fb70a184cf01$export$a8c1621ea79325d3;
var $fec8fb70a184cf01$export$357523c63a2253b9;
var $fec8fb70a184cf01$export$44c361b8ec72ef7f;
'use strict';

var $6XEYK = parcelRequire("6XEYK");

var $9YPP7 = parcelRequire("9YPP7");

var $l4Qn0 = parcelRequire("l4Qn0");

var $9PyLY = parcelRequire("9PyLY");
const $fec8fb70a184cf01$var$isNullOrUndefined = (value)=>value === null || value === undefined;
function $fec8fb70a184cf01$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $fec8fb70a184cf01$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $fec8fb70a184cf01$var$encode(key, options),
                            '[',
                            $fec8fb70a184cf01$var$encode(index, options),
                            ']=',
                            $fec8fb70a184cf01$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $fec8fb70a184cf01$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $fec8fb70a184cf01$var$encode(key, options),
                            '[]=',
                            $fec8fb70a184cf01$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
            return (key)=>(result, value)=>{
                    if (value === null || value === undefined || value.length === 0) return result;
                    if (result.length === 0) return [
                        [
                            $fec8fb70a184cf01$var$encode(key, options),
                            '=',
                            $fec8fb70a184cf01$var$encode(value, options)
                        ].join('')
                    ];
                    return [
                        [
                            result,
                            $fec8fb70a184cf01$var$encode(value, options)
                        ].join(options.arrayFormatSeparator)
                    ];
                };
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $fec8fb70a184cf01$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $fec8fb70a184cf01$var$encode(key, options),
                            '=',
                            $fec8fb70a184cf01$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $fec8fb70a184cf01$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $fec8fb70a184cf01$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $fec8fb70a184cf01$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$fec8fb70a184cf01$var$decode(item, options)) : value === null ? value : $fec8fb70a184cf01$var$decode(value, options);
                accumulator[key] = newValue;
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $fec8fb70a184cf01$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $fec8fb70a184cf01$var$encode(value, options) {
    if (options.encode) return options.strict ? $6XEYK(value) : encodeURIComponent(value);
    return value;
}
function $fec8fb70a184cf01$var$decode(value, options) {
    if (options.decode) return $9YPP7(value);
    return value;
}
function $fec8fb70a184cf01$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $fec8fb70a184cf01$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $fec8fb70a184cf01$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $fec8fb70a184cf01$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $fec8fb70a184cf01$var$extract(input) {
    input = $fec8fb70a184cf01$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $fec8fb70a184cf01$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $fec8fb70a184cf01$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $fec8fb70a184cf01$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $fec8fb70a184cf01$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $l4Qn0(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator'
        ].includes(options.arrayFormat) ? value : $fec8fb70a184cf01$var$decode(value, options);
        formatter($fec8fb70a184cf01$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $fec8fb70a184cf01$var$parseValue(value[k], options);
        else ret[key] = $fec8fb70a184cf01$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $fec8fb70a184cf01$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$fec8fb70a184cf01$export$f9380c9a627682d3 = $fec8fb70a184cf01$var$extract;
$fec8fb70a184cf01$export$98e6a39c04603d36 = $fec8fb70a184cf01$var$parse;
$fec8fb70a184cf01$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $fec8fb70a184cf01$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $fec8fb70a184cf01$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $fec8fb70a184cf01$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $fec8fb70a184cf01$var$encode(key, options);
        if (Array.isArray(value)) return value.reduce(formatter(key), []).join('&');
        return $fec8fb70a184cf01$var$encode(key, options) + '=' + $fec8fb70a184cf01$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$fec8fb70a184cf01$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $l4Qn0(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $fec8fb70a184cf01$var$parse($fec8fb70a184cf01$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $fec8fb70a184cf01$var$decode(hash, options)
    } : {});
};
$fec8fb70a184cf01$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true
    }, options);
    const url = $fec8fb70a184cf01$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $fec8fb70a184cf01$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $fec8fb70a184cf01$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $fec8fb70a184cf01$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $fec8fb70a184cf01$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${$fec8fb70a184cf01$var$encode(object.fragmentIdentifier, options)}`;
    return `${url}${queryString}${hash}`;
};
$fec8fb70a184cf01$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $fec8fb70a184cf01$export$7a5253c0f62e0150(input, options);
    return $fec8fb70a184cf01$export$a8c1621ea79325d3({
        url: url,
        query: $9PyLY(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$fec8fb70a184cf01$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $fec8fb70a184cf01$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("6XEYK", function(module, exports) {
'use strict';
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("9YPP7", function(module, exports) {
'use strict';
var $7441eabb5801ca04$var$token = '%[a-f0-9]{2}';
var $7441eabb5801ca04$var$singleMatcher = new RegExp('(' + $7441eabb5801ca04$var$token + ')|([^%]+?)', 'gi');
var $7441eabb5801ca04$var$multiMatcher = new RegExp('(' + $7441eabb5801ca04$var$token + ')+', 'gi');
function $7441eabb5801ca04$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $7441eabb5801ca04$var$decodeComponents(left), $7441eabb5801ca04$var$decodeComponents(right));
}
function $7441eabb5801ca04$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($7441eabb5801ca04$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $7441eabb5801ca04$var$decodeComponents(tokens, i).join('');
            tokens = input.match($7441eabb5801ca04$var$singleMatcher) || [];
        }
        return input;
    }
}
function $7441eabb5801ca04$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $7441eabb5801ca04$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $7441eabb5801ca04$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $7441eabb5801ca04$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $7441eabb5801ca04$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("l4Qn0", function(module, exports) {
'use strict';
module.exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("9PyLY", function(module, exports) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});


parcelRegister("c40db", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("62KHl")).default);
$parcel$export(module.exports, "apdexType", () => (parcelRequire("dpXUu")).apdexType);
$parcel$export(module.exports, "envType", () => (parcelRequire("dpXUu")).envType);
$parcel$export(module.exports, "eventType", () => (parcelRequire("dpXUu")).eventType);
$parcel$export(module.exports, "originType", () => (parcelRequire("dpXUu")).originType);
$parcel$export(module.exports, "platformType", () => (parcelRequire("dpXUu")).platformType);
$parcel$export(module.exports, "tenantType", () => (parcelRequire("dpXUu")).tenantType);
$parcel$export(module.exports, "userType", () => (parcelRequire("dpXUu")).userType);
$parcel$export(module.exports, "originTracingType", () => (parcelRequire("dpXUu")).originTracingType);
$parcel$export(module.exports, "TypeAheadHelper", () => (parcelRequire("lI9z0")).default);
$parcel$export(module.exports, "DwellTimeHelper", () => (parcelRequire("i3Wuc")).default);
$parcel$export(module.exports, "DwellTimeHelperWithBrowserInteraction", () => (parcelRequire("lDnl8")).default);
$parcel$export(module.exports, "CompressionRule", () => (parcelRequire("aFMrF")).CompressionRule);
$parcel$export(module.exports, "ResilienceMechanism", () => (parcelRequire("9GE8Y")).ResilienceMechanism);
$parcel$export(module.exports, "StopLowPriorityEventDelayReason", () => (parcelRequire("b4U7t")).StopLowPriorityEventDelayReason);
$parcel$export(module.exports, "STARGATE_PROXY_PATH", () => (parcelRequire("ls3Em")).STARGATE_PROXY_PATH);
$parcel$export(module.exports, "perimeterType", () => (parcelRequire("dpXUu")).perimeterType);
$parcel$export(module.exports, "aliasType", () => (parcelRequire("dpXUu")).aliasType);
$parcel$export(module.exports, "groupType", () => (parcelRequire("dpXUu")).groupType);
$parcel$export(module.exports, "productEmbedType", () => (parcelRequire("dpXUu")).productEmbedType);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $62KHl = parcelRequire("62KHl");

var $dpXUu = parcelRequire("dpXUu");

var $i3Wuc = parcelRequire("i3Wuc");

var $lDnl8 = parcelRequire("lDnl8");

var $aFMrF = parcelRequire("aFMrF");

var $b4U7t = parcelRequire("b4U7t");

var $9GE8Y = parcelRequire("9GE8Y");

var $ls3Em = parcelRequire("ls3Em");

var $lI9z0 = parcelRequire("lI9z0");

});
parcelRegister("62KHl", function(module, exports) {
$parcel$export(module.exports, "default", () => $4667273d53967e9d$export$2e2bcd8739ae039);

var $ekGgq = parcelRequire("ekGgq");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $kipyU = parcelRequire("kipyU");

var $br65s = parcelRequire("br65s");

var $dpXUu = parcelRequire("dpXUu");

var $nxH15 = parcelRequire("nxH15");

var $doaPm = parcelRequire("doaPm");

var $478yZ = parcelRequire("478yZ");

var $dIKYA = parcelRequire("dIKYA");

var $1dFnn = parcelRequire("1dFnn");

var $aYviu = parcelRequire("aYviu");

var $3xmDM = parcelRequire("3xmDM");

var $74pGx = parcelRequire("74pGx");

var $9hqdJ = parcelRequire("9hqdJ");

var $9Do9V = parcelRequire("9Do9V");

var $89ZKV = parcelRequire("89ZKV");

var $lsX7U = parcelRequire("lsX7U");

var $5kUYv = parcelRequire("5kUYv");

var $9raiz = parcelRequire("9raiz");

var $dyX62 = parcelRequire("dyX62");

var $eS4G8 = parcelRequire("eS4G8");

var $h5UBC = parcelRequire("h5UBC");

var $7Jko1 = parcelRequire("7Jko1");

var $ls3Em = parcelRequire("ls3Em");

var $5P1Jy = parcelRequire("5P1Jy");

var $cMwGH = parcelRequire("cMwGH");

var $j5Le2 = parcelRequire("j5Le2");

var $kxbHy = parcelRequire("kxbHy");

var $8jZU6 = parcelRequire("8jZU6");

var $4penA = parcelRequire("4penA");

var $kqsXa = parcelRequire("kqsXa");

var $1Ygrk = parcelRequire("1Ygrk");

var $1F03j = parcelRequire("1F03j");

var $c77r4 = parcelRequire("c77r4");

var $4uub9 = parcelRequire("4uub9");

var $gUTHp = parcelRequire("gUTHp");

var $gKKSu = parcelRequire("gKKSu");

var $lHJ7U = parcelRequire("lHJ7U");

var $2E7is = parcelRequire("2E7is");

var $7UqwT = parcelRequire("7UqwT");

var $hPniv = parcelRequire("hPniv");
function $4667273d53967e9d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4667273d53967e9d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4667273d53967e9d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4667273d53967e9d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4667273d53967e9d$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $4667273d53967e9d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsWebClient(productInfo) {
        var _this = this;
        var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsWebClient);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_useStargate", function(useStargate) {
            if (useStargate == null) return true;
            return useStargate;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_changeInternalUserId", function(userId, anonymousId) {
            _this._eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== _this._eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            _this._eventProcessor.getUser().setAnonymousId(anonymousId);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_createSubproductGetter", function(subproduct) {
            return (0, $aYviu.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_createEmbeddedProductGetter", function(embeddedProduct) {
            return (0, $aYviu.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getLastScreenEvent", function() {
            try {
                return JSON.parse(_this._safeSessionStorage.getItem($4667273d53967e9d$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch (_unused) {
                _this._safeSessionStorage.removeItem($4667273d53967e9d$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_setLastScreenEvent", function(event) {
            _this._safeSessionStorage.setItem($4667273d53967e9d$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_shouldEventBeDelayed", function(event) {
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            var isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return _this._eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_fireEvent", function(identifier, builtEvent, context, callback) {
            switch(builtEvent.eventType){
                case (0, $dpXUu.eventType).UI:
                case (0, $dpXUu.eventType).OPERATIONAL:
                case (0, $dpXUu.eventType).TRACK:
                    return _this._eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $dpXUu.eventType).SCREEN:
                    return _this._eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $dpXUu.eventType).IDENTIFY:
                    return _this._eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error("No handler has been defined for events of type ".concat(builtEvent.eventType));
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_fireDelayedEvent", function(identifier, builtEvent, context, userInfo) {
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                _this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(builtEvent.tags || []), [
                    'sentWithDelay'
                ]);
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                _this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                _this._changeInternalUserId(_this._userInfo.userId, _this._userInfo.anonymousId);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_delayEvent", function(identifier, builtEvent, context, userInfo, callback) {
            _this._eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_processEvent", function(identifier, builtEvent, context, callback) {
            _this._testingCache.saveEvent(builtEvent);
            if (_this._shouldEventBeDelayed(builtEvent)) {
                _this._delayEvent(identifier, builtEvent, context, _this._userInfo, callback);
                return Promise.resolve();
            } else return _this._fireEvent(identifier, builtEvent, context, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setEmbeddedProduct", function(embeddedProduct) {
            _this._internalProductInfo.embeddedProduct = _this._createEmbeddedProductGetter(embeddedProduct);
            _this.resetUIViewedTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearEmbeddedProduct", function() {
            _this._internalProductInfo.embeddedProduct = _this._createEmbeddedProductGetter(null);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setSubproduct", function(subproduct) {
            _this._internalProductInfo.subproduct = _this._createSubproductGetter(subproduct);
            _this.resetUIViewedTimers();
        });
        /**
      * Calling this function in the intialisation of the client in product
      * captures specified 'origin tracing' URL params and fires a single origin landed event
      * <p>
      * This function expects a mapping between the keys for any URL parameters
      *  that should be captured and removed for origin tracing
      * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
      * Each handler function should return an object with two items
      * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
      * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
      *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
      * </p>
      * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
      * e.g. from a share or email
      *
      * An example calling this function using an external decoding library, with taskSessionId specified to persist
      * analyticsWebClient.setOriginTracingHandlers({
           atlOrigin: encodedOrigin => {
               const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
               return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
           },
       });
      *
      * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
      * @this {AnalyticsWebClient}
      */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setOriginTracingHandlers", function(originParamHandlerMapping) {
            var capturedOriginTraces = _this._originTracing.handleOriginParameters(originParamHandlerMapping, _this._historyReplaceFn);
            var keys = Object.keys(capturedOriginTraces);
            keys.forEach(function(x) {
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') _this._task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            var originAttributes = {};
            keys.forEach(function(x) {
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn("Handling method for origin parameter ".concat(x, " has not returned any attributes"));
            });
            if (keys.length > 0) return _this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            function() {});
            return Promise.resolve();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setTenantInfo", function(tenantIdType, tenantId) {
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, $dpXUu.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, $9raiz.isType)((0, $dpXUu.tenantType), tenantIdType)) throw new Error("Invalid tenantIdType '".concat(tenantIdType, "', ") + "must be an tenantType: [".concat((0, $eS4G8.objectValues)((0, $dpXUu.tenantType)), "]"));
            _this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
            _this._eventProcessor.refreshMetadata(_this._userInfo, _this._tenantInfo);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearTenantInfo", function() {
            _this._tenantInfo = {};
            _this._eventProcessor.refreshMetadata(_this._userInfo, _this._tenantInfo);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setOrgInfo", function(orgId) {
            if (!orgId) throw new Error('Missing orgId');
            _this._orgInfo = {
                orgId: orgId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearOrgInfo", function() {
            _this._orgInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setWorkspaceInfo", function(workspaceId) {
            if (!workspaceId) throw new Error('Missing workspaceId');
            _this._workspaceInfo = {
                workspaceId: workspaceId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearWorkspaceInfo", function() {
            _this._workspaceInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setCollaborationContextInfo", function(collaborationContextAri) {
            if (!collaborationContextAri) throw new Error('Missing collaborationContextAri');
            _this._collaborationContextInfo = {
                collaborationContextAri: collaborationContextAri
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearCollaborationContextInfo", function() {
            _this._collaborationContextInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setUserInfo", function(userIdType, userId) {
            (0, $c77r4.validateIdentifyEvent)(userIdType, userId);
            _this._changeInternalUserId(userId);
            _this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: _this._eventProcessor.getUser().getAnonymousId()
            };
            _this._eventProcessor.refreshMetadata(_this._userInfo, _this._tenantInfo);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearUserInfo", function() {
            _this._changeInternalUserId(undefined);
            _this._userInfo = {
                anonymousId: _this._eventProcessor.getUser().getAnonymousId()
            };
            _this._eventProcessor.refreshMetadata(_this._userInfo, _this._tenantInfo);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setAlias", function(aliasKeyType, alias) {
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, $9raiz.isType)((0, $dpXUu.aliasType), aliasKeyType)) throw new Error("Invalid aliasType '".concat(aliasKeyType, "', ") + "must be an aliasType: [".concat((0, $eS4G8.objectValues)((0, $dpXUu.aliasType)), "]"));
            _this._aliases[aliasKeyType] = alias;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearAlias", function() {
            _this._aliases = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setGroup", function(groupsKeyType, group) {
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, $9raiz.isType)((0, $dpXUu.groupType), groupsKeyType)) throw new Error("Invalid groupType '".concat(groupsKeyType, "', ") + "must be an groupType: [".concat((0, $eS4G8.objectValues)((0, $dpXUu.groupType)), "]"));
            _this._groups[groupsKeyType] = group;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearGroup", function() {
            _this._groups = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getAnonymousId", function() {
            return _this._userInfo.anonymousId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getCurrentSessionId", function() {
            return _this._sessionTracking.getCurrentSessionId();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setUIViewedAttributes", function(uiViewedAttributes) {
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(uiViewedAttributes) !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            _this._uiViewedAttributes = $4667273d53967e9d$var$_objectSpread({}, uiViewedAttributes);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getUIViewedAttributes", function() {
            return _this._uiViewedAttributes;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearUIViewedAttributes", function() {
            _this._uiViewedAttributes = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "appendUIViewedAttributes", function(attributes) {
            if (!_this._uiViewedAttributes) _this._uiViewedAttributes = attributes;
            else _this._uiViewedAttributes = $4667273d53967e9d$var$_objectSpread($4667273d53967e9d$var$_objectSpread({}, _this._uiViewedAttributes), attributes);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sendIdentifyEvent", function(userIdType, userId, callback) {
            _this.setUserInfo(userIdType, userId);
            var builtEvent = {
                userIdType: userIdType,
                eventType: (0, $dpXUu.eventType).IDENTIFY
            };
            return _this._processEvent(userId, builtEvent, _this._context, callback);
        });
        /**
     * @deprecated
     * please use {@link sendScreenEvent instead)
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sendPageEvent", function(name, callback) {
            return _this.sendScreenEvent(name, callback);
        });
        /**
     * send screen event
     * @param event The event / For retrocompatibility event name is still supported here.
     * @param callback
     * @param attributes. Deprecated, will get ignored if using an event object as first param.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sendScreenEvent", function(event, callback, attributes) {
            var screenName;
            var screenAttributes;
            var screenContainers;
            var screenTags;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(event) === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $gKKSu.validateScreenEvent)(screenName);
            (0, $1F03j.validateContainers)(screenContainers);
            var builtEvent = (0, $1dFnn.buildScreenEvent)(_this._internalProductInfo, _this._tenantInfo, _this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, _this._tabTracking.getCurrentTabId(), _this._sessionTracking.getCurrentSessionId(), _this._task.getAllTaskSessions(), _this._crossProductInteractionTracking.getInteractionSession(), _this._orgInfo, _this._pageLoadId, _this._workspaceInfo, _this._collaborationContextInfo, event, screenContainers, _this._aliases, _this._groups);
            var builtEventWithName = $4667273d53967e9d$var$_objectSpread({
                name: screenName
            }, builtEvent);
            _this._setLastScreenEvent(builtEventWithName);
            return _this._processEvent(screenName, builtEventWithName, _this._context, (0, $7UqwT.default)(callback, builtEventWithName));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sendTrackEvent", function(event, callback) {
            (0, $lHJ7U.validateTrackEvent)(event);
            var builtEvent = (0, $doaPm.buildActionEvent)(_this._internalProductInfo, _this._tenantInfo, _this._userInfo, event, (0, $dpXUu.eventType).TRACK, _this._tabTracking.getCurrentTabId(), _this._sessionTracking.getCurrentSessionId(), _this._task.getAllTaskSessions(), _this._crossProductInteractionTracking.getInteractionSession(), _this._orgInfo, _this._pageLoadId, _this._workspaceInfo, _this._collaborationContextInfo, _this._aliases, _this._groups);
            return _this._processEvent((0, $478yZ.buildActionName)(event), builtEvent, _this._context, (0, $7UqwT.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sendUIEvent", function(event, callback) {
            (0, $2E7is.validateUIEvent)(event);
            var builtEvent = (0, $doaPm.buildActionEvent)(_this._internalProductInfo, _this._tenantInfo, _this._userInfo, event, (0, $dpXUu.eventType).UI, _this._tabTracking.getCurrentTabId(), _this._sessionTracking.getCurrentSessionId(), _this._task.getAllTaskSessions(), _this._crossProductInteractionTracking.getInteractionSession(), _this._orgInfo, _this._pageLoadId, _this._workspaceInfo, _this._collaborationContextInfo, _this._aliases, _this._groups);
            return _this._processEvent((0, $478yZ.buildActionName)(event), builtEvent, _this._context, (0, $7UqwT.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sendOperationalEvent", function(event, callback) {
            (0, $4uub9.validateOperationalEvent)(event);
            var builtEvent = (0, $doaPm.buildActionEvent)(_this._internalProductInfo, _this._tenantInfo, _this._userInfo, event, (0, $dpXUu.eventType).OPERATIONAL, _this._tabTracking.getCurrentTabId(), _this._sessionTracking.getCurrentSessionId(), _this._task.getAllTaskSessions(), _this._crossProductInteractionTracking.getInteractionSession(), _this._orgInfo, _this._pageLoadId, _this._workspaceInfo, _this._collaborationContextInfo, _this._aliases, _this._groups);
            return _this._processEvent((0, $478yZ.buildActionName)(event), builtEvent, _this._context, (0, $7UqwT.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "startUIViewedEvent", function(callback) {
            _this.stopUIViewedEvent();
            _this._uiViewedEvent = _this.createUIViewedEvent(callback);
            _this._uiViewedEvent.start();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "stopUIViewedEvent", function() {
            if (_this._uiViewedEvent) {
                _this._uiViewedEvent.stop();
                _this._uiViewedEvent = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "resetUIViewedTimers", function() {
            if (_this._uiViewedEvent) _this._uiViewedEvent.resetTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "signalUserActive", function() {
            var uiViewedEvent = _this._uiViewedEvent || _this.createUIViewedEvent(null);
            uiViewedEvent.signalUserActive();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "createUIViewedEvent", function(callback) {
            return new (0, $4penA.default)(_this._internalProductInfo, function() {
                return {
                    embeddedProduct: _this._internalProductInfo.embeddedProduct(),
                    subproduct: _this._internalProductInfo.subproduct(),
                    tenantIdType: _this._tenantInfo.tenantIdType,
                    tenantId: _this._tenantInfo.tenantId,
                    userId: _this._userInfo.userId,
                    lastScreenEvent: _this._getLastScreenEvent(),
                    attributes: _this._uiViewedAttributes
                };
            }, function(event) {
                return _this.sendUIEvent(event, callback);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "startApdexEvent", function(apdexEvent) {
            _this._apdexEvent.start(apdexEvent);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getApdexStart", function(apdexEvent) {
            return _this._apdexEvent.getStart(apdexEvent);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "stopApdexEvent", function(apdexEvent, callback) {
            _this._apdexEvent.stop(apdexEvent, callback);
        });
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "startLowPriorityEventDelay", function(timeout, callback) {
            _this._eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "stopLowPriorityEventDelay", function() {
            _this._eventDelayQueue.stopLowPriorityEventDelay();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "onEvent", function(_analyticsId, analyticsData) {
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, $dpXUu.eventType).TRACK) return _this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $dpXUu.eventType).UI) return _this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $dpXUu.eventType).OPERATIONAL) return _this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $dpXUu.eventType).SCREEN) return _this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $dpXUu.eventType).IDENTIFY) return _this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error("Invalid analyticsData.eventType '".concat(analyticsData.eventType, "', ") + "must be an eventType: [".concat((0, $eS4G8.objectValues)((0, $dpXUu.eventType)), "]"));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setResponseCallback", function(responseCallback) {
            _this._eventProcessor.setResponseCallback(responseCallback);
        });
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, $9raiz.isType)((0, $dpXUu.envType), productInfo.env)) throw new Error("Invalid productInfo.env '".concat(productInfo.env, "', ") + "must be an envType: [".concat((0, $eS4G8.objectValues)((0, $dpXUu.envType)), "]"));
        if (!productInfo.origin) productInfo.origin = (0, $dpXUu.originType).WEB;
        else if (!(0, $9raiz.isType)((0, $dpXUu.originType), productInfo.origin)) throw new Error("Invalid productInfo.origin '".concat(productInfo.origin, "', ") + "must be an originType: [".concat((0, $eS4G8.objectValues)((0, $dpXUu.originType)), "]"));
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $dpXUu.originType).WEB ? (0, $dpXUu.platformType).WEB : (0, $dpXUu.platformType).DESKTOP;
        else (0, $gUTHp.validatePlatform)(productInfo);
        this._logger = settings.logger || console;
        // Auto-detect Oasis perimeter (e.g. FedRAMP Moderate) when the consumer hasn't explicitly provided a perimeter.
        if (!productInfo.perimeter) try {
            if ((0, $kipyU.isFedrampModerate)()) productInfo.perimeter = (0, $dpXUu.perimeterType).FEDRAMP_MODERATE;
        } catch (e) {
            this._logger.warn('Failed to auto-detect perimeter: %s', e instanceof Error ? e.message : String(e));
        }
        // Default to commercial perimeter if not explicitly provided and not auto-detected.
        if (!productInfo.perimeter) productInfo.perimeter = (0, $dpXUu.perimeterType).COMMERCIAL;
        if (!(0, $9raiz.isType)((0, $dpXUu.perimeterType), productInfo.perimeter)) throw new Error("Invalid productInfo.perimeter '".concat(productInfo.perimeter, "', ") + "must be a perimeterType: [".concat((0, $eS4G8.objectValues)((0, $dpXUu.perimeterType)), "]"));
        // Auto-detect Oasis Isolated Cloud (IC) environment when the consumer hasn't explicitly provided an `ic` value.
        if (!productInfo.ic) try {
            var icId = (0, $br65s.isolationContextId)();
            if (icId && icId.length > 0) productInfo.ic = icId;
        } catch (e) {
            this._logger.warn('Failed to auto-detect isolation context: %s', e instanceof Error ? e.message : String(e));
        }
        this._internalProductInfo = $4667273d53967e9d$var$_objectSpread($4667273d53967e9d$var$_objectSpread({}, productInfo), {}, {
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        });
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        if (productInfo !== null && productInfo !== void 0 && productInfo.embeddedContext) {
            this._embeddedContext = productInfo.embeddedContext;
            if ((0, $lsX7U.isFirstParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromProduct: this._embeddedContext['embeddedFromProduct'],
                embeddedFromSubproduct: this._embeddedContext['embeddedFromSubproduct'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
            if ((0, $5kUYv.isThirdParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
        }
        this._context = (0, $dIKYA.buildContext)(this._internalProductInfo);
        this._safeSessionStorage = new (0, $cMwGH.default)();
        var _useStargate = this._useStargate(settings.useStargate);
        var apiHost = (0, $ls3Em.selectHost)({
            useStargate: _useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            ic: productInfo.ic,
            envOverride: productInfo.envOverride,
            apiHost: settings.apiHost
        });
        var apiHostProtocol = settings.apiHostProtocol || 'https';
        var minRetryDelay = settings.minRetryDelay || 1000;
        var maxAttempts = settings.maxRetryAttempts !== undefined && Number.isInteger(settings.maxRetryAttempts) && settings.maxRetryAttempts >= 0 ? settings.maxRetryAttempts + 1 : undefined;
        var retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload,
            maxAttempts: maxAttempts,
            maxQueueSize: settings.maxQueueSize
        };
        var retryQueuePrefix = "awc-".concat(productInfo.env);
        var xidPromiseGetter = function xidPromiseGetter() {
            return (0, $hPniv.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        };
        var disableCookiePersistence = settings.disableCookiePersistence || false;
        var metadataClientFactory = settings.metadataClientFactory || (0, $89ZKV.MetadataClient).Factory;
        var metadataClient = metadataClientFactory(apiHostProtocol, apiHost, productInfo.product);
        this._eventProcessor = new (0, $9Do9V.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this._logger,
            metadataClient: metadataClient,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: (0, $dyX62.LoggingResponseCallback).getCallback(this._logger),
            env: productInfo.env,
            perimeter: productInfo.perimeter,
            enableMetadataCalls: this.metadataCallsEnabled(settings),
            enableEventCalls: this.eventCallsEnabled(settings)
        });
        this._userInfo = {
            anonymousId: this._eventProcessor.getUser().getAnonymousId(settings === null || settings === void 0 ? void 0 : settings.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $7Jko1.default)();
        this._tabTracking = new (0, $j5Le2.default)();
        this._sessionTracking = new (0, $5P1Jy.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this._task = new (0, $kxbHy.default)();
        this._originTracing = new (0, $h5UBC.default)();
        this._eventProcessor.setOriginTracingClient(this._originTracing);
        // Init Apdex
        this._apdexEvent = new (0, $nxH15.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $74pGx.defaultHistoryReplaceFn);
        this._eventDelayQueue = new (0, $9hqdJ.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $8jZU6.default)(settings.isSynthetic, settings.enableTestingCache);
        this._pageLoadId = (0, $1Ygrk.default)();
        this._workspaceInfo = {};
        this._collaborationContextInfo = {};
        this._aliases = {};
        this._groups = {};
        this._crossProductInteractionTracking = new (0, $3xmDM.default)({
            perimeter: productInfo.perimeter,
            product: productInfo.product,
            sendEventCallback: this.sendOperationalEvent,
            historyReplaceFn: this._historyReplaceFn
        });
        this._crossProductInteractionTracking.validateInteractionSession();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsWebClient, [
        {
            key: "metadataCallsEnabled",
            value: function metadataCallsEnabled(settings) {
                if (typeof settings.disableMetadataCalls === 'boolean') return !settings.disableMetadataCalls;
                return !(0, $kqsXa.TestSupport).isGeminiVREnvironment() && !(0, $kqsXa.TestSupport).areFetchCallsDisabled();
            }
        },
        {
            key: "eventCallsEnabled",
            value: function eventCallsEnabled(settings) {
                if (typeof settings.disableEventCalls === 'boolean') return !settings.disableEventCalls;
                return !(0, $kqsXa.TestSupport).isGeminiVREnvironment() && !(0, $kqsXa.TestSupport).areFetchCallsDisabled();
            }
        },
        {
            key: "setEventValidationMode",
            value: function setEventValidationMode(eventValidationMode) {
                this._context.context.validationMode = eventValidationMode;
            }
        },
        {
            key: "task",
            get: function get() {
                return this._task;
            }
        },
        {
            key: "_productInfo",
            get: function get() {
                return this._internalProductInfo;
            }
        }
    ]);
}();

});
parcelRegister("kipyU", function(module, exports) {
$parcel$export(module.exports, "isFedrampModerate", () => $ec695131736c7743$export$104cb891a6e90b3a);

var $jkIt8 = parcelRequire("jkIt8");

var $cb103 = parcelRequire("cb103");
function $ec695131736c7743$export$104cb891a6e90b3a() {
    if (typeof document === 'undefined') {
        var _globalThis$ssrContex, _globalThis$ssrContex2;
        // @ts-ignore
        return (_globalThis$ssrContex = (_globalThis$ssrContex2 = globalThis.ssrContext) === null || _globalThis$ssrContex2 === void 0 ? void 0 : _globalThis$ssrContex2.isInFedramp) !== null && _globalThis$ssrContex !== void 0 ? _globalThis$ssrContex : false;
    }
    var atlCtxCookieValues = (0, $cb103.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $jkIt8.FEDRAMP_MODERATE);
}

});
parcelRegister("jkIt8", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $e1326132531ff3f4$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $e1326132531ff3f4$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $e1326132531ff3f4$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $e1326132531ff3f4$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $e1326132531ff3f4$export$a0ffa0598c95dfb7);
var $e1326132531ff3f4$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $e1326132531ff3f4$export$f005e2e9f707cb5f = 'commercial';
var $e1326132531ff3f4$export$17b81a3d6c98013c = 'isolated-cloud';
var $e1326132531ff3f4$export$a739cd5aac835909 = 'staging';
var $e1326132531ff3f4$export$42dd0cdd351a4a9 = 'prod';
var $e1326132531ff3f4$export$404582bc18fe4d9e = 'dev';
var $e1326132531ff3f4$export$87285944378c596 = 'Atl-Ctx-Perimeter';
var $e1326132531ff3f4$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
var $e1326132531ff3f4$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
var $e1326132531ff3f4$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
var $e1326132531ff3f4$export$b61e047ddcc35726 = 'GCP';
var $e1326132531ff3f4$export$1baf17f3e645a2b2 = 'AWS';

});

parcelRegister("cb103", function(module, exports) {
$parcel$export(module.exports, "parseAtlCtxCookies", () => $8dd749ac6736275f$export$3fa7b7af96286cc9);

var $jkIt8 = parcelRequire("jkIt8");

var $jQwvU = parcelRequire("jQwvU");
function $8dd749ac6736275f$export$3fa7b7af96286cc9() {
    var global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        var cookies = global.document.cookie;
        var perimeter = (0, $jQwvU.getRawCookieValue)((0, $jkIt8.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        var icDomain = (0, $jQwvU.getRawCookieValue)((0, $jkIt8.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        var icId = (0, $jQwvU.getRawCookieValue)((0, $jkIt8.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        var emptyIcDomain = !icDomain || icDomain.length === 0;
        var emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});
parcelRegister("jQwvU", function(module, exports) {
$parcel$export(module.exports, "getRawCookieValue", () => $e72c183095e6d0ea$export$aa09aab30a92256c);

var $iYJcE = parcelRequire("iYJcE");
function $e72c183095e6d0ea$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $e72c183095e6d0ea$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $e72c183095e6d0ea$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e72c183095e6d0ea$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e72c183095e6d0ea$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $e72c183095e6d0ea$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $e72c183095e6d0ea$export$aa09aab30a92256c(cookieName, cookieString) {
    if (!cookieString) return undefined;
    var cookies = cookieString.split(';');
    var _iterator = $e72c183095e6d0ea$var$_createForOfIteratorHelper(cookies), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var cookie = _step.value;
            var _cookie$trim$split = cookie.trim().split('='), _cookie$trim$split2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_cookie$trim$split, 2), name = _cookie$trim$split2[0], value = _cookie$trim$split2[1];
            if (name === cookieName) return value;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return undefined;
}

});



parcelRegister("br65s", function(module, exports) {
$parcel$export(module.exports, "isolationContextId", () => $8536f01372624beb$export$839b022803d38d4d);

var $cb103 = parcelRequire("cb103");

var $hppuA = parcelRequire("hppuA");
function $8536f01372624beb$export$839b022803d38d4d() {
    if (typeof document === 'undefined') {
        var _globalThis$ssrContex;
        // @ts-ignore
        return (0, $hppuA.isIsolatedCloud)() ? (_globalThis$ssrContex = globalThis.ssrContext) === null || _globalThis$ssrContex === void 0 ? void 0 : _globalThis$ssrContex.icName : undefined;
    }
    var atlCtxCookieValues = (0, $cb103.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icId;
}

});
parcelRegister("hppuA", function(module, exports) {
$parcel$export(module.exports, "isIsolatedCloud", () => $cac88bb0dc9097b1$export$9186ccba8effc5de);

var $cZhcL = parcelRequire("cZhcL");

var $cb103 = parcelRequire("cb103");
function $cac88bb0dc9097b1$export$9186ccba8effc5de() {
    if (typeof document === 'undefined') {
        var _globalThis$ssrContex, _globalThis$ssrContex2;
        // @ts-ignore
        return (_globalThis$ssrContex = (_globalThis$ssrContex2 = globalThis.ssrContext) === null || _globalThis$ssrContex2 === void 0 ? void 0 : _globalThis$ssrContex2.isInIC) !== null && _globalThis$ssrContex !== void 0 ? _globalThis$ssrContex : false;
    }
    var atlCtxCookieValues = (0, $cb103.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $cZhcL.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}

});
parcelRegister("cZhcL", function(module, exports) {
$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", () => $97488712825fa5bf$export$d8347b4aae768c2d);

var $jkIt8 = parcelRequire("jkIt8");
var $97488712825fa5bf$export$d8347b4aae768c2d = [
    (0, $jkIt8.COMMERCIAL)
];

});



parcelRegister("dpXUu", function(module, exports) {
$parcel$export(module.exports, "envType", () => $9c4c150c990b1f10$export$56ac8ebc9870b1b9);
$parcel$export(module.exports, "eventType", () => $9c4c150c990b1f10$export$4c045e605d532c98);
$parcel$export(module.exports, "platformType", () => $9c4c150c990b1f10$export$6b4f396210e539f3);
$parcel$export(module.exports, "originType", () => $9c4c150c990b1f10$export$f73e9fcd368bb695);
$parcel$export(module.exports, "tenantType", () => $9c4c150c990b1f10$export$496f06ac2a964da2);
$parcel$export(module.exports, "productEmbedType", () => $9c4c150c990b1f10$export$f49776dca27a2e7c);
$parcel$export(module.exports, "userType", () => $9c4c150c990b1f10$export$1827adfd178b4870);
$parcel$export(module.exports, "apdexType", () => $9c4c150c990b1f10$export$99b37380a464d794);
$parcel$export(module.exports, "desktopPlatforms", () => $9c4c150c990b1f10$export$809831be6c4c6227);
$parcel$export(module.exports, "webPlatforms", () => $9c4c150c990b1f10$export$19c579398ad213e7);
$parcel$export(module.exports, "originTracingType", () => $9c4c150c990b1f10$export$62a500c02dc63ee);
$parcel$export(module.exports, "perimeterType", () => $9c4c150c990b1f10$export$bdd41749d2096e4b);
$parcel$export(module.exports, "aliasType", () => $9c4c150c990b1f10$export$a8c99e46b781d936);
$parcel$export(module.exports, "groupType", () => $9c4c150c990b1f10$export$e73680b18d9b7c6e);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ // These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.


var $9c4c150c990b1f10$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
var $9c4c150c990b1f10$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
var $9c4c150c990b1f10$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    /**
   *  @deprecated desktop is here for retrocompatibility, please select one of the above OS instead.
   */ platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
var $9c4c150c990b1f10$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
var $9c4c150c990b1f10$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["STUDIO_WORKSPACE_ID"] = "studioWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
var $9c4c150c990b1f10$export$f49776dca27a2e7c = /*#__PURE__*/ function(productEmbedType) {
    productEmbedType["FIRST_PARTY"] = "FIRST_PARTY";
    productEmbedType["THIRD_PARTY"] = "THIRD_PARTY";
    return productEmbedType;
}({});
var $9c4c150c990b1f10$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $9c4c150c990b1f10$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
var $9c4c150c990b1f10$export$809831be6c4c6227 = Object.freeze([
    $9c4c150c990b1f10$export$6b4f396210e539f3.DESKTOP,
    $9c4c150c990b1f10$export$6b4f396210e539f3.MAC,
    $9c4c150c990b1f10$export$6b4f396210e539f3.LINUX,
    $9c4c150c990b1f10$export$6b4f396210e539f3.WINDOWS
]);
var $9c4c150c990b1f10$export$19c579398ad213e7 = Object.freeze([
    $9c4c150c990b1f10$export$6b4f396210e539f3.WEB,
    $9c4c150c990b1f10$export$6b4f396210e539f3.MOBILE_WEB
]);
var $9c4c150c990b1f10$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
var $9c4c150c990b1f10$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
var $9c4c150c990b1f10$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
var $9c4c150c990b1f10$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
var $9c4c150c990b1f10$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

});

parcelRegister("nxH15", function(module, exports) {
$parcel$export(module.exports, "default", () => $046c48c9d0dd9a40$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $dpXUu = parcelRequire("dpXUu");

var $9raiz = parcelRequire("9raiz");

var $7Jko1 = parcelRequire("7Jko1");

var $7kC2L = parcelRequire("7kC2L");
function $046c48c9d0dd9a40$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $046c48c9d0dd9a40$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $046c48c9d0dd9a40$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $046c48c9d0dd9a40$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $046c48c9d0dd9a40$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ApdexEvent(onEvent, pageVisibility) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ApdexEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getEventKey", function(_ref) {
            var task = _ref.task, taskId = _ref.taskId;
            return taskId ? "".concat(task, ".").concat(taskId) : task;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getEventTimingByName", function(name) {
            var eventTimings = _this._performance.getEntriesByName(name);
            var eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getApdexFields", function(event) {
            var apdexTimings = _this._getApdexTimings(event);
            var apdexScore = _this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return $046c48c9d0dd9a40$var$_objectSpread($046c48c9d0dd9a40$var$_objectSpread({}, apdexTimings), {}, {
                apdex: apdexScore
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getApdexTimings", function(event) {
            var eventKey = _this._getEventKey(event);
            var eventStartName = "".concat(eventKey, "-start");
            var startTime = event.startTime || _this._getStartTime(event, eventStartName);
            var stopTime = event.stopTime || _this._getStopTime();
            // We do some clean up of the marks and started events
            _this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getStartTime", function(event, eventName) {
            var startTime;
            var timeOrigin = _this._performance.getTimeOrigin();
            if (event.type === (0, $dpXUu.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                var eventTiming = _this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getStopTime", function() {
            return _this._performance.getTimeOrigin() + _this._performance.now();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_cleanApdexState", function(eventKey) {
            _this._performance.clearMarks("".concat(eventKey, "-start"));
            _this._performance.clearMarks("".concat(eventKey, "-stop"));
            _this._startedEvents.delete(eventKey);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getVisibilityFields", function(event) {
            var isActiveTab;
            /**
       * For initialLoad type:
       * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
       *
       * For transition type:
       * 1. active status is tracked in active events map (_isActiveEvents)
       *
       * For any type, if startTime or stopTime is specified:
       * 1. If currently active (!_isHidden)
       */ if (event.type === (0, $dpXUu.apdexType).INITIAL_LOAD) isActiveTab = !_this._wasPreviouslyHidden;
            else if (event.type === (0, $dpXUu.apdexType).TRANSITION) {
                var eventKey = _this._getEventKey(event);
                isActiveTab = _this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !_this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_calculateApdex", function(_ref2) {
            var duration = _ref2.duration, _ref2$threshold = _ref2.threshold, threshold = _ref2$threshold === void 0 ? _this._threshold : _ref2$threshold;
            var apdex;
            var satisfiedThreshold = threshold;
            var tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_validateStartEvent", function(event) {
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_validateStopEvent", function(event) {
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $9raiz.isType)((0, $dpXUu.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
       * For a transition, if the startTime was not specified,
       * the start event should have been present.
       */ if (!event.startTime && event.type === (0, $dpXUu.apdexType).TRANSITION) {
                var eventKey = _this._getEventKey(event);
                if (!_this._startedEvents.has(eventKey)) throw new Error("Apdex event transition \"".concat(eventKey, "\" was not started"));
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_shouldSendEvent", function(event) {
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_sendEvent", function(event, callback) {
            if (_this._shouldSendEvent(event)) _this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: $046c48c9d0dd9a40$var$_objectSpread($046c48c9d0dd9a40$var$_objectSpread({}, event.additionalAttributes), {}, {
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || _this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                })
            }, callback);
        });
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, $7Jko1.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, $7kC2L.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', function(isHidden) {
            _this.onVisibilityChange(!isHidden);
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ApdexEvent, [
        {
            key: "start",
            value: function start(event) {
                this._validateStartEvent(event);
                if (!this._performance.isAvailable()) return;
                var eventKey = this._getEventKey(event);
                var eventStartName = "".concat(eventKey, "-start");
                this._startedEvents.set(eventKey, true);
                this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
                this._performance.clearMarks(eventStartName);
                this._performance.mark(eventStartName);
            }
        },
        {
            key: "getStart",
            value: function getStart(event) {
                this._validateStartEvent(event);
                if (!this._performance.isAvailable()) return undefined;
                var eventKey = this._getEventKey(event);
                var eventStartName = "".concat(eventKey, "-start");
                return this._getEventTimingByName(eventStartName);
            }
        },
        {
            key: "stop",
            value: function stop(event, callback) {
                this._validateStopEvent(event);
                if (!this._performance.isAvailable()) return;
                var apdexFields = this._getApdexFields(event);
                var visibilityFields = this._getVisibilityFields(event);
                this._sendEvent($046c48c9d0dd9a40$var$_objectSpread($046c48c9d0dd9a40$var$_objectSpread($046c48c9d0dd9a40$var$_objectSpread({}, event), apdexFields), visibilityFields), callback);
            }
        },
        {
            key: "onVisibilityChange",
            value: function onVisibilityChange(isActive) {
                var _this2 = this;
                if (!isActive) {
                    this._wasPreviouslyHidden = true;
                    Array.from(this._isActiveEvents.keys()).forEach(function(key) {
                        return _this2._isActiveEvents.set(key, false);
                    });
                }
            }
        }
    ]);
}();

});
parcelRegister("9raiz", function(module, exports) {
$parcel$export(module.exports, "isType", () => $6dee9fba7ded93f5$export$26b9f946b448f23e);
function $6dee9fba7ded93f5$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}

});

parcelRegister("7Jko1", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a0c8cae642f3b67$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
var $5a0c8cae642f3b67$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PageVisibility() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PageVisibility);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_bindEventListeners", function() {
            document.addEventListener(_this._visibilityChange, _this._handleVisibilityChange, false);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_handleVisibilityChange", function() {
            var isHidden = document[_this._hidden];
            _this._isHidden = isHidden;
            _this._callbacks.forEach(function(callbackFn) {
                return callbackFn(isHidden);
            });
        });
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PageVisibility, [
        {
            key: "addCallback",
            value: function addCallback(name, fn) {
                if (typeof name !== 'string') throw new Error('Invalid name, must be string');
                if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
                this._callbacks.set(name, fn);
            }
        },
        {
            key: "removeCallback",
            value: function removeCallback(name) {
                if (this._callbacks.has(name)) this._callbacks.delete(name);
            }
        },
        {
            key: "getIsHidden",
            value: function getIsHidden() {
                return this._isHidden;
            }
        }
    ]);
}();

});

parcelRegister("7kC2L", function(module, exports) {
$parcel$export(module.exports, "default", () => $5567e94e2046948c$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");
var $5567e94e2046948c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Performance() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Performance);
        this._performance = window.performance;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Performance, [
        {
            key: "clearMarks",
            value: function clearMarks() {
                var _this$_performance;
                if (!this._performance || !this._performance.clearMarks) return;
                (_this$_performance = this._performance).clearMarks.apply(_this$_performance, arguments);
            }
        },
        {
            key: "mark",
            value: function mark() {
                var _this$_performance2;
                if (!this._performance || !this._performance.mark) return;
                (_this$_performance2 = this._performance).mark.apply(_this$_performance2, arguments);
            }
        },
        {
            key: "getEntriesByName",
            value: function getEntriesByName() {
                var _this$_performance3;
                if (!this._performance || !this._performance.getEntriesByName) return [];
                return (_this$_performance3 = this._performance).getEntriesByName.apply(_this$_performance3, arguments);
            }
        },
        {
            key: "getTimeOrigin",
            value: function getTimeOrigin() {
                if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
                return this._performance.timeOrigin || this._performance.timing.navigationStart;
            }
        },
        {
            key: "now",
            value: function now() {
                if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
                return this._performance.now();
            }
        },
        {
            key: "isAvailable",
            value: function isAvailable() {
                return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
            }
        }
    ]);
}();

});


parcelRegister("doaPm", function(module, exports) {
$parcel$export(module.exports, "buildActionEvent", () => $9bf5ea544d445952$export$7bf451af4a8e3dd9);

var $25nEq = parcelRequire("25nEq");

var $3Bvfg = parcelRequire("3Bvfg");

var $i5njK = parcelRequire("i5njK");

var $16Pbp = parcelRequire("16Pbp");

var $34zyg = parcelRequire("34zyg");

var $bYscG = parcelRequire("bYscG");

var $lReO1 = parcelRequire("lReO1");

var $fea3y = parcelRequire("fea3y");

var $bCSvc = parcelRequire("bCSvc");

var $10rPP = parcelRequire("10rPP");

var $cu68C = parcelRequire("cu68C");

var $fcerX = parcelRequire("fcerX");
function $9bf5ea544d445952$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9bf5ea544d445952$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9bf5ea544d445952$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9bf5ea544d445952$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9bf5ea544d445952$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, aliases, groups) {
    var productFields = (0, $fea3y.buildProductFields)(productInfo, (0, $fcerX.extractProductOverrides)(event));
    var tenantFields = (0, $bCSvc.buildTenantFields)(tenantInfo);
    var orgFields = (0, $lReO1.buildOrgFields)(orgInfo);
    var workspaceFields = (0, $cu68C.buildWorkspaceFields)(workspaceInfo);
    var collaborationContextFields = (0, $16Pbp.buildCollaborationContextFields)(collaborationContextInfo);
    var userFields = (0, $10rPP.buildUserFields)(userInfo);
    var actionFields = (0, $3Bvfg.buildActionFields)(event, actionEventType);
    return $9bf5ea544d445952$var$_objectSpread($9bf5ea544d445952$var$_objectSpread($9bf5ea544d445952$var$_objectSpread($9bf5ea544d445952$var$_objectSpread($9bf5ea544d445952$var$_objectSpread($9bf5ea544d445952$var$_objectSpread($9bf5ea544d445952$var$_objectSpread($9bf5ea544d445952$var$_objectSpread($9bf5ea544d445952$var$_objectSpread($9bf5ea544d445952$var$_objectSpread({}, productFields), tenantFields), orgFields), userFields), actionFields), (0, $34zyg.buildEventOverrides)(event)), {}, {
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId
    }, workspaceFields), collaborationContextFields), (0, $i5njK.buildAliases)(aliases)), (0, $bYscG.buildGroups)(groups));
}

});
parcelRegister("3Bvfg", function(module, exports) {
$parcel$export(module.exports, "buildActionFields", () => $29fd106b1c4d9134$export$655ecf7241feac42);

var $25nEq = parcelRequire("25nEq");

var $gLNNb = parcelRequire("gLNNb");
function $29fd106b1c4d9134$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $29fd106b1c4d9134$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $29fd106b1c4d9134$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $29fd106b1c4d9134$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $29fd106b1c4d9134$export$655ecf7241feac42(event, actionEventType) {
    return $29fd106b1c4d9134$var$_objectSpread({
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType
    }, (0, $gLNNb.buildContainersWithName)(event.containers));
}

});
parcelRegister("gLNNb", function(module, exports) {
$parcel$export(module.exports, "buildContainersWithName", () => $c357a8d34df33912$export$f045f238d77c002a);

var $9ThfS = parcelRequire("9ThfS");

var $c6Zqk = parcelRequire("c6Zqk");

var $fF75j = parcelRequire("fF75j");
function $c357a8d34df33912$export$f045f238d77c002a(containers) {
    if ((0, $fF75j.isNotEmptyObject)(containers)) {
        var validContainers = (0, $c6Zqk.filterAndBuildContainers)(containers);
        return (0, $9ThfS.buildAttributesWithName)('containers', validContainers);
    }
    return undefined;
}

});
parcelRegister("9ThfS", function(module, exports) {
$parcel$export(module.exports, "buildAttributesWithName", () => $7336a2a017c8348e$export$55b70947967d0b50);

var $25nEq = parcelRequire("25nEq");

var $fF75j = parcelRequire("fF75j");
function $7336a2a017c8348e$export$55b70947967d0b50(name, attrObject) {
    return (0, $fF75j.isNotEmptyObject)(attrObject) ? (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, name, attrObject) : undefined;
}

});
parcelRegister("fF75j", function(module, exports) {
$parcel$export(module.exports, "isNotEmptyObject", () => $b6702e3d22f9f4a3$export$e0287cc73292b477);

var $8OhNE = parcelRequire("8OhNE");
function $b6702e3d22f9f4a3$export$e0287cc73292b477(obj) {
    return (0, $8OhNE.isPlainObject)(obj) && Object.keys(obj).length > 0;
}

});
parcelRegister("8OhNE", function(module, exports) {
$parcel$export(module.exports, "isPlainObject", () => $66a0cce84268e928$export$53b83ca8eaab0383);

var $ekGgq = parcelRequire("ekGgq");
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $66a0cce84268e928$var$isObject(val) {
    return val !== null && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val) === 'object' && Array.isArray(val) === false;
}
function $66a0cce84268e928$var$isObjectObject(o) {
    return $66a0cce84268e928$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function $66a0cce84268e928$export$53b83ca8eaab0383(o) {
    if ($66a0cce84268e928$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    var ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    var prot = ctor.prototype;
    if ($66a0cce84268e928$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}

});



parcelRegister("c6Zqk", function(module, exports) {
$parcel$export(module.exports, "filterAndBuildContainers", () => $8d15b10e48711977$export$3f5115a568819c1a);
function $8d15b10e48711977$export$3f5115a568819c1a(containers) {
    var validContainers = {};
    Object.keys(containers).forEach(function(key) {
        var value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}

});



parcelRegister("i5njK", function(module, exports) {
$parcel$export(module.exports, "buildAliases", () => $d2aac801566a776e$export$2c4ef8ee173bbcaa);

var $fF75j = parcelRequire("fF75j");
function $d2aac801566a776e$export$2c4ef8ee173bbcaa(aliases) {
    if ((0, $fF75j.isNotEmptyObject)(aliases)) return {
        aliases: aliases
    };
    return undefined;
}

});

parcelRegister("16Pbp", function(module, exports) {
$parcel$export(module.exports, "buildCollaborationContextFields", () => $0cee0de0c0689d82$export$d138783ff9effae1);
function $0cee0de0c0689d82$export$d138783ff9effae1(collaborationContextInfo) {
    return {
        collaborationContextAri: collaborationContextInfo.collaborationContextAri
    };
}

});

parcelRegister("34zyg", function(module, exports) {
$parcel$export(module.exports, "buildEventOverrides", () => $23cd529cd6044111$export$469803cc371327c2);
function $23cd529cd6044111$export$469803cc371327c2(event) {
    var result = {};
    if (event.anonymousId) result.anonymousId = event.anonymousId;
    if (event.excludedProperties) result.excludedProperties = event.excludedProperties;
    if (event.userConsents) result.userConsents = event.userConsents;
    return result;
}

});

parcelRegister("bYscG", function(module, exports) {
$parcel$export(module.exports, "buildGroups", () => $8b7b2cf5859cbfb1$export$680f59e10d3eb269);

var $fF75j = parcelRequire("fF75j");
function $8b7b2cf5859cbfb1$export$680f59e10d3eb269(groups) {
    if ((0, $fF75j.isNotEmptyObject)(groups)) return {
        groups: groups
    };
    return undefined;
}

});

parcelRegister("lReO1", function(module, exports) {
$parcel$export(module.exports, "buildOrgFields", () => $fe9a0859b48fd736$export$19ccbe55c9aa75d5);
function $fe9a0859b48fd736$export$19ccbe55c9aa75d5(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}

});

parcelRegister("fea3y", function(module, exports) {
$parcel$export(module.exports, "buildProductFields", () => $b15ff6cf1be335fd$export$bd1896e45d2ef8e8);

var $36pRP = parcelRequire("36pRP");
function $b15ff6cf1be335fd$export$bd1896e45d2ef8e8(productInfo, productOverrides) {
    var overrides = productOverrides || {};
    var env = (0, $36pRP.getProductField)(productInfo.env, overrides.env);
    var product = (0, $36pRP.getProductField)(productInfo.product, overrides.product);
    var subproduct = (0, $36pRP.getProductField)(productInfo.subproduct(), overrides.subproduct);
    var version = (0, $36pRP.getProductField)(productInfo.version, overrides.version);
    var origin = (0, $36pRP.getProductField)(productInfo.origin, overrides.origin);
    var platform = (0, $36pRP.getProductField)(productInfo.platform, overrides.platform);
    var ic = productInfo.ic; // ic should not be overriden once set
    var cdp = productInfo.cdp;
    var csp = productInfo.csp;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform,
        ic: ic,
        cdp: cdp,
        csp: csp
    };
}

});
parcelRegister("36pRP", function(module, exports) {
$parcel$export(module.exports, "getProductField", () => $2425ff53b9f84897$export$690c718dc8037b2e);
function $2425ff53b9f84897$export$690c718dc8037b2e(field, override) {
    return override === undefined ? field : override;
}

});


parcelRegister("bCSvc", function(module, exports) {
$parcel$export(module.exports, "buildTenantFields", () => $876d8558daa280db$export$ab02ab56ae59d840);
function $876d8558daa280db$export$ab02ab56ae59d840(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}

});

parcelRegister("10rPP", function(module, exports) {
$parcel$export(module.exports, "buildUserFields", () => $0bbb61f8fe744228$export$4557a3fdd8921d68);
function $0bbb61f8fe744228$export$4557a3fdd8921d68(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}

});

parcelRegister("cu68C", function(module, exports) {
$parcel$export(module.exports, "buildWorkspaceFields", () => $916d0c3cd820eaae$export$73c41604cd4b31da);
function $916d0c3cd820eaae$export$73c41604cd4b31da(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}

});

parcelRegister("fcerX", function(module, exports) {
$parcel$export(module.exports, "extractProductOverrides", () => $b1032f70589e833f$export$e3d99b4bfec06f6e);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $b1032f70589e833f$export$e3d99b4bfec06f6e(event) {
    var env = event.env, product = event.product, subproduct = event.subproduct, version = event.version, origin = event.origin, platform = event.platform;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}

});


parcelRegister("478yZ", function(module, exports) {
$parcel$export(module.exports, "buildActionName", () => $2fee755b81092588$export$9c5623a792efc9b0);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $2fee755b81092588$export$9c5623a792efc9b0(event) {
    return "".concat(event.actionSubject, " ").concat(event.action);
}

});

parcelRegister("dIKYA", function(module, exports) {
$parcel$export(module.exports, "buildContext", () => $9fd3d2eab8b5dac2$export$3a7fe28f9bf4f3d9);

var $cjBLF = parcelRequire("cjBLF");
var $9fd3d2eab8b5dac2$var$libraryVersion = "5.32.0";
function $9fd3d2eab8b5dac2$var$getDefaultValidationMode(productInfo) {
    var environment = productInfo.env;
    if (environment === undefined) return (0, $cjBLF.validationMode).QUIET;
    if (environment.includes('prod')) return (0, $cjBLF.validationMode).QUIET;
    return (0, $cjBLF.validationMode).COMPLETE;
}
function $9fd3d2eab8b5dac2$export$3a7fe28f9bf4f3d9(productInfo) {
    var screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: $9fd3d2eab8b5dac2$var$libraryVersion
            },
            validationMode: $9fd3d2eab8b5dac2$var$getDefaultValidationMode(productInfo)
        }
    };
}

});
parcelRegister("cjBLF", function(module, exports) {
$parcel$export(module.exports, "validationMode", () => $8f748e4bbc815a77$export$fbd92247fb4d6159);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $8f748e4bbc815a77$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});

});


parcelRegister("1dFnn", function(module, exports) {
$parcel$export(module.exports, "buildScreenEvent", () => $0e3719bfd1028ce1$export$c7d9a5f56acc4b19);

var $25nEq = parcelRequire("25nEq");

var $dpXUu = parcelRequire("dpXUu");

var $i5njK = parcelRequire("i5njK");

var $9ThfS = parcelRequire("9ThfS");

var $16Pbp = parcelRequire("16Pbp");

var $gLNNb = parcelRequire("gLNNb");

var $34zyg = parcelRequire("34zyg");

var $bYscG = parcelRequire("bYscG");

var $dIkIq = parcelRequire("dIkIq");

var $lReO1 = parcelRequire("lReO1");

var $fea3y = parcelRequire("fea3y");

var $bCSvc = parcelRequire("bCSvc");

var $10rPP = parcelRequire("10rPP");

var $cu68C = parcelRequire("cu68C");
function $0e3719bfd1028ce1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0e3719bfd1028ce1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0e3719bfd1028ce1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0e3719bfd1028ce1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0e3719bfd1028ce1$var$buildAttributes(attributes) {
    return (0, $9ThfS.buildAttributesWithName)('attributes', attributes);
}
function $0e3719bfd1028ce1$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return (0, $9ThfS.buildAttributesWithName)('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function $0e3719bfd1028ce1$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, event, containers, aliases, groups) {
    var productFields = (0, $fea3y.buildProductFields)(productInfo);
    var tenantFields = (0, $bCSvc.buildTenantFields)(tenantInfo);
    var userFields = (0, $10rPP.buildUserFields)(userInfo);
    var orgFields = (0, $lReO1.buildOrgFields)(orgInfo);
    var workspaceFields = (0, $cu68C.buildWorkspaceFields)(workspaceInfo);
    var collaborationContextFields = (0, $16Pbp.buildCollaborationContextFields)(collaborationContextInfo);
    return $0e3719bfd1028ce1$var$_objectSpread($0e3719bfd1028ce1$var$_objectSpread($0e3719bfd1028ce1$var$_objectSpread($0e3719bfd1028ce1$var$_objectSpread($0e3719bfd1028ce1$var$_objectSpread($0e3719bfd1028ce1$var$_objectSpread($0e3719bfd1028ce1$var$_objectSpread($0e3719bfd1028ce1$var$_objectSpread($0e3719bfd1028ce1$var$_objectSpread($0e3719bfd1028ce1$var$_objectSpread($0e3719bfd1028ce1$var$_objectSpread($0e3719bfd1028ce1$var$_objectSpread($0e3719bfd1028ce1$var$_objectSpread({
        eventType: (0, $dpXUu.eventType).SCREEN
    }, productFields), tenantFields), userFields), orgFields), (0, $dIkIq.buildLocationFields)(event)), $0e3719bfd1028ce1$var$buildAttributes(attributes)), $0e3719bfd1028ce1$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes)), (0, $gLNNb.buildContainersWithName)(containers)), (0, $34zyg.buildEventOverrides)(event)), {}, {
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId
    }, workspaceFields), collaborationContextFields), (0, $i5njK.buildAliases)(aliases)), (0, $bYscG.buildGroups)(groups));
}

});
parcelRegister("dIkIq", function(module, exports) {
$parcel$export(module.exports, "buildLocationFields", () => $9fbf74185e6a4e67$export$6dfd201add24e54d);

var $ekGgq = parcelRequire("ekGgq");
function $9fbf74185e6a4e67$export$6dfd201add24e54d(event) {
    var payload = (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(event) === 'object' ? event : undefined;
    return {
        title: '',
        path: typeof (payload === null || payload === void 0 ? void 0 : payload.path) === 'string' ? payload.path : '',
        url: typeof (payload === null || payload === void 0 ? void 0 : payload.url) === 'string' ? payload.url : '',
        referrer: '',
        search: ''
    };
}

});


parcelRegister("aYviu", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fd7c8f1cf1381dd$export$2e2bcd8739ae039);
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ var $7fd7c8f1cf1381dd$var$isFunction = function isFunction(possibleFn) {
    return typeof possibleFn === 'function';
};
var $7fd7c8f1cf1381dd$export$2e2bcd8739ae039 = function(possibleFn, errorMessage) {
    return function() {
        if ($7fd7c8f1cf1381dd$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("".concat(errorMessage, " - ").concat(e instanceof Error ? e.message : String(e)));
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("3xmDM", function(module, exports) {
$parcel$export(module.exports, "default", () => $293604237edd7ee5$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $5qIxc = parcelRequire("5qIxc");

var $hiAXT = parcelRequire("hiAXT");

var $aWPob = parcelRequire("aWPob");

var $dpXUu = parcelRequire("dpXUu");

var $2UUeH = parcelRequire("2UUeH");
var $293604237edd7ee5$var$isCrossProductInteractionAttribute = function isCrossProductInteractionAttribute(_, paramName) {
    return paramName === (0, $hiAXT.URL_QUERY_PARAM_INTERACTION_SESSION);
};
/**
 * This class initialises the Analytics Cross Product Interaction Client, which keeps track of the
 * interactionSessionId we use to track cross-product user journeys.
 *
 * It parses URL query parameters for any previous interaction session attributes.
 * If none exist, the Analytics Cross Product Interaction Client will generate a new
 * interactionSessionId, and the class will expose a method for retrieving this from Session Storage
 *
 * @param sendEventCallback: Expects a callback function that can send an analytics event
 */ var $293604237edd7ee5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function CrossProductInteractionTracking(options) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, CrossProductInteractionTracking);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "validProduct", false);
        this.isEnabled = options.perimeter !== (0, $dpXUu.perimeterType).FEDRAMP_MODERATE;
        this.urlValidation = {
            result: true,
            url: ''
        };
        this.sendEventCallback = options.sendEventCallback;
        if (this.isEnabled) {
            var bridge;
            var interactionSessionId;
            var interactionSource;
            var interactionSessionOptions;
            this.urlValidation.url = window.location.href;
            // Validate product
            //
            // Various UI components in the page might initialize their own AWC instances but some of those
            // instances might be associated with subordinate products that are of no interest to XPC tracking. We
            // want to avoid XPC meta analytics being fired against uninteresting products.
            //
            // Some products (e.g. Confluence) also have custom URL replace functions passed into AWC settings,
            // and we need to use those to ensure our query parameter is correctly processed.
            //
            // TODO - this is currently the best way we can try and guarantee that the most relevant product's AWC
            // is passing in the options. Down the line we ideally want the relevant products themselves to opt-in
            // to initialising cross product tracking via a flag in their AWC init options.
            this.validProduct = (0, $aWPob.validProducts).includes(options.product);
            if (this.validProduct) {
                // Only parse URL parameters if we are in a valid product
                var crossProductUrlPramater = (0, $2UUeH.default)($293604237edd7ee5$var$isCrossProductInteractionAttribute, options.historyReplaceFn);
                var interactionSessionBlob = (0, $hiAXT.URL_QUERY_PARAM_INTERACTION_SESSION) in crossProductUrlPramater ? crossProductUrlPramater[0, $hiAXT.URL_QUERY_PARAM_INTERACTION_SESSION] : null;
                if (interactionSessionBlob) try {
                    var interactionSession = JSON.parse(atob(interactionSessionBlob));
                    if (interactionSession.bridge && interactionSession.id && interactionSession.source) {
                        // All 3 fields must be present from a valid query param
                        bridge = interactionSession.bridge;
                        interactionSessionId = interactionSession.id;
                        interactionSource = interactionSession.source;
                    } else this.urlValidation.result = false;
                } catch (_unused) {
                    // Gracefully fail through if parameter has been corrupted
                    this.urlValidation.result = false;
                }
                interactionSessionOptions = {
                    analyticsEventCallback: this.sendEventCallback,
                    persistedSessionId: interactionSessionId
                };
            }
            // Initialise interaction session client with parsed values if they exist
            this.analyticsCrossProductInteractionClient = new (0, $5qIxc.default)(interactionSessionOptions, bridge, interactionSource);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(CrossProductInteractionTracking, [
        {
            key: "getInteractionSession",
            value: function getInteractionSession() {
                if (this.isEnabled && this.analyticsCrossProductInteractionClient) return {
                    bridge: this.analyticsCrossProductInteractionClient.getBridge(),
                    id: this.analyticsCrossProductInteractionClient.getCurrentInteractionSessionId(),
                    prevId: this.analyticsCrossProductInteractionClient.getPreviousInteractionSessionId(),
                    source: this.analyticsCrossProductInteractionClient.getInteractionSource()
                };
                else return {
                    bridge: null,
                    id: null,
                    prevId: null,
                    source: null
                };
            }
        },
        {
            key: "validateInteractionSession",
            value: function validateInteractionSession() {
                if (!this.urlValidation.result) this.sendEventCallback({
                    action: 'corrupted',
                    actionSubject: 'interactionSession',
                    attributes: {
                        url: this.urlValidation.url
                    },
                    source: 'interactionComponent',
                    tags: [
                        'navigationExperiences'
                    ] // InteractionSession events will be registered under this platform product
                });
            }
        }
    ]);
}();

});
parcelRegister("5qIxc", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f41ed13c410b797$export$2e2bcd8739ae039);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $25nEq = parcelRequire("25nEq");

var $iyMnq = parcelRequire("iyMnq");

var $e67NL = parcelRequire("e67NL");

var $50U6m = parcelRequire("50U6m");

var $gwTbL = parcelRequire("gwTbL");

var $iukH2 = parcelRequire("iukH2");
var $3f41ed13c410b797$export$b9dd752fb13352ce = 'interactionSession.source';
var $3f41ed13c410b797$export$e04e3c50573f9af7 = 'interactionSession.bridge';
/**
 * AnalyticsCrossProductInteractionClient is a wrapper for the InteractionSessionTracking class.
 * It is designed to be used internally within the Atlassian Analytics Pipeline as well as useCrossProductUrlWrapper hook.
 * It is not intended to be used directly by end-users.
 *
 * This will create an instance of the interaction session tracker on the window object, which can be shared across different parts of a document.
 * If the internal client already exists, it will use the existing instance. Creating the client in a singleton manner like this enables us
 * to debounce updates to Session Storage, which is important when a large number of links using our hook are rendered on a page.
 *
 * The other interaction session parameters are written directly to session storage as they are predominantly read-only,
 * with the only update being the initialisation of the client
 */ var $3f41ed13c410b797$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(function AnalyticsCrossProductInteractionClient(interactionSessionOptions, bridge, interactionSource) {
    var _this = this;
    (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsCrossProductInteractionClient);
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getCurrentInteractionSessionId", function() {
        return _this.isEnabled && _this.interactionSessionTracking ? _this.interactionSessionTracking.getCurrentInteractionSessionId() : null;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getPreviousInteractionSessionId", function() {
        return _this.isEnabled && _this.interactionSessionTracking ? _this.interactionSessionTracking.getPreviousInteractionSessionId() : null;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getBridge", function() {
        return _this.isEnabled && _this.safeSessionStorage ? _this.safeSessionStorage.getItem($3f41ed13c410b797$export$e04e3c50573f9af7) : null;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getInteractionSource", function() {
        return _this.isEnabled && _this.safeSessionStorage ? _this.safeSessionStorage.getItem($3f41ed13c410b797$export$b9dd752fb13352ce) : null;
    });
    var shouldDisable = (0, $50U6m.fg)('use_frontend_feature_encoding_sdk_platform') ? !(0, $iyMnq.isFeatureEnabled)('atlassian-analytics', 'atlassian-analytics-cross-product-interaction-client') : (0, $e67NL.isFedrampModerate)();
    this.isEnabled = !shouldDisable;
    if (this.isEnabled) {
        // Get singleton interaction session tracking instance
        this.interactionSessionTracking = (0, $gwTbL.default).getInstance();
        var isValidPersistedId = false;
        if (this.interactionSessionTracking) {
            if (interactionSessionOptions) {
                this.interactionSessionTracking.setAnalyticsCallback(interactionSessionOptions.analyticsEventCallback);
                isValidPersistedId = this.interactionSessionTracking.setInteractionSessionId(interactionSessionOptions.persistedSessionId);
            }
        }
        this.safeSessionStorage = new (0, $iukH2.default)();
        // Store other interaction session parameters directly in session storage if ID has been validated
        if (isValidPersistedId) {
            bridge && this.safeSessionStorage.setItem($3f41ed13c410b797$export$e04e3c50573f9af7, bridge);
            interactionSource && this.safeSessionStorage.setItem($3f41ed13c410b797$export$b9dd752fb13352ce, interactionSource);
        }
    }
});

});
parcelRegister("iyMnq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $cRnTy = parcelRequire("cRnTy");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabled", {
    enumerable: true,
    get: function() {
        return $cRnTy.isEnvironmentBlockEnabled;
    }
});
Object.defineProperty(module.exports, "isFeatureEnabled", {
    enumerable: true,
    get: function() {
        return $cRnTy.isFeatureEnabled;
    }
});

});
parcelRegister("cRnTy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearAuditState = module.exports.configureAuditState = module.exports.shouldEnableForAudit = module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $4IiYp = parcelRequire("4IiYp");

var $5usR7 = parcelRequire("5usR7");

var $f7GDf = parcelRequire("f7GDf");

var $4WG8s = parcelRequire("4WG8s");
const $95ccf857b0bcb579$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX = "aem-audit";
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @returns if the environment block is available in the current cloud environment
 */ function $95ccf857b0bcb579$var$isEnvironmentBlockEnabled(environmentBlockName) {
    const boundaryKey = $95ccf857b0bcb579$var$getBoundaryKey();
    return (0, $5usR7.isEnvironmentBlockEnabledForBoundary)(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabled = $95ccf857b0bcb579$var$isEnvironmentBlockEnabled;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param offeringPredicates Optional map of boundary keys to predicate functions. When a predicate
 *   is provided for the current boundary, the feature is only considered enabled if both
 *   the AEM state and the predicate return true.
 * @returns if the feature is available in the current cloud environment
 */ function $95ccf857b0bcb579$var$isFeatureEnabled(environmentBlockName, featureName, offeringPredicates) {
    const override = (0, $f7GDf.getFeatureOverride)(environmentBlockName, featureName);
    if (override !== null) return override;
    const boundaryKey = $95ccf857b0bcb579$var$getBoundaryKey();
    const aemResult = (0, $5usR7.isFeatureEnabledForBoundary)(environmentBlockName, featureName, boundaryKey);
    // Keep predicate evaluation deferred until AEM or an explicit fallback resolves the feature as enabled.
    const isAllowedForCurrentOffering = ()=>{
        const predicate = offeringPredicates ? offeringPredicates[boundaryKey] : undefined;
        return predicate ? predicate() : true;
    };
    if (!aemResult) {
        const metadata = (0, $5usR7.getFeatureAvailabilityMetadataForBoundary)(environmentBlockName, featureName, boundaryKey);
        if ($95ccf857b0bcb579$var$shouldEnableForIcPreRelease(metadata, boundaryKey)) return isAllowedForCurrentOffering();
        if ((0, $4WG8s.isSSR)()) return false; // SSR: fallback to standard AEM resolution
        if (metadata && metadata.auditPhase) return $95ccf857b0bcb579$var$shouldEnableForAudit(metadata.auditPhase, environmentBlockName, featureName);
        return false; // fallback to default behavior when not in audit state
    }
    return isAllowedForCurrentOffering();
}
module.exports.isFeatureEnabled = $95ccf857b0bcb579$var$isFeatureEnabled;
/** Enables IC pre-release features only for the pre-release isolation context. */ function $95ccf857b0bcb579$var$shouldEnableForIcPreRelease(metadata, boundaryKey) {
    return boundaryKey === $5usR7.ISOLATED_CLOUD_COMMERCIAL_KEY && (0, $4IiYp.isolationContextId)() === "ic-dr6" && metadata !== undefined && metadata.preRelease === true;
}
/**
 * Determines whether a feature that is not enabled via standard AEM resolution
 * should be enabled due to an active audit phase.
 *
 * This function should only be called for excluded features in browser contexts that have an active
 * audit phase. It applies the following rules:
 *
 * | Phase            | Environment | localStorage key set? | Result  |
 * | ---------------- | ----------- | --------------------- | ------- |
 * | internal-audit   | non-prod    | any                   | true    |
 * | internal-audit   | prod        | any                   | false   |
 * | external-audit   | non-prod    | any                   | true    |
 * | external-audit   | prod        | yes ("true")          | true    |
 * | external-audit   | prod        | no                    | false   |
 *
 * In SSR contexts (no window/localStorage), this falls back to false
 * for any case that would require a localStorage check.
 */ function $95ccf857b0bcb579$var$shouldEnableForAudit(auditPhase, environmentBlockName, featureName) {
    const envType = (0, $4WG8s.getEnvironmentType)();
    if (envType === "non-prod") return true;
    if (auditPhase === $5usR7.UnderAuditPhase.EXTERNAL_AUDIT && !(0, $4WG8s.isSSR)() && localStorage.getItem(`${$95ccf857b0bcb579$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`) === "true") return true;
    return false;
}
module.exports.shouldEnableForAudit = $95ccf857b0bcb579$var$shouldEnableForAudit;
function $95ccf857b0bcb579$var$getBoundaryKey() {
    if ((0, $4IiYp.isFedrampModerate)()) return $5usR7.FED_MOD_KEY;
    if ((0, $4IiYp.isIsolatedCloud)()) return $5usR7.ISOLATED_CLOUD_COMMERCIAL_KEY;
    return $5usR7.COMMERCIAL_KEY;
}
function $95ccf857b0bcb579$var$configureAuditState(environmentBlockName, featureName, value) {
    localStorage.setItem(`${$95ccf857b0bcb579$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`, value);
}
module.exports.configureAuditState = $95ccf857b0bcb579$var$configureAuditState;
function $95ccf857b0bcb579$var$clearAuditState(environmentBlockName, featureName) {
    localStorage.removeItem(`${$95ccf857b0bcb579$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`);
}
module.exports.clearAuditState = $95ccf857b0bcb579$var$clearAuditState;
// Register global API on window for browser dev tools usage
if (typeof window !== "undefined") window.__AEM_FEATURE_JS__ = {
    checkFeature: $95ccf857b0bcb579$var$isFeatureEnabled,
    overrideFeature: $f7GDf.overrideFeature,
    clearFeatureOverride: $f7GDf.clearFeatureOverride,
    clearAllOverrides: $f7GDf.clearAllOverrides,
    configureAuditState: $95ccf857b0bcb579$var$configureAuditState,
    clearAuditState: $95ccf857b0bcb579$var$clearAuditState
};

});
parcelRegister("4IiYp", function(module, exports) {
$parcel$export(module.exports, "isIsolatedCloud", () => $36e9fd2f62a1f8d7$export$9186ccba8effc5de);
$parcel$export(module.exports, "isFedrampModerate", () => $36e9fd2f62a1f8d7$export$104cb891a6e90b3a);
$parcel$export(module.exports, "isolationContextId", () => $36e9fd2f62a1f8d7$export$839b022803d38d4d);

var $gDKIc = parcelRequire("gDKIc");

var $3SaBA = parcelRequire("3SaBA");
function $36e9fd2f62a1f8d7$export$9186ccba8effc5de() {
    var atlCtxCookieValues = (0, $3SaBA.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $gDKIc.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}
function $36e9fd2f62a1f8d7$export$104cb891a6e90b3a() {
    var atlCtxCookieValues = (0, $3SaBA.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $gDKIc.FEDRAMP_MODERATE);
}
function $36e9fd2f62a1f8d7$export$80638ee198476daf() {
    var atlCtxCookieValues = (0, $3SaBA.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icDomain;
}
function $36e9fd2f62a1f8d7$export$839b022803d38d4d() {
    var atlCtxCookieValues = (0, $3SaBA.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icId;
}

});
parcelRegister("gDKIc", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $c1d485e2a5aca663$export$ce553301d55c2fd8);
$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", () => $c1d485e2a5aca663$export$d8347b4aae768c2d);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $c1d485e2a5aca663$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $c1d485e2a5aca663$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $c1d485e2a5aca663$export$a0ffa0598c95dfb7);
var $c1d485e2a5aca663$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $c1d485e2a5aca663$export$f005e2e9f707cb5f = 'commercial';
var $c1d485e2a5aca663$export$a739cd5aac835909 = 'staging';
var $c1d485e2a5aca663$export$42dd0cdd351a4a9 = 'prod';
var $c1d485e2a5aca663$export$404582bc18fe4d9e = 'dev';
var $c1d485e2a5aca663$export$d8347b4aae768c2d = [
    $c1d485e2a5aca663$export$f005e2e9f707cb5f
];
var $c1d485e2a5aca663$export$b1b1ccc8f3e7f954 = [
    $c1d485e2a5aca663$export$f005e2e9f707cb5f,
    $c1d485e2a5aca663$export$ce553301d55c2fd8
];
var $c1d485e2a5aca663$export$87285944378c596 = 'Atl-Ctx-Perimeter';
var $c1d485e2a5aca663$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
var $c1d485e2a5aca663$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';

});

parcelRegister("3SaBA", function(module, exports) {
$parcel$export(module.exports, "parseAtlCtxCookies", () => $2d1ea43de658d657$export$3fa7b7af96286cc9);

var $iYJcE = parcelRequire("iYJcE");

var $gDKIc = parcelRequire("gDKIc");
function $2d1ea43de658d657$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $2d1ea43de658d657$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $2d1ea43de658d657$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2d1ea43de658d657$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2d1ea43de658d657$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $2d1ea43de658d657$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
/**
 * Internal helper function used to parse cookie values and extract value of provided cookie name
 * @param {AtlCtxCookieName} cookieName - The name of the cookie to extract
 * @param {string} cookieString - The full cookie string
 * @returns {string | undefined} - The cookie value if present, undefined otherwise
 */ function $2d1ea43de658d657$var$getRawCookieValue(cookieName, cookieString) {
    if (!cookieString) return undefined;
    var cookies = cookieString.split(';');
    var _iterator = $2d1ea43de658d657$var$_createForOfIteratorHelper(cookies), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var cookie = _step.value;
            var _cookie$trim$split = cookie.trim().split('='), _cookie$trim$split2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_cookie$trim$split, 2), name = _cookie$trim$split2[0], value = _cookie$trim$split2[1];
            if (name === cookieName) return value;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return undefined;
}
function $2d1ea43de658d657$export$3fa7b7af96286cc9() {
    var global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        var cookies = global.document.cookie;
        var perimeter = $2d1ea43de658d657$var$getRawCookieValue((0, $gDKIc.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        var icDomain = $2d1ea43de658d657$var$getRawCookieValue((0, $gDKIc.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        var icId = $2d1ea43de658d657$var$getRawCookieValue((0, $gDKIc.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        var emptyIcDomain = !icDomain || icDomain.length === 0;
        var emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});


parcelRegister("5usR7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = module.exports.UnderAuditPhase = module.exports.BOUNDARY_KEYS_LIST = module.exports.getFeatureAvailabilityMetadataForBoundary = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

var $ePlFc = parcelRequire("ePlFc");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $ePlFc.isEnvironmentBlockEnabledForBoundary;
    }
});

var $ePlFc = parcelRequire("ePlFc");
Object.defineProperty(module.exports, "isFeatureEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $ePlFc.isFeatureEnabledForBoundary;
    }
});

var $ePlFc = parcelRequire("ePlFc");
Object.defineProperty(module.exports, "getFeatureAvailabilityMetadataForBoundary", {
    enumerable: true,
    get: function() {
        return $ePlFc.getFeatureAvailabilityMetadataForBoundary;
    }
});

var $fM9g9 = parcelRequire("fM9g9");
Object.defineProperty(module.exports, "BOUNDARY_KEYS_LIST", {
    enumerable: true,
    get: function() {
        return $fM9g9.BOUNDARY_KEYS_LIST;
    }
});
Object.defineProperty(module.exports, "UnderAuditPhase", {
    enumerable: true,
    get: function() {
        return $fM9g9.UnderAuditPhase;
    }
});
Object.defineProperty(module.exports, "COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $fM9g9.COMMERCIAL_KEY;
    }
});
Object.defineProperty(module.exports, "FED_MOD_KEY", {
    enumerable: true,
    get: function() {
        return $fM9g9.FED_MOD_KEY;
    }
});
Object.defineProperty(module.exports, "ISOLATED_CLOUD_COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $fM9g9.ISOLATED_CLOUD_COMMERCIAL_KEY;
    }
});

});
parcelRegister("ePlFc", function(module, exports) {
"use strict";
var $acb6a20cd20feb92$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getFeatureAvailabilityMetadataForBoundary = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

const $acb6a20cd20feb92$var$sdk_data_json_1 = $acb6a20cd20feb92$var$__importDefault((parcelRequire("2X8pS")));
const $acb6a20cd20feb92$var$aemEnvironmentBlockData = $acb6a20cd20feb92$var$sdk_data_json_1.default;
// Build reverse map: offeringId -> offeringShortKeyId, derived from compositionKeyMap (offeringShortKeyId -> offeringId)
const $acb6a20cd20feb92$var$offeringToOfferingShortKeyId = Object.fromEntries(Object.entries($acb6a20cd20feb92$var$aemEnvironmentBlockData.compositionKeyMap).map(([offeringShortKeyId, offeringId])=>[
        offeringId,
        offeringShortKeyId
    ]));
/**
 * Translates a full offering ID (BoundaryKey) to its short SDK key name.
 * Falls back to the original key if no mapping exists.
 */ function $acb6a20cd20feb92$var$toofferingShortKeyId(boundaryKey) {
    const mapped = $acb6a20cd20feb92$var$offeringToOfferingShortKeyId[boundaryKey];
    return mapped !== undefined && mapped !== null ? mapped : boundaryKey;
}
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @param boundaryKey The boundary to evaluate for.
 *
 * @returns if the environment block is available in the current cloud environment
 */ function $acb6a20cd20feb92$var$isEnvironmentBlockEnabledForBoundary(environmentBlockName, boundaryKey) {
    return $acb6a20cd20feb92$var$environmentBlockInBoundary(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabledForBoundary = $acb6a20cd20feb92$var$isEnvironmentBlockEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns if the feature is available in the current cloud environment
 */ function $acb6a20cd20feb92$var$isFeatureEnabledForBoundary(environmentBlockName, featureName, boundaryKey) {
    if ($acb6a20cd20feb92$var$environmentBlockInBoundary(environmentBlockName, boundaryKey)) {
        const environmentBlockData = $acb6a20cd20feb92$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
        const feature = environmentBlockData.features[featureName];
        if (!feature) return false;
        return feature.compositions[$acb6a20cd20feb92$var$toofferingShortKeyId(boundaryKey)] === true;
    }
    return false;
}
module.exports.isFeatureEnabledForBoundary = $acb6a20cd20feb92$var$isFeatureEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns the availability metadata for the feature in the given boundary, or undefined if none
 */ function $acb6a20cd20feb92$var$getFeatureAvailabilityMetadataForBoundary(environmentBlockName, featureName, boundaryKey) {
    const block = $acb6a20cd20feb92$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return undefined;
    const feature = block.features[featureName];
    if (!feature) return undefined;
    return feature.availabilityMetadata && feature.availabilityMetadata[$acb6a20cd20feb92$var$toofferingShortKeyId(boundaryKey)];
}
module.exports.getFeatureAvailabilityMetadataForBoundary = $acb6a20cd20feb92$var$getFeatureAvailabilityMetadataForBoundary;
function $acb6a20cd20feb92$var$environmentBlockInBoundary(environmentBlockName, boundaryKey) {
    const block = $acb6a20cd20feb92$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return false;
    return block.compositions[$acb6a20cd20feb92$var$toofferingShortKeyId(boundaryKey)] === true;
}

});
parcelRegister("2X8pS", function(module, exports) {
module.exports = JSON.parse("{\"compositionKeyMap\":{\"cc\":\"commercial-cloud\",\"ic\":\"isolated-cloud-commercial\",\"fm\":\"fedramp-moderate\"},\"environmentBlocks\":{\"adminhub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"adminhub-access-requests\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-beta-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-collections-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-discover-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-enterprise-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-add-app-standalone-apps-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-product\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-admin-insights\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-ai-enabled-apps\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-api-token-and-key-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-api-token-controls\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-app-requests\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-app-updates\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-application-tunnels\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-apps-discovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-atlassian-guard-standard\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-atlassian-intelligence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-audit-log\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-authentication-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-authentication-policies\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-automations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-backup-and-restore\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-billing-console\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-billing-preview\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-byok\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-cart\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-cmk-encryption\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-code-intelligence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-connected-emoji\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-connected-sources\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-connector-protection\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-contacts\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-custom-domain-email-notification\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-custom-domains\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-data-classifications\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-data-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-data-residency\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-data-security-policies\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-data-transfer\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-delta-migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-disaster-recovery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-discover-apps-shadow-it\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-discover-new-products\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-enable-user-merge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-encryption\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-environments\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-experiment-controls\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-external-user-security\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-footprint\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-freeze-windows\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-guard-detect-alerts\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-guard-detect-detections\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-help\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-hippa-compliance\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-jsm-scim\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-link-bitbucket\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-llm\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-login-customisation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-managed-accounts-export\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-marketplace-apps\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-mcp-settings\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-mobile-app-policy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-nested-side-navigation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-org-audit-logs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-org-create\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-org-deletion\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-org-transfer\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-performance-monitoring\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-platform-usage\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-policies\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-portfolio-insights\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-insights-workflow-discovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-insights\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-product-recommendation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-product-urls\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-release-tracks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-revamped-organization-overview\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-rovo-access\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-rovo-chat-protection\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-rovo-insights\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-rovo-mcp-server\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-rovo-settings\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-saml-sso\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-sandbox\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-searchbar\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-security-checklist\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-sensitive-data-policies\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-signup\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-site-rename\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-site-transfer\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-system-health\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-team-site-assignment\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-teams\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-teamwork-graph-cli\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-units\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-use-available-apps\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-user-access-invites\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-user-access-settings\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-user-connected-apps\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-user-counts\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-user-last-active-timestamp\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-workspaces-table-plans\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"core-adminhub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"assets\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"assets-data-manager-client-tools-distribution\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"assets-data-manager-ui\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"assets-data-manager\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"assets-recent-items\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"assets-reports\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"assets-rovo-search\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"core-assets\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-analytics\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"atlassian-analytics-3p-data-source-connections\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-chart-dashboard-pdf-png-exports\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-chart-templates\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-charts\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-comments\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-commerce-sentry\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-cross-product-interaction-client\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-dashboard-subscriptions\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-dashboard-templates\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-dashboards\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-data-lake-connections\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-data-shares\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-jira-align-enterprise-insights-connections\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"core-atlassian-analytics\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"bitbucket\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"bitbucket-development-events-and-status\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"bitbucket-merge-queue\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"bitbucket-slack-app\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"bitbucket-ssh-key-validation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"pipelines\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"chat\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"compass\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"confluence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"ccma\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"confluence-anonymous-access\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-canvas-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-canvas-relay\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-comment-and-header-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-company-hub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-content-archiving\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-content-manager\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-create-experience\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-databases\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"availabilityMetadata\":{\"fm\":{\"auditPhase\":\"external-audit\"}}},\"confluence-editing-experience\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-edition-awareness\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-editor-offline-storage\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-embedded-pages\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-employee-directory\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-forge-apps-sidebar\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-inline-comments-in-edit-mode\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-inspect-permissions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-invitations\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"confluence-legacy-collaborative-editor\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"confluence-legacy-ssr-frontend\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"confluence-loom-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-mission-control\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-mobile-app\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-monolith-isolated-cloud\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}},\"confluence-monolith\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"confluence-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-page-analytics\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-page-tree\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-pages-blogs-folders\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-premium-onboarding\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-presenter-mode\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-public-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-questions-native-experience\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-recap\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-remix\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-search\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-server\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-share-to-slack-button\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-single-space-guests\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-slack-integration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-slides\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-smart-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-space-analytics\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-team-calendars\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-update-page-owners\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-view-page\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-whiteboards\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"availabilityMetadata\":{\"fm\":{\"auditPhase\":\"external-audit\"}}},\"core-confluence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"moved-to-monolith-awaiting-deprecation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"customer-service-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"customer-service-management-ai-agent\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"dx\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"feedback\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"focus\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"asks-and-planning\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"goals\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"goals-townsquare-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"guard-premium\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"guard-premium-atlassian-guard-premium-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"guard-premium-full-site-security-scanning\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"home\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"basic-home-experience\":{\"compositions\":{\"cc\":false,\"ic\":false,\"fm\":true}},\"home-cross-app-create\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"home-dashboard-experience\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"home-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"home-ms-teams-and-slack-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"home-org-chart-analytics-pipeline\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"home-rerouting-services\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"home-status-backend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"home-where-you-work\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"jira\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-jira\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"issue-transition-customisation-for-srb\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jcma-x2c\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jcma\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-admin-oauth-credentials\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-ai-issue-classification\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-ai-planner\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-ai-snippet\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-ai-upsell-in-editor-free\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-apps-menu\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-atlassian-intelligence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-atlassian-vs-code-extension\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-audit-log\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-backlogs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-boards-and-views\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-calendar-view\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-company-managed-projects\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-components\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-dashboard-public-sharing\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-development-hub\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-development-tab-druid-metric-cards\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-development-tab-issue-centric-deployments\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-development-tab\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-devinfo-async-pull-request-icon\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-devops-toolchain\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-edition-awareness\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-figma-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-forms\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-github-for-jira\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"jira-github-workflows\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-global-issue-create-smart-fields\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-goals-nav\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-import-work-sidebar\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-in-product-help\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-individual-capacity-planning\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-insights\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-invite-people\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-issue\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-jinx-blue-green-jql-search\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-jpd-nav-recommendations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-jpd-roadmap-on-timeline-cross-sell\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-loom-banner\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-marketplace-sidebar-recommendations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-mobile-app\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-monolith-isolated-cloud\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}},\"jira-monolith\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-next-best-task\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-oasis-reports\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-opsgenie\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-planned-deprecated-jira-services\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-plans\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-project-archiving\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-project-issue-navigator\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-project-templates\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-project-theme-unsplash\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-project\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-quickstart-pages\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-releases\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-roadmap-in-nav\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-search-investigation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-share\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-site-optimiser\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-slack\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-smart-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-smart-related-issues\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-software-devops\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-software-reports-cycle-time\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-software-reports-deployment-frequency\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-spreadsheets-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-synced-blocks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-team-managed-projects\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-unsplash\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-whiteboards-backlog-experiment\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-work-item-archiving\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-work-suggestions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-workflow-configuration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-your-work-dashboard\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"modern-issue-transition-connect-app-fields\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"jira-align\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"jira-product-discovery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"jira-service-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"jira-service-management-help-center\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-ai-core-services\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-ai-ops\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-ai-services\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-alert-notifications\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-analytics-dashboards\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-approvals\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-assets-vertical\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-automation-playbook\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-canned-responses\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-case-management\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-change-ai-risk-assessment\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-change-calendar\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-change-management-deployment-vendors\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-change-management\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jsm-change-risk-assessment\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-change-risk-reporter-configuration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-chat-jira-event-integration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-chat-ops-ic-custom-apps\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}},\"jsm-chat-ops\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-chat-slack-and-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-chat\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-cloud-megatron\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-csat\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-csm-functionality\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-customer-access-internal-account\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-customer-account-directory\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-customer-notifications\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-customer-service-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-deployment-gating\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-deployment-tracking\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jsm-developer-escalations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-email-requests\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-embeddable-widget\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-entity-migration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-err-governance-api\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-accounts\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-single-sign-on\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-user-provisioning\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-forms\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-halp-admin-panel\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-help-center-change-password\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-help-center-password-login\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-help-center-rovo-agent\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center-virtual-agent\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-hr-employee-experience\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-incident-conference-calls\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-incident-management-integration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-issue\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-journey-builder\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-knowledge-base\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-lightweight-frontend\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-multi-language-support\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-on-call-schedule\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-ops-gatekeeper\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-ops-genie-reporting\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-opsgenie-conference-management\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-opsgenie-devops\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-portal-only-account-scim\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-post-incident-reviews\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-queues\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-related-issues\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jsm-reports-operations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-request-intake\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-services\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-shield\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-sla-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-status-page-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-support-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-surveys\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-templates-and-views\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-virtual-service-agent\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-workforce-management-and-smart-routing\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-workforce\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"opsgenie-automation-actions\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"opsgenie-bitbucket-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"opsgenie-internal-ops\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"opsgenie-onboarding\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"opsgenie-postmortem\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"opsgenie-url-shortener\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"opsgenie-web-apps\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"opsgenie\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"loom\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"loom-ai-evaluation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"projects\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"projects-townsquare-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"rovo\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"rovo-ai-app-availability\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-atlassian-intelligence-app-availability\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-generative-ai-editor\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-machine-learning\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-natural-language-in-automation-rule-creation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-projects\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-smart-features-based-on-machine-learning-tecton-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-editor-ai-panels\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"rovo-dev\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"rovo-dev-agents\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"statuspage\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"studio\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"talent\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"teams\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-teams\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"teams-directory-frontend\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"teams-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"teams-profile-media-token-fetch\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"teams-third-party-invites\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"unified-profile\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"user-provided-banners-on-profile-pictures\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"trello\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"trello-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"anti-abuse-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"anti-abuse-classification\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"core-anti-abuse-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"application-tunnels\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-application-tunnels\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"atlassian-cli\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{}},\"atlassian-new-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"atlassian-visualization-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"atlassian-analytics-chart-export\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-visualization-platform-kamino\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-manifold\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-monolith\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-rovo-skills\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"automation-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"admin-experience-connector\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-barrel-next-gen\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-barrel\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-network-and-key-management\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"automation-platform-actions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-platform-automation-templates\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-branches\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-platform-conditions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-platform-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-legacy\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"automation-platform-natural-language-rule-builder\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-rule-builder\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-sieve\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-templates\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-triggers\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-provisioner\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"core-automation-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"central-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"agentic-runtime-session-execution\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"ai-3p-connections\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"ai-3p-lifecycle\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"ai-3p-permissions\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"ai-managed-objects\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"ai-safety\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"alta\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"convo-ai-legacy\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"convo-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"gen-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"knowledge-ai-tecton\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"knowledge-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"knowledge-discovery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"machine-learning-platform-supporting-infrastructure\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"machine-learning-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-chat-send-message\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"cloud-to-data-center-connection-bridge\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"code-assist\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"collaboration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-collaboration-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"userbase-merge\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"commerce-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"commerce-platform-pls-changes-for-hams-cofs-in-boundary-deployment\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"commerce-platform-self-serve\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"core-commerce-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"customer-configuration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-customer-configuration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"orcs\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"org-policy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"customer-data-lake\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-customer-data-lake\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"druid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"link-paste-anonymization\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"plato-data-lake-proxy\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"plato-data-lake\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"socrates-demux\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"starrocks\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"customer-facing-observability\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"customer-support-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"aggregated-support-help\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"ecosystem-forge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-ecosystem-forge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"dac-get-help-widget\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"developer-atlassian-community\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"docs-atlassian-com\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"ecosystem-oauth\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"ecosystem-outbound-auth-flow\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"expression-playground\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"forge-ac-checker-fedramp\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-ac-checker\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"forge-app-client-events\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-apps-bff\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"forge-cli\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"forge-developer-console\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-entity-storage\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-object-store\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-remote-capabilities\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-runtime-logs-api\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-sql-storage\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"forge-storage-control-plane\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-storage-service-rockmelon\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"forge-system-apps\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-ui-ic-cdn-auth\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}}}},\"editor-collaboration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"block-service\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"core-editor-collaboration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"real-time-presence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"experience-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-experience-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"export-control-compliance\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"growth-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"auto-provisioning\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"bxp-signup\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"core-growth-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"cross-flow\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"feedback-collection\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"growth-content-generation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"growth-unified-profile\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"identity\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"authz-consistency-checker\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"core-identity\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"identity-cache\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"identity-core-post-m4\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"identity-deprecated-for-gcp-m5\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"identity-gsuite-bridge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"identity-microsoft-azure-ad-bridge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"identity-mobile-integrity\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"identity-userbase-merge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"identity-virality\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"suspicious-login-blocking\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"learning-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"marketplace\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"marketplace-amkt-fe-server\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"marketplace-app-discovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"marketplace-app-migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"marketplace-atlassian-labs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"marketplace-audit-logs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"marketplace-self-service-purchase-provision-install\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"agc-migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"commercial-cloud-to-agc\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"data-center-to-agc\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"migration-link-fixing\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"migrations-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"ai-powered-migration-intelligence\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"app-migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"brie\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"continuous-import-export-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"core-migrations-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"dare-app-migration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"data-center-to-cloud-migration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"file-migration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"lio-synthetic-consumer\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"media-migration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"migration-admin-ui\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"sandbox-promotion\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"monolith-key-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"navigation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-navigation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"navigation-home-entry-mode\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"navigation-identity-ic-routing\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}},\"navigation-switcher-discovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"navigation-switcher-rovo-scas-visibility\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"units-icons\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"notification-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-notification-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"notifications-fpn-link\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"post-office\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-post-office\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"identity-mail-proxy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"post-office-rml-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"product-integrations-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-product-integrations-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"external-user-directory-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"gitlab-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"google-workspace-apps-integrations\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"sign-in-with-slack-usage-analytics\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"product-license-enforcement-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-product-license-enforcement-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"reporting-lines\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-reporting-lines\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"search\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-search\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"search-identity-dare-isolated\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"search-identity-user-validator\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"search-townsquare-tab\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"user-search-indexing\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"xpsearch-forward-store\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"smartlinks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"atlassian-third-party-smartlinks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"core-smartlinks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"linking-platform-cdn\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"linking-platform-user-preferences\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"stakeholder-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"teamwork-graph-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"collaboration-graph\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"core-teamwork-graph-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"flock\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"usage-based-pricing-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"usage-tracking-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-usage-tracking-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"user-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-user-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"user-recommendations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-user-recommendations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-graphql-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-atlassian-graphql-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-platform-deployer\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"atlassian-proxy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-atlassian-proxy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-secure-sandbox-platform\":{\"compositions\":{\"cc\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"atlassian-workflow-platform-temporal\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"batched-data-replication-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-batched-data-replication-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"kamino-ingestion\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"kamino-portal\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"batched-data-replication-platform-infrastructure\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-batched-data-replication-platform-infrastructure\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"browser-remote-update-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"build-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"artifact-distribution\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"deployment-gating\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"deployments\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"kitt-source-control\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"racs-refapp-archetype\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"racs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"secrets\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"change-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"change-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"experimentation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"feature-flag\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"flag-distribution\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"cloud-governance-and-inventory\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"cdp-cell-provisioning\":{\"compositions\":{\"cc\":false,\"ic\":false,\"fm\":false}}}},\"cloud-telemetry\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"compliance-posture-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"configuration-distribution\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"config-registry\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"shipyard\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"consent-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"consenthub\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"core-network-automation-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"cdp-network\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"fedramp-network\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"isolated-cloud-network\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"core-network-automation-telemetry\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"cna-theia\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"cna-theid\":{\"compositions\":{\"cc\":false,\"ic\":false,\"fm\":false}}}},\"cross-boundary-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-cross-boundary-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"cpg-federal\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"data-policy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"icg-commercial\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"icg-ic\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}},\"isolated-cloud-network\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"customer-data-lake-infrastructure\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"data-access-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-access-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-center-diagnostics\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"data-depot-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-depot-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"data-depot-legacy-store\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-exchange-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"phoenix-tester\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"queuing-platform\":{\"compositions\":{\"cc\":false,\"ic\":false,\"fm\":false}},\"streamhub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"streaming-processing-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"streaming-proxy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"topic-osb\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"emperor-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-platform-services\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-platform-services\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"hydra\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"pii-mapper\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"data-telemetry-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-telemetry-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"postgres-telemetry-agent\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"telemetry-management\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"detection-and-response-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"disaster-recovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"region-failover-orchestration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"edge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-edge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"edge-cloudfront\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}},\"edge-diagnostics\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"edge-proxy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"edge-sliver-refapp-archetype\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"envoy-partitions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"encryption-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"cryptor-ref-client\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"cryptor\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"kms-proxy\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"environment-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"error-tracking-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"sentry-opsgenie-integration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"event-demux-and-routing-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-event-demux-and-routing-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"event-demux\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"flight-deck-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"gasv3\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"analytics-service\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"gasv3-tester\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"golden-ami\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"incident-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"rapid-investigation-framework\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"infrastructure\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-infrastructure\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"internal-data-lake\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"airlock-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"job-execution-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-job-execution-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"job-orchestration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-job-orchestration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"kitt-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"atlaskube\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"kitt-fleet-scoped\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"kitt-fleet-unscoped\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"kitt-fleet\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"logging-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"management-plane\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"media-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-media-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"media-cdn-delivery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"media-control-plane\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"messaging-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"metrics-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"micros-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"network-fabric\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-network-fabric\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"network-extension-routing\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"observability-visualization-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"opensearch\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"per-tenant-loop\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"performance-testing-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"provisioning\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"core-provisioning\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"public-backend-proxy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-public-backend-proxy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"rate-limiting-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-rate-limiting-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"heimdall-tester\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"hofund-platform-tester\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"relational-database-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"homa\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"postgresql\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"sql\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"release-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{}},\"release-tracks\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{}},\"resiliency-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"wiremock\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"security-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"service-authentication\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"identity-provider\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"key-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"poco\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"rollcall\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"slauth\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"service-mesh\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"sp-ref-kitt-consumer-archetype\":{\"compositions\":{\"cc\":false,\"ic\":false,\"fm\":false}},\"sp-ref-kitt-provider\":{\"compositions\":{\"cc\":false,\"ic\":false,\"fm\":false}}}},\"shard-and-cell-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"raptor-archetype\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"shard-lifecycle-service\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"slauth-auth-slack-notification-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"software-system-of-record-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"staff-directory\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"static-app-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"cookie-reference-app\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"ssr-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"static-app-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"statsig\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"atlassian-statsig-proxy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"targeting-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-targeting-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"tdp-control-plane\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"tdp-entity-relationship-store\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tdp-entity-relationship-store\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"tdp-object-store\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tdp-object-store\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"tdp-sky-bridge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-tdp-sky-bridge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"tenant-context\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tenant-context\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"tcs-ref-client\":{\"compositions\":{\"cc\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"tenant-lifecycle\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tenant-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"tenant-data-destroyer\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"tenant-passivation-removal\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"testing-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"polliwhirl\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"testing-platform-legacy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"tracing-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"vector-database\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"violation-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"volt-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"volt-platform-app\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"workplace-infra\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}}}}");

});


parcelRegister("fM9g9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnderAuditPhase = module.exports.BOUNDARY_KEYS_LIST = module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = void 0;
// Each BoundaryKey is a key in the sdk data
module.exports.COMMERCIAL_KEY = "commercial-cloud";
module.exports.FED_MOD_KEY = "fedramp-moderate";
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = "isolated-cloud-commercial";
module.exports.BOUNDARY_KEYS_LIST = [
    module.exports.COMMERCIAL_KEY,
    module.exports.FED_MOD_KEY,
    module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY
];
var $b7c28576a691a936$var$UnderAuditPhase;
(function(UnderAuditPhase) {
    UnderAuditPhase["INTERNAL_AUDIT"] = "internal-audit";
    UnderAuditPhase["EXTERNAL_AUDIT"] = "external-audit";
})($b7c28576a691a936$var$UnderAuditPhase || (module.exports.UnderAuditPhase = $b7c28576a691a936$var$UnderAuditPhase = {}));

});


parcelRegister("f7GDf", function(module, exports) {
"use strict";
/**
 * Manages feature overrides stored in browser localStorage.
 * No-ops when not in a browser context.
 *
 * localStorage key: "AEM_FEATURE_OVERRIDES"
 * localStorage value: JSON-encoded string mapping "{environmentBlockName}::{featureName}" to boolean
 *
 * Example:
 *   "AEM_FEATURE_OVERRIDES": "{\"confluence::my_feature\":true,\"jira::other_feature\":false}"
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearAllOverrides = module.exports.clearFeatureOverride = module.exports.overrideFeature = module.exports.getFeatureOverride = module.exports.STORAGE_KEY = void 0;
module.exports.STORAGE_KEY = "AEM_FEATURE_OVERRIDES";
function $b028944b6dce7676$var$buildKey(environmentBlockName, featureName) {
    return `${environmentBlockName}::${featureName}`;
}
function $b028944b6dce7676$var$isBrowserEnvironment() {
    return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}
function $b028944b6dce7676$var$getOverridesMap() {
    const featureOverrideValue = window.localStorage.getItem(module.exports.STORAGE_KEY);
    if (featureOverrideValue) try {
        return JSON.parse(featureOverrideValue);
    } catch (e) {
        console.warn("Failed to parse AEM_FEATURE_OVERRIDES from localStorage", e);
    }
    return {};
}
function $b028944b6dce7676$var$setOverridesMap(map) {
    window.localStorage.setItem(module.exports.STORAGE_KEY, JSON.stringify(map));
}
/**
 * Returns the override value for a feature if one exists, or null if no override is set.
 * Returns null in non-browser environments.
 */ function $b028944b6dce7676$var$getFeatureOverride(environmentBlockName, featureName) {
    if (!$b028944b6dce7676$var$isBrowserEnvironment()) return null;
    const map = $b028944b6dce7676$var$getOverridesMap();
    const key = $b028944b6dce7676$var$buildKey(environmentBlockName, featureName);
    if (key in map) return map[key];
    return null;
}
module.exports.getFeatureOverride = $b028944b6dce7676$var$getFeatureOverride;
/**
 * Sets a feature override in localStorage.
 */ function $b028944b6dce7676$var$overrideFeature(environmentBlockName, featureName, value) {
    if (!$b028944b6dce7676$var$isBrowserEnvironment()) return;
    const map = $b028944b6dce7676$var$getOverridesMap();
    map[$b028944b6dce7676$var$buildKey(environmentBlockName, featureName)] = value;
    $b028944b6dce7676$var$setOverridesMap(map);
}
module.exports.overrideFeature = $b028944b6dce7676$var$overrideFeature;
/**
 * Removes a single feature override from localStorage. Removes the key entirely if no overrides are left.
 */ function $b028944b6dce7676$var$clearFeatureOverride(environmentBlockName, featureName) {
    if (!$b028944b6dce7676$var$isBrowserEnvironment()) return;
    const map = $b028944b6dce7676$var$getOverridesMap();
    delete map[$b028944b6dce7676$var$buildKey(environmentBlockName, featureName)];
    if (Object.keys(map).length === 0) window.localStorage.removeItem(module.exports.STORAGE_KEY);
    else $b028944b6dce7676$var$setOverridesMap(map);
}
module.exports.clearFeatureOverride = $b028944b6dce7676$var$clearFeatureOverride;
/**
 * Clears all feature overrides from localStorage.
 */ function $b028944b6dce7676$var$clearAllOverrides() {
    if (!$b028944b6dce7676$var$isBrowserEnvironment()) return;
    window.localStorage.removeItem(module.exports.STORAGE_KEY);
}
module.exports.clearAllOverrides = $b028944b6dce7676$var$clearAllOverrides;

});

parcelRegister("4WG8s", function(module, exports) {

var $3ZMUU = parcelRequire("3ZMUU");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getEnvironmentType = module.exports.isSSR = void 0;
/** Returns true when running in a server-side rendering context (no browser window). */ function $399d43667833604d$var$isSSR() {
    return typeof window === "undefined" || typeof document === "undefined" || Boolean(typeof $3ZMUU !== "undefined" && $3ZMUU && $3ZMUU.env && undefined); // see https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/7377575ff0ec8a6f78257788b224e37c2bae8f66/platform/packages/editor/editor-common/src/core-utils/is-ssr.ts#lines-6
}
module.exports.isSSR = $399d43667833604d$var$isSSR;
/**
 * Returns the current environment type.
 * Defaults to "prod" in unknown cases.
 *
 * In SSR contexts, reads from globalThis.ssrContext.environmentType.
 * In browser contexts, infers from window.location.hostname.
 */ function $399d43667833604d$var$getEnvironmentType() {
    // 1. SSR: Use ssrContext if available
    if (typeof window === "undefined") {
        // @ts-expect-error — ssrContext in globalThis type
        const ssrContext = globalThis.ssrContext;
        if (ssrContext && ssrContext.environmentType) {
            const type = ssrContext.environmentType;
            if (type === "dev") return "non-prod";
            if (type === "staging") return "non-prod";
            if (type === "prod") return "prod";
        }
        return "prod";
    }
    // 2. Browser: Use hostname-based detection with all patterns
    const host = window.location.hostname.toLowerCase();
    if (!host) // default to prod if no location available
    return "prod";
    // Exact matches
    if (host === "localhost" || host === "127.0.0.1") return "non-prod";
    // Staging patterns
    if (host.endsWith(".jira-dev.com") || host.includes(".stg.") || host.includes(".staging.") || host.endsWith(".atlassian-stg-fedm.net") || host.endsWith(".atlassian-stg-fedm.com")) return "non-prod";
    // Development patterns
    if (host.includes(".dev.") || host.includes(".ddev.")) return "non-prod";
    if (host.endsWith(".atlassian.net") || host.endsWith(".atlassian-us-gov-mod.com") || host.endsWith(".atlassian.com")) return "prod";
    return "prod";
}
module.exports.getEnvironmentType = $399d43667833604d$var$getEnvironmentType;

});



parcelRegister("e67NL", function(module, exports) {
$parcel$export(module.exports, "isFedrampModerate", () => $a437ad7a6d378e3e$export$104cb891a6e90b3a);

var $8HSEG = parcelRequire("8HSEG");

var $1RGl6 = parcelRequire("1RGl6");
function $a437ad7a6d378e3e$export$104cb891a6e90b3a() {
    if (typeof document === 'undefined') {
        var _globalThis$ssrContex, _globalThis$ssrContex2;
        // @ts-ignore
        return (_globalThis$ssrContex = (_globalThis$ssrContex2 = globalThis.ssrContext) === null || _globalThis$ssrContex2 === void 0 ? void 0 : _globalThis$ssrContex2.isInFedramp) !== null && _globalThis$ssrContex !== void 0 ? _globalThis$ssrContex : false;
    }
    var atlCtxCookieValues = (0, $1RGl6.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $8HSEG.FEDRAMP_MODERATE);
}

});
parcelRegister("8HSEG", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $01a2c93ad6c282b5$export$ce553301d55c2fd8);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $01a2c93ad6c282b5$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $01a2c93ad6c282b5$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $01a2c93ad6c282b5$export$a0ffa0598c95dfb7);
var $01a2c93ad6c282b5$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $01a2c93ad6c282b5$export$f005e2e9f707cb5f = 'commercial';
var $01a2c93ad6c282b5$export$17b81a3d6c98013c = 'isolated-cloud';
var $01a2c93ad6c282b5$export$a739cd5aac835909 = 'staging';
var $01a2c93ad6c282b5$export$42dd0cdd351a4a9 = 'prod';
var $01a2c93ad6c282b5$export$404582bc18fe4d9e = 'dev';
var $01a2c93ad6c282b5$export$87285944378c596 = 'Atl-Ctx-Perimeter';
var $01a2c93ad6c282b5$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
var $01a2c93ad6c282b5$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
var $01a2c93ad6c282b5$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
var $01a2c93ad6c282b5$export$b61e047ddcc35726 = 'GCP';
var $01a2c93ad6c282b5$export$1baf17f3e645a2b2 = 'AWS';

});

parcelRegister("1RGl6", function(module, exports) {
$parcel$export(module.exports, "parseAtlCtxCookies", () => $15bb956a425ce96e$export$3fa7b7af96286cc9);

var $8HSEG = parcelRequire("8HSEG");

var $2rhdB = parcelRequire("2rhdB");
function $15bb956a425ce96e$export$3fa7b7af96286cc9() {
    var global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        var cookies = global.document.cookie;
        var perimeter = (0, $2rhdB.getRawCookieValue)((0, $8HSEG.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        var icDomain = (0, $2rhdB.getRawCookieValue)((0, $8HSEG.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        var icId = (0, $2rhdB.getRawCookieValue)((0, $8HSEG.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        var emptyIcDomain = !icDomain || icDomain.length === 0;
        var emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});
parcelRegister("2rhdB", function(module, exports) {
$parcel$export(module.exports, "getRawCookieValue", () => $1c6b75962a71756a$export$aa09aab30a92256c);

var $iYJcE = parcelRequire("iYJcE");
function $1c6b75962a71756a$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $1c6b75962a71756a$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $1c6b75962a71756a$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $1c6b75962a71756a$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1c6b75962a71756a$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $1c6b75962a71756a$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $1c6b75962a71756a$export$aa09aab30a92256c(cookieName, cookieString) {
    if (!cookieString) return undefined;
    var cookies = cookieString.split(';');
    var _iterator = $1c6b75962a71756a$var$_createForOfIteratorHelper(cookies), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var cookie = _step.value;
            var _cookie$trim$split = cookie.trim().split('='), _cookie$trim$split2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_cookie$trim$split, 2), name = _cookie$trim$split2[0], value = _cookie$trim$split2[1];
            if (name === cookieName) return value;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return undefined;
}

});



parcelRegister("gwTbL", function(module, exports) {
$parcel$export(module.exports, "default", () => $c08a71d1bea39f71$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $iMVPw = parcelRequire("iMVPw");
var $c08a71d1bea39f71$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
var $c08a71d1bea39f71$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function GlobalInteractionSessionTracking() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, GlobalInteractionSessionTracking);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(GlobalInteractionSessionTracking, null, [
        {
            key: "getInstance",
            value: function getInstance() {
                var interactionSessionTracking;
                try {
                    // Check if InteractionSessionTracking in global window object
                    if ($c08a71d1bea39f71$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$c08a71d1bea39f71$export$7bc189309d2ad463];
                    else {
                        // Initialise InteractionSessionTracking on global window object
                        window[$c08a71d1bea39f71$export$7bc189309d2ad463] = new (0, $iMVPw.default)();
                        interactionSessionTracking = window[$c08a71d1bea39f71$export$7bc189309d2ad463];
                    }
                } catch (error) {
                // Silently swallow exception
                }
                return interactionSessionTracking;
            }
        }
    ]);
}();

});
parcelRegister("iMVPw", function(module, exports) {
$parcel$export(module.exports, "default", () => $dad991887cadc559$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $iukH2 = parcelRequire("iukH2");
var $dad991887cadc559$var$INTERACTION_SESSION_ID_STORAGE_KEY = 'interactionSession.id';
var $dad991887cadc559$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY = 'interactionSession.id.prev';
var $dad991887cadc559$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY = 'interactionSession.expiry';
var $dad991887cadc559$export$285f6bddd927a06d = 1800000; // 30 minutes
var $dad991887cadc559$export$d050a4cab1b9f734 = 86400000; // 24 hours
var $dad991887cadc559$export$a92e915d70316eb2 = 5000; // 5 seconds
var $dad991887cadc559$export$de43760b2dc10c19 = 0.9; // 90% of expiry
var $dad991887cadc559$var$INTEGER_REGEX = /^\d+$/;
var $dad991887cadc559$export$5d4c4eab0863aae3 = 'interactionSessionIdUpdated';
/**
 * This class is essentially a wrapper around SessionStorage that introduces some failsafes (such as switching to InMemoryStorage if SessionStorage is not available)
 * and providing resilient methods for accessing and updating the interaction session ID.
 * This class can be initialised anywhere within a document, and `getCurrentInteractionSessionId` will always return the latest interaction session ID.
 *
 * The `setAnalyticsCallback` method must be called with a valid analytics event callback function provided by an Analytics Web Client before any other methods are used.
 * This is to ensure that any generated or renewed session IDs can be reported via an analytics event.
 *
 * The `setInteractionSessionId` method will write the SessionStorage with the persisted session ID, and is only intended to be used by the Analytics Web Client
 */ var $dad991887cadc559$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    // This callback function will be called whenever a new session ID is generated
    // It expects a function that sends an operational analytics event, with
    // the first parameter being set to the action ('started' or 'renewed'), and the second parameter being
    // an InteractionSession object containing the new session ID and previous session ID.
    function InteractionSessionTracking() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, InteractionSessionTracking);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "analyticsReady", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "generateNewSessionId", function() {
            if (!_this.analyticsReady) return null;
            var currentSessionId = _this.safeSessionStorage.getItem($dad991887cadc559$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            var newSessionId = Date.now().toString();
            _this.safeSessionStorage.setItem($dad991887cadc559$var$INTERACTION_SESSION_ID_STORAGE_KEY, newSessionId);
            var _this$getCurrentSessi = _this.getCurrentSessionParams(), isValidSession = _this$getCurrentSessi.isValidSession;
            if (!isValidSession) // If session is not valid at this point, something has gone wrong with Session Storage access
            // Calling sendInteractionSessionEvent now would result in an infinite loop, so we terminate
            return null;
            if (currentSessionId) {
                // Store a copy of the current session ID so we can link sessions if needed
                _this.safeSessionStorage.setItem($dad991887cadc559$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY, currentSessionId);
                _this.sendInteractionSessionEvent('renewed');
            } else _this.sendInteractionSessionEvent('started');
            // Event listener is in useCrossProductUrl.tsx to update URL query params
            document.dispatchEvent(new Event($dad991887cadc559$export$5d4c4eab0863aae3));
            return newSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "updateSessionExpiry", function() {
            var expiry = Date.now() + _this.sessionExpiryTime;
            _this.safeSessionStorage.setItem($dad991887cadc559$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "debouncedUpdateSessionExpiry", function(currentExpiry) {
            var updateSessionExpiry = _this.updateSessionExpiry;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + _this.sessionExpiryDebounceThresholdPercentage * _this.sessionExpiryTime) updateSessionExpiry();
            else {
                if (_this.sessionExpiryDebounceTimer) clearTimeout(_this.sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                _this.sessionExpiryDebounceTimer = setTimeout(function() {
                    updateSessionExpiry();
                }, _this.sessionExpiryDebounce);
            }
        });
        this.sessionExpiryTime = $dad991887cadc559$export$285f6bddd927a06d;
        this.sessionExpiryDebounce = $dad991887cadc559$export$a92e915d70316eb2;
        this.sessionExpiryDebounceThresholdPercentage = $dad991887cadc559$export$de43760b2dc10c19;
        this.safeSessionStorage = new (0, $iukH2.default)();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(InteractionSessionTracking, [
        {
            key: "getCurrentInteractionSessionId",
            value: function getCurrentInteractionSessionId() {
                try {
                    var _this$getCurrentSessi2 = this.getCurrentSessionParams(), isValidSession = _this$getCurrentSessi2.isValidSession, sessionExpiry = _this$getCurrentSessi2.sessionExpiry, sessionId = _this$getCurrentSessi2.sessionId;
                    // If we have an existing valid session we can return the sessionId straight away
                    if (isValidSession) {
                        this.debouncedUpdateSessionExpiry(sessionExpiry);
                        return sessionId;
                    }
                    // To generate a new session ID we must ensure analytics is ready
                    if (this.analyticsReady) {
                        // Session expiry update must occur before generateNewSessionId. Otherwise we were running
                        // into issues of calls attempting to read the session ID before a valid expiry had been set
                        this.debouncedUpdateSessionExpiry(sessionExpiry);
                        return this.generateNewSessionId();
                    }
                } catch (err) {
                // Silently swallow exception
                }
                return null;
            }
        },
        {
            key: "getPreviousInteractionSessionId",
            value: function getPreviousInteractionSessionId() {
                return this.safeSessionStorage.getItem($dad991887cadc559$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
            }
        },
        {
            key: "setInteractionSessionId",
            value: function setInteractionSessionId(persistedSessionId) {
                if (this.validateSessionId(persistedSessionId)) {
                    var currentSessionId = this.safeSessionStorage.getItem($dad991887cadc559$var$INTERACTION_SESSION_ID_STORAGE_KEY);
                    // If we are already on the required session ID, just return true and make no changes
                    // This can happen if the persisted session ID in options is the same as the current session ID
                    // We noticed this happening in some cases where Confluence's own URL redirect logic was causing
                    // race conditions with our URL stripping, resulting in the same query parameter being processed multiple times
                    if (currentSessionId === persistedSessionId) return false;
                    // Session expiry update must occur before we fire off the dispatchEvent. Otherwise we were running
                    // into issues of the event consumer attempting to read the session ID before a valid expiry had been set
                    this.debouncedUpdateSessionExpiry(0);
                    this.safeSessionStorage.setItem($dad991887cadc559$var$INTERACTION_SESSION_ID_STORAGE_KEY, persistedSessionId);
                    this.safeSessionStorage.removeItem($dad991887cadc559$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
                    document.dispatchEvent(new Event($dad991887cadc559$export$5d4c4eab0863aae3));
                    return true;
                }
                return false;
            }
        },
        {
            key: "setAnalyticsCallback",
            value: function setAnalyticsCallback(sendEventCallback) {
                if (this.analyticsReady) // If we already have a valid callback, don't over-write it
                return;
                if (sendEventCallback && typeof sendEventCallback === 'function') {
                    this.sendEventCallback = sendEventCallback;
                    this.analyticsReady = true;
                } else this.analyticsReady = false;
            }
        },
        {
            key: "validateSessionId",
            value: function validateSessionId(sessionId) {
                // Check if persisted session ID can parse as valid Unix timestamp
                if (sessionId && $dad991887cadc559$var$INTEGER_REGEX.test(sessionId)) {
                    var sessionAge = Date.now() - parseInt(sessionId, 10);
                    // Validate that timestamp is not a future time, and is also within the TTL
                    if (sessionAge >= 0 && sessionAge <= $dad991887cadc559$export$d050a4cab1b9f734) return true;
                }
                return false;
            }
        },
        {
            key: "getCurrentSessionParams",
            value: function getCurrentSessionParams() {
                var sessionId = this.safeSessionStorage.getItem($dad991887cadc559$var$INTERACTION_SESSION_ID_STORAGE_KEY);
                var sessionExpiry = parseInt(this.safeSessionStorage.getItem($dad991887cadc559$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
                if (sessionId && !Number.isNaN(sessionExpiry) && sessionExpiry > Date.now()) return {
                    isValidSession: true,
                    sessionExpiry: sessionExpiry,
                    sessionId: sessionId
                };
                return {
                    isValidSession: false,
                    sessionExpiry: sessionExpiry,
                    sessionId: sessionId
                };
            }
        },
        {
            key: "sendInteractionSessionEvent",
            value: function sendInteractionSessionEvent(action) {
                this.sendEventCallback && this.sendEventCallback({
                    action: action,
                    actionSubject: 'interactionSession',
                    source: 'interactionComponent',
                    tags: [
                        'navigationExperiences'
                    ] // InteractionSession events will be registered under this platform product
                });
            }
        }
    ]);
}();

});
parcelRegister("iukH2", function(module, exports) {
$parcel$export(module.exports, "default", () => $d75b148bb05fa448$export$2e2bcd8739ae039);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $1gLwd = parcelRequire("1gLwd");

var $3KMgh = parcelRequire("3KMgh");
function $d75b148bb05fa448$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $d75b148bb05fa448$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $d75b148bb05fa448$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d75b148bb05fa448$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
// eslint-disable-next-line import/no-anonymous-default-export
var $d75b148bb05fa448$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_SafeStorage) {
    function _default(options) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, _default);
        var storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = window.sessionStorage || (0, $1gLwd.default);
        } catch (err) {
            storageToUse = (0, $1gLwd.default);
        }
        return $d75b148bb05fa448$var$_callSuper(this, _default, [
            storageToUse,
            options
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(_default, _SafeStorage);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(_default);
}((0, $3KMgh.default));

});
parcelRegister("1gLwd", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ecc2545dba4bca4$export$2e2bcd8739ae039);

var $3erKm = parcelRequire("3erKm");
// eslint-disable-next-line import/no-anonymous-default-export
var $0ecc2545dba4bca4$var$inmemorystorage = new (0, $3erKm.InMemoryStore)();
var $0ecc2545dba4bca4$export$2e2bcd8739ae039 = $0ecc2545dba4bca4$var$inmemorystorage;

});
parcelRegister("3erKm", function(module, exports) {
$parcel$export(module.exports, "InMemoryStore", () => $25a833d2391d5233$export$90e3e001bcac59c7);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $25nEq = parcelRequire("25nEq");
var $25a833d2391d5233$export$90e3e001bcac59c7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(function InMemoryStore() {
    var _this = this;
    (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, InMemoryStore);
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "data", {});
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "length", 0);
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setItem", function(key, value) {
        _this.data[key] = value;
        _this.length = Object.keys(_this.data).length;
        return value;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getItem", function(key) {
        if (key in _this.data) return _this.data[key];
        return null;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "removeItem", function(key) {
        if (key in _this.data) delete _this.data[key];
        _this.length = Object.keys(_this.data).length;
        return null;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clear", function() {
        _this.data = {};
        _this.length = 0;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "key", function(index) {
        return Object.keys(_this.data)[index];
    });
});

});


parcelRegister("3KMgh", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bbb1abbaa4b4747$export$2e2bcd8739ae039);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $25nEq = parcelRequire("25nEq");

var $hqF8O = parcelRequire("hqF8O");

var $1gLwd = parcelRequire("1gLwd");

var $ekrwR = parcelRequire("ekrwR");
var $2bbb1abbaa4b4747$export$41c06fdd37b7e9a5 = 'awc';
var $2bbb1abbaa4b4747$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
var $2bbb1abbaa4b4747$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(function SafeStorage(storageToUse) {
    var _this = this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, SafeStorage);
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getStore", function() {
        return _this.store;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getItem", function(key) {
        return _this.store.getItem(_this.createKey(key));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "removeItem", function(key) {
        return _this.store.removeItem(_this.createKey(key));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setItem", function(key, value) {
        try {
            _this.store.setItem(_this.createKey(key), value);
        } catch (err) {
            // Theoretically should only be QuotaExceededError, but keeping 'err' generic
            // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
            _this.swapToInMemory();
            _this.store.setItem(_this.createKey(key), value);
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "swapToInMemory", function() {
        if (_this.store === (0, $1gLwd.default) || typeof window === 'undefined') return;
        var keys = Object.keys(_this.store || {});
        var inMemoryStorage;
        if ((0, $ekrwR.isSupported)(window[$2bbb1abbaa4b4747$export$770aa8bc07b3de03])) inMemoryStorage = window[$2bbb1abbaa4b4747$export$770aa8bc07b3de03];
        else {
            inMemoryStorage = (0, $1gLwd.default);
            if (!window[$2bbb1abbaa4b4747$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
            // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
            // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
            window[$2bbb1abbaa4b4747$export$770aa8bc07b3de03] = (0, $1gLwd.default);
        }
        keys.forEach(function(key) {
            if (key.indexOf(_this.getPrefix()) === 0) {
                var value = _this.store.getItem(key);
                if (value) inMemoryStorage.setItem(key, value);
            }
        });
        _this.store = inMemoryStorage;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clear", function() {
        return _this.store.clear();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "key", function(index) {
        return _this.store.key(index);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getPrefix", function() {
        return _this.prefix;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "createKey", function(key) {
        if (_this.prefix) return "".concat(_this.getPrefix(), ".").concat(key);
        return key;
    });
    this.options = options;
    var prefixes = [];
    if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($2bbb1abbaa4b4747$export$41c06fdd37b7e9a5);
    if (options.envPrefix && options.envPrefix !== (0, $hqF8O.envType).PROD) prefixes.push(options.envPrefix);
    this.prefix = prefixes.join('-');
    if ((0, $ekrwR.isSupported)(storageToUse)) this.store = storageToUse;
    else this.swapToInMemory();
});

});
parcelRegister("hqF8O", function(module, exports) {
$parcel$export(module.exports, "envType", () => $cb04c7282236de98$export$56ac8ebc9870b1b9);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ // This type has been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
var $cb04c7282236de98$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["DEV"] = "dev";
    envType["LOCAL"] = "local";
    envType["PROD"] = "prod";
    envType["STAGING"] = "staging";
    return envType;
}({});

});

parcelRegister("ekrwR", function(module, exports) {
$parcel$export(module.exports, "isSupported", () => $a6e849a1caf58321$export$48c17662a6902497);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ function $a6e849a1caf58321$export$48c17662a6902497(store) {
    var TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        var key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        var value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}

});






parcelRegister("hiAXT", function(module, exports) {
$parcel$export(module.exports, "URL_QUERY_PARAM_INTERACTION_SESSION", () => $c980ca96fe3c1be9$export$81d16f1428ce0486);
var $c980ca96fe3c1be9$export$81d16f1428ce0486 = 'xpis';
var $c980ca96fe3c1be9$export$2e3999ec51334ffe = function generateUrlWithParams(url, bridge, interactionSessionId, product, subProduct) {
    var interactionSource = subProduct ? "".concat(product, "-").concat(subProduct) : product;
    var interactionSession = {
        bridge: bridge,
        id: interactionSessionId,
        source: interactionSource
    };
    var paramValueEncoded = btoa(JSON.stringify(interactionSession));
    var partialUrl = false;
    var urlObj;
    // If relative URL provided, add localhost as placeholder base, to be stripped later
    try {
        urlObj = new URL(url);
    } catch (_unused) {
        urlObj = new URL(url, 'http://localhost/');
        partialUrl = true;
    }
    urlObj.searchParams.set($c980ca96fe3c1be9$export$81d16f1428ce0486, paramValueEncoded);
    if (partialUrl) return urlObj.pathname + urlObj.search;
    else return urlObj.toString();
};

});

parcelRegister("aWPob", function(module, exports) {
$parcel$export(module.exports, "validProducts", () => $7f872ef078f1fd45$export$b1e8b4360a046e61);
// Add products that will participate in cross-product interaction tracking here
// TODO: Down the line this should ideally be synced with ECS product list but that
// will take significant engineering effort
var $7f872ef078f1fd45$export$b1e8b4360a046e61 = [
    'jira',
    'confluence',
    'townsquare',
    'loom',
    'atlassianStudio',
    'bitbucket',
    'admin',
    'mercury',
    'talent',
    'trello',
    'analyticsVisualizationPlatform'
];

});

parcelRegister("2UUeH", function(module, exports) {
$parcel$export(module.exports, "default", () => $21fc6f103b6afda8$export$2e2bcd8739ae039);

var $3hnNg = parcelRequire("3hnNg");

var $74pGx = parcelRequire("74pGx");

var $8ZtlX = parcelRequire("8ZtlX");
var $21fc6f103b6afda8$var$urlParamExtractor = function urlParamExtractor(isCaptureParam) {
    var historyReplaceFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $74pGx.defaultHistoryReplaceFn);
    // Extract target parameters and values from URL if present
    var originalUrl = window.location.href;
    var fragmentHash = window.location.hash;
    var removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    var _parseUrl = (0, $3hnNg.parseUrl)(removedFragmentURL), url = _parseUrl.url, query = _parseUrl.query;
    var captureParams = (0, $8ZtlX.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        var queryWithoutCaptureParams = (0, $8ZtlX.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            var newUrl = "".concat(url, "?").concat((0, $3hnNg.stringify)(queryWithoutCaptureParams)).concat(fragmentHash);
            historyReplaceFn(newUrl);
        } else historyReplaceFn("".concat(url).concat(fragmentHash));
    }
    return captureParams;
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$21fc6f103b6afda8$export$2e2bcd8739ae039 = $21fc6f103b6afda8$var$urlParamExtractor;

});
parcelRegister("3hnNg", function(module, exports) {
$parcel$export(module.exports, "extract", () => $26356a878988d07a$export$f9380c9a627682d3, (v) => $26356a878988d07a$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $26356a878988d07a$export$98e6a39c04603d36, (v) => $26356a878988d07a$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $26356a878988d07a$export$fac44ee5b035f737, (v) => $26356a878988d07a$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $26356a878988d07a$export$7a5253c0f62e0150, (v) => $26356a878988d07a$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $26356a878988d07a$export$a8c1621ea79325d3, (v) => $26356a878988d07a$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $26356a878988d07a$export$357523c63a2253b9, (v) => $26356a878988d07a$export$357523c63a2253b9 = v);
var $26356a878988d07a$export$f9380c9a627682d3;
var $26356a878988d07a$export$98e6a39c04603d36;
var $26356a878988d07a$export$fac44ee5b035f737;
var $26356a878988d07a$export$7a5253c0f62e0150;
var $26356a878988d07a$export$a8c1621ea79325d3;
var $26356a878988d07a$export$357523c63a2253b9;
var $26356a878988d07a$export$44c361b8ec72ef7f;
'use strict';

var $6XEYK = parcelRequire("6XEYK");

var $9YPP7 = parcelRequire("9YPP7");

var $l4Qn0 = parcelRequire("l4Qn0");

var $9PyLY = parcelRequire("9PyLY");
const $26356a878988d07a$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $26356a878988d07a$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $26356a878988d07a$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $26356a878988d07a$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $26356a878988d07a$var$encode(key, options),
                            '[',
                            $26356a878988d07a$var$encode(index, options),
                            ']=',
                            $26356a878988d07a$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $26356a878988d07a$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $26356a878988d07a$var$encode(key, options),
                            '[]=',
                            $26356a878988d07a$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $26356a878988d07a$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $26356a878988d07a$var$encode(key, options),
                            ':list=',
                            $26356a878988d07a$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $26356a878988d07a$var$encode(key, options),
                                keyValueSep,
                                $26356a878988d07a$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $26356a878988d07a$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $26356a878988d07a$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $26356a878988d07a$var$encode(key, options),
                            '=',
                            $26356a878988d07a$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $26356a878988d07a$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $26356a878988d07a$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $26356a878988d07a$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$26356a878988d07a$var$decode(item, options)) : value === null ? value : $26356a878988d07a$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $26356a878988d07a$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$26356a878988d07a$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $26356a878988d07a$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $26356a878988d07a$var$encode(value, options) {
    if (options.encode) return options.strict ? $6XEYK(value) : encodeURIComponent(value);
    return value;
}
function $26356a878988d07a$var$decode(value, options) {
    if (options.decode) return $9YPP7(value);
    return value;
}
function $26356a878988d07a$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $26356a878988d07a$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $26356a878988d07a$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $26356a878988d07a$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $26356a878988d07a$var$extract(input) {
    input = $26356a878988d07a$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $26356a878988d07a$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $26356a878988d07a$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $26356a878988d07a$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $26356a878988d07a$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $l4Qn0(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $26356a878988d07a$var$decode(value, options);
        formatter($26356a878988d07a$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $26356a878988d07a$var$parseValue(value[k], options);
        else ret[key] = $26356a878988d07a$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $26356a878988d07a$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$26356a878988d07a$export$f9380c9a627682d3 = $26356a878988d07a$var$extract;
$26356a878988d07a$export$98e6a39c04603d36 = $26356a878988d07a$var$parse;
$26356a878988d07a$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $26356a878988d07a$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $26356a878988d07a$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $26356a878988d07a$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $26356a878988d07a$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $26356a878988d07a$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $26356a878988d07a$var$encode(key, options) + '=' + $26356a878988d07a$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$26356a878988d07a$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $l4Qn0(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $26356a878988d07a$var$parse($26356a878988d07a$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $26356a878988d07a$var$decode(hash, options)
    } : {});
};
$26356a878988d07a$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$26356a878988d07a$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $26356a878988d07a$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $26356a878988d07a$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $26356a878988d07a$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $26356a878988d07a$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $26356a878988d07a$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$26356a878988d07a$var$encodeFragmentIdentifier] ? $26356a878988d07a$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$26356a878988d07a$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$26356a878988d07a$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $26356a878988d07a$export$7a5253c0f62e0150(input, options);
    return $26356a878988d07a$export$a8c1621ea79325d3({
        url: url,
        query: $9PyLY(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$26356a878988d07a$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $26356a878988d07a$export$357523c63a2253b9(input, exclusionFilter, options);
};

});

parcelRegister("74pGx", function(module, exports) {
$parcel$export(module.exports, "defaultHistoryReplaceFn", () => $525cd4a927009906$export$600dd5bf1b049f11);
var $525cd4a927009906$export$600dd5bf1b049f11 = function defaultHistoryReplaceFn(newUrl) {
    return window.history.replaceState({}, '', newUrl);
};

});

parcelRegister("8ZtlX", function(module, exports) {
$parcel$export(module.exports, "mapKeys", () => $68baca26a6bab057$export$781522908e4e76a1);
$parcel$export(module.exports, "pick", () => $68baca26a6bab057$export$357523c63a2253b9);
$parcel$export(module.exports, "omitBy", () => $68baca26a6bab057$export$d7a617dda645b4e3);
$parcel$export(module.exports, "pickBy", () => $68baca26a6bab057$export$b460b275d6c6aa0);
$parcel$export(module.exports, "omit", () => $68baca26a6bab057$export$30a06c8d3562193f);
$parcel$export(module.exports, "equals", () => $68baca26a6bab057$export$e9bab7fafb253603);
$parcel$export(module.exports, "partition", () => $68baca26a6bab057$export$b29f828819edca8d);

var $ekGgq = parcelRequire("ekGgq");
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
var $68baca26a6bab057$export$781522908e4e76a1 = function mapKeys(obj, fn) {
    return Object.keys(obj).reduce(function(acc, k) {
        var key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
};
// https://www.30secondsofcode.org/js/s/pick
var $68baca26a6bab057$export$357523c63a2253b9 = function pick(obj, arr) {
    return arr.reduce(function(acc, curr) {
        return curr in obj && (acc[curr] = obj[curr]), acc;
    }, {});
};
// https://www.30secondsofcode.org/js/s/omit-by
var $68baca26a6bab057$export$d7a617dda645b4e3 = function omitBy(obj, fn) {
    return Object.keys(obj).filter(function(k) {
        return !fn(obj[k], k);
    }).reduce(function(acc, key) {
        return acc[key] = obj[key], acc;
    }, {});
};
// https://www.30secondsofcode.org/js/s/pick-by
var $68baca26a6bab057$export$b460b275d6c6aa0 = function pickBy(obj, fn) {
    return Object.keys(obj).filter(function(k) {
        return fn(obj[k], k);
    }).reduce(function(acc, key) {
        return acc[key] = obj[key], acc;
    }, {});
};
// https://www.30secondsofcode.org/js/s/omit
var $68baca26a6bab057$export$30a06c8d3562193f = function omit(obj, arr) {
    return Object.keys(obj).filter(function(k) {
        return arr.indexOf(k) < 0;
    }).reduce(function(acc, key) {
        return acc[key] = obj[key], acc;
    }, {});
};
// https://www.30secondsofcode.org/js/s/equals
var $68baca26a6bab057$export$e9bab7fafb253603 = function equals(a, b) {
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(a) !== 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(b) !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    var keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every(function(k) {
        return $68baca26a6bab057$export$e9bab7fafb253603(a[k], b[k]);
    });
};
// https://www.30secondsofcode.org/js/s/partition
var $68baca26a6bab057$export$b29f828819edca8d = function partition(arr, fn) {
    return arr.reduce(// eslint-disable-next-line no-shadow
    function(acc, val, i, arr) {
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);
};

});



parcelRegister("9hqdJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c1a0a725e9fc5bf$export$2e2bcd8739ae039);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $25nEq = parcelRequire("25nEq");

var $7Io7X = parcelRequire("7Io7X");

var $9BGWy = parcelRequire("9BGWy");

var $b4U7t = parcelRequire("b4U7t");
var $6c1a0a725e9fc5bf$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(function EventDelayCoordinator(fireDelayedEvent, compressors) {
    var _this = this;
    (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, EventDelayCoordinator);
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "push", function(identifier, builtEvent, context, userInfo) {
        _this.delayQueue.push(identifier, builtEvent, context, userInfo);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "startLowPriorityEventDelay", function() {
        var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $7Io7X.DEFAULT_DELAY_TIMEOUT);
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        if (Number.isNaN(timeout) || timeout <= 0) throw new Error("Invalid timeout period: ".concat(timeout, ", must be a number greater than 0"));
        if (_this.delayTimeout) clearTimeout(_this.delayTimeout);
        var delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $7Io7X.MAX_DELAY_TIMEOUT)) : (0, $7Io7X.MAX_DELAY_TIMEOUT);
        _this.delayCallback = callback;
        _this.delayTimeout = setTimeout(function() {
            return _this.stopLowPriorityEventDelay((0, $b4U7t.StopLowPriorityEventDelayReason).TIMEOUT);
        }, delayTimeoutPeriod);
        // If the queue is still flushing from a previous delay period, then we should cancel that flush
        // to stop it from negatively impacting the performance of the new critical section
        _this.delayQueue.cancelFlush();
        _this.isDelaying = true;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "stopLowPriorityEventDelay", function() {
        var _this$delayCallback;
        var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $b4U7t.StopLowPriorityEventDelayReason).MANUAL;
        if (_this.delayTimeout) {
            clearTimeout(_this.delayTimeout);
            _this.delayTimeout = undefined;
        }
        _this.delayQueue.startFlush();
        _this.isDelaying = false;
        (_this$delayCallback = _this.delayCallback) === null || _this$delayCallback === void 0 || _this$delayCallback.call(_this, reason);
        _this.delayCallback = undefined;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "isDelayingLowPriorityEvents", function() {
        return _this.isDelaying;
    });
    this.isDelaying = false;
    this.delayQueue = new (0, $9BGWy.default)(fireDelayedEvent, compressors);
});

});
parcelRegister("7Io7X", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_DELAY_TIMEOUT", () => $59df5babe6000c50$export$cf090d5281b5ae06);
$parcel$export(module.exports, "MAX_DELAY_TIMEOUT", () => $59df5babe6000c50$export$8575e30be0feb909);
var $59df5babe6000c50$export$cf090d5281b5ae06 = 10000;
var $59df5babe6000c50$export$8575e30be0feb909 = 30000;

});

parcelRegister("9BGWy", function(module, exports) {
$parcel$export(module.exports, "default", () => $6fe8e1689316f53e$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $25nEq = parcelRequire("25nEq");

var $478yZ = parcelRequire("478yZ");

var $8ZtlX = parcelRequire("8ZtlX");

var $7VElg = parcelRequire("7VElg");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
var $6fe8e1689316f53e$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
var $6fe8e1689316f53e$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
var $6fe8e1689316f53e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(function EventDelayQueue(processFn, compressionRules) {
    var _this = this;
    (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, EventDelayQueue);
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "push", function(identifier, builtEvent, context, userInfo) {
        _this.eventArgs.push({
            identifier: identifier,
            builtEvent: builtEvent,
            context: context,
            userInfo: userInfo
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "size", function() {
        return _this.eventArgs.length;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "startFlush", function() {
        try {
            _this.eventArgs = _this.compressEventArgs(_this.eventArgs);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn('Failed to perform compression on the delayed analytics events. ' + "Error: ".concat(e.message, ". Sending ").concat(_this.eventArgs.length, " uncompressed events instead"));
        }
        _this.flushNextBatch();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "cancelFlush", function() {
        if (_this.flushBatchTimeout) {
            clearTimeout(_this.flushBatchTimeout);
            _this.flushBatchTimeout = null;
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "flushNextBatch", function() {
        var batch = _this.eventArgs.splice(0, $6fe8e1689316f53e$var$FLUSH_BATCH_SIZE);
        batch.forEach(function(item) {
            return _this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo);
        });
        if (_this.eventArgs.length > 0) _this.flushBatchTimeout = setTimeout(function() {
            return _this.flushNextBatch();
        }, $6fe8e1689316f53e$var$FLUSH_BATCH_BACKOFF_PERIOD);
        else _this.flushBatchTimeout = null;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "compressEventArgs", function(eventArgs) {
        var _partition = (0, $8ZtlX.partition)(eventArgs, function(args) {
            return _this.compressor.canCompress(args.builtEvent);
        }), _partition2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_partition, 2), compressibleEventArgs = _partition2[0], incompressibleEventArgs = _partition2[1];
        // Events can only be compressed together if they share the same context and user info, since these are top-level
        // fields that need to exist on the fired event and can only be set to a single value.
        // We can achieve this by grouping our events by context prior to passing them to the compressor.
        var contextGroups = compressibleEventArgs.reduce(function(groups, args) {
            var matchingGroup = groups.find(function(group) {
                return (0, $8ZtlX.equals)(group.userInfo, args.userInfo) && (0, $8ZtlX.equals)(group.context, args.context);
            });
            if (matchingGroup) matchingGroup.eventArgs.push(args);
            else groups.push({
                userInfo: args.userInfo,
                context: args.context,
                eventArgs: [
                    args
                ]
            });
            return groups;
        }, []);
        // Run the compressor on each group
        var allCompressedEventArgs = contextGroups.reduce(function(acc, group) {
            try {
                var events = group.eventArgs.map(function(args) {
                    return args.builtEvent;
                });
                var compressedEvents = _this.compressor.compress(events);
                var compressedEventArgs = compressedEvents.map(function(compressedEvent) {
                    return {
                        identifier: (0, $478yZ.buildActionName)(compressedEvent),
                        builtEvent: compressedEvent,
                        userInfo: group.userInfo,
                        context: group.context
                    };
                });
                return acc.concat(compressedEventArgs);
            } catch (e) {
                // If anything goes wrong while compressing this group, then just fall back on the
                // uncompressed events instead. The event compressor already handles errors with invalid
                // generator functions or results, but this is an extra layer of defense to prevent data
                // loss in the event of an unexpected error.
                // eslint-disable-next-line no-console
                console.warn('Failed to compress some analytics events. ' + "Error: ".concat(e.message, ". Sending ").concat(group.eventArgs.length, " uncompressed events instead"));
                return group.eventArgs;
            }
        }, []);
        incompressibleEventArgs.forEach(function(args) {
            return allCompressedEventArgs.push(args);
        });
        return allCompressedEventArgs;
    });
    this.processFn = processFn;
    this.flushBatchTimeout = null;
    this.eventArgs = [];
    this.compressor = new (0, $7VElg.default)(compressionRules);
});

});
parcelRegister("7VElg", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c5d265bae4f52f8$export$2e2bcd8739ae039);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $25nEq = parcelRequire("25nEq");

var $3Bvfg = parcelRequire("3Bvfg");

var $8ZtlX = parcelRequire("8ZtlX");

var $aFMrF = parcelRequire("aFMrF");
function $5c5d265bae4f52f8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5c5d265bae4f52f8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5c5d265bae4f52f8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5c5d265bae4f52f8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5c5d265bae4f52f8$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(function EventCompressor() {
    var _this = this;
    var compressionRules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, EventCompressor);
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "canCompress", function(event) {
        return _this.compressionRules.some(function(compressionRule) {
            return compressionRule.canCompress(event);
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "compress", function(events) {
        var groups = _this.createGroups(events);
        return groups.reduce(function(allCompressedEvents, group) {
            var groupCompressedEvents = _this.compressGroup(group);
            return allCompressedEvents.concat(groupCompressedEvents);
        }, []);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "createGroups", function(events) {
        return(// Group events based on contextual fields. These fields are anything that is added by the client itself,
        // rather than passed in by the caller (eg. product, org. and tenant info)
        events.reduce(function(groups, event) {
            var matchingCompressor = _this.compressionRules.find(function(compressor) {
                return compressor.canCompress(event);
            });
            var contextFields;
            if (matchingCompressor) {
                var actionFields = (0, $3Bvfg.buildActionFields)(event, event.eventType);
                contextFields = (0, $8ZtlX.omit)(event, Object.keys(actionFields));
            }
            var matchingGroup = groups.find(function(group) {
                return matchingCompressor === group.compressor && (0, $8ZtlX.equals)(contextFields, group.contextFields);
            });
            if (matchingGroup) matchingGroup.events.push(event);
            else groups.push({
                contextFields: contextFields,
                compressor: matchingCompressor,
                events: [
                    event
                ]
            });
            return groups;
        }, []));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "compressGroup", function(group) {
        // If this group doesn't have any compressor, then the event args are already in their final format
        if (!group.compressor) return group.events;
        try {
            // Run the compressor on the group to generate some new events.
            // The compression function is only expected to return the action fields for each
            // event that it generates, since all other fields are generated by the client.
            var compressedEventActionFields = group.compressor.compress(group.events);
            // Add the context fields to each of the resulting events to inflate them into a full action event
            return compressedEventActionFields.map(function(actionFields) {
                return $5c5d265bae4f52f8$var$_objectSpread($5c5d265bae4f52f8$var$_objectSpread({}, actionFields), group.contextFields);
            });
        } catch (e) {
            // If we fail to compress the events, then just fall back the uncompressed events
            // so that no data is lost. This can happen if the compression function throws an error
            // or returns some invalid event payloads.
            // eslint-disable-next-line no-console
            // console.warn(
            // 	'Failed to compress some analytics events. ' +
            // 		`Error: ${(e as Error).message}. Sending ${
            // 			group.events.length
            // 		} uncompressed events instead`,
            // );
            return group.events;
        }
    });
    if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
    if (!compressionRules.every(function(rule) {
        return rule instanceof (0, $aFMrF.CompressionRule);
    })) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
    this.compressionRules = compressionRules;
});

});
parcelRegister("aFMrF", function(module, exports) {
$parcel$export(module.exports, "CompressionRule", () => $7c534fef00d87d47$export$89b3253ddfd2e6e8);

var $iYJcE = parcelRequire("iYJcE");

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $25nEq = parcelRequire("25nEq");

var $2vM2B = parcelRequire("2vM2B");

var $8ZtlX = parcelRequire("8ZtlX");

var $kCOHZ = parcelRequire("kCOHZ");

var $l6Ufe = parcelRequire("l6Ufe");
var $7c534fef00d87d47$export$89b3253ddfd2e6e8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(/**
 * @callback EventPredicate
 * @param {object} event An analytics event
 * @returns {boolean} A flag indicating whether or not the event matches the conditions
 */ /**
 * @callback CompressionFunction
 * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
 * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
 */ /**
 * This constructor defines a new rule for compressing analytics events.
 * @param {EventPredicate} predicate
 * @param {CompressionFunction} compressFn
 */ function CompressionRule(predicate, compressFn) {
    var _this = this;
    (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, CompressionRule);
    /**
   * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
   * @param event
   * @returns {boolean}
   */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "canCompress", function(event) {
        try {
            return event && (0, $2vM2B.isActionEventType)(event.eventType) && _this.predicate(event);
        } catch (e) {
            return false;
        }
    });
    /**
   * This function compresses as many events in the given collection as possible.<p>
   * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
   * appended to the end of the resulting array.
   *
   * @param events A collection of analytic events to compress
   * @returns {Array.<Object>} The action fields for the resulting compressed events
   */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "compress", function(events) {
        var _partition = (0, $8ZtlX.partition)(events, function(event) {
            return _this.canCompress(event);
        }), _partition2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_partition, 2), compatibleEvents = _partition2[0], incompatibleEvents = _partition2[1];
        var compressedEvents = _this.compressFn(compatibleEvents);
        if (!compressedEvents) throw new Error('No events were returned from the compression function');
        compressedEvents.forEach(function(event) {
            (0, $l6Ufe.validateActionEventType)(event.eventType);
            (0, $kCOHZ.validateActionEvent)(event);
        });
        return compressedEvents.concat(incompatibleEvents);
    });
    if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
    if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
    this.predicate = predicate;
    this.compressFn = compressFn;
});

});
parcelRegister("2vM2B", function(module, exports) {
$parcel$export(module.exports, "isActionEventType", () => $1d43bdf01dd62daa$export$d19cebda16f7579a);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $dpXUu = parcelRequire("dpXUu");
function $1d43bdf01dd62daa$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $dpXUu.eventType).OPERATIONAL:
        case (0, $dpXUu.eventType).TRACK:
        case (0, $dpXUu.eventType).UI:
            return true;
        default:
            return false;
    }
}

});

parcelRegister("kCOHZ", function(module, exports) {
$parcel$export(module.exports, "validateActionEvent", () => $f03eb0e423f5e21d$export$e0c121325c66ed4c);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $1F03j = parcelRequire("1F03j");
function $f03eb0e423f5e21d$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    (0, $1F03j.validateContainers)(event.containers);
}

});
parcelRegister("1F03j", function(module, exports) {
$parcel$export(module.exports, "validateContainers", () => $1359a92b5a227f93$export$e63ea5d8477971d3);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $3aElN = parcelRequire("3aElN");
function $1359a92b5a227f93$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach(function(container) {
        return (0, $3aElN.validateContainersObject)(container);
    });
}

});
parcelRegister("3aElN", function(module, exports) {
$parcel$export(module.exports, "validateContainersObject", () => $24f19b0fc028052f$export$df8ff30e3c960006);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $8OhNE = parcelRequire("8OhNE");
function $24f19b0fc028052f$export$df8ff30e3c960006(container) {
    if (!(0, $8OhNE.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}

});



parcelRegister("l6Ufe", function(module, exports) {
$parcel$export(module.exports, "validateActionEventType", () => $f5e5c98807f45d8d$export$4a8d7476662aebcc);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $dpXUu = parcelRequire("dpXUu");

var $2vM2B = parcelRequire("2vM2B");
var $f5e5c98807f45d8d$var$actionEventTypes = Object.freeze([
    (0, $dpXUu.eventType).OPERATIONAL,
    (0, $dpXUu.eventType).TRACK,
    (0, $dpXUu.eventType).UI
]);
function $f5e5c98807f45d8d$export$4a8d7476662aebcc(type) {
    if (!(0, $2vM2B.isActionEventType)(type)) throw new Error("Invalid action event type: ".concat(type, ", must be one of: [").concat($f5e5c98807f45d8d$var$actionEventTypes, "]"));
    return true;
}

});




parcelRegister("b4U7t", function(module, exports) {
$parcel$export(module.exports, "StopLowPriorityEventDelayReason", () => $810b9993bdaf216c$export$fa6e3729c21cb8f);
var $810b9993bdaf216c$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("9Do9V", function(module, exports) {
$parcel$export(module.exports, "default", () => $703a7f160fd6ee7a$export$2e2bcd8739ae039);

var $ekGgq = parcelRequire("ekGgq");

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $25nEq = parcelRequire("25nEq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $cmI9b = parcelRequire("cmI9b");

var $f4MJF = parcelRequire("f4MJF");

var $1Ygrk = parcelRequire("1Ygrk");

var $acFLR = parcelRequire("acFLR");

var $cHKVx = parcelRequire("cHKVx");

var $o1t1Z = parcelRequire("o1t1Z");

var $bJ6Ic = parcelRequire("bJ6Ic");

var $9vzfq = parcelRequire("9vzfq");

var $c8Y37 = parcelRequire("c8Y37");

var $HBXCt = parcelRequire("HBXCt");

var $hL0G3 = parcelRequire("hL0G3");

var $3I9pn = parcelRequire("3I9pn");

var $zYlx7 = parcelRequire("zYlx7");

var $amec4c = parcelRequire("amec4c");

var $5pjnf = parcelRequire("5pjnf");

var $lhwNW = parcelRequire("lhwNW");
function $703a7f160fd6ee7a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $703a7f160fd6ee7a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $703a7f160fd6ee7a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $703a7f160fd6ee7a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $703a7f160fd6ee7a$var$AnalyticsAPIResponse = /*#__PURE__*/ function() {
    function AnalyticsAPIResponse(success, validationErrors, message, code, validationReports) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsAPIResponse);
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsAPIResponse, [
        {
            key: "isSuccess",
            value: function isSuccess() {
                return this.success;
            }
        },
        {
            key: "getValidationErrors",
            value: function getValidationErrors() {
                return this.validationErrors;
            }
        },
        {
            key: "getMessage",
            value: function getMessage() {
                return this.message;
            }
        },
        {
            key: "getCode",
            value: function getCode() {
                return this.code;
            }
        },
        {
            key: "getValidationReports",
            value: function getValidationReports() {
                return this.validationReports === undefined ? null : this.validationReports;
            }
        }
    ]);
}();
var $703a7f160fd6ee7a$var$Message = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(function Message(error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Message);
    this.error = error;
});
var $703a7f160fd6ee7a$var$EventValidationReport = /*#__PURE__*/ function() {
    function EventValidationReport(messageId, results) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, EventValidationReport);
        this.messageId = messageId;
        this.results = results;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(EventValidationReport, [
        {
            key: "getMessageId",
            value: function getMessageId() {
                return this.messageId;
            }
        },
        {
            key: "getResults",
            value: function getResults() {
                return this.results;
            }
        }
    ]);
}();
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $703a7f160fd6ee7a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function EventProcessor(options) {
        var _this = this, _this$options;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, EventProcessor);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "originTracingClient", null);
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sendEvents", /*#__PURE__*/ function() {
            var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(items, callback) {
                var _this$lastSendEventsE, _this$metadataClient;
                var httpRetryCount, metricsPayload, eventsWithXID, sentAt, metadataInfo, _this$getEventUrl, _this$getEventUrl2, eventUrl, isFallbackUrl, metadata, unpackagedEvents, batchBody, _this$originTracingCl, _response, errorName, _this$getEventUrl3, _this$getEventUrl4, _, willUseFallbackUrl, _t;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!(_this.options.enableEventCalls === false)) {
                                _context.next = 1;
                                break;
                            }
                            return _context.abrupt("return");
                        case 1:
                            httpRetryCount = _this.resilienceQueue.getGlobalRetryCount();
                            metricsPayload = _this.metrics.getMetricsPayload();
                            _context.next = 2;
                            return _this.attachXIDs(items);
                        case 2:
                            eventsWithXID = _context.sent;
                            // Calculating sentAt after the XID generation as this may take some time.
                            sentAt = new Date().toISOString();
                            _context.next = 3;
                            return _this.metadataClient.getMetadataAsync();
                        case 3:
                            metadataInfo = _context.sent;
                            _this$getEventUrl = _this.getEventUrl(metadataInfo), _this$getEventUrl2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_this$getEventUrl, 2), eventUrl = _this$getEventUrl2[0], isFallbackUrl = _this$getEventUrl2[1];
                            metadata = $703a7f160fd6ee7a$var$_objectSpread($703a7f160fd6ee7a$var$_objectSpread({}, metricsPayload), {}, {
                                httpRetryCount: httpRetryCount,
                                lastSendEventsErrorReason: ((_this$lastSendEventsE = _this.lastSendEventsError) === null || _this$lastSendEventsE === void 0 ? void 0 : _this$lastSendEventsE.message) || null,
                                // Temporary back-compat
                                lastSendEventsError: _this.lastSendEventsError,
                                lastUrlFallbackError: _this.lastUrlFallbackError,
                                isUsingFallbackUrl: isFallbackUrl,
                                props: (metadataInfo === null || metadataInfo === void 0 ? void 0 : metadataInfo.props) || null,
                                metadataClientMetrics: ((_this$metadataClient = _this.metadataClient) === null || _this$metadataClient === void 0 ? void 0 : _this$metadataClient.metrics) || null
                            }); // Remove default values from metadata to save space
                            _this.cleanLibraryMetadata(metadata);
                            unpackagedEvents = eventsWithXID.map(function(item) {
                                _this.applyExclusions(item);
                                item.msg.sentAt = sentAt;
                                return item.msg;
                            });
                            batchBody = {
                                batch: unpackagedEvents,
                                sentAt: sentAt,
                                metadata: metadata
                            };
                            _context.prev = 4;
                            _context.next = 5;
                            return (0, $amec4c.sendEvents)({
                                url: eventUrl,
                                batch: batchBody,
                                timeout: _this.options.requestTimeout
                            });
                        case 5:
                            _response = _context.sent;
                            _this.lastSendEventsError = null;
                            _this.lastUrlFallbackError = null;
                            _this.metrics.subtractFromMetrics(metricsPayload);
                            callback(null, _response);
                            (_this$originTracingCl = _this.originTracingClient) === null || _this$originTracingCl === void 0 || _this$originTracingCl.cleanupOriginParameters(items);
                            _context.next = 6;
                            return _this.invokeLocalResponseCallbackAsync(items, _response, null);
                        case 6:
                            _context.next = 8;
                            break;
                        case 7:
                            _context.prev = 7;
                            _t = _context["catch"](4);
                            // If there's an error, other than one which indicates a temporary problem with the service,
                            // we'll stop using the URL from the metadata and fall back to the default URL. After a time
                            // we'll fall forward again in case the problem has been resolved.
                            if (_t instanceof (0, $c8Y37.FetchError) && [
                                429,
                                503
                            ].includes(_t.statusCode)) // Ignore 429 and 503 errors since they're considered to indicate a temporary
                            // issue with the service, rather than a network failure due to blocked requests.
                            _this.lastSendEventsError = new (0, $hL0G3.LastError)('ServerBusyError', _t);
                            else {
                                errorName = _t instanceof Error && (0, $5pjnf.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(_t.name) ? _t.name : 'Unknown';
                                _this.lastSendEventsError = new (0, $hL0G3.LastError)(errorName, _t);
                                // Handle falling back to the default URL if we're using the metadata URL.
                                _this.useUrlFromMetadata = false;
                                // If we're now using the fallback URL, and the last attempt wasn't,
                                // we'll record this as the error that triggered the fallback.
                                _this$getEventUrl3 = _this.getEventUrl(metadataInfo), _this$getEventUrl4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_this$getEventUrl3, 2), _ = _this$getEventUrl4[0], willUseFallbackUrl = _this$getEventUrl4[1];
                                if (willUseFallbackUrl && willUseFallbackUrl !== isFallbackUrl) _this.lastUrlFallbackError = _this.lastSendEventsError;
                            }
                            callback(_t, null);
                            _context.next = 8;
                            return _this.invokeLocalResponseCallbackAsync(items, null, _t);
                        case 8:
                        case "end":
                            return _context.stop();
                    }
                }, _callee, null, [
                    [
                        4,
                        7
                    ]
                ]);
            }));
            return function(_x, _x2) {
                return _ref.apply(this, arguments);
            };
        }());
        this.options = $703a7f160fd6ee7a$var$_objectSpread($703a7f160fd6ee7a$var$_objectSpread({}, options), {}, {
            requestTimeout: options.requestTimeout || (0, $bJ6Ic.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false,
            env: options.env,
            perimeter: options.perimeter || '',
            enableMetadataCalls: typeof options.enableMetadataCalls === 'boolean' ? options.enableMetadataCalls : true,
            enableEventCalls: typeof options.enableEventCalls === 'boolean' ? options.enableEventCalls : true
        });
        this.user = new (0, $lhwNW.default)((_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = "".concat(options.apiHostProtocol, "://").concat(options.apiHost, "/batch");
        this.metrics = (0, $f4MJF.default)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $cmI9b.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.metadataClient = options.metadataClient;
        this.useUrlFromMetadata = true;
        this.lastSendEventsError = null;
        this.lastUrlFallbackError = null;
        setInterval(function() {
            _this.useUrlFromMetadata = true;
        }, 600000);
        this.resilienceQueue.start(this.sendEvents);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(EventProcessor, [
        {
            key: "getUser",
            value: function getUser() {
                return this.user;
            }
        },
        {
            key: "track",
            value: function() {
                var _track = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(eventName, builtEvent, context, callback) {
                    var baseEvent, eventWithoutMessageId, event, packagedEvent;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                baseEvent = this.buildBaseEvent(context, (0, $5pjnf.SegmentEventTypes).TRACK, builtEvent);
                                eventWithoutMessageId = $703a7f160fd6ee7a$var$_objectSpread($703a7f160fd6ee7a$var$_objectSpread({}, baseEvent), {}, {
                                    type: (0, $5pjnf.SegmentEventTypes).TRACK,
                                    properties: (0, $zYlx7.prepareEventProperties)(builtEvent),
                                    event: eventName
                                });
                                event = $703a7f160fd6ee7a$var$_objectSpread($703a7f160fd6ee7a$var$_objectSpread({}, eventWithoutMessageId), {}, {
                                    messageId: this.createMessageId()
                                });
                                packagedEvent = this.packageEvent(event);
                                _context2.next = 1;
                                return this.enqueueEvent(packagedEvent);
                            case 1:
                                if (callback) callback();
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function track(_x3, _x4, _x5, _x6) {
                    return _track.apply(this, arguments);
                }
                return track;
            }()
        },
        {
            key: "page",
            value: function() {
                var _page = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(eventName, builtEvent, context, callback) {
                    var baseEvent, eventWithoutMessageId, event, packagedEvent;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                baseEvent = this.buildBaseEvent(context, (0, $5pjnf.SegmentEventTypes).PAGE, builtEvent);
                                eventWithoutMessageId = $703a7f160fd6ee7a$var$_objectSpread($703a7f160fd6ee7a$var$_objectSpread({}, baseEvent), {}, {
                                    type: (0, $5pjnf.SegmentEventTypes).PAGE,
                                    properties: (0, $zYlx7.prepareEventProperties)(builtEvent),
                                    name: eventName
                                });
                                event = $703a7f160fd6ee7a$var$_objectSpread($703a7f160fd6ee7a$var$_objectSpread({}, eventWithoutMessageId), {}, {
                                    messageId: this.createMessageId()
                                });
                                packagedEvent = this.packageEvent(event);
                                _context3.next = 1;
                                return this.enqueueEvent(packagedEvent);
                            case 1:
                                if (callback) callback();
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function page(_x7, _x8, _x9, _x0) {
                    return _page.apply(this, arguments);
                }
                return page;
            }() // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
        },
        {
            key: "identify",
            value: function() {
                var _identify = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(_identifier, builtEvent, context, callback) {
                    var baseEvent, eventWithoutMessageId, event, packagedEvent;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                baseEvent = this.buildBaseEvent(context, (0, $5pjnf.SegmentEventTypes).IDENTIFY, builtEvent);
                                eventWithoutMessageId = $703a7f160fd6ee7a$var$_objectSpread($703a7f160fd6ee7a$var$_objectSpread({}, baseEvent), {}, {
                                    type: (0, $5pjnf.SegmentEventTypes).IDENTIFY,
                                    traits: (0, $zYlx7.prepareEventProperties)(builtEvent)
                                });
                                event = $703a7f160fd6ee7a$var$_objectSpread($703a7f160fd6ee7a$var$_objectSpread({}, eventWithoutMessageId), {}, {
                                    messageId: this.createMessageId()
                                });
                                packagedEvent = this.packageEvent(event);
                                _context4.next = 1;
                                return this.enqueueEvent(packagedEvent);
                            case 1:
                                if (callback) callback();
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function identify(_x1, _x10, _x11, _x12) {
                    return _identify.apply(this, arguments);
                }
                return identify;
            }()
        },
        {
            key: "enqueueEvent",
            value: function() {
                var _enqueueEvent = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(packagedEvent) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                if (this.options.enableMetadataCalls) this.metadataClient.start(false); // Start the metadata client if needed
                                _context5.next = 1;
                                return this.resilienceQueue.addItem(packagedEvent);
                            case 1:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function enqueueEvent(_x13) {
                    return _enqueueEvent.apply(this, arguments);
                }
                return enqueueEvent;
            }()
        },
        {
            key: "buildBaseEvent",
            value: function buildBaseEvent(context, type, overrides) {
                var clonedContext = (0, $3I9pn.prepareEventContext)(context);
                var segmentContext = (0, $o1t1Z.buildContext)(clonedContext, overrides);
                return {
                    context: segmentContext,
                    timestamp: new Date().toISOString(),
                    type: type,
                    userId: this.user.getUserId(),
                    anonymousId: overrides.anonymousId || this.user.getAnonymousId()
                };
            }
        },
        {
            key: "createMessageId",
            value: function createMessageId() {
                return "ajs-".concat((0, $1Ygrk.default)());
            }
        },
        {
            key: "packageEvent",
            value: function packageEvent(event) {
                var _this$options2 = this.options, apiHost = _this$options2.apiHost, apiHostProtocol = _this$options2.apiHostProtocol;
                return {
                    headers: {
                        'Content-Type': 'text/plain'
                    },
                    msg: event,
                    url: "".concat(apiHostProtocol, "://").concat(apiHost, "/").concat(event.type.charAt(0))
                };
            }
        },
        {
            key: "applyExclusions",
            value: function applyExclusions(item) {
                var _msg$context;
                var msg = item.msg;
                var properties = msg.properties;
                var traits = msg.traits;
                var excluded = (_msg$context = msg.context) === null || _msg$context === void 0 ? void 0 : _msg$context.excludedProperties;
                if (!excluded) return;
                if (excluded.anonymousId === true) msg.anonymousId = undefined;
                if (excluded.interactionSession === true) {
                    if (properties) properties.interactionSession = undefined;
                }
                if (excluded.sessionId === true) {
                    if (properties) properties.sessionId = undefined;
                }
                if (excluded.pageLoadId === true) {
                    if (properties) properties.pageLoadId = undefined;
                }
                if (excluded.tabId === true) {
                    if (properties) properties.tabId = undefined;
                }
                if (excluded.taskSessions === true) {
                    if (properties) properties.taskSessions = undefined;
                }
                if (excluded.userId === true) {
                    msg.userId = undefined;
                    if (properties) properties.userIdType = undefined;
                }
                if (excluded.xid === true) {
                    if (properties) properties.xid = undefined;
                    if (traits) traits.xid = undefined;
                }
            }
        },
        {
            key: "getEventUrl",
            value: function getEventUrl(metadataInfo) {
                var preferredBatchUrl = metadataInfo !== null && metadataInfo !== void 0 && metadataInfo.url ? metadataInfo.url : this.gasv3BatchUrl;
                var finalBatchUrl = this.useUrlFromMetadata ? preferredBatchUrl : this.gasv3BatchUrl;
                var isFallbackUrl = preferredBatchUrl === this.gasv3BatchUrl ? null : finalBatchUrl !== preferredBatchUrl;
                return [
                    finalBatchUrl,
                    isFallbackUrl
                ];
            }
        },
        {
            key: "cleanLibraryMetadata",
            value: function cleanLibraryMetadata(obj) {
                var _this2 = this;
                // skip if the parameter is not an object
                if (obj === null || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(obj) !== 'object') return;
                for(var key in obj){
                    // Skip cleaning up props object and its keys
                    // to avoid having to check the existence of the fields in props object
                    // and manipulate them to calculate metadata signature in analytics service
                    if (key === 'props') continue;
                    var value = obj[key];
                    // Remove null or undefined values
                    if (value === null || value === undefined) delete obj[key];
                    else if (typeof value === 'number' && value === 0) delete obj[key];
                    else if (Array.isArray(value)) {
                        if (value.length === 0) delete obj[key];
                        else value.forEach(function(item) {
                            _this2.cleanLibraryMetadata(item);
                        });
                    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object') this.cleanLibraryMetadata(obj[key]);
                }
            }
        },
        {
            key: "invokeLocalResponseCallbackAsync",
            value: function() {
                var _invokeLocalResponseCallbackAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(items, response, error) {
                    var localResponseCallback, analyticsAPIResponse, _responseObject$messa, responseObject, analyticsResponse, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                localResponseCallback = this.responseCallback;
                                if (!localResponseCallback) {
                                    _context6.next = 6;
                                    break;
                                }
                                // If we have a response, we'll parse it and create an AnalyticsAPIResponse from it.
                                analyticsAPIResponse = null;
                                if (!response) {
                                    _context6.next = 5;
                                    break;
                                }
                                _context6.prev = 1;
                                _context6.next = 2;
                                return response.clone().json();
                            case 2:
                                responseObject = _context6.sent;
                                _context6.next = 4;
                                break;
                            case 3:
                                _context6.prev = 3;
                                _t2 = _context6["catch"](1);
                            case 4:
                                // Ensure we've got a valid object to work with, filling in any missing
                                // properties as best we can.
                                responseObject = responseObject || {};
                                responseObject.code = Number.parseInt(responseObject.code) > 0 ? Number.parseInt(responseObject.code) : response.status;
                                responseObject.success = responseObject.success || responseObject.code >= 200 && responseObject.code <= 299;
                                analyticsAPIResponse = new $703a7f160fd6ee7a$var$AnalyticsAPIResponse(responseObject.success, responseObject.validationErrors || new Map(), new $703a7f160fd6ee7a$var$Message(((_responseObject$messa = responseObject.message) === null || _responseObject$messa === void 0 ? void 0 : _responseObject$messa.error) || ''), responseObject.code, responseObject.validationReports || null);
                            case 5:
                                // If we have an error, but it's not an instance of Error (e.g. it's a string), we'll convert it to an Error object.
                                if (error && !(error instanceof Error)) error = new Error(String(error));
                                analyticsResponse = $703a7f160fd6ee7a$var$BatchInterceptor.toAnalyticsResponse(items || [], error || null, // In case 'error' were to be undefined we'll convert it to null.
                                analyticsAPIResponse);
                                localResponseCallback(analyticsResponse);
                            case 6:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function invokeLocalResponseCallbackAsync(_x14, _x15, _x16) {
                    return _invokeLocalResponseCallbackAsync.apply(this, arguments);
                }
                return invokeLocalResponseCallbackAsync;
            }()
        },
        {
            key: "attachXIDs",
            value: function() {
                var _attachXIDs = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7(items) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (!this.xidPromiseCallback) {
                                    _context7.next = 1;
                                    break;
                                }
                                return _context7.abrupt("return", (0, $acFLR.attachXidToMultipleEvents)(items, this.xidPromiseCallback));
                            case 1:
                                return _context7.abrupt("return", Promise.resolve(items));
                            case 2:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function attachXIDs(_x17) {
                    return _attachXIDs.apply(this, arguments);
                }
                return attachXIDs;
            }()
        },
        {
            key: "setOriginTracingClient",
            value: function setOriginTracingClient(client) {
                this.originTracingClient = client;
            }
        },
        {
            key: "setResponseCallback",
            value: function setResponseCallback(responseCallback) {
                this.responseCallback = responseCallback;
            }
        },
        {
            key: "refreshMetadata",
            value: function refreshMetadata(userInfo, tenantInfo) {
                this.metadataClient.userInfo = userInfo;
                this.metadataClient.tenantInfo = tenantInfo;
            }
        }
    ]);
}();
var $703a7f160fd6ee7a$var$BatchInterceptor = /*#__PURE__*/ function() {
    function BatchInterceptor() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, BatchInterceptor);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(BatchInterceptor, null, [
        {
            key: "toAnalyticsResponse",
            value: function toAnalyticsResponse(items, error, analyticsAPIResponse) {
                var eventResponseList = [];
                if (analyticsAPIResponse !== null) {
                    var _ref2 = [
                        analyticsAPIResponse.code,
                        analyticsAPIResponse.success
                    ], statusCode = _ref2[0], success = _ref2[1];
                    if (statusCode >= 200 && statusCode <= 299) {
                        var _analyticsAPIResponse;
                        (_analyticsAPIResponse = analyticsAPIResponse.validationReports) === null || _analyticsAPIResponse === void 0 || _analyticsAPIResponse.forEach(function(report) {
                            var matchedEvent = items.find(function(item) {
                                return item.msg.messageId === report.messageId;
                            });
                            if (matchedEvent) eventResponseList.push(new (0, $9vzfq.EventResponse)(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                        });
                        return new (0, $cHKVx.AnalyticsResponse)(success, statusCode, (0, $HBXCt.HTTP_STATUS_CODE_MAP).get(statusCode), eventResponseList);
                    } else if (statusCode >= 400 && statusCode <= 499) {
                        var _analyticsAPIResponse2;
                        // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                        var errorMessage = ((_analyticsAPIResponse2 = analyticsAPIResponse.message) === null || _analyticsAPIResponse2 === void 0 ? void 0 : _analyticsAPIResponse2.error) !== null ? analyticsAPIResponse.message.error : (0, $HBXCt.HTTP_STATUS_CODE_MAP).has(statusCode) ? (0, $HBXCt.HTTP_STATUS_CODE_MAP).get(statusCode) : (0, $HBXCt.HTTP_STATUS_CODE_MAP).get(-1);
                        items.forEach(function(item) {
                            eventResponseList.push(new (0, $9vzfq.EventResponse)(item.msg.messageId, [], item.msg));
                        });
                        return new (0, $cHKVx.AnalyticsResponse)(success, statusCode, errorMessage, eventResponseList);
                    }
                } else if (error !== null && error !== void 0 && error.message) {
                    var match = error.message.match(BatchInterceptor.http_error_regex);
                    if (match) {
                        items.forEach(function(item) {
                            eventResponseList.push(new (0, $9vzfq.EventResponse)(item.msg.messageId, [], item.msg));
                        });
                        return new (0, $cHKVx.AnalyticsResponse)(false, Number(match[1]), match[2], eventResponseList);
                    }
                }
                items.forEach(function(item) {
                    eventResponseList.push(new (0, $9vzfq.EventResponse)(item.msg.messageId, [], item.msg));
                });
                return new (0, $cHKVx.AnalyticsResponse)(false, -1, (0, $HBXCt.HTTP_STATUS_CODE_MAP).get(-1), eventResponseList);
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($703a7f160fd6ee7a$var$BatchInterceptor, "http_error_regex", /HTTP Error\s([0-9]{3})\s\((.+)\)/);

});
parcelRegister("cmI9b", function(module, exports) {
$parcel$export(module.exports, "default", () => $9009c8d029fe1a5f$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $3zQGx = parcelRequire("3zQGx");

var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$9009c8d029fe1a5f$export$2e2bcd8739ae039 = function(retryQueuePrefix, product, options, logger) {
    return new (0, $3zQGx.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("3zQGx", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_POLLING_OPTIONS", () => $29ad82233d2d80ba$export$d219df4fe04c04a7);
$parcel$export(module.exports, "default", () => $29ad82233d2d80ba$export$2e2bcd8739ae039);

var $fL8KA = parcelRequire("fL8KA");

var $25nEq = parcelRequire("25nEq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $g0txv = parcelRequire("g0txv");

var $b6FTZ = parcelRequire("b6FTZ");

var $aB9ZI = parcelRequire("aB9ZI");

var $4r6Zx = parcelRequire("4r6Zx");

var $ldMum = parcelRequire("ldMum");

var $f4MJF = parcelRequire("f4MJF");

var $2SiT1 = parcelRequire("2SiT1");

var $cx5q7 = parcelRequire("cx5q7");

var $3efd3 = parcelRequire("3efd3");

var $9GE8Y = parcelRequire("9GE8Y");
function $29ad82233d2d80ba$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $29ad82233d2d80ba$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $29ad82233d2d80ba$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $29ad82233d2d80ba$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $29ad82233d2d80ba$var$ONE_MINUTE = 60000;
var $29ad82233d2d80ba$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $29ad82233d2d80ba$var$ONE_MINUTE,
    minRetryDelay: $29ad82233d2d80ba$var$ONE_MINUTE,
    maxRetryDelay: $29ad82233d2d80ba$var$ONE_MINUTE
};
var $29ad82233d2d80ba$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // The maximum number of events that can be stored in the resilience queue (IndexedDB/memory).
    // This limit is per product and is enforced by the EventCountGuard in the resilience layer.
    maxQueueSize: 8000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $29ad82233d2d80ba$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PullBatchableQueue(queuePrefix, product, options, logger) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PullBatchableQueue);
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $aB9ZI.default)(product, {
            logger: logger,
            maxAttempts: options === null || options === void 0 ? void 0 : options.maxAttempts,
            maxEventLimit: (options === null || options === void 0 ? void 0 : options.maxQueueSize) || $29ad82233d2d80ba$export$d219df4fe04c04a7.maxQueueSize
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $cx5q7.default)($29ad82233d2d80ba$var$_objectSpread($29ad82233d2d80ba$var$_objectSpread({}, this.options), {}, {
            waitInterval: options !== null && options !== void 0 && options.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }), this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $cx5q7.default)($29ad82233d2d80ba$var$_objectSpread($29ad82233d2d80ba$var$_objectSpread({}, $29ad82233d2d80ba$var$LONG_POLLING_OPTIONS), {}, {
            waitInterval: $29ad82233d2d80ba$var$LONG_POLLING_OPTIONS.flushWaitMs
        }), this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $f4MJF.default)();
        this.networkStatus = new (0, $2SiT1.default)(function(status) {
            if (status === (0, $9GE8Y.NetworkStatusEnum).OFFLINE) _this.scheduler.stop();
            else _this.checkEventCountAndReschedule();
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PullBatchableQueue, [
        {
            key: "start",
            value: function start(flushCallback) {
                this.batchFlushCallback = flushCallback;
                this.longPollingScheduler.schedule();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.scheduler.stop();
                this.longPollingScheduler.stop();
            }
        },
        {
            key: "addItem",
            value: function() {
                var _addItem = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(item) {
                    var jsonStringifiedAndParsedItem, _yield$this$resilienc, numberOfEvictedItems;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                // Since Jira and Confluence use `.toJSON` on objects that should be strings
                                // And expect us to use `JSON.stringify` on these objects,
                                // And indexeddb strips these functions from the objects when adding them to the DB,
                                // We must run this silly stringify and parse before passing the event to the resilience meechanism.
                                // Planning on removing this in v4
                                jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
                                _context.next = 1;
                                return this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $4r6Zx.GuardPolicy).EVICT);
                            case 1:
                                _yield$this$resilienc = _context.sent;
                                numberOfEvictedItems = _yield$this$resilienc.numberOfEvictedItems;
                                this.scheduler.schedule();
                                this.metricsCollector.addToEventCount();
                                if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function addItem(_x) {
                    return _addItem.apply(this, arguments);
                }
                return addItem;
            }()
        },
        {
            key: "getGlobalRetryCount",
            value: function getGlobalRetryCount() {
                return this.scheduler.getFailureCount();
            }
        },
        {
            key: "scheduleCallback",
            value: function() {
                var _scheduleCallback = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(done) {
                    var result, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                if (!(this.networkStatus.getNetworkStatus() === (0, $9GE8Y.NetworkStatusEnum).OFFLINE)) {
                                    _context2.next = 1;
                                    break;
                                }
                                done((0, $3efd3.DoneState).NOOP);
                                return _context2.abrupt("return");
                            case 1:
                                _context2.prev = 1;
                                _context2.next = 2;
                                return this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
                            case 2:
                                result = _context2.sent;
                                done(result);
                                _context2.next = 4;
                                break;
                            case 3:
                                _context2.prev = 3;
                                _t = _context2["catch"](1);
                                if (!(_t.name === (0, $ldMum.CallbackProcessingErrorName))) {
                                    _context2.next = 4;
                                    break;
                                }
                                done((0, $3efd3.DoneState).ERROR);
                                return _context2.abrupt("return");
                            case 4:
                                _context2.prev = 4;
                                _context2.next = 5;
                                return this.checkEventCountAndReschedule();
                            case 5:
                                return _context2.finish(4);
                            case 6:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            3,
                            4,
                            6
                        ]
                    ]);
                }));
                function scheduleCallback(_x2) {
                    return _scheduleCallback.apply(this, arguments);
                }
                return scheduleCallback;
            }()
        },
        {
            key: "checkEventCountAndReschedule",
            value: function() {
                var _checkEventCountAndReschedule = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3() {
                    var eventWaitingCount;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                _context3.next = 1;
                                return this.resilience.getItemCount();
                            case 1:
                                eventWaitingCount = _context3.sent;
                                if (eventWaitingCount > 0) this.scheduler.schedule({
                                    immediate: eventWaitingCount >= this.options.batchFlushSize
                                });
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function checkEventCountAndReschedule() {
                    return _checkEventCountAndReschedule.apply(this, arguments);
                }
                return checkEventCountAndReschedule;
            }()
        },
        {
            key: "scheduleLongCallBack",
            value: function() {
                var _scheduleLongCallBack = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(done) {
                    var _this2 = this;
                    var numberOfQueuesPurged, reclaimMetrics;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                // Eventually we will want to send data about how many queues were purged
                                numberOfQueuesPurged = (0, $g0txv.default)(this.queuePrefix);
                                this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
                                // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
                                _context5.next = 1;
                                return (0, $b6FTZ.default)(this.queuePrefix, /*#__PURE__*/ function() {
                                    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(localStorageItems) {
                                        var itemsToAdd, _yield$_this2$resilie, addedEvents;
                                        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                                            while(true)switch(_context4.prev = _context4.next){
                                                case 0:
                                                    itemsToAdd = localStorageItems.map(function(localStorageItem) {
                                                        return {
                                                            item: localStorageItem.item,
                                                            retryAttempts: localStorageItem.attemptNumber,
                                                            id: localStorageItem.id
                                                        };
                                                    });
                                                    _context4.next = 1;
                                                    return _this2.resilience.bulkAddItem(itemsToAdd, (0, $4r6Zx.GuardPolicy).IGNORE);
                                                case 1:
                                                    _yield$_this2$resilie = _context4.sent;
                                                    addedEvents = _yield$_this2$resilie.items;
                                                    if (!(addedEvents.length === itemsToAdd.length)) {
                                                        _context4.next = 2;
                                                        break;
                                                    }
                                                    return _context4.abrupt("return", {
                                                        status: 'successful'
                                                    });
                                                case 2:
                                                    return _context4.abrupt("return", {
                                                        status: 'partial',
                                                        acceptedItemIds: addedEvents.map(function(event) {
                                                            return event.id;
                                                        })
                                                    });
                                                case 3:
                                                case "end":
                                                    return _context4.stop();
                                            }
                                        }, _callee4);
                                    }));
                                    return function(_x4) {
                                        return _ref.apply(this, arguments);
                                    };
                                }());
                            case 1:
                                reclaimMetrics = _context5.sent;
                                this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
                                // We dont want to flush events from here as there maybe issues with analytics-service
                                // Scheduler has all the context and can schedule the next batch accordingly
                                _context5.next = 2;
                                return this.checkEventCountAndReschedule();
                            case 2:
                                done((0, $3efd3.DoneState).SUCCESS);
                                this.longPollingScheduler.schedule();
                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function scheduleLongCallBack(_x3) {
                    return _scheduleLongCallBack.apply(this, arguments);
                }
                return scheduleLongCallBack;
            }()
        },
        {
            key: "flush",
            value: function flush(wrappedItems, otherMetadata) {
                var _this3 = this;
                this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
                var batchFlushCallback = this.batchFlushCallback;
                if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
                return new Promise(function(resolve, reject) {
                    if (wrappedItems.length <= 0) {
                        resolve((0, $3efd3.DoneState).NOOP);
                        return;
                    }
                    var items = wrappedItems.map(function(wrappedItem) {
                        var item = wrappedItem.item;
                        if (wrappedItem.retryAttempts > 0 && item.msg) {
                            if (!item.msg._metadata) item.msg._metadata = {};
                            item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                        }
                        return item;
                    });
                    batchFlushCallback(items, function(error) {
                        if (error) {
                            if (otherMetadata.numberOfDeletedItems > 0) _this3.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                            reject(error);
                        } else resolve((0, $3efd3.DoneState).SUCCESS);
                    });
                });
            }
        },
        {
            key: "buildOptions",
            value: function buildOptions(options) {
                return {
                    backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || $29ad82233d2d80ba$export$d219df4fe04c04a7.backoffFactor,
                    backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : $29ad82233d2d80ba$export$d219df4fe04c04a7.backoffJitterPercentage,
                    batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || $29ad82233d2d80ba$export$d219df4fe04c04a7.batchFlushSize,
                    flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || $29ad82233d2d80ba$export$d219df4fe04c04a7.flushBeforeUnload,
                    flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || $29ad82233d2d80ba$export$d219df4fe04c04a7.flushWaitMs,
                    maxQueueSize: (options === null || options === void 0 ? void 0 : options.maxQueueSize) || $29ad82233d2d80ba$export$d219df4fe04c04a7.maxQueueSize,
                    maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || $29ad82233d2d80ba$export$d219df4fe04c04a7.maxAttempts,
                    maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || $29ad82233d2d80ba$export$d219df4fe04c04a7.maxRetryDelay,
                    minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || $29ad82233d2d80ba$export$d219df4fe04c04a7.minRetryDelay
                };
            }
        }
    ]);
}();

});
parcelRegister("g0txv", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba738f5e1bb5880f$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $4uOvq = parcelRequire("4uOvq");

var $2uDuF = parcelRequire("2uDuF");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
var $ba738f5e1bb5880f$var$validSuffixs = Object.values((0, $4uOvq.LocalStorageKeySuffix));
var $ba738f5e1bb5880f$export$2e2bcd8739ae039 = function(prefix) {
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        var queueStates = Object.keys(localStorage).filter(function(key) {
            return key && key.startsWith("".concat(prefix, ".")) || false;
        }).map(function(key) {
            return key.split('.');
        }).filter(function(splitKeys) {
            return splitKeys.length === 3 && $ba738f5e1bb5880f$var$validSuffixs.includes(splitKeys[2]);
        }).reduce(function(accumulator, currentKeys) {
            var _currentKeys = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(currentKeys, 3), id = _currentKeys[1], suffix = _currentKeys[2];
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        var queuesToPurge = Object.keys(queueStates).filter(function(id) {
            return queueStates[id][(0, $4uOvq.LocalStorageKeySuffix).ACK] !== true;
        });
        queuesToPurge.forEach(function(id) {
            var _createLocalStorageKe = (0, $2uDuF.createLocalStorageKeys)(prefix, id), queue = _createLocalStorageKe.queue, inProgress = _createLocalStorageKe.inProgress, reclaimStart = _createLocalStorageKe.reclaimStart, reclaimEnd = _createLocalStorageKe.reclaimEnd;
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(inProgress);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(queue);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(reclaimStart);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("4uOvq", function(module, exports) {
$parcel$export(module.exports, "LocalStorageKeySuffix", () => $34612426f666b75f$export$ecfa71cbc9b28241);
$parcel$export(module.exports, "Timers", () => $34612426f666b75f$export$8bb2c1fb2b1765a9);
var $34612426f666b75f$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
var $34612426f666b75f$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("2uDuF", function(module, exports) {
$parcel$export(module.exports, "createLocalStorageKeys", () => $1d0d04b78b826b82$export$8433d54f767cbec5);

var $25nEq = parcelRequire("25nEq");

var $4uOvq = parcelRequire("4uOvq");
var $1d0d04b78b826b82$export$8433d54f767cbec5 = function createLocalStorageKeys(queuePrefix, queueId) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $4uOvq.LocalStorageKeySuffix).ACK, "".concat(queuePrefix, ".").concat(queueId, ".").concat((0, $4uOvq.LocalStorageKeySuffix).ACK)), (0, $4uOvq.LocalStorageKeySuffix).QUEUE, "".concat(queuePrefix, ".").concat(queueId, ".").concat((0, $4uOvq.LocalStorageKeySuffix).QUEUE)), (0, $4uOvq.LocalStorageKeySuffix).IN_PROGRESS, "".concat(queuePrefix, ".").concat(queueId, ".").concat((0, $4uOvq.LocalStorageKeySuffix).IN_PROGRESS)), (0, $4uOvq.LocalStorageKeySuffix).RECLAIM_START, "".concat(queuePrefix, ".").concat(queueId, ".").concat((0, $4uOvq.LocalStorageKeySuffix).RECLAIM_START)), (0, $4uOvq.LocalStorageKeySuffix).RECLAIM_END, "".concat(queuePrefix, ".").concat(queueId, ".").concat((0, $4uOvq.LocalStorageKeySuffix).RECLAIM_END));
};

});


parcelRegister("b6FTZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $021634adde976b1b$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $1Ygrk = parcelRequire("1Ygrk");

var $4uOvq = parcelRequire("4uOvq");

var $2uDuF = parcelRequire("2uDuF");
function $021634adde976b1b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $021634adde976b1b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $021634adde976b1b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $021634adde976b1b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Code we need to mimic:
// https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L262-L357
// Note we do not want to run this library due to the performance, duplication and memory leak issues.
var $021634adde976b1b$var$promisedSetTimeout = function promisedSetTimeout(msToWait) {
    return new Promise(function(resolve) {
        setTimeout(resolve, msToWait);
    });
};
var $021634adde976b1b$var$findOtherQueues = function findOtherQueues(queuePrefix) {
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return Object.keys(localStorage).filter(function(key) {
            return key.startsWith(queuePrefix);
        }).map(function(key) {
            return key.split('.');
        }).filter(function(split) {
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $4uOvq.LocalStorageKeySuffix).ACK) try {
                // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                var ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    var ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $4uOvq.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (_unused) {
            // ignore and drop value
            }
            return false;
        }).map(function(split) {
            return split[1];
        });
    } catch (_unused2) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
var $021634adde976b1b$var$tryReclaim = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(options, callback) {
        var _options$storageKeys, ack, reclaimStart, reclaimEnd, start;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _options$storageKeys = options.storageKeys, ack = _options$storageKeys.ack, reclaimStart = _options$storageKeys.reclaimStart, reclaimEnd = _options$storageKeys.reclaimEnd;
                    start = Date.now(); // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    localStorage.setItem(reclaimStart, options.reclaimProcessId);
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    localStorage.setItem(ack, start.toString());
                    _context.next = 1;
                    return $021634adde976b1b$var$promisedSetTimeout((0, $4uOvq.Timers).RECLAIM_WAIT);
                case 1:
                    if (!// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
                    (Date.now() > start + (0, $4uOvq.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    localStorage.getItem(reclaimStart) !== options.reclaimProcessId)) {
                        _context.next = 2;
                        break;
                    }
                    throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
                case 2:
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
                    _context.next = 3;
                    return $021634adde976b1b$var$promisedSetTimeout((0, $4uOvq.Timers).RECLAIM_WAIT);
                case 3:
                    if (!// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
                    (Date.now() > start + (0, $4uOvq.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    localStorage.getItem(reclaimEnd) !== options.reclaimProcessId)) {
                        _context.next = 4;
                        break;
                    }
                    throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
                case 4:
                    return _context.abrupt("return", $021634adde976b1b$var$reclaim(options, callback));
                case 5:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function tryReclaim(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var $021634adde976b1b$var$reclaim = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(options, callback) {
        var _options$storageKeys2, queue, inProgress, eventsInQueue, eventsInProgress, arrayOfEventsInProgress, eventsToProcess, result, leftover;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _options$storageKeys2 = options.storageKeys, queue = _options$storageKeys2.queue, inProgress = _options$storageKeys2.inProgress; // Queue is an array of events while inProgress is an object with a uuid for key
                    // Either of these queues may legitimately be missing.
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
                    eventsInProgress = JSON.parse(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    localStorage.getItem(inProgress) || '{}');
                    arrayOfEventsInProgress = Object.entries(eventsInProgress).map(function(_ref3) {
                        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), key = _ref4[0], item = _ref4[1];
                        var itemWithId = $021634adde976b1b$var$_objectSpread($021634adde976b1b$var$_objectSpread({}, item), {}, {
                            // LocalStorage-retry would add the attemptCounter after failure, rather than
                            // as it was being processed
                            attemptNumber: item.attemptNumber + 1,
                            id: key
                        });
                        return itemWithId;
                    });
                    eventsToProcess = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(eventsInQueue), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(arrayOfEventsInProgress));
                    if (!(eventsToProcess.length > 0)) {
                        _context2.next = 4;
                        break;
                    }
                    _context2.next = 1;
                    return callback(eventsToProcess);
                case 1:
                    result = _context2.sent;
                    if (!(result.status === 'successful')) {
                        _context2.next = 2;
                        break;
                    }
                    $021634adde976b1b$var$clearLocalStorageKeys(options.storageKeys);
                    _context2.next = 3;
                    break;
                case 2:
                    if (!(result.status === 'partial')) {
                        _context2.next = 3;
                        break;
                    }
                    // Dont delete all events if we are only able to take some of them.
                    leftover = eventsToProcess.filter(function(event) {
                        return !result.acceptedItemIds.includes(event.id);
                    }); // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
                    // However, there is a very small chance that we may lose events if the process exits between these two commands.
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    localStorage.removeItem(inProgress);
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    localStorage.setItem(queue, JSON.stringify(leftover));
                    return _context2.abrupt("return", {
                        fullReclaim: false
                    });
                case 3:
                    _context2.next = 5;
                    break;
                case 4:
                    $021634adde976b1b$var$clearLocalStorageKeys(options.storageKeys);
                case 5:
                    return _context2.abrupt("return", {
                        fullReclaim: true
                    });
                case 6:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function reclaim(_x3, _x4) {
        return _ref2.apply(this, arguments);
    };
}();
// Exterminate
var $021634adde976b1b$var$clearLocalStorageKeys = function clearLocalStorageKeys(keys) {
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.queue);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.inProgress);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.reclaimEnd);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.ack);
};
var $021634adde976b1b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(queuePrefix, callback) {
        var reclaimProcessId, queuesToReclaim, claims, settledClaims, failedReclaims, successfulClaims, fullReclaims, partialReclaims;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    if (!(typeof queuePrefix !== 'string' || queuePrefix.length === 0)) {
                        _context3.next = 1;
                        break;
                    }
                    return _context3.abrupt("return", {
                        fullReclaims: 0,
                        partialReclaims: 0,
                        failedReclaims: 0
                    });
                case 1:
                    reclaimProcessId = (0, $1Ygrk.default)();
                    queuesToReclaim = $021634adde976b1b$var$findOtherQueues(queuePrefix);
                    claims = queuesToReclaim.map(function(id) {
                        return $021634adde976b1b$var$tryReclaim({
                            queuePrefix: queuePrefix,
                            reclaimProcessId: reclaimProcessId,
                            storageKeys: (0, $2uDuF.createLocalStorageKeys)(queuePrefix, id)
                        }, callback);
                    });
                    _context3.next = 2;
                    return Promise.allSettled(claims);
                case 2:
                    settledClaims = _context3.sent;
                    failedReclaims = settledClaims.filter(function(claim) {
                        return claim.status === 'rejected';
                    });
                    successfulClaims = settledClaims.filter(function(settledValue) {
                        return settledValue.status === 'fulfilled';
                    }).map(function(result) {
                        return result.value;
                    });
                    fullReclaims = successfulClaims.filter(function(claim) {
                        return claim.fullReclaim;
                    });
                    partialReclaims = successfulClaims.filter(function(claim) {
                        return !claim.fullReclaim;
                    });
                    return _context3.abrupt("return", {
                        failedReclaims: failedReclaims.length,
                        partialReclaims: partialReclaims.length,
                        fullReclaims: fullReclaims.length
                    });
                case 3:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function(_x5, _x6) {
        return _ref5.apply(this, arguments);
    };
}();

});
parcelRegister("1Ygrk", function(module, exports) {
$parcel$export(module.exports, "default", () => $16f8259e8856e670$export$2e2bcd8739ae039);
// UUID v4 generator with fallback for non-secure contexts
function $16f8259e8856e670$export$2e2bcd8739ae039() {
    var g = globalThis;
    try {
        if (g.crypto && typeof g.crypto.randomUUID === 'function') return g.crypto.randomUUID();
    } catch (_unused) {
    // ignore and fallback
    }
    // Fallback to Math.random-based v4 UUID
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.floor(Math.random() * 16);
        var v = c === 'x' ? r : r & 0x3 | 0x8; // x => random hex digit; y => set RFC 4122 variant bits (10xx), yielding 8, 9, a, or b
        return v.toString(16);
    });
}

});


parcelRegister("aB9ZI", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b751cc60eb1a247$export$2e2bcd8739ae039);

var $dwiKG = parcelRequire("dwiKG");
var $7b751cc60eb1a247$export$2e2bcd8739ae039 = (0, $dwiKG.default);

});
parcelRegister("dwiKG", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d7ccf4aa6931707$export$2e2bcd8739ae039);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $4r6Zx = parcelRequire("4r6Zx");

var $9hTgF = parcelRequire("9hTgF");

var $5ZJYG = parcelRequire("5ZJYG");

var $B6WLz = parcelRequire("B6WLz");

var $hxjSL = parcelRequire("hxjSL");

var $1YukK = parcelRequire("1YukK");
var $9d7ccf4aa6931707$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function DbDelegator(namespace) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, DbDelegator);
        this.namespace = namespace;
        this.options = (0, $9hTgF.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(DbDelegator, [
        {
            key: "getResilienceMechanism",
            value: function getResilienceMechanism(namespace, options) {
                if (!options.useMemory) try {
                    return new (0, $hxjSL.default)(namespace, options);
                } catch (error) {
                    if (!(error instanceof (0, $5ZJYG.default))) {
                        var _options$logger;
                        (_options$logger = options.logger) === null || _options$logger === void 0 || _options$logger.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
                    }
                }
                return new (0, $1YukK.default)(this.namespace, options);
            }
        },
        {
            key: "addItem",
            value: function addItem(item, options) {
                var _this = this;
                var policy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $4r6Zx.GuardPolicy).ABANDON;
                return this.runOrFailOver(function() {
                    return _this.resilience.addItem(item, options, policy);
                });
            }
        },
        {
            key: "bulkAddItem",
            value: function bulkAddItem(itemOptions) {
                var _this2 = this;
                var policy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $4r6Zx.GuardPolicy).ABANDON;
                return this.runOrFailOver(function() {
                    return _this2.resilience.bulkAddItem(itemOptions, policy);
                });
            }
        },
        {
            key: "getItems",
            value: function getItems(count) {
                var _this3 = this;
                return this.runOrFailOver(function() {
                    return _this3.resilience.getItems(count);
                });
            }
        },
        {
            key: "deleteItems",
            value: function deleteItems(itemIds) {
                var _this4 = this;
                return this.runOrFailOver(function() {
                    return _this4.resilience.deleteItems(itemIds);
                });
            }
        },
        {
            key: "getItemCount",
            value: function getItemCount() {
                var _this5 = this;
                return this.runOrFailOver(function() {
                    return _this5.resilience.getItemCount();
                });
            }
        },
        {
            key: "processItems",
            value: function processItems(processFn, count) {
                var _this6 = this;
                return this.runOrFailOver(function() {
                    return _this6.resilience.processItems(processFn, count);
                });
            }
        },
        {
            key: "storeType",
            value: function storeType() {
                return this.resilience.storeType();
            }
        },
        {
            key: "runOrFailOver",
            value: function() {
                var _runOrFailOver = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(runnable) {
                    var _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.prev = 0;
                                _context.next = 1;
                                return runnable();
                            case 1:
                                return _context.abrupt("return", _context.sent);
                            case 2:
                                _context.prev = 2;
                                _t = _context["catch"](0);
                                if (!(0, $B6WLz.shouldIgnoreResilienceDbError)(_t)) {
                                    _context.next = 3;
                                    break;
                                }
                                throw _t;
                            case 3:
                                if (!(this.resilience.storeType() === (0, $4r6Zx.StoreType).INDEXEDDB)) {
                                    _context.next = 4;
                                    break;
                                }
                                _context.next = 4;
                                return this.failOver();
                            case 4:
                                return _context.abrupt("return", runnable());
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            0,
                            2
                        ]
                    ]);
                }));
                function runOrFailOver(_x) {
                    return _runOrFailOver.apply(this, arguments);
                }
                return runOrFailOver;
            }()
        },
        {
            key: "failOver",
            value: function() {
                var _failOver = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2() {
                    var oldResilience, newResilience, _yield$oldResilience$, items, bulkAddItemsResponse, addedItemIds, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                // Attempt to get any events we can and put them into memory
                                oldResilience = this.resilience;
                                newResilience = new (0, $1YukK.default)(this.namespace, this.options);
                                this.resilience = newResilience;
                                _context2.prev = 1;
                                _context2.next = 2;
                                return oldResilience.getItems(this.options.maxEventLimit);
                            case 2:
                                _yield$oldResilience$ = _context2.sent;
                                items = _yield$oldResilience$.items;
                                if (!(items.length > 0)) {
                                    _context2.next = 4;
                                    break;
                                }
                                _context2.next = 3;
                                return newResilience.bulkAddItemWrapperType(items, (0, $4r6Zx.GuardPolicy).IGNORE);
                            case 3:
                                bulkAddItemsResponse = _context2.sent;
                                addedItemIds = bulkAddItemsResponse.items.map(function(item) {
                                    return item.id;
                                });
                                _context2.next = 4;
                                return oldResilience.deleteItems(addedItemIds);
                            case 4:
                                _context2.next = 6;
                                break;
                            case 5:
                                _context2.prev = 5;
                                _t2 = _context2["catch"](1);
                                this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
                            // Dont need to catch. We are just getting events if we can
                            case 6:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            5
                        ]
                    ]);
                }));
                function failOver() {
                    return _failOver.apply(this, arguments);
                }
                return failOver;
            }()
        }
    ]);
}();

});
parcelRegister("4r6Zx", function(module, exports) {
$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", () => $33af1b6df02acb6a$export$d21fbb25eb37b5bf);
$parcel$export(module.exports, "RESILIENCE_DB_NAME", () => $33af1b6df02acb6a$export$8cad224051643259);
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", () => $33af1b6df02acb6a$export$3d8420be07b276ab);
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", () => $33af1b6df02acb6a$export$a512a65455fce2a6);
$parcel$export(module.exports, "TIME_ADDED_INDEX", () => $33af1b6df02acb6a$export$89d9c1ff8ac91862);
$parcel$export(module.exports, "RETRY_INDEX", () => $33af1b6df02acb6a$export$a37d385bcd713809);
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", () => $33af1b6df02acb6a$export$6d8635fed0e4b14d);
$parcel$export(module.exports, "StoreType", () => $33af1b6df02acb6a$export$39337ab5872e9457);
$parcel$export(module.exports, "GuardPolicy", () => $33af1b6df02acb6a$export$7710d69e6f450f20);
var $33af1b6df02acb6a$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
var $33af1b6df02acb6a$export$8cad224051643259 = 'analytics-web-client';
var $33af1b6df02acb6a$export$3d8420be07b276ab = 'analytics-resilience';
var $33af1b6df02acb6a$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
var $33af1b6df02acb6a$export$89d9c1ff8ac91862 = 'timeAdded';
var $33af1b6df02acb6a$export$a37d385bcd713809 = 'retryAttempts';
var $33af1b6df02acb6a$export$6d8635fed0e4b14d = 15000;
var $33af1b6df02acb6a$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
var $33af1b6df02acb6a$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    // Adds as many items as possible and IGONRES the rest.
    // Only to be used with BulkAdd
    GuardPolicy["IGNORE"] = "ignore";
    // ABANDON the request if not all items can be added.
    GuardPolicy["ABANDON"] = "abandon";
    // EVICT old items to make room for new items if space is tight.
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("9hTgF", function(module, exports) {
$parcel$export(module.exports, "createOptionsWithDefaults", () => $6c30929ffd0630e9$export$ddc6718318090f71);

var $2qzvd = parcelRequire("2qzvd");
var $6c30929ffd0630e9$export$ddc6718318090f71 = function createOptionsWithDefaults(options) {
    return {
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $2qzvd.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $2qzvd.EVENT_COUNT_LIMIT)
    };
};

});
parcelRegister("2qzvd", function(module, exports) {
$parcel$export(module.exports, "GET_ITEM_COUNT", () => $1c498c884937cf8b$export$b6df3d334cec060f);
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", () => $1c498c884937cf8b$export$14ef152a03a4b6ee);
$parcel$export(module.exports, "MAX_ATTEMPTS", () => $1c498c884937cf8b$export$da9ab7b2fd5998e8);
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", () => $1c498c884937cf8b$export$1188664dfff364c8);
var $1c498c884937cf8b$export$b6df3d334cec060f = 7;
var $1c498c884937cf8b$export$14ef152a03a4b6ee = 60000;
var $1c498c884937cf8b$export$da9ab7b2fd5998e8 = 10;
var $1c498c884937cf8b$export$1188664dfff364c8 = 8000;

});


parcelRegister("5ZJYG", function(module, exports) {
$parcel$export(module.exports, "default", () => $45d6507642197b13$export$2e2bcd8739ae039);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $45d6507642197b13$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $45d6507642197b13$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $45d6507642197b13$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($45d6507642197b13$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $45d6507642197b13$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
/*
 Only to be used with window.indexeddb is undefined.
 This will prevent DbDelegator from logging errors, but will not prevent swapping to memoryDB
*/ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $45d6507642197b13$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    function NoIndexedDbError() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoIndexedDbError);
        _this = $45d6507642197b13$var$_callSuper(this, NoIndexedDbError, [
            'window.indexeddb is undefined.'
        ]);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, NoIndexedDbError.prototype);
        _this.name = $45d6507642197b13$export$fc14cf6dcea0f8ed;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NoIndexedDbError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoIndexedDbError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});

parcelRegister("B6WLz", function(module, exports) {
$parcel$export(module.exports, "shouldIgnoreResilienceDbError", () => $06f8d85073d84c3b$export$74101021e0969375);

var $ekGgq = parcelRequire("ekGgq");

var $i6hRu = parcelRequire("i6hRu");

var $ldMum = parcelRequire("ldMum");

var $hZkpD = parcelRequire("hZkpD");
var $06f8d85073d84c3b$export$74101021e0969375 = function shouldIgnoreResilienceDbError(error) {
    if (error && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(error) === 'object' && 'name' in error) {
        var errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $i6hRu.AbandonWriteErrorName) || errorWithName.name === (0, $ldMum.CallbackProcessingErrorName) || errorWithName.name === (0, $hZkpD.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("i6hRu", function(module, exports) {
$parcel$export(module.exports, "AbandonWriteErrorName", () => $d2d6a47f21b9612f$export$ba95206613c96b28);
$parcel$export(module.exports, "default", () => $d2d6a47f21b9612f$export$2e2bcd8739ae039);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $d2d6a47f21b9612f$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $d2d6a47f21b9612f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $d2d6a47f21b9612f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d2d6a47f21b9612f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $d2d6a47f21b9612f$export$ba95206613c96b28 = 'AbandonWriteError';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $d2d6a47f21b9612f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    function AbandonWriteError(source) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AbandonWriteError);
        _this = $d2d6a47f21b9612f$var$_callSuper(this, AbandonWriteError, [
            "Event Limit reached. Abandoning write to: ".concat(source)
        ]);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, AbandonWriteError.prototype);
        _this.name = $d2d6a47f21b9612f$export$ba95206613c96b28;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(AbandonWriteError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AbandonWriteError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});

parcelRegister("ldMum", function(module, exports) {
$parcel$export(module.exports, "CallbackProcessingErrorName", () => $f7306cb8422ee85a$export$a409c8de90e11e14);
$parcel$export(module.exports, "default", () => $f7306cb8422ee85a$export$2e2bcd8739ae039);

var $ekGgq = parcelRequire("ekGgq");

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $f7306cb8422ee85a$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $f7306cb8422ee85a$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $f7306cb8422ee85a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f7306cb8422ee85a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $f7306cb8422ee85a$export$a409c8de90e11e14 = 'CallbackProcessingError';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $f7306cb8422ee85a$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    function CallbackProcessingError(error) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, CallbackProcessingError);
        var messageFromError = error && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(error) === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        var messageFromString = typeof error === 'string' && error;
        var message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        _this = $f7306cb8422ee85a$var$_callSuper(this, CallbackProcessingError, [
            "Error thrown while processing events in callback: ".concat(message)
        ]);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, CallbackProcessingError.prototype);
        _this.name = $f7306cb8422ee85a$export$a409c8de90e11e14;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(CallbackProcessingError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(CallbackProcessingError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});

parcelRegister("hZkpD", function(module, exports) {
$parcel$export(module.exports, "InvalidPolicyErrorName", () => $d187f7a92ea73b17$export$7e7aee9a953465ec);
$parcel$export(module.exports, "default", () => $d187f7a92ea73b17$export$2e2bcd8739ae039);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $d187f7a92ea73b17$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $d187f7a92ea73b17$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $d187f7a92ea73b17$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d187f7a92ea73b17$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $d187f7a92ea73b17$export$7e7aee9a953465ec = 'InvalidPolicyError';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $d187f7a92ea73b17$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    function InvalidPolicyError(policy, method) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, InvalidPolicyError);
        _this = $d187f7a92ea73b17$var$_callSuper(this, InvalidPolicyError, [
            "Method '".concat(method, "' cannot be called with policy '").concat(policy, "'.")
        ]);
        _this.name = $d187f7a92ea73b17$export$7e7aee9a953465ec;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(InvalidPolicyError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(InvalidPolicyError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});


parcelRegister("hxjSL", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc44f0f2693c9e2c$export$2e2bcd8739ae039);

var $1Vcia = parcelRequire("1Vcia");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $gyG3B = parcelRequire("gyG3B");

var $4r6Zx = parcelRequire("4r6Zx");

var $lG9Bp = parcelRequire("lG9Bp");

var $9hTgF = parcelRequire("9hTgF");

var $2qzvd = parcelRequire("2qzvd");

var $ldMum = parcelRequire("ldMum");

var $hZkpD = parcelRequire("hZkpD");

var $5ZJYG = parcelRequire("5ZJYG");

var $B6WLz = parcelRequire("B6WLz");

var $Np7tU = parcelRequire("Np7tU");

var $8c4CO = parcelRequire("8c4CO");

var $cxfqV = parcelRequire("cxfqV");
var $cc44f0f2693c9e2c$var$_excluded = [
    "item"
], $cc44f0f2693c9e2c$var$_excluded2 = [
    "items"
];
function $cc44f0f2693c9e2c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cc44f0f2693c9e2c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cc44f0f2693c9e2c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cc44f0f2693c9e2c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We have rolled our own client for IndexedDb as many Indexeddb libraries are
 * not flexible enough for our use case of:
 * 1. Adding specific indexes for time,
 * 2. Getting items on a specific index,
 * 3. Updating a field on an event while getting the event inside of a single ACID compliant transaction.
 */ var $cc44f0f2693c9e2c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function IndexedDbConnector(_namespace) {
        var _this = this;
        var _options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, IndexedDbConnector);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "startDB", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        return _context2.abrupt("return", new Promise(/*#__PURE__*/ function() {
                            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(resolve, reject) {
                                var dbTimeout, request, _t;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                                    while(true)switch(_context.prev = _context.next){
                                        case 0:
                                            if (!(typeof window !== 'undefined')) {
                                                _context.next = 6;
                                                break;
                                            }
                                            dbTimeout = window.setTimeout(function() {
                                                _this.logger.warn('IndexedDB timed out.');
                                                reject(new (0, $5ZJYG.default)());
                                            }, (0, $4r6Zx.INDEXEDDB_TIMEOUT));
                                            /*
                       * The database version number can never change.
                       * An upgrade transaction is limited to only one connection to the database.
                       * Once this is done, we cannot open any connections with older versions of the schema.
                       * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
                       *
                       * Due to the nature of how AWC is used (multiple tabs that are very long lived),
                       * we will not be able to run version upgrades via indexeddb.
                       *
                       * This does not mean we cant change what is stored in the tables,
                       * this limitation just prevents us from:
                       *   - Creating new ObjectStores in this database connection, and
                       *   - Creating new indexes on our ObjectStores
                       *
                       * Any upgrades we wish to run in the future will have to create a new database,
                       * and migrate all the data from older databases.
                       *
                       * This also means any migrations we make will have to be supported until we have evidence
                       * that no events are coming from old versions of the database.
                       * This may take a long time.
                       */ request = window.indexedDB.open((0, $4r6Zx.RESILIENCE_DB_NAME), 1);
                                            request.onupgradeneeded = function(event) {
                                                if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                                                var db = request.result;
                                                var store = db.createObjectStore((0, $4r6Zx.RESILIENCE_STORE_NAME), {
                                                    keyPath: 'id'
                                                });
                                                store.createIndex((0, $4r6Zx.TIME_TO_PROCESS_AFTER_INDEX), (0, $4r6Zx.TIME_TO_PROCESS_AFTER_INDEX), {
                                                    unique: false
                                                });
                                                store.createIndex((0, $4r6Zx.RETRY_INDEX), (0, $4r6Zx.RETRY_INDEX), {
                                                    unique: false
                                                });
                                                store.createIndex((0, $4r6Zx.TIME_ADDED_INDEX), (0, $4r6Zx.TIME_ADDED_INDEX), {
                                                    unique: false
                                                });
                                                // Compound key index of product - timeAdded.
                                                store.createIndex((0, $4r6Zx.NAMESPACE_AND_TIME_ADDED_INDEX), [
                                                    'namespace',
                                                    'timeAdded'
                                                ], {
                                                    unique: false
                                                });
                                            };
                                            request.onerror = function() {
                                                reject(new (0, $5ZJYG.default)());
                                            };
                                            _context.prev = 1;
                                            _context.next = 2;
                                            return (0, $cxfqV.requestToPromise)(request);
                                        case 2:
                                            return _context.abrupt("return", resolve(request.result));
                                        case 3:
                                            _context.prev = 3;
                                            _t = _context["catch"](1);
                                            _this.logger.warn('IndexedDB failed to initialise.', _t);
                                            reject(new (0, $5ZJYG.default)());
                                        case 4:
                                            _context.prev = 4;
                                            window.clearTimeout(dbTimeout);
                                            return _context.finish(4);
                                        case 5:
                                            _context.next = 7;
                                            break;
                                        case 6:
                                            _this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                                            reject(new (0, $5ZJYG.default)());
                                        case 7:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _callee, null, [
                                    [
                                        1,
                                        3,
                                        4,
                                        5
                                    ]
                                ]);
                            }));
                            return function(_x, _x2) {
                                return _ref2.apply(this, arguments);
                            };
                        }()));
                    case 1:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2);
        })));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "addItem", /*#__PURE__*/ function() {
            var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(item) {
                var options, policy, logger, namespace, value, _yield$_this$getObjec, objectStore, bulkAddResult, _args3 = arguments, _t2;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                    while(true)switch(_context3.prev = _context3.next){
                        case 0:
                            options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
                            policy = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : (0, $4r6Zx.GuardPolicy).ABANDON;
                            logger = _this.logger, namespace = _this.namespace;
                            value = (0, $lG9Bp.convertToItemWrapper)(item, namespace, options);
                            _context3.next = 1;
                            return _this.getObjectStoreAndTransaction('readwrite');
                        case 1:
                            _yield$_this$getObjec = _context3.sent;
                            objectStore = _yield$_this$getObjec.objectStore;
                            if (!(policy === (0, $4r6Zx.GuardPolicy).IGNORE)) {
                                _context3.next = 2;
                                break;
                            }
                            throw new (0, $hZkpD.default)(policy, 'IndexedDbConnector#addItem');
                        case 2:
                            _context3.prev = 2;
                            if (!(!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string')) {
                                _context3.next = 3;
                                break;
                            }
                            throw new Error('Namespace not specified');
                        case 3:
                            _context3.next = 4;
                            return _this.globalEventLimitGuard.insertItems(objectStore, [
                                value
                            ], policy);
                        case 4:
                            bulkAddResult = _context3.sent;
                            if (!(bulkAddResult.items.length === 1)) {
                                _context3.next = 5;
                                break;
                            }
                            return _context3.abrupt("return", {
                                item: bulkAddResult.items[0],
                                numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                            });
                        case 5:
                            throw new Error("Incorrect number of items added. Expected: 1, got: ".concat(bulkAddResult.items.length));
                        case 6:
                            _context3.prev = 6;
                            _t2 = _context3["catch"](2);
                            if (!(0, $B6WLz.shouldIgnoreResilienceDbError)(_t2)) {
                                _context3.next = 7;
                                break;
                            }
                            throw _t2;
                        case 7:
                            logger.log('Failed to add item to table', _t2);
                            throw new Error('Request to add item to table failed');
                        case 8:
                        case "end":
                            return _context3.stop();
                    }
                }, _callee3, null, [
                    [
                        2,
                        6
                    ]
                ]);
            }));
            return function(_x3) {
                return _ref3.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "bulkAddItem", /*#__PURE__*/ function() {
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(itemOptions) {
                var policy, logger, namespace, items, _yield$_this$getObjec2, objectStore, _args4 = arguments, _t3;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                    while(true)switch(_context4.prev = _context4.next){
                        case 0:
                            policy = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : (0, $4r6Zx.GuardPolicy).ABANDON;
                            logger = _this.logger, namespace = _this.namespace;
                            items = itemOptions.map(function(_ref5) {
                                var item = _ref5.item, options = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref5, $cc44f0f2693c9e2c$var$_excluded);
                                return (0, $lG9Bp.convertToItemWrapper)(item, namespace, options);
                            });
                            _context4.next = 1;
                            return _this.getObjectStoreAndTransaction('readwrite');
                        case 1:
                            _yield$_this$getObjec2 = _context4.sent;
                            objectStore = _yield$_this$getObjec2.objectStore;
                            _context4.prev = 2;
                            _context4.next = 3;
                            return _this.globalEventLimitGuard.insertItems(objectStore, items, policy);
                        case 3:
                            return _context4.abrupt("return", _context4.sent);
                        case 4:
                            _context4.prev = 4;
                            _t3 = _context4["catch"](2);
                            if (!(0, $B6WLz.shouldIgnoreResilienceDbError)(_t3)) {
                                _context4.next = 5;
                                break;
                            }
                            throw _t3;
                        case 5:
                            logger.log('Failed to add item to table', _t3);
                            throw new Error('Request to add item to table failed');
                        case 6:
                        case "end":
                            return _context4.stop();
                    }
                }, _callee4, null, [
                    [
                        2,
                        4
                    ]
                ]);
            }));
            return function(_x4) {
                return _ref4.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getItems", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6() {
            var count, fixedCount, logger, maxAttempts, _yield$_this$getObjec3, transaction, objectStore, timeIndex, upperBoundOpenKeyRange, request, getResult, _args6 = arguments;
            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context6) {
                while(true)switch(_context6.prev = _context6.next){
                    case 0:
                        count = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : (0, $2qzvd.GET_ITEM_COUNT);
                        fixedCount = count > 0 ? count : (0, $2qzvd.GET_ITEM_COUNT);
                        logger = _this.logger;
                        maxAttempts = _this.options.maxAttempts;
                        _context6.next = 1;
                        return _this.getObjectStoreAndTransaction('readwrite');
                    case 1:
                        _yield$_this$getObjec3 = _context6.sent;
                        transaction = _yield$_this$getObjec3.transaction;
                        objectStore = _yield$_this$getObjec3.objectStore;
                        timeIndex = objectStore.index((0, $4r6Zx.TIME_TO_PROCESS_AFTER_INDEX));
                        upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
                        request = timeIndex.openCursor(upperBoundOpenKeyRange);
                        _context6.next = 2;
                        return new Promise(/*#__PURE__*/ function() {
                            var _ref7 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(resolve, reject) {
                                var items, numberOfDeletedItems;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                                    while(true)switch(_context5.prev = _context5.next){
                                        case 0:
                                            items = [];
                                            numberOfDeletedItems = 0;
                                            request.onerror = function(error) {
                                                logger.error('Failed to open cursor:', error);
                                                reject('Failed to open cursor');
                                            };
                                            // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                                            request.onsuccess = function(event) {
                                                var cursor = event.target.result;
                                                if (cursor) {
                                                    // Prevent mutation of the value we are returning
                                                    var value = $cc44f0f2693c9e2c$var$_objectSpread({}, cursor.value);
                                                    items.push(value);
                                                    // Mutations seem to be required for testing indexeddb library
                                                    var updatedValue = cursor.value;
                                                    updatedValue.retryAttempts += 1;
                                                    updatedValue.timeToBeProcessedAfter = Date.now() + (0, $2qzvd.VISIBILITY_TIMEOUT);
                                                    if (updatedValue.retryAttempts >= maxAttempts) {
                                                        ++numberOfDeletedItems;
                                                        var _request = cursor.delete();
                                                        (0, $8c4CO.monitorErrorsOnRequest)(_request, logger);
                                                    } else {
                                                        var _request2 = cursor.update(updatedValue);
                                                        (0, $8c4CO.monitorErrorsOnRequest)(_request2, logger);
                                                    }
                                                    if (items.length < fixedCount) cursor.continue();
                                                    else resolve({
                                                        items: items,
                                                        numberOfDeletedItems: numberOfDeletedItems
                                                    });
                                                } else resolve({
                                                    items: items,
                                                    numberOfDeletedItems: numberOfDeletedItems
                                                });
                                            };
                                        case 1:
                                        case "end":
                                            return _context5.stop();
                                    }
                                }, _callee5);
                            }));
                            return function(_x5, _x6) {
                                return _ref7.apply(this, arguments);
                            };
                        }());
                    case 2:
                        getResult = _context6.sent;
                        _context6.next = 3;
                        return (0, $gyG3B.commitTransaction)(transaction, _this.logger);
                    case 3:
                        return _context6.abrupt("return", getResult);
                    case 4:
                    case "end":
                        return _context6.stop();
                }
            }, _callee6);
        })));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "deleteItems", /*#__PURE__*/ function() {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7(itemIds) {
                var _yield$_this$getObjec4, transaction, objectStore, deletePromises, _t4;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context7) {
                    while(true)switch(_context7.prev = _context7.next){
                        case 0:
                            _context7.next = 1;
                            return _this.getObjectStoreAndTransaction('readwrite');
                        case 1:
                            _yield$_this$getObjec4 = _context7.sent;
                            transaction = _yield$_this$getObjec4.transaction;
                            objectStore = _yield$_this$getObjec4.objectStore;
                            _context7.prev = 2;
                            deletePromises = itemIds.map(function(id) {
                                return _this.deleteItem(objectStore, id);
                            });
                            _context7.next = 3;
                            return (0, $gyG3B.commitTransaction)(transaction, _this.logger);
                        case 3:
                            _context7.next = 4;
                            return Promise.all(deletePromises);
                        case 4:
                            _context7.next = 6;
                            break;
                        case 5:
                            _context7.prev = 5;
                            _t4 = _context7["catch"](2);
                            _this.logger.warn('Failed to delete items from indexeddb.', _t4);
                            throw _t4;
                        case 6:
                        case "end":
                            return _context7.stop();
                    }
                }, _callee7, null, [
                    [
                        2,
                        5
                    ]
                ]);
            }));
            return function(_x7) {
                return _ref8.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getItemCount", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8() {
            var _yield$_this$getObjec5, transaction, objectStore, timeIndex, upperBoundOpenKeyRange, request, event;
            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context8) {
                while(true)switch(_context8.prev = _context8.next){
                    case 0:
                        _context8.next = 1;
                        return _this.getObjectStoreAndTransaction('readonly');
                    case 1:
                        _yield$_this$getObjec5 = _context8.sent;
                        transaction = _yield$_this$getObjec5.transaction;
                        objectStore = _yield$_this$getObjec5.objectStore;
                        timeIndex = objectStore.index((0, $4r6Zx.TIME_TO_PROCESS_AFTER_INDEX));
                        upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
                        request = timeIndex.count(upperBoundOpenKeyRange);
                        _context8.next = 2;
                        return (0, $cxfqV.requestToPromise)(request);
                    case 2:
                        event = _context8.sent;
                        _context8.next = 3;
                        return (0, $gyG3B.commitTransaction)(transaction, _this.logger);
                    case 3:
                        return _context8.abrupt("return", event.target.result);
                    case 4:
                    case "end":
                        return _context8.stop();
                }
            }, _callee8);
        })));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "processItems", /*#__PURE__*/ function() {
            var _ref0 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(processFn) {
                var count, _yield$_this$getItems, items, partialResult, result, itemIds, _args9 = arguments, _t5;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context9) {
                    while(true)switch(_context9.prev = _context9.next){
                        case 0:
                            count = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : (0, $2qzvd.GET_ITEM_COUNT);
                            _context9.next = 1;
                            return _this.getItems(count);
                        case 1:
                            _yield$_this$getItems = _context9.sent;
                            items = _yield$_this$getItems.items;
                            partialResult = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_yield$_this$getItems, $cc44f0f2693c9e2c$var$_excluded2);
                            _context9.prev = 2;
                            _context9.next = 3;
                            return processFn(items, partialResult);
                        case 3:
                            result = _context9.sent;
                            itemIds = items.map(function(item) {
                                return item.id;
                            }); // We should not await this delete as a rejected promise would get caught by the catch statement
                            _context9.next = 4;
                            return _this.deleteItems(itemIds);
                        case 4:
                            return _context9.abrupt("return", result);
                        case 5:
                            _context9.prev = 5;
                            _t5 = _context9["catch"](2);
                            throw new (0, $ldMum.default)(_t5);
                        case 6:
                        case "end":
                            return _context9.stop();
                    }
                }, _callee9, null, [
                    [
                        2,
                        5
                    ]
                ]);
            }));
            return function(_x8) {
                return _ref0.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "deleteItem", /*#__PURE__*/ function() {
            var _ref1 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(objectStore, id) {
                var logger, _t6;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context0) {
                    while(true)switch(_context0.prev = _context0.next){
                        case 0:
                            logger = _this.logger;
                            _context0.prev = 1;
                            _context0.next = 2;
                            return (0, $cxfqV.requestToPromise)(objectStore.delete(id));
                        case 2:
                            _context0.next = 4;
                            break;
                        case 3:
                            _context0.prev = 3;
                            _t6 = _context0["catch"](1);
                            logger.error('Failed to delete item:', id, _t6);
                            throw _t6;
                        case 4:
                        case "end":
                            return _context0.stop();
                    }
                }, _callee0, null, [
                    [
                        1,
                        3
                    ]
                ]);
            }));
            return function(_x9, _x0) {
                return _ref1.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getObjectStoreAndTransaction", /*#__PURE__*/ function() {
            var _ref10 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1(mode) {
                var transaction, objectStore;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context1) {
                    while(true)switch(_context1.prev = _context1.next){
                        case 0:
                            _context1.next = 1;
                            return _this.db;
                        case 1:
                            transaction = _context1.sent.transaction((0, $4r6Zx.RESILIENCE_STORE_NAME), mode);
                            objectStore = transaction.objectStore((0, $4r6Zx.RESILIENCE_STORE_NAME));
                            return _context1.abrupt("return", {
                                transaction: transaction,
                                objectStore: objectStore
                            });
                        case 2:
                        case "end":
                            return _context1.stop();
                    }
                }, _callee1);
            }));
            return function(_x1) {
                return _ref10.apply(this, arguments);
            };
        }());
        this.options = (0, $9hTgF.createOptionsWithDefaults)(_options);
        this.namespace = _namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $5ZJYG.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(function() {});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $Np7tU.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(IndexedDbConnector, [
        {
            key: "storeType",
            value: function storeType() {
                return (0, $4r6Zx.StoreType).INDEXEDDB;
            }
        }
    ]);
}();

});
parcelRegister("gyG3B", function(module, exports) {
$parcel$export(module.exports, "commitTransaction", () => $c0e0720223c37df2$export$feab8418f018df89);

var $9gUwK = parcelRequire("9gUwK");
var $c0e0720223c37df2$export$feab8418f018df89 = function commitTransaction(transaction, logger) {
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return (0, $9gUwK.transactionToPromise)(transaction);
};

});
parcelRegister("9gUwK", function(module, exports) {
$parcel$export(module.exports, "transactionToPromise", () => $6c0174cc05898746$export$2a5213bce1720b42);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $6c0174cc05898746$export$2a5213bce1720b42 = function transactionToPromise(transaction) {
    return new Promise(function(resolve, reject) {
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = function() {
            resolve();
        };
        transaction.onerror = function(event) {
            reject(event);
        };
        transaction.onabort = function(event) {
            reject(event);
        };
    });
};

});


parcelRegister("lG9Bp", function(module, exports) {
$parcel$export(module.exports, "convertToItemWrapper", () => $fc84f8080a8d29e1$export$aec476f33d77be11);

var $1Ygrk = parcelRequire("1Ygrk");
var $fc84f8080a8d29e1$export$aec476f33d77be11 = function convertToItemWrapper(item, namespace, _ref) {
    var id = _ref.id, retryAttempts = _ref.retryAttempts, timeToProcessOffset = _ref.timeToProcessOffset;
    return {
        item: item,
        id: id || (0, $1Ygrk.default)(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    };
};

});

parcelRegister("Np7tU", function(module, exports) {
$parcel$export(module.exports, "default", () => $09480ff5e266e6b6$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $gyG3B = parcelRequire("gyG3B");

var $4r6Zx = parcelRequire("4r6Zx");

var $i6hRu = parcelRequire("i6hRu");

var $cxfqV = parcelRequire("cxfqV");
/**
 * A class to enforce a limit on the amount of Analytics Events stored in AWC IndexedDb.
 */ var $09480ff5e266e6b6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function IndexedDbEventCountGuard(eventLimit, namespace, logger, deleteItemHandler) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, IndexedDbEventCountGuard);
        /**
     * This query fetches the oldest events currently stored in AWC IndexedDb object store
     * and deletes them sequentially
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "deleteOldestNEvents", /*#__PURE__*/ function() {
            var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(objectStore, count) {
                var _target;
                var productTimeAddedIndex, keyRangeValues, getAllRequest, event, result, deletePromises, _t;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            productTimeAddedIndex = objectStore.index((0, $4r6Zx.NAMESPACE_AND_TIME_ADDED_INDEX));
                            keyRangeValues = IDBKeyRange.bound([
                                _this.namespace,
                                0
                            ], [
                                _this.namespace,
                                Date.now()
                            ]);
                            getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
                            _context.next = 1;
                            return (0, $cxfqV.requestToPromise)(getAllRequest);
                        case 1:
                            event = _context.sent;
                            result = event === null || event === void 0 || (_target = event.target) === null || _target === void 0 ? void 0 : _target.result; // Adding extra safety
                            if (!(result && Array.isArray(result) && result.length > 0)) {
                                _context.next = 5;
                                break;
                            }
                            _context.prev = 2;
                            deletePromises = result.map(function(item) {
                                return _this.deleteItemHandler(objectStore, item);
                            });
                            _context.next = 3;
                            return Promise.all(deletePromises);
                        case 3:
                            _context.next = 5;
                            break;
                        case 4:
                            _context.prev = 4;
                            _t = _context["catch"](2);
                            _this.logger.warn('Failed to delete items from indexeddb.', _t);
                            throw _t;
                        case 5:
                        case "end":
                            return _context.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        4
                    ]
                ]);
            }));
            return function(_x, _x2) {
                return _ref.apply(this, arguments);
            };
        }());
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(IndexedDbEventCountGuard, [
        {
            key: "insertItems",
            value: function() {
                var _insertItems = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(objectStore, items) {
                    var policy, itemsToAdd, numberOfEvictedItems, promises, _args2 = arguments, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                policy = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : (0, $4r6Zx.GuardPolicy).ABANDON;
                                itemsToAdd = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(items);
                                numberOfEvictedItems = 0;
                                _t2 = policy;
                                _context2.next = _t2 === (0, $4r6Zx.GuardPolicy).ABANDON ? 1 : _t2 === (0, $4r6Zx.GuardPolicy).EVICT ? 3 : _t2 === (0, $4r6Zx.GuardPolicy).IGNORE ? 5 : 7;
                                break;
                            case 1:
                                _context2.next = 2;
                                return this.throwIfNotEnoughSpace(objectStore, items.length);
                            case 2:
                                return _context2.abrupt("continue", 7);
                            case 3:
                                _context2.next = 4;
                                return this.evictIfNotEnoughSpace(objectStore, items.length);
                            case 4:
                                numberOfEvictedItems = _context2.sent;
                                return _context2.abrupt("continue", 7);
                            case 5:
                                _context2.next = 6;
                                return this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                            case 6:
                                return _context2.abrupt("continue", 7);
                            case 7:
                                promises = itemsToAdd.map(function(item) {
                                    return (0, $cxfqV.requestToPromise)(objectStore.add(item));
                                });
                                _context2.next = 8;
                                return Promise.all(promises);
                            case 8:
                                _context2.next = 9;
                                return (0, $gyG3B.commitTransaction)(objectStore.transaction, this.logger);
                            case 9:
                                return _context2.abrupt("return", {
                                    items: itemsToAdd,
                                    numberOfEvictedItems: numberOfEvictedItems
                                });
                            case 10:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function insertItems(_x3, _x4) {
                    return _insertItems.apply(this, arguments);
                }
                return insertItems;
            }()
        },
        {
            key: "throwIfNotEnoughSpace",
            value: function() {
                var _throwIfNotEnoughSpace = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(objectStore, requiredSpace) {
                    var freeSpace;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                _context3.next = 1;
                                return this.calculateFreeSpace(objectStore);
                            case 1:
                                freeSpace = _context3.sent;
                                if (!(freeSpace < requiredSpace)) {
                                    _context3.next = 2;
                                    break;
                                }
                                throw new (0, $i6hRu.default)("Not enough space in IndexedDb. Needed ".concat(requiredSpace, " but only had ").concat(freeSpace));
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function throwIfNotEnoughSpace(_x5, _x6) {
                    return _throwIfNotEnoughSpace.apply(this, arguments);
                }
                return throwIfNotEnoughSpace;
            }()
        },
        {
            key: "evictIfNotEnoughSpace",
            value: function() {
                var _evictIfNotEnoughSpace = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(objectStore, requiredSpace) {
                    var freeSpace, extraSpace;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return this.calculateFreeSpace(objectStore);
                            case 1:
                                freeSpace = _context4.sent;
                                if (!(freeSpace < requiredSpace)) {
                                    _context4.next = 3;
                                    break;
                                }
                                extraSpace = requiredSpace - freeSpace;
                                _context4.next = 2;
                                return this.deleteOldestNEvents(objectStore, extraSpace);
                            case 2:
                                return _context4.abrupt("return", extraSpace);
                            case 3:
                                return _context4.abrupt("return", 0);
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function evictIfNotEnoughSpace(_x7, _x8) {
                    return _evictIfNotEnoughSpace.apply(this, arguments);
                }
                return evictIfNotEnoughSpace;
            }()
        },
        {
            key: "calculateHowManyEventsWeCanAdd",
            value: function() {
                var _calculateHowManyEventsWeCanAdd = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(objectStore, items) {
                    var freeSpace, numberOfItemsToRemove, start;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                _context5.next = 1;
                                return this.calculateFreeSpace(objectStore);
                            case 1:
                                freeSpace = _context5.sent;
                                if (freeSpace < items.length) {
                                    numberOfItemsToRemove = items.length - freeSpace;
                                    start = items.length - numberOfItemsToRemove;
                                    items.splice(start, numberOfItemsToRemove);
                                }
                            case 2:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function calculateHowManyEventsWeCanAdd(_x9, _x0) {
                    return _calculateHowManyEventsWeCanAdd.apply(this, arguments);
                }
                return calculateHowManyEventsWeCanAdd;
            }()
        },
        {
            key: "calculateFreeSpace",
            value: function() {
                var _calculateFreeSpace = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(objectStore) {
                    var numberOfEventsInDb;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                _context6.next = 1;
                                return this.getCountofEventsInObjectStore(objectStore);
                            case 1:
                                numberOfEventsInDb = _context6.sent;
                                return _context6.abrupt("return", this.eventLimit - numberOfEventsInDb);
                            case 2:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function calculateFreeSpace(_x1) {
                    return _calculateFreeSpace.apply(this, arguments);
                }
                return calculateFreeSpace;
            }()
        },
        {
            key: "getCountofEventsInObjectStore",
            value: function() {
                var _getCountofEventsInObjectStore = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7(objectStore) {
                    var productTimeAddedIndex, keyRangeValues, request, event;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                productTimeAddedIndex = objectStore.index((0, $4r6Zx.NAMESPACE_AND_TIME_ADDED_INDEX));
                                keyRangeValues = IDBKeyRange.bound([
                                    this.namespace,
                                    0
                                ], [
                                    this.namespace,
                                    Date.now()
                                ]);
                                request = productTimeAddedIndex.count(keyRangeValues);
                                _context7.next = 1;
                                return (0, $cxfqV.requestToPromise)(request);
                            case 1:
                                event = _context7.sent;
                                return _context7.abrupt("return", event.target.result);
                            case 2:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function getCountofEventsInObjectStore(_x10) {
                    return _getCountofEventsInObjectStore.apply(this, arguments);
                }
                return getCountofEventsInObjectStore;
            }()
        }
    ]);
}();

});
parcelRegister("cxfqV", function(module, exports) {
$parcel$export(module.exports, "requestToPromise", () => $920489cfec389054$export$85ceed0783e42041);
// Not to be used on cursors or other requests that may call onsuccess multiple times.
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $920489cfec389054$export$85ceed0783e42041 = function requestToPromise(request) {
    return new Promise(function(resolve, reject) {
        request.onsuccess = function(event) {
            resolve(event);
        };
        request.onerror = function(event) {
            reject(event);
        };
    });
};

});


parcelRegister("8c4CO", function(module, exports) {
$parcel$export(module.exports, "monitorErrorsOnRequest", () => $5f730822a9ef2e6f$export$342d941b6f724995);
// For requests that are not mission critical
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $5f730822a9ef2e6f$export$342d941b6f724995 = function monitorErrorsOnRequest(request, logger) {
    request.onerror = function(event) {
        logger.warn('Error thrown from request:', event);
    };
};

});


parcelRegister("1YukK", function(module, exports) {
$parcel$export(module.exports, "default", () => $1702ecaf3ddce481$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $4r6Zx = parcelRequire("4r6Zx");

var $lG9Bp = parcelRequire("lG9Bp");

var $9hTgF = parcelRequire("9hTgF");

var $2qzvd = parcelRequire("2qzvd");

var $ldMum = parcelRequire("ldMum");

var $hZkpD = parcelRequire("hZkpD");

var $e7ngm = parcelRequire("e7ngm");
var $1702ecaf3ddce481$var$_excluded = [
    "item"
], $1702ecaf3ddce481$var$_excluded2 = [
    "items"
];
function $1702ecaf3ddce481$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1702ecaf3ddce481$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1702ecaf3ddce481$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1702ecaf3ddce481$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1702ecaf3ddce481$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $1702ecaf3ddce481$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $1702ecaf3ddce481$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $1702ecaf3ddce481$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1702ecaf3ddce481$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $1702ecaf3ddce481$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $1702ecaf3ddce481$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function MemoryDb(namespace) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, MemoryDb);
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $9hTgF.createOptionsWithDefaults)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $e7ngm.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(MemoryDb, [
        {
            key: "addItem",
            value: function() {
                var _addItem = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(item) {
                    var options, policy, storedValue, bulkAddItemsResult, _args = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                                policy = _args.length > 2 && _args[2] !== undefined ? _args[2] : (0, $4r6Zx.GuardPolicy).ABANDON;
                                if (!(policy === (0, $4r6Zx.GuardPolicy).IGNORE)) {
                                    _context.next = 1;
                                    break;
                                }
                                throw new (0, $hZkpD.default)(policy, 'IndexedDbConnector#addItem');
                            case 1:
                                storedValue = (0, $lG9Bp.convertToItemWrapper)(item, this.namespace, options); // Delegated responsiblity to event limit guard to insert to memory stored
                                _context.next = 2;
                                return this.globalEventLimitGuard.insertItemsToMemoryStore([
                                    storedValue
                                ], policy);
                            case 2:
                                bulkAddItemsResult = _context.sent;
                                return _context.abrupt("return", Promise.resolve({
                                    item: bulkAddItemsResult.items[0],
                                    numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
                                }));
                            case 3:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function addItem(_x) {
                    return _addItem.apply(this, arguments);
                }
                return addItem;
            }()
        },
        {
            key: "bulkAddItem",
            value: function bulkAddItem(itemOptions) {
                var _this = this;
                var policy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $4r6Zx.GuardPolicy).ABANDON;
                var items = itemOptions.map(function(_ref) {
                    var item = _ref.item, addOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $1702ecaf3ddce481$var$_excluded);
                    return (0, $lG9Bp.convertToItemWrapper)(item, _this.namespace, addOptions);
                });
                return this.bulkAddItemWrapperType(items, policy);
            }
        },
        {
            key: "bulkAddItemWrapperType",
            value: function bulkAddItemWrapperType(items) {
                var policy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $4r6Zx.GuardPolicy).ABANDON;
                return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
            }
        },
        {
            key: "getItems",
            value: function getItems() {
                var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $2qzvd.GET_ITEM_COUNT);
                return Promise.resolve(this.synchronousGetItems(count));
            }
        },
        {
            key: "synchronousGetItems",
            value: function synchronousGetItems() {
                var _this2 = this;
                var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $2qzvd.GET_ITEM_COUNT);
                var fixedCount = count > 0 ? count : (0, $2qzvd.GET_ITEM_COUNT);
                var now = Date.now();
                var wrappedItems = [];
                var itemsToRemove = [];
                var _iterator = $1702ecaf3ddce481$var$_createForOfIteratorHelper(this.memoryStore), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var wrappedItem = _step.value;
                        if (wrappedItem.timeToBeProcessedAfter <= now) {
                            wrappedItems.push($1702ecaf3ddce481$var$_objectSpread({}, wrappedItem));
                            // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                            wrappedItem.timeToBeProcessedAfter += (0, $2qzvd.VISIBILITY_TIMEOUT);
                            wrappedItem.retryAttempts += 1;
                            if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
                        }
                        if (wrappedItems.length >= fixedCount) break;
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                itemsToRemove.forEach(function(item) {
                    var index = _this2.memoryStore.indexOf(item);
                    _this2.memoryStore.splice(index, 1);
                });
                return {
                    items: wrappedItems,
                    numberOfDeletedItems: itemsToRemove.length
                };
            }
        },
        {
            key: "deleteItems",
            value: function deleteItems(itemIds) {
                this.memoryStore = this.memoryStore.filter(function(item) {
                    return !itemIds.includes(item.id);
                });
                return Promise.resolve(void 0);
            }
        },
        {
            key: "getItemCount",
            value: function getItemCount() {
                var now = Date.now();
                var count = this.memoryStore.filter(function(item) {
                    return item.timeToBeProcessedAfter <= now;
                }).length;
                return Promise.resolve(count);
            }
        },
        {
            key: "processItems",
            value: function() {
                var _processItems = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(processFn, count) {
                    var _this$synchronousGetI, items, partialGetResult, itemIds, result, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _this$synchronousGetI = this.synchronousGetItems(count), items = _this$synchronousGetI.items, partialGetResult = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_this$synchronousGetI, $1702ecaf3ddce481$var$_excluded2);
                                itemIds = items.map(function(i) {
                                    return i.id;
                                });
                                _context2.prev = 1;
                                _context2.next = 2;
                                return processFn(items, partialGetResult);
                            case 2:
                                result = _context2.sent;
                                _context2.next = 3;
                                return this.deleteItems(itemIds);
                            case 3:
                                return _context2.abrupt("return", result);
                            case 4:
                                _context2.prev = 4;
                                _t = _context2["catch"](1);
                                throw new (0, $ldMum.default)(_t);
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            4
                        ]
                    ]);
                }));
                function processItems(_x2, _x3) {
                    return _processItems.apply(this, arguments);
                }
                return processItems;
            }()
        },
        {
            key: "storeType",
            value: function storeType() {
                return (0, $4r6Zx.StoreType).MEMORY;
            }
        },
        {
            key: "addItems",
            value: function addItems(itemsToAdd) {
                var _this$memoryStore;
                (_this$memoryStore = this.memoryStore).push.apply(_this$memoryStore, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(itemsToAdd));
                // Sorting everytime, intentionally.
                this.memoryStore.sort(function(a, b) {
                    return a.timeAdded - b.timeAdded;
                });
            }
        },
        {
            key: "evictEventsIfNeeded",
            value: function evictEventsIfNeeded(eventLimit) {
                var numberOfEventsInDb = this.memoryStore.length;
                // The number of analytics events currently in MemoryDb and
                // the Z events we are proposing to add will exceed our event count limit.
                if (numberOfEventsInDb > eventLimit) {
                    var m = numberOfEventsInDb - eventLimit;
                    // Removing oldest M events
                    this.memoryStore.splice(0, m);
                    return m;
                }
                return 0;
            }
        }
    ]);
}();

});
parcelRegister("e7ngm", function(module, exports) {
$parcel$export(module.exports, "default", () => $a473c3a6a30f3441$export$2e2bcd8739ae039);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $4r6Zx = parcelRequire("4r6Zx");

var $i6hRu = parcelRequire("i6hRu");
var $a473c3a6a30f3441$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function MemoryDbEventCountGuard(eventLimit, memoryItemHandlers) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, MemoryDbEventCountGuard);
        /**
     * Unlike IndexedDb, we cannot take advantage of any index. So we are,
     * treating the memory store as a sorted set when adding items.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "insertItemsToMemoryStore", function(itemsToAdd, policy) {
            switch(policy){
                case (0, $4r6Zx.GuardPolicy).ABANDON:
                    return _this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $4r6Zx.GuardPolicy).EVICT:
                    return Promise.resolve(_this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $4r6Zx.GuardPolicy).IGNORE:
                    return _this.handleAddAsManyAsPossible(itemsToAdd);
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(MemoryDbEventCountGuard, [
        {
            key: "handleAbandonIfLimitWillExceedPolicy",
            value: function() {
                var _handleAbandonIfLimitWillExceedPolicy = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(itemsToAdd) {
                    var itemCount;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 1;
                                return this.memoryItemHandlers.getItemCount();
                            case 1:
                                itemCount = _context.sent;
                                if (!(itemCount + itemsToAdd.length > this.eventLimit)) {
                                    _context.next = 2;
                                    break;
                                }
                                throw new (0, $i6hRu.default)((0, $4r6Zx.StoreType).MEMORY);
                            case 2:
                                this.memoryItemHandlers.addItems(itemsToAdd);
                                return _context.abrupt("return", {
                                    items: itemsToAdd,
                                    numberOfEvictedItems: 0
                                });
                            case 3:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function handleAbandonIfLimitWillExceedPolicy(_x) {
                    return _handleAbandonIfLimitWillExceedPolicy.apply(this, arguments);
                }
                return handleAbandonIfLimitWillExceedPolicy;
            }()
        },
        {
            key: "handleEvictOldestIfLimitExceededPolicy",
            value: function handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
                this.memoryItemHandlers.addItems(itemsToAdd);
                var numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
                return {
                    items: itemsToAdd,
                    numberOfEvictedItems: numberOfEvictedItems
                };
            }
        },
        {
            key: "handleAddAsManyAsPossible",
            value: function() {
                var _handleAddAsManyAsPossible = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(itemsToAdd) {
                    var freeSpace, partialEventsToAdd, _t, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _t = this.eventLimit;
                                _context2.next = 1;
                                return this.memoryItemHandlers.getItemCount();
                            case 1:
                                _t2 = _context2.sent;
                                freeSpace = _t - _t2;
                                partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
                                this.memoryItemHandlers.addItems(partialEventsToAdd);
                                return _context2.abrupt("return", {
                                    items: partialEventsToAdd,
                                    numberOfEvictedItems: 0
                                });
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function handleAddAsManyAsPossible(_x2) {
                    return _handleAddAsManyAsPossible.apply(this, arguments);
                }
                return handleAddAsManyAsPossible;
            }()
        }
    ]);
}();

});




parcelRegister("f4MJF", function(module, exports) {
$parcel$export(module.exports, "default", () => $02d51d0ac0f3eacd$export$2e2bcd8739ae039);

var $50YPo = parcelRequire("50YPo");
var $02d51d0ac0f3eacd$var$cachedMetricsClient = null;
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$02d51d0ac0f3eacd$export$2e2bcd8739ae039 = function() {
    if (!$02d51d0ac0f3eacd$var$cachedMetricsClient) $02d51d0ac0f3eacd$var$cachedMetricsClient = new (0, $50YPo.MetricsCollector)();
    return $02d51d0ac0f3eacd$var$cachedMetricsClient;
};

});
parcelRegister("50YPo", function(module, exports) {
$parcel$export(module.exports, "MetricsCollector", () => $3a6c22fbb2e9498b$export$4b62ee5120ab50a8);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $9GE8Y = parcelRequire("9GE8Y");
var $3a6c22fbb2e9498b$export$4b62ee5120ab50a8 = /*#__PURE__*/ function() {
    function MetricsCollector() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, MetricsCollector);
        // Number of events discarded due to exceeding retry limits.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "itemsDiscardedByRetry", 0);
        // Number of events created by the product in current tab.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "eventCount", 0);
        // Number of events discarded due to reaching queue max size.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "itemsDiscardedByOverflow", 0);
        // Will be used in the future when we get more resilience mechanisms
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "resilienceMechanism", (0, $9GE8Y.ResilienceMechanism).INDEXEDDB);
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "localstorageNumberOfQueuesPurged", 0);
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "localstorageNumberOfFullReclaims", 0);
        // Queue was found but not all events were able to be put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "localstorageNumberOfPartialReclaims", 0);
        // Reclaim failed for a queue and reclaim was abandonded.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "localstorageNumberOfFailedReclaims", 0);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(MetricsCollector, [
        {
            key: "addToItemsDiscardedByRetryCounter",
            value: function addToItemsDiscardedByRetryCounter() {
                var numberOfDeletedEvents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
                this.itemsDiscardedByRetry += numberOfDeletedEvents;
            }
        },
        {
            key: "addToEventCount",
            value: function addToEventCount() {
                this.eventCount++;
            }
        },
        {
            key: "addToItemsDiscardedByOverflowCounter",
            value: function addToItemsDiscardedByOverflowCounter() {
                var numberOfDeletedEvents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
                this.itemsDiscardedByOverflow += numberOfDeletedEvents;
            }
        },
        {
            key: "setResilienceMechanism",
            value: function setResilienceMechanism(mechanism) {
                this.resilienceMechanism = mechanism;
            }
        },
        {
            key: "addToReclaimMetrics",
            value: function addToReclaimMetrics(reclaimMetrics) {
                this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
                this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
                this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
            }
        },
        {
            key: "addToPurgedQueuesMetrics",
            value: function addToPurgedQueuesMetrics(numberOfQueuesPurged) {
                this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
            }
        },
        {
            key: "subtractFromMetrics",
            value: function subtractFromMetrics(sentMetrics) {
                this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
                this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
                this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
                // Localstorage specific
                this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
                this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
                this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
                this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
            }
        },
        {
            key: "subtractFromCount",
            value: function subtractFromCount(count, subtract) {
                return Math.max(count - (subtract || 0), 0);
            }
        },
        {
            key: "getMetricsPayload",
            value: function getMetricsPayload() {
                return {
                    itemsDiscardedByRetry: this.itemsDiscardedByRetry,
                    eventCount: this.eventCount,
                    itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
                    resilienceMechanism: this.resilienceMechanism,
                    // Localstorage specific
                    localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
                    fullReclaims: this.localstorageNumberOfFullReclaims,
                    partialReclaims: this.localstorageNumberOfPartialReclaims,
                    failedReclaims: this.localstorageNumberOfFailedReclaims
                };
            }
        }
    ]);
}();

});
parcelRegister("9GE8Y", function(module, exports) {
$parcel$export(module.exports, "ResilienceMechanism", () => $70d72d06700e4121$export$c75161629e3ec34e);
$parcel$export(module.exports, "NetworkStatusEnum", () => $70d72d06700e4121$export$ee138fa712d11b84);
var $70d72d06700e4121$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
var $70d72d06700e4121$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});



parcelRegister("2SiT1", function(module, exports) {
$parcel$export(module.exports, "default", () => $217f46601d89c1b6$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $9GE8Y = parcelRequire("9GE8Y");
var $217f46601d89c1b6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function NetworkStatus(networkChangeCallback) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NetworkStatus);
        this._networkChangeCallback = networkChangeCallback;
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', function() {
                return _this._networkChangeCallback((0, $9GE8Y.NetworkStatusEnum).OFFLINE);
            });
            window.addEventListener('online', function() {
                return _this._networkChangeCallback((0, $9GE8Y.NetworkStatusEnum).ONLINE);
            });
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NetworkStatus, [
        {
            key: "removeListeners",
            value: function removeListeners() {
                var _this2 = this;
                if (typeof window !== 'undefined') {
                    window.addEventListener('offline', function() {
                        return _this2._networkChangeCallback((0, $9GE8Y.NetworkStatusEnum).OFFLINE);
                    });
                    window.addEventListener('online', function() {
                        return _this2._networkChangeCallback((0, $9GE8Y.NetworkStatusEnum).ONLINE);
                    });
                }
            }
        },
        {
            key: "getNetworkStatus",
            value: function getNetworkStatus() {
                if (window.navigator.onLine) return (0, $9GE8Y.NetworkStatusEnum).ONLINE;
                return (0, $9GE8Y.NetworkStatusEnum).OFFLINE;
            }
        }
    ]);
}();

});

parcelRegister("cx5q7", function(module, exports) {
$parcel$export(module.exports, "default", () => $91fcc5723998e290$export$2e2bcd8739ae039);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $25nEq = parcelRequire("25nEq");

var $8Gucb = parcelRequire("8Gucb");

var $3efd3 = parcelRequire("3efd3");
var $91fcc5723998e290$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
var $91fcc5723998e290$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $91fcc5723998e290$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(function Scheduler(retryOptions, callback) {
    var _this = this;
    (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Scheduler);
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "schedule", function() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, immediate = _ref.immediate;
        if (typeof window === 'undefined') return;
        if (_this.operationInFlight) {
            if (immediate) _this.queuedSchedule = $91fcc5723998e290$export$8bb92baee001fc60.IMMEDIATE;
            else if (_this.queuedSchedule !== $91fcc5723998e290$export$8bb92baee001fc60.IMMEDIATE) _this.queuedSchedule = $91fcc5723998e290$export$8bb92baee001fc60.WAIT;
        // Only run immediately if we have no failures
        } else if ((immediate || _this.options.waitInterval <= 0) && _this.failureCount === 0) {
            _this.clearTimeout();
            _this.run();
        // Calculate backoff for normal or failure scenario
        } else if (_this.scheduledTimeout === null) _this.scheduledTimeout = window.setTimeout(_this.run, _this.calculateBackoff());
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "stop", function() {
        _this.clearTimeout();
        _this.queuedSchedule = $91fcc5723998e290$export$8bb92baee001fc60.NONE;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getFailureCount", function() {
        return _this.failureCount;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getCallbackStatus", function() {
        return _this.callbackTimer.getCallbackStatus();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearTimeout", function() {
        if (typeof window !== 'undefined' && _this.scheduledTimeout !== null) {
            window.clearTimeout(_this.scheduledTimeout);
            _this.scheduledTimeout = null;
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "run", function() {
        _this.operationInFlight = true;
        _this.clearTimeout();
        try {
            _this.callbackTimer.executeCallbackWithTimeout(// callback to execute
            _this.callback, // when callback completes, call this function
            _this.done, // on timeout, do this instead
            function() {
                return _this.done((0, $3efd3.DoneState).ERROR);
            });
        } catch (err) {
            _this.done(err);
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "done", function(state) {
        _this.operationInFlight = false;
        if (state === (0, $3efd3.DoneState).ERROR || _this.callbackTimer.getCallbackStatus() === (0, $8Gucb.CallbackStatus).TIMED_OUT) {
            _this.failureCount++;
            _this.clearTimeout();
        } else if (state === (0, $3efd3.DoneState).SUCCESS) _this.failureCount = 0;
        _this.processQueuedSchedule();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "processQueuedSchedule", function() {
        if (_this.queuedSchedule !== $91fcc5723998e290$export$8bb92baee001fc60.NONE) {
            var immediate = _this.queuedSchedule === $91fcc5723998e290$export$8bb92baee001fc60.IMMEDIATE;
            _this.queuedSchedule = $91fcc5723998e290$export$8bb92baee001fc60.NONE;
            _this.schedule({
                immediate: immediate
            });
        } else if (_this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
        // For example, when this.callback(this._done) was not called within
        // this.callbackTimeoutPeriod
        _this.schedule();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "calculateBackoff", function() {
        var _this$options = _this.options, minRetryDelay = _this$options.minRetryDelay, maxRetryDelay = _this$options.maxRetryDelay, backoffFactor = _this$options.backoffFactor, backoffJitterPercentage = _this$options.backoffJitterPercentage, waitInterval = _this$options.waitInterval;
        // Helper for deviation based on a single random sample
        var jitter = function jitter(base, symmetric) {
            if (!backoffJitterPercentage || base <= 0) return 0;
            var r = (Math.random() - 0.5) * 2;
            var frac = symmetric ? r : Math.abs(r);
            return Math.floor(frac * backoffJitterPercentage * base);
        };
        // No failures: wait interval with positive-only jitter
        if (_this.failureCount === 0) return waitInterval + jitter(waitInterval, false);
        // Failures: exponential backoff with symmetric jitter
        var base = Math.min(minRetryDelay * Math.pow(backoffFactor, _this.failureCount), maxRetryDelay);
        var withJitter = base + jitter(base, true);
        return Math.max(minRetryDelay, Math.min(withJitter, maxRetryDelay));
    });
    this.options = {
        minRetryDelay: retryOptions.minRetryDelay || $91fcc5723998e290$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
        maxRetryDelay: retryOptions.maxRetryDelay || $91fcc5723998e290$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
        backoffFactor: retryOptions.backoffFactor || $91fcc5723998e290$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
        backoffJitterPercentage: retryOptions.backoffJitterPercentage || $91fcc5723998e290$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
        waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $91fcc5723998e290$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
        callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $91fcc5723998e290$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
    };
    this.scheduledTimeout = null;
    this.failureCount = 0;
    this.callback = callback;
    this.operationInFlight = false;
    this.queuedSchedule = $91fcc5723998e290$export$8bb92baee001fc60.NONE;
    this.callbackTimer = new (0, $8Gucb.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
});

});
parcelRegister("8Gucb", function(module, exports) {
$parcel$export(module.exports, "CallbackStatus", () => $6529ab323cc35eef$export$ef3353088fca369c);
$parcel$export(module.exports, "CallbackWithTimeout", () => $6529ab323cc35eef$export$590a718599f8f8b3);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
var $6529ab323cc35eef$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
var $6529ab323cc35eef$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
var $6529ab323cc35eef$export$590a718599f8f8b3 = /*#__PURE__*/ function() {
    function CallbackWithTimeout(timeoutPeriod) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, CallbackWithTimeout);
        // Milliseconds to wait
        // Tracks the settimeout; so that we can clear the timeout
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "timeoutHandle", undefined);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "callbackStatus", $6529ab323cc35eef$export$ef3353088fca369c.IDLE);
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(CallbackWithTimeout, [
        {
            key: "transitionCallbackStatus",
            value: function transitionCallbackStatus(currentStatus, event) {
                switch(currentStatus){
                    case $6529ab323cc35eef$export$ef3353088fca369c.IDLE:
                    case $6529ab323cc35eef$export$ef3353088fca369c.TIMED_OUT:
                    case $6529ab323cc35eef$export$ef3353088fca369c.COMPLETED:
                        if (event === $6529ab323cc35eef$export$def7d978353eaa0.EXECUTE) this.callbackStatus = $6529ab323cc35eef$export$ef3353088fca369c.RUNNING;
                        break;
                    case $6529ab323cc35eef$export$ef3353088fca369c.RUNNING:
                        switch(event){
                            case $6529ab323cc35eef$export$def7d978353eaa0.COMPLETE:
                                this.callbackStatus = $6529ab323cc35eef$export$ef3353088fca369c.COMPLETED;
                                break;
                            case $6529ab323cc35eef$export$def7d978353eaa0.TIMEOUT:
                                this.callbackStatus = $6529ab323cc35eef$export$ef3353088fca369c.TIMED_OUT;
                                break;
                        }
                        break;
                    default:
                        this.callbackStatus = currentStatus;
                }
            }
        },
        {
            key: "executeCallbackWithTimeout",
            value: function executeCallbackWithTimeout(callback, onDone, onTimeout) {
                var _this = this;
                if (typeof window === 'undefined') return;
                this.transitionCallbackStatus(this.callbackStatus, $6529ab323cc35eef$export$def7d978353eaa0.EXECUTE);
                // Setting timeout
                this.timeoutHandle = window.setTimeout(function() {
                    _this.transitionCallbackStatus(_this.callbackStatus, $6529ab323cc35eef$export$def7d978353eaa0.TIMEOUT);
                    onTimeout();
                }, this.timeoutPeriod);
                // Executing callback
                callback(function(state) {
                    _this.cancelTimeout();
                    if (_this.getCallbackStatus() !== $6529ab323cc35eef$export$ef3353088fca369c.TIMED_OUT) {
                        _this.transitionCallbackStatus(_this.callbackStatus, $6529ab323cc35eef$export$def7d978353eaa0.COMPLETE);
                        onDone(state);
                    }
                });
            }
        },
        {
            key: "getCallbackStatus",
            value: function getCallbackStatus() {
                return this.callbackStatus;
            }
        },
        {
            key: "cancelTimeout",
            value: function cancelTimeout() {
                if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
                    window.clearTimeout(this.timeoutHandle);
                    this.timeoutHandle = undefined;
                }
            }
        }
    ]);
}();

});

parcelRegister("3efd3", function(module, exports) {
$parcel$export(module.exports, "DoneState", () => $259e7a33bf7a29f3$export$f93c40fda808dd0c);
// Clients can optionally provide the callbackTimeoutPeriod parameter
var $259e7a33bf7a29f3$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("acFLR", function(module, exports) {
$parcel$export(module.exports, "attachXidToMultipleEvents", () => $76db6d310b8b4afb$export$c21270cab66ab290);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $vZHup = parcelRequire("vZHup");
function $76db6d310b8b4afb$export$c21270cab66ab290(_x, _x2) {
    return $76db6d310b8b4afb$var$_attachXidToMultipleEvents.apply(this, arguments);
}
function $76db6d310b8b4afb$var$_attachXidToMultipleEvents() {
    $76db6d310b8b4afb$var$_attachXidToMultipleEvents = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(items, xidItemPromiseCallback) {
        var xidCallback, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.prev = 0;
                    _context.next = 1;
                    return xidItemPromiseCallback;
                case 1:
                    xidCallback = _context.sent;
                    return _context.abrupt("return", items.map(function(item) {
                        return (0, $vZHup.attachXidToSingleEvent)(item, xidCallback);
                    }));
                case 2:
                    _context.prev = 2;
                    _t = _context["catch"](0);
                    return _context.abrupt("return", items);
                case 3:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                0,
                2
            ]
        ]);
    }));
    return $76db6d310b8b4afb$var$_attachXidToMultipleEvents.apply(this, arguments);
}

});
parcelRegister("vZHup", function(module, exports) {
$parcel$export(module.exports, "attachXidToSingleEvent", () => $0602c1c9bcdffe46$export$c9c3aaf655d6f275);

var $25nEq = parcelRequire("25nEq");

var $5pjnf = parcelRequire("5pjnf");
function $0602c1c9bcdffe46$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0602c1c9bcdffe46$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0602c1c9bcdffe46$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0602c1c9bcdffe46$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0602c1c9bcdffe46$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $5pjnf.SegmentEventTypes).PAGE || item.msg.type === (0, $5pjnf.SegmentEventTypes).TRACK) {
        var xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = $0602c1c9bcdffe46$var$_objectSpread($0602c1c9bcdffe46$var$_objectSpread({}, item.msg.properties), {}, {
            xid: xid
        });
    } else if (item.msg.traits && item.msg.type === (0, $5pjnf.SegmentEventTypes).IDENTIFY) {
        var _xid = xidCallback();
        if (_xid && Array.isArray(_xid)) item.msg.traits = $0602c1c9bcdffe46$var$_objectSpread($0602c1c9bcdffe46$var$_objectSpread({}, item.msg.traits), {}, {
            xid: _xid
        });
    }
    return item;
}

});
parcelRegister("5pjnf", function(module, exports) {
$parcel$export(module.exports, "SegmentEventTypes", () => $3efe50d51d84d6fc$export$ddf929981dc6feb3);
$parcel$export(module.exports, "ALLOW_LISTED_FETCH_ERROR_NAMES", () => $3efe50d51d84d6fc$export$96f086dcf574a9e2);
// Segment event types copied from our backend
// https://bitbucket.org/atlassian/analytics-service/src/master/api/src/main/java/com/atlassian/dataservices/analytics/service/api/segment/
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $3efe50d51d84d6fc$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    // Dont need Screen as page and screen are the same and we only use page
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
var $3efe50d51d84d6fc$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
var $3efe50d51d84d6fc$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});
var $3efe50d51d84d6fc$export$96f086dcf574a9e2 = [
    'FetchError',
    'AbortError',
    'TypeError'
];

});



parcelRegister("cHKVx", function(module, exports) {
$parcel$export(module.exports, "AnalyticsResponse", () => $93fde6e60f95bd45$export$133650fcdde1b226);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");
var $93fde6e60f95bd45$export$133650fcdde1b226 = /*#__PURE__*/ function() {
    function AnalyticsResponse(success, statusCode, message, eventResponseList) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsResponse);
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsResponse, [
        {
            key: "isSuccess",
            value: function isSuccess() {
                return this.success;
            }
        },
        {
            key: "getStatusCode",
            value: function getStatusCode() {
                return this.statusCode;
            }
        },
        {
            key: "getMessage",
            value: function getMessage() {
                return this.message;
            }
        },
        {
            key: "getEventResponseList",
            value: function getEventResponseList() {
                return this.eventResponseList;
            }
        }
    ]);
}();

});

parcelRegister("o1t1Z", function(module, exports) {
$parcel$export(module.exports, "buildContext", () => $0483615eaa710c8d$export$3a7fe28f9bf4f3d9);

var $25nEq = parcelRequire("25nEq");

var $4ZNSA = parcelRequire("4ZNSA");
function $0483615eaa710c8d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0483615eaa710c8d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0483615eaa710c8d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0483615eaa710c8d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Shallow removal of all falsey properties from an object, returning a new object.
var $0483615eaa710c8d$var$removeFalseyProperties = function removeFalseyProperties(obj) {
    var result = {};
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) // If the value is not strictly true, map it to undefined
        {
            if (obj[key]) result[key] = obj[key];
        }
    }
    return result;
};
var $0483615eaa710c8d$export$3a7fe28f9bf4f3d9 = function buildContext(context, overrides) {
    var result = $0483615eaa710c8d$var$_objectSpread($0483615eaa710c8d$var$_objectSpread({}, context.context), {}, {
        userAgent: navigator.userAgent
    });
    // use nestedRemoveUndefinedValues to strip undefined properties before
    // spreading the override object since we want properties that explicitly
    // set to 'undefined' to not overwrite any values, just like properties
    // that are 'undefined' because they're not set at all will.
    if (overrides !== null && overrides !== void 0 && overrides.excludedProperties) result.excludedProperties = $0483615eaa710c8d$var$_objectSpread($0483615eaa710c8d$var$_objectSpread({}, result.excludedProperties), (0, $4ZNSA.nestedRemoveUndefinedValues)(overrides.excludedProperties, '$.excludedProperties'));
    if (overrides !== null && overrides !== void 0 && overrides.userConsents) result.userConsents = $0483615eaa710c8d$var$_objectSpread($0483615eaa710c8d$var$_objectSpread({}, result.userConsents), (0, $4ZNSA.nestedRemoveUndefinedValues)(overrides.userConsents, '$.userConsents'));
    // Remove any falsey properties since we only want to have exclusions
    // that were explicitly declared as excluded.
    if (result.excludedProperties) result.excludedProperties = $0483615eaa710c8d$var$removeFalseyProperties(result.excludedProperties);
    return result;
};

});
parcelRegister("4ZNSA", function(module, exports) {
$parcel$export(module.exports, "nestedRemoveUndefinedValues", () => $3a338cf2d1e795da$export$2250ccecd1e040fd);

var $ekGgq = parcelRequire("ekGgq");
// This function will essentially deepClone as well
var $3a338cf2d1e795da$export$2250ccecd1e040fd = function nestedRemoveUndefinedValues(obj, path) {
    var recursionDepthLimit = 512;
    var _nestedRemoveUndefinedValuesImpl = function nestedRemoveUndefinedValuesImpl(source, processedReferences, path, depth) {
        if (source === null || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(source) !== 'object') return source;
        // If the level of nesting is egregiously excessive we'll stop processing any further to
        // avoid crashing due to stack exhaustion, instead we return a note object.
        if (depth > recursionDepthLimit) return {
            _depthLimitExceeded: true,
            message: "Object nesting depth limit exceeded at path '".concat(path, "' with depth '").concat(depth, "'")
        };
        // If this object has already been seen then processing it would create a circular reference,
        // instead we return a note object.
        if (processedReferences.has(source)) {
            var originalPath = processedReferences.get(source);
            return {
                _circularReference: true,
                message: "Circular reference to object at original path '".concat(originalPath, "' detected at path '").concat(path, "'"),
                originalPath: originalPath
            };
        }
        processedReferences.set(source, path);
        var clone = {};
        Object.keys(source).forEach(function(key) {
            var value = source[key];
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    var newArray = [];
                    value.forEach(function(v, i) {
                        var newValue = _nestedRemoveUndefinedValuesImpl(v, processedReferences, "".concat(path, ".").concat(key, "[").concat(i, "]"), depth + 1);
                        if (newValue !== undefined) newArray.push(newValue);
                    });
                    clone[key] = newArray;
                } else {
                    var newValue = _nestedRemoveUndefinedValuesImpl(value, processedReferences, "".concat(path, ".").concat(key), depth + 1);
                    if (newValue !== undefined) clone[key] = newValue;
                }
            }
        });
        processedReferences.delete(source);
        return clone;
    };
    return _nestedRemoveUndefinedValuesImpl(obj, new Map(), path, 0);
};

});


parcelRegister("bJ6Ic", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", () => $88991a89387117c8$export$9175ce0e1c95daf2);
$parcel$export(module.exports, "DEFAULT_METADATA_REQUEST_TIMEOUT", () => $88991a89387117c8$export$8fddcd1eff390364);
$parcel$export(module.exports, "DEFAULT_METADATA_REFRESH_INTERVAL", () => $88991a89387117c8$export$92ed669a3d41dad3);
$parcel$export(module.exports, "DEFAULT_METADATA_MIN_RETRY_DELAY", () => $88991a89387117c8$export$6649d5c857717efe);
$parcel$export(module.exports, "DEFAULT_METADATA_MAX_RETRY_DELAY", () => $88991a89387117c8$export$33e7628d3b2c0e2);
$parcel$export(module.exports, "DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL", () => $88991a89387117c8$export$6f1c008dd0c3b67e);
var $88991a89387117c8$export$9175ce0e1c95daf2 = 10000; // 10 seconds
var $88991a89387117c8$export$8fddcd1eff390364 = 60000; // 60 seconds
var $88991a89387117c8$export$92ed669a3d41dad3 = 600000; // 10 minutes
var $88991a89387117c8$export$6649d5c857717efe = 5000; // 5 seconds
var $88991a89387117c8$export$33e7628d3b2c0e2 = 3600000; // 60 minutes
var $88991a89387117c8$export$6f1c008dd0c3b67e = 10; // 10 milliseconds

});

parcelRegister("9vzfq", function(module, exports) {
$parcel$export(module.exports, "EventResponse", () => $6ec259c712435776$export$51e0b986fdbf3840);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");
var $6ec259c712435776$export$51e0b986fdbf3840 = /*#__PURE__*/ function() {
    function EventResponse(messageId, results, segmentEvent) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, EventResponse);
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(EventResponse, [
        {
            key: "getMessageId",
            value: function getMessageId() {
                return this.messageId;
            }
        },
        {
            key: "getResults",
            value: function getResults() {
                return this.results;
            }
        },
        {
            key: "getSegmentEvent",
            value: function getSegmentEvent() {
                return this.segmentEvent;
            }
        }
    ]);
}();

});

parcelRegister("c8Y37", function(module, exports) {
$parcel$export(module.exports, "FetchError", () => $8d74cff4d55c4f44$export$26e841bcf1aeb894);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $8d74cff4d55c4f44$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $8d74cff4d55c4f44$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $8d74cff4d55c4f44$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($8d74cff4d55c4f44$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $8d74cff4d55c4f44$export$26e841bcf1aeb894 = /*#__PURE__*/ function(_Error) {
    function FetchError(message, statusCode, statusText) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FetchError);
        _this = $8d74cff4d55c4f44$var$_callSuper(this, FetchError, [
            message
        ]);
        _this.statusCode = statusCode;
        _this.statusText = statusText;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(FetchError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FetchError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});

parcelRegister("HBXCt", function(module, exports) {
$parcel$export(module.exports, "HTTP_STATUS_CODE_MAP", () => $08317673ed014342$export$ba118f9de1e5ac63);
var $08317673ed014342$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);

});

parcelRegister("hL0G3", function(module, exports) {
$parcel$export(module.exports, "LastError", () => $ced759ee3c9667b9$export$a63e16b3351b8c36);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $c8Y37 = parcelRequire("c8Y37");
var $ced759ee3c9667b9$export$a63e16b3351b8c36 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(function LastError(reason, error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, LastError);
    this.reason = reason;
    this.message = error instanceof Error ? error.message : null;
    this.statusCode = error instanceof (0, $c8Y37.FetchError) ? error.statusCode : null;
});

});

parcelRegister("3I9pn", function(module, exports) {
$parcel$export(module.exports, "prepareEventContext", () => $2b3cc7703d365242$export$6b26e26d40264200);
// @ts-ignore

var $dMCb6 = parcelRequire("dMCb6");

var $4ZNSA = parcelRequire("4ZNSA");
var $2b3cc7703d365242$export$6b26e26d40264200 = function prepareEventContext(context) {
    var propertiesWithoutUndefined = (0, $4ZNSA.nestedRemoveUndefinedValues)(context, '$.context');
    return (0, (/*@__PURE__*/$parcel$interopDefault($dMCb6)))(propertiesWithoutUndefined);
};

});
parcelRegister("dMCb6", function(module, exports) {
'use strict';

var $6so8c = parcelRequire("6so8c");
/**
 * Expose `traverse`.
 */ module.exports = $a08d5f71a1a1eb97$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $a08d5f71a1a1eb97$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === 'object') return $a08d5f71a1a1eb97$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $a08d5f71a1a1eb97$var$traverseArray(input, strict);
    else if ($6so8c.is(input, strict)) return $6so8c.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $a08d5f71a1a1eb97$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $a08d5f71a1a1eb97$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $a08d5f71a1a1eb97$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $a08d5f71a1a1eb97$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("6so8c", function(module, exports) {
$parcel$export(module.exports, "parse", () => $4b381390c1569522$export$98e6a39c04603d36, (v) => $4b381390c1569522$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "is", () => $4b381390c1569522$export$226b3eccf92c9ed9, (v) => $4b381390c1569522$export$226b3eccf92c9ed9 = v);
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $4b381390c1569522$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $4b381390c1569522$export$226b3eccf92c9ed9;
'use strict';
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $4b381390c1569522$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$4b381390c1569522$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $4b381390c1569522$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === ' ') offset = new Date().getTimezoneOffset();
    else if (arr[9] !== 'Z' && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === '+') offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$4b381390c1569522$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== 'string') return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $4b381390c1569522$var$matcher.test(string);
};

});



parcelRegister("zYlx7", function(module, exports) {
$parcel$export(module.exports, "prepareEventProperties", () => $06c21484e05d2894$export$44d22e5fb02cc68e);
// @ts-ignore

var $dMCb6 = parcelRequire("dMCb6");

var $4ZNSA = parcelRequire("4ZNSA");
var $06c21484e05d2894$export$44d22e5fb02cc68e = function prepareEventProperties(properties) {
    var propertiesWithoutUndefined = (0, $4ZNSA.nestedRemoveUndefinedValues)(properties, '$.properties');
    // Remove any override properties that shouldn't be included in the event body
    delete propertiesWithoutUndefined.excludedProperties;
    delete propertiesWithoutUndefined.userConsents;
    return (0, (/*@__PURE__*/$parcel$interopDefault($dMCb6)))(propertiesWithoutUndefined);
};

});

parcelRegister("amec4c", function(module, exports) {
$parcel$export(module.exports, "sendEvents", () => $78a6f802f57c0600$export$8e8f0180c1b41fad);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $cvlyC = parcelRequire("cvlyC");

var $c8Y37 = parcelRequire("c8Y37");
function $78a6f802f57c0600$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $78a6f802f57c0600$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $78a6f802f57c0600$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $78a6f802f57c0600$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $78a6f802f57c0600$export$8e8f0180c1b41fad = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(options) {
        var _createOrGetAbortCont;
        var signal, corsOptions, response, responseBody, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    signal = (_createOrGetAbortCont = $78a6f802f57c0600$var$createOrGetAbortController(options)) === null || _createOrGetAbortCont === void 0 ? void 0 : _createOrGetAbortCont.signal;
                    corsOptions = $78a6f802f57c0600$var$getCorsForUrl(options.url);
                    _context.next = 1;
                    return fetch(options.url, $78a6f802f57c0600$var$_objectSpread({
                        method: 'POST',
                        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
                        headers: {
                            'Content-Type': 'text/plain'
                        },
                        body: JSON.stringify(options.batch),
                        signal: signal
                    }, corsOptions));
                case 1:
                    response = _context.sent;
                    if (!(response.status !== 200)) {
                        _context.next = 2;
                        break;
                    }
                    throw new (0, $c8Y37.FetchError)("HTTP Error ".concat(response.status, " (").concat(response.statusText, ")"), response.status, response.statusText);
                case 2:
                    _context.prev = 2;
                    _context.next = 3;
                    return response.clone().json();
                case 3:
                    responseBody = _context.sent;
                    if (!(responseBody.success === true)) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return", response);
                case 4:
                    _context.next = 6;
                    break;
                case 5:
                    _context.prev = 5;
                    _t = _context["catch"](2);
                case 6:
                    throw new (0, $c8Y37.FetchError)('Invalid HTTP Response (Invalid response body)', 200, 'Invalid response body');
                case 7:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                2,
                5
            ]
        ]);
    }));
    return function sendEvents(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $78a6f802f57c0600$var$createOrGetAbortController = function createOrGetAbortController(options) {
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        var abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(function() {
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
    return undefined;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
var $78a6f802f57c0600$var$getCorsForUrl = (0, $cvlyC.default)(function(url) {
    var origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});

parcelRegister("lhwNW", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7e4a1cbd6920661$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $gZAUI = parcelRequire("gZAUI");

var $hel6R = parcelRequire("hel6R");

var $kN8x2 = parcelRequire("kN8x2");

var $jc2hJ = parcelRequire("jc2hJ");

var $1Ygrk = parcelRequire("1Ygrk");
// Cookie is stale, if anonymousId was generated 7 days ago.
var $f7e4a1cbd6920661$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
var $f7e4a1cbd6920661$var$SAFE = 'SAFE';
var $f7e4a1cbd6920661$var$UNSAFE = 'UNSAFE';
var $f7e4a1cbd6920661$var$NOT_FOUND = 'NOT_FOUND';
var $f7e4a1cbd6920661$var$COOKIE = 'COOKIE';
var $f7e4a1cbd6920661$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
var $f7e4a1cbd6920661$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function User(disableCookiePersistence) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, User);
        this.store = new (0, $jc2hJ.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $kN8x2.default)(disableCookiePersistence);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(User, [
        {
            key: "getUserId",
            value: function getUserId() {
                return this.userId || null;
            }
        },
        {
            key: "setUserId",
            value: function setUserId(userId) {
                this.userId = userId;
            }
        },
        {
            key: "getAnonymousId",
            value: function getAnonymousId(customAnonymousIdGenerator) {
                /**
       * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
       * If not set in localStorage, check cookies. Also set localStorage for future attempts.
       * If not in cookies, generate a new one. Set both cookie and localStorage keys.
       */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
            }
        },
        {
            key: "setAnonymousId",
            value: function setAnonymousId(anonymousId) {
                var stringifyAnonymosId = JSON.stringify(anonymousId);
                this.cookie.set((0, $hel6R.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
                this.lastAnonymousIdCookieUpdate = Date.now();
                return this.store.setItem((0, $hel6R.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
            }
        },
        {
            key: "getAnonymousIdFromStorage",
            value: function getAnonymousIdFromStorage(source) {
                var rawStorageAnonidValue = source === $f7e4a1cbd6920661$var$LOCAL_STORAGE ? this.store.getItem((0, $hel6R.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $hel6R.AWCCookiesKeys).AJS_ANONYMOUS_ID);
                if (rawStorageAnonidValue) {
                    var unsafeValue = {
                        type: $f7e4a1cbd6920661$var$UNSAFE,
                        anonymousId: rawStorageAnonidValue
                    };
                    try {
                        var parsedAnonId = JSON.parse(rawStorageAnonidValue);
                        if (parsedAnonId && typeof parsedAnonId === 'string') return {
                            type: $f7e4a1cbd6920661$var$SAFE,
                            anonymousId: parsedAnonId
                        };
                        return unsafeValue;
                    } catch (_unused) {
                        /*
           * Segments new Analytics-next client will store strings as strings without stringifing.
           * The legacy Segment client and AWC always stringify and parse cookies and values.
           * If the new Segment analytics-client stores a cookie and local storage value first, it will
           * breaking old clients.
           *
           * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
           *
           * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
           */ return unsafeValue;
                    }
                }
                return {
                    type: $f7e4a1cbd6920661$var$NOT_FOUND
                };
            }
        },
        {
            key: "getAnonymousIdFromLocalStorageAndUpdateCookieIfStale",
            value: function getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
                var localStorageValue = this.getAnonymousIdFromStorage($f7e4a1cbd6920661$var$LOCAL_STORAGE);
                var shouldUpdateCookie = false;
                if (!this.lastAnonymousIdCookieUpdate || (0, $gZAUI.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $f7e4a1cbd6920661$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
                switch(localStorageValue.type){
                    case $f7e4a1cbd6920661$var$SAFE:
                        if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                        return localStorageValue.anonymousId;
                    case $f7e4a1cbd6920661$var$UNSAFE:
                        return localStorageValue.anonymousId;
                    case $f7e4a1cbd6920661$var$NOT_FOUND:
                    default:
                        return null;
                }
            }
        },
        {
            key: "getAnonymousIdFromCookieAndUpdateLocalStorage",
            value: function getAnonymousIdFromCookieAndUpdateLocalStorage() {
                var cookieValue = this.getAnonymousIdFromStorage($f7e4a1cbd6920661$var$COOKIE);
                switch(cookieValue.type){
                    case $f7e4a1cbd6920661$var$SAFE:
                    case $f7e4a1cbd6920661$var$UNSAFE:
                        this.store.setItem((0, $hel6R.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                        return cookieValue.anonymousId;
                    case $f7e4a1cbd6920661$var$NOT_FOUND:
                    default:
                        return null;
                }
            }
        },
        {
            key: "generateNewAnonymousId",
            value: function generateNewAnonymousId(customAnonymousIdGenerator) {
                var generator = typeof customAnonymousIdGenerator === 'function' ? customAnonymousIdGenerator : function() {
                    return (0, $1Ygrk.default)();
                };
                var newAnonId = generator();
                this.setAnonymousId(newAnonId);
                return newAnonId;
            }
        }
    ]);
}();

});
parcelRegister("gZAUI", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5eefa24cee0d464$export$2e2bcd8739ae039);

var $aZMy3 = parcelRequire("aZMy3");

var $TYEI2 = parcelRequire("TYEI2");

var $4TrOW = parcelRequire("4TrOW");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $c5eefa24cee0d464$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $c5eefa24cee0d464$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4TrOW.default)(2, arguments);
    var dateLeft = (0, $aZMy3.default)(dirtyDateLeft);
    var dateRight = (0, $aZMy3.default)(dirtyDateRight);
    var sign = $c5eefa24cee0d464$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $TYEI2.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($c5eefa24cee0d464$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("aZMy3", function(module, exports) {
$parcel$export(module.exports, "default", () => $80154294055fc0be$export$2e2bcd8739ae039);

var $4bFFZ = parcelRequire("4bFFZ");

var $4TrOW = parcelRequire("4TrOW");
function $80154294055fc0be$export$2e2bcd8739ae039(argument) {
    (0, $4TrOW.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $4bFFZ.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("4TrOW", function(module, exports) {
$parcel$export(module.exports, "default", () => $3901e111ba7236f6$export$2e2bcd8739ae039);
function $3901e111ba7236f6$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});


parcelRegister("TYEI2", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a84301ba1ee0b49$export$2e2bcd8739ae039);

var $cZw4L = parcelRequire("cZw4L");

var $dziQx = parcelRequire("dziQx");

var $4TrOW = parcelRequire("4TrOW");
var $0a84301ba1ee0b49$var$MILLISECONDS_IN_DAY = 86400000;
function $0a84301ba1ee0b49$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4TrOW.default)(2, arguments);
    var startOfDayLeft = (0, $dziQx.default)(dirtyDateLeft);
    var startOfDayRight = (0, $dziQx.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $cZw4L.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $cZw4L.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $0a84301ba1ee0b49$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("cZw4L", function(module, exports) {
$parcel$export(module.exports, "default", () => $975410219190d432$export$2e2bcd8739ae039);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $975410219190d432$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("dziQx", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e0d29bdc51e5637$export$2e2bcd8739ae039);

var $aZMy3 = parcelRequire("aZMy3");

var $4TrOW = parcelRequire("4TrOW");
function $9e0d29bdc51e5637$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4TrOW.default)(1, arguments);
    var date = (0, $aZMy3.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("hel6R", function(module, exports) {
$parcel$export(module.exports, "AWCCookiesKeys", () => $c8b41e64c5f9315f$export$202d555a5dbfd90c);
$parcel$export(module.exports, "AllAnalyticsCookies", () => $c8b41e64c5f9315f$export$d4cb17942ea57c95);

var $25nEq = parcelRequire("25nEq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");
var $c8b41e64c5f9315f$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
var $c8b41e64c5f9315f$var$CookieSchema = /*#__PURE__*/ function() {
    function CookieSchema(key, options) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, CookieSchema);
        this.key = key;
        this.options = options;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(CookieSchema, [
        {
            key: "getAttributes",
            value: function getAttributes() {
                return this.options;
            }
        },
        {
            key: "getKey",
            value: function getKey() {
                return this.key;
            }
        }
    ]);
}();
var $c8b41e64c5f9315f$var$isSecure = function isSecure() {
    try {
        return globalThis && globalThis.location && globalThis.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
var $c8b41e64c5f9315f$export$d4cb17942ea57c95 = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $c8b41e64c5f9315f$export$202d555a5dbfd90c.AWC_TLD_TEST, new $c8b41e64c5f9315f$var$CookieSchema('__awc_tld_test__', {
    expires: 365,
    secure: $c8b41e64c5f9315f$var$isSecure(),
    path: '/'
})), $c8b41e64c5f9315f$export$202d555a5dbfd90c.AWC_ANALYTICS_DEBUG, new $c8b41e64c5f9315f$var$CookieSchema('atlassian_analytics_debug', {
    expires: 365,
    secure: $c8b41e64c5f9315f$var$isSecure(),
    path: '/'
})), $c8b41e64c5f9315f$export$202d555a5dbfd90c.AJS_ANONYMOUS_ID, new $c8b41e64c5f9315f$var$CookieSchema('ajs_anonymous_id', {
    expires: 365,
    secure: $c8b41e64c5f9315f$var$isSecure(),
    path: '/'
}));

});

parcelRegister("kN8x2", function(module, exports) {
$parcel$export(module.exports, "default", () => $f22f007bc4ca3f5c$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $bDLqY = parcelRequire("bDLqY");

var $hel6R = parcelRequire("hel6R");

var $dd4rW = parcelRequire("dd4rW");

var $k6Fyl = parcelRequire("k6Fyl");
function $f22f007bc4ca3f5c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f22f007bc4ca3f5c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f22f007bc4ca3f5c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f22f007bc4ca3f5c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f22f007bc4ca3f5c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function CookieWrapper(disableCookiePersistence) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, CookieWrapper);
        this.cookieLike = (0, $k6Fyl.canUseCookie)(disableCookiePersistence) ? (0, (/*@__PURE__*/$parcel$interopDefault($bDLqY))) : new (0, $dd4rW.default)();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(CookieWrapper, [
        {
            key: "set",
            value: function set(name, value, options) {
                // no-op
                if (!(0, $hel6R.AllAnalyticsCookies)[name]) {
                    // eslint-disable-next-line no-console
                    console.warn("Unknown cookie key ".concat(name, " provided, not set."));
                    return;
                }
                return this.cookieLike.set((0, $hel6R.AllAnalyticsCookies)[name].getKey(), value, $f22f007bc4ca3f5c$var$_objectSpread($f22f007bc4ca3f5c$var$_objectSpread({}, (0, $hel6R.AllAnalyticsCookies)[name].getAttributes()), {}, {
                    // Function is memoized so we only calculate this once per page load
                    domain: (0, $k6Fyl.getTld)()
                }, options));
            }
        },
        {
            key: "get",
            value: function get(name) {
                if (!(0, $hel6R.AllAnalyticsCookies)[name]) {
                    // eslint-disable-next-line no-console
                    console.warn("Unknown cookie key ".concat(name, " provided, not fetched."));
                    return;
                }
                return this.cookieLike.get((0, $hel6R.AllAnalyticsCookies)[name].getKey());
            }
        },
        {
            key: "remove",
            value: function remove(name, options) {
                if (!(0, $hel6R.AllAnalyticsCookies)[name]) {
                    // eslint-disable-next-line no-console
                    console.warn("Unknown cookie key ".concat(name, " provided, not removed."));
                    return;
                }
                this.cookieLike.remove((0, $hel6R.AllAnalyticsCookies)[name].getKey(), $f22f007bc4ca3f5c$var$_objectSpread({}, options));
            }
        }
    ]);
}();

});
parcelRegister("bDLqY", function(module, exports) {
/*! js-cookie v3.0.8 | MIT */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (key === '__proto__') continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    if (!(found in jar)) jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (_e) {
                // Do nothing...
                }
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    return api;
});

});

parcelRegister("dd4rW", function(module, exports) {
$parcel$export(module.exports, "default", () => $99dff0dfd76e6218$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $jc2hJ = parcelRequire("jc2hJ");
var $99dff0dfd76e6218$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function LocalStorageAlt() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, LocalStorageAlt);
        this.safeStorage = new (0, $jc2hJ.default)({
            useStoragePrefix: false
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(LocalStorageAlt, [
        {
            key: "set",
            value: function set(name, value) {
                this.safeStorage.setItem(name, value);
                return value;
            }
        },
        {
            key: "get",
            value: function get(name) {
                var value = this.safeStorage.getItem(name);
                return value || undefined;
            }
        },
        {
            key: "remove",
            value: function remove(name) {
                this.safeStorage.removeItem(name);
            }
        }
    ]);
}();

});
parcelRegister("jc2hJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $df90e90c3af4c162$export$2e2bcd8739ae039);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $eXTjr = parcelRequire("eXTjr");

var $5eu7g = parcelRequire("5eu7g");
function $df90e90c3af4c162$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $df90e90c3af4c162$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $df90e90c3af4c162$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($df90e90c3af4c162$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
// eslint-disable-next-line import/no-anonymous-default-export
var $df90e90c3af4c162$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_SafeStorage) {
    function _default(options) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, _default);
        var storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = globalThis.localStorage || (0, $eXTjr.default);
        } catch (err) {
            storageToUse = (0, $eXTjr.default);
        }
        return $df90e90c3af4c162$var$_callSuper(this, _default, [
            storageToUse,
            options
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(_default, _SafeStorage);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(_default);
}((0, $5eu7g.default));

});
parcelRegister("eXTjr", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae517b47e306f68f$export$2e2bcd8739ae039);

var $fGVRK = parcelRequire("fGVRK");
// eslint-disable-next-line import/no-anonymous-default-export
var $ae517b47e306f68f$var$inmemorystorage = new (0, $fGVRK.InMemoryStore)();
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$ae517b47e306f68f$export$2e2bcd8739ae039 = $ae517b47e306f68f$var$inmemorystorage;

});
parcelRegister("fGVRK", function(module, exports) {
$parcel$export(module.exports, "InMemoryStore", () => $b6c7aa36770a96ec$export$90e3e001bcac59c7);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $25nEq = parcelRequire("25nEq");
var $b6c7aa36770a96ec$export$90e3e001bcac59c7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(function InMemoryStore() {
    var _this = this;
    (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, InMemoryStore);
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_data", {});
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "length", 0);
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setItem", function(key, value) {
        _this._data[key] = value;
        _this.length = Object.keys(_this._data).length;
        return value;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getItem", function(key) {
        if (key in _this._data) return _this._data[key];
        return null;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "removeItem", function(key) {
        if (key in _this._data) delete _this._data[key];
        _this.length = Object.keys(_this._data).length;
        return null;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clear", function() {
        _this._data = {};
        _this.length = 0;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "key", function(index) {
        return Object.keys(_this._data)[index];
    });
});

});


parcelRegister("5eu7g", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cf59f0615ba9877$export$2e2bcd8739ae039);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $25nEq = parcelRequire("25nEq");

var $dpXUu = parcelRequire("dpXUu");

var $eXTjr = parcelRequire("eXTjr");

var $kxxHr = parcelRequire("kxxHr");
var $3cf59f0615ba9877$export$41c06fdd37b7e9a5 = 'awc';
var $3cf59f0615ba9877$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $3cf59f0615ba9877$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(function SafeStorage(storageToUse) {
    var _this = this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, SafeStorage);
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getStore", function() {
        return _this._store;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getItem", function(key) {
        return _this._store.getItem(_this.createKey(key));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "removeItem", function(key) {
        return _this._store.removeItem(_this.createKey(key));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setItem", function(key, value) {
        try {
            _this._store.setItem(_this.createKey(key), value);
        } catch (err) {
            // Theoretically should only be QuotaExceededError, but keeping 'err' generic
            // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
            _this.swapToInMemory();
            _this._store.setItem(_this.createKey(key), value);
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "swapToInMemory", function() {
        if (_this._store === (0, $eXTjr.default) || typeof globalThis === 'undefined') return;
        var keys = Object.keys(_this._store || {});
        var inMemoryStorage;
        if ((0, $kxxHr.isSupported)(globalThis[$3cf59f0615ba9877$export$770aa8bc07b3de03])) inMemoryStorage = globalThis[$3cf59f0615ba9877$export$770aa8bc07b3de03];
        else {
            inMemoryStorage = (0, $eXTjr.default);
            if (!globalThis[$3cf59f0615ba9877$export$770aa8bc07b3de03]) // If not already attached to globalThis then attach our instance of InMemoryStorage
            // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
            // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
            globalThis[$3cf59f0615ba9877$export$770aa8bc07b3de03] = (0, $eXTjr.default);
        }
        keys.forEach(function(key) {
            if (key.indexOf(_this.getPrefix()) === 0) {
                var value = _this._store.getItem(key);
                if (value) inMemoryStorage.setItem(key, value);
            }
        });
        _this._store = inMemoryStorage;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clear", function() {
        return _this._store.clear();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "key", function(index) {
        return _this._store.key(index);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getPrefix", function() {
        return _this._prefix;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "createKey", function(key) {
        if (_this._prefix) return "".concat(_this.getPrefix(), ".").concat(key);
        return key;
    });
    this.options = options;
    var prefixes = [];
    if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($3cf59f0615ba9877$export$41c06fdd37b7e9a5);
    if (options.envPrefix && options.envPrefix !== (0, $dpXUu.envType).PROD) prefixes.push(options.envPrefix);
    this._prefix = prefixes.join('-');
    if ((0, $kxxHr.isSupported)(storageToUse)) this._store = storageToUse;
    else this.swapToInMemory();
});

});
parcelRegister("kxxHr", function(module, exports) {
$parcel$export(module.exports, "isSupported", () => $ef4107c8056f0789$export$48c17662a6902497);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $ef4107c8056f0789$export$48c17662a6902497(store) {
    var TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        var key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        var value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}

});




parcelRegister("k6Fyl", function(module, exports) {
$parcel$export(module.exports, "canUseCookie", () => $ea3499c14649495b$export$a9330601ee8f4d95);
$parcel$export(module.exports, "getTld", () => $ea3499c14649495b$export$de6821eed3d5f32d);

var $bDLqY = parcelRequire("bDLqY");

var $cvlyC = parcelRequire("cvlyC");

var $hel6R = parcelRequire("hel6R");
var $ea3499c14649495b$export$a9330601ee8f4d95 = function canUseCookie() {
    var disableCookiePersistence = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
var $ea3499c14649495b$export$eb80e1beaa8dacf8 = (0, $hel6R.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
var $ea3499c14649495b$export$19164982d36535d8 = 'tld_test';
var $ea3499c14649495b$export$de6821eed3d5f32d = (0, $cvlyC.default)(function() {
    if (typeof location === 'undefined') return '';
    var _location = location, hostname = _location.hostname;
    var splitHostname = hostname.split('.');
    for(var i = 1; i <= splitHostname.length; i++){
        var domainParts = splitHostname.slice(i * -1);
        var domain = ".".concat(domainParts.join('.'));
        (0, (/*@__PURE__*/$parcel$interopDefault($bDLqY))).set($ea3499c14649495b$export$eb80e1beaa8dacf8, $ea3499c14649495b$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($bDLqY))).get($ea3499c14649495b$export$eb80e1beaa8dacf8) === $ea3499c14649495b$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bDLqY))).remove($ea3499c14649495b$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});




parcelRegister("89ZKV", function(module, exports) {
$parcel$export(module.exports, "MetadataClient", () => $5f0f1169c182c3a3$export$1ac223ae496131c9);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $gE0et = parcelRequire("gE0et");

var $2SiT1 = parcelRequire("2SiT1");

var $3zQGx = parcelRequire("3zQGx");

var $cx5q7 = parcelRequire("cx5q7");

var $3efd3 = parcelRequire("3efd3");

var $9GE8Y = parcelRequire("9GE8Y");

var $kqsXa = parcelRequire("kqsXa");

var $bJ6Ic = parcelRequire("bJ6Ic");

var $c8Y37 = parcelRequire("c8Y37");

var $3LjAy = parcelRequire("3LjAy");

var $4ra9w = parcelRequire("4ra9w");

var $5pjnf = parcelRequire("5pjnf");
var $5f0f1169c182c3a3$var$_MetadataClient;
function $5f0f1169c182c3a3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5f0f1169c182c3a3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5f0f1169c182c3a3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5f0f1169c182c3a3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5f0f1169c182c3a3$export$1ac223ae496131c9 = /*#__PURE__*/ function() {
    function MetadataClient(apiHostProtocol, apiHost, product) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, MetadataClient);
        this._userInfo = {
            anonymousId: ''
        };
        this._tenantInfo = {};
        this._url = "".concat(apiHostProtocol, "://").concat(apiHost, "/metadata");
        this._product = product;
        this._metadataInfo = null;
        this._requestStatus = 'PENDING';
        this._lastFetchRequestCount = 0;
        this._lastErrorReason = null;
        this._fetchAbortController = null;
        this._hasBeenStopped = false;
        this._isEnabled = false;
        this._propertyChangeRefreshTimeout = null;
        var isStargateProxy = (0, $gE0et.isStargateProxyPath)({
            apiHost: apiHost
        });
        this._metadataHost = isStargateProxy ? 'PRODUCT_HOST' : apiHost;
        this._options = this.buildOptions({
            backoffFactor: 2,
            backoffJitterPercentage: 0.8,
            flushBeforeUnload: false,
            flushWaitMs: 500,
            maxAttempts: 10,
            minRetryDelay: (0, $bJ6Ic.DEFAULT_METADATA_MIN_RETRY_DELAY),
            maxRetryDelay: (0, $bJ6Ic.DEFAULT_METADATA_MAX_RETRY_DELAY)
        });
        this._scheduler = new (0, $cx5q7.default)($5f0f1169c182c3a3$var$_objectSpread($5f0f1169c182c3a3$var$_objectSpread({}, this._options), {}, {
            waitInterval: (0, $bJ6Ic.DEFAULT_METADATA_REFRESH_INTERVAL)
        }), this.scheduleCallback.bind(this));
        this._networkStatus = null;
    }
    /**
   * Starts the metadata client. This will start the scheduler and begin
   * fetching metadata.
   *
   * @param allowRestart - If false, the client will not be restarted if it has already been stopped
   *						 by a call to stop().
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(MetadataClient, [
        {
            key: "start",
            value: function start(allowRestart) {
                var _this = this;
                if (this._isEnabled || this._hasBeenStopped && !allowRestart) return;
                this._isEnabled = true;
                this.startNetworkStatusMonitor();
                setTimeout(function() {
                    _this._scheduler.schedule({
                        immediate: true
                    });
                }, MetadataClient.INITIAL_REFRESH_DELAY);
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$_fetchAbortCont;
                if (!this._isEnabled) return;
                this._hasBeenStopped = true;
                this._isEnabled = false;
                this.stopNetworkStatusMonitor();
                this._scheduler.stop();
                (_this$_fetchAbortCont = this._fetchAbortController) === null || _this$_fetchAbortCont === void 0 || _this$_fetchAbortCont.abort();
                this.resetPropertyChangeRefresh();
            }
        },
        {
            key: "startNetworkStatusMonitor",
            value: function startNetworkStatusMonitor() {
                var _this2 = this;
                if (this._networkStatus) return;
                this._networkStatus = new (0, $2SiT1.default)(function(status) {
                    if (status === (0, $9GE8Y.NetworkStatusEnum).OFFLINE) _this2._scheduler.stop();
                    else if (_this2._isEnabled) _this2._scheduler.schedule({
                        immediate: _this2._metadataInfo === null
                    });
                });
            }
        },
        {
            key: "stopNetworkStatusMonitor",
            value: function stopNetworkStatusMonitor() {
                if (this._networkStatus) {
                    this._networkStatus.removeListeners();
                    this._networkStatus = null;
                }
            }
        },
        {
            key: "refreshMetadataAsync",
            value: function() {
                var _refreshMetadataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2() {
                    var _this$_fetchAbortCont2, _this3 = this;
                    var fetchAbortSignal;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                if (!((0, $kqsXa.TestSupport).areFetchCallsDisabled() || !this._isEnabled)) {
                                    _context2.next = 1;
                                    break;
                                }
                                return _context2.abrupt("return", Promise.resolve());
                            case 1:
                                (_this$_fetchAbortCont2 = this._fetchAbortController) === null || _this$_fetchAbortCont2 === void 0 || _this$_fetchAbortCont2.abort();
                                this._fetchAbortController = new AbortController();
                                fetchAbortSignal = this._fetchAbortController.signal;
                                this._lastFetchRequestCount = this._scheduler.getFailureCount();
                                _context2.next = 2;
                                return (0, $3LjAy.fetchMetadata)(this._url, {
                                    product: this._product,
                                    userInfo: this._userInfo,
                                    tenantInfo: this._tenantInfo
                                }, (0, $bJ6Ic.DEFAULT_METADATA_REQUEST_TIMEOUT), fetchAbortSignal).then(/*#__PURE__*/ function() {
                                    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(response) {
                                        var metadata;
                                        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                                            while(true)switch(_context.prev = _context.next){
                                                case 0:
                                                    _context.next = 1;
                                                    return response.json();
                                                case 1:
                                                    metadata = _context.sent;
                                                    _this3._metadataInfo = (0, $4ra9w.MetadataResponse).fromJson(metadata);
                                                    _this3._lastFetchRequestCount++;
                                                    _this3._requestStatus = 'FETCHED';
                                                    _this3._lastErrorReason = null;
                                                case 2:
                                                case "end":
                                                    return _context.stop();
                                            }
                                        }, _callee);
                                    }));
                                    return function(_x) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()).catch(function(error) {
                                    if (fetchAbortSignal.aborted) // This request was aborted, so we don't need to handle it.
                                    return;
                                    _this3._requestStatus = 'FAILED';
                                    if (error instanceof (0, $c8Y37.FetchError) && [
                                        429,
                                        503
                                    ].includes(error.statusCode)) _this3._lastErrorReason = 'ServerBusyError';
                                    else _this3._lastErrorReason = error instanceof Error && (0, $5pjnf.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
                                    throw error;
                                });
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function refreshMetadataAsync() {
                    return _refreshMetadataAsync.apply(this, arguments);
                }
                return refreshMetadataAsync;
            }()
        },
        {
            key: "getMetadataAsync",
            value: function getMetadataAsync() {
                return Promise.resolve(this._metadataInfo);
            }
        },
        {
            key: "status",
            get: function get() {
                return this._requestStatus;
            }
        },
        {
            key: "lastErrorReason",
            get: function get() {
                return this._lastErrorReason;
            }
        },
        {
            key: "lastFetchRequestCount",
            get: function get() {
                return this._lastFetchRequestCount;
            }
        },
        {
            key: "userInfo",
            get: function get() {
                return this._userInfo;
            },
            set: function set(userInfo) {
                var _this$_userInfo, _this$_userInfo2;
                if (((_this$_userInfo = this._userInfo) === null || _this$_userInfo === void 0 ? void 0 : _this$_userInfo.userId) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId) && ((_this$_userInfo2 = this._userInfo) === null || _this$_userInfo2 === void 0 ? void 0 : _this$_userInfo2.userIdType) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userIdType)) return;
                this._userInfo = userInfo;
                this.schedulePropertyChangeRefresh();
            }
        },
        {
            key: "tenantInfo",
            get: function get() {
                return this._tenantInfo;
            },
            set: function set(tenantInfo) {
                var _this$_tenantInfo, _this$_tenantInfo2;
                if (((_this$_tenantInfo = this._tenantInfo) === null || _this$_tenantInfo === void 0 ? void 0 : _this$_tenantInfo.tenantId) === (tenantInfo === null || tenantInfo === void 0 ? void 0 : tenantInfo.tenantId) && ((_this$_tenantInfo2 = this._tenantInfo) === null || _this$_tenantInfo2 === void 0 ? void 0 : _this$_tenantInfo2.tenantIdType) === (tenantInfo === null || tenantInfo === void 0 ? void 0 : tenantInfo.tenantIdType)) return;
                this._tenantInfo = tenantInfo;
                this.schedulePropertyChangeRefresh();
            }
        },
        {
            key: "metrics",
            get: function get() {
                return {
                    host: this._metadataHost,
                    status: this.status,
                    lastErrorReason: this.lastErrorReason,
                    lastRefreshRequestCount: this.lastFetchRequestCount
                };
            }
        },
        {
            key: "scheduleCallback",
            value: function() {
                var _scheduleCallback = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(done) {
                    var _this$_networkStatus;
                    var _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (!(((_this$_networkStatus = this._networkStatus) === null || _this$_networkStatus === void 0 ? void 0 : _this$_networkStatus.getNetworkStatus()) === (0, $9GE8Y.NetworkStatusEnum).OFFLINE)) {
                                    _context3.next = 1;
                                    break;
                                }
                                done((0, $3efd3.DoneState).NOOP);
                                return _context3.abrupt("return");
                            case 1:
                                _context3.prev = 1;
                                _context3.next = 2;
                                return this.refreshMetadataAsync();
                            case 2:
                                done((0, $3efd3.DoneState).SUCCESS);
                                this._scheduler.schedule();
                                _context3.next = 4;
                                break;
                            case 3:
                                _context3.prev = 3;
                                _t = _context3["catch"](1);
                                done((0, $3efd3.DoneState).ERROR);
                            case 4:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function scheduleCallback(_x2) {
                    return _scheduleCallback.apply(this, arguments);
                }
                return scheduleCallback;
            }()
        },
        {
            key: "schedulePropertyChangeRefresh",
            value: function schedulePropertyChangeRefresh() {
                var _this4 = this;
                if (!this._isEnabled) return;
                this.resetPropertyChangeRefresh();
                this._propertyChangeRefreshTimeout = setTimeout(function() {
                    _this4.resetPropertyChangeRefresh();
                    _this4._scheduler.schedule({
                        immediate: true
                    });
                }, (0, $bJ6Ic.DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL));
            }
        },
        {
            key: "resetPropertyChangeRefresh",
            value: function resetPropertyChangeRefresh() {
                if (this._propertyChangeRefreshTimeout) {
                    clearTimeout(this._propertyChangeRefreshTimeout);
                    this._propertyChangeRefreshTimeout = null;
                }
            }
        },
        {
            key: "buildOptions",
            value: function buildOptions(options) {
                return {
                    backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || (0, $3zQGx.DEFAULT_POLLING_OPTIONS).backoffFactor,
                    backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : (0, $3zQGx.DEFAULT_POLLING_OPTIONS).backoffJitterPercentage,
                    maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || (0, $3zQGx.DEFAULT_POLLING_OPTIONS).maxRetryDelay,
                    minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || (0, $3zQGx.DEFAULT_POLLING_OPTIONS).minRetryDelay
                };
            }
        }
    ]);
}();
$5f0f1169c182c3a3$var$_MetadataClient = $5f0f1169c182c3a3$export$1ac223ae496131c9;
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5f0f1169c182c3a3$export$1ac223ae496131c9, "INITIAL_REFRESH_DELAY", 1);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5f0f1169c182c3a3$export$1ac223ae496131c9, "Factory", function(apiHostProtocol, apiHost, product) {
    return new $5f0f1169c182c3a3$var$_MetadataClient(apiHostProtocol, apiHost, product);
});

});
parcelRegister("gE0et", function(module, exports) {
$parcel$export(module.exports, "isStargateProxyPath", () => $c1e08fe93559206d$export$83a9dd8d74be72c);

var $ls3Em = parcelRequire("ls3Em");
function $c1e08fe93559206d$export$83a9dd8d74be72c(_ref) {
    var apiHost = _ref.apiHost;
    return apiHost === (0, $ls3Em.stargateProxyUrl)();
}

});
parcelRegister("ls3Em", function(module, exports) {
$parcel$export(module.exports, "STARGATE_PROXY_PATH", () => $f9df0b541c3a14c4$export$5df9262e102d0c32);
$parcel$export(module.exports, "stargateProxyUrl", () => $f9df0b541c3a14c4$export$78e02cfb66671ad0);
$parcel$export(module.exports, "selectHost", () => $f9df0b541c3a14c4$export$18c0b81944902eae);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $dpXUu = parcelRequire("dpXUu");

var $f9df0b541c3a14c4$var$PROD_HOST = 'as.atlassian.com/api/v1';
var $f9df0b541c3a14c4$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
var $f9df0b541c3a14c4$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
var $f9df0b541c3a14c4$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
var $f9df0b541c3a14c4$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
var $f9df0b541c3a14c4$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
var $f9df0b541c3a14c4$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
var $f9df0b541c3a14c4$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
var $f9df0b541c3a14c4$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
/**
* Returns the full Stargate proxy URL (host + proxy path) for the current host.
*
* This is the default endpoint for Commercial, FedRAMP Moderate (with Stargate),
* and Oasis IC environments. Using the first-party proxy works around browser
* restrictions with third-party cookies.
*
* In non-browser environments (e.g. SSR) where `window` is not defined, the host
* portion is omitted and the function returns only `STARGATE_PROXY_PATH`
* (i.e. `/gateway/api/gasv3/api/v1`).
*/ function $f9df0b541c3a14c4$export$78e02cfb66671ad0() {
    return (typeof window !== 'undefined' ? window.location.host : '') + $f9df0b541c3a14c4$export$5df9262e102d0c32;
}
var $f9df0b541c3a14c4$var$handleFedRampModerate = function handleFedRampModerate(_ref) {
    var useStargate = _ref.useStargate, env = _ref.env, useLegacyUrl = _ref.useLegacyUrl, envOverride = _ref.envOverride;
    if (env === (0, $dpXUu.envType).LOCAL || env === (0, $dpXUu.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, $dpXUu.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, $dpXUu.envType).PROD ? $f9df0b541c3a14c4$var$FEDRAMP_PROD_HOST : $f9df0b541c3a14c4$var$FEDRAMP_STAGING_HOST;
    if (useLegacyUrl) return env === (0, $dpXUu.envType).PROD ? $f9df0b541c3a14c4$var$STARGATE_FEDRAMP_PROD_HOST : $f9df0b541c3a14c4$var$STARGATE_FEDRAMP_STAGING_HOST;
    return $f9df0b541c3a14c4$export$78e02cfb66671ad0();
};
var $f9df0b541c3a14c4$var$handleCommercial = function handleCommercial(_ref2) {
    var useStargate = _ref2.useStargate, env = _ref2.env, useLegacyUrl = _ref2.useLegacyUrl;
    if (!useStargate) return env === (0, $dpXUu.envType).PROD ? $f9df0b541c3a14c4$var$PROD_HOST : $f9df0b541c3a14c4$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $dpXUu.envType).PROD ? $f9df0b541c3a14c4$var$STARGATE_PROD_HOST : $f9df0b541c3a14c4$var$STARGATE_STAGING_HOST;
    return $f9df0b541c3a14c4$export$78e02cfb66671ad0();
};
function $f9df0b541c3a14c4$export$18c0b81944902eae(_ref3) {
    var useStargate = _ref3.useStargate, env = _ref3.env, useLegacyUrl = _ref3.useLegacyUrl, perimeter = _ref3.perimeter, ic = _ref3.ic, envOverride = _ref3.envOverride, apiHost = _ref3.apiHost;
    // If the caller has explicitly set an apiHost, use it as the endpoint.
    if (apiHost) return apiHost;
    // When running inside an IC, events are routed through the Stargate proxy.
    if (ic) {
        if (useLegacyUrl) throw Error('IC is set but useLegacyUrl is true. Legacy URLs are not supported in IC environments.');
        return $f9df0b541c3a14c4$export$78e02cfb66671ad0();
    }
    if (perimeter === (0, $dpXUu.perimeterType).FEDRAMP_MODERATE) return $f9df0b541c3a14c4$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $f9df0b541c3a14c4$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}

});


parcelRegister("kqsXa", function(module, exports) {
$parcel$export(module.exports, "TestSupport", () => $edecb1e04eb94083$export$44b578549c42d779);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
var $edecb1e04eb94083$export$44b578549c42d779 = /*#__PURE__*/ function() {
    function TestSupport() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, TestSupport);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(TestSupport, null, [
        {
            key: "isGeminiVREnvironment",
            value: function isGeminiVREnvironment() {
                try {
                    for(var k in globalThis){
                        if (k.startsWith('__gemini_') && k.endsWith('__')) return true;
                    }
                } catch (e) {
                // ignore
                }
                return false;
            }
        },
        {
            key: "areMetadataCallsDisabled",
            value: function areMetadataCallsDisabled() {
                return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty(TestSupport.DISABLE_METADATA_CALLS_PROPERTY);
            }
        },
        {
            key: "areEventCallsDisabled",
            value: function areEventCallsDisabled() {
                return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty(TestSupport.DISABLE_EVENT_CALLS_PROPERTY);
            }
        },
        {
            key: "areFetchCallsDisabled",
            value: function areFetchCallsDisabled() {
                return this.getGlobalBooleanProperty(TestSupport.DISABLE_FETCH_CALLS_PROPERTY);
            }
        },
        {
            key: "getSyntheticFlagOverride",
            value: function getSyntheticFlagOverride() {
                return this.getGlobalTriStateProperty(TestSupport.SYNTHETIC_FLAG_OVERRIDE_PROPERTY);
            }
        },
        {
            key: "getGlobalBooleanProperty",
            value: function getGlobalBooleanProperty(propertyName) {
                if (globalThis && globalThis.hasOwnProperty(propertyName)) return globalThis[propertyName] === true;
                return false;
            }
        },
        {
            key: "getGlobalTriStateProperty",
            value: function getGlobalTriStateProperty(propertyName) {
                if (globalThis && globalThis.hasOwnProperty(propertyName)) {
                    var value = globalThis[propertyName];
                    if (typeof value === 'boolean') return value;
                }
                return undefined;
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($edecb1e04eb94083$export$44b578549c42d779, "DISABLE_METADATA_CALLS_PROPERTY", '__awc_disable_metadata_calls__');
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($edecb1e04eb94083$export$44b578549c42d779, "DISABLE_EVENT_CALLS_PROPERTY", '__awc_disable_event_calls__');
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($edecb1e04eb94083$export$44b578549c42d779, "DISABLE_FETCH_CALLS_PROPERTY", '__awc_disable_fetch_calls__');
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($edecb1e04eb94083$export$44b578549c42d779, "SYNTHETIC_FLAG_OVERRIDE_PROPERTY", '__awc_synthetic_flag_override__');

});

parcelRegister("3LjAy", function(module, exports) {
$parcel$export(module.exports, "fetchMetadata", () => $2bd4f4c8b23cd51e$export$55b0d0261469055);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $cvlyC = parcelRequire("cvlyC");

var $c8Y37 = parcelRequire("c8Y37");
function $2bd4f4c8b23cd51e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2bd4f4c8b23cd51e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2bd4f4c8b23cd51e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2bd4f4c8b23cd51e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2bd4f4c8b23cd51e$export$55b0d0261469055 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(url, params, timeout, signal) {
        var _params$userInfo, _params$userInfo2, _params$tenantInfo, _params$tenantInfo2;
        var requestAbortController, corsOptions, metadataUrl, response;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    requestAbortController = $2bd4f4c8b23cd51e$var$createRequestAbortController(timeout, signal);
                    corsOptions = $2bd4f4c8b23cd51e$var$getCorsForUrl(url);
                    metadataUrl = url + '?' + new URLSearchParams({
                        product: "".concat(params.product),
                        userId: "".concat(((_params$userInfo = params.userInfo) === null || _params$userInfo === void 0 ? void 0 : _params$userInfo.userId) || ''),
                        userIdType: "".concat(((_params$userInfo2 = params.userInfo) === null || _params$userInfo2 === void 0 ? void 0 : _params$userInfo2.userIdType) || ''),
                        tenantId: "".concat(((_params$tenantInfo = params.tenantInfo) === null || _params$tenantInfo === void 0 ? void 0 : _params$tenantInfo.tenantId) || ''),
                        tenantIdType: "".concat(((_params$tenantInfo2 = params.tenantInfo) === null || _params$tenantInfo2 === void 0 ? void 0 : _params$tenantInfo2.tenantIdType) || '')
                    }).toString();
                    _context.next = 1;
                    return fetch(metadataUrl, $2bd4f4c8b23cd51e$var$_objectSpread({
                        method: 'GET',
                        signal: requestAbortController.signal
                    }, corsOptions));
                case 1:
                    response = _context.sent;
                    if (!(response.status !== 200)) {
                        _context.next = 2;
                        break;
                    }
                    throw new (0, $c8Y37.FetchError)("Metadata: HTTP Error ".concat(response.status, " (").concat(response.statusText, ")"), response.status, response.statusText);
                case 2:
                    return _context.abrupt("return", response);
                case 3:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function fetchMetadata(_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
    };
}();
var $2bd4f4c8b23cd51e$var$createRequestAbortController = function createRequestAbortController(timeout, signal) {
    var abortController = new AbortController();
    setTimeout(function() {
        abortController.abort();
    }, timeout || 30000);
    signal === null || signal === void 0 || signal.addEventListener('abort', function() {
        abortController.abort();
    });
    return abortController;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
var $2bd4f4c8b23cd51e$var$getCorsForUrl = (0, $cvlyC.default)(function(url) {
    var origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});

parcelRegister("4ra9w", function(module, exports) {
$parcel$export(module.exports, "MetadataResponse", () => $33b18f215ea84257$export$4b1a5e5486cc0d80);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");
var $33b18f215ea84257$export$4b1a5e5486cc0d80 = /*#__PURE__*/ function() {
    function MetadataResponse(props, url) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, MetadataResponse);
        this.props = props;
        this.url = url;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(MetadataResponse, null, [
        {
            key: "fromJson",
            value: function fromJson(json) {
                var isString = function isString(value) {
                    return typeof value === 'string' || value instanceof String;
                };
                var url = isString(json === null || json === void 0 ? void 0 : json.url) ? json.url.trim() : '';
                return new MetadataResponse((json === null || json === void 0 ? void 0 : json.props) || null, url.startsWith('http') ? url : null);
            }
        }
    ]);
}();

});


parcelRegister("lsX7U", function(module, exports) {
$parcel$export(module.exports, "isFirstParty", () => $fa0a13d0aa14ff8d$export$f56713ced121eb91);

var $dpXUu = parcelRequire("dpXUu");
var $fa0a13d0aa14ff8d$export$f56713ced121eb91 = function isFirstParty(input) {
    return input.embeddedType === (0, $dpXUu.productEmbedType).FIRST_PARTY && input.embeddedFromProduct !== undefined;
};

});

parcelRegister("5kUYv", function(module, exports) {
$parcel$export(module.exports, "isThirdParty", () => $3e2b040d881a7205$export$ab34f90cc32c8960);

var $dpXUu = parcelRequire("dpXUu");
var $3e2b040d881a7205$export$ab34f90cc32c8960 = function isThirdParty(input) {
    return input.embeddedType === (0, $dpXUu.productEmbedType).THIRD_PARTY && input.embeddedFromTopLevelDomain !== undefined;
};

});

parcelRegister("dyX62", function(module, exports) {
$parcel$export(module.exports, "LoggingResponseCallback", () => $9dfc4aa78eb337fc$export$48361b6ed38f1b0);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");
var $9dfc4aa78eb337fc$export$48361b6ed38f1b0 = /*#__PURE__*/ function() {
    function LoggingResponseCallback() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, LoggingResponseCallback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(LoggingResponseCallback, null, [
        {
            key: "getCallback",
            value: function getCallback(logger) {
                logger = logger || console;
                return function(response) {
                    LoggingResponseCallback.callback(response, logger);
                };
            }
        },
        {
            key: "callback",
            value: function callback(response, logger) {
                var statusCode = response.getStatusCode();
                if (statusCode >= 200 && statusCode <= 299) response.getEventResponseList().forEach(function(eventResponse) {
                    logger.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
                });
                else if (statusCode === 400 || statusCode === 404) {
                    logger.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
                    response.getEventResponseList().forEach(function(eventResponse) {
                        logger.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
                    });
                } else {
                    logger.log('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
                    response.eventResponseList.forEach(function(eventResponse) {
                        logger.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
                    });
                }
            }
        }
    ]);
}();

});

parcelRegister("eS4G8", function(module, exports) {
$parcel$export(module.exports, "objectValues", () => $ad39bce6d9283b30$export$ad1854f4a08c15f8);
function $ad39bce6d9283b30$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}

});

parcelRegister("h5UBC", function(module, exports) {
$parcel$export(module.exports, "default", () => $c71ed008013c1ce7$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $dpXUu = parcelRequire("dpXUu");

var $2UUeH = parcelRequire("2UUeH");
var $c71ed008013c1ce7$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function OriginTracing() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, OriginTracing);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "pendingCleanup", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "handleOriginParameters", function(originParamHandlerMapping, historyReplaceFn) {
            // Collect all the parameter labels to be handled
            var originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            var invalidParams = originParamLabelList.filter(function(x) {
                return Object.values((0, $dpXUu.originTracingType)).indexOf(x) < 0;
            });
            if (invalidParams.length > 0) throw new Error("Invalid Origin Tracing Parameter(s) supplied: ".concat(invalidParams.join(), "!"));
            var isCaptureParam = function isCaptureParam(_, key) {
                return originParamLabelList.indexOf(key) >= 0;
            };
            // Capture params WITHOUT removing from URL (explicit no-op required because
            // urlParamExtractor defaults to calling history.replaceState if omitted)
            var paramExtractorReplace = function paramExtractorReplace() {};
            var capturedURLParams = (0, $2UUeH.default)(isCaptureParam, paramExtractorReplace);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            var applyHandlerFunction = function applyHandlerFunction(key) {
                var x = originParamHandlerMapping[key](capturedURLParams[key]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, x);
            };
            var capturedOriginTraces = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce(function(accumulator, currentValue) {
                return Object.assign(accumulator, currentValue);
            }, {});
            if (Object.keys(capturedOriginTraces).length > 0) _this.pendingCleanup = function() {
                (0, $2UUeH.default)(isCaptureParam, historyReplaceFn);
            };
            return capturedOriginTraces;
        });
        this._originStore = {};
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(OriginTracing, [
        {
            key: "_cleanupOriginParams",
            value: /** Executes and clears any pending origin param cleanup. No-op if nothing is pending. */ function _cleanupOriginParams() {
                if (this.pendingCleanup) {
                    var cleanup = this.pendingCleanup;
                    this.pendingCleanup = null;
                    cleanup();
                }
            }
        },
        {
            key: "cleanupOriginParameters",
            value: function cleanupOriginParameters(events) {
                try {
                    if (this.pendingCleanup) {
                        var hasOriginLanded = events.some(function(item) {
                            return 'event' in item.msg && item.msg.event === OriginTracing.messageEvent;
                        });
                        if (hasOriginLanded) this._cleanupOriginParams();
                    }
                } catch (_unused) {
                // Silently ignore cleanup errors to avoid disrupting the flush cycle
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c71ed008013c1ce7$export$2e2bcd8739ae039, "messageEvent", 'origin landed');

});

parcelRegister("5P1Jy", function(module, exports) {
$parcel$export(module.exports, "default", () => $43d30f76663fb1b4$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $50U6m = parcelRequire("50U6m");

var $7Nwkx = parcelRequire("7Nwkx");

var $jc2hJ = parcelRequire("jc2hJ");
// WARNING: The value of SESSION_ID_STORAGE_KEY is relied upon by other Platform packages
// (eg. search-page, product-search-dialog). If you need to change this key, you MUST
// notify the dependant Platform teams and update all dependent packages accordingly.
var $43d30f76663fb1b4$var$SESSION_ID_STORAGE_KEY = 'session.id';
var $43d30f76663fb1b4$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
var $43d30f76663fb1b4$var$ONLY_NUMBERS_REGEX = /^\d+$/;
var $43d30f76663fb1b4$export$285f6bddd927a06d = 1800000;
var $43d30f76663fb1b4$export$a92e915d70316eb2 = 5000;
var $43d30f76663fb1b4$export$de43760b2dc10c19 = 0.9;
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $43d30f76663fb1b4$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function SessionTracking() {
        var _this = this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, SessionTracking);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_generateNewSessionId", function() {
            var newSessionId = Date.now().toString();
            _this._safeLocalStorage.setItem($43d30f76663fb1b4$var$SESSION_ID_STORAGE_KEY, newSessionId);
            if ((0, $50U6m.fg)('awc_session_id_early_exit')) {
                // If session is not valid at this point, something has gone wrong with Local Storage access
                // Calling the callback may result in possible recursion errors (see HOT-304742). Feature
                // gating roll-out of this early exit condition
                var _this$_getCurrentSess = _this._getCurrentSessionParams(), isValidSession = _this$_getCurrentSess.isValidSession;
                if (!isValidSession) return '';
            }
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            _this._onNewSessionStarted && _this._onNewSessionStarted();
            return newSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_updateSessionExpiry", function() {
            var expiry = Date.now() + _this._sessionExpiryTime;
            _this._safeLocalStorage.setItem($43d30f76663fb1b4$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_debouncedUpdateSessionExpiry", function(currentExpiry) {
            var _updateSessionExpiry = _this._updateSessionExpiry;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + _this._sessionExpiryDebounceThresholdPercentage * _this._sessionExpiryTime) _updateSessionExpiry();
            else {
                if (_this._sessionExpiryDebounceTimer) clearTimeout(_this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                _this._sessionExpiryDebounceTimer = setTimeout(function() {
                    _updateSessionExpiry();
                }, _this._sessionExpiryDebounce);
            }
        });
        this._sessionExpiryTime = options.sessionExpiryTime || $43d30f76663fb1b4$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $43d30f76663fb1b4$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $43d30f76663fb1b4$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : (0, $7Nwkx.NOOP);
        this._safeLocalStorage = new (0, $jc2hJ.default)();
    }
    /*
   * This function retrieves the current session ID and expiry from SessionStorage
   * It runs the necessary checks to ensure the session ID is valid and within expiry
   *
   * It returns the values along with a `validSession` boolean
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(SessionTracking, [
        {
            key: "_getCurrentSessionParams",
            value: function _getCurrentSessionParams() {
                var sessionId = this._safeLocalStorage.getItem($43d30f76663fb1b4$var$SESSION_ID_STORAGE_KEY);
                var sessionExpiry = parseInt(this._safeLocalStorage.getItem($43d30f76663fb1b4$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
                // REGEX test: Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
                // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
                if (sessionId && !Number.isNaN(sessionExpiry) && $43d30f76663fb1b4$var$ONLY_NUMBERS_REGEX.test(sessionId) && sessionExpiry > Date.now()) return {
                    isValidSession: true,
                    sessionExpiry: sessionExpiry,
                    sessionId: sessionId
                };
                return {
                    isValidSession: false,
                    sessionExpiry: sessionExpiry,
                    sessionId: sessionId
                };
            }
        },
        {
            key: "getCurrentSessionId",
            value: function getCurrentSessionId() {
                var _this$_getCurrentSess2 = this._getCurrentSessionParams(), isValidSession = _this$_getCurrentSess2.isValidSession, sessionExpiry = _this$_getCurrentSess2.sessionExpiry, sessionId = _this$_getCurrentSess2.sessionId;
                this._debouncedUpdateSessionExpiry(sessionExpiry);
                // If we have an existing valid session we can return the sessionId straight away
                if (isValidSession) return sessionId;
                else return this._generateNewSessionId();
            }
        }
    ]);
}();

});
parcelRegister("7Nwkx", function(module, exports) {
$parcel$export(module.exports, "NOOP", () => $5ad6301d2094590b$export$5702a91a6f42969f);
// 90% of expiry
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $5ad6301d2094590b$export$5702a91a6f42969f = function NOOP() {};

});


parcelRegister("cMwGH", function(module, exports) {
$parcel$export(module.exports, "default", () => $94e352d257707d44$export$2e2bcd8739ae039);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $eXTjr = parcelRequire("eXTjr");

var $5eu7g = parcelRequire("5eu7g");
function $94e352d257707d44$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $94e352d257707d44$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $94e352d257707d44$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($94e352d257707d44$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
// eslint-disable-next-line import/no-anonymous-default-export
var $94e352d257707d44$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_SafeStorage) {
    function _default(options) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, _default);
        var storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = globalThis.sessionStorage || (0, $eXTjr.default);
        } catch (err) {
            storageToUse = (0, $eXTjr.default);
        }
        return $94e352d257707d44$var$_callSuper(this, _default, [
            storageToUse,
            options
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(_default, _SafeStorage);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(_default);
}((0, $5eu7g.default));

});

parcelRegister("j5Le2", function(module, exports) {
$parcel$export(module.exports, "default", () => $de631ded0d60c70b$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $cMwGH = parcelRequire("cMwGH");

var $1Ygrk = parcelRequire("1Ygrk");
var $de631ded0d60c70b$var$STORAGE_KEY = 'tab.id';
var $de631ded0d60c70b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function TabTracking() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, TabTracking);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_generateNewTabId", function() {
            var newTabId = (0, $1Ygrk.default)();
            _this._safeSessionStorage.setItem($de631ded0d60c70b$var$STORAGE_KEY, newTabId);
            return newTabId;
        });
        this._safeSessionStorage = new (0, $cMwGH.default)();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(TabTracking, [
        {
            key: "getCurrentTabId",
            value: function getCurrentTabId() {
                var tabId = this._safeSessionStorage.getItem($de631ded0d60c70b$var$STORAGE_KEY);
                if (!tabId) tabId = this._generateNewTabId();
                return tabId;
            }
        }
    ]);
}();

});

parcelRegister("kxbHy", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef2ff75caf77a3e2$export$2e2bcd8739ae039);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $25nEq = parcelRequire("25nEq");

var $3hnNg = parcelRequire("3hnNg");

var $dpXUu = parcelRequire("dpXUu");

var $8ZtlX = parcelRequire("8ZtlX");

var $cMwGH = parcelRequire("cMwGH");

var $2UUeH = parcelRequire("2UUeH");

var $1Ygrk = parcelRequire("1Ygrk");
function $ef2ff75caf77a3e2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ef2ff75caf77a3e2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ef2ff75caf77a3e2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ef2ff75caf77a3e2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ef2ff75caf77a3e2$var$STORAGE_KEY = 'taskSessions';
var $ef2ff75caf77a3e2$var$INIT_KEY = 'taskSessionsInit';
var $ef2ff75caf77a3e2$var$AWC_PARAM_PREFIX = 'awc.';
var $ef2ff75caf77a3e2$var$TASK_SESSION_RELOAD_TIME = 3000;
var $ef2ff75caf77a3e2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(function TaskSessionStore() {
    var _this = this;
    (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, TaskSessionStore);
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_taskSessionsNotRecentlyInitialised", function(currentTimestamp) {
        return _this._safeSessionStorage.getItem($ef2ff75caf77a3e2$var$STORAGE_KEY) === null || _this._safeSessionStorage.getItem($ef2ff75caf77a3e2$var$INIT_KEY) === null || parseInt(_this._safeSessionStorage.getItem($ef2ff75caf77a3e2$var$INIT_KEY) || '0', 10) < currentTimestamp - $ef2ff75caf77a3e2$var$TASK_SESSION_RELOAD_TIME;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_removeTaskSessionPrefix", function(_, taskSessionName) {
        return taskSessionName.split($ef2ff75caf77a3e2$var$AWC_PARAM_PREFIX)[1];
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isTaskSessionQueryParam", function(_, taskSessionName) {
        return taskSessionName.startsWith($ef2ff75caf77a3e2$var$AWC_PARAM_PREFIX);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getAllTaskSessions", function() {
        try {
            return JSON.parse(_this._safeSessionStorage.getItem($ef2ff75caf77a3e2$var$STORAGE_KEY) || '');
        } catch (_unused) {
            return {};
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_writeToSessionStorage", function(taskSessions) {
        try {
            _this._safeSessionStorage.setItem($ef2ff75caf77a3e2$var$STORAGE_KEY, JSON.stringify(taskSessions));
        // eslint-disable-next-line no-empty
        } catch (_unused2) {}
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_appendTaskSessions", function(newTaskSessions) {
        var currentState = _this.getAllTaskSessions();
        var newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
        _this._writeToSessionStorage(newState);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_safelyRemoveKey", function(currentState, taskSessionName) {
        if (currentState === null) return {};
        delete currentState[taskSessionName];
        return currentState;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "createTaskSession", function(taskSessionName) {
        var taskSessionId = (0, $1Ygrk.default)();
        var newTaskSessions = {};
        newTaskSessions[taskSessionName] = taskSessionId;
        _this._appendTaskSessions(newTaskSessions);
        return taskSessionId;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "createTaskSessionWithProvidedId", function(taskSessionName, taskSessionId) {
        if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
        var newTaskSessions = {};
        newTaskSessions[taskSessionName] = taskSessionId;
        _this._appendTaskSessions(newTaskSessions);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "completeTaskSession", function(taskSessionName) {
        var currentState = _this.getAllTaskSessions();
        var updatedState = _this._safelyRemoveKey(currentState, taskSessionName);
        _this._writeToSessionStorage(updatedState);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "formatTaskSessionQueryString", function(_ref) {
        var uri = _ref.uri, includedTaskSessions = _ref.includedTaskSessions;
        var _parseUrl = (0, $3hnNg.parseUrl)(uri), url = _parseUrl.url, query = _parseUrl.query;
        var currentState = _this.getAllTaskSessions();
        // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
        var filteredTaskSessions = includedTaskSessions ? (0, $8ZtlX.pick)(currentState, includedTaskSessions) : (0, $8ZtlX.omit)(currentState, Object.values((0, $dpXUu.originTracingType)));
        if (Object.keys(filteredTaskSessions).length === 0) return uri;
        var queryWithTaskSessions = $ef2ff75caf77a3e2$var$_objectSpread($ef2ff75caf77a3e2$var$_objectSpread({}, (0, $8ZtlX.mapKeys)(filteredTaskSessions, function(_, taskSessionName) {
            return $ef2ff75caf77a3e2$var$AWC_PARAM_PREFIX + taskSessionName;
        })), query);
        return "".concat(url, "?").concat((0, $3hnNg.stringify)(queryWithTaskSessions));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "stripQueryParameters", function() {
        var extractedTaskSessions = (0, $8ZtlX.mapKeys)((0, $2UUeH.default)(_this._isTaskSessionQueryParam), _this._removeTaskSessionPrefix);
        _this._appendTaskSessions(extractedTaskSessions);
    });
    var _currentTimestamp = Date.now();
    this._safeSessionStorage = new (0, $cMwGH.default)();
    // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
    try {
        if (this._taskSessionsNotRecentlyInitialised(_currentTimestamp)) {
            this._writeToSessionStorage({});
            this._safeSessionStorage.setItem($ef2ff75caf77a3e2$var$INIT_KEY, _currentTimestamp.toString());
        }
    // eslint-disable-next-line no-empty
    } catch (_unused3) {}
});

});

parcelRegister("8jZU6", function(module, exports) {
$parcel$export(module.exports, "default", () => $60f01de259a84dee$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $bDLqY = parcelRequire("bDLqY");

var $hel6R = parcelRequire("hel6R");

var $kqsXa = parcelRequire("kqsXa");
var $60f01de259a84dee$var$MAX_CACHE_SIZE = 100;
var $60f01de259a84dee$var$COOKIE_NAME = (0, $hel6R.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
var $60f01de259a84dee$var$DEBUG_TAG = 'synthetic';
var $60f01de259a84dee$var$TestingCache = /*#__PURE__*/ function() {
    function TestingCache(syntheticFlagOverride, enableTestingCache) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, TestingCache);
        this._syntheticFlagOverride = typeof syntheticFlagOverride === 'boolean' ? syntheticFlagOverride : undefined;
        this._enableTestingCache = typeof enableTestingCache === 'boolean' ? enableTestingCache : undefined;
        this._isDebugCookieEnabled = TestingCache.getDebugCookie();
        this.bind();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(TestingCache, [
        {
            key: "saveEvent",
            value: function saveEvent(event) {
                try {
                    if (!event) return;
                    this.bind();
                    this.addSyntheticTag(event);
                    this.cache(event);
                } catch (_unused) {
                // Ignore errors from testing cache.
                }
            }
        },
        {
            key: "bind",
            value: function bind() {
                if (!this.shouldCacheEvent() || typeof window === 'undefined' || window.testAnalytics) return;
                window.testAnalytics = {
                    eventCache: [],
                    events: function events() {
                        return window.testAnalytics.eventCache;
                    },
                    clear: function clear() {
                        window.testAnalytics.eventCache = [];
                        try {
                            localStorage.removeItem('awc.ui.viewed.last.sent');
                            localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                            localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                            localStorage.removeItem('awc-local.ui.viewed.last.sent');
                        } catch (_unused2) {
                        // Ignore errors from localStorage.
                        }
                    }
                };
            }
        },
        {
            key: "cache",
            value: function cache(event) {
                if (!this.shouldCacheEvent() || typeof window === 'undefined' || !window.testAnalytics) return;
                if (window.testAnalytics.eventCache.length >= $60f01de259a84dee$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
                window.testAnalytics.eventCache.push(event);
            }
        },
        {
            key: "addSyntheticTag",
            value: function addSyntheticTag(event) {
                if (!this.shouldSetSyntheticFlag()) return;
                if (event.tags instanceof Array) {
                    if (!event.tags.includes($60f01de259a84dee$var$DEBUG_TAG)) event.tags.push($60f01de259a84dee$var$DEBUG_TAG);
                } else event.tags = [
                    $60f01de259a84dee$var$DEBUG_TAG
                ];
            }
        },
        {
            key: "shouldCacheEvent",
            value: function shouldCacheEvent() {
                return this._enableTestingCache ? this._enableTestingCache : this._isDebugCookieEnabled;
            }
        },
        {
            key: "shouldSetSyntheticFlag",
            value: function shouldSetSyntheticFlag() {
                if (this._syntheticFlagOverride !== undefined) return this._syntheticFlagOverride;
                var globalSyntheticOverride = (0, $kqsXa.TestSupport).getSyntheticFlagOverride();
                if (globalSyntheticOverride !== undefined) return globalSyntheticOverride;
                return this.shouldCacheEvent();
            }
        }
    ], [
        {
            key: "getDebugCookie",
            value: function getDebugCookie() {
                try {
                    return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($bDLqY))).get($60f01de259a84dee$var$COOKIE_NAME) || 'false') === true;
                } catch (_unused3) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($bDLqY))).remove($60f01de259a84dee$var$COOKIE_NAME);
                }
                return false;
            }
        }
    ]);
}();
var $60f01de259a84dee$export$2e2bcd8739ae039 = $60f01de259a84dee$var$TestingCache;

});

parcelRegister("4penA", function(module, exports) {
$parcel$export(module.exports, "default", () => $3354a6ae24846e2f$export$2e2bcd8739ae039);

var $1Vcia = parcelRequire("1Vcia");

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $25nEq = parcelRequire("25nEq");

var $dpXUu = parcelRequire("dpXUu");

var $daYpa = parcelRequire("daYpa");

var $jc2hJ = parcelRequire("jc2hJ");
var $3354a6ae24846e2f$var$_excluded = [
    "embeddedProduct"
];
function $3354a6ae24846e2f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3354a6ae24846e2f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3354a6ae24846e2f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3354a6ae24846e2f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3354a6ae24846e2f$var$DEFAULT_DELAY = 2000; // 2 seconds
var $3354a6ae24846e2f$var$DEFAULT_THROTTLE = 3600000; // 1 hour
var $3354a6ae24846e2f$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
var $3354a6ae24846e2f$var$DEFAULT_MALFORMED_UIVIEWED_EVENT = 'malformed.uiviewed.last.sent';
var $3354a6ae24846e2f$var$SendEventDecision = /*#__PURE__*/ function(SendEventDecision) {
    SendEventDecision[SendEventDecision["FocusLost"] = 0] = "FocusLost";
    SendEventDecision[SendEventDecision["UserOrTenantIncomplete"] = 1] = "UserOrTenantIncomplete";
    SendEventDecision[SendEventDecision["MalformedUiViewedRateLimited"] = 2] = "MalformedUiViewedRateLimited";
    SendEventDecision[SendEventDecision["EligibleToSend"] = 3] = "EligibleToSend";
    SendEventDecision[SendEventDecision["UiViewedRateLimited"] = 4] = "UiViewedRateLimited";
    return SendEventDecision;
}($3354a6ae24846e2f$var$SendEventDecision || {});
var $3354a6ae24846e2f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(function UIViewedEvent(productInfo, getContext, onEvent) {
    var _this = this;
    var settings = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIViewedEvent);
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "start", function() {
        _this._startInterval();
        _this._bindEventListeners();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "stop", function() {
        _this._stopInterval();
        _this._unbindEventListeners();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "resetTimers", function() {
        if (_this._intervalId) {
            _this.stop();
            _this.start();
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "signalUserActive", function() {
        _this._sendUserActiveEvents();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_bindEventListeners", function() {
        if (typeof window !== 'undefined') {
            window.addEventListener('focus', _this._focusListener);
            window.addEventListener('blur', _this._blurListener);
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_unbindEventListeners", function() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('focus', _this._focusListener);
            window.removeEventListener('blur', _this._blurListener);
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_startInterval", function() {
        clearInterval(_this._intervalId);
        _this._intervalId = setInterval(_this._handleDwellTimerTriggered, _this._delay);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_stopInterval", function() {
        if (_this._intervalId) {
            clearInterval(_this._intervalId);
            _this._intervalId = null;
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getProductKey", function(product, subproduct) {
        var productKey = product;
        if (subproduct) productKey += "-".concat(subproduct);
        return productKey;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getLastSentTimestamp", function(productKey, tenantId, userId) {
        var json = _this._parseLocalStorageData(_this._storageKey) || {};
        var u = json[userId] || {};
        var t = u[tenantId] || {};
        var p = t[productKey] || null;
        return p;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_parseLocalStorageData", function(key) {
        var data = _this._safeLocalStorage.getItem(key);
        try {
            return JSON.parse(data || '');
        } catch (_unused) {
            _this._safeLocalStorage.removeItem(key);
            return null;
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getMalformedLastSentTimestamp", function(productKey, tenantId, userId) {
        var json = _this._parseLocalStorageData(_this._malformedEventStorageKey) || {};
        var finalUserId = userId || 'NOT_SET';
        var finalTenantId = tenantId || 'NOT_SET';
        var u = json[finalUserId] || {};
        var t = u[finalTenantId] || {};
        var p = t[productKey] || null;
        return p;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_setLastSentTimestamp", function(productKey, tenantId, userId) {
        var json = _this._parseLocalStorageData(_this._storageKey) || {};
        var u = json[userId] || {};
        var t = u[tenantId] || {};
        t[productKey] = Date.now();
        u[tenantId] = t;
        json[userId] = u;
        _this._safeLocalStorage.setItem(_this._storageKey, JSON.stringify(json));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_setMalformedLastSentTimestamp", function(productKey, tenantId, userId) {
        var json = _this._parseLocalStorageData(_this._malformedEventStorageKey) || {};
        var finalUserId = userId || 'NOT_SET';
        var finalTenantId = tenantId || 'NOT_SET';
        var u = json[finalUserId] || {};
        var t = u[finalTenantId] || {};
        t[productKey] = Date.now();
        u[finalTenantId] = t;
        json[finalUserId] = u;
        _this._safeLocalStorage.setItem(_this._malformedEventStorageKey, JSON.stringify(json));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_handleDwellTimerTriggered", function() {
        var document = (0, $daYpa.getDocument)();
        if (document && !document.hasFocus()) return;
        _this._sendUserActiveEvents();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_sendUserActiveEvents", function() {
        var _this$_getContext = _this._getContext(), embeddedProduct = _this$_getContext.embeddedProduct, context = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_this$_getContext, $3354a6ae24846e2f$var$_excluded);
        _this._sendEvent(_this._product, context, false);
        if (embeddedProduct) _this._sendEvent(embeddedProduct, context, true);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_sendEvent", function(product, context, isEmbeddedProduct) {
        var subproduct = context.subproduct, tenantIdType = context.tenantIdType, tenantId = context.tenantId, userId = context.userId, lastScreenEvent = context.lastScreenEvent, attributes = context.attributes;
        var productKey = _this._getProductKey(product, subproduct);
        var sendEventDecision = _this._shouldSendEvent(productKey, tenantIdType, tenantId, userId);
        switch(sendEventDecision){
            case $3354a6ae24846e2f$var$SendEventDecision.EligibleToSend:
                _this._setLastSentTimestamp(productKey, tenantId, userId);
                _this._onEvent(_this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'ui', 'viewed'));
                break;
            case $3354a6ae24846e2f$var$SendEventDecision.UserOrTenantIncomplete:
                _this._setMalformedLastSentTimestamp(productKey, tenantId, userId);
                _this._onEvent(_this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'malformed', 'uiviewed'));
                break;
            default:
                break;
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_shouldSendEvent", function(productKey, tenantIdType, tenantId, userId) {
        // TENANT OR USER ID NOT SET
        if (tenantIdType !== (0, $dpXUu.tenantType).NONE && !tenantId || !userId) {
            var _sinceLastSent = Date.now() - _this._getMalformedLastSentTimestamp(productKey, tenantId, userId);
            if (_sinceLastSent === null || _sinceLastSent > _this._throttle) return $3354a6ae24846e2f$var$SendEventDecision.UserOrTenantIncomplete;
            return $3354a6ae24846e2f$var$SendEventDecision.MalformedUiViewedRateLimited;
        }
        var sinceLastSent = Date.now() - _this._getLastSentTimestamp(productKey, tenantId, userId);
        if (sinceLastSent === null || sinceLastSent > _this._throttle) return $3354a6ae24846e2f$var$SendEventDecision.EligibleToSend;
        return $3354a6ae24846e2f$var$SendEventDecision.UiViewedRateLimited;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_createEvent", function(product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes, actionSubject, action) {
        var event = {
            product: product,
            source: 'ui',
            action: action,
            actionSubject: actionSubject,
            attributes: extraAttributes
        };
        if (isEmbeddedProduct) {
            // Clear the subproduct and version as they don't relate to the embedded product
            event.subproduct = null;
            event.version = null;
            event.attributes = $3354a6ae24846e2f$var$_objectSpread($3354a6ae24846e2f$var$_objectSpread({}, event.attributes), {}, {
                embeddedInEnv: _this._productInfo.env,
                embeddedInProduct: _this._productInfo.product,
                embeddedInSubproduct: subproduct,
                embeddedInVersion: _this._productInfo.version,
                embeddedInOrigin: _this._productInfo.origin,
                embeddedInPlatform: _this._productInfo.platform
            });
        }
        if (lastScreenEvent) event.attributes = $3354a6ae24846e2f$var$_objectSpread($3354a6ae24846e2f$var$_objectSpread({}, event.attributes), {}, {
            lastScreenEvent: {
                name: lastScreenEvent.name,
                attributes: lastScreenEvent.attributes
            }
        });
        return event;
    });
    if (!productInfo) throw new Error('Missing productInfo');
    if (!productInfo.product) throw new Error('Missing productInfo.product');
    if (!getContext) throw new Error('Missing getContext callback');
    if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
    if (!onEvent) throw new Error('Missing onEvent callback');
    if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
    this._productInfo = productInfo;
    this._product = productInfo.product;
    this._getContext = getContext;
    this._onEvent = onEvent;
    this._delay = settings.delay || $3354a6ae24846e2f$var$DEFAULT_DELAY;
    this._throttle = settings.throttle || $3354a6ae24846e2f$var$DEFAULT_THROTTLE;
    this._storageKey = settings.storageKey || $3354a6ae24846e2f$var$DEFAULT_STORAGE_KEY;
    this._malformedEventStorageKey = settings.malformedStorageKey || $3354a6ae24846e2f$var$DEFAULT_MALFORMED_UIVIEWED_EVENT;
    this._safeLocalStorage = new (0, $jc2hJ.default)({
        envPrefix: this._productInfo.env
    });
    this._focusListener = function() {
        _this._startInterval();
    };
    this._blurListener = function() {
        _this._stopInterval();
    };
});

});
parcelRegister("daYpa", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $997b10b79fa3f8dc$export$f65ca476c09acec0);
var $997b10b79fa3f8dc$export$f65ca476c09acec0 = function getDocument() {
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("c77r4", function(module, exports) {
$parcel$export(module.exports, "validateIdentifyEvent", () => $8d1be80e306e78b1$export$c16a4e16aa4026c0);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $dpXUu = parcelRequire("dpXUu");

var $9raiz = parcelRequire("9raiz");

var $eS4G8 = parcelRequire("eS4G8");
function $8d1be80e306e78b1$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, $9raiz.isType)((0, $dpXUu.userType), userIdType)) throw new Error("Invalid userIdType '".concat(userIdType, "', ") + "must be an userType: [".concat((0, $eS4G8.objectValues)((0, $dpXUu.userType)), "]"));
}

});

parcelRegister("4uub9", function(module, exports) {
$parcel$export(module.exports, "validateOperationalEvent", () => $34515fab26bd9a15$export$1e561554275607ef);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $kCOHZ = parcelRequire("kCOHZ");
function $34515fab26bd9a15$export$1e561554275607ef(event) {
    (0, $kCOHZ.validateActionEvent)(event);
}

});

parcelRegister("gUTHp", function(module, exports) {
$parcel$export(module.exports, "validatePlatform", () => $c50d1502f8d3d175$export$801b46c35394d316);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $dpXUu = parcelRequire("dpXUu");

var $9raiz = parcelRequire("9raiz");

var $eS4G8 = parcelRequire("eS4G8");
function $c50d1502f8d3d175$export$801b46c35394d316(productInfo) {
    if (!(0, $9raiz.isType)((0, $dpXUu.platformType), productInfo.platform)) throw new Error("Invalid productInfo.platform '".concat(productInfo.platform, "', ") + "must be a platformType: [".concat((0, $eS4G8.objectValues)((0, $dpXUu.platformType)), "]"));
    if (productInfo.origin === (0, $dpXUu.originType).DESKTOP && !(0, $9raiz.isType)((0, $dpXUu.desktopPlatforms), productInfo.platform)) throw new Error("Invalid productInfo.platform '".concat(productInfo.platform, "', ") + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, $dpXUu.originType).WEB && !(0, $9raiz.isType)((0, $dpXUu.webPlatforms), productInfo.platform)) throw new Error("Invalid productInfo.platform '".concat(productInfo.platform, "', must be one of [web, mobileWeb]"));
}

});

parcelRegister("gKKSu", function(module, exports) {
$parcel$export(module.exports, "validateScreenEvent", () => $c3254e2a0fc6d4e4$export$dc993432a592dc27);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ function $c3254e2a0fc6d4e4$export$dc993432a592dc27(name) {
    if (!name) throw new Error('Missing name');
}

});

parcelRegister("lHJ7U", function(module, exports) {
$parcel$export(module.exports, "validateTrackEvent", () => $fcd09e4ca0ff1670$export$8c014fd74b0c8b99);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $kCOHZ = parcelRequire("kCOHZ");
function $fcd09e4ca0ff1670$export$8c014fd74b0c8b99(event) {
    (0, $kCOHZ.validateActionEvent)(event);
}

});

parcelRegister("2E7is", function(module, exports) {
$parcel$export(module.exports, "validateUIEvent", () => $1ed4fa2aafa80baa$export$e5bac0930c812e90);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $kCOHZ = parcelRequire("kCOHZ");
function $1ed4fa2aafa80baa$export$e5bac0930c812e90(event) {
    (0, $kCOHZ.validateActionEvent)(event);
}

});

parcelRegister("7UqwT", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c22578f1038a2ab$export$2e2bcd8739ae039);
function $5c22578f1038a2ab$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return function() {
        callback(event);
    };
}

});

parcelRegister("hPniv", function(module, exports) {
$parcel$export(module.exports, "XIDPromise", () => $cfa945807de0debd$export$fbe53bbbe682bcdd);

var $Lo77l = parcelRequire("Lo77l");
var $cfa945807de0debd$export$fbe53bbbe682bcdd = function XIDPromise(xidConsent, xidPromiseFn) {
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        var timeoutPromise = function timeoutPromise() {
            return new Promise(function(resolve) {
                setTimeout(function() {
                    return resolve(function() {
                        return (0, $Lo77l.createTimeoutXid)();
                    });
                }, (0, $Lo77l.XID_TIMEOUT));
            });
        };
        var xidPromise = function xidPromise() {
            return xidPromiseFn().catch(function() {
                return function() {
                    return (0, $Lo77l.createUnknownXid)();
                };
            });
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("Lo77l", function(module, exports) {
$parcel$export(module.exports, "XID_TIMEOUT", () => $08e71866145a7f5d$export$545bcbd53afabfa3);
$parcel$export(module.exports, "createTimeoutXid", () => $08e71866145a7f5d$export$af4087e36d63846);
$parcel$export(module.exports, "createUnknownXid", () => $08e71866145a7f5d$export$fa341d0c750d705b);

var $3Mpn1 = parcelRequire("3Mpn1");
var $08e71866145a7f5d$export$545bcbd53afabfa3 = 5000;
var $08e71866145a7f5d$export$af4087e36d63846 = function createTimeoutXid() {
    return [
        {
            type: (0, $3Mpn1.XIDItemType).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, $3Mpn1.XIDItemType).UID,
            state: 'TIMEOUT'
        }
    ];
};
var $08e71866145a7f5d$export$fa341d0c750d705b = function createUnknownXid() {
    return [
        {
            type: (0, $3Mpn1.XIDItemType).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, $3Mpn1.XIDItemType).UID,
            state: 'UNKNOWN'
        }
    ];
};

});
parcelRegister("3Mpn1", function(module, exports) {
$parcel$export(module.exports, "XIDItemType", () => $2c0988cb35351eed$export$92ca0438bcb0d396);
var $2c0988cb35351eed$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
var $2c0988cb35351eed$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("i3Wuc", function(module, exports) {
$parcel$export(module.exports, "default", () => $d265dfee85eca2f5$export$2e2bcd8739ae039);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $25nEq = parcelRequire("25nEq");

var $2HsPW = parcelRequire("2HsPW");

var $4tI8a = parcelRequire("4tI8a");
function $d265dfee85eca2f5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d265dfee85eca2f5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d265dfee85eca2f5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d265dfee85eca2f5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d265dfee85eca2f5$var$DEFAULT_TIMING = {
    initialPollInterval: 5,
    pollBackoffRate: 2,
    idleTimeout: 30
};
/**
 * Helper class to record the amount of time a user has spent on a page.
 *
 * Two kinds of dwell events are fired. Dwell milestone events are fired periodically while the
 * user is on the page, at increasing intervals (by default, 5s, 10s, 20s, 40s, etc.). A final
 * dwell event will also be fired when the user leaves the page.
 *
 * Note that the event data passed to this helper should be compatible with a 'track' event.
 * See https://extranet.atlassian.com/display/PData/Track+Events for more information.
 *
 * Example usage:
 *
 * const baseEventData = {
 *   actionSubject: 'page',
 *   actionSubjectId: 'aa4fd6c5-28f4-40fa-807a-765a39957cb5',
 *   source: 'page',
 *   containerType: 'space',
 *   containerId: '340f1acf-d15b-4677-88c6-4671d23fb131',
 * }
 *
 * const helper = new DwellTimeHelper(sendTrackEventFunction, baseEventData, searchSessionId)
 * helper.start();
 */ var $d265dfee85eca2f5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(/**
 * Callback for sending a 'track' analytics event. This callback should either be the
 * 'sendTrackEvent' method on the AnalyticsWebClient, or a method that eventually delegates to it.
 * The data for the dwell event will be passed to this method for sending.
 *
 * @callback trackCallback
 * @param {Object} eventData - the base event data that will be added to the track event.
 */ /**
 * Creates and initialises the DwellTimeHelper.
 *
 * @param {trackCallback} trackCallback - the track callback responsible for actually sending
 * the event.
 * @param {Object} eventData - the base data that will be added to the track event.
 * Additional dwell time attributes will be appended to this data. Note that you don't need to
 * include the 'action' property, as this will be added automatically.
 * @param {?string} searchSessionId - a unique identifier for the related search session.
 * @param {?Object} timingOptions - for the purpose of debugging, you can override the default
 * timing used for measuring dwell time. The following values are possible:
 * - initialPollInterval: how long to wait before the first dwell milestone event
 * is fired (in seconds). Default = 5.
 * - pollBackoffRate: how much to multiply the last poll interval by on each dwell milestone.
 * event. Default = 2.
 * - idleTimeout: how long to wait for no user activity before pausing
 * the dwell timer (in seconds). Default = 30s.
 * @param {?DwellTimeHelperOptions} dwellTimeHelperOptions - options provided to customise behaviour
 * of the helper.
 * - iframeDwell = enable detection of activity in iframes.
 */ function DwellTimeHelper(trackCallback, _eventData, _searchSessionId, timingOptions, dwellTimeHelperOptions) {
    var _this = this;
    (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, DwellTimeHelper);
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "timeMeInitialized", false);
    /**
   * Starts the dwell timer. This method should be called upon the initial page load.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "start", function() {
        if (_this.timeMeInitialized) throw new Error('DwellTimeHelper should only be initialised once per page load.');
        _this.timeMeInitialized = true;
        _this._initDwellTimeCounterAndPolling();
        if (typeof window !== 'undefined') window.addEventListener('beforeunload', function() {
            _this.stop();
        });
    });
    /**
   * Stops the dwell timer and sends the final dwell event. Call this method if you wish to
   * finalise a dwell measurement without starting a new one. When switching to a new page in a
   * single-page app, use newPage instead.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "stop", function() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).isUserCurrentlyOnPage) _this._sendDwellEvent(_this._eventData, _this._searchSessionId, true);
        (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).stopAllTimers();
        (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).resetAllRecordedPageTimes();
        (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).timeElapsedCallbacks = [];
        _this.timeMeInitialized = false;
    });
    /**
   * Send the final dwell event and reinitialise the dwell timer for a new page.
   * This method should be called whenever a new page is switched to in a single-page app context.
   *
   * @param {Object} eventData - the base data that will be added to the track event.
   * @param {?string} searchSessionId - the new search session ID.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "newPage", function(eventData, searchSessionId) {
        (0, $4tI8a.validateDwellBaseEvent)(eventData);
        _this.stop();
        _this._eventData = eventData;
        _this._searchSessionId = searchSessionId;
        _this._initDwellTimeCounterAndPolling();
    });
    /**
   * This is a modified version of timeit's original listForIdleEvents function,
   * which also listens to events inside same-origin iframes (such as Confluence whiteboards and databases).
   * https://github.com/jasonzissman/TimeMe.js/blob/master/timeme.js#L338
   */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_listForIdleEvents", function() {
        document.addEventListener('mousemove', function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).userActivityDetected();
        });
        document.addEventListener('keyup', function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).userActivityDetected();
        });
        document.addEventListener('touchstart', function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).userActivityDetected();
        });
        window.addEventListener('scroll', function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).userActivityDetected();
        });
        /**
     * Find all same origin iframes (same origin allow access to contentWindow.document)
     * and add event listeners to them too.
     */ var iframes = document.getElementsByTagName('iframe');
        for(var i = 0; i < iframes.length; i++){
            var iframe = iframes[i];
            try {
                var _iframe$contentWindow, _iframe$contentWindow2, _iframe$contentWindow3;
                iframe === null || iframe === void 0 || (_iframe$contentWindow = iframe.contentWindow) === null || _iframe$contentWindow === void 0 || _iframe$contentWindow.document.addEventListener('mousemove', function() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).userActivityDetected();
                });
                iframe === null || iframe === void 0 || (_iframe$contentWindow2 = iframe.contentWindow) === null || _iframe$contentWindow2 === void 0 || _iframe$contentWindow2.document.addEventListener('keyup', function() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).userActivityDetected();
                });
                iframe === null || iframe === void 0 || (_iframe$contentWindow3 = iframe.contentWindow) === null || _iframe$contentWindow3 === void 0 || _iframe$contentWindow3.document.addEventListener('touchstart', function() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).userActivityDetected();
                });
            } catch (e) {
            // do nothing: We don't want to listen to cross-origin iframes
            }
        }
        setInterval(function() {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).isUserCurrentlyIdle !== true) {
                (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).checkIdleState();
                // This ensures the timer continues when switching between the iframe and the rest of the page
                (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).startTimer();
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).checkIdleStateRateMs);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_initDwellTimeCounterAndPolling", function() {
        var _this$_dwellTimeHelpe;
        // If iframeDwell is enabled, override the listener for idle events to also listen to events in iframes.
        if ((_this$_dwellTimeHelpe = _this._dwellTimeHelperOptions) !== null && _this$_dwellTimeHelpe !== void 0 && _this$_dwellTimeHelpe.iframeDwell) (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).listForIdleEvents = _this._listForIdleEvents;
        (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).initialize({
            idleTimeoutInSeconds: _this._timing.idleTimeout
        });
        _this._pollDwellTime(_this._timing.initialPollInterval, _this._searchSessionId, _this._eventData);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_pollDwellTime", function(pollTime, searchSessionId, eventData) {
        (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).callAfterTimeElapsedInSeconds(pollTime, function() {
            _this._sendDwellEvent(eventData, searchSessionId, false);
            _this._pollDwellTime(pollTime * _this._timing.pollBackoffRate, searchSessionId, eventData);
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_sendDwellEvent", function(eventData, searchSessionId, isFinalDwellEvent) {
        var dwellAttributes = {
            dwellTime: (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).getTimeOnCurrentPageInMilliseconds(),
            searchReferrer: searchSessionId,
            finalDwellEvent: isFinalDwellEvent
        };
        _this._trackCallback({
            action: 'dwelled',
            actionSubject: eventData.actionSubject,
            actionSubjectId: eventData.actionSubjectId,
            source: eventData.source,
            containerType: eventData.containerType,
            containerId: eventData.containerId,
            containers: eventData.containers,
            objectType: eventData.objectType,
            objectId: eventData.objectId,
            attributes: $d265dfee85eca2f5$var$_objectSpread($d265dfee85eca2f5$var$_objectSpread({}, dwellAttributes), eventData.attributes),
            tags: eventData.tags
        });
    });
    if (!trackCallback) throw new Error('trackCallback is required for DwellTimeHelper');
    (0, $4tI8a.validateDwellBaseEvent)(_eventData);
    this._trackCallback = trackCallback;
    this._eventData = _eventData;
    this._searchSessionId = _searchSessionId;
    this._timing = $d265dfee85eca2f5$var$_objectSpread($d265dfee85eca2f5$var$_objectSpread({}, $d265dfee85eca2f5$var$DEFAULT_TIMING), timingOptions);
    this._dwellTimeHelperOptions = dwellTimeHelperOptions;
});

});
parcelRegister("2HsPW", function(module, exports) {
/*Copyright (c) 2020 Jason Zissman
Permission is hereby granted, free of charge, to any person obtaining a copy of
this software and associated documentation files (the "Software"), to deal in
the Software without restriction, including without limitation the rights to
use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
the Software, and to permit persons to whom the Software is furnished to do so,
subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/ (()=>{
    ((root, factory)=>{
        if (module.exports) // CommonJS
        return module.exports = factory();
        else if (typeof define === 'function' && define.amd) // AMD
        define([], ()=>{
            return root.TimeMe = factory();
        });
        else // Global Variables
        return root.TimeMe = factory();
    })(module.exports, ()=>{
        let TimeMe = {
            startStopTimes: {},
            idleTimeoutMs: 30000,
            currentIdleTimeMs: 0,
            checkIdleStateRateMs: 250,
            isUserCurrentlyOnPage: true,
            isUserCurrentlyIdle: false,
            currentPageName: "default-page-name",
            timeElapsedCallbacks: [],
            userLeftCallbacks: [],
            userReturnCallbacks: [],
            trackTimeOnElement: (elementId)=>{
                let element = document.getElementById(elementId);
                if (element) {
                    element.addEventListener("mouseover", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("mousemove", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("mouseleave", ()=>{
                        TimeMe.stopTimer(elementId);
                    });
                    element.addEventListener("keypress", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("focus", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                }
            },
            getTimeOnElementInSeconds: (elementId)=>{
                let time = TimeMe.getTimeOnPageInSeconds(elementId);
                if (time) return time;
                else return 0;
            },
            // startTime is optional. If provided, must be of type Date(). By providing
            // startTime, you are overriding the internal timing mechanism and manually
            // indicating the start time.
            startTimer: (pageName, startTime)=>{
                if (!pageName) pageName = TimeMe.currentPageName;
                if (TimeMe.startStopTimes[pageName] === undefined) TimeMe.startStopTimes[pageName] = [];
                else {
                    let arrayOfTimes = TimeMe.startStopTimes[pageName];
                    let latestStartStopEntry = arrayOfTimes[arrayOfTimes.length - 1];
                    if (latestStartStopEntry !== undefined && latestStartStopEntry.stopTime === undefined) // Can't start new timer until previous finishes.
                    return;
                }
                TimeMe.startStopTimes[pageName].push({
                    "startTime": startTime || new Date(),
                    "stopTime": undefined
                });
            },
            stopAllTimers: ()=>{
                let pageNames = Object.keys(TimeMe.startStopTimes);
                for(let i = 0; i < pageNames.length; i++)TimeMe.stopTimer(pageNames[i]);
            },
            // stopTime is optional. If provided, must be of type Date(). By providing
            // stopTime, you are overriding the internal timing mechanism and manually
            // indicating the stop time.
            stopTimer: (pageName, stopTime)=>{
                if (!pageName) pageName = TimeMe.currentPageName;
                let arrayOfTimes = TimeMe.startStopTimes[pageName];
                if (arrayOfTimes === undefined || arrayOfTimes.length === 0) // Can't stop timer before you've started it.
                return;
                if (arrayOfTimes[arrayOfTimes.length - 1].stopTime === undefined) arrayOfTimes[arrayOfTimes.length - 1].stopTime = stopTime || new Date();
            },
            getTimeOnCurrentPageInSeconds: ()=>{
                return TimeMe.getTimeOnPageInSeconds(TimeMe.currentPageName);
            },
            getTimeOnPageInSeconds: (pageName)=>{
                let timeInMs = TimeMe.getTimeOnPageInMilliseconds(pageName);
                if (timeInMs === undefined) return undefined;
                else return timeInMs / 1000;
            },
            getTimeOnCurrentPageInMilliseconds: ()=>{
                return TimeMe.getTimeOnPageInMilliseconds(TimeMe.currentPageName);
            },
            getTimeOnPageInMilliseconds: (pageName)=>{
                let totalTimeOnPage = 0;
                let arrayOfTimes = TimeMe.startStopTimes[pageName];
                if (arrayOfTimes === undefined) // Can't get time on page before you've started the timer.
                return;
                let timeSpentOnPageInSeconds = 0;
                for(let i = 0; i < arrayOfTimes.length; i++){
                    let startTime = arrayOfTimes[i].startTime;
                    let stopTime = arrayOfTimes[i].stopTime;
                    if (stopTime === undefined) stopTime = new Date();
                    let difference = stopTime - startTime;
                    timeSpentOnPageInSeconds += difference;
                }
                totalTimeOnPage = Number(timeSpentOnPageInSeconds);
                return totalTimeOnPage;
            },
            getTimeOnAllPagesInSeconds: ()=>{
                let allTimes = [];
                let pageNames = Object.keys(TimeMe.startStopTimes);
                for(let i = 0; i < pageNames.length; i++){
                    let pageName = pageNames[i];
                    let timeOnPage = TimeMe.getTimeOnPageInSeconds(pageName);
                    allTimes.push({
                        "pageName": pageName,
                        "timeOnPage": timeOnPage
                    });
                }
                return allTimes;
            },
            setIdleDurationInSeconds: (duration)=>{
                let durationFloat = parseFloat(duration);
                if (isNaN(durationFloat) === false) TimeMe.idleTimeoutMs = duration * 1000;
                else throw {
                    name: "InvalidDurationException",
                    message: "An invalid duration time (" + duration + ") was provided."
                };
            },
            setCurrentPageName: (pageName)=>{
                TimeMe.currentPageName = pageName;
            },
            resetRecordedPageTime: (pageName)=>{
                delete TimeMe.startStopTimes[pageName];
            },
            resetAllRecordedPageTimes: ()=>{
                let pageNames = Object.keys(TimeMe.startStopTimes);
                for(let i = 0; i < pageNames.length; i++)TimeMe.resetRecordedPageTime(pageNames[i]);
            },
            userActivityDetected: ()=>{
                if (TimeMe.isUserCurrentlyIdle) TimeMe.triggerUserHasReturned();
                TimeMe.resetIdleCountdown();
            },
            resetIdleCountdown: ()=>{
                TimeMe.isUserCurrentlyIdle = false;
                TimeMe.currentIdleTimeMs = 0;
            },
            callWhenUserLeaves: (callback, numberOfTimesToInvoke)=>{
                TimeMe.userLeftCallbacks.push({
                    callback: callback,
                    numberOfTimesToInvoke: numberOfTimesToInvoke
                });
            },
            callWhenUserReturns: (callback, numberOfTimesToInvoke)=>{
                TimeMe.userReturnCallbacks.push({
                    callback: callback,
                    numberOfTimesToInvoke: numberOfTimesToInvoke
                });
            },
            triggerUserHasReturned: ()=>{
                if (!TimeMe.isUserCurrentlyOnPage) {
                    TimeMe.isUserCurrentlyOnPage = true;
                    TimeMe.resetIdleCountdown();
                    for(let i = 0; i < TimeMe.userReturnCallbacks.length; i++){
                        let userReturnedCallback = TimeMe.userReturnCallbacks[i];
                        let numberTimes = userReturnedCallback.numberOfTimesToInvoke;
                        if (isNaN(numberTimes) || numberTimes === undefined || numberTimes > 0) {
                            userReturnedCallback.numberOfTimesToInvoke -= 1;
                            userReturnedCallback.callback();
                        }
                    }
                }
                TimeMe.startTimer();
            },
            // TODO - we are muddying the waters in between
            // 'user left page' and 'user gone idle'. Really should be
            // two separate concepts entirely. Need to break this into smaller  functions
            // for either scenario.
            triggerUserHasLeftPageOrGoneIdle: ()=>{
                if (TimeMe.isUserCurrentlyOnPage) {
                    TimeMe.isUserCurrentlyOnPage = false;
                    for(let i = 0; i < TimeMe.userLeftCallbacks.length; i++){
                        let userHasLeftCallback = TimeMe.userLeftCallbacks[i];
                        let numberTimes = userHasLeftCallback.numberOfTimesToInvoke;
                        if (isNaN(numberTimes) || numberTimes === undefined || numberTimes > 0) {
                            userHasLeftCallback.numberOfTimesToInvoke -= 1;
                            userHasLeftCallback.callback();
                        }
                    }
                }
                TimeMe.stopAllTimers();
            },
            callAfterTimeElapsedInSeconds: (timeInSeconds, callback)=>{
                TimeMe.timeElapsedCallbacks.push({
                    timeInSeconds: timeInSeconds,
                    callback: callback,
                    pending: true
                });
            },
            checkIdleState: ()=>{
                for(let i = 0; i < TimeMe.timeElapsedCallbacks.length; i++)if (TimeMe.timeElapsedCallbacks[i].pending && TimeMe.getTimeOnCurrentPageInSeconds() > TimeMe.timeElapsedCallbacks[i].timeInSeconds) {
                    TimeMe.timeElapsedCallbacks[i].callback();
                    TimeMe.timeElapsedCallbacks[i].pending = false;
                }
                if (TimeMe.isUserCurrentlyIdle === false && TimeMe.currentIdleTimeMs > TimeMe.idleTimeoutMs) {
                    TimeMe.isUserCurrentlyIdle = true;
                    TimeMe.triggerUserHasLeftPageOrGoneIdle();
                } else TimeMe.currentIdleTimeMs += TimeMe.checkIdleStateRateMs;
            },
            visibilityChangeEventName: undefined,
            hiddenPropName: undefined,
            listenForVisibilityEvents: (trackWhenUserLeavesPage, trackWhenUserGoesIdle)=>{
                if (trackWhenUserLeavesPage) TimeMe.listenForUserLeavesOrReturnsEvents();
                if (trackWhenUserGoesIdle) TimeMe.listForIdleEvents();
            },
            listenForUserLeavesOrReturnsEvents: ()=>{
                if (typeof document.hidden !== "undefined") {
                    TimeMe.hiddenPropName = "hidden";
                    TimeMe.visibilityChangeEventName = "visibilitychange";
                } else if (typeof document.mozHidden !== "undefined") {
                    TimeMe.hiddenPropName = "mozHidden";
                    TimeMe.visibilityChangeEventName = "mozvisibilitychange";
                } else if (typeof document.msHidden !== "undefined") {
                    TimeMe.hiddenPropName = "msHidden";
                    TimeMe.visibilityChangeEventName = "msvisibilitychange";
                } else if (typeof document.webkitHidden !== "undefined") {
                    TimeMe.hiddenPropName = "webkitHidden";
                    TimeMe.visibilityChangeEventName = "webkitvisibilitychange";
                }
                document.addEventListener(TimeMe.visibilityChangeEventName, ()=>{
                    if (document[TimeMe.hiddenPropName]) TimeMe.triggerUserHasLeftPageOrGoneIdle();
                    else TimeMe.triggerUserHasReturned();
                }, false);
                window.addEventListener('blur', ()=>{
                    TimeMe.triggerUserHasLeftPageOrGoneIdle();
                });
                window.addEventListener('focus', ()=>{
                    TimeMe.triggerUserHasReturned();
                });
            },
            listForIdleEvents: ()=>{
                document.addEventListener("mousemove", ()=>{
                    TimeMe.userActivityDetected();
                });
                document.addEventListener("keyup", ()=>{
                    TimeMe.userActivityDetected();
                });
                document.addEventListener("touchstart", ()=>{
                    TimeMe.userActivityDetected();
                });
                window.addEventListener("scroll", ()=>{
                    TimeMe.userActivityDetected();
                });
                setInterval(()=>{
                    if (TimeMe.isUserCurrentlyIdle !== true) TimeMe.checkIdleState();
                }, TimeMe.checkIdleStateRateMs);
            },
            websocket: undefined,
            websocketHost: undefined,
            setUpWebsocket: (websocketOptions)=>{
                if (window.WebSocket && websocketOptions) {
                    let websocketHost = websocketOptions.websocketHost; // "ws://hostname:port"
                    try {
                        TimeMe.websocket = new WebSocket(websocketHost);
                        window.onbeforeunload = ()=>{
                            TimeMe.sendCurrentTime(websocketOptions.appId);
                        };
                        TimeMe.websocket.onopen = ()=>{
                            TimeMe.sendInitWsRequest(websocketOptions.appId);
                        };
                        TimeMe.websocket.onerror = (error)=>{
                            if (console) console.log("Error occurred in websocket connection: " + error);
                        };
                        TimeMe.websocket.onmessage = (event)=>{
                            if (console) console.log(event.data);
                        };
                    } catch (error) {
                        if (console) console.error("Failed to connect to websocket host.  Error:" + error);
                    }
                }
            },
            websocketSend: (data)=>{
                TimeMe.websocket.send(JSON.stringify(data));
            },
            sendCurrentTime: (appId)=>{
                let timeSpentOnPage = TimeMe.getTimeOnCurrentPageInMilliseconds();
                let data = {
                    type: "INSERT_TIME",
                    appId: appId,
                    timeOnPageMs: timeSpentOnPage,
                    pageName: TimeMe.currentPageName
                };
                TimeMe.websocketSend(data);
            },
            sendInitWsRequest: (appId)=>{
                let data = {
                    type: "INIT",
                    appId: appId
                };
                TimeMe.websocketSend(data);
            },
            initialize: (options)=>{
                let idleTimeoutInSeconds = TimeMe.idleTimeoutMs || 30;
                let currentPageName = TimeMe.currentPageName || "default-page-name";
                let websocketOptions = undefined;
                let initialStartTime = undefined;
                let trackWhenUserLeavesPage = true;
                let trackWhenUserGoesIdle = true;
                if (options) {
                    idleTimeoutInSeconds = options.idleTimeoutInSeconds || idleTimeoutInSeconds;
                    currentPageName = options.currentPageName || currentPageName;
                    websocketOptions = options.websocketOptions;
                    initialStartTime = options.initialStartTime;
                    if (options.trackWhenUserLeavesPage === false) trackWhenUserLeavesPage = false;
                    if (options.trackWhenUserGoesIdle === false) trackWhenUserGoesIdle = false;
                }
                TimeMe.setIdleDurationInSeconds(idleTimeoutInSeconds);
                TimeMe.setCurrentPageName(currentPageName);
                TimeMe.setUpWebsocket(websocketOptions);
                TimeMe.listenForVisibilityEvents(trackWhenUserLeavesPage, trackWhenUserGoesIdle);
                // TODO - only do this if page currently visible.
                TimeMe.startTimer(undefined, initialStartTime);
            }
        };
        return TimeMe;
    });
}).call(module.exports);

});

parcelRegister("4tI8a", function(module, exports) {
$parcel$export(module.exports, "validateDwellBaseEvent", () => $342c1a4e360e5895$export$39d6334da9a44984);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ function $342c1a4e360e5895$export$39d6334da9a44984(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
}

});


parcelRegister("lDnl8", function(module, exports) {
$parcel$export(module.exports, "default", () => $fbff584de572cd84$export$2e2bcd8739ae039);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $25nEq = parcelRequire("25nEq");

var $jvN07 = parcelRequire("jvN07");

var $4tI8a = parcelRequire("4tI8a");
function $fbff584de572cd84$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fbff584de572cd84$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fbff584de572cd84$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fbff584de572cd84$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fbff584de572cd84$var$DEFAULT_TIMING = {
    initialPollInterval: 5000,
    idleTimeout: 30000,
    multiplierCallback: function multiplierCallback(x) {
        return x + x;
    }
};
/**
 * Helper class to record the amount of time a user has spent on a page.
 *
 * Two kinds of dwell events are fired. Dwell milestone events are fired periodically while the
 * user is on the page, at increasing intervals (by default, 5s, 10s, 20s, 40s, etc.). A final
 * dwell event will also be fired when the user leaves the page.
 *
 * Note that the event data passed to this helper should be compatible with a 'track' event.
 * See https://extranet.atlassian.com/display/PData/Track+Events for more information.
 *
 * Example usage:
 *
 * const baseEventData = {
 *   actionSubject: 'page',
 *   actionSubjectId: 'aa4fd6c5-28f4-40fa-807a-765a39957cb5',
 *   source: 'page',
 *   containerType: 'space',
 *   containerId: '340f1acf-d15b-4677-88c6-4671d23fb131',
 * }
 *
 * const helper = new DwellTimeHelper(sendTrackEventFunction, baseEventData, searchSessionId)
 * helper.start();
 */ var $fbff584de572cd84$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(/**
 * Callback for sending a 'track' analytics event. This callback should either be the
 * 'sendTrackEvent' method on the AnalyticsWebClient, or a method that eventually delegates to it.
 * The data for the dwell event will be passed to this method for sending.
 *
 * @callback trackCallback
 * @param {Object} eventData - the base event data that will be added to the track event.
 */ /**
 * Creates and initialises the DwellTimeHelper.
 *
 * @param {trackCallback} trackCallback - the track callback responsible for actually sending
 * the event.
 * @param {Object} eventData - the base data that will be added to the track event.
 * Additional dwell time attributes will be appended to this data. Note that you don't need to
 * include the 'action' property, as this will be added automatically.
 * @param {?string} searchSessionId - a unique identifier for the related search session.
 * @param {?Object} timingOptions - for the purpose of debugging, you can override the default
 * timing used for measuring dwell time. The following values are possible:
 * - initialPollInterval: how long to wait before the first dwell milestone event
 * is fired (in seconds). Default = 5.
 * - pollBackoffRate: how much to multiply the last poll interval by on each dwell milestone.
 * event. Default = 2.
 * - idleTimeout: how long to wait for no user activity before pausing
 * the dwell timer (in seconds). Default = 30s.
 */ function DwellTimeHelper(trackCallback, _eventData, _searchSessionId, timingOptions) {
    var _this = this;
    (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, DwellTimeHelper);
    /**
   * Starts the dwell timer. This method should be called upon the initial page load.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "start", function() {
        _this.browserInteractionTime.startTimer();
        _this.browserInteractionTime.addTimeIntervalEllapsedCallback({
            callback: function callback(timeInMilliseconds) {
                return _this._sendDwellEvent(_this._eventData, _this._searchSessionId, timeInMilliseconds, false);
            },
            timeInMilliseconds: _this._timing.initialPollInterval,
            multiplier: _this._timing.multiplierCallback
        });
        if (typeof window !== 'undefined') window.addEventListener('beforeunload', _this._onBeforeUnload);
    });
    /**
   * Stops the dwell timer and sends the final dwell event. Call this method if you wish to
   * finalise a dwell measurement without starting a new one. When switching to a new page in a
   * single-page app, use newPage instead.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "stop", function() {
        if (_this.browserInteractionTime.isRunning()) _this._sendDwellEvent(_this._eventData, _this._searchSessionId, _this.browserInteractionTime.getTimeInMilliseconds(), true);
        _this.browserInteractionTime.stopTimer();
    });
    /**
   * Send the final dwell event and reinitialise the dwell timer for a new page.
   * This method should be called whenever a new page is switched to in a single-page app context.
   *
   * @param {Object} eventData - the base data that will be added to the track event.
   * @param {?string} searchSessionId - the new search session ID.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "newPage", function(eventData, searchSessionId) {
        (0, $4tI8a.validateDwellBaseEvent)(eventData);
        _this.stop();
        _this.browserInteractionTime.reset();
        _this.setEventData(eventData);
        _this.setSearchSessionId(searchSessionId);
        _this.start();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setEventData", function(eventData) {
        _this._eventData = eventData;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getEventData", function() {
        return _this._eventData;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setSearchSessionId", function(searchSessionId) {
        _this._searchSessionId = searchSessionId;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getSearchSessionId", function() {
        return _this._searchSessionId;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "destroy", function() {
        _this.browserInteractionTime.destroy();
        if (typeof window !== 'undefined') window.removeEventListener('beforeunload', _this._onBeforeUnload);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_onBeforeUnload", function() {
        _this.stop();
        _this.destroy();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_sendDwellEvent", function(eventData, searchSessionId, timeInMilliseconds, isFinalDwellEvent) {
        var dwellAttributes = {
            dwellTime: timeInMilliseconds,
            searchReferrer: searchSessionId,
            finalDwellEvent: isFinalDwellEvent
        };
        _this._trackCallback({
            action: 'dwelled',
            actionSubject: eventData.actionSubject,
            actionSubjectId: eventData.actionSubjectId,
            source: eventData.source,
            containerType: eventData.containerType,
            containerId: eventData.containerId,
            objectType: eventData.objectType,
            objectId: eventData.objectId,
            attributes: $fbff584de572cd84$var$_objectSpread($fbff584de572cd84$var$_objectSpread({}, dwellAttributes), eventData.attributes),
            tags: eventData.tags
        });
    });
    if (!trackCallback) throw new Error('trackCallback is required for DwellTimeHelper');
    (0, $4tI8a.validateDwellBaseEvent)(_eventData);
    this._trackCallback = trackCallback;
    this._eventData = _eventData;
    this._searchSessionId = _searchSessionId;
    this._timing = $fbff584de572cd84$var$_objectSpread($fbff584de572cd84$var$_objectSpread({}, $fbff584de572cd84$var$DEFAULT_TIMING), timingOptions);
    this.browserInteractionTime = new (0, $jvN07.default)({
        idleTimeoutMs: this._timing.idleTimeout,
        checkCallbacksIntervalMs: 500
    });
});

});
parcelRegister("jvN07", function(module, exports) {
$parcel$export(module.exports, "default", () => $e346ec1cd3eefb72$export$2e2bcd8739ae039);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ var $e346ec1cd3eefb72$var$__assign = function() {
    $e346ec1cd3eefb72$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e346ec1cd3eefb72$var$__assign.apply(this, arguments);
};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $e346ec1cd3eefb72$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $e346ec1cd3eefb72$var$isObject_1 = $e346ec1cd3eefb72$var$isObject;
var $e346ec1cd3eefb72$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
/** Detect free variable `global` from Node.js. */ var $e346ec1cd3eefb72$var$freeGlobal = typeof $e346ec1cd3eefb72$var$commonjsGlobal == 'object' && $e346ec1cd3eefb72$var$commonjsGlobal && $e346ec1cd3eefb72$var$commonjsGlobal.Object === Object && $e346ec1cd3eefb72$var$commonjsGlobal;
var $e346ec1cd3eefb72$var$_freeGlobal = $e346ec1cd3eefb72$var$freeGlobal;
/** Detect free variable `self`. */ var $e346ec1cd3eefb72$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $e346ec1cd3eefb72$var$root = $e346ec1cd3eefb72$var$_freeGlobal || $e346ec1cd3eefb72$var$freeSelf || Function('return this')();
var $e346ec1cd3eefb72$var$_root = $e346ec1cd3eefb72$var$root;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $e346ec1cd3eefb72$var$now = function() {
    return $e346ec1cd3eefb72$var$_root.Date.now();
};
var $e346ec1cd3eefb72$var$now_1 = $e346ec1cd3eefb72$var$now;
/** Built-in value references. */ var $e346ec1cd3eefb72$var$Symbol = $e346ec1cd3eefb72$var$_root.Symbol;
var $e346ec1cd3eefb72$var$_Symbol = $e346ec1cd3eefb72$var$Symbol;
/** Used for built-in method references. */ var $e346ec1cd3eefb72$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e346ec1cd3eefb72$var$hasOwnProperty = $e346ec1cd3eefb72$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e346ec1cd3eefb72$var$nativeObjectToString = $e346ec1cd3eefb72$var$objectProto.toString;
/** Built-in value references. */ var $e346ec1cd3eefb72$var$symToStringTag = $e346ec1cd3eefb72$var$_Symbol ? $e346ec1cd3eefb72$var$_Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $e346ec1cd3eefb72$var$getRawTag(value) {
    var isOwn = $e346ec1cd3eefb72$var$hasOwnProperty.call(value, $e346ec1cd3eefb72$var$symToStringTag), tag = value[$e346ec1cd3eefb72$var$symToStringTag];
    try {
        value[$e346ec1cd3eefb72$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $e346ec1cd3eefb72$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$e346ec1cd3eefb72$var$symToStringTag] = tag;
        else delete value[$e346ec1cd3eefb72$var$symToStringTag];
    }
    return result;
}
var $e346ec1cd3eefb72$var$_getRawTag = $e346ec1cd3eefb72$var$getRawTag;
/** Used for built-in method references. */ var $e346ec1cd3eefb72$var$objectProto$1 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e346ec1cd3eefb72$var$nativeObjectToString$1 = $e346ec1cd3eefb72$var$objectProto$1.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $e346ec1cd3eefb72$var$objectToString(value) {
    return $e346ec1cd3eefb72$var$nativeObjectToString$1.call(value);
}
var $e346ec1cd3eefb72$var$_objectToString = $e346ec1cd3eefb72$var$objectToString;
/** `Object#toString` result references. */ var $e346ec1cd3eefb72$var$nullTag = '[object Null]', $e346ec1cd3eefb72$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $e346ec1cd3eefb72$var$symToStringTag$1 = $e346ec1cd3eefb72$var$_Symbol ? $e346ec1cd3eefb72$var$_Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $e346ec1cd3eefb72$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $e346ec1cd3eefb72$var$undefinedTag : $e346ec1cd3eefb72$var$nullTag;
    return $e346ec1cd3eefb72$var$symToStringTag$1 && $e346ec1cd3eefb72$var$symToStringTag$1 in Object(value) ? $e346ec1cd3eefb72$var$_getRawTag(value) : $e346ec1cd3eefb72$var$_objectToString(value);
}
var $e346ec1cd3eefb72$var$_baseGetTag = $e346ec1cd3eefb72$var$baseGetTag;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $e346ec1cd3eefb72$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $e346ec1cd3eefb72$var$isObjectLike_1 = $e346ec1cd3eefb72$var$isObjectLike;
/** `Object#toString` result references. */ var $e346ec1cd3eefb72$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $e346ec1cd3eefb72$var$isSymbol(value) {
    return typeof value == 'symbol' || $e346ec1cd3eefb72$var$isObjectLike_1(value) && $e346ec1cd3eefb72$var$_baseGetTag(value) == $e346ec1cd3eefb72$var$symbolTag;
}
var $e346ec1cd3eefb72$var$isSymbol_1 = $e346ec1cd3eefb72$var$isSymbol;
/** Used as references for various `Number` constants. */ var $e346ec1cd3eefb72$var$NAN = 0 / 0;
/** Used to match leading and trailing whitespace. */ var $e346ec1cd3eefb72$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $e346ec1cd3eefb72$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $e346ec1cd3eefb72$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $e346ec1cd3eefb72$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $e346ec1cd3eefb72$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $e346ec1cd3eefb72$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($e346ec1cd3eefb72$var$isSymbol_1(value)) return $e346ec1cd3eefb72$var$NAN;
    if ($e346ec1cd3eefb72$var$isObject_1(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $e346ec1cd3eefb72$var$isObject_1(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($e346ec1cd3eefb72$var$reTrim, '');
    var isBinary = $e346ec1cd3eefb72$var$reIsBinary.test(value);
    return isBinary || $e346ec1cd3eefb72$var$reIsOctal.test(value) ? $e346ec1cd3eefb72$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $e346ec1cd3eefb72$var$reIsBadHex.test(value) ? $e346ec1cd3eefb72$var$NAN : +value;
}
var $e346ec1cd3eefb72$var$toNumber_1 = $e346ec1cd3eefb72$var$toNumber;
/** Error message constants. */ var $e346ec1cd3eefb72$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e346ec1cd3eefb72$var$nativeMax = Math.max, $e346ec1cd3eefb72$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $e346ec1cd3eefb72$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($e346ec1cd3eefb72$var$FUNC_ERROR_TEXT);
    wait = $e346ec1cd3eefb72$var$toNumber_1(wait) || 0;
    if ($e346ec1cd3eefb72$var$isObject_1(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $e346ec1cd3eefb72$var$nativeMax($e346ec1cd3eefb72$var$toNumber_1(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $e346ec1cd3eefb72$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $e346ec1cd3eefb72$var$now_1();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($e346ec1cd3eefb72$var$now_1());
    }
    function debounced() {
        var time = $e346ec1cd3eefb72$var$now_1(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $e346ec1cd3eefb72$var$debounce_1 = $e346ec1cd3eefb72$var$debounce;
/** Error message constants. */ var $e346ec1cd3eefb72$var$FUNC_ERROR_TEXT$1 = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $e346ec1cd3eefb72$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($e346ec1cd3eefb72$var$FUNC_ERROR_TEXT$1);
    if ($e346ec1cd3eefb72$var$isObject_1(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $e346ec1cd3eefb72$var$debounce_1(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
var $e346ec1cd3eefb72$var$throttle_1 = $e346ec1cd3eefb72$var$throttle;
var $e346ec1cd3eefb72$var$windowIdleEvents = [
    'scroll',
    'resize'
];
var $e346ec1cd3eefb72$var$documentIdleEvents = [
    'wheel',
    'keydown',
    'keyup',
    'mousedown',
    'mousemove',
    'touchstart',
    'touchmove',
    'click',
    'contextmenu'
];
var $e346ec1cd3eefb72$var$BrowserInteractionTime = /** @class */ function() {
    function BrowserInteractionTime(_a) {
        var _b = _a.timeIntervalEllapsedCallbacks, timeIntervalEllapsedCallbacks = _b === void 0 ? [] : _b, _c = _a.absoluteTimeEllapsedCallbacks, absoluteTimeEllapsedCallbacks = _c === void 0 ? [] : _c, _d = _a.checkCallbacksIntervalMs, checkCallbacksIntervalMs = _d === void 0 ? 100 : _d, _e = _a.browserTabInactiveCallbacks, browserTabInactiveCallbacks = _e === void 0 ? [] : _e, _f = _a.idleCallbacks, idleCallbacks = _f === void 0 ? [] : _f, _g = _a.stopTimerOnTabchange, stopTimerOnTabchange = _g === void 0 ? true : _g, _h = _a.activeCallbacks, activeCallbacks = _h === void 0 ? [] : _h, _j = _a.browserTabActiveCallbacks, browserTabActiveCallbacks = _j === void 0 ? [] : _j, _k = _a.idleTimeoutMs, idleTimeoutMs = _k === void 0 ? 3000 : _k;
        var _this = this;
        this.onBrowserTabInactive = function() {
            // if running pause timer
            if (_this.isRunning() && _this.stopTimerOnTabchange) _this.stopTimer();
            _this.browserTabInactiveCallbacks.forEach(function(fn) {
                return fn(_this.getTimeInMilliseconds());
            });
        };
        this.onBrowserTabActive = function() {
            // if not running start timer
            if (!_this.isRunning()) _this.startTimer();
            _this.browserTabActiveCallbacks.forEach(function(fn) {
                return fn(_this.getTimeInMilliseconds());
            });
        };
        this.onBrowserActiveChange = function() {
            if (document.visibilityState === 'visible') _this.onBrowserTabActive();
            else _this.onBrowserTabInactive();
        };
        this.onTimePassed = function() {
            // check all callbacks time and if passed execute callback
            _this.absoluteTimeEllapsedCallbacks.forEach(function(_a, index) {
                var callback = _a.callback, pending = _a.pending, timeInMilliseconds = _a.timeInMilliseconds;
                if (pending && timeInMilliseconds <= _this.getTimeInMilliseconds()) {
                    callback(_this.getTimeInMilliseconds());
                    _this.absoluteTimeEllapsedCallbacks[index].pending = false;
                }
            });
            _this.timeIntervalEllapsedCallbacks.forEach(function(_a, index) {
                var callback = _a.callback, timeInMilliseconds = _a.timeInMilliseconds, multiplier = _a.multiplier;
                if (timeInMilliseconds <= _this.getTimeInMilliseconds()) {
                    callback(_this.getTimeInMilliseconds());
                    _this.timeIntervalEllapsedCallbacks[index].timeInMilliseconds = multiplier(timeInMilliseconds);
                }
            });
            if (_this.currentIdleTimeMs >= _this.idleTimeoutMs && _this.isRunning()) {
                _this.idle = true;
                _this.stopTimer();
                _this.idleCallbacks.forEach(function(fn) {
                    return fn(_this.getTimeInMilliseconds());
                });
            } else _this.currentIdleTimeMs += _this.checkCallbacksIntervalMs;
        };
        this.resetIdleTime = function() {
            if (_this.idle) _this.startTimer();
            _this.activeCallbacks.forEach(function(fn) {
                return fn(_this.getTimeInMilliseconds());
            });
            _this.idle = false;
            _this.currentIdleTimeMs = 0;
        };
        this.registerEventListeners = function() {
            var documentListenerOptions = {
                passive: true
            };
            var windowListenerOptions = $e346ec1cd3eefb72$var$__assign({}, documentListenerOptions, {
                capture: true
            });
            document.addEventListener('visibilitychange', _this.onBrowserActiveChange);
            var throttleResetIdleTime = $e346ec1cd3eefb72$var$throttle_1(_this.resetIdleTime, 2000, {
                leading: true,
                trailing: false
            });
            $e346ec1cd3eefb72$var$windowIdleEvents.forEach(function(event) {
                window.addEventListener(event, throttleResetIdleTime, windowListenerOptions);
            });
            $e346ec1cd3eefb72$var$documentIdleEvents.forEach(function(event) {
                return document.addEventListener(event, throttleResetIdleTime, documentListenerOptions);
            });
        };
        this.unregisterEventListeners = function() {
            document.removeEventListener('visibilitychange', _this.onBrowserActiveChange);
            $e346ec1cd3eefb72$var$windowIdleEvents.forEach(function(event) {
                return window.removeEventListener(event, _this.resetIdleTime);
            });
            $e346ec1cd3eefb72$var$documentIdleEvents.forEach(function(event) {
                return document.removeEventListener(event, _this.resetIdleTime);
            });
        };
        this.checkCallbacksOnInterval = function() {
            _this.checkCallbackIntervalId = window.setInterval(function() {
                _this.onTimePassed();
            }, _this.checkCallbacksIntervalMs);
        };
        this.startTimer = function() {
            if (!_this.checkCallbackIntervalId) _this.checkCallbacksOnInterval();
            var last = _this.times[_this.times.length - 1];
            if (last && last.stop === null) return;
            _this.times.push({
                start: performance.now(),
                stop: null
            });
            _this.running = true;
        };
        this.stopTimer = function() {
            if (!_this.times.length) return;
            _this.times[_this.times.length - 1].stop = performance.now();
            _this.running = false;
        };
        this.addTimeIntervalEllapsedCallback = function(timeIntervalEllapsedCallback) {
            _this.timeIntervalEllapsedCallbacks.push(timeIntervalEllapsedCallback);
        };
        this.addAbsoluteTimeEllapsedCallback = function(absoluteTimeEllapsedCallback) {
            _this.absoluteTimeEllapsedCallbacks.push(absoluteTimeEllapsedCallback);
        };
        this.addBrowserTabInactiveCallback = function(browserTabInactiveCallback) {
            _this.browserTabInactiveCallbacks.push(browserTabInactiveCallback);
        };
        this.addBrowserTabActiveCallback = function(browserTabActiveCallback) {
            _this.browserTabActiveCallbacks.push(browserTabActiveCallback);
        };
        this.addIdleCallback = function(inactiveCallback) {
            _this.idleCallbacks.push(inactiveCallback);
        };
        this.addActiveCallback = function(activeCallback) {
            _this.activeCallbacks.push(activeCallback);
        };
        this.getTimeInMilliseconds = function() {
            return _this.times.reduce(function(acc, current) {
                if (current.stop) acc = acc + (current.stop - current.start);
                else acc = acc + (performance.now() - current.start);
                return acc;
            }, 0);
        };
        this.isRunning = function() {
            return _this.running;
        };
        this.isIdle = function() {
            return _this.idle;
        };
        this.reset = function() {
            _this.times = [];
        };
        this.destroy = function() {
            _this.unregisterEventListeners();
            if (_this.checkCallbackIntervalId) window.clearInterval(_this.checkCallbackIntervalId);
        };
        this.running = false;
        this.times = [];
        this.idle = false;
        this.currentIdleTimeMs = 0;
        this.marks = {};
        this.measures = {};
        this.stopTimerOnTabchange = stopTimerOnTabchange;
        this.browserTabActiveCallbacks = browserTabActiveCallbacks;
        this.browserTabInactiveCallbacks = browserTabInactiveCallbacks;
        this.checkCallbacksIntervalMs = checkCallbacksIntervalMs;
        this.idleTimeoutMs = idleTimeoutMs;
        this.timeIntervalEllapsedCallbacks = timeIntervalEllapsedCallbacks;
        this.absoluteTimeEllapsedCallbacks = absoluteTimeEllapsedCallbacks;
        this.idleCallbacks = idleCallbacks;
        this.activeCallbacks = activeCallbacks;
        this.registerEventListeners();
    }
    BrowserInteractionTime.prototype.mark = function(key) {
        if (!this.marks[key]) this.marks[key] = [];
        this.marks[key].push({
            time: this.getTimeInMilliseconds()
        });
    };
    BrowserInteractionTime.prototype.getMarks = function(name) {
        if (this.marks[name].length < 1) return;
        return this.marks[name];
    };
    BrowserInteractionTime.prototype.measure = function(name, startMarkName, endMarkName) {
        var startMarks = this.marks[startMarkName];
        var startMark = startMarks[startMarks.length - 1];
        var endMarks = this.marks[endMarkName];
        var endMark = endMarks[endMarks.length - 1];
        if (!this.measures[name]) this.measures[name] = [];
        this.measures[name].push({
            name: name,
            startTime: startMark.time,
            duration: endMark.time - startMark.time
        });
    };
    BrowserInteractionTime.prototype.getMeasures = function(name) {
        if (!this.measures[name] && this.measures[name].length < 1) return;
        return this.measures[name];
    };
    return BrowserInteractionTime;
}();
var $e346ec1cd3eefb72$export$2e2bcd8739ae039 = $e346ec1cd3eefb72$var$BrowserInteractionTime;

});


parcelRegister("lI9z0", function(module, exports) {
$parcel$export(module.exports, "default", () => $fce52030a1132d31$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $fce52030a1132d31$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fce52030a1132d31$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fce52030a1132d31$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fce52030a1132d31$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * TypeAheadHelper is helper file which assists in
 * tracking analytics around typeahead components, such as mentions, in
 * a consistent way. It generates objects that can be passed into
 * an instance of analyticsWebClient to trigger events.
 *
 * Example usage:
 *
 * const typeAheadHelper = new TypeAheadHelper(
 *   webClient.sendTrackEvent,
 *   baseEvent // an object containing the action + additional context attributes
 * );
 *
 * mentionHelper.search('abc');
 * mentionHelper.searched(resultsArray);
 * mentionHelper.selected(selectedIndex);
 */ function $fce52030a1132d31$var$combineWithBaseEvent(action, extraAttributes, baseEvent) {
    var event = $fce52030a1132d31$var$_objectSpread({
        action: action
    }, baseEvent);
    event.attributes = $fce52030a1132d31$var$_objectSpread($fce52030a1132d31$var$_objectSpread({}, extraAttributes), event.attributes);
    return event;
}
var $fce52030a1132d31$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new instance of TypeAheadHelper.
   *
   * @param {Function} onEvent the function to call when an analytics event must be fired.
   *  There will be one argument, the analytics event object.
   * @param {Object} baseEvent base event with action and context to use when triggering events.
   *  More details here: https://product-fabric.atlassian.net/wiki/x/XQCZFg
   */ function TypeAheadHelper(onEvent, baseEvent) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, TypeAheadHelper);
        this._onEvent = onEvent;
        this._baseEvent = baseEvent;
        this._searchStartedTime = null;
        this._lastQueryResultsTime = null;
        this._queryLength = null;
        this._baseEvent = $fce52030a1132d31$var$_objectSpread({}, baseEvent);
    }
    /**
   * Records the start time of the first web request
   * and a copy of the query length for sending later in an analytics event.
   *
   * It should be called before the web request is initially made.
   *
   * @param {String} query the string entered as the query
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(TypeAheadHelper, [
        {
            key: "search",
            value: function search(query) {
                if (!query && query !== '') throw new Error('Missing query param');
                this._searchStartedTime = Date.now();
                this._queryLength = (query || '').length;
            }
        },
        {
            key: "searched",
            value: function searched(results) {
                if (!results) throw new Error('Missing results param');
                if (this._queryLength === null) throw new Error('search() must be called before searched().');
                var responseTimeMs = Date.now() - this._searchStartedTime;
                this._lastQueryResultsTime = Date.now();
                this._lastResults = results;
                var extraAttributes = {
                    responseTimeMs: responseTimeMs,
                    queryLength: this._queryLength,
                    results: results
                };
                var event = $fce52030a1132d31$var$combineWithBaseEvent('searched', extraAttributes, this._baseEvent);
                this._onEvent(event);
            }
        },
        {
            key: "selected",
            value: function selected(selectionIndex) {
                if (!selectionIndex && selectionIndex !== 0) throw new Error('Missing selectionIndex param');
                if (!this._lastQueryResultsTime) throw new Error('searched() must be called before selected().');
                var now = Date.now();
                var selectionTimeMs = now - this._lastQueryResultsTime;
                var searchTimeMs = now - this._searchStartedTime;
                var selectedResultValue = this._lastResults[selectionIndex];
                var extraAttributes = {
                    queryLength: this._queryLength,
                    selectionIndex: selectionIndex,
                    selectionTimeMs: selectionTimeMs,
                    searchTimeMs: searchTimeMs,
                    selectedResultValue: selectedResultValue
                };
                var event = $fce52030a1132d31$var$combineWithBaseEvent('selected', extraAttributes, this._baseEvent);
                this._onEvent(event);
            }
        }
    ]);
}();

});


parcelRegister("jSI6G", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $e795462a5dbdab0d$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $e795462a5dbdab0d$var$invariant;

});

parcelRegister("ifpPH", function(module, exports) {
$parcel$export(module.exports, "Text", () => $d48daa9a522ca942$export$5f1af8db9871e1d6);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $afMOk = parcelRequire("afMOk");

var $idDql = parcelRequire("idDql");

var $99N5z = parcelRequire("99N5z");

var $c77J7 = parcelRequire("c77J7");

var $a3VXv = parcelRequire("a3VXv");

var $lCgDr = parcelRequire("lCgDr");

var $g6aLb = parcelRequire("g6aLb");

var $9ftmO = parcelRequire("9ftmO");
var $d48daa9a522ca942$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $d48daa9a522ca942$var$resetStyles = (0, $74Zh5.css)({
    margin: 0,
    overflowWrap: 'anywhere'
});
var $d48daa9a522ca942$var$strongStyles = (0, $74Zh5.css)({
    fontWeight: "var(--ds-font-weight-bold, 653)"
});
var $d48daa9a522ca942$var$emStyles = (0, $74Zh5.css)({
    fontStyle: 'italic'
});
var $d48daa9a522ca942$var$textAlignMap = {
    center: (0, $74Zh5.css)({
        textAlign: 'center'
    }),
    end: (0, $74Zh5.css)({
        textAlign: 'end'
    }),
    start: (0, $74Zh5.css)({
        textAlign: 'start'
    })
};
var $d48daa9a522ca942$var$truncationStyles = (0, $74Zh5.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
var $d48daa9a522ca942$var$wordBreakMap = {
    breakAll: (0, $74Zh5.css)({
        wordBreak: 'break-all'
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $d48daa9a522ca942$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $99N5z.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $a3VXv.inverseColorMap).hasOwnProperty(surface)) return (0, $a3VXv.inverseColorMap)[surface];
    return 'color.text';
};
var $d48daa9a522ca942$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $afMOk.default)($d48daa9a522ca942$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $c77J7.useHasTextAncestor)();
    var color = $d48daa9a522ca942$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = (0, $74Zh5.jsx)(Component, {
        ref: ref,
        css: [
            $d48daa9a522ca942$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $g6aLb.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $lCgDr.textColorStylesMap)[color],
            maxLines && $d48daa9a522ca942$var$truncationStyles,
            maxLines === 1 && $d48daa9a522ca942$var$wordBreakMap.breakAll,
            align && $d48daa9a522ca942$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $9ftmO.textWeightStylesMap)[weight],
            Component === 'em' && $d48daa9a522ca942$var$emStyles,
            Component === 'strong' && $d48daa9a522ca942$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $74Zh5.jsx)((0, $idDql.HasTextAncestorProvider), {
        value: true
    }, component);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$d48daa9a522ca942$export$2e2bcd8739ae039 = $d48daa9a522ca942$export$5f1af8db9871e1d6;

});
parcelRegister("idDql", function(module, exports) {
$parcel$export(module.exports, "HasTextAncestorProvider", () => $d43805ab09abcfec$export$ae933c6cbe5643ad);

var $8a6gB = parcelRequire("8a6gB");
var $d43805ab09abcfec$export$ae933c6cbe5643ad = (0, $8a6gB.HasTextAncestorContext).Provider;

});
parcelRegister("8a6gB", function(module, exports) {
$parcel$export(module.exports, "HasTextAncestorContext", () => $5f141e5f4d88626f$export$19538d0bfc69c6e0);

var $5FkrB = parcelRequire("5FkrB");
var $5f141e5f4d88626f$export$19538d0bfc69c6e0 = /*#__PURE__*/ (0, $5FkrB.createContext)(false);

});


parcelRegister("99N5z", function(module, exports) {
$parcel$export(module.exports, "useSurface", () => $6aab085817c2aae8$export$1aeb4f6b93c4540d);

var $5FkrB = parcelRequire("5FkrB");

var $b4wFT = parcelRequire("b4wFT");
var $6aab085817c2aae8$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)((0, $b4wFT.SurfaceContext));
};
(0, $b4wFT.SurfaceContext).displayName = 'SurfaceProvider';

});

parcelRegister("c77J7", function(module, exports) {
$parcel$export(module.exports, "useHasTextAncestor", () => $8d1c21dc53d3f2ff$export$9322276ec105d055);

var $5FkrB = parcelRequire("5FkrB");

var $8a6gB = parcelRequire("8a6gB");
var $8d1c21dc53d3f2ff$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $5FkrB.useContext)((0, $8a6gB.HasTextAncestorContext));
};

});

parcelRegister("a3VXv", function(module, exports) {
$parcel$export(module.exports, "inverseColorMap", () => $75372494f37b0909$export$2185ce37f9bdd963);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a28069eff63ae56e4151436b4687b08>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::d88dceee1459b4e9e492bb497e903575>>
 */ var $75372494f37b0909$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse',
    'color.rovo.background.brand.bold': 'color.text.inverse',
    'color.rovo.background.brand.bold.hovered': 'color.text.inverse',
    'color.rovo.background.brand.bold.pressed': 'color.text.inverse'
};

});

parcelRegister("lCgDr", function(module, exports) {
$parcel$export(module.exports, "textColorStylesMap", () => $fbca0cfef91c3ba3$export$3a1bcba60b23d7f0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $dborj = parcelRequire("dborj");

var $6jMrz = parcelRequire("6jMrz");
var $fbca0cfef91c3ba3$export$3a1bcba60b23d7f0 = (0, $dborj.getSerializedStylesMap)('color', (0, $6jMrz.textColorMap));

});

parcelRegister("g6aLb", function(module, exports) {
$parcel$export(module.exports, "textSizeStylesMap", () => $bb858d9269c98c26$export$219d364c0da35ae4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $dborj = parcelRequire("dborj");

var $hjnle = parcelRequire("hjnle");
var $bb858d9269c98c26$export$219d364c0da35ae4 = (0, $dborj.getSerializedStylesMap)('font', (0, $hjnle.textSizeMap));

});
parcelRegister("hjnle", function(module, exports) {
$parcel$export(module.exports, "textSizeMap", () => $c9a6511ed0151e9a$export$236bfe3a33ef1292);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::610f7a87b5183bc177338e33463cac82>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ var $c9a6511ed0151e9a$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});


parcelRegister("9ftmO", function(module, exports) {
$parcel$export(module.exports, "textWeightStylesMap", () => $6bbc4b7537635055$export$38845ca010b93505);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $dborj = parcelRequire("dborj");

var $hqXup = parcelRequire("hqXup");
var $6bbc4b7537635055$export$38845ca010b93505 = (0, $dborj.getSerializedStylesMap)('fontWeight', (0, $hqXup.textWeightMap));

});
parcelRegister("hqXup", function(module, exports) {
$parcel$export(module.exports, "textWeightMap", () => $cb1302c29e5dd03b$export$855cfd311192d666);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::771460ab0c298bfffbf486012c7cfab6>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ var $cb1302c29e5dd03b$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};

});



parcelRegister("bb0Oq", function(module, exports) {
$parcel$export(module.exports, "default", () => $82315a19372f332f$export$2e2bcd8739ae039);
/* heading.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $a3VXv = parcelRequire("a3VXv");

var $99N5z = parcelRequire("99N5z");

var $bvkQY = parcelRequire("bvkQY");

var $3ZMUU = parcelRequire("3ZMUU");
var $82315a19372f332f$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $82315a19372f332f$var$styles = {
    reset: "_dxsyidpf _1i144jg8 _nmk4glyw"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $82315a19372f332f$var$headingColorStyles = {
    'color.text': "_1w90i7uo",
    'color.text.inverse': "_1w9015cr",
    'color.text.warning.inverse': "_1w901yd3"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $82315a19372f332f$var$headingSizeStyles = {
    xxlarge: "_fqox1iff",
    xlarge: "_fqox12ln",
    large: "_fqox10sd",
    medium: "_fqox1af2",
    small: "_fqox1e3o",
    xsmall: "_fqox1qyo",
    xxsmall: "_fqoxi4vh"
};
/**
 * @codegenEnd
 */ var $82315a19372f332f$var$useColor = function useColor(colorProp) {
    var surface = (0, $99N5z.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $a3VXv.inverseColorMap).hasOwnProperty(surface)) return (0, $a3VXv.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $82315a19372f332f$var$Heading = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    typeof $3ZMUU;
    var _useHeading = (0, $bvkQY.useHeading)($82315a19372f332f$var$sizeTagMap[size]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === 'div' && hLevel;
    var color = $82315a19372f332f$var$useColor(colorProp);
    return /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $970q7.default)([
            $82315a19372f332f$var$styles.reset,
            $82315a19372f332f$var$headingSizeStyles[size],
            $82315a19372f332f$var$headingColorStyles[color]
        ])
    }, children);
});
var $82315a19372f332f$export$2e2bcd8739ae039 = $82315a19372f332f$var$Heading;

});
parcelRegister("bvkQY", function(module, exports) {
$parcel$export(module.exports, "useHeading", () => $8602c3fdf0fab40c$export$97a37b1befbbf9b1);

var $62RlP = parcelRequire("62RlP");
var $8602c3fdf0fab40c$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = (0, $62RlP.useHeadingLevel)();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : "h".concat(hLevel)) || fallback
    ];
};

});
parcelRegister("62RlP", function(module, exports) {
$parcel$export(module.exports, "useHeadingLevel", () => $466c505f5338113d$export$6a64a1e2d0bbbf75);

var $5FkrB = parcelRequire("5FkrB");

var $eB7p5 = parcelRequire("eB7p5");
var $466c505f5338113d$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $5FkrB.useContext)((0, $eB7p5.HeadingLevelContext));
};

});
parcelRegister("eB7p5", function(module, exports) {
$parcel$export(module.exports, "HeadingLevelContext", () => $aa0a4395fbca7551$export$d1fa8a19e192bc63);

var $5FkrB = parcelRequire("5FkrB");
var $aa0a4395fbca7551$export$d1fa8a19e192bc63 = /*#__PURE__*/ (0, $5FkrB.createContext)(0);

});




parcelRegister("aLEtb", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $7d6daf9bcf6c0b57$export$a4687b0234b40e28);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $bDUuG = parcelRequire("bDUuG");

var $cqQpq = parcelRequire("cqQpq");
function $7d6daf9bcf6c0b57$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7d6daf9bcf6c0b57$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7d6daf9bcf6c0b57$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7d6daf9bcf6c0b57$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7d6daf9bcf6c0b57$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $bDUuG.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $cqQpq.useTrackedRef)(analyticsData);
    var fnRef = (0, $cqQpq.useTrackedRef)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $7d6daf9bcf6c0b57$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("bDUuG", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $879f28ba40c47674$export$5bf35293e545f20c);

var $dLGML = parcelRequire("dLGML");

var $TNyZj = parcelRequire("TNyZj");

var $509QN = parcelRequire("509QN");
function $879f28ba40c47674$export$5bf35293e545f20c() {
    var analyticsContext = (0, $509QN.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $TNyZj.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("TNyZj", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a7b95699500e142$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $50U6m = parcelRequire("50U6m");

var $b9YAn = parcelRequire("b9YAn");
function $0a7b95699500e142$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0a7b95699500e142$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0a7b95699500e142$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0a7b95699500e142$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0a7b95699500e142$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $0a7b95699500e142$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $0a7b95699500e142$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0a7b95699500e142$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $0a7b95699500e142$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $0a7b95699500e142$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $0a7b95699500e142$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            var payload = $0a7b95699500e142$var$clonePayload(_this.payload);
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $0a7b95699500e142$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $b9YAn.default));
var $0a7b95699500e142$var$clonePayload = function clonePayload(payload) {
    if ((0, $50U6m.fg)('platform-analytics-next-safe-clone')) try {
        return JSON.parse(JSON.stringify(payload));
    } catch (e) {
        // Shallow clone keeps the event usable without crashing the UI.
        return $0a7b95699500e142$var$_objectSpread({}, payload);
    }
    /**
   * A hacky "deep clone" of the object. This is limited in that it wont
   * support functions, regexs, Maps, Sets, etc, but none of those need to
   * be represented in our payload.
   */ return JSON.parse(JSON.stringify(payload));
};

});
parcelRegister("b9YAn", function(module, exports) {
$parcel$export(module.exports, "default", () => $81ff880d8cb76a60$export$2e2bcd8739ae039);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $81ff880d8cb76a60$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $81ff880d8cb76a60$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $81ff880d8cb76a60$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $81ff880d8cb76a60$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $81ff880d8cb76a60$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $81ff880d8cb76a60$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $81ff880d8cb76a60$var$_objectSpread($81ff880d8cb76a60$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("509QN", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $3a4497eea280292e$export$d1f587f82ad51c4);

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $3a4497eea280292e$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};

});


parcelRegister("cqQpq", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $90d091140a6cc984$export$1d27a74659855e44);

var $5FkrB = parcelRequire("5FkrB");
var $90d091140a6cc984$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("5yoeA", function(module, exports) {
$parcel$export(module.exports, "Focusable", () => $40b2ed289482eab3$export$35a3bebf7ef2d934);
/* focusable.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $40b2ed289482eab3$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $40b2ed289482eab3$var$_excluded2 = [
    "className"
];
var $40b2ed289482eab3$var$focusRingStyles = null;
var $40b2ed289482eab3$var$insetFocusRingStyles = null;
var $40b2ed289482eab3$export$35a3bebf7ef2d934 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $40b2ed289482eab3$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $40b2ed289482eab3$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $970q7.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});

});

parcelRegister("72GAO", function(module, exports) {
$parcel$export(module.exports, "Text", () => $5209c25cc099adfe$export$5f1af8db9871e1d6);
/* text.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $afMOk = parcelRequire("afMOk");

var $idDql = parcelRequire("idDql");

var $99N5z = parcelRequire("99N5z");

var $c77J7 = parcelRequire("c77J7");
var $5209c25cc099adfe$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $5209c25cc099adfe$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $99N5z.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($5209c25cc099adfe$var$inverseColorMap.hasOwnProperty(surface)) return $5209c25cc099adfe$var$inverseColorMap[surface];
    return 'color.text';
};
var $5209c25cc099adfe$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $5209c25cc099adfe$var$fontSizeMap = {
    medium: "_11c8fhey",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $5209c25cc099adfe$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $5209c25cc099adfe$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
var $5209c25cc099adfe$var$inverseColorMap = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $5209c25cc099adfe$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $afMOk.default)($5209c25cc099adfe$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $c77J7.useHasTextAncestor)();
    var color = $5209c25cc099adfe$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        className: (0, $970q7.default)([
            $5209c25cc099adfe$var$styles.root,
            size && $5209c25cc099adfe$var$fontSizeMap[size],
            color && $5209c25cc099adfe$var$textColorMap[color],
            maxLines && $5209c25cc099adfe$var$styles.truncation,
            maxLines === 1 && $5209c25cc099adfe$var$styles.breakAll,
            align && $5209c25cc099adfe$var$styles["textAlign.".concat(align)],
            weight && $5209c25cc099adfe$var$fontWeightMap[weight],
            Component === 'em' && $5209c25cc099adfe$var$styles['as.em'],
            Component === 'strong' && $5209c25cc099adfe$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $5FkrB.createElement((0, $idDql.HasTextAncestorProvider), {
        value: true
    }, component);
});

});

parcelRegister("5yfDB", function(module, exports) {
$parcel$export(module.exports, "default", () => $40ac4214599ec615$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $iO8GM = parcelRequire("iO8GM");

var $4mzlU = parcelRequire("4mzlU");

var $e8kqY = parcelRequire("e8kqY");

var $abSTK = parcelRequire("abSTK");

var $ccBRl = parcelRequire("ccBRl");

var $goIky = parcelRequire("goIky");
var $40ac4214599ec615$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $40ac4214599ec615$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $40ac4214599ec615$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $40ac4214599ec615$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $40ac4214599ec615$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $abSTK.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ccBRl.default), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $goIky.default), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e8kqY.default), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4mzlU.default), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        shortcut: tooltip === null || tooltip === void 0 ? void 0 : tooltip.shortcut
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $abSTK.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $iO8GM.default)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ccBRl.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $goIky.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e8kqY.default), null, label)));
    });
}));
$40ac4214599ec615$var$IconButton.displayName = 'IconButton';
var $40ac4214599ec615$export$2e2bcd8739ae039 = $40ac4214599ec615$var$IconButton;

});
parcelRegister("iO8GM", function(module, exports) {
$parcel$export(module.exports, "default", () => $db13a2f91f6a0f56$export$2e2bcd8739ae039);

var $ekGgq = parcelRequire("ekGgq");
function $db13a2f91f6a0f56$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref) === 'object') ref.current = value;
        });
    };
}

});

parcelRegister("4mzlU", function(module, exports) {
$parcel$export(module.exports, "default", () => $32d4a3c4842e3ceb$export$2e2bcd8739ae039);
/* tooltip.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");


var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $3wzaG = parcelRequire("3wzaG");

var $eVb4V = parcelRequire("eVb4V");

var $hy47X = parcelRequire("hy47X");

var $3UUXy = parcelRequire("3UUXy");

var $iUCre = parcelRequire("iUCre");

var $e9nnz = parcelRequire("e9nnz");

var $7X67V = parcelRequire("7X67V");

var $50U6m = parcelRequire("50U6m");

var $5K5L9 = parcelRequire("5K5L9");

var $fV8Mu = parcelRequire("fV8Mu");

var $64A04 = parcelRequire("64A04");

var $lTPIB = parcelRequire("lTPIB");

var $jWEo0 = parcelRequire("jWEo0");

var $elQ7X = parcelRequire("elQ7X");

var $eP9RN = parcelRequire("eP9RN");

var $a3FU2 = parcelRequire("a3FU2");

var $mgmjQ = parcelRequire("mgmjQ");

var $jWW4h = parcelRequire("jWW4h");

var $2NaAU = parcelRequire("2NaAU");

var $jr7hX = parcelRequire("jr7hX");

var $HBQqj = parcelRequire("HBQqj");
function $32d4a3c4842e3ceb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $32d4a3c4842e3ceb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $32d4a3c4842e3ceb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $32d4a3c4842e3ceb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $32d4a3c4842e3ceb$var$tooltipZIndex = (0, $64A04.layers).tooltip();
var $32d4a3c4842e3ceb$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "24.3.3"
};
// Inverts motion direction
var $32d4a3c4842e3ceb$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $32d4a3c4842e3ceb$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * For the `platform-dst-top-layer-tooltip` path only. Always `false` when that
 * gate is off, so this cannot affect the legacy path even if it gains a caller
 * there.
 *
 * `mouseover` also fires when the pointer crosses boundaries between elements
 * _inside_ the trigger. A `relatedTarget` the trigger does not contain is what
 * distinguishes a real re-entry from one of those.
 */ function $32d4a3c4842e3ceb$var$isTopLayerPointerReEntry(_ref) {
    var trigger = _ref.trigger, relatedTarget = _ref.relatedTarget;
    if (!(0, $50U6m.fg)('platform-dst-top-layer-tooltip')) return false;
    // Missing trigger, or pointer from outside the document. Treat both as an
    // entry so we cannot get stuck suppressed.
    if (!trigger || !(relatedTarget instanceof Node)) return true;
    return !trigger.contains(relatedTarget);
}
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $32d4a3c4842e3ceb$var$Tooltip(_ref2) {
    var children = _ref2.children, _ref2$position = _ref2.position, position = _ref2$position === void 0 ? 'bottom' : _ref2$position, _ref2$mousePosition = _ref2.mousePosition, mousePosition = _ref2$mousePosition === void 0 ? 'bottom' : _ref2$mousePosition, content = _ref2.content, _ref2$truncate = _ref2.truncate, truncate = _ref2$truncate === void 0 ? false : _ref2$truncate, _ref2$component = _ref2.component, Container = _ref2$component === void 0 ? (0, $HBQqj.default) : _ref2$component, _ref2$tag = _ref2.tag, TargetContainer = _ref2$tag === void 0 ? 'div' : _ref2$tag, testId = _ref2.testId, _ref2$delay = _ref2.delay, delay = _ref2$delay === void 0 ? 300 : _ref2$delay, _ref2$onShow = _ref2.onShow, onShow = _ref2$onShow === void 0 ? (0, $eVb4V.default) : _ref2$onShow, _ref2$onHide = _ref2.onHide, onHide = _ref2$onHide === void 0 ? (0, $eVb4V.default) : _ref2$onHide, canAppear = _ref2.canAppear, _ref2$hideTooltipOnCl = _ref2.hideTooltipOnClick, hideTooltipOnClick = _ref2$hideTooltipOnCl === void 0 ? false : _ref2$hideTooltipOnCl, _ref2$hideTooltipOnMo = _ref2.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref2$hideTooltipOnMo === void 0 ? false : _ref2$hideTooltipOnMo, analyticsContext = _ref2.analyticsContext, _ref2$strategy = _ref2.strategy, strategy = _ref2$strategy === void 0 ? 'fixed' : _ref2$strategy, _ref2$ignoreTooltipPo = _ref2.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref2$ignoreTooltipPo === void 0 ? false : _ref2$ignoreTooltipPo, _ref2$isScreenReaderA = _ref2.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref2$isScreenReaderA === void 0 ? false : _ref2$isScreenReaderA, shortcut = _ref2.shortcut, _ref2$shouldAlwaysFad = _ref2.shouldAlwaysFadeIn, shouldAlwaysFadeIn = _ref2$shouldAlwaysFad === void 0 ? false : _ref2$shouldAlwaysFad, _ref2$shouldRenderToP = _ref2.shouldRenderToParent, shouldRenderToParent = _ref2$shouldRenderToP === void 0 ? false : _ref2$shouldRenderToP;
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    var isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    var tooltipPosition = isMousePosition ? mousePosition : position;
    var onShowHandler = (0, $3wzaG.usePlatformLeafSyntheticEventHandler)($32d4a3c4842e3ceb$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $32d4a3c4842e3ceb$var$analyticsAttributes));
    var onHideHandler = (0, $3wzaG.usePlatformLeafSyntheticEventHandler)($32d4a3c4842e3ceb$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $32d4a3c4842e3ceb$var$analyticsAttributes));
    var apiRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $5FkrB.useRef)(null);
    var containerRef = (0, $5FkrB.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $5FkrB.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $3UUXy.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $3UUXy.default)(onShowHandler);
    var onHideHandlerStable = (0, $3UUXy.default)(onHideHandler);
    var delayStable = (0, $3UUXy.default)(delay);
    var canAppearStable = (0, $3UUXy.default)(canAppear);
    var hasCalledShowHandler = (0, $5FkrB.useRef)(false);
    var shouldAlwaysFadeInStable = (0, $3UUXy.default)(shouldAlwaysFadeIn);
    var start = (0, $5FkrB.useCallback)(function(api) {
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $5FkrB.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $5FkrB.useRef)(false);
    (0, $5FkrB.useEffect)(function() {
        return (0, $a3FU2.register)({
            onRegister: function onRegister(_ref3) {
                var isDragging = _ref3.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    // Set while a pointer press has dismissed the tooltip. Every read and write is
    // behind `platform-dst-top-layer-tooltip`, where `popover="hint"` owns pointer
    // dismissal, so the legacy path never sees this.
    var isTopLayerPointerDismissedRef = (0, $5FkrB.useRef)(false);
    var tryShowTooltip = (0, $5FkrB.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Stay dismissed until the trigger is re-entered or blurred. Otherwise
     * light dismiss hides on pointerup and the next `mouseover` from a
     * boundary crossing inside the trigger re-shows it. Deliberately after
     * the "already active" branch, so a held press stays visible.
     */ if (isTopLayerPointerDismissedRef.current && (0, $50U6m.fg)('platform-dst-top-layer-tooltip')) return;
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref4) {
                var isImmediate = _ref4.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: function hide(_ref5) {
                var isImmediate = _ref5.isImmediate;
                if (isImmediate) setState('hide');
                else if ((0, $50U6m.fg)('platform-dst-top-layer-tooltip')) // Top-layer path: set state to 'top-layer-exit'. The component
                // stays mounted and Popover's isOpen prop transitions to
                // false, triggering the CSS exit animation internally.
                // finishHideAnimation is called after a brief delay matching
                // the CSS exit animation duration.
                setState('top-layer-exit');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: shouldAlwaysFadeInStable.current
        };
        var api = (0, $2NaAU.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    var hideTooltipOnEsc = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    // When using top-layer, popover="auto" handles Escape natively
    (0, $hy47X.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out' || state === 'top-layer-exit' || (0, $50U6m.fg)('platform-dst-top-layer-tooltip')
    });
    // ── Top-layer exit animation lifecycle ──
    // When state is 'top-layer-exit', Popover's isOpen transitions to false and
    // the CSS exit animation plays. The Popover's built-in `transitionend`
    // detection (with timeout fallback) calls `onExitFinish` when the exit
    // animation completes, which triggers the tooltip-manager lifecycle
    // (finishHideAnimation → done → onHide, setState('hide'), cleanup).
    var handleExitFinish = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current3;
        (_apiRef$current3 = apiRef.current) === null || _apiRef$current3 === void 0 || _apiRef$current3.finishHideAnimation();
    }, []);
    // Browser dismiss (light dismiss on pointerup, or Escape). Recorded so we stay
    // hidden until the trigger is re-entered. Only wired up on the top-layer path,
    // but gated anyway to keep every use of the ref flag-checked.
    var handlePopoverClose = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current4;
        if ((0, $50U6m.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = true;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $5FkrB.useEffect)(function() {
        if (state === 'hide') return 0, $eVb4V.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $5FkrB.useCallback)(function() {
        // Native light dismiss hides on pointerup, not here. Recorded now so the
        // tooltip stays dismissed afterwards.
        if ((0, $50U6m.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = true;
        // A press inside the show delay never reaches light dismiss, because no
        // popover is open on pointerup. Cancel the pending show so a quick click
        // does not surface a tooltip over content the press just changed.
        var shouldCancelPendingShow = stableState.current === 'hide' && (0, $50U6m.fg)('platform-dst-top-layer-tooltip');
        if ((hideTooltipOnMouseDown || shouldCancelPendingShow) && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown,
        stableState
    ]);
    var onClick = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        // Re-arm on a real re-entry, not on a boundary crossing inside the trigger.
        if ($32d4a3c4842e3ceb$var$isTopLayerPointerReEntry({
            trigger: targetRef.current,
            relatedTarget: event.relatedTarget
        }) && (0, $50U6m.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = false;
        var source = isMousePosition ? {
            type: 'mouse',
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = isMousePosition ? function(event) {
        var _apiRef$current5;
        if ((_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.isActive()) apiRef.current.mousePos = {
            clientX: event.clientX,
            clientY: event.clientY
        };
    } : undefined;
    var onMouseOverTooltip = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $5FkrB.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (_unused) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $5FkrB.useCallback)(function() {
        // Focus leaving ends the dismissal, so focus coming back can show the tooltip.
        if ((0, $50U6m.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = false;
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $5FkrB.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out' && state !== 'top-layer-exit';
    var handleOpenLayerObserverCloseSignal = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current6;
        (_apiRef$current6 = apiRef.current) === null || _apiRef$current6 === void 0 || _apiRef$current6.requestHide({
            isImmediate: true
        });
    }, []);
    // Registered unconditionally so the hook order never depends on the feature
    // flag value. On the top-layer path the Popover primitive (used by
    // TopLayerTooltipPopup) registers with the observer directly, so we pass
    // isOpen: false to avoid double-counting (the hook is a no-op while the
    // layer is not open).
    (0, $iUCre.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: (0, $50U6m.fg)('platform-dst-top-layer-tooltip') ? false : shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current7;
        if (isMousePosition && (_apiRef$current7 = apiRef.current) !== null && _apiRef$current7 !== void 0 && _apiRef$current7.mousePos && targetRef.current) return (0, $jWW4h.getVirtualElementFromMousePos)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $jr7hX.default)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $5FkrB.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    var PopperWrapper = shouldRenderToParent ? (0, $5FkrB.Fragment) : $32d4a3c4842e3ceb$var$TooltipPortal;
    var trigger = typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, children($32d4a3c4842e3ceb$var$_objectSpread($32d4a3c4842e3ceb$var$_objectSpread($32d4a3c4842e3ceb$var$_objectSpread({}, tooltipTriggerProps), testId ? {
        testId: "".concat(testId, "--container")
    } : {}), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, tooltipTriggerProps, testId ? {
        'data-testid': "".concat(testId, "--container")
    } : undefined, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent);
    if ((0, $50U6m.fg)('platform-dst-top-layer-tooltip')) {
        var _apiRef$current$mouse, _apiRef$current8;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, trigger, shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($32d4a3c4842e3ceb$var$TopLayerTooltipPopup, {
            targetRef: targetRef,
            tooltipPosition: tooltipPosition,
            mousePos: (_apiRef$current$mouse = (_apiRef$current8 = apiRef.current) === null || _apiRef$current8 === void 0 ? void 0 : _apiRef$current8.mousePos) !== null && _apiRef$current$mouse !== void 0 ? _apiRef$current$mouse : undefined,
            position: position,
            onMouseOut: onMouseOut,
            onMouseOverTooltip: onMouseOverTooltip,
            ignoreTooltipPointerEvents: ignoreTooltipPointerEvents,
            truncate: truncate,
            testId: testId,
            shortcut: shortcut,
            content: content,
            Container: Container,
            onClose: handlePopoverClose,
            onExitFinish: handleExitFinish,
            isOpen: state !== 'hide' && state !== 'top-layer-exit'
        }) : null);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, trigger, shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(PopperWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5K5L9.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref6) {
        var ref = _ref6.ref, style = _ref6.style, update = _ref6.update, placement = _ref6.placement;
        var direction = isMousePosition ? undefined : $32d4a3c4842e3ceb$var$invertedDirection[$32d4a3c4842e3ceb$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e9nnz.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7X67V.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref7) {
            var className = _ref7.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $32d4a3c4842e3ceb$var$_objectSpread($32d4a3c4842e3ceb$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $32d4a3c4842e3ceb$export$2e2bcd8739ae039 = $32d4a3c4842e3ceb$var$Tooltip;
var $32d4a3c4842e3ceb$var$TooltipPortal = function TooltipPortal(_ref8) {
    var children = _ref8.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fV8Mu.default), {
        zIndex: $32d4a3c4842e3ceb$var$tooltipZIndex
    }, children);
};
var $32d4a3c4842e3ceb$var$tooltipMouseAnimationStyles = {
    enter: "_j7hq1bym",
    exit: "_j7hq1a5s"
};
/**
 * Top-layer tooltip popup component.
 *
 * Composes `Popover` (top-layer visibility + animation) with two positioning
 * hooks, of which EXACTLY ONE is enabled - two writing to the same popover would
 * fight for ownership, so `isEnabled` is derived from one boolean and negated:
 *
 *   - `useAnchoredPopoverAtPoint` for cursor-tracking positions (`mouse`,
 *     `mouse-x`, `mouse-y`) activated by a pointer.
 *   - `useAnchoredPopover` for everything else, including a cursor position
 *     activated via keyboard focus, where there is no cursor to track and
 *     anchoring to the trigger is what keeps the tooltip beside the target.
 *
 * Exit animation is handled by `Popover`'s `isOpen` prop. When `isOpen`
 * transitions to `false`, the primitive calls `hidePopover()` internally and
 * the CSS exit animation plays via `allow-discrete`. No glue code needed.
 */ function $32d4a3c4842e3ceb$var$TopLayerTooltipPopup(_ref9) {
    var targetRef = _ref9.targetRef, tooltipPosition = _ref9.tooltipPosition, mousePos = _ref9.mousePos, position = _ref9.position, onMouseOut = _ref9.onMouseOut, onMouseOverTooltip = _ref9.onMouseOverTooltip, ignoreTooltipPointerEvents = _ref9.ignoreTooltipPointerEvents, truncate = _ref9.truncate, testId = _ref9.testId, shortcut = _ref9.shortcut, content = _ref9.content, Container = _ref9.Container, onClose = _ref9.onClose, onExitFinish = _ref9.onExitFinish, isOpen = _ref9.isOpen;
    var popoverRef = (0, $5FkrB.useRef)(null);
    // Translate the legacy Popper-style placement string ("right",
    // "bottom-start", etc.) once and pass the same object to the hook and
    // to `Popover`.
    var placement = (0, $lTPIB.fromLegacyPlacement)({
        legacy: tooltipPosition
    });
    var isMousePosition = position === 'mouse' || position === 'mouse-x' || position === 'mouse-y';
    var isMouseStrategyActive = isMousePosition && Boolean(mousePos);
    // One object so the two calls cannot drift on `placement` or `isOpen`.
    var sharedPositioning = {
        popoverRef: popoverRef,
        placement: placement,
        isOpen: isOpen
    };
    (0, $elQ7X.useAnchoredPopover)($32d4a3c4842e3ceb$var$_objectSpread($32d4a3c4842e3ceb$var$_objectSpread({}, sharedPositioning), {}, {
        anchorRef: targetRef,
        isEnabled: !isMouseStrategyActive
    }));
    // `getPoint()` is latched once per activation, which is per-show here because
    // `TopLayerTooltipPopup` mounts fresh on every show. `null` before the trigger
    // has mounted applies no positioning at all.
    (0, $eP9RN.useAnchoredPopoverAtPoint)($32d4a3c4842e3ceb$var$_objectSpread($32d4a3c4842e3ceb$var$_objectSpread({}, sharedPositioning), {}, {
        isEnabled: isMouseStrategyActive,
        getPoint: function getPoint() {
            if (!mousePos || !targetRef.current || !isMousePosition) return null;
            return (0, $mgmjQ.getAnchorPoint)({
                cursor: mousePos,
                triggerRect: targetRef.current.getBoundingClientRect(),
                tooltipPosition: position,
                placement: placement
            });
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jWEo0.Popover), {
        ref: popoverRef,
        role: "tooltip",
        mode: "hint",
        isOpen: isOpen,
        onClose: onClose,
        onExitFinish: onExitFinish,
        testId: testId ? "".concat(testId, "--popover") : undefined,
        shouldAnimate: true,
        enteringAnimationXcss: isMouseStrategyActive && $32d4a3c4842e3ceb$var$tooltipMouseAnimationStyles.enter,
        exitingAnimationXcss: isMouseStrategyActive && $32d4a3c4842e3ceb$var$tooltipMouseAnimationStyles.exit,
        placement: placement
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, {
        className: "Tooltip",
        style: ignoreTooltipPointerEvents ? {
            pointerEvents: 'none'
        } : undefined,
        truncate: truncate,
        placement: tooltipPosition,
        testId: testId,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOverTooltip,
        shortcut: shortcut,
        role: "presentation"
    }, typeof content === 'function' ? content({
        update: (0, $eVb4V.default)
    }) : content));
}

});
parcelRegister("3wzaG", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $290fa485630d1395$export$1a04351537078b55);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $bDUuG = parcelRequire("bDUuG");

var $cqQpq = parcelRequire("cqQpq");
function $290fa485630d1395$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $290fa485630d1395$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $290fa485630d1395$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $290fa485630d1395$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $290fa485630d1395$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $bDUuG.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $cqQpq.useTrackedRef)(analyticsData);
    var fnRef = (0, $cqQpq.useTrackedRef)(fn);
    var handler = (0, $5FkrB.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $290fa485630d1395$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("eVb4V", function(module, exports) {
$parcel$export(module.exports, "default", () => $adcefb868cf2fc9d$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $adcefb868cf2fc9d$export$2e2bcd8739ae039() {}

});

parcelRegister("hy47X", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc68d04423a653c6$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $lmG37 = parcelRequire("lmG37");
function $cc68d04423a653c6$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $lmG37.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $7QpUe.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("lmG37", function(module, exports) {
$parcel$export(module.exports, "KEY_UP", () => $f8dc452a9f988247$export$390330c10ff2b9a1);
$parcel$export(module.exports, "KEY_DOWN", () => $f8dc452a9f988247$export$a80636c6f41931fe);
$parcel$export(module.exports, "KEY_LEFT", () => $f8dc452a9f988247$export$fc4577f2a2af0ae3);
$parcel$export(module.exports, "KEY_RIGHT", () => $f8dc452a9f988247$export$c40f9845adc73fb5);
$parcel$export(module.exports, "KEY_HOME", () => $f8dc452a9f988247$export$4af703091671bc);
$parcel$export(module.exports, "KEY_END", () => $f8dc452a9f988247$export$e2bc30913faa5db7);
$parcel$export(module.exports, "KEY_TAB", () => $f8dc452a9f988247$export$10f6869ed0a7d75b);
$parcel$export(module.exports, "KEY_ENTER", () => $f8dc452a9f988247$export$8152f929a25a0ff4);
$parcel$export(module.exports, "KEY_SPACE", () => $f8dc452a9f988247$export$e51a3576c045c8d5);
$parcel$export(module.exports, "ESCAPE", () => $f8dc452a9f988247$export$2bb790b9008907b4);
/**
 * Character key codes which can be used in keyboard events.
 */ var $f8dc452a9f988247$export$390330c10ff2b9a1 = 'ArrowUp';
var $f8dc452a9f988247$export$a80636c6f41931fe = 'ArrowDown';
var $f8dc452a9f988247$export$fc4577f2a2af0ae3 = 'ArrowLeft';
var $f8dc452a9f988247$export$c40f9845adc73fb5 = 'ArrowRight';
var $f8dc452a9f988247$export$4af703091671bc = 'Home';
var $f8dc452a9f988247$export$e2bc30913faa5db7 = 'End';
var $f8dc452a9f988247$export$10f6869ed0a7d75b = 'Tab';
var $f8dc452a9f988247$export$8152f929a25a0ff4 = 'Enter';
var $f8dc452a9f988247$export$e51a3576c045c8d5 = 'Space';
var $f8dc452a9f988247$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("3UUXy", function(module, exports) {
$parcel$export(module.exports, "default", () => $2da2c910992d9a40$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $2da2c910992d9a40$export$2e2bcd8739ae039(value) {
    var ref = (0, $5FkrB.useRef)(value);
    (0, $5FkrB.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("iUCre", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $dc4b45f7ee6225f5$export$469bb693f11edc7f);

var $5FkrB = parcelRequire("5FkrB");

var $lHXR8 = parcelRequire("lHXR8");

var $2AINz = parcelRequire("2AINz");
function $dc4b45f7ee6225f5$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $lHXR8.OpenLayerObserverContext));
    var namespace = (0, $2AINz.useOpenLayerObserverNamespace)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("lHXR8", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $fcdc0b4830f2aedd$export$5fbf4d7fae6cdc00);

var $5FkrB = parcelRequire("5FkrB");
var $fcdc0b4830f2aedd$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});

parcelRegister("2AINz", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $1e31b1a2322b2689$export$1d57e79091cc3046);

var $5FkrB = parcelRequire("5FkrB");

var $33jD0 = parcelRequire("33jD0");
function $1e31b1a2322b2689$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $33jD0.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("33jD0", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $2390e0a738ab81f9$export$644a49f3b8c50fcd);

var $5FkrB = parcelRequire("5FkrB");
var $2390e0a738ab81f9$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});



parcelRegister("e9nnz", function(module, exports) {
$parcel$export(module.exports, "ExitingContext", () => $a4d40a97fb679e4b$export$b9c4904d7a6929e6);
$parcel$export(module.exports, "default", () => $a4d40a97fb679e4b$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $50U6m = parcelRequire("50U6m");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $a4d40a97fb679e4b$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isInsideExitingPersistence: false,
    isExiting: false
};
var $a4d40a97fb679e4b$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $5FkrB.createContext)($a4d40a97fb679e4b$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $a4d40a97fb679e4b$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a4d40a97fb679e4b$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($a4d40a97fb679e4b$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $a4d40a97fb679e4b$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $a4d40a97fb679e4b$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $a4d40a97fb679e4b$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $a4d40a97fb679e4b$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $a4d40a97fb679e4b$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $a4d40a97fb679e4b$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false,
            isInsideExitingPersistence: true
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false,
            isInsideExitingPersistence: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $a4d40a97fb679e4b$var$childrenToArray(previousChildren);
    var current = $a4d40a97fb679e4b$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var nextChildren = currentChildren !== children ? $a4d40a97fb679e4b$var$childrenToArray(children) : current;
    var missingKeys = $a4d40a97fb679e4b$var$getMissingKeys(nextChildren, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $a4d40a97fb679e4b$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $50U6m.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $a4d40a97fb679e4b$var$wrapChildWithContextProvider(child, {
            appear: true,
            isInsideExitingPersistence: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $a4d40a97fb679e4b$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$a4d40a97fb679e4b$export$2e2bcd8739ae039 = $a4d40a97fb679e4b$var$ExitingPersistence;
$a4d40a97fb679e4b$var$ExitingPersistence.displayName = 'ExitingPersistence';

});

parcelRegister("7X67V", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ca2cbc46961ee1d$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $hCtkn = parcelRequire("hCtkn");
var $5ca2cbc46961ee1d$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $5ca2cbc46961ee1d$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $5ca2cbc46961ee1d$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $hCtkn.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $5ca2cbc46961ee1d$export$2e2bcd8739ae039 = $5ca2cbc46961ee1d$var$FadeIn;

});
parcelRegister("hCtkn", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd3cbc249d27df0c$export$2e2bcd8739ae039);
/* keyframes-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $i4KJT = parcelRequire("i4KJT");

var $hF78c = parcelRequire("hF78c");

var $IQapX = parcelRequire("IQapX");

var $e7MAD = parcelRequire("e7MAD");

var $aKoBY = parcelRequire("aKoBY");

var $aNX0r = parcelRequire("aNX0r");
var $cd3cbc249d27df0c$var$zoomIn = null;
var $cd3cbc249d27df0c$var$zoomOut = null;
var $cd3cbc249d27df0c$var$fadeIn = null;
var $cd3cbc249d27df0c$var$fadeOut = null;
var $cd3cbc249d27df0c$var$fadeInFromTop = null;
var $cd3cbc249d27df0c$var$fadeOutFromTop = null;
var $cd3cbc249d27df0c$var$fadeInFromLeft = null;
var $cd3cbc249d27df0c$var$fadeOutFromLeft = null;
var $cd3cbc249d27df0c$var$fadeInFromBottom = null;
var $cd3cbc249d27df0c$var$fadeOutFromBottom = null;
var $cd3cbc249d27df0c$var$fadeInFromRight = null;
var $cd3cbc249d27df0c$var$fadeOutFromRight = null;
var $cd3cbc249d27df0c$var$fadeInFromTopConstant = null;
var $cd3cbc249d27df0c$var$fadeOutFromTopConstant = null;
var $cd3cbc249d27df0c$var$fadeInFromLeftConstant = null;
var $cd3cbc249d27df0c$var$fadeOutFromLeftConstant = null;
var $cd3cbc249d27df0c$var$fadeInFromBottomConstant = null;
var $cd3cbc249d27df0c$var$fadeOutFromBottomConstant = null;
var $cd3cbc249d27df0c$var$fadeInFromRightConstant = null;
var $cd3cbc249d27df0c$var$fadeOutFromRightConstant = null;
var $cd3cbc249d27df0c$var$slideInFromTop = null;
var $cd3cbc249d27df0c$var$slideOutFromTop = null;
var $cd3cbc249d27df0c$var$slideInFromRight = null;
var $cd3cbc249d27df0c$var$slideOutFromRight = null;
var $cd3cbc249d27df0c$var$slideInFromBottom = null;
var $cd3cbc249d27df0c$var$slideOutFromBottom = null;
var $cd3cbc249d27df0c$var$slideInFromLeft = null;
var $cd3cbc249d27df0c$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $cd3cbc249d27df0c$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $aNX0r.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $aKoBY.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $e7MAD.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $5FkrB.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $IQapX.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $hF78c.exitingDurations)[duration] : (0, $i4KJT.durations)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $970q7.default)([
            (0, $970q7.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $970q7.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $970q7.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $970q7.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $970q7.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $970q7.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $970q7.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $970q7.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $970q7.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $970q7.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $970q7.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $970q7.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $970q7.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $970q7.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $970q7.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $970q7.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $970q7.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $970q7.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $970q7.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $970q7.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $970q7.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $970q7.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $970q7.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $970q7.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $970q7.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $970q7.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $970q7.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $970q7.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $970q7.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $970q7.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $970q7.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $970q7.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $970q7.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $970q7.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $970q7.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $970q7.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $970q7.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $970q7.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $970q7.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $970q7.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $970q7.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $970q7.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $970q7.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $970q7.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $970q7.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $970q7.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $970q7.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $970q7.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $970q7.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $970q7.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $970q7.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $cd3cbc249d27df0c$export$2e2bcd8739ae039 = $cd3cbc249d27df0c$var$EnteringMotion;

});
parcelRegister("i4KJT", function(module, exports) {
$parcel$export(module.exports, "durations", () => $d28cdb29d522de41$export$38b928a7167ce124);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $d28cdb29d522de41$export$368bacef0dacbe05 = 25;
var $d28cdb29d522de41$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};

});

parcelRegister("hF78c", function(module, exports) {
$parcel$export(module.exports, "exitingDurations", () => $cdbbcc1c2e33aec2$export$30fa1a2e62ae150c);

var $i4KJT = parcelRequire("i4KJT");
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $cdbbcc1c2e33aec2$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $cdbbcc1c2e33aec2$export$30fa1a2e62ae150c = {
    none: (0, $i4KJT.durations).none,
    small: (0, $i4KJT.durations).small * $cdbbcc1c2e33aec2$var$EXITING_MOTION_MULTIPLIER,
    medium: (0, $i4KJT.durations).medium * $cdbbcc1c2e33aec2$var$EXITING_MOTION_MULTIPLIER,
    large: (0, $i4KJT.durations).large * $cdbbcc1c2e33aec2$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("IQapX", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $086c9375c67ced11$export$b7baf7667a68d87c);

var $bm3oP = parcelRequire("bm3oP");
var $086c9375c67ced11$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!(0, $bm3oP.isMatchMediaAvailable)()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};

});
parcelRegister("bm3oP", function(module, exports) {
$parcel$export(module.exports, "isMatchMediaAvailable", () => $844462dae5886456$export$c5406bd59b374abd);
var $844462dae5886456$export$c5406bd59b374abd = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};

});


parcelRegister("e7MAD", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", () => $a487691292d75b7e$export$4f34107a2b00f39c);

var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $a487691292d75b7e$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $a487691292d75b7e$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $a487691292d75b7e$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("aKoBY", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $7d314a9652abc935$export$3b6f38abbdcbd000);

var $5FkrB = parcelRequire("5FkrB");

var $e9nnz = parcelRequire("e9nnz");
var $7d314a9652abc935$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)((0, $e9nnz.ExitingContext));
};

});

parcelRegister("aNX0r", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $7ddc405ea29e2371$export$25c7213fc07ec080);

var $5FkrB = parcelRequire("5FkrB");

var $78X8o = parcelRequire("78X8o");

var $cDKvn = parcelRequire("cDKvn");
var $7ddc405ea29e2371$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var identifier = (0, $78X8o.useUniqueId)();
    var context = (0, $5FkrB.useContext)((0, $cDKvn.StaggeredEntranceContext));
    return context(identifier);
};

});
parcelRegister("78X8o", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $5337269aea17b3f5$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $5337269aea17b3f5$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});

parcelRegister("cDKvn", function(module, exports) {
$parcel$export(module.exports, "StaggeredEntranceContext", () => $933d338336ba1945$export$5e65d7d58ae96ad8);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");

var $3S9Na = parcelRequire("3S9Na");
var $933d338336ba1945$export$5e65d7d58ae96ad8 = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $eVb4V.default)
    };
});
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $933d338336ba1945$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $3S9Na.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($933d338336ba1945$export$5e65d7d58ae96ad8.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$933d338336ba1945$export$2e2bcd8739ae039 = $933d338336ba1945$var$StaggeredEntrance;

});
parcelRegister("3S9Na", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $2d1e02c02964befa$export$e5c5a5f917a5871c);

var $5FkrB = parcelRequire("5FkrB");
var $2d1e02c02964befa$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);

});





parcelRegister("5K5L9", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $42e5b75ea169c552$export$badac9ada3a0bdf9);

var $fC8ib = parcelRequire("fC8ib");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $lsgol = parcelRequire("lsgol");

var $50U6m = parcelRequire("50U6m");

var $kmo34 = parcelRequire("kmo34");

var $kCaFw = parcelRequire("kCaFw");

// Export types from PopperJS / React Popper
var $42e5b75ea169c552$var$viewportPadding = 5;
var $42e5b75ea169c552$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $42e5b75ea169c552$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $42e5b75ea169c552$var$defaultChildrenFn() {
    return null;
}
var $42e5b75ea169c552$var$defaultOffset = [
    0,
    8
];
function $42e5b75ea169c552$export$badac9ada3a0bdf9(_ref) {
    var children = _ref.children, offset = _ref.offset, placement = _ref.placement, referenceElement = _ref.referenceElement, modifiers = _ref.modifiers, strategy = _ref.strategy, shouldFitViewport = _ref.shouldFitViewport;
    // The FF check sits at the very top of the public Popper so the
    // rest of the function (which has its own hooks) does not violate
    // the rules of hooks. Each branch is its own component with its
    // own complete hook order. Props are forwarded explicitly to
    // satisfy `no-unsafe-spread-props`.
    if ((0, $50U6m.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kCaFw.PopperTopLayer), {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($42e5b75ea169c552$var$LegacyPopper, {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
}
function $42e5b75ea169c552$var$LegacyPopper(_ref2) {
    var _ref2$children = _ref2.children, children = _ref2$children === void 0 ? $42e5b75ea169c552$var$defaultChildrenFn : _ref2$children, _ref2$offset = _ref2.offset, offset = _ref2$offset === void 0 ? $42e5b75ea169c552$var$defaultOffset : _ref2$offset, _ref2$placement = _ref2.placement, placement = _ref2$placement === void 0 ? 'bottom-start' : _ref2$placement, _ref2$referenceElemen = _ref2.referenceElement, referenceElement = _ref2$referenceElemen === void 0 ? undefined : _ref2$referenceElemen, modifiers = _ref2.modifiers, _ref2$strategy = _ref2.strategy, strategy = _ref2$strategy === void 0 ? 'fixed' : _ref2$strategy, _ref2$shouldFitViewpo = _ref2.shouldFitViewport, shouldFitViewport = _ref2$shouldFitViewpo === void 0 ? false : _ref2$shouldFitViewpo;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $5FkrB.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $42e5b75ea169c552$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $kmo34.getMaxSizeModifiers)({
            viewportPadding: $42e5b75ea169c552$var$viewportPadding
        }) : [];
        return [].concat($42e5b75ea169c552$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $5FkrB.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $lsgol.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("kmo34", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", () => $ed28843bb38c002b$export$6d8c2b45c99d6e3f);

var $iYJcE = parcelRequire("iYJcE");
function $ed28843bb38c002b$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});

parcelRegister("kCaFw", function(module, exports) {
$parcel$export(module.exports, "PopperTopLayer", () => $f01fa1d8348a181d$export$9802f50720ab826e);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");

var $3FHSI = parcelRequire("3FHSI");

var $bV0Q4 = parcelRequire("bV0Q4");

var $kdlYT = parcelRequire("kdlYT");

var $4NEzJ = parcelRequire("4NEzJ");

var $e1tcw = parcelRequire("e1tcw");

var $fYeDC = parcelRequire("fYeDC");

var $kyudp = parcelRequire("kyudp");

var $eMHjn = parcelRequire("eMHjn");

var $csRnP = parcelRequire("csRnP");

var $5PAvc = parcelRequire("5PAvc");

var $lu0lf = parcelRequire("lu0lf");

var $1OtNW = parcelRequire("1OtNW");
/**
 * Inert render-prop values. The browser owns positioning under CSS Anchor
 * Positioning, so `style` / `ref` / `arrowProps` / `update` / `forceUpdate`
 * are no-ops that consumers can safely spread. Module scope keeps identities
 * stable for effect dep arrays.
 */ var $f01fa1d8348a181d$var$noopStyle = {};
var $f01fa1d8348a181d$var$noopSetRef = (0, $eVb4V.default);
var $f01fa1d8348a181d$var$noopUpdate = function noopUpdate() {
    return Promise.resolve(null);
};
var $f01fa1d8348a181d$var$noopForceUpdate = function noopForceUpdate() {
    return {};
};
/**
 * `react-popper` stamps `data-popper-arrow` on the arrow element at runtime
 * but does not declare it on `arrowProps`. Widen the type so consumers that
 * rely on the attribute (CSS selectors, snapshots, tests) keep working.
 */ var $f01fa1d8348a181d$var$noopArrowProps = {
    ref: $f01fa1d8348a181d$var$noopSetRef,
    style: $f01fa1d8348a181d$var$noopStyle,
    'data-popper-arrow': true
};
/**
 * Returns the primary axis (`top` / `bottom` / `left` / `right`) of a popper
 * placement, used to pick which axis `useFitViewportMaxSize` caps to the
 * anchor edge.
 */ function $f01fa1d8348a181d$var$getPlacementAxis(placement) {
    if (placement.startsWith('top')) return 'top';
    if (placement.startsWith('bottom')) return 'bottom';
    if (placement.startsWith('left')) return 'left';
    if (placement.startsWith('right')) return 'right';
    // `auto*` placements have no fixed axis. Default to `bottom` to match the
    // `auto -> block-end` mapping in `fromLegacyPlacement`.
    return 'bottom';
}
/**
 * Normalises popper's `[along, away]` offset (which may include `null` or
 * `undefined` entries) into the `[along, away]` number tuple
 * `fromLegacyPlacement` expects.
 */ function $f01fa1d8348a181d$var$popperToTopLayerOffset(offset) {
    if (!offset) return undefined;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(offset, 2), along = _offset[0], away = _offset[1];
    if (along == null && away == null) return undefined;
    return [
        along !== null && along !== void 0 ? along : 0,
        away !== null && away !== void 0 ? away : 0
    ];
}
function $f01fa1d8348a181d$export$9802f50720ab826e(_ref) {
    var _ref2;
    var children = _ref.children, offset = _ref.offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, referenceElement = _ref.referenceElement, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    // `modifiers` and `strategy` are accepted for source compatibility but have
    // no runtime effect; CSS Anchor Positioning + top-layer rendering replaces
    // them. See `top-layer/notes/migrations/popper-migration.md`.
    // Anchor resolution: `referenceElement` prop, then `<Manager>` context.
    var managerAnchor = (0, $lu0lf.useManagerAnchor)();
    var effectiveReference = (_ref2 = referenceElement !== null && referenceElement !== void 0 ? referenceElement : managerAnchor) !== null && _ref2 !== void 0 ? _ref2 : undefined;
    // Real DOM nodes go to `useAnchorPosition`; popper `VirtualElement`s are
    // bridged through `useAnchorPositionAtPoint`, which owns its own synthetic
    // anchor.
    var htmlAnchor = effectiveReference instanceof HTMLElement ? effectiveReference : null;
    var virtualReference = effectiveReference != null && !(effectiveReference instanceof HTMLElement) ? effectiveReference : null;
    var htmlAnchorRef = (0, $5FkrB.useRef)(htmlAnchor);
    htmlAnchorRef.current = htmlAnchor;
    var popoverRef = (0, $5FkrB.useRef)(null);
    var popoverId = (0, $e1tcw.usePopoverId)();
    // Track the resolved DOM anchor in state so visibility / max-size hooks
    // re-run when its identity changes. Virtual anchors do not feed these
    // hooks because their probe is outside the consumer's DOM.
    //
    // Adjust state during render by comparing against the state itself: the
    // conditional guard means `setResolvedAnchor` is skipped once they match,
    // so it converges in one extra render. This is the React-documented pattern
    // and is side-effect-free — no ref mutation during render.
    var _useState = (0, $5FkrB.useState)(htmlAnchor), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), resolvedAnchor = _useState2[0], setResolvedAnchor = _useState2[1];
    if (resolvedAnchor !== htmlAnchor) setResolvedAnchor(htmlAnchor);
    var topLayerPlacement = (0, $5FkrB.useMemo)(function() {
        return (0, $3FHSI.fromLegacyPlacement)({
            legacy: (0, $csRnP.toLegacyPlacement)(placement),
            offset: $f01fa1d8348a181d$var$popperToTopLayerOffset(offset)
        });
    }, [
        placement,
        offset
    ]);
    var isOpen = effectiveReference != null;
    // HTML-element path. No-op when the reference is virtual or absent.
    (0, $kdlYT.useAnchorPosition)({
        anchorRef: htmlAnchorRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isEnabled: htmlAnchor != null,
        isOpen: isOpen
    });
    // Virtual-element path. `useAnchorPositionAtPoint` owns a synthetic
    // anchor in `document.body` and latches `getPoint` once per
    // `isEnabled` activation. Reading the latest `virtualReference` and
    // `topLayerPlacement` via refs ensures the latched closure always
    // sees the current values rather than the ones captured at first
    // activation, which would otherwise go stale if either prop changes
    // while the popper stays open.
    var virtualReferenceRef = (0, $5FkrB.useRef)(virtualReference);
    virtualReferenceRef.current = virtualReference;
    var topLayerPlacementRef = (0, $5FkrB.useRef)(topLayerPlacement);
    topLayerPlacementRef.current = topLayerPlacement;
    var isVirtualEnabled = virtualReference != null;
    (0, $4NEzJ.useAnchorPositionAtPoint)({
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isEnabled: isVirtualEnabled,
        isOpen: isOpen,
        getPoint: function getPoint() {
            var current = virtualReferenceRef.current;
            if (!current) return null;
            return (0, $eMHjn.rectPointForPlacement)({
                rect: current.getBoundingClientRect(),
                placement: topLayerPlacementRef.current,
                isRtl: (0, $kyudp.isPageRtl)()
            });
        }
    });
    var _useReferenceVisibili = (0, $1OtNW.useReferenceVisibility)({
        anchor: resolvedAnchor,
        popoverRef: popoverRef
    }), isReferenceHidden = _useReferenceVisibili.isReferenceHidden, hasPopperEscaped = _useReferenceVisibili.hasPopperEscaped;
    // Restore legacy `react-popper`'s natural-width behaviour. Under CSS
    // Anchor Positioning the `position-area` grid cell becomes the popover
    // host's containing block, so an auto-width host shrinks to that cell.
    // When the anchor sits near a viewport edge the cell is narrow, so the
    // content wraps far more than it did under `react-popper` (which kept the
    // content's natural width and shifted/flipped to stay on screen).
    // `min-inline-size: max-content` (mode `'none'`) floors the host at its
    // content's intrinsic width, so a too-narrow span overflows the viewport
    // (driving `position-try-fallbacks`) instead of wrapping. This is safe
    // alongside `shouldFitViewport`: the fit caps clamp the host on both axes,
    // so the host never exceeds the viewport / anchor-edge cap.
    (0, $fYeDC.useWidthFromAnchor)({
        mode: 'none',
        popoverRef: popoverRef,
        anchorRef: htmlAnchorRef,
        isOpen: isOpen
    });
    // `shouldFitViewport` caps are applied directly to the `position-area`
    // host, whose containing block is the cell between the anchor edge and the
    // viewport edge — so a pure-CSS `calc(100% - 5px - gap)` reproduces the
    // legacy per-placement anchor-edge cap with no measurement. The gap mirrors
    // `getPlacement`: an omitted offset resolves to `space.100`, otherwise the
    // consumer's `away` value.
    var resolvedOffset = $f01fa1d8348a181d$var$popperToTopLayerOffset(offset);
    var fitGap = resolvedOffset ? "".concat(resolvedOffset[1], "px") : "var(--ds-space-100, 8px)";
    var placementAxis = $f01fa1d8348a181d$var$getPlacementAxis(placement);
    (0, $5PAvc.useFitViewportMaxSize)({
        target: popoverRef,
        placementAxis: placementAxis,
        gap: fitGap,
        isEnabled: shouldFitViewport,
        isOpen: isOpen
    });
    var renderChildren = children;
    if (typeof renderChildren !== 'function') return null;
    var renderPropArg = {
        ref: $f01fa1d8348a181d$var$noopSetRef,
        style: $f01fa1d8348a181d$var$noopStyle,
        placement: placement,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped,
        update: $f01fa1d8348a181d$var$noopUpdate,
        forceUpdate: $f01fa1d8348a181d$var$noopForceUpdate,
        arrowProps: $f01fa1d8348a181d$var$noopArrowProps
    };
    var content = renderChildren(renderPropArg);
    // The `shouldFitViewport` size caps live on the `<Popover>` host itself
    // (applied by `useFitViewportMaxSize` above), so the consumer's content is
    // rendered directly with no intermediate wrapper.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bV0Q4.Popover), {
        ref: popoverRef,
        id: popoverId,
        isOpen: isOpen,
        mode: "manual",
        shouldAnimate: false
    }, content);
}

});
parcelRegister("3FHSI", function(module, exports) {
$parcel$export(module.exports, "fromLegacyPlacement", () => $2ac73d5cb9e11b1f$export$69e99ed50b2534c9);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $jLOvB = parcelRequire("jLOvB");
function $2ac73d5cb9e11b1f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2ac73d5cb9e11b1f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2ac73d5cb9e11b1f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2ac73d5cb9e11b1f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2ac73d5cb9e11b1f$export$69e99ed50b2534c9(_ref) {
    var legacy = _ref.legacy, offset = _ref.offset;
    var basePlacement = (0, $jLOvB.placementMapping)[legacy];
    if (!offset) return basePlacement;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(offset, 2), along = _offset[0], away = _offset[1];
    return $2ac73d5cb9e11b1f$var$_objectSpread($2ac73d5cb9e11b1f$var$_objectSpread({}, basePlacement), {}, {
        offset: {
            gap: away,
            crossAxisShift: {
                // Sign is captured in `direction`; `value` is the magnitude.
                value: Math.abs(along),
                direction: along >= 0 ? 'forwards' : 'backwards'
            }
        }
    });
}

});
parcelRegister("jLOvB", function(module, exports) {
$parcel$export(module.exports, "placementMapping", () => $e6499612008a1486$export$27df359c528b7120);
/**
 * The full mapping record. Internal - use `fromLegacyPlacement` from the
 * public entry-point so the offset-tuple translation is applied consistently.
 *
 * Note: `auto`, `auto-start`, `auto-end` map to `block-end` placements. This
 * is a reduction in expressiveness vs Popper.js (which picked the best
 * placement at runtime). CSS `position-try-fallbacks` flips at the edge but
 * the initial placement is fixed. Migration consumers who relied on Popper's
 * dynamic auto-flip should pick an explicit placement instead.
 */ var $e6499612008a1486$export$27df359c528b7120 = {
    top: {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'start'
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'end'
    },
    bottom: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    },
    right: {
        axis: 'inline',
        edge: 'end',
        align: 'center'
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'start'
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'end'
    },
    left: {
        axis: 'inline',
        edge: 'start',
        align: 'center'
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'start'
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'end'
    },
    auto: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'auto-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'auto-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    }
};

});


parcelRegister("bV0Q4", function(module, exports) {
$parcel$export(module.exports, "Popover", () => $8ad5ab271a034ac0$export$5b6b19405a83ff9d);
/* popover.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $hUFig = parcelRequire("hUFig");

var $7QpUe = parcelRequire("7QpUe");

var $iO8GM = parcelRequire("iO8GM");

var $bvsoE = parcelRequire("bvsoE");

var $4GeHz = parcelRequire("4GeHz");

var $aV7S3 = parcelRequire("aV7S3");

var $13E4J = parcelRequire("13E4J");

var $cEazL = parcelRequire("cEazL");

var $ensDV = parcelRequire("ensDV");

var $3DRzX = parcelRequire("3DRzX");
/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ var $8ad5ab271a034ac0$var$supportsPopoverHint = (0, $bvsoE.default)(function() {
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    var element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
// Surface reset — neutralises inherited interaction and text-layout properties
// (e.g. `pointer-events: none` from an overlaid controls container and
// `white-space: nowrap` from an `@atlaskit/select` option) that leak into a
// top-layer element because, for CSS inheritance, it is still a DOM child of its
// trigger (top-layer promotion is paint/stacking only; the legacy portal path
// avoided this by rendering at `<body>`). Excludes `color`/`font` (theming) and
// `direction`/`unicode-bidi` (RTL must inherit).
//
// KEEP IN SYNC with the identical `surfaceResetStyles` in `dialog/dialog-content.tsx`.
// ADS forbids sharing styles across files (`no-exported-styles` /
// `no-imported-style-values` — Compiled styles are null at runtime), so the reset is
// co-located and duplicated deliberately.
var $8ad5ab271a034ac0$var$surfaceResetStyles = {
    root: "_lcxv1wug _o5724jg8 _1nmz4jg8 _1i4q4jg8 _y3gnv2br _azhwidpf _1p1dglyw"
};
var $8ad5ab271a034ac0$var$styles = {
    root: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r041wug _1reoewfl _18m9ewfl _bfhk1j28 _4t3i1wug",
    motion: "_k8m011k7 _1oecdn4k _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v179n",
    exit: "_y44vof1f"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
var $8ad5ab271a034ac0$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ var $8ad5ab271a034ac0$var$POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
var $8ad5ab271a034ac0$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function Popover(_ref, ref) {
    var children = _ref.children, _ref$mode = _ref.mode, modeProp = _ref$mode === void 0 ? 'auto' : _ref$mode, onClose = _ref.onClose, onEnterFinish = _ref.onEnterFinish, onExitFinish = _ref.onExitFinish, _ref$shouldAnimate = _ref.shouldAnimate, shouldAnimate = _ref$shouldAnimate === void 0 ? false : _ref$shouldAnimate, placement = _ref.placement, testId = _ref.testId, isOpen = _ref.isOpen, enteringAnimationXcss = _ref.enteringAnimationXcss, exitingAnimationXcss = _ref.exitingAnimationXcss, role = _ref.role, label = _ref.label, labelledBy = _ref.labelledBy, idProp = _ref.id;
    var autoId = (0, $5FkrB.useId)();
    var ownRef = (0, $5FkrB.useRef)(null);
    var combinedRef = (0, $iO8GM.default)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    var popoverId = idProp !== null && idProp !== void 0 ? idProp : "popover-".concat(autoId.replace(/:/g, ''));
    var _useAnimatedVisibilit = (0, $cEazL.useAnimatedVisibility)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    }), phase = _useAnimatedVisibilit.phase, onToggle = _useAnimatedVisibilit.onToggle;
    // True while the host element is mounted (any phase except `closed`).
    // Used as a dep so listener-rebind effects re-attach after a remount.
    var isVisible = phase !== 'closed';
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // focus-capturing roles are handled below via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus-restoration.md.
    (0, $ensDV.useFocusWrap)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    (0, $3DRzX.useInitialFocus)({
        elementRef: ownRef,
        phase: phase,
        role: role
    });
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined.
    var handleObserverClose = (0, $5FkrB.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose({
            reason: 'programmatic'
        });
    }, [
        onClose
    ]);
    (0, $4GeHz.useNotifyOpenLayerObserver)({
        type: role && $8ad5ab271a034ac0$var$POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen: isOpen,
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    var mode = modeProp === 'hint' && !$8ad5ab271a034ac0$var$supportsPopoverHint() ? 'auto' : modeProp;
    var popupMotionStyle = (0, $5FkrB.useMemo)(function() {
        if (!placement || !shouldAnimate) return undefined;
        var _resolvePlacement = (0, $aV7S3.resolvePlacement)({
            placement: placement
        }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge;
        return $8ad5ab271a034ac0$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]);
    // Prevents toggle handler from calling onClose for our own hidePopover() calls.
    var programmaticCloseRef = (0, $5FkrB.useRef)(false);
    // Set in capture-phase keydown so the toggle handler knows close reason.
    var closeReasonRef = (0, $5FkrB.useRef)('light-dismiss');
    // Snapshot of pre-open focus, used to restore focus for nested popovers
    // with focus-capturing roles (browser only restores the outermost).
    var previouslyFocusedElementRef = (0, $5FkrB.useRef)(null);
    var handleBeforeToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState !== 'open') return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- need active element snapshot
        var active = document.activeElement;
        previouslyFocusedElementRef.current = active instanceof HTMLElement ? active : null;
    }, []);
    var handleToggle = (0, $5FkrB.useCallback)(function(event) {
        var element = ownRef.current;
        if (event.newState === 'open') {
            onToggle(event);
            return;
        }
        if (event.newState === 'closed') {
            if (element) {
                // Nested-popover focus restoration fallback (browser only
                // restores outermost; Firefox skips nested entirely).
                // Restore only when the role moved focus in on open AND the
                // close was Escape/programmatic. For light dismiss, the
                // click target keeps focus per HTML spec
                // (`focusPreviousElement=false`).
                var previouslyFocused = previouslyFocusedElementRef.current;
                var reason = closeReasonRef.current;
                var isProgrammatic = programmaticCloseRef.current;
                var shouldRestore = previouslyFocused !== null && previouslyFocused.isConnected && (0, $13E4J.shouldFocusIntoPopover)({
                    role: role
                }) && (reason === 'escape' || isProgrammatic);
                if (shouldRestore && previouslyFocused) previouslyFocused.focus({
                    preventScroll: true
                });
                previouslyFocusedElementRef.current = null;
            }
            // Programmatic close: consumer already knows.
            if (programmaticCloseRef.current) // Reset reason so a stale 'escape' from a race with Escape keydown
            // does not corrupt the next browser-dismiss cycle.
            closeReasonRef.current = 'light-dismiss';
            else {
                // Browser dismiss (Escape/click-outside).
                var _reason = closeReasonRef.current;
                closeReasonRef.current = 'light-dismiss';
                // Optional: `manual` mode has no `onClose` in the forwarded type.
                onClose === null || onClose === void 0 || onClose({
                    reason: _reason
                });
            }
        }
        onToggle(event);
    }, [
        onClose,
        onToggle,
        role
    ]);
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `previouslyFocusedElementRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        var unbindEscape = (0, $7QpUe.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key === 'Escape') closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        var unbindToggle = (0, $7QpUe.bind)(element, {
            type: 'toggle',
            listener: handleToggle
        });
        // Snapshot `document.activeElement` before `useInitialFocus` moves it.
        var unbindBeforeToggle = (0, $7QpUe.bind)(element, {
            type: 'beforetoggle',
            listener: handleBeforeToggle
        });
        return function() {
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleToggle,
        handleBeforeToggle,
        isVisible
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            programmaticCloseRef.current = false;
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and the no-animation path unmounts before
            // `handleToggle` can reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch (_unused) {}
            return function() {
                programmaticCloseRef.current = true;
                try {
                    element.hidePopover();
                } catch (_unused2) {}
            };
        }
        programmaticCloseRef.current = true;
        try {
            element.hidePopover();
        } catch (_unused3) {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        ref: combinedRef,
        id: popoverId,
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        style: popupMotionStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $8ad5ab271a034ac0$var$styles.root,
            $8ad5ab271a034ac0$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $8ad5ab271a034ac0$var$styles.enter,
            shouldAnimate && phase === 'exiting' && $8ad5ab271a034ac0$var$styles.exit,
            shouldAnimate && $8ad5ab271a034ac0$var$styles.motion,
            (0, $hUFig.cx)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ])
    }, children);
});

});
parcelRegister("hUFig", function(module, exports) {
$parcel$export(module.exports, "cx", () => $d0a7b2aae633a080$export$a274e22fb40f762e);

var $970q7 = parcelRequire("970q7");
const $d0a7b2aae633a080$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $970q7.default)(actualStyles);
};

});

parcelRegister("bvsoE", function(module, exports) {
$parcel$export(module.exports, "default", () => $86089df3a0fd54eb$export$2e2bcd8739ae039);
/**
 * Creates a new function that will cache the result of it's first call.
 *
 * ```ts
 * function sayHello(name: string): string {
 *   return `Hello ${name}`;
 * }
 * const cached = once(sayHello);
 *
 * cached('Alex'); // returns "Hello Alex"
 * cached('Sam'); // returns "Hello Alex" (underlying `sayHello` function not called)
 * ```
 *
 * **Notes**
 *
 * - If the `onced` function throws, then the return value of the function is not cached
 * - Respects call site context (`this`) when executing the onced function
 */ function $86089df3a0fd54eb$export$2e2bcd8739ae039(fn) {
    var cache = null;
    return function result() {
        if (!cache) {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            cache = {
                value: fn.call.apply(fn, [
                    this
                ].concat(args))
            };
        }
        /**
     * Intentionally not adding `.clear()` function property
     *
     * - We currently have no need for it
     * - We don't want to add a `.clear()` to functions that should never be called twice,
     *   for example: `cleanup` functions.
     * - We can add a `onceWithCleanup` variant as a separate export from ds-lib if the
     *   need arises 🧘
     */ return cache.value;
    };
}

});

parcelRegister("4GeHz", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $36867d1ee34deccb$export$469bb693f11edc7f);

var $5FkrB = parcelRequire("5FkrB");

var $ffBNy = parcelRequire("ffBNy");

var $82jDF = parcelRequire("82jDF");
function $36867d1ee34deccb$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $ffBNy.OpenLayerObserverContext));
    var namespace = (0, $82jDF.useOpenLayerObserverNamespace)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("ffBNy", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $b1a593a8828d8f20$export$5fbf4d7fae6cdc00);

var $5FkrB = parcelRequire("5FkrB");
var $b1a593a8828d8f20$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});

parcelRegister("82jDF", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $5d9dbe83d025de57$export$1d57e79091cc3046);

var $5FkrB = parcelRequire("5FkrB");

var $8sk1x = parcelRequire("8sk1x");
function $5d9dbe83d025de57$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $8sk1x.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("8sk1x", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $6280789573ef57cc$export$644a49f3b8c50fcd);

var $5FkrB = parcelRequire("5FkrB");
var $6280789573ef57cc$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});



parcelRegister("aV7S3", function(module, exports) {
$parcel$export(module.exports, "resolvePlacement", () => $7f3555381f07ba25$export$63044d21bc3d3fa2);

var $1zYlV = parcelRequire("1zYlV");
/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ var $7f3555381f07ba25$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $7f3555381f07ba25$export$63044d21bc3d3fa2(_ref) {
    var _placement$offset, _placement$axis, _placement$edge, _placement$align, _placement$offset$cro, _placement$offset2, _placement$offset$cro2, _placement$offset3;
    var placement = _ref.placement;
    var consumerGap = (_placement$offset = placement.offset) === null || _placement$offset === void 0 ? void 0 : _placement$offset.gap;
    return {
        axis: (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block',
        edge: (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end',
        align: (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center',
        offset: {
            gap: consumerGap === undefined ? $7f3555381f07ba25$var$DEFAULT_GAP : (0, $1zYlV.toCssLengthString)({
                value: consumerGap
            }),
            crossAxisShift: {
                value: (0, $1zYlV.toCssLengthString)({
                    value: (_placement$offset$cro = (_placement$offset2 = placement.offset) === null || _placement$offset2 === void 0 || (_placement$offset2 = _placement$offset2.crossAxisShift) === null || _placement$offset2 === void 0 ? void 0 : _placement$offset2.value) !== null && _placement$offset$cro !== void 0 ? _placement$offset$cro : 0
                }),
                direction: (_placement$offset$cro2 = (_placement$offset3 = placement.offset) === null || _placement$offset3 === void 0 || (_placement$offset3 = _placement$offset3.crossAxisShift) === null || _placement$offset3 === void 0 ? void 0 : _placement$offset3.direction) !== null && _placement$offset$cro2 !== void 0 ? _placement$offset$cro2 : 'forwards'
            }
        }
    };
}

});
parcelRegister("1zYlV", function(module, exports) {
$parcel$export(module.exports, "toCssLengthString", () => $1267e01a1a8a4abc$export$63b6b0ff65d84d47);
/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $1267e01a1a8a4abc$export$63b6b0ff65d84d47(_ref) {
    var value = _ref.value;
    if (typeof value === 'number') return "".concat(value, "px");
    return value;
}

});


parcelRegister("13E4J", function(module, exports) {
$parcel$export(module.exports, "shouldFocusIntoPopover", () => $0c55285f00381bc9$export$b12adccf56228c71);
var $0c55285f00381bc9$var$rolesThatMoveFocus = new Set([
    'dialog',
    'alertdialog',
    'menu',
    'listbox',
    'tree',
    'grid'
]);
function $0c55285f00381bc9$export$b12adccf56228c71(_ref) {
    var role = _ref.role;
    if (!role) return false;
    return $0c55285f00381bc9$var$rolesThatMoveFocus.has(role);
}

});

parcelRegister("cEazL", function(module, exports) {
$parcel$export(module.exports, "useAnimatedVisibility", () => $93516c96f9a01130$export$1bccb45daf07907f);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $l2A81 = parcelRequire("l2A81");
function $93516c96f9a01130$var$runCancellableSettlement(_ref) {
    var schedule = _ref.schedule, onSettled = _ref.onSettled;
    var isCancelled = false;
    schedule(function() {
        if (isCancelled) return;
        onSettled();
    });
    return function() {
        isCancelled = true;
    };
}
/**
 * Fires `onSettled` once all animations currently applied to `element`
 * finish or are cancelled. Returns a cleanup that prevents stale settlement.
 */ function $93516c96f9a01130$var$runOnAnimationsSettled(_ref2) {
    var element = _ref2.element, onSettled = _ref2.onSettled;
    return $93516c96f9a01130$var$runCancellableSettlement({
        onSettled: onSettled,
        schedule: function schedule(settle) {
            var _element$getAnimation, _element$getAnimation2;
            var animations = (_element$getAnimation = (_element$getAnimation2 = element.getAnimations) === null || _element$getAnimation2 === void 0 ? void 0 : _element$getAnimation2.call(element)) !== null && _element$getAnimation !== void 0 ? _element$getAnimation : [];
            Promise.allSettled(animations.map(function(animation) {
                return animation.finished;
            })).then(settle);
        }
    });
}
function $93516c96f9a01130$export$1bccb45daf07907f(_ref3) {
    var isOpen = _ref3.isOpen, shouldAnimate = _ref3.shouldAnimate, elementRef = _ref3.elementRef, onEnterFinish = _ref3.onEnterFinish, onExitFinish = _ref3.onExitFinish;
    var willAnimate = shouldAnimate && !(0, $l2A81.prefersReducedMotion)();
    var isNativeClosedRef = (0, $5FkrB.useRef)(false);
    // Promote `closed → entering`/`closed → open` synchronously during
    // render so the host element mounts in the same commit as the open
    // intent. All other transitions are driven by phase-specific effects.
    var _useState = (0, $5FkrB.useState)(function() {
        if (!isOpen) return 'closed';
        return willAnimate ? 'entering' : 'open';
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), phase = _useState2[0], setPhase = _useState2[1];
    // Rearm only after controlled state and the native lifecycle have both
    // reached closed. Resetting as soon as `isOpen` becomes false can erase a
    // closing toggle that was handled in the same React batch.
    if (!isOpen && phase === 'closed') isNativeClosedRef.current = false;
    if (isOpen && phase === 'closed' && !isNativeClosedRef.current) setPhase(willAnimate ? 'entering' : 'open');
    if (!isOpen && (phase === 'open' || phase === 'entering')) // Close intent. Move to `exiting` to gate the unmount on either
    // the exit transition (animated) or the closing toggle event
    // (non-animated). Includes interrupted entry (`entering → exiting`).
    setPhase('exiting');
    if (isOpen && phase === 'exiting' && !isNativeClosedRef.current) // Reopen mid-exit. With animation, jump back to `entering` and let
    // the entry transition restart from current visual state. Without
    // animation, jump straight to `open` (the handshake we were waiting
    // for is no longer relevant; the consumer wants the host visible
    // again synchronously).
    setPhase(willAnimate ? 'entering' : 'open');
    // Keep stable refs to the latest callbacks so effects and promise callbacks
    // always call the current callback without needing them in dependency arrays.
    var onEnterFinishRef = (0, $5FkrB.useRef)(onEnterFinish);
    onEnterFinishRef.current = onEnterFinish;
    var onExitFinishRef = (0, $5FkrB.useRef)(onExitFinish);
    onExitFinishRef.current = onExitFinish;
    // Animated entry: wait for all active animations and move to `open`.
    (0, $5FkrB.useEffect)(function() {
        if (phase !== 'entering') return;
        var element = elementRef.current;
        if (!element) return;
        return $93516c96f9a01130$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                var _onEnterFinishRef$cur;
                // Fire the consumer callback before transitioning phase so any
                // state the consumer reads (refs, DOM nodes) is still attached
                // in the same synchronous tick, regardless of React batching
                // semantics.
                (_onEnterFinishRef$cur = onEnterFinishRef.current) === null || _onEnterFinishRef$cur === void 0 || _onEnterFinishRef$cur.call(onEnterFinishRef);
                setPhase(function(current) {
                    return current === 'entering' ? 'open' : current;
                });
            }
        });
    }, [
        phase,
        elementRef
    ]);
    // Non-animated entry callback. The lifecycle goes `closed → open`
    // directly with no `entering` phase; fire `onEnterFinish` on that jump.
    // A previous-phase ref avoids double-firing on the animated path.
    var prevPhaseForEntryRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForEntryRef.current;
        prevPhaseForEntryRef.current = phase;
        // Animated entry settle goes through `entering` and already fired
        // onEnterFinish above; only handle the non-animated direct jumps.
        if (prevPhase !== 'open' && phase === 'open' && prevPhase !== 'entering') {
            var _onEnterFinishRef$cur2;
            (_onEnterFinishRef$cur2 = onEnterFinishRef.current) === null || _onEnterFinishRef$cur2 === void 0 || _onEnterFinishRef$cur2.call(onEnterFinishRef);
        }
    }, [
        phase
    ]);
    // Animated exit: wait for all active animations, fire `onExitFinish`,
    // then move to `closed` to unmount the host.
    (0, $5FkrB.useEffect)(function() {
        if (phase !== 'exiting' || !willAnimate) return;
        var element = elementRef.current;
        if (!element) return;
        return $93516c96f9a01130$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                var _onExitFinishRef$curr;
                // Fire the consumer callback before transitioning phase to
                // `closed`. The phase change drives the host element unmount,
                // and consumers expect to be able to read the element (or a
                // forwarded ref to it) inside `onExitFinish`. Doing this in
                // the safe order avoids relying on React's automatic batching
                // to keep the element attached across the callback.
                (_onExitFinishRef$curr = onExitFinishRef.current) === null || _onExitFinishRef$curr === void 0 || _onExitFinishRef$curr.call(onExitFinishRef);
                setPhase(function(current) {
                    return current === 'exiting' ? 'closed' : current;
                });
            }
        });
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    // Native dismissal is authoritative. Its toggle can arrive while controlled
    // state still says open, so remember that native state and do not
    // reopen until `isOpen` has first moved to false.
    (0, $5FkrB.useLayoutEffect)(function() {
        if (phase === 'exiting' && !willAnimate && isNativeClosedRef.current) setPhase('closed');
    }, [
        phase,
        willAnimate
    ]);
    var onToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState === 'open') {
            isNativeClosedRef.current = false;
            return;
        }
        if (event.newState !== 'closed') return;
        isNativeClosedRef.current = true;
        setPhase(function(current) {
            if (current === 'open' || current === 'entering') return 'exiting';
            if (current === 'exiting' && !willAnimate) return 'closed';
            return current;
        });
    }, [
        willAnimate
    ]);
    // Non-animated exit callback. There are no animations to wait for, so fire
    // `onExitFinish` on the transition into `exiting` (the unmount itself
    // is gated by the closing toggle handshake above).
    var prevPhaseForExitRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForExitRef.current;
        prevPhaseForExitRef.current = phase;
        // Only fire on the non-animated transition into `exiting`. The
        // animated path's `exiting → closed` settle already fires
        // `onExitFinish` from `runOnAnimationsSettled`.
        if (prevPhase !== 'exiting' && phase === 'exiting' && !willAnimate) {
            var _onExitFinishRef$curr2;
            (_onExitFinishRef$curr2 = onExitFinishRef.current) === null || _onExitFinishRef$curr2 === void 0 || _onExitFinishRef$curr2.call(onExitFinishRef);
        }
    }, [
        phase,
        willAnimate
    ]);
    return {
        phase: phase,
        onToggle: onToggle
    };
}

});
parcelRegister("l2A81", function(module, exports) {
$parcel$export(module.exports, "prefersReducedMotion", () => $f515cf3607dacec7$export$ff7706047246b98b);

var $bvsoE = parcelRequire("bvsoE");
var $f515cf3607dacec7$export$ff7706047246b98b = (0, $bvsoE.default)(function() {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});

});


parcelRegister("ensDV", function(module, exports) {
$parcel$export(module.exports, "useFocusWrap", () => $a7796e9658bdc85c$export$4f6462e86a70abe5);

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $cfeMO = parcelRequire("cfeMO");

var $a8jhg = parcelRequire("a8jhg");

var $abtqo = parcelRequire("abtqo");

var $khtlA = parcelRequire("khtlA");
/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/outputs/menu-keyboard-decision.md
 */ function $a7796e9658bdc85c$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $a7796e9658bdc85c$export$4f6462e86a70abe5(_ref) {
    var elementRef = _ref.elementRef, role = _ref.role, phase = _ref.phase;
    var isVisible = phase !== 'closed';
    (0, $5FkrB.useEffect)(function() {
        var element = elementRef.current;
        if (!element || !$a7796e9658bdc85c$var$roleRequiresFocusWrap(role) || !isVisible) return;
        var unbind = (0, $7QpUe.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $khtlA.isNestedLayerFocused)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                var direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                var next = (0, $abtqo.getNextFocusable)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                var fallback = direction === 'forwards' ? (0, $cfeMO.getFirstFocusable)({
                    container: element
                }) : (0, $a8jhg.getLastFocusable)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}

});
parcelRegister("cfeMO", function(module, exports) {
$parcel$export(module.exports, "getFirstFocusable", () => $8ea25afdbdc75ed4$export$748138f04a69bf21);

var $aiw5o = parcelRequire("aiw5o");
function $8ea25afdbdc75ed4$export$748138f04a69bf21(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $aiw5o.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}

});
parcelRegister("aiw5o", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $77f4796a5defae13$export$f6768025e418420e);

var $7oSpO = parcelRequire("7oSpO");

var $jiNIe = parcelRequire("jiNIe");
function $77f4796a5defae13$export$f6768025e418420e(_ref) {
    var container = _ref.container, filter = _ref.filter;
    return Array.from(container.querySelectorAll((0, $jiNIe.selectors).focusable)).filter(function(element) {
        return element instanceof HTMLElement;
    }).filter(function(element) {
        return (0, $7oSpO.isInSameLayer)({
            element: element,
            container: container
        });
    }).filter(function(element) {
        return !filter || filter(element, container);
    });
}

});
parcelRegister("7oSpO", function(module, exports) {
$parcel$export(module.exports, "isInSameLayer", () => $5634fc0d1bb51a5d$export$df8c72c64edc7260);
var $5634fc0d1bb51a5d$var$topLayerSelector = '[popover], dialog, [role="dialog"], [role="alertdialog"]';
function $5634fc0d1bb51a5d$export$df8c72c64edc7260(_ref) {
    var element = _ref.element, container = _ref.container;
    return element.closest($5634fc0d1bb51a5d$var$topLayerSelector) === container.closest($5634fc0d1bb51a5d$var$topLayerSelector);
}

});

parcelRegister("jiNIe", function(module, exports) {
$parcel$export(module.exports, "selectors", () => $e0d64299560c5807$export$e1252723db1c541);
var $e0d64299560c5807$export$e1252723db1c541 = function() {
    // Common exclusion filter applied to every selector.
    var not = ':not([tabindex="-1"]):not([aria-disabled="true"]):not([aria-hidden="true"])';
    var notDisabled = ":not([disabled])".concat(not);
    var focusable = [
        "a[href]".concat(not),
        "area[href]".concat(not),
        "input".concat(notDisabled, ":not([type=\"hidden\"])"),
        "select".concat(notDisabled),
        "textarea".concat(notDisabled),
        "button".concat(notDisabled),
        "iframe".concat(not),
        "audio[controls]".concat(not),
        "video[controls]".concat(not),
        "[contenteditable]:not([contenteditable=\"false\"])".concat(not),
        "[tabindex]".concat(notDisabled)
    ];
    return {
        focusable: focusable.join(','),
        // Build the `:focus` selector
        focused: focusable.map(function(selector) {
            return "".concat(selector, ":focus");
        }).join(',')
    };
}();

});



parcelRegister("a8jhg", function(module, exports) {
$parcel$export(module.exports, "getLastFocusable", () => $76099ada0fdf0007$export$73e81fa65335a75b);

var $aiw5o = parcelRequire("aiw5o");
function $76099ada0fdf0007$export$73e81fa65335a75b(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $aiw5o.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}

});

parcelRegister("abtqo", function(module, exports) {
$parcel$export(module.exports, "getNextFocusable", () => $76a1c193db3b7ec3$export$a7db88e6d491b450);
/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * Returns `null` if there is no focused element within the container or if
 * the focused element is not in the list of focusable elements.
 */ 
var $aiw5o = parcelRequire("aiw5o");

var $jiNIe = parcelRequire("jiNIe");
function $76a1c193db3b7ec3$export$a7db88e6d491b450(_ref) {
    var _all$nextIndex;
    var container = _ref.container, direction = _ref.direction, filter = _ref.filter;
    var all = (0, $aiw5o.getFocusables)({
        container: container,
        filter: filter
    });
    var current = container.querySelector((0, $jiNIe.selectors).focused);
    if (!(current instanceof HTMLElement)) return null;
    var index = all.indexOf(current);
    if (index === -1) return null;
    var nextIndex = function() {
        if (direction === 'forwards') return (index + 1) % all.length;
        var proposed = index - 1;
        // if going into negative numbers, loop back to the last item
        return proposed < 0 ? all.length - 1 : proposed;
    }();
    return (_all$nextIndex = all[nextIndex]) !== null && _all$nextIndex !== void 0 ? _all$nextIndex : null;
}

});

parcelRegister("khtlA", function(module, exports) {
$parcel$export(module.exports, "isNestedLayerFocused", () => $ec3c28ef0dd48e61$export$b9590fdfeb5f722f);

var $lFhdZ = parcelRequire("lFhdZ");

var $7oSpO = parcelRequire("7oSpO");
function $ec3c28ef0dd48e61$export$b9590fdfeb5f722f(_ref) {
    var _getDocument;
    var container = _ref.container;
    var focused = (_getDocument = (0, $lFhdZ.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return !(0, $7oSpO.isInSameLayer)({
        element: focused,
        container: container
    });
}

});
parcelRegister("lFhdZ", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $fc5ac9c99de29fbb$export$f65ca476c09acec0);
var $fc5ac9c99de29fbb$export$f65ca476c09acec0 = function getDocument() {
    if (typeof document !== 'undefined') return document;
    return null;
};

});



parcelRegister("3DRzX", function(module, exports) {
$parcel$export(module.exports, "useInitialFocus", () => $2a6e934b81596289$export$e992c40175757a22);

var $5FkrB = parcelRequire("5FkrB");

var $cfeMO = parcelRequire("cfeMO");
/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox regardless of role. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, or menu), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
var $2a6e934b81596289$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $2a6e934b81596289$var$isTextboxLikeElement(element) {
    var role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    var tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        var _element$getAttribute;
        var type = ((_element$getAttribute = element.getAttribute('type')) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : 'text').toLowerCase();
        return $2a6e934b81596289$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $2a6e934b81596289$var$isComboboxControllingPopup(_ref) {
    var _active$getAttribute;
    var container = _ref.container;
    var ownerDocument = container.ownerDocument;
    var active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$2a6e934b81596289$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    var idRefs = (_active$getAttribute = active.getAttribute('aria-controls')) !== null && _active$getAttribute !== void 0 ? _active$getAttribute : active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    var referencedIds = idRefs.split(/\s+/).filter(function(id) {
        return id !== '';
    });
    return referencedIds.some(function(id) {
        var referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function $2a6e934b81596289$var$getInitialFocusTarget(_ref2) {
    var container = _ref2.container, role = _ref2.role;
    if (role === 'dialog' || role === 'alertdialog') {
        // Prefer element with the native HTML autofocus attribute.
        var autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $cfeMO.getFirstFocusable)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific (menu / listbox) rather
    // than hoisted. Hoisting it over-matched on dialog popups that contain
    // a nested combobox (e.g. datetime-picker's dialog hosts a react-select),
    // where the active combobox's `aria-controls` falsely matched the
    // container and suppressed the dialog's own focus contract.
    if (role === 'menu') {
        if ($2a6e934b81596289$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/outputs/menu-keyboard-decision.md
        return (0, $cfeMO.getFirstFocusable)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($2a6e934b81596289$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        var selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        var firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $cfeMO.getFirstFocusable)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $2a6e934b81596289$export$e992c40175757a22(_ref3) {
    var elementRef = _ref3.elementRef, phase = _ref3.phase, role = _ref3.role;
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    var prevPhaseRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var _getInitialFocusTarge;
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        var element = elementRef.current;
        if (!element) return;
        (_getInitialFocusTarge = $2a6e934b81596289$var$getInitialFocusTarget({
            container: element,
            role: role
        })) === null || _getInitialFocusTarge === void 0 || _getInitialFocusTarge.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}

});


parcelRegister("kdlYT", function(module, exports) {
$parcel$export(module.exports, "useAnchorPosition", () => $eb7612906dd2d851$export$56b02a1e583f953c);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $45Zis = parcelRequire("45Zis");

var $bvsoE = parcelRequire("bvsoE");

var $gSQRn = parcelRequire("gSQRn");

var $2UYeW = parcelRequire("2UYeW");

var $a2Mxx = parcelRequire("a2Mxx");

var $lhkic = parcelRequire("lhkic");

var $cTOxF = parcelRequire("cTOxF");

var $aV7S3 = parcelRequire("aV7S3");

var $4h4T0 = parcelRequire("4h4T0");
// `resolvePlacement` is intentionally NOT re-exported here - import it directly
// from `./resolve-placement` so search-and-jump lands at the source of truth.
/**
 * Module-scope no-op `ResizeObserver` used in non-DOM jest environments where
 * `ResizeObserver` is `undefined`. Hoisted out of the effect to avoid
 * allocating a new class declaration on every run.
 */ var $eb7612906dd2d851$var$NoopResizeObserver = /*#__PURE__*/ function() {
    function NoopResizeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoopResizeObserver);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoopResizeObserver, [
        {
            key: "observe",
            value: function observe() {}
        },
        {
            key: "unobserve",
            value: function unobserve() {}
        },
        {
            key: "disconnect",
            value: function disconnect() {}
        }
    ]);
}();
/**
 * Returns true when the popover is currently open. Wrapped because the
 * `:popover-open` pseudo-class is not implemented in some test environments
 * (e.g. jsdom), where `matches` throws on unknown selectors.
 */ function $eb7612906dd2d851$var$isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch (_unused) {
        return false;
    }
}
/**
 * Detects whether the browser supports CSS Anchor Positioning.
 * Uses `once()` for lazy evaluation: safe for SSR and avoids hydration mismatches.
 */ var $eb7612906dd2d851$var$supportsAnchorPositioning = (0, $bvsoE.default)(function() {
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('anchor-name', '--a');
});
/**
 * Every logical margin property this module can write: one per axis, per side.
 *
 * Deriving the union from `TPlacementAxis` and `TPlacementEdge` rather than
 * writing the four names out keeps it in step with the placement model, and
 * makes `CROSS_AXIS_SHIFT_CUSTOM_PROPERTY` below exhaustive by construction.
 */ /**
 * The custom property mirroring each cross-axis shift margin.
 *
 * These are written for the planned named arrow `@position-try` rules. Nothing
 * reads them yet, and the shift no longer depends on them: the antisymmetric
 * margins written by `crossAxisShiftMargins` survive a cross-axis slide on
 * their own.
 *
 * Keyed on `TLogicalMarginProperty` and not on `string`, so a margin property
 * that has no custom property (or a custom property whose margin no longer
 * exists) is a compile error rather than an `undefined` lookup that reaches
 * `setStyle` as `{ property: undefined, value }`.
 */ var $eb7612906dd2d851$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY = {
    'margin-inline-start': '--ds-cross-axis-shift-margin-start',
    'margin-inline-end': '--ds-cross-axis-shift-margin-end',
    'margin-block-start': '--ds-cross-axis-shift-margin-block-start',
    'margin-block-end': '--ds-cross-axis-shift-margin-block-end'
};
var $eb7612906dd2d851$var$ZEROED_CROSS_AXIS_SHIFT_CUSTOM_PROPERTIES = Object.values($eb7612906dd2d851$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY).map(function(property) {
    return {
        property: property,
        value: '0px'
    };
});
/**
 * Returns the CSS margin declaration that creates a gap between the
 * popover and its trigger on the side facing the anchor.
 *
 * For example, a `block-end` placement (popover below) gets
 * `margin-block-start: 8px` to push it away from the trigger's bottom edge.
 */ function $eb7612906dd2d851$var$edgeMargin(_ref) {
    var placement = _ref.placement, offset = _ref.offset;
    var axis = placement.axis, edge = placement.edge;
    // The gap sits on the side FACING the anchor, which is always the side
    // opposite the placement edge.
    var anchorFacingEdge = edge === 'end' ? 'start' : 'end';
    return {
        property: "margin-".concat(axis, "-").concat(anchorFacingEdge),
        value: offset
    };
}
/**
 * **The cross-axis shift margins.**
 *
 * The shift is written antisymmetrically on BOTH cross-axis sides
 * (`start: +value`, `end: -value`) rather than as a single margin on the side
 * picked from `align`. Two separate behaviours require it:
 *
 * 1. **`align: 'center'` is centered with `anchor-center`, which centers the
 *    popover's MARGIN box on the anchor.** A single-sided margin widens the
 *    margin box, so it displaces the border box by only half its value. An
 *    antisymmetric pair leaves the margin box width unchanged (`+value` and
 *    `-value` sum to zero) while moving its center by the full value.
 * 2. **`position-try-fallbacks` can slide the popover onto the opposite
 *    cross-axis side.** A `<position-area>` fallback keeps the base style's
 *    margins, and margin on the un-anchored side has no effect, so a
 *    single-sided margin is silently dropped once the browser slides across the
 *    cross axis. With both sides written, whichever side ends up anchored moves
 *    the popover the same physical direction.
 *
 * Leaving the margin box width unchanged also means the shift does not move
 * the point at which `position-try-fallbacks` decides the popover overflows.
 *
 * A `<try-tactic>` fallback (`flip-block`, `flip-inline`) behaves differently to
 * a `<position-area>` one: it SWAPS the start and end margins rather than
 * keeping them, which is what preserves the gap through a flip. So a flip across
 * the cross axis mirrors the shift along with the rest of the placement, rather
 * than preserving its physical direction. Only the diagonal fallback does that,
 * and only for `align: 'start' | 'end'`. See `placementToTryFallbacks`.
 *
 * A positive value always moves the popover toward the cross-axis END, so
 * `direction: 'forwards'` means the same thing for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 */ function $eb7612906dd2d851$var$crossAxisShiftMargins(_ref2) {
    var placement = _ref2.placement, crossAxisShiftCssValue = _ref2.crossAxisShiftCssValue, direction = _ref2.direction;
    var crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    // Wrap any string in calc() with the sign factor. CSS handles the math,
    // so opaque values such as design tokens negate correctly.
    var negated = "calc(-1 * ".concat(crossAxisShiftCssValue, ")");
    var isForwards = direction === 'forwards';
    return [
        {
            property: "margin-".concat(crossAxis, "-start"),
            value: isForwards ? crossAxisShiftCssValue : negated
        },
        {
            property: "margin-".concat(crossAxis, "-end"),
            value: isForwards ? negated : crossAxisShiftCssValue
        }
    ];
}
/**
 * Returns a referentially-stable, fully-resolved `TPlacement`. The memo is
 * keyed on the resolved primitive fields so a fresh inline `placement` object
 * (or undefined fields vs explicit defaults) does not produce a fresh result.
 */ function $eb7612906dd2d851$var$useStablePlacement(placement) {
    var resolved = (0, $aV7S3.resolvePlacement)({
        placement: placement
    });
    var axis = resolved.axis;
    var edge = resolved.edge;
    var align = resolved.align;
    var gap = resolved.offset.gap;
    var shiftValue = resolved.offset.crossAxisShift.value;
    var shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuild inside the memo from primitive deps so the factory does not
    // close over the outer `resolved` reference and exhaustive-deps can verify.
    return (0, $5FkrB.useMemo)(function() {
        return {
            axis: axis,
            edge: edge,
            align: align,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        };
    }, [
        axis,
        edge,
        align,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $eb7612906dd2d851$export$56b02a1e583f953c(_ref3) {
    var anchorRef = _ref3.anchorRef, popoverRef = _ref3.popoverRef, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? {} : _ref3$placement, _ref3$forceFallbackPo = _ref3.forceFallbackPositioning, forceFallbackPositioning = _ref3$forceFallbackPo === void 0 ? false : _ref3$forceFallbackPo, _ref3$isEnabled = _ref3.isEnabled, isEnabled = _ref3$isEnabled === void 0 ? true : _ref3$isEnabled, isOpen = _ref3.isOpen;
    var id = (0, $5FkrB.useId)();
    var stablePlacement = $eb7612906dd2d851$var$useStablePlacement(placement);
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!isEnabled) return;
        var trigger = anchorRef.current;
        var popover = popoverRef.current;
        if (!trigger || !popover) return;
        var gapCssValue = stablePlacement.offset.gap;
        var crossAxisShiftCssValue = stablePlacement.offset.crossAxisShift.value;
        var shouldForceFallback = Boolean(forceFallbackPositioning);
        if ($eb7612906dd2d851$var$supportsAnchorPositioning() && !shouldForceFallback) {
            // Reuse an existing `anchor-name` if the element already has one.
            // Another popover might already be anchored to the old name.
            var anchorName = trigger.style.getPropertyValue('anchor-name') || "--anchor-".concat(id.replace(/:/g, ''));
            var gap = $eb7612906dd2d851$var$edgeMargin({
                placement: stablePlacement,
                offset: gapCssValue
            });
            // Computed once; also mirrored into the
            // `--ds-cross-axis-shift-margin-*` custom properties below.
            var crossAxisShift = $eb7612906dd2d851$var$crossAxisShiftMargins({
                placement: stablePlacement,
                crossAxisShiftCssValue: crossAxisShiftCssValue,
                direction: stablePlacement.offset.crossAxisShift.direction
            });
            var popoverStyles = [
                {
                    property: 'position-anchor',
                    value: anchorName
                },
                {
                    property: 'position-area',
                    value: (0, $a2Mxx.placementToPositionArea)({
                        placement: stablePlacement
                    })
                },
                {
                    property: 'position-try-fallbacks',
                    value: (0, $lhkic.placementToTryFallbacks)({
                        placement: stablePlacement
                    })
                },
                // Reset browser default popover positioning that conflicts
                // with anchor positioning (UA: `inset: 0; margin: auto;`)
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                },
                gap
            ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(crossAxisShift), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))($eb7612906dd2d851$var$ZEROED_CROSS_AXIS_SHIFT_CUSTOM_PROPERTIES), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(crossAxisShift.map(function(_ref4) {
                var property = _ref4.property, value = _ref4.value;
                return {
                    property: $eb7612906dd2d851$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY[property],
                    value: value
                };
            })));
            /**
       * **We are never cleaning up anchor names**
       *
       * _Rationale_
       *
       * - Multiple popovers can share the same anchor element.
       * - Sometimes the `useAnchorPosition` hook and `Popover`
       *   are not in the same component.
       * - There can be times when, even with reference counting, we
       *   could remove the anchor-name while it is still being used
       *   by something else - especially with async react updates
       *   which can cause tearing
       *
       * _More_
       *
       * See `notes/decisions/anchor-name-lifetime.md`
       */ trigger.style.setProperty('anchor-name', anchorName);
            return (0, $4h4T0.setStyle)({
                element: popover,
                styles: popoverStyles
            });
        }
        // JS fallback. The popover is already in the top layer via
        // popover="auto", so we only reset UA defaults and set top/left
        // based on measurements.
        var cleanupBaseStyles = (0, $4h4T0.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                }
            ]
        });
        // The popover can be consumer-owned (`@atlaskit/popper`'s `createPopper`),
        // so restore prior inline values rather than removing ours.
        var undoPosition;
        var undoHide;
        // `opacity: 0` not `visibility: hidden`: Firefox skips visibility-hidden
        // elements during `<dialog>` initial-focus traversal.
        function hideUntilPositioned() {
            // Keep the first snapshot, else we capture our own `opacity: 0`.
            // (`!popover` is for TS: narrowing does not reach nested functions.)
            if (!popover || undoHide) return;
            undoHide = (0, $4h4T0.setStyle)({
                element: popover,
                styles: [
                    {
                        property: 'opacity',
                        value: '0'
                    }
                ]
            });
        }
        function reveal() {
            var _undoHide;
            (_undoHide = undoHide) === null || _undoHide === void 0 || _undoHide();
            undoHide = undefined;
        }
        function restorePosition() {
            var _undoPosition;
            (_undoPosition = undoPosition) === null || _undoPosition === void 0 || _undoPosition();
            undoPosition = undefined;
        }
        function update() {
            if (!trigger || !popover) return;
            var triggerRect = trigger.getBoundingClientRect();
            var viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            // Resolve consumer-supplied CSS length strings (tokens, calc, var,
            // px, rem, etc) to pixels. The probe is mounted INSIDE the popover
            // itself so the resolved length matches the scope a token would
            // resolve against from inside the popover content. (The popover
            // lives in the top layer, not the trigger's DOM tree, so probing
            // at `popover.parentElement` would resolve in a different scope
            // than the consumer's token authoring expects.)
            var gapPx = (0, $cTOxF.resolveCssLengthToPixels)({
                value: gapCssValue,
                container: popover
            });
            var crossAxisShiftPx = (0, $cTOxF.resolveCssLengthToPixels)({
                value: crossAxisShiftCssValue,
                container: popover
            });
            var _computeFallbackPosit = (0, $gSQRn.computeFallbackPosition)({
                triggerRect: triggerRect,
                popoverEl: popover,
                placement: stablePlacement,
                viewport: viewport,
                gap: gapPx,
                crossAxisShift: {
                    value: crossAxisShiftPx,
                    direction: stablePlacement.offset.crossAxisShift.direction
                }
            }), top = _computeFallbackPosit.top, left = _computeFallbackPosit.left;
            // Restore first so the snapshot stays the consumer's value.
            restorePosition();
            undoPosition = (0, $4h4T0.setStyle)({
                element: popover,
                styles: [
                    {
                        property: 'top',
                        value: "".concat(top, "px")
                    },
                    {
                        property: 'left',
                        value: "".concat(left, "px")
                    }
                ]
            });
            reveal();
        }
        // Throttle scroll/resize updates to one per animation frame
        var scheduledUpdate = (0, $45Zis.default)(update);
        // Wait for the FIRST valid layout before measuring: the popover
        // is `display: none` until `showPopover()`, and some browsers
        // fire `toggle` before layout, so RAF-after-toggle is unreliable.
        // ResizeObserver fires once the browser has real dimensions.
        // Self-disconnects after one valid measurement; ongoing
        // scroll/resize is handled by the window listeners below.
        // `ResizeObserver` is missing in some non-DOM jest environments
        // (e.g. post-office's `node` environment). Fall back to a no-op
        // observer there. The scroll/resize listeners below still keep
        // the popover positioned in the rare case the consumer also
        // polyfilled `showPopover` but not `ResizeObserver`. Real
        // browsers always have it. The `NoopResizeObserver` class is
        // hoisted to module scope (see top of file) so we do not allocate
        // a new constructor on every effect run.
        var ResizeObserverImpl = typeof ResizeObserver !== 'undefined' ? ResizeObserver : $eb7612906dd2d851$var$NoopResizeObserver;
        var resizeObserver = new ResizeObserverImpl(function() {
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                update();
                resizeObserver.disconnect();
            }
        });
        // If the popover is already open by the time this effect runs (for
        // example, the parent `useAnchorPosition` effect runs after the child
        // `Popover` effect that called `showPopover()`), the initial `toggle`
        // event has already fired and our listener below would miss it. Start
        // observing immediately so the first measurement still happens.
        if ($eb7612906dd2d851$var$isPopoverOpen(popover)) {
            hideUntilPositioned();
            resizeObserver.observe(popover);
        }
        var undoPositioning = (0, $2UYeW.combine)(cleanupBaseStyles, // Each open needs a fresh measurement, so hide and re-observe.
        (0, $7QpUe.bind)(popover, {
            type: 'toggle',
            listener: function listener(event) {
                var toggleEvent = event;
                if (toggleEvent.newState === 'open') {
                    hideUntilPositioned();
                    resizeObserver.observe(popover);
                }
            }
        }), function() {
            return resizeObserver.disconnect();
        }, (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: scheduledUpdate,
            options: {
                capture: true,
                passive: true
            }
        }), (0, $7QpUe.bind)(window, {
            type: 'resize',
            listener: scheduledUpdate,
            options: {
                passive: true
            }
        }), function() {
            scheduledUpdate.cancel();
            restorePosition();
            reveal();
        });
        return undoPositioning;
    }, [
        anchorRef,
        popoverRef,
        stablePlacement,
        forceFallbackPositioning,
        isEnabled,
        id,
        isOpen
    ]);
}

});
parcelRegister("gSQRn", function(module, exports) {
$parcel$export(module.exports, "computeFallbackPosition", () => $c4aab15c1f8ac2e2$export$d5ef1dac02135664);

var $25nEq = parcelRequire("25nEq");
function $c4aab15c1f8ac2e2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c4aab15c1f8ac2e2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c4aab15c1f8ac2e2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c4aab15c1f8ac2e2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * JS fallback positioning math. Used only when the browser does not
 * support CSS Anchor Positioning (less than 6% of users).
 *
 * Consumer-supplied `offset.gap` and `offset.crossAxisShift` are
 * honored: the caller (`useAnchorPosition`) resolves CSS length strings
 * (tokens, calc, var, etc) to pixels via a DOM probe before passing them
 * in. The caller also keeps the popover hidden (`opacity: 0`) until the
 * first measurement completes, so the popover never paints at the wrong
 * position.
 */ /**
 * A viewport-relative position, in pixels. Physical rather than logical
 * because it is written straight to `top` / `left`.
 */ /**
 * The cross-axis shift with its length already resolved to pixels.
 *
 * Mirrors `TCrossAxisShiftOffset`, whose `value` is an unresolved CSS length
 * string. Only this module needs the pixel form, because only this module does
 * the arithmetic itself.
 */ /**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function $c4aab15c1f8ac2e2$var$computeEdgePosition(_ref) {
    var axis = _ref.axis, edge = _ref.edge, triggerRect = _ref.triggerRect, popoverWidth = _ref.popoverWidth, popoverHeight = _ref.popoverHeight, viewport = _ref.viewport, gap = _ref.gap;
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        var spaceBelow = viewport.height - triggerRect.bottom;
        var spaceAbove = triggerRect.top;
        var fitsBelow = spaceBelow >= popoverHeight + gap;
        var useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        var _spaceAbove = triggerRect.top;
        var _spaceBelow = viewport.height - triggerRect.bottom;
        var fitsAbove = _spaceAbove >= popoverHeight + gap;
        var useAbove = fitsAbove || _spaceAbove >= _spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        var spaceRight = viewport.width - triggerRect.right;
        var spaceLeft = triggerRect.left;
        var fitsRight = spaceRight >= popoverWidth + gap;
        var useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        var _spaceLeft = triggerRect.left;
        var _spaceRight = viewport.width - triggerRect.right;
        var fitsLeft = _spaceLeft >= popoverWidth + gap;
        var useLeft = fitsLeft || _spaceLeft >= _spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function $c4aab15c1f8ac2e2$var$applyAlignment(_ref2) {
    var position = _ref2.position, axis = _ref2.axis, align = _ref2.align, triggerRect = _ref2.triggerRect, popoverWidth = _ref2.popoverWidth, popoverHeight = _ref2.popoverHeight;
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return $c4aab15c1f8ac2e2$var$_objectSpread($c4aab15c1f8ac2e2$var$_objectSpread({}, position), {}, {
            left: triggerRect.left
        });
        // align === 'end'
        return $c4aab15c1f8ac2e2$var$_objectSpread($c4aab15c1f8ac2e2$var$_objectSpread({}, position), {}, {
            left: triggerRect.right - popoverWidth
        });
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return $c4aab15c1f8ac2e2$var$_objectSpread($c4aab15c1f8ac2e2$var$_objectSpread({}, position), {}, {
        top: triggerRect.top
    });
    // align === 'end'
    return $c4aab15c1f8ac2e2$var$_objectSpread($c4aab15c1f8ac2e2$var$_objectSpread({}, position), {}, {
        top: triggerRect.bottom - popoverHeight
    });
}
/**
 * Applies the cross-axis shift offset.
 *
 * `forwards` always moves the popover toward the cross-axis END and
 * `backwards` toward the START, for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 *
 * This is a coordinate, so the direction is the sign and nothing else. There
 * is deliberately no per-`align` sign inversion here: the CSS path inverts the
 * sign only because a margin on the END side pushes a box the opposite way to
 * a margin on the START side, which is a property of margins rather than of
 * the shift. Applying that inversion to a coordinate moved `align: 'end'`
 * popovers the wrong way.
 */ function $c4aab15c1f8ac2e2$var$applyCrossAxisShift(_ref3) {
    var position = _ref3.position, axis = _ref3.axis, crossAxisShift = _ref3.crossAxisShift;
    if (crossAxisShift.value === 0) return position;
    var directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    var delta = crossAxisShift.value * directionSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return $c4aab15c1f8ac2e2$var$_objectSpread($c4aab15c1f8ac2e2$var$_objectSpread({}, position), {}, {
        left: position.left + delta
    });
    return $c4aab15c1f8ac2e2$var$_objectSpread($c4aab15c1f8ac2e2$var$_objectSpread({}, position), {}, {
        top: position.top + delta
    });
}
function $c4aab15c1f8ac2e2$export$d5ef1dac02135664(_ref4) {
    var triggerRect = _ref4.triggerRect, popoverEl = _ref4.popoverEl, placement = _ref4.placement, viewport = _ref4.viewport, gap = _ref4.gap, crossAxisShift = _ref4.crossAxisShift;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    var popoverWidth = popoverEl.offsetWidth;
    var popoverHeight = popoverEl.offsetHeight;
    var basePosition = $c4aab15c1f8ac2e2$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    var alignedPosition = $c4aab15c1f8ac2e2$var$applyAlignment({
        position: basePosition,
        axis: axis,
        align: align,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    var shiftedPosition = $c4aab15c1f8ac2e2$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        crossAxisShift: crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}

});

parcelRegister("2UYeW", function(module, exports) {
$parcel$export(module.exports, "combine", () => $21ff8a276eb37634$export$1be1fc439b849fdf);
/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $21ff8a276eb37634$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, cleanupFns = new Array(_len), _key = 0; _key < _len; _key++)cleanupFns[_key] = arguments[_key];
    return function cleanup() {
        cleanupFns.forEach(function(callback) {
            return callback === null || callback === void 0 ? void 0 : callback();
        });
    };
}

});

parcelRegister("a2Mxx", function(module, exports) {
$parcel$export(module.exports, "placementToPositionArea", () => $74ffbe4d2bf46789$export$de49b61f233ddeb9);

var $aV7S3 = parcelRequire("aV7S3");
function $74ffbe4d2bf46789$export$de49b61f233ddeb9(_ref) {
    var placement = _ref.placement;
    var _resolvePlacement = (0, $aV7S3.resolvePlacement)({
        placement: placement
    }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge, align = _resolvePlacement.align;
    var edgeValue = "".concat(axis, "-").concat(edge);
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    var spanDir = align === 'start' ? 'end' : 'start';
    return "".concat(edgeValue, " span-").concat(crossAxis, "-").concat(spanDir);
}

});

parcelRegister("lhkic", function(module, exports) {
$parcel$export(module.exports, "placementToTryFallbacks", () => $f7daed2d34a4002d$export$c4e16947a95d61f1);

var $aV7S3 = parcelRequire("aV7S3");
/**
 * A `position-area` primary edge — the placement axis joined to its edge, e.g.
 * `block-end` or `inline-start`. These are the four edges a popover can sit on.
 */ function $f7daed2d34a4002d$var$slideOnEdge(_ref) {
    var align = _ref.align, edgeKey = _ref.edgeKey, crossAxis = _ref.crossAxis;
    if (align === 'center') return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-end"),
        "".concat(edgeKey, " span-").concat(crossAxis, "-start")
    ];
    // For `align: 'start'` the popover expands toward `end`, so the "near"
    // span is `end` and the "far" span is `start`; `align: 'end'` mirrors
    // this. The bare `edgeKey` (re-centered) sits between them.
    var near = align === 'start' ? 'end' : 'start';
    var far = align === 'start' ? 'start' : 'end';
    return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(near),
        edgeKey,
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(far)
    ];
}
function $f7daed2d34a4002d$var$flipDiagonally(_ref2) {
    var axis = _ref2.axis;
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    var flipToCrossAxis = axis === 'block' ? 'flip-inline' : 'flip-block';
    return "".concat(flipOnMainAxis, " ").concat(flipToCrossAxis);
}
function $f7daed2d34a4002d$export$c4e16947a95d61f1(_ref3) {
    var placement = _ref3.placement;
    /**
   * **Build the fallback list**
   *
   * Each entry is a complete alternative position.
   * The browser tries them _in order_ and uses the _first_ one that fits.
   */ var resolved = (0, $aV7S3.resolvePlacement)({
        placement: placement
    });
    var axis = resolved.axis, edge = resolved.edge, align = resolved.align;
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    var flippedEdge = edge === 'start' ? 'end' : 'start';
    var sameEdgeArea = "".concat(axis, "-").concat(edge);
    var oppositeEdgeArea = "".concat(axis, "-").concat(flippedEdge);
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    /**
   * **Fallback algorithm**
   *
   * We have two things we can do to keep something visible:
   *
   * 1. _Slide_ along edges
   * 2. _Flip_ to another edge
   *
   * _Centered popover_
   *
   * Desired: Sits in middle of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge (centered)
   *  3: _Slide_ along opposite edge on the cross axis
   *
   * _Start or end aligned popover_
   *
   * Desired: Sits at start / end of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge
   *  3: _Flip_ on the diagonal (flip main axis + flip cross axis) into the
   *     opposite corner. For start / end alignment, this is the clean escape
   *     when the popover would otherwise land offscreen on both axes (ie in a
   *     corner). Rule 4 gets the job done, but a slide drops the gap
   *     as named position-area values don't carry margins).
   *     The diagonal flip keeps the gap and the alignment.
   *  4: _Slide_ along opposite edge on the cross axis
   */ return [
        $f7daed2d34a4002d$var$slideOnEdge({
            align: align,
            edgeKey: sameEdgeArea,
            crossAxis: crossAxis
        }),
        flipOnMainAxis,
        align !== 'center' ? $f7daed2d34a4002d$var$flipDiagonally({
            axis: axis
        }) : null,
        $f7daed2d34a4002d$var$slideOnEdge({
            align: align,
            edgeKey: oppositeEdgeArea,
            crossAxis: crossAxis
        })
    ].filter(Boolean).flat().join(', ');
}

});

parcelRegister("cTOxF", function(module, exports) {
$parcel$export(module.exports, "resolveCssLengthToPixels", () => $9641d3abff911a67$export$98721546d2816d9e);
var $9641d3abff911a67$var$elementCaches = new WeakMap();
function $9641d3abff911a67$var$canCacheResolvedLength(value) {
    // Custom-property values can be retargeted by inline overrides on the
    // consumer's wrapper, so we cannot prove a cached pixel value is still valid.
    return !value.includes('var(');
}
function $9641d3abff911a67$var$getCachedResolvedLength(_ref) {
    var _cacheForElement$get;
    var element = _ref.element, value = _ref.value;
    if (!$9641d3abff911a67$var$canCacheResolvedLength(value)) return null;
    var cacheForElement = $9641d3abff911a67$var$elementCaches.get(element);
    return (_cacheForElement$get = cacheForElement === null || cacheForElement === void 0 ? void 0 : cacheForElement.get(value)) !== null && _cacheForElement$get !== void 0 ? _cacheForElement$get : null;
}
function $9641d3abff911a67$var$cacheResolvedLength(_ref2) {
    var _elementCaches$get;
    var element = _ref2.element, value = _ref2.value, result = _ref2.result;
    if (!$9641d3abff911a67$var$canCacheResolvedLength(value)) return;
    var cacheForElement = (_elementCaches$get = $9641d3abff911a67$var$elementCaches.get(element)) !== null && _elementCaches$get !== void 0 ? _elementCaches$get : new Map();
    cacheForElement.set(value, result);
    $9641d3abff911a67$var$elementCaches.set(element, cacheForElement);
}
function $9641d3abff911a67$export$98721546d2816d9e(_ref3) {
    var value = _ref3.value, container = _ref3.container;
    if (typeof value === 'number') return value;
    // Fast path: unitless zero is universally zero pixels - accept `'0'` and
    // `'-0'` without a probe. (Consumers occasionally pass `'0'` instead of
    // the number `0`.)
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from the consumer normalisation
    // in `resolvePlacement`. Avoid a reflow when we can.
    var pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    var cached = $9641d3abff911a67$var$getCachedResolvedLength({
        element: container,
        value: value
    });
    if (cached !== null) return cached;
    var probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hide the probe from assistive tech and event targeting; defensive
    // against `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    container.appendChild(probe);
    var resolved = parseFloat(getComputedStyle(probe).marginLeft);
    container.removeChild(probe);
    var result = Number.isFinite(resolved) ? resolved : 0;
    $9641d3abff911a67$var$cacheResolvedLength({
        element: container,
        value: value,
        result: result
    });
    return result;
}

});

parcelRegister("4h4T0", function(module, exports) {
$parcel$export(module.exports, "setStyle", () => $31cc8a3dab82cc8b$export$37a5fde709c1db82);
/**
 * A single inline style declaration.
 *
 * `TProperty` narrows the property name for callers that write a known, closed
 * set of properties. Narrowing it lets a record keyed on those same names be
 * checked for exhaustiveness at compile time, rather than silently resolving to
 * `undefined` for a name that was never mapped.
 */ /**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 */ function $31cc8a3dab82cc8b$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

});


parcelRegister("4NEzJ", function(module, exports) {
$parcel$export(module.exports, "useAnchorPositionAtPoint", () => $37eb367392e98963$export$6f230729189a5b8a);

var $5FkrB = parcelRequire("5FkrB");

var $kdlYT = parcelRequire("kdlYT");
/**
 * A point in viewport coordinates (CSS pixels) at which the synthetic
 * anchor should be placed.
 *
 * Axis-named (`x`/`y`) rather than edge-named (`left`/`top`) so the
 * shape is unambiguous in RTL writing modes - there is no ambiguity
 * about whether a coordinate is logical (`inline-start`/`block-start`)
 * or physical (`left`/`top`). Viewport coordinates are always
 * physical, so we name them with the physical axis labels.
 */ /**
 * Styles the synthetic anchor as an invisible, zero-size point.
 * Dynamic `inset-*` overrides are written by the positioning effect.
 *
 * Uses `Object.assign` rather than Compiled CSS (element is outside the React tree)
 * or the internal `setStyle` helper (we own this element entirely - it is created
 * and removed by this hook - so the snapshot/restore semantics `setStyle`
 * provides for caller-owned elements would be dead work here).
 */ function $37eb367392e98963$var$applyStaticAnchorStyles(element) {
    Object.assign(element.style, {
        position: 'fixed',
        // `top`/`left` rather than `inset-block-start`/`inset-inline-start`
        // for consistency with the dynamic positioning effect below, which
        // uses physical properties (see comment there for the rationale).
        top: '0',
        left: '0',
        // Zero size - placement decides which side the popover sits on.
        width: '0',
        height: '0',
        // Prevent the overlay from intercepting pointer events.
        pointerEvents: 'none'
    });
}
function $37eb367392e98963$export$6f230729189a5b8a(_ref) {
    var popoverRef = _ref.popoverRef, placement = _ref.placement, getPoint = _ref.getPoint, _ref$isEnabled = _ref.isEnabled, isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled, isOpen = _ref.isOpen;
    var syntheticAnchorRef = (0, $5FkrB.useRef)(null);
    // `getPoint` is kept in a ref so the layout effect can call the
    // latest version without listing it as a dep - that would re-fire
    // on every render and re-latch the point.
    var getPointRef = (0, $5FkrB.useRef)(getPoint);
    getPointRef.current = getPoint;
    // Lazy element creation: the `<div>` is only created when both
    // `isEnabled` is true AND `getPoint()` returns a non-null point.
    // `useLayoutEffect` ensures the element exists before the inner
    // `useAnchorPosition` (also a layout effect) reads the ref.
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!isEnabled) return;
        var point = getPointRef.current();
        if (!point) return;
        var anchor = document.createElement('div');
        anchor.setAttribute('aria-hidden', 'true');
        $37eb367392e98963$var$applyStaticAnchorStyles(anchor);
        // `point.x`/`y` are physical viewport coordinates (from
        // `MouseEvent.clientX/Y`), so map directly onto physical
        // `left`/`top`. This is RTL-safe: `position: fixed` + physical
        // insets is direction-independent. Using logical
        // `inset-inline-start` would need `viewportWidth - point.x` in
        // RTL to land at the same physical pixel.
        anchor.style.top = "".concat(point.y, "px");
        anchor.style.left = "".concat(point.x, "px");
        document.body.appendChild(anchor);
        syntheticAnchorRef.current = anchor;
        return function cleanup() {
            anchor.remove();
            syntheticAnchorRef.current = null;
        };
    }, [
        isEnabled
    ]);
    // Mirror `isEnabled` so both hooks stay in sync - when disabled,
    // neither this hook nor the inner one touches the popover, leaving
    // any other positioning the consumer has set up free to take effect.
    (0, $kdlYT.useAnchorPosition)({
        anchorRef: syntheticAnchorRef,
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: isEnabled,
        isOpen: isOpen
    });
}

});

parcelRegister("e1tcw", function(module, exports) {
$parcel$export(module.exports, "usePopoverId", () => $a357cf5d0bf33cb3$export$9198c6c168be2eeb);

var $h8qvJ = parcelRequire("h8qvJ");
function $a357cf5d0bf33cb3$export$9198c6c168be2eeb() {
    // `@atlaskit/ds-lib/use-id` already strips characters that React's
    // `useId` produces (`:`, `«`, `»`) which are invalid in HTML ID
    // tokens. The `popover-` prefix is purely for DOM debug clarity.
    return "popover-".concat((0, $h8qvJ.useId)());
}

});
parcelRegister("h8qvJ", function(module, exports) {
$parcel$export(module.exports, "useId", () => $c797bf80d6171378$export$f680877a34711e37);

var $5FkrB = parcelRequire("5FkrB");
function $c797bf80d6171378$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId().replace(/[:«»]/g, '_');
}

});


parcelRegister("fYeDC", function(module, exports) {
$parcel$export(module.exports, "useWidthFromAnchor", () => $ba07d06cb3944e4d$export$7071d791a7b131ed);

var $5FkrB = parcelRequire("5FkrB");

var $bvsoE = parcelRequire("bvsoE");

var $4h4T0 = parcelRequire("4h4T0");
/**
 * Probes anchor SIZING, separately from `anchor-name` (see
 * `supportsAnchorPositioning`): some browsers have positioning but not sizing.
 * `once()` for SSR safety.
 */ var $ba07d06cb3944e4d$var$supportsAnchorSize = (0, $bvsoE.default)(function() {
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('min-inline-size', 'anchor-size(self-inline)');
});
/**
 * The JS fallback's stand-in for `anchor-size(self-inline)`. `offsetWidth` / `offsetHeight` are
 * physical, so the axis is picked from the popover's `writing-mode`. Anything not horizontal is
 * treated as vertical, and an unknown or empty value falls back to `offsetWidth`.
 */ function $ba07d06cb3944e4d$var$getFallbackAnchorInlineSize(_ref) {
    var anchor = _ref.anchor, popover = _ref.popover;
    // `String()` because not every test environment implements `writing-mode`.
    var writingMode = String(getComputedStyle(popover).writingMode);
    var isVertical = writingMode.startsWith('vertical') || writingMode.startsWith('sideways');
    return isVertical ? anchor.offsetHeight : anchor.offsetWidth;
}
function $ba07d06cb3944e4d$export$7071d791a7b131ed(_ref2) {
    var mode = _ref2.mode, popoverRef = _ref2.popoverRef, anchorRef = _ref2.anchorRef, isOpen = _ref2.isOpen;
    (0, $5FkrB.useLayoutEffect)(function() {
        var node = popoverRef.current;
        if (!node) return;
        if (mode === 'match-anchor') {
            // No floor here: it would let the popover grow past the anchor.
            if ($ba07d06cb3944e4d$var$supportsAnchorSize()) return (0, $4h4T0.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'inline-size',
                        value: 'anchor-size(self-inline)'
                    }
                ]
            });
            var anchor = anchorRef.current;
            if (anchor) return (0, $4h4T0.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'inline-size',
                        value: "".concat($ba07d06cb3944e4d$var$getFallbackAnchorInlineSize({
                            anchor: anchor,
                            popover: node
                        }), "px")
                    }
                ]
            });
            return;
        }
        if (mode === 'min-anchor') {
            // One floor only. The content floor from mode 'none' deliberately does not also apply
            // here, and cannot: it would need this same property. See the decision note.
            if ($ba07d06cb3944e4d$var$supportsAnchorSize()) return (0, $4h4T0.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'min-inline-size',
                        value: 'anchor-size(self-inline)'
                    }
                ]
            });
            var _anchor = anchorRef.current;
            if (_anchor) return (0, $4h4T0.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'min-inline-size',
                        value: "".concat($ba07d06cb3944e4d$var$getFallbackAnchorInlineSize({
                            anchor: _anchor,
                            popover: node
                        }), "px")
                    }
                ]
            });
            // Nothing to measure, so no floor.
            return;
        }
        // Makes a too-narrow span overflow and drive `position-try-fallbacks` instead of wrapping.
        // `@atlaskit/popper` resets this exact property to `0` for its fit-to-viewport mode.
        return (0, $4h4T0.setStyle)({
            element: node,
            styles: [
                {
                    property: 'min-inline-size',
                    value: 'max-content'
                }
            ]
        });
    }, [
        mode,
        popoverRef,
        anchorRef,
        isOpen
    ]);
}

});

parcelRegister("kyudp", function(module, exports) {
$parcel$export(module.exports, "isPageRtl", () => $ef6e6bba330bb3cb$export$175375e9a2b5515d);

var $lFhdZ = parcelRequire("lFhdZ");
function $ef6e6bba330bb3cb$export$175375e9a2b5515d() {
    var document = (0, $lFhdZ.getDocument)();
    if (!document) return false;
    return document.dir === 'rtl' || document.body.dir === 'rtl' || document.documentElement.dir === 'rtl';
}

});

parcelRegister("eMHjn", function(module, exports) {
$parcel$export(module.exports, "rectPointForPlacement", () => $ac37252925604701$export$b065aeb850c3e87f);
/**
 * Reduces an anchor rect to the single viewport point that, wrapped in a
 * zero-size synthetic anchor, produces the same popover position
 * `useAnchorPosition` would for the given placement. This works because
 * `useAnchorPosition` only reads the edge / alignment corner of the rect,
 * so a coincident zero-size point is geometrically equivalent.
 *
 * RTL is resolved here so the downstream synthetic anchor only sees physical
 * coordinates. Defaults mirror `getPlacement` in
 * `@atlaskit/top-layer/placement-map` (`axis: 'block'`, `edge: 'end'`,
 * `align: 'center'`).
 */ function $ac37252925604701$export$b065aeb850c3e87f(_ref) {
    var _placement$axis, _placement$edge, _placement$align;
    var rect = _ref.rect, placement = _ref.placement, isRtl = _ref.isRtl;
    var axis = (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block';
    var edge = (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end';
    var align = (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center';
    if (axis === 'block') {
        // Popover sits above (`edge: 'start'`) or below (`edge: 'end'`)
        // the anchor. Hug the matching horizontal edge; align along x.
        var _y = edge === 'start' ? rect.top : rect.bottom;
        var _x = $ac37252925604701$var$horizontalForAlign({
            rect: rect,
            align: align,
            isRtl: isRtl
        });
        return {
            x: _x,
            y: _y
        };
    }
    // `axis: 'inline'`: popover sits inline-start or inline-end of the
    // anchor. Hug the matching vertical edge; align along y.
    var x = $ac37252925604701$var$inlineEdgeX({
        rect: rect,
        edge: edge,
        isRtl: isRtl
    });
    var y = $ac37252925604701$var$verticalForAlign({
        rect: rect,
        align: align
    });
    return {
        x: x,
        y: y
    };
}
function $ac37252925604701$var$horizontalForAlign(_ref2) {
    var rect = _ref2.rect, align = _ref2.align, isRtl = _ref2.isRtl;
    if (align === 'center') return rect.left + rect.width / 2;
    // `start` / `end` are logical. In LTR, `start` is the left edge.
    // In RTL, `start` is the right edge.
    var isStartLeft = !isRtl;
    if (align === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}
function $ac37252925604701$var$verticalForAlign(_ref3) {
    var rect = _ref3.rect, align = _ref3.align;
    if (align === 'center') return rect.top + rect.height / 2;
    if (align === 'start') return rect.top;
    return rect.bottom;
}
function $ac37252925604701$var$inlineEdgeX(_ref4) {
    var rect = _ref4.rect, edge = _ref4.edge, isRtl = _ref4.isRtl;
    var isStartLeft = !isRtl;
    if (edge === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}

});

parcelRegister("csRnP", function(module, exports) {
$parcel$export(module.exports, "toLegacyPlacement", () => $9131825d85e58b66$export$e9a6fdb80170ffd);
/**
 * `@popperjs/core`'s `Placement` union is a strict subset of `TLegacyPlacement`
 * (the placement-map adds `top-center` / `bottom-center` on top of popper's
 * enum), so every value popper hands us is a valid legacy placement.
 *
 * The cast keeps the runtime path free of an extra module-level lookup that
 * bundlers can occasionally fail to wire up (observed as `Cannot read
 * properties of undefined (reading 'includes')` in component-test bundles).
 *
 * Shared so the React and imperative popper adapters resolve this identically.
 */ function $9131825d85e58b66$export$e9a6fdb80170ffd(placement) {
    return placement;
}

});

parcelRegister("5PAvc", function(module, exports) {
$parcel$export(module.exports, "useFitViewportMaxSize", () => $01187bfef3ee88f5$export$f16d8ac7373995e1);

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $ke62Q = parcelRequire("ke62Q");
/**
 * Applies the `shouldFitViewport` size caps directly to the
 * `position-area`-anchored popover host. Pure CSS — the browser owns every
 * value, so there is no measurement, no scroll/resize listeners, and no
 * `--ds-popper-anchor-*` custom properties.
 *
 * **Primary (placement) axis** is capped to `calc(100% - 5px - gap)`. Because
 * the host carries `position-area`, its containing block *is* the position-area
 * cell — the region between the anchor edge and the viewport edge — so `100%`
 * resolves to that distance. The popover is pushed `gap` into the cell by its
 * offset margin (`margin-*`, set by `useAnchorPosition`), so the gap is
 * subtracted as well to keep the legacy `viewportPadding = 5` on the far edge.
 * The cap is also more correct than measuring the requested placement: the cell
 * follows whichever side `position-try-fallbacks` actually flips to, so it
 * tracks the flip automatically.
 *
 * **Cross axis** is capped to `calc(100dvw|dvh - 10px)` (viewport, legacy
 * `2 * viewportPadding`). `display: flex` (plus a `min-*-size: 0` reset on the
 * child) lets an oversized child shrink and reflow to the cap. The host stays
 * `overflow: visible` so it never clips the consumer surface's `box-shadow`;
 * scrolling content that cannot reflow is the consumer surface's own
 * responsibility (it owns `overflow`), matching legacy `react-popper`, which
 * applied the cap to the consumer's own element.
 *
 * `min-inline-size` is reset to `0`. `useWidthFromAnchor({ mode: 'none' })`
 * floors the host at `max-content` so a too-narrow span overflows and drives
 * `position-try-fallbacks` rather than wrapping. That floor is the opposite of
 * fitting: when it exceeds a cap, CSS min/max resolution lets the min win and
 * the host overflows the viewport. In fit mode the caps must win, so the floor
 * is neutralised here; `setStyle` restores the prior inline value on cleanup.
 *
 * Verified in Chromium: `max-block-size: calc(100% - …)` on a `position: fixed`
 * + `position-area` element resolves `100%` to the cell, not the viewport.
 */ var $01187bfef3ee88f5$var$CROSS_INLINE_CAP = 'calc(100dvw - 10px)';
var $01187bfef3ee88f5$var$CROSS_BLOCK_CAP = 'calc(100dvh - 10px)';
/**
 * Legacy `viewportPadding` (`preventOverflow` padding) the popover kept from
 * every viewport edge under `react-popper`. The caps above already *reserve*
 * this space (`- 5px` on the primary far edge, `- 10px` = `2 * 5px` on the
 * cross axis), but nothing makes the reservation land on the viewport side:
 * the anchor-side gap is a real margin (`useAnchorPosition`'s `edgeMargin`),
 * the viewport side has none, so a capped popover packs flush against the
 * viewport edge it slid/flipped to. Re-applying the padding as a margin on the
 * three non-anchor sides puts the reserved space back on the viewport side.
 * `position-try` flips mirror margins and slides keep them per-side, so the
 * gap tracks whichever edge the browser settles on.
 */ var $01187bfef3ee88f5$var$VIEWPORT_PADDING = '5px';
/**
 * The popover's three non-anchor margin sides for a given placement axis — the
 * primary *far* side plus both cross sides. The remaining (anchor-facing) side
 * already carries the offset gap from `useAnchorPosition` and is left alone.
 */ var $01187bfef3ee88f5$var$NON_ANCHOR_MARGIN_SIDES = {
    top: [
        'margin-block-start',
        'margin-inline-start',
        'margin-inline-end'
    ],
    bottom: [
        'margin-block-end',
        'margin-inline-start',
        'margin-inline-end'
    ],
    left: [
        'margin-inline-start',
        'margin-block-start',
        'margin-block-end'
    ],
    right: [
        'margin-inline-end',
        'margin-block-start',
        'margin-block-end'
    ]
};
function $01187bfef3ee88f5$export$f16d8ac7373995e1(_ref) {
    var target = _ref.target, placementAxis = _ref.placementAxis, gap = _ref.gap, isEnabled = _ref.isEnabled, isOpen = _ref.isOpen;
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = target.current;
        if (!element || !isEnabled) return;
        var isBlockAxis = placementAxis === 'top' || placementAxis === 'bottom';
        var primaryAxisCap = "calc(100% - 5px - ".concat(gap, ")");
        var cleanupHost = (0, $ke62Q.setStyle)({
            element: element,
            styles: [
                {
                    property: 'display',
                    value: 'flex'
                },
                // Neutralise `useWidthFromAnchor`'s `min-inline-size: max-content`
                // floor so the caps below win and content reflows. `setStyle`
                // restores the floor on cleanup.
                //
                // This package only uses `mode: 'none'`. Note that `mode: 'min-anchor'`
                // puts its ANCHOR floor on the same property, so pairing this hook with
                // that mode would drop the anchor floor rather than a content floor. See
                // `@atlaskit/top-layer` `notes/decisions/width-from-anchor-floors.md`.
                {
                    property: 'min-inline-size',
                    value: '0'
                },
                isBlockAxis ? {
                    property: 'max-block-size',
                    value: primaryAxisCap
                } : {
                    property: 'max-inline-size',
                    value: primaryAxisCap
                },
                isBlockAxis ? {
                    property: 'max-inline-size',
                    value: $01187bfef3ee88f5$var$CROSS_INLINE_CAP
                } : {
                    property: 'max-block-size',
                    value: $01187bfef3ee88f5$var$CROSS_BLOCK_CAP
                }
            ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))($01187bfef3ee88f5$var$NON_ANCHOR_MARGIN_SIDES[placementAxis].map(function(property) {
                return {
                    property: property,
                    value: $01187bfef3ee88f5$var$VIEWPORT_PADDING
                };
            })))
        });
        // The host deliberately stays `overflow: visible`. An ancestor with
        // `overflow: auto` clips a descendant's `box-shadow`, so capping and
        // scrolling on the host would strip the elevation shadow from the
        // consumer surface. Instead the host only constrains size; scrolling
        // oversized content is the consumer surface's own responsibility,
        // matching the contract `@atlaskit/top-layer`'s `PopoverSurface` follows
        // (shadow and `overflow` on one element). For that surface (the host's
        // flex child) to be clamped to the cap and scroll its own content, it
        // must be allowed to shrink below its intrinsic size, so reset its
        // min-size floor.
        var child = element.firstElementChild;
        var cleanupChild = child instanceof HTMLElement ? (0, $ke62Q.setStyle)({
            element: child,
            styles: [
                {
                    property: 'min-block-size',
                    value: '0'
                },
                {
                    property: 'min-inline-size',
                    value: '0'
                }
            ]
        }) : undefined;
        return function() {
            cleanupHost();
            cleanupChild === null || cleanupChild === void 0 || cleanupChild();
        };
    }, [
        target,
        placementAxis,
        gap,
        isEnabled,
        isOpen
    ]);
}

});
parcelRegister("ke62Q", function(module, exports) {
$parcel$export(module.exports, "setStyle", () => $eb99cdd5a53c0db8$export$37a5fde709c1db82);
/**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 *
 * Copied from `@atlaskit/top-layer`'s internal `setStyle` (not exported there
 * yet); inline here until top-layer exposes it via a subpath export.
 */ function $eb99cdd5a53c0db8$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

});


parcelRegister("lu0lf", function(module, exports) {
$parcel$export(module.exports, "useManagerAnchor", () => $fa3caa28ee3fa48d$export$941a7e8bf0b9eafd);

var $5FkrB = parcelRequire("5FkrB");

var $7FQrs = parcelRequire("7FQrs");
function $fa3caa28ee3fa48d$export$941a7e8bf0b9eafd() {
    return (0, $5FkrB.useContext)((0, $7FQrs.AnchorContext));
}

});
parcelRegister("7FQrs", function(module, exports) {
$parcel$export(module.exports, "AnchorContext", () => $59650a99191b9498$export$8f73317645bb7b8e);

var $5FkrB = parcelRequire("5FkrB");
var $59650a99191b9498$export$8f73317645bb7b8e = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});


parcelRegister("1OtNW", function(module, exports) {
$parcel$export(module.exports, "useReferenceVisibility", () => $1521947eb8be1cc3$export$61d36e2b682e92f7);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $hBpH8 = parcelRequire("hBpH8");
var $1521947eb8be1cc3$var$INITIAL = {
    isReferenceHidden: false,
    hasPopperEscaped: false
};
function $1521947eb8be1cc3$var$isFullyOutsideViewport(rect, viewport) {
    if (rect.width === 0 && rect.height === 0) return true;
    if (rect.bottom <= 0) return true;
    if (rect.right <= 0) return true;
    if (rect.top >= viewport.height) return true;
    if (rect.left >= viewport.width) return true;
    return false;
}
function $1521947eb8be1cc3$var$isClippingOverflow(value) {
    return value === 'auto' || value === 'scroll' || value === 'hidden' || value === 'clip';
}
function $1521947eb8be1cc3$var$isClippedByAncestors(element) {
    var rect = element.getBoundingClientRect();
    var parent = element.parentElement;
    while(parent){
        // Read the longhand axis properties directly. The `overflow` shorthand
        // is only populated when both axes share the same value, so reading it
        // alone misses ancestors that set only `overflow-x` or `overflow-y`.
        var style = window.getComputedStyle(parent);
        var clipsHorizontally = $1521947eb8be1cc3$var$isClippingOverflow(style.overflowX);
        var clipsVertically = $1521947eb8be1cc3$var$isClippingOverflow(style.overflowY);
        if (clipsHorizontally || clipsVertically) {
            var parentRect = parent.getBoundingClientRect();
            var horizontallyOutside = rect.right <= parentRect.left || rect.left >= parentRect.right;
            var verticallyOutside = rect.bottom <= parentRect.top || rect.top >= parentRect.bottom;
            if (clipsHorizontally && horizontallyOutside) return true;
            if (clipsVertically && verticallyOutside) return true;
        }
        parent = parent.parentElement;
    }
    return false;
}
function $1521947eb8be1cc3$export$61d36e2b682e92f7(_ref) {
    var anchor = _ref.anchor, popoverRef = _ref.popoverRef;
    var _useState = (0, $5FkrB.useState)($1521947eb8be1cc3$var$INITIAL), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), visibility = _useState2[0], setVisibility = _useState2[1];
    var measure = (0, $5FkrB.useCallback)(function() {
        if (!anchor) {
            setVisibility(function(previous) {
                return previous.isReferenceHidden === false && previous.hasPopperEscaped === false ? previous : $1521947eb8be1cc3$var$INITIAL;
            });
            return;
        }
        var viewport = (0, $hBpH8.readViewport)();
        var anchorRect = anchor.getBoundingClientRect();
        var isReferenceHidden = $1521947eb8be1cc3$var$isFullyOutsideViewport(anchorRect, viewport) || $1521947eb8be1cc3$var$isClippedByAncestors(anchor);
        var popoverElement = popoverRef.current;
        var hasPopperEscaped = popoverElement ? $1521947eb8be1cc3$var$isFullyOutsideViewport(popoverElement.getBoundingClientRect(), viewport) : false;
        setVisibility(function(previous) {
            if (previous.isReferenceHidden === isReferenceHidden && previous.hasPopperEscaped === hasPopperEscaped) return previous;
            return {
                isReferenceHidden: isReferenceHidden,
                hasPopperEscaped: hasPopperEscaped
            };
        });
    }, [
        anchor,
        popoverRef
    ]);
    (0, $5FkrB.useLayoutEffect)(function() {
        measure();
        if (typeof window === 'undefined') return undefined;
        var cleanups = [];
        // Resize observer on the anchor so layout changes update visibility.
        if (anchor && typeof ResizeObserver !== 'undefined') {
            var observer = new ResizeObserver(function() {
                return measure();
            });
            observer.observe(anchor);
            cleanups.push(function() {
                return observer.disconnect();
            });
        }
        // Scroll + resize: any scroll event in the document can move the
        // anchor in/out of any scrollable ancestor's viewport.
        cleanups.push((0, $7QpUe.bindAll)(window, [
            {
                type: 'scroll',
                listener: measure,
                options: {
                    capture: true,
                    passive: true
                }
            },
            {
                type: 'resize',
                listener: measure,
                options: {
                    passive: true
                }
            }
        ]));
        var visual = window.visualViewport;
        if (visual) cleanups.push((0, $7QpUe.bind)(visual, {
            type: 'resize',
            listener: measure,
            options: {
                passive: true
            }
        }));
        return function() {
            cleanups.forEach(function(cleanup) {
                return cleanup();
            });
        };
    }, [
        anchor,
        measure
    ]);
    return visibility;
}

});
parcelRegister("hBpH8", function(module, exports) {
$parcel$export(module.exports, "readViewport", () => $cd09d2d12908ffa2$export$64beed533e21f72d);
/**
 * Returns the current viewport size in CSS pixels, preferring the visual
 * viewport (which accounts for pinch-zoom on touch devices) over the
 * layout viewport. Returns `{ width: 0, height: 0 }` in non-DOM
 * environments so callers can use the result unconditionally.
 */ function $cd09d2d12908ffa2$export$64beed533e21f72d() {
    if (typeof window === 'undefined') return {
        width: 0,
        height: 0
    };
    var visual = window.visualViewport;
    if (visual) return {
        width: visual.width,
        height: visual.height
    };
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}

});




parcelRegister("fV8Mu", function(module, exports) {
$parcel$export(module.exports, "default", () => $b972fda2d5cd73a8$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $50U6m = parcelRequire("50U6m");

var $5xfKc = parcelRequire("5xfKc");

var $3xP8x = parcelRequire("3xP8x");

var $bjDXH = parcelRequire("bjDXH");

var $jsLZg = parcelRequire("jsLZg");
function $b972fda2d5cd73a8$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $bjDXH.default)(mountStrategy);
    (0, $jsLZg.default)(zIndex);
    return !(0, $50U6m.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5xfKc.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3xP8x.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("5xfKc", function(module, exports) {
$parcel$export(module.exports, "default", () => $407c3f4d80e747f9$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $5nOvn = parcelRequire("5nOvn");

var $8LRuV = parcelRequire("8LRuV");

var $SGOeg = parcelRequire("SGOeg");

var $kmtTd = parcelRequire("kmtTd");

var $ki13r = parcelRequire("ki13r");

var $cKtyc = parcelRequire("cKtyc");
function $407c3f4d80e747f9$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $5FkrB.useMemo)(function() {
        return (0, $ki13r.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    var colorMode = (0, $8LRuV.useColorMode)();
    var isInsideThemeProvider = (0, $SGOeg.useIsInsideThemeProvider)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $kmtTd.appendPortalContainerIfNotAppended)(container);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            (0, $cKtyc.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $aLeHs.createPortal)(isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5nOvn.ThemeProvider), {
        defaultColorMode: colorMode
    }, children) : children, container);
}

});
parcelRegister("5nOvn", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", () => $3eb646f90832f30b$export$d8964aec282183a3);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $fL8KA = parcelRequire("fL8KA");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $970q7 = parcelRequire("970q7");

var $6HG4S = parcelRequire("6HG4S");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $9AP5g = parcelRequire("9AP5g");

var $khRfh = parcelRequire("khRfh");

var $dfiLq = parcelRequire("dfiLq");

var $fYEbK = parcelRequire("fYEbK");

var $dLBZC = parcelRequire("dLBZC");

var $buC9l = parcelRequire("buC9l");

var $bhsSk = parcelRequire("bhsSk");

var $0J1ha = parcelRequire("0J1ha");

var $gfmgU = parcelRequire("gfmgU");

var $SGOeg = parcelRequire("SGOeg");

var $10rn6 = parcelRequire("10rn6");
function $3eb646f90832f30b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3eb646f90832f30b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3eb646f90832f30b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3eb646f90832f30b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3eb646f90832f30b$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    shape: 'shape',
    spacing: 'spacing',
    typography: 'typography'
};
var $3eb646f90832f30b$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
var $3eb646f90832f30b$var$prefersDarkModeMql = $3eb646f90832f30b$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $3eb646f90832f30b$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $3eb646f90832f30b$var$prefersDarkModeMql !== null && $3eb646f90832f30b$var$prefersDarkModeMql !== void 0 && $3eb646f90832f30b$var$prefersDarkModeMql.matches ? 'dark' : 'light';
    return colorMode;
}
var $3eb646f90832f30b$var$contentStyles = {
    body: "_1e0c1bgi"
};
function $3eb646f90832f30b$export$d8964aec282183a3(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? 'auto' : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme;
    var _useState = (0, $5FkrB.useState)(defaultColorMode), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), chosenColorMode = _useState2[0], setChosenColorMode = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)($3eb646f90832f30b$var$getReconciledColorMode(defaultColorMode)), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), reconciledColorMode = _useState4[0], setReconciledColorMode = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return $3eb646f90832f30b$var$_objectSpread($3eb646f90832f30b$var$_objectSpread({}, $3eb646f90832f30b$var$defaultThemeSettings), defaultTheme);
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), theme = _useState6[0], setTheme = _useState6[1];
    var setColorMode = (0, $5FkrB.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode($3eb646f90832f30b$var$getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, $5FkrB.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return $3eb646f90832f30b$var$_objectSpread($3eb646f90832f30b$var$_objectSpread({}, theme), nextTheme);
        });
    }, []);
    var lastSetGlobalThemePromiseRef = (0, $5FkrB.useRef)(null);
    var isInsideAppProvider = (0, $dLBZC.useIsInsideAppProvider)();
    var isAppProviderThemingEnabled = (0, $fYEbK.useIsAppProviderThemingEnabled)();
    var isInsideThemeProvider = (0, $SGOeg.useIsInsideThemeProvider)();
    /**
   * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
   *
   * This will not use sub-tree theming but instead set the global theme state using the
   * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
   * for compatibility with `@atlaskit/css-reset`.
   *
   * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
   * `html` in order to apply global theme state, which would allow a more consistent approach to
   * theme loading.
   */ var isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled;
    (0, $5FkrB.useEffect)(function() {
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ var cleanupLastFnCall = /*#__PURE__*/ function() {
                var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
                    var unbindFn;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!lastSetGlobalThemePromiseRef.current) {
                                    _context.next = 2;
                                    break;
                                }
                                _context.next = 1;
                                return lastSetGlobalThemePromiseRef.current;
                            case 1:
                                unbindFn = _context.sent;
                                unbindFn();
                                lastSetGlobalThemePromiseRef.current = null;
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function cleanupLastFnCall() {
                    return _ref2.apply(this, arguments);
                };
            }();
            var safelySetGlobalTheme = /*#__PURE__*/ function() {
                var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2() {
                    var promise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 1;
                                return cleanupLastFnCall();
                            case 1:
                                promise = (0, $dfiLq.setGlobalTheme)($3eb646f90832f30b$var$_objectSpread($3eb646f90832f30b$var$_objectSpread({}, theme), {}, {
                                    colorMode: reconciledColorMode
                                }));
                                lastSetGlobalThemePromiseRef.current = promise;
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                return function safelySetGlobalTheme() {
                    return _ref3.apply(this, arguments);
                };
            }();
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        }
        // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $10rn6.loadAndMountThemes)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (!$3eb646f90832f30b$var$prefersDarkModeMql) return;
        var unbindListener = (0, $7QpUe.bind)($3eb646f90832f30b$var$prefersDarkModeMql, {
            type: 'change',
            listener: function listener(event) {
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    var attrs = $3eb646f90832f30b$var$_objectSpread($3eb646f90832f30b$var$_objectSpread({}, (0, $khRfh.getThemeHtmlAttrs)($3eb646f90832f30b$var$_objectSpread($3eb646f90832f30b$var$_objectSpread({}, theme), {}, {
        colorMode: reconciledColorMode
    }))), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $9AP5g.SUBTREE_THEME_ATTRIBUTE), true));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bhsSk.InsideThemeProviderContext).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $buC9l.ColorModeContext).Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0J1ha.SetColorModeContext).Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gfmgU.ThemeContext).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gfmgU.SetThemeContext).Provider, {
        value: setPartialTheme
    }, !isRootThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, attrs, {
        className: (0, $970q7.default)([
            $3eb646f90832f30b$var$contentStyles.body
        ])
    }), children) : children)))));
}

});
parcelRegister("khRfh", function(module, exports) {
$parcel$export(module.exports, "getThemeHtmlAttrs", () => $ec4eb29d91d718cb$export$e1f80cb7a749802f);
$parcel$export(module.exports, "default", () => $ec4eb29d91d718cb$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $50U6m = parcelRequire("50U6m");

var $9AP5g = parcelRequire("9AP5g");

var $6lN5g = parcelRequire("6lN5g");

var $e6NGy = parcelRequire("e6NGy");

var $3ENxc = parcelRequire("3ENxc");

var $6clIx = parcelRequire("6clIx");
function $ec4eb29d91d718cb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ec4eb29d91d718cb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ec4eb29d91d718cb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ec4eb29d91d718cb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ec4eb29d91d718cb$var$defaultColorMode = 'light';
var $ec4eb29d91d718cb$var$defaultContrastMode = 'no-preference';
var $ec4eb29d91d718cb$export$e1f80cb7a749802f = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $6lN5g.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $6lN5g.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $6lN5g.themeStateDefaults)['light'] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $6lN5g.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$motion = _ref.motion, motion = _ref$motion === void 0 ? (0, $6lN5g.themeStateDefaults)['motion']() : _ref$motion, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $6lN5g.themeStateDefaults)['shape'] : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $6lN5g.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $6lN5g.themeStateDefaults)['typography'] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $6lN5g.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $e6NGy.themeObjectToString)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $9AP5g.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $9AP5g.COLOR_MODE_ATTRIBUTE), colorMode === 'auto' ? $ec4eb29d91d718cb$var$defaultColorMode : colorMode);
    if ((0, $50U6m.fg)('platform_increased-contrast-themes')) result = $ec4eb29d91d718cb$var$_objectSpread($ec4eb29d91d718cb$var$_objectSpread({}, result), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $9AP5g.CONTRAST_MODE_ATTRIBUTE), contrastMode === 'auto' ? $ec4eb29d91d718cb$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $6clIx.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $3ENxc.hash)(optionString);
        result[0, $9AP5g.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $ec4eb29d91d718cb$export$2e2bcd8739ae039 = $ec4eb29d91d718cb$export$e1f80cb7a749802f;

});
parcelRegister("e6NGy", function(module, exports) {
$parcel$export(module.exports, "themeObjectToString", () => $a4582ab93641fdfd$export$62c37ab81302621a);

var $ekGgq = parcelRequire("ekGgq");

var $iYJcE = parcelRequire("iYJcE");

var $firKk = parcelRequire("firKk");

var $hQI5A = parcelRequire("hQI5A");

var $13QP3 = parcelRequire("13QP3");
var $a4582ab93641fdfd$var$customThemeOptions = 'UNSAFE_themeOptions';
var $a4582ab93641fdfd$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && (0, $firKk.isColorMode)(id) || // custom theme state
        kind === $a4582ab93641fdfd$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' || // other theme states
        (0, $13QP3.isThemeKind)(kind) && typeof id === 'string' && (0, $hQI5A.isThemeIds)(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};

});
parcelRegister("firKk", function(module, exports) {
$parcel$export(module.exports, "isColorMode", () => $b22e0f4bd02ee9bc$export$4a14e169b1de4ee7);
var $b22e0f4bd02ee9bc$export$4a14e169b1de4ee7 = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};

});

parcelRegister("hQI5A", function(module, exports) {
$parcel$export(module.exports, "isThemeIds", () => $cfe97e314278c305$export$ea35b8958c39dd07);

var $l6nO9 = parcelRequire("l6nO9");
var $cfe97e314278c305$export$ea35b8958c39dd07 = function isThemeIds(themeId) {
    return (0, $l6nO9.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};

});
parcelRegister("l6nO9", function(module, exports) {
$parcel$export(module.exports, "themeIds", () => $f5cca04043e97ccd$export$7d43e72a58e3283f);
/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */ var $f5cca04043e97ccd$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'UNSAFE-test-light',
    'dark',
    'UNSAFE-test-dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];

});


parcelRegister("13QP3", function(module, exports) {
$parcel$export(module.exports, "isThemeKind", () => $0c5f0bb7a775b02f$export$958fa026be3a263e);
var $0c5f0bb7a775b02f$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $0c5f0bb7a775b02f$export$958fa026be3a263e = function isThemeKind(themeKind) {
    return $0c5f0bb7a775b02f$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};

});


parcelRegister("6clIx", function(module, exports) {
$parcel$export(module.exports, "isValidBrandHex", () => $4834b5af4fbc0ef8$export$53031ac1ecb71f44);
var $4834b5af4fbc0ef8$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};

});


parcelRegister("dfiLq", function(module, exports) {
$parcel$export(module.exports, "setGlobalTheme", () => $9a4b3b2d125ade05$export$fd7e0dd2b74807f7);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $50U6m = parcelRequire("50U6m");

var $dG82B = parcelRequire("dG82B");

var $6lN5g = parcelRequire("6lN5g");

var $aZgxu = parcelRequire("aZgxu");

var $USNiu = parcelRequire("USNiu");

var $koLca = parcelRequire("koLca");

var $3BOiJ = parcelRequire("3BOiJ");

var $6clIx = parcelRequire("6clIx");

var $j7IrW = parcelRequire("j7IrW");

var $jeuD9 = parcelRequire("jeuD9");
function $9a4b3b2d125ade05$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $9a4b3b2d125ade05$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $9a4b3b2d125ade05$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $9a4b3b2d125ade05$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $9a4b3b2d125ade05$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $9a4b3b2d125ade05$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $9a4b3b2d125ade05$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9a4b3b2d125ade05$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9a4b3b2d125ade05$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9a4b3b2d125ade05$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $9a4b3b2d125ade05$export$fd7e0dd2b74807f7 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3() {
        var nextThemeState, themeLoader, _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$motion, motion, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeState, themePreferences, loadingStrategy, loadingTasks, themeOverridePreferences, overrideThemeCssLoadingTasks, mode, attrOfMissingCustomStyles, _iterator, _step, themeId, overrideThemeCss, autoUnbind, _args3 = arguments, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    nextThemeState = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    _ref2 = typeof nextThemeState === 'function' ? nextThemeState($9a4b3b2d125ade05$var$_objectSpread($9a4b3b2d125ade05$var$_objectSpread({}, (0, $6lN5g.themeStateDefaults)), {}, {
                        typography: (0, $6lN5g.themeStateDefaults)['typography'],
                        shape: (0, $6lN5g.themeStateDefaults)['shape'],
                        motion: (0, $6lN5g.themeStateDefaults)['motion']()
                    }, (0, $dG82B.getGlobalTheme)())) : nextThemeState, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $6lN5g.themeStateDefaults)['colorMode'] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $6lN5g.themeStateDefaults)['contrastMode'] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $6lN5g.themeStateDefaults)['dark'] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $6lN5g.themeStateDefaults)['light'] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $6lN5g.themeStateDefaults)['shape'] : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $6lN5g.themeStateDefaults)['spacing'] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $6lN5g.themeStateDefaults)['typography'] : _ref2$typography, _ref2$motion = _ref2.motion, motion = _ref2$motion === void 0 ? (0, $6lN5g.themeStateDefaults)['motion']() : _ref2$motion, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $6lN5g.themeStateDefaults)['UNSAFE_themeOptions'] : _ref2$UNSAFE_themeOpt; // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $50U6m.fg)('platform_increased-contrast-themes')) {
                        if (light === 'light-increased-contrast') light = 'light';
                        if (dark === 'dark-increased-contrast') dark = 'dark';
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        motion: motion,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $3BOiJ.getThemePreferences)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $jeuD9.loadAndAppendThemeCss); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 1;
                                        return loadingStrategy(themeId);
                                    case 1:
                                        return _context.abrupt("return", _context.sent);
                                    case 2:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }());
                    themeOverridePreferences = (0, $koLca.getThemeOverridePreferences)(themeState); // Start loading override CSS before the first await. It is appended only after the standard
                    // themes have loaded so that the override cascade order remains deterministic.
                    overrideThemeCssLoadingTasks = themeLoader ? [] : themeOverridePreferences.map(function(themeId) {
                        return (0, $j7IrW.loadThemeCss)(themeId);
                    }); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $6clIx.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $6lN5g.themeStateDefaults)['colorMode'];
                        attrOfMissingCustomStyles = (0, $USNiu.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 1;
                                        return (parcelRequire("9oHZo"));
                                    case 1:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 2:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 1;
                    return Promise.all(loadingTasks);
                case 1:
                    if (!themeLoader) {
                        _context3.next = 9;
                        break;
                    }
                    _iterator = $9a4b3b2d125ade05$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 2;
                    _iterator.s();
                case 3:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 5;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 4;
                    return loadingStrategy(themeId);
                case 4:
                    _context3.next = 3;
                    break;
                case 5:
                    _context3.next = 7;
                    break;
                case 6:
                    _context3.prev = 6;
                    _t = _context3["catch"](2);
                    _iterator.e(_t);
                case 7:
                    _context3.prev = 7;
                    _iterator.f();
                    return _context3.finish(7);
                case 8:
                    _context3.next = 11;
                    break;
                case 9:
                    _context3.next = 10;
                    return Promise.all(overrideThemeCssLoadingTasks);
                case 10:
                    overrideThemeCss = _context3.sent;
                    _context3.next = 11;
                    return Promise.all(themeOverridePreferences.map(function(themeId, index) {
                        return (0, $jeuD9.loadAndAppendThemeCss)(themeId, overrideThemeCss[index]);
                    }));
                case 11:
                    autoUnbind = (0, $aZgxu.default)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 12:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                2,
                6,
                7,
                8
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("dG82B", function(module, exports) {
$parcel$export(module.exports, "getGlobalTheme", () => $9f556f5b50981903$export$813ecdf77207a053);

var $25nEq = parcelRequire("25nEq");

var $9AP5g = parcelRequire("9AP5g");

var $88LDI = parcelRequire("88LDI");

var $kigv8 = parcelRequire("kigv8");
function $9f556f5b50981903$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9f556f5b50981903$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9f556f5b50981903$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9f556f5b50981903$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9f556f5b50981903$export$813ecdf77207a053 = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $9AP5g.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $9AP5g.THEME_DATA_ATTRIBUTE)) || '';
    return $9f556f5b50981903$var$_objectSpread($9f556f5b50981903$var$_objectSpread({}, (0, $kigv8.themeStringToObject)(theme)), (0, $88LDI.isThemeColorMode)(colorMode) && {
        colorMode: colorMode
    });
};

});
parcelRegister("88LDI", function(module, exports) {
$parcel$export(module.exports, "isThemeColorMode", () => $5ed4064b4ac2aa3f$export$fcfb1976c88f9f75);

var $bcBv1 = parcelRequire("bcBv1");
var $5ed4064b4ac2aa3f$export$fcfb1976c88f9f75 = function isThemeColorMode(colorMode) {
    return (0, $bcBv1.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};

});
parcelRegister("bcBv1", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", () => $827de745ceff3d4d$export$83993de8eb66733);
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $827de745ceff3d4d$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];

});


parcelRegister("kigv8", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", () => $ec6249de1b2286f1$export$f19b488f7c0547ee);

var $iYJcE = parcelRequire("iYJcE");

var $firKk = parcelRequire("firKk");

var $hQI5A = parcelRequire("hQI5A");

var $13QP3 = parcelRequire("13QP3");
var $ec6249de1b2286f1$var$customThemeOptions = 'UNSAFE_themeOptions';
var $ec6249de1b2286f1$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ').map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && (0, $firKk.isColorMode)(id)) themeObject[kind] = id;
        if ((0, $13QP3.isThemeKind)(kind) && (0, $hQI5A.isThemeIds)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $ec6249de1b2286f1$var$customThemeOptions) try {
            themeObject[$ec6249de1b2286f1$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};

});


parcelRegister("aZgxu", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ffc6e39b7f2dd73$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $50U6m = parcelRequire("50U6m");

var $khRfh = parcelRequire("khRfh");

var $d4mPb = parcelRequire("d4mPb");

var $lLJrX = parcelRequire("lLJrX");
function $7ffc6e39b7f2dd73$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $d4mPb.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $d4mPb.default).bind();
    } else (0, $d4mPb.default).unbind();
    if ((0, $50U6m.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $lLJrX.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $lLJrX.default).bind();
        } else (0, $lLJrX.default).unbind();
    }
    var themeAttributes = (0, $khRfh.default)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $d4mPb.default).unbind();
        if ((0, $50U6m.fg)('platform_increased-contrast-themes')) (0, $lLJrX.default).unbind();
    };
}

});
parcelRegister("d4mPb", function(module, exports) {
$parcel$export(module.exports, "default", () => $983d5a90f967f7fe$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $7QpUe = parcelRequire("7QpUe");

var $9AP5g = parcelRequire("9AP5g");

var $jeuD9 = parcelRequire("jeuD9");
var $983d5a90f967f7fe$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $983d5a90f967f7fe$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $9AP5g.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
var $983d5a90f967f7fe$var$darkModeMql = $983d5a90f967f7fe$var$isMatchMediaAvailable && window.matchMedia((0, $jeuD9.darkModeMediaQuery));
var $983d5a90f967f7fe$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ColorModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "unbindThemeChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$983d5a90f967f7fe$var$darkModeMql) return 'light';
                return $983d5a90f967f7fe$var$darkModeMql !== null && $983d5a90f967f7fe$var$darkModeMql !== void 0 && $983d5a90f967f7fe$var$darkModeMql.matches ? 'dark' : 'light';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($983d5a90f967f7fe$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $7QpUe.bind)($983d5a90f967f7fe$var$darkModeMql, {
                    type: 'change',
                    listener: $983d5a90f967f7fe$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $983d5a90f967f7fe$var$SingletonColorModeObserver = new $983d5a90f967f7fe$var$ColorModeObserver();
var $983d5a90f967f7fe$export$2e2bcd8739ae039 = $983d5a90f967f7fe$var$SingletonColorModeObserver;

});
parcelRegister("jeuD9", function(module, exports) {
$parcel$export(module.exports, "loadAndAppendThemeCss", () => $e00715b6e459a098$export$26cd7ae85c7144e5);
$parcel$export(module.exports, "darkModeMediaQuery", () => $e00715b6e459a098$export$bb1e815119d30f8b);
$parcel$export(module.exports, "moreContrastMediaQuery", () => $e00715b6e459a098$export$8662df6937d86fcb);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $9AP5g = parcelRequire("9AP5g");

var $j7IrW = parcelRequire("j7IrW");
var $e00715b6e459a098$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId, preloadedThemeCss) {
        var themeCss, style, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $9AP5g.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]:not([").concat((0, $9AP5g.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 1;
                        break;
                    }
                    return _context.abrupt("return");
                case 1:
                    if (themeId) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (!(preloadedThemeCss !== null && preloadedThemeCss !== void 0)) {
                        _context.next = 3;
                        break;
                    }
                    _t = preloadedThemeCss;
                    _context.next = 5;
                    break;
                case 3:
                    _context.next = 4;
                    return (0, $j7IrW.loadThemeCss)(themeId);
                case 4:
                    _t = _context.sent;
                case 5:
                    themeCss = _t;
                    style = document.createElement('style');
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 6:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var $e00715b6e459a098$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
var $e00715b6e459a098$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("j7IrW", function(module, exports) {
$parcel$export(module.exports, "loadThemeCss", () => $dec12687bb640dba$export$8a48286ed7df6720);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $1XYfd = parcelRequire("1XYfd");
var $dec12687bb640dba$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 1;
                    return (0, $1XYfd.default)[themeId]();
                case 1:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 2:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("1XYfd", function(module, exports) {
$parcel$export(module.exports, "themeImportMap", () => $16ea0866e540b1ea$export$3a171c49f8c16356);
$parcel$export(module.exports, "default", () => $16ea0866e540b1ea$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::3f58b313f1e628496675dd91b81ecfa1>>
 * @codegenCommand yarn build tokens
 */ 
















var $16ea0866e540b1ea$export$3a171c49f8c16356 = {
    'light': function light() {
        return (parcelRequire("bDSDt"));
    },
    'light-future': function lightFuture() {
        return (parcelRequire("8SV4m"));
    },
    'light-finesse': function lightFinesse() {
        return (parcelRequire("3sbKi"));
    },
    'light-increased-contrast-finesse': function lightIncreasedContrastFinesse() {
        return (parcelRequire("clWHD"));
    },
    'light-increased-contrast': function lightIncreasedContrast() {
        return (parcelRequire("10OzB"));
    },
    'UNSAFE-test-light': function UNSAFETestLight() {
        return (parcelRequire("2hNfn"));
    },
    'UNSAFE-test-dark': function UNSAFETestDark() {
        return (parcelRequire("tvvg7"));
    },
    'dark': function dark() {
        return (parcelRequire("8Ul61"));
    },
    'dark-future': function darkFuture() {
        return (parcelRequire("fUMDb"));
    },
    'dark-finesse': function darkFinesse() {
        return (parcelRequire("fONlQ"));
    },
    'dark-increased-contrast-finesse': function darkIncreasedContrastFinesse() {
        return (parcelRequire("89bQV"));
    },
    'dark-increased-contrast': function darkIncreasedContrast() {
        return (parcelRequire("5r8Y4"));
    },
    'spacing': function spacing() {
        return (parcelRequire("9aLgs"));
    },
    'typography': function typography() {
        return (parcelRequire("b3HFs"));
    },
    'typography-finesse': function typographyFinesse() {
        return (parcelRequire("1VnnL"));
    },
    'shape': function shape() {
        return (parcelRequire("2BLfh"));
    },
    'motion': function motion() {
        return (parcelRequire("j7Ivm"));
    }
};
var $16ea0866e540b1ea$export$2e2bcd8739ae039 = $16ea0866e540b1ea$export$3a171c49f8c16356;

});




parcelRegister("lLJrX", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd913e28a40792b4$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $7QpUe = parcelRequire("7QpUe");

var $9AP5g = parcelRequire("9AP5g");

var $jeuD9 = parcelRequire("jeuD9");
var $fd913e28a40792b4$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $fd913e28a40792b4$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $9AP5g.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
var $fd913e28a40792b4$var$contrastModeMql = $fd913e28a40792b4$var$isMatchMediaAvailable && window.matchMedia((0, $jeuD9.moreContrastMediaQuery));
var $fd913e28a40792b4$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ContrastModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "unbindContrastChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$fd913e28a40792b4$var$contrastModeMql) return 'no-preference';
                return $fd913e28a40792b4$var$contrastModeMql !== null && $fd913e28a40792b4$var$contrastModeMql !== void 0 && $fd913e28a40792b4$var$contrastModeMql.matches ? 'more' : 'no-preference';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($fd913e28a40792b4$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $7QpUe.bind)($fd913e28a40792b4$var$contrastModeMql, {
                    type: 'change',
                    listener: $fd913e28a40792b4$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $fd913e28a40792b4$var$SingletonContrastModeObserver = new $fd913e28a40792b4$var$ContrastModeObserver();
var $fd913e28a40792b4$export$2e2bcd8739ae039 = $fd913e28a40792b4$var$SingletonContrastModeObserver;

});


parcelRegister("USNiu", function(module, exports) {
$parcel$export(module.exports, "findMissingCustomStyleElements", () => $0aafbc0c1e392f5b$export$bd1ac9300b0e885a);

var $9AP5g = parcelRequire("9AP5g");

var $3ENxc = parcelRequire("3ENxc");
function $0aafbc0c1e392f5b$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $3ENxc.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $9AP5g.CUSTOM_THEME_ATTRIBUTE), "=\"").concat(uniqueId, "\"][").concat((0, $9AP5g.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}

});

parcelRegister("koLca", function(module, exports) {
$parcel$export(module.exports, "getThemeOverridePreferences", () => $ed9aa88ca40ae06d$export$5d76d7014f4a5d08);

var $fC8ib = parcelRequire("fC8ib");

var $50U6m = parcelRequire("50U6m");

var $ei0Es = parcelRequire("ei0Es");
var $ed9aa88ca40ae06d$var$finesseOverrides = {
    light: 'light-finesse',
    'light-increased-contrast': 'light-increased-contrast-finesse',
    dark: 'dark-finesse',
    'dark-increased-contrast': 'dark-increased-contrast-finesse',
    typography: 'typography-finesse'
};
var $ed9aa88ca40ae06d$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(themeState) {
    if (!(0, $50U6m.fg)('platform-dst-tokens-finesse')) return [];
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, typography = themeState.typography;
    var selectedThemes = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(colorMode === 'auto' ? [
        light,
        dark
    ] : [
        themeState[colorMode]
    ]), [
        typography
    ]);
    if (contrastMode !== 'no-preference' && (0, $50U6m.fg)('platform_increased-contrast-themes')) selectedThemes.forEach(function(themeId) {
        var increasedContrastTheme = (0, $ei0Es.default)(themeId);
        if (increasedContrastTheme) selectedThemes.push(increasedContrastTheme);
    });
    var themeOverridePreferences = selectedThemes.map(function(themeId) {
        return $ed9aa88ca40ae06d$var$finesseOverrides[themeId];
    }).filter(function(themeId) {
        return themeId !== undefined;
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set(themeOverridePreferences));
};

});
parcelRegister("ei0Es", function(module, exports) {
$parcel$export(module.exports, "default", () => $a673407db681c464$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $N6ReQ = parcelRequire("N6ReQ");
function $a673407db681c464$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $N6ReQ.default)).find(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}

});
parcelRegister("N6ReQ", function(module, exports) {
$parcel$export(module.exports, "themeOverrideIds", () => $0939e582e4241e27$export$ba8a43b83ecc69f8);
$parcel$export(module.exports, "themeIdsWithOverrides", () => $0939e582e4241e27$export$92ba366331403db2);
$parcel$export(module.exports, "default", () => $0939e582e4241e27$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $l6nO9 = parcelRequire("l6nO9");


/**
 * Themes: The internal identifier of a theme.
 * These ids are what the actual theme files/folders are called.
 * style-dictionary will attempt to locate these in the file-system.
 */ /**
 * ThemeOverrides: The internal identifier of a theme override. Which are themes that contain
 * a subset of tokens intended to override an existing theme. These ids are what the actual
 * theme files/folders are called. style-dictionary will attempt to locate these in the file-system.
 * Theme overrides are temporary and there may not be any defined at times.
 */ // Retain Themes in this public type for backwards compatibility.
// platform-dst-tokens-finesse cleanup: Revisit when the temporary override themes are removed.
/**
 * Theme kinds: The type of theme.
 * Some themes are entirely focused on Color, whilst others are purely focused on spacing.
 * In the future other types may be introduced such as typography.
 */ /**
 * Contrast preferences: The system contrast preference
 */ var $0939e582e4241e27$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $0939e582e4241e27$export$ba8a43b83ecc69f8 = [
    'light-finesse',
    'light-increased-contrast-finesse',
    'dark-finesse',
    'dark-increased-contrast-finesse',
    'typography-finesse'
];
var $0939e582e4241e27$export$92ba366331403db2 = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((0, $l6nO9.themeIds)), $0939e582e4241e27$export$ba8a43b83ecc69f8);
var $0939e582e4241e27$export$9d64ff89b6869900 = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-finesse': {
        id: 'light-finesse',
        displayName: 'FY27 Finesse Light Theme Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast-finesse': {
        id: 'light-increased-contrast-finesse',
        displayName: 'FY27 Finesse Light Theme (increased contrast) Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light-increased-contrast'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'UNSAFE-test-light': {
        id: 'UNSAFE-test-light',
        displayName: 'UNSAFE Test Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light'
    },
    'UNSAFE-test-dark': {
        id: 'UNSAFE-test-dark',
        displayName: 'UNSAFE Test Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-finesse': {
        id: 'dark-finesse',
        displayName: 'FY27 Finesse Dark Theme Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'dark'
    },
    'atlassian-dark-increased-contrast-finesse': {
        id: 'dark-increased-contrast-finesse',
        displayName: 'FY27 Finesse Dark Theme (increased contrast) Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'dark-increased-contrast'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-finesse': {
        id: 'typography-finesse',
        displayName: 'FY27 Finesse Typography Override',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        },
        override: 'typography'
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$0939e582e4241e27$export$2e2bcd8739ae039 = $0939e582e4241e27$export$9d64ff89b6869900;

});



parcelRegister("3BOiJ", function(module, exports) {
$parcel$export(module.exports, "getThemePreferences", () => $2a0bd88b2a46cb27$export$dd6aeb7c823fc03d);

var $fC8ib = parcelRequire("fC8ib");

var $50U6m = parcelRequire("50U6m");

var $ei0Es = parcelRequire("ei0Es");
var $2a0bd88b2a46cb27$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography, motion = themeState.motion;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $50U6m.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $ei0Es.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $50U6m.fg)('platform_increased-contrast-themes')) {
            var increasedContrastTheme = (0, $ei0Es.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set(themePreferences));
};

});

parcelRegister("9oHZo", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("gi38D"),
    $iKwew("adg9C")
]).then(()=>parcelRequire('jLYkO'));

});


parcelRegister("fYEbK", function(module, exports) {
$parcel$export(module.exports, "useIsAppProviderThemingEnabled", () => $ba1ba235bf65b49c$export$a782702263f77544);

var $5FkrB = parcelRequire("5FkrB");

var $lGlxg = parcelRequire("lGlxg");
var $ba1ba235bf65b49c$export$a782702263f77544 = function useIsAppProviderThemingEnabled() {
    return (0, $5FkrB.useContext)((0, $lGlxg.AppProviderThemingEnabledContext));
};

});
parcelRegister("lGlxg", function(module, exports) {
$parcel$export(module.exports, "AppProviderThemingEnabledContext", () => $fc8e39bf58b08a3f$export$d2def9838ca456c0);

var $5FkrB = parcelRequire("5FkrB");
var $fc8e39bf58b08a3f$export$d2def9838ca456c0 = /*#__PURE__*/ (0, $5FkrB.createContext)(false);

});


parcelRegister("dLBZC", function(module, exports) {
$parcel$export(module.exports, "useIsInsideAppProvider", () => $a05d22bc685d9de7$export$26aa23367bfbab0e);

var $5FkrB = parcelRequire("5FkrB");

var $8klkn = parcelRequire("8klkn");
var $a05d22bc685d9de7$export$26aa23367bfbab0e = function useIsInsideAppProvider() {
    return (0, $5FkrB.useContext)((0, $8klkn.InsideAppProviderContext));
};

});
parcelRegister("8klkn", function(module, exports) {
$parcel$export(module.exports, "InsideAppProviderContext", () => $6100bc3bbf0b7ac9$export$7981b2444296e410);

var $5FkrB = parcelRequire("5FkrB");
var $6100bc3bbf0b7ac9$export$7981b2444296e410 = /*#__PURE__*/ (0, $5FkrB.createContext)(false);

});


parcelRegister("buC9l", function(module, exports) {
$parcel$export(module.exports, "ColorModeContext", () => $85e016ca147353cc$export$49ddd74a6729fdb0);

var $5FkrB = parcelRequire("5FkrB");
var $85e016ca147353cc$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);

});

parcelRegister("bhsSk", function(module, exports) {
$parcel$export(module.exports, "InsideThemeProviderContext", () => $021e9353b06d2882$export$332347eeb335453c);

var $5FkrB = parcelRequire("5FkrB");
var $021e9353b06d2882$export$332347eeb335453c = /*#__PURE__*/ (0, $5FkrB.createContext)(false);

});

parcelRegister("0J1ha", function(module, exports) {
$parcel$export(module.exports, "SetColorModeContext", () => $0022ec27217363ed$export$b06130bad0bbc70f);

var $5FkrB = parcelRequire("5FkrB");
var $0022ec27217363ed$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);

});

parcelRegister("gfmgU", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", () => $bd3f52c2e3d4f330$export$2c657da244d00bd6);
$parcel$export(module.exports, "SetThemeContext", () => $bd3f52c2e3d4f330$export$f7a97b47760e2a13);

var $5FkrB = parcelRequire("5FkrB");
var $bd3f52c2e3d4f330$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $bd3f52c2e3d4f330$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);

});

parcelRegister("SGOeg", function(module, exports) {
$parcel$export(module.exports, "useIsInsideThemeProvider", () => $0a464043c5ac532b$export$7ca11437599d653d);

var $5FkrB = parcelRequire("5FkrB");

var $bhsSk = parcelRequire("bhsSk");
var $0a464043c5ac532b$export$7ca11437599d653d = function useIsInsideThemeProvider() {
    var _useContext;
    return (_useContext = (0, $5FkrB.useContext)((0, $bhsSk.InsideThemeProviderContext))) !== null && _useContext !== void 0 ? _useContext : false;
};

});

parcelRegister("10rn6", function(module, exports) {
$parcel$export(module.exports, "loadAndMountThemes", () => $0bbb05f64441d8b4$export$7d4a7e812d176b24);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $lFhdZ = parcelRequire("lFhdZ");

var $1XYfd = parcelRequire("1XYfd");

var $8bvU3 = parcelRequire("8bvU3");
var $0bbb05f64441d8b4$var$loadThemeCss = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(0, $8bvU3.isThemeMounted)(themeId)) {
                        _context.next = 1;
                        break;
                    }
                    return _context.abrupt("return");
                case 1:
                    if (themeId) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    _context.next = 3;
                    return (0, $1XYfd.themeImportMap)[themeId]();
                case 3:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $0bbb05f64441d8b4$var$mountThemeCss = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(css, themeId) {
        var doc, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    // SSR-safe: Only mount on client side
                    doc = (0, $lFhdZ.getDocument)();
                    if (doc) {
                        _context2.next = 1;
                        break;
                    }
                    return _context2.abrupt("return");
                case 1:
                    style = doc.createElement('style');
                    style.textContent = css;
                    style.dataset.theme = themeId;
                    // Prevent duplicate mounting of themes.
                    // It's possible the theme was already being loaded elsewhere.
                    if (!(0, $8bvU3.isThemeMounted)(themeId)) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return");
                case 2:
                    doc.head.appendChild(style);
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function mountThemeCss(_x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();
var $0bbb05f64441d8b4$var$loadAndMountThemeCss = /*#__PURE__*/ function() {
    var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(themeId) {
        var themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 1;
                    return $0bbb05f64441d8b4$var$loadThemeCss(themeId);
                case 1:
                    themeCss = _context3.sent;
                    if (themeCss) {
                        _context3.next = 2;
                        break;
                    }
                    return _context3.abrupt("return");
                case 2:
                    $0bbb05f64441d8b4$var$mountThemeCss(themeCss, themeId);
                case 3:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function loadAndMountThemeCss(_x4) {
        return _ref3.apply(this, arguments);
    };
}();
var $0bbb05f64441d8b4$export$7d4a7e812d176b24 = /*#__PURE__*/ function() {
    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(theme) {
        var themesToLoad;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    themesToLoad = Object.values(theme).filter(function(themeId) {
                        return !!themeId;
                    });
                    themesToLoad.forEach($0bbb05f64441d8b4$var$loadAndMountThemeCss);
                case 1:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function loadAndMountThemes(_x5) {
        return _ref4.apply(this, arguments);
    };
}();

});
parcelRegister("8bvU3", function(module, exports) {
$parcel$export(module.exports, "isThemeMounted", () => $5f58191f17fbe680$export$835a0dc855d02822);

var $lFhdZ = parcelRequire("lFhdZ");

var $9AP5g = parcelRequire("9AP5g");
function $5f58191f17fbe680$export$835a0dc855d02822(themeId) {
    var doc = (0, $lFhdZ.getDocument)();
    if (!doc) return false;
    return doc.head.querySelector("style[".concat((0, $9AP5g.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
}

});



parcelRegister("8LRuV", function(module, exports) {
$parcel$export(module.exports, "useColorMode", () => $662c360a0b5c0d7a$export$20f3076712c8dfa);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $dG82B = parcelRequire("dG82B");

var $h1IZv = parcelRequire("h1IZv");

var $buC9l = parcelRequire("buC9l");
function $662c360a0b5c0d7a$export$20f3076712c8dfa() {
    var value = (0, $5FkrB.useContext)((0, $buC9l.ColorModeContext));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    var theme = (0, $dG82B.getGlobalTheme)();
    var _useState = (0, $5FkrB.useState)((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), resolvedColorMode = _useState2[0], setResolvedColorMode = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        var observer = new (0, $h1IZv.ThemeMutationObserver)(function(theme) {
            setResolvedColorMode((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}

});
parcelRegister("h1IZv", function(module, exports) {
$parcel$export(module.exports, "ThemeMutationObserver", () => $c6556df0165c1fe6$export$b741a7c3bcb1c635);
$parcel$export(module.exports, "default", () => $c6556df0165c1fe6$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $9AP5g = parcelRequire("9AP5g");

var $dG82B = parcelRequire("dG82B");
var $c6556df0165c1fe6$export$b741a7c3bcb1c635 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $dG82B.getGlobalTheme)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $9AP5g.THEME_DATA_ATTRIBUTE),
                            (0, $9AP5g.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c6556df0165c1fe6$export$b741a7c3bcb1c635, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c6556df0165c1fe6$export$b741a7c3bcb1c635, "callbacks", new Set());
var $c6556df0165c1fe6$export$2e2bcd8739ae039 = $c6556df0165c1fe6$export$b741a7c3bcb1c635;

});


parcelRegister("kmtTd", function(module, exports) {
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $ed2d0c26fdd9dc78$export$c582005add11e141);

var $hHDX8 = parcelRequire("hHDX8");

var $kwTgP = parcelRequire("kwTgP");
var $ed2d0c26fdd9dc78$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $hHDX8.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $hHDX8.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $kwTgP.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $ed2d0c26fdd9dc78$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $ed2d0c26fdd9dc78$var$getPortalParent().appendChild(container);
};

});
parcelRegister("hHDX8", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", () => $ce35719b8fe24aa7$export$e4c79eb95c23a0da);
$parcel$export(module.exports, "portalParentSelector", () => $ce35719b8fe24aa7$export$72f415121273627e);
$parcel$export(module.exports, "portalClassName", () => $ce35719b8fe24aa7$export$13f57c02915787b3);
var $ce35719b8fe24aa7$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $ce35719b8fe24aa7$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $ce35719b8fe24aa7$export$13f57c02915787b3 = 'atlaskit-portal';

});

parcelRegister("kwTgP", function(module, exports) {
$parcel$export(module.exports, "getBody", () => $ef21ab619b0b14e8$export$135b49d4bc2964c6);
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $ef21ab619b0b14e8$export$135b49d4bc2964c6 = function getBody() {
    return document.body;
};

});


parcelRegister("ki13r", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $ec564e7f86444039$export$26ae5ca175b4ec5a);

var $hHDX8 = parcelRequire("hHDX8");
var $ec564e7f86444039$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $hHDX8.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};

});

parcelRegister("cKtyc", function(module, exports) {
$parcel$export(module.exports, "removePortalContainer", () => $9480b40d0374d071$export$da99f98bf3fe55b3);

var $hHDX8 = parcelRequire("hHDX8");

var $kwTgP = parcelRequire("kwTgP");
var $9480b40d0374d071$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $hHDX8.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $hHDX8.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $kwTgP.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $9480b40d0374d071$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    var parent = $9480b40d0374d071$var$getPortalParent();
    if (parent.contains(container)) parent.removeChild(container);
};

});


parcelRegister("3xP8x", function(module, exports) {
$parcel$export(module.exports, "default", () => $294c1ed9b98aa8bc$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $5nOvn = parcelRequire("5nOvn");

var $8LRuV = parcelRequire("8LRuV");

var $SGOeg = parcelRequire("SGOeg");

var $ePOyQ = parcelRequire("ePOyQ");

var $h6GgU = parcelRequire("h6GgU");

var $dyLv4 = parcelRequire("dyLv4");
function $294c1ed9b98aa8bc$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    var colorMode = (0, $8LRuV.useColorMode)();
    var isInsideThemeProvider = (0, $SGOeg.useIsInsideThemeProvider)();
    (0, $ePOyQ.useIsomorphicLayoutEffect)(function() {
        var tempPortalContainer = (0, $h6GgU.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $dyLv4.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Suspense), {
        fallback: null
    }, isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5nOvn.ThemeProvider), {
        defaultColorMode: colorMode
    }, children) : children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $aLeHs.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("ePOyQ", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $accd0c7719cc05e3$export$700979bc83e7db82);

var $5FkrB = parcelRequire("5FkrB");
var $accd0c7719cc05e3$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5FkrB.useLayoutEffect) : (0, $5FkrB.useEffect);

});

parcelRegister("h6GgU", function(module, exports) {
$parcel$export(module.exports, "createAtlaskitPortal", () => $c743c97e9960c6bd$export$fef014d7cef9e543);

var $hHDX8 = parcelRequire("hHDX8");
var $c743c97e9960c6bd$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $c743c97e9960c6bd$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($c743c97e9960c6bd$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $hHDX8.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};

});

parcelRegister("dyLv4", function(module, exports) {
$parcel$export(module.exports, "createPortalParent", () => $9df34bdaed18272b$export$95029ca7aca2989e);

var $hHDX8 = parcelRequire("hHDX8");

var $kwTgP = parcelRequire("kwTgP");
var $9df34bdaed18272b$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $9df34bdaed18272b$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($9df34bdaed18272b$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $hHDX8.portalParentSelector));
        if (!parentElement) {
            var _getBody;
            var parent = document.createElement('div');
            parent.className = (0, $hHDX8.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody = (0, $kwTgP.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

});


parcelRegister("bjDXH", function(module, exports) {
$parcel$export(module.exports, "default", () => $83d077a9d4e5feff$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $ePOyQ = parcelRequire("ePOyQ");
var $83d077a9d4e5feff$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $ePOyQ.useIsomorphicLayoutEffect) : (0, $5FkrB.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $83d077a9d4e5feff$export$2e2bcd8739ae039 = $83d077a9d4e5feff$var$useIsSubsequentRender;

});

parcelRegister("jsLZg", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2b5db1d8b3115ec$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $84KKZ = parcelRequire("84KKZ");

var $1HDR8 = parcelRequire("1HDR8");
var $e2b5db1d8b3115ec$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $5FkrB.useEffect)(function() {
        (0, $1HDR8.default)((0, $84KKZ.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $1HDR8.default)((0, $84KKZ.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $e2b5db1d8b3115ec$export$2e2bcd8739ae039 = $e2b5db1d8b3115ec$var$useFirePortalEvent;

});
parcelRegister("84KKZ", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", () => $5e12f7691be82ebc$export$ed5835cc67e87f72);
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", () => $5e12f7691be82ebc$export$80816bd900e5bd00);
var $5e12f7691be82ebc$export$ed5835cc67e87f72 = 'akPortalMount';
var $5e12f7691be82ebc$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("1HDR8", function(module, exports) {
$parcel$export(module.exports, "default", () => $13d8b9306358618f$export$2e2bcd8739ae039);
var $13d8b9306358618f$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $13d8b9306358618f$var$getLayerName = function getLayerName(zIndex) {
    return $13d8b9306358618f$var$zIndexToName.hasOwnProperty(zIndex) ? $13d8b9306358618f$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $13d8b9306358618f$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $13d8b9306358618f$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $13d8b9306358618f$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $13d8b9306358618f$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("64A04", function(module, exports) {
$parcel$export(module.exports, "layers", () => $46bf0aae0dfb1de2$export$7be255094ccdc533);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ var $46bf0aae0dfb1de2$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $46bf0aae0dfb1de2$export$c93026a968943f95 = 'light';
var $46bf0aae0dfb1de2$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $46bf0aae0dfb1de2$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};

});

parcelRegister("lTPIB", function(module, exports) {
$parcel$export(module.exports, "fromLegacyPlacement", () => $ff16da3649f6ba73$export$69e99ed50b2534c9);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $kV4t6 = parcelRequire("kV4t6");
function $ff16da3649f6ba73$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ff16da3649f6ba73$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ff16da3649f6ba73$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ff16da3649f6ba73$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ff16da3649f6ba73$export$69e99ed50b2534c9(_ref) {
    var legacy = _ref.legacy, offset = _ref.offset;
    var basePlacement = (0, $kV4t6.placementMapping)[legacy];
    if (!offset) return basePlacement;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(offset, 2), along = _offset[0], away = _offset[1];
    return $ff16da3649f6ba73$var$_objectSpread($ff16da3649f6ba73$var$_objectSpread({}, basePlacement), {}, {
        offset: {
            gap: away,
            crossAxisShift: {
                // Sign is captured in `direction`; `value` is the magnitude.
                value: Math.abs(along),
                direction: along >= 0 ? 'forwards' : 'backwards'
            }
        }
    });
}

});
parcelRegister("kV4t6", function(module, exports) {
$parcel$export(module.exports, "placementMapping", () => $f3ac98d69f3de1ed$export$27df359c528b7120);
/**
 * The full mapping record. Internal - use `fromLegacyPlacement` from the
 * public entry-point so the offset-tuple translation is applied consistently.
 *
 * Note: `auto`, `auto-start`, `auto-end` map to `block-end` placements. This
 * is a reduction in expressiveness vs Popper.js (which picked the best
 * placement at runtime). CSS `position-try-fallbacks` flips at the edge but
 * the initial placement is fixed. Migration consumers who relied on Popper's
 * dynamic auto-flip should pick an explicit placement instead.
 */ var $f3ac98d69f3de1ed$export$27df359c528b7120 = {
    top: {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'start'
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'end'
    },
    bottom: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    },
    right: {
        axis: 'inline',
        edge: 'end',
        align: 'center'
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'start'
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'end'
    },
    left: {
        axis: 'inline',
        edge: 'start',
        align: 'center'
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'start'
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'end'
    },
    auto: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'auto-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'auto-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    }
};

});


parcelRegister("jWEo0", function(module, exports) {
$parcel$export(module.exports, "Popover", () => $e852c2f93196e24b$export$5b6b19405a83ff9d);
/* popover.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $hUFig = parcelRequire("hUFig");

var $7QpUe = parcelRequire("7QpUe");

var $iO8GM = parcelRequire("iO8GM");

var $bvsoE = parcelRequire("bvsoE");

var $iUCre = parcelRequire("iUCre");

var $c18KD = parcelRequire("c18KD");

var $l1oyc = parcelRequire("l1oyc");

var $1BVGt = parcelRequire("1BVGt");

var $3Fxpo = parcelRequire("3Fxpo");

var $gNnJe = parcelRequire("gNnJe");
/**
 * Native restoration only covers the first popover in an auto/hint stack, not each nested popover.
 * This fallback also supports manual popovers, which have no native restoration target.
 * See https://html.spec.whatwg.org/multipage/popover.html#show-popover (step 15.8).
 */ function $e852c2f93196e24b$var$restoreFocus(_ref) {
    var popover = _ref.popover, focusRestorationTarget = _ref.focusRestorationTarget;
    if (!focusRestorationTarget) return;
    var ownerDocument = popover.ownerDocument;
    // Native restoration has finished. Preserve focus moved outside the popover.
    var activeElementAfterClose = ownerDocument.activeElement;
    // Before close, we checked that focus was inside. Body can now mean focus was lost during close.
    if (activeElementAfterClose === ownerDocument.body || popover.contains(activeElementAfterClose)) // Match native popover restoration, which does not scroll the viewport.
    focusRestorationTarget.focus({
        preventScroll: true
    });
}
/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ var $e852c2f93196e24b$var$supportsPopoverHint = (0, $bvsoE.default)(function() {
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    var element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
// Surface reset — neutralises inherited interaction and text-layout properties
// (e.g. `pointer-events: none` from an overlaid controls container and
// `white-space: nowrap` from an `@atlaskit/select` option) that leak into a
// top-layer element because, for CSS inheritance, it is still a DOM child of its
// trigger (top-layer promotion is paint/stacking only; the legacy portal path
// avoided this by rendering at `<body>`). Excludes `color`/`font` (theming) and
// `direction`/`unicode-bidi` (RTL must inherit).
//
// Not `all: initial`: the target is what `<body>` gave the portal path, not the
// spec initial values (UA serif, black, `color-scheme: normal`), and as an author
// declaration it would also override the UA `[popover]` rules (`position: fixed`,
// `display: none` when closed).
//
// KEEP IN SYNC with the identical `surfaceResetStyles` in `dialog/dialog-content.tsx`.
// ADS forbids sharing styles across files (`no-exported-styles` /
// `no-imported-style-values` — Compiled styles are null at runtime), so the reset is
// co-located and duplicated deliberately. The `satisfies` check below fails the
// build if either copy drifts.
var $e852c2f93196e24b$var$surfaceResetStyles = {
    root: "_lcxv1wug _o5724jg8 _1nmz4jg8 _1i4q4jg8 _y3gnv2br _azhwidpf _1p1dglyw"
};
var $e852c2f93196e24b$var$styles = {
    root: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r041wug _1reoewfl _18m9ewfl _bfhk1j28 _4t3i1wug _p6861txw _51hckb7n _1yp3idpf _f5r5idpf",
    motion: "_k8m011k7 _1oecdn4k _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v179n",
    exit: "_y44vof1f"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
var $e852c2f93196e24b$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ var $e852c2f93196e24b$var$POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
var $e852c2f93196e24b$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function Popover(_ref2, ref) {
    var children = _ref2.children, _ref2$mode = _ref2.mode, modeProp = _ref2$mode === void 0 ? 'auto' : _ref2$mode, onClose = _ref2.onClose, onEnterFinish = _ref2.onEnterFinish, onExitFinish = _ref2.onExitFinish, _ref2$shouldAnimate = _ref2.shouldAnimate, shouldAnimate = _ref2$shouldAnimate === void 0 ? false : _ref2$shouldAnimate, placement = _ref2.placement, testId = _ref2.testId, isOpen = _ref2.isOpen, enteringAnimationXcss = _ref2.enteringAnimationXcss, exitingAnimationXcss = _ref2.exitingAnimationXcss, role = _ref2.role, label = _ref2.label, labelledBy = _ref2.labelledBy, idProp = _ref2.id;
    var autoId = (0, $5FkrB.useId)();
    var ownRef = (0, $5FkrB.useRef)(null);
    var combinedRef = (0, $iO8GM.default)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    var popoverId = idProp !== null && idProp !== void 0 ? idProp : "popover-".concat(autoId.replace(/:/g, ''));
    // Keep the semantic callback current without rebinding native lifecycle
    // listeners during the same commit that calls showPopover()/hidePopover().
    var onCloseRef = (0, $5FkrB.useRef)(onClose);
    (0, $5FkrB.useLayoutEffect)(function() {
        onCloseRef.current = onClose;
    }, [
        onClose
    ]);
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined.
    var handleObserverClose = (0, $5FkrB.useCallback)(function() {
        var _onCloseRef$current;
        (_onCloseRef$current = onCloseRef.current) === null || _onCloseRef$current === void 0 || _onCloseRef$current.call(onCloseRef, {
            reason: 'programmatic'
        });
    }, []);
    (0, $iUCre.useNotifyOpenLayerObserver)({
        type: role && $e852c2f93196e24b$var$POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen: isOpen,
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    var mode = modeProp === 'hint' && !$e852c2f93196e24b$var$supportsPopoverHint() ? 'auto' : modeProp;
    var popupMotionStyle = (0, $5FkrB.useMemo)(function() {
        if (!placement || !shouldAnimate) return undefined;
        var _resolvePlacement = (0, $l1oyc.resolvePlacement)({
            placement: placement
        }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge;
        return $e852c2f93196e24b$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]);
    // Tracks the close reason, including our own hidePopover() calls.
    var closeReasonRef = (0, $5FkrB.useRef)('light-dismiss');
    // Pre-open focus target, cleared before close when restoration is not eligible.
    var focusRestorationTargetRef = (0, $5FkrB.useRef)(null);
    var handleBeforeToggle = (0, $5FkrB.useCallback)(function(event) {
        var popover = event.currentTarget;
        if (!(popover instanceof HTMLElement)) return;
        var ownerDocument = popover.ownerDocument;
        var activeElement = ownerDocument.activeElement;
        if (event.newState === 'open') {
            focusRestorationTargetRef.current = activeElement instanceof HTMLElement ? activeElement : null;
            return;
        }
        /**
     * Like native restoration, leave external focus alone and skip light dismiss.
     * Check before closing so focus already on body is not mistaken for focus lost during close.
     * See https://html.spec.whatwg.org/multipage/popover.html#hide-popover-algorithm (step 20.2).
     */ if (closeReasonRef.current === 'light-dismiss' || !popover.contains(activeElement)) focusRestorationTargetRef.current = null;
    }, []);
    var handleToggleClosed = (0, $5FkrB.useCallback)(function(event) {
        var popover = event.currentTarget;
        if (!(popover instanceof HTMLElement)) return;
        var focusRestorationTarget = focusRestorationTargetRef.current;
        focusRestorationTargetRef.current = null;
        var reason = closeReasonRef.current;
        // Reset reason so a stale 'escape' from a race with Escape keydown
        // does not corrupt the next browser-dismiss cycle.
        closeReasonRef.current = 'light-dismiss';
        // Run after native restoration, before notifying the consumer, which may move focus itself.
        $e852c2f93196e24b$var$restoreFocus({
            popover: popover,
            focusRestorationTarget: focusRestorationTarget
        });
        // Programmatic closes are already known to the consumer.
        if (reason !== 'programmatic') {
            var _onCloseRef$current2;
            (_onCloseRef$current2 = onCloseRef.current) === null || _onCloseRef$current2 === void 0 || _onCloseRef$current2.call(onCloseRef, {
                reason: reason
            });
        }
    }, []);
    var _useAnimatedVisibilit = (0, $1BVGt.useAnimatedVisibility)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    }), phase = _useAnimatedVisibilit.phase, isMounted = _useAnimatedVisibilit.isMounted, onBeforeToggle = _useAnimatedVisibilit.onBeforeToggle, onToggle = _useAnimatedVisibilit.onToggle;
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // popovers are handled above via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus.md.
    (0, $3Fxpo.useFocusWrap)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    (0, $gNnJe.useInitialFocus)({
        elementRef: ownRef,
        phase: phase,
        role: role
    });
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `focusRestorationTargetRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        var unbindEscape = (0, $7QpUe.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                // Ignore Escape events dispatched after native close.
                if (event.key === 'Escape' && (0, $c18KD.isNativeElementOpen)({
                    element: element
                })) closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        var unbindToggle = (0, $7QpUe.bind)(element, {
            type: 'toggle',
            listener: function listener(event) {
                if (event.newState === 'closed') handleToggleClosed(event);
                onToggle(event);
            }
        });
        // Snapshot the active element before `useInitialFocus` moves it,
        // then advance the shared visibility lifecycle.
        var unbindBeforeToggle = (0, $7QpUe.bind)(element, {
            type: 'beforetoggle',
            listener: function listener(event) {
                handleBeforeToggle(event);
                onBeforeToggle(event);
            }
        });
        return function() {
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleBeforeToggle,
        handleToggleClosed,
        isMounted,
        onBeforeToggle,
        onToggle
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and interrupted close lifecycles may not reach
            // `handleToggleClosed` to reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch (_unused) {}
            return function() {
                closeReasonRef.current = 'programmatic';
                try {
                    element.hidePopover();
                } catch (_unused2) {}
            };
        }
        closeReasonRef.current = 'programmatic';
        try {
            element.hidePopover();
        } catch (_unused3) {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isMounted) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        ref: combinedRef,
        id: popoverId,
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        style: popupMotionStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $e852c2f93196e24b$var$styles.root,
            $e852c2f93196e24b$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $e852c2f93196e24b$var$styles.enter,
            shouldAnimate && phase === 'exiting' && $e852c2f93196e24b$var$styles.exit,
            shouldAnimate && $e852c2f93196e24b$var$styles.motion,
            (0, $hUFig.cx)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ])
    }, children);
});

});
parcelRegister("c18KD", function(module, exports) {
$parcel$export(module.exports, "isNativeElementOpen", () => $8bfc5dcef78af629$export$89b923e18c14644d);
function $8bfc5dcef78af629$export$89b923e18c14644d(_ref) {
    var element = _ref.element;
    if (element instanceof HTMLDialogElement) return element.open;
    // Some DOM implementations throw for unsupported pseudo-classes.
    try {
        return element.matches(':popover-open');
    } catch (_unused) {
        return false;
    }
}

});

parcelRegister("l1oyc", function(module, exports) {
$parcel$export(module.exports, "resolvePlacement", () => $f4dcbc342eaa878e$export$63044d21bc3d3fa2);

var $bQr74 = parcelRequire("bQr74");
/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ var $f4dcbc342eaa878e$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $f4dcbc342eaa878e$export$63044d21bc3d3fa2(_ref) {
    var _placement$axis, _placement$edge, _placement$align, _placement$offset$gap, _placement$offset, _placement$offset$cro, _placement$offset2, _placement$offset$cro2, _placement$offset3;
    var placement = _ref.placement;
    return {
        axis: (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block',
        edge: (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end',
        align: (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center',
        // Not `??`: `undefined` must survive, so "not specified" stays
        // distinguishable from an explicit `0`.
        minSize: placement.minSize === undefined ? undefined : (0, $bQr74.toCssLengthString)({
            value: placement.minSize
        }),
        offset: {
            gap: (0, $bQr74.toCssLengthString)({
                value: (_placement$offset$gap = (_placement$offset = placement.offset) === null || _placement$offset === void 0 ? void 0 : _placement$offset.gap) !== null && _placement$offset$gap !== void 0 ? _placement$offset$gap : $f4dcbc342eaa878e$var$DEFAULT_GAP
            }),
            crossAxisShift: {
                value: (0, $bQr74.toCssLengthString)({
                    value: (_placement$offset$cro = (_placement$offset2 = placement.offset) === null || _placement$offset2 === void 0 || (_placement$offset2 = _placement$offset2.crossAxisShift) === null || _placement$offset2 === void 0 ? void 0 : _placement$offset2.value) !== null && _placement$offset$cro !== void 0 ? _placement$offset$cro : 0
                }),
                direction: (_placement$offset$cro2 = (_placement$offset3 = placement.offset) === null || _placement$offset3 === void 0 || (_placement$offset3 = _placement$offset3.crossAxisShift) === null || _placement$offset3 === void 0 ? void 0 : _placement$offset3.direction) !== null && _placement$offset$cro2 !== void 0 ? _placement$offset$cro2 : 'forwards'
            }
        }
    };
}

});
parcelRegister("bQr74", function(module, exports) {
$parcel$export(module.exports, "toCssLengthString", () => $89f9951b5d6e8b0d$export$63b6b0ff65d84d47);
/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $89f9951b5d6e8b0d$export$63b6b0ff65d84d47(_ref) {
    var value = _ref.value;
    if (typeof value === 'number') return "".concat(value, "px");
    return value;
}

});


parcelRegister("1BVGt", function(module, exports) {
$parcel$export(module.exports, "useAnimatedVisibility", () => $12c5fdfbc1dd5a24$export$1bccb45daf07907f);

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $c18KD = parcelRequire("c18KD");

var $3ce0A = parcelRequire("3ce0A");
function $12c5fdfbc1dd5a24$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $12c5fdfbc1dd5a24$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $12c5fdfbc1dd5a24$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $12c5fdfbc1dd5a24$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $12c5fdfbc1dd5a24$var$runCancellableSettlement(_ref) {
    var schedule = _ref.schedule, onSettled = _ref.onSettled;
    var isCancelled = false;
    schedule(function() {
        if (isCancelled) return;
        onSettled();
    });
    return function() {
        // Prevent an interrupted or unmounted lifecycle from firing a stale callback.
        isCancelled = true;
    };
}
/**
 * Fires `onSettled` once all animations currently applied to `element`
 * finish or are cancelled. Returns a cleanup that prevents stale settlement.
 */ function $12c5fdfbc1dd5a24$var$runOnAnimationsSettled(_ref2) {
    var element = _ref2.element, onSettled = _ref2.onSettled;
    return $12c5fdfbc1dd5a24$var$runCancellableSettlement({
        onSettled: onSettled,
        schedule: function schedule(settle) {
            var _element$getAnimation, _element$getAnimation2;
            var animations = (_element$getAnimation = (_element$getAnimation2 = element.getAnimations) === null || _element$getAnimation2 === void 0 ? void 0 : _element$getAnimation2.call(element)) !== null && _element$getAnimation !== void 0 ? _element$getAnimation : [];
            Promise.allSettled(animations.map(function(animation) {
                return animation.finished;
            })).then(settle);
        }
    });
}
/**
 * Visibility lifecycle phase shared between `useAnimatedVisibility`,
 * `useFocusWrap`, `useInitialFocus`, and the `Popover` / `Dialog`
 * components.
 *
 * - `closed`: host element is unmounted. No DOM presence.
 * - `entering`: host element is mounted and the CSS entry transition
 *   is playing. **Only emitted when animation is enabled.** With
 *   animation disabled the lifecycle goes directly `closed → open`.
 * - `open`: host element is mounted and settled. No transition is
 *   playing.
 * - `exiting`: a native close has begun but the host element remains
 *   mounted. Usually this follows `isOpen` changing to `false`, but it can
 *   also begin with a browser-initiated dismissal while controlled intent
 *   is still open. With animation disabled, this phase lasts until the
 *   browser's closed `toggle` fires so native focus restoration can finish.
 *
 * State machine:
 * ```
 *   animation ON:   closed → entering → open → exiting → closed
 *   animation OFF:  closed →            open → exiting → closed
 *   interrupts:     entering → exiting (close mid-entry)
 *                   exiting  → entering (reopen mid-exit, animated)
 *                   exiting  → open     (reopen mid-handshake, non-animated)
 * ```
 */ function $12c5fdfbc1dd5a24$var$getInitialVisibilityState(_ref3) {
    var isOpen = _ref3.isOpen, willAnimate = _ref3.willAnimate;
    if (!isOpen) return {
        phase: 'closed',
        controlledIntent: 'closed'
    };
    if (willAnimate) return {
        phase: 'entering',
        controlledIntent: 'open'
    };
    return {
        phase: 'open',
        controlledIntent: 'open'
    };
}
/**
 * Applies one lifecycle event to the current visibility phase.
 *
 * Events that are stale for the current phase are ignored. This allows
 * animation callbacks and native close events to settle safely after an
 * interrupted lifecycle.
 */ function $12c5fdfbc1dd5a24$var$getNextVisibilityState(state, action) {
    if (action.type === 'open-requested') {
        var shouldEnter = state.phase === 'closed' || state.phase === 'exiting' && state.controlledIntent === 'closed';
        if (shouldEnter && action.willAnimate) return {
            phase: 'entering',
            controlledIntent: 'open'
        };
        if (shouldEnter) return {
            phase: 'open',
            controlledIntent: 'open'
        };
        return $12c5fdfbc1dd5a24$var$_objectSpread($12c5fdfbc1dd5a24$var$_objectSpread({}, state), {}, {
            controlledIntent: 'open'
        });
    }
    if (action.type === 'close-requested') return $12c5fdfbc1dd5a24$var$_objectSpread($12c5fdfbc1dd5a24$var$_objectSpread({}, state), {}, {
        controlledIntent: 'closed'
    });
    if (action.type === 'exit-started') {
        if (state.phase !== 'open' && state.phase !== 'entering') return state;
        return $12c5fdfbc1dd5a24$var$_objectSpread($12c5fdfbc1dd5a24$var$_objectSpread({}, state), {}, {
            phase: 'exiting'
        });
    }
    if (action.type === 'entry-settled') {
        if (state.phase !== 'entering') return state;
        return $12c5fdfbc1dd5a24$var$_objectSpread($12c5fdfbc1dd5a24$var$_objectSpread({}, state), {}, {
            phase: 'open'
        });
    }
    if (action.type === 'exit-settled') {
        if (state.phase !== 'exiting') return state;
        return $12c5fdfbc1dd5a24$var$_objectSpread($12c5fdfbc1dd5a24$var$_objectSpread({}, state), {}, {
            phase: 'closed'
        });
    }
    return state;
}
function $12c5fdfbc1dd5a24$export$1bccb45daf07907f(_ref4) {
    var isOpen = _ref4.isOpen, shouldAnimate = _ref4.shouldAnimate, elementRef = _ref4.elementRef, onEnterFinish = _ref4.onEnterFinish, onExitFinish = _ref4.onExitFinish;
    var willAnimate = shouldAnimate && !(0, $3ce0A.prefersReducedMotion)();
    var _useReducer = (0, $5FkrB.useReducer)($12c5fdfbc1dd5a24$var$getNextVisibilityState, {
        isOpen: isOpen,
        willAnimate: willAnimate
    }, $12c5fdfbc1dd5a24$var$getInitialVisibilityState), _useReducer2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useReducer, 2), visibilityState = _useReducer2[0], dispatch = _useReducer2[1];
    var phase = visibilityState.phase, controlledIntent = visibilityState.controlledIntent;
    // Keep stable refs to the latest callbacks so effects and animation settlement closures
    // always call the current callback without needing them in dependency arrays.
    var onEnterFinishRef = (0, $5FkrB.useRef)(onEnterFinish);
    var onExitFinishRef = (0, $5FkrB.useRef)(onExitFinish);
    var willAnimateRef = (0, $5FkrB.useRef)(willAnimate);
    (0, $5FkrB.useLayoutEffect)(function() {
        onEnterFinishRef.current = onEnterFinish;
        onExitFinishRef.current = onExitFinish;
        willAnimateRef.current = willAnimate;
    }, [
        onEnterFinish,
        onExitFinish,
        willAnimate
    ]);
    // Synchronize controlled intent during render so opening mounts the host in
    // the same commit. Keeping the processed intent in reducer state prevents a
    // browser-driven exit from being mistaken for a new controlled open request.
    if (isOpen && controlledIntent === 'closed') dispatch({
        type: 'open-requested',
        willAnimate: willAnimate
    });
    if (!isOpen && controlledIntent === 'open') dispatch({
        type: 'close-requested'
    });
    // Entry can commit `open` before its callback because the host stays mounted.
    // This ensures consumers observe the settled DOM rather than entering styles.
    // Treat the phase before the initial commit as closed so an initially open host
    // notifies consumers.
    var prevPhaseRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        if (prevPhase === phase) return;
        if (phase === 'open') {
            var _onEnterFinishRef$cur;
            (_onEnterFinishRef$cur = onEnterFinishRef.current) === null || _onEnterFinishRef$cur === void 0 || _onEnterFinishRef$cur.call(onEnterFinishRef);
        }
    }, [
        phase
    ]);
    var isMounted = phase !== 'closed';
    var cancelExitSettlementRef = (0, $5FkrB.useRef)(function() {});
    // Exit must notify consumers before `closed` unmounts the host.
    var settleExit = (0, $5FkrB.useCallback)(function() {
        var _onExitFinishRef$curr;
        (_onExitFinishRef$curr = onExitFinishRef.current) === null || _onExitFinishRef$curr === void 0 || _onExitFinishRef$curr.call(onExitFinishRef);
        dispatch({
            type: 'exit-settled'
        });
    }, []);
    // Primitives bind these stable callbacks to their native lifecycle events.
    // This keeps event ownership at the primitive while the hook owns state transitions.
    var onBeforeToggle = (0, $5FkrB.useCallback)(function(event) {
        // Any native transition supersedes a previous exit snapshot. This prevents
        // a stale settlement from closing a host that is reopening or closing again.
        cancelExitSettlementRef.current();
        // Snapshot currentTarget because the DOM clears it after event dispatch.
        var element = event.currentTarget;
        if (event.newState === 'open' && element instanceof HTMLElement) {
            element.removeAttribute('inert');
            element.removeAttribute('aria-hidden');
        }
        if (event.newState === 'closed') {
            if (element instanceof HTMLElement) // We use a microtask to let native focus restoration happen before making the element inert.
            // The browser restores focus after beforetoggle returns, during its close steps.
            queueMicrotask(function() {
                // A controlled close can be interrupted by isOpen changing back to true,
                // which reopens the element before this microtask runs.
                if ((0, $c18KD.isNativeElementOpen)({
                    element: element
                })) return;
                // Exit animations keep closed content rendered, so make it non-interactive and hide it from assistive technology.
                element.setAttribute('inert', '');
                // Tooling does not consistently treat inert content as hidden, even though the browser does.
                element.setAttribute('aria-hidden', 'true');
            });
            dispatch({
                type: 'exit-started'
            });
        }
    }, []);
    var onToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState !== 'closed') return;
        if (!willAnimateRef.current) {
            cancelExitSettlementRef.current = $12c5fdfbc1dd5a24$var$runCancellableSettlement({
                schedule: queueMicrotask,
                onSettled: settleExit
            });
            return;
        }
        var element = elementRef.current;
        if (!element) return;
        // The closed `toggle` is task-queued after synchronous `beforetoggle`.
        // Snapshot here so the exiting phase styles have committed and the list
        // represents the animations that actually govern exit settlement.
        cancelExitSettlementRef.current = $12c5fdfbc1dd5a24$var$runOnAnimationsSettled({
            element: element,
            onSettled: settleExit
        });
    }, [
        elementRef,
        settleExit
    ]);
    (0, $5FkrB.useLayoutEffect)(function() {
        return function() {
            // Prevent a pending animation or microtask from notifying after unmount.
            cancelExitSettlementRef.current();
        };
    }, []);
    // Entry settlement only removes entering styles. Its callback runs after the
    // resulting `open` commit in the effect above.
    (0, $5FkrB.useEffect)(function settleEntry() {
        if (phase !== 'entering') return;
        if (!willAnimate) {
            dispatch({
                type: 'entry-settled'
            });
            return;
        }
        var element = elementRef.current;
        if (!element) return;
        return $12c5fdfbc1dd5a24$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                dispatch({
                    type: 'entry-settled'
                });
            }
        });
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    return {
        phase: phase,
        isMounted: isMounted,
        onBeforeToggle: onBeforeToggle,
        onToggle: onToggle
    };
}

});
parcelRegister("3ce0A", function(module, exports) {
$parcel$export(module.exports, "prefersReducedMotion", () => $253d5be3760099c8$export$ff7706047246b98b);

var $bvsoE = parcelRequire("bvsoE");
var $253d5be3760099c8$export$ff7706047246b98b = (0, $bvsoE.default)(function() {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});

});


parcelRegister("3Fxpo", function(module, exports) {
$parcel$export(module.exports, "useFocusWrap", () => $2abf1dadebafbd11$export$4f6462e86a70abe5);

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $fANl5 = parcelRequire("fANl5");

var $bymLX = parcelRequire("bymLX");

var $gpt0k = parcelRequire("gpt0k");

var $iguOX = parcelRequire("iguOX");
/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/outputs/menu-keyboard-decision.md
 */ function $2abf1dadebafbd11$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $2abf1dadebafbd11$export$4f6462e86a70abe5(_ref) {
    var elementRef = _ref.elementRef, role = _ref.role, phase = _ref.phase;
    var isVisible = phase !== 'closed';
    (0, $5FkrB.useEffect)(function() {
        var element = elementRef.current;
        if (!element || !$2abf1dadebafbd11$var$roleRequiresFocusWrap(role) || !isVisible) return;
        var unbind = (0, $7QpUe.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $iguOX.isNestedLayerFocused)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                var direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                var next = (0, $gpt0k.getNextFocusable)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                var fallback = direction === 'forwards' ? (0, $fANl5.getFirstFocusable)({
                    container: element
                }) : (0, $bymLX.getLastFocusable)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}

});
parcelRegister("fANl5", function(module, exports) {
$parcel$export(module.exports, "getFirstFocusable", () => $b5a07d899983befa$export$748138f04a69bf21);

var $fimr4 = parcelRequire("fimr4");
function $b5a07d899983befa$export$748138f04a69bf21(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $fimr4.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}

});
parcelRegister("fimr4", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $b229f0b77a5ab951$export$f6768025e418420e);

var $aMYjD = parcelRequire("aMYjD");
var $b229f0b77a5ab951$var$focusableExclusions = [
    '[tabindex="-1"]',
    ':disabled',
    '[aria-disabled="true"]',
    '[aria-hidden="true"]'
];
var $b229f0b77a5ab951$var$exclusionSelector = $b229f0b77a5ab951$var$focusableExclusions.map(function(selector) {
    return ":not(".concat(selector, ")");
}).join('');
var $b229f0b77a5ab951$var$focusableSelector = [
    'a[href]',
    'area[href]',
    'input:not([type="hidden"])',
    'select',
    'textarea',
    'button',
    'iframe',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])',
    '[tabindex]'
].map(function(selector) {
    return "".concat(selector).concat($b229f0b77a5ab951$var$exclusionSelector);
}).join(',');
function $b229f0b77a5ab951$var$isVisible(element) {
    // Visibility filtering must not break focus navigation when the API is unsupported.
    if (typeof element.checkVisibility !== 'function') return true;
    try {
        // Exclude elements hidden by display, content-visibility or visibility because
        // they cannot receive focus. Offscreen, occluded and opacity-zero elements can
        // receive focus, so they intentionally remain included.
        return element.checkVisibility({
            checkVisibilityCSS: true
        });
    } catch (_unused) {
        return true;
    }
}
function $b229f0b77a5ab951$export$f6768025e418420e(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var containerLayer = (0, $aMYjD.getClosestLayer)({
        element: container
    });
    return Array.from(container.querySelectorAll($b229f0b77a5ab951$var$focusableSelector)).filter(function(element) {
        if (!(element instanceof HTMLElement)) return false;
        if ((0, $aMYjD.getClosestLayer)({
            element: element
        }) !== containerLayer) return false;
        if (element.closest('[inert]')) return false;
        if (!$b229f0b77a5ab951$var$isVisible(element)) return false;
        return !filter || filter(element, container);
    });
}

});
parcelRegister("aMYjD", function(module, exports) {
$parcel$export(module.exports, "getClosestLayer", () => $7dad2c8867d94a80$export$3c9385904be131db);
function $7dad2c8867d94a80$export$3c9385904be131db(_ref) {
    var element = _ref.element;
    return element.closest('[popover], dialog');
}

});



parcelRegister("bymLX", function(module, exports) {
$parcel$export(module.exports, "getLastFocusable", () => $869488cf49d75786$export$73e81fa65335a75b);

var $fimr4 = parcelRequire("fimr4");
function $869488cf49d75786$export$73e81fa65335a75b(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $fimr4.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}

});

parcelRegister("gpt0k", function(module, exports) {
$parcel$export(module.exports, "getNextFocusable", () => $bf257ac4b1f2b4f2$export$a7db88e6d491b450);
/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * The currently focused element does not need to be tabbable. This prevents
 * navigation from getting stuck on an element that was programmatically or
 * pointer focused with `tabindex="-1"`. Negative-tab-index elements remain
 * excluded as destinations.
 *
 * Returns `null` if there is no focused element within the container.
 */ 
var $fimr4 = parcelRequire("fimr4");
function $bf257ac4b1f2b4f2$export$a7db88e6d491b450(_ref) {
    var _all3;
    var container = _ref.container, direction = _ref.direction, filter = _ref.filter;
    var all = (0, $fimr4.getFocusables)({
        container: container,
        filter: filter
    });
    var first = all[0];
    var last = all[all.length - 1];
    // Checking the elements directly narrows types from `HTMLElement | undefined`.
    if (!first || !last) return null;
    var current = container.ownerDocument.activeElement;
    if (!(current instanceof HTMLElement) || !container.contains(current)) return null;
    var index = all.indexOf(current);
    // The focused element can be absent from `all` when it is non-tabbable or
    // excluded by the filter. Find the first focusable element that follows it in
    // the DOM, which identifies the nearest focusable destination in either direction.
    if (index === -1) {
        var _all;
        var followingIndex = all.findIndex(function(element) {
            return Boolean(current.compareDocumentPosition(element) & current.DOCUMENT_POSITION_FOLLOWING);
        });
        if (direction === 'forwards') {
            var _all$followingIndex;
            // If nothing follows the current element, then wrap to the start.
            return (_all$followingIndex = all[followingIndex]) !== null && _all$followingIndex !== void 0 ? _all$followingIndex : first;
        }
        // The closest preceding element is immediately before the first following one.
        // A missing adjacent entry means the backward sequence wraps to the end.
        return (_all = all[followingIndex - 1]) !== null && _all !== void 0 ? _all : last;
    }
    // The current element is tabbable, so use its adjacent list entry and wrap
    // when it is already at the boundary.
    if (direction === 'forwards') {
        var _all2;
        return (_all2 = all[index + 1]) !== null && _all2 !== void 0 ? _all2 : first;
    }
    return (_all3 = all[index - 1]) !== null && _all3 !== void 0 ? _all3 : last;
}

});

parcelRegister("iguOX", function(module, exports) {
$parcel$export(module.exports, "isNestedLayerFocused", () => $d4c1a10403905470$export$b9590fdfeb5f722f);

var $aMYjD = parcelRequire("aMYjD");
function $d4c1a10403905470$export$b9590fdfeb5f722f(_ref) {
    var container = _ref.container;
    var focused = container.ownerDocument.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return (0, $aMYjD.getClosestLayer)({
        element: focused
    }) !== (0, $aMYjD.getClosestLayer)({
        element: container
    });
}

});


parcelRegister("gNnJe", function(module, exports) {
$parcel$export(module.exports, "useInitialFocus", () => $c3a3a0ebbc5251b1$export$e992c40175757a22);

var $5FkrB = parcelRequire("5FkrB");

var $fANl5 = parcelRequire("fANl5");
/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox regardless of role. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, or menu), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
var $c3a3a0ebbc5251b1$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $c3a3a0ebbc5251b1$var$isTextboxLikeElement(element) {
    var role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    var tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        var _element$getAttribute;
        var type = ((_element$getAttribute = element.getAttribute('type')) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : 'text').toLowerCase();
        return $c3a3a0ebbc5251b1$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $c3a3a0ebbc5251b1$var$isComboboxControllingPopup(_ref) {
    var _active$getAttribute;
    var container = _ref.container;
    var ownerDocument = container.ownerDocument;
    var active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$c3a3a0ebbc5251b1$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    var idRefs = (_active$getAttribute = active.getAttribute('aria-controls')) !== null && _active$getAttribute !== void 0 ? _active$getAttribute : active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    var referencedIds = idRefs.split(/\s+/).filter(function(id) {
        return id !== '';
    });
    return referencedIds.some(function(id) {
        var referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function $c3a3a0ebbc5251b1$var$getInitialFocusTarget(_ref2) {
    var container = _ref2.container, role = _ref2.role;
    if (role === 'dialog' || role === 'alertdialog') {
        // Prefer element with the native HTML autofocus attribute.
        var autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $fANl5.getFirstFocusable)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific (menu / listbox) rather
    // than hoisted. Hoisting it over-matched on dialog popups that contain
    // a nested combobox (e.g. datetime-picker's dialog hosts a react-select),
    // where the active combobox's `aria-controls` falsely matched the
    // container and suppressed the dialog's own focus contract.
    if (role === 'menu') {
        if ($c3a3a0ebbc5251b1$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/outputs/menu-keyboard-decision.md
        return (0, $fANl5.getFirstFocusable)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($c3a3a0ebbc5251b1$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        var selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        var firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $fANl5.getFirstFocusable)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $c3a3a0ebbc5251b1$export$e992c40175757a22(_ref3) {
    var elementRef = _ref3.elementRef, phase = _ref3.phase, role = _ref3.role;
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    var prevPhaseRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var _getInitialFocusTarge;
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        var element = elementRef.current;
        if (!element) return;
        (_getInitialFocusTarge = $c3a3a0ebbc5251b1$var$getInitialFocusTarget({
            container: element,
            role: role
        })) === null || _getInitialFocusTarge === void 0 || _getInitialFocusTarge.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}

});


parcelRegister("elQ7X", function(module, exports) {
$parcel$export(module.exports, "useAnchoredPopover", () => $a72b7646da3451df$export$147d8888d96bf7a3);
/**
 * Positioning AND anchor-relative sizing for top-layer popovers. Anchors an
 * ELEMENT; to anchor a viewport coordinate use `useAnchoredPopoverAtPoint`.
 *
 * Two runtime paths, each a function that applies its styles and returns the
 * cleanup: CSS Anchor Positioning in `./anchor-positioning`, and the JavaScript
 * fallback in `./javascript-fallback`. The path is resolved ONCE, at the top of
 * the hook, and threaded through positioning, sizing and margins.
 *
 * See `notes/architecture/positioning.md` and
 * `notes/decisions/fit-available-space.md`.
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $h8qvJ = parcelRequire("h8qvJ");

var $bNPwE = parcelRequire("bNPwE");

var $djPv8 = parcelRequire("djPv8");

var $g6ocn = parcelRequire("g6ocn");

var $l1oyc = parcelRequire("l1oyc");

var $6bmix = parcelRequire("6bmix");

var $2jAwj = parcelRequire("2jAwj");
/**
 * Which way the popover's inline axis runs. Maps every physical measurement below
 * onto a logical axis: the viewport unit of each cap and the anchor's measured
 * size. A style read, not a layout read, so it is cheap enough to take for every
 * popover.
 */ function $a72b7646da3451df$var$getPopoverWritingMode(_ref) {
    var popover = _ref.popover;
    // `String()` because not every test environment implements `writing-mode`.
    var writingMode = String(getComputedStyle(popover).writingMode);
    var isVertical = writingMode.startsWith('vertical') || writingMode.startsWith('sideways');
    return isVertical ? 'vertical' : 'horizontal';
}
/**
 * Measured stand-in for `anchor-size(self-*)`, used wherever `anchor-size()` is
 * not: the JavaScript fallback, and browsers with anchor positioning but no
 * `anchor-size()`.
 *
 * `offsetWidth` / `offsetHeight` are physical, so the axis is picked from the
 * POPOVER's `writing-mode`. Deliberately not memoized: a cached anchor size is a
 * stale one. Runs once per effect, not per frame.
 */ function $a72b7646da3451df$var$measureAnchorSize(_ref2) {
    var anchor = _ref2.anchor, writingMode = _ref2.writingMode;
    if (writingMode === 'vertical') return {
        inline: "".concat(anchor.offsetHeight, "px"),
        block: "".concat(anchor.offsetWidth, "px")
    };
    return {
        inline: "".concat(anchor.offsetWidth, "px"),
        block: "".concat(anchor.offsetHeight, "px")
    };
}
var $a72b7646da3451df$var$NO_ANCHOR_SIZE = {
    inline: null,
    block: null
};
var $a72b7646da3451df$var$CSS_ANCHOR_SIZE = {
    inline: 'anchor-size(self-inline)',
    block: 'anchor-size(self-block)'
};
function $a72b7646da3451df$var$isAnchorRelative(size) {
    return size === 'match-anchor' || size === 'min-anchor';
}
/**
 * The `anchor-name` written to an anchor that does not already carry one, as a CSS
 * `<dashed-ident>`. `useId()` is the same source as every other id in the design
 * system, including the popover's own `id` that `aria-controls` and `popovertarget`
 * point at, so it is unique exactly where those are and collides exactly where
 * they do. See `useAnchoredPopover` for the one case that needs the host's help.
 *
 * `@atlaskit/ds-lib`'s `useId` already swaps React's `:` and `«»` for `_`. The
 * replace covers a host `identifierPrefix`, which may carry characters a
 * `<dashed-ident>` cannot.
 */ function $a72b7646da3451df$var$useNewAnchorName() {
    var id = (0, $h8qvJ.useId)();
    return (0, $5FkrB.useMemo)(function() {
        return "--anchor-".concat(id.replace(/[^A-Za-z0-9_-]/g, '_'));
    }, [
        id
    ]);
}
/**
 * A referentially-stable, fully-resolved `TPlacement`, so a fresh inline
 * `placement` object does not re-run the effect.
 */ function $a72b7646da3451df$var$useStablePlacement(placement) {
    var resolved = (0, $l1oyc.resolvePlacement)({
        placement: placement
    });
    var axis = resolved.axis;
    var edge = resolved.edge;
    var align = resolved.align;
    var minSize = resolved.minSize;
    var gap = resolved.offset.gap;
    var shiftValue = resolved.offset.crossAxisShift.value;
    var shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuilt from primitive deps, so the factory does not close over `resolved`
    // and exhaustive-deps can verify it.
    return (0, $5FkrB.useMemo)(function() {
        return {
            axis: axis,
            edge: edge,
            align: align,
            minSize: minSize,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        };
    }, [
        axis,
        edge,
        align,
        minSize,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $a72b7646da3451df$export$147d8888d96bf7a3(_ref3) {
    var anchorRef = _ref3.anchorRef, popoverRef = _ref3.popoverRef, placement = _ref3.placement, isOpen = _ref3.isOpen, _ref3$isEnabled = _ref3.isEnabled, isEnabled = _ref3$isEnabled === void 0 ? true : _ref3$isEnabled, _ref3$inlineSize = _ref3.inlineSize, inlineSize = _ref3$inlineSize === void 0 ? 'content' : _ref3$inlineSize, _ref3$blockSize = _ref3.blockSize, blockSize = _ref3$blockSize === void 0 ? 'content' : _ref3$blockSize, _ref3$shouldPreserveI = _ref3.shouldPreserveInlineSize, shouldPreserveInlineSize = _ref3$shouldPreserveI === void 0 ? false : _ref3$shouldPreserveI, _ref3$forceFallbackPo = _ref3.forceFallbackPositioning, forceFallbackPositioning = _ref3$forceFallbackPo === void 0 ? false : _ref3$forceFallbackPo;
    // Stable for the life of the hook instance, so it follows a replacement anchor
    // element (the point hook remounts its `<div>`).
    var fallbackAnchorName = $a72b7646da3451df$var$useNewAnchorName();
    var stablePlacement = $a72b7646da3451df$var$useStablePlacement(placement);
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!isEnabled) return;
        // Resolved once, so positioning, sizing and margins cannot disagree about it.
        var isUsingCssAnchorPositioning = (0, $6bmix.supportsAnchorPositioning)() && !forceFallbackPositioning;
        // BOTH probes: a browser can have positioning without sizing, and
        // `anchor-size()` needs the `position-anchor` only the CSS path writes.
        var canUseAnchorSize = isUsingCssAnchorPositioning && (0, $2jAwj.supportsAnchorSize)();
        var trigger = anchorRef.current;
        var popover = popoverRef.current;
        if (!trigger || !popover) return;
        // Fitting also reserves padding from the viewport edge as a margin.
        var isFitting = inlineSize === 'max-available' || blockSize === 'max-available';
        // Always read: the viewport caps are always written, and their unit follows
        // the popover's writing mode.
        var writingMode = $a72b7646da3451df$var$getPopoverWritingMode({
            popover: popover
        });
        // Skipped where possible, so a position-only consumer pays no layout read.
        // Fitting on the CSS path needs it to clamp the default flip floor; see
        // `getDefaultPlacementAxisFloor`.
        var needsAnchorSize = $a72b7646da3451df$var$isAnchorRelative(inlineSize) || $a72b7646da3451df$var$isAnchorRelative(blockSize) || isFitting && isUsingCssAnchorPositioning;
        var anchorSize = needsAnchorSize ? canUseAnchorSize ? $a72b7646da3451df$var$CSS_ANCHOR_SIZE : $a72b7646da3451df$var$measureAnchorSize({
            anchor: trigger,
            writingMode: writingMode
        }) : $a72b7646da3451df$var$NO_ANCHOR_SIZE;
        var sizeStyles = (0, $djPv8.getAnchoredPopoverSizeDeclarations)({
            placement: stablePlacement,
            inlineSize: inlineSize,
            blockSize: blockSize,
            isUsingCssAnchorPositioning: isUsingCssAnchorPositioning,
            anchorSize: anchorSize,
            writingMode: writingMode,
            shouldPreserveInlineSize: shouldPreserveInlineSize
        });
        if (isUsingCssAnchorPositioning) return (0, $bNPwE.applyAnchorPositioning)({
            anchor: trigger,
            popover: popover,
            placement: stablePlacement,
            sizeStyles: sizeStyles,
            isFitting: isFitting,
            fallbackAnchorName: fallbackAnchorName
        });
        return (0, $g6ocn.applyJavaScriptFallbackPositioning)({
            anchor: trigger,
            popover: popover,
            placement: stablePlacement,
            sizeStyles: sizeStyles
        });
    }, [
        isEnabled,
        anchorRef,
        popoverRef,
        stablePlacement,
        inlineSize,
        blockSize,
        shouldPreserveInlineSize,
        fallbackAnchorName,
        forceFallbackPositioning,
        isOpen
    ]);
}

});
parcelRegister("bNPwE", function(module, exports) {
$parcel$export(module.exports, "applyAnchorPositioning", () => $897c3d3a16126728$export$50da8074e1408934);

var $fC8ib = parcelRequire("fC8ib");

var $3huvO = parcelRequire("3huvO");

var $8Ta8d = parcelRequire("8Ta8d");

var $5Qkj5 = parcelRequire("5Qkj5");

var $aNKWr = parcelRequire("aNKWr");

var $4WZav = parcelRequire("4WZav");

var $5c63r = parcelRequire("5c63r");

var $lEJx4 = parcelRequire("lEJx4");
function $897c3d3a16126728$export$50da8074e1408934(_ref) {
    var anchor = _ref.anchor, popover = _ref.popover, placement = _ref.placement, sizeStyles = _ref.sizeStyles, isFitting = _ref.isFitting, fallbackAnchorName = _ref.fallbackAnchorName;
    // Reuse rather than mint: another popover may already be anchored to it, or a
    // CONSUMER may have set it on their own element, as `post-office` does.
    var existingAnchorName = (0, $4WZav.getExistingAnchorName)(anchor);
    var anchorName = existingAnchorName !== null && existingAnchorName !== void 0 ? existingAnchorName : fallbackAnchorName;
    var gap = (0, $5Qkj5.edgeMargin)({
        placement: placement,
        offset: placement.offset.gap
    });
    var crossAxisShift = (0, $8Ta8d.crossAxisShiftMargins)({
        placement: placement,
        crossAxisShiftCssValue: placement.offset.crossAxisShift.value,
        direction: placement.offset.crossAxisShift.direction
    });
    var popoverStyles = [
        {
            property: 'position-anchor',
            value: anchorName
        },
        {
            property: 'position-area',
            value: (0, $5c63r.placementToPositionArea)({
                placement: placement
            })
        },
        {
            property: 'position-try-fallbacks',
            value: (0, $lEJx4.placementToTryFallbacks)({
                placement: placement
            })
        },
        /**
   * **`position-visibility: always`**
   *
   * `position-visibility` is used to control the visibility of an anchored
   * popover based on the visibility of the element being anchored to (the target).
   *
   * Default `position-visibility` value: `anchors-visible` → hide the anchored
   * popover when the target is fully clipped by an ancestor (eg a scroll container)
   * or is `visibility:hidden`.
   * Sadly this "automatic hiding" does not actually "close" the popover,
   * so things like `:popover-open` are still active, even though the popover
   * is no longer painted and no longer receives pointer input. Chrome keeps it
   * focusable and in the accessibility tree, so keyboard and screen reader users
   * can still land inside a surface that is not painted.
   * Per-engine behaviour: `notes/decisions/position-visibility-always.md`.
   *
   * Generally we have not run into issues with the default (`anchors-visible`)
   *
   * Exceptions:
   *  - Target is intentionally not visible (eg `position:absolute` moving it outside of
   *    its parent's "clipped boundary", or a `visibility:hidden` trigger)
   *  - A trigger is scrolled out of its scroll container while the popover is open.
   *
   * We are switching from `anchors-visible` → `always` _for now_ to force no
   * automatic hiding of the popover. There seems to be no compelling reason to use
   * the default value. If one arises in the future, we could look towards making
   *  this behaviour configurable.
   */ {
            property: 'position-visibility',
            value: 'always'
        },
        // Reset browser default popover positioning that conflicts
        // with anchor positioning (UA: `inset: 0; margin: auto;`)
        {
            property: 'margin',
            value: '0'
        },
        {
            property: 'inset',
            value: 'auto'
        },
        gap
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(isFitting ? (0, $aNKWr.getFitMarginDeclarations)({
        placement: placement,
        crossAxisShiftMargins: crossAxisShift
    }) : crossAxisShift), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sizeStyles));
    // Anchor names are never cleaned up: multiple popovers can share an anchor,
    // and even with reference counting an async React update could remove the name
    // while something else still uses it. See
    // `notes/decisions/anchor-name-lifetime.md`. Only written when minted: a name
    // from a stylesheet may be a list, which an inline copy of its first entry
    // would collapse.
    if (existingAnchorName === null) anchor.style.setProperty('anchor-name', anchorName);
    return (0, $3huvO.setStyle)({
        element: popover,
        styles: popoverStyles
    });
}

});
parcelRegister("3huvO", function(module, exports) {
$parcel$export(module.exports, "setStyle", () => $263aa0b8aa926efa$export$37a5fde709c1db82);
/**
 * A single inline style declaration.
 *
 * `TProperty` narrows the property name for callers that write a known, closed
 * set of properties. Narrowing it lets a record keyed on those same names be
 * checked for exhaustiveness at compile time, rather than silently resolving to
 * `undefined` for a name that was never mapped.
 */ /**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 */ function $263aa0b8aa926efa$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

});

parcelRegister("8Ta8d", function(module, exports) {
$parcel$export(module.exports, "crossAxisShiftMargins", () => $678b51af60839698$export$f7505ccec0897ae3);
/**
 * The cross-axis shift, written antisymmetrically on BOTH cross-axis sides rather
 * than as one margin. Do not collapse it to one side: a single margin widens the
 * margin box, so `anchor-center` displaces the border box by only half the value,
 * a `<position-area>` fallback sliding across the cross axis drops it entirely,
 * and the widened box changes where the popover is judged to overflow.
 *
 * A positive value always moves the popover toward the cross-axis END, so
 * `direction: 'forwards'` means the same thing for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 */ function $678b51af60839698$export$f7505ccec0897ae3(_ref) {
    var placement = _ref.placement, crossAxisShiftCssValue = _ref.crossAxisShiftCssValue, direction = _ref.direction;
    var crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    // `calc()` rather than JavaScript math, so opaque values such as design tokens
    // negate correctly.
    var negated = "calc(-1 * ".concat(crossAxisShiftCssValue, ")");
    var isForwards = direction === 'forwards';
    return [
        {
            property: "margin-".concat(crossAxis, "-start"),
            value: isForwards ? crossAxisShiftCssValue : negated
        },
        {
            property: "margin-".concat(crossAxis, "-end"),
            value: isForwards ? negated : crossAxisShiftCssValue
        }
    ];
}

});

parcelRegister("5Qkj5", function(module, exports) {
$parcel$export(module.exports, "edgeMargin", () => $44118f9b85d41d63$export$b94d052c6b40496);
/**
 * The margin that creates the gap between the popover and its anchor.
 */ function $44118f9b85d41d63$export$b94d052c6b40496(_ref) {
    var placement = _ref.placement, offset = _ref.offset;
    var axis = placement.axis, edge = placement.edge;
    // The side FACING the anchor is always opposite the placement edge.
    var anchorFacingEdge = edge === 'end' ? 'start' : 'end';
    return {
        property: "margin-".concat(axis, "-").concat(anchorFacingEdge),
        value: offset
    };
}

});

parcelRegister("aNKWr", function(module, exports) {
$parcel$export(module.exports, "getFitMarginDeclarations", () => $7dd2e499cbcb24c7$export$a7ffde4a856e8d8e);

var $fC8ib = parcelRequire("fC8ib");

var $djPv8 = parcelRequire("djPv8");
/**
 * Every logical margin property the fit recipe can write. Declared here and
 * imported by `edge-margin.tsx` and `cross-axis-shift-margins.tsx`: two
 * structurally identical declarations are interchangeable to the compiler, so a
 * divergence would surface only as a silently-ignored property name at
 * `setStyle`.
 */ /**
 * The cross-axis sides that face the viewport rather than the anchor, and so take
 * the reserved padding.
 *
 * A `span-*` cell aligns the popover's MARGIN box to the anchor's edge, so padding
 * on the anchor-facing side does not reserve space at the viewport: it insets the
 * border box from the edge the consumer asked it to line up with. A centred
 * popover has no anchor-facing side, and padding both keeps the shift pair
 * antisymmetric so `anchor-center` still centres.
 *
 * Known cost: the slide fallbacks do not swap the inline margins the way
 * `flip-inline` does, so a slid popover keeps its padding on the anchor side (or,
 * re-centred, sits 2.5px off centre). Alignment in the requested position wins.
 */ function $7dd2e499cbcb24c7$var$viewportFacingCrossAxisSides(_ref) {
    var align = _ref.align;
    if (align === 'center') return [
        'start',
        'end'
    ];
    // `align: 'start'` sits on the anchor's start edge and expands toward end.
    return [
        align === 'start' ? 'end' : 'start'
    ];
}
function $7dd2e499cbcb24c7$export$a7ffde4a856e8d8e(_ref2) {
    var placement = _ref2.placement, crossAxisShiftMargins = _ref2.crossAxisShiftMargins;
    var crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    var paddedProperties = new Set($7dd2e499cbcb24c7$var$viewportFacingCrossAxisSides({
        align: placement.align
    }).map(function(side) {
        return "margin-".concat(crossAxis, "-").concat(side);
    }));
    return [
        {
            property: "margin-".concat(placement.axis, "-").concat(placement.edge),
            value: (0, $djPv8.VIEWPORT_PADDING)
        }
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(crossAxisShiftMargins.map(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        return paddedProperties.has(property) ? {
            property: property,
            value: "calc(".concat(value, " + ").concat((0, $djPv8.VIEWPORT_PADDING), ")")
        } : {
            property: property,
            value: value
        };
    })));
}

});
parcelRegister("djPv8", function(module, exports) {
$parcel$export(module.exports, "VIEWPORT_PADDING", () => $9b24ffc256ae44ea$export$9f2fdbacbc62226e);
$parcel$export(module.exports, "getAnchoredPopoverSizeDeclarations", () => $9b24ffc256ae44ea$export$860b30329fa0b990);
/**
 * The space kept clear between a popover and the viewport edge. Matches legacy
 * `@atlaskit/popper`'s `preventOverflow` padding of `5`.
 */ var $9b24ffc256ae44ea$export$9f2fdbacbc62226e = '5px';
var $9b24ffc256ae44ea$export$32ab78b2bb853a01 = '150px';
/**
 * Which way the POPOVER's inline axis runs; `'vertical'` covers the `vertical-*`
 * and `sideways-*` writing modes. Measured rather than assumed, because every
 * logical property this module writes resolves against the popover's own writing
 * mode, and so must the viewport unit paired with it.
 */ /**
 * The dynamic viewport unit for one of the popover's axes. Not `dvi` / `dvb`:
 * css-values-4 defines those against the ROOT element's writing mode, while the
 * `max-{axis}-size` they are written to follows the popover's, so a popover in a
 * `vertical-rl` subtree of a horizontal document would be capped by the wrong
 * dimension.
 */ function $9b24ffc256ae44ea$var$viewportUnit(_ref) {
    var axis = _ref.axis, writingMode = _ref.writingMode;
    var isHorizontalAxis = axis === 'inline' === (writingMode === 'horizontal');
    return isHorizontalAxis ? 'dvw' : 'dvh';
}
/**
 * How one axis of an anchored popover is sized. Both axes take these four values
 * under identical rules.
 *
 * - `'content'`: sized by its content. Named after `flex-basis: content`; NOT
 *   `'auto'`, whose CSS meaning for a positioned box is shrink-to-fit, the very
 *   behaviour rule 4 removes.
 * - `'match-anchor'`: exactly the anchor's size on this axis.
 * - `'min-anchor'`: at least the anchor's size on this axis, free to grow.
 * - `'max-available'`: at most the space between the anchor and the viewport
 *   edge, content-sized below that. Capped by the `position-area` cell on the
 *   placement axis and by the viewport on the cross axis (a `span-*` cell is
 *   narrower than the viewport, so capping to it would wrap content that fits on
 *   screen).
 *
 * Four rules apply on top:
 *
 * 1. Fitting one axis fills a `'content'` other axis with `'max-available'` too.
 *    An explicit value is never overridden, so caps stay strictly per-axis.
 * 2. Fitting either axis floors the placement axis, because flipping is a
 *    whole-popover outcome. See `getPlacementAxisFloor`.
 * 3. The viewport cap is unconditional, so a non-fitting axis still cannot
 *    overhang the screen. `'max-available'` and `'content'` are therefore
 *    indistinguishable on the cross axis.
 * 4. A non-anchor-relative inline axis gets `inline-size: max-content`. Under
 *    `position-area` the containing block is the cell, so a CSS `auto` inline
 *    size shrink-to-fits a too-narrow cell and WRAPS into it, never overflowing
 *    and so never sliding to the roomier side. The caps still beat it, because a
 *    max beats a definite size. Not needed on the block axis, which does not
 *    wrap, nor on the JavaScript fallback, whose containing block is the
 *    viewport. Consumers opt out with `shouldPreserveInlineSize`.
 *
 * See `notes/decisions/fit-available-space.md`.
 */ /**
 * Narrowed rather than `string`, so a typo cannot reach `setStyle` as a
 * silently-ignored property name.
 */ /**
 * The anchor's size along each axis, as a CSS length. `null` when nothing needs
 * it, so the measurement is skipped.
 *
 * The CSS path uses the `self-` keywords, whose axes are the POPOVER's, so each
 * value matches the axis of the property it is set on (`anchor-size(inline)` and
 * `anchor-size(width)` are both silently wrong in a vertical writing mode). The
 * JavaScript fallback uses a measured pixel length, because `anchor-size()` needs
 * a `position-anchor` that path never sets. See
 * `notes/decisions/width-from-anchor-floors.md`.
 */ function $9b24ffc256ae44ea$var$getCrossAxis(axis) {
    return axis === 'block' ? 'inline' : 'block';
}
/**
 * The whole viewport, less the reserved padding on both sides. Rule 3's backstop.
 */ function $9b24ffc256ae44ea$var$viewportCap(_ref2) {
    var axis = _ref2.axis, writingMode = _ref2.writingMode;
    return "calc(100".concat($9b24ffc256ae44ea$var$viewportUnit({
        axis: axis,
        writingMode: writingMode
    }), " - 2 * ").concat($9b24ffc256ae44ea$export$9f2fdbacbc62226e, ")");
}
/**
 * The position-area cell cap, for the placement axis only. The host carries
 * `position-area`, so per css-anchor-position-1 the cell is its containing block:
 * `100%` is the anchor edge to the viewport edge, and it follows whichever side
 * `position-try-fallbacks` settles on. Percentages do not subtract margins, so
 * the gap is subtracted here.
 *
 * Meaningless on the JavaScript fallback, whose containing block is the viewport,
 * so that path gets `viewportCap` on both axes.
 */ function $9b24ffc256ae44ea$var$cellCap(_ref3) {
    var gap = _ref3.gap;
    return "calc(100% - ".concat($9b24ffc256ae44ea$export$9f2fdbacbc62226e, " - ").concat(gap, ")");
}
/**
 * The anchor term of the placement-axis floor, and the one place it is capped.
 *
 * `'match-anchor'` earns a floor only where it can flip: a definite size clamps to
 * the cap and shrinks below the anchor instead of flipping.
 *
 * The `canFlip` clamp is deliberate both ways. With no flip in play an unclamped
 * floor beats `max-{axis}-size` (CSS resolves `min` last), making the viewport
 * backstop inert. With a flip in play, clamping would stop the floor exceeding
 * the cell cap, which is what drives the flip.
 */ function $9b24ffc256ae44ea$var$getPlacementAxisAnchorFloor(_ref4) {
    var placementAxis = _ref4.placementAxis, placementAxisSize = _ref4.placementAxisSize, anchorValue = _ref4.anchorValue, canFlip = _ref4.canFlip, writingMode = _ref4.writingMode;
    var hasAnchorFloor = placementAxisSize === 'min-anchor' || placementAxisSize === 'match-anchor' && canFlip;
    if (!hasAnchorFloor || anchorValue === null) return undefined;
    if (canFlip) return anchorValue;
    return "min(".concat(anchorValue, ", ").concat($9b24ffc256ae44ea$var$viewportCap({
        axis: placementAxis,
        writingMode: writingMode
    }), ")");
}
/**
 * The default flip floor, clamped so that SOME cell can always hold it.
 *
 * The two cells either side of the anchor add up to the viewport less the anchor,
 * so the roomier one is at least half of that. A floor whose margin box fits
 * inside that half is guaranteed a cell somewhere in the fallback chain.
 * Unclamped, a short viewport with a centred anchor has NO cell that holds
 * 150px: every try-fallback overflows, the browser reverts to the base position,
 * and the floor pushes the popover past the viewport edge.
 *
 * This is NOT the `min(floor, cellCap)` that suppresses flipping: it is relative
 * to the VIEWPORT, so a small base cell still overflows it. `max(0px, …)` states
 * the lower bound for an anchor taller than the viewport.
 */ function $9b24ffc256ae44ea$var$getDefaultPlacementAxisFloor(_ref5) {
    var placementAxis = _ref5.placementAxis, anchorValue = _ref5.anchorValue, gap = _ref5.gap, writingMode = _ref5.writingMode;
    if (anchorValue === null) return $9b24ffc256ae44ea$export$32ab78b2bb853a01;
    // The viewport term and the anchor term must measure the SAME axis; see
    // `viewportUnit`.
    var viewport = "100".concat($9b24ffc256ae44ea$var$viewportUnit({
        axis: placementAxis,
        writingMode: writingMode
    }));
    var halfOfRemainingViewport = "calc((".concat(viewport, " - ").concat(anchorValue, ") / 2 - ").concat(gap, " - ").concat($9b24ffc256ae44ea$export$9f2fdbacbc62226e, ")");
    return "min(".concat($9b24ffc256ae44ea$export$32ab78b2bb853a01, ", max(0px, ").concat(halfOfRemainingViewport, "))");
}
/**
 * The placement-axis floor: explicit minimums COMPOSE, the default does not.
 *
 * `placement.minSize` and the anchor term are both explicit requests, so they
 * compose as `max()`. `FALLBACK_MINIMUM_MAIN_AXIS_SIZE` never composes: it only
 * ever won by overriding a size the consumer asked for, and the anchor term drives
 * the flip on its own. Knock-on, intended: `minSize: 0` no longer removes an
 * anchor floor, because `max(0px, anchor)` IS the anchor.
 */ function $9b24ffc256ae44ea$var$getPlacementAxisFloor(_ref6) {
    var minSize = _ref6.minSize, placementAxis = _ref6.placementAxis, placementAxisSize = _ref6.placementAxisSize, anchorValue = _ref6.anchorValue, gap = _ref6.gap, canFlip = _ref6.canFlip, writingMode = _ref6.writingMode;
    var anchorFloor = $9b24ffc256ae44ea$var$getPlacementAxisAnchorFloor({
        placementAxis: placementAxis,
        placementAxisSize: placementAxisSize,
        anchorValue: anchorValue,
        canFlip: canFlip,
        writingMode: writingMode
    });
    if (minSize !== undefined) return anchorFloor === undefined ? minSize : "max(".concat(minSize, ", ").concat(anchorFloor, ")");
    if (anchorFloor !== undefined) return anchorFloor;
    if (!canFlip) return undefined;
    return $9b24ffc256ae44ea$var$getDefaultPlacementAxisFloor({
        placementAxis: placementAxis,
        anchorValue: anchorValue,
        gap: gap,
        writingMode: writingMode
    });
}
function $9b24ffc256ae44ea$export$860b30329fa0b990(_ref7) {
    var placement = _ref7.placement, inlineSize = _ref7.inlineSize, blockSize = _ref7.blockSize, isUsingCssAnchorPositioning = _ref7.isUsingCssAnchorPositioning, anchorSize = _ref7.anchorSize, writingMode = _ref7.writingMode, _ref7$shouldPreserveI = _ref7.shouldPreserveInlineSize, shouldPreserveInlineSize = _ref7$shouldPreserveI === void 0 ? false : _ref7$shouldPreserveI;
    var placementAxis = placement.axis;
    var crossAxis = $9b24ffc256ae44ea$var$getCrossAxis(placementAxis);
    // Rule 1. Feeds the per-axis CAPS only.
    var size = {
        inline: inlineSize === 'content' && blockSize === 'max-available' ? 'max-available' : inlineSize,
        block: blockSize === 'content' && inlineSize === 'max-available' ? 'max-available' : blockSize
    };
    // Rule 2 reads the requested values instead, un-mirrored: flipping is a
    // whole-popover outcome, so a fit request on either axis turns the floor on.
    var isFitting = inlineSize === 'max-available' || blockSize === 'max-available';
    // ...but only where the floor is what causes the flip. On the JavaScript
    // fallback a floor only inflates the measured size the side is picked from, so
    // it would flip a popover that fits.
    var canFlip = isFitting && isUsingCssAnchorPositioning;
    var declarations = [
        // Rule 3: both caps are always written. Only the placement axis can take the
        // cell cap.
        {
            property: "max-".concat(placementAxis, "-size"),
            value: size[placementAxis] === 'max-available' && isUsingCssAnchorPositioning ? $9b24ffc256ae44ea$var$cellCap({
                gap: placement.offset.gap
            }) : $9b24ffc256ae44ea$var$viewportCap({
                axis: placementAxis,
                writingMode: writingMode
            })
        },
        {
            property: "max-".concat(crossAxis, "-size"),
            value: $9b24ffc256ae44ea$var$viewportCap({
                axis: crossAxis,
                writingMode: writingMode
            })
        }
    ];
    // Rule 4. Only for a non-anchor-relative inline axis, so `'match-anchor'` below
    // stays the one writer of `inline-size` when it applies. CSS path only: the
    // fallback's containing block is the viewport, where shrink-to-fit already IS
    // the natural width for anything that fits on screen.
    if (isUsingCssAnchorPositioning && !shouldPreserveInlineSize && (size.inline === 'content' || size.inline === 'max-available')) declarations.push({
        property: 'inline-size',
        value: 'max-content'
    });
    // A max beats a definite size, so the caps above still win over this.
    for(var _i = 0, _arr = [
        placementAxis,
        crossAxis
    ]; _i < _arr.length; _i++){
        var axis = _arr[_i];
        var anchorValue = anchorSize[axis];
        if (size[axis] === 'match-anchor' && anchorValue !== null) declarations.push({
            property: "".concat(axis, "-size"),
            value: anchorValue
        });
    }
    var placementAxisFloor = $9b24ffc256ae44ea$var$getPlacementAxisFloor({
        minSize: placement.minSize,
        placementAxis: placementAxis,
        placementAxisSize: size[placementAxis],
        anchorValue: anchorSize[placementAxis],
        gap: placement.offset.gap,
        canFlip: canFlip,
        writingMode: writingMode
    });
    if (placementAxisFloor !== undefined) declarations.push({
        property: "min-".concat(placementAxis, "-size"),
        value: placementAxisFloor
    });
    // A size contract, not a flip driver, so it is clamped to the cap.
    var crossAxisAnchorValue = anchorSize[crossAxis];
    if (size[crossAxis] === 'min-anchor' && crossAxisAnchorValue !== null) declarations.push({
        property: "min-".concat(crossAxis, "-size"),
        value: "min(".concat(crossAxisAnchorValue, ", ").concat($9b24ffc256ae44ea$var$viewportCap({
            axis: crossAxis,
            writingMode: writingMode
        }), ")")
    });
    return declarations;
}

});


parcelRegister("4WZav", function(module, exports) {
$parcel$export(module.exports, "getExistingAnchorName", () => $39ac06ffbaca99b1$export$948d15b01d509455);
/**
 * The `anchor-name` an element already carries, or `null`. Computed as well as
 * inline, so a name set from a STYLESHEET is found: a minted inline name would
 * otherwise override it for every other rule anchored to that element.
 * `anchor-name` is a list and `position-anchor` takes one ident, so the first
 * name is the one to anchor to.
 */ function $39ac06ffbaca99b1$export$948d15b01d509455(element) {
    var declared = element.style.getPropertyValue('anchor-name') || getComputedStyle(element).getPropertyValue('anchor-name');
    var first = declared.split(',')[0].trim();
    return first !== '' && first !== 'none' ? first : null;
}

});

parcelRegister("5c63r", function(module, exports) {
$parcel$export(module.exports, "placementToPositionArea", () => $3c82c507518d64e6$export$de49b61f233ddeb9);
/**
 * Resolves a placement to CSS `position-area` syntax.
 *
 * The `align` field represents the *visual* alignment:
 * - `align: 'start'` means "aligned to the trigger's start edge" (left in LTR for block axis)
 * - `align: 'end'` means "aligned to the trigger's end edge"
 * - `align: 'center'` means centered (single-axis position-area)
 *
 * CSS `position-area` uses `span-*` keywords which indicate the *expansion direction*.
 * Visual start-alignment requires `span-{cross-axis}-end` (expand toward end = start-aligned).
 * This function handles the inversion internally.
 *
 * Takes the RESOLVED placement, which the hook threads through positioning,
 * sizing and margins alike, so nothing here can disagree with them.
 *
 * @example
 * // For a `block-end` placement, by `align`:
 * // 'center' → 'block-end'
 * // 'start'  → 'block-end span-inline-end'
 * // 'end'    → 'block-end span-inline-start'
 */ function $3c82c507518d64e6$export$de49b61f233ddeb9(_ref) {
    var placement = _ref.placement;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    var edgeValue = "".concat(axis, "-").concat(edge);
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    var spanDir = align === 'start' ? 'end' : 'start';
    return "".concat(edgeValue, " span-").concat(crossAxis, "-").concat(spanDir);
}

});

parcelRegister("lEJx4", function(module, exports) {
$parcel$export(module.exports, "placementToTryFallbacks", () => $fc40a72e330468a9$export$c4e16947a95d61f1);
/**
 * The placement axis joined to its edge, e.g. `block-end`.
 */ /**
 * The cells to slide to along one edge, on the cross axis.
 *
 * A try option is only worth listing if its margin box can fit where an earlier
 * one did not, and two options over the SAME cell have the same margin box and
 * the same fit result. That rules out three cells for an aligned placement: the
 * near span on the requested edge IS the base position-area, and on the opposite
 * edge the near and far spans are where `flip-{A}` and the diagonal flip land.
 *
 * A centred placement has no near or far, so it slides to both spans on both
 * edges.
 */ function $fc40a72e330468a9$var$slideOnEdge(_ref) {
    var align = _ref.align, edgeKey = _ref.edgeKey, crossAxis = _ref.crossAxis, isOppositeEdge = _ref.isOppositeEdge;
    if (align === 'center') return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-end"),
        "".concat(edgeKey, " span-").concat(crossAxis, "-start")
    ];
    if (isOppositeEdge) return [
        edgeKey
    ];
    // For `align: 'start'` the popover expands toward `end`, so the far span is
    // `start`; `align: 'end'` mirrors this.
    var far = align === 'start' ? 'start' : 'end';
    return [
        edgeKey,
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(far)
    ];
}
function $fc40a72e330468a9$var$flipDiagonally(_ref2) {
    var axis = _ref2.axis;
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    var flipToCrossAxis = axis === 'block' ? 'flip-inline' : 'flip-block';
    return "".concat(flipOnMainAxis, " ").concat(flipToCrossAxis);
}
function $fc40a72e330468a9$export$c4e16947a95d61f1(_ref3) {
    var placement = _ref3.placement;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    var flippedEdge = edge === 'start' ? 'end' : 'start';
    var sameEdgeArea = "".concat(axis, "-").concat(edge);
    var oppositeEdgeArea = "".concat(axis, "-").concat(flippedEdge);
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    return [
        $fc40a72e330468a9$var$slideOnEdge({
            align: align,
            edgeKey: sameEdgeArea,
            crossAxis: crossAxis,
            isOppositeEdge: false
        }),
        flipOnMainAxis,
        align !== 'center' ? $fc40a72e330468a9$var$flipDiagonally({
            axis: axis
        }) : null,
        $fc40a72e330468a9$var$slideOnEdge({
            align: align,
            edgeKey: oppositeEdgeArea,
            crossAxis: crossAxis,
            isOppositeEdge: true
        })
    ].filter(Boolean).flat().join(', ');
}

});


parcelRegister("g6ocn", function(module, exports) {
$parcel$export(module.exports, "applyJavaScriptFallbackPositioning", () => $bb8ffa3b0e112869$export$89babc4c2047d2ba);

var $fC8ib = parcelRequire("fC8ib");

var $7QpUe = parcelRequire("7QpUe");

var $45Zis = parcelRequire("45Zis");

var $4brzy = parcelRequire("4brzy");

var $3huvO = parcelRequire("3huvO");

var $wSmH1 = parcelRequire("wSmH1");

var $4blcj = parcelRequire("4blcj");

var $1iw4C = parcelRequire("1iw4C");
/**
 * Wrapped because jsdom throws on the unknown `:popover-open` selector.
 */ function $bb8ffa3b0e112869$var$isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch (_unused) {
        return false;
    }
}
/**
 * Observes the popover until its first non-zero layout, then self-disconnects;
 * ongoing movement is handled by the scroll and resize listeners. The popover is
 * `display: none` until `showPopover()`, and some browsers fire `toggle` before
 * layout, so RAF-after-toggle is unreliable.
 *
 * `null` where `ResizeObserver` is missing (non-DOM jest environments). There is
 * then no measurement to wait for, so the caller positions immediately and must
 * not hide the popover, because no reveal would follow.
 */ function $bb8ffa3b0e112869$var$createFirstLayoutObserver(_ref) {
    var popover = _ref.popover, onFirstLayout = _ref.onFirstLayout;
    if (typeof ResizeObserver === 'undefined') return null;
    try {
        var observer = new ResizeObserver(function() {
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                onFirstLayout();
                observer.disconnect();
            }
        });
        return observer;
    } catch (error) {
        (0, $1iw4C.warnFallbackFailure)({
            error: error
        });
        return null;
    }
}
function $bb8ffa3b0e112869$export$89babc4c2047d2ba(_ref2) {
    var anchor = _ref2.anchor, popover = _ref2.popover, placement = _ref2.placement, sizeStyles = _ref2.sizeStyles;
    // Already in the top layer via the `popover` attribute, so this only resets the
    // UA defaults and writes measured `top` / `left`.
    var cleanupBaseStyles = (0, $3huvO.setStyle)({
        element: popover,
        styles: [
            {
                property: 'margin',
                value: '0'
            },
            {
                property: 'inset',
                value: 'auto'
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sizeStyles))
    });
    // The popover can be consumer-owned (`@atlaskit/popper`'s `createPopper`),
    // so restore prior inline values rather than removing ours.
    var undoPosition;
    var undoHide;
    // Resolved once per open and per resize, reused across scrolls: resolving is a
    // full style and layout flush, and a scroll cannot change what a CSS length
    // resolves to. A resize can (viewport units), and so can a re-open (a token
    // retargeted while closed).
    var resolvedOffsets = null;
    function invalidateResolvedOffsets() {
        resolvedOffsets = null;
    }
    function getResolvedOffsets() {
        if (resolvedOffsets) return resolvedOffsets;
        // Probed INSIDE the popover: it is in the top layer, not the anchor's DOM
        // tree, so anywhere else resolves a token against a different scope.
        resolvedOffsets = {
            gap: (0, $4blcj.resolveCssLengthToPixels)({
                value: placement.offset.gap,
                container: popover
            }),
            crossAxisShift: (0, $4blcj.resolveCssLengthToPixels)({
                value: placement.offset.crossAxisShift.value,
                container: popover
            })
        };
        return resolvedOffsets;
    }
    function reveal() {
        var _undoHide;
        (_undoHide = undoHide) === null || _undoHide === void 0 || _undoHide();
        undoHide = undefined;
    }
    function restorePosition() {
        var _undoPosition;
        (_undoPosition = undoPosition) === null || _undoPosition === void 0 || _undoPosition();
        undoPosition = undefined;
    }
    // `opacity: 0` not `visibility: hidden`: Firefox skips visibility-hidden
    // elements during `<dialog>` initial-focus traversal.
    function hideUntilPositioned() {
        // Keep the first snapshot, else we capture our own `opacity: 0`.
        if (undoHide) return;
        undoHide = (0, $3huvO.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'opacity',
                    value: '0'
                }
            ]
        });
    }
    /**
   * Last resort. The base styles above reset the UA
   * `[popover] { inset: 0; margin: auto }`, so a popover with no `top` / `left`
   * sits in the viewport corner rather than centred.
   */ function centerInViewport() {
        restorePosition();
        undoPosition = (0, $3huvO.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'inset',
                    value: '0'
                },
                {
                    property: 'margin',
                    value: 'auto'
                }
            ]
        });
    }
    function update() {
        try {
            var triggerRect = anchor.getBoundingClientRect();
            var viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            var _getResolvedOffsets = getResolvedOffsets(), gap = _getResolvedOffsets.gap, crossAxisShift = _getResolvedOffsets.crossAxisShift;
            var _computeFallbackPosit = (0, $wSmH1.computeFallbackPosition)({
                triggerRect: triggerRect,
                popoverEl: popover,
                placement: placement,
                viewport: viewport,
                gap: gap,
                crossAxisShift: {
                    value: crossAxisShift,
                    direction: placement.offset.crossAxisShift.direction
                }
            }), top = _computeFallbackPosit.top, left = _computeFallbackPosit.left;
            // A non-finite coordinate serialises to a declaration the browser drops,
            // landing the popover in the corner just as silently as a throw would.
            if (!Number.isFinite(top) || !Number.isFinite(left)) {
                centerInViewport();
                return;
            }
            // Restore first so the snapshot stays the consumer's value.
            restorePosition();
            undoPosition = (0, $3huvO.setStyle)({
                element: popover,
                styles: [
                    {
                        property: 'top',
                        value: "".concat(top, "px")
                    },
                    {
                        property: 'left',
                        value: "".concat(left, "px")
                    }
                ]
            });
        } catch (error) {
            (0, $1iw4C.warnFallbackFailure)({
                error: error
            });
            // Anchoring needs the trigger geometry we just failed to get, so the
            // centred position is the only one left to degrade to.
            try {
                centerInViewport();
            } catch (_unused2) {}
        } finally{
            // Unconditional. A popover in the wrong place is recoverable on the
            // next scroll or resize; one left at `opacity: 0` is invisible forever.
            reveal();
        }
    }
    function invalidateAndUpdate() {
        invalidateResolvedOffsets();
        update();
    }
    // One update per animation frame. Scroll reuses the resolved offsets; resize
    // re-resolves them.
    var scheduledScrollUpdate = (0, $45Zis.default)(update);
    var scheduledResizeUpdate = (0, $45Zis.default)(invalidateAndUpdate);
    var firstLayoutObserver = $bb8ffa3b0e112869$var$createFirstLayoutObserver({
        popover: popover,
        onFirstLayout: update
    });
    function positionOnNextLayout() {
        // A token can have been retargeted while the popover was closed, so each
        // open re-resolves the offsets.
        invalidateResolvedOffsets();
        // No observer means no measurement is coming: position now, and do not
        // hide, because the reveal would never arrive.
        if (!firstLayoutObserver) {
            update();
            return;
        }
        hideUntilPositioned();
        firstLayoutObserver.observe(popover);
    }
    // The popover can already be open when this runs, in which case the initial
    // `toggle` has fired and the listener below would miss it.
    if ($bb8ffa3b0e112869$var$isPopoverOpen(popover)) positionOnNextLayout();
    return (0, $4brzy.combine)(cleanupBaseStyles, // Each open needs a fresh measurement, so hide and re-observe.
    (0, $7QpUe.bind)(popover, {
        type: 'toggle',
        listener: function listener(event) {
            var toggleEvent = event;
            if (toggleEvent.newState === 'open') positionOnNextLayout();
        }
    }), function() {
        return firstLayoutObserver === null || firstLayoutObserver === void 0 ? void 0 : firstLayoutObserver.disconnect();
    }, (0, $7QpUe.bind)(window, {
        type: 'scroll',
        listener: scheduledScrollUpdate,
        options: {
            capture: true,
            passive: true
        }
    }), (0, $7QpUe.bind)(window, {
        type: 'resize',
        listener: scheduledResizeUpdate,
        options: {
            passive: true
        }
    }), function() {
        scheduledScrollUpdate.cancel();
        scheduledResizeUpdate.cancel();
        restorePosition();
        reveal();
    });
}

});
parcelRegister("4brzy", function(module, exports) {
$parcel$export(module.exports, "combine", () => $30bd93d71af75ed8$export$1be1fc439b849fdf);
/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $30bd93d71af75ed8$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, cleanupFns = new Array(_len), _key = 0; _key < _len; _key++)cleanupFns[_key] = arguments[_key];
    return function cleanup() {
        cleanupFns.forEach(function(callback) {
            return callback === null || callback === void 0 ? void 0 : callback();
        });
    };
}

});

parcelRegister("wSmH1", function(module, exports) {
$parcel$export(module.exports, "computeFallbackPosition", () => $062d290869264803$export$d5ef1dac02135664);

var $25nEq = parcelRequire("25nEq");
function $062d290869264803$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $062d290869264803$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $062d290869264803$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $062d290869264803$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * A viewport-relative position, in pixels. Physical rather than logical
 * because it is written straight to `top` / `left`.
 */ /**
 * `TCrossAxisShiftOffset` with its CSS length already resolved to pixels. Only
 * this module needs the pixel form, because only this module does arithmetic.
 */ /**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function $062d290869264803$var$computeEdgePosition(_ref) {
    var axis = _ref.axis, edge = _ref.edge, triggerRect = _ref.triggerRect, popoverWidth = _ref.popoverWidth, popoverHeight = _ref.popoverHeight, viewport = _ref.viewport, gap = _ref.gap;
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        var spaceBelow = viewport.height - triggerRect.bottom;
        var spaceAbove = triggerRect.top;
        var fitsBelow = spaceBelow >= popoverHeight + gap;
        var useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        var _spaceAbove = triggerRect.top;
        var _spaceBelow = viewport.height - triggerRect.bottom;
        var fitsAbove = _spaceAbove >= popoverHeight + gap;
        var useAbove = fitsAbove || _spaceAbove >= _spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        var spaceRight = viewport.width - triggerRect.right;
        var spaceLeft = triggerRect.left;
        var fitsRight = spaceRight >= popoverWidth + gap;
        var useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        var _spaceLeft = triggerRect.left;
        var _spaceRight = viewport.width - triggerRect.right;
        var fitsLeft = _spaceLeft >= popoverWidth + gap;
        var useLeft = fitsLeft || _spaceLeft >= _spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function $062d290869264803$var$applyAlignment(_ref2) {
    var position = _ref2.position, axis = _ref2.axis, align = _ref2.align, triggerRect = _ref2.triggerRect, popoverWidth = _ref2.popoverWidth, popoverHeight = _ref2.popoverHeight;
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return $062d290869264803$var$_objectSpread($062d290869264803$var$_objectSpread({}, position), {}, {
            left: triggerRect.left
        });
        // align === 'end'
        return $062d290869264803$var$_objectSpread($062d290869264803$var$_objectSpread({}, position), {}, {
            left: triggerRect.right - popoverWidth
        });
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return $062d290869264803$var$_objectSpread($062d290869264803$var$_objectSpread({}, position), {}, {
        top: triggerRect.top
    });
    // align === 'end'
    return $062d290869264803$var$_objectSpread($062d290869264803$var$_objectSpread({}, position), {}, {
        top: triggerRect.bottom - popoverHeight
    });
}
/**
 * Applies the cross-axis shift offset. `forwards` always moves the popover
 * toward the cross-axis END, for every `align` value.
 *
 * Do not add a per-`align` sign inversion here. This is a coordinate, so the
 * direction is the sign and nothing else. The CSS path inverts only because an
 * END-side margin pushes a box the opposite way to a START-side one, which is a
 * property of margins.
 */ function $062d290869264803$var$applyCrossAxisShift(_ref3) {
    var position = _ref3.position, axis = _ref3.axis, crossAxisShift = _ref3.crossAxisShift;
    if (crossAxisShift.value === 0) return position;
    var directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    var delta = crossAxisShift.value * directionSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return $062d290869264803$var$_objectSpread($062d290869264803$var$_objectSpread({}, position), {}, {
        left: position.left + delta
    });
    return $062d290869264803$var$_objectSpread($062d290869264803$var$_objectSpread({}, position), {}, {
        top: position.top + delta
    });
}
function $062d290869264803$export$d5ef1dac02135664(_ref4) {
    var triggerRect = _ref4.triggerRect, popoverEl = _ref4.popoverEl, placement = _ref4.placement, viewport = _ref4.viewport, gap = _ref4.gap, crossAxisShift = _ref4.crossAxisShift;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    var popoverWidth = popoverEl.offsetWidth;
    var popoverHeight = popoverEl.offsetHeight;
    var basePosition = $062d290869264803$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    var alignedPosition = $062d290869264803$var$applyAlignment({
        position: basePosition,
        axis: axis,
        align: align,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    var shiftedPosition = $062d290869264803$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        crossAxisShift: crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}

});

parcelRegister("4blcj", function(module, exports) {
$parcel$export(module.exports, "resolveCssLengthToPixels", () => $30b8a1e71ad61973$export$98721546d2816d9e);

var $1iw4C = parcelRequire("1iw4C");
/**
 * `null` when the environment cannot measure at all.
 */ function $30b8a1e71ad61973$var$measureWithProbe(_ref) {
    var value = _ref.value, container = _ref.container;
    // Reached through the container rather than the global, so a popover in
    // another document still measures and one with no view degrades gracefully.
    var view = container.ownerDocument.defaultView;
    if (!view) return null;
    var probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hidden from assistive tech and event targeting; defensive against
    // `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    try {
        container.appendChild(probe);
        var resolved = parseFloat(view.getComputedStyle(probe).marginLeft);
        return Number.isFinite(resolved) ? resolved : 0;
    } catch (error) {
        (0, $1iw4C.warnFallbackFailure)({
            error: error
        });
        return null;
    } finally{
        // `remove()` rather than `removeChild()`: consumer code may already have
        // detached the probe, which must not throw out of a layout effect.
        probe.remove();
    }
}
function $30b8a1e71ad61973$export$98721546d2816d9e(_ref2) {
    var _measureWithProbe;
    var value = _ref2.value, container = _ref2.container;
    if (typeof value === 'number') return value;
    // Fast path: consumers occasionally pass `'0'` instead of the number `0`.
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from `resolvePlacement`, so this avoids
    // a reflow for the common case.
    var pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    return (_measureWithProbe = $30b8a1e71ad61973$var$measureWithProbe({
        value: value,
        container: container
    })) !== null && _measureWithProbe !== void 0 ? _measureWithProbe : 0;
}

});
parcelRegister("1iw4C", function(module, exports) {
$parcel$export(module.exports, "warnFallbackFailure", () => $0f205a016cca29fd$export$e142245b95267f17);

function $0f205a016cca29fd$export$e142245b95267f17(_ref) {
    var error = _ref.error;
    return;
}

});



parcelRegister("6bmix", function(module, exports) {
$parcel$export(module.exports, "supportsAnchorPositioning", () => $48051113e4d895eb$export$7192e63dfa9e8124);

var $ajdCt = parcelRequire("ajdCt");
var $48051113e4d895eb$export$7192e63dfa9e8124 = (0, $ajdCt.createCssDeclarationProbe)({
    property: 'anchor-name',
    value: '--a'
});

});
parcelRegister("ajdCt", function(module, exports) {
$parcel$export(module.exports, "createCssDeclarationProbe", () => $78163e4c6c215929$export$69de71b4b7c76bad);

var $bvsoE = parcelRequire("bvsoE");
function $78163e4c6c215929$export$69de71b4b7c76bad(_ref) {
    var property = _ref.property, value = _ref.value;
    return (0, $bvsoE.default)(function supportsCssDeclaration() {
        if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
        return CSS.supports(property, value);
    });
}

});


parcelRegister("2jAwj", function(module, exports) {
$parcel$export(module.exports, "supportsAnchorSize", () => $1af9af403b45d5b5$export$1c8dd0d1c9df9c6e);

var $ajdCt = parcelRequire("ajdCt");
var $1af9af403b45d5b5$export$1c8dd0d1c9df9c6e = (0, $ajdCt.createCssDeclarationProbe)({
    property: 'min-inline-size',
    value: 'anchor-size(self-inline)'
});

});


parcelRegister("eP9RN", function(module, exports) {
$parcel$export(module.exports, "useAnchoredPopoverAtPoint", () => $acad7b711c0e6ea2$export$3c5c8baff3ccd957);

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $elQ7X = parcelRequire("elQ7X");
var $acad7b711c0e6ea2$var$_excluded = [
    "getPoint",
    "isEnabled"
];
function $acad7b711c0e6ea2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $acad7b711c0e6ea2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $acad7b711c0e6ea2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $acad7b711c0e6ea2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * A point in viewport coordinates (CSS pixels). Axis-named rather than
 * edge-named, because viewport coordinates are always physical.
 */ /**
 * Appended to `document.body` to escape any transformed ancestor, which would
 * break viewport-relative resolution of `position: fixed`. `Object.assign`
 * rather than `setStyle`: we own the element, so there is nothing to restore.
 */ function $acad7b711c0e6ea2$var$mountAnchorElementAtPoint(_ref) {
    var point = _ref.point;
    var element = document.createElement('div');
    element.setAttribute('aria-hidden', 'true');
    Object.assign(element.style, {
        position: 'fixed',
        // Physical insets: `inset-inline-start` would need `viewportWidth - point.x`
        // in RTL.
        top: "".concat(point.y, "px"),
        left: "".concat(point.x, "px"),
        // Zero size, so placement alone decides which side the popover sits on.
        width: '0',
        height: '0',
        pointerEvents: 'none'
    });
    document.body.appendChild(element);
    return {
        element: element,
        cleanup: function cleanup() {
            element.remove();
        }
    };
}
function $acad7b711c0e6ea2$export$3c5c8baff3ccd957(_ref2) {
    var getPoint = _ref2.getPoint, _ref2$isEnabled = _ref2.isEnabled, isEnabled = _ref2$isEnabled === void 0 ? true : _ref2$isEnabled, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $acad7b711c0e6ea2$var$_excluded);
    var anchorRef = (0, $5FkrB.useRef)(null);
    // Latched, keyed on `isEnabled`: consumers read mutable refs inside `getPoint`,
    // so re-reading it would move an already-open popover, and keying on
    // `getPoint`'s identity would re-latch on every parent render.
    var getPointRef = (0, $5FkrB.useRef)(getPoint);
    getPointRef.current = getPoint;
    // Declared BEFORE `useAnchoredPopover` below, so the element exists when that
    // hook's effect reads the ref (React runs layout effects in source order). This
    // effect must not depend on anything the delegated effect does not: a dependency
    // here alone re-creates the element without that hook writing an `anchor-name`
    // onto it, and positioning silently dies.
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!isEnabled) return;
        var point = getPointRef.current();
        if (!point) return;
        var _mountAnchorElementAt = $acad7b711c0e6ea2$var$mountAnchorElementAtPoint({
            point: point
        }), element = _mountAnchorElementAt.element, unmountAnchorElement = _mountAnchorElementAt.cleanup;
        anchorRef.current = element;
        return function cleanup() {
            unmountAnchorElement();
            anchorRef.current = null;
        };
    // The latch. See `getPointRef` above: `getPoint` is deliberately absent.
    }, [
        isEnabled
    ]);
    (0, $elQ7X.useAnchoredPopover)($acad7b711c0e6ea2$var$_objectSpread($acad7b711c0e6ea2$var$_objectSpread({}, rest), {}, {
        anchorRef: anchorRef,
        isEnabled: isEnabled
    }));
}

});

parcelRegister("a3FU2", function(module, exports) {
$parcel$export(module.exports, "register", () => $752ab03f37f22fda$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $7QpUe = parcelRequire("7QpUe");
var $752ab03f37f22fda$var$registrations = new Set();
var $752ab03f37f22fda$var$cleanupEndEventListeners = null;
function $752ab03f37f22fda$var$onDragStart() {
    if ($752ab03f37f22fda$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $752ab03f37f22fda$var$cleanupEndEventListeners = (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragend',
            listener: $752ab03f37f22fda$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $752ab03f37f22fda$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $752ab03f37f22fda$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($752ab03f37f22fda$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $752ab03f37f22fda$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $752ab03f37f22fda$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $752ab03f37f22fda$var$cleanupEndEventListeners = null;
    var clone = Array.from($752ab03f37f22fda$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $752ab03f37f22fda$var$bindStartEvents() {
    return (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $752ab03f37f22fda$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $752ab03f37f22fda$var$onDragStart
        }
    ]);
}
var $752ab03f37f22fda$var$cleanupStartEventListeners = null;
function $752ab03f37f22fda$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$752ab03f37f22fda$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $752ab03f37f22fda$var$cleanupStartEventListeners = $752ab03f37f22fda$var$bindStartEvents();
    $752ab03f37f22fda$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $752ab03f37f22fda$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $752ab03f37f22fda$var$registrations.delete(registration);
        if ($752ab03f37f22fda$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $752ab03f37f22fda$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $752ab03f37f22fda$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("mgmjQ", function(module, exports) {
$parcel$export(module.exports, "getAnchorPoint", () => $042ebebdf3c8a5b8$export$d26fd3d066ede49);
/**
 * Returns the trigger's X edge for inline-axis placements, or the
 * trigger's horizontal center for block-axis placements.
 *
 * Note: does not account for RTL writing modes.
 */ function $042ebebdf3c8a5b8$var$getTriggerEdgeX(_ref) {
    var triggerRect = _ref.triggerRect, placement = _ref.placement;
    if (placement.axis === 'inline') return placement.edge === 'start' ? triggerRect.left : triggerRect.right;
    return triggerRect.left + triggerRect.width / 2;
}
/**
 * Returns the trigger's Y edge for block-axis placements, or the
 * trigger's vertical center for inline-axis placements.
 */ function $042ebebdf3c8a5b8$var$getTriggerEdgeY(_ref2) {
    var triggerRect = _ref2.triggerRect, placement = _ref2.placement;
    if (placement.axis === 'block') return placement.edge === 'start' ? triggerRect.top : triggerRect.bottom;
    return triggerRect.top + triggerRect.height / 2;
}
function $042ebebdf3c8a5b8$export$d26fd3d066ede49(_ref3) {
    var cursor = _ref3.cursor, triggerRect = _ref3.triggerRect, tooltipPosition = _ref3.tooltipPosition, placement = _ref3.placement;
    if (tooltipPosition === 'mouse-y') return {
        x: $042ebebdf3c8a5b8$var$getTriggerEdgeX({
            triggerRect: triggerRect,
            placement: placement
        }),
        y: cursor.clientY
    };
    if (tooltipPosition === 'mouse-x') return {
        x: cursor.clientX,
        y: $042ebebdf3c8a5b8$var$getTriggerEdgeY({
            triggerRect: triggerRect,
            placement: placement
        })
    };
    // tooltipPosition === 'mouse'
    return {
        x: cursor.clientX,
        y: cursor.clientY
    };
}

});

parcelRegister("jWW4h", function(module, exports) {
$parcel$export(module.exports, "getVirtualElementFromMousePos", () => $e8607a2d873b3355$export$2e68479e0a5d8746);
function $e8607a2d873b3355$export$2e68479e0a5d8746(mousePos, _ref) {
    var targetElement = _ref.targetElement, tooltipPosition = _ref.tooltipPosition;
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            });
        }
    };
    var targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            });
        }
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            });
        }
    };
    throw new Error("Invalid tooltip position for virtual element: ".concat(tooltipPosition));
}

});

parcelRegister("2NaAU", function(module, exports) {
$parcel$export(module.exports, "show", () => $20886030c0da208f$export$57bf213be019eeb0);

var $50U6m = parcelRequire("50U6m");
var $20886030c0da208f$var$delayId = null;
function $20886030c0da208f$var$clearScheduled() {
    if ($20886030c0da208f$var$delayId != null) {
        window.clearTimeout($20886030c0da208f$var$delayId);
        $20886030c0da208f$var$delayId = null;
    }
}
function $20886030c0da208f$var$scheduleTimeout(fn, delay) {
    $20886030c0da208f$var$clearScheduled();
    $20886030c0da208f$var$delayId = window.setTimeout(function() {
        $20886030c0da208f$var$delayId = null;
        fn();
    }, delay);
}
// This file is a singleton for managing tooltips.
//
// Once we roll out top-layer and remove the legacy path, this manager can be simplified:
// - Singleton: Can be removed; the platform (popover="auto" or popover="hint") already enforces
//   only one tooltip open at a time.
// - Phase machine: Can be simplified; drop hide-animating and finishHideAnimation (legacy fade-out).
//   Use e.g. pending-show | visible | pending-hide with immediate hide.
// - API: Can drop or simplify mousePosition/mousePos if no longer needed; keep delay scheduling,
//   keep(), requestHide, abort, and minimal lifecycle.
var $20886030c0da208f$var$active = null;
function $20886030c0da208f$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($20886030c0da208f$var$active && $20886030c0da208f$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            $20886030c0da208f$var$clearScheduled();
            $20886030c0da208f$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            $20886030c0da208f$var$clearScheduled();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            $20886030c0da208f$var$clearScheduled();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        // Bug in legacy path: isImmediate hide requests are ignored during waiting-to-hide,
        // meaning Escape/scroll won't instantly dismiss a tooltip that's already fading out.
        // Gated fix: only apply the immediate-hide behavior under the top-layer flag for now.
        if (phase === 'waiting-to-hide') {
            if (isImmediate && (0, $50U6m.fg)('platform-dst-top-layer-tooltip')) immediatelyHideAndDone();
            return;
        }
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        $20886030c0da208f$var$scheduleTimeout(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function start() {
        var shouldAlwaysFadeIn = entry.shouldAlwaysFadeIn;
        var showImmediately = Boolean($20886030c0da208f$var$active && $20886030c0da208f$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($20886030c0da208f$var$active) {
            $20886030c0da208f$var$clearScheduled();
            $20886030c0da208f$var$active.entry.hide({
                isImmediate: true
            });
            $20886030c0da208f$var$active.entry.done();
            $20886030c0da208f$var$active = null;
        }
        // this tooltip is now the active tooltip
        $20886030c0da208f$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        $20886030c0da208f$var$scheduleTimeout(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePos: entry.source.type === 'mouse' ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}

});

parcelRegister("jr7hX", function(module, exports) {
$parcel$export(module.exports, "default", () => $e266314cb40581a7$export$2e2bcd8739ae039);

var $lQAki = parcelRequire("lQAki");
function $e266314cb40581a7$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $lQAki.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});
parcelRegister("lQAki", function(module, exports) {
$parcel$export(module.exports, "useIdSeed", () => $fe7aa1f51e629d74$export$6ee17796e3d70de2);

var $h8qvJ = parcelRequire("h8qvJ");
function $fe7aa1f51e629d74$export$6ee17796e3d70de2() {
    var uid = (0, $h8qvJ.useId)();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}

});


parcelRegister("HBQqj", function(module, exports) {
$parcel$export(module.exports, "default", () => $08315f6785ccbc22$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $cAEge = parcelRequire("cAEge");
var $08315f6785ccbc22$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $08315f6785ccbc22$var$TooltipContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut, role = _ref.role;
    return /*#__PURE__*/ $5FkrB.createElement((0, $cAEge.default), {
        ref: ref,
        style: style,
        className: (0, $970q7.default)([
            $08315f6785ccbc22$var$styles.base,
            truncate && $08315f6785ccbc22$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut,
        role: role
    }, children);
});
$08315f6785ccbc22$var$TooltipContainer.displayName = 'TooltipContainer';
var $08315f6785ccbc22$export$2e2bcd8739ae039 = $08315f6785ccbc22$var$TooltipContainer;

});
parcelRegister("cAEge", function(module, exports) {
$parcel$export(module.exports, "default", () => $92a813cf9d41da56$export$2e2bcd8739ae039);
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $9yrH2 = parcelRequire("9yrH2");
var $92a813cf9d41da56$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $92a813cf9d41da56$var$TooltipPrimitive = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut, _ref$role = _ref.role, role = _ref$role === void 0 ? 'tooltip' : _ref$role;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        role: role,
        className: (0, $970q7.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $5FkrB.createElement((0, $9yrH2.TooltipShortcut), {
        shortcut: shortcut
    })));
});
$92a813cf9d41da56$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $92a813cf9d41da56$export$2e2bcd8739ae039 = $92a813cf9d41da56$var$TooltipPrimitive;

});
parcelRegister("9yrH2", function(module, exports) {
$parcel$export(module.exports, "TooltipShortcut", () => $6f4cc550ae8ac983$export$5bcbc43c84236222);
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $6f4cc550ae8ac983$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
var $6f4cc550ae8ac983$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            $6f4cc550ae8ac983$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $5FkrB.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $970q7.default)([
                $6f4cc550ae8ac983$var$styles.shortcutSegment
            ])
        }, segment);
    }));
};

});




parcelRegister("e8kqY", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4a1a9cdc7bf2d54$export$2e2bcd8739ae039);
/* visually-hidden.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $a4a1a9cdc7bf2d54$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $a4a1a9cdc7bf2d54$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $970q7.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
$a4a1a9cdc7bf2d54$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $a4a1a9cdc7bf2d54$export$2e2bcd8739ae039 = $a4a1a9cdc7bf2d54$var$VisuallyHidden;

});

parcelRegister("abSTK", function(module, exports) {
$parcel$export(module.exports, "default", () => $76b58416a5044cb0$export$2e2bcd8739ae039);
/* button-base.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $hRJ5R = parcelRequire("hRJ5R");

var $iO8GM = parcelRequire("iO8GM");

var $gpUQB = parcelRequire("gpUQB");

var $h8qvJ = parcelRequire("h8qvJ");

var $50U6m = parcelRequire("50U6m");

var $btdNC = parcelRequire("btdNC");

var $e8kqY = parcelRequire("e8kqY");

var $9lDWQ = parcelRequire("9lDWQ");

var $gT1wL = parcelRequire("gT1wL");

var $iZn4f = parcelRequire("iZn4f");

var $cgjHo = parcelRequire("cgjHo");
var $76b58416a5044cb0$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $76b58416a5044cb0$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $76b58416a5044cb0$var$LOADING_LABEL = ', Loading';
var $76b58416a5044cb0$var$styles = {
    base: "_2rko1qi0 _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    interactiveMotion: "_v564k6bl _1ggl5xtf",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk187o _irr3187o _1di6187o",
    spacingCompact: "_2rko12b0 _1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $76b58416a5044cb0$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $76b58416a5044cb0$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
var $76b58416a5044cb0$var$rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31afz _9h8h15cr _1di61kru"
};
var $76b58416a5044cb0$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _9h8h1yd3",
    interactive: "_30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
var $76b58416a5044cb0$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
var $76b58416a5044cb0$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
var $76b58416a5044cb0$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $76b58416a5044cb0$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $76b58416a5044cb0$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
function(_ref, ref) {
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $76b58416a5044cb0$var$_excluded);
    var localRef = (0, $5FkrB.useRef)(null);
    var splitButtonContext = (0, $gT1wL.useSplitButtonContext)();
    var loadingLabelId = (0, $h8qvJ.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $gpUQB.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $76b58416a5044cb0$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $btdNC.Pressable), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $iO8GM.default)([
            localRef,
            ref
        ]),
        xcss: (0, $hRJ5R.cx)($76b58416a5044cb0$var$styles.base, isInteractive && (0, $50U6m.fg)('platform-dst-motion-uplift-button') && $76b58416a5044cb0$var$styles.interactiveMotion, appearance === 'default' && $76b58416a5044cb0$var$defaultStyles.root, appearance === 'default' && isInteractive && $76b58416a5044cb0$var$defaultStyles.interactive, appearance === 'primary' && $76b58416a5044cb0$var$primaryStyles.root, appearance === 'primary' && isInteractive && $76b58416a5044cb0$var$primaryStyles.interactive, appearance === 'rovo' && $76b58416a5044cb0$var$rovoStyles.root, appearance === 'rovo' && isInteractive && $76b58416a5044cb0$var$rovoStyles.interactive, appearance === 'warning' && $76b58416a5044cb0$var$warningStyles.root, appearance === 'warning' && isInteractive && $76b58416a5044cb0$var$warningStyles.interactive, appearance === 'danger' && $76b58416a5044cb0$var$dangerStyles.root, appearance === 'danger' && isInteractive && $76b58416a5044cb0$var$dangerStyles.interactive, appearance === 'discovery' && $76b58416a5044cb0$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $76b58416a5044cb0$var$discoveryStyles.interactive, appearance === 'subtle' && $76b58416a5044cb0$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $76b58416a5044cb0$var$subtleStyles.interactive, $76b58416a5044cb0$var$styles.linkDecorationUnset, isSelected && $76b58416a5044cb0$var$selectedStyles.root, isSelected && isSplitButton && $76b58416a5044cb0$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $76b58416a5044cb0$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $76b58416a5044cb0$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $76b58416a5044cb0$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $76b58416a5044cb0$var$selectedStyles.discovery, isDisabled && $76b58416a5044cb0$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $76b58416a5044cb0$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $76b58416a5044cb0$var$defaultStyles.disabled, spacing === 'compact' && $76b58416a5044cb0$var$styles.spacingCompact, // This must come after spacing compact styling as it overrides the border radius
        isCircle && !isSplitButton && $76b58416a5044cb0$var$styles.circle, shouldFitContainer && $76b58416a5044cb0$var$styles.fullWidth, hasIconBefore && $76b58416a5044cb0$var$styles.buttonIconBefore, hasIconAfter && $76b58416a5044cb0$var$styles.buttonIconAfter, isIconButton && $76b58416a5044cb0$var$styles.iconButton, isIconButton && spacing === 'compact' && $76b58416a5044cb0$var$styles.iconButtonCompact, isLoading && $76b58416a5044cb0$var$styles.loading, isSplitButton && $76b58416a5044cb0$var$styles.splitButton, isNavigationSplitButton && $76b58416a5044cb0$var$styles.navigationSplitButton),
        isDisabled: isDisabled,
        "aria-live": "polite"
    }, isLoading && {
        'aria-disabled': true
    }, {
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($76b58416a5044cb0$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $iZn4f.default)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9lDWQ.SplitButtonContext).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        className: (0, $970q7.default)([
            $76b58416a5044cb0$var$styles.loadingOverlay
        ])
    }, (0, $cgjHo.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e8kqY.default), {
        id: loadingLabelId
    }, $76b58416a5044cb0$var$LOADING_LABEL)));
});
var $76b58416a5044cb0$export$2e2bcd8739ae039 = $76b58416a5044cb0$var$ButtonBase;

});
parcelRegister("hRJ5R", function(module, exports) {
$parcel$export(module.exports, "cx", () => $d01a5d8bb96c5a7e$export$a274e22fb40f762e);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ parcelRequire("5FkrB");


var $Pd8py = parcelRequire("Pd8py");
var $d01a5d8bb96c5a7e$var$strictApi = (0, $Pd8py.createStrictAPI)();
var $d01a5d8bb96c5a7e$export$dbf350e5966cf602 = $d01a5d8bb96c5a7e$var$strictApi.css;
var $d01a5d8bb96c5a7e$export$eb1ecd84a24ee424 = $d01a5d8bb96c5a7e$var$strictApi.cssMap;
$d01a5d8bb96c5a7e$var$strictApi.cssMap;
var $d01a5d8bb96c5a7e$export$a274e22fb40f762e = $d01a5d8bb96c5a7e$var$strictApi.cx;
var $d01a5d8bb96c5a7e$var$XCSSProp = $d01a5d8bb96c5a7e$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 

});
parcelRegister("Pd8py", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", () => $099ef3ce425dd0d2$export$39716b4af53f4ad);

var $fExW7 = parcelRequire("fExW7");

var $hUFig = parcelRequire("hUFig");
function $099ef3ce425dd0d2$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $fExW7.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $fExW7.createStrictSetupError)();
        },
        cx: $hUFig.cx,
        XCSSProp () {
            throw (0, $fExW7.createStrictSetupError)();
        }
    };
}

});
parcelRegister("fExW7", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", () => $b654ea81990ec19e$export$c4df1cb0c2b4d77c);
const $b654ea81990ec19e$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $b654ea81990ec19e$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});



parcelRegister("gpUQB", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf3b13d9d73de104$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $bf3b13d9d73de104$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $5FkrB.useRef)(true);
    (0, $5FkrB.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("btdNC", function(module, exports) {
$parcel$export(module.exports, "Pressable", () => $859d1b6c2ad6603b$export$27c701ed9e449e99);
/* pressable.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $hUFig = parcelRequire("hUFig");

var $aLEtb = parcelRequire("aLEtb");

var $dsVPZ = parcelRequire("dsVPZ");

var $eVb4V = parcelRequire("eVb4V");

var $eqVaP = parcelRequire("eqVaP");

var $5yoeA = parcelRequire("5yoeA");
var $859d1b6c2ad6603b$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $859d1b6c2ad6603b$var$_excluded2 = [
    "className"
];
var $859d1b6c2ad6603b$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
var $859d1b6c2ad6603b$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $eVb4V.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $859d1b6c2ad6603b$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $aLEtb.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "22.5.1",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $859d1b6c2ad6603b$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement((0, $5yoeA.Focusable), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $dsVPZ.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $hUFig.cx)($859d1b6c2ad6603b$var$styles.root, isDisabled && $859d1b6c2ad6603b$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});

});
parcelRegister("dsVPZ", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $9cdac13a38ee471b$export$95df08bae54cb4df);
function $9cdac13a38ee471b$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use;
        var ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}

});


parcelRegister("9lDWQ", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContext", () => $6ce5101b12a1b7f3$export$4b86304b2c0d7e71);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5FkrB = parcelRequire("5FkrB");
var $6ce5101b12a1b7f3$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);

});

parcelRegister("gT1wL", function(module, exports) {
$parcel$export(module.exports, "useSplitButtonContext", () => $c4b2f7b93688fa74$export$47e2c6fdb142d947);

var $5FkrB = parcelRequire("5FkrB");

var $9lDWQ = parcelRequire("9lDWQ");
var $c4b2f7b93688fa74$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $5FkrB.useContext)((0, $9lDWQ.SplitButtonContext));
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("iZn4f", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd2fd13b7e17523c$export$2e2bcd8739ae039);
function $dd2fd13b7e17523c$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $dd2fd13b7e17523c$var$tabKeyCode = 9;
function $dd2fd13b7e17523c$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $dd2fd13b7e17523c$var$tabKeyCode) return;
    $dd2fd13b7e17523c$var$abort(event);
}
function $dd2fd13b7e17523c$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $dd2fd13b7e17523c$var$abort,
        onMouseUpCapture: $dd2fd13b7e17523c$var$abort,
        onKeyDownCapture: $dd2fd13b7e17523c$var$onKey,
        onKeyUpCapture: $dd2fd13b7e17523c$var$onKey,
        onTouchStartCapture: $dd2fd13b7e17523c$var$abort,
        onTouchEndCapture: $dd2fd13b7e17523c$var$abort,
        onPointerDownCapture: $dd2fd13b7e17523c$var$abort,
        onPointerUpCapture: $dd2fd13b7e17523c$var$abort,
        onClickCapture: $dd2fd13b7e17523c$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $dd2fd13b7e17523c$var$abort
    } : events;
}

});

parcelRegister("cgjHo", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ed64276c2b30505$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $9ztDu = parcelRequire("9ztDu");
function $8ed64276c2b30505$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $8ed64276c2b30505$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'rovo' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $8ed64276c2b30505$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9ztDu.default), {
        size: $8ed64276c2b30505$var$getIconSpacing(spacing),
        appearance: $8ed64276c2b30505$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});


parcelRegister("ccBRl", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e23f919bcd6960d$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $8e23f919bcd6960d$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $8e23f919bcd6960d$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        className: (0, $970q7.default)([
            $8e23f919bcd6960d$var$styles.common,
            type === 'text' && $8e23f919bcd6960d$var$styles.text,
            type === 'icon' && $8e23f919bcd6960d$var$styles.icon,
            isLoading && $8e23f919bcd6960d$var$styles.fade
        ])
    }, children);
};
var $8e23f919bcd6960d$export$2e2bcd8739ae039 = $8e23f919bcd6960d$var$Content;

});

parcelRegister("goIky", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf01465dd7c7d1ef$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $50U6m = parcelRequire("50U6m");
function $bf01465dd7c7d1ef$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $bf01465dd7c7d1ef$var$IconRenderer = function IconRenderer(_ref) {
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    var Icon = _ref.icon;
    var isRenderProp = $bf01465dd7c7d1ef$var$isIconRenderProp(Icon);
    var iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $50U6m.fg)('platform_dst_button_chevron_sizing') ? function(iconName) {
            return iconName.startsWith('Chevron') ? 'small' : 'medium';
        } : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, iconProps));
};
var $bf01465dd7c7d1ef$export$2e2bcd8739ae039 = $bf01465dd7c7d1ef$var$IconRenderer;

});


parcelRegister("ac8VW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe87206c037b1ad46cb54a88ca95fa3b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76c1f46438176f91$var$_react = $76c1f46438176f91$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $76c1f46438176f91$var$_iconNew = $76c1f46438176f91$var$_interopRequireDefault((parcelRequire("gDzom")));
function $76c1f46438176f91$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cross
 * Usage guidance:
 * Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76c1f46438176f91$var$CrossIcon = (props)=>/*#__PURE__*/ $76c1f46438176f91$var$_react.default.createElement($76c1f46438176f91$var$_iconNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.53 3.53 9.06 8l4.47 4.47-1.06 1.06L8 9.06l-4.47 4.47-1.06-1.06L6.94 8 2.47 3.53l1.06-1.06L8 6.94l4.47-4.47z"/>`
    }, props));
$76c1f46438176f91$var$CrossIcon.displayName = 'CrossIcon';
var $76c1f46438176f91$var$_default = module.exports.default = $76c1f46438176f91$var$CrossIcon;

});
parcelRegister("gDzom", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Icon", () => $c1cbbdf3204a3ef0$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $c1cbbdf3204a3ef0$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $c1cbbdf3204a3ef0$var$svgStyles = null;
var $c1cbbdf3204a3ef0$var$iconStyles = null;
var $c1cbbdf3204a3ef0$var$smallIconStyles = null;
var $c1cbbdf3204a3ef0$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $c1cbbdf3204a3ef0$var$baseHcmStyles = null;
var $c1cbbdf3204a3ef0$var$scaleSize = null;
var $c1cbbdf3204a3ef0$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c1cbbdf3204a3ef0$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c1cbbdf3204a3ef0$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $c1cbbdf3204a3ef0$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $c1cbbdf3204a3ef0$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $970q7.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $970q7.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $c1cbbdf3204a3ef0$var$coreSizeSmall[spacing] : $c1cbbdf3204a3ef0$var$coreSizeMedium[spacing]
        ])
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$c1cbbdf3204a3ef0$export$2e2bcd8739ae039 = $c1cbbdf3204a3ef0$export$f04a61298a47a40f;

});


parcelRegister("m5IEn", function(module, exports) {
$parcel$export(module.exports, "Inline", () => $04267de539304abd$export$fbae5b5ffd8af05e);
/* inline.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hRJ5R = parcelRequire("hRJ5R");

var $018Xo = parcelRequire("018Xo");
var $04267de539304abd$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $04267de539304abd$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $04267de539304abd$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            $04267de539304abd$var$styles.separator
        ])
    }, children);
};
var $04267de539304abd$export$fbae5b5ffd8af05e = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $04267de539304abd$var$_excluded);
    var separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $5FkrB.createElement($04267de539304abd$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $5FkrB.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $5FkrB.createElement((0, $018Xo.Flex), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $hRJ5R.cx)(grow === 'hug' && $04267de539304abd$var$styles.hug, grow === 'fill' && $04267de539304abd$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$04267de539304abd$export$fbae5b5ffd8af05e.displayName = 'Inline';

});
parcelRegister("018Xo", function(module, exports) {
$parcel$export(module.exports, "Flex", () => $00370acaba4d9627$export$f51f4c4ede09e011);
/* flex.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $00370acaba4d9627$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $00370acaba4d9627$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $00370acaba4d9627$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $00370acaba4d9627$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $00370acaba4d9627$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $00370acaba4d9627$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $00370acaba4d9627$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $00370acaba4d9627$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
var $00370acaba4d9627$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $00370acaba4d9627$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, ariaAttributes, {
        role: role,
        className: (0, $970q7.default)([
            $00370acaba4d9627$var$styles.root,
            gap && $00370acaba4d9627$var$columnGapMap[gap],
            columnGap && $00370acaba4d9627$var$columnGapMap[columnGap],
            gap && $00370acaba4d9627$var$rowGapMap[gap],
            rowGap && $00370acaba4d9627$var$rowGapMap[rowGap],
            alignItems && $00370acaba4d9627$var$alignItemsMap[alignItems],
            direction && $00370acaba4d9627$var$flexDirectionMap[direction],
            justifyContent && $00370acaba4d9627$var$justifyContentMap[justifyContent],
            wrap && $00370acaba4d9627$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$00370acaba4d9627$export$f51f4c4ede09e011.displayName = 'Flex';

});


parcelRegister("9FlpM", function(module, exports) {
$parcel$export(module.exports, "Stack", () => $70988de881688cbc$export$694e0d28c7ffc90c);
/* stack.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $hRJ5R = parcelRequire("hRJ5R");

var $018Xo = parcelRequire("018Xo");
var $70988de881688cbc$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "spread",
    "grow",
    "space",
    "children",
    "testId",
    "xcss",
    "role"
];
var $70988de881688cbc$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $70988de881688cbc$export$694e0d28c7ffc90c = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $70988de881688cbc$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement((0, $018Xo.Flex), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, ariaAttributes, {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $hRJ5R.cx)(grow === 'hug' && $70988de881688cbc$var$styles.hug, grow === 'fill' && $70988de881688cbc$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$70988de881688cbc$export$694e0d28c7ffc90c.displayName = 'Stack';

});

parcelRegister("cMVCI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b3cfa183fa168ea8c7cf286e27765b6f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $94f6aa88698e8a20$var$_react = $94f6aa88698e8a20$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $94f6aa88698e8a20$var$_iconNew = $94f6aa88698e8a20$var$_interopRequireDefault((parcelRequire("gDzom")));
function $94f6aa88698e8a20$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-error
 * Usage guidance:
 * Reserved for error statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $94f6aa88698e8a20$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $94f6aa88698e8a20$var$_react.default.createElement($94f6aa88698e8a20$var$_iconNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$94f6aa88698e8a20$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $94f6aa88698e8a20$var$_default = module.exports.default = $94f6aa88698e8a20$var$StatusErrorIcon;

});

parcelRegister("7bxOu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::341f1a6f1df1c6bee81376e850857e59>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $53b3ca20ba4a049e$var$_react = $53b3ca20ba4a049e$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $53b3ca20ba4a049e$var$_iconNew = $53b3ca20ba4a049e$var$_interopRequireDefault((parcelRequire("gDzom")));
function $53b3ca20ba4a049e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-information
 * Usage guidance:
 * Reserved for information statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $53b3ca20ba4a049e$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $53b3ca20ba4a049e$var$_react.default.createElement($53b3ca20ba4a049e$var$_iconNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$53b3ca20ba4a049e$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $53b3ca20ba4a049e$var$_default = module.exports.default = $53b3ca20ba4a049e$var$StatusInformationIcon;

});

parcelRegister("lcW9s", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fec260a5beb0e93db2111df1ab9a2e97>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f707d3a071331bf4$var$_react = $f707d3a071331bf4$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $f707d3a071331bf4$var$_iconNew = $f707d3a071331bf4$var$_interopRequireDefault((parcelRequire("gDzom")));
function $f707d3a071331bf4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-success
 * Usage guidance:
 * Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f707d3a071331bf4$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $f707d3a071331bf4$var$_react.default.createElement($f707d3a071331bf4$var$_iconNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$f707d3a071331bf4$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $f707d3a071331bf4$var$_default = module.exports.default = $f707d3a071331bf4$var$StatusSuccessIcon;

});

parcelRegister("lNKbd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd90c08a28534c92e68f27855e77fa64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fdf1fef12078b66f$var$_react = $fdf1fef12078b66f$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $fdf1fef12078b66f$var$_iconNew = $fdf1fef12078b66f$var$_interopRequireDefault((parcelRequire("gDzom")));
function $fdf1fef12078b66f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-warning
 * Usage guidance:
 * Reserved for warning statuses.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fdf1fef12078b66f$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $fdf1fef12078b66f$var$_react.default.createElement($fdf1fef12078b66f$var$_iconNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$fdf1fef12078b66f$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $fdf1fef12078b66f$var$_default = module.exports.default = $fdf1fef12078b66f$var$StatusWarningIcon;

});

parcelRegister("jgNUw", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0763a2a29633b85$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");

var $8cfv1 = parcelRequire("8cfv1");

var $74pZe = parcelRequire("74pZe");

var $6R7Di = parcelRequire("6R7Di");
var $e0763a2a29633b85$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $e0763a2a29633b85$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use `Button` from `@atlaskit/button/default/button`.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $e0763a2a29633b85$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $eVb4V.default) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $eVb4V.default) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $e0763a2a29633b85$var$_excluded);
    var isOnlySingleIcon = (0, $6R7Di.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    // in Firefox
    var onMouseDown = (0, $5FkrB.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($e0763a2a29633b85$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $5FkrB.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($e0763a2a29633b85$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $5FkrB.useMemo)(function() {
        return (0, $74pZe.getCss)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8cfv1.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$e0763a2a29633b85$var$Button.displayName = 'Button';
var $e0763a2a29633b85$export$2e2bcd8739ae039 = $e0763a2a29633b85$var$Button;

});
parcelRegister("8cfv1", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f7b778c870b53cc$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $aLEtb = parcelRequire("aLEtb");

var $eVb4V = parcelRequire("eVb4V");

var $gpUQB = parcelRequire("gpUQB");

var $75gwF = parcelRequire("75gwF");

var $eqVaP = parcelRequire("eqVaP");

var $f2dbC = parcelRequire("f2dbC");

var $k5by5 = parcelRequire("k5by5");

var $8dW9X = parcelRequire("8dW9X");

var $9mNc1 = parcelRequire("9mNc1");

var $kcV4s = parcelRequire("kcV4s");

var $c0nz8 = parcelRequire("c0nz8");
var $5f7b778c870b53cc$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $5f7b778c870b53cc$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out
 * and we bump Button to set padding based on the new icons.
 */ var $5f7b778c870b53cc$var$iconBeforeSpacingFixStyle = (0, $74Zh5.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $5f7b778c870b53cc$var$iconAfterSpacingFixStyle = (0, $74Zh5.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $5f7b778c870b53cc$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $kcV4s.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $5f7b778c870b53cc$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $kcV4s.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $74Zh5.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $5f7b778c870b53cc$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'default' : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? 'a' : 'button' : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $eVb4V.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $eVb4V.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 'default' : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? 'button' : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $5f7b778c870b53cc$var$_excluded);
    var ourRef = (0, $5FkrB.useRef)();
    var setRef = (0, $5FkrB.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $gpUQB.default)(ourRef, autoFocus);
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $aLEtb.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "25.3.5",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $5FkrB.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $5FkrB.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $74Zh5.css)((0, $8dW9X.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-warning-inverse, #292A2E)", " !important")
        }
    };
    return (0, $74Zh5.jsx)((0, $75gwF.default), null, (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $5f7b778c870b53cc$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $f2dbC.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $74Zh5.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $9mNc1.getIconStyle)({
                spacing: spacing
            }),
            $5f7b778c870b53cc$var$getSpacingFix(children, $5f7b778c870b53cc$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $5f7b778c870b53cc$var$getChildren(children, [
        fadeStyles,
        (0, $k5by5.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $74Zh5.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $9mNc1.getIconStyle)({
                spacing: spacing
            }),
            $5f7b778c870b53cc$var$getSpacingFix(children, $5f7b778c870b53cc$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $74Zh5.jsx)("span", {
        css: [
            (0, $c0nz8.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5f7b778c870b53cc$export$2e2bcd8739ae039 = $5f7b778c870b53cc$var$ButtonBase;

});
parcelRegister("75gwF", function(module, exports) {
$parcel$export(module.exports, "default", () => $5285d1b79b900e73$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- LENS1-245 tracks @atlaskit/focus-ring deprecation. */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
var $5285d1b79b900e73$var$BORDER_WIDTH = 2;
var $5285d1b79b900e73$var$baseFocusOutsideStyles = (0, $74Zh5.css)({
    outline: "var(--ds-border-width-focused, 2px)".concat(" solid ", "var(--ds-border-focused, #4688EC)"),
    outlineOffset: $5285d1b79b900e73$var$BORDER_WIDTH
});
var $5285d1b79b900e73$var$baseInsetStyles = (0, $74Zh5.css)({
    outlineColor: "var(--ds-border-focused, #4688EC)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$5285d1b79b900e73$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
var $5285d1b79b900e73$var$focusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $5285d1b79b900e73$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $5285d1b79b900e73$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: "var(--ds-border-width, 1px)".concat(" solid")
        }
    }
});
var $5285d1b79b900e73$var$insetFocusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $5285d1b79b900e73$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $5285d1b79b900e73$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: "var(--ds-border-width, 1px)".concat(" solid"),
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 *
 * @deprecated FocusRing is deprecated. Use Focusable from @atlaskit/primitives/compiled/focusable instead.
 */ var $5285d1b79b900e73$var$FocusRing = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $5285d1b79b900e73$var$baseInsetStyles : $5285d1b79b900e73$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $5285d1b79b900e73$var$insetFocusRingStyles : $5285d1b79b900e73$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $74Zh5.jsx)((0, $74Zh5.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $5FkrB.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $5FkrB.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$5285d1b79b900e73$var$FocusRing.displayName = 'FocusRing';
var $5285d1b79b900e73$export$2e2bcd8739ae039 = $5285d1b79b900e73$var$FocusRing;

});

parcelRegister("f2dbC", function(module, exports) {
$parcel$export(module.exports, "default", () => $af21457669944388$export$2e2bcd8739ae039);
function $af21457669944388$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $af21457669944388$var$tabKeyCode = 9;
function $af21457669944388$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $af21457669944388$var$tabKeyCode) return;
    $af21457669944388$var$abort(event);
}
var $af21457669944388$var$block = {
    onMouseDownCapture: $af21457669944388$var$abort,
    onMouseUpCapture: $af21457669944388$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $af21457669944388$var$onKey,
    onKeyUpCapture: $af21457669944388$var$onKey,
    onTouchStartCapture: $af21457669944388$var$abort,
    onTouchEndCapture: $af21457669944388$var$abort,
    onPointerDownCapture: $af21457669944388$var$abort,
    onPointerUpCapture: $af21457669944388$var$abort,
    onClickCapture: $af21457669944388$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $af21457669944388$var$abort
};
var $af21457669944388$var$doNotBlock = {};
function $af21457669944388$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $af21457669944388$var$doNotBlock : $af21457669944388$var$block;
}

});

parcelRegister("k5by5", function(module, exports) {
$parcel$export(module.exports, "getContentStyle", () => $e9ed3ba00a3e194a$export$7ad0316cc0dd65a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");
function $e9ed3ba00a3e194a$export$7ad0316cc0dd65a(_ref) {
    var spacing = _ref.spacing;
    return (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : '0 2px',
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}

});

parcelRegister("8dW9X", function(module, exports) {
$parcel$export(module.exports, "getFadingCss", () => $5fcca6eb305a9885$export$1b5827d324e945b1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");
function $5fcca6eb305a9885$export$1b5827d324e945b1(_ref) {
    var hasOverlay = _ref.hasOverlay;
    return (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}

});

parcelRegister("9mNc1", function(module, exports) {
$parcel$export(module.exports, "getIconStyle", () => $6d1c53d12ac7a727$export$864eea3f4ec3368f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");
function $6d1c53d12ac7a727$export$864eea3f4ec3368f(_ref) {
    var spacing = _ref.spacing;
    return (0, $74Zh5.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : "0 2px",
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}

});

parcelRegister("kcV4s", function(module, exports) {
$parcel$export(module.exports, "getIfVisuallyHiddenChildren", () => $eb6132b48d587eca$export$20bbd2efb0d734c4);

var $5FkrB = parcelRequire("5FkrB");

var $e8kqY = parcelRequire("e8kqY");
var $eb6132b48d587eca$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $5FkrB.isValidElement)(children) && children.type === (0, $e8kqY.default);
};

});

parcelRegister("c0nz8", function(module, exports) {
$parcel$export(module.exports, "overlayCss", () => $8bd7c3c4e645b70a$export$1a9fe1b84c876bb5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var $8bd7c3c4e645b70a$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});


parcelRegister("74pZe", function(module, exports) {
$parcel$export(module.exports, "getCss", () => $525d107f97649f51$export$955358618f994a11);

var $25nEq = parcelRequire("25nEq");

var $50U6m = parcelRequire("50U6m");
function $525d107f97649f51$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $525d107f97649f51$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $525d107f97649f51$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $525d107f97649f51$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $525d107f97649f51$var$gridSize = 8;
var $525d107f97649f51$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
var $525d107f97649f51$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: 'auto'
};
var $525d107f97649f51$var$lineHeights = {
    default: $525d107f97649f51$var$heights.default,
    compact: $525d107f97649f51$var$heights.compact,
    none: 'inherit'
};
var $525d107f97649f51$var$padding = {
    // 10px gutter
    default: "0 ".concat($525d107f97649f51$var$gridSize + $525d107f97649f51$var$gridSize / 4, "px"),
    compact: "0 ".concat($525d107f97649f51$var$gridSize + $525d107f97649f51$var$gridSize / 4, "px"),
    none: '0'
};
var $525d107f97649f51$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($525d107f97649f51$var$gridSize / 4, "px"),
    default: "0 ".concat($525d107f97649f51$var$gridSize / 4, "px"),
    none: '0'
};
var $525d107f97649f51$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var $525d107f97649f51$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
var $525d107f97649f51$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    }),
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $525d107f97649f51$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
var $525d107f97649f51$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    }
};
var $525d107f97649f51$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
var $525d107f97649f51$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    }
};
var $525d107f97649f51$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
var $525d107f97649f51$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $525d107f97649f51$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    })
};
/**
 * Anchor-text-color variants applied when the legacy `Button` is rendered as
 * an `<a>` (via `href`). Each `<variant>WithAnchorTextColorStyles` is a
 * self-contained appearance object that adds explicit `color` /
 * `text-decoration` on the base, `:hover`, and `:active` states, preventing
 * browser default or ambient anchor styles from overriding the button's
 * intended text color or adding an unwanted underline.
 *
 * Gated by `platform-dst-legacy-button-anchor-text-color` and used *instead*
 * of the base `<variant>Styles`. When cleaning up the gate: delete the base
 * `<variant>Styles` and rename the `WithAnchorTextColor` variant to replace
 * it.
 *
 * Link-like variants (`link`, `subtle-link`) keep their intentional underline
 * on `:hover` / `:active`.
 */ var $525d107f97649f51$var$defaultWithAnchorTextColorStyles = $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$defaultStyles), {}, {
    textDecoration: 'none',
    '&:hover': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$defaultStyles['&:hover']), {}, {
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    }),
    '&:active': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$defaultStyles['&:active']), {}, {
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    })
});
var $525d107f97649f51$var$primaryWithAnchorTextColorStyles = $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$primaryStyles), {}, {
    textDecoration: 'none',
    '&:hover': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$primaryStyles['&:hover']), {}, {
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    }),
    '&:active': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$primaryStyles['&:active']), {}, {
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    })
});
var $525d107f97649f51$var$linkWithAnchorTextColorStyles = $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$linkStyles), {}, {
    textDecoration: 'none'
});
var $525d107f97649f51$var$subtleWithAnchorTextColorStyles = $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$subtleStyles), {}, {
    textDecoration: 'none',
    '&:hover': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$subtleStyles['&:hover']), {}, {
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    }),
    '&:active': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$subtleStyles['&:active']), {}, {
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    })
});
var $525d107f97649f51$var$subtleLinkWithAnchorTextColorStyles = $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$subtleLinkStyles), {}, {
    textDecoration: 'none'
});
var $525d107f97649f51$var$warningWithAnchorTextColorStyles = $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$warningStyles), {}, {
    textDecoration: 'none',
    '&:hover': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$warningStyles['&:hover']), {}, {
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    }),
    '&:active': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$warningStyles['&:active']), {}, {
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    })
});
var $525d107f97649f51$var$dangerWithAnchorTextColorStyles = $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$dangerStyles), {}, {
    textDecoration: 'none',
    '&:hover': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$dangerStyles['&:hover']), {}, {
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    }),
    '&:active': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$dangerStyles['&:active']), {}, {
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    })
});
var $525d107f97649f51$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $525d107f97649f51$export$955358618f994a11(_ref) {
    var appearance = _ref.appearance, spacing = _ref.spacing, isSelected = _ref.isSelected, shouldFitContainer = _ref.shouldFitContainer, isOnlySingleIcon = _ref.isOnlySingleIcon;
    var baseAppearanceStyles = (0, $50U6m.fg)('platform-dst-legacy-button-anchor-text-color') ? $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, appearance === 'default' && $525d107f97649f51$var$defaultWithAnchorTextColorStyles), appearance === 'primary' && $525d107f97649f51$var$primaryWithAnchorTextColorStyles), appearance === 'link' && $525d107f97649f51$var$linkWithAnchorTextColorStyles), appearance === 'subtle' && $525d107f97649f51$var$subtleWithAnchorTextColorStyles), appearance === 'subtle-link' && $525d107f97649f51$var$subtleLinkWithAnchorTextColorStyles), appearance === 'warning' && $525d107f97649f51$var$warningWithAnchorTextColorStyles), appearance === 'danger' && $525d107f97649f51$var$dangerWithAnchorTextColorStyles) : $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, appearance === 'default' && $525d107f97649f51$var$defaultStyles), appearance === 'primary' && $525d107f97649f51$var$primaryStyles), appearance === 'link' && $525d107f97649f51$var$linkStyles), appearance === 'subtle' && $525d107f97649f51$var$subtleStyles), appearance === 'subtle-link' && $525d107f97649f51$var$subtleLinkStyles), appearance === 'warning' && $525d107f97649f51$var$warningStyles), appearance === 'danger' && $525d107f97649f51$var$dangerStyles);
    var appearanceStyles = appearance === 'default' && (0, $50U6m.fg)('platform-dst-tokens-finesse') ? $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, baseAppearanceStyles), {}, {
        '&:hover': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, baseAppearanceStyles['&:hover']), {}, {
            background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
        }),
        '&:active': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, baseAppearanceStyles['&:active']), {}, {
            background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
        })
    }) : baseAppearanceStyles;
    var activeStyles = appearanceStyles['&:active'];
    return $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-radius-medium, 6px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: (0, $50U6m.fg)('platform-dst-motion-uplift-button') ? "var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))".concat(", box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)") : 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $525d107f97649f51$var$heights[spacing],
        lineHeight: $525d107f97649f51$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $525d107f97649f51$var$singleIconPadding[spacing] : $525d107f97649f51$var$padding[spacing],
        verticalAlign: $525d107f97649f51$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center'
    }, isSelected ? $525d107f97649f51$var$selectedStyles : $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, appearanceStyles), activeStyles && (0, $50U6m.fg)('platform-dst-motion-uplift-button') && {
        '&:active': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, activeStyles), {}, {
            transition: "var(--ds-button-pressed, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
        })
    }), {}, {
        '&[disabled]': {
            color: "var(--ds-text-disabled, #080F214A)",
            backgroundColor: $525d107f97649f51$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent',
            cursor: 'not-allowed',
            textDecoration: 'none',
            '&:hovered': {
                backgroundColor: $525d107f97649f51$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
            },
            '&:active': {
                backgroundColor: $525d107f97649f51$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
            }
        }
    }, $525d107f97649f51$var$hasOverlayStyles)), {}, {
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}

});

parcelRegister("6R7Di", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fdd9d09d2bfaab9$export$2e2bcd8739ae039);

var $kcV4s = parcelRequire("kcV4s");
function $4fdd9d09d2bfaab9$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $kcV4s.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});


parcelRegister("8F9hT", function(module, exports) {
$parcel$export(module.exports, "default", () => $64e95b69a05329e9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hRJ5R = parcelRequire("hRJ5R");

var $50U6m = parcelRequire("50U6m");

var $2BQqo = parcelRequire("2BQqo");
var $auVZV = parcelRequire("auVZV");
var $64e95b69a05329e9$var$_excluded = [
    "children",
    "testId",
    "appearance",
    "newWindowLabel",
    "target",
    "className",
    "style"
];
var $64e95b69a05329e9$var$styles = {
    base: "_2rkolb4i _ect4ttxp",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    defaultAppearanceMotion: "_4bfu1r31 _1hms8stv _ajmmnqa1 _v564hxmd _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1j28 _1bnx8stv _jf4cnqa1 _o7kshxmd _30l313af _1nrm1j28 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    subtleAppearanceMotion: "_4bfu1j28 _1hms8stv _ajmmnqa1 _v564hxmd _syazazsu _1a3b1j28 _4fpr8stv _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _o7kshxmd _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    inverseAppearanceMotion: "_4bfu1r31 _1hms8stv _ajmmnqa1 _v564hxmd _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1j28 _1bnx8stv _jf4cnqa1 _o7kshxmd _30l315cr _1nrm1j28 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
var $64e95b69a05329e9$var$iconStyles = null;
var $64e95b69a05329e9$var$LinkWithoutRef = function LinkWithoutRef(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, newWindowLabel = _ref.newWindowLabel, target = _ref.target, _preventedClassName = _ref.className, _preventedStyle = _ref.style, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $64e95b69a05329e9$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement((0, $2BQqo.Anchor), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, htmlAttributes, {
        target: target,
        ref: ref,
        xcss: (0, $hRJ5R.cx)($64e95b69a05329e9$var$styles.base, appearance === 'default' && ((0, $50U6m.fg)('platform-dst-motion-uplift-list-item') ? $64e95b69a05329e9$var$styles.defaultAppearanceMotion : $64e95b69a05329e9$var$styles.defaultAppearance), appearance === 'subtle' && ((0, $50U6m.fg)('platform-dst-motion-uplift-list-item') ? $64e95b69a05329e9$var$styles.subtleAppearanceMotion : $64e95b69a05329e9$var$styles.subtleAppearance), appearance === 'inverse' && ((0, $50U6m.fg)('platform-dst-motion-uplift-list-item') ? $64e95b69a05329e9$var$styles.inverseAppearanceMotion : $64e95b69a05329e9$var$styles.inverseAppearance), // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $64e95b69a05329e9$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }), children, target === '_blank' && /*#__PURE__*/ $5FkrB.createElement((0, $auVZV.Box), {
        as: "span",
        xcss: $64e95b69a05329e9$var$styles.iconWrapper,
        testId: testId && "".concat(testId, "__icon")
    }, "\uFEFF", /*#__PURE__*/ $5FkrB.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $970q7.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ var $64e95b69a05329e9$var$Link = /*#__PURE__*/ (0, $5FkrB.forwardRef)($64e95b69a05329e9$var$LinkWithoutRef);
var $64e95b69a05329e9$export$2e2bcd8739ae039 = $64e95b69a05329e9$var$Link;

});
parcelRegister("2BQqo", function(module, exports) {
$parcel$export(module.exports, "Anchor", () => $1e67b3f18959f659$export$b688253958b8dfe7);
/* anchor.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $ekGgq = parcelRequire("ekGgq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $hUFig = parcelRequire("hUFig");

var $afMOk = parcelRequire("afMOk");

var $aLEtb = parcelRequire("aLEtb");

var $fqdOr = parcelRequire("fqdOr");

var $eVb4V = parcelRequire("eVb4V");

var $h8qvJ = parcelRequire("h8qvJ");

var $eqVaP = parcelRequire("eqVaP");

var $e8kqY = parcelRequire("e8kqY");

var $5yoeA = parcelRequire("5yoeA");
var $1e67b3f18959f659$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $1e67b3f18959f659$var$_excluded2 = [
    "className"
];
var $1e67b3f18959f659$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
var $1e67b3f18959f659$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $1e67b3f18959f659$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $1e67b3f18959f659$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $eVb4V.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? '(opens new window)' : _ref$newWindowLabel, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $1e67b3f18959f659$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $h8qvJ.useId)();
    var onClick = (0, $aLEtb.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@atlaskit/primitives",
        packageVersion: "22.5.1",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $1e67b3f18959f659$var$_excluded2);
    var RouterLink = (0, $fqdOr.useRouterLink)();
    var isExternal = typeof href === 'string' && $1e67b3f18959f659$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $1e67b3f18959f659$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(href) === 'object';
    (0, $afMOk.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $5FkrB.createElement((0, $5yoeA.Focusable), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $hUFig.cx)($1e67b3f18959f659$var$styles.root, $1e67b3f18959f659$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $5FkrB.createElement((0, $e8kqY.default), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
var $1e67b3f18959f659$export$b688253958b8dfe7 = /*#__PURE__*/ (0, $5FkrB.forwardRef)($1e67b3f18959f659$var$AnchorNoRef);

});
parcelRegister("fqdOr", function(module, exports) {
$parcel$export(module.exports, "useRouterLink", () => $b3a3ff9ad68cd756$export$6d558eab13290f59);

var $5FkrB = parcelRequire("5FkrB");

var $ebMPR = parcelRequire("ebMPR");
var $b3a3ff9ad68cd756$export$6d558eab13290f59 = function useRouterLink() {
    var _useContext = (0, $5FkrB.useContext)((0, $ebMPR.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
    return;
};

});
parcelRegister("ebMPR", function(module, exports) {
$parcel$export(module.exports, "RouterLinkProviderContext", () => $a547f97d5a6cf5e1$export$2931e0ee690eee88);

var $5FkrB = parcelRequire("5FkrB");
var $a547f97d5a6cf5e1$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $5FkrB.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $a547f97d5a6cf5e1$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($a547f97d5a6cf5e1$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$a547f97d5a6cf5e1$export$2e2bcd8739ae039 = $a547f97d5a6cf5e1$var$RouterLinkProvider;

});



parcelRegister("auVZV", function(module, exports) {
$parcel$export(module.exports, "Box", () => $7a49b1df02a75aca$export$e71c4d32a2263218);
/* box.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $b4wFT = parcelRequire("b4wFT");
var $7a49b1df02a75aca$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $7a49b1df02a75aca$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $7a49b1df02a75aca$var$baseStyles = null;
var $7a49b1df02a75aca$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhk187o",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $7a49b1df02a75aca$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $7a49b1df02a75aca$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $7a49b1df02a75aca$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $7a49b1df02a75aca$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $7a49b1df02a75aca$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $7a49b1df02a75aca$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
var $7a49b1df02a75aca$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $7a49b1df02a75aca$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $7a49b1df02a75aca$var$_excluded2);
    var node = /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: (0, $970q7.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $7a49b1df02a75aca$var$backgroundColorMap[backgroundColor],
            backgroundColor && $7a49b1df02a75aca$var$isSurfaceToken(backgroundColor) && $7a49b1df02a75aca$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $7a49b1df02a75aca$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $7a49b1df02a75aca$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $7a49b1df02a75aca$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $7a49b1df02a75aca$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $5FkrB.createElement((0, $b4wFT.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
function $7a49b1df02a75aca$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $7a49b1df02a75aca$var$setSurfaceTokenMap;
}

});


parcelRegister("dUWEU", function(module, exports) {
$parcel$export(module.exports, "default", () => $a21e01c03a9c4d94$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $abSTK = parcelRequire("abSTK");

var $ccBRl = parcelRequire("ccBRl");

var $goIky = parcelRequire("goIky");
var $a21e01c03a9c4d94$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $a21e01c03a9c4d94$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $a21e01c03a9c4d94$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $a21e01c03a9c4d94$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $a21e01c03a9c4d94$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $abSTK.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName
    }, saferRest), iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ccBRl.default), {
        type: "icon",
        position: "before",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $goIky.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ccBRl.default), {
        isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ccBRl.default), {
        type: "icon",
        position: "after",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $goIky.default), {
        icon: iconAfter
    })));
}));
$a21e01c03a9c4d94$var$Button.displayName = 'Button';
var $a21e01c03a9c4d94$export$2e2bcd8739ae039 = $a21e01c03a9c4d94$var$Button;

});

parcelRegister("lvjuN", function(module, exports) {
$parcel$export(module.exports, "Checkbox", () => $fa7b9da54b6e47b4$export$48513f6b9f8ce62d);
/* checkbox.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $aLEtb = parcelRequire("aLEtb");

var $iO8GM = parcelRequire("iO8GM");

var $3QsUo = parcelRequire("3QsUo");

var $c5y9i = parcelRequire("c5y9i");

var $d5iXy = parcelRequire("d5iXy");

var $dJSKK = parcelRequire("dJSKK");
var $fa7b9da54b6e47b4$var$_excluded = [
    "isChecked",
    "isDisabled",
    "isInvalid",
    "defaultChecked",
    "isIndeterminate",
    "onChange",
    "analyticsContext",
    "label",
    "name",
    "value",
    "isRequired",
    "testId",
    "xcss",
    "className"
];
/**
 * The input is visually hidden but remains in the DOM for accessibility.
 * State-based styling is handled by the Label component using CSS custom properties
 * that cascade to the CheckboxIcon, avoiding nested sibling selectors.
 */ var $fa7b9da54b6e47b4$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
};
var $fa7b9da54b6e47b4$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function Checkbox(_ref, ref) {
    var isCheckedProp = _ref.isChecked, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isInvalid = _ref.isInvalid, isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid, _ref$defaultChecked = _ref.defaultChecked, defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked, _ref$isIndeterminate = _ref.isIndeterminate, isIndeterminate = _ref$isIndeterminate === void 0 ? false : _ref$isIndeterminate, onChangeProps = _ref.onChange, analyticsContext = _ref.analyticsContext, label = _ref.label, name = _ref.name, value = _ref.value, isRequired = _ref.isRequired, testId = _ref.testId, xcss = _ref.xcss, className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $fa7b9da54b6e47b4$var$_excluded);
    var _useState = (0, $5FkrB.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isCheckedState = _useState2[0], setIsCheckedState = _useState2[1];
    var onChange = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    var onChangeAnalytics = (0, $aLEtb.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "@atlaskit/checkbox",
        packageVersion: "19.1.1"
    });
    var internalRef = (0, $5FkrB.useRef)(null);
    var mergedRefs = (0, $iO8GM.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    var isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5FkrB.useEffect)(function() {
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ $5FkrB.createElement((0, $c5y9i.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? "".concat(rest.id, "-label") : undefined,
        testId: testId && "".concat(testId, "--checkbox-label"),
        xcss: xcss
    }, /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0
    }, rest, {
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            $fa7b9da54b6e47b4$var$checkboxStyles.root,
            className
        ]),
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && "".concat(testId, "--hidden-checkbox"),
        "data-invalid": isInvalid ? 'true' : undefined
    })), /*#__PURE__*/ $5FkrB.createElement((0, $3QsUo.default), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ $5FkrB.createElement((0, $d5iXy.default), null, label, isRequired && /*#__PURE__*/ $5FkrB.createElement((0, $dJSKK.default), null)));
}));
$fa7b9da54b6e47b4$export$48513f6b9f8ce62d.displayName = 'Checkbox';
var // keep the default export for backwards compatibility
$fa7b9da54b6e47b4$export$2e2bcd8739ae039 = $fa7b9da54b6e47b4$export$48513f6b9f8ce62d;

});
parcelRegister("3QsUo", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ccca7160d04a198$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
/**
 * Styles for the checkbox icon.
 * CSS custom properties for colors are set by the parent Label element
 * and consumed directly in these styles.
 */ var $2ccca7160d04a198$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function $2ccca7160d04a198$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ $5FkrB.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ $5FkrB.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ var $2ccca7160d04a198$var$CheckboxIcon = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var isIndeterminate = _ref.isIndeterminate, isChecked = _ref.isChecked;
    var icon = (0, $5FkrB.useMemo)(function() {
        return $2ccca7160d04a198$var$getIcon(isIndeterminate, isChecked);
    }, [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ $5FkrB.createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $970q7.default)([
            $2ccca7160d04a198$var$svgStyles.root
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $5FkrB.createElement("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        className: (0, $970q7.default)([
            $2ccca7160d04a198$var$svgStyles.rect
        ])
    }), icon));
});
var $2ccca7160d04a198$export$2e2bcd8739ae039 = $2ccca7160d04a198$var$CheckboxIcon;

});

parcelRegister("c5y9i", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cd070e8cfc9c0f7$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v2.0.0 */ /**
 * Base state styles with CSS custom properties.
 * Pseudo-selectors (:hover, :focus-within, :active) on the label element
 * update CSS variables that cascade to the CheckboxIcon.
 * This avoids nested sibling selectors.
 *
 * Uses `css` over `cssMap` to work around a bug in Compiled types when
 * using CSS variables in pseudo-selectors.
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $8cd070e8cfc9c0f7$var$baseStyles = null;
var $8cd070e8cfc9c0f7$var$textLabelLayoutStyles = null;
// Checked/Indeterminate state
var $8cd070e8cfc9c0f7$var$checkedStyles = null;
// Invalid state - must override hover/active to maintain red border
var $8cd070e8cfc9c0f7$var$invalidStyles = null;
// Disabled state - must override hover/active to maintain disabled appearance
var $8cd070e8cfc9c0f7$var$disabledStyles = null;
// Disabled + Checked/Indeterminate
var $8cd070e8cfc9c0f7$var$disabledCheckedStyles = null;
function $8cd070e8cfc9c0f7$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, isChecked = _ref.isChecked, isIndeterminate = _ref.isIndeterminate, isInvalid = _ref.isInvalid, testId = _ref.testId, label = _ref.label, id = _ref.id, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("label", {
        className: (0, $970q7.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwn187o _f0gr187o _syaz1gmx _80om13gf _1vj5187o _q29q187o _dh4g187o _cz1u187o _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("d5iXy", function(module, exports) {
$parcel$export(module.exports, "default", () => $986a72fc4ddd96ec$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $986a72fc4ddd96ec$var$labelTextStyles = null;
function $986a72fc4ddd96ec$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            "_nd5l11ig _1wpz1h6o"
        ])
    }, children);
}

});

parcelRegister("dJSKK", function(module, exports) {
$parcel$export(module.exports, "default", () => $a009f31e2434411f$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $a009f31e2434411f$var$requiredIndicatorStyles = null;
function $a009f31e2434411f$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "aria-hidden": true,
        className: (0, $970q7.default)([
            "_syaz1tmw _bozgv77o"
        ])
    }, "*");
}

});


parcelRegister("bxWTK", function(module, exports) {
$parcel$export(module.exports, "WidthObserver", () => $868076b348d71ed1$export$b2ad68b9bc407b80);

var $5FkrB = parcelRequire("5FkrB");

var $donxB = parcelRequire("donxB");
var $868076b348d71ed1$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $donxB.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});

});
parcelRegister("donxB", function(module, exports) {
$parcel$export(module.exports, "WidthDetectorObserver", () => $9bffc6fe1a50f729$export$ff983d2a2b6112ea);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $huUkj = parcelRequire("huUkj");
var $9bffc6fe1a50f729$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(function(_ref) {
    var setWidth = _ref.setWidth, offscreen = _ref.offscreen;
    var _useInView = (0, $huUkj.useInView)({
        /* Optional options */ threshold: 0
    }), _useInView2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useInView, 3), inViewRef = _useInView2[0], inView = _useInView2[1], target = _useInView2[2];
    var observer = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(function() {
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        return new ResizeObserver(function(entries) {
            if (!Array.isArray(entries) || !entries.length) return;
            var width = entries[0].contentRect.width;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        var currentObserver = observer.current;
        var resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return function() {
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("huUkj", function(module, exports) {
$parcel$export(module.exports, "useInView", () => $cbd0ee50051aaaeb$export$2f62ee6831462844);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $cbd0ee50051aaaeb$export$2f62ee6831462844() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef();
    var observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef();
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    }), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState, 2), state = _React$useState2[0], setState = _React$useState2[1];
    var threshold = options.threshold, root = options.root, rootMargin = options.rootMargin;
    var setRef = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function(node) {
        observerInstance.current = new IntersectionObserver(function(entries) {
            if (entries && entries.length) {
                var intersection = entries[0];
                var isIntersecting = intersection.isIntersecting, intersectionRatio = intersection.intersectionRatio;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    var numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    var inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        return function() {
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



parcelRegister("h19KG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ceff5ba2cd41cd6899d33441cb75c99>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c63a1832a2581897$var$_react = $c63a1832a2581897$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $c63a1832a2581897$var$_iconNew = $c63a1832a2581897$var$_interopRequireDefault((parcelRequire("gDzom")));
function $c63a1832a2581897$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-down
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c63a1832a2581897$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $c63a1832a2581897$var$_react.default.createElement($c63a1832a2581897$var$_iconNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$c63a1832a2581897$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $c63a1832a2581897$var$_default = module.exports.default = $c63a1832a2581897$var$ChevronDownIcon;

});

parcelRegister("aMiKe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da37f0a43857e8b8e953de1c778f2dc8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d8ced6060a88250$var$_react = $7d8ced6060a88250$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $7d8ced6060a88250$var$_iconNew = $7d8ced6060a88250$var$_interopRequireDefault((parcelRequire("gDzom")));
function $7d8ced6060a88250$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-right
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7d8ced6060a88250$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $7d8ced6060a88250$var$_react.default.createElement($7d8ced6060a88250$var$_iconNew.default, Object.assign({
        name: "ChevronRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.03 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L10.44 8 4.97 2.53z"/>`
    }, props));
$7d8ced6060a88250$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $7d8ced6060a88250$var$_default = module.exports.default = $7d8ced6060a88250$var$ChevronRightIcon;

});

parcelRegister("4oEEp", function(module, exports) {
$parcel$export(module.exports, "HeadCell", () => $3338efb071a4b472$export$4e8024263ace498b);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $gDiFE = parcelRequire("gDiFE");

var $kL1TB = parcelRequire("kL1TB");

var $9TAkY = parcelRequire("9TAkY");
var $3338efb071a4b472$var$_excluded = [
    "children",
    "align",
    "testId",
    "backgroundColor",
    "xcss",
    "scope",
    "tableType"
];
var $3338efb071a4b472$var$InputHeadStyle = (0, $gDiFE.xcss)({
    borderBlockWidth: 'border.width',
    borderBlockStyle: 'solid',
    borderInlineEndWidth: 'border.width',
    borderInlineEndStyle: 'solid',
    borderColor: 'color.border',
    backgroundColor: 'elevation.surface.sunken'
});
var $3338efb071a4b472$var$InventoryHeadStyle = (0, $gDiFE.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        borderInlineEndWidth: 'border.width',
        borderInlineEndStyle: 'solid',
        borderColor: 'color.border'
    },
    backgroundColor: 'elevation.surface',
    height: '48px',
    borderBlockStartWidth: 'border.width',
    borderBlockStartStyle: 'solid',
    borderBlockEndWidth: 'border.width.selected',
    borderBlockEndStyle: 'solid',
    borderColor: 'color.border'
});
var $3338efb071a4b472$var$HeadCellStyle = (0, $gDiFE.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':first-of-type': {
        borderInlineStartWidth: 'border.width',
        borderInlineStartStyle: 'solid',
        borderColor: 'color.border',
        borderTopLeftRadius: 'radius.large'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        paddingInline: 'space.100',
        borderColor: 'color.border',
        borderTopRightRadius: 'radius.large'
    },
    position: 'sticky',
    borderColor: 'color.border',
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
    color: 'color.text.subtlest',
    textAlign: 'left',
    top: 'space.0',
    // @ts-expect-error-next-line - none of the zIndex ADS tokens equate to 2
    zIndex: 2,
    paddingInline: 'space.100'
});
var $3338efb071a4b472$export$4e8024263ace498b = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, align = _ref.align, testId = _ref.testId, backgroundColor = _ref.backgroundColor, customXcss = _ref.xcss, _ref$scope = _ref.scope, scope = _ref$scope === void 0 ? 'col' : _ref$scope, _ref$tableType = _ref.tableType, tableType = _ref$tableType === void 0 ? (0, $9TAkY.TableType).input : _ref$tableType, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $3338efb071a4b472$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kL1TB.TH), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        scope: scope,
        align: align,
        testId: testId,
        ref: ref,
        xcss: [
            $3338efb071a4b472$var$HeadCellStyle,
            tableType === (0, $9TAkY.TableType).inventory && $3338efb071a4b472$var$InventoryHeadStyle,
            tableType === (0, $9TAkY.TableType).input && $3338efb071a4b472$var$InputHeadStyle,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- this is inline with what atlaskit primitives do.
            customXcss
        ],
        backgroundColor: backgroundColor
    }), children);
});

});
parcelRegister("kL1TB", function(module, exports) {
$parcel$export(module.exports, "TH", () => $f1c9aaead5037b92$export$2b39a3648955dd09);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $gtBt8 = parcelRequire("gtBt8");
var $f1c9aaead5037b92$export$2b39a3648955dd09 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gtBt8.BaseCell), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "th",
        ref: ref
    }, props));
});

});
parcelRegister("gtBt8", function(module, exports) {
$parcel$export(module.exports, "BaseCell", () => $bfec6b539f2289ce$export$41ad0bbfa4755cac);

var $5FkrB = parcelRequire("5FkrB");

var $4Pn6z = parcelRequire("4Pn6z");
var $gDiFE = parcelRequire("gDiFE");
/**
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-sort
 */ var $bfec6b539f2289ce$var$alignLeftStyles = (0, $gDiFE.xcss)({
    textAlign: 'left'
});
var $bfec6b539f2289ce$var$alignCenterStyles = (0, $gDiFE.xcss)({
    textAlign: 'center'
});
var $bfec6b539f2289ce$var$alignRightStyles = (0, $gDiFE.xcss)({
    textAlign: 'right'
});
var $bfec6b539f2289ce$var$focusOutline = (0, $gDiFE.xcss)({
    ':focus-visible': {
        //@ts-expect-error This is a hack to get better focus styles
        boxShadow: "0 0 0 2px ".concat("var(--ds-border-focused, #4688EC)", " inset"),
        outline: 'none'
    },
    ':focus': {
        //@ts-expect-error This is a hack to get better focus styles
        boxShadow: "0 0 0 2px ".concat("var(--ds-border-focused, #4688EC)", " inset")
    }
});
var $bfec6b539f2289ce$var$alignMap = {
    text: $bfec6b539f2289ce$var$alignLeftStyles,
    number: $bfec6b539f2289ce$var$alignRightStyles,
    icon: $bfec6b539f2289ce$var$alignCenterStyles
};
var $bfec6b539f2289ce$export$41ad0bbfa4755cac = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, as = _ref.as, customXcss = _ref.xcss, children = _ref.children, _ref$align = _ref.align, align = _ref$align === void 0 ? 'text' : _ref$align, display = _ref.display, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? 'space.100' : _ref$paddingBlock, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? 'space.100' : _ref$paddingInline, backgroundColor = _ref.backgroundColor, scope = _ref.scope, width = _ref.width, sortDirection = _ref.sortDirection, colSpan = _ref.colSpan, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, tabIndex = _ref.tabIndex, onKeyDown = _ref.onKeyDown;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), {
        ref: ref,
        scope: scope,
        xcss: [
            $bfec6b539f2289ce$var$alignMap[align],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $gDiFE.xcss)({
                width: width
            }),
            tabIndex === 0 && $bfec6b539f2289ce$var$focusOutline,
            customXcss
        ],
        backgroundColor: backgroundColor,
        paddingBlock: paddingBlock,
        paddingInline: paddingInline,
        as: as,
        display: display !== null && display !== void 0 ? display : 'unset',
        testId: testId,
        "aria-sort": sortDirection,
        colSpan: colSpan,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        tabIndex: tabIndex,
        onKeyDown: onKeyDown
    }, children);
});

});


parcelRegister("9TAkY", function(module, exports) {
$parcel$export(module.exports, "TableState", () => $73456febbcc7b492$export$3d6dc94c3b008646);
$parcel$export(module.exports, "TableType", () => $73456febbcc7b492$export$ec659152c0ce3638);
$parcel$export(module.exports, "CharlieTable", () => $73456febbcc7b492$export$653047d99c89ec70);

var $25nEq = parcelRequire("25nEq");

var $fC8ib = parcelRequire("fC8ib");

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $kGO2D = parcelRequire("kGO2D");

var $dUWEU = parcelRequire("dUWEU");

var $5yfDB = parcelRequire("5yfDB");

var $lvjuN = parcelRequire("lvjuN");

var $4Pn6z = parcelRequire("4Pn6z");
var $2kuK2 = parcelRequire("2kuK2");
var $1qQas = parcelRequire("1qQas");
var $gDiFE = parcelRequire("gDiFE");

var $9ztDu = parcelRequire("9ztDu");

var $bxWTK = parcelRequire("bxWTK");

var $cYEG6 = parcelRequire("cYEG6");

var $hZrFa = parcelRequire("hZrFa");

var $86aoj = parcelRequire("86aoj");

var $aQxuW = parcelRequire("aQxuW");

var $cMkZu = parcelRequire("cMkZu");

var $f20te = parcelRequire("f20te");

var $5THOi = parcelRequire("5THOi");

var $iRBPG = parcelRequire("iRBPG");

var $cvf3Z = parcelRequire("cvf3Z");

var $bF0W9 = parcelRequire("bF0W9");

var $a36et = parcelRequire("a36et");

var $iQ45V = parcelRequire("iQ45V");

var $eYe65 = parcelRequire("eYe65");

var $4Aklk = parcelRequire("4Aklk");
var $73456febbcc7b492$var$_excluded = [
    "labels",
    "manualSorting",
    "manualPagination",
    "enableResizing",
    "tableType",
    "tableState",
    "rowSpacing",
    "xcssOverrides",
    "enableKeyboardNavigation"
], $73456febbcc7b492$var$_excluded2 = [
    "charlieTableState",
    "tableRef"
], $73456febbcc7b492$var$_excluded3 = [
    "charlieTableState"
];
function $73456febbcc7b492$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $73456febbcc7b492$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $73456febbcc7b492$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $73456febbcc7b492$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $73456febbcc7b492$export$3d6dc94c3b008646 = {
    loaded: 'LOADED',
    loading: 'LOADING',
    error: 'ERROR'
};
var $73456febbcc7b492$export$ec659152c0ce3638 = {
    inventory: 'INVENTORY',
    input: 'INPUT'
};
/**
 * CharlieTableStyles
 */ var $73456febbcc7b492$var$ExpandableRowCellPadding = (0, $gDiFE.xcss)({
    paddingInlineStart: 'space.100'
});
var $73456febbcc7b492$var$RowCursorPointer = (0, $gDiFE.xcss)({
    cursor: 'pointer'
});
var $73456febbcc7b492$var$TDExtraStyle = (0, $gDiFE.xcss)({
    borderBottomWidth: 'border.width',
    borderBottomStyle: 'solid',
    borderInlineEndWidth: 'border.width',
    borderInlineEndStyle: 'solid',
    borderColor: 'color.border'
});
var $73456febbcc7b492$var$OverflowHiddenStyle = (0, $gDiFE.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
var $73456febbcc7b492$var$LoadMoreWrapperStyle = (0, $gDiFE.xcss)({
    marginBlockStart: 'space.100'
});
var $73456febbcc7b492$var$CheckboxWrapperStyle = (0, $gDiFE.xcss)({
    width: 'fit-content',
    marginInlineStart: 'space.negative.100'
});
var $73456febbcc7b492$var$SubRowButtonWrapperStyle = (0, $gDiFE.xcss)({
    marginInlineEnd: 'space.050'
});
var $73456febbcc7b492$var$SubRowExpandableStyle = (0, $gDiFE.xcss)({
    // @ts-expect-error - this saves us from rerendering all the cells
    position: 'var(--col-group-position)',
    left: '0',
    whiteSpace: 'nowrap',
    borderBottomWidth: 'border.width',
    borderBottomStyle: 'solid',
    borderInlineStartWidth: 'border.width',
    borderInlineStartStyle: 'solid',
    borderColor: 'color.border',
    zIndex: '1'
});
var $73456febbcc7b492$var$LoadingTableStyle = (0, $gDiFE.xcss)({
    opacity: 0.7,
    pointerEvents: 'none'
});
var $73456febbcc7b492$var$TableWrapperStyle = (0, $gDiFE.xcss)({
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    height: '100%',
    overflow: 'auto',
    borderTopLeftRadius: 'radius.large',
    borderTopRightRadius: 'radius.large'
});
var $73456febbcc7b492$var$FooterStyles = (0, $gDiFE.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'sticky',
    left: 'space.0'
});
var $73456febbcc7b492$var$FooterDividerStyles = (0, $gDiFE.xcss)({
    border: 'none',
    borderBottom: "var(--ds-border-width-selected, 2px)".concat(" solid ", "var(--ds-border, #0B120E24)"),
    marginTop: 'space.250',
    width: '10%'
});
var $73456febbcc7b492$var$LoadingOverlayStyle = (0, $gDiFE.xcss)({
    position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center',
    pointerEvents: 'none',
    top: 'space.0',
    left: 'space.0',
    right: 'space.0',
    bottom: 'space.0'
});

var $73456febbcc7b492$export$653047d99c89ec70 = function CharlieTable(_ref) {
    var _props$refs, _props$state2, _props$initialState2, _props$state5, _props$state6, _props$initialState5, _props$initialState6, _props$state9, _props$initialState9, _props$refs2, _table$getState$colum, _props$refs3;
    var _ref$labels = _ref.labels, labels = _ref$labels === void 0 ? {
        sortButton: 'Column sort button',
        selectAllRows: 'Select all rows',
        selectRow: 'Select row',
        expandRow: 'Expand row',
        loadMore: 'Load more'
    } : _ref$labels, _ref$manualSorting = _ref.manualSorting, manualSorting = _ref$manualSorting === void 0 ? true : _ref$manualSorting, _ref$manualPagination = _ref.manualPagination, manualPagination = _ref$manualPagination === void 0 ? true : _ref$manualPagination, _ref$enableResizing = _ref.enableResizing, enableResizing = _ref$enableResizing === void 0 ? false : _ref$enableResizing, _ref$tableType = _ref.tableType, tableType = _ref$tableType === void 0 ? $73456febbcc7b492$export$ec659152c0ce3638.input : _ref$tableType, _ref$tableState = _ref.tableState, tableState = _ref$tableState === void 0 ? $73456febbcc7b492$export$3d6dc94c3b008646.loaded : _ref$tableState, _ref$rowSpacing = _ref.rowSpacing, rowSpacing = _ref$rowSpacing === void 0 ? 'default' : _ref$rowSpacing, xcssOverrides = _ref.xcssOverrides, _ref$enableKeyboardNa = _ref.enableKeyboardNavigation, enableKeyboardNavigation = _ref$enableKeyboardNa === void 0 ? false : _ref$enableKeyboardNa, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $73456febbcc7b492$var$_excluded);
    var _useState = (0, $5FkrB.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), parentSize = _useState2[0], setParentSize = _useState2[1];
    var tableRef = (0, $5FkrB.useRef)(null);
    (0, $5FkrB.useImperativeHandle)((_props$refs = props.refs) === null || _props$refs === void 0 ? void 0 : _props$refs.tableRef, function() {
        return tableRef.current;
    });
    var _useKeyboardNavigatio = (0, $hZrFa.useKeyboardNavigation)(), tableNavigationControllers = _useKeyboardNavigatio.tableNavigationControllers;
    var infiniteScrollRef = (0, $cYEG6.useInfiniteScroll)({
        onScrollTo: function onScrollTo() {
            var _props$onLoadNext;
            (_props$onLoadNext = props.onLoadNext) === null || _props$onLoadNext === void 0 || _props$onLoadNext.call(props);
        }
    });
    var CharlieTableDndWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).lazy(function() {
        return (parcelRequire("7vnkj")).then(function(module) {
            return {
                default: module.CharlieTableDndWrapper
            };
        });
    });
    var CharlieWrapper = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        if (props.enableColumnReorder || enableResizing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(_ref2, ref) {
            var charlieTableState = _ref2.charlieTableState, tableRef = _ref2.tableRef, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $73456febbcc7b492$var$_excluded2);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Suspense, {
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), props)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(CharlieTableDndWrapper, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                ref: ref,
                charlieTableState: charlieTableState
            }, props, {
                tableRef: tableRef
            })));
        });
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(_ref3, ref) {
            var charlieTableState = _ref3.charlieTableState, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref3, $73456febbcc7b492$var$_excluded3);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                ref: ref
            }, props));
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.enableColumnReorder,
        enableResizing
    ]);
    var dummyId = 'charlie-table-reserved-checkbox';
    var oldModifiedColumns = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        var _props$columns;
        if (props.columnDefs) return undefined;
        var dummyCheckboxOldColumn = {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), null),
            key: dummyId,
            width: 44,
            minWidth: 44,
            isSortable: false,
            cell: {
                render: function render() {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), null);
                }
            }
        };
        return props.enableRowSelection ? [
            dummyCheckboxOldColumn
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((_props$columns = props.columns) !== null && _props$columns !== void 0 ? _props$columns : [])) : props.columns;
    }, [
        props.columns,
        props.enableRowSelection,
        props.columnDefs
    ]);
    var tanModifiedColumns = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        if (!props.columnDefs) return undefined;
        var dummyCheckboxTanColumn = {
            header: function header() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), null);
            },
            id: dummyId,
            size: 44,
            minSize: 44,
            enableSorting: false,
            cell: function cell() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), null);
            }
        };
        return props.enableRowSelection ? [
            dummyCheckboxTanColumn
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(props.columnDefs)) : props.columnDefs;
    }, [
        props.columnDefs,
        props.enableRowSelection
    ]);
    var appendDummyCheckboxToList = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function(list) {
        return props.enableRowSelection && list ? [
            dummyId
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(list !== null && list !== void 0 ? list : [])) : list;
    }, [
        props.enableRowSelection
    ]);
    var modifiedColumnOrder = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        var _props$state;
        return appendDummyCheckboxToList((_props$state = props.state) === null || _props$state === void 0 ? void 0 : _props$state.columnOrder);
    }, [
        appendDummyCheckboxToList,
        (_props$state2 = props.state) === null || _props$state2 === void 0 ? void 0 : _props$state2.columnOrder
    ]);
    var modifiedInitialColumnOrder = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        var _props$initialState;
        return appendDummyCheckboxToList((_props$initialState = props.initialState) === null || _props$initialState === void 0 ? void 0 : _props$initialState.columnOrder);
    }, [
        appendDummyCheckboxToList,
        (_props$initialState2 = props.initialState) === null || _props$initialState2 === void 0 ? void 0 : _props$initialState2.columnOrder
    ]);
    var modifiedColumnPinningStart = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        var _props$state$columnPi, _props$state3, _props$state4;
        return appendDummyCheckboxToList((_props$state$columnPi = (_props$state3 = props.state) === null || _props$state3 === void 0 || (_props$state3 = _props$state3.columnPinning) === null || _props$state3 === void 0 ? void 0 : _props$state3.start) !== null && _props$state$columnPi !== void 0 ? _props$state$columnPi : (_props$state4 = props.state) === null || _props$state4 === void 0 || (_props$state4 = _props$state4.columnPinning) === null || _props$state4 === void 0 ? void 0 : _props$state4.left);
    }, [
        appendDummyCheckboxToList,
        (_props$state5 = props.state) === null || _props$state5 === void 0 || (_props$state5 = _props$state5.columnPinning) === null || _props$state5 === void 0 ? void 0 : _props$state5.start,
        (_props$state6 = props.state) === null || _props$state6 === void 0 || (_props$state6 = _props$state6.columnPinning) === null || _props$state6 === void 0 ? void 0 : _props$state6.left
    ]);
    var modifiedInitialColumnPinningStart = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        var _props$initialState$c, _props$initialState3, _props$initialState4;
        return appendDummyCheckboxToList((_props$initialState$c = (_props$initialState3 = props.initialState) === null || _props$initialState3 === void 0 || (_props$initialState3 = _props$initialState3.columnPinning) === null || _props$initialState3 === void 0 ? void 0 : _props$initialState3.start) !== null && _props$initialState$c !== void 0 ? _props$initialState$c : (_props$initialState4 = props.initialState) === null || _props$initialState4 === void 0 || (_props$initialState4 = _props$initialState4.columnPinning) === null || _props$initialState4 === void 0 ? void 0 : _props$initialState4.left);
    }, [
        appendDummyCheckboxToList,
        (_props$initialState5 = props.initialState) === null || _props$initialState5 === void 0 || (_props$initialState5 = _props$initialState5.columnPinning) === null || _props$initialState5 === void 0 ? void 0 : _props$initialState5.start,
        (_props$initialState6 = props.initialState) === null || _props$initialState6 === void 0 || (_props$initialState6 = _props$initialState6.columnPinning) === null || _props$initialState6 === void 0 ? void 0 : _props$initialState6.left
    ]);
    var modifiedColumnPinning = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        var _props$state7, _props$state8;
        return modifiedColumnPinningStart ? $73456febbcc7b492$var$_objectSpread($73456febbcc7b492$var$_objectSpread({}, (_props$state7 = props.state) === null || _props$state7 === void 0 ? void 0 : _props$state7.columnPinning), {}, {
            start: modifiedColumnPinningStart
        }) : (_props$state8 = props.state) === null || _props$state8 === void 0 ? void 0 : _props$state8.columnPinning;
    }, [
        modifiedColumnPinningStart,
        (_props$state9 = props.state) === null || _props$state9 === void 0 ? void 0 : _props$state9.columnPinning
    ]);
    var modifiedInitialColumnPinning = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        var _props$initialState7, _props$initialState8;
        return modifiedInitialColumnPinningStart ? $73456febbcc7b492$var$_objectSpread($73456febbcc7b492$var$_objectSpread({}, (_props$initialState7 = props.initialState) === null || _props$initialState7 === void 0 ? void 0 : _props$initialState7.columnPinning), {}, {
            start: modifiedInitialColumnPinningStart
        }) : (_props$initialState8 = props.initialState) === null || _props$initialState8 === void 0 ? void 0 : _props$initialState8.columnPinning;
    }, [
        modifiedInitialColumnPinningStart,
        (_props$initialState9 = props.initialState) === null || _props$initialState9 === void 0 ? void 0 : _props$initialState9.columnPinning
    ]);
    var convertedCharles = (0, $4Aklk.useConvertCharlieTableToTanStack)($73456febbcc7b492$var$_objectSpread($73456febbcc7b492$var$_objectSpread({}, props), {}, {
        columnDefs: tanModifiedColumns,
        columns: oldModifiedColumns,
        manualPagination: manualPagination,
        manualSorting: manualSorting,
        state: $73456febbcc7b492$var$_objectSpread($73456febbcc7b492$var$_objectSpread({}, props.state), {}, {
            columnPinning: modifiedColumnPinning,
            columnOrder: modifiedColumnOrder
        }),
        initialState: $73456febbcc7b492$var$_objectSpread($73456febbcc7b492$var$_objectSpread({}, props.initialState), {}, {
            columnPinning: modifiedInitialColumnPinning,
            columnOrder: modifiedInitialColumnOrder
        })
    }));
    var columns = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        return convertedCharles.columns;
    }, [
        convertedCharles.columns
    ]);
    var data = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        return convertedCharles.data;
    }, [
        convertedCharles.data
    ]);
    var table = (0, $kGO2D.useReactTable)($73456febbcc7b492$var$_objectSpread($73456febbcc7b492$var$_objectSpread({}, convertedCharles), {}, {
        columns: columns,
        data: data,
        autoResetExpanded: props.autoResetExpanded
    }));
    (0, $5FkrB.useImperativeHandle)((_props$refs2 = props.refs) === null || _props$refs2 === void 0 ? void 0 : _props$refs2.internalTableRef, function() {
        return table;
    }, [
        table
    ]);
    var hasWidths = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Object.keys((_table$getState$colum = table.getState().columnSizing) !== null && _table$getState$colum !== void 0 ? _table$getState$colum : {})).length > 0 || enableResizing;
    var totalTableWidth = table.getTotalSize();
    var columnCssVars = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        var _table$getState;
        var cols = table.getAllLeafColumns();
        var colCss = {};
        cols.forEach(function(col) {
            var isPinned = col.getIsPinned();
            if (!isPinned || !col) return;
            var colKeyPrefix = "--col-".concat(col.id);
            colCss["".concat(colKeyPrefix, "-left")] = isPinned === 'left' ? "".concat(col.getStart('left'), "px") : undefined;
            colCss["".concat(colKeyPrefix, "-right")] = isPinned === 'right' ? "".concat(col.getAfter('right'), "px") : undefined;
            // @ts-expect-error-next-line - none of the zIndex ADS tokens equate to 1
            colCss["".concat(colKeyPrefix, "-zIndex")] = 1;
            colCss["".concat(colKeyPrefix, "-position")] = 'sticky';
        });
        if (table !== null && table !== void 0 && (_table$getState = table.getState()) !== null && _table$getState !== void 0 && (_table$getState = _table$getState.columnPinning) !== null && _table$getState !== void 0 && _table$getState.left && table.getState().columnPinning.left.length > 0) colCss["--col-group-position"] = 'sticky';
        return colCss;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        table.options.state
    ]);
    var isEmptyState = table.options.data.length === 0 && tableState === $73456febbcc7b492$export$3d6dc94c3b008646.loaded;
    return(/*#__PURE__*/ //normally you shouldn't do this, but was having trouble passing the generic with the lazy loaded component
    //@ts-expect-error lazy loading isses
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(CharlieWrapper, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        xcss: $73456febbcc7b492$var$TableWrapperStyle,
        ref: (_props$refs3 = props.refs) === null || _props$refs3 === void 0 ? void 0 : _props$refs3.tableContainerRef
    }, (props.enableColumnReorder || enableResizing) && {
        charlieTableState: table,
        tableRef: tableRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bxWTK.WidthObserver), {
        setWidth: setParentSize
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iQ45V.Table), {
        testId: props.testId,
        ref: tableRef,
        xcss: [
            props.isLoading || tableState === $73456febbcc7b492$export$3d6dc94c3b008646.loading ? $73456febbcc7b492$var$LoadingTableStyle : false,
            (0, $gDiFE.xcss)($73456febbcc7b492$var$_objectSpread($73456febbcc7b492$var$_objectSpread({}, columnCssVars), {}, {
                borderCollapse: 'separate',
                borderSpacing: '0px',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                tableLayout: hasWidths ? 'fixed' : 'auto',
                width: '100%',
                overflow: 'auto',
                margin: 'space.0'
            }))
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aQxuW.Colgroup), null, table.getHeaderGroups().map(function(headerGroup) {
        return headerGroup.headers.map(function(header) {
            if ((header === null || header === void 0 ? void 0 : header.column) == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $86aoj.Col), {
                key: header.id,
                xcss: (0, $gDiFE.xcss)({
                    width: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                    (!header.column.getIsLastColumn() || parentSize && parentSize < totalTableWidth) && enableResizing ? "".concat(header.column.getSize(), "px") : undefined,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                })
            });
        });
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $eYe65.THead), null, table.getHeaderGroups().map(function(headerGroup) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5THOi.TR), {
            key: headerGroup.id
        }, headerGroup.headers.map(function(header, idx) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iRBPG.CharlieTableHeader), {
                key: header.id,
                labels: labels,
                charlieTableColumn: header,
                index: idx,
                enableResizing: enableResizing && header.column.getCanResize(),
                charlieTableState: table,
                tableType: tableType,
                enableColumnReorder: props.enableColumnReorder,
                enableRowSelection: props.enableRowSelection,
                hasWidths: hasWidths,
                xcss: typeof (xcssOverrides === null || xcssOverrides === void 0 ? void 0 : xcssOverrides.headerCell) === 'function' ? xcssOverrides.headerCell(header, table.getState()) : undefined
            });
        }));
    })), (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        var _props$refs4;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cvf3Z.TBody), {
            ref: (_props$refs4 = props.refs) === null || _props$refs4 === void 0 ? void 0 : _props$refs4.tableBodyRef
        }, table.getRowModel().rows ? table.getRowModel().rows.map(function(row, index) {
            var _row$original, _props$renderOptions, _props$renderOptions2, _props$renderOptions3, _table$getRowModel$ro, _table$getRowModel$ro2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), {
                key: row.id
            }, (_row$original = row.original) !== null && _row$original !== void 0 && _row$original.overrideRender || row.getIsGrouped() && (_props$renderOptions = props.renderOptions) !== null && _props$renderOptions !== void 0 && _props$renderOptions.groupingRow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bF0W9.Row), {
                spacing: rowSpacing,
                onClick: function onClick(e) {
                    var _props$onRowClick;
                    // @ts-expect-error Prevent row click if a link was clicked
                    if (e.target.closest('a')) return;
                    (_props$onRowClick = props.onRowClick) === null || _props$onRowClick === void 0 || _props$onRowClick.call(props, row);
                },
                xcss: props.onRowClick && $73456febbcc7b492$var$RowCursorPointer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f20te.TD), {
                xcss: [
                    $73456febbcc7b492$var$SubRowExpandableStyle,
                    typeof (xcssOverrides === null || xcssOverrides === void 0 ? void 0 : xcssOverrides.rowCell) === 'function' ? xcssOverrides.rowCell(row.getVisibleCells()[0], table.getState()) : undefined
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $2kuK2.Flex), {
                alignItems: "center"
            }, (props.renderChildComponent || ((_props$renderOptions2 = props.renderOptions) === null || _props$renderOptions2 === void 0 ? void 0 : _props$renderOptions2.groupingRow)) && row.getCanExpand() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), {
                xcss: [
                    $73456febbcc7b492$var$SubRowButtonWrapperStyle,
                    (0, $gDiFE.xcss)({
                        // @ts-expect-error - needed for nested styles
                        // eslint-disable-next-line @compiled/no-suppress-xcss
                        paddingInlineStart: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                        row.getCanExpand() ? "".concat((row.depth + 1) * 8, "px") : "".concat(32 + (row.depth + 1) * 8, "px")
                    })
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5yfDB.default), {
                spacing: "compact",
                testId: "expand-row-button",
                appearance: "subtle",
                interactionName: props.interactionName,
                analyticsContext: $73456febbcc7b492$var$_objectSpread({
                    componentName: 'charlieTableExpandRowButton'
                }, props.analyticsContext),
                "aria-pressed": row.getIsExpanded(),
                label: labels.expandRow,
                icon: function icon(iconProps) {
                    var _row$getIsExpanded;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cMkZu.ExpandIcon), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                        isExpanded: (_row$getIsExpanded = row.getIsExpanded()) !== null && _row$getIsExpanded !== void 0 ? _row$getIsExpanded : false
                    }, iconProps));
                },
                onClick: function onClick(e) {
                    e.stopPropagation();
                    row.toggleExpanded();
                }
            })), row.original.overrideRender && row.original.overrideRender(row.original), ((_props$renderOptions3 = props.renderOptions) === null || _props$renderOptions3 === void 0 ? void 0 : _props$renderOptions3.groupingRow) && props.renderOptions.groupingRow(row.original, table.getState()))), row.getVisibleCells().length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f20te.TD), {
                colSpan: row.getVisibleCells().length - 1,
                xcss: [
                    $73456febbcc7b492$var$TDExtraStyle,
                    typeof (xcssOverrides === null || xcssOverrides === void 0 ? void 0 : xcssOverrides.rowCell) === 'function' ? xcssOverrides.rowCell(row.getVisibleCells()[1], table.getState()) : undefined
                ]
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bF0W9.Row), {
                key: row.id,
                spacing: rowSpacing,
                onClick: function onClick(e) {
                    var _props$onRowClick2;
                    // @ts-expect-error Prevent row click if a link was clicked
                    if (e.target.closest('a')) return;
                    (_props$onRowClick2 = props.onRowClick) === null || _props$onRowClick2 === void 0 || _props$onRowClick2.call(props, row);
                },
                xcss: props.onRowClick && $73456febbcc7b492$var$RowCursorPointer
            }, row.getVisibleCells().map(function(cell, index) {
                var _row$getParentRow;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a36et.RowCell), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                    tableType: tableType
                }, enableKeyboardNavigation && {
                    tabIndex: 0,
                    onKeyDown: tableNavigationControllers
                }, {
                    xcss: [
                        $73456febbcc7b492$var$OverflowHiddenStyle,
                        cell.row.getCanExpand() && (props.enableRowSelection && index === 1 || !props.enableRowSelection && index === 0) && $73456febbcc7b492$var$ExpandableRowCellPadding,
                        cell.column.getIsPinned() && (0, $gDiFE.xcss)({
                            // @ts-expect-error - this saves us from rerendering all the cells
                            // eslint-disable-next-line @compiled/no-suppress-xcss, @atlaskit/ui-styling-standard/no-unsafe-values
                            zIndex: "var(--col-".concat(cell.column.id, "-zIndex)"),
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                            left: "var(--col-".concat(cell.column.id, "-left)"),
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                            right: "var(--col-".concat(cell.column.id, "-right)"),
                            // @ts-expect-error - this saves us from rerendering all the cells
                            // eslint-disable-next-line @compiled/no-suppress-xcss, @atlaskit/ui-styling-standard/no-unsafe-values
                            position: "var(--col-".concat(cell.column.id, "-position)")
                        }),
                        typeof (xcssOverrides === null || xcssOverrides === void 0 ? void 0 : xcssOverrides.rowCell) === 'function' ? xcssOverrides.rowCell(cell, table.getState()) : undefined
                    ],
                    key: cell.id
                }), index === 0 && props.enableRowSelection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), {
                    xcss: $73456febbcc7b492$var$CheckboxWrapperStyle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $lvjuN.Checkbox), {
                    analyticsContext: $73456febbcc7b492$var$_objectSpread({
                        componentName: 'charlieTableExpandRowButton'
                    }, props.analyticsContext),
                    "aria-label": labels.selectRow,
                    isDisabled: !row.getCanSelect(),
                    isChecked: row.getIsSelected(),
                    onClick: function onClick(e) {
                        e.stopPropagation();
                        row.toggleSelected();
                    }
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $2kuK2.Flex), {
                    alignItems: "center",
                    xcss: [
                        $73456febbcc7b492$var$OverflowHiddenStyle,
                        (props.enableRowSelection && index === 1 || !props.enableRowSelection && index === 0) && !((_row$getParentRow = row.getParentRow()) !== null && _row$getParentRow !== void 0 && _row$getParentRow.getIsGrouped()) && (0, $gDiFE.xcss)({
                            //@ts-expect-error needed for logic
                            // eslint-disable-next-line @compiled/no-suppress-xcss
                            paddingInlineStart: "".concat(row.depth * 8, "px")
                        })
                    ]
                }, row.getCanExpand() && (props.enableRowSelection && index === 1 || !props.enableRowSelection && index === 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), {
                    xcss: $73456febbcc7b492$var$SubRowButtonWrapperStyle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5yfDB.default), {
                    spacing: "compact",
                    testId: "expand-row-button",
                    interactionName: props.interactionName,
                    analyticsContext: $73456febbcc7b492$var$_objectSpread({
                        componentName: 'charlieTableExpandRowButton'
                    }, props.analyticsContext),
                    appearance: "subtle",
                    "aria-pressed": row.getIsExpanded(),
                    label: labels.expandRow,
                    icon: function icon(iconProps) {
                        var _row$getIsExpanded2;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cMkZu.ExpandIcon), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                            isExpanded: (_row$getIsExpanded2 = row.getIsExpanded()) !== null && _row$getIsExpanded2 !== void 0 ? _row$getIsExpanded2 : false
                        }, iconProps));
                    },
                    onClick: function onClick(e) {
                        e.stopPropagation();
                        row.toggleExpanded();
                    }
                })), (0, $kGO2D.flexRender)(cell.column.columnDef.cell, cell.getContext())));
            })), row.getIsExpanded() && props.renderChildComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, props === null || props === void 0 ? void 0 : props.renderChildComponent({
                rowData: row,
                tableState: table.getState()
            })), props.hasNext && //we pagination with child components is not supported yet
            !props.renderChildComponent && index === Math.floor(((_table$getRowModel$ro = (_table$getRowModel$ro2 = table.getRowModel().rows) === null || _table$getRowModel$ro2 === void 0 ? void 0 : _table$getRowModel$ro2.length) !== null && _table$getRowModel$ro !== void 0 ? _table$getRowModel$ro : 0) * 0.92) && /*#__PURE__*/ // if user is 92% through the table, load more rows
            (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("tr", {
                key: 'loadMoreTrigger',
                ref: infiniteScrollRef
            }));
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null));
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        rowSpacing,
        table.options.state.rowSelection,
        table.options.state.sorting,
        table.options.state.expanded,
        table.options.state.columnOrder,
        table.options.state.grouping,
        table.options.state.columnVisibility,
        table.options.data
    ])), (props.hasNext != null && props.onLoadNext != null || props.isLoading != null) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1qQas.Inline), {
        xcss: $73456febbcc7b492$var$FooterStyles
    }, props.hasNext && props.onLoadNext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), {
        xcss: $73456febbcc7b492$var$LoadMoreWrapperStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dUWEU.default), {
        testId: "prev-page-test-id",
        isLoading: props.isLoading || tableState === $73456febbcc7b492$export$3d6dc94c3b008646.loading,
        onClick: function onClick() {
            var _props$onLoadNext2;
            (_props$onLoadNext2 = props.onLoadNext) === null || _props$onLoadNext2 === void 0 || _props$onLoadNext2.call(props);
        },
        "aria-label": labels.loadMoreLabel,
        spacing: "compact"
    }, labels.loadMore)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, !(isEmptyState || tableState === $73456febbcc7b492$export$3d6dc94c3b008646.error || props.hidePaginationEndIndicator) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), {
        as: "hr",
        testId: "table-footer-divider",
        xcss: $73456febbcc7b492$var$FooterDividerStyles,
        role: "presentation"
    }))), (props.isLoading || tableState === $73456febbcc7b492$export$3d6dc94c3b008646.loading) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $2kuK2.Flex), {
        xcss: $73456febbcc7b492$var$LoadingOverlayStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9ztDu.default), {
        size: "large",
        testId: "common-table-spinner"
    })), tableState === $73456febbcc7b492$export$3d6dc94c3b008646.error && props.errorView, isEmptyState && props.emptyTableView));
};

});
parcelRegister("kGO2D", function(module, exports) {
$parcel$export(module.exports, "createColumnHelper", () => (parcelRequire("e6OxX")).createColumnHelper);
$parcel$export(module.exports, "createRow", () => (parcelRequire("e6OxX")).createRow);
$parcel$export(module.exports, "createTable", () => (parcelRequire("e6OxX")).createTable);
$parcel$export(module.exports, "flattenBy", () => (parcelRequire("e6OxX")).flattenBy);
$parcel$export(module.exports, "functionalUpdate", () => (parcelRequire("e6OxX")).functionalUpdate);
$parcel$export(module.exports, "getCoreRowModel", () => (parcelRequire("e6OxX")).getCoreRowModel);
$parcel$export(module.exports, "getExpandedRowModel", () => (parcelRequire("e6OxX")).getExpandedRowModel);
$parcel$export(module.exports, "getGroupedRowModel", () => (parcelRequire("e6OxX")).getGroupedRowModel);
$parcel$export(module.exports, "getMemoOptions", () => (parcelRequire("e6OxX")).getMemoOptions);
$parcel$export(module.exports, "getSortedRowModel", () => (parcelRequire("e6OxX")).getSortedRowModel);
$parcel$export(module.exports, "memo", () => (parcelRequire("e6OxX")).memo);
$parcel$export(module.exports, "flexRender", () => $f0fe8c1560dd2b1d$export$f2385bb6e3ac4b4f);
$parcel$export(module.exports, "useReactTable", () => $f0fe8c1560dd2b1d$export$25eaeb3743e6b31f);
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */ 
var $5FkrB = parcelRequire("5FkrB");

var $e6OxX = parcelRequire("e6OxX");
//
/**
 * If rendering headers, cells, or footers with custom markup, use flexRender instead of `cell.getValue()` or `cell.renderValue()`.
 */ function $f0fe8c1560dd2b1d$export$f2385bb6e3ac4b4f(Comp, props) {
    return !Comp ? null : $f0fe8c1560dd2b1d$var$isReactComponent(Comp) ? /*#__PURE__*/ $5FkrB.createElement(Comp, props) : Comp;
}
function $f0fe8c1560dd2b1d$var$isReactComponent(component) {
    return $f0fe8c1560dd2b1d$var$isClassComponent(component) || typeof component === 'function' || $f0fe8c1560dd2b1d$var$isExoticComponent(component);
}
function $f0fe8c1560dd2b1d$var$isClassComponent(component) {
    return typeof component === 'function' && (()=>{
        const proto = Object.getPrototypeOf(component);
        return proto.prototype && proto.prototype.isReactComponent;
    })();
}
function $f0fe8c1560dd2b1d$var$isExoticComponent(component) {
    return typeof component === 'object' && typeof component.$$typeof === 'symbol' && [
        'react.memo',
        'react.forward_ref'
    ].includes(component.$$typeof.description);
}
function $f0fe8c1560dd2b1d$export$25eaeb3743e6b31f(options) {
    // Compose in the generic options to the user options
    const resolvedOptions = {
        state: {},
        // Dummy state
        onStateChange: ()=>{},
        // noop
        renderFallbackValue: null,
        ...options
    };
    // Create a new table and store it in state
    const [tableRef] = $5FkrB.useState(()=>({
            current: (0, $e6OxX.createTable)(resolvedOptions)
        }));
    // By default, manage table state here using the table's initial state
    const [state, setState] = $5FkrB.useState(()=>tableRef.current.initialState);
    // Compose the default state above with any user state. This will allow the user
    // to only control a subset of the state if desired.
    tableRef.current.setOptions((prev)=>({
            ...prev,
            ...options,
            state: {
                ...state,
                ...options.state
            },
            // Similarly, we'll maintain both our internal state and any user-provided
            // state.
            onStateChange: (updater)=>{
                setState(updater);
                options.onStateChange == null || options.onStateChange(updater);
            }
        }));
    return tableRef.current;
}

});
parcelRegister("e6OxX", function(module, exports) {
$parcel$export(module.exports, "createColumnHelper", () => $a458d5bea2d12b69$export$4b44a5cb9651fe5e);
$parcel$export(module.exports, "functionalUpdate", () => $a458d5bea2d12b69$export$7f095f455ad5af3f);
$parcel$export(module.exports, "flattenBy", () => $a458d5bea2d12b69$export$bf4548421d1b2c8);
$parcel$export(module.exports, "memo", () => $a458d5bea2d12b69$export$7c73462e0d25e514);
$parcel$export(module.exports, "getMemoOptions", () => $a458d5bea2d12b69$export$b1f82222dc43996c);
$parcel$export(module.exports, "createRow", () => $a458d5bea2d12b69$export$3442c5d213434705);
$parcel$export(module.exports, "createTable", () => $a458d5bea2d12b69$export$33bbb3ec7652e187);
$parcel$export(module.exports, "getCoreRowModel", () => $a458d5bea2d12b69$export$32d0bc001e828250);
$parcel$export(module.exports, "getExpandedRowModel", () => $a458d5bea2d12b69$export$53cfec7b1b8d1fcd);
$parcel$export(module.exports, "getGroupedRowModel", () => $a458d5bea2d12b69$export$2b7f4b57ce71b81);
$parcel$export(module.exports, "getSortedRowModel", () => $a458d5bea2d12b69$export$4ca93ca80835d8c1);
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */ // type Person = {
//   firstName: string
//   lastName: string
//   age: number
//   visits: number
//   status: string
//   progress: number
//   createdAt: Date
//   nested: {
//     foo: [
//       {
//         bar: 'bar'
//       }
//     ]
//     bar: { subBar: boolean }[]
//     baz: {
//       foo: 'foo'
//       bar: {
//         baz: 'baz'
//       }
//     }
//   }
// }
// const test: DeepKeys<Person> = 'nested.foo.0.bar'
// const test2: DeepKeys<Person> = 'nested.bar'
// const helper = createColumnHelper<Person>()
// helper.accessor('nested.foo', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.foo.0.bar', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.bar', {
//   cell: info => info.getValue(),
// })
function $a458d5bea2d12b69$export$4b44a5cb9651fe5e() {
    return {
        accessor: (accessor, column)=>{
            return typeof accessor === 'function' ? {
                ...column,
                accessorFn: accessor
            } : {
                ...column,
                accessorKey: accessor
            };
        },
        display: (column)=>column,
        group: (column)=>column
    };
}
// Is this type a tuple?
// If this type is a tuple, what indices are allowed?
///
function $a458d5bea2d12b69$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === 'function' ? updater(input) : updater;
}
function $a458d5bea2d12b69$export$8793edee2d425525() {
//
}
function $a458d5bea2d12b69$export$2b5605d8069324bd(key, instance) {
    return (updater)=>{
        instance.setState((old)=>{
            return {
                ...old,
                [key]: $a458d5bea2d12b69$export$7f095f455ad5af3f(updater, old[key])
            };
        });
    };
}
function $a458d5bea2d12b69$export$f6e2535fb5126e54(d) {
    return d instanceof Function;
}
function $a458d5bea2d12b69$export$5cd576d1827d40c8(d) {
    return Array.isArray(d) && d.every((val)=>typeof val === 'number');
}
function $a458d5bea2d12b69$export$bf4548421d1b2c8(arr, getChildren) {
    const flat = [];
    const recurse = (subArr)=>{
        subArr.forEach((item)=>{
            flat.push(item);
            const children = getChildren(item);
            if (children != null && children.length) recurse(children);
        });
    };
    recurse(arr);
    return flat;
}
function $a458d5bea2d12b69$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = [];
    let result;
    return (depArgs)=>{
        let depTime;
        if (opts.key && opts.debug) depTime = Date.now();
        const newDeps = getDeps(depArgs);
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && opts.debug) resultTime = Date.now();
        result = fn(...newDeps);
        opts == null || opts.onChange == null || opts.onChange(result);
        if (opts.key && opts.debug) {
            if (opts != null && opts.debug()) {
                const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
                const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
                const resultFpsPercentage = resultEndTime / 16;
                const pad = (str, num)=>{
                    str = String(str);
                    while(str.length < num)str = ' ' + str;
                    return str;
                };
                console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
            }
        }
        return result;
    };
}
function $a458d5bea2d12b69$export$b1f82222dc43996c(tableOptions, debugLevel, key, onChange) {
    return {
        debug: ()=>{
            var _tableOptions$debugAl;
            return (_tableOptions$debugAl = tableOptions == null ? void 0 : tableOptions.debugAll) != null ? _tableOptions$debugAl : tableOptions[debugLevel];
        },
        key: false,
        onChange: onChange
    };
}
function $a458d5bea2d12b69$export$3cb21b6b1233300e(table, row, column, columnId) {
    const getRenderValue = ()=>{
        var _cell$getValue;
        return (_cell$getValue = cell.getValue()) != null ? _cell$getValue : table.options.renderFallbackValue;
    };
    const cell = {
        id: `${row.id}_${column.id}`,
        row: row,
        column: column,
        getValue: ()=>row.getValue(columnId),
        renderValue: getRenderValue,
        getContext: $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table,
                column,
                row,
                cell
            ], (table, column, row, cell)=>({
                table: table,
                column: column,
                row: row,
                cell: cell,
                getValue: cell.getValue,
                renderValue: cell.renderValue
            }), $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugCells', 'cell.getContext'))
    };
    table._features.forEach((feature)=>{
        feature.createCell == null || feature.createCell(cell, column, row, table);
    }, {});
    return cell;
}
function $a458d5bea2d12b69$export$1bfa986e9c92c0b5(table, columnDef, depth, parent) {
    var _ref, _resolvedColumnDef$id;
    const defaultColumn = table._getDefaultColumnDef();
    const resolvedColumnDef = {
        ...defaultColumn,
        ...columnDef
    };
    const accessorKey = resolvedColumnDef.accessorKey;
    let id = (_ref = (_resolvedColumnDef$id = resolvedColumnDef.id) != null ? _resolvedColumnDef$id : accessorKey ? typeof String.prototype.replaceAll === 'function' ? accessorKey.replaceAll('.', '_') : accessorKey.replace(/\./g, '_') : undefined) != null ? _ref : typeof resolvedColumnDef.header === 'string' ? resolvedColumnDef.header : undefined;
    let accessorFn;
    if (resolvedColumnDef.accessorFn) accessorFn = resolvedColumnDef.accessorFn;
    else if (accessorKey) {
        // Support deep accessor keys
        if (accessorKey.includes('.')) accessorFn = (originalRow)=>{
            let result = originalRow;
            for (const key of accessorKey.split('.')){
                var _result;
                result = (_result = result) == null ? void 0 : _result[key];
            }
            return result;
        };
        else accessorFn = (originalRow)=>originalRow[resolvedColumnDef.accessorKey];
    }
    if (!id) throw new Error();
    let column = {
        id: `${String(id)}`,
        accessorFn: accessorFn,
        parent: parent,
        depth: depth,
        columnDef: resolvedColumnDef,
        columns: [],
        getFlatColumns: $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                true
            ], ()=>{
            var _column$columns;
            return [
                column,
                ...(_column$columns = column.columns) == null ? void 0 : _column$columns.flatMap((d)=>d.getFlatColumns())
            ];
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugColumns', 'column.getFlatColumns')),
        getLeafColumns: $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table._getOrderColumnsFn()
            ], (orderColumns)=>{
            var _column$columns2;
            if ((_column$columns2 = column.columns) != null && _column$columns2.length) {
                let leafColumns = column.columns.flatMap((column)=>column.getLeafColumns());
                return orderColumns(leafColumns);
            }
            return [
                column
            ];
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugColumns', 'column.getLeafColumns'))
    };
    for (const feature of table._features)feature.createColumn == null || feature.createColumn(column, table);
    // Yes, we have to convert table to unknown, because we know more than the compiler here.
    return column;
}
const $a458d5bea2d12b69$var$debug = 'debugHeaders';
//
function $a458d5bea2d12b69$var$createHeader(table, column, options) {
    var _options$id;
    const id = (_options$id = options.id) != null ? _options$id : column.id;
    let header = {
        id: id,
        column: column,
        index: options.index,
        isPlaceholder: !!options.isPlaceholder,
        placeholderId: options.placeholderId,
        depth: options.depth,
        subHeaders: [],
        colSpan: 0,
        rowSpan: 0,
        headerGroup: null,
        getLeafHeaders: ()=>{
            const leafHeaders = [];
            const recurseHeader = (h)=>{
                if (h.subHeaders && h.subHeaders.length) h.subHeaders.map(recurseHeader);
                leafHeaders.push(h);
            };
            recurseHeader(header);
            return leafHeaders;
        },
        getContext: ()=>({
                table: table,
                header: header,
                column: column
            })
    };
    table._features.forEach((feature)=>{
        feature.createHeader == null || feature.createHeader(header, table);
    });
    return header;
}
const $a458d5bea2d12b69$export$79b704688b15c0f4 = {
    createTable: (table)=>{
        // Header Groups
        table.getHeaderGroups = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, left, right)=>{
            var _left$map$filter, _right$map$filter;
            const leftColumns = (_left$map$filter = left == null ? void 0 : left.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _left$map$filter : [];
            const rightColumns = (_right$map$filter = right == null ? void 0 : right.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _right$map$filter : [];
            const centerColumns = leafColumns.filter((column)=>!(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
            const headerGroups = $a458d5bea2d12b69$export$d8c3a8af36458fc3(allColumns, [
                ...leftColumns,
                ...centerColumns,
                ...rightColumns
            ], table);
            return headerGroups;
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getHeaderGroups'));
        table.getCenterHeaderGroups = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, left, right)=>{
            leafColumns = leafColumns.filter((column)=>!(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
            return $a458d5bea2d12b69$export$d8c3a8af36458fc3(allColumns, leafColumns, table, 'center');
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getCenterHeaderGroups'));
        table.getLeftHeaderGroups = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left
            ], (allColumns, leafColumns, left)=>{
            var _left$map$filter2;
            const orderedLeafColumns = (_left$map$filter2 = left == null ? void 0 : left.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _left$map$filter2 : [];
            return $a458d5bea2d12b69$export$d8c3a8af36458fc3(allColumns, orderedLeafColumns, table, 'left');
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getLeftHeaderGroups'));
        table.getRightHeaderGroups = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, right)=>{
            var _right$map$filter2;
            const orderedLeafColumns = (_right$map$filter2 = right == null ? void 0 : right.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _right$map$filter2 : [];
            return $a458d5bea2d12b69$export$d8c3a8af36458fc3(allColumns, orderedLeafColumns, table, 'right');
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getRightHeaderGroups'));
        // Footer Groups
        table.getFooterGroups = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getFooterGroups'));
        table.getLeftFooterGroups = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getLeftHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getLeftFooterGroups'));
        table.getCenterFooterGroups = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getCenterHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getCenterFooterGroups'));
        table.getRightFooterGroups = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getRightHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getRightFooterGroups'));
        // Flat Headers
        table.getFlatHeaders = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getHeaderGroups()
            ], (headerGroups)=>{
            return headerGroups.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getFlatHeaders'));
        table.getLeftFlatHeaders = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getLeftHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getLeftFlatHeaders'));
        table.getCenterFlatHeaders = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getCenterHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getCenterFlatHeaders'));
        table.getRightFlatHeaders = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getRightHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getRightFlatHeaders'));
        // Leaf Headers
        table.getCenterLeafHeaders = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getCenterFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders;
                return !((_header$subHeaders = header.subHeaders) != null && _header$subHeaders.length);
            });
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getCenterLeafHeaders'));
        table.getLeftLeafHeaders = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getLeftFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders2;
                return !((_header$subHeaders2 = header.subHeaders) != null && _header$subHeaders2.length);
            });
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getLeftLeafHeaders'));
        table.getRightLeafHeaders = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getRightFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders3;
                return !((_header$subHeaders3 = header.subHeaders) != null && _header$subHeaders3.length);
            });
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getRightLeafHeaders'));
        table.getLeafHeaders = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getLeftHeaderGroups(),
                table.getCenterHeaderGroups(),
                table.getRightHeaderGroups()
            ], (left, center, right)=>{
            var _left$0$headers, _left$, _center$0$headers, _center$, _right$0$headers, _right$;
            return [
                ...(_left$0$headers = (_left$ = left[0]) == null ? void 0 : _left$.headers) != null ? _left$0$headers : [],
                ...(_center$0$headers = (_center$ = center[0]) == null ? void 0 : _center$.headers) != null ? _center$0$headers : [],
                ...(_right$0$headers = (_right$ = right[0]) == null ? void 0 : _right$.headers) != null ? _right$0$headers : []
            ].map((header)=>{
                return header.getLeafHeaders();
            }).flat();
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getLeafHeaders'));
    }
};
function $a458d5bea2d12b69$export$d8c3a8af36458fc3(allColumns, columnsToGroup, table, headerFamily) {
    var _headerGroups$0$heade, _headerGroups$;
    // Find the max depth of the columns:
    // build the leaf column row
    // build each buffer row going up
    //    placeholder for non-existent level
    //    real column for existing level
    let maxDepth = 0;
    const findMaxDepth = function(columns, depth) {
        if (depth === void 0) depth = 1;
        maxDepth = Math.max(maxDepth, depth);
        columns.filter((column)=>column.getIsVisible()).forEach((column)=>{
            var _column$columns;
            if ((_column$columns = column.columns) != null && _column$columns.length) findMaxDepth(column.columns, depth + 1);
        }, 0);
    };
    findMaxDepth(allColumns);
    let headerGroups = [];
    const createHeaderGroup = (headersToGroup, depth)=>{
        // The header group we are creating
        const headerGroup = {
            depth: depth,
            id: [
                headerFamily,
                `${depth}`
            ].filter(Boolean).join('_'),
            headers: []
        };
        // The parent columns we're going to scan next
        const pendingParentHeaders = [];
        // Scan each column for parents
        headersToGroup.forEach((headerToGroup)=>{
            // What is the latest (last) parent column?
            const latestPendingParentHeader = [
                ...pendingParentHeaders
            ].reverse()[0];
            const isLeafHeader = headerToGroup.column.depth === headerGroup.depth;
            let column;
            let isPlaceholder = false;
            if (isLeafHeader && headerToGroup.column.parent) // The parent header is new
            column = headerToGroup.column.parent;
            else {
                // The parent header is repeated
                column = headerToGroup.column;
                isPlaceholder = true;
            }
            if (latestPendingParentHeader && (latestPendingParentHeader == null ? void 0 : latestPendingParentHeader.column) === column) // This column is repeated. Add it as a sub header to the next batch
            latestPendingParentHeader.subHeaders.push(headerToGroup);
            else {
                // This is a new header. Let's create it
                const header = $a458d5bea2d12b69$var$createHeader(table, column, {
                    id: [
                        headerFamily,
                        depth,
                        column.id,
                        headerToGroup == null ? void 0 : headerToGroup.id
                    ].filter(Boolean).join('_'),
                    isPlaceholder: isPlaceholder,
                    placeholderId: isPlaceholder ? `${pendingParentHeaders.filter((d)=>d.column === column).length}` : undefined,
                    depth: depth,
                    index: pendingParentHeaders.length
                });
                // Add the headerToGroup as a subHeader of the new header
                header.subHeaders.push(headerToGroup);
                // Add the new header to the pendingParentHeaders to get grouped
                // in the next batch
                pendingParentHeaders.push(header);
            }
            headerGroup.headers.push(headerToGroup);
            headerToGroup.headerGroup = headerGroup;
        });
        headerGroups.push(headerGroup);
        if (depth > 0) createHeaderGroup(pendingParentHeaders, depth - 1);
    };
    const bottomHeaders = columnsToGroup.map((column, index)=>$a458d5bea2d12b69$var$createHeader(table, column, {
            depth: maxDepth,
            index: index
        }));
    createHeaderGroup(bottomHeaders, maxDepth - 1);
    headerGroups.reverse();
    // headerGroups = headerGroups.filter(headerGroup => {
    //   return !headerGroup.headers.every(header => header.isPlaceholder)
    // })
    const recurseHeadersForSpans = (headers)=>{
        const filteredHeaders = headers.filter((header)=>header.column.getIsVisible());
        return filteredHeaders.map((header)=>{
            let colSpan = 0;
            let rowSpan = 0;
            let childRowSpans = [
                0
            ];
            if (header.subHeaders && header.subHeaders.length) {
                childRowSpans = [];
                recurseHeadersForSpans(header.subHeaders).forEach((_ref)=>{
                    let { colSpan: childColSpan, rowSpan: childRowSpan } = _ref;
                    colSpan += childColSpan;
                    childRowSpans.push(childRowSpan);
                });
            } else colSpan = 1;
            const minChildRowSpan = Math.min(...childRowSpans);
            rowSpan = rowSpan + minChildRowSpan;
            header.colSpan = colSpan;
            header.rowSpan = rowSpan;
            return {
                colSpan: colSpan,
                rowSpan: rowSpan
            };
        });
    };
    recurseHeadersForSpans((_headerGroups$0$heade = (_headerGroups$ = headerGroups[0]) == null ? void 0 : _headerGroups$.headers) != null ? _headerGroups$0$heade : []);
    return headerGroups;
}
const $a458d5bea2d12b69$export$3442c5d213434705 = (table, id, original, rowIndex, depth, subRows, parentId)=>{
    let row = {
        id: id,
        index: rowIndex,
        original: original,
        depth: depth,
        parentId: parentId,
        _valuesCache: {},
        _uniqueValuesCache: {},
        getValue: (columnId)=>{
            if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            row._valuesCache[columnId] = column.accessorFn(row.original, rowIndex);
            return row._valuesCache[columnId];
        },
        getUniqueValues: (columnId)=>{
            if (row._uniqueValuesCache.hasOwnProperty(columnId)) return row._uniqueValuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            if (!column.columnDef.getUniqueValues) {
                row._uniqueValuesCache[columnId] = [
                    row.getValue(columnId)
                ];
                return row._uniqueValuesCache[columnId];
            }
            row._uniqueValuesCache[columnId] = column.columnDef.getUniqueValues(row.original, rowIndex);
            return row._uniqueValuesCache[columnId];
        },
        renderValue: (columnId)=>{
            var _row$getValue;
            return (_row$getValue = row.getValue(columnId)) != null ? _row$getValue : table.options.renderFallbackValue;
        },
        subRows: subRows != null ? subRows : [],
        getLeafRows: ()=>$a458d5bea2d12b69$export$bf4548421d1b2c8(row.subRows, (d)=>d.subRows),
        getParentRow: ()=>row.parentId ? table.getRow(row.parentId, true) : undefined,
        getParentRows: ()=>{
            let parentRows = [];
            let currentRow = row;
            while(true){
                const parentRow = currentRow.getParentRow();
                if (!parentRow) break;
                parentRows.push(parentRow);
                currentRow = parentRow;
            }
            return parentRows.reverse();
        },
        getAllCells: $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns()
            ], (leafColumns)=>{
            return leafColumns.map((column)=>{
                return $a458d5bea2d12b69$export$3cb21b6b1233300e(table, row, column, column.id);
            });
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugRows', 'getAllCells')),
        _getAllCellsByColumnId: $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                row.getAllCells()
            ], (allCells)=>{
            return allCells.reduce((acc, cell)=>{
                acc[cell.column.id] = cell;
                return acc;
            }, {});
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugRows', 'getAllCellsByColumnId'))
    };
    for(let i = 0; i < table._features.length; i++){
        const feature = table._features[i];
        feature == null || feature.createRow == null || feature.createRow(row, table);
    }
    return row;
};
//
const $a458d5bea2d12b69$export$1f746e6a9cd841b1 = {
    createColumn: (column, table)=>{
        column._getFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, column.id);
        column.getFacetedRowModel = ()=>{
            if (!column._getFacetedRowModel) return table.getPreFilteredRowModel();
            return column._getFacetedRowModel();
        };
        column._getFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, column.id);
        column.getFacetedUniqueValues = ()=>{
            if (!column._getFacetedUniqueValues) return new Map();
            return column._getFacetedUniqueValues();
        };
        column._getFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, column.id);
        column.getFacetedMinMaxValues = ()=>{
            if (!column._getFacetedMinMaxValues) return undefined;
            return column._getFacetedMinMaxValues();
        };
    }
};
const $a458d5bea2d12b69$var$includesString = (row, columnId, filterValue)=>{
    var _filterValue$toString, _row$getValue;
    const search = filterValue == null || (_filterValue$toString = filterValue.toString()) == null ? void 0 : _filterValue$toString.toLowerCase();
    return Boolean((_row$getValue = row.getValue(columnId)) == null || (_row$getValue = _row$getValue.toString()) == null || (_row$getValue = _row$getValue.toLowerCase()) == null ? void 0 : _row$getValue.includes(search));
};
$a458d5bea2d12b69$var$includesString.autoRemove = (val)=>$a458d5bea2d12b69$var$testFalsey(val);
const $a458d5bea2d12b69$var$includesStringSensitive = (row, columnId, filterValue)=>{
    var _row$getValue2;
    return Boolean((_row$getValue2 = row.getValue(columnId)) == null || (_row$getValue2 = _row$getValue2.toString()) == null ? void 0 : _row$getValue2.includes(filterValue));
};
$a458d5bea2d12b69$var$includesStringSensitive.autoRemove = (val)=>$a458d5bea2d12b69$var$testFalsey(val);
const $a458d5bea2d12b69$var$equalsString = (row, columnId, filterValue)=>{
    var _row$getValue3;
    return ((_row$getValue3 = row.getValue(columnId)) == null || (_row$getValue3 = _row$getValue3.toString()) == null ? void 0 : _row$getValue3.toLowerCase()) === (filterValue == null ? void 0 : filterValue.toLowerCase());
};
$a458d5bea2d12b69$var$equalsString.autoRemove = (val)=>$a458d5bea2d12b69$var$testFalsey(val);
const $a458d5bea2d12b69$var$arrIncludes = (row, columnId, filterValue)=>{
    var _row$getValue4;
    return (_row$getValue4 = row.getValue(columnId)) == null ? void 0 : _row$getValue4.includes(filterValue);
};
$a458d5bea2d12b69$var$arrIncludes.autoRemove = (val)=>$a458d5bea2d12b69$var$testFalsey(val);
const $a458d5bea2d12b69$var$arrIncludesAll = (row, columnId, filterValue)=>{
    return !filterValue.some((val)=>{
        var _row$getValue5;
        return !((_row$getValue5 = row.getValue(columnId)) != null && _row$getValue5.includes(val));
    });
};
$a458d5bea2d12b69$var$arrIncludesAll.autoRemove = (val)=>$a458d5bea2d12b69$var$testFalsey(val) || !(val != null && val.length);
const $a458d5bea2d12b69$var$arrIncludesSome = (row, columnId, filterValue)=>{
    return filterValue.some((val)=>{
        var _row$getValue6;
        return (_row$getValue6 = row.getValue(columnId)) == null ? void 0 : _row$getValue6.includes(val);
    });
};
$a458d5bea2d12b69$var$arrIncludesSome.autoRemove = (val)=>$a458d5bea2d12b69$var$testFalsey(val) || !(val != null && val.length);
const $a458d5bea2d12b69$var$equals = (row, columnId, filterValue)=>{
    return row.getValue(columnId) === filterValue;
};
$a458d5bea2d12b69$var$equals.autoRemove = (val)=>$a458d5bea2d12b69$var$testFalsey(val);
const $a458d5bea2d12b69$var$weakEquals = (row, columnId, filterValue)=>{
    return row.getValue(columnId) == filterValue;
};
$a458d5bea2d12b69$var$weakEquals.autoRemove = (val)=>$a458d5bea2d12b69$var$testFalsey(val);
const $a458d5bea2d12b69$var$inNumberRange = (row, columnId, filterValue)=>{
    let [min, max] = filterValue;
    const rowValue = row.getValue(columnId);
    return rowValue >= min && rowValue <= max;
};
$a458d5bea2d12b69$var$inNumberRange.resolveFilterValue = (val)=>{
    let [unsafeMin, unsafeMax] = val;
    let parsedMin = typeof unsafeMin !== 'number' ? parseFloat(unsafeMin) : unsafeMin;
    let parsedMax = typeof unsafeMax !== 'number' ? parseFloat(unsafeMax) : unsafeMax;
    let min = unsafeMin === null || Number.isNaN(parsedMin) ? -Infinity : parsedMin;
    let max = unsafeMax === null || Number.isNaN(parsedMax) ? Infinity : parsedMax;
    if (min > max) {
        const temp = min;
        min = max;
        max = temp;
    }
    return [
        min,
        max
    ];
};
$a458d5bea2d12b69$var$inNumberRange.autoRemove = (val)=>$a458d5bea2d12b69$var$testFalsey(val) || $a458d5bea2d12b69$var$testFalsey(val[0]) && $a458d5bea2d12b69$var$testFalsey(val[1]);
// Export
const $a458d5bea2d12b69$export$6ad8312e296ec316 = {
    includesString: $a458d5bea2d12b69$var$includesString,
    includesStringSensitive: $a458d5bea2d12b69$var$includesStringSensitive,
    equalsString: $a458d5bea2d12b69$var$equalsString,
    arrIncludes: $a458d5bea2d12b69$var$arrIncludes,
    arrIncludesAll: $a458d5bea2d12b69$var$arrIncludesAll,
    arrIncludesSome: $a458d5bea2d12b69$var$arrIncludesSome,
    equals: $a458d5bea2d12b69$var$equals,
    weakEquals: $a458d5bea2d12b69$var$weakEquals,
    inNumberRange: $a458d5bea2d12b69$var$inNumberRange
};
// Utils
function $a458d5bea2d12b69$var$testFalsey(val) {
    return val === undefined || val === null || val === '';
}
//
const $a458d5bea2d12b69$export$f1d67534a0c5e9d3 = {
    getDefaultColumnDef: ()=>{
        return {
            filterFn: 'auto'
        };
    },
    getInitialState: (state)=>{
        return {
            columnFilters: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnFiltersChange: $a458d5bea2d12b69$export$2b5605d8069324bd('columnFilters', table),
            filterFromLeafRows: false,
            maxLeafRowFilterDepth: 100
        };
    },
    createColumn: (column, table)=>{
        column.getAutoFilterFn = ()=>{
            const firstRow = table.getCoreRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === 'string') return $a458d5bea2d12b69$export$6ad8312e296ec316.includesString;
            if (typeof value === 'number') return $a458d5bea2d12b69$export$6ad8312e296ec316.inNumberRange;
            if (typeof value === 'boolean') return $a458d5bea2d12b69$export$6ad8312e296ec316.equals;
            if (value !== null && typeof value === 'object') return $a458d5bea2d12b69$export$6ad8312e296ec316.equals;
            if (Array.isArray(value)) return $a458d5bea2d12b69$export$6ad8312e296ec316.arrIncludes;
            return $a458d5bea2d12b69$export$6ad8312e296ec316.weakEquals;
        };
        column.getFilterFn = ()=>{
            var _table$options$filter, _table$options$filter2;
            return $a458d5bea2d12b69$export$f6e2535fb5126e54(column.columnDef.filterFn) ? column.columnDef.filterFn : column.columnDef.filterFn === 'auto' ? column.getAutoFilterFn() : (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[column.columnDef.filterFn]) != null ? _table$options$filter : $a458d5bea2d12b69$export$6ad8312e296ec316[column.columnDef.filterFn];
        };
        column.getCanFilter = ()=>{
            var _column$columnDef$ena, _table$options$enable, _table$options$enable2;
            return ((_column$columnDef$ena = column.columnDef.enableColumnFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnFilters) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && !!column.accessorFn;
        };
        column.getIsFiltered = ()=>column.getFilterIndex() > -1;
        column.getFilterValue = ()=>{
            var _table$getState$colum;
            return (_table$getState$colum = table.getState().columnFilters) == null || (_table$getState$colum = _table$getState$colum.find((d)=>d.id === column.id)) == null ? void 0 : _table$getState$colum.value;
        };
        column.getFilterIndex = ()=>{
            var _table$getState$colum2, _table$getState$colum3;
            return (_table$getState$colum2 = (_table$getState$colum3 = table.getState().columnFilters) == null ? void 0 : _table$getState$colum3.findIndex((d)=>d.id === column.id)) != null ? _table$getState$colum2 : -1;
        };
        column.setFilterValue = (value)=>{
            table.setColumnFilters((old)=>{
                const filterFn = column.getFilterFn();
                const previousFilter = old == null ? void 0 : old.find((d)=>d.id === column.id);
                const newFilter = $a458d5bea2d12b69$export$7f095f455ad5af3f(value, previousFilter ? previousFilter.value : undefined);
                //
                if ($a458d5bea2d12b69$export$5b01eb94d7ce58a8(filterFn, newFilter, column)) {
                    var _old$filter;
                    return (_old$filter = old == null ? void 0 : old.filter((d)=>d.id !== column.id)) != null ? _old$filter : [];
                }
                const newFilterObj = {
                    id: column.id,
                    value: newFilter
                };
                if (previousFilter) {
                    var _old$map;
                    return (_old$map = old == null ? void 0 : old.map((d)=>{
                        if (d.id === column.id) return newFilterObj;
                        return d;
                    })) != null ? _old$map : [];
                }
                if (old != null && old.length) return [
                    ...old,
                    newFilterObj
                ];
                return [
                    newFilterObj
                ];
            });
        };
    },
    createRow: (row, _table)=>{
        row.columnFilters = {};
        row.columnFiltersMeta = {};
    },
    createTable: (table)=>{
        table.setColumnFilters = (updater)=>{
            const leafColumns = table.getAllLeafColumns();
            const updateFn = (old)=>{
                var _functionalUpdate;
                return (_functionalUpdate = $a458d5bea2d12b69$export$7f095f455ad5af3f(updater, old)) == null ? void 0 : _functionalUpdate.filter((filter)=>{
                    const column = leafColumns.find((d)=>d.id === filter.id);
                    if (column) {
                        const filterFn = column.getFilterFn();
                        if ($a458d5bea2d12b69$export$5b01eb94d7ce58a8(filterFn, filter.value, column)) return false;
                    }
                    return true;
                });
            };
            table.options.onColumnFiltersChange == null || table.options.onColumnFiltersChange(updateFn);
        };
        table.resetColumnFilters = (defaultState)=>{
            var _table$initialState$c, _table$initialState;
            table.setColumnFilters(defaultState ? [] : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnFilters) != null ? _table$initialState$c : []);
        };
        table.getPreFilteredRowModel = ()=>table.getCoreRowModel();
        table.getFilteredRowModel = ()=>{
            if (!table._getFilteredRowModel && table.options.getFilteredRowModel) table._getFilteredRowModel = table.options.getFilteredRowModel(table);
            if (table.options.manualFiltering || !table._getFilteredRowModel) return table.getPreFilteredRowModel();
            return table._getFilteredRowModel();
        };
    }
};
function $a458d5bea2d12b69$export$5b01eb94d7ce58a8(filterFn, value, column) {
    return (filterFn && filterFn.autoRemove ? filterFn.autoRemove(value, column) : false) || typeof value === 'undefined' || typeof value === 'string' && !value;
}
const $a458d5bea2d12b69$var$sum = (columnId, _leafRows, childRows)=>{
    // It's faster to just add the aggregations together instead of
    // process leaf nodes individually
    return childRows.reduce((sum, next)=>{
        const nextValue = next.getValue(columnId);
        return sum + (typeof nextValue === 'number' ? nextValue : 0);
    }, 0);
};
const $a458d5bea2d12b69$var$min = (columnId, _leafRows, childRows)=>{
    let min;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null && (min > value || min === undefined && value >= value)) min = value;
    });
    return min;
};
const $a458d5bea2d12b69$var$max = (columnId, _leafRows, childRows)=>{
    let max;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null && (max < value || max === undefined && value >= value)) max = value;
    });
    return max;
};
const $a458d5bea2d12b69$var$extent = (columnId, _leafRows, childRows)=>{
    let min;
    let max;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    });
    return [
        min,
        max
    ];
};
const $a458d5bea2d12b69$var$mean = (columnId, leafRows)=>{
    let count = 0;
    let sum = 0;
    leafRows.forEach((row)=>{
        let value = row.getValue(columnId);
        if (value != null && (value = +value) >= value) ++count, sum += value;
    });
    if (count) return sum / count;
    return;
};
const $a458d5bea2d12b69$var$median = (columnId, leafRows)=>{
    if (!leafRows.length) return;
    const values = leafRows.map((row)=>row.getValue(columnId));
    if (!$a458d5bea2d12b69$export$5cd576d1827d40c8(values)) return;
    if (values.length === 1) return values[0];
    const mid = Math.floor(values.length / 2);
    const nums = values.sort((a, b)=>a - b);
    return values.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
};
const $a458d5bea2d12b69$var$unique = (columnId, leafRows)=>{
    return Array.from(new Set(leafRows.map((d)=>d.getValue(columnId))).values());
};
const $a458d5bea2d12b69$var$uniqueCount = (columnId, leafRows)=>{
    return new Set(leafRows.map((d)=>d.getValue(columnId))).size;
};
const $a458d5bea2d12b69$var$count = (_columnId, leafRows)=>{
    return leafRows.length;
};
const $a458d5bea2d12b69$export$3aa4339120b8b25b = {
    sum: $a458d5bea2d12b69$var$sum,
    min: $a458d5bea2d12b69$var$min,
    max: $a458d5bea2d12b69$var$max,
    extent: $a458d5bea2d12b69$var$extent,
    mean: $a458d5bea2d12b69$var$mean,
    median: $a458d5bea2d12b69$var$median,
    unique: $a458d5bea2d12b69$var$unique,
    uniqueCount: $a458d5bea2d12b69$var$uniqueCount,
    count: $a458d5bea2d12b69$var$count
};
//
const $a458d5bea2d12b69$export$9c9247c655f92e74 = {
    getDefaultColumnDef: ()=>{
        return {
            aggregatedCell: (props)=>{
                var _toString, _props$getValue;
                return (_toString = (_props$getValue = props.getValue()) == null || _props$getValue.toString == null ? void 0 : _props$getValue.toString()) != null ? _toString : null;
            },
            aggregationFn: 'auto'
        };
    },
    getInitialState: (state)=>{
        return {
            grouping: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onGroupingChange: $a458d5bea2d12b69$export$2b5605d8069324bd('grouping', table),
            groupedColumnMode: 'reorder'
        };
    },
    createColumn: (column, table)=>{
        column.toggleGrouping = ()=>{
            table.setGrouping((old)=>{
                // Find any existing grouping for this column
                if (old != null && old.includes(column.id)) return old.filter((d)=>d !== column.id);
                return [
                    ...old != null ? old : [],
                    column.id
                ];
            });
        };
        column.getCanGroup = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableGrouping) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableGrouping) != null ? _table$options$enable : true) && (!!column.accessorFn || !!column.columnDef.getGroupingValue);
        };
        column.getIsGrouped = ()=>{
            var _table$getState$group;
            return (_table$getState$group = table.getState().grouping) == null ? void 0 : _table$getState$group.includes(column.id);
        };
        column.getGroupedIndex = ()=>{
            var _table$getState$group2;
            return (_table$getState$group2 = table.getState().grouping) == null ? void 0 : _table$getState$group2.indexOf(column.id);
        };
        column.getToggleGroupingHandler = ()=>{
            const canGroup = column.getCanGroup();
            return ()=>{
                if (!canGroup) return;
                column.toggleGrouping();
            };
        };
        column.getAutoAggregationFn = ()=>{
            const firstRow = table.getCoreRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === 'number') return $a458d5bea2d12b69$export$3aa4339120b8b25b.sum;
            if (Object.prototype.toString.call(value) === '[object Date]') return $a458d5bea2d12b69$export$3aa4339120b8b25b.extent;
        };
        column.getAggregationFn = ()=>{
            var _table$options$aggreg, _table$options$aggreg2;
            if (!column) throw new Error();
            return $a458d5bea2d12b69$export$f6e2535fb5126e54(column.columnDef.aggregationFn) ? column.columnDef.aggregationFn : column.columnDef.aggregationFn === 'auto' ? column.getAutoAggregationFn() : (_table$options$aggreg = (_table$options$aggreg2 = table.options.aggregationFns) == null ? void 0 : _table$options$aggreg2[column.columnDef.aggregationFn]) != null ? _table$options$aggreg : $a458d5bea2d12b69$export$3aa4339120b8b25b[column.columnDef.aggregationFn];
        };
    },
    createTable: (table)=>{
        table.setGrouping = (updater)=>table.options.onGroupingChange == null ? void 0 : table.options.onGroupingChange(updater);
        table.resetGrouping = (defaultState)=>{
            var _table$initialState$g, _table$initialState;
            table.setGrouping(defaultState ? [] : (_table$initialState$g = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.grouping) != null ? _table$initialState$g : []);
        };
        table.getPreGroupedRowModel = ()=>table.getFilteredRowModel();
        table.getGroupedRowModel = ()=>{
            if (!table._getGroupedRowModel && table.options.getGroupedRowModel) table._getGroupedRowModel = table.options.getGroupedRowModel(table);
            if (table.options.manualGrouping || !table._getGroupedRowModel) return table.getPreGroupedRowModel();
            return table._getGroupedRowModel();
        };
    },
    createRow: (row, table)=>{
        row.getIsGrouped = ()=>!!row.groupingColumnId;
        row.getGroupingValue = (columnId)=>{
            if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.columnDef.getGroupingValue)) return row.getValue(columnId);
            row._groupingValuesCache[columnId] = column.columnDef.getGroupingValue(row.original);
            return row._groupingValuesCache[columnId];
        };
        row._groupingValuesCache = {};
    },
    createCell: (cell, column, row, table)=>{
        cell.getIsGrouped = ()=>column.getIsGrouped() && column.id === row.groupingColumnId;
        cell.getIsPlaceholder = ()=>!cell.getIsGrouped() && column.getIsGrouped();
        cell.getIsAggregated = ()=>{
            var _row$subRows;
            return !cell.getIsGrouped() && !cell.getIsPlaceholder() && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
        };
    }
};
function $a458d5bea2d12b69$export$ac763d2b0470e663(leafColumns, grouping, groupedColumnMode) {
    if (!(grouping != null && grouping.length) || !groupedColumnMode) return leafColumns;
    const nonGroupingColumns = leafColumns.filter((col)=>!grouping.includes(col.id));
    if (groupedColumnMode === 'remove') return nonGroupingColumns;
    const groupingColumns = grouping.map((g)=>leafColumns.find((col)=>col.id === g)).filter(Boolean);
    return [
        ...groupingColumns,
        ...nonGroupingColumns
    ];
}
//
const $a458d5bea2d12b69$export$fec9c66cd0275c2c = {
    getInitialState: (state)=>{
        return {
            columnOrder: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnOrderChange: $a458d5bea2d12b69$export$2b5605d8069324bd('columnOrder', table)
        };
    },
    createColumn: (column, table)=>{
        column.getIndex = $a458d5bea2d12b69$export$7c73462e0d25e514((position)=>[
                $a458d5bea2d12b69$export$1d7c103713892a11(table, position)
            ], (columns)=>columns.findIndex((d)=>d.id === column.id), $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugColumns', 'getIndex'));
        column.getIsFirstColumn = (position)=>{
            var _columns$;
            const columns = $a458d5bea2d12b69$export$1d7c103713892a11(table, position);
            return ((_columns$ = columns[0]) == null ? void 0 : _columns$.id) === column.id;
        };
        column.getIsLastColumn = (position)=>{
            var _columns;
            const columns = $a458d5bea2d12b69$export$1d7c103713892a11(table, position);
            return ((_columns = columns[columns.length - 1]) == null ? void 0 : _columns.id) === column.id;
        };
    },
    createTable: (table)=>{
        table.setColumnOrder = (updater)=>table.options.onColumnOrderChange == null ? void 0 : table.options.onColumnOrderChange(updater);
        table.resetColumnOrder = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnOrder(defaultState ? [] : (_table$initialState$c = table.initialState.columnOrder) != null ? _table$initialState$c : []);
        };
        table._getOrderColumnsFn = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getState().columnOrder,
                table.getState().grouping,
                table.options.groupedColumnMode
            ], (columnOrder, grouping, groupedColumnMode)=>(columns)=>{
                // Sort grouped columns to the start of the column list
                // before the headers are built
                let orderedColumns = [];
                // If there is no order, return the normal columns
                if (!(columnOrder != null && columnOrder.length)) orderedColumns = columns;
                else {
                    const columnOrderCopy = [
                        ...columnOrder
                    ];
                    // If there is an order, make a copy of the columns
                    const columnsCopy = [
                        ...columns
                    ];
                    // And make a new ordered array of the columns
                    // Loop over the columns and place them in order into the new array
                    while(columnsCopy.length && columnOrderCopy.length){
                        const targetColumnId = columnOrderCopy.shift();
                        const foundIndex = columnsCopy.findIndex((d)=>d.id === targetColumnId);
                        if (foundIndex > -1) orderedColumns.push(columnsCopy.splice(foundIndex, 1)[0]);
                    }
                    // If there are any columns left, add them to the end
                    orderedColumns = [
                        ...orderedColumns,
                        ...columnsCopy
                    ];
                }
                return $a458d5bea2d12b69$export$ac763d2b0470e663(orderedColumns, grouping, groupedColumnMode);
            }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', '_getOrderColumnsFn'));
    }
};
//
const $a458d5bea2d12b69$var$getDefaultColumnPinningState = ()=>({
        left: [],
        right: []
    });
const $a458d5bea2d12b69$export$3563275ce70c4813 = {
    getInitialState: (state)=>{
        return {
            columnPinning: $a458d5bea2d12b69$var$getDefaultColumnPinningState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnPinningChange: $a458d5bea2d12b69$export$2b5605d8069324bd('columnPinning', table)
        };
    },
    createColumn: (column, table)=>{
        column.pin = (position)=>{
            const columnIds = column.getLeafColumns().map((d)=>d.id).filter(Boolean);
            table.setColumnPinning((old)=>{
                var _old$left3, _old$right3;
                if (position === 'right') {
                    var _old$left, _old$right;
                    return {
                        left: ((_old$left = old == null ? void 0 : old.left) != null ? _old$left : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                        right: [
                            ...((_old$right = old == null ? void 0 : old.right) != null ? _old$right : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                            ...columnIds
                        ]
                    };
                }
                if (position === 'left') {
                    var _old$left2, _old$right2;
                    return {
                        left: [
                            ...((_old$left2 = old == null ? void 0 : old.left) != null ? _old$left2 : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                            ...columnIds
                        ],
                        right: ((_old$right2 = old == null ? void 0 : old.right) != null ? _old$right2 : []).filter((d)=>!(columnIds != null && columnIds.includes(d)))
                    };
                }
                return {
                    left: ((_old$left3 = old == null ? void 0 : old.left) != null ? _old$left3 : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                    right: ((_old$right3 = old == null ? void 0 : old.right) != null ? _old$right3 : []).filter((d)=>!(columnIds != null && columnIds.includes(d)))
                };
            });
        };
        column.getCanPin = ()=>{
            const leafColumns = column.getLeafColumns();
            return leafColumns.some((d)=>{
                var _d$columnDef$enablePi, _ref, _table$options$enable;
                return ((_d$columnDef$enablePi = d.columnDef.enablePinning) != null ? _d$columnDef$enablePi : true) && ((_ref = (_table$options$enable = table.options.enableColumnPinning) != null ? _table$options$enable : table.options.enablePinning) != null ? _ref : true);
            });
        };
        column.getIsPinned = ()=>{
            const leafColumnIds = column.getLeafColumns().map((d)=>d.id);
            const { left: left, right: right } = table.getState().columnPinning;
            const isLeft = leafColumnIds.some((d)=>left == null ? void 0 : left.includes(d));
            const isRight = leafColumnIds.some((d)=>right == null ? void 0 : right.includes(d));
            return isLeft ? 'left' : isRight ? 'right' : false;
        };
        column.getPinnedIndex = ()=>{
            var _table$getState$colum, _table$getState$colum2;
            const position = column.getIsPinned();
            return position ? (_table$getState$colum = (_table$getState$colum2 = table.getState().columnPinning) == null || (_table$getState$colum2 = _table$getState$colum2[position]) == null ? void 0 : _table$getState$colum2.indexOf(column.id)) != null ? _table$getState$colum : -1 : 0;
        };
    },
    createRow: (row, table)=>{
        row.getCenterVisibleCells = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allCells, left, right)=>{
            const leftAndRight = [
                ...left != null ? left : [],
                ...right != null ? right : []
            ];
            return allCells.filter((d)=>!leftAndRight.includes(d.column.id));
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugRows', 'getCenterVisibleCells'));
        row.getLeftVisibleCells = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.left
            ], (allCells, left)=>{
            const cells = (left != null ? left : []).map((columnId)=>allCells.find((cell)=>cell.column.id === columnId)).filter(Boolean).map((d)=>({
                    ...d,
                    position: 'left'
                }));
            return cells;
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugRows', 'getLeftVisibleCells'));
        row.getRightVisibleCells = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.right
            ], (allCells, right)=>{
            const cells = (right != null ? right : []).map((columnId)=>allCells.find((cell)=>cell.column.id === columnId)).filter(Boolean).map((d)=>({
                    ...d,
                    position: 'right'
                }));
            return cells;
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugRows', 'getRightVisibleCells'));
    },
    createTable: (table)=>{
        table.setColumnPinning = (updater)=>table.options.onColumnPinningChange == null ? void 0 : table.options.onColumnPinningChange(updater);
        table.resetColumnPinning = (defaultState)=>{
            var _table$initialState$c, _table$initialState;
            return table.setColumnPinning(defaultState ? $a458d5bea2d12b69$var$getDefaultColumnPinningState() : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnPinning) != null ? _table$initialState$c : $a458d5bea2d12b69$var$getDefaultColumnPinningState());
        };
        table.getIsSomeColumnsPinned = (position)=>{
            var _pinningState$positio;
            const pinningState = table.getState().columnPinning;
            if (!position) {
                var _pinningState$left, _pinningState$right;
                return Boolean(((_pinningState$left = pinningState.left) == null ? void 0 : _pinningState$left.length) || ((_pinningState$right = pinningState.right) == null ? void 0 : _pinningState$right.length));
            }
            return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
        };
        table.getLeftLeafColumns = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.left
            ], (allColumns, left)=>{
            return (left != null ? left : []).map((columnId)=>allColumns.find((column)=>column.id === columnId)).filter(Boolean);
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugColumns', 'getLeftLeafColumns'));
        table.getRightLeafColumns = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.right
            ], (allColumns, right)=>{
            return (right != null ? right : []).map((columnId)=>allColumns.find((column)=>column.id === columnId)).filter(Boolean);
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugColumns', 'getRightLeafColumns'));
        table.getCenterLeafColumns = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, left, right)=>{
            const leftAndRight = [
                ...left != null ? left : [],
                ...right != null ? right : []
            ];
            return allColumns.filter((d)=>!leftAndRight.includes(d.id));
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugColumns', 'getCenterLeafColumns'));
    }
};
function $a458d5bea2d12b69$var$safelyAccessDocument(_document) {
    return _document || (typeof document !== 'undefined' ? document : null);
}
//
//
const $a458d5bea2d12b69$export$2f660993f4eb1f29 = {
    size: 150,
    minSize: 20,
    maxSize: Number.MAX_SAFE_INTEGER
};
const $a458d5bea2d12b69$var$getDefaultColumnSizingInfoState = ()=>({
        startOffset: null,
        startSize: null,
        deltaOffset: null,
        deltaPercentage: null,
        isResizingColumn: false,
        columnSizingStart: []
    });
const $a458d5bea2d12b69$export$9916c85814812d4a = {
    getDefaultColumnDef: ()=>{
        return $a458d5bea2d12b69$export$2f660993f4eb1f29;
    },
    getInitialState: (state)=>{
        return {
            columnSizing: {},
            columnSizingInfo: $a458d5bea2d12b69$var$getDefaultColumnSizingInfoState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            columnResizeMode: 'onEnd',
            columnResizeDirection: 'ltr',
            onColumnSizingChange: $a458d5bea2d12b69$export$2b5605d8069324bd('columnSizing', table),
            onColumnSizingInfoChange: $a458d5bea2d12b69$export$2b5605d8069324bd('columnSizingInfo', table)
        };
    },
    createColumn: (column, table)=>{
        column.getSize = ()=>{
            var _column$columnDef$min, _ref, _column$columnDef$max;
            const columnSize = table.getState().columnSizing[column.id];
            return Math.min(Math.max((_column$columnDef$min = column.columnDef.minSize) != null ? _column$columnDef$min : $a458d5bea2d12b69$export$2f660993f4eb1f29.minSize, (_ref = columnSize != null ? columnSize : column.columnDef.size) != null ? _ref : $a458d5bea2d12b69$export$2f660993f4eb1f29.size), (_column$columnDef$max = column.columnDef.maxSize) != null ? _column$columnDef$max : $a458d5bea2d12b69$export$2f660993f4eb1f29.maxSize);
        };
        column.getStart = $a458d5bea2d12b69$export$7c73462e0d25e514((position)=>[
                position,
                $a458d5bea2d12b69$export$1d7c103713892a11(table, position),
                table.getState().columnSizing
            ], (position, columns)=>columns.slice(0, column.getIndex(position)).reduce((sum, column)=>sum + column.getSize(), 0), $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugColumns', 'getStart'));
        column.getAfter = $a458d5bea2d12b69$export$7c73462e0d25e514((position)=>[
                position,
                $a458d5bea2d12b69$export$1d7c103713892a11(table, position),
                table.getState().columnSizing
            ], (position, columns)=>columns.slice(column.getIndex(position) + 1).reduce((sum, column)=>sum + column.getSize(), 0), $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugColumns', 'getAfter'));
        column.resetSize = ()=>{
            table.setColumnSizing((_ref2)=>{
                let { [column.id]: _, ...rest } = _ref2;
                return rest;
            });
        };
        column.getCanResize = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableResizing) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnResizing) != null ? _table$options$enable : true);
        };
        column.getIsResizing = ()=>{
            return table.getState().columnSizingInfo.isResizingColumn === column.id;
        };
    },
    createHeader: (header, table)=>{
        header.getSize = ()=>{
            let sum = 0;
            const recurse = (header)=>{
                if (header.subHeaders.length) header.subHeaders.forEach(recurse);
                else {
                    var _header$column$getSiz;
                    sum += (_header$column$getSiz = header.column.getSize()) != null ? _header$column$getSiz : 0;
                }
            };
            recurse(header);
            return sum;
        };
        header.getStart = ()=>{
            if (header.index > 0) {
                const prevSiblingHeader = header.headerGroup.headers[header.index - 1];
                return prevSiblingHeader.getStart() + prevSiblingHeader.getSize();
            }
            return 0;
        };
        header.getResizeHandler = (_contextDocument)=>{
            const column = table.getColumn(header.column.id);
            const canResize = column == null ? void 0 : column.getCanResize();
            return (e)=>{
                if (!column || !canResize) return;
                e.persist == null || e.persist();
                if ($a458d5bea2d12b69$var$isTouchStartEvent(e)) {
                    // lets not respond to multiple touches (e.g. 2 or 3 fingers)
                    if (e.touches && e.touches.length > 1) return;
                }
                const startSize = header.getSize();
                const columnSizingStart = header ? header.getLeafHeaders().map((d)=>[
                        d.column.id,
                        d.column.getSize()
                    ]) : [
                    [
                        column.id,
                        column.getSize()
                    ]
                ];
                const clientX = $a458d5bea2d12b69$var$isTouchStartEvent(e) ? Math.round(e.touches[0].clientX) : e.clientX;
                const newColumnSizing = {};
                const updateOffset = (eventType, clientXPos)=>{
                    if (typeof clientXPos !== 'number') return;
                    table.setColumnSizingInfo((old)=>{
                        var _old$startOffset, _old$startSize;
                        const deltaDirection = table.options.columnResizeDirection === 'rtl' ? -1 : 1;
                        const deltaOffset = (clientXPos - ((_old$startOffset = old == null ? void 0 : old.startOffset) != null ? _old$startOffset : 0)) * deltaDirection;
                        const deltaPercentage = Math.max(deltaOffset / ((_old$startSize = old == null ? void 0 : old.startSize) != null ? _old$startSize : 0), -0.999999);
                        old.columnSizingStart.forEach((_ref3)=>{
                            let [columnId, headerSize] = _ref3;
                            newColumnSizing[columnId] = Math.round(Math.max(headerSize + headerSize * deltaPercentage, 0) * 100) / 100;
                        });
                        return {
                            ...old,
                            deltaOffset: deltaOffset,
                            deltaPercentage: deltaPercentage
                        };
                    });
                    if (table.options.columnResizeMode === 'onChange' || eventType === 'end') table.setColumnSizing((old)=>({
                            ...old,
                            ...newColumnSizing
                        }));
                };
                const onMove = (clientXPos)=>updateOffset('move', clientXPos);
                const onEnd = (clientXPos)=>{
                    updateOffset('end', clientXPos);
                    table.setColumnSizingInfo((old)=>({
                            ...old,
                            isResizingColumn: false,
                            startOffset: null,
                            startSize: null,
                            deltaOffset: null,
                            deltaPercentage: null,
                            columnSizingStart: []
                        }));
                };
                const contextDocument = $a458d5bea2d12b69$var$safelyAccessDocument(_contextDocument);
                const mouseEvents = {
                    moveHandler: (e)=>onMove(e.clientX),
                    upHandler: (e)=>{
                        contextDocument == null || contextDocument.removeEventListener('mousemove', mouseEvents.moveHandler);
                        contextDocument == null || contextDocument.removeEventListener('mouseup', mouseEvents.upHandler);
                        onEnd(e.clientX);
                    }
                };
                const touchEvents = {
                    moveHandler: (e)=>{
                        if (e.cancelable) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        onMove(e.touches[0].clientX);
                        return false;
                    },
                    upHandler: (e)=>{
                        var _e$touches$;
                        contextDocument == null || contextDocument.removeEventListener('touchmove', touchEvents.moveHandler);
                        contextDocument == null || contextDocument.removeEventListener('touchend', touchEvents.upHandler);
                        if (e.cancelable) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        onEnd((_e$touches$ = e.touches[0]) == null ? void 0 : _e$touches$.clientX);
                    }
                };
                const passiveIfSupported = $a458d5bea2d12b69$export$4927b5943c7c0b4() ? {
                    passive: false
                } : false;
                if ($a458d5bea2d12b69$var$isTouchStartEvent(e)) {
                    contextDocument == null || contextDocument.addEventListener('touchmove', touchEvents.moveHandler, passiveIfSupported);
                    contextDocument == null || contextDocument.addEventListener('touchend', touchEvents.upHandler, passiveIfSupported);
                } else {
                    contextDocument == null || contextDocument.addEventListener('mousemove', mouseEvents.moveHandler, passiveIfSupported);
                    contextDocument == null || contextDocument.addEventListener('mouseup', mouseEvents.upHandler, passiveIfSupported);
                }
                table.setColumnSizingInfo((old)=>({
                        ...old,
                        startOffset: clientX,
                        startSize: startSize,
                        deltaOffset: 0,
                        deltaPercentage: 0,
                        columnSizingStart: columnSizingStart,
                        isResizingColumn: column.id
                    }));
            };
        };
    },
    createTable: (table)=>{
        table.setColumnSizing = (updater)=>table.options.onColumnSizingChange == null ? void 0 : table.options.onColumnSizingChange(updater);
        table.setColumnSizingInfo = (updater)=>table.options.onColumnSizingInfoChange == null ? void 0 : table.options.onColumnSizingInfoChange(updater);
        table.resetColumnSizing = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnSizing(defaultState ? {} : (_table$initialState$c = table.initialState.columnSizing) != null ? _table$initialState$c : {});
        };
        table.resetHeaderSizeInfo = (defaultState)=>{
            var _table$initialState$c2;
            table.setColumnSizingInfo(defaultState ? $a458d5bea2d12b69$var$getDefaultColumnSizingInfoState() : (_table$initialState$c2 = table.initialState.columnSizingInfo) != null ? _table$initialState$c2 : $a458d5bea2d12b69$var$getDefaultColumnSizingInfoState());
        };
        table.getTotalSize = ()=>{
            var _table$getHeaderGroup, _table$getHeaderGroup2;
            return (_table$getHeaderGroup = (_table$getHeaderGroup2 = table.getHeaderGroups()[0]) == null ? void 0 : _table$getHeaderGroup2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getHeaderGroup : 0;
        };
        table.getLeftTotalSize = ()=>{
            var _table$getLeftHeaderG, _table$getLeftHeaderG2;
            return (_table$getLeftHeaderG = (_table$getLeftHeaderG2 = table.getLeftHeaderGroups()[0]) == null ? void 0 : _table$getLeftHeaderG2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getLeftHeaderG : 0;
        };
        table.getCenterTotalSize = ()=>{
            var _table$getCenterHeade, _table$getCenterHeade2;
            return (_table$getCenterHeade = (_table$getCenterHeade2 = table.getCenterHeaderGroups()[0]) == null ? void 0 : _table$getCenterHeade2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getCenterHeade : 0;
        };
        table.getRightTotalSize = ()=>{
            var _table$getRightHeader, _table$getRightHeader2;
            return (_table$getRightHeader = (_table$getRightHeader2 = table.getRightHeaderGroups()[0]) == null ? void 0 : _table$getRightHeader2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getRightHeader : 0;
        };
    }
};
let $a458d5bea2d12b69$var$passiveSupported = null;
function $a458d5bea2d12b69$export$4927b5943c7c0b4() {
    if (typeof $a458d5bea2d12b69$var$passiveSupported === 'boolean') return $a458d5bea2d12b69$var$passiveSupported;
    let supported = false;
    try {
        const options = {
            get passive () {
                supported = true;
                return false;
            }
        };
        const noop = ()=>{};
        window.addEventListener('test', noop, options);
        window.removeEventListener('test', noop);
    } catch (err) {
        supported = false;
    }
    $a458d5bea2d12b69$var$passiveSupported = supported;
    return $a458d5bea2d12b69$var$passiveSupported;
}
function $a458d5bea2d12b69$var$isTouchStartEvent(e) {
    return e.type === 'touchstart';
}
//
const $a458d5bea2d12b69$export$be5545a32e20d889 = {
    getInitialState: (state)=>{
        return {
            columnVisibility: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnVisibilityChange: $a458d5bea2d12b69$export$2b5605d8069324bd('columnVisibility', table)
        };
    },
    createColumn: (column, table)=>{
        column.toggleVisibility = (value)=>{
            if (column.getCanHide()) table.setColumnVisibility((old)=>({
                    ...old,
                    [column.id]: value != null ? value : !column.getIsVisible()
                }));
        };
        column.getIsVisible = ()=>{
            var _ref, _table$getState$colum;
            const childColumns = column.columns;
            return (_ref = childColumns.length ? childColumns.some((c)=>c.getIsVisible()) : (_table$getState$colum = table.getState().columnVisibility) == null ? void 0 : _table$getState$colum[column.id]) != null ? _ref : true;
        };
        column.getCanHide = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableHiding) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableHiding) != null ? _table$options$enable : true);
        };
        column.getToggleVisibilityHandler = ()=>{
            return (e)=>{
                column.toggleVisibility == null || column.toggleVisibility(e.target.checked);
            };
        };
    },
    createRow: (row, table)=>{
        row._getAllVisibleCells = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                row.getAllCells(),
                table.getState().columnVisibility
            ], (cells)=>{
            return cells.filter((cell)=>cell.column.getIsVisible());
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugRows', '_getAllVisibleCells'));
        row.getVisibleCells = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                row.getLeftVisibleCells(),
                row.getCenterVisibleCells(),
                row.getRightVisibleCells()
            ], (left, center, right)=>[
                ...left,
                ...center,
                ...right
            ], $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugRows', 'getVisibleCells'));
    },
    createTable: (table)=>{
        const makeVisibleColumnsMethod = (key, getColumns)=>{
            return $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                    getColumns(),
                    getColumns().filter((d)=>d.getIsVisible()).map((d)=>d.id).join('_')
                ], (columns)=>{
                return columns.filter((d)=>d.getIsVisible == null ? void 0 : d.getIsVisible());
            }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugColumns', key));
        };
        table.getVisibleFlatColumns = makeVisibleColumnsMethod('getVisibleFlatColumns', ()=>table.getAllFlatColumns());
        table.getVisibleLeafColumns = makeVisibleColumnsMethod('getVisibleLeafColumns', ()=>table.getAllLeafColumns());
        table.getLeftVisibleLeafColumns = makeVisibleColumnsMethod('getLeftVisibleLeafColumns', ()=>table.getLeftLeafColumns());
        table.getRightVisibleLeafColumns = makeVisibleColumnsMethod('getRightVisibleLeafColumns', ()=>table.getRightLeafColumns());
        table.getCenterVisibleLeafColumns = makeVisibleColumnsMethod('getCenterVisibleLeafColumns', ()=>table.getCenterLeafColumns());
        table.setColumnVisibility = (updater)=>table.options.onColumnVisibilityChange == null ? void 0 : table.options.onColumnVisibilityChange(updater);
        table.resetColumnVisibility = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnVisibility(defaultState ? {} : (_table$initialState$c = table.initialState.columnVisibility) != null ? _table$initialState$c : {});
        };
        table.toggleAllColumnsVisible = (value)=>{
            var _value;
            value = (_value = value) != null ? _value : !table.getIsAllColumnsVisible();
            table.setColumnVisibility(table.getAllLeafColumns().reduce((obj, column)=>({
                    ...obj,
                    [column.id]: !value ? !(column.getCanHide != null && column.getCanHide()) : value
                }), {}));
        };
        table.getIsAllColumnsVisible = ()=>!table.getAllLeafColumns().some((column)=>!(column.getIsVisible != null && column.getIsVisible()));
        table.getIsSomeColumnsVisible = ()=>table.getAllLeafColumns().some((column)=>column.getIsVisible == null ? void 0 : column.getIsVisible());
        table.getToggleAllColumnsVisibilityHandler = ()=>{
            return (e)=>{
                var _target;
                table.toggleAllColumnsVisible((_target = e.target) == null ? void 0 : _target.checked);
            };
        };
    }
};
function $a458d5bea2d12b69$export$1d7c103713892a11(table, position) {
    return !position ? table.getVisibleLeafColumns() : position === 'center' ? table.getCenterVisibleLeafColumns() : position === 'left' ? table.getLeftVisibleLeafColumns() : table.getRightVisibleLeafColumns();
}
//
const $a458d5bea2d12b69$export$4b37edcdc7ad2fe1 = {
    createTable: (table)=>{
        table._getGlobalFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, '__global__');
        table.getGlobalFacetedRowModel = ()=>{
            if (table.options.manualFiltering || !table._getGlobalFacetedRowModel) return table.getPreFilteredRowModel();
            return table._getGlobalFacetedRowModel();
        };
        table._getGlobalFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, '__global__');
        table.getGlobalFacetedUniqueValues = ()=>{
            if (!table._getGlobalFacetedUniqueValues) return new Map();
            return table._getGlobalFacetedUniqueValues();
        };
        table._getGlobalFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, '__global__');
        table.getGlobalFacetedMinMaxValues = ()=>{
            if (!table._getGlobalFacetedMinMaxValues) return;
            return table._getGlobalFacetedMinMaxValues();
        };
    }
};
//
const $a458d5bea2d12b69$export$61e9e0661ff79b1c = {
    getInitialState: (state)=>{
        return {
            globalFilter: undefined,
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onGlobalFilterChange: $a458d5bea2d12b69$export$2b5605d8069324bd('globalFilter', table),
            globalFilterFn: 'auto',
            getColumnCanGlobalFilter: (column)=>{
                var _table$getCoreRowMode;
                const value = (_table$getCoreRowMode = table.getCoreRowModel().flatRows[0]) == null || (_table$getCoreRowMode = _table$getCoreRowMode._getAllCellsByColumnId()[column.id]) == null ? void 0 : _table$getCoreRowMode.getValue();
                return typeof value === 'string' || typeof value === 'number';
            }
        };
    },
    createColumn: (column, table)=>{
        column.getCanGlobalFilter = ()=>{
            var _column$columnDef$ena, _table$options$enable, _table$options$enable2, _table$options$getCol;
            return ((_column$columnDef$ena = column.columnDef.enableGlobalFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableGlobalFilter) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && ((_table$options$getCol = table.options.getColumnCanGlobalFilter == null ? void 0 : table.options.getColumnCanGlobalFilter(column)) != null ? _table$options$getCol : true) && !!column.accessorFn;
        };
    },
    createTable: (table)=>{
        table.getGlobalAutoFilterFn = ()=>{
            return $a458d5bea2d12b69$export$6ad8312e296ec316.includesString;
        };
        table.getGlobalFilterFn = ()=>{
            var _table$options$filter, _table$options$filter2;
            const { globalFilterFn: globalFilterFn } = table.options;
            return $a458d5bea2d12b69$export$f6e2535fb5126e54(globalFilterFn) ? globalFilterFn : globalFilterFn === 'auto' ? table.getGlobalAutoFilterFn() : (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[globalFilterFn]) != null ? _table$options$filter : $a458d5bea2d12b69$export$6ad8312e296ec316[globalFilterFn];
        };
        table.setGlobalFilter = (updater)=>{
            table.options.onGlobalFilterChange == null || table.options.onGlobalFilterChange(updater);
        };
        table.resetGlobalFilter = (defaultState)=>{
            table.setGlobalFilter(defaultState ? undefined : table.initialState.globalFilter);
        };
    }
};
//
const $a458d5bea2d12b69$export$fed54e0d64c17fb2 = {
    getInitialState: (state)=>{
        return {
            expanded: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onExpandedChange: $a458d5bea2d12b69$export$2b5605d8069324bd('expanded', table),
            paginateExpandedRows: true
        };
    },
    createTable: (table)=>{
        let registered = false;
        let queued = false;
        table._autoResetExpanded = ()=>{
            var _ref, _table$options$autoRe;
            if (!registered) {
                table._queue(()=>{
                    registered = true;
                });
                return;
            }
            if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetExpanded) != null ? _ref : !table.options.manualExpanding) {
                if (queued) return;
                queued = true;
                table._queue(()=>{
                    table.resetExpanded();
                    queued = false;
                });
            }
        };
        table.setExpanded = (updater)=>table.options.onExpandedChange == null ? void 0 : table.options.onExpandedChange(updater);
        table.toggleAllRowsExpanded = (expanded)=>{
            if (expanded != null ? expanded : !table.getIsAllRowsExpanded()) table.setExpanded(true);
            else table.setExpanded({});
        };
        table.resetExpanded = (defaultState)=>{
            var _table$initialState$e, _table$initialState;
            table.setExpanded(defaultState ? {} : (_table$initialState$e = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.expanded) != null ? _table$initialState$e : {});
        };
        table.getCanSomeRowsExpand = ()=>{
            return table.getPrePaginationRowModel().flatRows.some((row)=>row.getCanExpand());
        };
        table.getToggleAllRowsExpandedHandler = ()=>{
            return (e)=>{
                e.persist == null || e.persist();
                table.toggleAllRowsExpanded();
            };
        };
        table.getIsSomeRowsExpanded = ()=>{
            const expanded = table.getState().expanded;
            return expanded === true || Object.values(expanded).some(Boolean);
        };
        table.getIsAllRowsExpanded = ()=>{
            const expanded = table.getState().expanded;
            // If expanded is true, save some cycles and return true
            if (typeof expanded === 'boolean') return expanded === true;
            if (!Object.keys(expanded).length) return false;
            // If any row is not expanded, return false
            if (table.getRowModel().flatRows.some((row)=>!row.getIsExpanded())) return false;
            // They must all be expanded :shrug:
            return true;
        };
        table.getExpandedDepth = ()=>{
            let maxDepth = 0;
            const rowIds = table.getState().expanded === true ? Object.keys(table.getRowModel().rowsById) : Object.keys(table.getState().expanded);
            rowIds.forEach((id)=>{
                const splitId = id.split('.');
                maxDepth = Math.max(maxDepth, splitId.length);
            });
            return maxDepth;
        };
        table.getPreExpandedRowModel = ()=>table.getSortedRowModel();
        table.getExpandedRowModel = ()=>{
            if (!table._getExpandedRowModel && table.options.getExpandedRowModel) table._getExpandedRowModel = table.options.getExpandedRowModel(table);
            if (table.options.manualExpanding || !table._getExpandedRowModel) return table.getPreExpandedRowModel();
            return table._getExpandedRowModel();
        };
    },
    createRow: (row, table)=>{
        row.toggleExpanded = (expanded)=>{
            table.setExpanded((old)=>{
                var _expanded;
                const exists = old === true ? true : !!(old != null && old[row.id]);
                let oldExpanded = {};
                if (old === true) Object.keys(table.getRowModel().rowsById).forEach((rowId)=>{
                    oldExpanded[rowId] = true;
                });
                else oldExpanded = old;
                expanded = (_expanded = expanded) != null ? _expanded : !exists;
                if (!exists && expanded) return {
                    ...oldExpanded,
                    [row.id]: true
                };
                if (exists && !expanded) {
                    const { [row.id]: _, ...rest } = oldExpanded;
                    return rest;
                }
                return old;
            });
        };
        row.getIsExpanded = ()=>{
            var _table$options$getIsR;
            const expanded = table.getState().expanded;
            return !!((_table$options$getIsR = table.options.getIsRowExpanded == null ? void 0 : table.options.getIsRowExpanded(row)) != null ? _table$options$getIsR : expanded === true || (expanded == null ? void 0 : expanded[row.id]));
        };
        row.getCanExpand = ()=>{
            var _table$options$getRow, _table$options$enable, _row$subRows;
            return (_table$options$getRow = table.options.getRowCanExpand == null ? void 0 : table.options.getRowCanExpand(row)) != null ? _table$options$getRow : ((_table$options$enable = table.options.enableExpanding) != null ? _table$options$enable : true) && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
        };
        row.getIsAllParentsExpanded = ()=>{
            let isFullyExpanded = true;
            let currentRow = row;
            while(isFullyExpanded && currentRow.parentId){
                currentRow = table.getRow(currentRow.parentId, true);
                isFullyExpanded = currentRow.getIsExpanded();
            }
            return isFullyExpanded;
        };
        row.getToggleExpandedHandler = ()=>{
            const canExpand = row.getCanExpand();
            return ()=>{
                if (!canExpand) return;
                row.toggleExpanded();
            };
        };
    }
};
//
const $a458d5bea2d12b69$var$defaultPageIndex = 0;
const $a458d5bea2d12b69$var$defaultPageSize = 10;
const $a458d5bea2d12b69$var$getDefaultPaginationState = ()=>({
        pageIndex: $a458d5bea2d12b69$var$defaultPageIndex,
        pageSize: $a458d5bea2d12b69$var$defaultPageSize
    });
const $a458d5bea2d12b69$export$bce540641752d22b = {
    getInitialState: (state)=>{
        return {
            ...state,
            pagination: {
                ...$a458d5bea2d12b69$var$getDefaultPaginationState(),
                ...state == null ? void 0 : state.pagination
            }
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onPaginationChange: $a458d5bea2d12b69$export$2b5605d8069324bd('pagination', table)
        };
    },
    createTable: (table)=>{
        let registered = false;
        let queued = false;
        table._autoResetPageIndex = ()=>{
            var _ref, _table$options$autoRe;
            if (!registered) {
                table._queue(()=>{
                    registered = true;
                });
                return;
            }
            if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetPageIndex) != null ? _ref : !table.options.manualPagination) {
                if (queued) return;
                queued = true;
                table._queue(()=>{
                    table.resetPageIndex();
                    queued = false;
                });
            }
        };
        table.setPagination = (updater)=>{
            const safeUpdater = (old)=>{
                let newState = $a458d5bea2d12b69$export$7f095f455ad5af3f(updater, old);
                return newState;
            };
            return table.options.onPaginationChange == null ? void 0 : table.options.onPaginationChange(safeUpdater);
        };
        table.resetPagination = (defaultState)=>{
            var _table$initialState$p;
            table.setPagination(defaultState ? $a458d5bea2d12b69$var$getDefaultPaginationState() : (_table$initialState$p = table.initialState.pagination) != null ? _table$initialState$p : $a458d5bea2d12b69$var$getDefaultPaginationState());
        };
        table.setPageIndex = (updater)=>{
            table.setPagination((old)=>{
                let pageIndex = $a458d5bea2d12b69$export$7f095f455ad5af3f(updater, old.pageIndex);
                const maxPageIndex = typeof table.options.pageCount === 'undefined' || table.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : table.options.pageCount - 1;
                pageIndex = Math.max(0, Math.min(pageIndex, maxPageIndex));
                return {
                    ...old,
                    pageIndex: pageIndex
                };
            });
        };
        table.resetPageIndex = (defaultState)=>{
            var _table$initialState$p2, _table$initialState;
            table.setPageIndex(defaultState ? $a458d5bea2d12b69$var$defaultPageIndex : (_table$initialState$p2 = (_table$initialState = table.initialState) == null || (_table$initialState = _table$initialState.pagination) == null ? void 0 : _table$initialState.pageIndex) != null ? _table$initialState$p2 : $a458d5bea2d12b69$var$defaultPageIndex);
        };
        table.resetPageSize = (defaultState)=>{
            var _table$initialState$p3, _table$initialState2;
            table.setPageSize(defaultState ? $a458d5bea2d12b69$var$defaultPageSize : (_table$initialState$p3 = (_table$initialState2 = table.initialState) == null || (_table$initialState2 = _table$initialState2.pagination) == null ? void 0 : _table$initialState2.pageSize) != null ? _table$initialState$p3 : $a458d5bea2d12b69$var$defaultPageSize);
        };
        table.setPageSize = (updater)=>{
            table.setPagination((old)=>{
                const pageSize = Math.max(1, $a458d5bea2d12b69$export$7f095f455ad5af3f(updater, old.pageSize));
                const topRowIndex = old.pageSize * old.pageIndex;
                const pageIndex = Math.floor(topRowIndex / pageSize);
                return {
                    ...old,
                    pageIndex: pageIndex,
                    pageSize: pageSize
                };
            });
        };
        //deprecated
        table.setPageCount = (updater)=>table.setPagination((old)=>{
                var _table$options$pageCo;
                let newPageCount = $a458d5bea2d12b69$export$7f095f455ad5af3f(updater, (_table$options$pageCo = table.options.pageCount) != null ? _table$options$pageCo : -1);
                if (typeof newPageCount === 'number') newPageCount = Math.max(-1, newPageCount);
                return {
                    ...old,
                    pageCount: newPageCount
                };
            });
        table.getPageOptions = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getPageCount()
            ], (pageCount)=>{
            let pageOptions = [];
            if (pageCount && pageCount > 0) pageOptions = [
                ...new Array(pageCount)
            ].fill(null).map((_, i)=>i);
            return pageOptions;
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', 'getPageOptions'));
        table.getCanPreviousPage = ()=>table.getState().pagination.pageIndex > 0;
        table.getCanNextPage = ()=>{
            const { pageIndex: pageIndex } = table.getState().pagination;
            const pageCount = table.getPageCount();
            if (pageCount === -1) return true;
            if (pageCount === 0) return false;
            return pageIndex < pageCount - 1;
        };
        table.previousPage = ()=>{
            return table.setPageIndex((old)=>old - 1);
        };
        table.nextPage = ()=>{
            return table.setPageIndex((old)=>{
                return old + 1;
            });
        };
        table.firstPage = ()=>{
            return table.setPageIndex(0);
        };
        table.lastPage = ()=>{
            return table.setPageIndex(table.getPageCount() - 1);
        };
        table.getPrePaginationRowModel = ()=>table.getExpandedRowModel();
        table.getPaginationRowModel = ()=>{
            if (!table._getPaginationRowModel && table.options.getPaginationRowModel) table._getPaginationRowModel = table.options.getPaginationRowModel(table);
            if (table.options.manualPagination || !table._getPaginationRowModel) return table.getPrePaginationRowModel();
            return table._getPaginationRowModel();
        };
        table.getPageCount = ()=>{
            var _table$options$pageCo2;
            return (_table$options$pageCo2 = table.options.pageCount) != null ? _table$options$pageCo2 : Math.ceil(table.getRowCount() / table.getState().pagination.pageSize);
        };
        table.getRowCount = ()=>{
            var _table$options$rowCou;
            return (_table$options$rowCou = table.options.rowCount) != null ? _table$options$rowCou : table.getPrePaginationRowModel().rows.length;
        };
    }
};
//
const $a458d5bea2d12b69$var$getDefaultRowPinningState = ()=>({
        top: [],
        bottom: []
    });
const $a458d5bea2d12b69$export$213d72cb2ac7d440 = {
    getInitialState: (state)=>{
        return {
            rowPinning: $a458d5bea2d12b69$var$getDefaultRowPinningState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onRowPinningChange: $a458d5bea2d12b69$export$2b5605d8069324bd('rowPinning', table)
        };
    },
    createRow: (row, table)=>{
        row.pin = (position, includeLeafRows, includeParentRows)=>{
            const leafRowIds = includeLeafRows ? row.getLeafRows().map((_ref)=>{
                let { id: id } = _ref;
                return id;
            }) : [];
            const parentRowIds = includeParentRows ? row.getParentRows().map((_ref2)=>{
                let { id: id } = _ref2;
                return id;
            }) : [];
            const rowIds = new Set([
                ...parentRowIds,
                row.id,
                ...leafRowIds
            ]);
            table.setRowPinning((old)=>{
                var _old$top3, _old$bottom3;
                if (position === 'bottom') {
                    var _old$top, _old$bottom;
                    return {
                        top: ((_old$top = old == null ? void 0 : old.top) != null ? _old$top : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                        bottom: [
                            ...((_old$bottom = old == null ? void 0 : old.bottom) != null ? _old$bottom : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                            ...Array.from(rowIds)
                        ]
                    };
                }
                if (position === 'top') {
                    var _old$top2, _old$bottom2;
                    return {
                        top: [
                            ...((_old$top2 = old == null ? void 0 : old.top) != null ? _old$top2 : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                            ...Array.from(rowIds)
                        ],
                        bottom: ((_old$bottom2 = old == null ? void 0 : old.bottom) != null ? _old$bottom2 : []).filter((d)=>!(rowIds != null && rowIds.has(d)))
                    };
                }
                return {
                    top: ((_old$top3 = old == null ? void 0 : old.top) != null ? _old$top3 : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                    bottom: ((_old$bottom3 = old == null ? void 0 : old.bottom) != null ? _old$bottom3 : []).filter((d)=>!(rowIds != null && rowIds.has(d)))
                };
            });
        };
        row.getCanPin = ()=>{
            var _ref3;
            const { enableRowPinning: enableRowPinning, enablePinning: enablePinning } = table.options;
            if (typeof enableRowPinning === 'function') return enableRowPinning(row);
            return (_ref3 = enableRowPinning != null ? enableRowPinning : enablePinning) != null ? _ref3 : true;
        };
        row.getIsPinned = ()=>{
            const rowIds = [
                row.id
            ];
            const { top: top, bottom: bottom } = table.getState().rowPinning;
            const isTop = rowIds.some((d)=>top == null ? void 0 : top.includes(d));
            const isBottom = rowIds.some((d)=>bottom == null ? void 0 : bottom.includes(d));
            return isTop ? 'top' : isBottom ? 'bottom' : false;
        };
        row.getPinnedIndex = ()=>{
            var _ref4, _visiblePinnedRowIds$;
            const position = row.getIsPinned();
            if (!position) return -1;
            const visiblePinnedRowIds = (_ref4 = position === 'top' ? table.getTopRows() : table.getBottomRows()) == null ? void 0 : _ref4.map((_ref5)=>{
                let { id: id } = _ref5;
                return id;
            });
            return (_visiblePinnedRowIds$ = visiblePinnedRowIds == null ? void 0 : visiblePinnedRowIds.indexOf(row.id)) != null ? _visiblePinnedRowIds$ : -1;
        };
    },
    createTable: (table)=>{
        table.setRowPinning = (updater)=>table.options.onRowPinningChange == null ? void 0 : table.options.onRowPinningChange(updater);
        table.resetRowPinning = (defaultState)=>{
            var _table$initialState$r, _table$initialState;
            return table.setRowPinning(defaultState ? $a458d5bea2d12b69$var$getDefaultRowPinningState() : (_table$initialState$r = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.rowPinning) != null ? _table$initialState$r : $a458d5bea2d12b69$var$getDefaultRowPinningState());
        };
        table.getIsSomeRowsPinned = (position)=>{
            var _pinningState$positio;
            const pinningState = table.getState().rowPinning;
            if (!position) {
                var _pinningState$top, _pinningState$bottom;
                return Boolean(((_pinningState$top = pinningState.top) == null ? void 0 : _pinningState$top.length) || ((_pinningState$bottom = pinningState.bottom) == null ? void 0 : _pinningState$bottom.length));
            }
            return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
        };
        table._getPinnedRows = (visibleRows, pinnedRowIds, position)=>{
            var _table$options$keepPi;
            const rows = ((_table$options$keepPi = table.options.keepPinnedRows) != null ? _table$options$keepPi : true) ? //get all rows that are pinned even if they would not be otherwise visible
            //account for expanded parent rows, but not pagination or filtering
            (pinnedRowIds != null ? pinnedRowIds : []).map((rowId)=>{
                const row = table.getRow(rowId, true);
                return row.getIsAllParentsExpanded() ? row : null;
            }) : //else get only visible rows that are pinned
            (pinnedRowIds != null ? pinnedRowIds : []).map((rowId)=>visibleRows.find((row)=>row.id === rowId));
            return rows.filter(Boolean).map((d)=>({
                    ...d,
                    position: position
                }));
        };
        table.getTopRows = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getRowModel().rows,
                table.getState().rowPinning.top
            ], (allRows, topPinnedRowIds)=>table._getPinnedRows(allRows, topPinnedRowIds, 'top'), $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugRows', 'getTopRows'));
        table.getBottomRows = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getRowModel().rows,
                table.getState().rowPinning.bottom
            ], (allRows, bottomPinnedRowIds)=>table._getPinnedRows(allRows, bottomPinnedRowIds, 'bottom'), $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugRows', 'getBottomRows'));
        table.getCenterRows = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getRowModel().rows,
                table.getState().rowPinning.top,
                table.getState().rowPinning.bottom
            ], (allRows, top, bottom)=>{
            const topAndBottom = new Set([
                ...top != null ? top : [],
                ...bottom != null ? bottom : []
            ]);
            return allRows.filter((d)=>!topAndBottom.has(d.id));
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugRows', 'getCenterRows'));
    }
};
//
const $a458d5bea2d12b69$export$e8905133e7bf3121 = {
    getInitialState: (state)=>{
        return {
            rowSelection: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onRowSelectionChange: $a458d5bea2d12b69$export$2b5605d8069324bd('rowSelection', table),
            enableRowSelection: true,
            enableMultiRowSelection: true,
            enableSubRowSelection: true
        };
    },
    createTable: (table)=>{
        table.setRowSelection = (updater)=>table.options.onRowSelectionChange == null ? void 0 : table.options.onRowSelectionChange(updater);
        table.resetRowSelection = (defaultState)=>{
            var _table$initialState$r;
            return table.setRowSelection(defaultState ? {} : (_table$initialState$r = table.initialState.rowSelection) != null ? _table$initialState$r : {});
        };
        table.toggleAllRowsSelected = (value)=>{
            table.setRowSelection((old)=>{
                value = typeof value !== 'undefined' ? value : !table.getIsAllRowsSelected();
                const rowSelection = {
                    ...old
                };
                const preGroupedFlatRows = table.getPreGroupedRowModel().flatRows;
                // We don't use `mutateRowIsSelected` here for performance reasons.
                // All of the rows are flat already, so it wouldn't be worth it
                if (value) preGroupedFlatRows.forEach((row)=>{
                    if (!row.getCanSelect()) return;
                    rowSelection[row.id] = true;
                });
                else preGroupedFlatRows.forEach((row)=>{
                    delete rowSelection[row.id];
                });
                return rowSelection;
            });
        };
        table.toggleAllPageRowsSelected = (value)=>table.setRowSelection((old)=>{
                const resolvedValue = typeof value !== 'undefined' ? value : !table.getIsAllPageRowsSelected();
                const rowSelection = {
                    ...old
                };
                table.getRowModel().rows.forEach((row)=>{
                    $a458d5bea2d12b69$var$mutateRowIsSelected(rowSelection, row.id, resolvedValue, true, table);
                });
                return rowSelection;
            });
        // addRowSelectionRange: rowId => {
        //   const {
        //     rows,
        //     rowsById,
        //     options: { selectGroupingRows, selectSubRows },
        //   } = table
        //   const findSelectedRow = (rows: Row[]) => {
        //     let found
        //     rows.find(d => {
        //       if (d.getIsSelected()) {
        //         found = d
        //         return true
        //       }
        //       const subFound = findSelectedRow(d.subRows || [])
        //       if (subFound) {
        //         found = subFound
        //         return true
        //       }
        //       return false
        //     })
        //     return found
        //   }
        //   const firstRow = findSelectedRow(rows) || rows[0]
        //   const lastRow = rowsById[rowId]
        //   let include = false
        //   const selectedRowIds = {}
        //   const addRow = (row: Row) => {
        //     mutateRowIsSelected(selectedRowIds, row.id, true, {
        //       rowsById,
        //       selectGroupingRows: selectGroupingRows!,
        //       selectSubRows: selectSubRows!,
        //     })
        //   }
        //   table.rows.forEach(row => {
        //     const isFirstRow = row.id === firstRow.id
        //     const isLastRow = row.id === lastRow.id
        //     if (isFirstRow || isLastRow) {
        //       if (!include) {
        //         include = true
        //       } else if (include) {
        //         addRow(row)
        //         include = false
        //       }
        //     }
        //     if (include) {
        //       addRow(row)
        //     }
        //   })
        //   table.setRowSelection(selectedRowIds)
        // },
        table.getPreSelectedRowModel = ()=>table.getCoreRowModel();
        table.getSelectedRowModel = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getState().rowSelection,
                table.getCoreRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return $a458d5bea2d12b69$export$f150e72530556b0b(table, rowModel);
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', 'getSelectedRowModel'));
        table.getFilteredSelectedRowModel = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getState().rowSelection,
                table.getFilteredRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return $a458d5bea2d12b69$export$f150e72530556b0b(table, rowModel);
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', 'getFilteredSelectedRowModel'));
        table.getGroupedSelectedRowModel = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getState().rowSelection,
                table.getSortedRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return $a458d5bea2d12b69$export$f150e72530556b0b(table, rowModel);
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', 'getGroupedSelectedRowModel'));
        ///
        // getGroupingRowCanSelect: rowId => {
        //   const row = table.getRow(rowId)
        //   if (!row) {
        //     throw new Error()
        //   }
        //   if (typeof table.options.enableGroupingRowSelection === 'function') {
        //     return table.options.enableGroupingRowSelection(row)
        //   }
        //   return table.options.enableGroupingRowSelection ?? false
        // },
        table.getIsAllRowsSelected = ()=>{
            const preGroupedFlatRows = table.getFilteredRowModel().flatRows;
            const { rowSelection: rowSelection } = table.getState();
            let isAllRowsSelected = Boolean(preGroupedFlatRows.length && Object.keys(rowSelection).length);
            if (isAllRowsSelected) {
                if (preGroupedFlatRows.some((row)=>row.getCanSelect() && !rowSelection[row.id])) isAllRowsSelected = false;
            }
            return isAllRowsSelected;
        };
        table.getIsAllPageRowsSelected = ()=>{
            const paginationFlatRows = table.getPaginationRowModel().flatRows.filter((row)=>row.getCanSelect());
            const { rowSelection: rowSelection } = table.getState();
            let isAllPageRowsSelected = !!paginationFlatRows.length;
            if (isAllPageRowsSelected && paginationFlatRows.some((row)=>!rowSelection[row.id])) isAllPageRowsSelected = false;
            return isAllPageRowsSelected;
        };
        table.getIsSomeRowsSelected = ()=>{
            var _table$getState$rowSe;
            const totalSelected = Object.keys((_table$getState$rowSe = table.getState().rowSelection) != null ? _table$getState$rowSe : {}).length;
            return totalSelected > 0 && totalSelected < table.getFilteredRowModel().flatRows.length;
        };
        table.getIsSomePageRowsSelected = ()=>{
            const paginationFlatRows = table.getPaginationRowModel().flatRows;
            return table.getIsAllPageRowsSelected() ? false : paginationFlatRows.filter((row)=>row.getCanSelect()).some((d)=>d.getIsSelected() || d.getIsSomeSelected());
        };
        table.getToggleAllRowsSelectedHandler = ()=>{
            return (e)=>{
                table.toggleAllRowsSelected(e.target.checked);
            };
        };
        table.getToggleAllPageRowsSelectedHandler = ()=>{
            return (e)=>{
                table.toggleAllPageRowsSelected(e.target.checked);
            };
        };
    },
    createRow: (row, table)=>{
        row.toggleSelected = (value, opts)=>{
            const isSelected = row.getIsSelected();
            table.setRowSelection((old)=>{
                var _opts$selectChildren;
                value = typeof value !== 'undefined' ? value : !isSelected;
                if (row.getCanSelect() && isSelected === value) return old;
                const selectedRowIds = {
                    ...old
                };
                $a458d5bea2d12b69$var$mutateRowIsSelected(selectedRowIds, row.id, value, (_opts$selectChildren = opts == null ? void 0 : opts.selectChildren) != null ? _opts$selectChildren : true, table);
                return selectedRowIds;
            });
        };
        row.getIsSelected = ()=>{
            const { rowSelection: rowSelection } = table.getState();
            return $a458d5bea2d12b69$export$710e11cf672b86c(row, rowSelection);
        };
        row.getIsSomeSelected = ()=>{
            const { rowSelection: rowSelection } = table.getState();
            return $a458d5bea2d12b69$export$8f4c46e5d7907334(row, rowSelection) === 'some';
        };
        row.getIsAllSubRowsSelected = ()=>{
            const { rowSelection: rowSelection } = table.getState();
            return $a458d5bea2d12b69$export$8f4c46e5d7907334(row, rowSelection) === 'all';
        };
        row.getCanSelect = ()=>{
            var _table$options$enable;
            if (typeof table.options.enableRowSelection === 'function') return table.options.enableRowSelection(row);
            return (_table$options$enable = table.options.enableRowSelection) != null ? _table$options$enable : true;
        };
        row.getCanSelectSubRows = ()=>{
            var _table$options$enable2;
            if (typeof table.options.enableSubRowSelection === 'function') return table.options.enableSubRowSelection(row);
            return (_table$options$enable2 = table.options.enableSubRowSelection) != null ? _table$options$enable2 : true;
        };
        row.getCanMultiSelect = ()=>{
            var _table$options$enable3;
            if (typeof table.options.enableMultiRowSelection === 'function') return table.options.enableMultiRowSelection(row);
            return (_table$options$enable3 = table.options.enableMultiRowSelection) != null ? _table$options$enable3 : true;
        };
        row.getToggleSelectedHandler = ()=>{
            const canSelect = row.getCanSelect();
            return (e)=>{
                var _target;
                if (!canSelect) return;
                row.toggleSelected((_target = e.target) == null ? void 0 : _target.checked);
            };
        };
    }
};
const $a458d5bea2d12b69$var$mutateRowIsSelected = (selectedRowIds, id, value, includeChildren, table)=>{
    var _row$subRows;
    const row = table.getRow(id, true);
    // const isGrouped = row.getIsGrouped()
    // if ( // TODO: enforce grouping row selection rules
    //   !isGrouped ||
    //   (isGrouped && table.options.enableGroupingRowSelection)
    // ) {
    if (value) {
        if (!row.getCanMultiSelect()) Object.keys(selectedRowIds).forEach((key)=>delete selectedRowIds[key]);
        if (row.getCanSelect()) selectedRowIds[id] = true;
    } else delete selectedRowIds[id];
    // }
    if (includeChildren && (_row$subRows = row.subRows) != null && _row$subRows.length && row.getCanSelectSubRows()) row.subRows.forEach((row)=>$a458d5bea2d12b69$var$mutateRowIsSelected(selectedRowIds, row.id, value, includeChildren, table));
};
function $a458d5bea2d12b69$export$f150e72530556b0b(table, rowModel) {
    const rowSelection = table.getState().rowSelection;
    const newSelectedFlatRows = [];
    const newSelectedRowsById = {};
    // Filters top level and nested rows
    const recurseRows = function(rows, depth) {
        return rows.map((row)=>{
            var _row$subRows2;
            const isSelected = $a458d5bea2d12b69$export$710e11cf672b86c(row, rowSelection);
            if (isSelected) {
                newSelectedFlatRows.push(row);
                newSelectedRowsById[row.id] = row;
            }
            if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length) row = {
                ...row,
                subRows: recurseRows(row.subRows)
            };
            if (isSelected) return row;
        }).filter(Boolean);
    };
    return {
        rows: recurseRows(rowModel.rows),
        flatRows: newSelectedFlatRows,
        rowsById: newSelectedRowsById
    };
}
function $a458d5bea2d12b69$export$710e11cf672b86c(row, selection) {
    var _selection$row$id;
    return (_selection$row$id = selection[row.id]) != null ? _selection$row$id : false;
}
function $a458d5bea2d12b69$export$8f4c46e5d7907334(row, selection, table) {
    var _row$subRows3;
    if (!((_row$subRows3 = row.subRows) != null && _row$subRows3.length)) return false;
    let allChildrenSelected = true;
    let someSelected = false;
    row.subRows.forEach((subRow)=>{
        // Bail out early if we know both of these
        if (someSelected && !allChildrenSelected) return;
        if (subRow.getCanSelect()) {
            if ($a458d5bea2d12b69$export$710e11cf672b86c(subRow, selection)) someSelected = true;
            else allChildrenSelected = false;
        }
        // Check row selection of nested subrows
        if (subRow.subRows && subRow.subRows.length) {
            const subRowChildrenSelected = $a458d5bea2d12b69$export$8f4c46e5d7907334(subRow, selection);
            if (subRowChildrenSelected === 'all') someSelected = true;
            else if (subRowChildrenSelected === 'some') {
                someSelected = true;
                allChildrenSelected = false;
            } else allChildrenSelected = false;
        }
    });
    return allChildrenSelected ? 'all' : someSelected ? 'some' : false;
}
const $a458d5bea2d12b69$export$8758689f50bddb9f = /([0-9]+)/gm;
const $a458d5bea2d12b69$var$alphanumeric = (rowA, rowB, columnId)=>{
    return $a458d5bea2d12b69$var$compareAlphanumeric($a458d5bea2d12b69$var$toString(rowA.getValue(columnId)).toLowerCase(), $a458d5bea2d12b69$var$toString(rowB.getValue(columnId)).toLowerCase());
};
const $a458d5bea2d12b69$var$alphanumericCaseSensitive = (rowA, rowB, columnId)=>{
    return $a458d5bea2d12b69$var$compareAlphanumeric($a458d5bea2d12b69$var$toString(rowA.getValue(columnId)), $a458d5bea2d12b69$var$toString(rowB.getValue(columnId)));
};
// The text filter is more basic (less numeric support)
// but is much faster
const $a458d5bea2d12b69$var$text = (rowA, rowB, columnId)=>{
    return $a458d5bea2d12b69$var$compareBasic($a458d5bea2d12b69$var$toString(rowA.getValue(columnId)).toLowerCase(), $a458d5bea2d12b69$var$toString(rowB.getValue(columnId)).toLowerCase());
};
// The text filter is more basic (less numeric support)
// but is much faster
const $a458d5bea2d12b69$var$textCaseSensitive = (rowA, rowB, columnId)=>{
    return $a458d5bea2d12b69$var$compareBasic($a458d5bea2d12b69$var$toString(rowA.getValue(columnId)), $a458d5bea2d12b69$var$toString(rowB.getValue(columnId)));
};
const $a458d5bea2d12b69$var$datetime = (rowA, rowB, columnId)=>{
    const a = rowA.getValue(columnId);
    const b = rowB.getValue(columnId);
    // Can handle nullish values
    // Use > and < because == (and ===) doesn't work with
    // Date objects (would require calling getTime()).
    return a > b ? 1 : a < b ? -1 : 0;
};
const $a458d5bea2d12b69$var$basic = (rowA, rowB, columnId)=>{
    return $a458d5bea2d12b69$var$compareBasic(rowA.getValue(columnId), rowB.getValue(columnId));
};
// Utils
function $a458d5bea2d12b69$var$compareBasic(a, b) {
    return a === b ? 0 : a > b ? 1 : -1;
}
function $a458d5bea2d12b69$var$toString(a) {
    if (typeof a === 'number') {
        if (isNaN(a) || a === Infinity || a === -Infinity) return '';
        return String(a);
    }
    if (typeof a === 'string') return a;
    return '';
}
// Mixed sorting is slow, but very inclusive of many edge cases.
// It handles numbers, mixed alphanumeric combinations, and even
// null, undefined, and Infinity
function $a458d5bea2d12b69$var$compareAlphanumeric(aStr, bStr) {
    // Split on number groups, but keep the delimiter
    // Then remove falsey split values
    const a = aStr.split($a458d5bea2d12b69$export$8758689f50bddb9f).filter(Boolean);
    const b = bStr.split($a458d5bea2d12b69$export$8758689f50bddb9f).filter(Boolean);
    // While
    while(a.length && b.length){
        const aa = a.shift();
        const bb = b.shift();
        const an = parseInt(aa, 10);
        const bn = parseInt(bb, 10);
        const combo = [
            an,
            bn
        ].sort();
        // Both are string
        if (isNaN(combo[0])) {
            if (aa > bb) return 1;
            if (bb > aa) return -1;
            continue;
        }
        // One is a string, one is a number
        if (isNaN(combo[1])) return isNaN(an) ? -1 : 1;
        // Both are numbers
        if (an > bn) return 1;
        if (bn > an) return -1;
    }
    return a.length - b.length;
}
// Exports
const $a458d5bea2d12b69$export$47423a4cd813a815 = {
    alphanumeric: $a458d5bea2d12b69$var$alphanumeric,
    alphanumericCaseSensitive: $a458d5bea2d12b69$var$alphanumericCaseSensitive,
    text: $a458d5bea2d12b69$var$text,
    textCaseSensitive: $a458d5bea2d12b69$var$textCaseSensitive,
    datetime: $a458d5bea2d12b69$var$datetime,
    basic: $a458d5bea2d12b69$var$basic
};
//
const $a458d5bea2d12b69$export$c7de5ec16c5efba8 = {
    getInitialState: (state)=>{
        return {
            sorting: [],
            ...state
        };
    },
    getDefaultColumnDef: ()=>{
        return {
            sortingFn: 'auto',
            sortUndefined: 1
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onSortingChange: $a458d5bea2d12b69$export$2b5605d8069324bd('sorting', table),
            isMultiSortEvent: (e)=>{
                return e.shiftKey;
            }
        };
    },
    createColumn: (column, table)=>{
        column.getAutoSortingFn = ()=>{
            const firstRows = table.getFilteredRowModel().flatRows.slice(10);
            let isString = false;
            for (const row of firstRows){
                const value = row == null ? void 0 : row.getValue(column.id);
                if (Object.prototype.toString.call(value) === '[object Date]') return $a458d5bea2d12b69$export$47423a4cd813a815.datetime;
                if (typeof value === 'string') {
                    isString = true;
                    if (value.split($a458d5bea2d12b69$export$8758689f50bddb9f).length > 1) return $a458d5bea2d12b69$export$47423a4cd813a815.alphanumeric;
                }
            }
            if (isString) return $a458d5bea2d12b69$export$47423a4cd813a815.text;
            return $a458d5bea2d12b69$export$47423a4cd813a815.basic;
        };
        column.getAutoSortDir = ()=>{
            const firstRow = table.getFilteredRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === 'string') return 'asc';
            return 'desc';
        };
        column.getSortingFn = ()=>{
            var _table$options$sortin, _table$options$sortin2;
            if (!column) throw new Error();
            return $a458d5bea2d12b69$export$f6e2535fb5126e54(column.columnDef.sortingFn) ? column.columnDef.sortingFn : column.columnDef.sortingFn === 'auto' ? column.getAutoSortingFn() : (_table$options$sortin = (_table$options$sortin2 = table.options.sortingFns) == null ? void 0 : _table$options$sortin2[column.columnDef.sortingFn]) != null ? _table$options$sortin : $a458d5bea2d12b69$export$47423a4cd813a815[column.columnDef.sortingFn];
        };
        column.toggleSorting = (desc, multi)=>{
            // if (column.columns.length) {
            //   column.columns.forEach((c, i) => {
            //     if (c.id) {
            //       table.toggleColumnSorting(c.id, undefined, multi || !!i)
            //     }
            //   })
            //   return
            // }
            // this needs to be outside of table.setSorting to be in sync with rerender
            const nextSortingOrder = column.getNextSortingOrder();
            const hasManualValue = typeof desc !== 'undefined' && desc !== null;
            table.setSorting((old)=>{
                // Find any existing sorting for this column
                const existingSorting = old == null ? void 0 : old.find((d)=>d.id === column.id);
                const existingIndex = old == null ? void 0 : old.findIndex((d)=>d.id === column.id);
                let newSorting = [];
                // What should we do with this sort action?
                let sortAction;
                let nextDesc = hasManualValue ? desc : nextSortingOrder === 'desc';
                // Multi-mode
                if (old != null && old.length && column.getCanMultiSort() && multi) {
                    if (existingSorting) sortAction = 'toggle';
                    else sortAction = 'add';
                } else {
                    // Normal mode
                    if (old != null && old.length && existingIndex !== old.length - 1) sortAction = 'replace';
                    else if (existingSorting) sortAction = 'toggle';
                    else sortAction = 'replace';
                }
                // Handle toggle states that will remove the sorting
                if (sortAction === 'toggle') {
                    // If we are "actually" toggling (not a manual set value), should we remove the sorting?
                    if (!hasManualValue) // Is our intention to remove?
                    {
                        if (!nextSortingOrder) sortAction = 'remove';
                    }
                }
                if (sortAction === 'add') {
                    var _table$options$maxMul;
                    newSorting = [
                        ...old,
                        {
                            id: column.id,
                            desc: nextDesc
                        }
                    ];
                    // Take latest n columns
                    newSorting.splice(0, newSorting.length - ((_table$options$maxMul = table.options.maxMultiSortColCount) != null ? _table$options$maxMul : Number.MAX_SAFE_INTEGER));
                } else if (sortAction === 'toggle') // This flips (or sets) the
                newSorting = old.map((d)=>{
                    if (d.id === column.id) return {
                        ...d,
                        desc: nextDesc
                    };
                    return d;
                });
                else if (sortAction === 'remove') newSorting = old.filter((d)=>d.id !== column.id);
                else newSorting = [
                    {
                        id: column.id,
                        desc: nextDesc
                    }
                ];
                return newSorting;
            });
        };
        column.getFirstSortDir = ()=>{
            var _ref, _column$columnDef$sor;
            const sortDescFirst = (_ref = (_column$columnDef$sor = column.columnDef.sortDescFirst) != null ? _column$columnDef$sor : table.options.sortDescFirst) != null ? _ref : column.getAutoSortDir() === 'desc';
            return sortDescFirst ? 'desc' : 'asc';
        };
        column.getNextSortingOrder = (multi)=>{
            var _table$options$enable, _table$options$enable2;
            const firstSortDirection = column.getFirstSortDir();
            const isSorted = column.getIsSorted();
            if (!isSorted) return firstSortDirection;
            if (isSorted !== firstSortDirection && ((_table$options$enable = table.options.enableSortingRemoval) != null ? _table$options$enable : true) && // If enableSortRemove, enable in general
            (multi ? (_table$options$enable2 = table.options.enableMultiRemove) != null ? _table$options$enable2 : true : true // If multi, don't allow if enableMultiRemove))
            )) return false;
            return isSorted === 'desc' ? 'asc' : 'desc';
        };
        column.getCanSort = ()=>{
            var _column$columnDef$ena, _table$options$enable3;
            return ((_column$columnDef$ena = column.columnDef.enableSorting) != null ? _column$columnDef$ena : true) && ((_table$options$enable3 = table.options.enableSorting) != null ? _table$options$enable3 : true) && !!column.accessorFn;
        };
        column.getCanMultiSort = ()=>{
            var _ref2, _column$columnDef$ena2;
            return (_ref2 = (_column$columnDef$ena2 = column.columnDef.enableMultiSort) != null ? _column$columnDef$ena2 : table.options.enableMultiSort) != null ? _ref2 : !!column.accessorFn;
        };
        column.getIsSorted = ()=>{
            var _table$getState$sorti;
            const columnSort = (_table$getState$sorti = table.getState().sorting) == null ? void 0 : _table$getState$sorti.find((d)=>d.id === column.id);
            return !columnSort ? false : columnSort.desc ? 'desc' : 'asc';
        };
        column.getSortIndex = ()=>{
            var _table$getState$sorti2, _table$getState$sorti3;
            return (_table$getState$sorti2 = (_table$getState$sorti3 = table.getState().sorting) == null ? void 0 : _table$getState$sorti3.findIndex((d)=>d.id === column.id)) != null ? _table$getState$sorti2 : -1;
        };
        column.clearSorting = ()=>{
            //clear sorting for just 1 column
            table.setSorting((old)=>old != null && old.length ? old.filter((d)=>d.id !== column.id) : []);
        };
        column.getToggleSortingHandler = ()=>{
            const canSort = column.getCanSort();
            return (e)=>{
                if (!canSort) return;
                e.persist == null || e.persist();
                column.toggleSorting == null || column.toggleSorting(undefined, column.getCanMultiSort() ? table.options.isMultiSortEvent == null ? void 0 : table.options.isMultiSortEvent(e) : false);
            };
        };
    },
    createTable: (table)=>{
        table.setSorting = (updater)=>table.options.onSortingChange == null ? void 0 : table.options.onSortingChange(updater);
        table.resetSorting = (defaultState)=>{
            var _table$initialState$s, _table$initialState;
            table.setSorting(defaultState ? [] : (_table$initialState$s = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.sorting) != null ? _table$initialState$s : []);
        };
        table.getPreSortedRowModel = ()=>table.getGroupedRowModel();
        table.getSortedRowModel = ()=>{
            if (!table._getSortedRowModel && table.options.getSortedRowModel) table._getSortedRowModel = table.options.getSortedRowModel(table);
            if (table.options.manualSorting || !table._getSortedRowModel) return table.getPreSortedRowModel();
            return table._getSortedRowModel();
        };
    }
};
const $a458d5bea2d12b69$var$builtInFeatures = [
    $a458d5bea2d12b69$export$79b704688b15c0f4,
    $a458d5bea2d12b69$export$be5545a32e20d889,
    $a458d5bea2d12b69$export$fec9c66cd0275c2c,
    $a458d5bea2d12b69$export$3563275ce70c4813,
    $a458d5bea2d12b69$export$1f746e6a9cd841b1,
    $a458d5bea2d12b69$export$f1d67534a0c5e9d3,
    $a458d5bea2d12b69$export$4b37edcdc7ad2fe1,
    //depends on ColumnFaceting
    $a458d5bea2d12b69$export$61e9e0661ff79b1c,
    //depends on ColumnFiltering
    $a458d5bea2d12b69$export$c7de5ec16c5efba8,
    $a458d5bea2d12b69$export$9c9247c655f92e74,
    //depends on RowSorting
    $a458d5bea2d12b69$export$fed54e0d64c17fb2,
    $a458d5bea2d12b69$export$bce540641752d22b,
    $a458d5bea2d12b69$export$213d72cb2ac7d440,
    $a458d5bea2d12b69$export$e8905133e7bf3121,
    $a458d5bea2d12b69$export$9916c85814812d4a
];
//
function $a458d5bea2d12b69$export$33bbb3ec7652e187(options) {
    var _options$_features, _options$initialState;
    const _features = [
        ...$a458d5bea2d12b69$var$builtInFeatures,
        ...(_options$_features = options._features) != null ? _options$_features : []
    ];
    let table = {
        _features: _features
    };
    const defaultOptions = table._features.reduce((obj, feature)=>{
        return Object.assign(obj, feature.getDefaultOptions == null ? void 0 : feature.getDefaultOptions(table));
    }, {});
    const mergeOptions = (options)=>{
        if (table.options.mergeOptions) return table.options.mergeOptions(defaultOptions, options);
        return {
            ...defaultOptions,
            ...options
        };
    };
    const coreInitialState = {};
    let initialState = {
        ...coreInitialState,
        ...(_options$initialState = options.initialState) != null ? _options$initialState : {}
    };
    table._features.forEach((feature)=>{
        var _feature$getInitialSt;
        initialState = (_feature$getInitialSt = feature.getInitialState == null ? void 0 : feature.getInitialState(initialState)) != null ? _feature$getInitialSt : initialState;
    });
    const queued = [];
    let queuedTimeout = false;
    const coreInstance = {
        _features: _features,
        options: {
            ...defaultOptions,
            ...options
        },
        initialState: initialState,
        _queue: (cb)=>{
            queued.push(cb);
            if (!queuedTimeout) {
                queuedTimeout = true;
                // Schedule a microtask to run the queued callbacks after
                // the current call stack (render, etc) has finished.
                Promise.resolve().then(()=>{
                    while(queued.length)queued.shift()();
                    queuedTimeout = false;
                }).catch((error)=>setTimeout(()=>{
                        throw error;
                    }));
            }
        },
        reset: ()=>{
            table.setState(table.initialState);
        },
        setOptions: (updater)=>{
            const newOptions = $a458d5bea2d12b69$export$7f095f455ad5af3f(updater, table.options);
            table.options = mergeOptions(newOptions);
        },
        getState: ()=>{
            return table.options.state;
        },
        setState: (updater)=>{
            table.options.onStateChange == null || table.options.onStateChange(updater);
        },
        _getRowId: (row, index, parent)=>{
            var _table$options$getRow;
            return (_table$options$getRow = table.options.getRowId == null ? void 0 : table.options.getRowId(row, index, parent)) != null ? _table$options$getRow : `${parent ? [
                parent.id,
                index
            ].join('.') : index}`;
        },
        getCoreRowModel: ()=>{
            if (!table._getCoreRowModel) table._getCoreRowModel = table.options.getCoreRowModel(table);
            return table._getCoreRowModel();
        },
        // The final calls start at the bottom of the model,
        // expanded rows, which then work their way up
        getRowModel: ()=>{
            return table.getPaginationRowModel();
        },
        //in next version, we should just pass in the row model as the optional 2nd arg
        getRow: (id, searchAll)=>{
            let row = (searchAll ? table.getPrePaginationRowModel() : table.getRowModel()).rowsById[id];
            if (!row) {
                row = table.getCoreRowModel().rowsById[id];
                if (!row) throw new Error();
            }
            return row;
        },
        _getDefaultColumnDef: $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.options.defaultColumn
            ], (defaultColumn)=>{
            var _defaultColumn;
            defaultColumn = (_defaultColumn = defaultColumn) != null ? _defaultColumn : {};
            return {
                header: (props)=>{
                    const resolvedColumnDef = props.header.column.columnDef;
                    if (resolvedColumnDef.accessorKey) return resolvedColumnDef.accessorKey;
                    if (resolvedColumnDef.accessorFn) return resolvedColumnDef.id;
                    return null;
                },
                // footer: props => props.header.column.id,
                cell: (props)=>{
                    var _props$renderValue$to, _props$renderValue;
                    return (_props$renderValue$to = (_props$renderValue = props.renderValue()) == null || _props$renderValue.toString == null ? void 0 : _props$renderValue.toString()) != null ? _props$renderValue$to : null;
                },
                ...table._features.reduce((obj, feature)=>{
                    return Object.assign(obj, feature.getDefaultColumnDef == null ? void 0 : feature.getDefaultColumnDef());
                }, {}),
                ...defaultColumn
            };
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(options, 'debugColumns', '_getDefaultColumnDef')),
        _getColumnDefs: ()=>table.options.columns,
        getAllColumns: $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table._getColumnDefs()
            ], (columnDefs)=>{
            const recurseColumns = function(columnDefs, parent, depth) {
                if (depth === void 0) depth = 0;
                return columnDefs.map((columnDef)=>{
                    const column = $a458d5bea2d12b69$export$1bfa986e9c92c0b5(table, columnDef, depth, parent);
                    const groupingColumnDef = columnDef;
                    column.columns = groupingColumnDef.columns ? recurseColumns(groupingColumnDef.columns, column, depth + 1) : [];
                    return column;
                });
            };
            return recurseColumns(columnDefs);
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(options, 'debugColumns', 'getAllColumns')),
        getAllFlatColumns: $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getAllColumns()
            ], (allColumns)=>{
            return allColumns.flatMap((column)=>{
                return column.getFlatColumns();
            });
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(options, 'debugColumns', 'getAllFlatColumns')),
        _getAllFlatColumnsById: $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getAllFlatColumns()
            ], (flatColumns)=>{
            return flatColumns.reduce((acc, column)=>{
                acc[column.id] = column;
                return acc;
            }, {});
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(options, 'debugColumns', 'getAllFlatColumnsById')),
        getAllLeafColumns: $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table._getOrderColumnsFn()
            ], (allColumns, orderColumns)=>{
            let leafColumns = allColumns.flatMap((column)=>column.getLeafColumns());
            return orderColumns(leafColumns);
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(options, 'debugColumns', 'getAllLeafColumns')),
        getColumn: (columnId)=>{
            const column = table._getAllFlatColumnsById()[columnId];
            return column;
        }
    };
    Object.assign(table, coreInstance);
    for(let index = 0; index < table._features.length; index++){
        const feature = table._features[index];
        feature == null || feature.createTable == null || feature.createTable(table);
    }
    return table;
}
function $a458d5bea2d12b69$export$32d0bc001e828250() {
    return (table)=>$a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.options.data
            ], (data)=>{
            const rowModel = {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            const accessRows = function(originalRows, depth, parentRow) {
                if (depth === void 0) depth = 0;
                const rows = [];
                for(let i = 0; i < originalRows.length; i++){
                    // This could be an expensive check at scale, so we should move it somewhere else, but where?
                    // if (!id) {
                    //   if (process.env.NODE_ENV !== 'production') {
                    //     throw new Error(`getRowId expected an ID, but got ${id}`)
                    //   }
                    // }
                    // Make the row
                    const row = $a458d5bea2d12b69$export$3442c5d213434705(table, table._getRowId(originalRows[i], i, parentRow), originalRows[i], i, depth, undefined, parentRow == null ? void 0 : parentRow.id);
                    // Keep track of every row in a flat array
                    rowModel.flatRows.push(row);
                    // Also keep track of every row by its ID
                    rowModel.rowsById[row.id] = row;
                    // Push table row into parent
                    rows.push(row);
                    // Get the original subrows
                    if (table.options.getSubRows) {
                        var _row$originalSubRows;
                        row.originalSubRows = table.options.getSubRows(originalRows[i], i);
                        // Then recursively access them
                        if ((_row$originalSubRows = row.originalSubRows) != null && _row$originalSubRows.length) row.subRows = accessRows(row.originalSubRows, depth + 1, row);
                    }
                }
                return rows;
            };
            rowModel.rows = accessRows(data);
            return rowModel;
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', 'getRowModel', ()=>table._autoResetPageIndex()));
}
function $a458d5bea2d12b69$export$53cfec7b1b8d1fcd() {
    return (table)=>$a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getState().expanded,
                table.getPreExpandedRowModel(),
                table.options.paginateExpandedRows
            ], (expanded, rowModel, paginateExpandedRows)=>{
            if (!rowModel.rows.length || expanded !== true && !Object.keys(expanded != null ? expanded : {}).length) return rowModel;
            if (!paginateExpandedRows) // Only expand rows at this point if they are being paginated
            return rowModel;
            return $a458d5bea2d12b69$export$1293f966cdb38633(rowModel);
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', 'getExpandedRowModel'));
}
function $a458d5bea2d12b69$export$1293f966cdb38633(rowModel) {
    const expandedRows = [];
    const handleRow = (row)=>{
        var _row$subRows;
        expandedRows.push(row);
        if ((_row$subRows = row.subRows) != null && _row$subRows.length && row.getIsExpanded()) row.subRows.forEach(handleRow);
    };
    rowModel.rows.forEach(handleRow);
    return {
        rows: expandedRows,
        flatRows: rowModel.flatRows,
        rowsById: rowModel.rowsById
    };
}
function $a458d5bea2d12b69$export$d17dd32c9eab9fc7() {
    return (table, columnId)=>$a458d5bea2d12b69$export$7c73462e0d25e514(()=>{
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, (facetedRowModel)=>{
            if (!facetedRowModel) return undefined;
            const uniqueValues = facetedRowModel.flatRows.flatMap((flatRow)=>{
                var _flatRow$getUniqueVal;
                return (_flatRow$getUniqueVal = flatRow.getUniqueValues(columnId)) != null ? _flatRow$getUniqueVal : [];
            }).map(Number).filter((value)=>!Number.isNaN(value));
            if (!uniqueValues.length) return;
            let facetedMinValue = uniqueValues[0];
            let facetedMaxValue = uniqueValues[uniqueValues.length - 1];
            for (const value of uniqueValues){
                if (value < facetedMinValue) facetedMinValue = value;
                else if (value > facetedMaxValue) facetedMaxValue = value;
            }
            return [
                facetedMinValue,
                facetedMaxValue
            ];
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', 'getFacetedMinMaxValues'));
}
function $a458d5bea2d12b69$var$filterRows(rows, filterRowImpl, table) {
    if (table.options.filterFromLeafRows) return $a458d5bea2d12b69$var$filterRowModelFromLeafs(rows, filterRowImpl, table);
    return $a458d5bea2d12b69$var$filterRowModelFromRoot(rows, filterRowImpl, table);
}
function $a458d5bea2d12b69$var$filterRowModelFromLeafs(rowsToFilter, filterRow, table) {
    var _table$options$maxLea;
    const newFilteredFlatRows = [];
    const newFilteredRowsById = {};
    const maxDepth = (_table$options$maxLea = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea : 100;
    const recurseFilterRows = function(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        const rows = [];
        // Filter from children up first
        for(let i = 0; i < rowsToFilter.length; i++){
            var _row$subRows;
            let row = rowsToFilter[i];
            const newRow = $a458d5bea2d12b69$export$3442c5d213434705(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
            newRow.columnFilters = row.columnFilters;
            if ((_row$subRows = row.subRows) != null && _row$subRows.length && depth < maxDepth) {
                newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                row = newRow;
                if (filterRow(row) && !newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                    continue;
                }
                if (filterRow(row) || newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                    continue;
                }
            } else {
                row = newRow;
                if (filterRow(row)) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                }
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function $a458d5bea2d12b69$var$filterRowModelFromRoot(rowsToFilter, filterRow, table) {
    var _table$options$maxLea2;
    const newFilteredFlatRows = [];
    const newFilteredRowsById = {};
    const maxDepth = (_table$options$maxLea2 = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea2 : 100;
    // Filters top level and nested rows
    const recurseFilterRows = function(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        // Filter from parents downward first
        const rows = [];
        // Apply the filter to any subRows
        for(let i = 0; i < rowsToFilter.length; i++){
            let row = rowsToFilter[i];
            const pass = filterRow(row);
            if (pass) {
                var _row$subRows2;
                if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length && depth < maxDepth) {
                    const newRow = $a458d5bea2d12b69$export$3442c5d213434705(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
                    newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                    row = newRow;
                }
                rows.push(row);
                newFilteredFlatRows.push(row);
                newFilteredRowsById[row.id] = row;
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function $a458d5bea2d12b69$export$3519aa0e35dc33b4() {
    return (table, columnId)=>$a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter,
                table.getFilteredRowModel()
            ], (preRowModel, columnFilters, globalFilter)=>{
            if (!preRowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) return preRowModel;
            const filterableIds = [
                ...columnFilters.map((d)=>d.id).filter((d)=>d !== columnId),
                globalFilter ? '__global__' : undefined
            ].filter(Boolean);
            const filterRowsImpl = (row)=>{
                // Horizontally filter rows through each column
                for(let i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            return $a458d5bea2d12b69$var$filterRows(preRowModel.rows, filterRowsImpl, table);
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', 'getFacetedRowModel'));
}
function $a458d5bea2d12b69$export$1fb5d0c1edc37de2() {
    return (table, columnId)=>$a458d5bea2d12b69$export$7c73462e0d25e514(()=>{
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, (facetedRowModel)=>{
            if (!facetedRowModel) return new Map();
            let facetedUniqueValues = new Map();
            for(let i = 0; i < facetedRowModel.flatRows.length; i++){
                const values = facetedRowModel.flatRows[i].getUniqueValues(columnId);
                for(let j = 0; j < values.length; j++){
                    const value = values[j];
                    if (facetedUniqueValues.has(value)) {
                        var _facetedUniqueValues$;
                        facetedUniqueValues.set(value, ((_facetedUniqueValues$ = facetedUniqueValues.get(value)) != null ? _facetedUniqueValues$ : 0) + 1);
                    } else facetedUniqueValues.set(value, 1);
                }
            }
            return facetedUniqueValues;
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', `getFacetedUniqueValues_${columnId}`));
}
function $a458d5bea2d12b69$export$26f255a2756e1638() {
    return (table)=>$a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter
            ], (rowModel, columnFilters, globalFilter)=>{
            if (!rowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) {
                for(let i = 0; i < rowModel.flatRows.length; i++){
                    rowModel.flatRows[i].columnFilters = {};
                    rowModel.flatRows[i].columnFiltersMeta = {};
                }
                return rowModel;
            }
            const resolvedColumnFilters = [];
            const resolvedGlobalFilters = [];
            (columnFilters != null ? columnFilters : []).forEach((d)=>{
                var _filterFn$resolveFilt;
                const column = table.getColumn(d.id);
                if (!column) return;
                const filterFn = column.getFilterFn();
                if (!filterFn) return;
                resolvedColumnFilters.push({
                    id: d.id,
                    filterFn: filterFn,
                    resolvedValue: (_filterFn$resolveFilt = filterFn.resolveFilterValue == null ? void 0 : filterFn.resolveFilterValue(d.value)) != null ? _filterFn$resolveFilt : d.value
                });
            });
            const filterableIds = (columnFilters != null ? columnFilters : []).map((d)=>d.id);
            const globalFilterFn = table.getGlobalFilterFn();
            const globallyFilterableColumns = table.getAllLeafColumns().filter((column)=>column.getCanGlobalFilter());
            if (globalFilter && globalFilterFn && globallyFilterableColumns.length) {
                filterableIds.push('__global__');
                globallyFilterableColumns.forEach((column)=>{
                    var _globalFilterFn$resol;
                    resolvedGlobalFilters.push({
                        id: column.id,
                        filterFn: globalFilterFn,
                        resolvedValue: (_globalFilterFn$resol = globalFilterFn.resolveFilterValue == null ? void 0 : globalFilterFn.resolveFilterValue(globalFilter)) != null ? _globalFilterFn$resol : globalFilter
                    });
                });
            }
            let currentColumnFilter;
            let currentGlobalFilter;
            // Flag the prefiltered row model with each filter state
            for(let j = 0; j < rowModel.flatRows.length; j++){
                const row = rowModel.flatRows[j];
                row.columnFilters = {};
                if (resolvedColumnFilters.length) for(let i = 0; i < resolvedColumnFilters.length; i++){
                    currentColumnFilter = resolvedColumnFilters[i];
                    const id = currentColumnFilter.id;
                    // Tag the row with the column filter state
                    row.columnFilters[id] = currentColumnFilter.filterFn(row, id, currentColumnFilter.resolvedValue, (filterMeta)=>{
                        row.columnFiltersMeta[id] = filterMeta;
                    });
                }
                if (resolvedGlobalFilters.length) {
                    for(let i = 0; i < resolvedGlobalFilters.length; i++){
                        currentGlobalFilter = resolvedGlobalFilters[i];
                        const id = currentGlobalFilter.id;
                        // Tag the row with the first truthy global filter state
                        if (currentGlobalFilter.filterFn(row, id, currentGlobalFilter.resolvedValue, (filterMeta)=>{
                            row.columnFiltersMeta[id] = filterMeta;
                        })) {
                            row.columnFilters.__global__ = true;
                            break;
                        }
                    }
                    if (row.columnFilters.__global__ !== true) row.columnFilters.__global__ = false;
                }
            }
            const filterRowsImpl = (row)=>{
                // Horizontally filter rows through each column
                for(let i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            // Filter final rows using all of the active filters
            return $a458d5bea2d12b69$var$filterRows(rowModel.rows, filterRowsImpl, table);
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', 'getFilteredRowModel', ()=>table._autoResetPageIndex()));
}
function $a458d5bea2d12b69$export$2b7f4b57ce71b81() {
    return (table)=>$a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getState().grouping,
                table.getPreGroupedRowModel()
            ], (grouping, rowModel)=>{
            if (!rowModel.rows.length || !grouping.length) {
                rowModel.rows.forEach((row)=>{
                    row.depth = 0;
                    row.parentId = undefined;
                });
                return rowModel;
            }
            // Filter the grouping list down to columns that exist
            const existingGrouping = grouping.filter((columnId)=>table.getColumn(columnId));
            const groupedFlatRows = [];
            const groupedRowsById = {};
            // const onlyGroupedFlatRows: Row[] = [];
            // const onlyGroupedRowsById: Record<RowId, Row> = {};
            // const nonGroupedFlatRows: Row[] = [];
            // const nonGroupedRowsById: Record<RowId, Row> = {};
            // Recursively group the data
            const groupUpRecursively = function(rows, depth, parentId) {
                if (depth === void 0) depth = 0;
                // Grouping depth has been been met
                // Stop grouping and simply rewrite thd depth and row relationships
                if (depth >= existingGrouping.length) return rows.map((row)=>{
                    row.depth = depth;
                    groupedFlatRows.push(row);
                    groupedRowsById[row.id] = row;
                    if (row.subRows) row.subRows = groupUpRecursively(row.subRows, depth + 1, row.id);
                    return row;
                });
                const columnId = existingGrouping[depth];
                // Group the rows together for this level
                const rowGroupsMap = $a458d5bea2d12b69$var$groupBy(rows, columnId);
                // Perform aggregations for each group
                const aggregatedGroupedRows = Array.from(rowGroupsMap.entries()).map((_ref, index)=>{
                    let [groupingValue, groupedRows] = _ref;
                    let id = `${columnId}:${groupingValue}`;
                    id = parentId ? `${parentId}>${id}` : id;
                    // First, Recurse to group sub rows before aggregation
                    const subRows = groupUpRecursively(groupedRows, depth + 1, id);
                    subRows.forEach((subRow)=>{
                        subRow.parentId = id;
                    });
                    // Flatten the leaf rows of the rows in this group
                    const leafRows = depth ? $a458d5bea2d12b69$export$bf4548421d1b2c8(groupedRows, (row)=>row.subRows) : groupedRows;
                    const row = $a458d5bea2d12b69$export$3442c5d213434705(table, id, leafRows[0].original, index, depth, undefined, parentId);
                    Object.assign(row, {
                        groupingColumnId: columnId,
                        groupingValue: groupingValue,
                        subRows: subRows,
                        leafRows: leafRows,
                        getValue: (columnId)=>{
                            // Don't aggregate columns that are in the grouping
                            if (existingGrouping.includes(columnId)) {
                                if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
                                if (groupedRows[0]) {
                                    var _groupedRows$0$getVal;
                                    row._valuesCache[columnId] = (_groupedRows$0$getVal = groupedRows[0].getValue(columnId)) != null ? _groupedRows$0$getVal : undefined;
                                }
                                return row._valuesCache[columnId];
                            }
                            if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
                            // Aggregate the values
                            const column = table.getColumn(columnId);
                            const aggregateFn = column == null ? void 0 : column.getAggregationFn();
                            if (aggregateFn) {
                                row._groupingValuesCache[columnId] = aggregateFn(columnId, leafRows, groupedRows);
                                return row._groupingValuesCache[columnId];
                            }
                        }
                    });
                    subRows.forEach((subRow)=>{
                        groupedFlatRows.push(subRow);
                        groupedRowsById[subRow.id] = subRow;
                    // if (subRow.getIsGrouped?.()) {
                    //   onlyGroupedFlatRows.push(subRow);
                    //   onlyGroupedRowsById[subRow.id] = subRow;
                    // } else {
                    //   nonGroupedFlatRows.push(subRow);
                    //   nonGroupedRowsById[subRow.id] = subRow;
                    // }
                    });
                    return row;
                });
                return aggregatedGroupedRows;
            };
            const groupedRows = groupUpRecursively(rowModel.rows, 0);
            groupedRows.forEach((subRow)=>{
                groupedFlatRows.push(subRow);
                groupedRowsById[subRow.id] = subRow;
            // if (subRow.getIsGrouped?.()) {
            //   onlyGroupedFlatRows.push(subRow);
            //   onlyGroupedRowsById[subRow.id] = subRow;
            // } else {
            //   nonGroupedFlatRows.push(subRow);
            //   nonGroupedRowsById[subRow.id] = subRow;
            // }
            });
            return {
                rows: groupedRows,
                flatRows: groupedFlatRows,
                rowsById: groupedRowsById
            };
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', 'getGroupedRowModel', ()=>{
            table._queue(()=>{
                table._autoResetExpanded();
                table._autoResetPageIndex();
            });
        }));
}
function $a458d5bea2d12b69$var$groupBy(rows, columnId) {
    const groupMap = new Map();
    return rows.reduce((map, row)=>{
        const resKey = `${row.getGroupingValue(columnId)}`;
        const previous = map.get(resKey);
        if (!previous) map.set(resKey, [
            row
        ]);
        else previous.push(row);
        return map;
    }, groupMap);
}
function $a458d5bea2d12b69$export$ddfd3662e196c265(opts) {
    return (table)=>$a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getState().pagination,
                table.getPrePaginationRowModel(),
                table.options.paginateExpandedRows ? undefined : table.getState().expanded
            ], (pagination, rowModel)=>{
            if (!rowModel.rows.length) return rowModel;
            const { pageSize: pageSize, pageIndex: pageIndex } = pagination;
            let { rows: rows, flatRows: flatRows, rowsById: rowsById } = rowModel;
            const pageStart = pageSize * pageIndex;
            const pageEnd = pageStart + pageSize;
            rows = rows.slice(pageStart, pageEnd);
            let paginatedRowModel;
            if (!table.options.paginateExpandedRows) paginatedRowModel = $a458d5bea2d12b69$export$1293f966cdb38633({
                rows: rows,
                flatRows: flatRows,
                rowsById: rowsById
            });
            else paginatedRowModel = {
                rows: rows,
                flatRows: flatRows,
                rowsById: rowsById
            };
            paginatedRowModel.flatRows = [];
            const handleRow = (row)=>{
                paginatedRowModel.flatRows.push(row);
                if (row.subRows.length) row.subRows.forEach(handleRow);
            };
            paginatedRowModel.rows.forEach(handleRow);
            return paginatedRowModel;
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', 'getPaginationRowModel'));
}
function $a458d5bea2d12b69$export$4ca93ca80835d8c1() {
    return (table)=>$a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getState().sorting,
                table.getPreSortedRowModel()
            ], (sorting, rowModel)=>{
            if (!rowModel.rows.length || !(sorting != null && sorting.length)) return rowModel;
            const sortingState = table.getState().sorting;
            const sortedFlatRows = [];
            // Filter out sortings that correspond to non existing columns
            const availableSorting = sortingState.filter((sort)=>{
                var _table$getColumn;
                return (_table$getColumn = table.getColumn(sort.id)) == null ? void 0 : _table$getColumn.getCanSort();
            });
            const columnInfoById = {};
            availableSorting.forEach((sortEntry)=>{
                const column = table.getColumn(sortEntry.id);
                if (!column) return;
                columnInfoById[sortEntry.id] = {
                    sortUndefined: column.columnDef.sortUndefined,
                    invertSorting: column.columnDef.invertSorting,
                    sortingFn: column.getSortingFn()
                };
            });
            const sortData = (rows)=>{
                // This will also perform a stable sorting using the row index
                // if needed.
                const sortedData = rows.map((row)=>({
                        ...row
                    }));
                sortedData.sort((rowA, rowB)=>{
                    for(let i = 0; i < availableSorting.length; i += 1){
                        var _sortEntry$desc;
                        const sortEntry = availableSorting[i];
                        const columnInfo = columnInfoById[sortEntry.id];
                        const sortUndefined = columnInfo.sortUndefined;
                        const isDesc = (_sortEntry$desc = sortEntry == null ? void 0 : sortEntry.desc) != null ? _sortEntry$desc : false;
                        let sortInt = 0;
                        // All sorting ints should always return in ascending order
                        if (sortUndefined) {
                            const aValue = rowA.getValue(sortEntry.id);
                            const bValue = rowB.getValue(sortEntry.id);
                            const aUndefined = aValue === undefined;
                            const bUndefined = bValue === undefined;
                            if (aUndefined || bUndefined) {
                                if (sortUndefined === 'first') return aUndefined ? -1 : 1;
                                if (sortUndefined === 'last') return aUndefined ? 1 : -1;
                                sortInt = aUndefined && bUndefined ? 0 : aUndefined ? sortUndefined : -sortUndefined;
                            }
                        }
                        if (sortInt === 0) sortInt = columnInfo.sortingFn(rowA, rowB, sortEntry.id);
                        // If sorting is non-zero, take care of desc and inversion
                        if (sortInt !== 0) {
                            if (isDesc) sortInt *= -1;
                            if (columnInfo.invertSorting) sortInt *= -1;
                            return sortInt;
                        }
                    }
                    return rowA.index - rowB.index;
                });
                // If there are sub-rows, sort them
                sortedData.forEach((row)=>{
                    var _row$subRows;
                    sortedFlatRows.push(row);
                    if ((_row$subRows = row.subRows) != null && _row$subRows.length) row.subRows = sortData(row.subRows);
                });
                return sortedData;
            };
            return {
                rows: sortData(rowModel.rows),
                flatRows: sortedFlatRows,
                rowsById: rowModel.rowsById
            };
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', 'getSortedRowModel', ()=>table._autoResetPageIndex()));
}

});


parcelRegister("1qQas", function(module, exports) {
$parcel$export(module.exports, "Inline", () => $10b0af967ce59e29$export$fbae5b5ffd8af05e);

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $gDiFE = parcelRequire("gDiFE");

var $2kuK2 = parcelRequire("2kuK2");
var $10b0af967ce59e29$var$flexGrowMap = {
    hug: (0, $gDiFE.xcss)({
        flexGrow: 0
    }),
    fill: (0, $gDiFE.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
var $10b0af967ce59e29$var$separatorStyles = (0, $74Zh5.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $10b0af967ce59e29$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $74Zh5.jsx)("span", {
        css: $10b0af967ce59e29$var$separatorStyles
    }, children);
};
var $10b0af967ce59e29$export$fbae5b5ffd8af05e = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, id = _ref2.id, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $74Zh5.jsx)($10b0af967ce59e29$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $5FkrB.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $74Zh5.jsx)((0, $5FkrB.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $10b0af967ce59e29$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $74Zh5.jsx)((0, $2kuK2.Flex), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$10b0af967ce59e29$export$fbae5b5ffd8af05e.displayName = 'Inline';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$10b0af967ce59e29$export$2e2bcd8739ae039 = $10b0af967ce59e29$export$fbae5b5ffd8af05e;

});

parcelRegister("cYEG6", function(module, exports) {
$parcel$export(module.exports, "useInfiniteScroll", () => $972aa47356a2f862$export$a973cef5093a8d22);

var $5FkrB = parcelRequire("5FkrB");
function $972aa47356a2f862$export$a973cef5093a8d22(_ref) {
    var onScrollTo = _ref.onScrollTo;
    var loadMoreRef = (0, $5FkrB.useRef)(null);
    // This function is called by the IntersectionObserver API when "loaderTarget" UI element
    // changes visibility.  If it has become visible (typically by user scrolling), call our
    // scroll handler and the parent will attempt to load more data
    var fetchMoreCallback = (0, $5FkrB.useCallback)(function(loadMoreEntry) {
        // Sometimes based on an unknown render race condition, the previous IntersectionObserver is not
        // properly cleared before the next one is observed, which causes the 0th indexed IntersectionObserver
        // to never be intersecting, which causes the onScrollTo callback to not be called when it should be.
        // To fix this just get rid of the old observer if it is not properly cleaned up.
        if (loadMoreEntry.length > 1) loadMoreEntry.shift();
        if (loadMoreEntry !== null && loadMoreEntry !== void 0 && loadMoreEntry[0].isIntersecting) onScrollTo();
    }, [
        onScrollTo
    ]);
    (0, $5FkrB.useEffect)(function() {
        var intersectionObserver = new IntersectionObserver(fetchMoreCallback);
        var loadMoreRefCurrent = loadMoreRef.current;
        if (loadMoreRef.current) intersectionObserver.observe(loadMoreRef.current);
        return function() {
            if (loadMoreRefCurrent) intersectionObserver.unobserve(loadMoreRefCurrent);
            intersectionObserver.disconnect();
        };
    }, [
        loadMoreRef,
        fetchMoreCallback
    ]);
    return loadMoreRef;
}

});

parcelRegister("hZrFa", function(module, exports) {
$parcel$export(module.exports, "useKeyboardNavigation", () => $d18d9776d06d6aa4$export$4da28cf324280418);
/**
 * Allows for tables to use keyboard arrow
 * keys (up, down, left, right) to navigate the table.
 *
 * The hook also includes meta + c to copy the content. Since the
 * table is not ADF, this only copies text content and not the
 * full experience like images / status lozenge.
 */ var $d18d9776d06d6aa4$export$4da28cf324280418 = function useKeyboardNavigation() {
    var tableNavigationControllers = function tableNavigationControllers(event) {
        var key = event.key;
        var target = event.currentTarget;
        if (key === 'ArrowDown' || key === 'ArrowUp' || key === 'ArrowLeft' || key === 'ArrowRight' || key === 'Enter' || key === 'c' && event.metaKey) event.preventDefault();
        else return;
        if (key === 'Enter') {
            var focusableSelector = 'a[href], input, select, textarea, button, [tabindex]:not([tabindex="-1"])';
            var focusableChild = target.querySelector(focusableSelector);
            if (focusableChild) {
                focusableChild.click();
                // For editable children (inputs, selects, textareas) focus moves into them
                // intentionally so the user can type — leave focus alone.
                // For buttons, clicking triggers the action; focus the button itself so the
                // user gets proper keyboard feedback without breaking subsequent navigation.
                // For links and other focusable elements, re-focus the cell so arrow-key
                // navigation continues to work.
                if (focusableChild.matches('button')) focusableChild.focus();
                else if (!focusableChild.matches('input, select, textarea')) target.focus();
            } else target.click();
            return;
        }
        var nextElement;
        switch(key){
            case 'ArrowDown':
                var _target$parentElement;
                nextElement = (_target$parentElement = target.parentElement) === null || _target$parentElement === void 0 || (_target$parentElement = _target$parentElement.nextElementSibling) === null || _target$parentElement === void 0 ? void 0 : _target$parentElement.children[target.cellIndex];
                break;
            case 'ArrowUp':
                var _target$parentElement2;
                nextElement = (_target$parentElement2 = target.parentElement) === null || _target$parentElement2 === void 0 || (_target$parentElement2 = _target$parentElement2.previousElementSibling) === null || _target$parentElement2 === void 0 ? void 0 : _target$parentElement2.children[target.cellIndex];
                break;
            case 'ArrowLeft':
                nextElement = target.previousElementSibling;
                break;
            case 'ArrowRight':
                nextElement = target.nextElementSibling;
                break;
            case 'c':
                if (event.metaKey) target.textContent && navigator.clipboard.writeText(target.textContent);
                break;
        }
        if (nextElement instanceof HTMLElement) {
            nextElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
            // Focus interactive children directly so the user can interact
            // immediately (e.g. type in an input, activate a button).
            // Arrow-key events from focused children still bubble up to the <td>
            // where onKeyDown is attached, so grid navigation continues to work.
            var _focusableChild = nextElement.querySelector('input, select, textarea, button, [tabindex]:not([tabindex="-1"])');
            if (_focusableChild) _focusableChild.focus();
            else nextElement.focus();
        }
    };
    return {
        tableNavigationControllers: tableNavigationControllers
    };
};

});

parcelRegister("86aoj", function(module, exports) {
$parcel$export(module.exports, "Col", () => $5e56f1b89dbed8cd$export$963a4b2511a4b70c);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $4Pn6z = parcelRequire("4Pn6z");
var $5e56f1b89dbed8cd$var$_excluded = [
    "children"
];
var $5e56f1b89dbed8cd$export$963a4b2511a4b70c = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $5e56f1b89dbed8cd$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "col",
        ref: ref
    }, props), children);
});

});

parcelRegister("aQxuW", function(module, exports) {
$parcel$export(module.exports, "Colgroup", () => $7e58beb48fc933e3$export$89efc2d0ceeaa030);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $auVZV = parcelRequire("auVZV");
var $7e58beb48fc933e3$var$_excluded = [
    "children"
];
var $7e58beb48fc933e3$export$89efc2d0ceeaa030 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $7e58beb48fc933e3$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $auVZV.Box), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "colgroup",
        ref: ref
    }, props), children);
});

});

parcelRegister("cMkZu", function(module, exports) {
$parcel$export(module.exports, "ExpandIcon", () => $94da4010313f3aaa$export$fcdb0af0473ee9e4);
// TODO: Using HipChat icons as the standard icon set is missing large
// versions of `chevron-up` and `chevron-down`, despite already including
// `chevron-left-large` and `chevron-right-large`...

var $5FkrB = parcelRequire("5FkrB");

var $h19KG = parcelRequire("h19KG");

var $aMiKe = parcelRequire("aMiKe");
var $94da4010313f3aaa$export$fcdb0af0473ee9e4 = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var isExpanded = _ref.isExpanded;
    switch(isExpanded){
        case false:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aMiKe))), {
                spacing: "compact",
                label: "",
                color: "currentColor",
                size: "small"
            });
        case true:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h19KG))), {
                spacing: "compact",
                label: "",
                color: "currentColor",
                size: "small"
            });
    }
});

});

parcelRegister("f20te", function(module, exports) {
$parcel$export(module.exports, "TD", () => $af176858f7845e77$export$9cf5b401f969f5e3);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $gtBt8 = parcelRequire("gtBt8");
var $af176858f7845e77$var$_excluded = [
    "testId"
];
var $af176858f7845e77$export$9cf5b401f969f5e3 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $af176858f7845e77$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gtBt8.BaseCell), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "td",
        testId: testId
    }, props, {
        ref: ref
    }));
});

});

parcelRegister("5THOi", function(module, exports) {
$parcel$export(module.exports, "TR", () => $44b4129522b3eb56$export$5582bd7183a5e873);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $4Pn6z = parcelRequire("4Pn6z");
var $44b4129522b3eb56$var$_excluded = [
    "isSelected"
];
var $44b4129522b3eb56$export$5582bd7183a5e873 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var isSelected = _ref.isSelected, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $44b4129522b3eb56$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "tr",
        tabIndex: -1,
        "aria-selected": isSelected,
        ref: ref
    }, props));
});

});

parcelRegister("iRBPG", function(module, exports) {
$parcel$export(module.exports, "CharlieTableHeader", () => $dbba8600637d245b$export$dfa60aeb2051f459);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $kGO2D = parcelRequire("kGO2D");

var $jgNUw = parcelRequire("jgNUw");

var $lvjuN = parcelRequire("lvjuN");

var $6fVzT = parcelRequire("6fVzT");

var $4Pn6z = parcelRequire("4Pn6z");
var $2kuK2 = parcelRequire("2kuK2");
var $1qQas = parcelRequire("1qQas");
var $gDiFE = parcelRequire("gDiFE");

var $4mzlU = parcelRequire("4mzlU");

var $cAEge = parcelRequire("cAEge");

var $4oEEp = parcelRequire("4oEEp");

var $d90PQ = parcelRequire("d90PQ");
var $dbba8600637d245b$var$_excluded = [
    "children"
];
function $dbba8600637d245b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dbba8600637d245b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dbba8600637d245b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dbba8600637d245b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dbba8600637d245b$var$HeaderDescriptionStyles = (0, $gDiFE.xcss)({
    background: "var(--ds-surface-overlay, #FFFFFF)",
    boxSizing: 'content-box',
    maxHeight: '500px',
    maxWidth: '300px',
    //TODO: move this to the children of the tooltip, not as styling for the tooltip
    //@ts-expect-error styling is applying but property does not exist for SafeCSSObject
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles
    ul: {
        paddingLeft: "var(--ds-space-250, 20px)"
    },
    boxShadow: 'elevation.shadow.overlay',
    color: 'color.text',
    padding: 'space.300',
    borderRadius: 'radius.xsmall',
    margin: 'space.050'
});
var $dbba8600637d245b$var$checkboxWrapperStyle = (0, $gDiFE.xcss)({
    paddingInlineStart: 'space.100'
});
var $dbba8600637d245b$var$NotReorderingPaddingStyle = (0, $gDiFE.xcss)({
    paddingInlineStart: 'space.100',
    alignItems: 'center'
});
var $dbba8600637d245b$var$overflowInlineStyle = (0, $gDiFE.xcss)({
    overflow: 'hidden',
    alignItems: 'center'
});
var $dbba8600637d245b$var$ButtonFontStyles = (0, $gDiFE.xcss)({
    overflow: 'hidden',
    flex: 1,
    textOverflow: 'ellipsis',
    color: 'color.text.subtlest',
    textAlign: 'left',
    fontWeight: 'font.weight.bold'
});
var $dbba8600637d245b$var$ButtonFontCurrentSortStyles = (0, $gDiFE.xcss)({
    color: 'color.text.brand'
});
var $dbba8600637d245b$var$SortButtonStyle = (0, $74Zh5.css)({
    width: 'fit-content',
    paddingInline: "var(--ds-space-050, 4px)",
    height: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    fill: "var(--ds-text-subtlest, #6B6E76)".concat(" !important")
});
var $dbba8600637d245b$var$SortButtonCurrentSortStyle = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    fill: "var(--ds-text-brand, #1868DB)".concat(" !important"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles
    '.sortable-icon': {
        opacity: 1,
        transitionDelay: '150ms'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles
    'svg, path, g': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        fill: "var(--ds-text-brand, #1868DB)".concat(" !important")
    }
});
var $dbba8600637d245b$var$DragHandlerIconContainerStyle = (0, $gDiFE.xcss)({
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: 'size.100'
});

var $dbba8600637d245b$export$dfa60aeb2051f459 = function CharlieTableHeader(_ref) {
    var _charlieTableColumn$c, _charlieTableColumn$c2;
    var labels = _ref.labels, tableType = _ref.tableType, charlieTableColumn = _ref.charlieTableColumn, charlieTableState = _ref.charlieTableState, index = _ref.index, _ref$enableResizing = _ref.enableResizing, enableResizing = _ref$enableResizing === void 0 ? false : _ref$enableResizing, enableColumnReorder = _ref.enableColumnReorder, enableRowSelection = _ref.enableRowSelection, hasWidths = _ref.hasWidths, customXcss = _ref.xcss, analyticsContext = _ref.analyticsContext, interactionName = _ref.interactionName;
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(false), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState, 2), showIcons = _React$useState2[0], setShowIcons = _React$useState2[1];
    var PragmaticHeadCellLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).lazy(function() {
        return (parcelRequire("ltx6p")).then(function(module) {
            return {
                default: module.PragmaticHeadCell
            };
        });
    });
    var Header = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        if (enableResizing || enableColumnReorder) return function(props) {
            return (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Suspense, {
                fallback: (0, $74Zh5.jsx)((0, $4oEEp.HeadCell), props)
            }, (0, $74Zh5.jsx)(PragmaticHeadCellLazy, props));
        };
        else return 0, $4oEEp.HeadCell;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enableResizing,
        enableColumnReorder
    ]);
    if (enableRowSelection && index === 0) return (0, $74Zh5.jsx)((0, $4oEEp.HeadCell), {
        tableType: tableType,
        xcss: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $gDiFE.xcss)({
                // @ts-expect-error-next-line - none of the zIndex ADS tokens equate to 1
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                zIndex: charlieTableColumn.column.getIsPinned() ? 3 : undefined,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                left: "var(--col-".concat(charlieTableColumn.id, "-left)"),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                right: "var(--col-".concat(charlieTableColumn.id, "-right)"),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                position: charlieTableColumn.column.getIsPinned() ? 'sticky' : 'relative',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                paddingInlineStart: 'space.100'
            }),
            customXcss
        ],
        width: hasWidths ? "".concat(charlieTableColumn.getSize(), "px") : undefined,
        key: charlieTableColumn.id
    }, (0, $74Zh5.jsx)((0, $4Pn6z.Box), {
        xcss: $dbba8600637d245b$var$checkboxWrapperStyle
    }, (0, $74Zh5.jsx)((0, $lvjuN.Checkbox), {
        analyticsContext: $dbba8600637d245b$var$_objectSpread({
            componentName: 'charlieTableSortColumnButton'
        }, analyticsContext),
        "aria-label": labels === null || labels === void 0 ? void 0 : labels.selectAllRows,
        isIndeterminate: charlieTableState.getIsSomeRowsSelected(),
        isChecked: charlieTableState.getIsAllRowsSelected(),
        onClick: function onClick() {
            return charlieTableState.toggleAllRowsSelected();
        }
    })));
    var sortDirection = charlieTableColumn.column.getIsSorted();
    return (0, $74Zh5.jsx)(Header, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        tableType: tableType,
        xcss: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $gDiFE.xcss)($dbba8600637d245b$var$_objectSpread({
                // @ts-expect-error-next-line - none of the zIndex ADS tokens equate to 1
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                zIndex: charlieTableColumn.column.getIsPinned() ? 3 : undefined,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                left: "var(--col-".concat(charlieTableColumn.id, "-left)"),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                right: "var(--col-".concat(charlieTableColumn.id, "-right)"),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                position: charlieTableColumn.column.getIsPinned() ? 'sticky' : 'relative'
            }, enableColumnReorder ? {
                paddingInlineStart: 'space.0',
                cursor: 'grab'
            } : {
                //overriding dom default of space.0 for first-of-type
                ':first-of-type': {
                    paddingInlineStart: 'space.100'
                }
            })),
            customXcss
        ],
        onWidthChange: function onWidthChange(width) {
            charlieTableState.setColumnSizing(function(old) {
                return $dbba8600637d245b$var$_objectSpread($dbba8600637d245b$var$_objectSpread({}, old), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, charlieTableColumn.id, width));
            });
        }
    }, sortDirection && {
        sortDirection: sortDirection === 'asc' ? 'ascending' : 'descending'
    }, {
        enableColumnReorder: enableColumnReorder,
        enableResizing: enableResizing,
        width: hasWidths ? "".concat(charlieTableColumn.getSize(), "px") : undefined,
        key: charlieTableColumn.id,
        id: charlieTableColumn.id,
        onMouseEnter: function onMouseEnter() {
            return setShowIcons(true);
        },
        onMouseLeave: function onMouseLeave() {
            return setShowIcons(false);
        }
    }), (0, $74Zh5.jsx)((0, $4mzlU.default), {
        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(props, ref) {
            var children = props.children, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $dbba8600637d245b$var$_excluded);
            if (ref == null) return null;
            return (0, $74Zh5.jsx)((0, $cAEge.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
                ref: ref
            }), (0, $74Zh5.jsx)((0, $4Pn6z.Box), {
                xcss: $dbba8600637d245b$var$HeaderDescriptionStyles
            }, children));
        }),
        content: ((_charlieTableColumn$c = charlieTableColumn.column.columnDef.meta) === null || _charlieTableColumn$c === void 0 ? void 0 : _charlieTableColumn$c.description) && (0, $74Zh5.jsx)((0, $4Pn6z.Box), null, (0, $74Zh5.jsx)("b", null, (0, $kGO2D.flexRender)(charlieTableColumn.column.columnDef.header, charlieTableColumn.getContext())), (_charlieTableColumn$c2 = charlieTableColumn.column.columnDef.meta) === null || _charlieTableColumn$c2 === void 0 ? void 0 : _charlieTableColumn$c2.description),
        position: "bottom"
    }, function(tooltipProps) {
        var _charlieTableColumn$c3, _charlieTableColumn$c4, _charlieTableColumn$c5;
        return charlieTableColumn.column.getCanSort() ? (0, $74Zh5.jsx)((0, $4Pn6z.Box), tooltipProps, (0, $74Zh5.jsx)((0, $1qQas.Inline), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            xcss: enableColumnReorder ? $dbba8600637d245b$var$overflowInlineStyle : $dbba8600637d245b$var$NotReorderingPaddingStyle,
            spread: "space-between"
        }, tooltipProps), (0, $74Zh5.jsx)((0, $1qQas.Inline), {
            xcss: $dbba8600637d245b$var$overflowInlineStyle
        }, enableColumnReorder && (0, $74Zh5.jsx)((0, $2kuK2.Flex), {
            xcss: $dbba8600637d245b$var$DragHandlerIconContainerStyle
        }, showIcons && (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6fVzT))), {
            label: "Drag list item",
            color: "var(--ds-icon, #292A2E)",
            size: "small"
        })), (0, $74Zh5.jsx)((0, $4Pn6z.Box), {
            xcss: [
                $dbba8600637d245b$var$ButtonFontStyles,
                sortDirection && $dbba8600637d245b$var$ButtonFontCurrentSortStyles
            ]
        }, (0, $kGO2D.flexRender)(charlieTableColumn.column.columnDef.header, charlieTableColumn.getContext()))), (0, $74Zh5.jsx)((0, $jgNUw.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            testId: "".concat(charlieTableColumn.id, "-sort-button"),
            spacing: "none",
            appearance: "subtle"
        }, tooltipProps, {
            onClick: function onClick() {
                return charlieTableColumn.column.toggleSorting();
            },
            "aria-label": "".concat(charlieTableColumn.id, " column sort button"),
            interactionName: interactionName,
            analyticsContext: $dbba8600637d245b$var$_objectSpread({
                componentName: 'charlieTableSortColumnButton'
            }, analyticsContext),
            css: [
                $dbba8600637d245b$var$SortButtonStyle,
                sortDirection && $dbba8600637d245b$var$SortButtonCurrentSortStyle
            ]
        }), (0, $74Zh5.jsx)((0, $2kuK2.Flex), {
            xcss: $dbba8600637d245b$var$DragHandlerIconContainerStyle
        }, (_charlieTableColumn$c3 = charlieTableColumn.column.columnDef.meta) !== null && _charlieTableColumn$c3 !== void 0 && _charlieTableColumn$c3.sortDescription ? (0, $74Zh5.jsx)((0, $4mzlU.default), {
            testId: "sort-tooltip",
            content: "".concat(sortDirection === 'asc' ? (_charlieTableColumn$c4 = charlieTableColumn.column.columnDef.meta) === null || _charlieTableColumn$c4 === void 0 ? void 0 : _charlieTableColumn$c4.sortDescription.asc : (_charlieTableColumn$c5 = charlieTableColumn.column.columnDef.meta) === null || _charlieTableColumn$c5 === void 0 ? void 0 : _charlieTableColumn$c5.sortDescription.desc)
        }, (showIcons || sortDirection) && (0, $74Zh5.jsx)((0, $d90PQ.SortIcon), {
            sortDirection: sortDirection !== null && sortDirection !== void 0 ? sortDirection : 'asc',
            isCurrentSort: sortDirection ? true : false
        })) : (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, (showIcons || sortDirection) && (0, $74Zh5.jsx)((0, $d90PQ.SortIcon), {
            sortDirection: sortDirection !== null && sortDirection !== void 0 ? sortDirection : 'asc',
            isCurrentSort: sortDirection ? true : false
        })))))) : (0, $74Zh5.jsx)((0, $4Pn6z.Box), tooltipProps, (0, $74Zh5.jsx)((0, $1qQas.Inline), {
            xcss: enableColumnReorder ? $dbba8600637d245b$var$overflowInlineStyle : $dbba8600637d245b$var$NotReorderingPaddingStyle
        }, enableColumnReorder && (0, $74Zh5.jsx)((0, $2kuK2.Flex), {
            xcss: $dbba8600637d245b$var$DragHandlerIconContainerStyle
        }, showIcons && (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6fVzT))), {
            label: "Drag list item",
            color: "var(--ds-icon, #292A2E)",
            size: "small"
        })), (0, $74Zh5.jsx)((0, $4Pn6z.Box), {
            xcss: $dbba8600637d245b$var$ButtonFontStyles
        }, (0, $kGO2D.flexRender)(charlieTableColumn.column.columnDef.header, charlieTableColumn.getContext()))));
    }));
};

});
parcelRegister("6fVzT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8da0453588db1ecd928d81f929e2bf9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $48e0ce91f12f5575$var$_react = $48e0ce91f12f5575$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $48e0ce91f12f5575$var$_iconNew = $48e0ce91f12f5575$var$_interopRequireDefault((parcelRequire("gDzom")));
function $48e0ce91f12f5575$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DragHandleVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/drag-handle-vertical
 * Usage guidance:
 * Reserved for dragging elements along a vertical axis.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $48e0ce91f12f5575$var$DragHandleVerticalIcon = (props)=>/*#__PURE__*/ $48e0ce91f12f5575$var$_react.default.createElement($48e0ce91f12f5575$var$_iconNew.default, Object.assign({
        name: "DragHandleVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 8a1.75 1.75 0 1 1-3.5 0A1.75 1.75 0 0 1 7 8m5.5 0A1.75 1.75 0 1 1 9 8a1.75 1.75 0 0 1 3.5 0M7 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/>`
    }, props));
$48e0ce91f12f5575$var$DragHandleVerticalIcon.displayName = 'DragHandleVerticalIcon';
var $48e0ce91f12f5575$var$_default = module.exports.default = $48e0ce91f12f5575$var$DragHandleVerticalIcon;

});

parcelRegister("d90PQ", function(module, exports) {
$parcel$export(module.exports, "SortIcon", () => $991cc3793dda819b$export$72820c4f313d7b94);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $fbxAc = parcelRequire("fbxAc");

var $32mZT = parcelRequire("32mZT");
var $991cc3793dda819b$var$styles = (0, $74Zh5.css)({
    display: 'flex',
    alignSelf: 'center',
    opacity: 1,
    transition: 'opacity 100ms ease-in-out'
});
var $991cc3793dda819b$var$SortableIconClassName = 'sortable-icon';
var $991cc3793dda819b$export$72820c4f313d7b94 = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var sortDirection = _ref.sortDirection, isCurrentSort = _ref.isCurrentSort;
    var primaryColor = isCurrentSort ? "var(--ds-icon-brand, #1868DB)" : "var(--ds-text-disabled, #080F214A)";
    var showSortUp = !isCurrentSort || isCurrentSort && sortDirection === 'asc';
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    (0, $74Zh5.jsx)("span", {
        css: $991cc3793dda819b$var$styles,
        className: $991cc3793dda819b$var$SortableIconClassName
    }, showSortUp ? (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($32mZT))), {
        label: "ascending",
        color: primaryColor,
        spacing: "compact",
        size: "small"
    }) : (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fbxAc))), {
        label: "descending",
        color: primaryColor,
        spacing: "compact",
        size: "small"
    })));
});

});
parcelRegister("fbxAc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a417dd35c32223c531e68a3b3a9c2a91>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0e1eef7130b05c4$var$_react = $b0e1eef7130b05c4$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $b0e1eef7130b05c4$var$_iconNew = $b0e1eef7130b05c4$var$_interopRequireDefault((parcelRequire("gDzom")));
function $b0e1eef7130b05c4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/arrow-down
 * Usage guidance:
 * Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0e1eef7130b05c4$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $b0e1eef7130b05c4$var$_react.default.createElement($b0e1eef7130b05c4$var$_iconNew.default, Object.assign({
        name: "ArrowDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$b0e1eef7130b05c4$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $b0e1eef7130b05c4$var$_default = module.exports.default = $b0e1eef7130b05c4$var$ArrowDownIcon;

});

parcelRegister("32mZT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::674db590f296a2f756724d798fd052ed>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $236365c1d44ac31a$var$_react = $236365c1d44ac31a$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $236365c1d44ac31a$var$_iconNew = $236365c1d44ac31a$var$_interopRequireDefault((parcelRequire("gDzom")));
function $236365c1d44ac31a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/arrow-up
 * Usage guidance:
 * Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $236365c1d44ac31a$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $236365c1d44ac31a$var$_react.default.createElement($236365c1d44ac31a$var$_iconNew.default, Object.assign({
        name: "ArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$236365c1d44ac31a$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $236365c1d44ac31a$var$_default = module.exports.default = $236365c1d44ac31a$var$ArrowUpIcon;

});


parcelRegister("ltx6p", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("4xOaE"),
    $iKwew("abGR0")
]).then(()=>parcelRequire('jG848'));

});


parcelRegister("cvf3Z", function(module, exports) {
$parcel$export(module.exports, "TBody", () => $91a4108fe41094fe$export$7005b8a93a167348);
/* body.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");


var $5FkrB = parcelRequire("5FkrB");

var $hRJ5R = parcelRequire("hRJ5R");

var $ioSmZ = parcelRequire("ioSmZ");
var $91a4108fe41094fe$var$_excluded = [
    "children",
    "xcss"
];
var $91a4108fe41094fe$var$bodyStyles = {
    root: "_19itglyw _kqswh2mm"
};
var $91a4108fe41094fe$export$7005b8a93a167348 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(_ref, ref) {
    var children = _ref.children, customXcss = _ref.xcss, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $91a4108fe41094fe$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ioSmZ.TBody), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        xcss: (0, $hRJ5R.cx)($91a4108fe41094fe$var$bodyStyles.root, customXcss),
        ref: ref
    }, props), children);
});

});
parcelRegister("ioSmZ", function(module, exports) {
$parcel$export(module.exports, "TBody", () => $d654a495d42662e1$export$7005b8a93a167348);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $auVZV = parcelRequire("auVZV");
var $d654a495d42662e1$var$_excluded = [
    "children"
];
var $d654a495d42662e1$export$7005b8a93a167348 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $d654a495d42662e1$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $auVZV.Box), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "tbody"
    }, props, {
        ref: ref
    }), children);
});

});


parcelRegister("bF0W9", function(module, exports) {
$parcel$export(module.exports, "Row", () => $87d440196703d7b8$export$b59bdbef9ce70de2);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $gDiFE = parcelRequire("gDiFE");

var $5THOi = parcelRequire("5THOi");
var $87d440196703d7b8$var$_excluded = [
    "children",
    "testId",
    "spacing",
    "xcss",
    "isSelected"
];
var $87d440196703d7b8$var$bodyRowStyles = (0, $gDiFE.xcss)({
    height: '44px',
    ':hover': {
        backgroundColor: 'elevation.surface.raised.hovered'
    },
    ':focus-visible::after': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        boxShadow: undefined
    },
    position: 'relative',
    border: 'none',
    borderImageWidth: 0,
    borderSpacing: 0,
    backgroundColor: 'elevation.surface'
});
var $87d440196703d7b8$var$compactRow = (0, $gDiFE.xcss)({
    height: '36px' //replace with size tokens when released
});
var $87d440196703d7b8$export$b59bdbef9ce70de2 = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, spacing = _ref.spacing, customXcss = _ref.xcss, isSelected = _ref.isSelected, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $87d440196703d7b8$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5THOi.TR), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: ref,
        isSelected: isSelected,
        testId: testId,
        xcss: [
            $87d440196703d7b8$var$bodyRowStyles,
            spacing === 'compact' && $87d440196703d7b8$var$compactRow,
            customXcss
        ]
    }, props), children);
}));

});

parcelRegister("a36et", function(module, exports) {
$parcel$export(module.exports, "RowCell", () => $750f04d256cf0537$export$502da2b9cfd708e5);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $gDiFE = parcelRequire("gDiFE");

var $f20te = parcelRequire("f20te");

var $9TAkY = parcelRequire("9TAkY");
var $750f04d256cf0537$var$_excluded = [
    "children",
    "testId",
    "xcss",
    "tableType"
];
var $750f04d256cf0537$var$InputCellStyle = (0, $gDiFE.xcss)({
    borderInlineEndWidth: 'border.width',
    borderInlineEndStyle: 'solid',
    borderColor: 'color.border'
});
var $750f04d256cf0537$var$InventoryCellStyle = (0, $gDiFE.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        borderInlineEndWidth: 'border.width',
        borderInlineEndStyle: 'solid',
        borderColor: 'color.border'
    }
});
var $750f04d256cf0537$var$RowCellStyle = (0, $gDiFE.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':first-of-type': {
        paddingInlineStart: 'space.200',
        borderInlineStartWidth: 'border.width',
        borderInlineStartStyle: 'solid',
        borderColor: 'color.border',
        paddingBlock: 'space.0'
    },
    paddingInlineStart: 'space.200',
    borderBlockEndWidth: 'border.width',
    borderBlockEndStyle: 'solid',
    paddingBlock: 'space.0',
    borderColor: 'color.border',
    whiteSpace: 'nowrap',
    background: 'inherit'
});
var $750f04d256cf0537$export$502da2b9cfd708e5 = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, customXcss = _ref.xcss, _ref$tableType = _ref.tableType, tableType = _ref$tableType === void 0 ? (0, $9TAkY.TableType).input : _ref$tableType, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $750f04d256cf0537$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f20te.TD), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        testId: testId,
        xcss: [
            $750f04d256cf0537$var$RowCellStyle,
            tableType === (0, $9TAkY.TableType).inventory && $750f04d256cf0537$var$InventoryCellStyle,
            tableType === (0, $9TAkY.TableType).input && $750f04d256cf0537$var$InputCellStyle,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- this is inline with what atlaskit primitives do.
            customXcss
        ],
        ref: ref
    }, props), children);
}));

});

parcelRegister("iQ45V", function(module, exports) {
$parcel$export(module.exports, "Table", () => $db7042690b9df762$export$54ec01a60f47d33d);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $ifySV = parcelRequire("ifySV");
var $db7042690b9df762$var$_excluded = [
    "children",
    "testId",
    "xcss"
];
var $db7042690b9df762$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, customXcss = _ref.xcss, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $db7042690b9df762$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ifySV.Table), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        testId: testId,
        xcss: customXcss,
        ref: ref
    }, props), children);
});

});
parcelRegister("ifySV", function(module, exports) {
$parcel$export(module.exports, "Table", () => $d494b022b6210e7c$export$54ec01a60f47d33d);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $4Pn6z = parcelRequire("4Pn6z");
var $d494b022b6210e7c$var$_excluded = [
    "children",
    "testId"
];
var $d494b022b6210e7c$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $d494b022b6210e7c$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "table",
        testId: testId,
        ref: ref
    }, props), children);
});

});


parcelRegister("eYe65", function(module, exports) {
$parcel$export(module.exports, "THead", () => $ae619ab5cc17c151$export$c4c2bc57f2e82919);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $gDiFE = parcelRequire("gDiFE");

var $35qld = parcelRequire("35qld");
var $ae619ab5cc17c151$var$_excluded = [
    "children",
    "xcss"
];
var $ae619ab5cc17c151$var$THeadBaseStyles = (0, $gDiFE.xcss)({
    position: 'sticky',
    //@ts-expect-error suggested options do not have value equivalent to 2
    zIndex: 2,
    inset: 'space.0',
    border: 'none',
    backgroundColor: 'color.background.input.hovered',
    borderTopLeftRadius: 'radius.large',
    borderTopRightRadius: 'radius.large',
    overflow: 'hidden',
    '::before': {
        content: '""',
        position: 'absolute',
        top: 'space.0',
        left: 'space.0',
        backgroundColor: 'color.background.neutral'
    }
});
var $ae619ab5cc17c151$export$c4c2bc57f2e82919 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, customXcss = _ref.xcss, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $ae619ab5cc17c151$var$_excluded);
    return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- this is inline with what atlaskit primitives do.
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $35qld.THead), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        xcss: [
            $ae619ab5cc17c151$var$THeadBaseStyles,
            customXcss
        ],
        ref: ref
    }, props), children));
});

});
parcelRegister("35qld", function(module, exports) {
$parcel$export(module.exports, "THead", () => $23f645897ffb54bf$export$c4c2bc57f2e82919);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $4Pn6z = parcelRequire("4Pn6z");
var $23f645897ffb54bf$var$_excluded = [
    "children"
];
var $23f645897ffb54bf$export$c4c2bc57f2e82919 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $23f645897ffb54bf$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "thead"
    }, props, {
        ref: ref
    }), children);
});

});


parcelRegister("4Aklk", function(module, exports) {
$parcel$export(module.exports, "useConvertCharlieTableToTanStack", () => $356a4de9cad863bf$export$c430cf84aab272ac);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $e6OxX = parcelRequire("e6OxX");

var $ekACv = parcelRequire("ekACv");
function $356a4de9cad863bf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $356a4de9cad863bf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $356a4de9cad863bf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $356a4de9cad863bf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $356a4de9cad863bf$export$c430cf84aab272ac = function useConvertCharlieTableToTanStack(options) {
    var _options$initialState, _options$initialState2, _options$initialState3, _options$initialState4, _options$initialState5, _options$initialState6, _options$initialState7, _options$initialState8, _options$initialState9, _options$initialState0, _options$initialState1, _options$initialState10, _options$initialState11, _options$initialState12, _options$initialState13, _options$initialState14, _options$state2, _options$state3, _options$state$column, _options$state5, _options$state6, _options$state7, _options$state8, _options$state9, _options$state0, _options$state1, _options$state10, _options$state11, _options$state12, _options$state13, _options$state14, _options$state15, _options$state16, _options$state17, _options$defaultColum, _options$defaultColum2, _options$defaultColum3, _options$enableSortin;
    var columnHelper = (0, $e6OxX.createColumnHelper)();
    var stableEmptyTanArray = (0, $5FkrB.useMemo)(function() {
        return [];
    }, []);
    var stableEmptyCharlesArray = (0, $5FkrB.useMemo)(function() {
        return [];
    }, []);
    var mapRowsToData = (0, $5FkrB.useCallback)(function(rows) {
        return rows.map(function(row) {
            return $356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread({}, row.data), {}, {
                isExpandable: row.isExpandable,
                isDefaultExpanded: row.isDefaultExpanded,
                isDisabled: row.isDisabled,
                isHidden: row.isHidden,
                groupKey: row.groupKey,
                groupValue: row.groupValue,
                overrideRender: row.overrideRender,
                subRows: row.subRows ? mapRowsToData(row.subRows) : undefined
            });
        });
    }, []);
    var mappedRowToData = (0, $5FkrB.useMemo)(function() {
        var _options$rows;
        return mapRowsToData((_options$rows = options.rows) !== null && _options$rows !== void 0 ? _options$rows : stableEmptyCharlesArray);
    }, [
        mapRowsToData,
        options.rows,
        stableEmptyCharlesArray
    ]);
    // Memoize columns
    var memoizedColumns = (0, $5FkrB.useMemo)(function() {
        var _options$columnDefs, _options$columns;
        return (_options$columnDefs = options.columnDefs) !== null && _options$columnDefs !== void 0 ? _options$columnDefs : (_options$columns = options.columns) === null || _options$columns === void 0 ? void 0 : _options$columns.map(function(oldColumn) {
            if ($356a4de9cad863bf$var$isCharlieTableColumn(oldColumn)) return columnHelper.accessor(function(row) {
                return row;
            }, {
                id: oldColumn.key,
                enableSorting: oldColumn.isSortable,
                header: function header() {
                    return oldColumn.content;
                },
                minSize: oldColumn.minWidth,
                size: oldColumn.width,
                maxSize: oldColumn.maxWidth,
                cell: function cell(props) {
                    return oldColumn.cell.render(props.getValue());
                },
                meta: {
                    description: oldColumn.description,
                    sortDescription: oldColumn.sortDescription
                }
            });
            return oldColumn;
        });
    }, [
        columnHelper,
        options.columns,
        options.columnDefs
    ]);
    var data = (0, $5FkrB.useMemo)(function() {
        var _options$data;
        return $356a4de9cad863bf$var$hasCharlieParam(options, 'rows') ? mappedRowToData : (_options$data = options.data) !== null && _options$data !== void 0 ? _options$data : stableEmptyTanArray;
    }, [
        options,
        mappedRowToData,
        stableEmptyTanArray
    ]);
    var sortingOption = $356a4de9cad863bf$var$hasTanstackParam(options, 'onSortingChange') ? {
        onSortingChange: options.onSortingChange
    } : $356a4de9cad863bf$var$hasCharlieParam(options, 'onSortChange') ? {
        onSortingChange: $356a4de9cad863bf$var$handleSortChange(options)
    } : {};
    // Convert CharlieTableHook options to TanStack TableOptions
    // @ts-expect-error have to translate between types. will be deleted
    var tanStackOptions = $356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread({}, options), {}, {
        columns: memoizedColumns !== null && memoizedColumns !== void 0 ? memoizedColumns : [],
        //move this to its own function for memo
        data: data,
        //move this to its own function for memo
        initialState: $356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread({}, ((_options$initialState = options.initialState) === null || _options$initialState === void 0 ? void 0 : _options$initialState.columnOrder) && {
            columnOrder: (_options$initialState2 = options.initialState) === null || _options$initialState2 === void 0 ? void 0 : _options$initialState2.columnOrder,
            columnVisibility: (_options$initialState3 = options.initialState.columnVisibility) !== null && _options$initialState3 !== void 0 ? _options$initialState3 : memoizedColumns === null || memoizedColumns === void 0 ? void 0 : memoizedColumns.reduce(function(acc, col) {
                if (col.id) {
                    var _options$state;
                    if ((_options$state = options.state) !== null && _options$state !== void 0 && (_options$state = _options$state.columnOrder) !== null && _options$state !== void 0 && _options$state.includes(col.id)) acc[col.id] = true; // Set all columns to visible by default
                    else acc[col.id] = false;
                }
                return acc;
            }, {})
        }), ((_options$initialState4 = options.initialState) === null || _options$initialState4 === void 0 ? void 0 : _options$initialState4.columnVisibility) && {
            columnVisibility: options.initialState.columnVisibility
        }), ((_options$initialState5 = options.initialState) === null || _options$initialState5 === void 0 ? void 0 : _options$initialState5.sorting) && {
            sorting: $356a4de9cad863bf$var$convertToSortingState((_options$initialState6 = options.initialState) === null || _options$initialState6 === void 0 ? void 0 : _options$initialState6.sorting)
        }), ((_options$initialState7 = options.initialState) === null || _options$initialState7 === void 0 ? void 0 : _options$initialState7.expanded) && {
            expanded: (_options$initialState8 = options.initialState) === null || _options$initialState8 === void 0 ? void 0 : _options$initialState8.expanded
        }), ((_options$initialState9 = options.initialState) === null || _options$initialState9 === void 0 ? void 0 : _options$initialState9.rowSelection) && {
            rowSelection: (_options$initialState0 = options.initialState) === null || _options$initialState0 === void 0 ? void 0 : _options$initialState0.rowSelection
        }), ((_options$initialState1 = options.initialState) === null || _options$initialState1 === void 0 ? void 0 : _options$initialState1.columnWidths) && {
            columnSizing: (_options$initialState10 = options.initialState) === null || _options$initialState10 === void 0 ? void 0 : _options$initialState10.columnWidths
        }), ((_options$initialState11 = options.initialState) === null || _options$initialState11 === void 0 ? void 0 : _options$initialState11.columnSizing) && {
            columnSizing: (_options$initialState12 = options.initialState) === null || _options$initialState12 === void 0 ? void 0 : _options$initialState12.columnSizing
        }), ((_options$initialState13 = options.initialState) === null || _options$initialState13 === void 0 ? void 0 : _options$initialState13.columnPinning) && {
            columnPinning: $356a4de9cad863bf$var$convertToColumnPinningState((_options$initialState14 = options.initialState) === null || _options$initialState14 === void 0 ? void 0 : _options$initialState14.columnPinning)
        }),
        state: $356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread({}, ((_options$state2 = options.state) === null || _options$state2 === void 0 ? void 0 : _options$state2.columnOrder) && {
            columnOrder: (_options$state3 = options.state) === null || _options$state3 === void 0 ? void 0 : _options$state3.columnOrder,
            columnVisibility: (_options$state$column = options.state.columnVisibility) !== null && _options$state$column !== void 0 ? _options$state$column : memoizedColumns === null || memoizedColumns === void 0 ? void 0 : memoizedColumns.reduce(function(acc, col) {
                if (col.id) {
                    var _options$state4;
                    if ((_options$state4 = options.state) !== null && _options$state4 !== void 0 && (_options$state4 = _options$state4.columnOrder) !== null && _options$state4 !== void 0 && _options$state4.includes(col.id)) acc[col.id] = true; // Set all columns to visible by default
                    else acc[col.id] = false;
                }
                return acc;
            }, {})
        }), ((_options$state5 = options.state) === null || _options$state5 === void 0 ? void 0 : _options$state5.columnVisibility) && {
            columnVisibility: options.state.columnVisibility
        }), ((_options$state6 = options.state) === null || _options$state6 === void 0 ? void 0 : _options$state6.sorting) && {
            sorting: $356a4de9cad863bf$var$convertToSortingState((_options$state7 = options.state) === null || _options$state7 === void 0 ? void 0 : _options$state7.sorting)
        }), ((_options$state8 = options.state) === null || _options$state8 === void 0 ? void 0 : _options$state8.expanded) && {
            expanded: (_options$state9 = options.state) === null || _options$state9 === void 0 ? void 0 : _options$state9.expanded
        }), ((_options$state0 = options.state) === null || _options$state0 === void 0 ? void 0 : _options$state0.rowSelection) && {
            rowSelection: (_options$state1 = options.state) === null || _options$state1 === void 0 ? void 0 : _options$state1.rowSelection
        }), ((_options$state10 = options.state) === null || _options$state10 === void 0 ? void 0 : _options$state10.columnWidths) && {
            columnSizing: (_options$state11 = options.state) === null || _options$state11 === void 0 ? void 0 : _options$state11.columnWidths
        }), ((_options$state12 = options.state) === null || _options$state12 === void 0 ? void 0 : _options$state12.columnSizing) && {
            columnSizing: (_options$state13 = options.state) === null || _options$state13 === void 0 ? void 0 : _options$state13.columnSizing
        }), ((_options$state14 = options.state) === null || _options$state14 === void 0 ? void 0 : _options$state14.grouping) && {
            grouping: options.state.grouping
        }), ((_options$state15 = options.state) === null || _options$state15 === void 0 ? void 0 : _options$state15.columnPinning) && {
            columnPinning: $356a4de9cad863bf$var$convertToColumnPinningState((_options$state16 = options.state) === null || _options$state16 === void 0 ? void 0 : _options$state16.columnPinning)
        }), ((_options$state17 = options.state) === null || _options$state17 === void 0 ? void 0 : _options$state17.columnVisibility) && {
            columnVisibility: options.state.columnVisibility
        })
    }, options.onColumnOrderChange && {
        onColumnOrderChange: options.onColumnOrderChange
    }), sortingOption), $356a4de9cad863bf$var$hasCharlieParam(options, 'defaultColumnWidths') && {
        defaultColumn: {
            size: (_options$defaultColum = options.defaultColumnWidths) === null || _options$defaultColum === void 0 ? void 0 : _options$defaultColum.width,
            maxSize: (_options$defaultColum2 = options.defaultColumnWidths) === null || _options$defaultColum2 === void 0 ? void 0 : _options$defaultColum2.maxWidth,
            minSize: (_options$defaultColum3 = options.defaultColumnWidths) === null || _options$defaultColum3 === void 0 ? void 0 : _options$defaultColum3.minWidth
        }
    }), $356a4de9cad863bf$var$hasCharlieParam(options, 'onSelectionChange') && {
        onRowSelectionChange: options.onSelectionChange
    }), $356a4de9cad863bf$var$hasCharlieParam(options, 'onColumnWidthsChange') && {
        onColumnSizingChange: options.onColumnWidthsChange
    }), $356a4de9cad863bf$var$hasCharlieParam(options, 'rows') && $356a4de9cad863bf$var$hasCharlieParam(options, 'getRowId') && {
        // @ts-expect-error deleting once charliehook is deprecated
        getRowId: function getRowId(row, index) {
            return options.getRowId({
                row: {
                    data: row
                },
                index: index
            });
        }
    }), $356a4de9cad863bf$var$hasCharlieParam(options, 'rows') && {
        getSubRows: function getSubRows(row) {
            return row.subRows;
        }
    }), $356a4de9cad863bf$var$hasCharlieParam(options, 'onExpandChange') && {
        onExpandedChange: options.onExpandChange
    }), $356a4de9cad863bf$var$hasCharlieParam(options, 'rows') && {
        //@ts-expect-error deleting once charliehook is deprecated
        getRowCanExpand: function getRowCanExpand(row) {
            return row.original.isExpandable === true;
        }
    }), $356a4de9cad863bf$var$hasTanstackParam(options, 'onRowSelectionChange') && {
        onRowSelectionChange: options.onRowSelectionChange
    }), $356a4de9cad863bf$var$hasTanstackParam(options, 'onColumnSizingChange') && {
        onColumnSizingChange: options.onColumnSizingChange
    }), $356a4de9cad863bf$var$hasTanstackParam(options, 'getSubRows') && !$356a4de9cad863bf$var$hasCharlieParam(options, 'rows') && {
        getSubRows: options.getSubRows
    }), $356a4de9cad863bf$var$hasTanstackParam(options, 'defaultColumn') && {
        defaultColumn: options.defaultColumn
    }), $356a4de9cad863bf$var$hasTanstackParam(options, 'onExpandedChange') && {
        onExpandedChange: options.onExpandedChange
    }), !$356a4de9cad863bf$var$hasCharlieParam(options, 'rows') && $356a4de9cad863bf$var$hasTanstackParam(options, 'getRowId') && {
        getRowId: options.getRowId
    }), !$356a4de9cad863bf$var$hasCharlieParam(options, 'rows') && $356a4de9cad863bf$var$hasTanstackParam(options, 'getSubRows') && {
        getSubRows: options.getSubRows
    }), $356a4de9cad863bf$var$hasTanstackParam(options, 'getRowCanExpand') && {
        getRowCanExpand: options.getRowCanExpand
    }), {}, {
        enableSortingRemoval: (_options$enableSortin = options.enableSortingRemoval) !== null && _options$enableSortin !== void 0 ? _options$enableSortin : false,
        enableRowSelection: options.enableRowSelection,
        getCoreRowModel: (0, $e6OxX.getCoreRowModel)(),
        getExpandedRowModel: (0, $e6OxX.getExpandedRowModel)(),
        getGroupedRowModel: options.enableServerSideGrouping ? (0, $ekACv.manualGroupedRowModel)() : (0, $e6OxX.getGroupedRowModel)(),
        getSortedRowModel: (0, $e6OxX.getSortedRowModel)()
    });
    return tanStackOptions;
};
function $356a4de9cad863bf$var$isCharlieTableColumn(column) {
    return column && column.key != null && column.content != null && column.cell && typeof column.cell.render === 'function';
}
var $356a4de9cad863bf$var$convertToColumnPinningState = function convertToColumnPinningState(pinning) {
    if (!pinning) return {
        left: [],
        right: []
    };
    if ('start' in pinning || 'end' in pinning) {
        var _pinning$start, _pinning$end;
        return {
            left: (_pinning$start = pinning.start) !== null && _pinning$start !== void 0 ? _pinning$start : [],
            right: (_pinning$end = pinning.end) !== null && _pinning$end !== void 0 ? _pinning$end : []
        };
    }
    return pinning;
};
var $356a4de9cad863bf$var$convertToSortingState = function convertToSortingState(sorting) {
    if (Array.isArray(sorting)) return sorting;
    else if (sorting !== null && sorting !== void 0 && sorting.field) return [
        {
            id: sorting.field,
            desc: sorting.direction === 'desc'
        }
    ];
    // If sorting is undefined, return an empty array.
    return [];
};
function $356a4de9cad863bf$var$hasCharlieParam(options, parameter) {
    var isUsingCharles = parameter in options;
    return isUsingCharles;
}
function $356a4de9cad863bf$var$hasTanstackParam(options, parameter) {
    return parameter in options;
}
var $356a4de9cad863bf$var$handleSortChange = function handleSortChange(options) {
    return function(sortUpdator) {
        if ($356a4de9cad863bf$var$hasCharlieParam(options, 'onSortChange') && options.onSortChange) {
            var _options$state18;
            // Convert Tanstack sorting to original format
            var sortingValue = (0, $e6OxX.functionalUpdate)(sortUpdator, $356a4de9cad863bf$var$convertToSortingState((_options$state18 = options.state) === null || _options$state18 === void 0 ? void 0 : _options$state18.sorting));
            var convertedSort = sortingValue && sortingValue.length > 0 ? {
                field: sortingValue[0].id,
                direction: sortingValue[0].desc ? 'desc' : 'asc'
            } : undefined;
            options.onSortChange(convertedSort);
        }
        return undefined;
    };
};

});
parcelRegister("ekACv", function(module, exports) {
$parcel$export(module.exports, "manualGroupedRowModel", () => $a6ef56e94c8be78c$export$bfec7ec94303aa98);

var $e6OxX = parcelRequire("e6OxX");
function $a6ef56e94c8be78c$export$bfec7ec94303aa98() {
    return function(table) {
        return (0, $e6OxX.memo)(function() {
            return [
                table.getState().grouping,
                table.getPreGroupedRowModel()
            ];
        }, function(grouping, rowModel) {
            try {
                if (!rowModel.rows.length || !grouping.length) return rowModel;
                // Filter the grouping list down to columns that exist
                var existingGrouping = grouping.filter(function(columnId) {
                    return table.getColumn(columnId);
                });
                var groupedFlatRows = [];
                var groupedRowsById = {};
                // Recursively group the data
                var _groupUpRecursively = function groupUpRecursively(rows) {
                    var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                    var parentId = arguments.length > 2 ? arguments[2] : undefined;
                    // Grouping depth has been been met
                    // Stop grouping and simply rewrite thd depth and row relationships
                    if (depth >= existingGrouping.length) return rows.map(function(row) {
                        row.depth = depth;
                        groupedFlatRows.push(row);
                        groupedRowsById[row.id] = row;
                        if (row.subRows.length) row.subRows = _groupUpRecursively(row.subRows, depth + 1, row.id);
                        return row;
                    });
                    var columnId = existingGrouping[depth];
                    if (!columnId) throw new Error('Column not found');
                    return rows.map(function(row) {
                        var groupingValue = row.getGroupingValue(columnId);
                        var id = row.id;
                        var subRows = _groupUpRecursively(row.subRows, depth + 1, id);
                        var leafRows = depth ? (0, $e6OxX.flattenBy)(row.subRows, function(row) {
                            return row.subRows;
                        }) : row.subRows;
                        var groupedRow = (0, $e6OxX.createRow)(table, id, row.original, 0, depth, undefined, parentId);
                        return Object.assign(groupedRow, {
                            groupingColumnId: columnId,
                            groupingValue: groupingValue,
                            subRows: subRows,
                            leafRows: leafRows
                        });
                    });
                };
                var groupedRows = _groupUpRecursively(rowModel.rows, 0);
                groupedRows.forEach(function(subRow) {
                    groupedFlatRows.push(subRow);
                    groupedRowsById[subRow.id] = subRow;
                });
                return {
                    rows: groupedRows,
                    flatRows: groupedFlatRows,
                    rowsById: groupedRowsById
                };
            } catch (error) {
                return rowModel;
            }
        }, (0, $e6OxX.getMemoOptions)(table.options, 'debugTable', 'getGroupedRowModel', function() {
            table._queue(function() {
                table._autoResetExpanded();
                table._autoResetPageIndex();
            });
        }));
    };
}

});


parcelRegister("7vnkj", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("4xOaE").then(()=>parcelRequire('2NRa8'));

});



parcelRegister("eCCay", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa5238e80877390a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
var $aa5238e80877390a$var$buttonGroupStyles = (0, $74Zh5.css)({
    display: 'inline-flex',
    gap: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> *': {
        flex: '1 0 auto'
    }
});
function $aa5238e80877390a$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, testId = _ref.testId, label = _ref.label, titleId = _ref.titleId;
    return (0, $74Zh5.jsx)("div", {
        css: $aa5238e80877390a$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.toArray(children), function(child, idx) {
        if (!child) return null;
        return (0, $74Zh5.jsx)((0, $5FkrB.Fragment), {
            key: idx
        }, child);
    }));
}

});

parcelRegister("cAVP0", function(module, exports) {
$parcel$export(module.exports, "default", () => $92b5b303238413ad$export$2e2bcd8739ae039);
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $92b5b303238413ad$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("bgNpv", function(module, exports) {
$parcel$export(module.exports, "default", () => $8347842f191e39da$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $l2Z7B = parcelRequire("l2Z7B");

var $5FkrB = parcelRequire("5FkrB");

var $hrVKU = parcelRequire("hrVKU");

var $5Kjrj = parcelRequire("5Kjrj");
function $8347842f191e39da$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $l2Z7B.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $l2Z7B.__rest)(nextProps, [
        "values"
    ]);
    return (0, $5Kjrj.shallowEqual)(nextValues, values) && (0, $5Kjrj.shallowEqual)(otherProps, nextOtherProps);
}
function $8347842f191e39da$var$FormattedMessage(props) {
    var intl = (0, $hrVKU.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $5FkrB.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $5FkrB.createElement(Component, null, $5FkrB.Children.toArray(nodes));
    return $5FkrB.createElement($5FkrB.Fragment, null, nodes);
}
$8347842f191e39da$var$FormattedMessage.displayName = 'FormattedMessage';
var $8347842f191e39da$var$MemoizedFormattedMessage = $5FkrB.memo($8347842f191e39da$var$FormattedMessage, $8347842f191e39da$var$areEqual);
$8347842f191e39da$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $8347842f191e39da$export$2e2bcd8739ae039 = $8347842f191e39da$var$MemoizedFormattedMessage;

});
parcelRegister("hrVKU", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb41c259f0d2c9ae$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $ach6K = parcelRequire("ach6K");

var $5Kjrj = parcelRequire("5Kjrj");
function $cb41c259f0d2c9ae$export$2e2bcd8739ae039() {
    var intl = $5FkrB.useContext((0, $ach6K.Context));
    (0, $5Kjrj.invariantIntlContext)(intl);
    return intl;
}

});
parcelRegister("ach6K", function(module, exports) {
$parcel$export(module.exports, "Provider", () => $76c84ba0e6a0ff47$export$2881499e37b75b9a);
$parcel$export(module.exports, "Context", () => $76c84ba0e6a0ff47$export$841858b892ce1f4c);
$parcel$export(module.exports, "default", () => $76c84ba0e6a0ff47$export$2e2bcd8739ae039);

var $l2Z7B = parcelRequire("l2Z7B");

var $5FkrB = parcelRequire("5FkrB");

var $knBeW = parcelRequire("knBeW");

var $5Kjrj = parcelRequire("5Kjrj");
function $76c84ba0e6a0ff47$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// TODO: We should provide initial value here
var $76c84ba0e6a0ff47$var$IntlContext = $5FkrB.createContext(null);
var $76c84ba0e6a0ff47$var$IntlConsumer = $76c84ba0e6a0ff47$var$IntlContext.Consumer, $76c84ba0e6a0ff47$var$IntlProvider = $76c84ba0e6a0ff47$var$IntlContext.Provider;
var $76c84ba0e6a0ff47$export$2881499e37b75b9a = $76c84ba0e6a0ff47$var$IntlProvider;
var $76c84ba0e6a0ff47$export$841858b892ce1f4c = $76c84ba0e6a0ff47$var$IntlContext;
function $76c84ba0e6a0ff47$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $5FkrB.createElement($76c84ba0e6a0ff47$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $5Kjrj.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $5FkrB.createElement(WrappedComponent, (0, $l2Z7B.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($76c84ba0e6a0ff47$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($knBeW)))($5FkrB.forwardRef(function(props, ref) {
        return $5FkrB.createElement(WithIntl, (0, $l2Z7B.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($knBeW)))(WithIntl, WrappedComponent);
}

});
parcelRegister("5Kjrj", function(module, exports) {
$parcel$export(module.exports, "invariantIntlContext", () => $42f053ec1963a0e6$export$45c4bbf6e55bba1f);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $42f053ec1963a0e6$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "assignUniqueKeysToParts", () => $42f053ec1963a0e6$export$cfec03d26465fa63);
$parcel$export(module.exports, "shallowEqual", () => $42f053ec1963a0e6$export$d36bdfa510afb180);

var $l2Z7B = parcelRequire("l2Z7B");

var $5FkrB = parcelRequire("5FkrB");

var $kVTHJ = parcelRequire("kVTHJ");

var $ftB2S = parcelRequire("ftB2S");
function $42f053ec1963a0e6$export$45c4bbf6e55bba1f(intl) {
    (0, $kVTHJ.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $42f053ec1963a0e6$export$b52f8d6fc0d47415 = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, (0, $ftB2S.DEFAULT_INTL_CONFIG)), {
    textComponent: $5FkrB.Fragment
});
function $42f053ec1963a0e6$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($5FkrB.Children.toArray(parts));
    };
}
function $42f053ec1963a0e6$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("kVTHJ", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $f3d457438d3fe9d5$export$f5708dca728d7177);
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $f3d457438d3fe9d5$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $f3d457438d3fe9d5$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $f3d457438d3fe9d5$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $f3d457438d3fe9d5$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $f3d457438d3fe9d5$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $f3d457438d3fe9d5$export$3fae2929ed23c202(map, pl, field) {
    return $f3d457438d3fe9d5$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $f3d457438d3fe9d5$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $f3d457438d3fe9d5$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $f3d457438d3fe9d5$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $f3d457438d3fe9d5$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $f3d457438d3fe9d5$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}

});





parcelRegister("kzB9W", function(module, exports) {
$parcel$export(module.exports, "default", () => $efa3e699f80dfb1c$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $dUWEU = parcelRequire("dUWEU");

var $lmG37 = parcelRequire("lmG37");

var $iO8GM = parcelRequire("iO8GM");

var $eVb4V = parcelRequire("eVb4V");

var $2oF7I = parcelRequire("2oF7I");

var $h7zHk = parcelRequire("h7zHk");

var $h19KG = parcelRequire("h19KG");

var $aOu6p = parcelRequire("aOu6p");

var $50U6m = parcelRequire("50U6m");

var $dY97G = parcelRequire("dY97G");

var $64A04 = parcelRequire("64A04");

var $9t5p4 = parcelRequire("9t5p4");

var $jhEkG = parcelRequire("jhEkG");

var $aPakJ = parcelRequire("aPakJ");

var $1jaJ9 = parcelRequire("1jaJ9");

var $1ujC5 = parcelRequire("1ujC5");

var $bLniy = parcelRequire("bLniy");
var $efa3e699f80dfb1c$var$_excluded = [
    "ref",
    "aria-controls",
    "aria-expanded",
    "aria-haspopup"
];
function $efa3e699f80dfb1c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $efa3e699f80dfb1c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $efa3e699f80dfb1c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $efa3e699f80dfb1c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $efa3e699f80dfb1c$var$MAX_HEIGHT = "calc(100vh - 16px)";
var $efa3e699f80dfb1c$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
var $efa3e699f80dfb1c$var$getFallbackPlacements = function getFallbackPlacements(placement) {
    var placementPieces = placement.split('-');
    var mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        var crossAxis = placementPieces[1];
        return [
            "".concat(mainAxis),
            "".concat(mainAxis, "-").concat($efa3e699f80dfb1c$var$opposites[crossAxis]),
            "".concat($efa3e699f80dfb1c$var$opposites[mainAxis], "-").concat(crossAxis),
            "".concat($efa3e699f80dfb1c$var$opposites[mainAxis]),
            "".concat($efa3e699f80dfb1c$var$opposites[mainAxis], "-").concat($efa3e699f80dfb1c$var$opposites[crossAxis]),
            'auto'
        ];
    } else return [
        "".concat(mainAxis, "-start"),
        "".concat(mainAxis, "-end"),
        "".concat($efa3e699f80dfb1c$var$opposites[mainAxis]),
        "".concat($efa3e699f80dfb1c$var$opposites[mainAxis], "-start"),
        "".concat($efa3e699f80dfb1c$var$opposites[mainAxis], "-end"),
        "auto"
    ];
};
function $efa3e699f80dfb1c$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * Legacy Popper/Popup implementation (hooks run unconditionally when this component mounts).
 */ function $efa3e699f80dfb1c$var$DropdownMenuLegacy(_ref) {
    var _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, _ref$defaultOpen = _ref.defaultOpen, defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isOpen = _ref.isOpen, _ref$onOpenChange = _ref.onOpenChange, onOpenChange = _ref$onOpenChange === void 0 ? (0, $eVb4V.default) : _ref$onOpenChange, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, returnFocusRef = _ref.returnFocusRef, spacing = _ref.spacing, statusLabel = _ref.statusLabel, testId = _ref.testId, _trigger = _ref.trigger, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? (0, $64A04.layers).modal() : _ref$zIndex, label = _ref.label, interactionName = _ref.interactionName, strategy = _ref.strategy, menuLabel = _ref.menuLabel, _ref$shouldPreventEsc = _ref.shouldPreventEscapePropagation, shouldPreventEscapePropagation = _ref$shouldPreventEsc === void 0 ? false : _ref$shouldPreventEsc, shouldIgnoreCloseEvent = _ref.shouldIgnoreCloseEvent;
    var _useControlledState = (0, $2oF7I.default)(isOpen, function() {
        return defaultOpen;
    }), _useControlledState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useControlledState, 2), isLocalOpen = _useControlledState2[0], setLocalIsOpen = _useControlledState2[1];
    var triggerRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isTriggeredUsingKeyboard = _useState2[0], setTriggeredUsingKeyboard = _useState2[1];
    var id = (0, $bLniy.default)();
    var itemRef = (0, $1ujC5.default)();
    var _useLayering = (0, $aOu6p.useLayering)(), currentLevel = _useLayering.currentLevel;
    var fallbackPlacements = (0, $5FkrB.useMemo)(function() {
        return $efa3e699f80dfb1c$var$getFallbackPlacements(placement);
    }, [
        placement
    ]);
    var handleTriggerClicked = (0, $5FkrB.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    function(event) {
        var newValue = !isLocalOpen;
        var clientX = event.clientX, clientY = event.clientY, type = event.type, detail = event.detail;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            var _itemRef$current;
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef === null || itemRef === void 0 || (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || _itemRef$current.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    var handleOnClose = (0, $5FkrB.useCallback)(function(event, currentLevel) {
        var _event$target$closest, _event$target;
        var isTabLeftOrEscapeKey = $efa3e699f80dfb1c$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape' || event.key === (0, $lmG37.KEY_LEFT));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && $efa3e699f80dfb1c$var$isKeyboardEvent(event) && (event.key === 'Escape' || event.key === (0, $lmG37.KEY_LEFT))) event.stopPropagation();
        if (event !== null && !isTabLeftOrEscapeKey && event.target instanceof HTMLElement && (_event$target$closest = (_event$target = event.target).closest) !== null && _event$target$closest !== void 0 && _event$target$closest.call(_event$target, "[id^=".concat((0, $bLniy.PREFIX), "] [aria-haspopup]"))) {
            var _itemRef$current2;
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            var toCloseLevel = (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 ? void 0 : _itemRef$current2.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(function() {
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        else if ($efa3e699f80dfb1c$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape' || event.key === (0, $lmG37.KEY_LEFT))) requestAnimationFrame(function() {
            var _itemRef$current3;
            (_itemRef$current3 = itemRef.current) === null || _itemRef$current3 === void 0 || _itemRef$current3.focus();
        });
        else if (triggerRef.current) {
            var _event$target$closest2, _event$target2;
            // Don't focus the trigger if the click was outside of the menu
            var isClickOutsideMenu = (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLElement && ((_event$target$closest2 = (_event$target2 = event.target).closest) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.call(_event$target2, '[role="menu"]')) === null;
            var shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(function() {
                var _triggerRef$current;
                (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || _triggerRef$current.focus();
            });
        }
        var newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    var _useFocus = (0, $h7zHk.default)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $5FkrB.useEffect)(function() {
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $eVb4V.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $eVb4V.default;
        return (0, $7QpUe.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                var isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest("[id^=".concat((0, $bLniy.PREFIX), "] [aria-haspopup]"));
                if (e.key === (0, $lmG37.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $lmG37.KEY_SPACE) || e.key === (0, $lmG37.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $lmG37.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ var conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1jaJ9.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dY97G.Popup), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
        // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
        returnFocusRef === undefined,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        role: shouldRenderToParent && currentLevel > 0 ? 'group' : undefined,
        fallbackPlacements: fallbackPlacements,
        testId: testId && "".concat(testId, "--content"),
        shouldUseCaptureOnOutsideClick: true,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent
    }, conditionalProps, {
        shouldDisableFocusLock: true,
        trigger: function trigger(_ref2) {
            var ref = _ref2.ref, ariaControls = _ref2['aria-controls'], ariaExpanded = _ref2['aria-expanded'], ariaHasPopup = _ref2['aria-haspopup'], rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $efa3e699f80dfb1c$var$_excluded);
            if (typeof _trigger === 'function') return _trigger($efa3e699f80dfb1c$var$_objectSpread($efa3e699f80dfb1c$var$_objectSpread($efa3e699f80dfb1c$var$_objectSpread({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup
            }, rest), bindFocus), {}, {
                triggerRef: (0, $iO8GM.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger")
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dUWEU.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, bindFocus, {
                ref: (0, $iO8GM.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: function iconAfter(iconProps) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h19KG))), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, iconProps, {
                        size: "small"
                    }));
                },
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger"),
                "aria-label": label,
                interactionName: interactionName
            }), _trigger);
        },
        content: function content(_ref3) {
            var setInitialFocusRef = _ref3.setInitialFocusRef, update = _ref3.update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jhEkG.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aPakJ.default), {
                spacing: spacing,
                maxHeight: $efa3e699f80dfb1c$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && "".concat(testId, "--menu-wrapper"),
                menuLabel: menuLabel
            }, children));
        }
    })));
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ var $efa3e699f80dfb1c$var$DropdownMenu = function DropdownMenu(props) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, children = props.children, _props$defaultOpen = props.defaultOpen, defaultOpen = _props$defaultOpen === void 0 ? false : _props$defaultOpen, _props$isLoading = props.isLoading, isLoading = _props$isLoading === void 0 ? false : _props$isLoading, isOpen = props.isOpen, _props$onOpenChange = props.onOpenChange, onOpenChange = _props$onOpenChange === void 0 ? (0, $eVb4V.default) : _props$onOpenChange, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottom-start' : _props$placement, _props$shouldFitConta = props.shouldFitContainer, shouldFitContainer = _props$shouldFitConta === void 0 ? false : _props$shouldFitConta, returnFocusRef = props.returnFocusRef, spacing = props.spacing, statusLabel = props.statusLabel, testId = props.testId, trigger = props.trigger, label = props.label, interactionName = props.interactionName, menuLabel = props.menuLabel;
    if ((0, $50U6m.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9t5p4.default), {
        autoFocus: autoFocus,
        children: children,
        defaultOpen: defaultOpen,
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        placement: placement,
        shouldFitContainer: shouldFitContainer,
        returnFocusRef: returnFocusRef,
        spacing: spacing,
        statusLabel: statusLabel,
        testId: testId,
        trigger: trigger,
        label: label,
        interactionName: interactionName,
        menuLabel: menuLabel
    });
    // Forward full public props to the legacy Popper/Popup implementation unchanged.
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- wrapper delegates entire DropdownMenuProps API
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($efa3e699f80dfb1c$var$DropdownMenuLegacy, props);
};
var $efa3e699f80dfb1c$export$2e2bcd8739ae039 = $efa3e699f80dfb1c$var$DropdownMenu;

});
parcelRegister("2oF7I", function(module, exports) {
$parcel$export(module.exports, "default", () => $1bedb8eb38a3e847$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $1bedb8eb38a3e847$export$2e2bcd8739ae039(propValue) {
    var getDefaultPropValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
        return propValue;
    };
    var isControlled = propValue !== undefined;
    var _useState = (0, $5FkrB.useState)(getDefaultPropValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), valueState = _useState2[0], setValue = _useState2[1];
    var isControlledRef = (0, $5FkrB.useRef)(isControlled);
    (0, $5FkrB.useEffect)(function() {
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var value = isControlled ? propValue : valueState;
    var setValueIfUncontrolled = (0, $5FkrB.useCallback)(function(newValue) {
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("h7zHk", function(module, exports) {
$parcel$export(module.exports, "default", () => $c76ec7f1ca125947$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $c76ec7f1ca125947$export$2e2bcd8739ae039() {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isFocused = _useState2[0], setIsFocused = _useState2[1];
    // ensure bindFocus has a stable ref
    var bindFocus = (0, $5FkrB.useRef)({
        onFocus: function onFocus() {
            return setIsFocused(true);
        },
        onBlur: function onBlur() {
            return setIsFocused(false);
        }
    });
    (0, $5FkrB.useEffect)(function() {
        // handle the case where a component might
        // unmount while being focused.
        return function() {
            return setIsFocused(false);
        };
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("aOu6p", function(module, exports) {
$parcel$export(module.exports, "useLayering", () => $7df5ec948c08a88e$export$c8b4d54e03dee6ed);

var $5FkrB = parcelRequire("5FkrB");

var $7UgYu = parcelRequire("7UgYu");

var $e55pn = parcelRequire("e55pn");

var $7ekwm = parcelRequire("7ekwm");
function $7df5ec948c08a88e$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $5FkrB.useContext)((0, $7UgYu.LevelContext));
    var layerNode = (0, $5FkrB.useContext)((0, $e55pn.LevelNodeContext));
    var rootNode = (0, $5FkrB.useContext)((0, $7ekwm.RootNodeContext));
    var isLayerDisabled = (0, $5FkrB.useCallback)(function() {
        // This is an impossible case, added for type safety
        if (!(layerNode !== null && layerNode !== void 0 && layerNode.current) || !(rootNode !== null && rootNode !== void 0 && rootNode.current)) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    var getTopLevel = (0, $5FkrB.useCallback)(function() {
        return rootNode !== null && rootNode !== void 0 && rootNode.current ? rootNode.current.getHeight() : null;
    }, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}

});
parcelRegister("7UgYu", function(module, exports) {
$parcel$export(module.exports, "LevelContext", () => $5c1aee337f1ba1a6$export$650d12d3c2ddb8fc);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5FkrB = parcelRequire("5FkrB");
var $5c1aee337f1ba1a6$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $5FkrB.createContext)(0);

});

parcelRegister("e55pn", function(module, exports) {
$parcel$export(module.exports, "LevelNodeContext", () => $a405ba4faea0638e$export$18f4d8b5b3a77f59);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5FkrB = parcelRequire("5FkrB");
var $a405ba4faea0638e$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    current: null
});

});

parcelRegister("7ekwm", function(module, exports) {
$parcel$export(module.exports, "RootNodeContext", () => $5439c23b8fed5083$export$fa973f110e8f6ca8);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5FkrB = parcelRequire("5FkrB");
var $5439c23b8fed5083$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    current: null
});

});


parcelRegister("dY97G", function(module, exports) {
$parcel$export(module.exports, "Popup", () => $a2b7f495199a9de5$export$129a32eedafa97c5);
/* popup.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");


var $h8qvJ = parcelRequire("h8qvJ");

var $ezd8U = parcelRequire("ezd8U");

var $iUCre = parcelRequire("iUCre");

var $gCdxV = parcelRequire("gCdxV");

var $50U6m = parcelRequire("50U6m");

var $4yHJ4 = parcelRequire("4yHJ4");

var $hFSRt = parcelRequire("hFSRt");

var $fV8Mu = parcelRequire("fV8Mu");

var $auVZV = parcelRequire("auVZV");

var $9Z4Uz = parcelRequire("9Z4Uz");

var $3TRTB = parcelRequire("3TRTB");

var $516xU = parcelRequire("516xU");

var $jH5Jd = parcelRequire("jH5Jd");

var $2PE7x = parcelRequire("2PE7x");
var $a2b7f495199a9de5$var$defaultLayer = 400;
var $a2b7f495199a9de5$var$wrapperStyles = {
    root: "_kqswh2mm"
};
var $a2b7f495199a9de5$var$PopupLegacy = function PopupLegacy(props) {
    var xcss = props.xcss, _props$appearance = props.appearance, inAppearance = _props$appearance === void 0 ? 'default' : _props$appearance, isOpen = props.isOpen, providedId = props.id, offset = props.offset, testId = props.testId, trigger = props.trigger, content = props.content, onClose = props.onClose, boundary = props.boundary, _props$rootBoundary = props.rootBoundary, rootBoundary = _props$rootBoundary === void 0 ? 'viewport' : _props$rootBoundary, _props$shouldFlip = props.shouldFlip, shouldFlip = _props$shouldFlip === void 0 ? true : _props$shouldFlip, _props$placement = props.placement, placement = _props$placement === void 0 ? 'auto' : _props$placement, fallbackPlacements = props.fallbackPlacements, PopupContainer = props.popupComponent, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, _props$zIndex = props.zIndex, zIndex = _props$zIndex === void 0 ? $a2b7f495199a9de5$var$defaultLayer : _props$zIndex, _props$shouldUseCaptu = props.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _props$shouldUseCaptu === void 0 ? false : _props$shouldUseCaptu, shouldIgnoreCloseEvent = props.shouldIgnoreCloseEvent, _props$shouldRenderTo = props.shouldRenderToParent, inShouldRenderToParent = _props$shouldRenderTo === void 0 ? false : _props$shouldRenderTo, _props$shouldFitConta = props.shouldFitContainer, shouldFitContainer = _props$shouldFitConta === void 0 ? false : _props$shouldFitConta, _props$shouldDisableF = props.shouldDisableFocusLock, shouldDisableFocusLock = _props$shouldDisableF === void 0 ? false : _props$shouldDisableF, _props$shouldReturnFo = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo === void 0 ? true : _props$shouldReturnFo, strategy = props.strategy, role = props.role, label = props.label, titleId = props.titleId, modifiers = props.modifiers, shouldFitViewport = props.shouldFitViewport;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $jH5Jd.useGetMemoizedMergedTriggerRef)();
    var getMergedTriggerRefNew = (0, $2PE7x.useGetMemoizedMergedTriggerRefNew)();
    var generatedId = (0, $h8qvJ.useId)();
    var _usePopupAppearance = (0, $516xU.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    }), appearance = _usePopupAppearance.appearance, shouldRenderToParent = _usePopupAppearance.shouldRenderToParent;
    var id = providedId || generatedId;
    var handleOpenLayerObserverCloseSignal = (0, $5FkrB.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose(null);
    }, [
        onClose
    ]);
    (0, $iUCre.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal,
        type: 'popup'
    });
    // `xcss` is part of Popup's public API and is forwarded as-is to
    // the internal PopperWrapper, which rebuilds the inner styles. We
    // re-bind via a property accessor on a stable object so the
    // design-system css-prop lint rule's identifier-shape check no
    // longer flags it (avoiding a ratcheted lint suppression here).
    var xcssPassthrough = {
        value: xcss
    };
    var renderPopperWrapper = /*#__PURE__*/ $5FkrB.createElement((0, $ezd8U.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ $5FkrB.createElement((0, $9Z4Uz.default), {
        xcss: xcssPassthrough.value,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        zIndex: zIndex,
        strategy: shouldFitContainer ? 'absolute' : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    var popupContent = /*#__PURE__*/ $5FkrB.createElement((0, $4yHJ4.Manager), null, /*#__PURE__*/ $5FkrB.createElement((0, $hFSRt.Reference), null, function(_ref) {
        var ref = _ref.ref;
        return trigger({
            ref: !(0, $50U6m.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            'aria-controls': isOpen ? id : undefined,
            'aria-expanded': isOpen,
            'aria-haspopup': role === 'dialog' && (0, $50U6m.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
        });
    }), !(0, $50U6m.fg)('platform-dst-motion-uplift-popup') && isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ $5FkrB.createElement((0, $fV8Mu.default), {
        zIndex: zIndex
    }, renderPopperWrapper)), (0, $50U6m.fg)('platform-dst-motion-uplift-popup') && /*#__PURE__*/ $5FkrB.createElement((0, $gCdxV.default), {
        appear: true
    }, isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ $5FkrB.createElement((0, $fV8Mu.default), {
        zIndex: zIndex
    }, renderPopperWrapper))));
    if (shouldFitContainer) return /*#__PURE__*/ $5FkrB.createElement((0, $auVZV.Box), {
        xcss: $a2b7f495199a9de5$var$wrapperStyles.root
    }, popupContent);
    return popupContent;
};
var $a2b7f495199a9de5$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $5FkrB.memo)(function(props) {
    // Choose the rendering implementation at the component boundary rather than
    // gating hooks inside a single component. Each implementation owns its own
    // hooks unconditionally, so a runtime feature-flag change swaps component
    // types (a clean remount) instead of changing the hook order of a mounted
    // component.
    if ((0, $50U6m.fg)('platform-dst-top-layer')) // Pass the original props object to preserve the discriminated union
    // (shouldFitContainer: true vs false) that is lost after destructuring.
    return /*#__PURE__*/ $5FkrB.createElement((0, $3TRTB.PopupTopLayer), props);
    return /*#__PURE__*/ $5FkrB.createElement($a2b7f495199a9de5$var$PopupLegacy, props);
});

});
parcelRegister("ezd8U", function(module, exports) {
$parcel$export(module.exports, "Layering", () => $a9ae8770cf8dda67$export$7c885f891c940977);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5FkrB = parcelRequire("5FkrB");

var $bITpv = parcelRequire("bITpv");

var $7UgYu = parcelRequire("7UgYu");

var $e55pn = parcelRequire("e55pn");

var $7ekwm = parcelRequire("7ekwm");
var $a9ae8770cf8dda67$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel, levelNode = _ref.node;
    (0, $5FkrB.useEffect)(function() {
        var levelNodeSafe = levelNode.current;
        var parentNode = levelNodeSafe.parent;
        parentNode === null || parentNode === void 0 || parentNode.addChild(levelNodeSafe);
        return function() {
            parentNode === null || parentNode === void 0 || parentNode.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7UgYu.LevelContext).Provider, {
        value: currentLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e55pn.LevelNodeContext).Provider, {
        value: levelNode
    }, children));
};
var $a9ae8770cf8dda67$export$7c885f891c940977 = function Layering(_ref2) {
    var children = _ref2.children, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? true : _ref2$isDisabled;
    var currentLevel = (0, $5FkrB.useContext)((0, $7UgYu.LevelContext));
    var parentNode = (0, $5FkrB.useContext)((0, $e55pn.LevelNodeContext));
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var newNode = (0, $5FkrB.useRef)(new (0, $bITpv.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($a9ae8770cf8dda67$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7ekwm.RootNodeContext).Provider, {
        value: newNode
    }, content);
};

});
parcelRegister("bITpv", function(module, exports) {
$parcel$export(module.exports, "LayerNode", () => $888ec9232a0c31a2$export$da4f61fd78d35243);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");
var $888ec9232a0c31a2$export$da4f61fd78d35243 = /*#__PURE__*/ function() {
    function LayerNode(id, parent) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, LayerNode);
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(LayerNode, [
        {
            key: "addChild",
            value: function addChild(node) {
                this.childNodes.push(node);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(node) {
                this.childNodes = this.childNodes.filter(function(child) {
                    return child.id !== node.id;
                });
            }
        },
        {
            key: "getLevel",
            value: function getLevel() {
                if (!this.parent) return 1;
                return this.parent.getLevel() + 1;
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                if (this.childNodes.length === 0) return 1;
                return Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(this.childNodes.map(function(child) {
                    return child.getHeight();
                }))) + 1;
            }
        }
    ]);
}();

});


parcelRegister("gCdxV", function(module, exports) {
$parcel$export(module.exports, "ExitingContext", () => $c18ab3f20498f5ce$export$b9c4904d7a6929e6);
$parcel$export(module.exports, "default", () => $c18ab3f20498f5ce$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $50U6m = parcelRequire("50U6m");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $c18ab3f20498f5ce$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isInsideExitingPersistence: false,
    isExiting: false
};
var $c18ab3f20498f5ce$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $5FkrB.createContext)($c18ab3f20498f5ce$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $c18ab3f20498f5ce$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $c18ab3f20498f5ce$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($c18ab3f20498f5ce$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $c18ab3f20498f5ce$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $c18ab3f20498f5ce$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $c18ab3f20498f5ce$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $c18ab3f20498f5ce$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $c18ab3f20498f5ce$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $c18ab3f20498f5ce$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false,
            isInsideExitingPersistence: true
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false,
            isInsideExitingPersistence: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $c18ab3f20498f5ce$var$childrenToArray(previousChildren);
    var current = $c18ab3f20498f5ce$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var nextChildren = currentChildren !== children ? $c18ab3f20498f5ce$var$childrenToArray(children) : current;
    var missingKeys = $c18ab3f20498f5ce$var$getMissingKeys(nextChildren, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $c18ab3f20498f5ce$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $50U6m.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $c18ab3f20498f5ce$var$wrapChildWithContextProvider(child, {
            appear: true,
            isInsideExitingPersistence: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $c18ab3f20498f5ce$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$c18ab3f20498f5ce$export$2e2bcd8739ae039 = $c18ab3f20498f5ce$var$ExitingPersistence;
$c18ab3f20498f5ce$var$ExitingPersistence.displayName = 'ExitingPersistence';

});

parcelRegister("4yHJ4", function(module, exports) {
$parcel$export(module.exports, "Manager", () => $351c41799462e9b8$export$d0d38e7dec7a1a61);

var $5FkrB = parcelRequire("5FkrB");

var $hvYLl = parcelRequire("hvYLl");

var $7FQrs = parcelRequire("7FQrs");

var $1aail = parcelRequire("1aail");

var $6RHim = parcelRequire("6RHim");
function $351c41799462e9b8$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    // `setAnchor` is the `useState` setter, which React guarantees is stable
    // across renders, so it can be passed straight to the context provider.
    var _useAnchorState = (0, $6RHim.useAnchorState)(), anchor = _useAnchorState.anchor, setAnchor = _useAnchorState.setAnchor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $hvYLl.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1aail.AnchorSetterContext).Provider, {
        value: setAnchor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7FQrs.AnchorContext).Provider, {
        value: anchor
    }, children)));
}

});
parcelRegister("1aail", function(module, exports) {
$parcel$export(module.exports, "AnchorSetterContext", () => $0d8eb5f51af49ee0$export$804169e6eecdff16);

var $5FkrB = parcelRequire("5FkrB");
var $0d8eb5f51af49ee0$export$804169e6eecdff16 = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return undefined;
});

});

parcelRegister("6RHim", function(module, exports) {
$parcel$export(module.exports, "useAnchorState", () => $4ff946d970cd17db$export$1b1b50fdcd7ac375);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $4ff946d970cd17db$export$1b1b50fdcd7ac375() {
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), anchor = _useState2[0], setAnchor = _useState2[1];
    return {
        anchor: anchor,
        setAnchor: setAnchor
    };
}

});


parcelRegister("hFSRt", function(module, exports) {
$parcel$export(module.exports, "Reference", () => $cde0d25d074125a2$export$e0be378c32fb70a7);

var $5FkrB = parcelRequire("5FkrB");

var $agyC9 = parcelRequire("agyC9");

var $iO8GM = parcelRequire("iO8GM");

var $c554F = parcelRequire("c554F");
function $cde0d25d074125a2$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var publishAnchor = (0, $c554F.useManagerAnchorSetter)();
    var composedRef = (0, $5FkrB.useMemo)(function() {
        return (0, $iO8GM.default)([
            publishAnchor,
            innerRef
        ]);
    }, [
        publishAnchor,
        innerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $agyC9.Reference), {
        innerRef: composedRef
    }, children);
}

});
parcelRegister("c554F", function(module, exports) {
$parcel$export(module.exports, "useManagerAnchorSetter", () => $8cb9e34f19ae2f0f$export$fcdda419d7091b3);

var $5FkrB = parcelRequire("5FkrB");

var $1aail = parcelRequire("1aail");
function $8cb9e34f19ae2f0f$export$fcdda419d7091b3() {
    return (0, $5FkrB.useContext)((0, $1aail.AnchorSetterContext));
}

});


parcelRegister("9Z4Uz", function(module, exports) {
$parcel$export(module.exports, "default", () => $01e0383d73d1296a$export$2e2bcd8739ae039);
/* popper-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $25nEq = parcelRequire("25nEq");

var $fC8ib = parcelRequire("fC8ib");

var $iYJcE = parcelRequire("iYJcE");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $aOu6p = parcelRequire("aOu6p");

var $a4u8y = parcelRequire("a4u8y");

var $50U6m = parcelRequire("50U6m");

var $5K5L9 = parcelRequire("5K5L9");

var $epSvB = parcelRequire("epSvB");

var $ka0H5 = parcelRequire("ka0H5");

var $d4EwR = parcelRequire("d4EwR");
var $01e0383d73d1296a$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children",
    "appearance",
    "className",
    "isReferenceHidden",
    "shouldFitViewport"
];
function $01e0383d73d1296a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $01e0383d73d1296a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $01e0383d73d1296a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $01e0383d73d1296a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $01e0383d73d1296a$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
var $01e0383d73d1296a$var$fullWidthStyles = null;
var $01e0383d73d1296a$var$wrapperStyles = {
    root: "_2rko1mok _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs130s _syazi7uo _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36",
    fullWidth: "_1bsb1osq",
    motion: "_c71l1kw7 _1e0c1txw"
};
var $01e0383d73d1296a$var$scrollableStyles = null;
var $01e0383d73d1296a$var$blanketStyles = null;
var $01e0383d73d1296a$var$modalStyles = null;
var $01e0383d73d1296a$var$focusRingStyles = {
    root: "_mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y"
};
var $01e0383d73d1296a$var$placementMap = {
    top: {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-start': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-end': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    bottom: {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-start': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-end': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    left: {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-start': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-end': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    right: {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-start': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-end': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    }
};
var $01e0383d73d1296a$var$DefaultPopupComponent = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, appearance = props.appearance, className = props.className, _isReferenceHidden = props.isReferenceHidden, shouldFitViewport = props.shouldFitViewport, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $01e0383d73d1296a$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            $01e0383d73d1296a$var$wrapperStyles.root,
            appearance === 'UNSAFE_modal-below-sm' && "_dk5d1b66 _c71l1ei0 _kqsw1n9t _152t1b66",
            (!shouldRenderToParent || shouldFitViewport) && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ])
    }, htmlAttributes, {
        ref: !(0, $50U6m.fg)('platform-dst-motion-uplift-popup') ? ref : undefined
    }), children);
});
function $01e0383d73d1296a$var$PopperWrapper(_ref) {
    var xcss = _ref.xcss, isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $01e0383d73d1296a$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldIgnoreCloseEvent = _ref.shouldIgnoreCloseEvent, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, zIndex = _ref.zIndex;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== 'dialog';
    (0, $d4EwR.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $ka0H5.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var _useLayering = (0, $aOu6p.useLayering)(), currentLevel = _useLayering.currentLevel;
    var mergedModifiers = (0, $5FkrB.useMemo)(function() {
        return [
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ $5FkrB.createElement((0, $5K5L9.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update, isReferenceHidden = _ref2.isReferenceHidden;
        var popupContainer = /*#__PURE__*/ $5FkrB.createElement(PopupContainer, {
            className: (0, $970q7.default)([
                xcss,
                // @ts-expect-error: `ax` is not typed correctly
                !initialFocusRef && (0, $50U6m.fg)('platform-design-system-apply-popup-wrapper-focus') && $01e0383d73d1296a$var$focusRingStyles.root
            ]),
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: !(0, $50U6m.fg)('platform-dst-motion-uplift-popup') ? function(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            } : undefined,
            style: (0, $50U6m.fg)('platform-dst-motion-uplift-popup') || appearance === 'UNSAFE_modal-below-sm' ? {} : style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer,
            shouldFitViewport: shouldFitViewport,
            isReferenceHidden: isReferenceHidden
        }, /*#__PURE__*/ $5FkrB.createElement((0, $epSvB.RepositionOnUpdate), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        var isAutoPlacement = placement === 'auto' || placement === 'auto-start' || placement === 'auto-end';
        var container = /*#__PURE__*/ $5FkrB.createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $01e0383d73d1296a$var$_objectSpread($01e0383d73d1296a$var$_objectSpread({}, style), {}, {
                zIndex: zIndex
            }),
            // using tabIndex={-1} would cause a bug where Safari focuses
            // first on the browser address bar when using keyboard
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            "data-testid": "".concat(testId, "--container"),
            className: (0, $970q7.default)([
                shouldFitContainer && $01e0383d73d1296a$var$wrapperStyles.fullWidth
            ])
        }, /*#__PURE__*/ $5FkrB.createElement((0, $a4u8y.default), {
            enteringAnimation: !isAutoPlacement ? $01e0383d73d1296a$var$placementMap[placement].enter : undefined,
            exitingAnimation: !isAutoPlacement ? $01e0383d73d1296a$var$placementMap[placement].exit : undefined,
            xcss: $01e0383d73d1296a$var$wrapperStyles.motion
        }, popupContainer));
        return /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, (0, $50U6m.fg)('platform-dst-motion-uplift-popup') ? container : popupContainer, appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ $5FkrB.createElement("div", {
            className: (0, $970q7.default)([
                "_1r04idpf _kqsw1n9t _bfhk1i5c"
            ])
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$01e0383d73d1296a$export$2e2bcd8739ae039 = $01e0383d73d1296a$var$PopperWrapper;

});
parcelRegister("a4u8y", function(module, exports) {
$parcel$export(module.exports, "default", () => $7551a7aaf4a0dde9$export$2e2bcd8739ae039);
/* motion.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $hRJ5R = parcelRequire("hRJ5R");

var $iO8GM = parcelRequire("iO8GM");

var $50U6m = parcelRequire("50U6m");

var $1mlml = parcelRequire("1mlml");

var $eV3qm = parcelRequire("eV3qm");

var $5ge4J = parcelRequire("5ge4J");

var $9sq65 = parcelRequire("9sq65");

var $lDoSq = parcelRequire("lDoSq");

var $20nR7 = parcelRequire("20nR7");

var $1L4Ob = parcelRequire("1L4Ob");

var $dbSL4 = parcelRequire("dbSL4");
function $7551a7aaf4a0dde9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7551a7aaf4a0dde9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7551a7aaf4a0dde9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7551a7aaf4a0dde9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7551a7aaf4a0dde9$var$styles = {
    base: "_1y0co91m _1bumglyw _sedtglyw",
    hidden: "_3um015vq"
};
/**
 * Legacy implementation of `Motion` that inlines the animation lifecycle.
 * Used when the `platform-dst-use-motion` feature gate is off.
 */ var $7551a7aaf4a0dde9$var$MotionLegacy = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, enteringAnimation = _ref.enteringAnimation, enteringAnimationXcss = _ref.enteringAnimationXcss, exitingAnimation = _ref.exitingAnimation, exitingAnimationXcss = _ref.exitingAnimationXcss, onFinishMotion = _ref.onFinish, xcss = _ref.xcss, styleProp = _ref.style, testId = _ref.testId;
    var staggered = (0, $dbSL4.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $20nR7.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var staggeredDelay = isExiting ? 0 : staggered.delay;
    var staggedIsReady = staggered.isReady;
    var _useState = (0, $5FkrB.useState)(appear ? staggedIsReady && !staggeredDelay ? 'entering' : 'init' : 'idle'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var elementRef = (0, $5FkrB.useRef)(null);
    var reanimateRef = (0, $5FkrB.useRef)();
    var animationRef = (0, $5FkrB.useRef)();
    var staggeredEntryRef = (0, $5FkrB.useRef)();
    (0, $5FkrB.useEffect)(function() {
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]);
    // Handles staggered entry
    (0, $5FkrB.useEffect)(function() {
        if (state !== 'init') return;
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(function() {
            setState('entering');
        }, staggeredDelay);
        return function() {
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        state,
        staggedIsReady,
        staggeredDelay
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ var onAnimationEnd = (0, $5FkrB.useCallback)(function(state, cancelled) {
        // We are done animating, so we set the state to idle
        var newState = 'idle';
        if (state === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('exiting');
        }
        if (state === 'entering') onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('entering');
        if (reanimateRef.current === (0, $lDoSq.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $lDoSq.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (!staggedIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is idle or init, we don't need to do anything
        if (state === 'idle' || state === 'init') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if ((0, $5ge4J.isReducedMotion)() || !exitingAnimation && !exitingAnimationXcss) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        var animationDuration = 0;
        if (state === 'entering' || state === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    var animationTimings = (0, $eV3qm.getDurationMs)((0, $9sq65.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    var _styles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $1mlml.getComputedAnimationDurationMs)(_styles.animationName, _styles.animationDuration, _styles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting' && (exitingAnimation || exitingAnimationXcss)) animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration);
        else if (state === 'entering' && (enteringAnimation || enteringAnimationXcss)) animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration);
        return function() {
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        exitingAnimation,
        enteringAnimation,
        exitingAnimationXcss,
        enteringAnimationXcss,
        staggeredDelay,
        staggedIsReady
    ]);
    (0, $5FkrB.useImperativeHandle)(ref, function() {
        return {
            reanimate: function reanimate(value) {
                animationRef.current && clearTimeout(animationRef.current);
                reanimateRef.current = value;
                if (value === (0, $lDoSq.Reanimate).exit_then_enter) setState('exiting');
                else if (value === (0, $lDoSq.Reanimate).enter) setState('entering');
            }
        };
    });
    var style = {};
    var customAnimation;
    if (state === 'entering') {
        if (enteringAnimation) style.animation = enteringAnimation;
        else if (enteringAnimationXcss) customAnimation = enteringAnimationXcss;
    } else if (state === 'exiting') {
        if (exitingAnimation) style.animation = exitingAnimation;
        else if (exitingAnimationXcss) customAnimation = exitingAnimationXcss;
    }
    var hasAnimationStyles = state !== 'idle' && state !== 'init';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            hasAnimationStyles && $7551a7aaf4a0dde9$var$styles.base,
            state === 'init' && $7551a7aaf4a0dde9$var$styles.hidden,
            (0, $hRJ5R.cx)(xcss, customAnimation)
        ]),
        ref: (0, $iO8GM.default)([
            staggered.ref,
            elementRef
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: styleProp || hasAnimationStyles ? $7551a7aaf4a0dde9$var$_objectSpread($7551a7aaf4a0dde9$var$_objectSpread({}, styleProp), style) : undefined,
        "data-testid": testId
    }, children);
});
/**
 * Implementation of `Motion` built on top of the `useMotion` hook.
 * Used when the `platform-dst-use-motion` feature gate is on.
 */ var $7551a7aaf4a0dde9$var$MotionNext = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var children = _ref2.children, enteringAnimation = _ref2.enteringAnimation, enteringAnimationXcss = _ref2.enteringAnimationXcss, exitingAnimation = _ref2.exitingAnimation, exitingAnimationXcss = _ref2.exitingAnimationXcss, onFinishMotion = _ref2.onFinish, xcss = _ref2.xcss, styleProp = _ref2.style, testId = _ref2.testId;
    var _useMotion = (0, $1L4Ob.useMotion)({
        onFinish: onFinishMotion
    }), state = _useMotion.state, motionRef = _useMotion.ref, reanimate = _useMotion.reanimate;
    (0, $5FkrB.useImperativeHandle)(ref, function() {
        return {
            reanimate: reanimate
        };
    }, [
        reanimate
    ]);
    // `xcss` and `style` apply to the wrapper `<div>` the `Motion` component renders,
    // so they are merged here (not in the hook) alongside the hook's animation output.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            state === 'init' && $7551a7aaf4a0dde9$var$styles.hidden,
            (0, $hRJ5R.cx)(xcss, state === 'entering' && enteringAnimationXcss, state === 'exiting' && exitingAnimationXcss)
        ]),
        ref: motionRef,
        style: $7551a7aaf4a0dde9$var$_objectSpread($7551a7aaf4a0dde9$var$_objectSpread({}, styleProp), {}, {
            animation: state === 'entering' ? enteringAnimation : state === 'exiting' ? exitingAnimation : undefined
        }),
        "data-testid": testId
    }, children);
});
/**
 * __Motion__
 *
 * A motion primitive that can be used to animate the entry and exit of components.
 */ var $7551a7aaf4a0dde9$var$Motion = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    if ((0, $50U6m.fg)('platform-dst-use-motion')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($7551a7aaf4a0dde9$var$MotionNext, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        ref: ref
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($7551a7aaf4a0dde9$var$MotionLegacy, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        ref: ref
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$7551a7aaf4a0dde9$export$2e2bcd8739ae039 = $7551a7aaf4a0dde9$var$Motion;

});
parcelRegister("1mlml", function(module, exports) {
$parcel$export(module.exports, "getComputedAnimationDurationMs", () => $0fd86a131b845a20$export$dd9b73a7482d05b6);

var $7b6mz = parcelRequire("7b6mz");
var $0fd86a131b845a20$var$cssTimePattern = /^-?(?:\d+\.?\d*|\.\d+)(?:ms|s)$/;
var $0fd86a131b845a20$var$toCssList = function toCssList(value) {
    return value.split(',').map(function(item) {
        return item.trim();
    }).filter(Boolean);
};
var $0fd86a131b845a20$var$toTimeList = function toTimeList(value) {
    return $0fd86a131b845a20$var$toCssList(value).filter(function(time) {
        return $0fd86a131b845a20$var$cssTimePattern.test(time);
    }).map((0, $7b6mz.convertToMs));
};
var $0fd86a131b845a20$export$dd9b73a7482d05b6 = function getComputedAnimationDurationMs(animationName, animationDuration, animationDelay) {
    var names = $0fd86a131b845a20$var$toCssList(animationName);
    var durations = $0fd86a131b845a20$var$toTimeList(animationDuration);
    var delays = $0fd86a131b845a20$var$toTimeList(animationDelay);
    if (names.length === 0 || durations.length === 0) return 0;
    var longestDuration = 0;
    for(var index = 0; index < names.length; index++){
        if (names[index] === 'none') continue;
        var duration = durations[index % durations.length];
        var delay = delays.length > 0 ? delays[index % delays.length] : 0;
        longestDuration = Math.max(longestDuration, duration + delay);
    }
    return longestDuration;
};

});
parcelRegister("7b6mz", function(module, exports) {
$parcel$export(module.exports, "convertToMs", () => $539e7f0f75477e7c$export$75eee42ff540d8ae);
var $539e7f0f75477e7c$export$75eee42ff540d8ae = function convertToMs(duration) {
    // Use regex to separate the number and the unit
    var matches = duration.match(/^(-?(?:\d+\.?\d*|\.\d+))(s|ms)$/);
    if (!matches) return 0; // Or return for invalid format
    var value = parseFloat(matches[1]);
    var unit = matches[2];
    if (unit === 's') return value * 1000; // Convert seconds to milliseconds
    else return value; // Already in milliseconds
};

});


parcelRegister("eV3qm", function(module, exports) {
$parcel$export(module.exports, "getDurationMs", () => $adc90b840dd1ecf3$export$d0038b6e47881463);

var $fC8ib = parcelRequire("fC8ib");
var $adc90b840dd1ecf3$export$d0038b6e47881463 = function getDurationMs(animation) {
    var animations = animation.split(/,(?![^()]*\))/).map(function(value) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(value.trim().matchAll(/(-?\d*\.?\d+)(ms|s)\b/g));
    }).filter(function(matches) {
        return matches.length > 0;
    });
    if (animations.length === 0) return {
        duration: 0,
        delay: 0
    };
    return animations.reduce(function(longest, matches) {
        var toMilliseconds = function toMilliseconds(match) {
            var value = parseFloat(match[1]);
            return match[2] === 's' ? value * 1000 : value;
        };
        var timing = {
            duration: toMilliseconds(matches[0]),
            delay: matches[1] ? toMilliseconds(matches[1]) : 0
        };
        return timing.duration + timing.delay > longest.duration + longest.delay ? timing : longest;
    }, {
        duration: 0,
        delay: 0
    });
};

});

parcelRegister("5ge4J", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $3d495d740baa06b4$export$b7baf7667a68d87c);

var $1AUvB = parcelRequire("1AUvB");
var $3d495d740baa06b4$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!(0, $1AUvB.isMatchMediaAvailable)()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};

});
parcelRegister("1AUvB", function(module, exports) {
$parcel$export(module.exports, "isMatchMediaAvailable", () => $1294fcb644ec5fba$export$c5406bd59b374abd);
var $1294fcb644ec5fba$export$c5406bd59b374abd = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};

});


parcelRegister("9sq65", function(module, exports) {
$parcel$export(module.exports, "resolveMotionToken", () => $6e2af8f0f35951b8$export$82b92541889a035d);

var $lFhdZ = parcelRequire("lFhdZ");
var $6e2af8f0f35951b8$export$82b92541889a035d = function resolveMotionToken(token) {
    var cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    var cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        var _getDocument;
        var documentElement = (_getDocument = (0, $lFhdZ.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};

});

parcelRegister("lDoSq", function(module, exports) {
$parcel$export(module.exports, "Reanimate", () => $fc008981eebbece2$export$569340a66b14e0dc);
/**
 * Supported reanimate values.
 * 'enter' will re-enter the animation.
 * 'exit-then-enter' will exit the animation and then enter it again.
 */ var $fc008981eebbece2$export$569340a66b14e0dc = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    Reanimate["exit"] = "exit";
    return Reanimate;
}({});

});

parcelRegister("20nR7", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $175e1620f175a67e$export$3b6f38abbdcbd000);

var $5FkrB = parcelRequire("5FkrB");

var $gCdxV = parcelRequire("gCdxV");
var $175e1620f175a67e$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)((0, $gCdxV.ExitingContext));
};

});

parcelRegister("1L4Ob", function(module, exports) {
$parcel$export(module.exports, "useMotion", () => $147de9175b7cc189$export$2a51cfe9390d36ef);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $iO8GM = parcelRequire("iO8GM");

var $1mlml = parcelRequire("1mlml");

var $eV3qm = parcelRequire("eV3qm");

var $5ge4J = parcelRequire("5ge4J");

var $kWFLQ = parcelRequire("kWFLQ");

var $9sq65 = parcelRequire("9sq65");

var $lDoSq = parcelRequire("lDoSq");

var $20nR7 = parcelRequire("20nR7");

var $dbSL4 = parcelRequire("dbSL4");
function $147de9175b7cc189$export$2a51cfe9390d36ef() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, onFinishMotion = _ref.onFinish, onStartMotion = _ref.onStart, initialState = _ref.initialState;
    var reducedMotion = (0, $5ge4J.isReducedMotion)();
    var staggered = (0, $dbSL4.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $20nR7.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var staggeredDelay = isExiting ? 0 : staggered.delay;
    var staggeredIsReady = staggered.isReady;
    var _useState = (0, $5FkrB.useState)(initialState !== null && initialState !== void 0 ? initialState : appear ? staggeredIsReady && !staggeredDelay ? 'entering' : 'init' : 'visible'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    // ExitingPersistence must win during render so consumers apply exit styles before layout effects.
    // The lifecycle effect below uses the same value to measure and finish that exit.
    var motionState = isExiting ? 'exiting' : state;
    var elementRef = (0, $5FkrB.useRef)(null);
    var onStartMotionRef = (0, $5FkrB.useRef)(onStartMotion);
    onStartMotionRef.current = onStartMotion;
    var reanimateRef = (0, $5FkrB.useRef)();
    var animationRef = (0, $5FkrB.useRef)();
    var staggeredEntryRef = (0, $5FkrB.useRef)();
    (0, $kWFLQ.useLayoutEffect)(function() {
        if (motionState === 'exiting') {
            var _onStartMotionRef$cur;
            (_onStartMotionRef$cur = onStartMotionRef.current) === null || _onStartMotionRef$cur === void 0 || _onStartMotionRef$cur.call(onStartMotionRef, 'exiting');
        }
        if (motionState === 'entering') {
            var _onStartMotionRef$cur2;
            (_onStartMotionRef$cur2 = onStartMotionRef.current) === null || _onStartMotionRef$cur2 === void 0 || _onStartMotionRef$cur2.call(onStartMotionRef, 'entering');
        }
    }, [
        motionState
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ var onAnimationEnd = (0, $5FkrB.useCallback)(function(currentState, cancelled) {
        // We are done animating, so we set the state to visible
        var newState = 'visible';
        if (currentState === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('exiting');
        }
        if (currentState === 'entering') onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('entering');
        if (reanimateRef.current === (0, $lDoSq.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $lDoSq.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current === (0, $lDoSq.Reanimate).enter) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        else if (reanimateRef.current === (0, $lDoSq.Reanimate).exit) {
            // We are done reanimating, so we clear the reanimate state
            reanimateRef.current = undefined;
            newState = 'hidden';
        }
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    // Handles staggered entry
    (0, $5FkrB.useEffect)(function() {
        if (state !== 'init') return;
        if (reducedMotion) {
            onAnimationEnd('entering', false);
            return;
        }
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(function() {
            setState('entering');
        }, staggeredDelay);
        return function() {
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        onAnimationEnd,
        state,
        staggeredIsReady,
        staggeredDelay,
        reducedMotion
    ]);
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (!staggeredIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is visible, hidden or init, we don't need to do anything
        if (motionState === 'visible' || motionState === 'init' || motionState === 'hidden') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if (reducedMotion) {
            onAnimationEnd(motionState, isCancelled);
            return;
        }
        var animationDuration = 0;
        if (motionState === 'entering' || motionState === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    var animationTimings = (0, $eV3qm.getDurationMs)((0, $9sq65.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    var computedStyles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $1mlml.getComputedAnimationDurationMs)(computedStyles.animationName, computedStyles.animationDuration, computedStyles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (motionState === 'exiting') animationRef.current = setTimeout(function() {
            return onAnimationEnd(motionState, isCancelled);
        }, animationDuration);
        else if (motionState === 'entering') animationRef.current = setTimeout(function() {
            return onAnimationEnd(motionState, isCancelled);
        }, animationDuration);
        return function() {
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        motionState,
        appear,
        staggeredDelay,
        staggeredIsReady,
        reducedMotion
    ]);
    var reanimate = (0, $5FkrB.useCallback)(function(value) {
        animationRef.current && clearTimeout(animationRef.current);
        reanimateRef.current = value;
        if (value === (0, $lDoSq.Reanimate).exit_then_enter) setState('exiting');
        else if (value === (0, $lDoSq.Reanimate).enter) setState('entering');
        else if (value === (0, $lDoSq.Reanimate).exit) setState('exiting');
    }, []);
    var ref = (0, $5FkrB.useMemo)(function() {
        return (0, $iO8GM.default)([
            staggered.ref,
            elementRef
        ]);
    }, [
        staggered.ref
    ]);
    return {
        ref: ref,
        reanimate: reanimate,
        state: motionState
    };
}

});
parcelRegister("kWFLQ", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $f3f9a03b1d952aa5$export$e5c5a5f917a5871c);

var $5FkrB = parcelRequire("5FkrB");
var $f3f9a03b1d952aa5$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);

});

parcelRegister("dbSL4", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $99a6c74665968655$export$25c7213fc07ec080);

var $5FkrB = parcelRequire("5FkrB");

var $frODf = parcelRequire("frODf");

var $jGiOd = parcelRequire("jGiOd");
var $99a6c74665968655$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var identifier = (0, $frODf.useUniqueId)();
    var context = (0, $5FkrB.useContext)((0, $jGiOd.StaggeredEntranceContext));
    return context(identifier);
};

});
parcelRegister("frODf", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $b3f0a7178266e53c$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $b3f0a7178266e53c$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});

parcelRegister("jGiOd", function(module, exports) {
$parcel$export(module.exports, "StaggeredEntranceContext", () => $e540879ec0962abd$export$5e65d7d58ae96ad8);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");

var $kWFLQ = parcelRequire("kWFLQ");
var $e540879ec0962abd$export$5e65d7d58ae96ad8 = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $eVb4V.default)
    };
});
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $e540879ec0962abd$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $kWFLQ.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($e540879ec0962abd$export$5e65d7d58ae96ad8.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$e540879ec0962abd$export$2e2bcd8739ae039 = $e540879ec0962abd$var$StaggeredEntrance;

});




parcelRegister("epSvB", function(module, exports) {
$parcel$export(module.exports, "RepositionOnUpdate", () => $a7edaecb351c1789$export$51eddd7655ca235a);

var $5FkrB = parcelRequire("5FkrB");
var $a7edaecb351c1789$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $5FkrB.useRef)(true);
    (0, $5FkrB.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update.
        // Guard against `update` being undefined: on Safari the Popper instance may
        // not be fully initialised when this layout effect fires, in which case the
        // render-prop `update` is undefined and calling it throws
        // `TypeError: e.update is not a function`.
        if (typeof update === 'function') update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, children);
};

});

parcelRegister("ka0H5", function(module, exports) {
$parcel$export(module.exports, "useCloseManager", () => $ead5479bf2690ca1$export$92dae2778ae88f9d);
// eslint-disable-next-line no-duplicate-imports

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $eVb4V = parcelRequire("eVb4V");

var $aOu6p = parcelRequire("aOu6p");

var $50U6m = parcelRequire("50U6m");

var $bwSz6 = parcelRequire("bwSz6");

var $3vy2m = parcelRequire("3vy2m");
var $ead5479bf2690ca1$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, capture = _ref.shouldUseCaptureOnOutsideClick, shouldIgnoreCloseEvent = _ref.shouldIgnoreCloseEvent, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useLayering = (0, $aOu6p.useLayering)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    var _useAnimationFrame = (0, $3vy2m.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var mouseDownTarget = (0, $5FkrB.useRef)(null);
    (0, $5FkrB.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $eVb4V.default;
        var closePopup = function closePopup(event) {
            if (shouldIgnoreCloseEvent !== null && shouldIgnoreCloseEvent !== void 0 && shouldIgnoreCloseEvent(event) && (0, $50U6m.fg)('cc_blocks_changeboarding')) return;
            if (onClose) {
                var _currentLevel = null;
                if (event.target instanceof HTMLElement) {
                    var _event$target$closest, _event$target$closest2;
                    _currentLevel = (_event$target$closest = (_event$target$closest2 = event.target.closest("[data-ds--level]")) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.getAttribute('data-ds--level')) !== null && _event$target$closest !== void 0 ? _event$target$closest : null;
                }
                _currentLevel ? onClose(event, Number(_currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $50U6m.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            if (target instanceof HTMLElement) {
                var _target$closest;
                var layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, "[data-ds--level]");
                if (layeredElement) {
                    var closeType = layeredElement.getAttribute('data-ds--close--type');
                    if (closeType === 'single' && isLayerDisabled()) // if the close type is single, we won't close other disabled layers when clicking outside
                    return;
                    var levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                    if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // Don't close this popup when the click landed inside a higher-level layer
                    // (e.g. a Drawer or Modal that portals to <body>). Such nodes are not DOM
                    // descendants of popupRef, so the contains() checks below would wrongly
                    // classify them as "outside" clicks and close the popup prematurely.
                    return;
                }
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            var didClickStartInsidePopup = popupRef && mouseDownTarget.current instanceof Node && popupRef.contains(mouseDownTarget.current);
            if (!isClickOnPopup && !isClickOnTrigger && !didClickStartInsidePopup) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $bwSz6.isInteractiveElement)(document.activeElement) && (0, $50U6m.fg)('platform_dst_popup-disable-focuslock')) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        var onMouseDown = function onMouseDown(event) {
            /**
       * Tracking the target of the mouse down event.
       * This is used to prevent the popup from closing when the user mouses down inside the popup, but then
       * moves the mouse outside the popup before releasing the mouse button.
       *
       * This is a common user interaction - users may have mistakenly clicked on something, or changed their mind,
       * so they try to cancel their click by moving their mouse away from what they had moused down on.
       *
       * Blanket uses the same technique.
       */ mouseDownTarget.current = event.target;
        };
        var onKeyDown = function onKeyDown(event) {
            var key = event.key;
            if ((key === 'Escape' || key === 'Esc') && (0, $50U6m.fg)('platform_dst_nested_escape')) {
                var _eventTarget$closest;
                var eventTarget = event.target instanceof HTMLElement ? event.target : null;
                var layeredAncestor = eventTarget === null || eventTarget === void 0 || (_eventTarget$closest = eventTarget.closest) === null || _eventTarget$closest === void 0 ? void 0 : _eventTarget$closest.call(eventTarget, '[data-ds--level]');
                var levelStr = layeredAncestor === null || layeredAncestor === void 0 ? void 0 : layeredAncestor.getAttribute('data-ds--level');
                if (levelStr && Number(levelStr) > currentLevel) return;
            }
            if ((0, $50U6m.fg)('platform_dst_popup-disable-focuslock')) {
                var shiftKey = event.shiftKey;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
            }
        };
        var unbind = (0, $eVb4V.default);
        if ((0, $50U6m.fg)('popup-onclose-fix')) setTimeout(function() {
            unbind = (0, $7QpUe.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                },
                {
                    type: 'mousedown',
                    listener: onMouseDown
                }
            ]);
        }, 0);
        else unbind = (0, $7QpUe.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'mousedown',
                listener: onMouseDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $eVb4V.default);
        unbindBlur = (0, $7QpUe.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            if ((0, $50U6m.fg)('popup-onclose-fix')) setTimeout(function() {
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        shouldIgnoreCloseEvent,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("bwSz6", function(module, exports) {
$parcel$export(module.exports, "isInteractiveElement", () => $864d026677cce2dd$export$3dee5e4542c672d9);
var $864d026677cce2dd$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
var $864d026677cce2dd$export$3dee5e4542c672d9 = function isInteractiveElement(element) {
    if ($864d026677cce2dd$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};

});

parcelRegister("3vy2m", function(module, exports) {
$parcel$export(module.exports, "useAnimationFrame", () => $28deab68320ef15f$export$641fa9c94086b46e);

var $5FkrB = parcelRequire("5FkrB");
var $28deab68320ef15f$export$641fa9c94086b46e = function useAnimationFrame() {
    var animationsRef = (0, $5FkrB.useRef)([]);
    var requestFrame = (0, $5FkrB.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, $5FkrB.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, $5FkrB.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("d4EwR", function(module, exports) {
$parcel$export(module.exports, "useFocusManager", () => $984b16538a2886c6$export$10c5169755ce7bd7);

var $5FkrB = parcelRequire("5FkrB");

var $b6Hjk = parcelRequire("b6Hjk");

var $eVb4V = parcelRequire("eVb4V");

var $aOu6p = parcelRequire("aOu6p");

var $50U6m = parcelRequire("50U6m");

var $3vy2m = parcelRequire("3vy2m");
var $984b16538a2886c6$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, shouldReturnFocus = _ref.shouldReturnFocus, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useAnimationFrame = (0, $3vy2m.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var _useLayering = (0, $aOu6p.useLayering)(), currentLevel = _useLayering.currentLevel;
    (0, $5FkrB.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $eVb4V.default;
        if (shouldDisableFocusTrap && (0, $50U6m.fg)('platform_dst_popup-disable-focuslock')) {
            var isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            var popups = document.querySelectorAll("[data-ds--level=\"".concat(currentLevel - 1, "\"]"));
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(function() {
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $eVb4V.default;
            }
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: (0, $50U6m.fg)('platform_dst_nested_escape') ? false : true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($b6Hjk)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
            if ((0, $50U6m.fg)('platform_dst-popup-trigger-initial-focus-ref') && shouldReturnFocus) requestFrame(function() {
                if (triggerRef !== null && triggerRef !== void 0 && triggerRef.isConnected && (document.activeElement === document.body || document.activeElement === document.documentElement || !document.activeElement)) triggerRef.focus();
            });
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});
parcelRegister("b6Hjk", function(module, exports) {

var $lQ8M2 = parcelRequire("lQ8M2");
var $8161d9da2c93c765$var$listeningFocusTrap = null;
function $8161d9da2c93c765$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $8161d9da2c93c765$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($8161d9da2c93c765$var$listeningFocusTrap) $8161d9da2c93c765$var$listeningFocusTrap.pause();
        $8161d9da2c93c765$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $8161d9da2c93c765$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $8161d9da2c93c765$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $8161d9da2c93c765$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $8161d9da2c93c765$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $8161d9da2c93c765$var$tryFocus(lastTabbableNode);
            return $8161d9da2c93c765$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $8161d9da2c93c765$var$tryFocus(firstTabbableNode);
        $8161d9da2c93c765$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $lQ8M2(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $8161d9da2c93c765$var$tryFocus(lastTabbableNode);
        $8161d9da2c93c765$var$tryFocus(firstTabbableNode);
    }
}
function $8161d9da2c93c765$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $8161d9da2c93c765$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
module.exports = $8161d9da2c93c765$var$focusTrap;

});
parcelRegister("lQ8M2", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $fe654298f8d91f4b$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $fe654298f8d91f4b$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}

});




parcelRegister("3TRTB", function(module, exports) {
$parcel$export(module.exports, "PopupTopLayer", () => $2d7050bf4b301b0f$export$e24b8cb659609dee);
/* popup-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");


var $eVb4V = parcelRequire("eVb4V");

var $hMSs1 = parcelRequire("hMSs1");

var $bHHwI = parcelRequire("bHHwI");

var $87pUt = parcelRequire("87pUt");

var $raqQD = parcelRequire("raqQD");

var $crjjC = parcelRequire("crjjC");

var $lESsq = parcelRequire("lESsq");

var $rC5Q0 = parcelRequire("rC5Q0");

var $dlMkc = parcelRequire("dlMkc");

var $29RES = parcelRequire("29RES");
function $2d7050bf4b301b0f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2d7050bf4b301b0f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2d7050bf4b301b0f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2d7050bf4b301b0f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Top-layer positioning is handled by CSS Anchor Positioning, not inline styles.
var $2d7050bf4b301b0f$var$EMPTY_STYLE = {};
var $2d7050bf4b301b0f$export$e24b8cb659609dee = /*#__PURE__*/ (0, $5FkrB.memo)(function PopupTopLayer(_ref) {
    var _roleProps$role;
    var xcss = _ref.xcss, isOpen = _ref.isOpen, providedId = _ref.id, offsetProp = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, _ref$onClose = _ref.onClose, onClose = _ref$onClose === void 0 ? (0, $eVb4V.default) : _ref$onClose, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, _fallbackPlacements = _ref.fallbackPlacements, _ref$shouldFlip = _ref.shouldFlip, _shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldReturnFocu = _ref.shouldReturnFocus, _shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, role = _ref.role, label = _ref.label, titleId = _ref.titleId, _zIndex = _ref.zIndex, _shouldRenderToParent = _ref.shouldRenderToParent, _strategy = _ref.strategy, _modifiers = _ref.modifiers, _boundary = _ref.boundary, _rootBoundary = _ref.rootBoundary, _shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, _shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor, _appearance = _ref.appearance;
    var triggerRef = (0, $5FkrB.useRef)(null);
    var popoverRef = (0, $5FkrB.useRef)(null);
    /**
   * Escape hatch for consumer-chosen initial focus target.
   *
   * The legacy `Popup` surfaced `setInitialFocusRef` on the content
   * render prop with a `Dispatch<SetStateAction<HTMLElement | null>>`
   * signature so it could be passed as a React `ref` callback. We
   * keep the same shape for API compatibility, but store the value in
   * a ref rather than component state. Flipping state on every open
   * caused a needless re-render and, more importantly, raced the
   * initial-focus effect below. The ref is read in the open-side
   * effect to override the role-based default focus chosen by
   * `useInitialFocus` inside the underlying `Popover`.
   */ var consumerInitialFocusRef = (0, $5FkrB.useRef)(null);
    var setInitialFocusRef = (0, $5FkrB.useCallback)(function(value) {
        consumerInitialFocusRef.current = typeof value === 'function' ? value(consumerInitialFocusRef.current) : value;
    }, []);
    /**
   * Override the role-based initial focus chosen by the underlying
   * `Popover` (its internal `useInitialFocus`).
   *
   * React flushes child effects before parent effects, so by the time
   * this effect runs the role-based default focus has already moved.
   * We then apply the legacy `Popup` contract:
   *
   * 1. If the consumer wired `setInitialFocusRef`, focus that element
   *    (escape hatch wins).
   * 2. Otherwise, if `autoFocus={false}`, return focus to the trigger.
   *    The `autoFocus` prop on `Popup` opts out of any initial-focus
   *    movement, even for roles like `dialog`.
   *
   * When neither applies the role-based default from the underlying
   * `Popover` stays in place.
   */ (0, $5FkrB.useEffect)(function() {
        if (!isOpen) {
            /**
       * Clear the consumer-supplied focus target on close so a
       * subsequent open does not silently inherit a stale ref from
       * the previous open cycle. The next open will re-collect a
       * target only if the content render prop re-wires
       * `setInitialFocusRef`.
       */ consumerInitialFocusRef.current = null;
            return;
        }
        var consumerTarget = consumerInitialFocusRef.current;
        if (consumerTarget && consumerTarget.isConnected) {
            consumerTarget.focus();
            return;
        }
        if (!autoFocus) {
            var _trigger = triggerRef.current;
            if (_trigger && _trigger.isConnected) _trigger.focus();
        }
    }, [
        isOpen,
        autoFocus
    ]);
    var popoverId = (0, $rC5Q0.usePopoverId)();
    // Placement conversion.
    // Legacy `offset` is the popper `[along, away]` tuple; `fromLegacyPlacement`
    // folds it into the new `placement.offset` shape so it travels with placement.
    var topLayerPlacement = (0, $5FkrB.useMemo)(function() {
        return (0, $bHHwI.fromLegacyPlacement)({
            legacy: placement,
            offset: offsetProp
        });
    }, [
        placement,
        offsetProp
    ]);
    (0, $lESsq.useAnchoredPopover)($2d7050bf4b301b0f$var$_objectSpread({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen
    }, (0, $dlMkc.getPopupAxisSizes)({
        shouldFitContainer: shouldFitContainer,
        shouldFitViewport: shouldFitViewport
    })));
    // onClose bridge.
    // Translates top-layer's { reason: TPopoverCloseReason } into legacy
    // onClose(event, currentLevel?) by synthesizing DOM events.
    //
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    // No manual triggerRef.current?.focus() is needed.
    var handleOnClose = (0, $5FkrB.useCallback)(function(_ref2) {
        var reason = _ref2.reason;
        onClose((0, $87pUt.createPopoverCloseEvent)({
            reason: reason
        }));
    }, [
        onClose
    ]);
    // Content render-prop bridge.
    // Legacy content() receives { isOpen, update, setInitialFocusRef, onClose }.
    // update is a no-op because CSS Anchor Positioning self-updates.
    var contentProps = (0, $5FkrB.useMemo)(function() {
        return {
            isOpen: isOpen,
            update: (0, $eVb4V.default),
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        };
    }, [
        isOpen,
        onClose,
        setInitialFocusRef
    ]);
    // Role mapping.
    // Build the role/label props for Popover.
    // Roles requiring accessible names must have label or labelledBy.
    var roleProps = (0, $29RES.useRoleProps)({
        role: role,
        label: label,
        titleId: titleId
    });
    var resolvedPopoverId = providedId !== null && providedId !== void 0 ? providedId : popoverId;
    var ariaAttributes = (0, $hMSs1.getAriaForTrigger)({
        role: (_roleProps$role = roleProps.role) !== null && _roleProps$role !== void 0 ? _roleProps$role : 'dialog',
        isOpen: isOpen,
        popoverId: resolvedPopoverId
    });
    // Narrow to ForwardRefExoticComponent so JSX accepts the ref prop.
    // All popupComponent implementations use forwardRef per the PopupComponentProps contract.
    var Container = PopupContainer;
    // Map to legacy TriggerProps.
    var triggerProps = {
        ref: function ref(node) {
            triggerRef.current = node;
        },
        'aria-controls': ariaAttributes['aria-controls'],
        // `aria-expanded` reflects current open state.
        'aria-expanded': ariaAttributes['aria-expanded'],
        // FUDGE(top-layer-api): cast to the narrow public TriggerProps['aria-haspopup'] union.
        // `getAriaForTrigger` derives `aria-haspopup` from the content's role and types it
        // as the wider WAI-ARIA union (boolean | 'dialog' | 'menu' | 'listbox' | 'tree' | 'grid').
        // We keep the public popup TriggerProps narrow (boolean | 'dialog') because the
        // top-layer API surface is not yet settled. Widening adopter types now would commit
        // us to a public surface we may revisit. The runtime value is unchanged; only the
        // TypeScript-visible type is narrowed at this boundary.
        'aria-haspopup': ariaAttributes['aria-haspopup']
    };
    return /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, trigger(triggerProps), /*#__PURE__*/ $5FkrB.createElement((0, $raqQD.Popover), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: popoverRef,
        id: resolvedPopoverId
    }, roleProps, {
        isOpen: isOpen,
        onClose: handleOnClose,
        shouldAnimate: true,
        placement: topLayerPlacement,
        testId: testId && "".concat(testId, "--content")
    }), Container ? /*#__PURE__*/ $5FkrB.createElement(Container, {
        style: $2d7050bf4b301b0f$var$EMPTY_STYLE,
        id: providedId,
        "data-placement": placement,
        "data-testid": testId,
        tabIndex: autoFocus ? -1 : undefined,
        xcss: xcss,
        shouldFitViewport: shouldFitViewport
    }, content(contentProps)) : /*#__PURE__*/ // `PopoverSurface` owns `overflow: auto` and the `box-shadow` on the
    // same element, so it is the scroll container. The wrapper exists only
    // to carry the consumer's `xcss`: `PopoverSurface` exposes no
    // `className` or `xcss` by design, so `xcss` lands on a CHILD of the
    // surface. `width` works there; surface-level declarations apply one
    // level in. Same shape as `compositional/popup-content-top-layer.tsx`.
    $5FkrB.createElement((0, $crjjC.PopoverSurface), null, /*#__PURE__*/ $5FkrB.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: xcss
    }, content(contentProps)))));
});

});
parcelRegister("hMSs1", function(module, exports) {
$parcel$export(module.exports, "getAriaForTrigger", () => $035780a5f3bca592$export$9dd1d61dd4d4755);
/**
 * Roles accepted by `getAriaForTrigger`.
 *
 * Excludes tooltip-family roles (`tooltip`, `note`, `status`, `alert`, `log`)
 * because the correct trigger wiring for those is `aria-describedby`, not
 * `aria-haspopup` / `aria-expanded` / `aria-controls`. Use `aria-describedby`
 * manually for tooltip triggers.
 */ /**
 * Maps each supported popover role to its `aria-haspopup` value.
 *
 * Derived from the HTML spec - maps popover roles to what the trigger
 * announces. Roles that do not produce a popup use `undefined` instead (for
 * non-popup roles like `tooltip`/`status`/`alert`/`note`/`log` where
 * `aria-haspopup` would be misleading), so they are intentionally excluded
 * from this mapping and from `getAriaForTrigger`.
 *
 * `true` is intentionally not a value in this mapping. The runtime only ever
 * produces the explicit string forms, so allowing it would invite consumers
 * to pass `true` and get an `aria-haspopup="true"` serialisation that the
 * runtime no longer emits.
 */ var $035780a5f3bca592$var$roleToAriaHasPopup = {
    dialog: 'dialog',
    alertdialog: 'dialog',
    menu: 'menu',
    listbox: 'listbox',
    tree: 'tree',
    grid: 'grid'
};
function $035780a5f3bca592$export$9dd1d61dd4d4755(_ref) {
    var role = _ref.role, isOpen = _ref.isOpen, popoverId = _ref.popoverId;
    // `aria-controls` is set to `undefined` while closed. The `Popover` /
    // `Dialog` primitives unmount their host element after the exit
    // animation finishes, so a closed-state `aria-controls` would point
    // at a node that is not in the DOM. Returning `undefined` here means
    // JSX spread renders no `aria-controls` attribute on the trigger
    // until the target exists, avoiding the dangling reference while
    // keeping the relationship live whenever it is meaningful.
    return {
        'aria-haspopup': $035780a5f3bca592$var$roleToAriaHasPopup[role],
        'aria-expanded': isOpen,
        'aria-controls': isOpen ? popoverId : undefined
    };
}

});

parcelRegister("bHHwI", function(module, exports) {
$parcel$export(module.exports, "fromLegacyPlacement", () => $88557954ddf59374$export$69e99ed50b2534c9);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $hAlsd = parcelRequire("hAlsd");
function $88557954ddf59374$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $88557954ddf59374$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $88557954ddf59374$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $88557954ddf59374$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $88557954ddf59374$export$69e99ed50b2534c9(_ref) {
    var legacy = _ref.legacy, offset = _ref.offset;
    var basePlacement = (0, $hAlsd.placementMapping)[legacy];
    if (!offset) return basePlacement;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(offset, 2), along = _offset[0], away = _offset[1];
    return $88557954ddf59374$var$_objectSpread($88557954ddf59374$var$_objectSpread({}, basePlacement), {}, {
        offset: {
            gap: away,
            crossAxisShift: {
                // Sign is captured in `direction`; `value` is the magnitude.
                value: Math.abs(along),
                direction: along >= 0 ? 'forwards' : 'backwards'
            }
        }
    });
}

});
parcelRegister("hAlsd", function(module, exports) {
$parcel$export(module.exports, "placementMapping", () => $ccd670ce09f485ab$export$27df359c528b7120);
/**
 * The full mapping record. Internal - use `fromLegacyPlacement` from the
 * public entry-point so the offset-tuple translation is applied consistently.
 *
 * Note: `auto`, `auto-start`, `auto-end` map to `block-end` placements. This
 * is a reduction in expressiveness vs Popper.js (which picked the best
 * placement at runtime). CSS `position-try-fallbacks` flips at the edge but
 * the initial placement is fixed. Migration consumers who relied on Popper's
 * dynamic auto-flip should pick an explicit placement instead.
 */ var $ccd670ce09f485ab$export$27df359c528b7120 = {
    top: {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'start'
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'end'
    },
    bottom: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    },
    right: {
        axis: 'inline',
        edge: 'end',
        align: 'center'
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'start'
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'end'
    },
    left: {
        axis: 'inline',
        edge: 'start',
        align: 'center'
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'start'
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'end'
    },
    auto: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'auto-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'auto-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    }
};

});


parcelRegister("87pUt", function(module, exports) {
$parcel$export(module.exports, "createPopoverCloseEvent", () => $5e93135852b41f01$export$27b4de066896ac63);
/**
 * Creates a synthetic DOM event from a `TPopoverCloseReason`.
 *
 * Useful when bridging the Popover primitive's `onClose({ reason })` callback
 * to a legacy API that expects a native DOM event - for example,
 * `@atlaskit/inline-dialog`'s `onClose(event)` contract.
 *
 * - `'escape'` → `KeyboardEvent('keydown', { key: 'Escape' })`
 * - `'light-dismiss'` → `MouseEvent('click')`
 *
 * For any other reason, a generic `Event('close')` is returned as a fallback.
 *
 * @example
 * ```tsx
 * import { createPopoverCloseEvent, type TPopoverCloseReason } from '@atlaskit/top-layer/popover';
 *
 * function onPopoverClose({ reason }: { reason: TPopoverCloseReason }) {
 *   legacyOnClose(createPopoverCloseEvent({ reason }));
 * }
 * ```
 */ function $5e93135852b41f01$export$27b4de066896ac63(_ref) {
    var reason = _ref.reason;
    if (reason === 'escape') return new KeyboardEvent('keydown', {
        key: 'Escape',
        bubbles: true
    });
    if (reason === 'light-dismiss') return new MouseEvent('click', {
        bubbles: true,
        cancelable: true
    });
    return new Event('close');
}

});

parcelRegister("raqQD", function(module, exports) {
$parcel$export(module.exports, "Popover", () => $051a9d50aec333c1$export$5b6b19405a83ff9d);
/* popover.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $hUFig = parcelRequire("hUFig");

var $7QpUe = parcelRequire("7QpUe");

var $iO8GM = parcelRequire("iO8GM");

var $bvsoE = parcelRequire("bvsoE");

var $iUCre = parcelRequire("iUCre");

var $gaaLe = parcelRequire("gaaLe");

var $6DtZS = parcelRequire("6DtZS");

var $6sMtO = parcelRequire("6sMtO");

var $3aj7x = parcelRequire("3aj7x");

var $ap8jH = parcelRequire("ap8jH");
/**
 * Native restoration only covers the first popover in an auto/hint stack, not each nested popover.
 * This fallback also supports manual popovers, which have no native restoration target.
 * See https://html.spec.whatwg.org/multipage/popover.html#show-popover (step 15.8).
 */ function $051a9d50aec333c1$var$restoreFocus(_ref) {
    var popover = _ref.popover, focusRestorationTarget = _ref.focusRestorationTarget;
    if (!focusRestorationTarget) return;
    var ownerDocument = popover.ownerDocument;
    // Native restoration has finished. Preserve focus moved outside the popover.
    var activeElementAfterClose = ownerDocument.activeElement;
    // Before close, we checked that focus was inside. Body can now mean focus was lost during close.
    if (activeElementAfterClose === ownerDocument.body || popover.contains(activeElementAfterClose)) // Match native popover restoration, which does not scroll the viewport.
    focusRestorationTarget.focus({
        preventScroll: true
    });
}
/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ var $051a9d50aec333c1$var$supportsPopoverHint = (0, $bvsoE.default)(function() {
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    var element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
// Surface reset — neutralises inherited interaction and text-layout properties
// (e.g. `pointer-events: none` from an overlaid controls container and
// `white-space: nowrap` from an `@atlaskit/select` option) that leak into a
// top-layer element because, for CSS inheritance, it is still a DOM child of its
// trigger (top-layer promotion is paint/stacking only; the legacy portal path
// avoided this by rendering at `<body>`). Excludes `color`/`font` (theming) and
// `direction`/`unicode-bidi` (RTL must inherit).
//
// Not `all: initial`: the target is what `<body>` gave the portal path, not the
// spec initial values (UA serif, black, `color-scheme: normal`), and as an author
// declaration it would also override the UA `[popover]` rules (`position: fixed`,
// `display: none` when closed).
//
// KEEP IN SYNC with the identical `surfaceResetStyles` in `dialog/dialog-content.tsx`.
// ADS forbids sharing styles across files (`no-exported-styles` /
// `no-imported-style-values` — Compiled styles are null at runtime), so the reset is
// co-located and duplicated deliberately. The `satisfies` check below fails the
// build if either copy drifts.
var $051a9d50aec333c1$var$surfaceResetStyles = {
    root: "_lcxv1wug _o5724jg8 _1nmz4jg8 _1i4q4jg8 _y3gnv2br _azhwidpf _1p1dglyw"
};
var $051a9d50aec333c1$var$styles = {
    root: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r041wug _1reoewfl _18m9ewfl _bfhk1j28 _4t3i1wug _p6861txw _51hckb7n _1yp3idpf _f5r5idpf",
    motion: "_k8m011k7 _1oecdn4k _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v179n",
    exit: "_y44vof1f"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
var $051a9d50aec333c1$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ var $051a9d50aec333c1$var$POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
var $051a9d50aec333c1$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function Popover(_ref2, ref) {
    var children = _ref2.children, _ref2$mode = _ref2.mode, modeProp = _ref2$mode === void 0 ? 'auto' : _ref2$mode, onClose = _ref2.onClose, onEnterFinish = _ref2.onEnterFinish, onExitFinish = _ref2.onExitFinish, _ref2$shouldAnimate = _ref2.shouldAnimate, shouldAnimate = _ref2$shouldAnimate === void 0 ? false : _ref2$shouldAnimate, placement = _ref2.placement, testId = _ref2.testId, isOpen = _ref2.isOpen, enteringAnimationXcss = _ref2.enteringAnimationXcss, exitingAnimationXcss = _ref2.exitingAnimationXcss, role = _ref2.role, label = _ref2.label, labelledBy = _ref2.labelledBy, idProp = _ref2.id;
    var autoId = (0, $5FkrB.useId)();
    var ownRef = (0, $5FkrB.useRef)(null);
    var combinedRef = (0, $iO8GM.default)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    var popoverId = idProp !== null && idProp !== void 0 ? idProp : "popover-".concat(autoId.replace(/:/g, ''));
    // Keep the semantic callback current without rebinding native lifecycle
    // listeners during the same commit that calls showPopover()/hidePopover().
    var onCloseRef = (0, $5FkrB.useRef)(onClose);
    (0, $5FkrB.useLayoutEffect)(function() {
        onCloseRef.current = onClose;
    }, [
        onClose
    ]);
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined.
    var handleObserverClose = (0, $5FkrB.useCallback)(function() {
        var _onCloseRef$current;
        (_onCloseRef$current = onCloseRef.current) === null || _onCloseRef$current === void 0 || _onCloseRef$current.call(onCloseRef, {
            reason: 'programmatic'
        });
    }, []);
    (0, $iUCre.useNotifyOpenLayerObserver)({
        type: role && $051a9d50aec333c1$var$POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen: isOpen,
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    var mode = modeProp === 'hint' && !$051a9d50aec333c1$var$supportsPopoverHint() ? 'auto' : modeProp;
    var popupMotionStyle = (0, $5FkrB.useMemo)(function() {
        if (!placement || !shouldAnimate) return undefined;
        var _resolvePlacement = (0, $6DtZS.resolvePlacement)({
            placement: placement
        }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge;
        return $051a9d50aec333c1$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]);
    // Tracks the close reason, including our own hidePopover() calls.
    var closeReasonRef = (0, $5FkrB.useRef)('light-dismiss');
    // Pre-open focus target, cleared before close when restoration is not eligible.
    var focusRestorationTargetRef = (0, $5FkrB.useRef)(null);
    var handleBeforeToggle = (0, $5FkrB.useCallback)(function(event) {
        var popover = event.currentTarget;
        if (!(popover instanceof HTMLElement)) return;
        var ownerDocument = popover.ownerDocument;
        var activeElement = ownerDocument.activeElement;
        if (event.newState === 'open') {
            focusRestorationTargetRef.current = activeElement instanceof HTMLElement ? activeElement : null;
            return;
        }
        /**
     * Like native restoration, leave external focus alone and skip light dismiss.
     * Check before closing so focus already on body is not mistaken for focus lost during close.
     * See https://html.spec.whatwg.org/multipage/popover.html#hide-popover-algorithm (step 20.2).
     */ if (closeReasonRef.current === 'light-dismiss' || !popover.contains(activeElement)) focusRestorationTargetRef.current = null;
    }, []);
    var handleToggleClosed = (0, $5FkrB.useCallback)(function(event) {
        var popover = event.currentTarget;
        if (!(popover instanceof HTMLElement)) return;
        var focusRestorationTarget = focusRestorationTargetRef.current;
        focusRestorationTargetRef.current = null;
        var reason = closeReasonRef.current;
        // Reset reason so a stale 'escape' from a race with Escape keydown
        // does not corrupt the next browser-dismiss cycle.
        closeReasonRef.current = 'light-dismiss';
        // Run after native restoration, before notifying the consumer, which may move focus itself.
        $051a9d50aec333c1$var$restoreFocus({
            popover: popover,
            focusRestorationTarget: focusRestorationTarget
        });
        // Programmatic closes are already known to the consumer.
        if (reason !== 'programmatic') {
            var _onCloseRef$current2;
            (_onCloseRef$current2 = onCloseRef.current) === null || _onCloseRef$current2 === void 0 || _onCloseRef$current2.call(onCloseRef, {
                reason: reason
            });
        }
    }, []);
    var _useAnimatedVisibilit = (0, $6sMtO.useAnimatedVisibility)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    }), phase = _useAnimatedVisibilit.phase, isMounted = _useAnimatedVisibilit.isMounted, onBeforeToggle = _useAnimatedVisibilit.onBeforeToggle, onToggle = _useAnimatedVisibilit.onToggle;
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // popovers are handled above via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus.md.
    (0, $3aj7x.useFocusWrap)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    (0, $ap8jH.useInitialFocus)({
        elementRef: ownRef,
        phase: phase,
        role: role
    });
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `focusRestorationTargetRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        var unbindEscape = (0, $7QpUe.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                // Ignore Escape events dispatched after native close.
                if (event.key === 'Escape' && (0, $gaaLe.isNativeElementOpen)({
                    element: element
                })) closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        var unbindToggle = (0, $7QpUe.bind)(element, {
            type: 'toggle',
            listener: function listener(event) {
                if (event.newState === 'closed') handleToggleClosed(event);
                onToggle(event);
            }
        });
        // Snapshot the active element before `useInitialFocus` moves it,
        // then advance the shared visibility lifecycle.
        var unbindBeforeToggle = (0, $7QpUe.bind)(element, {
            type: 'beforetoggle',
            listener: function listener(event) {
                handleBeforeToggle(event);
                onBeforeToggle(event);
            }
        });
        return function() {
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleBeforeToggle,
        handleToggleClosed,
        isMounted,
        onBeforeToggle,
        onToggle
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and interrupted close lifecycles may not reach
            // `handleToggleClosed` to reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch (_unused) {}
            return function() {
                closeReasonRef.current = 'programmatic';
                try {
                    element.hidePopover();
                } catch (_unused2) {}
            };
        }
        closeReasonRef.current = 'programmatic';
        try {
            element.hidePopover();
        } catch (_unused3) {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isMounted) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        ref: combinedRef,
        id: popoverId,
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        style: popupMotionStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $051a9d50aec333c1$var$styles.root,
            $051a9d50aec333c1$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $051a9d50aec333c1$var$styles.enter,
            shouldAnimate && phase === 'exiting' && $051a9d50aec333c1$var$styles.exit,
            shouldAnimate && $051a9d50aec333c1$var$styles.motion,
            (0, $hUFig.cx)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ])
    }, children);
});

});
parcelRegister("gaaLe", function(module, exports) {
$parcel$export(module.exports, "isNativeElementOpen", () => $bc45ed643a91f3f5$export$89b923e18c14644d);
function $bc45ed643a91f3f5$export$89b923e18c14644d(_ref) {
    var element = _ref.element;
    if (element instanceof HTMLDialogElement) return element.open;
    // Some DOM implementations throw for unsupported pseudo-classes.
    try {
        return element.matches(':popover-open');
    } catch (_unused) {
        return false;
    }
}

});

parcelRegister("6DtZS", function(module, exports) {
$parcel$export(module.exports, "resolvePlacement", () => $4d4da76463e3fc46$export$63044d21bc3d3fa2);

var $jSjqv = parcelRequire("jSjqv");
/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ var $4d4da76463e3fc46$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $4d4da76463e3fc46$export$63044d21bc3d3fa2(_ref) {
    var _placement$axis, _placement$edge, _placement$align, _placement$offset$gap, _placement$offset, _placement$offset$cro, _placement$offset2, _placement$offset$cro2, _placement$offset3;
    var placement = _ref.placement;
    return {
        axis: (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block',
        edge: (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end',
        align: (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center',
        // Not `??`: `undefined` must survive, so "not specified" stays
        // distinguishable from an explicit `0`.
        minSize: placement.minSize === undefined ? undefined : (0, $jSjqv.toCssLengthString)({
            value: placement.minSize
        }),
        offset: {
            gap: (0, $jSjqv.toCssLengthString)({
                value: (_placement$offset$gap = (_placement$offset = placement.offset) === null || _placement$offset === void 0 ? void 0 : _placement$offset.gap) !== null && _placement$offset$gap !== void 0 ? _placement$offset$gap : $4d4da76463e3fc46$var$DEFAULT_GAP
            }),
            crossAxisShift: {
                value: (0, $jSjqv.toCssLengthString)({
                    value: (_placement$offset$cro = (_placement$offset2 = placement.offset) === null || _placement$offset2 === void 0 || (_placement$offset2 = _placement$offset2.crossAxisShift) === null || _placement$offset2 === void 0 ? void 0 : _placement$offset2.value) !== null && _placement$offset$cro !== void 0 ? _placement$offset$cro : 0
                }),
                direction: (_placement$offset$cro2 = (_placement$offset3 = placement.offset) === null || _placement$offset3 === void 0 || (_placement$offset3 = _placement$offset3.crossAxisShift) === null || _placement$offset3 === void 0 ? void 0 : _placement$offset3.direction) !== null && _placement$offset$cro2 !== void 0 ? _placement$offset$cro2 : 'forwards'
            }
        }
    };
}

});
parcelRegister("jSjqv", function(module, exports) {
$parcel$export(module.exports, "toCssLengthString", () => $e782212d129da460$export$63b6b0ff65d84d47);
/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $e782212d129da460$export$63b6b0ff65d84d47(_ref) {
    var value = _ref.value;
    if (typeof value === 'number') return "".concat(value, "px");
    return value;
}

});


parcelRegister("6sMtO", function(module, exports) {
$parcel$export(module.exports, "useAnimatedVisibility", () => $4b4af6ac9c2b0d5c$export$1bccb45daf07907f);

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $gaaLe = parcelRequire("gaaLe");

var $ayeEN = parcelRequire("ayeEN");
function $4b4af6ac9c2b0d5c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4b4af6ac9c2b0d5c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4b4af6ac9c2b0d5c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4b4af6ac9c2b0d5c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4b4af6ac9c2b0d5c$var$runCancellableSettlement(_ref) {
    var schedule = _ref.schedule, onSettled = _ref.onSettled;
    var isCancelled = false;
    schedule(function() {
        if (isCancelled) return;
        onSettled();
    });
    return function() {
        // Prevent an interrupted or unmounted lifecycle from firing a stale callback.
        isCancelled = true;
    };
}
/**
 * Fires `onSettled` once all animations currently applied to `element`
 * finish or are cancelled. Returns a cleanup that prevents stale settlement.
 */ function $4b4af6ac9c2b0d5c$var$runOnAnimationsSettled(_ref2) {
    var element = _ref2.element, onSettled = _ref2.onSettled;
    return $4b4af6ac9c2b0d5c$var$runCancellableSettlement({
        onSettled: onSettled,
        schedule: function schedule(settle) {
            var _element$getAnimation, _element$getAnimation2;
            var animations = (_element$getAnimation = (_element$getAnimation2 = element.getAnimations) === null || _element$getAnimation2 === void 0 ? void 0 : _element$getAnimation2.call(element)) !== null && _element$getAnimation !== void 0 ? _element$getAnimation : [];
            Promise.allSettled(animations.map(function(animation) {
                return animation.finished;
            })).then(settle);
        }
    });
}
/**
 * Visibility lifecycle phase shared between `useAnimatedVisibility`,
 * `useFocusWrap`, `useInitialFocus`, and the `Popover` / `Dialog`
 * components.
 *
 * - `closed`: host element is unmounted. No DOM presence.
 * - `entering`: host element is mounted and the CSS entry transition
 *   is playing. **Only emitted when animation is enabled.** With
 *   animation disabled the lifecycle goes directly `closed → open`.
 * - `open`: host element is mounted and settled. No transition is
 *   playing.
 * - `exiting`: a native close has begun but the host element remains
 *   mounted. Usually this follows `isOpen` changing to `false`, but it can
 *   also begin with a browser-initiated dismissal while controlled intent
 *   is still open. With animation disabled, this phase lasts until the
 *   browser's closed `toggle` fires so native focus restoration can finish.
 *
 * State machine:
 * ```
 *   animation ON:   closed → entering → open → exiting → closed
 *   animation OFF:  closed →            open → exiting → closed
 *   interrupts:     entering → exiting (close mid-entry)
 *                   exiting  → entering (reopen mid-exit, animated)
 *                   exiting  → open     (reopen mid-handshake, non-animated)
 * ```
 */ function $4b4af6ac9c2b0d5c$var$getInitialVisibilityState(_ref3) {
    var isOpen = _ref3.isOpen, willAnimate = _ref3.willAnimate;
    if (!isOpen) return {
        phase: 'closed',
        controlledIntent: 'closed'
    };
    if (willAnimate) return {
        phase: 'entering',
        controlledIntent: 'open'
    };
    return {
        phase: 'open',
        controlledIntent: 'open'
    };
}
/**
 * Applies one lifecycle event to the current visibility phase.
 *
 * Events that are stale for the current phase are ignored. This allows
 * animation callbacks and native close events to settle safely after an
 * interrupted lifecycle.
 */ function $4b4af6ac9c2b0d5c$var$getNextVisibilityState(state, action) {
    if (action.type === 'open-requested') {
        var shouldEnter = state.phase === 'closed' || state.phase === 'exiting' && state.controlledIntent === 'closed';
        if (shouldEnter && action.willAnimate) return {
            phase: 'entering',
            controlledIntent: 'open'
        };
        if (shouldEnter) return {
            phase: 'open',
            controlledIntent: 'open'
        };
        return $4b4af6ac9c2b0d5c$var$_objectSpread($4b4af6ac9c2b0d5c$var$_objectSpread({}, state), {}, {
            controlledIntent: 'open'
        });
    }
    if (action.type === 'close-requested') return $4b4af6ac9c2b0d5c$var$_objectSpread($4b4af6ac9c2b0d5c$var$_objectSpread({}, state), {}, {
        controlledIntent: 'closed'
    });
    if (action.type === 'exit-started') {
        if (state.phase !== 'open' && state.phase !== 'entering') return state;
        return $4b4af6ac9c2b0d5c$var$_objectSpread($4b4af6ac9c2b0d5c$var$_objectSpread({}, state), {}, {
            phase: 'exiting'
        });
    }
    if (action.type === 'entry-settled') {
        if (state.phase !== 'entering') return state;
        return $4b4af6ac9c2b0d5c$var$_objectSpread($4b4af6ac9c2b0d5c$var$_objectSpread({}, state), {}, {
            phase: 'open'
        });
    }
    if (action.type === 'exit-settled') {
        if (state.phase !== 'exiting') return state;
        return $4b4af6ac9c2b0d5c$var$_objectSpread($4b4af6ac9c2b0d5c$var$_objectSpread({}, state), {}, {
            phase: 'closed'
        });
    }
    return state;
}
function $4b4af6ac9c2b0d5c$export$1bccb45daf07907f(_ref4) {
    var isOpen = _ref4.isOpen, shouldAnimate = _ref4.shouldAnimate, elementRef = _ref4.elementRef, onEnterFinish = _ref4.onEnterFinish, onExitFinish = _ref4.onExitFinish;
    var willAnimate = shouldAnimate && !(0, $ayeEN.prefersReducedMotion)();
    var _useReducer = (0, $5FkrB.useReducer)($4b4af6ac9c2b0d5c$var$getNextVisibilityState, {
        isOpen: isOpen,
        willAnimate: willAnimate
    }, $4b4af6ac9c2b0d5c$var$getInitialVisibilityState), _useReducer2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useReducer, 2), visibilityState = _useReducer2[0], dispatch = _useReducer2[1];
    var phase = visibilityState.phase, controlledIntent = visibilityState.controlledIntent;
    // Keep stable refs to the latest callbacks so effects and animation settlement closures
    // always call the current callback without needing them in dependency arrays.
    var onEnterFinishRef = (0, $5FkrB.useRef)(onEnterFinish);
    var onExitFinishRef = (0, $5FkrB.useRef)(onExitFinish);
    var willAnimateRef = (0, $5FkrB.useRef)(willAnimate);
    (0, $5FkrB.useLayoutEffect)(function() {
        onEnterFinishRef.current = onEnterFinish;
        onExitFinishRef.current = onExitFinish;
        willAnimateRef.current = willAnimate;
    }, [
        onEnterFinish,
        onExitFinish,
        willAnimate
    ]);
    // Synchronize controlled intent during render so opening mounts the host in
    // the same commit. Keeping the processed intent in reducer state prevents a
    // browser-driven exit from being mistaken for a new controlled open request.
    if (isOpen && controlledIntent === 'closed') dispatch({
        type: 'open-requested',
        willAnimate: willAnimate
    });
    if (!isOpen && controlledIntent === 'open') dispatch({
        type: 'close-requested'
    });
    // Entry can commit `open` before its callback because the host stays mounted.
    // This ensures consumers observe the settled DOM rather than entering styles.
    // Treat the phase before the initial commit as closed so an initially open host
    // notifies consumers.
    var prevPhaseRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        if (prevPhase === phase) return;
        if (phase === 'open') {
            var _onEnterFinishRef$cur;
            (_onEnterFinishRef$cur = onEnterFinishRef.current) === null || _onEnterFinishRef$cur === void 0 || _onEnterFinishRef$cur.call(onEnterFinishRef);
        }
    }, [
        phase
    ]);
    var isMounted = phase !== 'closed';
    var cancelExitSettlementRef = (0, $5FkrB.useRef)(function() {});
    // Exit must notify consumers before `closed` unmounts the host.
    var settleExit = (0, $5FkrB.useCallback)(function() {
        var _onExitFinishRef$curr;
        (_onExitFinishRef$curr = onExitFinishRef.current) === null || _onExitFinishRef$curr === void 0 || _onExitFinishRef$curr.call(onExitFinishRef);
        dispatch({
            type: 'exit-settled'
        });
    }, []);
    // Primitives bind these stable callbacks to their native lifecycle events.
    // This keeps event ownership at the primitive while the hook owns state transitions.
    var onBeforeToggle = (0, $5FkrB.useCallback)(function(event) {
        // Any native transition supersedes a previous exit snapshot. This prevents
        // a stale settlement from closing a host that is reopening or closing again.
        cancelExitSettlementRef.current();
        // Snapshot currentTarget because the DOM clears it after event dispatch.
        var element = event.currentTarget;
        if (event.newState === 'open' && element instanceof HTMLElement) {
            element.removeAttribute('inert');
            element.removeAttribute('aria-hidden');
        }
        if (event.newState === 'closed') {
            if (element instanceof HTMLElement) // We use a microtask to let native focus restoration happen before making the element inert.
            // The browser restores focus after beforetoggle returns, during its close steps.
            queueMicrotask(function() {
                // A controlled close can be interrupted by isOpen changing back to true,
                // which reopens the element before this microtask runs.
                if ((0, $gaaLe.isNativeElementOpen)({
                    element: element
                })) return;
                // Exit animations keep closed content rendered, so make it non-interactive and hide it from assistive technology.
                element.setAttribute('inert', '');
                // Tooling does not consistently treat inert content as hidden, even though the browser does.
                element.setAttribute('aria-hidden', 'true');
            });
            dispatch({
                type: 'exit-started'
            });
        }
    }, []);
    var onToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState !== 'closed') return;
        if (!willAnimateRef.current) {
            cancelExitSettlementRef.current = $4b4af6ac9c2b0d5c$var$runCancellableSettlement({
                schedule: queueMicrotask,
                onSettled: settleExit
            });
            return;
        }
        var element = elementRef.current;
        if (!element) return;
        // The closed `toggle` is task-queued after synchronous `beforetoggle`.
        // Snapshot here so the exiting phase styles have committed and the list
        // represents the animations that actually govern exit settlement.
        cancelExitSettlementRef.current = $4b4af6ac9c2b0d5c$var$runOnAnimationsSettled({
            element: element,
            onSettled: settleExit
        });
    }, [
        elementRef,
        settleExit
    ]);
    (0, $5FkrB.useLayoutEffect)(function() {
        return function() {
            // Prevent a pending animation or microtask from notifying after unmount.
            cancelExitSettlementRef.current();
        };
    }, []);
    // Entry settlement only removes entering styles. Its callback runs after the
    // resulting `open` commit in the effect above.
    (0, $5FkrB.useEffect)(function settleEntry() {
        if (phase !== 'entering') return;
        if (!willAnimate) {
            dispatch({
                type: 'entry-settled'
            });
            return;
        }
        var element = elementRef.current;
        if (!element) return;
        return $4b4af6ac9c2b0d5c$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                dispatch({
                    type: 'entry-settled'
                });
            }
        });
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    return {
        phase: phase,
        isMounted: isMounted,
        onBeforeToggle: onBeforeToggle,
        onToggle: onToggle
    };
}

});
parcelRegister("ayeEN", function(module, exports) {
$parcel$export(module.exports, "prefersReducedMotion", () => $7ae872ecb3ab26e9$export$ff7706047246b98b);

var $bvsoE = parcelRequire("bvsoE");
var $7ae872ecb3ab26e9$export$ff7706047246b98b = (0, $bvsoE.default)(function() {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});

});


parcelRegister("3aj7x", function(module, exports) {
$parcel$export(module.exports, "useFocusWrap", () => $24e12333f089bf31$export$4f6462e86a70abe5);

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $3EcAc = parcelRequire("3EcAc");

var $5YdlV = parcelRequire("5YdlV");

var $7KwSu = parcelRequire("7KwSu");

var $guKLp = parcelRequire("guKLp");
/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/outputs/menu-keyboard-decision.md
 */ function $24e12333f089bf31$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $24e12333f089bf31$export$4f6462e86a70abe5(_ref) {
    var elementRef = _ref.elementRef, role = _ref.role, phase = _ref.phase;
    var isVisible = phase !== 'closed';
    (0, $5FkrB.useEffect)(function() {
        var element = elementRef.current;
        if (!element || !$24e12333f089bf31$var$roleRequiresFocusWrap(role) || !isVisible) return;
        var unbind = (0, $7QpUe.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $guKLp.isNestedLayerFocused)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                var direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                var next = (0, $7KwSu.getNextFocusable)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                var fallback = direction === 'forwards' ? (0, $3EcAc.getFirstFocusable)({
                    container: element
                }) : (0, $5YdlV.getLastFocusable)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}

});
parcelRegister("3EcAc", function(module, exports) {
$parcel$export(module.exports, "getFirstFocusable", () => $2a7ede3bbfccf375$export$748138f04a69bf21);

var $eteCC = parcelRequire("eteCC");
function $2a7ede3bbfccf375$export$748138f04a69bf21(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $eteCC.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}

});
parcelRegister("eteCC", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $a88f1db9098ec519$export$f6768025e418420e);

var $3WOJ5 = parcelRequire("3WOJ5");
var $a88f1db9098ec519$var$focusableExclusions = [
    '[tabindex="-1"]',
    ':disabled',
    '[aria-disabled="true"]',
    '[aria-hidden="true"]'
];
var $a88f1db9098ec519$var$exclusionSelector = $a88f1db9098ec519$var$focusableExclusions.map(function(selector) {
    return ":not(".concat(selector, ")");
}).join('');
var $a88f1db9098ec519$var$focusableSelector = [
    'a[href]',
    'area[href]',
    'input:not([type="hidden"])',
    'select',
    'textarea',
    'button',
    'iframe',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])',
    '[tabindex]'
].map(function(selector) {
    return "".concat(selector).concat($a88f1db9098ec519$var$exclusionSelector);
}).join(',');
function $a88f1db9098ec519$var$isVisible(element) {
    // Visibility filtering must not break focus navigation when the API is unsupported.
    if (typeof element.checkVisibility !== 'function') return true;
    try {
        // Exclude elements hidden by display, content-visibility or visibility because
        // they cannot receive focus. Offscreen, occluded and opacity-zero elements can
        // receive focus, so they intentionally remain included.
        return element.checkVisibility({
            checkVisibilityCSS: true
        });
    } catch (_unused) {
        return true;
    }
}
function $a88f1db9098ec519$export$f6768025e418420e(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var containerLayer = (0, $3WOJ5.getClosestLayer)({
        element: container
    });
    return Array.from(container.querySelectorAll($a88f1db9098ec519$var$focusableSelector)).filter(function(element) {
        if (!(element instanceof HTMLElement)) return false;
        if ((0, $3WOJ5.getClosestLayer)({
            element: element
        }) !== containerLayer) return false;
        if (element.closest('[inert]')) return false;
        if (!$a88f1db9098ec519$var$isVisible(element)) return false;
        return !filter || filter(element, container);
    });
}

});
parcelRegister("3WOJ5", function(module, exports) {
$parcel$export(module.exports, "getClosestLayer", () => $2dfe230a25f658cd$export$3c9385904be131db);
function $2dfe230a25f658cd$export$3c9385904be131db(_ref) {
    var element = _ref.element;
    return element.closest('[popover], dialog');
}

});



parcelRegister("5YdlV", function(module, exports) {
$parcel$export(module.exports, "getLastFocusable", () => $458ce9ed11383167$export$73e81fa65335a75b);

var $eteCC = parcelRequire("eteCC");
function $458ce9ed11383167$export$73e81fa65335a75b(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $eteCC.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}

});

parcelRegister("7KwSu", function(module, exports) {
$parcel$export(module.exports, "getNextFocusable", () => $5a4655208d536a2f$export$a7db88e6d491b450);
/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * The currently focused element does not need to be tabbable. This prevents
 * navigation from getting stuck on an element that was programmatically or
 * pointer focused with `tabindex="-1"`. Negative-tab-index elements remain
 * excluded as destinations.
 *
 * Returns `null` if there is no focused element within the container.
 */ 
var $eteCC = parcelRequire("eteCC");
function $5a4655208d536a2f$export$a7db88e6d491b450(_ref) {
    var _all3;
    var container = _ref.container, direction = _ref.direction, filter = _ref.filter;
    var all = (0, $eteCC.getFocusables)({
        container: container,
        filter: filter
    });
    var first = all[0];
    var last = all[all.length - 1];
    // Checking the elements directly narrows types from `HTMLElement | undefined`.
    if (!first || !last) return null;
    var current = container.ownerDocument.activeElement;
    if (!(current instanceof HTMLElement) || !container.contains(current)) return null;
    var index = all.indexOf(current);
    // The focused element can be absent from `all` when it is non-tabbable or
    // excluded by the filter. Find the first focusable element that follows it in
    // the DOM, which identifies the nearest focusable destination in either direction.
    if (index === -1) {
        var _all;
        var followingIndex = all.findIndex(function(element) {
            return Boolean(current.compareDocumentPosition(element) & current.DOCUMENT_POSITION_FOLLOWING);
        });
        if (direction === 'forwards') {
            var _all$followingIndex;
            // If nothing follows the current element, then wrap to the start.
            return (_all$followingIndex = all[followingIndex]) !== null && _all$followingIndex !== void 0 ? _all$followingIndex : first;
        }
        // The closest preceding element is immediately before the first following one.
        // A missing adjacent entry means the backward sequence wraps to the end.
        return (_all = all[followingIndex - 1]) !== null && _all !== void 0 ? _all : last;
    }
    // The current element is tabbable, so use its adjacent list entry and wrap
    // when it is already at the boundary.
    if (direction === 'forwards') {
        var _all2;
        return (_all2 = all[index + 1]) !== null && _all2 !== void 0 ? _all2 : first;
    }
    return (_all3 = all[index - 1]) !== null && _all3 !== void 0 ? _all3 : last;
}

});

parcelRegister("guKLp", function(module, exports) {
$parcel$export(module.exports, "isNestedLayerFocused", () => $c023b8f76ff8f0f2$export$b9590fdfeb5f722f);

var $3WOJ5 = parcelRequire("3WOJ5");
function $c023b8f76ff8f0f2$export$b9590fdfeb5f722f(_ref) {
    var container = _ref.container;
    var focused = container.ownerDocument.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return (0, $3WOJ5.getClosestLayer)({
        element: focused
    }) !== (0, $3WOJ5.getClosestLayer)({
        element: container
    });
}

});


parcelRegister("ap8jH", function(module, exports) {
$parcel$export(module.exports, "useInitialFocus", () => $7932b0b4500a320e$export$e992c40175757a22);

var $5FkrB = parcelRequire("5FkrB");

var $3EcAc = parcelRequire("3EcAc");
/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox regardless of role. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, or menu), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
var $7932b0b4500a320e$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $7932b0b4500a320e$var$isTextboxLikeElement(element) {
    var role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    var tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        var _element$getAttribute;
        var type = ((_element$getAttribute = element.getAttribute('type')) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : 'text').toLowerCase();
        return $7932b0b4500a320e$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $7932b0b4500a320e$var$isComboboxControllingPopup(_ref) {
    var _active$getAttribute;
    var container = _ref.container;
    var ownerDocument = container.ownerDocument;
    var active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$7932b0b4500a320e$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    var idRefs = (_active$getAttribute = active.getAttribute('aria-controls')) !== null && _active$getAttribute !== void 0 ? _active$getAttribute : active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    var referencedIds = idRefs.split(/\s+/).filter(function(id) {
        return id !== '';
    });
    return referencedIds.some(function(id) {
        var referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function $7932b0b4500a320e$var$getInitialFocusTarget(_ref2) {
    var container = _ref2.container, role = _ref2.role;
    if (role === 'dialog' || role === 'alertdialog') {
        // Prefer element with the native HTML autofocus attribute.
        var autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $3EcAc.getFirstFocusable)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific (menu / listbox) rather
    // than hoisted. Hoisting it over-matched on dialog popups that contain
    // a nested combobox (e.g. datetime-picker's dialog hosts a react-select),
    // where the active combobox's `aria-controls` falsely matched the
    // container and suppressed the dialog's own focus contract.
    if (role === 'menu') {
        if ($7932b0b4500a320e$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/outputs/menu-keyboard-decision.md
        return (0, $3EcAc.getFirstFocusable)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($7932b0b4500a320e$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        var selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        var firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $3EcAc.getFirstFocusable)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $7932b0b4500a320e$export$e992c40175757a22(_ref3) {
    var elementRef = _ref3.elementRef, phase = _ref3.phase, role = _ref3.role;
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    var prevPhaseRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var _getInitialFocusTarge;
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        var element = elementRef.current;
        if (!element) return;
        (_getInitialFocusTarge = $7932b0b4500a320e$var$getInitialFocusTarget({
            container: element,
            role: role
        })) === null || _getInitialFocusTarge === void 0 || _getInitialFocusTarge.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}

});


parcelRegister("crjjC", function(module, exports) {
$parcel$export(module.exports, "PopoverSurface", () => $90e6fd4ff800cdc4$export$8b7437164e479115);
/* popover-surface.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $90e6fd4ff800cdc4$var$styles = {
    root: "_2rkofajl _1reo1wug _18m91wug _bfhk1bhr _syazi7uo _16qs130s"
};
function $90e6fd4ff800cdc4$export$8b7437164e479115(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            $90e6fd4ff800cdc4$var$styles.root
        ])
    }, children);
}

});

parcelRegister("lESsq", function(module, exports) {
$parcel$export(module.exports, "useAnchoredPopover", () => $fc479381e0d3888b$export$147d8888d96bf7a3);
/**
 * Positioning AND anchor-relative sizing for top-layer popovers. Anchors an
 * ELEMENT; to anchor a viewport coordinate use `useAnchoredPopoverAtPoint`.
 *
 * Two runtime paths, each a function that applies its styles and returns the
 * cleanup: CSS Anchor Positioning in `./anchor-positioning`, and the JavaScript
 * fallback in `./javascript-fallback`. The path is resolved ONCE, at the top of
 * the hook, and threaded through positioning, sizing and margins.
 *
 * See `notes/architecture/positioning.md` and
 * `notes/decisions/fit-available-space.md`.
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $h8qvJ = parcelRequire("h8qvJ");

var $fEcue = parcelRequire("fEcue");

var $cbNlA = parcelRequire("cbNlA");

var $bptRk = parcelRequire("bptRk");

var $6DtZS = parcelRequire("6DtZS");

var $8wATx = parcelRequire("8wATx");

var $8Hx58 = parcelRequire("8Hx58");
/**
 * Which way the popover's inline axis runs. Maps every physical measurement below
 * onto a logical axis: the viewport unit of each cap and the anchor's measured
 * size. A style read, not a layout read, so it is cheap enough to take for every
 * popover.
 */ function $fc479381e0d3888b$var$getPopoverWritingMode(_ref) {
    var popover = _ref.popover;
    // `String()` because not every test environment implements `writing-mode`.
    var writingMode = String(getComputedStyle(popover).writingMode);
    var isVertical = writingMode.startsWith('vertical') || writingMode.startsWith('sideways');
    return isVertical ? 'vertical' : 'horizontal';
}
/**
 * Measured stand-in for `anchor-size(self-*)`, used wherever `anchor-size()` is
 * not: the JavaScript fallback, and browsers with anchor positioning but no
 * `anchor-size()`.
 *
 * `offsetWidth` / `offsetHeight` are physical, so the axis is picked from the
 * POPOVER's `writing-mode`. Deliberately not memoized: a cached anchor size is a
 * stale one. Runs once per effect, not per frame.
 */ function $fc479381e0d3888b$var$measureAnchorSize(_ref2) {
    var anchor = _ref2.anchor, writingMode = _ref2.writingMode;
    if (writingMode === 'vertical') return {
        inline: "".concat(anchor.offsetHeight, "px"),
        block: "".concat(anchor.offsetWidth, "px")
    };
    return {
        inline: "".concat(anchor.offsetWidth, "px"),
        block: "".concat(anchor.offsetHeight, "px")
    };
}
var $fc479381e0d3888b$var$NO_ANCHOR_SIZE = {
    inline: null,
    block: null
};
var $fc479381e0d3888b$var$CSS_ANCHOR_SIZE = {
    inline: 'anchor-size(self-inline)',
    block: 'anchor-size(self-block)'
};
function $fc479381e0d3888b$var$isAnchorRelative(size) {
    return size === 'match-anchor' || size === 'min-anchor';
}
/**
 * The `anchor-name` written to an anchor that does not already carry one, as a CSS
 * `<dashed-ident>`. `useId()` is the same source as every other id in the design
 * system, including the popover's own `id` that `aria-controls` and `popovertarget`
 * point at, so it is unique exactly where those are and collides exactly where
 * they do. See `useAnchoredPopover` for the one case that needs the host's help.
 *
 * `@atlaskit/ds-lib`'s `useId` already swaps React's `:` and `«»` for `_`. The
 * replace covers a host `identifierPrefix`, which may carry characters a
 * `<dashed-ident>` cannot.
 */ function $fc479381e0d3888b$var$useNewAnchorName() {
    var id = (0, $h8qvJ.useId)();
    return (0, $5FkrB.useMemo)(function() {
        return "--anchor-".concat(id.replace(/[^A-Za-z0-9_-]/g, '_'));
    }, [
        id
    ]);
}
/**
 * A referentially-stable, fully-resolved `TPlacement`, so a fresh inline
 * `placement` object does not re-run the effect.
 */ function $fc479381e0d3888b$var$useStablePlacement(placement) {
    var resolved = (0, $6DtZS.resolvePlacement)({
        placement: placement
    });
    var axis = resolved.axis;
    var edge = resolved.edge;
    var align = resolved.align;
    var minSize = resolved.minSize;
    var gap = resolved.offset.gap;
    var shiftValue = resolved.offset.crossAxisShift.value;
    var shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuilt from primitive deps, so the factory does not close over `resolved`
    // and exhaustive-deps can verify it.
    return (0, $5FkrB.useMemo)(function() {
        return {
            axis: axis,
            edge: edge,
            align: align,
            minSize: minSize,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        };
    }, [
        axis,
        edge,
        align,
        minSize,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $fc479381e0d3888b$export$147d8888d96bf7a3(_ref3) {
    var anchorRef = _ref3.anchorRef, popoverRef = _ref3.popoverRef, placement = _ref3.placement, isOpen = _ref3.isOpen, _ref3$isEnabled = _ref3.isEnabled, isEnabled = _ref3$isEnabled === void 0 ? true : _ref3$isEnabled, _ref3$inlineSize = _ref3.inlineSize, inlineSize = _ref3$inlineSize === void 0 ? 'content' : _ref3$inlineSize, _ref3$blockSize = _ref3.blockSize, blockSize = _ref3$blockSize === void 0 ? 'content' : _ref3$blockSize, _ref3$shouldPreserveI = _ref3.shouldPreserveInlineSize, shouldPreserveInlineSize = _ref3$shouldPreserveI === void 0 ? false : _ref3$shouldPreserveI, _ref3$forceFallbackPo = _ref3.forceFallbackPositioning, forceFallbackPositioning = _ref3$forceFallbackPo === void 0 ? false : _ref3$forceFallbackPo;
    // Stable for the life of the hook instance, so it follows a replacement anchor
    // element (the point hook remounts its `<div>`).
    var fallbackAnchorName = $fc479381e0d3888b$var$useNewAnchorName();
    var stablePlacement = $fc479381e0d3888b$var$useStablePlacement(placement);
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!isEnabled) return;
        // Resolved once, so positioning, sizing and margins cannot disagree about it.
        var isUsingCssAnchorPositioning = (0, $8wATx.supportsAnchorPositioning)() && !forceFallbackPositioning;
        // BOTH probes: a browser can have positioning without sizing, and
        // `anchor-size()` needs the `position-anchor` only the CSS path writes.
        var canUseAnchorSize = isUsingCssAnchorPositioning && (0, $8Hx58.supportsAnchorSize)();
        var trigger = anchorRef.current;
        var popover = popoverRef.current;
        if (!trigger || !popover) return;
        // Fitting also reserves padding from the viewport edge as a margin.
        var isFitting = inlineSize === 'max-available' || blockSize === 'max-available';
        // Always read: the viewport caps are always written, and their unit follows
        // the popover's writing mode.
        var writingMode = $fc479381e0d3888b$var$getPopoverWritingMode({
            popover: popover
        });
        // Skipped where possible, so a position-only consumer pays no layout read.
        // Fitting on the CSS path needs it to clamp the default flip floor; see
        // `getDefaultPlacementAxisFloor`.
        var needsAnchorSize = $fc479381e0d3888b$var$isAnchorRelative(inlineSize) || $fc479381e0d3888b$var$isAnchorRelative(blockSize) || isFitting && isUsingCssAnchorPositioning;
        var anchorSize = needsAnchorSize ? canUseAnchorSize ? $fc479381e0d3888b$var$CSS_ANCHOR_SIZE : $fc479381e0d3888b$var$measureAnchorSize({
            anchor: trigger,
            writingMode: writingMode
        }) : $fc479381e0d3888b$var$NO_ANCHOR_SIZE;
        var sizeStyles = (0, $cbNlA.getAnchoredPopoverSizeDeclarations)({
            placement: stablePlacement,
            inlineSize: inlineSize,
            blockSize: blockSize,
            isUsingCssAnchorPositioning: isUsingCssAnchorPositioning,
            anchorSize: anchorSize,
            writingMode: writingMode,
            shouldPreserveInlineSize: shouldPreserveInlineSize
        });
        if (isUsingCssAnchorPositioning) return (0, $fEcue.applyAnchorPositioning)({
            anchor: trigger,
            popover: popover,
            placement: stablePlacement,
            sizeStyles: sizeStyles,
            isFitting: isFitting,
            fallbackAnchorName: fallbackAnchorName
        });
        return (0, $bptRk.applyJavaScriptFallbackPositioning)({
            anchor: trigger,
            popover: popover,
            placement: stablePlacement,
            sizeStyles: sizeStyles
        });
    }, [
        isEnabled,
        anchorRef,
        popoverRef,
        stablePlacement,
        inlineSize,
        blockSize,
        shouldPreserveInlineSize,
        fallbackAnchorName,
        forceFallbackPositioning,
        isOpen
    ]);
}

});
parcelRegister("fEcue", function(module, exports) {
$parcel$export(module.exports, "applyAnchorPositioning", () => $b64447054e17c0a1$export$50da8074e1408934);

var $fC8ib = parcelRequire("fC8ib");

var $92ZkI = parcelRequire("92ZkI");

var $lQVBN = parcelRequire("lQVBN");

var $fbTJ8 = parcelRequire("fbTJ8");

var $bBVZn = parcelRequire("bBVZn");

var $lOeDc = parcelRequire("lOeDc");

var $atUBI = parcelRequire("atUBI");

var $iFgHX = parcelRequire("iFgHX");
function $b64447054e17c0a1$export$50da8074e1408934(_ref) {
    var anchor = _ref.anchor, popover = _ref.popover, placement = _ref.placement, sizeStyles = _ref.sizeStyles, isFitting = _ref.isFitting, fallbackAnchorName = _ref.fallbackAnchorName;
    // Reuse rather than mint: another popover may already be anchored to it, or a
    // CONSUMER may have set it on their own element, as `post-office` does.
    var existingAnchorName = (0, $lOeDc.getExistingAnchorName)(anchor);
    var anchorName = existingAnchorName !== null && existingAnchorName !== void 0 ? existingAnchorName : fallbackAnchorName;
    var gap = (0, $fbTJ8.edgeMargin)({
        placement: placement,
        offset: placement.offset.gap
    });
    var crossAxisShift = (0, $lQVBN.crossAxisShiftMargins)({
        placement: placement,
        crossAxisShiftCssValue: placement.offset.crossAxisShift.value,
        direction: placement.offset.crossAxisShift.direction
    });
    var popoverStyles = [
        {
            property: 'position-anchor',
            value: anchorName
        },
        {
            property: 'position-area',
            value: (0, $atUBI.placementToPositionArea)({
                placement: placement
            })
        },
        {
            property: 'position-try-fallbacks',
            value: (0, $iFgHX.placementToTryFallbacks)({
                placement: placement
            })
        },
        /**
   * **`position-visibility: always`**
   *
   * `position-visibility` is used to control the visibility of an anchored
   * popover based on the visibility of the element being anchored to (the target).
   *
   * Default `position-visibility` value: `anchors-visible` → hide the anchored
   * popover when the target is fully clipped by an ancestor (eg a scroll container)
   * or is `visibility:hidden`.
   * Sadly this "automatic hiding" does not actually "close" the popover,
   * so things like `:popover-open` are still active, even though the popover
   * is no longer painted and no longer receives pointer input. Chrome keeps it
   * focusable and in the accessibility tree, so keyboard and screen reader users
   * can still land inside a surface that is not painted.
   * Per-engine behaviour: `notes/decisions/position-visibility-always.md`.
   *
   * Generally we have not run into issues with the default (`anchors-visible`)
   *
   * Exceptions:
   *  - Target is intentionally not visible (eg `position:absolute` moving it outside of
   *    its parent's "clipped boundary", or a `visibility:hidden` trigger)
   *  - A trigger is scrolled out of its scroll container while the popover is open.
   *
   * We are switching from `anchors-visible` → `always` _for now_ to force no
   * automatic hiding of the popover. There seems to be no compelling reason to use
   * the default value. If one arises in the future, we could look towards making
   *  this behaviour configurable.
   */ {
            property: 'position-visibility',
            value: 'always'
        },
        // Reset browser default popover positioning that conflicts
        // with anchor positioning (UA: `inset: 0; margin: auto;`)
        {
            property: 'margin',
            value: '0'
        },
        {
            property: 'inset',
            value: 'auto'
        },
        gap
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(isFitting ? (0, $bBVZn.getFitMarginDeclarations)({
        placement: placement,
        crossAxisShiftMargins: crossAxisShift
    }) : crossAxisShift), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sizeStyles));
    // Anchor names are never cleaned up: multiple popovers can share an anchor,
    // and even with reference counting an async React update could remove the name
    // while something else still uses it. See
    // `notes/decisions/anchor-name-lifetime.md`. Only written when minted: a name
    // from a stylesheet may be a list, which an inline copy of its first entry
    // would collapse.
    if (existingAnchorName === null) anchor.style.setProperty('anchor-name', anchorName);
    return (0, $92ZkI.setStyle)({
        element: popover,
        styles: popoverStyles
    });
}

});
parcelRegister("92ZkI", function(module, exports) {
$parcel$export(module.exports, "setStyle", () => $6963e0745334af6c$export$37a5fde709c1db82);
/**
 * A single inline style declaration.
 *
 * `TProperty` narrows the property name for callers that write a known, closed
 * set of properties. Narrowing it lets a record keyed on those same names be
 * checked for exhaustiveness at compile time, rather than silently resolving to
 * `undefined` for a name that was never mapped.
 */ /**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 */ function $6963e0745334af6c$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

});

parcelRegister("lQVBN", function(module, exports) {
$parcel$export(module.exports, "crossAxisShiftMargins", () => $fe8b242b38967a1f$export$f7505ccec0897ae3);
/**
 * The cross-axis shift, written antisymmetrically on BOTH cross-axis sides rather
 * than as one margin. Do not collapse it to one side: a single margin widens the
 * margin box, so `anchor-center` displaces the border box by only half the value,
 * a `<position-area>` fallback sliding across the cross axis drops it entirely,
 * and the widened box changes where the popover is judged to overflow.
 *
 * A positive value always moves the popover toward the cross-axis END, so
 * `direction: 'forwards'` means the same thing for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 */ function $fe8b242b38967a1f$export$f7505ccec0897ae3(_ref) {
    var placement = _ref.placement, crossAxisShiftCssValue = _ref.crossAxisShiftCssValue, direction = _ref.direction;
    var crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    // `calc()` rather than JavaScript math, so opaque values such as design tokens
    // negate correctly.
    var negated = "calc(-1 * ".concat(crossAxisShiftCssValue, ")");
    var isForwards = direction === 'forwards';
    return [
        {
            property: "margin-".concat(crossAxis, "-start"),
            value: isForwards ? crossAxisShiftCssValue : negated
        },
        {
            property: "margin-".concat(crossAxis, "-end"),
            value: isForwards ? negated : crossAxisShiftCssValue
        }
    ];
}

});

parcelRegister("fbTJ8", function(module, exports) {
$parcel$export(module.exports, "edgeMargin", () => $b0f31c552b40e9ad$export$b94d052c6b40496);
/**
 * The margin that creates the gap between the popover and its anchor.
 */ function $b0f31c552b40e9ad$export$b94d052c6b40496(_ref) {
    var placement = _ref.placement, offset = _ref.offset;
    var axis = placement.axis, edge = placement.edge;
    // The side FACING the anchor is always opposite the placement edge.
    var anchorFacingEdge = edge === 'end' ? 'start' : 'end';
    return {
        property: "margin-".concat(axis, "-").concat(anchorFacingEdge),
        value: offset
    };
}

});

parcelRegister("bBVZn", function(module, exports) {
$parcel$export(module.exports, "getFitMarginDeclarations", () => $874021d3dc602aeb$export$a7ffde4a856e8d8e);

var $fC8ib = parcelRequire("fC8ib");

var $cbNlA = parcelRequire("cbNlA");
/**
 * Every logical margin property the fit recipe can write. Declared here and
 * imported by `edge-margin.tsx` and `cross-axis-shift-margins.tsx`: two
 * structurally identical declarations are interchangeable to the compiler, so a
 * divergence would surface only as a silently-ignored property name at
 * `setStyle`.
 */ /**
 * The cross-axis sides that face the viewport rather than the anchor, and so take
 * the reserved padding.
 *
 * A `span-*` cell aligns the popover's MARGIN box to the anchor's edge, so padding
 * on the anchor-facing side does not reserve space at the viewport: it insets the
 * border box from the edge the consumer asked it to line up with. A centred
 * popover has no anchor-facing side, and padding both keeps the shift pair
 * antisymmetric so `anchor-center` still centres.
 *
 * Known cost: the slide fallbacks do not swap the inline margins the way
 * `flip-inline` does, so a slid popover keeps its padding on the anchor side (or,
 * re-centred, sits 2.5px off centre). Alignment in the requested position wins.
 */ function $874021d3dc602aeb$var$viewportFacingCrossAxisSides(_ref) {
    var align = _ref.align;
    if (align === 'center') return [
        'start',
        'end'
    ];
    // `align: 'start'` sits on the anchor's start edge and expands toward end.
    return [
        align === 'start' ? 'end' : 'start'
    ];
}
function $874021d3dc602aeb$export$a7ffde4a856e8d8e(_ref2) {
    var placement = _ref2.placement, crossAxisShiftMargins = _ref2.crossAxisShiftMargins;
    var crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    var paddedProperties = new Set($874021d3dc602aeb$var$viewportFacingCrossAxisSides({
        align: placement.align
    }).map(function(side) {
        return "margin-".concat(crossAxis, "-").concat(side);
    }));
    return [
        {
            property: "margin-".concat(placement.axis, "-").concat(placement.edge),
            value: (0, $cbNlA.VIEWPORT_PADDING)
        }
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(crossAxisShiftMargins.map(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        return paddedProperties.has(property) ? {
            property: property,
            value: "calc(".concat(value, " + ").concat((0, $cbNlA.VIEWPORT_PADDING), ")")
        } : {
            property: property,
            value: value
        };
    })));
}

});
parcelRegister("cbNlA", function(module, exports) {
$parcel$export(module.exports, "VIEWPORT_PADDING", () => $8dfcca713866dcbf$export$9f2fdbacbc62226e);
$parcel$export(module.exports, "getAnchoredPopoverSizeDeclarations", () => $8dfcca713866dcbf$export$860b30329fa0b990);
/**
 * The space kept clear between a popover and the viewport edge. Matches legacy
 * `@atlaskit/popper`'s `preventOverflow` padding of `5`.
 */ var $8dfcca713866dcbf$export$9f2fdbacbc62226e = '5px';
var $8dfcca713866dcbf$export$32ab78b2bb853a01 = '150px';
/**
 * Which way the POPOVER's inline axis runs; `'vertical'` covers the `vertical-*`
 * and `sideways-*` writing modes. Measured rather than assumed, because every
 * logical property this module writes resolves against the popover's own writing
 * mode, and so must the viewport unit paired with it.
 */ /**
 * The dynamic viewport unit for one of the popover's axes. Not `dvi` / `dvb`:
 * css-values-4 defines those against the ROOT element's writing mode, while the
 * `max-{axis}-size` they are written to follows the popover's, so a popover in a
 * `vertical-rl` subtree of a horizontal document would be capped by the wrong
 * dimension.
 */ function $8dfcca713866dcbf$var$viewportUnit(_ref) {
    var axis = _ref.axis, writingMode = _ref.writingMode;
    var isHorizontalAxis = axis === 'inline' === (writingMode === 'horizontal');
    return isHorizontalAxis ? 'dvw' : 'dvh';
}
/**
 * How one axis of an anchored popover is sized. Both axes take these four values
 * under identical rules.
 *
 * - `'content'`: sized by its content. Named after `flex-basis: content`; NOT
 *   `'auto'`, whose CSS meaning for a positioned box is shrink-to-fit, the very
 *   behaviour rule 4 removes.
 * - `'match-anchor'`: exactly the anchor's size on this axis.
 * - `'min-anchor'`: at least the anchor's size on this axis, free to grow.
 * - `'max-available'`: at most the space between the anchor and the viewport
 *   edge, content-sized below that. Capped by the `position-area` cell on the
 *   placement axis and by the viewport on the cross axis (a `span-*` cell is
 *   narrower than the viewport, so capping to it would wrap content that fits on
 *   screen).
 *
 * Four rules apply on top:
 *
 * 1. Fitting one axis fills a `'content'` other axis with `'max-available'` too.
 *    An explicit value is never overridden, so caps stay strictly per-axis.
 * 2. Fitting either axis floors the placement axis, because flipping is a
 *    whole-popover outcome. See `getPlacementAxisFloor`.
 * 3. The viewport cap is unconditional, so a non-fitting axis still cannot
 *    overhang the screen. `'max-available'` and `'content'` are therefore
 *    indistinguishable on the cross axis.
 * 4. A non-anchor-relative inline axis gets `inline-size: max-content`. Under
 *    `position-area` the containing block is the cell, so a CSS `auto` inline
 *    size shrink-to-fits a too-narrow cell and WRAPS into it, never overflowing
 *    and so never sliding to the roomier side. The caps still beat it, because a
 *    max beats a definite size. Not needed on the block axis, which does not
 *    wrap, nor on the JavaScript fallback, whose containing block is the
 *    viewport. Consumers opt out with `shouldPreserveInlineSize`.
 *
 * See `notes/decisions/fit-available-space.md`.
 */ /**
 * Narrowed rather than `string`, so a typo cannot reach `setStyle` as a
 * silently-ignored property name.
 */ /**
 * The anchor's size along each axis, as a CSS length. `null` when nothing needs
 * it, so the measurement is skipped.
 *
 * The CSS path uses the `self-` keywords, whose axes are the POPOVER's, so each
 * value matches the axis of the property it is set on (`anchor-size(inline)` and
 * `anchor-size(width)` are both silently wrong in a vertical writing mode). The
 * JavaScript fallback uses a measured pixel length, because `anchor-size()` needs
 * a `position-anchor` that path never sets. See
 * `notes/decisions/width-from-anchor-floors.md`.
 */ function $8dfcca713866dcbf$var$getCrossAxis(axis) {
    return axis === 'block' ? 'inline' : 'block';
}
/**
 * The whole viewport, less the reserved padding on both sides. Rule 3's backstop.
 */ function $8dfcca713866dcbf$var$viewportCap(_ref2) {
    var axis = _ref2.axis, writingMode = _ref2.writingMode;
    return "calc(100".concat($8dfcca713866dcbf$var$viewportUnit({
        axis: axis,
        writingMode: writingMode
    }), " - 2 * ").concat($8dfcca713866dcbf$export$9f2fdbacbc62226e, ")");
}
/**
 * The position-area cell cap, for the placement axis only. The host carries
 * `position-area`, so per css-anchor-position-1 the cell is its containing block:
 * `100%` is the anchor edge to the viewport edge, and it follows whichever side
 * `position-try-fallbacks` settles on. Percentages do not subtract margins, so
 * the gap is subtracted here.
 *
 * Meaningless on the JavaScript fallback, whose containing block is the viewport,
 * so that path gets `viewportCap` on both axes.
 */ function $8dfcca713866dcbf$var$cellCap(_ref3) {
    var gap = _ref3.gap;
    return "calc(100% - ".concat($8dfcca713866dcbf$export$9f2fdbacbc62226e, " - ").concat(gap, ")");
}
/**
 * The anchor term of the placement-axis floor, and the one place it is capped.
 *
 * `'match-anchor'` earns a floor only where it can flip: a definite size clamps to
 * the cap and shrinks below the anchor instead of flipping.
 *
 * The `canFlip` clamp is deliberate both ways. With no flip in play an unclamped
 * floor beats `max-{axis}-size` (CSS resolves `min` last), making the viewport
 * backstop inert. With a flip in play, clamping would stop the floor exceeding
 * the cell cap, which is what drives the flip.
 */ function $8dfcca713866dcbf$var$getPlacementAxisAnchorFloor(_ref4) {
    var placementAxis = _ref4.placementAxis, placementAxisSize = _ref4.placementAxisSize, anchorValue = _ref4.anchorValue, canFlip = _ref4.canFlip, writingMode = _ref4.writingMode;
    var hasAnchorFloor = placementAxisSize === 'min-anchor' || placementAxisSize === 'match-anchor' && canFlip;
    if (!hasAnchorFloor || anchorValue === null) return undefined;
    if (canFlip) return anchorValue;
    return "min(".concat(anchorValue, ", ").concat($8dfcca713866dcbf$var$viewportCap({
        axis: placementAxis,
        writingMode: writingMode
    }), ")");
}
/**
 * The default flip floor, clamped so that SOME cell can always hold it.
 *
 * The two cells either side of the anchor add up to the viewport less the anchor,
 * so the roomier one is at least half of that. A floor whose margin box fits
 * inside that half is guaranteed a cell somewhere in the fallback chain.
 * Unclamped, a short viewport with a centred anchor has NO cell that holds
 * 150px: every try-fallback overflows, the browser reverts to the base position,
 * and the floor pushes the popover past the viewport edge.
 *
 * This is NOT the `min(floor, cellCap)` that suppresses flipping: it is relative
 * to the VIEWPORT, so a small base cell still overflows it. `max(0px, …)` states
 * the lower bound for an anchor taller than the viewport.
 */ function $8dfcca713866dcbf$var$getDefaultPlacementAxisFloor(_ref5) {
    var placementAxis = _ref5.placementAxis, anchorValue = _ref5.anchorValue, gap = _ref5.gap, writingMode = _ref5.writingMode;
    if (anchorValue === null) return $8dfcca713866dcbf$export$32ab78b2bb853a01;
    // The viewport term and the anchor term must measure the SAME axis; see
    // `viewportUnit`.
    var viewport = "100".concat($8dfcca713866dcbf$var$viewportUnit({
        axis: placementAxis,
        writingMode: writingMode
    }));
    var halfOfRemainingViewport = "calc((".concat(viewport, " - ").concat(anchorValue, ") / 2 - ").concat(gap, " - ").concat($8dfcca713866dcbf$export$9f2fdbacbc62226e, ")");
    return "min(".concat($8dfcca713866dcbf$export$32ab78b2bb853a01, ", max(0px, ").concat(halfOfRemainingViewport, "))");
}
/**
 * The placement-axis floor: explicit minimums COMPOSE, the default does not.
 *
 * `placement.minSize` and the anchor term are both explicit requests, so they
 * compose as `max()`. `FALLBACK_MINIMUM_MAIN_AXIS_SIZE` never composes: it only
 * ever won by overriding a size the consumer asked for, and the anchor term drives
 * the flip on its own. Knock-on, intended: `minSize: 0` no longer removes an
 * anchor floor, because `max(0px, anchor)` IS the anchor.
 */ function $8dfcca713866dcbf$var$getPlacementAxisFloor(_ref6) {
    var minSize = _ref6.minSize, placementAxis = _ref6.placementAxis, placementAxisSize = _ref6.placementAxisSize, anchorValue = _ref6.anchorValue, gap = _ref6.gap, canFlip = _ref6.canFlip, writingMode = _ref6.writingMode;
    var anchorFloor = $8dfcca713866dcbf$var$getPlacementAxisAnchorFloor({
        placementAxis: placementAxis,
        placementAxisSize: placementAxisSize,
        anchorValue: anchorValue,
        canFlip: canFlip,
        writingMode: writingMode
    });
    if (minSize !== undefined) return anchorFloor === undefined ? minSize : "max(".concat(minSize, ", ").concat(anchorFloor, ")");
    if (anchorFloor !== undefined) return anchorFloor;
    if (!canFlip) return undefined;
    return $8dfcca713866dcbf$var$getDefaultPlacementAxisFloor({
        placementAxis: placementAxis,
        anchorValue: anchorValue,
        gap: gap,
        writingMode: writingMode
    });
}
function $8dfcca713866dcbf$export$860b30329fa0b990(_ref7) {
    var placement = _ref7.placement, inlineSize = _ref7.inlineSize, blockSize = _ref7.blockSize, isUsingCssAnchorPositioning = _ref7.isUsingCssAnchorPositioning, anchorSize = _ref7.anchorSize, writingMode = _ref7.writingMode, _ref7$shouldPreserveI = _ref7.shouldPreserveInlineSize, shouldPreserveInlineSize = _ref7$shouldPreserveI === void 0 ? false : _ref7$shouldPreserveI;
    var placementAxis = placement.axis;
    var crossAxis = $8dfcca713866dcbf$var$getCrossAxis(placementAxis);
    // Rule 1. Feeds the per-axis CAPS only.
    var size = {
        inline: inlineSize === 'content' && blockSize === 'max-available' ? 'max-available' : inlineSize,
        block: blockSize === 'content' && inlineSize === 'max-available' ? 'max-available' : blockSize
    };
    // Rule 2 reads the requested values instead, un-mirrored: flipping is a
    // whole-popover outcome, so a fit request on either axis turns the floor on.
    var isFitting = inlineSize === 'max-available' || blockSize === 'max-available';
    // ...but only where the floor is what causes the flip. On the JavaScript
    // fallback a floor only inflates the measured size the side is picked from, so
    // it would flip a popover that fits.
    var canFlip = isFitting && isUsingCssAnchorPositioning;
    var declarations = [
        // Rule 3: both caps are always written. Only the placement axis can take the
        // cell cap.
        {
            property: "max-".concat(placementAxis, "-size"),
            value: size[placementAxis] === 'max-available' && isUsingCssAnchorPositioning ? $8dfcca713866dcbf$var$cellCap({
                gap: placement.offset.gap
            }) : $8dfcca713866dcbf$var$viewportCap({
                axis: placementAxis,
                writingMode: writingMode
            })
        },
        {
            property: "max-".concat(crossAxis, "-size"),
            value: $8dfcca713866dcbf$var$viewportCap({
                axis: crossAxis,
                writingMode: writingMode
            })
        }
    ];
    // Rule 4. Only for a non-anchor-relative inline axis, so `'match-anchor'` below
    // stays the one writer of `inline-size` when it applies. CSS path only: the
    // fallback's containing block is the viewport, where shrink-to-fit already IS
    // the natural width for anything that fits on screen.
    if (isUsingCssAnchorPositioning && !shouldPreserveInlineSize && (size.inline === 'content' || size.inline === 'max-available')) declarations.push({
        property: 'inline-size',
        value: 'max-content'
    });
    // A max beats a definite size, so the caps above still win over this.
    for(var _i = 0, _arr = [
        placementAxis,
        crossAxis
    ]; _i < _arr.length; _i++){
        var axis = _arr[_i];
        var anchorValue = anchorSize[axis];
        if (size[axis] === 'match-anchor' && anchorValue !== null) declarations.push({
            property: "".concat(axis, "-size"),
            value: anchorValue
        });
    }
    var placementAxisFloor = $8dfcca713866dcbf$var$getPlacementAxisFloor({
        minSize: placement.minSize,
        placementAxis: placementAxis,
        placementAxisSize: size[placementAxis],
        anchorValue: anchorSize[placementAxis],
        gap: placement.offset.gap,
        canFlip: canFlip,
        writingMode: writingMode
    });
    if (placementAxisFloor !== undefined) declarations.push({
        property: "min-".concat(placementAxis, "-size"),
        value: placementAxisFloor
    });
    // A size contract, not a flip driver, so it is clamped to the cap.
    var crossAxisAnchorValue = anchorSize[crossAxis];
    if (size[crossAxis] === 'min-anchor' && crossAxisAnchorValue !== null) declarations.push({
        property: "min-".concat(crossAxis, "-size"),
        value: "min(".concat(crossAxisAnchorValue, ", ").concat($8dfcca713866dcbf$var$viewportCap({
            axis: crossAxis,
            writingMode: writingMode
        }), ")")
    });
    return declarations;
}

});


parcelRegister("lOeDc", function(module, exports) {
$parcel$export(module.exports, "getExistingAnchorName", () => $0418ede718155fc4$export$948d15b01d509455);
/**
 * The `anchor-name` an element already carries, or `null`. Computed as well as
 * inline, so a name set from a STYLESHEET is found: a minted inline name would
 * otherwise override it for every other rule anchored to that element.
 * `anchor-name` is a list and `position-anchor` takes one ident, so the first
 * name is the one to anchor to.
 */ function $0418ede718155fc4$export$948d15b01d509455(element) {
    var declared = element.style.getPropertyValue('anchor-name') || getComputedStyle(element).getPropertyValue('anchor-name');
    var first = declared.split(',')[0].trim();
    return first !== '' && first !== 'none' ? first : null;
}

});

parcelRegister("atUBI", function(module, exports) {
$parcel$export(module.exports, "placementToPositionArea", () => $7a1885dd650c979f$export$de49b61f233ddeb9);
/**
 * Resolves a placement to CSS `position-area` syntax.
 *
 * The `align` field represents the *visual* alignment:
 * - `align: 'start'` means "aligned to the trigger's start edge" (left in LTR for block axis)
 * - `align: 'end'` means "aligned to the trigger's end edge"
 * - `align: 'center'` means centered (single-axis position-area)
 *
 * CSS `position-area` uses `span-*` keywords which indicate the *expansion direction*.
 * Visual start-alignment requires `span-{cross-axis}-end` (expand toward end = start-aligned).
 * This function handles the inversion internally.
 *
 * Takes the RESOLVED placement, which the hook threads through positioning,
 * sizing and margins alike, so nothing here can disagree with them.
 *
 * @example
 * // For a `block-end` placement, by `align`:
 * // 'center' → 'block-end'
 * // 'start'  → 'block-end span-inline-end'
 * // 'end'    → 'block-end span-inline-start'
 */ function $7a1885dd650c979f$export$de49b61f233ddeb9(_ref) {
    var placement = _ref.placement;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    var edgeValue = "".concat(axis, "-").concat(edge);
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    var spanDir = align === 'start' ? 'end' : 'start';
    return "".concat(edgeValue, " span-").concat(crossAxis, "-").concat(spanDir);
}

});

parcelRegister("iFgHX", function(module, exports) {
$parcel$export(module.exports, "placementToTryFallbacks", () => $d9690435e89a011c$export$c4e16947a95d61f1);
/**
 * The placement axis joined to its edge, e.g. `block-end`.
 */ /**
 * The cells to slide to along one edge, on the cross axis.
 *
 * A try option is only worth listing if its margin box can fit where an earlier
 * one did not, and two options over the SAME cell have the same margin box and
 * the same fit result. That rules out three cells for an aligned placement: the
 * near span on the requested edge IS the base position-area, and on the opposite
 * edge the near and far spans are where `flip-{A}` and the diagonal flip land.
 *
 * A centred placement has no near or far, so it slides to both spans on both
 * edges.
 */ function $d9690435e89a011c$var$slideOnEdge(_ref) {
    var align = _ref.align, edgeKey = _ref.edgeKey, crossAxis = _ref.crossAxis, isOppositeEdge = _ref.isOppositeEdge;
    if (align === 'center') return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-end"),
        "".concat(edgeKey, " span-").concat(crossAxis, "-start")
    ];
    if (isOppositeEdge) return [
        edgeKey
    ];
    // For `align: 'start'` the popover expands toward `end`, so the far span is
    // `start`; `align: 'end'` mirrors this.
    var far = align === 'start' ? 'start' : 'end';
    return [
        edgeKey,
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(far)
    ];
}
function $d9690435e89a011c$var$flipDiagonally(_ref2) {
    var axis = _ref2.axis;
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    var flipToCrossAxis = axis === 'block' ? 'flip-inline' : 'flip-block';
    return "".concat(flipOnMainAxis, " ").concat(flipToCrossAxis);
}
function $d9690435e89a011c$export$c4e16947a95d61f1(_ref3) {
    var placement = _ref3.placement;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    var flippedEdge = edge === 'start' ? 'end' : 'start';
    var sameEdgeArea = "".concat(axis, "-").concat(edge);
    var oppositeEdgeArea = "".concat(axis, "-").concat(flippedEdge);
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    return [
        $d9690435e89a011c$var$slideOnEdge({
            align: align,
            edgeKey: sameEdgeArea,
            crossAxis: crossAxis,
            isOppositeEdge: false
        }),
        flipOnMainAxis,
        align !== 'center' ? $d9690435e89a011c$var$flipDiagonally({
            axis: axis
        }) : null,
        $d9690435e89a011c$var$slideOnEdge({
            align: align,
            edgeKey: oppositeEdgeArea,
            crossAxis: crossAxis,
            isOppositeEdge: true
        })
    ].filter(Boolean).flat().join(', ');
}

});


parcelRegister("bptRk", function(module, exports) {
$parcel$export(module.exports, "applyJavaScriptFallbackPositioning", () => $84e930e6d3c71ac8$export$89babc4c2047d2ba);

var $fC8ib = parcelRequire("fC8ib");

var $7QpUe = parcelRequire("7QpUe");

var $45Zis = parcelRequire("45Zis");

var $5xGuE = parcelRequire("5xGuE");

var $92ZkI = parcelRequire("92ZkI");

var $aQd77 = parcelRequire("aQd77");

var $7oklb = parcelRequire("7oklb");

var $dryiB = parcelRequire("dryiB");
/**
 * Wrapped because jsdom throws on the unknown `:popover-open` selector.
 */ function $84e930e6d3c71ac8$var$isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch (_unused) {
        return false;
    }
}
/**
 * Observes the popover until its first non-zero layout, then self-disconnects;
 * ongoing movement is handled by the scroll and resize listeners. The popover is
 * `display: none` until `showPopover()`, and some browsers fire `toggle` before
 * layout, so RAF-after-toggle is unreliable.
 *
 * `null` where `ResizeObserver` is missing (non-DOM jest environments). There is
 * then no measurement to wait for, so the caller positions immediately and must
 * not hide the popover, because no reveal would follow.
 */ function $84e930e6d3c71ac8$var$createFirstLayoutObserver(_ref) {
    var popover = _ref.popover, onFirstLayout = _ref.onFirstLayout;
    if (typeof ResizeObserver === 'undefined') return null;
    try {
        var observer = new ResizeObserver(function() {
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                onFirstLayout();
                observer.disconnect();
            }
        });
        return observer;
    } catch (error) {
        (0, $dryiB.warnFallbackFailure)({
            error: error
        });
        return null;
    }
}
function $84e930e6d3c71ac8$export$89babc4c2047d2ba(_ref2) {
    var anchor = _ref2.anchor, popover = _ref2.popover, placement = _ref2.placement, sizeStyles = _ref2.sizeStyles;
    // Already in the top layer via the `popover` attribute, so this only resets the
    // UA defaults and writes measured `top` / `left`.
    var cleanupBaseStyles = (0, $92ZkI.setStyle)({
        element: popover,
        styles: [
            {
                property: 'margin',
                value: '0'
            },
            {
                property: 'inset',
                value: 'auto'
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sizeStyles))
    });
    // The popover can be consumer-owned (`@atlaskit/popper`'s `createPopper`),
    // so restore prior inline values rather than removing ours.
    var undoPosition;
    var undoHide;
    // Resolved once per open and per resize, reused across scrolls: resolving is a
    // full style and layout flush, and a scroll cannot change what a CSS length
    // resolves to. A resize can (viewport units), and so can a re-open (a token
    // retargeted while closed).
    var resolvedOffsets = null;
    function invalidateResolvedOffsets() {
        resolvedOffsets = null;
    }
    function getResolvedOffsets() {
        if (resolvedOffsets) return resolvedOffsets;
        // Probed INSIDE the popover: it is in the top layer, not the anchor's DOM
        // tree, so anywhere else resolves a token against a different scope.
        resolvedOffsets = {
            gap: (0, $7oklb.resolveCssLengthToPixels)({
                value: placement.offset.gap,
                container: popover
            }),
            crossAxisShift: (0, $7oklb.resolveCssLengthToPixels)({
                value: placement.offset.crossAxisShift.value,
                container: popover
            })
        };
        return resolvedOffsets;
    }
    function reveal() {
        var _undoHide;
        (_undoHide = undoHide) === null || _undoHide === void 0 || _undoHide();
        undoHide = undefined;
    }
    function restorePosition() {
        var _undoPosition;
        (_undoPosition = undoPosition) === null || _undoPosition === void 0 || _undoPosition();
        undoPosition = undefined;
    }
    // `opacity: 0` not `visibility: hidden`: Firefox skips visibility-hidden
    // elements during `<dialog>` initial-focus traversal.
    function hideUntilPositioned() {
        // Keep the first snapshot, else we capture our own `opacity: 0`.
        if (undoHide) return;
        undoHide = (0, $92ZkI.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'opacity',
                    value: '0'
                }
            ]
        });
    }
    /**
   * Last resort. The base styles above reset the UA
   * `[popover] { inset: 0; margin: auto }`, so a popover with no `top` / `left`
   * sits in the viewport corner rather than centred.
   */ function centerInViewport() {
        restorePosition();
        undoPosition = (0, $92ZkI.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'inset',
                    value: '0'
                },
                {
                    property: 'margin',
                    value: 'auto'
                }
            ]
        });
    }
    function update() {
        try {
            var triggerRect = anchor.getBoundingClientRect();
            var viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            var _getResolvedOffsets = getResolvedOffsets(), gap = _getResolvedOffsets.gap, crossAxisShift = _getResolvedOffsets.crossAxisShift;
            var _computeFallbackPosit = (0, $aQd77.computeFallbackPosition)({
                triggerRect: triggerRect,
                popoverEl: popover,
                placement: placement,
                viewport: viewport,
                gap: gap,
                crossAxisShift: {
                    value: crossAxisShift,
                    direction: placement.offset.crossAxisShift.direction
                }
            }), top = _computeFallbackPosit.top, left = _computeFallbackPosit.left;
            // A non-finite coordinate serialises to a declaration the browser drops,
            // landing the popover in the corner just as silently as a throw would.
            if (!Number.isFinite(top) || !Number.isFinite(left)) {
                centerInViewport();
                return;
            }
            // Restore first so the snapshot stays the consumer's value.
            restorePosition();
            undoPosition = (0, $92ZkI.setStyle)({
                element: popover,
                styles: [
                    {
                        property: 'top',
                        value: "".concat(top, "px")
                    },
                    {
                        property: 'left',
                        value: "".concat(left, "px")
                    }
                ]
            });
        } catch (error) {
            (0, $dryiB.warnFallbackFailure)({
                error: error
            });
            // Anchoring needs the trigger geometry we just failed to get, so the
            // centred position is the only one left to degrade to.
            try {
                centerInViewport();
            } catch (_unused2) {}
        } finally{
            // Unconditional. A popover in the wrong place is recoverable on the
            // next scroll or resize; one left at `opacity: 0` is invisible forever.
            reveal();
        }
    }
    function invalidateAndUpdate() {
        invalidateResolvedOffsets();
        update();
    }
    // One update per animation frame. Scroll reuses the resolved offsets; resize
    // re-resolves them.
    var scheduledScrollUpdate = (0, $45Zis.default)(update);
    var scheduledResizeUpdate = (0, $45Zis.default)(invalidateAndUpdate);
    var firstLayoutObserver = $84e930e6d3c71ac8$var$createFirstLayoutObserver({
        popover: popover,
        onFirstLayout: update
    });
    function positionOnNextLayout() {
        // A token can have been retargeted while the popover was closed, so each
        // open re-resolves the offsets.
        invalidateResolvedOffsets();
        // No observer means no measurement is coming: position now, and do not
        // hide, because the reveal would never arrive.
        if (!firstLayoutObserver) {
            update();
            return;
        }
        hideUntilPositioned();
        firstLayoutObserver.observe(popover);
    }
    // The popover can already be open when this runs, in which case the initial
    // `toggle` has fired and the listener below would miss it.
    if ($84e930e6d3c71ac8$var$isPopoverOpen(popover)) positionOnNextLayout();
    return (0, $5xGuE.combine)(cleanupBaseStyles, // Each open needs a fresh measurement, so hide and re-observe.
    (0, $7QpUe.bind)(popover, {
        type: 'toggle',
        listener: function listener(event) {
            var toggleEvent = event;
            if (toggleEvent.newState === 'open') positionOnNextLayout();
        }
    }), function() {
        return firstLayoutObserver === null || firstLayoutObserver === void 0 ? void 0 : firstLayoutObserver.disconnect();
    }, (0, $7QpUe.bind)(window, {
        type: 'scroll',
        listener: scheduledScrollUpdate,
        options: {
            capture: true,
            passive: true
        }
    }), (0, $7QpUe.bind)(window, {
        type: 'resize',
        listener: scheduledResizeUpdate,
        options: {
            passive: true
        }
    }), function() {
        scheduledScrollUpdate.cancel();
        scheduledResizeUpdate.cancel();
        restorePosition();
        reveal();
    });
}

});
parcelRegister("5xGuE", function(module, exports) {
$parcel$export(module.exports, "combine", () => $4090ff1f05bf2704$export$1be1fc439b849fdf);
/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $4090ff1f05bf2704$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, cleanupFns = new Array(_len), _key = 0; _key < _len; _key++)cleanupFns[_key] = arguments[_key];
    return function cleanup() {
        cleanupFns.forEach(function(callback) {
            return callback === null || callback === void 0 ? void 0 : callback();
        });
    };
}

});

parcelRegister("aQd77", function(module, exports) {
$parcel$export(module.exports, "computeFallbackPosition", () => $7e48eed1c0b537f4$export$d5ef1dac02135664);

var $25nEq = parcelRequire("25nEq");
function $7e48eed1c0b537f4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7e48eed1c0b537f4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7e48eed1c0b537f4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7e48eed1c0b537f4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * A viewport-relative position, in pixels. Physical rather than logical
 * because it is written straight to `top` / `left`.
 */ /**
 * `TCrossAxisShiftOffset` with its CSS length already resolved to pixels. Only
 * this module needs the pixel form, because only this module does arithmetic.
 */ /**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function $7e48eed1c0b537f4$var$computeEdgePosition(_ref) {
    var axis = _ref.axis, edge = _ref.edge, triggerRect = _ref.triggerRect, popoverWidth = _ref.popoverWidth, popoverHeight = _ref.popoverHeight, viewport = _ref.viewport, gap = _ref.gap;
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        var spaceBelow = viewport.height - triggerRect.bottom;
        var spaceAbove = triggerRect.top;
        var fitsBelow = spaceBelow >= popoverHeight + gap;
        var useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        var _spaceAbove = triggerRect.top;
        var _spaceBelow = viewport.height - triggerRect.bottom;
        var fitsAbove = _spaceAbove >= popoverHeight + gap;
        var useAbove = fitsAbove || _spaceAbove >= _spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        var spaceRight = viewport.width - triggerRect.right;
        var spaceLeft = triggerRect.left;
        var fitsRight = spaceRight >= popoverWidth + gap;
        var useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        var _spaceLeft = triggerRect.left;
        var _spaceRight = viewport.width - triggerRect.right;
        var fitsLeft = _spaceLeft >= popoverWidth + gap;
        var useLeft = fitsLeft || _spaceLeft >= _spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function $7e48eed1c0b537f4$var$applyAlignment(_ref2) {
    var position = _ref2.position, axis = _ref2.axis, align = _ref2.align, triggerRect = _ref2.triggerRect, popoverWidth = _ref2.popoverWidth, popoverHeight = _ref2.popoverHeight;
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return $7e48eed1c0b537f4$var$_objectSpread($7e48eed1c0b537f4$var$_objectSpread({}, position), {}, {
            left: triggerRect.left
        });
        // align === 'end'
        return $7e48eed1c0b537f4$var$_objectSpread($7e48eed1c0b537f4$var$_objectSpread({}, position), {}, {
            left: triggerRect.right - popoverWidth
        });
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return $7e48eed1c0b537f4$var$_objectSpread($7e48eed1c0b537f4$var$_objectSpread({}, position), {}, {
        top: triggerRect.top
    });
    // align === 'end'
    return $7e48eed1c0b537f4$var$_objectSpread($7e48eed1c0b537f4$var$_objectSpread({}, position), {}, {
        top: triggerRect.bottom - popoverHeight
    });
}
/**
 * Applies the cross-axis shift offset. `forwards` always moves the popover
 * toward the cross-axis END, for every `align` value.
 *
 * Do not add a per-`align` sign inversion here. This is a coordinate, so the
 * direction is the sign and nothing else. The CSS path inverts only because an
 * END-side margin pushes a box the opposite way to a START-side one, which is a
 * property of margins.
 */ function $7e48eed1c0b537f4$var$applyCrossAxisShift(_ref3) {
    var position = _ref3.position, axis = _ref3.axis, crossAxisShift = _ref3.crossAxisShift;
    if (crossAxisShift.value === 0) return position;
    var directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    var delta = crossAxisShift.value * directionSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return $7e48eed1c0b537f4$var$_objectSpread($7e48eed1c0b537f4$var$_objectSpread({}, position), {}, {
        left: position.left + delta
    });
    return $7e48eed1c0b537f4$var$_objectSpread($7e48eed1c0b537f4$var$_objectSpread({}, position), {}, {
        top: position.top + delta
    });
}
function $7e48eed1c0b537f4$export$d5ef1dac02135664(_ref4) {
    var triggerRect = _ref4.triggerRect, popoverEl = _ref4.popoverEl, placement = _ref4.placement, viewport = _ref4.viewport, gap = _ref4.gap, crossAxisShift = _ref4.crossAxisShift;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    var popoverWidth = popoverEl.offsetWidth;
    var popoverHeight = popoverEl.offsetHeight;
    var basePosition = $7e48eed1c0b537f4$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    var alignedPosition = $7e48eed1c0b537f4$var$applyAlignment({
        position: basePosition,
        axis: axis,
        align: align,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    var shiftedPosition = $7e48eed1c0b537f4$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        crossAxisShift: crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}

});

parcelRegister("7oklb", function(module, exports) {
$parcel$export(module.exports, "resolveCssLengthToPixels", () => $561a8d819d241522$export$98721546d2816d9e);

var $dryiB = parcelRequire("dryiB");
/**
 * `null` when the environment cannot measure at all.
 */ function $561a8d819d241522$var$measureWithProbe(_ref) {
    var value = _ref.value, container = _ref.container;
    // Reached through the container rather than the global, so a popover in
    // another document still measures and one with no view degrades gracefully.
    var view = container.ownerDocument.defaultView;
    if (!view) return null;
    var probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hidden from assistive tech and event targeting; defensive against
    // `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    try {
        container.appendChild(probe);
        var resolved = parseFloat(view.getComputedStyle(probe).marginLeft);
        return Number.isFinite(resolved) ? resolved : 0;
    } catch (error) {
        (0, $dryiB.warnFallbackFailure)({
            error: error
        });
        return null;
    } finally{
        // `remove()` rather than `removeChild()`: consumer code may already have
        // detached the probe, which must not throw out of a layout effect.
        probe.remove();
    }
}
function $561a8d819d241522$export$98721546d2816d9e(_ref2) {
    var _measureWithProbe;
    var value = _ref2.value, container = _ref2.container;
    if (typeof value === 'number') return value;
    // Fast path: consumers occasionally pass `'0'` instead of the number `0`.
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from `resolvePlacement`, so this avoids
    // a reflow for the common case.
    var pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    return (_measureWithProbe = $561a8d819d241522$var$measureWithProbe({
        value: value,
        container: container
    })) !== null && _measureWithProbe !== void 0 ? _measureWithProbe : 0;
}

});
parcelRegister("dryiB", function(module, exports) {
$parcel$export(module.exports, "warnFallbackFailure", () => $9c98670a4e590182$export$e142245b95267f17);

function $9c98670a4e590182$export$e142245b95267f17(_ref) {
    var error = _ref.error;
    return;
}

});



parcelRegister("8wATx", function(module, exports) {
$parcel$export(module.exports, "supportsAnchorPositioning", () => $634dee6f4ed13f86$export$7192e63dfa9e8124);

var $9GFat = parcelRequire("9GFat");
var $634dee6f4ed13f86$export$7192e63dfa9e8124 = (0, $9GFat.createCssDeclarationProbe)({
    property: 'anchor-name',
    value: '--a'
});

});
parcelRegister("9GFat", function(module, exports) {
$parcel$export(module.exports, "createCssDeclarationProbe", () => $70d7f86415b8fa17$export$69de71b4b7c76bad);

var $bvsoE = parcelRequire("bvsoE");
function $70d7f86415b8fa17$export$69de71b4b7c76bad(_ref) {
    var property = _ref.property, value = _ref.value;
    return (0, $bvsoE.default)(function supportsCssDeclaration() {
        if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
        return CSS.supports(property, value);
    });
}

});


parcelRegister("8Hx58", function(module, exports) {
$parcel$export(module.exports, "supportsAnchorSize", () => $655c0041d3086a3d$export$1c8dd0d1c9df9c6e);

var $9GFat = parcelRequire("9GFat");
var $655c0041d3086a3d$export$1c8dd0d1c9df9c6e = (0, $9GFat.createCssDeclarationProbe)({
    property: 'min-inline-size',
    value: 'anchor-size(self-inline)'
});

});


parcelRegister("rC5Q0", function(module, exports) {
$parcel$export(module.exports, "usePopoverId", () => $0530123d1fc06a55$export$9198c6c168be2eeb);

var $h8qvJ = parcelRequire("h8qvJ");
function $0530123d1fc06a55$export$9198c6c168be2eeb() {
    // `@atlaskit/ds-lib/use-id`, not React's `useId`: React's output contains
    // `:`, `«` and `»`, which are invalid in an HTML id token.
    return "popover-".concat((0, $h8qvJ.useId)());
}

});

parcelRegister("dlMkc", function(module, exports) {
$parcel$export(module.exports, "getPopupAxisSizes", () => $9b82b8d4fe58dd86$export$60eb6c71554f82c4);
/**
 * Maps the legacy `shouldFitContainer` / `shouldFitViewport` pair onto
 * `useAnchoredPopover`'s per-axis sizes. Shared by the standard and the
 * compositional adapter so the two cannot drift.
 *
 * Both props can be set together while `inlineSize` takes one value, so
 * `shouldFitContainer` wins the inline axis, being the more specific request.
 * Fitting then applies to the block axis only, and still turns the
 * placement-axis floor on, so a cramped popup flips rather than letterboxing.
 *
 * Known cost on a `left-*` / `right-*` placement: the anchor floor is unclamped
 * so it can drive the flip, and a min beats a max, so a trigger wider than the
 * viewport is floored past the viewport cap. Not new, and not reconciled - see
 * `@atlaskit/top-layer`'s `notes/decisions/width-from-anchor-floors.md`.
 */ function $9b82b8d4fe58dd86$export$60eb6c71554f82c4(_ref) {
    var shouldFitContainer = _ref.shouldFitContainer, shouldFitViewport = _ref.shouldFitViewport;
    var blockSize = shouldFitViewport ? 'max-available' : 'content';
    if (shouldFitContainer) return {
        inlineSize: 'match-anchor',
        blockSize: blockSize
    };
    if (shouldFitViewport) return {
        inlineSize: 'max-available',
        blockSize: blockSize
    };
    return {
        inlineSize: 'content',
        blockSize: blockSize
    };
}

});

parcelRegister("29RES", function(module, exports) {
$parcel$export(module.exports, "useRoleProps", () => $19260b79c60c8869$export$892580369e97d8b9);

var $5FkrB = parcelRequire("5FkrB");
function $19260b79c60c8869$export$892580369e97d8b9(_ref) {
    var role = _ref.role, label = _ref.label, titleId = _ref.titleId;
    return (0, $5FkrB.useMemo)(function() {
        if (role === 'dialog' || role === 'alertdialog' || role === 'menu') {
            if (titleId) return {
                role: role,
                labelledBy: titleId
            };
            return {
                role: role,
                label: label !== null && label !== void 0 ? label : 'Popup'
            };
        }
        if (role) return {
            role: role,
            label: label
        };
        // No role supplied: preserve the legacy "no popup semantics" contract.
        return {
            role: undefined,
            label: label
        };
    }, [
        role,
        label,
        titleId
    ]);
}

});


parcelRegister("516xU", function(module, exports) {
$parcel$export(module.exports, "usePopupAppearance", () => $3a721fa318d8ecb3$export$4065aef1d79a5730);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $50U6m = parcelRequire("50U6m");

var $9yvgx = parcelRequire("9yvgx");
function $3a721fa318d8ecb3$export$4065aef1d79a5730(_ref) {
    var _appearance = _ref.appearance, _shouldRenderToParent = _ref.shouldRenderToParent;
    var canBecomeModal = _appearance === 'UNSAFE_modal-below-sm';
    /**
   * This gate removes unnecessary state changes across the below-sm boundary
   * The state change is only needed if the popup can become a modal - and this is maintained
   */ var shouldUseMediaQuery = !(0, $50U6m.fg)('platform_dst_popup_media_query_perf_fix') || canBecomeModal;
    var mq = (0, $9yvgx.UNSAFE_useMediaQuery)('below.sm', shouldUseMediaQuery ? function(e) {
        setIsSmallViewport(!!e.matches);
    } : undefined);
    var _useState = (0, $5FkrB.useState)(!!(mq !== null && mq !== void 0 && mq.matches)), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSmallViewport = _useState2[0], setIsSmallViewport = _useState2[1];
    var appearance = canBecomeModal && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    var shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("9yvgx", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $6f4f8ac5b81b352b$export$49e55ae2c03d6045);

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $411lF = parcelRequire("411lF");
var $6f4f8ac5b81b352b$var$_window, $6f4f8ac5b81b352b$var$_window$matchMedia, $6f4f8ac5b81b352b$var$_window2, $6f4f8ac5b81b352b$var$_window2$matchMedia, $6f4f8ac5b81b352b$var$_window3, $6f4f8ac5b81b352b$var$_window3$matchMedia, $6f4f8ac5b81b352b$var$_window4, $6f4f8ac5b81b352b$var$_window4$matchMedia, $6f4f8ac5b81b352b$var$_window5, $6f4f8ac5b81b352b$var$_window5$matchMedia, $6f4f8ac5b81b352b$var$_window6, $6f4f8ac5b81b352b$var$_window6$matchMedia, $6f4f8ac5b81b352b$var$_window7, $6f4f8ac5b81b352b$var$_window7$matchMedia, $6f4f8ac5b81b352b$var$_window8, $6f4f8ac5b81b352b$var$_window8$matchMedia, $6f4f8ac5b81b352b$var$_window9, $6f4f8ac5b81b352b$var$_window9$matchMedia, $6f4f8ac5b81b352b$var$_window0, $6f4f8ac5b81b352b$var$_window0$matchMedia, $6f4f8ac5b81b352b$var$_window1, $6f4f8ac5b81b352b$var$_window1$matchMedia;
var $6f4f8ac5b81b352b$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($6f4f8ac5b81b352b$var$_window = window) === null || $6f4f8ac5b81b352b$var$_window === void 0 || ($6f4f8ac5b81b352b$var$_window$matchMedia = $6f4f8ac5b81b352b$var$_window.matchMedia) === null || $6f4f8ac5b81b352b$var$_window$matchMedia === void 0 ? void 0 : $6f4f8ac5b81b352b$var$_window$matchMedia.call($6f4f8ac5b81b352b$var$_window, (0, $411lF.media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($6f4f8ac5b81b352b$var$_window2 = window) === null || $6f4f8ac5b81b352b$var$_window2 === void 0 || ($6f4f8ac5b81b352b$var$_window2$matchMedia = $6f4f8ac5b81b352b$var$_window2.matchMedia) === null || $6f4f8ac5b81b352b$var$_window2$matchMedia === void 0 ? void 0 : $6f4f8ac5b81b352b$var$_window2$matchMedia.call($6f4f8ac5b81b352b$var$_window2, (0, $411lF.media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($6f4f8ac5b81b352b$var$_window3 = window) === null || $6f4f8ac5b81b352b$var$_window3 === void 0 || ($6f4f8ac5b81b352b$var$_window3$matchMedia = $6f4f8ac5b81b352b$var$_window3.matchMedia) === null || $6f4f8ac5b81b352b$var$_window3$matchMedia === void 0 ? void 0 : $6f4f8ac5b81b352b$var$_window3$matchMedia.call($6f4f8ac5b81b352b$var$_window3, (0, $411lF.media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($6f4f8ac5b81b352b$var$_window4 = window) === null || $6f4f8ac5b81b352b$var$_window4 === void 0 || ($6f4f8ac5b81b352b$var$_window4$matchMedia = $6f4f8ac5b81b352b$var$_window4.matchMedia) === null || $6f4f8ac5b81b352b$var$_window4$matchMedia === void 0 ? void 0 : $6f4f8ac5b81b352b$var$_window4$matchMedia.call($6f4f8ac5b81b352b$var$_window4, (0, $411lF.media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($6f4f8ac5b81b352b$var$_window5 = window) === null || $6f4f8ac5b81b352b$var$_window5 === void 0 || ($6f4f8ac5b81b352b$var$_window5$matchMedia = $6f4f8ac5b81b352b$var$_window5.matchMedia) === null || $6f4f8ac5b81b352b$var$_window5$matchMedia === void 0 ? void 0 : $6f4f8ac5b81b352b$var$_window5$matchMedia.call($6f4f8ac5b81b352b$var$_window5, (0, $411lF.media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($6f4f8ac5b81b352b$var$_window6 = window) === null || $6f4f8ac5b81b352b$var$_window6 === void 0 || ($6f4f8ac5b81b352b$var$_window6$matchMedia = $6f4f8ac5b81b352b$var$_window6.matchMedia) === null || $6f4f8ac5b81b352b$var$_window6$matchMedia === void 0 ? void 0 : $6f4f8ac5b81b352b$var$_window6$matchMedia.call($6f4f8ac5b81b352b$var$_window6, (0, $411lF.media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($6f4f8ac5b81b352b$var$_window7 = window) === null || $6f4f8ac5b81b352b$var$_window7 === void 0 || ($6f4f8ac5b81b352b$var$_window7$matchMedia = $6f4f8ac5b81b352b$var$_window7.matchMedia) === null || $6f4f8ac5b81b352b$var$_window7$matchMedia === void 0 ? void 0 : $6f4f8ac5b81b352b$var$_window7$matchMedia.call($6f4f8ac5b81b352b$var$_window7, (0, $411lF.media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($6f4f8ac5b81b352b$var$_window8 = window) === null || $6f4f8ac5b81b352b$var$_window8 === void 0 || ($6f4f8ac5b81b352b$var$_window8$matchMedia = $6f4f8ac5b81b352b$var$_window8.matchMedia) === null || $6f4f8ac5b81b352b$var$_window8$matchMedia === void 0 ? void 0 : $6f4f8ac5b81b352b$var$_window8$matchMedia.call($6f4f8ac5b81b352b$var$_window8, (0, $411lF.media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($6f4f8ac5b81b352b$var$_window9 = window) === null || $6f4f8ac5b81b352b$var$_window9 === void 0 || ($6f4f8ac5b81b352b$var$_window9$matchMedia = $6f4f8ac5b81b352b$var$_window9.matchMedia) === null || $6f4f8ac5b81b352b$var$_window9$matchMedia === void 0 ? void 0 : $6f4f8ac5b81b352b$var$_window9$matchMedia.call($6f4f8ac5b81b352b$var$_window9, (0, $411lF.media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($6f4f8ac5b81b352b$var$_window0 = window) === null || $6f4f8ac5b81b352b$var$_window0 === void 0 || ($6f4f8ac5b81b352b$var$_window0$matchMedia = $6f4f8ac5b81b352b$var$_window0.matchMedia) === null || $6f4f8ac5b81b352b$var$_window0$matchMedia === void 0 ? void 0 : $6f4f8ac5b81b352b$var$_window0$matchMedia.call($6f4f8ac5b81b352b$var$_window0, (0, $411lF.media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($6f4f8ac5b81b352b$var$_window1 = window) === null || $6f4f8ac5b81b352b$var$_window1 === void 0 || ($6f4f8ac5b81b352b$var$_window1$matchMedia = $6f4f8ac5b81b352b$var$_window1.matchMedia) === null || $6f4f8ac5b81b352b$var$_window1$matchMedia === void 0 ? void 0 : $6f4f8ac5b81b352b$var$_window1$matchMedia.call($6f4f8ac5b81b352b$var$_window1, (0, $411lF.media).below.xl.replace('@media ', '').trim())
};
var $6f4f8ac5b81b352b$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $5FkrB.useRef)(listener);
    (0, $5FkrB.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $6f4f8ac5b81b352b$var$queries[queryString];
    (0, $5FkrB.useLayoutEffect)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $7QpUe.bind)(mq, {
            type: 'change',
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("411lF", function(module, exports) {
$parcel$export(module.exports, "media", () => $2ec84d2d4928089d$export$987d49ffe1b0900f);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $2ec84d2d4928089d$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});



parcelRegister("jH5Jd", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", () => $e56679fddd3bf8a0$export$7cc5c058dd769dff);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $cvlyC = parcelRequire("cvlyC");
var $e56679fddd3bf8a0$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $5FkrB.useState)(function() {
        return (0, $cvlyC.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("2PE7x", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", () => $20ff774fe0ee677f$export$5d3a2de79e07b376);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $cvlyC = parcelRequire("cvlyC");
var $20ff774fe0ee677f$export$5d3a2de79e07b376 = function useGetMemoizedMergedTriggerRefNew() {
    var _useState = (0, $5FkrB.useState)(function() {
        return (0, $cvlyC.default)(function(ref, setTriggerRef) {
            return function(node) {
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 1), getMemoizedMergedTriggerRefNew = _useState2[0];
    return getMemoizedMergedTriggerRefNew;
};

});


parcelRegister("9t5p4", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e4b0381575c2ec4$export$2e2bcd8739ae039);
/* dropdown-menu-top-layer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $7QpUe = parcelRequire("7QpUe");

var $dUWEU = parcelRequire("dUWEU");

var $lmG37 = parcelRequire("lmG37");

var $eVb4V = parcelRequire("eVb4V");

var $2oF7I = parcelRequire("2oF7I");

var $h7zHk = parcelRequire("h7zHk");

var $h19KG = parcelRequire("h19KG");

var $6xFrB = parcelRequire("6xFrB");

var $9ztDu = parcelRequire("9ztDu");

var $aEy4n = parcelRequire("aEy4n");

var $lSYUF = parcelRequire("lSYUF");

var $fcful = parcelRequire("fcful");

var $hEyq2 = parcelRequire("hEyq2");

var $a2YRu = parcelRequire("a2YRu");

var $2EfXQ = parcelRequire("2EfXQ");

var $5vpw8 = parcelRequire("5vpw8");

var $7dbsW = parcelRequire("7dbsW");

var $gP3m7 = parcelRequire("gP3m7");

var $1jaJ9 = parcelRequire("1jaJ9");
function $6e4b0381575c2ec4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6e4b0381575c2ec4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6e4b0381575c2ec4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6e4b0381575c2ec4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6e4b0381575c2ec4$var$MAX_HEIGHT = "calc(100vh - 16px)";
var $6e4b0381575c2ec4$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
};
/**
 * Event types produced by trigger interactions.
 *
 * - `React.MouseEvent<Element>`: from the trigger's `onClick` handler
 * - `React.KeyboardEvent<Element>`: from the trigger's `onClick` when activated via keyboard
 * - `KeyboardEvent`: native event from the ArrowDown `bind(window, ...)` listener
 */ function $6e4b0381575c2ec4$var$getRootMenuPopover(_ref) {
    var _menu$parentElement;
    var menu = _ref.menu;
    var parentMenu = (_menu$parentElement = menu.parentElement) === null || _menu$parentElement === void 0 ? void 0 : _menu$parentElement.closest('[popover][role="menu"]');
    if (!parentMenu) return menu;
    return $6e4b0381575c2ec4$var$getRootMenuPopover({
        menu: parentMenu
    });
}
/**
 * Loading indicator for the dropdown menu.
 */ function $6e4b0381575c2ec4$var$LoadingIndicator(_ref2) {
    var _ref2$statusLabel = _ref2.statusLabel, statusLabel = _ref2$statusLabel === void 0 ? 'Loading' : _ref2$statusLabel, testId = _ref2.testId;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        role: "menuitem",
        className: (0, $970q7.default)([
            $6e4b0381575c2ec4$var$styles.spinnerContainer
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $9ztDu.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
}
/**
 * Top-layer implementation of DropdownMenu.
 *
 * Replaces the legacy `@atlaskit/popup` + `@atlaskit/portal` + `@atlaskit/layering` pipeline
 * with the native Popover API via `@atlaskit/top-layer`.
 *
 * What is no longer needed:
 * - Portal: top layer handles stacking natively
 * - FocusLock / react-focus-lock: popover=auto provides light dismiss
 * - z-index: top layer is always above everything
 * - FocusManager (ref registration): replaced by DOM-query-based `useArrowNavigation`
 * - handle-focus.tsx: replaced by `useArrowNavigation`
 * - Layering context: top layer nesting is handled by the browser
 * - Fallback placements / Popper: CSS Anchor Positioning handles positioning
 */ function $6e4b0381575c2ec4$var$DropdownMenuTopLayer(_ref3) {
    var _ref5;
    var children = _ref3.children, _ref3$defaultOpen = _ref3.defaultOpen, defaultOpen = _ref3$defaultOpen === void 0 ? false : _ref3$defaultOpen, _ref3$isLoading = _ref3.isLoading, isLoading = _ref3$isLoading === void 0 ? false : _ref3$isLoading, isOpenProp = _ref3.isOpen, _ref3$onOpenChange = _ref3.onOpenChange, onOpenChange = _ref3$onOpenChange === void 0 ? (0, $eVb4V.default) : _ref3$onOpenChange, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? 'bottom-start' : _ref3$placement, _ref3$shouldFitContai = _ref3.shouldFitContainer, shouldFitContainer = _ref3$shouldFitContai === void 0 ? false : _ref3$shouldFitContai, returnFocusRef = _ref3.returnFocusRef, spacing = _ref3.spacing, statusLabel = _ref3.statusLabel, testId = _ref3.testId, trigger = _ref3.trigger, label = _ref3.label, interactionName = _ref3.interactionName, menuLabel = _ref3.menuLabel;
    var _useControlledState = (0, $2oF7I.default)(isOpenProp, function() {
        return defaultOpen;
    }), _useControlledState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useControlledState, 2), isLocalOpen = _useControlledState2[0], setLocalIsOpen = _useControlledState2[1];
    var triggerRef = (0, $5FkrB.useRef)(null);
    var popoverRef = (0, $5FkrB.useRef)(null);
    var popoverId = (0, $7dbsW.usePopoverId)();
    var topLayerPlacement = (0, $5FkrB.useMemo)(function() {
        return (0, $lSYUF.fromLegacyPlacement)({
            legacy: placement
        });
    }, [
        placement
    ]);
    (0, $a2YRu.useAnchorPosition)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isLocalOpen
    });
    (0, $gP3m7.useWidthFromAnchor)({
        mode: shouldFitContainer ? 'min-anchor' : 'none',
        popoverRef: popoverRef,
        anchorRef: triggerRef,
        isOpen: isLocalOpen
    });
    // Close handling.
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    //
    // The only custom focus handling needed is `returnFocusRef`: when provided,
    // we redirect focus to a different element than the trigger. We do this
    // in the onClose callback via rAF, which runs after the browser's native
    // restoration, effectively overriding it.
    var handleOnClose = (0, $5FkrB.useCallback)(function() {
        if (returnFocusRef) requestAnimationFrame(function() {
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        setLocalIsOpen(false);
        onOpenChange({
            isOpen: false,
            event: null
        });
    }, [
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    // Trigger click handling.
    var handleTriggerClicked = (0, $5FkrB.useCallback)(function(event) {
        var nextIsOpen = !isLocalOpen;
        setLocalIsOpen(nextIsOpen);
        // Extract the native DOM event for onOpenChange
        var nativeEvent = 'nativeEvent' in event ? event.nativeEvent : event;
        onOpenChange({
            isOpen: nextIsOpen,
            event: nativeEvent
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange
    ]);
    var _useFocus = (0, $h7zHk.default)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When trigger is focused, open dropdown on ArrowDown (top-level only).
    // Per WAI-ARIA, ArrowDown opens a menu from a menubar/button trigger,
    // but inside a vertical submenu, ArrowDown navigates between siblings
    // and ArrowRight opens nested menus instead.
    (0, $5FkrB.useEffect)(function() {
        var _triggerRef$current;
        if (!isFocused || isLocalOpen) return;
        // Do not open on ArrowDown if this trigger is inside a parent menu.
        // Nested menus should only be opened via ArrowRight or Enter.
        var isNestedTrigger = Boolean((_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.closest('[role="menu"]'));
        return (0, $7QpUe.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $lmG37.KEY_DOWN) && !isNestedTrigger) {
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked
    ]);
    var handleNestedOpen = (0, $5FkrB.useCallback)(function(_ref4) {
        var trigger = _ref4.trigger;
        trigger.click();
    }, []);
    var handleTabClose = (0, $5FkrB.useCallback)(function() {
        var currentMenu = popoverRef.current;
        if (!currentMenu) return;
        // Hiding the root native popover synchronously closes its descendant popovers and restores
        // focus to the root trigger. The browser can then perform the Tab default action from there.
        $6e4b0381575c2ec4$var$getRootMenuPopover({
            menu: currentMenu
        }).hidePopover();
    }, []);
    (0, $5vpw8.useArrowNavigation)({
        containerRef: popoverRef,
        onClose: handleTabClose,
        onNestedOpen: handleNestedOpen,
        onNestedClose: handleOnClose,
        isEnabled: isLocalOpen,
        filter: (0, $2EfXQ.isAtCurrentMenuLevel)
    });
    // Close on menu item click.
    // Close when a regular menuitem is clicked, but not checkboxes/radios
    // and not nested triggers (items with aria-haspopup).
    var handleMenuClick = (0, $5FkrB.useCallback)(function(e) {
        var _e$target$closest, _e$target;
        if (!(e.target instanceof Element)) return;
        var menuItem = (_e$target$closest = (_e$target = e.target).closest) === null || _e$target$closest === void 0 ? void 0 : _e$target$closest.call(_e$target, '[role="menuitem"], [role="menuitemcheckbox"], [role="menuitemradio"]');
        if (!menuItem) return;
        var isCheckboxOrRadio = menuItem.getAttribute('role') === 'menuitemcheckbox' || menuItem.getAttribute('role') === 'menuitemradio';
        // Do not close the menu when clicking a nested trigger (aria-haspopup).
        // The nested dropdown will handle its own open/close.
        var isNestedTrigger = menuItem.hasAttribute('aria-haspopup');
        if (!isCheckboxOrRadio && !isNestedTrigger) {
            setLocalIsOpen(false);
            onOpenChange({
                isOpen: false,
                event: e.nativeEvent
            });
        }
    }, [
        setLocalIsOpen,
        onOpenChange
    ]);
    var ariaAttributes = (0, $aEy4n.getAriaForTrigger)({
        role: 'menu',
        isOpen: isLocalOpen,
        popoverId: popoverId
    });
    // FUDGE(top-layer-api): cast `aria-haspopup` to the narrow shape that adopter
    // public types expect. `@atlaskit/top-layer` types `aria-haspopup` as the wider
    // WAI-ARIA union, but the public `CustomTriggerProps` (extending `@atlaskit/popup`
    // `TriggerProps`) is intentionally kept narrow (`boolean | 'dialog'`) because the
    // top-layer API surface is not yet settled. The runtime value is unchanged; only
    // the TypeScript-visible type is narrowed at this boundary.
    var narrowAriaAttributes = ariaAttributes;
    /**
   * Custom trigger consumers historically receive a callback ref,
   * and their code assumes it is one.
   * Using this wrapper for compatibility...
   */ var setTriggerRef = (0, $5FkrB.useCallback)(function(node) {
        triggerRef.current = node;
    }, []);
    var renderTrigger = function renderTrigger() {
        if (typeof trigger === 'function') return trigger($6e4b0381575c2ec4$var$_objectSpread($6e4b0381575c2ec4$var$_objectSpread({}, narrowAriaAttributes), {}, {
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            triggerRef: setTriggerRef,
            isSelected: isLocalOpen,
            onClick: handleTriggerClicked,
            testId: testId && "".concat(testId, "--trigger")
        }));
        return /*#__PURE__*/ $5FkrB.createElement((0, $dUWEU.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            ref: setTriggerRef
        }, narrowAriaAttributes, {
            isSelected: isLocalOpen,
            iconAfter: function iconAfter(iconProps) {
                return /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($h19KG))), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, iconProps, {
                    size: "small"
                }));
            },
            onClick: handleTriggerClicked,
            testId: testId && "".concat(testId, "--trigger"),
            "aria-label": label,
            interactionName: interactionName
        }), trigger);
    };
    return /*#__PURE__*/ $5FkrB.createElement((0, $1jaJ9.default), null, renderTrigger(), /*#__PURE__*/ $5FkrB.createElement((0, $fcful.Popover), {
        ref: popoverRef,
        id: popoverId,
        role: "menu",
        label: (_ref5 = menuLabel !== null && menuLabel !== void 0 ? menuLabel : label) !== null && _ref5 !== void 0 ? _ref5 : typeof trigger === 'string' ? trigger : 'Menu',
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        shouldAnimate: true,
        placement: topLayerPlacement,
        testId: testId && "".concat(testId, "--content")
    }, /*#__PURE__*/ $5FkrB.createElement((0, $hEyq2.PopoverSurface), null, /*#__PURE__*/ $5FkrB.createElement((0, $6xFrB.default), {
        maxHeight: $6e4b0381575c2ec4$var$MAX_HEIGHT,
        maxWidth: shouldFitContainer ? undefined : 800,
        onClick: handleMenuClick,
        spacing: spacing,
        testId: testId && "".concat(testId, "--menu-wrapper--menu-group")
    }, isLoading ? /*#__PURE__*/ $5FkrB.createElement($6e4b0381575c2ec4$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && "".concat(testId, "--menu-wrapper--loading-indicator")
    }) : children))));
}
var $6e4b0381575c2ec4$export$2e2bcd8739ae039 = $6e4b0381575c2ec4$var$DropdownMenuTopLayer;

});
parcelRegister("6xFrB", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c35f91febbc7ca1$export$2e2bcd8739ae039);
/* menu-group.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $9CqML = parcelRequire("9CqML");

var $bXzol = parcelRequire("bXzol");
var $4c35f91febbc7ca1$var$_excluded = [
    "isLoading",
    "maxWidth",
    "minWidth",
    "minHeight",
    "maxHeight",
    "testId",
    "role",
    "spacing",
    "menuLabel",
    "className"
];
var $4c35f91febbc7ca1$var$baseStyles = null;
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $4c35f91febbc7ca1$var$MenuGroup = function MenuGroup(_ref) {
    var isLoading = _ref.isLoading, maxWidth = _ref.maxWidth, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, testId = _ref.testId, role = _ref.role, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'cozy' : _ref$spacing, menuLabel = _ref.menuLabel, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $4c35f91febbc7ca1$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement((0, $9CqML.SpacingContext).Provider, {
        value: spacing
    }, /*#__PURE__*/ $5FkrB.createElement((0, $bXzol.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "border"
    }, /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        "data-testid": testId,
        role: role,
        className: (0, $970q7.default)([
            "_1reo1wug _18m91wug _1e0c1txw _kqswpfqs _2lx21bp4",
            UNSAFE_className
        ]),
        "aria-label": menuLabel
    }, rest))));
};
var $4c35f91febbc7ca1$export$2e2bcd8739ae039 = $4c35f91febbc7ca1$var$MenuGroup;

});
parcelRegister("9CqML", function(module, exports) {
$parcel$export(module.exports, "SpacingContext", () => $01cea6fab91f51f7$export$443076ec7ebce042);

var $5FkrB = parcelRequire("5FkrB");

var $01cea6fab91f51f7$export$443076ec7ebce042 = /*#__PURE__*/ (0, $5FkrB.createContext)('cozy');

});

parcelRegister("bXzol", function(module, exports) {
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", () => $8b50a86dacab0fa0$export$9ca534b70725964d);

var $5FkrB = parcelRequire("5FkrB");
var $8b50a86dacab0fa0$export$9ca534b70725964d = /*#__PURE__*/ (0, $5FkrB.createContext)('border');

});


parcelRegister("aEy4n", function(module, exports) {
$parcel$export(module.exports, "getAriaForTrigger", () => $7c1811553882724a$export$9dd1d61dd4d4755);
/**
 * Roles accepted by `getAriaForTrigger`.
 *
 * Excludes tooltip-family roles (`tooltip`, `note`, `status`, `alert`, `log`)
 * because the correct trigger wiring for those is `aria-describedby`, not
 * `aria-haspopup` / `aria-expanded` / `aria-controls`. Use `aria-describedby`
 * manually for tooltip triggers.
 */ /**
 * Valid values for the `aria-haspopup` attribute.
 *
 * Derived from the HTML spec - maps popover roles to what the trigger
 * announces. `undefined` means the attribute is omitted entirely (used for
 * non-popup roles like `tooltip`/`status`/`alert`/`note`/`log` where
 * `aria-haspopup` would be misleading).
 *
 * `true` is intentionally NOT in the union - the runtime only ever produces
 * the explicit string forms, so widening the type would invite consumers to
 * pass `true` and get an `aria-haspopup="true"` serialisation that the
 * runtime no longer emits.
 */ /**
 * Non-undefined subset of `TAriaHasPopupValue`. Every role accepted by
 * `getAriaForTrigger` maps to a concrete `aria-haspopup` string, so the
 * trigger always receives a defined attribute value.
 */ var $7c1811553882724a$var$roleToAriaHasPopup = {
    dialog: 'dialog',
    alertdialog: 'dialog',
    menu: 'menu',
    listbox: 'listbox',
    tree: 'tree',
    grid: 'grid'
};
function $7c1811553882724a$export$9dd1d61dd4d4755(_ref) {
    var role = _ref.role, isOpen = _ref.isOpen, popoverId = _ref.popoverId;
    // `aria-controls` is set to `undefined` while closed. The `Popover` /
    // `Dialog` primitives unmount their host element after the exit
    // animation finishes, so a closed-state `aria-controls` would point
    // at a node that is not in the DOM. Returning `undefined` here means
    // JSX spread renders no `aria-controls` attribute on the trigger
    // until the target exists, avoiding the dangling reference while
    // keeping the relationship live whenever it is meaningful.
    return {
        'aria-haspopup': $7c1811553882724a$var$roleToAriaHasPopup[role],
        'aria-expanded': isOpen,
        'aria-controls': isOpen ? popoverId : undefined
    };
}

});

parcelRegister("lSYUF", function(module, exports) {
$parcel$export(module.exports, "fromLegacyPlacement", () => $feede424fdeb9dd7$export$69e99ed50b2534c9);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $jn8yt = parcelRequire("jn8yt");
function $feede424fdeb9dd7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $feede424fdeb9dd7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $feede424fdeb9dd7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $feede424fdeb9dd7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $feede424fdeb9dd7$export$69e99ed50b2534c9(_ref) {
    var legacy = _ref.legacy, offset = _ref.offset;
    var basePlacement = (0, $jn8yt.placementMapping)[legacy];
    if (!offset) return basePlacement;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(offset, 2), along = _offset[0], away = _offset[1];
    return $feede424fdeb9dd7$var$_objectSpread($feede424fdeb9dd7$var$_objectSpread({}, basePlacement), {}, {
        offset: {
            gap: away,
            crossAxisShift: {
                // Sign is captured in `direction`; `value` is the magnitude.
                value: Math.abs(along),
                direction: along >= 0 ? 'forwards' : 'backwards'
            }
        }
    });
}

});
parcelRegister("jn8yt", function(module, exports) {
$parcel$export(module.exports, "placementMapping", () => $e1a6cd28504a494c$export$27df359c528b7120);
/**
 * The full mapping record. Internal - use `fromLegacyPlacement` from the
 * public entry-point so the offset-tuple translation is applied consistently.
 *
 * Note: `auto`, `auto-start`, `auto-end` map to `block-end` placements. This
 * is a reduction in expressiveness vs Popper.js (which picked the best
 * placement at runtime). CSS `position-try-fallbacks` flips at the edge but
 * the initial placement is fixed. Migration consumers who relied on Popper's
 * dynamic auto-flip should pick an explicit placement instead.
 */ var $e1a6cd28504a494c$export$27df359c528b7120 = {
    top: {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'start'
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'end'
    },
    bottom: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    },
    right: {
        axis: 'inline',
        edge: 'end',
        align: 'center'
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'start'
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'end'
    },
    left: {
        axis: 'inline',
        edge: 'start',
        align: 'center'
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'start'
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'end'
    },
    auto: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'auto-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'auto-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    }
};

});


parcelRegister("fcful", function(module, exports) {
$parcel$export(module.exports, "Popover", () => $b103fdb0f1d92e4d$export$5b6b19405a83ff9d);
/* popover.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $hUFig = parcelRequire("hUFig");

var $7QpUe = parcelRequire("7QpUe");

var $iO8GM = parcelRequire("iO8GM");

var $bvsoE = parcelRequire("bvsoE");

var $4wcqh = parcelRequire("4wcqh");

var $2ZFRH = parcelRequire("2ZFRH");

var $atnoy = parcelRequire("atnoy");

var $cz3XU = parcelRequire("cz3XU");

var $aa6ww = parcelRequire("aa6ww");

var $75ERe = parcelRequire("75ERe");
/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ var $b103fdb0f1d92e4d$var$supportsPopoverHint = (0, $bvsoE.default)(function() {
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    var element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
// Surface reset — neutralises inherited interaction and text-layout properties
// (e.g. `pointer-events: none` from an overlaid controls container and
// `white-space: nowrap` from an `@atlaskit/select` option) that leak into a
// top-layer element because, for CSS inheritance, it is still a DOM child of its
// trigger (top-layer promotion is paint/stacking only; the legacy portal path
// avoided this by rendering at `<body>`). Excludes `color`/`font` (theming) and
// `direction`/`unicode-bidi` (RTL must inherit).
//
// KEEP IN SYNC with the identical `surfaceResetStyles` in `dialog/dialog-content.tsx`.
// ADS forbids sharing styles across files (`no-exported-styles` /
// `no-imported-style-values` — Compiled styles are null at runtime), so the reset is
// co-located and duplicated deliberately.
var $b103fdb0f1d92e4d$var$surfaceResetStyles = {
    root: "_lcxv1wug _o5724jg8 _1nmz4jg8 _1i4q4jg8 _y3gnv2br _azhwidpf _1p1dglyw"
};
var $b103fdb0f1d92e4d$var$styles = {
    root: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r041wug _1reoewfl _18m9ewfl _bfhk1j28 _4t3i1wug",
    motion: "_k8m011k7 _1oecdn4k _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v179n",
    exit: "_y44vof1f"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
var $b103fdb0f1d92e4d$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ var $b103fdb0f1d92e4d$var$POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
var $b103fdb0f1d92e4d$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function Popover(_ref, ref) {
    var children = _ref.children, _ref$mode = _ref.mode, modeProp = _ref$mode === void 0 ? 'auto' : _ref$mode, onClose = _ref.onClose, onEnterFinish = _ref.onEnterFinish, onExitFinish = _ref.onExitFinish, _ref$shouldAnimate = _ref.shouldAnimate, shouldAnimate = _ref$shouldAnimate === void 0 ? false : _ref$shouldAnimate, placement = _ref.placement, testId = _ref.testId, isOpen = _ref.isOpen, enteringAnimationXcss = _ref.enteringAnimationXcss, exitingAnimationXcss = _ref.exitingAnimationXcss, role = _ref.role, label = _ref.label, labelledBy = _ref.labelledBy, idProp = _ref.id;
    var autoId = (0, $5FkrB.useId)();
    var ownRef = (0, $5FkrB.useRef)(null);
    var combinedRef = (0, $iO8GM.default)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    var popoverId = idProp !== null && idProp !== void 0 ? idProp : "popover-".concat(autoId.replace(/:/g, ''));
    var _useAnimatedVisibilit = (0, $cz3XU.useAnimatedVisibility)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    }), phase = _useAnimatedVisibilit.phase, onToggle = _useAnimatedVisibilit.onToggle;
    // True while the host element is mounted (any phase except `closed`).
    // Used as a dep so listener-rebind effects re-attach after a remount.
    var isVisible = phase !== 'closed';
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // focus-capturing roles are handled below via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus-restoration.md.
    (0, $aa6ww.useFocusWrap)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    (0, $75ERe.useInitialFocus)({
        elementRef: ownRef,
        phase: phase,
        role: role
    });
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined.
    var handleObserverClose = (0, $5FkrB.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose({
            reason: 'programmatic'
        });
    }, [
        onClose
    ]);
    (0, $4wcqh.useNotifyOpenLayerObserver)({
        type: role && $b103fdb0f1d92e4d$var$POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen: isOpen,
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    var mode = modeProp === 'hint' && !$b103fdb0f1d92e4d$var$supportsPopoverHint() ? 'auto' : modeProp;
    var popupMotionStyle = (0, $5FkrB.useMemo)(function() {
        if (!placement || !shouldAnimate) return undefined;
        var _resolvePlacement = (0, $2ZFRH.resolvePlacement)({
            placement: placement
        }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge;
        return $b103fdb0f1d92e4d$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]);
    // Prevents toggle handler from calling onClose for our own hidePopover() calls.
    var programmaticCloseRef = (0, $5FkrB.useRef)(false);
    // Set in capture-phase keydown so the toggle handler knows close reason.
    var closeReasonRef = (0, $5FkrB.useRef)('light-dismiss');
    // Snapshot of pre-open focus, used to restore focus for nested popovers
    // with focus-capturing roles (browser only restores the outermost).
    var previouslyFocusedElementRef = (0, $5FkrB.useRef)(null);
    var handleBeforeToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState !== 'open') return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- need active element snapshot
        var active = document.activeElement;
        previouslyFocusedElementRef.current = active instanceof HTMLElement ? active : null;
    }, []);
    var handleToggle = (0, $5FkrB.useCallback)(function(event) {
        var element = ownRef.current;
        if (event.newState === 'open') {
            onToggle(event);
            return;
        }
        if (event.newState === 'closed') {
            if (element) {
                // Nested-popover focus restoration fallback (browser only
                // restores outermost; Firefox skips nested entirely).
                // Restore only when the role moved focus in on open AND the
                // close was Escape/programmatic. For light dismiss, the
                // click target keeps focus per HTML spec
                // (`focusPreviousElement=false`).
                var previouslyFocused = previouslyFocusedElementRef.current;
                var reason = closeReasonRef.current;
                var isProgrammatic = programmaticCloseRef.current;
                var shouldRestore = previouslyFocused !== null && previouslyFocused.isConnected && (0, $atnoy.shouldFocusIntoPopover)({
                    role: role
                }) && (reason === 'escape' || isProgrammatic);
                if (shouldRestore && previouslyFocused) previouslyFocused.focus({
                    preventScroll: true
                });
                previouslyFocusedElementRef.current = null;
            }
            // Programmatic close: consumer already knows.
            if (programmaticCloseRef.current) // Reset reason so a stale 'escape' from a race with Escape keydown
            // does not corrupt the next browser-dismiss cycle.
            closeReasonRef.current = 'light-dismiss';
            else {
                // Browser dismiss (Escape/click-outside).
                var _reason = closeReasonRef.current;
                closeReasonRef.current = 'light-dismiss';
                // Optional: `manual` mode has no `onClose` in the forwarded type.
                onClose === null || onClose === void 0 || onClose({
                    reason: _reason
                });
            }
        }
        onToggle(event);
    }, [
        onClose,
        onToggle,
        role
    ]);
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `previouslyFocusedElementRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        var unbindEscape = (0, $7QpUe.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key === 'Escape') closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        var unbindToggle = (0, $7QpUe.bind)(element, {
            type: 'toggle',
            listener: handleToggle
        });
        // Snapshot `document.activeElement` before `useInitialFocus` moves it.
        var unbindBeforeToggle = (0, $7QpUe.bind)(element, {
            type: 'beforetoggle',
            listener: handleBeforeToggle
        });
        return function() {
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleToggle,
        handleBeforeToggle,
        isVisible
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            programmaticCloseRef.current = false;
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and the no-animation path unmounts before
            // `handleToggle` can reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch (_unused) {}
            return function() {
                programmaticCloseRef.current = true;
                try {
                    element.hidePopover();
                } catch (_unused2) {}
            };
        }
        programmaticCloseRef.current = true;
        try {
            element.hidePopover();
        } catch (_unused3) {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        ref: combinedRef,
        id: popoverId,
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        style: popupMotionStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $b103fdb0f1d92e4d$var$styles.root,
            $b103fdb0f1d92e4d$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $b103fdb0f1d92e4d$var$styles.enter,
            shouldAnimate && phase === 'exiting' && $b103fdb0f1d92e4d$var$styles.exit,
            shouldAnimate && $b103fdb0f1d92e4d$var$styles.motion,
            (0, $hUFig.cx)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ])
    }, children);
});

});
parcelRegister("4wcqh", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $34a3c981fe907f22$export$469bb693f11edc7f);

var $5FkrB = parcelRequire("5FkrB");

var $21w4e = parcelRequire("21w4e");

var $8UK3T = parcelRequire("8UK3T");
function $34a3c981fe907f22$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $21w4e.OpenLayerObserverContext));
    var namespace = (0, $8UK3T.useOpenLayerObserverNamespace)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("21w4e", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $17948ca43843fb75$export$5fbf4d7fae6cdc00);

var $5FkrB = parcelRequire("5FkrB");
var $17948ca43843fb75$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});

parcelRegister("8UK3T", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $67d7489478f8f6fa$export$1d57e79091cc3046);

var $5FkrB = parcelRequire("5FkrB");

var $h41FW = parcelRequire("h41FW");
function $67d7489478f8f6fa$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $h41FW.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("h41FW", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $c6c41c147e6273c5$export$644a49f3b8c50fcd);

var $5FkrB = parcelRequire("5FkrB");
var $c6c41c147e6273c5$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});



parcelRegister("2ZFRH", function(module, exports) {
$parcel$export(module.exports, "resolvePlacement", () => $22e1c0cfc4927867$export$63044d21bc3d3fa2);

var $bWgOU = parcelRequire("bWgOU");
/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ var $22e1c0cfc4927867$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $22e1c0cfc4927867$export$63044d21bc3d3fa2(_ref) {
    var _placement$offset, _placement$axis, _placement$edge, _placement$align, _placement$offset$cro, _placement$offset2, _placement$offset$cro2, _placement$offset3;
    var placement = _ref.placement;
    var consumerGap = (_placement$offset = placement.offset) === null || _placement$offset === void 0 ? void 0 : _placement$offset.gap;
    return {
        axis: (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block',
        edge: (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end',
        align: (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center',
        offset: {
            gap: consumerGap === undefined ? $22e1c0cfc4927867$var$DEFAULT_GAP : (0, $bWgOU.toCssLengthString)({
                value: consumerGap
            }),
            crossAxisShift: {
                value: (0, $bWgOU.toCssLengthString)({
                    value: (_placement$offset$cro = (_placement$offset2 = placement.offset) === null || _placement$offset2 === void 0 || (_placement$offset2 = _placement$offset2.crossAxisShift) === null || _placement$offset2 === void 0 ? void 0 : _placement$offset2.value) !== null && _placement$offset$cro !== void 0 ? _placement$offset$cro : 0
                }),
                direction: (_placement$offset$cro2 = (_placement$offset3 = placement.offset) === null || _placement$offset3 === void 0 || (_placement$offset3 = _placement$offset3.crossAxisShift) === null || _placement$offset3 === void 0 ? void 0 : _placement$offset3.direction) !== null && _placement$offset$cro2 !== void 0 ? _placement$offset$cro2 : 'forwards'
            }
        }
    };
}

});
parcelRegister("bWgOU", function(module, exports) {
$parcel$export(module.exports, "toCssLengthString", () => $8b12289acf867772$export$63b6b0ff65d84d47);
/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $8b12289acf867772$export$63b6b0ff65d84d47(_ref) {
    var value = _ref.value;
    if (typeof value === 'number') return "".concat(value, "px");
    return value;
}

});


parcelRegister("atnoy", function(module, exports) {
$parcel$export(module.exports, "shouldFocusIntoPopover", () => $79fec293ca75466f$export$b12adccf56228c71);
var $79fec293ca75466f$var$rolesThatMoveFocus = new Set([
    'dialog',
    'alertdialog',
    'menu',
    'listbox',
    'tree',
    'grid'
]);
function $79fec293ca75466f$export$b12adccf56228c71(_ref) {
    var role = _ref.role;
    if (!role) return false;
    return $79fec293ca75466f$var$rolesThatMoveFocus.has(role);
}

});

parcelRegister("cz3XU", function(module, exports) {
$parcel$export(module.exports, "useAnimatedVisibility", () => $925bd4562e5dc5b7$export$1bccb45daf07907f);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $2oJJA = parcelRequire("2oJJA");
function $925bd4562e5dc5b7$var$runCancellableSettlement(_ref) {
    var schedule = _ref.schedule, onSettled = _ref.onSettled;
    var isCancelled = false;
    schedule(function() {
        if (isCancelled) return;
        onSettled();
    });
    return function() {
        isCancelled = true;
    };
}
/**
 * Fires `onSettled` once all animations currently applied to `element`
 * finish or are cancelled. Returns a cleanup that prevents stale settlement.
 */ function $925bd4562e5dc5b7$var$runOnAnimationsSettled(_ref2) {
    var element = _ref2.element, onSettled = _ref2.onSettled;
    return $925bd4562e5dc5b7$var$runCancellableSettlement({
        onSettled: onSettled,
        schedule: function schedule(settle) {
            var _element$getAnimation, _element$getAnimation2;
            var animations = (_element$getAnimation = (_element$getAnimation2 = element.getAnimations) === null || _element$getAnimation2 === void 0 ? void 0 : _element$getAnimation2.call(element)) !== null && _element$getAnimation !== void 0 ? _element$getAnimation : [];
            Promise.allSettled(animations.map(function(animation) {
                return animation.finished;
            })).then(settle);
        }
    });
}
function $925bd4562e5dc5b7$export$1bccb45daf07907f(_ref3) {
    var isOpen = _ref3.isOpen, shouldAnimate = _ref3.shouldAnimate, elementRef = _ref3.elementRef, onEnterFinish = _ref3.onEnterFinish, onExitFinish = _ref3.onExitFinish;
    var willAnimate = shouldAnimate && !(0, $2oJJA.prefersReducedMotion)();
    var isNativeClosedRef = (0, $5FkrB.useRef)(false);
    // Promote `closed → entering`/`closed → open` synchronously during
    // render so the host element mounts in the same commit as the open
    // intent. All other transitions are driven by phase-specific effects.
    var _useState = (0, $5FkrB.useState)(function() {
        if (!isOpen) return 'closed';
        return willAnimate ? 'entering' : 'open';
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), phase = _useState2[0], setPhase = _useState2[1];
    // Rearm only after controlled state and the native lifecycle have both
    // reached closed. Resetting as soon as `isOpen` becomes false can erase a
    // closing toggle that was handled in the same React batch.
    if (!isOpen && phase === 'closed') isNativeClosedRef.current = false;
    if (isOpen && phase === 'closed' && !isNativeClosedRef.current) setPhase(willAnimate ? 'entering' : 'open');
    if (!isOpen && (phase === 'open' || phase === 'entering')) // Close intent. Move to `exiting` to gate the unmount on either
    // the exit transition (animated) or the closing toggle event
    // (non-animated). Includes interrupted entry (`entering → exiting`).
    setPhase('exiting');
    if (isOpen && phase === 'exiting' && !isNativeClosedRef.current) // Reopen mid-exit. With animation, jump back to `entering` and let
    // the entry transition restart from current visual state. Without
    // animation, jump straight to `open` (the handshake we were waiting
    // for is no longer relevant; the consumer wants the host visible
    // again synchronously).
    setPhase(willAnimate ? 'entering' : 'open');
    // Keep stable refs to the latest callbacks so effects and promise callbacks
    // always call the current callback without needing them in dependency arrays.
    var onEnterFinishRef = (0, $5FkrB.useRef)(onEnterFinish);
    onEnterFinishRef.current = onEnterFinish;
    var onExitFinishRef = (0, $5FkrB.useRef)(onExitFinish);
    onExitFinishRef.current = onExitFinish;
    // Animated entry: wait for all active animations and move to `open`.
    (0, $5FkrB.useEffect)(function() {
        if (phase !== 'entering') return;
        var element = elementRef.current;
        if (!element) return;
        return $925bd4562e5dc5b7$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                var _onEnterFinishRef$cur;
                // Fire the consumer callback before transitioning phase so any
                // state the consumer reads (refs, DOM nodes) is still attached
                // in the same synchronous tick, regardless of React batching
                // semantics.
                (_onEnterFinishRef$cur = onEnterFinishRef.current) === null || _onEnterFinishRef$cur === void 0 || _onEnterFinishRef$cur.call(onEnterFinishRef);
                setPhase(function(current) {
                    return current === 'entering' ? 'open' : current;
                });
            }
        });
    }, [
        phase,
        elementRef
    ]);
    // Non-animated entry callback. The lifecycle goes `closed → open`
    // directly with no `entering` phase; fire `onEnterFinish` on that jump.
    // A previous-phase ref avoids double-firing on the animated path.
    var prevPhaseForEntryRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForEntryRef.current;
        prevPhaseForEntryRef.current = phase;
        // Animated entry settle goes through `entering` and already fired
        // onEnterFinish above; only handle the non-animated direct jumps.
        if (prevPhase !== 'open' && phase === 'open' && prevPhase !== 'entering') {
            var _onEnterFinishRef$cur2;
            (_onEnterFinishRef$cur2 = onEnterFinishRef.current) === null || _onEnterFinishRef$cur2 === void 0 || _onEnterFinishRef$cur2.call(onEnterFinishRef);
        }
    }, [
        phase
    ]);
    // Animated exit: wait for all active animations, fire `onExitFinish`,
    // then move to `closed` to unmount the host.
    (0, $5FkrB.useEffect)(function() {
        if (phase !== 'exiting' || !willAnimate) return;
        var element = elementRef.current;
        if (!element) return;
        return $925bd4562e5dc5b7$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                var _onExitFinishRef$curr;
                // Fire the consumer callback before transitioning phase to
                // `closed`. The phase change drives the host element unmount,
                // and consumers expect to be able to read the element (or a
                // forwarded ref to it) inside `onExitFinish`. Doing this in
                // the safe order avoids relying on React's automatic batching
                // to keep the element attached across the callback.
                (_onExitFinishRef$curr = onExitFinishRef.current) === null || _onExitFinishRef$curr === void 0 || _onExitFinishRef$curr.call(onExitFinishRef);
                setPhase(function(current) {
                    return current === 'exiting' ? 'closed' : current;
                });
            }
        });
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    // Native dismissal is authoritative. Its toggle can arrive while controlled
    // state still says open, so remember that native state and do not
    // reopen until `isOpen` has first moved to false.
    (0, $5FkrB.useLayoutEffect)(function() {
        if (phase === 'exiting' && !willAnimate && isNativeClosedRef.current) setPhase('closed');
    }, [
        phase,
        willAnimate
    ]);
    var onToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState === 'open') {
            isNativeClosedRef.current = false;
            return;
        }
        if (event.newState !== 'closed') return;
        isNativeClosedRef.current = true;
        setPhase(function(current) {
            if (current === 'open' || current === 'entering') return 'exiting';
            if (current === 'exiting' && !willAnimate) return 'closed';
            return current;
        });
    }, [
        willAnimate
    ]);
    // Non-animated exit callback. There are no animations to wait for, so fire
    // `onExitFinish` on the transition into `exiting` (the unmount itself
    // is gated by the closing toggle handshake above).
    var prevPhaseForExitRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForExitRef.current;
        prevPhaseForExitRef.current = phase;
        // Only fire on the non-animated transition into `exiting`. The
        // animated path's `exiting → closed` settle already fires
        // `onExitFinish` from `runOnAnimationsSettled`.
        if (prevPhase !== 'exiting' && phase === 'exiting' && !willAnimate) {
            var _onExitFinishRef$curr2;
            (_onExitFinishRef$curr2 = onExitFinishRef.current) === null || _onExitFinishRef$curr2 === void 0 || _onExitFinishRef$curr2.call(onExitFinishRef);
        }
    }, [
        phase,
        willAnimate
    ]);
    return {
        phase: phase,
        onToggle: onToggle
    };
}

});
parcelRegister("2oJJA", function(module, exports) {
$parcel$export(module.exports, "prefersReducedMotion", () => $1bf14c879282be56$export$ff7706047246b98b);

var $bvsoE = parcelRequire("bvsoE");
var $1bf14c879282be56$export$ff7706047246b98b = (0, $bvsoE.default)(function() {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});

});


parcelRegister("aa6ww", function(module, exports) {
$parcel$export(module.exports, "useFocusWrap", () => $765fe5fd152dd74a$export$4f6462e86a70abe5);

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $1etIZ = parcelRequire("1etIZ");

var $5NxlG = parcelRequire("5NxlG");

var $46sQV = parcelRequire("46sQV");

var $74R1X = parcelRequire("74R1X");
/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/outputs/menu-keyboard-decision.md
 */ function $765fe5fd152dd74a$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $765fe5fd152dd74a$export$4f6462e86a70abe5(_ref) {
    var elementRef = _ref.elementRef, role = _ref.role, phase = _ref.phase;
    var isVisible = phase !== 'closed';
    (0, $5FkrB.useEffect)(function() {
        var element = elementRef.current;
        if (!element || !$765fe5fd152dd74a$var$roleRequiresFocusWrap(role) || !isVisible) return;
        var unbind = (0, $7QpUe.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $74R1X.isNestedLayerFocused)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                var direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                var next = (0, $46sQV.getNextFocusable)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                var fallback = direction === 'forwards' ? (0, $1etIZ.getFirstFocusable)({
                    container: element
                }) : (0, $5NxlG.getLastFocusable)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}

});
parcelRegister("1etIZ", function(module, exports) {
$parcel$export(module.exports, "getFirstFocusable", () => $0e5e27f156f9e55c$export$748138f04a69bf21);

var $95hCA = parcelRequire("95hCA");
function $0e5e27f156f9e55c$export$748138f04a69bf21(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $95hCA.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}

});
parcelRegister("95hCA", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $69d23fe834b3fb9c$export$f6768025e418420e);

var $9X2K4 = parcelRequire("9X2K4");

var $6j44T = parcelRequire("6j44T");
function $69d23fe834b3fb9c$export$f6768025e418420e(_ref) {
    var container = _ref.container, filter = _ref.filter;
    return Array.from(container.querySelectorAll((0, $6j44T.selectors).focusable)).filter(function(element) {
        return element instanceof HTMLElement;
    }).filter(function(element) {
        return (0, $9X2K4.isInSameLayer)({
            element: element,
            container: container
        });
    }).filter(function(element) {
        return !filter || filter(element, container);
    });
}

});
parcelRegister("9X2K4", function(module, exports) {
$parcel$export(module.exports, "isInSameLayer", () => $73ebc049180c91cb$export$df8c72c64edc7260);
var $73ebc049180c91cb$var$topLayerSelector = '[popover], dialog, [role="dialog"], [role="alertdialog"]';
function $73ebc049180c91cb$export$df8c72c64edc7260(_ref) {
    var element = _ref.element, container = _ref.container;
    return element.closest($73ebc049180c91cb$var$topLayerSelector) === container.closest($73ebc049180c91cb$var$topLayerSelector);
}

});

parcelRegister("6j44T", function(module, exports) {
$parcel$export(module.exports, "selectors", () => $4977ae3c1c93dcaf$export$e1252723db1c541);
var $4977ae3c1c93dcaf$export$e1252723db1c541 = function() {
    // Common exclusion filter applied to every selector.
    var not = ':not([tabindex="-1"]):not([aria-disabled="true"]):not([aria-hidden="true"])';
    var notDisabled = ":not([disabled])".concat(not);
    var focusable = [
        "a[href]".concat(not),
        "area[href]".concat(not),
        "input".concat(notDisabled, ":not([type=\"hidden\"])"),
        "select".concat(notDisabled),
        "textarea".concat(notDisabled),
        "button".concat(notDisabled),
        "iframe".concat(not),
        "audio[controls]".concat(not),
        "video[controls]".concat(not),
        "[contenteditable]:not([contenteditable=\"false\"])".concat(not),
        "[tabindex]".concat(notDisabled)
    ];
    return {
        focusable: focusable.join(','),
        // Build the `:focus` selector
        focused: focusable.map(function(selector) {
            return "".concat(selector, ":focus");
        }).join(',')
    };
}();

});



parcelRegister("5NxlG", function(module, exports) {
$parcel$export(module.exports, "getLastFocusable", () => $438b65b604e8b00d$export$73e81fa65335a75b);

var $95hCA = parcelRequire("95hCA");
function $438b65b604e8b00d$export$73e81fa65335a75b(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $95hCA.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}

});

parcelRegister("46sQV", function(module, exports) {
$parcel$export(module.exports, "getNextFocusable", () => $2fce1a829520f0be$export$a7db88e6d491b450);
/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * Returns `null` if there is no focused element within the container or if
 * the focused element is not in the list of focusable elements.
 */ 
var $95hCA = parcelRequire("95hCA");

var $6j44T = parcelRequire("6j44T");
function $2fce1a829520f0be$export$a7db88e6d491b450(_ref) {
    var _all$nextIndex;
    var container = _ref.container, direction = _ref.direction, filter = _ref.filter;
    var all = (0, $95hCA.getFocusables)({
        container: container,
        filter: filter
    });
    var current = container.querySelector((0, $6j44T.selectors).focused);
    if (!(current instanceof HTMLElement)) return null;
    var index = all.indexOf(current);
    if (index === -1) return null;
    var nextIndex = function() {
        if (direction === 'forwards') return (index + 1) % all.length;
        var proposed = index - 1;
        // if going into negative numbers, loop back to the last item
        return proposed < 0 ? all.length - 1 : proposed;
    }();
    return (_all$nextIndex = all[nextIndex]) !== null && _all$nextIndex !== void 0 ? _all$nextIndex : null;
}

});

parcelRegister("74R1X", function(module, exports) {
$parcel$export(module.exports, "isNestedLayerFocused", () => $52720adf1c8420fe$export$b9590fdfeb5f722f);

var $lFhdZ = parcelRequire("lFhdZ");

var $9X2K4 = parcelRequire("9X2K4");
function $52720adf1c8420fe$export$b9590fdfeb5f722f(_ref) {
    var _getDocument;
    var container = _ref.container;
    var focused = (_getDocument = (0, $lFhdZ.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return !(0, $9X2K4.isInSameLayer)({
        element: focused,
        container: container
    });
}

});


parcelRegister("75ERe", function(module, exports) {
$parcel$export(module.exports, "useInitialFocus", () => $5298b17c822202ac$export$e992c40175757a22);

var $5FkrB = parcelRequire("5FkrB");

var $1etIZ = parcelRequire("1etIZ");
/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox regardless of role. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, or menu), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
var $5298b17c822202ac$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $5298b17c822202ac$var$isTextboxLikeElement(element) {
    var role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    var tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        var _element$getAttribute;
        var type = ((_element$getAttribute = element.getAttribute('type')) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : 'text').toLowerCase();
        return $5298b17c822202ac$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $5298b17c822202ac$var$isComboboxControllingPopup(_ref) {
    var _active$getAttribute;
    var container = _ref.container;
    var ownerDocument = container.ownerDocument;
    var active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$5298b17c822202ac$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    var idRefs = (_active$getAttribute = active.getAttribute('aria-controls')) !== null && _active$getAttribute !== void 0 ? _active$getAttribute : active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    var referencedIds = idRefs.split(/\s+/).filter(function(id) {
        return id !== '';
    });
    return referencedIds.some(function(id) {
        var referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function $5298b17c822202ac$var$getInitialFocusTarget(_ref2) {
    var container = _ref2.container, role = _ref2.role;
    if (role === 'dialog' || role === 'alertdialog') {
        // Prefer element with the native HTML autofocus attribute.
        var autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $1etIZ.getFirstFocusable)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific (menu / listbox) rather
    // than hoisted. Hoisting it over-matched on dialog popups that contain
    // a nested combobox (e.g. datetime-picker's dialog hosts a react-select),
    // where the active combobox's `aria-controls` falsely matched the
    // container and suppressed the dialog's own focus contract.
    if (role === 'menu') {
        if ($5298b17c822202ac$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/outputs/menu-keyboard-decision.md
        return (0, $1etIZ.getFirstFocusable)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($5298b17c822202ac$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        var selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        var firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $1etIZ.getFirstFocusable)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $5298b17c822202ac$export$e992c40175757a22(_ref3) {
    var elementRef = _ref3.elementRef, phase = _ref3.phase, role = _ref3.role;
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    var prevPhaseRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var _getInitialFocusTarge;
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        var element = elementRef.current;
        if (!element) return;
        (_getInitialFocusTarge = $5298b17c822202ac$var$getInitialFocusTarget({
            container: element,
            role: role
        })) === null || _getInitialFocusTarge === void 0 || _getInitialFocusTarge.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}

});


parcelRegister("hEyq2", function(module, exports) {
$parcel$export(module.exports, "PopoverSurface", () => $cda0def86655916a$export$8b7437164e479115);
/* popover-surface.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $cda0def86655916a$var$styles = {
    root: "_2rkofajl _1reo1wug _18m91wug _bfhk1bhr _syazi7uo _16qs130s"
};
function $cda0def86655916a$export$8b7437164e479115(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            $cda0def86655916a$var$styles.root
        ])
    }, children);
}

});

parcelRegister("a2YRu", function(module, exports) {
$parcel$export(module.exports, "useAnchorPosition", () => $75094d24ba4c1778$export$56b02a1e583f953c);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $45Zis = parcelRequire("45Zis");

var $bvsoE = parcelRequire("bvsoE");

var $2peaN = parcelRequire("2peaN");

var $fuCTG = parcelRequire("fuCTG");

var $jgGFa = parcelRequire("jgGFa");

var $kHdon = parcelRequire("kHdon");

var $5f8RE = parcelRequire("5f8RE");

var $2ZFRH = parcelRequire("2ZFRH");

var $2AlU3 = parcelRequire("2AlU3");
// `resolvePlacement` is intentionally NOT re-exported here - import it directly
// from `./resolve-placement` so search-and-jump lands at the source of truth.
/**
 * Module-scope no-op `ResizeObserver` used in non-DOM jest environments where
 * `ResizeObserver` is `undefined`. Hoisted out of the effect to avoid
 * allocating a new class declaration on every run.
 */ var $75094d24ba4c1778$var$NoopResizeObserver = /*#__PURE__*/ function() {
    function NoopResizeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoopResizeObserver);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoopResizeObserver, [
        {
            key: "observe",
            value: function observe() {}
        },
        {
            key: "unobserve",
            value: function unobserve() {}
        },
        {
            key: "disconnect",
            value: function disconnect() {}
        }
    ]);
}();
/**
 * Returns true when the popover is currently open. Wrapped because the
 * `:popover-open` pseudo-class is not implemented in some test environments
 * (e.g. jsdom), where `matches` throws on unknown selectors.
 */ function $75094d24ba4c1778$var$isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch (_unused) {
        return false;
    }
}
/**
 * Detects whether the browser supports CSS Anchor Positioning.
 * Uses `once()` for lazy evaluation: safe for SSR and avoids hydration mismatches.
 */ var $75094d24ba4c1778$var$supportsAnchorPositioning = (0, $bvsoE.default)(function() {
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('anchor-name', '--a');
});
/**
 * Every logical margin property this module can write: one per axis, per side.
 *
 * Deriving the union from `TPlacementAxis` and `TPlacementEdge` rather than
 * writing the four names out keeps it in step with the placement model, and
 * makes `CROSS_AXIS_SHIFT_CUSTOM_PROPERTY` below exhaustive by construction.
 */ /**
 * The custom property mirroring each cross-axis shift margin.
 *
 * These are written for the planned named arrow `@position-try` rules. Nothing
 * reads them yet, and the shift no longer depends on them: the antisymmetric
 * margins written by `crossAxisShiftMargins` survive a cross-axis slide on
 * their own.
 *
 * Keyed on `TLogicalMarginProperty` and not on `string`, so a margin property
 * that has no custom property (or a custom property whose margin no longer
 * exists) is a compile error rather than an `undefined` lookup that reaches
 * `setStyle` as `{ property: undefined, value }`.
 */ var $75094d24ba4c1778$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY = {
    'margin-inline-start': '--ds-cross-axis-shift-margin-start',
    'margin-inline-end': '--ds-cross-axis-shift-margin-end',
    'margin-block-start': '--ds-cross-axis-shift-margin-block-start',
    'margin-block-end': '--ds-cross-axis-shift-margin-block-end'
};
var $75094d24ba4c1778$var$ZEROED_CROSS_AXIS_SHIFT_CUSTOM_PROPERTIES = Object.values($75094d24ba4c1778$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY).map(function(property) {
    return {
        property: property,
        value: '0px'
    };
});
/**
 * Returns the CSS margin declaration that creates a gap between the
 * popover and its trigger on the side facing the anchor.
 *
 * For example, a `block-end` placement (popover below) gets
 * `margin-block-start: 8px` to push it away from the trigger's bottom edge.
 */ function $75094d24ba4c1778$var$edgeMargin(_ref) {
    var placement = _ref.placement, offset = _ref.offset;
    var axis = placement.axis, edge = placement.edge;
    // The gap sits on the side FACING the anchor, which is always the side
    // opposite the placement edge.
    var anchorFacingEdge = edge === 'end' ? 'start' : 'end';
    return {
        property: "margin-".concat(axis, "-").concat(anchorFacingEdge),
        value: offset
    };
}
/**
 * **The cross-axis shift margins.**
 *
 * The shift is written antisymmetrically on BOTH cross-axis sides
 * (`start: +value`, `end: -value`) rather than as a single margin on the side
 * picked from `align`. Two separate behaviours require it:
 *
 * 1. **`align: 'center'` is centered with `anchor-center`, which centers the
 *    popover's MARGIN box on the anchor.** A single-sided margin widens the
 *    margin box, so it displaces the border box by only half its value. An
 *    antisymmetric pair leaves the margin box width unchanged (`+value` and
 *    `-value` sum to zero) while moving its center by the full value.
 * 2. **`position-try-fallbacks` can slide the popover onto the opposite
 *    cross-axis side.** A `<position-area>` fallback keeps the base style's
 *    margins, and margin on the un-anchored side has no effect, so a
 *    single-sided margin is silently dropped once the browser slides across the
 *    cross axis. With both sides written, whichever side ends up anchored moves
 *    the popover the same physical direction.
 *
 * Leaving the margin box width unchanged also means the shift does not move
 * the point at which `position-try-fallbacks` decides the popover overflows.
 *
 * A `<try-tactic>` fallback (`flip-block`, `flip-inline`) behaves differently to
 * a `<position-area>` one: it SWAPS the start and end margins rather than
 * keeping them, which is what preserves the gap through a flip. So a flip across
 * the cross axis mirrors the shift along with the rest of the placement, rather
 * than preserving its physical direction. Only the diagonal fallback does that,
 * and only for `align: 'start' | 'end'`. See `placementToTryFallbacks`.
 *
 * A positive value always moves the popover toward the cross-axis END, so
 * `direction: 'forwards'` means the same thing for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 */ function $75094d24ba4c1778$var$crossAxisShiftMargins(_ref2) {
    var placement = _ref2.placement, crossAxisShiftCssValue = _ref2.crossAxisShiftCssValue, direction = _ref2.direction;
    var crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    // Wrap any string in calc() with the sign factor. CSS handles the math,
    // so opaque values such as design tokens negate correctly.
    var negated = "calc(-1 * ".concat(crossAxisShiftCssValue, ")");
    var isForwards = direction === 'forwards';
    return [
        {
            property: "margin-".concat(crossAxis, "-start"),
            value: isForwards ? crossAxisShiftCssValue : negated
        },
        {
            property: "margin-".concat(crossAxis, "-end"),
            value: isForwards ? negated : crossAxisShiftCssValue
        }
    ];
}
/**
 * Returns a referentially-stable, fully-resolved `TPlacement`. The memo is
 * keyed on the resolved primitive fields so a fresh inline `placement` object
 * (or undefined fields vs explicit defaults) does not produce a fresh result.
 */ function $75094d24ba4c1778$var$useStablePlacement(placement) {
    var resolved = (0, $2ZFRH.resolvePlacement)({
        placement: placement
    });
    var axis = resolved.axis;
    var edge = resolved.edge;
    var align = resolved.align;
    var gap = resolved.offset.gap;
    var shiftValue = resolved.offset.crossAxisShift.value;
    var shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuild inside the memo from primitive deps so the factory does not
    // close over the outer `resolved` reference and exhaustive-deps can verify.
    return (0, $5FkrB.useMemo)(function() {
        return {
            axis: axis,
            edge: edge,
            align: align,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        };
    }, [
        axis,
        edge,
        align,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $75094d24ba4c1778$export$56b02a1e583f953c(_ref3) {
    var anchorRef = _ref3.anchorRef, popoverRef = _ref3.popoverRef, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? {} : _ref3$placement, _ref3$forceFallbackPo = _ref3.forceFallbackPositioning, forceFallbackPositioning = _ref3$forceFallbackPo === void 0 ? false : _ref3$forceFallbackPo, _ref3$isEnabled = _ref3.isEnabled, isEnabled = _ref3$isEnabled === void 0 ? true : _ref3$isEnabled, isOpen = _ref3.isOpen;
    var id = (0, $5FkrB.useId)();
    var stablePlacement = $75094d24ba4c1778$var$useStablePlacement(placement);
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!isEnabled) return;
        var trigger = anchorRef.current;
        var popover = popoverRef.current;
        if (!trigger || !popover) return;
        var gapCssValue = stablePlacement.offset.gap;
        var crossAxisShiftCssValue = stablePlacement.offset.crossAxisShift.value;
        var shouldForceFallback = Boolean(forceFallbackPositioning);
        if ($75094d24ba4c1778$var$supportsAnchorPositioning() && !shouldForceFallback) {
            // Reuse an existing `anchor-name` if the element already has one.
            // Another popover might already be anchored to the old name.
            var anchorName = trigger.style.getPropertyValue('anchor-name') || "--anchor-".concat(id.replace(/:/g, ''));
            var gap = $75094d24ba4c1778$var$edgeMargin({
                placement: stablePlacement,
                offset: gapCssValue
            });
            // Computed once; also mirrored into the
            // `--ds-cross-axis-shift-margin-*` custom properties below.
            var crossAxisShift = $75094d24ba4c1778$var$crossAxisShiftMargins({
                placement: stablePlacement,
                crossAxisShiftCssValue: crossAxisShiftCssValue,
                direction: stablePlacement.offset.crossAxisShift.direction
            });
            var popoverStyles = [
                {
                    property: 'position-anchor',
                    value: anchorName
                },
                {
                    property: 'position-area',
                    value: (0, $jgGFa.placementToPositionArea)({
                        placement: stablePlacement
                    })
                },
                {
                    property: 'position-try-fallbacks',
                    value: (0, $kHdon.placementToTryFallbacks)({
                        placement: stablePlacement
                    })
                },
                // Reset browser default popover positioning that conflicts
                // with anchor positioning (UA: `inset: 0; margin: auto;`)
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                },
                gap
            ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(crossAxisShift), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))($75094d24ba4c1778$var$ZEROED_CROSS_AXIS_SHIFT_CUSTOM_PROPERTIES), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(crossAxisShift.map(function(_ref4) {
                var property = _ref4.property, value = _ref4.value;
                return {
                    property: $75094d24ba4c1778$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY[property],
                    value: value
                };
            })));
            /**
       * **We are never cleaning up anchor names**
       *
       * _Rationale_
       *
       * - Multiple popovers can share the same anchor element.
       * - Sometimes the `useAnchorPosition` hook and `Popover`
       *   are not in the same component.
       * - There can be times when, even with reference counting, we
       *   could remove the anchor-name while it is still being used
       *   by something else - especially with async react updates
       *   which can cause tearing
       *
       * _More_
       *
       * See `notes/decisions/anchor-name-lifetime.md`
       */ trigger.style.setProperty('anchor-name', anchorName);
            return (0, $2AlU3.setStyle)({
                element: popover,
                styles: popoverStyles
            });
        }
        // JS fallback. The popover is already in the top layer via
        // popover="auto", so we only reset UA defaults and set top/left
        // based on measurements.
        var cleanupBaseStyles = (0, $2AlU3.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                }
            ]
        });
        // The popover can be consumer-owned (`@atlaskit/popper`'s `createPopper`),
        // so restore prior inline values rather than removing ours.
        var undoPosition;
        var undoHide;
        // `opacity: 0` not `visibility: hidden`: Firefox skips visibility-hidden
        // elements during `<dialog>` initial-focus traversal.
        function hideUntilPositioned() {
            // Keep the first snapshot, else we capture our own `opacity: 0`.
            // (`!popover` is for TS: narrowing does not reach nested functions.)
            if (!popover || undoHide) return;
            undoHide = (0, $2AlU3.setStyle)({
                element: popover,
                styles: [
                    {
                        property: 'opacity',
                        value: '0'
                    }
                ]
            });
        }
        function reveal() {
            var _undoHide;
            (_undoHide = undoHide) === null || _undoHide === void 0 || _undoHide();
            undoHide = undefined;
        }
        function restorePosition() {
            var _undoPosition;
            (_undoPosition = undoPosition) === null || _undoPosition === void 0 || _undoPosition();
            undoPosition = undefined;
        }
        function update() {
            if (!trigger || !popover) return;
            var triggerRect = trigger.getBoundingClientRect();
            var viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            // Resolve consumer-supplied CSS length strings (tokens, calc, var,
            // px, rem, etc) to pixels. The probe is mounted INSIDE the popover
            // itself so the resolved length matches the scope a token would
            // resolve against from inside the popover content. (The popover
            // lives in the top layer, not the trigger's DOM tree, so probing
            // at `popover.parentElement` would resolve in a different scope
            // than the consumer's token authoring expects.)
            var gapPx = (0, $5f8RE.resolveCssLengthToPixels)({
                value: gapCssValue,
                container: popover
            });
            var crossAxisShiftPx = (0, $5f8RE.resolveCssLengthToPixels)({
                value: crossAxisShiftCssValue,
                container: popover
            });
            var _computeFallbackPosit = (0, $2peaN.computeFallbackPosition)({
                triggerRect: triggerRect,
                popoverEl: popover,
                placement: stablePlacement,
                viewport: viewport,
                gap: gapPx,
                crossAxisShift: {
                    value: crossAxisShiftPx,
                    direction: stablePlacement.offset.crossAxisShift.direction
                }
            }), top = _computeFallbackPosit.top, left = _computeFallbackPosit.left;
            // Restore first so the snapshot stays the consumer's value.
            restorePosition();
            undoPosition = (0, $2AlU3.setStyle)({
                element: popover,
                styles: [
                    {
                        property: 'top',
                        value: "".concat(top, "px")
                    },
                    {
                        property: 'left',
                        value: "".concat(left, "px")
                    }
                ]
            });
            reveal();
        }
        // Throttle scroll/resize updates to one per animation frame
        var scheduledUpdate = (0, $45Zis.default)(update);
        // Wait for the FIRST valid layout before measuring: the popover
        // is `display: none` until `showPopover()`, and some browsers
        // fire `toggle` before layout, so RAF-after-toggle is unreliable.
        // ResizeObserver fires once the browser has real dimensions.
        // Self-disconnects after one valid measurement; ongoing
        // scroll/resize is handled by the window listeners below.
        // `ResizeObserver` is missing in some non-DOM jest environments
        // (e.g. post-office's `node` environment). Fall back to a no-op
        // observer there. The scroll/resize listeners below still keep
        // the popover positioned in the rare case the consumer also
        // polyfilled `showPopover` but not `ResizeObserver`. Real
        // browsers always have it. The `NoopResizeObserver` class is
        // hoisted to module scope (see top of file) so we do not allocate
        // a new constructor on every effect run.
        var ResizeObserverImpl = typeof ResizeObserver !== 'undefined' ? ResizeObserver : $75094d24ba4c1778$var$NoopResizeObserver;
        var resizeObserver = new ResizeObserverImpl(function() {
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                update();
                resizeObserver.disconnect();
            }
        });
        // If the popover is already open by the time this effect runs (for
        // example, the parent `useAnchorPosition` effect runs after the child
        // `Popover` effect that called `showPopover()`), the initial `toggle`
        // event has already fired and our listener below would miss it. Start
        // observing immediately so the first measurement still happens.
        if ($75094d24ba4c1778$var$isPopoverOpen(popover)) {
            hideUntilPositioned();
            resizeObserver.observe(popover);
        }
        var undoPositioning = (0, $fuCTG.combine)(cleanupBaseStyles, // Each open needs a fresh measurement, so hide and re-observe.
        (0, $7QpUe.bind)(popover, {
            type: 'toggle',
            listener: function listener(event) {
                var toggleEvent = event;
                if (toggleEvent.newState === 'open') {
                    hideUntilPositioned();
                    resizeObserver.observe(popover);
                }
            }
        }), function() {
            return resizeObserver.disconnect();
        }, (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: scheduledUpdate,
            options: {
                capture: true,
                passive: true
            }
        }), (0, $7QpUe.bind)(window, {
            type: 'resize',
            listener: scheduledUpdate,
            options: {
                passive: true
            }
        }), function() {
            scheduledUpdate.cancel();
            restorePosition();
            reveal();
        });
        return undoPositioning;
    }, [
        anchorRef,
        popoverRef,
        stablePlacement,
        forceFallbackPositioning,
        isEnabled,
        id,
        isOpen
    ]);
}

});
parcelRegister("2peaN", function(module, exports) {
$parcel$export(module.exports, "computeFallbackPosition", () => $1c08e90932a9be29$export$d5ef1dac02135664);

var $25nEq = parcelRequire("25nEq");
function $1c08e90932a9be29$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1c08e90932a9be29$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1c08e90932a9be29$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1c08e90932a9be29$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * JS fallback positioning math. Used only when the browser does not
 * support CSS Anchor Positioning (less than 6% of users).
 *
 * Consumer-supplied `offset.gap` and `offset.crossAxisShift` are
 * honored: the caller (`useAnchorPosition`) resolves CSS length strings
 * (tokens, calc, var, etc) to pixels via a DOM probe before passing them
 * in. The caller also keeps the popover hidden (`opacity: 0`) until the
 * first measurement completes, so the popover never paints at the wrong
 * position.
 */ /**
 * A viewport-relative position, in pixels. Physical rather than logical
 * because it is written straight to `top` / `left`.
 */ /**
 * The cross-axis shift with its length already resolved to pixels.
 *
 * Mirrors `TCrossAxisShiftOffset`, whose `value` is an unresolved CSS length
 * string. Only this module needs the pixel form, because only this module does
 * the arithmetic itself.
 */ /**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function $1c08e90932a9be29$var$computeEdgePosition(_ref) {
    var axis = _ref.axis, edge = _ref.edge, triggerRect = _ref.triggerRect, popoverWidth = _ref.popoverWidth, popoverHeight = _ref.popoverHeight, viewport = _ref.viewport, gap = _ref.gap;
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        var spaceBelow = viewport.height - triggerRect.bottom;
        var spaceAbove = triggerRect.top;
        var fitsBelow = spaceBelow >= popoverHeight + gap;
        var useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        var _spaceAbove = triggerRect.top;
        var _spaceBelow = viewport.height - triggerRect.bottom;
        var fitsAbove = _spaceAbove >= popoverHeight + gap;
        var useAbove = fitsAbove || _spaceAbove >= _spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        var spaceRight = viewport.width - triggerRect.right;
        var spaceLeft = triggerRect.left;
        var fitsRight = spaceRight >= popoverWidth + gap;
        var useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        var _spaceLeft = triggerRect.left;
        var _spaceRight = viewport.width - triggerRect.right;
        var fitsLeft = _spaceLeft >= popoverWidth + gap;
        var useLeft = fitsLeft || _spaceLeft >= _spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function $1c08e90932a9be29$var$applyAlignment(_ref2) {
    var position = _ref2.position, axis = _ref2.axis, align = _ref2.align, triggerRect = _ref2.triggerRect, popoverWidth = _ref2.popoverWidth, popoverHeight = _ref2.popoverHeight;
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return $1c08e90932a9be29$var$_objectSpread($1c08e90932a9be29$var$_objectSpread({}, position), {}, {
            left: triggerRect.left
        });
        // align === 'end'
        return $1c08e90932a9be29$var$_objectSpread($1c08e90932a9be29$var$_objectSpread({}, position), {}, {
            left: triggerRect.right - popoverWidth
        });
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return $1c08e90932a9be29$var$_objectSpread($1c08e90932a9be29$var$_objectSpread({}, position), {}, {
        top: triggerRect.top
    });
    // align === 'end'
    return $1c08e90932a9be29$var$_objectSpread($1c08e90932a9be29$var$_objectSpread({}, position), {}, {
        top: triggerRect.bottom - popoverHeight
    });
}
/**
 * Applies the cross-axis shift offset.
 *
 * `forwards` always moves the popover toward the cross-axis END and
 * `backwards` toward the START, for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 *
 * This is a coordinate, so the direction is the sign and nothing else. There
 * is deliberately no per-`align` sign inversion here: the CSS path inverts the
 * sign only because a margin on the END side pushes a box the opposite way to
 * a margin on the START side, which is a property of margins rather than of
 * the shift. Applying that inversion to a coordinate moved `align: 'end'`
 * popovers the wrong way.
 */ function $1c08e90932a9be29$var$applyCrossAxisShift(_ref3) {
    var position = _ref3.position, axis = _ref3.axis, crossAxisShift = _ref3.crossAxisShift;
    if (crossAxisShift.value === 0) return position;
    var directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    var delta = crossAxisShift.value * directionSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return $1c08e90932a9be29$var$_objectSpread($1c08e90932a9be29$var$_objectSpread({}, position), {}, {
        left: position.left + delta
    });
    return $1c08e90932a9be29$var$_objectSpread($1c08e90932a9be29$var$_objectSpread({}, position), {}, {
        top: position.top + delta
    });
}
function $1c08e90932a9be29$export$d5ef1dac02135664(_ref4) {
    var triggerRect = _ref4.triggerRect, popoverEl = _ref4.popoverEl, placement = _ref4.placement, viewport = _ref4.viewport, gap = _ref4.gap, crossAxisShift = _ref4.crossAxisShift;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    var popoverWidth = popoverEl.offsetWidth;
    var popoverHeight = popoverEl.offsetHeight;
    var basePosition = $1c08e90932a9be29$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    var alignedPosition = $1c08e90932a9be29$var$applyAlignment({
        position: basePosition,
        axis: axis,
        align: align,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    var shiftedPosition = $1c08e90932a9be29$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        crossAxisShift: crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}

});

parcelRegister("fuCTG", function(module, exports) {
$parcel$export(module.exports, "combine", () => $b477d48968bffe01$export$1be1fc439b849fdf);
/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $b477d48968bffe01$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, cleanupFns = new Array(_len), _key = 0; _key < _len; _key++)cleanupFns[_key] = arguments[_key];
    return function cleanup() {
        cleanupFns.forEach(function(callback) {
            return callback === null || callback === void 0 ? void 0 : callback();
        });
    };
}

});

parcelRegister("jgGFa", function(module, exports) {
$parcel$export(module.exports, "placementToPositionArea", () => $e0709af03665a3bf$export$de49b61f233ddeb9);

var $2ZFRH = parcelRequire("2ZFRH");
function $e0709af03665a3bf$export$de49b61f233ddeb9(_ref) {
    var placement = _ref.placement;
    var _resolvePlacement = (0, $2ZFRH.resolvePlacement)({
        placement: placement
    }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge, align = _resolvePlacement.align;
    var edgeValue = "".concat(axis, "-").concat(edge);
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    var spanDir = align === 'start' ? 'end' : 'start';
    return "".concat(edgeValue, " span-").concat(crossAxis, "-").concat(spanDir);
}

});

parcelRegister("kHdon", function(module, exports) {
$parcel$export(module.exports, "placementToTryFallbacks", () => $f1123630dcb1ec68$export$c4e16947a95d61f1);

var $2ZFRH = parcelRequire("2ZFRH");
/**
 * A `position-area` primary edge — the placement axis joined to its edge, e.g.
 * `block-end` or `inline-start`. These are the four edges a popover can sit on.
 */ function $f1123630dcb1ec68$var$slideOnEdge(_ref) {
    var align = _ref.align, edgeKey = _ref.edgeKey, crossAxis = _ref.crossAxis;
    if (align === 'center') return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-end"),
        "".concat(edgeKey, " span-").concat(crossAxis, "-start")
    ];
    // For `align: 'start'` the popover expands toward `end`, so the "near"
    // span is `end` and the "far" span is `start`; `align: 'end'` mirrors
    // this. The bare `edgeKey` (re-centered) sits between them.
    var near = align === 'start' ? 'end' : 'start';
    var far = align === 'start' ? 'start' : 'end';
    return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(near),
        edgeKey,
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(far)
    ];
}
function $f1123630dcb1ec68$var$flipDiagonally(_ref2) {
    var axis = _ref2.axis;
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    var flipToCrossAxis = axis === 'block' ? 'flip-inline' : 'flip-block';
    return "".concat(flipOnMainAxis, " ").concat(flipToCrossAxis);
}
function $f1123630dcb1ec68$export$c4e16947a95d61f1(_ref3) {
    var placement = _ref3.placement;
    /**
   * **Build the fallback list**
   *
   * Each entry is a complete alternative position.
   * The browser tries them _in order_ and uses the _first_ one that fits.
   */ var resolved = (0, $2ZFRH.resolvePlacement)({
        placement: placement
    });
    var axis = resolved.axis, edge = resolved.edge, align = resolved.align;
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    var flippedEdge = edge === 'start' ? 'end' : 'start';
    var sameEdgeArea = "".concat(axis, "-").concat(edge);
    var oppositeEdgeArea = "".concat(axis, "-").concat(flippedEdge);
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    /**
   * **Fallback algorithm**
   *
   * We have two things we can do to keep something visible:
   *
   * 1. _Slide_ along edges
   * 2. _Flip_ to another edge
   *
   * _Centered popover_
   *
   * Desired: Sits in middle of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge (centered)
   *  3: _Slide_ along opposite edge on the cross axis
   *
   * _Start or end aligned popover_
   *
   * Desired: Sits at start / end of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge
   *  3: _Flip_ on the diagonal (flip main axis + flip cross axis) into the
   *     opposite corner. For start / end alignment, this is the clean escape
   *     when the popover would otherwise land offscreen on both axes (ie in a
   *     corner). Rule 4 gets the job done, but a slide drops the gap
   *     as named position-area values don't carry margins).
   *     The diagonal flip keeps the gap and the alignment.
   *  4: _Slide_ along opposite edge on the cross axis
   */ return [
        $f1123630dcb1ec68$var$slideOnEdge({
            align: align,
            edgeKey: sameEdgeArea,
            crossAxis: crossAxis
        }),
        flipOnMainAxis,
        align !== 'center' ? $f1123630dcb1ec68$var$flipDiagonally({
            axis: axis
        }) : null,
        $f1123630dcb1ec68$var$slideOnEdge({
            align: align,
            edgeKey: oppositeEdgeArea,
            crossAxis: crossAxis
        })
    ].filter(Boolean).flat().join(', ');
}

});

parcelRegister("5f8RE", function(module, exports) {
$parcel$export(module.exports, "resolveCssLengthToPixels", () => $3d153abee90bb07c$export$98721546d2816d9e);
var $3d153abee90bb07c$var$elementCaches = new WeakMap();
function $3d153abee90bb07c$var$canCacheResolvedLength(value) {
    // Custom-property values can be retargeted by inline overrides on the
    // consumer's wrapper, so we cannot prove a cached pixel value is still valid.
    return !value.includes('var(');
}
function $3d153abee90bb07c$var$getCachedResolvedLength(_ref) {
    var _cacheForElement$get;
    var element = _ref.element, value = _ref.value;
    if (!$3d153abee90bb07c$var$canCacheResolvedLength(value)) return null;
    var cacheForElement = $3d153abee90bb07c$var$elementCaches.get(element);
    return (_cacheForElement$get = cacheForElement === null || cacheForElement === void 0 ? void 0 : cacheForElement.get(value)) !== null && _cacheForElement$get !== void 0 ? _cacheForElement$get : null;
}
function $3d153abee90bb07c$var$cacheResolvedLength(_ref2) {
    var _elementCaches$get;
    var element = _ref2.element, value = _ref2.value, result = _ref2.result;
    if (!$3d153abee90bb07c$var$canCacheResolvedLength(value)) return;
    var cacheForElement = (_elementCaches$get = $3d153abee90bb07c$var$elementCaches.get(element)) !== null && _elementCaches$get !== void 0 ? _elementCaches$get : new Map();
    cacheForElement.set(value, result);
    $3d153abee90bb07c$var$elementCaches.set(element, cacheForElement);
}
function $3d153abee90bb07c$export$98721546d2816d9e(_ref3) {
    var value = _ref3.value, container = _ref3.container;
    if (typeof value === 'number') return value;
    // Fast path: unitless zero is universally zero pixels - accept `'0'` and
    // `'-0'` without a probe. (Consumers occasionally pass `'0'` instead of
    // the number `0`.)
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from the consumer normalisation
    // in `resolvePlacement`. Avoid a reflow when we can.
    var pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    var cached = $3d153abee90bb07c$var$getCachedResolvedLength({
        element: container,
        value: value
    });
    if (cached !== null) return cached;
    var probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hide the probe from assistive tech and event targeting; defensive
    // against `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    container.appendChild(probe);
    var resolved = parseFloat(getComputedStyle(probe).marginLeft);
    container.removeChild(probe);
    var result = Number.isFinite(resolved) ? resolved : 0;
    $3d153abee90bb07c$var$cacheResolvedLength({
        element: container,
        value: value,
        result: result
    });
    return result;
}

});

parcelRegister("2AlU3", function(module, exports) {
$parcel$export(module.exports, "setStyle", () => $1e1fef10dc605e8f$export$37a5fde709c1db82);
/**
 * A single inline style declaration.
 *
 * `TProperty` narrows the property name for callers that write a known, closed
 * set of properties. Narrowing it lets a record keyed on those same names be
 * checked for exhaustiveness at compile time, rather than silently resolving to
 * `undefined` for a name that was never mapped.
 */ /**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 */ function $1e1fef10dc605e8f$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

});


parcelRegister("2EfXQ", function(module, exports) {
$parcel$export(module.exports, "isAtCurrentMenuLevel", () => $1edbb35a3273a726$export$f1bba0ef464d60af);
var $1edbb35a3273a726$var$menuScope = '[role="menu"]';
/**
 * Recursively walks from `node` toward `container`, returning `true` when
 * `container` is reached without crossing another `role="menu"` ancestor.
 *
 * Used by `isAtCurrentMenuLevel` (pattern 2) to determine if the
 * `closestMenu` is owned by the wrapper container directly. Recursion
 * avoids a mutable `let parent` walk and keeps the function body linear.
 */ function $1edbb35a3273a726$var$reachesContainerWithoutNestedMenu(node, container) {
    if (!node || node === container) return node === container;
    if (node.getAttribute('role') === 'menu') return false;
    return $1edbb35a3273a726$var$reachesContainerWithoutNestedMenu(node.parentElement, container);
}
function $1edbb35a3273a726$export$f1bba0ef464d60af(element, container) {
    var closestMenu = element.closest($1edbb35a3273a726$var$menuScope);
    // Container itself has role="menu". Element belongs to this level
    // if its closest menu is the container.
    if (container.getAttribute('role') === 'menu') return closestMenu === container;
    // Container is a wrapper without role="menu" (e.g. dropdown-menu
    // wraps a MenuGroup). The element belongs to the top level if its
    // closest role="menu" ancestor is a direct child of the container,
    // i.e. there is no nested role="menu" between them.
    if (closestMenu === null) return true;
    // Walk up from the closest menu to see if it is "owned" by this
    // container without passing through another role="menu" first.
    return $1edbb35a3273a726$var$reachesContainerWithoutNestedMenu(closestMenu.parentElement, container);
}

});

parcelRegister("5vpw8", function(module, exports) {
$parcel$export(module.exports, "useArrowNavigation", () => $4023a433327edc3e$export$23dfbae28e0cc453);

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $lFhdZ = parcelRequire("lFhdZ");

var $lmG37 = parcelRequire("lmG37");

var $1etIZ = parcelRequire("1etIZ");

var $5NxlG = parcelRequire("5NxlG");

var $46sQV = parcelRequire("46sQV");
var $4023a433327edc3e$var$menuScope = '[role="menu"]';
function $4023a433327edc3e$export$23dfbae28e0cc453(_ref) {
    var containerRef = _ref.containerRef, onClose = _ref.onClose, onNestedOpen = _ref.onNestedOpen, onNestedClose = _ref.onNestedClose, _ref$isEnabled = _ref.isEnabled, isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled, filter = _ref.filter;
    var handleKeyDown = (0, $5FkrB.useCallback)(function(event) {
        var _getDocument;
        var container = containerRef.current;
        if (!container) return;
        // Guard: only handle the event if the currently focused element
        // belongs to this menu level. The focused element's closest
        // [role="menu"] must be this container (not a nested sub-menu).
        // When no filter is provided, fall back to the closest-menu check
        // if the container has role="menu".
        var focused = (_getDocument = (0, $lFhdZ.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement;
        if (focused instanceof HTMLElement) {
            if (filter) {
                if (!filter(focused, container)) return;
            }
            if (!filter && container.getAttribute('role') === 'menu' && focused.closest($4023a433327edc3e$var$menuScope) !== container) return;
        }
        if (event.key === (0, $lmG37.KEY_DOWN)) {
            var _getNextFocusable;
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (_getNextFocusable = (0, $46sQV.getNextFocusable)({
                container: container,
                direction: 'forwards',
                filter: filter
            })) === null || _getNextFocusable === void 0 || _getNextFocusable.focus();
            return;
        }
        if (event.key === (0, $lmG37.KEY_UP)) {
            var _getNextFocusable2;
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (_getNextFocusable2 = (0, $46sQV.getNextFocusable)({
                container: container,
                direction: 'backwards',
                filter: filter
            })) === null || _getNextFocusable2 === void 0 || _getNextFocusable2.focus();
            return;
        }
        if (event.key === (0, $lmG37.KEY_HOME)) {
            var _getFirstFocusable;
            // Prevent browser default (e.g. scrolling to top of page).
            event.preventDefault();
            (_getFirstFocusable = (0, $1etIZ.getFirstFocusable)({
                container: container,
                filter: filter
            })) === null || _getFirstFocusable === void 0 || _getFirstFocusable.focus();
            return;
        }
        if (event.key === (0, $lmG37.KEY_END)) {
            var _getLastFocusable;
            // Prevent browser default (e.g. scrolling to bottom of page).
            event.preventDefault();
            (_getLastFocusable = (0, $5NxlG.getLastFocusable)({
                container: container,
                filter: filter
            })) === null || _getLastFocusable === void 0 || _getLastFocusable.focus();
            return;
        }
        if (event.key === (0, $lmG37.KEY_TAB)) {
            onClose();
            return;
        }
        // ── Nested menu navigation (WAI-ARIA menu pattern) ──
        // ArrowRight on a menuitem with aria-haspopup opens the submenu.
        if (event.key === 'ArrowRight') {
            if (onNestedOpen && focused instanceof HTMLElement && focused.hasAttribute('aria-haspopup')) {
                event.preventDefault();
                onNestedOpen({
                    trigger: focused
                });
            }
            return;
        }
        // ArrowLeft closes the current menu if it is nested inside a parent menu.
        if (event.key === 'ArrowLeft') {
            if (onNestedClose) {
                var _container$parentElem;
                // Only close if this container is inside another role="menu"
                // (i.e. it is a submenu, not the top-level menu).
                // Walk up from the parent to avoid matching the container itself.
                var isNested = ((_container$parentElem = container.parentElement) === null || _container$parentElem === void 0 ? void 0 : _container$parentElem.closest($4023a433327edc3e$var$menuScope)) !== null;
                if (isNested) {
                    event.preventDefault();
                    onNestedClose();
                }
            }
            return;
        }
    }, [
        containerRef,
        onClose,
        onNestedOpen,
        onNestedClose,
        filter
    ]);
    (0, $5FkrB.useEffect)(function() {
        var container = containerRef.current;
        if (!container || !isEnabled) return;
        return (0, $7QpUe.bind)(container, {
            type: 'keydown',
            listener: handleKeyDown
        });
    }, [
        containerRef,
        handleKeyDown,
        isEnabled
    ]);
}

});

parcelRegister("7dbsW", function(module, exports) {
$parcel$export(module.exports, "usePopoverId", () => $5402a42f3272ccb8$export$9198c6c168be2eeb);

var $h8qvJ = parcelRequire("h8qvJ");
function $5402a42f3272ccb8$export$9198c6c168be2eeb() {
    // `@atlaskit/ds-lib/use-id` already strips characters that React's
    // `useId` produces (`:`, `«`, `»`) which are invalid in HTML ID
    // tokens. The `popover-` prefix is purely for DOM debug clarity.
    return "popover-".concat((0, $h8qvJ.useId)());
}

});

parcelRegister("gP3m7", function(module, exports) {
$parcel$export(module.exports, "useWidthFromAnchor", () => $c3f4032b03cbf481$export$7071d791a7b131ed);

var $5FkrB = parcelRequire("5FkrB");

var $bvsoE = parcelRequire("bvsoE");

var $2AlU3 = parcelRequire("2AlU3");
/**
 * Probes anchor SIZING, separately from `anchor-name` (see
 * `supportsAnchorPositioning`): some browsers have positioning but not sizing.
 * `once()` for SSR safety.
 */ var $c3f4032b03cbf481$var$supportsAnchorSize = (0, $bvsoE.default)(function() {
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('min-inline-size', 'anchor-size(self-inline)');
});
/**
 * The JS fallback's stand-in for `anchor-size(self-inline)`. `offsetWidth` / `offsetHeight` are
 * physical, so the axis is picked from the popover's `writing-mode`. Anything not horizontal is
 * treated as vertical, and an unknown or empty value falls back to `offsetWidth`.
 */ function $c3f4032b03cbf481$var$getFallbackAnchorInlineSize(_ref) {
    var anchor = _ref.anchor, popover = _ref.popover;
    // `String()` because not every test environment implements `writing-mode`.
    var writingMode = String(getComputedStyle(popover).writingMode);
    var isVertical = writingMode.startsWith('vertical') || writingMode.startsWith('sideways');
    return isVertical ? anchor.offsetHeight : anchor.offsetWidth;
}
function $c3f4032b03cbf481$export$7071d791a7b131ed(_ref2) {
    var mode = _ref2.mode, popoverRef = _ref2.popoverRef, anchorRef = _ref2.anchorRef, isOpen = _ref2.isOpen;
    (0, $5FkrB.useLayoutEffect)(function() {
        var node = popoverRef.current;
        if (!node) return;
        if (mode === 'match-anchor') {
            // No floor here: it would let the popover grow past the anchor.
            if ($c3f4032b03cbf481$var$supportsAnchorSize()) return (0, $2AlU3.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'inline-size',
                        value: 'anchor-size(self-inline)'
                    }
                ]
            });
            var anchor = anchorRef.current;
            if (anchor) return (0, $2AlU3.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'inline-size',
                        value: "".concat($c3f4032b03cbf481$var$getFallbackAnchorInlineSize({
                            anchor: anchor,
                            popover: node
                        }), "px")
                    }
                ]
            });
            return;
        }
        if (mode === 'min-anchor') {
            // One floor only. The content floor from mode 'none' deliberately does not also apply
            // here, and cannot: it would need this same property. See the decision note.
            if ($c3f4032b03cbf481$var$supportsAnchorSize()) return (0, $2AlU3.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'min-inline-size',
                        value: 'anchor-size(self-inline)'
                    }
                ]
            });
            var _anchor = anchorRef.current;
            if (_anchor) return (0, $2AlU3.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'min-inline-size',
                        value: "".concat($c3f4032b03cbf481$var$getFallbackAnchorInlineSize({
                            anchor: _anchor,
                            popover: node
                        }), "px")
                    }
                ]
            });
            // Nothing to measure, so no floor.
            return;
        }
        // Makes a too-narrow span overflow and drive `position-try-fallbacks` instead of wrapping.
        // `@atlaskit/popper` resets this exact property to `0` for its fit-to-viewport mode.
        return (0, $2AlU3.setStyle)({
            element: node,
            styles: [
                {
                    property: 'min-inline-size',
                    value: 'max-content'
                }
            ]
        });
    }, [
        mode,
        popoverRef,
        anchorRef,
        isOpen
    ]);
}

});

parcelRegister("1jaJ9", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f3fe2fe00d41eb7$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $jQ0Tw = parcelRequire("jQ0Tw");
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ var $0f3fe2fe00d41eb7$var$SelectionStore = function SelectionStore(props) {
    var children = props.children;
    var store = (0, $5FkrB.useRef)({});
    var context = (0, $5FkrB.useMemo)(function() {
        return {
            setItemState: function setItemState(group, id, value) {
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: function getItemState(group, id) {
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: function setGroupState(group, value) {
                store.current[group] = value;
            },
            getGroupState: function getGroupState(group) {
                return store.current[group] || {};
            }
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jQ0Tw.SelectionStoreContext).Provider, {
        value: context
    }, children);
};
var $0f3fe2fe00d41eb7$export$2e2bcd8739ae039 = $0f3fe2fe00d41eb7$var$SelectionStore;

});
parcelRegister("jQ0Tw", function(module, exports) {
$parcel$export(module.exports, "SelectionStoreContext", () => $e713914be6d6449b$export$756f795847463ebd);

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");
var $e713914be6d6449b$export$756f795847463ebd = /*#__PURE__*/ (0, $5FkrB.createContext)({
    setItemState: (0, $eVb4V.default),
    getItemState: function getItemState() {
        return undefined;
    },
    setGroupState: (0, $eVb4V.default),
    getGroupState: function getGroupState() {
        return {};
    }
});

});



parcelRegister("jhEkG", function(module, exports) {
$parcel$export(module.exports, "default", () => $e09ee412fd2daea2$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $aOu6p = parcelRequire("aOu6p");

var $1XHw7 = parcelRequire("1XHw7");

var $dJiLQ = parcelRequire("dJiLQ");
/**
 * Focus manager logic.
 */ var $e09ee412fd2daea2$var$FocusManager = function FocusManager(_ref) {
    var children = _ref.children, onClose = _ref.onClose;
    var menuItemRefs = (0, $5FkrB.useRef)([]);
    // Used to force a re-render only
    var _useState = (0, $5FkrB.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), refresh = _useState2[0], setRefresh = _useState2[1];
    var registerMode = (0, $5FkrB.useRef)('ordered');
    registerMode.current = 'ordered';
    var registerRef = (0, $5FkrB.useCallback)(function(ref) {
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error("Unexpected case of ".concat(registerMode.current));
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    var _useLayering = (0, $aOu6p.useLayering)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    var isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, $5FkrB.useEffect)(function() {
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bind)(window, {
            type: 'keydown',
            listener: (0, $1XHw7.default)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        });
    }, [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    var contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dJiLQ.FocusManagerContext).Provider, {
        value: contextValue
    }, children);
};
var $e09ee412fd2daea2$export$2e2bcd8739ae039 = $e09ee412fd2daea2$var$FocusManager;

});
parcelRegister("1XHw7", function(module, exports) {
$parcel$export(module.exports, "default", () => $16dd0eba97ba115d$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $lmG37 = parcelRequire("lmG37");

var $50U6m = parcelRequire("50U6m");

var $bLniy = parcelRequire("bLniy");
var $16dd0eba97ba115d$var$actionMap = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $lmG37.KEY_DOWN), 'next'), (0, $lmG37.KEY_UP), 'prev'), (0, $lmG37.KEY_HOME), 'first'), (0, $lmG37.KEY_END), 'last');
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ var $16dd0eba97ba115d$var$getNextFocusableElement = function getNextFocusableElement(refs, currentFocusedIdx) {
    for(var i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        var element = refs[currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ var $16dd0eba97ba115d$var$getPrevFocusableElement = function getPrevFocusableElement(refs, currentFocusedIdx) {
    for(var i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        var element = refs[currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $16dd0eba97ba115d$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    var isNestedMenu = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    return function(e) {
        var _refs$current;
        var currentRefs = (_refs$current = refs.current) !== null && _refs$current !== void 0 ? _refs$current : [];
        var currentFocusedIdx = currentRefs.findIndex(function(_ref) {
            var _document$activeEleme;
            var el = _ref.current;
            return el && ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el));
        });
        if ((0, $50U6m.fg)('platform_dst_popup-disable-focuslock')) {
            var _document$activeEleme2;
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            var isNestedDropdown = !!((_document$activeEleme2 = document.activeElement) !== null && _document$activeEleme2 !== void 0 && _document$activeEleme2.closest("[id^=".concat((0, $bLniy.PREFIX), "]")));
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $lmG37.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $lmG37.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, $lmG37.KEY_LEFT)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, $lmG37.KEY_RIGHT)) {
            var activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        var action = $16dd0eba97ba115d$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                var nextFocusableElement = $16dd0eba97ba115d$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                var prevFocusableElement = $16dd0eba97ba115d$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                var firstFocusableElement = $16dd0eba97ba115d$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                var lastFocusableElement = $16dd0eba97ba115d$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement === null || lastFocusableElement === void 0 || lastFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("bLniy", function(module, exports) {
$parcel$export(module.exports, "PREFIX", () => $89062811dcd64d86$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $89062811dcd64d86$export$2e2bcd8739ae039);

var $h8qvJ = parcelRequire("h8qvJ");
var $89062811dcd64d86$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $89062811dcd64d86$export$2e2bcd8739ae039() {
    var id = (0, $h8qvJ.useId)();
    return "".concat($89062811dcd64d86$export$8a682ae47622dbb9).concat(id);
}

});


parcelRegister("dJiLQ", function(module, exports) {
$parcel$export(module.exports, "FocusManagerContext", () => $02945aff112f1d42$export$f18c1d4fc7326096);

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");
var $02945aff112f1d42$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    menuItemRefs: [],
    registerRef: (0, $eVb4V.default)
});

});


parcelRegister("aPakJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e16aec66c845d90$export$2e2bcd8739ae039);
/* menu-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");


var $6xFrB = parcelRequire("6xFrB");

var $50U6m = parcelRequire("50U6m");

var $auVZV = parcelRequire("auVZV");

var $9ztDu = parcelRequire("9ztDu");

var $ljGAD = parcelRequire("ljGAD");

var $4k87k = parcelRequire("4k87k");

var $dJiLQ = parcelRequire("dJiLQ");
var $7e16aec66c845d90$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
};
var $7e16aec66c845d90$var$LoadingIndicator = function LoadingIndicator(_ref) {
    var _ref$statusLabel = _ref.statusLabel, statusLabel = _ref$statusLabel === void 0 ? 'Loading' : _ref$statusLabel, testId = _ref.testId;
    return /*#__PURE__*/ $5FkrB.createElement((0, $auVZV.Box), {
        xcss: $7e16aec66c845d90$var$styles.spinnerContainer,
        role: "menuitem"
    }, /*#__PURE__*/ $5FkrB.createElement((0, $9ztDu.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
};
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ var $7e16aec66c845d90$var$MenuWrapper = function MenuWrapper(_ref2) {
    var children = _ref2.children, isLoading = _ref2.isLoading, maxHeight = _ref2.maxHeight, maxWidth = _ref2.maxWidth, onClose = _ref2.onClose, onUpdate = _ref2.onUpdate, statusLabel = _ref2.statusLabel, setInitialFocusRef = _ref2.setInitialFocusRef, shouldRenderToParent = _ref2.shouldRenderToParent, spacing = _ref2.spacing, testId = _ref2.testId, isTriggeredUsingKeyboard = _ref2.isTriggeredUsingKeyboard, autoFocus = _ref2.autoFocus, menuLabel = _ref2.menuLabel;
    var _useContext = (0, $5FkrB.useContext)((0, $dJiLQ.FocusManagerContext)), menuItemRefs = _useContext.menuItemRefs;
    var closeOnMenuItemClick = function closeOnMenuItemClick(e) {
        var isTargetMenuItemOrDescendant = menuItemRefs.some(function(menuItemRef) {
            var menuItem = menuItemRef.current;
            if (!menuItem) return false;
            var isCheckboxOrRadio = (0, $ljGAD.default)(menuItem) || (0, $4k87k.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $5FkrB.useLayoutEffect)(function() {
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $5FkrB.useEffect)(function() {
        var _menuItemRefs$map$fin;
        var firstFocusableRef = (_menuItemRefs$map$fin = menuItemRefs.map(function(_ref3) {
            var current = _ref3.current;
            return current;
        }).find(function(el) {
            return !!el && !el.hasAttribute('disabled');
        })) !== null && _menuItemRefs$map$fin !== void 0 ? _menuItemRefs$map$fin : null;
        if (((0, $50U6m.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef === null || firstFocusableRef === void 0 || firstFocusableRef.focus();
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ $5FkrB.createElement((0, $6xFrB.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && "".concat(testId, "--menu-group"),
        menuLabel: menuLabel
    }, isLoading ? /*#__PURE__*/ $5FkrB.createElement($7e16aec66c845d90$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && "".concat(testId, "--loading-indicator")
    }) : children);
};
var $7e16aec66c845d90$export$2e2bcd8739ae039 = $7e16aec66c845d90$var$MenuWrapper;

});
parcelRegister("ljGAD", function(module, exports) {
$parcel$export(module.exports, "default", () => $f84c68cb50a7ea6a$export$2e2bcd8739ae039);
function $f84c68cb50a7ea6a$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("4k87k", function(module, exports) {
$parcel$export(module.exports, "default", () => $325f5391bd4137c8$export$2e2bcd8739ae039);
function $325f5391bd4137c8$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("1ujC5", function(module, exports) {
$parcel$export(module.exports, "default", () => $1157ce92c724a1fa$export$2e2bcd8739ae039);
// eslint-disable-next-line sort-imports

var $5FkrB = parcelRequire("5FkrB");

var $50U6m = parcelRequire("50U6m");

var $dJiLQ = parcelRequire("dJiLQ");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $1157ce92c724a1fa$var$useRegisterItemWithFocusManager() {
    var hasPopup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _useContext = (0, $5FkrB.useContext)((0, $dJiLQ.FocusManagerContext)), registerRef = _useContext.registerRef;
    var itemRef = (0, $5FkrB.useRef)(null);
    (0, $5FkrB.useEffect)(function() {
        if (hasPopup && (0, $50U6m.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $1157ce92c724a1fa$export$2e2bcd8739ae039 = $1157ce92c724a1fa$var$useRegisterItemWithFocusManager;

});


parcelRegister("b1mKd", function(module, exports) {
$parcel$export(module.exports, "default", () => $80616e41d77620e9$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $iO8GM = parcelRequire("iO8GM");

var $b3Jv3 = parcelRequire("b3Jv3");

var $5pBYw = parcelRequire("5pBYw");

var $b19OW = parcelRequire("b19OW");

var $50U6m = parcelRequire("50U6m");

var $1ujC5 = parcelRequire("1ujC5");
var $80616e41d77620e9$var$_excluded = [
    "children",
    "component",
    "description",
    "elemAfter",
    "elemBefore",
    "href",
    "isDisabled",
    "isSelected",
    "onClick",
    "rel",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "target",
    "testId",
    "UNSAFE_shouldDisableRouterLink",
    "returnFocusRef",
    "interactionName",
    "role"
];
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ var $80616e41d77620e9$var$DropdownMenuItem = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, component = _ref.component, description = _ref.description, elemAfter = _ref.elemAfter, elemBefore = _ref.elemBefore, href = _ref.href, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, rel = _ref.rel, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, target = _ref.target, testId = _ref.testId, UNSAFE_shouldDisableRouterLink = _ref.UNSAFE_shouldDisableRouterLink, returnFocusRef = _ref.returnFocusRef, interactionName = _ref.interactionName, role = _ref.role, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $80616e41d77620e9$var$_excluded);
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    var isNestedTrigger = !!rest['aria-haspopup'];
    var itemRef = (0, $1ujC5.default)(isNestedTrigger);
    var handleItemClick = (0, $5FkrB.useCallback)(function(event) {
        if (returnFocusRef !== null && returnFocusRef !== void 0 && returnFocusRef.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5pBYw.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $iO8GM.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        target: target,
        rel: rel,
        interactionName: interactionName
    }, rest), children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b19OW.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $iO8GM.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName
    }, rest), children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b3Jv3.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $iO8GM.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        target: target,
        rel: rel,
        interactionName: interactionName
    }, rest, isNestedTrigger && (0, $50U6m.fg)('platform_dst_dropdown_nested_trigger_aria_current') ? {
        'aria-current': undefined
    } : {}), children);
});
var $80616e41d77620e9$export$2e2bcd8739ae039 = $80616e41d77620e9$var$DropdownMenuItem;

});
parcelRegister("b3Jv3", function(module, exports) {
$parcel$export(module.exports, "default", () => $80d344dca8e23c2b$export$2e2bcd8739ae039);
/* button-item.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $eqVaP = parcelRequire("eqVaP");

var $gN7dF = parcelRequire("gN7dF");
var $80d344dca8e23c2b$var$_excluded = [
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "interactionName"
];
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $80d344dca8e23c2b$var$ButtonItem = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var children = props.children, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $80d344dca8e23c2b$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ $5FkrB.createElement((0, $gN7dF.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        className: UNSAFE_className
    }, rest, {
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return /*#__PURE__*/ $5FkrB.createElement("button", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            "data-testid": testId,
            "aria-current": isSelected ? 'true' : undefined
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }), children);
    });
}));
var $80d344dca8e23c2b$export$2e2bcd8739ae039 = $80d344dca8e23c2b$var$ButtonItem;

});
parcelRegister("gN7dF", function(module, exports) {
$parcel$export(module.exports, "default", () => $c396d2949306f9df$export$2e2bcd8739ae039);
/* menu-item-primitive.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $50U6m = parcelRequire("50U6m");

var $m5IEn = parcelRequire("m5IEn");

var $9CqML = parcelRequire("9CqML");

var $bXzol = parcelRequire("bXzol");
var $c396d2949306f9df$var$renderTitle = function renderTitle(Component, props) {
    return(/*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    $5FkrB.createElement(Component, props));
};
var $c396d2949306f9df$var$styles = {
    root: "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _4bfu1r31 _1hmsglyw _ajmmnqa1 _kqswh2mm _1e0c1txw _vchhusvi _1bsb1osq _1tke1ylp _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t _4cvr1h6o _uiztglyw _80omtlke _ymio1r31 _ypr0glyw _zcxs1o36 _nt751v1w _mizu1v1w _1bg41gjf _1ah31gjf _49pcnqa1 _ra3xnqa1 _1hvwdkaa _128mdkaa _9oik1r31 _1bnxglyw _jf4cnqa1 _1cvmnqa1 _4davt94y",
    beforeAfterElement: "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf",
    content: "_12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bah1h6o _16jlkb7n _y3gn1e5h",
    truncate: "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c",
    title: "_11c8fhey",
    wordBreak: "_1nmz1hna",
    description: "_11c8wadc _syaz1rpy",
    disabledDescription: "_syaz1gmx",
    unselected: "_bfhksm61 _syaz1r31 _10531r31 _irr31dpa _30l31r31 _1di61dpa _9h8h1r31",
    disabled: "_80om13gf _bfhksm61 _syaz1gmx _irr3sm61 _30l31gmx _1di6sm61 _9h8h1gmx",
    selectedBorder: "_1mp4yh40 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrze3t _iajmze3t _z5wtze3t",
    selectedNotch: "_rfx3bx74 _1mp41y44 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrutpp _iajmutpp _z5wtze3t",
    selected: "_bfhk15s3 _syaz6x5g _10536x5g _irr3ufnl _30l316jw _1di6nozp _9h8h6x5g",
    selectedOld: "_30l36x5g",
    motionUnselected: "_v564hxmd _o7kshxmd _1ggl87vo",
    motionSelected: "_v5641rrn _o7kshxmd"
};
var $c396d2949306f9df$var$spacingMapStyles = {
    cozy: "_1rjcu2gc _18zrpxbi",
    compact: "_1rjc1b66 _18zrutpp _1tkezwfg"
};
var $c396d2949306f9df$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $c396d2949306f9df$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isTitleHeading = _ref.isTitleHeading, isTitleHeading = _ref$isTitleHeading === void 0 ? false : _ref$isTitleHeading, testId = _ref.testId;
    var spacing = (0, $5FkrB.useContext)((0, $9CqML.SpacingContext));
    var selectionStyle = (0, $5FkrB.useContext)((0, $bXzol.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    var UNSAFE_className = UNSAFE_externalClassName;
    return function() {
        return children({
            className: (0, $970q7.default)([
                (0, $970q7.default)([
                    $c396d2949306f9df$var$styles.root,
                    $c396d2949306f9df$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $c396d2949306f9df$var$styles.unselected,
                    !isDisabled && !isSelected && (0, $50U6m.fg)('platform-dst-motion-uplift-list-item') && $c396d2949306f9df$var$styles.motionUnselected,
                    !isDisabled && isSelected && $c396d2949306f9df$var$styles.selected,
                    !isDisabled && isSelected && (0, $50U6m.fg)('platform-dst-motion-uplift-list-item') && $c396d2949306f9df$var$styles.motionSelected,
                    !isDisabled && isSelected && $c396d2949306f9df$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === 'border' && $c396d2949306f9df$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === 'notch' && $c396d2949306f9df$var$styles.selectedNotch,
                    isDisabled && $c396d2949306f9df$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ $5FkrB.createElement((0, $m5IEn.Inline), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $c396d2949306f9df$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && /*#__PURE__*/ $5FkrB.createElement("span", {
                "data-item-elem-before": true,
                "data-testid": testId && "".concat(testId, "--icon-before"),
                className: (0, $970q7.default)([
                    $c396d2949306f9df$var$styles.beforeAfterElement
                ])
            }, iconBefore), title && /*#__PURE__*/ $5FkrB.createElement("div", {
                className: (0, $970q7.default)([
                    $c396d2949306f9df$var$styles.content
                ])
            }, $c396d2949306f9df$var$renderTitle(isTitleHeading ? 'h2' : 'span', {
                children: title,
                className: (0, $970q7.default)([
                    $c396d2949306f9df$var$styles.title,
                    shouldTitleWrap ? $c396d2949306f9df$var$styles.wordBreak : $c396d2949306f9df$var$styles.truncate
                ]),
                'data-item-title': true
            }), description && /*#__PURE__*/ $5FkrB.createElement("span", {
                "data-item-description": true,
                className: (0, $970q7.default)([
                    $c396d2949306f9df$var$styles.description,
                    isDisabled && $c396d2949306f9df$var$styles.disabledDescription,
                    shouldDescriptionWrap && $c396d2949306f9df$var$styles.wordBreak,
                    !shouldDescriptionWrap && $c396d2949306f9df$var$styles.truncate
                ])
            }, description)), iconAfter && /*#__PURE__*/ $5FkrB.createElement("span", {
                "data-item-elem-after": true,
                "data-testid": testId && "".concat(testId, "--icon-after"),
                className: (0, $970q7.default)([
                    $c396d2949306f9df$var$styles.beforeAfterElement
                ])
            }, iconAfter))
        });
    }();
};
var $c396d2949306f9df$export$2e2bcd8739ae039 = $c396d2949306f9df$var$MenuItemPrimitive;

});


parcelRegister("5pBYw", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f0cbea440f9628b$export$2e2bcd8739ae039);
/* custom-item.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $eqVaP = parcelRequire("eqVaP");

var $gN7dF = parcelRequire("gN7dF");
var $3f0cbea440f9628b$var$_excluded = [
    "component",
    "isDisabled",
    "isSelected",
    "isTitleHeading",
    "onClick",
    "testId",
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $3f0cbea440f9628b$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
// Dirty hack to get generics working with forward ref [1/2]
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $3f0cbea440f9628b$var$CustomItem = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var Component = _ref.component, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isTitleHeading = _ref.isTitleHeading, isTitleHeading = _ref$isTitleHeading === void 0 ? false : _ref$isTitleHeading, onClick = _ref.onClick, testId = _ref.testId, children = _ref.children, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, onMouseDown = _ref.onMouseDown, shouldTitleWrap = _ref.shouldTitleWrap, shouldDescriptionWrap = _ref.shouldDescriptionWrap, UNSAFE_className = _ref.className, UNSAFE_isDraggable = _ref.UNSAFE_isDraggable, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $3f0cbea440f9628b$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ $5FkrB.createElement((0, $gN7dF.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        className: UNSAFE_className
    }, rest, {
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: isTitleHeading,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref2) {
        var children = _ref2.children, className = _ref2.className;
        return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $3f0cbea440f9628b$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $3f0cbea440f9628b$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $3f0cbea440f9628b$var$preventEvent : handleClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled || undefined
        }), children);
    });
}));
var $3f0cbea440f9628b$export$2e2bcd8739ae039 = $3f0cbea440f9628b$var$CustomItem;

});

parcelRegister("b19OW", function(module, exports) {
$parcel$export(module.exports, "default", () => $805767daeccc2a7c$export$2e2bcd8739ae039);
/* link-item.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $5e9ur = parcelRequire("5e9ur");

var $eqVaP = parcelRequire("eqVaP");

var $gN7dF = parcelRequire("gN7dF");
var $805767daeccc2a7c$var$_excluded = [
    "children",
    "href",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_shouldDisableRouterLink",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $805767daeccc2a7c$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $805767daeccc2a7c$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
var $805767daeccc2a7c$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $805767daeccc2a7c$var$LinkItem = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var children = props.children, href = props.href, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, UNSAFE_shouldDisableRouterLink = props.UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable = props.UNSAFE_isDraggable, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $805767daeccc2a7c$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var RouterLink = (0, $5e9ur.useRouterLink)();
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    var isExternal = typeof href === 'string' && $805767daeccc2a7c$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $805767daeccc2a7c$var$IS_NON_HTTP_BASED.test(href);
    var isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ var isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $5FkrB.createElement((0, $gN7dF.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: false,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        title: children,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
            "data-vc": "link-item"
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            href: isDisabled ? undefined : href
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $805767daeccc2a7c$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $805767daeccc2a7c$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $805767daeccc2a7c$var$preventEvent : handleClick,
            "aria-current": isSelected ? 'page' : undefined,
            "aria-disabled": isDisabled || undefined,
            ref: ref
        }), children);
    });
}));
var $805767daeccc2a7c$export$2e2bcd8739ae039 = $805767daeccc2a7c$var$LinkItem;

});
parcelRegister("5e9ur", function(module, exports) {
$parcel$export(module.exports, "useRouterLink", () => $3ce59f172dd76f40$export$6d558eab13290f59);

var $5FkrB = parcelRequire("5FkrB");

var $dgsld = parcelRequire("dgsld");
var $3ce59f172dd76f40$export$6d558eab13290f59 = function useRouterLink() {
    var _useContext = (0, $5FkrB.useContext)((0, $dgsld.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
    return;
};

});
parcelRegister("dgsld", function(module, exports) {
$parcel$export(module.exports, "RouterLinkProviderContext", () => $9a82c0f90aa1e4d5$export$2931e0ee690eee88);

var $5FkrB = parcelRequire("5FkrB");
var $9a82c0f90aa1e4d5$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $5FkrB.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $9a82c0f90aa1e4d5$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($9a82c0f90aa1e4d5$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$9a82c0f90aa1e4d5$export$2e2bcd8739ae039 = $9a82c0f90aa1e4d5$var$RouterLinkProvider;

});




parcelRegister("eaEPs", function(module, exports) {
$parcel$export(module.exports, "default", () => $a511aba2d268bdcc$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $h8qvJ = parcelRequire("h8qvJ");

var $9Odc5 = parcelRequire("9Odc5");

var $ilmn1 = parcelRequire("ilmn1");
var $a511aba2d268bdcc$var$_excluded = [
    "children",
    "id",
    "isList",
    "isScrollable",
    "title",
    "testId",
    "hasSeparator"
];
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ var $a511aba2d268bdcc$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, title = _ref.title, testId = _ref.testId, hasSeparator = _ref.hasSeparator, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $a511aba2d268bdcc$var$_excluded);
    var uid = (0, $h8qvJ.useId)();
    var titleId = "dropdown-menu-item-group-title-".concat(uid);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9Odc5.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ilmn1.default), {
        id: titleId,
        title: title
    }), children);
});
var $a511aba2d268bdcc$export$2e2bcd8739ae039 = $a511aba2d268bdcc$var$DropdownMenuItemGroup;

});
parcelRegister("9Odc5", function(module, exports) {
$parcel$export(module.exports, "default", () => $72430498340681e6$export$2e2bcd8739ae039);
/* section.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $lRVeU = parcelRequire("lRVeU");
var $72430498340681e6$var$_excluded = [
    "children",
    "title",
    "titleId",
    "testId",
    "isScrollable",
    "hasSeparator",
    "id",
    "isList",
    "isSideNavSection",
    "label",
    "className"
];
var $72430498340681e6$var$itemHeadingTopMargin = 20;
var $72430498340681e6$var$itemHeadingBottomMargin = 6;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
var $72430498340681e6$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
var $72430498340681e6$var$skeletonHeadingHeight = 8;
var $72430498340681e6$var$skeletonHeadingMarginOffset = 3;
var $72430498340681e6$var$skeletonHeadingTopMargin = $72430498340681e6$var$itemHeadingTopMargin + ($72430498340681e6$var$itemHeadingContentHeight - $72430498340681e6$var$skeletonHeadingHeight) - $72430498340681e6$var$skeletonHeadingMarginOffset;
var $72430498340681e6$var$sectionPaddingTopBottom = 6;
var $72430498340681e6$var$styles = {
    root: "_1ywu1ule _cfu11ule _1qdgi2wt _kfgti2wt _aetrb3bt _1kt9b3bt _1p3hi2wt _1l6bgktf _osbldlk8 _auo4rdoj _hp2110yn _1mfv8jkm _1bg41n1a",
    scrollable: "_1reo1wug _18m91wug _1o9zkb7n",
    unscrollable: "_1o9zidpf",
    thinSeparator: "_mqm2lllh",
    noSeparator: "_n7cnyjp0",
    sideNavSectionHeading: "_18zru2gc"
};
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $72430498340681e6$var$Section = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, title = _ref.title, titleId = _ref.titleId, testId = _ref.testId, isScrollable = _ref.isScrollable, hasSeparator = _ref.hasSeparator, id = _ref.id, _ref$isList = _ref.isList, isList = _ref$isList === void 0 ? false : _ref$isList, _ref$isSideNavSection = _ref.isSideNavSection, isSideNavSection = _ref$isSideNavSection === void 0 ? false : _ref$isSideNavSection, label = _ref.label, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $72430498340681e6$var$_excluded);
    var content = isList ? /*#__PURE__*/ $5FkrB.createElement("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $5FkrB.Children).map((0, $5FkrB.Children).toArray(children), function(child, index) {
        return /*#__PURE__*/ $5FkrB.createElement("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: 'none',
                margin: 0,
                padding: 0
            },
            key: index
        }, child);
    })) : children;
    var childrenMarkup = title !== undefined ? /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement((0, $lRVeU.default), {
        testId: testId && "".concat(testId, "--heading"),
        "aria-hidden": true,
        className: (0, $970q7.default)([
            isSideNavSection && $72430498340681e6$var$styles.sideNavSectionHeading
        ])
    }, title), content) : /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, content);
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $970q7.default)([
            $72430498340681e6$var$styles.root,
            isScrollable ? $72430498340681e6$var$styles.scrollable : $72430498340681e6$var$styles.unscrollable,
            hasSeparator ? $72430498340681e6$var$styles.thinSeparator : $72430498340681e6$var$styles.noSeparator,
            UNSAFE_className
        ]),
        id: id,
        "aria-label": title || label,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }), childrenMarkup);
});
var $72430498340681e6$export$2e2bcd8739ae039 = $72430498340681e6$var$Section;

});
parcelRegister("lRVeU", function(module, exports) {
$parcel$export(module.exports, "default", () => $febaf2c5b093b9e1$export$2e2bcd8739ae039);
/* heading-item.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $febaf2c5b093b9e1$var$_excluded = [
    "children",
    "testId",
    "headingLevel",
    "id",
    "className"
];
var $febaf2c5b093b9e1$var$headingStyles = null;
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $febaf2c5b093b9e1$var$HeadingItem = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 2 : _ref$headingLevel, id = _ref.id, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $febaf2c5b093b9e1$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: (0, $970q7.default)([
            "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu",
            UNSAFE_className
        ])
    }, rest), children);
});
var $febaf2c5b093b9e1$export$2e2bcd8739ae039 = $febaf2c5b093b9e1$var$HeadingItem;

});


parcelRegister("ilmn1", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5ab8a6d27952d68$export$2e2bcd8739ae039);
/* group-title.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $5FkrB = parcelRequire("5FkrB");

var $auVZV = parcelRequire("auVZV");
var $d5ab8a6d27952d68$var$styles = {
    heading: "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups.
 *
 * Pre-existing a11y note: uses `role="menuitem"` with `aria-hidden="true"`.
 * WAI-ARIA APG recommends `role="presentation"` for non-interactive group
 * headings, with the group linked via `aria-labelledby`. Out of scope for
 * the top-layer migration — this is legacy behavior.
 *
 * @internal
 */ var $d5ab8a6d27952d68$var$GroupTitle = function GroupTitle(_ref) {
    var id = _ref.id, title = _ref.title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $auVZV.Box), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $d5ab8a6d27952d68$var$styles.heading
    }, title);
};
var $d5ab8a6d27952d68$export$2e2bcd8739ae039 = $d5ab8a6d27952d68$var$GroupTitle;

});


parcelRegister("5tQm9", function(module, exports) {
$parcel$export(module.exports, "default", () => $3fd84610385902f8$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $9Pk7k = parcelRequire("9Pk7k");

var $elG2K = parcelRequire("elG2K");

var $klKsD = parcelRequire("klKsD");
function $3fd84610385902f8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3fd84610385902f8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3fd84610385902f8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3fd84610385902f8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3fd84610385902f8$export$2e2bcd8739ae039(_ref) {
    var loaderFn = _ref.loaderFn, children = _ref.children, defaultMessages = _ref.defaultMessages;
    var intl = (0, $klKsD.useSafeIntl)();
    var messages = (0, $elG2K.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ var mergedMessages = (0, $5FkrB.useMemo)(function() {
        return $3fd84610385902f8$var$_objectSpread($3fd84610385902f8$var$_objectSpread($3fd84610385902f8$var$_objectSpread({}, defaultMessages), intl.messages), messages);
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9Pk7k.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
}

});
parcelRegister("9Pk7k", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $72787b545755cf1e$export$7e4cbedfdd7b4c0d);
$parcel$export(module.exports, "default", () => $72787b545755cf1e$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $l2Z7B = parcelRequire("l2Z7B");

var $5FkrB = parcelRequire("5FkrB");

var $ach6K = parcelRequire("ach6K");

var $5Kjrj = parcelRequire("5Kjrj");

var $htSVt = parcelRequire("htSVt");
var $ftB2S = parcelRequire("ftB2S");
var $2k5ES = parcelRequire("2k5ES");

var $b1zcR = parcelRequire("b1zcR");
function $72787b545755cf1e$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $72787b545755cf1e$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $b1zcR.isFormatXMLElementFn)(v) ? (0, $5Kjrj.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $72787b545755cf1e$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $72787b545755cf1e$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $2k5ES.formatMessage).apply(void 0, (0, $l2Z7B.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $5FkrB.Children.toArray(chunks);
    return chunks;
};
var $72787b545755cf1e$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $l2Z7B.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $72787b545755cf1e$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $htSVt.createIntl)((0, $l2Z7B.__assign)((0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, (0, $5Kjrj.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    return (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, coreIntl), {
        formatMessage: $72787b545755cf1e$var$formatMessage.bind(null, {
            locale: coreIntl.locale,
            timeZone: coreIntl.timeZone,
            fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
            formats: coreIntl.formats,
            defaultLocale: coreIntl.defaultLocale,
            defaultFormats: coreIntl.defaultFormats,
            messages: coreIntl.messages,
            onError: coreIntl.onError,
            defaultRichTextElements: defaultRichTextElements
        }, coreIntl.formatters)
    });
};
var $72787b545755cf1e$var$IntlProvider = /** @class */ function(_super) {
    (0, $l2Z7B.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $ftB2S.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: $72787b545755cf1e$export$7e4cbedfdd7b4c0d($72787b545755cf1e$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $72787b545755cf1e$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $72787b545755cf1e$var$processIntlConfig(props);
        if (!(0, $5Kjrj.shallowEqual)(prevConfig, config)) return {
            intl: $72787b545755cf1e$export$7e4cbedfdd7b4c0d(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $5Kjrj.invariantIntlContext)(this.state.intl);
        return $5FkrB.createElement((0, $ach6K.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $5Kjrj.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($5FkrB.PureComponent);
var $72787b545755cf1e$export$2e2bcd8739ae039 = $72787b545755cf1e$var$IntlProvider;

});
parcelRegister("htSVt", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $cb9fc0461b2a2e42$export$7e4cbedfdd7b4c0d);

var $l2Z7B = parcelRequire("l2Z7B");

var $ftB2S = parcelRequire("ftB2S");

var $lxO85 = parcelRequire("lxO85");

var $8IvbH = parcelRequire("8IvbH");

var $3h18O = parcelRequire("3h18O");

var $63ABF = parcelRequire("63ABF");

var $37L44 = parcelRequire("37L44");

var $2k5ES = parcelRequire("2k5ES");

var $cEdDX = parcelRequire("cEdDX");

var $bNLaT = parcelRequire("bNLaT");
function $cb9fc0461b2a2e42$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $cb9fc0461b2a2e42$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $cb9fc0461b2a2e42$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
}
function $cb9fc0461b2a2e42$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $ftB2S.createFormatters)(cache);
    var resolvedConfig = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, (0, $ftB2S.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $lxO85.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $lxO85.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $lxO85.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    $cb9fc0461b2a2e42$var$verifyConfigMessages(resolvedConfig);
    return (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $8IvbH.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $8IvbH.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $3h18O.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $63ABF.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $63ABF.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $63ABF.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $63ABF.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $63ABF.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $37L44.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $2k5ES.formatMessage).bind(null, resolvedConfig, formatters),
        $t: (0, $2k5ES.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $cEdDX.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $cEdDX.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $bNLaT.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("8IvbH", function(module, exports) {
$parcel$export(module.exports, "formatNumber", () => $658aa001f74e17e0$export$f5dd818bff069720);
$parcel$export(module.exports, "formatNumberToParts", () => $658aa001f74e17e0$export$6871080848f10b2f);

var $ftB2S = parcelRequire("ftB2S");

var $lxO85 = parcelRequire("lxO85");
var $658aa001f74e17e0$var$NUMBER_FORMAT_OPTIONS = [
    'localeMatcher',
    'style',
    'currency',
    'currencyDisplay',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem'
];
function $658aa001f74e17e0$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $ftB2S.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $ftB2S.filterProps)(options, $658aa001f74e17e0$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $658aa001f74e17e0$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $658aa001f74e17e0$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $lxO85.IntlError)((0, $lxO85.IntlErrorCode).FORMAT_ERROR, 'Error formatting number.', e));
    }
    return String(value);
}
function $658aa001f74e17e0$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $658aa001f74e17e0$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $lxO85.IntlError)((0, $lxO85.IntlErrorCode).FORMAT_ERROR, 'Error formatting number.', e));
    }
    return [];
}

});

parcelRegister("3h18O", function(module, exports) {
$parcel$export(module.exports, "formatRelativeTime", () => $2623d837842f9cad$export$b4ea3b48dcf921f6);

var $ftB2S = parcelRequire("ftB2S");

var $jpwqX = parcelRequire("jpwqX");

var $lxO85 = parcelRequire("lxO85");
var $2623d837842f9cad$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $2623d837842f9cad$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $ftB2S.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $ftB2S.filterProps)(options, $2623d837842f9cad$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $2623d837842f9cad$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $jpwqX.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $jpwqX.ErrorCode).MISSING_INTL_API));
    try {
        return $2623d837842f9cad$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $lxO85.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

});

parcelRegister("63ABF", function(module, exports) {
$parcel$export(module.exports, "formatDate", () => $468f6b2d6b5b6e33$export$3ae94a2503e890a1);
$parcel$export(module.exports, "formatTime", () => $468f6b2d6b5b6e33$export$3203edd9e5edd663);
$parcel$export(module.exports, "formatDateTimeRange", () => $468f6b2d6b5b6e33$export$a7fc3a91cb2ec376);
$parcel$export(module.exports, "formatDateToParts", () => $468f6b2d6b5b6e33$export$dc1f059bce486b1);
$parcel$export(module.exports, "formatTimeToParts", () => $468f6b2d6b5b6e33$export$af6e5d7a5c73edeb);

var $l2Z7B = parcelRequire("l2Z7B");

var $ftB2S = parcelRequire("ftB2S");

var $lxO85 = parcelRequire("lxO85");
var $468f6b2d6b5b6e33$var$DATE_TIME_FORMAT_OPTIONS = [
    'localeMatcher',
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem'
];
function $468f6b2d6b5b6e33$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $ftB2S.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $ftB2S.filterProps)(options, $468f6b2d6b5b6e33$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $468f6b2d6b5b6e33$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $468f6b2d6b5b6e33$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $lxO85.IntlError)((0, $lxO85.IntlErrorCode).FORMAT_ERROR, 'Error formatting date.', e));
    }
    return String(date);
}
function $468f6b2d6b5b6e33$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $468f6b2d6b5b6e33$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $lxO85.IntlError)((0, $lxO85.IntlErrorCode).FORMAT_ERROR, 'Error formatting time.', e));
    }
    return String(date);
}
function $468f6b2d6b5b6e33$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $ftB2S.filterProps)(options, $468f6b2d6b5b6e33$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $lxO85.IntlError)((0, $lxO85.IntlErrorCode).FORMAT_ERROR, 'Error formatting date time range.', e));
    }
    return String(from);
}
function $468f6b2d6b5b6e33$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $468f6b2d6b5b6e33$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $lxO85.IntlError)((0, $lxO85.IntlErrorCode).FORMAT_ERROR, 'Error formatting date.', e));
    }
    return [];
}
function $468f6b2d6b5b6e33$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $468f6b2d6b5b6e33$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $lxO85.IntlError)((0, $lxO85.IntlErrorCode).FORMAT_ERROR, 'Error formatting time.', e));
    }
    return [];
}

});

parcelRegister("37L44", function(module, exports) {
$parcel$export(module.exports, "formatPlural", () => $2466889469f751f1$export$bbbd05c900f3568d);

var $ftB2S = parcelRequire("ftB2S");

var $lxO85 = parcelRequire("lxO85");

var $jpwqX = parcelRequire("jpwqX");
var $2466889469f751f1$var$PLURAL_FORMAT_OPTIONS = [
    'localeMatcher',
    'type'
];
function $2466889469f751f1$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $jpwqX.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $jpwqX.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $ftB2S.filterProps)(options, $2466889469f751f1$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $lxO85.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

});

parcelRegister("2k5ES", function(module, exports) {
$parcel$export(module.exports, "formatMessage", () => $1b11d6a681c9014e$export$25868d1e8e76735f);

var $l2Z7B = parcelRequire("l2Z7B");

var $kVTHJ = parcelRequire("kVTHJ");

var $9exF4 = parcelRequire("9exF4");

var $lxO85 = parcelRequire("lxO85");
parcelRequire("6dpFj");
var $4VghZ = parcelRequire("4VghZ");
function $1b11d6a681c9014e$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $l2Z7B.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $1b11d6a681c9014e$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $1b11d6a681c9014e$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $9exF4.IntlMessageFormat).formats;
    return (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, mfFormats), f1), {
        date: $1b11d6a681c9014e$var$deepMergeOptions($1b11d6a681c9014e$var$setTimeZoneInOptions(mfFormats.date, timeZone), $1b11d6a681c9014e$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $1b11d6a681c9014e$var$deepMergeOptions($1b11d6a681c9014e$var$setTimeZoneInOptions(mfFormats.time, timeZone), $1b11d6a681c9014e$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
function $1b11d6a681c9014e$export$25868d1e8e76735f(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $kVTHJ.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $4VghZ.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, defaultRichTextElements), values || {});
    formats = $1b11d6a681c9014e$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $1b11d6a681c9014e$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $lxO85.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $lxO85.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $l2Z7B.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $lxO85.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $lxO85.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
}

});

parcelRegister("cEdDX", function(module, exports) {
$parcel$export(module.exports, "formatList", () => $9353cdc81fe3f1a9$export$e8b8be48b45905bb);
$parcel$export(module.exports, "formatListToParts", () => $9353cdc81fe3f1a9$export$6f284aad1934db69);

var $l2Z7B = parcelRequire("l2Z7B");

var $ftB2S = parcelRequire("ftB2S");

var $jpwqX = parcelRequire("jpwqX");

var $lxO85 = parcelRequire("lxO85");
var $9353cdc81fe3f1a9$var$LIST_FORMAT_OPTIONS = [
    'localeMatcher',
    'type',
    'style'
];
var $9353cdc81fe3f1a9$var$now = Date.now();
function $9353cdc81fe3f1a9$var$generateToken(i) {
    return "".concat($9353cdc81fe3f1a9$var$now, "_").concat(i, "_").concat($9353cdc81fe3f1a9$var$now);
}
function $9353cdc81fe3f1a9$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $9353cdc81fe3f1a9$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results;
}
function $9353cdc81fe3f1a9$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $jpwqX.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $jpwqX.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $ftB2S.filterProps)(options, $9353cdc81fe3f1a9$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === 'object') {
                var id = $9353cdc81fe3f1a9$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $lxO85.IntlError)((0, $lxO85.IntlErrorCode).FORMAT_ERROR, 'Error formatting list.', e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("bNLaT", function(module, exports) {
$parcel$export(module.exports, "formatDisplayName", () => $8978dd3e5f4a7a94$export$62fe1a4d9e891fa2);

var $ftB2S = parcelRequire("ftB2S");

var $jpwqX = parcelRequire("jpwqX");

var $lxO85 = parcelRequire("lxO85");
var $8978dd3e5f4a7a94$var$DISPLAY_NAMES_OPTONS = [
    'localeMatcher',
    'style',
    'type',
    'fallback'
];
function $8978dd3e5f4a7a94$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $jpwqX.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $jpwqX.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $ftB2S.filterProps)(options, $8978dd3e5f4a7a94$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $lxO85.IntlError)((0, $lxO85.IntlErrorCode).FORMAT_ERROR, 'Error formatting display name.', e));
    }
}

});



parcelRegister("elG2K", function(module, exports) {
$parcel$export(module.exports, "useMessages", () => $a723a3ce07aeaf5d$export$4d17e2d9c5348842);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $8FEOs = parcelRequire("8FEOs");
function $a723a3ce07aeaf5d$export$4d17e2d9c5348842(locale, loaderFn) {
    var _useState = (0, $5FkrB.useState)((0, $8FEOs.DEFAULT_LOCALE_STATE)), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), localeState = _useState2[0], setLocaleState = _useState2[1];
    var loadedLocaleRef = (0, $5FkrB.useRef)(localeState.locale);
    (0, $5FkrB.useEffect)(function() {
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        var current = true;
        loaderFn(locale).then(function(messages) {
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages !== null && messages !== void 0 ? messages : {}
                });
            }
        }, function(error) {
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return function() {
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
}

});
parcelRegister("8FEOs", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_LOCALE_STATE", () => $6501cfa6d304229b$export$79618bef82c02d4c);
var $6501cfa6d304229b$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};

});


parcelRegister("klKsD", function(module, exports) {
$parcel$export(module.exports, "useSafeIntl", () => $ed09cef97ff629d0$export$f752ac21ea3960a5);

var $5FkrB = parcelRequire("5FkrB");

var $9Pk7k = parcelRequire("9Pk7k");
var $ftB2S = parcelRequire("ftB2S");
var $ach6K = parcelRequire("ach6K");

var $8FEOs = parcelRequire("8FEOs");
// Prevents memory leaks
var $ed09cef97ff629d0$var$cache = (0, $ftB2S.createIntlCache)();
var $ed09cef97ff629d0$export$f752ac21ea3960a5 = function useSafeIntl() {
    var context = (0, $5FkrB.useContext)((0, $ach6K.Context));
    if (!context) return (0, $9Pk7k.createIntl)((0, $8FEOs.DEFAULT_LOCALE_STATE), $ed09cef97ff629d0$var$cache);
    return context;
};

});


parcelRegister("i2C5U", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $d225f6a1c2f7387a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $dpsBA = parcelRequire("dpsBA");
var $d225f6a1c2f7387a$export$2e2bcd8739ae039 = (0, $dpsBA.default);

});
parcelRegister("dpsBA", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c33cc9195371752$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $9c33cc9195371752$export$2e2bcd8739ae039 = {
    'admin-hub-pagination.next.page.button': 'Next',
    'admin-hub-pagination.page.range': '{itemsStart} to {itemsEnd} results',
    'admin-hub-pagination.page.range.with.total': '{itemsStart} to {itemsEnd} of {totalCount, plural, one {# result} other {# results}}',
    'admin-hub-pagination.pagination': 'Pagination',
    'admin-hub-pagination.previous.page.button': 'Previous',
    'admin-hub-pagination.refresh.count.current': 'Showing {currentCount, plural, one {# result} other {# results}} out of {totalCount} {label}',
    'admin-hub-pagination.refresh.count.total': 'Showing {totalCount} {label}',
    'admin-hub-pagination.refresh.item.default.label': '{totalCount, plural, one {Item} other {Items}}',
    'admin-hub-pagination.refresh.label': 'Refresh',
    'admin-hub-pagination.refresh.loading': 'Checking for updates',
    'admin-hub-pagination.result.per.page': 'Results per page:'
};

});


parcelRegister("7BOim", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("ecpS4").then(()=>parcelRequire('cBDH5'));

});

parcelRegister("lBZGT", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("dF9jh").then(()=>parcelRequire('bxiND'));

});

parcelRegister("bGn3J", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("g0gY2").then(()=>parcelRequire('45lp9'));

});

parcelRegister("kbs14", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("leOE2").then(()=>parcelRequire('drZZD'));

});

parcelRegister("he924", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("2SeHx").then(()=>parcelRequire('3AVeU'));

});

parcelRegister("6n0tt", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("zCgEk").then(()=>parcelRequire('3VY9x'));

});

parcelRegister("jpANc", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("fBQVT").then(()=>parcelRequire('2Xttc'));

});

parcelRegister("a0R1n", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("bsAI3").then(()=>parcelRequire('kprYx'));

});

parcelRegister("8oykS", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("lVjdg").then(()=>parcelRequire('eL7Qk'));

});

parcelRegister("4GjoG", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("iYq5l").then(()=>parcelRequire('l98DB'));

});

parcelRegister("inXrq", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("8ucTx").then(()=>parcelRequire('aCvFC'));

});

parcelRegister("ix375", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("eQ9ej").then(()=>parcelRequire('bxogB'));

});

parcelRegister("8NjuC", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("7TvKW").then(()=>parcelRequire('cLG0i'));

});

parcelRegister("5kzPX", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("bVq9q").then(()=>parcelRequire('ja1CQ'));

});

parcelRegister("7jwnm", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("eOaQO").then(()=>parcelRequire('5pB62'));

});

parcelRegister("73JLl", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("7Kmqe").then(()=>parcelRequire('gR32c'));

});

parcelRegister("01W4K", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("jnig0").then(()=>parcelRequire('hvq8N'));

});

parcelRegister("hGuAk", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("agclC").then(()=>parcelRequire('bnAcp'));

});

parcelRegister("e2uAj", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("aoRLF").then(()=>parcelRequire('iNlfw'));

});

parcelRegister("b9qm9", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("ceIx6").then(()=>parcelRequire('jhqka'));

});

parcelRegister("hk4dg", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("gwgSb").then(()=>parcelRequire('gpe45'));

});

parcelRegister("Jx3pr", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("9VMXq").then(()=>parcelRequire('3M7Lu'));

});

parcelRegister("cFvPh", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("c2QZs").then(()=>parcelRequire('kQvT3'));

});

parcelRegister("hwI6q", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("efLrJ").then(()=>parcelRequire('li3kc'));

});

parcelRegister("6bnW7", function(module, exports) {
$parcel$export(module.exports, "defineMessages", () => $0129647dae5e982a$export$1adfeb024f5185b);
$parcel$export(module.exports, "FormattedDate", () => $0129647dae5e982a$export$40ae3194919d16b);
$parcel$export(module.exports, "FormattedNumber", () => $0129647dae5e982a$export$db80edc1e6b2f63d);
$parcel$export(module.exports, "FormattedList", () => $0129647dae5e982a$export$f52b44e459e6e71d);

var $4txGJ = parcelRequire("4txGJ");

var $ach6K = parcelRequire("ach6K");

var $hrVKU = parcelRequire("hrVKU");

var $9Pk7k = parcelRequire("9Pk7k");

var $kPiFO = parcelRequire("kPiFO");


var $bgNpv = parcelRequire("bgNpv");


var $ftB2S = parcelRequire("ftB2S");
function $0129647dae5e982a$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $0129647dae5e982a$export$747d244ee58120dd(msg) {
    return msg;
}
var $0129647dae5e982a$export$40ae3194919d16b = (0, $4txGJ.createFormattedComponent)('formatDate');
var $0129647dae5e982a$export$5b390a54f8a846f7 = (0, $4txGJ.createFormattedComponent)('formatTime');
var $0129647dae5e982a$export$db80edc1e6b2f63d = (0, $4txGJ.createFormattedComponent)('formatNumber');
var $0129647dae5e982a$export$f52b44e459e6e71d = (0, $4txGJ.createFormattedComponent)('formatList');
var $0129647dae5e982a$export$c2336ea5aaab92fa = (0, $4txGJ.createFormattedComponent)('formatDisplayName');
var $0129647dae5e982a$export$7fdc7d2c91ce149b = (0, $4txGJ.createFormattedDateTimePartsComponent)('formatDate');
var $0129647dae5e982a$export$ec35873761676c2a = (0, $4txGJ.createFormattedDateTimePartsComponent)('formatTime');

});
parcelRegister("4txGJ", function(module, exports) {
$parcel$export(module.exports, "createFormattedDateTimePartsComponent", () => $342400a1edd754e2$export$7448277f6036d2ab);
$parcel$export(module.exports, "createFormattedComponent", () => $342400a1edd754e2$export$b37e14176d001dec);

var $l2Z7B = parcelRequire("l2Z7B");

var $5FkrB = parcelRequire("5FkrB");

var $hrVKU = parcelRequire("hrVKU");
var $342400a1edd754e2$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($342400a1edd754e2$var$DisplayName || ($342400a1edd754e2$var$DisplayName = {}));
var $342400a1edd754e2$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($342400a1edd754e2$var$DisplayNameParts || ($342400a1edd754e2$var$DisplayNameParts = {}));
var $342400a1edd754e2$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $hrVKU.default)();
    var value = props.value, children = props.children, formatProps = (0, $l2Z7B.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$342400a1edd754e2$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $342400a1edd754e2$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $hrVKU.default)();
    var value = props.value, children = props.children, formatProps = (0, $l2Z7B.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$342400a1edd754e2$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $342400a1edd754e2$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $hrVKU.default)();
        var value = props.value, children = props.children, formatProps = (0, $l2Z7B.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $342400a1edd754e2$var$DisplayNameParts[name];
    return ComponentParts;
}
function $342400a1edd754e2$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $hrVKU.default)();
        var value = props.value, children = props.children, formatProps = (0, $l2Z7B.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $5FkrB.Fragment;
        return $5FkrB.createElement(Text, null, formattedValue);
    };
    Component.displayName = $342400a1edd754e2$var$DisplayName[name];
    return Component;
}

});

parcelRegister("kPiFO", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2970e3937265c75$export$2e2bcd8739ae039);

var $l2Z7B = parcelRequire("l2Z7B");

var $5FkrB = parcelRequire("5FkrB");

var $kVTHJ = parcelRequire("kVTHJ");

var $hrVKU = parcelRequire("hrVKU");
var $f2970e3937265c75$var$MINUTE = 60;
var $f2970e3937265c75$var$HOUR = 3600;
var $f2970e3937265c75$var$DAY = 86400;
function $f2970e3937265c75$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $f2970e3937265c75$var$MINUTE) return 'second';
    if (absValue < $f2970e3937265c75$var$HOUR) return 'minute';
    if (absValue < $f2970e3937265c75$var$DAY) return 'hour';
    return 'day';
}
function $f2970e3937265c75$var$getDurationInSeconds(unit) {
    switch(unit){
        case 'second':
            return 1;
        case 'minute':
            return $f2970e3937265c75$var$MINUTE;
        case 'hour':
            return $f2970e3937265c75$var$HOUR;
        default:
            return $f2970e3937265c75$var$DAY;
    }
}
function $f2970e3937265c75$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case 'second':
            return value;
        case 'minute':
            return value * $f2970e3937265c75$var$MINUTE;
        default:
            return value * $f2970e3937265c75$var$HOUR;
    }
}
var $f2970e3937265c75$var$INCREMENTABLE_UNITS = [
    'second',
    'minute',
    'hour'
];
function $f2970e3937265c75$var$canIncrement(unit) {
    if (unit === void 0) unit = 'second';
    return $f2970e3937265c75$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $f2970e3937265c75$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $hrVKU.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, $l2Z7B.__rest)(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === 'function') return children(formattedRelativeTime);
    if (Text) return $5FkrB.createElement(Text, null, formattedRelativeTime);
    return $5FkrB.createElement($5FkrB.Fragment, null, formattedRelativeTime);
};
var $f2970e3937265c75$var$FormattedRelativeTime = function(_a) {
    var value = _a.value, unit = _a.unit, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, $l2Z7B.__rest)(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $kVTHJ.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $f2970e3937265c75$var$canIncrement(unit)), 'Cannot schedule update with unit longer than hour');
    var _b = $5FkrB.useState(), prevUnit = _b[0], setPrevUnit = _b[1];
    var _c = $5FkrB.useState(0), prevValue = _c[0], setPrevValue = _c[1];
    var _d = $5FkrB.useState(0), currentValueInSeconds = _d[0], setCurrentValueInSeconds = _d[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($f2970e3937265c75$var$canIncrement(unit) ? $f2970e3937265c75$var$valueToSeconds(value, unit) : 0);
    }
    $5FkrB.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$f2970e3937265c75$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $f2970e3937265c75$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === 'day') return clearUpdateTimer;
        var unitDuration = $f2970e3937265c75$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($f2970e3937265c75$var$canIncrement(unit) && typeof currentValueInSeconds === 'number' && updateIntervalInSeconds) {
        currentUnit = $f2970e3937265c75$var$selectUnit(currentValueInSeconds);
        var unitDuration = $f2970e3937265c75$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $5FkrB.createElement($f2970e3937265c75$var$SimpleFormattedRelativeTime, (0, $l2Z7B.__assign)({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$f2970e3937265c75$var$FormattedRelativeTime.displayName = 'FormattedRelativeTime';
$f2970e3937265c75$var$FormattedRelativeTime.defaultProps = {
    value: 0,
    unit: 'second'
};
var $f2970e3937265c75$export$2e2bcd8739ae039 = $f2970e3937265c75$var$FormattedRelativeTime;

});


parcelRegister("eSyoe", function(module, exports) {

var $lIhLB = parcelRequire("lIhLB");

var $2IEpz = parcelRequire("2IEpz");

var $bSUt0 = parcelRequire("bSUt0");
/** Error message constants. */ var $ad50c8eeec1f512b$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ad50c8eeec1f512b$var$nativeMax = Math.max, $ad50c8eeec1f512b$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $ad50c8eeec1f512b$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($ad50c8eeec1f512b$var$FUNC_ERROR_TEXT);
    wait = $bSUt0(wait) || 0;
    if ($lIhLB(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $ad50c8eeec1f512b$var$nativeMax($bSUt0(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $ad50c8eeec1f512b$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $2IEpz();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($2IEpz());
    }
    function debounced() {
        var time = $2IEpz(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = $ad50c8eeec1f512b$var$debounce;

});
parcelRegister("2IEpz", function(module, exports) {

var $iXqsg = parcelRequire("iXqsg");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $1faf09b77d13e0f6$var$now = function() {
    return $iXqsg.Date.now();
};
module.exports = $1faf09b77d13e0f6$var$now;

});

parcelRegister("bSUt0", function(module, exports) {

var $2UuW5 = parcelRequire("2UuW5");

var $lIhLB = parcelRequire("lIhLB");

var $3sIvm = parcelRequire("3sIvm");
/** Used as references for various `Number` constants. */ var $8a7089fbe4706c31$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $8a7089fbe4706c31$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $8a7089fbe4706c31$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $8a7089fbe4706c31$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $8a7089fbe4706c31$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $8a7089fbe4706c31$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($3sIvm(value)) return $8a7089fbe4706c31$var$NAN;
    if ($lIhLB(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $lIhLB(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $2UuW5(value);
    var isBinary = $8a7089fbe4706c31$var$reIsBinary.test(value);
    return isBinary || $8a7089fbe4706c31$var$reIsOctal.test(value) ? $8a7089fbe4706c31$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $8a7089fbe4706c31$var$reIsBadHex.test(value) ? $8a7089fbe4706c31$var$NAN : +value;
}
module.exports = $8a7089fbe4706c31$var$toNumber;

});
parcelRegister("2UuW5", function(module, exports) {

var $joR0V = parcelRequire("joR0V");
/** Used to match leading whitespace. */ var $21e8cef54ead7066$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $21e8cef54ead7066$var$baseTrim(string) {
    return string ? string.slice(0, $joR0V(string) + 1).replace($21e8cef54ead7066$var$reTrimStart, '') : string;
}
module.exports = $21e8cef54ead7066$var$baseTrim;

});
parcelRegister("joR0V", function(module, exports) {
/** Used to match a single whitespace character. */ var $e1f961ac832bfec6$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $e1f961ac832bfec6$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $e1f961ac832bfec6$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $e1f961ac832bfec6$var$trimmedEndIndex;

});




parcelRegister("kuWWJ", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("gAHKi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::455ddf841838a21b0f783ea6448b0f9c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c141f119f975d6a4$var$_react = $c141f119f975d6a4$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $c141f119f975d6a4$var$_iconNew = $c141f119f975d6a4$var$_interopRequireDefault((parcelRequire("gDzom")));
function $c141f119f975d6a4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/search
 * Usage guidance:
 * Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c141f119f975d6a4$var$SearchIcon = (props)=>/*#__PURE__*/ $c141f119f975d6a4$var$_react.default.createElement($c141f119f975d6a4$var$_iconNew.default, Object.assign({
        name: "SearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7" clip-rule="evenodd"/>`
    }, props));
$c141f119f975d6a4$var$SearchIcon.displayName = 'SearchIcon';
var $c141f119f975d6a4$var$_default = module.exports.default = $c141f119f975d6a4$var$SearchIcon;

});

parcelRegister("6fyuV", function(module, exports) {
$parcel$export(module.exports, "default", () => $48cee75820d7c027$export$2e2bcd8739ae039);
/* text-field.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $ekGgq = parcelRequire("ekGgq");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $aLEtb = parcelRequire("aLEtb");

var $50U6m = parcelRequire("50U6m");
var $48cee75820d7c027$var$_excluded = [
    "appearance",
    "className",
    "elemAfterInput",
    "elemBeforeInput",
    "isCompact",
    "isDisabled",
    "isInvalid",
    "isMonospaced",
    "isReadOnly",
    "isRequired",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onMouseDown",
    "placeholder",
    "testId",
    "width"
];
function $48cee75820d7c027$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $48cee75820d7c027$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $48cee75820d7c027$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $48cee75820d7c027$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $48cee75820d7c027$var$containerMedia = {
    invalid: "_msj6gir2",
    disabled: "_6up518qt"
};
var $48cee75820d7c027$var$inputMediaDisabled = null;
var $48cee75820d7c027$var$analyticsParams = {
    componentName: 'textField',
    packageName: "@atlaskit/textfield",
    packageVersion: "10.2.3"
};
var $48cee75820d7c027$var$disabledStyle = {
    standard: "_1h6d187o _bfhk187o _syaz1gmx _80om13gf",
    subtle: "_1h6d1j28 _bfhk1j28 _syaz1gmx _80om13gf",
    none: "_1h6d1j28 _bfhk1j28 _syaz1gmx _80om13gf"
};
var $48cee75820d7c027$var$invalidStyle = null;
var $48cee75820d7c027$var$focusWithinStyle = {
    standard: "_1p9x1v1w _qao9r01l _q433vyy1",
    subtle: "_1p9x1v1w _qao9r01l _q433vyy1",
    none: "_1p9x1j28 _qao91j28 _q4333sij"
};
var $48cee75820d7c027$var$hoverStyle = {
    standard: "_4cvxrsbi _irr3l4ek",
    subtle: "_4cvxrsbi _irr3l4ek",
    none: "_4cvx1j28 _irr31j28"
};
var $48cee75820d7c027$var$getContainerTextBgAndBorderColor = {
    standard: "_1h6drsbi _1dqonqa1 _syazi7uo _80om1kdv _bfhk1j9a _msj6gir2",
    subtle: "_1h6d1j28 _1dqonqa1 _syazi7uo _80om1kdv _16hg1j28 _msj6gir2",
    none: "_1h6d1j28 _1dqoglyw _syazi7uo _80om1kdv _16hg1j28 _msj6gir2"
};
var $48cee75820d7c027$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
var $48cee75820d7c027$var$getMaxWidth = function getMaxWidth(width) {
    return !width ? "100%" : width in $48cee75820d7c027$var$widthMap ? "".concat($48cee75820d7c027$var$widthMap[width], "px") : "".concat(+width, "px");
};
var $48cee75820d7c027$var$containerStyleAppearance = {
    standard: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    subtle: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    none: "_1dqoglyw"
};
var $48cee75820d7c027$var$containerStyles = null;
var $48cee75820d7c027$var$inputDisabledStyle = null;
var $48cee75820d7c027$var$inputCompactStyle = null;
var $48cee75820d7c027$var$inputMonospacedStyle = null;
// iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textfield uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
var $48cee75820d7c027$var$inputStyle = null;
var $48cee75820d7c027$var$finessePlaceholderStyle = null;
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ var $48cee75820d7c027$var$Textfield = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'standard' : _props$appearance, className = props.className, elemAfterInput = props.elemAfterInput, elemBeforeInput = props.elemBeforeInput, _props$isCompact = props.isCompact, isCompact = _props$isCompact === void 0 ? false : _props$isCompact, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isMonospaced = props.isMonospaced, isMonospaced = _props$isMonospaced === void 0 ? false : _props$isMonospaced, _props$isReadOnly = props.isReadOnly, isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly, _props$isRequired = props.isRequired, isRequired = _props$isRequired === void 0 ? false : _props$isRequired, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, onMouseDown = props.onMouseDown, placeholder = props.placeholder, testId = props.testId, width = props.width, spreadProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $48cee75820d7c027$var$_excluded);
    var inputRef = (0, $5FkrB.useRef)(null);
    var handleOnFocus = (0, $aLEtb.usePlatformLeafEventHandler)($48cee75820d7c027$var$_objectSpread({
        fn: function fn(event) {
            onFocus && onFocus(event);
        },
        action: 'focused'
    }, $48cee75820d7c027$var$analyticsParams));
    var handleOnBlur = (0, $aLEtb.usePlatformLeafEventHandler)($48cee75820d7c027$var$_objectSpread({
        fn: function fn(event) {
            onBlur && onBlur(event);
        },
        action: 'blurred'
    }, $48cee75820d7c027$var$analyticsParams));
    var handleOnMouseDown = (0, $5FkrB.useCallback)(function(event) {
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        var target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    var setInputRef = (0, $5FkrB.useCallback)(function(inputElement) {
        inputRef.current = inputElement;
        if (!ref) return;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref) === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && "".concat(testId, "-container"),
        onMouseDown: handleOnMouseDown,
        style: {
            maxWidth: "".concat($48cee75820d7c027$var$getMaxWidth(width))
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $970q7.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c8fhey _1reo15vq _18m915vq _v564r5cv _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnq1qi0",
            $48cee75820d7c027$var$getContainerTextBgAndBorderColor[appearance],
            $48cee75820d7c027$var$containerStyleAppearance[appearance],
            !isDisabled && $48cee75820d7c027$var$focusWithinStyle[appearance],
            !isDisabled && $48cee75820d7c027$var$hoverStyle[appearance],
            isDisabled && $48cee75820d7c027$var$containerMedia.disabled,
            isDisabled && $48cee75820d7c027$var$disabledStyle[appearance],
            isInvalid && $48cee75820d7c027$var$containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qsizbr _1dbzizbr _uk1sr01l",
            className
        ])
    }, elemBeforeInput, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, spreadProps, {
        "aria-invalid": isInvalid ? isInvalid : undefined,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired,
        className: (0, $970q7.default)([
            "_19itidpf _11c81d4k _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk1j28 _syaz1kw7 _80om1kw7 _14ji12x7 _olc612x7 _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr1rpy _1tn2fhey _l9oiu2gc _549yu2gc _1h5w12x7 _124212x7",
            (0, $50U6m.fg)('platform-dst-tokens-finesse') && "_1idrazsu",
            isMonospaced && "_ect4zzfg _14mdzzfg",
            isCompact && "_11zpv77o _1l02v77o _daj712x7 _141f12x7 _1srd1b66 _oi9h1b66 _1e3012x7 _1txv12x7",
            isDisabled && "_syaz1gmx _1idr1gmx",
            isDisabled && "_1fnx18qt"
        ])
    })), elemAfterInput);
});
var $48cee75820d7c027$export$2e2bcd8739ae039 = $48cee75820d7c027$var$Textfield;

});

parcelRegister("ifX9g", function(module, exports) {
$parcel$export(module.exports, "Pressable", () => $d4a7825669dd53f6$export$27c701ed9e449e99);
$parcel$export(module.exports, "default", () => $d4a7825669dd53f6$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $fC8ib = parcelRequire("fC8ib");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $aLEtb = parcelRequire("aLEtb");

var $eVb4V = parcelRequire("eVb4V");

var $eqVaP = parcelRequire("eqVaP");

var $8TPdI = parcelRequire("8TPdI");

var $jPLJI = parcelRequire("jPLJI");

var $4FBpX = parcelRequire("4FBpX");

var $7xD7o = parcelRequire("7xD7o");

var $6ZsH1 = parcelRequire("6ZsH1");

var $aWY4P = parcelRequire("aWY4P");
var $d4a7825669dd53f6$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $d4a7825669dd53f6$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $d4a7825669dd53f6$var$focusRingStyles = (0, $74Zh5.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $jPLJI.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $aWY4P.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $4FBpX.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: "".concat((0, $4FBpX.borderWidthMap)['border.width'], " solid")
        }
    }
});
var $d4a7825669dd53f6$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
var $d4a7825669dd53f6$var$enabledStyles = (0, $74Zh5.css)({
    cursor: 'pointer'
});
var $d4a7825669dd53f6$var$disabledStyles = (0, $74Zh5.css)({
    cursor: 'not-allowed'
});
var $d4a7825669dd53f6$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $eVb4V.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $d4a7825669dd53f6$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $aLEtb.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "22.5.1",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $d4a7825669dd53f6$var$_excluded2);
    var resolvedStyles = (0, $6ZsH1.parseXcss)(xcss);
    return (0, $74Zh5.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $d4a7825669dd53f6$var$baseStyles,
            $d4a7825669dd53f6$var$focusRingStyles,
            isDisabled ? $d4a7825669dd53f6$var$disabledStyles : $d4a7825669dd53f6$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $8TPdI.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $7xD7o.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $7xD7o.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $7xD7o.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $7xD7o.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $7xD7o.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $7xD7o.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $7xD7o.paddingStylesMap).paddingInlineEnd[paddingInlineEnd]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(resolvedStyles.emotion || [])),
        "data-testid": testId
    }), children);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$d4a7825669dd53f6$export$2e2bcd8739ae039 = $d4a7825669dd53f6$export$27c701ed9e449e99;

});

parcelRegister("j5dho", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bdcfaadd200b1558cd21a6be22e04743>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de48c9039bc5ccc4$var$_react = $de48c9039bc5ccc4$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $de48c9039bc5ccc4$var$_iconNew = $de48c9039bc5ccc4$var$_interopRequireDefault((parcelRequire("gDzom")));
function $de48c9039bc5ccc4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/calendar
 * Usage guidance:
 * Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $de48c9039bc5ccc4$var$CalendarIcon = (props)=>/*#__PURE__*/ $de48c9039bc5ccc4$var$_react.default.createElement($de48c9039bc5ccc4$var$_iconNew.default, Object.assign({
        name: "CalendarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$de48c9039bc5ccc4$var$CalendarIcon.displayName = 'CalendarIcon';
var $de48c9039bc5ccc4$var$_default = module.exports.default = $de48c9039bc5ccc4$var$CalendarIcon;

});

parcelRegister("bCpKE", function(module, exports) {
$parcel$export(module.exports, "createLocalizationProvider", () => $8757380721f8d58c$export$ea56ca58f08ffa52);

var $fC8ib = parcelRequire("fC8ib");

var $50U6m = parcelRequire("50U6m");

var $O88OY = parcelRequire("O88OY");

var $dEOoP = parcelRequire("dEOoP");

var $kkUAE = parcelRequire("kkUAE");
var $8757380721f8d58c$export$ea56ca58f08ffa52 = function createLocalizationProvider(locale, formatterOptions) {
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    var normalizedLocale = (0, $O88OY.normalizeLocale)(locale);
    var intlLocale = new Intl.Locale(normalizedLocale);
    var formatDate = function formatDate(date) {
        return Intl.DateTimeFormat(normalizedLocale).format(date);
    };
    var formatTime = function formatTime(date) {
        return Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    };
    var getDays = function getDays() {
        var weekStartDay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var length = arguments.length > 1 ? arguments[1] : undefined;
        var dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        var weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        var rotatedWeekdays = weekStartDay > 0 ? [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(weekdays.slice(weekStartDay)), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(weekdays.slice(0, weekStartDay))) : weekdays;
        return rotatedWeekdays.map(function(day) {
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            var result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    var getDaysShort = function getDaysShort() {
        var weekStartDay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        return getDays(weekStartDay, 'short');
    };
    var getDaysLong = function getDaysLong() {
        var weekStartDay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        return getDays(weekStartDay, 'long');
    };
    var getMonthsLong = function getMonthsLong() {
        var monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map(function(month) {
            return(// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
        });
    };
    var parseDate = function parseDate(date) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return (0, $dEOoP.createDateParser)(normalizedLocale)(date, options);
    };
    var formatToParts = function formatToParts() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
        var formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
     * Safari has a bug that returns the wrong month for years 2005 and before.
     * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
     * Not all the months fail in each year. To ensure the correct output,
     * we select 2020 as the base year for the whole date,
     * then we replace in the result the original input year
     */ var fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        var fixedParts = (0, $kkUAE.toFormattedParts)(formatter.formatToParts(fixedDate));
        var originalParts = (0, $kkUAE.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
     * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
     * We fix it by detecting the real time with getHours method
     */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    var getFirstDayOfWeek = function getFirstDayOfWeek() {
        if (!(0, $50U6m.fg)('platform-dst-locale-week-start-day')) return 0;
        // Typed via platform/typings/esnext.intl.d.ts until lib ESNext.Intl is enabled.
        // See https://github.com/microsoft/TypeScript/issues/61713#issuecomment-5569377698
        var weekInfo = intlLocale.getWeekInfo();
        // Intl uses ISO weekdays (1 = Monday … 7 = Sunday).
        // Calendar / getDays* use JS weekdays (0 = Sunday … 6 = Saturday).
        return weekInfo.firstDay % 7;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts,
        getFirstDayOfWeek: getFirstDayOfWeek
    };
};

});
parcelRegister("O88OY", function(module, exports) {
$parcel$export(module.exports, "normalizeLocale", () => $096afc5067edc0cd$export$dca0327c9b9c6498);
var $096afc5067edc0cd$export$dca0327c9b9c6498 = function normalizeLocale(locale) {
    return locale.replace(/_/g, '-');
};

});

parcelRegister("dEOoP", function(module, exports) {
$parcel$export(module.exports, "createDateParser", () => $9f161b134342570e$export$cfa2ef2687faeda2);

var $O88OY = parcelRequire("O88OY");

var $lUraI = parcelRequire("lUraI");

var $itgND = parcelRequire("itgND");

var $tZftm = parcelRequire("tZftm");
var $9f161b134342570e$var$INVALID_DATE = new Date(NaN);
var $9f161b134342570e$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
var $9f161b134342570e$var$INVARIANT_DATE = (0, $tZftm.toDate)($9f161b134342570e$var$INVARIANT);
var $9f161b134342570e$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
var $9f161b134342570e$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
var $9f161b134342570e$var$stripExtras = function stripExtras(str) {
    return str.replace(/\u200E/g, '');
};
var $9f161b134342570e$var$extractDateParts = function extractDateParts(matchResult) {
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map(function(datePart) {
        return parseInt(datePart, 10);
    });
};
var $9f161b134342570e$export$cfa2ef2687faeda2 = function createDateParser(locale) {
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    var normalizedLocale = (0, $O88OY.normalizeLocale)(locale);
    var dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    var rawDateString = dateFormatter.format($9f161b134342570e$var$INVARIANT_DATE);
    var shortDate = $9f161b134342570e$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    var formatMatch = shortDate.match($9f161b134342570e$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    var formatParts = $9f161b134342570e$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    var yearPosition = formatParts.indexOf($9f161b134342570e$var$INVARIANT.year);
    var monthPosition = formatParts.indexOf($9f161b134342570e$var$INVARIANT.month);
    var dayPosition = formatParts.indexOf($9f161b134342570e$var$INVARIANT.day);
    return function(date) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var dateMatch = $9f161b134342570e$var$stripExtras(date).match($9f161b134342570e$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $9f161b134342570e$var$INVALID_DATE;
        var dateParts = $9f161b134342570e$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        var extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        var normalizedDate = (0, $itgND.normalizeDate)(extractedDate, options === null || options === void 0 ? void 0 : options.defaultFirstDay);
        if (!(0, $lUraI.isValid)(normalizedDate)) return $9f161b134342570e$var$INVALID_DATE;
        return (0, $tZftm.toDate)(normalizedDate);
    };
};

});
parcelRegister("lUraI", function(module, exports) {
$parcel$export(module.exports, "isValid", () => $ff33e7b4c131cbed$export$1ea939691cdc45b8);

var $dLtJP = parcelRequire("dLtJP");
var $ff33e7b4c131cbed$export$1ea939691cdc45b8 = function isValid(date) {
    var year = date.year, month = date.month, day = date.day;
    var daysInMonth = (0, $dLtJP.getDaysInMonth)(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};

});
parcelRegister("dLtJP", function(module, exports) {
$parcel$export(module.exports, "getDaysInMonth", () => $02960b4870ae0dc0$export$f645ddd439eb259d);

var $ljBWV = parcelRequire("ljBWV");
var $02960b4870ae0dc0$export$f645ddd439eb259d = function getDaysInMonth(year, month) {
    // February depends on leap year
    if (month === 2 && (0, $ljBWV.isLeapYear)(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};

});
parcelRegister("ljBWV", function(module, exports) {
$parcel$export(module.exports, "isLeapYear", () => $f848cf4a5bdc1e88$export$553d7fa8e3805fc0);
var $f848cf4a5bdc1e88$export$553d7fa8e3805fc0 = function isLeapYear(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};

});



parcelRegister("itgND", function(module, exports) {
$parcel$export(module.exports, "normalizeDate", () => $d727f778dbdc99fa$export$fcc71269590ba0a8);

var $4hTSo = parcelRequire("4hTSo");
var $d727f778dbdc99fa$export$fcc71269590ba0a8 = function normalizeDate(date) {
    var defaultFirstDay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var now = (0, $4hTSo.toDateObj)(new Date());
    var year = date.year, month = date.month, day = date.day;
    // 19 should evaluate to 2019
    var fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    var normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    var normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    var normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});
parcelRegister("4hTSo", function(module, exports) {
$parcel$export(module.exports, "toDateObj", () => $31f417d15b2909ce$export$abe96da78d4f59dd);
var $31f417d15b2909ce$export$abe96da78d4f59dd = function toDateObj(date) {
    return {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    };
};

});


parcelRegister("tZftm", function(module, exports) {
$parcel$export(module.exports, "toDate", () => $05a2383c5952984a$export$e67a095c620b86fe);
var $05a2383c5952984a$export$e67a095c620b86fe = function toDate(date) {
    return(// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day));
};

});


parcelRegister("kkUAE", function(module, exports) {
$parcel$export(module.exports, "toFormattedParts", () => $ece192877f9cb9e6$export$9b7ca29af37c192);

var $25nEq = parcelRequire("25nEq");
function $ece192877f9cb9e6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ece192877f9cb9e6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ece192877f9cb9e6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ece192877f9cb9e6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ece192877f9cb9e6$export$9b7ca29af37c192 = function toFormattedParts(rawParts) {
    return rawParts.reduce(function(result, datePart) {
        return $ece192877f9cb9e6$var$_objectSpread($ece192877f9cb9e6$var$_objectSpread({}, result), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, datePart.type, datePart.value));
    }, {});
};

});


parcelRegister("78ORw", function(module, exports) {
$parcel$export(module.exports, "default", () => $5330bbf7705e7e35$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $iMit8 = parcelRequire("iMit8");

var $kFNli = parcelRequire("kFNli");

var $fbEFz = parcelRequire("fbEFz");

var $jr0yw = parcelRequire("jr0yw");
var $5330bbf7705e7e35$var$packageName = "@atlaskit/select";
var $5330bbf7705e7e35$var$packageVersion = "22.11.5";
var $5330bbf7705e7e35$var$createAndFireEventOnAtlaskit = (0, $iMit8.default)('atlaskit');
var $5330bbf7705e7e35$var$Select = (0, $kFNli.default)({
    componentName: 'select',
    packageName: $5330bbf7705e7e35$var$packageName,
    packageVersion: $5330bbf7705e7e35$var$packageVersion
})((0, $fbEFz.default)({
    onChange: $5330bbf7705e7e35$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $5330bbf7705e7e35$var$packageName,
            packageVersion: $5330bbf7705e7e35$var$packageVersion
        }
    })
})((0, $jr0yw.SelectWithoutAnalytics)));
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$5330bbf7705e7e35$export$2e2bcd8739ae039 = $5330bbf7705e7e35$var$Select;

});
parcelRegister("iMit8", function(module, exports) {
$parcel$export(module.exports, "default", () => $dabb093c0c5b1634$export$2e2bcd8739ae039);
var $dabb093c0c5b1634$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};

});

parcelRegister("kFNli", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0cde958f3677352$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $l9NcB = parcelRequire("l9NcB");
var $f0cde958f3677352$var$_excluded = [
    "analyticsContext"
];
function $f0cde958f3677352$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f0cde958f3677352$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f0cde958f3677352$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f0cde958f3677352$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f0cde958f3677352$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $f0cde958f3677352$var$_excluded);
            var analyticsData = (0, $5FkrB.useMemo)(function() {
                return $f0cde958f3677352$var$_objectSpread($f0cde958f3677352$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $l9NcB.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
                ref: ref
            })));
        });
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $f0cde958f3677352$export$2e2bcd8739ae039 = $f0cde958f3677352$var$withAnalyticsContext;

});
parcelRegister("l9NcB", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6709ac4711d5a89$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $50U6m = parcelRequire("50U6m");

var $1gg3S = parcelRequire("1gg3S");

var $ftEKF = parcelRequire("ftEKF");

var $d1YUA = parcelRequire("d1YUA");
var $f6709ac4711d5a89$var$AnalyticsContext = function AnalyticsContext(props) {
    // Resolved once at mount, never re-read: Modern and Legacy are different component types, so
    // switching on a later render would unmount the whole subtree beneath this provider.
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(function() {
        return (0, $1gg3S.default) || (0, $50U6m.fg)('analytics-next-use-legacy-context') === false || (0, $50U6m.fg)('adminhub-analytics-next-use-modern-context');
    }), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState, 1), isModernContext = _React$useState2[0];
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d1YUA.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ftEKF.default), props);
};
var $f6709ac4711d5a89$export$2e2bcd8739ae039 = $f6709ac4711d5a89$var$AnalyticsContext;

});
parcelRegister("1gg3S", function(module, exports) {
$parcel$export(module.exports, "default", () => $0eb3be8b64b15357$export$2e2bcd8739ae039);

var $3ZMUU = parcelRequire("3ZMUU");
var $0eb3be8b64b15357$var$_process$env;
/// <reference types="node" />
var $0eb3be8b64b15357$var$_default_1 = typeof $3ZMUU !== 'undefined' && $3ZMUU !== null && (($0eb3be8b64b15357$var$_process$env = {}, $0eb3be8b64b15357$var$_process$env === void 0) ? void 0 : $0eb3be8b64b15357$var$_process$env['ANALYTICS_NEXT_MODERN_CONTEXT']);
var $0eb3be8b64b15357$export$2e2bcd8739ae039 = $0eb3be8b64b15357$var$_default_1;

});

parcelRegister("ftEKF", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4492ce4107f08c4$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $8vJ0V = parcelRequire("8vJ0V");

var $iyyOp = parcelRequire("iyyOp");
function $b4492ce4107f08c4$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $b4492ce4107f08c4$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $b4492ce4107f08c4$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b4492ce4107f08c4$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $b4492ce4107f08c4$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).func
};
var $b4492ce4107f08c4$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $b4492ce4107f08c4$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsContext);
        _this = $b4492ce4107f08c4$var$_callSuper(this, AnalyticsContext, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $b4492ce4107f08c4$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $b4492ce4107f08c4$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(AnalyticsContext, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iyyOp.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
}((0, $5FkrB.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b4492ce4107f08c4$var$AnalyticsContext, "contextTypes", $b4492ce4107f08c4$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b4492ce4107f08c4$var$AnalyticsContext, "childContextTypes", $b4492ce4107f08c4$var$ContextTypes);
var $b4492ce4107f08c4$export$2e2bcd8739ae039 = $b4492ce4107f08c4$var$AnalyticsContext;

});

parcelRegister("d1YUA", function(module, exports) {
$parcel$export(module.exports, "default", () => $97ca9e2bedb57888$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");

var $509QN = parcelRequire("509QN");

var $cqQpq = parcelRequire("cqQpq");
var $97ca9e2bedb57888$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $cqQpq.useTrackedRef)(data);
    var _useAnalyticsContext = (0, $509QN.useAnalyticsContext)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $5FkrB.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $5FkrB.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iyyOp.default).Provider, {
        value: value
    }, children);
};
var $97ca9e2bedb57888$export$2e2bcd8739ae039 = $97ca9e2bedb57888$var$AnalyticsContext;

});



parcelRegister("fbEFz", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0e76e33fa7d4968$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $bDUuG = parcelRequire("bDUuG");

var $cDc6S = parcelRequire("cDc6S");
var $b0e76e33fa7d4968$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
            var _usePatchedProps = (0, $cDc6S.usePatchedProps)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $bDUuG.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $b0e76e33fa7d4968$export$2e2bcd8739ae039 = $b0e76e33fa7d4968$var$withAnalyticsEvents;

});
parcelRegister("cDc6S", function(module, exports) {
$parcel$export(module.exports, "usePatchedProps", () => $9322855ad5a6ed63$export$9ebb5a84d17e5d18);

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $bDUuG = parcelRequire("bDUuG");
function $9322855ad5a6ed63$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9322855ad5a6ed63$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9322855ad5a6ed63$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9322855ad5a6ed63$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9322855ad5a6ed63$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $bDUuG.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $5FkrB.useRef)({});
    var patchedProps = (0, $5FkrB.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $9322855ad5a6ed63$var$_objectSpread($9322855ad5a6ed63$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $9322855ad5a6ed63$var$_objectSpread($9322855ad5a6ed63$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});


parcelRegister("jr0yw", function(module, exports) {
$parcel$export(module.exports, "SelectWithoutAnalytics", () => $e260f84bd2b3a814$export$d1de3b251ccaa8a3);

var $ltFAn = parcelRequire("ltFAn");

var $jjC0m = parcelRequire("jjC0m");
var $e260f84bd2b3a814$export$d1de3b251ccaa8a3 = (0, $jjC0m.default)((0, $ltFAn.default));

});
parcelRegister("ltFAn", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa2c90720798138e$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $cLLJ4 = parcelRequire("cLLJ4");

var $ikjov = parcelRequire("ikjov");

var $d2TmP = parcelRequire("d2TmP");
var $fa2c90720798138e$var$AsyncSelect = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    // when isAsync is true, options are not provided and async props are used, we will enable async
    var isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    var stateManagedProps = (0, $ikjov.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    var selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    var selectProps = (0, $d2TmP.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cLLJ4.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: ref
    }, selectProps));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fa2c90720798138e$export$2e2bcd8739ae039 = $fa2c90720798138e$var$AsyncSelect;

});
parcelRegister("cLLJ4", function(module, exports) {
$parcel$export(module.exports, "default", () => $94bee52f6056242d$export$2e2bcd8739ae039);
/* select.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");
parcelRequire("dujqE");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $fC8ib = parcelRequire("fC8ib");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $dJ32z = parcelRequire("dJ32z");

var $dsVPZ = parcelRequire("dsVPZ");

var $eVb4V = parcelRequire("eVb4V");

var $Ew39N = parcelRequire("Ew39N");

var $2goCw = parcelRequire("2goCw");

var $j7QB2 = parcelRequire("j7QB2");

var $jOlL3 = parcelRequire("jOlL3");

var $6muHy = parcelRequire("6muHy");

var $liCzk = parcelRequire("liCzk");

var $3yr7f = parcelRequire("3yr7f");

var $1l3Nw = parcelRequire("1l3Nw");

var $eF1OB = parcelRequire("eF1OB");

var $fuxeO = parcelRequire("fuxeO");

var $4JhfO = parcelRequire("4JhfO");

var $jKHAs = parcelRequire("jKHAs");

var $iDDR5 = parcelRequire("iDDR5");

var $k28lc = parcelRequire("k28lc");

var $ecwrt = parcelRequire("ecwrt");

var $i7tRn = parcelRequire("i7tRn");

var $i2prK = parcelRequire("i2prK");

var $9LMRF = parcelRequire("9LMRF");

var $1I7vO = parcelRequire("1I7vO");

var $7rzUZ = parcelRequire("7rzUZ");

var $f49h5 = parcelRequire("f49h5");

var $daBbz = parcelRequire("daBbz");

var $admh3 = parcelRequire("admh3");
function $94bee52f6056242d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $94bee52f6056242d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $94bee52f6056242d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $94bee52f6056242d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $94bee52f6056242d$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $94bee52f6056242d$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $94bee52f6056242d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($94bee52f6056242d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $94bee52f6056242d$var$noop = (0, $eVb4V.default);
function $94bee52f6056242d$var$notNullish(item) {
    return item != null;
}
function $94bee52f6056242d$var$scrollIntoView(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) (0, $1I7vO.scrollTo)(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) (0, $1I7vO.scrollTo)(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $94bee52f6056242d$var$isMobileDevice() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (_unused) {
        return false;
    }
}
function $94bee52f6056242d$var$isTouchCapable() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (_unused2) {
        return false;
    }
}
/**
 * Filters out unsupported selectors (e.g., pseudo-classes, complex selectors) from a styles object.
 * @param styles - The styles object to filter.
 * @returns A new object containing only supported styles.
 */ var $94bee52f6056242d$var$filterUnsupportedSelectors = function filterUnsupportedSelectors(styles) {
    var unsupportedSelectors = [
        ':',
        // pseudo-classes/elements
        '[',
        // attribute selectors
        '>',
        // child combinator
        '+',
        // adjacent sibling combinator
        '~',
        // general sibling combinator
        ' ',
        // descendant combinator
        '*',
        // universal selector
        '#',
        // ID selector
        '.',
        // class selector
        '@',
        // at-rules
        '&',
        // parent selector
        '|',
        // namespace separator
        '^',
        // starts with
        '$',
        // ends with
        '=' // equals
    ];
    return Object.keys(styles).reduce(function(filteredStyles, key) {
        if (!unsupportedSelectors.some(function(selector) {
            return key.includes(selector);
        })) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};
var $94bee52f6056242d$var$elemBeforeCSS = null;
// Matches the duration of `motion.label.exit`; used only if a consumer render path
// unmounts the exiting values before their motion completion callback can run.
var $94bee52f6056242d$var$MULTI_VALUE_EXIT_FALLBACK_DURATION_MS = 100;
var $94bee52f6056242d$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: $94bee52f6056242d$var$isTouchCapable(),
    captureMenuScroll: !$94bee52f6056242d$var$isTouchCapable(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $3yr7f.createFilter)(),
    formatGroupLabel: (0, $1l3Nw.formatGroupLabel),
    getOptionLabel: (0, $eF1OB.getOptionLabel),
    getOptionValue: (0, $fuxeO.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $admh3.isOptionDisabled),
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !$94bee52f6056242d$var$isMobileDevice(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false
};
function $94bee52f6056242d$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $94bee52f6056242d$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $94bee52f6056242d$var$_isOptionSelected(props, option, selectValue);
    var label = $94bee52f6056242d$var$getOptionLabel(props, option);
    var value = $94bee52f6056242d$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $94bee52f6056242d$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        //@ts-ignore
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $94bee52f6056242d$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $94bee52f6056242d$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $94bee52f6056242d$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $94bee52f6056242d$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter($94bee52f6056242d$var$notNullish);
}
function $94bee52f6056242d$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $94bee52f6056242d$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $94bee52f6056242d$var$buildFocusableOptions(props, selectValue) {
    return $94bee52f6056242d$var$buildFocusableOptionsFromCategorizedOptions($94bee52f6056242d$var$buildCategorizedOptions(props, selectValue));
}
function $94bee52f6056242d$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$94bee52f6056242d$var$shouldHideSelectedOptions(props) || !isSelected) && $94bee52f6056242d$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $94bee52f6056242d$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $94bee52f6056242d$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $94bee52f6056242d$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $94bee52f6056242d$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $94bee52f6056242d$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $94bee52f6056242d$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $94bee52f6056242d$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $94bee52f6056242d$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $94bee52f6056242d$var$getOptionValue(props, i) === candidate;
    });
}
function $94bee52f6056242d$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $94bee52f6056242d$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $94bee52f6056242d$var$instanceId = 1;
// eslint-disable-next-line @repo/internal/react/no-class-components, @atlaskit/volt-strict-mode/no-multiple-exports
var $94bee52f6056242d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Select);
        _this = $94bee52f6056242d$var$_callSuper(this, Select, [
            _props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "state", {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: '',
            controlElement: null,
            isMultiValueExiting: false,
            hasCompletedMultiValueExit: false
        });
        // Misc. Instance Properties
        // ------------------------------
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "blockOptionHover", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "isComposing", false);
        // TODO
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "initialTouchX", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "initialTouchY", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "openAfterFocus", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "openAfterClick", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "scrollToFocusedOptionOnUpdate", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "multiValueExitFallbackTimeout", null);
        // Refs
        // ------------------------------
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "controlRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getControlRef", function(ref) {
            _this.controlRef = ref;
            // Mirror the ref into state on the top-layer path so
            // `MenuPortalTopLayer`'s layout effects react to the anchor attaching.
            // Skip the null-ref (unmount) case: setState during unmount is unsafe
            // and the state is dropped with the instance anyway.
            if (ref === null) return;
            if (_this.state.controlElement !== ref && (0, $2goCw.fg)('platform-dst-top-layer')) _this.setState({
                controlElement: ref
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "focusedOptionRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getFocusedOptionRef", function(ref) {
            _this.focusedOptionRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "menuListRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getMenuListRef", function(ref) {
            _this.menuListRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "inputRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getInputRef", function(ref) {
            _this.inputRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onMultiValueMotionFinish", function() {
            if (_this.state.isMultiValueExiting) _this.setState({
                isMultiValueExiting: false,
                hasCompletedMultiValueExit: true,
                selectValue: []
            });
        });
        // aliased for consumers
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "focus", _this.focusInput);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "blur", _this.blurInput);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onControlClick", function() {
            var focusOption = _this.openAfterClick;
            _this.openAfterClick = null;
            if (focusOption && !_this.props.menuIsOpen) _this.openMenu(focusOption);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onChange", function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "setValue", function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "selectOption", function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $ecwrt.multiValueAsValue)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $ecwrt.multiValueAsValue)([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $f49h5.singleValueAsValue)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $f49h5.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "removeValue", function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $daBbz.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clearValue", function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $daBbz.valueTernary)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "popValue", function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $daBbz.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        });
        // ==============================
        // Getters
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getFocusedOptionId", function(focusedOption) {
            return $94bee52f6056242d$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getFocusableOptionsWithIds", function() {
            return $94bee52f6056242d$var$buildFocusableOptionsWithIds($94bee52f6056242d$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getValue", function() {
            return _this.state.selectValue;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "cx", function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $4JhfO.classNames).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getOptionLabel", function(data) {
            return $94bee52f6056242d$var$getOptionLabel(_this.props, data);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getOptionValue", function(data) {
            return $94bee52f6056242d$var$getOptionValue(_this.props, data);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getStyles", function(key, props) {
            var base = {
                boxSizing: 'border-box'
            };
            var custom = _this.props.styles[key];
            if (custom) return $94bee52f6056242d$var$filterUnsupportedSelectors(custom(base, props));
            return base;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getClassNames", function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getElementId", function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getComponents", function() {
            return (0, $j7QB2.defaultComponents)(_this.props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "buildCategorizedOptions", function() {
            return $94bee52f6056242d$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getCategorizedOptions", function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "buildFocusableOptions", function() {
            return $94bee52f6056242d$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getFocusableOptions", function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        });
        // ==============================
        // Helpers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "ariaOnChange", function(value, actionMeta) {
            _this.setState({
                ariaSelection: $94bee52f6056242d$var$_objectSpread({
                    value: value
                }, actionMeta)
            });
        });
        // ==============================
        // Mouse Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onMenuMouseDown", function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onMenuMouseMove", function(_) {
            _this.blockOptionHover = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onControlMouseDown", function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                var _this$controlRef;
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!((_this$controlRef = _this.controlRef) !== null && _this$controlRef !== void 0 && _this$controlRef.closest('[data-rbd-draggable-context-id]'))) return;
            }
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenuAfterClick('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onDropdownIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenuAfterClick('first');
            event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onClearIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onScroll", function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $iDDR5.isDocumentElement)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onCompositionStart", function() {
            _this.isComposing = true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onCompositionEnd", function() {
            _this.isComposing = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onTouchStart", function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onTouchMove", function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onControlTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onClearIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onDropdownIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        });
        // ==============================
        // Focus Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "handleInputChange", function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onInputFocus", function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
                // `openAfterFocus` always follows a pointer gesture, so defer until
                // click. `openMenuOnFocus` alone can come from a keyboard tab
                // with no pointer gesture in flight, so open synchronously.
                if (_this.openAfterFocus) _this.openMenuAfterClick('first');
                else _this.openMenu('first');
            }
            _this.openAfterFocus = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onInputBlur", function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            if ((0, $2goCw.fg)('platform_dst_select_menu_close_on_blur')) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            _this.props.menuIsOpen && _this.onMenuClose();
            else _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onOptionHover", function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "shouldHideSelectedOptions", function() {
            return $94bee52f6056242d$var$shouldHideSelectedOptions(_this.props);
        });
        // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onValueInputFocus", function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        });
        // ==============================
        // Keyboard Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onKeyDown", function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus, shouldPreventEscapePropagation = _this$props5.shouldPreventEscapePropagation;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) _this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if ((0, $2goCw.fg)('platform-dst-top-layer')) {
                        if (menuIsOpen) {
                            _this.setState({
                                inputIsHiddenAfterUpdate: false
                            });
                            return;
                        }
                        if (isClearable && escapeClearsValue) {
                            _this.clearValue();
                            return;
                        }
                        // Native auto popovers own every Escape on the top-layer path.
                        // The active popover consumes the close request and synchronizes
                        // menuIsOpen through its onClose bridge.
                        return;
                    }
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                        if (shouldPreventEscapePropagation && event.target instanceof HTMLElement) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "handleOpenLayerObserverCloseSignal", function() {
            _this.onMenuClose();
        });
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$94bee52f6056242d$var$instanceId);
        _this.state.selectValue = (0, $jKHAs.cleanValue)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $94bee52f6056242d$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(Select, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) $94bee52f6056242d$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this2 = this;
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                // A consumer can cause the value subtree to unmount while the final tags are exiting.
                // The fallback keeps the placeholder out for the exit duration, then restores it even
                // when the individual MultiValue completion callback cannot fire.
                if (!prevState.isMultiValueExiting && this.state.isMultiValueExiting) this.multiValueExitFallbackTimeout = setTimeout(function() {
                    _this2.onMultiValueMotionFinish();
                }, $94bee52f6056242d$var$MULTI_VALUE_EXIT_FALLBACK_DURATION_MS);
                else if (prevState.isMultiValueExiting && !this.state.isMultiValueExiting) {
                    if (this.multiValueExitFallbackTimeout) {
                        clearTimeout(this.multiValueExitFallbackTimeout);
                        this.multiValueExitFallbackTimeout = null;
                    }
                }
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    $94bee52f6056242d$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.removeEventListener('scroll', this.onScroll, true);
                if (this.multiValueExitFallbackTimeout) {
                    clearTimeout(this.multiValueExitFallbackTimeout);
                    this.multiValueExitFallbackTimeout = null;
                }
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "shouldDeferOpenUntilClick",
            value: /**
     * Whether to defer the menu open until the in-flight click completes.
     * Any renderer that drives a `popover="auto"` element must, otherwise
     * the browser's light-dismiss can close the menu during the opening
     * gesture. Today only the top-layer path needs it.
     */ function shouldDeferOpenUntilClick() {
                return (0, $2goCw.fg)('platform-dst-top-layer');
            }
        },
        {
            key: "openMenuAfterClick",
            value: function openMenuAfterClick(focusOption) {
                if (!this.shouldDeferOpenUntilClick()) {
                    this.openMenu(focusOption);
                    return;
                }
                this.openAfterClick = focusOption;
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this3 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                var focusedOption = focusableOptions[openAtIndex];
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusedOption,
                    focusedOptionId: this.getFocusedOptionId(focusedOption)
                }, function() {
                    return _this3.onMenuOpen();
                });
                (0, $dsVPZ.isSafari)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
            }
        },
        {
            key: "updateInputLabel",
            value: function updateInputLabel(inputLabel) {
                var _this4 = this;
                if (inputLabel) {
                    var _this$inputRef;
                    (_this$inputRef = this.inputRef) === null || _this$inputRef === void 0 || _this$inputRef.setAttribute('aria-label', inputLabel);
                    setTimeout(function() {
                        var normalizedLabel = _this4.props['aria-label'] || _this4.props.label;
                        if (normalizedLabel) {
                            var _this4$inputRef;
                            (_this4$inputRef = _this4.inputRef) === null || _this4$inputRef === void 0 || _this4$inputRef.setAttribute('aria-label', normalizedLabel);
                        } else {
                            var _this4$inputRef2;
                            (_this4$inputRef2 = _this4.inputRef) === null || _this4$inputRef2 === void 0 || _this4$inputRef2.removeAttribute('aria-label');
                        }
                    }, 500);
                }
            }
        },
        {
            key: "calculateInputLabel",
            value: function calculateInputLabel(focusedOption, optionIndex) {
                var _this5 = this;
                var options = this.props.options;
                var isOptionsGrouped = options === null || options === void 0 ? void 0 : options.every(function(obj) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(obj) === 'object' && obj !== null && 'options' in obj;
                });
                var inputLabel = this.getOptionLabel(focusedOption);
                var isOptionFocused = function isOptionFocused(option) {
                    return _this5.getOptionLabel(option) === inputLabel;
                };
                var groupData = options === null || options === void 0 ? void 0 : options.find(function(option) {
                    var _groupCandidate$optio, _groupCandidate$optio2;
                    var groupCandidate = option;
                    return (_groupCandidate$optio = (_groupCandidate$optio2 = groupCandidate.options) === null || _groupCandidate$optio2 === void 0 ? void 0 : _groupCandidate$optio2.some(isOptionFocused)) !== null && _groupCandidate$optio !== void 0 ? _groupCandidate$optio : false;
                });
                if (isOptionsGrouped) {
                    var _groupData$options$fi;
                    var groupOptionIndex = (_groupData$options$fi = groupData === null || groupData === void 0 ? void 0 : groupData.options.findIndex(isOptionFocused)) !== null && _groupData$options$fi !== void 0 ? _groupData$options$fi : 0;
                    var totalLength = options === null || options === void 0 ? void 0 : options.reduce(function(acc, currentGroup) {
                        var _group$options;
                        var group = currentGroup;
                        acc += group === null || group === void 0 || (_group$options = group.options) === null || _group$options === void 0 ? void 0 : _group$options.length;
                        return acc;
                    }, 0);
                    inputLabel = "".concat(inputLabel, ", ").concat(groupData === null || groupData === void 0 ? void 0 : groupData.label, " (").concat(groupOptionIndex + 1, " of ").concat(totalLength, ")");
                } else inputLabel = "".concat(inputLabel, " (").concat(optionIndex + 1, " of ").concat(options === null || options === void 0 ? void 0 : options.length, ")");
                return inputLabel;
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus],
                    focusedValueId: "".concat(this.getElementId('selected-value'), "-").concat(nextFocus, "-remove"),
                    focusedOption: null,
                    focusedOptionId: null
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedValueId: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $94bee52f6056242d$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $94bee52f6056242d$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $94bee52f6056242d$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                var _this$props$component;
                if (typeof this.props.formatOptionLabel === 'function') {
                    var inputValue = this.props.inputValue;
                    var selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: inputValue,
                        selectValue: selectValue
                    });
                }
                // Auto-render elemBefore in dropdown menu only if formatOptionLabel is not provided
                // and no custom Option component is provided (custom Option components may already
                // render elemBefore themselves, causing it to appear twice)
                if (context === 'menu' && !this.props.formatOptionLabel && !((_this$props$component = this.props.components) !== null && _this$props$component !== void 0 && _this$props$component.Option) && (0, $2goCw.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
                    var elemBefore = data.elemBefore;
                    if (elemBefore) {
                        var label = this.getOptionLabel(data);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                            className: (0, $970q7.default)([
                                "_zulpu2gc _1e0c1txw _4cvr1h6o"
                            ])
                        }, elemBefore, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", null, label));
                    }
                }
                return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "calculateDescription",
            value: function calculateDescription() {
                var descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
                var isMulti = this.props.isMulti;
                var hasValue = this.state.selectValue.length > 0;
                // Determine base description based on selection state
                var baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
                // Fast path for single select with no description prop
                if (!isMulti && !descriptionProp) return {
                    'aria-describedby': baseDescriptionId
                };
                // Build the describedby string efficiently
                var describedBy = baseDescriptionId;
                // Add description prop if it exists
                if (descriptionProp) describedBy = describedBy ? "".concat(descriptionProp, " ").concat(describedBy) : descriptionProp;
                // For multi-select, always add multi-message ID
                if (isMulti) {
                    var multiMessage = this.getElementId('multi-message');
                    describedBy = describedBy ? "".concat(describedBy, " ").concat(multiMessage) : multiMessage;
                }
                return {
                    'aria-describedby': describedBy
                };
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchstart', this.onTouchStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchmove', this.onTouchMove);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, form = _this$props8.form, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, isDisabled = _this$props8.isDisabled, isInvalid = _this$props8.isInvalid, isRequired = _this$props8.isRequired, isSearchable = _this$props8.isSearchable, label = _this$props8.label, labelId = _this$props8.labelId, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required, _this$props8$tabIndex = _this$props8.tabIndex, tabIndex = _this$props8$tabIndex === void 0 ? 0 : _this$props8$tabIndex, testId = _this$props8.testId;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var inputIsHidden = this.state.inputIsHidden;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                var isDisabledA11yFixEnabled = (0, $2goCw.fg)('platform_dst_select_disabled_a11y_fix');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = $94bee52f6056242d$var$_objectSpread($94bee52f6056242d$var$_objectSpread($94bee52f6056242d$var$_objectSpread($94bee52f6056242d$var$_objectSpread($94bee52f6056242d$var$_objectSpread({}, !this.props.isSearchable && (0, $2goCw.fg)('platform_fix_autocomplete_aria_for_select') ? {} : {
                    'aria-autocomplete': 'both'
                }), {}, {
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-expanded': menuIsOpen,
                    // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
                    'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                    'aria-invalid': this.props['aria-invalid'] || isInvalid,
                    'aria-label': this.props['aria-label'] || label,
                    'aria-labelledby': this.props['aria-labelledby'] || labelId,
                    'aria-required': required || isRequired,
                    role: 'combobox',
                    'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && !(0, $2goCw.fg)('select_issearchable_aria-readonly_fix') && {
                    'aria-readonly': true
                }), isDisabledA11yFixEnabled && {
                    'aria-disabled': isDisabled || undefined
                }), this.calculateDescription());
                var effectiveTabIndex = isDisabledA11yFixEnabled && isDisabled ? -1 : tabIndex;
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jOlL3.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: $94bee52f6056242d$var$noop,
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: effectiveTabIndex,
                    inputMode: "none",
                    form: form,
                    value: "",
                    "data-testid": testId && "".concat(testId, "-select--input")
                }, ariaAttributes));
                // NOTE: Don't add the `name` prop to this Input, `name` is already a prop on the hidden input element that has the value of the select.
                // Adding `name` to this Input will cause unexpected behavior.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Input, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    testId: testId,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: effectiveTabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this6 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder, testId = _this$props9.testId;
                var _this$state4 = this.state, selectValue = _this$state4.selectValue, focusedValue = _this$state4.focusedValue, isFocused = _this$state4.isFocused;
                var renderMultiValues = function renderMultiValues() {
                    var isMotionEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                    return selectValue.map(function(opt, index) {
                        var isOptionFocused = opt === focusedValue;
                        var key = "".concat(_this6.getOptionLabel(opt), "-").concat(_this6.getOptionValue(opt));
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(MultiValue, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                            components: {
                                Container: MultiValueContainer,
                                Label: MultiValueLabel,
                                Remove: MultiValueRemove
                            },
                            isFocused: isOptionFocused,
                            isDisabled: isDisabled,
                            key: key,
                            index: index,
                            isMotionEnabled: isMotionEnabled,
                            onMotionFinish: _this6.onMultiValueMotionFinish,
                            removeProps: $94bee52f6056242d$var$_objectSpread($94bee52f6056242d$var$_objectSpread({
                                onClick: function onClick() {
                                    return _this6.removeValue(opt);
                                },
                                onTouchEnd: function onTouchEnd() {
                                    return _this6.removeValue(opt);
                                },
                                onMouseDown: function onMouseDown(e) {
                                    e.preventDefault();
                                }
                            }, testId && {
                                'data-testid': "".concat(testId, "-select--multivalue-").concat(index, "-remove")
                            }), {}, {
                                id: "".concat(_this6.getElementId('selected-value'), "-").concat(index, "-remove")
                            }),
                            data: opt,
                            innerProps: $94bee52f6056242d$var$_objectSpread($94bee52f6056242d$var$_objectSpread({}, testId && {
                                'data-testid': "".concat(testId, "-select--multivalue-").concat(index)
                            }), {}, {
                                id: "".concat(_this6.getElementId('selected-value'), "-").concat(index)
                            })
                        }), _this6.formatOptionLabel(opt, 'value'));
                    });
                };
                var placeholderElement = inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Placeholder, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: $94bee52f6056242d$var$_objectSpread({
                        id: this.getElementId('placeholder')
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--placeholder")
                    })
                }), placeholder);
                if (isMulti) {
                    var _this$props$component2, _this$props$component3;
                    var ffTagUplifts = (0, $2goCw.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
                    var ffTagMotion = (0, $2goCw.fg)('platform-dst-motion-uplift-labels');
                    var isTagMotionEnabled = ((_this$props$component2 = this.props.components) === null || _this$props$component2 === void 0 ? void 0 : _this$props$component2.MultiValue) === undefined && ((_this$props$component3 = this.props.components) === null || _this$props$component3 === void 0 ? void 0 : _this$props$component3.MultiValueContainer) === undefined && ffTagUplifts && ffTagMotion;
                    if (isTagMotionEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $Ew39N.default), null, controlShouldRenderValue ? renderMultiValues(true) : null), (!this.hasValue() || !controlShouldRenderValue) && !this.state.isMultiValueExiting && placeholderElement);
                    if (!this.hasValue() || !controlShouldRenderValue) return placeholderElement;
                    return renderMultiValues();
                }
                if (!this.hasValue() || !controlShouldRenderValue) return placeholderElement;
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(SingleValue, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled,
                    innerProps: $94bee52f6056242d$var$_objectSpread({
                        id: this.getElementId('single-value')
                    }, isDisabled && (0, $2goCw.fg)('platform_dst_select_disabled_a11y_fix') && {
                        'aria-hidden': true
                    })
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props0 = this.props, clearControlLabel = _this$props0.clearControlLabel, isDisabled = _this$props0.isDisabled, isLoading = _this$props0.isLoading, spacing = _this$props0.spacing, testId = _this$props0.testId;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = $94bee52f6056242d$var$_objectSpread({
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd
                }, testId && {
                    'data-testid': "".concat(testId, "-select--clear-indicator")
                });
                var isCompact = spacing === 'compact';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(ClearIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                    clearControlLabel: clearControlLabel
                }, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props1 = this.props, isDisabled = _this$props1.isDisabled, isLoading = _this$props1.isLoading, spacing = _this$props1.spacing, testId = _this$props1.testId;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var isCompact = spacing === 'compact';
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LoadingIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                    "data-testid": testId && "".concat(testId, "-select--loading-indicator")
                }, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, spacing = _this$props10.spacing, testId = _this$props10.testId;
                var isFocused = this.state.isFocused;
                var isCompact = spacing === 'compact';
                var innerProps = $94bee52f6056242d$var$_objectSpread({
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    // Always hidden: DropdownIndicator hoists aria-hidden onto consumer-supplied
                    // children only, keeping the voice-control button visible to AT.
                    'aria-hidden': 'true'
                }, testId && {
                    'data-testid': "".concat(testId, "-select--dropdown-indicator")
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(DropdownIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this7 = this;
                var _this$getComponents6 = this.getComponents(), Group = _this$getComponents6.Group, GroupHeading = _this$getComponents6.GroupHeading, Menu = _this$getComponents6.Menu, MenuList = _this$getComponents6.MenuList, MenuPortal = _this$getComponents6.MenuPortal, LoadingMessage = _this$getComponents6.LoadingMessage, NoOptionsMessage = _this$getComponents6.NoOptionsMessage, Option = _this$getComponents6.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props11 = this.props, captureMenuScroll = _this$props11.captureMenuScroll, inputValue = _this$props11.inputValue, isLoading = _this$props11.isLoading, loadingMessage = _this$props11.loadingMessage, minMenuHeight = _this$props11.minMenuHeight, maxMenuHeight = _this$props11.maxMenuHeight, menuIsOpen = _this$props11.menuIsOpen, menuPlacement = _this$props11.menuPlacement, menuPosition = _this$props11.menuPosition, menuPortalTarget = _this$props11.menuPortalTarget, menuShouldBlockScroll = _this$props11.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props11.menuShouldScrollIntoView, noOptionsMessage = _this$props11.noOptionsMessage, onMenuScrollToTop = _this$props11.onMenuScrollToTop, onMenuScrollToBottom = _this$props11.onMenuScrollToBottom, testId = _this$props11.testId;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id, headingId) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this7.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this7.selectOption(data);
                    };
                    var optionId = "".concat(_this7.getElementId('option'), "-").concat(id);
                    var innerProps = $94bee52f6056242d$var$_objectSpread({
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        role: _this7.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                        'aria-selected': _this7.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                        // We don't want aria-disabled if it's false. It's just noisy.
                        'aria-disabled': !isDisabled ? undefined : isDisabled,
                        'aria-describedby': headingId
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--option-").concat(id)
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Option, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this7.getFocusedOptionRef : undefined
                    }), _this7.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) {
                    var items = this.getCategorizedOptions();
                    menuUI = items.map(function(item) {
                        if (item.type === 'group') {
                            var data = item.data, options = item.options, groupIndex = item.index;
                            var groupId = "".concat(_this7.getElementId('group'), "-").concat(groupIndex);
                            var headingId = "".concat(groupId, "-heading");
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Group, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                                key: groupId,
                                data: data,
                                options: options,
                                Heading: GroupHeading,
                                headingProps: $94bee52f6056242d$var$_objectSpread({
                                    id: headingId,
                                    data: item.data
                                }, testId && {
                                    'data-testid': "".concat(testId, "-select--group-").concat(groupIndex, "-heading")
                                }),
                                label: _this7.formatGroupLabel(item.data)
                            }), item.options.map(function(option) {
                                return render(option, "".concat(groupIndex, "-").concat(option.index), headingId);
                            }));
                        } else if (item.type === 'option') return render(item, "".concat(item.index));
                        return undefined;
                    });
                } else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NoOptionsMessage, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                        innerProps: $94bee52f6056242d$var$_objectSpread($94bee52f6056242d$var$_objectSpread({}, this.props['UNSAFE_is_experimental_generic'] && {
                            role: 'listitem'
                        }), testId && {
                            'data-testid': "".concat(testId, "-select--no-options")
                        })
                    }), _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $liCzk.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Menu, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: $94bee52f6056242d$var$_objectSpread({
                            onMouseDown: _this7.onMenuMouseDown,
                            onMouseMove: _this7.onMenuMouseMove,
                            id: _this7.props.components.Menu ? _this7.getElementId('listbox') : undefined
                        }, testId && {
                            'data-testid': "".concat(testId, "-select--listbox-container")
                        }),
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9LMRF.default), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        var _this7$inputRef, _this7$inputRef2;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(MenuList, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this7.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: $94bee52f6056242d$var$_objectSpread($94bee52f6056242d$var$_objectSpread($94bee52f6056242d$var$_objectSpread({
                                role: _this7.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox'
                            }, _this7.props['UNSAFE_is_experimental_generic'] && {
                                'aria-labelledby': ((_this7$inputRef = _this7.inputRef) === null || _this7$inputRef === void 0 ? void 0 : _this7$inputRef.id) || _this7.getElementId('input')
                            }), {}, {
                                'aria-multiselectable': !commonProps.isMulti || _this7.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                id: _this7.getElementId('listbox')
                            }, testId && {
                                'data-testid': "".concat(testId, "-select--listbox")
                            }), (0, $dsVPZ.isSafari)() && !_this7.props['UNSAFE_is_experimental_generic'] && {
                                'aria-describedby': ((_this7$inputRef2 = _this7.inputRef) === null || _this7$inputRef2 === void 0 ? void 0 : _this7$inputRef2.id) || _this7.getElementId('input')
                            }),
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), _this7.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                            role: "list"
                        }, menuUI) : menuUI);
                    }));
                });
                // On the top-layer path the menu always portals (into the top layer)
                // regardless of consumer `menuPortalTarget` / `menuPosition`. Off the
                // flag we keep the legacy "portal only when needed" behaviour.
                var shouldPortal = (0, $2goCw.fg)('platform-dst-top-layer') || menuPortalTarget || menuPosition === 'fixed';
                if (!shouldPortal) return menuElement;
                // Top-layer path needs the state mirror so MenuPortalTopLayer re-renders
                // when the anchor attaches; legacy path keeps the direct ref read.
                var controlElementForPortal = (0, $2goCw.fg)('platform-dst-top-layer') ? this.state.controlElement : this.controlRef;
                var menuPortal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(MenuPortal, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: controlElementForPortal,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement);
                // The Provider plumbs the close signal to MenuPortalTopLayer; not
                // needed on the legacy path.
                if (!(0, $2goCw.fg)('platform-dst-top-layer')) return menuPortal;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $k28lc.MenuPortalCloseContext).Provider, {
                    value: this.handleOpenLayerObserverCloseSignal
                }, menuPortal);
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this8 = this;
                var _this$props12 = this.props, delimiter = _this$props12.delimiter, isDisabled = _this$props12.isDisabled, isMulti = _this$props12.isMulti, required = _this$props12.required, name = _this$props12.name;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $i2prK.default), {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this8.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this8.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state5 = this.state, ariaSelection = _this$state5.ariaSelection, isFocused = _this$state5.isFocused, selectValue = _this$state5.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6muHy.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "renderMultiselectMessage",
            value: function renderMultiselectMessage() {
                // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
                // Also, since this is rendered onscreen, it should be transtlated automatically.
                var msg = ", multiple selections available, ".concat(this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : '');
                return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
                (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
                    id: this.getElementId('multi-message'),
                    hidden: true
                }, msg));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents7 = this.getComponents(), Control = _this$getComponents7.Control, IndicatorsContainer = _this$getComponents7.IndicatorsContainer, SelectContainer = _this$getComponents7.SelectContainer, ValueContainer = _this$getComponents7.ValueContainer;
                var _this$props13 = this.props, className = _this$props13.className, id = _this$props13.id, isDisabled = _this$props13.isDisabled, menuIsOpen = _this$props13.menuIsOpen, isInvalid = _this$props13.isInvalid, testId = _this$props13.testId, _this$props13$appeara = _this$props13.appearance, appearance = _this$props13$appeara === void 0 ? 'default' : _this$props13$appeara, _this$props13$spacing = _this$props13.spacing, spacing = _this$props13$spacing === void 0 ? 'default' : _this$props13$spacing;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                var isCompact = spacing === 'compact';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7rzUZ.SelectGetStylesContext).Provider, {
                    value: this.getStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(SelectContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                    className: className,
                    innerProps: $94bee52f6056242d$var$_objectSpread({
                        id: id,
                        onKeyDown: this.onKeyDown
                    }, testId && {
                        'data-testid': testId && "".concat(testId, "-select--container")
                    }),
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), commonProps.isMulti && this.renderMultiselectMessage(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Control, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: $94bee52f6056242d$var$_objectSpread({
                        onMouseDown: this.onControlMouseDown,
                        onClick: this.onControlClick,
                        onTouchEnd: this.onControlTouchEnd
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--control")
                    }),
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(ValueContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    isDisabled: isDisabled,
                    isCompact: isCompact,
                    hasValue: commonProps.hasValue || this.state.isMultiValueExiting,
                    innerProps: $94bee52f6056242d$var$_objectSpread($94bee52f6056242d$var$_objectSpread({}, testId && {
                        'data-testid': "".concat(testId, "-select--value-container")
                    }), commonProps.isMulti && commonProps.hasValue && !(0, $dJ32z.isAppleDevice)() && {
                        // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                        // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                        // DST Accessibility.
                        role: 'application'
                    })
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(IndicatorsContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    isDisabled: isDisabled,
                    innerProps: $94bee52f6056242d$var$_objectSpread({}, testId && {
                        'data-testid': "".concat(testId, "-select--indicators-container")
                    })
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField(), !(0, $2goCw.fg)('platform-dst-top-layer') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $i7tRn.NotifyOpenLayerObserver), {
                    isOpen: this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $jKHAs.cleanValue)(value);
                var isTagMotionEnabled = false;
                if (isMulti) {
                    var _props$components, _props$components2;
                    var ffTagUplifts = (0, $2goCw.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
                    var ffTagMotion = (0, $2goCw.fg)('platform-dst-motion-uplift-labels');
                    isTagMotionEnabled = ((_props$components = props.components) === null || _props$components === void 0 ? void 0 : _props$components.MultiValue) === undefined && ((_props$components2 = props.components) === null || _props$components2 === void 0 ? void 0 : _props$components2.MultiValueContainer) === undefined && ffTagUplifts && ffTagMotion;
                }
                var hasCompletedMultiValueExit = selectValue.length > 0 ? false : state.hasCompletedMultiValueExit;
                var isMultiValueExiting = isTagMotionEnabled && selectValue.length === 0 && !hasCompletedMultiValueExit && (state.isMultiValueExiting || state.selectValue.length > 0 && value !== (prevProps === null || prevProps === void 0 ? void 0 : prevProps.value));
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $94bee52f6056242d$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $94bee52f6056242d$var$buildFocusableOptionsWithIds($94bee52f6056242d$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $94bee52f6056242d$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $94bee52f6056242d$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $94bee52f6056242d$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $daBbz.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return $94bee52f6056242d$var$_objectSpread($94bee52f6056242d$var$_objectSpread($94bee52f6056242d$var$_objectSpread({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus,
                    isMultiValueExiting: isMultiValueExiting,
                    hasCompletedMultiValueExit: hasCompletedMultiValueExit
                });
            }
        }
    ]);
}((0, $5FkrB.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($94bee52f6056242d$export$2e2bcd8739ae039, "defaultProps", $94bee52f6056242d$export$9c21a3269931e1e6);

});
parcelRegister("dJ32z", function(module, exports) {
$parcel$export(module.exports, "isAppleDevice", () => $9fe1d61f676e91d7$export$e1865c3bedcd822b);
function $9fe1d61f676e91d7$var$testPlatform(re) {
    var _userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_userAgentData = window.navigator['userAgentData']) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || window.navigator.platform) : false;
}
function $9fe1d61f676e91d7$var$isIPhone() {
    return $9fe1d61f676e91d7$var$testPlatform(/^iPhone/i);
}
function $9fe1d61f676e91d7$var$isIPad() {
    return $9fe1d61f676e91d7$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $9fe1d61f676e91d7$var$isMac() && navigator.maxTouchPoints > 1;
}
function $9fe1d61f676e91d7$var$isMac() {
    return $9fe1d61f676e91d7$var$testPlatform(/^Mac/i);
}
function $9fe1d61f676e91d7$var$isIOS() {
    return $9fe1d61f676e91d7$var$isIPhone() || $9fe1d61f676e91d7$var$isIPad();
}
function $9fe1d61f676e91d7$export$e1865c3bedcd822b() {
    return $9fe1d61f676e91d7$var$isMac() || $9fe1d61f676e91d7$var$isIOS();
}

});

parcelRegister("Ew39N", function(module, exports) {
$parcel$export(module.exports, "ExitingContext", () => $079c98fce8470dd9$export$b9c4904d7a6929e6);
$parcel$export(module.exports, "default", () => $079c98fce8470dd9$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $1cFy9 = parcelRequire("1cFy9");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $079c98fce8470dd9$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isInsideExitingPersistence: false,
    isExiting: false
};
var $079c98fce8470dd9$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $5FkrB.createContext)($079c98fce8470dd9$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $079c98fce8470dd9$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $079c98fce8470dd9$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($079c98fce8470dd9$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $079c98fce8470dd9$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $079c98fce8470dd9$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $079c98fce8470dd9$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $079c98fce8470dd9$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $079c98fce8470dd9$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $079c98fce8470dd9$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false,
            isInsideExitingPersistence: true
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false,
            isInsideExitingPersistence: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $079c98fce8470dd9$var$childrenToArray(previousChildren);
    var current = $079c98fce8470dd9$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var nextChildren = currentChildren !== children ? $079c98fce8470dd9$var$childrenToArray(children) : current;
    var missingKeys = $079c98fce8470dd9$var$getMissingKeys(nextChildren, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $079c98fce8470dd9$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $1cFy9.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $079c98fce8470dd9$var$wrapChildWithContextProvider(child, {
            appear: true,
            isInsideExitingPersistence: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $079c98fce8470dd9$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$079c98fce8470dd9$export$2e2bcd8739ae039 = $079c98fce8470dd9$var$ExitingPersistence;
$079c98fce8470dd9$var$ExitingPersistence.displayName = 'ExitingPersistence';

});
parcelRegister("1cFy9", function(module, exports) {
$parcel$export(module.exports, "fg", () => $0e07245f4af1b97e$export$b40ec24ac8275656);

var $16ky6 = parcelRequire("16ky6");
function $0e07245f4af1b97e$export$b40ec24ac8275656(name) {
    return (0, $16ky6.resolveBooleanFlag)(name);
}

});
parcelRegister("16ky6", function(module, exports) {
$parcel$export(module.exports, "resolveBooleanFlag", () => $0cd64a973c98e05e$export$6333b6aff9fc6275);

var $ISKn7 = parcelRequire("ISKn7");

var $6cKc6 = parcelRequire("6cKc6");

var $3FLgb = parcelRequire("3FLgb");

var $aG6Mi = parcelRequire("aG6Mi");

var $fbkc3 = parcelRequire("fbkc3");

var $aseYL = parcelRequire("aseYL");
var $0cd64a973c98e05e$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $3FLgb.ENV_ENABLE_PLATFORM_FF) || (0, $aG6Mi.ENV_STORYBOOK_ENABLE_PLATFORM_FF);
function $0cd64a973c98e05e$export$6333b6aff9fc6275(flagKey) {
    if ($0cd64a973c98e05e$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $6cKc6.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $aseYL.pkgName), flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = (0, $fbkc3.globalVar)[0, $aseYL.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = (0, $fbkc3.globalVar)[0, $aseYL.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $ISKn7.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = (0, $fbkc3.globalVar)[0, $aseYL.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("6cKc6", function(module, exports) {
$parcel$export(module.exports, "debug", () => $4847b24543918228$export$1c9f709888824e05);
var $4847b24543918228$var$_process, $4847b24543918228$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $4847b24543918228$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($4847b24543918228$var$_process = globalThis.process) === null || $4847b24543918228$var$_process === void 0 || ($4847b24543918228$var$_process = $4847b24543918228$var$_process.env) === null || $4847b24543918228$var$_process === void 0 ? void 0 : $4847b24543918228$var$_process.JEST_WORKER_ID) !== undefined;
var $4847b24543918228$var$DEBUG_MODE = !$4847b24543918228$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($4847b24543918228$var$_process2 = globalThis.process) === null || $4847b24543918228$var$_process2 === void 0 || ($4847b24543918228$var$_process2 = $4847b24543918228$var$_process2.env) === null || $4847b24543918228$var$_process2 === void 0 ? void 0 : $4847b24543918228$var$_process2.NODE_ENV) !== 'production';
var $4847b24543918228$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$4847b24543918228$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});

parcelRegister("3FLgb", function(module, exports) {
$parcel$export(module.exports, "ENV_ENABLE_PLATFORM_FF", () => $2ac9dc460cd879a5$export$b574c24e1e6490f5);

var $aseYL = parcelRequire("aseYL");
var $2ac9dc460cd879a5$export$b574c24e1e6490f5 = (0, $aseYL.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});
parcelRegister("aseYL", function(module, exports) {
$parcel$export(module.exports, "PFF_GLOBAL_KEY", () => $79c8236e2ec10e73$export$7e41b1b2bdee3f98);
$parcel$export(module.exports, "pkgName", () => $79c8236e2ec10e73$export$407f05df8e3ce9f3);
$parcel$export(module.exports, "hasProcessEnv", () => $79c8236e2ec10e73$export$75f4a1454eff2805);

var $3ZMUU = parcelRequire("3ZMUU");
var $79c8236e2ec10e73$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $79c8236e2ec10e73$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
var $79c8236e2ec10e73$export$75f4a1454eff2805 = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';

});


parcelRegister("aG6Mi", function(module, exports) {
$parcel$export(module.exports, "ENV_STORYBOOK_ENABLE_PLATFORM_FF", () => $7c631592673fb9ae$export$92f8b531feaeb23d);

var $aseYL = parcelRequire("aseYL");
var $7c631592673fb9ae$export$92f8b531feaeb23d = (0, $aseYL.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});

parcelRegister("fbkc3", function(module, exports) {
$parcel$export(module.exports, "globalVar", () => $b0d78c1077f6482e$export$54ea85357b4e0159);

var $aseYL = parcelRequire("aseYL");
var $b0d78c1077f6482e$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $b0d78c1077f6482e$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$b0d78c1077f6482e$export$54ea85357b4e0159[0, $aseYL.PFF_GLOBAL_KEY] = $b0d78c1077f6482e$export$54ea85357b4e0159[0, $aseYL.PFF_GLOBAL_KEY] || $b0d78c1077f6482e$var$DEFAULT_PFF_GLOBAL;

});




parcelRegister("2goCw", function(module, exports) {
$parcel$export(module.exports, "fg", () => $1a602c7a42a6b6e9$export$b40ec24ac8275656);

var $fVqFc = parcelRequire("fVqFc");
function $1a602c7a42a6b6e9$export$b40ec24ac8275656(name) {
    return (0, $fVqFc.resolveBooleanFlag)(name);
}

});
parcelRegister("fVqFc", function(module, exports) {
$parcel$export(module.exports, "resolveBooleanFlag", () => $b980dcb185148fa4$export$6333b6aff9fc6275);

var $ISKn7 = parcelRequire("ISKn7");

var $4VHGb = parcelRequire("4VHGb");

var $kwQzj = parcelRequire("kwQzj");

var $jjR7B = parcelRequire("jjR7B");

var $jSpoJ = parcelRequire("jSpoJ");

var $csYNd = parcelRequire("csYNd");
var $b980dcb185148fa4$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $kwQzj.ENV_ENABLE_PLATFORM_FF) || (0, $jjR7B.ENV_STORYBOOK_ENABLE_PLATFORM_FF);
function $b980dcb185148fa4$export$6333b6aff9fc6275(flagKey) {
    if ($b980dcb185148fa4$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $4VHGb.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $csYNd.pkgName), flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = (0, $jSpoJ.globalVar)[0, $csYNd.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = (0, $jSpoJ.globalVar)[0, $csYNd.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $ISKn7.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = (0, $jSpoJ.globalVar)[0, $csYNd.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("4VHGb", function(module, exports) {
$parcel$export(module.exports, "debug", () => $396e5e161f821912$export$1c9f709888824e05);
var $396e5e161f821912$var$_process, $396e5e161f821912$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $396e5e161f821912$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($396e5e161f821912$var$_process = globalThis.process) === null || $396e5e161f821912$var$_process === void 0 || ($396e5e161f821912$var$_process = $396e5e161f821912$var$_process.env) === null || $396e5e161f821912$var$_process === void 0 ? void 0 : $396e5e161f821912$var$_process.JEST_WORKER_ID) !== undefined;
var $396e5e161f821912$var$DEBUG_MODE = !$396e5e161f821912$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($396e5e161f821912$var$_process2 = globalThis.process) === null || $396e5e161f821912$var$_process2 === void 0 || ($396e5e161f821912$var$_process2 = $396e5e161f821912$var$_process2.env) === null || $396e5e161f821912$var$_process2 === void 0 ? void 0 : $396e5e161f821912$var$_process2.NODE_ENV) !== 'production';
var $396e5e161f821912$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$396e5e161f821912$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});

parcelRegister("kwQzj", function(module, exports) {
$parcel$export(module.exports, "ENV_ENABLE_PLATFORM_FF", () => $ef1f92d98bd37648$export$b574c24e1e6490f5);

var $csYNd = parcelRequire("csYNd");
var $ef1f92d98bd37648$export$b574c24e1e6490f5 = (0, $csYNd.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});
parcelRegister("csYNd", function(module, exports) {
$parcel$export(module.exports, "PFF_GLOBAL_KEY", () => $913741bfcee28775$export$7e41b1b2bdee3f98);
$parcel$export(module.exports, "pkgName", () => $913741bfcee28775$export$407f05df8e3ce9f3);
$parcel$export(module.exports, "hasProcessEnv", () => $913741bfcee28775$export$75f4a1454eff2805);

var $3ZMUU = parcelRequire("3ZMUU");
var $913741bfcee28775$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $913741bfcee28775$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
var $913741bfcee28775$export$75f4a1454eff2805 = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';

});


parcelRegister("jjR7B", function(module, exports) {
$parcel$export(module.exports, "ENV_STORYBOOK_ENABLE_PLATFORM_FF", () => $e108ff869a9f8930$export$92f8b531feaeb23d);

var $csYNd = parcelRequire("csYNd");
var $e108ff869a9f8930$export$92f8b531feaeb23d = (0, $csYNd.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});

parcelRegister("jSpoJ", function(module, exports) {
$parcel$export(module.exports, "globalVar", () => $e786c2f0c69ccc92$export$54ea85357b4e0159);

var $csYNd = parcelRequire("csYNd");
var $e786c2f0c69ccc92$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $e786c2f0c69ccc92$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$e786c2f0c69ccc92$export$54ea85357b4e0159[0, $csYNd.PFF_GLOBAL_KEY] = $e786c2f0c69ccc92$export$54ea85357b4e0159[0, $csYNd.PFF_GLOBAL_KEY] || $e786c2f0c69ccc92$var$DEFAULT_PFF_GLOBAL;

});



parcelRegister("j7QB2", function(module, exports) {
$parcel$export(module.exports, "components", () => $dec77852640eeff8$export$9b5ac10f59f76296);
$parcel$export(module.exports, "defaultComponents", () => $dec77852640eeff8$export$71abc632aa29e6fe);

var $25nEq = parcelRequire("25nEq");

var $3ZdAs = parcelRequire("3ZdAs");

var $9iDGZ = parcelRequire("9iDGZ");

var $eql03 = parcelRequire("eql03");

var $3TsIb = parcelRequire("3TsIb");

var $Fow6Q = parcelRequire("Fow6Q");

var $gTi0T = parcelRequire("gTi0T");

var $5U6NA = parcelRequire("5U6NA");

var $epIvX = parcelRequire("epIvX");

var $dDVYA = parcelRequire("dDVYA");

var $dvDRG = parcelRequire("dvDRG");

var $8naz6 = parcelRequire("8naz6");

var $8xuiz = parcelRequire("8xuiz");

var $funhD = parcelRequire("funhD");

var $ize4e = parcelRequire("ize4e");

var $63eGE = parcelRequire("63eGE");

var $Fy2WY = parcelRequire("Fy2WY");

var $h90T7 = parcelRequire("h90T7");

var $1VviI = parcelRequire("1VviI");

var $dqeFX = parcelRequire("dqeFX");

var $luzWk = parcelRequire("luzWk");

var $4l44U = parcelRequire("4l44U");

var $jW1m1 = parcelRequire("jW1m1");
function $dec77852640eeff8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dec77852640eeff8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dec77852640eeff8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dec77852640eeff8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dec77852640eeff8$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $epIvX.ClearIndicator),
    Control: (0, $Fow6Q.default),
    DropdownIndicator: (0, $dDVYA.DropdownIndicator),
    Group: (0, $gTi0T.default),
    GroupHeading: (0, $5U6NA.GroupHeading),
    IndicatorsContainer: (0, $3ZdAs.IndicatorsContainer),
    Input: (0, $8naz6.default),
    LoadingIndicator: (0, $dvDRG.LoadingIndicator),
    Menu: (0, $8xuiz.default),
    MenuList: (0, $funhD.MenuList),
    MenuPortal: (0, $Fy2WY.MenuPortal),
    LoadingMessage: (0, $ize4e.LoadingMessage),
    NoOptionsMessage: (0, $63eGE.NoOptionsMessage),
    MultiValue: (0, $h90T7.default),
    MultiValueContainer: (0, $9iDGZ.MultiValueContainer),
    MultiValueLabel: (0, $1VviI.MultiValueLabel),
    MultiValueRemove: (0, $dqeFX.MultiValueRemove),
    Option: (0, $luzWk.default),
    Placeholder: (0, $4l44U.default),
    SelectContainer: (0, $eql03.SelectContainer),
    SingleValue: (0, $jW1m1.default),
    ValueContainer: (0, $3TsIb.ValueContainer)
};
var $dec77852640eeff8$export$71abc632aa29e6fe = function defaultComponents(props) {
    return $dec77852640eeff8$var$_objectSpread($dec77852640eeff8$var$_objectSpread({}, $dec77852640eeff8$export$9b5ac10f59f76296), props.components);
};

});
parcelRegister("3ZdAs", function(module, exports) {
$parcel$export(module.exports, "IndicatorsContainer", () => $2e719bb2c0cb4d88$export$d0ffd7e649cab6f);
/* indicators-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $5rHW6 = parcelRequire("5rHW6");
var $2e719bb2c0cb4d88$var$indicatorContainerStyles = null;
var $2e719bb2c0cb4d88$export$d0ffd7e649cab6f = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $5rHW6.getStyleProps)(props, 'indicatorsContainer', {
        indicators: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $hUFig.cx)(className, xcss, '-IndicatorsContainer')
        ])
    }, innerProps), children);
};

});
parcelRegister("5rHW6", function(module, exports) {
$parcel$export(module.exports, "getStyleProps", () => $3f718e277219ccdb$export$26417cabd806a658);
var $3f718e277219ccdb$export$26417cabd806a658 = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};

});


parcelRegister("9iDGZ", function(module, exports) {
$parcel$export(module.exports, "MultiValueContainer", () => $6c5495907b5fbc88$export$cf9cf2a30a59265c);
/* multi-value-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");
var $6c5495907b5fbc88$var$multiValueStyles = {
    root: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _1e0c1txw _1ul9ze3t _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _bfhk1j9a _p12f1osq _syazi7uo _3yq3glyw",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk15s3 _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
var $6c5495907b5fbc88$export$cf9cf2a30a59265c = function MultiValueContainer(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isFocused = _ref.isFocused, isDisabled = _ref.isDisabled, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $6c5495907b5fbc88$var$multiValueStyles.root,
            isDisabled && $6c5495907b5fbc88$var$multiValueStyles.disabled,
            isFocused && $6c5495907b5fbc88$var$multiValueStyles.focused,
            (0, $hUFig.cx)(className, xcss, '-multiValue')
        ])
    }), children);
};

});

parcelRegister("eql03", function(module, exports) {
$parcel$export(module.exports, "SelectContainer", () => $a803c889a7ae2629$export$446eebadefe1123b);
/* select-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $5rHW6 = parcelRequire("5rHW6");
var $a803c889a7ae2629$var$containerStyles = {
    default: "_11c81d4k _kqswh2mm _lcxv1rj4 _1tn2fhey",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf"
};
var $a803c889a7ae2629$export$446eebadefe1123b = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl, xcss = props.xcss;
    var _getStyleProps = (0, $5rHW6.getStyleProps)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), className = _getStyleProps.className, css = _getStyleProps.css;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $a803c889a7ae2629$var$containerStyles.default,
            isRtl && $a803c889a7ae2629$var$containerStyles.rtl,
            isDisabled && $a803c889a7ae2629$var$containerStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-container')
        ]),
        style: css
    }, innerProps), children);
};

});

parcelRegister("3TsIb", function(module, exports) {
$parcel$export(module.exports, "ValueContainer", () => $2d5cc7b0db56d4fd$export$4dc9f58ad9a1a000);
/* value-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $2goCw = parcelRequire("2goCw");

var $5rHW6 = parcelRequire("5rHW6");
var $2d5cc7b0db56d4fd$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _y4ti12x7 _bozg12x7",
    verticalPaddingStandard: "_1q51v77o _85i5v77o",
    verticalPaddingTagUpliftMulti: "_1q511b66 _85i51b66",
    verticalPaddingTagUpliftCompactMulti: "_1q51v77o _85i5v77o",
    verticalPaddingCompactNonUplift: "_1q51ze3t _85i5ze3t",
    flex: "_1e0c1txw",
    flexWithGap: "_zulp1b66 _1e0c1txw _1n261g80"
};
var $2d5cc7b0db56d4fd$export$4dc9f58ad9a1a000 = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue, isCompact = props.isCompact, xcss = props.xcss, controlShouldRenderValue = props.selectProps.controlShouldRenderValue;
    var _getStyleProps = (0, $5rHW6.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    var ffTagUplifts = (0, $2goCw.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    var tagUpliftMultiVertical = ffTagUplifts && isMulti;
    var tagUpliftChipRow = ffTagUplifts && isMulti && hasValue && controlShouldRenderValue;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $2d5cc7b0db56d4fd$var$valueContainerStyles.default,
            tagUpliftMultiVertical && isCompact && $2d5cc7b0db56d4fd$var$valueContainerStyles.verticalPaddingTagUpliftCompactMulti,
            tagUpliftMultiVertical && !isCompact && $2d5cc7b0db56d4fd$var$valueContainerStyles.verticalPaddingTagUpliftMulti,
            !tagUpliftMultiVertical && !isCompact && $2d5cc7b0db56d4fd$var$valueContainerStyles.verticalPaddingStandard,
            !tagUpliftMultiVertical && isCompact && $2d5cc7b0db56d4fd$var$valueContainerStyles.verticalPaddingCompactNonUplift,
            isMulti && hasValue && controlShouldRenderValue && $2d5cc7b0db56d4fd$var$valueContainerStyles.flex,
            tagUpliftChipRow && $2d5cc7b0db56d4fd$var$valueContainerStyles.flexWithGap,
            (0, $hUFig.cx)(className, xcss, '-ValueContainer')
        ]),
        style: css
    }, innerProps), children);
};

});

parcelRegister("Fow6Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $07c6d8fe84a948e6$export$2e2bcd8739ae039);
/* control.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $2goCw = parcelRequire("2goCw");

var $5rHW6 = parcelRequire("5rHW6");
var $07c6d8fe84a948e6$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkofajl _v564r5cv _1h6drsbi _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _15peftgi _1ke8ftgi _jaboglyw _1u6luvb6 _4cvxrsbi _123byq51 _d0altlke _irr3l4ek _1ogl1caj",
    defaultT26Shape: "_2rko1qi0",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsvyy1",
    disabled: "_1h6d187o _lcxvglyw _bfhk187o _1u6lfrlt",
    focused: "_1h6d1v1w _bfhkr01l _16qsvyy1 _1u6lvyy1 _4cvx1v1w _irr3r01l",
    subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
var $07c6d8fe84a948e6$var$Control = function Control(props) {
    var children = props.children, appearance = props.appearance, isCompact = props.isCompact, isDisabled = props.isDisabled, isFocused = props.isFocused, isInvalid = props.isInvalid, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen, xcss = props.xcss;
    var _getStyleProps = (0, $5rHW6.getStyleProps)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: innerRef,
        className: (0, $970q7.default)([
            $07c6d8fe84a948e6$var$styles.default,
            (0, $2goCw.fg)('platform-dst-shape-theme-default') && $07c6d8fe84a948e6$var$styles.defaultT26Shape,
            isDisabled && $07c6d8fe84a948e6$var$styles.disabled,
            isInvalid && $07c6d8fe84a948e6$var$styles.invalid,
            isCompact && $07c6d8fe84a948e6$var$styles.compact,
            appearance === 'subtle' && $07c6d8fe84a948e6$var$styles.subtle,
            appearance === 'subtle' && isFocused && $07c6d8fe84a948e6$var$styles.subtleFocused,
            isFocused && $07c6d8fe84a948e6$var$styles.focused,
            appearance === 'none' && $07c6d8fe84a948e6$var$styles.none,
            (0, $hUFig.cx)(className, xcss, '-control')
        ]),
        style: css
    }, innerProps, {
        "aria-disabled": (0, $2goCw.fg)('platform_dst_select_disabled_a11y_fix') ? undefined : isDisabled || undefined
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$07c6d8fe84a948e6$export$2e2bcd8739ae039 = $07c6d8fe84a948e6$var$Control;

});

parcelRegister("gTi0T", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4bfc176ba8a75ef$export$2e2bcd8739ae039);
/* group.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $5rHW6 = parcelRequire("5rHW6");
var $c4bfc176ba8a75ef$var$styles = {
    root: "_85i5u2gc _1q51u2gc"
};
var $c4bfc176ba8a75ef$var$Group = function Group(props) {
    var children = props.children, builtinCX = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, selectProps = props.selectProps, xcss = props.xcss;
    var _getStyleProps = (0, $5rHW6.getStyleProps)(props, 'group', {
        group: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $c4bfc176ba8a75ef$var$styles.root,
            (0, $hUFig.cx)(className, xcss, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className, '-Group')
        ])
    }), label && /*#__PURE__*/ $5FkrB.createElement(Heading, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, headingProps, {
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: builtinCX
    }), label), /*#__PURE__*/ $5FkrB.createElement("div", null, children));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c4bfc176ba8a75ef$export$2e2bcd8739ae039 = $c4bfc176ba8a75ef$var$Group;

});

parcelRegister("5U6NA", function(module, exports) {
$parcel$export(module.exports, "GroupHeading", () => $44c774caab3e2195$export$85c8b41a3cd87edc);
/* group-heading.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $5rHW6 = parcelRequire("5rHW6");

var $19xWY = parcelRequire("19xWY");
var $44c774caab3e2195$var$_excluded = [
    "data"
];
var $44c774caab3e2195$var$headingStyles = null;
var $44c774caab3e2195$export$85c8b41a3cd87edc = function GroupHeading(props) {
    var xcss = props.xcss;
    var _cleanCommonProps = (0, $19xWY.cleanCommonProps)(props), data = _cleanCommonProps.data, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_cleanCommonProps, $44c774caab3e2195$var$_excluded);
    var _getStyleProps = (0, $5rHW6.getStyleProps)(props, 'groupHeading', {
        'group-heading': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_11c8wadc _1e0c1ule _syazazsu _80om73ad _k48pwu06 _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $hUFig.cx)(className, xcss, '-group')
        ]),
        style: css
    }, innerProps));
};

});
parcelRegister("19xWY", function(module, exports) {
$parcel$export(module.exports, "cleanCommonProps", () => $0d70f77d03d47ad2$export$8e9fd4287627890c);

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");
var $0d70f77d03d47ad2$var$_excluded = [
    "className",
    "clearValue",
    "cx",
    "xcss",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue"
];
function $0d70f77d03d47ad2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0d70f77d03d47ad2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0d70f77d03d47ad2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0d70f77d03d47ad2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0d70f77d03d47ad2$export$8e9fd4287627890c = function cleanCommonProps(props) {
    //className
    var className = props.className, clearValue = props.clearValue, cx = props.cx, xcss = props.xcss, getStyles = props.getStyles, getClassNames = props.getClassNames, getValue = props.getValue, hasValue = props.hasValue, isMulti = props.isMulti, isRtl = props.isRtl, options = props.options, selectOption = props.selectOption, selectProps = props.selectProps, setValue = props.setValue, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $0d70f77d03d47ad2$var$_excluded);
    return $0d70f77d03d47ad2$var$_objectSpread({}, innerProps);
};

});


parcelRegister("epIvX", function(module, exports) {
$parcel$export(module.exports, "ClearIndicator", () => $a7e5ee1eb1ac249e$export$ecf9cf59142dd54a);
/* clear-indicator.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $eNN4d = parcelRequire("eNN4d");

var $btdNC = parcelRequire("btdNC");

var $5rHW6 = parcelRequire("5rHW6");
var $a7e5ee1eb1ac249e$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _1q51v77o _y4tiv77o _85i5v77o _bozgv77o"
};
var $a7e5ee1eb1ac249e$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1rpy _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf"
};
var $a7e5ee1eb1ac249e$export$ecf9cf59142dd54a = function ClearIndicator(props) {
    var innerProps = props.innerProps, _props$clearControlLa = props.clearControlLabel, clearControlLabel = _props$clearControlLa === void 0 ? 'clear' : _props$clearControlLa, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $5rHW6.getStyleProps)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $a7e5ee1eb1ac249e$var$clearIndicatorStyles.default,
            isCompact && $a7e5ee1eb1ac249e$var$clearIndicatorStyles.compact,
            (0, $hUFig.cx)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $btdNC.Pressable), {
        xcss: $a7e5ee1eb1ac249e$var$iconContainerStyles.root,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eNN4d))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
};

});
parcelRegister("eNN4d", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::23550e9a9f6f237ba15b0b9afdf2850e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ac6bb3fe21b42fd6$var$_react = $ac6bb3fe21b42fd6$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $ac6bb3fe21b42fd6$var$_iconNew = $ac6bb3fe21b42fd6$var$_interopRequireDefault((parcelRequire("gDzom")));
function $ac6bb3fe21b42fd6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cross-circle
 * Usage guidance:
 * Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ac6bb3fe21b42fd6$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $ac6bb3fe21b42fd6$var$_react.default.createElement($ac6bb3fe21b42fd6$var$_iconNew.default, Object.assign({
        name: "CrossCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m0 6.94L5.03 3.97 3.97 5.03 6.94 8l-2.97 2.97 1.06 1.06L8 9.06l2.97 2.97 1.06-1.06L9.06 8l2.97-2.97-1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$ac6bb3fe21b42fd6$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $ac6bb3fe21b42fd6$var$_default = module.exports.default = $ac6bb3fe21b42fd6$var$CrossCircleIcon;

});


parcelRegister("dDVYA", function(module, exports) {
$parcel$export(module.exports, "DropdownIndicator", () => $9eebe3bdccf4f70f$export$ec98719d3db7f2e4);
/* dropdown-indicator.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $h19KG = parcelRequire("h19KG");

var $2goCw = parcelRequire("2goCw");

var $m5IEn = parcelRequire("m5IEn");
var $btdNC = parcelRequire("btdNC");

var $5rHW6 = parcelRequire("5rHW6");
var $9eebe3bdccf4f70f$var$_excluded = [
    "aria-hidden"
];
var $9eebe3bdccf4f70f$var$dropdownWrapperStyles = {
    root: "_1q5112x7 _y4ti12x7 _85i512x7 _bozg12x7"
};
// Reset styles for the voice-control <Pressable> so the chevron renders
// pixel-identical to the gate-off icon-in-a-div. Uses @atlaskit/css cssMap
// (aliased as strictCssMap) because Pressable's xcss prop requires that type.
var $9eebe3bdccf4f70f$var$voiceControlPressableStyles = {
    root: "_1rjcidpf _18zridpf _1mouidpf _195gidpf _bfhk1j28 _1e0c1txw _4cvr1h6o"
};
// Inline size reset applied as a last resort (see the `style` prop docs on
// @atlaskit/primitives). Consumers ship global element selectors such as
// `& button { min-width: 149px }` (e.g. Jira Plans' hierarchy filter — see
// https://hello.jira.atlassian.cloud/jira/browse/JPO-42328) whose (class +
// element) specificity outranks the atomic single-class styles above, stretching
// this button and pushing the chevron toward the middle of the control. Inline
// styles outrank any selector, so the button always hugs the chevron and stays
// right-aligned like the gate-off icon-in-a-div.
var $9eebe3bdccf4f70f$var$voiceControlPressableSizeReset = {
    minWidth: 0,
    width: 'auto'
};
var $9eebe3bdccf4f70f$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syazazsu _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf",
    disabled: "_syaz1gmx"
};
var $9eebe3bdccf4f70f$export$ec98719d3db7f2e4 = function DropdownIndicator(props) {
    var _props$innerProps = props.innerProps, innerProps = _props$innerProps === void 0 ? {} : _props$innerProps, children = props.children, isDisabled = props.isDisabled, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $5rHW6.getStyleProps)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    var ariaHidden = innerProps['aria-hidden'], restInnerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(innerProps, $9eebe3bdccf4f70f$var$_excluded);
    var isVoiceControlAccessible = (0, $2goCw.fg)('platform_dst_select_dropdown_voice_control');
    // Stable testid for the hoisted aria-hidden children wrapper (avoids parentElement in tests).
    var wrapperTestId = restInnerProps['data-testid'] ? "".concat(restInnerProps['data-testid'], "-children") : undefined;
    var voiceControlAccessibleIndicator = children ? /*#__PURE__*/ $5FkrB.createElement("div", {
        "aria-hidden": ariaHidden,
        "data-testid": wrapperTestId
    }, children) : /*#__PURE__*/ $5FkrB.createElement((0, $btdNC.Pressable), {
        tabIndex: -1,
        "aria-label": "toggle select menu",
        isDisabled: isDisabled,
        componentName: "DropdownIndicatorVoiceControl",
        xcss: $9eebe3bdccf4f70f$var$voiceControlPressableStyles.root,
        style: $9eebe3bdccf4f70f$var$voiceControlPressableSizeReset
    }, /*#__PURE__*/ $5FkrB.createElement((0, $m5IEn.Inline), {
        as: "span",
        xcss: $9eebe3bdccf4f70f$var$dropdownWrapperStyles.root
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($h19KG))), {
        color: "currentColor",
        label: "open",
        size: "small"
    })));
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $9eebe3bdccf4f70f$var$dropdownStyles.default,
            isDisabled && $9eebe3bdccf4f70f$var$dropdownStyles.disabled,
            isCompact && $9eebe3bdccf4f70f$var$dropdownStyles.compact,
            (0, $hUFig.cx)(className, xcss, '-indicatorContainer')
        ])
    }, restInnerProps, {
        "aria-hidden": isVoiceControlAccessible ? undefined : ariaHidden
    }), isVoiceControlAccessible ? voiceControlAccessibleIndicator : children !== null && children !== void 0 ? children : /*#__PURE__*/ $5FkrB.createElement((0, $m5IEn.Inline), {
        as: "span",
        xcss: $9eebe3bdccf4f70f$var$dropdownWrapperStyles.root
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($h19KG))), {
        color: "currentColor",
        label: "open",
        size: "small"
    })));
};

});

parcelRegister("dvDRG", function(module, exports) {
$parcel$export(module.exports, "LoadingIndicator", () => $9d5d17f7fb6aa84f$export$7c20be4c1d342248);
/* loading-indicator.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $9ztDu = parcelRequire("9ztDu");

var $5rHW6 = parcelRequire("5rHW6");
var $9d5d17f7fb6aa84f$var$_excluded = [
    "innerProps",
    "isRtl",
    "size",
    "isCompact",
    "xcss"
];
function $9d5d17f7fb6aa84f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9d5d17f7fb6aa84f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9d5d17f7fb6aa84f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9d5d17f7fb6aa84f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9d5d17f7fb6aa84f$var$loadingIndicatorStyles = {
    default: "_1q5112x7 _y4tiu2gc _85i512x7 _bozgu2gc",
    compact: "_1q51idpf _85i5idpf"
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $9d5d17f7fb6aa84f$export$7c20be4c1d342248 = function LoadingIndicator(_ref) {
    var innerProps = _ref.innerProps, isRtl = _ref.isRtl, _ref$size = _ref.size, size = _ref$size === void 0 ? 4 : _ref$size, isCompact = _ref.isCompact, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $9d5d17f7fb6aa84f$var$_excluded);
    var _getStyleProps = (0, $5rHW6.getStyleProps)($9d5d17f7fb6aa84f$var$_objectSpread($9d5d17f7fb6aa84f$var$_objectSpread({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $9d5d17f7fb6aa84f$var$loadingIndicatorStyles.default,
            isCompact && $9d5d17f7fb6aa84f$var$loadingIndicatorStyles.compact,
            (0, $hUFig.cx)(className, xcss, '-loadingIndicator')
        ])
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $9ztDu.default), {
        size: "small"
    }));
};

});

parcelRegister("8naz6", function(module, exports) {
$parcel$export(module.exports, "default", () => $6188aabd99583ec0$export$2e2bcd8739ae039);
/* input.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $2goCw = parcelRequire("2goCw");

var $5rHW6 = parcelRequire("5rHW6");

var $19xWY = parcelRequire("19xWY");
var $6188aabd99583ec0$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName",
    "testId"
];
var $6188aabd99583ec0$var$inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
var $6188aabd99583ec0$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
var $6188aabd99583ec0$var$nativeInputStylesOld = null;
var $6188aabd99583ec0$var$nativeInputStyles = null;
var $6188aabd99583ec0$var$hidden = null;
var $6188aabd99583ec0$var$Input = function Input(props) {
    var builtinCX = props.cx, value = props.value, xcss = props.xcss, isMulti = props.isMulti;
    var _cleanCommonProps = (0, $19xWY.cleanCommonProps)(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, testId = _cleanCommonProps.testId, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_cleanCommonProps, $6188aabd99583ec0$var$_excluded);
    var dataId = testId ? "".concat(testId, "-select--input") : null;
    var _getStyleProps = (0, $5rHW6.getStyleProps)(props, 'input', {
        'input-container': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    var ffTagUplifts = (0, $2goCw.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    if ((0, $2goCw.fg)('platform_fix_input_component_styling')) return /*#__PURE__*/ $5FkrB.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $6188aabd99583ec0$var$inputStyles.root,
            isMulti && ffTagUplifts && $6188aabd99583ec0$var$inputStyles.labellingFFStyles,
            isDisabled && $6188aabd99583ec0$var$inputStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $6188aabd99583ec0$var$inputStylesOld.root,
            isMulti && ffTagUplifts && $6188aabd99583ec0$var$inputStylesOld.labellingFFStyles,
            isDisabled && $6188aabd99583ec0$var$inputStylesOld.disabled,
            (0, $hUFig.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6188aabd99583ec0$export$2e2bcd8739ae039 = $6188aabd99583ec0$var$Input;

});

parcelRegister("8xuiz", function(module, exports) {
$parcel$export(module.exports, "default", () => $6378e8769993eab0$export$2e2bcd8739ae039);
/* menu.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $2goCw = parcelRequire("2goCw");

var $5rHW6 = parcelRequire("5rHW6");
var $6378e8769993eab0$var$menuStyles = {
    root: "_2rko12b0 _kqswstnw _1bsb1osq _1pbykb7n _6rthu2gc _1pfhu2gc _bfhk1bhr _16qs130s",
    rootT26Shape: "_2rko1mok",
    bottom: "_152t1osq",
    top: "_u7co1osq"
};
var $6378e8769993eab0$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottom' : _props$placement, xcss = props.xcss;
    var _getStyleProps = (0, $5rHW6.getStyleProps)(props, 'menu', {
        menu: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $6378e8769993eab0$var$menuStyles.root,
            $6378e8769993eab0$var$menuStyles[placement],
            (0, $2goCw.fg)('platform-dst-shape-theme-default') && $6378e8769993eab0$var$menuStyles.rootT26Shape,
            (0, $hUFig.cx)(xcss, className, '-menu')
        ]),
        style: css,
        ref: innerRef
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6378e8769993eab0$export$2e2bcd8739ae039 = $6378e8769993eab0$var$Menu;

});

parcelRegister("funhD", function(module, exports) {
$parcel$export(module.exports, "MenuList", () => $b46bb7fbd85f1739$export$d4c4e98c5044dc8);
/* menu-list.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $5rHW6 = parcelRequire("5rHW6");
function $b46bb7fbd85f1739$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b46bb7fbd85f1739$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b46bb7fbd85f1739$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b46bb7fbd85f1739$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b46bb7fbd85f1739$var$menuListStyles = null;
var $b46bb7fbd85f1739$export$d4c4e98c5044dc8 = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti, maxHeight = props.maxHeight, xcss = props.xcss;
    var _getStyleProps = (0, $5rHW6.getStyleProps)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $hUFig.cx)(className, xcss, '-MenuList')
        ]),
        style: $b46bb7fbd85f1739$var$_objectSpread($b46bb7fbd85f1739$var$_objectSpread({}, css), {}, {
            maxHeight: maxHeight
        }),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};

});

parcelRegister("ize4e", function(module, exports) {
$parcel$export(module.exports, "LoadingMessage", () => $d8466851397e02fd$export$e928a71d039d3102);
/* menu-loading-message.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $72GAO = parcelRequire("72GAO");

var $5rHW6 = parcelRequire("5rHW6");
var $d8466851397e02fd$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
];
function $d8466851397e02fd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d8466851397e02fd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d8466851397e02fd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d8466851397e02fd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d8466851397e02fd$var$noticeStyles = null;
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $d8466851397e02fd$export$e928a71d039d3102 = function LoadingMessage(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? 'Loading...' : _ref$children, innerProps = _ref.innerProps, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $d8466851397e02fd$var$_excluded);
    var _getStyleProps = (0, $5rHW6.getStyleProps)($d8466851397e02fd$var$_objectSpread($d8466851397e02fd$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $hUFig.cx)(className, xcss, '-LoadingMessage')
        ]),
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option"
    }), /*#__PURE__*/ $5FkrB.createElement((0, $72GAO.Text), {
        color: "color.text.subtle"
    }, children));
};

});

parcelRegister("63eGE", function(module, exports) {
$parcel$export(module.exports, "NoOptionsMessage", () => $467e6a62831498e0$export$d58b72b7d3c4072c);
/* menu-no-options-message.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $72GAO = parcelRequire("72GAO");

var $5rHW6 = parcelRequire("5rHW6");
var $467e6a62831498e0$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
];
function $467e6a62831498e0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $467e6a62831498e0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $467e6a62831498e0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $467e6a62831498e0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $467e6a62831498e0$var$noticeStyles = null;
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $467e6a62831498e0$export$d58b72b7d3c4072c = function NoOptionsMessage(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? 'No options' : _ref$children, innerProps = _ref.innerProps, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $467e6a62831498e0$var$_excluded);
    var _getStyleProps = (0, $5rHW6.getStyleProps)($467e6a62831498e0$var$_objectSpread($467e6a62831498e0$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $hUFig.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        style: css,
        role: "option"
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $72GAO.Text), {
        color: "color.text.subtle"
    }, children));
};

});

parcelRegister("Fy2WY", function(module, exports) {
$parcel$export(module.exports, "MenuPortal", () => $07ce3d6455375668$export$793392f970497feb);
/* menu-portal.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $6I9SI = parcelRequire("6I9SI");

var $aLeHs = parcelRequire("aLeHs");

var $2goCw = parcelRequire("2goCw");

var $5rHW6 = parcelRequire("5rHW6");

var $dI0Ja = parcelRequire("dI0Ja");

var $8znmW = parcelRequire("8znmW");
function $07ce3d6455375668$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $07ce3d6455375668$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $07ce3d6455375668$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $07ce3d6455375668$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $07ce3d6455375668$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
var $07ce3d6455375668$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $07ce3d6455375668$var$menuPortalStyles = {
    root: "_1pbykb7n _1e02a1vk _kqswcp1v _152t1nmo _1bsb1qxj"
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
function $07ce3d6455375668$var$MenuPortalLegacy(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, xcss = props.xcss;
    var menuPortalRef = (0, $5FkrB.useRef)(null);
    var cleanupRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)($07ce3d6455375668$var$coercePlacement(menuPlacement)), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), placement = _useState2[0], setPortalPlacement = _useState2[1];
    var portalPlacementContext = (0, $5FkrB.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState3 = (0, $5FkrB.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), computedPosition = _useState4[0], setComputedPosition = _useState4[1];
    var updateComputedPosition = (0, $5FkrB.useCallback)(function() {
        if (!controlElement) return;
        var rect = $07ce3d6455375668$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $5FkrB.useLayoutEffect)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $5FkrB.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $6I9SI.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $5FkrB.useLayoutEffect)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $5FkrB.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // Legacy quirk: `computedPosition` is null until the layout effect runs,
    // so the first render returns null even with `defaultMenuIsOpen` set.
    // Synchronous observers (VR snapshots) see a one-frame "closed" state.
    // Left as-is; the top-layer path supersedes this and positions declaratively.
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    var _getStyleProps = (0, $5rHW6.getStyleProps)($07ce3d6455375668$var$_objectSpread($07ce3d6455375668$var$_objectSpread({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    // same wrapper element whether fixed or portalled
    var menuWrapper = /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $07ce3d6455375668$var$menuPortalStyles.root,
            (0, $hUFig.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: $07ce3d6455375668$var$_objectSpread({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': "".concat(computedPosition.rect.left, "px"),
            '--menu-position': menuPosition,
            '--menu-top': "".concat(computedPosition.offset, "px"),
            '--menu-width': "".concat(computedPosition.rect.width, "px")
        }, css)
    }, innerProps), children);
    return /*#__PURE__*/ $5FkrB.createElement((0, $dI0Ja.PortalPlacementContext).Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $aLeHs.createPortal)(menuWrapper, appendTo) : menuWrapper);
}
var $07ce3d6455375668$export$793392f970497feb = function MenuPortal(props) {
    if ((0, $2goCw.fg)('platform-dst-top-layer')) // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ $5FkrB.createElement((0, $8znmW.MenuPortalTopLayer), props);
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ $5FkrB.createElement($07ce3d6455375668$var$MenuPortalLegacy, props);
};

});
parcelRegister("dI0Ja", function(module, exports) {
$parcel$export(module.exports, "PortalPlacementContext", () => $9faff2e6cc59df12$export$e001f626511a0ead);

var $5FkrB = parcelRequire("5FkrB");
var $9faff2e6cc59df12$export$e001f626511a0ead = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});

parcelRegister("8znmW", function(module, exports) {
$parcel$export(module.exports, "MenuPortalTopLayer", () => $63d3b831fca851ce$export$1f5427c7f5364d0b);
/* menu-portal-top-layer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $1NNLT = parcelRequire("1NNLT");

var $ld9s3 = parcelRequire("ld9s3");

var $8zliQ = parcelRequire("8zliQ");

var $iGKpq = parcelRequire("iGKpq");

var $5rHW6 = parcelRequire("5rHW6");

var $k28lc = parcelRequire("k28lc");
function $63d3b831fca851ce$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $63d3b831fca851ce$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $63d3b831fca851ce$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $63d3b831fca851ce$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// `'auto'` falls through to `'end'`; top-layer's `position-try-fallbacks` flips it if needed.
function $63d3b831fca851ce$var$reactSelectEdgeToTopLayerEdge(menuPlacement) {
    return menuPlacement === 'top' ? 'start' : 'end';
}
var $63d3b831fca851ce$var$menuPortalStyles = {
    root: "_ofie1496"
};
function $63d3b831fca851ce$export$1f5427c7f5364d0b(props) {
    var children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, xcss = props.xcss;
    // Select's "close the menu" callback, distinct from `Popover.onClose`.
    var closeSelect = (0, $5FkrB.useContext)((0, $k28lc.MenuPortalCloseContext));
    var popoverRef = (0, $5FkrB.useRef)(null);
    // Top-layer hooks need a RefObject; in-render mutation keeps it in sync
    // with the prop without an effect. The hooks re-read `.current` from
    // `isOpen`-keyed layout effects, so a stable ref identity is fine.
    var anchorRef = (0, $5FkrB.useRef)(null);
    anchorRef.current = controlElement;
    // `controlElement` is null on initial mount / SSR until `Select` mirrors
    // its ref into state. While null, every hook below no-ops to avoid DOM
    // reads or registering an unpositioned popover.
    var isAnchored = controlElement !== null;
    // `gap: 0` matches the legacy MenuPortal (no trigger-to-menu gap; the
    // menu root already declares its own `marginBlockStart`). Without this
    // override `useAnchorPosition`'s default 8px gap would diverge visually
    // from the legacy path.
    (0, $8zliQ.useAnchorPosition)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        placement: {
            axis: 'block',
            edge: $63d3b831fca851ce$var$reactSelectEdgeToTopLayerEdge(menuPlacement),
            offset: {
                gap: 0
            }
        },
        isOpen: isAnchored
    });
    (0, $iGKpq.useWidthFromAnchor)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        mode: 'match-anchor',
        isOpen: isAnchored
    });
    var handlePopoverClose = (0, $5FkrB.useCallback)(function() {
        if (closeSelect) closeSelect();
    }, [
        closeSelect
    ]);
    // Explicit observer registration: the outer Popover is intentionally
    // roleless (see Popover comment below), so Popover cannot auto-register
    // from its role. This lets `closeLayers()` (Modal / Drawer) dismiss us.
    (0, $1NNLT.useNotifyOpenLayerObserver)({
        type: 'popup',
        isOpen: isAnchored,
        onClose: handlePopoverClose
    });
    // Top-layer owns positioning; zero offset/rect preserves the consumer
    // styles call shape.
    var _getStyleProps = (0, $5rHW6.getStyleProps)($63d3b831fca851ce$var$_objectSpread($63d3b831fca851ce$var$_objectSpread({}, props), {}, {
        offset: 0,
        position: menuPosition,
        rect: {
            left: 0,
            width: 0
        }
    }), 'menuPortal', {
        'menu-portal': true
    }), className = _getStyleProps.className;
    // Popover stays mounted and is driven by `isOpen` so its layout-effect
    // teardown (`hidePopover`, observer cleanup, position-hook style reset)
    // runs against a live element. Conditional render would skip that path.
    //
    // `mode="auto"` delegates light-dismiss and Escape to the browser. The
    // `onClose` bridge then synchronizes react-select's `menuIsOpen` state after
    // native dismissal, keeping this popover available to consume the request.
    //
    // The Popover host is intentionally roleless: the inner `MenuList`
    // keeps `role="listbox"` and the id referenced by `aria-controls`.
    // Putting the role on the outer host caused Playwright `toBeVisible`
    // and some SR hit-testing to treat it as hidden (zero bounding rect
    // while `styles.root` opts out of UA `[popover]` positioning).
    //
    // TODO: add open / close animation. Select unmounts MenuPortalTopLayer
    // the moment `menuIsOpen` flips false, so Popover's `animate` exit
    // transition never gets a frame. Needs keeping the portal mounted
    // through the exit (`onExitFinish`) on the Select side.
    return /*#__PURE__*/ $5FkrB.createElement((0, $ld9s3.Popover), {
        ref: popoverRef,
        mode: "auto",
        isOpen: isAnchored,
        onClose: handlePopoverClose
    }, /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // `className` carries consumer `styles.menuPortal({...})` output,
        // `xcss` carries caller compiled atomic classes, and `-MenuPortal`
        // is a legacy selector hook kept for parity with MenuPortalLegacy.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss, @typescript-eslint/no-explicit-any
        className: (0, $970q7.default)([
            $63d3b831fca851ce$var$menuPortalStyles.root,
            (0, $hUFig.cx)(className, xcss, '-MenuPortal')
        ])
    }, innerProps), children));
}

});
parcelRegister("1NNLT", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $1500f99dc31235ae$export$469bb693f11edc7f);

var $5FkrB = parcelRequire("5FkrB");

var $8gFOt = parcelRequire("8gFOt");

var $73GTX = parcelRequire("73GTX");
function $1500f99dc31235ae$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $8gFOt.OpenLayerObserverContext));
    var namespace = (0, $73GTX.useOpenLayerObserverNamespace)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("8gFOt", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $6050408fbd63770e$export$5fbf4d7fae6cdc00);

var $5FkrB = parcelRequire("5FkrB");
var $6050408fbd63770e$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});

parcelRegister("73GTX", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $523a178d69736f00$export$1d57e79091cc3046);

var $5FkrB = parcelRequire("5FkrB");

var $BwlO5 = parcelRequire("BwlO5");
function $523a178d69736f00$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $BwlO5.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("BwlO5", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $070c8cfed51aadb3$export$644a49f3b8c50fcd);

var $5FkrB = parcelRequire("5FkrB");
var $070c8cfed51aadb3$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});



parcelRegister("ld9s3", function(module, exports) {
$parcel$export(module.exports, "Popover", () => $f71224b9481f58c7$export$5b6b19405a83ff9d);
/* popover.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $hUFig = parcelRequire("hUFig");

var $7QpUe = parcelRequire("7QpUe");

var $iO8GM = parcelRequire("iO8GM");

var $bvsoE = parcelRequire("bvsoE");

var $1NNLT = parcelRequire("1NNLT");

var $ci32B = parcelRequire("ci32B");

var $hqsy5 = parcelRequire("hqsy5");

var $50qVk = parcelRequire("50qVk");

var $apLft = parcelRequire("apLft");

var $94JdY = parcelRequire("94JdY");
/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ var $f71224b9481f58c7$var$supportsPopoverHint = (0, $bvsoE.default)(function() {
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    var element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
// Surface reset — neutralises inherited interaction and text-layout properties
// (e.g. `pointer-events: none` from an overlaid controls container and
// `white-space: nowrap` from an `@atlaskit/select` option) that leak into a
// top-layer element because, for CSS inheritance, it is still a DOM child of its
// trigger (top-layer promotion is paint/stacking only; the legacy portal path
// avoided this by rendering at `<body>`). Excludes `color`/`font` (theming) and
// `direction`/`unicode-bidi` (RTL must inherit).
//
// KEEP IN SYNC with the identical `surfaceResetStyles` in `dialog/dialog-content.tsx`.
// ADS forbids sharing styles across files (`no-exported-styles` /
// `no-imported-style-values` — Compiled styles are null at runtime), so the reset is
// co-located and duplicated deliberately.
var $f71224b9481f58c7$var$surfaceResetStyles = {
    root: "_lcxv1wug _o5724jg8 _1nmz4jg8 _1i4q4jg8 _y3gnv2br _azhwidpf _1p1dglyw"
};
var $f71224b9481f58c7$var$styles = {
    root: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r041wug _1reoewfl _18m9ewfl _bfhk1j28 _4t3i1wug",
    motion: "_k8m011k7 _1oecdn4k _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v179n",
    exit: "_y44vof1f"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
var $f71224b9481f58c7$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ var $f71224b9481f58c7$var$POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
var $f71224b9481f58c7$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function Popover(_ref, ref) {
    var children = _ref.children, _ref$mode = _ref.mode, modeProp = _ref$mode === void 0 ? 'auto' : _ref$mode, onClose = _ref.onClose, onEnterFinish = _ref.onEnterFinish, onExitFinish = _ref.onExitFinish, _ref$shouldAnimate = _ref.shouldAnimate, shouldAnimate = _ref$shouldAnimate === void 0 ? false : _ref$shouldAnimate, placement = _ref.placement, testId = _ref.testId, isOpen = _ref.isOpen, enteringAnimationXcss = _ref.enteringAnimationXcss, exitingAnimationXcss = _ref.exitingAnimationXcss, role = _ref.role, label = _ref.label, labelledBy = _ref.labelledBy, idProp = _ref.id;
    var autoId = (0, $5FkrB.useId)();
    var ownRef = (0, $5FkrB.useRef)(null);
    var combinedRef = (0, $iO8GM.default)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    var popoverId = idProp !== null && idProp !== void 0 ? idProp : "popover-".concat(autoId.replace(/:/g, ''));
    var _useAnimatedVisibilit = (0, $50qVk.useAnimatedVisibility)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    }), phase = _useAnimatedVisibilit.phase, onToggle = _useAnimatedVisibilit.onToggle;
    // True while the host element is mounted (any phase except `closed`).
    // Used as a dep so listener-rebind effects re-attach after a remount.
    var isVisible = phase !== 'closed';
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // focus-capturing roles are handled below via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus-restoration.md.
    (0, $apLft.useFocusWrap)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    (0, $94JdY.useInitialFocus)({
        elementRef: ownRef,
        phase: phase,
        role: role
    });
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined.
    var handleObserverClose = (0, $5FkrB.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose({
            reason: 'programmatic'
        });
    }, [
        onClose
    ]);
    (0, $1NNLT.useNotifyOpenLayerObserver)({
        type: role && $f71224b9481f58c7$var$POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen: isOpen,
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    var mode = modeProp === 'hint' && !$f71224b9481f58c7$var$supportsPopoverHint() ? 'auto' : modeProp;
    var popupMotionStyle = (0, $5FkrB.useMemo)(function() {
        if (!placement || !shouldAnimate) return undefined;
        var _resolvePlacement = (0, $ci32B.resolvePlacement)({
            placement: placement
        }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge;
        return $f71224b9481f58c7$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]);
    // Prevents toggle handler from calling onClose for our own hidePopover() calls.
    var programmaticCloseRef = (0, $5FkrB.useRef)(false);
    // Set in capture-phase keydown so the toggle handler knows close reason.
    var closeReasonRef = (0, $5FkrB.useRef)('light-dismiss');
    // Snapshot of pre-open focus, used to restore focus for nested popovers
    // with focus-capturing roles (browser only restores the outermost).
    var previouslyFocusedElementRef = (0, $5FkrB.useRef)(null);
    var handleBeforeToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState !== 'open') return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- need active element snapshot
        var active = document.activeElement;
        previouslyFocusedElementRef.current = active instanceof HTMLElement ? active : null;
    }, []);
    var handleToggle = (0, $5FkrB.useCallback)(function(event) {
        var element = ownRef.current;
        if (event.newState === 'open') {
            onToggle(event);
            return;
        }
        if (event.newState === 'closed') {
            if (element) {
                // Nested-popover focus restoration fallback (browser only
                // restores outermost; Firefox skips nested entirely).
                // Restore only when the role moved focus in on open AND the
                // close was Escape/programmatic. For light dismiss, the
                // click target keeps focus per HTML spec
                // (`focusPreviousElement=false`).
                var previouslyFocused = previouslyFocusedElementRef.current;
                var reason = closeReasonRef.current;
                var isProgrammatic = programmaticCloseRef.current;
                var shouldRestore = previouslyFocused !== null && previouslyFocused.isConnected && (0, $hqsy5.shouldFocusIntoPopover)({
                    role: role
                }) && (reason === 'escape' || isProgrammatic);
                if (shouldRestore && previouslyFocused) previouslyFocused.focus({
                    preventScroll: true
                });
                previouslyFocusedElementRef.current = null;
            }
            // Programmatic close: consumer already knows.
            if (programmaticCloseRef.current) // Reset reason so a stale 'escape' from a race with Escape keydown
            // does not corrupt the next browser-dismiss cycle.
            closeReasonRef.current = 'light-dismiss';
            else {
                // Browser dismiss (Escape/click-outside).
                var _reason = closeReasonRef.current;
                closeReasonRef.current = 'light-dismiss';
                // Optional: `manual` mode has no `onClose` in the forwarded type.
                onClose === null || onClose === void 0 || onClose({
                    reason: _reason
                });
            }
        }
        onToggle(event);
    }, [
        onClose,
        onToggle,
        role
    ]);
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `previouslyFocusedElementRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        var unbindEscape = (0, $7QpUe.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key === 'Escape') closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        var unbindToggle = (0, $7QpUe.bind)(element, {
            type: 'toggle',
            listener: handleToggle
        });
        // Snapshot `document.activeElement` before `useInitialFocus` moves it.
        var unbindBeforeToggle = (0, $7QpUe.bind)(element, {
            type: 'beforetoggle',
            listener: handleBeforeToggle
        });
        return function() {
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleToggle,
        handleBeforeToggle,
        isVisible
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            programmaticCloseRef.current = false;
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and the no-animation path unmounts before
            // `handleToggle` can reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch (_unused) {}
            return function() {
                programmaticCloseRef.current = true;
                try {
                    element.hidePopover();
                } catch (_unused2) {}
            };
        }
        programmaticCloseRef.current = true;
        try {
            element.hidePopover();
        } catch (_unused3) {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        ref: combinedRef,
        id: popoverId,
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        style: popupMotionStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $f71224b9481f58c7$var$styles.root,
            $f71224b9481f58c7$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $f71224b9481f58c7$var$styles.enter,
            shouldAnimate && phase === 'exiting' && $f71224b9481f58c7$var$styles.exit,
            shouldAnimate && $f71224b9481f58c7$var$styles.motion,
            (0, $hUFig.cx)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ])
    }, children);
});

});
parcelRegister("ci32B", function(module, exports) {
$parcel$export(module.exports, "resolvePlacement", () => $8f29865d17b61026$export$63044d21bc3d3fa2);

var $iEJO2 = parcelRequire("iEJO2");
/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ var $8f29865d17b61026$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $8f29865d17b61026$export$63044d21bc3d3fa2(_ref) {
    var _placement$offset, _placement$axis, _placement$edge, _placement$align, _placement$offset$cro, _placement$offset2, _placement$offset$cro2, _placement$offset3;
    var placement = _ref.placement;
    var consumerGap = (_placement$offset = placement.offset) === null || _placement$offset === void 0 ? void 0 : _placement$offset.gap;
    return {
        axis: (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block',
        edge: (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end',
        align: (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center',
        offset: {
            gap: consumerGap === undefined ? $8f29865d17b61026$var$DEFAULT_GAP : (0, $iEJO2.toCssLengthString)({
                value: consumerGap
            }),
            crossAxisShift: {
                value: (0, $iEJO2.toCssLengthString)({
                    value: (_placement$offset$cro = (_placement$offset2 = placement.offset) === null || _placement$offset2 === void 0 || (_placement$offset2 = _placement$offset2.crossAxisShift) === null || _placement$offset2 === void 0 ? void 0 : _placement$offset2.value) !== null && _placement$offset$cro !== void 0 ? _placement$offset$cro : 0
                }),
                direction: (_placement$offset$cro2 = (_placement$offset3 = placement.offset) === null || _placement$offset3 === void 0 || (_placement$offset3 = _placement$offset3.crossAxisShift) === null || _placement$offset3 === void 0 ? void 0 : _placement$offset3.direction) !== null && _placement$offset$cro2 !== void 0 ? _placement$offset$cro2 : 'forwards'
            }
        }
    };
}

});
parcelRegister("iEJO2", function(module, exports) {
$parcel$export(module.exports, "toCssLengthString", () => $0381483c0b3d34ec$export$63b6b0ff65d84d47);
/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $0381483c0b3d34ec$export$63b6b0ff65d84d47(_ref) {
    var value = _ref.value;
    if (typeof value === 'number') return "".concat(value, "px");
    return value;
}

});


parcelRegister("hqsy5", function(module, exports) {
$parcel$export(module.exports, "shouldFocusIntoPopover", () => $cafb0296b390f03f$export$b12adccf56228c71);
var $cafb0296b390f03f$var$rolesThatMoveFocus = new Set([
    'dialog',
    'alertdialog',
    'menu',
    'listbox',
    'tree',
    'grid'
]);
function $cafb0296b390f03f$export$b12adccf56228c71(_ref) {
    var role = _ref.role;
    if (!role) return false;
    return $cafb0296b390f03f$var$rolesThatMoveFocus.has(role);
}

});

parcelRegister("50qVk", function(module, exports) {
$parcel$export(module.exports, "useAnimatedVisibility", () => $3a51d64d61bc19e5$export$1bccb45daf07907f);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $63UTg = parcelRequire("63UTg");
function $3a51d64d61bc19e5$var$runCancellableSettlement(_ref) {
    var schedule = _ref.schedule, onSettled = _ref.onSettled;
    var isCancelled = false;
    schedule(function() {
        if (isCancelled) return;
        onSettled();
    });
    return function() {
        isCancelled = true;
    };
}
/**
 * Fires `onSettled` once all animations currently applied to `element`
 * finish or are cancelled. Returns a cleanup that prevents stale settlement.
 */ function $3a51d64d61bc19e5$var$runOnAnimationsSettled(_ref2) {
    var element = _ref2.element, onSettled = _ref2.onSettled;
    return $3a51d64d61bc19e5$var$runCancellableSettlement({
        onSettled: onSettled,
        schedule: function schedule(settle) {
            var _element$getAnimation, _element$getAnimation2;
            var animations = (_element$getAnimation = (_element$getAnimation2 = element.getAnimations) === null || _element$getAnimation2 === void 0 ? void 0 : _element$getAnimation2.call(element)) !== null && _element$getAnimation !== void 0 ? _element$getAnimation : [];
            Promise.allSettled(animations.map(function(animation) {
                return animation.finished;
            })).then(settle);
        }
    });
}
function $3a51d64d61bc19e5$export$1bccb45daf07907f(_ref3) {
    var isOpen = _ref3.isOpen, shouldAnimate = _ref3.shouldAnimate, elementRef = _ref3.elementRef, onEnterFinish = _ref3.onEnterFinish, onExitFinish = _ref3.onExitFinish;
    var willAnimate = shouldAnimate && !(0, $63UTg.prefersReducedMotion)();
    var isNativeClosedRef = (0, $5FkrB.useRef)(false);
    // Promote `closed → entering`/`closed → open` synchronously during
    // render so the host element mounts in the same commit as the open
    // intent. All other transitions are driven by phase-specific effects.
    var _useState = (0, $5FkrB.useState)(function() {
        if (!isOpen) return 'closed';
        return willAnimate ? 'entering' : 'open';
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), phase = _useState2[0], setPhase = _useState2[1];
    // Rearm only after controlled state and the native lifecycle have both
    // reached closed. Resetting as soon as `isOpen` becomes false can erase a
    // closing toggle that was handled in the same React batch.
    if (!isOpen && phase === 'closed') isNativeClosedRef.current = false;
    if (isOpen && phase === 'closed' && !isNativeClosedRef.current) setPhase(willAnimate ? 'entering' : 'open');
    if (!isOpen && (phase === 'open' || phase === 'entering')) // Close intent. Move to `exiting` to gate the unmount on either
    // the exit transition (animated) or the closing toggle event
    // (non-animated). Includes interrupted entry (`entering → exiting`).
    setPhase('exiting');
    if (isOpen && phase === 'exiting' && !isNativeClosedRef.current) // Reopen mid-exit. With animation, jump back to `entering` and let
    // the entry transition restart from current visual state. Without
    // animation, jump straight to `open` (the handshake we were waiting
    // for is no longer relevant; the consumer wants the host visible
    // again synchronously).
    setPhase(willAnimate ? 'entering' : 'open');
    // Keep stable refs to the latest callbacks so effects and promise callbacks
    // always call the current callback without needing them in dependency arrays.
    var onEnterFinishRef = (0, $5FkrB.useRef)(onEnterFinish);
    onEnterFinishRef.current = onEnterFinish;
    var onExitFinishRef = (0, $5FkrB.useRef)(onExitFinish);
    onExitFinishRef.current = onExitFinish;
    // Animated entry: wait for all active animations and move to `open`.
    (0, $5FkrB.useEffect)(function() {
        if (phase !== 'entering') return;
        var element = elementRef.current;
        if (!element) return;
        return $3a51d64d61bc19e5$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                var _onEnterFinishRef$cur;
                // Fire the consumer callback before transitioning phase so any
                // state the consumer reads (refs, DOM nodes) is still attached
                // in the same synchronous tick, regardless of React batching
                // semantics.
                (_onEnterFinishRef$cur = onEnterFinishRef.current) === null || _onEnterFinishRef$cur === void 0 || _onEnterFinishRef$cur.call(onEnterFinishRef);
                setPhase(function(current) {
                    return current === 'entering' ? 'open' : current;
                });
            }
        });
    }, [
        phase,
        elementRef
    ]);
    // Non-animated entry callback. The lifecycle goes `closed → open`
    // directly with no `entering` phase; fire `onEnterFinish` on that jump.
    // A previous-phase ref avoids double-firing on the animated path.
    var prevPhaseForEntryRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForEntryRef.current;
        prevPhaseForEntryRef.current = phase;
        // Animated entry settle goes through `entering` and already fired
        // onEnterFinish above; only handle the non-animated direct jumps.
        if (prevPhase !== 'open' && phase === 'open' && prevPhase !== 'entering') {
            var _onEnterFinishRef$cur2;
            (_onEnterFinishRef$cur2 = onEnterFinishRef.current) === null || _onEnterFinishRef$cur2 === void 0 || _onEnterFinishRef$cur2.call(onEnterFinishRef);
        }
    }, [
        phase
    ]);
    // Animated exit: wait for all active animations, fire `onExitFinish`,
    // then move to `closed` to unmount the host.
    (0, $5FkrB.useEffect)(function() {
        if (phase !== 'exiting' || !willAnimate) return;
        var element = elementRef.current;
        if (!element) return;
        return $3a51d64d61bc19e5$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                var _onExitFinishRef$curr;
                // Fire the consumer callback before transitioning phase to
                // `closed`. The phase change drives the host element unmount,
                // and consumers expect to be able to read the element (or a
                // forwarded ref to it) inside `onExitFinish`. Doing this in
                // the safe order avoids relying on React's automatic batching
                // to keep the element attached across the callback.
                (_onExitFinishRef$curr = onExitFinishRef.current) === null || _onExitFinishRef$curr === void 0 || _onExitFinishRef$curr.call(onExitFinishRef);
                setPhase(function(current) {
                    return current === 'exiting' ? 'closed' : current;
                });
            }
        });
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    // Native dismissal is authoritative. Its toggle can arrive while controlled
    // state still says open, so remember that native state and do not
    // reopen until `isOpen` has first moved to false.
    (0, $5FkrB.useLayoutEffect)(function() {
        if (phase === 'exiting' && !willAnimate && isNativeClosedRef.current) setPhase('closed');
    }, [
        phase,
        willAnimate
    ]);
    var onToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState === 'open') {
            isNativeClosedRef.current = false;
            return;
        }
        if (event.newState !== 'closed') return;
        isNativeClosedRef.current = true;
        setPhase(function(current) {
            if (current === 'open' || current === 'entering') return 'exiting';
            if (current === 'exiting' && !willAnimate) return 'closed';
            return current;
        });
    }, [
        willAnimate
    ]);
    // Non-animated exit callback. There are no animations to wait for, so fire
    // `onExitFinish` on the transition into `exiting` (the unmount itself
    // is gated by the closing toggle handshake above).
    var prevPhaseForExitRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForExitRef.current;
        prevPhaseForExitRef.current = phase;
        // Only fire on the non-animated transition into `exiting`. The
        // animated path's `exiting → closed` settle already fires
        // `onExitFinish` from `runOnAnimationsSettled`.
        if (prevPhase !== 'exiting' && phase === 'exiting' && !willAnimate) {
            var _onExitFinishRef$curr2;
            (_onExitFinishRef$curr2 = onExitFinishRef.current) === null || _onExitFinishRef$curr2 === void 0 || _onExitFinishRef$curr2.call(onExitFinishRef);
        }
    }, [
        phase,
        willAnimate
    ]);
    return {
        phase: phase,
        onToggle: onToggle
    };
}

});
parcelRegister("63UTg", function(module, exports) {
$parcel$export(module.exports, "prefersReducedMotion", () => $469f2725366163c1$export$ff7706047246b98b);

var $bvsoE = parcelRequire("bvsoE");
var $469f2725366163c1$export$ff7706047246b98b = (0, $bvsoE.default)(function() {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});

});


parcelRegister("apLft", function(module, exports) {
$parcel$export(module.exports, "useFocusWrap", () => $7950e3c2e9a92fe9$export$4f6462e86a70abe5);

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $a8Q6q = parcelRequire("a8Q6q");

var $hg4jV = parcelRequire("hg4jV");

var $6SFhp = parcelRequire("6SFhp");

var $3oYXX = parcelRequire("3oYXX");
/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/outputs/menu-keyboard-decision.md
 */ function $7950e3c2e9a92fe9$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $7950e3c2e9a92fe9$export$4f6462e86a70abe5(_ref) {
    var elementRef = _ref.elementRef, role = _ref.role, phase = _ref.phase;
    var isVisible = phase !== 'closed';
    (0, $5FkrB.useEffect)(function() {
        var element = elementRef.current;
        if (!element || !$7950e3c2e9a92fe9$var$roleRequiresFocusWrap(role) || !isVisible) return;
        var unbind = (0, $7QpUe.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $3oYXX.isNestedLayerFocused)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                var direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                var next = (0, $6SFhp.getNextFocusable)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                var fallback = direction === 'forwards' ? (0, $a8Q6q.getFirstFocusable)({
                    container: element
                }) : (0, $hg4jV.getLastFocusable)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}

});
parcelRegister("a8Q6q", function(module, exports) {
$parcel$export(module.exports, "getFirstFocusable", () => $76231141248dde73$export$748138f04a69bf21);

var $4q3rq = parcelRequire("4q3rq");
function $76231141248dde73$export$748138f04a69bf21(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $4q3rq.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}

});
parcelRegister("4q3rq", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $337c4284aa85d7c2$export$f6768025e418420e);

var $8Qlvz = parcelRequire("8Qlvz");

var $6RMvS = parcelRequire("6RMvS");
function $337c4284aa85d7c2$export$f6768025e418420e(_ref) {
    var container = _ref.container, filter = _ref.filter;
    return Array.from(container.querySelectorAll((0, $6RMvS.selectors).focusable)).filter(function(element) {
        return element instanceof HTMLElement;
    }).filter(function(element) {
        return (0, $8Qlvz.isInSameLayer)({
            element: element,
            container: container
        });
    }).filter(function(element) {
        return !filter || filter(element, container);
    });
}

});
parcelRegister("8Qlvz", function(module, exports) {
$parcel$export(module.exports, "isInSameLayer", () => $6703dd2a01749b58$export$df8c72c64edc7260);
var $6703dd2a01749b58$var$topLayerSelector = '[popover], dialog, [role="dialog"], [role="alertdialog"]';
function $6703dd2a01749b58$export$df8c72c64edc7260(_ref) {
    var element = _ref.element, container = _ref.container;
    return element.closest($6703dd2a01749b58$var$topLayerSelector) === container.closest($6703dd2a01749b58$var$topLayerSelector);
}

});

parcelRegister("6RMvS", function(module, exports) {
$parcel$export(module.exports, "selectors", () => $4ffd5309dd94e3dc$export$e1252723db1c541);
var $4ffd5309dd94e3dc$export$e1252723db1c541 = function() {
    // Common exclusion filter applied to every selector.
    var not = ':not([tabindex="-1"]):not([aria-disabled="true"]):not([aria-hidden="true"])';
    var notDisabled = ":not([disabled])".concat(not);
    var focusable = [
        "a[href]".concat(not),
        "area[href]".concat(not),
        "input".concat(notDisabled, ":not([type=\"hidden\"])"),
        "select".concat(notDisabled),
        "textarea".concat(notDisabled),
        "button".concat(notDisabled),
        "iframe".concat(not),
        "audio[controls]".concat(not),
        "video[controls]".concat(not),
        "[contenteditable]:not([contenteditable=\"false\"])".concat(not),
        "[tabindex]".concat(notDisabled)
    ];
    return {
        focusable: focusable.join(','),
        // Build the `:focus` selector
        focused: focusable.map(function(selector) {
            return "".concat(selector, ":focus");
        }).join(',')
    };
}();

});



parcelRegister("hg4jV", function(module, exports) {
$parcel$export(module.exports, "getLastFocusable", () => $c9074834a121f40c$export$73e81fa65335a75b);

var $4q3rq = parcelRequire("4q3rq");
function $c9074834a121f40c$export$73e81fa65335a75b(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $4q3rq.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}

});

parcelRegister("6SFhp", function(module, exports) {
$parcel$export(module.exports, "getNextFocusable", () => $5027ce858485bdde$export$a7db88e6d491b450);
/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * Returns `null` if there is no focused element within the container or if
 * the focused element is not in the list of focusable elements.
 */ 
var $4q3rq = parcelRequire("4q3rq");

var $6RMvS = parcelRequire("6RMvS");
function $5027ce858485bdde$export$a7db88e6d491b450(_ref) {
    var _all$nextIndex;
    var container = _ref.container, direction = _ref.direction, filter = _ref.filter;
    var all = (0, $4q3rq.getFocusables)({
        container: container,
        filter: filter
    });
    var current = container.querySelector((0, $6RMvS.selectors).focused);
    if (!(current instanceof HTMLElement)) return null;
    var index = all.indexOf(current);
    if (index === -1) return null;
    var nextIndex = function() {
        if (direction === 'forwards') return (index + 1) % all.length;
        var proposed = index - 1;
        // if going into negative numbers, loop back to the last item
        return proposed < 0 ? all.length - 1 : proposed;
    }();
    return (_all$nextIndex = all[nextIndex]) !== null && _all$nextIndex !== void 0 ? _all$nextIndex : null;
}

});

parcelRegister("3oYXX", function(module, exports) {
$parcel$export(module.exports, "isNestedLayerFocused", () => $27a2e794465841c7$export$b9590fdfeb5f722f);

var $lFhdZ = parcelRequire("lFhdZ");

var $8Qlvz = parcelRequire("8Qlvz");
function $27a2e794465841c7$export$b9590fdfeb5f722f(_ref) {
    var _getDocument;
    var container = _ref.container;
    var focused = (_getDocument = (0, $lFhdZ.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return !(0, $8Qlvz.isInSameLayer)({
        element: focused,
        container: container
    });
}

});


parcelRegister("94JdY", function(module, exports) {
$parcel$export(module.exports, "useInitialFocus", () => $69b7916696a8e641$export$e992c40175757a22);

var $5FkrB = parcelRequire("5FkrB");

var $a8Q6q = parcelRequire("a8Q6q");
/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox regardless of role. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, or menu), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
var $69b7916696a8e641$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $69b7916696a8e641$var$isTextboxLikeElement(element) {
    var role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    var tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        var _element$getAttribute;
        var type = ((_element$getAttribute = element.getAttribute('type')) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : 'text').toLowerCase();
        return $69b7916696a8e641$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $69b7916696a8e641$var$isComboboxControllingPopup(_ref) {
    var _active$getAttribute;
    var container = _ref.container;
    var ownerDocument = container.ownerDocument;
    var active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$69b7916696a8e641$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    var idRefs = (_active$getAttribute = active.getAttribute('aria-controls')) !== null && _active$getAttribute !== void 0 ? _active$getAttribute : active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    var referencedIds = idRefs.split(/\s+/).filter(function(id) {
        return id !== '';
    });
    return referencedIds.some(function(id) {
        var referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function $69b7916696a8e641$var$getInitialFocusTarget(_ref2) {
    var container = _ref2.container, role = _ref2.role;
    if (role === 'dialog' || role === 'alertdialog') {
        // Prefer element with the native HTML autofocus attribute.
        var autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $a8Q6q.getFirstFocusable)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific (menu / listbox) rather
    // than hoisted. Hoisting it over-matched on dialog popups that contain
    // a nested combobox (e.g. datetime-picker's dialog hosts a react-select),
    // where the active combobox's `aria-controls` falsely matched the
    // container and suppressed the dialog's own focus contract.
    if (role === 'menu') {
        if ($69b7916696a8e641$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/outputs/menu-keyboard-decision.md
        return (0, $a8Q6q.getFirstFocusable)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($69b7916696a8e641$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        var selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        var firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $a8Q6q.getFirstFocusable)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $69b7916696a8e641$export$e992c40175757a22(_ref3) {
    var elementRef = _ref3.elementRef, phase = _ref3.phase, role = _ref3.role;
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    var prevPhaseRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var _getInitialFocusTarge;
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        var element = elementRef.current;
        if (!element) return;
        (_getInitialFocusTarge = $69b7916696a8e641$var$getInitialFocusTarget({
            container: element,
            role: role
        })) === null || _getInitialFocusTarge === void 0 || _getInitialFocusTarge.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}

});


parcelRegister("8zliQ", function(module, exports) {
$parcel$export(module.exports, "useAnchorPosition", () => $63d21dea6f39d819$export$56b02a1e583f953c);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $45Zis = parcelRequire("45Zis");

var $bvsoE = parcelRequire("bvsoE");

var $2fwmU = parcelRequire("2fwmU");

var $3WiY0 = parcelRequire("3WiY0");

var $eRQbi = parcelRequire("eRQbi");

var $4IJcL = parcelRequire("4IJcL");

var $hcFCx = parcelRequire("hcFCx");

var $ci32B = parcelRequire("ci32B");

var $b1W5A = parcelRequire("b1W5A");
// `resolvePlacement` is intentionally NOT re-exported here - import it directly
// from `./resolve-placement` so search-and-jump lands at the source of truth.
/**
 * Module-scope no-op `ResizeObserver` used in non-DOM jest environments where
 * `ResizeObserver` is `undefined`. Hoisted out of the effect to avoid
 * allocating a new class declaration on every run.
 */ var $63d21dea6f39d819$var$NoopResizeObserver = /*#__PURE__*/ function() {
    function NoopResizeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoopResizeObserver);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoopResizeObserver, [
        {
            key: "observe",
            value: function observe() {}
        },
        {
            key: "unobserve",
            value: function unobserve() {}
        },
        {
            key: "disconnect",
            value: function disconnect() {}
        }
    ]);
}();
/**
 * Returns true when the popover is currently open. Wrapped because the
 * `:popover-open` pseudo-class is not implemented in some test environments
 * (e.g. jsdom), where `matches` throws on unknown selectors.
 */ function $63d21dea6f39d819$var$isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch (_unused) {
        return false;
    }
}
/**
 * Detects whether the browser supports CSS Anchor Positioning.
 * Uses `once()` for lazy evaluation: safe for SSR and avoids hydration mismatches.
 */ var $63d21dea6f39d819$var$supportsAnchorPositioning = (0, $bvsoE.default)(function() {
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('anchor-name', '--a');
});
/**
 * Every logical margin property this module can write: one per axis, per side.
 *
 * Deriving the union from `TPlacementAxis` and `TPlacementEdge` rather than
 * writing the four names out keeps it in step with the placement model, and
 * makes `CROSS_AXIS_SHIFT_CUSTOM_PROPERTY` below exhaustive by construction.
 */ /**
 * The custom property mirroring each cross-axis shift margin.
 *
 * These are written for the planned named arrow `@position-try` rules. Nothing
 * reads them yet, and the shift no longer depends on them: the antisymmetric
 * margins written by `crossAxisShiftMargins` survive a cross-axis slide on
 * their own.
 *
 * Keyed on `TLogicalMarginProperty` and not on `string`, so a margin property
 * that has no custom property (or a custom property whose margin no longer
 * exists) is a compile error rather than an `undefined` lookup that reaches
 * `setStyle` as `{ property: undefined, value }`.
 */ var $63d21dea6f39d819$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY = {
    'margin-inline-start': '--ds-cross-axis-shift-margin-start',
    'margin-inline-end': '--ds-cross-axis-shift-margin-end',
    'margin-block-start': '--ds-cross-axis-shift-margin-block-start',
    'margin-block-end': '--ds-cross-axis-shift-margin-block-end'
};
var $63d21dea6f39d819$var$ZEROED_CROSS_AXIS_SHIFT_CUSTOM_PROPERTIES = Object.values($63d21dea6f39d819$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY).map(function(property) {
    return {
        property: property,
        value: '0px'
    };
});
/**
 * Returns the CSS margin declaration that creates a gap between the
 * popover and its trigger on the side facing the anchor.
 *
 * For example, a `block-end` placement (popover below) gets
 * `margin-block-start: 8px` to push it away from the trigger's bottom edge.
 */ function $63d21dea6f39d819$var$edgeMargin(_ref) {
    var placement = _ref.placement, offset = _ref.offset;
    var axis = placement.axis, edge = placement.edge;
    // The gap sits on the side FACING the anchor, which is always the side
    // opposite the placement edge.
    var anchorFacingEdge = edge === 'end' ? 'start' : 'end';
    return {
        property: "margin-".concat(axis, "-").concat(anchorFacingEdge),
        value: offset
    };
}
/**
 * **The cross-axis shift margins.**
 *
 * The shift is written antisymmetrically on BOTH cross-axis sides
 * (`start: +value`, `end: -value`) rather than as a single margin on the side
 * picked from `align`. Two separate behaviours require it:
 *
 * 1. **`align: 'center'` is centered with `anchor-center`, which centers the
 *    popover's MARGIN box on the anchor.** A single-sided margin widens the
 *    margin box, so it displaces the border box by only half its value. An
 *    antisymmetric pair leaves the margin box width unchanged (`+value` and
 *    `-value` sum to zero) while moving its center by the full value.
 * 2. **`position-try-fallbacks` can slide the popover onto the opposite
 *    cross-axis side.** A `<position-area>` fallback keeps the base style's
 *    margins, and margin on the un-anchored side has no effect, so a
 *    single-sided margin is silently dropped once the browser slides across the
 *    cross axis. With both sides written, whichever side ends up anchored moves
 *    the popover the same physical direction.
 *
 * Leaving the margin box width unchanged also means the shift does not move
 * the point at which `position-try-fallbacks` decides the popover overflows.
 *
 * A `<try-tactic>` fallback (`flip-block`, `flip-inline`) behaves differently to
 * a `<position-area>` one: it SWAPS the start and end margins rather than
 * keeping them, which is what preserves the gap through a flip. So a flip across
 * the cross axis mirrors the shift along with the rest of the placement, rather
 * than preserving its physical direction. Only the diagonal fallback does that,
 * and only for `align: 'start' | 'end'`. See `placementToTryFallbacks`.
 *
 * A positive value always moves the popover toward the cross-axis END, so
 * `direction: 'forwards'` means the same thing for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 */ function $63d21dea6f39d819$var$crossAxisShiftMargins(_ref2) {
    var placement = _ref2.placement, crossAxisShiftCssValue = _ref2.crossAxisShiftCssValue, direction = _ref2.direction;
    var crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    // Wrap any string in calc() with the sign factor. CSS handles the math,
    // so opaque values such as design tokens negate correctly.
    var negated = "calc(-1 * ".concat(crossAxisShiftCssValue, ")");
    var isForwards = direction === 'forwards';
    return [
        {
            property: "margin-".concat(crossAxis, "-start"),
            value: isForwards ? crossAxisShiftCssValue : negated
        },
        {
            property: "margin-".concat(crossAxis, "-end"),
            value: isForwards ? negated : crossAxisShiftCssValue
        }
    ];
}
/**
 * Returns a referentially-stable, fully-resolved `TPlacement`. The memo is
 * keyed on the resolved primitive fields so a fresh inline `placement` object
 * (or undefined fields vs explicit defaults) does not produce a fresh result.
 */ function $63d21dea6f39d819$var$useStablePlacement(placement) {
    var resolved = (0, $ci32B.resolvePlacement)({
        placement: placement
    });
    var axis = resolved.axis;
    var edge = resolved.edge;
    var align = resolved.align;
    var gap = resolved.offset.gap;
    var shiftValue = resolved.offset.crossAxisShift.value;
    var shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuild inside the memo from primitive deps so the factory does not
    // close over the outer `resolved` reference and exhaustive-deps can verify.
    return (0, $5FkrB.useMemo)(function() {
        return {
            axis: axis,
            edge: edge,
            align: align,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        };
    }, [
        axis,
        edge,
        align,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $63d21dea6f39d819$export$56b02a1e583f953c(_ref3) {
    var anchorRef = _ref3.anchorRef, popoverRef = _ref3.popoverRef, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? {} : _ref3$placement, _ref3$forceFallbackPo = _ref3.forceFallbackPositioning, forceFallbackPositioning = _ref3$forceFallbackPo === void 0 ? false : _ref3$forceFallbackPo, _ref3$isEnabled = _ref3.isEnabled, isEnabled = _ref3$isEnabled === void 0 ? true : _ref3$isEnabled, isOpen = _ref3.isOpen;
    var id = (0, $5FkrB.useId)();
    var stablePlacement = $63d21dea6f39d819$var$useStablePlacement(placement);
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!isEnabled) return;
        var trigger = anchorRef.current;
        var popover = popoverRef.current;
        if (!trigger || !popover) return;
        var gapCssValue = stablePlacement.offset.gap;
        var crossAxisShiftCssValue = stablePlacement.offset.crossAxisShift.value;
        var shouldForceFallback = Boolean(forceFallbackPositioning);
        if ($63d21dea6f39d819$var$supportsAnchorPositioning() && !shouldForceFallback) {
            // Reuse an existing `anchor-name` if the element already has one.
            // Another popover might already be anchored to the old name.
            var anchorName = trigger.style.getPropertyValue('anchor-name') || "--anchor-".concat(id.replace(/:/g, ''));
            var gap = $63d21dea6f39d819$var$edgeMargin({
                placement: stablePlacement,
                offset: gapCssValue
            });
            // Computed once; also mirrored into the
            // `--ds-cross-axis-shift-margin-*` custom properties below.
            var crossAxisShift = $63d21dea6f39d819$var$crossAxisShiftMargins({
                placement: stablePlacement,
                crossAxisShiftCssValue: crossAxisShiftCssValue,
                direction: stablePlacement.offset.crossAxisShift.direction
            });
            var popoverStyles = [
                {
                    property: 'position-anchor',
                    value: anchorName
                },
                {
                    property: 'position-area',
                    value: (0, $eRQbi.placementToPositionArea)({
                        placement: stablePlacement
                    })
                },
                {
                    property: 'position-try-fallbacks',
                    value: (0, $4IJcL.placementToTryFallbacks)({
                        placement: stablePlacement
                    })
                },
                // Reset browser default popover positioning that conflicts
                // with anchor positioning (UA: `inset: 0; margin: auto;`)
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                },
                gap
            ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(crossAxisShift), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))($63d21dea6f39d819$var$ZEROED_CROSS_AXIS_SHIFT_CUSTOM_PROPERTIES), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(crossAxisShift.map(function(_ref4) {
                var property = _ref4.property, value = _ref4.value;
                return {
                    property: $63d21dea6f39d819$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY[property],
                    value: value
                };
            })));
            /**
       * **We are never cleaning up anchor names**
       *
       * _Rationale_
       *
       * - Multiple popovers can share the same anchor element.
       * - Sometimes the `useAnchorPosition` hook and `Popover`
       *   are not in the same component.
       * - There can be times when, even with reference counting, we
       *   could remove the anchor-name while it is still being used
       *   by something else - especially with async react updates
       *   which can cause tearing
       *
       * _More_
       *
       * See `notes/decisions/anchor-name-lifetime.md`
       */ trigger.style.setProperty('anchor-name', anchorName);
            return (0, $b1W5A.setStyle)({
                element: popover,
                styles: popoverStyles
            });
        }
        // JS fallback. The popover is already in the top layer via
        // popover="auto", so we only reset UA defaults and set top/left
        // based on measurements.
        var cleanupBaseStyles = (0, $b1W5A.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                }
            ]
        });
        // The popover can be consumer-owned (`@atlaskit/popper`'s `createPopper`),
        // so restore prior inline values rather than removing ours.
        var undoPosition;
        var undoHide;
        // `opacity: 0` not `visibility: hidden`: Firefox skips visibility-hidden
        // elements during `<dialog>` initial-focus traversal.
        function hideUntilPositioned() {
            // Keep the first snapshot, else we capture our own `opacity: 0`.
            // (`!popover` is for TS: narrowing does not reach nested functions.)
            if (!popover || undoHide) return;
            undoHide = (0, $b1W5A.setStyle)({
                element: popover,
                styles: [
                    {
                        property: 'opacity',
                        value: '0'
                    }
                ]
            });
        }
        function reveal() {
            var _undoHide;
            (_undoHide = undoHide) === null || _undoHide === void 0 || _undoHide();
            undoHide = undefined;
        }
        function restorePosition() {
            var _undoPosition;
            (_undoPosition = undoPosition) === null || _undoPosition === void 0 || _undoPosition();
            undoPosition = undefined;
        }
        function update() {
            if (!trigger || !popover) return;
            var triggerRect = trigger.getBoundingClientRect();
            var viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            // Resolve consumer-supplied CSS length strings (tokens, calc, var,
            // px, rem, etc) to pixels. The probe is mounted INSIDE the popover
            // itself so the resolved length matches the scope a token would
            // resolve against from inside the popover content. (The popover
            // lives in the top layer, not the trigger's DOM tree, so probing
            // at `popover.parentElement` would resolve in a different scope
            // than the consumer's token authoring expects.)
            var gapPx = (0, $hcFCx.resolveCssLengthToPixels)({
                value: gapCssValue,
                container: popover
            });
            var crossAxisShiftPx = (0, $hcFCx.resolveCssLengthToPixels)({
                value: crossAxisShiftCssValue,
                container: popover
            });
            var _computeFallbackPosit = (0, $2fwmU.computeFallbackPosition)({
                triggerRect: triggerRect,
                popoverEl: popover,
                placement: stablePlacement,
                viewport: viewport,
                gap: gapPx,
                crossAxisShift: {
                    value: crossAxisShiftPx,
                    direction: stablePlacement.offset.crossAxisShift.direction
                }
            }), top = _computeFallbackPosit.top, left = _computeFallbackPosit.left;
            // Restore first so the snapshot stays the consumer's value.
            restorePosition();
            undoPosition = (0, $b1W5A.setStyle)({
                element: popover,
                styles: [
                    {
                        property: 'top',
                        value: "".concat(top, "px")
                    },
                    {
                        property: 'left',
                        value: "".concat(left, "px")
                    }
                ]
            });
            reveal();
        }
        // Throttle scroll/resize updates to one per animation frame
        var scheduledUpdate = (0, $45Zis.default)(update);
        // Wait for the FIRST valid layout before measuring: the popover
        // is `display: none` until `showPopover()`, and some browsers
        // fire `toggle` before layout, so RAF-after-toggle is unreliable.
        // ResizeObserver fires once the browser has real dimensions.
        // Self-disconnects after one valid measurement; ongoing
        // scroll/resize is handled by the window listeners below.
        // `ResizeObserver` is missing in some non-DOM jest environments
        // (e.g. post-office's `node` environment). Fall back to a no-op
        // observer there. The scroll/resize listeners below still keep
        // the popover positioned in the rare case the consumer also
        // polyfilled `showPopover` but not `ResizeObserver`. Real
        // browsers always have it. The `NoopResizeObserver` class is
        // hoisted to module scope (see top of file) so we do not allocate
        // a new constructor on every effect run.
        var ResizeObserverImpl = typeof ResizeObserver !== 'undefined' ? ResizeObserver : $63d21dea6f39d819$var$NoopResizeObserver;
        var resizeObserver = new ResizeObserverImpl(function() {
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                update();
                resizeObserver.disconnect();
            }
        });
        // If the popover is already open by the time this effect runs (for
        // example, the parent `useAnchorPosition` effect runs after the child
        // `Popover` effect that called `showPopover()`), the initial `toggle`
        // event has already fired and our listener below would miss it. Start
        // observing immediately so the first measurement still happens.
        if ($63d21dea6f39d819$var$isPopoverOpen(popover)) {
            hideUntilPositioned();
            resizeObserver.observe(popover);
        }
        var undoPositioning = (0, $3WiY0.combine)(cleanupBaseStyles, // Each open needs a fresh measurement, so hide and re-observe.
        (0, $7QpUe.bind)(popover, {
            type: 'toggle',
            listener: function listener(event) {
                var toggleEvent = event;
                if (toggleEvent.newState === 'open') {
                    hideUntilPositioned();
                    resizeObserver.observe(popover);
                }
            }
        }), function() {
            return resizeObserver.disconnect();
        }, (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: scheduledUpdate,
            options: {
                capture: true,
                passive: true
            }
        }), (0, $7QpUe.bind)(window, {
            type: 'resize',
            listener: scheduledUpdate,
            options: {
                passive: true
            }
        }), function() {
            scheduledUpdate.cancel();
            restorePosition();
            reveal();
        });
        return undoPositioning;
    }, [
        anchorRef,
        popoverRef,
        stablePlacement,
        forceFallbackPositioning,
        isEnabled,
        id,
        isOpen
    ]);
}

});
parcelRegister("2fwmU", function(module, exports) {
$parcel$export(module.exports, "computeFallbackPosition", () => $1a361733b29222bc$export$d5ef1dac02135664);

var $25nEq = parcelRequire("25nEq");
function $1a361733b29222bc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1a361733b29222bc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1a361733b29222bc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1a361733b29222bc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * JS fallback positioning math. Used only when the browser does not
 * support CSS Anchor Positioning (less than 6% of users).
 *
 * Consumer-supplied `offset.gap` and `offset.crossAxisShift` are
 * honored: the caller (`useAnchorPosition`) resolves CSS length strings
 * (tokens, calc, var, etc) to pixels via a DOM probe before passing them
 * in. The caller also keeps the popover hidden (`opacity: 0`) until the
 * first measurement completes, so the popover never paints at the wrong
 * position.
 */ /**
 * A viewport-relative position, in pixels. Physical rather than logical
 * because it is written straight to `top` / `left`.
 */ /**
 * The cross-axis shift with its length already resolved to pixels.
 *
 * Mirrors `TCrossAxisShiftOffset`, whose `value` is an unresolved CSS length
 * string. Only this module needs the pixel form, because only this module does
 * the arithmetic itself.
 */ /**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function $1a361733b29222bc$var$computeEdgePosition(_ref) {
    var axis = _ref.axis, edge = _ref.edge, triggerRect = _ref.triggerRect, popoverWidth = _ref.popoverWidth, popoverHeight = _ref.popoverHeight, viewport = _ref.viewport, gap = _ref.gap;
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        var spaceBelow = viewport.height - triggerRect.bottom;
        var spaceAbove = triggerRect.top;
        var fitsBelow = spaceBelow >= popoverHeight + gap;
        var useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        var _spaceAbove = triggerRect.top;
        var _spaceBelow = viewport.height - triggerRect.bottom;
        var fitsAbove = _spaceAbove >= popoverHeight + gap;
        var useAbove = fitsAbove || _spaceAbove >= _spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        var spaceRight = viewport.width - triggerRect.right;
        var spaceLeft = triggerRect.left;
        var fitsRight = spaceRight >= popoverWidth + gap;
        var useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        var _spaceLeft = triggerRect.left;
        var _spaceRight = viewport.width - triggerRect.right;
        var fitsLeft = _spaceLeft >= popoverWidth + gap;
        var useLeft = fitsLeft || _spaceLeft >= _spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function $1a361733b29222bc$var$applyAlignment(_ref2) {
    var position = _ref2.position, axis = _ref2.axis, align = _ref2.align, triggerRect = _ref2.triggerRect, popoverWidth = _ref2.popoverWidth, popoverHeight = _ref2.popoverHeight;
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return $1a361733b29222bc$var$_objectSpread($1a361733b29222bc$var$_objectSpread({}, position), {}, {
            left: triggerRect.left
        });
        // align === 'end'
        return $1a361733b29222bc$var$_objectSpread($1a361733b29222bc$var$_objectSpread({}, position), {}, {
            left: triggerRect.right - popoverWidth
        });
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return $1a361733b29222bc$var$_objectSpread($1a361733b29222bc$var$_objectSpread({}, position), {}, {
        top: triggerRect.top
    });
    // align === 'end'
    return $1a361733b29222bc$var$_objectSpread($1a361733b29222bc$var$_objectSpread({}, position), {}, {
        top: triggerRect.bottom - popoverHeight
    });
}
/**
 * Applies the cross-axis shift offset.
 *
 * `forwards` always moves the popover toward the cross-axis END and
 * `backwards` toward the START, for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 *
 * This is a coordinate, so the direction is the sign and nothing else. There
 * is deliberately no per-`align` sign inversion here: the CSS path inverts the
 * sign only because a margin on the END side pushes a box the opposite way to
 * a margin on the START side, which is a property of margins rather than of
 * the shift. Applying that inversion to a coordinate moved `align: 'end'`
 * popovers the wrong way.
 */ function $1a361733b29222bc$var$applyCrossAxisShift(_ref3) {
    var position = _ref3.position, axis = _ref3.axis, crossAxisShift = _ref3.crossAxisShift;
    if (crossAxisShift.value === 0) return position;
    var directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    var delta = crossAxisShift.value * directionSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return $1a361733b29222bc$var$_objectSpread($1a361733b29222bc$var$_objectSpread({}, position), {}, {
        left: position.left + delta
    });
    return $1a361733b29222bc$var$_objectSpread($1a361733b29222bc$var$_objectSpread({}, position), {}, {
        top: position.top + delta
    });
}
function $1a361733b29222bc$export$d5ef1dac02135664(_ref4) {
    var triggerRect = _ref4.triggerRect, popoverEl = _ref4.popoverEl, placement = _ref4.placement, viewport = _ref4.viewport, gap = _ref4.gap, crossAxisShift = _ref4.crossAxisShift;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    var popoverWidth = popoverEl.offsetWidth;
    var popoverHeight = popoverEl.offsetHeight;
    var basePosition = $1a361733b29222bc$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    var alignedPosition = $1a361733b29222bc$var$applyAlignment({
        position: basePosition,
        axis: axis,
        align: align,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    var shiftedPosition = $1a361733b29222bc$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        crossAxisShift: crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}

});

parcelRegister("3WiY0", function(module, exports) {
$parcel$export(module.exports, "combine", () => $2de5804f026f3efe$export$1be1fc439b849fdf);
/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $2de5804f026f3efe$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, cleanupFns = new Array(_len), _key = 0; _key < _len; _key++)cleanupFns[_key] = arguments[_key];
    return function cleanup() {
        cleanupFns.forEach(function(callback) {
            return callback === null || callback === void 0 ? void 0 : callback();
        });
    };
}

});

parcelRegister("eRQbi", function(module, exports) {
$parcel$export(module.exports, "placementToPositionArea", () => $ad2e7e0a59e52cee$export$de49b61f233ddeb9);

var $ci32B = parcelRequire("ci32B");
function $ad2e7e0a59e52cee$export$de49b61f233ddeb9(_ref) {
    var placement = _ref.placement;
    var _resolvePlacement = (0, $ci32B.resolvePlacement)({
        placement: placement
    }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge, align = _resolvePlacement.align;
    var edgeValue = "".concat(axis, "-").concat(edge);
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    var spanDir = align === 'start' ? 'end' : 'start';
    return "".concat(edgeValue, " span-").concat(crossAxis, "-").concat(spanDir);
}

});

parcelRegister("4IJcL", function(module, exports) {
$parcel$export(module.exports, "placementToTryFallbacks", () => $36fe563d287e74de$export$c4e16947a95d61f1);

var $ci32B = parcelRequire("ci32B");
/**
 * A `position-area` primary edge — the placement axis joined to its edge, e.g.
 * `block-end` or `inline-start`. These are the four edges a popover can sit on.
 */ function $36fe563d287e74de$var$slideOnEdge(_ref) {
    var align = _ref.align, edgeKey = _ref.edgeKey, crossAxis = _ref.crossAxis;
    if (align === 'center') return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-end"),
        "".concat(edgeKey, " span-").concat(crossAxis, "-start")
    ];
    // For `align: 'start'` the popover expands toward `end`, so the "near"
    // span is `end` and the "far" span is `start`; `align: 'end'` mirrors
    // this. The bare `edgeKey` (re-centered) sits between them.
    var near = align === 'start' ? 'end' : 'start';
    var far = align === 'start' ? 'start' : 'end';
    return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(near),
        edgeKey,
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(far)
    ];
}
function $36fe563d287e74de$var$flipDiagonally(_ref2) {
    var axis = _ref2.axis;
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    var flipToCrossAxis = axis === 'block' ? 'flip-inline' : 'flip-block';
    return "".concat(flipOnMainAxis, " ").concat(flipToCrossAxis);
}
function $36fe563d287e74de$export$c4e16947a95d61f1(_ref3) {
    var placement = _ref3.placement;
    /**
   * **Build the fallback list**
   *
   * Each entry is a complete alternative position.
   * The browser tries them _in order_ and uses the _first_ one that fits.
   */ var resolved = (0, $ci32B.resolvePlacement)({
        placement: placement
    });
    var axis = resolved.axis, edge = resolved.edge, align = resolved.align;
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    var flippedEdge = edge === 'start' ? 'end' : 'start';
    var sameEdgeArea = "".concat(axis, "-").concat(edge);
    var oppositeEdgeArea = "".concat(axis, "-").concat(flippedEdge);
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    /**
   * **Fallback algorithm**
   *
   * We have two things we can do to keep something visible:
   *
   * 1. _Slide_ along edges
   * 2. _Flip_ to another edge
   *
   * _Centered popover_
   *
   * Desired: Sits in middle of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge (centered)
   *  3: _Slide_ along opposite edge on the cross axis
   *
   * _Start or end aligned popover_
   *
   * Desired: Sits at start / end of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge
   *  3: _Flip_ on the diagonal (flip main axis + flip cross axis) into the
   *     opposite corner. For start / end alignment, this is the clean escape
   *     when the popover would otherwise land offscreen on both axes (ie in a
   *     corner). Rule 4 gets the job done, but a slide drops the gap
   *     as named position-area values don't carry margins).
   *     The diagonal flip keeps the gap and the alignment.
   *  4: _Slide_ along opposite edge on the cross axis
   */ return [
        $36fe563d287e74de$var$slideOnEdge({
            align: align,
            edgeKey: sameEdgeArea,
            crossAxis: crossAxis
        }),
        flipOnMainAxis,
        align !== 'center' ? $36fe563d287e74de$var$flipDiagonally({
            axis: axis
        }) : null,
        $36fe563d287e74de$var$slideOnEdge({
            align: align,
            edgeKey: oppositeEdgeArea,
            crossAxis: crossAxis
        })
    ].filter(Boolean).flat().join(', ');
}

});

parcelRegister("hcFCx", function(module, exports) {
$parcel$export(module.exports, "resolveCssLengthToPixels", () => $c863d7a28f2983fa$export$98721546d2816d9e);
var $c863d7a28f2983fa$var$elementCaches = new WeakMap();
function $c863d7a28f2983fa$var$canCacheResolvedLength(value) {
    // Custom-property values can be retargeted by inline overrides on the
    // consumer's wrapper, so we cannot prove a cached pixel value is still valid.
    return !value.includes('var(');
}
function $c863d7a28f2983fa$var$getCachedResolvedLength(_ref) {
    var _cacheForElement$get;
    var element = _ref.element, value = _ref.value;
    if (!$c863d7a28f2983fa$var$canCacheResolvedLength(value)) return null;
    var cacheForElement = $c863d7a28f2983fa$var$elementCaches.get(element);
    return (_cacheForElement$get = cacheForElement === null || cacheForElement === void 0 ? void 0 : cacheForElement.get(value)) !== null && _cacheForElement$get !== void 0 ? _cacheForElement$get : null;
}
function $c863d7a28f2983fa$var$cacheResolvedLength(_ref2) {
    var _elementCaches$get;
    var element = _ref2.element, value = _ref2.value, result = _ref2.result;
    if (!$c863d7a28f2983fa$var$canCacheResolvedLength(value)) return;
    var cacheForElement = (_elementCaches$get = $c863d7a28f2983fa$var$elementCaches.get(element)) !== null && _elementCaches$get !== void 0 ? _elementCaches$get : new Map();
    cacheForElement.set(value, result);
    $c863d7a28f2983fa$var$elementCaches.set(element, cacheForElement);
}
function $c863d7a28f2983fa$export$98721546d2816d9e(_ref3) {
    var value = _ref3.value, container = _ref3.container;
    if (typeof value === 'number') return value;
    // Fast path: unitless zero is universally zero pixels - accept `'0'` and
    // `'-0'` without a probe. (Consumers occasionally pass `'0'` instead of
    // the number `0`.)
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from the consumer normalisation
    // in `resolvePlacement`. Avoid a reflow when we can.
    var pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    var cached = $c863d7a28f2983fa$var$getCachedResolvedLength({
        element: container,
        value: value
    });
    if (cached !== null) return cached;
    var probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hide the probe from assistive tech and event targeting; defensive
    // against `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    container.appendChild(probe);
    var resolved = parseFloat(getComputedStyle(probe).marginLeft);
    container.removeChild(probe);
    var result = Number.isFinite(resolved) ? resolved : 0;
    $c863d7a28f2983fa$var$cacheResolvedLength({
        element: container,
        value: value,
        result: result
    });
    return result;
}

});

parcelRegister("b1W5A", function(module, exports) {
$parcel$export(module.exports, "setStyle", () => $807cd902c97ff796$export$37a5fde709c1db82);
/**
 * A single inline style declaration.
 *
 * `TProperty` narrows the property name for callers that write a known, closed
 * set of properties. Narrowing it lets a record keyed on those same names be
 * checked for exhaustiveness at compile time, rather than silently resolving to
 * `undefined` for a name that was never mapped.
 */ /**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 */ function $807cd902c97ff796$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

});


parcelRegister("iGKpq", function(module, exports) {
$parcel$export(module.exports, "useWidthFromAnchor", () => $d9b02623d3e32ce4$export$7071d791a7b131ed);

var $5FkrB = parcelRequire("5FkrB");

var $bvsoE = parcelRequire("bvsoE");

var $b1W5A = parcelRequire("b1W5A");
/**
 * Probes anchor SIZING, separately from `anchor-name` (see
 * `supportsAnchorPositioning`): some browsers have positioning but not sizing.
 * `once()` for SSR safety.
 */ var $d9b02623d3e32ce4$var$supportsAnchorSize = (0, $bvsoE.default)(function() {
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('min-inline-size', 'anchor-size(self-inline)');
});
/**
 * The JS fallback's stand-in for `anchor-size(self-inline)`. `offsetWidth` / `offsetHeight` are
 * physical, so the axis is picked from the popover's `writing-mode`. Anything not horizontal is
 * treated as vertical, and an unknown or empty value falls back to `offsetWidth`.
 */ function $d9b02623d3e32ce4$var$getFallbackAnchorInlineSize(_ref) {
    var anchor = _ref.anchor, popover = _ref.popover;
    // `String()` because not every test environment implements `writing-mode`.
    var writingMode = String(getComputedStyle(popover).writingMode);
    var isVertical = writingMode.startsWith('vertical') || writingMode.startsWith('sideways');
    return isVertical ? anchor.offsetHeight : anchor.offsetWidth;
}
function $d9b02623d3e32ce4$export$7071d791a7b131ed(_ref2) {
    var mode = _ref2.mode, popoverRef = _ref2.popoverRef, anchorRef = _ref2.anchorRef, isOpen = _ref2.isOpen;
    (0, $5FkrB.useLayoutEffect)(function() {
        var node = popoverRef.current;
        if (!node) return;
        if (mode === 'match-anchor') {
            // No floor here: it would let the popover grow past the anchor.
            if ($d9b02623d3e32ce4$var$supportsAnchorSize()) return (0, $b1W5A.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'inline-size',
                        value: 'anchor-size(self-inline)'
                    }
                ]
            });
            var anchor = anchorRef.current;
            if (anchor) return (0, $b1W5A.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'inline-size',
                        value: "".concat($d9b02623d3e32ce4$var$getFallbackAnchorInlineSize({
                            anchor: anchor,
                            popover: node
                        }), "px")
                    }
                ]
            });
            return;
        }
        if (mode === 'min-anchor') {
            // One floor only. The content floor from mode 'none' deliberately does not also apply
            // here, and cannot: it would need this same property. See the decision note.
            if ($d9b02623d3e32ce4$var$supportsAnchorSize()) return (0, $b1W5A.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'min-inline-size',
                        value: 'anchor-size(self-inline)'
                    }
                ]
            });
            var _anchor = anchorRef.current;
            if (_anchor) return (0, $b1W5A.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'min-inline-size',
                        value: "".concat($d9b02623d3e32ce4$var$getFallbackAnchorInlineSize({
                            anchor: _anchor,
                            popover: node
                        }), "px")
                    }
                ]
            });
            // Nothing to measure, so no floor.
            return;
        }
        // Makes a too-narrow span overflow and drive `position-try-fallbacks` instead of wrapping.
        // `@atlaskit/popper` resets this exact property to `0` for its fit-to-viewport mode.
        return (0, $b1W5A.setStyle)({
            element: node,
            styles: [
                {
                    property: 'min-inline-size',
                    value: 'max-content'
                }
            ]
        });
    }, [
        mode,
        popoverRef,
        anchorRef,
        isOpen
    ]);
}

});

parcelRegister("k28lc", function(module, exports) {
$parcel$export(module.exports, "MenuPortalCloseContext", () => $e95a76de5d17b3c6$export$a0d5b29fa9affc38);

var $5FkrB = parcelRequire("5FkrB");
var $e95a76de5d17b3c6$export$a0d5b29fa9affc38 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);

});



parcelRegister("h90T7", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7b3f743fab61d91$export$2e2bcd8739ae039);
/* multi-value.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $25nEq = parcelRequire("25nEq");

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $cSMlO = parcelRequire("cSMlO");

var $2goCw = parcelRequire("2goCw");

var $lhPnS = parcelRequire("lhPnS");

var $5rHW6 = parcelRequire("5rHW6");

var $6Uwhr = parcelRequire("6Uwhr");

var $9iDGZ = parcelRequire("9iDGZ");

var $1VviI = parcelRequire("1VviI");
function $c7b3f743fab61d91$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c7b3f743fab61d91$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c7b3f743fab61d91$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c7b3f743fab61d91$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c7b3f743fab61d91$var$multiValueTagWrapperStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1mouze3t _195gze3t _4cvr1h6o _1e0c1txw _1ul9ze3t _zdxokb7n _v5ynkb7n _13lsf1ug _3pxh1h6o _d0dz1txw _1ouwze3t"
};
var $c7b3f743fab61d91$var$multiValueMotionStyles = {
    active: "_1reo15vq _18m915vq _8hrz1e5h",
    entering: "_y44v1ukz _1bumglyw",
    exiting: "_y44v12ef _1bumglyw"
};
// Tag-like color styles
var $c7b3f743fab61d91$var$tagLikeColorStyles = {
    gray: "_119bmsup",
    blue: "_119b18hp",
    green: "_119b5d2u",
    red: "_119bn9dc",
    yellow: "_119b1s7j",
    purple: "_119bluwt",
    lime: "_119b1m7d",
    magenta: "_119b132u",
    orange: "_119b1ip5",
    teal: "_119b131p"
};
var $c7b3f743fab61d91$var$tagLikeBorderFilterStyles = null;
// Tag-like styles for custom content values (not plain text) when FF is on.
// Mirrors the TagNew component's visual appearance (padding, margins, sizing, colors).
// The container uses tag-like styling while Label/Remove sub-components are preserved
// so custom overrides (e.g. custom aria-labels, rendering objects as data) continue to work.
var $c7b3f743fab61d91$var$multiValueTagLikeStyles = {
    root: "_1reo15vq _18m915vq _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1mouze3t _195gze3t _1e0c116y _vchhusvi _kqswh2mm _4cvr1h6o _1wpz1h6o _1ul9ze3t _1o9zkb7n _p12ff6dh _4t3i1k92 _bfhksm61 _syazi7uo _80om73ad _3yq3glyw",
    labelWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _11c8wadc _1e0c1txw _4cvr1h6o _1ul9ze3t _1tkeidpf _2a9v1kw7",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk1dpa _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
var $c7b3f743fab61d91$var$getMultiValueLabelText = function getMultiValueLabelText(children, data) {
    if (typeof children === 'string') return children;
    var label = data === null || data === void 0 ? void 0 : data.label;
    return typeof label === 'string' ? label : '';
};
var $c7b3f743fab61d91$var$MultiValueContent = function MultiValueContent(contentProps) {
    var props = contentProps.multiValueProps, motionRef = contentProps.motionRef, motionState = contentProps.motionState;
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, isFocused = props.isFocused, removeProps = props.removeProps, selectProps = props.selectProps, cropWithEllipsis = props.cropWithEllipsis;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    var labelText = $c7b3f743fab61d91$var$getMultiValueLabelText(children, data);
    var isPlainLabel = typeof children === 'string';
    var ffTagUplifts = (0, $2goCw.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    var isEnteringWithMotion = motionState === 'entering';
    var isExitingWithMotion = motionState === 'exiting';
    var _getStyleProps = (0, $5rHW6.getStyleProps)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    }), containerCss = _getStyleProps.css, containerClassName = _getStyleProps.className;
    var _getStyleProps2 = (0, $5rHW6.getStyleProps)(props, 'multiValueLabel', {
        'multi-value__label': true
    }), labelCss = _getStyleProps2.css, labelClassName = _getStyleProps2.className;
    var _getStyleProps3 = (0, $5rHW6.getStyleProps)(props, 'multiValueRemove', {
        'multi-value__remove': true
    }), removeCss = _getStyleProps3.css, removeClassName = _getStyleProps3.className;
    var hasCustomLabel = Label !== (0, $1VviI.MultiValueLabel);
    var hasCustomContainer = Container !== (0, $9iDGZ.MultiValueContainer);
    var selectStyles = selectProps.styles;
    var hasCustomMultiValueStyles = Boolean((selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValue) || (selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValueLabel) || (selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValueRemove));
    var selectClassNames = selectProps.classNames;
    var hasCustomMultiValueClassNames = Boolean((selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValue) || (selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValueLabel) || (selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValueRemove));
    // Detect if getStyles was overridden directly on this component instance (e.g. via the
    // components prop wrapper passing a custom getStyles). The context holds the original
    // Select instance's getStyles — a reference inequality means a custom override was passed.
    // When context is absent (e.g. in mocked/test contexts), assume no override.
    var selectGetStyles = (0, $6Uwhr.useSelectGetStyles)();
    var hasOverriddenGetStyles = selectGetStyles !== undefined && props.getStyles !== selectGetStyles;
    var hasCustomContainerStyles = hasCustomMultiValueStyles || hasCustomMultiValueClassNames || hasOverriddenGetStyles;
    if (ffTagUplifts && isPlainLabel && !hasCustomLabel && !hasCustomContainer && !hasCustomContainerStyles) {
        var _ref = data !== null && data !== void 0 ? data : {}, elemBefore = _ref.elemBefore, tagColor = _ref.color;
        return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
            ref: motionRef,
            className: (0, $970q7.default)([
                $c7b3f743fab61d91$var$multiValueTagWrapperStyles.root,
                isExitingWithMotion && $c7b3f743fab61d91$var$multiValueMotionStyles.active,
                isExitingWithMotion && $c7b3f743fab61d91$var$multiValueMotionStyles.exiting,
                (0, $hUFig.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ])
        }), /*#__PURE__*/ $5FkrB.createElement((0, $lhPnS.default), {
            text: labelText,
            isRemovable: !isDisabled,
            removeButtonLabel: "".concat(labelText, ", remove"),
            onBeforeRemoveAction: function onBeforeRemoveAction() {
                var _removeProps$onClick;
                (_removeProps$onClick = removeProps.onClick) === null || _removeProps$onClick === void 0 || _removeProps$onClick.call(removeProps, {});
                return false;
            },
            color: tagColor !== null && tagColor !== void 0 ? tagColor : 'gray',
            elemBefore: elemBefore,
            hasMargin: false
        }));
    }
    // FF on + custom content → tag-like path
    if (ffTagUplifts && !hasCustomContainer) {
        var colorKey = data === null || data === void 0 ? void 0 : data.color;
        return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            "data-multi-value-tag-like": "true"
        }, innerProps, {
            ref: motionRef,
            style: containerCss,
            className: (0, $970q7.default)([
                $c7b3f743fab61d91$var$multiValueTagLikeStyles.root,
                $c7b3f743fab61d91$var$tagLikeColorStyles.gray,
                colorKey === 'blue' && $c7b3f743fab61d91$var$tagLikeColorStyles.blue,
                colorKey === 'green' && $c7b3f743fab61d91$var$tagLikeColorStyles.green,
                colorKey === 'red' && $c7b3f743fab61d91$var$tagLikeColorStyles.red,
                colorKey === 'yellow' && $c7b3f743fab61d91$var$tagLikeColorStyles.yellow,
                colorKey === 'purple' && $c7b3f743fab61d91$var$tagLikeColorStyles.purple,
                colorKey === 'lime' && $c7b3f743fab61d91$var$tagLikeColorStyles.lime,
                colorKey === 'magenta' && $c7b3f743fab61d91$var$tagLikeColorStyles.magenta,
                colorKey === 'orange' && $c7b3f743fab61d91$var$tagLikeColorStyles.orange,
                colorKey === 'teal' && $c7b3f743fab61d91$var$tagLikeColorStyles.teal,
                "_1h6dip4g",
                isDisabled && $c7b3f743fab61d91$var$multiValueTagLikeStyles.disabled,
                isFocused && $c7b3f743fab61d91$var$multiValueTagLikeStyles.focused,
                (isEnteringWithMotion || isExitingWithMotion) && $c7b3f743fab61d91$var$multiValueMotionStyles.active,
                isEnteringWithMotion && $c7b3f743fab61d91$var$multiValueMotionStyles.entering,
                isExitingWithMotion && $c7b3f743fab61d91$var$multiValueMotionStyles.exiting,
                (0, $hUFig.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ])
        }), /*#__PURE__*/ $5FkrB.createElement("div", {
            className: (0, $970q7.default)([
                $c7b3f743fab61d91$var$multiValueTagLikeStyles.labelWrapper
            ])
        }, /*#__PURE__*/ $5FkrB.createElement(Label, {
            data: data,
            innerProps: {
                style: labelCss,
                className: labelClassName
            },
            className: labelClassName,
            hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
            selectProps: selectProps
        }, children)), /*#__PURE__*/ $5FkrB.createElement(Remove, {
            data: data,
            innerProps: $c7b3f743fab61d91$var$_objectSpread({
                style: removeCss,
                className: removeClassName,
                role: 'button',
                tabIndex: -1,
                'aria-label': "".concat(labelText || 'option', ", remove")
            }, removeProps),
            className: removeClassName,
            isDisabled: isDisabled,
            selectProps: selectProps
        }));
    }
    // FF off → default styles
    return /*#__PURE__*/ $5FkrB.createElement(Container, {
        data: data,
        innerProps: $c7b3f743fab61d91$var$_objectSpread({
            style: containerCss,
            className: containerClassName
        }, innerProps),
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps
    }, /*#__PURE__*/ $5FkrB.createElement(Label, {
        data: data,
        innerProps: {
            style: labelCss,
            className: labelClassName
        },
        className: labelClassName,
        hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
        selectProps: selectProps
    }, children), /*#__PURE__*/ $5FkrB.createElement(Remove, {
        data: data,
        innerProps: $c7b3f743fab61d91$var$_objectSpread({
            style: removeCss,
            className: removeClassName,
            role: 'button',
            tabIndex: -1,
            'aria-label': "".concat(labelText || 'option', ", remove")
        }, removeProps),
        className: removeClassName,
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var $c7b3f743fab61d91$var$MotionMultiValue = function MotionMultiValue(props) {
    var multiValueProps = props.multiValueProps;
    var _useMotion = (0, $cSMlO.useMotion)({
        onFinish: function onFinish(motionState) {
            if (motionState === 'exiting') {
                var _multiValueProps$onMo;
                (_multiValueProps$onMo = multiValueProps.onMotionFinish) === null || _multiValueProps$onMo === void 0 || _multiValueProps$onMo.call(multiValueProps);
            }
        }
    }), ref = _useMotion.ref, state = _useMotion.state;
    return /*#__PURE__*/ $5FkrB.createElement($c7b3f743fab61d91$var$MultiValueContent, {
        multiValueProps: multiValueProps,
        motionRef: ref,
        motionState: state
    });
};
var $c7b3f743fab61d91$var$MultiValue = function MultiValue(props) {
    if (props.isMotionEnabled) return /*#__PURE__*/ $5FkrB.createElement($c7b3f743fab61d91$var$MotionMultiValue, {
        multiValueProps: props
    });
    return /*#__PURE__*/ $5FkrB.createElement($c7b3f743fab61d91$var$MultiValueContent, {
        multiValueProps: props
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c7b3f743fab61d91$export$2e2bcd8739ae039 = $c7b3f743fab61d91$var$MultiValue;

});
parcelRegister("cSMlO", function(module, exports) {
$parcel$export(module.exports, "useMotion", () => $961008a4fac8ed44$export$2a51cfe9390d36ef);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $iO8GM = parcelRequire("iO8GM");

var $7bESH = parcelRequire("7bESH");

var $fAhUI = parcelRequire("fAhUI");

var $ZBv4y = parcelRequire("ZBv4y");

var $5p97I = parcelRequire("5p97I");

var $ihEP3 = parcelRequire("ihEP3");

var $3woLB = parcelRequire("3woLB");

var $1YIzH = parcelRequire("1YIzH");
function $961008a4fac8ed44$export$2a51cfe9390d36ef() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, onFinishMotion = _ref.onFinish, initialState = _ref.initialState;
    var reducedMotion = (0, $ZBv4y.isReducedMotion)();
    var staggered = (0, $1YIzH.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $3woLB.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var staggeredDelay = isExiting ? 0 : staggered.delay;
    var staggeredIsReady = staggered.isReady;
    var _useState = (0, $5FkrB.useState)(initialState !== null && initialState !== void 0 ? initialState : appear ? staggeredIsReady && !staggeredDelay ? 'entering' : 'init' : 'visible'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var elementRef = (0, $5FkrB.useRef)(null);
    var reanimateRef = (0, $5FkrB.useRef)();
    var animationRef = (0, $5FkrB.useRef)();
    var staggeredEntryRef = (0, $5FkrB.useRef)();
    (0, $5FkrB.useEffect)(function() {
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ var onAnimationEnd = (0, $5FkrB.useCallback)(function(currentState, cancelled) {
        // We are done animating, so we set the state to visible
        var newState = 'visible';
        if (currentState === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('exiting');
        }
        if (currentState === 'entering') onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('entering');
        if (reanimateRef.current === (0, $ihEP3.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $ihEP3.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current === (0, $ihEP3.Reanimate).enter) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        else if (reanimateRef.current === (0, $ihEP3.Reanimate).exit) {
            // We are done reanimating, so we clear the reanimate state
            reanimateRef.current = undefined;
            newState = 'hidden';
        }
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    // Handles staggered entry
    (0, $5FkrB.useEffect)(function() {
        if (state !== 'init') return;
        if (reducedMotion) {
            onAnimationEnd('entering', false);
            return;
        }
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(function() {
            setState('entering');
        }, staggeredDelay);
        return function() {
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        onAnimationEnd,
        state,
        staggeredIsReady,
        staggeredDelay,
        reducedMotion
    ]);
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (!staggeredIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is visible, hidden or init, we don't need to do anything
        if (state === 'visible' || state === 'init' || state === 'hidden') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if (reducedMotion) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        var animationDuration = 0;
        if (state === 'entering' || state === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    var animationTimings = (0, $fAhUI.getDurationMs)((0, $5p97I.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    var computedStyles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $7bESH.getComputedAnimationDurationMs)(computedStyles.animationName, computedStyles.animationDuration, computedStyles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting') animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration);
        else if (state === 'entering') animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration);
        return function() {
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        appear,
        staggeredDelay,
        staggeredIsReady,
        reducedMotion
    ]);
    var reanimate = (0, $5FkrB.useCallback)(function(value) {
        animationRef.current && clearTimeout(animationRef.current);
        reanimateRef.current = value;
        if (value === (0, $ihEP3.Reanimate).exit_then_enter) setState('exiting');
        else if (value === (0, $ihEP3.Reanimate).enter) setState('entering');
        else if (value === (0, $ihEP3.Reanimate).exit) setState('exiting');
    }, []);
    var ref = (0, $iO8GM.default)([
        staggered.ref,
        elementRef
    ]);
    return {
        ref: ref,
        reanimate: reanimate,
        state: state
    };
}

});
parcelRegister("7bESH", function(module, exports) {
$parcel$export(module.exports, "getComputedAnimationDurationMs", () => $53b945a5302aa6d8$export$dd9b73a7482d05b6);

var $gI7oZ = parcelRequire("gI7oZ");
var $53b945a5302aa6d8$var$cssTimePattern = /^-?(?:\d+\.?\d*|\.\d+)(?:ms|s)$/;
var $53b945a5302aa6d8$var$toCssList = function toCssList(value) {
    return value.split(',').map(function(item) {
        return item.trim();
    }).filter(Boolean);
};
var $53b945a5302aa6d8$var$toTimeList = function toTimeList(value) {
    return $53b945a5302aa6d8$var$toCssList(value).filter(function(time) {
        return $53b945a5302aa6d8$var$cssTimePattern.test(time);
    }).map((0, $gI7oZ.convertToMs));
};
var $53b945a5302aa6d8$export$dd9b73a7482d05b6 = function getComputedAnimationDurationMs(animationName, animationDuration, animationDelay) {
    var names = $53b945a5302aa6d8$var$toCssList(animationName);
    var durations = $53b945a5302aa6d8$var$toTimeList(animationDuration);
    var delays = $53b945a5302aa6d8$var$toTimeList(animationDelay);
    if (names.length === 0 || durations.length === 0) return 0;
    var longestDuration = 0;
    for(var index = 0; index < names.length; index++){
        if (names[index] === 'none') continue;
        var duration = durations[index % durations.length];
        var delay = delays.length > 0 ? delays[index % delays.length] : 0;
        longestDuration = Math.max(longestDuration, duration + delay);
    }
    return longestDuration;
};

});
parcelRegister("gI7oZ", function(module, exports) {
$parcel$export(module.exports, "convertToMs", () => $c2a67f521d8b5dd8$export$75eee42ff540d8ae);
var $c2a67f521d8b5dd8$export$75eee42ff540d8ae = function convertToMs(duration) {
    // Use regex to separate the number and the unit
    var matches = duration.match(/^(-?(?:\d+\.?\d*|\.\d+))(s|ms)$/);
    if (!matches) return 0; // Or return for invalid format
    var value = parseFloat(matches[1]);
    var unit = matches[2];
    if (unit === 's') return value * 1000; // Convert seconds to milliseconds
    else return value; // Already in milliseconds
};

});


parcelRegister("fAhUI", function(module, exports) {
$parcel$export(module.exports, "getDurationMs", () => $b5881d1d72044cf9$export$d0038b6e47881463);

var $fC8ib = parcelRequire("fC8ib");
var $b5881d1d72044cf9$export$d0038b6e47881463 = function getDurationMs(animation) {
    var animations = animation.split(/,(?![^()]*\))/).map(function(value) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(value.trim().matchAll(/(-?\d*\.?\d+)(ms|s)\b/g));
    }).filter(function(matches) {
        return matches.length > 0;
    });
    if (animations.length === 0) return {
        duration: 0,
        delay: 0
    };
    return animations.reduce(function(longest, matches) {
        var toMilliseconds = function toMilliseconds(match) {
            var value = parseFloat(match[1]);
            return match[2] === 's' ? value * 1000 : value;
        };
        var timing = {
            duration: toMilliseconds(matches[0]),
            delay: matches[1] ? toMilliseconds(matches[1]) : 0
        };
        return timing.duration + timing.delay > longest.duration + longest.delay ? timing : longest;
    }, {
        duration: 0,
        delay: 0
    });
};

});

parcelRegister("ZBv4y", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $0b92c95f58714ab9$export$b7baf7667a68d87c);

var $3NXiM = parcelRequire("3NXiM");
var $0b92c95f58714ab9$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!(0, $3NXiM.isMatchMediaAvailable)()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};

});
parcelRegister("3NXiM", function(module, exports) {
$parcel$export(module.exports, "isMatchMediaAvailable", () => $2c53f2d5236a0739$export$c5406bd59b374abd);
var $2c53f2d5236a0739$export$c5406bd59b374abd = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};

});


parcelRegister("5p97I", function(module, exports) {
$parcel$export(module.exports, "resolveMotionToken", () => $3ef65d4153125262$export$82b92541889a035d);

var $lFhdZ = parcelRequire("lFhdZ");
var $3ef65d4153125262$export$82b92541889a035d = function resolveMotionToken(token) {
    var cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    var cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        var _getDocument;
        var documentElement = (_getDocument = (0, $lFhdZ.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};

});

parcelRegister("ihEP3", function(module, exports) {
$parcel$export(module.exports, "Reanimate", () => $d4f97affabda7aaa$export$569340a66b14e0dc);
/**
 * Supported reanimate values.
 * 'enter' will re-enter the animation.
 * 'exit-then-enter' will exit the animation and then enter it again.
 */ var $d4f97affabda7aaa$export$569340a66b14e0dc = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    Reanimate["exit"] = "exit";
    return Reanimate;
}({});

});

parcelRegister("3woLB", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $290792675e57d901$export$3b6f38abbdcbd000);

var $5FkrB = parcelRequire("5FkrB");

var $Ew39N = parcelRequire("Ew39N");
var $290792675e57d901$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)((0, $Ew39N.ExitingContext));
};

});

parcelRegister("1YIzH", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $170df8a910162468$export$25c7213fc07ec080);

var $5FkrB = parcelRequire("5FkrB");

var $9zRZC = parcelRequire("9zRZC");

var $bfPbo = parcelRequire("bfPbo");
var $170df8a910162468$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var identifier = (0, $9zRZC.useUniqueId)();
    var context = (0, $5FkrB.useContext)((0, $bfPbo.StaggeredEntranceContext));
    return context(identifier);
};

});
parcelRegister("9zRZC", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $6f9143ce49c395a7$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $6f9143ce49c395a7$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});

parcelRegister("bfPbo", function(module, exports) {
$parcel$export(module.exports, "StaggeredEntranceContext", () => $8318cc3eaba48c89$export$5e65d7d58ae96ad8);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");

var $gooFO = parcelRequire("gooFO");
var $8318cc3eaba48c89$export$5e65d7d58ae96ad8 = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $eVb4V.default)
    };
});
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $8318cc3eaba48c89$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $gooFO.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($8318cc3eaba48c89$export$5e65d7d58ae96ad8.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$8318cc3eaba48c89$export$2e2bcd8739ae039 = $8318cc3eaba48c89$var$StaggeredEntrance;

});
parcelRegister("gooFO", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $bef206e0a4e40cfb$export$e5c5a5f917a5871c);

var $5FkrB = parcelRequire("5FkrB");
var $bef206e0a4e40cfb$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);

});




parcelRegister("lhPnS", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7f30b4d24b41fb0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $25nEq = parcelRequire("25nEq");

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $kMTjB = parcelRequire("kMTjB");

var $iO8GM = parcelRequire("iO8GM");

var $eVb4V = parcelRequire("eVb4V");

var $5supy = parcelRequire("5supy");

var $Ew39N = parcelRequire("Ew39N");
var $dqo70 = parcelRequire("dqo70");

var $kkvYm = parcelRequire("kkvYm");

var $41QTh = parcelRequire("41QTh");

var $h2ToJ = parcelRequire("h2ToJ");

var $fRgWa = parcelRequire("fRgWa");

var $chQYe = parcelRequire("chQYe");

var $dENoG = parcelRequire("dENoG");

var $ldwMZ = parcelRequire("ldwMZ");

var $hxdc0 = parcelRequire("hxdc0");

var $87KeV = parcelRequire("87KeV");

var $4VJDZ = parcelRequire("4VJDZ");
var $f7f30b4d24b41fb0$var$_excluded = [
    "appearance",
    "elemBefore",
    "isRemovable",
    "text",
    "color",
    "href",
    "removeButtonLabel",
    "testId",
    "onBeforeRemoveAction",
    "onAfterRemoveAction",
    "linkComponent",
    "migration_fallback",
    "maxWidth",
    "hasMargin",
    "swatchBefore",
    "swatchBeforeLabel",
    "swatchBeforeRole"
];
var $f7f30b4d24b41fb0$var$textLinkCssVar = '--ds-ctl';
var $f7f30b4d24b41fb0$var$textDefaultCssVar = '--ds-ct';
var $f7f30b4d24b41fb0$var$textActiveCssVar = '--ds-ctp';
var $f7f30b4d24b41fb0$var$backgroundHoverCssVar = '--ds-cbh';
var $f7f30b4d24b41fb0$var$backgroundActiveCssVar = '--ds-cba';
var $f7f30b4d24b41fb0$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($f7f30b4d24b41fb0$var$TagStatus || {});
var $f7f30b4d24b41fb0$var$packageName = "@atlaskit/tag";
var $f7f30b4d24b41fb0$var$packageVersion = "15.7.2";
var $f7f30b4d24b41fb0$var$defaultBeforeRemoveAction = function defaultBeforeRemoveAction() {
    return true;
};
/**
 * These hide the focus ring for the tag when its remove button is focused,
 * preventing a double focus ring.
 */ var $f7f30b4d24b41fb0$var$removingStyles = null;
var $f7f30b4d24b41fb0$var$RemovableTagComponent = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var appearance = _ref.appearance, _ref$elemBefore = _ref.elemBefore, elemBefore = _ref$elemBefore === void 0 ? null : _ref$elemBefore, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? '' : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, removeButtonLabel = _ref.removeButtonLabel, testId = _ref.testId, _ref$onBeforeRemoveAc = _ref.onBeforeRemoveAction, onBeforeRemoveAction = _ref$onBeforeRemoveAc === void 0 ? $f7f30b4d24b41fb0$var$defaultBeforeRemoveAction : _ref$onBeforeRemoveAc, _ref$onAfterRemoveAct = _ref.onAfterRemoveAction, onAfterRemoveAction = _ref$onAfterRemoveAct === void 0 ? (0, $eVb4V.default) : _ref$onAfterRemoveAct, linkComponent = _ref.linkComponent, migration_fallback = _ref.migration_fallback, maxWidth = _ref.maxWidth, _ref$hasMargin = _ref.hasMargin, hasMargin = _ref$hasMargin === void 0 ? true : _ref$hasMargin, swatchBefore = _ref.swatchBefore, swatchBeforeLabel = _ref.swatchBeforeLabel, swatchBeforeRole = _ref.swatchBeforeRole, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $f7f30b4d24b41fb0$var$_excluded);
    var _useState = (0, $5FkrB.useState)($f7f30b4d24b41fb0$var$TagStatus.Showing), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), isHoverCloseButton = _useState4[0], setIsHoverCloseButton = _useState4[1];
    var normalizedText = (0, $h2ToJ.getTagText)(text);
    var onAfterRemoveActionWithAnalytics = (0, $kMTjB.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $f7f30b4d24b41fb0$var$packageName,
            packageVersion: $f7f30b4d24b41fb0$var$packageVersion
        }
    }, 'atlaskit');
    var handleRemoveComplete = (0, $5FkrB.useCallback)(function() {
        setStatus($f7f30b4d24b41fb0$var$TagStatus.Removed);
    }, []);
    var handleRemoveRequest = (0, $5FkrB.useCallback)(function() {
        if (onBeforeRemoveAction && onBeforeRemoveAction()) {
            onAfterRemoveActionWithAnalytics(normalizedText);
            handleRemoveComplete();
        }
    }, [
        handleRemoveComplete,
        normalizedText,
        onBeforeRemoveAction,
        onAfterRemoveActionWithAnalytics
    ]);
    var onKeyPress = (0, $5FkrB.useCallback)(function(e) {
        var spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    var removingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus($f7f30b4d24b41fb0$var$TagStatus.Removing);
    }, []);
    var showingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus($f7f30b4d24b41fb0$var$TagStatus.Showing);
    }, []);
    var handleMouseOver = (0, $5FkrB.useCallback)(function() {
        return setIsHoverCloseButton(true);
    }, []);
    var handleMouseOut = (0, $5FkrB.useCallback)(function() {
        return setIsHoverCloseButton(false);
    }, []);
    var removeButton = isRemovable ? /*#__PURE__*/ $5FkrB.createElement((0, $4VJDZ.default), {
        "aria-label": "".concat(removeButtonLabel || 'Remove', " ").concat(normalizedText),
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: "close-button-".concat(testId)
    }) : undefined;
    // Handle migration_fallback: render Lozenge when flag is off and migration_fallback is 'lozenge'
    if (migration_fallback === 'lozenge' && !(0, $kkvYm.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        var lozengeAppearance = (0, $hxdc0.getLozengeAppearance)(color);
        return /*#__PURE__*/ $5FkrB.createElement((0, $5supy.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            appearance: lozengeAppearance,
            isBold: false,
            testId: testId
        }, rest), normalizedText);
    }
    // Use new TagNew component behind feature flag
    // TagNew handles its own animation internally via RemovableWrapper
    if ((0, $kkvYm.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        var newColor = (0, $41QTh.colorMapping)[color || 'standard'];
        return /*#__PURE__*/ $5FkrB.createElement((0, $fRgWa.default), {
            ref: ref,
            color: newColor,
            text: normalizedText,
            elemBefore: elemBefore,
            href: href,
            testId: testId,
            isRemovable: isRemovable,
            removeButtonLabel: removeButtonLabel,
            onBeforeRemoveAction: onBeforeRemoveAction,
            onAfterRemoveAction: onAfterRemoveActionWithAnalytics,
            maxWidth: maxWidth,
            hasMargin: hasMargin,
            swatchBefore: swatchBefore,
            swatchBeforeLabel: swatchBeforeLabel,
            swatchBeforeRole: swatchBeforeRole
        });
    }
    // Original implementation
    var content = /*#__PURE__*/ $5FkrB.createElement((0, $87KeV.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: normalizedText,
        color: color,
        href: href,
        linkComponent: linkComponent,
        testId: testId
    });
    var hoverCloseButtonColors = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
    }, $f7f30b4d24b41fb0$var$backgroundHoverCssVar, undefined), $f7f30b4d24b41fb0$var$backgroundActiveCssVar, undefined), $f7f30b4d24b41fb0$var$textDefaultCssVar, undefined), $f7f30b4d24b41fb0$var$textActiveCssVar, undefined), $f7f30b4d24b41fb0$var$textLinkCssVar, undefined);
    return /*#__PURE__*/ $5FkrB.createElement((0, $Ew39N.default), null, !(status === $f7f30b4d24b41fb0$var$TagStatus.Removed) && /*#__PURE__*/ $5FkrB.createElement((0, $dqo70.default), {
        key: "atlaskit-removable-tag-legacy-shrink-out",
        onFinish: handleRemoveComplete
    }, function(motion) {
        return /*#__PURE__*/ $5FkrB.createElement((0, $dENoG.default), {
            ref: (0, $iO8GM.default)([
                motion.ref,
                ref
            ]),
            appearance: appearance,
            color: color,
            testId: testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
            "data-removable": true,
            "data-removing": status === $f7f30b4d24b41fb0$var$TagStatus.Removing,
            "data-ishoverclosebutton": isHoverCloseButton,
            href: href,
            before: /*#__PURE__*/ $5FkrB.createElement((0, $ldwMZ.default), {
                elemBefore: elemBefore
            }),
            contentElement: content,
            after: removeButton,
            className: (0, $970q7.default)([
                status === $f7f30b4d24b41fb0$var$TagStatus.Removing && "_z30c1r31 _twwiglyw _1pka1o36 _bqhtfiwo"
            ])
        });
    }));
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ var $f7f30b4d24b41fb0$var$RemovableTag = (0, $chQYe.markAsTagMotionCapable)(/*#__PURE__*/ (0, $5FkrB.memo)($f7f30b4d24b41fb0$var$RemovableTagComponent));
var $f7f30b4d24b41fb0$export$2e2bcd8739ae039 = $f7f30b4d24b41fb0$var$RemovableTag;

});
parcelRegister("kMTjB", function(module, exports) {
$parcel$export(module.exports, "useCallbackWithAnalytics", () => $f22332cbeb943408$export$53c2b9c37c40e0d8);

var $5FkrB = parcelRequire("5FkrB");

var $j4mCt = parcelRequire("j4mCt");

var $c4vQA = parcelRequire("c4vQA");
var $f22332cbeb943408$export$53c2b9c37c40e0d8 = function useCallbackWithAnalytics(method, payload, channel) {
    var _useAnalyticsEvents = (0, $j4mCt.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var methodRef = (0, $c4vQA.useTrackedRef)(method);
    var payloadRef = (0, $c4vQA.useTrackedRef)(payload);
    return (0, $5FkrB.useCallback)(function() {
        var pload = typeof payloadRef.current === 'function' ? payloadRef.current.apply(payloadRef, arguments) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current.apply(methodRef, arguments);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};

});
parcelRegister("j4mCt", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $de1fefd0b9a3a744$export$5bf35293e545f20c);

var $dLGML = parcelRequire("dLGML");

var $2GX3v = parcelRequire("2GX3v");

var $1Zhrr = parcelRequire("1Zhrr");
function $de1fefd0b9a3a744$export$5bf35293e545f20c() {
    var analyticsContext = (0, $1Zhrr.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $2GX3v.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("2GX3v", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f5d5032e21b4ae3$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $kkvYm = parcelRequire("kkvYm");

var $rqM8q = parcelRequire("rqM8q");
function $1f5d5032e21b4ae3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1f5d5032e21b4ae3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1f5d5032e21b4ae3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1f5d5032e21b4ae3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1f5d5032e21b4ae3$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $1f5d5032e21b4ae3$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $1f5d5032e21b4ae3$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1f5d5032e21b4ae3$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1f5d5032e21b4ae3$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $1f5d5032e21b4ae3$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $1f5d5032e21b4ae3$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            var payload = $1f5d5032e21b4ae3$var$clonePayload(_this.payload);
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $1f5d5032e21b4ae3$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $rqM8q.default));
var $1f5d5032e21b4ae3$var$clonePayload = function clonePayload(payload) {
    if ((0, $kkvYm.fg)('platform-analytics-next-safe-clone')) try {
        return JSON.parse(JSON.stringify(payload));
    } catch (e) {
        // Shallow clone keeps the event usable without crashing the UI.
        return $1f5d5032e21b4ae3$var$_objectSpread({}, payload);
    }
    /**
   * A hacky "deep clone" of the object. This is limited in that it wont
   * support functions, regexs, Maps, Sets, etc, but none of those need to
   * be represented in our payload.
   */ return JSON.parse(JSON.stringify(payload));
};

});
parcelRegister("kkvYm", function(module, exports) {
$parcel$export(module.exports, "fg", () => $ecce7a029b0d4244$export$b40ec24ac8275656);

var $7pYB8 = parcelRequire("7pYB8");
function $ecce7a029b0d4244$export$b40ec24ac8275656(name) {
    return (0, $7pYB8.resolveBooleanFlag)(name);
}

});
parcelRegister("7pYB8", function(module, exports) {
$parcel$export(module.exports, "resolveBooleanFlag", () => $5669dfac9a8edf71$export$6333b6aff9fc6275);

var $ISKn7 = parcelRequire("ISKn7");

var $iZKNZ = parcelRequire("iZKNZ");

var $7cmn9 = parcelRequire("7cmn9");

var $9Gjwv = parcelRequire("9Gjwv");

var $kYZLB = parcelRequire("kYZLB");

var $cSRsf = parcelRequire("cSRsf");
var $5669dfac9a8edf71$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $7cmn9.ENV_ENABLE_PLATFORM_FF) || (0, $9Gjwv.ENV_STORYBOOK_ENABLE_PLATFORM_FF);
function $5669dfac9a8edf71$export$6333b6aff9fc6275(flagKey) {
    if ($5669dfac9a8edf71$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $iZKNZ.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $cSRsf.pkgName), flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = (0, $kYZLB.globalVar)[0, $cSRsf.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = (0, $kYZLB.globalVar)[0, $cSRsf.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $ISKn7.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = (0, $kYZLB.globalVar)[0, $cSRsf.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("iZKNZ", function(module, exports) {
$parcel$export(module.exports, "debug", () => $dd423b083afba939$export$1c9f709888824e05);
var $dd423b083afba939$var$_process, $dd423b083afba939$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $dd423b083afba939$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($dd423b083afba939$var$_process = globalThis.process) === null || $dd423b083afba939$var$_process === void 0 || ($dd423b083afba939$var$_process = $dd423b083afba939$var$_process.env) === null || $dd423b083afba939$var$_process === void 0 ? void 0 : $dd423b083afba939$var$_process.JEST_WORKER_ID) !== undefined;
var $dd423b083afba939$var$DEBUG_MODE = !$dd423b083afba939$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($dd423b083afba939$var$_process2 = globalThis.process) === null || $dd423b083afba939$var$_process2 === void 0 || ($dd423b083afba939$var$_process2 = $dd423b083afba939$var$_process2.env) === null || $dd423b083afba939$var$_process2 === void 0 ? void 0 : $dd423b083afba939$var$_process2.NODE_ENV) !== 'production';
var $dd423b083afba939$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$dd423b083afba939$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});

parcelRegister("7cmn9", function(module, exports) {
$parcel$export(module.exports, "ENV_ENABLE_PLATFORM_FF", () => $53db021073183d6a$export$b574c24e1e6490f5);

var $cSRsf = parcelRequire("cSRsf");
var $53db021073183d6a$export$b574c24e1e6490f5 = (0, $cSRsf.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});
parcelRegister("cSRsf", function(module, exports) {
$parcel$export(module.exports, "PFF_GLOBAL_KEY", () => $9613fe251bb347cd$export$7e41b1b2bdee3f98);
$parcel$export(module.exports, "pkgName", () => $9613fe251bb347cd$export$407f05df8e3ce9f3);
$parcel$export(module.exports, "hasProcessEnv", () => $9613fe251bb347cd$export$75f4a1454eff2805);

var $3ZMUU = parcelRequire("3ZMUU");
var $9613fe251bb347cd$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $9613fe251bb347cd$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
var $9613fe251bb347cd$export$75f4a1454eff2805 = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';

});


parcelRegister("9Gjwv", function(module, exports) {
$parcel$export(module.exports, "ENV_STORYBOOK_ENABLE_PLATFORM_FF", () => $70c72e31fb1859f7$export$92f8b531feaeb23d);

var $cSRsf = parcelRequire("cSRsf");
var $70c72e31fb1859f7$export$92f8b531feaeb23d = (0, $cSRsf.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});

parcelRegister("kYZLB", function(module, exports) {
$parcel$export(module.exports, "globalVar", () => $f46952d3a59aa360$export$54ea85357b4e0159);

var $cSRsf = parcelRequire("cSRsf");
var $f46952d3a59aa360$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $f46952d3a59aa360$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$f46952d3a59aa360$export$54ea85357b4e0159[0, $cSRsf.PFF_GLOBAL_KEY] = $f46952d3a59aa360$export$54ea85357b4e0159[0, $cSRsf.PFF_GLOBAL_KEY] || $f46952d3a59aa360$var$DEFAULT_PFF_GLOBAL;

});



parcelRegister("rqM8q", function(module, exports) {
$parcel$export(module.exports, "default", () => $05274ac3165ab682$export$2e2bcd8739ae039);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $05274ac3165ab682$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $05274ac3165ab682$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $05274ac3165ab682$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $05274ac3165ab682$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $05274ac3165ab682$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $05274ac3165ab682$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $05274ac3165ab682$var$_objectSpread($05274ac3165ab682$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("1Zhrr", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $17290480b955c5b1$export$d1f587f82ad51c4);

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $17290480b955c5b1$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};

});


parcelRegister("c4vQA", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $8c9e8ff131a82d14$export$1d27a74659855e44);

var $5FkrB = parcelRequire("5FkrB");
var $8c9e8ff131a82d14$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("5supy", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f972846489e3122$export$2e2bcd8739ae039);
/* lozenge.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $50U6m = parcelRequire("50U6m");

var $40PkG = parcelRequire("40PkG");
/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ var $3f972846489e3122$var$styles = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect4ttxp _1wyb1skh _zg8l4jg8 _k48pwu06 _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhksm61",
    'bg.subtle.inprogress': "_bfhksm61",
    'bg.subtle.moved': "_bfhksm61",
    'bg.subtle.new': "_bfhksm61",
    'bg.subtle.removed': "_bfhksm61",
    'bg.subtle.success': "_bfhksm61",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syazi7uo",
    'text.bold': "_syazwwip"
};
var $3f972846489e3122$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed'
];
var $3f972846489e3122$var$newSemanticColors = [
    'success',
    'discovery',
    'warning',
    'danger',
    'information',
    'neutral'
];
var $3f972846489e3122$var$appearanceMapping = {
    neutral: 'default',
    default: 'default',
    information: 'inprogress',
    inprogress: 'inprogress',
    warning: 'moved',
    moved: 'moved',
    removed: 'removed',
    danger: 'removed',
    success: 'success',
    discovery: 'new',
    new: 'new'
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $3f972846489e3122$var$LegacyLozenge = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? 'bold' : 'subtle';
    var appearanceType = (0, $5FkrB.useMemo)(function() {
        return $3f972846489e3122$var$appearanceTypes.includes(appearance) || $3f972846489e3122$var$newSemanticColors.includes(appearance) ? $3f972846489e3122$var$appearanceMapping[appearance] : 'default';
    }, [
        appearance
    ]);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $970q7.default)([
            $3f972846489e3122$var$styles.container,
            $3f972846489e3122$var$styles["bg.".concat(appearanceStyle, ".").concat(appearanceType)],
            appearanceStyle === 'subtle' && $3f972846489e3122$var$styles["outline.subtle.".concat(appearanceType)],
            appearanceStyle === 'subtle' && $3f972846489e3122$var$styles.containerSubtle
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $970q7.default)([
            $3f972846489e3122$var$styles.text,
            (0, $50U6m.fg)('platform-lozenge-custom-letterspacing') && $3f972846489e3122$var$styles.customLetterspacing,
            $3f972846489e3122$var$styles["text.".concat(appearanceStyle)]
        ])
    }, children));
});
$3f972846489e3122$var$LegacyLozenge.displayName = 'Lozenge';
/**
 * Wrapper component that switches between old and new Lozenge based on feature flag
 */ var $3f972846489e3122$var$LozengeWrapper = /*#__PURE__*/ (0, $5FkrB.memo)(function(props) {
    if ((0, $50U6m.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) return /*#__PURE__*/ $5FkrB.createElement((0, $40PkG.default), props);
    return /*#__PURE__*/ $5FkrB.createElement($3f972846489e3122$var$LegacyLozenge, props);
});
$3f972846489e3122$var$LozengeWrapper.displayName = 'Lozenge';
var $3f972846489e3122$export$2e2bcd8739ae039 = $3f972846489e3122$var$LozengeWrapper;

});
parcelRegister("40PkG", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ebefb163f4e3420$export$2e2bcd8739ae039);
/* lozenge.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");


var $c2yie = parcelRequire("c2yie");
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $2ebefb163f4e3420$var$Lozenge = function Lozenge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style, testId = _ref.testId, children = _ref.children, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance;
    var baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        children: children
    };
    return /*#__PURE__*/ $5FkrB.createElement((0, $c2yie.default), baseProps, children);
};
$2ebefb163f4e3420$var$Lozenge.displayName = 'Lozenge';
var $2ebefb163f4e3420$export$2e2bcd8739ae039 = $2ebefb163f4e3420$var$Lozenge;

});
parcelRegister("c2yie", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c4045cfee3ec217$export$2e2bcd8739ae039);
/* lozenge-base.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $25nEq = parcelRequire("25nEq");

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $1aCqH = parcelRequire("1aCqH");

var $hRJ5R = parcelRequire("hRJ5R");

var $h19KG = parcelRequire("h19KG");

var $9Z4Tm = parcelRequire("9Z4Tm");

var $50U6m = parcelRequire("50U6m");

var $ifX9g = parcelRequire("ifX9g");

var $9ztDu = parcelRequire("9ztDu");

var $drplt = parcelRequire("drplt");

var $1aU3y = parcelRequire("1aU3y");

var $jDn2Q = parcelRequire("jDn2Q");
function $8c4045cfee3ec217$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8c4045cfee3ec217$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8c4045cfee3ec217$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8c4045cfee3ec217$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Get the pressed background color for the selected lozenge dropdown trigger
var $8c4045cfee3ec217$var$pressedBackgroundMapping = {
    success: "var(--ds-background-success-subtler-pressed, #B3DF72)",
    warning: "var(--ds-background-warning-subtler-pressed, #FBC828)",
    danger: "var(--ds-background-danger-subtler-pressed, #FD9891)",
    information: "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    neutral: "var(--ds-background-neutral-pressed, #080F214A)",
    discovery: "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'accent-red': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'accent-orange': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'accent-yellow': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'accent-lime': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'accent-green': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'accent-teal': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'accent-blue': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'accent-purple': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'accent-magenta': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'accent-gray': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
};
var $8c4045cfee3ec217$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1j28 _kqswh2mm _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k92 _1q51v77o _85i5v77o _bozg1b66 _y4ti1b66",
    motionContainer: "_k8m01rje _1oeci9qs _6fl41d08",
    containerSpacious: "_2rko1qi0 _1tkeviql _1q511b66 _85i51b66 _bozgutpp _y4tiutpp",
    containerBadgePadding: "_y4ti303w",
    text: "_11c8wadc _1reo15vq _18m915vq _o5721q9c",
    textEllipsis: "_1bto1l2s",
    textClip: "_1btozryt",
    textSpacious: "_11c8fhey _k48p1wq8",
    textSelected: "_syaz6x5g",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw",
    loadingOverlayMotion: "_j7hq1bym _5sag1ign _1pglindk",
    metricBadgeWrapper: "_1e0c1txw",
    'semantic.success': "_3wu02gvx _bfhk14j0 _syaz1p1e",
    'semantic.warning': "_3wu01wfx _bfhk10f4 _syazmgs1",
    'semantic.danger': "_3wu01mzp _bfhk18wg _syaz1blx",
    'semantic.information': "_3wu0wn4u _bfhk8lbg _syaz1qd9",
    'semantic.neutral': "_3wu01l7x _bfhki8nm _syazi7uo",
    'semantic.discovery': "_3wu019v3 _bfhke670 _syaz1g72",
    'accent.red': "_3wu0n9dc _bfhk1rtt _syazhwvp",
    'accent.orange': "_3wu01ip5 _bfhk165s _syaz7i1p",
    'accent.yellow': "_3wu01s7j _bfhk1773 _syazekll",
    'accent.lime': "_3wu01m7d _bfhkz2ec _syaz1ik3",
    'accent.green': "_3wu05d2u _bfhk1wnw _syaz1y78",
    'accent.teal': "_3wu0131p _bfhk1a17 _syaz12v7",
    'accent.blue': "_3wu018hp _bfhk1dy8 _syaz1kyx",
    'accent.purple': "_3wu0luwt _bfhk1nm4 _syaz1mn1",
    'accent.magenta': "_3wu0132u _bfhkv9ra _syaz1qur",
    'accent.gray': "_3wu01l7x _bfhkysee _syaz1tmo",
    'interactive.semantic.success': "_irr31r82 _1di6d6jc",
    'interactive.semantic.warning': "_irr31yx4 _1di6bkku",
    'interactive.semantic.danger': "_irr370oi _1di6jkmi",
    'interactive.semantic.information': "_irr315aw _1di6ar1y",
    'interactive.semantic.neutral': "_irr3plhp _1di61gdz",
    'interactive.semantic.discovery': "_irr3rumk _1di65usi",
    'interactive.accent.red': "_irr3affd _1di61j5a",
    'interactive.accent.orange': "_irr31ei0 _1di6dpo3",
    'interactive.accent.yellow': "_irr31uw7 _1di61r9w",
    'interactive.accent.lime': "_irr31gf0 _1di62kxc",
    'interactive.accent.green': "_irr31e2h _1di6ybhx",
    'interactive.accent.teal': "_irr3kwwr _1di61jb0",
    'interactive.accent.blue': "_irr3815t _1di6rwxf",
    'interactive.accent.purple': "_irr3attl _1di63nfk",
    'interactive.accent.magenta': "_irr31axx _1di642ri",
    'interactive.accent.gray': "_irr3wejn _1di618ut",
    iconBorderFilter: "_1h6d74of",
    content: "_zulp1b66 _1e0c116y _4cvr1h6o",
    maxWidth: "_p12f1osq",
    contentSpacious: "_zulp12x7",
    loadingContent: "_tzy4idpf",
    loadingMotion: "_k8m0brmi _1oec1ign _6fl4indk",
    containerBadgePressed: "_1axmtoke _17i7toke",
    containerBadgeNeutralAppearance: "_1ftrnkaw _1axmnkaw _17i7nkaw"
};
var $8c4045cfee3ec217$var$interactiveMotionStyles = {
    motion: "_v564k6bl _1ggl5xtf"
};
/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */ var $8c4045cfee3ec217$var$LozengeBase = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, appearance = _ref.appearance, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, onClick = _ref.onClick, style = _ref.style, analyticsContext = _ref.analyticsContext, interactionName = _ref.interactionName, ariaControls = _ref['aria-controls'], ariaExpanded = _ref['aria-expanded'], ariaHaspopup = _ref['aria-haspopup'], ariaLabel = _ref['aria-label'];
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), resizing = _useState2[0], setResizing = _useState2[1];
    var onFinishMotion = function onFinishMotion() {
        return setResizing(false);
    };
    var resizingWidth = (0, $9Z4Tm.useResizing)({
        dimension: 'width',
        duration: "var(--ds-duration-medium, 200ms)",
        easing: "var(--ds-easing-inout-bold, cubic-bezier(0.4, 0, 0, 1))",
        onFinishMotion: onFinishMotion
    });
    var isInitialRender = (0, $5FkrB.useRef)(true);
    var isInteractive = typeof onClick === 'function';
    // Determine the effective color, with fallback logic for legacy appearances
    var resolvedColor = (0, $jDn2Q.resolveLozengeColor)(appearance) || 'neutral';
    var _getThemeStyles = (0, $drplt.getThemeStyles)(resolvedColor), category = _getThemeStyles.category, key = _getThemeStyles.key;
    var colorStyleKey = "".concat(category, ".").concat(key);
    var interactiveStyleKey = "interactive.".concat(category, ".").concat(key);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && maxWidth.endsWith('%');
    var resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === 'inverse' ? 'inverse' : (0, $jDn2Q.resolveLozengeColor)(trailingMetricAppearance) : resolvedColor;
    // Map the resolved trailing metric appearance to a Badge appearance.
    // Semantic colors map to their new bold variants (e.g. successBold),
    // which provide sufficient color emphasis on top of the subtler
    // lozenge background. Accent colors and unknown values fall back to
    // the neutral appearance.
    var metricBadgeAppearance = function() {
        if (resolvedTrailingMetricAppearance === 'inverse') return 'inverse';
        if (resolvedTrailingMetricAppearance == null) return 'neutral';
        if (resolvedTrailingMetricAppearance.startsWith('accent-')) return 'neutral';
        switch(resolvedTrailingMetricAppearance){
            case 'success':
                return 'successBold';
            case 'warning':
                return 'warningBold';
            case 'danger':
                return 'dangerBold';
            case 'information':
                return 'informationBold';
            case 'discovery':
                return 'discoveryBold';
            case 'neutral':
            default:
                return 'neutral';
        }
    }();
    var commonStyleOverrides = {
        backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
        // Constrain the container to the smaller of the explicit maxWidth and 100% of
        // the parent. Using min(...) means the lozenge never overflows its parent,
        // while still honouring the explicit maxWidth prop when the parent is wider.
        maxWidth: maxWidthIsPc ? maxWidth : "min(".concat(maxWidthValue, ", 100%)")
    };
    var hasTrailingMetric = trailingMetric != null && trailingMetric !== '';
    var childrenKey = typeof children === 'string' ? children : undefined;
    (0, $5FkrB.useLayoutEffect)(function() {
        // Ignore initial render
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        setResizing(true);
    }, [
        childrenKey
    ]);
    var enableMotionFG = (0, $50U6m.fg)('platform-dst-motion-uplift');
    var enableButtonMotionFG = (0, $50U6m.fg)('platform-dst-motion-uplift-button');
    var innerContent = /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-testid": testId ? "".concat(testId, "--content") : undefined
    }, enableMotionFG ? resizingWidth : undefined, {
        className: (0, $970q7.default)([
            $8c4045cfee3ec217$var$styles.content,
            spacing === 'spacious' && $8c4045cfee3ec217$var$styles.contentSpacious,
            isInteractive && enableButtonMotionFG && $8c4045cfee3ec217$var$styles.loadingMotion,
            isLoading && $8c4045cfee3ec217$var$styles.loadingContent,
            // Constrain the content wrapper to its container so text truncation
            // works correctly within the flex layout, regardless of whether maxWidth
            // is a percentage, fixed value, or the parent container is narrower than
            // the explicit maxWidth.
            $8c4045cfee3ec217$var$styles.maxWidth
        ])
    }), iconBefore && /*#__PURE__*/ $5FkrB.createElement((0, $1aU3y.default), {
        size: spacing === 'spacious' ? 'medium' : 'small',
        icon: iconBefore,
        color: resolvedColor,
        testId: testId && "".concat(testId, "--icon")
    }), /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            // The text fills 100% of the inner content wrapper. The container's
            // own max-width (set on the container via commonStyleOverrides) handles
            // the actual size constraint, so the text just needs to fill the available
            // space and truncate when it overflows.
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")"),
            color: style === null || style === void 0 ? void 0 : style.color
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $970q7.default)([
            $8c4045cfee3ec217$var$styles.text,
            enableMotionFG && resizing && !maxWidth ? $8c4045cfee3ec217$var$styles.textClip : $8c4045cfee3ec217$var$styles.textEllipsis,
            spacing === 'spacious' && $8c4045cfee3ec217$var$styles.textSpacious
        ])
    }, children), hasTrailingMetric && !resolvedColor.startsWith('accent-') && /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-lozenge-metric-wrapper": true,
        "data-testid": testId && "".concat(testId, "--metric"),
        className: (0, $970q7.default)([
            $8c4045cfee3ec217$var$styles.metricBadgeWrapper
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $1aCqH.default), {
        appearance: metricBadgeAppearance
    }, trailingMetric)), isInteractive && /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($h19KG))), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && "".concat(testId, "--chevron")
    }));
    if (isInteractive) return /*#__PURE__*/ $5FkrB.createElement((0, $ifX9g.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: ref,
        xcss: (0, $hRJ5R.cx)($8c4045cfee3ec217$var$styles.container, !isLoading && enableButtonMotionFG ? $8c4045cfee3ec217$var$interactiveMotionStyles.motion : enableMotionFG && $8c4045cfee3ec217$var$styles.motionContainer, spacing === 'spacious' && $8c4045cfee3ec217$var$styles.containerSpacious, !isSelected && $8c4045cfee3ec217$var$styles.iconBorderFilter, $8c4045cfee3ec217$var$styles[colorStyleKey], !isLoading && $8c4045cfee3ec217$var$styles[interactiveStyleKey], hasTrailingMetric && $8c4045cfee3ec217$var$styles.containerBadgePressed, hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $8c4045cfee3ec217$var$styles.containerBadgeNeutralAppearance)
    }, isLoading && {
        'aria-busy': true,
        'aria-disabled': true,
        isDisabled: true
    }, {
        "aria-label": isLoading ? 'Loading' : ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        onClick: isLoading ? undefined : onClick,
        style: $8c4045cfee3ec217$var$_objectSpread($8c4045cfee3ec217$var$_objectSpread({}, commonStyleOverrides), {}, {
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: "solid ".concat("var(--ds-border-width, 1px)", " ", isSelected ? 'var(--border-color) !important' : 'transparent'),
            backgroundColor: isSelected ? $8c4045cfee3ec217$var$pressedBackgroundMapping[resolvedColor] : undefined,
            cursor: isLoading ? 'progress' : 'pointer'
        }),
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger"
    }, isSelected && {
        'data-selected': 'true'
    }), innerContent, isLoading && /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId ? "".concat(testId, "--loading-overlay") : undefined,
        className: (0, $970q7.default)([
            $8c4045cfee3ec217$var$styles.loadingOverlay,
            enableButtonMotionFG && $8c4045cfee3ec217$var$styles.loadingOverlayMotion
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $9ztDu.default), {
        size: spacing === 'spacious' ? 'small' : 'xsmall',
        label: ", Loading",
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    })));
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, $970q7.default)([
            $8c4045cfee3ec217$var$styles.container,
            spacing === 'spacious' && $8c4045cfee3ec217$var$styles.containerSpacious,
            spacing !== 'spacious' && hasTrailingMetric && $8c4045cfee3ec217$var$styles.containerBadgePadding,
            $8c4045cfee3ec217$var$styles[colorStyleKey],
            $8c4045cfee3ec217$var$styles.iconBorderFilter,
            hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $8c4045cfee3ec217$var$styles.containerBadgeNeutralAppearance
        ])
    }, innerContent);
}));
var $8c4045cfee3ec217$export$2e2bcd8739ae039 = $8c4045cfee3ec217$var$LozengeBase;

});
parcelRegister("1aCqH", function(module, exports) {
$parcel$export(module.exports, "default", () => $0da488f75a4043f8$export$2e2bcd8739ae039);
/* badge-new.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $72GAO = parcelRequire("72GAO");

var $8zPAc = parcelRequire("8zPAc");

var $9UfWS = parcelRequire("9UfWS");
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ // Nested selectors with data attributes are required for theme switching
var $0da488f75a4043f8$var$stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk14j0",
    danger: "_syaz1blx _bfhk18wg",
    warning: "_syazmgs1 _bfhk10f4",
    information: "_syaz1qd9 _bfhk8lbg",
    discovery: "_syaz1g72 _bfhke670",
    neutral: "_syazi7uo _bfhk7qp0",
    inverse: "_bfhkvuon _syazi7uo",
    informationBold: "_syaz1qd9 _bfhk9pm7",
    successBold: "_syaz1p1e _bfhk16ib",
    dangerBold: "_syaz1blx _bfhkud63",
    warningBold: "_syazmgs1 _bfhk1kmu",
    warningBoldDark: "_syazmgs1 _bfhkgj02",
    discoveryBold: "_syaz1g72 _bfhk5ly7"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ var $0da488f75a4043f8$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === 'number' && max ? (0, $9UfWS.formatValue)(children, max) : children;
};
/**
 * __BadgeNew__
 *
 * New visual refresh implementation of Badge component for the labelling system.
 * This component is used when the 'platform-dst-lozenge-tag-badge-visual-uplifts' feature flag is enabled.
 *
 * Uses new appearance naming convention:
 * - success (green)
 * - danger (red)
 * - neutral (gray)
 * - information (blue)
 * - inverse (inverted colors)
 * - warning (orange/yellow)
 * - discovery (purple)
 * - informationBold (bold blue, color.background.information.subtle)
 * - successBold (bold green, color.background.success.subtle)
 * - dangerBold (bold red, color.background.danger.subtle)
 * - warningBold (bold warning, color.background.warning.bold)
 * - discoveryBold (bold purple, color.background.discovery.subtle)
 */ var $0da488f75a4043f8$var$BadgeNew = /*#__PURE__*/ (0, $5FkrB.memo)(function BadgeNew(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    var _useThemeObserver = (0, $8zPAc.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    // In dark theme, warningBold needs to swap to a lighter background
    // (color.background.warning.subtle / Orange800) for better contrast against
    // the typical dark surface colors.
    var resolvedAppearance = appearance === 'warningBold' && colorMode === 'dark' ? 'warningBoldDark' : appearance;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $970q7.default)([
            $0da488f75a4043f8$var$stylesNew.root,
            $0da488f75a4043f8$var$stylesNew[resolvedAppearance]
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $72GAO.Text), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $0da488f75a4043f8$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $0da488f75a4043f8$export$2e2bcd8739ae039 = $0da488f75a4043f8$var$BadgeNew;

});
parcelRegister("8zPAc", function(module, exports) {
$parcel$export(module.exports, "useThemeObserver", () => $63e99ae9cd33d309$export$3dd7971102e44fa8);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $dG82B = parcelRequire("dG82B");

var $h1IZv = parcelRequire("h1IZv");
var $63e99ae9cd33d309$export$3dd7971102e44fa8 = function useThemeObserver() {
    var _useState = (0, $5FkrB.useState)((0, $dG82B.getGlobalTheme)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        var observer = new (0, $h1IZv.default)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $63e99ae9cd33d309$export$2e2bcd8739ae039 = $63e99ae9cd33d309$export$3dd7971102e44fa8;

});

parcelRegister("9UfWS", function(module, exports) {
$parcel$export(module.exports, "formatValue", () => $7365b71a3b911fbf$export$7c4d25c0c3217d8c);
function $7365b71a3b911fbf$var$getSafeValue() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $7365b71a3b911fbf$export$7c4d25c0c3217d8c(value, max) {
    var safeValue = $7365b71a3b911fbf$var$getSafeValue(value);
    var safeMax = $7365b71a3b911fbf$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("9Z4Tm", function(module, exports) {
$parcel$export(module.exports, "useResizing", () => $744d9af81f1a5245$export$a300664a1a230956);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $f7zEt = parcelRequire("f7zEt");

var $aEbhM = parcelRequire("aEbhM");

var $1S966 = parcelRequire("1S966");

var $emAlm = parcelRequire("emAlm");

var $40NHJ = parcelRequire("40NHJ");

var $9XR4a = parcelRequire("9XR4a");
/**
 * Which dimension(s) of the element to animate.
 *
 * - `'width'` animates only width changes.
 * - `'height'` animates only height changes.
 * - `'both'` animates width and height changes simultaneously.
 */ /**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $744d9af81f1a5245$var$parseCSSTimeToMs(value) {
    var parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $744d9af81f1a5245$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $744d9af81f1a5245$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
var $744d9af81f1a5245$export$a300664a1a230956 = function useResizing(_ref) {
    var dimension = _ref.dimension, duration = _ref.duration, easing = _ref.easing, onFinishMotion = _ref.onFinishMotion;
    var prevDimensions = (0, $5FkrB.useRef)();
    var _useElementRef = (0, $aEbhM.useElementRef)(), _useElementRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useElementRef, 2), element = _useElementRef2[0], setElementRef = _useElementRef2[1];
    var setTimeout = (0, $40NHJ.useSetTimeout)({
        cleanup: 'next-effect'
    });
    var requestAnimationFrame = (0, $emAlm.useRequestAnimationFrame)();
    (0, $9XR4a.useSnapshotBeforeUpdate)(function() {
        if ((0, $f7zEt.isReducedMotion)() || !element) return;
        var rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $1S966.useLayoutEffect)(function() {
        if ((0, $f7zEt.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        var rect = element.getBoundingClientRect();
        var nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!$744d9af81f1a5245$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
            return;
        }
        var propertyList = $744d9af81f1a5245$var$getDimensionPropertyList(dimension);
        var newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = "".concat(prevDimensions.current.width, "px");
        if (dimension === 'height' || dimension === 'both') newStyles.height = "".concat(prevDimensions.current.height, "px");
        Object.assign(element.style, newStyles);
        var resolvedDuration = $744d9af81f1a5245$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = "".concat(nextDimensions.width, "px");
                if (dimension === 'height' || dimension === 'both') element.style.height = "".concat(nextDimensions.height, "px");
                setTimeout(function() {
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};

});
parcelRegister("f7zEt", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $b0232a2fa99764c0$export$b7baf7667a68d87c);

var $ecZuE = parcelRequire("ecZuE");
var $b0232a2fa99764c0$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!(0, $ecZuE.isMatchMediaAvailable)()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};

});
parcelRegister("ecZuE", function(module, exports) {
$parcel$export(module.exports, "isMatchMediaAvailable", () => $a581e2f4a28585ba$export$c5406bd59b374abd);
var $a581e2f4a28585ba$export$c5406bd59b374abd = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};

});


parcelRegister("aEbhM", function(module, exports) {
$parcel$export(module.exports, "useElementRef", () => $7c0664f362997749$export$ff879f35a69d56b7);

var $5FkrB = parcelRequire("5FkrB");
var $7c0664f362997749$export$ff879f35a69d56b7 = function useElementRef() {
    var elementRef = (0, $5FkrB.useRef)(null);
    var setRef = (0, $5FkrB.useCallback)(function(ref) {
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});

parcelRegister("1S966", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $15d1e42bef2ce5ed$export$e5c5a5f917a5871c);

var $5FkrB = parcelRequire("5FkrB");
var $15d1e42bef2ce5ed$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);

});

parcelRegister("emAlm", function(module, exports) {
$parcel$export(module.exports, "useRequestAnimationFrame", () => $a74f4fce46837c50$export$1775f27e7c8051ca);

var $5FkrB = parcelRequire("5FkrB");
var $a74f4fce46837c50$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $a74f4fce46837c50$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $a74f4fce46837c50$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};

});

parcelRegister("40NHJ", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", () => $2ebdb7c7469c8bf6$export$4f34107a2b00f39c);

var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $2ebdb7c7469c8bf6$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $2ebdb7c7469c8bf6$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $2ebdb7c7469c8bf6$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("9XR4a", function(module, exports) {
$parcel$export(module.exports, "useSnapshotBeforeUpdate", () => $7412c991512a8f43$export$9e95200239cd148b);

var $5FkrB = parcelRequire("5FkrB");

var $1S966 = parcelRequire("1S966");
var $7412c991512a8f43$export$9e95200239cd148b = function useSnapshotBeforeUpdate(cb) {
    var isFirstRender = (0, $5FkrB.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $1S966.useLayoutEffect)(function() {
        isFirstRender.current = false;
    }, []);
};

});


parcelRegister("drplt", function(module, exports) {
$parcel$export(module.exports, "getThemeStyles", () => $9c9175041946e684$export$a3fc04b8551e006a);
// extract the category and key from the resolved color
var $9c9175041946e684$export$a3fc04b8551e006a = function getThemeStyles(resolvedColor) {
    var isAccent = resolvedColor.startsWith('accent-');
    var category = isAccent ? 'accent' : 'semantic';
    var key = isAccent ? resolvedColor.replace('accent-', '') : resolvedColor;
    return {
        category: category,
        key: key
    };
};

});

parcelRegister("1aU3y", function(module, exports) {
$parcel$export(module.exports, "default", () => $0db2353ef35514f9$export$2e2bcd8739ae039);
/* icon-renderer.tsx generated by @compiled/babel-plugin v3.0.2 */ 

var $5FkrB = parcelRequire("5FkrB");

var $50U6m = parcelRequire("50U6m");

var $auVZV = parcelRequire("auVZV");
// Map lozenge colors to appropriate icon colors.
//
// We intentionally use `color.text.*.bolder` tokens for icons across all
// colored lozenges (semantic + accent). Text tokens use higher-stop palette
// values (Color700+) which pass 3:1 contrast against subtler backgrounds in
// every interactive state — including pressed where icon Color600 fails for
// most hues. Using text tokens uniformly:
//   - avoids global changes to the `color.icon.*` token ramps
//   - keeps icon and text visually aligned in the lozenge
//   - guarantees ≥3:1 contrast across default/hover/pressed states
//
// Neutral lozenges use `color.text.subtle` to match the neutral text styling
// and remain consistent with their alpha-based backgrounds.
var $0db2353ef35514f9$var$getIconColor = function getIconColor(color) {
    switch(color){
        // Semantic
        case 'success':
            return "var(--ds-text-success, #4C6B1F)";
        case 'warning':
            return "var(--ds-text-warning, #9E4C00)";
        case 'danger':
            return "var(--ds-text-danger, #AE2E24)";
        case 'information':
            return "var(--ds-text-information, #1558BC)";
        case 'discovery':
            return "var(--ds-text-discovery, #803FA5)";
        case 'neutral':
            return "var(--ds-text-subtle, #505258)";
        // Accent
        case 'accent-red':
            return "var(--ds-text-accent-red, #AE2E24)";
        case 'accent-orange':
            return "var(--ds-text-accent-orange, #9E4C00)";
        case 'accent-yellow':
            return "var(--ds-text-accent-yellow, #7F5F01)";
        case 'accent-lime':
            return "var(--ds-text-accent-lime, #4C6B1F)";
        case 'accent-green':
            return "var(--ds-text-accent-green, #216E4E)";
        case 'accent-teal':
            return "var(--ds-text-accent-teal, #206A83)";
        case 'accent-blue':
            return "var(--ds-text-accent-blue, #1558BC)";
        case 'accent-purple':
            return "var(--ds-text-accent-purple, #803FA5)";
        case 'accent-magenta':
            return "var(--ds-text-accent-magenta, #943D73)";
        case 'accent-gray':
            return "var(--ds-text-subtle, #505258)";
        default:
            return "var(--ds-text-subtle, #505258)";
    }
};
var $0db2353ef35514f9$var$styles = {
    motion: "_k8m01ylx _1oeci9qs _6fl41d08"
};
/**
 * Icon renderer for lozenge components
 * Handles proper sizing and color theming for icons
 */ var $0db2353ef35514f9$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon, color = _ref.color, testId = _ref.testId, size = _ref.size;
    var iconColor = $0db2353ef35514f9$var$getIconColor(color);
    return (0, $50U6m.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $auVZV.Box), {
        xcss: $0db2353ef35514f9$var$styles.motion,
        style: {
            color: iconColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, {
        label: "",
        size: size,
        testId: testId
    })) : /*#__PURE__*/ // Cast required because the lozenge intentionally uses some
    // `color.text.*.bolder` tokens for icons that don't pass 3:1 contrast
    // at their default `color.icon.*` stop. The Icon component types only
    // accept `IconColor`, but text tokens are valid CSS color values and
    // render correctly at runtime.
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, {
        color: iconColor,
        label: "",
        size: size,
        testId: testId
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$0db2353ef35514f9$export$2e2bcd8739ae039 = $0db2353ef35514f9$var$IconRenderer;

});

parcelRegister("jDn2Q", function(module, exports) {
$parcel$export(module.exports, "resolveLozengeColor", () => $e4b3890ca43eeb4f$export$acf5d2b7dc999bda);
// Map legacy appearance to new color values
var $e4b3890ca43eeb4f$var$legacyAppearanceMap = {
    default: 'neutral',
    removed: 'danger',
    inprogress: 'information',
    new: 'discovery',
    moved: 'warning'
};
var $e4b3890ca43eeb4f$export$acf5d2b7dc999bda = function resolveLozengeColor() {
    var _legacyAppearanceMap$;
    var appearance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'neutral';
    if (appearance.startsWith('accent-')) return appearance;
    return (_legacyAppearanceMap$ = $e4b3890ca43eeb4f$var$legacyAppearanceMap[appearance]) !== null && _legacyAppearanceMap$ !== void 0 ? _legacyAppearanceMap$ : appearance;
};

});




parcelRegister("dqo70", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c60682ff6564d2d$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $kDLIJ = parcelRequire("kDLIJ");

var $ZBv4y = parcelRequire("ZBv4y");

var $lavil = parcelRequire("lavil");

var $gooFO = parcelRequire("gooFO");

var $3S69A = parcelRequire("3S69A");

var $bGYdO = parcelRequire("bGYdO");

var $3woLB = parcelRequire("3woLB");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $9c60682ff6564d2d$var$ShrinkOut = function ShrinkOut(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'small' : _ref$duration, onFinish = _ref.onFinish;
    var _useElementRef = (0, $lavil.useElementRef)(), _useElementRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useElementRef, 2), element = _useElementRef2[0], setElementRef = _useElementRef2[1];
    var exiting = (0, $3woLB.useExitingPersistence)();
    var requestAnimationFrame = (0, $3S69A.useRequestAnimationFrame)();
    var setTimeout = (0, $bGYdO.useSetTimeout)();
    var direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $gooFO.useLayoutEffect)(function() {
        if (exiting.isExiting && element) {
            if ((0, $ZBv4y.isReducedMotion)()) {
                exiting.onFinish && exiting.onFinish();
                onFinish && onFinish('exiting');
                return;
            }
            var newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: "".concat(element.offsetWidth, "px"),
                height: "".concat(element.offsetHeight, "px"),
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    var newStyles = {
                        width: '0px',
                        margin: '0px',
                        // We animate margin down to zero so it doesn't take any space.
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $kDLIJ.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(function() {
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $kDLIJ.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $9c60682ff6564d2d$export$2e2bcd8739ae039 = $9c60682ff6564d2d$var$ShrinkOut;

});
parcelRegister("kDLIJ", function(module, exports) {
$parcel$export(module.exports, "durations", () => $f06c77720b2b21af$export$38b928a7167ce124);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $f06c77720b2b21af$export$368bacef0dacbe05 = 25;
var $f06c77720b2b21af$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};

});

parcelRegister("lavil", function(module, exports) {
$parcel$export(module.exports, "useElementRef", () => $f692cea2bd736556$export$ff879f35a69d56b7);

var $5FkrB = parcelRequire("5FkrB");
var $f692cea2bd736556$export$ff879f35a69d56b7 = function useElementRef() {
    var elementRef = (0, $5FkrB.useRef)(null);
    var setRef = (0, $5FkrB.useCallback)(function(ref) {
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});

parcelRegister("3S69A", function(module, exports) {
$parcel$export(module.exports, "useRequestAnimationFrame", () => $2d1b3034bb7b3a2b$export$1775f27e7c8051ca);

var $5FkrB = parcelRequire("5FkrB");
var $2d1b3034bb7b3a2b$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $2d1b3034bb7b3a2b$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $2d1b3034bb7b3a2b$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};

});

parcelRegister("bGYdO", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", () => $883254b93396a860$export$4f34107a2b00f39c);

var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $883254b93396a860$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $883254b93396a860$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $883254b93396a860$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});


parcelRegister("41QTh", function(module, exports) {
$parcel$export(module.exports, "colorMapping", () => $2ef0485fdc9628e7$export$3351a8d90bcc13aa);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // Color mapping from old color names to new color names
var $2ef0485fdc9628e7$export$3351a8d90bcc13aa = {
    standard: 'gray',
    grey: 'gray',
    blue: 'blue',
    green: 'green',
    red: 'red',
    yellow: 'yellow',
    purple: 'purple',
    lime: 'lime',
    magenta: 'magenta',
    orange: 'orange',
    teal: 'teal',
    // Light variants map to same as their non-light counterparts
    greyLight: 'gray',
    blueLight: 'blue',
    greenLight: 'green',
    redLight: 'red',
    yellowLight: 'yellow',
    purpleLight: 'purple',
    limeLight: 'lime',
    magentaLight: 'magenta',
    orangeLight: 'orange',
    tealLight: 'teal'
};

});

parcelRegister("h2ToJ", function(module, exports) {
$parcel$export(module.exports, "getTagText", () => $c68d9874d8445035$export$7d100de1166870f6);
// Intentionally scoped to the UI-uplifted TagNew implementation.
var $c68d9874d8445035$export$7d100de1166870f6 = function getTagText(text) {
    return Array.isArray(text) ? text.join('') : text;
};

});

parcelRegister("fRgWa", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8b8f1a2f4e48730$export$2e2bcd8739ae039);
/* tag-new.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $h19KG = parcelRequire("h19KG");

var $kkvYm = parcelRequire("kkvYm");

var $btdNC = parcelRequire("btdNC");

var $9ztDu = parcelRequire("9ztDu");

var $41QTh = parcelRequire("41QTh");

var $h2ToJ = parcelRequire("h2ToJ");

var $4GosE = parcelRequire("4GosE");

var $4W0It = parcelRequire("4W0It");

var $chQYe = parcelRequire("chQYe");

var $j5j9o = parcelRequire("j5j9o");

var $59CfW = parcelRequire("59CfW");

var $cT0RG = parcelRequire("cT0RG");

var $1puCn = parcelRequire("1puCn");

var $wh4vE = parcelRequire("wh4vE");

var $3WKjv = parcelRequire("3WKjv");
var $b8b8f1a2f4e48730$var$_excluded = [
    "color",
    "text",
    "elemBefore",
    "href",
    "linkComponent",
    "isRemovable",
    "removeButtonLabel",
    "onBeforeRemoveAction",
    "onAfterRemoveAction",
    "testId",
    "maxWidth",
    "hasMargin",
    "onClick",
    "swatchBefore",
    "swatchBeforeLabel",
    "swatchBeforeRole",
    "trailingMetric"
], $b8b8f1a2f4e48730$var$_excluded2 = [
    "color",
    "text",
    "elemBefore",
    "testId",
    "maxWidth",
    "hasMargin",
    "onClick",
    "isSelected",
    "isLoading",
    "analyticsContext",
    "hasChevron",
    "swatchBefore",
    "swatchBeforeLabel",
    "swatchBeforeRole",
    "trailingMetric"
];
var $b8b8f1a2f4e48730$var$styles = {
    baseStyles: "_zulp1b66 _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1rjcv77o _18zr1mie _1mou1b66 _195g1b66 _1e0c116y _vchhusvi _1ul9idpf _p12ff6dh _4t3i1k92 _kqswh2mm _4cvr1h6o _80om73ad _bfhksm61",
    noMarginStyles: "_1mouze3t _195gze3t",
    removableStyles: "_zulp1b66",
    beforeStyles: "_4bfu1snc _1hmsagmp _ajmmvv82 _1e0c116y _4cvr1h6o _1o9zidpf _syaz125o",
    beforeStylesSelected: "_syazxl6c",
    textStyles: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n _1ul9idpf _syazi7uo",
    textStylesSelected: "_syaz6x5g",
    afterStyles: "_1e0c1txw _4cvr1h6o _1o9zidpf _lcxv1wug _kqswh2mm",
    afterMotionStyles: "_1ul9utpp",
    trailingMetric: "_2rkolb4i _11c8wadc _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _4cvr1h6o _1o9zidpf _1kz6184x _bfhk1w9g _syazi7uo",
    trailingMetricEndPadding: "_y4ti303w",
    focusRingStyles: "_1ygbdfik _1ah3v77o",
    childFocusRingStyles: "_1a37dfik _1cwgv77o",
    interactiveBaseStyles: "_80omtlke _1all1b66 _qsdj1r31 _17ncglyw _15hpnqa1 _1rg815vq _1yoo15vq _j8j91snc _1afaagmp _gdbt10yn _h5vp116y _1qxz1h6o _8zx0idpf _1km4jdj5 _wc1fagmp _9408jdj5 _usew1snc _ebtnagmp _uvk910yn _10nj1r31 _1xq0glyw _18x1nqa1 _2mpsagmp",
    interactiveHoverStyles: "_17501r31 _qrsc8stv _1wodnqa1 _irr31dpa _rlyhjdj5 _1di6fcek",
    interactiveMotionStyles: "_v564k6bl _1ggl5xtf",
    activeMotionStyles: "_1reo15vq _18m915vq _8hrz1e5h",
    enteringMotionStyles: "_y44v1ukz _1bumglyw",
    exitingMotionStyles: "_y44v12ef _1bumglyw"
};
// For accent borders, we use the new color.border.accent.*.subtle tokens (Color300
// light / Color800 dark) which provide proper decorative-border colours
//
// Icons keep color.icon.accent.* in the default state (vibrant on the plain page
// background) and swap to color.text.accent.* in hovered/pressed states (where the
// Tag picks up a coloured background and needs guaranteed 3:1 icon contrast).
var $b8b8f1a2f4e48730$var$colorStyles = {
    gray: "_119bmsup _1ib21diz _egnk1sqi _17x31sqi _ih6z7qp0",
    blue: "_119b18hp _1ib26txe _egnk16jw _17x316jw _ih6z1dy8",
    green: "_119b5d2u _1ib217hp _egnkh55r _17x3h55r _ih6z1wnw",
    red: "_119bn9dc _1ib2nbxb _egnk9lu1 _17x39lu1 _ih6z1rtt",
    yellow: "_119b1s7j _1ib21oqg _egnkfb2s _17x3fb2s _ih6z1773",
    purple: "_119bluwt _1ib2uq3u _egnkqmo9 _17x3qmo9 _ih6z1nm4",
    lime: "_119b1m7d _1ib28645 _egnk1tco _17x31tco _ih6zz2ec",
    magenta: "_119b132u _1ib2v8hk _egnk1s8m _17x31s8m _ih6zv9ra",
    orange: "_119b1ip5 _1ib21j6y _egnkp1lv _17x3p1lv _ih6z165s",
    teal: "_119b131p _1ib28uof _egnk17qg _17x317qg _ih6z1a17"
};
// Border + icon filter styles - base state.
// Borders use the new color.border.accent.*.subtle tokens directly.
// Icons use the color.icon.accent.* tokens directly in the default state.
var $b8b8f1a2f4e48730$var$borderIconFilterStyles = {
    root: "_1h6dip4g _wi6h9ea2"
};
// Border + icon filter styles - interactive states (hover/pressed).
// Icons swap to the color.text.accent.* tokens for guaranteed 3:1 contrast
// against the coloured interactive backgrounds. Borders stay constant.
var $b8b8f1a2f4e48730$var$borderIconInteractiveFilterStyles = {
    root: "_4cvxip4g _zqoiipvw _q4ztip4g _ba35u0j8"
};
var $b8b8f1a2f4e48730$var$dropdownStyles = {
    interactive: "_irr31dpa _1di6fcek",
    selected: "_1h6dq98m _syaz6x5g _bfhk15s3 _irr3ufnl _1di6nozp",
    content: "_zulp1b66 _1reo15vq _18m915vq _1e0c116y _4cvr1h6o _16jlkb7n _1o9zkb7n _1ul9idpf",
    loadingMotion: "_k8m0brmi _1oec1ign _6fl4indk _sedtglyw",
    loadingOverlayMotion: "_j7hq1bym _5sag1ign _1pglindk _1bumglyw",
    loadingContent: "_tzy4idpf",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw"
};
/**
 * __TagNew__
 *
 * TagNew is the visual uplift implementation of Tag
 */ var $b8b8f1a2f4e48730$var$TagNewComponent = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TagNew(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'gray' : _ref$color, text = _ref.text, elemBefore = _ref.elemBefore, href = _ref.href, linkComponent = _ref.linkComponent, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, removeButtonLabel = _ref.removeButtonLabel, onBeforeRemoveAction = _ref.onBeforeRemoveAction, onAfterRemoveAction = _ref.onAfterRemoveAction, testId = _ref.testId, maxWidth = _ref.maxWidth, _ref$hasMargin = _ref.hasMargin, hasMargin = _ref$hasMargin === void 0 ? true : _ref$hasMargin, onClick = _ref.onClick, swatchBefore = _ref.swatchBefore, swatchBeforeLabel = _ref.swatchBeforeLabel, swatchBeforeRole = _ref.swatchBeforeRole, trailingMetric = _ref.trailingMetric, other = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $b8b8f1a2f4e48730$var$_excluded);
    var normalizedText = (0, $h2ToJ.getTagText)(text);
    var _useTagRemoval = (0, $3WKjv.useTagRemoval)(onBeforeRemoveAction), status = _useTagRemoval.status, handleRemoveRequest = _useTagRemoval.handleRemoveRequest, onKeyPress = _useTagRemoval.onKeyPress, removingTag = _useTagRemoval.removingTag, showingTag = _useTagRemoval.showingTag;
    var onShrinkOutExitComplete = (0, $5FkrB.useCallback)(function() {
        onAfterRemoveAction === null || onAfterRemoveAction === void 0 || onAfterRemoveAction(normalizedText);
    }, [
        normalizedText,
        onAfterRemoveAction
    ]);
    var _useLink = (0, $1puCn.useLink)(href, linkComponent), isLink = _useLink.isLink, LinkComponent = _useLink.LinkComponent;
    var _useButtonInteraction = (0, $cT0RG.useButtonInteraction)(), isLinkHovered = _useButtonInteraction.isLinkHovered, isOverButton = _useButtonInteraction.isOverButton, isButtonFocused = _useButtonInteraction.isButtonFocused, isLinkFocused = _useButtonInteraction.isLinkFocused, buttonHandlers = _useButtonInteraction.buttonHandlers, linkHandlers = _useButtonInteraction.linkHandlers;
    var removeButton = (0, $wh4vE.useRemoveButton)({
        isRemovable: isRemovable,
        tagText: normalizedText,
        removeButtonLabel: removeButtonLabel,
        testId: testId,
        handleRemoveRequest: handleRemoveRequest,
        removingTag: removingTag,
        showingTag: showingTag,
        onKeyPress: onKeyPress,
        buttonHandlers: buttonHandlers
    });
    var isMotionEnabled = (0, $kkvYm.fg)('platform-dst-motion-uplift-labels');
    var renderTagContent = function renderTagContent(tagRef) {
        var isEntering = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var isExiting = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, other, {
            ref: tagRef,
            "data-testid": testId,
            style: maxWidth !== undefined ? {
                maxWidth: maxWidth
            } : undefined,
            className: (0, $970q7.default)([
                $b8b8f1a2f4e48730$var$styles.baseStyles,
                !hasMargin && $b8b8f1a2f4e48730$var$styles.noMarginStyles,
                $b8b8f1a2f4e48730$var$colorStyles[color],
                $b8b8f1a2f4e48730$var$borderIconFilterStyles.root,
                isLink && $b8b8f1a2f4e48730$var$styles.interactiveBaseStyles,
                isLink && $b8b8f1a2f4e48730$var$styles.focusRingStyles,
                isLink && isMotionEnabled && $b8b8f1a2f4e48730$var$styles.interactiveMotionStyles,
                (isEntering || isExiting) && $b8b8f1a2f4e48730$var$styles.activeMotionStyles,
                isEntering && $b8b8f1a2f4e48730$var$styles.enteringMotionStyles,
                isExiting && $b8b8f1a2f4e48730$var$styles.exitingMotionStyles,
                isLink && isLinkHovered && !isOverButton && $b8b8f1a2f4e48730$var$borderIconInteractiveFilterStyles.root,
                isLink && isLinkHovered && !isOverButton && $b8b8f1a2f4e48730$var$styles.interactiveHoverStyles,
                isRemovable && $b8b8f1a2f4e48730$var$styles.removableStyles,
                isLinkFocused && !isButtonFocused && $b8b8f1a2f4e48730$var$styles.childFocusRingStyles,
                !isRemovable && trailingMetric != null && trailingMetric !== '' && $b8b8f1a2f4e48730$var$styles.trailingMetricEndPadding
            ])
        }), /*#__PURE__*/ $5FkrB.createElement((0, $4GosE.LinkWrapper), {
            isLink: isLink,
            href: href,
            LinkComponent: LinkComponent,
            testId: testId,
            linkHandlers: linkHandlers,
            onClick: onClick
        }, /*#__PURE__*/ $5FkrB.createElement((0, $j5j9o.default), {
            colorKey: color,
            swatchBefore: swatchBefore,
            swatchBeforeLabel: swatchBeforeLabel,
            swatchBeforeRole: swatchBeforeRole
        }), elemBefore && /*#__PURE__*/ $5FkrB.createElement("span", {
            className: (0, $970q7.default)([
                $b8b8f1a2f4e48730$var$styles.beforeStyles
            ])
        }, elemBefore), /*#__PURE__*/ $5FkrB.createElement("span", {
            "data-tag-text": true,
            className: (0, $970q7.default)([
                $b8b8f1a2f4e48730$var$styles.textStyles
            ])
        }, normalizedText), trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ $5FkrB.createElement("span", {
            "data-testid": testId && "".concat(testId, "--metric"),
            className: (0, $970q7.default)([
                $b8b8f1a2f4e48730$var$styles.trailingMetric
            ])
        }, trailingMetric)), removeButton && /*#__PURE__*/ $5FkrB.createElement("span", {
            className: (0, $970q7.default)([
                $b8b8f1a2f4e48730$var$styles.afterStyles,
                isMotionEnabled && $b8b8f1a2f4e48730$var$styles.afterMotionStyles
            ])
        }, !isExiting && removeButton));
    };
    if (isMotionEnabled) return /*#__PURE__*/ $5FkrB.createElement((0, $59CfW.TagMotion), {
        forwardedRef: ref,
        onExitComplete: isRemovable ? onShrinkOutExitComplete : undefined,
        status: status
    }, function(_ref2) {
        var isEntering = _ref2.isEntering, isExiting = _ref2.isExiting, motionRef = _ref2.ref;
        return renderTagContent(motionRef, isEntering, isExiting);
    });
    return /*#__PURE__*/ $5FkrB.createElement((0, $4W0It.RemovableWrapper), {
        isRemovable: isRemovable,
        status: status,
        onShrinkOutExitComplete: isRemovable ? onShrinkOutExitComplete : undefined
    }, renderTagContent(ref));
});
var $b8b8f1a2f4e48730$export$aba6bd1190e79361 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TagDropdownTrigger(_ref3, ref) {
    var _ref3$color = _ref3.color, color = _ref3$color === void 0 ? 'gray' : _ref3$color, text = _ref3.text, elemBefore = _ref3.elemBefore, testId = _ref3.testId, maxWidth = _ref3.maxWidth, _ref3$hasMargin = _ref3.hasMargin, hasMargin = _ref3$hasMargin === void 0 ? true : _ref3$hasMargin, onClick = _ref3.onClick, _ref3$isSelected = _ref3.isSelected, isSelected = _ref3$isSelected === void 0 ? false : _ref3$isSelected, _ref3$isLoading = _ref3.isLoading, isLoading = _ref3$isLoading === void 0 ? false : _ref3$isLoading, _analyticsContext = _ref3.analyticsContext, _ref3$hasChevron = _ref3.hasChevron, hasChevron = _ref3$hasChevron === void 0 ? true : _ref3$hasChevron, swatchBefore = _ref3.swatchBefore, swatchBeforeLabel = _ref3.swatchBeforeLabel, swatchBeforeRole = _ref3.swatchBeforeRole, trailingMetric = _ref3.trailingMetric, other = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref3, $b8b8f1a2f4e48730$var$_excluded2);
    var resolvedColor = (0, $41QTh.colorMapping)[color] || 'gray';
    var isMotionEnabled = (0, $kkvYm.fg)('platform-dst-motion-uplift-labels');
    return /*#__PURE__*/ $5FkrB.createElement((0, $btdNC.Pressable), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: ref,
        xcss: (0, $hUFig.cx)($b8b8f1a2f4e48730$var$styles.baseStyles, !hasMargin && $b8b8f1a2f4e48730$var$styles.noMarginStyles, $b8b8f1a2f4e48730$var$colorStyles[resolvedColor], $b8b8f1a2f4e48730$var$borderIconFilterStyles.root, $b8b8f1a2f4e48730$var$dropdownStyles.interactive, $b8b8f1a2f4e48730$var$styles.focusRingStyles, $b8b8f1a2f4e48730$var$borderIconInteractiveFilterStyles.root, isSelected && $b8b8f1a2f4e48730$var$dropdownStyles.selected, isMotionEnabled && $b8b8f1a2f4e48730$var$styles.interactiveMotionStyles, // Reduce end padding when trailing metric is the last element (no chevron)
        !hasChevron && trailingMetric != null && trailingMetric !== '' && $b8b8f1a2f4e48730$var$styles.trailingMetricEndPadding),
        onClick: isLoading ? undefined : onClick,
        style: {
            borderColor: isSelected ? "var(--ds-border-selected, #1868DB)" : undefined,
            cursor: isLoading ? 'progress' : 'pointer',
            maxWidth: maxWidth !== undefined ? maxWidth : undefined
        }
    }, isLoading && {
        'aria-busy': true,
        'aria-disabled': true,
        isDisabled: true
    }, {
        testId: testId
    }, other), /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            $b8b8f1a2f4e48730$var$dropdownStyles.content,
            isMotionEnabled && $b8b8f1a2f4e48730$var$dropdownStyles.loadingMotion,
            isLoading && $b8b8f1a2f4e48730$var$dropdownStyles.loadingContent
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $j5j9o.default), {
        colorKey: resolvedColor,
        swatchBefore: swatchBefore,
        swatchBeforeLabel: swatchBeforeLabel,
        swatchBeforeRole: swatchBeforeRole
    }), elemBefore && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            $b8b8f1a2f4e48730$var$styles.beforeStyles,
            isSelected && $b8b8f1a2f4e48730$var$styles.beforeStylesSelected
        ])
    }, elemBefore), /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-tag-text": true,
        className: (0, $970q7.default)([
            $b8b8f1a2f4e48730$var$styles.textStyles,
            isSelected && $b8b8f1a2f4e48730$var$styles.textStylesSelected
        ])
    }, (0, $h2ToJ.getTagText)(text)), trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId && "".concat(testId, "--metric"),
        className: (0, $970q7.default)([
            $b8b8f1a2f4e48730$var$styles.trailingMetric
        ])
    }, trailingMetric), hasChevron && /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($h19KG))), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && "".concat(testId, "--chevron")
    })), isLoading && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            $b8b8f1a2f4e48730$var$dropdownStyles.loadingOverlay,
            isMotionEnabled && $b8b8f1a2f4e48730$var$dropdownStyles.loadingOverlayMotion
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $9ztDu.default), {
        size: 'xsmall',
        label: ", Loading",
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    })));
});
/**
 * __Tag new__
 */ var $b8b8f1a2f4e48730$var$TagNew = (0, $chQYe.markAsTagMotionCapable)(/*#__PURE__*/ (0, $5FkrB.memo)($b8b8f1a2f4e48730$var$TagNewComponent));
var $b8b8f1a2f4e48730$export$2e2bcd8739ae039 = $b8b8f1a2f4e48730$var$TagNew;

});
parcelRegister("4GosE", function(module, exports) {
$parcel$export(module.exports, "LinkWrapper", () => $368e0f23b26ce11b$export$ce4b6a469c26f53f);

var $5FkrB = parcelRequire("5FkrB");
function $368e0f23b26ce11b$export$ce4b6a469c26f53f(_ref) {
    var isLink = _ref.isLink, href = _ref.href, LinkComponent = _ref.LinkComponent, testId = _ref.testId, children = _ref.children, onClick = _ref.onClick, linkHandlers = _ref.linkHandlers;
    if (isLink && href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LinkComponent, {
        href: href,
        testId: testId ? "".concat(testId, "--link") : undefined,
        onClick: onClick,
        onMouseEnter: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseEnter,
        onMouseLeave: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseLeave,
        onMouseDown: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseDown,
        onFocus: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onFocus,
        onBlur: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onBlur
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, children);
}

});

parcelRegister("4W0It", function(module, exports) {
$parcel$export(module.exports, "RemovableWrapper", () => $397d2277a1742ba4$export$898a500849bb5cf4);
/* removable-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ /**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $Ew39N = parcelRequire("Ew39N");
var $dqo70 = parcelRequire("dqo70");

var $1ePVu = parcelRequire("1ePVu");
/**
 * Stable key so ExitingPersistence can match this child across the remove transition
 * (see ShrinkOut + ExitingPersistence docs in @atlaskit/motion).
 */ var $397d2277a1742ba4$var$removableShrinkOutChildKey = 'atlaskit-tag-removable-shrink-out';
var $397d2277a1742ba4$var$motionWrapperStyles = null;
function $397d2277a1742ba4$export$898a500849bb5cf4(_ref) {
    var isRemovable = _ref.isRemovable, status = _ref.status, onShrinkOutExitComplete = _ref.onShrinkOutExitComplete, children = _ref.children;
    if (isRemovable) return /*#__PURE__*/ $5FkrB.createElement((0, $Ew39N.default), null, !(status === (0, $1ePVu.TagStatus).Removed) && /*#__PURE__*/ $5FkrB.createElement((0, $dqo70.default), {
        key: $397d2277a1742ba4$var$removableShrinkOutChildKey,
        onFinish: onShrinkOutExitComplete ? function(phase) {
            if (phase === 'exiting') onShrinkOutExitComplete();
        } : undefined
    }, function(motion) {
        return /*#__PURE__*/ $5FkrB.createElement("span", {
            ref: motion.ref,
            className: (0, $970q7.default)([
                "_1e0c116y"
            ])
        }, children);
    }));
    return children;
}

});
parcelRegister("1ePVu", function(module, exports) {
$parcel$export(module.exports, "TagStatus", () => $0e6f60b4b9982a21$export$74452314b63acabc);
// Tag status enum
var $0e6f60b4b9982a21$export$74452314b63acabc = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}({});

});


parcelRegister("chQYe", function(module, exports) {
$parcel$export(module.exports, "markAsTagMotionCapable", () => $8f202964259be310$export$88b132e52a65ec37);
var $8f202964259be310$var$tagMotionCapability = Symbol.for('@atlaskit/tag/motion-capable');
function $8f202964259be310$export$88b132e52a65ec37(component) {
    Object.defineProperty(component, $8f202964259be310$var$tagMotionCapability, {
        value: true
    });
    return component;
}

});

parcelRegister("j5j9o", function(module, exports) {
$parcel$export(module.exports, "default", () => $de4d56d56926245f$export$2e2bcd8739ae039);
/* swatch-before.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $de4d56d56926245f$var$tagSwatchBeforeStyles = {
    swatch: "_2rkolb4i _1bsboqnp _4t3ioqnp _1o9zidpf"
};
var $de4d56d56926245f$var$tagSwatchBeforeColorStyles = {
    gray: "_bfhk18j9",
    blue: "_bfhk115i",
    green: "_bfhk1rsu",
    red: "_bfhkkrt9",
    yellow: "_bfhk8y3s",
    purple: "_bfhk18ah",
    lime: "_bfhkbq5w",
    magenta: "_bfhk1mi6",
    orange: "_bfhk1kkj",
    teal: "_bfhktdv8"
};
function $de4d56d56926245f$export$2e2bcd8739ae039(_ref) {
    var colorKey = _ref.colorKey, swatchBefore = _ref.swatchBefore, swatchBeforeLabel = _ref.swatchBeforeLabel, swatchBeforeRole = _ref.swatchBeforeRole;
    if (swatchBefore === undefined || swatchBefore === false) return null;
    if (swatchBefore === true) return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, swatchBeforeLabel && swatchBeforeRole ? {
        'aria-label': swatchBeforeLabel,
        role: swatchBeforeRole
    } : {}, {
        className: (0, $970q7.default)([
            $de4d56d56926245f$var$tagSwatchBeforeStyles.swatch,
            $de4d56d56926245f$var$tagSwatchBeforeColorStyles[colorKey]
        ])
    }));
    return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, swatchBeforeLabel && swatchBeforeRole ? {
        'aria-label': swatchBeforeLabel,
        role: swatchBeforeRole
    } : {}, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            backgroundColor: swatchBefore
        },
        className: (0, $970q7.default)([
            $de4d56d56926245f$var$tagSwatchBeforeStyles.swatch
        ])
    }));
}

});

parcelRegister("59CfW", function(module, exports) {
$parcel$export(module.exports, "TagMotion", () => $3c0b77e0928a7dc6$export$6adae1772ccf137c);
/* tag-motion.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");


var $iO8GM = parcelRequire("iO8GM");

var $ZBv4y = parcelRequire("ZBv4y");

var $Ew39N = parcelRequire("Ew39N");

var $3woLB = parcelRequire("3woLB");

var $cSMlO = parcelRequire("cSMlO");

var $1ePVu = parcelRequire("1ePVu");
var $3c0b77e0928a7dc6$var$tagMotionKey = 'atlaskit-tag-motion';
function $3c0b77e0928a7dc6$var$TagMotionContent(_ref) {
    var children = _ref.children, forwardedRef = _ref.forwardedRef, onExitComplete = _ref.onExitComplete;
    var _useMotion = (0, $cSMlO.useMotion)({
        onFinish: function onFinish(phase) {
            if (phase === 'exiting') onExitComplete === null || onExitComplete === void 0 || onExitComplete();
        }
    }), motionRef = _useMotion.ref, state = _useMotion.state;
    var mergedRef = (0, $5FkrB.useMemo)(function() {
        return (0, $iO8GM.default)([
            forwardedRef,
            motionRef
        ]);
    }, [
        forwardedRef,
        motionRef
    ]);
    return children({
        isEntering: state === 'entering',
        isExiting: state === 'exiting',
        ref: mergedRef
    });
}
function $3c0b77e0928a7dc6$export$6adae1772ccf137c(_ref2) {
    var children = _ref2.children, forwardedRef = _ref2.forwardedRef, onExitComplete = _ref2.onExitComplete, status = _ref2.status;
    var hasCompletedReducedMotionExit = (0, $5FkrB.useRef)(false);
    var outerPresence = (0, $3woLB.useExitingPersistence)();
    var isRemoved = status === (0, $1ePVu.TagStatus).Removed || outerPresence.isExiting;
    var shouldAppear = outerPresence.isInsideExitingPersistence && outerPresence.appear && !outerPresence.isExiting;
    var latestExitState = (0, $5FkrB.useRef)({
        onExitComplete: onExitComplete,
        outerPresence: outerPresence,
        status: status
    });
    latestExitState.current = {
        onExitComplete: onExitComplete,
        outerPresence: outerPresence,
        status: status
    };
    var onMotionExitComplete = (0, $5FkrB.useCallback)(function() {
        var latest = latestExitState.current;
        if (latest.outerPresence.isExiting) {
            var _latest$outerPresence, _latest$outerPresence2;
            (_latest$outerPresence = (_latest$outerPresence2 = latest.outerPresence).onFinish) === null || _latest$outerPresence === void 0 || _latest$outerPresence.call(_latest$outerPresence2);
        }
        if (latest.status === (0, $1ePVu.TagStatus).Removed) {
            var _latest$onExitComplet;
            (_latest$onExitComplet = latest.onExitComplete) === null || _latest$onExitComplet === void 0 || _latest$onExitComplet.call(latest);
        }
    }, []);
    (0, $5FkrB.useEffect)(function() {
        if (isRemoved && (0, $ZBv4y.isReducedMotion)() && !hasCompletedReducedMotionExit.current) {
            hasCompletedReducedMotionExit.current = true;
            onMotionExitComplete();
        }
    }, [
        isRemoved,
        onMotionExitComplete
    ]);
    return /*#__PURE__*/ $5FkrB.createElement((0, $Ew39N.default), {
        appear: shouldAppear
    }, !isRemoved && /*#__PURE__*/ $5FkrB.createElement($3c0b77e0928a7dc6$var$TagMotionContent, {
        key: $3c0b77e0928a7dc6$var$tagMotionKey,
        forwardedRef: forwardedRef,
        onExitComplete: onMotionExitComplete
    }, children));
}

});

parcelRegister("cT0RG", function(module, exports) {
$parcel$export(module.exports, "useButtonInteraction", () => $961b4ad410ffee71$export$84acd183858d8235);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $961b4ad410ffee71$export$84acd183858d8235() {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isLinkHovered = _useState2[0], setIsLinkHovered = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), isOverButton = _useState4[0], setIsOverButton = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), isButtonFocused = _useState6[0], setIsButtonFocused = _useState6[1];
    var _useState7 = (0, $5FkrB.useState)(false), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState7, 2), isLinkFocused = _useState8[0], setIsLinkFocused = _useState8[1];
    // Track if last interaction was via mouse (to determine keyboard vs mouse focus)
    var hadMouseDownRef = (0, $5FkrB.useRef)(false);
    // Button handlers
    var buttonHandlers = (0, $5FkrB.useMemo)(function() {
        return {
            onMouseEnter: function onMouseEnter() {
                return setIsOverButton(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setIsOverButton(false);
            },
            onMouseDown: function onMouseDown(e) {
                // Prevent the browser from moving focus to the remove button on mousedown.
                // Without this, parent composite widgets (e.g. Select) lose input focus when
                // the user clicks remove, triggering unwanted blur side-effects.
                e === null || e === void 0 || e.preventDefault();
                hadMouseDownRef.current = true;
            },
            onFocus: function onFocus() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsButtonFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function onBlur() {
                return setIsButtonFocused(false);
            }
        };
    }, []);
    // Link handlers - includes hover tracking
    var linkHandlers = (0, $5FkrB.useMemo)(function() {
        return {
            onMouseEnter: function onMouseEnter() {
                return setIsLinkHovered(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setIsLinkHovered(false);
            },
            onMouseDown: function onMouseDown() {
                hadMouseDownRef.current = true;
            },
            onFocus: function onFocus() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsLinkFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function onBlur() {
                return setIsLinkFocused(false);
            }
        };
    }, []);
    return {
        isLinkHovered: isLinkHovered,
        isOverButton: isOverButton,
        isButtonFocused: isButtonFocused,
        isLinkFocused: isLinkFocused,
        buttonHandlers: buttonHandlers,
        linkHandlers: linkHandlers
    };
}

});

parcelRegister("1puCn", function(module, exports) {
$parcel$export(module.exports, "useLink", () => $106fe0546e938070$export$dcf14c9974fe2767);

var $8F9hT = parcelRequire("8F9hT");
function $106fe0546e938070$export$dcf14c9974fe2767(href, linkComponent) {
    var isLink = Boolean(href);
    var LinkComponent = linkComponent !== null && linkComponent !== void 0 ? linkComponent : (0, $8F9hT.default);
    return {
        isLink: isLink,
        LinkComponent: LinkComponent
    };
}

});

parcelRegister("wh4vE", function(module, exports) {
$parcel$export(module.exports, "useRemoveButton", () => $06103b5d456d647f$export$97d8be09cd53869b);
/**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $4VJDZ = parcelRequire("4VJDZ");
function $06103b5d456d647f$export$97d8be09cd53869b(_ref) {
    var isRemovable = _ref.isRemovable, tagText = _ref.tagText, removeButtonLabel = _ref.removeButtonLabel, testId = _ref.testId, handleRemoveRequest = _ref.handleRemoveRequest, removingTag = _ref.removingTag, showingTag = _ref.showingTag, onKeyPress = _ref.onKeyPress, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? 'default' : _ref$shape, buttonHandlers = _ref.buttonHandlers;
    var handleFocus = (0, $5FkrB.useCallback)(function() {
        removingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onFocus();
    }, [
        removingTag,
        buttonHandlers
    ]);
    var handleBlur = (0, $5FkrB.useCallback)(function() {
        showingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onBlur();
    }, [
        showingTag,
        buttonHandlers
    ]);
    return (0, $5FkrB.useMemo)(function() {
        if (!isRemovable) return undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4VJDZ.default), {
            "aria-label": "".concat(removeButtonLabel || 'Remove', " ").concat(tagText),
            onClick: handleRemoveRequest,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyPress: onKeyPress,
            onMouseEnter: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseEnter,
            onMouseLeave: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseLeave,
            onMouseDown: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseDown,
            testId: testId ? "close-button-".concat(testId) : undefined,
            shape: shape
        });
    }, [
        isRemovable,
        removeButtonLabel,
        tagText,
        handleRemoveRequest,
        handleFocus,
        handleBlur,
        onKeyPress,
        buttonHandlers,
        testId,
        shape
    ]);
}

});
parcelRegister("4VJDZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $396fe43deca37097$export$2e2bcd8739ae039);
/* remove-button.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");


var $hRJ5R = parcelRequire("hRJ5R");

var $ac8VW = parcelRequire("ac8VW");

var $kkvYm = parcelRequire("kkvYm");

var $btdNC = parcelRequire("btdNC");
var $396fe43deca37097$var$removeButtonStyles = {
    root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i1j6v _1bsb1j6v _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah3idpf _irr31dpa _1di6fcek",
    circle: "_2rko1rr0 _1ah3idpf",
    focusRing: "_1ah3v77o",
    newIcon: "_rjxpv77o"
};
var $396fe43deca37097$var$RemoveButton = function RemoveButton(_ref) {
    var ariaLabel = _ref['aria-label'], onClick = _ref.onClick, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onKeyPress = _ref.onKeyPress, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onMouseDown = _ref.onMouseDown, onMouseUp = _ref.onMouseUp, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, testId = _ref.testId, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? 'default' : _ref$shape;
    return /*#__PURE__*/ $5FkrB.createElement((0, $btdNC.Pressable), {
        xcss: (0, $hRJ5R.cx)($396fe43deca37097$var$removeButtonStyles.root, shape === 'circle' && $396fe43deca37097$var$removeButtonStyles.circle, $396fe43deca37097$var$removeButtonStyles.newIcon, (0, $kkvYm.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && $396fe43deca37097$var$removeButtonStyles.focusRing),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: testId
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ac8VW))), {
        color: "currentColor",
        label: "",
        size: "small"
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$396fe43deca37097$export$2e2bcd8739ae039 = $396fe43deca37097$var$RemoveButton;

});


parcelRegister("3WKjv", function(module, exports) {
$parcel$export(module.exports, "useTagRemoval", () => $2dfab6cf7c24c531$export$f26019543e9f862f);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $lJICD = parcelRequire("lJICD");

var $1ePVu = parcelRequire("1ePVu");
function $2dfab6cf7c24c531$export$f26019543e9f862f(onBeforeRemoveAction) {
    var _useState = (0, $5FkrB.useState)((0, $1ePVu.TagStatus).Showing), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var handleRemoveRequest = (0, $5FkrB.useCallback)(function() {
        var beforeAction = onBeforeRemoveAction !== null && onBeforeRemoveAction !== void 0 ? onBeforeRemoveAction : (0, $lJICD.defaultBeforeRemoveAction);
        if (beforeAction()) // Defer onAfterRemoveAction until ShrinkOut's onFinish so ExitingPersistence can run
        // the exit animation (e.g. in multi-select and user pickers).
        setStatus((0, $1ePVu.TagStatus).Removed);
    }, [
        onBeforeRemoveAction
    ]);
    var onKeyPress = (0, $5FkrB.useCallback)(function(e) {
        var spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    var removingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus((0, $1ePVu.TagStatus).Removing);
    }, []);
    var showingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus((0, $1ePVu.TagStatus).Showing);
    }, []);
    return {
        status: status,
        handleRemoveRequest: handleRemoveRequest,
        onKeyPress: onKeyPress,
        removingTag: removingTag,
        showingTag: showingTag
    };
}

});
parcelRegister("lJICD", function(module, exports) {
$parcel$export(module.exports, "defaultBeforeRemoveAction", () => $fd3069f7666ca009$export$279e7025ed114474);
var $fd3069f7666ca009$export$279e7025ed114474 = function defaultBeforeRemoveAction() {
    return true;
};

});



parcelRegister("dENoG", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f1554013c6da3e8$export$2e2bcd8739ae039);
/* base.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $9f1554013c6da3e8$var$_excluded = [
    "before",
    "contentElement",
    "after",
    "testId",
    "style",
    "color",
    "href",
    "className"
];
function $9f1554013c6da3e8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9f1554013c6da3e8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9f1554013c6da3e8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9f1554013c6da3e8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Border colors - Hardcoded for Visual Refresh - to be removed with labelling system work
var $9f1554013c6da3e8$var$borderColors = {
    standard: "_1h6d14je",
    blue: "_1h6duisw",
    red: "_1h6da2c0",
    yellow: "_1h6deh2r",
    green: "_1h6d18uw",
    teal: "_1h6d1ug6",
    purple: "_1h6d157s",
    lime: "_1h6dn0nx",
    magenta: "_1h6d1lf6",
    orange: "_1h6dh727",
    grey: "_1h6d14je",
    standardLink: "_1h6d14je",
    blueLight: "_1h6duisw",
    redLight: "_1h6da2c0",
    yellowLight: "_1h6deh2r",
    greenLight: "_1h6d18uw",
    tealLight: "_1h6d1ug6",
    purpleLight: "_1h6d157s",
    limeLight: "_1h6dn0nx",
    magentaLight: "_1h6d1lf6",
    orangeLight: "_1h6dh727",
    greyLight: "_1h6d14je"
};
var $9f1554013c6da3e8$var$baseStyles = null;
var $9f1554013c6da3e8$var$interactiveStyles = null;
var $9f1554013c6da3e8$var$focusRingStyles = null;
var $9f1554013c6da3e8$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function BaseTag(_ref, ref) {
    var before = _ref.before, contentElement = _ref.contentElement, after = _ref.after, testId = _ref.testId, style = _ref.style, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, className = _ref.className, other = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $9f1554013c6da3e8$var$_excluded);
    var isLink = Boolean(href);
    var isRemovable = Boolean(after);
    var isInteractive = isLink || isRemovable;
    if (color === 'gray') // internally we use 'grey' for gray color so that we can make migration easier behind the ff (gray will work with and without ff now)
    color = 'grey';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, other, {
        ref: ref,
        style: $9f1554013c6da3e8$var$_objectSpread({}, style),
        className: (0, $970q7.default)([
            "_zulp1b66 _2rko12b0 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3i1k92 _kqswh2mm _4cvr1h6o _bfhksm61 _syazi7uo _80om73ad",
            isInteractive && "_1e38dfik _7glxv77o",
            isLink && "_irr31dpa _1di6fcek",
            $9f1554013c6da3e8$var$borderColors[color],
            className
        ]),
        "data-testid": testId
    }), before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9f1554013c6da3e8$export$2e2bcd8739ae039 = $9f1554013c6da3e8$var$BaseTag;

});

parcelRegister("ldwMZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7243f206888d2c9$export$2e2bcd8739ae039);
/* before.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $f7243f206888d2c9$var$beforeElementStyles = null;
var $f7243f206888d2c9$var$Before = function Before(_ref) {
    var elemBefore = _ref.elemBefore;
    return elemBefore ? /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            "_1e0c1txw _4t3i1j6v _4cvr1h6o _1bah1h6o _152tze3t"
        ])
    }, elemBefore) : null;
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f7243f206888d2c9$export$2e2bcd8739ae039 = $f7243f206888d2c9$var$Before;

});

parcelRegister("hxdc0", function(module, exports) {
$parcel$export(module.exports, "getLozengeAppearance", () => $cc3fc08b4415b7d7$export$4d9e331cafeacb9d);
/**
 * Maps Tag color values to Lozenge appearance values.
 * Used for migration_fallback rendering when feature flag is off.
 */ var $cc3fc08b4415b7d7$var$colorToLozengeAppearanceMap = {
    gray: 'default',
    grey: 'default',
    lime: 'success',
    green: 'success',
    blue: 'inprogress',
    red: 'removed',
    purple: 'new',
    yellow: 'moved',
    orange: 'moved',
    magenta: 'new',
    teal: 'inprogress',
    grayLight: 'default',
    greyLight: 'default',
    limeLight: 'success',
    greenLight: 'success',
    blueLight: 'inprogress',
    redLight: 'removed',
    purpleLight: 'new',
    yellowLight: 'moved',
    orangeLight: 'moved',
    magentaLight: 'new',
    tealLight: 'inprogress'
};
function $cc3fc08b4415b7d7$export$4d9e331cafeacb9d(color) {
    return $cc3fc08b4415b7d7$var$colorToLozengeAppearanceMap[color || 'gray'] || 'default';
}

});

parcelRegister("87KeV", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ea2d8680c8ed83a$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $h2ToJ = parcelRequire("h2ToJ");
var $5ea2d8680c8ed83a$var$baseStyles = null;
var $5ea2d8680c8ed83a$var$linkStyles = null;
var $5ea2d8680c8ed83a$var$hasAfterStyles = null;
var $5ea2d8680c8ed83a$var$Content = function Content(_ref) {
    var _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? '' : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, linkComponent = _ref.linkComponent, testId = _ref.testId;
    var Link = linkComponent !== null && linkComponent !== void 0 ? linkComponent : 'a';
    var normalizedText = (0, $h2ToJ.getTagText)(text);
    if (href) return /*#__PURE__*/ $5FkrB.createElement(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? "".concat(testId, "--link") : undefined,
        className: (0, $970q7.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazi7uo _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3i7uo _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
            isRemovable && "_p12f1lit"
        ])
    }, normalizedText);
    else return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            isRemovable && "_p12f1lit"
        ])
    }, normalizedText);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5ea2d8680c8ed83a$export$2e2bcd8739ae039 = $5ea2d8680c8ed83a$var$Content;

});


parcelRegister("6Uwhr", function(module, exports) {
$parcel$export(module.exports, "useSelectGetStyles", () => $50810336fdb79afd$export$2a533455c10aa11f);
/**
 * Hook to consume the SelectGetStylesContext.
 *
 * @internal — not part of the public API
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $7rzUZ = parcelRequire("7rzUZ");
var $50810336fdb79afd$export$2a533455c10aa11f = function useSelectGetStyles() {
    return (0, $5FkrB.useContext)((0, $7rzUZ.SelectGetStylesContext));
};

});
parcelRegister("7rzUZ", function(module, exports) {
$parcel$export(module.exports, "SelectGetStylesContext", () => $56b6eaa0b87956ad$export$50727c0a52da4015);
/**
 * Internal context used to pass the original Select instance's getStyles function
 * down to components like MultiValue, without polluting the public CommonProps API.
 *
 * This allows MultiValue to detect whether getStyles has been overridden on a
 * component instance (e.g. via a custom component wrapper passing a different
 * getStyles prop), by comparing props.getStyles against the original.
 *
 * @internal — not part of the public API
 */ 
var $5FkrB = parcelRequire("5FkrB");
var $56b6eaa0b87956ad$export$50727c0a52da4015 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);

});


parcelRegister("1VviI", function(module, exports) {
$parcel$export(module.exports, "MultiValueLabel", () => $167364fe8f9ee209$export$544aeea2a5ce08ee);
/* multi-value-label.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");
var $167364fe8f9ee209$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c8fhey _o5721q9c _y4tiv77o _bozg1b66 _syaz1kw7",
    disabled: "_syaz1gmx",
    ellipsis: "_1bto1l2s"
};
var $167364fe8f9ee209$export$544aeea2a5ce08ee = function MultiValueLabel(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isDisabled = _ref.isDisabled, hasEllipsis = _ref.hasEllipsis, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $167364fe8f9ee209$var$multiValueLabelStyles.root,
            isDisabled && $167364fe8f9ee209$var$multiValueLabelStyles.disabled,
            hasEllipsis && $167364fe8f9ee209$var$multiValueLabelStyles.ellipsis,
            (0, $hUFig.cx)(className, xcss, '-MultiValueLabel')
        ])
    }), children);
};

});


parcelRegister("dqeFX", function(module, exports) {
$parcel$export(module.exports, "MultiValueRemove", () => $9c59165fc5bcc906$export$8e1fd1a40e7a2f4a);
/* multi-value-remove.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $ac8VW = parcelRequire("ac8VW");
var $9c59165fc5bcc906$var$disabledStyles = null;
var $9c59165fc5bcc906$var$enabledStyles = null;
var $9c59165fc5bcc906$var$multiValueRemoveStyles = {
    focused: "_bfhkb1q9 _lswu6x5g",
    root: "_19itglyw _2rko12b0 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _1e0c1txw _lswui7uo _1q51v77o _y4tiv77o _85i5v77o _bozgv77o _12l2v77o _1ah312gs _irr31dpa _13br1tmw _1di6fcek _i5f81tmw"
};
function $9c59165fc5bcc906$export$8e1fd1a40e7a2f4a(_ref) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, innerProps = _ref.innerProps, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $9c59165fc5bcc906$var$multiValueRemoveStyles.root,
            isFocused && $9c59165fc5bcc906$var$multiValueRemoveStyles.focused,
            (0, $hUFig.cx)(className, xcss, '-MultiValueRemove')
        ])
    }), /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
        className: (0, $970q7.default)([
            isDisabled && "_1e0cglyw",
            !isDisabled && "_1e0c1kw7"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ac8VW))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
}

});

parcelRegister("luzWk", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa584738d3bc7a92$export$2e2bcd8739ae039);
/* option.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $2goCw = parcelRequire("2goCw");

var $5rHW6 = parcelRequire("5rHW6");
var $fa584738d3bc7a92$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syazi7uo _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di6fcek",
    disabled: "_syaz1gmx _80om13gf _bfhk1j28 _16qsglyw _1di61j28 _112eglyw",
    focused: "_bfhk1dpa _16qs1x9r _112e5u6v",
    selected: "_syaz6x5g _bfhk15s3 _16qs1x9r _1di6nozp _112e5u6v",
    focusedSelected: "_bfhkufnl",
    motion: "_v564hxmd _o7kshxmd _1ggl87vo",
    motionSelected: "_v5641rrn _o7kshxmd"
};
var $fa584738d3bc7a92$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $5rHW6.getStyleProps)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $fa584738d3bc7a92$var$optionStyles.root,
            !isDisabled && !isSelected && (0, $2goCw.fg)('platform-dst-motion-uplift-list-item') && $fa584738d3bc7a92$var$optionStyles.motion,
            isFocused && $fa584738d3bc7a92$var$optionStyles.focused,
            isSelected && $fa584738d3bc7a92$var$optionStyles.selected,
            isFocused && isSelected && $fa584738d3bc7a92$var$optionStyles.focusedSelected,
            !isDisabled && isSelected && (0, $2goCw.fg)('platform-dst-motion-uplift-list-item') && $fa584738d3bc7a92$var$optionStyles.motionSelected,
            isDisabled && $fa584738d3bc7a92$var$optionStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-option')
        ]),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fa584738d3bc7a92$export$2e2bcd8739ae039 = $fa584738d3bc7a92$var$Option;

});

parcelRegister("4l44U", function(module, exports) {
$parcel$export(module.exports, "default", () => $328c496bdc27f3d2$export$2e2bcd8739ae039);
/* placeholder.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $5rHW6 = parcelRequire("5rHW6");
var $328c496bdc27f3d2$var$placeholderStyles = {
    root: "_nd5l1sux _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syaz1rpy",
    disabled: "_syaz1gmx"
};
var $328c496bdc27f3d2$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, xcss = props.xcss;
    var _getStyleProps = (0, $5rHW6.getStyleProps)(props, 'placeholder', {
        placeholder: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $328c496bdc27f3d2$var$placeholderStyles.root,
            isDisabled && $328c496bdc27f3d2$var$placeholderStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-placeholder')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$328c496bdc27f3d2$export$2e2bcd8739ae039 = $328c496bdc27f3d2$var$Placeholder;

});

parcelRegister("jW1m1", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8347c0841cf8c1f$export$2e2bcd8739ae039);
/* single-value.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $5rHW6 = parcelRequire("5rHW6");
var $e8347c0841cf8c1f$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syazi7uo",
    disalbed: "_syaz1gmx"
};
var $e8347c0841cf8c1f$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $5rHW6.getStyleProps)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $e8347c0841cf8c1f$var$styles.root,
            isDisabled && $e8347c0841cf8c1f$var$styles.disalbed,
            (0, $hUFig.cx)(className, xcss, '-singleValue')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e8347c0841cf8c1f$export$2e2bcd8739ae039 = $e8347c0841cf8c1f$var$SingleValue;

});


parcelRegister("jOlL3", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6c39084849be6f2$export$2e2bcd8739ae039);
/* dummy-input.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $e6c39084849be6f2$var$_excluded = [
    "innerRef"
];
var $e6c39084849be6f2$var$removeProps = function removeProps(propsObj) {
    for(var _len = arguments.length, properties = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)properties[_key - 1] = arguments[_key];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $e6c39084849be6f2$var$dummyInputStyles = null;
function $e6c39084849be6f2$export$2e2bcd8739ae039(_ref5) {
    var innerRef = _ref5.innerRef, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref5, $e6c39084849be6f2$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = $e6c39084849be6f2$var$removeProps(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: innerRef,
        className: (0, $970q7.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d1j28 _syaz1j28 _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ])
    }, filteredProps));
}

});

parcelRegister("6muHy", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a1c9cd24c148cee$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $hri2Q = parcelRequire("hri2Q");

var $lMuYC = parcelRequire("lMuYC");
function $4a1c9cd24c148cee$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4a1c9cd24c148cee$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4a1c9cd24c148cee$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4a1c9cd24c148cee$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Root Container
// ==============================
var $4a1c9cd24c148cee$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isOptionDisabled = selectProps.isOptionDisabled, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, isLoading = selectProps.isLoading;
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $5FkrB.useMemo)(function() {
        return $4a1c9cd24c148cee$var$_objectSpread($4a1c9cd24c148cee$var$_objectSpread({}, (0, $hri2Q.defaultAriaLiveMessages)), ariaLiveMessages);
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $5FkrB.useMemo)(function() {
        var message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            var onChangeProps = $4a1c9cd24c148cee$var$_objectSpread({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    var ariaResults = (0, $5FkrB.useMemo)(function() {
        var resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ScreenReaderText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        id: "aria-results"
    }, ariaResults));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $lMuYC.default), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $lMuYC.default), {
        "aria-live": ariaLive // Should be undefined by default unless a specific use case requires it
        ,
        role: "status"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4a1c9cd24c148cee$export$2e2bcd8739ae039 = $4a1c9cd24c148cee$var$LiveRegion;

});
parcelRegister("hri2Q", function(module, exports) {
$parcel$export(module.exports, "defaultAriaLiveMessages", () => $cb22f4a117984b93$export$a7265767c78f9bae);
var $cb22f4a117984b93$export$a7265767c78f9bae = {
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? "option ".concat(label, ", deselected") : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? "option ".concat(label, ", selected.") : '';
            default:
                return '';
        }
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return inputValue ? "".concat(resultsMessage, " for search term ").concat(inputValue, ".") : '';
    }
};

});

parcelRegister("lMuYC", function(module, exports) {
$parcel$export(module.exports, "default", () => $fdb61bf9e9002f05$export$2e2bcd8739ae039);
/* a11y-text.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
// Assistive text to describe visual elements. Hidden for sighted users.
var $fdb61bf9e9002f05$var$styles = null;
var $fdb61bf9e9002f05$var$A11yText = function A11yText(props) {
    return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _uiztglyw _o5721q9c",
            "-a11yText"
        ])
    }, props));
};
var $fdb61bf9e9002f05$export$2e2bcd8739ae039 = $fdb61bf9e9002f05$var$A11yText;

});


parcelRegister("liCzk", function(module, exports) {
$parcel$export(module.exports, "default", () => $f81932667ad0d199$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");

var $2goCw = parcelRequire("2goCw");

var $dI0Ja = parcelRequire("dI0Ja");
function $f81932667ad0d199$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f81932667ad0d199$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f81932667ad0d199$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f81932667ad0d199$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f81932667ad0d199$var$noop = (0, $eVb4V.default);
function $f81932667ad0d199$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
function $f81932667ad0d199$var$isDocumentElement(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $f81932667ad0d199$var$normalizedHeight(el) {
    if ($f81932667ad0d199$var$isDocumentElement(el)) return window.innerHeight;
    return el.clientHeight;
}
function $f81932667ad0d199$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($f81932667ad0d199$var$isDocumentElement(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $f81932667ad0d199$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $f81932667ad0d199$var$getScrollTop(el) {
    if ($f81932667ad0d199$var$isDocumentElement(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $f81932667ad0d199$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $f81932667ad0d199$var$noop;
    var start = $f81932667ad0d199$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $f81932667ad0d199$var$easeOutCubic(currentTime, start, change, duration);
        $f81932667ad0d199$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $f81932667ad0d199$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $f81932667ad0d199$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $f81932667ad0d199$var$normalizedHeight(scrollParent);
    var scrollTop = $f81932667ad0d199$var$getScrollTop(scrollParent);
    var menuTopFromParent = menuTop;
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTopFromParent;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $f81932667ad0d199$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $f81932667ad0d199$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $f81932667ad0d199$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $f81932667ad0d199$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $f81932667ad0d199$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
var $f81932667ad0d199$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
// NOTE: internal only
// eslint-disable-next-line @repo/internal/react/require-jsdoc
// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Menu placer__
 *
 * A menu placer {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ var $f81932667ad0d199$var$MenuPlacer = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView;
    var _ref2 = (0, $5FkrB.useContext)((0, $dI0Ja.PortalPlacementContext)) || {}, setPortalPlacement = _ref2.setPortalPlacement;
    var ref = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)(maxMenuHeight), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    // The minimum height of the control
    var controlHeight = 38;
    (0, $5FkrB.useLayoutEffect)(function() {
        // When the menu is hosted in the browser top layer, positioning, flipping
        // and viewport-fit are all handled by `@atlaskit/top-layer`. The placer
        // becomes a pass-through that only forwards `maxMenuHeight` as a cap.
        if ((0, $2goCw.fg)('platform-dst-top-layer')) return;
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $f81932667ad0d199$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: $f81932667ad0d199$var$_objectSpread($f81932667ad0d199$var$_objectSpread({}, props), {}, {
            placement: placement || $f81932667ad0d199$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $f81932667ad0d199$export$2e2bcd8739ae039 = $f81932667ad0d199$var$MenuPlacer;

});

parcelRegister("3yr7f", function(module, exports) {
$parcel$export(module.exports, "createFilter", () => $296994bcb992c677$export$5d81789ff4aeccdf);

var $25nEq = parcelRequire("25nEq");

var $cvlyC = parcelRequire("cvlyC");

var $jH4Ey = parcelRequire("jH4Ey");
function $296994bcb992c677$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $296994bcb992c677$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $296994bcb992c677$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $296994bcb992c677$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $296994bcb992c677$var$memoizedStripDiacriticsForInput = (0, $cvlyC.default)((0, $jH4Ey.stripDiacritics));
var $296994bcb992c677$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $296994bcb992c677$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $296994bcb992c677$export$5d81789ff4aeccdf = function createFilter(config) {
    return function(option, rawInput) {
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = $296994bcb992c677$var$_objectSpread({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $296994bcb992c677$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $296994bcb992c677$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $296994bcb992c677$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $296994bcb992c677$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $jH4Ey.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};

});
parcelRegister("jH4Ey", function(module, exports) {
$parcel$export(module.exports, "stripDiacritics", () => $e565a47a4970bd9d$export$b5bee4b27048330b);
var $e565a47a4970bd9d$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $e565a47a4970bd9d$var$anyDiacritic = new RegExp('[' + $e565a47a4970bd9d$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $e565a47a4970bd9d$var$diacriticToBase = {};
for(var $e565a47a4970bd9d$var$i = 0; $e565a47a4970bd9d$var$i < $e565a47a4970bd9d$var$diacritics.length; $e565a47a4970bd9d$var$i++){
    var $e565a47a4970bd9d$var$diacritic = $e565a47a4970bd9d$var$diacritics[$e565a47a4970bd9d$var$i];
    for(var $e565a47a4970bd9d$var$j = 0; $e565a47a4970bd9d$var$j < $e565a47a4970bd9d$var$diacritic.letters.length; $e565a47a4970bd9d$var$j++)$e565a47a4970bd9d$var$diacriticToBase[$e565a47a4970bd9d$var$diacritic.letters[$e565a47a4970bd9d$var$j]] = $e565a47a4970bd9d$var$diacritic.base;
}
var $e565a47a4970bd9d$export$b5bee4b27048330b = function stripDiacritics(str) {
    return str.replace($e565a47a4970bd9d$var$anyDiacritic, function(match) {
        return $e565a47a4970bd9d$var$diacriticToBase[match];
    });
};

});


parcelRegister("1l3Nw", function(module, exports) {
$parcel$export(module.exports, "formatGroupLabel", () => $0f9ab2c0ba42afbc$export$f4da216a6ca54656);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $0f9ab2c0ba42afbc$export$f4da216a6ca54656 = function formatGroupLabel(group) {
    return group.label;
};

});

parcelRegister("eF1OB", function(module, exports) {
$parcel$export(module.exports, "getOptionLabel", () => $aac64d78776c2baf$export$dac6ace3020563ca);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $aac64d78776c2baf$export$dac6ace3020563ca = function getOptionLabel(option) {
    return option.label;
};

});

parcelRegister("fuxeO", function(module, exports) {
$parcel$export(module.exports, "getOptionValue", () => $b47370b77ab2aa78$export$40be908210c5a79c);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $b47370b77ab2aa78$export$40be908210c5a79c = function getOptionValue(option) {
    return option.value;
};

});

parcelRegister("4JhfO", function(module, exports) {
$parcel$export(module.exports, "classNames", () => $3718bfab194873ae$export$ce4ab0c55987d1ff);
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $3718bfab194873ae$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $3718bfab194873ae$export$ce4ab0c55987d1ff(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($3718bfab194873ae$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}

});

parcelRegister("jKHAs", function(module, exports) {
$parcel$export(module.exports, "cleanValue", () => $e6141faa59684c1f$export$33f062f47f21a01);

var $ekGgq = parcelRequire("ekGgq");
var $e6141faa59684c1f$export$33f062f47f21a01 = function cleanValue(value) {
    if (Array.isArray(value)) return value.filter(Boolean);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};

});

parcelRegister("iDDR5", function(module, exports) {
$parcel$export(module.exports, "isDocumentElement", () => $d91ac8ecf508537c$export$d8a62a489b442872);
function $d91ac8ecf508537c$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}

});

parcelRegister("ecwrt", function(module, exports) {
$parcel$export(module.exports, "multiValueAsValue", () => $a56b59fee84ad09c$export$d1ca752ec761b95b);
function $a56b59fee84ad09c$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}

});

parcelRegister("i7tRn", function(module, exports) {
$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $d3100b01439ce5a7$export$17baa7c95b6ba1b8);

var $1NNLT = parcelRequire("1NNLT");
function $d3100b01439ce5a7$export$17baa7c95b6ba1b8(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose;
    (0, $1NNLT.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});

parcelRegister("i2prK", function(module, exports) {
$parcel$export(module.exports, "default", () => $d21c27103089d120$export$2e2bcd8739ae039);
/* required-input.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $eVb4V = parcelRequire("eVb4V");
var $d21c27103089d120$var$styles = null;
var $d21c27103089d120$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return /*#__PURE__*/ $5FkrB.createElement("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        className: (0, $970q7.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $eVb4V.default)
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d21c27103089d120$export$2e2bcd8739ae039 = $d21c27103089d120$var$RequiredInput;

});

parcelRegister("9LMRF", function(module, exports) {
$parcel$export(module.exports, "default", () => $71ce6855fce1ee9e$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $4wz2v = parcelRequire("4wz2v");

var $jnbB8 = parcelRequire("jnbB8");
var $71ce6855fce1ee9e$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $71ce6855fce1ee9e$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = (0, $4wz2v.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = (0, $jnbB8.default)({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, lockEnabled && /*#__PURE__*/ // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        onClick: $71ce6855fce1ee9e$var$blurSelectInput,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            position: 'fixed',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockStart: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineStart: 0
        }
    }), children(targetRef));
}

});
parcelRegister("4wz2v", function(module, exports) {
$parcel$export(module.exports, "default", () => $34b554a9e9c6b455$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $lkkWy = parcelRequire("lkkWy");
var $34b554a9e9c6b455$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $34b554a9e9c6b455$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $5FkrB.useRef)(false);
    var isTop = (0, $5FkrB.useRef)(false);
    var touchStart = (0, $5FkrB.useRef)(0);
    var scrollTarget = (0, $5FkrB.useRef)(null);
    var handleEventDelta = (0, $5FkrB.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $34b554a9e9c6b455$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $5FkrB.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $5FkrB.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $5FkrB.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $5FkrB.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $lkkWy.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $5FkrB.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}

});
parcelRegister("lkkWy", function(module, exports) {
$parcel$export(module.exports, "supportsPassiveEvents", () => $f86bb62f1de45660$export$b0622a6911dbeaf5);
// ==============================
// Passive Event Detector
// ==============================

var $eVb4V = parcelRequire("eVb4V");
var $f86bb62f1de45660$var$noop = (0, $eVb4V.default);
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $f86bb62f1de45660$var$passiveOptionAccessed = false;
var $f86bb62f1de45660$var$options = {
    get passive () {
        return $f86bb62f1de45660$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $f86bb62f1de45660$var$w = typeof window !== 'undefined' ? window : {};
if ($f86bb62f1de45660$var$w.addEventListener && $f86bb62f1de45660$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $f86bb62f1de45660$var$w.addEventListener('p', $f86bb62f1de45660$var$noop, $f86bb62f1de45660$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $f86bb62f1de45660$var$w.removeEventListener('p', $f86bb62f1de45660$var$noop, false);
}
var $f86bb62f1de45660$export$b0622a6911dbeaf5 = $f86bb62f1de45660$var$passiveOptionAccessed;

});


parcelRegister("jnbB8", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1a92963c11ed37d$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
var $e1a92963c11ed37d$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $e1a92963c11ed37d$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $e1a92963c11ed37d$var$preventTouchMove(e) {
    e.preventDefault();
}
function $e1a92963c11ed37d$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $e1a92963c11ed37d$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $e1a92963c11ed37d$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $e1a92963c11ed37d$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $e1a92963c11ed37d$var$activeScrollLocks = 0;
var $e1a92963c11ed37d$var$listenerOptions = {
    capture: false,
    passive: false
};
function $e1a92963c11ed37d$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $5FkrB.useRef)({});
    var scrollTarget = (0, $5FkrB.useRef)(null);
    var addScrollLock = (0, $5FkrB.useCallback)(function(touchScrollTarget) {
        if (!$e1a92963c11ed37d$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $e1a92963c11ed37d$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $e1a92963c11ed37d$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($e1a92963c11ed37d$var$LOCK_STYLES).forEach(function(key) {
                var val = $e1a92963c11ed37d$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $e1a92963c11ed37d$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $e1a92963c11ed37d$var$preventTouchMove, $e1a92963c11ed37d$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $e1a92963c11ed37d$var$preventInertiaScroll, $e1a92963c11ed37d$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $e1a92963c11ed37d$var$allowTouchMove, $e1a92963c11ed37d$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $e1a92963c11ed37d$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $5FkrB.useCallback)(function(touchScrollTarget) {
        if (!$e1a92963c11ed37d$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $e1a92963c11ed37d$var$activeScrollLocks = Math.max($e1a92963c11ed37d$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $e1a92963c11ed37d$var$activeScrollLocks < 1) $e1a92963c11ed37d$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $e1a92963c11ed37d$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $e1a92963c11ed37d$var$preventTouchMove, $e1a92963c11ed37d$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $e1a92963c11ed37d$var$preventInertiaScroll, $e1a92963c11ed37d$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $e1a92963c11ed37d$var$allowTouchMove, $e1a92963c11ed37d$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}

});


parcelRegister("1I7vO", function(module, exports) {
$parcel$export(module.exports, "scrollTo", () => $13efba46e7b5601a$export$3f99968195accfaf);

var $iDDR5 = parcelRequire("iDDR5");
function $13efba46e7b5601a$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ((0, $iDDR5.isDocumentElement)(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}

});

parcelRegister("f49h5", function(module, exports) {
$parcel$export(module.exports, "singleValueAsValue", () => $af7e6c7b6fd34047$export$dea4763e29237f4c);
function $af7e6c7b6fd34047$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}

});

parcelRegister("daBbz", function(module, exports) {
$parcel$export(module.exports, "valueTernary", () => $99690dd0f7e3222e$export$40fb9515c784cc3b);
function $99690dd0f7e3222e$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}

});

parcelRegister("admh3", function(module, exports) {
$parcel$export(module.exports, "isOptionDisabled", () => $76fc6570f4ea699d$export$56bd0c8d90db075);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $76fc6570f4ea699d$export$56bd0c8d90db075 = function isOptionDisabled(option) {
    return !!option.isDisabled;
};

});


parcelRegister("ikjov", function(module, exports) {
$parcel$export(module.exports, "default", () => $d57923873641050e$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
var $d57923873641050e$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $d57923873641050e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d57923873641050e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d57923873641050e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d57923873641050e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d57923873641050e$var$handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $d57923873641050e$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions, propsOptions = _ref.options, _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $d57923873641050e$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $5FkrB.useRef)(undefined);
    var mounted = (0, $5FkrB.useRef)(false);
    var _useState = (0, $5FkrB.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : ''), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(propsDefaultOptions === true), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $5FkrB.useState)(undefined), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $5FkrB.useState)([]), _useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState9, 2), loadedOptions = _useState0[0], setLoadedOptions = _useState0[1];
    var _useState1 = (0, $5FkrB.useState)(false), _useState10 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState1, 2), passEmptyOptions = _useState10[0], setPassEmptyOptions = _useState10[1];
    var _useState11 = (0, $5FkrB.useState)({}), _useState12 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState11, 2), optionsCache = _useState12[0], setOptionsCache = _useState12[1];
    var _useState13 = (0, $5FkrB.useState)(undefined), _useState14 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState13, 2), prevDefaultOptions = _useState14[0], setPrevDefaultOptions = _useState14[1];
    var _useState15 = (0, $5FkrB.useState)(undefined), _useState16 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState15, 2), prevCacheOptions = _useState16[0], setPrevCacheOptions = _useState16[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $5FkrB.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $5FkrB.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $5FkrB.useCallback)(function(newValue, actionMeta) {
        var inputValue = $d57923873641050e$var$handleInputChange(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? $d57923873641050e$var$_objectSpread($d57923873641050e$var$_objectSpread({}, optionsCache), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return $d57923873641050e$var$_objectSpread($d57923873641050e$var$_objectSpread({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}

});

parcelRegister("d2TmP", function(module, exports) {
$parcel$export(module.exports, "default", () => $97f6690ca39d1bb1$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
var $97f6690ca39d1bb1$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $97f6690ca39d1bb1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $97f6690ca39d1bb1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $97f6690ca39d1bb1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $97f6690ca39d1bb1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $97f6690ca39d1bb1$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $97f6690ca39d1bb1$var$_excluded);
    var _useState = (0, $5FkrB.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $5FkrB.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $5FkrB.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $5FkrB.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $5FkrB.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return $97f6690ca39d1bb1$var$_objectSpread($97f6690ca39d1bb1$var$_objectSpread({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});


parcelRegister("jjC0m", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0fd45a91eb1a658$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");
var $e0fd45a91eb1a658$var$_excluded = [
    "ariaLiveMessages",
    "components",
    "isInvalid",
    "menuRenderMode",
    "onClickPreventDefault",
    "tabSelectsValue",
    "validationState"
];
function $e0fd45a91eb1a658$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e0fd45a91eb1a658$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e0fd45a91eb1a658$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e0fd45a91eb1a658$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e0fd45a91eb1a658$var$InlineMenuPortal = function InlineMenuPortal(_ref) {
    var children = _ref.children;
    return children;
};
var $e0fd45a91eb1a658$var$InlineMenu = function InlineMenu(_ref2) {
    var children = _ref2.children, innerProps = _ref2.innerProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        // MenuList owns this ID; forwarding it here would create duplicate listbox IDs.
        id: undefined
    }), children);
};
function $e0fd45a91eb1a658$export$2e2bcd8739ae039(WrappedComponent) {
    var AtlaskitSelect = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        var ariaLiveMessages = props.ariaLiveMessages, components = props.components, isInvalid = props.isInvalid, _props$menuRenderMode = props.menuRenderMode, menuRenderMode = _props$menuRenderMode === void 0 ? 'popup' : _props$menuRenderMode, _props$onClickPrevent = props.onClickPreventDefault, onClickPreventDefault = _props$onClickPrevent === void 0 ? true : _props$onClickPrevent, _props$tabSelectsValu = props.tabSelectsValue, tabSelectsValue = _props$tabSelectsValu === void 0 ? false : _props$tabSelectsValu, _props$validationStat = props.validationState, validationState = _props$validationStat === void 0 ? 'default' : _props$validationStat, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $e0fd45a91eb1a658$var$_excluded);
        var internalSelectRef = (0, $5FkrB.useRef)(null);
        var inlineMenuComponents = (0, $5FkrB.useMemo)(function() {
            return $e0fd45a91eb1a658$var$_objectSpread($e0fd45a91eb1a658$var$_objectSpread({}, components), {}, {
                MenuPortal: $e0fd45a91eb1a658$var$InlineMenuPortal,
                Menu: $e0fd45a91eb1a658$var$InlineMenu
            });
        }, [
            components
        ]);
        /**
     * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
     * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
     * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
     * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
     * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
     */ (0, $5FkrB.useImperativeHandle)(forwardedRef, function() {
            return {
                select: internalSelectRef.current,
                focus: function focus() {
                    var _internalSelectRef$cu;
                    return (_internalSelectRef$cu = internalSelectRef.current) === null || _internalSelectRef$cu === void 0 ? void 0 : _internalSelectRef$cu.focus();
                },
                blur: function blur() {
                    var _internalSelectRef$cu2;
                    return (_internalSelectRef$cu2 = internalSelectRef.current) === null || _internalSelectRef$cu2 === void 0 ? void 0 : _internalSelectRef$cu2.blur();
                }
            };
        }, []);
        if (menuRenderMode === 'inline') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error'
        }, restProps, {
            components: inlineMenuComponents,
            menuIsOpen: true,
            tabSelectsValue: tabSelectsValue,
            isAsync: true
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error',
            components: components
        }, restProps, {
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        }));
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});



parcelRegister("jyEcA", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3d060902a6fea76$export$2e2bcd8739ae039);
/* calendar.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");


var $aLEtb = parcelRequire("aLEtb");

var $eVb4V = parcelRequire("eVb4V");

var $h8qvJ = parcelRequire("h8qvJ");

var $auVZV = parcelRequire("auVZV");
var $9FlpM = parcelRequire("9FlpM");

var $3jmjI = parcelRequire("3jmjI");

var $J30nr = parcelRequire("J30nr");

var $dffKj = parcelRequire("dffKj");

var $8W8An = parcelRequire("8W8An");

var $aVkaD = parcelRequire("aVkaD");

var $an83H = parcelRequire("an83H");

var $d2Jzc = parcelRequire("d2Jzc");

var $fzBXN = parcelRequire("fzBXN");

var $dS7TY = parcelRequire("dS7TY");
function $e3d060902a6fea76$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e3d060902a6fea76$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e3d060902a6fea76$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e3d060902a6fea76$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e3d060902a6fea76$var$styles = {
    box: "_1e0c1o8l _uiztglyw"
};
var $e3d060902a6fea76$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "@atlaskit/calendar",
    packageVersion: "19.3.1"
};
var $e3d060902a6fea76$var$InnerCalendar = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function Calendar(_ref, ref) {
    var day = _ref.day, _ref$defaultDay = _ref.defaultDay, defaultDay = _ref$defaultDay === void 0 ? 0 : _ref$defaultDay, _ref$defaultMonth = _ref.defaultMonth, defaultMonth = _ref$defaultMonth === void 0 ? 0 : _ref$defaultMonth, _ref$defaultPreviousl = _ref.defaultPreviouslySelected, defaultPreviouslySelected = _ref$defaultPreviousl === void 0 ? [] : _ref$defaultPreviousl, _ref$defaultSelected = _ref.defaultSelected, defaultSelected = _ref$defaultSelected === void 0 ? [] : _ref$defaultSelected, _ref$defaultYear = _ref.defaultYear, defaultYear = _ref$defaultYear === void 0 ? 0 : _ref$defaultYear, disabled = _ref.disabled, disabledDateFilter = _ref.disabledDateFilter, minDate = _ref.minDate, maxDate = _ref.maxDate, month = _ref.month, nextMonthLabel = _ref.nextMonthLabel, _ref$onBlur = _ref.onBlur, onBlur = _ref$onBlur === void 0 ? (0, $eVb4V.default) : _ref$onBlur, _ref$onChange = _ref.onChange, onChange = _ref$onChange === void 0 ? (0, $eVb4V.default) : _ref$onChange, _ref$onFocus = _ref.onFocus, onFocus = _ref$onFocus === void 0 ? (0, $eVb4V.default) : _ref$onFocus, _ref$onSelect = _ref.onSelect, onSelect = _ref$onSelect === void 0 ? (0, $eVb4V.default) : _ref$onSelect, previouslySelected = _ref.previouslySelected, previousMonthLabel = _ref.previousMonthLabel, selected = _ref.selected, _ref$shouldSetFocusOn = _ref.shouldSetFocusOnCurrentDay, shouldSetFocusOnCurrentDay = _ref$shouldSetFocusOn === void 0 ? false : _ref$shouldSetFocusOn, today = _ref.today, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? 'en-US' : _ref$locale, year = _ref.year, analyticsContext = _ref.analyticsContext, weekStartDay = _ref.weekStartDay, testId = _ref.testId, className = _ref.className, style = _ref.style, _ref$tabIndex = _ref.tabIndex, tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;
    var _useControlledDateSta = (0, $8W8An.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    }), _useControlledDateSta2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useControlledDateSta.day, 2), dayValue = _useControlledDateSta2[0], setDayValue = _useControlledDateSta2[1], _useControlledDateSta3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useControlledDateSta.month, 2), monthValue = _useControlledDateSta3[0], setMonthValue = _useControlledDateSta3[1], _useControlledDateSta4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useControlledDateSta.year, 2), yearValue = _useControlledDateSta4[0], setYearValue = _useControlledDateSta4[1], _useControlledDateSta5 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useControlledDateSta.today, 1), todayValue = _useControlledDateSta5[0], _useControlledDateSta6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useControlledDateSta.selected, 2), selectedValue = _useControlledDateSta6[0], setSelectedValue = _useControlledDateSta6[1], _useControlledDateSta7 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useControlledDateSta.previous, 2), previouslySelectedValue = _useControlledDateSta7[0], setPreviouslySelectedValue = _useControlledDateSta7[1];
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), shouldSetFocus = _useState2[0], setShouldSetFocus = _useState2[1];
    var onChangeWithAnalytics = (0, $aLEtb.usePlatformLeafEventHandler)($e3d060902a6fea76$var$_objectSpread({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext
    }, $e3d060902a6fea76$var$analyticsAttributes));
    var _useHandleDateChange = (0, $d2Jzc.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    }), navigate = _useHandleDateChange.navigate, handleClickNextMonth = _useHandleDateChange.handleClickNextMonth, handleClickNextYear = _useHandleDateChange.handleClickNextYear, handleClickPrevMonth = _useHandleDateChange.handleClickPrevMonth, handleClickPrevYear = _useHandleDateChange.handleClickPrevYear;
    var onSelectWithAnalytics = (0, $aLEtb.usePlatformLeafEventHandler)($e3d060902a6fea76$var$_objectSpread({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext
    }, $e3d060902a6fea76$var$analyticsAttributes));
    var _useHandleDateSelect = (0, $fzBXN.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    }), handleClickDay = _useHandleDateSelect.handleClickDay, handleContainerKeyDown = _useHandleDateSelect.handleContainerKeyDown;
    var _useFocusing = (0, $aVkaD.default)({
        onFocus: onFocus,
        onBlur: onBlur
    }), handleContainerBlur = _useFocusing.handleContainerBlur, handleContainerFocus = _useFocusing.handleContainerFocus;
    var _useLocale = (0, $dS7TY.default)({
        locale: locale,
        weekStartDay: weekStartDay
    }), monthsLong = _useLocale.monthsLong, daysShort = _useLocale.daysShort, daysLong = _useLocale.daysLong, resolvedWeekStartDay = _useLocale.weekStartDay;
    var weeks = (0, $an83H.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: resolvedWeekStartDay
    });
    var getNextMonthHeading = function getNextMonthHeading() {
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        var nextMonth = monthValue % 12;
        var showNextYear = monthValue === 12;
        return "".concat(monthsLong[nextMonth], " ").concat(showNextYear ? yearValue + 1 : yearValue);
    };
    var getNextYearHeading = function getNextYearHeading() {
        // Months are held in Date object as zero-indexed
        var thisMonth = (monthValue - 1) % 12;
        var nextYear = yearValue + 1;
        return "".concat(monthsLong[thisMonth], " ").concat(nextYear);
    };
    var getPreviousMonthHeading = function getPreviousMonthHeading() {
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        var previousMonth = (monthValue + 12 - 2) % 12;
        var showPreviousYear = monthValue === 1;
        return "".concat(monthsLong[previousMonth], " ").concat(showPreviousYear ? yearValue - 1 : yearValue);
    };
    var getPreviousYearHeading = function getPreviousYearHeading() {
        // Months are held in Date object as zero-indexed
        var thisMonth = (monthValue - 1) % 12;
        var previousYear = yearValue - 1;
        return "".concat(monthsLong[thisMonth], " ").concat(previousYear);
    };
    var headerId = (0, $h8qvJ.useId)();
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && "".concat(testId, "--container"),
        ref: ref
    }, /*#__PURE__*/ $5FkrB.createElement((0, $auVZV.Box), {
        xcss: $e3d060902a6fea76$var$styles.box,
        padding: "space.200",
        "aria-label": "calendar",
        testId: testId && "".concat(testId, "--calendar")
    }, /*#__PURE__*/ $5FkrB.createElement((0, $9FlpM.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ $5FkrB.createElement((0, $3jmjI.default), {
        monthLongTitle: monthsLong[monthValue - 1],
        year: yearValue,
        nextMonthLabel: nextMonthLabel,
        previousMonthLabel: previousMonthLabel,
        nextMonthHeading: getNextMonthHeading(),
        nextYearHeading: getNextYearHeading(),
        previousMonthHeading: getPreviousMonthHeading(),
        previousYearHeading: getPreviousYearHeading(),
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear,
        headerId: headerId,
        tabIndex: tabIndex,
        testId: testId
    }), /*#__PURE__*/ $5FkrB.createElement((0, $auVZV.Box), {
        role: "grid",
        onKeyDown: handleContainerKeyDown,
        "aria-labelledby": headerId,
        testId: testId && "".concat(testId, "--calendar-dates")
    }, /*#__PURE__*/ $5FkrB.createElement((0, $dffKj.default), {
        daysShort: daysShort,
        testId: testId
    }), /*#__PURE__*/ $5FkrB.createElement((0, $J30nr.default), {
        weeks: weeks,
        handleClickDay: handleClickDay,
        monthsLong: monthsLong,
        shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
        tabIndex: tabIndex,
        testId: testId
    })))));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ var $e3d060902a6fea76$var$Calendar = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ $5FkrB.createElement($e3d060902a6fea76$var$InnerCalendar, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        ref: ref
    }));
}));
$e3d060902a6fea76$var$Calendar.displayName = 'Calendar';
var $e3d060902a6fea76$export$2e2bcd8739ae039 = $e3d060902a6fea76$var$Calendar;

});
parcelRegister("3jmjI", function(module, exports) {
$parcel$export(module.exports, "default", () => $269475276824d638$export$2e2bcd8739ae039);
/* header.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $5yfDB = parcelRequire("5yfDB");

var $h8qvJ = parcelRequire("h8qvJ");

var $9WFxd = parcelRequire("9WFxd");

var $6yQ9L = parcelRequire("6yQ9L");

var $378mN = parcelRequire("378mN");

var $4r3Kr = parcelRequire("4r3Kr");

var $aMiKe = parcelRequire("aMiKe");

var $50U6m = parcelRequire("50U6m");

var $auVZV = parcelRequire("auVZV");
var $m5IEn = parcelRequire("m5IEn");
// platform-dst-motion-uplift-list-item cleanup: once fully rolled out, drop the gate
// in the return below and always apply these transitions.
var $269475276824d638$var$arrowMotionStyles = null;
var $269475276824d638$var$Header = /*#__PURE__*/ (0, $5FkrB.memo)(function Header(_ref) {
    var monthLongTitle = _ref.monthLongTitle, year = _ref.year, _ref$previousMonthLab = _ref.previousMonthLabel, previousMonthLabel = _ref$previousMonthLab === void 0 ? 'Previous month' : _ref$previousMonthLab, _ref$previousYearLabe = _ref.previousYearLabel, previousYearLabel = _ref$previousYearLabe === void 0 ? 'Previous year' : _ref$previousYearLabe, previousMonthHeading = _ref.previousMonthHeading, previousYearHeading = _ref.previousYearHeading, _ref$nextMonthLabel = _ref.nextMonthLabel, nextMonthLabel = _ref$nextMonthLabel === void 0 ? 'Next month' : _ref$nextMonthLabel, _ref$nextYearLabel = _ref.nextYearLabel, nextYearLabel = _ref$nextYearLabel === void 0 ? 'Next year' : _ref$nextYearLabel, nextMonthHeading = _ref.nextMonthHeading, nextYearHeading = _ref.nextYearHeading, handleClickPrevMonth = _ref.handleClickPrevMonth, handleClickPrevYear = _ref.handleClickPrevYear, handleClickNextMonth = _ref.handleClickNextMonth, handleClickNextYear = _ref.handleClickNextYear, headerId = _ref.headerId, tabIndex = _ref.tabIndex, testId = _ref.testId;
    var announceId = (0, $h8qvJ.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasInteractedWithMonthOrYear = _useState2[0], setHasInteractedWithMonthOrYear = _useState2[1];
    var handlePrevMonthInteraction = function handlePrevMonthInteraction(e) {
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevMonth(e);
    };
    var handlePrevYearInteraction = function handlePrevYearInteraction(e) {
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevYear(e);
    };
    var handleNextMonthInteraction = function handleNextMonthInteraction(e) {
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextMonth(e);
    };
    var handleNextYearInteraction = function handleNextYearInteraction(e) {
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextYear(e);
    };
    var header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $auVZV.Box), {
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $m5IEn.Inline), {
        space: "space.0",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $m5IEn.Inline), {
        space: "space.100",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5yfDB.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handlePrevYearInteraction,
        testId: testId && "".concat(testId, "--previous-year"),
        icon: function icon(iconProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6yQ9L))), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, iconProps, {
                size: "small"
            }));
        },
        label: "".concat(previousYearLabel, ", ").concat(previousYearHeading)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5yfDB.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handlePrevMonthInteraction,
        testId: testId && "".concat(testId, "--previous-month"),
        icon: function icon(iconProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4r3Kr))), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, iconProps, {
                size: "small"
            }));
        },
        label: "".concat(previousMonthLabel, ", ").concat(previousMonthHeading)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $auVZV.Box), {
        "aria-live": hasInteractedWithMonthOrYear ? 'polite' : undefined,
        id: announceId,
        testId: testId && "".concat(testId, "--current-month-year--container")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9WFxd.default), {
        size: "xsmall",
        as: "h2",
        id: headerId,
        testId: testId && "".concat(testId, "--current-month-year")
    }, "".concat(monthLongTitle, " ").concat(year))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $m5IEn.Inline), {
        space: "space.100",
        alignBlock: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5yfDB.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handleNextMonthInteraction,
        testId: testId && "".concat(testId, "--next-month"),
        icon: function icon(iconProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aMiKe))), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, iconProps, {
                size: "small"
            }));
        },
        label: "".concat(nextMonthLabel, ", ").concat(nextMonthHeading)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5yfDB.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handleNextYearInteraction,
        testId: testId && "".concat(testId, "--next-year"),
        icon: function icon(iconProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($378mN))), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, iconProps, {
                size: "small"
            }));
        },
        label: "".concat(nextYearLabel, ", ").concat(nextYearHeading)
    }))));
    return (0, $50U6m.fg)('platform-dst-motion-uplift-list-item') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        className: (0, $970q7.default)([
            "_1rxyhxmd _1quahxmd _1xkm87vo _21j8glyw"
        ])
    }, header) : header;
});
$269475276824d638$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$269475276824d638$export$2e2bcd8739ae039 = $269475276824d638$var$Header;

});
parcelRegister("9WFxd", function(module, exports) {
$parcel$export(module.exports, "default", () => $73d9bfca0ffd5276$export$2e2bcd8739ae039);
/* heading.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $a3VXv = parcelRequire("a3VXv");

var $99N5z = parcelRequire("99N5z");

var $gKk5H = parcelRequire("gKk5H");

var $3ZMUU = parcelRequire("3ZMUU");
var $73d9bfca0ffd5276$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $73d9bfca0ffd5276$var$styles = {
    reset: "_dxsyidpf _1i144jg8 _nmk4glyw"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $73d9bfca0ffd5276$var$headingColorStyles = {
    'color.text': "_1w90i7uo",
    'color.text.inverse': "_1w9015cr",
    'color.text.warning.inverse': "_1w901yd3"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $73d9bfca0ffd5276$var$headingSizeStyles = {
    xxlarge: "_fqox1iff",
    xlarge: "_fqox12ln",
    large: "_fqox10sd",
    medium: "_fqox1af2",
    small: "_fqox1e3o",
    xsmall: "_fqox1qyo",
    xxsmall: "_fqoxi4vh"
};
/**
 * @codegenEnd
 */ var $73d9bfca0ffd5276$var$useColor = function useColor(colorProp) {
    var surface = (0, $99N5z.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $a3VXv.inverseColorMap).hasOwnProperty(surface)) return (0, $a3VXv.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $73d9bfca0ffd5276$var$Heading = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    typeof $3ZMUU;
    var _useHeading = (0, $gKk5H.useHeading)($73d9bfca0ffd5276$var$sizeTagMap[size]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === 'div' && hLevel;
    var color = $73d9bfca0ffd5276$var$useColor(colorProp);
    return /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $970q7.default)([
            $73d9bfca0ffd5276$var$styles.reset,
            $73d9bfca0ffd5276$var$headingSizeStyles[size],
            $73d9bfca0ffd5276$var$headingColorStyles[color]
        ])
    }, children);
});
var $73d9bfca0ffd5276$export$2e2bcd8739ae039 = $73d9bfca0ffd5276$var$Heading;

});
parcelRegister("gKk5H", function(module, exports) {
$parcel$export(module.exports, "useHeading", () => $c31086d85a29f730$export$97a37b1befbbf9b1);

var $6nggs = parcelRequire("6nggs");
var $c31086d85a29f730$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = (0, $6nggs.useHeadingLevel)();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : "h".concat(hLevel)) || fallback
    ];
};

});
parcelRegister("6nggs", function(module, exports) {
$parcel$export(module.exports, "useHeadingLevel", () => $4a4181d9c3865ff8$export$6a64a1e2d0bbbf75);

var $5FkrB = parcelRequire("5FkrB");

var $1UOrv = parcelRequire("1UOrv");
var $4a4181d9c3865ff8$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $5FkrB.useContext)((0, $1UOrv.HeadingLevelContext));
};

});
parcelRegister("1UOrv", function(module, exports) {
$parcel$export(module.exports, "HeadingLevelContext", () => $16522643e20801a2$export$d1fa8a19e192bc63);

var $5FkrB = parcelRequire("5FkrB");
var $16522643e20801a2$export$d1fa8a19e192bc63 = /*#__PURE__*/ (0, $5FkrB.createContext)(0);

});




parcelRegister("6yQ9L", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::30c4d8563d4405635aa2922e0e9918c6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4c6e6039029006a9$var$_react = $4c6e6039029006a9$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $4c6e6039029006a9$var$_iconNew = $4c6e6039029006a9$var$_interopRequireDefault((parcelRequire("gDzom")));
function $4c6e6039029006a9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-double-left
 * Usage guidance:
 * Known uses: Navigate to previous year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4c6e6039029006a9$var$ChevronDoubleLeftIcon = (props)=>/*#__PURE__*/ $4c6e6039029006a9$var$_react.default.createElement($4c6e6039029006a9$var$_iconNew.default, Object.assign({
        name: "ChevronDoubleLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m7.72 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L3.31 8l5.47-5.47z"/><path fill="currentcolor" d="m12.47 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L8.06 8l5.47-5.47z"/>`
    }, props));
$4c6e6039029006a9$var$ChevronDoubleLeftIcon.displayName = 'ChevronDoubleLeftIcon';
var $4c6e6039029006a9$var$_default = module.exports.default = $4c6e6039029006a9$var$ChevronDoubleLeftIcon;

});

parcelRegister("378mN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29c7322dd95328d239ae1ca6bd298f91>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $244883fc9b8bb580$var$_react = $244883fc9b8bb580$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $244883fc9b8bb580$var$_iconNew = $244883fc9b8bb580$var$_interopRequireDefault((parcelRequire("gDzom")));
function $244883fc9b8bb580$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-double-right
 * Usage guidance:
 * Known uses: Navigate to next year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $244883fc9b8bb580$var$ChevronDoubleRightIcon = (props)=>/*#__PURE__*/ $244883fc9b8bb580$var$_react.default.createElement($244883fc9b8bb580$var$_iconNew.default, Object.assign({
        name: "ChevronDoubleRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8.28 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L12.69 8 7.22 2.53z"/><path fill="currentcolor" d="m3.53 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L7.94 8 2.47 2.53z"/>`
    }, props));
$244883fc9b8bb580$var$ChevronDoubleRightIcon.displayName = 'ChevronDoubleRightIcon';
var $244883fc9b8bb580$var$_default = module.exports.default = $244883fc9b8bb580$var$ChevronDoubleRightIcon;

});

parcelRegister("4r3Kr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7ea16940a5b16b575a448de9712a73f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33ac9753a867fbba$var$_react = $33ac9753a867fbba$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $33ac9753a867fbba$var$_iconNew = $33ac9753a867fbba$var$_interopRequireDefault((parcelRequire("gDzom")));
function $33ac9753a867fbba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-left
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33ac9753a867fbba$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $33ac9753a867fbba$var$_react.default.createElement($33ac9753a867fbba$var$_iconNew.default, Object.assign({
        name: "ChevronLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$33ac9753a867fbba$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $33ac9753a867fbba$var$_default = module.exports.default = $33ac9753a867fbba$var$ChevronLeftIcon;

});


parcelRegister("J30nr", function(module, exports) {
$parcel$export(module.exports, "default", () => $087688d4908973c9$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $4Pn6z = parcelRequire("4Pn6z");

var $aVzVe = parcelRequire("aVzVe");

var $hZCZP = parcelRequire("hZCZP");
var $087688d4908973c9$var$WeekDays = /*#__PURE__*/ (0, $5FkrB.memo)(function WeekDays(_ref) {
    var weeks = _ref.weeks, handleClickDay = _ref.handleClickDay, monthsLong = _ref.monthsLong, shouldSetFocus = _ref.shouldSetFocus, tabIndex = _ref.tabIndex, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.default), {
        role: "rowgroup",
        testId: testId && "".concat(testId, "--month")
    }, weeks.map(function(week, i) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $hZCZP.default), {
            key: i,
            testId: testId && "".concat(testId, "--week")
        }, week.values.map(function(weekDay) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aVzVe.default), {
                key: "".concat(week.id, "-").concat(weekDay.id),
                isDisabled: weekDay.isDisabled,
                isFocused: weekDay.isFocused,
                isToday: weekDay.isToday,
                dayLong: weekDay.weekDayName,
                month: weekDay.month,
                monthLong: monthsLong[weekDay.month - 1],
                onClick: handleClickDay,
                isPreviouslySelected: weekDay.isPreviouslySelected,
                isSelected: weekDay.isSelected,
                isSibling: weekDay.isSiblingMonth,
                year: weekDay.year,
                shouldSetFocus: shouldSetFocus,
                tabIndex: tabIndex,
                testId: testId
            }, weekDay.day);
        }));
    }));
});
$087688d4908973c9$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$087688d4908973c9$export$2e2bcd8739ae039 = $087688d4908973c9$var$WeekDays;

});
parcelRegister("aVzVe", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f4b17a42956054d$export$2e2bcd8739ae039);
/* date.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $eVb4V = parcelRequire("eVb4V");

var $50U6m = parcelRequire("50U6m");

var $7Nyp4 = parcelRequire("7Nyp4");
var $7f4b17a42956054d$var$dateCellSiblingStyle = null;
var $7f4b17a42956054d$var$dateCellTodayStyle = null;
var $7f4b17a42956054d$var$dateCellPrevSelectedStyle = null;
var $7f4b17a42956054d$var$dateCellSelectedStyle = null;
// platform-dst-tokens-finesse cleanup: merge into dateCellSelectedStyle after rollout
var $7f4b17a42956054d$var$dateCellSelectedFinesseStyle = null;
var $7f4b17a42956054d$var$dateCellDisabledStyle = null;
var $7f4b17a42956054d$var$dateCellStyles = null;
// platform-dst-motion-uplift-list-item cleanup: once fully rolled out, fold these
// transitions into the styles above and drop the gate in the `css` array below.
var $7f4b17a42956054d$var$dateCellMotionStyles = null;
var $7f4b17a42956054d$var$dateCellSelectedMotionStyles = null;
var $7f4b17a42956054d$var$Date = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, _ref) {
    var day = _ref2.children, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isFocused = _ref2.isFocused, isFocused = _ref2$isFocused === void 0 ? false : _ref2$isFocused, _ref2$isToday = _ref2.isToday, isToday = _ref2$isToday === void 0 ? false : _ref2$isToday, dayLong = _ref2.dayLong, month = _ref2.month, monthLong = _ref2.monthLong, _ref2$onClick = _ref2.onClick, onClick = _ref2$onClick === void 0 ? (0, $eVb4V.default) : _ref2$onClick, _ref2$isPreviouslySel = _ref2.isPreviouslySelected, isPreviouslySelected = _ref2$isPreviouslySel === void 0 ? false : _ref2$isPreviouslySel, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$isSibling = _ref2.isSibling, isSibling = _ref2$isSibling === void 0 ? false : _ref2$isSibling, year = _ref2.year, shouldSetFocus = _ref2.shouldSetFocus, tabIndex = _ref2.tabIndex, testId = _ref2.testId;
    var dateRef = (0, $5FkrB.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $5FkrB.useEffect)(function() {
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    var focusRef = (0, $5FkrB.useRef)(null);
    (0, $5FkrB.useEffect)(function() {
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    var handleClick = (0, $5FkrB.useCallback)(function() {
        var _dateRef$current = dateRef.current, dayValue = _dateRef$current.day, monthValue = _dateRef$current.month, yearValue = _dateRef$current.year, isDisabledValue = _dateRef$current.isDisabled;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    return /*#__PURE__*/ $5FkrB.createElement((0, $7Nyp4.Grid), {
        role: "gridcell",
        alignItems: "center"
    }, /*#__PURE__*/ $5FkrB.createElement("button", {
        "aria-current": isToday ? 'date' : undefined,
        "aria-disabled": isDisabled || undefined,
        "aria-label": "".concat(day, ", ").concat(dayLong, " ").concat(monthLong, " ").concat(year),
        "aria-pressed": isSelected ? 'true' : 'false',
        tabIndex: isFocused ? tabIndex : -1,
        type: "button",
        onClick: handleClick,
        ref: focusRef,
        "data-disabled": isDisabled || undefined,
        "data-focused": isFocused || undefined,
        "data-prev-selected": isPreviouslySelected || undefined,
        "data-selected": isSelected || undefined,
        "data-sibling": isSibling || undefined,
        "data-today": isToday || undefined,
        "data-testid": testId && (isSelected ? "".concat(testId, "--selected-day") : "".concat(testId, "--day")),
        className: (0, $970q7.default)([
            "_kkk2n7od _2rko1qi0 _11c8fhey _v564hxmd _1h6d1j28 _1dqonqa1 _189e1dm9 _1e0c1ule _kqswh2mm _16jlkb7n _bfhk1j28 _syazi7uo _80omtlke _85i51b66 _1q511b66 _y4tirdoj _bozgrdoj _y3gn1h6o _pojj1v1w _10knnqa1 _1wysdkaa _irr31dpa _30l3i7uo _1ggl87vo _1di6fcek _9h8hi7uo",
            isSibling && "_v564hxmd _syaz1rpy _30l31rpy",
            isToday && "_syaz6x5g _k48pwu06 _1ywu1ule _1qdgyh40 _18postnw _1hfk1r31 _aetrb3bt _1gufv77o _1czdv77o _g0nfv77o",
            isPreviouslySelected && "_v564hxmd _bfhk15s3 _syazazsu _30l3azsu",
            isSelected && "_v564hxmd _bfhk15s3 _syaz6x5g _irr3ufnl _30l36x5g",
            isSelected && (0, $50U6m.fg)('platform-dst-tokens-finesse') && "_v564hxmd _bfhkjmqp _syaz15cr _irr31q28 _30l315cr _1ggl87vo _1di612kk _9h8h15cr",
            isDisabled && "_v564hxmd _syaz1gmx _80om13gf _irr31j28 _30l31gmx",
            (0, $50U6m.fg)('platform-dst-motion-uplift-list-item') && "_v564hxmd _1gk4glyw _o7kshxmd _1ggl87vo",
            (isSelected || isPreviouslySelected) && (0, $50U6m.fg)('platform-dst-motion-uplift-list-item') && "_v5641rrn"
        ])
    }, day));
}));
$7f4b17a42956054d$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7f4b17a42956054d$export$2e2bcd8739ae039 = $7f4b17a42956054d$var$Date;

});
parcelRegister("7Nyp4", function(module, exports) {
$parcel$export(module.exports, "Grid", () => $5ad7cbc8d3374c7d$export$ef2184bd89960b14);
/* grid.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $5ad7cbc8d3374c7d$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $5ad7cbc8d3374c7d$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $5ad7cbc8d3374c7d$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $5ad7cbc8d3374c7d$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
var $5ad7cbc8d3374c7d$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $5ad7cbc8d3374c7d$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
var $5ad7cbc8d3374c7d$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
var $5ad7cbc8d3374c7d$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignItems, alignContent = _ref.alignContent, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, id = _ref.id, role = _ref.role, testId = _ref.testId, autoFlow = _ref.autoFlow, xcss = _ref.xcss;
    var Component = as || 'div';
    return /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        role: role,
        className: (0, $970q7.default)([
            $5ad7cbc8d3374c7d$var$baseStyles.root,
            gap && $5ad7cbc8d3374c7d$var$columnGapMap[gap],
            columnGap && $5ad7cbc8d3374c7d$var$columnGapMap[columnGap],
            gap && $5ad7cbc8d3374c7d$var$rowGapMap[gap],
            rowGap && $5ad7cbc8d3374c7d$var$rowGapMap[rowGap],
            alignItems && $5ad7cbc8d3374c7d$var$alignItemsMap[alignItems],
            alignContent && $5ad7cbc8d3374c7d$var$alignContentMap[alignContent],
            justifyContent && $5ad7cbc8d3374c7d$var$justifyContentMap[justifyContent],
            autoFlow && $5ad7cbc8d3374c7d$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$5ad7cbc8d3374c7d$export$ef2184bd89960b14.displayName = 'Grid';

});


parcelRegister("hZCZP", function(module, exports) {
$parcel$export(module.exports, "default", () => $d19661fcdd6f3e9d$export$2e2bcd8739ae039);
/* week-day-grid.tsx generated by @compiled/babel-plugin v3.0.2 */ 

var $5FkrB = parcelRequire("5FkrB");

var $7Nyp4 = parcelRequire("7Nyp4");
var $d19661fcdd6f3e9d$var$styles = {
    templateColumns: "_yv0eloeq"
};
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ var $d19661fcdd6f3e9d$var$WeekDayGrid = function WeekDayGrid(_ref) {
    var testId = _ref.testId, children = _ref.children, isHidden = _ref.isHidden;
    var row = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7Nyp4.Grid), {
        testId: testId,
        xcss: $d19661fcdd6f3e9d$var$styles.templateColumns,
        role: "row"
    }, children);
    return isHidden ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        "aria-hidden": "true"
    }, row) : row;
};
var $d19661fcdd6f3e9d$export$2e2bcd8739ae039 = $d19661fcdd6f3e9d$var$WeekDayGrid;

});


parcelRegister("dffKj", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a48e3e8e20129b1$export$2e2bcd8739ae039);
/* week-header.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");


var $auVZV = parcelRequire("auVZV");
var $72GAO = parcelRequire("72GAO");

var $hZCZP = parcelRequire("hZCZP");
var $9a48e3e8e20129b1$var$styles = {
    columnHeader: "_1ul98pqr _o5721q9c _1e0c1txw _1bah1h6o"
};
var $9a48e3e8e20129b1$var$WeekHeader = /*#__PURE__*/ (0, $5FkrB.memo)(function WeekHeader(_ref) {
    var daysShort = _ref.daysShort, testId = _ref.testId;
    return /*#__PURE__*/ $5FkrB.createElement((0, $hZCZP.default), {
        isHidden: true,
        testId: testId && "".concat(testId, "--column-headers")
    }, daysShort.map(function(shortDay) {
        return /*#__PURE__*/ $5FkrB.createElement((0, $auVZV.Box), {
            padding: "space.100",
            xcss: $9a48e3e8e20129b1$var$styles.columnHeader,
            key: shortDay,
            role: "columnheader",
            testId: testId && "".concat(testId, "--column-header")
        }, /*#__PURE__*/ $5FkrB.createElement((0, $72GAO.Text), {
            weight: "bold",
            size: "small",
            align: "center",
            color: "color.text.subtle"
        }, shortDay));
    }));
});
$9a48e3e8e20129b1$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9a48e3e8e20129b1$export$2e2bcd8739ae039 = $9a48e3e8e20129b1$var$WeekHeader;

});

parcelRegister("8W8An", function(module, exports) {
$parcel$export(module.exports, "default", () => $681a6670d6ee42c2$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $2oF7I = parcelRequire("2oF7I");

var $b9s5x = parcelRequire("b9s5x");

var $69x5N = parcelRequire("69x5N");
function $681a6670d6ee42c2$export$2e2bcd8739ae039(_ref) {
    var day = _ref.day, defaultDay = _ref.defaultDay, month = _ref.month, defaultMonth = _ref.defaultMonth, year = _ref.year, defaultYear = _ref.defaultYear, today = _ref.today, selected = _ref.selected, defaultSelected = _ref.defaultSelected, previouslySelected = _ref.previouslySelected, defaultPreviouslySelected = _ref.defaultPreviouslySelected;
    var _useLazyRef = (0, $b9s5x.default)(function() {
        var now = new Date();
        var thisDay = now.getDate();
        var thisMonth = now.getMonth() + 1;
        var thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    }), _useLazyRef$current = _useLazyRef.current, thisDay = _useLazyRef$current.thisDay, thisMonth = _useLazyRef$current.thisMonth, thisYear = _useLazyRef$current.thisYear;
    var _useControlled = (0, $2oF7I.default)(day, function() {
        return defaultDay || thisDay;
    }), _useControlled2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useControlled, 2), dayValue = _useControlled2[0], setDayValue = _useControlled2[1];
    var _useControlled3 = (0, $2oF7I.default)(month, function() {
        return defaultMonth || thisMonth;
    }), _useControlled4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useControlled3, 2), monthValue = _useControlled4[0], setMonthValue = _useControlled4[1];
    var _useControlled5 = (0, $2oF7I.default)(year, function() {
        return defaultYear || thisYear;
    }), _useControlled6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useControlled5, 2), yearValue = _useControlled6[0], setYearValue = _useControlled6[1];
    var _useControlled7 = (0, $2oF7I.default)(today, function() {
        return today || "".concat(thisYear, "-").concat((0, $69x5N.default)(thisMonth), "-").concat((0, $69x5N.default)(thisDay));
    }), _useControlled8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useControlled7, 1), todayValue = _useControlled8[0];
    var _useControlled9 = (0, $2oF7I.default)(selected, function() {
        return defaultSelected;
    }), _useControlled0 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useControlled9, 2), selectedValue = _useControlled0[0], setSelectedValue = _useControlled0[1];
    var _useControlled1 = (0, $2oF7I.default)(previouslySelected, function() {
        return defaultPreviouslySelected;
    }), _useControlled10 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useControlled1, 2), previouslySelectedValue = _useControlled10[0], setPreviouslySelectedValue = _useControlled10[1];
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("b9s5x", function(module, exports) {
$parcel$export(module.exports, "default", () => $81e652ba4695f5f9$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
var $81e652ba4695f5f9$var$uniqueReferencedValue = {};
function $81e652ba4695f5f9$export$2e2bcd8739ae039(initializer) {
    var ref = (0, $5FkrB.useRef)($81e652ba4695f5f9$var$uniqueReferencedValue);
    if (ref.current === $81e652ba4695f5f9$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});

parcelRegister("69x5N", function(module, exports) {
$parcel$export(module.exports, "default", () => $47ad40cd7646edfe$export$2e2bcd8739ae039);
function $47ad40cd7646edfe$export$2e2bcd8739ae039(num) {
    return num < 10 ? "0".concat(num) : "".concat(num);
}

});


parcelRegister("aVkaD", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f3edfb7ec573a59$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $7f3edfb7ec573a59$export$2e2bcd8739ae039(_ref) {
    var onBlur = _ref.onBlur, onFocus = _ref.onFocus;
    var handleContainerBlur = (0, $5FkrB.useCallback)(function(event) {
        onBlur(event);
    }, [
        onBlur
    ]);
    var handleContainerFocus = (0, $5FkrB.useCallback)(function(event) {
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("an83H", function(module, exports) {
$parcel$export(module.exports, "default", () => $78d24da4dc6d7bcf$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $9sK38 = parcelRequire("9sK38");

var $gMEiR = parcelRequire("gMEiR");

var $Kqkrb = parcelRequire("Kqkrb");

var $ffUrG = parcelRequire("ffUrG");
function $78d24da4dc6d7bcf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $78d24da4dc6d7bcf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $78d24da4dc6d7bcf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $78d24da4dc6d7bcf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $78d24da4dc6d7bcf$var$useGetCalendarWithSixthWeek(calendar, _ref) {
    var month = _ref.month, year = _ref.year, weekStartDay = _ref.weekStartDay;
    var shouldDisplaySixthWeek = calendar.length % 6;
    var calendarLastValue = calendar[calendar.length - 1];
    return (0, $5FkrB.useMemo)(function() {
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            var lastDayIsSibling = calendarLastValue.siblingMonth;
            var sliceStart = lastDayIsSibling ? (0, $gMEiR.daysPerWeek) : 0;
            return (0, $ffUrG.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $gMEiR.daysPerWeek)).map(function(date) {
                return $78d24da4dc6d7bcf$var$_objectSpread($78d24da4dc6d7bcf$var$_objectSpread({}, date), {}, {
                    siblingMonth: true
                });
            });
        }
        return [];
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $78d24da4dc6d7bcf$export$2e2bcd8739ae039(_ref2) {
    var day = _ref2.day, daysLong = _ref2.daysLong, month = _ref2.month, year = _ref2.year, today = _ref2.today, disabled = _ref2.disabled, disabledDateFilter = _ref2.disabledDateFilter, minDateString = _ref2.minDate, maxDateString = _ref2.maxDate, selected = _ref2.selected, previouslySelected = _ref2.previouslySelected, weekStartDay = _ref2.weekStartDay;
    var calendar = (0, $5FkrB.useMemo)(function() {
        return (0, $ffUrG.default)(year, month - 1, {
            weekStartDay: weekStartDay
        });
    }, [
        month,
        weekStartDay,
        year
    ]);
    var calendarWithSixthWeek = $78d24da4dc6d7bcf$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push.apply(calendar, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(calendarWithSixthWeek));
    var minDate = minDateString ? (0, $9sK38.default)(minDateString) : undefined;
    var maxDate = maxDateString ? (0, $9sK38.default)(maxDateString) : undefined;
    var needJsDate = minDateString || maxDateString;
    return (0, $5FkrB.useMemo)(function() {
        var weeks = [];
        calendar.forEach(function(date) {
            var dateAsString = (0, $Kqkrb.default)(date, {
                fixMonth: true
            });
            var JSDate = needJsDate ? (0, $9sK38.default)(dateAsString) : undefined;
            var week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            var weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            var weekDayName = daysLong[weekDayOffset];
            var isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            var isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            var isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            var isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            var isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            var isFocused = day === date.day && !date.siblingMonth;
            var isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            var isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            var isSiblingMonth = !!date.siblingMonth;
            var isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("9sK38", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e3a731328348eea$export$2e2bcd8739ae039);

var $55Hwx = parcelRequire("55Hwx");

var $5n8dM = parcelRequire("5n8dM");

var $7KFtH = parcelRequire("7KFtH");
function $6e3a731328348eea$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $5n8dM.default)(1, arguments);
    var additionalDigits = (0, $7KFtH.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $6e3a731328348eea$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $6e3a731328348eea$var$parseYear(dateStrings.date, additionalDigits);
        date = $6e3a731328348eea$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $6e3a731328348eea$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $6e3a731328348eea$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $6e3a731328348eea$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $6e3a731328348eea$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $6e3a731328348eea$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $6e3a731328348eea$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $6e3a731328348eea$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($6e3a731328348eea$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($6e3a731328348eea$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($6e3a731328348eea$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $6e3a731328348eea$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $6e3a731328348eea$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $6e3a731328348eea$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($6e3a731328348eea$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $6e3a731328348eea$var$parseDateUnit(captures[1]);
    var month = $6e3a731328348eea$var$parseDateUnit(captures[2]) - 1;
    var day = $6e3a731328348eea$var$parseDateUnit(captures[3]);
    var week = $6e3a731328348eea$var$parseDateUnit(captures[4]);
    var dayOfWeek = $6e3a731328348eea$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$6e3a731328348eea$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $6e3a731328348eea$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$6e3a731328348eea$var$validateDate(year, month, day) || !$6e3a731328348eea$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $6e3a731328348eea$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $6e3a731328348eea$var$parseTime(timeString) {
    var captures = timeString.match($6e3a731328348eea$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $6e3a731328348eea$var$parseTimeUnit(captures[1]);
    var minutes = $6e3a731328348eea$var$parseTimeUnit(captures[2]);
    var seconds = $6e3a731328348eea$var$parseTimeUnit(captures[3]);
    if (!$6e3a731328348eea$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $55Hwx.millisecondsInHour) + minutes * (0, $55Hwx.millisecondsInMinute) + seconds * 1000;
}
function $6e3a731328348eea$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $6e3a731328348eea$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($6e3a731328348eea$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$6e3a731328348eea$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $55Hwx.millisecondsInHour) + minutes * (0, $55Hwx.millisecondsInMinute));
}
function $6e3a731328348eea$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $6e3a731328348eea$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $6e3a731328348eea$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $6e3a731328348eea$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($6e3a731328348eea$var$daysInMonths[month] || ($6e3a731328348eea$var$isLeapYearIndex(year) ? 29 : 28));
}
function $6e3a731328348eea$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($6e3a731328348eea$var$isLeapYearIndex(year) ? 366 : 365);
}
function $6e3a731328348eea$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $6e3a731328348eea$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $6e3a731328348eea$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});
parcelRegister("55Hwx", function(module, exports) {
$parcel$export(module.exports, "millisecondsInMinute", () => $3b4f2e47871a6333$export$91246f0b9bd9beff);
$parcel$export(module.exports, "millisecondsInHour", () => $3b4f2e47871a6333$export$7f72910d6dfd237a);
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $3b4f2e47871a6333$export$dfd9b671c89acc8e = 7;
var $3b4f2e47871a6333$export$3913210603d8e9ae = 365.2425;
var $3b4f2e47871a6333$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $3b4f2e47871a6333$export$91246f0b9bd9beff = 60000;
var $3b4f2e47871a6333$export$7f72910d6dfd237a = 3600000;
var $3b4f2e47871a6333$export$397c2d5776aa9055 = 1000;
var $3b4f2e47871a6333$export$4dec998e48f9c246 = -$3b4f2e47871a6333$export$81caae6e1cc7a622;
var $3b4f2e47871a6333$export$f2f5ae5a8e2d8f9f = 60;
var $3b4f2e47871a6333$export$3c58128db900d44e = 3;
var $3b4f2e47871a6333$export$80d7e435f744f319 = 12;
var $3b4f2e47871a6333$export$4db7641526e3241f = 4;
var $3b4f2e47871a6333$export$698aec755e92c695 = 3600;
var $3b4f2e47871a6333$export$a77c1a7ebebe2a5a = 60;
var $3b4f2e47871a6333$export$815a9362476d2fe3 = $3b4f2e47871a6333$export$698aec755e92c695 * 24;
var $3b4f2e47871a6333$export$34804a017b31e2fe = $3b4f2e47871a6333$export$815a9362476d2fe3 * 7;
var $3b4f2e47871a6333$export$7271e9e3478110d1 = $3b4f2e47871a6333$export$815a9362476d2fe3 * $3b4f2e47871a6333$export$3913210603d8e9ae;
var $3b4f2e47871a6333$export$8e6600bbdee7dabb = $3b4f2e47871a6333$export$7271e9e3478110d1 / 12;
var $3b4f2e47871a6333$export$be1dccf2de902d31 = $3b4f2e47871a6333$export$8e6600bbdee7dabb * 3;

});

parcelRegister("5n8dM", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e957a499413f6b7$export$2e2bcd8739ae039);
function $3e957a499413f6b7$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});

parcelRegister("7KFtH", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a4d00f949aee6a3$export$2e2bcd8739ae039);
function $5a4d00f949aee6a3$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});


parcelRegister("gMEiR", function(module, exports) {
$parcel$export(module.exports, "daysPerWeek", () => $c3806468c02d6736$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $c3806468c02d6736$export$c9b7c010035d60c6);
var $c3806468c02d6736$export$3ae905d9742bef55 = 7;
var $c3806468c02d6736$export$c9b7c010035d60c6 = 12;

});

parcelRegister("Kqkrb", function(module, exports) {
$parcel$export(module.exports, "default", () => $08b8b84f9c25fd06$export$2e2bcd8739ae039);

var $69x5N = parcelRequire("69x5N");
function $08b8b84f9c25fd06$export$2e2bcd8739ae039(date, options) {
    return "".concat(date.year, "-").concat((0, $69x5N.default)(date.month + (options && options.fixMonth ? 1 : 0)), "-").concat((0, $69x5N.default)(date.day));
}

});

parcelRegister("ffUrG", function(module, exports) {
$parcel$export(module.exports, "default", () => $b1b40a9bd93a242f$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $gMEiR = parcelRequire("gMEiR");

var $lOflG = parcelRequire("lOflG");
function $b1b40a9bd93a242f$export$2e2bcd8739ae039(year, month) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        weekStartDay: 0
    }, _ref$weekStartDay = _ref.weekStartDay, weekStartDay = _ref$weekStartDay === void 0 ? 0 : _ref$weekStartDay;
    var date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    var utcYear = date.getUTCFullYear();
    var utcMonth = date.getUTCMonth();
    var calendar = [];
    var firstDay = date.getUTCDay();
    var firstDate = -(((0, $gMEiR.daysPerWeek) - weekStartDay + firstDay) % (0, $gMEiR.daysPerWeek));
    var lastDate = (0, $lOflG.default)(utcYear, utcMonth);
    var lastDay = (lastDate - firstDate) % (0, $gMEiR.daysPerWeek);
    var lastDateOfPreviousMonth = (0, $lOflG.default)(utcYear, utcMonth - 1);
    var dateCounter = firstDate;
    var currentDay;
    var currentDate;
    var currentDateObject = null;
    var calculatedMonth;
    var calculatedYear;
    var maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $gMEiR.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $gMEiR.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $gMEiR.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $gMEiR.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $gMEiR.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("lOflG", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe0a2c6ddcdf7528$export$2e2bcd8739ae039);
function $fe0a2c6ddcdf7528$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("d2Jzc", function(module, exports) {
$parcel$export(module.exports, "default", () => $97eecee102b849ed$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $gMEiR = parcelRequire("gMEiR");

var $Kqkrb = parcelRequire("Kqkrb");

var $lOflG = parcelRequire("lOflG");
function $97eecee102b849ed$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $97eecee102b849ed$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $97eecee102b849ed$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $97eecee102b849ed$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $97eecee102b849ed$var$getNextMonth = function getNextMonth(monthValue, yearValue) {
    var month = monthValue;
    var year = yearValue;
    if (month === (0, $gMEiR.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
var $97eecee102b849ed$var$getPrevMonth = function getPrevMonth(monthValue, yearValue) {
    var month = monthValue;
    var year = yearValue;
    if (month === 1) {
        month = (0, $gMEiR.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $97eecee102b849ed$export$2e2bcd8739ae039(_ref) {
    var _ref$day = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref.day, 2), dayValue = _ref$day[0], setDayValue = _ref$day[1], _ref$month = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref.month, 2), monthValue = _ref$month[0], setMonthValue = _ref$month[1], _ref$year = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref.year, 2), yearValue = _ref$year[0], setYearValue = _ref$year[1], _ref$shouldSetFocus = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref.shouldSetFocus, 2), _shouldSetFocus = _ref$shouldSetFocus[0], setShouldSetFocus = _ref$shouldSetFocus[1], onChange = _ref.onChange;
    var dateRef = (0, $5FkrB.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5FkrB.useEffect)(function() {
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    var triggerOnChange = (0, $5FkrB.useCallback)(function(_ref2) {
        var year = _ref2.year, month = _ref2.month, day = _ref2.day, type = _ref2.type;
        var iso = (0, $Kqkrb.default)({
            year: year,
            month: month,
            day: day
        });
        var isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    var navigate = (0, $5FkrB.useCallback)(function(type) {
        var _dateRef$current = dateRef.current, day = _dateRef$current.day, month = _dateRef$current.month, year = _dateRef$current.year;
        if (type === 'down') {
            var next = day + (0, $gMEiR.daysPerWeek);
            var daysInMonth = (0, $lOflG.default)(year, month - 1);
            if (next > daysInMonth) {
                var _getNextMonth = $97eecee102b849ed$var$getNextMonth(month, year), nextMonth = _getNextMonth.month, nextYear = _getNextMonth.year;
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            var prev = day - 1;
            if (prev < 1) {
                var _getPrevMonth = $97eecee102b849ed$var$getPrevMonth(month, year), prevMonth = _getPrevMonth.month, prevYear = _getPrevMonth.year;
                var prevDay = (0, $lOflG.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            var _next = day + 1;
            var _daysInMonth = (0, $lOflG.default)(year, month - 1);
            if (_next > _daysInMonth) {
                var _getNextMonth2 = $97eecee102b849ed$var$getNextMonth(month, year), _nextMonth = _getNextMonth2.month, _nextYear = _getNextMonth2.year;
                triggerOnChange({
                    year: _nextYear,
                    month: _nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: _next,
                type: type
            });
        } else if (type === 'up') {
            var _prev = day - (0, $gMEiR.daysPerWeek);
            if (_prev < 1) {
                var _getPrevMonth2 = $97eecee102b849ed$var$getPrevMonth(month, year), _prevMonth = _getPrevMonth2.month, _prevYear = _getPrevMonth2.year;
                var _prevDay = (0, $lOflG.default)(_prevYear, _prevMonth - 1) + _prev;
                triggerOnChange({
                    year: _prevYear,
                    month: _prevMonth,
                    day: _prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: _prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    var handleClickNextMonth = (0, $5FkrB.useCallback)(function() {
        var _dateRef$current$getN = $97eecee102b849ed$var$_objectSpread($97eecee102b849ed$var$_objectSpread({}, dateRef.current), $97eecee102b849ed$var$getNextMonth(dateRef.current.month, dateRef.current.year)), day = _dateRef$current$getN.day, month = _dateRef$current$getN.month, year = _dateRef$current$getN.year;
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'nextMonth'
        });
    }, [
        triggerOnChange
    ]);
    var handleClickNextYear = (0, $5FkrB.useCallback)(function() {
        var _dateRef$current2 = dateRef.current, day = _dateRef$current2.day, month = _dateRef$current2.month, year = _dateRef$current2.year;
        triggerOnChange({
            day: day,
            month: month,
            year: year + 1,
            type: 'nextYear'
        });
    }, [
        triggerOnChange
    ]);
    var handleClickPrevMonth = (0, $5FkrB.useCallback)(function() {
        var _dateRef$current$getP = $97eecee102b849ed$var$_objectSpread($97eecee102b849ed$var$_objectSpread({}, dateRef.current), $97eecee102b849ed$var$getPrevMonth(dateRef.current.month, dateRef.current.year)), day = _dateRef$current$getP.day, month = _dateRef$current$getP.month, year = _dateRef$current$getP.year;
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prevMonth'
        });
    }, [
        triggerOnChange
    ]);
    var handleClickPrevYear = (0, $5FkrB.useCallback)(function() {
        var _dateRef$current3 = dateRef.current, day = _dateRef$current3.day, month = _dateRef$current3.month, year = _dateRef$current3.year;
        triggerOnChange({
            day: day,
            month: month,
            year: year - 1,
            type: 'prevYear'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear
    };
}

});

parcelRegister("fzBXN", function(module, exports) {
$parcel$export(module.exports, "default", () => $b56792a2bb94bfa0$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $Kqkrb = parcelRequire("Kqkrb");
var $b56792a2bb94bfa0$var$arrowKeys = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
function $b56792a2bb94bfa0$export$2e2bcd8739ae039(_ref) {
    var _ref$day = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref.day, 1), dayValue = _ref$day[0], _ref$month = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref.month, 1), monthValue = _ref$month[0], _ref$year = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref.year, 1), yearValue = _ref$year[0], _ref$selected = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref.selected, 2), selectedValue = _ref$selected[0], setSelectedValue = _ref$selected[1], _ref$previous = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref.previous, 2), setPreviouslySelectedValue = _ref$previous[1], onSelect = _ref.onSelect, navigate = _ref.navigate;
    var dateRef = (0, $5FkrB.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5FkrB.useEffect)(function() {
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    var triggerOnSelect = (0, $5FkrB.useCallback)(function(_ref2) {
        var year = _ref2.year, month = _ref2.month, day = _ref2.day;
        var iso = (0, $Kqkrb.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    var handleClickDay = (0, $5FkrB.useCallback)(function(_ref3) {
        var year = _ref3.year, month = _ref3.month, day = _ref3.day;
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    var handleContainerKeyDown = (0, $5FkrB.useCallback)(function(e) {
        var key = e.key;
        var arrowKey = $b56792a2bb94bfa0$var$arrowKeys[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("dS7TY", function(module, exports) {
$parcel$export(module.exports, "default", () => $a19672aa5c5ede59$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $bCpKE = parcelRequire("bCpKE");

var $50U6m = parcelRequire("50U6m");
function $a19672aa5c5ede59$export$2e2bcd8739ae039(_ref) {
    var locale = _ref.locale, weekStartDay = _ref.weekStartDay;
    var l10n = (0, $5FkrB.useMemo)(function() {
        return (0, $bCpKE.createLocalizationProvider)(locale);
    }, [
        locale
    ]);
    var resolvedWeekStartDay = (0, $5FkrB.useMemo)(function() {
        return weekStartDay !== null && weekStartDay !== void 0 ? weekStartDay : (0, $50U6m.fg)('platform-dst-locale-week-start-day') ? l10n.getFirstDayOfWeek() : 0;
    }, [
        l10n,
        weekStartDay
    ]);
    var monthsLong = (0, $5FkrB.useMemo)(function() {
        return l10n.getMonthsLong();
    }, [
        l10n
    ]);
    var daysShort = (0, $5FkrB.useMemo)(function() {
        return l10n.getDaysShort(resolvedWeekStartDay);
    }, [
        l10n,
        resolvedWeekStartDay
    ]);
    var daysLong = (0, $5FkrB.useMemo)(function() {
        return l10n.getDaysLong(resolvedWeekStartDay);
    }, [
        l10n,
        resolvedWeekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong,
        weekStartDay: resolvedWeekStartDay
    };
}

});


parcelRegister("eOG0P", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac9652f72cf08031$export$2e2bcd8739ae039);

var $9Ilag = parcelRequire("9Ilag");
function $ac9652f72cf08031$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $9Ilag.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}

});
parcelRegister("9Ilag", function(module, exports) {
$parcel$export(module.exports, "default", () => $7128a3f0131f145e$export$2e2bcd8739ae039);

var $gDpKG = parcelRequire("gDpKG");
function $7128a3f0131f145e$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $gDpKG.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $gDpKG.default)(r, a) : void 0;
    }
}

});
parcelRegister("gDpKG", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1c443a7ae54a274$export$2e2bcd8739ae039);
function $c1c443a7ae54a274$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});



parcelRegister("4AHqC", function(module, exports) {
$parcel$export(module.exports, "default", () => $357c362a628e0026$export$2e2bcd8739ae039);
function $357c362a628e0026$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("fnxbN", function(module, exports) {
$parcel$export(module.exports, "default", () => $b322bfaf968ece30$export$2e2bcd8739ae039);

var $5h2NW = parcelRequire("5h2NW");
function $b322bfaf968ece30$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $5h2NW.default)(t, e);
}

});

parcelRegister("llIiI", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8adec5a2456053d$export$2e2bcd8739ae039);

var $5tmUm = parcelRequire("5tmUm");

var $7ZUle = parcelRequire("7ZUle");

var $5H4Te = parcelRequire("5H4Te");
function $f8adec5a2456053d$export$2e2bcd8739ae039(t) {
    var r = (0, $7ZUle.default)();
    return function() {
        var e, o = (0, $5tmUm.default)(t);
        if (r) {
            var s = (0, $5tmUm.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $5H4Te.default)(this, e);
    };
}

});
parcelRegister("5tmUm", function(module, exports) {
$parcel$export(module.exports, "default", () => $3fc16e38cdaa47e8$export$2e2bcd8739ae039);
function $3fc16e38cdaa47e8$export$2e2bcd8739ae039(t) {
    return $3fc16e38cdaa47e8$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $3fc16e38cdaa47e8$export$2e2bcd8739ae039(t);
}

});

parcelRegister("7ZUle", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d29ef23edead2c9$export$2e2bcd8739ae039);
function $5d29ef23edead2c9$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5d29ef23edead2c9$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("5H4Te", function(module, exports) {
$parcel$export(module.exports, "default", () => $4254c2e67805ec50$export$2e2bcd8739ae039);

var $4bFFZ = parcelRequire("4bFFZ");

var $4AHqC = parcelRequire("4AHqC");
function $4254c2e67805ec50$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $4bFFZ.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $4AHqC.default)(t);
}

});


parcelRegister("aWDq9", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f7de64e86c81d8f$export$2e2bcd8739ae039);
function $7f7de64e86c81d8f$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("kU8z5", function(module, exports) {
$parcel$export(module.exports, "default", () => $f37fae6ac693d96f$export$2e2bcd8739ae039);

var $9ngsp = parcelRequire("9ngsp");
function $f37fae6ac693d96f$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $9ngsp.default)(o.key), o);
    }
}
function $f37fae6ac693d96f$export$2e2bcd8739ae039(e, r, t) {
    return r && $f37fae6ac693d96f$var$_defineProperties(e.prototype, r), t && $f37fae6ac693d96f$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("7WAD0", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $5c8a5cc9c3b8635c$var$noop() {
// No operation performed.
}
module.exports = $5c8a5cc9c3b8635c$var$noop;

});

parcelRegister("7igKY", function(module, exports) {
$parcel$export(module.exports, "mergeRefs", () => $54f7365ef23cc5c4$export$c9058316764c140e);

var $eurAs = parcelRequire("eurAs");

var $f8grB = parcelRequire("f8grB");
function $54f7365ef23cc5c4$export$c9058316764c140e(refs) {
    return (0, $f8grB.createCallbackRef)(function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $eurAs.assignRef)(ref, newValue);
        });
    });
}

});
parcelRegister("f8grB", function(module, exports) {
$parcel$export(module.exports, "createCallbackRef", () => $b0445bdec5b8b292$export$35a19128eb4acba4);
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $b0445bdec5b8b292$export$35a19128eb4acba4(callback) {
    var current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            var last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}

});


parcelRegister("rM88w", function(module, exports) {

var $kqGi7 = parcelRequire("kqGi7");

var $3PGbS = parcelRequire("3PGbS");

var $4XdzH = parcelRequire("4XdzH");

var $4vMNO = parcelRequire("4vMNO");

var $llxyP = parcelRequire("llxyP");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $0537db6479d58bdd$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $4XdzH;
    if (typeof value == 'object') return $4vMNO(value) ? $3PGbS(value[0], value[1]) : $kqGi7(value);
    return $llxyP(value);
}
module.exports = $0537db6479d58bdd$var$baseIteratee;

});
parcelRegister("kqGi7", function(module, exports) {

var $cu7Wi = parcelRequire("cu7Wi");

var $gCoRb = parcelRequire("gCoRb");

var $ksIMb = parcelRequire("ksIMb");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $edf70a82707a5c74$var$baseMatches(source) {
    var matchData = $gCoRb(source);
    if (matchData.length == 1 && matchData[0][2]) return $ksIMb(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $cu7Wi(object, source, matchData);
    };
}
module.exports = $edf70a82707a5c74$var$baseMatches;

});
parcelRegister("cu7Wi", function(module, exports) {

var $7kqkb = parcelRequire("7kqkb");

var $ca8FL = parcelRequire("ca8FL");
/** Used to compose bitmasks for value comparisons. */ var $916e71f2ad42bc0c$var$COMPARE_PARTIAL_FLAG = 1, $916e71f2ad42bc0c$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $916e71f2ad42bc0c$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $7kqkb;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $ca8FL(srcValue, objValue, $916e71f2ad42bc0c$var$COMPARE_PARTIAL_FLAG | $916e71f2ad42bc0c$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $916e71f2ad42bc0c$var$baseIsMatch;

});
parcelRegister("7kqkb", function(module, exports) {

var $jcImH = parcelRequire("jcImH");

var $djPNA = parcelRequire("djPNA");

var $hylOX = parcelRequire("hylOX");

var $jO3zu = parcelRequire("jO3zu");

var $bxqxo = parcelRequire("bxqxo");

var $esD6S = parcelRequire("esD6S");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $555ed227043693dd$var$Stack(entries) {
    var data = this.__data__ = new $jcImH(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$555ed227043693dd$var$Stack.prototype.clear = $djPNA;
$555ed227043693dd$var$Stack.prototype['delete'] = $hylOX;
$555ed227043693dd$var$Stack.prototype.get = $jO3zu;
$555ed227043693dd$var$Stack.prototype.has = $bxqxo;
$555ed227043693dd$var$Stack.prototype.set = $esD6S;
module.exports = $555ed227043693dd$var$Stack;

});
parcelRegister("djPNA", function(module, exports) {

var $jcImH = parcelRequire("jcImH");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $9b253ae18ed66763$var$stackClear() {
    this.__data__ = new $jcImH;
    this.size = 0;
}
module.exports = $9b253ae18ed66763$var$stackClear;

});

parcelRegister("hylOX", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $cc7689cecebf80d4$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $cc7689cecebf80d4$var$stackDelete;

});

parcelRegister("jO3zu", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e6b57505e61dbbd6$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $e6b57505e61dbbd6$var$stackGet;

});

parcelRegister("bxqxo", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $86675c97e12c435a$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $86675c97e12c435a$var$stackHas;

});

parcelRegister("esD6S", function(module, exports) {

var $jcImH = parcelRequire("jcImH");

var $45eKn = parcelRequire("45eKn");

var $fbj5d = parcelRequire("fbj5d");
/** Used as the size to enable large array optimizations. */ var $a87204a1a5016597$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $a87204a1a5016597$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $jcImH) {
        var pairs = data.__data__;
        if (!$45eKn || pairs.length < $a87204a1a5016597$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $fbj5d(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $a87204a1a5016597$var$stackSet;

});


parcelRegister("ca8FL", function(module, exports) {

var $9b9bC = parcelRequire("9b9bC");

var $9Msco = parcelRequire("9Msco");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $8dad2568c75ac63f$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$9Msco(value) && !$9Msco(other)) return value !== value && other !== other;
    return $9b9bC(value, other, bitmask, customizer, $8dad2568c75ac63f$var$baseIsEqual, stack);
}
module.exports = $8dad2568c75ac63f$var$baseIsEqual;

});
parcelRegister("9b9bC", function(module, exports) {

var $7kqkb = parcelRequire("7kqkb");

var $63dty = parcelRequire("63dty");

var $hmXdW = parcelRequire("hmXdW");

var $9UVG3 = parcelRequire("9UVG3");

var $eYfpN = parcelRequire("eYfpN");

var $4vMNO = parcelRequire("4vMNO");

var $hKJGr = parcelRequire("hKJGr");

var $35WaP = parcelRequire("35WaP");
/** Used to compose bitmasks for value comparisons. */ var $6aec445ee44e62ff$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $6aec445ee44e62ff$var$argsTag = '[object Arguments]', $6aec445ee44e62ff$var$arrayTag = '[object Array]', $6aec445ee44e62ff$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $6aec445ee44e62ff$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6aec445ee44e62ff$var$hasOwnProperty = $6aec445ee44e62ff$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $6aec445ee44e62ff$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $4vMNO(object), othIsArr = $4vMNO(other), objTag = objIsArr ? $6aec445ee44e62ff$var$arrayTag : $eYfpN(object), othTag = othIsArr ? $6aec445ee44e62ff$var$arrayTag : $eYfpN(other);
    objTag = objTag == $6aec445ee44e62ff$var$argsTag ? $6aec445ee44e62ff$var$objectTag : objTag;
    othTag = othTag == $6aec445ee44e62ff$var$argsTag ? $6aec445ee44e62ff$var$objectTag : othTag;
    var objIsObj = objTag == $6aec445ee44e62ff$var$objectTag, othIsObj = othTag == $6aec445ee44e62ff$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $hKJGr(object)) {
        if (!$hKJGr(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $7kqkb);
        return objIsArr || $35WaP(object) ? $63dty(object, other, bitmask, customizer, equalFunc, stack) : $hmXdW(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $6aec445ee44e62ff$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $6aec445ee44e62ff$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $6aec445ee44e62ff$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $7kqkb);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $7kqkb);
    return $9UVG3(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $6aec445ee44e62ff$var$baseIsEqualDeep;

});
parcelRegister("63dty", function(module, exports) {

var $lRqBv = parcelRequire("lRqBv");

var $nxDZH = parcelRequire("nxDZH");

var $lNWRT = parcelRequire("lNWRT");
/** Used to compose bitmasks for value comparisons. */ var $467d79e7a0dc3223$var$COMPARE_PARTIAL_FLAG = 1, $467d79e7a0dc3223$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $467d79e7a0dc3223$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $467d79e7a0dc3223$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $467d79e7a0dc3223$var$COMPARE_UNORDERED_FLAG ? new $lRqBv : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$nxDZH(other, function(othValue, othIndex) {
                if (!$lNWRT(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $467d79e7a0dc3223$var$equalArrays;

});
parcelRegister("lRqBv", function(module, exports) {

var $fbj5d = parcelRequire("fbj5d");

var $jZbnn = parcelRequire("jZbnn");

var $watpw = parcelRequire("watpw");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $fea32f338652af47$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $fbj5d;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$fea32f338652af47$var$SetCache.prototype.add = $fea32f338652af47$var$SetCache.prototype.push = $jZbnn;
$fea32f338652af47$var$SetCache.prototype.has = $watpw;
module.exports = $fea32f338652af47$var$SetCache;

});
parcelRegister("jZbnn", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $03c13c07b846ee4b$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $03c13c07b846ee4b$var$setCacheAdd(value) {
    this.__data__.set(value, $03c13c07b846ee4b$var$HASH_UNDEFINED);
    return this;
}
module.exports = $03c13c07b846ee4b$var$setCacheAdd;

});

parcelRegister("watpw", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $060b1d10c0941294$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $060b1d10c0941294$var$setCacheHas;

});


parcelRegister("nxDZH", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $046c3f1b97584d32$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $046c3f1b97584d32$var$arraySome;

});

parcelRegister("lNWRT", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fdfbd692a8a03f6b$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $fdfbd692a8a03f6b$var$cacheHas;

});


parcelRegister("hmXdW", function(module, exports) {

var $fb7PP = parcelRequire("fb7PP");

var $e4K2f = parcelRequire("e4K2f");

var $grAle = parcelRequire("grAle");

var $63dty = parcelRequire("63dty");

var $f98N5 = parcelRequire("f98N5");

var $p1poT = parcelRequire("p1poT");
/** Used to compose bitmasks for value comparisons. */ var $ca526e59406bed21$var$COMPARE_PARTIAL_FLAG = 1, $ca526e59406bed21$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $ca526e59406bed21$var$boolTag = '[object Boolean]', $ca526e59406bed21$var$dateTag = '[object Date]', $ca526e59406bed21$var$errorTag = '[object Error]', $ca526e59406bed21$var$mapTag = '[object Map]', $ca526e59406bed21$var$numberTag = '[object Number]', $ca526e59406bed21$var$regexpTag = '[object RegExp]', $ca526e59406bed21$var$setTag = '[object Set]', $ca526e59406bed21$var$stringTag = '[object String]', $ca526e59406bed21$var$symbolTag = '[object Symbol]';
var $ca526e59406bed21$var$arrayBufferTag = '[object ArrayBuffer]', $ca526e59406bed21$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $ca526e59406bed21$var$symbolProto = $fb7PP ? $fb7PP.prototype : undefined, $ca526e59406bed21$var$symbolValueOf = $ca526e59406bed21$var$symbolProto ? $ca526e59406bed21$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ca526e59406bed21$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $ca526e59406bed21$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $ca526e59406bed21$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $e4K2f(object), new $e4K2f(other))) return false;
            return true;
        case $ca526e59406bed21$var$boolTag:
        case $ca526e59406bed21$var$dateTag:
        case $ca526e59406bed21$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $grAle(+object, +other);
        case $ca526e59406bed21$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $ca526e59406bed21$var$regexpTag:
        case $ca526e59406bed21$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $ca526e59406bed21$var$mapTag:
            var convert = $f98N5;
        case $ca526e59406bed21$var$setTag:
            var isPartial = bitmask & $ca526e59406bed21$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $p1poT);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $ca526e59406bed21$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $63dty(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $ca526e59406bed21$var$symbolTag:
            if ($ca526e59406bed21$var$symbolValueOf) return $ca526e59406bed21$var$symbolValueOf.call(object) == $ca526e59406bed21$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $ca526e59406bed21$var$equalByTag;

});
parcelRegister("e4K2f", function(module, exports) {

var $iXqsg = parcelRequire("iXqsg");
/** Built-in value references. */ var $a3f526090b0d03d9$var$Uint8Array = $iXqsg.Uint8Array;
module.exports = $a3f526090b0d03d9$var$Uint8Array;

});

parcelRegister("f98N5", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $b06e83ec105b03f5$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $b06e83ec105b03f5$var$mapToArray;

});

parcelRegister("p1poT", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $04b36da66dc85ac6$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $04b36da66dc85ac6$var$setToArray;

});


parcelRegister("9UVG3", function(module, exports) {

var $cLnAZ = parcelRequire("cLnAZ");
/** Used to compose bitmasks for value comparisons. */ var $738615844c0356e3$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $738615844c0356e3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $738615844c0356e3$var$hasOwnProperty = $738615844c0356e3$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $738615844c0356e3$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $738615844c0356e3$var$COMPARE_PARTIAL_FLAG, objProps = $cLnAZ(object), objLength = objProps.length, othProps = $cLnAZ(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $738615844c0356e3$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $738615844c0356e3$var$equalObjects;

});
parcelRegister("cLnAZ", function(module, exports) {

var $3rhCx = parcelRequire("3rhCx");

var $1QI3J = parcelRequire("1QI3J");

var $8XuRV = parcelRequire("8XuRV");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $94ac2d67f2b0179c$var$getAllKeys(object) {
    return $3rhCx(object, $8XuRV, $1QI3J);
}
module.exports = $94ac2d67f2b0179c$var$getAllKeys;

});
parcelRegister("3rhCx", function(module, exports) {

var $fj32b = parcelRequire("fj32b");

var $4vMNO = parcelRequire("4vMNO");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $28118fcaf071ff15$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $4vMNO(object) ? result : $fj32b(result, symbolsFunc(object));
}
module.exports = $28118fcaf071ff15$var$baseGetAllKeys;

});
parcelRegister("fj32b", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $b24afbe2c8091864$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $b24afbe2c8091864$var$arrayPush;

});


parcelRegister("1QI3J", function(module, exports) {

var $cjaaB = parcelRequire("cjaaB");

var $3EIHX = parcelRequire("3EIHX");
/** Used for built-in method references. */ var $158cd2fdded140ac$var$objectProto = Object.prototype;
/** Built-in value references. */ var $158cd2fdded140ac$var$propertyIsEnumerable = $158cd2fdded140ac$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $158cd2fdded140ac$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $158cd2fdded140ac$var$getSymbols = !$158cd2fdded140ac$var$nativeGetSymbols ? $3EIHX : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $cjaaB($158cd2fdded140ac$var$nativeGetSymbols(object), function(symbol) {
        return $158cd2fdded140ac$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $158cd2fdded140ac$var$getSymbols;

});
parcelRegister("cjaaB", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $8f5f25ebc211fb67$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $8f5f25ebc211fb67$var$arrayFilter;

});

parcelRegister("3EIHX", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $2a97c993b4c74802$var$stubArray() {
    return [];
}
module.exports = $2a97c993b4c74802$var$stubArray;

});


parcelRegister("8XuRV", function(module, exports) {

var $5WR7T = parcelRequire("5WR7T");

var $83XOu = parcelRequire("83XOu");

var $8Ak9r = parcelRequire("8Ak9r");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $685bc755b0ff08ca$var$keys(object) {
    return $8Ak9r(object) ? $5WR7T(object) : $83XOu(object);
}
module.exports = $685bc755b0ff08ca$var$keys;

});
parcelRegister("5WR7T", function(module, exports) {

var $64Uwy = parcelRequire("64Uwy");

var $bB85C = parcelRequire("bB85C");

var $4vMNO = parcelRequire("4vMNO");

var $hKJGr = parcelRequire("hKJGr");

var $kgLdF = parcelRequire("kgLdF");

var $35WaP = parcelRequire("35WaP");
/** Used for built-in method references. */ var $454b945364a48147$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $454b945364a48147$var$hasOwnProperty = $454b945364a48147$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $454b945364a48147$var$arrayLikeKeys(value, inherited) {
    var isArr = $4vMNO(value), isArg = !isArr && $bB85C(value), isBuff = !isArr && !isArg && $hKJGr(value), isType = !isArr && !isArg && !isBuff && $35WaP(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $64Uwy(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $454b945364a48147$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $kgLdF(key, length)))) result.push(key);
    return result;
}
module.exports = $454b945364a48147$var$arrayLikeKeys;

});
parcelRegister("64Uwy", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $46cef64ec31e2299$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $46cef64ec31e2299$var$baseTimes;

});

parcelRegister("bB85C", function(module, exports) {

var $jvIOd = parcelRequire("jvIOd");

var $9Msco = parcelRequire("9Msco");
/** Used for built-in method references. */ var $87196cdc2acd682b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $87196cdc2acd682b$var$hasOwnProperty = $87196cdc2acd682b$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $87196cdc2acd682b$var$propertyIsEnumerable = $87196cdc2acd682b$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $87196cdc2acd682b$var$isArguments = $jvIOd(function() {
    return arguments;
}()) ? $jvIOd : function(value) {
    return $9Msco(value) && $87196cdc2acd682b$var$hasOwnProperty.call(value, 'callee') && !$87196cdc2acd682b$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $87196cdc2acd682b$var$isArguments;

});
parcelRegister("jvIOd", function(module, exports) {

var $7Vpf7 = parcelRequire("7Vpf7");

var $9Msco = parcelRequire("9Msco");
/** `Object#toString` result references. */ var $e343abb5076d96d4$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $e343abb5076d96d4$var$baseIsArguments(value) {
    return $9Msco(value) && $7Vpf7(value) == $e343abb5076d96d4$var$argsTag;
}
module.exports = $e343abb5076d96d4$var$baseIsArguments;

});


parcelRegister("hKJGr", function(module, exports) {

var $iXqsg = parcelRequire("iXqsg");

var $fBnUd = parcelRequire("fBnUd");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $iXqsg.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fBnUd;
module.exports = isBuffer;

});
parcelRegister("fBnUd", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b5bcdade5c765129$var$stubFalse() {
    return false;
}
module.exports = $b5bcdade5c765129$var$stubFalse;

});


parcelRegister("35WaP", function(module, exports) {

var $hCJUZ = parcelRequire("hCJUZ");

var $2K3WO = parcelRequire("2K3WO");

var $6hpGa = parcelRequire("6hpGa");
/* Node.js helper references. */ var $240ef6cdb9617e20$var$nodeIsTypedArray = $6hpGa && $6hpGa.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $240ef6cdb9617e20$var$isTypedArray = $240ef6cdb9617e20$var$nodeIsTypedArray ? $2K3WO($240ef6cdb9617e20$var$nodeIsTypedArray) : $hCJUZ;
module.exports = $240ef6cdb9617e20$var$isTypedArray;

});
parcelRegister("hCJUZ", function(module, exports) {

var $7Vpf7 = parcelRequire("7Vpf7");

var $1NwxS = parcelRequire("1NwxS");

var $9Msco = parcelRequire("9Msco");
/** `Object#toString` result references. */ var $cd499aac81060e71$var$argsTag = '[object Arguments]', $cd499aac81060e71$var$arrayTag = '[object Array]', $cd499aac81060e71$var$boolTag = '[object Boolean]', $cd499aac81060e71$var$dateTag = '[object Date]', $cd499aac81060e71$var$errorTag = '[object Error]', $cd499aac81060e71$var$funcTag = '[object Function]', $cd499aac81060e71$var$mapTag = '[object Map]', $cd499aac81060e71$var$numberTag = '[object Number]', $cd499aac81060e71$var$objectTag = '[object Object]', $cd499aac81060e71$var$regexpTag = '[object RegExp]', $cd499aac81060e71$var$setTag = '[object Set]', $cd499aac81060e71$var$stringTag = '[object String]', $cd499aac81060e71$var$weakMapTag = '[object WeakMap]';
var $cd499aac81060e71$var$arrayBufferTag = '[object ArrayBuffer]', $cd499aac81060e71$var$dataViewTag = '[object DataView]', $cd499aac81060e71$var$float32Tag = '[object Float32Array]', $cd499aac81060e71$var$float64Tag = '[object Float64Array]', $cd499aac81060e71$var$int8Tag = '[object Int8Array]', $cd499aac81060e71$var$int16Tag = '[object Int16Array]', $cd499aac81060e71$var$int32Tag = '[object Int32Array]', $cd499aac81060e71$var$uint8Tag = '[object Uint8Array]', $cd499aac81060e71$var$uint8ClampedTag = '[object Uint8ClampedArray]', $cd499aac81060e71$var$uint16Tag = '[object Uint16Array]', $cd499aac81060e71$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $cd499aac81060e71$var$typedArrayTags = {};
$cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$float32Tag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$float64Tag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$int8Tag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$int16Tag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$int32Tag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$uint8Tag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$uint8ClampedTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$uint16Tag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$uint32Tag] = true;
$cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$argsTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$arrayTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$arrayBufferTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$boolTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$dataViewTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$dateTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$errorTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$funcTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$mapTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$numberTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$objectTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$regexpTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$setTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$stringTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $cd499aac81060e71$var$baseIsTypedArray(value) {
    return $9Msco(value) && $1NwxS(value.length) && !!$cd499aac81060e71$var$typedArrayTags[$7Vpf7(value)];
}
module.exports = $cd499aac81060e71$var$baseIsTypedArray;

});
parcelRegister("1NwxS", function(module, exports) {
/** Used as references for various `Number` constants. */ var $14f39ce873328624$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $14f39ce873328624$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $14f39ce873328624$var$MAX_SAFE_INTEGER;
}
module.exports = $14f39ce873328624$var$isLength;

});


parcelRegister("2K3WO", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $1ff2f08eeb6e8b52$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $1ff2f08eeb6e8b52$var$baseUnary;

});

parcelRegister("6hpGa", function(module, exports) {

var $2eo3w = parcelRequire("2eo3w");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $2eo3w.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("83XOu", function(module, exports) {

var $8wFaN = parcelRequire("8wFaN");

var $6Rv5K = parcelRequire("6Rv5K");
/** Used for built-in method references. */ var $5ded003d0f731881$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5ded003d0f731881$var$hasOwnProperty = $5ded003d0f731881$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $5ded003d0f731881$var$baseKeys(object) {
    if (!$8wFaN(object)) return $6Rv5K(object);
    var result = [];
    for(var key in Object(object))if ($5ded003d0f731881$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $5ded003d0f731881$var$baseKeys;

});
parcelRegister("8wFaN", function(module, exports) {
/** Used for built-in method references. */ var $63514008f87d0c8b$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $63514008f87d0c8b$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $63514008f87d0c8b$var$objectProto;
    return value === proto;
}
module.exports = $63514008f87d0c8b$var$isPrototype;

});

parcelRegister("6Rv5K", function(module, exports) {

var $gFyuD = parcelRequire("gFyuD");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $4fefcf7f8e97df7b$var$nativeKeys = $gFyuD(Object.keys, Object);
module.exports = $4fefcf7f8e97df7b$var$nativeKeys;

});
parcelRegister("gFyuD", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $c22b3b500d8fe60a$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $c22b3b500d8fe60a$var$overArg;

});



parcelRegister("8Ak9r", function(module, exports) {

var $78AO6 = parcelRequire("78AO6");

var $1NwxS = parcelRequire("1NwxS");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $64015129b62b03be$var$isArrayLike(value) {
    return value != null && $1NwxS(value.length) && !$78AO6(value);
}
module.exports = $64015129b62b03be$var$isArrayLike;

});




parcelRegister("eYfpN", function(module, exports) {

var $2EgYc = parcelRequire("2EgYc");

var $45eKn = parcelRequire("45eKn");

var $2bW4y = parcelRequire("2bW4y");

var $cvnnV = parcelRequire("cvnnV");

var $2XKpH = parcelRequire("2XKpH");

var $7Vpf7 = parcelRequire("7Vpf7");

var $1DbD2 = parcelRequire("1DbD2");
/** `Object#toString` result references. */ var $ae62a06bd7777973$var$mapTag = '[object Map]', $ae62a06bd7777973$var$objectTag = '[object Object]', $ae62a06bd7777973$var$promiseTag = '[object Promise]', $ae62a06bd7777973$var$setTag = '[object Set]', $ae62a06bd7777973$var$weakMapTag = '[object WeakMap]';
var $ae62a06bd7777973$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $ae62a06bd7777973$var$dataViewCtorString = $1DbD2($2EgYc), $ae62a06bd7777973$var$mapCtorString = $1DbD2($45eKn), $ae62a06bd7777973$var$promiseCtorString = $1DbD2($2bW4y), $ae62a06bd7777973$var$setCtorString = $1DbD2($cvnnV), $ae62a06bd7777973$var$weakMapCtorString = $1DbD2($2XKpH);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $ae62a06bd7777973$var$getTag = $7Vpf7;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($2EgYc && $ae62a06bd7777973$var$getTag(new $2EgYc(new ArrayBuffer(1))) != $ae62a06bd7777973$var$dataViewTag || $45eKn && $ae62a06bd7777973$var$getTag(new $45eKn) != $ae62a06bd7777973$var$mapTag || $2bW4y && $ae62a06bd7777973$var$getTag($2bW4y.resolve()) != $ae62a06bd7777973$var$promiseTag || $cvnnV && $ae62a06bd7777973$var$getTag(new $cvnnV) != $ae62a06bd7777973$var$setTag || $2XKpH && $ae62a06bd7777973$var$getTag(new $2XKpH) != $ae62a06bd7777973$var$weakMapTag) $ae62a06bd7777973$var$getTag = function(value) {
    var result = $7Vpf7(value), Ctor = result == $ae62a06bd7777973$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $1DbD2(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $ae62a06bd7777973$var$dataViewCtorString:
            return $ae62a06bd7777973$var$dataViewTag;
        case $ae62a06bd7777973$var$mapCtorString:
            return $ae62a06bd7777973$var$mapTag;
        case $ae62a06bd7777973$var$promiseCtorString:
            return $ae62a06bd7777973$var$promiseTag;
        case $ae62a06bd7777973$var$setCtorString:
            return $ae62a06bd7777973$var$setTag;
        case $ae62a06bd7777973$var$weakMapCtorString:
            return $ae62a06bd7777973$var$weakMapTag;
    }
    return result;
};
module.exports = $ae62a06bd7777973$var$getTag;

});
parcelRegister("2EgYc", function(module, exports) {

var $76YAf = parcelRequire("76YAf");

var $iXqsg = parcelRequire("iXqsg");
/* Built-in method references that are verified to be native. */ var $1edc7b1251ee37af$var$DataView = $76YAf($iXqsg, 'DataView');
module.exports = $1edc7b1251ee37af$var$DataView;

});

parcelRegister("2bW4y", function(module, exports) {

var $76YAf = parcelRequire("76YAf");

var $iXqsg = parcelRequire("iXqsg");
/* Built-in method references that are verified to be native. */ var $1989a7d3b4a7eed0$var$Promise = $76YAf($iXqsg, 'Promise');
module.exports = $1989a7d3b4a7eed0$var$Promise;

});

parcelRegister("cvnnV", function(module, exports) {

var $76YAf = parcelRequire("76YAf");

var $iXqsg = parcelRequire("iXqsg");
/* Built-in method references that are verified to be native. */ var $91aa850b36ee58fd$var$Set = $76YAf($iXqsg, 'Set');
module.exports = $91aa850b36ee58fd$var$Set;

});

parcelRegister("2XKpH", function(module, exports) {

var $76YAf = parcelRequire("76YAf");

var $iXqsg = parcelRequire("iXqsg");
/* Built-in method references that are verified to be native. */ var $2285183bc7b4f19f$var$WeakMap = $76YAf($iXqsg, 'WeakMap');
module.exports = $2285183bc7b4f19f$var$WeakMap;

});





parcelRegister("gCoRb", function(module, exports) {

var $1RmrW = parcelRequire("1RmrW");

var $8XuRV = parcelRequire("8XuRV");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $c19379f9bb80f646$var$getMatchData(object) {
    var result = $8XuRV(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $1RmrW(value)
        ];
    }
    return result;
}
module.exports = $c19379f9bb80f646$var$getMatchData;

});
parcelRegister("1RmrW", function(module, exports) {

var $lIhLB = parcelRequire("lIhLB");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $15ac27ba16e67add$var$isStrictComparable(value) {
    return value === value && !$lIhLB(value);
}
module.exports = $15ac27ba16e67add$var$isStrictComparable;

});


parcelRegister("ksIMb", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $ee5927c36e3a084b$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $ee5927c36e3a084b$var$matchesStrictComparable;

});


parcelRegister("3PGbS", function(module, exports) {

var $ca8FL = parcelRequire("ca8FL");

var $fe1Wm = parcelRequire("fe1Wm");

var $hCkFK = parcelRequire("hCkFK");

var $agaje = parcelRequire("agaje");

var $1RmrW = parcelRequire("1RmrW");

var $ksIMb = parcelRequire("ksIMb");

var $WbaOC = parcelRequire("WbaOC");
/** Used to compose bitmasks for value comparisons. */ var $2ca6dcb21d828bb2$var$COMPARE_PARTIAL_FLAG = 1, $2ca6dcb21d828bb2$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $2ca6dcb21d828bb2$var$baseMatchesProperty(path, srcValue) {
    if ($agaje(path) && $1RmrW(srcValue)) return $ksIMb($WbaOC(path), srcValue);
    return function(object) {
        var objValue = $fe1Wm(object, path);
        return objValue === undefined && objValue === srcValue ? $hCkFK(object, path) : $ca8FL(srcValue, objValue, $2ca6dcb21d828bb2$var$COMPARE_PARTIAL_FLAG | $2ca6dcb21d828bb2$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $2ca6dcb21d828bb2$var$baseMatchesProperty;

});
parcelRegister("fe1Wm", function(module, exports) {

var $7khqM = parcelRequire("7khqM");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $b159ab20ff56cd31$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $7khqM(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $b159ab20ff56cd31$var$get;

});
parcelRegister("7khqM", function(module, exports) {

var $33EWK = parcelRequire("33EWK");

var $WbaOC = parcelRequire("WbaOC");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $5557ec177d5378fb$var$baseGet(object, path) {
    path = $33EWK(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$WbaOC(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $5557ec177d5378fb$var$baseGet;

});


parcelRegister("hCkFK", function(module, exports) {

var $9Ulc4 = parcelRequire("9Ulc4");

var $1nYFI = parcelRequire("1nYFI");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $cd3605666d66c3fb$var$hasIn(object, path) {
    return object != null && $1nYFI(object, path, $9Ulc4);
}
module.exports = $cd3605666d66c3fb$var$hasIn;

});
parcelRegister("9Ulc4", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $7369c8a0346a73dc$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $7369c8a0346a73dc$var$baseHasIn;

});

parcelRegister("1nYFI", function(module, exports) {

var $33EWK = parcelRequire("33EWK");

var $bB85C = parcelRequire("bB85C");

var $4vMNO = parcelRequire("4vMNO");

var $kgLdF = parcelRequire("kgLdF");

var $1NwxS = parcelRequire("1NwxS");

var $WbaOC = parcelRequire("WbaOC");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $102700946ffbe2b3$var$hasPath(object, path, hasFunc) {
    path = $33EWK(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $WbaOC(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $1NwxS(length) && $kgLdF(key, length) && ($4vMNO(object) || $bB85C(object));
}
module.exports = $102700946ffbe2b3$var$hasPath;

});



parcelRegister("4XdzH", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $39b733c8f22468c0$var$identity(value) {
    return value;
}
module.exports = $39b733c8f22468c0$var$identity;

});

parcelRegister("llxyP", function(module, exports) {

var $ctAP5 = parcelRequire("ctAP5");

var $dvjkq = parcelRequire("dvjkq");

var $agaje = parcelRequire("agaje");

var $WbaOC = parcelRequire("WbaOC");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $f8a5979d7e51b6a2$var$property(path) {
    return $agaje(path) ? $ctAP5($WbaOC(path)) : $dvjkq(path);
}
module.exports = $f8a5979d7e51b6a2$var$property;

});
parcelRegister("ctAP5", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $9154c1b8898a4a95$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $9154c1b8898a4a95$var$baseProperty;

});

parcelRegister("dvjkq", function(module, exports) {

var $7khqM = parcelRequire("7khqM");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $9d4d29d60f770ac8$var$basePropertyDeep(path) {
    return function(object) {
        return $7khqM(object, path);
    };
}
module.exports = $9d4d29d60f770ac8$var$basePropertyDeep;

});



parcelRegister("ll6bk", function(module, exports) {

var $d7fGq = parcelRequire("d7fGq");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $f8905ab289a7a2b1$var$toInteger(value) {
    var result = $d7fGq(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = $f8905ab289a7a2b1$var$toInteger;

});
parcelRegister("d7fGq", function(module, exports) {

var $bSUt0 = parcelRequire("bSUt0");
/** Used as references for various `Number` constants. */ var $98c818320fa2d95c$var$INFINITY = 1 / 0, $98c818320fa2d95c$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $98c818320fa2d95c$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $bSUt0(value);
    if (value === $98c818320fa2d95c$var$INFINITY || value === -$98c818320fa2d95c$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $98c818320fa2d95c$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = $98c818320fa2d95c$var$toFinite;

});


parcelRegister("aH7bq", function(module, exports) {
$parcel$export(module.exports, "CheckboxOption", () => $7c937df582a41edf$export$d40cc97ecda916f9);
/* checkbox-option.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $iNVbQ = parcelRequire("iNVbQ");
var $7c937df582a41edf$var$svgStyles = null;
var $7c937df582a41edf$var$CheckboxIcon = function CheckboxIcon(props) {
    var primaryColor = props.primaryColor, secondaryColor = props.secondaryColor, label = props.label;
    return /*#__PURE__*/ $5FkrB.createElement("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $970q7.default)([
            "_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $5FkrB.createElement("rect", {
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        fill: "currentColor"
    }), /*#__PURE__*/ $5FkrB.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    })));
};
var $7c937df582a41edf$export$d40cc97ecda916f9 = function CheckboxOption(props) {
    return /*#__PURE__*/ $5FkrB.createElement((0, $iNVbQ.ControlOption), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        Icon: $7c937df582a41edf$var$CheckboxIcon
    }, props));
};

});
parcelRegister("iNVbQ", function(module, exports) {
$parcel$export(module.exports, "ControlOption", () => $db092a59d4882fd7$export$e41f7c07e51665da);
/* control-option.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $50U6m = parcelRequire("50U6m");
var $db092a59d4882fd7$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk1j28 _16qs1kw7 _syaz1kw7 _1di6fcek",
    focused: "_bfhk1dpa _16qsgkog _112e5u6v",
    finesseFocused: "_16qsglyw _112eglyw",
    disabled: "_syaz1gmx",
    motion: "_v564hxmd _o7kshxmd _1ggl87vo"
};
// state of the parent option
// the primary color represents the outer or background element
var $db092a59d4882fd7$var$getPrimaryColor = function getPrimaryColor(_ref) {
    var isActive = _ref.isActive, isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected;
    if (isDisabled) return "var(--ds-background-disabled, #0515240F)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #123263)";
    else if (isActive) return "var(--ds-background-selected-pressed, #8FB8F6)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #1558BC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #1868DB)";
    return "var(--ds-background-neutral, #0515240F)";
};
// the secondary color represents the radio dot or checkmark
var $db092a59d4882fd7$var$getSecondaryColor = function getSecondaryColor(_ref2) {
    var isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected;
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #080F214A)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
var $db092a59d4882fd7$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1ihb _1gqp1ihb"
};
var $db092a59d4882fd7$var$baseIconStyles = null;
var $db092a59d4882fd7$var$baseOptionStyles = null;
var $db092a59d4882fd7$export$e41f7c07e51665da = function ControlOption(props) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    var onMouseDown = (0, $5FkrB.useCallback)(function() {
        return setIsActive(true);
    }, []);
    var onMouseUp = (0, $5FkrB.useCallback)(function() {
        return setIsActive(false);
    }, []);
    var Icon = props.Icon, children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, cx = props.cx, className = props.className, isDisabled = props.isDisabled, isSelected = props.isSelected, isFocused = props.isFocused;
    var classNames = (0, $5FkrB.useMemo)(function() {
        return cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className);
    }, [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            $db092a59d4882fd7$var$optionStyles.default,
            !isDisabled && (0, $50U6m.fg)('platform-dst-motion-uplift-list-item') && $db092a59d4882fd7$var$optionStyles.motion,
            isFocused && $db092a59d4882fd7$var$optionStyles.focused,
            isFocused && (0, $50U6m.fg)('platform-dst-tokens-finesse') && $db092a59d4882fd7$var$optionStyles.finesseFocused,
            isDisabled && $db092a59d4882fd7$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseLeave: onMouseUp
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
            isSelected || isActive || isDisabled ? $db092a59d4882fd7$var$iconStyles.inherit : $db092a59d4882fd7$var$iconStyles.default
        ])
    }, !!Icon ? /*#__PURE__*/ $5FkrB.createElement(Icon, {
        label: "",
        primaryColor: $db092a59d4882fd7$var$getPrimaryColor({
            isDisabled: isDisabled,
            isSelected: isSelected,
            isFocused: isFocused,
            isActive: isActive
        }),
        secondaryColor: $db092a59d4882fd7$var$getSecondaryColor({
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        isFacadeDisabled: true
    }) : null), /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
        ])
    }, children));
};

});


parcelRegister("59otM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1078ad25bb88c0aacc625e83cbe31eaf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c00c81bb815e11a$var$_react = $3c00c81bb815e11a$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $3c00c81bb815e11a$var$_iconNew = $3c00c81bb815e11a$var$_interopRequireDefault((parcelRequire("gDzom")));
function $3c00c81bb815e11a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/ai-agent
 * Usage guidance:
 * Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3c00c81bb815e11a$var$AiAgentIcon = (props)=>/*#__PURE__*/ $3c00c81bb815e11a$var$_react.default.createElement($3c00c81bb815e11a$var$_iconNew.default, Object.assign({
        name: "AiAgentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
$3c00c81bb815e11a$var$AiAgentIcon.displayName = 'AiAgentIcon';
var $3c00c81bb815e11a$var$_default = module.exports.default = $3c00c81bb815e11a$var$AiAgentIcon;

});

parcelRegister("a67qK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::44bfe3fda6843e57916c639848bc7fcd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75a03a788dbb037a$var$_react = $75a03a788dbb037a$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $75a03a788dbb037a$var$_iconNew = $75a03a788dbb037a$var$_interopRequireDefault((parcelRequire("gDzom")));
function $75a03a788dbb037a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/person
 * Usage guidance:
 * Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75a03a788dbb037a$var$PersonIcon = (props)=>/*#__PURE__*/ $75a03a788dbb037a$var$_react.default.createElement($75a03a788dbb037a$var$_iconNew.default, Object.assign({
        name: "PersonIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$75a03a788dbb037a$var$PersonIcon.displayName = 'PersonIcon';
var $75a03a788dbb037a$var$_default = module.exports.default = $75a03a788dbb037a$var$PersonIcon;

});

parcelRegister("aWVGs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a375ef61b97315ae7ff25123b3ed791c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f8c10f6c7d7ffc6$var$_react = $7f8c10f6c7d7ffc6$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $7f8c10f6c7d7ffc6$var$_iconNew = $7f8c10f6c7d7ffc6$var$_interopRequireDefault((parcelRequire("gDzom")));
function $7f8c10f6c7d7ffc6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/release
 * Usage guidance:
 * Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f8c10f6c7d7ffc6$var$ReleaseIcon = (props)=>/*#__PURE__*/ $7f8c10f6c7d7ffc6$var$_react.default.createElement($7f8c10f6c7d7ffc6$var$_iconNew.default, Object.assign({
        name: "ReleaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$7f8c10f6c7d7ffc6$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $7f8c10f6c7d7ffc6$var$_default = module.exports.default = $7f8c10f6c7d7ffc6$var$ReleaseIcon;

});

parcelRegister("jMKPI", function(module, exports) {
$parcel$export(module.exports, "default", () => $e676d41834cd8010$export$2e2bcd8739ae039);
/* badge.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $50U6m = parcelRequire("50U6m");

var $72GAO = parcelRequire("72GAO");

var $b1qrY = parcelRequire("b1qrY");

var $akkVd = parcelRequire("akkVd");

var $1aCqH = parcelRequire("1aCqH");

var $aHXTg = parcelRequire("aHXTg");
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they will be updated in the labelling system work and we want to avoid frequent UI changes.\
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ var $e676d41834cd8010$var$neutral300 = '#DDDEE1';
var $e676d41834cd8010$var$red300 = '#FD9891';
var $e676d41834cd8010$var$blue300 = '#8FB8F6';
var $e676d41834cd8010$var$neutral1000 = '#292A2E';
var $e676d41834cd8010$var$styles = {
    root: "_2rkolb4i _18zr1b66 _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    added: "_bfhk1y9u _syazi7uo",
    default: "_bfhk1fkg _syazwwip",
    important: "_bfhk1366 _syazwwip",
    primary: "_bfhk1ymo _syazwwip",
    primaryInverted: "_bfhkvuon _syaz1oa5",
    removed: "_bfhk1gly _syazi7uo"
};
var $e676d41834cd8010$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === 'number' && typeof max === 'number' ? (0, $aHXTg.formatValueWithNegativeSupport)(children, max) : children;
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ var $e676d41834cd8010$var$Badge = /*#__PURE__*/ (0, $5FkrB.memo)(function Badge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    if ((0, $50U6m.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        // Map old appearance names to new ones
        var newAppearance = (0, $b1qrY.appearanceMapping)[appearance];
        return /*#__PURE__*/ $5FkrB.createElement((0, $1aCqH.default), {
            appearance: newAppearance,
            max: max,
            style: style,
            testId: testId
        }, children);
    }
    var oldAppearance = (0, $akkVd.appearanceMappingToOld)[appearance];
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $970q7.default)([
            $e676d41834cd8010$var$styles.root,
            $e676d41834cd8010$var$styles[oldAppearance]
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $72GAO.Text), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $e676d41834cd8010$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $e676d41834cd8010$export$2e2bcd8739ae039 = $e676d41834cd8010$var$Badge;

});
parcelRegister("b1qrY", function(module, exports) {
$parcel$export(module.exports, "appearanceMapping", () => $80644e2bed1866d1$export$d21bba0569254935);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var $80644e2bed1866d1$export$d21bba0569254935 = {
    added: 'success',
    removed: 'danger',
    default: 'neutral',
    primary: 'information',
    primaryInverted: 'inverse',
    important: 'danger',
    warning: 'warning',
    discovery: 'discovery',
    danger: 'danger',
    success: 'success',
    information: 'information',
    inverse: 'inverse',
    neutral: 'neutral',
    informationBold: 'informationBold',
    successBold: 'successBold',
    dangerBold: 'dangerBold',
    warningBold: 'warningBold',
    discoveryBold: 'discoveryBold'
};

});

parcelRegister("akkVd", function(module, exports) {
$parcel$export(module.exports, "appearanceMappingToOld", () => $784c0047ac8f9b6c$export$16f8cc7ac3541e83);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var $784c0047ac8f9b6c$export$16f8cc7ac3541e83 = {
    added: 'added',
    removed: 'removed',
    default: 'default',
    primary: 'primary',
    primaryInverted: 'primaryInverted',
    important: 'important',
    danger: 'removed',
    success: 'added',
    information: 'primary',
    inverse: 'primaryInverted',
    neutral: 'default',
    warning: 'default',
    discovery: 'default',
    informationBold: 'primary',
    successBold: 'added',
    dangerBold: 'important',
    warningBold: 'default',
    discoveryBold: 'default'
};

});

parcelRegister("aHXTg", function(module, exports) {
$parcel$export(module.exports, "formatValueWithNegativeSupport", () => $7cbc607cce3cf77d$export$4b844743568d5983);
function $7cbc607cce3cf77d$var$getSafeValueWithNegativeSupport() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $7cbc607cce3cf77d$export$4b844743568d5983(value, max) {
    var safeValue = $7cbc607cce3cf77d$var$getSafeValueWithNegativeSupport(value);
    var safeMax = $7cbc607cce3cf77d$var$getSafeValueWithNegativeSupport(max);
    var hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("6Qk7v", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fb734d833f2f5f7$export$2e2bcd8739ae039);

var $3NKAv = parcelRequire("3NKAv");
parcelRequire("kqp0i");

parcelRequire("ckRFu");
parcelRequire("5qnXH");
parcelRequire("eP8dQ");
parcelRequire("5FkrB");
parcelRequire("7t6hN");
var $4fb734d833f2f5f7$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $4fb734d833f2f5f7$export$2e2bcd8739ae039 = (0, $3NKAv.default).bind(null);
$4fb734d833f2f5f7$var$tags.forEach(function(tagName) {
    $4fb734d833f2f5f7$export$2e2bcd8739ae039[tagName] = $4fb734d833f2f5f7$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("3NKAv", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c4a161278714118$export$2e2bcd8739ae039);

var $d1G9Q = parcelRequire("d1G9Q");
parcelRequire("74Zh5");
var $rxpl9 = parcelRequire("rxpl9");

var $ckRFu = parcelRequire("ckRFu");

var $5qnXH = parcelRequire("5qnXH");

var $eP8dQ = parcelRequire("eP8dQ");

var $5FkrB = parcelRequire("5FkrB");

var $7t6hN = parcelRequire("7t6hN");
var $2c4a161278714118$var$isBrowser = typeof document !== 'undefined';
var $2c4a161278714118$var$isDevelopment = false;
var $2c4a161278714118$var$testOmitPropsOnStringTag = (0, $7t6hN.default);
var $2c4a161278714118$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $2c4a161278714118$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $2c4a161278714118$var$testOmitPropsOnStringTag : $2c4a161278714118$var$testOmitPropsOnComponent;
};
var $2c4a161278714118$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $2c4a161278714118$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $eP8dQ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $5qnXH.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $eP8dQ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$2c4a161278714118$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $5FkrB.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $2c4a161278714118$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $2c4a161278714118$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $2c4a161278714118$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $rxpl9.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $5FkrB.useContext((0, $rxpl9.T));
            }
            if (typeof props.className === 'string') className = (0, $eP8dQ.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $ckRFu.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $2c4a161278714118$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $5FkrB.createElement($5FkrB.Fragment, null, /*#__PURE__*/ $5FkrB.createElement($2c4a161278714118$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $5FkrB.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $2c4a161278714118$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $d1G9Q.default)({}, options, nextOptions, {
                shouldForwardProp: $2c4a161278714118$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("7t6hN", function(module, exports) {
$parcel$export(module.exports, "default", () => $57001e228c890016$export$2e2bcd8739ae039);

var $7VhhO = parcelRequire("7VhhO");
// eslint-disable-next-line no-undef
var $57001e228c890016$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $57001e228c890016$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $7VhhO.default)(function(prop) {
    return $57001e228c890016$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("f5vjV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1eb0bea125dd8937d618f765cb0e5678>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $afbf9e3c851377a1$var$_react = $afbf9e3c851377a1$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $afbf9e3c851377a1$var$_iconNew = $afbf9e3c851377a1$var$_interopRequireDefault((parcelRequire("gDzom")));
function $afbf9e3c851377a1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/refresh
 * Usage guidance:
 * Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $afbf9e3c851377a1$var$RefreshIcon = (props)=>/*#__PURE__*/ $afbf9e3c851377a1$var$_react.default.createElement($afbf9e3c851377a1$var$_iconNew.default, Object.assign({
        name: "RefreshIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 3.67V1H1v5c0 .414.336.75.75.75H6.5v-1.5H3.236a5.5 5.5 0 1 1-.666 3.63l-1.48.24A7.002 7.002 0 0 0 15 8 7 7 0 0 0 2.5 3.67" clip-rule="evenodd"/>`
    }, props));
$afbf9e3c851377a1$var$RefreshIcon.displayName = 'RefreshIcon';
var $afbf9e3c851377a1$var$_default = module.exports.default = $afbf9e3c851377a1$var$RefreshIcon;

});

parcelRegister("288ej", function(module, exports) {
$parcel$export(module.exports, "default", () => $18d2b661453c9380$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $25nEq = parcelRequire("25nEq");

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $dI9BQ = parcelRequire("dI9BQ");

var $iO8GM = parcelRequire("iO8GM");

var $eVb4V = parcelRequire("eVb4V");

var $5supy = parcelRequire("5supy");

var $aNF62 = parcelRequire("aNF62");

var $kctvn = parcelRequire("kctvn");

var $50U6m = parcelRequire("50U6m");

var $hCD1J = parcelRequire("hCD1J");

var $gbOaB = parcelRequire("gbOaB");

var $7OGdb = parcelRequire("7OGdb");

var $1XWyn = parcelRequire("1XWyn");

var $dIJOH = parcelRequire("dIJOH");

var $jHNrb = parcelRequire("jHNrb");

var $dXxxV = parcelRequire("dXxxV");

var $796iz = parcelRequire("796iz");

var $5U0GO = parcelRequire("5U0GO");
var $18d2b661453c9380$var$_excluded = [
    "appearance",
    "elemBefore",
    "isRemovable",
    "text",
    "color",
    "href",
    "removeButtonLabel",
    "testId",
    "onBeforeRemoveAction",
    "onAfterRemoveAction",
    "linkComponent",
    "migration_fallback",
    "maxWidth",
    "hasMargin",
    "swatchBefore",
    "swatchBeforeLabel",
    "swatchBeforeRole"
];
var $18d2b661453c9380$var$textLinkCssVar = '--ds-ctl';
var $18d2b661453c9380$var$textDefaultCssVar = '--ds-ct';
var $18d2b661453c9380$var$textActiveCssVar = '--ds-ctp';
var $18d2b661453c9380$var$backgroundHoverCssVar = '--ds-cbh';
var $18d2b661453c9380$var$backgroundActiveCssVar = '--ds-cba';
var $18d2b661453c9380$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($18d2b661453c9380$var$TagStatus || {});
var $18d2b661453c9380$var$packageName = "@atlaskit/tag";
var $18d2b661453c9380$var$packageVersion = "15.8.5";
var $18d2b661453c9380$var$defaultBeforeRemoveAction = function defaultBeforeRemoveAction() {
    return true;
};
/**
 * These hide the focus ring for the tag when its remove button is focused,
 * preventing a double focus ring.
 */ var $18d2b661453c9380$var$removingStyles = null;
var $18d2b661453c9380$var$RemovableTagComponent = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var appearance = _ref.appearance, _ref$elemBefore = _ref.elemBefore, elemBefore = _ref$elemBefore === void 0 ? null : _ref$elemBefore, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? '' : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, removeButtonLabel = _ref.removeButtonLabel, testId = _ref.testId, _ref$onBeforeRemoveAc = _ref.onBeforeRemoveAction, onBeforeRemoveAction = _ref$onBeforeRemoveAc === void 0 ? $18d2b661453c9380$var$defaultBeforeRemoveAction : _ref$onBeforeRemoveAc, _ref$onAfterRemoveAct = _ref.onAfterRemoveAction, onAfterRemoveAction = _ref$onAfterRemoveAct === void 0 ? (0, $eVb4V.default) : _ref$onAfterRemoveAct, linkComponent = _ref.linkComponent, migration_fallback = _ref.migration_fallback, maxWidth = _ref.maxWidth, _ref$hasMargin = _ref.hasMargin, hasMargin = _ref$hasMargin === void 0 ? true : _ref$hasMargin, swatchBefore = _ref.swatchBefore, swatchBeforeLabel = _ref.swatchBeforeLabel, swatchBeforeRole = _ref.swatchBeforeRole, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $18d2b661453c9380$var$_excluded);
    var _useState = (0, $5FkrB.useState)($18d2b661453c9380$var$TagStatus.Showing), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), isHoverCloseButton = _useState4[0], setIsHoverCloseButton = _useState4[1];
    var normalizedText = (0, $gbOaB.getTagText)(text);
    var onAfterRemoveActionWithAnalytics = (0, $dI9BQ.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $18d2b661453c9380$var$packageName,
            packageVersion: $18d2b661453c9380$var$packageVersion
        }
    }, 'atlaskit');
    var handleRemoveComplete = (0, $5FkrB.useCallback)(function() {
        setStatus($18d2b661453c9380$var$TagStatus.Removed);
    }, []);
    var handleRemoveRequest = (0, $5FkrB.useCallback)(function() {
        if (onBeforeRemoveAction && onBeforeRemoveAction()) {
            onAfterRemoveActionWithAnalytics(normalizedText);
            handleRemoveComplete();
        }
    }, [
        handleRemoveComplete,
        normalizedText,
        onBeforeRemoveAction,
        onAfterRemoveActionWithAnalytics
    ]);
    var onKeyPress = (0, $5FkrB.useCallback)(function(e) {
        var spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    var removingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus($18d2b661453c9380$var$TagStatus.Removing);
    }, []);
    var showingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus($18d2b661453c9380$var$TagStatus.Showing);
    }, []);
    var handleMouseOver = (0, $5FkrB.useCallback)(function() {
        return setIsHoverCloseButton(true);
    }, []);
    var handleMouseOut = (0, $5FkrB.useCallback)(function() {
        return setIsHoverCloseButton(false);
    }, []);
    var removeButton = isRemovable ? /*#__PURE__*/ $5FkrB.createElement((0, $5U0GO.default), {
        "aria-label": "".concat(removeButtonLabel || 'Remove', " ").concat(normalizedText),
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: "close-button-".concat(testId)
    }) : undefined;
    // Handle migration_fallback: render Lozenge when flag is off and migration_fallback is 'lozenge'
    if (migration_fallback === 'lozenge' && !(0, $50U6m.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        var lozengeAppearance = (0, $dXxxV.getLozengeAppearance)(color);
        return /*#__PURE__*/ $5FkrB.createElement((0, $5supy.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            appearance: lozengeAppearance,
            isBold: false,
            testId: testId
        }, rest), normalizedText);
    }
    // Use new TagNew component behind feature flag
    // TagNew handles its own animation internally via RemovableWrapper
    if ((0, $50U6m.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        var newColor = (0, $hCD1J.colorMapping)[color || 'standard'];
        return /*#__PURE__*/ $5FkrB.createElement((0, $1XWyn.default), {
            ref: ref,
            color: newColor,
            text: normalizedText,
            elemBefore: elemBefore,
            href: href,
            testId: testId,
            isRemovable: isRemovable,
            removeButtonLabel: removeButtonLabel,
            onBeforeRemoveAction: onBeforeRemoveAction,
            onAfterRemoveAction: onAfterRemoveActionWithAnalytics,
            maxWidth: maxWidth,
            hasMargin: hasMargin,
            swatchBefore: swatchBefore,
            swatchBeforeLabel: swatchBeforeLabel,
            swatchBeforeRole: swatchBeforeRole
        });
    }
    // Original implementation
    var content = /*#__PURE__*/ $5FkrB.createElement((0, $796iz.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: normalizedText,
        color: color,
        href: href,
        linkComponent: linkComponent,
        testId: testId
    });
    var hoverCloseButtonColors = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
    }, $18d2b661453c9380$var$backgroundHoverCssVar, undefined), $18d2b661453c9380$var$backgroundActiveCssVar, undefined), $18d2b661453c9380$var$textDefaultCssVar, undefined), $18d2b661453c9380$var$textActiveCssVar, undefined), $18d2b661453c9380$var$textLinkCssVar, undefined);
    return /*#__PURE__*/ $5FkrB.createElement((0, $aNF62.default), null, !(status === $18d2b661453c9380$var$TagStatus.Removed) && /*#__PURE__*/ $5FkrB.createElement((0, $kctvn.default), {
        key: "atlaskit-removable-tag-legacy-shrink-out",
        onFinish: handleRemoveComplete
    }, function(motion) {
        return /*#__PURE__*/ $5FkrB.createElement((0, $dIJOH.default), {
            ref: (0, $iO8GM.default)([
                motion.ref,
                ref
            ]),
            appearance: appearance,
            color: color,
            testId: testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
            "data-removable": true,
            "data-removing": status === $18d2b661453c9380$var$TagStatus.Removing,
            "data-ishoverclosebutton": isHoverCloseButton,
            href: href,
            before: /*#__PURE__*/ $5FkrB.createElement((0, $jHNrb.default), {
                elemBefore: elemBefore
            }),
            contentElement: content,
            after: removeButton,
            className: (0, $970q7.default)([
                status === $18d2b661453c9380$var$TagStatus.Removing && "_z30c1r31 _twwiglyw _1pka1o36 _bqhtfiwo"
            ])
        });
    }));
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ var $18d2b661453c9380$var$RemovableTag = (0, $7OGdb.markAsTagMotionCapable)(/*#__PURE__*/ (0, $5FkrB.memo)($18d2b661453c9380$var$RemovableTagComponent));
var $18d2b661453c9380$export$2e2bcd8739ae039 = $18d2b661453c9380$var$RemovableTag;

});
parcelRegister("dI9BQ", function(module, exports) {
$parcel$export(module.exports, "useCallbackWithAnalytics", () => $9fb6d6a188216314$export$53c2b9c37c40e0d8);

var $5FkrB = parcelRequire("5FkrB");

var $bDUuG = parcelRequire("bDUuG");

var $cqQpq = parcelRequire("cqQpq");
var $9fb6d6a188216314$export$53c2b9c37c40e0d8 = function useCallbackWithAnalytics(method, payload, channel) {
    var _useAnalyticsEvents = (0, $bDUuG.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var methodRef = (0, $cqQpq.useTrackedRef)(method);
    var payloadRef = (0, $cqQpq.useTrackedRef)(payload);
    return (0, $5FkrB.useCallback)(function() {
        var pload = typeof payloadRef.current === 'function' ? payloadRef.current.apply(payloadRef, arguments) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current.apply(methodRef, arguments);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};

});

parcelRegister("aNF62", function(module, exports) {
$parcel$export(module.exports, "ExitingContext", () => $7dce5bdaf433551a$export$b9c4904d7a6929e6);
$parcel$export(module.exports, "default", () => $7dce5bdaf433551a$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $50U6m = parcelRequire("50U6m");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $7dce5bdaf433551a$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isInsideExitingPersistence: false,
    isExiting: false
};
var $7dce5bdaf433551a$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $5FkrB.createContext)($7dce5bdaf433551a$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $7dce5bdaf433551a$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $7dce5bdaf433551a$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($7dce5bdaf433551a$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $7dce5bdaf433551a$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $7dce5bdaf433551a$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $7dce5bdaf433551a$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $7dce5bdaf433551a$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $7dce5bdaf433551a$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $7dce5bdaf433551a$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false,
            isInsideExitingPersistence: true
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false,
            isInsideExitingPersistence: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $7dce5bdaf433551a$var$childrenToArray(previousChildren);
    var current = $7dce5bdaf433551a$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var nextChildren = currentChildren !== children ? $7dce5bdaf433551a$var$childrenToArray(children) : current;
    var missingKeys = $7dce5bdaf433551a$var$getMissingKeys(nextChildren, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $7dce5bdaf433551a$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $50U6m.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $7dce5bdaf433551a$var$wrapChildWithContextProvider(child, {
            appear: true,
            isInsideExitingPersistence: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $7dce5bdaf433551a$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$7dce5bdaf433551a$export$2e2bcd8739ae039 = $7dce5bdaf433551a$var$ExitingPersistence;
$7dce5bdaf433551a$var$ExitingPersistence.displayName = 'ExitingPersistence';

});

parcelRegister("kctvn", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb4bd0b7398aac21$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $eqAKy = parcelRequire("eqAKy");

var $gACoS = parcelRequire("gACoS");

var $eVsTj = parcelRequire("eVsTj");

var $4uuz6 = parcelRequire("4uuz6");

var $c7Plr = parcelRequire("c7Plr");

var $9k1b5 = parcelRequire("9k1b5");

var $akCUj = parcelRequire("akCUj");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $eb4bd0b7398aac21$var$ShrinkOut = function ShrinkOut(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'small' : _ref$duration, onFinish = _ref.onFinish;
    var _useElementRef = (0, $eVsTj.useElementRef)(), _useElementRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useElementRef, 2), element = _useElementRef2[0], setElementRef = _useElementRef2[1];
    var exiting = (0, $akCUj.useExitingPersistence)();
    var requestAnimationFrame = (0, $c7Plr.useRequestAnimationFrame)();
    var setTimeout = (0, $9k1b5.useSetTimeout)();
    var direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $4uuz6.useLayoutEffect)(function() {
        if (exiting.isExiting && element) {
            if ((0, $gACoS.isReducedMotion)()) {
                exiting.onFinish && exiting.onFinish();
                onFinish && onFinish('exiting');
                return;
            }
            var newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: "".concat(element.offsetWidth, "px"),
                height: "".concat(element.offsetHeight, "px"),
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    var newStyles = {
                        width: '0px',
                        margin: '0px',
                        // We animate margin down to zero so it doesn't take any space.
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $eqAKy.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(function() {
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $eqAKy.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $eb4bd0b7398aac21$export$2e2bcd8739ae039 = $eb4bd0b7398aac21$var$ShrinkOut;

});
parcelRegister("eqAKy", function(module, exports) {
$parcel$export(module.exports, "durations", () => $a81000281e311a76$export$38b928a7167ce124);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $a81000281e311a76$export$368bacef0dacbe05 = 25;
var $a81000281e311a76$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};

});

parcelRegister("gACoS", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $c13dcba1845ee9f2$export$b7baf7667a68d87c);

var $gmPW4 = parcelRequire("gmPW4");
var $c13dcba1845ee9f2$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!(0, $gmPW4.isMatchMediaAvailable)()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};

});
parcelRegister("gmPW4", function(module, exports) {
$parcel$export(module.exports, "isMatchMediaAvailable", () => $bea6fcbdfeebb196$export$c5406bd59b374abd);
var $bea6fcbdfeebb196$export$c5406bd59b374abd = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};

});


parcelRegister("eVsTj", function(module, exports) {
$parcel$export(module.exports, "useElementRef", () => $addcccba53dac043$export$ff879f35a69d56b7);

var $5FkrB = parcelRequire("5FkrB");
var $addcccba53dac043$export$ff879f35a69d56b7 = function useElementRef() {
    var elementRef = (0, $5FkrB.useRef)(null);
    var setRef = (0, $5FkrB.useCallback)(function(ref) {
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});

parcelRegister("4uuz6", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $3451ac6466de4e7e$export$e5c5a5f917a5871c);

var $5FkrB = parcelRequire("5FkrB");
var $3451ac6466de4e7e$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);

});

parcelRegister("c7Plr", function(module, exports) {
$parcel$export(module.exports, "useRequestAnimationFrame", () => $8d3df77d4b5248cd$export$1775f27e7c8051ca);

var $5FkrB = parcelRequire("5FkrB");
var $8d3df77d4b5248cd$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $8d3df77d4b5248cd$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $8d3df77d4b5248cd$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};

});

parcelRegister("9k1b5", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", () => $6c96e52e57c436a4$export$4f34107a2b00f39c);

var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $6c96e52e57c436a4$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $6c96e52e57c436a4$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $6c96e52e57c436a4$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("akCUj", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $7859f3cad9bf15af$export$3b6f38abbdcbd000);

var $5FkrB = parcelRequire("5FkrB");

var $aNF62 = parcelRequire("aNF62");
var $7859f3cad9bf15af$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)((0, $aNF62.ExitingContext));
};

});


parcelRegister("hCD1J", function(module, exports) {
$parcel$export(module.exports, "colorMapping", () => $cd44423d3f068162$export$3351a8d90bcc13aa);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // Color mapping from old color names to new color names
var $cd44423d3f068162$export$3351a8d90bcc13aa = {
    standard: 'gray',
    grey: 'gray',
    blue: 'blue',
    green: 'green',
    red: 'red',
    yellow: 'yellow',
    purple: 'purple',
    lime: 'lime',
    magenta: 'magenta',
    orange: 'orange',
    teal: 'teal',
    // Light variants map to same as their non-light counterparts
    greyLight: 'gray',
    blueLight: 'blue',
    greenLight: 'green',
    redLight: 'red',
    yellowLight: 'yellow',
    purpleLight: 'purple',
    limeLight: 'lime',
    magentaLight: 'magenta',
    orangeLight: 'orange',
    tealLight: 'teal'
};

});

parcelRegister("gbOaB", function(module, exports) {
$parcel$export(module.exports, "getTagText", () => $bc9497266815a6b3$export$7d100de1166870f6);
// Intentionally scoped to the UI-uplifted TagNew implementation.
var $bc9497266815a6b3$export$7d100de1166870f6 = function getTagText(text) {
    return Array.isArray(text) ? text.join('') : text;
};

});

parcelRegister("7OGdb", function(module, exports) {
$parcel$export(module.exports, "markAsTagMotionCapable", () => $5b0df23fa40678c4$export$88b132e52a65ec37);
var $5b0df23fa40678c4$var$tagMotionCapability = Symbol.for('@atlaskit/tag/motion-capable');
function $5b0df23fa40678c4$export$88b132e52a65ec37(component) {
    Object.defineProperty(component, $5b0df23fa40678c4$var$tagMotionCapability, {
        value: true
    });
    return component;
}

});

parcelRegister("1XWyn", function(module, exports) {
$parcel$export(module.exports, "default", () => $16e8b8a7d33ff93c$export$2e2bcd8739ae039);
/* tag-new.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $fufde = parcelRequire("fufde");

var $50U6m = parcelRequire("50U6m");

var $btdNC = parcelRequire("btdNC");

var $9ztDu = parcelRequire("9ztDu");

var $hCD1J = parcelRequire("hCD1J");

var $gbOaB = parcelRequire("gbOaB");

var $63JYF = parcelRequire("63JYF");

var $chTLL = parcelRequire("chTLL");

var $ho5mL = parcelRequire("ho5mL");

var $67R0l = parcelRequire("67R0l");

var $7OGdb = parcelRequire("7OGdb");

var $jMf2X = parcelRequire("jMf2X");

var $5b4Pi = parcelRequire("5b4Pi");

var $3px04 = parcelRequire("3px04");

var $1jQEl = parcelRequire("1jQEl");
var $16e8b8a7d33ff93c$var$_excluded = [
    "color",
    "text",
    "elemBefore",
    "href",
    "linkComponent",
    "isRemovable",
    "removeButtonLabel",
    "onBeforeRemoveAction",
    "onAfterRemoveAction",
    "testId",
    "maxWidth",
    "hasMargin",
    "onClick",
    "swatchBefore",
    "swatchBeforeLabel",
    "swatchBeforeRole",
    "trailingMetric"
], $16e8b8a7d33ff93c$var$_excluded2 = [
    "color",
    "text",
    "elemBefore",
    "testId",
    "maxWidth",
    "hasMargin",
    "onClick",
    "isSelected",
    "isLoading",
    "analyticsContext",
    "hasChevron",
    "swatchBefore",
    "swatchBeforeLabel",
    "swatchBeforeRole",
    "trailingMetric"
];
var $16e8b8a7d33ff93c$var$styles = {
    baseStyles: "_zulp1b66 _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1rjcv77o _18zr1mie _1mou1b66 _195g1b66 _1e0c116y _vchhusvi _1ul9idpf _p12ff6dh _4t3i1k92 _kqswh2mm _4cvr1h6o _80om73ad _bfhksm61 _1rfu1q9c",
    noMarginStyles: "_1mouze3t _195gze3t",
    removableStyles: "_zulp1b66",
    beforeStyles: "_4bfu1snc _1hmsagmp _ajmmvv82 _1e0c116y _4cvr1h6o _1o9zidpf _syaz125o",
    beforeStylesSelected: "_syazxl6c",
    textStyles: "_1reo15vq _18m915vq _o5721q9c _16jlkb7n _1ul9idpf _syazi7uo",
    textEllipsis: "_1bto1l2s",
    textClip: "_1btozryt",
    textStylesSelected: "_syaz6x5g",
    afterStyles: "_1e0c1txw _4cvr1h6o _1o9zidpf _lcxv1wug _kqswh2mm",
    afterMotionStyles: "_1ul9utpp",
    trailingMetric: "_2rkolb4i _11c8wadc _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _4cvr1h6o _1o9zidpf _1kz6184x _bfhk1w9g _syazi7uo",
    trailingMetricEndPadding: "_y4ti303w",
    focusRingStyles: "_1ygbdfik _1ah3v77o",
    childFocusRingStyles: "_1a37dfik _1cwgv77o",
    interactiveBaseStyles: "_80omtlke _1all1b66 _qsdj1r31 _17ncglyw _15hpnqa1 _1rg815vq _1yoo15vq _j8j91snc _1afaagmp _gdbt10yn _h5vp116y _1qxz1h6o _8zx0idpf _1km4jdj5 _wc1fagmp _9408jdj5 _usew1snc _ebtnagmp _uvk910yn _10nj1r31 _1xq0glyw _18x1nqa1 _2mpsagmp",
    interactiveHoverStyles: "_17501r31 _qrsc8stv _1wodnqa1 _irr31dpa _rlyhjdj5 _1di6fcek",
    interactiveMotionStyles: "_v564k6bl _1ggl5xtf",
    activeMotionStyles: "_1reo15vq _18m915vq"
};
// For accent borders, we use the new color.border.accent.*.subtle tokens (Color300
// light / Color800 dark) which provide proper decorative-border colours
//
// Icons keep color.icon.accent.* in the default state (vibrant on the plain page
// background) and swap to color.text.accent.* in hovered/pressed states (where the
// Tag picks up a coloured background and needs guaranteed 3:1 icon contrast).
var $16e8b8a7d33ff93c$var$colorStyles = {
    gray: "_119bmsup _1ib21diz _egnk1sqi _17x31sqi _ih6z7qp0",
    blue: "_119b18hp _1ib26txe _egnk16jw _17x316jw _ih6z1dy8",
    green: "_119b5d2u _1ib217hp _egnkh55r _17x3h55r _ih6z1wnw",
    red: "_119bn9dc _1ib2nbxb _egnk9lu1 _17x39lu1 _ih6z1rtt",
    yellow: "_119b1s7j _1ib21oqg _egnkfb2s _17x3fb2s _ih6z1773",
    purple: "_119bluwt _1ib2uq3u _egnkqmo9 _17x3qmo9 _ih6z1nm4",
    lime: "_119b1m7d _1ib28645 _egnk1tco _17x31tco _ih6zz2ec",
    magenta: "_119b132u _1ib2v8hk _egnk1s8m _17x31s8m _ih6zv9ra",
    orange: "_119b1ip5 _1ib21j6y _egnkp1lv _17x3p1lv _ih6z165s",
    teal: "_119b131p _1ib28uof _egnk17qg _17x317qg _ih6z1a17"
};
// Border + icon filter styles - base state.
// Borders use the new color.border.accent.*.subtle tokens directly.
// Icons use the color.icon.accent.* tokens directly in the default state.
var $16e8b8a7d33ff93c$var$borderIconFilterStyles = {
    root: "_1h6dip4g _wi6h9ea2"
};
// Border + icon filter styles - interactive states (hover/pressed).
// Icons swap to the color.text.accent.* tokens for guaranteed 3:1 contrast
// against the coloured interactive backgrounds. Borders stay constant.
var $16e8b8a7d33ff93c$var$borderIconInteractiveFilterStyles = {
    root: "_4cvxip4g _zqoiipvw _q4ztip4g _ba35u0j8"
};
var $16e8b8a7d33ff93c$var$dropdownStyles = {
    interactive: "_irr31dpa _1di6fcek",
    selected: "_1h6dq98m _syaz6x5g _bfhk15s3 _irr3ufnl _1di6nozp",
    content: "_zulp1b66 _1reo15vq _18m915vq _1e0c116y _4cvr1h6o _16jlkb7n _1o9zkb7n _1ul9idpf",
    loadingMotion: "_k8m0brmi _1oec1ign _6fl4indk _sedtglyw",
    loadingOverlayMotion: "_j7hq1bym _5sag1ign _1pglindk _1bumglyw",
    loadingContent: "_tzy4idpf",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw"
};
/**
 * __TagNew__
 *
 * TagNew is the visual uplift implementation of Tag
 */ var $16e8b8a7d33ff93c$var$TagNewComponent = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TagNew(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'gray' : _ref$color, text = _ref.text, elemBefore = _ref.elemBefore, href = _ref.href, linkComponent = _ref.linkComponent, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, removeButtonLabel = _ref.removeButtonLabel, onBeforeRemoveAction = _ref.onBeforeRemoveAction, onAfterRemoveAction = _ref.onAfterRemoveAction, testId = _ref.testId, maxWidth = _ref.maxWidth, _ref$hasMargin = _ref.hasMargin, hasMargin = _ref$hasMargin === void 0 ? true : _ref$hasMargin, onClick = _ref.onClick, swatchBefore = _ref.swatchBefore, swatchBeforeLabel = _ref.swatchBeforeLabel, swatchBeforeRole = _ref.swatchBeforeRole, trailingMetric = _ref.trailingMetric, other = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $16e8b8a7d33ff93c$var$_excluded);
    var normalizedText = (0, $gbOaB.getTagText)(text);
    var isMotionEnabled = (0, $50U6m.fg)('platform-dst-motion-uplift-labels');
    var _useTagRemoval = (0, $1jQEl.useTagRemoval)(onBeforeRemoveAction), status = _useTagRemoval.status, handleRemoveRequest = _useTagRemoval.handleRemoveRequest, onKeyPress = _useTagRemoval.onKeyPress, removingTag = _useTagRemoval.removingTag, showingTag = _useTagRemoval.showingTag;
    var onShrinkOutExitComplete = (0, $5FkrB.useCallback)(function() {
        onAfterRemoveAction === null || onAfterRemoveAction === void 0 || onAfterRemoveAction(normalizedText);
    }, [
        normalizedText,
        onAfterRemoveAction
    ]);
    var _useLink = (0, $5b4Pi.useLink)(href, linkComponent), isLink = _useLink.isLink, LinkComponent = _useLink.LinkComponent;
    var _useButtonInteraction = (0, $jMf2X.useButtonInteraction)(), isLinkHovered = _useButtonInteraction.isLinkHovered, isOverButton = _useButtonInteraction.isOverButton, isButtonFocused = _useButtonInteraction.isButtonFocused, isLinkFocused = _useButtonInteraction.isLinkFocused, buttonHandlers = _useButtonInteraction.buttonHandlers, linkHandlers = _useButtonInteraction.linkHandlers;
    var removeButton = (0, $3px04.useRemoveButton)({
        isRemovable: isRemovable,
        tagText: normalizedText,
        removeButtonLabel: removeButtonLabel,
        testId: testId,
        handleRemoveRequest: handleRemoveRequest,
        removingTag: removingTag,
        showingTag: showingTag,
        onKeyPress: onKeyPress,
        buttonHandlers: buttonHandlers
    });
    var renderTagContent = function renderTagContent(tagRef) {
        var isEntering = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var isExiting = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var hasEllipsis = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, other, {
            ref: tagRef,
            "data-testid": testId,
            style: maxWidth !== undefined ? {
                maxWidth: maxWidth
            } : undefined,
            className: (0, $970q7.default)([
                $16e8b8a7d33ff93c$var$styles.baseStyles,
                (isMotionEnabled || !hasMargin) && $16e8b8a7d33ff93c$var$styles.noMarginStyles,
                $16e8b8a7d33ff93c$var$colorStyles[color],
                $16e8b8a7d33ff93c$var$borderIconFilterStyles.root,
                isLink && $16e8b8a7d33ff93c$var$styles.interactiveBaseStyles,
                isLink && $16e8b8a7d33ff93c$var$styles.focusRingStyles,
                isLink && isMotionEnabled && $16e8b8a7d33ff93c$var$styles.interactiveMotionStyles,
                (isEntering || isExiting) && $16e8b8a7d33ff93c$var$styles.activeMotionStyles,
                isLink && isLinkHovered && !isOverButton && $16e8b8a7d33ff93c$var$borderIconInteractiveFilterStyles.root,
                isLink && isLinkHovered && !isOverButton && $16e8b8a7d33ff93c$var$styles.interactiveHoverStyles,
                isRemovable && $16e8b8a7d33ff93c$var$styles.removableStyles,
                isLinkFocused && !isButtonFocused && $16e8b8a7d33ff93c$var$styles.childFocusRingStyles,
                !isRemovable && trailingMetric != null && trailingMetric !== '' && $16e8b8a7d33ff93c$var$styles.trailingMetricEndPadding
            ])
        }), /*#__PURE__*/ $5FkrB.createElement((0, $63JYF.LinkWrapper), {
            isLink: isLink,
            href: href,
            LinkComponent: LinkComponent,
            testId: testId,
            linkHandlers: linkHandlers,
            onClick: onClick
        }, /*#__PURE__*/ $5FkrB.createElement((0, $ho5mL.default), {
            colorKey: color,
            swatchBefore: swatchBefore,
            swatchBeforeLabel: swatchBeforeLabel,
            swatchBeforeRole: swatchBeforeRole
        }), elemBefore && /*#__PURE__*/ $5FkrB.createElement("span", {
            className: (0, $970q7.default)([
                $16e8b8a7d33ff93c$var$styles.beforeStyles
            ])
        }, elemBefore), /*#__PURE__*/ $5FkrB.createElement("span", {
            "data-tag-text": true,
            className: (0, $970q7.default)([
                $16e8b8a7d33ff93c$var$styles.textStyles,
                hasEllipsis === false ? $16e8b8a7d33ff93c$var$styles.textClip : $16e8b8a7d33ff93c$var$styles.textEllipsis
            ])
        }, normalizedText), trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ $5FkrB.createElement("span", {
            "data-testid": testId && "".concat(testId, "--metric"),
            className: (0, $970q7.default)([
                $16e8b8a7d33ff93c$var$styles.trailingMetric
            ])
        }, trailingMetric)), removeButton && /*#__PURE__*/ $5FkrB.createElement("span", {
            className: (0, $970q7.default)([
                $16e8b8a7d33ff93c$var$styles.afterStyles,
                isMotionEnabled && $16e8b8a7d33ff93c$var$styles.afterMotionStyles
            ])
        }, !isExiting && removeButton));
    };
    if (isMotionEnabled) return /*#__PURE__*/ $5FkrB.createElement((0, $67R0l.TagMotion), {
        forwardedRef: ref,
        hasMargin: hasMargin,
        onExitComplete: isRemovable ? onShrinkOutExitComplete : undefined,
        status: status
    }, function(_ref2) {
        var hasEllipsis = _ref2.hasEllipsis, isEntering = _ref2.isEntering, isExiting = _ref2.isExiting, motionRef = _ref2.ref;
        return renderTagContent(motionRef, isEntering, isExiting, hasEllipsis);
    });
    return /*#__PURE__*/ $5FkrB.createElement((0, $chTLL.RemovableWrapper), {
        isRemovable: isRemovable,
        status: status,
        onShrinkOutExitComplete: isRemovable ? onShrinkOutExitComplete : undefined
    }, renderTagContent(ref));
});
var $16e8b8a7d33ff93c$export$aba6bd1190e79361 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TagDropdownTrigger(_ref3, ref) {
    var _ref3$color = _ref3.color, color = _ref3$color === void 0 ? 'gray' : _ref3$color, text = _ref3.text, elemBefore = _ref3.elemBefore, testId = _ref3.testId, maxWidth = _ref3.maxWidth, _ref3$hasMargin = _ref3.hasMargin, hasMargin = _ref3$hasMargin === void 0 ? true : _ref3$hasMargin, onClick = _ref3.onClick, _ref3$isSelected = _ref3.isSelected, isSelected = _ref3$isSelected === void 0 ? false : _ref3$isSelected, _ref3$isLoading = _ref3.isLoading, isLoading = _ref3$isLoading === void 0 ? false : _ref3$isLoading, _analyticsContext = _ref3.analyticsContext, _ref3$hasChevron = _ref3.hasChevron, hasChevron = _ref3$hasChevron === void 0 ? true : _ref3$hasChevron, swatchBefore = _ref3.swatchBefore, swatchBeforeLabel = _ref3.swatchBeforeLabel, swatchBeforeRole = _ref3.swatchBeforeRole, trailingMetric = _ref3.trailingMetric, other = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref3, $16e8b8a7d33ff93c$var$_excluded2);
    var resolvedColor = (0, $hCD1J.colorMapping)[color] || 'gray';
    var isMotionEnabled = (0, $50U6m.fg)('platform-dst-motion-uplift-labels');
    return /*#__PURE__*/ $5FkrB.createElement((0, $btdNC.Pressable), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: ref,
        xcss: (0, $hUFig.cx)($16e8b8a7d33ff93c$var$styles.baseStyles, !hasMargin && $16e8b8a7d33ff93c$var$styles.noMarginStyles, $16e8b8a7d33ff93c$var$colorStyles[resolvedColor], $16e8b8a7d33ff93c$var$borderIconFilterStyles.root, $16e8b8a7d33ff93c$var$dropdownStyles.interactive, $16e8b8a7d33ff93c$var$styles.focusRingStyles, $16e8b8a7d33ff93c$var$borderIconInteractiveFilterStyles.root, isSelected && $16e8b8a7d33ff93c$var$dropdownStyles.selected, isMotionEnabled && $16e8b8a7d33ff93c$var$styles.interactiveMotionStyles, // Reduce end padding when trailing metric is the last element (no chevron)
        !hasChevron && trailingMetric != null && trailingMetric !== '' && $16e8b8a7d33ff93c$var$styles.trailingMetricEndPadding),
        onClick: isLoading ? undefined : onClick,
        style: {
            borderColor: isSelected ? "var(--ds-border-selected, #1868DB)" : undefined,
            cursor: isLoading ? 'progress' : 'pointer',
            maxWidth: maxWidth !== undefined ? maxWidth : undefined
        }
    }, isLoading && {
        'aria-busy': true,
        'aria-disabled': true,
        isDisabled: true
    }, {
        testId: testId
    }, other), /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            $16e8b8a7d33ff93c$var$dropdownStyles.content,
            isMotionEnabled && $16e8b8a7d33ff93c$var$dropdownStyles.loadingMotion,
            isLoading && $16e8b8a7d33ff93c$var$dropdownStyles.loadingContent
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $ho5mL.default), {
        colorKey: resolvedColor,
        swatchBefore: swatchBefore,
        swatchBeforeLabel: swatchBeforeLabel,
        swatchBeforeRole: swatchBeforeRole
    }), elemBefore && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            $16e8b8a7d33ff93c$var$styles.beforeStyles,
            isSelected && $16e8b8a7d33ff93c$var$styles.beforeStylesSelected
        ])
    }, elemBefore), /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-tag-text": true,
        className: (0, $970q7.default)([
            $16e8b8a7d33ff93c$var$styles.textStyles,
            $16e8b8a7d33ff93c$var$styles.textEllipsis,
            isSelected && $16e8b8a7d33ff93c$var$styles.textStylesSelected
        ])
    }, (0, $gbOaB.getTagText)(text)), trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId && "".concat(testId, "--metric"),
        className: (0, $970q7.default)([
            $16e8b8a7d33ff93c$var$styles.trailingMetric
        ])
    }, trailingMetric), hasChevron && /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fufde))), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && "".concat(testId, "--chevron")
    })), isLoading && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            $16e8b8a7d33ff93c$var$dropdownStyles.loadingOverlay,
            isMotionEnabled && $16e8b8a7d33ff93c$var$dropdownStyles.loadingOverlayMotion
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $9ztDu.default), {
        size: 'xsmall',
        label: ", Loading",
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    })));
});
/**
 * __Tag new__
 */ var $16e8b8a7d33ff93c$var$TagNew = (0, $7OGdb.markAsTagMotionCapable)(/*#__PURE__*/ (0, $5FkrB.memo)($16e8b8a7d33ff93c$var$TagNewComponent));
var $16e8b8a7d33ff93c$export$2e2bcd8739ae039 = $16e8b8a7d33ff93c$var$TagNew;

});
parcelRegister("fufde", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ceff5ba2cd41cd6899d33441cb75c99>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b465753bb15ee4c1$var$_react = $b465753bb15ee4c1$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $b465753bb15ee4c1$var$_iconNew = $b465753bb15ee4c1$var$_interopRequireDefault((parcelRequire("cgSLx")));
function $b465753bb15ee4c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-down
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b465753bb15ee4c1$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $b465753bb15ee4c1$var$_react.default.createElement($b465753bb15ee4c1$var$_iconNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$b465753bb15ee4c1$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $b465753bb15ee4c1$var$_default = module.exports.default = $b465753bb15ee4c1$var$ChevronDownIcon;

});
parcelRegister("cgSLx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Icon", () => $8ef175fbb66f6c06$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $8ef175fbb66f6c06$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $8ef175fbb66f6c06$var$svgStyles = null;
var $8ef175fbb66f6c06$var$iconStyles = null;
var $8ef175fbb66f6c06$var$smallIconStyles = null;
var $8ef175fbb66f6c06$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $8ef175fbb66f6c06$var$baseHcmStyles = null;
var $8ef175fbb66f6c06$var$scaleSize = null;
var $8ef175fbb66f6c06$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $8ef175fbb66f6c06$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $8ef175fbb66f6c06$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $8ef175fbb66f6c06$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $8ef175fbb66f6c06$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $970q7.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $970q7.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $8ef175fbb66f6c06$var$coreSizeSmall[spacing] : $8ef175fbb66f6c06$var$coreSizeMedium[spacing]
        ])
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$8ef175fbb66f6c06$export$2e2bcd8739ae039 = $8ef175fbb66f6c06$export$f04a61298a47a40f;

});


parcelRegister("63JYF", function(module, exports) {
$parcel$export(module.exports, "LinkWrapper", () => $4696b00bc92b22ee$export$ce4b6a469c26f53f);

var $5FkrB = parcelRequire("5FkrB");
function $4696b00bc92b22ee$export$ce4b6a469c26f53f(_ref) {
    var isLink = _ref.isLink, href = _ref.href, LinkComponent = _ref.LinkComponent, testId = _ref.testId, children = _ref.children, onClick = _ref.onClick, linkHandlers = _ref.linkHandlers;
    if (isLink && href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LinkComponent, {
        href: href,
        testId: testId ? "".concat(testId, "--link") : undefined,
        onClick: onClick,
        onMouseEnter: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseEnter,
        onMouseLeave: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseLeave,
        onMouseDown: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseDown,
        onFocus: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onFocus,
        onBlur: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onBlur
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, children);
}

});

parcelRegister("chTLL", function(module, exports) {
$parcel$export(module.exports, "RemovableWrapper", () => $024f015fe0f4b2f0$export$898a500849bb5cf4);
/* removable-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ /**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $aNF62 = parcelRequire("aNF62");

var $kctvn = parcelRequire("kctvn");

var $102Za = parcelRequire("102Za");
/**
 * Stable key so ExitingPersistence can match this child across the remove transition
 * (see ShrinkOut + ExitingPersistence docs in @atlaskit/motion).
 */ var $024f015fe0f4b2f0$var$removableShrinkOutChildKey = 'atlaskit-tag-removable-shrink-out';
var $024f015fe0f4b2f0$var$motionWrapperStyles = null;
function $024f015fe0f4b2f0$export$898a500849bb5cf4(_ref) {
    var isRemovable = _ref.isRemovable, status = _ref.status, onShrinkOutExitComplete = _ref.onShrinkOutExitComplete, children = _ref.children;
    if (isRemovable) return /*#__PURE__*/ $5FkrB.createElement((0, $aNF62.default), null, !(status === (0, $102Za.TagStatus).Removed) && /*#__PURE__*/ $5FkrB.createElement((0, $kctvn.default), {
        key: $024f015fe0f4b2f0$var$removableShrinkOutChildKey,
        onFinish: onShrinkOutExitComplete ? function(phase) {
            if (phase === 'exiting') onShrinkOutExitComplete();
        } : undefined
    }, function(motion) {
        return /*#__PURE__*/ $5FkrB.createElement("span", {
            ref: motion.ref,
            className: (0, $970q7.default)([
                "_1e0c116y"
            ])
        }, children);
    }));
    return children;
}

});
parcelRegister("102Za", function(module, exports) {
$parcel$export(module.exports, "TagStatus", () => $0ba81b60cc2a960c$export$74452314b63acabc);
// Tag status enum
var $0ba81b60cc2a960c$export$74452314b63acabc = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}({});

});


parcelRegister("ho5mL", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca88d72440d2ac25$export$2e2bcd8739ae039);
/* swatch-before.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $ca88d72440d2ac25$var$tagSwatchBeforeStyles = {
    swatch: "_2rkolb4i _1bsboqnp _4t3ioqnp _1o9zidpf"
};
var $ca88d72440d2ac25$var$tagSwatchBeforeColorStyles = {
    gray: "_bfhk18j9",
    blue: "_bfhk115i",
    green: "_bfhk1rsu",
    red: "_bfhkkrt9",
    yellow: "_bfhk8y3s",
    purple: "_bfhk18ah",
    lime: "_bfhkbq5w",
    magenta: "_bfhk1mi6",
    orange: "_bfhk1kkj",
    teal: "_bfhktdv8"
};
function $ca88d72440d2ac25$export$2e2bcd8739ae039(_ref) {
    var colorKey = _ref.colorKey, swatchBefore = _ref.swatchBefore, swatchBeforeLabel = _ref.swatchBeforeLabel, swatchBeforeRole = _ref.swatchBeforeRole;
    if (swatchBefore === undefined || swatchBefore === false) return null;
    if (swatchBefore === true) return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, swatchBeforeLabel && swatchBeforeRole ? {
        'aria-label': swatchBeforeLabel,
        role: swatchBeforeRole
    } : {}, {
        className: (0, $970q7.default)([
            $ca88d72440d2ac25$var$tagSwatchBeforeStyles.swatch,
            $ca88d72440d2ac25$var$tagSwatchBeforeColorStyles[colorKey]
        ])
    }));
    return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, swatchBeforeLabel && swatchBeforeRole ? {
        'aria-label': swatchBeforeLabel,
        role: swatchBeforeRole
    } : {}, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            backgroundColor: swatchBefore
        },
        className: (0, $970q7.default)([
            $ca88d72440d2ac25$var$tagSwatchBeforeStyles.swatch
        ])
    }));
}

});

parcelRegister("67R0l", function(module, exports) {
$parcel$export(module.exports, "TagMotion", () => $475c8322803e2fc8$export$6adae1772ccf137c);
/* tag-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $iO8GM = parcelRequire("iO8GM");

var $iZsLR = parcelRequire("iZsLR");

var $aNF62 = parcelRequire("aNF62");

var $akCUj = parcelRequire("akCUj");

var $102Za = parcelRequire("102Za");
var $475c8322803e2fc8$var$tagMotionKey = 'atlaskit-tag-motion';
var $475c8322803e2fc8$var$motionWrapperStyles = {
    root: "_1reo15vq _18m915vq _1e0c1n7u _yv0ei47z",
    entering: "_y44vkz8f",
    exiting: "_y44v1rag",
    reducedMotion: "_1bumglyw"
};
var $475c8322803e2fc8$var$motionContentStyles = {
    root: "_1rjc1b66 _18zr1b66 _1e0c1txw _1ul9idpf"
};
function $475c8322803e2fc8$var$TagMotionContent(_ref) {
    var children = _ref.children, forwardedRef = _ref.forwardedRef, hasMargin = _ref.hasMargin, onExitComplete = _ref.onExitComplete;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), motionPhase = _useState2[0], setMotionPhase = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), hasEllipsis = _useState4[0], setHasEllipsis = _useState4[1];
    var motionElementRef = (0, $5FkrB.useRef)(null);
    var _useMotion = (0, $iZsLR.useMotion)({
        onStart: function onStart(phase) {
            if (motionElementRef.current) {
                var motionElement = motionElementRef.current;
                var inlineAnimation = motionElement.style.animation;
                motionElement.style.animation = 'none';
                var textElement = motionElement.querySelector('[data-tag-text]');
                setHasEllipsis(Boolean(textElement && textElement.scrollWidth > textElement.clientWidth));
                motionElement.style.animation = inlineAnimation;
            }
            setMotionPhase(phase);
        },
        onFinish: function onFinish(phase) {
            if (phase === 'exiting') onExitComplete === null || onExitComplete === void 0 || onExitComplete();
        }
    }), motionRef = _useMotion.ref, state = _useMotion.state;
    var mergedMotionRef = (0, $5FkrB.useMemo)(function() {
        return (0, $iO8GM.default)([
            motionElementRef,
            motionRef
        ]);
    }, [
        motionRef
    ]);
    var onAnimationEnd = (0, $5FkrB.useCallback)(function(event) {
        if (event.target === event.currentTarget) setMotionPhase(null);
    }, []);
    var activeMotionPhase = state === 'entering' || state === 'exiting' ? state : motionPhase;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        ref: mergedMotionRef,
        onAnimationEnd: onAnimationEnd,
        className: (0, $970q7.default)([
            $475c8322803e2fc8$var$motionWrapperStyles.root,
            activeMotionPhase === 'entering' && $475c8322803e2fc8$var$motionWrapperStyles.entering,
            activeMotionPhase === 'exiting' && $475c8322803e2fc8$var$motionWrapperStyles.exiting,
            $475c8322803e2fc8$var$motionWrapperStyles.reducedMotion
        ])
    }, hasMargin ? /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            $475c8322803e2fc8$var$motionContentStyles.root
        ])
    }, children({
        hasEllipsis: hasEllipsis,
        isEntering: activeMotionPhase === 'entering',
        isExiting: activeMotionPhase === 'exiting',
        ref: forwardedRef
    })) : children({
        hasEllipsis: hasEllipsis,
        isEntering: activeMotionPhase === 'entering',
        isExiting: activeMotionPhase === 'exiting',
        ref: forwardedRef
    }));
}
function $475c8322803e2fc8$export$6adae1772ccf137c(_ref2) {
    var children = _ref2.children, forwardedRef = _ref2.forwardedRef, hasMargin = _ref2.hasMargin, onExitComplete = _ref2.onExitComplete, status = _ref2.status;
    var outerPresence = (0, $akCUj.useExitingPersistence)();
    var isRemoved = status === (0, $102Za.TagStatus).Removed || outerPresence.isExiting;
    var shouldAppear = outerPresence.isInsideExitingPersistence && outerPresence.appear && !outerPresence.isExiting;
    var latestExitState = (0, $5FkrB.useRef)({
        onExitComplete: onExitComplete,
        outerPresence: outerPresence,
        status: status
    });
    latestExitState.current = {
        onExitComplete: onExitComplete,
        outerPresence: outerPresence,
        status: status
    };
    var onMotionExitComplete = (0, $5FkrB.useCallback)(function() {
        var latest = latestExitState.current;
        if (latest.outerPresence.isExiting) {
            var _latest$outerPresence, _latest$outerPresence2;
            (_latest$outerPresence = (_latest$outerPresence2 = latest.outerPresence).onFinish) === null || _latest$outerPresence === void 0 || _latest$outerPresence.call(_latest$outerPresence2);
        }
        if (latest.status === (0, $102Za.TagStatus).Removed) {
            var _latest$onExitComplet;
            (_latest$onExitComplet = latest.onExitComplete) === null || _latest$onExitComplet === void 0 || _latest$onExitComplet.call(latest);
        }
    }, []);
    return /*#__PURE__*/ $5FkrB.createElement((0, $aNF62.default), {
        appear: shouldAppear
    }, !isRemoved && /*#__PURE__*/ $5FkrB.createElement($475c8322803e2fc8$var$TagMotionContent, {
        key: $475c8322803e2fc8$var$tagMotionKey,
        forwardedRef: forwardedRef,
        hasMargin: hasMargin,
        onExitComplete: onMotionExitComplete
    }, children));
}

});
parcelRegister("iZsLR", function(module, exports) {
$parcel$export(module.exports, "useMotion", () => $dd343dd5c3c6ec8a$export$2a51cfe9390d36ef);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $iO8GM = parcelRequire("iO8GM");

var $fo2Dj = parcelRequire("fo2Dj");

var $duiXw = parcelRequire("duiXw");

var $gACoS = parcelRequire("gACoS");

var $fqirs = parcelRequire("fqirs");

var $4uuz6 = parcelRequire("4uuz6");

var $6HvI9 = parcelRequire("6HvI9");

var $akCUj = parcelRequire("akCUj");

var $lGxXS = parcelRequire("lGxXS");
function $dd343dd5c3c6ec8a$export$2a51cfe9390d36ef() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, onFinishMotion = _ref.onFinish, onStartMotion = _ref.onStart, initialState = _ref.initialState;
    var reducedMotion = (0, $gACoS.isReducedMotion)();
    var staggered = (0, $lGxXS.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $akCUj.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var staggeredDelay = isExiting ? 0 : staggered.delay;
    var staggeredIsReady = staggered.isReady;
    var _useState = (0, $5FkrB.useState)(initialState !== null && initialState !== void 0 ? initialState : appear ? staggeredIsReady && !staggeredDelay ? 'entering' : 'init' : 'visible'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    // ExitingPersistence must win during render so consumers apply exit styles before layout effects.
    // The lifecycle effect below uses the same value to measure and finish that exit.
    var motionState = isExiting ? 'exiting' : state;
    var elementRef = (0, $5FkrB.useRef)(null);
    var onStartMotionRef = (0, $5FkrB.useRef)(onStartMotion);
    onStartMotionRef.current = onStartMotion;
    var reanimateRef = (0, $5FkrB.useRef)();
    var animationRef = (0, $5FkrB.useRef)();
    var staggeredEntryRef = (0, $5FkrB.useRef)();
    (0, $4uuz6.useLayoutEffect)(function() {
        if (motionState === 'exiting') {
            var _onStartMotionRef$cur;
            (_onStartMotionRef$cur = onStartMotionRef.current) === null || _onStartMotionRef$cur === void 0 || _onStartMotionRef$cur.call(onStartMotionRef, 'exiting');
        }
        if (motionState === 'entering') {
            var _onStartMotionRef$cur2;
            (_onStartMotionRef$cur2 = onStartMotionRef.current) === null || _onStartMotionRef$cur2 === void 0 || _onStartMotionRef$cur2.call(onStartMotionRef, 'entering');
        }
    }, [
        motionState
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ var onAnimationEnd = (0, $5FkrB.useCallback)(function(currentState, cancelled) {
        // We are done animating, so we set the state to visible
        var newState = 'visible';
        if (currentState === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('exiting');
        }
        if (currentState === 'entering') onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('entering');
        if (reanimateRef.current === (0, $6HvI9.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $6HvI9.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current === (0, $6HvI9.Reanimate).enter) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        else if (reanimateRef.current === (0, $6HvI9.Reanimate).exit) {
            // We are done reanimating, so we clear the reanimate state
            reanimateRef.current = undefined;
            newState = 'hidden';
        }
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    // Handles staggered entry
    (0, $5FkrB.useEffect)(function() {
        if (state !== 'init') return;
        if (reducedMotion) {
            onAnimationEnd('entering', false);
            return;
        }
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(function() {
            setState('entering');
        }, staggeredDelay);
        return function() {
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        onAnimationEnd,
        state,
        staggeredIsReady,
        staggeredDelay,
        reducedMotion
    ]);
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (!staggeredIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is visible, hidden or init, we don't need to do anything
        if (motionState === 'visible' || motionState === 'init' || motionState === 'hidden') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if (reducedMotion) {
            onAnimationEnd(motionState, isCancelled);
            return;
        }
        var animationDuration = 0;
        if (motionState === 'entering' || motionState === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    var animationTimings = (0, $duiXw.getDurationMs)((0, $fqirs.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    var computedStyles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $fo2Dj.getComputedAnimationDurationMs)(computedStyles.animationName, computedStyles.animationDuration, computedStyles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (motionState === 'exiting') animationRef.current = setTimeout(function() {
            return onAnimationEnd(motionState, isCancelled);
        }, animationDuration);
        else if (motionState === 'entering') animationRef.current = setTimeout(function() {
            return onAnimationEnd(motionState, isCancelled);
        }, animationDuration);
        return function() {
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        motionState,
        appear,
        staggeredDelay,
        staggeredIsReady,
        reducedMotion
    ]);
    var reanimate = (0, $5FkrB.useCallback)(function(value) {
        animationRef.current && clearTimeout(animationRef.current);
        reanimateRef.current = value;
        if (value === (0, $6HvI9.Reanimate).exit_then_enter) setState('exiting');
        else if (value === (0, $6HvI9.Reanimate).enter) setState('entering');
        else if (value === (0, $6HvI9.Reanimate).exit) setState('exiting');
    }, []);
    var ref = (0, $5FkrB.useMemo)(function() {
        return (0, $iO8GM.default)([
            staggered.ref,
            elementRef
        ]);
    }, [
        staggered.ref
    ]);
    return {
        ref: ref,
        reanimate: reanimate,
        state: motionState
    };
}

});
parcelRegister("fo2Dj", function(module, exports) {
$parcel$export(module.exports, "getComputedAnimationDurationMs", () => $b33b23c7974e5feb$export$dd9b73a7482d05b6);

var $9Ovnn = parcelRequire("9Ovnn");
var $b33b23c7974e5feb$var$cssTimePattern = /^-?(?:\d+\.?\d*|\.\d+)(?:ms|s)$/;
var $b33b23c7974e5feb$var$toCssList = function toCssList(value) {
    return value.split(',').map(function(item) {
        return item.trim();
    }).filter(Boolean);
};
var $b33b23c7974e5feb$var$toTimeList = function toTimeList(value) {
    return $b33b23c7974e5feb$var$toCssList(value).filter(function(time) {
        return $b33b23c7974e5feb$var$cssTimePattern.test(time);
    }).map((0, $9Ovnn.convertToMs));
};
var $b33b23c7974e5feb$export$dd9b73a7482d05b6 = function getComputedAnimationDurationMs(animationName, animationDuration, animationDelay) {
    var names = $b33b23c7974e5feb$var$toCssList(animationName);
    var durations = $b33b23c7974e5feb$var$toTimeList(animationDuration);
    var delays = $b33b23c7974e5feb$var$toTimeList(animationDelay);
    if (names.length === 0 || durations.length === 0) return 0;
    var longestDuration = 0;
    for(var index = 0; index < names.length; index++){
        if (names[index] === 'none') continue;
        var duration = durations[index % durations.length];
        var delay = delays.length > 0 ? delays[index % delays.length] : 0;
        longestDuration = Math.max(longestDuration, duration + delay);
    }
    return longestDuration;
};

});
parcelRegister("9Ovnn", function(module, exports) {
$parcel$export(module.exports, "convertToMs", () => $72511f37856b2e4d$export$75eee42ff540d8ae);
var $72511f37856b2e4d$export$75eee42ff540d8ae = function convertToMs(duration) {
    // Use regex to separate the number and the unit
    var matches = duration.match(/^(-?(?:\d+\.?\d*|\.\d+))(s|ms)$/);
    if (!matches) return 0; // Or return for invalid format
    var value = parseFloat(matches[1]);
    var unit = matches[2];
    if (unit === 's') return value * 1000; // Convert seconds to milliseconds
    else return value; // Already in milliseconds
};

});


parcelRegister("duiXw", function(module, exports) {
$parcel$export(module.exports, "getDurationMs", () => $9d1cc891aed71571$export$d0038b6e47881463);

var $fC8ib = parcelRequire("fC8ib");
var $9d1cc891aed71571$export$d0038b6e47881463 = function getDurationMs(animation) {
    var animations = animation.split(/,(?![^()]*\))/).map(function(value) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(value.trim().matchAll(/(-?\d*\.?\d+)(ms|s)\b/g));
    }).filter(function(matches) {
        return matches.length > 0;
    });
    if (animations.length === 0) return {
        duration: 0,
        delay: 0
    };
    return animations.reduce(function(longest, matches) {
        var toMilliseconds = function toMilliseconds(match) {
            var value = parseFloat(match[1]);
            return match[2] === 's' ? value * 1000 : value;
        };
        var timing = {
            duration: toMilliseconds(matches[0]),
            delay: matches[1] ? toMilliseconds(matches[1]) : 0
        };
        return timing.duration + timing.delay > longest.duration + longest.delay ? timing : longest;
    }, {
        duration: 0,
        delay: 0
    });
};

});

parcelRegister("fqirs", function(module, exports) {
$parcel$export(module.exports, "resolveMotionToken", () => $b3a796e781d06578$export$82b92541889a035d);

var $lFhdZ = parcelRequire("lFhdZ");
var $b3a796e781d06578$export$82b92541889a035d = function resolveMotionToken(token) {
    var cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    var cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        var _getDocument;
        var documentElement = (_getDocument = (0, $lFhdZ.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};

});

parcelRegister("6HvI9", function(module, exports) {
$parcel$export(module.exports, "Reanimate", () => $4e0f5b60b27753be$export$569340a66b14e0dc);
/**
 * Supported reanimate values.
 * 'enter' will re-enter the animation.
 * 'exit-then-enter' will exit the animation and then enter it again.
 */ var $4e0f5b60b27753be$export$569340a66b14e0dc = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    Reanimate["exit"] = "exit";
    return Reanimate;
}({});

});

parcelRegister("lGxXS", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $fc97ddeced05433d$export$25c7213fc07ec080);

var $5FkrB = parcelRequire("5FkrB");

var $SIQkH = parcelRequire("SIQkH");

var $eTCcX = parcelRequire("eTCcX");
var $fc97ddeced05433d$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var identifier = (0, $SIQkH.useUniqueId)();
    var context = (0, $5FkrB.useContext)((0, $eTCcX.StaggeredEntranceContext));
    return context(identifier);
};

});
parcelRegister("SIQkH", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $0a47d42961a6a5a3$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $0a47d42961a6a5a3$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});

parcelRegister("eTCcX", function(module, exports) {
$parcel$export(module.exports, "StaggeredEntranceContext", () => $ad83d708a15a323e$export$5e65d7d58ae96ad8);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");

var $4uuz6 = parcelRequire("4uuz6");
var $ad83d708a15a323e$export$5e65d7d58ae96ad8 = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $eVb4V.default)
    };
});
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $ad83d708a15a323e$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $4uuz6.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($ad83d708a15a323e$export$5e65d7d58ae96ad8.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$ad83d708a15a323e$export$2e2bcd8739ae039 = $ad83d708a15a323e$var$StaggeredEntrance;

});




parcelRegister("jMf2X", function(module, exports) {
$parcel$export(module.exports, "useButtonInteraction", () => $e65e2bfc11ab7f46$export$84acd183858d8235);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $e65e2bfc11ab7f46$export$84acd183858d8235() {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isLinkHovered = _useState2[0], setIsLinkHovered = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), isOverButton = _useState4[0], setIsOverButton = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), isButtonFocused = _useState6[0], setIsButtonFocused = _useState6[1];
    var _useState7 = (0, $5FkrB.useState)(false), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState7, 2), isLinkFocused = _useState8[0], setIsLinkFocused = _useState8[1];
    // Track if last interaction was via mouse (to determine keyboard vs mouse focus)
    var hadMouseDownRef = (0, $5FkrB.useRef)(false);
    // Button handlers
    var buttonHandlers = (0, $5FkrB.useMemo)(function() {
        return {
            onMouseEnter: function onMouseEnter() {
                return setIsOverButton(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setIsOverButton(false);
            },
            onMouseDown: function onMouseDown(e) {
                // Prevent the browser from moving focus to the remove button on mousedown.
                // Without this, parent composite widgets (e.g. Select) lose input focus when
                // the user clicks remove, triggering unwanted blur side-effects.
                e === null || e === void 0 || e.preventDefault();
                hadMouseDownRef.current = true;
            },
            onFocus: function onFocus() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsButtonFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function onBlur() {
                return setIsButtonFocused(false);
            }
        };
    }, []);
    // Link handlers - includes hover tracking
    var linkHandlers = (0, $5FkrB.useMemo)(function() {
        return {
            onMouseEnter: function onMouseEnter() {
                return setIsLinkHovered(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setIsLinkHovered(false);
            },
            onMouseDown: function onMouseDown() {
                hadMouseDownRef.current = true;
            },
            onFocus: function onFocus() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsLinkFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function onBlur() {
                return setIsLinkFocused(false);
            }
        };
    }, []);
    return {
        isLinkHovered: isLinkHovered,
        isOverButton: isOverButton,
        isButtonFocused: isButtonFocused,
        isLinkFocused: isLinkFocused,
        buttonHandlers: buttonHandlers,
        linkHandlers: linkHandlers
    };
}

});

parcelRegister("5b4Pi", function(module, exports) {
$parcel$export(module.exports, "useLink", () => $3c51b9421d06fe02$export$dcf14c9974fe2767);

var $8F9hT = parcelRequire("8F9hT");
function $3c51b9421d06fe02$export$dcf14c9974fe2767(href, linkComponent) {
    var isLink = Boolean(href);
    var LinkComponent = linkComponent !== null && linkComponent !== void 0 ? linkComponent : (0, $8F9hT.default);
    return {
        isLink: isLink,
        LinkComponent: LinkComponent
    };
}

});

parcelRegister("3px04", function(module, exports) {
$parcel$export(module.exports, "useRemoveButton", () => $27bd4e0da7349491$export$97d8be09cd53869b);
/**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $5U0GO = parcelRequire("5U0GO");
function $27bd4e0da7349491$export$97d8be09cd53869b(_ref) {
    var isRemovable = _ref.isRemovable, tagText = _ref.tagText, removeButtonLabel = _ref.removeButtonLabel, testId = _ref.testId, handleRemoveRequest = _ref.handleRemoveRequest, removingTag = _ref.removingTag, showingTag = _ref.showingTag, onKeyPress = _ref.onKeyPress, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? 'default' : _ref$shape, buttonHandlers = _ref.buttonHandlers;
    var handleFocus = (0, $5FkrB.useCallback)(function() {
        removingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onFocus();
    }, [
        removingTag,
        buttonHandlers
    ]);
    var handleBlur = (0, $5FkrB.useCallback)(function() {
        showingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onBlur();
    }, [
        showingTag,
        buttonHandlers
    ]);
    return (0, $5FkrB.useMemo)(function() {
        if (!isRemovable) return undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5U0GO.default), {
            "aria-label": "".concat(removeButtonLabel || 'Remove', " ").concat(tagText),
            onClick: handleRemoveRequest,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyPress: onKeyPress,
            onMouseEnter: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseEnter,
            onMouseLeave: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseLeave,
            onMouseDown: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseDown,
            testId: testId ? "close-button-".concat(testId) : undefined,
            shape: shape
        });
    }, [
        isRemovable,
        removeButtonLabel,
        tagText,
        handleRemoveRequest,
        handleFocus,
        handleBlur,
        onKeyPress,
        buttonHandlers,
        testId,
        shape
    ]);
}

});
parcelRegister("5U0GO", function(module, exports) {
$parcel$export(module.exports, "default", () => $44c2b79ffdcb7cdd$export$2e2bcd8739ae039);
/* remove-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");


var $hRJ5R = parcelRequire("hRJ5R");

var $1Va8N = parcelRequire("1Va8N");

var $50U6m = parcelRequire("50U6m");

var $btdNC = parcelRequire("btdNC");
var $44c2b79ffdcb7cdd$var$removeButtonStyles = {
    root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i1j6v _1bsb1j6v _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah3idpf _irr31dpa _1di6fcek",
    circle: "_2rko1rr0 _1ah3idpf",
    focusRing: "_1ah3v77o",
    newIcon: "_rjxpv77o"
};
var $44c2b79ffdcb7cdd$var$RemoveButton = function RemoveButton(_ref) {
    var ariaLabel = _ref['aria-label'], onClick = _ref.onClick, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onKeyPress = _ref.onKeyPress, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onMouseDown = _ref.onMouseDown, onMouseUp = _ref.onMouseUp, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, testId = _ref.testId, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? 'default' : _ref$shape;
    return /*#__PURE__*/ $5FkrB.createElement((0, $btdNC.Pressable), {
        xcss: (0, $hRJ5R.cx)($44c2b79ffdcb7cdd$var$removeButtonStyles.root, shape === 'circle' && $44c2b79ffdcb7cdd$var$removeButtonStyles.circle, $44c2b79ffdcb7cdd$var$removeButtonStyles.newIcon, (0, $50U6m.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && $44c2b79ffdcb7cdd$var$removeButtonStyles.focusRing),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: testId
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Va8N))), {
        color: "currentColor",
        label: "",
        size: "small"
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$44c2b79ffdcb7cdd$export$2e2bcd8739ae039 = $44c2b79ffdcb7cdd$var$RemoveButton;

});
parcelRegister("1Va8N", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe87206c037b1ad46cb54a88ca95fa3b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1662fb12050f0961$var$_react = $1662fb12050f0961$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $1662fb12050f0961$var$_iconNew = $1662fb12050f0961$var$_interopRequireDefault((parcelRequire("cgSLx")));
function $1662fb12050f0961$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cross
 * Usage guidance:
 * Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1662fb12050f0961$var$CrossIcon = (props)=>/*#__PURE__*/ $1662fb12050f0961$var$_react.default.createElement($1662fb12050f0961$var$_iconNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.53 3.53 9.06 8l4.47 4.47-1.06 1.06L8 9.06l-4.47 4.47-1.06-1.06L6.94 8 2.47 3.53l1.06-1.06L8 6.94l4.47-4.47z"/>`
    }, props));
$1662fb12050f0961$var$CrossIcon.displayName = 'CrossIcon';
var $1662fb12050f0961$var$_default = module.exports.default = $1662fb12050f0961$var$CrossIcon;

});



parcelRegister("1jQEl", function(module, exports) {
$parcel$export(module.exports, "useTagRemoval", () => $0f6067edd7f57835$export$f26019543e9f862f);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $lntDW = parcelRequire("lntDW");

var $102Za = parcelRequire("102Za");
function $0f6067edd7f57835$export$f26019543e9f862f(onBeforeRemoveAction) {
    var _useState = (0, $5FkrB.useState)((0, $102Za.TagStatus).Showing), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var handleRemoveRequest = (0, $5FkrB.useCallback)(function() {
        var beforeAction = onBeforeRemoveAction !== null && onBeforeRemoveAction !== void 0 ? onBeforeRemoveAction : (0, $lntDW.defaultBeforeRemoveAction);
        if (beforeAction()) // Defer onAfterRemoveAction until ShrinkOut's onFinish so ExitingPersistence can run
        // the exit animation (e.g. in multi-select and user pickers).
        setStatus((0, $102Za.TagStatus).Removed);
    }, [
        onBeforeRemoveAction
    ]);
    var onKeyPress = (0, $5FkrB.useCallback)(function(e) {
        var spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    var removingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus((0, $102Za.TagStatus).Removing);
    }, []);
    var showingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus((0, $102Za.TagStatus).Showing);
    }, []);
    return {
        status: status,
        handleRemoveRequest: handleRemoveRequest,
        onKeyPress: onKeyPress,
        removingTag: removingTag,
        showingTag: showingTag
    };
}

});
parcelRegister("lntDW", function(module, exports) {
$parcel$export(module.exports, "defaultBeforeRemoveAction", () => $f902bd7a1f04fdec$export$279e7025ed114474);
var $f902bd7a1f04fdec$export$279e7025ed114474 = function defaultBeforeRemoveAction() {
    return true;
};

});



parcelRegister("dIJOH", function(module, exports) {
$parcel$export(module.exports, "default", () => $9fd2ecaefbff0e86$export$2e2bcd8739ae039);
/* base.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $9fd2ecaefbff0e86$var$_excluded = [
    "before",
    "contentElement",
    "after",
    "testId",
    "style",
    "color",
    "href",
    "className"
];
function $9fd2ecaefbff0e86$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9fd2ecaefbff0e86$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9fd2ecaefbff0e86$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9fd2ecaefbff0e86$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Border colors - Hardcoded for Visual Refresh - to be removed with labelling system work
var $9fd2ecaefbff0e86$var$borderColors = {
    standard: "_1h6d14je",
    blue: "_1h6duisw",
    red: "_1h6da2c0",
    yellow: "_1h6deh2r",
    green: "_1h6d18uw",
    teal: "_1h6d1ug6",
    purple: "_1h6d157s",
    lime: "_1h6dn0nx",
    magenta: "_1h6d1lf6",
    orange: "_1h6dh727",
    grey: "_1h6d14je",
    standardLink: "_1h6d14je",
    blueLight: "_1h6duisw",
    redLight: "_1h6da2c0",
    yellowLight: "_1h6deh2r",
    greenLight: "_1h6d18uw",
    tealLight: "_1h6d1ug6",
    purpleLight: "_1h6d157s",
    limeLight: "_1h6dn0nx",
    magentaLight: "_1h6d1lf6",
    orangeLight: "_1h6dh727",
    greyLight: "_1h6d14je"
};
var $9fd2ecaefbff0e86$var$baseStyles = null;
var $9fd2ecaefbff0e86$var$interactiveStyles = null;
var $9fd2ecaefbff0e86$var$focusRingStyles = null;
var $9fd2ecaefbff0e86$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function BaseTag(_ref, ref) {
    var before = _ref.before, contentElement = _ref.contentElement, after = _ref.after, testId = _ref.testId, style = _ref.style, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, className = _ref.className, other = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $9fd2ecaefbff0e86$var$_excluded);
    var isLink = Boolean(href);
    var isRemovable = Boolean(after);
    var isInteractive = isLink || isRemovable;
    if (color === 'gray') // internally we use 'grey' for gray color so that we can make migration easier behind the ff (gray will work with and without ff now)
    color = 'grey';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, other, {
        ref: ref,
        style: $9fd2ecaefbff0e86$var$_objectSpread({}, style),
        className: (0, $970q7.default)([
            "_zulp1b66 _2rko12b0 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3i1k92 _kqswh2mm _4cvr1h6o _bfhksm61 _syazi7uo _80om73ad",
            isInteractive && "_1e38dfik _7glxv77o",
            isLink && "_irr31dpa _1di6fcek",
            $9fd2ecaefbff0e86$var$borderColors[color],
            className
        ]),
        "data-testid": testId
    }), before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9fd2ecaefbff0e86$export$2e2bcd8739ae039 = $9fd2ecaefbff0e86$var$BaseTag;

});

parcelRegister("jHNrb", function(module, exports) {
$parcel$export(module.exports, "default", () => $e58861bcba118e44$export$2e2bcd8739ae039);
/* before.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $e58861bcba118e44$var$beforeElementStyles = null;
var $e58861bcba118e44$var$Before = function Before(_ref) {
    var elemBefore = _ref.elemBefore;
    return elemBefore ? /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            "_1e0c1txw _4t3i1j6v _4cvr1h6o _1bah1h6o _152tze3t"
        ])
    }, elemBefore) : null;
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e58861bcba118e44$export$2e2bcd8739ae039 = $e58861bcba118e44$var$Before;

});

parcelRegister("dXxxV", function(module, exports) {
$parcel$export(module.exports, "getLozengeAppearance", () => $a29acea54d1807e2$export$4d9e331cafeacb9d);
/**
 * Maps Tag color values to Lozenge appearance values.
 * Used for migration_fallback rendering when feature flag is off.
 */ var $a29acea54d1807e2$var$colorToLozengeAppearanceMap = {
    gray: 'default',
    grey: 'default',
    lime: 'success',
    green: 'success',
    blue: 'inprogress',
    red: 'removed',
    purple: 'new',
    yellow: 'moved',
    orange: 'moved',
    magenta: 'new',
    teal: 'inprogress',
    grayLight: 'default',
    greyLight: 'default',
    limeLight: 'success',
    greenLight: 'success',
    blueLight: 'inprogress',
    redLight: 'removed',
    purpleLight: 'new',
    yellowLight: 'moved',
    orangeLight: 'moved',
    magentaLight: 'new',
    tealLight: 'inprogress'
};
function $a29acea54d1807e2$export$4d9e331cafeacb9d(color) {
    return $a29acea54d1807e2$var$colorToLozengeAppearanceMap[color || 'gray'] || 'default';
}

});

parcelRegister("796iz", function(module, exports) {
$parcel$export(module.exports, "default", () => $533e426ee598fc71$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $gbOaB = parcelRequire("gbOaB");
var $533e426ee598fc71$var$baseStyles = null;
var $533e426ee598fc71$var$linkStyles = null;
var $533e426ee598fc71$var$hasAfterStyles = null;
var $533e426ee598fc71$var$Content = function Content(_ref) {
    var _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? '' : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, linkComponent = _ref.linkComponent, testId = _ref.testId;
    var Link = linkComponent !== null && linkComponent !== void 0 ? linkComponent : 'a';
    var normalizedText = (0, $gbOaB.getTagText)(text);
    if (href) return /*#__PURE__*/ $5FkrB.createElement(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? "".concat(testId, "--link") : undefined,
        className: (0, $970q7.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazi7uo _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3i7uo _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
            isRemovable && "_p12f1lit"
        ])
    }, normalizedText);
    else return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            isRemovable && "_p12f1lit"
        ])
    }, normalizedText);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$533e426ee598fc71$export$2e2bcd8739ae039 = $533e426ee598fc71$var$Content;

});


parcelRegister("bNmp1", function(module, exports) {
$parcel$export(module.exports, "default", () => $8965a5fc1a5cfd30$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9bc04a7f63dc23ac693ac49f41cc7cc3>>
 * @codegenCommand yarn build tokens
 */ var $8965a5fc1a5cfd30$var$tokens = {
    'motion.avatar.enter': '--ds-avatar-enter',
    'motion.avatar.exit': '--ds-avatar-exit',
    'motion.avatar.hovered': '--ds-avatar-hovered',
    'motion.blanket.enter': '--ds-blanket-enter',
    'motion.blanket.exit': '--ds-blanket-exit',
    'motion.button.hovered': '--ds-button-hovered',
    'motion.button.pressed': '--ds-button-pressed',
    'motion.duration.instant': '--ds-duration-instant',
    'motion.duration.long': '--ds-duration-long',
    'motion.duration.medium': '--ds-duration-medium',
    'motion.duration.short': '--ds-duration-short',
    'motion.duration.xlong': '--ds-duration-xlong',
    'motion.duration.xshort': '--ds-duration-xshort',
    'motion.duration.xxlong': '--ds-duration-xxlong',
    'motion.duration.xxshort': '--ds-duration-xxshort',
    'motion.easing.in.practical': '--ds-easing-in-practical',
    'motion.easing.inout.bold': '--ds-easing-inout-bold',
    'motion.easing.out.practical': '--ds-easing-out-practical',
    'motion.easing.out.bold': '--ds-easing-out-bold',
    'motion.easing.spring': '--ds-easing-spring',
    'motion.flag.enter': '--ds-flag-enter',
    'motion.flag.exit': '--ds-flag-exit',
    'motion.flag.reposition': '--ds-flag-reposition',
    'motion.input.focused': '--ds-input-focused',
    'motion.input.hovered': '--ds-input-hovered',
    'motion.keyframe.fade.in': '--ds-keyframe-fade-in',
    'motion.keyframe.fade.out': '--ds-keyframe-fade-out',
    'motion.keyframe.grid.column.in': '--ds-keyframe-grid-column-in',
    'motion.keyframe.grid.column.out': '--ds-keyframe-grid-column-out',
    'motion.keyframe.scale.in.medium': '--ds-keyframe-scale-in-medium',
    'motion.keyframe.scale.in.small': '--ds-keyframe-scale-in-small',
    'motion.keyframe.scale.out.medium': '--ds-keyframe-scale-out-medium',
    'motion.keyframe.scale.out.small': '--ds-keyframe-scale-out-small',
    'motion.keyframe.slide.in.bottom.short': '--ds-keyframe-slide-in-bottom-short',
    'motion.keyframe.slide.in.left.half': '--ds-keyframe-slide-in-left-half',
    'motion.keyframe.slide.in.left.short': '--ds-keyframe-slide-in-left-short',
    'motion.keyframe.slide.in.right.short': '--ds-keyframe-slide-in-right-short',
    'motion.keyframe.slide.in.top.short': '--ds-keyframe-slide-in-top-short',
    'motion.keyframe.slide.out.bottom.short': '--ds-keyframe-slide-out-bottom-short',
    'motion.keyframe.slide.out.left.half': '--ds-keyframe-slide-out-left-half',
    'motion.keyframe.slide.out.left.short': '--ds-keyframe-slide-out-left-short',
    'motion.keyframe.slide.out.right.short': '--ds-keyframe-slide-out-right-short',
    'motion.keyframe.slide.out.top.short': '--ds-keyframe-slide-out-top-short',
    'motion.label.enter': '--ds-label-enter',
    'motion.label.exit': '--ds-label-exit',
    'motion.listitem.hovered': '--ds-listitem-hovered',
    'motion.listitem.pressed': '--ds-listitem-pressed',
    'motion.listitem.selected': '--ds-listitem-selected',
    'motion.modal.enter': '--ds-modal-enter',
    'motion.modal.exit': '--ds-modal-exit',
    'motion.panel.content.enter': '--ds-panel-content-enter',
    'motion.panel.content.exit': '--ds-panel-content-exit',
    'motion.panel.enter': '--ds-panel-enter',
    'motion.panel.enter.left': '--ds-panel-enter-left',
    'motion.panel.enter.right': '--ds-panel-enter-right',
    'motion.panel.exit': '--ds-panel-exit',
    'motion.panel.exit.left': '--ds-panel-exit-left',
    'motion.panel.exit.right': '--ds-panel-exit-right',
    'motion.popup.enter.bottom': '--ds-popup-enter-bottom',
    'motion.popup.enter.left': '--ds-popup-enter-left',
    'motion.popup.enter.right': '--ds-popup-enter-right',
    'motion.popup.enter.top': '--ds-popup-enter-top',
    'motion.popup.exit.bottom': '--ds-popup-exit-bottom',
    'motion.popup.exit.left': '--ds-popup-exit-left',
    'motion.popup.exit.right': '--ds-popup-exit-right',
    'motion.popup.exit.top': '--ds-popup-exit-top',
    'motion.sidenav.enter.left': '--ds-sidenav-enter-left',
    'motion.sidenav.enter.right': '--ds-sidenav-enter-right',
    'motion.sidenav.exit.left': '--ds-sidenav-exit-left',
    'motion.sidenav.exit.right': '--ds-sidenav-exit-right',
    'motion.spotlight.enter': '--ds-spotlight-enter',
    'motion.spotlight.exit': '--ds-spotlight-exit',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.code.added.highlight': '--ds-background-code-added-highlight',
    'color.background.code.added.line': '--ds-background-code-added-line',
    'color.background.code.default': '--ds-background-code-default',
    'color.background.code.gutter': '--ds-background-code-gutter',
    'color.background.code.highlight': '--ds-background-code-highlight',
    'color.background.code.removed.highlight': '--ds-background-code-removed-highlight',
    'color.background.code.removed.line': '--ds-background-code-removed-line',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.subtle': '--ds-background-danger-subtle',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.subtle': '--ds-background-warning-subtle',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.subtle': '--ds-background-success-subtle',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.subtle': '--ds-background-discovery-subtle',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.subtle': '--ds-background-information-subtle',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.lime.subtle': '--ds-border-accent-lime-subtle',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.red.subtle': '--ds-border-accent-red-subtle',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.orange.subtle': '--ds-border-accent-orange-subtle',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.yellow.subtle': '--ds-border-accent-yellow-subtle',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.green.subtle': '--ds-border-accent-green-subtle',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.teal.subtle': '--ds-border-accent-teal-subtle',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.blue.subtle': '--ds-border-accent-blue-subtle',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.purple.subtle': '--ds-border-accent-purple-subtle',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.magenta.subtle': '--ds-border-accent-magenta-subtle',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.accent.gray.subtle': '--ds-border-accent-gray-subtle',
    'color.border.code': '--ds-border-code',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.input.search': '--ds-border-input-search',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.danger.subtle': '--ds-border-danger-subtle',
    'color.border.warning': '--ds-border-warning',
    'color.border.warning.subtle': '--ds-border-warning-subtle',
    'color.border.success': '--ds-border-success',
    'color.border.success.subtle': '--ds-border-success-subtle',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.discovery.subtle': '--ds-border-discovery-subtle',
    'color.border.information': '--ds-border-information',
    'color.border.information.subtle': '--ds-border-information-subtle',
    'color.border.bold': '--ds-border-bold',
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.code.accent.1': '--ds-text-code-accent-1',
    'color.text.code.accent.2': '--ds-text-code-accent-2',
    'color.text.code.comments': '--ds-text-code-comments',
    'color.text.code.default': '--ds-text-code-default',
    'color.text.code.functions': '--ds-text-code-functions',
    'color.text.code.gutter': '--ds-text-code-gutter',
    'color.text.code.keywords': '--ds-text-code-keywords',
    'color.text.code.numbers': '--ds-text-code-numbers',
    'color.text.code.operators': '--ds-text-code-operators',
    'color.text.code.strings': '--ds-text-code-strings',
    'color.text.code.tags': '--ds-text-code-tags',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'color.rovo.background.brand.bold': '--ds-rovo-background-brand-bold',
    'color.rovo.background.brand.bold.hovered': '--ds-rovo-background-brand-bold-hovered',
    'color.rovo.background.brand.bold.pressed': '--ds-rovo-background-brand-bold-pressed',
    'color.rovo.border.lime': '--ds-rovo-border-lime',
    'color.rovo.border.saffron': '--ds-rovo-border-saffron',
    'color.rovo.border.blue': '--ds-rovo-border-blue',
    'color.rovo.border.purple': '--ds-rovo-border-purple',
    'color.rovo.icon.lime': '--ds-rovo-icon-lime',
    'color.rovo.icon.saffron': '--ds-rovo-icon-saffron',
    'color.rovo.icon.blue': '--ds-rovo-icon-blue',
    'color.rovo.icon.purple': '--ds-rovo-icon-purple',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.container': '--ds-surface-container',
    'elevation.surface.container.hovered': '--ds-surface-container-hovered',
    'elevation.surface.container.pressed': '--ds-surface-container-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.rovo.surface.overlay': '--ds-rovo-surface-overlay',
    'elevation.rovo.surface.overlay.hovered': '--ds-rovo-surface-overlay-hovered',
    'elevation.rovo.surface.overlay.pressed': '--ds-rovo-surface-overlay-pressed',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $8965a5fc1a5cfd30$export$2e2bcd8739ae039 = $8965a5fc1a5cfd30$var$tokens;

});

parcelRegister("kgDEK", function(module, exports) {
$parcel$export(module.exports, "array", () => array);
$parcel$export(module.exports, "string", () => string);
$parcel$export(module.exports, "number", () => number);
$parcel$export(module.exports, "enum", () => _enum);
$parcel$export(module.exports, "object", () => object);

var $itOVw = parcelRequire("itOVw");
var $igTWG = parcelRequire("igTWG");
var $4S00O = parcelRequire("4S00O");
var $b9Fsy = parcelRequire("b9Fsy");
var $ciVeX = parcelRequire("ciVeX");
var $5ehZO = parcelRequire("5ehZO");
var $6xatX = parcelRequire("6xatX");
var $8S8Wz = parcelRequire("8S8Wz");

var $lhsqI = parcelRequire("lhsqI");

var $8S8Wz = parcelRequire("8S8Wz");

var $1XUsZ = parcelRequire("1XUsZ");

var $3OUUC = parcelRequire("3OUUC");

var $itOVw = parcelRequire("itOVw");

var $kUTFh = parcelRequire("kUTFh");
var $8K3FB = parcelRequire("8K3FB");
// Register English as the default locale on first ZodType construction. Hooked into the `ZodType` `$constructor` (rather than a top-level `config(en())` in `external.ts`) so bundlers honoring `sideEffects: false` can't tree-shake it out — see #5953, #5725. An explicit `z.config(z.locales.xx())` call wins regardless of order, since this only sets the default when none is present.
function _ensureDefaultLocale() {
    if (!$igTWG.globalConfig.localeError) $igTWG.config((0, $3OUUC.default)());
}
// the default memoizer is read by the core container init, which runs before `ZodType.init`, so each container calls this first
function _ensureDefaultMemoizer() {
    if (!$igTWG.globalConfig.memoizer) $igTWG.config({
        memoizer: $6xatX.memoizer()
    });
}
const ZodType = /*@__PURE__*/ $igTWG.$constructor("ZodType", (inst, def)=>{
    _ensureDefaultLocale();
    $4S00O.$ZodType.init(inst, def);
    inst.def = def;
    inst.type = def.type;
    return inst;
}, {
    check (...chks) {
        const def = this.def;
        return this.clone((0, $ciVeX).mergeDefs(def, {
            checks: [
                ...def.checks ?? [],
                ...chks.map((ch)=>typeof ch === "function" ? {
                        _zod: {
                            check: ch,
                            def: {
                                check: "custom"
                            },
                            onattach: []
                        }
                    } : ch)
            ]
        }), {
            parent: true
        });
    },
    with (...chks) {
        return this.check(...chks);
    },
    clone (def, params) {
        return $ciVeX.clone(this, def, params);
    },
    brand () {
        return this;
    },
    register (reg, meta) {
        reg.add(this, meta);
        return this;
    },
    refine (check, params) {
        return this.check(refine(check, params));
    },
    superRefine (refinement, params) {
        return this.check(superRefine(refinement, params));
    },
    overwrite (fn) {
        return this.check($itOVw._overwrite(fn));
    },
    optional () {
        return optional(this);
    },
    exactOptional () {
        return exactOptional(this);
    },
    nullable () {
        return nullable(this);
    },
    nullish () {
        return optional(nullable(this));
    },
    nonoptional (params) {
        return nonoptional(this, params);
    },
    array () {
        return array(this);
    },
    or (arg) {
        return union([
            this,
            arg
        ]);
    },
    and (arg) {
        return intersection(this, arg);
    },
    transform (tx) {
        return pipe(this, transform(tx));
    },
    default (d) {
        return _default(this, d);
    },
    prefault (d) {
        return prefault(this, d);
    },
    catch (params) {
        return _catch(this, params);
    },
    pipe (target) {
        return pipe(this, target);
    },
    readonly () {
        return readonly(this);
    },
    describe (description) {
        const cl = this.clone();
        $5ehZO.globalRegistry.add(cl, {
            description: description
        });
        return cl;
    },
    meta (...args) {
        // overloaded: meta() returns the registered metadata, meta(data) returns a clone with `data` registered. The mapped type picks up the second overload, so we accept variadic any-args and return `any` to satisfy both at runtime.
        if (args.length === 0) return $5ehZO.globalRegistry.get(this);
        const cl = this.clone();
        $5ehZO.globalRegistry.add(cl, args[0]);
        return cl;
    },
    isOptional () {
        return this.safeParse(undefined).success;
    },
    isNullable () {
        return this.safeParse(null).success;
    },
    apply (fn, ...args) {
        return args.length === 0 ? fn(this) : fn(this, ...args);
    },
    // Overrides core's `~standard` to add `jsonSchema`. Must stay a prototype entry: redefining it per instance demotes instances to dictionary mode.
    get "~standard" () {
        return (0, $ciVeX).hide(this, "~standard", {
            ...$4S00O.standardProps(this),
            jsonSchema: {
                input: (0, $1XUsZ.createStandardJSONSchemaMethod)(this, "input"),
                output: (0, $1XUsZ.createStandardJSONSchemaMethod)(this, "output")
            }
        });
    },
    set "~standard" (value){
        (0, $ciVeX).own(this, "~standard", value);
    },
    parse: function _parse(data, params) {
        return $kUTFh.parse(this, data, params, {
            callee: _parse
        });
    },
    parseAsync: async function _parseAsync(data, params) {
        return await $kUTFh.parseAsync(this, data, params, {
            callee: _parseAsync
        });
    },
    safeParse (data, params) {
        return $kUTFh.safeParse(this, data, params);
    },
    async safeParseAsync (data, params) {
        return $kUTFh.safeParseAsync(this, data, params);
    },
    // `spa` is an alias: same function object as `safeParseAsync`, as before.
    get spa () {
        return this?.safeParseAsync;
    },
    set spa (value){
        (0, $ciVeX).own(this, "spa", value);
    },
    validate (data, params) {
        return $8K3FB.validate(this, data, params);
    },
    validateAsync (data, params) {
        return $8K3FB.validateAsync(this, data, params);
    },
    encode: function _encode(data, params) {
        return $kUTFh.encode(this, data, params, {
            callee: _encode
        });
    },
    decode: function _decode(data, params) {
        return $kUTFh.decode(this, data, params, {
            callee: _decode
        });
    },
    encodeAsync: async function _encodeAsync(data, params) {
        return await $kUTFh.encodeAsync(this, data, params, {
            callee: _encodeAsync
        });
    },
    decodeAsync: async function _decodeAsync(data, params) {
        return await $kUTFh.decodeAsync(this, data, params, {
            callee: _decodeAsync
        });
    },
    safeEncode (data, params) {
        return $kUTFh.safeEncode(this, data, params);
    },
    safeDecode (data, params) {
        return $kUTFh.safeDecode(this, data, params);
    },
    async safeEncodeAsync (data, params) {
        return $kUTFh.safeEncodeAsync(this, data, params);
    },
    async safeDecodeAsync (data, params) {
        return $kUTFh.safeDecodeAsync(this, data, params);
    },
    toJSONSchema (params) {
        return (0, $1XUsZ.createToJSONSchemaMethod)(this, {})(params);
    },
    // Reads through to the registry on every access, so it must not cache.
    get description () {
        return $5ehZO.globalRegistry.get(this)?.description;
    },
    // No setter: `schema._def = x` throws, as it did when `_def` was a non-writable own property.
    get _def () {
        return this._zod.def;
    }
});
const _ZodString = /*@__PURE__*/ $igTWG.$constructor("_ZodString", (inst, def)=>{
    $4S00O.$ZodString.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.stringProcessor(inst, ctx, json, params);
}, /*@__PURE__*/ (0, $ciVeX).derived({
    format: (inst)=>$lhsqI.aggregateChecks(inst).format ?? null,
    minLength: (inst)=>$lhsqI.aggregateChecks(inst).minimum ?? null,
    maxLength: (inst)=>$lhsqI.aggregateChecks(inst).maximum ?? null
}, {
    regex (...args) {
        return this.check($itOVw._regex(...args));
    },
    includes (...args) {
        return this.check($itOVw._includes(...args));
    },
    startsWith (...args) {
        return this.check($itOVw._startsWith(...args));
    },
    endsWith (...args) {
        return this.check($itOVw._endsWith(...args));
    },
    min (...args) {
        return this.check($itOVw._minLength(...args));
    },
    max (...args) {
        return this.check($itOVw._maxLength(...args));
    },
    length (...args) {
        return this.check($itOVw._length(...args));
    },
    nonempty (...args) {
        return this.check($itOVw._minLength(1, ...args));
    },
    lowercase (params) {
        return this.check($itOVw._lowercase(params));
    },
    uppercase (params) {
        return this.check($itOVw._uppercase(params));
    },
    trim () {
        return this.check($itOVw._trim());
    },
    normalize (...args) {
        return this.check($itOVw._normalize(...args));
    },
    toLowerCase () {
        return this.check($itOVw._toLowerCase());
    },
    toUpperCase () {
        return this.check($itOVw._toUpperCase());
    },
    slugify () {
        return this.check($itOVw._slugify());
    }
}));
const ZodString = /*@__PURE__*/ $igTWG.$constructor("ZodString", (inst, def)=>{
    $4S00O.$ZodString.init(inst, def);
    _ZodString.init(inst, def);
}, {
    email (params) {
        return this.check($itOVw._email(ZodEmail, params));
    },
    url (params) {
        return this.check($itOVw._url(ZodURL, params));
    },
    jwt (params) {
        return this.check($itOVw._jwt(ZodJWT, params));
    },
    emoji (params) {
        return this.check($itOVw._emoji(ZodEmoji, params));
    },
    guid (params) {
        return this.check($itOVw._guid(ZodGUID, params));
    },
    uuid (params) {
        return this.check($itOVw._uuid(ZodUUID, params));
    },
    uuidv4 (params) {
        return this.check($itOVw._uuidv4(ZodUUID, params));
    },
    uuidv6 (params) {
        return this.check($itOVw._uuidv6(ZodUUID, params));
    },
    uuidv7 (params) {
        return this.check($itOVw._uuidv7(ZodUUID, params));
    },
    nanoid (params) {
        return this.check($itOVw._nanoid(ZodNanoID, params));
    },
    cuid (params) {
        return this.check($itOVw._cuid(ZodCUID, params));
    },
    cuid2 (params) {
        return this.check($itOVw._cuid2(ZodCUID2, params));
    },
    ulid (params) {
        return this.check($itOVw._ulid(ZodULID, params));
    },
    base64 (params) {
        return this.check($itOVw._base64(ZodBase64, params));
    },
    base64url (params) {
        return this.check($itOVw._base64url(ZodBase64URL, params));
    },
    xid (params) {
        return this.check($itOVw._xid(ZodXID, params));
    },
    ksuid (params) {
        return this.check($itOVw._ksuid(ZodKSUID, params));
    },
    ipv4 (params) {
        return this.check($itOVw._ipv4(ZodIPv4, params));
    },
    ipv6 (params) {
        return this.check($itOVw._ipv6(ZodIPv6, params));
    },
    cidrv4 (params) {
        return this.check($itOVw._cidrv4(ZodCIDRv4, params));
    },
    cidrv6 (params) {
        return this.check($itOVw._cidrv6(ZodCIDRv6, params));
    },
    e164 (params) {
        return this.check($itOVw._e164(ZodE164, params));
    },
    datetime (params) {
        return this.check($itOVw._isoDateTime(ZodISODateTime, params));
    },
    date (params) {
        return this.check($itOVw._isoDate(ZodISODate, params));
    },
    time (params) {
        return this.check($itOVw._isoTime(ZodISOTime, params));
    },
    duration (params) {
        return this.check($itOVw._isoDuration(ZodISODuration, params));
    }
});
function string(params) {
    return $itOVw._string(ZodString, params);
}
const ZodStringFormat = /*@__PURE__*/ $igTWG.$constructor("ZodStringFormat", (inst, def)=>{
    $4S00O.$ZodStringFormat.init(inst, def);
    _ZodString.init(inst, def);
});
const ZodISODateTime = /*@__PURE__*/ $igTWG.$constructor("ZodISODateTime", (inst, def)=>{
    $4S00O.$ZodISODateTime.init(inst, def);
    ZodStringFormat.init(inst, def);
});
const ZodISODate = /*@__PURE__*/ $igTWG.$constructor("ZodISODate", (inst, def)=>{
    $4S00O.$ZodISODate.init(inst, def);
    ZodStringFormat.init(inst, def);
});
const ZodISOTime = /*@__PURE__*/ $igTWG.$constructor("ZodISOTime", (inst, def)=>{
    $4S00O.$ZodISOTime.init(inst, def);
    ZodStringFormat.init(inst, def);
});
const ZodISODuration = /*@__PURE__*/ $igTWG.$constructor("ZodISODuration", (inst, def)=>{
    $4S00O.$ZodISODuration.init(inst, def);
    ZodStringFormat.init(inst, def);
});
const ZodEmail = /*@__PURE__*/ $igTWG.$constructor("ZodEmail", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $4S00O.$ZodEmail.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function email(params) {
    return $itOVw._email(ZodEmail, params);
}
const ZodGUID = /*@__PURE__*/ $igTWG.$constructor("ZodGUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $4S00O.$ZodGUID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function guid(params) {
    return $itOVw._guid(ZodGUID, params);
}
const ZodUUID = /*@__PURE__*/ $igTWG.$constructor("ZodUUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $4S00O.$ZodUUID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function uuid(params) {
    return $itOVw._uuid(ZodUUID, params);
}
function uuidv4(params) {
    return $itOVw._uuidv4(ZodUUID, params);
}
function uuidv6(params) {
    return $itOVw._uuidv6(ZodUUID, params);
}
function uuidv7(params) {
    return $itOVw._uuidv7(ZodUUID, params);
}
const ZodURL = /*@__PURE__*/ $igTWG.$constructor("ZodURL", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $4S00O.$ZodURL.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function url(params) {
    return $itOVw._url(ZodURL, params);
}
function httpUrl(params) {
    return $itOVw._url(ZodURL, {
        protocol: $8S8Wz.httpProtocol,
        hostname: $8S8Wz.domain,
        ...(0, $ciVeX).normalizeParams(params)
    });
}
const ZodEmoji = /*@__PURE__*/ $igTWG.$constructor("ZodEmoji", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $4S00O.$ZodEmoji.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function emoji(params) {
    return $itOVw._emoji(ZodEmoji, params);
}
const ZodNanoID = /*@__PURE__*/ $igTWG.$constructor("ZodNanoID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $4S00O.$ZodNanoID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function nanoid(params) {
    return $itOVw._nanoid(ZodNanoID, params);
}
const ZodCUID = /*@__PURE__*/ $igTWG.$constructor("ZodCUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $4S00O.$ZodCUID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function cuid(params) {
    return $itOVw._cuid(ZodCUID, params);
}
const ZodCUID2 = /*@__PURE__*/ $igTWG.$constructor("ZodCUID2", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $4S00O.$ZodCUID2.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function cuid2(params) {
    return $itOVw._cuid2(ZodCUID2, params);
}
const ZodULID = /*@__PURE__*/ $igTWG.$constructor("ZodULID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $4S00O.$ZodULID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function ulid(params) {
    return $itOVw._ulid(ZodULID, params);
}
const ZodXID = /*@__PURE__*/ $igTWG.$constructor("ZodXID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $4S00O.$ZodXID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function xid(params) {
    return $itOVw._xid(ZodXID, params);
}
const ZodKSUID = /*@__PURE__*/ $igTWG.$constructor("ZodKSUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $4S00O.$ZodKSUID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function ksuid(params) {
    return $itOVw._ksuid(ZodKSUID, params);
}
const ZodIPv4 = /*@__PURE__*/ $igTWG.$constructor("ZodIPv4", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $4S00O.$ZodIPv4.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function ipv4(params) {
    return $itOVw._ipv4(ZodIPv4, params);
}
const ZodMAC = /*@__PURE__*/ $igTWG.$constructor("ZodMAC", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $4S00O.$ZodMAC.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function mac(params) {
    return $itOVw._mac(ZodMAC, params);
}
const ZodIPv6 = /*@__PURE__*/ $igTWG.$constructor("ZodIPv6", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $4S00O.$ZodIPv6.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function ipv6(params) {
    return $itOVw._ipv6(ZodIPv6, params);
}
const ZodCIDRv4 = /*@__PURE__*/ $igTWG.$constructor("ZodCIDRv4", (inst, def)=>{
    $4S00O.$ZodCIDRv4.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function cidrv4(params) {
    return $itOVw._cidrv4(ZodCIDRv4, params);
}
const ZodCIDRv6 = /*@__PURE__*/ $igTWG.$constructor("ZodCIDRv6", (inst, def)=>{
    $4S00O.$ZodCIDRv6.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function cidrv6(params) {
    return $itOVw._cidrv6(ZodCIDRv6, params);
}
const ZodBase64 = /*@__PURE__*/ $igTWG.$constructor("ZodBase64", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $4S00O.$ZodBase64.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function base64(params) {
    return $itOVw._base64(ZodBase64, params);
}
const ZodBase64URL = /*@__PURE__*/ $igTWG.$constructor("ZodBase64URL", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $4S00O.$ZodBase64URL.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function base64url(params) {
    return $itOVw._base64url(ZodBase64URL, params);
}
const ZodE164 = /*@__PURE__*/ $igTWG.$constructor("ZodE164", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $4S00O.$ZodE164.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function e164(params) {
    return $itOVw._e164(ZodE164, params);
}
const ZodCreditCard = /*@__PURE__*/ $igTWG.$constructor("ZodCreditCard", (inst, def)=>{
    $4S00O.$ZodCreditCard.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function creditCard(params) {
    return $itOVw._creditCard(ZodCreditCard, params);
}
const ZodIBAN = /*@__PURE__*/ $igTWG.$constructor("ZodIBAN", (inst, def)=>{
    $4S00O.$ZodIBAN.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function iban(params) {
    return $itOVw._iban(ZodIBAN, params);
}
const ZodJWT = /*@__PURE__*/ $igTWG.$constructor("ZodJWT", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $4S00O.$ZodJWT.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function jwt(params) {
    return $itOVw._jwt(ZodJWT, params);
}
const ZodCustomStringFormat = /*@__PURE__*/ $igTWG.$constructor("ZodCustomStringFormat", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $4S00O.$ZodCustomStringFormat.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function stringFormat(format, fnOrRegex, _params = {}) {
    return $itOVw._stringFormat(ZodCustomStringFormat, format, fnOrRegex, _params);
}
function hostname(_params) {
    return $itOVw._stringFormat(ZodCustomStringFormat, "hostname", $8S8Wz.hostname, _params);
}
function hex(_params) {
    return $itOVw._stringFormat(ZodCustomStringFormat, "hex", $8S8Wz.hex, _params);
}
function currencyCode(_params) {
    return $itOVw._stringFormat(ZodCustomStringFormat, "currency_code", $8S8Wz.currencyCode, _params);
}
function hash(alg, params) {
    const enc = params?.enc ?? "hex";
    const format = `${alg}_${enc}`;
    const regex = $8S8Wz[format];
    if (!regex) throw new Error(`Unrecognized hash format: ${format}`);
    return $itOVw._stringFormat(ZodCustomStringFormat, format, regex, params);
}
const ZodNumber = /*@__PURE__*/ $igTWG.$constructor("ZodNumber", (inst, def)=>{
    $4S00O.$ZodNumber.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.numberProcessor(inst, ctx, json, params);
    inst.isFinite = true;
}, /*@__PURE__*/ (0, $ciVeX).derived({
    minValue: (inst)=>{
        const { minimum, exclusiveMinimum } = $lhsqI.aggregateChecks(inst);
        return Math.max(minimum ?? Number.NEGATIVE_INFINITY, exclusiveMinimum ?? Number.NEGATIVE_INFINITY);
    },
    maxValue: (inst)=>{
        const { maximum, exclusiveMaximum } = $lhsqI.aggregateChecks(inst);
        return Math.min(maximum ?? Number.POSITIVE_INFINITY, exclusiveMaximum ?? Number.POSITIVE_INFINITY);
    },
    isInt: (inst)=>{
        const { isInt, multipleOf } = $lhsqI.aggregateChecks(inst);
        return !!isInt || !!multipleOf?.some(Number.isSafeInteger);
    },
    format: (inst)=>$lhsqI.aggregateChecks(inst).format ?? null
}, {
    gt (value1, params) {
        return this.check($itOVw._gt(value1, params));
    },
    gte (value1, params) {
        return this.check($itOVw._gte(value1, params));
    },
    min (value1, params) {
        return this.check($itOVw._gte(value1, params));
    },
    lt (value1, params) {
        return this.check($itOVw._lt(value1, params));
    },
    lte (value1, params) {
        return this.check($itOVw._lte(value1, params));
    },
    max (value1, params) {
        return this.check($itOVw._lte(value1, params));
    },
    int (params) {
        return this.check(int(params));
    },
    safe (params) {
        return this.check(int(params));
    },
    positive (params) {
        return this.check($itOVw._gt(0, params));
    },
    nonnegative (params) {
        return this.check($itOVw._gte(0, params));
    },
    negative (params) {
        return this.check($itOVw._lt(0, params));
    },
    nonpositive (params) {
        return this.check($itOVw._lte(0, params));
    },
    multipleOf (value1, params) {
        return this.check($itOVw._multipleOf(value1, params));
    },
    step (value1, params) {
        return this.check($itOVw._multipleOf(value1, params));
    },
    finite () {
        return this;
    }
}));
function number(params) {
    return $itOVw._number(ZodNumber, params);
}
const ZodNumberFormat = /*@__PURE__*/ $igTWG.$constructor("ZodNumberFormat", (inst, def)=>{
    $4S00O.$ZodNumberFormat.init(inst, def);
    ZodNumber.init(inst, def);
});
function int(params) {
    return $itOVw._int(ZodNumberFormat, params);
}
function float32(params) {
    return $itOVw._float32(ZodNumberFormat, params);
}
function float64(params) {
    return $itOVw._float64(ZodNumberFormat, params);
}
function int32(params) {
    return $itOVw._int32(ZodNumberFormat, params);
}
function uint32(params) {
    return $itOVw._uint32(ZodNumberFormat, params);
}
const ZodBoolean = /*@__PURE__*/ $igTWG.$constructor("ZodBoolean", (inst, def)=>{
    $4S00O.$ZodBoolean.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.booleanProcessor(inst, ctx, json, params);
});
function boolean(params) {
    return $itOVw._boolean(ZodBoolean, params);
}
const ZodBigInt = /*@__PURE__*/ $igTWG.$constructor("ZodBigInt", (inst, def)=>{
    $4S00O.$ZodBigInt.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.bigintProcessor(inst, ctx, json, params);
}, /*@__PURE__*/ (0, $ciVeX).derived({
    minValue: (inst)=>$lhsqI.aggregateChecks(inst).minimum ?? null,
    maxValue: (inst)=>$lhsqI.aggregateChecks(inst).maximum ?? null,
    format: (inst)=>$lhsqI.aggregateChecks(inst).format ?? null
}, {
    gte (value1, params) {
        return this.check($itOVw._gte(value1, params));
    },
    min (value1, params) {
        return this.check($itOVw._gte(value1, params));
    },
    gt (value1, params) {
        return this.check($itOVw._gt(value1, params));
    },
    lt (value1, params) {
        return this.check($itOVw._lt(value1, params));
    },
    lte (value1, params) {
        return this.check($itOVw._lte(value1, params));
    },
    max (value1, params) {
        return this.check($itOVw._lte(value1, params));
    },
    positive (params) {
        return this.check($itOVw._gt(BigInt(0), params));
    },
    negative (params) {
        return this.check($itOVw._lt(BigInt(0), params));
    },
    nonpositive (params) {
        return this.check($itOVw._lte(BigInt(0), params));
    },
    nonnegative (params) {
        return this.check($itOVw._gte(BigInt(0), params));
    },
    multipleOf (value1, params) {
        return this.check($itOVw._multipleOf(value1, params));
    }
}));
function bigint(params) {
    return $itOVw._bigint(ZodBigInt, params);
}
const ZodBigIntFormat = /*@__PURE__*/ $igTWG.$constructor("ZodBigIntFormat", (inst, def)=>{
    $4S00O.$ZodBigIntFormat.init(inst, def);
    ZodBigInt.init(inst, def);
});
function int64(params) {
    return $itOVw._int64(ZodBigIntFormat, params);
}
function uint64(params) {
    return $itOVw._uint64(ZodBigIntFormat, params);
}
const ZodSymbol = /*@__PURE__*/ $igTWG.$constructor("ZodSymbol", (inst, def)=>{
    $4S00O.$ZodSymbol.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.symbolProcessor(inst, ctx, json, params);
});
function symbol(params) {
    return $itOVw._symbol(ZodSymbol, params);
}
const ZodUndefined = /*@__PURE__*/ $igTWG.$constructor("ZodUndefined", (inst, def)=>{
    $4S00O.$ZodUndefined.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.undefinedProcessor(inst, ctx, json, params);
});
function _undefined(params) {
    return $itOVw._undefined(ZodUndefined, params);
}
const ZodNull = /*@__PURE__*/ $igTWG.$constructor("ZodNull", (inst, def)=>{
    $4S00O.$ZodNull.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.nullProcessor(inst, ctx, json, params);
});
function _null(params) {
    return $itOVw._null(ZodNull, params);
}
const ZodAny = /*@__PURE__*/ $igTWG.$constructor("ZodAny", (inst, def)=>{
    $4S00O.$ZodAny.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.anyProcessor(inst, ctx, json, params);
});
function any() {
    return $itOVw._any(ZodAny);
}
const ZodUnknown = /*@__PURE__*/ $igTWG.$constructor("ZodUnknown", (inst, def)=>{
    $4S00O.$ZodUnknown.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.unknownProcessor(inst, ctx, json, params);
});
function unknown() {
    return $itOVw._unknown(ZodUnknown);
}
const ZodNever = /*@__PURE__*/ $igTWG.$constructor("ZodNever", (inst, def)=>{
    $4S00O.$ZodNever.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.neverProcessor(inst, ctx, json, params);
});
function never(params) {
    return $itOVw._never(ZodNever, params);
}
const ZodVoid = /*@__PURE__*/ $igTWG.$constructor("ZodVoid", (inst, def)=>{
    $4S00O.$ZodVoid.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.voidProcessor(inst, ctx, json, params);
});
function _void(params) {
    return $itOVw._void(ZodVoid, params);
}
const ZodDate = /*@__PURE__*/ $igTWG.$constructor("ZodDate", (inst, def)=>{
    $4S00O.$ZodDate.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.dateProcessor(inst, ctx, json, params);
    inst.min = (value1, params)=>inst.check($itOVw._gte(value1, params));
    inst.max = (value1, params)=>inst.check($itOVw._lte(value1, params));
}, /*@__PURE__*/ (0, $ciVeX).derived({
    minDate: (inst)=>{
        const { minimum } = $lhsqI.aggregateChecks(inst);
        return minimum ? new Date(minimum) : null;
    },
    maxDate: (inst)=>{
        const { maximum } = $lhsqI.aggregateChecks(inst);
        return maximum ? new Date(maximum) : null;
    }
}, {}));
function date(params) {
    return $itOVw._date(ZodDate, params);
}
const ZodArray = /*@__PURE__*/ $igTWG.$constructor("ZodArray", (inst, def)=>{
    _ensureDefaultMemoizer();
    $4S00O.$ZodArray.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.arrayProcessor(inst, ctx, json, params);
    inst.element = def.element;
}, {
    min (n, params) {
        return this.check($itOVw._minLength(n, params));
    },
    nonempty (params) {
        return this.check($itOVw._minLength(1, params));
    },
    max (n, params) {
        return this.check($itOVw._maxLength(n, params));
    },
    length (n, params) {
        return this.check($itOVw._length(n, params));
    },
    unwrap () {
        return this.element;
    }
});
function array(element, params) {
    return $itOVw._array(ZodArray, element, params);
}
function keyof(schema) {
    const shape = schema._zod.def.shape;
    return _enum(Object.keys(shape));
}
const ZodObject = /*@__PURE__*/ $igTWG.$constructor("ZodObject", (inst, def)=>{
    _ensureDefaultMemoizer();
    $4S00O.$ZodObjectJIT.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.objectProcessor(inst, ctx, json, params);
    (0, $ciVeX).installLazyProp(inst, "shape", (self)=>self._zod.def.shape, false);
}, {
    keyof () {
        return _enum(Object.keys(this._zod.def.shape));
    },
    catchall (catchall) {
        // `mergeDefs` rather than a spread: spreading reads `shape`, and resolving it can mint a whole fresh subtree
        return this.clone((0, $ciVeX).mergeDefs(this._zod.def, {
            catchall: catchall
        }));
    },
    passthrough () {
        return this.clone((0, $ciVeX).mergeDefs(this._zod.def, {
            catchall: unknown()
        }));
    },
    loose () {
        return this.clone((0, $ciVeX).mergeDefs(this._zod.def, {
            catchall: unknown()
        }));
    },
    strict () {
        return this.clone((0, $ciVeX).mergeDefs(this._zod.def, {
            catchall: never()
        }));
    },
    strip () {
        return this.clone((0, $ciVeX).mergeDefs(this._zod.def, {
            catchall: undefined
        }));
    },
    extend (incoming) {
        return (0, $ciVeX).extend(this, incoming);
    },
    safeExtend (incoming) {
        return (0, $ciVeX).safeExtend(this, incoming);
    },
    merge (other) {
        return (0, $ciVeX).merge(this, other);
    },
    pick (mask) {
        return (0, $ciVeX).pick(this, mask);
    },
    omit (mask) {
        return (0, $ciVeX).omit(this, mask);
    },
    partial (...args) {
        return (0, $ciVeX).partial(ZodOptional, this, args[0]);
    },
    exactPartial (...args) {
        return (0, $ciVeX).partial(ZodExactOptional, this, args[0], "exactPartial");
    },
    required (...args) {
        return (0, $ciVeX).required(ZodNonOptional, this, args[0]);
    }
});
function object(shape, params) {
    const def = {
        type: "object",
        shape: shape ?? {},
        ...(0, $ciVeX).normalizeParams(params)
    };
    return new ZodObject(def);
}
function strictObject(shape, params) {
    return new ZodObject({
        type: "object",
        shape: shape,
        catchall: never(),
        ...(0, $ciVeX).normalizeParams(params)
    });
}
function looseObject(shape, params) {
    return new ZodObject({
        type: "object",
        shape: shape,
        catchall: unknown(),
        ...(0, $ciVeX).normalizeParams(params)
    });
}
const ZodUnion = /*@__PURE__*/ $igTWG.$constructor("ZodUnion", (inst, def)=>{
    $4S00O.$ZodUnion.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.unionProcessor(inst, ctx, json, params);
    inst.options = def.options;
});
function union(options, params) {
    return new ZodUnion({
        type: "union",
        options: options,
        ...(0, $ciVeX).normalizeParams(params)
    });
}
const ZodXor = /*@__PURE__*/ $igTWG.$constructor("ZodXor", (inst, def)=>{
    ZodUnion.init(inst, def);
    $4S00O.$ZodXor.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.unionProcessor(inst, ctx, json, params);
    inst.options = def.options;
});
function xor(options, params) {
    return new ZodXor({
        type: "union",
        options: options,
        inclusive: false,
        ...(0, $ciVeX).normalizeParams(params)
    });
}
const ZodDiscriminatedUnion = /*@__PURE__*/ $igTWG.$constructor("ZodDiscriminatedUnion", (inst, def)=>{
    ZodUnion.init(inst, def);
    $4S00O.$ZodDiscriminatedUnion.init(inst, def);
});
function discriminatedUnion(discriminator, options, params) {
    // const [options, params] = args;
    return new ZodDiscriminatedUnion({
        type: "union",
        options: options,
        discriminator: discriminator,
        ...(0, $ciVeX).normalizeParams(params)
    });
}
const ZodIntersection = /*@__PURE__*/ $igTWG.$constructor("ZodIntersection", (inst, def)=>{
    $4S00O.$ZodIntersection.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.intersectionProcessor(inst, ctx, json, params);
});
function intersection(left, right) {
    return new ZodIntersection({
        type: "intersection",
        left: left,
        right: right
    });
}
const ZodTuple = /*@__PURE__*/ $igTWG.$constructor("ZodTuple", (inst, def)=>{
    _ensureDefaultMemoizer();
    $4S00O.$ZodTuple.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.tupleProcessor(inst, ctx, json, params);
}, {
    rest (rest) {
        return this.clone({
            ...this._zod.def,
            rest: rest
        });
    },
    partial () {
        const def = this._zod.def;
        // a refinement was authored against the full arity; partialing would run it on a shorter array
        if (def.checks?.length) throw new Error(".partial() cannot be used on tuple schemas containing refinements");
        return this.clone({
            ...def,
            items: def.items.map((item)=>new ZodOptional({
                    type: "optional",
                    innerType: item
                }))
        });
    }
});
function tuple(items, _paramsOrRest, _params) {
    const hasRest = _paramsOrRest instanceof $4S00O.$ZodType;
    const params = hasRest ? _params : _paramsOrRest;
    const rest = hasRest ? _paramsOrRest : null;
    return new ZodTuple({
        type: "tuple",
        items: items,
        rest: rest,
        ...(0, $ciVeX).normalizeParams(params)
    });
}
const ZodRecord = /*@__PURE__*/ $igTWG.$constructor("ZodRecord", (inst, def)=>{
    _ensureDefaultMemoizer();
    $4S00O.$ZodRecord.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.recordProcessor(inst, ctx, json, params);
    inst.keyType = def.keyType;
    inst.valueType = def.valueType;
});
function record(keyType, valueType, params) {
    // v3-compat: z.record(valueType, params?) — defaults keyType to z.string()
    if (!valueType || !valueType._zod) return new ZodRecord({
        type: "record",
        keyType: string(),
        valueType: keyType,
        ...(0, $ciVeX).normalizeParams(valueType)
    });
    return new ZodRecord({
        type: "record",
        keyType: keyType,
        valueType: valueType,
        ...(0, $ciVeX).normalizeParams(params)
    });
}
function partialRecord(keyType, valueType, params) {
    return new ZodRecord({
        type: "record",
        keyType: keyType,
        valueType: valueType,
        ...(0, $ciVeX).normalizeParams(params),
        partial: true
    });
}
function looseRecord(keyType, valueType, params) {
    return new ZodRecord({
        type: "record",
        keyType: keyType,
        valueType: valueType,
        mode: "loose",
        ...(0, $ciVeX).normalizeParams(params)
    });
}
const ZodMap = /*@__PURE__*/ $igTWG.$constructor("ZodMap", (inst, def)=>{
    _ensureDefaultMemoizer();
    $4S00O.$ZodMap.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.mapProcessor(inst, ctx, json, params);
    inst.keyType = def.keyType;
    inst.valueType = def.valueType;
    inst.min = (...args)=>inst.check($itOVw._minSize(...args));
    inst.nonempty = (params)=>inst.check($itOVw._minSize(1, params));
    inst.max = (...args)=>inst.check($itOVw._maxSize(...args));
    inst.size = (...args)=>inst.check($itOVw._size(...args));
});
function map(keyType, valueType, params) {
    return new ZodMap({
        type: "map",
        keyType: keyType,
        valueType: valueType,
        ...(0, $ciVeX).normalizeParams(params)
    });
}
const ZodSet = /*@__PURE__*/ $igTWG.$constructor("ZodSet", (inst, def)=>{
    _ensureDefaultMemoizer();
    $4S00O.$ZodSet.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.setProcessor(inst, ctx, json, params);
    inst.min = (...args)=>inst.check($itOVw._minSize(...args));
    inst.nonempty = (params)=>inst.check($itOVw._minSize(1, params));
    inst.max = (...args)=>inst.check($itOVw._maxSize(...args));
    inst.size = (...args)=>inst.check($itOVw._size(...args));
});
function set(valueType, params) {
    return new ZodSet({
        type: "set",
        valueType: valueType,
        ...(0, $ciVeX).normalizeParams(params)
    });
}
const ZodEnum = /*@__PURE__*/ $igTWG.$constructor("ZodEnum", (inst, def)=>{
    $4S00O.$ZodEnum.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.enumProcessor(inst, ctx, json, params);
    inst.enum = def.entries;
    // reuse the parsed value set so a numeric TS enum's reverse-mapping keys stay out
    inst.options = [
        ...inst._zod.values
    ];
    const keys = new Set(Object.keys(def.entries));
    inst.extract = (values, params)=>{
        const newEntries = {};
        for (const value1 of values){
            if (keys.has(value1)) newEntries[value1] = def.entries[value1];
            else throw new Error(`Key ${value1} not found in enum`);
        }
        return new ZodEnum({
            ...def,
            checks: [],
            ...(0, $ciVeX).normalizeParams(params),
            entries: newEntries
        });
    };
    inst.exclude = (values, params)=>{
        const newEntries = {
            ...def.entries
        };
        for (const value1 of values){
            if (keys.has(value1)) delete newEntries[value1];
            else throw new Error(`Key ${value1} not found in enum`);
        }
        return new ZodEnum({
            ...def,
            checks: [],
            ...(0, $ciVeX).normalizeParams(params),
            entries: newEntries
        });
    };
});
function _enum(values, params) {
    const entries = Array.isArray(values) ? Object.fromEntries(values.map((v)=>[
            v,
            v
        ])) : values;
    return new ZodEnum({
        type: "enum",
        entries: entries,
        ...(0, $ciVeX).normalizeParams(params)
    });
}
function nativeEnum(entries, params) {
    return new ZodEnum({
        type: "enum",
        entries: entries,
        ...(0, $ciVeX).normalizeParams(params)
    });
}
const ZodLiteral = /*@__PURE__*/ $igTWG.$constructor("ZodLiteral", (inst, def)=>{
    $4S00O.$ZodLiteral.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.literalProcessor(inst, ctx, json, params);
    inst.values = new Set(def.values);
    Object.defineProperty(inst, "value", {
        get () {
            if (def.values.length > 1) throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
            return def.values[0];
        }
    });
});
function literal(value1, params) {
    return new ZodLiteral({
        type: "literal",
        values: Array.isArray(value1) ? value1 : [
            value1
        ],
        ...(0, $ciVeX).normalizeParams(params)
    });
}
const ZodFile = /*@__PURE__*/ $igTWG.$constructor("ZodFile", (inst, def)=>{
    $4S00O.$ZodFile.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.fileProcessor(inst, ctx, json, params);
    inst.min = (size, params)=>inst.check($itOVw._minSize(size, params));
    inst.max = (size, params)=>inst.check($itOVw._maxSize(size, params));
    inst.mime = (types, params)=>inst.check($itOVw._mime(Array.isArray(types) ? types : [
            types
        ], params));
});
function file(params) {
    return $itOVw._file(ZodFile, params);
}
const ZodTransform = /*@__PURE__*/ $igTWG.$constructor("ZodTransform", (inst, def)=>{
    _ensureDefaultMemoizer();
    $4S00O.$ZodTransform.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.transformProcessor(inst, ctx, json, params);
    inst._zod.parse = (payload, _ctx)=>{
        if (_ctx.direction === "backward") throw new $igTWG.$ZodEncodeError(inst.constructor.name);
        payload.addIssue = (issue)=>{
            if (typeof issue === "string") payload.issues.push((0, $ciVeX).issue(issue, payload.value, def));
            else {
                // for Zod 3 backwards compatibility
                const _issue = issue;
                if (_issue.fatal) _issue.continue = false;
                _issue.code ?? (_issue.code = "custom");
                if (!("input" in _issue)) _issue.input = payload.value;
                _issue.inst ?? (_issue.inst = inst);
                // _issue.continue ??= true;
                payload.issues.push((0, $ciVeX).issue(_issue));
            }
        };
        const output = def.transform(payload.value, payload);
        if (output instanceof Promise) return output.then((output)=>{
            payload.value = output;
            return payload;
        });
        payload.value = output;
        return payload;
    };
});
function transform(fn) {
    return new ZodTransform({
        type: "transform",
        transform: fn
    });
}
const ZodOptional = /*@__PURE__*/ $igTWG.$constructor("ZodOptional", (inst, def)=>{
    $4S00O.$ZodOptional.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.optionalProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function optional(innerType) {
    return new ZodOptional({
        type: "optional",
        innerType: innerType
    });
}
const ZodExactOptional = /*@__PURE__*/ $igTWG.$constructor("ZodExactOptional", (inst, def)=>{
    $4S00O.$ZodExactOptional.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.optionalProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function exactOptional(innerType) {
    return new ZodExactOptional({
        type: "optional",
        innerType: innerType
    });
}
const ZodNullable = /*@__PURE__*/ $igTWG.$constructor("ZodNullable", (inst, def)=>{
    $4S00O.$ZodNullable.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.nullableProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function nullable(innerType) {
    return new ZodNullable({
        type: "nullable",
        innerType: innerType
    });
}
function nullish(innerType) {
    return optional(nullable(innerType));
}
const ZodDefault = /*@__PURE__*/ $igTWG.$constructor("ZodDefault", (inst, def)=>{
    $4S00O.$ZodDefault.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.defaultProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
    inst.removeDefault = inst.unwrap;
});
function _default(innerType, defaultValue) {
    return new ZodDefault({
        type: "default",
        innerType: innerType,
        get defaultValue () {
            return typeof defaultValue === "function" ? defaultValue() : (0, $ciVeX).shallowClone(defaultValue);
        }
    });
}
const ZodPrefault = /*@__PURE__*/ $igTWG.$constructor("ZodPrefault", (inst, def)=>{
    $4S00O.$ZodPrefault.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.prefaultProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function prefault(innerType, defaultValue) {
    return new ZodPrefault({
        type: "prefault",
        innerType: innerType,
        get defaultValue () {
            return typeof defaultValue === "function" ? defaultValue() : (0, $ciVeX).shallowClone(defaultValue);
        }
    });
}
const ZodNonOptional = /*@__PURE__*/ $igTWG.$constructor("ZodNonOptional", (inst, def)=>{
    $4S00O.$ZodNonOptional.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.nonoptionalProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function nonoptional(innerType, params) {
    return new ZodNonOptional({
        type: "nonoptional",
        innerType: innerType,
        ...(0, $ciVeX).normalizeParams(params)
    });
}
const ZodSuccess = /*@__PURE__*/ $igTWG.$constructor("ZodSuccess", (inst, def)=>{
    $4S00O.$ZodSuccess.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.successProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function success(innerType) {
    return new ZodSuccess({
        type: "success",
        innerType: innerType
    });
}
const ZodCatch = /*@__PURE__*/ $igTWG.$constructor("ZodCatch", (inst, def)=>{
    $4S00O.$ZodCatch.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.catchProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
    inst.removeCatch = inst.unwrap;
});
function _catch(innerType, catchValue) {
    return new ZodCatch({
        type: "catch",
        innerType: innerType,
        catchValue: typeof catchValue === "function" ? catchValue : $ciVeX.constantCatch(catchValue)
    });
}
const ZodNaN = /*@__PURE__*/ $igTWG.$constructor("ZodNaN", (inst, def)=>{
    $4S00O.$ZodNaN.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.nanProcessor(inst, ctx, json, params);
});
function nan(params) {
    return $itOVw._nan(ZodNaN, params);
}
const ZodPipe = /*@__PURE__*/ $igTWG.$constructor("ZodPipe", (inst, def)=>{
    $4S00O.$ZodPipe.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.pipeProcessor(inst, ctx, json, params);
    inst.in = def.in;
    inst.out = def.out;
});
function pipe(in_, out) {
    return new ZodPipe({
        type: "pipe",
        in: in_,
        out: out
    });
}
const ZodCodec = /*@__PURE__*/ $igTWG.$constructor("ZodCodec", (inst, def)=>{
    ZodPipe.init(inst, def);
    $4S00O.$ZodCodec.init(inst, def);
});
function codec(in_, out, params) {
    return new ZodCodec({
        type: "pipe",
        in: in_,
        out: out,
        transform: params.decode,
        reverseTransform: params.encode
    });
}
function invertCodec(codec) {
    const def = codec._zod.def;
    return new ZodCodec({
        type: "pipe",
        in: def.out,
        out: def.in,
        transform: def.reverseTransform,
        reverseTransform: def.transform
    });
}
const ZodPreprocess = /*@__PURE__*/ $igTWG.$constructor("ZodPreprocess", (inst, def)=>{
    ZodPipe.init(inst, def);
    $4S00O.$ZodPreprocess.init(inst, def);
});
const ZodReadonly = /*@__PURE__*/ $igTWG.$constructor("ZodReadonly", (inst, def)=>{
    $4S00O.$ZodReadonly.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.readonlyProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function readonly(innerType) {
    return new ZodReadonly({
        type: "readonly",
        innerType: innerType
    });
}
const ZodTemplateLiteral = /*@__PURE__*/ $igTWG.$constructor("ZodTemplateLiteral", (inst, def)=>{
    $4S00O.$ZodTemplateLiteral.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.templateLiteralProcessor(inst, ctx, json, params);
});
function templateLiteral(parts, params) {
    return new ZodTemplateLiteral({
        type: "template_literal",
        parts: parts,
        ...(0, $ciVeX).normalizeParams(params)
    });
}
const ZodLazy = /*@__PURE__*/ $igTWG.$constructor("ZodLazy", (inst, def)=>{
    $4S00O.$ZodLazy.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.lazyProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.getter();
});
function lazy(getter) {
    return new ZodLazy({
        type: "lazy",
        getter: getter
    });
}
const ZodPromise = /*@__PURE__*/ $igTWG.$constructor("ZodPromise", (inst, def)=>{
    $4S00O.$ZodPromise.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.promiseProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function promise(innerType) {
    return new ZodPromise({
        type: "promise",
        innerType: innerType
    });
}
const ZodFunction = /*@__PURE__*/ $igTWG.$constructor("ZodFunction", (inst, def)=>{
    $4S00O.$ZodFunction.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.functionProcessor(inst, ctx, json, params);
});
function _function(params) {
    return new ZodFunction({
        type: "function",
        input: Array.isArray(params?.input) ? tuple(params?.input) : params?.input ?? array(unknown()),
        output: params?.output ?? unknown()
    });
}
const ZodCustom = /*@__PURE__*/ $igTWG.$constructor("ZodCustom", (inst, def)=>{
    $4S00O.$ZodCustom.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lhsqI.customProcessor(inst, ctx, json, params);
});
function check(fn) {
    const ch = new $b9Fsy.$ZodCheck({
        check: "custom"
    });
    ch._zod.check = fn;
    return ch;
}
function custom(fn, _params) {
    return $itOVw._custom(ZodCustom, fn ?? (()=>true), _params);
}
function refine(fn, _params = {}) {
    return $itOVw._refine(ZodCustom, fn, _params);
}
function superRefine(fn, params) {
    return $itOVw._superRefine(fn, params);
}
const describe = $itOVw.describe;
const meta = $itOVw.meta;
const ZodInstanceOf = /*@__PURE__*/ $igTWG.$constructor("ZodInstanceOf", (inst, def)=>{
    ZodCustom.init(inst, def);
}, {
    properties (shape, params) {
        // asserts in place, so the narrowed output type is truthful without a wrapper
        return this.check($itOVw._properties(shape, params));
    }
});
function _instanceof(cls, params = {}) {
    const inst = new ZodInstanceOf({
        type: "custom",
        check: "custom",
        fn: (data)=>data instanceof cls,
        abort: true,
        ...(0, $ciVeX).normalizeParams(params)
    });
    inst._zod.bag.Class = cls;
    // Override check to emit invalid_type instead of custom
    inst._zod.check = (payload)=>{
        if (!(payload.value instanceof cls)) payload.issues.push({
            code: "invalid_type",
            expected: cls.name,
            input: payload.value,
            inst: inst,
            path: [
                ...inst._zod.def.path ?? []
            ]
        });
    };
    return inst;
}
const stringbool = (...args)=>$itOVw._stringbool({
        Codec: ZodCodec,
        Boolean: ZodBoolean,
        String: ZodString
    }, ...args);
function json(params) {
    const jsonSchema = lazy(()=>{
        return union([
            string(params),
            number(),
            boolean(),
            _null(),
            array(jsonSchema),
            record(string(), jsonSchema)
        ]);
    });
    return jsonSchema;
}
function preprocess(fn, schema) {
    return new ZodPreprocess({
        type: "pipe",
        in: transform(fn),
        out: schema
    });
}

});
parcelRegister("itOVw", function(module, exports) {
$parcel$export(module.exports, "_string", () => $d7427071dbf0b4e9$export$25986a84359f8f7f);
$parcel$export(module.exports, "_email", () => $d7427071dbf0b4e9$export$471b39521bec3299);
$parcel$export(module.exports, "_guid", () => $d7427071dbf0b4e9$export$129b5399d64cccb0);
$parcel$export(module.exports, "_uuid", () => $d7427071dbf0b4e9$export$f2f3139038bea52c);
$parcel$export(module.exports, "_uuidv4", () => $d7427071dbf0b4e9$export$a5559d7da37a112f);
$parcel$export(module.exports, "_uuidv6", () => $d7427071dbf0b4e9$export$53b427a8173231a);
$parcel$export(module.exports, "_uuidv7", () => $d7427071dbf0b4e9$export$588d23d6e9ec2ed5);
$parcel$export(module.exports, "_url", () => $d7427071dbf0b4e9$export$e3f203373341d39);
$parcel$export(module.exports, "_emoji", () => $d7427071dbf0b4e9$export$936e26d261396f46);
$parcel$export(module.exports, "_nanoid", () => $d7427071dbf0b4e9$export$a030949b19390ea0);
$parcel$export(module.exports, "_cuid", () => $d7427071dbf0b4e9$export$639125837b796148);
$parcel$export(module.exports, "_cuid2", () => $d7427071dbf0b4e9$export$36b63ef9af7972c2);
$parcel$export(module.exports, "_ulid", () => $d7427071dbf0b4e9$export$95acf3b3fa11bdc9);
$parcel$export(module.exports, "_xid", () => $d7427071dbf0b4e9$export$bbb0a2cfb079fa90);
$parcel$export(module.exports, "_ksuid", () => $d7427071dbf0b4e9$export$1306ede2f9ea153f);
$parcel$export(module.exports, "_ipv4", () => $d7427071dbf0b4e9$export$c77a1c80cebc2aad);
$parcel$export(module.exports, "_ipv6", () => $d7427071dbf0b4e9$export$964dfe0e2e4e8895);
$parcel$export(module.exports, "_mac", () => $d7427071dbf0b4e9$export$84f8b3e041d8e7d9);
$parcel$export(module.exports, "_cidrv4", () => $d7427071dbf0b4e9$export$feaac4e27a421ddc);
$parcel$export(module.exports, "_cidrv6", () => $d7427071dbf0b4e9$export$a0518ffc5273ec92);
$parcel$export(module.exports, "_base64", () => $d7427071dbf0b4e9$export$9fdb09384fbc4988);
$parcel$export(module.exports, "_base64url", () => $d7427071dbf0b4e9$export$178c70fb89c949fa);
$parcel$export(module.exports, "_e164", () => $d7427071dbf0b4e9$export$b8bf0b70d4bc7855);
$parcel$export(module.exports, "_creditCard", () => $d7427071dbf0b4e9$export$86d44988408f3a7f);
$parcel$export(module.exports, "_iban", () => $d7427071dbf0b4e9$export$ca14e367b122da36);
$parcel$export(module.exports, "_jwt", () => $d7427071dbf0b4e9$export$4a9318e6b46f1aa1);
$parcel$export(module.exports, "_isoDateTime", () => $d7427071dbf0b4e9$export$a62adeb27809351b);
$parcel$export(module.exports, "_isoDate", () => $d7427071dbf0b4e9$export$e4f19dd0a54e7a59);
$parcel$export(module.exports, "_isoTime", () => $d7427071dbf0b4e9$export$36f9f051d5e817c);
$parcel$export(module.exports, "_isoDuration", () => $d7427071dbf0b4e9$export$7d70539c76fbff4);
$parcel$export(module.exports, "_number", () => $d7427071dbf0b4e9$export$9249bb0b45639623);
$parcel$export(module.exports, "_int", () => $d7427071dbf0b4e9$export$3d5b343b1f51efdd);
$parcel$export(module.exports, "_float32", () => $d7427071dbf0b4e9$export$656ad65d6cf64174);
$parcel$export(module.exports, "_float64", () => $d7427071dbf0b4e9$export$9ddff8176107cc11);
$parcel$export(module.exports, "_int32", () => $d7427071dbf0b4e9$export$5ec965fd114a2f9f);
$parcel$export(module.exports, "_uint32", () => $d7427071dbf0b4e9$export$a43c28c6e86e066e);
$parcel$export(module.exports, "_boolean", () => $d7427071dbf0b4e9$export$e23c41ce5ce2db39);
$parcel$export(module.exports, "_bigint", () => $d7427071dbf0b4e9$export$c96ff33878177e4c);
$parcel$export(module.exports, "_int64", () => $d7427071dbf0b4e9$export$cb7d3ec922804f3f);
$parcel$export(module.exports, "_uint64", () => $d7427071dbf0b4e9$export$c51606f0dfa0f5a1);
$parcel$export(module.exports, "_symbol", () => $d7427071dbf0b4e9$export$a8f93f5b7c030e84);
$parcel$export(module.exports, "_undefined", () => $d7427071dbf0b4e9$export$60e4c9fe67803d40);
$parcel$export(module.exports, "_null", () => $d7427071dbf0b4e9$export$a2cbb38cda512d16);
$parcel$export(module.exports, "_any", () => $d7427071dbf0b4e9$export$4678886173313220);
$parcel$export(module.exports, "_unknown", () => $d7427071dbf0b4e9$export$e0ed508a47e00801);
$parcel$export(module.exports, "_never", () => $d7427071dbf0b4e9$export$887f43204ffc2a69);
$parcel$export(module.exports, "_void", () => $d7427071dbf0b4e9$export$9480825d3c8e9ad6);
$parcel$export(module.exports, "_date", () => $d7427071dbf0b4e9$export$da799735c76175a);
$parcel$export(module.exports, "_nan", () => $d7427071dbf0b4e9$export$a5e7e1f8491a5e50);
$parcel$export(module.exports, "_lt", () => $d7427071dbf0b4e9$export$2a42c74e76a068a);
$parcel$export(module.exports, "_lte", () => $d7427071dbf0b4e9$export$7a060cf3d60b84a6);
$parcel$export(module.exports, "_gt", () => $d7427071dbf0b4e9$export$7582466e3ab4d25b);
$parcel$export(module.exports, "_gte", () => $d7427071dbf0b4e9$export$a1c6d8834a3b19c9);
$parcel$export(module.exports, "_multipleOf", () => $d7427071dbf0b4e9$export$c41e40f80e978ab1);
$parcel$export(module.exports, "_maxSize", () => $d7427071dbf0b4e9$export$3eed6ccb98bc18db);
$parcel$export(module.exports, "_minSize", () => $d7427071dbf0b4e9$export$e379713268c2c18a);
$parcel$export(module.exports, "_size", () => $d7427071dbf0b4e9$export$2621565b966a8d23);
$parcel$export(module.exports, "_maxLength", () => $d7427071dbf0b4e9$export$ec76627108655a22);
$parcel$export(module.exports, "_minLength", () => $d7427071dbf0b4e9$export$21f6711a906c1450);
$parcel$export(module.exports, "_length", () => $d7427071dbf0b4e9$export$620b9f7ab17ff8a9);
$parcel$export(module.exports, "_regex", () => $d7427071dbf0b4e9$export$c4768a1bd8f8393);
$parcel$export(module.exports, "_lowercase", () => $d7427071dbf0b4e9$export$ea67c3edeec85c63);
$parcel$export(module.exports, "_uppercase", () => $d7427071dbf0b4e9$export$2998381b41c6902a);
$parcel$export(module.exports, "_includes", () => $d7427071dbf0b4e9$export$fccf016a6caa651d);
$parcel$export(module.exports, "_startsWith", () => $d7427071dbf0b4e9$export$2f37aaf99060de76);
$parcel$export(module.exports, "_endsWith", () => $d7427071dbf0b4e9$export$eaeaa2fcd833167e);
$parcel$export(module.exports, "_properties", () => $d7427071dbf0b4e9$export$a72788ae987f5bef);
$parcel$export(module.exports, "_mime", () => $d7427071dbf0b4e9$export$267177285a1a8b37);
$parcel$export(module.exports, "_overwrite", () => $d7427071dbf0b4e9$export$aeea8f004f34f8c2);
$parcel$export(module.exports, "_normalize", () => $d7427071dbf0b4e9$export$2b99bb23a814f78e);
$parcel$export(module.exports, "_trim", () => $d7427071dbf0b4e9$export$8be2de0b60774d1e);
$parcel$export(module.exports, "_toLowerCase", () => $d7427071dbf0b4e9$export$d9cfe939403a2525);
$parcel$export(module.exports, "_toUpperCase", () => $d7427071dbf0b4e9$export$cf76ef1ae9e9944e);
$parcel$export(module.exports, "_slugify", () => $d7427071dbf0b4e9$export$2801993b93f3c232);
$parcel$export(module.exports, "_array", () => $d7427071dbf0b4e9$export$4ea446333e3db634);
$parcel$export(module.exports, "_file", () => $d7427071dbf0b4e9$export$e335cd0b9f8bab1e);
$parcel$export(module.exports, "_custom", () => $d7427071dbf0b4e9$export$8bfc2ce1398e3071);
$parcel$export(module.exports, "_refine", () => $d7427071dbf0b4e9$export$ac822e05051812e1);
$parcel$export(module.exports, "_superRefine", () => $d7427071dbf0b4e9$export$f2b01ecb843d7ab9);
$parcel$export(module.exports, "describe", () => $d7427071dbf0b4e9$export$cd5450f3a47e3789);
$parcel$export(module.exports, "meta", () => $d7427071dbf0b4e9$export$6990040ee07315);
$parcel$export(module.exports, "_stringbool", () => $d7427071dbf0b4e9$export$a75528509e3a7006);
$parcel$export(module.exports, "_stringFormat", () => $d7427071dbf0b4e9$export$e25dde89ba546b88);

var $b9Fsy = parcelRequire("b9Fsy");

var $5ehZO = parcelRequire("5ehZO");

var $4S00O = parcelRequire("4S00O");

var $ciVeX = parcelRequire("ciVeX");
function $d7427071dbf0b4e9$var$snapshotChecks(def) {
    if (def.checks) def.checks = [
        ...def.checks
    ];
    return def;
}
function $d7427071dbf0b4e9$export$25986a84359f8f7f(Class, params) {
    return new Class($d7427071dbf0b4e9$var$snapshotChecks({
        type: "string",
        ...$ciVeX.normalizeParams(params)
    }));
}
function $d7427071dbf0b4e9$export$614049477c642ce0(Class, params) {
    return new Class($d7427071dbf0b4e9$var$snapshotChecks({
        type: "string",
        coerce: true,
        ...$ciVeX.normalizeParams(params)
    }));
}
function $d7427071dbf0b4e9$export$471b39521bec3299(Class, params) {
    return new Class({
        type: "string",
        format: "email",
        check: "string_format",
        abort: false,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$129b5399d64cccb0(Class, params) {
    return new Class({
        type: "string",
        format: "guid",
        check: "string_format",
        abort: false,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$f2f3139038bea52c(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$a5559d7da37a112f(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        version: "v4",
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$53b427a8173231a(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        version: "v6",
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$588d23d6e9ec2ed5(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        version: "v7",
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$e3f203373341d39(Class, params) {
    return new Class({
        type: "string",
        format: "url",
        check: "string_format",
        abort: false,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$936e26d261396f46(Class, params) {
    return new Class({
        type: "string",
        format: "emoji",
        check: "string_format",
        abort: false,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$a030949b19390ea0(Class, params) {
    return new Class({
        type: "string",
        format: "nanoid",
        check: "string_format",
        abort: false,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$639125837b796148(Class, params) {
    return new Class({
        type: "string",
        format: "cuid",
        check: "string_format",
        abort: false,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$36b63ef9af7972c2(Class, params) {
    return new Class({
        type: "string",
        format: "cuid2",
        check: "string_format",
        abort: false,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$95acf3b3fa11bdc9(Class, params) {
    return new Class({
        type: "string",
        format: "ulid",
        check: "string_format",
        abort: false,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$bbb0a2cfb079fa90(Class, params) {
    return new Class({
        type: "string",
        format: "xid",
        check: "string_format",
        abort: false,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$1306ede2f9ea153f(Class, params) {
    return new Class({
        type: "string",
        format: "ksuid",
        check: "string_format",
        abort: false,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$c77a1c80cebc2aad(Class, params) {
    return new Class({
        type: "string",
        format: "ipv4",
        check: "string_format",
        abort: false,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$964dfe0e2e4e8895(Class, params) {
    return new Class({
        type: "string",
        format: "ipv6",
        check: "string_format",
        abort: false,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$84f8b3e041d8e7d9(Class, params) {
    return new Class({
        type: "string",
        format: "mac",
        check: "string_format",
        abort: false,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$feaac4e27a421ddc(Class, params) {
    return new Class({
        type: "string",
        format: "cidrv4",
        check: "string_format",
        abort: false,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$a0518ffc5273ec92(Class, params) {
    return new Class({
        type: "string",
        format: "cidrv6",
        check: "string_format",
        abort: false,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$9fdb09384fbc4988(Class, params) {
    return new Class({
        type: "string",
        format: "base64",
        check: "string_format",
        abort: false,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$178c70fb89c949fa(Class, params) {
    return new Class({
        type: "string",
        format: "base64url",
        check: "string_format",
        abort: false,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$b8bf0b70d4bc7855(Class, params) {
    return new Class({
        type: "string",
        format: "e164",
        check: "string_format",
        abort: false,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$86d44988408f3a7f(Class, params) {
    return new Class({
        type: "string",
        format: "credit_card",
        check: "string_format",
        abort: false,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$ca14e367b122da36(Class, params) {
    return new Class({
        type: "string",
        format: "iban",
        check: "string_format",
        abort: false,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$4a9318e6b46f1aa1(Class, params) {
    return new Class({
        type: "string",
        format: "jwt",
        check: "string_format",
        abort: false,
        ...$ciVeX.normalizeParams(params)
    });
}
const $d7427071dbf0b4e9$export$3a3ade082c590099 = {
    Any: null,
    Minute: -1,
    Second: 0,
    Millisecond: 3,
    Microsecond: 6
};
function $d7427071dbf0b4e9$export$a62adeb27809351b(Class, params) {
    return new Class({
        type: "string",
        format: "datetime",
        check: "string_format",
        offset: false,
        local: false,
        precision: null,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$e4f19dd0a54e7a59(Class, params) {
    return new Class({
        type: "string",
        format: "date",
        check: "string_format",
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$36f9f051d5e817c(Class, params) {
    return new Class({
        type: "string",
        format: "time",
        check: "string_format",
        precision: null,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$7d70539c76fbff4(Class, params) {
    return new Class({
        type: "string",
        format: "duration",
        check: "string_format",
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$9249bb0b45639623(Class, params) {
    return new Class($d7427071dbf0b4e9$var$snapshotChecks({
        type: "number",
        checks: [],
        ...$ciVeX.normalizeParams(params)
    }));
}
function $d7427071dbf0b4e9$export$272511620e4661dd(Class, params) {
    return new Class($d7427071dbf0b4e9$var$snapshotChecks({
        type: "number",
        coerce: true,
        checks: [],
        ...$ciVeX.normalizeParams(params)
    }));
}
function $d7427071dbf0b4e9$export$3d5b343b1f51efdd(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "safeint",
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$656ad65d6cf64174(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "float32",
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$9ddff8176107cc11(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "float64",
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$5ec965fd114a2f9f(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "int32",
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$a43c28c6e86e066e(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "uint32",
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$e23c41ce5ce2db39(Class, params) {
    return new Class({
        type: "boolean",
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$c3eb0e1c7c887e5c(Class, params) {
    return new Class({
        type: "boolean",
        coerce: true,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$c96ff33878177e4c(Class, params) {
    return new Class({
        type: "bigint",
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$8ff745acc355d077(Class, params) {
    return new Class({
        type: "bigint",
        coerce: true,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$cb7d3ec922804f3f(Class, params) {
    return new Class({
        type: "bigint",
        check: "bigint_format",
        abort: false,
        format: "int64",
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$c51606f0dfa0f5a1(Class, params) {
    return new Class({
        type: "bigint",
        check: "bigint_format",
        abort: false,
        format: "uint64",
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$a8f93f5b7c030e84(Class, params) {
    return new Class({
        type: "symbol",
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$60e4c9fe67803d40(Class, params) {
    return new Class({
        type: "undefined",
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$a2cbb38cda512d16(Class, params) {
    return new Class({
        type: "null",
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$4678886173313220(Class) {
    return new Class({
        type: "any"
    });
}
function $d7427071dbf0b4e9$export$e0ed508a47e00801(Class) {
    return new Class({
        type: "unknown"
    });
}
function $d7427071dbf0b4e9$export$887f43204ffc2a69(Class, params) {
    return new Class({
        type: "never",
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$9480825d3c8e9ad6(Class, params) {
    return new Class({
        type: "void",
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$da799735c76175a(Class, params) {
    return new Class({
        type: "date",
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$2efeac445ea43f33(Class, params) {
    return new Class({
        type: "date",
        coerce: true,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$a5e7e1f8491a5e50(Class, params) {
    return new Class({
        type: "nan",
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$2a42c74e76a068a(value, params) {
    return new $b9Fsy.$ZodCheckLessThan({
        check: "less_than",
        ...$ciVeX.normalizeParams(params),
        value: value,
        inclusive: false
    });
}
function $d7427071dbf0b4e9$export$7a060cf3d60b84a6(value, params) {
    return new $b9Fsy.$ZodCheckLessThan({
        check: "less_than",
        ...$ciVeX.normalizeParams(params),
        value: value,
        inclusive: true
    });
}
function $d7427071dbf0b4e9$export$7582466e3ab4d25b(value, params) {
    return new $b9Fsy.$ZodCheckGreaterThan({
        check: "greater_than",
        ...$ciVeX.normalizeParams(params),
        value: value,
        inclusive: false
    });
}
function $d7427071dbf0b4e9$export$a1c6d8834a3b19c9(value, params) {
    return new $b9Fsy.$ZodCheckGreaterThan({
        check: "greater_than",
        ...$ciVeX.normalizeParams(params),
        value: value,
        inclusive: true
    });
}
function $d7427071dbf0b4e9$export$ddfc6f0a2e49a568(params) {
    return $d7427071dbf0b4e9$export$7582466e3ab4d25b(0, params);
}
function $d7427071dbf0b4e9$export$d30568dda7134ca5(params) {
    return $d7427071dbf0b4e9$export$2a42c74e76a068a(0, params);
}
function $d7427071dbf0b4e9$export$c3e51eea33419c94(params) {
    return $d7427071dbf0b4e9$export$7a060cf3d60b84a6(0, params);
}
function $d7427071dbf0b4e9$export$93ec5f75848b1928(params) {
    return $d7427071dbf0b4e9$export$a1c6d8834a3b19c9(0, params);
}
function $d7427071dbf0b4e9$export$c41e40f80e978ab1(value, params) {
    return new $b9Fsy.$ZodCheckMultipleOf({
        check: "multiple_of",
        ...$ciVeX.normalizeParams(params),
        value: value
    });
}
function $d7427071dbf0b4e9$export$3eed6ccb98bc18db(maximum, params) {
    return new $b9Fsy.$ZodCheckMaxSize({
        check: "max_size",
        ...$ciVeX.normalizeParams(params),
        maximum: maximum
    });
}
function $d7427071dbf0b4e9$export$e379713268c2c18a(minimum, params) {
    return new $b9Fsy.$ZodCheckMinSize({
        check: "min_size",
        ...$ciVeX.normalizeParams(params),
        minimum: minimum
    });
}
function $d7427071dbf0b4e9$export$2621565b966a8d23(size, params) {
    return new $b9Fsy.$ZodCheckSizeEquals({
        check: "size_equals",
        ...$ciVeX.normalizeParams(params),
        size: size
    });
}
function $d7427071dbf0b4e9$export$ec76627108655a22(maximum, params) {
    const ch = new $b9Fsy.$ZodCheckMaxLength({
        check: "max_length",
        ...$ciVeX.normalizeParams(params),
        maximum: maximum
    });
    return ch;
}
function $d7427071dbf0b4e9$export$21f6711a906c1450(minimum, params) {
    return new $b9Fsy.$ZodCheckMinLength({
        check: "min_length",
        ...$ciVeX.normalizeParams(params),
        minimum: minimum
    });
}
function $d7427071dbf0b4e9$export$620b9f7ab17ff8a9(length, params) {
    return new $b9Fsy.$ZodCheckLengthEquals({
        check: "length_equals",
        ...$ciVeX.normalizeParams(params),
        length: length
    });
}
function $d7427071dbf0b4e9$export$c4768a1bd8f8393(pattern, params) {
    return new $b9Fsy.$ZodCheckRegex({
        check: "string_format",
        format: "regex",
        ...$ciVeX.normalizeParams(params),
        pattern: pattern
    });
}
function $d7427071dbf0b4e9$export$ea67c3edeec85c63(params) {
    return new $b9Fsy.$ZodCheckLowerCase({
        check: "string_format",
        format: "lowercase",
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$2998381b41c6902a(params) {
    return new $b9Fsy.$ZodCheckUpperCase({
        check: "string_format",
        format: "uppercase",
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$fccf016a6caa651d(includes, params) {
    return new $b9Fsy.$ZodCheckIncludes({
        check: "string_format",
        format: "includes",
        ...$ciVeX.normalizeParams(params),
        includes: includes
    });
}
function $d7427071dbf0b4e9$export$2f37aaf99060de76(prefix, params) {
    return new $b9Fsy.$ZodCheckStartsWith({
        check: "string_format",
        format: "starts_with",
        ...$ciVeX.normalizeParams(params),
        prefix: prefix
    });
}
function $d7427071dbf0b4e9$export$eaeaa2fcd833167e(suffix, params) {
    return new $b9Fsy.$ZodCheckEndsWith({
        check: "string_format",
        format: "ends_with",
        ...$ciVeX.normalizeParams(params),
        suffix: suffix
    });
}
function $d7427071dbf0b4e9$export$537db06738ee7f1b(property, schema, params) {
    return new $b9Fsy.$ZodCheckProperty({
        check: "property",
        property: property,
        schema: schema,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$a72788ae987f5bef(shape, params) {
    return new $b9Fsy.$ZodCheckProperties({
        check: "properties",
        shape: shape,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$267177285a1a8b37(types, params) {
    return new $b9Fsy.$ZodCheckMimeType({
        check: "mime_type",
        mime: types,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$aeea8f004f34f8c2(tx) {
    return new $b9Fsy.$ZodCheckOverwrite({
        check: "overwrite",
        tx: tx
    });
}
function $d7427071dbf0b4e9$export$2b99bb23a814f78e(form) {
    return $d7427071dbf0b4e9$export$aeea8f004f34f8c2((input)=>input.normalize(form));
}
function $d7427071dbf0b4e9$export$8be2de0b60774d1e() {
    return $d7427071dbf0b4e9$export$aeea8f004f34f8c2((input)=>input.trim());
}
function $d7427071dbf0b4e9$export$d9cfe939403a2525() {
    return $d7427071dbf0b4e9$export$aeea8f004f34f8c2((input)=>input.toLowerCase());
}
function $d7427071dbf0b4e9$export$cf76ef1ae9e9944e() {
    return $d7427071dbf0b4e9$export$aeea8f004f34f8c2((input)=>input.toUpperCase());
}
function $d7427071dbf0b4e9$export$2801993b93f3c232() {
    return $d7427071dbf0b4e9$export$aeea8f004f34f8c2((input)=>$ciVeX.slugify(input));
}
function $d7427071dbf0b4e9$export$4ea446333e3db634(Class, element, params) {
    return new Class({
        type: "array",
        element: element,
        // get element() {
        //   return element;
        // },
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$48eec03fd15d025b(Class, options, params) {
    return new Class({
        type: "union",
        options: options,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$d941708f3b69bf5a(Class, options, params) {
    return new Class({
        type: "union",
        options: options,
        inclusive: false,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$ffbf51421b0acee1(Class, discriminator, options, params) {
    return new Class({
        type: "union",
        options: options,
        discriminator: discriminator,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$3d0d84e16c5ea809(Class, left, right) {
    return new Class({
        type: "intersection",
        left: left,
        right: right
    });
}
function $d7427071dbf0b4e9$export$a13693bfb304605a(Class, items, _paramsOrRest, _params) {
    const hasRest = _paramsOrRest instanceof $4S00O.$ZodType;
    const params = hasRest ? _params : _paramsOrRest;
    const rest = hasRest ? _paramsOrRest : null;
    return new Class({
        type: "tuple",
        items: items,
        rest: rest,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$64440e3f2e29d7bc(Class, keyType, valueType, params) {
    return new Class({
        type: "record",
        keyType: keyType,
        valueType: valueType,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$a0135aecf4a782ab(Class, keyType, valueType, params) {
    return new Class({
        type: "map",
        keyType: keyType,
        valueType: valueType,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$c37fd9e9b598996d(Class, valueType, params) {
    return new Class({
        type: "set",
        valueType: valueType,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$3290a9b46bcfecc1(Class, values, params) {
    const entries = Array.isArray(values) ? Object.fromEntries(values.map((v)=>[
            v,
            v
        ])) : values;
    // if (Array.isArray(values)) {
    //   for (const value of values) {
    //     entries[value] = value;
    //   }
    // } else {
    //   Object.assign(entries, values);
    // }
    // const entries: util.EnumLike = {};
    // for (const val of values) {
    //   entries[val] = val;
    // }
    return new Class({
        type: "enum",
        entries: entries,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$6b94bba2375b9e3d(Class, entries, params) {
    return new Class({
        type: "enum",
        entries: entries,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$a03e276eec27de8b(Class, value, params) {
    return new Class({
        type: "literal",
        values: Array.isArray(value) ? value : [
            value
        ],
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$e335cd0b9f8bab1e(Class, params) {
    return new Class({
        type: "file",
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$fa4a3df4db7f3166(Class, fn) {
    return new Class({
        type: "transform",
        transform: fn
    });
}
function $d7427071dbf0b4e9$export$6d07c57dda792495(Class, innerType) {
    return new Class({
        type: "optional",
        innerType: innerType
    });
}
function $d7427071dbf0b4e9$export$4e46ee4534ff341d(Class, innerType) {
    return new Class({
        type: "nullable",
        innerType: innerType
    });
}
function $d7427071dbf0b4e9$export$d4b0f68d0d916971(Class, innerType, defaultValue) {
    return new Class({
        type: "default",
        innerType: innerType,
        get defaultValue () {
            return typeof defaultValue === "function" ? defaultValue() : $ciVeX.shallowClone(defaultValue);
        }
    });
}
function $d7427071dbf0b4e9$export$24cb0533b28b009b(Class, innerType, params) {
    return new Class({
        type: "nonoptional",
        innerType: innerType,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$6f570707f72cba02(Class, innerType) {
    return new Class({
        type: "success",
        innerType: innerType
    });
}
function $d7427071dbf0b4e9$export$7f43fa37c3d8a0b3(Class, innerType, catchValue) {
    return new Class({
        type: "catch",
        innerType: innerType,
        catchValue: typeof catchValue === "function" ? catchValue : $ciVeX.constantCatch(catchValue)
    });
}
function $d7427071dbf0b4e9$export$fc24e256ce7b145(Class, in_, out) {
    return new Class({
        type: "pipe",
        in: in_,
        out: out
    });
}
function $d7427071dbf0b4e9$export$4fe7ff2cfb7a6dd7(Class, innerType) {
    return new Class({
        type: "readonly",
        innerType: innerType
    });
}
function $d7427071dbf0b4e9$export$f30d99994777b6d(Class, parts, params) {
    return new Class({
        type: "template_literal",
        parts: parts,
        ...$ciVeX.normalizeParams(params)
    });
}
function $d7427071dbf0b4e9$export$137d76f65e4bcae1(Class, getter) {
    return new Class({
        type: "lazy",
        getter: getter
    });
}
function $d7427071dbf0b4e9$export$d91bbb815217feb6(Class, innerType) {
    return new Class({
        type: "promise",
        innerType: innerType
    });
}
function $d7427071dbf0b4e9$export$8bfc2ce1398e3071(Class, fn, _params) {
    const norm = $ciVeX.normalizeParams(_params);
    norm.abort ?? (norm.abort = true); // default to abort:false
    const schema = new Class({
        type: "custom",
        check: "custom",
        fn: fn,
        ...norm
    });
    return schema;
}
function $d7427071dbf0b4e9$export$ac822e05051812e1(Class, fn, _params) {
    const schema = new Class({
        type: "custom",
        check: "custom",
        fn: fn,
        ...$ciVeX.normalizeParams(_params)
    });
    return schema;
}
function $d7427071dbf0b4e9$export$f2b01ecb843d7ab9(fn, params) {
    const ch = $d7427071dbf0b4e9$export$d37145829e4ff88e((payload)=>{
        payload.addIssue = (issue)=>{
            if (typeof issue === "string") payload.issues.push($ciVeX.issue(issue, payload.value, ch._zod.def));
            else {
                // for Zod 3 backwards compatibility
                const _issue = issue;
                if (_issue.fatal) _issue.continue = false;
                _issue.code ?? (_issue.code = "custom");
                if (!("input" in _issue)) _issue.input = payload.value;
                _issue.inst ?? (_issue.inst = ch);
                _issue.continue ?? (_issue.continue = !ch._zod.def.abort); // abort is always undefined, so this is always true...
                payload.issues.push($ciVeX.issue(_issue));
            }
        };
        return fn(payload.value, payload);
    }, params);
    return ch;
}
function $d7427071dbf0b4e9$export$d37145829e4ff88e(fn, params) {
    const ch = new $b9Fsy.$ZodCheck({
        check: "custom",
        ...$ciVeX.normalizeParams(params)
    });
    ch._zod.check = fn;
    return ch;
}
function $d7427071dbf0b4e9$export$cd5450f3a47e3789(description) {
    const ch = new $b9Fsy.$ZodCheck({
        check: "describe"
    });
    ch._zod.onattach = [
        (inst)=>{
            const existing = $5ehZO.globalRegistry.get(inst) ?? {};
            $5ehZO.globalRegistry.add(inst, {
                ...existing,
                description: description
            });
        }
    ];
    ch._zod.check = ()=>{}; // no-op check
    return ch;
}
function $d7427071dbf0b4e9$export$6990040ee07315(metadata) {
    const ch = new $b9Fsy.$ZodCheck({
        check: "meta"
    });
    ch._zod.onattach = [
        (inst)=>{
            const existing = $5ehZO.globalRegistry.get(inst) ?? {};
            $5ehZO.globalRegistry.add(inst, {
                ...existing,
                ...metadata
            });
        }
    ];
    ch._zod.check = ()=>{}; // no-op check
    return ch;
}
function $d7427071dbf0b4e9$export$a75528509e3a7006(Classes, _params) {
    const params = $ciVeX.normalizeParams(_params);
    let truthyArray = params.truthy ?? [
        "true",
        "1",
        "yes",
        "on",
        "y",
        "enabled"
    ];
    let falsyArray = params.falsy ?? [
        "false",
        "0",
        "no",
        "off",
        "n",
        "disabled"
    ];
    if (params.case !== "sensitive") {
        truthyArray = truthyArray.map((v)=>typeof v === "string" ? v.toLowerCase() : v);
        falsyArray = falsyArray.map((v)=>typeof v === "string" ? v.toLowerCase() : v);
    }
    const truthySet = new Set(truthyArray);
    const falsySet = new Set(falsyArray);
    const _Codec = Classes.Codec ?? $4S00O.$ZodCodec;
    const _Boolean = Classes.Boolean ?? $4S00O.$ZodBoolean;
    const _String = Classes.String ?? $4S00O.$ZodString;
    const stringSchema = new _String({
        type: "string",
        error: params.error
    });
    const booleanSchema = new _Boolean({
        type: "boolean",
        error: params.error
    });
    const codec = new _Codec({
        type: "pipe",
        in: stringSchema,
        out: booleanSchema,
        transform: (input, payload)=>{
            let data = input;
            if (params.case !== "sensitive") data = data.toLowerCase();
            if (truthySet.has(data)) return true;
            else if (falsySet.has(data)) return false;
            else {
                payload.issues.push({
                    code: "invalid_value",
                    expected: "stringbool",
                    values: [
                        ...truthySet,
                        ...falsySet
                    ],
                    input: payload.value,
                    inst: codec,
                    continue: false
                });
                return {};
            }
        },
        reverseTransform: (input, _payload)=>{
            if (input === true) return truthyArray[0] || "true";
            else return falsyArray[0] || "false";
        },
        error: params.error
    });
    codec._zod.bag.truthy = truthyArray;
    codec._zod.bag.falsy = falsyArray;
    codec._zod.bag.case = params.case ?? "insensitive";
    return codec;
}
function $d7427071dbf0b4e9$export$e25dde89ba546b88(Class, format, fnOrRegex, _params = {}) {
    const params = $ciVeX.normalizeParams(_params);
    const def = {
        check: "string_format",
        type: "string",
        format: format,
        fn: typeof fnOrRegex === "function" ? fnOrRegex : (val)=>fnOrRegex.test(val),
        ...params
    };
    if (fnOrRegex instanceof RegExp) def.pattern = fnOrRegex;
    const inst = new Class(def);
    return inst;
}

});
parcelRegister("b9Fsy", function(module, exports) {
$parcel$export(module.exports, "$ZodCheck", () => $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c);
$parcel$export(module.exports, "$ZodCheckLessThan", () => $81f0b1f6d5b9fb58$export$294415ecbdd02022);
$parcel$export(module.exports, "$ZodCheckGreaterThan", () => $81f0b1f6d5b9fb58$export$8b670f58decbca18);
$parcel$export(module.exports, "$ZodCheckMultipleOf", () => $81f0b1f6d5b9fb58$export$ae602e11c1dd0628);
$parcel$export(module.exports, "$ZodCheckNumberFormat", () => $81f0b1f6d5b9fb58$export$5c26c85ad6aed3e8);
$parcel$export(module.exports, "$ZodCheckBigIntFormat", () => $81f0b1f6d5b9fb58$export$a0a6d75ce7dc4d36);
$parcel$export(module.exports, "$ZodCheckMaxSize", () => $81f0b1f6d5b9fb58$export$b3cec505675cf50c);
$parcel$export(module.exports, "$ZodCheckMinSize", () => $81f0b1f6d5b9fb58$export$59fb0a2e7217c42b);
$parcel$export(module.exports, "$ZodCheckSizeEquals", () => $81f0b1f6d5b9fb58$export$af532c490f33cd47);
$parcel$export(module.exports, "$ZodCheckMaxLength", () => $81f0b1f6d5b9fb58$export$b07b097887f4c15a);
$parcel$export(module.exports, "$ZodCheckMinLength", () => $81f0b1f6d5b9fb58$export$cd5336aa96b8417c);
$parcel$export(module.exports, "$ZodCheckLengthEquals", () => $81f0b1f6d5b9fb58$export$ccdb9b9d477068fb);
$parcel$export(module.exports, "$ZodCheckStringFormat", () => $81f0b1f6d5b9fb58$export$e0c7f6847ab1b629);
$parcel$export(module.exports, "$ZodCheckRegex", () => $81f0b1f6d5b9fb58$export$6faea86ff718d6df);
$parcel$export(module.exports, "$ZodCheckLowerCase", () => $81f0b1f6d5b9fb58$export$e18e268bd5c9f27a);
$parcel$export(module.exports, "$ZodCheckUpperCase", () => $81f0b1f6d5b9fb58$export$6d0944a5127e820a);
$parcel$export(module.exports, "$ZodCheckIncludes", () => $81f0b1f6d5b9fb58$export$600021c28f0498dc);
$parcel$export(module.exports, "$ZodCheckStartsWith", () => $81f0b1f6d5b9fb58$export$8e83a74b4b83cc62);
$parcel$export(module.exports, "$ZodCheckEndsWith", () => $81f0b1f6d5b9fb58$export$4a10f85c6af4e92);
$parcel$export(module.exports, "$ZodCheckProperty", () => $81f0b1f6d5b9fb58$export$d36a4eecd766dbc0);
$parcel$export(module.exports, "$ZodCheckProperties", () => $81f0b1f6d5b9fb58$export$f344fa45e933b617);
$parcel$export(module.exports, "$ZodCheckMimeType", () => $81f0b1f6d5b9fb58$export$5546147f1877f806);
$parcel$export(module.exports, "$ZodCheckOverwrite", () => $81f0b1f6d5b9fb58$export$1bda1934456013d3);
// import { $ZodType } from "./schemas.js";

var $igTWG = parcelRequire("igTWG");

var $8S8Wz = parcelRequire("8S8Wz");

var $ciVeX = parcelRequire("ciVeX");
const $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c = /*@__PURE__*/ $igTWG.$constructor("$ZodCheck", (inst, def)=>{
    var _a;
    inst._zod ?? (inst._zod = {});
    inst._zod.def = def;
    (_a = inst._zod).onattach ?? (_a.onattach = []);
});
/** Default `when` for size-based checks: run only on non-nullish values with a `size`. */ const $81f0b1f6d5b9fb58$var$_whenHasSize = (payload)=>{
    const val = payload.value;
    return !$ciVeX.nullish(val) && val.size !== undefined;
};
/** Default `when` for length-based checks: run only on non-nullish values with a `length`. */ const $81f0b1f6d5b9fb58$var$_whenHasLength = (payload)=>{
    const val = payload.value;
    return !$ciVeX.nullish(val) && val.length !== undefined;
};
const $81f0b1f6d5b9fb58$var$numericOriginMap = {
    number: "number",
    bigint: "bigint",
    object: "date"
};
const $81f0b1f6d5b9fb58$export$294415ecbdd02022 = /*@__PURE__*/ $igTWG.$constructor("$ZodCheckLessThan", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    const origin = $81f0b1f6d5b9fb58$var$numericOriginMap[typeof def.value];
    inst._zod.check = (payload)=>{
        if (def.inclusive ? payload.value <= def.value : payload.value < def.value) return;
        payload.issues.push({
            origin: $81f0b1f6d5b9fb58$var$numericOriginMap[typeof payload.value] ?? origin,
            code: "too_big",
            maximum: typeof def.value === "object" ? def.value.getTime() : def.value,
            input: payload.value,
            inclusive: def.inclusive,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$8b670f58decbca18 = /*@__PURE__*/ $igTWG.$constructor("$ZodCheckGreaterThan", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    const origin = $81f0b1f6d5b9fb58$var$numericOriginMap[typeof def.value];
    inst._zod.check = (payload)=>{
        if (def.inclusive ? payload.value >= def.value : payload.value > def.value) return;
        payload.issues.push({
            origin: $81f0b1f6d5b9fb58$var$numericOriginMap[typeof payload.value] ?? origin,
            code: "too_small",
            minimum: typeof def.value === "object" ? def.value.getTime() : def.value,
            input: payload.value,
            inclusive: def.inclusive,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$ae602e11c1dd0628 = /*@__PURE__*/ $igTWG.$constructor("$ZodCheckMultipleOf", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    inst._zod.check = (payload)=>{
        if (typeof payload.value !== typeof def.value) throw new Error("Cannot mix number and bigint in multiple_of check.");
        const isMultiple = typeof payload.value === "bigint" ? def.value !== BigInt(0) && payload.value % def.value === BigInt(0) : $ciVeX.floatSafeRemainder(payload.value, def.value) === 0;
        if (isMultiple) return;
        payload.issues.push({
            origin: typeof payload.value,
            code: "not_multiple_of",
            divisor: def.value,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$5c26c85ad6aed3e8 = /*@__PURE__*/ $igTWG.$constructor("$ZodCheckNumberFormat", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def); // no format checks
    def.format = def.format || "float64";
    const isInt = def.format?.includes("int");
    const origin = isInt ? "int" : "number";
    const [minimum, maximum] = $ciVeX.NUMBER_FORMAT_RANGES[def.format];
    inst._zod.check = (payload)=>{
        const input = payload.value;
        if (isInt) {
            if (!Number.isInteger(input)) {
                // invalid_format issue
                // payload.issues.push({
                //   expected: def.format,
                //   format: def.format,
                //   code: "invalid_format",
                //   input,
                //   inst,
                // });
                // invalid_type issue
                payload.issues.push({
                    expected: origin,
                    format: def.format,
                    code: "invalid_type",
                    continue: false,
                    input: input,
                    inst: inst
                });
                return;
            // not_multiple_of issue
            // payload.issues.push({
            //   code: "not_multiple_of",
            //   origin: "number",
            //   input,
            //   inst,
            //   divisor: 1,
            // });
            }
            if (!Number.isSafeInteger(input)) {
                if (input > 0) // too_big
                payload.issues.push({
                    input: input,
                    code: "too_big",
                    maximum: Number.MAX_SAFE_INTEGER,
                    note: "Integers must be within the safe integer range.",
                    inst: inst,
                    origin: origin,
                    inclusive: true,
                    continue: !def.abort
                });
                else // too_small
                payload.issues.push({
                    input: input,
                    code: "too_small",
                    minimum: Number.MIN_SAFE_INTEGER,
                    note: "Integers must be within the safe integer range.",
                    inst: inst,
                    origin: origin,
                    inclusive: true,
                    continue: !def.abort
                });
                return;
            }
        }
        if (input < minimum) payload.issues.push({
            origin: "number",
            input: input,
            code: "too_small",
            minimum: minimum,
            inclusive: true,
            inst: inst,
            continue: !def.abort
        });
        if (input > maximum) payload.issues.push({
            origin: "number",
            input: input,
            code: "too_big",
            maximum: maximum,
            inclusive: true,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$a0a6d75ce7dc4d36 = /*@__PURE__*/ $igTWG.$constructor("$ZodCheckBigIntFormat", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def); // no format checks
    const [minimum, maximum] = $ciVeX.BIGINT_FORMAT_RANGES[def.format];
    inst._zod.check = (payload)=>{
        const input = payload.value;
        if (input < minimum) payload.issues.push({
            origin: "bigint",
            input: input,
            code: "too_small",
            minimum: minimum,
            inclusive: true,
            inst: inst,
            continue: !def.abort
        });
        if (input > maximum) payload.issues.push({
            origin: "bigint",
            input: input,
            code: "too_big",
            maximum: maximum,
            inclusive: true,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$b3cec505675cf50c = /*@__PURE__*/ $igTWG.$constructor("$ZodCheckMaxSize", (inst, def)=>{
    var _a;
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = $81f0b1f6d5b9fb58$var$_whenHasSize);
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const size = input.size;
        if (size <= def.maximum) return;
        payload.issues.push({
            origin: $ciVeX.getSizableOrigin(input),
            code: "too_big",
            maximum: def.maximum,
            inclusive: true,
            input: input,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$59fb0a2e7217c42b = /*@__PURE__*/ $igTWG.$constructor("$ZodCheckMinSize", (inst, def)=>{
    var _a;
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = $81f0b1f6d5b9fb58$var$_whenHasSize);
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const size = input.size;
        if (size >= def.minimum) return;
        payload.issues.push({
            origin: $ciVeX.getSizableOrigin(input),
            code: "too_small",
            minimum: def.minimum,
            inclusive: true,
            input: input,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$af532c490f33cd47 = /*@__PURE__*/ $igTWG.$constructor("$ZodCheckSizeEquals", (inst, def)=>{
    var _a;
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = $81f0b1f6d5b9fb58$var$_whenHasSize);
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const size = input.size;
        if (size === def.size) return;
        const tooBig = size > def.size;
        payload.issues.push({
            origin: $ciVeX.getSizableOrigin(input),
            ...tooBig ? {
                code: "too_big",
                maximum: def.size
            } : {
                code: "too_small",
                minimum: def.size
            },
            inclusive: true,
            exact: true,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$b07b097887f4c15a = /*@__PURE__*/ $igTWG.$constructor("$ZodCheckMaxLength", (inst, def)=>{
    var _a;
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = $81f0b1f6d5b9fb58$var$_whenHasLength);
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const units = input.length;
        // Strings are measured in Unicode code points, not UTF-16 units. A code point is at most two units, so a string that already fits in units fits in code points; only an overflow has to be counted.
        const length = typeof input === "string" && units > def.maximum ? $ciVeX.codePointLength(input) : units;
        if (length <= def.maximum) return;
        const origin = $ciVeX.getLengthableOrigin(input);
        payload.issues.push({
            origin: origin,
            code: "too_big",
            maximum: def.maximum,
            inclusive: true,
            input: input,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$cd5336aa96b8417c = /*@__PURE__*/ $igTWG.$constructor("$ZodCheckMinLength", (inst, def)=>{
    var _a;
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = $81f0b1f6d5b9fb58$var$_whenHasLength);
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const units = input.length;
        // A code point is one or two UTF-16 units, so fewer units than the floor can never reach it and twice the floor always clears it. Only in between is the exact count in doubt.
        const length = typeof input === "string" && units >= def.minimum && units < def.minimum * 2 ? $ciVeX.codePointLength(input) : units;
        if (length >= def.minimum) return;
        const origin = $ciVeX.getLengthableOrigin(input);
        payload.issues.push({
            origin: origin,
            code: "too_small",
            minimum: def.minimum,
            inclusive: true,
            input: input,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$ccdb9b9d477068fb = /*@__PURE__*/ $igTWG.$constructor("$ZodCheckLengthEquals", (inst, def)=>{
    var _a;
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = $81f0b1f6d5b9fb58$var$_whenHasLength);
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const units = input.length;
        // A code point is one or two UTF-16 units, so outside `[length, length * 2]` units the target is missed either way — and missed in the same direction in both measures.
        const length = typeof input === "string" && units >= def.length && units <= def.length * 2 ? $ciVeX.codePointLength(input) : units;
        if (length === def.length) return;
        const origin = $ciVeX.getLengthableOrigin(input);
        const tooBig = length > def.length;
        payload.issues.push({
            origin: origin,
            ...tooBig ? {
                code: "too_big",
                maximum: def.length
            } : {
                code: "too_small",
                minimum: def.length
            },
            inclusive: true,
            exact: true,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$e0c7f6847ab1b629 = /*@__PURE__*/ $igTWG.$constructor("$ZodCheckStringFormat", (inst, def)=>{
    var _a, _b;
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    if (def.pattern) (_a = inst._zod).check ?? (_a.check = (payload)=>{
        def.pattern.lastIndex = 0;
        if (def.pattern.test(payload.value)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: def.format,
            input: payload.value,
            ...def.pattern ? {
                pattern: def.pattern.toString()
            } : {},
            inst: inst,
            continue: !def.abort
        });
    });
    else (_b = inst._zod).check ?? (_b.check = ()=>{});
});
const $81f0b1f6d5b9fb58$export$6faea86ff718d6df = /*@__PURE__*/ $igTWG.$constructor("$ZodCheckRegex", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$e0c7f6847ab1b629.init(inst, def);
    inst._zod.check = (payload)=>{
        def.pattern.lastIndex = 0;
        if (def.pattern.test(payload.value)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "regex",
            input: payload.value,
            pattern: def.pattern.toString(),
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$e18e268bd5c9f27a = /*@__PURE__*/ $igTWG.$constructor("$ZodCheckLowerCase", (inst, def)=>{
    def.pattern ?? (def.pattern = $8S8Wz.lowercase);
    $81f0b1f6d5b9fb58$export$e0c7f6847ab1b629.init(inst, def);
});
const $81f0b1f6d5b9fb58$export$6d0944a5127e820a = /*@__PURE__*/ $igTWG.$constructor("$ZodCheckUpperCase", (inst, def)=>{
    def.pattern ?? (def.pattern = $8S8Wz.uppercase);
    $81f0b1f6d5b9fb58$export$e0c7f6847ab1b629.init(inst, def);
});
const $81f0b1f6d5b9fb58$export$600021c28f0498dc = /*@__PURE__*/ $igTWG.$constructor("$ZodCheckIncludes", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    const escapedRegex = $ciVeX.escapeRegex(def.includes);
    // `String.prototype.includes(sub, position)` matches `sub` at `position`
    // OR LATER, so the pattern must allow at least `position` leading chars
    // (`{N,}`), not exactly `position` chars (`{N}`).
    const pattern = new RegExp(typeof def.position === "number" ? `^.{${def.position},}${escapedRegex}` : escapedRegex);
    def.pattern = pattern;
    inst._zod.check = (payload)=>{
        if (payload.value.includes(def.includes, def.position)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "includes",
            includes: def.includes,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$8e83a74b4b83cc62 = /*@__PURE__*/ $igTWG.$constructor("$ZodCheckStartsWith", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    const pattern = new RegExp(`^${$ciVeX.escapeRegex(def.prefix)}.*`);
    def.pattern ?? (def.pattern = pattern);
    inst._zod.check = (payload)=>{
        if (payload.value.startsWith(def.prefix)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "starts_with",
            prefix: def.prefix,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$4a10f85c6af4e92 = /*@__PURE__*/ $igTWG.$constructor("$ZodCheckEndsWith", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    const pattern = new RegExp(`.*${$ciVeX.escapeRegex(def.suffix)}$`);
    def.pattern ?? (def.pattern = pattern);
    inst._zod.check = (payload)=>{
        if (payload.value.endsWith(def.suffix)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "ends_with",
            suffix: def.suffix,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
///////////////////////////////////
/////    $ZodCheckProperty    /////
///////////////////////////////////
function $81f0b1f6d5b9fb58$var$handleCheckPropertyResult(result, payload, property) {
    if (result.issues.length) payload.issues.push(...$ciVeX.prefixIssues(property, result.issues));
}
const $81f0b1f6d5b9fb58$export$d36a4eecd766dbc0 = /*@__PURE__*/ $igTWG.$constructor("$ZodCheckProperty", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    inst._zod.check = (payload)=>{
        const result = def.schema._zod.run({
            value: payload.value[def.property],
            issues: []
        }, {});
        if (result instanceof Promise) return result.then((result)=>$81f0b1f6d5b9fb58$var$handleCheckPropertyResult(result, payload, def.property));
        $81f0b1f6d5b9fb58$var$handleCheckPropertyResult(result, payload, def.property);
        return;
    };
});
const $81f0b1f6d5b9fb58$export$f344fa45e933b617 = /*@__PURE__*/ $igTWG.$constructor("$ZodCheckProperties", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    $ciVeX.hide(inst, Symbol.iterator, function*() {
        yield inst;
    });
    // key and schema snapshotted together: reading one live and the other cached lets a later mutation of the caller's shape object pair a stale key with a missing schema
    let entries;
    inst._zod.check = (payload)=>{
        // the base schema already typed the value, so only a nullish one is rejected here: the properties read on a primitive too, matching z.property() on a string's length
        if (payload.value == null) {
            payload.issues.push({
                expected: "object",
                code: "invalid_type",
                input: payload.value,
                inst: inst
            });
            return undefined;
        }
        entries ?? (entries = Reflect.ownKeys(def.shape).map((key)=>[
                key,
                def.shape[key]
            ]));
        const input = payload.value;
        let proms;
        for (const [key, schema] of entries){
            const result = schema._zod.run({
                value: input[key],
                issues: []
            }, {});
            if (result instanceof Promise) {
                proms ?? (proms = []);
                proms.push(result.then((result)=>$81f0b1f6d5b9fb58$var$handleCheckPropertyResult(result, payload, key)));
            } else $81f0b1f6d5b9fb58$var$handleCheckPropertyResult(result, payload, key);
        }
        if (proms) return Promise.all(proms).then(()=>undefined);
        return undefined;
    };
});
const $81f0b1f6d5b9fb58$export$5546147f1877f806 = /*@__PURE__*/ $igTWG.$constructor("$ZodCheckMimeType", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    const mimeSet = new Set(def.mime);
    inst._zod.check = (payload)=>{
        if (mimeSet.has(payload.value.type)) return;
        payload.issues.push({
            code: "invalid_value",
            values: def.mime,
            input: payload.value.type,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$1bda1934456013d3 = /*@__PURE__*/ $igTWG.$constructor("$ZodCheckOverwrite", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    inst._zod.check = (payload)=>{
        payload.value = def.tx(payload.value);
    };
});

});
parcelRegister("igTWG", function(module, exports) {
$parcel$export(module.exports, "$constructor", () => $d4d51e3b5652b8a4$export$3122533d606194de);
$parcel$export(module.exports, "$ZodAsyncError", () => $d4d51e3b5652b8a4$export$13016bcec11ba196);
$parcel$export(module.exports, "$ZodEncodeError", () => $d4d51e3b5652b8a4$export$a36d4c29b1151bde);
$parcel$export(module.exports, "globalConfig", () => $d4d51e3b5652b8a4$export$f9cd1e43211d8a4a);
$parcel$export(module.exports, "config", () => $d4d51e3b5652b8a4$export$e506a1d27d1eaa20);

var $ciVeX = parcelRequire("ciVeX");
var $d4d51e3b5652b8a4$var$_a;
const $d4d51e3b5652b8a4$export$96c94437c95d7862 = /*@__PURE__*/ Object.freeze({
    status: "aborted"
});
/* Shared descriptor for installing `_zod`; defineProperty reads it
 * synchronously, so reusing one object avoids a per-instance allocation. */ const $d4d51e3b5652b8a4$var$_zodDesc = {
    value: undefined,
    enumerable: false
};
// null where suppressing the capture would be unrecoverable: `parse()` puts the frames back with `captureStackTrace`, so without it the throw would lose its stack. also latched to null once `stackTraceLimit` proves unassignable, which a realm can do at any point by hardening Error
let $d4d51e3b5652b8a4$var$_E = "captureStackTrace" in Error ? Error : null;
// v8 captures a stack trace inside the Error constructor, which dominates a failed parse; costs only the frames, and parse() restores those. the constructor must RUN: Object.create is cheaper and passes instanceof, but Error.isError and util.types.isNativeError check an internal slot
function $d4d51e3b5652b8a4$var$newError(Definition) {
    const E = $d4d51e3b5652b8a4$var$_E;
    if (E) {
        const saved = E.stackTraceLimit;
        if (typeof saved === "number") {
            try {
                E.stackTraceLimit = 0;
            } catch  {
                $d4d51e3b5652b8a4$var$_E = null;
                return new Definition();
            }
            try {
                return new Definition();
            } finally{
                E.stackTraceLimit = saved;
            }
        }
    }
    return new Definition();
}
/*@__NO_SIDE_EFFECTS__*/ function $d4d51e3b5652b8a4$export$3122533d606194de(name, initializer, /** This trait's members, installed once on every prototype that composes it. They cannot be declared in the initializer above: that runs per instance, and the prototype is shared. */ proto, params) {
    // Prototype for this constructor's `_zod` internals. Lazily-derived fields (`values`, `pattern`, `optin`, …) install here once rather than as an accessor on every instance.
    const zodProto = {};
    // Assigning the fields in the constructor body is what gives instances in-object slots; building the object literally and reparenting it costs a second allocation and a generic property copy.
    function Internals(def) {
        this.def = def;
        this.constr = _;
        this.traits = new Set();
    }
    Internals.prototype = zodProto;
    const protoMembers = proto;
    // One trait's members land on every prototype whose chain composes it, so the answer is per prototype rather than per trait.
    const initialized = protoMembers && new WeakSet();
    function init(inst, def) {
        if (!inst._zod) {
            $d4d51e3b5652b8a4$var$_zodDesc.value = new Internals(def);
            try {
                Object.defineProperty(inst, "_zod", $d4d51e3b5652b8a4$var$_zodDesc);
            } finally{
                // Cleared even on throw, so the shared descriptor never leaks one instance's internals into the next.
                $d4d51e3b5652b8a4$var$_zodDesc.value = undefined;
            }
        } else if (inst._zod.traits.has(name)) return;
        inst._zod.traits.add(name);
        initializer(inst, def);
        if (initialized) {
            // `super(def)` from a user subclass gives `this` a prototype the subclass owns, and installing there would overwrite whatever the subclass declared. `constr` built the instance, so its prototype is the one below the subclass's that should carry the members. A receiver whose chain never reaches that prototype installs on its own, which for a plain object handed straight to `init` means `Object.prototype` — unchanged from before.
            const own = Object.getPrototypeOf(inst);
            const ctorProto = inst._zod.constr.prototype;
            let up = own;
            while(up && up !== ctorProto)up = Object.getPrototypeOf(up);
            const target = up ?? own;
            if (!initialized.has(target)) {
                initialized.add(target);
                (0, $ciVeX.members)(target, protoMembers);
            }
        }
        // support prototype modifications; for-in avoids the array allocation of Object.keys on the (usually empty) prototype
        const proto = _.prototype;
        for(const k in proto){
            if (!Object.prototype.hasOwnProperty.call(proto, k)) continue;
            if (!(k in inst)) inst[k] = proto[k].bind(inst);
        }
    }
    // doesn't work if Parent has a constructor with arguments
    const Parent = params?.Parent ?? Object;
    class Definition extends Parent {
    }
    Object.defineProperty(Definition, "name", {
        value: name
    });
    function _(def) {
        const inst = params?.Parent ? $d4d51e3b5652b8a4$var$newError(Definition) : this;
        init(inst, def);
        const deferred = inst._zod.deferred;
        if (deferred) {
            for (const fn of deferred)fn();
            // Released: initializers run once, and the list would otherwise be retained for the schema's lifetime.
            inst._zod.deferred = undefined;
        }
        // Global post-processor hook. Internal: installed by `import "zod/compile"` to enable AOT compilation for every constructed schema. Runs last, once the instance is fully built, because it hands the instance to compile(). The post-processor is expected to be reentrancy-guarded by its own implementation.
        const pp = globalThis.__zod_globalConfig?.postProcessor;
        if (pp) pp(inst);
        return inst;
    }
    Object.defineProperty(_, "init", {
        value: init
    });
    Object.defineProperty(_, Symbol.hasInstance, {
        value: (inst)=>{
            if (params?.Parent && inst instanceof params.Parent) return true;
            return inst?._zod?.traits?.has(name);
        }
    });
    Object.defineProperty(_, "name", {
        value: name
    });
    return _;
}
const $d4d51e3b5652b8a4$export$7d40e40c5b5a6c8f = /*@__PURE__*/ Symbol("zod_brand");
class $d4d51e3b5652b8a4$export$13016bcec11ba196 extends Error {
    constructor(){
        super(`Encountered Promise during synchronous parse. Use .parseAsync() instead.`);
    }
}
class $d4d51e3b5652b8a4$export$a36d4c29b1151bde extends Error {
    constructor(name){
        super(`Encountered unidirectional transform during encode: ${name}`);
        this.name = "ZodEncodeError";
    }
}
($d4d51e3b5652b8a4$var$_a = globalThis).__zod_globalConfig ?? ($d4d51e3b5652b8a4$var$_a.__zod_globalConfig = {});
const $d4d51e3b5652b8a4$export$f9cd1e43211d8a4a = globalThis.__zod_globalConfig;
function $d4d51e3b5652b8a4$export$e506a1d27d1eaa20(newConfig) {
    if (newConfig) Object.assign($d4d51e3b5652b8a4$export$f9cd1e43211d8a4a, newConfig);
    return $d4d51e3b5652b8a4$export$f9cd1e43211d8a4a;
}

});
parcelRegister("ciVeX", function(module, exports) {
$parcel$export(module.exports, "assertEqual", () => $8f5391358ccbeba2$export$27555cdfb0b84a1a);
$parcel$export(module.exports, "assertNotEqual", () => $8f5391358ccbeba2$export$49eedac51f614f7d);
$parcel$export(module.exports, "toZod", () => $8f5391358ccbeba2$export$e95468e219bfe076);
$parcel$export(module.exports, "assertIs", () => $8f5391358ccbeba2$export$6fee1f82edcf4a03);
$parcel$export(module.exports, "assertNever", () => $8f5391358ccbeba2$export$cbadc5a7223772a8);
$parcel$export(module.exports, "assert", () => $8f5391358ccbeba2$export$a7a9523472993e97);
$parcel$export(module.exports, "getEnumValues", () => $8f5391358ccbeba2$export$70a5d58ec00f3c11);
$parcel$export(module.exports, "joinValues", () => $8f5391358ccbeba2$export$e79b744344f50f50);
$parcel$export(module.exports, "stringifyPrimitive", () => $8f5391358ccbeba2$export$5859860f650378f4);
$parcel$export(module.exports, "jsonStringifyReplacer", () => $8f5391358ccbeba2$export$f4defb13cab882b2);
$parcel$export(module.exports, "cached", () => $8f5391358ccbeba2$export$ade7a147f5129058);
$parcel$export(module.exports, "nullish", () => $8f5391358ccbeba2$export$69fd1b70ebae5687);
$parcel$export(module.exports, "cleanRegex", () => $8f5391358ccbeba2$export$78d521805d6c22e4);
$parcel$export(module.exports, "floatSafeRemainder", () => $8f5391358ccbeba2$export$7807b52a740a7117);
$parcel$export(module.exports, "defineLazy", () => $8f5391358ccbeba2$export$d43070a5843c1e2);
$parcel$export(module.exports, "objectClone", () => $8f5391358ccbeba2$export$103832c7353c2f50);
$parcel$export(module.exports, "assignProp", () => $8f5391358ccbeba2$export$2e23d0571746a3fb);
$parcel$export(module.exports, "rawShape", () => $8f5391358ccbeba2$export$fd1f02864f419aa5);
$parcel$export(module.exports, "mergeDefs", () => $8f5391358ccbeba2$export$8969f8c824382d73);
$parcel$export(module.exports, "cloneDef", () => $8f5391358ccbeba2$export$21596dc63856f4c1);
$parcel$export(module.exports, "getElementAtPath", () => $8f5391358ccbeba2$export$4b74d241e1cc7892);
$parcel$export(module.exports, "promiseAllObject", () => $8f5391358ccbeba2$export$3db3408dad58da23);
$parcel$export(module.exports, "randomString", () => $8f5391358ccbeba2$export$7fa8378418b4411e);
$parcel$export(module.exports, "esc", () => $8f5391358ccbeba2$export$a1a11b095f88289a);
$parcel$export(module.exports, "slugify", () => $8f5391358ccbeba2$export$c383cdd2a518017a);
$parcel$export(module.exports, "captureStackTrace", () => $8f5391358ccbeba2$export$756e5cd2d260237b);
$parcel$export(module.exports, "isObject", () => $8f5391358ccbeba2$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "allowsEval", () => $8f5391358ccbeba2$export$1f119cb4d720843b);
$parcel$export(module.exports, "isPlainObject", () => $8f5391358ccbeba2$export$53b83ca8eaab0383);
$parcel$export(module.exports, "shallowClone", () => $8f5391358ccbeba2$export$370e8311c3cdebd9);
$parcel$export(module.exports, "numKeys", () => $8f5391358ccbeba2$export$71667e74ba29447f);
$parcel$export(module.exports, "getParsedType", () => $8f5391358ccbeba2$export$3e9057828ebd5c7a);
$parcel$export(module.exports, "propertyKeyTypes", () => $8f5391358ccbeba2$export$b99c149ecf60be48);
$parcel$export(module.exports, "primitiveTypes", () => $8f5391358ccbeba2$export$c34ffd355f76f0e4);
$parcel$export(module.exports, "escapeRegex", () => $8f5391358ccbeba2$export$104ed90cc1a13451);
$parcel$export(module.exports, "clone", () => $8f5391358ccbeba2$export$9cd59f9826255e47);
$parcel$export(module.exports, "normalizeParams", () => $8f5391358ccbeba2$export$d6b7b25dfacfd300);
$parcel$export(module.exports, "createTransparentProxy", () => $8f5391358ccbeba2$export$6ebbd8d3cb03909b);
$parcel$export(module.exports, "optionalKeys", () => $8f5391358ccbeba2$export$240159211e66adb9);
$parcel$export(module.exports, "NUMBER_FORMAT_RANGES", () => $8f5391358ccbeba2$export$8e78302060ccf26f);
$parcel$export(module.exports, "BIGINT_FORMAT_RANGES", () => $8f5391358ccbeba2$export$538d1d6d5cfcb3b6);
$parcel$export(module.exports, "pick", () => $8f5391358ccbeba2$export$357523c63a2253b9);
$parcel$export(module.exports, "omit", () => $8f5391358ccbeba2$export$30a06c8d3562193f);
$parcel$export(module.exports, "extend", () => $8f5391358ccbeba2$export$8b58be045bf06082);
$parcel$export(module.exports, "safeExtend", () => $8f5391358ccbeba2$export$40c90eb222f50efb);
$parcel$export(module.exports, "merge", () => $8f5391358ccbeba2$export$4950aa0f605343fb);
$parcel$export(module.exports, "partial", () => $8f5391358ccbeba2$export$e45945969df8035a);
$parcel$export(module.exports, "required", () => $8f5391358ccbeba2$export$a7a0278c004aac3f);
$parcel$export(module.exports, "aborted", () => $8f5391358ccbeba2$export$bd75b6d981b9c7f2);
$parcel$export(module.exports, "explicitlyAborted", () => $8f5391358ccbeba2$export$a5fe2d8610d815ec);
$parcel$export(module.exports, "prefixIssues", () => $8f5391358ccbeba2$export$7f35a4c434118b9e);
$parcel$export(module.exports, "unwrapMessage", () => $8f5391358ccbeba2$export$56590e5a47837d61);
$parcel$export(module.exports, "attachSchema", () => $8f5391358ccbeba2$export$5f3bf32142eef856);
$parcel$export(module.exports, "finalizeIssue", () => $8f5391358ccbeba2$export$c5e667bbfc286a9d);
$parcel$export(module.exports, "getSizableOrigin", () => $8f5391358ccbeba2$export$67a7c9c676c45d2b);
$parcel$export(module.exports, "codePointLength", () => $8f5391358ccbeba2$export$89f26bd0a2764944);
$parcel$export(module.exports, "getLengthableOrigin", () => $8f5391358ccbeba2$export$479f5a070abeb487);
$parcel$export(module.exports, "parsedType", () => $8f5391358ccbeba2$export$858d360cf6da2b65);
$parcel$export(module.exports, "issue", () => $8f5391358ccbeba2$export$69ad3503f98be476);
$parcel$export(module.exports, "cleanEnum", () => $8f5391358ccbeba2$export$9b57aa937148f32);
$parcel$export(module.exports, "base64ToUint8Array", () => $8f5391358ccbeba2$export$f01069a3c307e50e);
$parcel$export(module.exports, "uint8ArrayToBase64", () => $8f5391358ccbeba2$export$36bac84b1c2da9c7);
$parcel$export(module.exports, "base64urlToUint8Array", () => $8f5391358ccbeba2$export$b9fa2551f2db41e1);
$parcel$export(module.exports, "uint8ArrayToBase64url", () => $8f5391358ccbeba2$export$975f78e50159df6f);
$parcel$export(module.exports, "hexToUint8Array", () => $8f5391358ccbeba2$export$6c74ef56152ffb8d);
$parcel$export(module.exports, "uint8ArrayToHex", () => $8f5391358ccbeba2$export$c44b02fb03dbac82);
$parcel$export(module.exports, "Class", () => $8f5391358ccbeba2$export$4c85e640eb41c31b);
$parcel$export(module.exports, "members", () => $8f5391358ccbeba2$export$100ad4af8c8d544f);
$parcel$export(module.exports, "own", () => $8f5391358ccbeba2$export$a97a0f27b0201230);
$parcel$export(module.exports, "hide", () => $8f5391358ccbeba2$export$fe8985bb6374093c);
$parcel$export(module.exports, "derived", () => $8f5391358ccbeba2$export$90b0b54dab0a340a);
$parcel$export(module.exports, "defineLazyInternal", () => $8f5391358ccbeba2$export$ab4d63bd6339ba82);
$parcel$export(module.exports, "installLazyProp", () => $8f5391358ccbeba2$export$fd3ec217a5ca1bc7);
$parcel$export(module.exports, "CONSTANT_CATCH", () => $8f5391358ccbeba2$export$2644f2739b5380cd);
$parcel$export(module.exports, "constantCatch", () => $8f5391358ccbeba2$export$79bf7eed34458669);

var $igTWG = parcelRequire("igTWG");
function $8f5391358ccbeba2$export$27555cdfb0b84a1a(val) {
    return val;
}
function $8f5391358ccbeba2$export$49eedac51f614f7d(val) {
    return val;
}
function $8f5391358ccbeba2$export$e95468e219bfe076() {
    return (schema)=>schema;
}
function $8f5391358ccbeba2$export$6fee1f82edcf4a03(_arg) {}
function $8f5391358ccbeba2$export$cbadc5a7223772a8(_x) {
    throw new Error("Unexpected value in exhaustive check");
}
function $8f5391358ccbeba2$export$a7a9523472993e97(_) {}
function $8f5391358ccbeba2$export$70a5d58ec00f3c11(entries) {
    const numericValues = Object.values(entries).filter((v)=>typeof v === "number");
    const values = Object.entries(entries).filter(([k, _])=>numericValues.indexOf(+k) === -1).map(([_, v])=>v);
    return values;
}
function $8f5391358ccbeba2$export$e79b744344f50f50(array, separator = "|") {
    return array.map((val)=>$8f5391358ccbeba2$export$5859860f650378f4(val)).join(separator);
}
function $8f5391358ccbeba2$export$f4defb13cab882b2(_, value) {
    if (typeof value === "bigint") return value.toString();
    return value;
}
// the accessor lives on a shared prototype: an own accessor makes every box a dictionary-mode object (~360 B and a slow load per read against ~100 B and an inlined getter here)
class $8f5391358ccbeba2$var$Cached {
    constructor(getter){
        this._getter = getter;
        this._value = undefined;
    }
    get value() {
        const getter = this._getter;
        if (getter !== undefined) {
            this._value = getter();
            this._getter = undefined;
        }
        return this._value;
    }
}
function $8f5391358ccbeba2$export$ade7a147f5129058(getter) {
    return new $8f5391358ccbeba2$var$Cached(getter);
}
function $8f5391358ccbeba2$export$69fd1b70ebae5687(input) {
    return input === null || input === undefined;
}
function $8f5391358ccbeba2$export$78d521805d6c22e4(source) {
    const start = source.startsWith("^") ? 1 : 0;
    const end = source.endsWith("$") ? source.length - 1 : source.length;
    return source.slice(start, end);
}
function $8f5391358ccbeba2$export$7807b52a740a7117(val, step) {
    const ratio = val / step;
    const roundedRatio = Math.round(ratio);
    // `val` and `step` each round to a double before the division rounds again, so a true decimal multiple's quotient can sit up to 1.5 of these scaled epsilons from the integer. A 1x tolerance therefore rejected 2.03 as a multiple of 0.07; 4x covers the worst case with margin.
    const tolerance = 4 * Number.EPSILON * Math.max(Math.abs(ratio), 1);
    if (Math.abs(ratio - roundedRatio) < tolerance) return 0;
    return ratio - roundedRatio;
}
const $8f5391358ccbeba2$var$EVALUATING = /* @__PURE__*/ Symbol("evaluating");
function $8f5391358ccbeba2$export$d43070a5843c1e2(object, key, getter) {
    let value = undefined;
    Object.defineProperty(object, key, {
        get () {
            if (value === $8f5391358ccbeba2$var$EVALUATING) // Circular reference detected, return undefined to break the cycle
            return undefined;
            if (value === undefined) {
                value = $8f5391358ccbeba2$var$EVALUATING;
                value = getter();
            }
            return value;
        },
        set (v) {
            Object.defineProperty(object, key, {
                value: v
            });
        // object[key] = v;
        },
        configurable: true
    });
}
function $8f5391358ccbeba2$export$103832c7353c2f50(obj) {
    return Object.create(Object.getPrototypeOf(obj), Object.getOwnPropertyDescriptors(obj));
}
function $8f5391358ccbeba2$export$2e23d0571746a3fb(target, prop, value) {
    Object.defineProperty(target, prop, {
        value: value,
        writable: true,
        enumerable: true,
        configurable: true
    });
}
function $8f5391358ccbeba2$export$fd1f02864f419aa5(def) {
    const desc = Object.getOwnPropertyDescriptor(def, "shape");
    return desc?.get ? desc.get.raw : desc?.value;
}
// where a builder reads its source's keys and descriptors, resolving only a shape a def answers for itself. A shape resolves by object spread, so only its enumerable keys are ever part of it.
function $8f5391358ccbeba2$var$sourceShape(schema) {
    return $8f5391358ccbeba2$export$fd1f02864f419aa5(schema._zod.def) ?? schema._zod.def.shape;
}
// a key whose value is not settled yet, self-caching so every read after the first gets the same one
function $8f5391358ccbeba2$var$deferProp(target, key, getter) {
    Object.defineProperty(target, key, {
        get () {
            const value = getter();
            $8f5391358ccbeba2$export$2e23d0571746a3fb(this, key, value);
            return value;
        },
        enumerable: true,
        configurable: true
    });
}
// Writes a settled key. A plain assignment is much cheaper than `defineProperty` and produces the same descriptor, but it runs whatever setter already answers to the key — an accessor this shape deferred, or an inherited one, which `__proto__` has on every object and prototype pollution can add for any name.
function $8f5391358ccbeba2$var$putProp(target, key, value) {
    if (key in target) $8f5391358ccbeba2$export$2e23d0571746a3fb(target, key, value);
    else target[key] = value;
}
/**
 * Copies `keys` of `source`'s shape onto `target`, each value passed through `wrap`.
 *
 * A key the source has resolved is copied through now, so the derived shape states it outright and nothing has to resolve it to learn what it holds. A key the source still defers stays deferred, and reads back through the source's own `shape`, so it resolves once and both shapes get that one schema.
 */ function $8f5391358ccbeba2$var$mirrorShape(target, source, keys, wrap) {
    const raw = $8f5391358ccbeba2$var$sourceShape(source);
    for (const key of keys){
        const desc = Object.getOwnPropertyDescriptor(raw, key);
        if (!desc.enumerable) continue;
        if (desc.get) $8f5391358ccbeba2$var$deferProp(target, key, ()=>{
            const value = source._zod.def.shape[key];
            return wrap ? wrap(value, key) : value;
        });
        else $8f5391358ccbeba2$var$putProp(target, key, wrap ? wrap(desc.value, key) : desc.value);
    }
}
// same, for a plain shape a caller passed rather than a schema's
function $8f5391358ccbeba2$var$mirrorProps(target, source) {
    for (const key of Reflect.ownKeys(source)){
        const desc = Object.getOwnPropertyDescriptor(source, key);
        if (!desc.enumerable) continue;
        if (desc.get) $8f5391358ccbeba2$var$deferProp(target, key, ()=>source[key]);
        else $8f5391358ccbeba2$var$putProp(target, key, desc.value);
    }
}
function $8f5391358ccbeba2$export$8969f8c824382d73(...defs) {
    const mergedDescriptors = {};
    for (const def of defs){
        const descriptors = Object.getOwnPropertyDescriptors(def);
        Object.assign(mergedDescriptors, descriptors);
    }
    return Object.defineProperties({}, mergedDescriptors);
}
function $8f5391358ccbeba2$export$21596dc63856f4c1(schema) {
    return $8f5391358ccbeba2$export$8969f8c824382d73(schema._zod.def);
}
function $8f5391358ccbeba2$export$4b74d241e1cc7892(obj, path) {
    if (!path) return obj;
    return path.reduce((acc, key)=>acc?.[key], obj);
}
function $8f5391358ccbeba2$export$3db3408dad58da23(promisesObj) {
    const keys = Object.keys(promisesObj);
    const promises = keys.map((key)=>promisesObj[key]);
    return Promise.all(promises).then((results)=>{
        const resolvedObj = {};
        for(let i = 0; i < keys.length; i++)resolvedObj[keys[i]] = results[i];
        return resolvedObj;
    });
}
function $8f5391358ccbeba2$export$7fa8378418b4411e(length = 10) {
    const chars = "abcdefghijklmnopqrstuvwxyz";
    let str = "";
    for(let i = 0; i < length; i++)str += chars[Math.floor(Math.random() * chars.length)];
    return str;
}
function $8f5391358ccbeba2$export$a1a11b095f88289a(str) {
    return JSON.stringify(str);
}
function $8f5391358ccbeba2$export$c383cdd2a518017a(input) {
    return input.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const $8f5391358ccbeba2$export$756e5cd2d260237b = "captureStackTrace" in Error ? Error.captureStackTrace : (..._args)=>{};
function $8f5391358ccbeba2$export$a6cdc56e425d0d0a(data) {
    return typeof data === "object" && data !== null && !Array.isArray(data);
}
const $8f5391358ccbeba2$export$1f119cb4d720843b = /* @__PURE__*/ $8f5391358ccbeba2$export$ade7a147f5129058(()=>{
    // Skip the probe under `jitless`: strict CSPs report the caught `new Function` as a `securitypolicyviolation` even though the throw is swallowed.
    if ((0, $igTWG.globalConfig).jitless) return false;
    // @ts-ignore
    if (typeof navigator !== "undefined" && navigator?.userAgent?.includes("Cloudflare")) return false;
    try {
        const F = Function;
        new F("");
        return true;
    } catch (_) {
        return false;
    }
});
function $8f5391358ccbeba2$export$53b83ca8eaab0383(o) {
    if ($8f5391358ccbeba2$export$a6cdc56e425d0d0a(o) === false) return false;
    // modified constructor
    const ctor = o.constructor;
    if (ctor === undefined) return true;
    if (typeof ctor !== "function") return true;
    // modified prototype
    const prot = ctor.prototype;
    if ($8f5391358ccbeba2$export$a6cdc56e425d0d0a(prot) === false) return false;
    // ctor doesn't have static `isPrototypeOf`
    if (Object.prototype.hasOwnProperty.call(prot, "isPrototypeOf") === false) return false;
    return true;
}
function $8f5391358ccbeba2$export$370e8311c3cdebd9(o) {
    if ($8f5391358ccbeba2$export$53b83ca8eaab0383(o)) return {
        ...o
    };
    if (Array.isArray(o)) return [
        ...o
    ];
    if (o instanceof Map) return new Map(o);
    if (o instanceof Set) return new Set(o);
    return o;
}
function $8f5391358ccbeba2$export$71667e74ba29447f(data) {
    let keyCount = 0;
    for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) keyCount++;
    return keyCount;
}
const $8f5391358ccbeba2$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return "undefined";
        case "string":
            return "string";
        case "number":
            return Number.isNaN(data) ? "nan" : "number";
        case "boolean":
            return "boolean";
        case "function":
            return "function";
        case "bigint":
            return "bigint";
        case "symbol":
            return "symbol";
        case "object":
            if (Array.isArray(data)) return "array";
            if (data === null) return "null";
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return "promise";
            if (typeof Map !== "undefined" && data instanceof Map) return "map";
            if (typeof Set !== "undefined" && data instanceof Set) return "set";
            if (typeof Date !== "undefined" && data instanceof Date) return "date";
            // @ts-ignore
            if (typeof File !== "undefined" && data instanceof File) return "file";
            return "object";
        default:
            throw new Error(`Unknown data type: ${t}`);
    }
};
const $8f5391358ccbeba2$export$b99c149ecf60be48 = /* @__PURE__*/ new Set([
    "string",
    "number",
    "symbol"
]);
const $8f5391358ccbeba2$export$c34ffd355f76f0e4 = /* @__PURE__*/ new Set([
    "string",
    "number",
    "bigint",
    "boolean",
    "symbol",
    "undefined"
]);
function $8f5391358ccbeba2$export$104ed90cc1a13451(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $8f5391358ccbeba2$export$9cd59f9826255e47(inst, def, params) {
    const cl = new inst._zod.constr(def ?? inst._zod.def);
    if (!def || params?.parent) cl._zod.parent = inst;
    return cl;
}
function $8f5391358ccbeba2$export$d6b7b25dfacfd300(_params) {
    const params = _params;
    if (!params) return {};
    if (typeof params === "string") return {
        error: ()=>params
    };
    if (params?.message !== undefined) {
        if (params?.error !== undefined) throw new Error("Cannot specify both `message` and `error` params");
        params.error = params.message;
    }
    delete params.message;
    if (typeof params.error === "string") return {
        ...params,
        error: ()=>params.error
    };
    return params;
}
function $8f5391358ccbeba2$export$6ebbd8d3cb03909b(getter) {
    let target;
    return new Proxy({}, {
        get (_, prop, receiver) {
            target ?? (target = getter());
            return Reflect.get(target, prop, receiver);
        },
        set (_, prop, value, receiver) {
            target ?? (target = getter());
            return Reflect.set(target, prop, value, receiver);
        },
        has (_, prop) {
            target ?? (target = getter());
            return Reflect.has(target, prop);
        },
        deleteProperty (_, prop) {
            target ?? (target = getter());
            return Reflect.deleteProperty(target, prop);
        },
        ownKeys (_) {
            target ?? (target = getter());
            return Reflect.ownKeys(target);
        },
        getOwnPropertyDescriptor (_, prop) {
            target ?? (target = getter());
            return Reflect.getOwnPropertyDescriptor(target, prop);
        },
        defineProperty (_, prop, descriptor) {
            target ?? (target = getter());
            return Reflect.defineProperty(target, prop, descriptor);
        }
    });
}
function $8f5391358ccbeba2$export$5859860f650378f4(value) {
    if (typeof value === "bigint") return value.toString() + "n";
    if (typeof value === "string") return `"${value}"`;
    return `${value}`;
}
function $8f5391358ccbeba2$export$240159211e66adb9(shape) {
    return Object.keys(shape).filter((k)=>{
        return shape[k]._zod.optin !== undefined && shape[k]._zod.optout === "optional";
    });
}
const $8f5391358ccbeba2$export$8e78302060ccf26f = /*@__PURE__*/ (()=>({
        safeint: [
            Number.MIN_SAFE_INTEGER,
            Number.MAX_SAFE_INTEGER
        ],
        int32: [
            -2147483648,
            2147483647
        ],
        uint32: [
            0,
            4294967295
        ],
        float32: [
            -3.4028234663852886e+38,
            3.4028234663852886e38
        ],
        float64: [
            -Number.MAX_VALUE,
            Number.MAX_VALUE
        ]
    }))();
const $8f5391358ccbeba2$export$538d1d6d5cfcb3b6 = {
    int64: [
        /* @__PURE__*/ BigInt("-9223372036854775808"),
        /* @__PURE__*/ BigInt("9223372036854775807")
    ],
    uint64: [
        /* @__PURE__*/ BigInt(0),
        /* @__PURE__*/ BigInt("18446744073709551615")
    ]
};
function $8f5391358ccbeba2$export$357523c63a2253b9(schema, mask) {
    const currDef = schema._zod.def;
    const checks = currDef.checks;
    const hasChecks = checks && checks.length > 0;
    if (hasChecks) throw new Error(".pick() cannot be used on object schemas containing refinements");
    const newShape = {};
    $8f5391358ccbeba2$var$mirrorShape(newShape, schema, $8f5391358ccbeba2$var$maskedKeys(schema, mask));
    return $8f5391358ccbeba2$export$9cd59f9826255e47(schema, $8f5391358ccbeba2$export$8969f8c824382d73(currDef, {
        shape: newShape,
        checks: []
    }));
}
// the mask keys that select something, checked against the source's shape without resolving it
function $8f5391358ccbeba2$var$maskedKeys(schema, mask) {
    const raw = $8f5391358ccbeba2$var$sourceShape(schema);
    const keys = [];
    // `for...in` skips symbols, so a symbol in the mask would select nothing
    for (const key of Reflect.ownKeys(mask)){
        if (!Object.getOwnPropertyDescriptor(raw, key)?.enumerable) throw new Error(`Unrecognized key: "${String(key)}"`);
        if (mask[key]) keys.push(key);
    }
    return keys;
}
function $8f5391358ccbeba2$export$30a06c8d3562193f(schema, mask) {
    const currDef = schema._zod.def;
    const checks = currDef.checks;
    const hasChecks = checks && checks.length > 0;
    if (hasChecks) throw new Error(".omit() cannot be used on object schemas containing refinements");
    const omitted = new Set($8f5391358ccbeba2$var$maskedKeys(schema, mask));
    const newShape = {};
    $8f5391358ccbeba2$var$mirrorShape(newShape, schema, Reflect.ownKeys($8f5391358ccbeba2$var$sourceShape(schema)).filter((key)=>!omitted.has(key)));
    return $8f5391358ccbeba2$export$9cd59f9826255e47(schema, $8f5391358ccbeba2$export$8969f8c824382d73(currDef, {
        shape: newShape,
        checks: []
    }));
}
function $8f5391358ccbeba2$export$8b58be045bf06082(schema, shape) {
    if (!$8f5391358ccbeba2$export$53b83ca8eaab0383(shape)) throw new Error("Invalid input to extend: expected a plain object");
    const checks = schema._zod.def.checks;
    const hasChecks = checks && checks.length > 0;
    if (hasChecks) {
        // Only throw if new shape overlaps with existing shape. Use getOwnPropertyDescriptor to check key existence without accessing values
        const existingShape = $8f5391358ccbeba2$var$sourceShape(schema);
        for (const key of Reflect.ownKeys(shape)){
            if (Object.getOwnPropertyDescriptor(existingShape, key) !== undefined) throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
        }
    }
    return $8f5391358ccbeba2$export$9cd59f9826255e47(schema, $8f5391358ccbeba2$export$8969f8c824382d73(schema._zod.def, {
        shape: $8f5391358ccbeba2$var$extended(schema, shape)
    }));
}
// the source's keys, then the caller's overlaid on top
function $8f5391358ccbeba2$var$extended(schema, shape) {
    const newShape = {};
    $8f5391358ccbeba2$var$mirrorShape(newShape, schema, Reflect.ownKeys($8f5391358ccbeba2$var$sourceShape(schema)));
    $8f5391358ccbeba2$var$mirrorProps(newShape, shape);
    return newShape;
}
function $8f5391358ccbeba2$export$40c90eb222f50efb(schema, shape) {
    if (!$8f5391358ccbeba2$export$53b83ca8eaab0383(shape)) throw new Error("Invalid input to safeExtend: expected a plain object");
    return $8f5391358ccbeba2$export$9cd59f9826255e47(schema, $8f5391358ccbeba2$export$8969f8c824382d73(schema._zod.def, {
        shape: $8f5391358ccbeba2$var$extended(schema, shape)
    }));
}
function $8f5391358ccbeba2$export$4950aa0f605343fb(a, b) {
    if (!b?._zod?.def) throw new Error("Invalid input to merge: expected an object schema. To merge a plain shape, use `.extend()`.");
    if (a._zod.def.checks?.length) throw new Error(".merge() cannot be used on object schemas containing refinements. Use .safeExtend() instead.");
    const newShape = {};
    $8f5391358ccbeba2$var$mirrorShape(newShape, a, Reflect.ownKeys($8f5391358ccbeba2$var$sourceShape(a)));
    $8f5391358ccbeba2$var$mirrorShape(newShape, b, Reflect.ownKeys($8f5391358ccbeba2$var$sourceShape(b)));
    const def = $8f5391358ccbeba2$export$8969f8c824382d73(a._zod.def, {
        shape: newShape,
        get catchall () {
            return b._zod.def.catchall;
        },
        checks: b._zod.def.checks ?? []
    });
    return $8f5391358ccbeba2$export$9cd59f9826255e47(a, def);
}
function $8f5391358ccbeba2$export$e45945969df8035a(Class, schema, mask, name = "partial") {
    const currDef = schema._zod.def;
    const checks = currDef.checks;
    const hasChecks = checks && checks.length > 0;
    if (hasChecks) throw new Error(`.${name}() cannot be used on object schemas containing refinements`);
    const selected = mask ? new Set($8f5391358ccbeba2$var$maskedKeys(schema, mask)) : undefined;
    const newShape = {};
    $8f5391358ccbeba2$var$mirrorShape(newShape, schema, Reflect.ownKeys($8f5391358ccbeba2$var$sourceShape(schema)), Class && ((value, key)=>selected && !selected.has(key) ? value : new Class({
            type: "optional",
            innerType: value
        })));
    return $8f5391358ccbeba2$export$9cd59f9826255e47(schema, $8f5391358ccbeba2$export$8969f8c824382d73(schema._zod.def, {
        shape: newShape,
        checks: []
    }));
}
function $8f5391358ccbeba2$export$a7a0278c004aac3f(Class, schema, mask) {
    const selected = mask ? new Set($8f5391358ccbeba2$var$maskedKeys(schema, mask)) : undefined;
    const newShape = {};
    $8f5391358ccbeba2$var$mirrorShape(newShape, schema, Reflect.ownKeys($8f5391358ccbeba2$var$sourceShape(schema)), (value, key)=>// overwrite with non-optional
        selected && !selected.has(key) ? value : new Class({
            type: "nonoptional",
            innerType: value
        }));
    return $8f5391358ccbeba2$export$9cd59f9826255e47(schema, $8f5391358ccbeba2$export$8969f8c824382d73(schema._zod.def, {
        shape: newShape
    }));
}
function $8f5391358ccbeba2$export$bd75b6d981b9c7f2(x, startIndex = 0) {
    if (x.aborted === true) return true;
    for(let i = startIndex; i < x.issues.length; i++){
        if (x.issues[i]?.continue !== true) return true;
    }
    return false;
}
function $8f5391358ccbeba2$export$a5fe2d8610d815ec(x, startIndex = 0) {
    if (x.aborted === true) return true;
    for(let i = startIndex; i < x.issues.length; i++){
        if (x.issues[i]?.continue === false) return true;
    }
    return false;
}
function $8f5391358ccbeba2$export$7f35a4c434118b9e(path, issues) {
    return issues.map((iss)=>{
        var _a;
        (_a = iss).path ?? (_a.path = []);
        iss.path.unshift(path);
        return iss;
    });
}
function $8f5391358ccbeba2$export$56590e5a47837d61(message) {
    return typeof message === "string" ? message : message?.message;
}
function $8f5391358ccbeba2$export$5f3bf32142eef856(issues, start, inst) {
    var _a;
    for(let i = start; i < issues.length; i++)(_a = issues[i]).schema ?? (_a.schema = inst);
}
function $8f5391358ccbeba2$export$c5e667bbfc286a9d(iss, ctx, config) {
    var _a;
    // A schema that raised an issue itself owns it outright, and outranks any stamp an enclosing check left in `attachSchema`. String formats and z.custom() are schema and check at once, so when they act as a check they defer to that stamp instead.
    const traits = iss.inst?._zod?.traits;
    if (traits?.has("$ZodType")) {
        if (traits.has("$ZodCheck")) (_a = iss).schema ?? (_a.schema = iss.inst);
        else iss.schema = iss.inst;
    }
    // Decreasing specificity, first map to return a message wins. `inst` is whatever raised the issue, so a check's own map outranks the owning schema's.
    const schemaError = iss.schema !== iss.inst ? iss.schema?._zod.def?.error : undefined;
    const message = iss.message ? iss.message : $8f5391358ccbeba2$export$56590e5a47837d61(iss.inst?._zod.def?.error?.(iss)) ?? $8f5391358ccbeba2$export$56590e5a47837d61(schemaError?.(iss)) ?? $8f5391358ccbeba2$export$56590e5a47837d61(ctx?.error?.(iss)) ?? $8f5391358ccbeba2$export$56590e5a47837d61(config.customError?.(iss)) ?? $8f5391358ccbeba2$export$56590e5a47837d61(config.localeError?.(iss)) ?? "Invalid input";
    // an explicit own-key copy beats object rest with excluded keys, which v8 routes through a generic runtime call; Object.keys rather than for-in so an issue pushed with a prototype does not leak inherited keys, and an own __proto__ key is dropped rather than assigned through the setter
    const full = {};
    for (const k of Object.keys(iss)){
        if (k === "inst" || k === "schema" || k === "continue" || k === "input" || k === "__proto__") continue;
        full[k] = iss[k];
    }
    full.path ?? (full.path = []);
    full.message = message;
    if (ctx?.reportInput) full.input = iss.input;
    return full;
}
function $8f5391358ccbeba2$export$67a7c9c676c45d2b(input) {
    if (input instanceof Set) return "set";
    if (input instanceof Map) return "map";
    // @ts-ignore
    if (input instanceof File) return "file";
    return "unknown";
}
const $8f5391358ccbeba2$var$highSurrogate = /[\uD800-\uDBFF]/;
function $8f5391358ccbeba2$export$89f26bd0a2764944(str) {
    const units = str.length;
    if (!$8f5391358ccbeba2$var$highSurrogate.test(str)) return units;
    let count = units;
    for(let i = 0; i < units - 1; i++)if ((str.charCodeAt(i) & 0xfc00) === 0xd800 && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
        count--;
        i++;
    }
    return count;
}
function $8f5391358ccbeba2$export$479f5a070abeb487(input) {
    if (Array.isArray(input)) return "array";
    if (typeof input === "string") return "string";
    return "unknown";
}
function $8f5391358ccbeba2$export$858d360cf6da2b65(data) {
    const t = typeof data;
    switch(t){
        case "number":
            return Number.isNaN(data) ? "nan" : "number";
        case "object":
            {
                if (data === null) return "null";
                if (Array.isArray(data)) return "array";
                const obj = data;
                if (obj && Object.getPrototypeOf(obj) !== Object.prototype && "constructor" in obj && obj.constructor) return obj.constructor.name;
            }
    }
    return t;
}
function $8f5391358ccbeba2$export$69ad3503f98be476(...args) {
    const [iss, input, inst] = args;
    if (typeof iss === "string") return {
        message: iss,
        code: "custom",
        input: input,
        inst: inst
    };
    return {
        ...iss
    };
}
function $8f5391358ccbeba2$export$9b57aa937148f32(obj) {
    return Object.entries(obj).filter(([k, _])=>{
        // return true if NaN, meaning it's not a number, thus a string key
        return Number.isNaN(Number.parseInt(k, 10));
    }).map((el)=>el[1]);
}
function $8f5391358ccbeba2$export$f01069a3c307e50e(base64) {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for(let i = 0; i < binaryString.length; i++)bytes[i] = binaryString.charCodeAt(i);
    return bytes;
}
function $8f5391358ccbeba2$export$36bac84b1c2da9c7(bytes) {
    let binaryString = "";
    for(let i = 0; i < bytes.length; i++)binaryString += String.fromCharCode(bytes[i]);
    return btoa(binaryString);
}
function $8f5391358ccbeba2$export$b9fa2551f2db41e1(base64url) {
    const base64 = base64url.replace(/-/g, "+").replace(/_/g, "/");
    const padding = "=".repeat((4 - base64.length % 4) % 4);
    return $8f5391358ccbeba2$export$f01069a3c307e50e(base64 + padding);
}
function $8f5391358ccbeba2$export$975f78e50159df6f(bytes) {
    return $8f5391358ccbeba2$export$36bac84b1c2da9c7(bytes).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function $8f5391358ccbeba2$export$6c74ef56152ffb8d(hex) {
    const cleanHex = hex.replace(/^0x/, "");
    if (cleanHex.length % 2 !== 0) throw new Error("Invalid hex string length");
    const bytes = new Uint8Array(cleanHex.length / 2);
    for(let i = 0; i < cleanHex.length; i += 2)bytes[i / 2] = Number.parseInt(cleanHex.slice(i, i + 2), 16);
    return bytes;
}
function $8f5391358ccbeba2$export$c44b02fb03dbac82(bytes) {
    return Array.from(bytes).map((b)=>b.toString(16).padStart(2, "0")).join("");
}
class $8f5391358ccbeba2$export$4c85e640eb41c31b {
    constructor(..._args){}
}
function $8f5391358ccbeba2$export$100ad4af8c8d544f(proto, table) {
    for(const key in table){
        const desc = Object.getOwnPropertyDescriptor(table, key);
        // a getter installs as written, so it stays live: `description` reads through to the registry on every access. not enumerable: an object literal's is, and a prototype member never was
        if (desc.get) Object.defineProperty(proto, key, {
            ...desc,
            enumerable: false
        });
        else $8f5391358ccbeba2$var$defineBound(proto, key, desc.value);
    }
}
function $8f5391358ccbeba2$export$a97a0f27b0201230(inst, key, value, enumerable = true) {
    Object.defineProperty(inst, key, {
        configurable: true,
        writable: true,
        enumerable: enumerable,
        value: value
    });
    return value;
}
function $8f5391358ccbeba2$export$fe8985bb6374093c(inst, key, value) {
    return $8f5391358ccbeba2$export$a97a0f27b0201230(inst, key, value, false);
}
/*@__NO_SIDE_EFFECTS__*/ function $8f5391358ccbeba2$export$90b0b54dab0a340a(computes, table) {
    for(const key in computes){
        const compute = computes[key];
        // an object literal's accessor is configurable and enumerable, and `members` copies the descriptor as written
        Object.defineProperty(table, key, {
            configurable: true,
            enumerable: true,
            get () {
                return $8f5391358ccbeba2$export$a97a0f27b0201230(this, key, compute(this));
            },
            set (value) {
                $8f5391358ccbeba2$export$a97a0f27b0201230(this, key, value);
            }
        });
    }
    return table;
}
function $8f5391358ccbeba2$var$defineBound(proto, key, fn) {
    Object.defineProperty(proto, key, {
        configurable: true,
        get () {
            // vitest's spyOn calls a prototype getter bare to find the function it wraps, so a nullish receiver answers the raw method
            return this == null ? fn : $8f5391358ccbeba2$export$a97a0f27b0201230(this, key, fn.bind(this));
        },
        set (value) {
            $8f5391358ccbeba2$export$a97a0f27b0201230(this, key, value);
        }
    });
}
/** Returns the prototype to install on, or `undefined` if this group is already installed on it. */ function $8f5391358ccbeba2$var$claim(inst, sentinel) {
    const proto = Object.getPrototypeOf(inst);
    // Runs on every construction, so `in` rather than the costlier `hasOwnProperty.call`. Sentinels are keys the group itself defines.
    return sentinel in proto ? undefined : proto;
}
// The internals whose init chain is installing. A second call for the same one is a derived constructor overriding its base, so it must not construct another schema in between or the override is dropped.
let $8f5391358ccbeba2$var$installing;
// Set while a getter is running, so a value that resolved through a recursion break is not memoized. One shared descriptor shadows the key for the duration, which costs no per-key allocation.
let $8f5391358ccbeba2$var$broke = false;
const $8f5391358ccbeba2$var$breaker = {
    configurable: true,
    get () {
        $8f5391358ccbeba2$var$broke = true;
        return undefined;
    }
};
function $8f5391358ccbeba2$export$ab4d63bd6339ba82(inst, key, compute) {
    const proto = Object.getPrototypeOf(inst._zod);
    if (key in proto && $8f5391358ccbeba2$var$installing !== inst._zod) {
        // A repeat construction: everything is installed already. Cleared here so the reference is not held past the first construction of every type.
        $8f5391358ccbeba2$var$installing = undefined;
        return;
    }
    $8f5391358ccbeba2$var$installing = inst._zod;
    Object.defineProperty(proto, key, {
        configurable: true,
        get () {
            // Shadowed before computing so a re-entrant read from a recursive schema resolves to undefined instead of running the getter again.
            Object.defineProperty(this, key, $8f5391358ccbeba2$var$breaker);
            const outer = $8f5391358ccbeba2$var$broke;
            $8f5391358ccbeba2$var$broke = false;
            try {
                const value = compute(this);
                // A result that resolved through a recursion break is recomputed once the graph is complete; everything else memoizes, undefined included.
                if ($8f5391358ccbeba2$var$broke) delete this[key];
                else Object.defineProperty(this, key, {
                    configurable: true,
                    writable: true,
                    value: value
                });
                $8f5391358ccbeba2$var$broke = $8f5391358ccbeba2$var$broke || outer;
                return value;
            } catch (err) {
                // A compute that threw memoizes nothing, so a later read runs it again and fails the same way. The shadow goes with it, since leaving it installed would answer undefined for every later read.
                delete this[key];
                $8f5391358ccbeba2$var$broke = $8f5391358ccbeba2$var$broke || outer;
                throw err;
            }
        },
        set (value) {
            Object.defineProperty(this, key, {
                configurable: true,
                writable: true,
                value: value
            });
        }
    });
}
function $8f5391358ccbeba2$export$fd3ec217a5ca1bc7(inst, key, make, enumerable) {
    const proto = $8f5391358ccbeba2$var$claim(inst, key);
    if (!proto) return;
    Object.defineProperty(proto, key, {
        configurable: true,
        get () {
            // Shadowed before computing, so a re-entrant read from a self-referential shape resolves to undefined instead of running the getter again. A data property rather than an accessor: an own accessor is the dictionary-mode transition this exists to avoid.
            const desc = {
                configurable: true,
                writable: true,
                enumerable: enumerable,
                value: undefined
            };
            Object.defineProperty(this, key, desc);
            // a compute that throws leaves the shadow behind, so later reads answer undefined instead of re-throwing; `defineLazy` did the same, and `defineLazyInternal`'s delete-on-catch would cost bytes in every bundle for a case only a throwing user getter reaches
            desc.value = make(this);
            Object.defineProperty(this, key, desc);
            return desc.value;
        },
        set (value) {
            Object.defineProperty(this, key, {
                configurable: true,
                writable: true,
                enumerable: enumerable,
                value: value
            });
        }
    });
}
const $8f5391358ccbeba2$export$2644f2739b5380cd = "~constantCatch";
function $8f5391358ccbeba2$export$79bf7eed34458669(value) {
    const fn = ()=>value;
    fn[$8f5391358ccbeba2$export$2644f2739b5380cd] = true;
    return fn;
}

});


parcelRegister("8S8Wz", function(module, exports) {
$parcel$export(module.exports, "cuid", () => $675a4de49b6b20b4$export$e057ec210c7d3443);
$parcel$export(module.exports, "cuid2", () => $675a4de49b6b20b4$export$af5866a6cccce9f0);
$parcel$export(module.exports, "ulid", () => $675a4de49b6b20b4$export$c34778236461ea95);
$parcel$export(module.exports, "xid", () => $675a4de49b6b20b4$export$5eecaf20006cb6cb);
$parcel$export(module.exports, "ksuid", () => $675a4de49b6b20b4$export$f49b11deeb9beb0f);
$parcel$export(module.exports, "nanoid", () => $675a4de49b6b20b4$export$ac4959f4f1338dfc);
$parcel$export(module.exports, "nanoidOfLength", () => $675a4de49b6b20b4$export$5e38a73263010503);
$parcel$export(module.exports, "duration", () => $675a4de49b6b20b4$export$1f34108aa9eb96ab);
$parcel$export(module.exports, "extendedDuration", () => $675a4de49b6b20b4$export$e30244ba59a8cd84);
$parcel$export(module.exports, "guid", () => $675a4de49b6b20b4$export$46e8f25c7328f77e);
$parcel$export(module.exports, "uuid", () => $675a4de49b6b20b4$export$31b40729666a4ae0);
$parcel$export(module.exports, "uuid4", () => $675a4de49b6b20b4$export$19f53698e68b2496);
$parcel$export(module.exports, "uuid6", () => $675a4de49b6b20b4$export$1d78c41b29712c01);
$parcel$export(module.exports, "uuid7", () => $675a4de49b6b20b4$export$b3092b3ac1fa0ace);
$parcel$export(module.exports, "email", () => $675a4de49b6b20b4$export$d290fa47940df19d);
$parcel$export(module.exports, "html5Email", () => $675a4de49b6b20b4$export$d2c782992f0a89ee);
$parcel$export(module.exports, "rfc5322Email", () => $675a4de49b6b20b4$export$54f6bc2d4fd0bb08);
$parcel$export(module.exports, "unicodeEmail", () => $675a4de49b6b20b4$export$f8855510ae7521df);
$parcel$export(module.exports, "idnEmail", () => $675a4de49b6b20b4$export$d402ea1c27a77371);
$parcel$export(module.exports, "browserEmail", () => $675a4de49b6b20b4$export$9d1ec0311c8ce72e);
$parcel$export(module.exports, "emoji", () => $675a4de49b6b20b4$export$a19185d1233fc4b2);
$parcel$export(module.exports, "ipv4", () => $675a4de49b6b20b4$export$291a17a16047f284);
$parcel$export(module.exports, "ipv6", () => $675a4de49b6b20b4$export$4e0c86a59c658526);
$parcel$export(module.exports, "mac", () => $675a4de49b6b20b4$export$f8d11e097856efcf);
$parcel$export(module.exports, "cidrv4", () => $675a4de49b6b20b4$export$fc96793d9715e5a1);
$parcel$export(module.exports, "cidrv6", () => $675a4de49b6b20b4$export$b6e650831cac87fb);
$parcel$export(module.exports, "base64", () => $675a4de49b6b20b4$export$b3b2de96497acc47);
$parcel$export(module.exports, "base64url", () => $675a4de49b6b20b4$export$7d21597c7bc64465);
$parcel$export(module.exports, "hostname", () => $675a4de49b6b20b4$export$640106f6dc7d2706);
$parcel$export(module.exports, "domain", () => $675a4de49b6b20b4$export$21779e503be4cd98);
$parcel$export(module.exports, "httpProtocol", () => $675a4de49b6b20b4$export$b23749f357fbda41);
$parcel$export(module.exports, "e164", () => $675a4de49b6b20b4$export$2fa5ed24c9ef198e);
$parcel$export(module.exports, "creditCard", () => $675a4de49b6b20b4$export$34823d8b18327f02);
$parcel$export(module.exports, "currencyCode", () => $675a4de49b6b20b4$export$a7ec4418d70e8d95);
$parcel$export(module.exports, "iban", () => $675a4de49b6b20b4$export$a829806fb5977d78);
$parcel$export(module.exports, "date", () => $675a4de49b6b20b4$export$324d90190a8b822a);
$parcel$export(module.exports, "time", () => $675a4de49b6b20b4$export$2da9be4cfdb689b1);
$parcel$export(module.exports, "datetime", () => $675a4de49b6b20b4$export$7ba4466dbd0f07e1);
$parcel$export(module.exports, "anyString", () => $675a4de49b6b20b4$export$24da0a402b44e53a);
$parcel$export(module.exports, "string", () => $675a4de49b6b20b4$export$22b082955e083ec3);
$parcel$export(module.exports, "bigint", () => $675a4de49b6b20b4$export$a0f65b52274bcc00);
$parcel$export(module.exports, "integer", () => $675a4de49b6b20b4$export$32744b5b3bba4764);
$parcel$export(module.exports, "number", () => $675a4de49b6b20b4$export$98e628dec113755e);
$parcel$export(module.exports, "boolean", () => $675a4de49b6b20b4$export$4a21f16c33752377);
$parcel$export(module.exports, "null", () => $675a4de49b6b20b4$export$7b1b591b262c240);
$parcel$export(module.exports, "undefined", () => $675a4de49b6b20b4$export$1db45310990710a5);
$parcel$export(module.exports, "lowercase", () => $675a4de49b6b20b4$export$5b1f80f3c282648c);
$parcel$export(module.exports, "uppercase", () => $675a4de49b6b20b4$export$6cfe151e6b925e83);
$parcel$export(module.exports, "hex", () => $675a4de49b6b20b4$export$834dfc94dde4b3d8);
$parcel$export(module.exports, "md5_hex", () => $675a4de49b6b20b4$export$7d7ef811f6d53a1);
$parcel$export(module.exports, "md5_base64", () => $675a4de49b6b20b4$export$85425f7cda9f4890);
$parcel$export(module.exports, "md5_base64url", () => $675a4de49b6b20b4$export$e54699b04083758c);
$parcel$export(module.exports, "sha1_hex", () => $675a4de49b6b20b4$export$2f163473ef893e12);
$parcel$export(module.exports, "sha1_base64", () => $675a4de49b6b20b4$export$fc9670fedfd2524a);
$parcel$export(module.exports, "sha1_base64url", () => $675a4de49b6b20b4$export$5b6729b977839ffd);
$parcel$export(module.exports, "sha256_hex", () => $675a4de49b6b20b4$export$a923016129fea5fb);
$parcel$export(module.exports, "sha256_base64", () => $675a4de49b6b20b4$export$ebc25582a9e85396);
$parcel$export(module.exports, "sha256_base64url", () => $675a4de49b6b20b4$export$9b7979bfebd9716e);
$parcel$export(module.exports, "sha384_hex", () => $675a4de49b6b20b4$export$61d1fe464d10a5d1);
$parcel$export(module.exports, "sha384_base64", () => $675a4de49b6b20b4$export$103403cb96133ac3);
$parcel$export(module.exports, "sha384_base64url", () => $675a4de49b6b20b4$export$eeafcb7aab6a9870);
$parcel$export(module.exports, "sha512_hex", () => $675a4de49b6b20b4$export$e246a4310a1ad74d);
$parcel$export(module.exports, "sha512_base64", () => $675a4de49b6b20b4$export$f698997e063dbdae);
$parcel$export(module.exports, "sha512_base64url", () => $675a4de49b6b20b4$export$a63330069e1b81f6);

var $ciVeX = parcelRequire("ciVeX");
const $675a4de49b6b20b4$export$e057ec210c7d3443 = /^[cC][0-9a-z]{6,}$/;
const $675a4de49b6b20b4$export$af5866a6cccce9f0 = /^[0-9a-z]+$/;
const $675a4de49b6b20b4$export$c34778236461ea95 = /^[0-7][0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{25}$/;
const $675a4de49b6b20b4$export$5eecaf20006cb6cb = /^[0-9a-vA-V]{20}$/;
const $675a4de49b6b20b4$export$f49b11deeb9beb0f = /^[A-Za-z0-9]{27}$/;
const $675a4de49b6b20b4$export$ac4959f4f1338dfc = /^[a-zA-Z0-9_-]{21}$/;
function $675a4de49b6b20b4$export$5e38a73263010503(length) {
    return new RegExp(`^[a-zA-Z0-9_-]{${length}}$`);
}
const $675a4de49b6b20b4$export$1f34108aa9eb96ab = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/;
const $675a4de49b6b20b4$export$e30244ba59a8cd84 = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
const $675a4de49b6b20b4$export$46e8f25c7328f77e = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/;
const $675a4de49b6b20b4$export$31b40729666a4ae0 = (version)=>{
    if (!version) return /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/;
    return new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${version}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`);
};
const $675a4de49b6b20b4$export$19f53698e68b2496 = /*@__PURE__*/ $675a4de49b6b20b4$export$31b40729666a4ae0(4);
const $675a4de49b6b20b4$export$1d78c41b29712c01 = /*@__PURE__*/ $675a4de49b6b20b4$export$31b40729666a4ae0(6);
const $675a4de49b6b20b4$export$b3092b3ac1fa0ace = /*@__PURE__*/ $675a4de49b6b20b4$export$31b40729666a4ae0(7);
const $675a4de49b6b20b4$export$d290fa47940df19d = /^(?:[A-Za-z0-9_'+\-]+\.)*[A-Za-z0-9_'+\-]*[A-Za-z0-9_+-]@(?:[A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/;
const $675a4de49b6b20b4$export$d2c782992f0a89ee = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
const $675a4de49b6b20b4$export$54f6bc2d4fd0bb08 = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const $675a4de49b6b20b4$export$f8855510ae7521df = /^[^\s@"]{1,64}@[^\s@]{1,255}$/u;
const $675a4de49b6b20b4$export$d402ea1c27a77371 = $675a4de49b6b20b4$export$f8855510ae7521df;
const $675a4de49b6b20b4$export$9d1ec0311c8ce72e = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
// Single character class, not an alternation: the two properties overlap (U+1F9B0-U+1F9B3), so `(A|B)+` backtracks exponentially on a failed match. The leading lookahead then demands one anchor — a pictograph, a regional indicator, or the enclosing keycap — because `\p{Emoji_Component}` on its own covers ASCII digits, `#`, `*`, ZWJ, variation selectors and skin tone modifiers, none of which is an emoji without a base.
const $675a4de49b6b20b4$var$_emoji = `^(?=[\\s\\S]*[\\p{Extended_Pictographic}\\p{Regional_Indicator}\\u20E3])[\\p{Extended_Pictographic}\\p{Emoji_Component}]+$`;
function $675a4de49b6b20b4$export$a19185d1233fc4b2() {
    return new RegExp($675a4de49b6b20b4$var$_emoji, "u");
}
const $675a4de49b6b20b4$export$291a17a16047f284 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $675a4de49b6b20b4$export$4e0c86a59c658526 = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/;
const $675a4de49b6b20b4$export$f8d11e097856efcf = (delimiter)=>{
    const escapedDelim = $ciVeX.escapeRegex(delimiter ?? ":");
    return new RegExp(`^(?:[0-9A-F]{2}${escapedDelim}){5}[0-9A-F]{2}$|^(?:[0-9a-f]{2}${escapedDelim}){5}[0-9a-f]{2}$`);
};
const $675a4de49b6b20b4$export$fc96793d9715e5a1 = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/;
const $675a4de49b6b20b4$export$b6e650831cac87fb = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
const $675a4de49b6b20b4$export$b3b2de96497acc47 = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/;
const $675a4de49b6b20b4$export$7d21597c7bc64465 = /^(?:[A-Za-z0-9_-]{4})*(?:[A-Za-z0-9_-]{2,3})?$/;
const $675a4de49b6b20b4$export$640106f6dc7d2706 = /^(?=.{1,253}\.?$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-0-9a-zA-Z]{0,61}[0-9a-zA-Z])?)*\.?$/;
const $675a4de49b6b20b4$export$21779e503be4cd98 = /^(?=.{1,253}$)([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}$/;
const $675a4de49b6b20b4$export$b23749f357fbda41 = /^https?$/;
const $675a4de49b6b20b4$export$2fa5ed24c9ef198e = /^\+[1-9]\d{6,14}$/;
const $675a4de49b6b20b4$export$34823d8b18327f02 = /^\d(?:[ -]?\d){11,18}$/;
const $675a4de49b6b20b4$export$a7ec4418d70e8d95 = /^(?:AED|AFN|ALL|AMD|AOA|ARS|AUD|AWG|AZN|BAM|BBD|BDT|BHD|BIF|BMD|BND|BOB|BOV|BRL|BSD|BTN|BWP|BYN|BZD|CAD|CDF|CHE|CHF|CHW|CLF|CLP|CNY|COP|COU|CRC|CUP|CVE|CZK|DJF|DKK|DOP|DZD|EGP|ERN|ETB|EUR|FJD|FKP|GBP|GEL|GHS|GIP|GMD|GNF|GTQ|GYD|HKD|HNL|HTG|HUF|IDR|ILS|INR|IQD|IRR|ISK|JMD|JOD|JPY|KES|KGS|KHR|KMF|KPW|KRW|KWD|KYD|KZT|LAK|LBP|LKR|LRD|LSL|LYD|MAD|MDL|MGA|MKD|MMK|MNT|MOP|MRU|MUR|MVR|MWK|MXN|MXV|MYR|MZN|NAD|NGN|NIO|NOK|NPR|NZD|OMR|PAB|PEN|PGK|PHP|PKR|PLN|PYG|QAR|RON|RSD|RUB|RWF|SAR|SBD|SCR|SDG|SEK|SGD|SHP|SLE|SOS|SRD|SSP|STN|SVC|SYP|SZL|THB|TJS|TMT|TND|TOP|TRY|TTD|TWD|TZS|UAH|UGX|USD|USN|UYI|UYU|UYW|UZS|VED|VES|VND|VUV|WST|XAD|XAF|XAG|XAU|XBA|XBB|XBC|XBD|XCD|XCG|XDR|XOF|XPD|XPF|XPT|XSU|XTS|XUA|XXX|YER|ZAR|ZMW|ZWG)$/;
const $675a4de49b6b20b4$export$a829806fb5977d78 = /^[A-Z]{2}(?!00|01|99)\d{2}[A-Z0-9]{11,30}$/;
const $675a4de49b6b20b4$var$dateSource = `(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))`;
/** Anchors a pattern source. The interpolation lives here rather than at the call site because
 * esbuild will not drop a `@__PURE__` call whose own argument interpolates a variable, but it
 * will drop `anchor(dateSource)`. Keeping it inline pinned `date` into every bundle. */ function $675a4de49b6b20b4$var$anchor(source) {
    return new RegExp(`^${source}$`);
}
const $675a4de49b6b20b4$export$324d90190a8b822a = /*@__PURE__*/ $675a4de49b6b20b4$var$anchor($675a4de49b6b20b4$var$dateSource);
function $675a4de49b6b20b4$var$timeSource(args) {
    const hhmm = `(?:[01]\\d|2[0-3]):[0-5]\\d`;
    const regex = typeof args.precision === "number" ? args.precision === -1 ? `${hhmm}` : args.precision === 0 ? `${hhmm}:[0-5]\\d` : `${hhmm}:[0-5]\\d\\.\\d{${args.precision}}` : args.seconds ? `${hhmm}:[0-5]\\d(?:\\.\\d+)?` : `${hhmm}(?::[0-5]\\d(?:\\.\\d+)?)?`;
    return regex;
}
function $675a4de49b6b20b4$export$2da9be4cfdb689b1(args) {
    return new RegExp(`^${$675a4de49b6b20b4$var$timeSource(args)}$`);
}
function $675a4de49b6b20b4$export$7ba4466dbd0f07e1(args) {
    const opts = [
        "Z"
    ];
    // if (args.offset) opts.push(`([+-]\\d{2}:\\d{2})`);
    if (args.offset) opts.push(`([+-](?:[01]\\d|2[0-3]):[0-5]\\d)`);
    // RFC 3339 mandates seconds wherever the time carries a `Z` or an offset, so only the unqualified form `local` adds may omit them
    const qualified = `${$675a4de49b6b20b4$var$timeSource({
        precision: args.precision,
        seconds: true
    })}(?:${opts.join("|")})`;
    const timeRegex = args.local ? `${qualified}|${$675a4de49b6b20b4$var$timeSource({
        precision: args.precision
    })}` : qualified;
    return new RegExp(`^${$675a4de49b6b20b4$var$dateSource}T(?:${timeRegex})$`);
}
const $675a4de49b6b20b4$export$24da0a402b44e53a = /^[\s\S]{0,}$/;
const $675a4de49b6b20b4$export$22b082955e083ec3 = (params)=>{
    const regex = params ? `[\\s\\S]{${params?.minimum ?? 0},${params?.maximum ?? ""}}` : `[\\s\\S]*`;
    return new RegExp(`^${regex}$`);
};
const $675a4de49b6b20b4$export$a0f65b52274bcc00 = /^-?\d+n?$/;
const $675a4de49b6b20b4$export$32744b5b3bba4764 = /^-?\d+$/;
const $675a4de49b6b20b4$export$98e628dec113755e = /^-?\d+(?:\.\d+)?$/;
const $675a4de49b6b20b4$export$4a21f16c33752377 = /^(?:true|false)$/i;
const $675a4de49b6b20b4$export$7b1b591b262c240 = /^null$/i;
const $675a4de49b6b20b4$export$1db45310990710a5 = /^undefined$/i;
const $675a4de49b6b20b4$export$5b1f80f3c282648c = /^[^A-Z]*$/;
const $675a4de49b6b20b4$export$6cfe151e6b925e83 = /^[^a-z]*$/;
const $675a4de49b6b20b4$export$834dfc94dde4b3d8 = /^[0-9a-fA-F]*$/;
// Hash regexes for different algorithms and encodings
// Helper function to create base64 regex with exact length and padding
function $675a4de49b6b20b4$var$fixedBase64(bodyLength, padding) {
    return new RegExp(`^[A-Za-z0-9+/]{${bodyLength}}${padding}$`);
}
// Helper function to create base64url regex with exact length (no padding)
function $675a4de49b6b20b4$var$fixedBase64url(length) {
    return new RegExp(`^[A-Za-z0-9_-]{${length}}$`);
}
const $675a4de49b6b20b4$export$7d7ef811f6d53a1 = /^[0-9a-fA-F]{32}$/;
const $675a4de49b6b20b4$export$85425f7cda9f4890 = /*@__PURE__*/ $675a4de49b6b20b4$var$fixedBase64(22, "==");
const $675a4de49b6b20b4$export$e54699b04083758c = /*@__PURE__*/ $675a4de49b6b20b4$var$fixedBase64url(22);
const $675a4de49b6b20b4$export$2f163473ef893e12 = /^[0-9a-fA-F]{40}$/;
const $675a4de49b6b20b4$export$fc9670fedfd2524a = /*@__PURE__*/ $675a4de49b6b20b4$var$fixedBase64(27, "=");
const $675a4de49b6b20b4$export$5b6729b977839ffd = /*@__PURE__*/ $675a4de49b6b20b4$var$fixedBase64url(27);
const $675a4de49b6b20b4$export$a923016129fea5fb = /^[0-9a-fA-F]{64}$/;
const $675a4de49b6b20b4$export$ebc25582a9e85396 = /*@__PURE__*/ $675a4de49b6b20b4$var$fixedBase64(43, "=");
const $675a4de49b6b20b4$export$9b7979bfebd9716e = /*@__PURE__*/ $675a4de49b6b20b4$var$fixedBase64url(43);
const $675a4de49b6b20b4$export$61d1fe464d10a5d1 = /^[0-9a-fA-F]{96}$/;
const $675a4de49b6b20b4$export$103403cb96133ac3 = /*@__PURE__*/ $675a4de49b6b20b4$var$fixedBase64(64, "");
const $675a4de49b6b20b4$export$eeafcb7aab6a9870 = /*@__PURE__*/ $675a4de49b6b20b4$var$fixedBase64url(64);
const $675a4de49b6b20b4$export$e246a4310a1ad74d = /^[0-9a-fA-F]{128}$/;
const $675a4de49b6b20b4$export$f698997e063dbdae = /*@__PURE__*/ $675a4de49b6b20b4$var$fixedBase64(86, "==");
const $675a4de49b6b20b4$export$a63330069e1b81f6 = /*@__PURE__*/ $675a4de49b6b20b4$var$fixedBase64url(86);

});


parcelRegister("5ehZO", function(module, exports) {
$parcel$export(module.exports, "globalRegistry", () => $3cec3829b03c3a57$export$bc58ce2776ecdb6f);
var $3cec3829b03c3a57$var$_a;
const $3cec3829b03c3a57$export$26c272954616d4a2 = /*@__PURE__*/ Symbol("ZodOutput");
const $3cec3829b03c3a57$export$4159eb10f43487af = /*@__PURE__*/ Symbol("ZodInput");
class $3cec3829b03c3a57$export$dc03955eec152cc5 {
    constructor(){
        this._map = new WeakMap();
        this._idmap = new Map();
    }
    add(schema, ..._meta) {
        const meta = _meta[0];
        this._map.set(schema, meta);
        if (meta && typeof meta === "object" && "id" in meta) this._idmap.set(meta.id, schema);
        return this;
    }
    clear() {
        this._map = new WeakMap();
        this._idmap = new Map();
        return this;
    }
    remove(schema) {
        const meta = this._map.get(schema);
        if (meta && typeof meta === "object" && "id" in meta) this._idmap.delete(meta.id);
        this._map.delete(schema);
        return this;
    }
    get(schema) {
        // return this._map.get(schema) as any;
        // inherit metadata
        const p = schema._zod.parent;
        if (p) {
            const pm = {
                ...this.get(p) ?? {}
            };
            delete pm.id; // do not inherit id
            const f = {
                ...pm,
                ...this._map.get(schema)
            };
            return Object.keys(f).length ? f : undefined;
        }
        return this._map.get(schema);
    }
    has(schema) {
        return this._map.has(schema);
    }
}
function $3cec3829b03c3a57$export$4bb7493d241fd8a5() {
    return new $3cec3829b03c3a57$export$dc03955eec152cc5();
}
($3cec3829b03c3a57$var$_a = globalThis).__zod_globalRegistry ?? ($3cec3829b03c3a57$var$_a.__zod_globalRegistry = $3cec3829b03c3a57$export$4bb7493d241fd8a5());
const $3cec3829b03c3a57$export$bc58ce2776ecdb6f = globalThis.__zod_globalRegistry;

});

parcelRegister("4S00O", function(module, exports) {
$parcel$export(module.exports, "$ZodType", () => $38bc36f53cb4eb10$export$f43a5c3966de8238);
$parcel$export(module.exports, "standardProps", () => $38bc36f53cb4eb10$export$bcaeb817fdf064d3);
$parcel$export(module.exports, "$ZodString", () => $38bc36f53cb4eb10$export$4342b4432d7b1471);
$parcel$export(module.exports, "$ZodStringFormat", () => $38bc36f53cb4eb10$export$2d69a0d3057a5c7d);
$parcel$export(module.exports, "$ZodGUID", () => $38bc36f53cb4eb10$export$4ca4397e3147da59);
$parcel$export(module.exports, "$ZodUUID", () => $38bc36f53cb4eb10$export$8794aae384e3c177);
$parcel$export(module.exports, "$ZodEmail", () => $38bc36f53cb4eb10$export$a3726aadb6108cdc);
$parcel$export(module.exports, "$ZodURL", () => $38bc36f53cb4eb10$export$7e12af57cac08b7a);
$parcel$export(module.exports, "$ZodEmoji", () => $38bc36f53cb4eb10$export$154cd448b85bb5a3);
$parcel$export(module.exports, "$ZodNanoID", () => $38bc36f53cb4eb10$export$5a160d28c6d62c88);
$parcel$export(module.exports, "$ZodCUID", () => $38bc36f53cb4eb10$export$f4f84bd3c6706e60);
$parcel$export(module.exports, "$ZodCUID2", () => $38bc36f53cb4eb10$export$faf1483c11362df6);
$parcel$export(module.exports, "$ZodULID", () => $38bc36f53cb4eb10$export$c5788701f4f55294);
$parcel$export(module.exports, "$ZodXID", () => $38bc36f53cb4eb10$export$e721fd3317199b85);
$parcel$export(module.exports, "$ZodKSUID", () => $38bc36f53cb4eb10$export$baa9849ea82bee6e);
$parcel$export(module.exports, "$ZodISODateTime", () => $38bc36f53cb4eb10$export$3273e4d2df37774b);
$parcel$export(module.exports, "$ZodISODate", () => $38bc36f53cb4eb10$export$75b9bf98f4d806dc);
$parcel$export(module.exports, "$ZodISOTime", () => $38bc36f53cb4eb10$export$e9b9c3c2359a3ebc);
$parcel$export(module.exports, "$ZodISODuration", () => $38bc36f53cb4eb10$export$d9e850ab18e4b22e);
$parcel$export(module.exports, "$ZodIPv4", () => $38bc36f53cb4eb10$export$93fc833bbf7ceb99);
$parcel$export(module.exports, "$ZodIPv6", () => $38bc36f53cb4eb10$export$8c939a460418a1bf);
$parcel$export(module.exports, "$ZodMAC", () => $38bc36f53cb4eb10$export$747370108f97e6ea);
$parcel$export(module.exports, "$ZodCIDRv4", () => $38bc36f53cb4eb10$export$e164feaf5ae5296b);
$parcel$export(module.exports, "$ZodCIDRv6", () => $38bc36f53cb4eb10$export$3c3aacb740759234);
$parcel$export(module.exports, "base64Charset", () => $38bc36f53cb4eb10$export$a9609837d77c7102);
$parcel$export(module.exports, "$ZodBase64", () => $38bc36f53cb4eb10$export$d7d4932079e2113d);
$parcel$export(module.exports, "base64urlCharset", () => $38bc36f53cb4eb10$export$be54091f6dba12e7);
$parcel$export(module.exports, "$ZodBase64URL", () => $38bc36f53cb4eb10$export$f5c3c3bbec012fa6);
$parcel$export(module.exports, "$ZodE164", () => $38bc36f53cb4eb10$export$46d3507e8483217);
$parcel$export(module.exports, "$ZodCreditCard", () => $38bc36f53cb4eb10$export$901cea49d453364b);
$parcel$export(module.exports, "$ZodIBAN", () => $38bc36f53cb4eb10$export$3742722adf5f31af);
$parcel$export(module.exports, "$ZodJWT", () => $38bc36f53cb4eb10$export$f515616cf0cda103);
$parcel$export(module.exports, "$ZodCustomStringFormat", () => $38bc36f53cb4eb10$export$9dde4397c7b8a192);
$parcel$export(module.exports, "$ZodNumber", () => $38bc36f53cb4eb10$export$b7292ed81eaafd49);
$parcel$export(module.exports, "$ZodNumberFormat", () => $38bc36f53cb4eb10$export$2cfebe79b769ec9);
$parcel$export(module.exports, "$ZodBoolean", () => $38bc36f53cb4eb10$export$828bf41e557d7dda);
$parcel$export(module.exports, "$ZodBigInt", () => $38bc36f53cb4eb10$export$7600843f2a3baa73);
$parcel$export(module.exports, "$ZodBigIntFormat", () => $38bc36f53cb4eb10$export$487194b75209a5dd);
$parcel$export(module.exports, "$ZodSymbol", () => $38bc36f53cb4eb10$export$c9e7e1831bb8dd12);
$parcel$export(module.exports, "$ZodUndefined", () => $38bc36f53cb4eb10$export$379ccf61f9830869);
$parcel$export(module.exports, "$ZodNull", () => $38bc36f53cb4eb10$export$d05db4d7bc9da27d);
$parcel$export(module.exports, "$ZodAny", () => $38bc36f53cb4eb10$export$de3a83ac65a18f35);
$parcel$export(module.exports, "$ZodUnknown", () => $38bc36f53cb4eb10$export$37ea092643879ea0);
$parcel$export(module.exports, "$ZodNever", () => $38bc36f53cb4eb10$export$4b2a18191b39c3b4);
$parcel$export(module.exports, "$ZodVoid", () => $38bc36f53cb4eb10$export$6fd82db70787afbb);
$parcel$export(module.exports, "$ZodDate", () => $38bc36f53cb4eb10$export$9a0ab9fbd61629f8);
$parcel$export(module.exports, "$ZodArray", () => $38bc36f53cb4eb10$export$fd77bdade7d2292b);
$parcel$export(module.exports, "$ZodObjectJIT", () => $38bc36f53cb4eb10$export$330feb3f8e03c085);
$parcel$export(module.exports, "$ZodUnion", () => $38bc36f53cb4eb10$export$37a2350ef0bd638c);
$parcel$export(module.exports, "$ZodXor", () => $38bc36f53cb4eb10$export$b04ced974a46c0b4);
$parcel$export(module.exports, "$ZodDiscriminatedUnion", () => $38bc36f53cb4eb10$export$aad4f17edfb83795);
$parcel$export(module.exports, "$ZodIntersection", () => $38bc36f53cb4eb10$export$2299250b426aba4b);
$parcel$export(module.exports, "$ZodTuple", () => $38bc36f53cb4eb10$export$bba1b90a721dbd94);
$parcel$export(module.exports, "$ZodRecord", () => $38bc36f53cb4eb10$export$cc20b90ec1a8c208);
$parcel$export(module.exports, "$ZodMap", () => $38bc36f53cb4eb10$export$5ccfd30a7e358409);
$parcel$export(module.exports, "$ZodSet", () => $38bc36f53cb4eb10$export$20cf27bc33a30268);
$parcel$export(module.exports, "$ZodEnum", () => $38bc36f53cb4eb10$export$31462b6e6c50b618);
$parcel$export(module.exports, "$ZodLiteral", () => $38bc36f53cb4eb10$export$86699355265fa258);
$parcel$export(module.exports, "$ZodFile", () => $38bc36f53cb4eb10$export$1997de0576a81377);
$parcel$export(module.exports, "$ZodTransform", () => $38bc36f53cb4eb10$export$14b591f873519189);
$parcel$export(module.exports, "$ZodOptional", () => $38bc36f53cb4eb10$export$980e9af565c4d7aa);
$parcel$export(module.exports, "$ZodExactOptional", () => $38bc36f53cb4eb10$export$384d083c2a6b693f);
$parcel$export(module.exports, "$ZodNullable", () => $38bc36f53cb4eb10$export$7994573b6604ec66);
$parcel$export(module.exports, "$ZodDefault", () => $38bc36f53cb4eb10$export$ae2d21004b7243f7);
$parcel$export(module.exports, "$ZodPrefault", () => $38bc36f53cb4eb10$export$29a8d757258be679);
$parcel$export(module.exports, "$ZodNonOptional", () => $38bc36f53cb4eb10$export$30ca726c4c50a6d7);
$parcel$export(module.exports, "$ZodSuccess", () => $38bc36f53cb4eb10$export$3cc4d03e729326ea);
$parcel$export(module.exports, "$ZodCatch", () => $38bc36f53cb4eb10$export$d6f8b228374f6d37);
$parcel$export(module.exports, "$ZodNaN", () => $38bc36f53cb4eb10$export$528f71701e6a7aee);
$parcel$export(module.exports, "$ZodPipe", () => $38bc36f53cb4eb10$export$4cb25cfde430326c);
$parcel$export(module.exports, "$ZodCodec", () => $38bc36f53cb4eb10$export$c622e07db8a40b53);
$parcel$export(module.exports, "$ZodPreprocess", () => $38bc36f53cb4eb10$export$200c161ed581d39b);
$parcel$export(module.exports, "$ZodReadonly", () => $38bc36f53cb4eb10$export$f9f268f3fbb1601b);
$parcel$export(module.exports, "$ZodTemplateLiteral", () => $38bc36f53cb4eb10$export$37ea86c57a77af54);
$parcel$export(module.exports, "$ZodFunction", () => $38bc36f53cb4eb10$export$877c6e9c05ede764);
$parcel$export(module.exports, "$ZodPromise", () => $38bc36f53cb4eb10$export$bdefabff0dd84ca4);
$parcel$export(module.exports, "$ZodLazy", () => $38bc36f53cb4eb10$export$662fecee2efa1a66);
$parcel$export(module.exports, "$ZodCustom", () => $38bc36f53cb4eb10$export$3a5d0e5e098b79ba);

var $b9Fsy = parcelRequire("b9Fsy");

var $igTWG = parcelRequire("igTWG");

var $17YCc = parcelRequire("17YCc");

var $8K3FB = parcelRequire("8K3FB");

var $8S8Wz = parcelRequire("8S8Wz");

var $ciVeX = parcelRequire("ciVeX");

var $lVCDL = parcelRequire("lVCDL");
const $38bc36f53cb4eb10$export$f43a5c3966de8238 = /*@__PURE__*/ $igTWG.$constructor("$ZodType", (inst, def)=>{
    var _a;
    inst ?? (inst = {});
    inst._zod.def = def; // set _def property
    inst._zod.bag = inst._zod.bag || {}; // initialize _bag object
    inst._zod.version = (0, $lVCDL.version);
    const defChecks = inst._zod.def.checks;
    // if inst is itself a checks.$ZodCheck, run it as a check
    const checks = inst._zod.traits.has("$ZodCheck") ? [
        inst,
        ...defChecks ?? []
    ] : defChecks?.length ? [
        ...defChecks
    ] : [];
    for (const ch of checks)for (const fn of ch._zod.onattach)fn(inst);
    if (checks.length === 0) {
        // deferred initializer inst._zod.parse is not yet defined
        (_a = inst._zod).deferred ?? (_a.deferred = []);
        inst._zod.deferred?.push(()=>{
            inst._zod.run = inst._zod.parse;
        });
    } else {
        const runChecks = (payload, checks, ctx)=>{
            if (payload.memo) return payload;
            let isAborted = $ciVeX.aborted(payload);
            let asyncResult;
            for (const ch of checks){
                if (ch._zod.def.when) {
                    if ($ciVeX.explicitlyAborted(payload)) continue;
                    const shouldRun = ch._zod.def.when(payload);
                    if (!shouldRun) continue;
                } else if (isAborted) continue;
                const currLen = payload.issues.length;
                const _ = ch._zod.check(payload);
                if (_ instanceof Promise && ctx?.async === false) throw new $igTWG.$ZodAsyncError();
                if (asyncResult || _ instanceof Promise) asyncResult = (asyncResult ?? Promise.resolve()).then(async ()=>{
                    await _;
                    const nextLen = payload.issues.length;
                    if (nextLen === currLen) return;
                    $ciVeX.attachSchema(payload.issues, currLen, inst);
                    if (!isAborted) isAborted = $ciVeX.aborted(payload, currLen);
                });
                else {
                    const nextLen = payload.issues.length;
                    if (nextLen === currLen) continue;
                    $ciVeX.attachSchema(payload.issues, currLen, inst);
                    if (!isAborted) isAborted = $ciVeX.aborted(payload, currLen);
                }
            }
            if (asyncResult) return asyncResult.then(()=>{
                return payload;
            });
            return payload;
        };
        const handleCanaryResult = (canary, payload, ctx)=>{
            // abort if the canary is aborted
            if ($ciVeX.aborted(canary)) {
                canary.aborted = true;
                return canary;
            }
            // run checks first, then
            const checkResult = runChecks(payload, checks, ctx);
            if (checkResult instanceof Promise) {
                if (ctx.async === false) throw new $igTWG.$ZodAsyncError();
                return checkResult.then((checkResult)=>inst._zod.parse(checkResult, ctx));
            }
            return inst._zod.parse(checkResult, ctx);
        };
        inst._zod.run = (payload, ctx)=>{
            if (ctx.skipChecks) return inst._zod.parse(payload, ctx);
            if (ctx.direction === "backward") {
                // run canary initial pass (no checks)
                const canary = inst._zod.parse({
                    value: payload.value,
                    issues: []
                }, {
                    ...ctx,
                    skipChecks: true
                });
                if (canary instanceof Promise) return canary.then((canary)=>{
                    return handleCanaryResult(canary, payload, ctx);
                });
                return handleCanaryResult(canary, payload, ctx);
            }
            // forward
            const result = inst._zod.parse(payload, ctx);
            if (result instanceof Promise) {
                if (ctx.async === false) throw new $igTWG.$ZodAsyncError();
                return result.then((result)=>runChecks(result, checks, ctx));
            }
            return runChecks(result, checks, ctx);
        };
    }
}, {
    // Wrappers extend this by installing a richer factory over it; reading it eagerly would defeat the laziness.
    get "~standard" () {
        return $ciVeX.hide(this, "~standard", $38bc36f53cb4eb10$export$bcaeb817fdf064d3(this));
    },
    set "~standard" (value){
        $ciVeX.own(this, "~standard", value);
    }
});
/** The Standard Schema surface for `inst`. Shared so wrappers can extend it without forcing it. */ // a Standard Schema result only reports issues, so a failure finalizes them straight off the raw payload: no ZodError, and no lazy result to read through
const $38bc36f53cb4eb10$var$toStandardResult = (r, ctx)=>r.issues.length ? {
        issues: r.issues.map((iss)=>$ciVeX.finalizeIssue(iss, ctx, $igTWG.config()))
    } : {
        value: r.value
    };
async function $38bc36f53cb4eb10$var$validateAsync(inst, value1) {
    const ctx = {
        async: true
    };
    return $38bc36f53cb4eb10$var$toStandardResult(await inst._zod.run({
        value: value1,
        issues: []
    }, ctx), ctx);
}
function $38bc36f53cb4eb10$export$bcaeb817fdf064d3(inst) {
    return {
        validate: (value1)=>{
            const ctx = {
                async: false
            };
            try {
                const r = inst._zod.run({
                    value: value1,
                    issues: []
                }, ctx);
                if (!(r instanceof Promise)) return $38bc36f53cb4eb10$var$toStandardResult(r, ctx);
            } catch (_) {}
            // async function so a synchronously throwing check rejects instead of escaping validate
            return $38bc36f53cb4eb10$var$validateAsync(inst, value1);
        },
        vendor: "zod",
        version: 1
    };
}
const $38bc36f53cb4eb10$export$4342b4432d7b1471 = /*@__PURE__*/ $igTWG.$constructor("$ZodString", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    // a format's own pattern, else unbounded; a template literal derives the check-aware form itself
    inst._zod.pattern = def.pattern ?? $8S8Wz.anyString;
    inst._zod.parse = (payload, _)=>{
        if (def.coerce) try {
            payload.value = String(payload.value);
        } catch (_) {}
        if (typeof payload.value === "string") return payload;
        payload.issues.push({
            expected: "string",
            code: "invalid_type",
            input: payload.value,
            inst: inst
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$2d69a0d3057a5c7d = /*@__PURE__*/ $igTWG.$constructor("$ZodStringFormat", (inst, def)=>{
    // check initialization must come first
    $b9Fsy.$ZodCheckStringFormat.init(inst, def);
    $38bc36f53cb4eb10$export$4342b4432d7b1471.init(inst, def);
});
const $38bc36f53cb4eb10$export$4ca4397e3147da59 = /*@__PURE__*/ $igTWG.$constructor("$ZodGUID", (inst, def)=>{
    def.pattern ?? (def.pattern = $8S8Wz.guid);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$8794aae384e3c177 = /*@__PURE__*/ $igTWG.$constructor("$ZodUUID", (inst, def)=>{
    if (def.version) {
        const versionMap = {
            v1: 1,
            v2: 2,
            v3: 3,
            v4: 4,
            v5: 5,
            v6: 6,
            v7: 7,
            v8: 8
        };
        const v = versionMap[def.version];
        if (v === undefined) throw new Error(`Invalid UUID version: "${def.version}"`);
        def.pattern ?? (def.pattern = $8S8Wz.uuid(v));
    } else def.pattern ?? (def.pattern = $8S8Wz.uuid());
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$a3726aadb6108cdc = /*@__PURE__*/ $igTWG.$constructor("$ZodEmail", (inst, def)=>{
    def.pattern ?? (def.pattern = $8S8Wz.email);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$f460f59bb193614e = 1;
const $38bc36f53cb4eb10$export$95483bc06fdd8d2 = 2;
function $38bc36f53cb4eb10$export$981c5d1bd3894713(input) {
    try {
        if (typeof URL !== "undefined" && typeof URL.canParse === "function") return URL.canParse(input);
        new URL(input);
        return true;
    } catch  {
        return false;
    }
}
function $38bc36f53cb4eb10$export$c6e27db96f1f206c(trimmed, def) {
    if (!("normalize" in def) && !("hostname" in def) && !("protocol" in def)) return $38bc36f53cb4eb10$export$981c5d1bd3894713(trimmed) || $38bc36f53cb4eb10$export$95483bc06fdd8d2;
    return $38bc36f53cb4eb10$export$f2bb86aa76d51ae5(trimmed, def);
}
function $38bc36f53cb4eb10$export$f2bb86aa76d51ae5(trimmed, def) {
    // When normalize is off, require :// for http/https URLs. This prevents strings like "http:example.com" or "https:/path" from being silently accepted
    if (!def.normalize && def.protocol?.source === $8S8Wz.httpProtocol.source && !/^https?:\/\//i.test(trimmed)) return $38bc36f53cb4eb10$export$f460f59bb193614e;
    try {
        if (typeof URL !== "undefined") {
            const URLStatic = URL;
            if (typeof URLStatic.parse === "function") return URLStatic.parse(trimmed) ?? $38bc36f53cb4eb10$export$95483bc06fdd8d2;
        }
        // @ts-ignore
        return new URL(trimmed);
    } catch  {
        return $38bc36f53cb4eb10$export$95483bc06fdd8d2;
    }
}
const $38bc36f53cb4eb10$var$asciiTabOrNewline = /[\t\n\r]/g;
function $38bc36f53cb4eb10$export$165c9bc4c1279215(value1) {
    return value1.replace($38bc36f53cb4eb10$var$asciiTabOrNewline, "");
}
function $38bc36f53cb4eb10$export$1c04d86e3f4d2da0(url, hostname) {
    hostname.lastIndex = 0;
    return hostname.test(url.hostname);
}
function $38bc36f53cb4eb10$export$d090bf6bb05011ae(url, protocol) {
    protocol.lastIndex = 0;
    return protocol.test(url.protocol.endsWith(":") ? url.protocol.slice(0, -1) : url.protocol);
}
const $38bc36f53cb4eb10$export$7e12af57cac08b7a = /*@__PURE__*/ $igTWG.$constructor("$ZodURL", (inst, def)=>{
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        try {
            // Trim whitespace from input
            const trimmed = payload.value.trim();
            const url = $38bc36f53cb4eb10$export$c6e27db96f1f206c(trimmed, def);
            if (url === $38bc36f53cb4eb10$export$f460f59bb193614e) {
                payload.issues.push({
                    code: "invalid_format",
                    format: "url",
                    note: "Invalid URL format",
                    input: payload.value,
                    inst: inst,
                    continue: !def.abort
                });
                return;
            }
            if (url === $38bc36f53cb4eb10$export$95483bc06fdd8d2) {
                payload.issues.push({
                    code: "invalid_format",
                    format: "url",
                    input: payload.value,
                    inst: inst,
                    continue: !def.abort
                });
                return;
            }
            if (url === true) {
                payload.value = $38bc36f53cb4eb10$export$165c9bc4c1279215(trimmed);
                return;
            }
            if (def.hostname && !$38bc36f53cb4eb10$export$1c04d86e3f4d2da0(url, def.hostname)) payload.issues.push({
                code: "invalid_format",
                format: "url",
                note: "Invalid hostname",
                pattern: def.hostname.source,
                input: payload.value,
                inst: inst,
                continue: !def.abort
            });
            if (def.protocol && !$38bc36f53cb4eb10$export$d090bf6bb05011ae(url, def.protocol)) payload.issues.push({
                code: "invalid_format",
                format: "url",
                note: "Invalid protocol",
                pattern: def.protocol.source,
                input: payload.value,
                inst: inst,
                continue: !def.abort
            });
            // Set the output value based on normalize flag
            payload.value = def.normalize ? url.href : $38bc36f53cb4eb10$export$165c9bc4c1279215(trimmed);
            return;
        } catch (_) {
            payload.issues.push({
                code: "invalid_format",
                format: "url",
                input: payload.value,
                inst: inst,
                continue: !def.abort
            });
        }
    };
});
const $38bc36f53cb4eb10$export$154cd448b85bb5a3 = /*@__PURE__*/ $igTWG.$constructor("$ZodEmoji", (inst, def)=>{
    def.pattern ?? (def.pattern = $8S8Wz.emoji());
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$5a160d28c6d62c88 = /*@__PURE__*/ $igTWG.$constructor("$ZodNanoID", (inst, def)=>{
    if (def.length !== undefined && (!Number.isInteger(def.length) || def.length < 1)) throw new Error(`Invalid nanoid length: ${def.length}`);
    def.pattern ?? (def.pattern = def.length === undefined ? $8S8Wz.nanoid : $8S8Wz.nanoidOfLength(def.length));
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$f4f84bd3c6706e60 = /*@__PURE__*/ $igTWG.$constructor("$ZodCUID", (inst, def)=>{
    def.pattern ?? (def.pattern = $8S8Wz.cuid);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$faf1483c11362df6 = /*@__PURE__*/ $igTWG.$constructor("$ZodCUID2", (inst, def)=>{
    def.pattern ?? (def.pattern = $8S8Wz.cuid2);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$c5788701f4f55294 = /*@__PURE__*/ $igTWG.$constructor("$ZodULID", (inst, def)=>{
    def.pattern ?? (def.pattern = $8S8Wz.ulid);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$e721fd3317199b85 = /*@__PURE__*/ $igTWG.$constructor("$ZodXID", (inst, def)=>{
    def.pattern ?? (def.pattern = $8S8Wz.xid);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$baa9849ea82bee6e = /*@__PURE__*/ $igTWG.$constructor("$ZodKSUID", (inst, def)=>{
    def.pattern ?? (def.pattern = $8S8Wz.ksuid);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$3273e4d2df37774b = /*@__PURE__*/ $igTWG.$constructor("$ZodISODateTime", (inst, def)=>{
    def.pattern ?? (def.pattern = $8S8Wz.datetime(def));
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$75b9bf98f4d806dc = /*@__PURE__*/ $igTWG.$constructor("$ZodISODate", (inst, def)=>{
    def.pattern ?? (def.pattern = $8S8Wz.date);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$e9b9c3c2359a3ebc = /*@__PURE__*/ $igTWG.$constructor("$ZodISOTime", (inst, def)=>{
    def.pattern ?? (def.pattern = $8S8Wz.time(def));
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$d9e850ab18e4b22e = /*@__PURE__*/ $igTWG.$constructor("$ZodISODuration", (inst, def)=>{
    def.pattern ?? (def.pattern = $8S8Wz.duration);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$93fc833bbf7ceb99 = /*@__PURE__*/ $igTWG.$constructor("$ZodIPv4", (inst, def)=>{
    def.pattern ?? (def.pattern = $8S8Wz.ipv4);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
/** An IPv6 address is written with hex digits, colons and dots, and nothing else. The guard is what makes the check below an IPv6 check: `new URL("http://[...]")` parses an authority, not an address, so `@` and `\` re-delimit it and `"::@1\\"` validates against the host `0.0.0.1`. The URL parser also deletes ASCII tab, LF and CR rather than failing, which is how `"::1\n"` validated as `::1`. */ const $38bc36f53cb4eb10$var$ipv6Alphabet = /^[0-9a-fA-F:.]+$/;
function $38bc36f53cb4eb10$export$a04342fa1d51a93c(value1) {
    if (!$38bc36f53cb4eb10$var$ipv6Alphabet.test(value1)) return false;
    return $38bc36f53cb4eb10$export$981c5d1bd3894713(`http://[${value1}]`);
}
const $38bc36f53cb4eb10$export$8c939a460418a1bf = /*@__PURE__*/ $igTWG.$constructor("$ZodIPv6", (inst, def)=>{
    def.pattern ?? (def.pattern = $8S8Wz.ipv6);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if (!$38bc36f53cb4eb10$export$a04342fa1d51a93c(payload.value)) payload.issues.push({
            code: "invalid_format",
            format: "ipv6",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $38bc36f53cb4eb10$export$747370108f97e6ea = /*@__PURE__*/ $igTWG.$constructor("$ZodMAC", (inst, def)=>{
    def.pattern ?? (def.pattern = $8S8Wz.mac(def.delimiter));
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$e164feaf5ae5296b = /*@__PURE__*/ $igTWG.$constructor("$ZodCIDRv4", (inst, def)=>{
    def.pattern ?? (def.pattern = $8S8Wz.cidrv4);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
function $38bc36f53cb4eb10$export$5a4fa0b686dce6df(value1) {
    const parts = value1.split("/");
    if (parts.length !== 2) return false;
    const [address, prefix] = parts;
    if (!prefix) return false;
    const prefixNum = Number(prefix);
    if (`${prefixNum}` !== prefix) return false;
    if (prefixNum < 0 || prefixNum > 128) return false;
    return $38bc36f53cb4eb10$export$a04342fa1d51a93c(address);
}
const $38bc36f53cb4eb10$export$3c3aacb740759234 = /*@__PURE__*/ $igTWG.$constructor("$ZodCIDRv6", (inst, def)=>{
    def.pattern ?? (def.pattern = $8S8Wz.cidrv6); // not used for validation
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if (!$38bc36f53cb4eb10$export$5a4fa0b686dce6df(payload.value)) payload.issues.push({
            code: "invalid_format",
            format: "cidrv6",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
function $38bc36f53cb4eb10$export$5f5b3f6a560c676b(data) {
    if (data === "") return true;
    // atob ignores whitespace, so reject it up front.
    if (/\s/.test(data)) return false;
    if (data.length % 4 !== 0) return false;
    try {
        // @ts-ignore
        atob(data);
        return true;
    } catch  {
        return false;
    }
}
const $38bc36f53cb4eb10$export$a9609837d77c7102 = /^[0-9a-zA-Z+/]*={0,2}$/;
const $38bc36f53cb4eb10$export$d7d4932079e2113d = /*@__PURE__*/ $igTWG.$constructor("$ZodBase64", (inst, def)=>{
    def.pattern ?? (def.pattern = $38bc36f53cb4eb10$export$a9609837d77c7102);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if ($38bc36f53cb4eb10$export$5f5b3f6a560c676b(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "base64",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $38bc36f53cb4eb10$export$be54091f6dba12e7 = /^[A-Za-z0-9_-]*$/;
function $38bc36f53cb4eb10$export$eb95420c5686a3be(data) {
    if (!$38bc36f53cb4eb10$export$be54091f6dba12e7.test(data)) return false;
    const base64 = data.replace(/[-_]/g, (c)=>c === "-" ? "+" : "/");
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
    return $38bc36f53cb4eb10$export$5f5b3f6a560c676b(padded);
}
const $38bc36f53cb4eb10$export$f5c3c3bbec012fa6 = /*@__PURE__*/ $igTWG.$constructor("$ZodBase64URL", (inst, def)=>{
    def.pattern ?? (def.pattern = $38bc36f53cb4eb10$export$be54091f6dba12e7);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if ($38bc36f53cb4eb10$export$eb95420c5686a3be(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "base64url",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $38bc36f53cb4eb10$export$46d3507e8483217 = /*@__PURE__*/ $igTWG.$constructor("$ZodE164", (inst, def)=>{
    def.pattern ?? (def.pattern = $8S8Wz.e164);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
//////////////////////////////   ZodCreditCard   //////////////////////////////
const $38bc36f53cb4eb10$var$CC_SANITIZE = /[- ]/g;
/** Luhn checksum on a digit-only string. Adapted from valibot (MIT). */ function $38bc36f53cb4eb10$var$isLuhnAlgo(digits) {
    let length = digits.length;
    let bit = 1;
    let sum = 0;
    while(length){
        const value1 = digits.charCodeAt(--length) - 48;
        bit ^= 1;
        sum += bit ? [
            0,
            2,
            4,
            6,
            8,
            1,
            3,
            5,
            7,
            9
        ][value1] : value1;
    }
    return sum % 10 === 0;
}
function $38bc36f53cb4eb10$export$16723e63da389301(input) {
    if (!$8S8Wz.creditCard.test(input)) return false;
    return $38bc36f53cb4eb10$var$isLuhnAlgo(input.replace($38bc36f53cb4eb10$var$CC_SANITIZE, ""));
}
const $38bc36f53cb4eb10$export$901cea49d453364b = /*@__PURE__*/ $igTWG.$constructor("$ZodCreditCard", (inst, def)=>{
    // Shape only — the Luhn check below is not expressible as a pattern, so consumers of `pattern` (JSON Schema, template literals) get the length and separator rules alone.
    def.pattern ?? (def.pattern = $8S8Wz.creditCard);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if ($38bc36f53cb4eb10$export$16723e63da389301(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "credit_card",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
//////////////////////////////   ZodIBAN   //////////////////////////////
// iso 7064 mod 97-10 checksum without BigInt
function $38bc36f53cb4eb10$var$isIso7064Mod97(iban) {
    let remainder = 0;
    const len = iban.length;
    for(let i = 4; i < len; i++){
        const code = iban.charCodeAt(i);
        remainder = (code >= 65 ? remainder * 100 + (code - 55) : remainder * 10 + (code - 48)) % 97;
    }
    for(let i = 0; i < 4; i++){
        const code = iban.charCodeAt(i);
        remainder = (code >= 65 ? remainder * 100 + (code - 55) : remainder * 10 + (code - 48)) % 97;
    }
    return remainder === 1;
}
function $38bc36f53cb4eb10$export$90cbbdc8889fba6c(input) {
    if (!$8S8Wz.iban.test(input)) return false;
    return $38bc36f53cb4eb10$var$isIso7064Mod97(input);
}
const $38bc36f53cb4eb10$export$3742722adf5f31af = /*@__PURE__*/ $igTWG.$constructor("$ZodIBAN", (inst, def)=>{
    // shape only — checksum is not expressible as a pattern
    def.pattern ?? (def.pattern = $8S8Wz.iban);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if ($38bc36f53cb4eb10$export$90cbbdc8889fba6c(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "iban",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
function $38bc36f53cb4eb10$export$5fc0c2a4042aff0a(token, algorithm = null) {
    try {
        const tokensParts = token.split(".");
        if (tokensParts.length !== 3) return false;
        const [header] = tokensParts;
        if (!header) return false;
        // @ts-ignore
        const parsedHeader = JSON.parse(atob(header));
        if ("typ" in parsedHeader && parsedHeader?.typ !== "JWT") return false;
        if (!parsedHeader.alg) return false;
        if (algorithm && (!("alg" in parsedHeader) || parsedHeader.alg !== algorithm)) return false;
        return true;
    } catch  {
        return false;
    }
}
const $38bc36f53cb4eb10$export$f515616cf0cda103 = /*@__PURE__*/ $igTWG.$constructor("$ZodJWT", (inst, def)=>{
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if ($38bc36f53cb4eb10$export$5fc0c2a4042aff0a(payload.value, def.alg)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "jwt",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $38bc36f53cb4eb10$export$9dde4397c7b8a192 = /*@__PURE__*/ $igTWG.$constructor("$ZodCustomStringFormat", (inst, def)=>{
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if (def.fn(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: def.format,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $38bc36f53cb4eb10$export$b7292ed81eaafd49 = /*@__PURE__*/ $igTWG.$constructor("$ZodNumber", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $8S8Wz.number;
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = Number(payload.value);
        } catch (_) {}
        const input = payload.value;
        if (typeof input === "number" && !Number.isNaN(input) && Number.isFinite(input)) return payload;
        const received = typeof input === "number" ? Number.isNaN(input) ? "NaN" : !Number.isFinite(input) ? String(input) : undefined : undefined;
        payload.issues.push({
            expected: "number",
            code: "invalid_type",
            input: input,
            inst: inst,
            ...received ? {
                received: received
            } : {}
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$2cfebe79b769ec9 = /*@__PURE__*/ $igTWG.$constructor("$ZodNumberFormat", (inst, def)=>{
    $b9Fsy.$ZodCheckNumberFormat.init(inst, def);
    $38bc36f53cb4eb10$export$b7292ed81eaafd49.init(inst, def); // no format checks
});
const $38bc36f53cb4eb10$export$828bf41e557d7dda = /*@__PURE__*/ $igTWG.$constructor("$ZodBoolean", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $8S8Wz.boolean;
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = Boolean(payload.value);
        } catch (_) {}
        const input = payload.value;
        if (typeof input === "boolean") return payload;
        payload.issues.push({
            expected: "boolean",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$7600843f2a3baa73 = /*@__PURE__*/ $igTWG.$constructor("$ZodBigInt", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $8S8Wz.bigint;
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = BigInt(payload.value);
        } catch (_) {}
        if (typeof payload.value === "bigint") return payload;
        payload.issues.push({
            expected: "bigint",
            code: "invalid_type",
            input: payload.value,
            inst: inst
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$487194b75209a5dd = /*@__PURE__*/ $igTWG.$constructor("$ZodBigIntFormat", (inst, def)=>{
    $b9Fsy.$ZodCheckBigIntFormat.init(inst, def);
    $38bc36f53cb4eb10$export$7600843f2a3baa73.init(inst, def); // no format checks
});
const $38bc36f53cb4eb10$export$c9e7e1831bb8dd12 = /*@__PURE__*/ $igTWG.$constructor("$ZodSymbol", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (typeof input === "symbol") return payload;
        payload.issues.push({
            expected: "symbol",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$379ccf61f9830869 = /*@__PURE__*/ $igTWG.$constructor("$ZodUndefined", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $8S8Wz.undefined;
    inst._zod.values = new Set([
        undefined
    ]);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (typeof input === "undefined") return payload;
        payload.issues.push({
            expected: "undefined",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$d05db4d7bc9da27d = /*@__PURE__*/ $igTWG.$constructor("$ZodNull", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $8S8Wz.null;
    inst._zod.values = new Set([
        null
    ]);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (input === null) return payload;
        payload.issues.push({
            expected: "null",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$de3a83ac65a18f35 = /*@__PURE__*/ $igTWG.$constructor("$ZodAny", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload)=>payload;
});
const $38bc36f53cb4eb10$export$37ea092643879ea0 = /*@__PURE__*/ $igTWG.$constructor("$ZodUnknown", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload)=>payload;
});
const $38bc36f53cb4eb10$export$4b2a18191b39c3b4 = /*@__PURE__*/ $igTWG.$constructor("$ZodNever", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        payload.issues.push({
            expected: "never",
            code: "invalid_type",
            input: payload.value,
            inst: inst
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$6fd82db70787afbb = /*@__PURE__*/ $igTWG.$constructor("$ZodVoid", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (typeof input === "undefined") return payload;
        payload.issues.push({
            expected: "void",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$9a0ab9fbd61629f8 = /*@__PURE__*/ $igTWG.$constructor("$ZodDate", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = new Date(payload.value);
        } catch (_err) {}
        const input = payload.value;
        const isDate = input instanceof Date;
        const isValidDate = isDate && !Number.isNaN(input.getTime());
        if (isValidDate) return payload;
        payload.issues.push({
            expected: "date",
            code: "invalid_type",
            input: input,
            ...isDate ? {
                received: "Invalid Date"
            } : {},
            inst: inst
        });
        return payload;
    };
});
function $38bc36f53cb4eb10$var$handleArrayResult(result, final, index) {
    if (result.issues.length) final.issues.push(...$ciVeX.prefixIssues(index, result.issues));
    final.value[index] = result.value;
}
const $38bc36f53cb4eb10$export$fd77bdade7d2292b = /*@__PURE__*/ $igTWG.$constructor("$ZodArray", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    const memo = $igTWG.globalConfig.memoizer;
    memo?.attach(inst);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!Array.isArray(input)) {
            payload.issues.push({
                expected: "array",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        payload.value = memo ? memo.alloc(inst, payload, Array(input.length), ctx) : Array(input.length);
        const proms = [];
        const abortEarly = ctx?.abortEarly;
        for(let i = 0; i < input.length; i++){
            const item = input[i];
            const result = def.element._zod.run({
                value: item,
                issues: []
            }, ctx);
            if (result instanceof Promise) proms.push(result.then((result)=>$38bc36f53cb4eb10$var$handleArrayResult(result, payload, i)));
            else {
                $38bc36f53cb4eb10$var$handleArrayResult(result, payload, i);
                // the element's payload is authoritative here, since handleArrayResult forwards every issue; an object's is not, because it drops a failed absent optional
                if (abortEarly && result.issues.length !== 0 && $ciVeX.aborted(result)) break;
            }
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload; //handleArrayResultsAsync(parseResults, final);
    };
});
function $38bc36f53cb4eb10$var$handlePropertyResult(result, final, key, input, optin, optout) {
    const isPresent = key in input;
    const isOptionalOut = optout === "optional";
    // The middle rung means "absence permitted, nothing supplied in its place", so an absent key contributes nothing — whatever the schema made of `undefined` is invented, not substituted. Only `optional` reaches this with a value: `defaulted` substitutes, and a schema that isn't optional-out has to keep the key.
    if (!isPresent && isOptionalOut && optin === "optional") return;
    if (result.issues.length) {
        // For optional-in/out schemas, ignore errors on absent keys.
        if (optin !== undefined && isOptionalOut && !isPresent) return;
        final.issues.push(...$ciVeX.prefixIssues(key, result.issues));
    }
    if (!isPresent && optin === undefined) {
        if (!result.issues.length) final.issues.push({
            code: "invalid_type",
            expected: "nonoptional",
            input: undefined,
            path: [
                key
            ]
        });
        return;
    }
    if (result.value === undefined) {
        if (isPresent || optin === "defaulted" && !isOptionalOut) final.value[key] = undefined;
    } else final.value[key] = result.value;
}
// one shared instance; a fresh [] per schema cost 56 bytes retained
const $38bc36f53cb4eb10$var$NO_SYMBOL_KEYS = [];
function $38bc36f53cb4eb10$var$normalizeDef(def) {
    const keys = Object.keys(def.shape);
    const ownSymbols = Object.getOwnPropertySymbols(def.shape);
    const symbolKeys = ownSymbols.length ? ownSymbols : $38bc36f53cb4eb10$var$NO_SYMBOL_KEYS;
    // aliases `keys` when there are no symbols, so a string-only shape keeps one array
    const allKeys = symbolKeys.length ? [
        ...keys,
        ...symbolKeys
    ] : keys;
    for (const k of allKeys){
        if (!def.shape?.[k]?._zod?.traits?.has("$ZodType")) throw new Error(`Invalid element at key "${String(k)}": expected a Zod schema`);
    }
    const okeys = $ciVeX.optionalKeys(def.shape);
    return {
        ...def,
        allKeys: allKeys,
        symbolKeys: symbolKeys,
        // string-only: handleCatchall matches it against `for...in`, which never yields a symbol
        keySet: new Set(keys),
        numKeys: keys.length,
        optionalKeys: new Set(okeys)
    };
}
function $38bc36f53cb4eb10$var$handleCatchall(proms, input, payload, ctx, def, inst, abortEarly) {
    const unrecognized = [];
    const keySet = def.keySet;
    const _catchall = def.catchall._zod;
    const t = _catchall.def.type;
    const optin = _catchall.optin;
    const optout = _catchall.optout;
    // starts at 0, not the current length: the shape phase already ran and may have aborted
    let seen = 0;
    for(const key in input){
        if (abortEarly && payload.issues.length !== seen) {
            if ($ciVeX.aborted(payload, seen)) break;
            seen = payload.issues.length;
        }
        // Must precede the __proto__ branch: a declared key is not unrecognized, even though the shape loop deliberately strips __proto__ from the parsed output.
        if (keySet.has(key)) continue;
        // Don't copy an undeclared __proto__ into the result; assignment to a plain {} would replace the result prototype. But in strict mode it is still an unknown key, so report it before skipping.
        if (key === "__proto__") {
            if (t === "never") unrecognized.push(key);
            continue;
        }
        if (t === "never") {
            unrecognized.push(key);
            continue;
        }
        const r = _catchall.run({
            value: input[key],
            issues: []
        }, ctx);
        if (r instanceof Promise) proms.push(r.then((r)=>$38bc36f53cb4eb10$var$handlePropertyResult(r, payload, key, input, optin, optout)));
        else $38bc36f53cb4eb10$var$handlePropertyResult(r, payload, key, input, optin, optout);
    }
    if (unrecognized.length) payload.issues.push({
        code: "unrecognized_keys",
        keys: unrecognized,
        input: input,
        inst: inst,
        // Describes the shape of the input, not the validity of the parsed value, so it never aborts. The parse still fails; the schema's own checks just get to run first, and an enclosing intersection can reconcile the key against a sibling operand.
        continue: true
    });
    if (!proms.length) return payload;
    return Promise.all(proms).then(()=>{
        return payload;
    });
}
const $38bc36f53cb4eb10$export$54037a1ef79a4f1a = /*@__PURE__*/ $igTWG.$constructor("$ZodObject", (inst, def)=>{
    // requires cast because technically $ZodObject doesn't extend
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    const desc = Object.getOwnPropertyDescriptor(def, "shape");
    // a cloned def carries its source's accessor, which knows the shape it answers from; adopting that keeps the clone's keys readable without running it
    const sh = desc?.get ? desc.get.raw : def.shape ?? {};
    if (sh) {
        // Freezes the shape on first read, so its getters resolve once and every later read sees the same schemas.
        const get = ()=>{
            const newSh = {
                ...sh
            };
            Object.defineProperty(def, "shape", {
                value: newSh
            });
            get.raw = newSh;
            return newSh;
        };
        get.raw = sh;
        Object.defineProperty(def, "shape", {
            get: get
        });
    }
    const _normalized = $ciVeX.cached(()=>$38bc36f53cb4eb10$var$normalizeDef(def));
    $ciVeX.defineLazyInternal(inst, "propValues", (zod)=>{
        const shape = zod.def.shape;
        const propValues = {};
        for(const key in shape){
            const field = shape[key]._zod;
            if (field.values) {
                if (!Object.prototype.hasOwnProperty.call(propValues, key)) $ciVeX.assignProp(propValues, key, new Set());
                for (const v of field.values)propValues[key].add(v);
                // An omittable slot reads back as undefined at a discriminator lookup, so it has to claim undefined: two options that can both omit the key are not discriminable on it.
                if (field.optin !== undefined) propValues[key].add(undefined);
            }
        }
        return propValues;
    });
    const isObject = $ciVeX.isObject;
    const catchall = def.catchall;
    let value1;
    const memo = $igTWG.globalConfig.memoizer;
    memo?.attach(inst);
    inst._zod.parse = (payload, ctx)=>{
        value1 ?? (value1 = _normalized.value);
        const input = payload.value;
        if (!isObject(input)) {
            payload.issues.push({
                expected: "object",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        payload.value = memo ? memo.alloc(inst, payload, {}, ctx) : {};
        const proms = [];
        const shape = value1.shape;
        const abortEarly = ctx?.abortEarly;
        let seen = payload.issues.length;
        for (const key of value1.allKeys){
            if (abortEarly && payload.issues.length !== seen) {
                if ($ciVeX.aborted(payload, seen)) break;
                seen = payload.issues.length;
            }
            if (key === "__proto__") continue;
            const el = shape[key];
            const optin = el._zod.optin;
            const optout = el._zod.optout;
            const r = el._zod.run({
                value: input[key],
                issues: []
            }, ctx);
            if (r instanceof Promise) proms.push(r.then((r)=>$38bc36f53cb4eb10$var$handlePropertyResult(r, payload, key, input, optin, optout)));
            else $38bc36f53cb4eb10$var$handlePropertyResult(r, payload, key, input, optin, optout);
        }
        if (!catchall) return proms.length ? Promise.all(proms).then(()=>payload) : payload;
        return $38bc36f53cb4eb10$var$handleCatchall(proms, input, payload, ctx, _normalized.value, inst, abortEarly === true);
    };
});
const $38bc36f53cb4eb10$export$330feb3f8e03c085 = /*@__PURE__*/ $igTWG.$constructor("$ZodObjectJIT", (inst, def)=>{
    // requires cast because technically $ZodObject doesn't extend
    $38bc36f53cb4eb10$export$54037a1ef79a4f1a.init(inst, def);
    const superParse = inst._zod.parse;
    const _normalized = $ciVeX.cached(()=>$38bc36f53cb4eb10$var$normalizeDef(def));
    const memo = $igTWG.globalConfig.memoizer;
    const generateFastpass = (shape)=>{
        const normalized = _normalized.value;
        const syms = normalized.symbolKeys;
        // a symbol has no source literal, so it is read as `syms[i]` off the closed-over scope
        const doc = new (0, $17YCc.Doc)([
            "payload",
            "ctx"
        ], {
            shape: shape,
            inst: inst,
            memo: memo,
            syms: syms
        });
        const parseStr = (k)=>`shape[${k}]._zod.run({ value: input[${k}], issues: [] }, ctx)`;
        // prefixes in place, like util.prefixIssues. newResult must land before the early return: a catchall runs after this and would otherwise write onto the caller's input
        const prefixStr = (id, k)=>`
          let ${id}_ab = false;
          for (let i = 0; i < ${id}.issues.length; i++) {
            const iss = ${id}.issues[i];
            iss.path = iss.path ? [${k}, ...iss.path] : [${k}];
            payload.issues.push(iss);
            if (iss.continue !== true) ${id}_ab = true;
          }
          if (${id}_ab && ctx && ctx.abortEarly) {
            payload.value = newResult;
            return payload;
          }`;
        doc.write(`const input = payload.value;`);
        const ids = Object.create(null);
        let counter = 0;
        for (const key of normalized.allKeys)ids[key] = `key_${counter++}`;
        // A: preserve key order {
        doc.write(memo ? `const newResult = memo.alloc(inst, payload, {}, ctx);` : `const newResult = {};`);
        for (const key of normalized.allKeys){
            if (key === "__proto__") continue;
            const id = ids[key];
            const k = typeof key === "symbol" ? `syms[${syms.indexOf(key)}]` : $ciVeX.esc(key);
            const isPresent = `${k} in input`;
            const schema = shape[key];
            const optin = schema?._zod?.optin;
            const isOptionalIn = optin !== undefined;
            const isOptionalOut = schema?._zod?.optout === "optional";
            doc.write(`const ${id} = ${parseStr(k)};`);
            if (isOptionalIn && isOptionalOut) {
                // For optional-in/out schemas, ignore errors on absent keys — and, like the interpreted path, drop the value produced alongside them. The middle rung goes further: it permits absence without supplying anything in its place, so an absent key contributes nothing at all.
                const assign = optin === "optional" ? `${id}_present` : `${id}.value !== undefined || ${id}_present`;
                doc.write(`
        const ${id}_present = ${isPresent};
        if (!${id}.issues.length || ${id}_present) {
          if (${id}.issues.length) {${prefixStr(id, k)}
          }

          if (${assign}) {
            newResult[${k}] = ${id}.value;
          }
        }

      `);
            } else if (!isOptionalIn) doc.write(`
        const ${id}_present = ${isPresent};
        if (${id}.issues.length) {${prefixStr(id, k)}
        }
        if (!${id}_present && !${id}.issues.length) {
          payload.issues.push({
            code: "invalid_type",
            expected: "nonoptional",
            input: undefined,
            path: [${k}]
          });
          if (ctx && ctx.abortEarly) {
            payload.value = newResult;
            return payload;
          }
        }

        if (${id}_present) {
          newResult[${k}] = ${id}.value;
        }

      `);
            else {
                doc.write(`
        if (${id}.issues.length) {${prefixStr(id, k)}
        }
      `);
                if (optin === "defaulted") doc.write(`newResult[${k}] = ${id}.value;`);
                else doc.write(`
        if (${id}.value !== undefined || ${isPresent}) {
          newResult[${k}] = ${id}.value;
        }
      `);
            }
        }
        doc.write(`payload.value = newResult;`);
        doc.write(`return payload;`);
        // closing `shape` in is what pays: turbofan specializes the parser against that one shape object, so every `shape[k]._zod.run` folds to a known callee. as a parameter it stays a generic load and measures 13% slower even with the forwarding frame gone
        return doc.compile();
    };
    let fastpass;
    const isObject = $ciVeX.isObject;
    const jit = !$igTWG.globalConfig.jitless;
    const allowsEval = $ciVeX.allowsEval;
    const fastEnabled = jit && allowsEval.value; // && !def.catchall;
    const catchall = def.catchall;
    let value1;
    inst._zod.parse = (payload, ctx)=>{
        value1 ?? (value1 = _normalized.value);
        const input = payload.value;
        if (!isObject(input)) {
            payload.issues.push({
                expected: "object",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        if (jit && fastEnabled && ctx?.async === false && ctx.jitless !== true) {
            // always synchronous
            if (!fastpass) fastpass = generateFastpass(def.shape);
            payload = fastpass(payload, ctx);
            if (!catchall) return payload;
            return $38bc36f53cb4eb10$var$handleCatchall([], input, payload, ctx, value1, inst, ctx?.abortEarly === true);
        }
        return superParse(payload, ctx);
    };
});
function $38bc36f53cb4eb10$var$handleUnionResults(results, final, inst, ctx) {
    for (const result of results)if (result.issues.length === 0) {
        final.value = result.value;
        return final;
    }
    const nonaborted = results.filter((r)=>!$ciVeX.aborted(r));
    if (nonaborted.length === 1) {
        final.value = nonaborted[0].value;
        return nonaborted[0];
    }
    final.issues.push({
        code: "invalid_union",
        input: final.value,
        inst: inst,
        errors: results.map((result)=>result.issues.map((iss)=>$ciVeX.finalizeIssue(iss, ctx, $igTWG.config())))
    });
    return final;
}
const $38bc36f53cb4eb10$export$37a2350ef0bd638c = /*@__PURE__*/ $igTWG.$constructor("$ZodUnion", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    $ciVeX.defineLazyInternal(inst, "optin", (zod)=>zod.def.options.some((o)=>o._zod.optin === "defaulted") ? "defaulted" : zod.def.options.some((o)=>o._zod.optin !== undefined) ? "optional" : undefined);
    $ciVeX.defineLazyInternal(inst, "optout", (zod)=>zod.def.options.some((o)=>o._zod.optout === "optional") ? "optional" : undefined);
    $ciVeX.defineLazyInternal(inst, "values", (zod)=>{
        if (zod.def.options.every((o)=>o._zod.values)) return new Set(zod.def.options.flatMap((option)=>Array.from(option._zod.values)));
        return undefined;
    });
    $ciVeX.defineLazyInternal(inst, "pattern", (zod)=>{
        if (zod.def.options.every((o)=>o._zod.pattern)) {
            const patterns = zod.def.options.map((o)=>o._zod.pattern);
            return new RegExp(`^(${patterns.map((p)=>$ciVeX.cleanRegex(p.source)).join("|")})$`);
        }
        return undefined;
    });
    const first = def.options.length === 1 ? def.options[0]._zod.run : null;
    inst._zod.parse = (payload, ctx)=>{
        if (first) return first(payload, ctx);
        let async = false;
        const results = [];
        for (const option of def.options){
            const result = option._zod.run({
                value: payload.value,
                issues: []
            }, ctx);
            if (result instanceof Promise) {
                results.push(result);
                async = true;
            } else {
                if (result.issues.length === 0) return result;
                results.push(result);
            }
        }
        if (!async) return $38bc36f53cb4eb10$var$handleUnionResults(results, payload, inst, ctx);
        return Promise.all(results).then((results)=>{
            return $38bc36f53cb4eb10$var$handleUnionResults(results, payload, inst, ctx);
        });
    };
});
function $38bc36f53cb4eb10$var$handleExclusiveUnionResults(results, final, inst, ctx) {
    const matches = [];
    for(let i = 0; i < results.length; i++)if (results[i].issues.length === 0) matches.push(i);
    if (matches.length === 1) {
        final.value = results[matches[0]].value;
        return final;
    }
    if (matches.length === 0) // No matches - same as regular union
    final.issues.push({
        code: "invalid_union",
        input: final.value,
        inst: inst,
        errors: results.map((result)=>result.issues.map((iss)=>$ciVeX.finalizeIssue(iss, ctx, $igTWG.config())))
    });
    else // Multiple matches - exclusive union failure
    final.issues.push({
        code: "invalid_union",
        input: final.value,
        inst: inst,
        errors: [],
        inclusive: false,
        matches: matches
    });
    return final;
}
const $38bc36f53cb4eb10$export$b04ced974a46c0b4 = /*@__PURE__*/ $igTWG.$constructor("$ZodXor", (inst, def)=>{
    $38bc36f53cb4eb10$export$37a2350ef0bd638c.init(inst, def);
    def.inclusive = false;
    const first = def.options.length === 1 ? def.options[0]._zod.run : null;
    inst._zod.parse = (payload, ctx)=>{
        if (first) return first(payload, ctx);
        let async = false;
        const results = [];
        for (const option of def.options){
            const result = option._zod.run({
                value: payload.value,
                issues: []
            }, ctx);
            if (result instanceof Promise) {
                results.push(result);
                async = true;
            } else results.push(result);
        }
        if (!async) return $38bc36f53cb4eb10$var$handleExclusiveUnionResults(results, payload, inst, ctx);
        return Promise.all(results).then((results)=>{
            return $38bc36f53cb4eb10$var$handleExclusiveUnionResults(results, payload, inst, ctx);
        });
    };
});
function $38bc36f53cb4eb10$export$d95dcd4112c08983(union, value1) {
    const internals = union._zod;
    let map = internals.bag.optionsMap;
    if (!map) {
        map = $38bc36f53cb4eb10$var$discriminatorMap(internals.def);
        internals.bag.optionsMap = map;
    }
    const option = map.get(value1);
    if (option === null) throw new Error(`Ambiguous discriminator value "${String(value1)}"`);
    return option;
}
function $38bc36f53cb4eb10$var$discriminatorMap(def) {
    const map = new Map();
    for (const option of def.options){
        const values = option._zod.propValues?.[def.discriminator];
        if (!values || values.size === 0) throw new Error(`Invalid discriminated union option at index "${def.options.indexOf(option)}"`);
        for (const value1 of values)if (map.has(value1)) {
            if (value1 !== undefined) throw new Error(`Duplicate discriminator value "${String(value1)}"`);
            // keep the collision marked so a later member cannot reclaim it
            map.set(value1, null);
        } else map.set(value1, option);
    }
    return map;
}
const $38bc36f53cb4eb10$export$aad4f17edfb83795 = /*@__PURE__*/ $igTWG.$constructor("$ZodDiscriminatedUnion", (inst, def)=>{
    def.inclusive = false;
    $38bc36f53cb4eb10$export$37a2350ef0bd638c.init(inst, def);
    const _super = inst._zod.parse;
    $ciVeX.defineLazyInternal(inst, "propValues", (zod)=>{
        const propValues = {};
        let undefinedCount = 0;
        for (const option of zod.def.options){
            const pv = option._zod.propValues;
            if (!pv || Object.keys(pv).length === 0) throw new Error(`Invalid discriminated union option at index "${zod.def.options.indexOf(option)}"`);
            if (pv[zod.def.discriminator]?.has(undefined)) undefinedCount++;
            for (const [k, v] of Object.entries(pv)){
                if (!Object.prototype.hasOwnProperty.call(propValues, k)) $ciVeX.assignProp(propValues, k, new Set());
                for (const val of v)propValues[k].add(val);
            }
        }
        if (!zod.def.unionFallback && undefinedCount > 1) propValues[zod.def.discriminator]?.delete(undefined);
        return propValues;
    });
    // Checked now rather than in the lookup map below, so an option that lacks the discriminator fails at the `discriminatedUnion` call instead of on the first object parsed. Options whose shape cannot be enumerated without resolving it — pipes and lazies — are left to the map.
    def.options.forEach((option, i)=>{
        const propShape = $ciVeX.rawShape(option._zod.def);
        if (propShape && !Object.prototype.hasOwnProperty.call(propShape, def.discriminator)) throw new Error(`Invalid discriminated union option at index "${i}"`);
    });
    const disc = $ciVeX.cached(()=>$38bc36f53cb4eb10$var$discriminatorMap(def));
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!$ciVeX.isObject(input)) {
            payload.issues.push({
                code: "invalid_type",
                expected: "object",
                input: input,
                inst: inst
            });
            return payload;
        }
        const value1 = input?.[def.discriminator];
        const opt = disc.value.get(value1);
        // forward metadata cannot choose an encoder for an absent tag
        if (opt && (value1 !== undefined || ctx.direction !== "backward")) return opt._zod.run(payload, ctx);
        // Fall back to union matching when the fast discriminator path fails:
        // - explicitly enabled via unionFallback, or
        // - during backward direction (encode), since codec-based discriminators have different values in forward vs backward directions
        if (def.unionFallback || ctx.direction === "backward") return _super(payload, ctx);
        // no matching discriminator
        payload.issues.push({
            code: "invalid_union",
            errors: [],
            note: "No matching discriminator",
            discriminator: def.discriminator,
            options: Array.from(disc.value.keys()).filter((value1)=>disc.value.get(value1) !== null),
            input: input,
            path: [
                def.discriminator
            ],
            inst: inst
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$2299250b426aba4b = /*@__PURE__*/ $igTWG.$constructor("$ZodIntersection", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        const left = def.left._zod.run({
            value: input,
            issues: []
        }, ctx);
        const right = def.right._zod.run({
            value: input,
            issues: []
        }, ctx);
        const async = left instanceof Promise || right instanceof Promise;
        if (async) return Promise.all([
            left,
            right
        ]).then(([left, right])=>{
            return $38bc36f53cb4eb10$var$handleIntersectionResults(payload, left, right);
        });
        return $38bc36f53cb4eb10$var$handleIntersectionResults(payload, left, right);
    };
});
function $38bc36f53cb4eb10$export$4c2c6f84c333dcbc(a, b) {
    // const aType = parse.t(a);
    // const bType = parse.t(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    if (a instanceof Date && b instanceof Date && +a === +b) return {
        valid: true,
        data: a
    };
    if ($ciVeX.isPlainObject(a) && $ciVeX.isPlainObject(b)) {
        const bKeys = Object.keys(b);
        const sharedKeys = Object.keys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        if (Object.prototype.hasOwnProperty.call(newObj, "__proto__")) delete newObj.__proto__;
        for (const key of sharedKeys){
            if (key === "__proto__") continue;
            const sharedValue = $38bc36f53cb4eb10$export$4c2c6f84c333dcbc(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false,
                mergeErrorPath: [
                    key,
                    ...sharedValue.mergeErrorPath
                ]
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    }
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) return {
            valid: false,
            mergeErrorPath: []
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $38bc36f53cb4eb10$export$4c2c6f84c333dcbc(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false,
                mergeErrorPath: [
                    index,
                    ...sharedValue.mergeErrorPath
                ]
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    }
    return {
        valid: false,
        mergeErrorPath: []
    };
}
function $38bc36f53cb4eb10$var$handleIntersectionResults(result, left, right) {
    // Track which side(s) reject each key. A key rejection is reported only when BOTH sides reject it, so a key owned by one branch survives the other's key schema. strictObject reports these as unrecognized_keys; a record with an open key schema reports one invalid_key per key.
    const unrecKeys = new Map();
    let unrecIssue;
    const keyIssues = new Map();
    const collect = (iss, side)=>{
        let keys;
        if (iss.code === "unrecognized_keys" && !iss.path?.length) {
            unrecIssue ?? (unrecIssue = iss);
            keys = iss.keys;
        } else if (iss.code === "invalid_key" && iss.origin === "record" && iss.path?.length === 1) {
            const k = String(iss.path[0]);
            if (!keyIssues.has(k)) keyIssues.set(k, iss);
            keys = [
                k
            ];
        } else return false;
        for (const k of keys){
            if (!unrecKeys.has(k)) unrecKeys.set(k, {});
            unrecKeys.get(k)[side] = true;
        }
        return true;
    };
    for (const iss of left.issues)if (!collect(iss, "l")) result.issues.push(iss);
    for (const iss of right.issues)if (!collect(iss, "r")) result.issues.push(iss);
    // Report only keys rejected by BOTH sides
    const bothKeys = [
        ...unrecKeys
    ].filter(([, f])=>f.l && f.r).map(([k])=>k);
    if (bothKeys.length) {
        const aggregated = unrecIssue ? bothKeys.filter((k)=>unrecIssue.keys.includes(k)) : [];
        if (aggregated.length) result.issues.push({
            ...unrecIssue,
            keys: aggregated
        });
        for (const k of bothKeys)if (!aggregated.includes(k) && keyIssues.has(k)) result.issues.push(keyIssues.get(k));
    }
    const merged = $38bc36f53cb4eb10$export$4c2c6f84c333dcbc(left.value, right.value);
    if (!merged.valid) {
        if ($ciVeX.aborted(result)) return result;
        throw new Error(`Unmergable intersection. Error path: ` + `${JSON.stringify(merged.mergeErrorPath)}`);
    }
    result.value = merged.data;
    return result;
}
const $38bc36f53cb4eb10$export$bba1b90a721dbd94 = /*@__PURE__*/ $igTWG.$constructor("$ZodTuple", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    const items = def.items;
    const memo = $igTWG.globalConfig.memoizer;
    memo?.attach(inst);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!Array.isArray(input)) {
            payload.issues.push({
                input: input,
                inst: inst,
                expected: "tuple",
                code: "invalid_type"
            });
            return payload;
        }
        payload.value = memo ? memo.alloc(inst, payload, [], ctx) : [];
        const proms = [];
        const optinStart = $38bc36f53cb4eb10$var$getTupleOptStart(items, "optin");
        const optoutStart = $38bc36f53cb4eb10$var$getTupleOptStart(items, "optout");
        if (!def.rest) {
            if (input.length < optinStart) {
                payload.issues.push({
                    code: "too_small",
                    minimum: optinStart,
                    inclusive: true,
                    input: input,
                    inst: inst,
                    origin: "array"
                });
                return payload;
            }
            if (input.length > items.length) payload.issues.push({
                code: "too_big",
                maximum: items.length,
                inclusive: true,
                input: input,
                inst: inst,
                origin: "array"
            });
        }
        // Run every item in parallel, collecting results into an indexed array. The post-processing in `handleTupleResults` walks them in order so it can decide whether an absent optional-output error can truncate the tail or must be reported to preserve required output.
        const itemResults = new Array(items.length);
        // only tracked when there is a rest loop to skip
        const abortEarly = def.rest ? ctx?.abortEarly : undefined;
        let itemAborted = false;
        for(let i = 0; i < items.length; i++){
            const r = items[i]._zod.run({
                value: input[i],
                issues: []
            }, ctx);
            if (r instanceof Promise) proms.push(r.then((rr)=>{
                itemResults[i] = rr;
            }));
            else {
                itemResults[i] = r;
                if (abortEarly && !itemAborted && r.issues.length) itemAborted = $ciVeX.aborted(r);
            }
        }
        // sound because rest is non-empty exactly when every fixed index is present, the one case handleTupleResults cannot discard an item's issues
        if (def.rest && !itemAborted) {
            let i = items.length - 1;
            const rest = input.slice(items.length);
            let seen = payload.issues.length;
            for (const el of rest){
                if (abortEarly && payload.issues.length !== seen) {
                    if ($ciVeX.aborted(payload, seen)) break;
                    seen = payload.issues.length;
                }
                i++;
                const result = def.rest._zod.run({
                    value: el,
                    issues: []
                }, ctx);
                if (result instanceof Promise) proms.push(result.then((r)=>$38bc36f53cb4eb10$var$handleTupleResult(r, payload, i)));
                else $38bc36f53cb4eb10$var$handleTupleResult(result, payload, i);
            }
        }
        if (proms.length) return Promise.all(proms).then(()=>$38bc36f53cb4eb10$var$handleTupleResults(itemResults, payload, items, input, optoutStart));
        return $38bc36f53cb4eb10$var$handleTupleResults(itemResults, payload, items, input, optoutStart);
    };
});
function $38bc36f53cb4eb10$var$getTupleOptStart(items, key) {
    for(let i = items.length - 1; i >= 0; i--){
        // optin is a three-rung ladder so any rung above `undefined` permits an absent slot; optout stays two-valued.
        const omittable = key === "optin" ? items[i]._zod.optin !== undefined : items[i]._zod.optout === "optional";
        if (!omittable) return i + 1;
    }
    return 0;
}
function $38bc36f53cb4eb10$var$handleTupleResult(result, final, index) {
    if (result.issues.length) final.issues.push(...$ciVeX.prefixIssues(index, result.issues));
    final.value[index] = result.value;
}
function $38bc36f53cb4eb10$var$handleTupleResults(itemResults, final, items, input, optoutStart) {
    // Walk results in order. Mirror $ZodObject's swallow-on-absent-optional rule, but only after `optoutStart`: the first index where the output tuple tail can be absent.
    for(let i = 0; i < items.length; i++){
        const r = itemResults[i];
        const isPresent = i < input.length;
        // The array analog of `handlePropertyResult`'s absent-key early return: the middle rung permits absence without supplying anything in its place, so the tail truncates here instead of materializing whatever the item made of `undefined`.
        if (!isPresent && i >= optoutStart && items[i]._zod.optin === "optional") {
            final.value.length = i;
            break;
        }
        if (r.issues.length) {
            if (!isPresent && i >= optoutStart) {
                final.value.length = i;
                break;
            }
            final.issues.push(...$ciVeX.prefixIssues(i, r.issues));
        }
        final.value[i] = r.value;
    }
    // Drop trailing slots that produced `undefined` for absent input
    // (the array analog of an absent optional key on an object). The
    // `i >= input.length` floor is critical: an explicit `undefined`
    // *inside* the input must be preserved even when the schema is
    // optional-out (e.g. `z.string().or(z.undefined())` accepting an
    // explicit undefined value).
    for(let i = final.value.length - 1; i >= input.length; i--){
        if (items[i]._zod.optout === "optional" && final.value[i] === undefined) final.value.length = i;
        else break;
    }
    return final;
}
const $38bc36f53cb4eb10$export$cc20b90ec1a8c208 = /*@__PURE__*/ $igTWG.$constructor("$ZodRecord", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    const memo = $igTWG.globalConfig.memoizer;
    memo?.attach(inst);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!$ciVeX.isPlainObject(input)) {
            payload.issues.push({
                expected: "record",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        // no guard in either loop below: a record's invalid_key aborts but an enclosing intersection can reconcile it, so a stopped loop hides keys the sibling does not own and the intersection then rejects nothing
        const proms = [];
        const values = def.keyType._zod.values;
        if (values && !def.partial) {
            payload.value = memo ? memo.alloc(inst, payload, {}, ctx) : {};
            const recordKeys = new Set();
            for (const key of values)if (typeof key === "string" || typeof key === "number" || typeof key === "symbol") {
                recordKeys.add(typeof key === "number" ? key.toString() : key);
                // A declared __proto__ is stripped but is not an unrecognized key.
                if (key === "__proto__") continue;
                const keyResult = def.keyType._zod.run({
                    value: key,
                    issues: []
                }, ctx);
                if (keyResult instanceof Promise) throw new Error("Async schemas not supported in object keys currently");
                if (keyResult.issues.length) {
                    payload.issues.push({
                        code: "invalid_key",
                        origin: "record",
                        issues: keyResult.issues.map((iss)=>$ciVeX.finalizeIssue(iss, ctx, $igTWG.config())),
                        input: key,
                        path: [
                            key
                        ],
                        inst: inst
                    });
                    continue;
                }
                const outKey = keyResult.value;
                if (outKey === "__proto__") continue;
                const result = def.valueType._zod.run({
                    value: input[key],
                    issues: []
                }, ctx);
                if (result instanceof Promise) proms.push(result.then((result)=>{
                    if (result.issues.length) payload.issues.push(...$ciVeX.prefixIssues(key, result.issues));
                    payload.value[outKey] = result.value;
                }));
                else {
                    if (result.issues.length) payload.issues.push(...$ciVeX.prefixIssues(key, result.issues));
                    payload.value[outKey] = result.value;
                }
            }
            let unrecognized;
            for(const key in input)if (!recordKeys.has(key)) {
                if (def.mode === "loose") {
                    // skip __proto__ so it can't replace the result prototype via the assignment setter on the plain {} we build into
                    if (key === "__proto__") continue;
                    payload.value[key] = input[key];
                } else {
                    unrecognized = unrecognized ?? [];
                    unrecognized.push(key);
                }
            }
            if (unrecognized && unrecognized.length > 0) payload.issues.push({
                code: "unrecognized_keys",
                input: input,
                inst: inst,
                keys: unrecognized,
                continue: true
            });
        } else {
            payload.value = memo ? memo.alloc(inst, payload, {}, ctx) : {};
            // An enumerable key schema declares which keys the record owns, so a key outside the set is unrecognized. A non-enumerable one (regex, refine) is a constraint every key must satisfy, so a failing key is invalid. Only the former is reconcilable against the other side of an intersection.
            let unrecognized;
            // Reflect.ownKeys for Symbol-key support; filter non-enumerable to match z.object()
            for (const key of Reflect.ownKeys(input)){
                if (key === "__proto__") continue;
                if (!Object.prototype.propertyIsEnumerable.call(input, key)) continue;
                let keyResult = def.keyType._zod.run({
                    value: key,
                    issues: []
                }, ctx);
                if (keyResult instanceof Promise) throw new Error("Async schemas not supported in object keys currently");
                // Numeric string fallback: if key is a numeric string and failed, retry with Number(key). This handles z.number(), z.literal([1, 2, 3]), and unions containing numeric literals
                const checkNumericKey = typeof key === "string" && $8S8Wz.number.test(key) && keyResult.issues.length;
                if (checkNumericKey) {
                    const retryResult = def.keyType._zod.run({
                        value: Number(key),
                        issues: []
                    }, ctx);
                    if (retryResult instanceof Promise) throw new Error("Async schemas not supported in object keys currently");
                    if (retryResult.issues.length === 0) keyResult = retryResult;
                }
                if (keyResult.issues.length) {
                    if (def.mode === "loose") // Pass through unchanged
                    payload.value[key] = input[key];
                    else if (values) {
                        unrecognized = unrecognized ?? [];
                        unrecognized.push(key);
                    } else // Default "strict" behavior: error on invalid key
                    payload.issues.push({
                        code: "invalid_key",
                        origin: "record",
                        issues: keyResult.issues.map((iss)=>$ciVeX.finalizeIssue(iss, ctx, $igTWG.config())),
                        input: key,
                        path: [
                            key
                        ],
                        inst: inst
                    });
                    continue;
                }
                // the guard above tests the raw input key, but the key schema can normalize an ordinary key into __proto__; re-check the key we actually write under
                const outKey = keyResult.value;
                if (outKey === "__proto__") continue;
                const result = def.valueType._zod.run({
                    value: input[key],
                    issues: []
                }, ctx);
                if (result instanceof Promise) proms.push(result.then((result)=>{
                    if (result.issues.length) payload.issues.push(...$ciVeX.prefixIssues(key, result.issues));
                    payload.value[outKey] = result.value;
                }));
                else {
                    if (result.issues.length) payload.issues.push(...$ciVeX.prefixIssues(key, result.issues));
                    payload.value[outKey] = result.value;
                }
            }
            if (unrecognized && unrecognized.length > 0) payload.issues.push({
                code: "unrecognized_keys",
                input: input,
                inst: inst,
                keys: unrecognized,
                continue: true
            });
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload;
    };
});
const $38bc36f53cb4eb10$export$5ccfd30a7e358409 = /*@__PURE__*/ $igTWG.$constructor("$ZodMap", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    const memo = $igTWG.globalConfig.memoizer;
    memo?.attach(inst);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!(input instanceof Map)) {
            payload.issues.push({
                expected: "map",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        const proms = [];
        payload.value = memo ? memo.alloc(inst, payload, new Map(), ctx) : new Map();
        const abortEarly = ctx?.abortEarly;
        let seen = payload.issues.length;
        for (const [key, value1] of input){
            if (abortEarly && payload.issues.length !== seen) {
                if ($ciVeX.aborted(payload, seen)) break;
                seen = payload.issues.length;
            }
            const keyResult = def.keyType._zod.run({
                value: key,
                issues: []
            }, ctx);
            const valueResult = def.valueType._zod.run({
                value: value1,
                issues: []
            }, ctx);
            if (keyResult instanceof Promise || valueResult instanceof Promise) proms.push(Promise.all([
                keyResult,
                valueResult
            ]).then(([keyResult, valueResult])=>{
                $38bc36f53cb4eb10$var$handleMapResult(keyResult, valueResult, payload, key, input, inst, ctx);
            }));
            else $38bc36f53cb4eb10$var$handleMapResult(keyResult, valueResult, payload, key, input, inst, ctx);
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload;
    };
});
function $38bc36f53cb4eb10$var$handleMapResult(keyResult, valueResult, final, key, input, inst, ctx) {
    if (keyResult.issues.length) {
        if ($ciVeX.propertyKeyTypes.has(typeof key)) final.issues.push(...$ciVeX.prefixIssues(key, keyResult.issues));
        else final.issues.push({
            code: "invalid_key",
            origin: "map",
            input: input,
            inst: inst,
            issues: keyResult.issues.map((iss)=>$ciVeX.finalizeIssue(iss, ctx, $igTWG.config()))
        });
    }
    if (valueResult.issues.length) {
        if ($ciVeX.propertyKeyTypes.has(typeof key)) final.issues.push(...$ciVeX.prefixIssues(key, valueResult.issues));
        else final.issues.push({
            origin: "map",
            code: "invalid_element",
            input: input,
            inst: inst,
            key: key,
            issues: valueResult.issues.map((iss)=>$ciVeX.finalizeIssue(iss, ctx, $igTWG.config()))
        });
    }
    final.value.set(keyResult.value, valueResult.value);
}
const $38bc36f53cb4eb10$export$20cf27bc33a30268 = /*@__PURE__*/ $igTWG.$constructor("$ZodSet", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    const memo = $igTWG.globalConfig.memoizer;
    memo?.attach(inst);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!(input instanceof Set)) {
            payload.issues.push({
                input: input,
                inst: inst,
                expected: "set",
                code: "invalid_type"
            });
            return payload;
        }
        const proms = [];
        payload.value = memo ? memo.alloc(inst, payload, new Set(), ctx) : new Set();
        const abortEarly = ctx?.abortEarly;
        let seen = payload.issues.length;
        for (const item of input){
            if (abortEarly && payload.issues.length !== seen) {
                if ($ciVeX.aborted(payload, seen)) break;
                seen = payload.issues.length;
            }
            const result = def.valueType._zod.run({
                value: item,
                issues: []
            }, ctx);
            if (result instanceof Promise) proms.push(result.then((result)=>$38bc36f53cb4eb10$var$handleSetResult(result, payload)));
            else $38bc36f53cb4eb10$var$handleSetResult(result, payload);
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload;
    };
});
function $38bc36f53cb4eb10$var$handleSetResult(result, final) {
    if (result.issues.length) final.issues.push(...result.issues);
    final.value.add(result.value);
}
const $38bc36f53cb4eb10$export$31462b6e6c50b618 = /*@__PURE__*/ $igTWG.$constructor("$ZodEnum", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    const values = $ciVeX.getEnumValues(def.entries);
    const valuesSet = new Set(values);
    inst._zod.values = valuesSet;
    $ciVeX.defineLazyInternal(inst, "pattern", (zod)=>{
        const patternValues = $ciVeX.getEnumValues(zod.def.entries).filter((k)=>$ciVeX.propertyKeyTypes.has(typeof k));
        // unmatchable fallback, RE2-safe: an empty alternation would compile to /^()$/, which matches ""
        return new RegExp(patternValues.length ? `^(${patternValues.map((o)=>$ciVeX.escapeRegex(o.toString())).join("|")})$` : "^[^\\s\\S]$");
    });
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (valuesSet.has(input)) return payload;
        payload.issues.push({
            code: "invalid_value",
            values: values,
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$86699355265fa258 = /*@__PURE__*/ $igTWG.$constructor("$ZodLiteral", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    const values = new Set(def.values);
    inst._zod.values = values;
    $ciVeX.defineLazyInternal(inst, "pattern", (zod)=>{
        const vals = zod.def.values;
        // unmatchable fallback, RE2-safe: an empty alternation would compile to /^()$/, which matches ""
        return new RegExp(vals.length ? `^(${vals.map((o)=>typeof o === "string" ? $ciVeX.escapeRegex(o) : o ? $ciVeX.escapeRegex(o.toString()) : String(o)).join("|")})$` : "^[^\\s\\S]$");
    });
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (values.has(input)) return payload;
        payload.issues.push({
            code: "invalid_value",
            values: def.values,
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$1997de0576a81377 = /*@__PURE__*/ $igTWG.$constructor("$ZodFile", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        // @ts-ignore
        if (input instanceof File) return payload;
        payload.issues.push({
            expected: "file",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$14b591f873519189 = /*@__PURE__*/ $igTWG.$constructor("$ZodTransform", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.optin = "optional";
    $igTWG.globalConfig.memoizer?.guard(inst);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") throw new $igTWG.$ZodEncodeError(inst.constructor.name);
        const _out = def.transform(payload.value, payload);
        if (ctx.async) {
            const output = _out instanceof Promise ? _out : Promise.resolve(_out);
            return output.then((output)=>{
                payload.value = output;
                return payload;
            });
        }
        if (_out instanceof Promise) throw new $igTWG.$ZodAsyncError();
        payload.value = _out;
        return payload;
    };
});
function $38bc36f53cb4eb10$var$handleOptionalResult(payload, result) {
    // A substituting schema that still failed has no usable answer; yield undefined. Its issues are simply dropped: it ran on a payload of its own, so there is no shared array to truncate and nothing of the caller's to lose with it.
    payload.value = result.issues.length ? undefined : result.value;
    return payload;
}
const $38bc36f53cb4eb10$export$980e9af565c4d7aa = /*@__PURE__*/ $igTWG.$constructor("$ZodOptional", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    // .optional() propagates absence rather than substituting for it, so a defaulted inner keeps its rung.
    $ciVeX.defineLazyInternal(inst, "optin", (zod)=>zod.def.innerType._zod.optin === "defaulted" ? "defaulted" : "optional");
    inst._zod.optout = "optional";
    $ciVeX.defineLazyInternal(inst, "values", (zod)=>{
        const values = zod.def.innerType._zod.values;
        return values ? new Set([
            ...values,
            undefined
        ]) : undefined;
    });
    $ciVeX.defineLazyInternal(inst, "pattern", (zod)=>{
        const pattern = zod.def.innerType._zod.pattern;
        return pattern ? new RegExp(`^(${$ciVeX.cleanRegex(pattern.source)})?$`) : undefined;
    });
    inst._zod.parse = (payload, ctx)=>{
        if (payload.value === undefined) {
            // Only the top rung substitutes a value for absence; everything else leaves it intact, which is what .optional() means.
            if (def.innerType._zod.optin !== "defaulted") return payload;
            // Its own payload, for the same reason $ZodCatch gets one: a pipe forwards an unrecognized key through the caller's issues array, and this must not read that as the substituting schema failing and drop it.
            const result = def.innerType._zod.run({
                value: payload.value,
                issues: []
            }, ctx);
            if (result instanceof Promise) return result.then((result)=>$38bc36f53cb4eb10$var$handleOptionalResult(payload, result));
            return $38bc36f53cb4eb10$var$handleOptionalResult(payload, result);
        }
        return def.innerType._zod.run(payload, ctx);
    };
});
const $38bc36f53cb4eb10$export$384d083c2a6b693f = /*@__PURE__*/ $igTWG.$constructor("$ZodExactOptional", (inst, def)=>{
    // Call parent init - inherits optin/optout = "optional"
    $38bc36f53cb4eb10$export$980e9af565c4d7aa.init(inst, def);
    // Override values/pattern to NOT add undefined
    $ciVeX.defineLazyInternal(inst, "values", (zod)=>zod.def.innerType._zod.values);
    $ciVeX.defineLazyInternal(inst, "pattern", (zod)=>zod.def.innerType._zod.pattern);
    // Override parse to just delegate (no undefined handling)
    inst._zod.parse = (payload, ctx)=>{
        return def.innerType._zod.run(payload, ctx);
    };
});
const $38bc36f53cb4eb10$export$7994573b6604ec66 = /*@__PURE__*/ $igTWG.$constructor("$ZodNullable", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    $ciVeX.defineLazyInternal(inst, "optin", (zod)=>zod.def.innerType._zod.optin);
    $ciVeX.defineLazyInternal(inst, "optout", (zod)=>zod.def.innerType._zod.optout);
    $ciVeX.defineLazyInternal(inst, "pattern", (zod)=>{
        const pattern = zod.def.innerType._zod.pattern;
        return pattern ? new RegExp(`^(${$ciVeX.cleanRegex(pattern.source)}|null)$`) : undefined;
    });
    $ciVeX.defineLazyInternal(inst, "values", (zod)=>{
        return zod.def.innerType._zod.values ? new Set([
            ...zod.def.innerType._zod.values,
            null
        ]) : undefined;
    });
    inst._zod.parse = (payload, ctx)=>{
        // Forward direction (decode): allow null to pass through
        if (payload.value === null) return payload;
        return def.innerType._zod.run(payload, ctx);
    };
});
const $38bc36f53cb4eb10$export$ae2d21004b7243f7 = /*@__PURE__*/ $igTWG.$constructor("$ZodDefault", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    // inst._zod.qin = "true";
    inst._zod.optin = "defaulted";
    $ciVeX.defineLazyInternal(inst, "values", (zod)=>zod.def.innerType._zod.values);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        // Forward direction (decode): apply defaults for undefined input
        if (payload.value === undefined) {
            payload.value = def.defaultValue;
            /**
             * $ZodDefault returns the default value immediately in forward direction.
             * It doesn't pass the default value into the validator ("prefault"). There's no reason to pass the default value through validation. The validity of the default is enforced by TypeScript statically. Otherwise, it's the responsibility of the user to ensure the default is valid. In the case of pipes with divergent in/out types, you can specify the default on the `in` schema of your ZodPipe to set a "prefault" for the pipe.   */ return payload;
        }
        // Forward direction: continue with default handling
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then((result)=>$38bc36f53cb4eb10$var$handleDefaultResult(result, def));
        return $38bc36f53cb4eb10$var$handleDefaultResult(result, def);
    };
});
function $38bc36f53cb4eb10$var$handleDefaultResult(payload, def) {
    if (payload.value === undefined) payload.value = def.defaultValue;
    return payload;
}
const $38bc36f53cb4eb10$export$29a8d757258be679 = /*@__PURE__*/ $igTWG.$constructor("$ZodPrefault", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.optin = "defaulted";
    $ciVeX.defineLazyInternal(inst, "values", (zod)=>zod.def.innerType._zod.values);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        // Forward direction (decode): apply prefault for undefined input
        if (payload.value === undefined) payload.value = def.defaultValue;
        return def.innerType._zod.run(payload, ctx);
    };
});
const $38bc36f53cb4eb10$export$30ca726c4c50a6d7 = /*@__PURE__*/ $igTWG.$constructor("$ZodNonOptional", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    $ciVeX.defineLazyInternal(inst, "values", (zod)=>{
        const v = zod.def.innerType._zod.values;
        return v ? new Set([
            ...v
        ].filter((x)=>x !== undefined)) : undefined;
    });
    inst._zod.parse = (payload, ctx)=>{
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then((result)=>$38bc36f53cb4eb10$var$handleNonOptionalResult(result, inst));
        return $38bc36f53cb4eb10$var$handleNonOptionalResult(result, inst);
    };
});
function $38bc36f53cb4eb10$var$handleNonOptionalResult(payload, inst) {
    if (!payload.issues.length && payload.value === undefined) payload.issues.push({
        code: "invalid_type",
        expected: "nonoptional",
        input: payload.value,
        inst: inst
    });
    return payload;
}
const $38bc36f53cb4eb10$export$3cc4d03e729326ea = /*@__PURE__*/ $igTWG.$constructor("$ZodSuccess", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") throw new $igTWG.$ZodEncodeError("ZodSuccess");
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then((result)=>{
            payload.value = result.issues.length === 0;
            return payload;
        });
        payload.value = result.issues.length === 0;
        return payload;
    };
});
function $38bc36f53cb4eb10$var$handleCatchResult(payload, result, def, ctx) {
    if (!result.issues.length) {
        payload.value = result.value;
        // The value carries up, so the flag describing it has to carry with it: a back-edge into a node still being parsed must not be frozen by an enclosing readonly, and its checks belong to the node itself. Guarded so the ordinary case adds no own property.
        if (result.memo) payload.memo = true;
        return payload;
    }
    // Spread the inner's own payload, not ours: `value` has to stay the input the catch was handed, and the inner ran on a payload of its own so its issues are already private to this call.
    payload.value = def.catchValue({
        ...result,
        value: payload.value,
        error: {
            issues: result.issues.map((iss)=>$ciVeX.finalizeIssue(iss, ctx, $igTWG.config()))
        },
        input: payload.value
    });
    return payload;
}
const $38bc36f53cb4eb10$export$d6f8b228374f6d37 = /*@__PURE__*/ $igTWG.$constructor("$ZodCatch", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    $ciVeX.defineLazyInternal(inst, "optin", (zod)=>zod.def.innerType._zod.optin === "defaulted" ? "defaulted" : "optional");
    $ciVeX.defineLazyInternal(inst, "optout", (zod)=>zod.def.innerType._zod.optout);
    $ciVeX.defineLazyInternal(inst, "values", (zod)=>zod.def.innerType._zod.values);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        // Forward direction (decode): apply catch logic
        const result = def.innerType._zod.run({
            value: payload.value,
            issues: []
        }, ctx);
        if (result instanceof Promise) return result.then((result)=>$38bc36f53cb4eb10$var$handleCatchResult(payload, result, def, ctx));
        return $38bc36f53cb4eb10$var$handleCatchResult(payload, result, def, ctx);
    };
});
const $38bc36f53cb4eb10$export$528f71701e6a7aee = /*@__PURE__*/ $igTWG.$constructor("$ZodNaN", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        if (typeof payload.value !== "number" || !Number.isNaN(payload.value)) {
            payload.issues.push({
                input: payload.value,
                inst: inst,
                expected: "nan",
                code: "invalid_type"
            });
            return payload;
        }
        return payload;
    };
});
const $38bc36f53cb4eb10$export$4cb25cfde430326c = /*@__PURE__*/ $igTWG.$constructor("$ZodPipe", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    $ciVeX.defineLazyInternal(inst, "values", (zod)=>zod.def.in._zod.values);
    $ciVeX.defineLazyInternal(inst, "optin", (zod)=>zod.def.in._zod.optin);
    $ciVeX.defineLazyInternal(inst, "optout", (zod)=>zod.def.out._zod.optout);
    $ciVeX.defineLazyInternal(inst, "propValues", (zod)=>zod.def.in._zod.propValues);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") {
            const right = def.out._zod.run(payload, ctx);
            if (right instanceof Promise) return right.then((right)=>$38bc36f53cb4eb10$var$handlePipeResult(right, def.in, ctx));
            return $38bc36f53cb4eb10$var$handlePipeResult(right, def.in, ctx);
        }
        const left = def.in._zod.run(payload, ctx);
        if (left instanceof Promise) return left.then((left)=>$38bc36f53cb4eb10$var$handlePipeResult(left, def.out, ctx));
        return $38bc36f53cb4eb10$var$handlePipeResult(left, def.out, ctx);
    };
});
function $38bc36f53cb4eb10$var$handlePipeResult(left, next, ctx) {
    // Any issue stops the pipe, so a failing refinement never feeds its transform. An unrecognized key is the exception: it describes the input's extra properties, not the value being piped, and an enclosing intersection may yet reconcile it.
    if (left.issues.some((iss)=>iss.code !== "unrecognized_keys")) {
        // prevent further checks
        left.aborted = true;
        return left;
    }
    return next._zod.run({
        value: left.value,
        issues: left.issues
    }, ctx);
}
const $38bc36f53cb4eb10$export$c622e07db8a40b53 = /*@__PURE__*/ $igTWG.$constructor("$ZodCodec", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    $ciVeX.defineLazyInternal(inst, "values", (zod)=>zod.def.in._zod.values);
    $ciVeX.defineLazyInternal(inst, "optin", (zod)=>zod.def.in._zod.optin);
    $ciVeX.defineLazyInternal(inst, "optout", (zod)=>zod.def.out._zod.optout);
    $ciVeX.defineLazyInternal(inst, "propValues", (zod)=>zod.def.in._zod.propValues);
    inst._zod.parse = (payload, ctx)=>{
        const direction = ctx.direction || "forward";
        if (direction === "forward") {
            const left = def.in._zod.run(payload, ctx);
            if (left instanceof Promise) return left.then((left)=>$38bc36f53cb4eb10$var$handleCodecAResult(left, def, ctx));
            return $38bc36f53cb4eb10$var$handleCodecAResult(left, def, ctx);
        } else {
            const right = def.out._zod.run(payload, ctx);
            if (right instanceof Promise) return right.then((right)=>$38bc36f53cb4eb10$var$handleCodecAResult(right, def, ctx));
            return $38bc36f53cb4eb10$var$handleCodecAResult(right, def, ctx);
        }
    };
});
function $38bc36f53cb4eb10$var$handleCodecAResult(result, def, ctx) {
    if (result.issues.length) {
        // prevent further checks
        result.aborted = true;
        return result;
    }
    const direction = ctx.direction || "forward";
    if (direction === "forward") {
        const transformed = def.transform(result.value, result);
        if (transformed instanceof Promise) return transformed.then((value1)=>$38bc36f53cb4eb10$var$handleCodecTxResult(result, value1, def.out, ctx));
        return $38bc36f53cb4eb10$var$handleCodecTxResult(result, transformed, def.out, ctx);
    } else {
        const transformed = def.reverseTransform(result.value, result);
        if (transformed instanceof Promise) return transformed.then((value1)=>$38bc36f53cb4eb10$var$handleCodecTxResult(result, value1, def.in, ctx));
        return $38bc36f53cb4eb10$var$handleCodecTxResult(result, transformed, def.in, ctx);
    }
}
function $38bc36f53cb4eb10$var$handleCodecTxResult(left, value1, nextSchema, ctx) {
    // Check if transform added any issues
    if (left.issues.length) {
        left.aborted = true;
        return left;
    }
    return nextSchema._zod.run({
        value: value1,
        issues: left.issues
    }, ctx);
}
const $38bc36f53cb4eb10$export$200c161ed581d39b = /*@__PURE__*/ $igTWG.$constructor("$ZodPreprocess", (inst, def)=>{
    $38bc36f53cb4eb10$export$4cb25cfde430326c.init(inst, def);
});
const $38bc36f53cb4eb10$export$f9f268f3fbb1601b = /*@__PURE__*/ $igTWG.$constructor("$ZodReadonly", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    $ciVeX.defineLazyInternal(inst, "propValues", (zod)=>zod.def.innerType._zod.propValues);
    $ciVeX.defineLazyInternal(inst, "values", (zod)=>zod.def.innerType._zod.values);
    $ciVeX.defineLazyInternal(inst, "optin", (zod)=>zod.def.innerType?._zod?.optin);
    $ciVeX.defineLazyInternal(inst, "optout", (zod)=>zod.def.innerType?._zod?.optout);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then($38bc36f53cb4eb10$var$handleReadonlyResult);
        return $38bc36f53cb4eb10$var$handleReadonlyResult(result);
    };
});
function $38bc36f53cb4eb10$var$handleReadonlyResult(payload) {
    // A repeat visit hands back a node that is still being built; freezing it here would make the rest of its keys fail to assign.
    if (!payload.memo) payload.value = Object.freeze(payload.value);
    return payload;
}
// a leaf's pattern source with its own checks folded in: the last pattern-carrying check wins, else length bounds narrow the catch-all, else an integer format narrows the number form. the fold lives here instead of on `_zod.pattern` so a bundle without template literals never pays for it
function $38bc36f53cb4eb10$var$leafPattern(schema) {
    const def = schema._zod.def;
    let pattern = def.pattern;
    let isInt = !!def.format?.includes("int");
    let minimum;
    let maximum;
    for (const ch of def.checks ?? []){
        const d = ch._zod.def;
        if (d.pattern) pattern = d.pattern;
        isInt || (isInt = !!d.format?.includes("int"));
        const lo = d.minimum ?? d.length;
        const hi = d.maximum ?? d.length;
        if (lo !== undefined && (minimum === undefined || lo > minimum)) minimum = lo;
        if (hi !== undefined && (maximum === undefined || hi < maximum)) maximum = hi;
    }
    if (pattern) return pattern.source;
    // an empty range matches nothing at runtime, and `{8,5}` is not a legal quantifier
    if (minimum !== undefined && maximum !== undefined && minimum > maximum) return "(?!)";
    if (minimum !== undefined || maximum !== undefined) return $8S8Wz.string({
        minimum: minimum,
        maximum: maximum
    }).source;
    const own = schema._zod.pattern;
    return (isInt && own === $8S8Wz.number ? $8S8Wz.integer : own)?.source;
}
// a part's pattern source. a wrapper's pattern embeds its inner pattern's source verbatim, so the folded form is substituted in place without knowing the wrapper's own composition; a union's options are joined the way the union builds its own pattern
function $38bc36f53cb4eb10$var$partPattern(schema) {
    const def = schema._zod.def;
    const own = schema._zod.pattern?.source;
    // lazy resolves its inner on the internals, not the def
    const inner = def.innerType ?? schema._zod.innerType;
    if (inner) {
        const before = inner._zod.pattern?.source;
        const after = $38bc36f53cb4eb10$var$partPattern(inner);
        if (own && before && after && after !== before) return own.replace($ciVeX.cleanRegex(before), ()=>$ciVeX.cleanRegex(after));
        return own;
    }
    if (def.options) {
        const sources = def.options.map($38bc36f53cb4eb10$var$partPattern);
        if (sources.every(Boolean)) return `^(${sources.map((s)=>$ciVeX.cleanRegex(s)).join("|")})$`;
    }
    return $38bc36f53cb4eb10$var$leafPattern(schema);
}
const $38bc36f53cb4eb10$export$37ea86c57a77af54 = /*@__PURE__*/ $igTWG.$constructor("$ZodTemplateLiteral", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    const regexParts = [];
    for (const part of def.parts){
        if (typeof part === "object" && part !== null) {
            // is Zod schema
            const source = $38bc36f53cb4eb10$var$partPattern(part);
            if (!source) throw new Error(`Invalid template literal part, no pattern found: ${[
                ...part._zod.traits
            ].shift()}`);
            regexParts.push($ciVeX.cleanRegex(source));
        } else if (part === null || $ciVeX.primitiveTypes.has(typeof part)) regexParts.push($ciVeX.escapeRegex(`${part}`));
        else throw new Error(`Invalid template literal part: ${part}`);
    }
    inst._zod.pattern = new RegExp(`^${regexParts.join("")}$`);
    inst._zod.parse = (payload, _ctx)=>{
        if (typeof payload.value !== "string") {
            payload.issues.push({
                input: payload.value,
                inst: inst,
                expected: "string",
                code: "invalid_type"
            });
            return payload;
        }
        inst._zod.pattern.lastIndex = 0;
        if (!inst._zod.pattern.test(payload.value)) {
            payload.issues.push({
                input: payload.value,
                inst: inst,
                code: "invalid_format",
                format: def.format ?? "template_literal",
                pattern: inst._zod.pattern.source
            });
            return payload;
        }
        return payload;
    };
});
const $38bc36f53cb4eb10$export$877c6e9c05ede764 = /*@__PURE__*/ $igTWG.$constructor("$ZodFunction", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    // Defined, not assigned: the classic prototype exposes `_def` as a getter with no setter.
    Object.defineProperty(inst, "_def", {
        value: def
    });
    inst._zod.def = def;
    inst.implement = (func)=>{
        if (typeof func !== "function") throw new Error("implement() must be called with a function");
        // Defined inline so the closure stays anonymous: binding it to a `const` first names it, which costs 256 bytes per implemented function.
        return Object.defineProperty(function(...args) {
            const parsedArgs = inst._def.input ? (0, $8K3FB.parse)(inst._def.input, args) : args;
            const result = Reflect.apply(func, this, parsedArgs);
            if (inst._def.output) return (0, $8K3FB.parse)(inst._def.output, result);
            return result;
        }, "_zod", {
            value: inst._zod,
            enumerable: false
        });
    };
    inst.implementAsync = (func)=>{
        if (typeof func !== "function") throw new Error("implementAsync() must be called with a function");
        return Object.defineProperty(async function(...args) {
            const parsedArgs = inst._def.input ? await (0, $8K3FB.parseAsync)(inst._def.input, args) : args;
            const result = await Reflect.apply(func, this, parsedArgs);
            if (inst._def.output) return await (0, $8K3FB.parseAsync)(inst._def.output, result);
            return result;
        }, "_zod", {
            value: inst._zod,
            enumerable: false
        });
    };
    inst._zod.parse = (payload, _ctx)=>{
        if (typeof payload.value !== "function") {
            payload.issues.push({
                code: "invalid_type",
                expected: "function",
                input: payload.value,
                inst: inst
            });
            return payload;
        }
        // Check if output is a promise type to determine if we should use async implementation
        const hasPromiseOutput = inst._def.output && inst._def.output._zod.def.type === "promise";
        if (hasPromiseOutput) payload.value = inst.implementAsync(payload.value);
        else payload.value = inst.implement(payload.value);
        return payload;
    };
    inst.input = (...args)=>{
        const F = inst.constructor;
        if (Array.isArray(args[0])) return new F({
            type: "function",
            input: new $38bc36f53cb4eb10$export$bba1b90a721dbd94({
                type: "tuple",
                items: args[0],
                rest: args[1]
            }),
            output: inst._def.output
        });
        return new F({
            type: "function",
            input: args[0],
            output: inst._def.output
        });
    };
    inst.output = (output)=>{
        const F = inst.constructor;
        return new F({
            type: "function",
            input: inst._def.input,
            output: output
        });
    };
    return inst;
});
const $38bc36f53cb4eb10$export$bdefabff0dd84ca4 = /*@__PURE__*/ $igTWG.$constructor("$ZodPromise", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        return Promise.resolve(payload.value).then((inner)=>def.innerType._zod.run({
                value: inner,
                issues: []
            }, ctx));
    };
});
const $38bc36f53cb4eb10$export$662fecee2efa1a66 = /*@__PURE__*/ $igTWG.$constructor("$ZodLazy", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    // Cache the resolved inner type on the shared `def` so all clones of this lazy (e.g. via `.describe()`/`.meta()`) share the same inner instance, preserving identity for cycle detection on recursive schemas.
    $ciVeX.defineLazy(inst._zod, "innerType", ()=>{
        const d = def;
        if (!d._cachedInner) d._cachedInner = def.getter();
        return d._cachedInner;
    });
    $ciVeX.defineLazyInternal(inst, "pattern", (zod)=>zod.innerType?._zod?.pattern);
    $ciVeX.defineLazyInternal(inst, "propValues", (zod)=>zod.innerType?._zod?.propValues);
    $ciVeX.defineLazyInternal(inst, "optin", (zod)=>zod.innerType?._zod?.optin ?? undefined);
    $ciVeX.defineLazyInternal(inst, "optout", (zod)=>zod.innerType?._zod?.optout ?? undefined);
    inst._zod.parse = (payload, ctx)=>{
        const inner = inst._zod.innerType;
        return inner._zod.run(payload, ctx);
    };
});
const $38bc36f53cb4eb10$export$3a5d0e5e098b79ba = /*@__PURE__*/ $igTWG.$constructor("$ZodCustom", (inst, def)=>{
    $b9Fsy.$ZodCheck.init(inst, def);
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _)=>{
        return payload;
    };
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const r = def.fn(input);
        if (r instanceof Promise) return r.then((r)=>$38bc36f53cb4eb10$var$handleRefineResult(r, payload, input, inst));
        $38bc36f53cb4eb10$var$handleRefineResult(r, payload, input, inst);
        return;
    };
});
function $38bc36f53cb4eb10$var$handleRefineResult(result, payload, input, inst) {
    if (!result) {
        const _iss = {
            code: "custom",
            input: input,
            inst: inst,
            path: [
                ...inst._zod.def.path ?? []
            ],
            continue: !inst._zod.def.abort
        };
        if (inst._zod.def.params) _iss.params = inst._zod.def.params;
        payload.issues.push($ciVeX.issue(_iss));
    }
}

});
parcelRegister("17YCc", function(module, exports) {
$parcel$export(module.exports, "Doc", () => $0d2576ce26252dd8$export$bceacc74c2212615);
class $0d2576ce26252dd8$export$bceacc74c2212615 {
    constructor(args = [], closed = {}){
        this.content = [];
        this.indent = 0;
        this.args = args;
        this.closed = closed;
    }
    // the compiler catches a child's throw and keeps writing into this doc, so the indent has to unwind with it
    indented(fn) {
        this.indent += 1;
        try {
            fn(this);
        } finally{
            this.indent -= 1;
        }
    }
    write(arg) {
        if (typeof arg === "function") {
            arg(this, {
                execution: "sync"
            });
            arg(this, {
                execution: "async"
            });
            return;
        }
        const content = arg;
        const lines = content.split("\n").filter((x)=>x);
        const minIndent = Math.min(...lines.map((x)=>x.length - x.trimStart().length));
        const dedented = lines.map((x)=>x.slice(minIndent)).map((x)=>" ".repeat(this.indent * 2) + x);
        for (const line of dedented)this.content.push(line);
    }
    compile() {
        const F = Function;
        const content = this?.content ?? [
            ``
        ];
        const factory = new F(...Object.keys(this.closed), `return function (${this.args.join(", ")}) {\n${content.join("\n")}\n};`);
        return factory(...Object.values(this.closed));
    }
}

});

parcelRegister("8K3FB", function(module, exports) {
$parcel$export(module.exports, "_parse", () => $65d57763ab0754f3$export$dcd1bb9991b57edf);
$parcel$export(module.exports, "parse", () => $65d57763ab0754f3$export$98e6a39c04603d36);
$parcel$export(module.exports, "_parseAsync", () => $65d57763ab0754f3$export$1fcca22dc6c780d0);
$parcel$export(module.exports, "parseAsync", () => $65d57763ab0754f3$export$59b6f938fbf579e3);
$parcel$export(module.exports, "_safeParse", () => $65d57763ab0754f3$export$5ec32605bf51e98e);
$parcel$export(module.exports, "_safeParseAsync", () => $65d57763ab0754f3$export$c08c7322f5625faf);
$parcel$export(module.exports, "validate", () => $65d57763ab0754f3$export$a22775fa5e2eebd9);
$parcel$export(module.exports, "validateAsync", () => $65d57763ab0754f3$export$ec9e0a98ddb8e655);
$parcel$export(module.exports, "_encode", () => $65d57763ab0754f3$export$50e4445ccc10715b);
$parcel$export(module.exports, "_decode", () => $65d57763ab0754f3$export$bb4a21772f43c982);
$parcel$export(module.exports, "_encodeAsync", () => $65d57763ab0754f3$export$9954740a1a5eaaf1);
$parcel$export(module.exports, "_decodeAsync", () => $65d57763ab0754f3$export$74b09e12c8956d91);
$parcel$export(module.exports, "_safeEncode", () => $65d57763ab0754f3$export$6d688d774257f486);
$parcel$export(module.exports, "_safeDecode", () => $65d57763ab0754f3$export$b2ef531a734faad5);
$parcel$export(module.exports, "_safeEncodeAsync", () => $65d57763ab0754f3$export$fa2ac180d22758d6);
$parcel$export(module.exports, "_safeDecodeAsync", () => $65d57763ab0754f3$export$f66d2b402dc6318c);

var $igTWG = parcelRequire("igTWG");

var $hQwmQ = parcelRequire("hQwmQ");

var $ciVeX = parcelRequire("ciVeX");
// Always both keys, so the `_params` read site in `_parse` sees one object shape rather than two.
function $65d57763ab0754f3$var$finalizeParams(callee, params) {
    return {
        callee: params?.callee ?? callee,
        Err: params?.Err
    };
}
const $65d57763ab0754f3$export$dcd1bb9991b57edf = (_Err)=>{
    const fn = (schema, value, _ctx, _params)=>{
        const ctx = _ctx ? {
            ..._ctx,
            async: false
        } : {
            async: false
        };
        const result = schema._zod.run({
            value: value,
            issues: []
        }, ctx);
        if (result instanceof Promise) throw new $igTWG.$ZodAsyncError();
        if (result.issues.length) {
            const e1 = new (_params?.Err ?? _Err)(result.issues.map((iss)=>$ciVeX.finalizeIssue(iss, ctx, $igTWG.config())));
            $ciVeX.captureStackTrace(e1, _params?.callee ?? fn);
            throw e1;
        }
        return result.value;
    };
    return fn;
};
const $65d57763ab0754f3$export$98e6a39c04603d36 = /* @__PURE__*/ $65d57763ab0754f3$export$dcd1bb9991b57edf($hQwmQ.$ZodRealError);
const $65d57763ab0754f3$export$1fcca22dc6c780d0 = (_Err)=>{
    const fn = async (schema, value, _ctx, params)=>{
        const ctx = _ctx ? {
            ..._ctx,
            async: true
        } : {
            async: true
        };
        let result = schema._zod.run({
            value: value,
            issues: []
        }, ctx);
        if (result instanceof Promise) result = await result;
        if (result.issues.length) {
            const e1 = new (params?.Err ?? _Err)(result.issues.map((iss)=>$ciVeX.finalizeIssue(iss, ctx, $igTWG.config())));
            $ciVeX.captureStackTrace(e1, params?.callee ?? fn);
            throw e1;
        }
        return result.value;
    };
    return fn;
};
const $65d57763ab0754f3$export$59b6f938fbf579e3 = /* @__PURE__*/ $65d57763ab0754f3$export$1fcca22dc6c780d0($hQwmQ.$ZodRealError);
const $65d57763ab0754f3$export$5ec32605bf51e98e = (_Err)=>(schema, value, _ctx)=>{
        const ctx = _ctx ? {
            ..._ctx,
            async: false
        } : {
            async: false
        };
        const result = schema._zod.run({
            value: value,
            issues: []
        }, ctx);
        if (result instanceof Promise) throw new $igTWG.$ZodAsyncError();
        return result.issues.length ? $65d57763ab0754f3$var$failure(_Err, result.issues, ctx) : {
            success: true,
            data: result.value
        };
    };
const $65d57763ab0754f3$export$b48ee232557adc37 = /* @__PURE__*/ $65d57763ab0754f3$export$5ec32605bf51e98e($hQwmQ.$ZodRealError);
// the error is built on the first read of `error`: finalizing the issues and constructing the instance is most of a failing parse, and a caller that only branches on `success` never pays it. a getter in the literal keeps this small; the alternative, one shared accessor descriptor plus a hidden state slot, reads ~15% faster but costs ~75 B gzipped in every bundle
function $65d57763ab0754f3$var$failure(Err, issues, ctx) {
    let error;
    return {
        success: false,
        get error () {
            if (!error) {
                error = new Err(issues.map((iss)=>$ciVeX.finalizeIssue(iss, ctx, $igTWG.config())));
                // finalizeIssue drops `input`, so the built error holds nothing; keeping the raw issues past this point pins the parsed value for the life of the result
                issues = undefined;
                ctx = undefined;
            }
            return error;
        },
        set error (e){
            error = e;
            // a replacement makes the getter's branch unreachable, so the captures have to go here too
            issues = undefined;
            ctx = undefined;
        }
    };
}
const $65d57763ab0754f3$export$c08c7322f5625faf = (_Err)=>async (schema, value, _ctx)=>{
        const ctx = _ctx ? {
            ..._ctx,
            async: true
        } : {
            async: true
        };
        let result = schema._zod.run({
            value: value,
            issues: []
        }, ctx);
        if (result instanceof Promise) result = await result;
        return result.issues.length ? $65d57763ab0754f3$var$failure(_Err, result.issues, ctx) : {
            success: true,
            data: result.value
        };
    };
const $65d57763ab0754f3$export$9b07b0d6e0389261 = /* @__PURE__*/ $65d57763ab0754f3$export$c08c7322f5625faf($hQwmQ.$ZodRealError);
// registry mirrors of the compiler's sentinels, so this module never imports the compiler
const $65d57763ab0754f3$var$COMPILE_INVALID = /* @__PURE__ */ Symbol.for("zod.compile.invalid");
const $65d57763ab0754f3$var$COMPILE_FALLBACK = /* @__PURE__ */ Symbol.for("zod.compile.fallback");
const $65d57763ab0754f3$export$a22775fa5e2eebd9 = (schema, value, _ctx)=>{
    const validator = schema._zod.bag.validator;
    if (validator !== undefined) {
        if (validator(value) !== $65d57763ab0754f3$var$COMPILE_INVALID) return true;
        // a definite sentinel means the runtime would reject, so skip the re-parse; a ctx can still change the answer
        if (validator.definite === true && _ctx === undefined) return false;
    }
    return $65d57763ab0754f3$var$validateFallback(schema, value, _ctx);
};
function $65d57763ab0754f3$var$validateFallback(schema, value, _ctx) {
    const ctx = _ctx ? {
        ..._ctx,
        async: false,
        abortEarly: true
    } : {
        async: false,
        abortEarly: true
    };
    const fallbackRun = schema._zod.bag.fallbackRun;
    let result;
    if (fallbackRun) {
        // skip nested fast paths on the fallback, so user callbacks keep the at-most-twice bound
        ctx[$65d57763ab0754f3$var$COMPILE_FALLBACK] = true;
        result = fallbackRun({
            value: value,
            issues: []
        }, ctx);
    } else result = schema._zod.run({
        value: value,
        issues: []
    }, ctx);
    if (result instanceof Promise) throw new $igTWG.$ZodAsyncError();
    return result.issues.length === 0;
}
const $65d57763ab0754f3$export$ec9e0a98ddb8e655 = async (schema, value, _ctx)=>{
    const ctx = _ctx ? {
        ..._ctx,
        async: true,
        abortEarly: true
    } : {
        async: true,
        abortEarly: true
    };
    let result = schema._zod.run({
        value: value,
        issues: []
    }, ctx);
    if (result instanceof Promise) result = await result;
    return result.issues.length === 0;
};
const $65d57763ab0754f3$export$50e4445ccc10715b = (_Err)=>{
    const parse = $65d57763ab0754f3$export$dcd1bb9991b57edf(_Err);
    const fn = (schema, value, _ctx, _params)=>{
        const ctx = _ctx ? {
            ..._ctx,
            direction: "backward"
        } : {
            direction: "backward"
        };
        return parse(schema, value, ctx, $65d57763ab0754f3$var$finalizeParams(fn, _params));
    };
    return fn;
};
const $65d57763ab0754f3$export$c564cdbbe6da493 = /* @__PURE__*/ $65d57763ab0754f3$export$50e4445ccc10715b($hQwmQ.$ZodRealError);
const $65d57763ab0754f3$export$bb4a21772f43c982 = (_Err)=>{
    const parse = $65d57763ab0754f3$export$dcd1bb9991b57edf(_Err);
    const fn = (schema, value, _ctx, _params)=>{
        return parse(schema, value, _ctx, $65d57763ab0754f3$var$finalizeParams(fn, _params));
    };
    return fn;
};
const $65d57763ab0754f3$export$2f872c0f2117be69 = /* @__PURE__*/ $65d57763ab0754f3$export$bb4a21772f43c982($hQwmQ.$ZodRealError);
const $65d57763ab0754f3$export$9954740a1a5eaaf1 = (_Err)=>{
    const parseAsync = $65d57763ab0754f3$export$1fcca22dc6c780d0(_Err);
    const fn = async (schema, value, _ctx, _params)=>{
        const ctx = _ctx ? {
            ..._ctx,
            direction: "backward"
        } : {
            direction: "backward"
        };
        return await parseAsync(schema, value, ctx, $65d57763ab0754f3$var$finalizeParams(fn, _params));
    };
    return fn;
};
const $65d57763ab0754f3$export$1a62660bbffb8f11 = /* @__PURE__*/ $65d57763ab0754f3$export$9954740a1a5eaaf1($hQwmQ.$ZodRealError);
const $65d57763ab0754f3$export$74b09e12c8956d91 = (_Err)=>{
    const parseAsync = $65d57763ab0754f3$export$1fcca22dc6c780d0(_Err);
    const fn = async (schema, value, _ctx, _params)=>{
        return await parseAsync(schema, value, _ctx, $65d57763ab0754f3$var$finalizeParams(fn, _params));
    };
    return fn;
};
const $65d57763ab0754f3$export$e4c183687a6ff9b = /* @__PURE__*/ $65d57763ab0754f3$export$74b09e12c8956d91($hQwmQ.$ZodRealError);
const $65d57763ab0754f3$export$6d688d774257f486 = (_Err)=>(schema, value, _ctx)=>{
        const ctx = _ctx ? {
            ..._ctx,
            direction: "backward"
        } : {
            direction: "backward"
        };
        return $65d57763ab0754f3$export$5ec32605bf51e98e(_Err)(schema, value, ctx);
    };
const $65d57763ab0754f3$export$c094f85f253e4d7d = /* @__PURE__*/ $65d57763ab0754f3$export$6d688d774257f486($hQwmQ.$ZodRealError);
const $65d57763ab0754f3$export$b2ef531a734faad5 = (_Err)=>(schema, value, _ctx)=>{
        return $65d57763ab0754f3$export$5ec32605bf51e98e(_Err)(schema, value, _ctx);
    };
const $65d57763ab0754f3$export$7a47376c130cfeac = /* @__PURE__*/ $65d57763ab0754f3$export$b2ef531a734faad5($hQwmQ.$ZodRealError);
const $65d57763ab0754f3$export$fa2ac180d22758d6 = (_Err)=>async (schema, value, _ctx)=>{
        const ctx = _ctx ? {
            ..._ctx,
            direction: "backward"
        } : {
            direction: "backward"
        };
        return $65d57763ab0754f3$export$c08c7322f5625faf(_Err)(schema, value, ctx);
    };
const $65d57763ab0754f3$export$ed163a34170fecc5 = /* @__PURE__*/ $65d57763ab0754f3$export$fa2ac180d22758d6($hQwmQ.$ZodRealError);
const $65d57763ab0754f3$export$f66d2b402dc6318c = (_Err)=>async (schema, value, _ctx)=>{
        return $65d57763ab0754f3$export$c08c7322f5625faf(_Err)(schema, value, _ctx);
    };
const $65d57763ab0754f3$export$9f879005292a9bc9 = /* @__PURE__*/ $65d57763ab0754f3$export$f66d2b402dc6318c($hQwmQ.$ZodRealError);

});
parcelRegister("hQwmQ", function(module, exports) {
$parcel$export(module.exports, "$ZodError", () => $cfe0667fefc5f30b$export$544878318730b1d8);
$parcel$export(module.exports, "$ZodRealError", () => $cfe0667fefc5f30b$export$4e07b515db2f7672);
$parcel$export(module.exports, "flattenError", () => $cfe0667fefc5f30b$export$4d7e0dfd5ca8366f);
$parcel$export(module.exports, "formatError", () => $cfe0667fefc5f30b$export$7b5b869ee98c16ab);

var $igTWG = parcelRequire("igTWG");

var $ciVeX = parcelRequire("ciVeX");
/* Computing the message eagerly is expensive (pretty-printed JSON of all
 * issues), so defer it until first read. The accessor functions and
 * descriptors are shared across instances to keep error construction
 * cheap; the computed message is cached on the internals object. The
 * setter preserves plain assignment semantics for consumers that
 * overwrite `message`. */ function $cfe0667fefc5f30b$var$_getMessage() {
    const internals = this._zod;
    internals.message ?? (internals.message = JSON.stringify(internals.def, $ciVeX.jsonStringifyReplacer, 2));
    return internals.message;
}
function $cfe0667fefc5f30b$var$_setMessage(value) {
    this._zod.message = value;
}
const $cfe0667fefc5f30b$var$_messageDesc = {
    get: $cfe0667fefc5f30b$var$_getMessage,
    set: $cfe0667fefc5f30b$var$_setMessage,
    enumerable: true,
    configurable: true
};
const $cfe0667fefc5f30b$var$_issuesDesc = {
    value: undefined,
    enumerable: false
};
/* Prototypes that already carry the lazy `toString`. Seeded with the
 * intrinsics so that `init` on a foreign object — it accepts any object —
 * can never install an accessor onto a prototype we do not own. */ const $cfe0667fefc5f30b$var$_installedToString = /* @__PURE__ */ new WeakSet([
    Object.prototype,
    Error.prototype
]);
const $cfe0667fefc5f30b$var$initializer = (inst, def)=>{
    inst.name = "$ZodError";
    // `_zod` is already non-enumerable: $constructor's init defined it with this same descriptor
    $cfe0667fefc5f30b$var$_issuesDesc.value = def;
    Object.defineProperty(inst, "issues", $cfe0667fefc5f30b$var$_issuesDesc);
    // Clear the shared slot; a retained `value` pins the last error's issues.
    $cfe0667fefc5f30b$var$_issuesDesc.value = undefined;
    Object.defineProperty(inst, "message", $cfe0667fefc5f30b$var$_messageDesc);
    /* `toString` lives as a non-enumerable lazy getter on the shared
     * prototype; on first access it caches a per-instance closure so
     * detached usage still works. */ const proto = Object.getPrototypeOf(inst);
    if (!$cfe0667fefc5f30b$var$_installedToString.has(proto)) {
        $cfe0667fefc5f30b$var$_installedToString.add(proto);
        Object.defineProperty(proto, "toString", {
            configurable: true,
            enumerable: false,
            get () {
                const value = ()=>this.message;
                Object.defineProperty(this, "toString", {
                    value: value,
                    configurable: true,
                    writable: true
                });
                return value;
            },
            set (value) {
                Object.defineProperty(this, "toString", {
                    value: value,
                    configurable: true,
                    writable: true
                });
            }
        });
    }
};
const $cfe0667fefc5f30b$export$544878318730b1d8 = (0, $igTWG.$constructor)("$ZodError", $cfe0667fefc5f30b$var$initializer);
const $cfe0667fefc5f30b$export$4e07b515db2f7672 = (0, $igTWG.$constructor)("$ZodError", $cfe0667fefc5f30b$var$initializer, undefined, {
    Parent: Error
});
/** Get-or-create `obj[key]` as an own data property. A path segment naming an inherited member
 * ("toString", "constructor") would otherwise read through to the prototype, and assigning
 * "__proto__" would hit the setter instead of creating a key. */ function $cfe0667fefc5f30b$var$node(obj, key, make) {
    if (!Object.prototype.hasOwnProperty.call(obj, key)) {
        if (key === "__proto__") Object.defineProperty(obj, key, {
            value: make(),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else obj[key] = make();
    }
    return obj[key];
}
function $cfe0667fefc5f30b$export$4d7e0dfd5ca8366f(error, mapper = (issue)=>issue.message) {
    const fieldErrors = {};
    const formErrors = [];
    for (const sub of error.issues)if (sub.path.length > 0) $cfe0667fefc5f30b$var$node(fieldErrors, sub.path[0], ()=>[]).push(mapper(sub));
    else formErrors.push(mapper(sub));
    return {
        formErrors: formErrors,
        fieldErrors: fieldErrors
    };
}
function $cfe0667fefc5f30b$export$7b5b869ee98c16ab(error, mapper = (issue)=>issue.message) {
    const fieldErrors = {
        _errors: []
    };
    const processError = (error, path = [])=>{
        for (const issue of error.issues){
            if (issue.code === "invalid_union" && issue.errors.length) issue.errors.map((issues)=>processError({
                    issues: issues
                }, [
                    ...path,
                    ...issue.path
                ]));
            else if (issue.code === "invalid_key") processError({
                issues: issue.issues
            }, [
                ...path,
                ...issue.path
            ]);
            else if (issue.code === "invalid_element") processError({
                issues: issue.issues
            }, [
                ...path,
                ...issue.path
            ]);
            else {
                const fullpath = [
                    ...path,
                    ...issue.path
                ];
                if (fullpath.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < fullpath.length){
                        const el = fullpath[i];
                        const terminal = i === fullpath.length - 1;
                        // `_errors` is reserved by this legacy format, so merge a matching path segment into the current node instead of treating its array as a child.
                        if (el === "_errors") {
                            if (terminal) curr._errors.push(mapper(issue));
                            i++;
                            continue;
                        }
                        // A path element may collide with an inherited property name such as
                        // "__proto__" or "constructor". Truthiness checks read the prototype
                        // (so no node is created, then ._errors.push throws), and bracket
                        // assignment of "__proto__" hits the setter instead of creating an
                        // own key. Guard the read with hasOwnProperty and create the node
                        // with defineProperty so any path element becomes a real own key.
                        if (!Object.prototype.hasOwnProperty.call(curr, el)) Object.defineProperty(curr, el, {
                            value: {
                                _errors: []
                            },
                            enumerable: true,
                            writable: true,
                            configurable: true
                        });
                        const node = curr[el];
                        if (terminal) node._errors.push(mapper(issue));
                        curr = node;
                        i++;
                    }
                }
            }
        }
    };
    processError(error);
    return fieldErrors;
}
function $cfe0667fefc5f30b$export$93701dc89257de2f(error, mapper = (issue)=>issue.message) {
    const result = {
        errors: []
    };
    const processError = (error, path = [])=>{
        var _a;
        for (const issue of error.issues){
            if (issue.code === "invalid_union" && issue.errors.length) // regular union error
            issue.errors.map((issues)=>processError({
                    issues: issues
                }, [
                    ...path,
                    ...issue.path
                ]));
            else if (issue.code === "invalid_key") processError({
                issues: issue.issues
            }, [
                ...path,
                ...issue.path
            ]);
            else if (issue.code === "invalid_element") processError({
                issues: issue.issues
            }, [
                ...path,
                ...issue.path
            ]);
            else {
                const fullpath = [
                    ...path,
                    ...issue.path
                ];
                if (fullpath.length === 0) {
                    result.errors.push(mapper(issue));
                    continue;
                }
                let curr = result;
                let i = 0;
                while(i < fullpath.length){
                    const el = fullpath[i];
                    const terminal = i === fullpath.length - 1;
                    if (typeof el === "string") {
                        curr.properties ?? (curr.properties = {});
                        // el may collide with an inherited property name ("__proto__",
                        // "constructor", ...); ??= reads the prototype so the node is never
                        // created and curr.errors.push throws. Guard with hasOwnProperty and
                        // create the node with defineProperty so "__proto__" becomes a real
                        // own key rather than invoking the prototype setter.
                        if (!Object.prototype.hasOwnProperty.call(curr.properties, el)) Object.defineProperty(curr.properties, el, {
                            value: {
                                errors: []
                            },
                            enumerable: true,
                            writable: true,
                            configurable: true
                        });
                        curr = curr.properties[el];
                    } else {
                        curr.items ?? (curr.items = []);
                        (_a = curr.items)[el] ?? (_a[el] = {
                            errors: []
                        });
                        curr = curr.items[el];
                    }
                    if (terminal) curr.errors.push(mapper(issue));
                    i++;
                }
            }
        }
    };
    processError(error);
    return result;
}
function $cfe0667fefc5f30b$export$47768e8997ceb13a(_path) {
    const segs = [];
    const path = _path.map((seg)=>typeof seg === "object" ? seg.key : seg);
    for (const seg of path){
        if (typeof seg === "number") segs.push(`[${seg}]`);
        else if (typeof seg === "symbol") segs.push(`[${JSON.stringify(String(seg))}]`);
        else if (/[^\w$]/.test(seg)) segs.push(`[${JSON.stringify(seg)}]`);
        else {
            if (segs.length) segs.push(".");
            segs.push(seg);
        }
    }
    return segs.join("");
}
function $cfe0667fefc5f30b$export$44eaaa72d914fe8c(error) {
    const lines = [];
    // sort by path length
    const issues = [
        ...error.issues
    ].sort((a, b)=>(a.path ?? []).length - (b.path ?? []).length);
    // Process each issue
    for (const issue of issues){
        lines.push(`\u{2716} ${issue.message}`);
        if (issue.path?.length) lines.push(`  \u{2192} at ${$cfe0667fefc5f30b$export$47768e8997ceb13a(issue.path)}`);
    }
    // Convert Map to formatted string
    return lines.join("\n");
}

});


parcelRegister("lVCDL", function(module, exports) {
$parcel$export(module.exports, "version", () => $ff6ce508b9832e6e$export$83d89fbfd8236492);
const $ff6ce508b9832e6e$export$83d89fbfd8236492 = {
    major: 4,
    minor: 6,
    patch: 5
};

});



parcelRegister("6xatX", function(module, exports) {
$parcel$export(module.exports, "memoizer", () => $4c1df4b6597e8399$export$17ac4b5c50355589);

var $ciVeX = parcelRequire("ciVeX");
class $4c1df4b6597e8399$export$a41a050c6c386536 extends Error {
    constructor(){
        super(`Cannot parse a reference cycle that closes through a transform`);
        this.name = "ZodCyclicError";
    }
}
/** Keyed off the context object every schema in one parse call already shares. */ const $4c1df4b6597e8399$var$STATE = "~memo";
const $4c1df4b6597e8399$var$NO_ISSUES = [];
// a value a cycle can close through
function $4c1df4b6597e8399$var$isRef(value) {
    return value !== null && typeof value === "object";
}
// Receivers prefix paths in place, so the cache and every hand-out need their own copies.
function $4c1df4b6597e8399$var$cloneIssues(issues) {
    return issues.map((iss)=>iss.path ? {
            ...iss,
            path: iss.path.slice()
        } : {
            ...iss
        });
}
const $4c1df4b6597e8399$var$recursive = /*@__PURE__*/ new WeakMap();
/** What the walk established, in order of certainty: ordered so the strongest answer among children wins. */ const $4c1df4b6597e8399$var$NONE = 0;
const $4c1df4b6597e8399$var$ASSUMED = 1;
const $4c1df4b6597e8399$var$PROVEN = 2;
/** Whether this schema's subtree contains a cycle, so one parse can re-enter it. */ function $4c1df4b6597e8399$var$isRecursive(inst, stack, resolve) {
    const cached = $4c1df4b6597e8399$var$recursive.get(inst);
    if (cached !== undefined) return cached ? $4c1df4b6597e8399$var$PROVEN : $4c1df4b6597e8399$var$NONE;
    // Relative to the walk in progress, so not cached.
    if (stack.has(inst)) return $4c1df4b6597e8399$var$PROVEN;
    stack.add(inst);
    let result = $4c1df4b6597e8399$var$NONE;
    const check = (child)=>{
        if (result !== $4c1df4b6597e8399$var$PROVEN && child?._zod) {
            const answer = $4c1df4b6597e8399$var$isRecursive(child, stack, resolve);
            if (answer > result) result = answer;
        }
    };
    // `Reflect.ownKeys` rather than `Object.keys`, so a cycle through a declared symbol key is still seen
    const shape = (sh, spread)=>{
        let answer = $4c1df4b6597e8399$var$NONE;
        for (const key of Reflect.ownKeys(sh)){
            const desc = Object.getOwnPropertyDescriptor(sh, key);
            // an object resolves its shape by spread, so a key it does not enumerate is never parsed; `z.properties` reads every own key and so keeps them all
            if (spread && !desc.enumerable) continue;
            // resolving runs user code, and a factory mints a fresh subtree per read, so an edge the walk can't follow counts as a cycle
            const child = desc.get ? $4c1df4b6597e8399$var$ASSUMED : desc.value?._zod ? $4c1df4b6597e8399$var$isRecursive(desc.value, stack, resolve) : $4c1df4b6597e8399$var$NONE;
            if (child > answer) answer = child;
        }
        return answer;
    };
    const merge = (answer)=>{
        if (answer > result) result = answer;
    };
    const def = inst._zod.def;
    const kind = def.type;
    switch(kind){
        case "object":
            {
                const raw = $ciVeX.rawShape(def);
                // a def with no raw shape answers `shape` from an accessor of its own, and running that can mint a whole fresh subtree
                merge(raw ? shape(raw, true) : $4c1df4b6597e8399$var$ASSUMED);
                check(def.catchall);
                break;
            }
        case "array":
            check(def.element);
            break;
        case "tuple":
            for (const el of def.items)check(el);
            check(def.rest);
            break;
        case "record":
        case "map":
            check(def.keyType);
            check(def.valueType);
            break;
        case "set":
            check(def.valueType);
            break;
        case "union":
            for (const el of def.options)check(el);
            break;
        case "intersection":
            check(def.left);
            check(def.right);
            break;
        case "optional":
        case "nullable":
        case "default":
        case "prefault":
        case "catch":
        case "readonly":
        case "nonoptional":
        case "promise":
        case "success":
            check(def.innerType);
            break;
        case "pipe":
            check(def.in);
            check(def.out);
            break;
        case "function":
            check(def.input);
            check(def.output);
            break;
        // `$ZodLazy` caches its inner on the def, so a resolved edge is followed exactly
        case "lazy":
            {
                const inner = def._cachedInner ?? (resolve ? inst._zod.innerType : undefined);
                // walked with resolution off: one hop sees past the deferral, and a lazy that yields only another unresolved lazy is generative, so it stops there
                merge(inner ? $4c1df4b6597e8399$var$isRecursive(inner, stack, false) : $4c1df4b6597e8399$var$ASSUMED);
                break;
            }
        // a leaf by choice: `parts` are regex fragments, not data positions
        case "template_literal":
        // leaves
        case "string":
        case "number":
        case "int":
        case "boolean":
        case "bigint":
        case "symbol":
        case "undefined":
        case "null":
        case "void":
        case "never":
        case "any":
        case "unknown":
        case "date":
        case "nan":
        case "enum":
        case "literal":
        case "file":
        case "transform":
        case "custom":
            break;
        default:
            // a new built-in kind becomes a compile error here
            kind;
            // a user-defined kind can still hold children, and only its author knows where, so fall back to scanning the def — skipping accessors, since reading one can run user code
            for(const key in def){
                const desc = Object.getOwnPropertyDescriptor(def, key);
                if (!desc || desc.get) continue;
                const value = desc.value;
                if (!value || typeof value !== "object") continue;
                if (value._zod) check(value);
                else if (Array.isArray(value)) for (const el of value)check(el);
            }
    }
    stack.delete(inst);
    return $4c1df4b6597e8399$var$settle(inst, result);
}
/** An assumed answer must not outlive the resolution that settles it, so only a certain one is cached. */ function $4c1df4b6597e8399$var$settle(inst, answer) {
    if (answer !== $4c1df4b6597e8399$var$ASSUMED) $4c1df4b6597e8399$var$recursive.set(inst, answer === $4c1df4b6597e8399$var$PROVEN);
    return answer;
}
function $4c1df4b6597e8399$export$2cdda7da3ed37816(inst) {
    // z.compile never parses, so nothing would ever resolve a lazy for it; it runs once and already treats a throw here as recursive
    return $4c1df4b6597e8399$var$isRecursive(inst, new Set(), true) !== $4c1df4b6597e8399$var$NONE;
}
function $4c1df4b6597e8399$var$bucketFor(state, inst) {
    let bucket = state.buckets.get(inst);
    if (!bucket) {
        bucket = new WeakMap();
        state.buckets.set(inst, bucket);
    }
    return bucket;
}
// Set immediately before delegating to core and cleared immediately after, so `alloc` registers only for a visit this module is driving.
let $4c1df4b6597e8399$var$handoff;
// Allocated but unfinished entries. `alloc` and the matching pop both happen in the synchronous part of a parse, so they nest even when children are async, and one stack serves every schema.
const $4c1df4b6597e8399$var$open = [];
const $4c1df4b6597e8399$var$memo = {
    alloc (_inst, payload, empty) {
        const bucket = $4c1df4b6597e8399$var$handoff;
        if (!bucket) return empty;
        $4c1df4b6597e8399$var$handoff = undefined;
        const entry = {
            value: empty,
            issues: null
        };
        bucket.set(payload.value, entry);
        $4c1df4b6597e8399$var$open.push(entry);
        return empty;
    },
    guard (inst) {
        var _a;
        (_a = inst._zod).deferred ?? (_a.deferred = []);
        inst._zod.deferred.push(()=>{
            const base = inst._zod.parse;
            const wrapped = (payload, ctx)=>{
                // The value is a placeholder a back-edge is still waiting on, so the cycle closes through this transform. Its output can't exist in time to bind.
                if (ctx.direction !== "backward" && $4c1df4b6597e8399$export$2832d97103138047(ctx, payload.value)) throw new $4c1df4b6597e8399$export$a41a050c6c386536();
                return base(payload, ctx);
            };
            inst._zod.parse = wrapped;
            if (inst._zod.run === base) inst._zod.run = wrapped;
        });
    },
    attach (inst) {
        var _a;
        let isRecursiveInst;
        let rechecked = false;
        // a recursive schema is re-entered many times per parse and its bucket never changes
        let lastCtx;
        let lastBucket;
        // Wraps `parse` in a deferred so it sees the container's final parse. Core's own deferred copies `parse` into `run` when there are no checks, and it ran first, so `run` is patched to match; with checks, `run` reads `parse` dynamically.
        (_a = inst._zod).deferred ?? (_a.deferred = []);
        inst._zod.deferred.push(()=>{
            const base = inst._zod.parse;
            const wrapped = (payload, ctx)=>{
                if (isRecursiveInst === undefined) {
                    const walked = $4c1df4b6597e8399$var$isRecursive(inst, new Set(), false);
                    if (walked === $4c1df4b6597e8399$var$NONE) {
                        // Nothing here can ever fire, so take it back out.
                        inst._zod.parse = base;
                        if (inst._zod.run === wrapped) inst._zod.run = base;
                        return base(payload, ctx);
                    }
                    // this parse resolves the deferred edges on its own path, so ask once more before latching
                    if (walked === $4c1df4b6597e8399$var$PROVEN || rechecked) isRecursiveInst = true;
                    else rechecked = true;
                }
                const input = payload.value;
                if (!$4c1df4b6597e8399$var$isRef(input)) return base(payload, ctx);
                let state = ctx[$4c1df4b6597e8399$var$STATE];
                if (!state) {
                    state = {
                        buckets: new WeakMap(),
                        backEdges: undefined
                    };
                    ctx[$4c1df4b6597e8399$var$STATE] = state;
                }
                let bucket;
                if (lastCtx === ctx) bucket = lastBucket;
                else {
                    bucket = $4c1df4b6597e8399$var$bucketFor(state, inst);
                    lastCtx = ctx;
                    lastBucket = bucket;
                }
                const hit = bucket.get(input);
                if (hit) {
                    payload.value = hit.value;
                    if (hit.issues) {
                        if (hit.issues.length) payload.issues.push(...$4c1df4b6597e8399$var$cloneIssues(hit.issues));
                    } else {
                        // Still being parsed: its own checks cover it, so skip them here.
                        payload.memo = true;
                        state.backEdges ?? (state.backEdges = new WeakSet());
                        state.backEdges.add(hit.value);
                    }
                    return payload;
                }
                $4c1df4b6597e8399$var$handoff = bucket;
                const depth = $4c1df4b6597e8399$var$open.length;
                const result = base(payload, ctx);
                $4c1df4b6597e8399$var$handoff = undefined;
                // A container that rejected its input outright allocated nothing.
                const entry = $4c1df4b6597e8399$var$open.length > depth ? $4c1df4b6597e8399$var$open.pop() : undefined;
                // Both paths written out so the sync one allocates no closure. It runs once per node, and capturing here cost more than everything else combined.
                if (result instanceof Promise) return result.then((r)=>{
                    if (entry) entry.issues = r.issues.length ? $4c1df4b6597e8399$var$cloneIssues(r.issues) : $4c1df4b6597e8399$var$NO_ISSUES;
                    return r;
                });
                if (entry) entry.issues = result.issues.length ? $4c1df4b6597e8399$var$cloneIssues(result.issues) : $4c1df4b6597e8399$var$NO_ISSUES;
                return result;
            };
            inst._zod.parse = wrapped;
            if (inst._zod.run === base) inst._zod.run = wrapped;
        });
    }
};
function $4c1df4b6597e8399$export$17ac4b5c50355589() {
    return $4c1df4b6597e8399$var$memo;
}
function $4c1df4b6597e8399$export$2832d97103138047(ctx, value) {
    const backEdges = ctx[$4c1df4b6597e8399$var$STATE]?.backEdges;
    return backEdges !== undefined && $4c1df4b6597e8399$var$isRef(value) && backEdges.has(value);
}

});

parcelRegister("lhsqI", function(module, exports) {
$parcel$export(module.exports, "aggregateChecks", () => $f7e13d138e46c528$export$9329961b252a50ea);
$parcel$export(module.exports, "stringProcessor", () => $f7e13d138e46c528$export$c6950985d9de996d);
$parcel$export(module.exports, "numberProcessor", () => $f7e13d138e46c528$export$afd08f475b2e134f);
$parcel$export(module.exports, "booleanProcessor", () => $f7e13d138e46c528$export$f03e9163a5233fc4);
$parcel$export(module.exports, "bigintProcessor", () => $f7e13d138e46c528$export$8810d61ae56edc9c);
$parcel$export(module.exports, "symbolProcessor", () => $f7e13d138e46c528$export$fd2b3c73524160ce);
$parcel$export(module.exports, "nullProcessor", () => $f7e13d138e46c528$export$7667b76b86382b1f);
$parcel$export(module.exports, "undefinedProcessor", () => $f7e13d138e46c528$export$9838a7ce212344b0);
$parcel$export(module.exports, "voidProcessor", () => $f7e13d138e46c528$export$b5910bb267c78233);
$parcel$export(module.exports, "neverProcessor", () => $f7e13d138e46c528$export$694b9cd80480ac33);
$parcel$export(module.exports, "anyProcessor", () => $f7e13d138e46c528$export$a92de72ffd9087b5);
$parcel$export(module.exports, "unknownProcessor", () => $f7e13d138e46c528$export$4e1fea7b2e7474f);
$parcel$export(module.exports, "dateProcessor", () => $f7e13d138e46c528$export$d044e6246fe40d06);
$parcel$export(module.exports, "enumProcessor", () => $f7e13d138e46c528$export$a0f7e3681bbe4f0b);
$parcel$export(module.exports, "literalProcessor", () => $f7e13d138e46c528$export$b7a483a046d3a9b);
$parcel$export(module.exports, "nanProcessor", () => $f7e13d138e46c528$export$f33d8739d51ecc4b);
$parcel$export(module.exports, "templateLiteralProcessor", () => $f7e13d138e46c528$export$59812826ec9f1850);
$parcel$export(module.exports, "fileProcessor", () => $f7e13d138e46c528$export$62de47a40c7b42b0);
$parcel$export(module.exports, "successProcessor", () => $f7e13d138e46c528$export$1e296a49315ba27a);
$parcel$export(module.exports, "customProcessor", () => $f7e13d138e46c528$export$fe3af043a76e4dab);
$parcel$export(module.exports, "functionProcessor", () => $f7e13d138e46c528$export$654f185ba88226ab);
$parcel$export(module.exports, "transformProcessor", () => $f7e13d138e46c528$export$707b17683f9c9ec0);
$parcel$export(module.exports, "mapProcessor", () => $f7e13d138e46c528$export$5e912d1710885757);
$parcel$export(module.exports, "setProcessor", () => $f7e13d138e46c528$export$2ff44e7a32269271);
$parcel$export(module.exports, "arrayProcessor", () => $f7e13d138e46c528$export$afeff382d55f455b);
$parcel$export(module.exports, "objectProcessor", () => $f7e13d138e46c528$export$8cc078cf99794668);
$parcel$export(module.exports, "unionProcessor", () => $f7e13d138e46c528$export$f387dff1d8008b49);
$parcel$export(module.exports, "intersectionProcessor", () => $f7e13d138e46c528$export$2a29f9128b7167c3);
$parcel$export(module.exports, "tupleProcessor", () => $f7e13d138e46c528$export$7767a398545ac85c);
$parcel$export(module.exports, "recordProcessor", () => $f7e13d138e46c528$export$6cf7a4b4a95ef1a8);
$parcel$export(module.exports, "nullableProcessor", () => $f7e13d138e46c528$export$452ce6f96b49219a);
$parcel$export(module.exports, "nonoptionalProcessor", () => $f7e13d138e46c528$export$7c6ac5b60b42bfc9);
$parcel$export(module.exports, "defaultProcessor", () => $f7e13d138e46c528$export$f76e6c36e8fb062b);
$parcel$export(module.exports, "prefaultProcessor", () => $f7e13d138e46c528$export$1ded4e432f286ac2);
$parcel$export(module.exports, "catchProcessor", () => $f7e13d138e46c528$export$3f81793c903cb504);
$parcel$export(module.exports, "pipeProcessor", () => $f7e13d138e46c528$export$3a3e6911d4012a24);
$parcel$export(module.exports, "readonlyProcessor", () => $f7e13d138e46c528$export$dd90252c562e1d9);
$parcel$export(module.exports, "promiseProcessor", () => $f7e13d138e46c528$export$ecb899a95fe4bdc0);
$parcel$export(module.exports, "optionalProcessor", () => $f7e13d138e46c528$export$4b1db46aa3739c48);
$parcel$export(module.exports, "lazyProcessor", () => $f7e13d138e46c528$export$9980155f320c317b);

var $8S8Wz = parcelRequire("8S8Wz");

var $4S00O = parcelRequire("4S00O");

var $1XUsZ = parcelRequire("1XUsZ");

var $ciVeX = parcelRequire("ciVeX");
const $f7e13d138e46c528$var$narrowMin = (agg, key, value)=>{
    if (agg[key] === undefined || value > agg[key]) agg[key] = value;
};
const $f7e13d138e46c528$var$narrowMax = (agg, key, value)=>{
    if (agg[key] === undefined || value < agg[key]) agg[key] = value;
};
const $f7e13d138e46c528$var$narrowBoth = (agg, value)=>{
    $f7e13d138e46c528$var$narrowMin(agg, "minimum", value);
    $f7e13d138e46c528$var$narrowMax(agg, "maximum", value);
};
const $f7e13d138e46c528$var$addDivisor = (agg, value)=>{
    agg.multipleOf ?? (agg.multipleOf = []);
    if (!agg.multipleOf.includes(value)) agg.multipleOf.push(value);
};
const $f7e13d138e46c528$var$addPattern = (agg, pattern)=>{
    agg.patterns ?? (agg.patterns = new Set());
    agg.patterns.add(pattern);
};
const $f7e13d138e46c528$var$intersectMime = (agg, mime)=>{
    agg.mime = agg.mime ? agg.mime.filter((m)=>mime.includes(m)) : [
        ...mime
    ];
};
// last-wins, matching the bag's historical write order; the flag keeps an integer format from being lost to a later float one
const $f7e13d138e46c528$var$setFormat = (agg, format)=>{
    agg.format = format;
    if (format.includes("int")) agg.isInt = true;
};
const $f7e13d138e46c528$var$minContributor = (agg, def)=>$f7e13d138e46c528$var$narrowMin(agg, "minimum", def.minimum);
const $f7e13d138e46c528$var$maxContributor = (agg, def)=>$f7e13d138e46c528$var$narrowMax(agg, "maximum", def.maximum);
const $f7e13d138e46c528$var$formatContributor = (ranges)=>(agg, def)=>{
        $f7e13d138e46c528$var$setFormat(agg, def.format);
        const [minimum, maximum] = ranges[def.format];
        $f7e13d138e46c528$var$narrowMin(agg, "minimum", minimum);
        $f7e13d138e46c528$var$narrowMax(agg, "maximum", maximum);
    };
const $f7e13d138e46c528$var$contributors = {
    greater_than: (agg, def)=>$f7e13d138e46c528$var$narrowMin(agg, def.inclusive ? "minimum" : "exclusiveMinimum", def.value),
    less_than: (agg, def)=>$f7e13d138e46c528$var$narrowMax(agg, def.inclusive ? "maximum" : "exclusiveMaximum", def.value),
    multiple_of: (agg, def)=>$f7e13d138e46c528$var$addDivisor(agg, def.value),
    number_format: $f7e13d138e46c528$var$formatContributor((0, $ciVeX.NUMBER_FORMAT_RANGES)),
    bigint_format: $f7e13d138e46c528$var$formatContributor((0, $ciVeX.BIGINT_FORMAT_RANGES)),
    min_length: $f7e13d138e46c528$var$minContributor,
    max_length: $f7e13d138e46c528$var$maxContributor,
    length_equals: (agg, def)=>$f7e13d138e46c528$var$narrowBoth(agg, def.length),
    min_size: $f7e13d138e46c528$var$minContributor,
    max_size: $f7e13d138e46c528$var$maxContributor,
    size_equals: (agg, def)=>$f7e13d138e46c528$var$narrowBoth(agg, def.size),
    string_format: (agg, def)=>{
        $f7e13d138e46c528$var$setFormat(agg, def.format);
        if (def.pattern) $f7e13d138e46c528$var$addPattern(agg, def.pattern);
        if (def.format === "base64" || def.format === "base64url") agg.contentEncoding = def.format;
        if (def.local || def.precision === -1) agg.laxFormat = true;
    },
    mime_type: (agg, def)=>$f7e13d138e46c528$var$intersectMime(agg, def.mime)
};
function $f7e13d138e46c528$export$9329961b252a50ea(schema) {
    const agg = {};
    const def = schema._zod.def;
    // a format schema is its own first check, same rule as $ZodType init
    const list = schema._zod.traits.has("$ZodCheck") ? [
        schema,
        ...def.checks ?? []
    ] : def.checks ?? [];
    for (const ch of list)$f7e13d138e46c528$var$contributors[ch._zod.def.check]?.(agg, ch._zod.def);
    // reconcile with the bag so third-party onattach contributions still land; first-party residue is never tighter than the fold, so merging it back is idempotent for one and additive for the other
    const bag = schema._zod.bag;
    if (bag.minimum !== undefined) $f7e13d138e46c528$var$narrowMin(agg, "minimum", bag.minimum);
    if (bag.exclusiveMinimum !== undefined) $f7e13d138e46c528$var$narrowMin(agg, "exclusiveMinimum", bag.exclusiveMinimum);
    if (bag.maximum !== undefined) $f7e13d138e46c528$var$narrowMax(agg, "maximum", bag.maximum);
    if (bag.exclusiveMaximum !== undefined) $f7e13d138e46c528$var$narrowMax(agg, "exclusiveMaximum", bag.exclusiveMaximum);
    if (bag.multipleOf !== undefined) $f7e13d138e46c528$var$addDivisor(agg, bag.multipleOf);
    if (bag.format !== undefined) {
        agg.format ?? (agg.format = bag.format);
        if (bag.format.includes("int")) agg.isInt = true;
    }
    if (bag.mime) $f7e13d138e46c528$var$intersectMime(agg, bag.mime);
    for (const pattern of bag.patterns ?? [])$f7e13d138e46c528$var$addPattern(agg, pattern);
    return agg;
}
const $f7e13d138e46c528$var$formatMap = {
    guid: "uuid",
    url: "uri",
    datetime: "date-time",
    json_string: "json-string",
    regex: ""
};
// ==================== SIMPLE TYPE PROCESSORS ====================
// the runtime patterns are lax so parse paths never overflow the regex stack; the emitted schema swaps in the exact block forms, which zod itself never executes
const $f7e13d138e46c528$var$exactPatterns = new Map([
    [
        (0, $4S00O.base64Charset),
        $8S8Wz.base64
    ],
    [
        (0, $4S00O.base64urlCharset),
        $8S8Wz.base64url
    ]
]);
const $f7e13d138e46c528$var$exactPattern = (p)=>$f7e13d138e46c528$var$exactPatterns.get(p) ?? p;
const $f7e13d138e46c528$export$c6950985d9de996d = (schema, ctx, _json, _params)=>{
    const json = _json;
    json.type = "string";
    const { minimum: minimum, maximum: maximum, format: format, patterns: patterns, contentEncoding: contentEncoding, laxFormat: laxFormat } = $f7e13d138e46c528$export$9329961b252a50ea(schema);
    if (typeof minimum === "number") json.minLength = minimum;
    if (typeof maximum === "number") json.maxLength = maximum;
    // custom pattern overrides format
    if (format) {
        json.format = $f7e13d138e46c528$var$formatMap[format] ?? format;
        if (json.format === "") delete json.format; // empty format is not valid
        // `z.iso.time()` is never full-time, and `laxFormat` carries the datetime shapes that also accept what their keyword forbids
        if (format === "time" || laxFormat) delete json.format;
    }
    if (contentEncoding) json.contentEncoding = contentEncoding;
    if (patterns && patterns.size > 0) {
        const patternList = [
            ...patterns
        ].map($f7e13d138e46c528$var$exactPattern);
        if (patternList.length === 1) json.pattern = patternList[0].source;
        else if (patternList.length > 1) json.allOf = [
            ...patternList.map((regex)=>({
                    ...ctx.target === "draft-07" || ctx.target === "draft-04" || ctx.target === "openapi-3.0" ? {
                        type: "string"
                    } : {},
                    pattern: regex.source
                }))
        ];
    }
};
const $f7e13d138e46c528$export$afd08f475b2e134f = (schema, ctx, _json, params)=>{
    const json = _json;
    const { minimum: minimum, maximum: maximum, multipleOf: multipleOf, exclusiveMaximum: exclusiveMaximum, exclusiveMinimum: exclusiveMinimum, isInt: isInt } = $f7e13d138e46c528$export$9329961b252a50ea(schema);
    json.type = isInt ? "integer" : "number";
    // when both minimum and exclusiveMinimum exist, pick the more restrictive one
    const exMin = typeof exclusiveMinimum === "number" && exclusiveMinimum >= (minimum ?? Number.NEGATIVE_INFINITY);
    const exMax = typeof exclusiveMaximum === "number" && exclusiveMaximum <= (maximum ?? Number.POSITIVE_INFINITY);
    const legacy = ctx.target === "draft-04" || ctx.target === "openapi-3.0";
    if (exMin) {
        if (legacy) {
            json.minimum = exclusiveMinimum;
            json.exclusiveMinimum = true;
        } else json.exclusiveMinimum = exclusiveMinimum;
    } else if (typeof minimum === "number") json.minimum = minimum;
    if (exMax) {
        if (legacy) {
            json.maximum = exclusiveMaximum;
            json.exclusiveMaximum = true;
        } else json.exclusiveMaximum = exclusiveMaximum;
    } else if (typeof maximum === "number") json.maximum = maximum;
    if (multipleOf) {
        // JSON Schema requires a divisor strictly greater than zero, and a non-finite one does not survive JSON at all. A negative divisor accepts exactly what its absolute value accepts, so it still maps; zero, NaN and Infinity have no keyword form.
        const divisors = new Set();
        for (const divisor of multipleOf)if (Number.isFinite(divisor) && divisor !== 0) divisors.add(Math.abs(divisor));
        else (0, $1XUsZ.handleUnrepresentable)(schema, ctx, json, params, `A multipleOf divisor of ${divisor} cannot be represented in JSON Schema`);
        // chained divisors are a conjunction the keyword cannot carry alone, so extras ride an allOf, same as stacked patterns
        const [first, ...rest] = divisors;
        if (first !== undefined) json.multipleOf = first;
        if (rest.length) json.allOf = [
            ...json.allOf ?? [],
            ...rest.map((m)=>({
                    multipleOf: m
                }))
        ];
    }
};
const $f7e13d138e46c528$export$f03e9163a5233fc4 = (_schema, _ctx, json, _params)=>{
    json.type = "boolean";
};
const $f7e13d138e46c528$export$8810d61ae56edc9c = (schema, ctx, json, params)=>{
    (0, $1XUsZ.handleUnrepresentable)(schema, ctx, json, params, "BigInt cannot be represented in JSON Schema");
};
const $f7e13d138e46c528$export$fd2b3c73524160ce = (schema, ctx, json, params)=>{
    (0, $1XUsZ.handleUnrepresentable)(schema, ctx, json, params, "Symbols cannot be represented in JSON Schema");
};
const $f7e13d138e46c528$export$7667b76b86382b1f = (_schema, ctx, json, _params)=>{
    if (ctx.target === "openapi-3.0") {
        json.type = "string";
        json.nullable = true;
        json.enum = [
            null
        ];
    } else json.type = "null";
};
const $f7e13d138e46c528$export$9838a7ce212344b0 = (schema, ctx, json, params)=>{
    (0, $1XUsZ.handleUnrepresentable)(schema, ctx, json, params, "Undefined cannot be represented in JSON Schema");
};
const $f7e13d138e46c528$export$b5910bb267c78233 = (schema, ctx, json, params)=>{
    (0, $1XUsZ.handleUnrepresentable)(schema, ctx, json, params, "Void cannot be represented in JSON Schema");
};
const $f7e13d138e46c528$export$694b9cd80480ac33 = (_schema, _ctx, json, _params)=>{
    json.not = {};
};
const $f7e13d138e46c528$export$a92de72ffd9087b5 = (_schema, _ctx, _json, _params)=>{
// empty schema accepts anything
};
const $f7e13d138e46c528$export$4e1fea7b2e7474f = (_schema, _ctx, _json, _params)=>{
// empty schema accepts anything
};
const $f7e13d138e46c528$export$d044e6246fe40d06 = (schema, ctx, json, params)=>{
    (0, $1XUsZ.handleUnrepresentable)(schema, ctx, json, params, "Date cannot be represented in JSON Schema");
};
const $f7e13d138e46c528$export$a0f7e3681bbe4f0b = (schema, _ctx, json, _params)=>{
    const def = schema._zod.def;
    const values = (0, $ciVeX.getEnumValues)(def.entries);
    // an empty enum accepts nothing, same as z.never()
    if (values.length === 0) {
        json.not = {};
        return;
    }
    // Number enums can have both string and number values
    if (values.every((v)=>typeof v === "number")) json.type = "number";
    if (values.every((v)=>typeof v === "string")) json.type = "string";
    json.enum = values;
};
const $f7e13d138e46c528$export$b7a483a046d3a9b = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    // a literal with no values accepts nothing, same as z.never()
    if (def.values.length === 0) {
        json.not = {};
        return;
    }
    const vals = [];
    for (const val of def.values){
        if (val === undefined) {
            // a custom schema replaces the whole literal, so there is nothing left to accumulate
            if ((0, $1XUsZ.handleUnrepresentable)(schema, ctx, json, params, "Literal `undefined` cannot be represented in JSON Schema")) return;
        // otherwise do not add to vals
        } else if (typeof val === "bigint") {
            if ((0, $1XUsZ.handleUnrepresentable)(schema, ctx, json, params, "BigInt literals cannot be represented in JSON Schema")) return;
            vals.push(Number(val));
        } else vals.push(val);
    }
    if (vals.length === 0) ;
    else if (vals.length === 1) {
        const val = vals[0];
        json.type = val === null ? "null" : typeof val;
        if (ctx.target === "draft-04" || ctx.target === "openapi-3.0") json.enum = [
            val
        ];
        else json.const = val;
    } else {
        if (vals.every((v)=>typeof v === "number")) json.type = "number";
        if (vals.every((v)=>typeof v === "string")) json.type = "string";
        if (vals.every((v)=>typeof v === "boolean")) json.type = "boolean";
        if (vals.every((v)=>v === null)) json.type = "null";
        json.enum = vals;
    }
};
const $f7e13d138e46c528$export$f33d8739d51ecc4b = (schema, ctx, json, params)=>{
    (0, $1XUsZ.handleUnrepresentable)(schema, ctx, json, params, "NaN cannot be represented in JSON Schema");
};
const $f7e13d138e46c528$export$59812826ec9f1850 = (schema, _ctx, json, _params)=>{
    const _json = json;
    const pattern = schema._zod.pattern;
    if (!pattern) throw new Error("Pattern not found in template literal");
    _json.type = "string";
    _json.pattern = pattern.source;
};
const $f7e13d138e46c528$export$62de47a40c7b42b0 = (schema, _ctx, json, _params)=>{
    const _json = json;
    _json.type = "string";
    _json.format = "binary";
    _json.contentEncoding = "binary";
    const { minimum: minimum, maximum: maximum, mime: mime } = $f7e13d138e46c528$export$9329961b252a50ea(schema);
    if (minimum !== undefined) _json.minLength = minimum;
    if (maximum !== undefined) _json.maxLength = maximum;
    if (!mime) return;
    // an empty intersection means the mime checks share no value, so nothing passes at runtime; `anyOf` must be non-empty, so the false schema is `not: {}`
    if (mime.length === 0) _json.not = {};
    else if (mime.length === 1) _json.contentMediaType = mime[0];
    else _json.anyOf = mime.map((m)=>({
            contentMediaType: m
        }));
};
const $f7e13d138e46c528$export$1e296a49315ba27a = (_schema, _ctx, json, _params)=>{
    json.type = "boolean";
};
const $f7e13d138e46c528$export$fe3af043a76e4dab = (schema, ctx, json, params)=>{
    (0, $1XUsZ.handleUnrepresentable)(schema, ctx, json, params, "Custom types cannot be represented in JSON Schema");
};
const $f7e13d138e46c528$export$654f185ba88226ab = (schema, ctx, json, params)=>{
    (0, $1XUsZ.handleUnrepresentable)(schema, ctx, json, params, "Function types cannot be represented in JSON Schema");
};
const $f7e13d138e46c528$export$707b17683f9c9ec0 = (schema, ctx, json, params)=>{
    (0, $1XUsZ.handleUnrepresentable)(schema, ctx, json, params, "Transforms cannot be represented in JSON Schema");
};
const $f7e13d138e46c528$export$5e912d1710885757 = (schema, ctx, json, params)=>{
    (0, $1XUsZ.handleUnrepresentable)(schema, ctx, json, params, "Map cannot be represented in JSON Schema");
};
const $f7e13d138e46c528$export$2ff44e7a32269271 = (schema, ctx, json, params)=>{
    (0, $1XUsZ.handleUnrepresentable)(schema, ctx, json, params, "Set cannot be represented in JSON Schema");
};
const $f7e13d138e46c528$export$afeff382d55f455b = (schema, ctx, _json, params)=>{
    const json = _json;
    const def = schema._zod.def;
    const { minimum: minimum, maximum: maximum } = $f7e13d138e46c528$export$9329961b252a50ea(schema);
    if (typeof minimum === "number") json.minItems = minimum;
    if (typeof maximum === "number") json.maxItems = maximum;
    json.type = "array";
    json.items = (0, $1XUsZ.processSchema)(def.element, ctx, {
        ...params,
        path: [
            ...params.path,
            "items"
        ]
    });
};
// Transform and catch set `optin = "optional"` at runtime so the parser lets them observe an
// absent key, but their declared input type stays required. An input JSON Schema describes the
// declared type, so resolve past them to the schema that actually carries the optionality.
// Used by both `objectProcessor` (for `required`) and `tupleProcessor` (for `minItems`); see
// wiki/optionality.md, "The JSON Schema emitter reads the *static* value".
function $f7e13d138e46c528$var$inputOptin(schema) {
    const def = schema._zod.def;
    if (def.type === "pipe" && def.in._zod.traits.has("$ZodTransform")) return $f7e13d138e46c528$var$inputOptin(def.out);
    if (def.type === "catch") return $f7e13d138e46c528$var$inputOptin(def.innerType);
    return schema._zod.optin;
}
const $f7e13d138e46c528$export$8cc078cf99794668 = (schema, ctx, _json, params)=>{
    const json = _json;
    const def = schema._zod.def;
    const shape = def.shape;
    // dropping it while still emitting `additionalProperties: false` would emit a schema that rejects data this one requires
    const symbolKeys = Object.getOwnPropertySymbols(shape);
    if (symbolKeys.length && (0, $1XUsZ.handleUnrepresentable)(schema, ctx, json, params, "Symbol keys cannot be represented in JSON Schema")) return;
    json.type = "object";
    json.properties = {};
    for(const key in shape)// assignProp so a __proto__ key becomes an own property instead of hitting the inherited setter on the plain {} we build into
    (0, $ciVeX.assignProp)(json.properties, key, (0, $1XUsZ.processSchema)(shape[key], ctx, {
        ...params,
        path: [
            ...params.path,
            "properties",
            key
        ]
    }));
    // required keys
    const requiredKeys = [];
    for (const key of Object.keys(shape)){
        const field = def.shape[key];
        if (ctx.io === "input" ? $f7e13d138e46c528$var$inputOptin(field) === undefined : field._zod.optout === undefined) requiredKeys.push(key);
    }
    if (requiredKeys.length > 0) json.required = requiredKeys;
    // catchall
    if (def.catchall?._zod.def.type === "never") // strict
    json.additionalProperties = false;
    else if (!def.catchall) // regular
    {
        if (ctx.io === "output") json.additionalProperties = false;
    } else if (def.catchall) json.additionalProperties = (0, $1XUsZ.processSchema)(def.catchall, ctx, {
        ...params,
        path: [
            ...params.path,
            "additionalProperties"
        ]
    });
};
const $f7e13d138e46c528$export$f387dff1d8008b49 = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    // Exclusive unions (inclusive === false) use oneOf (exactly one match) instead of anyOf (one or more matches). This includes both z.xor() and discriminated unions
    const isExclusive = def.inclusive === false;
    const options = def.options.map((x, i)=>(0, $1XUsZ.processSchema)(x, ctx, {
            ...params,
            path: [
                ...params.path,
                isExclusive ? "oneOf" : "anyOf",
                i
            ]
        }));
    if (isExclusive) json.oneOf = options;
    else json.anyOf = options;
};
const $f7e13d138e46c528$export$2a29f9128b7167c3 = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    const a = (0, $1XUsZ.processSchema)(def.left, ctx, {
        ...params,
        path: [
            ...params.path,
            "allOf",
            0
        ]
    });
    const b = (0, $1XUsZ.processSchema)(def.right, ctx, {
        ...params,
        path: [
            ...params.path,
            "allOf",
            1
        ]
    });
    const isSimpleIntersection = (val)=>"allOf" in val && Object.keys(val).length === 1;
    const allOf = [
        ...isSimpleIntersection(a) ? a.allOf : [
            a
        ],
        ...isSimpleIntersection(b) ? b.allOf : [
            b
        ]
    ];
    json.allOf = allOf;
    // Recorded innermost first, so a nested intersection has already folded by the time this one is considered. The array is the handle rather than the schema, because a wrapper that inherits this schema shares the same array; `finalize` folds every object holding it. See `foldIntersection`.
    ctx.intersections.push(allOf);
};
const $f7e13d138e46c528$export$7767a398545ac85c = (schema, ctx, _json, params)=>{
    const json = _json;
    const def = schema._zod.def;
    json.type = "array";
    const prefixPath = ctx.target === "draft-2020-12" ? "prefixItems" : "items";
    const restPath = ctx.target === "draft-2020-12" ? "items" : ctx.target === "openapi-3.0" ? "items" : "additionalItems";
    const prefixItems = def.items.map((x, i)=>(0, $1XUsZ.processSchema)(x, ctx, {
            ...params,
            path: [
                ...params.path,
                prefixPath,
                i
            ]
        }));
    const rest = def.rest ? (0, $1XUsZ.processSchema)(def.rest, ctx, {
        ...params,
        path: [
            ...params.path,
            restPath,
            ...ctx.target === "openapi-3.0" ? [
                def.items.length
            ] : []
        ]
    }) : null;
    let minItems = def.items.length;
    while(minItems > 0){
        const item = def.items[minItems - 1];
        const optional = ctx.io === "input" ? $f7e13d138e46c528$var$inputOptin(item) !== undefined : item._zod.optout === "optional";
        if (!optional) break;
        minItems--;
    }
    const maxItems = def.items.length;
    const isClosed = !def.rest;
    if (ctx.target === "draft-2020-12") {
        json.prefixItems = prefixItems;
        if (isClosed) json.items = false;
        else if (rest) json.items = rest;
        if (minItems > 0) json.minItems = minItems;
        if (isClosed) json.maxItems = maxItems;
    } else if (ctx.target === "openapi-3.0") {
        json.items = {
            anyOf: prefixItems
        };
        if (rest) json.items.anyOf.push(rest);
        if (minItems > 0) json.minItems = minItems;
        if (isClosed) json.maxItems = maxItems;
    } else {
        json.items = prefixItems;
        if (isClosed) json.additionalItems = false;
        else if (rest) json.additionalItems = rest;
        if (minItems > 0) json.minItems = minItems;
        if (isClosed) json.maxItems = maxItems;
    }
    // explicit user-defined length checks take precedence
    const { minimum: minimum, maximum: maximum } = $f7e13d138e46c528$export$9329961b252a50ea(schema);
    if (typeof minimum === "number") json.minItems = minimum;
    if (typeof maximum === "number") json.maxItems = maximum;
};
/** JSON object keys are always strings, so a numeric record key schema is re-expressed over the
 * numeric-string form the record parser matches. Deferred to `finalize`, after the flatten: a key
 * behind a wrapper only carries its own `type` before then, and a union key only has its branches.
 *
 * A numeric bound cannot apply to a property name, so `minimum` and its siblings are dropped rather
 * than carried over: keeping them beside `type: "string"` reproduces the match-nothing schema this
 * exists to fix. A key that carries one therefore emits wider than the record parses — `z.record(z.number().min(5), V)`
 * accepts `"3"` — which is the deliberate trade, since throwing on it would reject an ordinary schema
 * outright. */ function $f7e13d138e46c528$var$stringifyKeyNames(bySchema, json, visited) {
    // an extracted key that rewrites cannot go on sharing its definition — the string form a key position needs is not the number form every other reference wants — so it inlines. One that does not rewrite keeps the `$ref`.
    if (json.$ref) {
        // a recursive key holds its own reference inside its definition, so a node already on the path is left alone rather than resolved again
        if (visited.has(json)) return json;
        visited.add(json);
        const def = bySchema.get(json)?.def;
        if (!def) return json;
        const inlined = $f7e13d138e46c528$var$stringifyKeyNames(bySchema, def, visited);
        return inlined === def ? json : inlined;
    }
    for (const keyword of [
        "anyOf",
        "oneOf"
    ]){
        const branches = json[keyword];
        if (!Array.isArray(branches)) continue;
        const mapped = branches.map((branch)=>$f7e13d138e46c528$var$stringifyKeyNames(bySchema, branch, visited));
        // rebuilding regardless would detach a key that had nothing to re-express, dropping its `$ref` and leaking the internal `id`
        if (mapped.some((branch, i)=>branch !== branches[i])) json = {
            ...json,
            [keyword]: mapped
        };
    }
    // a member that already admits a string leaves the key unconstrained, so the node's own type re-expresses only when every member is numeric
    const types = Array.isArray(json.type) ? json.type : [
        json.type
    ];
    const numericType = !types.includes("string") && types.some((t)=>t === "number" || t === "integer");
    // a heterogeneous key carries no type at all, so its numeric members are caught here instead
    const values = json.enum ?? (json.const !== undefined ? [
        json.const
    ] : undefined);
    if (!numericType && !values?.some((v)=>typeof v === "number")) return json;
    const { minimum: minimum, maximum: maximum, exclusiveMinimum: exclusiveMinimum, exclusiveMaximum: exclusiveMaximum, multipleOf: multipleOf, format: format, id: id, ...rest } = json;
    if (rest.enum) rest.enum = rest.enum.map((v)=>typeof v === "number" ? String(v) : v);
    else if (typeof rest.const === "number") rest.const = String(rest.const);
    // a heterogeneous key keeps its absent type: the stringified members already say what a key may be
    if (!numericType) return rest;
    rest.type = "string";
    if (!values) rest.pattern = (types.includes("number") ? $8S8Wz.number : $8S8Wz.integer).source;
    return rest;
}
/** Every record of one conversion, so the carriers are found in a single pass rather than once per record. */ const $f7e13d138e46c528$var$pendingRecords = new WeakMap();
function $f7e13d138e46c528$var$rewriteKeyNames(ctx) {
    // an extracted key is resolved by the object `extractToDef` left in its place, so the map is built once rather than searched per reference. `_zod.toJSONSchema` can hand the same object to two schemas, so the first entry carrying a body wins, as a search would have found it.
    const bySchema = new Map();
    for (const entry of ctx.seen.values())if (entry.def && !bySchema.has(entry.schema)) bySchema.set(entry.schema, entry);
    const rewrites = new Map();
    for (const record of $f7e13d138e46c528$var$pendingRecords.get(ctx) ?? []){
        const seen = ctx.seen.get(record);
        const names = (seen?.def ?? seen?.schema)?.propertyNames;
        if (!names || names === true || rewrites.has(names)) continue;
        const rewritten = $f7e13d138e46c528$var$stringifyKeyNames(bySchema, names, new Set());
        if (rewritten !== names) rewrites.set(names, rewritten);
    }
    if (!rewrites.size) return;
    // the flatten has already copied each record's own properties onto every wrapper by reference, and an extracted body is another such copy, so every carrier holding a rewritten key is updated together
    for (const entry of ctx.seen.values())for (const carrier of [
        entry.schema,
        entry.def
    ]){
        const rewritten = carrier && rewrites.get(carrier.propertyNames);
        if (rewritten) carrier.propertyNames = rewritten;
    }
}
const $f7e13d138e46c528$export$6cf7a4b4a95ef1a8 = (schema, ctx, _json, params)=>{
    const json = _json;
    const def = schema._zod.def;
    json.type = "object";
    // For looseRecord with regex patterns, use patternProperties. This correctly represents "only validate keys matching the pattern" semantics and composes well with allOf (intersections)
    const keyType = def.keyType;
    const patterns = $f7e13d138e46c528$export$9329961b252a50ea(keyType).patterns;
    if (def.mode === "loose" && patterns && patterns.size > 0) {
        // Use patternProperties for looseRecord with regex patterns
        const valueSchema = (0, $1XUsZ.processSchema)(def.valueType, ctx, {
            ...params,
            path: [
                ...params.path,
                "patternProperties",
                "*"
            ]
        });
        json.patternProperties = {};
        for (const pattern of patterns)(0, $ciVeX.assignProp)(json.patternProperties, $f7e13d138e46c528$var$exactPattern(pattern).source, valueSchema);
    } else {
        // Default behavior: use propertyNames + additionalProperties
        if (ctx.target === "draft-07" || ctx.target === "draft-2020-12") {
            json.propertyNames = (0, $1XUsZ.processSchema)(def.keyType, ctx, {
                ...params,
                path: [
                    ...params.path,
                    "propertyNames"
                ]
            });
            let pending = $f7e13d138e46c528$var$pendingRecords.get(ctx);
            if (!pending) {
                pending = [];
                $f7e13d138e46c528$var$pendingRecords.set(ctx, pending);
                ctx.deferred.push(()=>$f7e13d138e46c528$var$rewriteKeyNames(ctx));
            }
            pending.push(schema);
        }
        json.additionalProperties = (0, $1XUsZ.processSchema)(def.valueType, ctx, {
            ...params,
            path: [
                ...params.path,
                "additionalProperties"
            ]
        });
    }
    // Add required for keys with discrete values (enum, literal, etc.)
    const keyValues = keyType._zod.values;
    // Every key shares one value schema, so an optional-in value makes the whole key set omittable on input. Output keeps them: the exhaustive branch assigns every key, even one whose value came back undefined.
    const omittableOnInput = ctx.io === "input" && $f7e13d138e46c528$var$inputOptin(def.valueType) !== undefined;
    if (keyValues && !def.partial && !omittableOnInput) {
        const validKeyValues = [
            ...keyValues
        ].filter((v)=>typeof v === "string" || typeof v === "number");
        if (validKeyValues.length > 0) json.required = validKeyValues.map(String);
    }
};
const $f7e13d138e46c528$export$452ce6f96b49219a = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    const inner = (0, $1XUsZ.processSchema)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    if (ctx.target === "openapi-3.0") {
        seen.ref = def.innerType;
        json.nullable = true;
    } else json.anyOf = [
        inner,
        {
            type: "null"
        }
    ];
};
const $f7e13d138e46c528$export$7c6ac5b60b42bfc9 = (schema, ctx, _json, params)=>{
    const def = schema._zod.def;
    (0, $1XUsZ.processSchema)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
};
/** Round-trips a default value through JSON so the emitted schema is guaranteed to be valid JSON.
 * A BigInt has no reliable encoding, so it goes through `unrepresentable` like any other
 * unrepresentable value. Returns a sentinel when the caller must not write a default of its own. */ const $f7e13d138e46c528$var$UNREPRESENTABLE_DEFAULT = Symbol();
function $f7e13d138e46c528$var$serializeDefaultValue(value, schema, ctx, json, params) {
    let unrepresentable = false;
    const serialized = JSON.stringify(value, (_, val)=>{
        if (typeof val !== "bigint") return val;
        unrepresentable = true;
        return null;
    });
    if (!unrepresentable) return JSON.parse(serialized);
    (0, $1XUsZ.handleUnrepresentable)(schema, ctx, json, params, "BigInt defaults cannot be represented in JSON Schema");
    return $f7e13d138e46c528$var$UNREPRESENTABLE_DEFAULT;
}
const $f7e13d138e46c528$export$f76e6c36e8fb062b = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    (0, $1XUsZ.processSchema)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
    const value = $f7e13d138e46c528$var$serializeDefaultValue(def.defaultValue, schema, ctx, json, params);
    if (value !== $f7e13d138e46c528$var$UNREPRESENTABLE_DEFAULT) json.default = value;
};
const $f7e13d138e46c528$export$1ded4e432f286ac2 = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    (0, $1XUsZ.processSchema)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
    if (ctx.io !== "input") return;
    const value = $f7e13d138e46c528$var$serializeDefaultValue(def.defaultValue, schema, ctx, json, params);
    if (value !== $f7e13d138e46c528$var$UNREPRESENTABLE_DEFAULT) json._prefault = value;
};
const $f7e13d138e46c528$export$3f81793c903cb504 = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    (0, $1XUsZ.processSchema)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
    let catchValue;
    try {
        catchValue = def.catchValue(undefined);
    } catch  {
        (0, $1XUsZ.handleUnrepresentable)(schema, ctx, json, params, "Dynamic catch values are not supported in JSON Schema");
        return;
    }
    json.default = catchValue;
};
const $f7e13d138e46c528$export$3a3e6911d4012a24 = (schema, ctx, _json, params)=>{
    const def = schema._zod.def;
    const inIsTransform = def.in._zod.traits.has("$ZodTransform");
    const innerType = ctx.io === "input" ? inIsTransform ? def.out : def.in : def.out;
    (0, $1XUsZ.processSchema)(innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = innerType;
};
const $f7e13d138e46c528$export$dd90252c562e1d9 = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    (0, $1XUsZ.processSchema)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
    json.readOnly = true;
};
const $f7e13d138e46c528$export$ecb899a95fe4bdc0 = (schema, ctx, _json, params)=>{
    const def = schema._zod.def;
    (0, $1XUsZ.processSchema)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
};
const $f7e13d138e46c528$export$4b1db46aa3739c48 = (schema, ctx, _json, params)=>{
    const def = schema._zod.def;
    (0, $1XUsZ.processSchema)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
};
const $f7e13d138e46c528$export$9980155f320c317b = (schema, ctx, _json, params)=>{
    const innerType = schema._zod.innerType;
    (0, $1XUsZ.processSchema)(innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = innerType;
};
const $f7e13d138e46c528$export$e462eec3d35f5c06 = {
    string: $f7e13d138e46c528$export$c6950985d9de996d,
    number: $f7e13d138e46c528$export$afd08f475b2e134f,
    boolean: $f7e13d138e46c528$export$f03e9163a5233fc4,
    bigint: $f7e13d138e46c528$export$8810d61ae56edc9c,
    symbol: $f7e13d138e46c528$export$fd2b3c73524160ce,
    null: $f7e13d138e46c528$export$7667b76b86382b1f,
    undefined: $f7e13d138e46c528$export$9838a7ce212344b0,
    void: $f7e13d138e46c528$export$b5910bb267c78233,
    never: $f7e13d138e46c528$export$694b9cd80480ac33,
    any: $f7e13d138e46c528$export$a92de72ffd9087b5,
    unknown: $f7e13d138e46c528$export$4e1fea7b2e7474f,
    date: $f7e13d138e46c528$export$d044e6246fe40d06,
    enum: $f7e13d138e46c528$export$a0f7e3681bbe4f0b,
    literal: $f7e13d138e46c528$export$b7a483a046d3a9b,
    nan: $f7e13d138e46c528$export$f33d8739d51ecc4b,
    template_literal: $f7e13d138e46c528$export$59812826ec9f1850,
    file: $f7e13d138e46c528$export$62de47a40c7b42b0,
    success: $f7e13d138e46c528$export$1e296a49315ba27a,
    custom: $f7e13d138e46c528$export$fe3af043a76e4dab,
    function: $f7e13d138e46c528$export$654f185ba88226ab,
    transform: $f7e13d138e46c528$export$707b17683f9c9ec0,
    map: $f7e13d138e46c528$export$5e912d1710885757,
    set: $f7e13d138e46c528$export$2ff44e7a32269271,
    array: $f7e13d138e46c528$export$afeff382d55f455b,
    object: $f7e13d138e46c528$export$8cc078cf99794668,
    union: $f7e13d138e46c528$export$f387dff1d8008b49,
    intersection: $f7e13d138e46c528$export$2a29f9128b7167c3,
    tuple: $f7e13d138e46c528$export$7767a398545ac85c,
    record: $f7e13d138e46c528$export$6cf7a4b4a95ef1a8,
    nullable: $f7e13d138e46c528$export$452ce6f96b49219a,
    nonoptional: $f7e13d138e46c528$export$7c6ac5b60b42bfc9,
    default: $f7e13d138e46c528$export$f76e6c36e8fb062b,
    prefault: $f7e13d138e46c528$export$1ded4e432f286ac2,
    catch: $f7e13d138e46c528$export$3f81793c903cb504,
    pipe: $f7e13d138e46c528$export$3a3e6911d4012a24,
    readonly: $f7e13d138e46c528$export$dd90252c562e1d9,
    promise: $f7e13d138e46c528$export$ecb899a95fe4bdc0,
    optional: $f7e13d138e46c528$export$4b1db46aa3739c48,
    lazy: $f7e13d138e46c528$export$9980155f320c317b
};
function $f7e13d138e46c528$export$395d8e19463d4f49(input, params) {
    if ("_idmap" in input) {
        // Registry case
        const registry = input;
        const ctx = (0, $1XUsZ.initializeContext)({
            ...params,
            processors: $f7e13d138e46c528$export$e462eec3d35f5c06
        });
        const defs = {};
        // First pass: process all schemas to build the seen map
        for (const entry of registry._idmap.entries()){
            const [_, schema] = entry;
            (0, $1XUsZ.processSchema)(schema, ctx);
        }
        const schemas = {};
        const external = {
            registry: registry,
            uri: params?.uri,
            defs: defs
        };
        // Update the context with external configuration
        ctx.external = external;
        // Second pass: emit each schema
        for (const entry of registry._idmap.entries()){
            const [key, schema] = entry;
            (0, $1XUsZ.extractDefs)(ctx, schema);
            (0, $ciVeX.assignProp)(schemas, key, (0, $1XUsZ.finalize)(ctx, schema));
        }
        if (Object.keys(defs).length > 0) {
            const defsSegment = ctx.target === "draft-2020-12" ? "$defs" : "definitions";
            schemas.__shared = {
                [defsSegment]: defs
            };
        }
        return {
            schemas: schemas
        };
    }
    // Single schema case
    const ctx = (0, $1XUsZ.initializeContext)({
        ...params,
        processors: $f7e13d138e46c528$export$e462eec3d35f5c06
    });
    (0, $1XUsZ.processSchema)(input, ctx);
    (0, $1XUsZ.extractDefs)(ctx, input);
    return (0, $1XUsZ.finalize)(ctx, input);
}

});
parcelRegister("1XUsZ", function(module, exports) {
$parcel$export(module.exports, "initializeContext", () => $16e71a39bb8f69ca$export$881f7fb71351b304);
$parcel$export(module.exports, "handleUnrepresentable", () => $16e71a39bb8f69ca$export$e3c1b0b829661475);
$parcel$export(module.exports, "processSchema", () => $16e71a39bb8f69ca$export$f85120451780a2ef);
$parcel$export(module.exports, "extractDefs", () => $16e71a39bb8f69ca$export$ba2613251eadea93);
$parcel$export(module.exports, "finalize", () => $16e71a39bb8f69ca$export$578723aef62d92f5);
$parcel$export(module.exports, "createStandardJSONSchemaMethod", () => $16e71a39bb8f69ca$export$b29c48d79372468a);
$parcel$export(module.exports, "createToJSONSchemaMethod", () => $16e71a39bb8f69ca$export$d24eb8c1ef5f4df1);

var $5ehZO = parcelRequire("5ehZO");

var $ciVeX = parcelRequire("ciVeX");
function $16e71a39bb8f69ca$var$assignProps(target, ...sources) {
    for (const source of sources){
        for (const key of Reflect.ownKeys(source))if (Object.prototype.propertyIsEnumerable.call(source, key)) (0, $ciVeX.assignProp)(target, key, source[key]);
    }
    return target;
}
function $16e71a39bb8f69ca$export$881f7fb71351b304(params) {
    // Normalize target: convert old non-hyphenated versions to hyphenated versions
    let target = params?.target ?? "draft-2020-12";
    if (target === "draft-4") target = "draft-04";
    if (target === "draft-7") target = "draft-07";
    return {
        processors: params.processors ?? {},
        metadataRegistry: params?.metadata ?? (0, $5ehZO.globalRegistry),
        target: target,
        unrepresentable: params?.unrepresentable ?? "throw",
        override: params?.override ?? (()=>{}),
        io: params?.io ?? "output",
        counter: 0,
        seen: new Map(),
        sharedDefsExtractedFor: undefined,
        sharedEmitDoneFor: undefined,
        cycles: params?.cycles ?? "ref",
        reused: params?.reused ?? "inline",
        intersections: [],
        deferred: [],
        external: params?.external ?? undefined
    };
}
function $16e71a39bb8f69ca$export$e3c1b0b829661475(schema, ctx, json, params, message) {
    const result = typeof ctx.unrepresentable === "function" ? ctx.unrepresentable({
        zodSchema: schema,
        path: params.path,
        message: message
    }) : ctx.unrepresentable;
    if (result === "any") return false;
    if (result === undefined || result === "throw") throw new Error(message);
    Object.assign(json, result);
    return true;
}
function $16e71a39bb8f69ca$export$f85120451780a2ef(schema, ctx, _params = {
    path: [],
    schemaPath: []
}) {
    var _a;
    const def = schema._zod.def;
    // check for schema in seens
    const seen = ctx.seen.get(schema);
    if (seen) {
        seen.count++;
        // check if cycle
        const isCycle = _params.schemaPath.includes(schema);
        if (isCycle) seen.cycle = _params.path;
        return seen.schema;
    }
    // initialize
    const result = {
        schema: {},
        count: 1,
        cycle: undefined,
        path: _params.path
    };
    ctx.seen.set(schema, result);
    ctx.sharedDefsExtractedFor = undefined;
    ctx.sharedEmitDoneFor = undefined;
    // custom method overrides default behavior
    const overrideSchema = schema._zod.toJSONSchema?.();
    if (overrideSchema) result.schema = overrideSchema;
    else {
        const params = {
            ..._params,
            schemaPath: [
                ..._params.schemaPath,
                schema
            ],
            path: _params.path
        };
        if (schema._zod.processJSONSchema) schema._zod.processJSONSchema(ctx, result.schema, params);
        else {
            const _json = result.schema;
            const processor = ctx.processors[def.type];
            if (!processor) throw new Error(`[toJSONSchema]: Non-representable type encountered: ${def.type}`);
            processor(schema, ctx, _json, params);
        }
        const parent = schema._zod.parent;
        if (parent) {
            // Also set ref if processor didn't (for inheritance)
            if (!result.ref) result.ref = parent;
            $16e71a39bb8f69ca$export$f85120451780a2ef(parent, ctx, params);
            ctx.seen.get(parent).isParent = true;
        }
    }
    // metadata
    const meta = ctx.metadataRegistry.get(schema);
    if (meta) $16e71a39bb8f69ca$var$assignProps(result.schema, meta);
    if (ctx.io === "input" && $16e71a39bb8f69ca$var$isTransforming(schema)) {
        // examples/defaults only apply to output type of pipe
        delete result.schema.examples;
        delete result.schema.default;
    }
    // set prefault as default
    if (ctx.io === "input" && "_prefault" in result.schema) (_a = result.schema).default ?? (_a.default = result.schema._prefault);
    delete result.schema._prefault;
    // pulling fresh from ctx.seen in case it was overwritten
    const _result = ctx.seen.get(schema);
    return _result.schema;
}
// Escape a reference token for use in a JSON Pointer fragment (RFC 6901): `~` becomes `~0` and `/` becomes `~1`. The `~` replacement must run first.
function $16e71a39bb8f69ca$var$encodeJSONPointerSegment(segment) {
    return segment.replace(/~/g, "~0").replace(/\//g, "~1");
}
function $16e71a39bb8f69ca$export$ba2613251eadea93(ctx, schema) {
    // iterate over seen map;
    const root = ctx.seen.get(schema);
    if (!root) throw new Error("Unprocessed schema. This is a bug in Zod.");
    // With `external` set, every registered schema resolves through the external branch of `makeURI`, so the root branch below produces the same ref the external branch would — this pass is identical whichever schema it is called with, and only needs to run once.
    if (ctx.external && ctx.sharedDefsExtractedFor === ctx.external) return;
    // Track ids to detect duplicates across different schemas
    const idToSchema = new Map();
    for (const entry of ctx.seen.entries()){
        const id = ctx.metadataRegistry.get(entry[0])?.id;
        if (id) {
            const existing = idToSchema.get(id);
            if (existing && existing !== entry[0]) throw new Error(`Duplicate schema id "${id}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
            idToSchema.set(id, entry[0]);
        }
    }
    // returns a ref to the schema defId will be empty if the ref points to an external schema (or #)
    const makeURI = (entry)=>{
        // comparing the seen objects because sometimes multiple schemas map to the same seen object. e.g. lazy
        // external is configured
        const defsSegment = ctx.target === "draft-2020-12" ? "$defs" : "definitions";
        if (ctx.external) {
            const externalId = ctx.external.registry.get(entry[0])?.id; // ?? "__shared";// `__schema${ctx.counter++}`;
            // check if schema is in the external registry
            const uriGenerator = ctx.external.uri ?? ((id)=>id);
            if (externalId) return {
                ref: uriGenerator(externalId)
            };
            // otherwise, add to __shared
            const id = entry[1].defId ?? entry[1].schema.id ?? `schema${ctx.counter++}`;
            entry[1].defId = id; // set defId so it will be reused if needed
            return {
                defId: id,
                ref: `${uriGenerator("__shared")}#/${defsSegment}/${$16e71a39bb8f69ca$var$encodeJSONPointerSegment(id)}`
            };
        }
        const uriPrefix = `#`;
        const defUriPrefix = `${uriPrefix}/${defsSegment}/`;
        // an id-less root has nowhere to be extracted to, so it stays inline and self-references as `#`
        if (entry[1] === root && !entry[1].schema.id) return {
            ref: uriPrefix
        };
        // self-contained schema
        const defId = entry[1].schema.id ?? `__schema${ctx.counter++}`;
        return {
            defId: defId,
            ref: defUriPrefix + $16e71a39bb8f69ca$var$encodeJSONPointerSegment(defId)
        };
    };
    // stored cached version in `def` property remove all properties, set $ref
    const extractToDef = (entry)=>{
        // if the schema is already a reference, do not extract it
        if (entry[1].schema.$ref) return;
        const seen = entry[1];
        const { ref: ref, defId: defId } = makeURI(entry);
        seen.def = {
            ...seen.schema
        };
        // defId won't be set if the schema is a reference to an external schema or if the schema is the root schema
        if (defId) seen.defId = defId;
        // wipe away all properties except $ref
        const schema = seen.schema;
        for(const key in schema)delete schema[key];
        schema.$ref = ref;
    };
    // throw on cycles
    // break cycles
    if (ctx.cycles === "throw") for (const entry of ctx.seen.entries()){
        const seen = entry[1];
        if (seen.cycle) throw new Error("Cycle detected: " + `#/${seen.cycle?.join("/")}/<root>` + '\n\nSet the `cycles` parameter to `"ref"` to resolve cyclical schemas with defs.');
    }
    // extract schemas into $defs
    for (const entry of ctx.seen.entries()){
        const seen = entry[1];
        // convert root schema to # $ref
        if (schema === entry[0]) {
            extractToDef(entry); // this has special handling for the root schema
            continue;
        }
        // extract schemas that are in the external registry
        if (ctx.external) {
            const ext = ctx.external.registry.get(entry[0])?.id;
            if (schema !== entry[0] && ext) {
                extractToDef(entry);
                continue;
            }
        }
        // extract schemas with `id` meta
        const id = ctx.metadataRegistry.get(entry[0])?.id;
        if (id) {
            extractToDef(entry);
            continue;
        }
        // break cycles
        if (seen.cycle) {
            // any
            extractToDef(entry);
            continue;
        }
        // extract reused schemas
        if (seen.count > 1) {
            if (ctx.reused === "ref") extractToDef(entry);
        }
    }
    if (ctx.external) ctx.sharedDefsExtractedFor = ctx.external;
}
/** Rewrites `anyOf: [{type: "a"}, {type: "b"}]` to `type: ["a", "b"]`, which every JSON Schema draft treats as equivalent and most consumers render far better for the nullable case. Only branches that are a bare type assertion qualify — anything carrying a constraint, `$ref`, `const` or metadata is left alone. Runs after `flattenRef`, so a branch an override decorated or `$defs` extraction turned into a `$ref` is no longer bare and correctly stays in `anyOf`. `oneOf` is excluded: `integer` and `number` overlap, so "exactly one" and "at least one" are not the same there. OpenAPI 3.0 is excluded: its `type` must be a single string. */ function $16e71a39bb8f69ca$var$compactTypeUnion(schema) {
    const options = schema.anyOf;
    if (!Array.isArray(options) || options.length === 0 || schema.type !== undefined) return;
    const types = [];
    for (const option of options){
        if (!option || typeof option !== "object") return;
        // A branch that is itself a compactible union folds into this one — nested `anyOf` and a flat `type` array say the same thing. Compacting it first also makes the result independent of the order this pass walks the seen map in.
        $16e71a39bb8f69ca$var$compactTypeUnion(option);
        const keys = Object.keys(option);
        if (keys.length !== 1 || keys[0] !== "type") return;
        const type = option.type;
        for (const member of Array.isArray(type) ? type : [
            type
        ]){
            if (typeof member !== "string") return;
            if (!types.includes(member)) types.push(member);
        }
    }
    delete schema.anyOf;
    // A `type` array must be non-empty and unique (metaschema); a single member is spelled as a bare string.
    schema.type = types.length === 1 ? types[0] : types;
}
/** Keywords `foldIntersection` knows how to combine. Anything else — `$ref`, `patternProperties`,
 * an annotation like `description` — makes a member unfoldable, so a constraint this does not
 * understand leaves the `allOf` alone instead of being silently dropped or misattributed. */ const $16e71a39bb8f69ca$var$FOLDABLE_KEYS = new Set([
    "type",
    "properties",
    "required",
    "additionalProperties"
]);
const $16e71a39bb8f69ca$var$UNION_KEYS = [
    "oneOf",
    "anyOf"
];
/** A member's constraint on a key it does not declare itself. A `catchall` states one; `false`, an absent `additionalProperties`, and the empty schema a loose object emits state nothing. */ function $16e71a39bb8f69ca$var$undeclaredConstraint(member) {
    const extra = member.additionalProperties;
    if (extra === undefined || extra === false || typeof extra !== "object" || extra === null) return null;
    return Object.keys(extra).length ? extra : null;
}
/** Combines object members into the single object they describe together, or returns `null` if any of them carries a keyword outside {@link FOLDABLE_KEYS}. */ function $16e71a39bb8f69ca$var$foldObjects(members) {
    const objects = [];
    for (const member of members){
        // A boolean subschema is legal JSON Schema and carries no keywords to fold.
        if (typeof member !== "object" || member.type !== "object") return null;
        for(const key in member){
            if (!$16e71a39bb8f69ca$var$FOLDABLE_KEYS.has(key)) return null;
        }
        objects.push(member);
    }
    const properties = {};
    const required = new Set();
    for (const object of objects){
        for(const key in object.properties){
            // `in` would report a `__proto__` key as already present via the prototype chain and skip it.
            if (Object.prototype.hasOwnProperty.call(properties, key)) continue;
            // Every member constrains this key: the ones that declare it say how, and a `catchall` member constrains it too even though it does not name it. The key has to satisfy all of them, which is the same intersection one level down.
            const parts = [];
            for (const other of objects){
                const part = other.properties?.[key] ?? $16e71a39bb8f69ca$var$undeclaredConstraint(other);
                if (part === null || part === undefined) continue;
                if (!parts.some((seen)=>JSON.stringify(seen) === JSON.stringify(part))) parts.push(part);
            }
            const merged = parts.length === 1 ? parts[0] : $16e71a39bb8f69ca$var$foldObjects(parts) ?? {
                allOf: parts
            };
            (0, $ciVeX.assignProp)(properties, key, merged);
        }
        for (const key of object.required ?? [])required.add(key);
    }
    const folded = {
        type: "object",
        properties: properties
    };
    if (required.size) folded.required = [
        ...required
    ];
    // A key no member declares is rejected only when every member rejects it, so the fold is closed only when every member is. Otherwise it carries whatever the `catchall` members demand of such a key.
    if (objects.every((object)=>object.additionalProperties === false)) folded.additionalProperties = false;
    else {
        const constraints = [];
        for (const object of objects){
            const constraint = $16e71a39bb8f69ca$var$undeclaredConstraint(object);
            if (constraint && !constraints.some((seen)=>JSON.stringify(seen) === JSON.stringify(constraint))) constraints.push(constraint);
        }
        if (constraints.length === 1) folded.additionalProperties = constraints[0];
        else if (constraints.length > 1) folded.additionalProperties = {
            allOf: constraints
        };
    }
    return folded;
}
/** `additionalProperties` in an `allOf` member sees only that member's own `properties`, so two
 * closed object members reject each other's keys and the schema validates nothing. Zod's parser
 * pools the key sets instead — `handleIntersectionResults` reports a key as unrecognized only when
 * *every* side rejects it — so the emitted schema has to pool them too, and folding the members
 * into one object is the encoding that says so on every target.
 *
 * This runs from `finalize`, after `extractDefs`, which is what keeps it clear of the `$ref`
 * machinery: a member extracted into `$defs` is already a `$ref` by now and declines to fold, so it
 * keeps its reference and its own closedness rather than being inlined as a stale copy. */ function $16e71a39bb8f69ca$var$foldIntersection(json) {
    const allOf = json.allOf;
    if (!Array.isArray(allOf) || allOf.length < 2) return;
    // An `override` runs before this pass and may have written object keywords onto the intersection itself. Those are deliberate, so decline rather than overwrite them.
    for (const key of $16e71a39bb8f69ca$var$FOLDABLE_KEYS)if (key in json) return;
    // An intersection distributes over a union: `A & (X | Y)` is `(A & X) | (A & Y)`. Only the first union is distributed over; a second one stays among the members every branch folds against, where it fails the object check and declines the whole intersection rather than multiplying out.
    const unions = allOf.filter((m)=>$16e71a39bb8f69ca$var$UNION_KEYS.some((k)=>Array.isArray(m[k])));
    let folded = null;
    if (!unions.length) folded = $16e71a39bb8f69ca$var$foldObjects(allOf);
    else {
        const union = unions[0];
        const keyword = $16e71a39bb8f69ca$var$UNION_KEYS.find((k)=>Array.isArray(union[k]));
        if (Object.keys(union).length !== 1) return;
        const rest = allOf.filter((m)=>m !== union);
        const branches = union[keyword].map((branch)=>$16e71a39bb8f69ca$var$foldObjects([
                ...rest,
                branch
            ]));
        if (branches.some((b)=>!b)) return;
        folded = {
            [keyword]: branches
        };
    }
    if (!folded) return;
    delete json.allOf;
    $16e71a39bb8f69ca$var$assignProps(json, folded);
}
function $16e71a39bb8f69ca$export$578723aef62d92f5(ctx, schema) {
    const root = ctx.seen.get(schema);
    if (!root) throw new Error("Unprocessed schema. This is a bug in Zod.");
    // flatten refs - inherit properties from parent schemas
    const flattenRef = (zodSchema)=>{
        const seen = ctx.seen.get(zodSchema);
        // already processed
        if (seen.ref === null) return;
        const schema = seen.def ?? seen.schema;
        const _cached = {
            ...schema
        };
        const ref = seen.ref;
        seen.ref = null; // prevent infinite recursion
        if (ref) {
            flattenRef(ref);
            const refSeen = ctx.seen.get(ref);
            const refSchema = refSeen.schema;
            // merge referenced schema into current
            if (refSchema.$ref && (ctx.target === "draft-07" || ctx.target === "draft-04" || ctx.target === "openapi-3.0")) {
                // older drafts can't combine $ref with other properties
                schema.allOf = schema.allOf ?? [];
                schema.allOf.push(refSchema);
            } else $16e71a39bb8f69ca$var$assignProps(schema, refSchema);
            // restore child's own properties (child wins)
            $16e71a39bb8f69ca$var$assignProps(schema, _cached);
            const isParentRef = zodSchema._zod.parent === ref;
            // For parent chain, child is a refinement - remove parent-only properties
            if (isParentRef) for(const key in schema){
                if (key === "$ref" || key === "allOf") continue;
                if (!(key in _cached)) delete schema[key];
            }
            // When ref was extracted to $defs, remove properties that match the definition
            if (refSchema.$ref && refSeen.def) for(const key in schema){
                if (key === "$ref" || key === "allOf") continue;
                if (key in refSeen.def && JSON.stringify(schema[key]) === JSON.stringify(refSeen.def[key])) delete schema[key];
            }
        }
        // If parent was extracted (has $ref), propagate $ref to this schema. This handles cases like: readonly().meta({id}).describe() where processor sets ref to innerType but parent should be referenced
        const parent = zodSchema._zod.parent;
        if (parent && parent !== ref) {
            // Ensure parent is processed first so its def has inherited properties
            flattenRef(parent);
            const parentSeen = ctx.seen.get(parent);
            if (parentSeen?.schema.$ref) {
                schema.$ref = parentSeen.schema.$ref;
                // De-duplicate with parent's definition
                if (parentSeen.def) for(const key in schema){
                    if (key === "$ref" || key === "allOf") continue;
                    if (key in parentSeen.def && JSON.stringify(schema[key]) === JSON.stringify(parentSeen.def[key])) delete schema[key];
                }
            }
        }
        // execute overrides
        ctx.override({
            zodSchema: zodSchema,
            jsonSchema: schema,
            path: seen.path ?? []
        });
    };
    // Flattening walks the whole map and clears each `ref` as it goes, so a second call over the same map is a no-op scan. Skip it outright once it has run for a registry conversion.
    if (!ctx.external || ctx.sharedEmitDoneFor !== ctx.external) {
        for (const entry of [
            ...ctx.seen.entries()
        ].reverse())flattenRef(entry[0]);
        if (ctx.target !== "openapi-3.0") for (const entry of ctx.seen.entries())$16e71a39bb8f69ca$var$compactTypeUnion(entry[1].def ?? entry[1].schema);
        for (const rewrite of ctx.deferred)rewrite();
        // After flattening, every member that was extracted is a `$ref`, so the fold sees the final shape. A schema that inherits an intersection — through `z.lazy`, or any `ref` chain — holds the same `allOf` array, so fold by array identity to catch every copy.
        if (ctx.intersections.length) {
            const carriers = new Map();
            for (const seen of ctx.seen.values())for (const json of [
                seen.schema,
                seen.def
            ]){
                const allOf = json?.allOf;
                if (!Array.isArray(allOf)) continue;
                const existing = carriers.get(allOf);
                if (existing) existing.push(json);
                else carriers.set(allOf, [
                    json
                ]);
            }
            for (const allOf of ctx.intersections)for (const json of carriers.get(allOf) ?? [])$16e71a39bb8f69ca$var$foldIntersection(json);
        }
    }
    const result = {};
    if (ctx.target === "draft-2020-12") result.$schema = "https://json-schema.org/draft/2020-12/schema";
    else if (ctx.target === "draft-07") result.$schema = "http://json-schema.org/draft-07/schema#";
    else if (ctx.target === "draft-04") result.$schema = "http://json-schema.org/draft-04/schema#";
    else ctx.target;
    if (ctx.external?.uri) {
        const id = ctx.external.registry.get(schema)?.id;
        if (!id) throw new Error("Schema is missing an `id` property");
        result.$id = ctx.external.uri(id);
    }
    // when the root was extracted into $defs, `root.schema` is the `$ref` wrapper and `root.def` is the body that now lives under $defs
    $16e71a39bb8f69ca$var$assignProps(result, root.defId ? root.schema : root.def ?? root.schema);
    // The `id` in `.meta()` is a Zod-specific registration tag used to extract schemas into $defs — it is not user-facing JSON Schema metadata. Strip it from the output body where it would otherwise leak. The id is preserved implicitly via the $defs key (and via $ref paths).
    const rootMetaId = ctx.metadataRegistry.get(schema)?.id;
    if (rootMetaId !== undefined && result.id === rootMetaId) delete result.id;
    // build defs object. With `external`, `defs` is the shared object every schema writes into, so the same entries are reassigned on every call. Without it, `defs` is fresh per call and must be rebuilt.
    const defs = ctx.external?.defs ?? {};
    if (!ctx.external || ctx.sharedEmitDoneFor !== ctx.external) for (const entry of ctx.seen.entries()){
        const seen = entry[1];
        if (seen.def && seen.defId) {
            if (seen.def.id === seen.defId) delete seen.def.id;
            (0, $ciVeX.assignProp)(defs, seen.defId, seen.def);
        }
    }
    if (ctx.external) ctx.sharedEmitDoneFor = ctx.external;
    // set definitions in result
    if (ctx.external) ;
    else if (Object.keys(defs).length > 0) {
        if (ctx.target === "draft-2020-12") result.$defs = defs;
        else result.definitions = defs;
    }
    try {
        // this "finalizes" this schema and ensures all cycles are removed each call to finalize() is functionally independent though the seen map is shared
        const finalized = JSON.parse(JSON.stringify(result));
        Object.defineProperty(finalized, "~standard", {
            value: {
                ...schema["~standard"],
                jsonSchema: {
                    input: $16e71a39bb8f69ca$export$b29c48d79372468a(schema, "input", ctx.processors),
                    output: $16e71a39bb8f69ca$export$b29c48d79372468a(schema, "output", ctx.processors)
                }
            },
            enumerable: false,
            writable: false
        });
        return finalized;
    } catch (_err) {
        throw new Error("Error converting schema to JSON.");
    }
}
function $16e71a39bb8f69ca$var$isTransforming(_schema, _ctx) {
    const ctx = _ctx ?? {
        seen: new Set()
    };
    if (ctx.seen.has(_schema)) return false;
    ctx.seen.add(_schema);
    const def = _schema._zod.def;
    if (def.type === "transform") return true;
    if (def.type === "array") return $16e71a39bb8f69ca$var$isTransforming(def.element, ctx);
    if (def.type === "set") return $16e71a39bb8f69ca$var$isTransforming(def.valueType, ctx);
    if (def.type === "lazy") return $16e71a39bb8f69ca$var$isTransforming(def.getter(), ctx);
    if (def.type === "promise" || def.type === "optional" || def.type === "nonoptional" || def.type === "nullable" || def.type === "readonly" || def.type === "default" || def.type === "prefault" || def.type === "catch") return $16e71a39bb8f69ca$var$isTransforming(def.innerType, ctx);
    if (def.type === "intersection") return $16e71a39bb8f69ca$var$isTransforming(def.left, ctx) || $16e71a39bb8f69ca$var$isTransforming(def.right, ctx);
    if (def.type === "record" || def.type === "map") return $16e71a39bb8f69ca$var$isTransforming(def.keyType, ctx) || $16e71a39bb8f69ca$var$isTransforming(def.valueType, ctx);
    if (def.type === "pipe") {
        if (_schema._zod.traits.has("$ZodCodec")) return true;
        return $16e71a39bb8f69ca$var$isTransforming(def.in, ctx) || $16e71a39bb8f69ca$var$isTransforming(def.out, ctx);
    }
    if (def.type === "object") {
        for(const key in def.shape){
            if ($16e71a39bb8f69ca$var$isTransforming(def.shape[key], ctx)) return true;
        }
        return false;
    }
    if (def.type === "union") {
        for (const option of def.options){
            if ($16e71a39bb8f69ca$var$isTransforming(option, ctx)) return true;
        }
        return false;
    }
    if (def.type === "tuple") {
        for (const item of def.items){
            if ($16e71a39bb8f69ca$var$isTransforming(item, ctx)) return true;
        }
        if (def.rest && $16e71a39bb8f69ca$var$isTransforming(def.rest, ctx)) return true;
        return false;
    }
    return false;
}
const $16e71a39bb8f69ca$export$d24eb8c1ef5f4df1 = (schema, processors = {})=>(params)=>{
        const ctx = $16e71a39bb8f69ca$export$881f7fb71351b304({
            ...params,
            processors: processors
        });
        $16e71a39bb8f69ca$export$f85120451780a2ef(schema, ctx);
        $16e71a39bb8f69ca$export$ba2613251eadea93(ctx, schema);
        return $16e71a39bb8f69ca$export$578723aef62d92f5(ctx, schema);
    };
const $16e71a39bb8f69ca$export$b29c48d79372468a = (schema, io, processors = {})=>(params)=>{
        const { libraryOptions: libraryOptions, target: target } = params ?? {};
        const ctx = $16e71a39bb8f69ca$export$881f7fb71351b304({
            ...libraryOptions ?? {},
            target: target,
            io: io,
            processors: processors
        });
        $16e71a39bb8f69ca$export$f85120451780a2ef(schema, ctx);
        $16e71a39bb8f69ca$export$ba2613251eadea93(ctx, schema);
        return $16e71a39bb8f69ca$export$578723aef62d92f5(ctx, schema);
    };

});


parcelRegister("3OUUC", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c82302aae7b6758$export$2e2bcd8739ae039);

var $ciVeX = parcelRequire("ciVeX");
const $2c82302aae7b6758$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "characters",
            verb: "to have"
        },
        file: {
            unit: "bytes",
            verb: "to have"
        },
        array: {
            unit: "items",
            verb: "to have"
        },
        set: {
            unit: "items",
            verb: "to have"
        },
        map: {
            unit: "entries",
            verb: "to have"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "input",
        email: "email address",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datetime",
        date: "ISO date",
        time: "ISO time",
        duration: "ISO duration",
        ipv4: "IPv4 address",
        ipv6: "IPv6 address",
        mac: "MAC address",
        cidrv4: "IPv4 range",
        cidrv6: "IPv6 range",
        base64: "base64-encoded string",
        base64url: "base64url-encoded string",
        json_string: "JSON string",
        e164: "E.164 number",
        currency_code: "currency code",
        credit_card: "credit card number",
        iban: "IBAN",
        jwt: "JWT",
        template_literal: "input"
    };
    // type names: missing keys = do not translate (use raw value via ?? fallback)
    const TypeDictionary = {
        // Compatibility: "nan" -> "NaN" for display
        nan: "NaN"
    };
    function getTypeName(type, input) {
        if (type === "number" && typeof input === "number" && !Number.isFinite(input)) return String(input);
        return TypeDictionary[type] ?? type;
    }
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = getTypeName(issue.expected);
                    const receivedType = $ciVeX.parsedType(issue.input);
                    const received = getTypeName(receivedType, issue.input);
                    return `Invalid input: expected ${expected}, received ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Invalid input: expected ${$ciVeX.stringifyPrimitive(issue.values[0])}`;
                return `Invalid option: expected one of ${$ciVeX.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.exact ? "exactly " : issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Too big: expected ${issue.origin ?? "value"} to have ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elements"}`;
                    return `Too big: expected ${issue.origin ?? "value"} to be ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.exact ? "exactly " : issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Too small: expected ${issue.origin} to have ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Too small: expected ${issue.origin} to be ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Invalid string: must start with "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Invalid string: must end with "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Invalid string: must include "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Invalid string: must match pattern ${_issue.pattern}`;
                    return `Invalid ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Invalid number: must be a multiple of ${issue.divisor}`;
            case "unrecognized_keys":
                return `Unrecognized key${issue.keys.length > 1 ? "s" : ""}: ${$ciVeX.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `Invalid key in ${issue.origin}`;
            case "invalid_union":
                if (issue.options && Array.isArray(issue.options) && issue.options.length > 0) {
                    const opts = issue.options.map((o)=>`'${o}'`).join(" | ");
                    return `Invalid discriminator value. Expected ${opts}`;
                }
                if (issue.inclusive === false) return "Invalid input: more than one option matched";
                return "Invalid input";
            case "invalid_element":
                return `Invalid value in ${issue.origin}`;
            default:
                return `Invalid input`;
        }
    };
};
function $2c82302aae7b6758$export$2e2bcd8739ae039() {
    return {
        localeError: $2c82302aae7b6758$var$error()
    };
}

});

parcelRegister("kUTFh", function(module, exports) {
$parcel$export(module.exports, "parse", () => $f3a43778cf11e5e5$export$98e6a39c04603d36);
$parcel$export(module.exports, "parseAsync", () => $f3a43778cf11e5e5$export$59b6f938fbf579e3);
$parcel$export(module.exports, "safeParse", () => $f3a43778cf11e5e5$export$b48ee232557adc37);
$parcel$export(module.exports, "safeParseAsync", () => $f3a43778cf11e5e5$export$9b07b0d6e0389261);
$parcel$export(module.exports, "encode", () => $f3a43778cf11e5e5$export$c564cdbbe6da493);
$parcel$export(module.exports, "decode", () => $f3a43778cf11e5e5$export$2f872c0f2117be69);
$parcel$export(module.exports, "encodeAsync", () => $f3a43778cf11e5e5$export$1a62660bbffb8f11);
$parcel$export(module.exports, "decodeAsync", () => $f3a43778cf11e5e5$export$e4c183687a6ff9b);
$parcel$export(module.exports, "safeEncode", () => $f3a43778cf11e5e5$export$c094f85f253e4d7d);
$parcel$export(module.exports, "safeDecode", () => $f3a43778cf11e5e5$export$7a47376c130cfeac);
$parcel$export(module.exports, "safeEncodeAsync", () => $f3a43778cf11e5e5$export$ed163a34170fecc5);
$parcel$export(module.exports, "safeDecodeAsync", () => $f3a43778cf11e5e5$export$9f879005292a9bc9);

var $8K3FB = parcelRequire("8K3FB");

var $ccdOF = parcelRequire("ccdOF");
const $f3a43778cf11e5e5$export$98e6a39c04603d36 = /* @__PURE__ */ $8K3FB._parse((0, $ccdOF.ZodRealError));
const $f3a43778cf11e5e5$export$59b6f938fbf579e3 = /* @__PURE__ */ $8K3FB._parseAsync((0, $ccdOF.ZodRealError));
const $f3a43778cf11e5e5$export$b48ee232557adc37 = /* @__PURE__ */ $8K3FB._safeParse((0, $ccdOF.ZodRealError));
const $f3a43778cf11e5e5$export$9b07b0d6e0389261 = /* @__PURE__ */ $8K3FB._safeParseAsync((0, $ccdOF.ZodRealError));
const $f3a43778cf11e5e5$export$c564cdbbe6da493 = /* @__PURE__ */ $8K3FB._encode((0, $ccdOF.ZodRealError));
const $f3a43778cf11e5e5$export$2f872c0f2117be69 = /* @__PURE__ */ $8K3FB._decode((0, $ccdOF.ZodRealError));
const $f3a43778cf11e5e5$export$1a62660bbffb8f11 = /* @__PURE__ */ $8K3FB._encodeAsync((0, $ccdOF.ZodRealError));
const $f3a43778cf11e5e5$export$e4c183687a6ff9b = /* @__PURE__ */ $8K3FB._decodeAsync((0, $ccdOF.ZodRealError));
const $f3a43778cf11e5e5$export$c094f85f253e4d7d = /* @__PURE__ */ $8K3FB._safeEncode((0, $ccdOF.ZodRealError));
const $f3a43778cf11e5e5$export$7a47376c130cfeac = /* @__PURE__ */ $8K3FB._safeDecode((0, $ccdOF.ZodRealError));
const $f3a43778cf11e5e5$export$ed163a34170fecc5 = /* @__PURE__ */ $8K3FB._safeEncodeAsync((0, $ccdOF.ZodRealError));
const $f3a43778cf11e5e5$export$9f879005292a9bc9 = /* @__PURE__ */ $8K3FB._safeDecodeAsync((0, $ccdOF.ZodRealError));

});
parcelRegister("ccdOF", function(module, exports) {
$parcel$export(module.exports, "ZodRealError", () => $8e1152a3310e250e$export$42f76a3b4eb5449a);

var $igTWG = parcelRequire("igTWG");
var $hQwmQ = parcelRequire("hQwmQ");

var $ciVeX = parcelRequire("ciVeX");
/* Prototypes that already carry the lazy helper methods. Seeded with the
 * intrinsics so that `init` on a foreign object — it accepts any object —
 * can never install an accessor onto a prototype we do not own. */ const $8e1152a3310e250e$var$_installedErrorProtos = /* @__PURE__ */ new WeakSet([
    Object.prototype,
    Error.prototype
]);
/* Helper methods live as non-enumerable lazy getters on the shared
 * prototype instead of own properties on every instance. On first
 * access the getter allocates the per-instance closure and caches it
 * as a non-enumerable own property, so detached usage still works and
 * the allocation only happens for methods actually touched. */ function $8e1152a3310e250e$var$_lazyMethod(proto, key, make) {
    Object.defineProperty(proto, key, {
        configurable: true,
        enumerable: false,
        get () {
            const value = make(this);
            Object.defineProperty(this, key, {
                value: value,
                configurable: true,
                writable: true
            });
            return value;
        },
        set (value) {
            Object.defineProperty(this, key, {
                value: value,
                configurable: true,
                writable: true
            });
        }
    });
}
const $8e1152a3310e250e$var$initializer = (inst, issues)=>{
    (0, $hQwmQ.$ZodError).init(inst, issues);
    inst.name = "ZodError";
    const proto = Object.getPrototypeOf(inst);
    if ($8e1152a3310e250e$var$_installedErrorProtos.has(proto)) return;
    $8e1152a3310e250e$var$_installedErrorProtos.add(proto);
    $8e1152a3310e250e$var$_lazyMethod(proto, "format", (self)=>(mapper)=>$hQwmQ.formatError(self, mapper));
    $8e1152a3310e250e$var$_lazyMethod(proto, "flatten", (self)=>(mapper)=>$hQwmQ.flattenError(self, mapper));
    $8e1152a3310e250e$var$_lazyMethod(proto, "addIssue", (self)=>(issue)=>{
            self.issues.push(issue);
            self.message = JSON.stringify(self.issues, $ciVeX.jsonStringifyReplacer, 2);
        });
    $8e1152a3310e250e$var$_lazyMethod(proto, "addIssues", (self)=>(issues)=>{
            self.issues.push(...issues);
            self.message = JSON.stringify(self.issues, $ciVeX.jsonStringifyReplacer, 2);
        });
    Object.defineProperty(proto, "isEmpty", {
        configurable: true,
        enumerable: false,
        get () {
            return this.issues.length === 0;
        }
    });
};
const $8e1152a3310e250e$export$f98dac4b251ab333 = /*@__PURE__*/ $igTWG.$constructor("ZodError", $8e1152a3310e250e$var$initializer);
const $8e1152a3310e250e$export$42f76a3b4eb5449a = /*@__PURE__*/ $igTWG.$constructor("ZodError", $8e1152a3310e250e$var$initializer, undefined, {
    Parent: Error
}); // /** @deprecated Use `z.core.$ZodErrorMapCtx` instead. */
 // export type ErrorMapCtx = core.$ZodErrorMapCtx;

});



parcelRegister("k7fIB", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea50a775eb92d9fc$export$2e2bcd8739ae039);

var $4NT9w = parcelRequire("4NT9w");
var $ea50a775eb92d9fc$export$2e2bcd8739ae039 = (0, $4NT9w.default);

});
parcelRegister("4NT9w", function(module, exports) {
$parcel$export(module.exports, "default", () => $37f6852fd30fbfb0$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $DtLwq = parcelRequire("DtLwq");

var $bLIMX = parcelRequire("bLIMX");

var $gITbN = parcelRequire("gITbN");

var $ivsB7 = parcelRequire("ivsB7");
var $37f6852fd30fbfb0$var$useLayoutEffectSAFE = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * Custom hook to track changes to the interaction ID.
 * Uses a subscription system to automatically update when the interaction ID changes.
 */ function $37f6852fd30fbfb0$var$useInteractionIdValue() {
    var interactionId = (0, $5FkrB.useContext)((0, $gITbN.default));
    var _useState = (0, $5FkrB.useState)((interactionId === null || interactionId === void 0 ? void 0 : interactionId.current) || null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), currentId = _useState2[0], setCurrentId = _useState2[1];
    $37f6852fd30fbfb0$var$useLayoutEffectSAFE(function() {
        setCurrentId((interactionId === null || interactionId === void 0 ? void 0 : interactionId.current) || null);
        var unsubscribe = (0, $ivsB7.subscribeToInteractionIdChanges)(function(newId) {
            setCurrentId(newId);
        });
        return unsubscribe;
    }, [
        interactionId
    ]);
    return currentId;
}
function $37f6852fd30fbfb0$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, name = _ref.name, _ref$hold = _ref.hold, hold = _ref$hold === void 0 ? true : _ref$hold;
    // Check if UFO is enabled
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    var ufoEnabled = (0, $DtLwq.isUFOEnabled)();
    var currentInteractionId = $37f6852fd30fbfb0$var$useInteractionIdValue();
    // react-18: useId instead
    var context = (0, $5FkrB.useContext)((0, $bLIMX.default));
    $37f6852fd30fbfb0$var$useLayoutEffectSAFE(function() {
        // Skip hold registration if UFO is disabled
        if (!ufoEnabled) return;
        if (hold && context != null) return context.hold(name);
    }, [
        hold,
        context,
        name,
        currentInteractionId,
        ufoEnabled
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children) : null;
}

});
parcelRegister("DtLwq", function(module, exports) {
$parcel$export(module.exports, "isFedrampOverrideActive", () => $076abb7020acfb8b$export$1133b5e2873baa7a);
$parcel$export(module.exports, "DEFAULT_TTVC_REVISION", () => $076abb7020acfb8b$export$f9bb3bb330fb9609);
$parcel$export(module.exports, "setUFOConfig", () => $076abb7020acfb8b$export$10d6139a8fb42158);
$parcel$export(module.exports, "getConfig", () => $076abb7020acfb8b$export$44487a86467333c3);
$parcel$export(module.exports, "getSelectorConfig", () => $076abb7020acfb8b$export$59e1f072477dfb48);
$parcel$export(module.exports, "isUFOEnabled", () => $076abb7020acfb8b$export$74bdb753f1cf4860);
$parcel$export(module.exports, "isVCRevisionEnabled", () => $076abb7020acfb8b$export$4babcefc81a3ef0b);
$parcel$export(module.exports, "getMostRecentVCRevision", () => $076abb7020acfb8b$export$70184d6e2c753893);
$parcel$export(module.exports, "getReactHydrationStats", () => $076abb7020acfb8b$export$2d8f8d64dc343d7b);
$parcel$export(module.exports, "getInteractionRate", () => $076abb7020acfb8b$export$9466a8f085fa7d4e);
$parcel$export(module.exports, "shouldUseRawDataThirdPartyBehavior", () => $076abb7020acfb8b$export$9c69f5a724f05f38);
$parcel$export(module.exports, "getPostInteractionRate", () => $076abb7020acfb8b$export$1d459f020c06ae34);
$parcel$export(module.exports, "getCapabilityRate", () => $076abb7020acfb8b$export$29b9ffb14861a1d);
$parcel$export(module.exports, "getAwaitBM3TTIList", () => $076abb7020acfb8b$export$2d311b3fd18dcab1);
$parcel$export(module.exports, "getUfoNameOverrides", () => $076abb7020acfb8b$export$4f4649ef27b6f5d6);
$parcel$export(module.exports, "getMinorInteractions", () => $076abb7020acfb8b$export$b150ddad71c80d77);
$parcel$export(module.exports, "getDoNotAbortActivePressInteraction", () => $076abb7020acfb8b$export$3c170167645a0eff);
$parcel$export(module.exports, "getDoNotAbortActivePressInteractionOnTransition", () => $076abb7020acfb8b$export$d6dc9444bd15f70f);
$parcel$export(module.exports, "getFinishInteractionOnTransition", () => $076abb7020acfb8b$export$20e8108b8ccdd0bd);
$parcel$export(module.exports, "getInteractionTimeout", () => $076abb7020acfb8b$export$c681731847989445);

var $25nEq = parcelRequire("25nEq");

var $fC8ib = parcelRequire("fC8ib");

var $ekGgq = parcelRequire("ekGgq");

var $eSdwu = parcelRequire("eSdwu");

var $50U6m = parcelRequire("50U6m");
function $076abb7020acfb8b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $076abb7020acfb8b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $076abb7020acfb8b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $076abb7020acfb8b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $076abb7020acfb8b$var$config;
/**
 * Cached result of `isFedrampModerate()` so we don't re-parse cookies on
 * every selector lookup. Reset via `__resetFedrampOverrideCacheForTests` in
 * unit tests only.
 */ var $076abb7020acfb8b$var$cachedIsFedrampModerate;
function $076abb7020acfb8b$var$detectIsFedrampModerate() {
    if ($076abb7020acfb8b$var$cachedIsFedrampModerate !== undefined) return $076abb7020acfb8b$var$cachedIsFedrampModerate;
    try {
        $076abb7020acfb8b$var$cachedIsFedrampModerate = (0, $eSdwu.isFedrampModerate)();
    } catch (_unused) {
        // Defensive default: if perimeter detection throws, treat as non-FedRAMP
        // so UFO behaviour is unchanged. Mirrors `analyticsWebClient` pattern.
        $076abb7020acfb8b$var$cachedIsFedrampModerate = false;
    }
    return $076abb7020acfb8b$var$cachedIsFedrampModerate;
}
function $076abb7020acfb8b$export$89dc2b6be8cc261() {
    $076abb7020acfb8b$var$cachedIsFedrampModerate = undefined;
}
function $076abb7020acfb8b$export$1133b5e2873baa7a() {
    try {
        return $076abb7020acfb8b$var$detectIsFedrampModerate();
    } catch (_unused2) {
        return false;
    }
}
var $076abb7020acfb8b$var$FEDRAMP_DISABLED_SELECTOR_CONFIG = Object.freeze({
    id: false,
    testId: false,
    role: false,
    className: false,
    dataVC: false
});
var $076abb7020acfb8b$export$f9bb3bb330fb9609 = 'fy26.04';
function $076abb7020acfb8b$export$2182e73d31080cbc() {
    return $076abb7020acfb8b$export$f9bb3bb330fb9609;
}
var $076abb7020acfb8b$export$d50dacda7fe6392b = 1000;
function $076abb7020acfb8b$export$10d6139a8fb42158(newConfig) {
    var _newConfig$vc;
    // Handle edge cases with `enabledVCRevisions`
    var _ref = (_newConfig$vc = newConfig === null || newConfig === void 0 ? void 0 : newConfig.vc) !== null && _newConfig$vc !== void 0 ? _newConfig$vc : {}, enabledVCRevisions = _ref.enabledVCRevisions;
    if (enabledVCRevisions) {
        var _enabledVCRevisions$a;
        var byExperience = (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.byExperience) === 'object' ? enabledVCRevisions.byExperience : {};
        var allRevisions = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((_enabledVCRevisions$a = enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.all) !== null && _enabledVCRevisions$a !== void 0 ? _enabledVCRevisions$a : []), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Object.values(byExperience).flat()));
        $076abb7020acfb8b$var$config = $076abb7020acfb8b$var$_objectSpread($076abb7020acfb8b$var$_objectSpread({}, newConfig), {}, {
            vc: $076abb7020acfb8b$var$_objectSpread($076abb7020acfb8b$var$_objectSpread({}, newConfig.vc), {}, {
                enabledVCRevisions: {
                    all: Array.from(new Set(allRevisions)),
                    byExperience: byExperience
                }
            })
        });
    } else $076abb7020acfb8b$var$config = newConfig;
}
function $076abb7020acfb8b$export$44487a86467333c3() {
    return $076abb7020acfb8b$var$config;
}
function $076abb7020acfb8b$export$59e1f072477dfb48(callerOverride, defaultConfig) {
    var _ref2, _config;
    // 1. FedRAMP override always wins.
    if ($076abb7020acfb8b$var$detectIsFedrampModerate()) return $076abb7020acfb8b$var$FEDRAMP_DISABLED_SELECTOR_CONFIG;
    // 2. Then caller-provided.
    // 3. Then centrally configured.
    // 4. Then caller-provided default.
    return (_ref2 = callerOverride !== null && callerOverride !== void 0 ? callerOverride : (_config = $076abb7020acfb8b$var$config) === null || _config === void 0 || (_config = _config.vc) === null || _config === void 0 ? void 0 : _config.selectorConfig) !== null && _ref2 !== void 0 ? _ref2 : defaultConfig;
}
function $076abb7020acfb8b$export$74bdb753f1cf4860() {
    var _config2;
    // Default to enabled if config is not set or enabled is not explicitly false
    return ((_config2 = $076abb7020acfb8b$var$config) === null || _config2 === void 0 ? void 0 : _config2.enabled) !== false;
}
var $076abb7020acfb8b$var$isValidConfigArray = function isValidConfigArray(array) {
    return Array.isArray(array) && array.length > 0;
};
function $076abb7020acfb8b$export$87fbc8e01b137811() {
    var experienceKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    try {
        var _config$vc;
        if (!$076abb7020acfb8b$var$config) return [];
        if ((_config$vc = $076abb7020acfb8b$var$config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled) {
            var _config$vc2, _enabledVCRevisions$b;
            var _ref3 = (_config$vc2 = $076abb7020acfb8b$var$config.vc) !== null && _config$vc2 !== void 0 ? _config$vc2 : {}, enabledVCRevisions = _ref3.enabledVCRevisions;
            if ($076abb7020acfb8b$var$isValidConfigArray(enabledVCRevisions === null || enabledVCRevisions === void 0 || (_enabledVCRevisions$b = enabledVCRevisions.byExperience) === null || _enabledVCRevisions$b === void 0 ? void 0 : _enabledVCRevisions$b[experienceKey])) {
                var _enabledVCRevisions$b2;
                return (_enabledVCRevisions$b2 = enabledVCRevisions.byExperience) === null || _enabledVCRevisions$b2 === void 0 ? void 0 : _enabledVCRevisions$b2[experienceKey];
            }
            // When the disable flag is on, treat an explicitly-set empty array as
            // "no client-side revisions" rather than falling back to the default revision.
            var allRevisions = enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.all;
            if (Array.isArray(allRevisions) && allRevisions.length === 0 && (0, $50U6m.fg)('ufo_disable_ttvc_v4')) return allRevisions;
            if ($076abb7020acfb8b$var$isValidConfigArray(allRevisions)) return allRevisions;
            return [
                $076abb7020acfb8b$export$2182e73d31080cbc()
            ];
        }
        return [];
    } catch (_unused3) {
        return [];
    }
}
function $076abb7020acfb8b$export$4babcefc81a3ef0b(revision, experienceKey) {
    return $076abb7020acfb8b$export$87fbc8e01b137811(experienceKey).includes(revision);
}
function $076abb7020acfb8b$export$70184d6e2c753893() {
    var experienceKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var enabledVCRevisions = $076abb7020acfb8b$export$87fbc8e01b137811(experienceKey);
    if (enabledVCRevisions.length === 0) return $076abb7020acfb8b$export$2182e73d31080cbc();
    return enabledVCRevisions[enabledVCRevisions.length - 1];
}
function $076abb7020acfb8b$export$2d8f8d64dc343d7b() {
    if (!$076abb7020acfb8b$var$config) return undefined;
    try {
        var _config3, _config3$getReactHydr;
        var stats = (_config3 = $076abb7020acfb8b$var$config) === null || _config3 === void 0 || (_config3$getReactHydr = _config3.getReactHydrationStats) === null || _config3$getReactHydr === void 0 ? void 0 : _config3$getReactHydr.call(_config3);
        return stats !== null && stats !== void 0 ? stats : undefined;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('getReactHydrationStats threw an error: ', e);
        return undefined;
    }
}
function $076abb7020acfb8b$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$076abb7020acfb8b$var$config) return 0;
        var _config4 = $076abb7020acfb8b$var$config, killswitch = _config4.killswitch, rates = _config4.rates, rules = _config4.rules, kind = _config4.kind, autoGeneratedRate = _config4.autoGeneratedRate;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        var isUnknown = name === 'unknown';
        if (isUnknown) {
            if ((rates === null || rates === void 0 ? void 0 : rates[name]) != null) return rates[name];
            // Return default rate for unknown events when no explicit rate is configured
            return $076abb7020acfb8b$export$d50dacda7fe6392b;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(var i = 0; i < rules.length; i++){
            var rule = rules[i];
            var test = rule.test, rate = rule.rate;
            if (test != null && rate != null) {
                var regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        var isAutogenerated = name === null || name === void 0 ? void 0 : name.startsWith('auto-generated');
        if (isAutogenerated) {
            var _rate = autoGeneratedRate;
            if (_rate != null) return _rate;
        }
        if (kind != null) {
            var _rate2 = kind[interactionKind];
            if (_rate2 != null) return _rate2;
        }
        return 0;
    } catch (_unused4) {
        // Fallback
        return 0;
    }
}
function $076abb7020acfb8b$export$48f4e0d964030a96(name, interactionType) {
    return $076abb7020acfb8b$var$getConfigRate(name, interactionType, 'enableVCRawDataRates');
}
function $076abb7020acfb8b$export$9c69f5a724f05f38(name, interactionType) {
    return $076abb7020acfb8b$export$48f4e0d964030a96(name, interactionType) > 0;
}
function $076abb7020acfb8b$export$1d459f020c06ae34(name, interactionType) {
    return $076abb7020acfb8b$var$getConfigRate(name, interactionType, 'postInteractionLog');
}
function $076abb7020acfb8b$export$29b9ffb14861a1d(capability) {
    if ((0, $50U6m.fg)('platform_ufo_remove_deprecated_config_fields')) return 1;
    try {
        if (!$076abb7020acfb8b$var$config) return 0;
        var _config5 = $076abb7020acfb8b$var$config, capabilityRate = _config5.capability;
        if (capabilityRate != null) {
            var rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch (_unused5) {
        return 0;
    }
}
function $076abb7020acfb8b$var$getConfigRate(name, interactionType, configName) {
    try {
        if (!$076abb7020acfb8b$var$config) return 0;
        var gotConfig = $076abb7020acfb8b$var$config[configName];
        if (!(gotConfig !== null && gotConfig !== void 0 && gotConfig.enabled)) return 0;
        if (interactionType !== 'page_load' && interactionType !== 'transition') return 0;
        if (gotConfig.rates && typeof gotConfig.rates[name] === 'number') return gotConfig.rates[name];
        if ('kind' in gotConfig && gotConfig.kind && typeof gotConfig.kind[interactionType] === 'number') return gotConfig.kind[interactionType];
        return 0;
    } catch (_unused6) {
        return 0;
    }
}
var $076abb7020acfb8b$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function $076abb7020acfb8b$export$7e32aae12bf9b50f() {
    var defaultMethod = 'timeout';
    try {
        if (!$076abb7020acfb8b$var$config) return defaultMethod;
        var _config6 = $076abb7020acfb8b$var$config, typingMethod = _config6.typingMethod;
        if (typingMethod != null && $076abb7020acfb8b$var$validTypingMethods.find(function(m) {
            return m === typingMethod;
        })) return typingMethod;
        else return defaultMethod;
    } catch (_unused7) {
        return defaultMethod;
    }
}
function $076abb7020acfb8b$export$2d311b3fd18dcab1() {
    try {
        if (!$076abb7020acfb8b$var$config) return [];
        var _config7 = $076abb7020acfb8b$var$config, awaitBM3TTI = _config7.awaitBM3TTI;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch (_unused8) {
        return [];
    }
}
function $076abb7020acfb8b$export$4f4649ef27b6f5d6() {
    try {
        if (!$076abb7020acfb8b$var$config) return undefined;
        var _config8 = $076abb7020acfb8b$var$config, ufoNameOverrides = _config8.ufoNameOverrides;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch (_unused9) {
        return undefined;
    }
}
function $076abb7020acfb8b$export$b150ddad71c80d77() {
    try {
        if (!$076abb7020acfb8b$var$config) return undefined;
        var _config9 = $076abb7020acfb8b$var$config, minorInteractions = _config9.minorInteractions;
        return minorInteractions;
    } catch (_unused0) {
        return undefined;
    }
}
function $076abb7020acfb8b$export$3c170167645a0eff() {
    try {
        if (!$076abb7020acfb8b$var$config) return undefined;
        var _config0 = $076abb7020acfb8b$var$config, doNotAbortActivePressInteraction = _config0.doNotAbortActivePressInteraction;
        return doNotAbortActivePressInteraction;
    } catch (_unused1) {
        return undefined;
    }
}
function $076abb7020acfb8b$export$d6dc9444bd15f70f() {
    try {
        if (!$076abb7020acfb8b$var$config) return undefined;
        var _config1 = $076abb7020acfb8b$var$config, doNotAbortActivePressInteractionOnTransition = _config1.doNotAbortActivePressInteractionOnTransition;
        return doNotAbortActivePressInteractionOnTransition;
    } catch (_unused10) {
        return undefined;
    }
}
function $076abb7020acfb8b$export$20e8108b8ccdd0bd() {
    try {
        if (!$076abb7020acfb8b$var$config) return undefined;
        var _config10 = $076abb7020acfb8b$var$config, finishInteractionOnTransition = _config10.finishInteractionOnTransition;
        return finishInteractionOnTransition;
    } catch (_unused11) {
        return undefined;
    }
}
var $076abb7020acfb8b$export$2a8604960d7d23d9 = 60000;
function $076abb7020acfb8b$export$c681731847989445(ufoName) {
    try {
        if (!$076abb7020acfb8b$var$config) return $076abb7020acfb8b$export$2a8604960d7d23d9;
        var _config11 = $076abb7020acfb8b$var$config, interactionTimeout = _config11.interactionTimeout;
        if (interactionTimeout != null && interactionTimeout[ufoName] != null) return interactionTimeout[ufoName];
        if (interactionTimeout != null && interactionTimeout.__globalInteractionTimeout != null) return interactionTimeout.__globalInteractionTimeout;
        else return $076abb7020acfb8b$export$2a8604960d7d23d9;
    } catch (_unused12) {
        return $076abb7020acfb8b$export$2a8604960d7d23d9;
    }
}

});
parcelRegister("eSdwu", function(module, exports) {
$parcel$export(module.exports, "isFedrampModerate", () => $ad409937b0dd689b$export$104cb891a6e90b3a);

var $lkh54 = parcelRequire("lkh54");

var $kN4Zn = parcelRequire("kN4Zn");
function $ad409937b0dd689b$export$104cb891a6e90b3a() {
    if (typeof document === 'undefined') {
        var _globalThis$ssrContex, _globalThis$ssrContex2;
        // @ts-ignore
        return (_globalThis$ssrContex = (_globalThis$ssrContex2 = globalThis.ssrContext) === null || _globalThis$ssrContex2 === void 0 ? void 0 : _globalThis$ssrContex2.isInFedramp) !== null && _globalThis$ssrContex !== void 0 ? _globalThis$ssrContex : false;
    }
    var atlCtxCookieValues = (0, $kN4Zn.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $lkh54.FEDRAMP_MODERATE);
}

});
parcelRegister("lkh54", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $f868b71fb379c306$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $f868b71fb379c306$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "STAGING", () => $f868b71fb379c306$export$a739cd5aac835909);
$parcel$export(module.exports, "PRODUCTION", () => $f868b71fb379c306$export$42dd0cdd351a4a9);
$parcel$export(module.exports, "DEV", () => $f868b71fb379c306$export$404582bc18fe4d9e);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $f868b71fb379c306$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $f868b71fb379c306$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $f868b71fb379c306$export$a0ffa0598c95dfb7);
$parcel$export(module.exports, "BIFROST_ATL_CTX_CLOUD_SERVICE_PROVIDER", () => $f868b71fb379c306$export$74814ca8786924c3);
$parcel$export(module.exports, "CLOUD_SERVICE_PROVIDER_GCP", () => $f868b71fb379c306$export$b61e047ddcc35726);
var $f868b71fb379c306$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $f868b71fb379c306$export$f005e2e9f707cb5f = 'commercial';
var $f868b71fb379c306$export$17b81a3d6c98013c = 'isolated-cloud';
var $f868b71fb379c306$export$a739cd5aac835909 = 'staging';
var $f868b71fb379c306$export$42dd0cdd351a4a9 = 'prod';
var $f868b71fb379c306$export$404582bc18fe4d9e = 'dev';
var $f868b71fb379c306$export$87285944378c596 = 'Atl-Ctx-Perimeter';
var $f868b71fb379c306$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
var $f868b71fb379c306$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
var $f868b71fb379c306$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
var $f868b71fb379c306$export$b61e047ddcc35726 = 'GCP';
var $f868b71fb379c306$export$1baf17f3e645a2b2 = 'AWS';

});

parcelRegister("kN4Zn", function(module, exports) {
$parcel$export(module.exports, "parseAtlCtxCookies", () => $f22c40ef15d7672e$export$3fa7b7af96286cc9);

var $lkh54 = parcelRequire("lkh54");

var $lqDQf = parcelRequire("lqDQf");
function $f22c40ef15d7672e$export$3fa7b7af96286cc9() {
    var global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        var cookies = global.document.cookie;
        var perimeter = (0, $lqDQf.getRawCookieValue)((0, $lkh54.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        var icDomain = (0, $lqDQf.getRawCookieValue)((0, $lkh54.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        var icId = (0, $lqDQf.getRawCookieValue)((0, $lkh54.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        var emptyIcDomain = !icDomain || icDomain.length === 0;
        var emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});
parcelRegister("lqDQf", function(module, exports) {
$parcel$export(module.exports, "getRawCookieValue", () => $f99aee6bb01b7c4d$export$aa09aab30a92256c);

var $iYJcE = parcelRequire("iYJcE");
function $f99aee6bb01b7c4d$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $f99aee6bb01b7c4d$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $f99aee6bb01b7c4d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f99aee6bb01b7c4d$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f99aee6bb01b7c4d$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $f99aee6bb01b7c4d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $f99aee6bb01b7c4d$export$aa09aab30a92256c(cookieName, cookieString) {
    if (!cookieString) return undefined;
    var cookies = cookieString.split(';');
    var _iterator = $f99aee6bb01b7c4d$var$_createForOfIteratorHelper(cookies), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var cookie = _step.value;
            var _cookie$trim$split = cookie.trim().split('='), _cookie$trim$split2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_cookie$trim$split, 2), name = _cookie$trim$split2[0], value = _cookie$trim$split2[1];
            if (name === cookieName) return value;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return undefined;
}

});




parcelRegister("bLIMX", function(module, exports) {
$parcel$export(module.exports, "default", () => $8916d3957d190d4e$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $eqVaP = parcelRequire("eqVaP");

var $8916d3957d190d4e$export$2e2bcd8739ae039 = (0, $eqVaP.default);

});

parcelRegister("gITbN", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2cb90d222c902dc$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $5FkrB = parcelRequire("5FkrB");

var $6aILb = parcelRequire("6aILb");



// We use a context to allow modals to have their own lifecycle
var $c2cb90d222c902dc$var$interactionContext = /*#__PURE__*/ (0, $5FkrB.createContext)((0, $6aILb.default));
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$c2cb90d222c902dc$export$2e2bcd8739ae039 = $c2cb90d222c902dc$var$interactionContext;

});
parcelRegister("6aILb", function(module, exports) {
$parcel$export(module.exports, "default", () => $47e665ab75f65570$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $ivsB7 = parcelRequire("ivsB7");
// Same structure as react's useRef.
// This allows modals to use a ref to scope their value
// const id = useRef(null);
// <InteractionIDContext.Provider value={id}>...<
var $47e665ab75f65570$var$ObservableInteractionID = /*#__PURE__*/ function() {
    function ObservableInteractionID() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ObservableInteractionID);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_current", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ObservableInteractionID, [
        {
            key: "current",
            get: function get() {
                return this._current;
            },
            set: function set(newId) {
                var oldId = this._current;
                this._current = newId;
                if (oldId !== newId) (0, $ivsB7.listeners).forEach(function(listener) {
                    return listener(newId);
                });
            }
        }
    ]);
}();
var $47e665ab75f65570$var$initializeGlobalDefaultInteractionID = function initializeGlobalDefaultInteractionID() {
    if (globalThis.__UFO_DEFAULT_INTERACTION_ID__) return globalThis.__UFO_DEFAULT_INTERACTION_ID__;
    var instance = new $47e665ab75f65570$var$ObservableInteractionID();
    globalThis.__UFO_DEFAULT_INTERACTION_ID__ = instance;
    return instance;
};
var $47e665ab75f65570$var$DefaultInteractionID = $47e665ab75f65570$var$initializeGlobalDefaultInteractionID();
var $47e665ab75f65570$export$2e2bcd8739ae039 = $47e665ab75f65570$var$DefaultInteractionID;

});
parcelRegister("ivsB7", function(module, exports) {
$parcel$export(module.exports, "listeners", () => $d7914e204845f92d$export$58bed631278dbc67);
$parcel$export(module.exports, "subscribeToInteractionIdChanges", () => $d7914e204845f92d$export$3e0c3023952f6774);
// Subscription system for interaction ID changes
var $d7914e204845f92d$export$58bed631278dbc67 = new Set();
var $d7914e204845f92d$export$3e0c3023952f6774 = function subscribeToInteractionIdChanges(listener) {
    $d7914e204845f92d$export$58bed631278dbc67.add(listener);
    return function() {
        $d7914e204845f92d$export$58bed631278dbc67.delete(listener);
    };
};

});





parcelRegister("8lACD", function(module, exports) {
$parcel$export(module.exports, "useInteractionContext", () => $613cb14f5b88e96c$export$11bcb6e9af2aca35);

var $5FkrB = parcelRequire("5FkrB");

var $eqVaP = parcelRequire("eqVaP");
function $613cb14f5b88e96c$export$11bcb6e9af2aca35() {
    return (0, $5FkrB.useContext)((0, $eqVaP.default));
}

});

parcelRegister("4iVTn", function(module, exports) {
$parcel$export(module.exports, "default", () => $3225c00b9febbfdb$export$2e2bcd8739ae039);
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $3225c00b9febbfdb$var$coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}
var $3225c00b9febbfdb$export$2e2bcd8739ae039 = $3225c00b9febbfdb$var$coinflip;

});

parcelRegister("bYaqG", function(module, exports) {
$parcel$export(module.exports, "sanitizeLabelStackName", () => $8b6d635f85008a7f$export$3535cd9da4961282);
function $8b6d635f85008a7f$export$3535cd9da4961282(name) {
    if (name.startsWith('/')) name = name.replace(/^\/+/, '');
    if (name.endsWith('/')) name = name.replace(/\/+$/, '');
    return name;
}

});

parcelRegister("5OMCI", function(module, exports) {
$parcel$export(module.exports, "getActiveTrace", () => $43c756dcda940258$export$b6ac780db3a3cc77);
parcelRequire("gQVPx");
var $kuxjd = parcelRequire("kuxjd");

var $50U6m = parcelRequire("50U6m");

var $2oi3V = parcelRequire("2oi3V");

var $k0Cxu = parcelRequire("k0Cxu");

var $5Y1AV = parcelRequire("5Y1AV");

var $dZ6Fb = parcelRequire("dZ6Fb");
function $43c756dcda940258$export$b6ac780db3a3cc77() {
    if ((0, $50U6m.fg)('platform_ufo_enable_otel_context_manager')) {
        // Get trace context from active context
        var activeTraceContext = {
            traceId: String((0, $kuxjd.context).active().getValue((0, $dZ6Fb.traceIdKey))),
            spanId: String((0, $kuxjd.context).active().getValue((0, $k0Cxu.spanIdKey))),
            type: String((0, $kuxjd.context).active().getValue((0, $2oi3V.experienceTypeKey)))
        };
        // Return activeTraceContext if traceId and spanId are not "undefined"
        return activeTraceContext.traceId !== 'undefined' && activeTraceContext.spanId !== 'undefined' ? activeTraceContext : undefined;
    } else return (0, $5Y1AV.state).context || undefined;
}

});
parcelRegister("gQVPx", function(module, exports) {
$parcel$export(module.exports, "context", () => (parcelRequire("kuxjd")).context);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 

var $eRfZr = parcelRequire("eRfZr");















var $kuxjd = parcelRequire("kuxjd");

var $4Gd08 = parcelRequire("4Gd08");

var $7fonw = parcelRequire("7fonw");

var $3YtNg = parcelRequire("3YtNg");

var $kdTCg = parcelRequire("kdTCg");
var // Default export.
$c44e5c8d37d338e2$export$2e2bcd8739ae039 = {
    context: $kuxjd.context,
    diag: $4Gd08.diag,
    metrics: $7fonw.metrics,
    propagation: $3YtNg.propagation,
    trace: $kdTCg.trace
};

});
parcelRegister("eRfZr", function(module, exports) {
$parcel$export(module.exports, "createContextKey", () => $ad126b2fab83b218$export$b8c322c5a7cfce78);
$parcel$export(module.exports, "ROOT_CONTEXT", () => $ad126b2fab83b218$export$78df28f9b2f9a7dc);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Get a key to uniquely identify a context value
 *
 * @since 1.0.0
 */ function $ad126b2fab83b218$export$b8c322c5a7cfce78(description) {
    // The specification states that for the same input, multiple calls should
    // return different keys. Due to the nature of the JS dependency management
    // system, this creates problems where multiple versions of some package
    // could hold different keys for the same property.
    //
    // Therefore, we use Symbol.for which returns the same key for the same input.
    return Symbol.for(description);
}
class $ad126b2fab83b218$var$BaseContext {
    /**
     * Construct a new context which inherits values from an optional parent context.
     *
     * @param parentContext a context from which to inherit values
     */ constructor(parentContext){
        // for minification
        const self = this;
        self._currentContext = parentContext ? new Map(parentContext) : new Map();
        self.getValue = (key)=>self._currentContext.get(key);
        self.setValue = (key, value)=>{
            const context = new $ad126b2fab83b218$var$BaseContext(self._currentContext);
            context._currentContext.set(key, value);
            return context;
        };
        self.deleteValue = (key)=>{
            const context = new $ad126b2fab83b218$var$BaseContext(self._currentContext);
            context._currentContext.delete(key);
            return context;
        };
    }
}
const $ad126b2fab83b218$export$78df28f9b2f9a7dc = new $ad126b2fab83b218$var$BaseContext();

});

parcelRegister("kuxjd", function(module, exports) {
$parcel$export(module.exports, "context", () => $eeb0726c7b8207cc$export$a078c61943f9dbbe);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $2diR9 = parcelRequire("2diR9");
const $eeb0726c7b8207cc$export$a078c61943f9dbbe = (0, $2diR9.ContextAPI).getInstance();

});
parcelRegister("2diR9", function(module, exports) {
$parcel$export(module.exports, "ContextAPI", () => $19cb6c1b967e85bd$export$4148866f0a453927);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $jk1rM = parcelRequire("jk1rM");

var $Qsdj6 = parcelRequire("Qsdj6");

var $jrQSC = parcelRequire("jrQSC");
const $19cb6c1b967e85bd$var$API_NAME = 'context';
const $19cb6c1b967e85bd$var$NOOP_CONTEXT_MANAGER = new (0, $jk1rM.NoopContextManager)();
class $19cb6c1b967e85bd$export$4148866f0a453927 {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ constructor(){}
    /** Get the singleton instance of the Context API */ static getInstance() {
        if (!this._instance) this._instance = new $19cb6c1b967e85bd$export$4148866f0a453927();
        return this._instance;
    }
    /**
     * Set the current context manager.
     *
     * @returns true if the context manager was successfully registered, else false
     */ setGlobalContextManager(contextManager) {
        return (0, $Qsdj6.registerGlobal)($19cb6c1b967e85bd$var$API_NAME, contextManager, (0, $jrQSC.DiagAPI).instance());
    }
    /**
     * Get the currently active context
     */ active() {
        return this._getContextManager().active();
    }
    /**
     * Execute a function with an active context
     *
     * @param context context to be active during function execution
     * @param fn function to execute in a context
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ with(context, fn, thisArg, ...args) {
        return this._getContextManager().with(context, fn, thisArg, ...args);
    }
    /**
     * Bind a context to a target function or event emitter
     *
     * @param context context to bind to the event emitter or function. Defaults to the currently active context
     * @param target function or event emitter to bind
     */ bind(context, target) {
        return this._getContextManager().bind(context, target);
    }
    _getContextManager() {
        return (0, $Qsdj6.getGlobal)($19cb6c1b967e85bd$var$API_NAME) || $19cb6c1b967e85bd$var$NOOP_CONTEXT_MANAGER;
    }
    /** Disable and remove the global context manager */ disable() {
        this._getContextManager().disable();
        (0, $Qsdj6.unregisterGlobal)($19cb6c1b967e85bd$var$API_NAME, (0, $jrQSC.DiagAPI).instance());
    }
}

});
parcelRegister("jk1rM", function(module, exports) {
$parcel$export(module.exports, "NoopContextManager", () => $e11101ed10dc5b25$export$a27e5df35d1539a6);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $eRfZr = parcelRequire("eRfZr");
class $e11101ed10dc5b25$export$a27e5df35d1539a6 {
    active() {
        return 0, $eRfZr.ROOT_CONTEXT;
    }
    with(_context, fn, thisArg, ...args) {
        return fn.call(thisArg, ...args);
    }
    bind(_context, target) {
        return target;
    }
    enable() {
        return this;
    }
    disable() {
        return this;
    }
}

});

parcelRegister("Qsdj6", function(module, exports) {
$parcel$export(module.exports, "registerGlobal", () => $09dabe152ee7f842$export$d586ae880b433238);
$parcel$export(module.exports, "getGlobal", () => $09dabe152ee7f842$export$a4e55266d2135a7f);
$parcel$export(module.exports, "unregisterGlobal", () => $09dabe152ee7f842$export$d42ac835f38d1fb2);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $gR5Zi = parcelRequire("gR5Zi");

var $aWHaD = parcelRequire("aWHaD");
const $09dabe152ee7f842$var$major = (0, $gR5Zi.VERSION).split('.')[0];
const $09dabe152ee7f842$var$GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for(`opentelemetry.js.api.${$09dabe152ee7f842$var$major}`);
const $09dabe152ee7f842$var$_global = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};
function $09dabe152ee7f842$export$d586ae880b433238(type, instance, diag, allowOverride = false) {
    var _a;
    const api = $09dabe152ee7f842$var$_global[$09dabe152ee7f842$var$GLOBAL_OPENTELEMETRY_API_KEY] = (_a = $09dabe152ee7f842$var$_global[$09dabe152ee7f842$var$GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
        version: (0, $gR5Zi.VERSION)
    };
    if (!allowOverride && api[type]) {
        // already registered an API of this type
        const err = new Error(`@opentelemetry/api: Attempted duplicate registration of API: ${type}`);
        diag.error(err.stack || err.message);
        return false;
    }
    if (api.version !== (0, $gR5Zi.VERSION)) {
        // All registered APIs must be of the same version exactly
        const err = new Error(`@opentelemetry/api: Registration of version v${api.version} for ${type} does not match previously registered API v${(0, $gR5Zi.VERSION)}`);
        diag.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag.debug(`@opentelemetry/api: Registered a global for ${type} v${(0, $gR5Zi.VERSION)}.`);
    return true;
}
function $09dabe152ee7f842$export$a4e55266d2135a7f(type) {
    var _a, _b;
    const globalVersion = (_a = $09dabe152ee7f842$var$_global[$09dabe152ee7f842$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
    if (!globalVersion || !(0, $aWHaD.isCompatible)(globalVersion)) return;
    return (_b = $09dabe152ee7f842$var$_global[$09dabe152ee7f842$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function $09dabe152ee7f842$export$d42ac835f38d1fb2(type, diag) {
    diag.debug(`@opentelemetry/api: Unregistering a global for ${type} v${(0, $gR5Zi.VERSION)}.`);
    const api = $09dabe152ee7f842$var$_global[$09dabe152ee7f842$var$GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) delete api[type];
}

});
parcelRegister("gR5Zi", function(module, exports) {
$parcel$export(module.exports, "VERSION", () => $c4563d9fcd4cc26a$export$a4ad2735b021c132);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // this is autogenerated file, see scripts/version-update.js
const $c4563d9fcd4cc26a$export$a4ad2735b021c132 = '1.9.1';

});

parcelRegister("aWHaD", function(module, exports) {
$parcel$export(module.exports, "isCompatible", () => $7f80cef1b5d2accd$export$7fc0d8c3ab188c4c);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $gR5Zi = parcelRequire("gR5Zi");
const $7f80cef1b5d2accd$var$re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function $7f80cef1b5d2accd$export$a5733a4d26a1ec61(ownVersion) {
    const acceptedVersions = new Set([
        ownVersion
    ]);
    const rejectedVersions = new Set();
    const myVersionMatch = ownVersion.match($7f80cef1b5d2accd$var$re);
    if (!myVersionMatch) // we cannot guarantee compatibility so we always return noop
    return ()=>false;
    const ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4]
    };
    // if ownVersion has a prerelease tag, versions must match exactly
    if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
        return globalVersion === ownVersion;
    };
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible(globalVersion) {
        if (acceptedVersions.has(globalVersion)) return true;
        if (rejectedVersions.has(globalVersion)) return false;
        const globalVersionMatch = globalVersion.match($7f80cef1b5d2accd$var$re);
        if (!globalVersionMatch) // cannot parse other version
        // we cannot guarantee compatibility so we always noop
        return _reject(globalVersion);
        const globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4]
        };
        // if globalVersion has a prerelease tag, versions must match exactly
        if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
        // major versions must match
        if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
        return _reject(globalVersion);
    };
}
const $7f80cef1b5d2accd$export$7fc0d8c3ab188c4c = $7f80cef1b5d2accd$export$a5733a4d26a1ec61((0, $gR5Zi.VERSION));

});


parcelRegister("jrQSC", function(module, exports) {
$parcel$export(module.exports, "DiagAPI", () => $e2898ed087743bf2$export$5c8937ffc688cfd3);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $5fe1G = parcelRequire("5fe1G");

var $2zAM7 = parcelRequire("2zAM7");

var $at0WC = parcelRequire("at0WC");

var $Qsdj6 = parcelRequire("Qsdj6");
const $e2898ed087743bf2$var$API_NAME = 'diag';
class $e2898ed087743bf2$export$5c8937ffc688cfd3 {
    /** Get the singleton instance of the DiagAPI API */ static instance() {
        if (!this._instance) this._instance = new $e2898ed087743bf2$export$5c8937ffc688cfd3();
        return this._instance;
    }
    /**
     * Private internal constructor
     * @private
     */ constructor(){
        function _logProxy(funcName) {
            return function(...args) {
                const logger = (0, $Qsdj6.getGlobal)('diag');
                // shortcut if logger not set
                if (!logger) return;
                return logger[funcName](...args);
            };
        }
        // Using self local variable for minification purposes as 'this' cannot be minified
        const self = this;
        // DiagAPI specific functions
        const setLogger = (logger, optionsOrLogLevel = {
            logLevel: (0, $at0WC.DiagLogLevel).INFO
        })=>{
            var _a, _b, _c;
            if (logger === self) {
                // There isn't much we can do here.
                // Logging to the console might break the user application.
                // Try to log to self. If a logger was previously registered it will receive the log.
                const err = new Error('Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation');
                self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === 'number') optionsOrLogLevel = {
                logLevel: optionsOrLogLevel
            };
            const oldLogger = (0, $Qsdj6.getGlobal)('diag');
            const newLogger = (0, $2zAM7.createLogLevelDiagLogger)((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : (0, $at0WC.DiagLogLevel).INFO, logger);
            // There already is an logger registered. We'll let it know before overwriting it.
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                const stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : '<failed to generate stacktrace>';
                oldLogger.warn(`Current logger will be overwritten from ${stack}`);
                newLogger.warn(`Current logger will overwrite one already registered from ${stack}`);
            }
            return (0, $Qsdj6.registerGlobal)('diag', newLogger, self, true);
        };
        self.setLogger = setLogger;
        self.disable = ()=>{
            (0, $Qsdj6.unregisterGlobal)($e2898ed087743bf2$var$API_NAME, self);
        };
        self.createComponentLogger = (options)=>{
            return new (0, $5fe1G.DiagComponentLogger)(options);
        };
        self.verbose = _logProxy('verbose');
        self.debug = _logProxy('debug');
        self.info = _logProxy('info');
        self.warn = _logProxy('warn');
        self.error = _logProxy('error');
    }
}

});
parcelRegister("5fe1G", function(module, exports) {
$parcel$export(module.exports, "DiagComponentLogger", () => $3d193bc4fab6e174$export$b4bccc12f5b13129);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $Qsdj6 = parcelRequire("Qsdj6");
class $3d193bc4fab6e174$export$b4bccc12f5b13129 {
    constructor(props){
        this._namespace = props.namespace || 'DiagComponentLogger';
    }
    debug(...args) {
        return $3d193bc4fab6e174$var$logProxy('debug', this._namespace, args);
    }
    error(...args) {
        return $3d193bc4fab6e174$var$logProxy('error', this._namespace, args);
    }
    info(...args) {
        return $3d193bc4fab6e174$var$logProxy('info', this._namespace, args);
    }
    warn(...args) {
        return $3d193bc4fab6e174$var$logProxy('warn', this._namespace, args);
    }
    verbose(...args) {
        return $3d193bc4fab6e174$var$logProxy('verbose', this._namespace, args);
    }
}
function $3d193bc4fab6e174$var$logProxy(funcName, namespace, args) {
    const logger = (0, $Qsdj6.getGlobal)('diag');
    // shortcut if logger not set
    if (!logger) return;
    return logger[funcName](namespace, ...args);
}

});

parcelRegister("2zAM7", function(module, exports) {
$parcel$export(module.exports, "createLogLevelDiagLogger", () => $1dfb60736a2810dd$export$9a9cc475abb19689);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $at0WC = parcelRequire("at0WC");
function $1dfb60736a2810dd$export$9a9cc475abb19689(maxLevel, logger) {
    if (maxLevel < (0, $at0WC.DiagLogLevel).NONE) maxLevel = (0, $at0WC.DiagLogLevel).NONE;
    else if (maxLevel > (0, $at0WC.DiagLogLevel).ALL) maxLevel = (0, $at0WC.DiagLogLevel).ALL;
    // In case the logger is null or undefined
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        const theFunc = logger[funcName];
        if (typeof theFunc === 'function' && maxLevel >= theLevel) return theFunc.bind(logger);
        return function() {};
    }
    return {
        error: _filterFunc('error', (0, $at0WC.DiagLogLevel).ERROR),
        warn: _filterFunc('warn', (0, $at0WC.DiagLogLevel).WARN),
        info: _filterFunc('info', (0, $at0WC.DiagLogLevel).INFO),
        debug: _filterFunc('debug', (0, $at0WC.DiagLogLevel).DEBUG),
        verbose: _filterFunc('verbose', (0, $at0WC.DiagLogLevel).VERBOSE)
    };
}

});
parcelRegister("at0WC", function(module, exports) {
$parcel$export(module.exports, "DiagLogLevel", () => $79ed585b1b95c15f$export$b7d7b4c0f3c95263);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Defines the available internal logging levels for the diagnostic logger, the numeric values
 * of the levels are defined to match the original values from the initial LogLevel to avoid
 * compatibility/migration issues for any implementation that assume the numeric ordering.
 */ var $79ed585b1b95c15f$export$b7d7b4c0f3c95263;
(function(DiagLogLevel) {
    /** Diagnostic Logging level setting to disable all logging (except and forced logs) */ DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
    /** Identifies an error scenario */ DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
    /** Identifies a warning scenario */ DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
    /** General informational log message */ DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
    /** General debug log message */ DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
    /**
     * Detailed trace level logging should only be used for development, should only be set
     * in a development environment.
     */ DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
    /** Used to set the logging level to include all logging */ DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})($79ed585b1b95c15f$export$b7d7b4c0f3c95263 || ($79ed585b1b95c15f$export$b7d7b4c0f3c95263 = {}));

});





parcelRegister("4Gd08", function(module, exports) {
$parcel$export(module.exports, "diag", () => $36852b72a48d0767$export$c042e7c2f59bc046);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $jrQSC = parcelRequire("jrQSC");
const $36852b72a48d0767$export$c042e7c2f59bc046 = (0, $jrQSC.DiagAPI).instance();

});

parcelRegister("7fonw", function(module, exports) {
$parcel$export(module.exports, "metrics", () => $546cd82524fee72b$export$b0c5c2fac8144e54);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $3Kaqe = parcelRequire("3Kaqe");
const $546cd82524fee72b$export$b0c5c2fac8144e54 = (0, $3Kaqe.MetricsAPI).getInstance();

});
parcelRegister("3Kaqe", function(module, exports) {
$parcel$export(module.exports, "MetricsAPI", () => $2b9dc09431a6c63c$export$1339f6eb6111c638);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $aVsje = parcelRequire("aVsje");

var $Qsdj6 = parcelRequire("Qsdj6");

var $jrQSC = parcelRequire("jrQSC");
const $2b9dc09431a6c63c$var$API_NAME = 'metrics';
class $2b9dc09431a6c63c$export$1339f6eb6111c638 {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ constructor(){}
    /** Get the singleton instance of the Metrics API */ static getInstance() {
        if (!this._instance) this._instance = new $2b9dc09431a6c63c$export$1339f6eb6111c638();
        return this._instance;
    }
    /**
     * Set the current global meter provider.
     * Returns true if the meter provider was successfully registered, else false.
     */ setGlobalMeterProvider(provider) {
        return (0, $Qsdj6.registerGlobal)($2b9dc09431a6c63c$var$API_NAME, provider, (0, $jrQSC.DiagAPI).instance());
    }
    /**
     * Returns the global meter provider.
     */ getMeterProvider() {
        return (0, $Qsdj6.getGlobal)($2b9dc09431a6c63c$var$API_NAME) || (0, $aVsje.NOOP_METER_PROVIDER);
    }
    /**
     * Returns a meter from the global meter provider.
     */ getMeter(name, version, options) {
        return this.getMeterProvider().getMeter(name, version, options);
    }
    /** Remove the global meter provider */ disable() {
        (0, $Qsdj6.unregisterGlobal)($2b9dc09431a6c63c$var$API_NAME, (0, $jrQSC.DiagAPI).instance());
    }
}

});
parcelRegister("aVsje", function(module, exports) {
$parcel$export(module.exports, "NOOP_METER_PROVIDER", () => $7f452fe0fc81b006$export$d21fe83355c56e18);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $5qY9j = parcelRequire("5qY9j");
class $7f452fe0fc81b006$export$51c513ea08316108 {
    getMeter(_name, _version, _options) {
        return 0, $5qY9j.NOOP_METER;
    }
}
const $7f452fe0fc81b006$export$d21fe83355c56e18 = new $7f452fe0fc81b006$export$51c513ea08316108();

});
parcelRegister("5qY9j", function(module, exports) {
$parcel$export(module.exports, "NOOP_METER", () => $3f4e09db37b86423$export$65e277d35235a01f);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * NoopMeter is a noop implementation of the {@link Meter} interface. It reuses
 * constant NoopMetrics for all of its methods.
 */ class $3f4e09db37b86423$export$c23c6f85dd4fc1e9 {
    constructor(){}
    /**
     * @see {@link Meter.createGauge}
     */ createGauge(_name, _options) {
        return $3f4e09db37b86423$export$dd01300aacbcec1c;
    }
    /**
     * @see {@link Meter.createHistogram}
     */ createHistogram(_name, _options) {
        return $3f4e09db37b86423$export$689c32a6a552e1a6;
    }
    /**
     * @see {@link Meter.createCounter}
     */ createCounter(_name, _options) {
        return $3f4e09db37b86423$export$e6d19fe5233efc54;
    }
    /**
     * @see {@link Meter.createUpDownCounter}
     */ createUpDownCounter(_name, _options) {
        return $3f4e09db37b86423$export$2f189cd99d2b7429;
    }
    /**
     * @see {@link Meter.createObservableGauge}
     */ createObservableGauge(_name, _options) {
        return $3f4e09db37b86423$export$ea67e3c6ff624776;
    }
    /**
     * @see {@link Meter.createObservableCounter}
     */ createObservableCounter(_name, _options) {
        return $3f4e09db37b86423$export$163422b94c3edbcb;
    }
    /**
     * @see {@link Meter.createObservableUpDownCounter}
     */ createObservableUpDownCounter(_name, _options) {
        return $3f4e09db37b86423$export$5b8be9ab17b673b3;
    }
    /**
     * @see {@link Meter.addBatchObservableCallback}
     */ addBatchObservableCallback(_callback, _observables) {}
    /**
     * @see {@link Meter.removeBatchObservableCallback}
     */ removeBatchObservableCallback(_callback) {}
}
class $3f4e09db37b86423$export$834a616d1cf278b {
}
class $3f4e09db37b86423$export$b556ba0f560c45b extends $3f4e09db37b86423$export$834a616d1cf278b {
    add(_value, _attributes) {}
}
class $3f4e09db37b86423$export$df09a35db160df98 extends $3f4e09db37b86423$export$834a616d1cf278b {
    add(_value, _attributes) {}
}
class $3f4e09db37b86423$export$b7f4a3c7ea16c24 extends $3f4e09db37b86423$export$834a616d1cf278b {
    record(_value, _attributes) {}
}
class $3f4e09db37b86423$export$ef064c3e0426c607 extends $3f4e09db37b86423$export$834a616d1cf278b {
    record(_value, _attributes) {}
}
class $3f4e09db37b86423$export$a5a3e7829c289482 {
    addCallback(_callback) {}
    removeCallback(_callback) {}
}
class $3f4e09db37b86423$export$7a7e4b169d5c93a8 extends $3f4e09db37b86423$export$a5a3e7829c289482 {
}
class $3f4e09db37b86423$export$6990a2f90809ffc1 extends $3f4e09db37b86423$export$a5a3e7829c289482 {
}
class $3f4e09db37b86423$export$3ec3555bc6f693a4 extends $3f4e09db37b86423$export$a5a3e7829c289482 {
}
const $3f4e09db37b86423$export$65e277d35235a01f = new $3f4e09db37b86423$export$c23c6f85dd4fc1e9();
const $3f4e09db37b86423$export$e6d19fe5233efc54 = new $3f4e09db37b86423$export$b556ba0f560c45b();
const $3f4e09db37b86423$export$dd01300aacbcec1c = new $3f4e09db37b86423$export$b7f4a3c7ea16c24();
const $3f4e09db37b86423$export$689c32a6a552e1a6 = new $3f4e09db37b86423$export$ef064c3e0426c607();
const $3f4e09db37b86423$export$2f189cd99d2b7429 = new $3f4e09db37b86423$export$df09a35db160df98();
const $3f4e09db37b86423$export$163422b94c3edbcb = new $3f4e09db37b86423$export$7a7e4b169d5c93a8();
const $3f4e09db37b86423$export$ea67e3c6ff624776 = new $3f4e09db37b86423$export$6990a2f90809ffc1();
const $3f4e09db37b86423$export$5b8be9ab17b673b3 = new $3f4e09db37b86423$export$3ec3555bc6f693a4();
function $3f4e09db37b86423$export$bc3a498ccbb5c2b5() {
    return $3f4e09db37b86423$export$65e277d35235a01f;
}

});




parcelRegister("3YtNg", function(module, exports) {
$parcel$export(module.exports, "propagation", () => $2e4e16182d31b8c2$export$3e49040daa9dba20);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $c0ZlJ = parcelRequire("c0ZlJ");
const $2e4e16182d31b8c2$export$3e49040daa9dba20 = (0, $c0ZlJ.PropagationAPI).getInstance();

});
parcelRegister("c0ZlJ", function(module, exports) {
$parcel$export(module.exports, "PropagationAPI", () => $8bf512db52bec208$export$471eda0a6213cac9);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $Qsdj6 = parcelRequire("Qsdj6");

var $gM2PB = parcelRequire("gM2PB");

var $fslyt = parcelRequire("fslyt");

var $cA9o0 = parcelRequire("cA9o0");

var $t8Wdp = parcelRequire("t8Wdp");

var $jrQSC = parcelRequire("jrQSC");
const $8bf512db52bec208$var$API_NAME = 'propagation';
const $8bf512db52bec208$var$NOOP_TEXT_MAP_PROPAGATOR = new (0, $gM2PB.NoopTextMapPropagator)();
class $8bf512db52bec208$export$471eda0a6213cac9 {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ constructor(){
        this.createBaggage = (0, $t8Wdp.createBaggage);
        this.getBaggage = (0, $cA9o0.getBaggage);
        this.getActiveBaggage = (0, $cA9o0.getActiveBaggage);
        this.setBaggage = (0, $cA9o0.setBaggage);
        this.deleteBaggage = (0, $cA9o0.deleteBaggage);
    }
    /** Get the singleton instance of the Propagator API */ static getInstance() {
        if (!this._instance) this._instance = new $8bf512db52bec208$export$471eda0a6213cac9();
        return this._instance;
    }
    /**
     * Set the current propagator.
     *
     * @returns true if the propagator was successfully registered, else false
     */ setGlobalPropagator(propagator) {
        return (0, $Qsdj6.registerGlobal)($8bf512db52bec208$var$API_NAME, propagator, (0, $jrQSC.DiagAPI).instance());
    }
    /**
     * Inject context into a carrier to be propagated inter-process
     *
     * @param context Context carrying tracing data to inject
     * @param carrier carrier to inject context into
     * @param setter Function used to set values on the carrier
     */ inject(context, carrier, setter = (0, $fslyt.defaultTextMapSetter)) {
        return this._getGlobalPropagator().inject(context, carrier, setter);
    }
    /**
     * Extract context from a carrier
     *
     * @param context Context which the newly created context will inherit from
     * @param carrier Carrier to extract context from
     * @param getter Function used to extract keys from a carrier
     */ extract(context, carrier, getter = (0, $fslyt.defaultTextMapGetter)) {
        return this._getGlobalPropagator().extract(context, carrier, getter);
    }
    /**
     * Return a list of all fields which may be used by the propagator.
     */ fields() {
        return this._getGlobalPropagator().fields();
    }
    /** Remove the global propagator */ disable() {
        (0, $Qsdj6.unregisterGlobal)($8bf512db52bec208$var$API_NAME, (0, $jrQSC.DiagAPI).instance());
    }
    _getGlobalPropagator() {
        return (0, $Qsdj6.getGlobal)($8bf512db52bec208$var$API_NAME) || $8bf512db52bec208$var$NOOP_TEXT_MAP_PROPAGATOR;
    }
}

});
parcelRegister("gM2PB", function(module, exports) {
$parcel$export(module.exports, "NoopTextMapPropagator", () => $c36353426ea85293$export$8356c7eb3af7963b);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * No-op implementations of {@link TextMapPropagator}.
 */ class $c36353426ea85293$export$8356c7eb3af7963b {
    /** Noop inject function does nothing */ inject(_context, _carrier) {}
    /** Noop extract function does nothing and returns the input context */ extract(context, _carrier) {
        return context;
    }
    fields() {
        return [];
    }
}

});

parcelRegister("fslyt", function(module, exports) {
$parcel$export(module.exports, "defaultTextMapGetter", () => $b40a30ea52f26f2c$export$a0f575f55f38720a);
$parcel$export(module.exports, "defaultTextMapSetter", () => $b40a30ea52f26f2c$export$f70f1d111fccf1c1);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @since 1.0.0
 */ const $b40a30ea52f26f2c$export$a0f575f55f38720a = {
    get (carrier, key) {
        if (carrier == null) return undefined;
        return carrier[key];
    },
    keys (carrier) {
        if (carrier == null) return [];
        return Object.keys(carrier);
    }
};
const $b40a30ea52f26f2c$export$f70f1d111fccf1c1 = {
    set (carrier, key, value) {
        if (carrier == null) return;
        carrier[key] = value;
    }
};

});

parcelRegister("cA9o0", function(module, exports) {
$parcel$export(module.exports, "getBaggage", () => $929020b6cbc5b4cf$export$f3bffa0b5dd10d1e);
$parcel$export(module.exports, "getActiveBaggage", () => $929020b6cbc5b4cf$export$120a1756099436ee);
$parcel$export(module.exports, "setBaggage", () => $929020b6cbc5b4cf$export$adc9ca19eab3f500);
$parcel$export(module.exports, "deleteBaggage", () => $929020b6cbc5b4cf$export$4ca3a8a743c9f633);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $2diR9 = parcelRequire("2diR9");

var $eRfZr = parcelRequire("eRfZr");
/**
 * Baggage key
 */ const $929020b6cbc5b4cf$var$BAGGAGE_KEY = (0, $eRfZr.createContextKey)('OpenTelemetry Baggage Key');
function $929020b6cbc5b4cf$export$f3bffa0b5dd10d1e(context) {
    return context.getValue($929020b6cbc5b4cf$var$BAGGAGE_KEY) || undefined;
}
function $929020b6cbc5b4cf$export$120a1756099436ee() {
    return $929020b6cbc5b4cf$export$f3bffa0b5dd10d1e((0, $2diR9.ContextAPI).getInstance().active());
}
function $929020b6cbc5b4cf$export$adc9ca19eab3f500(context, baggage) {
    return context.setValue($929020b6cbc5b4cf$var$BAGGAGE_KEY, baggage);
}
function $929020b6cbc5b4cf$export$4ca3a8a743c9f633(context) {
    return context.deleteValue($929020b6cbc5b4cf$var$BAGGAGE_KEY);
}

});

parcelRegister("t8Wdp", function(module, exports) {
$parcel$export(module.exports, "createBaggage", () => $0579a470ad4bf112$export$1034a425c7384452);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $jrQSC = parcelRequire("jrQSC");

var $fhJKz = parcelRequire("fhJKz");

var $eF0Kh = parcelRequire("eF0Kh");
const $0579a470ad4bf112$var$diag = (0, $jrQSC.DiagAPI).instance();
function $0579a470ad4bf112$export$1034a425c7384452(entries = {}) {
    return new (0, $fhJKz.BaggageImpl)(new Map(Object.entries(entries)));
}
function $0579a470ad4bf112$export$c491cedc1b2b6e9e(str) {
    if (typeof str !== 'string') {
        $0579a470ad4bf112$var$diag.error(`Cannot create baggage metadata from unknown type: ${typeof str}`);
        str = '';
    }
    return {
        __TYPE__: (0, $eF0Kh.baggageEntryMetadataSymbol),
        toString () {
            return str;
        }
    };
}

});
parcelRegister("fhJKz", function(module, exports) {
$parcel$export(module.exports, "BaggageImpl", () => $b20bee92636f869c$export$b8c511fa1a5f4987);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ class $b20bee92636f869c$export$b8c511fa1a5f4987 {
    constructor(entries){
        this._entries = entries ? new Map(entries) : new Map();
    }
    getEntry(key) {
        const entry = this._entries.get(key);
        if (!entry) return undefined;
        return Object.assign({}, entry);
    }
    getAllEntries() {
        return Array.from(this._entries.entries());
    }
    setEntry(key, entry) {
        const newBaggage = new $b20bee92636f869c$export$b8c511fa1a5f4987(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    }
    removeEntry(key) {
        const newBaggage = new $b20bee92636f869c$export$b8c511fa1a5f4987(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    }
    removeEntries(...keys) {
        const newBaggage = new $b20bee92636f869c$export$b8c511fa1a5f4987(this._entries);
        for (const key of keys)newBaggage._entries.delete(key);
        return newBaggage;
    }
    clear() {
        return new $b20bee92636f869c$export$b8c511fa1a5f4987();
    }
}

});

parcelRegister("eF0Kh", function(module, exports) {
$parcel$export(module.exports, "baggageEntryMetadataSymbol", () => $aac57914b00d0ee6$export$92dd2fe8ddb5cb7);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Symbol used to make BaggageEntryMetadata an opaque type
 */ const $aac57914b00d0ee6$export$92dd2fe8ddb5cb7 = Symbol('BaggageEntryMetadata');

});




parcelRegister("kdTCg", function(module, exports) {
$parcel$export(module.exports, "trace", () => $eb9029bd27575e7d$export$357889f174732d38);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $lfwn9 = parcelRequire("lfwn9");
const $eb9029bd27575e7d$export$357889f174732d38 = (0, $lfwn9.TraceAPI).getInstance();

});
parcelRegister("lfwn9", function(module, exports) {
$parcel$export(module.exports, "TraceAPI", () => $f7841c286a5b915c$export$2cccde6fcc7b568a);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $Qsdj6 = parcelRequire("Qsdj6");

var $2w7xz = parcelRequire("2w7xz");

var $c74b0 = parcelRequire("c74b0");

var $eCrPW = parcelRequire("eCrPW");

var $jrQSC = parcelRequire("jrQSC");
const $f7841c286a5b915c$var$API_NAME = 'trace';
class $f7841c286a5b915c$export$2cccde6fcc7b568a {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ constructor(){
        this._proxyTracerProvider = new (0, $2w7xz.ProxyTracerProvider)();
        this.wrapSpanContext = (0, $c74b0.wrapSpanContext);
        this.isSpanContextValid = (0, $c74b0.isSpanContextValid);
        this.deleteSpan = (0, $eCrPW.deleteSpan);
        this.getSpan = (0, $eCrPW.getSpan);
        this.getActiveSpan = (0, $eCrPW.getActiveSpan);
        this.getSpanContext = (0, $eCrPW.getSpanContext);
        this.setSpan = (0, $eCrPW.setSpan);
        this.setSpanContext = (0, $eCrPW.setSpanContext);
    }
    /** Get the singleton instance of the Trace API */ static getInstance() {
        if (!this._instance) this._instance = new $f7841c286a5b915c$export$2cccde6fcc7b568a();
        return this._instance;
    }
    /**
     * Set the current global tracer.
     *
     * @returns true if the tracer provider was successfully registered, else false
     */ setGlobalTracerProvider(provider) {
        const success = (0, $Qsdj6.registerGlobal)($f7841c286a5b915c$var$API_NAME, this._proxyTracerProvider, (0, $jrQSC.DiagAPI).instance());
        if (success) this._proxyTracerProvider.setDelegate(provider);
        return success;
    }
    /**
     * Returns the global tracer provider.
     */ getTracerProvider() {
        return (0, $Qsdj6.getGlobal)($f7841c286a5b915c$var$API_NAME) || this._proxyTracerProvider;
    }
    /**
     * Returns a tracer from the global tracer provider.
     */ getTracer(name, version) {
        return this.getTracerProvider().getTracer(name, version);
    }
    /** Remove the global tracer provider */ disable() {
        (0, $Qsdj6.unregisterGlobal)($f7841c286a5b915c$var$API_NAME, (0, $jrQSC.DiagAPI).instance());
        this._proxyTracerProvider = new (0, $2w7xz.ProxyTracerProvider)();
    }
}

});
parcelRegister("2w7xz", function(module, exports) {
$parcel$export(module.exports, "ProxyTracerProvider", () => $1d546b548604f09e$export$4137aabcb4254962);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $docVs = parcelRequire("docVs");

var $3M3lO = parcelRequire("3M3lO");
const $1d546b548604f09e$var$NOOP_TRACER_PROVIDER = new (0, $3M3lO.NoopTracerProvider)();
class $1d546b548604f09e$export$4137aabcb4254962 {
    /**
     * Get a {@link ProxyTracer}
     */ getTracer(name, version, options) {
        var _a;
        return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new (0, $docVs.ProxyTracer)(this, name, version, options);
    }
    getDelegate() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : $1d546b548604f09e$var$NOOP_TRACER_PROVIDER;
    }
    /**
     * Set the delegate tracer provider
     */ setDelegate(delegate) {
        this._delegate = delegate;
    }
    getDelegateTracer(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
    }
}

});
parcelRegister("docVs", function(module, exports) {
$parcel$export(module.exports, "ProxyTracer", () => $9bf78b0a46f39e37$export$df2c38268c6bb6b3);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $lg06C = parcelRequire("lg06C");
const $9bf78b0a46f39e37$var$NOOP_TRACER = new (0, $lg06C.NoopTracer)();
class $9bf78b0a46f39e37$export$df2c38268c6bb6b3 {
    constructor(provider, name, version, options){
        this._provider = provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    startSpan(name, options, context) {
        return this._getTracer().startSpan(name, options, context);
    }
    startActiveSpan(_name, _options, _context, _fn) {
        const tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    }
    /**
     * Try to get a tracer from the proxy tracer provider.
     * If the proxy tracer provider has no delegate, return a noop tracer.
     */ _getTracer() {
        if (this._delegate) return this._delegate;
        const tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) return $9bf78b0a46f39e37$var$NOOP_TRACER;
        this._delegate = tracer;
        return this._delegate;
    }
}

});
parcelRegister("lg06C", function(module, exports) {
$parcel$export(module.exports, "NoopTracer", () => $f79b2c9f0cf912b2$export$714c1036cabcd223);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $2diR9 = parcelRequire("2diR9");

var $eCrPW = parcelRequire("eCrPW");

var $4oHZ8 = parcelRequire("4oHZ8");

var $c74b0 = parcelRequire("c74b0");
const $f79b2c9f0cf912b2$var$contextApi = (0, $2diR9.ContextAPI).getInstance();
class $f79b2c9f0cf912b2$export$714c1036cabcd223 {
    // startSpan starts a noop span.
    startSpan(name, options, context = $f79b2c9f0cf912b2$var$contextApi.active()) {
        const root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) return new (0, $4oHZ8.NonRecordingSpan)();
        const parentFromContext = context && (0, $eCrPW.getSpanContext)(context);
        if ($f79b2c9f0cf912b2$var$isSpanContext(parentFromContext) && (0, $c74b0.isSpanContextValid)(parentFromContext)) return new (0, $4oHZ8.NonRecordingSpan)(parentFromContext);
        else return new (0, $4oHZ8.NonRecordingSpan)();
    }
    startActiveSpan(name, arg2, arg3, arg4) {
        let opts;
        let ctx;
        let fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        const parentContext = ctx !== null && ctx !== void 0 ? ctx : $f79b2c9f0cf912b2$var$contextApi.active();
        const span = this.startSpan(name, opts, parentContext);
        const contextWithSpanSet = (0, $eCrPW.setSpan)(parentContext, span);
        return $f79b2c9f0cf912b2$var$contextApi.with(contextWithSpanSet, fn, undefined, span);
    }
}
function $f79b2c9f0cf912b2$var$isSpanContext(spanContext) {
    return spanContext !== null && typeof spanContext === 'object' && 'spanId' in spanContext && typeof spanContext['spanId'] === 'string' && 'traceId' in spanContext && typeof spanContext['traceId'] === 'string' && 'traceFlags' in spanContext && typeof spanContext['traceFlags'] === 'number';
}

});
parcelRegister("eCrPW", function(module, exports) {
$parcel$export(module.exports, "getSpan", () => $aa4a3515ec554764$export$246e04ba06066af1);
$parcel$export(module.exports, "getActiveSpan", () => $aa4a3515ec554764$export$1be426a8e585c83e);
$parcel$export(module.exports, "setSpan", () => $aa4a3515ec554764$export$8ab2f2e6ee8ed0a8);
$parcel$export(module.exports, "deleteSpan", () => $aa4a3515ec554764$export$a6bbfe9a17f7941c);
$parcel$export(module.exports, "setSpanContext", () => $aa4a3515ec554764$export$c90bf5428c14cdb1);
$parcel$export(module.exports, "getSpanContext", () => $aa4a3515ec554764$export$1a635f8f0b912781);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $eRfZr = parcelRequire("eRfZr");

var $4oHZ8 = parcelRequire("4oHZ8");

var $2diR9 = parcelRequire("2diR9");
/**
 * span key
 */ const $aa4a3515ec554764$var$SPAN_KEY = (0, $eRfZr.createContextKey)('OpenTelemetry Context Key SPAN');
function $aa4a3515ec554764$export$246e04ba06066af1(context) {
    return context.getValue($aa4a3515ec554764$var$SPAN_KEY) || undefined;
}
function $aa4a3515ec554764$export$1be426a8e585c83e() {
    return $aa4a3515ec554764$export$246e04ba06066af1((0, $2diR9.ContextAPI).getInstance().active());
}
function $aa4a3515ec554764$export$8ab2f2e6ee8ed0a8(context, span) {
    return context.setValue($aa4a3515ec554764$var$SPAN_KEY, span);
}
function $aa4a3515ec554764$export$a6bbfe9a17f7941c(context) {
    return context.deleteValue($aa4a3515ec554764$var$SPAN_KEY);
}
function $aa4a3515ec554764$export$c90bf5428c14cdb1(context, spanContext) {
    return $aa4a3515ec554764$export$8ab2f2e6ee8ed0a8(context, new (0, $4oHZ8.NonRecordingSpan)(spanContext));
}
function $aa4a3515ec554764$export$1a635f8f0b912781(context) {
    var _a;
    return (_a = $aa4a3515ec554764$export$246e04ba06066af1(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}

});
parcelRegister("4oHZ8", function(module, exports) {
$parcel$export(module.exports, "NonRecordingSpan", () => $333b85cebaab1512$export$972d28f7c6a8c6c7);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $kcKXu = parcelRequire("kcKXu");
class $333b85cebaab1512$export$972d28f7c6a8c6c7 {
    constructor(spanContext = (0, $kcKXu.INVALID_SPAN_CONTEXT)){
        this._spanContext = spanContext;
    }
    // Returns a SpanContext.
    spanContext() {
        return this._spanContext;
    }
    // By default does nothing
    setAttribute(_key, _value) {
        return this;
    }
    // By default does nothing
    setAttributes(_attributes) {
        return this;
    }
    // By default does nothing
    addEvent(_name, _attributes) {
        return this;
    }
    addLink(_link) {
        return this;
    }
    addLinks(_links) {
        return this;
    }
    // By default does nothing
    setStatus(_status) {
        return this;
    }
    // By default does nothing
    updateName(_name) {
        return this;
    }
    // By default does nothing
    end(_endTime) {}
    // isRecording always returns false for NonRecordingSpan.
    isRecording() {
        return false;
    }
    // By default does nothing
    recordException(_exception, _time) {}
}

});
parcelRegister("kcKXu", function(module, exports) {
$parcel$export(module.exports, "INVALID_SPANID", () => $eb595a9dc89fd35a$export$55cc39fb0d4bb4c0);
$parcel$export(module.exports, "INVALID_TRACEID", () => $eb595a9dc89fd35a$export$22be96e88d95e128);
$parcel$export(module.exports, "INVALID_SPAN_CONTEXT", () => $eb595a9dc89fd35a$export$8591e4c852b66703);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $h7rc9 = parcelRequire("h7rc9");
const $eb595a9dc89fd35a$export$55cc39fb0d4bb4c0 = '0000000000000000';
const $eb595a9dc89fd35a$export$22be96e88d95e128 = '00000000000000000000000000000000';
const $eb595a9dc89fd35a$export$8591e4c852b66703 = {
    traceId: $eb595a9dc89fd35a$export$22be96e88d95e128,
    spanId: $eb595a9dc89fd35a$export$55cc39fb0d4bb4c0,
    traceFlags: (0, $h7rc9.TraceFlags).NONE
};

});
parcelRegister("h7rc9", function(module, exports) {
$parcel$export(module.exports, "TraceFlags", () => $c7682f78e3e26135$export$bf9049ad2b0883ff);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @since 1.0.0
 */ var $c7682f78e3e26135$export$bf9049ad2b0883ff;
(function(TraceFlags) {
    /** Represents no flag set. */ TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
    /** Bit to represent whether trace is sampled in trace flags. */ TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})($c7682f78e3e26135$export$bf9049ad2b0883ff || ($c7682f78e3e26135$export$bf9049ad2b0883ff = {}));

});




parcelRegister("c74b0", function(module, exports) {
$parcel$export(module.exports, "isSpanContextValid", () => $8d1960dcddc2ec2a$export$e4373b9a2c09216c);
$parcel$export(module.exports, "wrapSpanContext", () => $8d1960dcddc2ec2a$export$c19cc0f1911bdb85);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $kcKXu = parcelRequire("kcKXu");

var $4oHZ8 = parcelRequire("4oHZ8");
// Valid characters (0-9, a-f, A-F) are marked as 1.
const $8d1960dcddc2ec2a$var$isHex = new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1
]);
function $8d1960dcddc2ec2a$var$isValidHex(id, length) {
    // As of 1.9.0 the id was allowed to be a non-string value,
    // even though it was not possible in the types.
    if (typeof id !== 'string' || id.length !== length) return false;
    let r = 0;
    for(let i = 0; i < id.length; i += 4)r += ($8d1960dcddc2ec2a$var$isHex[id.charCodeAt(i)] | 0) + ($8d1960dcddc2ec2a$var$isHex[id.charCodeAt(i + 1)] | 0) + ($8d1960dcddc2ec2a$var$isHex[id.charCodeAt(i + 2)] | 0) + ($8d1960dcddc2ec2a$var$isHex[id.charCodeAt(i + 3)] | 0);
    return r === length;
}
function $8d1960dcddc2ec2a$export$29dd34cf1269f6da(traceId) {
    return $8d1960dcddc2ec2a$var$isValidHex(traceId, 32) && traceId !== (0, $kcKXu.INVALID_TRACEID);
}
function $8d1960dcddc2ec2a$export$8e51c6d8f0586aff(spanId) {
    return $8d1960dcddc2ec2a$var$isValidHex(spanId, 16) && spanId !== (0, $kcKXu.INVALID_SPANID);
}
function $8d1960dcddc2ec2a$export$e4373b9a2c09216c(spanContext) {
    return $8d1960dcddc2ec2a$export$29dd34cf1269f6da(spanContext.traceId) && $8d1960dcddc2ec2a$export$8e51c6d8f0586aff(spanContext.spanId);
}
function $8d1960dcddc2ec2a$export$c19cc0f1911bdb85(spanContext) {
    return new (0, $4oHZ8.NonRecordingSpan)(spanContext);
}

});



parcelRegister("3M3lO", function(module, exports) {
$parcel$export(module.exports, "NoopTracerProvider", () => $2bf8742d11858935$export$87d8e93756f9e86e);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $lg06C = parcelRequire("lg06C");
class $2bf8742d11858935$export$87d8e93756f9e86e {
    getTracer(_name, _version, _options) {
        return new (0, $lg06C.NoopTracer)();
    }
}

});





parcelRegister("2oi3V", function(module, exports) {
$parcel$export(module.exports, "experienceTypeKey", () => $1bdbd57bc0aa644c$export$1069c2293742749e);

var $eRfZr = parcelRequire("eRfZr");
var $1bdbd57bc0aa644c$export$1069c2293742749e = (0, $eRfZr.createContextKey)('type');

});

parcelRegister("k0Cxu", function(module, exports) {
$parcel$export(module.exports, "spanIdKey", () => $e911b3d36c60bff5$export$ccdc89d1d45284c2);

var $eRfZr = parcelRequire("eRfZr");
var $e911b3d36c60bff5$export$ccdc89d1d45284c2 = (0, $eRfZr.createContextKey)('spanId');

});

parcelRegister("5Y1AV", function(module, exports) {
$parcel$export(module.exports, "state", () => $4583cafcbb6a1c40$export$ca000e230c0caa3e);
var $4583cafcbb6a1c40$export$ca000e230c0caa3e = {
    context: null
};

});

parcelRegister("dZ6Fb", function(module, exports) {
$parcel$export(module.exports, "traceIdKey", () => $a2e6240c3b8ab82d$export$65f3d43d675bb81b);

var $eRfZr = parcelRequire("eRfZr");
var $a2e6240c3b8ab82d$export$65f3d43d675bb81b = (0, $eRfZr.createContextKey)('traceId');

});


parcelRegister("iGolp", function(module, exports) {
$parcel$export(module.exports, "PreviousInteractionLog", () => $d99f08815d91a46e$export$dbba6cdedab4e68b);
$parcel$export(module.exports, "postInteractionLog", () => $d99f08815d91a46e$export$d8f52e8f804021e8);
$parcel$export(module.exports, "segmentUnmountCache", () => $d99f08815d91a46e$export$a2b14406ded37d60);
$parcel$export(module.exports, "getActiveInteraction", () => $d99f08815d91a46e$export$2b3954d2e8509985);
$parcel$export(module.exports, "updatePageLoadInteractionName", () => $d99f08815d91a46e$export$f6f1cf5bedf83c71);
$parcel$export(module.exports, "addCustomData", () => $d99f08815d91a46e$export$e4380431c2bdabee);
$parcel$export(module.exports, "addCustomTiming", () => $d99f08815d91a46e$export$27cacb7d7f3fe20a);
$parcel$export(module.exports, "addMark", () => $d99f08815d91a46e$export$728e28c22a0fba4);
$parcel$export(module.exports, "addSpan", () => $d99f08815d91a46e$export$2c1d6e17cfa9bbc7);
$parcel$export(module.exports, "addHold", () => $d99f08815d91a46e$export$7606887303596f82);
$parcel$export(module.exports, "addHoldByID", () => $d99f08815d91a46e$export$10582acd678c213);
$parcel$export(module.exports, "removeHoldByID", () => $d99f08815d91a46e$export$4983dfbbb996f7ae);
$parcel$export(module.exports, "addProfilerTimings", () => $d99f08815d91a46e$export$53d6f611de951a13);
$parcel$export(module.exports, "sinkInteractionHandler", () => $d99f08815d91a46e$export$9e614a29a1ac213e);
$parcel$export(module.exports, "sinkPostInteractionLogHandler", () => $d99f08815d91a46e$export$8a1ba7bef607358a);
$parcel$export(module.exports, "tryComplete", () => $d99f08815d91a46e$export$673be905888f8839);
$parcel$export(module.exports, "abort", () => $d99f08815d91a46e$export$5def58af4fd46132);
$parcel$export(module.exports, "abortByNewInteraction", () => $d99f08815d91a46e$export$c4a545284f55edf2);
$parcel$export(module.exports, "abortAll", () => $d99f08815d91a46e$export$614a7af2affc5dff);
$parcel$export(module.exports, "addNewInteraction", () => $d99f08815d91a46e$export$1a1ed1e1fdb2006b);
$parcel$export(module.exports, "addApdex", () => $d99f08815d91a46e$export$35220fd6cdd1b731);
$parcel$export(module.exports, "addRequestInfo", () => $d99f08815d91a46e$export$57d55b4569823d8f);
$parcel$export(module.exports, "addSegment", () => $d99f08815d91a46e$export$1c43f9ac826b6462);
$parcel$export(module.exports, "removeSegment", () => $d99f08815d91a46e$export$d0365e48b58231c3);
$parcel$export(module.exports, "interactionSpans", () => $d99f08815d91a46e$export$6ce04c7ca6810a7e);

var $fL8KA = parcelRequire("fL8KA");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $fC8ib = parcelRequire("fC8ib");

var $6HG4S = parcelRequire("6HG4S");

var $6JfQX = parcelRequire("6JfQX");

var $4iVTn = parcelRequire("4iVTn");

var $hdYpx = parcelRequire("hdYpx");

var $DtLwq = parcelRequire("DtLwq");

var $bPZgx = parcelRequire("bPZgx");

var $ly5tH = parcelRequire("ly5tH");

var $58ED5 = parcelRequire("58ED5");

var $dRzaM = parcelRequire("dRzaM");

var $8qy01 = parcelRequire("8qy01");

var $1MHAJ = parcelRequire("1MHAJ");

var $bDCbL = parcelRequire("bDCbL");

var $4hV16 = parcelRequire("4hV16");

var $hkc2F = parcelRequire("hkc2F");

var $aNUZN = parcelRequire("aNUZN");

var $78Mn6 = parcelRequire("78Mn6");
function $d99f08815d91a46e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d99f08815d91a46e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d99f08815d91a46e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d99f08815d91a46e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d99f08815d91a46e$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $d99f08815d91a46e$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $d99f08815d91a46e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $d99f08815d91a46e$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $d99f08815d91a46e$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $d99f08815d91a46e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $d99f08815d91a46e$export$dbba6cdedab4e68b = {
    id: undefined,
    name: undefined,
    type: undefined,
    isAborted: undefined,
    timestamp: undefined
};
var $d99f08815d91a46e$export$d8f52e8f804021e8 = new (0, $78Mn6.default)();
var $d99f08815d91a46e$var$interactionQueue = [];
var $d99f08815d91a46e$var$segmentCache = new Map();
var $d99f08815d91a46e$export$a2b14406ded37d60 = new Map(); // Temporarily store segment unmount counts
var $d99f08815d91a46e$var$segmentObservers = [];
function $d99f08815d91a46e$export$2b3954d2e8509985() {
    var interactionId = (0, $1MHAJ.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $aNUZN.interactions).get(interactionId.current);
}
function $d99f08815d91a46e$var$isPerformanceTracingEnabled() {
    var _getConfig;
    return ((_getConfig = (0, $DtLwq.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.enableAdditionalPerformanceMarks) || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
var $d99f08815d91a46e$var$performanceEventObserver;
var $d99f08815d91a46e$export$17afbba0f16b4b19 = function getPerformanceObserver() {
    $d99f08815d91a46e$var$performanceEventObserver = $d99f08815d91a46e$var$performanceEventObserver || new PerformanceObserver(function(entries) {
        var list = entries.getEntries();
        var _iterator = $d99f08815d91a46e$var$_createForOfIteratorHelper(list), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var entry = _step.value;
                if (entry.name === 'click') $d99f08815d91a46e$export$e6be05b411ce21a6(entry);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    });
    return $d99f08815d91a46e$var$performanceEventObserver;
};
var $d99f08815d91a46e$export$e6be05b411ce21a6 = function setInteractionPerformanceEvent(entry) {
    var interaction = $d99f08815d91a46e$export$2b3954d2e8509985();
    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') {
        var responsiveness = interaction.responsiveness || {};
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already
        // been set up
        responsiveness.experimentalInputToNextPaint = responsiveness.experimentalInputToNextPaint || entry.duration;
        responsiveness.inputDelay = responsiveness.experimentalInputToNextPaint || entry.processingStart - entry.startTime;
        interaction.responsiveness = responsiveness;
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        if (entry.startTime < interaction.start) interaction.start = entry.startTime;
    }
};
function $d99f08815d91a46e$var$labelStackToString(labelStack, name) {
    var _stack$map;
    var stack = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(labelStack !== null && labelStack !== void 0 ? labelStack : []);
    if (name) stack.push({
        name: name
    });
    return (_stack$map = stack.map(function(l) {
        return l.name;
    })) === null || _stack$map === void 0 ? void 0 : _stack$map.join('/');
}
function $d99f08815d91a46e$var$labelStackToIdString(labelStack) {
    var _labelStack$map;
    return labelStack === null || labelStack === void 0 || (_labelStack$map = labelStack.map(function(l) {
        return 'segmentId' in l ? "".concat(l.name, ":").concat(l.segmentId) : "".concat(l.name);
    })) === null || _labelStack$map === void 0 ? void 0 : _labelStack$map.join('/');
}
function $d99f08815d91a46e$var$addSegmentObserver(observer) {
    $d99f08815d91a46e$var$segmentObservers.push(observer);
    var _iterator2 = $d99f08815d91a46e$var$_createForOfIteratorHelper($d99f08815d91a46e$var$segmentCache.values()), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var segmentInfo = _step2.value;
            observer.onAdd(segmentInfo);
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $d99f08815d91a46e$var$removeSegmentObserver(observer) {
    var index = $d99f08815d91a46e$var$segmentObservers.findIndex(function(obs) {
        return obs === observer;
    });
    if (index !== -1) $d99f08815d91a46e$var$segmentObservers.splice(index, 1);
}
function $d99f08815d91a46e$export$cd7f480d6b8286c3(interactionId) {
    (0, $aNUZN.interactions).delete(interactionId);
}
function $d99f08815d91a46e$export$f6f1cf5bedf83c71(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    var interaction = $d99f08815d91a46e$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $d99f08815d91a46e$export$12f2b6cb85d59904(interactionId, data) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(key) {
        interaction.metaData[key] = data[key];
    });
}
function $d99f08815d91a46e$export$e4380431c2bdabee(interactionId, labelStack, data) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(i) {
        interaction.customData.push({
            labelStack: labelStack,
            data: (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, i, data[i])
        });
    });
}
function $d99f08815d91a46e$export$9bfdf89f35702b2e(interactionId, segmentId, data) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) {
        var _interaction$excluded;
        ((_interaction$excluded = interaction.excluded3pSegmentData) !== null && _interaction$excluded !== void 0 ? _interaction$excluded : interaction.excluded3pSegmentData = {})[segmentId] = $d99f08815d91a46e$var$_objectSpread($d99f08815d91a46e$var$_objectSpread({
            segmentId: segmentId
        }, interaction.excluded3pSegmentData[segmentId]), data);
    }
}
function $d99f08815d91a46e$export$35723c3772fda7dd(interactionId, segmentId, data) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) {
        if (!interaction.segmentExtraData) interaction.segmentExtraData = {};
        interaction.segmentExtraData[segmentId] = $d99f08815d91a46e$var$_objectSpread($d99f08815d91a46e$var$_objectSpread({}, interaction.segmentExtraData[segmentId]), data);
    }
}
/**
 * Builds a stable cross-segment dedup key for a segment3pTimings entry.
 *
 * For `resource-timing`, query-stripped backend labels + timing fields identify a request without
 * depending on query parameters. Shared CSS/JS asset timings dedupe across segments, but backend
 * fetch/XHR entries are scoped by `segmentId` because each iframe can make its own backend request
 * to the same URL.
 *
 * For all other labels the data objects are small (a handful of fields), so we use a full
 * JSON fingerprint which is cheap and collision-free.
 */ function $d99f08815d91a46e$var$buildCrossSegmentDedupKey(entry, segmentId) {
    if (entry.label === 'resource-timing') {
        var _ref = entry.data, resourceLabel = _ref.label, startTime = _ref.startTime, duration = _ref.duration, requestStart = _ref.requestStart, fetchStart = _ref.fetchStart, ttfb = _ref.ttfb, type = _ref.type;
        if ((0, $bDCbL.BACKEND_RESOURCE_TIMING_INITIATOR_TYPES).has(String(type))) // Backend calls are separate requests per segment; include extra timings and segment scope.
        return "resource-timing|".concat(resourceLabel, "|").concat(startTime, "|").concat(duration, "|").concat(fetchStart, "|").concat(requestStart, "|").concat(ttfb, "|").concat(segmentId);
        // Shared CSS/JS assets keep the original B3 key so they can dedupe across segments.
        return "resource-timing|".concat(resourceLabel, "|").concat(startTime, "|").concat(duration);
    }
    return "".concat(entry.label, "|").concat(JSON.stringify(entry.data));
}
function $d99f08815d91a46e$export$c227d812a1e08d80(interactionId, segmentId, entry) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) {
        // B3: dedup by content — drops identical entries within and across iframes.
        // Abort markers are excluded so every segment's abort is recorded.
        if (entry.label !== 'segment-timing-abort') {
            if (!interaction.segment3pCrossSegmentSeen) interaction.segment3pCrossSegmentSeen = new Set();
            var key = $d99f08815d91a46e$var$buildCrossSegmentDedupKey(entry, segmentId);
            if (interaction.segment3pCrossSegmentSeen.has(key)) return;
            interaction.segment3pCrossSegmentSeen.add(key);
        }
        if (!interaction.segment3pTimings) interaction.segment3pTimings = {};
        if (!interaction.segment3pTimings[segmentId]) interaction.segment3pTimings[segmentId] = [];
        interaction.segment3pTimings[segmentId].push(entry);
    }
}
function $d99f08815d91a46e$export$20265b12c6625451(interactionId, key, value) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction == null) return;
    // Allow null and undefined values
    if (value === null || value === undefined) {
        interaction.cohortingCustomData.set(key, value);
        return;
    }
    // Validate that the value is a primitive (number, boolean, or string)
    if (typeof value !== 'number' && typeof value !== 'boolean' && typeof value !== 'string') return;
    // Validate string length (max 50 characters)
    if (typeof value === 'string' && value.length > 50) return;
    interaction.cohortingCustomData.set(key, value);
}
function $d99f08815d91a46e$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) {
        var sanitizedData = Object.fromEntries(Object.entries(data).map(function(_ref2) {
            var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 2), key = _ref3[0], timingData = _ref3[1];
            return [
                (0, $hdYpx.sanitizeTimingName)(key),
                timingData
            ];
        }));
        interaction.customTimings.push({
            labelStack: labelStack,
            data: sanitizedData
        });
        if ($d99f08815d91a46e$var$isPerformanceTracingEnabled()) for(var _i = 0, _Object$entries = Object.entries(sanitizedData); _i < _Object$entries.length; _i++){
            var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], timingData = _Object$entries$_i[1];
            var startTime = timingData.startTime, endTime = timingData.endTime;
            try {
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat($d99f08815d91a46e$var$labelStackToString(labelStack, key), " [custom_timing]"), {
                    start: startTime,
                    end: endTime,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary-light'
                        }
                    }
                });
            } catch (_unused) {
            // do nothing
            }
        }
    }
}
function $d99f08815d91a46e$export$728e28c22a0fba4(interactionId, type, name, labelStack) {
    var time = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($d99f08815d91a46e$var$isPerformanceTracingEnabled()) performance.mark("\uD83D\uDEF8 ".concat($d99f08815d91a46e$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
        startTime: time
    });
}
function $d99f08815d91a46e$export$85d1eb835f669bf(_interactionId, _labelStack, _time) {}
function $d99f08815d91a46e$export$c4b23cc624bd2fb(type, name, labelStack) {
    var time = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : performance.now();
    (0, $aNUZN.interactions).forEach(function(interaction) {
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($d99f08815d91a46e$var$isPerformanceTracingEnabled()) performance.mark("\uD83D\uDEF8 ".concat($d99f08815d91a46e$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
        startTime: time
    });
}
function $d99f08815d91a46e$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start) {
    var end = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : performance.now();
    var size = arguments.length > 6 ? arguments[6] : undefined;
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($d99f08815d91a46e$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat($d99f08815d91a46e$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary'
                    }
                }
            });
        } catch (_unused2) {
        // do nothing
        }
    }
}
function $d99f08815d91a46e$export$943a8b2b5d6b1809(type, name, labelStack, start) {
    var end = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var size = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    (0, $aNUZN.interactions).forEach(function(interaction) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($d99f08815d91a46e$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat($d99f08815d91a46e$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
            start: start,
            end: end,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary'
                }
            }
        });
    } catch (_unused3) {
    // do nothing
    }
}
function $d99f08815d91a46e$export$9e04fe1a58571ec(moduleId, timestamp) {
    $d99f08815d91a46e$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
}
function $d99f08815d91a46e$export$6f228d1fdc911d7(identifier, start, end) {
    $d99f08815d91a46e$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
}
var $d99f08815d91a46e$var$moduleLoadingRequests = {};
function $d99f08815d91a46e$export$f5a8f10de74904da(input) {
    var result = input !== null && input !== void 0 ? input : '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function $d99f08815d91a46e$var$addHoldCriterion(id, labelStack, name, startTime) {
    var _window$__CRITERION__;
    if (!((_window$__CRITERION__ = window.__CRITERION__) !== null && _window$__CRITERION__ !== void 0 && _window$__CRITERION__.addUFOHold)) return;
    window.__CRITERION__.addUFOHold(id, $d99f08815d91a46e$var$labelStackToString(labelStack), name, startTime);
}
function $d99f08815d91a46e$var$removeHoldCriterion(id) {
    var _window$__CRITERION__2;
    if (!((_window$__CRITERION__2 = window.__CRITERION__) !== null && _window$__CRITERION__2 !== void 0 && _window$__CRITERION__2.removeUFOHold)) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $d99f08815d91a46e$export$7606887303596f82(interactionId, labelStack, name, _experimental, holdStartedAt) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    var id = (0, $6JfQX.default)();
    if (!interaction) // add hold timestamp to post interaction log if interaction is complete
    $d99f08815d91a46e$export$d8f52e8f804021e8.addHoldInfo(labelStack, name, holdStartedAt !== null && holdStartedAt !== void 0 ? holdStartedAt : performance.now());
    if (interaction != null) {
        var start = holdStartedAt !== null && holdStartedAt !== void 0 ? holdStartedAt : performance.now();
        var holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        if ($d99f08815d91a46e$var$shouldMoveHoldToExtendedBucket(interaction, holdActive)) $d99f08815d91a46e$var$ensureExtendedHoldActive(interaction).set(id, $d99f08815d91a46e$var$_objectSpread($d99f08815d91a46e$var$_objectSpread({}, holdActive), {}, {
            start: start
        }));
        else {
            interaction.holdActive.set(id, $d99f08815d91a46e$var$_objectSpread($d99f08815d91a46e$var$_objectSpread({}, holdActive), {}, {
                start: start
            }));
            $d99f08815d91a46e$var$addHoldCriterion(id, labelStack, name, start);
        }
        return function() {
            var end = performance.now();
            if ($d99f08815d91a46e$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat($d99f08815d91a46e$var$labelStackToString(labelStack, name), " [hold]"), {
                    start: start,
                    end: end,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'secondary-light'
                        }
                    }
                });
            } catch (_unused4) {
            // do nothing
            }
            $d99f08815d91a46e$var$removeHoldCriterion(id);
            var currentInteraction = (0, $aNUZN.interactions).get(interactionId);
            var currentHold = interaction.holdActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push($d99f08815d91a46e$var$_objectSpread($d99f08815d91a46e$var$_objectSpread({}, currentHold), {}, {
                        end: end
                    }));
                    interaction.holdActive.delete(id);
                }
                if (interaction.hold3pActive) {
                    var current3pHold = interaction.hold3pActive.get(id);
                    if (current3pHold != null) {
                        $d99f08815d91a46e$var$recordMetricVariantCategoryEnd(currentInteraction, current3pHold.labelStack, end);
                        if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                        currentInteraction.hold3pInfo.push($d99f08815d91a46e$var$_objectSpread($d99f08815d91a46e$var$_objectSpread({}, current3pHold), {}, {
                            end: end
                        }));
                        interaction.hold3pActive.delete(id);
                    }
                }
            }
        };
    }
    return function() {};
}
function $d99f08815d91a46e$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) {
        var start = performance.now();
        var holdActive = {
            labelStack: labelStack,
            name: name,
            start: start,
            ignoreOnSubmit: ignoreOnSubmit
        };
        if ($d99f08815d91a46e$var$shouldMoveHoldToExtendedBucket(interaction, holdActive)) $d99f08815d91a46e$var$ensureExtendedHoldActive(interaction).set(id, holdActive);
        else {
            interaction.holdActive.set(id, holdActive);
            $d99f08815d91a46e$var$addHoldCriterion(id, labelStack, name, start);
        }
    }
    return function() {};
}
function $d99f08815d91a46e$export$d6cf9650acfb0dab(interactionId, labelStack, name, start, end) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) {
        // `recordMetricVariantCategoryEnd` skips excluded (background-script) holds, so the completed
        // hold is retained in `hold3pInfo` for observability but never contributes a third-party
        // category end.
        $d99f08815d91a46e$var$recordMetricVariantCategoryEnd(interaction, labelStack, end);
        $d99f08815d91a46e$var$ensureExtendedHoldInfo(interaction).push({
            labelStack: labelStack,
            name: name,
            start: start,
            end: end
        });
    }
}
function $d99f08815d91a46e$export$4983dfbbb996f7ae(interactionId, id) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) {
        var end = performance.now();
        var currentInteraction = (0, $aNUZN.interactions).get(interactionId);
        var currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            if ($d99f08815d91a46e$var$shouldMoveHoldToExtendedBucket(currentInteraction, currentHold)) $d99f08815d91a46e$var$ensureExtendedHoldInfo(currentInteraction).push($d99f08815d91a46e$var$_objectSpread($d99f08815d91a46e$var$_objectSpread({}, currentHold), {}, {
                end: end
            }));
            else currentInteraction.holdInfo.push($d99f08815d91a46e$var$_objectSpread($d99f08815d91a46e$var$_objectSpread({}, currentHold), {}, {
                end: end
            }));
            interaction.holdActive.delete(id);
            $d99f08815d91a46e$var$removeHoldCriterion(id);
        }
        if (interaction.hold3pActive) {
            var current3pHold = interaction.hold3pActive.get(id);
            if (currentInteraction != null && current3pHold != null) {
                $d99f08815d91a46e$var$recordMetricVariantCategoryEnd(currentInteraction, current3pHold.labelStack, end);
                if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                currentInteraction.hold3pInfo.push($d99f08815d91a46e$var$_objectSpread($d99f08815d91a46e$var$_objectSpread({}, current3pHold), {}, {
                    end: end
                }));
                interaction.hold3pActive.delete(id);
            }
        }
    }
}
function $d99f08815d91a46e$export$2df109852219d16e(interactionId) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
function $d99f08815d91a46e$export$b1ce94abc72c69d7(interactionId, info) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction == null) return function() {};
    var preloadRow = {
        source: info.source,
        preloadStartedAt: info.preloadStartedAt,
        adoptedAt: info.adoptedAt
    };
    interaction.preloadInfo.push(preloadRow);
    var releaseHold = $d99f08815d91a46e$export$7606887303596f82(interactionId, [], "preload:".concat(info.source), false, interaction.start);
    var released = false;
    return function() {
        if (released) return;
        released = true;
        preloadRow.settledAt = performance.now();
        releaseHold();
    };
}
function $d99f08815d91a46e$export$43f87b52eb8fc449(args) {
    var interaction = $d99f08815d91a46e$export$2b3954d2e8509985();
    if (interaction == null || interaction.ufoName !== args.experienceKey || args.preloadKey !== undefined && interaction.preloadKey !== undefined && interaction.preloadKey !== args.preloadKey) return null;
    return $d99f08815d91a46e$export$b1ce94abc72c69d7(interaction.id, {
        source: args.source,
        preloadStartedAt: args.preloadStartedAt,
        adoptedAt: args.adoptedAt
    });
}
var $d99f08815d91a46e$var$onInteractionStartForPreloadHolds = null;
function $d99f08815d91a46e$export$e96f751b1e82abda(hook) {
    $d99f08815d91a46e$var$onInteractionStartForPreloadHolds = hook;
}
var $d99f08815d91a46e$export$9591b52b33ccc510 = {
    onPreload: function onPreload(moduleId, _priority) {
        $d99f08815d91a46e$export$9e04fe1a58571ec($d99f08815d91a46e$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart: function onLoadStart(info) {
        var timeoutId = setTimeout(function() {
            delete $d99f08815d91a46e$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        var request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $d99f08815d91a46e$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete: function onLoadComplete(info) {
        var request = $d99f08815d91a46e$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $d99f08815d91a46e$var$moduleLoadingRequests[info.identifier];
            $d99f08815d91a46e$export$6f228d1fdc911d7($d99f08815d91a46e$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted: function placeholderFallBackMounted(id, moduleId) {
        var interactionId = (0, $1MHAJ.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $d99f08815d91a46e$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted: function placeholderFallBackUnmounted(id) {
        var interactionId = (0, $1MHAJ.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $d99f08815d91a46e$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $d99f08815d91a46e$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError, errorHash, errorStatusCode) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError,
        errorHash: errorHash,
        errorStatusCode: errorStatusCode
    });
}
function $d99f08815d91a46e$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack, errorHash, errorStatusCode) {
    (0, $aNUZN.interactions).forEach(function(interaction) {
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack,
            errorHash: errorHash,
            errorStatusCode: errorStatusCode
        });
    });
}
function $d99f08815d91a46e$export$53d6f611de951a13(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    var _getConfig2;
    if ($d99f08815d91a46e$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat($d99f08815d91a46e$var$labelStackToString(labelStack), " [react-profiler] ").concat(type), {
            start: startTime,
            duration: actualDuration,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary-dark'
                }
            }
        });
    } catch (_unused5) {
    // do nothing
    }
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((_getConfig2 = (0, $DtLwq.getConfig)()) !== null && _getConfig2 !== void 0 && (_getConfig2 = _getConfig2.postInteractionLog) !== null && _getConfig2 !== void 0 && _getConfig2.enabled) $d99f08815d91a46e$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
}
function $d99f08815d91a46e$var$pushToQueue(id, data) {
    $d99f08815d91a46e$var$interactionQueue.push({
        id: id,
        data: data
    });
}
var $d99f08815d91a46e$var$handleInteraction = $d99f08815d91a46e$var$pushToQueue;
var $d99f08815d91a46e$var$isKnownMetricVariantCategory = function isKnownMetricVariantCategory(type) {
    return type === 'third-party' || type === 'gen-ai';
};
var $d99f08815d91a46e$var$hasMetricVariantCategory = function hasMetricVariantCategory(labelStack, category) {
    var _labelStack$some;
    return (_labelStack$some = labelStack === null || labelStack === void 0 ? void 0 : labelStack.some(function(label) {
        return 'type' in label && label.type === category;
    })) !== null && _labelStack$some !== void 0 ? _labelStack$some : false;
};
var $d99f08815d91a46e$var$hasAnyMetricVariantCategory = function hasAnyMetricVariantCategory(labelStack) {
    var _labelStack$some2;
    return (_labelStack$some2 = labelStack === null || labelStack === void 0 ? void 0 : labelStack.some(function(label) {
        return 'type' in label && $d99f08815d91a46e$var$isKnownMetricVariantCategory(label.type);
    })) !== null && _labelStack$some2 !== void 0 ? _labelStack$some2 : false;
};
/**
 * A hold is fully excluded from every metric window (standard and include-third-party) and from
 * completion gating iff its labelStack contains a single label that is BOTH `type: 'third-party'`
 * AND `excludeFromMetrics: true`. Requiring both on the same label guarantees exclusion can only
 * ever apply to third-party work, never first-party. Such holds are dropped at creation time, so
 * they never enter `holdActive`/`hold3pActive`, never block completion.
 */ var $d99f08815d91a46e$var$isExcludedThirdPartyHold = function isExcludedThirdPartyHold(labelStack) {
    var _labelStack$some3;
    return (_labelStack$some3 = labelStack === null || labelStack === void 0 ? void 0 : labelStack.some(function(label) {
        return 'type' in label && label.type === 'third-party' && 'excludeFromMetrics' in label && label.excludeFromMetrics === true;
    })) !== null && _labelStack$some3 !== void 0 ? _labelStack$some3 : false;
};
var $d99f08815d91a46e$var$getMetricVariantCategories = function getMetricVariantCategories(labelStack) {
    var categories = new Set();
    labelStack === null || labelStack === void 0 || labelStack.forEach(function(label) {
        if ('type' in label && $d99f08815d91a46e$var$isKnownMetricVariantCategory(label.type)) categories.add(label.type);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(categories);
};
var $d99f08815d91a46e$var$hasMetricVariantCategoryInHoldData = function hasMetricVariantCategoryInHoldData(interaction, category) {
    var _interaction$holdActi, _interaction$hold3pIn, _interaction$hold3pAc, _interaction$hold3pAc2;
    return interaction.holdInfo.some(function(hold) {
        return $d99f08815d91a46e$var$hasMetricVariantCategory(hold.labelStack, category);
    }) || (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((_interaction$holdActi = interaction.holdActive.values()) !== null && _interaction$holdActi !== void 0 ? _interaction$holdActi : []).some(function(hold) {
        return $d99f08815d91a46e$var$hasMetricVariantCategory(hold.labelStack, category);
    }) || (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((_interaction$hold3pIn = interaction.hold3pInfo) !== null && _interaction$hold3pIn !== void 0 ? _interaction$hold3pIn : []).some(function(hold) {
        return $d99f08815d91a46e$var$hasMetricVariantCategory(hold.labelStack, category);
    }) || (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((_interaction$hold3pAc = (_interaction$hold3pAc2 = interaction.hold3pActive) === null || _interaction$hold3pAc2 === void 0 ? void 0 : _interaction$hold3pAc2.values()) !== null && _interaction$hold3pAc !== void 0 ? _interaction$hold3pAc : []).some(function(hold) {
        return $d99f08815d91a46e$var$hasMetricVariantCategory(hold.labelStack, category);
    });
};
var $d99f08815d91a46e$var$recordMetricVariantCategoryEnd = function recordMetricVariantCategoryEnd(interaction, labelStack, end) {
    var _interaction$metricCa;
    // Excluded third-party holds (e.g. Forge background scripts) still live in `hold3pActive` and
    // gate completion like any third-party hold, but they must never contribute a third-party
    // category end. Skipping here covers every caller at once: the normal-release closure in
    // `addHold`, `removeHoldByID`, `addCompletedHold`, and the abort/timeout iterator
    // `recordActiveMetricVariantCategoryEnds`.
    if ($d99f08815d91a46e$var$isExcludedThirdPartyHold(labelStack)) return;
    var categories = $d99f08815d91a46e$var$getMetricVariantCategories(labelStack);
    if (categories.length === 0) return;
    interaction.metricCategoryEnds = (_interaction$metricCa = interaction.metricCategoryEnds) !== null && _interaction$metricCa !== void 0 ? _interaction$metricCa : {};
    categories.forEach(function(category) {
        var _category;
        interaction.metricCategoryEnds[category] = Math.max((_category = interaction.metricCategoryEnds[category]) !== null && _category !== void 0 ? _category : 0, end);
    });
};
var $d99f08815d91a46e$var$recordActiveMetricVariantCategoryEnds = function recordActiveMetricVariantCategoryEnds(interaction, end) {
    var _interaction$hold3pAc3;
    (_interaction$hold3pAc3 = interaction.hold3pActive) === null || _interaction$hold3pAc3 === void 0 || _interaction$hold3pAc3.forEach(function(hold) {
        $d99f08815d91a46e$var$recordMetricVariantCategoryEnd(interaction, hold.labelStack, end);
    });
};
var $d99f08815d91a46e$var$hasActiveMetricVariantCategory = function hasActiveMetricVariantCategory(interaction, category) {
    var _interaction$hold3pAc4, _interaction$hold3pAc5;
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((_interaction$hold3pAc4 = (_interaction$hold3pAc5 = interaction.hold3pActive) === null || _interaction$hold3pAc5 === void 0 ? void 0 : _interaction$hold3pAc5.values()) !== null && _interaction$hold3pAc4 !== void 0 ? _interaction$hold3pAc4 : []).some(function(hold) {
        return $d99f08815d91a46e$var$hasMetricVariantCategory(hold.labelStack, category);
    });
};
function $d99f08815d91a46e$var$shouldMoveHoldToExtendedBucket(interaction, hold) {
    // Excluded third-party holds (e.g. Forge background scripts) are routed to the extended
    // (`hold3pActive`) bucket exactly like any other third-party hold: they carry `type: 'third-party'`
    // so `hasAnyMetricVariantCategory` is true. They therefore keep gating completion (which preserves
    // the standard-bucket VC parity), and are excluded ONLY at the third-party accounting sites
    // (`recordMetricVariantCategoryEnd` and the `end3p` computation via `getNonExcludedThirdPartyEnd`).
    return $d99f08815d91a46e$var$hasAnyMetricVariantCategory(hold.labelStack) || interaction.end !== 0 && hold.start > interaction.end;
}
/**
 * The third-party end marker (`end3p`), used as the `include-third-party` window end whenever no
 * genuine third-party category end was recorded, must reflect only NON-excluded third-party work.
 *
 * `currentTime` is the timestamp the caller would otherwise have used verbatim (e.g. the abort
 * time, or the interaction end on the success path). If there is any genuine (non-excluded)
 * third-party hold that is still ACTIVE at this point, that work legitimately extends to
 * `currentTime`, so we keep it. Otherwise the only active third-party holds are excluded
 * background scripts, which must NOT drag the marker, so we fall back to the latest end among the
 * already-released non-excluded holds, clamped to at least `interactionEnd`. This preserves the
 * pre-fix behaviour for real third-party work while preventing background scripts from inflating
 * `end3p` / the include-third-party window.
 *
 * Note the released entries in `hold3pInfo` are `HoldActive & { end: number }`, so we read `h.end`.
 */ var $d99f08815d91a46e$var$getNonExcludedThirdPartyEnd = function getNonExcludedThirdPartyEnd(interaction, currentTime, interactionEnd) {
    var _interaction$hold3pAc6, _interaction$hold3pAc7, _interaction$hold3pIn2;
    var activeHolds = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((_interaction$hold3pAc6 = (_interaction$hold3pAc7 = interaction.hold3pActive) === null || _interaction$hold3pAc7 === void 0 ? void 0 : _interaction$hold3pAc7.values()) !== null && _interaction$hold3pAc6 !== void 0 ? _interaction$hold3pAc6 : []);
    var releasedHolds = (_interaction$hold3pIn2 = interaction.hold3pInfo) !== null && _interaction$hold3pIn2 !== void 0 ? _interaction$hold3pIn2 : [];
    // If this interaction never involved an excluded (background-script) hold at all
    // (none active AND none released), it is unaffected by an exclusion logic.
    // The derivation below only runs when at least one excluded hold actually exists.
    var hasAnyExcludedThirdParty = activeHolds.some(function(hold) {
        return $d99f08815d91a46e$var$isExcludedThirdPartyHold(hold.labelStack);
    }) || releasedHolds.some(function(hold) {
        return $d99f08815d91a46e$var$isExcludedThirdPartyHold(hold.labelStack);
    });
    if (!hasAnyExcludedThirdParty) return currentTime;
    // If a genuine (non-excluded) third-party hold is still active, the interaction is legitimately
    // being kept open by real third-party work, so the marker is the current time
    var hasActiveNonExcludedThirdParty = activeHolds.some(function(hold) {
        return !$d99f08815d91a46e$var$isExcludedThirdPartyHold(hold.labelStack);
    });
    if (hasActiveNonExcludedThirdParty) return currentTime;
    // Otherwise, only excluded background-script holds (if any) remain active. `currentTime` may have
    // been pushed out purely by a background script, so derive the marker from the latest genuine
    // (non-excluded) third-party work instead, floored to the interaction end so it is never reported
    // earlier than the interaction itself and a background script can never drag it late.
    return Math.max.apply(Math, [
        interactionEnd
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(releasedHolds.filter(function(hold) {
        return !$d99f08815d91a46e$var$isExcludedThirdPartyHold(hold.labelStack);
    }).map(function(hold) {
        return hold.end;
    }))));
};
function $d99f08815d91a46e$var$ensureExtendedHoldActive(interaction) {
    var _interaction$hold3pAc8;
    interaction.hold3pActive = (_interaction$hold3pAc8 = interaction.hold3pActive) !== null && _interaction$hold3pAc8 !== void 0 ? _interaction$hold3pAc8 : new Map();
    return interaction.hold3pActive;
}
function $d99f08815d91a46e$var$ensureExtendedHoldInfo(interaction) {
    var _interaction$hold3pIn3;
    interaction.hold3pInfo = (_interaction$hold3pIn3 = interaction.hold3pInfo) !== null && _interaction$hold3pIn3 !== void 0 ? _interaction$hold3pIn3 : [];
    return interaction.hold3pInfo;
}
function $d99f08815d91a46e$var$moveLateActiveHoldsToExtendedBucket(interaction) {
    if (interaction.end === 0) return;
    var holdsToMove = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(interaction.holdActive.entries()).filter(function(_ref4) {
        var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref4, 2), hold = _ref5[1];
        return $d99f08815d91a46e$var$shouldMoveHoldToExtendedBucket(interaction, hold);
    });
    holdsToMove.forEach(function(_ref6) {
        var _ref7 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref6, 2), id = _ref7[0], hold = _ref7[1];
        $d99f08815d91a46e$var$ensureExtendedHoldActive(interaction).set(id, hold);
        interaction.holdActive.delete(id);
    });
}
function $d99f08815d91a46e$var$ensureMetricWindows(interaction) {
    var _interaction$metricCa2, _interaction$metricCa3;
    if (interaction.end === 0) return;
    var hasGenAI = $d99f08815d91a46e$var$hasMetricVariantCategoryInHoldData(interaction, 'gen-ai');
    var hasThirdParty = $d99f08815d91a46e$var$hasMetricVariantCategoryInHoldData(interaction, 'third-party');
    var includeThirdPartyEnd = ((_interaction$metricCa2 = interaction.metricCategoryEnds) === null || _interaction$metricCa2 === void 0 ? void 0 : _interaction$metricCa2['third-party']) !== undefined ? Math.max(interaction.metricCategoryEnds['third-party'], interaction.end) : interaction.end3p;
    var includeGenAIEnd = ((_interaction$metricCa3 = interaction.metricCategoryEnds) === null || _interaction$metricCa3 === void 0 ? void 0 : _interaction$metricCa3['gen-ai']) !== undefined ? Math.max(interaction.metricCategoryEnds['gen-ai'], interaction.end) : undefined;
    interaction.metricWindows = $d99f08815d91a46e$var$_objectSpread($d99f08815d91a46e$var$_objectSpread({}, interaction.metricWindows), {}, {
        standard: {
            start: interaction.start,
            end: interaction.end,
            includeCategories: [],
            excludeCategories: [
                'third-party',
                'gen-ai'
            ]
        }
    });
    if (includeThirdPartyEnd !== undefined && (hasThirdParty || !hasGenAI)) interaction.metricWindows['include-third-party'] = {
        start: interaction.start,
        end: includeThirdPartyEnd,
        includeCategories: [
            'third-party'
        ],
        excludeCategories: []
    };
    if (hasGenAI && includeGenAIEnd !== undefined) interaction.metricWindows['include-gen-ai'] = {
        start: interaction.start,
        end: includeGenAIEnd,
        includeCategories: [
            'gen-ai'
        ],
        excludeCategories: []
    };
}
function $d99f08815d91a46e$var$addLifecycleObservation(interaction, observation) {
    var _interaction$lifecycl;
    interaction.lifecycleObservations = (_interaction$lifecycl = interaction.lifecycleObservations) !== null && _interaction$lifecycl !== void 0 ? _interaction$lifecycl : [];
    interaction.lifecycleObservations.push(observation);
}
function $d99f08815d91a46e$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach(function(cleanUpCallback) {
        cleanUpCallback();
    });
}
function $d99f08815d91a46e$var$finishInteraction(id, data) {
    var endTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    data.end = endTime;
    $d99f08815d91a46e$var$ensureMetricWindows(data);
    try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 [".concat(data.type, "] ").concat(data.ufoName, " [ttai]"), {
            start: data.start,
            end: data.end,
            detail: {
                devtools: {
                    track: 'main metrics',
                    trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                    color: 'tertiary'
                }
            }
        });
        performance.mark("TTAI", {
            startTime: data.end,
            detail: {
                devtools: {
                    dataType: 'marker'
                }
            }
        });
    } catch (_unused6) {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $8qy01.currentFeatureFlagsAccessed));
    (0, $dRzaM.clearActiveTrace)();
    $d99f08815d91a46e$var$callCleanUpCallbacks(data);
    (0, $4hV16.flushSsrRenderProfilerTraces)();
    if (data.type === 'page_load') data.hydration = (0, $DtLwq.getReactHydrationStats)();
    // By this time, stop the post interaction log observer if coinflip rate is 0
    if (!(0, $4iVTn.default)((0, $DtLwq.getPostInteractionRate)((0, $ly5tH.sanitizeUfoName)(data.ufoName), data.type))) $d99f08815d91a46e$export$d8f52e8f804021e8.stopVCObserver();
    $d99f08815d91a46e$export$cd7f480d6b8286c3(id);
    $d99f08815d91a46e$export$dbba6cdedab4e68b.id = data.id;
    $d99f08815d91a46e$export$dbba6cdedab4e68b.type = data.type;
    $d99f08815d91a46e$export$dbba6cdedab4e68b.timestamp = data.end;
    $d99f08815d91a46e$export$dbba6cdedab4e68b.name = data.ufoName || 'unknown';
    $d99f08815d91a46e$export$dbba6cdedab4e68b.isAborted = data.abortReason != null;
    if (data.ufoName) $d99f08815d91a46e$var$handleInteraction(id, data);
    if ($d99f08815d91a46e$var$isPerformanceTracingEnabled()) {
        var profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach(function(profilerTiming) {
            var labelStackId = $d99f08815d91a46e$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                var _profilerTimingMap$ge, _timing$start, _timing$end;
                var timing = (_profilerTimingMap$ge = profilerTimingMap.get(labelStackId)) !== null && _profilerTimingMap$ge !== void 0 ? _profilerTimingMap$ge : {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < ((_timing$start = timing.start) !== null && _timing$start !== void 0 ? _timing$start : Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > ((_timing$end = timing.end) !== null && _timing$end !== void 0 ? _timing$end : Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            var _iterator3 = $d99f08815d91a46e$var$_createForOfIteratorHelper(profilerTimingMap.entries()), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var _step3$value = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_step3.value, 2), _step3$value$ = _step3$value[1], labelStack = _step3$value$.labelStack, start = _step3$value$.start, end = _step3$value$.end;
                    performance.measure("\uD83D\uDEF8 ".concat($d99f08815d91a46e$var$labelStackToString(labelStack), " [segment_ttai]"), {
                        start: start,
                        end: end,
                        detail: {
                            devtools: {
                                track: "\uD83D\uDEF8 reactUFO detailed timings",
                                color: 'secondary-dark'
                            }
                        }
                    });
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        } catch (_unused7) {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch (_unused8) {
    // do nothing
    }
}
function $d99f08815d91a46e$export$9e614a29a1ac213e(sinkFn) {
    if ($d99f08815d91a46e$var$handleInteraction === $d99f08815d91a46e$var$pushToQueue) {
        $d99f08815d91a46e$var$handleInteraction = sinkFn;
        $d99f08815d91a46e$var$interactionQueue.forEach(function(interaction) {
            sinkFn(interaction.id, interaction.data);
        });
        $d99f08815d91a46e$var$interactionQueue.length = 0;
    }
}
function $d99f08815d91a46e$export$8a1ba7bef607358a(sinkFn) {
    $d99f08815d91a46e$export$d8f52e8f804021e8.sinkHandler(sinkFn);
}
// a flag to prevent multiple submitting
var $d99f08815d91a46e$var$activeSubmitted = false;
function $d99f08815d91a46e$export$673be905888f8839(interactionId, endTime) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) {
        var _interaction$hold3pAc9;
        var noMoreActiveHolds = interaction.holdActive.size === 0;
        var shouldUseRawDataThirdParty = (0, $DtLwq.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        var postInteraction = /*#__PURE__*/ function() {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
                var _getConfig3;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if ((_getConfig3 = (0, $DtLwq.getConfig)()) !== null && _getConfig3 !== void 0 && (_getConfig3 = _getConfig3.postInteractionLog) !== null && _getConfig3 !== void 0 && _getConfig3.enabled) $d99f08815d91a46e$export$d8f52e8f804021e8.onInteractionComplete(interaction);
                            $d99f08815d91a46e$var$activeSubmitted = false;
                        case 1:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function postInteraction() {
                return _ref8.apply(this, arguments);
            };
        }();
        var noMoreActiveMetricVariantHolds = ((_interaction$hold3pAc9 = interaction.hold3pActive) === null || _interaction$hold3pAc9 === void 0 ? void 0 : _interaction$hold3pAc9.size) === 0 || interaction.hold3pActive === undefined;
        var shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $d99f08815d91a46e$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If using separated metric variant behavior, wait for extended category holds to clear.
        // The backing fields still use their legacy 3P names because they are part of the existing
        // third-party payload contract, but this bucket now also drives client metric windows.
        if (shouldUseSeparatedMetricVariantBehavior) {
            // If there are no standard holds active, mark the interaction as successful
            // but don't finish until extended metric variant holds are cleared.
            if (noMoreActiveHolds && !noMoreActiveMetricVariantHolds) {
                // Mark interaction as successful by setting endTime, but don't finish yet
                if (endTime !== undefined && interaction.end === 0) interaction.end = endTime;
                $d99f08815d91a46e$var$moveLateActiveHoldsToExtendedBucket(interaction);
                $d99f08815d91a46e$var$ensureMetricWindows(interaction);
                // Wait for extended metric variant holds to clear before finishing.
                return;
            }
            // If all holds, including extended metric variant holds, are cleared, finish the interaction.
            if (noMoreActiveHolds && noMoreActiveMetricVariantHolds) {
                if (!$d99f08815d91a46e$var$activeSubmitted) {
                    var _getConfig4, _getConfig5;
                    // Set the legacy third-party end marker when extended metric variant holds clear,
                    // preserving existing 3P payload behavior while category-specific end times are
                    // recorded separately in metricCategoryEnds. When a genuine third-party hold is still
                    // active (or was the last to release), `getNonExcludedThirdPartyEnd` returns the same
                    // clamped current time as before. When only excluded background-script holds remain,
                    // the marker is derived from the non-excluded third-party holds and floored to the
                    // interaction end, so a background script cannot drag it late.
                    var currentTime = endTime !== null && endTime !== void 0 ? endTime : performance.now();
                    interaction.end3p = $d99f08815d91a46e$var$getNonExcludedThirdPartyEnd(interaction, interaction.end !== 0 && currentTime < interaction.end ? interaction.end : currentTime, interaction.end !== 0 ? interaction.end : currentTime);
                    $d99f08815d91a46e$var$ensureMetricWindows(interaction);
                    $d99f08815d91a46e$var$finishInteraction(interactionId, interaction, interaction.end !== 0 ? interaction.end : endTime);
                    if ((_getConfig4 = (0, $DtLwq.getConfig)()) !== null && _getConfig4 !== void 0 && (_getConfig4 = _getConfig4.extraSearchPageInteraction) !== null && _getConfig4 !== void 0 && _getConfig4.enabled && interaction.ufoName === ((_getConfig5 = (0, $DtLwq.getConfig)()) === null || _getConfig5 === void 0 || (_getConfig5 = _getConfig5.extraSearchPageInteraction) === null || _getConfig5 === void 0 ? void 0 : _getConfig5.searchPageMetricName)) (0, $bPZgx.onSearchPageInteractionComplete)(interactionId, interaction);
                    $d99f08815d91a46e$var$activeSubmitted = true;
                }
                postInteraction();
            }
        } else if (noMoreActiveHolds) {
            if (!$d99f08815d91a46e$var$activeSubmitted) {
                var _getConfig6, _getConfig7;
                $d99f08815d91a46e$var$finishInteraction(interactionId, interaction, endTime);
                if ((_getConfig6 = (0, $DtLwq.getConfig)()) !== null && _getConfig6 !== void 0 && (_getConfig6 = _getConfig6.extraSearchPageInteraction) !== null && _getConfig6 !== void 0 && _getConfig6.enabled && interaction.ufoName === ((_getConfig7 = (0, $DtLwq.getConfig)()) === null || _getConfig7 === void 0 || (_getConfig7 = _getConfig7.extraSearchPageInteraction) === null || _getConfig7 === void 0 ? void 0 : _getConfig7.searchPageMetricName)) (0, $bPZgx.onSearchPageInteractionComplete)(interactionId, interaction);
                $d99f08815d91a46e$var$activeSubmitted = true;
            }
            postInteraction();
        }
    }
}
function $d99f08815d91a46e$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach(function(cancelCallback) {
        cancelCallback();
    });
}
function $d99f08815d91a46e$export$5def58af4fd46132(interactionId, abortReason) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) {
        var _interaction$hold3pAc10, _interaction$hold3pAc11;
        var shouldUseRawDataThirdParty = (0, $DtLwq.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        var noMoreActiveHolds = interaction.holdActive.size === 0;
        var has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        var shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $d99f08815d91a46e$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            var _interaction$hold3pAc0, _interaction$hold3pAc1;
            var endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Excluded background-script holds that are still active at abort/timeout must not drag
            // `end3p` (and thus the include-third-party window) past the real interaction end. Derive it
            // from the non-excluded third-party holds only. `recordActiveMetricVariantCategoryEnds`
            // likewise skips excluded holds internally.
            interaction.end3p = $d99f08815d91a46e$var$getNonExcludedThirdPartyEnd(interaction, performance.now(), endTime);
            $d99f08815d91a46e$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $d99f08815d91a46e$var$addLifecycleObservation(interaction, {
                type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
                timestamp: interaction.end3p,
                activeHoldCount: (_interaction$hold3pAc0 = (_interaction$hold3pAc1 = interaction.hold3pActive) === null || _interaction$hold3pAc1 === void 0 ? void 0 : _interaction$hold3pAc1.size) !== null && _interaction$hold3pAc0 !== void 0 ? _interaction$hold3pAc0 : 0
            });
            $d99f08815d91a46e$var$ensureMetricWindows(interaction);
            $d99f08815d91a46e$var$finishInteraction(interactionId, interaction, endTime);
            $d99f08815d91a46e$export$d8f52e8f804021e8.reset();
            $d99f08815d91a46e$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        $d99f08815d91a46e$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $d99f08815d91a46e$var$addLifecycleObservation(interaction, {
            type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
            timestamp: performance.now(),
            activeHoldCount: interaction.holdActive.size + ((_interaction$hold3pAc10 = (_interaction$hold3pAc11 = interaction.hold3pActive) === null || _interaction$hold3pAc11 === void 0 ? void 0 : _interaction$hold3pAc11.size) !== null && _interaction$hold3pAc10 !== void 0 ? _interaction$hold3pAc10 : 0)
        });
        $d99f08815d91a46e$var$finishInteraction(interactionId, interaction);
        $d99f08815d91a46e$export$d8f52e8f804021e8.reset();
        $d99f08815d91a46e$export$d8f52e8f804021e8.stopVCObserver();
    }
}
function $d99f08815d91a46e$export$c4a545284f55edf2(interactionId, interactionName) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) {
        var shouldUseRawDataThirdParty = (0, $DtLwq.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        var noMoreActiveHolds = interaction.holdActive.size === 0;
        var has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        var shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $d99f08815d91a46e$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            var endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Excluded background-script holds still active at this point must not drag `end3p` (and
            // thus the include-third-party window) past the real interaction end. Derive it from the
            // non-excluded third-party holds only, clamped to at least the interaction end.
            interaction.end3p = $d99f08815d91a46e$var$getNonExcludedThirdPartyEnd(interaction, performance.now(), endTime);
            $d99f08815d91a46e$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $d99f08815d91a46e$var$addLifecycleObservation(interaction, {
                type: 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: interactionName
            });
            $d99f08815d91a46e$var$ensureMetricWindows(interaction);
            $d99f08815d91a46e$var$finishInteraction(interactionId, interaction, endTime);
            $d99f08815d91a46e$export$d8f52e8f804021e8.reset();
            $d99f08815d91a46e$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        $d99f08815d91a46e$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $d99f08815d91a46e$var$addLifecycleObservation(interaction, {
            type: 'new_interaction_started',
            timestamp: performance.now(),
            triggerName: interactionName
        });
        $d99f08815d91a46e$var$finishInteraction(interactionId, interaction);
        $d99f08815d91a46e$export$d8f52e8f804021e8.reset();
        $d99f08815d91a46e$export$d8f52e8f804021e8.stopVCObserver();
    } else {
        // post-interaction log is active after interaction is aborted by new one
        $d99f08815d91a46e$export$d8f52e8f804021e8.reset();
        $d99f08815d91a46e$export$d8f52e8f804021e8.stopVCObserver();
    }
}
function $d99f08815d91a46e$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    var activeInteraction = $d99f08815d91a46e$export$2b3954d2e8509985();
    var finishInteractions = (0, $DtLwq.getFinishInteractionOnTransition)();
    (0, $aNUZN.interactions).forEach(function(interaction, interactionId) {
        var isActiveInteraction = activeInteraction === interaction;
        var hasFinished = interaction.holdActive.size === 0;
        if (isActiveInteraction && abortReason === 'transition' && interaction.type === 'press' && finishInteractions !== null && finishInteractions !== void 0 && finishInteractions.includes(interaction.ufoName)) hasFinished = true;
        var shouldUseRawDataThirdParty = (0, $DtLwq.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        var noMoreActiveHolds = interaction.holdActive.size === 0;
        var has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        var shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $d99f08815d91a46e$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            var endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Excluded background-script holds still active at transition/new-interaction abort must not
            // drag `end3p` (and thus the include-third-party window) past the real interaction end.
            // Derive it from the non-excluded third-party holds only, clamped to at least the end.
            interaction.end3p = $d99f08815d91a46e$var$getNonExcludedThirdPartyEnd(interaction, performance.now(), endTime);
            $d99f08815d91a46e$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $d99f08815d91a46e$var$addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: abortedByInteractionName
            });
            $d99f08815d91a46e$var$ensureMetricWindows(interaction);
            $d99f08815d91a46e$var$finishInteraction(interactionId, interaction, endTime);
            $d99f08815d91a46e$export$d8f52e8f804021e8.reset();
            $d99f08815d91a46e$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        if (!hasFinished) {
            $d99f08815d91a46e$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
            $d99f08815d91a46e$var$addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: performance.now(),
                triggerName: abortedByInteractionName
            });
        }
        $d99f08815d91a46e$var$finishInteraction(interactionId, interaction);
        $d99f08815d91a46e$export$d8f52e8f804021e8.reset();
        $d99f08815d91a46e$export$d8f52e8f804021e8.stopVCObserver();
    });
}
function $d99f08815d91a46e$export$7b9261a96cfe427b(id, cancelCallback) {
    var interaction = (0, $aNUZN.interactions).get(id);
    interaction === null || interaction === void 0 || interaction.cancelCallbacks.push(cancelCallback);
}
function $d99f08815d91a46e$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName) {
    var _config$extraSearchPa, _config$extraSearchPa2;
    var trace = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
    var preloadKey = arguments.length > 8 ? arguments[8] : undefined;
    $d99f08815d91a46e$export$d8f52e8f804021e8.reset();
    var vcObserver;
    var previousTime = startTime;
    var timeoutTime = (0, $DtLwq.getInteractionTimeout)(ufoName);
    var timerID = setTimeout(function() {
        $d99f08815d91a46e$export$5def58af4fd46132(interactionId, 'timeout');
    }, timeoutTime);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        var currentTime = performance.now();
        var timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        var newTimerID = setTimeout(function() {
            $d99f08815d91a46e$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    var addFeatureFlagsToInteraction = (0, $4iVTn.default)((0, $DtLwq.getCapabilityRate)('feature_flag_access'));
    var config = (0, $DtLwq.getConfig)();
    var searchPageConfig = {
        enableSmartAnswersMutations: config === null || config === void 0 || (_config$extraSearchPa = config.extraSearchPageInteraction) === null || _config$extraSearchPa === void 0 ? void 0 : _config$extraSearchPa.enabled,
        searchPageRoute: config === null || config === void 0 || (_config$extraSearchPa2 = config.extraSearchPageInteraction) === null || _config$extraSearchPa2 === void 0 ? void 0 : _config$extraSearchPa2.searchPageRoute
    };
    if (config && config.vc) {
        var vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, $DtLwq.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders,
            searchPageConfig: searchPageConfig
        };
        vcObserver = (0, $hkc2F.newVCObserver)(vcOptions);
    }
    var priorAccessedFg = type === 'press' ? {} : Object.fromEntries((0, $8qy01.allFeatureFlagsAccessed));
    var metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        preloadKey: preloadKey,
        type: type,
        previousInteractionName: $d99f08815d91a46e$export$dbba6cdedab4e68b.name,
        isPreviousInteractionAborted: $d99f08815d91a46e$export$dbba6cdedab4e68b.isAborted === true,
        marks: [],
        customData: [],
        cohortingCustomData: new Map(),
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdActive: new Map(),
        preloadInfo: [],
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        excluded3pSegmentData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName !== null && routeName !== void 0 ? routeName : ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: priorAccessedFg,
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace,
        vcObserver: vcObserver,
        hold3pActive: new Map(),
        hold3pInfo: [],
        minorInteractions: []
    };
    if (addFeatureFlagsToInteraction) (0, $8qy01.currentFeatureFlagsAccessed).clear();
    (0, $aNUZN.interactions).set(interactionId, metrics);
    var segmentObserver = {
        onAdd: function onAdd(segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove: function onRemove() {}
    };
    $d99f08815d91a46e$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(function() {
        $d99f08815d91a46e$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(function() {
        clearTimeout(metrics.timerID);
    });
    // Add cleanup for per-interaction VC observer
    if (vcObserver) metrics.cleanupCallbacks.push(function() {
        vcObserver.stop(ufoName);
    });
    var awaitBM3TTIList = (0, $DtLwq.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $d99f08815d91a46e$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition' || type === 'page_load') {
        var _getConfig8;
        // Use per-interaction VC observer if available, otherwise fall back to global
        var observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
        // Start post interaction observer for all if config is enabled
        // in case ufoName is updated at later time
        if ((_getConfig8 = (0, $DtLwq.getConfig)()) !== null && _getConfig8 !== void 0 && (_getConfig8 = _getConfig8.postInteractionLog) !== null && _getConfig8 !== void 0 && _getConfig8.enabled) $d99f08815d91a46e$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
    }
    if (type === 'press') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        var _observer = vcObserver;
        if (_observer) _observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
    }
    if ($d99f08815d91a46e$var$onInteractionStartForPreloadHolds) try {
        $d99f08815d91a46e$var$onInteractionStartForPreloadHolds(interactionId, ufoName, preloadKey);
    } catch (_unused9) {
    // Preload instrumentation must not break interaction creation.
    }
}
function $d99f08815d91a46e$export$4a759336b50e86e3(event) {
    var interaction = $d99f08815d91a46e$export$2b3954d2e8509985();
    if (interaction) {
        var _event$config;
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && ((_event$config = event.config) === null || _event$config === void 0 ? void 0 : _event$config.type) === 'PAGE_LOAD') $d99f08815d91a46e$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
    }
}
function $d99f08815d91a46e$export$ad216cc25852d44b(apdex) {
    (0, $aNUZN.interactions).forEach(function(interaction, key) {
        interaction.apdex.push(apdex);
        try {
            var _apdex$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdex.key, " [bm3_tti]"), {
                start: (_apdex$startTime = apdex.startTime) !== null && _apdex$startTime !== void 0 ? _apdex$startTime : interaction.start,
                end: apdex.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark("[bm3] TTI", {
                startTime: apdex.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch (_unused0) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $d99f08815d91a46e$export$4983dfbbb996f7ae(key, interaction.ufoName);
    });
}
function $d99f08815d91a46e$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            var _apdexInfo$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdexInfo.key, " [bm3_tti]"), {
                start: (_apdexInfo$startTime = apdexInfo.startTime) !== null && _apdexInfo$startTime !== void 0 ? _apdexInfo$startTime : interaction.start,
                end: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark("[bm3] TTI", {
                startTime: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch (_unused1) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $d99f08815d91a46e$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
    }
}
function $d99f08815d91a46e$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) interaction.requestInfo.push($d99f08815d91a46e$var$_objectSpread({
        labelStack: labelStack
    }, requestInfo));
}
function $d99f08815d91a46e$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $d99f08815d91a46e$var$getSegmentCacheKey(labelStack) {
    return labelStack.map(function(l) {
        if ($d99f08815d91a46e$var$isSegmentLabel(l)) return "".concat(l.name, "_").concat(l.segmentId);
        return l.name;
    }).join('|');
}
function $d99f08815d91a46e$export$1c43f9ac826b6462(labelStack) {
    var key = $d99f08815d91a46e$var$getSegmentCacheKey(labelStack);
    var existingSegment = $d99f08815d91a46e$var$segmentCache.get(key);
    if (!existingSegment) {
        var segmentInfo = {
            labelStack: labelStack
        };
        $d99f08815d91a46e$var$segmentCache.set(key, segmentInfo);
        $d99f08815d91a46e$var$segmentObservers.forEach(function(observer) {
            observer.onAdd(segmentInfo);
        });
    }
}
function $d99f08815d91a46e$export$d0365e48b58231c3(labelStack) {
    var key = $d99f08815d91a46e$var$getSegmentCacheKey(labelStack);
    var segmentInfo = $d99f08815d91a46e$var$segmentCache.get(key);
    if (segmentInfo) {
        $d99f08815d91a46e$var$segmentCache.delete(JSON.stringify(labelStack));
        var cacheKey = (0, $58ED5.stringifyLabelStackFully)(labelStack);
        $d99f08815d91a46e$export$a2b14406ded37d60.set(cacheKey, ($d99f08815d91a46e$export$a2b14406ded37d60.get(cacheKey) || 0) + 1);
        $d99f08815d91a46e$var$segmentObservers.forEach(function(observer) {
            observer.onRemove(segmentInfo);
        });
    }
}
function $d99f08815d91a46e$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($d99f08815d91a46e$var$isPerformanceTracingEnabled()) {
            var prevRedirect = interaction.redirects.at(-2);
            try {
                var _prevRedirect$time;
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat(nextUfoName, " [redirect]"), {
                    start: (_prevRedirect$time = prevRedirect === null || prevRedirect === void 0 ? void 0 : prevRedirect.time) !== null && _prevRedirect$time !== void 0 ? _prevRedirect$time : interaction.start,
                    end: time,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary'
                        }
                    }
                });
            } catch (_unused10) {
            // do nothing
            }
        }
    }
}
var $d99f08815d91a46e$export$6ce04c7ca6810a7e = [];
var $d99f08815d91a46e$var$defaultLabelStack = [
    {
        name: 'custom'
    }
];
function $d99f08815d91a46e$export$5342dcad19138a1c(name, start) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var labelStack = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : $d99f08815d91a46e$var$defaultLabelStack;
    var customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $d99f08815d91a46e$export$6ce04c7ca6810a7e.push(customSpan);
}

});
parcelRegister("hdYpx", function(module, exports) {
$parcel$export(module.exports, "sanitizeTimingName", () => $033c6d77796ac342$export$23e69abaca7d0236);
var $033c6d77796ac342$export$4c07c8a3507ce307 = 255;
var $033c6d77796ac342$var$GQL_OPERATION_PARAMS = [
    'operation',
    'operationName',
    'q'
];
function $033c6d77796ac342$var$isGqlUrl(name) {
    try {
        var url = new URL(name);
        var searchParams = url.search ? new URLSearchParams(url.search) : null;
        return $033c6d77796ac342$var$GQL_OPERATION_PARAMS.some(function(param) {
            return Boolean(searchParams === null || searchParams === void 0 ? void 0 : searchParams.get(param));
        });
    } catch (_unused) {
        return false;
    }
}
function $033c6d77796ac342$export$23e69abaca7d0236(name) {
    if (name.length <= $033c6d77796ac342$export$4c07c8a3507ce307) return name;
    if ($033c6d77796ac342$var$isGqlUrl(name)) return name;
    return name.slice(0, $033c6d77796ac342$export$4c07c8a3507ce307);
}

});

parcelRegister("bPZgx", function(module, exports) {
$parcel$export(module.exports, "onSearchPageInteractionComplete", () => $89e3fb3b901fadaa$export$74b9ce7e9d206a8);

var $5O2so = parcelRequire("5O2so");
function $89e3fb3b901fadaa$export$74b9ce7e9d206a8(interactionId, data) {
    if (data.ufoName) {
        (0, $5O2so.interactionBufferState).bufferInteractionData(interactionId, data);
        (0, $5O2so.interactionBufferState).interactionBuffer.length = 0;
    }
}

});
parcelRegister("5O2so", function(module, exports) {
$parcel$export(module.exports, "interactionBufferState", () => $43a3872c29698a5f$export$af15cc1c63c2807a);
var $43a3872c29698a5f$var$interactionBuffer = [];
var $43a3872c29698a5f$export$af15cc1c63c2807a = {
    interactionBuffer: $43a3872c29698a5f$var$interactionBuffer,
    bufferInteractionData: function bufferInteractionData(interactionId, data) {
        $43a3872c29698a5f$var$interactionBuffer.push({
            interactionId: interactionId,
            data: data
        });
    }
};

});


parcelRegister("ly5tH", function(module, exports) {
$parcel$export(module.exports, "sanitizeUfoName", () => $fb0105cbb260e990$export$e08487ea3ae92adb);
function $fb0105cbb260e990$export$e08487ea3ae92adb(name) {
    return name.replace(/_/g, '-');
}

});

parcelRegister("58ED5", function(module, exports) {
$parcel$export(module.exports, "stringifyLabelStackFully", () => $3bdd37440f9c7190$export$caeee352b541de1f);

var $6pNem = parcelRequire("6pNem");

var $bYaqG = parcelRequire("bYaqG");
function $3bdd37440f9c7190$export$caeee352b541de1f(labelStack) {
    return labelStack.map(function(l) {
        var name = (0, $bYaqG.sanitizeLabelStackName)(l.name);
        if ((0, $6pNem.isSegmentLabel)(l)) return "".concat(name, ":").concat(l.segmentId);
        return name;
    }).join('/');
}

});
parcelRegister("6pNem", function(module, exports) {
$parcel$export(module.exports, "isSegmentLabel", () => $4abb440e0394db73$export$1adbaf5c2363e4ae);
function $4abb440e0394db73$export$1adbaf5c2363e4ae(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}

});


parcelRegister("dRzaM", function(module, exports) {
$parcel$export(module.exports, "clearActiveTrace", () => $a17b8236da4e479f$export$17ab21d7be720b);

var $eRfZr = parcelRequire("eRfZr");

var $50U6m = parcelRequire("50U6m");

var $b49n7 = parcelRequire("b49n7");

var $5Y1AV = parcelRequire("5Y1AV");
function $a17b8236da4e479f$export$17ab21d7be720b() {
    if ((0, $50U6m.fg)('platform_ufo_enable_otel_context_manager')) // Now we need to get the global Context Manager and set the active context
    // Using type assertion because we've "extended" the ContextManager type
    {
        if ((0, $b49n7.getContextManager)() instanceof (0, $b49n7.UFOContextManager)) {
            var contextManager = (0, $b49n7.getContextManager)();
            // ROOT_CONTEXT is an empty context used to initialise ContextManagers
            contextManager.setActive((0, $eRfZr.ROOT_CONTEXT));
        }
    } else (0, $5Y1AV.state).context = null;
}

});
parcelRegister("b49n7", function(module, exports) {
$parcel$export(module.exports, "setContextManager", () => $80e7567ec3e4b167$export$4a00ab8a5dd9b5cf);
$parcel$export(module.exports, "getContextManager", () => $80e7567ec3e4b167$export$831109c9f7727010);
$parcel$export(module.exports, "UFOContextManager", () => $80e7567ec3e4b167$export$dd301b96c16f583d);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $eRfZr = parcelRequire("eRfZr");
/**
 * We need to store a reference to the Context manager so that we can get it later.
 * This is because the OTel JS API doesn't allow us to get the registered context manager,
 * and we need to get it because we need to call a function that's not available in the OTel API:
 * `setActive`. The OTel JS API design doesn't allow us to manually set the active context
 * despite the spec allowing for the capability. Sigh.
 *
 * I imagine this situation might not be permanent if we can move to a system were we can rely
 * solely on the API, but for the purposes of the first change being React UFO API compatible,
 * we'll need to do this.
 */ var $80e7567ec3e4b167$var$contextManager;
function $80e7567ec3e4b167$export$4a00ab8a5dd9b5cf(ctxMgr) {
    $80e7567ec3e4b167$var$contextManager = ctxMgr;
}
function $80e7567ec3e4b167$export$831109c9f7727010() {
    return $80e7567ec3e4b167$var$contextManager;
}
var $80e7567ec3e4b167$export$dd301b96c16f583d = /*#__PURE__*/ function() {
    function UFOContextManager() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UFOContextManager);
        /**
     * whether the context manager is enabled or not
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_enabled", false);
        /**
     * Keeps the reference to current context
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_currentContext", (0, $eRfZr.ROOT_CONTEXT));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UFOContextManager, [
        {
            key: "_bindFunction",
            value: /**
     *
     * @param context
     * @param target Function to be executed within the context
     */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
            function _bindFunction() {
                var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $eRfZr.ROOT_CONTEXT);
                var target = arguments.length > 1 ? arguments[1] : undefined;
                // eslint-disable-next-line @typescript-eslint/no-this-alias
                var manager = this;
                var contextWrapper = function contextWrapper() {
                    var _this = this;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return manager.with(context, function() {
                        return target.apply(_this, args);
                    });
                };
                Object.defineProperty(contextWrapper, 'length', {
                    enumerable: false,
                    configurable: true,
                    writable: false,
                    value: target.length
                });
                return contextWrapper;
            }
        },
        {
            key: "active",
            value: function active() {
                return this._currentContext;
            }
        },
        {
            key: "bind",
            value: function bind(context, target) {
                // if no specific context to propagate is given, we use the current one
                if (context === undefined) context = this.active();
                if (typeof target === 'function') return this._bindFunction(context, target);
                return target;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this._currentContext = (0, $eRfZr.ROOT_CONTEXT);
                this._enabled = false;
                return this;
            }
        },
        {
            key: "enable",
            value: function enable() {
                if (this._enabled) return this;
                this._enabled = true;
                this._currentContext = (0, $eRfZr.ROOT_CONTEXT);
                return this;
            }
        },
        {
            key: "with",
            value: function _with(context, fn, thisArg) {
                var previousContext = this._currentContext;
                this._currentContext = context || (0, $eRfZr.ROOT_CONTEXT);
                try {
                    for(var _len2 = arguments.length, args = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++)args[_key2 - 3] = arguments[_key2];
                    return fn.call.apply(fn, [
                        thisArg
                    ].concat(args));
                } finally{
                    this._currentContext = previousContext;
                }
            }
        },
        {
            key: "setActive",
            value: function setActive(context) {
                if (this._enabled) this._currentContext = context;
            }
        }
    ]);
}();

});


parcelRegister("8qy01", function(module, exports) {
$parcel$export(module.exports, "allFeatureFlagsAccessed", () => $622b1ffdc30d3221$export$5b78c989c8db2561);
$parcel$export(module.exports, "currentFeatureFlagsAccessed", () => $622b1ffdc30d3221$export$2a5c8df26bb89760);
$parcel$export(module.exports, "addFeatureFlagAccessed", () => $622b1ffdc30d3221$export$47fade9662f71000);

var $eSiml = parcelRequire("eSiml");
var $622b1ffdc30d3221$export$5b78c989c8db2561 = new Map();
var $622b1ffdc30d3221$export$2a5c8df26bb89760 = new Map();
function $622b1ffdc30d3221$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    var value = (0, $eSiml.redactValue)(featureFlagValue);
    $622b1ffdc30d3221$export$5b78c989c8db2561.set(featureFlagName, value);
    $622b1ffdc30d3221$export$2a5c8df26bb89760.set(featureFlagName, value);
}

});
parcelRegister("eSiml", function(module, exports) {
$parcel$export(module.exports, "redactValue", () => $ad4459a18488b3a3$export$fcc03ee4c944962f);

var $03VUm = parcelRequire("03VUm");

var $5zqBT = parcelRequire("5zqBT");
function $ad4459a18488b3a3$export$fcc03ee4c944962f(featureFlagValue) {
    return (0, $5zqBT.shouldRedactValue)(featureFlagValue) ? (0, $03VUm.NON_BOOLEAN_VALUE) : featureFlagValue;
}

});
parcelRegister("03VUm", function(module, exports) {
$parcel$export(module.exports, "NON_BOOLEAN_VALUE", () => $00bd333ed11530f5$export$42f4885608027d0c);
var $00bd333ed11530f5$export$42f4885608027d0c = 'non_boolean';

});

parcelRegister("5zqBT", function(module, exports) {
$parcel$export(module.exports, "shouldRedactValue", () => $40e4dcdb009870af$export$7b4abba432e57989);

var $ekGgq = parcelRequire("ekGgq");
function $40e4dcdb009870af$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch (_unused) {
        return false;
    }
    return false;
}
function $40e4dcdb009870af$var$isObject(value) {
    return value && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && value.constructor === Object;
}
function $40e4dcdb009870af$var$isString(input) {
    var result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (_unused2) {
        // swallow any errors
        result = false;
    }
    return result;
}
function $40e4dcdb009870af$export$7b4abba432e57989(value) {
    return $40e4dcdb009870af$var$isString(value) && $40e4dcdb009870af$var$startsAsObject(value) || $40e4dcdb009870af$var$isObject(value);
}

});



parcelRegister("1MHAJ", function(module, exports) {
$parcel$export(module.exports, "getInteractionId", () => $14cc167937275771$export$37bca3107733ac1e);

var $6aILb = parcelRequire("6aILb");
var $14cc167937275771$export$37bca3107733ac1e = function getInteractionId() {
    return 0, $6aILb.default;
};

});

parcelRegister("bDCbL", function(module, exports) {
$parcel$export(module.exports, "BACKEND_RESOURCE_TIMING_INITIATOR_TYPES", () => $8790f5b4bae46297$export$c3b002e13fbb9ef2);
var $8790f5b4bae46297$export$c3b002e13fbb9ef2 = new Set([
    'fetch',
    'xmlhttprequest'
]);

});

parcelRegister("4hV16", function(module, exports) {
$parcel$export(module.exports, "flushSsrRenderProfilerTraces", () => $31f4fa5271e30fd3$export$c8760e11c713fafc);

var $jIBBJ = parcelRequire("jIBBJ");
var $31f4fa5271e30fd3$export$c8760e11c713fafc = function flushSsrRenderProfilerTraces() {
    (0, $jIBBJ.default).spanStates.forEach(function(spanState) {
        if (spanState.latestEndTime != null) spanState.span.end(spanState.latestEndTime);
    });
    (0, $jIBBJ.default).spanStates.clear();
};

});
parcelRegister("jIBBJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5af4c79eef42636$export$2e2bcd8739ae039);
// Shared across profiler renders and the public reset/flush entry points. Keep this
// outside React context so Suspense restarts cannot discard the initial render.
var $e5af4c79eef42636$var$state = {
    startTimes: new Map(),
    spanStates: new Map(),
    lastActiveInteraction: undefined
};
var $e5af4c79eef42636$export$2e2bcd8739ae039 = $e5af4c79eef42636$var$state;

});


parcelRegister("hkc2F", function(module, exports) {
$parcel$export(module.exports, "newVCObserver", () => $c9cda539cbe7a4ee$export$c69731bddfc24d85);

var $4tXHg = parcelRequire("4tXHg");

var $iXcXg = parcelRequire("iXcXg");

var $h3Aj2 = parcelRequire("h3Aj2");
function $c9cda539cbe7a4ee$export$c69731bddfc24d85() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var shouldMockVCObserver = !(0, $4tXHg.isEnvironmentSupported)();
    var observer = shouldMockVCObserver ? new (0, $iXcXg.VCObserverNOOP)() : new (0, $h3Aj2.VCObserverWrapper)(opts);
    return observer;
}

});
parcelRegister("4tXHg", function(module, exports) {
$parcel$export(module.exports, "isEnvironmentSupported", () => $34382d68d092b1da$export$68d57b133e88584d);

var $3ZMUU = parcelRequire("3ZMUU");
var $34382d68d092b1da$var$_process;
// Some products set this variable to indicate it is running in SSR
var $34382d68d092b1da$var$isServer = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
var $34382d68d092b1da$var$isReactSSR = typeof $3ZMUU !== 'undefined' && Boolean((($34382d68d092b1da$var$_process = $3ZMUU) === null || $34382d68d092b1da$var$_process === void 0 || ($34382d68d092b1da$var$_process = $34382d68d092b1da$var$_process.env) === null || $34382d68d092b1da$var$_process === void 0 ? void 0 : $34382d68d092b1da$var$_process.REACT_SSR) || false);
function $34382d68d092b1da$export$68d57b133e88584d() {
    // SSR environment aren't supported
    if ($34382d68d092b1da$var$isReactSSR || $34382d68d092b1da$var$isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.WeakRef) !== 'function') return false;
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.MutationObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.IntersectionObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.PerformanceObserver) !== 'function') return false;
    return true;
}

});

parcelRegister("iXcXg", function(module, exports) {
$parcel$export(module.exports, "VCObserverNOOP", () => $dcc7c939921a3c40$export$24d07287b49da906);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");
var $dcc7c939921a3c40$export$24d07287b49da906 = /*#__PURE__*/ function() {
    function VCObserverNOOP() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, VCObserverNOOP);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(VCObserverNOOP, [
        {
            key: "start",
            value: function start(_) {}
        },
        {
            key: "stop",
            value: function stop() {}
        },
        {
            key: "getVCRawData",
            value: function getVCRawData() {
                return null;
            }
        },
        {
            key: "getVCResult",
            value: function getVCResult(_) {
                return Promise.resolve({
                    'ufo:vc:noop': true
                });
            }
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(_) {}
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart(_) {}
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop(_) {}
        }
    ]);
}();

});

parcelRegister("h3Aj2", function(module, exports) {
$parcel$export(module.exports, "VCObserverWrapper", () => $c6aee11d2ac6279e$export$4a1fe1ab3c13bbf5);

var $fC8ib = parcelRequire("fC8ib");

var $fL8KA = parcelRequire("fL8KA");

var $25nEq = parcelRequire("25nEq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $DtLwq = parcelRequire("DtLwq");

var $29WXY = parcelRequire("29WXY");

var $i4OdZ = parcelRequire("i4OdZ");

var $hakpj = parcelRequire("hakpj");

var $k6qaT = parcelRequire("k6qaT");
function $c6aee11d2ac6279e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c6aee11d2ac6279e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c6aee11d2ac6279e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c6aee11d2ac6279e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c6aee11d2ac6279e$export$4a1fe1ab3c13bbf5 = /*#__PURE__*/ function() {
    function VCObserverWrapper() {
        var _opts$ssrEnablePageLa, _opts$ssrEnablePageLa2, _opts$trackLayoutShif;
        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, VCObserverWrapper);
        this.newVCObserver = null;
        this.oldVCObserver = null;
        // Initialize SSR placeholder handler once
        this.ssrPlaceholderHandler = new (0, $k6qaT.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: (_opts$ssrEnablePageLa = opts.ssrEnablePageLayoutPlaceholder) !== null && _opts$ssrEnablePageLa !== void 0 ? _opts$ssrEnablePageLa : false
        });
        this.newVCObserver = new (0, $i4OdZ.default)({
            selectorConfig: opts.selectorConfig,
            isPostInteraction: opts.isPostInteraction,
            SSRConfig: {
                enablePageLayoutPlaceholder: (_opts$ssrEnablePageLa2 = opts.ssrEnablePageLayoutPlaceholder) !== null && _opts$ssrEnablePageLa2 !== void 0 ? _opts$ssrEnablePageLa2 : false
            },
            ssrPlaceholderHandler: this.ssrPlaceholderHandler,
            trackLayoutShiftOffenders: (_opts$trackLayoutShif = opts.trackLayoutShiftOffenders) !== null && _opts$trackLayoutShif !== void 0 ? _opts$trackLayoutShif : false,
            searchPageConfig: opts.searchPageConfig
        });
        if ((0, $DtLwq.isVCRevisionEnabled)('fy25.01') || (0, $DtLwq.isVCRevisionEnabled)('fy25.02')) this.oldVCObserver = new (0, $29WXY.VCObserver)($c6aee11d2ac6279e$var$_objectSpread($c6aee11d2ac6279e$var$_objectSpread({}, opts), {}, {
            ssrPlaceholderHandler: this.ssrPlaceholderHandler
        }));
    }
    // Helper method to process SSR abort listeners
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(VCObserverWrapper, [
        {
            key: "processSsrAbortListeners",
            value: function processSsrAbortListeners() {
                var _window;
                // Process any SSR abort listeners that remain
                if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
                    // Clean up any event listeners that may have been registered during SSR
                    // This is centralized here so only the wrapper handles unbinding, not individual observers
                    if (window.__SSR_ABORT_LISTENERS__.unbinds && Array.isArray(window.__SSR_ABORT_LISTENERS__.unbinds)) window.__SSR_ABORT_LISTENERS__.unbinds.forEach(function(unbind) {
                        if (typeof unbind === 'function') unbind();
                    });
                    // After all observers had a chance to process abort events,
                    // we can safely delete the SSR_ABORT_LISTENERS object
                    delete window.__SSR_ABORT_LISTENERS__;
                }
            }
        },
        {
            key: "start",
            value: function start(_ref) {
                var _this$newVCObserver;
                var startTime = _ref.startTime, experienceKey = _ref.experienceKey;
                if ((0, $DtLwq.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $DtLwq.isVCRevisionEnabled)('fy25.02', experienceKey)) {
                    var _this$oldVCObserver;
                    (_this$oldVCObserver = this.oldVCObserver) === null || _this$oldVCObserver === void 0 || _this$oldVCObserver.start({
                        startTime: startTime
                    });
                }
                (_this$newVCObserver = this.newVCObserver) === null || _this$newVCObserver === void 0 || _this$newVCObserver.start({
                    startTime: startTime
                });
                // Clean up any remaining SSR abort listeners after all observers have been started
                this.processSsrAbortListeners();
            }
        },
        {
            key: "stop",
            value: function stop(experienceKey) {
                var _this$newVCObserver2;
                if ((0, $DtLwq.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $DtLwq.isVCRevisionEnabled)('fy25.02', experienceKey)) {
                    var _this$oldVCObserver2;
                    (_this$oldVCObserver2 = this.oldVCObserver) === null || _this$oldVCObserver2 === void 0 || _this$oldVCObserver2.stop();
                }
                (_this$newVCObserver2 = this.newVCObserver) === null || _this$newVCObserver2 === void 0 || _this$newVCObserver2.stop();
                (0, $hakpj.RLLPlaceholderHandlers).getInstance().reset();
                // Clear shared SSR placeholder handler
                this.ssrPlaceholderHandler.clear();
            }
        },
        {
            key: "getVCRawData",
            value: function getVCRawData() {
                var _this$oldVCObserver$g, _this$oldVCObserver3;
                return (_this$oldVCObserver$g = (_this$oldVCObserver3 = this.oldVCObserver) === null || _this$oldVCObserver3 === void 0 ? void 0 : _this$oldVCObserver3.getVCRawData()) !== null && _this$oldVCObserver$g !== void 0 ? _this$oldVCObserver$g : null;
            }
        },
        {
            key: "getVCResult",
            value: function() {
                var _getVCResult = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(param) {
                    var _this$oldVCObserver4, _this$newVCObserver3, _v3v4Result$, _ref2;
                    var experienceKey, include3p, excludeSmartAnswersInSearch, includeSSRRatio, includeRawData, v1v2Result, v3v4Result, ssrRatio, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                experienceKey = param.experienceKey, include3p = param.include3p, excludeSmartAnswersInSearch = param.excludeSmartAnswersInSearch, includeSSRRatio = param.includeSSRRatio, includeRawData = param.includeRawData;
                                if (!((0, $DtLwq.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $DtLwq.isVCRevisionEnabled)('fy25.02', experienceKey))) {
                                    _context.next = 2;
                                    break;
                                }
                                _context.next = 1;
                                return (_this$oldVCObserver4 = this.oldVCObserver) === null || _this$oldVCObserver4 === void 0 ? void 0 : _this$oldVCObserver4.getVCResult(param);
                            case 1:
                                _t = _context.sent;
                                _context.next = 3;
                                break;
                            case 2:
                                _t = {};
                            case 3:
                                v1v2Result = _t;
                                _context.next = 4;
                                return (_this$newVCObserver3 = this.newVCObserver) === null || _this$newVCObserver3 === void 0 ? void 0 : _this$newVCObserver3.getVCResult({
                                    start: param.start,
                                    stop: param.stop,
                                    interactionId: param.interactionId,
                                    ssr: param.ssr,
                                    include3p: include3p,
                                    excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
                                    includeSSRRatio: includeSSRRatio,
                                    interactionType: param.interactionType,
                                    isPageVisible: param.isPageVisible,
                                    interactionAbortReason: param.interactionAbortReason,
                                    includeRawData: includeRawData,
                                    includeSSRInV3: param.includeSSRInV3,
                                    rawDataStopTime: param.rawDataStopTime,
                                    reportLayoutShiftOffenders: param.reportLayoutShiftOffenders
                                });
                            case 4:
                                v3v4Result = _context.sent;
                                if (!(!v3v4Result || v3v4Result.length === 0)) {
                                    _context.next = 5;
                                    break;
                                }
                                return _context.abrupt("return", v1v2Result !== null && v1v2Result !== void 0 ? v1v2Result : {});
                            case 5:
                                ssrRatio = v3v4Result === null || v3v4Result === void 0 || (_v3v4Result$ = v3v4Result[0]) === null || _v3v4Result$ === void 0 ? void 0 : _v3v4Result$.ssrRatio;
                                return _context.abrupt("return", $c6aee11d2ac6279e$var$_objectSpread($c6aee11d2ac6279e$var$_objectSpread($c6aee11d2ac6279e$var$_objectSpread({}, includeSSRRatio && ssrRatio !== undefined ? {
                                    'ufo:vc:ssrRatio': ssrRatio
                                } : {}), v1v2Result), {}, {
                                    'ufo:vc:rev': [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((_ref2 = v1v2Result === null || v1v2Result === void 0 ? void 0 : v1v2Result['ufo:vc:rev']) !== null && _ref2 !== void 0 ? _ref2 : []), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(v3v4Result !== null && v3v4Result !== void 0 ? v3v4Result : []))
                                }));
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getVCResult(_x) {
                    return _getVCResult.apply(this, arguments);
                }
                return getVCResult;
            }()
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {
                var _this$oldVCObserver5, _this$newVCObserver4;
                (_this$oldVCObserver5 = this.oldVCObserver) === null || _this$oldVCObserver5 === void 0 || _this$oldVCObserver5.setSSRElement(element);
                (_this$newVCObserver4 = this.newVCObserver) === null || _this$newVCObserver4 === void 0 || _this$newVCObserver4.setReactRootElement(element);
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart(startTime) {
                var _this$oldVCObserver6, _this$newVCObserver5;
                (_this$oldVCObserver6 = this.oldVCObserver) === null || _this$oldVCObserver6 === void 0 || _this$oldVCObserver6.setReactRootRenderStart(startTime || performance.now());
                (_this$newVCObserver5 = this.newVCObserver) === null || _this$newVCObserver5 === void 0 || _this$newVCObserver5.setReactRootRenderStart(startTime || performance.now());
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop(stopTime) {
                var _this$oldVCObserver7, _this$newVCObserver6;
                (_this$oldVCObserver7 = this.oldVCObserver) === null || _this$oldVCObserver7 === void 0 || _this$oldVCObserver7.setReactRootRenderStop(stopTime || performance.now());
                (_this$newVCObserver6 = this.newVCObserver) === null || _this$newVCObserver6 === void 0 || _this$newVCObserver6.setReactRootRenderStop(stopTime || performance.now());
            }
        },
        {
            key: "collectSSRPlaceholders",
            value: function collectSSRPlaceholders() {
                this.ssrPlaceholderHandler.collectExistingPlaceholders();
            }
        }
    ]);
}();

});
parcelRegister("29WXY", function(module, exports) {
$parcel$export(module.exports, "VCObserver", () => $192a297dec8b876e$export$1f70d263701b1d01);

var $fC8ib = parcelRequire("fC8ib");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $6HG4S = parcelRequire("6HG4S");

var $50U6m = parcelRequire("50U6m");

var $DtLwq = parcelRequire("DtLwq");

var $iGolp = parcelRequire("iGolp");

var $aTuIj = parcelRequire("aTuIj");

var $fUErN = parcelRequire("fUErN");

var $01Gqw = parcelRequire("01Gqw");

var $3co2j = parcelRequire("3co2j");

var $e34mJ = parcelRequire("e34mJ");

var $3H0iK = parcelRequire("3H0iK");
var $192a297dec8b876e$var$_excluded = [
    "__debug__element"
];
function $192a297dec8b876e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $192a297dec8b876e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $192a297dec8b876e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $192a297dec8b876e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $192a297dec8b876e$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
var $192a297dec8b876e$var$UNUSED_SECTOR = 0;
function $192a297dec8b876e$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), timestamp = _ref2[0], entries = _ref2[1];
        return [
            Number(timestamp),
            entries.map(function(entry) {
                var __debug__element = entry.__debug__element, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(entry, $192a297dec8b876e$var$_excluded);
                return rest;
            })
        ];
    }));
}
var $192a297dec8b876e$export$1f70d263701b1d01 = /*#__PURE__*/ function() {
    function VCObserver(options) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, VCObserver);
        /* abort logic */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "abortReason", {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "outOfBoundaryInfo", '');
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "viewport", {
            w: 0,
            h: 0
        });
        /* heatmap */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "arraySize", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "componentsLog", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "vcRatios", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "active", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "totalTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "startTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_startMeasureTimestamp", -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "ssr", {
            reactRendered: -1
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "unbind", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getAbortReasonInfo", function() {
            if (_this.abortReason.reason === null) return null;
            var info = _this.abortReason.info !== '' ? " ".concat(_this.abortReason.info) : '';
            return "".concat(_this.abortReason.reason).concat(info);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getVCRawData", function() {
            _this.measureStart();
            if (!_this.active) {
                _this.measureStop();
                return null;
            }
            _this.stop();
            var abortReasonInfo = _this.getAbortReasonInfo();
            _this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: $192a297dec8b876e$var$_objectSpread({}, _this.abortReason),
                heatmap: _this.heatmap,
                heatmapNext: _this.heatmapNext,
                outOfBoundaryInfo: _this.outOfBoundaryInfo,
                totalTime: Math.round(_this.totalTime + _this.observers.getTotalTime()),
                componentsLog: $192a297dec8b876e$var$_objectSpread({}, _this.componentsLog),
                viewport: $192a297dec8b876e$var$_objectSpread({}, _this.viewport),
                oldDomUpdatesEnabled: _this.oldDomUpdatesEnabled,
                devToolsEnabled: _this.devToolsEnabled,
                ratios: _this.vcRatios
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getVCResult", /*#__PURE__*/ function() {
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_ref3) {
                var start, stop, tti, prefix, ssr, vc, isEventAborted, experienceKey, interactionId, includeSSRRatio, startTime, fullPrefix, rawData, abortReason, abortReasonInfo, heatmap, heatmapNext, outOfBoundaryInfo, totalTime, componentsLog, viewport, devToolsEnabled, ratios, isTTVCv1Disabled, vcAbortedResultWithRevisions, ttvcV1Result, VC, VCBox, VCEntries, totalPainted, _componentsLog, vcNext, outOfBoundary, stopTime, ttvcV1DevToolInfo, ttvcV2DevToolInfo, shouldCreateDebugDetails, v1RevisionDebugDetails, v2RevisionDebugDetails, _window$__ufo_devtool2, _window2, _window$__ufo_devtool, _window, _window$__on_ufo_vc_d2, _window4, _window$__on_ufo_vc_d, _window3, isVCClean, revisionsData, speedIndex, SSRRatio, SSRRatioNext, SSRRatioPayload, isTTVCv3Enabled;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            start = _ref3.start, stop = _ref3.stop, tti = _ref3.tti, prefix = _ref3.prefix, ssr = _ref3.ssr, vc = _ref3.vc, isEventAborted = _ref3.isEventAborted, experienceKey = _ref3.experienceKey, interactionId = _ref3.interactionId, includeSSRRatio = _ref3.includeSSRRatio;
                            startTime = performance.now(); // add local measurement
                            fullPrefix = prefix !== undefined && prefix !== '' ? "".concat(prefix, ":") : '';
                            rawData = vc !== undefined ? vc : _this.getVCRawData();
                            if (!(rawData === null)) {
                                _context.next = 1;
                                break;
                            }
                            return _context.abrupt("return", {});
                        case 1:
                            abortReason = rawData.abortReason, abortReasonInfo = rawData.abortReasonInfo, heatmap = rawData.heatmap, heatmapNext = rawData.heatmapNext, outOfBoundaryInfo = rawData.outOfBoundaryInfo, totalTime = rawData.totalTime, componentsLog = rawData.componentsLog, viewport = rawData.viewport, devToolsEnabled = rawData.devToolsEnabled, ratios = rawData.ratios;
                            isTTVCv1Disabled = !(0, $DtLwq.isVCRevisionEnabled)('fy25.01', experienceKey);
                            if (!(abortReasonInfo !== null)) {
                                _context.next = 2;
                                break;
                            }
                            // exposing data to devtools
                            try {
                                if (devToolsEnabled && !_this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                            } catch (_unused) {}
                            vcAbortedResultWithRevisions = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:rev"), [
                                {
                                    revision: 'fy25.02',
                                    clean: false,
                                    'metric:vc90': null,
                                    abortReason: abortReason.reason,
                                    abortTimestamp: Math.round(abortReason.timestamp)
                                }
                            ]);
                            if (!isTTVCv1Disabled) vcAbortedResultWithRevisions["".concat(fullPrefix, "vc:rev")].push({
                                revision: 'fy25.01',
                                clean: false,
                                'metric:vc90': null,
                                abortReason: abortReason.reason,
                                abortTimestamp: Math.round(abortReason.timestamp)
                            });
                            return _context.abrupt("return", vcAbortedResultWithRevisions);
                        case 2:
                            ttvcV1Result = isTTVCv1Disabled ? {
                                VC: {},
                                VCBox: {},
                                VCEntries: {
                                    abs: [],
                                    rel: [],
                                    speedIndex: -1
                                },
                                totalPainted: -1
                            } : VCObserver.calculateVC({
                                heatmap: heatmap,
                                ssr: ssr,
                                componentsLog: $192a297dec8b876e$var$_objectSpread({}, componentsLog),
                                viewport: viewport,
                                fixSSRAttribution: includeSSRRatio
                            });
                            VC = ttvcV1Result.VC, VCBox = ttvcV1Result.VCBox, VCEntries = ttvcV1Result.VCEntries, totalPainted = ttvcV1Result.totalPainted;
                            _componentsLog = {};
                            Object.entries(_this.componentsLog).forEach(function(_ref5) {
                                var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref5, 2), _timestamp = _ref6[0], value = _ref6[1];
                                var timestamp = Number(_timestamp);
                                if (stop > timestamp) _componentsLog[timestamp] = value;
                            });
                            vcNext = VCObserver.calculateVC({
                                heatmap: heatmapNext,
                                ssr: ssr,
                                componentsLog: _componentsLog,
                                viewport: viewport,
                                fixSSRAttribution: includeSSRRatio
                            });
                            outOfBoundary = outOfBoundaryInfo ? (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:oob"), outOfBoundaryInfo) : {}; //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
                            stopTime = performance.now(); // exposing data to devtools
                            try {
                                if (!_this.isPostInteraction && devToolsEnabled) {
                                    ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                                        entries: VCEntries.rel,
                                        log: componentsLog,
                                        metrics: {
                                            '75': VC['75'],
                                            '80': VC['80'],
                                            '85': VC['85'],
                                            '90': VC['90'],
                                            '95': VC['95'],
                                            '98': VC['98'],
                                            '99': VC['99'],
                                            tti: tti,
                                            ttai: stop - start
                                        },
                                        start: start,
                                        stop: stop,
                                        heatmap: heatmap,
                                        ratios: ratios
                                    };
                                    ttvcV2DevToolInfo = {
                                        entries: vcNext.VCEntries.rel,
                                        log: componentsLog,
                                        metrics: {
                                            '75': vcNext.VC['75'],
                                            '80': vcNext.VC['80'],
                                            '85': vcNext.VC['85'],
                                            '90': vcNext.VC['90'],
                                            '95': vcNext.VC['95'],
                                            '98': vcNext.VC['98'],
                                            '99': vcNext.VC['99'],
                                            tti: tti,
                                            ttai: stop - start
                                        },
                                        start: start,
                                        stop: stop,
                                        heatmap: heatmapNext,
                                        ratios: ratios
                                    };
                                    if (isTTVCv1Disabled) {
                                        window.__vc = ttvcV2DevToolInfo;
                                        window.__vcNext = ttvcV2DevToolInfo;
                                    } else {
                                        window.__vc = ttvcV1DevToolInfo;
                                        window.__vcNext = ttvcV2DevToolInfo;
                                    }
                                    // Emitting a custom event to make it available in the Chrome extension
                                    window.dispatchEvent(new CustomEvent('vcReady', {
                                        detail: {
                                            log: $192a297dec8b876e$var$filterComponentsLog(componentsLog),
                                            entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                                        }
                                    }));
                                }
                                if (!_this.isPostInteraction) {
                                    // Only create revision debug details if callbacks exist
                                    shouldCreateDebugDetails = typeof window.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window.__on_ufo_vc_debug_data_ready === 'function';
                                    if (shouldCreateDebugDetails) {
                                        v1RevisionDebugDetails = (0, $fUErN.getVCRevisionDebugDetails)({
                                            revision: 'fy25.01',
                                            isClean: !abortReasonInfo,
                                            abortReason: abortReason.reason,
                                            VCEntries: VCEntries.rel,
                                            componentsLog: componentsLog,
                                            interactionId: interactionId
                                        });
                                        v2RevisionDebugDetails = (0, $fUErN.getVCRevisionDebugDetails)({
                                            revision: 'fy25.02',
                                            isClean: !abortReasonInfo,
                                            abortReason: abortReason.reason,
                                            VCEntries: vcNext.VCEntries.rel,
                                            componentsLog: componentsLog,
                                            interactionId: interactionId
                                        }); // Add devtool callback for both v1 and v2
                                        if (typeof window.__ufo_devtool_onVCRevisionReady__ === 'function') {
                                            // Handle v1 if not disabled
                                            if (!isTTVCv1Disabled) (_window$__ufo_devtool = (_window = window).__ufo_devtool_onVCRevisionReady__) === null || _window$__ufo_devtool === void 0 || _window$__ufo_devtool.call(_window, v1RevisionDebugDetails);
                                            // Handle v2
                                            (_window$__ufo_devtool2 = (_window2 = window).__ufo_devtool_onVCRevisionReady__) === null || _window$__ufo_devtool2 === void 0 || _window$__ufo_devtool2.call(_window2, v2RevisionDebugDetails);
                                        }
                                        if (typeof window.__on_ufo_vc_debug_data_ready === 'function') {
                                            if (!isTTVCv1Disabled) (_window$__on_ufo_vc_d = (_window3 = window).__on_ufo_vc_debug_data_ready) === null || _window$__on_ufo_vc_d === void 0 || _window$__on_ufo_vc_d.call(_window3, v1RevisionDebugDetails);
                                            (_window$__on_ufo_vc_d2 = (_window4 = window).__on_ufo_vc_debug_data_ready) === null || _window$__on_ufo_vc_d2 === void 0 || _window$__on_ufo_vc_d2.call(_window4, v2RevisionDebugDetails);
                                        }
                                    }
                                }
                            } catch (_unused2) {
                            /*  do nothing */ }
                            isVCClean = !abortReasonInfo;
                            revisionsData = (0, $01Gqw.getVCRevisionsData)({
                                fullPrefix: fullPrefix,
                                interaction: {
                                    start: start,
                                    end: stop
                                },
                                isVCClean: isVCClean,
                                calculatedVC: {
                                    VC: VC,
                                    VCBox: VCBox
                                },
                                calculatedVCNext: {
                                    VC: vcNext.VC,
                                    VCBox: vcNext.VCBox
                                },
                                isEventAborted: isEventAborted,
                                experienceKey: experienceKey,
                                ratios: ratios
                            });
                            speedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "ufo:speedIndex", isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex), "ufo:next:speedIndex", vcNext.VCEntries.speedIndex);
                            SSRRatio = VCObserver.getSSRRatio(VCEntries.rel, ssr);
                            SSRRatioNext = VCObserver.getSSRRatio(vcNext.VCEntries.rel, ssr);
                            SSRRatioPayload = includeSSRRatio ? (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:ssrRatio"), isTTVCv1Disabled ? SSRRatioNext : SSRRatio), "".concat(fullPrefix, "vc:next:ssrRatio"), SSRRatioNext) : {};
                            if (!isTTVCv1Disabled) {
                                _context.next = 3;
                                break;
                            }
                            return _context.abrupt("return", $192a297dec8b876e$var$_objectSpread($192a297dec8b876e$var$_objectSpread($192a297dec8b876e$var$_objectSpread($192a297dec8b876e$var$_objectSpread((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:size"), viewport), "".concat(fullPrefix, "vc:time"), Math.round(totalTime + (stopTime - startTime))), "".concat(fullPrefix, "vc:ratios"), ratios), outOfBoundary), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:ignored"), _this.getIgnoredElements(componentsLog)), SSRRatioPayload), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:ssrRatio"), SSRRatioNext), revisionsData), speedIndex));
                        case 3:
                            isTTVCv3Enabled = (0, $DtLwq.isVCRevisionEnabled)('fy25.03', experienceKey);
                            return _context.abrupt("return", $192a297dec8b876e$var$_objectSpread($192a297dec8b876e$var$_objectSpread($192a297dec8b876e$var$_objectSpread($192a297dec8b876e$var$_objectSpread((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
                                'metrics:vc': VC
                            }, "".concat(fullPrefix, "vc:state"), true), "".concat(fullPrefix, "vc:clean"), isVCClean), "".concat(fullPrefix, "vc:dom"), VCBox), "".concat(fullPrefix, "vc:updates"), isTTVCv3Enabled ? undefined : VCEntries.rel.slice(0, 50)), "".concat(fullPrefix, "vc:size"), viewport), "".concat(fullPrefix, "vc:time"), Math.round(totalTime + (stopTime - startTime))), "".concat(fullPrefix, "vc:total"), totalPainted), "".concat(fullPrefix, "vc:ratios"), ratios), "".concat(fullPrefix, "vc:ssrRatio"), SSRRatio), outOfBoundary), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:next"), vcNext.VC), "".concat(fullPrefix, "vc:next:updates"), isTTVCv3Enabled ? undefined : vcNext.VCEntries.rel.slice(0, 50)), "".concat(fullPrefix, "vc:next:dom"), vcNext.VCBox), SSRRatioPayload), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:ignored"), _this.getIgnoredElements(componentsLog)), revisionsData), speedIndex));
                        case 4:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x) {
                return _ref4.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "handleUpdate", function(rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue) {
            if (_this.abortReason.reason === null || _this.abortReason.blocking === false) {
                var time = Math.round(rawTime - _this.startTime);
                var mappedValues = _this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                _this.vcRatios[targetName] = _this.getElementRatio(mappedValues);
                if (!ignoreReason) _this.applyChangesToHeatMap(mappedValues, time, _this.heatmapNext);
                var interaction = (0, $iGolp.getActiveInteraction)();
                var isTTVCv1Disabled = !(0, $DtLwq.isVCRevisionEnabled)('fy25.01', interaction === null || interaction === void 0 ? void 0 : interaction.ufoName);
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') _this.applyChangesToHeatMap(mappedValues, time, _this.heatmap);
                if (!_this.componentsLog[time]) _this.componentsLog[time] = [];
                _this.componentsLog[time].push({
                    __debug__element: _this.devToolsEnabled ? new WeakRef(element) : null,
                    type: type,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "mapPixelsToHeatmap", function(left, top, width, height) {
            var _this$viewport = _this.viewport, w = _this$viewport.w, h = _this$viewport.h;
            var l = Math.floor(left / w * _this.arraySize);
            var t = Math.floor(top / h * _this.arraySize);
            var r = Math.ceil((left + width) / w * _this.arraySize);
            var b = Math.ceil((top + height) / h * _this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (_this.outOfBoundaryInfo === '') {
                var outOfBoundaryInfo = '';
                if (r > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(left, " ").concat(width);
                if (b > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(top, " ").concat(height);
                _this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            var result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(_this.arraySize, r),
                b: Math.min(_this.arraySize, b)
            };
            return result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getElementRatio", function(mappedValues) {
            var r = mappedValues.r, l = mappedValues.l, b = mappedValues.b, t = mappedValues.t;
            return (r - l) * (b - t) / (_this.arraySize * _this.arraySize);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "abortReasonCallback", function(key, time) {
            switch(key){
                case 'wheel':
                    _this.setAbortReason($192a297dec8b876e$var$abortReason.scroll, time);
                    break;
                case 'keydown':
                    // Don't abort press interactions on keydown events, as keydown is expected
                    // when users press Enter/Space to activate buttons or other interactive elements
                    if ((0, $50U6m.fg)('platform_ufo_keypress_interaction_abort')) {
                        var interaction = (0, $iGolp.getActiveInteraction)();
                        if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') break;
                    }
                    _this.setAbortReason($192a297dec8b876e$var$abortReason.keypress, time);
                    break;
                case 'resize':
                    _this.setAbortReason($192a297dec8b876e$var$abortReason.resize, time);
                    break;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "attachAbortListeners", function() {
            var _window5;
            _this.detachAbortListeners();
            var unbinds = (0, $aTuIj.attachAbortListeners)(window, _this.viewport, _this.abortReasonCallback);
            if ((_window5 = window) !== null && _window5 !== void 0 && _window5.__SSR_ABORT_LISTENERS__) Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(function(_ref9) {
                var _ref0 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref9, 2), key = _ref0[0], time = _ref0[1];
                if (time) _this.abortReasonCallback(key, time);
            });
            _this.unbind = unbinds;
        });
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        var ssrEnablePageLayoutPlaceholder = options.ssrEnablePageLayoutPlaceholder, ssrPlaceholderHandler = options.ssrPlaceholderHandler;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It enforces FedRAMP-override > caller-override >
        // centrally configured > caller default. When `getSelectorConfig()`
        // returns `undefined` we fall back to the legacy hard-coded default
        // to preserve pre-existing behaviour for callers that don't pass an
        // explicit `selectorConfig`.
        var LEGACY_DEFAULT_SELECTOR_CONFIG = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.observers = new (0, $3H0iK.Observers)({
            selectorConfig: (0, $DtLwq.getSelectorConfig)(options.selectorConfig, LEGACY_DEFAULT_SELECTOR_CONFIG) || options.selectorConfig || LEGACY_DEFAULT_SELECTOR_CONFIG,
            SSRConfig: {
                enablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder || false
            },
            ssrPlaceholderHandler: ssrPlaceholderHandler
        });
        this.heatmap = !(0, $DtLwq.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.isPostInteraction = options.isPostInteraction || false;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(VCObserver, [
        {
            key: "start",
            value: function start(_ref1) {
                var startTime = _ref1.startTime;
                this.active = true;
                if (this.observers.isBrowserSupported()) {
                    this.setViewportSize();
                    this.resetState();
                    this.startTime = startTime;
                    this.attachAbortListeners();
                    this.observers.subscribeResults(this.handleUpdate);
                    this.observers.observe();
                } else this.setAbortReason('not-supported', startTime);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.observers.disconnect();
                this.detachAbortListeners();
            }
        },
        {
            key: "getIgnoredElements",
            value: function getIgnoredElements(componentsLog) {
                return Object.values(componentsLog).flat().filter(function(_ref10) {
                    var ignoreReason = _ref10.ignoreReason;
                    return Boolean(ignoreReason);
                }).map(function(_ref11) {
                    var targetName = _ref11.targetName, ignoreReason = _ref11.ignoreReason;
                    return {
                        targetName: targetName,
                        ignoreReason: ignoreReason
                    };
                });
            }
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {
                this.observers.setReactRootElement(element);
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStart(startTime);
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStop(stopTime);
            }
        },
        {
            key: "collectSSRPlaceholders",
            value: function collectSSRPlaceholders() {
            // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
            // Individual observers don't need to implement this
            }
        },
        {
            key: "setAbortReason",
            value: function setAbortReason(abort, timestamp) {
                var info = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
                if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                    this.abortReason.reason = abort;
                    this.abortReason.info = info;
                    this.abortReason.timestamp = timestamp;
                    this.abortReason.blocking = abort !== $192a297dec8b876e$var$abortReason.scroll;
                    if (this.abortReason.blocking) this.detachAbortListeners();
                }
            }
        },
        {
            key: "resetState",
            value: function resetState() {
                this.abortReason = {
                    reason: null,
                    info: '',
                    timestamp: -1,
                    blocking: false
                };
                this.detachAbortListeners();
                this.heatmap = !(0, $DtLwq.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
                this.heatmapNext = this.getCleanHeatmap();
                this.totalTime = 0;
                this.componentsLog = {};
                this.vcRatios = {};
            }
        },
        {
            key: "getCleanHeatmap",
            value: function getCleanHeatmap() {
                var _this2 = this;
                return Array(this.arraySize).fill('').map(function() {
                    return Array(_this2.arraySize).fill($192a297dec8b876e$var$UNUSED_SECTOR);
                });
            }
        },
        {
            key: "setViewportSize",
            value: function setViewportSize() {
                this.viewport.w = (0, $e34mJ.getViewportWidth)();
                this.viewport.h = (0, $3co2j.getViewportHeight)();
            }
        },
        {
            key: "applyChangesToHeatMap",
            value: function applyChangesToHeatMap(a, time, heatmap) {
                var l = a.l, t = a.t, r = a.r, b = a.b;
                var localHeatmap = heatmap;
                for(var row = t; row < b; row++){
                    for(var col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                        try {
                            this.setAbortReason($192a297dec8b876e$var$abortReason.error, time, "index - ".concat(row));
                        } catch (_unused3) {
                            this.setAbortReason($192a297dec8b876e$var$abortReason.error, time, 'row error');
                        }
                        return;
                    } else localHeatmap[row][col] = time;
                }
            }
        },
        {
            key: "detachAbortListeners",
            value: function detachAbortListeners() {
                if (this.unbind) {
                    var unbind = this.unbind;
                    for(var i = 0; i < unbind.length; i++)unbind[i]();
                    this.unbind.length = 0;
                }
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ], [
        {
            key: "getSSRRatio",
            value: function getSSRRatio(entries, ssr) {
                if (ssr === undefined || entries.length === 0) return undefined;
                var maybeSSR = entries[0];
                if (maybeSSR.elements[0] === 'SSR') return maybeSSR.vc;
                return 0;
            }
        },
        {
            key: "calculateVC",
            value: function calculateVC(_ref12) {
                var heatmap = _ref12.heatmap, _ref12$ssr = _ref12.ssr, ssr = _ref12$ssr === void 0 ? $192a297dec8b876e$var$UNUSED_SECTOR : _ref12$ssr, componentsLog = _ref12.componentsLog, viewport = _ref12.viewport, fixSSRAttribution = _ref12.fixSSRAttribution;
                var lastUpdate = {};
                var totalPainted = 0;
                var ssrTime = fixSSRAttribution ? Math.floor(ssr) : ssr;
                if (ssrTime !== $192a297dec8b876e$var$UNUSED_SECTOR) {
                    var _window$document;
                    var element = {
                        __debug__element: new WeakRef((_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.body),
                        intersectionRect: {
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            x: 0,
                            y: 0,
                            width: viewport.w,
                            height: viewport.h,
                            toJSON: function toJSON() {
                                return {};
                            }
                        },
                        targetName: 'SSR'
                    };
                    if (!componentsLog[ssrTime]) componentsLog[ssrTime] = [];
                    componentsLog[ssrTime].push(element);
                }
                heatmap.forEach(function(line) {
                    line.forEach(function(entry) {
                        var rounded = Math.floor(entry === $192a297dec8b876e$var$UNUSED_SECTOR && ssrTime !== $192a297dec8b876e$var$UNUSED_SECTOR ? ssrTime : entry);
                        totalPainted += rounded !== $192a297dec8b876e$var$UNUSED_SECTOR ? 1 : 0;
                        if (rounded !== $192a297dec8b876e$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
                    });
                });
                var entries = Object.entries(lastUpdate).map(function(a) {
                    return [
                        parseInt(a[0], 10),
                        a[1]
                    ];
                }).sort(function(a, b) {
                    return a[0] > b[0] ? 1 : -1;
                });
                var VC = VCObserver.makeVCReturnObj();
                var VCBox = VCObserver.makeVCReturnObj();
                entries.reduce(function() {
                    var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var v = arguments.length > 1 ? arguments[1] : undefined;
                    var currRatio = v[1] / totalPainted;
                    var VCRatio = currRatio + acc;
                    var preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
                    var preciseAccRatio = Math.round(acc * 100);
                    VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
                    var time = v[0];
                    VCObserver.VCParts.forEach(function(key) {
                        var value = parseInt(key, 10);
                        if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                            var _componentsLog$time;
                            VC[key] = time;
                            VCBox[key] = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set((_componentsLog$time = componentsLog[time]) === null || _componentsLog$time === void 0 ? void 0 : _componentsLog$time.filter(function(v) {
                                return !v.ignoreReason;
                            }).map(function(v) {
                                return v.targetName;
                            })));
                        }
                    });
                    return VCRatio;
                }, 0);
                var VCEntries = entries.reduce(function(acc, _ref13, i) {
                    var _acc$abs, _componentsLog$timest, _acc$rel$vc, _acc$rel;
                    var _ref14 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref13, 2), timestamp = _ref14[0], entryPainted = _ref14[1];
                    var currentlyPainted = entryPainted + (((_acc$abs = acc.abs[i - 1]) === null || _acc$abs === void 0 ? void 0 : _acc$abs[1]) || 0);
                    var currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
                    var logEntry = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set((_componentsLog$timest = componentsLog[timestamp]) === null || _componentsLog$timest === void 0 ? void 0 : _componentsLog$timest.filter(function(v) {
                        return !v.ignoreReason;
                    }).map(function(v) {
                        return v.targetName;
                    })));
                    var ratioDelta = (currentlyPaintedRatio - ((_acc$rel$vc = (_acc$rel = acc.rel[i - 1]) === null || _acc$rel === void 0 ? void 0 : _acc$rel.vc) !== null && _acc$rel$vc !== void 0 ? _acc$rel$vc : 0)) / 100;
                    var speedIndex = timestamp * ratioDelta;
                    acc.speedIndex += speedIndex;
                    acc.abs.push([
                        timestamp,
                        currentlyPainted
                    ]);
                    acc.rel.push({
                        time: timestamp,
                        vc: currentlyPaintedRatio,
                        elements: logEntry
                    });
                    return acc;
                }, {
                    abs: [],
                    rel: [],
                    speedIndex: 0
                });
                VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
                return {
                    VC: VC,
                    VCBox: VCBox,
                    VCEntries: VCEntries,
                    totalPainted: totalPainted
                };
            }
        },
        {
            key: "makeVCReturnObj",
            value: function makeVCReturnObj() {
                var vc = {};
                VCObserver.VCParts.forEach(function(v) {
                    vc[v] = null;
                });
                return vc;
            }
        }
    ]);
}();
/** config * */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($192a297dec8b876e$export$1f70d263701b1d01, "VCParts", [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
]);

});
parcelRegister("aTuIj", function(module, exports) {
$parcel$export(module.exports, "attachAbortListeners", () => $7ee6dd8fb784756d$export$9010aa71841a6887);

var $7QpUe = parcelRequire("7QpUe");

var $bIlUG = parcelRequire("bIlUG");

var $3co2j = parcelRequire("3co2j");

var $e34mJ = parcelRequire("e34mJ");
function $7ee6dd8fb784756d$export$9010aa71841a6887(window, initialViewPort, callback) {
    var unbindWheel = (0, $7QpUe.bind)(window, {
        type: (0, $bIlUG.AbortEvent).wheel,
        listener: function listener(e) {
            callback((0, $bIlUG.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    var unbindKeydown = (0, $7QpUe.bind)(window, {
        type: (0, $bIlUG.AbortEvent).keydown,
        listener: function listener(e) {
            callback((0, $bIlUG.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    var unbindResize = (0, $7QpUe.bind)(window, {
        type: (0, $bIlUG.AbortEvent).resize,
        listener: function listener(e) {
            if ((0, $e34mJ.getViewportWidth)() !== initialViewPort.w || (0, $3co2j.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $bIlUG.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}

});
parcelRegister("bIlUG", function(module, exports) {
$parcel$export(module.exports, "AbortEvent", () => $8874cd440e9e8d1b$export$199edc0307b5587f);
var $8874cd440e9e8d1b$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};

});

parcelRegister("3co2j", function(module, exports) {
$parcel$export(module.exports, "getViewportHeight", () => $2545232ee73eb342$export$4f01c15d21ef9cc6);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $2545232ee73eb342$export$4f01c15d21ef9cc6() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (_unused) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

});

parcelRegister("e34mJ", function(module, exports) {
$parcel$export(module.exports, "getViewportWidth", () => $a3a4bb685fab145e$export$a497a1dcb4408212);
function $a3a4bb685fab145e$export$a497a1dcb4408212() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (_unused) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}

});


parcelRegister("fUErN", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionDebugDetails", () => $b95b75f734c61ed0$export$72e6dda9d5859230);

var $iYJcE = parcelRequire("iYJcE");

var $fC8ib = parcelRequire("fC8ib");
function $b95b75f734c61ed0$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $b95b75f734c61ed0$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $b95b75f734c61ed0$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b95b75f734c61ed0$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b95b75f734c61ed0$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b95b75f734c61ed0$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $b95b75f734c61ed0$export$72e6dda9d5859230(_ref) {
    var revision = _ref.revision, isClean = _ref.isClean, abortReason = _ref.abortReason, VCEntries = _ref.VCEntries, componentsLog = _ref.componentsLog, interactionId = _ref.interactionId;
    // Pre-sort VCEntries by time for efficient lookups
    var sortedVCEntries = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(VCEntries).sort(function(a, b) {
        return a.time - b.time;
    });
    // Pre-calculate max viewport percentage up to each time for efficient lookups
    var maxViewportPercentageAtTime = new Map();
    var maxSoFar = 0;
    var _iterator = $b95b75f734c61ed0$var$_createForOfIteratorHelper(sortedVCEntries), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var entry = _step.value;
            maxSoFar = Math.max(maxSoFar, entry.vc);
            maxViewportPercentageAtTime.set(entry.time, maxSoFar);
        }
    // Helper function to find the biggest previous viewport percentage
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var getBiggestPreviousViewportPercentage = function getBiggestPreviousViewportPercentage(targetTime) {
        // Binary search for the largest time <= targetTime
        var left = 0;
        var right = sortedVCEntries.length - 1;
        var result = -1;
        while(left <= right){
            var mid = Math.floor((left + right) / 2);
            if (sortedVCEntries[mid].time <= targetTime) {
                result = mid;
                left = mid + 1;
            } else right = mid - 1;
        }
        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVCEntries[result].time) || null : null;
    };
    var allVcLogs = [];
    // Add regular VC entries
    var _iterator2 = $b95b75f734c61ed0$var$_createForOfIteratorHelper(VCEntries), _step2;
    try {
        var _loop = function _loop() {
            var entry = _step2.value;
            var timeLogEntries = componentsLog[entry.time];
            allVcLogs.push({
                time: entry.time,
                viewportPercentage: entry.vc,
                entries: entry.elements.map(function(element) {
                    var logEntry = timeLogEntries === null || timeLogEntries === void 0 ? void 0 : timeLogEntries.find(function(log) {
                        return log.targetName === element;
                    });
                    return {
                        elementName: element,
                        type: logEntry === null || logEntry === void 0 ? void 0 : logEntry.type,
                        rect: logEntry === null || logEntry === void 0 ? void 0 : logEntry.intersectionRect,
                        visible: true,
                        attributeName: logEntry === null || logEntry === void 0 ? void 0 : logEntry.attributeName,
                        oldValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.oldValue,
                        newValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.newValue,
                        ignoreReason: logEntry === null || logEntry === void 0 ? void 0 : logEntry.ignoreReason
                    };
                })
            });
        };
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;)_loop();
    // Add ignored elements - only process timestamps that have ignored elements
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    for(var _i = 0, _Object$entries = Object.entries(componentsLog); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i], 2), timestamp = _Object$entries$_i[0], timeLogEntries = _Object$entries$_i[1];
        var ignoredElements = timeLogEntries.filter(function(log) {
            return log.ignoreReason;
        });
        if (ignoredElements.length === 0) continue;
        var time = Number(timestamp);
        var viewportPercentage = getBiggestPreviousViewportPercentage(time);
        allVcLogs.push({
            time: time,
            viewportPercentage: viewportPercentage,
            entries: ignoredElements.map(function(logEntry) {
                return {
                    elementName: logEntry.targetName,
                    type: logEntry.type,
                    rect: logEntry.intersectionRect,
                    visible: false,
                    attributeName: logEntry.attributeName,
                    oldValue: logEntry.oldValue,
                    newValue: logEntry.newValue,
                    ignoreReason: logEntry.ignoreReason
                };
            })
        });
    }
    // Sort once at the end
    allVcLogs.sort(function(a, b) {
        return a.time - b.time;
    });
    return {
        revision: revision,
        isClean: isClean,
        abortReason: abortReason,
        vcLogs: allVcLogs,
        interactionId: interactionId
    };
}

});

parcelRegister("01Gqw", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionsData", () => $0051012bc08f4886$export$5c86a34c9becd6d0);

var $25nEq = parcelRequire("25nEq");

var $DtLwq = parcelRequire("DtLwq");

var $h9fNq = parcelRequire("h9fNq");
function $0051012bc08f4886$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $0051012bc08f4886$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $0051012bc08f4886$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $0051012bc08f4886$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $0051012bc08f4886$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $0051012bc08f4886$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $0051012bc08f4886$var$VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
var $0051012bc08f4886$var$READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
function $0051012bc08f4886$var$createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    var details = {};
    var VC = calculatedVC.VC, VCBox = calculatedVC.VCBox; // Destructure once to avoid repeated property access
    var _iterator = $0051012bc08f4886$var$_createForOfIteratorHelper($0051012bc08f4886$var$VCParts), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            details[key] = {
                t: VC[key] || -1,
                e: VCBox[key] || $0051012bc08f4886$var$READONLY_EMPTY_ARRAY
            };
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return details;
}
function $0051012bc08f4886$export$5c86a34c9becd6d0(_ref) {
    var fullPrefix = _ref.fullPrefix, interaction = _ref.interaction, isVCClean = _ref.isVCClean, isEventAborted = _ref.isEventAborted, calculatedVC = _ref.calculatedVC, calculatedVCNext = _ref.calculatedVCNext, experienceKey = _ref.experienceKey, ratios = _ref.ratios;
    var pageVisibilityUpToTTAI = (0, $h9fNq.getPageVisibilityState)(interaction.start, interaction.end);
    var isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    var shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    var availableVCRevisionPayloads = [];
    if ((0, $DtLwq.isVCRevisionEnabled)('fy25.01', experienceKey)) {
        var revision = {
            revision: 'fy25.01',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
            vcDetails: $0051012bc08f4886$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    if ((0, $DtLwq.isVCRevisionEnabled)('fy25.02', experienceKey)) {
        var _revision = {
            revision: 'fy25.02',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
            vcDetails: $0051012bc08f4886$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) _revision.ratios = ratios;
        availableVCRevisionPayloads.push(_revision);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:rev"), availableVCRevisionPayloads);
}

});
parcelRegister("h9fNq", function(module, exports) {
$parcel$export(module.exports, "getEarliestHiddenTiming", () => $c7bf87bfb769b3be$export$754443ce7c615bd7);
$parcel$export(module.exports, "isOpenedInBackground", () => $c7bf87bfb769b3be$export$21a1a62a307062f1);
$parcel$export(module.exports, "getHasHiddenTimingBeforeSetup", () => $c7bf87bfb769b3be$export$95f048bd8bcdda23);
$parcel$export(module.exports, "setupHiddenTimingCapture", () => $c7bf87bfb769b3be$export$554cefe0f0373da4);
$parcel$export(module.exports, "getPageVisibilityState", () => $c7bf87bfb769b3be$export$768b2008623433e1);
$parcel$export(module.exports, "setupThrottleDetection", () => $c7bf87bfb769b3be$export$fa0d29a9c87052da);
$parcel$export(module.exports, "isTabThrottled", () => $c7bf87bfb769b3be$export$62a28c860277b3bf);
$parcel$export(module.exports, "getPageVisibilityTimeline", () => $c7bf87bfb769b3be$export$5a06b84e47ad70d9);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $7QpUe = parcelRequire("7QpUe");

var $50U6m = parcelRequire("50U6m");
var $c7bf87bfb769b3be$var$timings = [];
var $c7bf87bfb769b3be$var$wasHiddenFlag;
var $c7bf87bfb769b3be$var$setupFlag = false;
// Threshold for determining if page was opened in background.
// If setup runs within this time and page is hidden, we assume it was opened in a background tab.
var $c7bf87bfb769b3be$var$OPENED_IN_BACKGROUND_THRESHOLD_MS = 100;
var $c7bf87bfb769b3be$var$openedInBackground = null;
function $c7bf87bfb769b3be$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
var $c7bf87bfb769b3be$var$SIZE = 50;
var $c7bf87bfb769b3be$var$insertIndex = 0;
function $c7bf87bfb769b3be$export$754443ce7c615bd7(startTime, endTime) {
    var _timings$find;
    var earliestHiddenTiming = (_timings$find = $c7bf87bfb769b3be$var$timings.find(function(_ref) {
        var hidden = _ref.hidden, time = _ref.time;
        return hidden && time > 0 && time >= startTime && time <= endTime;
    })) === null || _timings$find === void 0 ? void 0 : _timings$find.time;
    if (typeof earliestHiddenTiming === 'number') return Math.round(earliestHiddenTiming - startTime);
}
function $c7bf87bfb769b3be$export$21a1a62a307062f1(interactionType) {
    if (interactionType !== 'page_load') return false;
    // Check native visibility-state entries first (most reliable, Chromium only)
    try {
        var entries = performance.getEntriesByType('visibility-state');
        if (entries.length > 0) return entries.some(function(entry) {
            return entry.name === 'hidden' && entry.startTime <= $c7bf87bfb769b3be$var$OPENED_IN_BACKGROUND_THRESHOLD_MS;
        });
    } catch (_unused) {
    // visibility-state not supported (Firefox/Safari)
    }
    // Fallback to cached value from setup (determined using time threshold)
    return $c7bf87bfb769b3be$var$openedInBackground === true;
}
function $c7bf87bfb769b3be$var$pushHidden(isPageHiddenFlag, time) {
    $c7bf87bfb769b3be$var$timings[$c7bf87bfb769b3be$var$insertIndex] = {
        time: time !== null && time !== void 0 ? time : performance.now(),
        hidden: isPageHiddenFlag
    };
    $c7bf87bfb769b3be$var$insertIndex = ($c7bf87bfb769b3be$var$insertIndex + 1) % $c7bf87bfb769b3be$var$SIZE;
    $c7bf87bfb769b3be$var$wasHiddenFlag = isPageHiddenFlag;
}
function $c7bf87bfb769b3be$var$handleChange() {
    var isPageHiddenFlag = $c7bf87bfb769b3be$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$c7bf87bfb769b3be$var$wasHiddenFlag) $c7bf87bfb769b3be$var$pushHidden(isPageHiddenFlag);
        $c7bf87bfb769b3be$var$wasHiddenFlag = true;
    } else {
        if ($c7bf87bfb769b3be$var$wasHiddenFlag) $c7bf87bfb769b3be$var$pushHidden(isPageHiddenFlag);
        $c7bf87bfb769b3be$var$wasHiddenFlag = false;
    }
}
var $c7bf87bfb769b3be$var$hasHiddenTimingBeforeSetup = false;
function $c7bf87bfb769b3be$export$95f048bd8bcdda23() {
    return $c7bf87bfb769b3be$var$hasHiddenTimingBeforeSetup;
}
function $c7bf87bfb769b3be$var$setup() {
    try {
        var results = performance.getEntriesByType('visibility-state');
        results === null || results === void 0 || results.forEach(function(result) {
            if ((0, $50U6m.fg)('platform_ufo_use_native_page_visibility_api')) $c7bf87bfb769b3be$var$pushHidden(result.name === 'hidden', result.startTime);
            if (result.name === 'hidden') $c7bf87bfb769b3be$var$hasHiddenTimingBeforeSetup = true;
        });
    } catch (_unused2) {
    /* do nothing */ /* note: visibility-state entry types are not available in Firefox/Safari: https://developer.mozilla.org/en-US/docs/Web/API/VisibilityStateEntry#browser_compatibility */ }
    (0, $7QpUe.bind)(window, {
        type: 'pageshow',
        listener: $c7bf87bfb769b3be$var$handleChange
    });
    (0, $7QpUe.bind)(window, {
        type: 'pagehide',
        listener: $c7bf87bfb769b3be$var$handleChange
    });
    (0, $7QpUe.bind)(document, {
        type: 'visibilitychange',
        listener: $c7bf87bfb769b3be$var$handleChange
    });
}
function $c7bf87bfb769b3be$export$554cefe0f0373da4() {
    if (!$c7bf87bfb769b3be$var$setupFlag) {
        var isPageHiddenFlag = $c7bf87bfb769b3be$var$isPageHidden();
        var setupTime = performance.now();
        // Determine if page was opened in background.
        // If we're early in page lifecycle (< threshold) and page is hidden,
        // it's likely the page was opened in a background tab.
        if ($c7bf87bfb769b3be$var$openedInBackground === null) $c7bf87bfb769b3be$var$openedInBackground = isPageHiddenFlag && setupTime < $c7bf87bfb769b3be$var$OPENED_IN_BACKGROUND_THRESHOLD_MS;
        $c7bf87bfb769b3be$var$pushHidden(isPageHiddenFlag, 0);
        $c7bf87bfb769b3be$var$setup();
        $c7bf87bfb769b3be$var$setupFlag = true;
    }
}
function $c7bf87bfb769b3be$export$768b2008623433e1(start, end) {
    // Input validation - return default for invalid inputs
    if (!Number.isFinite(start) || !Number.isFinite(end)) return 'visible';
    // Desirable default value is visible
    if ($c7bf87bfb769b3be$var$timings.length === 0) return 'visible';
    var currentSize = $c7bf87bfb769b3be$var$timings.length;
    var hiddenState = 'mixed';
    var startIdx = $c7bf87bfb769b3be$var$insertIndex;
    var endIdx = $c7bf87bfb769b3be$var$insertIndex;
    // currentSize is capped at SIZE.
    for(var i = 0; i < currentSize; i++){
        var tmpIdx = ($c7bf87bfb769b3be$var$insertIndex + i) % currentSize;
        // Add bounds checking before accessing array element
        if ($c7bf87bfb769b3be$var$timings[tmpIdx] && $c7bf87bfb769b3be$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($c7bf87bfb769b3be$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    // Add bounds checking before accessing timings array
    if (endIdx - startIdx === 0 && $c7bf87bfb769b3be$var$timings[startIdx]) hiddenState = $c7bf87bfb769b3be$var$timings[startIdx].hidden ? 'hidden' : 'visible';
    return hiddenState;
}
// Throttle detection configuration
// Expected interval for timer checks (in milliseconds)
var $c7bf87bfb769b3be$var$THROTTLE_CHECK_INTERVAL_MS = 1000;
// Threshold for considering a timer as throttled (50% drift tolerance)
var $c7bf87bfb769b3be$var$THROTTLE_DRIFT_THRESHOLD = 1.5;
// Maximum number of throttle measurements to store (circular buffer)
var $c7bf87bfb769b3be$var$THROTTLE_BUFFER_SIZE = 120;
// Circular buffer to store throttle measurements
var $c7bf87bfb769b3be$var$throttleMeasurements = [];
var $c7bf87bfb769b3be$var$throttleInsertIndex = 0;
var $c7bf87bfb769b3be$var$throttleIntervalId = null;
var $c7bf87bfb769b3be$var$lastThrottleCheckTime = null;
var $c7bf87bfb769b3be$var$throttleSetupDone = false;
function $c7bf87bfb769b3be$var$recordThrottleMeasurement(expectedElapsed, actualElapsed) {
    var isThrottled = actualElapsed > expectedElapsed * $c7bf87bfb769b3be$var$THROTTLE_DRIFT_THRESHOLD;
    $c7bf87bfb769b3be$var$throttleMeasurements[$c7bf87bfb769b3be$var$throttleInsertIndex] = {
        time: performance.now(),
        expectedElapsed: expectedElapsed,
        actualElapsed: actualElapsed,
        isThrottled: isThrottled
    };
    $c7bf87bfb769b3be$var$throttleInsertIndex = ($c7bf87bfb769b3be$var$throttleInsertIndex + 1) % $c7bf87bfb769b3be$var$THROTTLE_BUFFER_SIZE;
}
function $c7bf87bfb769b3be$var$throttleCheckCallback() {
    var currentTime = performance.now();
    if ($c7bf87bfb769b3be$var$lastThrottleCheckTime !== null) {
        var actualElapsed = currentTime - $c7bf87bfb769b3be$var$lastThrottleCheckTime;
        $c7bf87bfb769b3be$var$recordThrottleMeasurement($c7bf87bfb769b3be$var$THROTTLE_CHECK_INTERVAL_MS, actualElapsed);
    }
    $c7bf87bfb769b3be$var$lastThrottleCheckTime = currentTime;
}
function $c7bf87bfb769b3be$export$fa0d29a9c87052da() {
    if ($c7bf87bfb769b3be$var$throttleSetupDone) return;
    $c7bf87bfb769b3be$var$throttleSetupDone = true;
    // Record the initial timestamp
    $c7bf87bfb769b3be$var$lastThrottleCheckTime = performance.now();
    // Start the periodic timer for throttle detection
    $c7bf87bfb769b3be$var$throttleIntervalId = setInterval($c7bf87bfb769b3be$var$throttleCheckCallback, $c7bf87bfb769b3be$var$THROTTLE_CHECK_INTERVAL_MS);
}
function $c7bf87bfb769b3be$export$3279694d66e4a1() {
    if ($c7bf87bfb769b3be$var$throttleIntervalId !== null) {
        clearInterval($c7bf87bfb769b3be$var$throttleIntervalId);
        $c7bf87bfb769b3be$var$throttleIntervalId = null;
    }
    $c7bf87bfb769b3be$var$lastThrottleCheckTime = null;
    $c7bf87bfb769b3be$var$throttleSetupDone = false;
    $c7bf87bfb769b3be$var$throttleMeasurements.length = 0;
    $c7bf87bfb769b3be$var$throttleInsertIndex = 0;
}
function $c7bf87bfb769b3be$export$62a28c860277b3bf(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return false;
    // No measurements available
    if ($c7bf87bfb769b3be$var$throttleMeasurements.length === 0) return false;
    // Check if any measurement within the time window indicates throttling
    for(var i = 0; i < $c7bf87bfb769b3be$var$throttleMeasurements.length; i++){
        var measurement = $c7bf87bfb769b3be$var$throttleMeasurements[i];
        if (measurement && measurement.time >= startTime && measurement.time <= endTime && measurement.isThrottled) return true;
    }
    return false;
}
function $c7bf87bfb769b3be$export$77aaa9b1ce57d9bc(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    return $c7bf87bfb769b3be$var$throttleMeasurements.filter(function(measurement) {
        return measurement && measurement.time >= startTime && measurement.time <= endTime;
    });
}
function $c7bf87bfb769b3be$export$9332de935653b687(measurement) {
    $c7bf87bfb769b3be$var$throttleMeasurements[$c7bf87bfb769b3be$var$throttleInsertIndex] = measurement;
    $c7bf87bfb769b3be$var$throttleInsertIndex = ($c7bf87bfb769b3be$var$throttleInsertIndex + 1) % $c7bf87bfb769b3be$var$THROTTLE_BUFFER_SIZE;
}
function $c7bf87bfb769b3be$export$5a06b84e47ad70d9(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    if ($c7bf87bfb769b3be$var$timings.length === 0) return [];
    var result = [];
    // Find the most recent entry at or before startTime to establish initial state
    var initialEntry;
    var currentSize = $c7bf87bfb769b3be$var$timings.length;
    for(var i = 0; i < currentSize; i++){
        var idx = ($c7bf87bfb769b3be$var$insertIndex + i) % currentSize;
        var entry = $c7bf87bfb769b3be$var$timings[idx];
        if (entry && entry.time <= startTime) initialEntry = entry;
    }
    // Add the initial visibility state at the start of the window
    if (initialEntry) result.push({
        time: 0,
        hidden: initialEntry.hidden
    });
    // Add all entries within the time window
    for(var _i = 0; _i < currentSize; _i++){
        var _idx = ($c7bf87bfb769b3be$var$insertIndex + _i) % currentSize;
        var _entry = $c7bf87bfb769b3be$var$timings[_idx];
        if (_entry && _entry.time > startTime && _entry.time <= endTime) result.push({
            time: Math.round(_entry.time - startTime),
            hidden: _entry.hidden
        });
    }
    return result;
}
// Expose testing API on window for integration tests
if (typeof window !== 'undefined') window.__reactUfoHiddenTiming = {
    __injectThrottleMeasurementForTesting: $c7bf87bfb769b3be$export$9332de935653b687
};

});


parcelRegister("3H0iK", function(module, exports) {
$parcel$export(module.exports, "Observers", () => $2b059f1e9e6b20d6$export$b65d046240060e78);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $DtLwq = parcelRequire("DtLwq");

var $cDJdu = parcelRequire("cDJdu");

var $lj1OM = parcelRequire("lj1OM");

var $hakpj = parcelRequire("hakpj");

var $k6qaT = parcelRequire("k6qaT");
function $2b059f1e9e6b20d6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2b059f1e9e6b20d6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2b059f1e9e6b20d6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2b059f1e9e6b20d6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2b059f1e9e6b20d6$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function $2b059f1e9e6b20d6$var$isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    var isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
var $2b059f1e9e6b20d6$export$b65d046240060e78 = /*#__PURE__*/ function() {
    function Observers(opts) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Observers);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "observedMutations", new WeakMap());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "elementsInView", new Set());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "callbacks", new Set());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "totalTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_startMeasureTimestamp", -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "ssr", {
            state: $2b059f1e9e6b20d6$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "selectorConfig", {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscribeResults", function(cb) {
            _this.callbacks.add(cb);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "observeElement", function(node, mutation, type, ignoreReason, attributeName) {
            var _this$intersectionObs;
            var oldValue = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
            var newValue = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.observe(node);
            _this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        });
        // Selector-config resolution is centralised in `getSelectorConfig()`.
        // It enforces FedRAMP-override > caller-override > centrally
        // configured > caller default.
        var resolved = (0, $DtLwq.getSelectorConfig)(opts.selectorConfig, this.selectorConfig);
        this.selectorConfig = resolved !== null && resolved !== void 0 ? resolved : $2b059f1e9e6b20d6$var$_objectSpread($2b059f1e9e6b20d6$var$_objectSpread({}, this.selectorConfig), opts.selectorConfig);
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        // Use shared SSR placeholder handler if provided, otherwise create new one
        if (opts.ssrPlaceholderHandler) this.ssrPlaceholderHandler = opts.ssrPlaceholderHandler;
        else {
            var _opts$SSRConfig;
            this.ssrPlaceholderHandler = new (0, $k6qaT.SSRPlaceholderHandlers)({
                enablePageLayoutPlaceholder: (_opts$SSRConfig = opts.SSRConfig) === null || _opts$SSRConfig === void 0 ? void 0 : _opts$SSRConfig.enablePageLayoutPlaceholder
            });
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Observers, [
        {
            key: "isBrowserSupported",
            value: function isBrowserSupported() {
                return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
            }
        },
        {
            key: "observe",
            value: function observe() {
                var _this$mutationObserve;
                this.totalTime = 0;
                this.ssr = {
                    state: $2b059f1e9e6b20d6$var$state.normal,
                    reactRootElement: null,
                    renderStart: -1,
                    renderStop: -1
                };
                (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
                    attributeFilter: [
                        'hidden',
                        'style',
                        'src',
                        'class'
                    ],
                    attributeOldValue: true,
                    attributes: true,
                    childList: true,
                    subtree: true
                });
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this$mutationObserve2, _this$intersectionObs2;
                (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
                (_this$intersectionObs2 = this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.disconnect();
                this.observedMutations = new WeakMap();
                this.elementsInView.clear();
                this.callbacks.clear();
                this.ssr.reactRootElement = null;
                this.ssrPlaceholderHandler.clear();
            }
        },
        {
            key: "getTotalTime",
            value: function getTotalTime() {
                return this.totalTime;
            }
        },
        {
            key: "setReactRootElement",
            value: function setReactRootElement(element) {
                this.ssr.reactRootElement = element;
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStart = startTime;
                this.ssr.state = $2b059f1e9e6b20d6$var$state.waitingForFirstRender;
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStop = stopTime;
            }
        },
        {
            key: "getMutationObserver",
            value: function getMutationObserver() {
                var _this2 = this;
                if (!this.isBrowserSupported()) return null;
                return new MutationObserver(function(mutations) {
                    _this2.measureStart();
                    mutations.forEach(function(mutation) {
                        // patching element if timestamp not automatically added
                        // eslint-disable-next-line no-param-reassign
                        mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                        var ignoreReason = '';
                        if (_this2.ssr.state === $2b059f1e9e6b20d6$var$state.waitingForFirstRender && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            _this2.ssr.state = $2b059f1e9e6b20d6$var$state.ignoring;
                            if (_this2.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                            _this2.ssr.renderStop = mutation.timestamp + 500;
                            ignoreReason = 'ssr-hydration';
                        }
                        if (_this2.ssr.state === $2b059f1e9e6b20d6$var$state.ignoring && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            if (mutation.timestamp <= _this2.ssr.renderStop) ignoreReason = 'ssr-hydration';
                            else _this2.ssr.state = $2b059f1e9e6b20d6$var$state.normal;
                        }
                        if (mutation.type === 'childList') {
                            mutation.addedNodes.forEach(function(node) {
                                if ((0, $cDJdu.isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                                if (node instanceof HTMLElement) {
                                    if (_this2.ssrPlaceholderHandler.isPlaceholder(node) || _this2.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                        _this2.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, 'html', ignoreReason);
                                        });
                                        return;
                                    }
                                    if (_this2.ssrPlaceholderHandler.isPlaceholderReplacement(node) || _this2.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                        _this2.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, 'html', ignoreReason);
                                        });
                                        return;
                                    }
                                    _this2.observeElement(node, mutation, 'html', ignoreReason);
                                }
                                if (node instanceof Text && node.parentElement != null) _this2.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                            });
                            mutation.removedNodes.forEach(function(node) {
                                if (node instanceof Element) {
                                    var _this2$intersectionOb;
                                    _this2.elementsInView.delete(node);
                                    (_this2$intersectionOb = _this2.intersectionObserver) === null || _this2$intersectionOb === void 0 || _this2$intersectionOb.unobserve(node);
                                }
                            });
                        } else if (mutation.type === 'attributes') {
                            if (mutation.target instanceof HTMLElement) {
                                var _mutation$oldValue;
                                var attributeName = mutation.attributeName;
                                /*
              	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
              	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
              	Conceptually there is after all a mutation: there is an old value replaced with a new one,
              	and whether or not they are the same doesn't really matter.
              	And Custom elements should work the same way as MutationObserver."
              	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
              */ var oldValue = (_mutation$oldValue = mutation.oldValue) !== null && _mutation$oldValue !== void 0 ? _mutation$oldValue : undefined;
                                var newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                                if (oldValue !== newValue) {
                                    if ((0, $lj1OM.default)(mutation)) ignoreReason = 'non-visual-style';
                                    if ((0, $cDJdu.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = 'image';
                                    _this2.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                                }
                            }
                        }
                    });
                });
            }
        },
        {
            key: "getElementName",
            value: function getElementName(element) {
                try {
                    var tagName = element.localName;
                    var dataVCAttr = element.getAttribute('data-vc');
                    var dataVC = this.selectorConfig.dataVC && dataVCAttr ? "[data-vc=\"".concat(dataVCAttr, "\"]") : '';
                    var id = this.selectorConfig.id && element.id ? "#".concat(element.id) : '';
                    var testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
                    testId = testId ? "[testid=".concat(testId, "]") : '';
                    var role = this.selectorConfig.role ? element.getAttribute('role') : '';
                    role = role ? "[role=".concat(role, "]") : '';
                    var classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
                    classList = classList === '' ? '' : ".".concat(classList);
                    var attrs = dataVC ? dataVC : [
                        id,
                        testId,
                        role
                    ].join('');
                    var idString = '';
                    if (attrs === '' && classList === '') {
                        var parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                        idString = "".concat(parent, " > ").concat(tagName);
                    } else idString = [
                        tagName,
                        attrs || classList
                    ].join('');
                    return idString;
                } catch (_unused) {
                    return 'error';
                }
            }
        },
        {
            key: "getIntersectionObserver",
            value: function getIntersectionObserver() {
                var _this3 = this;
                if (!this.isBrowserSupported()) return null;
                return new IntersectionObserver(function(entries) {
                    _this3.measureStart();
                    entries.forEach(function(_ref) {
                        var isIntersecting = _ref.isIntersecting, ir = _ref.intersectionRect, target = _ref.target;
                        var data = _this3.observedMutations.get(target);
                        _this3.observedMutations.delete(target);
                        if (isIntersecting && ir.width > 0 && ir.height > 0) {
                            if (!(target instanceof HTMLElement)) return;
                            if (!(data !== null && data !== void 0 && data.mutation)) // ignore intersection report without recent mutation
                            return;
                            if (!$2b059f1e9e6b20d6$var$isElementVisible(target)) data.ignoreReason = 'not-visible';
                            if ((0, $hakpj.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(ir)) data.ignoreReason = 'rll-placeholder';
                            _this3.callbacks.forEach(function(callback) {
                                var elementName;
                                try {
                                    elementName = _this3.getElementName(target);
                                } catch (_unused2) {
                                    elementName = 'error';
                                }
                                callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                            });
                            _this3.elementsInView.add(target);
                        } else _this3.elementsInView.delete(target);
                    });
                    _this3.measureStop();
                });
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ]);
}();

});
parcelRegister("cDJdu", function(module, exports) {
$parcel$export(module.exports, "isContainedWithinMediaWrapper", () => $933c33a2ef685c31$export$f61fbc3b9c4a9019);

var $d1hf4 = parcelRequire("d1hf4");
function $933c33a2ef685c31$export$f61fbc3b9c4a9019(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $d1hf4.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
}

});
parcelRegister("d1hf4", function(module, exports) {
$parcel$export(module.exports, "MEDIA_WRAPPER_TAG", () => $97a8be428787b42a$export$7674290405cc25b0);
$parcel$export(module.exports, "VcMediaWrapperProps", () => $97a8be428787b42a$export$7028e9efe569888c);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");
var $97a8be428787b42a$export$7674290405cc25b0 = 'data-media-vc-wrapper';
var $97a8be428787b42a$export$7028e9efe569888c = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $97a8be428787b42a$export$7674290405cc25b0, true);
function $97a8be428787b42a$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", $97a8be428787b42a$export$7028e9efe569888c, children);
}

});


parcelRegister("lj1OM", function(module, exports) {
$parcel$export(module.exports, "default", () => $f82cc85d99ce8b0b$export$2e2bcd8739ae039);
/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ function $f82cc85d99ce8b0b$var$isNonVisualStyleMutation(_ref) {
    var target = _ref.target, attributeName = _ref.attributeName;
    if (!(target instanceof Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}
var $f82cc85d99ce8b0b$export$2e2bcd8739ae039 = $f82cc85d99ce8b0b$var$isNonVisualStyleMutation;

});

parcelRegister("hakpj", function(module, exports) {
$parcel$export(module.exports, "RLLPlaceholderHandlers", () => $c7f3334f039ee800$export$166779fc0f49d4df);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
var $c7f3334f039ee800$var$GLOBAL_RLL_HANDLERS_KEY = '__REACT_UFO_RLL_PLACEHOLDER_HANDLERS__';
var $c7f3334f039ee800$export$166779fc0f49d4df = /*#__PURE__*/ function() {
    function RLLPlaceholderHandlers() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, RLLPlaceholderHandlers);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "placeholders", []);
        if (typeof window !== 'undefined' && typeof document !== 'undefined' && typeof window.document !== 'undefined') this.collectRLLPlaceholders();
    }
    /**
   * Gets the global singleton instance of RLLPlaceholderHandlers.
   * Creates the instance if it doesn't exist and stores it in globalThis.
   * @returns The singleton instance of RLLPlaceholderHandlers
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(RLLPlaceholderHandlers, [
        {
            key: "reset",
            value: function reset() {
                this.placeholders = [];
            }
        },
        {
            key: "collectRLLPlaceholders",
            value: function collectRLLPlaceholders() {
                if (typeof window === 'undefined' || typeof document === 'undefined' || typeof window.document === 'undefined') return;
                var beginElements = document.querySelectorAll('input[data-lazy-begin]');
                var beginCount = beginElements.length;
                if (beginCount === 0) return;
                // Performance optimization: pre-allocate array with estimated size
                var allElements = [];
                // Performance optimization: use traditional for loop instead of forEach
                for(var i = 0; i < beginCount; i++){
                    var beginEl = beginElements[i];
                    var id = beginEl.getAttribute('data-lazy-begin');
                    if (!id) continue;
                    var elements = this.refElements(beginEl, id);
                    if (elements.length > 0) allElements.push.apply(allElements, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(elements));
                }
                // Second pass: batch all getBoundingClientRect calls to minimize reflow cycles
                var allElementsLength = allElements.length;
                if (allElementsLength > 0) {
                    // Performance optimization: pre-allocate array with exact size
                    var intersectingRects = [];
                    var windowWidth = window.innerWidth;
                    var windowHeight = window.innerHeight;
                    for(var _i = 0; _i < allElementsLength; _i++){
                        var rect = allElements[_i].getBoundingClientRect();
                        // Performance optimization: inline intersection calculation to avoid function call overhead
                        var left = Math.max(rect.left, 0);
                        var top = Math.max(rect.top, 0);
                        var right = Math.min(rect.right, windowWidth);
                        var bottom = Math.min(rect.bottom, windowHeight);
                        // Check if there's a valid intersection with non-zero width and height
                        if (left < right && top < bottom) intersectingRects.push(new DOMRect(left, top, right - left, bottom - top));
                    }
                    this.placeholders = intersectingRects;
                }
            }
        },
        {
            key: "refElements",
            value: function refElements(fromEl, id) {
                var result = [];
                var el = fromEl.nextSibling;
                // Performance optimization: use while loop instead of recursive calls
                while(el){
                    var _el$dataset;
                    if (((_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.lazyEnd) === id) break;
                    if (el.nodeType === Node.ELEMENT_NODE) result.push(el);
                    el = el.nextSibling;
                }
                return result;
            }
        },
        {
            key: "getPlaceholders",
            value: function getPlaceholders() {
                return this.placeholders;
            }
        },
        {
            key: "isRLLPlaceholderHydration",
            value: function isRLLPlaceholderHydration(intersectingRect) {
                var placeholdersLength = this.placeholders.length;
                if (placeholdersLength === 0) return false;
                // Performance optimization: cache array length and use traditional for loop
                for(var i = 0; i < placeholdersLength; i++){
                    var placeholderRect = this.placeholders[i];
                    if (this.areRectsEqual(intersectingRect, placeholderRect)) return true;
                }
                return false;
            }
        },
        {
            key: "areRectsEqual",
            value: function areRectsEqual(rect1, rect2) {
                // Early exit for exact matches (most common case)
                if (rect1.left === rect2.left && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom) return true;
                // Performance optimization: check largest differences first for early exit
                var leftDiff = rect1.left - rect2.left;
                if (leftDiff > 1 || leftDiff < -1) return false;
                var rightDiff = rect1.right - rect2.right;
                if (rightDiff > 1 || rightDiff < -1) return false;
                var topDiff = rect1.top - rect2.top;
                if (topDiff > 1 || topDiff < -1) return false;
                var bottomDiff = rect1.bottom - rect2.bottom;
                if (bottomDiff > 1 || bottomDiff < -1) return false;
                return true;
            }
        }
    ], [
        {
            key: "getInstance",
            value: function getInstance() {
                if (typeof globalThis !== 'undefined') {
                    if (!globalThis[$c7f3334f039ee800$var$GLOBAL_RLL_HANDLERS_KEY]) globalThis[$c7f3334f039ee800$var$GLOBAL_RLL_HANDLERS_KEY] = new RLLPlaceholderHandlers();
                    return globalThis[$c7f3334f039ee800$var$GLOBAL_RLL_HANDLERS_KEY];
                }
                // Fallback for environments without globalThis (should be rare)
                return new RLLPlaceholderHandlers();
            }
        }
    ]);
}();

});

parcelRegister("k6qaT", function(module, exports) {
$parcel$export(module.exports, "SSRPlaceholderHandlers", () => $ea28abe9e4080efa$export$c0102f1a1198d10f);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
var $ea28abe9e4080efa$var$ANCESTOR_LOOKUP_LIMIT = 10;
var $ea28abe9e4080efa$var$PAGE_LAYOUT_ID = 'page-layout.root';
var $ea28abe9e4080efa$export$c0102f1a1198d10f = /*#__PURE__*/ function() {
    function SSRPlaceholderHandlers(_ref) {
        var _this = this;
        var _ref$enablePageLayout = _ref.enablePageLayoutPlaceholder, enablePageLayoutPlaceholder = _ref$enablePageLayout === void 0 ? false : _ref$enablePageLayout;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, SSRPlaceholderHandlers);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "staticPlaceholders", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "callbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getSizeCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "reactValidateCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "EQUALITY_THRESHOLD", 1);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getPlaceholderId", function(el) {
            var _el$dataset;
            var ssrPlaceholderId = el === null || el === void 0 || (_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.ssrPlaceholder;
            if (!!ssrPlaceholderId) return ssrPlaceholderId;
            if (_this.enablePageLayoutPlaceholder && (el === null || el === void 0 ? void 0 : el.dataset.testid) === $ea28abe9e4080efa$var$PAGE_LAYOUT_ID) return $ea28abe9e4080efa$var$PAGE_LAYOUT_ID;
            return '';
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getPlaceholderReplacementId", function(el) {
            var _el$dataset2;
            var ssrPlaceholderReplaceId = el === null || el === void 0 || (_el$dataset2 = el.dataset) === null || _el$dataset2 === void 0 ? void 0 : _el$dataset2.ssrPlaceholderReplace;
            if (!!ssrPlaceholderReplaceId) return ssrPlaceholderReplaceId;
            if (_this.enablePageLayoutPlaceholder && (el === null || el === void 0 ? void 0 : el.dataset.testid) === $ea28abe9e4080efa$var$PAGE_LAYOUT_ID) return $ea28abe9e4080efa$var$PAGE_LAYOUT_ID;
            return '';
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "intersectionObserverCallback", function(_ref2) {
            var _this$intersectionObs;
            var target = _ref2.target, boundingClientRect = _ref2.boundingClientRect;
            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            var staticKey = _this.getPlaceholderId(target);
            if (staticKey) {
                if (_this.staticPlaceholders.has(staticKey) && _this.callbacks.has(staticKey)) {
                    // validation
                    var _resolve = _this.callbacks.get(staticKey);
                    if (!_resolve) return;
                    var rect = _this.staticPlaceholders.get(staticKey);
                    var hasSameSizePosition = _this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || _this.isDummyRect(rect)) _resolve(hasSameSizePosition);
                    else requestAnimationFrame(function() {
                        var targetRect = _this.getEffectiveBoundingRect(target);
                        var hasSameSizePosition = _this.hasSameSizePosition(rect, targetRect);
                        _resolve(hasSameSizePosition);
                    });
                    _this.callbacks.delete(staticKey);
                }
            } else {
                var key = _this.getPlaceholderReplacementId(target);
                var _resolve2 = _this.reactValidateCallbacks.get(key);
                if (!_resolve2) return;
                var _rect = _this.staticPlaceholders.get(key);
                var _hasSameSizePosition = _this.hasSameSizePosition(_rect, boundingClientRect);
                if (_hasSameSizePosition || _this.isDummyRect(_rect)) _resolve2(_hasSameSizePosition);
                else requestAnimationFrame(function() {
                    var targetRect = _this.getEffectiveBoundingRect(target);
                    var hasSameSizePosition = _this.hasSameSizePosition(_rect, targetRect);
                    _resolve2(hasSameSizePosition);
                });
                _this.staticPlaceholders.delete(staticKey);
                _this.reactValidateCallbacks.delete(staticKey);
            }
        });
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver(function(entries) {
            return entries.filter(function(entry) {
                return entry.intersectionRatio > 0;
            }).forEach(_this.intersectionObserverCallback);
        });
        this.enablePageLayoutPlaceholder = enablePageLayoutPlaceholder;
        if (window.document) try {
            // Collect initial placeholders using SSR dimensions. __SSR_PLACEHOLDERS_DIMENSIONS__ is
            // deliberately left in place: several VCObserverWrappers are built per page load and each
            // builds its own handler, so dropping it here would leave every later handler measuring
            // each placeholder with getBoundingClientRect() — a synchronous style recalc and a
            // full-document layout mid-hydration. Keeping it costs one small map per document.
            this.collectPlaceholdersInternal();
        } catch (_unused) {}
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(SSRPlaceholderHandlers, [
        {
            key: "clear",
            value: function clear() {
                this.staticPlaceholders = new Map();
                this.callbacks = new Map();
                this.getSizeCallbacks = new Map();
                this.reactValidateCallbacks = new Map();
            }
        },
        {
            key: "collectPlaceholdersInternal",
            value: function collectPlaceholdersInternal() {
                var _this2 = this;
                var selector = this.enablePageLayoutPlaceholder ? '[data-ssr-placeholder],[data-testid="page-layout.root"]' : '[data-ssr-placeholder]';
                var existingElements = document.querySelectorAll(selector);
                existingElements.forEach(function(el) {
                    var placeholderId = el instanceof HTMLElement && _this2.getPlaceholderId(el);
                    if (placeholderId && !_this2.staticPlaceholders.has(placeholderId)) {
                        var _window$__SSR_PLACEHO, _this2$intersectionOb;
                        var width = -1;
                        var height = -1;
                        var x = -1;
                        var y = -1;
                        // Use SSR dimensions from window global if available
                        var boundingClientRect = (_window$__SSR_PLACEHO = window.__SSR_PLACEHOLDERS_DIMENSIONS__) === null || _window$__SSR_PLACEHO === void 0 ? void 0 : _window$__SSR_PLACEHO[placeholderId];
                        if (boundingClientRect) {
                            width = boundingClientRect.width;
                            height = boundingClientRect.height;
                            x = boundingClientRect.x;
                            y = boundingClientRect.y;
                        } else {
                            // Fallback to current bounding rect if SSR dimensions not available
                            var rect = el.getBoundingClientRect();
                            width = rect.width;
                            height = rect.height;
                            x = rect.x;
                            y = rect.y;
                        }
                        _this2.staticPlaceholders.set(placeholderId, {
                            width: width,
                            height: height,
                            x: x,
                            y: y
                        });
                        (_this2$intersectionOb = _this2.intersectionObserver) === null || _this2$intersectionOb === void 0 || _this2$intersectionOb.observe(el);
                    }
                });
            }
        },
        {
            key: "collectExistingPlaceholders",
            value: function collectExistingPlaceholders() {
                if (!window.document) return;
                try {
                    // Collect placeholders using SSR dimensions or fallback to live dimensions
                    this.collectPlaceholdersInternal();
                } catch (_unused2) {
                // Silently fail if there are any issues
                }
            }
        },
        {
            key: "isPlaceholder",
            value: function isPlaceholder(element) {
                return Boolean(this.getPlaceholderId(element));
            }
        },
        {
            key: "isPlaceholderReplacement",
            value: function isPlaceholderReplacement(element) {
                return Boolean(this.getPlaceholderReplacementId(element));
            }
        },
        {
            key: "isPlaceholderIgnored",
            value: function isPlaceholderIgnored(element) {
                // data-ssr-placeholder-ignored doesn't have a value.
                return 'ssrPlaceholderIgnored' in element.dataset;
            }
        },
        {
            key: "isPlaceholderV4",
            value: function isPlaceholderV4(element) {
                var currentElement = element;
                var i = 0;
                while(currentElement && i < $ea28abe9e4080efa$var$ANCESTOR_LOOKUP_LIMIT){
                    if (Boolean(this.getPlaceholderId(currentElement))) return true;
                    currentElement = currentElement.parentElement;
                    i++;
                }
                return false;
            }
        },
        {
            key: "isPlaceholderReplacementV4",
            value: function isPlaceholderReplacementV4(element) {
                var currentElement = element;
                var i = 0;
                while(currentElement && i < $ea28abe9e4080efa$var$ANCESTOR_LOOKUP_LIMIT){
                    if (Boolean(this.getPlaceholderReplacementId(currentElement))) return true;
                    currentElement = currentElement.parentElement;
                    i++;
                }
                return false;
            }
        },
        {
            key: "findNearestPlaceholderContainerIfIgnored",
            value: function findNearestPlaceholderContainerIfIgnored(element) {
                if (!this.isPlaceholderIgnored(element)) return element;
                var ancestor = element.parentElement;
                var i = 0;
                while(ancestor && i < $ea28abe9e4080efa$var$ANCESTOR_LOOKUP_LIMIT){
                    if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
                    ancestor = ancestor.parentElement;
                    i++;
                }
                return element;
            }
        },
        {
            key: "findNearestPlaceholderOrContainer",
            value: function findNearestPlaceholderOrContainer(element) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $ea28abe9e4080efa$var$ANCESTOR_LOOKUP_LIMIT;
                var ancestor = element;
                if (this.isPlaceholderIgnored(element) && element.parentElement) ancestor = element.parentElement;
                var i = 0;
                while(ancestor && i < limit){
                    if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
                    if (ancestor.parentElement) {
                        ancestor = ancestor.parentElement;
                        i++;
                    } else break;
                }
                return element;
            }
        },
        {
            key: "checkIfExistedAndSizeMatching",
            value: function checkIfExistedAndSizeMatching(el) {
                var _this3 = this;
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = this.getPlaceholderId(el);
                return new Promise(function(resolve) {
                    if (!_this3.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        var _this3$intersectionOb;
                        _this3.callbacks.set(id, resolve);
                        (_this3$intersectionOb = _this3.intersectionObserver) === null || _this3$intersectionOb === void 0 || _this3$intersectionOb.observe(el);
                    }
                });
            }
        },
        {
            key: "checkIfExistedAndSizeMatchingV3",
            value: function checkIfExistedAndSizeMatchingV3(el) {
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = this.getPlaceholderId(el);
                var placeholderRects = this.staticPlaceholders.get(id);
                if (!placeholderRects) return false;
                return this.hasSameSizePosition(placeholderRects, this.getEffectiveBoundingRect(el));
            }
        },
        {
            key: "getSize",
            value: function getSize(el) {
                var _this4 = this;
                return new Promise(function(resolve) {
                    var _this4$intersectionOb;
                    _this4.getSizeCallbacks.set(_this4.getPlaceholderId(el), resolve);
                    (_this4$intersectionOb = _this4.intersectionObserver) === null || _this4$intersectionOb === void 0 || _this4$intersectionOb.observe(el);
                });
            }
        },
        {
            key: "validateReactComponentMatchToPlaceholder",
            value: function validateReactComponentMatchToPlaceholder(el) {
                var _this5 = this;
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = this.getPlaceholderReplacementId(el);
                return new Promise(function(resolve) {
                    if (!_this5.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        var _this5$intersectionOb;
                        _this5.reactValidateCallbacks.set(id, resolve);
                        (_this5$intersectionOb = _this5.intersectionObserver) === null || _this5$intersectionOb === void 0 || _this5$intersectionOb.observe(el);
                    }
                });
            }
        },
        {
            key: "validateReactComponentMatchToPlaceholderV4",
            value: function validateReactComponentMatchToPlaceholderV4(el) {
                el = this.findNearestPlaceholderOrContainer(el, 2); // We are using 2 due to over-eagerness of the default, only check itself and 1 ancestor
                var id = this.getPlaceholderReplacementId(el);
                return this.staticPlaceholders.has(id);
            }
        },
        {
            key: "hasSameSizePosition",
            value: function hasSameSizePosition(rect, boundingClientRect) {
                if (!rect) return false;
                var horizontalCheck = Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD;
                var verticalCheck = Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD;
                return horizontalCheck && verticalCheck || false;
            }
        },
        {
            key: "getEffectiveBoundingRect",
            value: function getEffectiveBoundingRect(el) {
                var computedStyle = window.getComputedStyle(el);
                // If element has display: contents, collect bounding rect from children
                if (computedStyle.display === 'contents') {
                    var children = Array.from(el.children);
                    if (children.length === 0) // No children, return zero rect
                    return new DOMRect(0, 0, 0, 0);
                    // Calculate union of all children's bounding rects
                    var minX = Infinity;
                    var minY = Infinity;
                    var maxX = -Infinity;
                    var maxY = -Infinity;
                    children.forEach(function(child) {
                        var childRect = child.getBoundingClientRect();
                        // Skip children with zero dimensions (likely also display: contents)
                        if (childRect.width > 0 || childRect.height > 0) {
                            minX = Math.min(minX, childRect.left);
                            minY = Math.min(minY, childRect.top);
                            maxX = Math.max(maxX, childRect.right);
                            maxY = Math.max(maxY, childRect.bottom);
                        }
                    });
                    // If no children with dimensions found, return zero rect
                    if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
                    return new DOMRect(minX, minY, maxX - minX, maxY - minY);
                }
                // Normal element, return its bounding rect
                return el.getBoundingClientRect();
            }
        },
        {
            key: "isDummyRect",
            value: function isDummyRect(rect) {
                return rect && rect.width < 0 && rect.height < 0 || false;
            }
        }
    ]);
}();

});



parcelRegister("i4OdZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d28f8f4638044c49$export$2e2bcd8739ae039);

var $fL8KA = parcelRequire("fL8KA");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $50U6m = parcelRequire("50U6m");

var $DtLwq = parcelRequire("DtLwq");

var $bYaqG = parcelRequire("bYaqG");

var $iGolp = parcelRequire("iGolp");

var $k6qaT = parcelRequire("k6qaT");

var $lF8z4 = parcelRequire("lF8z4");

var $ePEWw = parcelRequire("ePEWw");

var $jdRKQ = parcelRequire("jdRKQ");

var $dzHaO = parcelRequire("dzHaO");

var $3VF6y = parcelRequire("3VF6y");

var $5X23Y = parcelRequire("5X23Y");

var $cTTWn = parcelRequire("cTTWn");

var $gOE39 = parcelRequire("gOE39");

var $frhlU = parcelRequire("frhlU");

var $i8F2n = parcelRequire("i8F2n");
function $d28f8f4638044c49$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d28f8f4638044c49$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d28f8f4638044c49$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d28f8f4638044c49$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d28f8f4638044c49$var$SSRState = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
var $d28f8f4638044c49$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $d28f8f4638044c49$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function VCObserverNew(config) {
        var _config$isPostInterac, _ref, _getSelectorConfig, _config$trackLayoutSh, _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, VCObserverNew);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "viewportObserver", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "windowEventObserver", null);
        // SSR related properties
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "ssrPlaceholderHandler", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "ssr", {
            state: $d28f8f4638044c49$var$SSRState.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        });
        this.entriesTimeline = new (0, $lF8z4.default)();
        this.isPostInteraction = (_config$isPostInterac = config.isPostInteraction) !== null && _config$isPostInterac !== void 0 ? _config$isPostInterac : false;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It applies the FedRAMP all-`false` override when
        // `isFedrampModerate()` is true; otherwise it returns `caller-override
        // → setUFOConfig value → historical default`.
        this.selectorConfig = (_ref = (_getSelectorConfig = (0, $DtLwq.getSelectorConfig)(config.selectorConfig, $d28f8f4638044c49$var$DEFAULT_SELECTOR_CONFIG)) !== null && _getSelectorConfig !== void 0 ? _getSelectorConfig : config.selectorConfig) !== null && _ref !== void 0 ? _ref : $d28f8f4638044c49$var$DEFAULT_SELECTOR_CONFIG;
        // Use shared SSR placeholder handler if provided, otherwise create new one if feature flag is enabled
        if (config.ssrPlaceholderHandler) this.ssrPlaceholderHandler = config.ssrPlaceholderHandler;
        else {
            var _config$SSRConfig$ena, _config$SSRConfig;
            this.ssrPlaceholderHandler = new (0, $k6qaT.SSRPlaceholderHandlers)({
                enablePageLayoutPlaceholder: (_config$SSRConfig$ena = (_config$SSRConfig = config.SSRConfig) === null || _config$SSRConfig === void 0 ? void 0 : _config$SSRConfig.enablePageLayoutPlaceholder) !== null && _config$SSRConfig$ena !== void 0 ? _config$SSRConfig$ena : false
            });
        }
        this.trackLayoutShiftOffenders = (_config$trackLayoutSh = config.trackLayoutShiftOffenders) !== null && _config$trackLayoutSh !== void 0 ? _config$trackLayoutSh : false;
        this.viewportObserver = new (0, $frhlU.default)({
            onChange: function onChange(onChangeArg) {
                var time = onChangeArg.time, type = onChangeArg.type, elementRef = onChangeArg.elementRef, visible = onChangeArg.visible, rect = onChangeArg.rect, previousRect = onChangeArg.previousRect, mutationData = onChangeArg.mutationData;
                var elementName = 'unknown';
                var element = elementRef.deref();
                if (element) elementName = _this.getElementName(element);
                var data = {
                    type: type,
                    elementName: elementName,
                    rect: rect,
                    previousRect: previousRect,
                    visible: visible,
                    attributeName: mutationData === null || mutationData === void 0 ? void 0 : mutationData.attributeName,
                    oldValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.oldValue,
                    newValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.newValue,
                    originalMutationTimestamp: mutationData === null || mutationData === void 0 ? void 0 : mutationData.timestamp
                };
                if (element) {
                    var labelStacks = $d28f8f4638044c49$var$getLabelStacks(element);
                    if (labelStacks) Object.assign(data, {
                        labelStacks: labelStacks
                    });
                }
                _this.entriesTimeline.push({
                    time: time,
                    data: data
                });
            },
            // Pass SSR context to ViewportObserver
            getSSRState: function getSSRState() {
                return _this.getSSRState();
            },
            getSSRPlaceholderHandler: function getSSRPlaceholderHandler() {
                return _this.getSSRPlaceholderHandler();
            },
            searchPageConfig: config.searchPageConfig,
            trackLayoutShiftOffenders: this.trackLayoutShiftOffenders
        });
        this.windowEventObserver = new (0, $i8F2n.default)({
            onEvent: function onEvent(_ref2) {
                var time = _ref2.time, type = _ref2.type, event = _ref2.event;
                // Don't abort press interactions on keydown events, as keydown is expected
                // when users press Enter/Space to activate buttons or other interactive elements
                if (type === 'keydown' && (0, $50U6m.fg)('platform_ufo_keypress_interaction_abort')) {
                    var interaction = (0, $iGolp.getActiveInteraction)();
                    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') return;
                }
                var abortEventTargetElement = $d28f8f4638044c49$var$isAbortEventTargetSupported(type) && event ? $d28f8f4638044c49$var$getAbortEventTargetElement(event.target) : null;
                var elementName = abortEventTargetElement ? _this.getElementName(abortEventTargetElement) : undefined;
                _this.entriesTimeline.push({
                    time: time,
                    data: $d28f8f4638044c49$var$_objectSpread({
                        type: 'window:event',
                        eventType: type
                    }, elementName ? {
                        elementName: elementName
                    } : {})
                });
            }
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(VCObserverNew, [
        {
            key: "start",
            value: function start(_) {
                var _this$viewportObserve, _window, _this2 = this, _this$windowEventObse;
                // Reset SSR state on start (matches old VCObserver behavior)
                this.ssr = {
                    state: $d28f8f4638044c49$var$SSRState.normal,
                    reactRootElement: null,
                    // Reset to null (matches old VCObserver)
                    renderStart: -1,
                    renderStop: -1
                };
                (_this$viewportObserve = this.viewportObserver) === null || _this$viewportObserve === void 0 || _this$viewportObserve.start();
                this.entriesTimeline.clear();
                if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
                    var abortListeners = window.__SSR_ABORT_LISTENERS__;
                    var aborts = abortListeners.aborts;
                    if (aborts && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(aborts) === 'object') Object.entries(aborts).forEach(function(_ref3) {
                        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), key = _ref4[0], time = _ref4[1];
                        if (typeof time === 'number') _this2.entriesTimeline.push({
                            time: time,
                            data: {
                                type: 'window:event',
                                eventType: key
                            }
                        });
                    });
                }
                (_this$windowEventObse = this.windowEventObserver) === null || _this$windowEventObse === void 0 || _this$windowEventObse.start();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$viewportObserve2, _this$windowEventObse2;
                (_this$viewportObserve2 = this.viewportObserver) === null || _this$viewportObserve2 === void 0 || _this$viewportObserve2.stop();
                (_this$windowEventObse2 = this.windowEventObserver) === null || _this$windowEventObse2 === void 0 || _this$windowEventObse2.stop();
                // Clear SSR state on stop (matches old VCObserver behavior)
                this.ssr.reactRootElement = null;
            }
        },
        {
            key: "setReactRootElement",
            value: function setReactRootElement(element) {
                this.ssr.reactRootElement = element;
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStart = startTime;
                this.ssr.state = $d28f8f4638044c49$var$SSRState.waitingForFirstRender;
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStop = stopTime;
            }
        },
        {
            key: "collectSSRPlaceholders",
            value: function collectSSRPlaceholders() {
            // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
            // Individual observers don't need to implement this
            }
        },
        {
            key: "getSSRState",
            value: function getSSRState() {
                return this.ssr;
            }
        },
        {
            key: "getSSRPlaceholderHandler",
            value: function getSSRPlaceholderHandler() {
                return this.ssrPlaceholderHandler;
            }
        },
        {
            key: "addSSR",
            value: function addSSR(ssr) {
                this.entriesTimeline.push({
                    time: ssr,
                    data: {
                        elementName: 'SSR',
                        type: 'mutation:element',
                        rect: {
                            height: (0, $3VF6y.default)(),
                            width: (0, $5X23Y.default)(),
                            left: 0,
                            top: 0,
                            x: 0,
                            y: 0,
                            bottom: (0, $3VF6y.default)(),
                            right: (0, $5X23Y.default)(),
                            toJSON: function toJSON() {
                                return null;
                            }
                        },
                        visible: true
                    }
                });
            }
        },
        {
            key: "getVCResult",
            value: function() {
                var _getVCResult = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(param) {
                    var start, stop, interactionId, interactionType, interactionAbortReason, isPageVisible, include3p, includeSSRRatio, excludeSmartAnswersInSearch, rawDataStopTime, results, feVCCalculationStartTime, calculator_fy25_03, orderedEntries, fy25_03, calculator_fy26_04, calculator_next, calculatorParams, isFy2604Enabled, _yield$Promise$all, _yield$Promise$all2, fy26_04, vcNext, feVCCalculationEndTime, rawVCCalculationStartTime, rawHandler, rawStopTime, rawOrderedEntries, raw, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                start = param.start, stop = param.stop, interactionId = param.interactionId, interactionType = param.interactionType, interactionAbortReason = param.interactionAbortReason, isPageVisible = param.isPageVisible, include3p = param.include3p, includeSSRRatio = param.includeSSRRatio, excludeSmartAnswersInSearch = param.excludeSmartAnswersInSearch, rawDataStopTime = param.rawDataStopTime;
                                results = [];
                                this.addStartEntry(start);
                                feVCCalculationStartTime = performance.now();
                                calculator_fy25_03 = new (0, $jdRKQ.default)();
                                if (param.includeSSRInV3 && param.ssr) this.addSSR(param.ssr);
                                orderedEntries = this.entriesTimeline.getOrderedEntries({
                                    start: start,
                                    stop: stop
                                });
                                if (!(0, $DtLwq.isVCRevisionEnabled)('fy25.03')) {
                                    _context.next = 2;
                                    break;
                                }
                                _context.next = 1;
                                return calculator_fy25_03.calculate({
                                    orderedEntries: orderedEntries,
                                    startTime: start,
                                    stopTime: stop,
                                    interactionId: interactionId,
                                    interactionType: interactionType,
                                    isPostInteraction: this.isPostInteraction,
                                    include3p: include3p,
                                    excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
                                    includeSSRRatio: includeSSRRatio,
                                    isPageVisible: isPageVisible,
                                    interactionAbortReason: interactionAbortReason,
                                    reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
                                });
                            case 1:
                                _t = _context.sent;
                                _context.next = 3;
                                break;
                            case 2:
                                _t = null;
                            case 3:
                                fy25_03 = _t;
                                if (fy25_03) results.push(fy25_03);
                                // From TTVC v4 onwards, ensuring that SSR entry is always auto-added, whenever it is configured.
                                if (param.ssr) this.addSSR(param.ssr);
                                calculator_fy26_04 = new (0, $dzHaO.default)();
                                calculator_next = new (0, $cTTWn.default)();
                                calculatorParams = {
                                    orderedEntries: orderedEntries,
                                    startTime: start,
                                    stopTime: stop,
                                    interactionId: interactionId,
                                    interactionType: interactionType,
                                    isPostInteraction: this.isPostInteraction,
                                    include3p: include3p,
                                    excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
                                    includeSSRRatio: includeSSRRatio,
                                    isPageVisible: isPageVisible,
                                    interactionAbortReason: interactionAbortReason,
                                    reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
                                };
                                isFy2604Enabled = (0, $DtLwq.isVCRevisionEnabled)('fy26.04');
                                _context.next = 4;
                                return Promise.all([
                                    isFy2604Enabled ? calculator_fy26_04.calculate(calculatorParams) : null,
                                    (0, $DtLwq.isVCRevisionEnabled)('next') ? calculator_next.calculate(calculatorParams) : null
                                ]);
                            case 4:
                                _yield$Promise$all = _context.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all, 2);
                                fy26_04 = _yield$Promise$all2[0];
                                vcNext = _yield$Promise$all2[1];
                                if (fy26_04) results.push(fy26_04);
                                if (vcNext) results.push(vcNext);
                                feVCCalculationEndTime = performance.now(); // Always include raw data so the server can recalculate metrics
                                // (ssrRatio, labelStacks, speedIndex) from raw observations.
                                rawVCCalculationStartTime = performance.now();
                                rawHandler = new (0, $gOE39.default)(); // Use rawDataStopTime (end3p) when available to capture observations during 3p holds
                                rawStopTime = rawDataStopTime !== null && rawDataStopTime !== void 0 ? rawDataStopTime : stop;
                                rawOrderedEntries = rawDataStopTime ? this.entriesTimeline.getOrderedEntries({
                                    start: start,
                                    stop: rawStopTime
                                }) : orderedEntries;
                                _context.next = 5;
                                return rawHandler.getRawData({
                                    entries: rawOrderedEntries,
                                    startTime: start,
                                    stopTime: rawStopTime,
                                    isPageVisible: isPageVisible
                                });
                            case 5:
                                raw = _context.sent;
                                results.forEach(function(result) {
                                    delete result.vcDetails;
                                    delete result.ratios;
                                });
                                if (raw) {
                                    raw.rawVCTime = Number((performance.now() - rawVCCalculationStartTime).toFixed(2));
                                    raw.feVCTime = Number((feVCCalculationEndTime - feVCCalculationStartTime).toFixed(2));
                                    results.push(raw);
                                }
                                return _context.abrupt("return", results);
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getVCResult(_x) {
                    return _getVCResult.apply(this, arguments);
                }
                return getVCResult;
            }()
        },
        {
            key: "addStartEntry",
            value: function addStartEntry(startTime) {
                this.entriesTimeline.push({
                    time: startTime,
                    data: {
                        type: 'mutation:element',
                        elementName: 'START',
                        visible: true,
                        rect: {
                            x: 0,
                            y: 0,
                            width: window.innerWidth,
                            height: window.innerHeight,
                            top: 0,
                            left: 0,
                            bottom: window.innerHeight,
                            right: window.innerWidth,
                            toJSON: function toJSON() {
                                return {
                                    x: this.x,
                                    y: this.y,
                                    width: this.width,
                                    height: this.height,
                                    top: this.top,
                                    left: this.left,
                                    bottom: this.bottom,
                                    right: this.right
                                };
                            }
                        }
                    }
                });
            }
        },
        {
            key: "getElementName",
            value: function getElementName(element) {
                return (0, $ePEWw.default)(this.selectorConfig, element);
            }
        }
    ]);
}();
function $d28f8f4638044c49$var$labelStackFromFiber(fiber) {
    var _fiber$child;
    var value = fiber === null || fiber === void 0 || (_fiber$child = fiber.child) === null || _fiber$child === void 0 || (_fiber$child = _fiber$child.memoizedProps) === null || _fiber$child === void 0 ? void 0 : _fiber$child.value;
    return Array.isArray(value === null || value === void 0 ? void 0 : value.labelStack) ? value.labelStack : [];
}
function $d28f8f4638044c49$var$labelStackToString(labelStack) {
    return labelStack.map(function(label) {
        return (0, $bYaqG.sanitizeLabelStackName)(label.name);
    }).join('/');
}
function $d28f8f4638044c49$var$labelStackToSegment(labelStack) {
    var segmentIndex = -1;
    for(var i = labelStack.length - 1; i >= 0; i--)if (labelStack[i].segmentId) {
        segmentIndex = i;
        break;
    }
    return labelStack.slice(0, segmentIndex + 1).map(function(label) {
        return (0, $bYaqG.sanitizeLabelStackName)(label.name);
    }).join('/');
}
function $d28f8f4638044c49$var$traverseFiber(fiber) {
    var segment = 'unknown';
    var labelStackString = 'unknown';
    var currentFiber = fiber;
    while(currentFiber){
        if (currentFiber.type) {
            var componentName = currentFiber.type.displayName || currentFiber.type.name;
            if (componentName === 'UFOSegment' || componentName === 'UFOLabel') {
                var labelStack = $d28f8f4638044c49$var$labelStackFromFiber(currentFiber);
                labelStackString = $d28f8f4638044c49$var$labelStackToString(labelStack) || 'unknown';
                segment = $d28f8f4638044c49$var$labelStackToSegment(labelStack) || 'unknown';
                break;
            }
        }
        currentFiber = currentFiber.return;
    }
    return {
        segment: segment,
        labelStack: labelStackString
    };
}
function $d28f8f4638044c49$var$getLabelStacks(element) {
    var reactFiberKey = Object.keys(element).find(function(key) {
        return key.startsWith('__reactFiber$');
    });
    if (!reactFiberKey) return null;
    var fiber = element[reactFiberKey];
    return fiber ? $d28f8f4638044c49$var$traverseFiber(fiber) : null;
}
var $d28f8f4638044c49$var$SUPPORTED_ABORT_EVENT_TARGET_TYPES = new Set([
    'scroll-container',
    'scroll',
    'wheel'
]);
function $d28f8f4638044c49$var$isAbortEventTargetSupported(type) {
    return $d28f8f4638044c49$var$SUPPORTED_ABORT_EVENT_TARGET_TYPES.has(type);
}
function $d28f8f4638044c49$var$getAbortEventTargetElement(target) {
    if (target instanceof HTMLElement) return target;
    if (target instanceof Document) {
        var _target$documentEleme;
        var scrollingElement = target.scrollingElement;
        if (scrollingElement instanceof HTMLElement) return scrollingElement;
        return (_target$documentEleme = target.documentElement) !== null && _target$documentEleme !== void 0 ? _target$documentEleme : null;
    }
    if (target instanceof Window) {
        var _target$document$docu;
        var _scrollingElement = target.document.scrollingElement;
        if (_scrollingElement instanceof HTMLElement) return _scrollingElement;
        return (_target$document$docu = target.document.documentElement) !== null && _target$document$docu !== void 0 ? _target$document$docu : null;
    }
    if (target instanceof Node) return target.parentElement;
    return null;
}

});
parcelRegister("lF8z4", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc54120f907b7d53$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");
var $fc54120f907b7d53$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function EntriesTimeline() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, EntriesTimeline);
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(EntriesTimeline, [
        {
            key: "push",
            value: function push(entry) {
                this.unorderedEntries.push(entry);
                this.sortedEntriesCache.clear();
            }
        },
        {
            key: "getCacheKey",
            value: function getCacheKey(start, stop) {
                return "".concat(start !== null && start !== void 0 ? start : 'null', "_").concat(stop !== null && stop !== void 0 ? stop : 'null');
            }
        },
        {
            key: "getOrderedEntries",
            value: function getOrderedEntries(_ref) {
                var _this$sortedEntriesCa;
                var start = _ref.start, stop = _ref.stop;
                var cacheKey = this.getCacheKey(start, stop);
                var cachedSortedEntries = (_this$sortedEntriesCa = this.sortedEntriesCache.get(cacheKey)) === null || _this$sortedEntriesCa === void 0 ? void 0 : _this$sortedEntriesCa.deref();
                if (cachedSortedEntries) return cachedSortedEntries;
                var filteredEntries = this.unorderedEntries.filter(function(e) {
                    return e.time >= (start !== null && start !== void 0 ? start : 0) && e.time <= (stop !== null && stop !== void 0 ? stop : performance.now());
                });
                var sortedEntries = filteredEntries.sort(function(a, b) {
                    return a.time - b.time;
                });
                this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
                return sortedEntries;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.unorderedEntries = [];
                this.sortedEntriesCache.clear();
            }
        }
    ]);
}();

});

parcelRegister("ePEWw", function(module, exports) {
$parcel$export(module.exports, "default", () => $acc596884d14682a$export$2e2bcd8739ae039);
var $acc596884d14682a$var$nameCache = new WeakMap();
function $acc596884d14682a$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) {
        var elementInstance = 'Unknown';
        // Types of elements according to LLM
        if (element instanceof Text) elementInstance = 'Text';
        else if (element instanceof DocumentFragment) elementInstance = 'DocumentFragment';
        else if (element instanceof Document) elementInstance = 'Document';
        else if (element instanceof Comment) elementInstance = 'Comment';
        else if (element instanceof ProcessingInstruction) elementInstance = 'ProcessingInstruction';
        else if (element instanceof Attr) elementInstance = 'Attr';
        else if (element instanceof CDATASection) elementInstance = 'CDATASection';
        if (element.parentElement && element.parentElement instanceof HTMLElement) {
            var parentElementSelector = $acc596884d14682a$var$getElementName(selectorConfig, element.parentElement);
            return "".concat(parentElementSelector, " > ").concat(elementInstance);
        } else return elementInstance;
    }
    var cachedName = $acc596884d14682a$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    var tagName = element.localName;
    var encodeValue = function encodeValue(s) {
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch (_unused) {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    var getAttributeSelector = function getAttributeSelector(attributeName) {
        var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        if (element && typeof element.getAttribute !== 'function') return '';
        var attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        var encondedAttrValue = encodeValue(attrValue);
        return "".concat(prefix, "[").concat(attributeName, "=\"").concat(encondedAttrValue, "\"]");
    };
    // Construct the data-vc attribute selector if specified in the config.
    var dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    var id = selectorConfig.id && element.id ? "#".concat(encodeValue(element.id)) : '';
    // Construct the test ID selector if specified in the config.
    var testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    var role = selectorConfig.role ? getAttributeSelector('role') : '';
    var classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    var classList = selectorConfig.className && classNames ? ".".concat(classNames) : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    var primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    var attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        var parentName = element.parentElement ? $acc596884d14682a$var$getElementName(selectorConfig, element.parentElement) : 'unknown';
        return "".concat(parentName, " > ").concat(tagName);
    }
    // Return the final constructed name: tagName + attributes or classList.
    var name = "".concat(tagName).concat(attributes || classList);
    $acc596884d14682a$var$nameCache.set(element, name);
    return name;
}
var $acc596884d14682a$export$2e2bcd8739ae039 = $acc596884d14682a$var$getElementName;

});

parcelRegister("jdRKQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $dfe8edc4028e079e$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $50U6m = parcelRequire("50U6m");

var $aeUxq = parcelRequire("aeUxq");

var $aq2Gy = parcelRequire("aq2Gy");

var $6VzxC = parcelRequire("6VzxC");

var $gjuwC = parcelRequire("gjuwC");

var $fWZXc = parcelRequire("fWZXc");
function $dfe8edc4028e079e$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $dfe8edc4028e079e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $dfe8edc4028e079e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dfe8edc4028e079e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $dfe8edc4028e079e$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
var $dfe8edc4028e079e$var$REVISION_NO = 'fy25.03';
var $dfe8edc4028e079e$var$getConsideredEntryTypes = function getConsideredEntryTypes(include3p, excludeSmartAnswersInSearch) {
    var entryTypes = [
        'mutation:child-element',
        'mutation:element',
        'mutation:attribute',
        'layout-shift',
        'layout-shift:same-rect',
        'window:event'
    ];
    // Only include third-party elements in TTVC calculation when explicitly requested.
    // GenAI elements intentionally remain excluded from core TTVC; a server-side metric variant
    // can derive "including GenAI" from the emitted metricWindows payload.
    if (include3p) {
        entryTypes.push('mutation:third-party-element');
        entryTypes.push('mutation:third-party-attribute');
    }
    if (!excludeSmartAnswersInSearch) {
        entryTypes.push('mutation:smart-answers-element');
        entryTypes.push('mutation:smart-answers-attribute');
    }
    entryTypes.push('mutation:media');
    // Still included as part of TTVC v3
    entryTypes.push('mutation:attribute:non-visual-input-name');
    return entryTypes;
};
var $dfe8edc4028e079e$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractVCCalculator) {
    function VCCalculator_FY25_03(revisionNo) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, VCCalculator_FY25_03);
        return $dfe8edc4028e079e$var$_callSuper(this, VCCalculator_FY25_03, [
            revisionNo !== null && revisionNo !== void 0 ? revisionNo : $dfe8edc4028e079e$var$REVISION_NO
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(VCCalculator_FY25_03, _AbstractVCCalculator);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(VCCalculator_FY25_03, [
        {
            key: "isEntryIncluded",
            value: function isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
                if (!$dfe8edc4028e079e$var$getConsideredEntryTypes(include3p, excludeSmartAnswersInSearch).includes(entry.data.type)) return false;
                if (entry.data.type === 'mutation:attribute:framework-routing') return false;
                if (entry.data.type === 'mutation:media' && (0, $50U6m.fg)('media-perf-uplift-mutation-fix')) {
                    var entryData = entry.data;
                    var attributeName = entryData.attributeName;
                    if (attributeName && (/data-(test|file|context)-\S+/g.test(attributeName) || attributeName === 'data-cursor' || attributeName === 'alt' || (attributeName === 'localid' || attributeName === 'contenteditable' || attributeName === 'anchor-name') && (0, $aeUxq.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false))) return false;
                    // special case for style attribute to ignore only anchor-name changes
                    if ((0, $aeUxq.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false)) {
                        if ((0, $aq2Gy.containsAnchorNameMutationInStyle)({
                            attributeName: entryData.attributeName,
                            oldValue: entryData.oldValue,
                            newValue: entryData.newValue
                        })) return false;
                    }
                }
                if (entry.data.type === 'mutation:attribute') {
                    var _entryData = entry.data;
                    var _attributeName = _entryData.attributeName;
                    if (!_attributeName || (0, $gjuwC.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(_attributeName)) return false;
                    if (_attributeName.startsWith('data-test') || (0, $gjuwC.NON_VISUAL_ARIA_ATTRIBUTES).includes(_attributeName) || (0, $gjuwC.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES).includes(_attributeName) || (0, $gjuwC.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES).includes(_attributeName) && (0, $50U6m.fg)('platform_ufo_exclude_fdprocessedid_attribute')) return false;
                    return true;
                }
                if ((0, $fWZXc.default)(entry.data) && !entry.data.visible) return false;
                return true;
            }
        },
        {
            key: "getVCCleanStatus",
            value: function getVCCleanStatus(filteredEntries) {
                var dirtyReason = '';
                var abortTimestamp = -1;
                var hasAbortEvent = filteredEntries.some(function(entry) {
                    if (entry.data.type === 'window:event') {
                        var data = entry.data;
                        var eventType = data.eventType;
                        if ($dfe8edc4028e079e$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                            dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                            abortTimestamp = Math.round(entry.time);
                            return true;
                        }
                    }
                    return false;
                });
                if (hasAbortEvent && dirtyReason) return {
                    isVCClean: false,
                    dirtyReason: dirtyReason,
                    abortTimestamp: abortTimestamp
                };
                return {
                    isVCClean: true
                };
            }
        }
    ]);
}((0, $6VzxC.default));

});
parcelRegister("aeUxq", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $77471179cd56c057$export$9db1624a8af791a4);

var $h2bc4 = parcelRequire("h2bc4");

var $8qy01 = parcelRequire("8qy01");
var $77471179cd56c057$export$9db1624a8af791a4 = function expVal(experimentName, experimentParam, defaultValue) {
    // If client is not initialized, we return the default value
    if (!(0, $h2bc4.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $h2bc4.default).getExperimentValue(experimentName, experimentParam, defaultValue);
    (0, $8qy01.addFeatureFlagAccessed)("".concat(experimentName, ":").concat(experimentParam), experimentValue);
    return experimentValue;
};

});
parcelRegister("h2bc4", function(module, exports) {
$parcel$export(module.exports, "default", () => $c66b4e6bbb9bd1b2$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $20ap1 = parcelRequire("20ap1");

var $jeMGe = parcelRequire("jeMGe");



var $c66b4e6bbb9bd1b2$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $c66b4e6bbb9bd1b2$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$c66b4e6bbb9bd1b2$var$_FeatureGates = $c66b4e6bbb9bd1b2$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "client", new (0, $20ap1.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$c66b4e6bbb9bd1b2$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $c66b4e6bbb9bd1b2$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $c66b4e6bbb9bd1b2$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$c66b4e6bbb9bd1b2$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $c66b4e6bbb9bd1b2$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $c66b4e6bbb9bd1b2$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "initializeCalled", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.initializeCalled.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "initializeCompleted", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.initializeCompleted.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "waitUntilInitializeCompleted", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "initialize", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.initialize.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "initializeWithProvider", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.initializeWithProvider.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "initializeFromValues", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.initializeFromValues.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "manuallyLogGateExposure", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.manuallyLogGateExposure.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "getExperiment", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.getExperiment.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "manuallyLogExperimentExposure", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "manuallyLogLayerExposure", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.manuallyLogLayerExposure.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "shutdownStatsig", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.shutdownStatsig.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "overrideGate", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.overrideGate.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "clearGateOverride", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.clearGateOverride.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "overrideConfig", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.overrideConfig.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "clearConfigOverride", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.clearConfigOverride.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "setOverrides", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.setOverrides.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "getOverrides", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.getOverrides.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "clearAllOverrides", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.clearAllOverrides.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "isCurrentUser", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.isCurrentUser.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "onGateUpdated", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.onGateUpdated.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "onExperimentValueUpdated", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.onExperimentValueUpdated.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "onAnyUpdated", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.onAnyUpdated.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "updateUser", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.updateUser.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "updateUserWithProvider", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.updateUserWithProvider.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "updateUserWithValues", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.updateUserWithValues.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "getPackageVersion", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.getPackageVersion.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "getTargetApp", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.getTargetApp.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "getLayer", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.getLayer.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "getLayerValue", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.getLayerValue.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
var $c66b4e6bbb9bd1b2$var$boundFGJS = $c66b4e6bbb9bd1b2$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $c66b4e6bbb9bd1b2$var$FeatureGates;
    else {
        var $c66b4e6bbb9bd1b2$var$_boundFGJS, $c66b4e6bbb9bd1b2$var$_boundFGJS$getPackage;
        $c66b4e6bbb9bd1b2$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $c66b4e6bbb9bd1b2$var$boundVersion = (($c66b4e6bbb9bd1b2$var$_boundFGJS = $c66b4e6bbb9bd1b2$var$boundFGJS) === null || $c66b4e6bbb9bd1b2$var$_boundFGJS === void 0 || ($c66b4e6bbb9bd1b2$var$_boundFGJS$getPackage = $c66b4e6bbb9bd1b2$var$_boundFGJS.getPackageVersion) === null || $c66b4e6bbb9bd1b2$var$_boundFGJS$getPackage === void 0 ? void 0 : $c66b4e6bbb9bd1b2$var$_boundFGJS$getPackage.call($c66b4e6bbb9bd1b2$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($c66b4e6bbb9bd1b2$var$boundVersion !== (0, $jeMGe.CLIENT_VERSION)) {
            var $c66b4e6bbb9bd1b2$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($c66b4e6bbb9bd1b2$var$boundVersion, " when module version ").concat((0, $jeMGe.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($c66b4e6bbb9bd1b2$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $c66b4e6bbb9bd1b2$export$2e2bcd8739ae039 = $c66b4e6bbb9bd1b2$var$boundFGJS;

});
parcelRegister("20ap1", function(module, exports) {
$parcel$export(module.exports, "Client", () => $1753a69d5666fee7$export$1f2bb630327ac4b6);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");

var $7HFz2 = parcelRequire("7HFz2");

var $6bdCD = parcelRequire("6bdCD");

var $aJeNa = parcelRequire("aJeNa");

var $2lDCa = parcelRequire("2lDCa");

var $j14ui = parcelRequire("j14ui");

var $2cJWD = parcelRequire("2cJWD");

var $cK9Fv = parcelRequire("cK9Fv");

var $cKC49 = parcelRequire("cKC49");

var $bfqQV = parcelRequire("bfqQV");

var $9xnxJ = parcelRequire("9xnxJ");

var $ayvGz = parcelRequire("ayvGz");

var $hN688 = parcelRequire("hN688");

var $iYRGT = parcelRequire("iYRGT");

var $jeMGe = parcelRequire("jeMGe");
var $1753a69d5666fee7$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $1753a69d5666fee7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1753a69d5666fee7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1753a69d5666fee7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1753a69d5666fee7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1753a69d5666fee7$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $1753a69d5666fee7$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $1753a69d5666fee7$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $9xnxJ.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscriptions", new (0, $7HFz2.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "dataAdapter", new (0, $bfqQV.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $9xnxJ.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $cK9Fv.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 1;
                                    break;
                                }
                                if (!(0, $ayvGz.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $cK9Fv.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 1;
                                    break;
                                }
                                if (!(0, $ayvGz.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $jeMGe.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $1753a69d5666fee7$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $jeMGe.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $iYRGT.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $cK9Fv.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 1;
                                    break;
                                }
                                if (!(0, $ayvGz.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 1:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $cK9Fv.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $2cJWD.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 1;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 1:
                                _context5.next = 2;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 2:
                                _context5.next = 3;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 1:
                                if (!this.initCompleted) {
                                    _context7.next = 2;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 2:
                                _context7.next = 3;
                                return this.initPromise;
                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $6bdCD.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $6bdCD.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $2lDCa.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $ayvGz.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $ayvGz.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $1753a69d5666fee7$var$_objectSpread({}, clientOptions);
                                if (!clientOptions.localMode) {
                                    _context8.next = 2;
                                    break;
                                }
                                _context8.next = 1;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 1:
                                return _context8.abrupt("return");
                            case 2:
                                _context8.prev = 2;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $2cJWD.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $2cJWD.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 6;
                                break;
                            case 4:
                                _context8.prev = 4;
                                _t = _context8["catch"](2);
                                if (_t instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t === null || _t === void 0 ? void 0 : _t.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t;
                            case 6:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            2,
                            4
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $1753a69d5666fee7$var$_objectSpread($1753a69d5666fee7$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 2;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 2:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 6;
                                break;
                            case 4:
                                _context9.prev = 4;
                                _t2 = _context9["catch"](1);
                                if (_t2 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t2 === null || _t2 === void 0 ? void 0 : _t2.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t2;
                            case 6:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            4
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, _args0 = arguments, _t3;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $cKC49.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $1753a69d5666fee7$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $1753a69d5666fee7$var$_objectSpread($1753a69d5666fee7$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $1753a69d5666fee7$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $iYRGT.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(newClientOptions, $1753a69d5666fee7$var$_excluded);
                                frontendUser = (0, $hN688.toStatsigUser)(identifiers, customAttributes);
                                this.user = (0, $j14ui.deepAssign)({}, initializeValues.user, frontendUser);
                                statsigOptions = $1753a69d5666fee7$var$_objectSpread($1753a69d5666fee7$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 1;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 2;
                                return this.statsigClient.initializeAsync();
                            case 2:
                                _context0.next = 5;
                                break;
                            case 3:
                                _context0.prev = 3;
                                _t3 = _context0["catch"](1);
                                if (_t3 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_t3 === null || _t3 === void 0 ? void 0 : _t3.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($1753a69d5666fee7$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 4;
                                return this.statsigClient.initializeAsync();
                            case 4:
                                this.initWithDefaults = true;
                                throw _t3;
                            case 5:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise, _t4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 1:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 2;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 2:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 3;
                                _context10.next = 4;
                                return this.initPromise;
                            case 4:
                                _context10.next = 6;
                                break;
                            case 5:
                                _context10.prev = 5;
                                _t4 = _context10["catch"](3);
                            case 6:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 1;
                                                    break;
                                                }
                                                _context1.next = 1;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 1:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 7:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            3,
                            5
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, frontendUser, _updateUserCompletion, _ref4, errMsg, success, errorMessage, _t5, _t6;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 2;
                                return initializeValuesPromise;
                            case 2:
                                initializeValues = _context11.sent;
                                frontendUser = (0, $hN688.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, $j14ui.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
                                _context11.next = 4;
                                break;
                            case 3:
                                _context11.prev = 3;
                                _t5 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _t5 instanceof Error ? _t5.message : JSON.stringify(_t5);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _t5;
                            case 4:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 5;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 6;
                                    break;
                                }
                                _context11.next = 6;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 6:
                                _context11.next = 8;
                                break;
                            case 7:
                                _context11.prev = 7;
                                _t6 = _context11["catch"](5);
                                success = false;
                                errorMessage = String(_t6);
                            case 8:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 9;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 10;
                                break;
                            case 9:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 10:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            3
                        ],
                        [
                            5,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $jeMGe.CLIENT_VERSION;
            }
        },
        {
            key: "getTargetApp",
            value: function getTargetApp() {
                var _this$initOptions2;
                return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $aJeNa.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $aJeNa.Layer).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("7HFz2", function(module, exports) {
$parcel$export(module.exports, "default", () => $59bcca5a32a3773a$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $hLfKH = parcelRequire("hLfKH");
function $59bcca5a32a3773a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $59bcca5a32a3773a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $59bcca5a32a3773a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $59bcca5a32a3773a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $59bcca5a32a3773a$export$a66cbd9b2289cd78 = '@all-features';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $59bcca5a32a3773a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $59bcca5a32a3773a$var$_objectSpread($59bcca5a32a3773a$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $59bcca5a32a3773a$var$_objectSpread($59bcca5a32a3773a$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $59bcca5a32a3773a$var$_objectSpread($59bcca5a32a3773a$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $59bcca5a32a3773a$var$_objectSpread($59bcca5a32a3773a$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($59bcca5a32a3773a$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($59bcca5a32a3773a$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($59bcca5a32a3773a$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $59bcca5a32a3773a$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("6bdCD", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $47fe564159cc0d18$export$6dc24881a3d96325);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $amt94 = parcelRequire("amt94");

var $2aoCC = parcelRequire("2aoCC");
var $47fe564159cc0d18$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $amt94.migrateEvaluationDetails)(experiment.details), (0, $2aoCC.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("amt94", function(module, exports) {
$parcel$export(module.exports, "migrateEvaluationDetails", () => $78b2911d184810b0$export$18ad168d3dbac899);

var $iYJcE = parcelRequire("iYJcE");

var $2lDCa = parcelRequire("2lDCa");
var $78b2911d184810b0$var$evaluationReasonMappings = Object.entries((0, $2lDCa.EvaluationReason)).map(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $78b2911d184810b0$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $78b2911d184810b0$var$evaluationReasonMappings.find(function(_ref3) {
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 1), key = _ref4[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $2lDCa.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};

});
parcelRegister("2lDCa", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $1b5c459198dd8d8d$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $1b5c459198dd8d8d$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
}; // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});


parcelRegister("2aoCC", function(module, exports) {
$parcel$export(module.exports, "migrateSecondaryExposures", () => $193f9d5355456695$export$55fd683752d01e67);
var $193f9d5355456695$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});


parcelRegister("aJeNa", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $7cf994b8c9dff269$export$936d0764594b6eb3);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $amt94 = parcelRequire("amt94");

var $2aoCC = parcelRequire("2aoCC");
var $7cf994b8c9dff269$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $amt94.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $2aoCC.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $2aoCC.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("j14ui", function(module, exports) {
$parcel$export(module.exports, "deepAssign", () => $dd819773b2821dd0$export$1148cb79ceecd5fa);

var $ekGgq = parcelRequire("ekGgq");

var $iYJcE = parcelRequire("iYJcE");

var $fC8ib = parcelRequire("fC8ib");
function $dd819773b2821dd0$export$1148cb79ceecd5fa(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return $dd819773b2821dd0$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sources)));
    for(var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], src = _Object$entries$_i[1];
        var dst = target[key];
        var srcIsObj = src && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(src) === 'object' && !Array.isArray(src);
        var dstIsObj = dst && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(dst) === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $dd819773b2821dd0$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $dd819773b2821dd0$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sources)));
}

});

parcelRegister("2cJWD", function(module, exports) {
$parcel$export(module.exports, "default", () => $19b0576e040f49f0$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $iYRGT = parcelRequire("iYRGT");

var $jeMGe = parcelRequire("jeMGe");

var $8fiMv = parcelRequire("8fiMv");
function $19b0576e040f49f0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $19b0576e040f49f0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $19b0576e040f49f0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $19b0576e040f49f0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $19b0576e040f49f0$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $19b0576e040f49f0$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $19b0576e040f49f0$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $19b0576e040f49f0$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $19b0576e040f49f0$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $19b0576e040f49f0$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $19b0576e040f49f0$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $19b0576e040f49f0$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $19b0576e040f49f0$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $19b0576e040f49f0$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $19b0576e040f49f0$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(fetcherOptions) {
                    var targetApp, url, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 1;
                                _context.next = 2;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                                _context.prev = 3;
                                _t = _context["catch"](1);
                                if (!(_t instanceof Error)) {
                                    _context.next = 4;
                                    break;
                                }
                                throw _t;
                            case 4:
                                throw Error('Failed to retrieve client sdk key');
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 2;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                                _context2.prev = 3;
                                _t2 = _context2["catch"](1);
                                if (!(_t2 instanceof Error)) {
                                    _context2.next = 4;
                                    break;
                                }
                                throw _t2;
                            case 4:
                                throw Error('Failed to retrieve experiment values');
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 2;
                                    break;
                                }
                                _context3.next = 1;
                                return response.text();
                            case 1:
                                body = _context3.sent;
                                throw new (0, $8fiMv.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 2:
                                if (!(response.status === 204)) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new (0, $8fiMv.ResponseError)('Unexpected 204 response');
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return response.text();
                            case 1:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $19b0576e040f49f0$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $iYRGT.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $iYRGT.FeatureGateEnvironment).Production:
                        return $19b0576e040f49f0$export$18c93900db9358a4;
                    case (0, $iYRGT.FeatureGateEnvironment).Staging:
                        return $19b0576e040f49f0$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $iYRGT.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $iYRGT.FeatureGateEnvironment).Development:
                        return $19b0576e040f49f0$export$f058dbf75c3bc647;
                    case (0, $iYRGT.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $19b0576e040f49f0$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $19b0576e040f49f0$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $19b0576e040f49f0$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 1;
                                return fetch("".concat(baseUrl).concat(path), $19b0576e040f49f0$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $jeMGe.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 1:
                                response = _context5.sent;
                                _context5.next = 2;
                                return this.handleResponseError(response);
                            case 2:
                                _context5.next = 3;
                                return this.extractResponseBody(response);
                            case 3:
                                return _context5.abrupt("return", _context5.sent);
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $19b0576e040f49f0$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($19b0576e040f49f0$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($19b0576e040f49f0$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("iYRGT", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $dd177a7951d29162$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $dd177a7951d29162$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $dd177a7951d29162$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
var $dd177a7951d29162$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
var $dd177a7951d29162$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});

parcelRegister("jeMGe", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $e01515fc694d863e$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $e01515fc694d863e$export$a59f8d67326bd1cb = "6.0.2";

});

parcelRegister("8fiMv", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $600e4b088653d78d$export$286baf652d0b1206);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $600e4b088653d78d$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $600e4b088653d78d$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $600e4b088653d78d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($600e4b088653d78d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $600e4b088653d78d$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ResponseError);
        return $600e4b088653d78d$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});


parcelRegister("cK9Fv", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $947147d86d14eb6b$export$d119b37e5f788b43);

var $25nEq = parcelRequire("25nEq");

var $ygbGG = parcelRequire("ygbGG");

var $iYRGT = parcelRequire("iYRGT");
function $947147d86d14eb6b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $947147d86d14eb6b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $947147d86d14eb6b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $947147d86d14eb6b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $947147d86d14eb6b$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $947147d86d14eb6b$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $ygbGG.isFedRamp)() ? (0, $iYRGT.PerimeterType).FEDRAMP_MODERATE : (0, $iYRGT.PerimeterType).COMMERCIAL
    }, options);
};

});
parcelRegister("ygbGG", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $066fbb979700de6b$export$64d6499adf9b2e51);

var $cThmQ = parcelRequire("cThmQ");
function $066fbb979700de6b$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $cThmQ.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("cThmQ", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $962817e776c3bc68$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $962817e776c3bc68$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "FEDRAMP_FEDEX", () => $962817e776c3bc68$export$bd6b5a7802d76127);
$parcel$export(module.exports, "STAGING", () => $962817e776c3bc68$export$a739cd5aac835909);
$parcel$export(module.exports, "PRODUCTION", () => $962817e776c3bc68$export$42dd0cdd351a4a9);
$parcel$export(module.exports, "DEV", () => $962817e776c3bc68$export$404582bc18fe4d9e);
var $962817e776c3bc68$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $962817e776c3bc68$export$f005e2e9f707cb5f = 'commercial';
var $962817e776c3bc68$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $962817e776c3bc68$export$a739cd5aac835909 = 'stg';
var $962817e776c3bc68$export$42dd0cdd351a4a9 = 'prod';
var $962817e776c3bc68$export$404582bc18fe4d9e = 'dev';

});



parcelRegister("cKC49", function(module, exports) {
$parcel$export(module.exports, "migrateInitializationOptions", () => $94874f02fa1afb16$export$202946b690d26d22);

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");
var $94874f02fa1afb16$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $94874f02fa1afb16$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $94874f02fa1afb16$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $94874f02fa1afb16$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $94874f02fa1afb16$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $94874f02fa1afb16$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(options, $94874f02fa1afb16$var$_excluded);
    return $94874f02fa1afb16$var$_objectSpread($94874f02fa1afb16$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};

});

parcelRegister("bfqQV", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $8305ecc7067867f1$export$55fffef3474104af);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");
function $8305ecc7067867f1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8305ecc7067867f1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8305ecc7067867f1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8305ecc7067867f1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8305ecc7067867f1$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $8305ecc7067867f1$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $8305ecc7067867f1$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($8305ecc7067867f1$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $8305ecc7067867f1$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $8305ecc7067867f1$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoFetchDataAdapter);
        _this = $8305ecc7067867f1$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $8305ecc7067867f1$var$_objectSpread($8305ecc7067867f1$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $8305ecc7067867f1$var$_objectSpread($8305ecc7067867f1$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $8305ecc7067867f1$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $8305ecc7067867f1$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));

});

parcelRegister("9xnxJ", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $6f19754a7eb52889$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $6f19754a7eb52889$export$bcb28fbac1def494);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $dtn6l = parcelRequire("dtn6l");
function $6f19754a7eb52889$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6f19754a7eb52889$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6f19754a7eb52889$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6f19754a7eb52889$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6f19754a7eb52889$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $6f19754a7eb52889$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $6f19754a7eb52889$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $6f19754a7eb52889$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $6f19754a7eb52889$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $6f19754a7eb52889$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $6f19754a7eb52889$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $6f19754a7eb52889$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $6f19754a7eb52889$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $6f19754a7eb52889$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $6f19754a7eb52889$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $6f19754a7eb52889$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PersistentOverrideAdapter);
        this._overrides = $6f19754a7eb52889$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $6f19754a7eb52889$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $6f19754a7eb52889$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $6f19754a7eb52889$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($6f19754a7eb52889$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.removeItem($6f19754a7eb52889$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $6f19754a7eb52889$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $6f19754a7eb52889$var$_objectSpread($6f19754a7eb52889$var$_objectSpread({}, $6f19754a7eb52889$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($6f19754a7eb52889$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($6f19754a7eb52889$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($6f19754a7eb52889$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($6f19754a7eb52889$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $6f19754a7eb52889$var$_objectSpread($6f19754a7eb52889$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $6f19754a7eb52889$var$_objectSpread($6f19754a7eb52889$var$_objectSpread({}, current.details), {}, {
                        reason: $6f19754a7eb52889$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($6f19754a7eb52889$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($6f19754a7eb52889$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($6f19754a7eb52889$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($6f19754a7eb52889$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($6f19754a7eb52889$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($6f19754a7eb52889$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $6f19754a7eb52889$var$makeEmptyStore();
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($6f19754a7eb52889$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $6f19754a7eb52889$var$_objectSpread($6f19754a7eb52889$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $6f19754a7eb52889$var$_objectSpread($6f19754a7eb52889$var$_objectSpread({}, current.details), {}, {
                        reason: $6f19754a7eb52889$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($6f19754a7eb52889$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $6f19754a7eb52889$var$_objectSpread($6f19754a7eb52889$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $6f19754a7eb52889$var$_objectSpread($6f19754a7eb52889$var$_objectSpread({}, current.details), {}, {
                        reason: $6f19754a7eb52889$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});

parcelRegister("ayvGz", function(module, exports) {
$parcel$export(module.exports, "shallowEquals", () => $7af5a8738dbc79ce$export$fa1c2bbf4100b8bc);

var $iYJcE = parcelRequire("iYJcE");
var $7af5a8738dbc79ce$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};

});

parcelRegister("hN688", function(module, exports) {
$parcel$export(module.exports, "toStatsigUser", () => $cf3bc49d3595aa3c$export$3dad1db244472f32);

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");
var $cf3bc49d3595aa3c$var$_excluded = [
    "stableId"
];
function $cf3bc49d3595aa3c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cf3bc49d3595aa3c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cf3bc49d3595aa3c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cf3bc49d3595aa3c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cf3bc49d3595aa3c$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    var stableId = identifiers.stableId, otherIdentifiers = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(identifiers, $cf3bc49d3595aa3c$var$_excluded);
    var user = {
        customIDs: $cf3bc49d3595aa3c$var$_objectSpread($cf3bc49d3595aa3c$var$_objectSpread({}, otherIdentifiers), stableId !== undefined ? {
            stableID: stableId
        } : {}),
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};

});




parcelRegister("aq2Gy", function(module, exports) {
$parcel$export(module.exports, "containsAnchorNameMutationInStyle", () => $795e6a584a479ff2$export$f83f33200c1a234e);
$parcel$export(module.exports, "default", () => $795e6a584a479ff2$export$2e2bcd8739ae039);

var $50U6m = parcelRequire("50U6m");
function $795e6a584a479ff2$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $795e6a584a479ff2$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $795e6a584a479ff2$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $795e6a584a479ff2$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $795e6a584a479ff2$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $795e6a584a479ff2$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
/**
 * Matches only the editor drag and drop anchors. This is the pre-gate behaviour.
 */ var $795e6a584a479ff2$var$isDnDAnchorNameDeclaration = function isDnDAnchorNameDeclaration(declaration) {
    return declaration.startsWith('anchor-name: --node-anchor');
};
/**
 * Matches any `anchor-name` declaration.
 *
 * `anchor-name` (CSS Anchor Positioning) only names an element so that _other_
 * elements can position themselves against it. It never changes how the named
 * element itself renders, so adding or removing it is never a visual change.
 *
 * `@atlaskit/top-layer` writes `anchor-name` onto a popover's trigger as soon as
 * the popover host element exists, which for `Popover`-based consumers is first
 * open (for example, hovering an `@atlaskit/tooltip` trigger). Without this
 * exclusion that write is recorded as a repaint of the trigger at hover time,
 * which shifts TTVC in sessions where a user hovers a trigger before the page
 * has settled. See COPPER-1736.
 */ var $795e6a584a479ff2$var$isAnyAnchorNameDeclaration = function isAnyAnchorNameDeclaration(declaration) {
    return declaration.startsWith('anchor-name:');
};
var $795e6a584a479ff2$var$parseStyleSet = function parseStyleSet(style) {
    if (!style) return null;
    var set = new Set();
    var _iterator = $795e6a584a479ff2$var$_createForOfIteratorHelper(style.split(';')), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var part = _step.value;
            var t = part.trim();
            if (t) set.add(t);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return set;
};
/**
 * Checks if a mutation record represents a `style` change that consists only
 * of `anchor-name` declarations being added or removed.
 *
 * Without `platform_ufo_exclude_anchor_name_from_ttvc` this is limited to the
 * editor's drag and drop anchors (`--node-anchor…`), which is where the check
 * originated. With the gate on, every `anchor-name` is treated as non-visual,
 * because the property never affects the rendering of the element it is set on.
 *
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is an anchor-name-only style mutation
 */ function $795e6a584a479ff2$export$7a0b59cebcbf44ec(_ref) {
    var target = _ref.target, attributeName = _ref.attributeName, oldValue = _ref.oldValue, newValue = _ref.newValue;
    if (!(target instanceof Element)) return false;
    return $795e6a584a479ff2$export$f83f33200c1a234e({
        attributeName: attributeName,
        oldValue: oldValue,
        newValue: newValue
    });
}
function $795e6a584a479ff2$export$f83f33200c1a234e(_ref2) {
    var attributeName = _ref2.attributeName, oldValue = _ref2.oldValue, newValue = _ref2.newValue;
    if (attributeName !== 'style') return false;
    // Resolved once per mutation rather than once per declaration: this runs
    // inside the MutationObserver callback.
    var isIgnoredDeclaration = (0, $50U6m.fg)('platform_ufo_exclude_anchor_name_from_ttvc') ? $795e6a584a479ff2$var$isAnyAnchorNameDeclaration : $795e6a584a479ff2$var$isDnDAnchorNameDeclaration;
    var oldStyles = $795e6a584a479ff2$var$parseStyleSet(oldValue);
    var newStyles = $795e6a584a479ff2$var$parseStyleSet(newValue);
    var isAnchorNameMutation = false;
    var _iterator2 = $795e6a584a479ff2$var$_createForOfIteratorHelper(oldStyles !== null && oldStyles !== void 0 ? oldStyles : []), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var s = _step2.value;
            if (!(newStyles !== null && newStyles !== void 0 && newStyles.has(s))) {
                if (!isIgnoredDeclaration(s)) return false;
                isAnchorNameMutation = true;
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    var _iterator3 = $795e6a584a479ff2$var$_createForOfIteratorHelper(newStyles !== null && newStyles !== void 0 ? newStyles : []), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var _s = _step3.value;
            if (!(oldStyles !== null && oldStyles !== void 0 && oldStyles.has(_s))) {
                if (!isIgnoredDeclaration(_s)) return false;
                isAnchorNameMutation = true;
            }
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
    return isAnchorNameMutation;
}
var $795e6a584a479ff2$export$2e2bcd8739ae039 = $795e6a584a479ff2$export$7a0b59cebcbf44ec;

});

parcelRegister("6VzxC", function(module, exports) {
$parcel$export(module.exports, "default", () => $50b3a2af63cba354$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $fC8ib = parcelRequire("fC8ib");

var $fL8KA = parcelRequire("fL8KA");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $2SfpH = parcelRequire("2SfpH");

var $vFumy = parcelRequire("vFumy");

var $3VF6y = parcelRequire("3VF6y");

var $5X23Y = parcelRequire("5X23Y");

var $fWZXc = parcelRequire("fWZXc");
function $50b3a2af63cba354$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $50b3a2af63cba354$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $50b3a2af63cba354$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $50b3a2af63cba354$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $50b3a2af63cba354$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $50b3a2af63cba354$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $50b3a2af63cba354$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $50b3a2af63cba354$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $50b3a2af63cba354$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $50b3a2af63cba354$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
// Create comprehensive debug details including ignored entries
// Helper function for reporting ratios
function $50b3a2af63cba354$var$roundDecimal(value) {
    var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    var factor = Math.pow(10, decimals);
    return Math.round(value * factor) / factor;
}
var $50b3a2af63cba354$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AbstractVCCalculatorBase(revisionNo) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AbstractVCCalculatorBase);
        this.revisionNo = revisionNo;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AbstractVCCalculatorBase, [
        {
            key: "filterViewportEntries",
            value: function filterViewportEntries(entries) {
                return entries.filter(function(entry) {
                    return 'rect' in entry.data;
                });
            }
        },
        {
            key: "calculateRatios",
            value: function calculateRatios(filteredEntries) {
                var ratios = {};
                var viewportWidth = (0, $5X23Y.default)();
                var viewportHeight = (0, $3VF6y.default)();
                var totalViewportArea = viewportWidth * viewportHeight;
                if (totalViewportArea === 0) return ratios;
                var elementRects = new Map();
                var _iterator = $50b3a2af63cba354$var$_createForOfIteratorHelper(filteredEntries), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _entry = _step.value;
                        if ('rect' in _entry.data) {
                            var viewportEntry = _entry.data;
                            elementRects.set(viewportEntry.elementName, viewportEntry.rect);
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                var _iterator2 = $50b3a2af63cba354$var$_createForOfIteratorHelper(elementRects), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var _step2$value = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_step2.value, 2), elementName = _step2$value[0], rect = _step2$value[1];
                        var elementArea = rect.width * rect.height;
                        ratios[elementName] = $50b3a2af63cba354$var$roundDecimal(elementArea / totalViewportArea);
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
                return ratios;
            }
        },
        {
            key: "getLabelStacks",
            value: function getLabelStacks(filteredEntries, isPostInteraction) {
                var labelStacks = {};
                var _iterator3 = $50b3a2af63cba354$var$_createForOfIteratorHelper(filteredEntries), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var _entry2 = _step3.value;
                        if ((0, $fWZXc.default)(_entry2.data) && _entry2.data.labelStacks) {
                            if (isPostInteraction) labelStacks[_entry2.data.elementName] = {
                                segment: _entry2.data.labelStacks.segment,
                                labelStack: _entry2.data.labelStacks.labelStack
                            };
                            else labelStacks[_entry2.data.elementName] = _entry2.data.labelStacks.labelStack;
                        }
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                return labelStacks;
            }
        },
        {
            key: "calculateWithDebugInfo",
            value: function() {
                var _calculateWithDebugInfo = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, allEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders) {
                    var _window, _window2, _window3, _window4, _window6;
                    var percentiles, viewportEntries, _yield$calculateTTVCP, vcLogs, speedIndex, vcDetails, percentileIndex, entryDataBuffer, ssrRatio, layoutShiftInsights, previousViewportPercentage, _iterator4, _step4, _entry3, time, viewportPercentage, entries, elementNames, layoutShiftEntries, previousResult, i, percentile, enhancedVcLogs, shouldCalculate3p, shouldCalculateDebugDetails, sortedVcLogs, maxViewportPercentageAtTime, maxSoFar, _iterator5, _step5, log, getBiggestPreviousViewportPercentage, ignoredEntriesByTime, _iterator6, _step6, _entry4, _ignoredEntriesByTime, _viewportData$rect, _viewportData$previou, viewportData, timestamp, additionalVcLogs, _iterator7, _step7, _step7$value, _timestamp, ignoredEntries, _viewportPercentage, v3RevisionDebugDetails, _window5, _window5$__ufo_devtoo, _window7, _window7$__on_ufo_vc_, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                percentiles = [
                                    25,
                                    50,
                                    75,
                                    80,
                                    85,
                                    90,
                                    95,
                                    98,
                                    99,
                                    100
                                ];
                                viewportEntries = this.filterViewportEntries(filteredEntries);
                                _context.next = 1;
                                return (0, $2SfpH.calculateTTVCPercentilesWithDebugInfo)({
                                    viewport: {
                                        width: (0, $5X23Y.default)(),
                                        height: (0, $3VF6y.default)()
                                    },
                                    startTime: startTime,
                                    stopTime: stopTime,
                                    orderedEntries: viewportEntries
                                });
                            case 1:
                                _yield$calculateTTVCP = _context.sent;
                                vcLogs = _yield$calculateTTVCP.entries;
                                speedIndex = _yield$calculateTTVCP.speedIndex;
                                vcDetails = {};
                                percentileIndex = 0;
                                entryDataBuffer = new Set();
                                ssrRatio = -1;
                                layoutShiftInsights = null;
                                previousViewportPercentage = 0;
                                if (!vcLogs) {
                                    _context.next = 9;
                                    break;
                                }
                                _iterator4 = $50b3a2af63cba354$var$_createForOfIteratorHelper(vcLogs);
                                _context.prev = 2;
                                _iterator4.s();
                            case 3:
                                if ((_step4 = _iterator4.n()).done) {
                                    _context.next = 6;
                                    break;
                                }
                                _entry3 = _step4.value;
                                time = _entry3.time, viewportPercentage = _entry3.viewportPercentage, entries = _entry3.entries;
                                if (includeSSRRatio && ssrRatio === -1 && entries.some(function(e) {
                                    return e.elementName === 'SSR';
                                })) ssrRatio = viewportPercentage;
                                // Only process entries if we haven't reached all percentiles
                                if (!(percentileIndex >= percentiles.length)) {
                                    _context.next = 4;
                                    break;
                                }
                                return _context.abrupt("continue", 6);
                            case 4:
                                // Check if this entry matches any checkpoint percentiles
                                if (viewportPercentage >= percentiles[percentileIndex]) {
                                    elementNames = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set(entries.map(function(e) {
                                        return e.elementName;
                                    }))); // Process all matching percentiles in one go
                                    while(percentileIndex < percentiles.length && viewportPercentage >= percentiles[percentileIndex]){
                                        vcDetails["".concat(percentiles[percentileIndex])] = {
                                            t: Math.round(time),
                                            e: elementNames
                                        };
                                        if (reportLayoutShiftOffenders && percentiles[percentileIndex] === 90 && entries.some(function(e) {
                                            return e.type === 'layout-shift';
                                        })) {
                                            layoutShiftEntries = entries.filter(function(e) {
                                                return e.type === 'layout-shift';
                                            });
                                            layoutShiftInsights = {
                                                layoutShiftOffendersResult: (0, $vFumy.detectLayoutShiftCause)({
                                                    viewportEntries: viewportEntries,
                                                    layoutShiftEntries: layoutShiftEntries,
                                                    time: time,
                                                    startTime: startTime
                                                }),
                                                layoutShiftEntriesCount: layoutShiftEntries.length,
                                                layoutShiftImpact: viewportPercentage - previousViewportPercentage
                                            };
                                        }
                                        percentileIndex++;
                                    }
                                    // Clear buffer after processing all matching percentiles
                                    entryDataBuffer.clear();
                                } else // Only add to buffer if we haven't reached all percentiles
                                entries.forEach(function(e) {
                                    return entryDataBuffer.add(e);
                                });
                                previousViewportPercentage = viewportPercentage;
                            case 5:
                                _context.next = 3;
                                break;
                            case 6:
                                _context.next = 8;
                                break;
                            case 7:
                                _context.prev = 7;
                                _t = _context["catch"](2);
                                _iterator4.e(_t);
                            case 8:
                                _context.prev = 8;
                                _iterator4.f();
                                return _context.finish(8);
                            case 9:
                                // Fill in any missing percentiles with the last known values
                                previousResult = {
                                    t: 0,
                                    e: []
                                };
                                for(i = 0; i < percentiles.length; i++){
                                    percentile = percentiles[i];
                                    if (!(percentile in vcDetails)) vcDetails["".concat(percentile)] = previousResult;
                                    else previousResult = vcDetails["".concat(percentile)];
                                }
                                enhancedVcLogs = vcLogs ? vcLogs.map(function(log) {
                                    return $50b3a2af63cba354$var$_objectSpread($50b3a2af63cba354$var$_objectSpread({}, log), {}, {
                                        entries: log.entries.map(function(entry) {
                                            var _entry$rect, _entry$previousRect;
                                            return $50b3a2af63cba354$var$_objectSpread($50b3a2af63cba354$var$_objectSpread({}, entry), {}, {
                                                rect: (_entry$rect = entry.rect) === null || _entry$rect === void 0 ? void 0 : _entry$rect.toJSON(),
                                                previousRect: (_entry$previousRect = entry.previousRect) === null || _entry$previousRect === void 0 ? void 0 : _entry$previousRect.toJSON()
                                            });
                                        }),
                                        viewportPercentage: log.viewportPercentage
                                    });
                                }) : []; // If 3p metric enabled - calculate the debug details
                                shouldCalculate3p = include3p; // Only calculate enhanced debug details if devtool callbacks exist
                                shouldCalculateDebugDetails = !isPostInteraction && (typeof ((_window = window) === null || _window === void 0 ? void 0 : _window.__ufo_devtool_onVCRevisionReady__) === 'function' || typeof ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.__on_ufo_vc_debug_data_ready) === 'function' || typeof ((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.__ufo_devtool_vc_3p_debug_data) === 'function');
                                if (shouldCalculateDebugDetails && allEntries && vcLogs) {
                                    // Pre-sort vcLogs by time for efficient lookups
                                    sortedVcLogs = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(vcLogs).sort(function(a, b) {
                                        return a.time - b.time;
                                    }); // Pre-calculate max viewport percentage up to each time for efficient lookups
                                    maxViewportPercentageAtTime = new Map();
                                    maxSoFar = 0;
                                    _iterator5 = $50b3a2af63cba354$var$_createForOfIteratorHelper(sortedVcLogs);
                                    try {
                                        for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                            log = _step5.value;
                                            if (log.viewportPercentage !== null) {
                                                maxSoFar = Math.max(maxSoFar, log.viewportPercentage);
                                                maxViewportPercentageAtTime.set(log.time, maxSoFar);
                                            }
                                        }
                                    // Helper function to find the biggest previous viewport percentage
                                    } catch (err) {
                                        _iterator5.e(err);
                                    } finally{
                                        _iterator5.f();
                                    }
                                    getBiggestPreviousViewportPercentage = function getBiggestPreviousViewportPercentage(targetTime) {
                                        // Binary search for the largest time <= targetTime
                                        var left = 0;
                                        var right = sortedVcLogs.length - 1;
                                        var result = -1;
                                        while(left <= right){
                                            var mid = Math.floor((left + right) / 2);
                                            if (sortedVcLogs[mid].time <= targetTime) {
                                                result = mid;
                                                left = mid + 1;
                                            } else right = mid - 1;
                                        }
                                        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVcLogs[result].time) || null : null;
                                    }; // Group ignored entries by timestamp
                                    ignoredEntriesByTime = new Map();
                                    _iterator6 = $50b3a2af63cba354$var$_createForOfIteratorHelper(allEntries);
                                    try {
                                        for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                                            _entry4 = _step6.value;
                                            if ('rect' in _entry4.data && !this.isEntryIncluded(_entry4, include3p, excludeSmartAnswersInSearch)) {
                                                viewportData = _entry4.data;
                                                timestamp = Math.round(_entry4.time);
                                                if (!ignoredEntriesByTime.has(timestamp)) ignoredEntriesByTime.set(timestamp, []);
                                                (_ignoredEntriesByTime = ignoredEntriesByTime.get(timestamp)) === null || _ignoredEntriesByTime === void 0 || _ignoredEntriesByTime.push($50b3a2af63cba354$var$_objectSpread($50b3a2af63cba354$var$_objectSpread({}, viewportData), {}, {
                                                    rect: (_viewportData$rect = viewportData.rect) === null || _viewportData$rect === void 0 ? void 0 : _viewportData$rect.toJSON(),
                                                    previousRect: (_viewportData$previou = viewportData.previousRect) === null || _viewportData$previou === void 0 ? void 0 : _viewportData$previou.toJSON(),
                                                    ignoreReason: viewportData.visible ? viewportData.type : 'not-visible'
                                                }));
                                            }
                                        }
                                    // Add ignored entries to vcLogs
                                    } catch (err) {
                                        _iterator6.e(err);
                                    } finally{
                                        _iterator6.f();
                                    }
                                    additionalVcLogs = [];
                                    _iterator7 = $50b3a2af63cba354$var$_createForOfIteratorHelper(ignoredEntriesByTime);
                                    try {
                                        for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                                            _step7$value = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_step7.value, 2), _timestamp = _step7$value[0], ignoredEntries = _step7$value[1];
                                            if (ignoredEntries.length > 0) {
                                                _viewportPercentage = getBiggestPreviousViewportPercentage(_timestamp);
                                                additionalVcLogs.push({
                                                    time: _timestamp,
                                                    viewportPercentage: _viewportPercentage,
                                                    entries: ignoredEntries
                                                });
                                            }
                                        }
                                    // Combine and sort all vcLogs
                                    } catch (err) {
                                        _iterator7.e(err);
                                    } finally{
                                        _iterator7.f();
                                    }
                                    enhancedVcLogs = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(enhancedVcLogs), additionalVcLogs).sort(function(a, b) {
                                        return a.time - b.time;
                                    });
                                }
                                // Only create debug details if callbacks exist
                                v3RevisionDebugDetails = null;
                                if (shouldCalculateDebugDetails) v3RevisionDebugDetails = {
                                    revision: this.revisionNo,
                                    isClean: isVCClean && !interactionAbortReason && isPageVisible,
                                    abortReason: !isPageVisible ? 'browser_backgrounded' : dirtyReason !== null && dirtyReason !== void 0 ? dirtyReason : interactionAbortReason,
                                    vcLogs: enhancedVcLogs,
                                    interactionId: interactionId,
                                    interactionType: interactionType
                                };
                                // Handle devtool callback
                                if (v3RevisionDebugDetails && typeof ((_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.__ufo_devtool_onVCRevisionReady__) === 'function' && !include3p) try {
                                    (_window5 = window) === null || _window5 === void 0 || (_window5$__ufo_devtoo = _window5.__ufo_devtool_onVCRevisionReady__) === null || _window5$__ufo_devtoo === void 0 || _window5$__ufo_devtoo.call(_window5, v3RevisionDebugDetails);
                                } catch (e) {
                                    // if any error communicating with devtool, we don't want to break the app
                                    // eslint-disable-next-line no-console
                                    console.error('Error in onVCRevisionReady', e);
                                }
                                if (v3RevisionDebugDetails && typeof ((_window6 = window) === null || _window6 === void 0 ? void 0 : _window6.__on_ufo_vc_debug_data_ready) === 'function' && !include3p) try {
                                    (_window7 = window) === null || _window7 === void 0 || (_window7$__on_ufo_vc_ = _window7.__on_ufo_vc_debug_data_ready) === null || _window7$__on_ufo_vc_ === void 0 || _window7$__on_ufo_vc_.call(_window7, v3RevisionDebugDetails);
                                } catch (e) {
                                    // eslint-disable-next-line no-console
                                    console.error('Error in onVCRevisionReady', e);
                                }
                                if (v3RevisionDebugDetails && shouldCalculate3p) try {
                                    // Log vc details with 3p for debugging
                                    window.__ufo_devtool_vc_3p_debug_data = v3RevisionDebugDetails;
                                } catch (e) {
                                    // eslint-disable-next-line no-console
                                    console.error('Error in 3pDebugData', e);
                                }
                                return _context.abrupt("return", {
                                    vcDetails: vcDetails,
                                    ssrRatio: ssrRatio,
                                    speedIndex: speedIndex,
                                    VC90layoutShiftInsights: layoutShiftInsights
                                });
                            case 10:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            7,
                            8,
                            9
                        ]
                    ]);
                }));
                function calculateWithDebugInfo(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8, _x9, _x0, _x1, _x10, _x11, _x12, _x13) {
                    return _calculateWithDebugInfo.apply(this, arguments);
                }
                return calculateWithDebugInfo;
            }()
        },
        {
            key: "calculate",
            value: function() {
                var _calculate = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_ref) {
                    var _this = this, _vcDetails$90$t, _vcDetails$;
                    var startTime, stopTime, orderedEntries, interactionId, isPostInteraction, include3p, excludeSmartAnswersInSearch, includeSSRRatio, interactionType, isPageVisible, interactionAbortReason, reportLayoutShiftOffenders, filteredEntries, isVCClean, dirtyReason, getVCCleanStatusResult, _yield$this$calculate, vcDetails, ssrRatio, speedIndex, VC90layoutShiftInsights, layoutShiftInsightsPayload, _layoutShiftOffenders, _layoutShiftOffenders2, _layoutShiftOffenders3, layoutShiftOffendersResult, layoutShiftEntriesCount, layoutShiftImpact, result;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                startTime = _ref.startTime, stopTime = _ref.stopTime, orderedEntries = _ref.orderedEntries, interactionId = _ref.interactionId, isPostInteraction = _ref.isPostInteraction, include3p = _ref.include3p, excludeSmartAnswersInSearch = _ref.excludeSmartAnswersInSearch, includeSSRRatio = _ref.includeSSRRatio, interactionType = _ref.interactionType, isPageVisible = _ref.isPageVisible, interactionAbortReason = _ref.interactionAbortReason, reportLayoutShiftOffenders = _ref.reportLayoutShiftOffenders;
                                filteredEntries = orderedEntries.filter(function(entry) {
                                    return _this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
                                });
                                getVCCleanStatusResult = this.getVCCleanStatus(filteredEntries);
                                isVCClean = getVCCleanStatusResult.isVCClean;
                                dirtyReason = getVCCleanStatusResult.dirtyReason;
                                if (isVCClean) {
                                    _context2.next = 1;
                                    break;
                                }
                                return _context2.abrupt("return", {
                                    revision: this.revisionNo,
                                    'metric:vc90': null,
                                    clean: false,
                                    abortReason: dirtyReason,
                                    abortTimestamp: getVCCleanStatusResult.abortTimestamp
                                });
                            case 1:
                                _context2.next = 2;
                                return this.calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, orderedEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders);
                            case 2:
                                _yield$this$calculate = _context2.sent;
                                vcDetails = _yield$this$calculate.vcDetails;
                                ssrRatio = _yield$this$calculate.ssrRatio;
                                speedIndex = _yield$this$calculate.speedIndex;
                                VC90layoutShiftInsights = _yield$this$calculate.VC90layoutShiftInsights;
                                if (VC90layoutShiftInsights !== null && reportLayoutShiftOffenders) {
                                    layoutShiftOffendersResult = VC90layoutShiftInsights.layoutShiftOffendersResult, layoutShiftEntriesCount = VC90layoutShiftInsights.layoutShiftEntriesCount, layoutShiftImpact = VC90layoutShiftInsights.layoutShiftImpact;
                                    layoutShiftInsightsPayload = {
                                        impact: layoutShiftImpact,
                                        sources: layoutShiftEntriesCount !== null && layoutShiftEntriesCount !== void 0 ? layoutShiftEntriesCount : 0,
                                        same: {
                                            dir: (_layoutShiftOffenders = layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftVariables.allMovedSameWay) !== null && _layoutShiftOffenders !== void 0 ? _layoutShiftOffenders : false,
                                            dist: (_layoutShiftOffenders2 = layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftVariables.allMovedSameAmount) !== null && _layoutShiftOffenders2 !== void 0 ? _layoutShiftOffenders2 : false
                                        },
                                        total_mut: (_layoutShiftOffenders3 = layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftOffenders.length) !== null && _layoutShiftOffenders3 !== void 0 ? _layoutShiftOffenders3 : 0,
                                        mut: layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftOffenders.sort(function(a, b) {
                                            return Math.abs(a.distanceToLS) - Math.abs(b.distanceToLS);
                                        }).slice(0, 5).map(function(offender) {
                                            return {
                                                e: offender.offender,
                                                size: -1,
                                                // @todo: calculate size
                                                attr: {
                                                    t_before: offender.happenedBefore,
                                                    t_distance: offender.distanceToLS,
                                                    p_above: offender.isAbove,
                                                    p_left: offender.isLeft,
                                                    p_right: offender.isRight,
                                                    p_h_overlap: offender.hasHorizontalOverlap,
                                                    p_v_overlap: offender.hasVerticalOverlap,
                                                    p_same_offset: offender.matchesLayoutShiftDelta ? 'all' : 'none'
                                                }
                                            };
                                        })
                                    };
                                }
                                result = {
                                    revision: this.revisionNo,
                                    clean: true,
                                    'metric:vc90': (_vcDetails$90$t = vcDetails === null || vcDetails === void 0 || (_vcDetails$ = vcDetails['90']) === null || _vcDetails$ === void 0 ? void 0 : _vcDetails$.t) !== null && _vcDetails$90$t !== void 0 ? _vcDetails$90$t : null,
                                    vcDetails: vcDetails !== null && vcDetails !== void 0 ? vcDetails : undefined,
                                    'vc90:ls': layoutShiftInsightsPayload !== null && layoutShiftInsightsPayload !== void 0 ? layoutShiftInsightsPayload : undefined
                                };
                                result.ratios = this.calculateRatios(filteredEntries);
                                if (ssrRatio !== -1) result.ssrRatio = ssrRatio;
                                // speedIndex is only included in the result when it has a meaningful value (> 0)
                                if (speedIndex > 0) result.speedIndex = speedIndex;
                                result.labelStacks = this.getLabelStacks(filteredEntries, isPostInteraction);
                                return _context2.abrupt("return", result);
                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function calculate(_x14) {
                    return _calculate.apply(this, arguments);
                }
                return calculate;
            }()
        }
    ]);
}();

});
parcelRegister("2SfpH", function(module, exports) {
$parcel$export(module.exports, "calculateTTVCPercentilesWithDebugInfo", () => $217c94b84d506831$export$96ea73435089b05a);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $50U6m = parcelRequire("50U6m");

var $8qOKw = parcelRequire("8qOKw");

var $ddCYX = parcelRequire("ddCYX");

var $aJawl = parcelRequire("aJawl");
function $217c94b84d506831$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $217c94b84d506831$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $217c94b84d506831$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $217c94b84d506831$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $217c94b84d506831$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $217c94b84d506831$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $217c94b84d506831$var$calculateTTVCPercentiles(_x) {
    return $217c94b84d506831$var$_calculateTTVCPercentiles.apply(this, arguments);
}
function $217c94b84d506831$var$_calculateTTVCPercentiles() {
    $217c94b84d506831$var$_calculateTTVCPercentiles = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_ref) {
        var viewport, orderedEntries, percentiles, startTime, canvas, elementMap, _iterator, _step, entry, rect, elementName, timePixelCounts, canvasDimenstions, totalPixels, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    viewport = _ref.viewport, orderedEntries = _ref.orderedEntries, percentiles = _ref.percentiles, startTime = _ref.startTime;
                    canvas = new (0, $aJawl.ViewportCanvas)(viewport, (0, $50U6m.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
                    elementMap = new Map();
                    _iterator = $217c94b84d506831$var$_createForOfIteratorHelper(orderedEntries);
                    _context.prev = 1;
                    _iterator.s();
                case 2:
                    if ((_step = _iterator.n()).done) {
                        _context.next = 5;
                        break;
                    }
                    entry = _step.value;
                    if ('rect' in entry.data) {
                        _context.next = 3;
                        break;
                    }
                    return _context.abrupt("continue", 4);
                case 3:
                    rect = entry.data.rect;
                    elementName = entry.data.elementName;
                    canvas.drawRect(rect, entry.time);
                    if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
                    elementMap.get(entry.time).add(elementName);
                case 4:
                    _context.next = 2;
                    break;
                case 5:
                    _context.next = 7;
                    break;
                case 6:
                    _context.prev = 6;
                    _t = _context["catch"](1);
                    _iterator.e(_t);
                case 7:
                    _context.prev = 7;
                    _iterator.f();
                    return _context.finish(7);
                case 8:
                    _context.next = 9;
                    return canvas.getPixelCounts();
                case 9:
                    timePixelCounts = _context.sent;
                    canvasDimenstions = canvas.getScaledDimensions();
                    totalPixels = canvasDimenstions.width * canvasDimenstions.height;
                    return _context.abrupt("return", (0, $8qOKw.calculatePercentiles)(timePixelCounts, elementMap, percentiles, totalPixels, startTime));
                case 10:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                1,
                6,
                7,
                8
            ]
        ]);
    }));
    return $217c94b84d506831$var$_calculateTTVCPercentiles.apply(this, arguments);
}
function $217c94b84d506831$export$96ea73435089b05a(_x2) {
    return $217c94b84d506831$var$_calculateTTVCPercentilesWithDebugInfo.apply(this, arguments);
}
function $217c94b84d506831$var$_calculateTTVCPercentilesWithDebugInfo() {
    $217c94b84d506831$var$_calculateTTVCPercentilesWithDebugInfo = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_ref2) {
        var viewport, orderedEntries, startTime, canvas, elementMap, _iterator2, _step2, entry, rect, timePixelCounts, canvasDimensions, totalPixels, _t2;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    viewport = _ref2.viewport, orderedEntries = _ref2.orderedEntries, startTime = _ref2.startTime;
                    canvas = new (0, $aJawl.ViewportCanvas)(viewport, (0, $50U6m.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
                    elementMap = new Map();
                    _iterator2 = $217c94b84d506831$var$_createForOfIteratorHelper(orderedEntries);
                    _context2.prev = 1;
                    _iterator2.s();
                case 2:
                    if ((_step2 = _iterator2.n()).done) {
                        _context2.next = 5;
                        break;
                    }
                    entry = _step2.value;
                    if ('rect' in entry.data) {
                        _context2.next = 3;
                        break;
                    }
                    return _context2.abrupt("continue", 4);
                case 3:
                    rect = entry.data.rect;
                    canvas.drawRect(rect, entry.time);
                    if (!elementMap.has(entry.time)) elementMap.set(entry.time, []);
                    elementMap.get(entry.time).push(entry.data);
                case 4:
                    _context2.next = 2;
                    break;
                case 5:
                    _context2.next = 7;
                    break;
                case 6:
                    _context2.prev = 6;
                    _t2 = _context2["catch"](1);
                    _iterator2.e(_t2);
                case 7:
                    _context2.prev = 7;
                    _iterator2.f();
                    return _context2.finish(7);
                case 8:
                    _context2.next = 9;
                    return canvas.getPixelCounts();
                case 9:
                    timePixelCounts = _context2.sent;
                    canvasDimensions = canvas.getScaledDimensions();
                    totalPixels = canvasDimensions.width * canvasDimensions.height;
                    return _context2.abrupt("return", (0, $ddCYX.calculatePercentilesWithDebugInfo)(timePixelCounts, elementMap, totalPixels, startTime));
                case 10:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                1,
                6,
                7,
                8
            ]
        ]);
    }));
    return $217c94b84d506831$var$_calculateTTVCPercentilesWithDebugInfo.apply(this, arguments);
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$217c94b84d506831$export$2e2bcd8739ae039 = $217c94b84d506831$var$calculateTTVCPercentiles;

});
parcelRegister("8qOKw", function(module, exports) {
$parcel$export(module.exports, "calculatePercentiles", () => $62381e3681cd3c85$export$89c8da9b65eff678);

var $iYJcE = parcelRequire("iYJcE");
function $62381e3681cd3c85$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $62381e3681cd3c85$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $62381e3681cd3c85$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $62381e3681cd3c85$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $62381e3681cd3c85$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $62381e3681cd3c85$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $62381e3681cd3c85$export$89c8da9b65eff678(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    var results = {};
    var cumulativePixels = 0;
    var percentiles = unorderedPercentiles.sort(function(a, b) {
        return a - b;
    });
    // Sort entries by timestamp for consistent processing
    var sortedEntries = Array.from(timePixelCounts.entries()).sort(function(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), timeA = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), timeB = _ref4[0];
        return Number(timeA) - Number(timeB);
    });
    var percentileIndex = 0;
    var domElementsBuffer = new Set();
    var _iterator = $62381e3681cd3c85$var$_createForOfIteratorHelper(sortedEntries), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_step.value, 2), time = _step$value[0], pixelCount = _step$value[1];
            cumulativePixels += pixelCount;
            var percentCovered = cumulativePixels / totalPixels * 100;
            var elementNames = elementMap.get(time) || new Set();
            elementNames.forEach(function(elName) {
                return domElementsBuffer.add(elName);
            });
            var matchesAnyCheckpoints = false;
            while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
                results["".concat(percentiles[percentileIndex])] = {
                    t: Math.round(Number(time - startTime)),
                    e: Array.from(domElementsBuffer)
                };
                percentileIndex++;
                matchesAnyCheckpoints = true;
            }
            if (matchesAnyCheckpoints) domElementsBuffer.clear();
            if (percentileIndex >= percentiles.length) break;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var previousResult = {
        t: 0,
        e: []
    };
    for(var i = 0; i < percentiles.length; i++){
        var percentile = percentiles[i];
        if (!(percentile in results)) results["".concat(percentile)] = previousResult;
        previousResult = results["".concat(percentile)];
    }
    return results;
}

});

parcelRegister("ddCYX", function(module, exports) {
$parcel$export(module.exports, "calculatePercentilesWithDebugInfo", () => $99faba551d85ae67$export$a532ce01ea38d882);

var $iYJcE = parcelRequire("iYJcE");
function $99faba551d85ae67$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime) {
    var entries = new Array(elementMap.size);
    var cumulativePixels = 0;
    var speedIndex = 0;
    var previousPercentCovered = 0;
    var sortedEntries = Array.from(timePixelCounts.entries()).sort(function(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), timeA = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), timeB = _ref4[0];
        return Number(timeA) - Number(timeB);
    });
    for(var i = 0; i < sortedEntries.length; i++){
        var _sortedEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(sortedEntries[i], 2), time = _sortedEntries$i[0], pixelCount = _sortedEntries$i[1];
        cumulativePixels += pixelCount;
        var percentCovered = cumulativePixels / totalPixels * 100;
        var entryDatas = elementMap.get(time) || [];
        var relativeTime = Math.round(Number(time - startTime));
        entries[i] = {
            time: relativeTime,
            viewportPercentage: percentCovered,
            entries: Array.from(entryDatas)
        };
        // Speed index calculation: sum of (time × incremental viewport percentage)
        var ratioDelta = (percentCovered - previousPercentCovered) / 100;
        speedIndex += relativeTime * ratioDelta;
        previousPercentCovered = percentCovered;
    }
    return {
        entries: entries,
        speedIndex: Math.round(speedIndex)
    };
}

});

parcelRegister("aJawl", function(module, exports) {
$parcel$export(module.exports, "ViewportCanvas", () => $7cf64490e583b91b$export$3e59ac9de7402fb1);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $57Ru0 = parcelRequire("57Ru0");

var $13bxQ = parcelRequire("13bxQ");
var $7cf64490e583b91b$export$3e59ac9de7402fb1 = /*#__PURE__*/ function() {
    /** The underlying Canvas instance (either OffscreenCanvas or HTMLCanvasElement) */ /** The 2D rendering context of the canvas */ /** Scale factor applied to the canvas (affects final pixel counts) */ /** Maps unique colors to their corresponding timestamps */ /** Counter used to generate unique colors */ /**
   * Creates a new ViewportCanvas instance.
   * @param viewport - The dimensions of the viewport
   * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
   * @throws {Error} If canvas context cannot be obtained
   */ function ViewportCanvas(viewport) {
        var scaleFactor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ViewportCanvas);
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        var safeViewportWidth = Math.max(viewport.width, 1);
        var safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize canvas with scaled dimensions
        this.canvas = this.createCanvas(this.scaledWidth, this.scaledHeight);
        var ctx = this.canvas.getContext('2d', {
            alpha: false,
            // Disable alpha channel for better performance
            willReadFrequently: true,
            // Optimize for frequent pixel reading
            colorSpace: 'srgb' // Use standard RGB color space
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        this.ctx.imageSmoothingEnabled = false; // Disable image smoothing for better performance
        this.clear();
    }
    /**
   * Creates a canvas instance, falling back to HTMLCanvasElement if OffscreenCanvas is not available
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ViewportCanvas, [
        {
            key: "createCanvas",
            value: function createCanvas(width, height) {
                if (typeof OffscreenCanvas !== 'undefined') return new OffscreenCanvas(width, height);
                var canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                return canvas;
            }
        },
        {
            key: "getScaledDimensions",
            value: function getScaledDimensions() {
                return {
                    width: this.scaledWidth,
                    height: this.scaledHeight
                };
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            }
        },
        {
            key: "generateColor",
            value: function generateColor() {
                // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
                var rgbColor = this.colorCounter++ % 0x00ffffff;
                return (0, $13bxQ.getRGBComponents)(rgbColor);
            }
        },
        {
            key: "drawRect",
            value: function drawRect(rect, timestamp) {
                var color = this.generateColor();
                this.colorTimeMap.set(color, timestamp);
                this.ctx.fillStyle = color;
                if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
                var scaledX = rect.x * this.scaleX;
                var scaledY = rect.y * this.scaleY;
                var scaledWidth = rect.width * this.scaleX;
                var scaledHeight = rect.height * this.scaleY;
                this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
            }
        },
        {
            key: "getPixelCounts",
            value: function() {
                var _getPixelCounts = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
                    var imageData, timestampsAmount, pixelCounts, timePixelCounts, i, count, color, rgbColor, timestamp;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
                                timestampsAmount = this.colorTimeMap.size;
                                _context.next = 1;
                                return (0, $57Ru0.calculateDrawnPixelsRaw)(imageData, this.scaleFactor, timestampsAmount);
                            case 1:
                                pixelCounts = _context.sent;
                                // Convert color counts to timestamp counts
                                timePixelCounts = new Map();
                                i = 0;
                            case 2:
                                if (!(i < pixelCounts.length)) {
                                    _context.next = 5;
                                    break;
                                }
                                count = pixelCounts[i];
                                if (!(typeof count !== 'number')) {
                                    _context.next = 3;
                                    break;
                                }
                                return _context.abrupt("continue", 4);
                            case 3:
                                color = i + 1;
                                rgbColor = (0, $13bxQ.getRGBComponents)(color);
                                timestamp = this.colorTimeMap.get(rgbColor);
                                if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
                            case 4:
                                i++;
                                _context.next = 2;
                                break;
                            case 5:
                                return _context.abrupt("return", timePixelCounts);
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getPixelCounts() {
                    return _getPixelCounts.apply(this, arguments);
                }
                return getPixelCounts;
            }()
        }
    ]);
}();

});
parcelRegister("57Ru0", function(module, exports) {
$parcel$export(module.exports, "calculateDrawnPixelsRaw", () => $3bb717c84958744c$export$fafc9be44839f9c8);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $fBnGC = parcelRequire("fBnGC");
function $3bb717c84958744c$export$fafc9be44839f9c8(_x, _x2, _x3) {
    return $3bb717c84958744c$var$_calculateDrawnPixelsRaw.apply(this, arguments);
}
function $3bb717c84958744c$var$_calculateDrawnPixelsRaw() {
    $3bb717c84958744c$var$_calculateDrawnPixelsRaw = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(imageData, _, arraySize) {
        var data, arr, i, color, colorIndex;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    data = imageData.data;
                    arr = new Uint32Array(arraySize);
                    i = 0;
                case 1:
                    if (!(i < data.length)) {
                        _context.next = 3;
                        break;
                    }
                    // Check alpha
                    if (data[i + 3] !== 0) {
                        // Combine RGB components into a single 24-bit color value:
                        // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
                        // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
                        // data[i + 2]       - Blue component stays as is         (bits 0-7)
                        // The | operator combines all bits together
                        color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
                        colorIndex = color - 1;
                        arr[colorIndex] = (arr[colorIndex] || 0) + 1;
                    }
                    if (!(i % 10000 === 0)) {
                        _context.next = 2;
                        break;
                    }
                    _context.next = 2;
                    return (0, $fBnGC.default)();
                case 2:
                    i += 4;
                    _context.next = 1;
                    break;
                case 3:
                    return _context.abrupt("return", arr);
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $3bb717c84958744c$var$_calculateDrawnPixelsRaw.apply(this, arguments);
}

});
parcelRegister("fBnGC", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5bcaf5a62589785$export$2e2bcd8739ae039);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");
// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
function $b5bcaf5a62589785$var$taskYield() {
    return $b5bcaf5a62589785$var$_taskYield.apply(this, arguments);
}
function $b5bcaf5a62589785$var$_taskYield() {
    $b5bcaf5a62589785$var$_taskYield = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
        var resolve, p;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!('scheduler' in globalThis && // @ts-ignore
                    'yield' in globalThis.scheduler)) {
                        _context.next = 2;
                        break;
                    }
                    _context.next = 1;
                    return scheduler.yield();
                case 1:
                    return _context.abrupt("return");
                case 2:
                    resolve = function resolve() {};
                    p = new Promise(function(a) {
                        resolve = a;
                    });
                    setTimeout(resolve, 0);
                    _context.next = 3;
                    return p;
                case 3:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $b5bcaf5a62589785$var$_taskYield.apply(this, arguments);
}
var $b5bcaf5a62589785$export$2e2bcd8739ae039 = $b5bcaf5a62589785$var$taskYield;

});


parcelRegister("13bxQ", function(module, exports) {
$parcel$export(module.exports, "getRGBComponents", () => $0c3f06d2f3627856$export$54591583ed0b20ce);
/**
 * Converts a number into RGB components in such a way that they can be recombined
 * to form the original number using bitwise operations.
 * @param number - The input number to be split into RGB components.
 * @returns The RGB color string in the format "rgb(r, g, b)".
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $0c3f06d2f3627856$export$54591583ed0b20ce(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    var blue = n & 0xff;
    // Extract green component (bits 8-15)
    var green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    var red = n >> 16 & 0xff;
    return "rgb(".concat(red, ", ").concat(green, ", ").concat(blue, ")");
}

});



parcelRegister("vFumy", function(module, exports) {
$parcel$export(module.exports, "detectLayoutShiftCause", () => $05f31429283a0e0b$export$93ce39b765ea2cd3);
function $05f31429283a0e0b$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $05f31429283a0e0b$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $05f31429283a0e0b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $05f31429283a0e0b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $05f31429283a0e0b$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $05f31429283a0e0b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $05f31429283a0e0b$var$calculateOffenderState = function calculateOffenderState(current, matchesCurrentEntry) {
    // Once we know it's mixed across entries, we can short-circuit.
    if (current === 'some') return 'some';
    var entryState = matchesCurrentEntry ? 'all' : 'none';
    if (current == null) return entryState;
    // If the state flips between entries (all <-> none), it's "some".
    if (current !== entryState) return 'some';
    return current;
};
var $05f31429283a0e0b$var$calculateLayoutShiftMovement = function calculateLayoutShiftMovement(layoutShiftEntries) {
    var movements = layoutShiftEntries.map(function(lsEntry) {
        var rect = lsEntry.rect;
        var previousRect = lsEntry.previousRect;
        if (!rect || !previousRect) return null;
        var dx = rect.x - previousRect.x;
        var dy = rect.y - previousRect.y;
        return {
            dx: dx,
            dy: dy,
            movedX: dx !== 0,
            movedY: dy !== 0,
            dirX: Math.sign(dx),
            dirY: Math.sign(dy),
            absDx: Math.abs(dx),
            absDy: Math.abs(dy)
        };
    });
    var hasMovement = function hasMovement(m) {
        return m !== null;
    };
    var validMovements = movements.filter(hasMovement);
    var allHaveRects = layoutShiftEntries.length > 0 && validMovements.length === layoutShiftEntries.length;
    if (!allHaveRects) return {
        allHaveRects: allHaveRects,
        allMovedSameWay: false,
        allMovedSameAmount: false
    };
    var first = validMovements[0];
    var allMovedSameWay = validMovements.every(function(m) {
        return m.movedX === first.movedX && m.movedY === first.movedY && m.dirX === first.dirX && m.dirY === first.dirY;
    });
    var allMovedSameAmount = allMovedSameWay && validMovements.every(function(m) {
        return m.absDx === first.absDx && m.absDy === first.absDy;
    });
    return {
        allHaveRects: allHaveRects,
        allMovedSameWay: allMovedSameWay,
        allMovedSameAmount: allMovedSameAmount,
        deltaX: first.dx,
        deltaY: first.dy
    };
};
var $05f31429283a0e0b$export$93ce39b765ea2cd3 = function detectLayoutShiftCause(_ref) {
    var viewportEntries = _ref.viewportEntries, layoutShiftEntries = _ref.layoutShiftEntries, time = _ref.time, startTime = _ref.startTime, _ref$offenderWindowMs = _ref.offenderWindowMs, offenderWindowMs = _ref$offenderWindowMs === void 0 ? 250 : _ref$offenderWindowMs;
    var checkpointTimestamp = startTime + time;
    var filteredLSPotentialOffenders = viewportEntries.filter(function(viewportEntry) {
        return (viewportEntry.time < checkpointTimestamp && viewportEntry.time > checkpointTimestamp - offenderWindowMs || viewportEntry.time > checkpointTimestamp && viewportEntry.time < checkpointTimestamp + offenderWindowMs) && viewportEntry.data.type !== 'layout-shift';
    });
    // Summarize whether all layout-shift entries moved in a consistent direction and by the same amount.
    var layoutShiftVariables = $05f31429283a0e0b$var$calculateLayoutShiftMovement(layoutShiftEntries);
    // Classify each offender against *all* layout-shift entries when the layout shift is consistently moving in a
    // single axis (pure X or pure Y) so we can reason about whether an offender could have caused the movement.
    var layoutShiftOffenders = filteredLSPotentialOffenders.reduce(function(acc, offender) {
        var _offenderData$origina;
        var offenderData = offender.data;
        var offenderRect = offenderData.rect;
        if (!offenderRect) return acc;
        var offenderTimestamp = (_offenderData$origina = offenderData.originalMutationTimestamp) !== null && _offenderData$origina !== void 0 ? _offenderData$origina : offender.time;
        var happenedBefore = offenderTimestamp <= checkpointTimestamp;
        var offenderLeft = offenderRect.x;
        var offenderRight = offenderRect.x + offenderRect.width;
        var offenderTop = offenderRect.y;
        var offenderBottom = offenderRect.y + offenderRect.height;
        var shouldClassifyAgainstAllEntries = layoutShiftVariables.allMovedSameWay && 'deltaX' in layoutShiftVariables && 'deltaY' in layoutShiftVariables && layoutShiftVariables.deltaX === 0 !== (layoutShiftVariables.deltaY === 0);
        var isAbove = null;
        var isLeft = null;
        var isRight = null;
        var hasHorizontalOverlap = null;
        var hasVerticalOverlap = null;
        if (shouldClassifyAgainstAllEntries) {
            var _iterator = $05f31429283a0e0b$var$_createForOfIteratorHelper(layoutShiftEntries), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var lsEntry = _step.value;
                    var lsRect = lsEntry.rect;
                    if (!lsRect) continue;
                    var lsLeft = lsRect.x;
                    var lsRight = lsRect.x + lsRect.width;
                    var lsTop = lsRect.y;
                    var lsBottom = lsRect.y + lsRect.height;
                    isAbove = $05f31429283a0e0b$var$calculateOffenderState(isAbove, offenderBottom <= lsTop);
                    isLeft = $05f31429283a0e0b$var$calculateOffenderState(isLeft, offenderRight <= lsLeft);
                    isRight = $05f31429283a0e0b$var$calculateOffenderState(isRight, offenderLeft >= lsRight);
                    hasHorizontalOverlap = $05f31429283a0e0b$var$calculateOffenderState(hasHorizontalOverlap, offenderLeft < lsRight && offenderRight > lsLeft);
                    hasVerticalOverlap = $05f31429283a0e0b$var$calculateOffenderState(hasVerticalOverlap, offenderTop < lsBottom && offenderBottom > lsTop);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
        var matchesLayoutShiftDelta = false;
        if (shouldClassifyAgainstAllEntries && layoutShiftVariables.allMovedSameAmount && offenderData.previousRect) {
            var dx = offenderRect.x - offenderData.previousRect.x;
            var dy = offenderRect.y - offenderData.previousRect.y;
            var isPureX = layoutShiftVariables.deltaX !== 0 && layoutShiftVariables.deltaY === 0;
            var isPureY = layoutShiftVariables.deltaY !== 0 && layoutShiftVariables.deltaX === 0;
            if (isPureX) matchesLayoutShiftDelta = dx === layoutShiftVariables.deltaX && dy === 0;
            else if (isPureY) matchesLayoutShiftDelta = dy === layoutShiftVariables.deltaY && dx === 0;
        }
        acc.push({
            offender: offenderData.elementName,
            happenedBefore: happenedBefore,
            distanceToLS: Math.round(offenderTimestamp - checkpointTimestamp),
            isAbove: isAbove !== null && isAbove !== void 0 ? isAbove : 'none',
            isLeft: isLeft !== null && isLeft !== void 0 ? isLeft : 'none',
            isRight: isRight !== null && isRight !== void 0 ? isRight : 'none',
            hasHorizontalOverlap: hasHorizontalOverlap !== null && hasHorizontalOverlap !== void 0 ? hasHorizontalOverlap : 'none',
            hasVerticalOverlap: hasVerticalOverlap !== null && hasVerticalOverlap !== void 0 ? hasVerticalOverlap : 'none',
            matchesLayoutShiftDelta: matchesLayoutShiftDelta
        });
        return acc;
    }, []);
    return {
        layoutShiftVariables: layoutShiftVariables,
        layoutShiftOffenders: layoutShiftOffenders
    };
};

});

parcelRegister("3VF6y", function(module, exports) {
$parcel$export(module.exports, "default", () => $2dc69487c41fda63$export$2e2bcd8739ae039);
function $2dc69487c41fda63$var$getViewportHeight() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (_unused) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
var $2dc69487c41fda63$export$2e2bcd8739ae039 = $2dc69487c41fda63$var$getViewportHeight;

});

parcelRegister("5X23Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $45541023c89f2474$export$2e2bcd8739ae039);
function $45541023c89f2474$var$getViewportWidth() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (_unused) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
var $45541023c89f2474$export$2e2bcd8739ae039 = $45541023c89f2474$var$getViewportWidth;

});

parcelRegister("fWZXc", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9cc5487293cd169$export$2e2bcd8739ae039);
function $b9cc5487293cd169$var$isViewportEntryData(data) {
    if (data) {
        var hasElementName = typeof data.elementName === 'string';
        var hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}
var $b9cc5487293cd169$export$2e2bcd8739ae039 = $b9cc5487293cd169$var$isViewportEntryData;

});


parcelRegister("gjuwC", function(module, exports) {
$parcel$export(module.exports, "KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS", () => $be06195936d1da75$export$98812f4e79596e2b);
$parcel$export(module.exports, "NON_VISUAL_ARIA_ATTRIBUTES", () => $be06195936d1da75$export$44331555a87fcd9e);
$parcel$export(module.exports, "THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES", () => $be06195936d1da75$export$c4351da6279bef53);
$parcel$export(module.exports, "MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES", () => $be06195936d1da75$export$2492353b2cc31cc0);
$parcel$export(module.exports, "DARK_READER_BROWSER_EXTENSION_ATTRIBUTES", () => $be06195936d1da75$export$5a7b359ee5e32a5b);
// TODO: AFO-3523
// Those are the attributes we have found when testing the 'fy25.03' manually.
// We still need to replace this hardcoded list with a proper automation
var $be06195936d1da75$export$98812f4e79596e2b = [
    'data-drop-target-for-element',
    'data-drop-target-for-external',
    'draggable',
    'data-is-observed',
    'data-aui-version',
    'data-testid',
    'data-vc',
    'data-ssr-placeholder',
    'data-ssr-placeholder-replace',
    'data-vc-nvs',
    'data-media-vc-wrapper',
    'data-renderer-start-pos',
    'data-table-local-id',
    'spellcheck',
    'data-auto-scrollable',
    'id',
    'tabindex',
    'data-is-ttvc-ready',
    'contenteditable',
    'data-has-collab-initialised',
    'translate',
    'data-comment-id',
    'data-access-level'
];
var $be06195936d1da75$export$44331555a87fcd9e = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-hidden',
    'aria-expanded',
    'aria-controls',
    'aria-selected',
    'aria-checked',
    'aria-disabled',
    'aria-required',
    'aria-current',
    'aria-haspopup',
    'aria-pressed',
    'aria-atomic',
    'aria-live'
];
var $be06195936d1da75$export$c4351da6279bef53 = [
    'bis_skin_checked',
    'cz-shortcut-listen',
    'monica-version',
    'data-gr-ext-installed',
    'data-dashlane-rid',
    'sapling-installed',
    'data-gptw',
    // grammarly extensions
    'data-new-gr-c-s-loaded',
    'data-gr-aaa-notch-connection-id',
    'data-gr-aaa-loaded'
];
var $be06195936d1da75$export$2492353b2cc31cc0 = [
    'fdprocessedid',
    'data-dashlane-classification'
];
var $be06195936d1da75$export$5a7b359ee5e32a5b = [
    // dark reader extension
    'data-darkreader-inline-bgcolor',
    'data-darkreader-inline-bgimage',
    'data-darkreader-inline-border',
    'data-darkreader-inline-border-bottom',
    'data-darkreader-inline-border-left',
    'data-darkreader-inline-border-right',
    'data-darkreader-inline-border-top',
    'data-darkreader-inline-boxshadow',
    'data-darkreader-inline-color',
    'data-darkreader-inline-fill',
    'data-darkreader-inline-stroke',
    'data-darkreader-inline-outline',
    'data-darkreader-inline-stopcolor',
    'data-darkreader-inline-bg',
    'data-darkreader-inline-border-short',
    'data-darkreader-inline-border-bottom-short',
    'data-darkreader-inline-border-left-short',
    'data-darkreader-inline-border-right-short',
    'data-darkreader-inline-border-top-short'
];

});


parcelRegister("dzHaO", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e200894717f0493$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $50U6m = parcelRequire("50U6m");

var $jdRKQ = parcelRequire("jdRKQ");

var $gjuwC = parcelRequire("gjuwC");
function $9e200894717f0493$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $9e200894717f0493$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $9e200894717f0493$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9e200894717f0493$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $9e200894717f0493$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $9e200894717f0493$var$getConsideredEntryTypes = function getConsideredEntryTypes() {
    var consideredEntryTypes = [
        'mutation:display-contents-children-element'
    ];
    consideredEntryTypes.push('mutation:display-contents-children-attribute');
    return consideredEntryTypes;
};
var $9e200894717f0493$var$getExcludedEntryTypes = function getExcludedEntryTypes() {
    var excludedEntryTypes = [
        'layout-shift:same-rect',
        'mutation:attribute:non-visual-input-name'
    ];
    return excludedEntryTypes;
};
var $9e200894717f0493$var$fy26_04_excluded_attributes = [
    'data-is-hovered' // non-visual attribute
];
var $9e200894717f0493$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_VCCalculator_FY25_) {
    function VCCalculator_FY26_04() {
        var revisionNo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'fy26.04';
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, VCCalculator_FY26_04);
        return $9e200894717f0493$var$_callSuper(this, VCCalculator_FY26_04, [
            revisionNo
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(VCCalculator_FY26_04, _VCCalculator_FY25_);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(VCCalculator_FY26_04, [
        {
            key: "isEntryIncluded",
            value: function isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
                var extra_fy26_04_excluded_attributes = [
                    'data-fabric-mode'
                ];
                var entryData = entry.data;
                var attributeName = entryData.attributeName;
                if (entry.data.type === 'mutation:attribute' && attributeName && extra_fy26_04_excluded_attributes.includes(attributeName)) return false;
                var isEntryIncludedInV3 = $9e200894717f0493$var$_superPropGet(VCCalculator_FY26_04, "isEntryIncluded", this, 3)([
                    entry,
                    include3p,
                    excludeSmartAnswersInSearch
                ]);
                if (isEntryIncludedInV3 && !$9e200894717f0493$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
                if (entry.data.type === 'mutation:attribute' && (!attributeName || $9e200894717f0493$var$fy26_04_excluded_attributes.includes(attributeName) && (0, $50U6m.fg)('platform_ufo_data-is-hovered-v4-exclusion'))) return false;
                var thirdPartyAttributes = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((0, $gjuwC.THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES)), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((0, $gjuwC.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES)), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((0, $50U6m.fg)('platform_ufo_exclude_fdprocessedid_attribute') ? (0, $gjuwC.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES) : []));
                if (entryData.type === 'mutation:display-contents-children-attribute') {
                    if (!attributeName || attributeName.startsWith('data-test') || (0, $gjuwC.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(attributeName) || (0, $gjuwC.NON_VISUAL_ARIA_ATTRIBUTES).includes(attributeName) || thirdPartyAttributes.includes(attributeName)) return false;
                    return true;
                }
                return $9e200894717f0493$var$getConsideredEntryTypes().includes(entry.data.type);
            }
        }
    ]);
}((0, $jdRKQ.default));

});

parcelRegister("cTTWn", function(module, exports) {
$parcel$export(module.exports, "default", () => $964603b6c95f17ee$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $dzHaO = parcelRequire("dzHaO");
function $964603b6c95f17ee$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $964603b6c95f17ee$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $964603b6c95f17ee$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($964603b6c95f17ee$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $964603b6c95f17ee$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $964603b6c95f17ee$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize',
    'scroll-container'
];
var $964603b6c95f17ee$var$getConsideredEntryTypes = function getConsideredEntryTypes() {
    var consideredEntryTypes = [];
    return consideredEntryTypes;
};
var $964603b6c95f17ee$var$getExcludedEntryTypes = function getExcludedEntryTypes() {
    var excludedEntryTypes = [];
    return excludedEntryTypes;
};
var $964603b6c95f17ee$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_VCCalculator_FY26_) {
    function VCCalculator_Next() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, VCCalculator_Next);
        return $964603b6c95f17ee$var$_callSuper(this, VCCalculator_Next, [
            'next'
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(VCCalculator_Next, _VCCalculator_FY26_);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(VCCalculator_Next, [
        {
            key: "isEntryIncluded",
            value: function isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
                var isEntryIncludedInV4 = $964603b6c95f17ee$var$_superPropGet(VCCalculator_Next, "isEntryIncluded", this, 3)([
                    entry,
                    include3p,
                    excludeSmartAnswersInSearch
                ]);
                if (isEntryIncludedInV4 && !$964603b6c95f17ee$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
                return $964603b6c95f17ee$var$getConsideredEntryTypes().includes(entry.data.type);
            }
        },
        {
            key: "getVCCleanStatus",
            value: function getVCCleanStatus(filteredEntries) {
                var dirtyReason = '';
                var abortTimestamp = -1;
                var hasAbortEvent = filteredEntries.some(function(entry) {
                    if (entry.data.type === 'window:event') {
                        var data = entry.data;
                        var eventType = data.eventType;
                        if ($964603b6c95f17ee$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                            if (eventType === 'keydown') dirtyReason = 'keypress';
                            else if (eventType === 'scroll-container') dirtyReason = 'scroll';
                            else dirtyReason = eventType;
                            abortTimestamp = Math.round(entry.time);
                            return true;
                        }
                    }
                    return false;
                });
                if (hasAbortEvent && dirtyReason) return {
                    isVCClean: false,
                    dirtyReason: dirtyReason,
                    abortTimestamp: abortTimestamp
                };
                return {
                    isVCClean: true
                };
            }
        }
    ]);
}((0, $dzHaO.default));

});

parcelRegister("gOE39", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3e061e51a46a203$export$2e2bcd8739ae039);

var $1Vcia = parcelRequire("1Vcia");

var $fC8ib = parcelRequire("fC8ib");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $DtLwq = parcelRequire("DtLwq");

var $h9fNq = parcelRequire("h9fNq");

var $3VF6y = parcelRequire("3VF6y");

var $5X23Y = parcelRequire("5X23Y");
var $c3e061e51a46a203$var$_excluded = [
    "att"
];
function $c3e061e51a46a203$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $c3e061e51a46a203$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $c3e061e51a46a203$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $c3e061e51a46a203$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $c3e061e51a46a203$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $c3e061e51a46a203$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $c3e061e51a46a203$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c3e061e51a46a203$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c3e061e51a46a203$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c3e061e51a46a203$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c3e061e51a46a203$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
var $c3e061e51a46a203$var$MAX_OBSERVATIONS = 200;
var $c3e061e51a46a203$var$encodeRect = function encodeRect(rect) {
    return [
        Math.round(rect.left * 10) / 10,
        Math.round(rect.top * 10) / 10,
        Math.round(rect.right * 10) / 10,
        Math.round(rect.bottom * 10) / 10
    ];
};
var $c3e061e51a46a203$var$areRectsEqual = function areRectsEqual(left, right) {
    return left.every(function(value, index) {
        return value === right[index];
    });
};
function $c3e061e51a46a203$var$isWindowEventEntryData(data) {
    return data.type === 'window:event' && 'eventType' in data;
}
var $c3e061e51a46a203$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function RawDataHandler() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, RawDataHandler);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "revisionNo", 'raw-handler');
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(RawDataHandler, [
        {
            key: "getVCCleanStatus",
            value: function getVCCleanStatus(filteredEntries) {
                var dirtyReason = '';
                var abortTimestamp = -1;
                var hasAbortEvent = filteredEntries.some(function(entry) {
                    if (entry.data.type === 'window:event') {
                        var data = entry.data;
                        var eventType = data.eventType;
                        if ($c3e061e51a46a203$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                            dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                            abortTimestamp = Math.round(entry.time);
                            return true;
                        }
                    }
                    return false;
                });
                if (hasAbortEvent && dirtyReason) return {
                    isVCClean: false,
                    dirtyReason: dirtyReason,
                    abortTimestamp: abortTimestamp
                };
                return {
                    isVCClean: true
                };
            }
        },
        {
            key: "getRawData",
            value: function() {
                var _getRawData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_ref) {
                    var entries, startTime, stopTime, isPageVisible, isVCClean, dirtyReason, getVCCleanStatusResult, _getEarliestHiddenTim, viewportEntries, windowEventEntries, targetNameToIdMap, elementMapEntriesMap, nextElementId, typeMap, typeMapEntriesMap, nextTypeId, attributeMap, attributeEntriesMap, nextAttributeId, eventTypeMap, eventTypeMapEntriesMap, nextEventTypeId, labelStacksMap, rawObservations, rawEventObservations, shouldTrimEventObservations, shouldTrimViewportObservations, firstEventObservation, lastEventObservations, firstObservation, lastObservations, ssrEid, ssrObservation, ssrAlreadyIncluded, referencedEids, referencedChgs, referencedAtts, referencedEvts, referencedEventTargetEids, _iterator, _step, observation, _iterator2, _step2, _observation, _iterator3, _step3, eid, _iterator4, _step4, chg, _iterator5, _step5, att, _iterator6, _step6, evt, isFedrampScrubbed, scrubbedObservations, result;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                entries = _ref.entries, startTime = _ref.startTime, stopTime = _ref.stopTime, isPageVisible = _ref.isPageVisible;
                                getVCCleanStatusResult = this.getVCCleanStatus(entries);
                                isVCClean = getVCCleanStatusResult.isVCClean;
                                dirtyReason = getVCCleanStatusResult.dirtyReason;
                                if (isPageVisible) {
                                    _context.next = 1;
                                    break;
                                }
                                return _context.abrupt("return", {
                                    revision: this.revisionNo,
                                    clean: false,
                                    'metric:vc90': null,
                                    abortReason: 'browser_backgrounded',
                                    abortTimestamp: (_getEarliestHiddenTim = (0, $h9fNq.getEarliestHiddenTiming)(startTime, stopTime)) !== null && _getEarliestHiddenTim !== void 0 ? _getEarliestHiddenTim : -1,
                                    viewport: {
                                        w: (0, $5X23Y.default)(),
                                        h: (0, $3VF6y.default)()
                                    }
                                });
                            case 1:
                                viewportEntries = entries.filter(function(entry) {
                                    return entry.time >= startTime && entry.time <= stopTime && entry.data && entry.data.visible;
                                });
                                windowEventEntries = entries.filter(function(entry) {
                                    return entry.time >= startTime && entry.time <= stopTime && entry.data && $c3e061e51a46a203$var$isWindowEventEntryData(entry.data);
                                });
                                targetNameToIdMap = new Map();
                                elementMapEntriesMap = {};
                                nextElementId = 1;
                                typeMap = new Map();
                                typeMapEntriesMap = {};
                                nextTypeId = 1;
                                attributeMap = new Map();
                                attributeEntriesMap = {};
                                nextAttributeId = 1;
                                eventTypeMap = new Map();
                                eventTypeMapEntriesMap = {};
                                nextEventTypeId = 1;
                                labelStacksMap = {};
                                rawObservations = viewportEntries.map(function(entry) {
                                    var viewportEntry = entry.data;
                                    var targetName = viewportEntry.elementName || '';
                                    var type = viewportEntry.type || '';
                                    var rect = viewportEntry.rect;
                                    var attributeName = viewportEntry.attributeName || '';
                                    var eid = targetNameToIdMap.get(viewportEntry.elementName || '') || 0;
                                    if (eid === 0) {
                                        eid = nextElementId;
                                        nextElementId += 1;
                                        targetNameToIdMap.set(targetName, eid);
                                        elementMapEntriesMap[eid] = targetName;
                                    }
                                    // Capture labelStacks per element (only stored once per unique element)
                                    if (viewportEntry.labelStacks && !(eid in labelStacksMap)) {
                                        var labelInfo = {
                                            s: viewportEntry.labelStacks.segment,
                                            l: viewportEntry.labelStacks.labelStack
                                        };
                                        var shouldCompactImplicitUnknown = labelInfo.s === 'unknown' && labelInfo.l === 'unknown';
                                        labelStacksMap[eid] = shouldCompactImplicitUnknown ? 'u' : labelInfo;
                                    }
                                    var chg = typeMap.get(type || '') || 0;
                                    if (chg === 0) {
                                        chg = nextTypeId;
                                        nextTypeId += 1;
                                        typeMap.set(type, chg);
                                        typeMapEntriesMap[chg] = type;
                                    }
                                    var att = 0;
                                    if (attributeName) {
                                        att = attributeMap.get(attributeName) || 0;
                                        if (att === 0) {
                                            att = nextAttributeId;
                                            nextAttributeId += 1;
                                            attributeMap.set(attributeName, att);
                                            attributeEntriesMap[att] = attributeName;
                                        }
                                    }
                                    var encodedRect = $c3e061e51a46a203$var$encodeRect(rect);
                                    var encodedPreviousRect = viewportEntry.previousRect ? $c3e061e51a46a203$var$encodeRect(viewportEntry.previousRect) : null;
                                    var shouldIncludePreviousRect = encodedPreviousRect === null || !$c3e061e51a46a203$var$areRectsEqual(encodedRect, encodedPreviousRect);
                                    var observation = $c3e061e51a46a203$var$_objectSpread($c3e061e51a46a203$var$_objectSpread({
                                        t: Math.round(entry.time - startTime),
                                        r: encodedRect
                                    }, shouldIncludePreviousRect ? {
                                        pr: encodedPreviousRect
                                    } : {}), {}, {
                                        chg: chg,
                                        eid: eid || 0
                                    }, att > 0 ? {
                                        att: att
                                    } : {});
                                    return observation;
                                });
                                rawEventObservations = windowEventEntries.map(function(entry) {
                                    var windowEventEntry = entry.data;
                                    var eventType = windowEventEntry.eventType;
                                    var evtId = eventTypeMap.get(eventType) || 0;
                                    if (evtId === 0) {
                                        evtId = nextEventTypeId;
                                        nextEventTypeId += 1;
                                        eventTypeMap.set(eventType, evtId);
                                        eventTypeMapEntriesMap[evtId] = eventType;
                                    }
                                    var eventTargetId = 0;
                                    var eventTargetName = windowEventEntry.elementName || '';
                                    if (eventTargetName) {
                                        eventTargetId = targetNameToIdMap.get(eventTargetName) || 0;
                                        if (eventTargetId === 0) {
                                            eventTargetId = nextElementId;
                                            nextElementId += 1;
                                            targetNameToIdMap.set(eventTargetName, eventTargetId);
                                            elementMapEntriesMap[eventTargetId] = eventTargetName;
                                        }
                                    }
                                    var eventObservation = $c3e061e51a46a203$var$_objectSpread({
                                        t: Math.round(entry.time - startTime),
                                        evt: evtId
                                    }, eventTargetId > 0 ? {
                                        eid: eventTargetId
                                    } : {});
                                    return eventObservation;
                                });
                                shouldTrimEventObservations = rawEventObservations.length > $c3e061e51a46a203$var$MAX_OBSERVATIONS;
                                shouldTrimViewportObservations = rawObservations.length > $c3e061e51a46a203$var$MAX_OBSERVATIONS; // If the number of event observations is greater than the maximum allowed, we need to trim the event observations to the maximum allowed.
                                // We do this by keeping the first observation and the last MAX_OBSERVATIONS observations.
                                if (shouldTrimEventObservations) {
                                    firstEventObservation = rawEventObservations[0];
                                    lastEventObservations = rawEventObservations.slice(-$c3e061e51a46a203$var$MAX_OBSERVATIONS);
                                    rawEventObservations = [
                                        firstEventObservation
                                    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(lastEventObservations));
                                }
                                // If the number of observations is greater than the maximum allowed, we need to trim the observations to the maximum allowed.
                                // We do this by keeping the first observation, the SSR observation (if present), and the last MAX_OBSERVATIONS observations.
                                if (shouldTrimViewportObservations) {
                                    firstObservation = rawObservations[0];
                                    lastObservations = rawObservations.slice(-$c3e061e51a46a203$var$MAX_OBSERVATIONS); // Find the SSR observation by looking up the eid that corresponds to 'SSR' element name
                                    ssrEid = targetNameToIdMap.get('SSR');
                                    ssrObservation = ssrEid ? rawObservations.find(function(obs) {
                                        return obs.eid === ssrEid && obs !== firstObservation;
                                    }) : undefined; // Include SSR observation if it exists and is not already in the kept observations
                                    ssrAlreadyIncluded = ssrObservation && lastObservations.some(function(obs) {
                                        return obs === ssrObservation;
                                    });
                                    rawObservations = [
                                        firstObservation
                                    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(ssrObservation && !ssrAlreadyIncluded ? [
                                        ssrObservation
                                    ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(lastObservations));
                                }
                                if (shouldTrimViewportObservations || shouldTrimEventObservations) {
                                    // Collect referenced IDs from final retained observations. Keep this inside the trim
                                    // guard so the common untrimmed path avoids extra Set allocations and scans.
                                    referencedEids = new Set();
                                    referencedChgs = new Set();
                                    referencedAtts = new Set();
                                    referencedEvts = new Set();
                                    referencedEventTargetEids = new Set();
                                    _iterator = $c3e061e51a46a203$var$_createForOfIteratorHelper(rawObservations);
                                    try {
                                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                                            observation = _step.value;
                                            if (observation.eid > 0) referencedEids.add(observation.eid);
                                            if (typeof observation.chg === 'number' && observation.chg > 0) referencedChgs.add(observation.chg);
                                            if (observation.att !== undefined && observation.att > 0) referencedAtts.add(observation.att);
                                        }
                                    } catch (err) {
                                        _iterator.e(err);
                                    } finally{
                                        _iterator.f();
                                    }
                                    _iterator2 = $c3e061e51a46a203$var$_createForOfIteratorHelper(rawEventObservations);
                                    try {
                                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                            _observation = _step2.value;
                                            if (_observation.evt > 0) referencedEvts.add(_observation.evt);
                                            if (_observation.eid !== undefined && _observation.eid > 0) referencedEventTargetEids.add(_observation.eid);
                                        }
                                    } catch (err) {
                                        _iterator2.e(err);
                                    } finally{
                                        _iterator2.f();
                                    }
                                    _iterator3 = $c3e061e51a46a203$var$_createForOfIteratorHelper(Object.keys(elementMapEntriesMap).map(Number));
                                    try {
                                        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                            eid = _step3.value;
                                            if (!referencedEids.has(eid) && !referencedEventTargetEids.has(eid)) {
                                                delete elementMapEntriesMap[eid];
                                                delete labelStacksMap[eid];
                                            }
                                        }
                                    } catch (err) {
                                        _iterator3.e(err);
                                    } finally{
                                        _iterator3.f();
                                    }
                                    if (shouldTrimViewportObservations) {
                                        _iterator4 = $c3e061e51a46a203$var$_createForOfIteratorHelper(Object.keys(typeMapEntriesMap).map(Number));
                                        try {
                                            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                                chg = _step4.value;
                                                if (!referencedChgs.has(chg)) delete typeMapEntriesMap[chg];
                                            }
                                        } catch (err) {
                                            _iterator4.e(err);
                                        } finally{
                                            _iterator4.f();
                                        }
                                        _iterator5 = $c3e061e51a46a203$var$_createForOfIteratorHelper(Object.keys(attributeEntriesMap).map(Number));
                                        try {
                                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                                att = _step5.value;
                                                if (!referencedAtts.has(att)) delete attributeEntriesMap[att];
                                            }
                                        } catch (err) {
                                            _iterator5.e(err);
                                        } finally{
                                            _iterator5.f();
                                        }
                                    }
                                    if (shouldTrimEventObservations) {
                                        // Event type map cleanup is only needed when event observations were trimmed.
                                        // If only viewport observations were trimmed, all event observations remain and
                                        // therefore every event type ID in the map is still referenced.
                                        _iterator6 = $c3e061e51a46a203$var$_createForOfIteratorHelper(Object.keys(eventTypeMapEntriesMap).map(Number));
                                        try {
                                            for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                                                evt = _step6.value;
                                                if (!referencedEvts.has(evt)) delete eventTypeMapEntriesMap[evt];
                                            }
                                        } catch (err) {
                                            _iterator6.e(err);
                                        } finally{
                                            _iterator6.f();
                                        }
                                    }
                                }
                                // FedRAMP-Moderate scrubbing.
                                //
                                // In commercial environments the raw-handler payload includes:
                                //   - `rawData.att` / `obs[].att`  → DOM attribute names from
                                //     `MutationRecord.attributeName`. These are *names* (not values),
                                //     but custom product attributes can in principle embed
                                //     identifiers (e.g. `data-user-{id}-state`).
                                //   - `rawData.lbl`                → UFO labelStacks. Generally
                                //     curated product paths but in poorly-instrumented call sites
                                //     could embed dynamic identifiers.
                                //
                                // Server-side TTVC reconstruction does not require these fields
                                // (it is driven by timestamps, rectangles, and mutation kind),
                                // so dropping them in FedRAMP is safe and removes residual PII risk.
                                isFedrampScrubbed = (0, $DtLwq.isFedrampOverrideActive)();
                                scrubbedObservations = isFedrampScrubbed ? rawObservations.map(function(_ref2) {
                                    var _att = _ref2.att, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $c3e061e51a46a203$var$_excluded);
                                    return rest;
                                }) : rawObservations;
                                result = {
                                    revision: this.revisionNo,
                                    clean: isVCClean,
                                    'metric:vc90': null,
                                    rawData: {
                                        obs: scrubbedObservations !== null && scrubbedObservations !== void 0 ? scrubbedObservations : undefined,
                                        eid: elementMapEntriesMap !== null && elementMapEntriesMap !== void 0 ? elementMapEntriesMap : undefined,
                                        chg: typeMapEntriesMap !== null && typeMapEntriesMap !== void 0 ? typeMapEntriesMap : undefined,
                                        att: isFedrampScrubbed ? undefined : attributeEntriesMap !== null && attributeEntriesMap !== void 0 ? attributeEntriesMap : undefined,
                                        evts: rawEventObservations.length > 0 ? rawEventObservations : undefined,
                                        evt: Object.keys(eventTypeMapEntriesMap).length > 0 ? eventTypeMapEntriesMap : undefined,
                                        lbl: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? labelStacksMap : undefined,
                                        lblMode: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? 'sentinel-v1' : undefined
                                    },
                                    abortReason: dirtyReason,
                                    abortTimestamp: getVCCleanStatusResult.abortTimestamp,
                                    viewport: {
                                        w: (0, $5X23Y.default)(),
                                        h: (0, $3VF6y.default)()
                                    }
                                };
                                return _context.abrupt("return", result);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getRawData(_x) {
                    return _getRawData.apply(this, arguments);
                }
                return getRawData;
            }()
        }
    ]);
}();

});

parcelRegister("frhlU", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3d6d67691d5a6bd$export$2e2bcd8739ae039);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $50U6m = parcelRequire("50U6m");

var $cDJdu = parcelRequire("cDJdu");

var $aq2Gy = parcelRequire("aq2Gy");

var $lj1OM = parcelRequire("lj1OM");

var $eAFXa = parcelRequire("eAFXa");

var $hakpj = parcelRequire("hakpj");

var $wFqCH = parcelRequire("wFqCH");

var $69x5n = parcelRequire("69x5n");

var $gwgRo = parcelRequire("gwgRo");

var $iMyl6 = parcelRequire("iMyl6");

var $f9Q2p = parcelRequire("f9Q2p");

var $4HD8u = parcelRequire("4HD8u");

var $5OR1d = parcelRequire("5OR1d");

var $73isn = parcelRequire("73isn");

var $2Y2S2 = parcelRequire("2Y2S2");

var $8FHmX = parcelRequire("8FHmX");

var $da3Er = parcelRequire("da3Er");
function $b3d6d67691d5a6bd$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $b3d6d67691d5a6bd$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $b3d6d67691d5a6bd$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b3d6d67691d5a6bd$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b3d6d67691d5a6bd$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b3d6d67691d5a6bd$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $b3d6d67691d5a6bd$var$createElementMutationsWatcher = function createElementMutationsWatcher(removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler) {
    return function(_ref) {
        var target = _ref.target, rect = _ref.rect;
        if (getSSRState) {
            var ssrState = getSSRState();
            var SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return 'ssr-hydration';
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return 'ssr-hydration';
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            var ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return 'mutation:ssr-placeholder';
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return 'mutation:ssr-placeholder';
            }
        }
        if (hasSameDeletedNode && (0, $73isn.default)(target)) return 'mutation:remount';
        if ((0, $cDJdu.isContainedWithinMediaWrapper)(target)) return 'mutation:media';
        if (isWithinThirdPartySegment) return 'mutation:third-party-element';
        if (isWithinGenAISegment) return 'mutation:gen-ai-element';
        if (isWithinSmartAnswersSegment) return 'mutation:smart-answers-element';
        var isInIgnoreLsMarker = (0, $73isn.default)(target);
        if (!isInIgnoreLsMarker) return 'mutation:element';
        var isRLLPlaceholder = (0, $hakpj.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return 'mutation:rll-placeholder';
        var wasDeleted = removedNodeRects.some(function(nr) {
            return (0, $8FHmX.isSameRectDimensions)(nr, rect);
        });
        if (wasDeleted && isInIgnoreLsMarker) return 'mutation:element-replacement';
        return 'mutation:element';
    };
};
var $b3d6d67691d5a6bd$var$createElementMutationsWatcherNew = function createElementMutationsWatcherNew(removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler) {
    return function(_ref2) {
        var target = _ref2.target, rect = _ref2.rect;
        if (getSSRState) {
            var ssrState = getSSRState();
            var SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            var ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
        }
        if (hasSameDeletedNode && (0, $73isn.default)(target)) return {
            type: 'mutation:remount',
            mutationData: {
                timestamp: timestamp
            }
        };
        if ((0, $cDJdu.isContainedWithinMediaWrapper)(target)) return {
            type: 'mutation:media',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinThirdPartySegment) return {
            type: 'mutation:third-party-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinGenAISegment) return {
            type: 'mutation:gen-ai-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinSmartAnswersSegment) return {
            type: 'mutation:smart-answers-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        var isInIgnoreLsMarker = (0, $73isn.default)(target);
        if (!isInIgnoreLsMarker) return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
        var isRLLPlaceholder = (0, $hakpj.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return {
            type: 'mutation:rll-placeholder',
            mutationData: {
                timestamp: timestamp
            }
        };
        var wasDeleted = removedNodeRects.some(function(nr) {
            return (0, $8FHmX.isSameRectDimensions)(nr, rect);
        });
        if (wasDeleted && isInIgnoreLsMarker) return {
            type: 'mutation:element-replacement',
            mutationData: {
                timestamp: timestamp
            }
        };
        return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
    };
};
var $b3d6d67691d5a6bd$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    // SSR context functions
    function ViewportObserver(_ref3) {
        var _this = this;
        var onChange = _ref3.onChange, getSSRState = _ref3.getSSRState, getSSRPlaceholderHandler = _ref3.getSSRPlaceholderHandler, _ref3$trackLayoutShif = _ref3.trackLayoutShiftOffenders, trackLayoutShiftOffenders = _ref3$trackLayoutShif === void 0 ? false : _ref3$trackLayoutShif, searchPageConfig = _ref3.searchPageConfig;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ViewportObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "handleIntersectionEntry", function(_ref4) {
            var target = _ref4.target, rect = _ref4.rect, time = _ref4.time, type = _ref4.type, mutationData = _ref4.mutationData;
            if (!target) return;
            var visible = (0, $5OR1d.isElementVisible)(target);
            var lastElementRect = _this.mapVisibleNodeRects.get(target);
            _this.mapVisibleNodeRects.set(target, rect);
            _this.onChange({
                time: time,
                type: type,
                elementRef: new WeakRef(target),
                visible: visible,
                rect: rect,
                previousRect: lastElementRect,
                mutationData: mutationData
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "handleChildListMutation", /*#__PURE__*/ function() {
            var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_ref5) {
                var target, addedNodes, removedNodes, timestamp, removedNodeRects, targetNode, _iterator, _step, _loop, _t;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            target = _ref5.target, addedNodes = _ref5.addedNodes, removedNodes = _ref5.removedNodes, timestamp = _ref5.timestamp;
                            removedNodeRects = removedNodes.map(function(ref) {
                                var n = ref.deref();
                                if (!n) return;
                                return _this.mapVisibleNodeRects.get(n);
                            });
                            targetNode = target.deref();
                            _iterator = $b3d6d67691d5a6bd$var$_createForOfIteratorHelper(addedNodes);
                            _context2.prev = 1;
                            _loop = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _loop() {
                                var _this$getSSRState, _this$intersectionObs;
                                var addedNodeRef, addedNode, hasSameDeletedNode, _checkWithinComponent, isWithinThirdPartySegment, _checkWithinComponent2, isWithinGenAISegment, isWithinSmartAnswersSegment, isTargetReactRoot;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                                    while(true)switch(_context.prev = _context.next){
                                        case 0:
                                            addedNodeRef = _step.value;
                                            addedNode = addedNodeRef.deref();
                                            if (addedNode) {
                                                _context.next = 1;
                                                break;
                                            }
                                            return _context.abrupt("return", 1);
                                        case 1:
                                            hasSameDeletedNode = removedNodes.find(function(ref) {
                                                var n = ref.deref();
                                                if (!n || !addedNode) return false;
                                                return n.isEqualNode(addedNode);
                                            });
                                            _checkWithinComponent = (0, $iMyl6.default)(addedNode, 'UFOThirdPartySegment', _this.mapIs3pResult), isWithinThirdPartySegment = _checkWithinComponent.isWithin;
                                            _checkWithinComponent2 = (0, $iMyl6.default)(addedNode, 'UFOGenAISegment', _this.mapIsGenAIResult), isWithinGenAISegment = _checkWithinComponent2.isWithin;
                                            isWithinSmartAnswersSegment = Boolean(_this.shouldCheckSmartAnswersMutations() && (0, $4HD8u.isContainedWithinSmartAnswers)(addedNode));
                                            isTargetReactRoot = targetNode === ((_this$getSSRState = _this.getSSRState) === null || _this$getSSRState === void 0 || (_this$getSSRState = _this$getSSRState.call(_this)) === null || _this$getSSRState === void 0 ? void 0 : _this$getSSRState.reactRootElement);
                                            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.watchAndTag(addedNode, (_this.trackLayoutShiftOffenders ? $b3d6d67691d5a6bd$var$createElementMutationsWatcherNew : $b3d6d67691d5a6bd$var$createElementMutationsWatcher)(removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, !!hasSameDeletedNode, timestamp, isTargetReactRoot, _this.getSSRState, _this.getSSRPlaceholderHandler));
                                        case 2:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _loop);
                            });
                            _iterator.s();
                        case 2:
                            if ((_step = _iterator.n()).done) {
                                _context2.next = 5;
                                break;
                            }
                            return _context2.delegateYield(_loop(), "t0", 3);
                        case 3:
                            if (!_context2.t0) {
                                _context2.next = 4;
                                break;
                            }
                            return _context2.abrupt("continue", 4);
                        case 4:
                            _context2.next = 2;
                            break;
                        case 5:
                            _context2.next = 7;
                            break;
                        case 6:
                            _context2.prev = 6;
                            _t = _context2["catch"](1);
                            _iterator.e(_t);
                        case 7:
                            _context2.prev = 7;
                            _iterator.f();
                            return _context2.finish(7);
                        case 8:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        6,
                        7,
                        8
                    ]
                ]);
            }));
            return function(_x) {
                return _ref6.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "handleAttributeMutation", function(_ref7) {
            var _this$intersectionObs2;
            var target = _ref7.target, attributeName = _ref7.attributeName, oldValue = _ref7.oldValue, newValue = _ref7.newValue, timestamp = _ref7.timestamp;
            (_this$intersectionObs2 = _this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.watchAndTag(target, function(_ref8) {
                var target = _ref8.target, rect = _ref8.rect;
                if ((0, $cDJdu.isContainedWithinMediaWrapper)(target)) return {
                    type: 'mutation:media',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                var _checkWithinComponent3 = (0, $iMyl6.default)(target, 'UFOThirdPartySegment', _this.mapIs3pResult), isWithinThirdPartySegment = _checkWithinComponent3.isWithin;
                var _checkWithinComponent4 = (0, $iMyl6.default)(target, 'UFOGenAISegment', _this.mapIsGenAIResult), isWithinGenAISegment = _checkWithinComponent4.isWithin;
                if (isWithinThirdPartySegment) return {
                    type: 'mutation:third-party-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if (isWithinGenAISegment) return {
                    type: 'mutation:gen-ai-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if (_this.shouldCheckSmartAnswersMutations() && (0, $4HD8u.isContainedWithinSmartAnswers)(target)) return {
                    type: 'mutation:smart-answers-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, $aq2Gy.default)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $lj1OM.default)({
                    target: target,
                    attributeName: attributeName,
                    type: 'attributes'
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                // Pragmatic Drag and Drop attributes added during post-paint
                // registration; do not affect layout or paint.
                if ((0, $eAFXa.default)({
                    target: target,
                    attributeName: attributeName
                }) && (0, $50U6m.fg)('platform_ufo_exclude_pdnd_attributes_from_vc')) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $2Y2S2.isInputNameMutation)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-input-name',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                var isRLLPlaceholder = (0, $hakpj.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
                if (isRLLPlaceholder) return {
                    type: 'mutation:rll-placeholder',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                var lastElementRect = _this.mapVisibleNodeRects.get(target);
                if (lastElementRect && (0, $da3Er.isSameRectSize)(rect, lastElementRect)) return {
                    type: 'mutation:attribute:no-layout-shift',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                return {
                    type: 'mutation:attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "handleLayoutShift", function(_ref9) {
            var time = _ref9.time, changedRects = _ref9.changedRects;
            var _iterator2 = $b3d6d67691d5a6bd$var$_createForOfIteratorHelper(changedRects), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var changedRect = _step2.value;
                    var target = changedRect.node;
                    if (target) {
                        var isSameCurrentAndPreviousRects = (0, $8FHmX.isSameRectDimensions)(changedRect.rect, changedRect.previousRect);
                        _this.onChange({
                            time: time,
                            elementRef: new WeakRef(target),
                            visible: true,
                            rect: changedRect.rect,
                            previousRect: changedRect.previousRect,
                            type: isSameCurrentAndPreviousRects ? 'layout-shift:same-rect' : 'layout-shift'
                        });
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "shouldCheckSmartAnswersMutations", function() {
            var _this$searchPageConfi, _this$searchPageConfi2, _window;
            return ((_this$searchPageConfi = _this.searchPageConfig) === null || _this$searchPageConfi === void 0 ? void 0 : _this$searchPageConfi.enableSmartAnswersMutations) && ((_this$searchPageConfi2 = _this.searchPageConfig) === null || _this$searchPageConfi2 === void 0 ? void 0 : _this$searchPageConfi2.searchPageRoute) && ((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.pathname) && window.location.pathname === _this.searchPageConfig.searchPageRoute;
        });
        this.mapVisibleNodeRects = new WeakMap();
        this.mapIs3pResult = new WeakMap();
        this.mapIsGenAIResult = new WeakMap();
        this.onChange = onChange;
        this.isStarted = false;
        this.intersectionObserver = null;
        this.mutationObserver = null;
        this.performanceObserver = null;
        this.trackLayoutShiftOffenders = trackLayoutShiftOffenders;
        // Initialize SSR context functions
        this.getSSRState = getSSRState;
        this.getSSRPlaceholderHandler = getSSRPlaceholderHandler;
        this.searchPageConfig = searchPageConfig;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ViewportObserver, [
        {
            key: "initializeObservers",
            value: function initializeObservers() {
                if (this.isStarted) return;
                this.intersectionObserver = (0, $wFqCH.createIntersectionObserver)({
                    onEntry: this.handleIntersectionEntry
                });
                this.mutationObserver = (0, $69x5n.default)({
                    onChildListMutation: this.handleChildListMutation,
                    onAttributeMutation: this.handleAttributeMutation
                });
                this.performanceObserver = (0, $gwgRo.default)({
                    onLayoutShift: this.handleLayoutShift
                });
            }
        },
        {
            key: "start",
            value: function start() {
                var _this$mutationObserve, _this$performanceObse;
                if (this.isStarted) return;
                this.initializeObservers();
                (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
                    attributeOldValue: true,
                    attributes: true,
                    childList: true,
                    subtree: true
                });
                (_this$performanceObse = this.performanceObserver) === null || _this$performanceObse === void 0 || _this$performanceObse.observe({
                    type: 'layout-shift',
                    buffered: true,
                    // @ts-ignore -error
                    durationThreshold: 30
                });
                this.isStarted = true;
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$mutationObserve2, _this$intersectionObs3, _this$performanceObse2;
                if (!this.isStarted) return;
                (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
                (_this$intersectionObs3 = this.intersectionObserver) === null || _this$intersectionObs3 === void 0 || _this$intersectionObs3.disconnect();
                (_this$performanceObse2 = this.performanceObserver) === null || _this$performanceObse2 === void 0 || _this$performanceObse2.disconnect();
                this.isStarted = false;
                // Clean up caches when stopping
                (0, $f9Q2p.cleanupCaches)(this.mapIs3pResult);
            }
        }
    ]);
}();

});
parcelRegister("eAFXa", function(module, exports) {
$parcel$export(module.exports, "default", () => $a9f4f886e1052281$export$2e2bcd8739ae039);
/**
 * Attributes that Pragmatic Drag and Drop adds via `setAttribute` during its
 * post-paint registration step. They are used purely for hit testing and
 * registration bookkeeping, and do not affect layout, paint, or visible
 * styling, so they are safe to ignore for VC measurement.
 *
 * Drop target attributes follow `data-drop-target-for-<typeKey>` and are
 * handled by the prefix below (covers shipped and custom adapters).
 */ var $a9f4f886e1052281$export$bcd335ae574a0717 = new Set([
    // @atlaskit/pragmatic-drag-and-drop (core)
    'draggable',
    // Honey pot lives on a transient element; included for completeness.
    'data-pdnd-honey-pot',
    // @atlaskit/pragmatic-drag-and-drop-auto-scroll
    'data-auto-scrollable',
    // @atlaskit/pragmatic-drag-and-drop/react-beautiful-dnd-migration
    'data-rbd-draggable-droppable-id',
    'data-rbd-draggable-index',
    'data-rbd-droppable-type',
    'data-rbd-droppable-direction',
    'data-rbd-droppable-id',
    'data-rbd-droppable-context-id',
    'data-rbd-style-context-id'
]);
var $a9f4f886e1052281$export$846396c2d8be3710 = 'data-drop-target-for-';
function $a9f4f886e1052281$export$2e2bcd8739ae039(_ref) {
    var target = _ref.target, attributeName = _ref.attributeName;
    if (!(target instanceof Element)) return false;
    if (!attributeName) return false;
    if ($a9f4f886e1052281$export$bcd335ae574a0717.has(attributeName)) return true;
    if (attributeName.startsWith($a9f4f886e1052281$export$846396c2d8be3710)) return true;
    return false;
}

});

parcelRegister("wFqCH", function(module, exports) {
$parcel$export(module.exports, "createIntersectionObserver", () => $062320179c1b88d0$export$c3799d33e0ae80a5);

var $3jxjF = parcelRequire("3jxjF");
function $062320179c1b88d0$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $062320179c1b88d0$export$c3799d33e0ae80a5(_ref) {
    var onEntry = _ref.onEntry, onObserved = _ref.onObserved;
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    var callbacksPerElement = new WeakMap();
    var intersectionObserverCallback = function intersectionObserverCallback(entries) {
        var validEntries = [];
        var startTime = performance.now();
        entries.forEach(function(entry) {
            if (!(entry.target instanceof HTMLElement)) return;
            var tagOrCallback = callbacksPerElement.get(entry.target);
            if ((0, $3jxjF.isZeroDimensionRectangle)(entry.intersectionRect)) {
                var zeroDimensionRectangleTagCallback = function zeroDimensionRectangleTagCallback(props) {
                    var tagOrCallbackResult = typeof tagOrCallback === 'function' ? tagOrCallback(props) : tagOrCallback;
                    // override as display-contents mutation
                    if (tagOrCallbackResult === 'mutation:element') return 'mutation:display-contents-children-element';
                    // override as display-contents mutation
                    if (tagOrCallbackResult && typeof tagOrCallbackResult !== 'string' && tagOrCallbackResult.type === 'mutation:attribute' && 'oldValue' in tagOrCallbackResult.mutationData) {
                        var _tagOrCallbackResult$ = tagOrCallbackResult.mutationData, attributeName = _tagOrCallbackResult$.attributeName, oldValue = _tagOrCallbackResult$.oldValue, newValue = _tagOrCallbackResult$.newValue;
                        var isRoutingMutation = attributeName === 'style' && (!oldValue && newValue === 'display: none !important;' || oldValue === 'display: none !important;' && !newValue);
                        if (isRoutingMutation) return {
                            type: 'mutation:attribute:framework-routing',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                        return {
                            type: 'mutation:display-contents-children-attribute',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                    }
                    return tagOrCallbackResult;
                };
                for(var _i = 0, _Array$from = Array.from(entry.target.children); _i < _Array$from.length; _i++){
                    var child = _Array$from[_i];
                    observer.observe(child);
                    callbacksPerElement.set(child, zeroDimensionRectangleTagCallback);
                }
                return;
            }
            if (!$062320179c1b88d0$var$isValidEntry(entry)) return;
            var mutationTag = null;
            var mutationData = null;
            if (typeof tagOrCallback === 'function') {
                var tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag !== null && mutationTag !== void 0 ? mutationTag : 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved === null || onObserved === void 0 || onObserved({
            time: startTime,
            elements: validEntries
        });
    };
    var observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: function disconnect() {
            observer.disconnect();
        },
        unobserve: function unobserve(target) {
            observer.unobserve(target);
        },
        watchAndTag: function watchAndTag(target, tagOrCallback) {
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}

});
parcelRegister("3jxjF", function(module, exports) {
$parcel$export(module.exports, "isZeroDimensionRectangle", () => $269cfd5e63256d10$export$80d6b07c2266a1c6);
function $269cfd5e63256d10$export$80d6b07c2266a1c6(rect) {
    return rect.bottom === 0 && rect.top === 0 && rect.left === 0 && rect.right === 0 && rect.x === 0 && rect.y === 0 && rect.width === 0 && rect.height === 0;
}

});


parcelRegister("69x5n", function(module, exports) {
$parcel$export(module.exports, "default", () => $47ad3f7eff4dd279$export$2e2bcd8739ae039);

var $aeUxq = parcelRequire("aeUxq");
function $47ad3f7eff4dd279$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $47ad3f7eff4dd279$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $47ad3f7eff4dd279$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $47ad3f7eff4dd279$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $47ad3f7eff4dd279$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $47ad3f7eff4dd279$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
// Batched mutation data for performance optimization
function $47ad3f7eff4dd279$var$createMutationObserver(_ref) {
    var onAttributeMutation = _ref.onAttributeMutation, onChildListMutation = _ref.onChildListMutation, onMutationFinished = _ref.onMutationFinished;
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    var mutationObserverCallback = function mutationObserverCallback(mutations) {
        var targets = [];
        // Use nested Maps for O(1) batching performance
        // Short-lived Maps are safe since they're discarded after each callback
        var batchedMutations = new Map();
        var _iterator = $47ad3f7eff4dd279$var$_createForOfIteratorHelper(mutations), _step;
        try {
            var _loop = function _loop() {
                var mut = _step.value;
                if (!(mut.target instanceof HTMLElement)) return 0; // continue
                if ((0, $aeUxq.expVal)('cc_editor_vc_exclude_flags', 'isEnabled', false)) {
                    // Intended for excluding out of band mutations such as tooltips on hover, and page flags
                    // Currently being tested in Confluence
                    // Skip elements with data-vc-oob attribute
                    if (mut.target.dataset.vcOob) return {
                        v: void 0
                    };
                }
                if (mut.type === 'attributes') {
                    var _mut$oldValue;
                    /*
            	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
            	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
            	Conceptually there is after all a mutation: there is an old value replaced with a new one,
            	and whether or not they are the same doesn't really matter.
            	And Custom elements should work the same way as MutationObserver."
            	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
            */ var oldValue = (_mut$oldValue = mut.oldValue) !== null && _mut$oldValue !== void 0 ? _mut$oldValue : undefined;
                    var newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                    if (oldValue !== newValue) {
                        var _mut$attributeName;
                        onAttributeMutation({
                            target: mut.target,
                            attributeName: (_mut$attributeName = mut.attributeName) !== null && _mut$attributeName !== void 0 ? _mut$attributeName : 'unknown',
                            oldValue: oldValue,
                            newValue: newValue,
                            timestamp: mut.timestamp || performance.now()
                        });
                    }
                    return 0; // continue
                } else if (mut.type === 'childList') {
                    var _mut$addedNodes, _mut$removedNodes;
                    // In chromium browser MutationRecord has timestamp field, which we should use.
                    var timestamp = Math.round(mut.timestamp || performance.now());
                    // Get or create timestamp bucket
                    var timestampBucket = batchedMutations.get(timestamp);
                    if (!timestampBucket) {
                        timestampBucket = new Map();
                        batchedMutations.set(timestamp, timestampBucket);
                    }
                    // Get or create target batch within timestamp bucket
                    var batch = timestampBucket.get(mut.target);
                    if (!batch) {
                        batch = {
                            target: new WeakRef(mut.target),
                            addedNodes: [],
                            removedNodes: [],
                            timestamp: timestamp
                        };
                        timestampBucket.set(mut.target, batch);
                    }
                    // Accumulate added nodes
                    ((_mut$addedNodes = mut.addedNodes) !== null && _mut$addedNodes !== void 0 ? _mut$addedNodes : []).forEach(function(node) {
                        if (node instanceof HTMLElement) batch.addedNodes.push(new WeakRef(node));
                    });
                    // Accumulate removed nodes
                    ((_mut$removedNodes = mut.removedNodes) !== null && _mut$removedNodes !== void 0 ? _mut$removedNodes : []).forEach(function(node) {
                        if (node instanceof HTMLElement) batch.removedNodes.push(new WeakRef(node));
                    });
                }
                targets.push(mut.target);
            }, _ret;
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                _ret = _loop();
                if (_ret === 0) continue;
                if (_ret) return _ret.v;
            }
        // Process all batched childList mutations
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        var _iterator2 = $47ad3f7eff4dd279$var$_createForOfIteratorHelper(batchedMutations.values()), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var timestampBucket = _step2.value;
                var _iterator3 = $47ad3f7eff4dd279$var$_createForOfIteratorHelper(timestampBucket.values()), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var batch = _step3.value;
                        onChildListMutation({
                            target: batch.target,
                            addedNodes: batch.addedNodes,
                            removedNodes: batch.removedNodes,
                            timestamp: batch.timestamp
                        });
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        onMutationFinished === null || onMutationFinished === void 0 || onMutationFinished({
            targets: targets
        });
    };
    var observer = new MutationObserver(mutationObserverCallback);
    return observer;
}
var $47ad3f7eff4dd279$export$2e2bcd8739ae039 = $47ad3f7eff4dd279$var$createMutationObserver;

});

parcelRegister("gwgRo", function(module, exports) {
$parcel$export(module.exports, "default", () => $c06cb699e1763843$export$2e2bcd8739ae039);

var $8cbi2 = parcelRequire("8cbi2");
function $c06cb699e1763843$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $c06cb699e1763843$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $c06cb699e1763843$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $c06cb699e1763843$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $c06cb699e1763843$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $c06cb699e1763843$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $c06cb699e1763843$var$createPerformanceObserver(_ref) {
    var onLayoutShift = _ref.onLayoutShift;
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    var performanceObserverCallback = function performanceObserverCallback(entries) {
        var _iterator = $c06cb699e1763843$var$_createForOfIteratorHelper(entries.getEntries()), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var entry = _step.value;
                if (entry.entryType === 'layout-shift' && 'sources' in entry) {
                    // see https://developer.mozilla.org/en-US/docs/Web/API/LayoutShiftAttribution for more info
                    var changedRects = entry.sources.reduceRight(function(acc, attr) {
                        acc.push({
                            rect: (0, $8cbi2.convertPhysicalToLogicalResolution)(attr.currentRect),
                            previousRect: (0, $8cbi2.convertPhysicalToLogicalResolution)(attr.previousRect),
                            node: attr.node
                        });
                        return acc;
                    }, []);
                    onLayoutShift({
                        time: entry.startTime,
                        changedRects: changedRects
                    });
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
    var observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$c06cb699e1763843$export$2e2bcd8739ae039 = $c06cb699e1763843$var$createPerformanceObserver;

});
parcelRegister("8cbi2", function(module, exports) {
$parcel$export(module.exports, "convertPhysicalToLogicalResolution", () => $5f7833b03a428c50$export$5e3f54cad8cb65e2);
// The LayoutShiftAttribution API is returning the numbers on physical dimension
function $5f7833b03a428c50$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}

});


parcelRegister("iMyl6", function(module, exports) {
$parcel$export(module.exports, "default", () => $dac758c866bc6ad5$export$2e2bcd8739ae039);

var $50U6m = parcelRequire("50U6m");

var $4iVTn = parcelRequire("4iVTn");

var $66ZDE = parcelRequire("66ZDE");

var $f1VIu = parcelRequire("f1VIu");

var $f9Q2p = parcelRequire("f9Q2p");

var $iwyvF = parcelRequire("iwyvF");
var $dac758c866bc6ad5$var$OLD_DOM_WALK_MAX_LEVEL = 40;
var $dac758c866bc6ad5$var$OLD_FIBER_WALK_MAX_LEVEL = 40;
var $dac758c866bc6ad5$var$NEW_DOM_WALK_MAX_LEVEL = 400;
var $dac758c866bc6ad5$var$NEW_FIBER_WALK_MAX_LEVEL = 400;
var $dac758c866bc6ad5$var$CLEANUP_THRESHOLD = 50;
function $dac758c866bc6ad5$var$maybeCleanup(resultCache) {
    (0, $66ZDE.cacheCleanupState).callCount++;
    if ((0, $66ZDE.cacheCleanupState).callCount >= $dac758c866bc6ad5$var$CLEANUP_THRESHOLD && (0, $4iVTn.default)(0.3)) (0, $f9Q2p.cleanupCaches)(resultCache);
}
function $dac758c866bc6ad5$export$2e2bcd8739ae039(node, targetComponentName, resultCache) {
    $dac758c866bc6ad5$var$maybeCleanup(resultCache);
    if (resultCache.has(node)) {
        var _resultCache$get;
        return {
            isWithin: (_resultCache$get = resultCache.get(node)) !== null && _resultCache$get !== void 0 ? _resultCache$get : false
        };
    }
    var checkedNodes = [];
    var shouldUseBumpedWalkLevels = (0, $50U6m.fg)('ufo-bump-walk-levels');
    var DOM_WALK_MAX_LEVEL = shouldUseBumpedWalkLevels ? $dac758c866bc6ad5$var$NEW_DOM_WALK_MAX_LEVEL : $dac758c866bc6ad5$var$OLD_DOM_WALK_MAX_LEVEL;
    var FIBER_WALK_MAX_LEVEL = shouldUseBumpedWalkLevels ? $dac758c866bc6ad5$var$NEW_FIBER_WALK_MAX_LEVEL : $dac758c866bc6ad5$var$OLD_FIBER_WALK_MAX_LEVEL;
    // Always use cached fiber strategy to handle non-React elements reliably
    var _findFiberWithCache = (0, $iwyvF.default)(node, DOM_WALK_MAX_LEVEL, checkedNodes, shouldUseBumpedWalkLevels ? resultCache : undefined), fiber = _findFiberWithCache.fiber, cachedResult = _findFiberWithCache.cachedResult;
    if (cachedResult !== undefined) {
        checkedNodes.forEach(function(checkedNode) {
            resultCache.set(checkedNode, cachedResult);
        });
        return {
            isWithin: cachedResult
        };
    }
    if (!fiber) {
        checkedNodes.forEach(function(checkedNode) {
            resultCache.set(checkedNode, false);
        });
        return {
            isWithin: false
        };
    }
    var isWithin = (0, $f1VIu.default)(fiber, targetComponentName, FIBER_WALK_MAX_LEVEL);
    checkedNodes.forEach(function(checkedNode) {
        resultCache.set(checkedNode, isWithin);
    });
    return {
        isWithin: isWithin
    };
}

});
parcelRegister("66ZDE", function(module, exports) {
$parcel$export(module.exports, "cacheCleanupState", () => $47331dc3d19aeb2a$export$2d67c094e7802413);
var $47331dc3d19aeb2a$export$2d67c094e7802413 = {
    callCount: 0
};

});

parcelRegister("f1VIu", function(module, exports) {
$parcel$export(module.exports, "default", () => $af13b84da006a154$export$2e2bcd8739ae039);

var $dK5dy = parcelRequire("dK5dy");
function $af13b84da006a154$export$2e2bcd8739ae039(fiber, targetComponentName, maxLevel) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return false;
    if (!fiber) return false;
    var componentName = (0, $dK5dy.default)(fiber);
    if (componentName === targetComponentName) return true;
    // Recursively traverse up the fiber tree
    return $af13b84da006a154$export$2e2bcd8739ae039(fiber.return, targetComponentName, maxLevel - 1);
}

});
parcelRegister("dK5dy", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0139e5ceb777d92$export$2e2bcd8739ae039);

var $ekGgq = parcelRequire("ekGgq");
function $a0139e5ceb777d92$export$2e2bcd8739ae039(fiber) {
    var type = fiber === null || fiber === void 0 ? void 0 : fiber.type;
    if (!type) return undefined;
    if (typeof type === 'function' || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(type) === 'object') return type.displayName || type.name;
    return undefined;
}

});


parcelRegister("f9Q2p", function(module, exports) {
$parcel$export(module.exports, "cleanupCaches", () => $b0900fe5ec3282d5$export$6a35c3789c327630);

var $66ZDE = parcelRequire("66ZDE");
function $b0900fe5ec3282d5$export$6a35c3789c327630(resultCache) {
    resultCache = new WeakMap();
    (0, $66ZDE.cacheCleanupState).callCount = 0;
    return resultCache;
}

});

parcelRegister("iwyvF", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7c5fc0cc5e2c136$export$2e2bcd8739ae039);

var $a2zGi = parcelRequire("a2zGi");
function $d7c5fc0cc5e2c136$export$2e2bcd8739ae039(element, maxLevel, checkedNodes, resultCache) {
    var currentElement = element;
    var remainingLevels = maxLevel;
    while(currentElement && remainingLevels > 0){
        var cachedResult = resultCache === null || resultCache === void 0 ? void 0 : resultCache.get(currentElement);
        if (cachedResult !== undefined) return {
            fiber: null,
            cachedResult: cachedResult
        };
        checkedNodes.push(currentElement);
        var fiber = (0, $a2zGi.default)(currentElement);
        if (fiber) return {
            fiber: fiber
        };
        currentElement = currentElement.parentElement;
        remainingLevels--;
    }
    return {
        fiber: null
    };
}

});
parcelRegister("a2zGi", function(module, exports) {
$parcel$export(module.exports, "default", () => $74f5c4d7a5b314e3$export$2e2bcd8739ae039);
// Helper function to find React fiber on an element
function $74f5c4d7a5b314e3$export$2e2bcd8739ae039(element) {
    // Use for...in loop instead of Object.keys().find() to avoid creating an array
    for(var key in element){
        if (key.startsWith('__reactFiber$') || key.startsWith('__reactInternalInstance$')) return element[key];
    }
    return null;
}

});



parcelRegister("4HD8u", function(module, exports) {
$parcel$export(module.exports, "isContainedWithinSmartAnswers", () => $36c98921d8c95b64$export$16c2770458939f21);

var $lFhdZ = parcelRequire("lFhdZ");
function $36c98921d8c95b64$export$16c2770458939f21(node) {
    var doc = (0, $lFhdZ.getDocument)();
    if (!doc) return false;
    var smartAnswersElement = doc.getElementById('search-page-smart-answers');
    if (!smartAnswersElement) return false;
    // When the node is the smart answer element, .contains() still returns true
    return smartAnswersElement.contains(node);
}

});

parcelRegister("5OR1d", function(module, exports) {
$parcel$export(module.exports, "isElementVisible", () => $43cabfa4de00742b$export$e989c0fffaa6b27a);
function $43cabfa4de00742b$export$e989c0fffaa6b27a(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        var visible = element.checkVisibility({
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch (_unused) {
        // there is no support for checkVisibility
        return true;
    }
}

});

parcelRegister("73isn", function(module, exports) {
$parcel$export(module.exports, "default", () => $52272152b6de0464$export$2e2bcd8739ae039);
/**
 * Check if the element is in the VC ignore if no layout shift marker.
 * @param element - The element to check.
 * @returns True if the element has the data-vc-ignore-if-no-layout-shift attribute == 'true or its parent has it, false otherwise.
 */ function $52272152b6de0464$export$2e2bcd8739ae039(element) {
    if (!element) return false;
    return element.getAttribute('data-vc-ignore-if-no-layout-shift') === 'true' || $52272152b6de0464$export$2e2bcd8739ae039(element.parentElement);
}

});

parcelRegister("2Y2S2", function(module, exports) {
$parcel$export(module.exports, "isInputNameMutation", () => $2293696ad1b855e9$export$80a5724ceedcfd3d);
// Detecting this is required due to a React/Chromium bug, where React itself triggers an attribute mutation for input elements
// Reference: https://atlassian.slack.com/archives/C08EK6TCUP6/p1764129900970719
function $2293696ad1b855e9$export$80a5724ceedcfd3d(_ref) {
    var target = _ref.target, attributeName = _ref.attributeName, oldValue = _ref.oldValue, newValue = _ref.newValue;
    return target instanceof HTMLInputElement && attributeName === 'name' && (oldValue === '' || newValue === '');
}

});

parcelRegister("8FHmX", function(module, exports) {
$parcel$export(module.exports, "isSameRectDimensions", () => $6503cb4e757c446d$export$fde63bc968551821);
var $6503cb4e757c446d$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $6503cb4e757c446d$export$fde63bc968551821(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $6503cb4e757c446d$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $6503cb4e757c446d$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.x - b.x) <= $6503cb4e757c446d$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.y - b.y) <= $6503cb4e757c446d$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});

parcelRegister("da3Er", function(module, exports) {
$parcel$export(module.exports, "isSameRectSize", () => $994f0a9d66b84b63$export$597b41700f7dcd36);
var $994f0a9d66b84b63$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $994f0a9d66b84b63$export$597b41700f7dcd36(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $994f0a9d66b84b63$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $994f0a9d66b84b63$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});


parcelRegister("i8F2n", function(module, exports) {
$parcel$export(module.exports, "default", () => $d348ce7cce98d0e4$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $7QpUe = parcelRequire("7QpUe");
var $d348ce7cce98d0e4$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function WindowEventObserver(opts) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, WindowEventObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "unbindFns", []);
        this.onEvent = opts.onEvent;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(WindowEventObserver, [
        {
            key: "bindEvent",
            value: function bindEvent(type) {
                var _this = this;
                var unbindCallback = (0, $7QpUe.bind)(window, {
                    type: type,
                    listener: function listener(event) {
                        if (!event.isTrusted) return;
                        _this.onEvent({
                            time: event.timeStamp,
                            type: type,
                            event: event
                        });
                    },
                    options: {
                        passive: true,
                        once: true
                    }
                });
                this.unbindFns.push(unbindCallback);
            }
        },
        {
            key: "bindCaptureScrollEvent",
            value: function bindCaptureScrollEvent() {
                var _this2 = this;
                var unbindCallback = (0, $7QpUe.bind)(document, {
                    type: 'scroll',
                    listener: function listener(event) {
                        if (!event.isTrusted) return;
                        _this2.onEvent({
                            time: event.timeStamp,
                            type: 'scroll-container',
                            event: event
                        });
                    },
                    options: {
                        capture: true,
                        passive: true,
                        once: true
                    }
                });
                this.unbindFns.push(unbindCallback);
            }
        },
        {
            key: "start",
            value: function start() {
                this.bindEvent('wheel');
                this.bindEvent('scroll');
                this.bindEvent('keydown');
                this.bindEvent('resize');
                this.bindCaptureScrollEvent();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.unbindFns.forEach(function(cb) {
                    cb();
                });
                this.unbindFns = [];
            }
        }
    ]);
}();

});




parcelRegister("aNUZN", function(module, exports) {
$parcel$export(module.exports, "interactions", () => $7ddab1203f71ccc7$export$cc97b17ef9aeb088);
var $7ddab1203f71ccc7$export$cc97b17ef9aeb088 = new Map();

});

parcelRegister("78Mn6", function(module, exports) {
$parcel$export(module.exports, "default", () => $532ecd5f82496f95$export$2e2bcd8739ae039);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $DtLwq = parcelRequire("DtLwq");

var $h9fNq = parcelRequire("h9fNq");

var $h3Aj2 = parcelRequire("h3Aj2");
function $532ecd5f82496f95$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $532ecd5f82496f95$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $532ecd5f82496f95$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $532ecd5f82496f95$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $532ecd5f82496f95$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
var $532ecd5f82496f95$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PostInteractionLog() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PostInteractionLog);
        /**
     * Basic info about interaction that has just finished
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "lastInteractionFinish", null);
        /**
     * Array of observed react render timings
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "reactProfilerTimings", []);
        /**
     * Store the scheduled sink timeout Id so that it can be cancelled when needed
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sinkTimeoutId", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "holdInfo", []);
        /**
     * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "vcObserver", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "vcObserverSSRConfig", null);
        /**
     * Handler function to process / send the observation data
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sinkHandlerFn", function() {});
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PostInteractionLog, [
        {
            key: "initializeVCObserver",
            value: function initializeVCObserver(options) {
                this.vcObserver = new (0, $h3Aj2.VCObserverWrapper)($532ecd5f82496f95$var$_objectSpread($532ecd5f82496f95$var$_objectSpread({}, options), {}, {
                    isPostInteraction: true
                }));
            }
        },
        {
            key: "startVCObserver",
            value: function startVCObserver(_ref) {
                var _this$vcObserver;
                var startTime = _ref.startTime;
                (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
                    startTime: startTime
                });
            }
        },
        {
            key: "stopVCObserver",
            value: function stopVCObserver() {
                var _this$vcObserver2;
                (_this$vcObserver2 = this.vcObserver) === null || _this$vcObserver2 === void 0 || _this$vcObserver2.stop();
            }
        },
        {
            key: "setVCObserverSSRConfig",
            value: function setVCObserverSSRConfig(vcObserverSSRConfig) {
                this.vcObserverSSRConfig = vcObserverSSRConfig;
            }
        },
        {
            key: "setLastInteractionFinishVCResult",
            value: function setLastInteractionFinishVCResult(result) {
                this.lastInteractionFinishVCResult = result;
            }
        },
        {
            key: "sinkHandler",
            value: /**
     * Set the fn that would be invoked to process / send the observation data
     */ function sinkHandler(sinkHandlerFn) {
                this.sinkHandlerFn = sinkHandlerFn;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.lastInteractionFinish = null;
                this.reactProfilerTimings = [];
                this.holdInfo = [];
                if (this.sinkTimeoutId != null) {
                    clearTimeout(this.sinkTimeoutId);
                    this.sinkTimeoutId = null;
                }
                this.setVCObserverSSRConfig(null);
            }
        },
        {
            key: "hasData",
            value: function hasData() {
                var _this$reactProfilerTi;
                return ((_this$reactProfilerTi = this.reactProfilerTimings) === null || _this$reactProfilerTi === void 0 ? void 0 : _this$reactProfilerTi.length) > 0;
            }
        },
        {
            key: "sendPostInteractionLog",
            value: function() {
                var _sendPostInteractionLog = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
                    var _this$vcObserver4, _config$vc, _config$vc2, _this$vcObserver5;
                    var _this$vcObserver3, pageVisibilityState, isPageVisible, config, postInteractionFinishVCResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!(!this.lastInteractionFinish || !this.sinkHandlerFn)) {
                                    _context.next = 1;
                                    break;
                                }
                                this.reset();
                                (_this$vcObserver3 = this.vcObserver) === null || _this$vcObserver3 === void 0 || _this$vcObserver3.stop();
                                return _context.abrupt("return");
                            case 1:
                                pageVisibilityState = (0, $h9fNq.getPageVisibilityState)(this.lastInteractionFinish.start, this.lastInteractionFinish.end);
                                isPageVisible = pageVisibilityState === 'visible';
                                config = (0, $DtLwq.getConfig)();
                                _context.next = 2;
                                return (_this$vcObserver4 = this.vcObserver) === null || _this$vcObserver4 === void 0 ? void 0 : _this$vcObserver4.getVCResult($532ecd5f82496f95$var$_objectSpread($532ecd5f82496f95$var$_objectSpread({
                                    start: this.lastInteractionFinish.start,
                                    stop: performance.now(),
                                    tti: -1,
                                    // no need for TTI value here
                                    isEventAborted: !!this.lastInteractionFinish.abortReason,
                                    prefix: 'ufo',
                                    experienceKey: this.lastInteractionFinish.ufoName,
                                    interactionId: this.lastInteractionFinish.id,
                                    includeSSRInV3: config === null || config === void 0 || (_config$vc = config.vc) === null || _config$vc === void 0 ? void 0 : _config$vc.includeSSRInV3,
                                    includeSSRRatio: config === null || config === void 0 || (_config$vc2 = config.vc) === null || _config$vc2 === void 0 ? void 0 : _config$vc2.includeSSRRatio
                                }, this.vcObserverSSRConfig), {}, {
                                    interactionType: this.lastInteractionFinish.type,
                                    isPageVisible: isPageVisible,
                                    interactionAbortReason: this.lastInteractionFinish.abortReason
                                }));
                            case 2:
                                postInteractionFinishVCResult = _context.sent;
                                (_this$vcObserver5 = this.vcObserver) === null || _this$vcObserver5 === void 0 || _this$vcObserver5.stop();
                                this.sinkHandlerFn({
                                    lastInteractionFinish: this.lastInteractionFinish,
                                    reactProfilerTimings: this.reactProfilerTimings,
                                    postInteractionFinishVCResult: postInteractionFinishVCResult,
                                    lastInteractionFinishVCResult: this.lastInteractionFinishVCResult,
                                    postInteractionHoldInfo: this.holdInfo
                                });
                                this.reset();
                            case 3:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function sendPostInteractionLog() {
                    return _sendPostInteractionLog.apply(this, arguments);
                }
                return sendPostInteractionLog;
            }()
        },
        {
            key: "onInteractionComplete",
            value: function onInteractionComplete(_ref2) {
                var _getConfig, _this = this;
                var ufoName = _ref2.ufoName, start = _ref2.start, end = _ref2.end, id = _ref2.id, abortReason = _ref2.abortReason, abortedByInteractionName = _ref2.abortedByInteractionName, routeName = _ref2.routeName, type = _ref2.type, errors = _ref2.errors;
                this.lastInteractionFinish = {
                    ufoName: ufoName,
                    start: start,
                    end: end,
                    id: id,
                    abortReason: abortReason,
                    abortedByInteractionName: abortedByInteractionName,
                    routeName: routeName,
                    type: type,
                    errors: errors
                };
                var timeout = ((_getConfig = (0, $DtLwq.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.timeWindowForLateMutationsInMilliseconds) || $532ecd5f82496f95$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
                this.sinkTimeoutId = window.setTimeout(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 1;
                                return _this.sendPostInteractionLog();
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                })), timeout);
            }
        },
        {
            key: "addProfilerTimings",
            value: function addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
                if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
                    type: type,
                    actualDuration: actualDuration,
                    baseDuration: baseDuration,
                    startTime: startTime,
                    commitTime: commitTime,
                    labelStack: labelStack
                });
            }
        },
        {
            key: "addHoldInfo",
            value: function addHoldInfo(labelStack, name, start) {
                this.holdInfo.push({
                    name: name,
                    labelStack: labelStack,
                    start: start
                });
            }
        }
    ]);
}();

});


parcelRegister("fiGqm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d485ff62f9140a59decb65646f9f10e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2397203659facc5$var$_react = $b2397203659facc5$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $b2397203659facc5$var$_iconNew = $b2397203659facc5$var$_interopRequireDefault((parcelRequire("gDzom")));
function $b2397203659facc5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/arrow-left
 * Usage guidance:
 * Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2397203659facc5$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $b2397203659facc5$var$_react.default.createElement($b2397203659facc5$var$_iconNew.default, Object.assign({
        name: "ArrowLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 7.47 5-5 1.06 1.06-3.72 3.72H15v1.5H3.56l3.72 3.72-1.06 1.06-5-5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$b2397203659facc5$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $b2397203659facc5$var$_default = module.exports.default = $b2397203659facc5$var$ArrowLeftIcon;

});

parcelRegister("kYLlQ", function(module, exports) {
$parcel$export(module.exports, "getSchemaBasedOnStage", () => $f45e243dc5cc7973$export$fd147e7d448dea03);
$parcel$export(module.exports, "defaultSchema", () => $f45e243dc5cc7973$export$1db618b7b2275ea1);

var $cvlyC = parcelRequire("cvlyC");

var $50U6m = parcelRequire("50U6m");

var $jImCY = parcelRequire("jImCY");

var $7wC9F = parcelRequire("7wC9F");
var $4eHHu = parcelRequire("4eHHu");
var $5vwuc = parcelRequire("5vwuc");
var $cnShX = parcelRequire("cnShX");
var $d79nc = parcelRequire("d79nc");
var $gc8Zd = parcelRequire("gc8Zd");

var $5BI9O = parcelRequire("5BI9O");

var $NggDw = parcelRequire("NggDw");

var $gXBJA = parcelRequire("gXBJA");

var $cnShX = parcelRequire("cnShX");

var $e29IV = parcelRequire("e29IV");
var $f45e243dc5cc7973$var$getDefaultSchemaConfig = function getDefaultSchemaConfig() {
    var defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'panel_c1',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'blockTaskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'syncBlock',
            'bodiedSyncBlock',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'fontSize',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
var $f45e243dc5cc7973$export$e4e3ac1fa64862db = $f45e243dc5cc7973$var$getDefaultSchemaConfig();
var $f45e243dc5cc7973$export$fd147e7d448dea03 = (0, $cvlyC.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
function() {
    var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'final';
    var defaultSchemaConfig = $f45e243dc5cc7973$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $d79nc.layoutSectionWithSingleColumn),
        extension: (0, $50U6m.fg)('cc_maui_annotations_on_extensions') ? (0, $cnShX.extensionRootOnlyWithAnnotationStage0) : (0, $cnShX.extensionRootOnlyStage0),
        bodiedExtension: (0, $7wC9F.bodiedExtensionRootOnlyStage0),
        multiBodiedExtension: (0, $5vwuc.multiBodiedExtensionRootOnlyStage0),
        extensionFrame: (0, $5vwuc.extensionFrame),
        expand: (0, $4eHHu.expandWithNestedExpand),
        table: (0, $gc8Zd.tableWithNestedTable),
        tableRow: (0, $gc8Zd.tableRowWithNestedTable),
        tableCell: (0, $gc8Zd.tableCellWithNestedTableStage0),
        tableHeader: (0, $gc8Zd.tableHeaderWithNestedTableStage0),
        panel: (0, $gXBJA.extendedPanelRootOnlyStage0)(true),
        panel_c1: (0, $NggDw.extendedPanelC1RootOnlyStage0)(true),
        rule: (0, $e29IV.ruleWithAttrsRootOnlyStage0),
        bodiedRule: (0, $5BI9O.bodiedRuleRootOnlyStage0)
    };
    return (0, $jImCY.createSchema)(defaultSchemaConfig);
});
var $f45e243dc5cc7973$export$1db618b7b2275ea1 = $f45e243dc5cc7973$export$fd147e7d448dea03();

});
parcelRegister("jImCY", function(module, exports) {
$parcel$export(module.exports, "createSchema", () => $e5a3adc42ae6643f$export$5f4ce795563f4211);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 
var $9Jwkl = parcelRequire("9Jwkl");

var $hx0um = parcelRequire("hx0um");

var $fjUBg = parcelRequire("fjUBg");

var $4Ncgh = parcelRequire("4Ncgh");

var $llovD = parcelRequire("llovD");

var $dIXl1 = parcelRequire("dIXl1");

function $e5a3adc42ae6643f$export$5f4ce795563f4211(config) {
    var customNodeSpecs = config.customNodeSpecs, customMarkSpecs = config.customMarkSpecs;
    var nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    var marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat((0, $fjUBg.markGroupDeclarationsNames));
    var nodes = (0, $hx0um.addItems)((0, $llovD.nodesInOrder), nodesConfig, customNodeSpecs);
    var marks = (0, $hx0um.addItems)((0, $4Ncgh.marksInOrder), marksConfig, customMarkSpecs);
    nodes = (0, $dIXl1.sanitizeNodes)(nodes, marks);
    return new (0, $9Jwkl.Schema)({
        nodes: nodes,
        marks: marks
    });
}
var $e5a3adc42ae6643f$export$c77b6d30da5276a1 = true;

});
parcelRegister("9Jwkl", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $7161648073377122$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $7161648073377122$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $7161648073377122$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $7161648073377122$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "Node", () => $7161648073377122$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $7161648073377122$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $7161648073377122$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $7161648073377122$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $7161648073377122$export$3476b78f8f5a8b72);

var $at9VT = parcelRequire("at9VT");
function $7161648073377122$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $7161648073377122$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $7161648073377122$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $7161648073377122$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $7161648073377122$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $7161648073377122$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $7161648073377122$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $7161648073377122$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $7161648073377122$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $7161648073377122$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $7161648073377122$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $7161648073377122$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $7161648073377122$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $7161648073377122$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos) {
        if (pos == 0) return $7161648073377122$var$retIndex(0, pos);
        if (pos == this.size) return $7161648073377122$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos) return $7161648073377122$var$retIndex(i + 1, end);
                return $7161648073377122$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $7161648073377122$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $7161648073377122$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $7161648073377122$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $7161648073377122$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $7161648073377122$export$ffb0004e005737fa.empty;
        if (nodes instanceof $7161648073377122$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $7161648073377122$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $7161648073377122$export$ffb0004e005737fa.empty = new $7161648073377122$export$ffb0004e005737fa([], 0);
const $7161648073377122$var$found = {
    index: 0,
    offset: 0
};
function $7161648073377122$var$retIndex(index, offset) {
    $7161648073377122$var$found.index = index;
    $7161648073377122$var$found.offset = offset;
    return $7161648073377122$var$found;
}
function $7161648073377122$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$7161648073377122$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$7161648073377122$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $7161648073377122$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $7161648073377122$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $7161648073377122$export$c9d15bcfc6d42044.none;
        if (marks instanceof $7161648073377122$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $7161648073377122$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $7161648073377122$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $7161648073377122$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $7161648073377122$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $7161648073377122$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $7161648073377122$export$b3f2e2de3a8baa1e($7161648073377122$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $7161648073377122$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $7161648073377122$export$b3f2e2de3a8baa1e($7161648073377122$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $7161648073377122$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $7161648073377122$export$b3f2e2de3a8baa1e.empty = new $7161648073377122$export$b3f2e2de3a8baa1e($7161648073377122$export$ffb0004e005737fa.empty, 0, 0);
function $7161648073377122$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($7161648073377122$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $7161648073377122$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $7161648073377122$var$insertInto(child.content, dist - offset - 1, insert, child);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $7161648073377122$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $7161648073377122$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $7161648073377122$export$6de0e778727af3f2("Inconsistent open depths");
    return $7161648073377122$var$replaceOuter($from, $to, slice, 0);
}
function $7161648073377122$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $7161648073377122$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $7161648073377122$var$close(node, $7161648073377122$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $7161648073377122$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $7161648073377122$var$prepareSliceForReplace(slice, $from);
        return $7161648073377122$var$close(node, $7161648073377122$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $7161648073377122$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $7161648073377122$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $7161648073377122$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $7161648073377122$var$checkJoin(node, $after.node(depth));
    return node;
}
function $7161648073377122$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $7161648073377122$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $7161648073377122$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$7161648073377122$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $7161648073377122$var$addNode($end.nodeBefore, target);
}
function $7161648073377122$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $7161648073377122$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $7161648073377122$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $7161648073377122$var$joinable($end, $to, depth + 1);
    let content = [];
    $7161648073377122$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $7161648073377122$var$checkJoin(openStart, openEnd);
        $7161648073377122$var$addNode($7161648073377122$var$close(openStart, $7161648073377122$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $7161648073377122$var$addNode($7161648073377122$var$close(openStart, $7161648073377122$var$replaceTwoWay($from, $start, depth + 1)), content);
        $7161648073377122$var$addRange($start, $end, depth, content);
        if (openEnd) $7161648073377122$var$addNode($7161648073377122$var$close(openEnd, $7161648073377122$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $7161648073377122$var$addRange($to, null, depth, content);
    return new $7161648073377122$export$ffb0004e005737fa(content);
}
function $7161648073377122$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $7161648073377122$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $7161648073377122$var$joinable($from, $to, depth + 1);
        $7161648073377122$var$addNode($7161648073377122$var$close(type, $7161648073377122$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $7161648073377122$var$addRange($to, null, depth, content);
    return new $7161648073377122$export$ffb0004e005737fa(content);
}
function $7161648073377122$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($7161648073377122$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $7161648073377122$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $7161648073377122$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $7161648073377122$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $7161648073377122$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $7161648073377122$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $7161648073377122$var$resolveCache.set(doc, cache = new $7161648073377122$var$ResolveCache);
        let result = cache.elts[cache.i] = $7161648073377122$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $7161648073377122$var$resolveCacheSize;
        return result;
    }
}
class $7161648073377122$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $7161648073377122$var$resolveCacheSize = 12, $7161648073377122$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $7161648073377122$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $7161648073377122$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](https://prosemirror.net/docs/guide/#doc) for more information.
*/ class $7161648073377122$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $7161648073377122$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $7161648073377122$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $7161648073377122$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $7161648073377122$var$emptyAttrs) && $7161648073377122$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $7161648073377122$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $7161648073377122$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $7161648073377122$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $7161648073377122$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $7161648073377122$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $7161648073377122$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $7161648073377122$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $7161648073377122$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $7161648073377122$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $7161648073377122$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $7161648073377122$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$7161648073377122$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $7161648073377122$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$7161648073377122$export$85c928794f8d04d4.prototype.text = undefined;
class $7161648073377122$var$TextNode extends $7161648073377122$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $7161648073377122$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $7161648073377122$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $7161648073377122$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $7161648073377122$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $7161648073377122$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $7161648073377122$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $7161648073377122$export$364ed450558d7ec4.empty;
        let expr = $7161648073377122$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $7161648073377122$var$dfa($7161648073377122$var$nfa(expr));
        $7161648073377122$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $7161648073377122$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $7161648073377122$export$364ed450558d7ec4.empty = new $7161648073377122$export$364ed450558d7ec4(true);
class $7161648073377122$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $7161648073377122$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($7161648073377122$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $7161648073377122$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($7161648073377122$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $7161648073377122$var$parseExprSubscript(stream) {
    let expr = $7161648073377122$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $7161648073377122$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $7161648073377122$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $7161648073377122$var$parseExprRange(stream, expr) {
    let min = $7161648073377122$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $7161648073377122$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $7161648073377122$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $7161648073377122$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $7161648073377122$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $7161648073377122$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $7161648073377122$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $7161648073377122$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $7161648073377122$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($7161648073377122$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $7161648073377122$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($7161648073377122$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $7161648073377122$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $7161648073377122$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($7161648073377122$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $7161648073377122$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $7161648073377122$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $7161648073377122$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $7161648073377122$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $7161648073377122$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $7161648073377122$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $7161648073377122$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $7161648073377122$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $7161648073377122$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $7161648073377122$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $7161648073377122$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $7161648073377122$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $7161648073377122$export$ffb0004e005737fa.from(content), $7161648073377122$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $7161648073377122$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $7161648073377122$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $7161648073377122$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $7161648073377122$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($7161648073377122$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $7161648073377122$export$85c928794f8d04d4(this, attrs, content.append(after), $7161648073377122$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $7161648073377122$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $7161648073377122$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $7161648073377122$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $7161648073377122$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $7161648073377122$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $7161648073377122$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $7161648073377122$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $7161648073377122$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $7161648073377122$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $7161648073377122$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $7161648073377122$export$c9d15bcfc6d42044(this, $7161648073377122$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $7161648073377122$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $7161648073377122$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $7161648073377122$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $at9VT.default).from(spec.nodes), instanceSpec.marks = (0, $at9VT.default).from(spec.marks || {}), this.nodes = $7161648073377122$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $7161648073377122$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $7161648073377122$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $7161648073377122$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $7161648073377122$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = (json)=>$7161648073377122$export$85c928794f8d04d4.fromJSON(this, json);
        this.markFromJSON = (json)=>$7161648073377122$export$c9d15bcfc6d42044.fromJSON(this, json);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $7161648073377122$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $7161648073377122$var$TextNode(type, type.defaultAttrs, text, $7161648073377122$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $7161648073377122$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $7161648073377122$var$isTagRule(rule) {
    return rule.tag != null;
}
function $7161648073377122$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $7161648073377122$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($7161648073377122$var$isTagRule(rule)) this.tags.push(rule);
            else if ($7161648073377122$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $7161648073377122$var$ParseContext(this, options, false);
        context.addAll(dom, $7161648073377122$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $7161648073377122$var$ParseContext(this, options, true);
        context.addAll(dom, $7161648073377122$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $7161648073377122$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($7161648073377122$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $7161648073377122$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $7161648073377122$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $7161648073377122$export$1059c6e7d2ce5669(schema, $7161648073377122$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $7161648073377122$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $7161648073377122$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $7161648073377122$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $7161648073377122$var$OPT_PRESERVE_WS = 1, $7161648073377122$var$OPT_PRESERVE_WS_FULL = 2, $7161648073377122$var$OPT_OPEN_LEFT = 4;
function $7161648073377122$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $7161648073377122$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $7161648073377122$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $7161648073377122$var$OPT_PRESERVE_WS | $7161648073377122$var$OPT_PRESERVE_WS_FULL : base & ~$7161648073377122$var$OPT_OPEN_LEFT;
}
class $7161648073377122$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $7161648073377122$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $7161648073377122$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($7161648073377122$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $7161648073377122$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $7161648073377122$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($7161648073377122$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$7161648073377122$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $7161648073377122$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $7161648073377122$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $7161648073377122$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $7161648073377122$var$NodeContext(topNode.type, topNode.attrs, $7161648073377122$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $7161648073377122$var$NodeContext(null, null, $7161648073377122$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $7161648073377122$var$NodeContext(parser.schema.topNodeType, null, $7161648073377122$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $7161648073377122$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $7161648073377122$var$OPT_PRESERVE_WS) > 0;
        let { schema: schema } = this.parser;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS === "full") value = value.replace(/\r\n?/g, "\n");
            else if (schema.linebreakReplacement && /[\r\n]/.test(value) && this.top.findWrapping(schema.linebreakReplacement.create())) {
                let lines = value.split(/\r?\n|\r/);
                for(let i = 0; i < lines.length; i++){
                    if (i) this.insertNode(schema.linebreakReplacement.create(), marks, true);
                    if (lines[i]) this.insertNode(schema.text(lines[i]), marks, !/\S/.test(lines[i]));
                }
                value = "";
            } else value = value.replace(/\r?\n|\r/g, " ");
            if (value) this.insertNode(schema.text(value), marks, !/\S/.test(value));
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($7161648073377122$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $7161648073377122$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $7161648073377122$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($7161648073377122$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks, true);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks, dom.nodeName == "BR")) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks, false));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks, cautious) {
        let route, sync;
        for(let depth = this.open, penalty = 0; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length + penalty)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) {
                if (cautious) break;
                penalty += 2;
            }
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks, cautious) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks, cautious);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $7161648073377122$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $7161648073377122$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks, false);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $7161648073377122$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $7161648073377122$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $7161648073377122$var$OPT_OPEN_LEFT;
        let applyMarks = $7161648073377122$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $7161648073377122$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $7161648073377122$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $7161648073377122$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $7161648073377122$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $7161648073377122$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $7161648073377122$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $7161648073377122$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $7161648073377122$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $7161648073377122$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $7161648073377122$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $7161648073377122$var$renderSpec($7161648073377122$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $7161648073377122$var$renderSpec($7161648073377122$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $7161648073377122$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $7161648073377122$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $7161648073377122$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $7161648073377122$var$gatherToDOM(schema.marks);
    }
}
function $7161648073377122$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $7161648073377122$var$doc(options) {
    return options.document || window.document;
}
const $7161648073377122$var$suspiciousAttributeCache = new WeakMap();
function $7161648073377122$var$suspiciousAttributes(attrs) {
    let value = $7161648073377122$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $7161648073377122$var$suspiciousAttributeCache.set(attrs, value = $7161648073377122$var$suspiciousAttributesInner(attrs));
    return value;
}
function $7161648073377122$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $7161648073377122$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $7161648073377122$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else if (name == "style" && dom.style) dom.style.cssText = attrs[name];
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $7161648073377122$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("at9VT", function(module, exports) {
$parcel$export(module.exports, "default", () => $79f45143962c5d22$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $79f45143962c5d22$var$OrderedMap(content) {
    this.content = content;
}
$79f45143962c5d22$var$OrderedMap.prototype = {
    constructor: $79f45143962c5d22$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $79f45143962c5d22$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $79f45143962c5d22$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $79f45143962c5d22$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $79f45143962c5d22$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $79f45143962c5d22$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $79f45143962c5d22$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $79f45143962c5d22$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $79f45143962c5d22$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $79f45143962c5d22$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $79f45143962c5d22$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$79f45143962c5d22$var$OrderedMap.from = function(value) {
    if (value instanceof $79f45143962c5d22$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $79f45143962c5d22$var$OrderedMap(content);
};
var $79f45143962c5d22$export$2e2bcd8739ae039 = $79f45143962c5d22$var$OrderedMap;

});


parcelRegister("hx0um", function(module, exports) {
$parcel$export(module.exports, "addItems", () => $cc35e5c12ab665c2$export$efa5595d3b524179);
function $cc35e5c12ab665c2$export$efa5595d3b524179(builtInItems, config) {
    var customSpecs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ var items = builtInItems.reduce(function(items, _ref) {
        var name = _ref.name, spec = _ref.spec;
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce(function(items, name) {
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}

});

parcelRegister("fjUBg", function(module, exports) {
$parcel$export(module.exports, "markGroupDeclarations", () => $b27488f9d77b139f$export$78b27f3e8d09085f);
$parcel$export(module.exports, "markGroupDeclarationsNames", () => $b27488f9d77b139f$export$ee0d2ba599b1121f);

var $6p3ce = parcelRequire("6p3ce");
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
function $b27488f9d77b139f$var$groupDeclaration(name) {
    return {
        name: "__".concat(name, "GroupDeclaration"),
        spec: {
            group: name
        }
    };
}
var $b27488f9d77b139f$export$78b27f3e8d09085f = [
    $b27488f9d77b139f$var$groupDeclaration((0, $6p3ce.COLOR)),
    $b27488f9d77b139f$var$groupDeclaration((0, $6p3ce.FONT_STYLE)),
    $b27488f9d77b139f$var$groupDeclaration((0, $6p3ce.SEARCH_QUERY)),
    $b27488f9d77b139f$var$groupDeclaration((0, $6p3ce.LINK))
];
var $b27488f9d77b139f$export$ee0d2ba599b1121f = $b27488f9d77b139f$export$78b27f3e8d09085f.map(function(groupMark) {
    return groupMark.name;
});

});
parcelRegister("6p3ce", function(module, exports) {
$parcel$export(module.exports, "FONT_STYLE", () => $4a978e99466559de$export$4498a6080fed604c);
$parcel$export(module.exports, "SEARCH_QUERY", () => $4a978e99466559de$export$f8e8a5f34f6ea725);
$parcel$export(module.exports, "LINK", () => $4a978e99466559de$export$b395009ca7f092c7);
$parcel$export(module.exports, "COLOR", () => $4a978e99466559de$export$9b982809044276a6);
// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
var $4a978e99466559de$export$4498a6080fed604c = 'fontStyle';
var $4a978e99466559de$export$f8e8a5f34f6ea725 = 'searchQuery';
var $4a978e99466559de$export$b395009ca7f092c7 = 'link';
var $4a978e99466559de$export$9b982809044276a6 = 'color';
var $4a978e99466559de$export$470d0905851e47a1 = 'alignment';
var $4a978e99466559de$export$bacb7f4b06a06b22 = 'indentation';

});


parcelRegister("4Ncgh", function(module, exports) {
$parcel$export(module.exports, "marksInOrder", () => $37d53fec18fed641$export$2a20daddecce6807);

var $fC8ib = parcelRequire("fC8ib");

var $fjUBg = parcelRequire("fjUBg");

var $5fbqs = parcelRequire("5fbqs");
var $kX1mK = parcelRequire("kX1mK");
var $d3ddB = parcelRequire("d3ddB");
var $5BptP = parcelRequire("5BptP");
var $66hh0 = parcelRequire("66hh0");
var $iVDN9 = parcelRequire("iVDN9");
var $31cn2 = parcelRequire("31cn2");
var $2InDy = parcelRequire("2InDy");
var $kVedW = parcelRequire("kVedW");
var $7DpxI = parcelRequire("7DpxI");
var $iDfRT = parcelRequire("iDfRT");
var $13aOI = parcelRequire("13aOI");
var $5BE4e = parcelRequire("5BE4e");
var $lnr9T = parcelRequire("lnr9T");
var $1u7ml = parcelRequire("1u7ml");
var $1Ge5k = parcelRequire("1Ge5k");
var $dvZpe = parcelRequire("dvZpe");
var $9htZc = parcelRequire("9htZc");
var $1UbTw = parcelRequire("1UbTw");
var $8Krw2 = parcelRequire("8Krw2");
var $9fdRd = parcelRequire("9fdRd");
var $37d53fec18fed641$export$2a20daddecce6807 = [
    {
        name: 'link',
        spec: (0, $5BE4e.link)
    },
    {
        name: 'em',
        spec: (0, $kVedW.em)
    },
    {
        name: 'strong',
        spec: (0, $1u7ml.strong)
    },
    {
        name: 'textColor',
        spec: (0, $dvZpe.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $d3ddB.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $lnr9T.strike)
    },
    {
        name: 'subsup',
        spec: (0, $1Ge5k.subsup)
    },
    {
        name: 'underline',
        spec: (0, $1UbTw.underline)
    },
    {
        name: 'code',
        spec: (0, $iVDN9.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $9htZc.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $5fbqs.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $kX1mK.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $31cn2.confluenceInlineComment)
    }
].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((0, $fjUBg.markGroupDeclarations)), [
    {
        name: 'fontSize',
        spec: (0, $7DpxI.fontSize)
    },
    {
        name: 'breakout',
        spec: (0, $66hh0.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $2InDy.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $iDfRT.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $13aOI.indentation)
    },
    {
        name: 'border',
        spec: (0, $5BptP.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $8Krw2.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $9fdRd.unsupportedNodeAttribute)
    }
]);

});
parcelRegister("5fbqs", function(module, exports) {
$parcel$export(module.exports, "alignmentPositionMap", () => $3d173760bc329d8c$export$be9cf49015769bbd);
$parcel$export(module.exports, "alignment", () => $3d173760bc329d8c$export$8e53000a4ec837);

var $P0RMo = parcelRequire("P0RMo");
var $3d173760bc329d8c$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
var $3d173760bc329d8c$export$8e53000a4ec837 = (0, $P0RMo.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: function getAttrs(dom) {
                var align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            'div',
            {
                class: "fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-".concat(mark.attrs.align),
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});

});
parcelRegister("P0RMo", function(module, exports) {
$parcel$export(module.exports, "alignment", () => $09956f961005483e$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $09956f961005483e$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $09956f961005483e$export$8c5a050822fd698c);
$parcel$export(module.exports, "border", () => $09956f961005483e$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $09956f961005483e$export$89015c65f1c75e3f);
$parcel$export(module.exports, "code", () => $09956f961005483e$export$6565f9f03506010b);
$parcel$export(module.exports, "confluenceInlineComment", () => $09956f961005483e$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $09956f961005483e$export$3024f02c495408d6);
$parcel$export(module.exports, "em", () => $09956f961005483e$export$c63c6f932822f543);
$parcel$export(module.exports, "fontSize", () => $09956f961005483e$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "fragment", () => $09956f961005483e$export$f00aeb236b6f05af);
$parcel$export(module.exports, "indentation", () => $09956f961005483e$export$480c699bd4ec0d86);
$parcel$export(module.exports, "link", () => $09956f961005483e$export$9c30223ca0a664fb);
$parcel$export(module.exports, "strike", () => $09956f961005483e$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $09956f961005483e$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $09956f961005483e$export$b3401ee80eb31041);
$parcel$export(module.exports, "textColor", () => $09956f961005483e$export$32f78bffcd82ff28);
$parcel$export(module.exports, "typeAheadQuery", () => $09956f961005483e$export$20af3dabbb5538df);
$parcel$export(module.exports, "underline", () => $09956f961005483e$export$425327af25286e5e);
$parcel$export(module.exports, "unsupportedMark", () => $09956f961005483e$export$30d78d5eb6719bb8);
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $09956f961005483e$export$a316dc07ff5182a2);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "afm workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $4UYyG = parcelRequire("4UYyG");
var $09956f961005483e$export$8e53000a4ec837 = (0, $4UYyG.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
var $09956f961005483e$export$8512c9afa7b24c3b = (0, $4UYyG.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
var $09956f961005483e$export$8c5a050822fd698c = (0, $4UYyG.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
var $09956f961005483e$export$1edee58a52776cd9 = (0, $4UYyG.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
var $09956f961005483e$export$89015c65f1c75e3f = (0, $4UYyG.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
var $09956f961005483e$export$6565f9f03506010b = (0, $4UYyG.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
var $09956f961005483e$export$f3b72f8fc4684ecd = (0, $4UYyG.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
var $09956f961005483e$export$3024f02c495408d6 = (0, $4UYyG.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
var $09956f961005483e$export$c63c6f932822f543 = (0, $4UYyG.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $09956f961005483e$export$85e3c3ca0c6fb93 = (0, $4UYyG.createPMMarkSpecFactory)({
    attrs: {
        fontSize: {}
    }
});
var $09956f961005483e$export$f00aeb236b6f05af = (0, $4UYyG.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
var $09956f961005483e$export$480c699bd4ec0d86 = (0, $4UYyG.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
var $09956f961005483e$export$9c30223ca0a664fb = (0, $4UYyG.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
var $09956f961005483e$export$4899a95d70ec5056 = (0, $4UYyG.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $09956f961005483e$export$59ae2c325a998f89 = (0, $4UYyG.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $09956f961005483e$export$b3401ee80eb31041 = (0, $4UYyG.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
var $09956f961005483e$export$32f78bffcd82ff28 = (0, $4UYyG.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
var $09956f961005483e$export$20af3dabbb5538df = (0, $4UYyG.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
var $09956f961005483e$export$425327af25286e5e = (0, $4UYyG.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $09956f961005483e$export$30d78d5eb6719bb8 = (0, $4UYyG.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
var $09956f961005483e$export$a316dc07ff5182a2 = (0, $4UYyG.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});
parcelRegister("4UYyG", function(module, exports) {
$parcel$export(module.exports, "createPMMarkSpecFactory", () => $394b5e0b763e258b$export$cf5823ed4e9f4c6f);

var $25nEq = parcelRequire("25nEq");
function $394b5e0b763e258b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $394b5e0b763e258b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $394b5e0b763e258b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $394b5e0b763e258b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $394b5e0b763e258b$export$cf5823ed4e9f4c6f = function createPMMarkSpecFactory(markSpec) {
    return function(_ref) {
        var parseDOM = _ref.parseDOM, toDOM = _ref.toDOM, toDebugString = _ref.toDebugString;
        // @ts-ignore
        return $394b5e0b763e258b$var$_objectSpread($394b5e0b763e258b$var$_objectSpread($394b5e0b763e258b$var$_objectSpread($394b5e0b763e258b$var$_objectSpread({}, markSpec), parseDOM && {
            parseDOM: parseDOM
        }), toDOM && {
            toDOM: toDOM
        }), toDebugString && {
            toDebugString: toDebugString
        });
    };
};

});



parcelRegister("kX1mK", function(module, exports) {
$parcel$export(module.exports, "AnnotationTypes", () => $f40a60964fe12a6c$export$94aa2fc69ad33d19);
$parcel$export(module.exports, "AnnotationMarkStates", () => $f40a60964fe12a6c$export$4bab14797673da9f);
$parcel$export(module.exports, "buildDataAttributes", () => $f40a60964fe12a6c$export$93a98caa8bc6cb07);
$parcel$export(module.exports, "annotation", () => $f40a60964fe12a6c$export$8512c9afa7b24c3b);

var $25nEq = parcelRequire("25nEq");

var $P0RMo = parcelRequire("P0RMo");
function $f40a60964fe12a6c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f40a60964fe12a6c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f40a60964fe12a6c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f40a60964fe12a6c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f40a60964fe12a6c$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
var $f40a60964fe12a6c$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $f40a60964fe12a6c$export$93a98caa8bc6cb07(_ref) {
    var id = _ref.id, annotationType = _ref.annotationType, state = _ref.state;
    var data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return $f40a60964fe12a6c$var$_objectSpread($f40a60964fe12a6c$var$_objectSpread({}, data), {}, {
        'data-mark-annotation-state': state
    });
    return data;
}
var $f40a60964fe12a6c$export$8512c9afa7b24c3b = (0, $P0RMo.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        /*
        Data attributes on the DOM node are a temporary means of
        incrementally switching over to the Annotation mark. Once renderer
        provides native support for inline comments the data attributes on the
        DOM nodes will be removed.
      */ return [
            'span',
            $f40a60964fe12a6c$var$_objectSpread({
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation'
            }, $f40a60964fe12a6c$export$93a98caa8bc6cb07({
                id: node.attrs.id,
                annotationType: node.attrs.annotationType
            })),
            0
        ];
    }
});

});

parcelRegister("d3ddB", function(module, exports) {
$parcel$export(module.exports, "backgroundColor", () => $9805cf1429d73941$export$8c5a050822fd698c);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $50U6m = parcelRequire("50U6m");

var $hBDk3 = parcelRequire("hBDk3");

var $P0RMo = parcelRequire("P0RMo");

var $22vaF = parcelRequire("22vaF");

var $cQBqP = parcelRequire("cQBqP");

var $4IQAb = parcelRequire("4IQAb");

var $cXJFA = parcelRequire("cXJFA");

var $dvZpe = parcelRequire("dvZpe");
/**
 * @name backgroundColor_mark
 */ var $9805cf1429d73941$var$colorArrayPalette = [
    [
        (0, $22vaF.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $22vaF.P200),
        'Purple'
    ],
    // token: color.background.accent.purple.subtler
    [
        (0, $22vaF.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $22vaF.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $22vaF.Yellow200),
        'Yellow'
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $22vaF.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $22vaF.T200),
        'Teal'
    ] // token: color.background.accent.teal.subtler
];
var $9805cf1429d73941$var$colorArrayPaletteNew = [
    [
        (0, $22vaF.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $22vaF.B75),
        'Blue'
    ],
    // token: color.background.accent.blue.subtler
    [
        (0, $22vaF.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $22vaF.G75),
        'Green'
    ],
    // token: color.background.accent.green.subtler
    [
        (0, $22vaF.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $22vaF.Yellow200),
        'Yellow'
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $22vaF.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $22vaF.R200),
        'Red'
    ],
    // token: color.background.accent.red.subtler
    [
        (0, $22vaF.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $22vaF.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
var $9805cf1429d73941$export$14ec3f21a268e497 = new Map();
$9805cf1429d73941$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $9805cf1429d73941$export$14ec3f21a268e497.set(color.toLowerCase(), label);
});
var $9805cf1429d73941$var$RGB_PREFIX_BG_COLOR_REGEX = /^rgb/i;
var $9805cf1429d73941$export$5e11ef3de07e2b1 = new Map();
$9805cf1429d73941$var$colorArrayPaletteNew.forEach(function(_ref3) {
    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), color = _ref4[0], label = _ref4[1];
    return $9805cf1429d73941$export$5e11ef3de07e2b1.set(color.toLowerCase(), label);
});
var $9805cf1429d73941$var$isSupportedBackgroundColor = function isSupportedBackgroundColor(hexColor) {
    if ($9805cf1429d73941$export$14ec3f21a268e497.has(hexColor)) return true;
    return (0, $hBDk3.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && $9805cf1429d73941$export$5e11ef3de07e2b1.has(hexColor) && (hexColor !== (0, $22vaF.R200).toLowerCase() || (0, $50U6m.fg)('platform_editor_lovability_text_bg_color_patch_1'));
};
var $9805cf1429d73941$export$8c5a050822fd698c = (0, $P0RMo.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                if (value.match($9805cf1429d73941$var$RGB_PREFIX_BG_COLOR_REGEX)) hexColor = (0, $cXJFA.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $9805cf1429d73941$var$isSupportedBackgroundColor(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $9805cf1429d73941$var$isSupportedBackgroundColor(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $4IQAb.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $dvZpe.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $cQBqP.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, 'data-background-custom-color', mark.attrs.color)
        ];
    }
});

});
parcelRegister("hBDk3", function(module, exports) {
$parcel$export(module.exports, "expValEqualsNoExposure", () => $cd1464fafac10e16$export$63eebf86443a0a61);

var $fu2su = parcelRequire("fu2su");
function $cd1464fafac10e16$export$63eebf86443a0a61(experimentName, experimentParam, experimentExpectedValue) {
    var experimentDefaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return (0, $fu2su.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, false);
}

});
parcelRegister("fu2su", function(module, exports) {
$parcel$export(module.exports, "expValEqualsInternal", () => $b45b908ea6fe3fb7$export$58e581060588c6bb);

var $fqXMt = parcelRequire("fqXMt");

var $8qy01 = parcelRequire("8qy01");

var $6yDV6 = parcelRequire("6yDV6");

var $l0fUo = parcelRequire("l0fUo");
// This internal representation doesn't currently support productKeys
// the way expVal(...) does, this adds temporary support for some keys while
// we determine our preferred approach forward
var $b45b908ea6fe3fb7$var$allowsProductKeys = [
    'cc-maui-experiment',
    'cc_maui_create_keyword',
    'cc_maui_create_keyword_aa',
    'platform_use_unicode_emojis'
];
function $b45b908ea6fe3fb7$export$58e581060588c6bb(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, experimentExposure) {
    var _editorExperimentsCon, _editorExperimentsCon2;
    if ((0, $l0fUo._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $l0fUo._overrides)[experimentName] === experimentExpectedValue;
    // If client is not initialized, we compare with the default value
    if (!(0, $fqXMt.default).initializeCompleted()) return experimentDefaultValue === experimentExpectedValue;
    // Typescript is complaining here about accessing the productKeys property
    var experimentKeyName = $b45b908ea6fe3fb7$var$allowsProductKeys.includes(experimentName) ? (_editorExperimentsCon = (_editorExperimentsCon2 = (0, $6yDV6.editorExperimentsConfig)[experimentName]) === null || _editorExperimentsCon2 === void 0 || (_editorExperimentsCon2 = _editorExperimentsCon2.productKeys) === null || _editorExperimentsCon2 === void 0 ? void 0 : _editorExperimentsCon2[0, $l0fUo._product]) !== null && _editorExperimentsCon !== void 0 ? _editorExperimentsCon : experimentName : experimentName;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $fqXMt.default).getExperimentValue(experimentKeyName, experimentParam, experimentDefaultValue, {
        fireExperimentExposure: experimentExposure
    });
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $fqXMt.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $8qy01.addFeatureFlagAccessed)("".concat(experimentKeyName, ":").concat(experimentParam), experimentValue);
    return experimentValue === experimentExpectedValue;
}

});
parcelRegister("fqXMt", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3c7a7f2a539583a$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $aMpau = parcelRequire("aMpau");

var $22KTL = parcelRequire("22KTL");



var $b3c7a7f2a539583a$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $b3c7a7f2a539583a$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$b3c7a7f2a539583a$var$_FeatureGates = $b3c7a7f2a539583a$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "client", new (0, $aMpau.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$b3c7a7f2a539583a$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $b3c7a7f2a539583a$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $b3c7a7f2a539583a$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$b3c7a7f2a539583a$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $b3c7a7f2a539583a$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $b3c7a7f2a539583a$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "initializeCalled", $b3c7a7f2a539583a$var$_FeatureGates.client.initializeCalled.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "initializeCompleted", $b3c7a7f2a539583a$var$_FeatureGates.client.initializeCompleted.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "waitUntilInitializeCompleted", $b3c7a7f2a539583a$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "initialize", $b3c7a7f2a539583a$var$_FeatureGates.client.initialize.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "initializeWithProvider", $b3c7a7f2a539583a$var$_FeatureGates.client.initializeWithProvider.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "initializeFromValues", $b3c7a7f2a539583a$var$_FeatureGates.client.initializeFromValues.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "manuallyLogGateExposure", $b3c7a7f2a539583a$var$_FeatureGates.client.manuallyLogGateExposure.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "getExperiment", $b3c7a7f2a539583a$var$_FeatureGates.client.getExperiment.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "manuallyLogExperimentExposure", $b3c7a7f2a539583a$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "manuallyLogLayerExposure", $b3c7a7f2a539583a$var$_FeatureGates.client.manuallyLogLayerExposure.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "shutdownStatsig", $b3c7a7f2a539583a$var$_FeatureGates.client.shutdownStatsig.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "overrideGate", $b3c7a7f2a539583a$var$_FeatureGates.client.overrideGate.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "clearGateOverride", $b3c7a7f2a539583a$var$_FeatureGates.client.clearGateOverride.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "overrideConfig", $b3c7a7f2a539583a$var$_FeatureGates.client.overrideConfig.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "clearConfigOverride", $b3c7a7f2a539583a$var$_FeatureGates.client.clearConfigOverride.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "setOverrides", $b3c7a7f2a539583a$var$_FeatureGates.client.setOverrides.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "getOverrides", $b3c7a7f2a539583a$var$_FeatureGates.client.getOverrides.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "clearAllOverrides", $b3c7a7f2a539583a$var$_FeatureGates.client.clearAllOverrides.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "isCurrentUser", $b3c7a7f2a539583a$var$_FeatureGates.client.isCurrentUser.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "onGateUpdated", $b3c7a7f2a539583a$var$_FeatureGates.client.onGateUpdated.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "onExperimentValueUpdated", $b3c7a7f2a539583a$var$_FeatureGates.client.onExperimentValueUpdated.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "onAnyUpdated", $b3c7a7f2a539583a$var$_FeatureGates.client.onAnyUpdated.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "updateUser", $b3c7a7f2a539583a$var$_FeatureGates.client.updateUser.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "updateUserWithProvider", $b3c7a7f2a539583a$var$_FeatureGates.client.updateUserWithProvider.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "updateUserWithValues", $b3c7a7f2a539583a$var$_FeatureGates.client.updateUserWithValues.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "getPackageVersion", $b3c7a7f2a539583a$var$_FeatureGates.client.getPackageVersion.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "getTargetApp", $b3c7a7f2a539583a$var$_FeatureGates.client.getTargetApp.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "getLayer", $b3c7a7f2a539583a$var$_FeatureGates.client.getLayer.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "getLayerValue", $b3c7a7f2a539583a$var$_FeatureGates.client.getLayerValue.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
var $b3c7a7f2a539583a$var$boundFGJS = $b3c7a7f2a539583a$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $b3c7a7f2a539583a$var$FeatureGates;
    else {
        var $b3c7a7f2a539583a$var$_boundFGJS, $b3c7a7f2a539583a$var$_boundFGJS$getPackage;
        $b3c7a7f2a539583a$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $b3c7a7f2a539583a$var$boundVersion = (($b3c7a7f2a539583a$var$_boundFGJS = $b3c7a7f2a539583a$var$boundFGJS) === null || $b3c7a7f2a539583a$var$_boundFGJS === void 0 || ($b3c7a7f2a539583a$var$_boundFGJS$getPackage = $b3c7a7f2a539583a$var$_boundFGJS.getPackageVersion) === null || $b3c7a7f2a539583a$var$_boundFGJS$getPackage === void 0 ? void 0 : $b3c7a7f2a539583a$var$_boundFGJS$getPackage.call($b3c7a7f2a539583a$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($b3c7a7f2a539583a$var$boundVersion !== (0, $22KTL.CLIENT_VERSION)) {
            var $b3c7a7f2a539583a$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($b3c7a7f2a539583a$var$boundVersion, " when module version ").concat((0, $22KTL.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($b3c7a7f2a539583a$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $b3c7a7f2a539583a$export$2e2bcd8739ae039 = $b3c7a7f2a539583a$var$boundFGJS;

});
parcelRegister("aMpau", function(module, exports) {
$parcel$export(module.exports, "Client", () => $7d91e8f8404f7e13$export$1f2bb630327ac4b6);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");

var $344Sl = parcelRequire("344Sl");

var $jtLwS = parcelRequire("jtLwS");

var $213zb = parcelRequire("213zb");

var $7BkNf = parcelRequire("7BkNf");

var $jzOjt = parcelRequire("jzOjt");

var $d4i2e = parcelRequire("d4i2e");

var $kOIhh = parcelRequire("kOIhh");

var $ezbPt = parcelRequire("ezbPt");

var $arraH = parcelRequire("arraH");

var $4DKZE = parcelRequire("4DKZE");

var $1xlm2 = parcelRequire("1xlm2");

var $bUuKi = parcelRequire("bUuKi");

var $eMunP = parcelRequire("eMunP");

var $22KTL = parcelRequire("22KTL");
var $7d91e8f8404f7e13$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $7d91e8f8404f7e13$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7d91e8f8404f7e13$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7d91e8f8404f7e13$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7d91e8f8404f7e13$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7d91e8f8404f7e13$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $7d91e8f8404f7e13$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $7d91e8f8404f7e13$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $4DKZE.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscriptions", new (0, $344Sl.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "dataAdapter", new (0, $arraH.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $4DKZE.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $kOIhh.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 1;
                                    break;
                                }
                                if (!(0, $1xlm2.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $kOIhh.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 1;
                                    break;
                                }
                                if (!(0, $1xlm2.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $22KTL.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $7d91e8f8404f7e13$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $22KTL.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $eMunP.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $kOIhh.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 1;
                                    break;
                                }
                                if (!(0, $1xlm2.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 1:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $kOIhh.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $d4i2e.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 1;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 1:
                                _context5.next = 2;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 2:
                                _context5.next = 3;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 1:
                                if (!this.initCompleted) {
                                    _context7.next = 2;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 2:
                                _context7.next = 3;
                                return this.initPromise;
                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $jtLwS.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $jtLwS.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $7BkNf.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $1xlm2.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $1xlm2.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $7d91e8f8404f7e13$var$_objectSpread({}, clientOptions);
                                if (!clientOptions.localMode) {
                                    _context8.next = 2;
                                    break;
                                }
                                _context8.next = 1;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 1:
                                return _context8.abrupt("return");
                            case 2:
                                _context8.prev = 2;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $d4i2e.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $d4i2e.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 6;
                                break;
                            case 4:
                                _context8.prev = 4;
                                _t = _context8["catch"](2);
                                if (_t instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t === null || _t === void 0 ? void 0 : _t.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t;
                            case 6:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            2,
                            4
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $7d91e8f8404f7e13$var$_objectSpread($7d91e8f8404f7e13$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 2;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 2:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 6;
                                break;
                            case 4:
                                _context9.prev = 4;
                                _t2 = _context9["catch"](1);
                                if (_t2 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t2 === null || _t2 === void 0 ? void 0 : _t2.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t2;
                            case 6:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            4
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, _args0 = arguments, _t3;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $ezbPt.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $7d91e8f8404f7e13$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $7d91e8f8404f7e13$var$_objectSpread($7d91e8f8404f7e13$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $7d91e8f8404f7e13$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $eMunP.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(newClientOptions, $7d91e8f8404f7e13$var$_excluded);
                                frontendUser = (0, $bUuKi.toStatsigUser)(identifiers, customAttributes);
                                this.user = (0, $jzOjt.deepAssign)({}, initializeValues.user, frontendUser);
                                statsigOptions = $7d91e8f8404f7e13$var$_objectSpread($7d91e8f8404f7e13$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 1;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 2;
                                return this.statsigClient.initializeAsync();
                            case 2:
                                _context0.next = 5;
                                break;
                            case 3:
                                _context0.prev = 3;
                                _t3 = _context0["catch"](1);
                                if (_t3 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_t3 === null || _t3 === void 0 ? void 0 : _t3.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($7d91e8f8404f7e13$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 4;
                                return this.statsigClient.initializeAsync();
                            case 4:
                                this.initWithDefaults = true;
                                throw _t3;
                            case 5:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise, _t4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 1:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 2;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 2:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 3;
                                _context10.next = 4;
                                return this.initPromise;
                            case 4:
                                _context10.next = 6;
                                break;
                            case 5:
                                _context10.prev = 5;
                                _t4 = _context10["catch"](3);
                            case 6:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 1;
                                                    break;
                                                }
                                                _context1.next = 1;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 1:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 7:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            3,
                            5
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, frontendUser, _updateUserCompletion, _ref4, errMsg, success, errorMessage, _t5, _t6;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 2;
                                return initializeValuesPromise;
                            case 2:
                                initializeValues = _context11.sent;
                                frontendUser = (0, $bUuKi.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, $jzOjt.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
                                _context11.next = 4;
                                break;
                            case 3:
                                _context11.prev = 3;
                                _t5 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _t5 instanceof Error ? _t5.message : JSON.stringify(_t5);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _t5;
                            case 4:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 5;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 6;
                                    break;
                                }
                                _context11.next = 6;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 6:
                                _context11.next = 8;
                                break;
                            case 7:
                                _context11.prev = 7;
                                _t6 = _context11["catch"](5);
                                success = false;
                                errorMessage = String(_t6);
                            case 8:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 9;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 10;
                                break;
                            case 9:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 10:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            3
                        ],
                        [
                            5,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $22KTL.CLIENT_VERSION;
            }
        },
        {
            key: "getTargetApp",
            value: function getTargetApp() {
                var _this$initOptions2;
                return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $213zb.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $213zb.Layer).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("344Sl", function(module, exports) {
$parcel$export(module.exports, "default", () => $23b586fe23ee954c$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $hLfKH = parcelRequire("hLfKH");
function $23b586fe23ee954c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $23b586fe23ee954c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $23b586fe23ee954c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $23b586fe23ee954c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $23b586fe23ee954c$export$a66cbd9b2289cd78 = '@all-features';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $23b586fe23ee954c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $23b586fe23ee954c$var$_objectSpread($23b586fe23ee954c$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $23b586fe23ee954c$var$_objectSpread($23b586fe23ee954c$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $23b586fe23ee954c$var$_objectSpread($23b586fe23ee954c$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $23b586fe23ee954c$var$_objectSpread($23b586fe23ee954c$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($23b586fe23ee954c$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($23b586fe23ee954c$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($23b586fe23ee954c$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $23b586fe23ee954c$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("jtLwS", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $e2e5980ebbc7649e$export$6dc24881a3d96325);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $jQJJD = parcelRequire("jQJJD");

var $galQK = parcelRequire("galQK");
var $e2e5980ebbc7649e$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $jQJJD.migrateEvaluationDetails)(experiment.details), (0, $galQK.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("jQJJD", function(module, exports) {
$parcel$export(module.exports, "migrateEvaluationDetails", () => $e73659aa8ad7bbf7$export$18ad168d3dbac899);

var $iYJcE = parcelRequire("iYJcE");

var $7BkNf = parcelRequire("7BkNf");
var $e73659aa8ad7bbf7$var$evaluationReasonMappings = Object.entries((0, $7BkNf.EvaluationReason)).map(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $e73659aa8ad7bbf7$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $e73659aa8ad7bbf7$var$evaluationReasonMappings.find(function(_ref3) {
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 1), key = _ref4[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $7BkNf.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};

});
parcelRegister("7BkNf", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $588c1e3b51103826$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $588c1e3b51103826$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
}; // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});


parcelRegister("galQK", function(module, exports) {
$parcel$export(module.exports, "migrateSecondaryExposures", () => $bc4e87678a426191$export$55fd683752d01e67);
var $bc4e87678a426191$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});


parcelRegister("213zb", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $177e70fa7a3ceaa8$export$936d0764594b6eb3);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $jQJJD = parcelRequire("jQJJD");

var $galQK = parcelRequire("galQK");
var $177e70fa7a3ceaa8$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $jQJJD.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $galQK.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $galQK.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("jzOjt", function(module, exports) {
$parcel$export(module.exports, "deepAssign", () => $e408505bfcad1f3f$export$1148cb79ceecd5fa);

var $ekGgq = parcelRequire("ekGgq");

var $iYJcE = parcelRequire("iYJcE");

var $fC8ib = parcelRequire("fC8ib");
function $e408505bfcad1f3f$export$1148cb79ceecd5fa(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return $e408505bfcad1f3f$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sources)));
    for(var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], src = _Object$entries$_i[1];
        var dst = target[key];
        var srcIsObj = src && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(src) === 'object' && !Array.isArray(src);
        var dstIsObj = dst && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(dst) === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $e408505bfcad1f3f$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $e408505bfcad1f3f$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sources)));
}

});

parcelRegister("d4i2e", function(module, exports) {
$parcel$export(module.exports, "default", () => $9839a3716788087d$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $eMunP = parcelRequire("eMunP");

var $22KTL = parcelRequire("22KTL");

var $ebTPO = parcelRequire("ebTPO");
function $9839a3716788087d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9839a3716788087d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9839a3716788087d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9839a3716788087d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9839a3716788087d$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $9839a3716788087d$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $9839a3716788087d$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $9839a3716788087d$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $9839a3716788087d$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $9839a3716788087d$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $9839a3716788087d$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $9839a3716788087d$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $9839a3716788087d$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $9839a3716788087d$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $9839a3716788087d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(fetcherOptions) {
                    var targetApp, url, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 1;
                                _context.next = 2;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                                _context.prev = 3;
                                _t = _context["catch"](1);
                                if (!(_t instanceof Error)) {
                                    _context.next = 4;
                                    break;
                                }
                                throw _t;
                            case 4:
                                throw Error('Failed to retrieve client sdk key');
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 2;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                                _context2.prev = 3;
                                _t2 = _context2["catch"](1);
                                if (!(_t2 instanceof Error)) {
                                    _context2.next = 4;
                                    break;
                                }
                                throw _t2;
                            case 4:
                                throw Error('Failed to retrieve experiment values');
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 2;
                                    break;
                                }
                                _context3.next = 1;
                                return response.text();
                            case 1:
                                body = _context3.sent;
                                throw new (0, $ebTPO.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 2:
                                if (!(response.status === 204)) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new (0, $ebTPO.ResponseError)('Unexpected 204 response');
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return response.text();
                            case 1:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $9839a3716788087d$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $eMunP.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $eMunP.FeatureGateEnvironment).Production:
                        return $9839a3716788087d$export$18c93900db9358a4;
                    case (0, $eMunP.FeatureGateEnvironment).Staging:
                        return $9839a3716788087d$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $eMunP.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $eMunP.FeatureGateEnvironment).Development:
                        return $9839a3716788087d$export$f058dbf75c3bc647;
                    case (0, $eMunP.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $9839a3716788087d$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $9839a3716788087d$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $9839a3716788087d$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 1;
                                return fetch("".concat(baseUrl).concat(path), $9839a3716788087d$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $22KTL.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 1:
                                response = _context5.sent;
                                _context5.next = 2;
                                return this.handleResponseError(response);
                            case 2:
                                _context5.next = 3;
                                return this.extractResponseBody(response);
                            case 3:
                                return _context5.abrupt("return", _context5.sent);
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $9839a3716788087d$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($9839a3716788087d$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($9839a3716788087d$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("eMunP", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $ac2d1de1269ff12a$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $ac2d1de1269ff12a$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $ac2d1de1269ff12a$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
var $ac2d1de1269ff12a$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
var $ac2d1de1269ff12a$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});

parcelRegister("22KTL", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $17d025b3b9d0326b$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $17d025b3b9d0326b$export$a59f8d67326bd1cb = "6.0.2";

});

parcelRegister("ebTPO", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $a54d6764462409b5$export$286baf652d0b1206);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $a54d6764462409b5$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $a54d6764462409b5$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $a54d6764462409b5$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a54d6764462409b5$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $a54d6764462409b5$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ResponseError);
        return $a54d6764462409b5$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});


parcelRegister("kOIhh", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $f27ad2c74a954c85$export$d119b37e5f788b43);

var $25nEq = parcelRequire("25nEq");

var $ygbGG = parcelRequire("ygbGG");

var $eMunP = parcelRequire("eMunP");
function $f27ad2c74a954c85$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f27ad2c74a954c85$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f27ad2c74a954c85$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f27ad2c74a954c85$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f27ad2c74a954c85$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $f27ad2c74a954c85$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $ygbGG.isFedRamp)() ? (0, $eMunP.PerimeterType).FEDRAMP_MODERATE : (0, $eMunP.PerimeterType).COMMERCIAL
    }, options);
};

});

parcelRegister("ezbPt", function(module, exports) {
$parcel$export(module.exports, "migrateInitializationOptions", () => $a9ad8296cdf390b7$export$202946b690d26d22);

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");
var $a9ad8296cdf390b7$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $a9ad8296cdf390b7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a9ad8296cdf390b7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a9ad8296cdf390b7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a9ad8296cdf390b7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a9ad8296cdf390b7$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(options, $a9ad8296cdf390b7$var$_excluded);
    return $a9ad8296cdf390b7$var$_objectSpread($a9ad8296cdf390b7$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};

});

parcelRegister("arraH", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $79a180b0983ea59d$export$55fffef3474104af);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");
function $79a180b0983ea59d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $79a180b0983ea59d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $79a180b0983ea59d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $79a180b0983ea59d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $79a180b0983ea59d$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $79a180b0983ea59d$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $79a180b0983ea59d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($79a180b0983ea59d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $79a180b0983ea59d$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $79a180b0983ea59d$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoFetchDataAdapter);
        _this = $79a180b0983ea59d$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $79a180b0983ea59d$var$_objectSpread($79a180b0983ea59d$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $79a180b0983ea59d$var$_objectSpread($79a180b0983ea59d$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $79a180b0983ea59d$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $79a180b0983ea59d$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));

});

parcelRegister("4DKZE", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $360f41ddaec7fd76$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $360f41ddaec7fd76$export$bcb28fbac1def494);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $dtn6l = parcelRequire("dtn6l");
function $360f41ddaec7fd76$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $360f41ddaec7fd76$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $360f41ddaec7fd76$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $360f41ddaec7fd76$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $360f41ddaec7fd76$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $360f41ddaec7fd76$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $360f41ddaec7fd76$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $360f41ddaec7fd76$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $360f41ddaec7fd76$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $360f41ddaec7fd76$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $360f41ddaec7fd76$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $360f41ddaec7fd76$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $360f41ddaec7fd76$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $360f41ddaec7fd76$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $360f41ddaec7fd76$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $360f41ddaec7fd76$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PersistentOverrideAdapter);
        this._overrides = $360f41ddaec7fd76$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $360f41ddaec7fd76$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $360f41ddaec7fd76$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $360f41ddaec7fd76$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($360f41ddaec7fd76$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.removeItem($360f41ddaec7fd76$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $360f41ddaec7fd76$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $360f41ddaec7fd76$var$_objectSpread($360f41ddaec7fd76$var$_objectSpread({}, $360f41ddaec7fd76$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($360f41ddaec7fd76$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($360f41ddaec7fd76$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($360f41ddaec7fd76$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($360f41ddaec7fd76$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $360f41ddaec7fd76$var$_objectSpread($360f41ddaec7fd76$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $360f41ddaec7fd76$var$_objectSpread($360f41ddaec7fd76$var$_objectSpread({}, current.details), {}, {
                        reason: $360f41ddaec7fd76$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($360f41ddaec7fd76$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($360f41ddaec7fd76$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($360f41ddaec7fd76$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($360f41ddaec7fd76$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($360f41ddaec7fd76$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($360f41ddaec7fd76$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $360f41ddaec7fd76$var$makeEmptyStore();
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($360f41ddaec7fd76$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $360f41ddaec7fd76$var$_objectSpread($360f41ddaec7fd76$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $360f41ddaec7fd76$var$_objectSpread($360f41ddaec7fd76$var$_objectSpread({}, current.details), {}, {
                        reason: $360f41ddaec7fd76$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($360f41ddaec7fd76$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $360f41ddaec7fd76$var$_objectSpread($360f41ddaec7fd76$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $360f41ddaec7fd76$var$_objectSpread($360f41ddaec7fd76$var$_objectSpread({}, current.details), {}, {
                        reason: $360f41ddaec7fd76$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});

parcelRegister("1xlm2", function(module, exports) {
$parcel$export(module.exports, "shallowEquals", () => $11e9700ba07a94ec$export$fa1c2bbf4100b8bc);

var $iYJcE = parcelRequire("iYJcE");
var $11e9700ba07a94ec$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};

});

parcelRegister("bUuKi", function(module, exports) {
$parcel$export(module.exports, "toStatsigUser", () => $8abcc62178a2b1dc$export$3dad1db244472f32);

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");
var $8abcc62178a2b1dc$var$_excluded = [
    "stableId"
];
function $8abcc62178a2b1dc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8abcc62178a2b1dc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8abcc62178a2b1dc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8abcc62178a2b1dc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8abcc62178a2b1dc$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    var stableId = identifiers.stableId, otherIdentifiers = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(identifiers, $8abcc62178a2b1dc$var$_excluded);
    var user = {
        customIDs: $8abcc62178a2b1dc$var$_objectSpread($8abcc62178a2b1dc$var$_objectSpread({}, otherIdentifiers), stableId !== undefined ? {
            stableID: stableId
        } : {}),
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};

});



parcelRegister("6yDV6", function(module, exports) {
$parcel$export(module.exports, "editorExperimentsConfig", () => $4c64e2512c93a0fc$export$6cbb856f286b07ef);
/* eslint-disable perfectionist/sort-object-types */ /* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $2cO7g = parcelRequire("2cO7g");

var $9NnIe = parcelRequire("9NnIe");
var $4c64e2512c93a0fc$export$5c897d5297c5b7fd = [
    'platform_editor_blocks',
    'platform_editor_controls',
    'advanced_layouts',
    'single_column_layouts',
    'platform_editor_preview_panel_responsiveness',
    'platform_editor_toolbar_aifc'
];
var $4c64e2512c93a0fc$export$6cbb856f286b07ef = {
    // new format to avoid collisions with other users when updating the file
    // Added 2026-07-18
    cc_maui_remix_button_hover_corridor: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_remix_button_hover_corridor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-24
    platform_editor_layout_column_delete_shortcut_fix: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_delete_shortcut_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-21
    // `isEnabled` is the gating param; the experiment's dynamic config also carries the numeric
    // `shimmerDurationMs` (skeleton) and `highlightDurationMs` (purple highlight) durations, read at
    // runtime via `expVal`.
    platform_editor_agent_be_streaming: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_agent_be_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Editor Platform experiments
    // lwoollard experiments
    // Added 2026-04-21
    cwr_page_tree_auto_finalize: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr_page_tree_auto_finalize'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 02-12-2025
    cc_fix_hydration_ttvc: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_hydration_ttvc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    'editor_a11y__enghealth-46814_fy26': (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y__enghealth-46814_fy26'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19
    'enghealth-53346_fix_redaction_marker_editor': (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            jira: 'enghealth-53346_fix_redaction_marker_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-16
    platform_editor_remove_important_in_render_ext: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_important_in_render_ext'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-06
    confluence_comment_nudgebar_improvement: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_comment_nudgebar_improvement'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_quick_insert_embeds: (0, $9NnIe.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_quick_insert_embeds'
        },
        param: 'cohort',
        values: [
            'control',
            'prioritizeLinkInQIM',
            'prioritizeEmbedInQIM'
        ],
        defaultValue: 'control'
    }),
    confluence_remix_icon_right_side: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_remix_icon_right_side'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_editor_insm_doc_size_stats: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_doc_size_stats'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-26
    cc_editor_fix_insm_inp_buffer: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_fix_insm_inp_buffer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    cwr_blank_object_experiment: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr_blank_object_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-08
    confluence_inline_comments_fix_stale_selection: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_inline_comments_fix_stale_selection'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    rovo_remix_experience_context: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'rovo_remix_experience_context'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-05
    'databases-native-embeds-v2': (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'databases-native-embeds-v2'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    cc_editor_insm_outlier_events: (0, $9NnIe.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_outlier_events'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-17
    platform_editor_renderer_extension_width_fix: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_extension_width_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-24
    platform_editor_media_external_badge_bbc_fix: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_external_badge_bbc_fix',
            bitbucket: 'platform_editor_media_external_badge_bbc_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-20
    platform_editor_annotations_sync_on_docchange: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_annotations_sync_on_docchange'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $9NnIe.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_per_plugin_error_boundary: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_per_plugin_error_boundary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-05
    'company_hub_carousel_thumbnails-refactor': (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'company_hub_carousel_thumbnails-refactor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $9NnIe.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_paste_actions_menu: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-19
    platform_editor_controls_reliable_anchor: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_reliable_anchor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $9NnIe.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls',
            jira: 'platform_editor_controls_jira'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-07-21
    confluence_cwr_3p_connection_suggested_prompts: (0, $9NnIe.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_cwr_3p_connection_suggested_prompts'
        },
        param: 'cohort',
        values: [
            'control',
            'variant_a',
            'variant_b'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-05-26
    platform_editor_agent_mentions: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_agent_mentions',
            jira: 'platform_editor_agent_mentions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    platform_editor_reduced_agent_profile_cards: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_reduced_agent_profile_cards',
            jira: 'platform_editor_reduced_agent_profile_cards'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-30
    platform_editor_fix_link_paste_menu: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_link_paste_menu',
            jira: 'platform_editor_fix_link_paste_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_code_block_q4_lovability: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_code_block_q4_lovability',
            jira: 'platform_editor_code_block_q4_lovability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-16
    platform_editor_enable_single_player_step_merging: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enable_single_player_step_merging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_hide_overflow_menu: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_hide_overflow_menu',
            jira: 'platform_editor_toolbar_hide_overflow_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_responsiveness'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $9NnIe.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-06-25
    jira_editor_a11y_toolbar_fixes: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'jira_editor_a11y_toolbar_fixes',
            jira: 'jira_editor_a11y_toolbar_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-09
    platform_editor_blocks: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocks_conf',
            jira: 'platform_editor_blocks_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-23
    //Added 2025-07-16
    platform_editor_toolbar_aifc: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_confluence'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_breakout_interaction_rerender: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_interaction_rerender'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_blocktaskitem_node_tenantid: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_node_tenantid'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_with_dnd: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_with_dnd'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    'editor-a11y-fy26-keyboard-move-row-column': (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor-a11y-fy26-keyboard-move-row-column',
            jira: 'editor-a11y-fy26-keyboard-move-row-column'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-28
    editor_enable_image_alignment_in_expand: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enable_image_alignment_in_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_august_a11y: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_august_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-01
    cc_editor_ai_content_mode: (0, $9NnIe.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_ai_content_mode'
        },
        param: 'variant',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-01-09
    platform_editor_render_bodied_extension_as_inline: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_render_bodied_extension_as_inline'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-03
    platform_editor_ai_quick_prompt_iw_cc: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quick_prompt_iw_cc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_use_llm_space_recommendations: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_llm_space_recommendations'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-01
    // Added 2025-10-13
    platform_editor_media_error_analytics: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_error_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-27
    platform_editor_table_sticky_header_improvements: (0, $9NnIe.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_improvements'
        },
        param: 'cohort',
        values: [
            'control',
            'test_with_overflow',
            'test_without_overflow'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-29
    platform_editor_lovability_inline_code: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_inline_code'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_lovability_emoji_scaling: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_emoji_scaling'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-18
    editor_a11y_7152_profile_card_tab_order: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y_7152_profile_card_tab_order'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-19
    platform_editor_lovability_navigation_fixes: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_navigation_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-27 — Pre-auth unauthorised inline hover card UX
    platform_sl_3p_preauth_better_hovercard: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_preauth_better_hovercard',
            jira: 'platform_sl_3p_preauth_better_hovercard'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-21 — Post-auth GDrive Smart Link to Rovo Chat auto-open
    platform_sl_3p_post_auth_chat_open_exp: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_post_auth_chat_open_exp',
            jira: 'platform_sl_3p_post_auth_chat_open_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-29 — Social proof inline CTA for unauthorised 3P inline smart links
    platform_sl_3p_preauth_social_proof_inline_cta: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_preauth_social_proof_inline_cta',
            jira: 'platform_sl_3p_preauth_social_proof_inline_cta'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15 — Embed card footer rovo action for resolved 3P smart links in confluence
    platform_sl_3p_auth_rovo_embed_footer_exp: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_auth_rovo_embed_footer_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_submenu_open_click: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_submenu_open_click'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-13
    platform_editor_hide_extension_renderer_support: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hide_extension_renderer_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-23
    platform_editor_fix_new_line_after_heading: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_new_line_after_heading',
            jira: 'platform_editor_fix_new_line_after_heading'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-21
    platform_editor_copy_link_a11y_inconsistency_fix: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_copy_link_a11y_inconsistency_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_editor_fix_lagging_embed_resize_handle: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_lagging_embed_resize_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-30
    platform_editor_fix_cross_origin_editor_focus: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_cross_origin_editor_focus'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_ttvc_inline_extensions: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_ttvc_inline_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-03
    platform_editor_enghealth_a11y_jan_fixes: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enghealth_a11y_jan_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    cc_fd_db_top_editor_toolbar: (0, $9NnIe.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_fd_db_top_editor_toolbar'
        },
        param: 'cohort',
        values: [
            'control',
            'new-description',
            'orig-description'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-04-01
    cc_page_experiences_editor_image_generation: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_page_experiences_editor_image_generation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-23
    'cc-maui-experiment': (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-maui-experiment',
            jira: 'jira_maui_remix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_maui_create_keyword: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_create_keyword'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // A/A experiment paired with cc_maui_create_keyword, used only to balance exposures.
    cc_maui_create_keyword_aa: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_create_keyword_aa'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-13
    confluence_native_tabs_experiment: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_native_tabs_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-29
    cc_maui_polish_changes_batch_4: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_polish_changes_batch_4'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    'cc-mui-slides-experiment': (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-mui-slides-experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-27
    confluence_frontend_cwr_outcome_type_picker: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_frontend_cwr_outcome_type_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    cfe_cwr_outcome_picker_respect_site_settings: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'cfe_cwr_outcome_picker_respect_site_settings'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-12
    prompt_tile_content_type_localizaiton: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'prompt_tile_content_type_localizaiton'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-24
    'cwr-modal-ui-refresh': (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-modal-ui-refresh'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-08
    'cc-disambiguation-in-cwr': (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-disambiguation-in-cwr'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    'cwr-reduce-prompt-suggestion-max-chars': (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-reduce-prompt-suggestion-max-chars'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15
    'cwr-staging-area-close-as-minimize-button': (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-staging-area-close-as-minimize-button'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-08
    cc_cwr_prompt_strength_indicator: (0, $9NnIe.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_cwr_prompt_strength_indicator'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1',
            'variant2'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-02-12
    platform_editor_a11y_escape_link_dialog: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_a11y_escape_link_dialog',
            jira: 'platform_editor_a11y_escape_link_dialog'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_vc90_transition_panel_icon: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vc90_transition_panel_icon'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_emoji_default_scale: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_default_scale',
            jira: 'platform_editor_emoji_default_scale'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-17
    platform_editor_emoji_hover_show_tooltip: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_hover_show_tooltip',
            jira: 'platform_editor_emoji_hover_show_tooltip'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    platform_teamoji_26_refresh_emoji_picker: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_teamoji_26_refresh_emoji_picker',
            jira: 'platform_teamoji_26_refresh_emoji_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-16
    platform_use_unicode_emojis: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_unicode_emojis_confluence',
            jira: 'platform_use_unicode_emojis_jira',
            bitbucket: 'platform_use_unicode_emojis_bitbucket'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-26
    platform_editor_toolbar_update_jira_config: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_toolbar_update_jira_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_ai_blockmenu_integration: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_blockmenu_integration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-26
    platform_editor_remix_in_block_menu: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remix_in_block_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19 — fix table text length calculation for Remix/Improve Writing hero prompts
    remix_iw_block_menu_table_calc_fix: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'remix_iw_block_menu_table_calc_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_rovobutton_smartlink_toolbar_exp: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_rovobutton_smartlink_toolbar_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    confluence_fe_renderer_inline_node_mark_color_fix: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_renderer_inline_node_mark_color_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_diff_plugin_extended: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_diff_plugin_extended'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_fix_media_toolbar_border_dropdown: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_media_toolbar_border_dropdown'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-06
    platform_editor_single_player_expand: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_player_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_fit_to_content_on_demand: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_fit_to_content_on_demand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-09
    platform_editor_remove_collab_step_metrics: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_collab_step_metrics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    platform_editor_ai_normalized_telemetry: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_normalized_telemetry'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-15
    platform_editor_sync_block_ssr_config: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_sync_block_ssr_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-06
    confluence_fe_create_page_suggestion: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_create_page_suggestion'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-18
    platform_editor_selection_toolbar_block_handle: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_selection_toolbar_block_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    platform_editor_improve_preset_builder_logging: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_improve_preset_builder_logging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-23
    'cc-markdown-mode': (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-markdown-mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_ai_xstate_migration: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_xstate_migration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-31
    platform_editor_dnd_accessibility_fixes_expand: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_dnd_accessibility_fixes_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-15
    platform_editor_ai_no_stream_skip_pacer: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_no_stream_skip_pacer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-07
    platform_editor_layout_column_menu: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-29
    platform_editor_layout_column_selection_fix: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_selection_fix',
            jira: 'platform_editor_layout_column_selection_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15
    platform_editor_layout_column_valign_rendering: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_valign_rendering'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    platform_editor_external_embed_grid_fix: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_external_embed_grid_fix',
            jira: 'platform_editor_external_embed_grid_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-08
    cc_fd_wb_jira_quick_insert_experiment: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            jira: 'cc_fd_wb_jira_quick_insert_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-30
    cc_fix_editor_context_on_cwr_followups: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_editor_context_on_cwr_followups'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    cc_fix_ephemeral_preview_staging_area_registration: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_ephemeral_preview_staging_area_registration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    platform_editor_hydration_skip_react_portal: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hydration_skip_react_portal'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-28
    platform_editor_use_markdown_plus_parser: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_markdown_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_use_html_plus_parser: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_html_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    platform_editor_core_static_css: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_static_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_core_non_ecc_static_css: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_non_ecc_static_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_q4_loveability: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_q4_loveability',
            jira: 'platform_editor_table_q4_loveability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    platform_editor_table_menu_updates: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_menu_updates',
            jira: 'platform_editor_table_menu_updates'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-06
    confluence_live_doc_table_sort_bugfix: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_live_doc_table_sort_bugfix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    confluence_fe_disable_comment_if_offline_fix: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_disable_comment_if_offline_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    platform_editor_sync_block_activation: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_sync_block_activation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_paste_actions_menu_v2: (0, $9NnIe.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu_v2',
            jira: 'platform_editor_paste_actions_menu_v2'
        },
        param: 'variant',
        values: [
            'control',
            'hasSpellingAndGrammar',
            'hasAltAiActions'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-05-01 — Social proof experiment for unauthorized 3P block cards
    social_proof_3p_unauth_block_exp: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'social_proof_3p_unauth_block_exp',
            jira: 'social_proof_3p_unauth_block_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_replace_doc/setup
    platform_editor_ai_replace_doc: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_replace_doc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-18
    platform_editor_nest_table_in_panel: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nest_table_in_panel'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_rovo_support_create_inline_comment: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_rovo_support_create_inline_comment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_fix_sticky_header_malfunction: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_sticky_header_malfunction'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-17
    platform_editor_fix_sticky_header_row: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_sticky_header_row'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-10
    confluence_editor_paste_3p_link_actions_menu: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_paste_3p_link_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-29
    'a11y-fixes-week3-may-2026': (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'a11y-fixes-week3-may-2026',
            jira: 'a11y-fixes-week3-may-2026'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_reactions_selector_list: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_reactions_selector_list',
            jira: 'platform_a11y_fixes_reactions_selector_list'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_emoji_picker_list: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_emoji_picker_list',
            jira: 'platform_a11y_fixes_emoji_picker_list'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_emoji_title_shortname: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_emoji_title_shortname',
            jira: 'platform_a11y_fixes_emoji_title_shortname'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-25
    // HTML+ v2 incremental tool-call streaming contract — gates the new
    // PartialStreamParserV2 / ToolCallProcessorV2 / AdfChunkStrategyV2 stack
    // in `@atlassian/editor-rovo-bridge`, the `replaceValue` orchestrator
    // action, and the `toolCallsStreaming.supportsProvisionalToolCalls`
    // capability advert on `PageContentCommandResult`.
    platform_editor_use_html_plus_streaming_parser: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_html_plus_streaming_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_wide_slash_trigger: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_wide_slash_trigger'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11 — [CCI-15904] New AIFC Editor Experience (Full Page Staging Area + Post Stream Review Toolbar)
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_new_aifc_editor_experience/setup
    platform_editor_ai_new_aifc_editor_experience: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_new_aifc_editor_experience'
        },
        param: 'isBackendReviewMomentEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    // Gates the `GhostIconWave` animation primitive in
    // `@atlassian/rovo-platform-ui-components` — rendered as a loading cue on
    // Confluence's 3p-in-CWR (Rovo) surfaces. When off the primitive renders
    // nothing.
    confluence_3p_in_cwr_ghost_icons: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_3p_in_cwr_ghost_icons'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    platform_editor_lovability_text_bg_color: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_text_bg_color',
            jira: 'platform_editor_lovability_text_bg_color'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-20
    platform_editor_ssr_toolbar_optimistic: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ssr_toolbar_optimistic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19
    platform_editor_lovability_resize_dividers_panels: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_resize_dividers_panels'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_editor_add_breakout_marks_on_page_load: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_breakout_marks_on_page_load'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-23
    'aifc-confluence-editor-csp-fix': (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'aifc-confluence-editor-csp-fix',
            jira: 'aifc-confluence-editor-csp-fix'
        },
        param: 'value',
        defaultValue: false
    }),
    // Added 2026-07-01
    platform_editor_remove_pause_streaming: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_pause_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-17
    revert_remix_ephemeral_iframe_sizing_fix: (0, $2cO7g.createBooleanExperiment)({
        productKeys: {
            confluence: 'revert_remix_ephemeral_iframe_sizing_fix',
            jira: 'revert_remix_ephemeral_iframe_sizing_fix'
        },
        param: 'value',
        defaultValue: false
    }),
    // Added 2026-07-28
    cwr_publish_flow_live_doc_toggle_exp: (0, $9NnIe.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cwr_publish_flow_live_doc_toggle_exp'
        },
        param: 'cohort',
        defaultValue: 'control',
        values: [
            'control',
            'variantA',
            'variantB',
            'variantC'
        ]
    })
};

});
parcelRegister("2cO7g", function(module, exports) {
$parcel$export(module.exports, "createBooleanExperiment", () => $19b393cbecde60c2$export$456f1587c9c92021);

var $25nEq = parcelRequire("25nEq");

var $2YIAC = parcelRequire("2YIAC");
function $19b393cbecde60c2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $19b393cbecde60c2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $19b393cbecde60c2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $19b393cbecde60c2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $19b393cbecde60c2$export$456f1587c9c92021(config) {
    return $19b393cbecde60c2$var$_objectSpread($19b393cbecde60c2$var$_objectSpread({}, config), {}, {
        typeGuard: (0, $2YIAC.isBoolean),
        defaultValue: config.defaultValue
    });
}

});
parcelRegister("2YIAC", function(module, exports) {
$parcel$export(module.exports, "isBoolean", () => $22b3c5eff10d24ad$export$f9ce7b637dfbe238);
function $22b3c5eff10d24ad$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}

});


parcelRegister("9NnIe", function(module, exports) {
$parcel$export(module.exports, "createMultivariateExperiment", () => $721b1575bbf17975$export$fb89e8a786694d1);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $e6NXC = parcelRequire("e6NXC");
function $721b1575bbf17975$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $721b1575bbf17975$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $721b1575bbf17975$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $721b1575bbf17975$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $721b1575bbf17975$export$fb89e8a786694d1(config) {
    var values = config.values;
    return $721b1575bbf17975$var$_objectSpread($721b1575bbf17975$var$_objectSpread({}, config), {}, {
        values: (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(values),
        // Maintains the tuple
        typeGuard: (0, $e6NXC.oneOf)(config.values),
        defaultValue: config.defaultValue
    });
}

});
parcelRegister("e6NXC", function(module, exports) {
$parcel$export(module.exports, "oneOf", () => $a4586157607aafe3$export$a9a18ae5ba42aeab);

var $3ZMUU = parcelRequire("3ZMUU");
var $a4586157607aafe3$var$_process, $a4586157607aafe3$var$_process2;
var $a4586157607aafe3$var$IS_TESTING_ENV = typeof $3ZMUU !== 'undefined' && ((($a4586157607aafe3$var$_process = $3ZMUU) === null || $a4586157607aafe3$var$_process === void 0 || ($a4586157607aafe3$var$_process = $a4586157607aafe3$var$_process.env) === null || $a4586157607aafe3$var$_process === void 0 ? void 0 : $a4586157607aafe3$var$_process.NODE_ENV) === 'test' || (($a4586157607aafe3$var$_process2 = $3ZMUU) === null || $a4586157607aafe3$var$_process2 === void 0 || ($a4586157607aafe3$var$_process2 = $a4586157607aafe3$var$_process2.env) === null || $a4586157607aafe3$var$_process2 === void 0 ? void 0 : $a4586157607aafe3$var$_process2.JEST_WORKER_ID) !== undefined);
function $a4586157607aafe3$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
   * This is used by test utils to get the variants when running describe.each
   */ if ($a4586157607aafe3$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}

});



parcelRegister("l0fUo", function(module, exports) {
$parcel$export(module.exports, "_overrides", () => $f4a5f031930080e6$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_product", () => $f4a5f031930080e6$export$cf7305fc65acbf0d);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $hNWO3 = parcelRequire("hNWO3");

var $6yDV6 = parcelRequire("6yDV6");
function $f4a5f031930080e6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f4a5f031930080e6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f4a5f031930080e6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f4a5f031930080e6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f4a5f031930080e6$export$e5d73bf4f8e2ae96 = {};
var $f4a5f031930080e6$export$4e849416bb5c5b52 = {};
var $f4a5f031930080e6$export$cf7305fc65acbf0d;
function $f4a5f031930080e6$export$1c2b6dbf79eb3560(product, /**
 * Overrides are used to set the group of an experiment for testing purposes.
 * This is useful when you want to test a specific experiment group.
 */ groupOverrides, /**
 * Param overrides are used to set the experiment parameters for testing purposes.
 * This is useful when you want to tweak the experiment parameters for testing.
 */ paramOverrides, options) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        groupOverrides = Object.entries(groupOverrides).reduce(function(acc, _ref) {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
            var config = (0, $6yDV6.editorExperimentsConfig)[key];
            if (config) acc = $f4a5f031930080e6$var$_objectSpread($f4a5f031930080e6$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, config.typeGuard(value) ? value : config.defaultValue));
            return acc;
        }, {});
        $f4a5f031930080e6$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test' && !(options !== null && options !== void 0 && options.disableTestOverrides)) {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        var testOverrides = Object.fromEntries(Object.entries((0, $6yDV6.editorExperimentsConfig)).map(function(_ref3) {
            var _ref5, _ref6, _groupOverrides, _groupOverrides2;
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), key = _ref4[0], value = _ref4[1];
            var defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                (_ref5 = (_ref6 = (_groupOverrides = (_groupOverrides2 = groupOverrides) === null || _groupOverrides2 === void 0 ? void 0 : _groupOverrides2[key]) !== null && _groupOverrides !== void 0 ? _groupOverrides : (0, $hNWO3.testMultivariateOverrides)[key]) !== null && _ref6 !== void 0 ? _ref6 : (0, $hNWO3.testBooleanOverrides)[key]) !== null && _ref5 !== void 0 ? _ref5 : defaultValue
            ];
        }));
        $f4a5f031930080e6$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $f4a5f031930080e6$export$cf7305fc65acbf0d = product;
    $f4a5f031930080e6$export$4e849416bb5c5b52 = paramOverrides || {};
}

});
parcelRegister("hNWO3", function(module, exports) {
$parcel$export(module.exports, "testMultivariateOverrides", () => $cf64a0f7842ff334$export$7e849a84a00ffd1c);
$parcel$export(module.exports, "testBooleanOverrides", () => $cf64a0f7842ff334$export$54960937bb713f97);
var $cf64a0f7842ff334$export$7e849a84a00ffd1c = {
    cwr_publish_flow_live_doc_toggle_exp: 'control',
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_controls: 'control',
    cc_editor_ai_content_mode: 'control',
    platform_hover_card_preview_panel: 'control',
    cc_editor_insm_outlier_events: 'test',
    platform_editor_table_sticky_header_improvements: 'test_with_overflow',
    cc_fd_db_top_editor_toolbar: 'control',
    platform_editor_paste_actions_menu_v2: 'control',
    confluence_quick_insert_embeds: 'control',
    cc_cwr_prompt_strength_indicator: 'control',
    confluence_cwr_3p_connection_suggested_prompts: 'control'
};
var $cf64a0f7842ff334$export$54960937bb713f97 = {
    cc_maui_polish_changes_batch_4: false,
    social_proof_3p_unauth_block_exp: false,
    platform_sl_3p_preauth_better_hovercard: true,
    cwr_blank_object_experiment: false,
    platform_editor_preview_panel_responsiveness: false,
    'enghealth-53346_fix_redaction_marker_editor': false,
    platform_editor_toolbar_aifc: false,
    'test-new-experiments-package': false,
    platform_renderer_table_sticky_scrollbar: false,
    advanced_layouts: false,
    single_column_layouts: false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_editor_tables_table_selector: false,
    platform_renderer_fix_analytics_memo_callback: false,
    'jira-work-sync-desc-comment-summary': false,
    platform_editor_breakout_resizing: false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_enable_single_player_step_merging: false,
    platform_editor_paste_actions_menu: false,
    platform_editor_table_fit_to_content_on_demand: false,
    platform_editor_table_q4_loveability: false,
    platform_editor_table_menu_updates: false,
    'cwr-modal-ui-refresh': false,
    'cc-disambiguation-in-cwr': false,
    'cwr-reduce-prompt-suggestion-max-chars': false,
    'cwr-staging-area-close-as-minimize-button': false,
    prompt_tile_content_type_localizaiton: false,
    // [CCI-15904] New AIFC Editor Experience — read by the inline chat prompt view
    // in `conversation-assistant-chat-prompt-input`. Review moment eligibility is a
    // separate check (`editor-plugin-ai/src/ui/utils/review-moment-enabled.ts`) and
    // does not read this key.
    platform_editor_ai_new_aifc_editor_experience: false,
    cc_page_experiences_editor_image_generation: false,
    platform_use_unicode_emojis: false,
    platform_editor_emoji_hover_show_tooltip: false,
    'aifc-confluence-editor-csp-fix': false
};

});




parcelRegister("22vaF", function(module, exports) {
$parcel$export(module.exports, "R50", () => $17c3f295c13f82d8$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $17c3f295c13f82d8$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $17c3f295c13f82d8$export$be802dd0d8b57f35);
$parcel$export(module.exports, "RedBold", () => $17c3f295c13f82d8$export$8ce25cbf2e1e4328);
$parcel$export(module.exports, "R200", () => $17c3f295c13f82d8$export$60847d42f9da92a6);
$parcel$export(module.exports, "R300", () => $17c3f295c13f82d8$export$4a7404f376229999);
$parcel$export(module.exports, "R500", () => $17c3f295c13f82d8$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $17c3f295c13f82d8$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $17c3f295c13f82d8$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $17c3f295c13f82d8$export$5aae31392d72caaa);
$parcel$export(module.exports, "YellowBold", () => $17c3f295c13f82d8$export$b9aaaa578bb08b28);
$parcel$export(module.exports, "Yellow200", () => $17c3f295c13f82d8$export$fc857b6f8771648a);
$parcel$export(module.exports, "Y400", () => $17c3f295c13f82d8$export$59619663aa6500fb);
$parcel$export(module.exports, "Y600", () => $17c3f295c13f82d8$export$8d067e56aec921ba);
$parcel$export(module.exports, "Y800", () => $17c3f295c13f82d8$export$880b9499608823af);
$parcel$export(module.exports, "G50", () => $17c3f295c13f82d8$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $17c3f295c13f82d8$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $17c3f295c13f82d8$export$747d86715d4175de);
$parcel$export(module.exports, "GreenBold", () => $17c3f295c13f82d8$export$4ba6949317382ac4);
$parcel$export(module.exports, "G300", () => $17c3f295c13f82d8$export$940e1f69e873f202);
$parcel$export(module.exports, "G500", () => $17c3f295c13f82d8$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $17c3f295c13f82d8$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $17c3f295c13f82d8$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $17c3f295c13f82d8$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "BlueBold", () => $17c3f295c13f82d8$export$7489d9dce51bb172);
$parcel$export(module.exports, "B400", () => $17c3f295c13f82d8$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $17c3f295c13f82d8$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L50", () => $17c3f295c13f82d8$export$f51762073d2bb381);
$parcel$export(module.exports, "L200", () => $17c3f295c13f82d8$export$f72948ef771f6f15);
$parcel$export(module.exports, "L400", () => $17c3f295c13f82d8$export$4b0a7cabffffd4f5);
$parcel$export(module.exports, "L600", () => $17c3f295c13f82d8$export$b118f20869cce368);
$parcel$export(module.exports, "L800", () => $17c3f295c13f82d8$export$4d2dfdfde6a26b06);
$parcel$export(module.exports, "N0", () => $17c3f295c13f82d8$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $17c3f295c13f82d8$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $17c3f295c13f82d8$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N60", () => $17c3f295c13f82d8$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "GrayBold", () => $17c3f295c13f82d8$export$a85cd17eb3a74576);
$parcel$export(module.exports, "N80", () => $17c3f295c13f82d8$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "Neutral300", () => $17c3f295c13f82d8$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $17c3f295c13f82d8$export$13609db0e6812ab8);
$parcel$export(module.exports, "N600", () => $17c3f295c13f82d8$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $17c3f295c13f82d8$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $17c3f295c13f82d8$export$f78789c8b01753cd);
$parcel$export(module.exports, "M50", () => $17c3f295c13f82d8$export$dce26b47982a2d83);
$parcel$export(module.exports, "M200", () => $17c3f295c13f82d8$export$a19f0c33186f7767);
$parcel$export(module.exports, "M400", () => $17c3f295c13f82d8$export$a1d4686c17e1cdef);
$parcel$export(module.exports, "M600", () => $17c3f295c13f82d8$export$3bff0a0c68537008);
$parcel$export(module.exports, "M800", () => $17c3f295c13f82d8$export$aedcf6658caf5ad6);
$parcel$export(module.exports, "O200", () => $17c3f295c13f82d8$export$51716a84e62e022c);
$parcel$export(module.exports, "Orange50", () => $17c3f295c13f82d8$export$8692a80ca6403e1e);
$parcel$export(module.exports, "Orange200", () => $17c3f295c13f82d8$export$a0fa9fa6bfbb29d1);
$parcel$export(module.exports, "Orange400", () => $17c3f295c13f82d8$export$e58d39c2a9e7b70e);
$parcel$export(module.exports, "O600", () => $17c3f295c13f82d8$export$65becf92d294645b);
$parcel$export(module.exports, "O800", () => $17c3f295c13f82d8$export$d50a5202329f668e);
$parcel$export(module.exports, "P50", () => $17c3f295c13f82d8$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $17c3f295c13f82d8$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $17c3f295c13f82d8$export$6011520a64d9a187);
$parcel$export(module.exports, "PurpleBold", () => $17c3f295c13f82d8$export$33050b411a4844fe);
$parcel$export(module.exports, "P200", () => $17c3f295c13f82d8$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $17c3f295c13f82d8$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $17c3f295c13f82d8$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $17c3f295c13f82d8$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $17c3f295c13f82d8$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $17c3f295c13f82d8$export$776c9c497ef08533);
$parcel$export(module.exports, "TealBold", () => $17c3f295c13f82d8$export$f4de2950886ae4c9);
$parcel$export(module.exports, "T200", () => $17c3f295c13f82d8$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $17c3f295c13f82d8$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $17c3f295c13f82d8$export$6036577f95c3877e);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ /**
 * We're avoding importing these colors from @atlaskit/theme since we
 * do not want to have react as a dependency of this package.
 * TODO: Refactor this once tokenization by Core team is ready
 * https://product-fabric.atlassian.net/browse/CS-908
 */ 





var $17c3f295c13f82d8$export$4b84fd0e2c617bd = '#FFEBE6';
var $17c3f295c13f82d8$export$b34b069eff244586 = '#FFBDAD';
var $17c3f295c13f82d8$export$be802dd0d8b57f35 = '#FF8F73';
var $17c3f295c13f82d8$export$8ce25cbf2e1e4328 = '#FFB8B2';
var $17c3f295c13f82d8$export$60847d42f9da92a6 = '#FFD5D2';
var $17c3f295c13f82d8$export$4a7404f376229999 = '#FF5630';
var $17c3f295c13f82d8$export$2010d0fb4295b346 = '#DE350B';
var $17c3f295c13f82d8$export$2837b5a1a71d5c02 = '#BF2600';
var $17c3f295c13f82d8$export$8d9596b529bbb9cf = '#FFFAE6';
var $17c3f295c13f82d8$export$41060a744ab0b7ae = '#FFF0B3';
var $17c3f295c13f82d8$export$5aae31392d72caaa = '#FFC400';
var $17c3f295c13f82d8$export$b9aaaa578bb08b28 = '#EFDD4E';
var $17c3f295c13f82d8$export$fc857b6f8771648a = '#F8E6A0';
var $17c3f295c13f82d8$export$59619663aa6500fb = '#FF991F';
var $17c3f295c13f82d8$export$874739ea9e379ab6 = '#FF8B00';
var $17c3f295c13f82d8$export$8d067e56aec921ba = '#B38600';
var $17c3f295c13f82d8$export$880b9499608823af = '#7F5F01';
var $17c3f295c13f82d8$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $17c3f295c13f82d8$export$69a3bf21b9686c2b = '#ABF5D1';
var $17c3f295c13f82d8$export$747d86715d4175de = '#57D9A3';
var $17c3f295c13f82d8$export$4ba6949317382ac4 = '#97EDC9';
var $17c3f295c13f82d8$export$940e1f69e873f202 = '#36B37E';
var $17c3f295c13f82d8$export$a49394138f7b8e85 = '#00875A';
var $17c3f295c13f82d8$export$6fa04827ac68a4fb = '#006644';
var $17c3f295c13f82d8$export$226de0355ed012f8 = '#DEEBFF';
var $17c3f295c13f82d8$export$8c13c2ee36917869 = '#B3D4FF';
var $17c3f295c13f82d8$export$ecfc1dff386a3e7a = '#4C9AFF';
var $17c3f295c13f82d8$export$7489d9dce51bb172 = '#ADCBFB';
var $17c3f295c13f82d8$export$b3de0ae08da2ce64 = '#0052CC';
var $17c3f295c13f82d8$export$a6ee3d71bc067634 = '#0747A6';
var $17c3f295c13f82d8$export$f51762073d2bb381 = '#EFFFD6';
var $17c3f295c13f82d8$export$f72948ef771f6f15 = '#D3F1A7';
var $17c3f295c13f82d8$export$4b0a7cabffffd4f5 = '#BDE97C';
var $17c3f295c13f82d8$export$b118f20869cce368 = '#6A9A23';
var $17c3f295c13f82d8$export$4d2dfdfde6a26b06 = '#4C6B1F';
var $17c3f295c13f82d8$export$29a4f05edc054374 = '#FFFFFF';
var $17c3f295c13f82d8$export$9fdfb749e33cdf97 = '#F4F5F7';
var $17c3f295c13f82d8$export$3e51e8f1440314ba = '#EBECF0';
var $17c3f295c13f82d8$export$1ce2d1575d444ceb = '#DFE1E6';
var $17c3f295c13f82d8$export$8754fc7e6d8b3000 = '#C1C7D0';
var $17c3f295c13f82d8$export$c2e91cbeada39b8b = '#B3BAC5';
var $17c3f295c13f82d8$export$a85cd17eb3a74576 = '#B7B9BE';
var $17c3f295c13f82d8$export$eaa8c8a70ac22806 = '#97A0AF';
var $17c3f295c13f82d8$export$7c87d337fb91a97d = '#8993A4';
var $17c3f295c13f82d8$export$f563ee71e9ee74cd = '#6B778C';
var $17c3f295c13f82d8$export$e2ef2124cf4024b1 = '#5E6C84';
var $17c3f295c13f82d8$export$1ae1cebe22dcedb4 = '#DCDFE4';
var $17c3f295c13f82d8$export$13609db0e6812ab8 = '#091E4224';
var $17c3f295c13f82d8$export$c39c0fe0f26207ae = '#42526E';
var $17c3f295c13f82d8$export$7090862dc3038a9f = '#758195';
var $17c3f295c13f82d8$export$7d61b15e0da132af = '#172B4D';
var $17c3f295c13f82d8$export$f78789c8b01753cd = '#172B4D';
var $17c3f295c13f82d8$export$dce26b47982a2d83 = '#FFECF8';
var $17c3f295c13f82d8$export$a19f0c33186f7767 = '#FDD0EC';
var $17c3f295c13f82d8$export$a1d4686c17e1cdef = '#FCB6E1';
var $17c3f295c13f82d8$export$3bff0a0c68537008 = '#CD519D';
var $17c3f295c13f82d8$export$aedcf6658caf5ad6 = '#943D73';
var $17c3f295c13f82d8$export$51716a84e62e022c = '#FEDEC8';
var $17c3f295c13f82d8$export$8692a80ca6403e1e = '#FFF5DB';
var $17c3f295c13f82d8$export$a0fa9fa6bfbb29d1 = '#FCE4A6';
var $17c3f295c13f82d8$export$e58d39c2a9e7b70e = '#FBD779';
var $17c3f295c13f82d8$export$65becf92d294645b = '#E06C00';
var $17c3f295c13f82d8$export$d50a5202329f668e = '#9E4C00';
var $17c3f295c13f82d8$export$363e4475840015bb = '#EAE6FF';
var $17c3f295c13f82d8$export$4b0a4417ed59760f = '#C0B6F2';
var $17c3f295c13f82d8$export$6011520a64d9a187 = '#998DD9';
var $17c3f295c13f82d8$export$33050b411a4844fe = '#E3BDFA';
var $17c3f295c13f82d8$export$a7175d4e9206bc80 = '#DFD8FD';
var $17c3f295c13f82d8$export$b48405b95304b5a1 = '#6554C0';
var $17c3f295c13f82d8$export$c71e4279dd54a18d = '#5243AA';
var $17c3f295c13f82d8$export$147899de772240ec = '#403294';
var $17c3f295c13f82d8$export$2cf711fe14c66f06 = '#E6FCFF';
var $17c3f295c13f82d8$export$7a8f4d33f6f9772c = '#B3F5FF';
var $17c3f295c13f82d8$export$776c9c497ef08533 = '#79E2F2';
var $17c3f295c13f82d8$export$f4de2950886ae4c9 = '#B1E4F7';
var $17c3f295c13f82d8$export$69cb3ca10c1e330e = '#C6EDFB';
var $17c3f295c13f82d8$export$9dc1ef0f3f48059b = '#00B8D9';
var $17c3f295c13f82d8$export$6036577f95c3877e = '#008DA6';

});

parcelRegister("cQBqP", function(module, exports) {
$parcel$export(module.exports, "getDarkModeLCHColor", () => $95a7608797cf3192$export$a5065c3b8aacaf99);

var $je8Pt = parcelRequire("je8Pt");

var $dRZW3 = parcelRequire("dRZW3");

var $iOuXD = parcelRequire("iOuXD");
var $95a7608797cf3192$var$getLightness = function getLightness(color) {
    var rgb = (0, $dRZW3.rgbFromHex)(color);
    if (rgb === null) return 0;
    var lch = (0, $iOuXD.rgbToLch)(rgb);
    return lch.l;
};
var $95a7608797cf3192$export$a5065c3b8aacaf99 = function getDarkModeLCHColor(currentBackgroundColor) {
    var lightness = $95a7608797cf3192$var$getLightness(currentBackgroundColor);
    var newLightness = Math.abs(100 - lightness);
    return (0, $je8Pt.clampLightness)(currentBackgroundColor, newLightness).toUpperCase();
};

});
parcelRegister("je8Pt", function(module, exports) {
$parcel$export(module.exports, "clampLightness", () => $dff62c717d274cbc$export$313b8a8fcb34c3b8);

var $dRZW3 = parcelRequire("dRZW3");

var $iOuXD = parcelRequire("iOuXD");
var $dff62c717d274cbc$var$clamp = function clamp(i, min, max) {
    return Math.round(Math.min(Math.max(i, min), max));
};
var $dff62c717d274cbc$var$rgbToHex = function rgbToHex(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    var convertComponent = function convertComponent(c) {
        var cBase16 = c.toString(16);
        return cBase16.length === 1 ? "0".concat(cBase16) : cBase16;
    };
    return "#".concat(convertComponent(r)).concat(convertComponent(g)).concat(convertComponent(b));
};
var $dff62c717d274cbc$var$lchToLab = function lchToLab(_ref2) {
    var l = _ref2.l, c = _ref2.c, h = _ref2.h;
    var convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
var $dff62c717d274cbc$var$labToXyz = function labToXyz(_ref3) {
    var l = _ref3.l, a = _ref3.a, b = _ref3.b;
    var convertComponent = function convertComponent(c) {
        return c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    };
    var y = (l + 16) / 116;
    var x = a / 500 + y;
    var z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
var $dff62c717d274cbc$var$xyzToRgb = function xyzToRgb(_ref4) {
    var x = _ref4.x, y = _ref4.y, z = _ref4.z;
    var convertComponent = function convertComponent(c) {
        return 255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    };
    return {
        r: $dff62c717d274cbc$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $dff62c717d274cbc$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $dff62c717d274cbc$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
var $dff62c717d274cbc$var$lchToRgb = function lchToRgb(lch) {
    return $dff62c717d274cbc$var$xyzToRgb($dff62c717d274cbc$var$labToXyz($dff62c717d274cbc$var$lchToLab(lch)));
};
var $dff62c717d274cbc$export$313b8a8fcb34c3b8 = function clampLightness(color, newPercent) {
    var rgb = (0, $dRZW3.rgbFromHex)(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    var lch = (0, $iOuXD.rgbToLch)(rgb);
    lch.l = $dff62c717d274cbc$var$clamp(newPercent, 0, 100);
    return $dff62c717d274cbc$var$rgbToHex($dff62c717d274cbc$var$lchToRgb(lch));
};

});
parcelRegister("dRZW3", function(module, exports) {
$parcel$export(module.exports, "rgbFromHex", () => $a19044b00209b14a$export$d604f368c5212474);

var $2nfQL = parcelRequire("2nfQL");

var $gwjAb = parcelRequire("gwjAb");
var $a19044b00209b14a$export$d604f368c5212474 = function rgbFromHex(input) {
    var fullHex = (0, $2nfQL.expandShorthandHex)(input);
    var result = (0, $gwjAb.FULL_HEX_REGEX).exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};

});
parcelRegister("2nfQL", function(module, exports) {
$parcel$export(module.exports, "expandShorthandHex", () => $1baa0638b21d20fa$export$f67f480c2f5dd62d);
var $1baa0638b21d20fa$var$SHORTHAND_HEX_REGEX = /^#?([0-9a-f])([0-9a-f])([0-9a-f])$/i;
var $1baa0638b21d20fa$export$f67f480c2f5dd62d = function expandShorthandHex(input) {
    return input.replace($1baa0638b21d20fa$var$SHORTHAND_HEX_REGEX, function(_m, r, g, b) {
        return r + r + g + g + b + b;
    });
};

});

parcelRegister("gwjAb", function(module, exports) {
$parcel$export(module.exports, "FULL_HEX_REGEX", () => $c06ed32dd488160c$export$c3a7521d0ffa04dc);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 







var $c06ed32dd488160c$export$c3a7521d0ffa04dc = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i;
 // eslint-disable-next-line @atlaskit/volt-strict-mode/no-re-exports -- Public compatibility re-export.
 // eslint-disable-next-line @atlaskit/volt-strict-mode/no-re-exports -- Public compatibility re-export.

});


parcelRegister("iOuXD", function(module, exports) {
$parcel$export(module.exports, "rgbToLch", () => $db24e9ad517c2ca2$export$60714bf90ef24e7b);

var $5aPD5 = parcelRequire("5aPD5");

var $bT3U8 = parcelRequire("bT3U8");

var $6Amst = parcelRequire("6Amst");
var $db24e9ad517c2ca2$export$60714bf90ef24e7b = function rgbToLch(rgb) {
    return (0, $5aPD5.labToLch)((0, $6Amst.xyzToLab)((0, $bT3U8.rgbToXyz)(rgb)));
};

});
parcelRegister("5aPD5", function(module, exports) {
$parcel$export(module.exports, "labToLch", () => $3c45ef7115a5a15a$export$21f398e7d277f911);
var $3c45ef7115a5a15a$export$21f398e7d277f911 = function labToLch(_ref) {
    var l = _ref.l, a = _ref.a, b = _ref.b;
    var h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    var c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};

});

parcelRegister("bT3U8", function(module, exports) {
$parcel$export(module.exports, "rgbToXyz", () => $8a77dc1af7c09f3b$export$532d5190d94ac8d7);
var $8a77dc1af7c09f3b$export$532d5190d94ac8d7 = function rgbToXyz(rgb) {
    var convertRgbComponent = function convertRgbComponent(c) {
        return c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    };
    var convertXyzComponent = function convertXyzComponent(c) {
        return c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    };
    var r = convertRgbComponent(rgb.r / 255);
    var g = convertRgbComponent(rgb.g / 255);
    var b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};

});

parcelRegister("6Amst", function(module, exports) {
$parcel$export(module.exports, "xyzToLab", () => $4cb786a17b69575d$export$a7b197d2a22fcf09);
var $4cb786a17b69575d$export$a7b197d2a22fcf09 = function xyzToLab(_ref) {
    var x = _ref.x, y = _ref.y, z = _ref.z;
    return {
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    };
};

});




parcelRegister("4IQAb", function(module, exports) {
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $37040f47b4d0a26f$export$8b58ff1b36bb75e0);

var $aE9eF = parcelRequire("aE9eF");
function $37040f47b4d0a26f$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? (0, $aE9eF.textBackgroundColorPalette)[hexColor.toUpperCase()] : undefined;
}

});
parcelRegister("aE9eF", function(module, exports) {
$parcel$export(module.exports, "editorBorderPalette", () => $7c04cdcda82d9b65$export$aa000893c5e2b9c2);
$parcel$export(module.exports, "editorTextPalette", () => $7c04cdcda82d9b65$export$57fa5089caad992);
$parcel$export(module.exports, "textBackgroundColorPalette", () => $7c04cdcda82d9b65$export$12a518ff137dd389);
$parcel$export(module.exports, "editorBackgroundPalette", () => $7c04cdcda82d9b65$export$2462741d70e6a62f);

var $25nEq = parcelRequire("25nEq");

var $50U6m = parcelRequire("50U6m");

var $hBDk3 = parcelRequire("hBDk3");
function $7c04cdcda82d9b65$var$_defineAccessor(e, r, n, t) {
    var c = {
        configurable: !0,
        enumerable: !0
    };
    return c[e] = t, Object.defineProperty(r, n, c);
}
var $7c04cdcda82d9b65$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
var $7c04cdcda82d9b65$export$57fa5089caad992 = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7c04cdcda82d9b65$var$_defineAccessor("get", {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)',
    /** lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** lime - medium */ '#6A9A23': 'var(--ds-icon-accent-lime, #6A9A23)',
    /** lime - strong */ '#4C6B1F': 'var(--ds-text-accent-lime, #4C6B1F)',
    /** orange - light */ '#FCE4A6': 'var(--ds-background-accent-orange-subtler, #FCE4A6)',
    /** orange - medium */ '#E06C00': 'var(--ds-icon-accent-orange, #E06C00)',
    /** orange - strong */ '#9E4C00': 'var(--ds-text-accent-orange, #9E4C00)',
    /** magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** magenta - medium */ '#CD519D': 'var(--ds-icon-accent-magenta, #CD519D)',
    /** magenta - strong */ '#943D73': 'var(--ds-text-accent-magenta, #943D73)'
}, '#B38600', function() {
    return (0, $hBDk3.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && (0, $50U6m.fg)('platform_editor_lovability_text_bg_color_patch_1') ? 'var(--ds-border-accent-yellow, #B38600)' : 'var(--ds-icon-accent-yellow, #B38600)';
}), '#7F5F01', 'var(--ds-text-accent-yellow, #7F5F01)');
var $7c04cdcda82d9b65$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Yellow - light */ '#F8E6A0': 'var(--ds-background-accent-yellow-subtler, #F8E6A0)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Red - light */ '#FFD5D2': 'var(--ds-background-accent-red-subtler, #FFD5D2)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)',
    /** Blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** Green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)'
};
var $7c04cdcda82d9b65$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: function getValue() {
            return '#DEEBFF';
        },
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: function getValue() {
            return '#B3D4FF';
        },
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: function getValue() {
            return '#4C9AFF';
        },
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: function getValue() {
            return '#E6FCFF';
        },
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: function getValue() {
            return '#B3F5FF';
        },
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: function getValue() {
            return '#79E2F2';
        },
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: function getValue() {
            return '#E3FCEF';
        },
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: function getValue() {
            return '#ABF5D1';
        },
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: function getValue() {
            return '#57D9A3';
        },
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: function getValue() {
            return '#FFFAE6';
        },
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: function getValue() {
            return '#FFF0B3';
        },
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: function getValue() {
            return '#FFC400';
        },
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: function getValue() {
            return '#FFEBE6';
        },
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: function getValue() {
            return '#FFBDAD';
        },
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: function getValue() {
            return '#FF8F73';
        },
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: function getValue() {
            return '#EAE6FF';
        },
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: function getValue() {
            return '#C0B6F2';
        },
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: function getValue() {
            return '#998DD9';
        },
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: function getValue() {
            return '#FFFFFF';
        },
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: function getValue() {
            return '#F4F5F7';
        },
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: function getValue() {
            return '#B3BAC5';
        },
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    },
    /** lime - light */ '#EFFFD6': {
        getValue: function getValue() {
            return '#EFFFD6';
        },
        token: 'var(--ds-background-accent-lime-subtlest, #EFFFD6)'
    },
    /** lime - medium */ '#D3F1A7': {
        getValue: function getValue() {
            return '#D3F1A7';
        },
        token: 'var(--ds-background-accent-lime-subtler, #D3F1A7)'
    },
    /** lime - bold */ '#BDE97C': {
        getValue: function getValue() {
            return '#BDE97C';
        },
        token: 'var(--ds-background-accent-lime-subtler-hovered, #BDE97C)'
    },
    /** orange - light */ '#FFF5DB': {
        getValue: function getValue() {
            return '#FFF5DB';
        },
        token: 'var(--ds-background-accent-orange-subtlest, #FFF5DB)'
    },
    /** orange - medium */ '#FCE4A6': {
        getValue: function getValue() {
            return '#FCE4A6';
        },
        token: 'var(--ds-background-accent-orange-subtler, #FCE4A6)'
    },
    /** orange - bold */ '#FBD779': {
        getValue: function getValue() {
            return '#FBD779';
        },
        token: 'var(--ds-background-accent-orange-subtler-hovered, #FBD779)'
    },
    /** magenta - light */ '#FFECF8': {
        getValue: function getValue() {
            return '#FFECF8';
        },
        token: 'var(--ds-background-accent-magenta-subtlest, #FFECF8)'
    },
    /** magenta - medium */ '#FDD0EC': {
        getValue: function getValue() {
            return '#FDD0EC';
        },
        token: 'var(--ds-background-accent-magenta-subtler, #FDD0EC)'
    },
    /** magenta - bold */ '#FCB6E1': {
        getValue: function getValue() {
            return '#FCB6E1';
        },
        token: 'var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)'
    },
    // Bold row mappings using subtler.hovered tokens. These use new hex codes
    // so pre-existing documents keep their old subtle-token mappings above.
    /** blue - bold */ '#ADCBFB': {
        getValue: function getValue() {
            return '#ADCBFB';
        },
        token: 'var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)'
    },
    /** teal - bold */ '#B1E4F7': {
        getValue: function getValue() {
            return '#B1E4F7';
        },
        token: 'var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)'
    },
    /** green - bold */ '#97EDC9': {
        getValue: function getValue() {
            return '#97EDC9';
        },
        token: 'var(--ds-background-accent-green-subtler-hovered, #97EDC9)'
    },
    /** yellow - bold */ '#EFDD4E': {
        getValue: function getValue() {
            return '#EFDD4E';
        },
        token: 'var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)'
    },
    /** red - bold */ '#FFB8B2': {
        getValue: function getValue() {
            return '#FFB8B2';
        },
        token: 'var(--ds-background-accent-red-subtler-hovered, #FFB8B2)'
    },
    /** purple - bold */ '#E3BDFA': {
        getValue: function getValue() {
            return '#E3BDFA';
        },
        token: 'var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)'
    },
    /** gray - bold */ '#B7B9BE': {
        getValue: function getValue() {
            return '#B7B9BE';
        },
        token: 'var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)'
    }
};

});


parcelRegister("cXJFA", function(module, exports) {
$parcel$export(module.exports, "rgbToHex", () => $96fe6bcd59f9badc$export$34d09c4a771c46ef);

var $iYJcE = parcelRequire("iYJcE");
function $96fe6bcd59f9badc$export$34d09c4a771c46ef(value) {
    var matches = value.match(/(0?\.?[0-9]{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        var _matches$map = matches.map(Number), _matches$map2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_matches$map, 3), red = _matches$map2[0], green = _matches$map2[1], blue = _matches$map2[2];
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1);
    }
    return null;
}

});

parcelRegister("dvZpe", function(module, exports) {
$parcel$export(module.exports, "getGlobalTheme", () => $9d6dcd92ad05926a$export$813ecdf77207a053);
$parcel$export(module.exports, "textColor", () => $9d6dcd92ad05926a$export$32f78bffcd82ff28);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $hBDk3 = parcelRequire("hBDk3");

var $P0RMo = parcelRequire("P0RMo");

var $22vaF = parcelRequire("22vaF");

var $cQBqP = parcelRequire("cQBqP");

var $bl4KX = parcelRequire("bl4KX");

var $cXJFA = parcelRequire("cXJFA");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
var $9d6dcd92ad05926a$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $22vaF.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $22vaF.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $22vaF.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $22vaF.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $22vaF.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $22vaF.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $22vaF.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $22vaF.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $22vaF.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $22vaF.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $22vaF.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $22vaF.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $22vaF.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $22vaF.N0),
        'White'
    ],
    [
        (0, $22vaF.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $22vaF.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $22vaF.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $22vaF.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $22vaF.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $22vaF.P50),
        'Light purple'
    ] // Lavender secret
];
// experiment: platform_editor_lovability_text_bg_color
var $9d6dcd92ad05926a$var$colorArrayPaletteNew = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $22vaF.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $22vaF.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $22vaF.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $22vaF.L800),
        'Dark lime'
    ],
    [
        (0, $22vaF.Y800),
        'Dark yellow'
    ],
    [
        (0, $22vaF.O800),
        'Dark orange'
    ],
    [
        (0, $22vaF.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $22vaF.M800),
        'Dark magenta'
    ],
    [
        (0, $22vaF.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $22vaF.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $22vaF.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $22vaF.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $22vaF.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $22vaF.L600),
        'Lime'
    ],
    [
        (0, $22vaF.Y600),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $22vaF.O600),
        'Orange'
    ],
    [
        (0, $22vaF.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $22vaF.M600),
        'Magenta'
    ],
    [
        (0, $22vaF.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $22vaF.N0),
        'White'
    ],
    [
        (0, $22vaF.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $22vaF.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $22vaF.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $22vaF.L200),
        'Light lime'
    ],
    [
        (0, $22vaF.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $22vaF.Orange200),
        'Light orange'
    ],
    [
        (0, $22vaF.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $22vaF.M200),
        'Light magenta'
    ],
    [
        (0, $22vaF.P50),
        'Light purple'
    ] // Lavender secret
];
var $9d6dcd92ad05926a$export$569885e57444f84a = new Map();
var $9d6dcd92ad05926a$export$dee1d8a8cb3ab555 = new Map();
var $9d6dcd92ad05926a$export$81e5ed9e84fe2e28 = $9d6dcd92ad05926a$export$569885e57444f84a;
$9d6dcd92ad05926a$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $9d6dcd92ad05926a$export$569885e57444f84a.set(color.toLowerCase(), label);
});
$9d6dcd92ad05926a$var$colorArrayPaletteNew.forEach(function(_ref3) {
    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), color = _ref4[0], label = _ref4[1];
    return $9d6dcd92ad05926a$export$dee1d8a8cb3ab555.set(color.toLowerCase(), label);
});
var $9d6dcd92ad05926a$var$isSupportedTextColor = function isSupportedTextColor(hexColor) {
    if ($9d6dcd92ad05926a$export$569885e57444f84a.has(hexColor)) return true;
    return (0, $hBDk3.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && $9d6dcd92ad05926a$export$dee1d8a8cb3ab555.has(hexColor);
};
// these are for test only
var $9d6dcd92ad05926a$var$testGlobalTheme;
var $9d6dcd92ad05926a$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $9d6dcd92ad05926a$var$testGlobalTheme = theme;
};
var $9d6dcd92ad05926a$export$813ecdf77207a053 = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($9d6dcd92ad05926a$var$testGlobalTheme) return {
        colorMode: $9d6dcd92ad05926a$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
var $9d6dcd92ad05926a$var$RGB_PREFIX_TEXT_COLOR_REGEX = /^rgb/i;
var $9d6dcd92ad05926a$export$32f78bffcd82ff28 = (0, $P0RMo.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                if (value.match($9d6dcd92ad05926a$var$RGB_PREFIX_TEXT_COLOR_REGEX)) hexColor = (0, $cXJFA.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $9d6dcd92ad05926a$var$isSupportedTextColor(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $9d6dcd92ad05926a$var$isSupportedTextColor(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $bl4KX.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($9d6dcd92ad05926a$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $cQBqP.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, 'data-text-custom-color', mark.attrs.color)
        ];
    }
});

});
parcelRegister("bl4KX", function(module, exports) {
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $841558602a9fa3eb$export$9c2f408d391feb93);

var $aE9eF = parcelRequire("aE9eF");
function $841558602a9fa3eb$export$9c2f408d391feb93(hexColor) {
    var normalizedHexColor = hexColor ? hexColor.toUpperCase() : undefined;
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-expect-error
    return normalizedHexColor ? (0, $aE9eF.editorTextPalette)[normalizedHexColor] : undefined;
}

});



parcelRegister("5BptP", function(module, exports) {
$parcel$export(module.exports, "border", () => $41442c4148119198$export$1edee58a52776cd9);

var $iYJcE = parcelRequire("iYJcE");

var $P0RMo = parcelRequire("P0RMo");

var $22vaF = parcelRequire("22vaF");

var $bWPKc = parcelRequire("bWPKc");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ var $41442c4148119198$var$borderColorArrayPalette = [
    [
        (0, $22vaF.N300A),
        'Subtle gray'
    ],
    [
        (0, $22vaF.N600),
        'Gray'
    ],
    [
        (0, $22vaF.N1000),
        'Bold gray'
    ]
];
var $41442c4148119198$export$e4e044c989c86ca7 = new Map();
$41442c4148119198$var$borderColorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $41442c4148119198$export$e4e044c989c86ca7.set(color.toLowerCase(), label);
});
var $41442c4148119198$export$1edee58a52776cd9 = (0, $P0RMo.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: function getAttrs(domNode) {
                var _dom$getAttribute, _dom$getAttribute2;
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                var size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $41442c4148119198$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM: function toDOM(mark, isInline) {
        var wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        var paletteColorValue = (0, $bWPKc.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }
        ];
    }
});

});
parcelRegister("bWPKc", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $8b2d3fd2d2521277$export$bad3c41dd33cb4bc);

var $aE9eF = parcelRequire("aE9eF");
function $8b2d3fd2d2521277$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? (0, $aE9eF.editorBorderPalette)[hexColor.toUpperCase()] : undefined;
}

});


parcelRegister("66hh0", function(module, exports) {
$parcel$export(module.exports, "breakout", () => $4710b3b81a4d2e84$export$89015c65f1c75e3f);

var $P0RMo = parcelRequire("P0RMo");
var $4710b3b81a4d2e84$var$allowedTypes = [
    'wide',
    'full-width'
];
var $4710b3b81a4d2e84$export$89015c65f1c75e3f = (0, $P0RMo.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs: function getAttrs(dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var mode = dom.getAttribute('data-mode');
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var width = dom.getAttribute('data-width');
                return {
                    mode: $4710b3b81a4d2e84$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var _mark$attrs;
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});

});

parcelRegister("iVDN9", function(module, exports) {
$parcel$export(module.exports, "code", () => $dc7c6aab74e1d800$export$6565f9f03506010b);

var $P0RMo = parcelRequire("P0RMo");
var $dc7c6aab74e1d800$export$6565f9f03506010b = (0, $P0RMo.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});

});

parcelRegister("31cn2", function(module, exports) {
$parcel$export(module.exports, "confluenceInlineComment", () => $232b0f9e963c91cf$export$f3b72f8fc4684ecd);

var $P0RMo = parcelRequire("P0RMo");
var $232b0f9e963c91cf$export$f3b72f8fc4684ecd = (0, $P0RMo.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("2InDy", function(module, exports) {
$parcel$export(module.exports, "dataConsumer", () => $1fa206a7f541cfd7$export$3024f02c495408d6);
$parcel$export(module.exports, "toJSON", () => $1fa206a7f541cfd7$export$54fd2c36b5cc6731);

var $25nEq = parcelRequire("25nEq");

var $P0RMo = parcelRequire("P0RMo");

var $fBYOr = parcelRequire("fBYOr");
function $1fa206a7f541cfd7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1fa206a7f541cfd7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1fa206a7f541cfd7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1fa206a7f541cfd7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 // eslint-disable-next-line eslint-plugin-jsdoc/check-tag-names
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ var $1fa206a7f541cfd7$var$parseDataConsumer = function parseDataConsumer(maybeValue) {
    var sources = (0, $fBYOr.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch (_unused) {
        return false;
    }
};
var $1fa206a7f541cfd7$export$3024f02c495408d6 = (0, $P0RMo.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: function getAttrs(maybeValue) {
                return $1fa206a7f541cfd7$var$parseDataConsumer(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
var $1fa206a7f541cfd7$export$54fd2c36b5cc6731 = function toJSON(mark) {
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter(function(key) {
            return key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null;
        }).reduce(function(acc, key) {
            return $1fa206a7f541cfd7$var$_objectSpread($1fa206a7f541cfd7$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, mark.attrs[key]));
        }, {})
    };
};

});
parcelRegister("fBYOr", function(module, exports) {
$parcel$export(module.exports, "isDOMElement", () => $b5d97bcd379dd54c$export$c296e2d4365c37a5);
var $b5d97bcd379dd54c$export$c296e2d4365c37a5 = function isDOMElement(maybeNode) {
    return maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;
};

});


parcelRegister("kVedW", function(module, exports) {
$parcel$export(module.exports, "em", () => $f3b42a1611ed0190$export$c63c6f932822f543);

var $P0RMo = parcelRequire("P0RMo");
/**
 * @name em_mark
 */ var $f3b42a1611ed0190$var$emDOM = [
    'em'
];
var $f3b42a1611ed0190$export$c63c6f932822f543 = (0, $P0RMo.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM: function toDOM() {
        return $f3b42a1611ed0190$var$emDOM;
    }
});

});

parcelRegister("7DpxI", function(module, exports) {
$parcel$export(module.exports, "fontSize", () => $58effd346cdeca5a$export$85e3c3ca0c6fb93);

var $P0RMo = parcelRequire("P0RMo");
var $58effd346cdeca5a$var$allowedSizes = [
    'small'
];
var $58effd346cdeca5a$export$85e3c3ca0c6fb93 = (0, $P0RMo.fontSize)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-font-size',
            getAttrs: function getAttrs(dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var fontSize = dom.getAttribute('data-font-size');
                return {
                    fontSize: $58effd346cdeca5a$var$allowedSizes.indexOf(fontSize || '') === -1 ? 'small' : fontSize
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-font-size',
                'data-font-size': mark.attrs.fontSize
            },
            0
        ];
    }
});

});

parcelRegister("iDfRT", function(module, exports) {
$parcel$export(module.exports, "fragment", () => $d9082da3fca0d5e3$export$f00aeb236b6f05af);
$parcel$export(module.exports, "toJSON", () => $d9082da3fca0d5e3$export$54fd2c36b5cc6731);

var $25nEq = parcelRequire("25nEq");

var $P0RMo = parcelRequire("P0RMo");

var $fBYOr = parcelRequire("fBYOr");
function $d9082da3fca0d5e3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d9082da3fca0d5e3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d9082da3fca0d5e3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d9082da3fca0d5e3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ var $d9082da3fca0d5e3$var$parseFragment = function parseFragment(maybeValue) {
    var _maybeValue$getAttrib;
    if (!(0, $fBYOr.isDOMElement)(maybeValue)) return false;
    var name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    var localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
var $d9082da3fca0d5e3$export$f00aeb236b6f05af = (0, $P0RMo.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: function getAttrs(maybeValue) {
                return $d9082da3fca0d5e3$var$parseFragment(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
var $d9082da3fca0d5e3$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: $d9082da3fca0d5e3$var$_objectSpread({
            localId: mark.attrs.localId
        }, mark.attrs.name ? {
            name: mark.attrs.name
        } : {})
    };
};

});

parcelRegister("13aOI", function(module, exports) {
$parcel$export(module.exports, "indentation", () => $0c3e7647fb8be3b4$export$480c699bd4ec0d86);

var $P0RMo = parcelRequire("P0RMo");
var $0c3e7647fb8be3b4$export$480c699bd4ec0d86 = (0, $P0RMo.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs: function getAttrs(dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("5BE4e", function(module, exports) {
$parcel$export(module.exports, "link", () => $414f7cf8b289c32d$export$9c30223ca0a664fb);

var $25nEq = parcelRequire("25nEq");

var $P0RMo = parcelRequire("P0RMo");

var $7JWGN = parcelRequire("7JWGN");

var $80KTB = parcelRequire("80KTB");

function $414f7cf8b289c32d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $414f7cf8b289c32d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $414f7cf8b289c32d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $414f7cf8b289c32d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $414f7cf8b289c32d$export$9c30223ca0a664fb = (0, $P0RMo.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: (0, $80KTB.getLinkAttrs)('data-block-link'),
            contentElement: function contentElement(node) {
                var clone = node.cloneNode(true);
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                clone.removeAttribute('data-block-link');
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                clone.setAttribute('data-skip-paste', 'true');
                var wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: (0, $80KTB.getLinkAttrs)('href')
        }
    ],
    toDOM: function toDOM(node, isInline) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var attrs = Object.keys(node.attrs).reduce(function(attrs, key) {
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $7JWGN.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else // @ts-ignore
            attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            $414f7cf8b289c32d$var$_objectSpread($414f7cf8b289c32d$var$_objectSpread({}, attrs), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, 'data-block-link', 'true'), "class", 'blockLink')),
            0
        ];
    }
});

});
parcelRegister("7JWGN", function(module, exports) {
$parcel$export(module.exports, "isSafeUrl", () => $5a2a42d597582b06$export$c9f92f5469372e0f);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ var $5a2a42d597582b06$var$whitelistedURLPatterns = [
    /^http[s\u017F]?:\/\//im,
    /^ftp[s\u017F]?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^[s\u017F]mb:\/\//im,
    /^dynamic[s\u017F]nav:\/\//im,
    /^jamf[s\u017F]elf[s\u017F]ervice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^[s\u017F][k\u212A]ype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^new[s\u017F]:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cv[s\u017F]:/im,
    /^[s\u017F]vn:/im,
    /^mvn:/im,
    /^[s\u017F][s\u017F]h:/im,
    /^[s\u017F]cp:\/\//im,
    /^[s\u017F]ftp:\/\//im,
    /^itm[s\u017F]:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^note[s\u017F]:/im,
    /^note[s\u017F]:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^[s\u017F]ourcetree:/im,
    /^[s\u017F]ourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^what[s\u017F]app:/im,
    /^[s\u017F]lac[k\u212A]:/im,
    /^[s\u017F]ip[s\u017F]?:/im,
    /^magnet:/im,
    /^#/im
];
var $5a2a42d597582b06$export$c9f92f5469372e0f = function isSafeUrl(url) {
    var urlTrimmed = url === null || url === void 0 ? void 0 : url.trim();
    if (urlTrimmed === undefined) return true;
    if (urlTrimmed.length === 0) return true;
    return $5a2a42d597582b06$var$whitelistedURLPatterns.some(function(p) {
        return p.test(urlTrimmed);
    });
};

});

parcelRegister("80KTB", function(module, exports) {
$parcel$export(module.exports, "getLinkAttrs", () => $01815579359e579d$export$b5f67017585d1431);

var $ahkAj = parcelRequire("ahkAj");

var $7JWGN = parcelRequire("7JWGN");

var $3dJ4R = parcelRequire("3dJ4R");
var $01815579359e579d$export$b5f67017585d1431 = function getLinkAttrs(attribute) {
    return function(domNode) {
        var dom = domNode;
        var href = dom.getAttribute(attribute) || '';
        var attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $7JWGN.isSafeUrl)(href)) return false;
        if ((0, $ahkAj.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $3dJ4R.normalizeUrl)(href);
        return attrs;
    };
};

});
parcelRegister("ahkAj", function(module, exports) {
$parcel$export(module.exports, "isRootRelative", () => $77bb759c31e89b6c$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ /**
 * checks if root relative link
 */ function $77bb759c31e89b6c$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});

parcelRegister("3dJ4R", function(module, exports) {
$parcel$export(module.exports, "normalizeUrl", () => $25858d733818cedc$export$6535eb414fa2c8b6);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $g2ryK = parcelRequire("g2ryK");
function $25858d733818cedc$export$6535eb414fa2c8b6(url) {
    var match = (0, $g2ryK.getLinkMatch)(url);
    return match && match.url || '';
}

});
parcelRegister("g2ryK", function(module, exports) {
$parcel$export(module.exports, "getLinkMatch", () => $bad235f4644d3351$export$ce9ae45aed3e4ec);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $eoy5g = parcelRequire("eoy5g");

var $1hVTD = parcelRequire("1hVTD");
function $bad235f4644d3351$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    var match = (0, $eoy5g.linkifyMatch)(str);
    if (!match.length) match = (0, $1hVTD.linkify).match(str);
    return match && match[0];
}

});
parcelRegister("eoy5g", function(module, exports) {
$parcel$export(module.exports, "linkifyMatch", () => $a7adbef172f9d82a$export$6f7d7761b97f967);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $1hVTD = parcelRequire("1hVTD");
var $a7adbef172f9d82a$export$6f7d7761b97f967 = function linkifyMatch(text) {
    if (!(0, $1hVTD.LINK_REGEXP).test(text)) return [];
    var matches = [];
    var startpos = 0;
    var substr;
    substr = text.substr(startpos);
    while(substr){
        var link = (substr.match((0, $1hVTD.LINK_REGEXP)) || [
            ''
        ])[0];
        if (link) {
            var index = substr.search((0, $1hVTD.LINK_REGEXP));
            var start = index >= 0 ? index + startpos : index;
            var end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos = end;
            substr = text.substr(startpos);
        } else break;
    }
    return matches;
};

});
parcelRegister("1hVTD", function(module, exports) {
$parcel$export(module.exports, "linkify", () => $0f0449fb62ebb7a2$export$8ccbde94d5c7f8e7);
$parcel$export(module.exports, "LINK_REGEXP", () => $0f0449fb62ebb7a2$export$746d02eae03c72e1);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ /**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $840z9 = parcelRequire("840z9");

var $50U6m = parcelRequire("50U6m");





var $0f0449fb62ebb7a2$export$8ccbde94d5c7f8e7 = new (0, $840z9.default)();
var $0f0449fb62ebb7a2$var$URI_WITHOUT_SPACES = /(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+/;
var $0f0449fb62ebb7a2$var$URI_WITHOUT_SPACES_ANCHORED = /^(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+/;
var $0f0449fb62ebb7a2$var$urlWithoutSpacesValidator = {
    validate: function validate(text, pos) {
        var tail = text.slice(pos);
        var pattern = (0, $50U6m.fg)('platform_bugfix_invalid_urls_parsing_in_editor') ? $0f0449fb62ebb7a2$var$URI_WITHOUT_SPACES_ANCHORED : $0f0449fb62ebb7a2$var$URI_WITHOUT_SPACES;
        var match = tail.match(pattern);
        return match ? match[0].length : 0;
    }
};
var $0f0449fb62ebb7a2$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
var $0f0449fb62ebb7a2$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
var $0f0449fb62ebb7a2$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+/;
$0f0449fb62ebb7a2$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$0f0449fb62ebb7a2$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
$0f0449fb62ebb7a2$export$8ccbde94d5c7f8e7.add('tel:', $0f0449fb62ebb7a2$var$urlWithoutSpacesValidator);
$0f0449fb62ebb7a2$export$8ccbde94d5c7f8e7.add('file:', $0f0449fb62ebb7a2$var$urlWithoutSpacesValidator);
$0f0449fb62ebb7a2$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
$0f0449fb62ebb7a2$var$tlds.push($0f0449fb62ebb7a2$var$tlds2Char);
$0f0449fb62ebb7a2$export$8ccbde94d5c7f8e7.tlds($0f0449fb62ebb7a2$var$tlds, false);

});
parcelRegister("840z9", function(module, exports) {
$parcel$export(module.exports, "default", () => $5def22d34403614b$export$2e2bcd8739ae039);

var $aOi1C = parcelRequire("aOi1C");
//
// Helpers
//
// Merge objects
//
function $5def22d34403614b$var$assign(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $5def22d34403614b$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $5def22d34403614b$var$isString(obj) {
    return $5def22d34403614b$var$_class(obj) === '[object String]';
}
function $5def22d34403614b$var$isObject(obj) {
    return $5def22d34403614b$var$_class(obj) === '[object Object]';
}
function $5def22d34403614b$var$isRegExp(obj) {
    return $5def22d34403614b$var$_class(obj) === '[object RegExp]';
}
function $5def22d34403614b$var$isFunction(obj) {
    return $5def22d34403614b$var$_class(obj) === '[object Function]';
}
function $5def22d34403614b$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
//
const $5def22d34403614b$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $5def22d34403614b$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        /* eslint-disable-next-line no-prototype-builtins */ return acc || $5def22d34403614b$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
const $5def22d34403614b$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp(`^\\/\\/${self.re.src_auth}${self.re.src_host_port_strict}${self.re.src_path}`, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            `(?:localhost|(?:(?:${self.re.src_domain})\\.)+${self.re.src_domain_root})` + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp(`^${self.re.src_email_name}@${self.re.src_host_strict}`, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
const $5def22d34403614b$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
const $5def22d34403614b$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
function $5def22d34403614b$var$createValidator(re) {
    return function(text, pos) {
        const tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $5def22d34403614b$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}
// Schemas compiler. Build regexps.
//
function $5def22d34403614b$var$compile(self) {
    // Load & clone RE patterns.
    const re = self.re = (0, $aOi1C.default)(self.__opts__);
    // Define dynamic patterns
    const tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($5def22d34403614b$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.email_fuzzy_global = RegExp(untpl(re.tpl_email_fuzzy), 'ig');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_fuzzy_global = RegExp(untpl(re.tpl_link_fuzzy), 'ig');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.link_no_ip_fuzzy_global = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'ig');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    const aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error(`(LinkifyIt) Invalid schema "${name}": ${val}`);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        const val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        const compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($5def22d34403614b$var$isObject(val)) {
            if ($5def22d34403614b$var$isRegExp(val.validate)) compiled.validate = $5def22d34403614b$var$createValidator(val.validate);
            else if ($5def22d34403614b$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($5def22d34403614b$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $5def22d34403614b$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($5def22d34403614b$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $5def22d34403614b$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    const slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($5def22d34403614b$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp(`(^|(?!_)(?:[><\uff5c]|${re.src_ZPCc}))(${slist})`, 'i');
    self.re.schema_search = RegExp(`(^|(?!_)(?:[><\uff5c]|${re.src_ZPCc}))(${slist})`, 'ig');
    self.re.schema_at_start = RegExp(`^${self.re.schema_search.source}`, 'i');
    self.re.pretest = RegExp(`(${self.re.schema_test.source})|(${self.re.host_fuzzy_test.source})|@`, 'i');
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $5def22d34403614b$var$Match(text, schema, index, lastIndex) {
    const raw = text.slice(index, lastIndex);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = schema.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = index;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = lastIndex;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = raw;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = raw;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = raw;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $5def22d34403614b$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $5def22d34403614b$var$LinkifyIt)) return new $5def22d34403614b$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($5def22d34403614b$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $5def22d34403614b$var$assign({}, $5def22d34403614b$var$defaultOptions, options);
    this.__schemas__ = $5def22d34403614b$var$assign({}, $5def22d34403614b$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $5def22d34403614b$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $5def22d34403614b$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $5def22d34403614b$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $5def22d34403614b$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $5def22d34403614b$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $5def22d34403614b$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $5def22d34403614b$var$LinkifyIt.prototype.test = function test(text) {
    if (!text.length) return false;
    let m, re;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            if (this.testSchemaAt(text, m[2], re.lastIndex)) return true;
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) // guess schemaless links
    {
        if (text.search(this.re.host_fuzzy_test) >= 0) {
            if (text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy) !== null) return true;
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) // guess schemaless emails
    {
        if (text.indexOf('@') >= 0) {
            // We can't skip this check, because this cases are possible:
            // 192.168.1.1@gmail.com, my.in@example.com
            if (text.match(this.re.email_fuzzy) !== null) return true;
        }
    }
    return false;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $5def22d34403614b$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $5def22d34403614b$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $5def22d34403614b$var$LinkifyIt.prototype.match = function match(text) {
    const result = [];
    const type_schemed = [];
    const type_fuzzy_link = [];
    const type_fuzzy_email = [];
    let m, len, re;
    function choose(a, b) {
        if (!a) return b;
        if (!b) return a;
        if (a.index !== b.index) return a.index < b.index ? a : b;
        return a.lastIndex >= b.lastIndex ? a : b;
    }
    if (!text.length) return null;
    // scan for links with schema
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) type_schemed.push({
                schema: m[2],
                index: m.index + m[1].length,
                lastIndex: m.index + m[0].length + len
            });
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        re = this.__opts__.fuzzyIP ? this.re.link_fuzzy_global : this.re.link_no_ip_fuzzy_global;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null)type_fuzzy_link.push({
            schema: '',
            index: m.index + m[1].length,
            lastIndex: m.index + m[0].length
        });
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        re = this.re.email_fuzzy_global;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null)type_fuzzy_email.push({
            schema: 'mailto:',
            index: m.index + m[1].length,
            lastIndex: m.index + m[0].length
        });
    }
    const indexes = [
        0,
        0,
        0
    ];
    let lastIndex = 0;
    for(;;){
        const candidates = [
            type_schemed[indexes[0]],
            type_fuzzy_email[indexes[1]],
            type_fuzzy_link[indexes[2]]
        ];
        const candidate = choose(choose(candidates[0], candidates[1]), candidates[2]);
        if (!candidate) break;
        if (candidate === candidates[0]) indexes[0]++;
        else if (candidate === candidates[1]) indexes[1]++;
        else indexes[2]++;
        if (candidate.index < lastIndex) continue;
        const match = new $5def22d34403614b$var$Match(text, candidate.schema, candidate.index, candidate.lastIndex);
        this.__compiled__[match.schema].normalize(match, this);
        result.push(match);
        lastIndex = candidate.lastIndex;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $5def22d34403614b$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    if (!text.length) return null;
    const m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    const len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    const match = new $5def22d34403614b$var$Match(text, m[2], m.index + m[1].length, m.index + m[0].length + len);
    this.__compiled__[match.schema].normalize(match, this);
    return match;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $5def22d34403614b$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $5def22d34403614b$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $5def22d34403614b$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $5def22d34403614b$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = `http://${match.url}`;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = `mailto:${match.url}`;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $5def22d34403614b$var$LinkifyIt.prototype.onCompile = function onCompile() {};
var $5def22d34403614b$export$2e2bcd8739ae039 = $5def22d34403614b$var$LinkifyIt;

});
parcelRegister("aOi1C", function(module, exports) {
$parcel$export(module.exports, "default", () => $7dec8e54d5239c8f$export$2e2bcd8739ae039);
parcelRequire("aNtO2");
var $9pzVw = parcelRequire("9pzVw");
var $fUT3l = parcelRequire("fUT3l");
var $8BybH = parcelRequire("8BybH");
var $5g06v = parcelRequire("5g06v");
function $7dec8e54d5239c8f$export$2e2bcd8739ae039(opts) {
    const re = {};
    opts = opts || {};
    re.src_Any = (0, $9pzVw.default).source;
    re.src_Cc = (0, $fUT3l.default).source;
    re.src_Z = (0, $5g06v.default).source;
    re.src_P = (0, $8BybH.default).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    const text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = `(?:(?!${text_separators}|${re.src_ZPCc})${re.src_Any})`;
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    // Length is capped to exclude possible rescans till the end and avoid O(n^2)
    // DoS. No standard limit, just take something reasonable.
    re.src_auth = `(?:(?:(?!${re.src_ZCc}|[@/\\[\\]()]).){1,50}@)?`;
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = `(?=$|${text_separators}|${re.src_ZPCc})` + `(?!${opts['---'] ? '-(?!--)|' : '-|'}_|:\\d|\\.-|\\.(?!$|${re.src_ZPCc}))`;
    re.src_path = "(?:[/?#](?:" + `(?!${re.src_ZCc}|${text_separators}|[()[\\]{}.,"'?!\\-;]).|` + `\\[(?:(?!${re.src_ZCc}|\\]).)*\\]|` + `\\((?:(?!${re.src_ZCc}|[)]).)*\\)|` + `\\{(?:(?!${re.src_ZCc}|[}]).)*\\}|` + `\\"(?:(?!${re.src_ZCc}|["]).)+\\"|` + `\\'(?:(?!${re.src_ZCc}|[']).)+\\'|` + // allow `I'm_king` if no pair found
    `\\'(?=${re.src_pseudo_letter}|[-])|` + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.{2,}[a-zA-Z0-9%/&]|' + `\\.(?!${re.src_ZCc}|[.]|$)|` + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + // allow `,,,` in paths
    `,(?!${re.src_ZCc}|$)|` + // allow `;` if not followed by space-like char
    `;(?!${re.src_ZCc}|$)|` + // allow `!!!` in paths, but not at the end
    `\\!+(?!${re.src_ZCc}|[!]|$)|` + `\\?(?!${re.src_ZCc}|[?]|$)` + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    // Max name length capped to 64 chars (RFC 5321). This also prevents O(n^2)
    // rescans to the end on inputs like `mailto:mailto:...`
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]{0,63}';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + `${re.src_pseudo_letter}{1,63}` + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + `(?:${re.src_pseudo_letter})` + '|' + `(?:${re.src_pseudo_letter}(?:-|${re.src_pseudo_letter}){0,61}${re.src_pseudo_letter})` + ')';
    re.src_host = '(?:' + // Don't need IP check, because digits are already allowed in normal domain names
    //   src_ip4 +
    // '|' +
    `(?:(?:(?:${re.src_domain})\\.)*${re.src_domain})` + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + `(?:(?:(?:${re.src_domain})\\.)+(?:%TLDS%))` + ')';
    re.tpl_host_no_ip_fuzzy = `(?:(?:(?:${re.src_domain})\\.)+(?:%TLDS%))`;
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    //
    // Main rules
    //
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = `localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:${re.src_ZPCc}|>|$))`;
    re.tpl_email_fuzzy = `(^|${text_separators}|"|\\(|${re.src_ZCc})` + `(${re.src_email_name}@${re.tpl_host_fuzzy_strict})`;
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    `(^|(?![.:/\\-_@])(?:[$+<=>^\`|\uff5c]|${re.src_ZPCc}))` + `((?![$+<=>^\`|\uff5c])${re.tpl_host_port_fuzzy_strict}${re.src_path})`;
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    `(^|(?![.:/\\-_@])(?:[$+<=>^\`|\uff5c]|${re.src_ZPCc}))` + `((?![$+<=>^\`|\uff5c])${re.tpl_host_port_no_ip_fuzzy_strict}${re.src_path})`;
    return re;
}

});
parcelRegister("aNtO2", function(module, exports) {
$parcel$export(module.exports, "Any", () => (parcelRequire("9pzVw")).default);
$parcel$export(module.exports, "Cc", () => (parcelRequire("fUT3l")).default);
$parcel$export(module.exports, "P", () => (parcelRequire("8BybH")).default);
$parcel$export(module.exports, "Z", () => (parcelRequire("5g06v")).default);

var $9pzVw = parcelRequire("9pzVw");

var $fUT3l = parcelRequire("fUT3l");

var $cIyAb = parcelRequire("cIyAb");

var $8BybH = parcelRequire("8BybH");

var $g80XX = parcelRequire("g80XX");

var $5g06v = parcelRequire("5g06v");

});
parcelRegister("9pzVw", function(module, exports) {
$parcel$export(module.exports, "default", () => $6da25128b08992af$export$2e2bcd8739ae039);
var $6da25128b08992af$export$2e2bcd8739ae039 = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("fUT3l", function(module, exports) {
$parcel$export(module.exports, "default", () => $b966ca5700a5fee1$export$2e2bcd8739ae039);
var $b966ca5700a5fee1$export$2e2bcd8739ae039 = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("cIyAb", function(module, exports) {
var $94246b7671df4eee$export$2e2bcd8739ae039 = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});

parcelRegister("8BybH", function(module, exports) {
$parcel$export(module.exports, "default", () => $643c4c64aeb0c9a2$export$2e2bcd8739ae039);
var $643c4c64aeb0c9a2$export$2e2bcd8739ae039 = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});

parcelRegister("g80XX", function(module, exports) {
var $bbde24862701b102$export$2e2bcd8739ae039 = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/;

});

parcelRegister("5g06v", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d3e87026be501c3$export$2e2bcd8739ae039);
var $3d3e87026be501c3$export$2e2bcd8739ae039 = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});










parcelRegister("lnr9T", function(module, exports) {
$parcel$export(module.exports, "strike", () => $f900d01941f2446d$export$4899a95d70ec5056);

var $P0RMo = parcelRequire("P0RMo");
var $f900d01941f2446d$export$4899a95d70ec5056 = (0, $P0RMo.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: function getAttrs(value) {
                return value === 'line-through' && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            's'
        ];
    }
});

});

parcelRegister("1u7ml", function(module, exports) {
$parcel$export(module.exports, "strong", () => $114e4d3027b06d18$export$59ae2c325a998f89);

var $P0RMo = parcelRequire("P0RMo");
/**
 * @name strong_mark
 */ var $114e4d3027b06d18$var$strongDOM = [
    'strong'
];
var $114e4d3027b06d18$var$BOLD_FONT_WEIGHT_REGEX = /^(bold(er)?|[5-9][0-9]{2,})$/;
var $114e4d3027b06d18$export$59ae2c325a998f89 = (0, $P0RMo.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs: function getAttrs(node) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs: function getAttrs(node) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var element = node;
                var fontWeight = element.style.fontWeight;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || $114e4d3027b06d18$var$BOLD_FONT_WEIGHT_REGEX.test(fontWeight)) && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return $114e4d3027b06d18$var$strongDOM;
    }
});

});

parcelRegister("1Ge5k", function(module, exports) {
$parcel$export(module.exports, "subsup", () => $1394a3af0d46a777$export$b3401ee80eb31041);

var $P0RMo = parcelRequire("P0RMo");
/**
 * @name subsup_mark
 */ function $1394a3af0d46a777$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
var $1394a3af0d46a777$export$b3401ee80eb31041 = (0, $P0RMo.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: function getAttrs(node) {
                return $1394a3af0d46a777$var$getAttrFromVerticalAlign(node);
            }
        },
        {
            style: 'vertical-align=sub',
            getAttrs: function getAttrs(node) {
                return $1394a3af0d46a777$var$getAttrFromVerticalAlign(node);
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("9htZc", function(module, exports) {
$parcel$export(module.exports, "typeAheadQuery", () => $6c1cf638064b66b7$export$20af3dabbb5538df);

var $P0RMo = parcelRequire("P0RMo");

var $22vaF = parcelRequire("22vaF");
var $6c1cf638064b66b7$export$20af3dabbb5538df = (0, $P0RMo.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: "color: ".concat((0, $22vaF.B400))
            }
        ];
    }
});

});

parcelRegister("1UbTw", function(module, exports) {
$parcel$export(module.exports, "underline", () => $16343f694e54def3$export$425327af25286e5e);

var $P0RMo = parcelRequire("P0RMo");
var $16343f694e54def3$export$425327af25286e5e = (0, $P0RMo.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: function getAttrs(value) {
                return value === 'underline' && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            'u'
        ];
    }
});

});

parcelRegister("8Krw2", function(module, exports) {
$parcel$export(module.exports, "unsupportedMark", () => $65e7f6ad6688b964$export$30d78d5eb6719bb8);

var $P0RMo = parcelRequire("P0RMo");
var $65e7f6ad6688b964$export$30d78d5eb6719bb8 = (0, $P0RMo.unsupportedMark)({
    toDOM: function toDOM() {
        return [
            'span'
        ];
    }
});

});

parcelRegister("9fdRd", function(module, exports) {
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $6bb04387db9b433f$export$a316dc07ff5182a2);

var $P0RMo = parcelRequire("P0RMo");
var $6bb04387db9b433f$export$a316dc07ff5182a2 = (0, $P0RMo.unsupportedNodeAttribute)({
    toDOM: function toDOM() {
        return [
            'span'
        ];
    }
});

});


parcelRegister("llovD", function(module, exports) {
$parcel$export(module.exports, "nodesInOrder", () => $f89e922b09a33a94$export$77d2c0ec1ddbfa6c);

var $TWIcC = parcelRequire("TWIcC");
var $1aipV = parcelRequire("1aipV");
var $7wC9F = parcelRequire("7wC9F");
var $aUdhc = parcelRequire("aUdhc");
var $gBea6 = parcelRequire("gBea6");
var $gBtp4 = parcelRequire("gBtp4");
var $enrSO = parcelRequire("enrSO");
var $ds6FG = parcelRequire("ds6FG");
var $28jyL = parcelRequire("28jyL");
var $h4Vhg = parcelRequire("h4Vhg");
var $gTQzU = parcelRequire("gTQzU");
var $Mas9e = parcelRequire("Mas9e");
var $6e7am = parcelRequire("6e7am");
var $cO5dd = parcelRequire("cO5dd");
var $ixGXu = parcelRequire("ixGXu");
var $r9xZG = parcelRequire("r9xZG");
var $4eHHu = parcelRequire("4eHHu");
var $kUp6y = parcelRequire("kUp6y");
var $js3fs = parcelRequire("js3fs");
var $eswVP = parcelRequire("eswVP");
var $cnShX = parcelRequire("cnShX");
var $5vwuc = parcelRequire("5vwuc");
var $blZvD = parcelRequire("blZvD");
var $lta2M = parcelRequire("lta2M");
var $7S1Am = parcelRequire("7S1Am");
var $7YGzk = parcelRequire("7YGzk");
var $kuUB8 = parcelRequire("kuUB8");
var $iXSQk = parcelRequire("iXSQk");
var $d79nc = parcelRequire("d79nc");
var $2Ji8g = parcelRequire("2Ji8g");
var $6wWv8 = parcelRequire("6wWv8");
var $21g1t = parcelRequire("21g1t");
var $jzlkh = parcelRequire("jzlkh");
var $8JhSw = parcelRequire("8JhSw");
var $kZNkK = parcelRequire("kZNkK");
var $jOBJC = parcelRequire("jOBJC");
var $5MY3X = parcelRequire("5MY3X");
var $91Dmj = parcelRequire("91Dmj");
var $gAmJ3 = parcelRequire("gAmJ3");
var $e29IV = parcelRequire("e29IV");
var $9IIBj = parcelRequire("9IIBj");
var $hG501 = parcelRequire("hG501");
var $gc8Zd = parcelRequire("gc8Zd");
var $4VFl9 = parcelRequire("4VFl9");
var $lPSeS = parcelRequire("lPSeS");
var $zEe3b = parcelRequire("zEe3b");
var $hAyYk = parcelRequire("hAyYk");
var $40acJ = parcelRequire("40acJ");

var $5BI9O = parcelRequire("5BI9O");
var $f89e922b09a33a94$export$77d2c0ec1ddbfa6c = [
    {
        name: 'doc',
        spec: (0, $cO5dd.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $91Dmj.paragraph)
    },
    {
        name: 'text',
        spec: (0, $lPSeS.text)
    },
    {
        name: 'bulletList',
        spec: (0, $gBea6.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $5MY3X.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $2Ji8g.listItem)
    },
    {
        name: 'heading',
        spec: (0, $lta2M.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $kUp6y.extendedBlockquote)
    },
    {
        name: 'codeBlock',
        spec: (0, $enrSO.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $js3fs.extendedPanel)(true)
    },
    {
        name: 'panel_c1',
        spec: (0, $eswVP.extendedPanelC1)(true)
    },
    {
        name: 'rule',
        spec: (0, $e29IV.rule)
    },
    {
        name: 'bodiedRule',
        spec: (0, $5BI9O.bodiedRule)
    },
    {
        name: 'image',
        spec: (0, $7S1Am.image)
    },
    {
        name: 'mention',
        spec: (0, $kZNkK.mention)
    },
    {
        name: 'caption',
        spec: (0, $gBtp4.caption)
    },
    {
        name: 'media',
        spec: (0, $6wWv8.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $21g1t.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $8JhSw.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $jzlkh.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $gAmJ3.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $d79nc.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $iXSQk.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $blZvD.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $r9xZG.emoji)
    },
    {
        name: 'table',
        spec: (0, $gc8Zd.table)
    },
    {
        name: 'tableCell',
        spec: (0, $gc8Zd.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $gc8Zd.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $gc8Zd.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $ds6FG.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $h4Vhg.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $28jyL.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $6e7am.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $Mas9e.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $4VFl9.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $1aipV.taskItem)
    },
    {
        name: 'blockTaskItem',
        spec: (0, $1aipV.blockTaskItem)
    },
    {
        name: 'date',
        spec: (0, $gTQzU.date)
    },
    {
        name: 'status',
        spec: (0, $9IIBj.status)
    },
    {
        name: 'expand',
        spec: (0, $4eHHu.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $jOBJC.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $cnShX.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $kuUB8.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $7wC9F.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $5vwuc.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $5vwuc.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $7YGzk.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $TWIcC.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $ixGXu.embedCard)
    },
    {
        name: 'syncBlock',
        spec: (0, $hG501.syncBlock)
    },
    {
        name: 'bodiedSyncBlock',
        spec: (0, $aUdhc.bodiedSyncBlock)
    },
    {
        name: 'unknownBlock',
        spec: (0, $zEe3b.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $hAyYk.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $40acJ.unsupportedInline)
    }
];

});
parcelRegister("TWIcC", function(module, exports) {
$parcel$export(module.exports, "blockCard", () => $0a82ae2359e888cd$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockCardWithLocalId", () => $0a82ae2359e888cd$export$9894f24949f094e5);

var $25nEq = parcelRequire("25nEq");

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
function $0a82ae2359e888cd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0a82ae2359e888cd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0a82ae2359e888cd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0a82ae2359e888cd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name blockCard_node
 */ var $0a82ae2359e888cd$var$getCommonAttributesFromDom = function getCommonAttributesFromDom(dom) {
    var anchor = dom;
    var data = anchor.getAttribute('data-card-data');
    var datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? // eslint-disable-next-line @atlaskit/editor/no-as-casting
        dom.getAttribute('data-layout') || undefined : undefined,
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
var $0a82ae2359e888cd$export$c4c2f833baaebdb8 = (0, $2gWGi.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $0a82ae2359e888cd$var$_objectSpread({
                    url: anchor.getAttribute('href') || undefined
                }, $0a82ae2359e888cd$var$getCommonAttributesFromDom(dom));
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $0a82ae2359e888cd$var$_objectSpread({
                    url: anchor.getAttribute('data-card-url') || undefined
                }, $0a82ae2359e888cd$var$getCommonAttributesFromDom(dom));
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var _ref = node.attrs, url = _ref.url;
        var _ref2 = node.attrs, data = _ref2.data;
        var _ref3 = node.attrs, layout = _ref3.layout, width = _ref3.width, datasource = _ref3.datasource;
        var attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': "".concat(width)
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});
var $0a82ae2359e888cd$export$9894f24949f094e5 = (0, $2gWGi.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $0a82ae2359e888cd$var$_objectSpread($0a82ae2359e888cd$var$_objectSpread({
                    url: anchor.getAttribute('href') || undefined
                }, $0a82ae2359e888cd$var$getCommonAttributesFromDom(dom)), {}, {
                    localId: (0, $l4823.uuid).generate()
                });
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $0a82ae2359e888cd$var$_objectSpread($0a82ae2359e888cd$var$_objectSpread({
                    url: anchor.getAttribute('data-card-url') || undefined
                }, $0a82ae2359e888cd$var$getCommonAttributesFromDom(dom)), {}, {
                    localId: (0, $l4823.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2, _node$attrs3;
        var _ref4 = node.attrs, url = _ref4.url;
        var _ref5 = node.attrs, data = _ref5.data;
        var _ref6 = node.attrs, layout = _ref6.layout, width = _ref6.width, datasource = _ref6.datasource;
        var attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': "".concat(width),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.url) || ' '
        ];
    }
});

});
parcelRegister("2gWGi", function(module, exports) {
$parcel$export(module.exports, "blockCard", () => $1a7a9844253df8d3$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $1a7a9844253df8d3$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteLegacy", () => $1a7a9844253df8d3$export$199922e5af8e9a6);
$parcel$export(module.exports, "blockTaskItem", () => $1a7a9844253df8d3$export$16018c61064a18df);
$parcel$export(module.exports, "bodiedExtension", () => $1a7a9844253df8d3$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedRuleStage0", () => $1a7a9844253df8d3$export$fedbe6c839176437);
$parcel$export(module.exports, "bodiedSyncBlock", () => $1a7a9844253df8d3$export$e92c7e4302dd4371);
$parcel$export(module.exports, "bulletList", () => $1a7a9844253df8d3$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $1a7a9844253df8d3$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "codeBlock", () => $1a7a9844253df8d3$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "confluenceJiraIssue", () => $1a7a9844253df8d3$export$daf889beb5092f95);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $1a7a9844253df8d3$export$e6e4878f43c27cab);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $1a7a9844253df8d3$export$3e6d667072febc87);
$parcel$export(module.exports, "date", () => $1a7a9844253df8d3$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $1a7a9844253df8d3$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $1a7a9844253df8d3$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $1a7a9844253df8d3$export$2a111da947c407d2);
$parcel$export(module.exports, "embedCard", () => $1a7a9844253df8d3$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $1a7a9844253df8d3$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $1a7a9844253df8d3$export$9f77e0932fb78f72);
$parcel$export(module.exports, "extension", () => $1a7a9844253df8d3$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionFrameStage0", () => $1a7a9844253df8d3$export$b555be60c7703afb);
$parcel$export(module.exports, "hardBreak", () => $1a7a9844253df8d3$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $1a7a9844253df8d3$export$46e4a324ac90507f);
$parcel$export(module.exports, "image", () => $1a7a9844253df8d3$export$5c452ff88e35e47d);
$parcel$export(module.exports, "inlineCard", () => $1a7a9844253df8d3$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtensionWithMarks", () => $1a7a9844253df8d3$export$b3b1e36c2105006d);
$parcel$export(module.exports, "layoutColumn", () => $1a7a9844253df8d3$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $1a7a9844253df8d3$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionFull", () => $1a7a9844253df8d3$export$cdae19acb0a520fd);
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", () => $1a7a9844253df8d3$export$206007566ca0aca5);
$parcel$export(module.exports, "listItem", () => $1a7a9844253df8d3$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "media", () => $1a7a9844253df8d3$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $1a7a9844253df8d3$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $1a7a9844253df8d3$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $1a7a9844253df8d3$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleCaption", () => $1a7a9844253df8d3$export$8d067f22dc2d1254);
$parcel$export(module.exports, "mediaSingleFull", () => $1a7a9844253df8d3$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleWidthType", () => $1a7a9844253df8d3$export$4bd9a38995f6bf50);
$parcel$export(module.exports, "mention", () => $1a7a9844253df8d3$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtensionStage0", () => $1a7a9844253df8d3$export$750e45819f66d9d0);
$parcel$export(module.exports, "nestedExpand", () => $1a7a9844253df8d3$export$63cadbf5f4296627);
$parcel$export(module.exports, "orderedList", () => $1a7a9844253df8d3$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $1a7a9844253df8d3$export$21f42ab9b6679f44);
$parcel$export(module.exports, "panelC1Stage0", () => $1a7a9844253df8d3$export$6f6742e395e02fdc);
$parcel$export(module.exports, "paragraph", () => $1a7a9844253df8d3$export$9c206ddddb32a9b);
$parcel$export(module.exports, "placeholder", () => $1a7a9844253df8d3$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $1a7a9844253df8d3$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $1a7a9844253df8d3$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "syncBlock", () => $1a7a9844253df8d3$export$faab0ca9701d7048);
$parcel$export(module.exports, "table", () => $1a7a9844253df8d3$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithNestedTable", () => $1a7a9844253df8d3$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableCell", () => $1a7a9844253df8d3$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $1a7a9844253df8d3$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeader", () => $1a7a9844253df8d3$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $1a7a9844253df8d3$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRow", () => $1a7a9844253df8d3$export$ce666bf02318c957);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $1a7a9844253df8d3$export$7d657479499397);
$parcel$export(module.exports, "taskItem", () => $1a7a9844253df8d3$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $1a7a9844253df8d3$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $1a7a9844253df8d3$export$6f093cfa640b7166);
$parcel$export(module.exports, "unsupportedBlock", () => $1a7a9844253df8d3$export$44b79b0979d0f0f7);
$parcel$export(module.exports, "unsupportedInline", () => $1a7a9844253df8d3$export$310ebe0d80122e9b);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "afm workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $hwyVv = parcelRequire("hwyVv");
var $1a7a9844253df8d3$export$c4c2f833baaebdb8 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        },
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $1a7a9844253df8d3$export$67dc04e652a298ca = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
var $1a7a9844253df8d3$export$199922e5af8e9a6 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
var $1a7a9844253df8d3$export$16018c61064a18df = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(paragraph | extension) (paragraph | extension)*',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
var $1a7a9844253df8d3$export$27903d543b563e39 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
var $1a7a9844253df8d3$export$8bbe5aa5bba36cc1 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
var $1a7a9844253df8d3$export$e7320d153c538837 = (0, $hwyVv.createPMNodeSpecFactory)({
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
var $1a7a9844253df8d3$export$208411233915368e = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(paragraph | heading){1,1}',
    attrs: {
        localId: {
            default: ''
        },
        alignment: {
            default: null
        },
        color: {
            default: null
        },
        style: {
            default: null
        },
        weight: {
            default: null
        }
    }
});
var $1a7a9844253df8d3$export$fedbe6c839176437 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(paragraph | heading){1,1}',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        },
        alignment: {
            default: null
        },
        color: {
            default: null
        },
        style: {
            default: null
        },
        weight: {
            default: null
        }
    }
});
var $1a7a9844253df8d3$export$e92c7e4302dd4371 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(paragraph | blockCard | blockquote | bulletList | codeBlock | confluenceUnsupportedBlock | decisionList | embedCard | expand | heading | layoutSection | mediaGroup | mediaSingle | orderedList | panel_c1 | panel | rule | bodiedRule | table | taskList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fontSize alignment indentation breakout link fragment',
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true,
    isolating: true
});
var $1a7a9844253df8d3$export$a140c94e5ea26bee = (0, $hwyVv.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $1a7a9844253df8d3$export$8e3c2dfdc4f0453d = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
var $1a7a9844253df8d3$export$7bb0d5c671655cc4 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        },
        wrap: {
            default: null
        },
        hideLineNumbers: {
            default: false
        }
    },
    code: true,
    defining: true
});
var $1a7a9844253df8d3$export$e4f1c66d84049f8b = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        },
        wrap: {
            default: null
        },
        hideLineNumbers: {
            default: false
        }
    },
    code: true,
    defining: true
});
var $1a7a9844253df8d3$export$daf889beb5092f95 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
var $1a7a9844253df8d3$export$e6e4878f43c27cab = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
var $1a7a9844253df8d3$export$3e6d667072febc87 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
var $1a7a9844253df8d3$export$324d90190a8b822a = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$47988d68fe575725 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$6959e16eeff859b4 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
var $1a7a9844253df8d3$export$62d45a65fb43d95e = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
var $1a7a9844253df8d3$export$2a111da947c407d2 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(block | panel_c1 | codeBlock | panel | panel_c1_root_only | rule | bodiedRule | extension | bodiedExtension | multiBodiedExtension | layoutSection | blockRootOnly | expand | syncBlock | bodiedSyncBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fontSize alignment indentation dataConsumer fragment annotation breakout'
});
var $1a7a9844253df8d3$export$be4283d9a1cb1ff6 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$a19185d1233fc4b2 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$f5574b5d45fc2112 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$9f77e0932fb78f72 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute fragment dataConsumer annotation',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $1a7a9844253df8d3$export$7e3788972005cc72 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute fragment dataConsumer annotation',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $1a7a9844253df8d3$export$1b45514b112dd749 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$ad06037362b3c3b3 = (0, $hwyVv.createPMNodeSpecFactory)({
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$243bc54b0560ecc = (0, $hwyVv.createPMNodeSpecFactory)({
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$3e3366ebd634cc62 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$a8baf338431a691 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$b555be60c7703afb = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
var $1a7a9844253df8d3$export$371da9dd35aba193 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    linebreakReplacement: true
});
var $1a7a9844253df8d3$export$46e4a324ac90507f = (0, $hwyVv.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $1a7a9844253df8d3$export$1b0c1557b234fa00 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $1a7a9844253df8d3$export$85461f751c457cc2 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $1a7a9844253df8d3$export$2b380a0f7e250af1 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $1a7a9844253df8d3$export$5c452ff88e35e47d = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
var $1a7a9844253df8d3$export$cbf8224b64e0d942 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $1a7a9844253df8d3$export$2f4e72b9459914ad = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $1a7a9844253df8d3$export$16b353b2649bd8d9 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$b3b1e36c2105006d = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$ab76e7c03cd6f650 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(block | panel_c1 | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fontSize alignment indentation dataConsumer fragment annotation',
    attrs: {
        width: {
            default: undefined
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
var $1a7a9844253df8d3$export$b3b6a70a7fa4a5be = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
var $1a7a9844253df8d3$export$cdae19acb0a520fd = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
var $1a7a9844253df8d3$export$206007566ca0aca5 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        },
        localId: {
            default: null
        }
    },
    isolating: true
});
var $1a7a9844253df8d3$export$76c7e83ecc9cdf05 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $1a7a9844253df8d3$export$987d49ffe1b0900f = (0, $hwyVv.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$2855e964765eac9 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
var $1a7a9844253df8d3$export$38bab695e3f720f1 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$969fe3781ca15058 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
var $1a7a9844253df8d3$export$8d067f22dc2d1254 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$7e767666f2ce108a = (0, $hwyVv.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$4bd9a38995f6bf50 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$db83999c14438df4 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$46f790bd65f760d0 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$6f4c18ddc3950a66 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
var $1a7a9844253df8d3$export$750e45819f66d9d0 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
var $1a7a9844253df8d3$export$63cadbf5f4296627 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | bodiedRule | panel | blockquote | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $1a7a9844253df8d3$export$f03786aa6312d1e4 = (0, $hwyVv.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $1a7a9844253df8d3$export$a5dc81035676e7a = (0, $hwyVv.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
var $1a7a9844253df8d3$export$21f42ab9b6679f44 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | bodiedRule | decisionList | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$862432e0a10d1bc1 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | bodiedRule | decisionList | unsupportedBlock | extension | table)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$6f6742e395e02fdc = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | bodiedRule | decisionList | unsupportedBlock | extension | table)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$7eb9416336a42c2b = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | bodiedRule | decisionList | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$9c206ddddb32a9b = (0, $hwyVv.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $1a7a9844253df8d3$export$4f98472e6dc14293 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $1a7a9844253df8d3$export$b0710a201beac6b2 = (0, $hwyVv.createPMNodeSpecFactory)({
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $1a7a9844253df8d3$export$ea332b61641b0588 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $1a7a9844253df8d3$export$a1f41dc4901771f8 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $1a7a9844253df8d3$export$c7187bbd1a7a9244 = (0, $hwyVv.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
var $1a7a9844253df8d3$export$fbeb3a3956e8a3c7 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    }
});
var $1a7a9844253df8d3$export$1d53b70195c9c417 = (0, $hwyVv.createPMNodeSpecFactory)({
    attrs: {
        localId: {
            default: null
        }
    }
});
var $1a7a9844253df8d3$export$78cca5eef2450890 = (0, $hwyVv.createPMNodeSpecFactory)({
    attrs: {
        localId: {
            default: null
        },
        color: {
            default: null
        },
        style: {
            default: null
        },
        weight: {
            default: null
        }
    }
});
var $1a7a9844253df8d3$export$17f7139bf40eed49 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        },
        color: {
            default: null
        },
        style: {
            default: null
        },
        weight: {
            default: null
        }
    }
});
var $1a7a9844253df8d3$export$471f7ae5c4103ae1 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$b6ce52be8d7a261 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$faab0ca9701d7048 = (0, $hwyVv.createPMNodeSpecFactory)({
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$9852986a3ec5f6a0 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
var $1a7a9844253df8d3$export$ce086a560a1d05f5 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
var $1a7a9844253df8d3$export$e1e720e5f4603e6a = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
var $1a7a9844253df8d3$export$abf39ca178940ff3 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
var $1a7a9844253df8d3$export$48884d2a5190dc73 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
var $1a7a9844253df8d3$export$2a5a518232fa1a97 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
var $1a7a9844253df8d3$export$ce666bf02318c957 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
var $1a7a9844253df8d3$export$7d657479499397 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
var $1a7a9844253df8d3$export$6d8b0ef52e2e6390 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
var $1a7a9844253df8d3$export$375b6afcc5f4d291 = (0, $hwyVv.createPMNodeSpecFactory)({
    content: '(taskItem | taskList | unsupportedBlock | blockTaskItem)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
var $1a7a9844253df8d3$export$6f093cfa640b7166 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'inline'
});
var $1a7a9844253df8d3$export$5ea06bc686c59dc2 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'inline'
});
var $1a7a9844253df8d3$export$93256a4c17b33a82 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'inline'
});
var $1a7a9844253df8d3$export$a12828d0f14a2762 = (0, $hwyVv.createPMNodeSpecFactory)({});
var $1a7a9844253df8d3$export$44b79b0979d0f0f7 = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$310ebe0d80122e9b = (0, $hwyVv.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("hwyVv", function(module, exports) {
$parcel$export(module.exports, "createPMNodeSpecFactory", () => $cc208487ae3bfd91$export$bf0a80f00e2b8ff6);

var $25nEq = parcelRequire("25nEq");
function $cc208487ae3bfd91$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cc208487ae3bfd91$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cc208487ae3bfd91$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cc208487ae3bfd91$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cc208487ae3bfd91$export$bf0a80f00e2b8ff6 = function createPMNodeSpecFactory(nodeSpec) {
    return function(_ref) {
        var parseDOM = _ref.parseDOM, toDOM = _ref.toDOM, toDebugString = _ref.toDebugString;
        // @ts-ignore
        return $cc208487ae3bfd91$var$_objectSpread($cc208487ae3bfd91$var$_objectSpread($cc208487ae3bfd91$var$_objectSpread($cc208487ae3bfd91$var$_objectSpread({}, nodeSpec), parseDOM && {
            parseDOM: parseDOM
        }), toDOM && {
            toDOM: toDOM
        }), toDebugString && {
            toDebugString: toDebugString
        });
    };
};

});


parcelRegister("l4823", function(module, exports) {
$parcel$export(module.exports, "generateUuid", () => $f56033af584a611e$export$1c3aefb711c3a4cc);
$parcel$export(module.exports, "uuid", () => $f56033af584a611e$export$31b40729666a4ae0);
var $f56033af584a611e$export$1c3aefb711c3a4cc = function generateUuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $f56033af584a611e$var$staticValue = false;
var $f56033af584a611e$export$31b40729666a4ae0 = {
    setStatic: function setStatic(value) {
        $f56033af584a611e$var$staticValue = value;
    },
    generate: function generate() {
        return $f56033af584a611e$var$staticValue || $f56033af584a611e$export$1c3aefb711c3a4cc();
    }
};

});


parcelRegister("1aipV", function(module, exports) {
$parcel$export(module.exports, "taskItem", () => $0d9502dc3a462c45$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "blockTaskItem", () => $0d9502dc3a462c45$export$16018c61064a18df);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
var $0d9502dc3a462c45$export$6d8b0ef52e2e6390 = (0, $2gWGi.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $l4823.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    state: dom.getAttribute('data-task-state') || 'TODO'
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $0d9502dc3a462c45$export$16018c61064a18df = (0, $2gWGi.blockTaskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-is-block]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $l4823.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    state: dom.getAttribute('data-task-state') || 'TODO'
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2 = node.attrs, localId = _node$attrs2.localId, state = _node$attrs2.state;
        var attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO',
            'data-task-is-block': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("7wC9F", function(module, exports) {
$parcel$export(module.exports, "bodiedExtension", () => $57a91e507a072423$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedExtensionRootOnlyStage0", () => $57a91e507a072423$export$8bbe5aa5bba36cc1);

var $25nEq = parcelRequire("25nEq");

var $2gWGi = parcelRequire("2gWGi");

var $5LLLi = parcelRequire("5LLLi");
function $57a91e507a072423$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $57a91e507a072423$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $57a91e507a072423$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $57a91e507a072423$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $57a91e507a072423$export$27903d543b563e39 = (0, $2gWGi.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: function getAttrs(domNode) {
                return (0, $5LLLi.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $57a91e507a072423$export$8bbe5aa5bba36cc1 = $57a91e507a072423$var$_objectSpread($57a91e507a072423$var$_objectSpread({}, $57a91e507a072423$export$27903d543b563e39), {}, {
    marks: "breakout ".concat($57a91e507a072423$export$27903d543b563e39.marks)
});

});
parcelRegister("5LLLi", function(module, exports) {
$parcel$export(module.exports, "getExtensionAttrs", () => $4336640aab8f5b1f$export$1765e2758fc47004);

var $k6ZLN = parcelRequire("k6ZLN");
var $4336640aab8f5b1f$export$1765e2758fc47004 = function getExtensionAttrs(dom) {
    var isInline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var extensionType = dom.getAttribute('data-extension-type');
    var extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    var attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        var rawLayout = dom.getAttribute('data-layout');
        attrs.layout = (0, $k6ZLN.isValidLayout)(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});
parcelRegister("k6ZLN", function(module, exports) {
$parcel$export(module.exports, "isValidLayout", () => $ea44486b2bc9c87e$export$d5f21755dc782a4a);
var $ea44486b2bc9c87e$export$d5f21755dc782a4a = function isValidLayout(name) {
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};

});



parcelRegister("aUdhc", function(module, exports) {
$parcel$export(module.exports, "bodiedSyncBlock", () => $7f096ec34d684944$export$e92c7e4302dd4371);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
var $7f096ec34d684944$export$e92c7e4302dd4371 = (0, $2gWGi.bodiedSyncBlock)({
    parseDOM: [
        {
            tag: 'div[data-bodied-sync-block]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $l4823.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, resourceId = _node$attrs.resourceId;
        var name = 'div';
        var attrs = {
            'data-bodied-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs,
            0
        ];
    }
});

});

parcelRegister("gBea6", function(module, exports) {
$parcel$export(module.exports, "bulletListSelector", () => $c15b164f097d5ffe$export$5f25a39efab3b58b);
$parcel$export(module.exports, "bulletList", () => $c15b164f097d5ffe$export$a140c94e5ea26bee);
$parcel$export(module.exports, "bulletListWithLocalId", () => $c15b164f097d5ffe$export$dfd406053b2bab40);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
var $c15b164f097d5ffe$export$5f25a39efab3b58b = '.ak-ul';
var $c15b164f097d5ffe$export$a140c94e5ea26bee = (0, $2gWGi.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            class: $c15b164f097d5ffe$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});
var $c15b164f097d5ffe$export$dfd406053b2bab40 = (0, $2gWGi.bulletList)({
    parseDOM: [
        {
            tag: 'ul',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            class: $c15b164f097d5ffe$export$5f25a39efab3b58b.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});

});

parcelRegister("gBtp4", function(module, exports) {
$parcel$export(module.exports, "caption", () => $c166e8f567426a89$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "captionWithLocalId", () => $c166e8f567426a89$export$b5d01ee303c467aa);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
var $c166e8f567426a89$export$8e3c2dfdc4f0453d = (0, $2gWGi.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});
var $c166e8f567426a89$export$b5d01ee303c467aa = (0, $2gWGi.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-caption': 'true'
        };
        if ((node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) !== undefined) attrs['data-local-id'] = node.attrs.localId;
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});

});

parcelRegister("enrSO", function(module, exports) {
$parcel$export(module.exports, "codeBlock", () => $a778d7ac22429d96$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "toJSON", () => $a778d7ac22429d96$export$54fd2c36b5cc6731);
$parcel$export(module.exports, "codeBlockWithLocalId", () => $a778d7ac22429d96$export$3f75de798a0b5356);

var $9Jwkl = parcelRequire("9Jwkl");

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
/**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_node
 */ var $a778d7ac22429d96$var$getLanguageFromEditorStyle = function getLanguageFromEditorStyle(dom) {
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
var $a778d7ac22429d96$var$getLanguageFromBitbucketStyle = function getLanguageFromBitbucketStyle(dom) {
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $a778d7ac22429d96$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
var $a778d7ac22429d96$var$getLanguageFromCode = function getLanguageFromCode(dom) {
    var firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
var $a778d7ac22429d96$var$LANGUAGE_CLASS_REGEX = /(?:^|[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])language-((?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)/;
var $a778d7ac22429d96$var$TRAILING_NEWLINE_REGEX = /\n$/;
var $a778d7ac22429d96$var$extractLanguageFromClass = function extractLanguageFromClass(className) {
    var result = $a778d7ac22429d96$var$LANGUAGE_CLASS_REGEX.exec(className);
    if (result && result[1]) return result[1];
    return;
};
var $a778d7ac22429d96$var$removeLastNewLine = function removeLastNewLine(dom) {
    var parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    dom.textContent = dom.textContent.replace($a778d7ac22429d96$var$TRAILING_NEWLINE_REGEX, '');
    return dom;
};
function $a778d7ac22429d96$var$parseCodeFromHtml(node) {
    var code = '';
    node.childNodes.forEach(function(child) {
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            var tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $a778d7ac22429d96$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
var $a778d7ac22429d96$export$7bb0d5c671655cc4 = (0, $2gWGi.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var language = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $a778d7ac22429d96$var$getLanguageFromBitbucketStyle(dom.parentElement) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $a778d7ac22429d96$var$getLanguageFromEditorStyle(dom.parentElement) || $a778d7ac22429d96$var$getLanguageFromCode(dom) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-language');
                dom = $a778d7ac22429d96$var$removeLastNewLine(dom);
                var wrapAttr = dom.getAttribute('data-wrap');
                var isCopiedFromEditor = Boolean(dom.closest('[data-pm-slice]') || dom.hasAttribute('data-pm-slice'));
                // Default external HTML paste to wrapped when data-wrap is absent, but preserve
                // unwrapped editor-origin paste when copied content has data-pm-slice.
                var wrap = wrapAttr === null ? !isCopiedFromEditor : wrapAttr !== 'false';
                var hideLineNumbers = dom.getAttribute('data-hide-line-numbers') === 'true';
                return {
                    language: language,
                    wrap: wrap,
                    hideLineNumbers: hideLineNumbers,
                    localId: (0, $l4823.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {
                    wrap: true
                };
                return false;
            },
            getContent: function getContent(domNode, schema) {
                var code = $a778d7ac22429d96$var$parseCodeFromHtml(domNode);
                return code ? (0, $9Jwkl.Fragment).from(schema.text(code)) : (0, $9Jwkl.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (dom.querySelector('td[class*="blob-code"]')) return {
                    wrap: true
                };
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                // TODO: ED-5604 - Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                var lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach(function(line) {
                    return line.remove();
                });
                return {
                    wrap: true
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {};
        if ((node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) !== undefined) attrs['data-local-id'] = node.attrs.localId;
        // Always serialize data-wrap explicitly (both true and false) so that
        // editor-to-editor paste can distinguish intentional wrap:false from
        // absent data-wrap (which parseDOM defaults to wrap:true for external HTML).
        attrs['data-wrap'] = node.attrs.wrap ? 'true' : 'false';
        if (node.attrs.hideLineNumbers) attrs['data-hide-line-numbers'] = 'true';
        return [
            'pre',
            attrs,
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
var $a778d7ac22429d96$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: Object.keys(node.attrs).reduce(function(memo, key) {
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            if (key === 'wrap' && node.attrs.wrap === null) return memo;
            if (key === 'hideLineNumbers' && !node.attrs.hideLineNumbers) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    };
};
var $a778d7ac22429d96$export$3f75de798a0b5356 = (0, $2gWGi.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var language = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $a778d7ac22429d96$var$getLanguageFromBitbucketStyle(dom.parentElement) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $a778d7ac22429d96$var$getLanguageFromEditorStyle(dom.parentElement) || $a778d7ac22429d96$var$getLanguageFromCode(dom) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-language');
                dom = $a778d7ac22429d96$var$removeLastNewLine(dom);
                return {
                    language: language,
                    localId: (0, $l4823.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: function getContent(domNode, schema) {
                var code = $a778d7ac22429d96$var$parseCodeFromHtml(domNode);
                return code ? (0, $9Jwkl.Fragment).from(schema.text(code)) : (0, $9Jwkl.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                // TODO: ED-5604 - Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                var lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach(function(line) {
                    return line.remove();
                });
                return {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        var attrs = {};
        if ((node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) !== undefined) attrs['data-local-id'] = node.attrs.localId;
        return [
            'pre',
            attrs,
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});

});

parcelRegister("ds6FG", function(module, exports) {
$parcel$export(module.exports, "confluenceJiraIssue", () => $9cb310ab708b0703$export$daf889beb5092f95);

var $2gWGi = parcelRequire("2gWGi");
var $9cb310ab708b0703$var$name = 'confluenceJiraIssue';
var $9cb310ab708b0703$export$daf889beb5092f95 = (0, $2gWGi.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: "span[data-node-type=\"".concat($9cb310ab708b0703$var$name, "\"]"),
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': $9cb310ab708b0703$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("28jyL", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $18db804d55481544$export$e6e4878f43c27cab);

var $2gWGi = parcelRequire("2gWGi");
var $18db804d55481544$var$name = 'confluenceUnsupportedBlock';
var $18db804d55481544$export$e6e4878f43c27cab = (0, $2gWGi.confluenceUnsupportedBlock)({
    toDOM: function toDOM(node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        var attrs = {
            'data-node-type': $18db804d55481544$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($18db804d55481544$var$name, "\"]"),
            getAttrs: function getAttrs(dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("h4Vhg", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $c6ef3d8205120509$export$3e6d667072febc87);

var $2gWGi = parcelRequire("2gWGi");
var $c6ef3d8205120509$var$name = 'confluenceUnsupportedInline';
var $c6ef3d8205120509$export$3e6d667072febc87 = (0, $2gWGi.confluenceUnsupportedInline)({
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': $c6ef3d8205120509$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($c6ef3d8205120509$var$name, "\"]"),
            getAttrs: function getAttrs(dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("gTQzU", function(module, exports) {
$parcel$export(module.exports, "date", () => $c4da91508771171b$export$324d90190a8b822a);
$parcel$export(module.exports, "dateWithLocalId", () => $c4da91508771171b$export$a6a035390e3921b2);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
var $c4da91508771171b$export$324d90190a8b822a = (0, $2gWGi.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: function getAttrs(dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    timestamp: dom.getAttribute('data-timestamp')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});
var $c4da91508771171b$export$a6a035390e3921b2 = (0, $2gWGi.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: function getAttrs(dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    timestamp: dom.getAttribute('data-timestamp'),
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("Mas9e", function(module, exports) {
$parcel$export(module.exports, "decisionItem", () => $090c978eb6381123$export$6959e16eeff859b4);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
var $090c978eb6381123$export$6959e16eeff859b4 = (0, $2gWGi.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $l4823.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    state: dom.getAttribute('data-decision-state')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});

});

parcelRegister("6e7am", function(module, exports) {
$parcel$export(module.exports, "decisionListSelector", () => $48899bf20ae374f5$export$a5393ce68c2ff601);
$parcel$export(module.exports, "decisionList", () => $48899bf20ae374f5$export$62d45a65fb43d95e);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
/**
 * @name decisionList_node
 */ var $48899bf20ae374f5$var$name = 'decisionList';
var $48899bf20ae374f5$export$a5393ce68c2ff601 = "[data-node-type=\"".concat($48899bf20ae374f5$var$name, "\"]");
var $48899bf20ae374f5$export$62d45a65fb43d95e = (0, $2gWGi.decisionList)({
    parseDOM: [
        {
            tag: "ol".concat($48899bf20ae374f5$export$a5393ce68c2ff601),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-node-type': $48899bf20ae374f5$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("cO5dd", function(module, exports) {
$parcel$export(module.exports, "doc", () => $952e328fc7258c40$export$2a111da947c407d2);

var $2gWGi = parcelRequire("2gWGi");
var $952e328fc7258c40$export$2a111da947c407d2 = (0, $2gWGi.doc)({});

});

parcelRegister("ixGXu", function(module, exports) {
$parcel$export(module.exports, "embedCard", () => $d7fca1c0c60154bd$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "embedCardWithLocalId", () => $d7fca1c0c60154bd$export$36734475a7f6fd3e);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
var $d7fca1c0c60154bd$export$be4283d9a1cb1ff6 = (0, $2gWGi.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: function getAttrs(dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    url: dom.getAttribute('data-card-url'),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    layout: dom.getAttribute('data-layout') || 'center',
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-height')) || null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, url = _node$attrs.url, layout = _node$attrs.layout, width = _node$attrs.width, originalWidth = _node$attrs.originalWidth, originalHeight = _node$attrs.originalHeight;
        var attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});
var $d7fca1c0c60154bd$export$36734475a7f6fd3e = (0, $2gWGi.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: function getAttrs(dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    url: dom.getAttribute('data-card-url'),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    layout: dom.getAttribute('data-layout') || 'center',
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-height')) || null,
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3;
        var _node$attrs2 = node.attrs, url = _node$attrs2.url, layout = _node$attrs2.layout, width = _node$attrs2.width, originalWidth = _node$attrs2.originalWidth, originalHeight = _node$attrs2.originalHeight;
        var attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.localId) || undefined
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("r9xZG", function(module, exports) {
$parcel$export(module.exports, "emoji", () => $0519ed9fba260554$export$a19185d1233fc4b2);
$parcel$export(module.exports, "emojiWithLocalId", () => $0519ed9fba260554$export$ebb3b3c7a0ac9936);

var $25nEq = parcelRequire("25nEq");

var $2gWGi = parcelRequire("2gWGi");

var $8Gocz = parcelRequire("8Gocz");

var $crUxN = parcelRequire("crUxN");

var $l4823 = parcelRequire("l4823");
function $0519ed9fba260554$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0519ed9fba260554$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0519ed9fba260554$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0519ed9fba260554$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0519ed9fba260554$export$a19185d1233fc4b2 = (0, $2gWGi.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $0519ed9fba260554$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $0519ed9fba260554$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $0519ed9fba260554$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getAttrs: function getAttrs(dom) {
                return (0, $8Gocz.acNameToEmoji)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                dom.getAttribute('data-emoticon-name'));
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            getAttrs: function getAttrs(dom) {
                return (0, $crUxN.acShortcutToEmoji)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-hipchat-emoticon'));
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $0519ed9fba260554$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $0519ed9fba260554$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $0519ed9fba260554$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, shortName = _node$attrs.shortName, id = _node$attrs.id, text = _node$attrs.text;
        var attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
var $0519ed9fba260554$export$ebb3b3c7a0ac9936 = (0, $2gWGi.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $0519ed9fba260554$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $0519ed9fba260554$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $0519ed9fba260554$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $l4823.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: function getAttrs(dom) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var attrs = (0, $8Gocz.acNameToEmoji)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                dom.getAttribute('data-emoticon-name'));
                return $0519ed9fba260554$var$_objectSpread($0519ed9fba260554$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $l4823.uuid).generate()
                });
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: function getAttrs(dom) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                var attrs = (0, $crUxN.acShortcutToEmoji)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-hipchat-emoticon'));
                return $0519ed9fba260554$var$_objectSpread($0519ed9fba260554$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $l4823.uuid).generate()
                });
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $0519ed9fba260554$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $0519ed9fba260554$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $0519ed9fba260554$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3;
        var _node$attrs2 = node.attrs, shortName = _node$attrs2.shortName, id = _node$attrs2.id, text = _node$attrs2.text;
        var attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.localId) || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("8Gocz", function(module, exports) {
$parcel$export(module.exports, "acNameToEmoji", () => $652504e940a87f2a$export$f61e93bda2a8b420);

var $iQj8k = parcelRequire("iQj8k");

var $6ktYw = parcelRequire("6ktYw");
function $652504e940a87f2a$export$f61e93bda2a8b420(acName) {
    var emojiData = (0, $iQj8k.acNameToEmojiMap)[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: (0, $6ktYw.DEFAULT_EMOJI_ID),
        shortName: ":".concat(acName, ":"),
        text: ''
    };
}

});
parcelRegister("iQj8k", function(module, exports) {
$parcel$export(module.exports, "acNameToEmojiMap", () => $db7becc88de48a9a$export$7962498ea8ccffac);
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ var $db7becc88de48a9a$export$7962498ea8ccffac = {
    smile: [
        '1f642',
        ':slight_smile:',
        "\uD83D\uDE42"
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        "\uD83D\uDE41"
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        "\uD83D\uDE1B"
    ],
    laugh: [
        '1f600',
        ':grinning:',
        "\uD83D\uDE00"
    ],
    wink: [
        '1f609',
        ':wink:',
        "\uD83D\uDE09"
    ],
    information: [
        '2139',
        ':information_source:',
        "\u2139"
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        "\u2705"
    ],
    cross: [
        '274c',
        ':x:',
        "\u274C"
    ],
    warning: [
        '26a0',
        ':warning:',
        "\u26A0"
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        "\u2795"
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        "\u2796"
    ],
    question: [
        '2753',
        ':question:',
        "?"
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        "\uD83D\uDC4D"
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        "\uD83D\uDC4E"
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        "\uD83D\uDCA1"
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        "\uD83D\uDC9B"
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        "\uD83D\uDEAB"
    ],
    'red-star': [
        '2764',
        ':heart:',
        "\u2764\uFE0F"
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        "\uD83D\uDC9A"
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        "\uD83D\uDC99"
    ],
    heart: [
        '2764',
        ':heart:',
        "\u2764\uFE0F"
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        "\uD83D\uDC94"
    ]
};

});

parcelRegister("6ktYw", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_EMOJI_ID", () => $49bbdccb6782eda4$export$936e67708ade64a9);
$parcel$export(module.exports, "HC_EMOTICON_PREFIX", () => $49bbdccb6782eda4$export$1c102a772ecd912c);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ // Default emoji id for Confluence glyphs that has no match to Fabric Emoji





var $49bbdccb6782eda4$export$936e67708ade64a9 = '2b50';
var $49bbdccb6782eda4$export$209b328f48821d5f = 'blue-star';
var $49bbdccb6782eda4$export$1c102a772ecd912c = 'atlassian-';

});


parcelRegister("crUxN", function(module, exports) {
$parcel$export(module.exports, "acShortcutToEmoji", () => $9103de1f583792a0$export$441f8b58f5790a68);

var $6ktYw = parcelRequire("6ktYw");
function $9103de1f583792a0$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: "".concat((0, $6ktYw.HC_EMOTICON_PREFIX)).concat(hipchatEmoticonShortName),
        shortName: ":".concat(hipchatEmoticonShortName, ":"),
        text: ''
    };
}

});


parcelRegister("4eHHu", function(module, exports) {
$parcel$export(module.exports, "expandWithNestedExpand", () => $315a5e3d88924979$export$7b80cba28d10b2c1);
$parcel$export(module.exports, "expandWithNestedExpandLocalId", () => $315a5e3d88924979$export$2ae5e7565ff9ffa6);
$parcel$export(module.exports, "toJSON", () => $315a5e3d88924979$export$54fd2c36b5cc6731);

var $25nEq = parcelRequire("25nEq");

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
function $315a5e3d88924979$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $315a5e3d88924979$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $315a5e3d88924979$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $315a5e3d88924979$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_root_only_node
 */ function $315a5e3d88924979$var$getExpandAttrs(domNode) {
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    var dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
var $315a5e3d88924979$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $315a5e3d88924979$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $315a5e3d88924979$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $315a5e3d88924979$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $315a5e3d88924979$var$getExpandAttrs
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
var $315a5e3d88924979$export$7b80cba28d10b2c1 = (0, $2gWGi.expand)($315a5e3d88924979$var$nodeSpecOptions);
var $315a5e3d88924979$export$2ae5e7565ff9ffa6 = (0, $2gWGi.expand)({
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $315a5e3d88924979$var$getExpandAttrs(dom);
                return $315a5e3d88924979$var$_objectSpread($315a5e3d88924979$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $l4823.uuid).generate()
                });
            }
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $315a5e3d88924979$var$getExpandAttrs(dom);
                return $315a5e3d88924979$var$_objectSpread($315a5e3d88924979$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $l4823.uuid).generate()
                });
            }
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $315a5e3d88924979$var$getExpandAttrs(dom);
                return $315a5e3d88924979$var$_objectSpread($315a5e3d88924979$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $l4823.uuid).generate()
                });
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $315a5e3d88924979$var$getExpandAttrs(dom);
                return $315a5e3d88924979$var$_objectSpread($315a5e3d88924979$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $l4823.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $315a5e3d88924979$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return !key.startsWith('__');
        }).reduce(function(obj, key) {
            return $315a5e3d88924979$var$_objectSpread($315a5e3d88924979$var$_objectSpread({}, obj), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, node.attrs[key]));
        }, {})
    };
};

});

parcelRegister("kUp6y", function(module, exports) {
$parcel$export(module.exports, "blockquote", () => $f38c82de0dfe6d23$export$67dc04e652a298ca);
$parcel$export(module.exports, "extendedBlockquote", () => $f38c82de0dfe6d23$export$70a64939da3e8455);
$parcel$export(module.exports, "extendedBlockquoteWithLocalId", () => $f38c82de0dfe6d23$export$950ebf43f3364a0f);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
/**
 * @name blockquote_node
 */ var $f38c82de0dfe6d23$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM: function toDOM() {
        return [
            'blockquote',
            0
        ];
    }
};
var $f38c82de0dfe6d23$export$67dc04e652a298ca = (0, $2gWGi.blockquoteLegacy)($f38c82de0dfe6d23$var$nodeSpecOptions);
var $f38c82de0dfe6d23$export$70a64939da3e8455 = (0, $2gWGi.blockquote)($f38c82de0dfe6d23$var$nodeSpecOptions);
var $f38c82de0dfe6d23$var$nodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'blockquote',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            'blockquote',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
};
var $f38c82de0dfe6d23$export$950ebf43f3364a0f = (0, $2gWGi.blockquote)($f38c82de0dfe6d23$var$nodeSpecOptionsWithLocalId);

});

parcelRegister("js3fs", function(module, exports) {
$parcel$export(module.exports, "extendedPanel", () => $e29326e75b65326e$export$ce20b13564211141);

var $2gWGi = parcelRequire("2gWGi");

var $5lT1R = parcelRequire("5lT1R");
var $e29326e75b65326e$export$ce20b13564211141 = function extendedPanel(allowCustomPanel) {
    return (0, $2gWGi.panel)((0, $5lT1R.createPanelNodeSpecOptions)(allowCustomPanel));
};

});
parcelRegister("5lT1R", function(module, exports) {
$parcel$export(module.exports, "createPanelNodeSpecOptions", () => $3e599982e88c509e$export$1f22c1e22ac5e390);

var $g8Kxh = parcelRequire("g8Kxh");

var $hsCVx = parcelRequire("hsCVx");
var $3e599982e88c509e$export$1f22c1e22ac5e390 = function createPanelNodeSpecOptions(allowCustomPanel, generateLocalId) {
    return {
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: function getAttrs(dom) {
                    return (0, $hsCVx.getParseDOMAttrs)(allowCustomPanel, dom, generateLocalId);
                }
            }
        ],
        toDOM: function toDOM(node) {
            var attrs = (0, $g8Kxh.getDomAttrs)(node.attrs);
            var contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    };
};

});
parcelRegister("g8Kxh", function(module, exports) {
$parcel$export(module.exports, "getDomAttrs", () => $bc017db95f384dd9$export$573b838ca5694549);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $bc017db95f384dd9$export$573b838ca5694549 = function getDomAttrs(nodeAttrs) {
    var attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor,
        'data-local-id': (nodeAttrs === null || nodeAttrs === void 0 ? void 0 : nodeAttrs.localId) || undefined
    };
    return attrs;
};

});

parcelRegister("hsCVx", function(module, exports) {
$parcel$export(module.exports, "getParseDOMAttrs", () => $cb633f4becc6f0b6$export$f5f376335f9d8c6b);

var $25nEq = parcelRequire("25nEq");

var $l4823 = parcelRequire("l4823");

var $18mVh = parcelRequire("18mVh");
function $cb633f4becc6f0b6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cb633f4becc6f0b6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cb633f4becc6f0b6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cb633f4becc6f0b6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cb633f4becc6f0b6$export$f5f376335f9d8c6b = function getParseDOMAttrs(allowCustomPanel, dom, generateLocalId) {
    var parseDOMAttrs = {
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelType: dom.getAttribute('data-panel-type')
    };
    if (generateLocalId) parseDOMAttrs.localId = (0, $l4823.uuid).generate();
    if (allowCustomPanel) parseDOMAttrs = $cb633f4becc6f0b6$var$_objectSpread($cb633f4becc6f0b6$var$_objectSpread({}, parseDOMAttrs), {}, {
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIcon: dom.getAttribute('data-panel-icon'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelColor: dom.getAttribute('data-panel-color')
    });
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === (0, $18mVh.PanelType).CUSTOM ? (0, $18mVh.PanelType).INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};

});
parcelRegister("18mVh", function(module, exports) {
$parcel$export(module.exports, "PanelType", () => $0d3851d35c40c2fb$export$969277cf61e5a7aa);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 








var $0d3851d35c40c2fb$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});

});




parcelRegister("eswVP", function(module, exports) {
$parcel$export(module.exports, "extendedPanelC1", () => $a86d39c4ed835820$export$c158ac2988d2f011);

var $2gWGi = parcelRequire("2gWGi");

var $5lT1R = parcelRequire("5lT1R");
var $a86d39c4ed835820$export$c158ac2988d2f011 = function extendedPanelC1(allowCustomPanel) {
    return (0, $2gWGi.panelC1Stage0)((0, $5lT1R.createPanelNodeSpecOptions)(allowCustomPanel));
};

});

parcelRegister("cnShX", function(module, exports) {
$parcel$export(module.exports, "extension", () => $9041bea1cb0f5c80$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionRootOnlyStage0", () => $9041bea1cb0f5c80$export$ad06037362b3c3b3);
$parcel$export(module.exports, "extensionRootOnlyWithAnnotationStage0", () => $9041bea1cb0f5c80$export$243bc54b0560ecc);

var $25nEq = parcelRequire("25nEq");

var $2gWGi = parcelRequire("2gWGi");

var $5LLLi = parcelRequire("5LLLi");
function $9041bea1cb0f5c80$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9041bea1cb0f5c80$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9041bea1cb0f5c80$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9041bea1cb0f5c80$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9041bea1cb0f5c80$export$1b45514b112dd749 = (0, $2gWGi.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: function getAttrs(domNode) {
                return (0, $5LLLi.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});
var $9041bea1cb0f5c80$export$ad06037362b3c3b3 = $9041bea1cb0f5c80$var$_objectSpread($9041bea1cb0f5c80$var$_objectSpread({}, $9041bea1cb0f5c80$export$1b45514b112dd749), {}, {
    marks: 'breakout dataConsumer fragment unsupportedMark unsupportedNodeAttribute'
});
var $9041bea1cb0f5c80$export$3e3366ebd634cc62 = $9041bea1cb0f5c80$var$_objectSpread($9041bea1cb0f5c80$var$_objectSpread({}, $9041bea1cb0f5c80$export$1b45514b112dd749), {}, {
    marks: 'annotation dataConsumer fragment unsupportedMark unsupportedNodeAttribute'
});
var $9041bea1cb0f5c80$export$243bc54b0560ecc = $9041bea1cb0f5c80$var$_objectSpread($9041bea1cb0f5c80$var$_objectSpread({}, $9041bea1cb0f5c80$export$1b45514b112dd749), {}, {
    marks: 'annotation breakout dataConsumer fragment unsupportedMark unsupportedNodeAttribute'
});

});

parcelRegister("5vwuc", function(module, exports) {
$parcel$export(module.exports, "extensionFrame", () => $40290c0d346cbba2$export$4fdcae991fd743e7);
$parcel$export(module.exports, "multiBodiedExtension", () => $40290c0d346cbba2$export$c3c04d555a8b9013);
$parcel$export(module.exports, "multiBodiedExtensionRootOnlyStage0", () => $40290c0d346cbba2$export$6f4c18ddc3950a66);

var $25nEq = parcelRequire("25nEq");

var $2gWGi = parcelRequire("2gWGi");

var $5LLLi = parcelRequire("5LLLi");
function $40290c0d346cbba2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $40290c0d346cbba2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $40290c0d346cbba2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $40290c0d346cbba2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $40290c0d346cbba2$export$4fdcae991fd743e7 = (0, $2gWGi.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-extension-frame': 'true',
            // Frames are hidden by default and the active frame is revealed via CSS.
            // Using an inline style ensures frames are invisible from the moment
            // ProseMirror inserts them into the DOM, preventing a flash of all
            // frames before the styles are injected.
            style: 'display:none'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $40290c0d346cbba2$export$c3c04d555a8b9013 = (0, $2gWGi.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $5LLLi.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $40290c0d346cbba2$export$6f4c18ddc3950a66 = $40290c0d346cbba2$var$_objectSpread($40290c0d346cbba2$var$_objectSpread({}, $40290c0d346cbba2$export$c3c04d555a8b9013), {}, {
    marks: "breakout ".concat($40290c0d346cbba2$export$c3c04d555a8b9013.marks)
});

});

parcelRegister("blZvD", function(module, exports) {
$parcel$export(module.exports, "hardBreak", () => $84415e4f4d00d7c1$export$371da9dd35aba193);

var $2gWGi = parcelRequire("2gWGi");
var $84415e4f4d00d7c1$export$371da9dd35aba193 = (0, $2gWGi.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM: function toDOM() {
        return [
            'br'
        ];
    }
});

});

parcelRegister("lta2M", function(module, exports) {
$parcel$export(module.exports, "heading", () => $fa1418ee148b8b3a$export$46e4a324ac90507f);

var $2gWGi = parcelRequire("2gWGi");
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ var $fa1418ee148b8b3a$var$getAttrs = function getAttrs(level) {
    return function(domNode) {
        return {
            level: level,
            localId: // eslint-disable-next-line @atlaskit/editor/no-as-casting
            domNode.getAttribute('data-local-id') || null
        };
    };
};
var $fa1418ee148b8b3a$export$46e4a324ac90507f = (0, $2gWGi.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $fa1418ee148b8b3a$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $fa1418ee148b8b3a$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $fa1418ee148b8b3a$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $fa1418ee148b8b3a$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $fa1418ee148b8b3a$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $fa1418ee148b8b3a$var$getAttrs(6)
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, level = _node$attrs.level, localId = _node$attrs.localId;
        var name = 'h' + level;
        var attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
});

});

parcelRegister("7S1Am", function(module, exports) {
$parcel$export(module.exports, "image", () => $5baece5f0a467918$export$5c452ff88e35e47d);

var $2gWGi = parcelRequire("2gWGi");
var $5baece5f0a467918$export$5c452ff88e35e47d = (0, $2gWGi.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'img',
            node.attrs
        ];
    }
});

});

parcelRegister("7YGzk", function(module, exports) {
$parcel$export(module.exports, "inlineCard", () => $5cef2844eb49532a$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineCardWithLocalId", () => $5cef2844eb49532a$export$7ed775fc743eadd1);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
var $5cef2844eb49532a$export$cbf8224b64e0d942 = (0, $2gWGi.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});
var $5cef2844eb49532a$export$7ed775fc743eadd1 = (0, $2gWGi.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $l4823.uuid).generate()
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});

});

parcelRegister("kuUB8", function(module, exports) {
$parcel$export(module.exports, "inlineExtension", () => $eec2832b126ddd0a$export$16b353b2649bd8d9);

var $2gWGi = parcelRequire("2gWGi");

var $5LLLi = parcelRequire("5LLLi");
var $eec2832b126ddd0a$export$16b353b2649bd8d9 = (0, $2gWGi.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: function getAttrs(domNode) {
                return (0, $5LLLi.getExtensionAttrs)(domNode, true);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("iXSQk", function(module, exports) {
$parcel$export(module.exports, "layoutColumn", () => $dce847576bfa2e82$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutColumnWithLocalId", () => $dce847576bfa2e82$export$b2e27d292505bac2);
$parcel$export(module.exports, "layoutColumnStage0", () => $dce847576bfa2e82$export$f8cda4c28dab3f58);

var $25nEq = parcelRequire("25nEq");

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");

var $aKy1c = parcelRequire("aKy1c");
function $dce847576bfa2e82$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dce847576bfa2e82$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dce847576bfa2e82$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dce847576bfa2e82$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dce847576bfa2e82$var$setColumnAttributes = function setColumnAttributes(node) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$withLocalId = _ref.withLocalId, withLocalId = _ref$withLocalId === void 0 ? false : _ref$withLocalId;
    var attrs = {
        'data-layout-column': 'true'
    };
    var _node$attrs = node.attrs, width = _node$attrs.width, valign = _node$attrs.valign, localId = _node$attrs.localId;
    if (width) {
        var baseStyle = "flex-basis: ".concat(width, "%");
        attrs['style'] = "".concat(baseStyle, "; --column-width: ").concat(width, "%");
        attrs['data-column-width'] = "".concat(width);
    }
    if (valign) attrs['data-valign'] = valign;
    if (withLocalId && localId) attrs['data-local-id'] = localId;
    return attrs;
};
var $dce847576bfa2e82$var$getColumnAttrs = function getColumnAttrs() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$withLocalId = _ref2.withLocalId, withLocalId = _ref2$withLocalId === void 0 ? false : _ref2$withLocalId;
    return function(domNode) {
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        var dom = domNode;
        var base = $dce847576bfa2e82$var$_objectSpread({
            width: Number(dom.getAttribute('data-column-width')) || undefined
        }, withLocalId && {
            localId: (0, $l4823.uuid).generate()
        });
        var valign = (0, $aKy1c.parseValign)(dom.getAttribute('data-valign'));
        return valign ? $dce847576bfa2e82$var$_objectSpread($dce847576bfa2e82$var$_objectSpread({}, base), {}, {
            valign: valign
        }) : base;
    };
};
// We need to apply an attribute to the innermost child to help ProseMirror
// identify its boundaries better.
var $dce847576bfa2e82$var$LAYOUT_CONTENT_ATTRS = {
    'data-layout-content': 'true'
};
var $dce847576bfa2e82$export$ab76e7c03cd6f650 = (0, $2gWGi.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: $dce847576bfa2e82$var$getColumnAttrs()
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'div',
            $dce847576bfa2e82$var$setColumnAttributes(node),
            [
                'div',
                $dce847576bfa2e82$var$LAYOUT_CONTENT_ATTRS,
                0
            ]
        ];
    }
});
var $dce847576bfa2e82$export$b2e27d292505bac2 = (0, $2gWGi.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: $dce847576bfa2e82$var$getColumnAttrs({
                withLocalId: true
            })
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'div',
            $dce847576bfa2e82$var$setColumnAttributes(node, {
                withLocalId: true
            }),
            [
                'div',
                $dce847576bfa2e82$var$LAYOUT_CONTENT_ATTRS,
                0
            ]
        ];
    }
});
var $dce847576bfa2e82$export$f8cda4c28dab3f58 = $dce847576bfa2e82$export$b2e27d292505bac2;

});
parcelRegister("aKy1c", function(module, exports) {
$parcel$export(module.exports, "parseValign", () => $7d38969bddb907b3$export$80408efb85c33a7a);
/**
 * Parses a raw DOM attribute string into a valid {@link Valign}, or `undefined` if
 * the value is absent or not one of the allowed values.
 */ var $7d38969bddb907b3$export$80408efb85c33a7a = function parseValign(raw) {
    switch(raw){
        case 'top':
        case 'middle':
        case 'bottom':
            return raw;
        default:
            return undefined;
    }
};

});


parcelRegister("d79nc", function(module, exports) {
$parcel$export(module.exports, "layoutSection", () => $98c3332112afa089$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => $98c3332112afa089$export$4f9d8f623ff17117);
$parcel$export(module.exports, "layoutSectionWithLocalId", () => $98c3332112afa089$export$d9d3c69a64270b13);
$parcel$export(module.exports, "layoutSectionWithSingleColumnLocalId", () => $98c3332112afa089$export$64facded20dfd85c);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
var $98c3332112afa089$export$b3b6a70a7fa4a5be = (0, $2gWGi.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $98c3332112afa089$export$cdae19acb0a520fd = (0, $2gWGi.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $98c3332112afa089$export$4f9d8f623ff17117 = (0, $2gWGi.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: function getAttrs(dom) {
                var columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        var columnRuleStyle = node.attrs.columnRuleStyle;
        var attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $98c3332112afa089$export$d9d3c69a64270b13 = (0, $2gWGi.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: function getAttrs() {
                var localId = (0, $l4823.uuid).generate();
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-layout-section': 'true',
            'data-local-id': localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $98c3332112afa089$export$64facded20dfd85c = (0, $2gWGi.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: function getAttrs(dom) {
                var columnRuleStyle = dom.getAttribute('data-column-rule-style');
                var localId = (0, $l4823.uuid).generate();
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle,
                    localId: localId
                } : {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var columnRuleStyle = node.attrs.columnRuleStyle;
        var attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("2Ji8g", function(module, exports) {
$parcel$export(module.exports, "listItem", () => $1fcdd9714dc98cbd$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithLocalId", () => $1fcdd9714dc98cbd$export$483d52f09158e61c);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
var $1fcdd9714dc98cbd$export$76c7e83ecc9cdf05 = (0, $2gWGi.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM: function toDOM() {
        return [
            'li',
            0
        ];
    }
});
var $1fcdd9714dc98cbd$export$483d52f09158e61c = (0, $2gWGi.listItem)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            'li',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
});

});

parcelRegister("6wWv8", function(module, exports) {
$parcel$export(module.exports, "media", () => $4c131c6043ad0d60$export$987d49ffe1b0900f);

var $25nEq = parcelRequire("25nEq");

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");

var $8E8IU = parcelRequire("8E8IU");



function $4c131c6043ad0d60$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4c131c6043ad0d60$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4c131c6043ad0d60$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4c131c6043ad0d60$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4c131c6043ad0d60$export$bb3fe706be61f640 = $4c131c6043ad0d60$var$_objectSpread({}, (0, $2gWGi.media)({}).attrs);
var $4c131c6043ad0d60$export$987d49ffe1b0900f = (0, $8E8IU.createMediaSpec)($4c131c6043ad0d60$export$bb3fe706be61f640, false, false);
var $4c131c6043ad0d60$export$8446e47a4c7fd000 = (0, $8E8IU.createMediaSpec)($4c131c6043ad0d60$var$_objectSpread($4c131c6043ad0d60$var$_objectSpread({}, $4c131c6043ad0d60$export$bb3fe706be61f640), {}, {
    localId: {
        default: (0, $l4823.uuid).generate()
    }
}), false, true);

});
parcelRegister("8E8IU", function(module, exports) {
$parcel$export(module.exports, "createMediaSpec", () => $64b8d36cad0f3b77$export$35bdbf5bc8caa677);

var $2gWGi = parcelRequire("2gWGi");

var $22vaF = parcelRequire("22vaF");

var $l4823 = parcelRequire("l4823");

var $kEUIp = parcelRequire("kEUIp");

var $ajKZr = parcelRequire("ajKZr");
var $64b8d36cad0f3b77$var$PRIVATE_ATTR_PREFIX_REGEX = /^__/;
var $64b8d36cad0f3b77$export$35bdbf5bc8caa677 = function createMediaSpec(attributes) {
    var inline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var generateLocalId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var domNodeType = inline ? 'span' : 'div';
    var nodeName = inline ? 'mediaInline' : 'media';
    var parseDOM = [
        {
            tag: "".concat(domNodeType, "[data-node-type=\"").concat(nodeName, "\"]"),
            getAttrs: function getAttrs(dom) {
                var attrs = {};
                if (attributes) Object.keys(attributes).forEach(function(k) {
                    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    var key = (0, $kEUIp.camelCaseToKebabCase)(k).replace($64b8d36cad0f3b77$var$PRIVATE_ATTR_PREFIX_REGEX, '');
                    var value = // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute("data-".concat(key)) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                var width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                var height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                if (generateLocalId) attrs.localId = (0, $l4823.uuid).generate();
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    var toDOM = function toDOM(node) {
        var attrs = {
            'data-id': node.attrs.id,
            'data-node-type': "".concat(nodeName),
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            'data-local-id': node.attrs.localId || undefined,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: "display: inline-block; border-radius: 3px; background: ".concat((0, $22vaF.N30), "; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);")
        };
        (0, $ajKZr.copyPrivateAttributes)(node.attrs, attrs, attributes, function(key) {
            return "data-".concat((0, $kEUIp.camelCaseToKebabCase)(key.slice(2)));
        });
        return [
            "".concat(domNodeType),
            attrs
        ];
    };
    if (inline) return (0, $2gWGi.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $2gWGi.media)({
        parseDOM: [].concat(parseDOM, [
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: function getAttrs(dom) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    var attrs = {
                        type: 'external',
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        url: dom.getAttribute('src') || '',
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        alt: dom.getAttribute('alt') || ''
                    };
                    if (generateLocalId) attrs.localId = (0, $l4823.uuid).generate();
                    return attrs;
                }
            }
        ]),
        toDOM: toDOM
    });
};

});
parcelRegister("kEUIp", function(module, exports) {
$parcel$export(module.exports, "camelCaseToKebabCase", () => $f0a389881eede5d9$export$f84fdfb973c05bd8);
var $f0a389881eede5d9$export$f84fdfb973c05bd8 = function camelCaseToKebabCase(str) {
    return str.replace(/((?:[\0-@\[-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)([A-Z])/g, function(_, x, y) {
        return "".concat(x, "-").concat(y.toLowerCase());
    });
};

});

parcelRegister("ajKZr", function(module, exports) {
$parcel$export(module.exports, "copyPrivateAttributes", () => $783020fcad53e702$export$111130fa8968d741);
var $783020fcad53e702$export$111130fa8968d741 = function copyPrivateAttributes(from, to, attributes, map) {
    var attrs = attributes || {};
    Object.keys(attrs).forEach(function(key) {
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};

});



parcelRegister("21g1t", function(module, exports) {
$parcel$export(module.exports, "mediaGroup", () => $17881a914a2cf857$export$2855e964765eac9);

var $2gWGi = parcelRequire("2gWGi");
var $17881a914a2cf857$export$2855e964765eac9 = (0, $2gWGi.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM: function toDOM() {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});

});

parcelRegister("jzlkh", function(module, exports) {
$parcel$export(module.exports, "mediaInline", () => $e3f1d41d42ac667f$export$38bab695e3f720f1);

var $25nEq = parcelRequire("25nEq");

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");

var $8E8IU = parcelRequire("8E8IU");
function $e3f1d41d42ac667f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e3f1d41d42ac667f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e3f1d41d42ac667f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e3f1d41d42ac667f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e3f1d41d42ac667f$export$38bab695e3f720f1 = (0, $8E8IU.createMediaSpec)((0, $2gWGi.mediaInline)({}).attrs, true);
var $e3f1d41d42ac667f$export$aea8e9c496505c61 = (0, $8E8IU.createMediaSpec)($e3f1d41d42ac667f$var$_objectSpread($e3f1d41d42ac667f$var$_objectSpread({}, (0, $2gWGi.mediaInline)({}).attrs), {}, {
    localId: {
        default: (0, $l4823.uuid).generate()
    }
}), true, true);

});

parcelRegister("8JhSw", function(module, exports) {
$parcel$export(module.exports, "mediaSingle", () => $65b064f7fbebe4c2$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleWithCaption", () => $65b064f7fbebe4c2$export$d35e6c006d4abdfb);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => $65b064f7fbebe4c2$export$9c58e19811ce4cf5);
$parcel$export(module.exports, "mediaSingleFull", () => $65b064f7fbebe4c2$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleFullWithLocalId", () => $65b064f7fbebe4c2$export$75376a385837c942);
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 
var $5HFOg = parcelRequire("5HFOg");

var $65b064f7fbebe4c2$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
var $65b064f7fbebe4c2$export$969fe3781ca15058 = (0, $5HFOg.mediaSingleSpec)({
    withCaption: false,
    withExtendedWidthTypes: false
});
var $65b064f7fbebe4c2$export$d35e6c006d4abdfb = (0, $5HFOg.mediaSingleSpec)({
    withCaption: true,
    withExtendedWidthTypes: false
});
var $65b064f7fbebe4c2$export$9c58e19811ce4cf5 = (0, $5HFOg.mediaSingleSpec)({
    withCaption: false,
    withExtendedWidthTypes: true
});
var $65b064f7fbebe4c2$export$7e767666f2ce108a = (0, $5HFOg.mediaSingleSpec)({
    withCaption: true,
    withExtendedWidthTypes: true
});
var $65b064f7fbebe4c2$export$75376a385837c942 = (0, $5HFOg.mediaSingleSpec)({
    withCaption: true,
    withExtendedWidthTypes: true,
    generateLocalId: true
});

});
parcelRegister("5HFOg", function(module, exports) {
$parcel$export(module.exports, "mediaSingleSpec", () => $4271666d067c83fe$export$5a1e124099b60c6b);

var $25nEq = parcelRequire("25nEq");

var $2gWGi = parcelRequire("2gWGi");

var $fBYOr = parcelRequire("fBYOr");

var $l4823 = parcelRequire("l4823");

var $5idWB = parcelRequire("5idWB");
function $4271666d067c83fe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4271666d067c83fe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4271666d067c83fe$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4271666d067c83fe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4271666d067c83fe$export$5a1e124099b60c6b = function mediaSingleSpec(_ref) {
    var _ref$withCaption = _ref.withCaption, withCaption = _ref$withCaption === void 0 ? false : _ref$withCaption, _ref$withExtendedWidt = _ref.withExtendedWidthTypes, withExtendedWidthTypes = _ref$withExtendedWidt === void 0 ? false : _ref$withExtendedWidt, _ref$generateLocalId = _ref.generateLocalId, generateLocalId = _ref$generateLocalId === void 0 ? false : _ref$generateLocalId;
    var getAttrs = function getAttrs(dom) {
        if (!(0, $fBYOr.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        var layout = dom.getAttribute('data-layout') || 'center';
        var width = Number(dom.getAttribute('data-width')) || null;
        var widthType = dom.getAttribute('data-width-type');
        if (generateLocalId) return {
            layout: layout,
            width: width,
            widthType: widthType,
            localId: (0, $l4823.uuid).generate()
        };
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $5idWB.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    var getAttrsFromNode = function getAttrsFromNode(node) {
        var _node$attrs = node.attrs, layout = _node$attrs.layout, width = _node$attrs.width;
        var attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (generateLocalId) {
            var _node$attrs2;
            attrs['data-local-id'] = (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined;
        }
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            var widthType = node.attrs.widthType;
            return $4271666d067c83fe$var$_objectSpread($4271666d067c83fe$var$_objectSpread({}, attrs), {}, {
                'data-width-type': widthType || (0, $5idWB.WidthType).PERCENTAGE
            });
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $2gWGi.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $2gWGi.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $2gWGi.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $2gWGi.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};

});
parcelRegister("5idWB", function(module, exports) {
$parcel$export(module.exports, "WidthType", () => $3da9733cf4e7ae0e$export$4d41558722ac7eed);
/**
 * @description The widthType attribute is used to support fixed with media single
 */ var $3da9733cf4e7ae0e$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({}); // Public API aliases preserved from an eliminated entry-point (volt-migrate-package).

});



parcelRegister("kZNkK", function(module, exports) {
$parcel$export(module.exports, "mention", () => $f48fc5cbb5be8229$export$db83999c14438df4);
$parcel$export(module.exports, "toJSON", () => $f48fc5cbb5be8229$export$54fd2c36b5cc6731);

var $25nEq = parcelRequire("25nEq");

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
function $f48fc5cbb5be8229$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f48fc5cbb5be8229$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f48fc5cbb5be8229$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f48fc5cbb5be8229$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f48fc5cbb5be8229$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
var $f48fc5cbb5be8229$export$db83999c14438df4 = (0, $2gWGi.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var attrs = {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-mention-id') || $f48fc5cbb5be8229$export$db83999c14438df4.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: dom.textContent || $f48fc5cbb5be8229$export$db83999c14438df4.attrs.text.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    accessLevel: dom.getAttribute('data-access-level') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $f48fc5cbb5be8229$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $l4823.uuid).generate()
                };
                var userType = dom.getAttribute('data-user-type');
                if ($f48fc5cbb5be8229$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, id = _node$attrs.id, accessLevel = _node$attrs.accessLevel, text = _node$attrs.text, userType = _node$attrs.userType, localId = _node$attrs.localId;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
var $f48fc5cbb5be8229$var$isOptional = function isOptional(key) {
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
var $f48fc5cbb5be8229$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if ($f48fc5cbb5be8229$var$isOptional(key) && !node.attrs[key]) return obj;
            return $f48fc5cbb5be8229$var$_objectSpread($f48fc5cbb5be8229$var$_objectSpread({}, obj), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, node.attrs[key]));
        }, {})
    };
};

});

parcelRegister("jOBJC", function(module, exports) {
$parcel$export(module.exports, "nestedExpand", () => $e6cff53242991572$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpandWithLocalId", () => $e6cff53242991572$export$b854197485aa1fa0);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
function $e6cff53242991572$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e6cff53242991572$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e6cff53242991572$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e6cff53242991572$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name nestedExpand_content
 // eslint-disable-next-line eslint-plugin-jsdoc/check-tag-names
 * @minItems 1
 // eslint-disable-next-line eslint-plugin-jsdoc/check-tag-names
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ function $e6cff53242991572$var$getExpandAttrs(domNode, generateLocalId) {
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    var dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true,
        localId: generateLocalId ? (0, $l4823.uuid).generate() : undefined
    };
}
var $e6cff53242991572$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $e6cff53242991572$var$getExpandAttrs(domNode, false);
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $e6cff53242991572$var$getExpandAttrs(domNode, false);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
var $e6cff53242991572$export$63cadbf5f4296627 = (0, $2gWGi.nestedExpand)($e6cff53242991572$var$nestedExpandFactoryOptions);
var $e6cff53242991572$export$b854197485aa1fa0 = (0, $2gWGi.nestedExpand)($e6cff53242991572$var$_objectSpread($e6cff53242991572$var$_objectSpread({}, $e6cff53242991572$var$nestedExpandFactoryOptions), {}, {
    parseDOM: [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))($e6cff53242991572$var$nestedExpandFactoryOptions.parseDOM || []), [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $e6cff53242991572$var$getExpandAttrs(domNode, true);
            }
        },
        {
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $e6cff53242991572$var$getExpandAttrs(domNode, true);
            }
        }
    ])
}));

});

parcelRegister("5MY3X", function(module, exports) {
$parcel$export(module.exports, "orderedListSelector", () => $437006b003298686$export$4e7125c7ff595be5);
$parcel$export(module.exports, "orderedList", () => $437006b003298686$export$a5dc81035676e7a);
$parcel$export(module.exports, "orderedListWithLocalId", () => $437006b003298686$export$8157adc5747ec436);
$parcel$export(module.exports, "orderedListWithOrder", () => $437006b003298686$export$b9ab759e8298198f);
$parcel$export(module.exports, "orderedListWithOrderAndLocalId", () => $437006b003298686$export$2ea3505d41d7525d);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
var $437006b003298686$export$4e7125c7ff595be5 = '.ak-ol';
var $437006b003298686$export$a5dc81035676e7a = (0, $2gWGi.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            class: $437006b003298686$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
var $437006b003298686$export$8157adc5747ec436 = (0, $2gWGi.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            class: $437006b003298686$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $437006b003298686$var$resolveStart = function resolveStart(start) {
    var num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
var $437006b003298686$export$b9ab759e8298198f = (0, $2gWGi.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    var start = $437006b003298686$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        var start = $437006b003298686$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.order);
        var attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $437006b003298686$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
var $437006b003298686$export$2ea3505d41d7525d = (0, $2gWGi.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var startDOMAttr = dom.getAttribute('start');
                var localId = (0, $l4823.uuid).generate();
                if (startDOMAttr) {
                    var start = $437006b003298686$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start,
                        localId: localId
                    };
                }
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3, _node$attrs4;
        var start = $437006b003298686$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.order);
        var attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $437006b003298686$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("91Dmj", function(module, exports) {
$parcel$export(module.exports, "paragraph", () => $6922bce7683e6bc6$export$9c206ddddb32a9b);

var $2gWGi = parcelRequire("2gWGi");
var $6922bce7683e6bc6$export$9c206ddddb32a9b = (0, $2gWGi.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: function getAttrs(domNode) {
                var _paragraph$attrs, _paragraph$attrs$loca;
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $6922bce7683e6bc6$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var name = 'p';
        var attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
});

});

parcelRegister("gAmJ3", function(module, exports) {
$parcel$export(module.exports, "placeholder", () => $c131a2f8028bcf7d$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "placeholderWithLocalId", () => $c131a2f8028bcf7d$export$6205248609a8f7a0);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
var $c131a2f8028bcf7d$export$c7187bbd1a7a9244 = (0, $2gWGi.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: function getAttrs(dom) {
                return {
                    text: // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-placeholder') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $c131a2f8028bcf7d$export$c7187bbd1a7a9244.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var text = node.attrs.text;
        var attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
var $c131a2f8028bcf7d$export$6205248609a8f7a0 = (0, $2gWGi.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: function getAttrs(dom) {
                return {
                    text: // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-placeholder') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $c131a2f8028bcf7d$export$c7187bbd1a7a9244.attrs.text.default,
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var text = node.attrs.text;
        var attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("e29IV", function(module, exports) {
$parcel$export(module.exports, "rule", () => $a378cb7e2d7926b6$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "ruleWithLocalId", () => $a378cb7e2d7926b6$export$bf3ef6fb6ad90e7);
$parcel$export(module.exports, "ruleRootOnlyStage0", () => $a378cb7e2d7926b6$export$1d53b70195c9c417);
$parcel$export(module.exports, "ruleWithAttrsRootOnlyStage0", () => $a378cb7e2d7926b6$export$78cca5eef2450890);

var $25nEq = parcelRequire("25nEq");

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
function $a378cb7e2d7926b6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a378cb7e2d7926b6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a378cb7e2d7926b6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a378cb7e2d7926b6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name rule_node
 */ /**
 * @name rule_root_only_node
 */ /**
 * @name rule_with_attrs_node
 */ /**
 * @name rule_with_attrs_root_only_node
 */ var $a378cb7e2d7926b6$var$hrDOM = [
    'hr'
];
var $a378cb7e2d7926b6$export$fbeb3a3956e8a3c7 = (0, $2gWGi.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM: function toDOM() {
        return $a378cb7e2d7926b6$var$hrDOM;
    }
});
var $a378cb7e2d7926b6$export$bf3ef6fb6ad90e7 = (0, $2gWGi.rule)({
    parseDOM: [
        {
            tag: 'hr',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            'hr',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            }
        ];
    }
});
var $a378cb7e2d7926b6$var$getAttrs = function getAttrs(domNode) {
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    var dom = domNode;
    var weight = dom.getAttribute('data-weight');
    return {
        color: dom.getAttribute('data-color') || undefined,
        localId: dom.getAttribute('data-local-id') || undefined,
        style: dom.getAttribute('data-style') || undefined,
        weight: weight === null || weight === '' ? undefined : Number(weight)
    };
};
var $a378cb7e2d7926b6$export$ef9ec4ed8a654d7f = $a378cb7e2d7926b6$var$_objectSpread($a378cb7e2d7926b6$var$_objectSpread({}, $a378cb7e2d7926b6$export$bf3ef6fb6ad90e7), {}, {
    attrs: $a378cb7e2d7926b6$var$_objectSpread($a378cb7e2d7926b6$var$_objectSpread({}, $a378cb7e2d7926b6$export$bf3ef6fb6ad90e7.attrs), {}, {
        color: {
            default: null
        },
        style: {
            default: null
        },
        weight: {
            default: null
        }
    }),
    parseDOM: [
        {
            tag: 'hr',
            getAttrs: $a378cb7e2d7926b6$var$getAttrs
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2 = node.attrs, color = _node$attrs2.color, localId = _node$attrs2.localId, style = _node$attrs2.style, weight = _node$attrs2.weight;
        return [
            'hr',
            {
                'data-color': color || undefined,
                'data-local-id': localId || undefined,
                'data-style': style || undefined,
                'data-weight': weight !== null && weight !== void 0 ? weight : undefined
            }
        ];
    }
});
var $a378cb7e2d7926b6$export$1d53b70195c9c417 = $a378cb7e2d7926b6$var$_objectSpread($a378cb7e2d7926b6$var$_objectSpread({}, $a378cb7e2d7926b6$export$bf3ef6fb6ad90e7), {}, {
    marks: 'breakout unsupportedMark unsupportedNodeAttribute'
});
var $a378cb7e2d7926b6$export$78cca5eef2450890 = $a378cb7e2d7926b6$var$_objectSpread($a378cb7e2d7926b6$var$_objectSpread({}, $a378cb7e2d7926b6$export$ef9ec4ed8a654d7f), {}, {
    marks: 'breakout unsupportedMark unsupportedNodeAttribute'
});

});

parcelRegister("9IIBj", function(module, exports) {
$parcel$export(module.exports, "status", () => $713ad1e9e995d313$export$471f7ae5c4103ae1);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
var $713ad1e9e995d313$var$NEWLINE_REGEX = /\n/;
var $713ad1e9e995d313$export$471f7ae5c4103ae1 = (0, $2gWGi.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                var textContent = dom.textContent.replace($713ad1e9e995d313$var$NEWLINE_REGEX, '').trim();
                // Prefer data-text attribute over textContent
                // When NodeView DOM is copied, inner text content may not be preserved
                var text = dom.getAttribute('data-text') || textContent;
                return {
                    text: text,
                    color: dom.getAttribute('data-color'),
                    localId: (0, $l4823.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, text = _node$attrs.text, color = _node$attrs.color, localId = _node$attrs.localId, style = _node$attrs.style;
        var attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("hG501", function(module, exports) {
$parcel$export(module.exports, "syncBlock", () => $cdea3caddabc8835$export$faab0ca9701d7048);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
var $cdea3caddabc8835$export$faab0ca9701d7048 = (0, $2gWGi.syncBlock)({
    parseDOM: [
        {
            tag: 'div[data-sync-block]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $l4823.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, resourceId = _node$attrs.resourceId;
        var name = 'div';
        var attrs = {
            'data-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs
        ];
    }
});

});

parcelRegister("gc8Zd", function(module, exports) {
$parcel$export(module.exports, "tablePrefixSelector", () => $bca4bcd38fb8105c$export$9cfceb893b24742a);
$parcel$export(module.exports, "tableCellSelector", () => $bca4bcd38fb8105c$export$69cb4c3f80383763);
$parcel$export(module.exports, "tableHeaderSelector", () => $bca4bcd38fb8105c$export$7b07d37d879c957f);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => $bca4bcd38fb8105c$export$8dd42a84cd52da07);
$parcel$export(module.exports, "tableCellContentDomSelector", () => $bca4bcd38fb8105c$export$5e26a5c19f0865d8);
$parcel$export(module.exports, "getCellAttrs", () => $bca4bcd38fb8105c$export$43977bde391e007);
$parcel$export(module.exports, "getCellDomAttrs", () => $bca4bcd38fb8105c$export$363c8dda799bfe9c);
$parcel$export(module.exports, "tableBackgroundColorNames", () => $bca4bcd38fb8105c$export$8cc2833b5b349a1e);
$parcel$export(module.exports, "tableBackgroundColorNameByHex", () => $bca4bcd38fb8105c$export$87db0bca041942ef);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => $bca4bcd38fb8105c$export$219b7f492ad209f8);
$parcel$export(module.exports, "tableBackgroundColorPaletteNew", () => $bca4bcd38fb8105c$export$f26b9114878cba41);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => $bca4bcd38fb8105c$export$95e9c925fbf01d1c);
$parcel$export(module.exports, "table", () => $bca4bcd38fb8105c$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithCustomWidth", () => $bca4bcd38fb8105c$export$90e634fbace1f0c4);
$parcel$export(module.exports, "tableStage0", () => $bca4bcd38fb8105c$export$3862de5c8c9098cf);
$parcel$export(module.exports, "tableToJSON", () => $bca4bcd38fb8105c$export$1f92a2f429e06fa8);
$parcel$export(module.exports, "tableRow", () => $bca4bcd38fb8105c$export$ce666bf02318c957);
$parcel$export(module.exports, "tableCell", () => $bca4bcd38fb8105c$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "toJSONTableCell", () => $bca4bcd38fb8105c$export$2ac34c099660f1a8);
$parcel$export(module.exports, "tableHeader", () => $bca4bcd38fb8105c$export$48884d2a5190dc73);
$parcel$export(module.exports, "toJSONTableHeader", () => $bca4bcd38fb8105c$export$2af48797a1010bb1);
$parcel$export(module.exports, "tableWithNestedTable", () => $bca4bcd38fb8105c$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $bca4bcd38fb8105c$export$7d657479499397);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $bca4bcd38fb8105c$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $bca4bcd38fb8105c$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRowWithLocalId", () => $bca4bcd38fb8105c$export$c8f0853ac97552c9);
$parcel$export(module.exports, "tableCellWithLocalId", () => $bca4bcd38fb8105c$export$db76cfd28a574029);
$parcel$export(module.exports, "tableHeaderWithLocalId", () => $bca4bcd38fb8105c$export$b82d2b1d8824143d);
$parcel$export(module.exports, "tableRowWithNestedTableWithLocalId", () => $bca4bcd38fb8105c$export$27926e30c8a74147);
$parcel$export(module.exports, "tableCellWithNestedTableWithLocalId", () => $bca4bcd38fb8105c$export$e9fd700fafee293a);
$parcel$export(module.exports, "tableHeaderWithNestedTableWithLocalId", () => $bca4bcd38fb8105c$export$7928c3aeb4cd2213);
$parcel$export(module.exports, "tableCellStage0", () => $bca4bcd38fb8105c$export$7ffdb7030e2f2223);
$parcel$export(module.exports, "tableHeaderStage0", () => $bca4bcd38fb8105c$export$53c69bb0cddd9750);
$parcel$export(module.exports, "tableCellWithNestedTableStage0", () => $bca4bcd38fb8105c$export$10671ff6b5f3bd84);
$parcel$export(module.exports, "tableHeaderWithNestedTableStage0", () => $bca4bcd38fb8105c$export$69bdb7ac5d810d92);

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $2gWGi = parcelRequire("2gWGi");

var $22vaF = parcelRequire("22vaF");

var $cQBqP = parcelRequire("cQBqP");

var $8jkwd = parcelRequire("8jkwd");

var $jvEMA = parcelRequire("jvEMA");

var $bahcz = parcelRequire("bahcz");

var $ik1TX = parcelRequire("ik1TX");

var $cXJFA = parcelRequire("cXJFA");

var $l4823 = parcelRequire("l4823");

var $aKy1c = parcelRequire("aKy1c");
function $bca4bcd38fb8105c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bca4bcd38fb8105c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bca4bcd38fb8105c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bca4bcd38fb8105c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bca4bcd38fb8105c$export$9cfceb893b24742a = 'pm-table';
var $bca4bcd38fb8105c$var$COL_WIDTH_ATTR_REGEX = /^[0-9]+(,[0-9]+)*$/;
var $bca4bcd38fb8105c$export$69cb4c3f80383763 = "".concat($bca4bcd38fb8105c$export$9cfceb893b24742a, "-cell-content-wrap");
var $bca4bcd38fb8105c$export$7b07d37d879c957f = "".concat($bca4bcd38fb8105c$export$9cfceb893b24742a, "-header-content-wrap");
var $bca4bcd38fb8105c$export$8dd42a84cd52da07 = "".concat($bca4bcd38fb8105c$export$9cfceb893b24742a, "-cell-nodeview-wrapper");
var $bca4bcd38fb8105c$export$5e26a5c19f0865d8 = "".concat($bca4bcd38fb8105c$export$9cfceb893b24742a, "-cell-nodeview-content-dom");
var $bca4bcd38fb8105c$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $22vaF.N20).toLocaleLowerCase();
var $bca4bcd38fb8105c$export$43977bde391e007 = function getCellAttrs(dom) {
    var defaultValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var widthAttr = dom.getAttribute('data-colwidth');
    var width = widthAttr && $bca4bcd38fb8105c$var$COL_WIDTH_ATTR_REGEX.test(widthAttr) ? widthAttr.split(',').map(function(str) {
        return Number(str);
    }) : null;
    var colspan = Number(dom.getAttribute('colspan') || 1);
    var backgroundColor = dom.style.backgroundColor;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ var dataCellBackground = dom.getAttribute('data-cell-background');
    var dataCellBackgroundHexCode = dataCellBackground && (0, $bahcz.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $ik1TX.isRgb)(backgroundColor)) {
        var result = (0, $cXJFA.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    var backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    var localId = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.localId;
    var valign = (0, $aKy1c.parseValign)(dom.getAttribute('data-valign'));
    return $bca4bcd38fb8105c$var$_objectSpread($bca4bcd38fb8105c$var$_objectSpread({
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    }, localId && {
        localId: localId
    }), valign && {
        valign: valign
    });
};
// these are for test only
var $bca4bcd38fb8105c$var$testGlobalTheme;
var $bca4bcd38fb8105c$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $bca4bcd38fb8105c$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
var $bca4bcd38fb8105c$var$getGlobalTheme = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($bca4bcd38fb8105c$var$testGlobalTheme) return {
        colorMode: $bca4bcd38fb8105c$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
var $bca4bcd38fb8105c$var$cssVariablePattern = /^var\(--(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*\)$/;
var $bca4bcd38fb8105c$export$363c8dda799bfe9c = function getCellDomAttrs(node) {
    var _node$attrs;
    var attrs = {};
    var nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        var background = node.attrs.background;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        var ignored = nodeType === 'tableHeader' && background === $bca4bcd38fb8105c$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $bca4bcd38fb8105c$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            var color = (0, $ik1TX.isRgb)(background) && (0, $cXJFA.rgbToHex)(background) ? (0, $cXJFA.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ var tokenColor = (0, $8jkwd.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = "background-color: ".concat(tokenColor, ";");
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $bca4bcd38fb8105c$var$cssVariablePattern.test(color)) attrs.style = "background-color: ".concat(color, ";");
            else // if we have a custom color, we need to check if we are in dark mode
            if ($bca4bcd38fb8105c$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = "background-color: ".concat((0, $cQBqP.getDarkModeLCHColor)(color), ";");
            else // if we are in light mode, we can just set the color
            attrs.style = "background-color: ".concat(background, ";");
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            if (typeof color === 'string') attrs.colorname = $bca4bcd38fb8105c$export$87db0bca041942ef.get(color.toLowerCase());
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $bca4bcd38fb8105c$export$7b07d37d879c957f;
    else attrs.class = $bca4bcd38fb8105c$export$69cb4c3f80383763;
    if (node !== null && node !== void 0 && (_node$attrs = node.attrs) !== null && _node$attrs !== void 0 && _node$attrs.localId) attrs['data-local-id'] = node.attrs.localId;
    if (node.attrs.valign) attrs['data-valign'] = node.attrs.valign;
    return attrs;
};
var $bca4bcd38fb8105c$export$219b7f492ad209f8 = new Map();
var $bca4bcd38fb8105c$export$f26b9114878cba41 = new Map();
var $bca4bcd38fb8105c$export$95e9c925fbf01d1c = (0, $jvEMA.hexToRgba)((0, $22vaF.N800), 0.12) || (0, $22vaF.N0);
var $bca4bcd38fb8105c$export$8cc2833b5b349a1e = new Map();
var $bca4bcd38fb8105c$export$87db0bca041942ef = new Map();
// Original 7-column palette — kept as the default export so external consumers
// are not broken. When cleaning up the platform_editor_lovability_text_bg_color experiment, check if this can be removed
[
    [
        (0, $22vaF.N0),
        'White'
    ],
    [
        (0, $22vaF.B50),
        'Light blue'
    ],
    [
        (0, $22vaF.T50),
        'Light teal'
    ],
    [
        (0, $22vaF.G50),
        'Light green'
    ],
    [
        (0, $22vaF.Y50),
        'Light yellow'
    ],
    [
        (0, $22vaF.R50),
        'Light red'
    ],
    [
        (0, $22vaF.P50),
        'Light purple'
    ],
    [
        (0, $22vaF.N20),
        'Light gray'
    ],
    [
        (0, $22vaF.B75),
        'Blue'
    ],
    [
        (0, $22vaF.T75),
        'Teal'
    ],
    [
        (0, $22vaF.G75),
        'Green'
    ],
    [
        (0, $22vaF.Y75),
        'Yellow'
    ],
    [
        (0, $22vaF.R75),
        'Red'
    ],
    [
        (0, $22vaF.P75),
        'Purple'
    ],
    [
        (0, $22vaF.N60),
        'Gray'
    ],
    [
        (0, $22vaF.B100),
        'Dark blue'
    ],
    [
        (0, $22vaF.T100),
        'Dark teal'
    ],
    [
        (0, $22vaF.G200),
        'Dark green'
    ],
    [
        (0, $22vaF.Y200),
        'Dark yellow'
    ],
    [
        (0, $22vaF.R100),
        'Dark red'
    ],
    [
        (0, $22vaF.P100),
        'Dark purple'
    ]
].forEach(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), colorValue = _ref2[0], colorName = _ref2[1];
    $bca4bcd38fb8105c$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $bca4bcd38fb8105c$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
    $bca4bcd38fb8105c$export$87db0bca041942ef.set(colorValue.toLowerCase(), colorName);
});
[
    [
        (0, $22vaF.N0),
        'White'
    ],
    [
        (0, $22vaF.B50),
        'Light blue'
    ],
    [
        (0, $22vaF.T50),
        'Light teal'
    ],
    [
        (0, $22vaF.G50),
        'Light green'
    ],
    [
        (0, $22vaF.L50),
        'Subtle lime'
    ],
    [
        (0, $22vaF.Y50),
        'Light yellow'
    ],
    [
        (0, $22vaF.Orange50),
        'Subtle orange'
    ],
    [
        (0, $22vaF.R50),
        'Light red'
    ],
    [
        (0, $22vaF.M50),
        'Subtle magenta'
    ],
    [
        (0, $22vaF.P50),
        'Light purple'
    ],
    [
        (0, $22vaF.N20),
        'Light gray'
    ],
    [
        (0, $22vaF.B75),
        'Blue'
    ],
    [
        (0, $22vaF.T75),
        'Teal'
    ],
    [
        (0, $22vaF.G75),
        'Green'
    ],
    [
        (0, $22vaF.L200),
        'Lime'
    ],
    [
        (0, $22vaF.Y75),
        'Yellow'
    ],
    [
        (0, $22vaF.Orange200),
        'Orange'
    ],
    [
        (0, $22vaF.R75),
        'Red'
    ],
    [
        (0, $22vaF.M200),
        'Magenta'
    ],
    [
        (0, $22vaF.P75),
        'Purple'
    ],
    [
        (0, $22vaF.GrayBold),
        'Bold gray'
    ],
    [
        (0, $22vaF.BlueBold),
        'Bold blue'
    ],
    [
        (0, $22vaF.TealBold),
        'Bold teal'
    ],
    [
        (0, $22vaF.GreenBold),
        'Bold green'
    ],
    [
        (0, $22vaF.L400),
        'Bold lime'
    ],
    [
        (0, $22vaF.YellowBold),
        'Bold yellow'
    ],
    [
        (0, $22vaF.Orange400),
        'Bold orange'
    ],
    [
        (0, $22vaF.RedBold),
        'Bold red'
    ],
    [
        (0, $22vaF.M400),
        'Bold magenta'
    ],
    [
        (0, $22vaF.PurpleBold),
        'Bold purple'
    ]
].forEach(function(_ref3) {
    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), colorValue = _ref4[0], colorName = _ref4[1];
    $bca4bcd38fb8105c$export$f26b9114878cba41.set(colorValue.toLowerCase(), colorName);
    $bca4bcd38fb8105c$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
    $bca4bcd38fb8105c$export$87db0bca041942ef.set(colorValue.toLowerCase(), colorName);
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 // eslint-disable-next-line eslint-plugin-jsdoc/check-tag-names
 * @minItems 1
 // eslint-disable-next-line eslint-plugin-jsdoc/check-tag-names
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // table nodes with nested tables support
var $bca4bcd38fb8105c$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: function getAttrs(node) {
                var _dom$parentElement;
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = node;
                var breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $l4823.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: ED-5048 - Fix any, potential issue.
var $bca4bcd38fb8105c$var$createTableSpec = function createTableSpec() {
    return (0, $2gWGi.table)($bca4bcd38fb8105c$var$tableNodeSpecOptions);
};
var $bca4bcd38fb8105c$export$9852986a3ec5f6a0 = $bca4bcd38fb8105c$var$createTableSpec();
var $bca4bcd38fb8105c$export$90e634fbace1f0c4 = $bca4bcd38fb8105c$var$createTableSpec();
var $bca4bcd38fb8105c$export$3862de5c8c9098cf = $bca4bcd38fb8105c$var$createTableSpec();
var $bca4bcd38fb8105c$var$shouldIncludeAttribute = function shouldIncludeAttribute(key, value) {
    return !key.startsWith('__') && (key !== 'localId' || !!value);
};
var $bca4bcd38fb8105c$export$1f92a2f429e06fa8 = function tableToJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return $bca4bcd38fb8105c$var$shouldIncludeAttribute(key, node.attrs[key]);
        }).reduce(function(obj, key) {
            return $bca4bcd38fb8105c$var$_objectSpread($bca4bcd38fb8105c$var$_objectSpread({}, obj), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, node.attrs[key]));
        }, {})
    };
};
var $bca4bcd38fb8105c$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM: function toDOM() {
        return [
            'tr',
            0
        ];
    }
};
var $bca4bcd38fb8105c$export$ce666bf02318c957 = (0, $2gWGi.tableRow)($bca4bcd38fb8105c$var$tableRowNodeSpecOptions);
var $bca4bcd38fb8105c$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    },
    localId: {
        default: null,
        optional: true
    },
    valign: {
        default: null,
        optional: true
    }
};
var $bca4bcd38fb8105c$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: function getAttrs(dom) {
                return $bca4bcd38fb8105c$export$43977bde391e007(dom);
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'td',
            $bca4bcd38fb8105c$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $bca4bcd38fb8105c$export$e1e720e5f4603e6a = (0, $2gWGi.tableCell)($bca4bcd38fb8105c$var$tableCellNodeSpecOptions);
var $bca4bcd38fb8105c$export$2ac34c099660f1a8 = function toJSONTableCell(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            // Only process keys that are defined in cellAttrs
            if ($bca4bcd38fb8105c$var$cellAttrs[key] && $bca4bcd38fb8105c$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};
var $bca4bcd38fb8105c$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: function getAttrs(dom) {
                return(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $bca4bcd38fb8105c$export$43977bde391e007(dom, {
                    background: $bca4bcd38fb8105c$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                }));
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'th',
            $bca4bcd38fb8105c$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $bca4bcd38fb8105c$export$48884d2a5190dc73 = (0, $2gWGi.tableHeader)($bca4bcd38fb8105c$var$tableHeaderNodeSpecOptions);
var $bca4bcd38fb8105c$export$2af48797a1010bb1 = $bca4bcd38fb8105c$export$2ac34c099660f1a8;
var $bca4bcd38fb8105c$export$ce086a560a1d05f5 = (0, $2gWGi.tableWithNestedTable)($bca4bcd38fb8105c$var$tableNodeSpecOptions);
var $bca4bcd38fb8105c$export$7d657479499397 = (0, $2gWGi.tableRowWithNestedTable)($bca4bcd38fb8105c$var$tableRowNodeSpecOptions);
var $bca4bcd38fb8105c$export$abf39ca178940ff3 = (0, $2gWGi.tableCellWithNestedTable)($bca4bcd38fb8105c$var$tableCellNodeSpecOptions);
var $bca4bcd38fb8105c$export$2a5a518232fa1a97 = (0, $2gWGi.tableHeaderWithNestedTable)($bca4bcd38fb8105c$var$tableHeaderNodeSpecOptions);
// table nodes with localId support
var $bca4bcd38fb8105c$var$tableRowNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'tr',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        return [
            'tr',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
};
var $bca4bcd38fb8105c$export$c8f0853ac97552c9 = (0, $2gWGi.tableRow)($bca4bcd38fb8105c$var$tableRowNodeSpecOptionsWithLocalId);
var $bca4bcd38fb8105c$var$tableCellNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'td',
            getAttrs: function getAttrs(dom) {
                return(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $bca4bcd38fb8105c$export$43977bde391e007(dom, {
                    localId: (0, $l4823.uuid).generate()
                }));
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'td',
            $bca4bcd38fb8105c$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $bca4bcd38fb8105c$export$db76cfd28a574029 = (0, $2gWGi.tableCell)($bca4bcd38fb8105c$var$tableCellNodeSpecOptionsWithLocalId);
var $bca4bcd38fb8105c$var$tableHeaderNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: function getAttrs(dom) {
                return(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $bca4bcd38fb8105c$export$43977bde391e007(dom, {
                    background: $bca4bcd38fb8105c$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND,
                    localId: (0, $l4823.uuid).generate()
                }));
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'th',
            $bca4bcd38fb8105c$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $bca4bcd38fb8105c$export$b82d2b1d8824143d = (0, $2gWGi.tableHeader)($bca4bcd38fb8105c$var$tableHeaderNodeSpecOptionsWithLocalId);
var $bca4bcd38fb8105c$export$27926e30c8a74147 = (0, $2gWGi.tableRowWithNestedTable)($bca4bcd38fb8105c$var$tableRowNodeSpecOptionsWithLocalId);
var $bca4bcd38fb8105c$export$e9fd700fafee293a = (0, $2gWGi.tableCellWithNestedTable)($bca4bcd38fb8105c$var$tableCellNodeSpecOptionsWithLocalId);
var $bca4bcd38fb8105c$export$7928c3aeb4cd2213 = (0, $2gWGi.tableHeaderWithNestedTable)($bca4bcd38fb8105c$var$tableHeaderNodeSpecOptionsWithLocalId);
var $bca4bcd38fb8105c$export$7ffdb7030e2f2223 = $bca4bcd38fb8105c$export$db76cfd28a574029;
var $bca4bcd38fb8105c$export$53c69bb0cddd9750 = $bca4bcd38fb8105c$export$b82d2b1d8824143d;
var $bca4bcd38fb8105c$export$10671ff6b5f3bd84 = $bca4bcd38fb8105c$export$e9fd700fafee293a;
var $bca4bcd38fb8105c$export$69bdb7ac5d810d92 = $bca4bcd38fb8105c$export$7928c3aeb4cd2213; // Public API aliases preserved from an eliminated entry-point (volt-migrate-package).

});
parcelRegister("8jkwd", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $60d003a1d93a3b5b$export$a270511a0e7fd61a);

var $aE9eF = parcelRequire("aE9eF");
function $60d003a1d93a3b5b$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    var tokenData = hexColor ? (0, $aE9eF.editorBackgroundPalette)[hexColor.toUpperCase()] : undefined;
    // @ts-expect-error
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}

});

parcelRegister("jvEMA", function(module, exports) {
$parcel$export(module.exports, "hexToRgba", () => $e3408c2d870eff4c$export$9665a07d9187b414);
// eslint-disable-line import/no-namespace

var $fRhMo = parcelRequire("fRhMo");
function $e3408c2d870eff4c$export$9665a07d9187b414(rawColor, alpha) {
    var color = (0, $fRhMo.normalizeHexColor)(rawColor);
    if (!color) return null;
    var hex2rgb = function hex2rgb(color) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return color.match(/[0-9a-z\u017F\u212A]{2}/gi).map(function(hex) {
            return parseInt(hex, 16);
        });
    };
    return "rgba(".concat(hex2rgb(color).concat(alpha).join(','), ")");
}

});
parcelRegister("fRhMo", function(module, exports) {
$parcel$export(module.exports, "normalizeHexColor", () => $b8b998e964f41f90$export$b61655071712e690);

var $gMcRf = parcelRequire("gMcRf");

var $bahcz = parcelRequire("bahcz");

var $ik1TX = parcelRequire("ik1TX");

var $cXJFA = parcelRequire("cXJFA");
function $b8b998e964f41f90$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ((0, $bahcz.isHex)(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map(function(c) {
            return c === '#' ? '#' : "".concat(c).concat(c);
        }).join('');
    } else if ((0, $ik1TX.isRgb)(color)) return (0, $cXJFA.rgbToHex)(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if (// eslint-disable-next-line @typescript-eslint/no-explicit-any
        $gMcRf.default && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        $gMcRf.default[color]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        color = $gMcRf.default[color];
        else if ($gMcRf && $gMcRf[color]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        color = $gMcRf[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}

});
parcelRegister("gMcRf", function(module, exports) {
module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");

});

parcelRegister("bahcz", function(module, exports) {
$parcel$export(module.exports, "isHex", () => $820df8c59a228302$export$8a9b6341a7c96bc);
// eslint-disable-line import/no-namespace
var $820df8c59a228302$var$IS_HEX_REGEX = /^#([0-9A-Fa-f]{3}){1,2}$/;
function $820df8c59a228302$export$8a9b6341a7c96bc(color) {
    return $820df8c59a228302$var$IS_HEX_REGEX.test(color);
}

});

parcelRegister("ik1TX", function(module, exports) {
$parcel$export(module.exports, "isRgb", () => $d56b91da9e3af363$export$e698776ec826343);
// eslint-disable-line import/no-namespace
var $d56b91da9e3af363$var$IS_RGB_REGEX = /rgba?\(/;
function $d56b91da9e3af363$export$e698776ec826343(color) {
    return $d56b91da9e3af363$var$IS_RGB_REGEX.test(color);
}

});




parcelRegister("4VFl9", function(module, exports) {
$parcel$export(module.exports, "taskListSelector", () => $396c8d954768a0bc$export$c0ec71adb7a18fb2);
$parcel$export(module.exports, "taskList", () => $396c8d954768a0bc$export$375b6afcc5f4d291);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
/**
 * @name taskList_node
 */ var $396c8d954768a0bc$var$name = 'actionList';
var $396c8d954768a0bc$export$c0ec71adb7a18fb2 = "[data-node-type=\"".concat($396c8d954768a0bc$var$name, "\"]");
var $396c8d954768a0bc$var$taskListParseDOMAndToDOM = {
    parseDOM: [
        {
            tag: "div".concat($396c8d954768a0bc$export$c0ec71adb7a18fb2),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-node-type': $396c8d954768a0bc$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
var $396c8d954768a0bc$export$375b6afcc5f4d291 = (0, $2gWGi.taskList)($396c8d954768a0bc$var$taskListParseDOMAndToDOM);

});

parcelRegister("lPSeS", function(module, exports) {
$parcel$export(module.exports, "text", () => $fe586f22a9d17708$export$6f093cfa640b7166);

var $2gWGi = parcelRequire("2gWGi");
var $fe586f22a9d17708$export$6f093cfa640b7166 = (0, $2gWGi.text)({
    toDebugString: function() {
        return 'text_node';
    }
});

});

parcelRegister("zEe3b", function(module, exports) {
$parcel$export(module.exports, "default", () => $06b278f7fb862e9e$export$2e2bcd8739ae039);
var $06b278f7fb862e9e$var$name = 'unknownBlock';
var $06b278f7fb862e9e$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM: function toDOM() {
        return [
            'div',
            {
                'data-node-type': $06b278f7fb862e9e$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($06b278f7fb862e9e$var$name, "\"]")
        }
    ]
};

});

parcelRegister("hAyYk", function(module, exports) {
$parcel$export(module.exports, "unsupportedBlock", () => $cce0ed2f35758eb2$export$44b79b0979d0f0f7);

var $2gWGi = parcelRequire("2gWGi");
var $cce0ed2f35758eb2$export$44b79b0979d0f0f7 = (0, $2gWGi.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: function getAttrs(dom) {
                return {
                    originalValue: JSON.parse(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-original-value') || '{}')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("40acJ", function(module, exports) {
$parcel$export(module.exports, "unsupportedInline", () => $2e9f13e3dcb010d6$export$310ebe0d80122e9b);

var $2gWGi = parcelRequire("2gWGi");
var $2e9f13e3dcb010d6$export$310ebe0d80122e9b = (0, $2gWGi.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: function getAttrs(dom) {
                return {
                    originalValue: JSON.parse(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-original-value') || '{}')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("5BI9O", function(module, exports) {
$parcel$export(module.exports, "bodiedRule", () => $4152a92aca9aa215$export$2069efcbff2f0292);
$parcel$export(module.exports, "bodiedRuleRootOnlyStage0", () => $4152a92aca9aa215$export$208411233915368e);

var $25nEq = parcelRequire("25nEq");

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
function $4152a92aca9aa215$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4152a92aca9aa215$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4152a92aca9aa215$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4152a92aca9aa215$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name bodiedRule_node
 */ /**
 * @name bodiedRule_root_only_node
 */ var $4152a92aca9aa215$var$getAttrs = function getAttrs(domNode) {
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    var dom = domNode;
    var weight = dom.getAttribute('data-weight');
    return {
        alignment: dom.getAttribute('data-alignment') || undefined,
        color: dom.getAttribute('data-color') || undefined,
        localId: dom.getAttribute('data-local-id') || (0, $l4823.uuid).generate(),
        style: dom.getAttribute('data-style') || undefined,
        weight: weight === null || weight === '' ? undefined : Number(weight)
    };
};
var $4152a92aca9aa215$export$2069efcbff2f0292 = (0, $2gWGi.bodiedRuleStage0)({
    parseDOM: [
        {
            tag: 'div[data-node-type="bodied-rule"]',
            getAttrs: $4152a92aca9aa215$var$getAttrs
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, alignment = _node$attrs.alignment, color = _node$attrs.color, localId = _node$attrs.localId, style = _node$attrs.style, weight = _node$attrs.weight;
        return [
            'div',
            {
                'data-node-type': 'bodied-rule',
                'data-alignment': alignment || undefined,
                'data-color': color || undefined,
                'data-local-id': localId || undefined,
                'data-style': style || undefined,
                'data-weight': weight !== null && weight !== void 0 ? weight : undefined
            },
            0
        ];
    }
});
var $4152a92aca9aa215$export$208411233915368e = $4152a92aca9aa215$var$_objectSpread($4152a92aca9aa215$var$_objectSpread({}, $4152a92aca9aa215$export$2069efcbff2f0292), {}, {
    marks: 'breakout unsupportedMark unsupportedNodeAttribute'
});

});


parcelRegister("dIXl1", function(module, exports) {
$parcel$export(module.exports, "sanitizeNodes", () => $9fdd69bb2f717f48$export$daf54fed04c8fb77);

var $25nEq = parcelRequire("25nEq");
function $9fdd69bb2f717f48$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9fdd69bb2f717f48$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9fdd69bb2f717f48$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9fdd69bb2f717f48$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9fdd69bb2f717f48$export$daf54fed04c8fb77(nodes, supportedMarks) {
    var nodeNames = Object.keys(nodes);
    nodeNames.forEach(function(nodeKey) {
        var nodeSpec = $9fdd69bb2f717f48$var$_objectSpread({}, nodes[nodeKey]);
        if (nodeSpec.marks && nodeSpec.marks !== '_') // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        nodeSpec.marks = nodeSpec.marks.split(' ').filter(function(mark) {
            return !!supportedMarks[mark];
        }).join(' ');
        if (nodeSpec.content) nodeSpec.content = $9fdd69bb2f717f48$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $9fdd69bb2f717f48$var$sanitizeNodeSpecContent(nodes, rawContent) {
    var content = rawContent.replace(/(?:[\0-\/:-@\[-\^`\{-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g, ' ');
    var contentKeys = content.split(' ');
    var unsupportedContentKeys = Array.from(new Set(contentKeys.filter(function(contentKey) {
        return !$9fdd69bb2f717f48$var$isContentSupported(nodes, contentKey);
    }))).sort(function(a, b) {
        return b.length - a.length;
    });
    return unsupportedContentKeys.reduce(function(newContent, nodeName) {
        return $9fdd69bb2f717f48$var$sanitizedContent(newContent, nodeName);
    }, rawContent);
}
var $9fdd69bb2f717f48$var$WORD_CHAR_REGEX = /[0-9A-Z_a-z]/;
function $9fdd69bb2f717f48$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match($9fdd69bb2f717f48$var$WORD_CHAR_REGEX)) return '';
    var pattern = "(".concat(invalidContent, "((\\s)*\\|)+)|((\\|(\\s)*)+").concat(invalidContent, "(\\+|\\*)?)|(").concat(invalidContent, "$)|(").concat(invalidContent, "(\\+|\\*))");
    // Ignored via go/ees019
    return content.replace(new RegExp(pattern, 'gu'), '').replace('  ', ' ').trim();
}
function $9fdd69bb2f717f48$var$isContentSupported(nodes, contentKey) {
    var nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(var supportedKey in nodes)if (nodes.hasOwnProperty(supportedKey)) {
        var nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});


parcelRegister("NggDw", function(module, exports) {
$parcel$export(module.exports, "extendedPanelC1RootOnlyStage0", () => $0941321225e8d741$export$9ef8544aba133962);

var $25nEq = parcelRequire("25nEq");

var $bPF1d = parcelRequire("bPF1d");
function $0941321225e8d741$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0941321225e8d741$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0941321225e8d741$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0941321225e8d741$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0941321225e8d741$export$9ef8544aba133962 = function extendedPanelC1RootOnlyStage0(allowCustomPanel) {
    var panelNodeSpec = (0, $bPF1d.extendedPanelC1WithLocalId)(allowCustomPanel);
    return $0941321225e8d741$var$_objectSpread($0941321225e8d741$var$_objectSpread({}, panelNodeSpec), {}, {
        marks: "breakout ".concat(panelNodeSpec.marks)
    });
};

});
parcelRegister("bPF1d", function(module, exports) {
$parcel$export(module.exports, "extendedPanelC1WithLocalId", () => $89d4468b9d5f0770$export$9c65e35ecb68f683);

var $2gWGi = parcelRequire("2gWGi");

var $5lT1R = parcelRequire("5lT1R");
var $89d4468b9d5f0770$export$9c65e35ecb68f683 = function extendedPanelC1WithLocalId(allowCustomPanel) {
    return (0, $2gWGi.panelC1Stage0)((0, $5lT1R.createPanelNodeSpecOptions)(allowCustomPanel, true));
};

});


parcelRegister("gXBJA", function(module, exports) {
$parcel$export(module.exports, "extendedPanelRootOnlyStage0", () => $c58f6d417fb89ccf$export$71123ea8f73a7fb);

var $25nEq = parcelRequire("25nEq");

var $6DMV8 = parcelRequire("6DMV8");
function $c58f6d417fb89ccf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c58f6d417fb89ccf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c58f6d417fb89ccf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c58f6d417fb89ccf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c58f6d417fb89ccf$export$71123ea8f73a7fb = function extendedPanelRootOnlyStage0(allowCustomPanel) {
    var panelNodeSpec = (0, $6DMV8.extendedPanelWithLocalId)(allowCustomPanel);
    return $c58f6d417fb89ccf$var$_objectSpread($c58f6d417fb89ccf$var$_objectSpread({}, panelNodeSpec), {}, {
        marks: "breakout ".concat(panelNodeSpec.marks)
    });
};

});
parcelRegister("6DMV8", function(module, exports) {
$parcel$export(module.exports, "extendedPanelWithLocalId", () => $4d5c55339b0940f9$export$855c3c67c9c9ebaf);

var $2gWGi = parcelRequire("2gWGi");

var $5lT1R = parcelRequire("5lT1R");
var $4d5c55339b0940f9$export$855c3c67c9c9ebaf = function extendedPanelWithLocalId(allowCustomPanel) {
    return (0, $2gWGi.panel)((0, $5lT1R.createPanelNodeSpecOptions)(allowCustomPanel, true));
};

});



parcelRegister("gA3qV", function(module, exports) {
$parcel$export(module.exports, "default", () => $c122abe76d5b40d8$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $l9NcB = parcelRequire("l9NcB");
var $c122abe76d5b40d8$var$createNamespaceContext = function createNamespaceContext(namespace) {
    var displayName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'NamespacedContext';
    var Component = function Component(props) {
        var newData = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, namespace, props.data);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $l9NcB.default), {
            data: newData
        }, (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.only(props.children));
    };
    Component.displayName = displayName;
    return Component;
};
var $c122abe76d5b40d8$export$2e2bcd8739ae039 = $c122abe76d5b40d8$var$createNamespaceContext;

});

parcelRegister("jJH6F", function(module, exports) {
$parcel$export(module.exports, "EVENT_TYPE", () => $e5e3a854a8f07017$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $e5e3a854a8f07017$export$9523889e0a5da4ba);
$parcel$export(module.exports, "INPUT_METHOD", () => $e5e3a854a8f07017$export$85f107b1fcc9d96f);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $e5e3a854a8f07017$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $e5e3a854a8f07017$export$9957974f8b4d8f74);
var $e5e3a854a8f07017$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $e5e3a854a8f07017$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["ACTIONED"] = "actioned";
    ACTION["ACTIVATED"] = "activated";
    ACTION["ADDED"] = "added";
    ACTION["API_ERROR"] = "apiError";
    ACTION["API_RECEIVED"] = "apiReceived";
    ACTION["API_PURGED"] = "apiPurged";
    ACTION["BROWSER_FREEZE"] = "browserFreeze";
    ACTION["CANCELLED"] = "cancelled";
    ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
    ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
    ACTION["CHANGED_ICON"] = "changedIcon";
    ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
    ACTION["CHANGED_LAYOUT"] = "changedLayout";
    ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
    ACTION["CHANGED_TYPE"] = "changedType";
    ACTION["CHANGED_URL"] = "changedUrl";
    ACTION["CLEARED"] = "cleared";
    ACTION["CLICK"] = "click";
    ACTION["CLICKED"] = "clicked";
    ACTION["CLOSED"] = "closed";
    ACTION["COMMITTED"] = "committed";
    /** used in @atlassian/editor-referentiality */ ACTION["CONNECTED_NODES"] = "connectedNodes";
    ACTION["CONVERTED"] = "converted";
    ACTION["COPIED"] = "copied";
    ACTION["COPY_FAILED"] = "copyFailed";
    ACTION["CUT"] = "cut";
    ACTION["DEACTIVATED"] = "deactivated";
    ACTION["DECREMENTED"] = "decremented";
    ACTION["DELETED"] = "deleted";
    ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
    ACTION["DISCARDED"] = "discarded";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
    ACTION["DISMISSED"] = "dismissed";
    ACTION["DISPLAYED"] = "displayed";
    ACTION["DIVERGED"] = "diverged";
    ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
    ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
    ACTION["DOUBLE_CLICKED"] = "doubleClicked";
    ACTION["DRAGGED"] = "dragged";
    ACTION["EDITED"] = "edited";
    ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
    ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
    ACTION["EDITOR_MOUNTED"] = "mounted";
    ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["ENDED"] = "ended";
    ACTION["ENTERED"] = "entered";
    ACTION["ERROR"] = "error";
    ACTION["ERRORED"] = "errored";
    ACTION["EXPERIENCE_MEASURED"] = "experienceMeasured";
    ACTION["EXPERIENCE_SAMPLED"] = "experienceSampled";
    ACTION["EXPOSED"] = "exposed";
    ACTION["FETCHED"] = "fetched";
    ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
    ACTION["FAILED_TO_INSERT"] = "failedToInsert";
    ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
    ACTION["FIND_PERFORMED"] = "findPerformed";
    ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
    ACTION["UNDO_PERFORMED"] = "undo";
    ACTION["REDO_PERFORMED"] = "redo";
    ACTION["FORMATTED"] = "formatted";
    ACTION["HELP_OPENED"] = "helpOpened";
    ACTION["HIGHLIGHTED"] = "highlighted";
    ACTION["INCREMENTED"] = "incremented";
    ACTION["INDENTED"] = "indented";
    ACTION["INITIALISED"] = "initialised";
    ACTION["INITIATED"] = "initiated";
    /** used in @atlassian/editor-referentiality */ ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
    ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
    ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
    ACTION["INSERTED"] = "inserted";
    ACTION["INSERT_ATTEMPTED"] = "insertAttempted";
    ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
    ACTION["INVOKED"] = "invoked";
    /** used in @atlassian/editor-referentiality */ ACTION["GOT_CONNECTIONS"] = "gotConnections";
    ACTION["LANGUAGE_SELECTED"] = "languageSelected";
    ACTION["LIMITED_MODE_LATCHED"] = "limitedModeLatched";
    ACTION["LANGUAGE_AUTO_DETECTED"] = "languageAutoDetected";
    ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
    ACTION["MATCHED"] = "matched";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
    ACTION["ACCEPTED"] = "accepted";
    ACTION["NO_DIFF_FOUND"] = "noDiffFound";
    ACTION["OFFLINE_STORAGE_TOO_MANY_RETRIES_ERROR"] = "offlineStorageTooManyRetriesError";
    ACTION["OFFLINE_STORAGE_FAILED_STEPS"] = "offlineStorageFailedSteps";
    ACTION["OFFLINE_STORAGE_STEPS_DATABASE_ERROR"] = "offlineStorageStepsDatabaseError";
    ACTION["OFFLINE_STORAGE_RESYNC_ONLINE"] = "offlineStorageResyncOnline";
    ACTION["OFFLINE_STORAGE_BROADCAST_CHANNEL_FIRST_UPDATE"] = "offlineStorageBroadcastChannelFirstUpdate";
    ACTION["OFFLINE_STORAGE_RESTORE_STEPS_INITIATED"] = "offlineStorageRestoreStepsInitiated";
    ACTION["OPENED"] = "opened";
    ACTION["OUTDENTED"] = "outdented";
    ACTION["PASTED"] = "pasted";
    ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
    ACTION["PASTED_TIMED"] = "pastedTimed";
    ACTION["PRESSED"] = "pressed";
    ACTION["QUICK_INSERT_INFORMATION"] = "quickInsertInformation";
    ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
    ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
    ACTION["REFERENCE_SYNCED_BLOCK_DELETE"] = "referenceSyncedBlockDelete";
    ACTION["REFERENCE_SYNCED_BLOCK_UPDATE"] = "referenceSyncedBlockUpdate";
    ACTION["REFERENCE_SYNCED_BLOCK_UNSYNC"] = "referenceSyncedBlockUnsync";
    ACTION["REFERENCE_SYNCED_BLOCK_COPY"] = "referenceSyncedBlockCopy";
    ACTION["RIGHT_RAIL_VIEWED"] = "rightRailViewed";
    ACTION["REPLACED_ALL"] = "replacedAll";
    ACTION["REPLACED_ONE"] = "replacedOne";
    ACTION["RESOLVED"] = "resolved";
    ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
    ACTION["SELECTED"] = "selected";
    ACTION["SHOWN"] = "shown";
    ACTION["SLOW_INPUT"] = "slowInput";
    ACTION["STARTED"] = "started";
    ACTION["STOPPED"] = "stopped";
    ACTION["SUBMITTED"] = "submitted";
    ACTION["SUBSTITUTED"] = "autoSubstituted";
    ACTION["SYNCED_BLOCK_CREATE"] = "syncedBlockCreate";
    ACTION["SYNCED_BLOCK_UPDATE"] = "syncedBlockUpdate";
    ACTION["SYNCED_BLOCK_FETCH"] = "syncedBlockFetch";
    ACTION["SYNCED_BLOCK_FETCH_REFERENCES"] = "syncedBlockFetchReferences";
    ACTION["SYNCED_BLOCK_DELETE"] = "syncedBlockDelete";
    ACTION["SYNCED_BLOCK_GET_SOURCE_INFO"] = "syncedBlockGetSourceInfo";
    ACTION["SYNCED_BLOCK_UNSYNC"] = "syncedBlockUnsync";
    ACTION["SYNCED_BLOCK_EDIT_SOURCE"] = "syncedBlockEditSource";
    ACTION["SYNCED_BLOCK_VIEW_SYNCED_LOCATIONS"] = "syncedBlockViewSyncedLocations";
    ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
    ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
    ACTION["SYNCHRONY_ERROR"] = "synchronyError";
    ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
    ACTION["TOGGLED"] = "toggled";
    ACTION["TRIGGERED"] = "triggered";
    ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
    ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
    ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
    ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
    ACTION["TYPING_FINISHED"] = "typingFinished";
    ACTION["TYPING_STARTED"] = "typingStarted";
    ACTION["UNHANDLED_ERROR_CAUGHT"] = "unhandledErrorCaught";
    ACTION["UNLINK"] = "unlinked";
    ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
    ACTION["UPDATED"] = "updated";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_SOURCE"] = "updatedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_TARGET"] = "updatedTarget";
    ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
    ACTION["RENDERED"] = "rendered";
    ACTION["RENDERED_SAMPLED"] = "renderedSampled";
    ACTION["REASONING_VIEWED"] = "reasoningViewed";
    ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
    /**
   * @private
   * @deprecated
   *
   * This is no longer used and can be removed at a later date
   */ ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
    ACTION["NESTED_TABLE_TRANSFORMED"] = "nestedTableTransformed";
    ACTION["CONTAINER_NODE_TRANSFORMED"] = "containerNodeTransformed";
    ACTION["NATIVE_EMBEDS_TRANSFORMED"] = "nativeEmbedsTransformed";
    ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
    ACTION["REMOVE_ICON"] = "removedIcon";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
    ACTION["CRASHED"] = "unhandledErrorCaughtV2";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    // remove this enum when cleaning up platform_editor_remove_collab_step_metrics
    ACTION["NCS_SESSION_STEP_METRICS"] = "ncsSessionStepMetrics";
    ACTION["STEPS_TRACKED"] = "stepsTracked";
    ACTION["ORGANIC_CHANGES_TRACKED"] = "organicChangesTracked";
    ACTION["STEPS_FILTERED"] = "stepsFiltered";
    ACTION["AGENT_EDIT_SHIMMER_NOT_SHOWN"] = "agentEditShimmerNotShown";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
    ACTION["RECORD_VIDEO"] = "recordVideo";
    ACTION["INSERT_VIDEO"] = "insertVideo";
    ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
    ACTION["ADD_CHILD"] = "addChild";
    ACTION["CHANGE_ACTIVE"] = "changeActive";
    ACTION["REMOVE_CHILD"] = "removeChild";
    ACTION["UPDATE_PARAMETERS"] = "updateParameters";
    ACTION["GET_CHILDREN"] = "getChildren";
    ACTION["GET_CHILDREN_CONTAINER"] = "getChildrenContainer";
    ACTION["MOVED"] = "moved";
    ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
    ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
    ACTION["UPLOAD_FAILED"] = "uploadFailed";
    ACTION["TOGGLE_CODE_FOLDING"] = "toggleCodeFolding";
    ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
    ACTION["TOGGLE_CODE_BLOCK_LINE_NUMBERS"] = "toggleCodeBlockLineNumbers";
    ACTION["TRANSFORMED"] = "transformed";
    ACTION["RESIZED"] = "resized";
    ACTION["RESIZED_PERF_SAMPLING"] = "resizedPerfSampling";
    ACTION["BLOCKS_DRAG_INIT"] = "blocksDragInit";
    ACTION["SINGLE_COL_LAYOUT_DETECTED"] = "singleColumLayoutDetected";
    ACTION["VIEW_MORE"] = "viewMore";
    ACTION["LOCAL_ID_NOT_FOUND"] = "localIdNotFound";
    ACTION["LOCAL_IDS_REPAIRED"] = "localIdsRepaired";
    ACTION["NO_DOC_CHANGE_FOUND"] = "noDocChangeFound";
    ACTION["INVALID_COMMAND_FOUND"] = "invalidCommandFound";
    ACTION["MEDIA_SINGLE_WIDTH_TRANSFORMED"] = "mediaSingleWidthTransformed";
    /**
   * used in Editor AI inline suggestion for a track event when a suggestion is inserted
   * previously tracked events being used by Editor AI proactive suggestion
   *
   */ ACTION["SUGGESTION_INSERTED"] = "suggestionInserted";
    ACTION["SUGGESTION_DISMISSED"] = "suggestionDismissed";
    ACTION["SUGGESTION_VIEWED"] = "suggestionViewed";
    // fired when the on-device autocomplete LLM finishes loading/starting
    ACTION["LOCAL_MODEL_LOADED"] = "localModelLoaded";
    // fired when the on-device autocomplete LLM fails to load/start
    ACTION["LOCAL_MODEL_LOAD_FAILED"] = "localModelLoadFailed";
    ACTION["TABLE_WIDTH_INFO"] = "tableWidthInformation";
    ACTION["SUPPRESSED"] = "suppressed";
    return ACTION;
}({});
var $e5e3a854a8f07017$export$85f107b1fcc9d96f = /*#__PURE__*/ function(INPUT_METHOD) {
    INPUT_METHOD["ASCII"] = "ascii";
    INPUT_METHOD["AUTO"] = "auto";
    INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
    INPUT_METHOD["BUTTON"] = "button";
    INPUT_METHOD["BLUR"] = "blur";
    INPUT_METHOD["CARD"] = "card";
    INPUT_METHOD["CLIPBOARD"] = "clipboard";
    INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
    INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
    INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
    INPUT_METHOD["DRAG"] = "drag";
    INPUT_METHOD["EXTERNAL"] = "external";
    INPUT_METHOD["EXTENSION_API"] = "extensionApi";
    INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
    INPUT_METHOD["FORMATTING"] = "autoformatting";
    INPUT_METHOD["INSERT_MENU"] = "insertMenu";
    INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
    INPUT_METHOD["KEYBOARD"] = "keyboard";
    INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
    INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
    INPUT_METHOD["MANUAL"] = "manual";
    INPUT_METHOD["PICKER"] = "picker";
    INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
    INPUT_METHOD["PREFILL"] = "prefill";
    INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
    INPUT_METHOD["SHORTCUT"] = "shortcut";
    INPUT_METHOD["TOOLBAR"] = "toolbar";
    INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
    INPUT_METHOD["DATASOURCE"] = "datasource_config";
    INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
    INPUT_METHOD["MOUSE"] = "mouse";
    INPUT_METHOD["BROWSER"] = "browser";
    INPUT_METHOD["DOUBLE_CLICK"] = "doubleClick";
    INPUT_METHOD["META_CLICK"] = "metaClick";
    INPUT_METHOD["INLINE_SUGGESTION_FLOATING_TB"] = "inlineSuggestionFloatingToolbar";
    INPUT_METHOD["SYNCED_BLOCK_TB"] = "syncedBlockToolbar";
    INPUT_METHOD["BLOCK_MENU"] = "blockMenu";
    INPUT_METHOD["SMART_LINK"] = "smartLink";
    INPUT_METHOD["ELEMENT_BROWSER"] = "elementBrowser";
    INPUT_METHOD["LAYOUT_COLUMN_MENU"] = "layoutColumnMenu";
    INPUT_METHOD["REMIX"] = "remix";
    INPUT_METHOD["REMIX_FROM_MEDIA_INSERTS"] = "remixFromMediaInserts";
    return INPUT_METHOD;
}({});
var $e5e3a854a8f07017$export$9395e0d0ae49956f = /*#__PURE__*/ function(MEDIA_INSERT_TAB) {
    MEDIA_INSERT_TAB["CREATE"] = "create";
    MEDIA_INSERT_TAB["LINK"] = "link";
    MEDIA_INSERT_TAB["UPLOAD"] = "upload";
    return MEDIA_INSERT_TAB;
}({});
var $e5e3a854a8f07017$export$9b31fa32ae3f8051 = /*#__PURE__*/ function(INSERT_MEDIA_VIA) {
    INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
    INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
    INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
    return INSERT_MEDIA_VIA;
}({});
var $e5e3a854a8f07017$export$81a8b7dba1aa8f75 = /*#__PURE__*/ function(TRIGGER_METHOD) {
    TRIGGER_METHOD["BUTTON"] = "button";
    TRIGGER_METHOD["KEYBOARD"] = "keyboard";
    // single key, e.g. Esc, Enter
    TRIGGER_METHOD["SHORTCUT"] = "shortcut";
    // combination of keys, e.g. Mod + F
    TRIGGER_METHOD["TOOLBAR"] = "toolbar";
    TRIGGER_METHOD["EXTERNAL"] = "external";
    return TRIGGER_METHOD;
}({});
var $e5e3a854a8f07017$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["AI_INTERACTION"] = "aiInteraction";
    ACTION_SUBJECT["AI_RESULT"] = "aiResult";
    ACTION_SUBJECT["AI_FEEDBACK"] = "aiFeedback";
    ACTION_SUBJECT["AI_STREAMING"] = "aiStreaming";
    ACTION_SUBJECT["COLLAB"] = "collab";
    ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
    ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
    ACTION_SUBJECT["DATE"] = "date";
    ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
    ACTION_SUBJECT["DIVIDER"] = "divider";
    ACTION_SUBJECT["DOCUMENT"] = "document";
    ACTION_SUBJECT["EDITOR"] = "editor";
    ACTION_SUBJECT["ACTIVITY_SESSION"] = "activitySession";
    ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
    ACTION_SUBJECT["EMBEDS"] = "embeds";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["EXTENSION"] = "extension";
    ACTION_SUBJECT["EXTENSION_AS_INLINE"] = "extensionAsInline";
    ACTION_SUBJECT["FEATURE"] = "feature";
    ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
    ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
    ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
    ACTION_SUBJECT["HEADING"] = "heading";
    ACTION_SUBJECT["HELP"] = "help";
    ACTION_SUBJECT["INVITE_ITEM"] = "inviteItem";
    ACTION_SUBJECT["LAYOUT"] = "layout";
    ACTION_SUBJECT["LAYOUT_COLUMN_MENU"] = "layoutColumnMenu";
    ACTION_SUBJECT["LIST"] = "list";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["MENTION"] = "mention";
    ACTION_SUBJECT["MENTION_TYPEAHEAD"] = "mentionTypeahead";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["PANEL"] = "panel";
    ACTION_SUBJECT["PICKER"] = "picker";
    ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
    ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
    ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
    ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT["SELECTION"] = "selection";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
    ACTION_SUBJECT["TEAM_MENTION_TYPEAHEAD"] = "teamMentionTypeahead";
    ACTION_SUBJECT["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT["TEXT"] = "text";
    ACTION_SUBJECT["TOOLBAR"] = "toolbar";
    ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
    ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
    ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
    ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["TOOLTIP"] = "tooltip";
    ACTION_SUBJECT["LOOM"] = "loom";
    ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
    ACTION_SUBJECT["DRAG"] = "drag";
    ACTION_SUBJECT["ELEMENT"] = "element";
    ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
    ACTION_SUBJECT["ENGAGEMENT_PLATFORM"] = "engagementPlatform";
    ACTION_SUBJECT["MEDIA_VIEWER"] = "mediaViewer";
    ACTION_SUBJECT["DECORATION"] = "decoration";
    ACTION_SUBJECT["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT["EDITOR_PLUGIN_SELECTION_EXTENSION"] = "editorPluginSelectionExtension";
    ACTION_SUBJECT["AI_DEFINITIONS"] = "aiDefinitions";
    ACTION_SUBJECT["AI_QUICK_PROMPT"] = "aiQuickPrompt";
    ACTION_SUBJECT["AI_AUTOCOMPLETE"] = "aiAutocomplete";
    ACTION_SUBJECT["AI_SUGGESTIONS"] = "aiSuggestions";
    ACTION_SUBJECT["CONTEXTUAL_TYPEAHEAD"] = "contextualTypeahead";
    ACTION_SUBJECT["USER_PREFERENCES"] = "userPreferences";
    ACTION_SUBJECT["ALIGNMENT"] = "alignment";
    ACTION_SUBJECT["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT["TOOLBAR_DROPDOWN_MENU"] = "toolbarDropdownMenu";
    ACTION_SUBJECT["TOOLBAR_DROPDOWN_MENU_ITEM"] = "toolbarDropdownMenuItem";
    ACTION_SUBJECT["BLOCK_MENU"] = "blockMenu";
    ACTION_SUBJECT["BLOCK_MENU_ITEM"] = "blockMenuItem";
    ACTION_SUBJECT["PASTE_ACTIONS_MENU"] = "pasteActionsMenu";
    ACTION_SUBJECT["QUICK_INSERT"] = "quickInsert";
    ACTION_SUBJECT["SYNCED_BLOCK"] = "syncedBlock";
    ACTION_SUBJECT["NATIVE_EMBED"] = "nativeEmbed";
    ACTION_SUBJECT["NATIVE_EMBED_FALLBACK"] = "nativeEmbedFallback";
    return ACTION_SUBJECT;
}({});
var $e5e3a854a8f07017$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["ACTION"] = "action";
    ACTION_SUBJECT_ID["ACTIVITY"] = "activity";
    ACTION_SUBJECT_ID["AI_CHANGES_ACCEPT_BUTTON"] = "aiChangesAcceptButton";
    ACTION_SUBJECT_ID["AI_CHANGES_REJECT_BUTTON"] = "aiChangesRejectButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_DEFINE_BUTTON"] = "aiDefinitionsDefineButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_AUTO_HIGHLIGHT"] = "aiDefinitionsAutoHighlight";
    ACTION_SUBJECT_ID["AI_INLINE_SUGGESTION"] = "aiInlineSuggestion";
    ACTION_SUBJECT_ID["AI_PANELS_BODIED_EXTENSION"] = "aiPanelsBodiedExtension";
    ACTION_SUBJECT_ID["AI_PROMPT_LINK_PICKER_BUTTON"] = "aiPromptLinkPickerButton";
    ACTION_SUBJECT_ID["AI_PROMPT_MENTION_BUTTON"] = "aiPromptMentionButton";
    ACTION_SUBJECT_ID["AI_PROACTIVE_FEEDBACK_DIALOG"] = "aiProactiveFeedbackDialog";
    ACTION_SUBJECT_ID["AI_ASK_ROVO_BUTTON"] = "aiAskRovoButton";
    ACTION_SUBJECT_ID["AI_HERO_PROMPT_BUTTON"] = "aiHeroPromptButton";
    ACTION_SUBJECT_ID["AI_REMIX_BUTTON"] = "aiRemixButton";
    ACTION_SUBJECT_ID["AI_MORE_ROVO_OPTIONS"] = "aiMoreRovoOptions";
    ACTION_SUBJECT_ID["AI_TRANSLATE"] = "aiTranslate";
    ACTION_SUBJECT_ID["AI_CHANGE_TONE"] = "aiChangeTone";
    ACTION_SUBJECT_ID["ALL"] = "all";
    ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
    ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
    ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
    ACTION_SUBJECT_ID["BLOCK_MENU"] = "blockMenu";
    ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["BORDER"] = "border";
    ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
    ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
    ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
    ACTION_SUBJECT_ID["CANCEL"] = "cancel";
    ACTION_SUBJECT_ID["CAPTION"] = "caption";
    ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
    ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
    ACTION_SUBJECT_ID["CELL"] = "cell";
    ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    ACTION_SUBJECT_ID["CONVERSATION_ERROR"] = "conversationError";
    ACTION_SUBJECT_ID["SUGGESTIONS_REGENERATION_ERROR"] = "suggestionsRegenerationError";
    ACTION_SUBJECT_ID["SUGGESTIONS_ERROR_RETRY"] = "suggestionsErrorRetry";
    ACTION_SUBJECT_ID["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT_ID["COPY_LINK_TO_ANCHOR"] = "copyLinkToAnchor";
    ACTION_SUBJECT_ID["COPY_BLOCK"] = "copyBlock";
    ACTION_SUBJECT_ID["COPY_LINK_TO_BLOCK"] = "copyLinkToBlock";
    ACTION_SUBJECT_ID["DELETE_BLOCK"] = "deleteBlock";
    ACTION_SUBJECT_ID["MOVE_UP_BLOCK"] = "moveUpBlock";
    ACTION_SUBJECT_ID["MOVE_DOWN_BLOCK"] = "moveDownBlock";
    ACTION_SUBJECT_ID["TRANSFORM_BLOCK"] = "transformBlock";
    ACTION_SUBJECT_ID["FORMAT_MENU"] = "formatMenu";
    ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
    ACTION_SUBJECT_ID["DATE"] = "date";
    ACTION_SUBJECT_ID["DATE_DAY"] = "day";
    ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
    ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
    ACTION_SUBJECT_ID["DECISION"] = "decision";
    ACTION_SUBJECT_ID["DISCARD_STREAM"] = "discardStream";
    ACTION_SUBJECT_ID["DIVIDER"] = "divider";
    ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
    ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
    ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
    ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
    ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    ACTION_SUBJECT_ID["EXPAND"] = "expand";
    ACTION_SUBJECT_ID["EXPERIENCE_APPLICATION"] = "experienceApplication";
    ACTION_SUBJECT_ID["EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
    ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
    ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
    ACTION_SUBJECT_ID["FLOATING_TOOLBAR_OVERFLOW"] = "floatingToolbarOverflow";
    ACTION_SUBJECT_ID["FLOATING_TOOLBAR"] = "floatingToolbar";
    ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
    ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
    ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
    ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
    ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
    ACTION_SUBJECT_ID["FORMAT_SMALL_TEXT"] = "smallText";
    ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
    ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
    ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
    ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
    ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
    ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
    ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
    ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
    ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
    ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
    ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
    ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
    ACTION_SUBJECT_ID["HOVER_LABEL"] = "hoverLabel";
    ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["LAYOUT"] = "layout";
    ACTION_SUBJECT_ID["LAYOUT_COLUMN"] = "layoutColumn";
    ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
    ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
    ACTION_SUBJECT_ID["MEDIA"] = "media";
    ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
    ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
    ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["MENTION"] = "mention";
    ACTION_SUBJECT_ID["MENTION_PROVIDER"] = "mentionProvider";
    ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["NODE"] = "node";
    ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
    ACTION_SUBJECT_ID["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT_ID["PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
    ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
    ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
    ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
    ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
    ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
    ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
    ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
    ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
    ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
    ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
    ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
    ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
    ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
    ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
    ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
    ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
    ACTION_SUBJECT_ID["PICKER_TABLE_SIZE"] = "tableSizePicker";
    ACTION_SUBJECT_ID["DOCKED_PRIMARY_TOOLBAR"] = "dockedPrimaryToolbar";
    ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
    ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
    ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
    ACTION_SUBJECT_ID["PRIMARY_TOOLBAR"] = "primaryToolbar";
    ACTION_SUBJECT_ID["PROACTIVE_SUGGESTION"] = "proactiveSuggestion";
    ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
    ACTION_SUBJECT_ID["PUNC"] = "punctuation";
    ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
    ACTION_SUBJECT_ID["QUICK_INSERT"] = "quickInsert";
    ACTION_SUBJECT_ID["RANGE"] = "range";
    ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
    ACTION_SUBJECT_ID["RESIZED"] = "resized";
    ACTION_SUBJECT_ID["RESPONSE_FEEDBACK_BUTTON"] = "responseFeedbackButton";
    ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
    ACTION_SUBJECT_ID["SAVE"] = "save";
    ACTION_SUBJECT_ID["SECTION"] = "section";
    ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
    ACTION_SUBJECT_ID["SMART_LINK_ROVO_BUTTON"] = "smartLinkRovoButton";
    ACTION_SUBJECT_ID["SMART_LINK_SUMMARIZE_BUTTON"] = "smartLinkSummarizeButton";
    ACTION_SUBJECT_ID["STATUS"] = "status";
    ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
    ACTION_SUBJECT_ID["TABLE"] = "table";
    ACTION_SUBJECT_ID["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT_ID["TEXT"] = "text";
    ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
    ACTION_SUBJECT_ID["TOOLBAR_PREVIEW"] = "previewFromToolbar";
    ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
    ACTION_SUBJECT_ID["UNLINK"] = "unlink";
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
    ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
    ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
    ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
    ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
    ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT_ID["UPDATE_STREAM"] = "updateStream";
    ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR_PREFERENCES"] = "selectionToolbarPreferences";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR"] = "selectionToolbar";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_DROPDOWN"] = "editorPluginSelectionExtensionDropdown";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_ITEM"] = "editorPluginSelectionExtensionItem";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT"] = "editorPluginSelectionExtensionComponent";
    ACTION_SUBJECT_ID["TRANSFORM"] = "transform";
    ACTION_SUBJECT_ID["BODIED_SYNCED_BLOCK"] = "bodiedSyncBlock";
    ACTION_SUBJECT_ID["SYNCED_BLOCK"] = "syncBlock";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_TOOLBAR"] = "syncedBlockToolbar";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_COPY"] = "syncedBlockCopy";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_SOURCE_URL"] = "syncedBlockSourceUrl";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_UPDATE_CACHE"] = "syncedBlockUpdateCache";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_UPDATE"] = "syncedBlockUpdate";
    ACTION_SUBJECT_ID["REFERENCE_SYNCED_BLOCK_UPDATE"] = "referenceSyncedBlockUpdate";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_CREATE"] = "syncedBlockCreate";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_ADD_CONTENT"] = "syncedBlockAddContent";
    ACTION_SUBJECT_ID["REFERENCE_SYNCED_BLOCK_CREATE"] = "referenceSyncedBlockCreate";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_DELETE"] = "syncedBlockDelete";
    ACTION_SUBJECT_ID["REFERENCE_SYNCED_BLOCK_DELETE"] = "referenceSyncedBlockDelete";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_GET_SOURCE_INFO"] = "syncedBlockGetSourceInfo";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_FETCH"] = "syncedBlockFetch";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_FETCH_REFERENCES"] = "syncedBlockFetchReferences";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_CLICK_SYNCED_LOCATION"] = "syncedBlockClickSyncedLocation";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_LABEL"] = "syncedBlockLabel";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_SSR_ERROR"] = "syncedBlockSSRError";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_SOURCE_INFO_ORPHANED"] = "syncedBlockSourceInfoOrphaned";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_CACHE_DELETION_FORCED"] = "syncedBlockCacheDeletionForced";
    ACTION_SUBJECT_ID["UNSUPPORTED_SURFACE"] = "unsupportedSurface";
    ACTION_SUBJECT_ID["TABLE_STICKY_HEADER"] = "tableStickyHeader";
    ACTION_SUBJECT_ID["SNIPPET"] = "snippet";
    return ACTION_SUBJECT_ID;
}({});
var $e5e3a854a8f07017$export$75ef928acd21e35b = /*#__PURE__*/ function(FLOATING_CONTROLS_TITLE) {
    FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
    FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
    FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
    FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
    FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
    FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
    FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
    return FLOATING_CONTROLS_TITLE;
}({});
var $e5e3a854a8f07017$export$9f0b2adf3cfd71b7 = /*#__PURE__*/ function(CONTENT_COMPONENT) {
    CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
    CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
    CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
    CONTENT_COMPONENT["SELECTION_TOOLBAR"] = "selectionToolbar";
    return CONTENT_COMPONENT;
}({});

});

parcelRegister("3tz1M", function(module, exports) {
$parcel$export(module.exports, "expValEquals", () => $287f40536fb8b792$export$45abdb3f977b5b14);

var $kE9E8 = parcelRequire("kE9E8");
function $287f40536fb8b792$export$45abdb3f977b5b14(experimentName, experimentParam, experimentExpectedValue) {
    var experimentDefaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return (0, $kE9E8.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, true);
}

});
parcelRegister("kE9E8", function(module, exports) {
$parcel$export(module.exports, "expValEqualsInternal", () => $f07f06a7c56a5d00$export$58e581060588c6bb);

var $ivkVy = parcelRequire("ivkVy");

var $8qy01 = parcelRequire("8qy01");

var $cQG0q = parcelRequire("cQG0q");

var $2uJ2L = parcelRequire("2uJ2L");
// This internal representation doesn't currently support productKeys
// the way expVal(...) does, this adds temporary support for some keys while
// we determine our preferred approach forward
var $f07f06a7c56a5d00$var$allowsProductKeys = [
    'cc-maui-experiment',
    'cc_maui_create_keyword',
    'cc_maui_create_keyword_aa',
    'platform_use_unicode_emojis'
];
function $f07f06a7c56a5d00$export$58e581060588c6bb(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, experimentExposure) {
    var _editorExperimentsCon, _editorExperimentsCon2;
    if ((0, $2uJ2L._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $2uJ2L._overrides)[experimentName] === experimentExpectedValue;
    // If client is not initialized, we compare with the default value
    if (!(0, $ivkVy.default).initializeCompleted()) return experimentDefaultValue === experimentExpectedValue;
    // Typescript is complaining here about accessing the productKeys property
    var experimentKeyName = $f07f06a7c56a5d00$var$allowsProductKeys.includes(experimentName) ? (_editorExperimentsCon = (_editorExperimentsCon2 = (0, $cQG0q.editorExperimentsConfig)[experimentName]) === null || _editorExperimentsCon2 === void 0 || (_editorExperimentsCon2 = _editorExperimentsCon2.productKeys) === null || _editorExperimentsCon2 === void 0 ? void 0 : _editorExperimentsCon2[0, $2uJ2L._product]) !== null && _editorExperimentsCon !== void 0 ? _editorExperimentsCon : experimentName : experimentName;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $ivkVy.default).getExperimentValue(experimentKeyName, experimentParam, experimentDefaultValue, {
        fireExperimentExposure: experimentExposure
    });
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $ivkVy.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $8qy01.addFeatureFlagAccessed)("".concat(experimentKeyName, ":").concat(experimentParam), experimentValue);
    return experimentValue === experimentExpectedValue;
}

});
parcelRegister("ivkVy", function(module, exports) {
$parcel$export(module.exports, "default", () => $d78b5af2e9b09485$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $2MffS = parcelRequire("2MffS");

var $1OJWH = parcelRequire("1OJWH");



var $d78b5af2e9b09485$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $d78b5af2e9b09485$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$d78b5af2e9b09485$var$_FeatureGates = $d78b5af2e9b09485$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "client", new (0, $2MffS.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$d78b5af2e9b09485$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $d78b5af2e9b09485$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $d78b5af2e9b09485$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$d78b5af2e9b09485$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $d78b5af2e9b09485$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $d78b5af2e9b09485$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "initializeCalled", $d78b5af2e9b09485$var$_FeatureGates.client.initializeCalled.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "initializeCompleted", $d78b5af2e9b09485$var$_FeatureGates.client.initializeCompleted.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "waitUntilInitializeCompleted", $d78b5af2e9b09485$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "initialize", $d78b5af2e9b09485$var$_FeatureGates.client.initialize.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "initializeWithProvider", $d78b5af2e9b09485$var$_FeatureGates.client.initializeWithProvider.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "initializeFromValues", $d78b5af2e9b09485$var$_FeatureGates.client.initializeFromValues.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "manuallyLogGateExposure", $d78b5af2e9b09485$var$_FeatureGates.client.manuallyLogGateExposure.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "getExperiment", $d78b5af2e9b09485$var$_FeatureGates.client.getExperiment.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "manuallyLogExperimentExposure", $d78b5af2e9b09485$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "manuallyLogLayerExposure", $d78b5af2e9b09485$var$_FeatureGates.client.manuallyLogLayerExposure.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "shutdownStatsig", $d78b5af2e9b09485$var$_FeatureGates.client.shutdownStatsig.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "overrideGate", $d78b5af2e9b09485$var$_FeatureGates.client.overrideGate.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "clearGateOverride", $d78b5af2e9b09485$var$_FeatureGates.client.clearGateOverride.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "overrideConfig", $d78b5af2e9b09485$var$_FeatureGates.client.overrideConfig.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "clearConfigOverride", $d78b5af2e9b09485$var$_FeatureGates.client.clearConfigOverride.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "setOverrides", $d78b5af2e9b09485$var$_FeatureGates.client.setOverrides.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "getOverrides", $d78b5af2e9b09485$var$_FeatureGates.client.getOverrides.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "clearAllOverrides", $d78b5af2e9b09485$var$_FeatureGates.client.clearAllOverrides.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "isCurrentUser", $d78b5af2e9b09485$var$_FeatureGates.client.isCurrentUser.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "onGateUpdated", $d78b5af2e9b09485$var$_FeatureGates.client.onGateUpdated.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "onExperimentValueUpdated", $d78b5af2e9b09485$var$_FeatureGates.client.onExperimentValueUpdated.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "onAnyUpdated", $d78b5af2e9b09485$var$_FeatureGates.client.onAnyUpdated.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "updateUser", $d78b5af2e9b09485$var$_FeatureGates.client.updateUser.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "updateUserWithProvider", $d78b5af2e9b09485$var$_FeatureGates.client.updateUserWithProvider.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "updateUserWithValues", $d78b5af2e9b09485$var$_FeatureGates.client.updateUserWithValues.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "getPackageVersion", $d78b5af2e9b09485$var$_FeatureGates.client.getPackageVersion.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "getTargetApp", $d78b5af2e9b09485$var$_FeatureGates.client.getTargetApp.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "getLayer", $d78b5af2e9b09485$var$_FeatureGates.client.getLayer.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "getLayerValue", $d78b5af2e9b09485$var$_FeatureGates.client.getLayerValue.bind($d78b5af2e9b09485$var$_FeatureGates.client));
var $d78b5af2e9b09485$var$boundFGJS = $d78b5af2e9b09485$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $d78b5af2e9b09485$var$FeatureGates;
    else {
        var $d78b5af2e9b09485$var$_boundFGJS, $d78b5af2e9b09485$var$_boundFGJS$getPackage;
        $d78b5af2e9b09485$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $d78b5af2e9b09485$var$boundVersion = (($d78b5af2e9b09485$var$_boundFGJS = $d78b5af2e9b09485$var$boundFGJS) === null || $d78b5af2e9b09485$var$_boundFGJS === void 0 || ($d78b5af2e9b09485$var$_boundFGJS$getPackage = $d78b5af2e9b09485$var$_boundFGJS.getPackageVersion) === null || $d78b5af2e9b09485$var$_boundFGJS$getPackage === void 0 ? void 0 : $d78b5af2e9b09485$var$_boundFGJS$getPackage.call($d78b5af2e9b09485$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($d78b5af2e9b09485$var$boundVersion !== (0, $1OJWH.CLIENT_VERSION)) {
            var $d78b5af2e9b09485$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($d78b5af2e9b09485$var$boundVersion, " when module version ").concat((0, $1OJWH.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($d78b5af2e9b09485$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $d78b5af2e9b09485$export$2e2bcd8739ae039 = $d78b5af2e9b09485$var$boundFGJS;

});
parcelRegister("2MffS", function(module, exports) {
$parcel$export(module.exports, "Client", () => $205be5d487f24bd6$export$1f2bb630327ac4b6);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");

var $a2rTA = parcelRequire("a2rTA");

var $2JDKH = parcelRequire("2JDKH");

var $fhNL7 = parcelRequire("fhNL7");

var $cjLbo = parcelRequire("cjLbo");

var $aZMpI = parcelRequire("aZMpI");

var $hTYAN = parcelRequire("hTYAN");

var $a5c9l = parcelRequire("a5c9l");

var $8gCwK = parcelRequire("8gCwK");

var $i8loy = parcelRequire("i8loy");

var $14TSq = parcelRequire("14TSq");

var $kN1Sb = parcelRequire("kN1Sb");

var $1rHHs = parcelRequire("1rHHs");

var $lK9nx = parcelRequire("lK9nx");

var $1OJWH = parcelRequire("1OJWH");
var $205be5d487f24bd6$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $205be5d487f24bd6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $205be5d487f24bd6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $205be5d487f24bd6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $205be5d487f24bd6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $205be5d487f24bd6$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $205be5d487f24bd6$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $205be5d487f24bd6$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $14TSq.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscriptions", new (0, $a2rTA.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "dataAdapter", new (0, $i8loy.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $14TSq.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $a5c9l.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 1;
                                    break;
                                }
                                if (!(0, $kN1Sb.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $a5c9l.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 1;
                                    break;
                                }
                                if (!(0, $kN1Sb.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $1OJWH.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $205be5d487f24bd6$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $1OJWH.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $lK9nx.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $a5c9l.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 1;
                                    break;
                                }
                                if (!(0, $kN1Sb.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 1:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $a5c9l.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $hTYAN.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 1;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 1:
                                _context5.next = 2;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 2:
                                _context5.next = 3;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 1:
                                if (!this.initCompleted) {
                                    _context7.next = 2;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 2:
                                _context7.next = 3;
                                return this.initPromise;
                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $2JDKH.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $2JDKH.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $cjLbo.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $kN1Sb.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $kN1Sb.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $205be5d487f24bd6$var$_objectSpread({}, clientOptions);
                                if (!clientOptions.localMode) {
                                    _context8.next = 2;
                                    break;
                                }
                                _context8.next = 1;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 1:
                                return _context8.abrupt("return");
                            case 2:
                                _context8.prev = 2;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $hTYAN.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $hTYAN.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 6;
                                break;
                            case 4:
                                _context8.prev = 4;
                                _t = _context8["catch"](2);
                                if (_t instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t === null || _t === void 0 ? void 0 : _t.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t;
                            case 6:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            2,
                            4
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $205be5d487f24bd6$var$_objectSpread($205be5d487f24bd6$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 2;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 2:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 6;
                                break;
                            case 4:
                                _context9.prev = 4;
                                _t2 = _context9["catch"](1);
                                if (_t2 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t2 === null || _t2 === void 0 ? void 0 : _t2.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t2;
                            case 6:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            4
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, _args0 = arguments, _t3;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $8gCwK.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $205be5d487f24bd6$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $205be5d487f24bd6$var$_objectSpread($205be5d487f24bd6$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $205be5d487f24bd6$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $lK9nx.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(newClientOptions, $205be5d487f24bd6$var$_excluded);
                                frontendUser = (0, $1rHHs.toStatsigUser)(identifiers, customAttributes);
                                this.user = (0, $aZMpI.deepAssign)({}, initializeValues.user, frontendUser);
                                statsigOptions = $205be5d487f24bd6$var$_objectSpread($205be5d487f24bd6$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 1;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 2;
                                return this.statsigClient.initializeAsync();
                            case 2:
                                _context0.next = 5;
                                break;
                            case 3:
                                _context0.prev = 3;
                                _t3 = _context0["catch"](1);
                                if (_t3 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_t3 === null || _t3 === void 0 ? void 0 : _t3.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($205be5d487f24bd6$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 4;
                                return this.statsigClient.initializeAsync();
                            case 4:
                                this.initWithDefaults = true;
                                throw _t3;
                            case 5:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise, _t4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 1:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 2;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 2:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 3;
                                _context10.next = 4;
                                return this.initPromise;
                            case 4:
                                _context10.next = 6;
                                break;
                            case 5:
                                _context10.prev = 5;
                                _t4 = _context10["catch"](3);
                            case 6:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 1;
                                                    break;
                                                }
                                                _context1.next = 1;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 1:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 7:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            3,
                            5
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, frontendUser, _updateUserCompletion, _ref4, errMsg, success, errorMessage, _t5, _t6;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 2;
                                return initializeValuesPromise;
                            case 2:
                                initializeValues = _context11.sent;
                                frontendUser = (0, $1rHHs.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, $aZMpI.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
                                _context11.next = 4;
                                break;
                            case 3:
                                _context11.prev = 3;
                                _t5 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _t5 instanceof Error ? _t5.message : JSON.stringify(_t5);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _t5;
                            case 4:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 5;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 6;
                                    break;
                                }
                                _context11.next = 6;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 6:
                                _context11.next = 8;
                                break;
                            case 7:
                                _context11.prev = 7;
                                _t6 = _context11["catch"](5);
                                success = false;
                                errorMessage = String(_t6);
                            case 8:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 9;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 10;
                                break;
                            case 9:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 10:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            3
                        ],
                        [
                            5,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $1OJWH.CLIENT_VERSION;
            }
        },
        {
            key: "getTargetApp",
            value: function getTargetApp() {
                var _this$initOptions2;
                return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $fhNL7.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $fhNL7.Layer).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("a2rTA", function(module, exports) {
$parcel$export(module.exports, "default", () => $74efbac534cea6a3$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $hLfKH = parcelRequire("hLfKH");
function $74efbac534cea6a3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $74efbac534cea6a3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $74efbac534cea6a3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $74efbac534cea6a3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $74efbac534cea6a3$export$a66cbd9b2289cd78 = '@all-features';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $74efbac534cea6a3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $74efbac534cea6a3$var$_objectSpread($74efbac534cea6a3$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $74efbac534cea6a3$var$_objectSpread($74efbac534cea6a3$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $74efbac534cea6a3$var$_objectSpread($74efbac534cea6a3$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $74efbac534cea6a3$var$_objectSpread($74efbac534cea6a3$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($74efbac534cea6a3$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($74efbac534cea6a3$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($74efbac534cea6a3$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $74efbac534cea6a3$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("2JDKH", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $1fde9eb8de6d86b1$export$6dc24881a3d96325);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $3S9lt = parcelRequire("3S9lt");

var $hskWo = parcelRequire("hskWo");
var $1fde9eb8de6d86b1$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $3S9lt.migrateEvaluationDetails)(experiment.details), (0, $hskWo.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("3S9lt", function(module, exports) {
$parcel$export(module.exports, "migrateEvaluationDetails", () => $2d1daa0506c60c76$export$18ad168d3dbac899);

var $iYJcE = parcelRequire("iYJcE");

var $cjLbo = parcelRequire("cjLbo");
var $2d1daa0506c60c76$var$evaluationReasonMappings = Object.entries((0, $cjLbo.EvaluationReason)).map(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $2d1daa0506c60c76$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $2d1daa0506c60c76$var$evaluationReasonMappings.find(function(_ref3) {
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 1), key = _ref4[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $cjLbo.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};

});
parcelRegister("cjLbo", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $8f7bdbe08f33fd67$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $8f7bdbe08f33fd67$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
}; // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});


parcelRegister("hskWo", function(module, exports) {
$parcel$export(module.exports, "migrateSecondaryExposures", () => $cb554b9f623341e8$export$55fd683752d01e67);
var $cb554b9f623341e8$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});


parcelRegister("fhNL7", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $b20f0aa00048af96$export$936d0764594b6eb3);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $3S9lt = parcelRequire("3S9lt");

var $hskWo = parcelRequire("hskWo");
var $b20f0aa00048af96$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $3S9lt.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $hskWo.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $hskWo.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("aZMpI", function(module, exports) {
$parcel$export(module.exports, "deepAssign", () => $801527da98b74481$export$1148cb79ceecd5fa);

var $ekGgq = parcelRequire("ekGgq");

var $iYJcE = parcelRequire("iYJcE");

var $fC8ib = parcelRequire("fC8ib");
function $801527da98b74481$export$1148cb79ceecd5fa(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return $801527da98b74481$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sources)));
    for(var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], src = _Object$entries$_i[1];
        var dst = target[key];
        var srcIsObj = src && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(src) === 'object' && !Array.isArray(src);
        var dstIsObj = dst && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(dst) === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $801527da98b74481$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $801527da98b74481$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sources)));
}

});

parcelRegister("hTYAN", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0869323f9026a2d$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $lK9nx = parcelRequire("lK9nx");

var $1OJWH = parcelRequire("1OJWH");

var $daAXo = parcelRequire("daAXo");
function $d0869323f9026a2d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d0869323f9026a2d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d0869323f9026a2d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d0869323f9026a2d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d0869323f9026a2d$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $d0869323f9026a2d$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $d0869323f9026a2d$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $d0869323f9026a2d$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $d0869323f9026a2d$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $d0869323f9026a2d$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $d0869323f9026a2d$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $d0869323f9026a2d$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $d0869323f9026a2d$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $d0869323f9026a2d$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $d0869323f9026a2d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(fetcherOptions) {
                    var targetApp, url, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 1;
                                _context.next = 2;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                                _context.prev = 3;
                                _t = _context["catch"](1);
                                if (!(_t instanceof Error)) {
                                    _context.next = 4;
                                    break;
                                }
                                throw _t;
                            case 4:
                                throw Error('Failed to retrieve client sdk key');
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 2;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                                _context2.prev = 3;
                                _t2 = _context2["catch"](1);
                                if (!(_t2 instanceof Error)) {
                                    _context2.next = 4;
                                    break;
                                }
                                throw _t2;
                            case 4:
                                throw Error('Failed to retrieve experiment values');
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 2;
                                    break;
                                }
                                _context3.next = 1;
                                return response.text();
                            case 1:
                                body = _context3.sent;
                                throw new (0, $daAXo.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 2:
                                if (!(response.status === 204)) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new (0, $daAXo.ResponseError)('Unexpected 204 response');
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return response.text();
                            case 1:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $d0869323f9026a2d$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $lK9nx.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $lK9nx.FeatureGateEnvironment).Production:
                        return $d0869323f9026a2d$export$18c93900db9358a4;
                    case (0, $lK9nx.FeatureGateEnvironment).Staging:
                        return $d0869323f9026a2d$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $lK9nx.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $lK9nx.FeatureGateEnvironment).Development:
                        return $d0869323f9026a2d$export$f058dbf75c3bc647;
                    case (0, $lK9nx.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $d0869323f9026a2d$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $d0869323f9026a2d$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $d0869323f9026a2d$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 1;
                                return fetch("".concat(baseUrl).concat(path), $d0869323f9026a2d$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $1OJWH.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 1:
                                response = _context5.sent;
                                _context5.next = 2;
                                return this.handleResponseError(response);
                            case 2:
                                _context5.next = 3;
                                return this.extractResponseBody(response);
                            case 3:
                                return _context5.abrupt("return", _context5.sent);
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $d0869323f9026a2d$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($d0869323f9026a2d$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($d0869323f9026a2d$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("lK9nx", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $fd452b4241b633bb$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $fd452b4241b633bb$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $fd452b4241b633bb$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
var $fd452b4241b633bb$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
var $fd452b4241b633bb$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});

parcelRegister("1OJWH", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $152e19d0b9573482$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $152e19d0b9573482$export$a59f8d67326bd1cb = "6.0.2";

});

parcelRegister("daAXo", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $9968e069c694a701$export$286baf652d0b1206);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $9968e069c694a701$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $9968e069c694a701$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $9968e069c694a701$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9968e069c694a701$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $9968e069c694a701$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ResponseError);
        return $9968e069c694a701$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});


parcelRegister("a5c9l", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $7573cbb206e89b6b$export$d119b37e5f788b43);

var $25nEq = parcelRequire("25nEq");

var $ygbGG = parcelRequire("ygbGG");

var $lK9nx = parcelRequire("lK9nx");
function $7573cbb206e89b6b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7573cbb206e89b6b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7573cbb206e89b6b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7573cbb206e89b6b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7573cbb206e89b6b$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $7573cbb206e89b6b$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $ygbGG.isFedRamp)() ? (0, $lK9nx.PerimeterType).FEDRAMP_MODERATE : (0, $lK9nx.PerimeterType).COMMERCIAL
    }, options);
};

});

parcelRegister("8gCwK", function(module, exports) {
$parcel$export(module.exports, "migrateInitializationOptions", () => $604db40b2a67d7ff$export$202946b690d26d22);

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");
var $604db40b2a67d7ff$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $604db40b2a67d7ff$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $604db40b2a67d7ff$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $604db40b2a67d7ff$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $604db40b2a67d7ff$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $604db40b2a67d7ff$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(options, $604db40b2a67d7ff$var$_excluded);
    return $604db40b2a67d7ff$var$_objectSpread($604db40b2a67d7ff$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};

});

parcelRegister("i8loy", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $d33991f371140a0f$export$55fffef3474104af);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");
function $d33991f371140a0f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d33991f371140a0f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d33991f371140a0f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d33991f371140a0f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d33991f371140a0f$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $d33991f371140a0f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $d33991f371140a0f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d33991f371140a0f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $d33991f371140a0f$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $d33991f371140a0f$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoFetchDataAdapter);
        _this = $d33991f371140a0f$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $d33991f371140a0f$var$_objectSpread($d33991f371140a0f$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $d33991f371140a0f$var$_objectSpread($d33991f371140a0f$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $d33991f371140a0f$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $d33991f371140a0f$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));

});

parcelRegister("14TSq", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $0c918228b8ad6135$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $0c918228b8ad6135$export$bcb28fbac1def494);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $dtn6l = parcelRequire("dtn6l");
function $0c918228b8ad6135$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0c918228b8ad6135$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0c918228b8ad6135$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0c918228b8ad6135$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0c918228b8ad6135$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $0c918228b8ad6135$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $0c918228b8ad6135$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $0c918228b8ad6135$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $0c918228b8ad6135$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $0c918228b8ad6135$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $0c918228b8ad6135$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $0c918228b8ad6135$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $0c918228b8ad6135$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $0c918228b8ad6135$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $0c918228b8ad6135$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $0c918228b8ad6135$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PersistentOverrideAdapter);
        this._overrides = $0c918228b8ad6135$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $0c918228b8ad6135$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $0c918228b8ad6135$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $0c918228b8ad6135$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($0c918228b8ad6135$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.removeItem($0c918228b8ad6135$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $0c918228b8ad6135$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $0c918228b8ad6135$var$_objectSpread($0c918228b8ad6135$var$_objectSpread({}, $0c918228b8ad6135$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($0c918228b8ad6135$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($0c918228b8ad6135$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($0c918228b8ad6135$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($0c918228b8ad6135$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $0c918228b8ad6135$var$_objectSpread($0c918228b8ad6135$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $0c918228b8ad6135$var$_objectSpread($0c918228b8ad6135$var$_objectSpread({}, current.details), {}, {
                        reason: $0c918228b8ad6135$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($0c918228b8ad6135$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($0c918228b8ad6135$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($0c918228b8ad6135$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($0c918228b8ad6135$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($0c918228b8ad6135$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($0c918228b8ad6135$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $0c918228b8ad6135$var$makeEmptyStore();
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($0c918228b8ad6135$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $0c918228b8ad6135$var$_objectSpread($0c918228b8ad6135$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $0c918228b8ad6135$var$_objectSpread($0c918228b8ad6135$var$_objectSpread({}, current.details), {}, {
                        reason: $0c918228b8ad6135$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($0c918228b8ad6135$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $0c918228b8ad6135$var$_objectSpread($0c918228b8ad6135$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $0c918228b8ad6135$var$_objectSpread($0c918228b8ad6135$var$_objectSpread({}, current.details), {}, {
                        reason: $0c918228b8ad6135$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});

parcelRegister("kN1Sb", function(module, exports) {
$parcel$export(module.exports, "shallowEquals", () => $f229d62c1128b759$export$fa1c2bbf4100b8bc);

var $iYJcE = parcelRequire("iYJcE");
var $f229d62c1128b759$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};

});

parcelRegister("1rHHs", function(module, exports) {
$parcel$export(module.exports, "toStatsigUser", () => $10da35f48ba8b3b3$export$3dad1db244472f32);

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");
var $10da35f48ba8b3b3$var$_excluded = [
    "stableId"
];
function $10da35f48ba8b3b3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $10da35f48ba8b3b3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $10da35f48ba8b3b3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $10da35f48ba8b3b3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $10da35f48ba8b3b3$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    var stableId = identifiers.stableId, otherIdentifiers = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(identifiers, $10da35f48ba8b3b3$var$_excluded);
    var user = {
        customIDs: $10da35f48ba8b3b3$var$_objectSpread($10da35f48ba8b3b3$var$_objectSpread({}, otherIdentifiers), stableId !== undefined ? {
            stableID: stableId
        } : {}),
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};

});



parcelRegister("cQG0q", function(module, exports) {
$parcel$export(module.exports, "editorExperimentsConfig", () => $95aaecd90467856b$export$6cbb856f286b07ef);
/* eslint-disable perfectionist/sort-object-types */ /* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $aASgO = parcelRequire("aASgO");

var $htJJp = parcelRequire("htJJp");
var $95aaecd90467856b$export$5c897d5297c5b7fd = [
    'platform_editor_blocks',
    'platform_editor_controls',
    'advanced_layouts',
    'single_column_layouts',
    'platform_editor_preview_panel_responsiveness',
    'platform_editor_toolbar_aifc'
];
var $95aaecd90467856b$export$6cbb856f286b07ef = {
    // new format to avoid collisions with other users when updating the file
    // Added 2026-07-18
    cc_maui_remix_button_hover_corridor: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_remix_button_hover_corridor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-24
    platform_editor_layout_column_delete_shortcut_fix: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_delete_shortcut_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-21
    // `isEnabled` is the gating param; the experiment's dynamic config also carries the numeric
    // `shimmerDurationMs` (skeleton) and `highlightDurationMs` (purple highlight) durations, read at
    // runtime via `expVal`.
    platform_editor_agent_be_streaming: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_agent_be_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Editor Platform experiments
    // lwoollard experiments
    // Added 2026-04-21
    cwr_page_tree_auto_finalize: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr_page_tree_auto_finalize'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 02-12-2025
    cc_fix_hydration_ttvc: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_hydration_ttvc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    'editor_a11y__enghealth-46814_fy26': (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y__enghealth-46814_fy26'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19
    'enghealth-53346_fix_redaction_marker_editor': (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            jira: 'enghealth-53346_fix_redaction_marker_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-16
    platform_editor_remove_important_in_render_ext: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_important_in_render_ext'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-06
    confluence_comment_nudgebar_improvement: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_comment_nudgebar_improvement'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_quick_insert_embeds: (0, $htJJp.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_quick_insert_embeds'
        },
        param: 'cohort',
        values: [
            'control',
            'prioritizeLinkInQIM',
            'prioritizeEmbedInQIM'
        ],
        defaultValue: 'control'
    }),
    confluence_remix_icon_right_side: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_remix_icon_right_side'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_editor_insm_doc_size_stats: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_doc_size_stats'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-26
    cc_editor_fix_insm_inp_buffer: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_fix_insm_inp_buffer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    cwr_blank_object_experiment: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr_blank_object_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-08
    confluence_inline_comments_fix_stale_selection: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_inline_comments_fix_stale_selection'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    rovo_remix_experience_context: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'rovo_remix_experience_context'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-05
    'databases-native-embeds-v2': (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'databases-native-embeds-v2'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    cc_editor_insm_outlier_events: (0, $htJJp.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_outlier_events'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-03-24
    platform_editor_media_external_badge_bbc_fix: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_external_badge_bbc_fix',
            bitbucket: 'platform_editor_media_external_badge_bbc_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-20
    platform_editor_annotations_sync_on_docchange: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_annotations_sync_on_docchange'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $htJJp.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_per_plugin_error_boundary: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_per_plugin_error_boundary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-05
    'company_hub_carousel_thumbnails-refactor': (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'company_hub_carousel_thumbnails-refactor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $htJJp.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_paste_actions_menu: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-19
    platform_editor_controls_reliable_anchor: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_reliable_anchor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $htJJp.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls',
            jira: 'platform_editor_controls_jira'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-07-21
    confluence_cwr_3p_connection_suggested_prompts: (0, $htJJp.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_cwr_3p_connection_suggested_prompts'
        },
        param: 'cohort',
        values: [
            'control',
            'variant_a',
            'variant_b'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-05-26
    platform_editor_agent_mentions: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_agent_mentions',
            jira: 'platform_editor_agent_mentions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    platform_editor_reduced_agent_profile_cards: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_reduced_agent_profile_cards',
            jira: 'platform_editor_reduced_agent_profile_cards'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-30
    platform_editor_fix_link_paste_menu: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_link_paste_menu',
            jira: 'platform_editor_fix_link_paste_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_code_block_q4_lovability: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_code_block_q4_lovability',
            jira: 'platform_editor_code_block_q4_lovability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-16
    platform_editor_enable_single_player_step_merging: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enable_single_player_step_merging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_hide_overflow_menu: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_hide_overflow_menu',
            jira: 'platform_editor_toolbar_hide_overflow_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_responsiveness'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $htJJp.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-06-25
    jira_editor_a11y_toolbar_fixes: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'jira_editor_a11y_toolbar_fixes',
            jira: 'jira_editor_a11y_toolbar_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-09
    platform_editor_blocks: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocks_conf',
            jira: 'platform_editor_blocks_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-23
    //Added 2025-07-16
    platform_editor_toolbar_aifc: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_confluence'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_breakout_interaction_rerender: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_interaction_rerender'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_blocktaskitem_node_tenantid: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_node_tenantid'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_with_dnd: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_with_dnd'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    'editor-a11y-fy26-keyboard-move-row-column': (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor-a11y-fy26-keyboard-move-row-column',
            jira: 'editor-a11y-fy26-keyboard-move-row-column'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-28
    editor_enable_image_alignment_in_expand: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enable_image_alignment_in_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_august_a11y: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_august_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-01
    cc_editor_ai_content_mode: (0, $htJJp.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_ai_content_mode'
        },
        param: 'variant',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-01-09
    platform_editor_render_bodied_extension_as_inline: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_render_bodied_extension_as_inline'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-03
    platform_editor_ai_quick_prompt_iw_cc: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quick_prompt_iw_cc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_use_llm_space_recommendations: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_llm_space_recommendations'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-01
    // Added 2025-10-13
    platform_editor_media_error_analytics: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_error_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-27
    platform_editor_table_sticky_header_improvements: (0, $htJJp.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_improvements'
        },
        param: 'cohort',
        values: [
            'control',
            'test_with_overflow',
            'test_without_overflow'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-29
    platform_editor_lovability_inline_code: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_inline_code'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_lovability_emoji_scaling: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_emoji_scaling'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-18
    editor_a11y_7152_profile_card_tab_order: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y_7152_profile_card_tab_order'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-19
    platform_editor_lovability_navigation_fixes: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_navigation_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-27 — Pre-auth unauthorised inline hover card UX
    platform_sl_3p_preauth_better_hovercard: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_preauth_better_hovercard',
            jira: 'platform_sl_3p_preauth_better_hovercard'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-21 — Post-auth GDrive Smart Link to Rovo Chat auto-open
    platform_sl_3p_post_auth_chat_open_exp: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_post_auth_chat_open_exp',
            jira: 'platform_sl_3p_post_auth_chat_open_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-29 — Social proof inline CTA for unauthorised 3P inline smart links
    platform_sl_3p_preauth_social_proof_inline_cta: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_preauth_social_proof_inline_cta',
            jira: 'platform_sl_3p_preauth_social_proof_inline_cta'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15 — Embed card footer rovo action for resolved 3P smart links in confluence
    platform_sl_3p_auth_rovo_embed_footer_exp: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_auth_rovo_embed_footer_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_submenu_open_click: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_submenu_open_click'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-13
    platform_editor_hide_extension_renderer_support: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hide_extension_renderer_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-23
    platform_editor_fix_new_line_after_heading: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_new_line_after_heading',
            jira: 'platform_editor_fix_new_line_after_heading'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-21
    platform_editor_copy_link_a11y_inconsistency_fix: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_copy_link_a11y_inconsistency_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_editor_fix_lagging_embed_resize_handle: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_lagging_embed_resize_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-30
    platform_editor_fix_cross_origin_editor_focus: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_cross_origin_editor_focus'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_ttvc_inline_extensions: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_ttvc_inline_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    cc_fd_db_top_editor_toolbar: (0, $htJJp.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_fd_db_top_editor_toolbar'
        },
        param: 'cohort',
        values: [
            'control',
            'new-description',
            'orig-description'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-04-01
    cc_page_experiences_editor_image_generation: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_page_experiences_editor_image_generation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-23
    'cc-maui-experiment': (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-maui-experiment',
            jira: 'jira_maui_remix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_maui_create_keyword: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_create_keyword'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // A/A experiment paired with cc_maui_create_keyword, used only to balance exposures.
    cc_maui_create_keyword_aa: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_create_keyword_aa'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-13
    confluence_native_tabs_experiment: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_native_tabs_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-29
    cc_maui_polish_changes_batch_4: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_polish_changes_batch_4'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    'cc-mui-slides-experiment': (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-mui-slides-experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-27
    confluence_frontend_cwr_outcome_type_picker: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_frontend_cwr_outcome_type_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    cfe_cwr_outcome_picker_respect_site_settings: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'cfe_cwr_outcome_picker_respect_site_settings'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-12
    prompt_tile_content_type_localizaiton: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'prompt_tile_content_type_localizaiton'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-24
    'cwr-modal-ui-refresh': (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-modal-ui-refresh'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-08
    'cc-disambiguation-in-cwr': (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-disambiguation-in-cwr'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    'cwr-reduce-prompt-suggestion-max-chars': (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-reduce-prompt-suggestion-max-chars'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15
    'cwr-staging-area-close-as-minimize-button': (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-staging-area-close-as-minimize-button'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-08
    cc_cwr_prompt_strength_indicator: (0, $htJJp.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_cwr_prompt_strength_indicator'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1',
            'variant2'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-02-12
    platform_editor_a11y_escape_link_dialog: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_a11y_escape_link_dialog',
            jira: 'platform_editor_a11y_escape_link_dialog'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_vc90_transition_panel_icon: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vc90_transition_panel_icon'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_emoji_default_scale: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_default_scale',
            jira: 'platform_editor_emoji_default_scale'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-17
    platform_editor_emoji_hover_show_tooltip: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_hover_show_tooltip',
            jira: 'platform_editor_emoji_hover_show_tooltip'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    platform_teamoji_26_refresh_emoji_picker: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_teamoji_26_refresh_emoji_picker',
            jira: 'platform_teamoji_26_refresh_emoji_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-16
    platform_use_unicode_emojis: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_unicode_emojis_confluence',
            jira: 'platform_use_unicode_emojis_jira',
            bitbucket: 'platform_use_unicode_emojis_bitbucket'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-26
    platform_editor_toolbar_update_jira_config: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_toolbar_update_jira_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_ai_blockmenu_integration: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_blockmenu_integration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-26
    platform_editor_remix_in_block_menu: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remix_in_block_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19 — fix table text length calculation for Remix/Improve Writing hero prompts
    remix_iw_block_menu_table_calc_fix: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'remix_iw_block_menu_table_calc_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_rovobutton_smartlink_toolbar_exp: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_rovobutton_smartlink_toolbar_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    confluence_fe_renderer_inline_node_mark_color_fix: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_renderer_inline_node_mark_color_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_diff_plugin_extended: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_diff_plugin_extended'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_fix_media_toolbar_border_dropdown: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_media_toolbar_border_dropdown'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-06
    platform_editor_single_player_expand: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_player_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_fit_to_content_on_demand: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_fit_to_content_on_demand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-09
    platform_editor_remove_collab_step_metrics: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_collab_step_metrics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    platform_editor_ai_normalized_telemetry: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_normalized_telemetry'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-15
    platform_editor_sync_block_ssr_config: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_sync_block_ssr_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-06
    confluence_fe_create_page_suggestion: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_create_page_suggestion'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-18
    platform_editor_selection_toolbar_block_handle: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_selection_toolbar_block_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    platform_editor_improve_preset_builder_logging: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_improve_preset_builder_logging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-23
    'cc-markdown-mode': (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-markdown-mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_ai_xstate_migration: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_xstate_migration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-31
    platform_editor_dnd_accessibility_fixes_expand: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_dnd_accessibility_fixes_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-15
    platform_editor_ai_no_stream_skip_pacer: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_no_stream_skip_pacer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-07
    platform_editor_layout_column_menu: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-29
    platform_editor_layout_column_selection_fix: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_selection_fix',
            jira: 'platform_editor_layout_column_selection_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15
    platform_editor_layout_column_valign_rendering: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_valign_rendering'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    platform_editor_external_embed_grid_fix: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_external_embed_grid_fix',
            jira: 'platform_editor_external_embed_grid_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-08
    cc_fd_wb_jira_quick_insert_experiment: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            jira: 'cc_fd_wb_jira_quick_insert_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-30
    cc_fix_editor_context_on_cwr_followups: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_editor_context_on_cwr_followups'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    cc_fix_ephemeral_preview_staging_area_registration: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_ephemeral_preview_staging_area_registration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    platform_editor_hydration_skip_react_portal: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hydration_skip_react_portal'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-28
    platform_editor_use_markdown_plus_parser: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_markdown_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_use_html_plus_parser: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_html_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    platform_editor_core_static_css: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_static_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_core_non_ecc_static_css: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_non_ecc_static_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_q4_loveability: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_q4_loveability',
            jira: 'platform_editor_table_q4_loveability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    platform_editor_table_menu_updates: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_menu_updates',
            jira: 'platform_editor_table_menu_updates'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-06
    confluence_live_doc_table_sort_bugfix: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_live_doc_table_sort_bugfix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    confluence_fe_disable_comment_if_offline_fix: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_disable_comment_if_offline_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    platform_editor_sync_block_activation: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_sync_block_activation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_paste_actions_menu_v2: (0, $htJJp.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu_v2',
            jira: 'platform_editor_paste_actions_menu_v2'
        },
        param: 'variant',
        values: [
            'control',
            'hasSpellingAndGrammar',
            'hasAltAiActions'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-05-01 — Social proof experiment for unauthorized 3P block cards
    social_proof_3p_unauth_block_exp: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'social_proof_3p_unauth_block_exp',
            jira: 'social_proof_3p_unauth_block_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_replace_doc/setup
    platform_editor_ai_replace_doc: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_replace_doc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-18
    platform_editor_nest_table_in_panel: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nest_table_in_panel'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_rovo_support_create_inline_comment: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_rovo_support_create_inline_comment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_fix_sticky_header_malfunction: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_sticky_header_malfunction'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-17
    platform_editor_fix_sticky_header_row: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_sticky_header_row'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-10
    confluence_editor_paste_3p_link_actions_menu: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_paste_3p_link_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-29
    'a11y-fixes-week3-may-2026': (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'a11y-fixes-week3-may-2026',
            jira: 'a11y-fixes-week3-may-2026'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_reactions_selector_list: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_reactions_selector_list',
            jira: 'platform_a11y_fixes_reactions_selector_list'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_emoji_picker_list: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_emoji_picker_list',
            jira: 'platform_a11y_fixes_emoji_picker_list'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_emoji_title_shortname: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_emoji_title_shortname',
            jira: 'platform_a11y_fixes_emoji_title_shortname'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-25
    // HTML+ v2 incremental tool-call streaming contract — gates the new
    // PartialStreamParserV2 / ToolCallProcessorV2 / AdfChunkStrategyV2 stack
    // in `@atlassian/editor-rovo-bridge`, the `replaceValue` orchestrator
    // action, and the `toolCallsStreaming.supportsProvisionalToolCalls`
    // capability advert on `PageContentCommandResult`.
    platform_editor_use_html_plus_streaming_parser: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_html_plus_streaming_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_wide_slash_trigger: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_wide_slash_trigger'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11 — [CCI-15904] New AIFC Editor Experience (Full Page Staging Area + Post Stream Review Toolbar)
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_new_aifc_editor_experience/setup
    platform_editor_ai_new_aifc_editor_experience: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_new_aifc_editor_experience'
        },
        param: 'isBackendReviewMomentEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    // Gates the `GhostIconWave` animation primitive in
    // `@atlassian/rovo-platform-ui-components` — rendered as a loading cue on
    // Confluence's 3p-in-CWR (Rovo) surfaces. When off the primitive renders
    // nothing.
    confluence_3p_in_cwr_ghost_icons: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_3p_in_cwr_ghost_icons'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    platform_editor_lovability_text_bg_color: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_text_bg_color',
            jira: 'platform_editor_lovability_text_bg_color'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-20
    platform_editor_ssr_toolbar_optimistic: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ssr_toolbar_optimistic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19
    platform_editor_lovability_resize_dividers_panels: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_resize_dividers_panels'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_editor_add_breakout_marks_on_page_load: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_breakout_marks_on_page_load'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-23
    'aifc-confluence-editor-csp-fix': (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'aifc-confluence-editor-csp-fix',
            jira: 'aifc-confluence-editor-csp-fix'
        },
        param: 'value',
        defaultValue: false
    }),
    // Added 2026-07-01
    platform_editor_remove_pause_streaming: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_pause_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-17
    revert_remix_ephemeral_iframe_sizing_fix: (0, $aASgO.createBooleanExperiment)({
        productKeys: {
            confluence: 'revert_remix_ephemeral_iframe_sizing_fix',
            jira: 'revert_remix_ephemeral_iframe_sizing_fix'
        },
        param: 'value',
        defaultValue: false
    }),
    // Added 2026-07-28
    cwr_publish_flow_live_doc_toggle_exp: (0, $htJJp.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cwr_publish_flow_live_doc_toggle_exp'
        },
        param: 'cohort',
        defaultValue: 'control',
        values: [
            'control',
            'variantA',
            'variantB',
            'variantC'
        ]
    })
};

});
parcelRegister("aASgO", function(module, exports) {
$parcel$export(module.exports, "createBooleanExperiment", () => $7b675d1890190938$export$456f1587c9c92021);

var $25nEq = parcelRequire("25nEq");

var $I0b8U = parcelRequire("I0b8U");
function $7b675d1890190938$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7b675d1890190938$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7b675d1890190938$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7b675d1890190938$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7b675d1890190938$export$456f1587c9c92021(config) {
    return $7b675d1890190938$var$_objectSpread($7b675d1890190938$var$_objectSpread({}, config), {}, {
        typeGuard: (0, $I0b8U.isBoolean),
        defaultValue: config.defaultValue
    });
}

});
parcelRegister("I0b8U", function(module, exports) {
$parcel$export(module.exports, "isBoolean", () => $08443faa7b7e32e4$export$f9ce7b637dfbe238);
function $08443faa7b7e32e4$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}

});


parcelRegister("htJJp", function(module, exports) {
$parcel$export(module.exports, "createMultivariateExperiment", () => $cb989e61e0117b30$export$fb89e8a786694d1);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $l3lvo = parcelRequire("l3lvo");
function $cb989e61e0117b30$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cb989e61e0117b30$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cb989e61e0117b30$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cb989e61e0117b30$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cb989e61e0117b30$export$fb89e8a786694d1(config) {
    var values = config.values;
    return $cb989e61e0117b30$var$_objectSpread($cb989e61e0117b30$var$_objectSpread({}, config), {}, {
        values: (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(values),
        // Maintains the tuple
        typeGuard: (0, $l3lvo.oneOf)(config.values),
        defaultValue: config.defaultValue
    });
}

});
parcelRegister("l3lvo", function(module, exports) {
$parcel$export(module.exports, "oneOf", () => $f53a8f46214d5a72$export$a9a18ae5ba42aeab);

var $3ZMUU = parcelRequire("3ZMUU");
var $f53a8f46214d5a72$var$_process, $f53a8f46214d5a72$var$_process2;
var $f53a8f46214d5a72$var$IS_TESTING_ENV = typeof $3ZMUU !== 'undefined' && ((($f53a8f46214d5a72$var$_process = $3ZMUU) === null || $f53a8f46214d5a72$var$_process === void 0 || ($f53a8f46214d5a72$var$_process = $f53a8f46214d5a72$var$_process.env) === null || $f53a8f46214d5a72$var$_process === void 0 ? void 0 : $f53a8f46214d5a72$var$_process.NODE_ENV) === 'test' || (($f53a8f46214d5a72$var$_process2 = $3ZMUU) === null || $f53a8f46214d5a72$var$_process2 === void 0 || ($f53a8f46214d5a72$var$_process2 = $f53a8f46214d5a72$var$_process2.env) === null || $f53a8f46214d5a72$var$_process2 === void 0 ? void 0 : $f53a8f46214d5a72$var$_process2.JEST_WORKER_ID) !== undefined);
function $f53a8f46214d5a72$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
   * This is used by test utils to get the variants when running describe.each
   */ if ($f53a8f46214d5a72$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}

});



parcelRegister("2uJ2L", function(module, exports) {
$parcel$export(module.exports, "_overrides", () => $1d1152cde4aea295$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_product", () => $1d1152cde4aea295$export$cf7305fc65acbf0d);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $aZcdL = parcelRequire("aZcdL");

var $cQG0q = parcelRequire("cQG0q");
function $1d1152cde4aea295$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1d1152cde4aea295$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1d1152cde4aea295$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1d1152cde4aea295$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1d1152cde4aea295$export$e5d73bf4f8e2ae96 = {};
var $1d1152cde4aea295$export$4e849416bb5c5b52 = {};
var $1d1152cde4aea295$export$cf7305fc65acbf0d;
function $1d1152cde4aea295$export$1c2b6dbf79eb3560(product, /**
 * Overrides are used to set the group of an experiment for testing purposes.
 * This is useful when you want to test a specific experiment group.
 */ groupOverrides, /**
 * Param overrides are used to set the experiment parameters for testing purposes.
 * This is useful when you want to tweak the experiment parameters for testing.
 */ paramOverrides, options) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        groupOverrides = Object.entries(groupOverrides).reduce(function(acc, _ref) {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
            var config = (0, $cQG0q.editorExperimentsConfig)[key];
            if (config) acc = $1d1152cde4aea295$var$_objectSpread($1d1152cde4aea295$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, config.typeGuard(value) ? value : config.defaultValue));
            return acc;
        }, {});
        $1d1152cde4aea295$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test' && !(options !== null && options !== void 0 && options.disableTestOverrides)) {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        var testOverrides = Object.fromEntries(Object.entries((0, $cQG0q.editorExperimentsConfig)).map(function(_ref3) {
            var _ref5, _ref6, _groupOverrides, _groupOverrides2;
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), key = _ref4[0], value = _ref4[1];
            var defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                (_ref5 = (_ref6 = (_groupOverrides = (_groupOverrides2 = groupOverrides) === null || _groupOverrides2 === void 0 ? void 0 : _groupOverrides2[key]) !== null && _groupOverrides !== void 0 ? _groupOverrides : (0, $aZcdL.testMultivariateOverrides)[key]) !== null && _ref6 !== void 0 ? _ref6 : (0, $aZcdL.testBooleanOverrides)[key]) !== null && _ref5 !== void 0 ? _ref5 : defaultValue
            ];
        }));
        $1d1152cde4aea295$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $1d1152cde4aea295$export$cf7305fc65acbf0d = product;
    $1d1152cde4aea295$export$4e849416bb5c5b52 = paramOverrides || {};
}

});
parcelRegister("aZcdL", function(module, exports) {
$parcel$export(module.exports, "testMultivariateOverrides", () => $7ff914becf03f8e9$export$7e849a84a00ffd1c);
$parcel$export(module.exports, "testBooleanOverrides", () => $7ff914becf03f8e9$export$54960937bb713f97);
var $7ff914becf03f8e9$export$7e849a84a00ffd1c = {
    cwr_publish_flow_live_doc_toggle_exp: 'control',
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_controls: 'control',
    cc_editor_ai_content_mode: 'control',
    platform_hover_card_preview_panel: 'control',
    cc_editor_insm_outlier_events: 'test',
    platform_editor_table_sticky_header_improvements: 'test_with_overflow',
    cc_fd_db_top_editor_toolbar: 'control',
    platform_editor_paste_actions_menu_v2: 'control',
    confluence_quick_insert_embeds: 'control',
    cc_cwr_prompt_strength_indicator: 'control',
    confluence_cwr_3p_connection_suggested_prompts: 'control'
};
var $7ff914becf03f8e9$export$54960937bb713f97 = {
    cc_maui_polish_changes_batch_4: false,
    social_proof_3p_unauth_block_exp: false,
    platform_sl_3p_preauth_better_hovercard: true,
    cwr_blank_object_experiment: false,
    platform_editor_preview_panel_responsiveness: false,
    'enghealth-53346_fix_redaction_marker_editor': false,
    platform_editor_toolbar_aifc: false,
    'test-new-experiments-package': false,
    platform_renderer_table_sticky_scrollbar: false,
    advanced_layouts: false,
    single_column_layouts: false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_editor_tables_table_selector: false,
    platform_renderer_fix_analytics_memo_callback: false,
    'jira-work-sync-desc-comment-summary': false,
    platform_editor_breakout_resizing: false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_enable_single_player_step_merging: false,
    platform_editor_paste_actions_menu: false,
    platform_editor_table_fit_to_content_on_demand: false,
    platform_editor_table_q4_loveability: false,
    platform_editor_table_menu_updates: false,
    'cwr-modal-ui-refresh': false,
    'cc-disambiguation-in-cwr': false,
    'cwr-reduce-prompt-suggestion-max-chars': false,
    'cwr-staging-area-close-as-minimize-button': false,
    prompt_tile_content_type_localizaiton: false,
    // [CCI-15904] New AIFC Editor Experience — read by the inline chat prompt view
    // in `conversation-assistant-chat-prompt-input`. Review moment eligibility is a
    // separate check (`editor-plugin-ai/src/ui/utils/review-moment-enabled.ts`) and
    // does not read this key.
    platform_editor_ai_new_aifc_editor_experience: false,
    cc_page_experiences_editor_image_generation: false,
    platform_use_unicode_emojis: false,
    platform_editor_emoji_hover_show_tooltip: false,
    'aifc-confluence-editor-csp-fix': false
};

});




parcelRegister("5rVTQ", function(module, exports) {

var $4AIzG = parcelRequire("4AIzG");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $3f7c630e82d8e1a9$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $4AIzG(array, start, end);
}
module.exports = $3f7c630e82d8e1a9$var$castSlice;

});
parcelRegister("4AIzG", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $357d19d0d54cb643$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $357d19d0d54cb643$var$baseSlice;

});


parcelRegister("3gUX4", function(module, exports) {
/** Used to compose unicode character classes. */ var $261f0b2a4c7f027e$var$rsAstralRange = '\\ud800-\\udfff', $261f0b2a4c7f027e$var$rsComboMarksRange = '\\u0300-\\u036f', $261f0b2a4c7f027e$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $261f0b2a4c7f027e$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $261f0b2a4c7f027e$var$rsComboRange = $261f0b2a4c7f027e$var$rsComboMarksRange + $261f0b2a4c7f027e$var$reComboHalfMarksRange + $261f0b2a4c7f027e$var$rsComboSymbolsRange, $261f0b2a4c7f027e$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $261f0b2a4c7f027e$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $261f0b2a4c7f027e$var$reHasUnicode = RegExp('[' + $261f0b2a4c7f027e$var$rsZWJ + $261f0b2a4c7f027e$var$rsAstralRange + $261f0b2a4c7f027e$var$rsComboRange + $261f0b2a4c7f027e$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $261f0b2a4c7f027e$var$hasUnicode(string) {
    return $261f0b2a4c7f027e$var$reHasUnicode.test(string);
}
module.exports = $261f0b2a4c7f027e$var$hasUnicode;

});

parcelRegister("aqMZB", function(module, exports) {

var $6e8CA = parcelRequire("6e8CA");

var $3gUX4 = parcelRequire("3gUX4");

var $crUez = parcelRequire("crUez");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $7982560623280317$var$stringToArray(string) {
    return $3gUX4(string) ? $crUez(string) : $6e8CA(string);
}
module.exports = $7982560623280317$var$stringToArray;

});
parcelRegister("6e8CA", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $488abce9e61dd352$var$asciiToArray(string) {
    return string.split('');
}
module.exports = $488abce9e61dd352$var$asciiToArray;

});

parcelRegister("crUez", function(module, exports) {
/** Used to compose unicode character classes. */ var $9103a08849585e50$var$rsAstralRange = '\\ud800-\\udfff', $9103a08849585e50$var$rsComboMarksRange = '\\u0300-\\u036f', $9103a08849585e50$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $9103a08849585e50$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $9103a08849585e50$var$rsComboRange = $9103a08849585e50$var$rsComboMarksRange + $9103a08849585e50$var$reComboHalfMarksRange + $9103a08849585e50$var$rsComboSymbolsRange, $9103a08849585e50$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $9103a08849585e50$var$rsAstral = '[' + $9103a08849585e50$var$rsAstralRange + ']', $9103a08849585e50$var$rsCombo = '[' + $9103a08849585e50$var$rsComboRange + ']', $9103a08849585e50$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $9103a08849585e50$var$rsModifier = '(?:' + $9103a08849585e50$var$rsCombo + '|' + $9103a08849585e50$var$rsFitz + ')', $9103a08849585e50$var$rsNonAstral = '[^' + $9103a08849585e50$var$rsAstralRange + ']', $9103a08849585e50$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $9103a08849585e50$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $9103a08849585e50$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $9103a08849585e50$var$reOptMod = $9103a08849585e50$var$rsModifier + '?', $9103a08849585e50$var$rsOptVar = '[' + $9103a08849585e50$var$rsVarRange + ']?', $9103a08849585e50$var$rsOptJoin = '(?:' + $9103a08849585e50$var$rsZWJ + '(?:' + [
    $9103a08849585e50$var$rsNonAstral,
    $9103a08849585e50$var$rsRegional,
    $9103a08849585e50$var$rsSurrPair
].join('|') + ')' + $9103a08849585e50$var$rsOptVar + $9103a08849585e50$var$reOptMod + ')*', $9103a08849585e50$var$rsSeq = $9103a08849585e50$var$rsOptVar + $9103a08849585e50$var$reOptMod + $9103a08849585e50$var$rsOptJoin, $9103a08849585e50$var$rsSymbol = '(?:' + [
    $9103a08849585e50$var$rsNonAstral + $9103a08849585e50$var$rsCombo + '?',
    $9103a08849585e50$var$rsCombo,
    $9103a08849585e50$var$rsRegional,
    $9103a08849585e50$var$rsSurrPair,
    $9103a08849585e50$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $9103a08849585e50$var$reUnicode = RegExp($9103a08849585e50$var$rsFitz + '(?=' + $9103a08849585e50$var$rsFitz + ')|' + $9103a08849585e50$var$rsSymbol + $9103a08849585e50$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $9103a08849585e50$var$unicodeToArray(string) {
    return string.match($9103a08849585e50$var$reUnicode) || [];
}
module.exports = $9103a08849585e50$var$unicodeToArray;

});


parcelRegister("l75Tm", function(module, exports) {

var $6yyTH = parcelRequire("6yyTH");

var $duo48 = parcelRequire("duo48");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $f5eed274d1d1f151$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $f5eed274d1d1f151$var$rsComboMarksRange = '\\u0300-\\u036f', $f5eed274d1d1f151$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $f5eed274d1d1f151$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $f5eed274d1d1f151$var$rsComboRange = $f5eed274d1d1f151$var$rsComboMarksRange + $f5eed274d1d1f151$var$reComboHalfMarksRange + $f5eed274d1d1f151$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $f5eed274d1d1f151$var$rsCombo = '[' + $f5eed274d1d1f151$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $f5eed274d1d1f151$var$reComboMark = RegExp($f5eed274d1d1f151$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $f5eed274d1d1f151$var$deburr(string) {
    string = $duo48(string);
    return string && string.replace($f5eed274d1d1f151$var$reLatin, $6yyTH).replace($f5eed274d1d1f151$var$reComboMark, '');
}
module.exports = $f5eed274d1d1f151$var$deburr;

});
parcelRegister("6yyTH", function(module, exports) {

var $1BUSy = parcelRequire("1BUSy");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $4c60fcf10f95fb75$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $4c60fcf10f95fb75$var$deburrLetter = $1BUSy($4c60fcf10f95fb75$var$deburredLetters);
module.exports = $4c60fcf10f95fb75$var$deburrLetter;

});
parcelRegister("1BUSy", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $12c55e16f3aa6a95$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $12c55e16f3aa6a95$var$basePropertyOf;

});



parcelRegister("fBC68", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5c7dd2e8b224470$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b5c7dd2e8b224470$var$isUndefined(x) {
    return x === undefined;
}
var $b5c7dd2e8b224470$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ProviderFactory() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ProviderFactory);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "providers", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscribers", new Map());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ProviderFactory, [
        {
            key: "destroy",
            value: function destroy() {
                this.providers.clear();
                this.subscribers.clear();
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return !this.providers.size && !this.subscribers.size;
            }
        },
        {
            key: "setProvider",
            value: function setProvider(name, provider) {
                // Do not trigger notifyUpdate if provider is the same.
                if (this.providers.get(name) === provider) return;
                if (!$b5c7dd2e8b224470$var$isUndefined(provider)) this.providers.set(name, provider);
                else this.providers.delete(name);
                this.notifyUpdated(name, provider);
            }
        },
        {
            key: "removeProvider",
            value: function removeProvider(name) {
                this.providers.delete(name);
                this.notifyUpdated(name);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(name, handler) {
                var handlers = this.subscribers.get(name) || [];
                handlers.push(handler);
                this.subscribers.set(name, handlers);
                var provider = this.providers.get(name);
                if (provider) handler(name, provider);
                return provider;
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(name, handler) {
                var handlers = this.subscribers.get(name);
                if (!handlers) return;
                var index = handlers.indexOf(handler);
                if (index !== -1) handlers.splice(index, 1);
                if (handlers.length === 0) this.subscribers.delete(name);
                else this.subscribers.set(name, handlers);
            }
        },
        {
            key: "unsubscribeAll",
            value: function unsubscribeAll(name) {
                var handlers = this.subscribers.get(name);
                if (!handlers) return;
                this.subscribers.delete(name);
            }
        },
        {
            key: "hasProvider",
            value: function hasProvider(name) {
                return this.providers.has(name);
            }
        },
        {
            key: "notifyUpdated",
            value: function notifyUpdated(name, provider) {
                var handlers = this.subscribers.get(name);
                if (!handlers) return;
                handlers.forEach(function(handler) {
                    handler(name, provider);
                });
            }
        }
    ], [
        {
            key: "create",
            value: function create(// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            providers) {
                var providerFactory = new ProviderFactory();
                var keys = Object.keys(providers);
                keys.forEach(function(name) {
                    providerFactory.setProvider(name, providers[name]);
                });
                return providerFactory;
            }
        }
    ]);
}();

});

parcelRegister("d0n7Z", function(module, exports) {
$parcel$export(module.exports, "ProviderFactoryProvider", () => $977d372ececc4133$export$617c134b25cc4265);
$parcel$export(module.exports, "useProviderFactory", () => $977d372ececc4133$export$a3af4b6980aa23b5);
$parcel$export(module.exports, "useProvider", () => $977d372ececc4133$export$693cdb10cec23617);
$parcel$export(module.exports, "useProviderLayout", () => $977d372ececc4133$export$6fde1d0d81db98e1);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $fBC68 = parcelRequire("fBC68");
var $977d372ececc4133$var$ProviderFactoryContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext(new (0, $fBC68.default)());
var $977d372ececc4133$export$617c134b25cc4265 = $977d372ececc4133$var$ProviderFactoryContext.Provider;
var $977d372ececc4133$export$a3af4b6980aa23b5 = function useProviderFactory() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useContext($977d372ececc4133$var$ProviderFactoryContext);
};
var $977d372ececc4133$export$693cdb10cec23617 = function useProvider(name) {
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState, 2), provider = _React$useState2[0], setProvider = _React$useState2[1];
    var providerFactory = $977d372ececc4133$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        var providerHandler = function providerHandler(_, provider) {
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return function() {
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};
var $977d372ececc4133$export$6fde1d0d81db98e1 = function useProviderLayout(name) {
    var _React$useState3 = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(), _React$useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState3, 2), provider = _React$useState4[0], setProvider = _React$useState4[1];
    var providerFactory = $977d372ececc4133$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useLayoutEffect(function() {
        var providerHandler = function providerHandler(_, provider) {
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return function() {
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};

});

parcelRegister("1LBcl", function(module, exports) {
$parcel$export(module.exports, "akEditorFullPageDefaultFontSize", () => $149708fd63925c6e$export$fe6b0b821a0e9067);
$parcel$export(module.exports, "akEditorFullPageDenseFontSize", () => $149708fd63925c6e$export$24495b314f307191);
$parcel$export(module.exports, "akEditorCustomIconSize", () => $149708fd63925c6e$export$d2715266dd4a1fd1);
$parcel$export(module.exports, "akEditorShadowZIndex", () => $149708fd63925c6e$export$b46cda584c619451);
$parcel$export(module.exports, "akEditorStickyHeaderZIndex", () => $149708fd63925c6e$export$6bed85de54b5de42);
$parcel$export(module.exports, "akEditorFullPageMaxWidth", () => $149708fd63925c6e$export$fad19f16d3f953a3);
$parcel$export(module.exports, "akEditorDefaultLayoutWidth", () => $149708fd63925c6e$export$9db045950eedb49f);
$parcel$export(module.exports, "akEditorWideLayoutWidth", () => $149708fd63925c6e$export$74c442132af16a);
$parcel$export(module.exports, "akEditorFullWidthLayoutWidth", () => $149708fd63925c6e$export$f580e3d28d0986de);
$parcel$export(module.exports, "akEditorMaxWidthLayoutWidth", () => $149708fd63925c6e$export$c0f7d71e10d277e9);
$parcel$export(module.exports, "akEditorMaxLayoutWidth", () => $149708fd63925c6e$export$45eb0f5135abf6f1);
$parcel$export(module.exports, "akEditorTableNumberColumnWidth", () => $149708fd63925c6e$export$37df10057d36a0e5);
$parcel$export(module.exports, "akEditorBreakoutPadding", () => $149708fd63925c6e$export$437293c5e9fc2703);
$parcel$export(module.exports, "akEditorGutterPadding", () => $149708fd63925c6e$export$6e0f4d52efd3d2d);
$parcel$export(module.exports, "akEditorGutterPaddingDynamic", () => $149708fd63925c6e$export$f222e0c7a2dc5324);
$parcel$export(module.exports, "akEditorGutterPaddingReduced", () => $149708fd63925c6e$export$aae87d25ced827bb);
$parcel$export(module.exports, "akEditorFullPageNarrowBreakout", () => $149708fd63925c6e$export$cccda66937c91e4c);
$parcel$export(module.exports, "akEditorTableCellMinWidth", () => $149708fd63925c6e$export$e4d39a9e8607c1d3);
$parcel$export(module.exports, "akEditorTableLegacyCellMinWidth", () => $149708fd63925c6e$export$43946f2400ab6f1f);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPaddingWide", () => $149708fd63925c6e$export$558438ae7fd4b8ce);
$parcel$export(module.exports, "akEditorSwoopCubicBezier", () => $149708fd63925c6e$export$3b24948cd5dbb087);
$parcel$export(module.exports, "gridMediumMaxWidth", () => $149708fd63925c6e$export$5edb4f38c3eacb1a);
$parcel$export(module.exports, "breakoutWideScaleRatio", () => $149708fd63925c6e$export$e60820063058ed59);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidthSmallViewport", () => $149708fd63925c6e$export$60da500206e2ceec);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidth", () => $149708fd63925c6e$export$c0e6648ae1bb2fac);
$parcel$export(module.exports, "akLayoutGutterOffset", () => $149708fd63925c6e$export$847030921e9d5a40);
$parcel$export(module.exports, "akEditorLineHeight", () => $149708fd63925c6e$export$40eb41ab799f0329);
$parcel$export(module.exports, "akEditorWrappedNodeZIndex", () => $149708fd63925c6e$export$e88f6c898960b391);
$parcel$export(module.exports, "blockNodesVerticalMargin", () => $149708fd63925c6e$export$1d0d506416d457f1);
$parcel$export(module.exports, "scaledBlockNodesVerticalMargin", () => $149708fd63925c6e$export$53030af820b542f5);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_WIDTH", () => $149708fd63925c6e$export$e683ef42725d1713);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_HEIGHT", () => $149708fd63925c6e$export$226c784ba04bd04b);
$parcel$export(module.exports, "akEditorSelectedNodeClassName", () => $149708fd63925c6e$export$a02a3f1515c2e21a);
$parcel$export(module.exports, "relativeFontSizeToBase16", () => $149708fd63925c6e$export$59733a9f61449b25);

var $iYJcE = parcelRequire("iYJcE");

var $50U6m = parcelRequire("50U6m");

var $f3HJP = parcelRequire("f3HJP");
var $149708fd63925c6e$export$fe6b0b821a0e9067 = 16;
var $149708fd63925c6e$export$24495b314f307191 = 13;
var $149708fd63925c6e$export$9a7c520c39e1f0aa = "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
var $149708fd63925c6e$export$1d762aef048d30f9 = "var(--ds-background-accent-gray-subtler, #DDDEE1)";
var $149708fd63925c6e$export$a7a75e50ae62d0a8 = "var(--ds-border, #0B120E24)";
var $149708fd63925c6e$export$b9864494c2608629 = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
var $149708fd63925c6e$export$f0e953d95429ca1 = '12px';
var $149708fd63925c6e$export$a309dbdeca0adb1a = '2px 4px';
var $149708fd63925c6e$export$ef95eb6ef0fd0a4a = "var(--ds-background-danger, #FFECEB)";
var $149708fd63925c6e$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)'; // R75 with 50% opacity
var $149708fd63925c6e$export$3c108a6bc41bb5f2 = "var(--ds-border-danger, #E2483D)";
var $149708fd63925c6e$export$bf3aaa2106c119fd = "var(--ds-icon-danger, #C9372C)";
var $149708fd63925c6e$export$d2715266dd4a1fd1 = 20;
var $149708fd63925c6e$export$cf524c1b49838a49 = "var(--ds-border-selected, #1868DB)";
var $149708fd63925c6e$export$8dac549e32469ac4 = 1;
var $149708fd63925c6e$export$befaaae517e3d864 = 2;
var $149708fd63925c6e$export$6e1e1996c4e8cc51 = "".concat($149708fd63925c6e$export$8dac549e32469ac4, "px solid ", "var(--ds-border-selected, #1868DB)");
var $149708fd63925c6e$export$b6a59ac3a19b6343 = "0 0 0 ".concat($149708fd63925c6e$export$8dac549e32469ac4, "px ", "var(--ds-border-selected, #1868DB)");
var $149708fd63925c6e$export$37e178ca41c198ca = "0 0 0 ".concat($149708fd63925c6e$export$befaaae517e3d864, "px ", "var(--ds-border-selected, #1868DB)");
var $149708fd63925c6e$export$4a007c22e25e31f6 = 0.3;
var $149708fd63925c6e$export$f35cc48f3398ab79 = 1;
var $149708fd63925c6e$export$b46cda584c619451 = 2;
var $149708fd63925c6e$export$6bed85de54b5de42 = 11; // filmstrip uses 10 for its shadow
var $149708fd63925c6e$export$321ddd2f049dd12 = $149708fd63925c6e$export$6bed85de54b5de42 + 1;
var $149708fd63925c6e$export$daeac9b8422ac3c2 = 2;
var $149708fd63925c6e$export$501d46e11ed5bf73 = 500;
var $149708fd63925c6e$export$6817b4b6a5ef78f1 = 400;
var $149708fd63925c6e$export$93768eb72dec48ce = $149708fd63925c6e$export$501d46e11ed5bf73 + 10;
var $149708fd63925c6e$export$c0aec4e0896849a0 = $149708fd63925c6e$export$93768eb72dec48ce - 5;
var $149708fd63925c6e$export$5886f057e4f21fe4 = $149708fd63925c6e$export$6817b4b6a5ef78f1 + 5;
var $149708fd63925c6e$export$6e85faa46d537a3f = 11;
var $149708fd63925c6e$export$36ba77fba4a62d5f = "var(--ds-background-accent-gray-subtler, #DDDEE1)";
var $149708fd63925c6e$export$640eef769748f78f = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
var $149708fd63925c6e$export$4c6f61fb4b9ae93 = '#F1F2F4';
var $149708fd63925c6e$export$95e9a0285b97474d = '#2C333A';
var $149708fd63925c6e$export$f7bbcec54ff5bc47 = "var(--ds-border-focused, #4688EC)";
var $149708fd63925c6e$export$76b5e653883e5290 = '3px';
var $149708fd63925c6e$export$d0fb376c4d4be9e2 = '--table-container-bg';
var $149708fd63925c6e$export$6d85fe8177a50c0c = 0.5;
var $149708fd63925c6e$export$fad19f16d3f953a3 = 680;
var $149708fd63925c6e$export$9db045950eedb49f = 760;
var $149708fd63925c6e$export$74c442132af16a = 960; // This value is used for tables with breakouts and is used to calculate `breakoutWidthPx`
var $149708fd63925c6e$export$f580e3d28d0986de = 1800;
var $149708fd63925c6e$export$c0f7d71e10d277e9 = 4000;
var $149708fd63925c6e$export$9d5488b5afad62bf = 1792;
var $149708fd63925c6e$export$45eb0f5135abf6f1 = 4000;
var $149708fd63925c6e$export$37df10057d36a0e5 = 42;
var $149708fd63925c6e$export$437293c5e9fc2703 = 96;
var $149708fd63925c6e$export$6e0f4d52efd3d2d = 32;
var $149708fd63925c6e$export$f222e0c7a2dc5324 = function akEditorGutterPaddingDynamic() {
    return 72;
};
var $149708fd63925c6e$export$aae87d25ced827bb = 24;
var $149708fd63925c6e$export$cccda66937c91e4c = 600;
var $149708fd63925c6e$export$efe8561bbd3f74d2 = 720;
var $149708fd63925c6e$export$e4d39a9e8607c1d3 = 48;
var $149708fd63925c6e$export$43946f2400ab6f1f = 128;
var $149708fd63925c6e$export$558438ae7fd4b8ce = 12;
var $149708fd63925c6e$export$6beb98d32d4ca149 = 4;
var $149708fd63925c6e$export$3b24948cd5dbb087 = "cubic-bezier(0.15, 1, 0.3, 1)";
var $149708fd63925c6e$export$5edb4f38c3eacb1a = 1024;
var $149708fd63925c6e$export$e60820063058ed59 = 1.33;
var $149708fd63925c6e$export$60da500206e2ceec = 905; // from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
var $149708fd63925c6e$export$c0e6648ae1bb2fac = 1011; // = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
var $149708fd63925c6e$export$fb15fade89f67217 = $149708fd63925c6e$export$f35cc48f3398ab79 * 99;
var $149708fd63925c6e$export$847030921e9d5a40 = 12;
var $149708fd63925c6e$export$40eb41ab799f0329 = 1.714;
var $149708fd63925c6e$export$e271312fc7124aec = '1px';
var $149708fd63925c6e$export$d29cb2c31fcbb7c5 = 2;
var $149708fd63925c6e$export$688a6dc01e760755 = 320;
var $149708fd63925c6e$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
var $149708fd63925c6e$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
var $149708fd63925c6e$export$e88f6c898960b391 = $149708fd63925c6e$export$f35cc48f3398ab79 * 2; //prevent paragraph nodes from rendering above wrapped nodes
var $149708fd63925c6e$export$e5c605f2b2a12b00 = {
    SMALL: 550,
    MEDIUM: 760
};
var $149708fd63925c6e$export$1d0d506416d457f1 = '0.75rem';
var $149708fd63925c6e$export$53030af820b542f5 = '0.75em';
var $149708fd63925c6e$export$e683ef42725d1713 = 680;
var $149708fd63925c6e$export$226c784ba04bd04b = 480;
var $149708fd63925c6e$export$214ff00e5618d86c = 20;
var $149708fd63925c6e$export$c82675fa56f2eefd = '56px';
var $149708fd63925c6e$var$DEFAULT_FONT_SIZE = 14;
var $149708fd63925c6e$export$d7726a000ae2d7c = function FULL_PAGE_EDITOR_TOOLBAR_HEIGHT(isToolbarAIFCEnabled) {
    if (// if value is undefined assume this is being called outside of editor where the experiment can be checked
    isToolbarAIFCEnabled === undefined ? (0, $f3HJP.editorExperiment)('platform_editor_toolbar_aifc', true) || (0, $50U6m.fg)('platform_editor_ai_aifc_streaming') : isToolbarAIFCEnabled) return '44px';
    if ((0, $f3HJP.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) return "var(--ds-space-500, 40px)";
    return "var(--ds-space-500, 40px)";
};
var $149708fd63925c6e$export$d1343597f3b52d83 = 40;
var $149708fd63925c6e$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
var $149708fd63925c6e$export$58a725ff69bda73a = function editorFontSize(_ref) {
    var theme = _ref.theme;
    return theme && theme.baseFontSize ? theme.baseFontSize : $149708fd63925c6e$var$DEFAULT_FONT_SIZE;
};
var $149708fd63925c6e$export$945a9e125632354d = function relativeSize(multiplier) {
    return function(_ref2) {
        var theme = _ref2.theme;
        return $149708fd63925c6e$export$58a725ff69bda73a({
            theme: theme
        }) * multiplier;
    };
};
var $149708fd63925c6e$export$59733a9f61449b25 = function relativeFontSizeToBase16(px) {
    if (typeof px === 'string') px = parseInt(px);
    if (isNaN(px)) throw new Error("Invalid font size: '".concat(px, "'"));
    return "".concat(px / 16, "rem");
};
var $149708fd63925c6e$export$46715ac1fbd9e64e = function relativeSizeToBaseFontSize(value) {
    return "calc(".concat(value, " * var(--ak-editor-base-font-size) / ").concat($149708fd63925c6e$export$fe6b0b821a0e9067, ")");
};
var $149708fd63925c6e$export$96b72b7f243fa693 = {
    a4KMonitor: {
        width: 3440,
        height: 1440
    },
    laptopHiDPI: {
        width: 1440,
        height: 900
    },
    laptopMDPI: {
        width: 1280,
        height: 800
    },
    tabletL: {
        width: 1024,
        height: 1366
    },
    tabletS: {
        width: 768,
        height: 1024
    },
    mobileM: {
        width: 414,
        height: 736
    },
    mobileS: {
        width: 375,
        height: 667
    },
    mobileXS: {
        width: 320,
        height: 568
    }
};
var $149708fd63925c6e$export$9369fd010fa0ddd6 = 0;
var $149708fd63925c6e$export$846a716e9e69a8df = [
    [
        'White',
        '#000000'
    ],
    [
        'Light blue',
        '#0C294F'
    ],
    [
        'Light teal',
        '#0C343B'
    ],
    [
        'Light green',
        '#052E21'
    ],
    [
        'Light yellow',
        '#484123'
    ],
    [
        'Light red',
        '#441C13'
    ],
    [
        'Light purple',
        '#282249'
    ],
    [
        'Light gray',
        '#202328'
    ],
    [
        'Blue',
        '#0B3165'
    ],
    [
        'Teal',
        '#044853'
    ],
    [
        'Green',
        '#053927'
    ],
    [
        'Yellow',
        '#6F5C25'
    ],
    [
        'Red',
        '#582013'
    ],
    [
        'Purple',
        '#3E327B'
    ],
    [
        'Gray',
        '#475262'
    ],
    [
        'Dark blue',
        '#003884'
    ],
    [
        'Dark teal',
        '#055866'
    ],
    [
        'Dark green',
        '#044932'
    ],
    [
        'Dark yellow',
        '#82641C'
    ],
    [
        'Dark red',
        '#6B2A19'
    ],
    [
        'Dark purple',
        '#4D38B2'
    ]
].map(function(_ref3) {
    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), colorName = _ref4[0], colorValue = _ref4[1];
    return $149708fd63925c6e$export$5f2dade43b841301(colorName, colorValue);
}).join('\n');
function $149708fd63925c6e$export$5f2dade43b841301(colorName, colorValue) {
    return "\n  &[colorname=\"".concat(colorName, "\"] {\n    background-color: ").concat(colorValue, " !important; // !important to override default style color\n  }\n  ");
}
var $149708fd63925c6e$export$312e1e71424c4aa1 = [
    "var(--ds-icon-accent-red, #C9372C)",
    "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    "var(--ds-icon-accent-magenta, #CD519D)",
    "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "var(--ds-icon-accent-orange, #E06C00)",
    "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    "var(--ds-icon-accent-green, #22A06B)",
    "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    "var(--ds-icon-accent-blue, #357DE8)",
    "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    "var(--ds-icon-accent-teal, #2898BD)",
    "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    "var(--ds-icon-accent-lime, #6A9A23)",
    "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    "var(--ds-icon-accent-purple, #AF59E1)",
    "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    "var(--ds-icon-accent-gray, #7D818A)",
    "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    "var(--ds-icon-accent-yellow, #B38600)",
    "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    "var(--ds-background-accent-yellow-bolder-pressed, #614A05)"
];
var $149708fd63925c6e$export$42608c013398a830 = [
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
        svgBackgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-blue-bolder, #1868DB)",
        svgBackgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
        svgBackgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)",
        svgBackgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-purple-bolder, #964AC0)",
        svgBackgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)",
        svgBackgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)",
        svgBackgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-orange-bolder, #BD5B00)",
        svgBackgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)",
        svgBackgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-gray-bolder, #6B6E76)",
        svgBackgroundColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-blue-subtle, #669DF1)",
        svgBackgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
        svgBackgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
        svgBackgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF5DB)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-yellow-subtle, #EED12B)",
        svgBackgroundColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
        svgBackgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        svgBackgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-purple-subtle, #C97CF4)",
        svgBackgroundColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)",
        svgBackgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)"
    }
];

});
parcelRegister("f3HJP", function(module, exports) {
$parcel$export(module.exports, "editorExperiment", () => $af691053a80ff615$export$9b7cf3b74f250027);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $jQr4o = parcelRequire("jQr4o");

var $8qy01 = parcelRequire("8qy01");

var $jFnpM = parcelRequire("jFnpM");

var $9L6oc = parcelRequire("9L6oc");
function $af691053a80ff615$export$9b7cf3b74f250027(experimentName, expectedExperimentValue) {
    var _experimentConfig$pro;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        exposure: false
    };
    var experimentConfig = (0, $jFnpM.editorExperimentsConfig)[experimentName];
    if ((0, $9L6oc._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $9L6oc._overrides)[experimentName] === expectedExperimentValue;
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error("Editor experiment configuration is not defined ".concat(experimentName, ". Likely the experiment does not exist or editor package versions are misaligned"));
    if (!(0, $9L6oc._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var experimentKey = experimentConfig === null || experimentConfig === void 0 || (_experimentConfig$pro = experimentConfig.productKeys) === null || _experimentConfig$pro === void 0 ? void 0 : _experimentConfig$pro[0, $9L6oc._product];
    if (!experimentKey) {
        var _editorExperimentsCon;
        // This will be hit in the case of an experiment not being set up for the product
        return ((_editorExperimentsCon = (0, $jFnpM.editorExperimentsConfig)[experimentName]) === null || _editorExperimentsCon === void 0 ? void 0 : _editorExperimentsCon.defaultValue) === expectedExperimentValue;
    }
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $jQr4o.default).getExperimentValue(experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    if (// When cleaning this gate up -- `calling where the experiments have the product key set`
    // in __tests__/experiments should be updated (as it's had the count bumped to include these).
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $jQr4o.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) (0, $8qy01.addFeatureFlagAccessed)("".concat(experimentName, ":").concat(experimentConfig.param), experimentValue);
    return expectedExperimentValue === experimentValue;
}

});
parcelRegister("jQr4o", function(module, exports) {
$parcel$export(module.exports, "default", () => $e727df2602f0c6f0$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $c9wAm = parcelRequire("c9wAm");

var $2sCeC = parcelRequire("2sCeC");



var $e727df2602f0c6f0$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $e727df2602f0c6f0$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$e727df2602f0c6f0$var$_FeatureGates = $e727df2602f0c6f0$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "client", new (0, $c9wAm.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$e727df2602f0c6f0$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $e727df2602f0c6f0$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $e727df2602f0c6f0$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$e727df2602f0c6f0$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $e727df2602f0c6f0$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $e727df2602f0c6f0$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "initializeCalled", $e727df2602f0c6f0$var$_FeatureGates.client.initializeCalled.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "initializeCompleted", $e727df2602f0c6f0$var$_FeatureGates.client.initializeCompleted.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "waitUntilInitializeCompleted", $e727df2602f0c6f0$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "initialize", $e727df2602f0c6f0$var$_FeatureGates.client.initialize.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "initializeWithProvider", $e727df2602f0c6f0$var$_FeatureGates.client.initializeWithProvider.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "initializeFromValues", $e727df2602f0c6f0$var$_FeatureGates.client.initializeFromValues.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "manuallyLogGateExposure", $e727df2602f0c6f0$var$_FeatureGates.client.manuallyLogGateExposure.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "getExperiment", $e727df2602f0c6f0$var$_FeatureGates.client.getExperiment.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "manuallyLogExperimentExposure", $e727df2602f0c6f0$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "manuallyLogLayerExposure", $e727df2602f0c6f0$var$_FeatureGates.client.manuallyLogLayerExposure.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "shutdownStatsig", $e727df2602f0c6f0$var$_FeatureGates.client.shutdownStatsig.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "overrideGate", $e727df2602f0c6f0$var$_FeatureGates.client.overrideGate.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "clearGateOverride", $e727df2602f0c6f0$var$_FeatureGates.client.clearGateOverride.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "overrideConfig", $e727df2602f0c6f0$var$_FeatureGates.client.overrideConfig.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "clearConfigOverride", $e727df2602f0c6f0$var$_FeatureGates.client.clearConfigOverride.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "setOverrides", $e727df2602f0c6f0$var$_FeatureGates.client.setOverrides.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "getOverrides", $e727df2602f0c6f0$var$_FeatureGates.client.getOverrides.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "clearAllOverrides", $e727df2602f0c6f0$var$_FeatureGates.client.clearAllOverrides.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "isCurrentUser", $e727df2602f0c6f0$var$_FeatureGates.client.isCurrentUser.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "onGateUpdated", $e727df2602f0c6f0$var$_FeatureGates.client.onGateUpdated.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "onExperimentValueUpdated", $e727df2602f0c6f0$var$_FeatureGates.client.onExperimentValueUpdated.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "onAnyUpdated", $e727df2602f0c6f0$var$_FeatureGates.client.onAnyUpdated.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "updateUser", $e727df2602f0c6f0$var$_FeatureGates.client.updateUser.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "updateUserWithProvider", $e727df2602f0c6f0$var$_FeatureGates.client.updateUserWithProvider.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "updateUserWithValues", $e727df2602f0c6f0$var$_FeatureGates.client.updateUserWithValues.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "getPackageVersion", $e727df2602f0c6f0$var$_FeatureGates.client.getPackageVersion.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "getTargetApp", $e727df2602f0c6f0$var$_FeatureGates.client.getTargetApp.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "getLayer", $e727df2602f0c6f0$var$_FeatureGates.client.getLayer.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "getLayerValue", $e727df2602f0c6f0$var$_FeatureGates.client.getLayerValue.bind($e727df2602f0c6f0$var$_FeatureGates.client));
var $e727df2602f0c6f0$var$boundFGJS = $e727df2602f0c6f0$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $e727df2602f0c6f0$var$FeatureGates;
    else {
        var $e727df2602f0c6f0$var$_boundFGJS, $e727df2602f0c6f0$var$_boundFGJS$getPackage;
        $e727df2602f0c6f0$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $e727df2602f0c6f0$var$boundVersion = (($e727df2602f0c6f0$var$_boundFGJS = $e727df2602f0c6f0$var$boundFGJS) === null || $e727df2602f0c6f0$var$_boundFGJS === void 0 || ($e727df2602f0c6f0$var$_boundFGJS$getPackage = $e727df2602f0c6f0$var$_boundFGJS.getPackageVersion) === null || $e727df2602f0c6f0$var$_boundFGJS$getPackage === void 0 ? void 0 : $e727df2602f0c6f0$var$_boundFGJS$getPackage.call($e727df2602f0c6f0$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($e727df2602f0c6f0$var$boundVersion !== (0, $2sCeC.CLIENT_VERSION)) {
            var $e727df2602f0c6f0$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($e727df2602f0c6f0$var$boundVersion, " when module version ").concat((0, $2sCeC.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($e727df2602f0c6f0$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $e727df2602f0c6f0$export$2e2bcd8739ae039 = $e727df2602f0c6f0$var$boundFGJS;

});
parcelRegister("c9wAm", function(module, exports) {
$parcel$export(module.exports, "Client", () => $8d8f9a1aa50e8aef$export$1f2bb630327ac4b6);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");

var $bFONp = parcelRequire("bFONp");

var $7RzhR = parcelRequire("7RzhR");

var $176K2 = parcelRequire("176K2");

var $jSPjQ = parcelRequire("jSPjQ");

var $6KsNm = parcelRequire("6KsNm");

var $5lXNt = parcelRequire("5lXNt");

var $h9zr6 = parcelRequire("h9zr6");

var $b2E0X = parcelRequire("b2E0X");

var $eQpFj = parcelRequire("eQpFj");

var $jbC54 = parcelRequire("jbC54");

var $7JvSY = parcelRequire("7JvSY");

var $9iMh1 = parcelRequire("9iMh1");

var $k9ONe = parcelRequire("k9ONe");

var $2sCeC = parcelRequire("2sCeC");
var $8d8f9a1aa50e8aef$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $8d8f9a1aa50e8aef$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8d8f9a1aa50e8aef$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8d8f9a1aa50e8aef$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8d8f9a1aa50e8aef$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8d8f9a1aa50e8aef$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $8d8f9a1aa50e8aef$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $8d8f9a1aa50e8aef$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $jbC54.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscriptions", new (0, $bFONp.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "dataAdapter", new (0, $eQpFj.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $jbC54.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $h9zr6.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 1;
                                    break;
                                }
                                if (!(0, $7JvSY.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $h9zr6.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 1;
                                    break;
                                }
                                if (!(0, $7JvSY.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $2sCeC.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $8d8f9a1aa50e8aef$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $2sCeC.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $k9ONe.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $h9zr6.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 1;
                                    break;
                                }
                                if (!(0, $7JvSY.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 1:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $h9zr6.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $5lXNt.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 1;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 1:
                                _context5.next = 2;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 2:
                                _context5.next = 3;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 1:
                                if (!this.initCompleted) {
                                    _context7.next = 2;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 2:
                                _context7.next = 3;
                                return this.initPromise;
                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $7RzhR.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $7RzhR.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $jSPjQ.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $7JvSY.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $7JvSY.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $8d8f9a1aa50e8aef$var$_objectSpread({}, clientOptions);
                                if (!clientOptions.localMode) {
                                    _context8.next = 2;
                                    break;
                                }
                                _context8.next = 1;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 1:
                                return _context8.abrupt("return");
                            case 2:
                                _context8.prev = 2;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $5lXNt.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $5lXNt.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 6;
                                break;
                            case 4:
                                _context8.prev = 4;
                                _t = _context8["catch"](2);
                                if (_t instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t === null || _t === void 0 ? void 0 : _t.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t;
                            case 6:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            2,
                            4
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $8d8f9a1aa50e8aef$var$_objectSpread($8d8f9a1aa50e8aef$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 2;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 2:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 6;
                                break;
                            case 4:
                                _context9.prev = 4;
                                _t2 = _context9["catch"](1);
                                if (_t2 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t2 === null || _t2 === void 0 ? void 0 : _t2.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t2;
                            case 6:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            4
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, _args0 = arguments, _t3;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $b2E0X.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $8d8f9a1aa50e8aef$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $8d8f9a1aa50e8aef$var$_objectSpread($8d8f9a1aa50e8aef$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $8d8f9a1aa50e8aef$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $k9ONe.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(newClientOptions, $8d8f9a1aa50e8aef$var$_excluded);
                                frontendUser = (0, $9iMh1.toStatsigUser)(identifiers, customAttributes);
                                this.user = (0, $6KsNm.deepAssign)({}, initializeValues.user, frontendUser);
                                statsigOptions = $8d8f9a1aa50e8aef$var$_objectSpread($8d8f9a1aa50e8aef$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 1;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 2;
                                return this.statsigClient.initializeAsync();
                            case 2:
                                _context0.next = 5;
                                break;
                            case 3:
                                _context0.prev = 3;
                                _t3 = _context0["catch"](1);
                                if (_t3 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_t3 === null || _t3 === void 0 ? void 0 : _t3.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($8d8f9a1aa50e8aef$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 4;
                                return this.statsigClient.initializeAsync();
                            case 4:
                                this.initWithDefaults = true;
                                throw _t3;
                            case 5:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise, _t4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 1:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 2;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 2:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 3;
                                _context10.next = 4;
                                return this.initPromise;
                            case 4:
                                _context10.next = 6;
                                break;
                            case 5:
                                _context10.prev = 5;
                                _t4 = _context10["catch"](3);
                            case 6:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 1;
                                                    break;
                                                }
                                                _context1.next = 1;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 1:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 7:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            3,
                            5
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, frontendUser, _updateUserCompletion, _ref4, errMsg, success, errorMessage, _t5, _t6;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 2;
                                return initializeValuesPromise;
                            case 2:
                                initializeValues = _context11.sent;
                                frontendUser = (0, $9iMh1.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, $6KsNm.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
                                _context11.next = 4;
                                break;
                            case 3:
                                _context11.prev = 3;
                                _t5 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _t5 instanceof Error ? _t5.message : JSON.stringify(_t5);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _t5;
                            case 4:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 5;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 6;
                                    break;
                                }
                                _context11.next = 6;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 6:
                                _context11.next = 8;
                                break;
                            case 7:
                                _context11.prev = 7;
                                _t6 = _context11["catch"](5);
                                success = false;
                                errorMessage = String(_t6);
                            case 8:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 9;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 10;
                                break;
                            case 9:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 10:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            3
                        ],
                        [
                            5,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $2sCeC.CLIENT_VERSION;
            }
        },
        {
            key: "getTargetApp",
            value: function getTargetApp() {
                var _this$initOptions2;
                return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $176K2.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $176K2.Layer).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("bFONp", function(module, exports) {
$parcel$export(module.exports, "default", () => $87faed0a9889cee9$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $hLfKH = parcelRequire("hLfKH");
function $87faed0a9889cee9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $87faed0a9889cee9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $87faed0a9889cee9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $87faed0a9889cee9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $87faed0a9889cee9$export$a66cbd9b2289cd78 = '@all-features';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $87faed0a9889cee9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $87faed0a9889cee9$var$_objectSpread($87faed0a9889cee9$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $87faed0a9889cee9$var$_objectSpread($87faed0a9889cee9$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $87faed0a9889cee9$var$_objectSpread($87faed0a9889cee9$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $87faed0a9889cee9$var$_objectSpread($87faed0a9889cee9$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($87faed0a9889cee9$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($87faed0a9889cee9$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($87faed0a9889cee9$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $87faed0a9889cee9$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("7RzhR", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $5b98dae73ef9baa8$export$6dc24881a3d96325);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $5uq1X = parcelRequire("5uq1X");

var $1wife = parcelRequire("1wife");
var $5b98dae73ef9baa8$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $5uq1X.migrateEvaluationDetails)(experiment.details), (0, $1wife.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("5uq1X", function(module, exports) {
$parcel$export(module.exports, "migrateEvaluationDetails", () => $3ff3f236f3cebfcc$export$18ad168d3dbac899);

var $iYJcE = parcelRequire("iYJcE");

var $jSPjQ = parcelRequire("jSPjQ");
var $3ff3f236f3cebfcc$var$evaluationReasonMappings = Object.entries((0, $jSPjQ.EvaluationReason)).map(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $3ff3f236f3cebfcc$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $3ff3f236f3cebfcc$var$evaluationReasonMappings.find(function(_ref3) {
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 1), key = _ref4[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $jSPjQ.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};

});
parcelRegister("jSPjQ", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $e79ade5a931ae9b1$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $e79ade5a931ae9b1$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
}; // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});


parcelRegister("1wife", function(module, exports) {
$parcel$export(module.exports, "migrateSecondaryExposures", () => $11b6eea154a6f367$export$55fd683752d01e67);
var $11b6eea154a6f367$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});


parcelRegister("176K2", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $0cfbac9d4c75e170$export$936d0764594b6eb3);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $5uq1X = parcelRequire("5uq1X");

var $1wife = parcelRequire("1wife");
var $0cfbac9d4c75e170$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $5uq1X.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $1wife.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $1wife.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("6KsNm", function(module, exports) {
$parcel$export(module.exports, "deepAssign", () => $4e9d6015334c2fdb$export$1148cb79ceecd5fa);

var $ekGgq = parcelRequire("ekGgq");

var $iYJcE = parcelRequire("iYJcE");

var $fC8ib = parcelRequire("fC8ib");
function $4e9d6015334c2fdb$export$1148cb79ceecd5fa(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return $4e9d6015334c2fdb$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sources)));
    for(var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], src = _Object$entries$_i[1];
        var dst = target[key];
        var srcIsObj = src && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(src) === 'object' && !Array.isArray(src);
        var dstIsObj = dst && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(dst) === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $4e9d6015334c2fdb$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $4e9d6015334c2fdb$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sources)));
}

});

parcelRegister("5lXNt", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e5d4c5e594349f5$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $k9ONe = parcelRequire("k9ONe");

var $2sCeC = parcelRequire("2sCeC");

var $dMgtu = parcelRequire("dMgtu");
function $3e5d4c5e594349f5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3e5d4c5e594349f5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3e5d4c5e594349f5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3e5d4c5e594349f5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3e5d4c5e594349f5$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $3e5d4c5e594349f5$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $3e5d4c5e594349f5$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $3e5d4c5e594349f5$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $3e5d4c5e594349f5$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $3e5d4c5e594349f5$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $3e5d4c5e594349f5$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $3e5d4c5e594349f5$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $3e5d4c5e594349f5$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $3e5d4c5e594349f5$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $3e5d4c5e594349f5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(fetcherOptions) {
                    var targetApp, url, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 1;
                                _context.next = 2;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                                _context.prev = 3;
                                _t = _context["catch"](1);
                                if (!(_t instanceof Error)) {
                                    _context.next = 4;
                                    break;
                                }
                                throw _t;
                            case 4:
                                throw Error('Failed to retrieve client sdk key');
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 2;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                                _context2.prev = 3;
                                _t2 = _context2["catch"](1);
                                if (!(_t2 instanceof Error)) {
                                    _context2.next = 4;
                                    break;
                                }
                                throw _t2;
                            case 4:
                                throw Error('Failed to retrieve experiment values');
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 2;
                                    break;
                                }
                                _context3.next = 1;
                                return response.text();
                            case 1:
                                body = _context3.sent;
                                throw new (0, $dMgtu.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 2:
                                if (!(response.status === 204)) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new (0, $dMgtu.ResponseError)('Unexpected 204 response');
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return response.text();
                            case 1:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $3e5d4c5e594349f5$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $k9ONe.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $k9ONe.FeatureGateEnvironment).Production:
                        return $3e5d4c5e594349f5$export$18c93900db9358a4;
                    case (0, $k9ONe.FeatureGateEnvironment).Staging:
                        return $3e5d4c5e594349f5$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $k9ONe.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $k9ONe.FeatureGateEnvironment).Development:
                        return $3e5d4c5e594349f5$export$f058dbf75c3bc647;
                    case (0, $k9ONe.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $3e5d4c5e594349f5$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $3e5d4c5e594349f5$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $3e5d4c5e594349f5$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 1;
                                return fetch("".concat(baseUrl).concat(path), $3e5d4c5e594349f5$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $2sCeC.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 1:
                                response = _context5.sent;
                                _context5.next = 2;
                                return this.handleResponseError(response);
                            case 2:
                                _context5.next = 3;
                                return this.extractResponseBody(response);
                            case 3:
                                return _context5.abrupt("return", _context5.sent);
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $3e5d4c5e594349f5$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($3e5d4c5e594349f5$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($3e5d4c5e594349f5$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("k9ONe", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $eacc0c5b443d7e57$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $eacc0c5b443d7e57$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $eacc0c5b443d7e57$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
var $eacc0c5b443d7e57$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
var $eacc0c5b443d7e57$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});

parcelRegister("2sCeC", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $1cabdaec6fe908d5$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $1cabdaec6fe908d5$export$a59f8d67326bd1cb = "6.0.2";

});

parcelRegister("dMgtu", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $a07c8996147bee60$export$286baf652d0b1206);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $a07c8996147bee60$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $a07c8996147bee60$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $a07c8996147bee60$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a07c8996147bee60$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $a07c8996147bee60$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ResponseError);
        return $a07c8996147bee60$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});


parcelRegister("h9zr6", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $c7cec3ce9251ceee$export$d119b37e5f788b43);

var $25nEq = parcelRequire("25nEq");

var $ygbGG = parcelRequire("ygbGG");

var $k9ONe = parcelRequire("k9ONe");
function $c7cec3ce9251ceee$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c7cec3ce9251ceee$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c7cec3ce9251ceee$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c7cec3ce9251ceee$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c7cec3ce9251ceee$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $c7cec3ce9251ceee$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $ygbGG.isFedRamp)() ? (0, $k9ONe.PerimeterType).FEDRAMP_MODERATE : (0, $k9ONe.PerimeterType).COMMERCIAL
    }, options);
};

});

parcelRegister("b2E0X", function(module, exports) {
$parcel$export(module.exports, "migrateInitializationOptions", () => $809eeba5dfadeeed$export$202946b690d26d22);

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");
var $809eeba5dfadeeed$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $809eeba5dfadeeed$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $809eeba5dfadeeed$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $809eeba5dfadeeed$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $809eeba5dfadeeed$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $809eeba5dfadeeed$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(options, $809eeba5dfadeeed$var$_excluded);
    return $809eeba5dfadeeed$var$_objectSpread($809eeba5dfadeeed$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};

});

parcelRegister("eQpFj", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $ace9d49e9e3146af$export$55fffef3474104af);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");
function $ace9d49e9e3146af$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ace9d49e9e3146af$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ace9d49e9e3146af$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ace9d49e9e3146af$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ace9d49e9e3146af$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $ace9d49e9e3146af$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $ace9d49e9e3146af$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ace9d49e9e3146af$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $ace9d49e9e3146af$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $ace9d49e9e3146af$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoFetchDataAdapter);
        _this = $ace9d49e9e3146af$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $ace9d49e9e3146af$var$_objectSpread($ace9d49e9e3146af$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $ace9d49e9e3146af$var$_objectSpread($ace9d49e9e3146af$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $ace9d49e9e3146af$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $ace9d49e9e3146af$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));

});

parcelRegister("jbC54", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $df7c9578dd3b213e$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $df7c9578dd3b213e$export$bcb28fbac1def494);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $dtn6l = parcelRequire("dtn6l");
function $df7c9578dd3b213e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $df7c9578dd3b213e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $df7c9578dd3b213e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $df7c9578dd3b213e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $df7c9578dd3b213e$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $df7c9578dd3b213e$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $df7c9578dd3b213e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $df7c9578dd3b213e$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $df7c9578dd3b213e$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $df7c9578dd3b213e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $df7c9578dd3b213e$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $df7c9578dd3b213e$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $df7c9578dd3b213e$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $df7c9578dd3b213e$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $df7c9578dd3b213e$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $df7c9578dd3b213e$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PersistentOverrideAdapter);
        this._overrides = $df7c9578dd3b213e$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $df7c9578dd3b213e$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $df7c9578dd3b213e$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $df7c9578dd3b213e$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($df7c9578dd3b213e$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.removeItem($df7c9578dd3b213e$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $df7c9578dd3b213e$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $df7c9578dd3b213e$var$_objectSpread($df7c9578dd3b213e$var$_objectSpread({}, $df7c9578dd3b213e$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($df7c9578dd3b213e$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($df7c9578dd3b213e$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($df7c9578dd3b213e$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($df7c9578dd3b213e$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $df7c9578dd3b213e$var$_objectSpread($df7c9578dd3b213e$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $df7c9578dd3b213e$var$_objectSpread($df7c9578dd3b213e$var$_objectSpread({}, current.details), {}, {
                        reason: $df7c9578dd3b213e$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($df7c9578dd3b213e$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($df7c9578dd3b213e$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($df7c9578dd3b213e$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($df7c9578dd3b213e$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($df7c9578dd3b213e$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($df7c9578dd3b213e$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $df7c9578dd3b213e$var$makeEmptyStore();
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($df7c9578dd3b213e$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $df7c9578dd3b213e$var$_objectSpread($df7c9578dd3b213e$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $df7c9578dd3b213e$var$_objectSpread($df7c9578dd3b213e$var$_objectSpread({}, current.details), {}, {
                        reason: $df7c9578dd3b213e$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($df7c9578dd3b213e$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $df7c9578dd3b213e$var$_objectSpread($df7c9578dd3b213e$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $df7c9578dd3b213e$var$_objectSpread($df7c9578dd3b213e$var$_objectSpread({}, current.details), {}, {
                        reason: $df7c9578dd3b213e$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});

parcelRegister("7JvSY", function(module, exports) {
$parcel$export(module.exports, "shallowEquals", () => $5a157837fc11a06d$export$fa1c2bbf4100b8bc);

var $iYJcE = parcelRequire("iYJcE");
var $5a157837fc11a06d$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};

});

parcelRegister("9iMh1", function(module, exports) {
$parcel$export(module.exports, "toStatsigUser", () => $6c5b3d9edae47ebf$export$3dad1db244472f32);

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");
var $6c5b3d9edae47ebf$var$_excluded = [
    "stableId"
];
function $6c5b3d9edae47ebf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6c5b3d9edae47ebf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6c5b3d9edae47ebf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6c5b3d9edae47ebf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6c5b3d9edae47ebf$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    var stableId = identifiers.stableId, otherIdentifiers = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(identifiers, $6c5b3d9edae47ebf$var$_excluded);
    var user = {
        customIDs: $6c5b3d9edae47ebf$var$_objectSpread($6c5b3d9edae47ebf$var$_objectSpread({}, otherIdentifiers), stableId !== undefined ? {
            stableID: stableId
        } : {}),
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};

});



parcelRegister("jFnpM", function(module, exports) {
$parcel$export(module.exports, "editorExperimentsConfig", () => $e51402548fc880a3$export$6cbb856f286b07ef);
/* eslint-disable perfectionist/sort-object-types */ /* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $dxBNs = parcelRequire("dxBNs");

var $bgxSc = parcelRequire("bgxSc");
var $e51402548fc880a3$export$5c897d5297c5b7fd = [
    'platform_editor_blocks',
    'platform_editor_controls',
    'advanced_layouts',
    'single_column_layouts',
    'platform_editor_preview_panel_responsiveness',
    'platform_editor_toolbar_aifc'
];
var $e51402548fc880a3$export$6cbb856f286b07ef = {
    // new format to avoid collisions with other users when updating the file
    // Added 2026-07-18
    cc_maui_remix_button_hover_corridor: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_remix_button_hover_corridor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-24
    platform_editor_layout_column_delete_shortcut_fix: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_delete_shortcut_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-21
    // `isEnabled` is the gating param; the experiment's dynamic config also carries the numeric
    // `shimmerDurationMs` (skeleton) and `highlightDurationMs` (purple highlight) durations, read at
    // runtime via `expVal`.
    platform_editor_agent_be_streaming: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_agent_be_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Editor Platform experiments
    // lwoollard experiments
    // Added 2026-04-21
    cwr_page_tree_auto_finalize: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr_page_tree_auto_finalize'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 02-12-2025
    cc_fix_hydration_ttvc: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_hydration_ttvc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    'editor_a11y__enghealth-46814_fy26': (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y__enghealth-46814_fy26'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19
    'enghealth-53346_fix_redaction_marker_editor': (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            jira: 'enghealth-53346_fix_redaction_marker_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-16
    platform_editor_remove_important_in_render_ext: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_important_in_render_ext'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-06
    confluence_comment_nudgebar_improvement: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_comment_nudgebar_improvement'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_quick_insert_embeds: (0, $bgxSc.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_quick_insert_embeds'
        },
        param: 'cohort',
        values: [
            'control',
            'prioritizeLinkInQIM',
            'prioritizeEmbedInQIM'
        ],
        defaultValue: 'control'
    }),
    confluence_remix_icon_right_side: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_remix_icon_right_side'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_editor_insm_doc_size_stats: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_doc_size_stats'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-26
    cc_editor_fix_insm_inp_buffer: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_fix_insm_inp_buffer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    cwr_blank_object_experiment: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr_blank_object_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-08
    confluence_inline_comments_fix_stale_selection: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_inline_comments_fix_stale_selection'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    rovo_remix_experience_context: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'rovo_remix_experience_context'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-05
    'databases-native-embeds-v2': (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'databases-native-embeds-v2'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    cc_editor_insm_outlier_events: (0, $bgxSc.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_outlier_events'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-17
    platform_editor_renderer_extension_width_fix: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_extension_width_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-24
    platform_editor_media_external_badge_bbc_fix: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_external_badge_bbc_fix',
            bitbucket: 'platform_editor_media_external_badge_bbc_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-20
    platform_editor_annotations_sync_on_docchange: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_annotations_sync_on_docchange'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $bgxSc.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_per_plugin_error_boundary: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_per_plugin_error_boundary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-05
    'company_hub_carousel_thumbnails-refactor': (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'company_hub_carousel_thumbnails-refactor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $bgxSc.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_paste_actions_menu: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-19
    platform_editor_controls_reliable_anchor: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_reliable_anchor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $bgxSc.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls',
            jira: 'platform_editor_controls_jira'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-07-21
    confluence_cwr_3p_connection_suggested_prompts: (0, $bgxSc.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_cwr_3p_connection_suggested_prompts'
        },
        param: 'cohort',
        values: [
            'control',
            'variant_a',
            'variant_b'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-05-26
    platform_editor_agent_mentions: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_agent_mentions',
            jira: 'platform_editor_agent_mentions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    platform_editor_reduced_agent_profile_cards: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_reduced_agent_profile_cards',
            jira: 'platform_editor_reduced_agent_profile_cards'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-30
    platform_editor_fix_link_paste_menu: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_link_paste_menu',
            jira: 'platform_editor_fix_link_paste_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_code_block_q4_lovability: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_code_block_q4_lovability',
            jira: 'platform_editor_code_block_q4_lovability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-16
    platform_editor_enable_single_player_step_merging: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enable_single_player_step_merging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_hide_overflow_menu: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_hide_overflow_menu',
            jira: 'platform_editor_toolbar_hide_overflow_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_responsiveness'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $bgxSc.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-06-25
    jira_editor_a11y_toolbar_fixes: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'jira_editor_a11y_toolbar_fixes',
            jira: 'jira_editor_a11y_toolbar_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-09
    platform_editor_blocks: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocks_conf',
            jira: 'platform_editor_blocks_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-23
    //Added 2025-07-16
    platform_editor_toolbar_aifc: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_confluence'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_breakout_interaction_rerender: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_interaction_rerender'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_blocktaskitem_node_tenantid: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_node_tenantid'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_with_dnd: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_with_dnd'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    'editor-a11y-fy26-keyboard-move-row-column': (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor-a11y-fy26-keyboard-move-row-column',
            jira: 'editor-a11y-fy26-keyboard-move-row-column'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-28
    editor_enable_image_alignment_in_expand: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enable_image_alignment_in_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_august_a11y: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_august_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-01
    cc_editor_ai_content_mode: (0, $bgxSc.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_ai_content_mode'
        },
        param: 'variant',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-01-09
    platform_editor_render_bodied_extension_as_inline: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_render_bodied_extension_as_inline'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-03
    platform_editor_ai_quick_prompt_iw_cc: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quick_prompt_iw_cc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_use_llm_space_recommendations: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_llm_space_recommendations'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-01
    // Added 2025-10-13
    platform_editor_media_error_analytics: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_error_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-27
    platform_editor_table_sticky_header_improvements: (0, $bgxSc.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_improvements'
        },
        param: 'cohort',
        values: [
            'control',
            'test_with_overflow',
            'test_without_overflow'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-29
    platform_editor_lovability_inline_code: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_inline_code'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_lovability_emoji_scaling: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_emoji_scaling'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-18
    editor_a11y_7152_profile_card_tab_order: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y_7152_profile_card_tab_order'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-19
    platform_editor_lovability_navigation_fixes: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_navigation_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-27 — Pre-auth unauthorised inline hover card UX
    platform_sl_3p_preauth_better_hovercard: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_preauth_better_hovercard',
            jira: 'platform_sl_3p_preauth_better_hovercard'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-21 — Post-auth GDrive Smart Link to Rovo Chat auto-open
    platform_sl_3p_post_auth_chat_open_exp: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_post_auth_chat_open_exp',
            jira: 'platform_sl_3p_post_auth_chat_open_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-29 — Social proof inline CTA for unauthorised 3P inline smart links
    platform_sl_3p_preauth_social_proof_inline_cta: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_preauth_social_proof_inline_cta',
            jira: 'platform_sl_3p_preauth_social_proof_inline_cta'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15 — Embed card footer rovo action for resolved 3P smart links in confluence
    platform_sl_3p_auth_rovo_embed_footer_exp: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_auth_rovo_embed_footer_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_submenu_open_click: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_submenu_open_click'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-13
    platform_editor_hide_extension_renderer_support: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hide_extension_renderer_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-23
    platform_editor_fix_new_line_after_heading: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_new_line_after_heading',
            jira: 'platform_editor_fix_new_line_after_heading'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-21
    platform_editor_copy_link_a11y_inconsistency_fix: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_copy_link_a11y_inconsistency_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_editor_fix_lagging_embed_resize_handle: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_lagging_embed_resize_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-30
    platform_editor_fix_cross_origin_editor_focus: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_cross_origin_editor_focus'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_ttvc_inline_extensions: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_ttvc_inline_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-03
    platform_editor_enghealth_a11y_jan_fixes: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enghealth_a11y_jan_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    cc_fd_db_top_editor_toolbar: (0, $bgxSc.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_fd_db_top_editor_toolbar'
        },
        param: 'cohort',
        values: [
            'control',
            'new-description',
            'orig-description'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-04-01
    cc_page_experiences_editor_image_generation: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_page_experiences_editor_image_generation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-23
    'cc-maui-experiment': (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-maui-experiment',
            jira: 'jira_maui_remix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_maui_create_keyword: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_create_keyword'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // A/A experiment paired with cc_maui_create_keyword, used only to balance exposures.
    cc_maui_create_keyword_aa: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_create_keyword_aa'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-13
    confluence_native_tabs_experiment: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_native_tabs_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-29
    cc_maui_polish_changes_batch_4: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_polish_changes_batch_4'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    'cc-mui-slides-experiment': (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-mui-slides-experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-27
    confluence_frontend_cwr_outcome_type_picker: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_frontend_cwr_outcome_type_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    cfe_cwr_outcome_picker_respect_site_settings: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'cfe_cwr_outcome_picker_respect_site_settings'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-12
    prompt_tile_content_type_localizaiton: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'prompt_tile_content_type_localizaiton'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-24
    'cwr-modal-ui-refresh': (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-modal-ui-refresh'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-08
    'cc-disambiguation-in-cwr': (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-disambiguation-in-cwr'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    'cwr-reduce-prompt-suggestion-max-chars': (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-reduce-prompt-suggestion-max-chars'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15
    'cwr-staging-area-close-as-minimize-button': (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-staging-area-close-as-minimize-button'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-08
    cc_cwr_prompt_strength_indicator: (0, $bgxSc.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_cwr_prompt_strength_indicator'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1',
            'variant2'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-02-12
    platform_editor_a11y_escape_link_dialog: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_a11y_escape_link_dialog',
            jira: 'platform_editor_a11y_escape_link_dialog'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_vc90_transition_panel_icon: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vc90_transition_panel_icon'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_emoji_default_scale: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_default_scale',
            jira: 'platform_editor_emoji_default_scale'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-17
    platform_editor_emoji_hover_show_tooltip: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_hover_show_tooltip',
            jira: 'platform_editor_emoji_hover_show_tooltip'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    platform_teamoji_26_refresh_emoji_picker: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_teamoji_26_refresh_emoji_picker',
            jira: 'platform_teamoji_26_refresh_emoji_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-16
    platform_use_unicode_emojis: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_unicode_emojis_confluence',
            jira: 'platform_use_unicode_emojis_jira',
            bitbucket: 'platform_use_unicode_emojis_bitbucket'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-26
    platform_editor_toolbar_update_jira_config: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_toolbar_update_jira_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_ai_blockmenu_integration: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_blockmenu_integration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-26
    platform_editor_remix_in_block_menu: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remix_in_block_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19 — fix table text length calculation for Remix/Improve Writing hero prompts
    remix_iw_block_menu_table_calc_fix: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'remix_iw_block_menu_table_calc_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_rovobutton_smartlink_toolbar_exp: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_rovobutton_smartlink_toolbar_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    confluence_fe_renderer_inline_node_mark_color_fix: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_renderer_inline_node_mark_color_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_diff_plugin_extended: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_diff_plugin_extended'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_fix_media_toolbar_border_dropdown: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_media_toolbar_border_dropdown'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-06
    platform_editor_single_player_expand: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_player_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_fit_to_content_on_demand: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_fit_to_content_on_demand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-09
    platform_editor_remove_collab_step_metrics: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_collab_step_metrics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    platform_editor_ai_normalized_telemetry: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_normalized_telemetry'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-15
    platform_editor_sync_block_ssr_config: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_sync_block_ssr_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-06
    confluence_fe_create_page_suggestion: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_create_page_suggestion'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-18
    platform_editor_selection_toolbar_block_handle: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_selection_toolbar_block_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    platform_editor_improve_preset_builder_logging: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_improve_preset_builder_logging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-23
    'cc-markdown-mode': (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-markdown-mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_ai_xstate_migration: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_xstate_migration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-31
    platform_editor_dnd_accessibility_fixes_expand: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_dnd_accessibility_fixes_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-15
    platform_editor_ai_no_stream_skip_pacer: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_no_stream_skip_pacer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-07
    platform_editor_layout_column_menu: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-29
    platform_editor_layout_column_selection_fix: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_selection_fix',
            jira: 'platform_editor_layout_column_selection_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15
    platform_editor_layout_column_valign_rendering: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_valign_rendering'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    platform_editor_external_embed_grid_fix: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_external_embed_grid_fix',
            jira: 'platform_editor_external_embed_grid_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-08
    cc_fd_wb_jira_quick_insert_experiment: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            jira: 'cc_fd_wb_jira_quick_insert_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-30
    cc_fix_editor_context_on_cwr_followups: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_editor_context_on_cwr_followups'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    cc_fix_ephemeral_preview_staging_area_registration: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_ephemeral_preview_staging_area_registration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    platform_editor_hydration_skip_react_portal: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hydration_skip_react_portal'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-28
    platform_editor_use_markdown_plus_parser: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_markdown_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_use_html_plus_parser: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_html_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    platform_editor_core_static_css: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_static_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_core_non_ecc_static_css: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_non_ecc_static_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_q4_loveability: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_q4_loveability',
            jira: 'platform_editor_table_q4_loveability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    platform_editor_table_menu_updates: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_menu_updates',
            jira: 'platform_editor_table_menu_updates'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-06
    confluence_live_doc_table_sort_bugfix: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_live_doc_table_sort_bugfix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    confluence_fe_disable_comment_if_offline_fix: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_disable_comment_if_offline_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    platform_editor_sync_block_activation: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_sync_block_activation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_paste_actions_menu_v2: (0, $bgxSc.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu_v2',
            jira: 'platform_editor_paste_actions_menu_v2'
        },
        param: 'variant',
        values: [
            'control',
            'hasSpellingAndGrammar',
            'hasAltAiActions'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-05-01 — Social proof experiment for unauthorized 3P block cards
    social_proof_3p_unauth_block_exp: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'social_proof_3p_unauth_block_exp',
            jira: 'social_proof_3p_unauth_block_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_replace_doc/setup
    platform_editor_ai_replace_doc: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_replace_doc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-18
    platform_editor_nest_table_in_panel: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nest_table_in_panel'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_rovo_support_create_inline_comment: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_rovo_support_create_inline_comment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_fix_sticky_header_malfunction: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_sticky_header_malfunction'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-17
    platform_editor_fix_sticky_header_row: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_sticky_header_row'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-10
    confluence_editor_paste_3p_link_actions_menu: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_paste_3p_link_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-29
    'a11y-fixes-week3-may-2026': (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'a11y-fixes-week3-may-2026',
            jira: 'a11y-fixes-week3-may-2026'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_reactions_selector_list: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_reactions_selector_list',
            jira: 'platform_a11y_fixes_reactions_selector_list'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_emoji_picker_list: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_emoji_picker_list',
            jira: 'platform_a11y_fixes_emoji_picker_list'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_emoji_title_shortname: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_emoji_title_shortname',
            jira: 'platform_a11y_fixes_emoji_title_shortname'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-25
    // HTML+ v2 incremental tool-call streaming contract — gates the new
    // PartialStreamParserV2 / ToolCallProcessorV2 / AdfChunkStrategyV2 stack
    // in `@atlassian/editor-rovo-bridge`, the `replaceValue` orchestrator
    // action, and the `toolCallsStreaming.supportsProvisionalToolCalls`
    // capability advert on `PageContentCommandResult`.
    platform_editor_use_html_plus_streaming_parser: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_html_plus_streaming_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_wide_slash_trigger: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_wide_slash_trigger'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11 — [CCI-15904] New AIFC Editor Experience (Full Page Staging Area + Post Stream Review Toolbar)
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_new_aifc_editor_experience/setup
    platform_editor_ai_new_aifc_editor_experience: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_new_aifc_editor_experience'
        },
        param: 'isBackendReviewMomentEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    // Gates the `GhostIconWave` animation primitive in
    // `@atlassian/rovo-platform-ui-components` — rendered as a loading cue on
    // Confluence's 3p-in-CWR (Rovo) surfaces. When off the primitive renders
    // nothing.
    confluence_3p_in_cwr_ghost_icons: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_3p_in_cwr_ghost_icons'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    platform_editor_lovability_text_bg_color: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_text_bg_color',
            jira: 'platform_editor_lovability_text_bg_color'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-20
    platform_editor_ssr_toolbar_optimistic: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ssr_toolbar_optimistic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19
    platform_editor_lovability_resize_dividers_panels: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_resize_dividers_panels'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_editor_add_breakout_marks_on_page_load: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_breakout_marks_on_page_load'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-23
    'aifc-confluence-editor-csp-fix': (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'aifc-confluence-editor-csp-fix',
            jira: 'aifc-confluence-editor-csp-fix'
        },
        param: 'value',
        defaultValue: false
    }),
    // Added 2026-07-01
    platform_editor_remove_pause_streaming: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_pause_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-17
    revert_remix_ephemeral_iframe_sizing_fix: (0, $dxBNs.createBooleanExperiment)({
        productKeys: {
            confluence: 'revert_remix_ephemeral_iframe_sizing_fix',
            jira: 'revert_remix_ephemeral_iframe_sizing_fix'
        },
        param: 'value',
        defaultValue: false
    }),
    // Added 2026-07-28
    cwr_publish_flow_live_doc_toggle_exp: (0, $bgxSc.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cwr_publish_flow_live_doc_toggle_exp'
        },
        param: 'cohort',
        defaultValue: 'control',
        values: [
            'control',
            'variantA',
            'variantB',
            'variantC'
        ]
    })
};

});
parcelRegister("dxBNs", function(module, exports) {
$parcel$export(module.exports, "createBooleanExperiment", () => $9dbbad14421a300b$export$456f1587c9c92021);

var $25nEq = parcelRequire("25nEq");

var $jfBiK = parcelRequire("jfBiK");
function $9dbbad14421a300b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9dbbad14421a300b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9dbbad14421a300b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9dbbad14421a300b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9dbbad14421a300b$export$456f1587c9c92021(config) {
    return $9dbbad14421a300b$var$_objectSpread($9dbbad14421a300b$var$_objectSpread({}, config), {}, {
        typeGuard: (0, $jfBiK.isBoolean),
        defaultValue: config.defaultValue
    });
}

});
parcelRegister("jfBiK", function(module, exports) {
$parcel$export(module.exports, "isBoolean", () => $e03c5a5298a91a11$export$f9ce7b637dfbe238);
function $e03c5a5298a91a11$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}

});


parcelRegister("bgxSc", function(module, exports) {
$parcel$export(module.exports, "createMultivariateExperiment", () => $833b76d747dd73a3$export$fb89e8a786694d1);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $1O9FS = parcelRequire("1O9FS");
function $833b76d747dd73a3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $833b76d747dd73a3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $833b76d747dd73a3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $833b76d747dd73a3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $833b76d747dd73a3$export$fb89e8a786694d1(config) {
    var values = config.values;
    return $833b76d747dd73a3$var$_objectSpread($833b76d747dd73a3$var$_objectSpread({}, config), {}, {
        values: (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(values),
        // Maintains the tuple
        typeGuard: (0, $1O9FS.oneOf)(config.values),
        defaultValue: config.defaultValue
    });
}

});
parcelRegister("1O9FS", function(module, exports) {
$parcel$export(module.exports, "oneOf", () => $1511f715c6760b76$export$a9a18ae5ba42aeab);

var $3ZMUU = parcelRequire("3ZMUU");
var $1511f715c6760b76$var$_process, $1511f715c6760b76$var$_process2;
var $1511f715c6760b76$var$IS_TESTING_ENV = typeof $3ZMUU !== 'undefined' && ((($1511f715c6760b76$var$_process = $3ZMUU) === null || $1511f715c6760b76$var$_process === void 0 || ($1511f715c6760b76$var$_process = $1511f715c6760b76$var$_process.env) === null || $1511f715c6760b76$var$_process === void 0 ? void 0 : $1511f715c6760b76$var$_process.NODE_ENV) === 'test' || (($1511f715c6760b76$var$_process2 = $3ZMUU) === null || $1511f715c6760b76$var$_process2 === void 0 || ($1511f715c6760b76$var$_process2 = $1511f715c6760b76$var$_process2.env) === null || $1511f715c6760b76$var$_process2 === void 0 ? void 0 : $1511f715c6760b76$var$_process2.JEST_WORKER_ID) !== undefined);
function $1511f715c6760b76$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
   * This is used by test utils to get the variants when running describe.each
   */ if ($1511f715c6760b76$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}

});



parcelRegister("9L6oc", function(module, exports) {
$parcel$export(module.exports, "_overrides", () => $71ad75a3bf7acb5a$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_product", () => $71ad75a3bf7acb5a$export$cf7305fc65acbf0d);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $1Zmoq = parcelRequire("1Zmoq");

var $jFnpM = parcelRequire("jFnpM");
function $71ad75a3bf7acb5a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $71ad75a3bf7acb5a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $71ad75a3bf7acb5a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $71ad75a3bf7acb5a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $71ad75a3bf7acb5a$export$e5d73bf4f8e2ae96 = {};
var $71ad75a3bf7acb5a$export$4e849416bb5c5b52 = {};
var $71ad75a3bf7acb5a$export$cf7305fc65acbf0d;
function $71ad75a3bf7acb5a$export$1c2b6dbf79eb3560(product, /**
 * Overrides are used to set the group of an experiment for testing purposes.
 * This is useful when you want to test a specific experiment group.
 */ groupOverrides, /**
 * Param overrides are used to set the experiment parameters for testing purposes.
 * This is useful when you want to tweak the experiment parameters for testing.
 */ paramOverrides, options) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        groupOverrides = Object.entries(groupOverrides).reduce(function(acc, _ref) {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
            var config = (0, $jFnpM.editorExperimentsConfig)[key];
            if (config) acc = $71ad75a3bf7acb5a$var$_objectSpread($71ad75a3bf7acb5a$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, config.typeGuard(value) ? value : config.defaultValue));
            return acc;
        }, {});
        $71ad75a3bf7acb5a$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test' && !(options !== null && options !== void 0 && options.disableTestOverrides)) {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        var testOverrides = Object.fromEntries(Object.entries((0, $jFnpM.editorExperimentsConfig)).map(function(_ref3) {
            var _ref5, _ref6, _groupOverrides, _groupOverrides2;
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), key = _ref4[0], value = _ref4[1];
            var defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                (_ref5 = (_ref6 = (_groupOverrides = (_groupOverrides2 = groupOverrides) === null || _groupOverrides2 === void 0 ? void 0 : _groupOverrides2[key]) !== null && _groupOverrides !== void 0 ? _groupOverrides : (0, $1Zmoq.testMultivariateOverrides)[key]) !== null && _ref6 !== void 0 ? _ref6 : (0, $1Zmoq.testBooleanOverrides)[key]) !== null && _ref5 !== void 0 ? _ref5 : defaultValue
            ];
        }));
        $71ad75a3bf7acb5a$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $71ad75a3bf7acb5a$export$cf7305fc65acbf0d = product;
    $71ad75a3bf7acb5a$export$4e849416bb5c5b52 = paramOverrides || {};
}

});
parcelRegister("1Zmoq", function(module, exports) {
$parcel$export(module.exports, "testMultivariateOverrides", () => $172cdbb2e5a37249$export$7e849a84a00ffd1c);
$parcel$export(module.exports, "testBooleanOverrides", () => $172cdbb2e5a37249$export$54960937bb713f97);
var $172cdbb2e5a37249$export$7e849a84a00ffd1c = {
    cwr_publish_flow_live_doc_toggle_exp: 'control',
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_controls: 'control',
    cc_editor_ai_content_mode: 'control',
    platform_hover_card_preview_panel: 'control',
    cc_editor_insm_outlier_events: 'test',
    platform_editor_table_sticky_header_improvements: 'test_with_overflow',
    cc_fd_db_top_editor_toolbar: 'control',
    platform_editor_paste_actions_menu_v2: 'control',
    confluence_quick_insert_embeds: 'control',
    cc_cwr_prompt_strength_indicator: 'control',
    confluence_cwr_3p_connection_suggested_prompts: 'control'
};
var $172cdbb2e5a37249$export$54960937bb713f97 = {
    cc_maui_polish_changes_batch_4: false,
    social_proof_3p_unauth_block_exp: false,
    platform_sl_3p_preauth_better_hovercard: true,
    cwr_blank_object_experiment: false,
    platform_editor_preview_panel_responsiveness: false,
    'enghealth-53346_fix_redaction_marker_editor': false,
    platform_editor_toolbar_aifc: false,
    'test-new-experiments-package': false,
    platform_renderer_table_sticky_scrollbar: false,
    advanced_layouts: false,
    single_column_layouts: false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_editor_tables_table_selector: false,
    platform_renderer_fix_analytics_memo_callback: false,
    'jira-work-sync-desc-comment-summary': false,
    platform_editor_breakout_resizing: false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_enable_single_player_step_merging: false,
    platform_editor_paste_actions_menu: false,
    platform_editor_table_fit_to_content_on_demand: false,
    platform_editor_table_q4_loveability: false,
    platform_editor_table_menu_updates: false,
    'cwr-modal-ui-refresh': false,
    'cc-disambiguation-in-cwr': false,
    'cwr-reduce-prompt-suggestion-max-chars': false,
    'cwr-staging-area-close-as-minimize-button': false,
    prompt_tile_content_type_localizaiton: false,
    // [CCI-15904] New AIFC Editor Experience — read by the inline chat prompt view
    // in `conversation-assistant-chat-prompt-input`. Review moment eligibility is a
    // separate check (`editor-plugin-ai/src/ui/utils/review-moment-enabled.ts`) and
    // does not read this key.
    platform_editor_ai_new_aifc_editor_experience: false,
    cc_page_experiences_editor_image_generation: false,
    platform_use_unicode_emojis: false,
    platform_editor_emoji_hover_show_tooltip: false,
    'aifc-confluence-editor-csp-fix': false
};

});




parcelRegister("01HkO", function(module, exports) {
$parcel$export(module.exports, "getBreakpoint", () => $0051b57d3788950d$export$1eb095b00b926404);
$parcel$export(module.exports, "WidthContext", () => $0051b57d3788950d$export$27e39f636459b9f);
$parcel$export(module.exports, "WidthConsumer", () => $0051b57d3788950d$export$5d8538aa831b6ebb);
$parcel$export(module.exports, "WidthProvider", () => $0051b57d3788950d$export$7921e18173e8c666);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $cvlyC = parcelRequire("cvlyC");

var $45Zis = parcelRequire("45Zis");

var $bxWTK = parcelRequire("bxWTK");

var $5IgjU = parcelRequire("5IgjU");
var $0051b57d3788950d$var$styles = (0, $74Zh5.css)({
    position: 'relative',
    width: '100%'
});
var $0051b57d3788950d$var$SCROLLBAR_WIDTH = 30;
function $0051b57d3788950d$export$1eb095b00b926404() {
    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var MAX_S = 1266;
    var MAX_M = 2146;
    if (width >= MAX_S && width < MAX_M) return 'M';
    else if (width >= MAX_M) return 'L';
    return 'S';
}
function $0051b57d3788950d$export$31a4966bffb9ac98() {
    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return {
        width: width,
        breakpoint: $0051b57d3788950d$export$1eb095b00b926404(width)
    };
}
var $0051b57d3788950d$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext($0051b57d3788950d$export$31a4966bffb9ac98());
var $0051b57d3788950d$var$Provider = $0051b57d3788950d$export$27e39f636459b9f.Provider;
var $0051b57d3788950d$export$5d8538aa831b6ebb = $0051b57d3788950d$export$27e39f636459b9f.Consumer;
var $0051b57d3788950d$export$df154c49e93b2ac2 = (0, $cvlyC.default)(function() {
    var _document$body$offset, _document$body;
    return (0, $5IgjU.isSSR)() ? 0 : (_document$body$offset = (_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.offsetWidth) !== null && _document$body$offset !== void 0 ? _document$body$offset : 0;
});
var $0051b57d3788950d$export$7921e18173e8c666 = function WidthProvider(_ref) {
    var className = _ref.className, shouldCheckExistingValue = _ref.shouldCheckExistingValue, children = _ref.children;
    var existingContextValue = (0, $5FkrB.useContext)($0051b57d3788950d$export$27e39f636459b9f);
    var _useState = (0, $5FkrB.useState)($0051b57d3788950d$export$df154c49e93b2ac2), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), width = _useState2[0], setWidth = _useState2[1];
    var widthRef = (0, $5FkrB.useRef)(width);
    var isMountedRef = (0, $5FkrB.useRef)(true);
    var providerValue = (0, $5FkrB.useMemo)(function() {
        return $0051b57d3788950d$export$31a4966bffb9ac98(width);
    }, [
        width
    ]);
    var updateWidth = (0, $5FkrB.useMemo)(function() {
        return (0, $45Zis.default)(function(nextWidth) {
            var currentWidth = widthRef.current || 0;
            // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
            if (Math.abs(currentWidth - nextWidth) < $0051b57d3788950d$var$SCROLLBAR_WIDTH) return;
            // Avoid React memory leak by checking if the component is still mounted
            if (!isMountedRef.current) return;
            widthRef.current = nextWidth;
            setWidth(nextWidth);
        });
    }, []);
    var skipWidthDetection = shouldCheckExistingValue && existingContextValue.width > 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useLayoutEffect(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    return (0, $74Zh5.jsx)("div", {
        css: $0051b57d3788950d$var$styles,
        className: className
    }, !skipWidthDetection && (0, $74Zh5.jsx)((0, $5FkrB.Fragment), null, (0, $74Zh5.jsx)((0, $bxWTK.WidthObserver), {
        setWidth: updateWidth,
        offscreen: true
    }), (0, $74Zh5.jsx)($0051b57d3788950d$var$Provider, {
        value: providerValue
    }, children)), skipWidthDetection && children);
};

});
parcelRegister("5IgjU", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $428db8a4abdbe986$export$48d7c418edadb60c);

var $3ZMUU = parcelRequire("3ZMUU");
function $428db8a4abdbe986$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $3ZMUU !== 'undefined' && undefined);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});


parcelRegister("5dFQJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ccea110c6ec6c23$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $ach6K = parcelRequire("ach6K");

var $1LBcl = parcelRequire("1LBcl");

var $f8aZY = parcelRequire("f8aZY");

var $4mzlU = parcelRequire("4mzlU");

var $jJH6F = parcelRequire("jJH6F");

var $c0oX9 = parcelRequire("c0oX9");

var $fpooh = parcelRequire("fpooh");

var $iY18h = parcelRequire("iY18h");
var $3ccea110c6ec6c23$var$blockNodeStyle = (0, $74Zh5.css)({
    background: "var(--ds-background-disabled, #0515240F)",
    border: "var(--ds-border-width, 1px)".concat(" dashed ", "var(--ds-border-disabled, #0515240F)"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $1LBcl.relativeFontSizeToBase16)(14),
    margin: "var(--ds-space-100, 8px)".concat(" 0"),
    minHeight: '24px',
    padding: "var(--ds-space-150, 12px)",
    textAlign: 'center',
    verticalAlign: 'text-bottom',
    minWidth: '120px',
    alignItems: 'center',
    justifyContent: 'center'
});
var $3ccea110c6ec6c23$var$UnsupportedBlockNode = function UnsupportedBlockNode(_ref) {
    var node = _ref.node, intl = _ref.intl, dispatchAnalyticsEvent = _ref.dispatchAnalyticsEvent;
    var message = (0, $iY18h.getUnsupportedContent)((0, $c0oX9.unsupportedContentMessages).unsupportedBlockContent, (0, $c0oX9.unsupportedContentMessages).unsupportedBlockContent.defaultMessage + ':', node, intl);
    var tooltipContent = intl.formatMessage((0, $c0oX9.unsupportedContentMessages).unsupportedContentTooltip);
    var _useRef = (0, $5FkrB.useRef)({
        padding: '4px'
    }), style = _useRef.current;
    var originalNodeType = node === null || node === void 0 ? void 0 : node.attrs.originalValue.type;
    var tooltipOnShowHandler = (0, $5FkrB.useCallback)(function() {
        return dispatchAnalyticsEvent && (0, $fpooh.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $jJH6F.ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, originalNodeType);
    }, [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    (0, $74Zh5.jsx)("div", {
        css: $3ccea110c6ec6c23$var$blockNodeStyle,
        className: "unsupported"
    }, message, (0, $74Zh5.jsx)((0, $4mzlU.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, (0, $74Zh5.jsx)("span", {
        style: style
    }, (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f8aZY))), {
        label: "?"
    })))));
};
// eslint-disable-next-line @typescript-eslint/no-restricted-types
var $3ccea110c6ec6c23$var$_default_1 = (0, $ach6K.default)($3ccea110c6ec6c23$var$UnsupportedBlockNode);
var $3ccea110c6ec6c23$export$2e2bcd8739ae039 = $3ccea110c6ec6c23$var$_default_1;

});
parcelRegister("f8aZY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79927e3c1c348660896b3e18285ccee2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0402271ff9700a6$var$_react = $b0402271ff9700a6$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $b0402271ff9700a6$var$_iconNew = $b0402271ff9700a6$var$_interopRequireDefault((parcelRequire("hdyrD")));
function $b0402271ff9700a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/question-circle
 * Usage guidance:
 * Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0402271ff9700a6$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $b0402271ff9700a6$var$_react.default.createElement($b0402271ff9700a6$var$_iconNew.default, Object.assign({
        name: "QuestionCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$b0402271ff9700a6$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $b0402271ff9700a6$var$_default = module.exports.default = $b0402271ff9700a6$var$QuestionCircleIcon;

});
parcelRegister("hdyrD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Icon", () => $c88e5e9792f7a307$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $c88e5e9792f7a307$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $c88e5e9792f7a307$var$svgStyles = null;
var $c88e5e9792f7a307$var$iconStyles = null;
var $c88e5e9792f7a307$var$smallIconStyles = null;
var $c88e5e9792f7a307$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $c88e5e9792f7a307$var$baseHcmStyles = null;
var $c88e5e9792f7a307$var$scaleSize = null;
var $c88e5e9792f7a307$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c88e5e9792f7a307$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c88e5e9792f7a307$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $c88e5e9792f7a307$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $c88e5e9792f7a307$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $970q7.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $970q7.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $c88e5e9792f7a307$var$coreSizeSmall[spacing] : $c88e5e9792f7a307$var$coreSizeMedium[spacing]
        ])
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$c88e5e9792f7a307$export$2e2bcd8739ae039 = $c88e5e9792f7a307$export$f04a61298a47a40f;

});


parcelRegister("c0oX9", function(module, exports) {
$parcel$export(module.exports, "unsupportedContentMessages", () => $8bd8d7454cc3534c$export$32ec96484dd3ba39);

var $6bnW7 = parcelRequire("6bnW7");
var $8bd8d7454cc3534c$export$32ec96484dd3ba39 = (0, $6bnW7.defineMessages)({
    unsupportedInlineContent: {
        id: 'fabric.editor.unsupportedInlineContent',
        defaultMessage: 'Unsupported content',
        description: 'The text is shown as an inline label in the editor when a content node type is not supported for display. It appears alongside a question mark icon that provides more details via a tooltip.'
    },
    unsupportedBlockContent: {
        id: 'fabric.editor.unsupportedBlockContent',
        defaultMessage: 'This editor does not support displaying this content',
        description: 'The text is shown as a block-level message in the editor when a content block type is not supported for display. It appears centered within a dashed border container alongside a question mark icon that provides more details via a tooltip.'
    },
    unsupportedContentTooltip: {
        id: 'fabric.editor.unsupportedContentTooltip',
        defaultMessage: 'Content is not available in this editor, this will be preserved when you edit and save',
        description: 'The text is shown as tooltip content when the user hovers over the question mark icon on an unsupported content node in the editor. It reassures users that unsupported content will not be lost when they edit and save the document.'
    }
});

});

parcelRegister("fpooh", function(module, exports) {
$parcel$export(module.exports, "findAndTrackUnsupportedContentNodes", () => $b37c1c4264661b4e$export$d343369b8f25914);
$parcel$export(module.exports, "fireUnsupportedEvent", () => $b37c1c4264661b4e$export$e1051b410945e4d4);
$parcel$export(module.exports, "trackUnsupportedContentTooltipDisplayedFor", () => $b37c1c4264661b4e$export$3a34598135e7219b);

var $25nEq = parcelRequire("25nEq");

var $jJH6F = parcelRequire("jJH6F");
function $b37c1c4264661b4e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b37c1c4264661b4e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b37c1c4264661b4e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b37c1c4264661b4e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b37c1c4264661b4e$var$whitelistedAttributes = [
    'align',
    'annotationType',
    'extensionKey',
    'extensionType',
    'layout',
    'type',
    'localId',
    'mode',
    'language',
    'timestamp',
    'state',
    'originalWidth',
    'originalHeight',
    'height',
    'width',
    'shortName',
    'level',
    'userType',
    'order',
    'panelType',
    'color',
    'style',
    'isNumberColumnEnabled',
    'colspan',
    'rowspan',
    'colwidth',
    'background'
];
function $b37c1c4264661b4e$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
    var name = node.type.name;
    // Space concatenator used to reduce analytics payload size
    return ancestoryHierarchy ? "".concat(ancestoryHierarchy, " ").concat(name) : name;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $b37c1c4264661b4e$var$sanitizeMarks = function sanitizeMarks() {
    var marks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sanitizedMarks = [];
    marks.forEach(function(mark) {
        if (mark.attrs) {
            var attrs = $b37c1c4264661b4e$var$sanitizeAttributes(mark.attrs);
            sanitizedMarks.push($b37c1c4264661b4e$var$_objectSpread($b37c1c4264661b4e$var$_objectSpread({}, mark), {}, {
                attrs: attrs
            }));
        } else sanitizedMarks.push($b37c1c4264661b4e$var$_objectSpread({}, mark));
    });
    return sanitizedMarks;
};
var $b37c1c4264661b4e$var$sanitizeAttributes = function sanitizeAttributes() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sanitizedAttrs = Object.assign({}, attrs);
    Object.keys(attrs).filter(function(key) {
        return !$b37c1c4264661b4e$var$whitelistedAttributes.includes(key);
    }).forEach(function(key) {
        sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
    });
    return sanitizedAttrs;
};
var $b37c1c4264661b4e$var$trackUnsupportedContentTooltipActionFor = function trackUnsupportedContentTooltipActionFor(action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType) {
    dispatchAnalyticsEvent({
        action: action,
        actionSubjectId: unsupportedContentType,
        actionSubject: (0, $jJH6F.ACTION_SUBJECT).TOOLTIP,
        eventType: (0, $jJH6F.EVENT_TYPE).UI,
        attributes: {
            unsupportedNodeType: originalNodeType
        }
    });
};
var $b37c1c4264661b4e$export$d343369b8f25914 = function findAndTrackUnsupportedContentNodes(node, schema, dispatchAnalyticsEvent) {
    var ancestorHierarchy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var nodeType = node.type, nodeMarks = node.marks;
    var _schema$marks = schema.marks, unsupportedMark = _schema$marks.unsupportedMark, unsupportedNodeAttribute = _schema$marks.unsupportedNodeAttribute;
    var _schema$nodes = schema.nodes, unsupportedInline = _schema$nodes.unsupportedInline, unsupportedBlock = _schema$nodes.unsupportedBlock;
    var parentType = ancestorHierarchy.split(' ').pop() || '';
    if (nodeMarks.length) nodeMarks.forEach(function(mark) {
        if (mark.type === unsupportedMark) {
            var _ref = mark.attrs || {}, originalValue = _ref.originalValue;
            var _ref2 = originalValue || {}, type = _ref2.type;
            var unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: originalValue.attrs || {}
            };
            $b37c1c4264661b4e$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $jJH6F.ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
        } else if (mark.type === unsupportedNodeAttribute) {
            var _ref3 = mark.attrs || {}, unsupported = _ref3.unsupported;
            var _unsupportedNodeAttribute = {
                type: nodeType.name || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: unsupported || {}
            };
            $b37c1c4264661b4e$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $jJH6F.ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, _unsupportedNodeAttribute);
        }
    });
    if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
        var _ref4 = node.attrs || {}, originalValue = _ref4.originalValue;
        var _ref5 = originalValue || [], marks = _ref5.marks;
        var _ref6 = originalValue || {}, attrs = _ref6.attrs;
        var _ref7 = originalValue || {}, type = _ref7.type;
        var unsupportedNode = {
            type: type || '',
            ancestry: ancestorHierarchy,
            parentType: parentType,
            marks: marks || [],
            attrs: attrs || {}
        };
        var actionSubjectId = nodeType === unsupportedInline ? (0, $jJH6F.ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, $jJH6F.ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
        $b37c1c4264661b4e$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
    } else // Recursive check for nested content
    node.content.forEach(function(childNode) {
        return $b37c1c4264661b4e$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $b37c1c4264661b4e$var$concatAncestorHierarchy(node, ancestorHierarchy));
    });
};
var $b37c1c4264661b4e$export$e1051b410945e4d4 = function fireUnsupportedEvent(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode) {
    var sanitizedAttrs = $b37c1c4264661b4e$var$sanitizeAttributes(unsupportedNode.attrs);
    var sanitizedMarks = $b37c1c4264661b4e$var$sanitizeMarks(unsupportedNode.marks);
    var sanitizedUnsupportedNode = {
        type: unsupportedNode.type,
        ancestry: unsupportedNode.ancestry,
        parentType: unsupportedNode.parentType,
        attrs: sanitizedAttrs,
        marks: sanitizedMarks
    };
    var payload = {
        action: (0, $jJH6F.ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
        actionSubject: (0, $jJH6F.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: $b37c1c4264661b4e$var$_objectSpread({
            unsupportedNode: sanitizedUnsupportedNode
        }, !!errorCode && {
            errorCode: errorCode
        }),
        eventType: (0, $jJH6F.EVENT_TYPE).TRACK
    };
    dispatchAnalyticsEvent(payload);
};
var $b37c1c4264661b4e$export$3a34598135e7219b = function trackUnsupportedContentTooltipDisplayedFor(dispatchAnalyticsEvent, unsupportedContentType, originalNodeType) {
    $b37c1c4264661b4e$var$trackUnsupportedContentTooltipActionFor((0, $jJH6F.ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
};

});

parcelRegister("iY18h", function(module, exports) {
$parcel$export(module.exports, "getUnsupportedContent", () => $dceeb579b418516a$export$d4ded51d0f0bd2df);
function $dceeb579b418516a$export$d4ded51d0f0bd2df(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
message, prefix, node, intl) {
    var defaultLocale = 'en';
    var canTranslateToLocale = true;
    var locale = intl ? intl.locale : defaultLocale;
    var finalMessage = message.defaultMessage;
    if (node && locale.startsWith(defaultLocale)) {
        var originalValue = node.attrs.originalValue;
        if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
            finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
            canTranslateToLocale = false;
        } else if (originalValue.type) {
            finalMessage = "".concat(prefix, " ").concat(originalValue.type);
            canTranslateToLocale = false;
        }
    }
    if (intl && canTranslateToLocale) return intl.formatMessage(message);
    return finalMessage;
}

});


parcelRegister("jkJfI", function(module, exports) {
$parcel$export(module.exports, "isExperimentEnabled", () => $e132fccc70f9222f$export$336b018592dc9972);

var $1LtBL = parcelRequire("1LtBL");
function $e132fccc70f9222f$export$336b018592dc9972(experimentName) {
    return (0, $1LtBL.expVal)(experimentName, 'isEnabled', false) === true;
}

});
parcelRegister("1LtBL", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $149125cae6d87873$export$9db1624a8af791a4);

var $7RtyU = parcelRequire("7RtyU");
function $149125cae6d87873$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    return (0, $7RtyU.expValInternal)(experimentName, param, defaultValue, true);
}

});
parcelRegister("7RtyU", function(module, exports) {
$parcel$export(module.exports, "expValInternal", () => $5b946a12bad1110f$export$48708229abf6ab93);

var $ISKn7 = parcelRequire("ISKn7");

var $6z7VU = parcelRequire("6z7VU");

var $hIjZ3 = parcelRequire("hIjZ3");
function $5b946a12bad1110f$export$48708229abf6ab93(experimentName, param, defaultValue, fireExperimentExposure) {
    // Dev-mode override (platform website dev panel, Gemini VR test harness).
    if ((0, $hIjZ3.devOverrides).has(experimentName)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        var overrideParams = (0, $hIjZ3.devOverrides).get(experimentName);
        var overrideValue = overrideParams[param];
        if (overrideValue !== undefined) {
            (0, $6z7VU.addFeatureFlagAccessed)("".concat(experimentName, ":").concat(param), overrideValue);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return overrideValue;
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return defaultValue;
    }
    // If Statsig is not initialized, return the default.
    if (!(0, $ISKn7.default).initializeCompleted()) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return defaultValue;
    // Live Statsig value.
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var value = (0, $ISKn7.default).getExperimentValue(experimentName, param, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    (0, $6z7VU.addFeatureFlagAccessed)("".concat(experimentName, ":").concat(param), value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}

});
parcelRegister("6z7VU", function(module, exports) {
$parcel$export(module.exports, "addFeatureFlagAccessed", () => $4c7c2a4e2c033d6c$export$47fade9662f71000);

var $i0wFU = parcelRequire("i0wFU");
var $4c7c2a4e2c033d6c$export$5b78c989c8db2561 = new Map();
var $4c7c2a4e2c033d6c$export$2a5c8df26bb89760 = new Map();
function $4c7c2a4e2c033d6c$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    var value = (0, $i0wFU.redactValue)(featureFlagValue);
    $4c7c2a4e2c033d6c$export$5b78c989c8db2561.set(featureFlagName, value);
    $4c7c2a4e2c033d6c$export$2a5c8df26bb89760.set(featureFlagName, value);
}

});
parcelRegister("i0wFU", function(module, exports) {
$parcel$export(module.exports, "redactValue", () => $d1c192a3becf8b21$export$fcc03ee4c944962f);

var $ekGgq = parcelRequire("ekGgq");

var $7zq0Z = parcelRequire("7zq0Z");
function $d1c192a3becf8b21$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch (_unused) {
        return false;
    }
    return false;
}
function $d1c192a3becf8b21$var$isObject(value) {
    return value && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && value.constructor === Object;
}
function $d1c192a3becf8b21$var$isString(input) {
    var result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (_unused2) {
        // swallow any errors
        result = false;
    }
    return result;
}
function $d1c192a3becf8b21$export$7b4abba432e57989(value) {
    return $d1c192a3becf8b21$var$isString(value) && $d1c192a3becf8b21$var$startsAsObject(value) || $d1c192a3becf8b21$var$isObject(value);
}
function $d1c192a3becf8b21$export$fcc03ee4c944962f(featureFlagValue) {
    return $d1c192a3becf8b21$export$7b4abba432e57989(featureFlagValue) ? (0, $7zq0Z.NON_BOOLEAN_VALUE) : featureFlagValue;
}

});
parcelRegister("7zq0Z", function(module, exports) {
$parcel$export(module.exports, "NON_BOOLEAN_VALUE", () => $582ffb5235cb9916$export$42f4885608027d0c);
var $582ffb5235cb9916$export$42f4885608027d0c = 'non_boolean';

});



parcelRegister("hIjZ3", function(module, exports) {
$parcel$export(module.exports, "devOverrides", () => $ce560c1bf2ef5ae1$export$89f9222be8849d61);
var $ce560c1bf2ef5ae1$export$89f9222be8849d61 = new Map();
var $ce560c1bf2ef5ae1$export$1443858d5f82511f = false;
function $ce560c1bf2ef5ae1$export$6bce865e33a255c3(value) {
    $ce560c1bf2ef5ae1$export$1443858d5f82511f = value;
}

});




parcelRegister("j3BGx", function(module, exports) {
$parcel$export(module.exports, "editorExperiment", () => $ddfb879672c65d8f$export$9b7cf3b74f250027);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $ISKn7 = parcelRequire("ISKn7");

var $67sOe = parcelRequire("67sOe");

var $aj4TE = parcelRequire("aj4TE");

var $75k6K = parcelRequire("75k6K");
function $ddfb879672c65d8f$export$9b7cf3b74f250027(experimentName, expectedExperimentValue) {
    var _experimentConfig$pro;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        exposure: false
    };
    var experimentConfig = (0, $aj4TE.editorExperimentsConfig)[experimentName];
    if ((0, $75k6K._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $75k6K._overrides)[experimentName] === expectedExperimentValue;
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error("Editor experiment configuration is not defined ".concat(experimentName, ". Likely the experiment does not exist or editor package versions are misaligned"));
    if (!(0, $75k6K._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var experimentKey = experimentConfig === null || experimentConfig === void 0 || (_experimentConfig$pro = experimentConfig.productKeys) === null || _experimentConfig$pro === void 0 ? void 0 : _experimentConfig$pro[0, $75k6K._product];
    if (!experimentKey) {
        var _editorExperimentsCon;
        // This will be hit in the case of an experiment not being set up for the product
        return ((_editorExperimentsCon = (0, $aj4TE.editorExperimentsConfig)[experimentName]) === null || _editorExperimentsCon === void 0 ? void 0 : _editorExperimentsCon.defaultValue) === expectedExperimentValue;
    }
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $ISKn7.default).getExperimentValue(experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    if (// When cleaning this gate up -- `calling where the experiments have the product key set`
    // in __tests__/experiments should be updated (as it's had the count bumped to include these).
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $ISKn7.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) (0, $67sOe.addFeatureFlagAccessed)("".concat(experimentName, ":").concat(experimentConfig.param), experimentValue);
    return expectedExperimentValue === experimentValue;
}

});
parcelRegister("67sOe", function(module, exports) {
$parcel$export(module.exports, "allFeatureFlagsAccessed", () => $4749be6bd52e5f19$export$5b78c989c8db2561);
$parcel$export(module.exports, "currentFeatureFlagsAccessed", () => $4749be6bd52e5f19$export$2a5c8df26bb89760);
$parcel$export(module.exports, "addFeatureFlagAccessed", () => $4749be6bd52e5f19$export$47fade9662f71000);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $ebrP0 = parcelRequire("ebrP0");
var $4749be6bd52e5f19$export$5b78c989c8db2561 = new Map();
var $4749be6bd52e5f19$export$2a5c8df26bb89760 = new Map();
function $4749be6bd52e5f19$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    var value = (0, $ebrP0.redactValue)(featureFlagValue);
    $4749be6bd52e5f19$export$5b78c989c8db2561.set(featureFlagName, value);
    $4749be6bd52e5f19$export$2a5c8df26bb89760.set(featureFlagName, value);
}

});
parcelRegister("ebrP0", function(module, exports) {
$parcel$export(module.exports, "redactValue", () => $a537ac982015e7af$export$fcc03ee4c944962f);

var $bKurX = parcelRequire("bKurX");

var $7uHhe = parcelRequire("7uHhe");
function $a537ac982015e7af$export$fcc03ee4c944962f(featureFlagValue) {
    return (0, $7uHhe.shouldRedactValue)(featureFlagValue) ? (0, $bKurX.NON_BOOLEAN_VALUE) : featureFlagValue;
}

});
parcelRegister("bKurX", function(module, exports) {
$parcel$export(module.exports, "NON_BOOLEAN_VALUE", () => $88db9c52c0d9e920$export$42f4885608027d0c);
var $88db9c52c0d9e920$export$42f4885608027d0c = 'non_boolean';

});

parcelRegister("7uHhe", function(module, exports) {
$parcel$export(module.exports, "shouldRedactValue", () => $574ce7a0e2a528cf$export$7b4abba432e57989);

var $ekGgq = parcelRequire("ekGgq");
function $574ce7a0e2a528cf$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch (_unused) {
        return false;
    }
    return false;
}
function $574ce7a0e2a528cf$var$isObject(value) {
    return value && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && value.constructor === Object;
}
function $574ce7a0e2a528cf$var$isString(input) {
    var result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (_unused2) {
        // swallow any errors
        result = false;
    }
    return result;
}
function $574ce7a0e2a528cf$export$7b4abba432e57989(value) {
    return $574ce7a0e2a528cf$var$isString(value) && $574ce7a0e2a528cf$var$startsAsObject(value) || $574ce7a0e2a528cf$var$isObject(value);
}

});



parcelRegister("aj4TE", function(module, exports) {
$parcel$export(module.exports, "editorExperimentsConfig", () => $780f7a13a3c2fcae$export$6cbb856f286b07ef);
/* eslint-disable perfectionist/sort-object-types */ /* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $lU46N = parcelRequire("lU46N");

var $kCwz7 = parcelRequire("kCwz7");
var $780f7a13a3c2fcae$export$5c897d5297c5b7fd = [
    'platform_editor_blocks',
    'platform_editor_controls',
    'advanced_layouts',
    'single_column_layouts',
    'platform_editor_preview_panel_responsiveness',
    'platform_editor_toolbar_aifc'
];
var $780f7a13a3c2fcae$export$6cbb856f286b07ef = {
    // new format to avoid collisions with other users when updating the file
    // Added 2026-07-18
    cc_maui_remix_button_hover_corridor: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_remix_button_hover_corridor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-24
    platform_editor_layout_column_delete_shortcut_fix: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_delete_shortcut_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-21
    // `isEnabled` is the gating param; the experiment's dynamic config also carries the numeric
    // `shimmerDurationMs` (skeleton) and `highlightDurationMs` (purple highlight) durations, read at
    // runtime via `expVal`.
    platform_editor_agent_be_streaming: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_agent_be_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Editor Platform experiments
    // lwoollard experiments
    // Added 2026-04-21
    cwr_page_tree_auto_finalize: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr_page_tree_auto_finalize'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 02-12-2025
    cc_fix_hydration_ttvc: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_hydration_ttvc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    'editor_a11y__enghealth-46814_fy26': (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y__enghealth-46814_fy26'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19
    'enghealth-53346_fix_redaction_marker_editor': (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            jira: 'enghealth-53346_fix_redaction_marker_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-16
    platform_editor_remove_important_in_render_ext: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_important_in_render_ext'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-06
    confluence_comment_nudgebar_improvement: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_comment_nudgebar_improvement'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_quick_insert_embeds: (0, $kCwz7.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_quick_insert_embeds'
        },
        param: 'cohort',
        values: [
            'control',
            'prioritizeLinkInQIM',
            'prioritizeEmbedInQIM'
        ],
        defaultValue: 'control'
    }),
    confluence_remix_icon_right_side: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_remix_icon_right_side'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_editor_insm_doc_size_stats: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_doc_size_stats'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-26
    cc_editor_fix_insm_inp_buffer: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_fix_insm_inp_buffer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    cwr_blank_object_experiment: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr_blank_object_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-08
    confluence_inline_comments_fix_stale_selection: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_inline_comments_fix_stale_selection'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    rovo_remix_experience_context: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'rovo_remix_experience_context'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-05
    'databases-native-embeds-v2': (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'databases-native-embeds-v2'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    cc_editor_insm_outlier_events: (0, $kCwz7.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_outlier_events'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-17
    platform_editor_renderer_extension_width_fix: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_extension_width_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-24
    platform_editor_media_external_badge_bbc_fix: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_external_badge_bbc_fix',
            bitbucket: 'platform_editor_media_external_badge_bbc_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-20
    platform_editor_annotations_sync_on_docchange: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_annotations_sync_on_docchange'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $kCwz7.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_per_plugin_error_boundary: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_per_plugin_error_boundary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-05
    'company_hub_carousel_thumbnails-refactor': (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'company_hub_carousel_thumbnails-refactor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $kCwz7.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_paste_actions_menu: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-19
    platform_editor_controls_reliable_anchor: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_reliable_anchor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $kCwz7.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls',
            jira: 'platform_editor_controls_jira'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-07-21
    confluence_cwr_3p_connection_suggested_prompts: (0, $kCwz7.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_cwr_3p_connection_suggested_prompts'
        },
        param: 'cohort',
        values: [
            'control',
            'variant_a',
            'variant_b'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-05-26
    platform_editor_agent_mentions: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_agent_mentions',
            jira: 'platform_editor_agent_mentions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    platform_editor_reduced_agent_profile_cards: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_reduced_agent_profile_cards',
            jira: 'platform_editor_reduced_agent_profile_cards'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-30
    platform_editor_fix_link_paste_menu: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_link_paste_menu',
            jira: 'platform_editor_fix_link_paste_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_code_block_q4_lovability: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_code_block_q4_lovability',
            jira: 'platform_editor_code_block_q4_lovability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-17-03
    platform_editor_media_name_fallback: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_name_fallback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-12
    platform_editor_media_name_fallback_viewer_card: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_name_fallback_viewer_card'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-16
    platform_editor_enable_single_player_step_merging: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enable_single_player_step_merging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_hide_overflow_menu: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_hide_overflow_menu',
            jira: 'platform_editor_toolbar_hide_overflow_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_responsiveness'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $kCwz7.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-06-25
    jira_editor_a11y_toolbar_fixes: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'jira_editor_a11y_toolbar_fixes',
            jira: 'jira_editor_a11y_toolbar_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-09
    platform_editor_blocks: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocks_conf',
            jira: 'platform_editor_blocks_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-23
    //Added 2025-07-16
    platform_editor_toolbar_aifc: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_confluence'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_breakout_interaction_rerender: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_interaction_rerender'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_blocktaskitem_node_tenantid: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_node_tenantid'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_with_dnd: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_with_dnd'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    'editor-a11y-fy26-keyboard-move-row-column': (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor-a11y-fy26-keyboard-move-row-column',
            jira: 'editor-a11y-fy26-keyboard-move-row-column'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-28
    editor_enable_image_alignment_in_expand: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enable_image_alignment_in_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_august_a11y: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_august_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-01
    cc_editor_ai_content_mode: (0, $kCwz7.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_ai_content_mode'
        },
        param: 'variant',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-01-09
    platform_editor_render_bodied_extension_as_inline: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_render_bodied_extension_as_inline'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-03
    platform_editor_ai_quick_prompt_iw_cc: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quick_prompt_iw_cc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-15
    cc_smarts_should_improve_writing_migration: (0, $kCwz7.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_smarts_should_improve_writing_migration'
        },
        param: 'routingMode',
        values: [
            'control',
            'shadow_compare',
            'live_cc_smarts'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-10
    platform_use_llm_space_recommendations: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_llm_space_recommendations'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-01
    // Added 2025-10-13
    platform_editor_media_error_analytics: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_error_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-27
    platform_editor_table_sticky_header_improvements: (0, $kCwz7.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_improvements'
        },
        param: 'cohort',
        values: [
            'control',
            'test_with_overflow',
            'test_without_overflow'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-29
    platform_editor_lovability_inline_code: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_inline_code'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_lovability_emoji_scaling: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_emoji_scaling'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-18
    editor_a11y_7152_profile_card_tab_order: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y_7152_profile_card_tab_order'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-19
    platform_editor_lovability_navigation_fixes: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_navigation_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-27 — Pre-auth unauthorised inline hover card UX
    platform_sl_3p_preauth_better_hovercard: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_preauth_better_hovercard',
            jira: 'platform_sl_3p_preauth_better_hovercard'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-21 — Post-auth GDrive Smart Link to Rovo Chat auto-open
    platform_sl_3p_post_auth_chat_open_exp: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_post_auth_chat_open_exp',
            jira: 'platform_sl_3p_post_auth_chat_open_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-29 — Social proof inline CTA for unauthorised 3P inline smart links
    platform_sl_3p_preauth_social_proof_inline_cta: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_preauth_social_proof_inline_cta',
            jira: 'platform_sl_3p_preauth_social_proof_inline_cta'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15 — Embed card footer rovo action for resolved 3P smart links in confluence
    platform_sl_3p_auth_rovo_embed_footer_exp: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_auth_rovo_embed_footer_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_submenu_open_click: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_submenu_open_click'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-13
    platform_editor_hide_extension_renderer_support: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hide_extension_renderer_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-23
    platform_editor_fix_new_line_after_heading: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_new_line_after_heading',
            jira: 'platform_editor_fix_new_line_after_heading'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-21
    platform_editor_copy_link_a11y_inconsistency_fix: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_copy_link_a11y_inconsistency_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_editor_fix_lagging_embed_resize_handle: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_lagging_embed_resize_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-30
    platform_editor_fix_cross_origin_editor_focus: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_cross_origin_editor_focus'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_ttvc_inline_extensions: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_ttvc_inline_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-03
    platform_editor_enghealth_a11y_jan_fixes: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enghealth_a11y_jan_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    cc_fd_db_top_editor_toolbar: (0, $kCwz7.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_fd_db_top_editor_toolbar'
        },
        param: 'cohort',
        values: [
            'control',
            'new-description',
            'orig-description'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-04-01
    cc_page_experiences_editor_image_generation: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_page_experiences_editor_image_generation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-23
    'cc-maui-experiment': (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-maui-experiment',
            jira: 'jira_maui_remix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_maui_create_keyword: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_create_keyword'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // A/A experiment paired with cc_maui_create_keyword, used only to balance exposures.
    cc_maui_create_keyword_aa: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_create_keyword_aa'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-13
    confluence_native_tabs_experiment: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_native_tabs_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-29
    cc_maui_polish_changes_batch_4: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_polish_changes_batch_4'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    'cc-mui-slides-experiment': (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-mui-slides-experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-27
    confluence_frontend_cwr_outcome_type_picker: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_frontend_cwr_outcome_type_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    cfe_cwr_outcome_picker_respect_site_settings: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'cfe_cwr_outcome_picker_respect_site_settings'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-12
    prompt_tile_content_type_localizaiton: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'prompt_tile_content_type_localizaiton'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-24
    'cwr-modal-ui-refresh': (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-modal-ui-refresh'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-08
    'cc-disambiguation-in-cwr': (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-disambiguation-in-cwr'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    'cwr-reduce-prompt-suggestion-max-chars': (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-reduce-prompt-suggestion-max-chars'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15
    'cwr-staging-area-close-as-minimize-button': (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-staging-area-close-as-minimize-button'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-08
    cc_cwr_prompt_strength_indicator: (0, $kCwz7.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_cwr_prompt_strength_indicator'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1',
            'variant2'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-02-12
    platform_editor_a11y_escape_link_dialog: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_a11y_escape_link_dialog',
            jira: 'platform_editor_a11y_escape_link_dialog'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_vc90_transition_panel_icon: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vc90_transition_panel_icon'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_emoji_default_scale: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_default_scale',
            jira: 'platform_editor_emoji_default_scale'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-17
    platform_editor_emoji_hover_show_tooltip: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_hover_show_tooltip',
            jira: 'platform_editor_emoji_hover_show_tooltip'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    platform_teamoji_26_refresh_emoji_picker: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_teamoji_26_refresh_emoji_picker',
            jira: 'platform_teamoji_26_refresh_emoji_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-16
    platform_use_unicode_emojis: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_unicode_emojis_confluence',
            jira: 'platform_use_unicode_emojis_jira',
            bitbucket: 'platform_use_unicode_emojis_bitbucket'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-26
    platform_editor_toolbar_update_jira_config: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_toolbar_update_jira_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_ai_blockmenu_integration: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_blockmenu_integration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-26
    platform_editor_remix_in_block_menu: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remix_in_block_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19 — fix table text length calculation for Remix/Improve Writing hero prompts
    remix_iw_block_menu_table_calc_fix: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'remix_iw_block_menu_table_calc_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_rovobutton_smartlink_toolbar_exp: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_rovobutton_smartlink_toolbar_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_a11y_scrollable_region: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_a11y_scrollable_region'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    confluence_fe_renderer_inline_node_mark_color_fix: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_renderer_inline_node_mark_color_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_diff_plugin_extended: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_diff_plugin_extended'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_fix_media_toolbar_border_dropdown: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_media_toolbar_border_dropdown'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-06
    platform_editor_single_player_expand: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_player_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_fit_to_content_on_demand: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_fit_to_content_on_demand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-09
    platform_editor_remove_collab_step_metrics: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_collab_step_metrics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    platform_editor_ai_normalized_telemetry: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_normalized_telemetry'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-15
    platform_editor_sync_block_ssr_config: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_sync_block_ssr_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-06
    confluence_fe_create_page_suggestion: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_create_page_suggestion'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-18
    platform_editor_selection_toolbar_block_handle: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_selection_toolbar_block_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    platform_editor_improve_preset_builder_logging: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_improve_preset_builder_logging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-23
    'cc-markdown-mode': (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-markdown-mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_ai_xstate_migration: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_xstate_migration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-31
    platform_editor_dnd_accessibility_fixes_expand: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_dnd_accessibility_fixes_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-15
    platform_editor_ai_no_stream_skip_pacer: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_no_stream_skip_pacer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-07
    platform_editor_layout_column_menu: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-29
    platform_editor_layout_column_selection_fix: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_selection_fix',
            jira: 'platform_editor_layout_column_selection_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15
    platform_editor_layout_column_valign_rendering: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_valign_rendering'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    platform_editor_external_embed_grid_fix: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_external_embed_grid_fix',
            jira: 'platform_editor_external_embed_grid_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-08
    cc_fd_wb_jira_quick_insert_experiment: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            jira: 'cc_fd_wb_jira_quick_insert_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-30
    cc_fix_editor_context_on_cwr_followups: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_editor_context_on_cwr_followups'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    cc_fix_ephemeral_preview_staging_area_registration: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_ephemeral_preview_staging_area_registration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    platform_editor_hydration_skip_react_portal: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hydration_skip_react_portal'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-28
    platform_editor_use_markdown_plus_parser: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_markdown_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_use_html_plus_parser: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_html_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    platform_editor_core_static_css: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_static_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_core_non_ecc_static_css: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_non_ecc_static_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_q4_loveability: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_q4_loveability',
            jira: 'platform_editor_table_q4_loveability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    platform_editor_table_menu_updates: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_menu_updates',
            jira: 'platform_editor_table_menu_updates'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-06
    confluence_live_doc_table_sort_bugfix: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_live_doc_table_sort_bugfix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    confluence_fe_disable_comment_if_offline_fix: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_disable_comment_if_offline_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    platform_editor_sync_block_activation: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_sync_block_activation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_paste_actions_menu_v2: (0, $kCwz7.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu_v2',
            jira: 'platform_editor_paste_actions_menu_v2'
        },
        param: 'variant',
        values: [
            'control',
            'hasSpellingAndGrammar',
            'hasAltAiActions'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-05-01 — Social proof experiment for unauthorized 3P block cards
    social_proof_3p_unauth_block_exp: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'social_proof_3p_unauth_block_exp',
            jira: 'social_proof_3p_unauth_block_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_replace_doc/setup
    platform_editor_ai_replace_doc: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_replace_doc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-18
    platform_editor_nest_table_in_panel: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nest_table_in_panel'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_rovo_support_create_inline_comment: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_rovo_support_create_inline_comment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_fix_sticky_header_malfunction: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_sticky_header_malfunction'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-17
    platform_editor_fix_sticky_header_row: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_sticky_header_row'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-10
    confluence_editor_paste_3p_link_actions_menu: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_paste_3p_link_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-29
    'a11y-fixes-week3-may-2026': (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'a11y-fixes-week3-may-2026',
            jira: 'a11y-fixes-week3-may-2026'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_reactions_selector_list: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_reactions_selector_list',
            jira: 'platform_a11y_fixes_reactions_selector_list'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_emoji_picker_list: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_emoji_picker_list',
            jira: 'platform_a11y_fixes_emoji_picker_list'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_emoji_title_shortname: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_emoji_title_shortname',
            jira: 'platform_a11y_fixes_emoji_title_shortname'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-25
    // HTML+ v2 incremental tool-call streaming contract — gates the new
    // PartialStreamParserV2 / ToolCallProcessorV2 / AdfChunkStrategyV2 stack
    // in `@atlassian/editor-rovo-bridge`, the `replaceValue` orchestrator
    // action, and the `toolCallsStreaming.supportsProvisionalToolCalls`
    // capability advert on `PageContentCommandResult`.
    platform_editor_use_html_plus_streaming_parser: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_html_plus_streaming_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_wide_slash_trigger: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_wide_slash_trigger'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11 — [CCI-15904] New AIFC Editor Experience (Full Page Staging Area + Post Stream Review Toolbar)
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_new_aifc_editor_experience/setup
    platform_editor_ai_new_aifc_editor_experience: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_new_aifc_editor_experience'
        },
        param: 'isBackendReviewMomentEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    // Gates the `GhostIconWave` animation primitive in
    // `@atlassian/rovo-platform-ui-components` — rendered as a loading cue on
    // Confluence's 3p-in-CWR (Rovo) surfaces. When off the primitive renders
    // nothing.
    confluence_3p_in_cwr_ghost_icons: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_3p_in_cwr_ghost_icons'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    platform_editor_lovability_text_bg_color: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_text_bg_color',
            jira: 'platform_editor_lovability_text_bg_color'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-20
    platform_editor_ssr_toolbar_optimistic: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ssr_toolbar_optimistic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19
    platform_editor_lovability_resize_dividers_panels: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_resize_dividers_panels'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_editor_add_breakout_marks_on_page_load: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_breakout_marks_on_page_load'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-23
    'aifc-confluence-editor-csp-fix': (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'aifc-confluence-editor-csp-fix',
            jira: 'aifc-confluence-editor-csp-fix'
        },
        param: 'value',
        defaultValue: false
    }),
    // Added 2026-07-02
    platform_editor_media_download_fallback_name: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_download_fallback_name'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-01
    platform_editor_remove_pause_streaming: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_pause_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-17
    revert_remix_ephemeral_iframe_sizing_fix: (0, $lU46N.createBooleanExperiment)({
        productKeys: {
            confluence: 'revert_remix_ephemeral_iframe_sizing_fix',
            jira: 'revert_remix_ephemeral_iframe_sizing_fix'
        },
        param: 'value',
        defaultValue: false
    }),
    // Added 2026-07-28
    cwr_publish_flow_live_doc_toggle_exp: (0, $kCwz7.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cwr_publish_flow_live_doc_toggle_exp'
        },
        param: 'cohort',
        defaultValue: 'control',
        values: [
            'control',
            'variantA',
            'variantB',
            'variantC'
        ]
    })
};

});
parcelRegister("lU46N", function(module, exports) {
$parcel$export(module.exports, "createBooleanExperiment", () => $ff2203d7ace3f27a$export$456f1587c9c92021);

var $25nEq = parcelRequire("25nEq");

var $ff4cS = parcelRequire("ff4cS");
function $ff2203d7ace3f27a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ff2203d7ace3f27a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ff2203d7ace3f27a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ff2203d7ace3f27a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ff2203d7ace3f27a$export$456f1587c9c92021(config) {
    return $ff2203d7ace3f27a$var$_objectSpread($ff2203d7ace3f27a$var$_objectSpread({}, config), {}, {
        typeGuard: (0, $ff4cS.isBoolean),
        defaultValue: config.defaultValue
    });
}

});
parcelRegister("ff4cS", function(module, exports) {
$parcel$export(module.exports, "isBoolean", () => $b18b851251c1916a$export$f9ce7b637dfbe238);
function $b18b851251c1916a$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}

});


parcelRegister("kCwz7", function(module, exports) {
$parcel$export(module.exports, "createMultivariateExperiment", () => $f0309e120c503e73$export$fb89e8a786694d1);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $l0n7z = parcelRequire("l0n7z");
function $f0309e120c503e73$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f0309e120c503e73$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f0309e120c503e73$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f0309e120c503e73$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f0309e120c503e73$export$fb89e8a786694d1(config) {
    var values = config.values;
    return $f0309e120c503e73$var$_objectSpread($f0309e120c503e73$var$_objectSpread({}, config), {}, {
        values: (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(values),
        // Maintains the tuple
        typeGuard: (0, $l0n7z.oneOf)(config.values),
        defaultValue: config.defaultValue
    });
}

});
parcelRegister("l0n7z", function(module, exports) {
$parcel$export(module.exports, "oneOf", () => $f4ab8873548775e8$export$a9a18ae5ba42aeab);

var $3ZMUU = parcelRequire("3ZMUU");
var $f4ab8873548775e8$var$_process, $f4ab8873548775e8$var$_process2;
var $f4ab8873548775e8$var$IS_TESTING_ENV = typeof $3ZMUU !== 'undefined' && ((($f4ab8873548775e8$var$_process = $3ZMUU) === null || $f4ab8873548775e8$var$_process === void 0 || ($f4ab8873548775e8$var$_process = $f4ab8873548775e8$var$_process.env) === null || $f4ab8873548775e8$var$_process === void 0 ? void 0 : $f4ab8873548775e8$var$_process.NODE_ENV) === 'test' || (($f4ab8873548775e8$var$_process2 = $3ZMUU) === null || $f4ab8873548775e8$var$_process2 === void 0 || ($f4ab8873548775e8$var$_process2 = $f4ab8873548775e8$var$_process2.env) === null || $f4ab8873548775e8$var$_process2 === void 0 ? void 0 : $f4ab8873548775e8$var$_process2.JEST_WORKER_ID) !== undefined);
function $f4ab8873548775e8$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
   * This is used by test utils to get the variants when running describe.each
   */ if ($f4ab8873548775e8$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}

});



parcelRegister("75k6K", function(module, exports) {
$parcel$export(module.exports, "_overrides", () => $528899015f76bd1a$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_product", () => $528899015f76bd1a$export$cf7305fc65acbf0d);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $89JeF = parcelRequire("89JeF");

var $aj4TE = parcelRequire("aj4TE");
function $528899015f76bd1a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $528899015f76bd1a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $528899015f76bd1a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $528899015f76bd1a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $528899015f76bd1a$export$e5d73bf4f8e2ae96 = {};
var $528899015f76bd1a$export$4e849416bb5c5b52 = {};
var $528899015f76bd1a$export$cf7305fc65acbf0d;
function $528899015f76bd1a$export$1c2b6dbf79eb3560(product, /**
 * Overrides are used to set the group of an experiment for testing purposes.
 * This is useful when you want to test a specific experiment group.
 */ groupOverrides, /**
 * Param overrides are used to set the experiment parameters for testing purposes.
 * This is useful when you want to tweak the experiment parameters for testing.
 */ paramOverrides, options) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        groupOverrides = Object.entries(groupOverrides).reduce(function(acc, _ref) {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
            var config = (0, $aj4TE.editorExperimentsConfig)[key];
            if (config) acc = $528899015f76bd1a$var$_objectSpread($528899015f76bd1a$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, config.typeGuard(value) ? value : config.defaultValue));
            return acc;
        }, {});
        $528899015f76bd1a$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test' && !(options !== null && options !== void 0 && options.disableTestOverrides)) {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        var testOverrides = Object.fromEntries(Object.entries((0, $aj4TE.editorExperimentsConfig)).map(function(_ref3) {
            var _ref5, _ref6, _groupOverrides, _groupOverrides2;
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), key = _ref4[0], value = _ref4[1];
            var defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                (_ref5 = (_ref6 = (_groupOverrides = (_groupOverrides2 = groupOverrides) === null || _groupOverrides2 === void 0 ? void 0 : _groupOverrides2[key]) !== null && _groupOverrides !== void 0 ? _groupOverrides : (0, $89JeF.testMultivariateOverrides)[key]) !== null && _ref6 !== void 0 ? _ref6 : (0, $89JeF.testBooleanOverrides)[key]) !== null && _ref5 !== void 0 ? _ref5 : defaultValue
            ];
        }));
        $528899015f76bd1a$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $528899015f76bd1a$export$cf7305fc65acbf0d = product;
    $528899015f76bd1a$export$4e849416bb5c5b52 = paramOverrides || {};
}

});
parcelRegister("89JeF", function(module, exports) {
$parcel$export(module.exports, "testMultivariateOverrides", () => $5f0240d492457d1a$export$7e849a84a00ffd1c);
$parcel$export(module.exports, "testBooleanOverrides", () => $5f0240d492457d1a$export$54960937bb713f97);
var $5f0240d492457d1a$export$7e849a84a00ffd1c = {
    cwr_publish_flow_live_doc_toggle_exp: 'control',
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_controls: 'control',
    cc_editor_ai_content_mode: 'control',
    platform_hover_card_preview_panel: 'control',
    cc_editor_insm_outlier_events: 'test',
    platform_editor_table_sticky_header_improvements: 'test_with_overflow',
    cc_fd_db_top_editor_toolbar: 'control',
    platform_editor_paste_actions_menu_v2: 'control',
    cc_smarts_should_improve_writing_migration: 'control',
    confluence_quick_insert_embeds: 'control',
    cc_cwr_prompt_strength_indicator: 'control',
    confluence_cwr_3p_connection_suggested_prompts: 'control'
};
var $5f0240d492457d1a$export$54960937bb713f97 = {
    cc_maui_polish_changes_batch_4: false,
    social_proof_3p_unauth_block_exp: false,
    platform_sl_3p_preauth_better_hovercard: true,
    cwr_blank_object_experiment: false,
    platform_editor_preview_panel_responsiveness: false,
    'enghealth-53346_fix_redaction_marker_editor': false,
    platform_editor_toolbar_aifc: false,
    'test-new-experiments-package': false,
    platform_renderer_table_sticky_scrollbar: false,
    advanced_layouts: false,
    single_column_layouts: false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_editor_tables_table_selector: false,
    platform_renderer_fix_analytics_memo_callback: false,
    'jira-work-sync-desc-comment-summary': false,
    platform_editor_breakout_resizing: false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_enable_single_player_step_merging: false,
    platform_editor_paste_actions_menu: false,
    platform_editor_table_fit_to_content_on_demand: false,
    platform_editor_table_q4_loveability: false,
    platform_editor_table_menu_updates: false,
    'cwr-modal-ui-refresh': false,
    'cc-disambiguation-in-cwr': false,
    'cwr-reduce-prompt-suggestion-max-chars': false,
    'cwr-staging-area-close-as-minimize-button': false,
    prompt_tile_content_type_localizaiton: false,
    // [CCI-15904] New AIFC Editor Experience — read by the inline chat prompt view
    // in `conversation-assistant-chat-prompt-input`. Review moment eligibility is a
    // separate check (`editor-plugin-ai/src/ui/utils/review-moment-enabled.ts`) and
    // does not read this key.
    platform_editor_ai_new_aifc_editor_experience: false,
    cc_page_experiences_editor_image_generation: false,
    platform_use_unicode_emojis: false,
    platform_editor_emoji_hover_show_tooltip: false,
    'aifc-confluence-editor-csp-fix': false
};

});



parcelRegister("cc08P", function(module, exports) {
$parcel$export(module.exports, "Selection", () => $8e06b7206d4b50ac$export$52baac22726c72bf);
$parcel$export(module.exports, "SelectionRange", () => $8e06b7206d4b50ac$export$7bd1839c3c5d5bd4);
$parcel$export(module.exports, "TextSelection", () => $8e06b7206d4b50ac$export$c2b25f346d19bcbb);
$parcel$export(module.exports, "AllSelection", () => $8e06b7206d4b50ac$export$c15d9ba76bdbcd95);
$parcel$export(module.exports, "NodeSelection", () => $8e06b7206d4b50ac$export$e2940151ac854c0b);
$parcel$export(module.exports, "EditorState", () => $8e06b7206d4b50ac$export$afa855cbfaff27f2);
$parcel$export(module.exports, "Plugin", () => $8e06b7206d4b50ac$export$901cf72dabf2112a);
$parcel$export(module.exports, "PluginKey", () => $8e06b7206d4b50ac$export$1692d8b0e89cecc3);

var $9Jwkl = parcelRequire("9Jwkl");

var $lh06P = parcelRequire("lh06P");
const $8e06b7206d4b50ac$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $8e06b7206d4b50ac$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $8e06b7206d4b50ac$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $9Jwkl.Slice).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $9Jwkl.Slice).empty : content);
            if (i == 0) $8e06b7206d4b50ac$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $8e06b7206d4b50ac$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $8e06b7206d4b50ac$export$c2b25f346d19bcbb($pos) : $8e06b7206d4b50ac$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $8e06b7206d4b50ac$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $8e06b7206d4b50ac$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $8e06b7206d4b50ac$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $8e06b7206d4b50ac$var$findSelectionIn(doc, doc, 0, 0, 1) || new $8e06b7206d4b50ac$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $8e06b7206d4b50ac$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $8e06b7206d4b50ac$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $8e06b7206d4b50ac$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $8e06b7206d4b50ac$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $8e06b7206d4b50ac$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $8e06b7206d4b50ac$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$8e06b7206d4b50ac$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $8e06b7206d4b50ac$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $8e06b7206d4b50ac$var$warnedAboutTextSelection = false;
function $8e06b7206d4b50ac$var$checkTextSelection($pos) {
    if (!$8e06b7206d4b50ac$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $8e06b7206d4b50ac$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $8e06b7206d4b50ac$export$c2b25f346d19bcbb extends $8e06b7206d4b50ac$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $8e06b7206d4b50ac$var$checkTextSelection($anchor);
        $8e06b7206d4b50ac$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $8e06b7206d4b50ac$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $8e06b7206d4b50ac$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $9Jwkl.Slice).empty) {
        super.replace(tr, content);
        if (content == (0, $9Jwkl.Slice).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $8e06b7206d4b50ac$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $8e06b7206d4b50ac$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $8e06b7206d4b50ac$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $8e06b7206d4b50ac$export$52baac22726c72bf.findFrom($head, bias, true) || $8e06b7206d4b50ac$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $8e06b7206d4b50ac$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($8e06b7206d4b50ac$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $8e06b7206d4b50ac$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $8e06b7206d4b50ac$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$8e06b7206d4b50ac$export$52baac22726c72bf.jsonID("text", $8e06b7206d4b50ac$export$c2b25f346d19bcbb);
class $8e06b7206d4b50ac$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $8e06b7206d4b50ac$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $8e06b7206d4b50ac$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $8e06b7206d4b50ac$export$e2940151ac854c0b extends $8e06b7206d4b50ac$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $8e06b7206d4b50ac$export$52baac22726c72bf.near($pos);
        return new $8e06b7206d4b50ac$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $9Jwkl.Slice)((0, $9Jwkl.Fragment).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $8e06b7206d4b50ac$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $8e06b7206d4b50ac$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $8e06b7206d4b50ac$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $8e06b7206d4b50ac$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$8e06b7206d4b50ac$export$e2940151ac854c0b.prototype.visible = false;
$8e06b7206d4b50ac$export$52baac22726c72bf.jsonID("node", $8e06b7206d4b50ac$export$e2940151ac854c0b);
class $8e06b7206d4b50ac$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $8e06b7206d4b50ac$var$TextBookmark(pos, pos) : new $8e06b7206d4b50ac$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $8e06b7206d4b50ac$export$e2940151ac854c0b.isSelectable(node)) return new $8e06b7206d4b50ac$export$e2940151ac854c0b($pos);
        return $8e06b7206d4b50ac$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $8e06b7206d4b50ac$export$c15d9ba76bdbcd95 extends $8e06b7206d4b50ac$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $9Jwkl.Slice).empty) {
        if (content == (0, $9Jwkl.Slice).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $8e06b7206d4b50ac$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $8e06b7206d4b50ac$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $8e06b7206d4b50ac$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $8e06b7206d4b50ac$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $8e06b7206d4b50ac$var$AllBookmark;
    }
}
$8e06b7206d4b50ac$export$52baac22726c72bf.jsonID("all", $8e06b7206d4b50ac$export$c15d9ba76bdbcd95);
const $8e06b7206d4b50ac$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $8e06b7206d4b50ac$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $8e06b7206d4b50ac$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $8e06b7206d4b50ac$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $8e06b7206d4b50ac$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $8e06b7206d4b50ac$export$e2940151ac854c0b.isSelectable(child)) return $8e06b7206d4b50ac$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $8e06b7206d4b50ac$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $lh06P.ReplaceStep) || step instanceof (0, $lh06P.ReplaceAroundStep))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($8e06b7206d4b50ac$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $8e06b7206d4b50ac$var$UPDATED_SEL = 1, $8e06b7206d4b50ac$var$UPDATED_MARKS = 2, $8e06b7206d4b50ac$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $8e06b7206d4b50ac$export$febc5573c75cefb0 extends (0, $lh06P.Transform) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $8e06b7206d4b50ac$var$UPDATED_SEL) & ~$8e06b7206d4b50ac$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $8e06b7206d4b50ac$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $8e06b7206d4b50ac$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $9Jwkl.Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $8e06b7206d4b50ac$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$8e06b7206d4b50ac$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $9Jwkl.Mark).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty && this.selection.to == from + text.length) this.setSelection($8e06b7206d4b50ac$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $8e06b7206d4b50ac$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $8e06b7206d4b50ac$var$UPDATED_SCROLL) > 0;
    }
}
function $8e06b7206d4b50ac$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $8e06b7206d4b50ac$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $8e06b7206d4b50ac$var$bind(desc.init, self);
        this.apply = $8e06b7206d4b50ac$var$bind(desc.apply, self);
    }
}
const $8e06b7206d4b50ac$var$baseFields = [
    new $8e06b7206d4b50ac$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $8e06b7206d4b50ac$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $8e06b7206d4b50ac$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $8e06b7206d4b50ac$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $8e06b7206d4b50ac$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $8e06b7206d4b50ac$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $8e06b7206d4b50ac$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $8e06b7206d4b50ac$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $8e06b7206d4b50ac$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $8e06b7206d4b50ac$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Accessor that constructs and returns a new [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $8e06b7206d4b50ac$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $8e06b7206d4b50ac$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $8e06b7206d4b50ac$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $8e06b7206d4b50ac$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $8e06b7206d4b50ac$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $8e06b7206d4b50ac$var$Configuration(config.schema, config.plugins);
        let instance = new $8e06b7206d4b50ac$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $9Jwkl.Node).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $8e06b7206d4b50ac$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $8e06b7206d4b50ac$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $8e06b7206d4b50ac$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $8e06b7206d4b50ac$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $8e06b7206d4b50ac$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $8e06b7206d4b50ac$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $8e06b7206d4b50ac$var$keys = Object.create(null);
function $8e06b7206d4b50ac$var$createKey(name) {
    if (name in $8e06b7206d4b50ac$var$keys) return name + "$" + ++$8e06b7206d4b50ac$var$keys[name];
    $8e06b7206d4b50ac$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $8e06b7206d4b50ac$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $8e06b7206d4b50ac$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}

});
parcelRegister("lh06P", function(module, exports) {
$parcel$export(module.exports, "Mapping", () => $f7cb452bf977726e$export$f5f785078011b62);
$parcel$export(module.exports, "AddMarkStep", () => $f7cb452bf977726e$export$d24ba56b0e3464a9);
$parcel$export(module.exports, "RemoveMarkStep", () => $f7cb452bf977726e$export$94150db1311f67a9);
$parcel$export(module.exports, "AddNodeMarkStep", () => $f7cb452bf977726e$export$adefd16c402fee4e);
$parcel$export(module.exports, "RemoveNodeMarkStep", () => $f7cb452bf977726e$export$fdf7d1dc10724da2);
$parcel$export(module.exports, "ReplaceStep", () => $f7cb452bf977726e$export$5c860b2e74034756);
$parcel$export(module.exports, "ReplaceAroundStep", () => $f7cb452bf977726e$export$444ba800d6024a98);
$parcel$export(module.exports, "liftTarget", () => $f7cb452bf977726e$export$f1508b72cc76a09e);
$parcel$export(module.exports, "findWrapping", () => $f7cb452bf977726e$export$118cb9a83e81ba37);
$parcel$export(module.exports, "canSplit", () => $f7cb452bf977726e$export$5aaf008897aef029);
$parcel$export(module.exports, "canJoin", () => $f7cb452bf977726e$export$f15f89fd9d8cc98a);
$parcel$export(module.exports, "joinPoint", () => $f7cb452bf977726e$export$41b1d4cb5ceb3147);
$parcel$export(module.exports, "dropPoint", () => $f7cb452bf977726e$export$2819d598d048fc9c);
$parcel$export(module.exports, "replaceStep", () => $f7cb452bf977726e$export$ed6ac67359824afd);
$parcel$export(module.exports, "Transform", () => $f7cb452bf977726e$export$563a914cafbdc389);

var $9Jwkl = parcelRequire("9Jwkl");
// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $f7cb452bf977726e$var$lower16 = 0xffff;
const $f7cb452bf977726e$var$factor16 = Math.pow(2, 16);
function $f7cb452bf977726e$var$makeRecover(index, offset) {
    return index + offset * $f7cb452bf977726e$var$factor16;
}
function $f7cb452bf977726e$var$recoverIndex(value) {
    return value & $f7cb452bf977726e$var$lower16;
}
function $f7cb452bf977726e$var$recoverOffset(value) {
    return (value - (value & $f7cb452bf977726e$var$lower16)) / $f7cb452bf977726e$var$factor16;
}
const $f7cb452bf977726e$var$DEL_BEFORE = 1, $f7cb452bf977726e$var$DEL_AFTER = 2, $f7cb452bf977726e$var$DEL_ACROSS = 4, $f7cb452bf977726e$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $f7cb452bf977726e$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $f7cb452bf977726e$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($f7cb452bf977726e$var$DEL_BEFORE | $f7cb452bf977726e$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($f7cb452bf977726e$var$DEL_AFTER | $f7cb452bf977726e$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $f7cb452bf977726e$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $f7cb452bf977726e$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $f7cb452bf977726e$export$c53d01c3ab9721b3.empty) return $f7cb452bf977726e$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $f7cb452bf977726e$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $f7cb452bf977726e$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $f7cb452bf977726e$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $f7cb452bf977726e$var$DEL_AFTER : pos == end ? $f7cb452bf977726e$var$DEL_BEFORE : $f7cb452bf977726e$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $f7cb452bf977726e$var$DEL_SIDE;
                return new $f7cb452bf977726e$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $f7cb452bf977726e$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $f7cb452bf977726e$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $f7cb452bf977726e$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $f7cb452bf977726e$export$c53d01c3ab9721b3.empty : new $f7cb452bf977726e$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $f7cb452bf977726e$export$c53d01c3ab9721b3.empty = new $f7cb452bf977726e$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](https://prosemirror.net/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $f7cb452bf977726e$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(maps, /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps ? maps.length : 0){
        this.mirror = mirror;
        this.from = from;
        this.to = to;
        this._maps = maps || [];
        this.ownData = !(maps || mirror);
    }
    /**
    The step maps in this mapping.
    */ get maps() {
        return this._maps;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $f7cb452bf977726e$export$f5f785078011b62(this._maps, this.mirror, from, to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        if (!this.ownData) {
            this._maps = this._maps.slice();
            this.mirror = this.mirror && this.mirror.slice();
            this.ownData = true;
        }
        this.to = this._maps.push(map);
        if (mirrors != null) this.setMirror(this._maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this._maps.length; i < mapping._maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping._maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this._maps.length + mapping._maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping._maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $f7cb452bf977726e$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this._maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this._maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this._maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $f7cb452bf977726e$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $f7cb452bf977726e$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $f7cb452bf977726e$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $f7cb452bf977726e$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $f7cb452bf977726e$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $f7cb452bf977726e$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $f7cb452bf977726e$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $f7cb452bf977726e$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $f7cb452bf977726e$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $f7cb452bf977726e$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $f7cb452bf977726e$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $9Jwkl.ReplaceError)) return $f7cb452bf977726e$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $f7cb452bf977726e$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($f7cb452bf977726e$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $9Jwkl.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $f7cb452bf977726e$export$d24ba56b0e3464a9 extends $f7cb452bf977726e$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $9Jwkl.Slice)($f7cb452bf977726e$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $f7cb452bf977726e$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $f7cb452bf977726e$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $f7cb452bf977726e$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $f7cb452bf977726e$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $f7cb452bf977726e$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $f7cb452bf977726e$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$f7cb452bf977726e$export$fd55ce593607084a.jsonID("addMark", $f7cb452bf977726e$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $f7cb452bf977726e$export$94150db1311f67a9 extends $f7cb452bf977726e$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $9Jwkl.Slice)($f7cb452bf977726e$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $f7cb452bf977726e$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $f7cb452bf977726e$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $f7cb452bf977726e$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $f7cb452bf977726e$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $f7cb452bf977726e$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $f7cb452bf977726e$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$f7cb452bf977726e$export$fd55ce593607084a.jsonID("removeMark", $f7cb452bf977726e$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $f7cb452bf977726e$export$adefd16c402fee4e extends $f7cb452bf977726e$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $f7cb452bf977726e$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $f7cb452bf977726e$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $9Jwkl.Slice)((0, $9Jwkl.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $f7cb452bf977726e$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $f7cb452bf977726e$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $f7cb452bf977726e$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $f7cb452bf977726e$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $f7cb452bf977726e$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$f7cb452bf977726e$export$fd55ce593607084a.jsonID("addNodeMark", $f7cb452bf977726e$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $f7cb452bf977726e$export$fdf7d1dc10724da2 extends $f7cb452bf977726e$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $f7cb452bf977726e$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $f7cb452bf977726e$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $9Jwkl.Slice)((0, $9Jwkl.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $f7cb452bf977726e$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $f7cb452bf977726e$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $f7cb452bf977726e$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$f7cb452bf977726e$export$fd55ce593607084a.jsonID("removeNodeMark", $f7cb452bf977726e$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $f7cb452bf977726e$export$5c860b2e74034756 extends $f7cb452bf977726e$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $f7cb452bf977726e$var$contentBetween(doc, this.from, this.to)) return $f7cb452bf977726e$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $f7cb452bf977726e$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $f7cb452bf977726e$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $f7cb452bf977726e$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $f7cb452bf977726e$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice, this.structure);
    }
    merge(other) {
        if (!(other instanceof $f7cb452bf977726e$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $9Jwkl.Slice).empty : new (0, $9Jwkl.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $f7cb452bf977726e$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $9Jwkl.Slice).empty : new (0, $9Jwkl.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $f7cb452bf977726e$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $f7cb452bf977726e$export$5c860b2e74034756(json.from, json.to, (0, $9Jwkl.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
}
$f7cb452bf977726e$export$fd55ce593607084a.jsonID("replace", $f7cb452bf977726e$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $f7cb452bf977726e$export$444ba800d6024a98 extends $f7cb452bf977726e$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($f7cb452bf977726e$var$contentBetween(doc, this.from, this.gapFrom) || $f7cb452bf977726e$var$contentBetween(doc, this.gapTo, this.to))) return $f7cb452bf977726e$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $f7cb452bf977726e$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $f7cb452bf977726e$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $f7cb452bf977726e$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $f7cb452bf977726e$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $f7cb452bf977726e$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $f7cb452bf977726e$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $f7cb452bf977726e$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $9Jwkl.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$f7cb452bf977726e$export$fd55ce593607084a.jsonID("replaceAround", $f7cb452bf977726e$export$444ba800d6024a98);
function $f7cb452bf977726e$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $f7cb452bf977726e$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $f7cb452bf977726e$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $f7cb452bf977726e$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $f7cb452bf977726e$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $9Jwkl.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $f7cb452bf977726e$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $f7cb452bf977726e$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $f7cb452bf977726e$export$5c860b2e74034756(cur, end, (0, $9Jwkl.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $f7cb452bf977726e$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $9Jwkl.Slice)((0, $9Jwkl.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $f7cb452bf977726e$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $9Jwkl.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $9Jwkl.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $f7cb452bf977726e$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $f7cb452bf977726e$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth, contentBefore = 0, contentAfter = 0;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth) + contentBefore, endIndex = range.$to.indexAfter(depth) - contentAfter;
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$f7cb452bf977726e$var$canCut(node, index, endIndex)) break;
        if (index) contentBefore = 1;
        if (endIndex < node.childCount) contentAfter = 1;
    }
    return null;
}
function $f7cb452bf977726e$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $9Jwkl.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $9Jwkl.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $9Jwkl.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $9Jwkl.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $f7cb452bf977726e$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $9Jwkl.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $f7cb452bf977726e$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $f7cb452bf977726e$var$findWrappingOutside(range, nodeType);
    let inner = around && $f7cb452bf977726e$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($f7cb452bf977726e$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($f7cb452bf977726e$var$withAttrs));
}
function $f7cb452bf977726e$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $f7cb452bf977726e$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $f7cb452bf977726e$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $f7cb452bf977726e$var$wrap(tr, range, wrappers) {
    let content = (0, $9Jwkl.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $9Jwkl.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $f7cb452bf977726e$export$444ba800d6024a98(start, end, start, end, new (0, $9Jwkl.Slice)(content, 0, 0), wrappers.length, true));
}
function $f7cb452bf977726e$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $f7cb452bf977726e$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $f7cb452bf977726e$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $f7cb452bf977726e$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $f7cb452bf977726e$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $9Jwkl.Slice)((0, $9Jwkl.Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $f7cb452bf977726e$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $f7cb452bf977726e$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $f7cb452bf977726e$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $f7cb452bf977726e$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $f7cb452bf977726e$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $f7cb452bf977726e$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $9Jwkl.Slice)((0, $9Jwkl.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $f7cb452bf977726e$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $f7cb452bf977726e$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $9Jwkl.Fragment).empty, after = (0, $9Jwkl.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $9Jwkl.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $9Jwkl.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $f7cb452bf977726e$export$5c860b2e74034756(pos, pos, new (0, $9Jwkl.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $f7cb452bf977726e$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $f7cb452bf977726e$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $f7cb452bf977726e$var$canAppendWithSubstitutedLinebreaks(a, b) {
    if (!b.content.size) a.type.compatibleContent(b.type);
    let match = a.contentMatchAt(a.childCount);
    let { linebreakReplacement: linebreakReplacement } = a.type.schema;
    for(let i = 0; i < b.childCount; i++){
        let child = b.child(i);
        let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
        match = match.matchType(type);
        if (!match) return false;
        if (!a.type.allowsMarks(child.marks)) return false;
    }
    return match.validEnd;
}
function $f7cb452bf977726e$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && $f7cb452bf977726e$var$canAppendWithSubstitutedLinebreaks(a, b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $f7cb452bf977726e$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $f7cb452bf977726e$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $f7cb452bf977726e$var$join(tr, pos, depth) {
    let convertNewlines = null;
    let { linebreakReplacement: linebreakReplacement } = tr.doc.type.schema;
    let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
    if (linebreakReplacement && beforeType.inlineContent) {
        let pre = beforeType.whitespace == "pre";
        let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
        if (pre && !supportLinebreak) convertNewlines = false;
        else if (!pre && supportLinebreak) convertNewlines = true;
    }
    let mapFrom = tr.steps.length;
    if (convertNewlines === false) {
        let $after = tr.doc.resolve(pos + depth);
        $f7cb452bf977726e$var$replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
    }
    if (beforeType.inlineContent) $f7cb452bf977726e$var$clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
    let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
    tr.step(new $f7cb452bf977726e$export$5c860b2e74034756(start, mapping.map(pos + depth, -1), (0, $9Jwkl.Slice).empty, true));
    if (convertNewlines === true) {
        let $full = tr.doc.resolve(start);
        $f7cb452bf977726e$var$replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
    }
    return tr;
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $f7cb452bf977726e$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $f7cb452bf977726e$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $f7cb452bf977726e$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $9Jwkl.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($f7cb452bf977726e$var$fitsTrivially($from, $to, slice)) return new $f7cb452bf977726e$export$5c860b2e74034756(from, to, slice);
    return new $f7cb452bf977726e$var$Fitter($from, $to, slice).fit();
}
function $f7cb452bf977726e$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $f7cb452bf977726e$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $9Jwkl.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $9Jwkl.Fragment).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $9Jwkl.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $f7cb452bf977726e$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $f7cb452bf977726e$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $f7cb452bf977726e$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $9Jwkl.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $f7cb452bf977726e$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $9Jwkl.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $f7cb452bf977726e$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $9Jwkl.Slice)($f7cb452bf977726e$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $9Jwkl.Slice)($f7cb452bf977726e$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($f7cb452bf977726e$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $f7cb452bf977726e$var$addToFragment(this.placed, frontierDepth, (0, $9Jwkl.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $9Jwkl.Slice)($f7cb452bf977726e$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $9Jwkl.Slice).empty : new (0, $9Jwkl.Slice)($f7cb452bf977726e$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$f7cb452bf977726e$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $f7cb452bf977726e$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $f7cb452bf977726e$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $f7cb452bf977726e$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $f7cb452bf977726e$var$addToFragment(this.placed, this.depth, (0, $9Jwkl.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $9Jwkl.Fragment).empty, true);
        if (add.childCount) this.placed = $f7cb452bf977726e$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $f7cb452bf977726e$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($f7cb452bf977726e$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $f7cb452bf977726e$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($f7cb452bf977726e$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $f7cb452bf977726e$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $f7cb452bf977726e$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $f7cb452bf977726e$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $9Jwkl.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $f7cb452bf977726e$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$f7cb452bf977726e$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $f7cb452bf977726e$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $f7cb452bf977726e$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $f7cb452bf977726e$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($f7cb452bf977726e$var$fitsTrivially($from, $to, slice)) return tr.step(new $f7cb452bf977726e$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $f7cb452bf977726e$var$coveredDepths($from, $to);
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $f7cb452bf977726e$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $9Jwkl.Slice)($f7cb452bf977726e$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $f7cb452bf977726e$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($f7cb452bf977726e$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $9Jwkl.Fragment).empty, true));
    }
    return fragment;
}
function $f7cb452bf977726e$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $f7cb452bf977726e$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $9Jwkl.Slice)((0, $9Jwkl.Fragment).from(node), 0, 0));
}
function $f7cb452bf977726e$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $f7cb452bf977726e$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1))) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $f7cb452bf977726e$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $f7cb452bf977726e$export$626399c38172f669 extends $f7cb452bf977726e$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $f7cb452bf977726e$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $f7cb452bf977726e$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $9Jwkl.Slice)((0, $9Jwkl.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $f7cb452bf977726e$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $f7cb452bf977726e$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $f7cb452bf977726e$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $f7cb452bf977726e$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$f7cb452bf977726e$export$fd55ce593607084a.jsonID("attr", $f7cb452bf977726e$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $f7cb452bf977726e$export$f50707b396300ac9 extends $f7cb452bf977726e$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $f7cb452bf977726e$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $f7cb452bf977726e$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $f7cb452bf977726e$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $f7cb452bf977726e$export$f50707b396300ac9(json.attr, json.value);
    }
}
$f7cb452bf977726e$export$fd55ce593607084a.jsonID("docAttr", $f7cb452bf977726e$export$f50707b396300ac9);
/**
@internal
*/ let $f7cb452bf977726e$export$88cc3a1dfce48dd3 = class extends Error {
};
$f7cb452bf977726e$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$f7cb452bf977726e$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$f7cb452bf977726e$export$88cc3a1dfce48dd3.prototype.constructor = $f7cb452bf977726e$export$88cc3a1dfce48dd3;
$f7cb452bf977726e$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $f7cb452bf977726e$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $f7cb452bf977726e$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $f7cb452bf977726e$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $9Jwkl.Slice).empty) {
        let step = $f7cb452bf977726e$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $9Jwkl.Slice)((0, $9Jwkl.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $9Jwkl.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $f7cb452bf977726e$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $f7cb452bf977726e$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $f7cb452bf977726e$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $f7cb452bf977726e$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $f7cb452bf977726e$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $f7cb452bf977726e$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $f7cb452bf977726e$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $f7cb452bf977726e$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $f7cb452bf977726e$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $f7cb452bf977726e$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $f7cb452bf977726e$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or all marks of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        let node = this.doc.nodeAt(pos);
        if (!node) throw new RangeError("No node at position " + pos);
        if (mark instanceof (0, $9Jwkl.Mark)) {
            if (mark.isInSet(node.marks)) this.step(new $f7cb452bf977726e$export$fdf7d1dc10724da2(pos, mark));
        } else {
            let set = node.marks, found, steps = [];
            while(found = mark.isInSet(set)){
                steps.push(new $f7cb452bf977726e$export$fdf7d1dc10724da2(pos, found));
                set = found.removeFromSet(set);
            }
            for(let i = steps.length - 1; i >= 0; i--)this.step(steps[i]);
        }
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split (with the outermost nodes coming first).
    */ split(pos, depth = 1, typesAfter) {
        $f7cb452bf977726e$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $f7cb452bf977726e$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $f7cb452bf977726e$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $f7cb452bf977726e$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}

});


parcelRegister("drUcN", function(module, exports) {
$parcel$export(module.exports, "expValEquals", () => $9ca9653566c8c199$export$45abdb3f977b5b14);

var $77PRV = parcelRequire("77PRV");
function $9ca9653566c8c199$export$45abdb3f977b5b14(experimentName, experimentParam, experimentExpectedValue) {
    var experimentDefaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return (0, $77PRV.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, true);
}

});
parcelRegister("77PRV", function(module, exports) {
$parcel$export(module.exports, "expValEqualsInternal", () => $53016be5c91572ba$export$58e581060588c6bb);

var $ISKn7 = parcelRequire("ISKn7");

var $67sOe = parcelRequire("67sOe");

var $aj4TE = parcelRequire("aj4TE");

var $75k6K = parcelRequire("75k6K");
// This internal representation doesn't currently support productKeys
// the way expVal(...) does, this adds temporary support for some keys while
// we determine our preferred approach forward
var $53016be5c91572ba$var$allowsProductKeys = [
    'cc-maui-experiment',
    'cc_maui_create_keyword',
    'cc_maui_create_keyword_aa',
    'platform_use_unicode_emojis'
];
function $53016be5c91572ba$export$58e581060588c6bb(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, experimentExposure) {
    var _editorExperimentsCon, _editorExperimentsCon2;
    if ((0, $75k6K._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $75k6K._overrides)[experimentName] === experimentExpectedValue;
    // If client is not initialized, we compare with the default value
    if (!(0, $ISKn7.default).initializeCompleted()) return experimentDefaultValue === experimentExpectedValue;
    // Typescript is complaining here about accessing the productKeys property
    var experimentKeyName = $53016be5c91572ba$var$allowsProductKeys.includes(experimentName) ? (_editorExperimentsCon = (_editorExperimentsCon2 = (0, $aj4TE.editorExperimentsConfig)[experimentName]) === null || _editorExperimentsCon2 === void 0 || (_editorExperimentsCon2 = _editorExperimentsCon2.productKeys) === null || _editorExperimentsCon2 === void 0 ? void 0 : _editorExperimentsCon2[0, $75k6K._product]) !== null && _editorExperimentsCon !== void 0 ? _editorExperimentsCon : experimentName : experimentName;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $ISKn7.default).getExperimentValue(experimentKeyName, experimentParam, experimentDefaultValue, {
        fireExperimentExposure: experimentExposure
    });
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $ISKn7.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $67sOe.addFeatureFlagAccessed)("".concat(experimentKeyName, ":").concat(experimentParam), experimentValue);
    return experimentValue === experimentExpectedValue;
}

});


parcelRegister("hOwF6", function(module, exports) {
$parcel$export(module.exports, "ExpandBodyProvider", () => $cf80712dfb314584$export$57ea044a2befcf45);
$parcel$export(module.exports, "useExpandBody", () => $cf80712dfb314584$export$40dd974b96ebf5ba);
$parcel$export(module.exports, "withExpandBodyBlock", () => $cf80712dfb314584$export$b4e33946e63ad887);
$parcel$export(module.exports, "mergeExpandBodyText", () => $cf80712dfb314584$export$3099c7a6e9a4b682);

var $5FkrB = parcelRequire("5FkrB");

var $jkJfI = parcelRequire("jkJfI");

var $6qDDD = parcelRequire("6qDDD");
var $cf80712dfb314584$var$ExpandBodyContext = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $cf80712dfb314584$export$57ea044a2befcf45 = $cf80712dfb314584$var$ExpandBodyContext.Provider;
var $cf80712dfb314584$export$40dd974b96ebf5ba = function useExpandBody() {
    return (0, $5FkrB.useContext)($cf80712dfb314584$var$ExpandBodyContext);
};
var $cf80712dfb314584$export$8b49603a5a5ab281 = function ExpandBodyBlock(_ref) {
    var children = _ref.children, searchText = _ref.searchText;
    var body = $cf80712dfb314584$export$40dd974b96ebf5ba();
    if (searchText === undefined || body === null || body.revealed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children);
    return searchText;
};
var $cf80712dfb314584$export$b4e33946e63ad887 = function withExpandBodyBlock(node, ancestors, index, serialized) {
    var parent = ancestors[ancestors.length - 1];
    if (!parent || !(0, $6qDDD.isExpandNode)(parent)) return serialized;
    if (!(0, $jkJfI.isExperimentEnabled)('platform_editor_defer_collapsed_expand_body')) return serialized;
    // `serialized` is only null for a node the renderer has no component for, which a table is not.
    // Such a table falls through to the paths below, which do not reach into it.
    if (node.type.name === 'table' && serialized !== null) {
        var parts = (0, $6qDDD.getTableStandInParts)(node);
        // With no row to keep, one string can stand in for the whole table — the table then renders
        // nothing at all, and its text joins with the blocks either side of it.
        return parts.every(function(part) {
            return typeof part === 'string';
        }) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($cf80712dfb314584$export$8b49603a5a5ab281, {
            key: "expand-body-block-".concat(index),
            searchText: parts.join('')
        }, serialized) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($cf80712dfb314584$export$f62b093160ec006b, {
            key: "expand-body-table-".concat(index),
            node: node
        }, serialized);
    }
    if ((0, $6qDDD.holdsRevealableContent)(node)) return serialized;
    var searchText = (0, $6qDDD.getBlockSearchText)(node);
    if (searchText === undefined) return serialized;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($cf80712dfb314584$export$8b49603a5a5ab281, {
        key: "expand-body-block-".concat(index),
        searchText: searchText
    }, serialized);
};
var $cf80712dfb314584$var$isRow = function isRow(child) {
    return /*#__PURE__*/ (0, $5FkrB.isValidElement)(child) && child.props.nodeType === 'tableRow';
};
/**
 * The rows inside the serialized table, wherever they sit.
 *
 * What the serializer hands over is not reliably the element whose children are the rows. Marks are
 * folded around the node afterwards, and a product's own serializer may wrap the rows themselves —
 * Confluence's progressive renderer wraps every row but the first. Assuming either a depth or a set
 * of direct children means any wrapper added later silently costs the saving, so the rows are found
 * instead by the `nodeType` the serializer puts on every node.
 *
 * Descent stops at each row: a nested table's rows sit inside a row of this one, and would
 * otherwise be counted among them.
 *
 * The count is only a consistency check. `getTableStandInParts` indexes the rows by position, so a
 * partial match cannot be lined up and the table has to render instead.
 */ var $cf80712dfb314584$var$rowsOf = function rowsOf(serialized, rowCount) {
    var rows = [];
    var _collect = function collect(node) {
        (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.toArray(node).forEach(function(child) {
            if (!/*#__PURE__*/ (0, $5FkrB.isValidElement)(child)) return;
            if ($cf80712dfb314584$var$isRow(child)) {
                rows.push(child);
                return;
            }
            _collect(child.props.children);
        });
    };
    _collect(serialized);
    return rows.length === rowCount ? rows : undefined;
};
var $cf80712dfb314584$export$f62b093160ec006b = function ExpandBodyTable(_ref2) {
    var children = _ref2.children, node = _ref2.node;
    var body = $cf80712dfb314584$export$40dd974b96ebf5ba();
    if (body === null || body.revealed) return children;
    var rows = $cf80712dfb314584$var$rowsOf(children, node.childCount);
    if (!rows) {
        // eslint-disable-next-line no-console
        console.info('@atlaskit/renderer: the rows of a table in a collapsed expand were not found, so the table renders in full rather than showing their text');
        return children;
    }
    return (0, $6qDDD.getTableStandInParts)(node).map(function(part) {
        return typeof part === 'string' ? part : /*#__PURE__*/ // A row cannot stand in the page on its own — `<tr>` is only valid inside a table — so it
        // keeps the least table around it that makes the markup valid. None of this is laid out: the
        // body is hidden until the reader or find opens the expand, and opening it renders the real
        // table in place of all this.
        (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("table", {
            key: "expand-body-row-".concat(part)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("tbody", null, rows[part]));
    });
};
/** Whatever the serializer produced for one child: an element, a string, an array of either. */ var $cf80712dfb314584$var$searchTextOf = function searchTextOf(child) {
    return /*#__PURE__*/ (0, $5FkrB.isValidElement)(child) && child.type === $cf80712dfb314584$export$8b49603a5a5ab281 ? child.props.searchText : undefined;
};
var $cf80712dfb314584$export$3099c7a6e9a4b682 = function mergeExpandBodyText(children) {
    // Called for every fragment in the document, and only an expand's body has anything to merge, so
    // leave the array alone unless two neighbours are actually showing text.
    var hasRun = children.some(function(child, index) {
        return index > 0 && $cf80712dfb314584$var$searchTextOf(child) !== undefined && $cf80712dfb314584$var$searchTextOf(children[index - 1]) !== undefined;
    });
    if (!hasRun) return children;
    var merged = [];
    var run = [];
    var endRun = function endRun() {
        if (run.length === 0) return;
        if (run.length === 1) merged.push(run[0]);
        else {
            var _key;
            var text = run.map($cf80712dfb314584$var$searchTextOf).filter(Boolean).join((0, $6qDDD.BLOCK_SEPARATOR));
            // The blocks themselves, not the wrappers around them: nesting the wrappers would show
            // each block's text again inside the joined run.
            var blocks = run.map(function(child) {
                return child.props.children;
            });
            merged.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($cf80712dfb314584$export$8b49603a5a5ab281, {
                key: (_key = run[0].key) !== null && _key !== void 0 ? _key : undefined,
                searchText: text
            }, blocks));
        }
        run = [];
    };
    children.forEach(function(child) {
        if ($cf80712dfb314584$var$searchTextOf(child) === undefined) {
            endRun();
            merged.push(child);
            return;
        }
        run.push(child);
    });
    endRun();
    return merged;
};

});
parcelRegister("6qDDD", function(module, exports) {
$parcel$export(module.exports, "BLOCK_SEPARATOR", () => $4ae3eb1aebf08cd6$export$107fd3c009356079);
$parcel$export(module.exports, "isExpandNode", () => $4ae3eb1aebf08cd6$export$8e4b11a2e791d70a);
$parcel$export(module.exports, "holdsRevealableContent", () => $4ae3eb1aebf08cd6$export$190cd2ff72900fe7);
$parcel$export(module.exports, "getBlockSearchText", () => $4ae3eb1aebf08cd6$export$2228423caf47f74);
$parcel$export(module.exports, "getTableStandInParts", () => $4ae3eb1aebf08cd6$export$e860c2c8391d30bf);

var $4inI8 = parcelRequire("4inI8");
var $4ae3eb1aebf08cd6$export$107fd3c009356079 = ' ';
var $4ae3eb1aebf08cd6$var$asText = function asText(value) {
    return typeof value === 'string' ? value : '';
};
var $4ae3eb1aebf08cd6$var$nestedContentOf = function nestedContentOf(attrs) {
    var _attrs$parameters;
    return attrs === null || attrs === void 0 || (_attrs$parameters = attrs.parameters) === null || _attrs$parameters === void 0 ? void 0 : _attrs$parameters.nestedContent;
};
var $4ae3eb1aebf08cd6$export$8e4b11a2e791d70a = function isExpandNode(node) {
    return node.type.name === 'expand' || node.type.name === 'nestedExpand';
};
/**
 * Reads the text out of raw ADF JSON.
 *
 * Some extensions keep a whole ADF subtree in `attrs.parameters.nestedContent` rather than in their
 * node content. Confluence does this when the authored nesting is deeper than the schema allows —
 * an expand more than two collapsible layers deep, for example. To ProseMirror the extension is a
 * leaf, so walking the node tree never sees that subtree, even though a nested renderer puts it on
 * the page. Recurses, because stashed content often stashes more content of its own.
 */ var $4ae3eb1aebf08cd6$var$_adfEntityText = function adfEntityText(entity) {
    var _entity$content;
    if (!entity) return '';
    var parts = [];
    if (entity.type === 'text') parts.push($4ae3eb1aebf08cd6$var$asText(entity.text));
    var nestedContent = $4ae3eb1aebf08cd6$var$nestedContentOf(entity.attrs);
    if (nestedContent) // Prefer the real subtree over `attrs.text`, which is only a placeholder label for it.
    parts.push($4ae3eb1aebf08cd6$var$_adfEntityText(nestedContent));
    else {
        var _entity$attrs;
        parts.push($4ae3eb1aebf08cd6$var$asText((_entity$attrs = entity.attrs) === null || _entity$attrs === void 0 ? void 0 : _entity$attrs.text));
    }
    (_entity$content = entity.content) === null || _entity$content === void 0 || _entity$content.forEach(function(child) {
        return parts.push($4ae3eb1aebf08cd6$var$_adfEntityText(child));
    });
    return parts.filter(Boolean).join($4ae3eb1aebf08cd6$export$107fd3c009356079);
};
/**
 * `textBetween` skips every leaf node unless its spec declares `leafText`, and no ADF node
 * does — so mentions, emoji, dates and statuses would all be lost. They keep their visible
 * text in attrs, so read it from there.
 */ var $4ae3eb1aebf08cd6$var$leafText = function leafText(leaf) {
    var _leaf$attrs;
    var nestedContent = $4ae3eb1aebf08cd6$var$nestedContentOf(leaf.attrs);
    if (nestedContent) return $4ae3eb1aebf08cd6$var$_adfEntityText(nestedContent);
    return $4ae3eb1aebf08cd6$var$asText((_leaf$attrs = leaf.attrs) === null || _leaf$attrs === void 0 ? void 0 : _leaf$attrs.text);
};
var $4ae3eb1aebf08cd6$var$isRevealable = function isRevealable(node) {
    return $4ae3eb1aebf08cd6$export$8e4b11a2e791d70a(node) || Boolean($4ae3eb1aebf08cd6$var$nestedContentOf(node.attrs));
};
var $4ae3eb1aebf08cd6$var$revealableCache = new WeakMap();
var $4ae3eb1aebf08cd6$export$190cd2ff72900fe7 = function holdsRevealableContent(node) {
    var cached = $4ae3eb1aebf08cd6$var$revealableCache.get(node);
    if (cached !== undefined) return cached;
    var found = $4ae3eb1aebf08cd6$var$isRevealable(node);
    if (!found) node.descendants(function(descendant) {
        if (found) return false;
        found = $4ae3eb1aebf08cd6$var$isRevealable(descendant);
        return !found;
    });
    $4ae3eb1aebf08cd6$var$revealableCache.set(node, found);
    return found;
};
var $4ae3eb1aebf08cd6$var$hasInlineComment = function hasInlineComment(node) {
    return (0, $4inI8.findChildrenByMark)(node, node.type.schema.marks.annotation, true).some(function(annotation) {
        return annotation.node.marks.some(function(mark) {
            return mark.attrs.annotationType === 'inlineComment';
        });
    });
};
/** `null` is a cached "no search text for this node", as distinct from `undefined` for a miss. */ var $4ae3eb1aebf08cd6$var$searchTextCache = new WeakMap();
var $4ae3eb1aebf08cd6$export$2228423caf47f74 = function getBlockSearchText(node) {
    var cached = $4ae3eb1aebf08cd6$var$searchTextCache.get(node);
    if (cached === undefined) {
        cached = $4ae3eb1aebf08cd6$var$hasInlineComment(node) ? // No text, which makes the block render instead. Comment navigation looks through the DOM
        // for the commented text and scrolls to it, so that text has to be a real element —
        // plain text carries no comment marks and cannot stand in for it. Without this, the
        // arrow keys silently skip every comment inside a collapsed expand. We give up the
        // saving for this block on purpose.
        null : // A leaf block is not inside its own range, so `textBetween` would return nothing and its
        // text would be lost — a macro sitting straight in an expand body, for instance.
        node.isLeaf ? $4ae3eb1aebf08cd6$var$leafText(node) : node.textBetween(0, node.content.size, $4ae3eb1aebf08cd6$export$107fd3c009356079, $4ae3eb1aebf08cd6$var$leafText);
        $4ae3eb1aebf08cd6$var$searchTextCache.set(node, cached);
    }
    return cached !== null && cached !== void 0 ? cached : undefined;
};
/**
 * One piece of what a collapsed table shows: either the text of the rows being stood in for, or the
 * index of a row that has to keep rendering.
 */ var $4ae3eb1aebf08cd6$var$tableStandInCache = new WeakMap();
var $4ae3eb1aebf08cd6$export$e860c2c8391d30bf = function getTableStandInParts(table) {
    var cached = $4ae3eb1aebf08cd6$var$tableStandInCache.get(table);
    if (cached !== undefined) return cached;
    var parts = [];
    table.forEach(function(row, _offset, index) {
        var text = $4ae3eb1aebf08cd6$export$190cd2ff72900fe7(row) ? undefined : $4ae3eb1aebf08cd6$export$2228423caf47f74(row);
        if (text === undefined) {
            parts.push(index);
            return;
        }
        var last = parts[parts.length - 1];
        if (typeof last === 'string') {
            parts[parts.length - 1] = "".concat(last).concat($4ae3eb1aebf08cd6$export$107fd3c009356079).concat(text);
            return;
        }
        parts.push(text);
    });
    $4ae3eb1aebf08cd6$var$tableStandInCache.set(table, parts);
    return parts;
};

});
parcelRegister("4inI8", function(module, exports) {
$parcel$export(module.exports, "findParentNodeOfTypeClosestToPos", () => $320b3c5928e77c42$export$8bf0d019bde85d18);
$parcel$export(module.exports, "hasParentNodeOfType", () => $320b3c5928e77c42$export$14f438bb7227ce63);
$parcel$export(module.exports, "findChildrenByType", () => $320b3c5928e77c42$export$96bb9476c7c69f39);
$parcel$export(module.exports, "findChildrenByMark", () => $320b3c5928e77c42$export$c01a9e7ec615e821);
// src/selection.ts

var $cc08P = parcelRequire("cc08P");

var $9Jwkl = parcelRequire("9Jwkl");
var $320b3c5928e77c42$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
        const parent = $320b3c5928e77c42$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $320b3c5928e77c42$var$removeNodeAtPos(parent.pos)(tr);
        return tr;
    };
var $320b3c5928e77c42$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
        if (!Array.isArray(nodeType)) nodeType = [
            nodeType
        ];
        for(let i = 0, count = nodeType.length; i < count; i++){
            const parent = $320b3c5928e77c42$export$1a3a74094b9968e(nodeType[i])(tr.selection);
            if (parent) {
                const newTr = $320b3c5928e77c42$var$replaceNodeAtPos(parent.pos, content)(tr);
                if (newTr !== tr) return newTr;
            }
        }
        return tr;
    };
var $320b3c5928e77c42$export$7d6e4e6663186878 = (tr)=>{
    if ($320b3c5928e77c42$export$a8c1d2c13abf8822(tr.selection)) {
        const from = tr.selection.$from.pos;
        const to = tr.selection.$to.pos;
        return $320b3c5928e77c42$var$cloneTr(tr.delete(from, to));
    }
    return tr;
};
var $320b3c5928e77c42$export$39874bca494f9ba3 = (content)=>(tr)=>{
        if ($320b3c5928e77c42$export$a8c1d2c13abf8822(tr.selection)) {
            const { $from: $from, $to: $to } = tr.selection;
            if (content instanceof (0, $9Jwkl.Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, $9Jwkl.Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $320b3c5928e77c42$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, $cc08P.NodeSelection)(tr.doc.resolve($from.pos))));
        }
        return tr;
    };
var $320b3c5928e77c42$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
        const nextSelection = (0, $cc08P.Selection).findFrom(tr.doc.resolve(position), dir, true);
        if (nextSelection) return tr.setSelection(nextSelection);
        return tr;
    };
var $320b3c5928e77c42$var$isSelectableNode = (node)=>Boolean(node instanceof (0, $9Jwkl.Node) && node.type && node.type.spec.selectable);
var $320b3c5928e77c42$var$shouldSelectNode = (node)=>$320b3c5928e77c42$var$isSelectableNode(node) && node.type.isLeaf;
var $320b3c5928e77c42$var$setSelection = (node, pos, tr)=>{
    if ($320b3c5928e77c42$var$shouldSelectNode(node)) return tr.setSelection(new (0, $cc08P.NodeSelection)(tr.doc.resolve(pos)));
    return $320b3c5928e77c42$export$1df6d14df6b0b758(pos)(tr);
};
var $320b3c5928e77c42$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
        const hasPosition = typeof position === "number";
        const { $from: $from } = tr.selection;
        const $insertPos = hasPosition ? tr.doc.resolve(position) : $320b3c5928e77c42$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        const { parent: parent } = $insertPos;
        if ($320b3c5928e77c42$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
            const oldTr = tr;
            tr = $320b3c5928e77c42$export$39874bca494f9ba3(content)(tr);
            if (oldTr !== tr) return tr;
        }
        if ($320b3c5928e77c42$var$isEmptyParagraph(parent)) {
            const oldTr = tr;
            tr = $320b3c5928e77c42$export$b72cc612b642c071(parent.type, content)(tr);
            if (oldTr !== tr) {
                const pos = $320b3c5928e77c42$var$isSelectableNode(content) ? // for selectable node, selection position would be the position of the replaced parent
                $insertPos.before($insertPos.depth) : $insertPos.pos;
                return $320b3c5928e77c42$var$setSelection(content, pos, tr);
            }
        }
        if ($320b3c5928e77c42$export$b4d1262a40ad21d4($insertPos, content)) {
            tr.insert($insertPos.pos, content);
            const pos = hasPosition ? $insertPos.pos : $320b3c5928e77c42$var$isSelectableNode(content) ? // for atom nodes selection position after insertion is the previous pos
            tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
            return $320b3c5928e77c42$var$cloneTr($320b3c5928e77c42$var$setSelection(content, pos, tr));
        }
        for(let i = $insertPos.depth; i > 0; i--){
            const pos = $insertPos.after(i);
            const $pos = tr.doc.resolve(pos);
            if ($320b3c5928e77c42$export$b4d1262a40ad21d4($pos, content)) {
                tr.insert(pos, content);
                return $320b3c5928e77c42$var$cloneTr($320b3c5928e77c42$var$setSelection(content, pos, tr));
            }
        }
        return tr;
    };
var $320b3c5928e77c42$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
        const parent = $320b3c5928e77c42$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $320b3c5928e77c42$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
        return tr;
    };
var $320b3c5928e77c42$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
        if (!$320b3c5928e77c42$export$a8c1d2c13abf8822(tr.selection)) {
            const parent = $320b3c5928e77c42$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $320b3c5928e77c42$var$cloneTr(tr.setSelection((0, $cc08P.NodeSelection).create(tr.doc, parent.pos)));
        }
        return tr;
    };
var $320b3c5928e77c42$export$ffb1550ab6c3d03c = (tr)=>{
    const position = $320b3c5928e77c42$export$f8088819b1e2c2dc(tr.selection);
    if (typeof position === "number") return $320b3c5928e77c42$var$removeNodeAtPos(position)(tr);
    return tr;
};
// src/helpers.ts
var $320b3c5928e77c42$export$a8c1d2c13abf8822 = (selection)=>{
    return selection instanceof (0, $cc08P.NodeSelection);
};
var $320b3c5928e77c42$var$equalNodeType = (nodeType, node)=>{
    return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};
var $320b3c5928e77c42$var$cloneTr = (tr)=>{
    return Object.assign(Object.create(tr), tr).setTime(Date.now());
};
var $320b3c5928e77c42$var$replaceNodeAtPos = (position, content)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        const $pos = tr.doc.resolve(position);
        if (!node) return tr;
        if ($320b3c5928e77c42$var$canReplace($pos, content)) {
            tr = tr.replaceWith(position, position + node.nodeSize, content);
            const start = tr.selection.$from.pos - 1;
            tr = $320b3c5928e77c42$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
            tr = $320b3c5928e77c42$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
            return $320b3c5928e77c42$var$cloneTr(tr);
        }
        return tr;
    };
var $320b3c5928e77c42$var$canReplace = ($pos, content)=>{
    const node = $pos.node($pos.depth);
    return node && node.type.validContent(content instanceof (0, $9Jwkl.Fragment) ? content : (0, $9Jwkl.Fragment).from(content));
};
var $320b3c5928e77c42$var$removeNodeAtPos = (position)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        if (!node) return tr;
        return $320b3c5928e77c42$var$cloneTr(tr.delete(position, position + node.nodeSize));
    };
var $320b3c5928e77c42$export$b4d1262a40ad21d4 = ($pos, content)=>{
    const index = $pos.index();
    if (content instanceof (0, $9Jwkl.Fragment)) return $pos.parent.canReplace(index, index, content);
    else if (content instanceof (0, $9Jwkl.Node)) return $pos.parent.canReplaceWith(index, index, content.type);
    return false;
};
var $320b3c5928e77c42$var$isEmptyParagraph = (node)=>{
    return !node || node.type.name === "paragraph" && node.nodeSize === 2;
};
// src/selection.ts
var $320b3c5928e77c42$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
        if (validateSameParent && !$from.sameParent($to)) {
            let depth = Math.min($from.depth, $to.depth);
            while(depth >= 0){
                const fromNode = $from.node(depth);
                const toNode = $to.node(depth);
                if (toNode === fromNode) {
                    if (predicate(fromNode)) return {
                        // Return the resolved pos
                        pos: depth > 0 ? $from.before(depth) : 0,
                        start: $from.start(depth),
                        depth: depth,
                        node: fromNode
                    };
                }
                depth = depth - 1;
            }
            return;
        }
        return $320b3c5928e77c42$export$fe09644e3bc6166b($from, predicate);
    };
var $320b3c5928e77c42$export$fe09644e3bc6166b = ($pos, predicate)=>{
    for(let i = $pos.depth; i > 0; i--){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
};
var $320b3c5928e77c42$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
        const parent = $320b3c5928e77c42$export$dc159056ffdb4c76(predicate)(selection);
        if (parent) return $320b3c5928e77c42$export$666ce65defe9ad6e(parent.pos, domAtPos);
    };
var $320b3c5928e77c42$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
        return !!$320b3c5928e77c42$export$dc159056ffdb4c76(predicate)(selection);
    };
var $320b3c5928e77c42$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
        return $320b3c5928e77c42$export$dc159056ffdb4c76((node)=>$320b3c5928e77c42$var$equalNodeType(nodeType, node))(selection);
    };
var $320b3c5928e77c42$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
    return $320b3c5928e77c42$export$fe09644e3bc6166b($pos, (node)=>$320b3c5928e77c42$var$equalNodeType(nodeType, node));
};
var $320b3c5928e77c42$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
        return $320b3c5928e77c42$export$178ecaf80f45fdb6((node)=>$320b3c5928e77c42$var$equalNodeType(nodeType, node))(selection);
    };
var $320b3c5928e77c42$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
        return $320b3c5928e77c42$export$8556d79fa8189214((node)=>$320b3c5928e77c42$var$equalNodeType(nodeType, node), domAtPos)(selection);
    };
var $320b3c5928e77c42$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
        if ($320b3c5928e77c42$export$a8c1d2c13abf8822(selection)) {
            const { node: node, $from: $from } = selection;
            if ($320b3c5928e77c42$var$equalNodeType(nodeType, node)) return {
                node: node,
                start: $from.start(),
                pos: $from.pos,
                depth: $from.depth
            };
        }
    };
var $320b3c5928e77c42$export$f8088819b1e2c2dc = (selection)=>{
    const { nodeBefore: nodeBefore } = selection.$from;
    const maybeSelection = (0, $cc08P.Selection).findFrom(selection.$from, -1);
    if (maybeSelection && nodeBefore) {
        const parent = $320b3c5928e77c42$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
        if (parent) return parent.pos;
        return maybeSelection.$from.pos;
    }
};
var $320b3c5928e77c42$export$666ce65defe9ad6e = (position, domAtPos)=>{
    const dom = domAtPos(position);
    const node = dom.node.childNodes[dom.offset];
    if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
    if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
    return node;
};
// src/node.ts
var $320b3c5928e77c42$export$bffa455ba8c619a6 = (node, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    const result = [];
    node.descendants((child, pos)=>{
        result.push({
            node: child,
            pos: pos
        });
        if (!descend) return false;
    });
    return result;
};
var $320b3c5928e77c42$export$f94ca194e830789c = (node, predicate, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    else if (!predicate) throw new Error('Invalid "predicate" parameter');
    return $320b3c5928e77c42$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
};
var $320b3c5928e77c42$export$53418710fbc2d8cc = (node, descend = true)=>{
    return $320b3c5928e77c42$export$f94ca194e830789c(node, (child)=>child.isText, descend);
};
var $320b3c5928e77c42$export$ddc1620722e25671 = (node, descend = true)=>{
    return $320b3c5928e77c42$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
};
var $320b3c5928e77c42$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
    return $320b3c5928e77c42$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
};
var $320b3c5928e77c42$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
    return $320b3c5928e77c42$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
};
var $320b3c5928e77c42$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
    return $320b3c5928e77c42$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
};
var $320b3c5928e77c42$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
    return $320b3c5928e77c42$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
};
var $320b3c5928e77c42$export$2344b14b097df817 = (node, nodeType)=>{
    return !!$320b3c5928e77c42$export$96bb9476c7c69f39(node, nodeType).length;
};

});



parcelRegister("9F9pG", function(module, exports) {
$parcel$export(module.exports, "getText", () => $708f3ea6d303159c$export$c72d34660a162238);
$parcel$export(module.exports, "getEventHandler", () => $708f3ea6d303159c$export$eee20638634729b3);
$parcel$export(module.exports, "findInTree", () => $708f3ea6d303159c$export$38b61ebf4950cd39);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kYLlQ = parcelRequire("kYLlQ");

var $4i2rC = parcelRequire("4i2rC");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $708f3ea6d303159c$var$createEncoder(parser, encoder) {
    return function(value) {
        return encoder.encode(parser.parse(value));
    };
}
var $708f3ea6d303159c$export$bcf771b83128eae7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function ADFEncoder(createTransformerWithSchema) {
    (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ADFEncoder);
    var transformer = createTransformerWithSchema((0, $kYLlQ.defaultSchema));
    this.encode = $708f3ea6d303159c$var$createEncoder(transformer, new (0, $4i2rC.JSONTransformer)());
});
var $708f3ea6d303159c$export$c72d34660a162238 = function getText(node) {
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || "[".concat(typeof node.type === 'string' ? node.type : node.type.name, "]");
};
var $708f3ea6d303159c$export$eee20638634729b3 = function getEventHandler(eventHandlers, type) {
    var eventName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'onClick';
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
};
function $708f3ea6d303159c$export$38b61ebf4950cd39(element, topElement, evaluate) {
    if (element === topElement) return false;
    if (evaluate(element)) return true;
    if (!element.parentElement) return false;
    return $708f3ea6d303159c$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
}

});
parcelRegister("4i2rC", function(module, exports) {
$parcel$export(module.exports, "JSONTransformer", () => $31fabd424d7f1082$export$98cb1d9308d0944d);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $bTFoW = parcelRequire("bTFoW");

var $kYLlQ = parcelRequire("kYLlQ");

var $cpxic = parcelRequire("cpxic");

var $gJXah = parcelRequire("gJXah");
var $31fabd424d7f1082$var$createDocFromContent = function createDocFromContent(content) {
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
var $31fabd424d7f1082$var$emptyDoc = $31fabd424d7f1082$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
var $31fabd424d7f1082$export$98cb1d9308d0944d = /*#__PURE__*/ function() {
    /**
   * Creates a new JSONTransformer instance.
   * @param schema The current editor schema
   * @param mentionMap An optional mapping of user IDs to mention names. This is used by the encoder to substitute empty
   * mention node.attr.text values with mapped names.
   */ function JSONTransformer() {
        var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $kYLlQ.defaultSchema);
        var mentionMap = arguments.length > 1 ? arguments[1] : undefined;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, JSONTransformer);
        this.schema = schema;
        this.mentionMap = mentionMap;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(JSONTransformer, [
        {
            key: "encode",
            value: function encode(node) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var content = [];
                node.content.forEach(function(child) {
                    content.push((0, $cpxic.sanitizeNode)((0, $gJXah.toJSON)(child, _this.mentionMap), options));
                });
                if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($bTFoW)))(content, $31fabd424d7f1082$var$emptyDoc.content)) return $31fabd424d7f1082$var$createDocFromContent([]);
                return $31fabd424d7f1082$var$createDocFromContent(content);
            }
        },
        {
            key: "internalParse",
            value: function internalParse(content, schema) {
                var doc = schema.nodeFromJSON(content);
                doc.check();
                return doc;
            }
        },
        {
            key: "parse",
            value: function parse(content, stage) {
                if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
                var schema = !!stage ? (0, $kYLlQ.getSchemaBasedOnStage)(stage) : this.schema;
                if (!content.content || content.content.length === 0) return this.internalParse($31fabd424d7f1082$var$emptyDoc, schema);
                return this.internalParse(content, schema);
            }
        },
        {
            key: "encodeNode",
            value: function encodeNode(node) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return (0, $cpxic.sanitizeNode)((0, $gJXah.toJSON)(node, this.mentionMap), options);
            }
        }
    ]);
}();

});
parcelRegister("bTFoW", function(module, exports) {

var $ca8FL = parcelRequire("ca8FL");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $8a94f231e336fe73$var$isEqual(value, other) {
    return $ca8FL(value, other);
}
module.exports = $8a94f231e336fe73$var$isEqual;

});

parcelRegister("cpxic", function(module, exports) {
$parcel$export(module.exports, "sanitizeNode", () => $9091a507380c0122$export$48b382180baf8e88);

var $25nEq = parcelRequire("25nEq");

var $4JYPw = parcelRequire("4JYPw");

var $kbnxS = parcelRequire("kbnxS");

var $7rzIl = parcelRequire("7rzIl");

var $f8NMJ = parcelRequire("f8NMJ");
function $9091a507380c0122$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9091a507380c0122$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9091a507380c0122$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9091a507380c0122$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9091a507380c0122$var$hasNestedTable = function hasNestedTable(tableCellNode) {
    var _tableCellNode$conten;
    return (_tableCellNode$conten = tableCellNode.content) === null || _tableCellNode$conten === void 0 ? void 0 : _tableCellNode$conten.some(function(node) {
        return (node === null || node === void 0 ? void 0 : node.type) === 'table';
    });
};
function $9091a507380c0122$export$48b382180baf8e88(json) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$keepNestedTa = options.keepNestedTables, keepNestedTables = _options$keepNestedTa === void 0 ? false : _options$keepNestedTa;
    var sanitizedJSON = (0, $kbnxS.traverse)(json, {
        text: function text(node) {
            if (!node || !Array.isArray(node.marks)) return node;
            return $9091a507380c0122$var$_objectSpread($9091a507380c0122$var$_objectSpread({}, node), {}, {
                marks: node.marks.filter(function(mark) {
                    return mark.type !== 'typeAheadQuery';
                })
            });
        },
        status: function status(node) {
            if (node.attrs && !!node.attrs.text) return (0, $f8NMJ.removeNonAnnotationMarks)(node);
            return false; // empty status
        },
        caption: function caption(node) {
            if (node.content) return node;
            return false; // empty caption
        },
        tableCell: function tableCell(node) {
            if ($9091a507380c0122$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $4JYPw.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        tableHeader: function tableHeader(node) {
            if ($9091a507380c0122$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $4JYPw.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        panel_c1: function panel_c1(node) {
            return $9091a507380c0122$var$_objectSpread($9091a507380c0122$var$_objectSpread({}, node), {}, {
                type: 'panel'
            });
        },
        emoji: (0, $f8NMJ.removeNonAnnotationMarks),
        mention: (0, $f8NMJ.removeNonAnnotationMarks),
        date: (0, $f8NMJ.removeNonAnnotationMarks),
        hardBreak: (0, $7rzIl.removeMarks),
        inlineCard: (0, $f8NMJ.removeNonAnnotationMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("4JYPw", function(module, exports) {
$parcel$export(module.exports, "transformNestedTableNodeOutgoingDocument", () => $373a8cf7d0d88cfe$export$8a334a7d9fe120ec);

var $25nEq = parcelRequire("25nEq");

var $5jTpu = parcelRequire("5jTpu");

var $PcCHT = parcelRequire("PcCHT");

var $9pttu = parcelRequire("9pttu");
function $373a8cf7d0d88cfe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $373a8cf7d0d88cfe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $373a8cf7d0d88cfe$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $373a8cf7d0d88cfe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $373a8cf7d0d88cfe$export$8a334a7d9fe120ec = function transformNestedTableNodeOutgoingDocument(tableCellNode) {
    try {
        var _tableCellNode$conten;
        return $373a8cf7d0d88cfe$var$_objectSpread($373a8cf7d0d88cfe$var$_objectSpread({}, tableCellNode), {}, {
            content: (_tableCellNode$conten = tableCellNode.content) === null || _tableCellNode$conten === void 0 ? void 0 : _tableCellNode$conten.map(function(childNode) {
                // wrap nested table in an extension node
                if ((childNode === null || childNode === void 0 ? void 0 : childNode.type) === 'table') return (0, $5jTpu.extension)({
                    extensionType: (0, $9pttu.NESTED_TABLE_EXTENSION_TYPE),
                    extensionKey: (0, $9pttu.NESTED_TABLE_EXTENSION_KEY),
                    parameters: {
                        adf: JSON.stringify({
                            type: 'doc',
                            version: 1,
                            content: [
                                childNode
                            ]
                        })
                    }
                });
                return childNode;
            })
        });
    } catch (e) {
        throw new (0, $PcCHT.NodeNestingTransformError)('Failed to encode nested table node');
    }
};

});
parcelRegister("5jTpu", function(module, exports) {
$parcel$export(module.exports, "extension", () => $3df9b56222c8dac6$export$1b45514b112dd749);
var $3df9b56222c8dac6$export$1b45514b112dd749 = function extension(attrs) {
    return {
        type: 'extension',
        attrs: attrs
    };
};

});

parcelRegister("PcCHT", function(module, exports) {
$parcel$export(module.exports, "NodeNestingTransformError", () => $099e8e42c6716d6b$export$3d8e8d2182f13924);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $099e8e42c6716d6b$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $099e8e42c6716d6b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $099e8e42c6716d6b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($099e8e42c6716d6b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $099e8e42c6716d6b$export$3d8e8d2182f13924 = /*#__PURE__*/ function(_Error) {
    /**
   * @param message - Error message - Do not use any UGC in this message
   */ function NodeNestingTransformError(message) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NodeNestingTransformError);
        _this = $099e8e42c6716d6b$var$_callSuper(this, NodeNestingTransformError, [
            message
        ]);
        _this.name = 'NodeNestingTransformError';
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NodeNestingTransformError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NodeNestingTransformError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});

parcelRegister("9pttu", function(module, exports) {
$parcel$export(module.exports, "NESTED_TABLE_EXTENSION_TYPE", () => $6d9d4fe5cf9464fd$export$3b760d14ce8127a2);
$parcel$export(module.exports, "NESTED_TABLE_EXTENSION_KEY", () => $6d9d4fe5cf9464fd$export$f45f8b42c24922c1);



var $4JYPw = parcelRequire("4JYPw");
var $6d9d4fe5cf9464fd$export$3b760d14ce8127a2 = 'com.atlassian.confluence.migration', $6d9d4fe5cf9464fd$export$f45f8b42c24922c1 = 'nested-table';

});


parcelRegister("kbnxS", function(module, exports) {
$parcel$export(module.exports, "traverse", () => $eb171955d7e73573$export$df3f009e3d155b20);

var $25nEq = parcelRequire("25nEq");

var $ddGqI = parcelRequire("ddGqI");
function $eb171955d7e73573$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eb171955d7e73573$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eb171955d7e73573$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eb171955d7e73573$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $eb171955d7e73573$export$df3f009e3d155b20(adf, visitors) {
    if (!(0, $ddGqI.validateVisitors)(visitors)) throw new Error("Visitors are not valid: \"".concat(Object.keys(visitors).join(', '), "\""));
    return $eb171955d7e73573$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $eb171955d7e73573$var$traverseNode(adfNode, parent, visitors, index, depth) {
    var visitor = visitors[adfNode.type] || visitors['any'];
    var newNode = $eb171955d7e73573$var$_objectSpread({}, adfNode);
    if (visitor) {
        var processedNode = visitor($eb171955d7e73573$var$_objectSpread({}, newNode), parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce(function(acc, node, idx) {
        if (!node) return acc;
        var processedNode = $eb171955d7e73573$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});
parcelRegister("ddGqI", function(module, exports) {
$parcel$export(module.exports, "validateVisitors", () => $99fd66f07937fd09$export$735cfea22ce30f58);
function $99fd66f07937fd09$export$735cfea22ce30f58(_visitors) {
    return true;
}

});


parcelRegister("7rzIl", function(module, exports) {
$parcel$export(module.exports, "removeMarks", () => $56b6c22177910998$export$9bf001d8ef76e497);

var $25nEq = parcelRequire("25nEq");

function $56b6c22177910998$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $56b6c22177910998$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $56b6c22177910998$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $56b6c22177910998$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $56b6c22177910998$export$9bf001d8ef76e497(node) {
    var newNode = $56b6c22177910998$var$_objectSpread({}, node);
    delete newNode.marks;
    return newNode;
}

});

parcelRegister("f8NMJ", function(module, exports) {
$parcel$export(module.exports, "removeNonAnnotationMarks", () => $b05e38a50e9d4c29$export$8cae9126fc577085);

var $25nEq = parcelRequire("25nEq");
function $b05e38a50e9d4c29$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b05e38a50e9d4c29$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b05e38a50e9d4c29$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b05e38a50e9d4c29$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b05e38a50e9d4c29$export$8cae9126fc577085(node) {
    var newNode = $b05e38a50e9d4c29$var$_objectSpread({}, node);
    if (node.marks) newNode.marks = node.marks.filter(function(mark) {
        return mark.type === 'annotation';
    });
    return newNode;
}

});


parcelRegister("gJXah", function(module, exports) {
$parcel$export(module.exports, "toJSON", () => $c2febe2f553ef5c3$export$54fd2c36b5cc6731);

var $ekGgq = parcelRequire("ekGgq");

var $1Vcia = parcelRequire("1Vcia");

var $25nEq = parcelRequire("25nEq");

var $fkqjY = parcelRequire("fkqjY");

var $enrSO = parcelRequire("enrSO");

var $2InDy = parcelRequire("2InDy");

var $4eHHu = parcelRequire("4eHHu");

var $iDfRT = parcelRequire("iDfRT");

var $kZNkK = parcelRequire("kZNkK");

var $gc8Zd = parcelRequire("gc8Zd");

var $eQlOO = parcelRequire("eQlOO");

var $69D6c = parcelRequire("69D6c");

var $PTaSg = parcelRequire("PTaSg");
function $c2febe2f553ef5c3$var$_toPropertyKey(t) {
    var i = $c2febe2f553ef5c3$var$_toPrimitive(t, "string");
    return "symbol" == (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(i) ? i : i + "";
}
function $c2febe2f553ef5c3$var$_toPrimitive(t, r) {
    if ("object" != (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c2febe2f553ef5c3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c2febe2f553ef5c3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c2febe2f553ef5c3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c2febe2f553ef5c3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c2febe2f553ef5c3$var$isType = function isType(type) {
    return function(node) {
        return node.type.name === type;
    };
};
// Create a Set of node types that should have empty attrs removed
var $c2febe2f553ef5c3$var$NODES_WITH_EMPTY_ATTRS_REMOVAL = new Set([
    'paragraph',
    'layoutSection',
    'blockquote',
    'nestedExpand',
    'bulletList',
    'listItem',
    'orderedList',
    'rule',
    'caption',
    'tableRow',
    'media',
    'mediaSingle',
    'mediaInline'
]);
var $c2febe2f553ef5c3$var$isCodeBlock = $c2febe2f553ef5c3$var$isType('codeBlock');
var $c2febe2f553ef5c3$var$isMediaNode = $c2febe2f553ef5c3$var$isType('media');
var $c2febe2f553ef5c3$var$isMediaInline = $c2febe2f553ef5c3$var$isType('mediaInline');
var $c2febe2f553ef5c3$var$isMediaSingleNode = $c2febe2f553ef5c3$var$isType('mediaSingle');
var $c2febe2f553ef5c3$var$isMentionNode = $c2febe2f553ef5c3$var$isType('mention');
var $c2febe2f553ef5c3$var$isParagraph = $c2febe2f553ef5c3$var$isType('paragraph');
var $c2febe2f553ef5c3$var$isHeading = $c2febe2f553ef5c3$var$isType('heading');
var $c2febe2f553ef5c3$var$isTable = $c2febe2f553ef5c3$var$isType('table');
var $c2febe2f553ef5c3$var$isTableCell = $c2febe2f553ef5c3$var$isType('tableCell');
var $c2febe2f553ef5c3$var$isTableHeader = $c2febe2f553ef5c3$var$isType('tableHeader');
var $c2febe2f553ef5c3$var$isLinkMark = $c2febe2f553ef5c3$var$isType('link');
var $c2febe2f553ef5c3$var$isUnsupportedMark = $c2febe2f553ef5c3$var$isType('unsupportedMark');
var $c2febe2f553ef5c3$var$isUnsupportedNodeAttributeMark = $c2febe2f553ef5c3$var$isType('unsupportedNodeAttribute');
var $c2febe2f553ef5c3$var$isExpand = $c2febe2f553ef5c3$var$isType('expand');
var $c2febe2f553ef5c3$var$isNestedExpand = $c2febe2f553ef5c3$var$isType('nestedExpand');
var $c2febe2f553ef5c3$var$isExtensionNode = $c2febe2f553ef5c3$var$isType('extension');
var $c2febe2f553ef5c3$var$isUnsupportedNode = function isUnsupportedNode(node) {
    return $c2febe2f553ef5c3$var$isType('unsupportedBlock')(node) || $c2febe2f553ef5c3$var$isType('unsupportedInline')(node);
};
var $c2febe2f553ef5c3$var$isDataConsumer = $c2febe2f553ef5c3$var$isType('dataConsumer');
var $c2febe2f553ef5c3$var$isFragmentMark = $c2febe2f553ef5c3$var$isType('fragment');
var $c2febe2f553ef5c3$var$isAnnotationMark = $c2febe2f553ef5c3$var$isType('annotation');
var $c2febe2f553ef5c3$var$isAllowedNodeForAnnotation = function isAllowedNodeForAnnotation(node) {
    return !node.type.isBlock || $c2febe2f553ef5c3$var$isMediaNode(node) || $c2febe2f553ef5c3$var$isExtensionNode(node);
};
var $c2febe2f553ef5c3$var$isHardBreak = $c2febe2f553ef5c3$var$isType('hardBreak');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $c2febe2f553ef5c3$var$_filterNull = function filterNull(subject) {
    var output = $c2febe2f553ef5c3$var$_objectSpread({}, subject);
    // eslint-disable-next-line guard-for-in
    for(var key in output){
        var current = output[key];
        if (current === null) {
            var _output = output, unusedKey = _output[key], filteredObj = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_output, [
                key
            ].map($c2febe2f553ef5c3$var$_toPropertyKey));
            output = filteredObj;
        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(current) === 'object' && !Array.isArray(current)) output[key] = $c2febe2f553ef5c3$var$_filterNull(current);
    }
    return output;
};
var $c2febe2f553ef5c3$var$canOverrideMark = function canOverrideMark(mark, existingMarks) {
    if (existingMarks.some(function(e) {
        return mark.attrs.originalValue.type === e.type.name;
    })) return (0, $PTaSg.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
var $c2febe2f553ef5c3$var$getUnwrappedNodeAttributes = function getUnwrappedNodeAttributes(node, mark, obj) {
    var nodeAttributes = node.type.spec.attrs;
    var attributes = $c2febe2f553ef5c3$var$_objectSpread($c2febe2f553ef5c3$var$_objectSpread({}, mark.attrs.unsupported), obj.attrs);
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        var attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return $c2febe2f553ef5c3$var$_objectSpread($c2febe2f553ef5c3$var$_objectSpread({}, attributes), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, mark.attrs.unsupported[key]));
        }
    }
    return attributes;
};
/**
 * Transforms a Prosemirror node into a JSON representation. Compared with
 * native Prosemirror JSON, this representation ensures we have valid ADF attrs.
 *
 * @param node The Prosemirror node to transform.
 * @param mentionMap A map of mention IDs to their display names.
 * @returns The JSON representation of the node.
 */ var $c2febe2f553ef5c3$export$54fd2c36b5cc6731 = function toJSON(node, mentionMap) {
    var obj = {
        type: node.type.name
    };
    if ($c2febe2f553ef5c3$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($c2febe2f553ef5c3$var$isMediaNode(node)) obj.attrs = (0, $69D6c.toJSON)(node).attrs;
    else if ($c2febe2f553ef5c3$var$isMediaSingleNode(node)) obj.attrs = (0, $eQlOO.toJSON)(node).attrs;
    else if ($c2febe2f553ef5c3$var$isMediaInline(node)) obj.attrs = (0, $69D6c.toJSON)(node).attrs;
    else if ($c2febe2f553ef5c3$var$isMentionNode(node)) obj.attrs = (0, $kZNkK.toJSON)(node).attrs;
    else if ($c2febe2f553ef5c3$var$isCodeBlock(node)) obj.attrs = (0, $enrSO.toJSON)(node).attrs;
    else if ($c2febe2f553ef5c3$var$isTable(node)) obj.attrs = (0, $gc8Zd.tableToJSON)(node).attrs;
    else if ($c2febe2f553ef5c3$var$isTableCell(node)) obj.attrs = (0, $gc8Zd.toJSONTableCell)(node).attrs;
    else if ($c2febe2f553ef5c3$var$isTableHeader(node)) obj.attrs = (0, $gc8Zd.toJSONTableHeader)(node).attrs;
    else if ($c2febe2f553ef5c3$var$isExpand(node) || $c2febe2f553ef5c3$var$isNestedExpand(node)) obj.attrs = (0, $4eHHu.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $c2febe2f553ef5c3$var$_filterNull(obj.attrs);
    if ($c2febe2f553ef5c3$var$isMentionNode(node) && mentionMap) {
        var _text, _obj$attrs;
        // If the mentionMap exists and has a name defined then we should use it and prepend @ to the begining of it.
        var name = !!(mentionMap !== null && mentionMap !== void 0 && mentionMap[node.attrs.id]) ? "@".concat(mentionMap[node.attrs.id]) : '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var text = (_text = (_obj$attrs = obj.attrs) === null || _obj$attrs === void 0 ? void 0 : _obj$attrs.text) !== null && _text !== void 0 ? _text : '';
        obj.attrs = $c2febe2f553ef5c3$var$_objectSpread($c2febe2f553ef5c3$var$_objectSpread({}, obj.attrs), {}, {
            // If an explicit text value is set on the mention then that should take priority over the mentionMap value.
            text: !!text ? text : name
        });
    }
    if ($c2febe2f553ef5c3$var$NODES_WITH_EMPTY_ATTRS_REMOVAL.has(node.type.name) && obj.attrs && !Object.keys(obj.attrs).length || $c2febe2f553ef5c3$var$isHardBreak(node)) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach(function(child) {
        obj.content = obj.content || [];
        obj.content.push($c2febe2f553ef5c3$export$54fd2c36b5cc6731(child, mentionMap));
    });
    if ($c2febe2f553ef5c3$var$isParagraph(node) || $c2febe2f553ef5c3$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        var parsedMarks = node.marks.map(function(mark) {
            if ($c2febe2f553ef5c3$var$isAnnotationMark(mark) && !$c2febe2f553ef5c3$var$isAllowedNodeForAnnotation(node)) return null;
            else if ($c2febe2f553ef5c3$var$isUnsupportedMark(mark)) return $c2febe2f553ef5c3$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($c2febe2f553ef5c3$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($c2febe2f553ef5c3$var$isLinkMark(mark)) return (0, $fkqjY.toJSON)(mark);
            else if ($c2febe2f553ef5c3$var$isDataConsumer(mark)) {
                var _serialised$attrs$sou;
                var serialised = (0, $2InDy.toJSON)(mark);
                return !serialised.attrs.sources || ((_serialised$attrs$sou = serialised.attrs.sources) === null || _serialised$attrs$sou === void 0 ? void 0 : _serialised$attrs$sou.length) === 0 ? null : serialised;
            } else if ($c2febe2f553ef5c3$var$isFragmentMark(mark)) {
                var fragmentMark = (0, $iDfRT.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter(function(maybeMark) {
            return maybeMark !== null;
        });
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = (parsedMarks === null || parsedMarks === void 0 ? void 0 : parsedMarks.length) > 0 ? parsedMarks : undefined;
        var nodeAttributeMark = node.marks.find($c2febe2f553ef5c3$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = $c2febe2f553ef5c3$var$_objectSpread({}, $c2febe2f553ef5c3$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj));
    }
    return obj;
};

});
parcelRegister("fkqjY", function(module, exports) {
$parcel$export(module.exports, "toJSON", () => $b28d2420f1de95d7$export$54fd2c36b5cc6731);
var $b28d2420f1de95d7$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
var $b28d2420f1de95d7$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce(function(attrs, key) {
            if ($b28d2420f1de95d7$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    };
};

});

parcelRegister("eQlOO", function(module, exports) {
$parcel$export(module.exports, "toJSON", () => $ace6d8bda33ad7f5$export$54fd2c36b5cc6731);
var $ace6d8bda33ad7f5$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};

});

parcelRegister("69D6c", function(module, exports) {
$parcel$export(module.exports, "toJSON", () => $47b1e9941ea19bea$export$54fd2c36b5cc6731);
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ var $47b1e9941ea19bea$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt',
    'localId'
];
var $47b1e9941ea19bea$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt',
    'localId'
];
var $47b1e9941ea19bea$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter(function(key) {
            return !(key[0] === '_' && key[1] === '_');
        })// eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce(function(obj, key) {
            if (node.attrs.type === 'external' && $47b1e9941ea19bea$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($47b1e9941ea19bea$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};

});

parcelRegister("PTaSg", function(module, exports) {
$parcel$export(module.exports, "markOverrideRuleFor", () => $09bf9004ffa4fc12$export$28e4e3c024cce988);
var $09bf9004ffa4fc12$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: function canOverrideUnsupportedMark() {
        return true;
    }
};
var $09bf9004ffa4fc12$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: function canOverrideUnsupportedMark() {
        return false;
    }
};
var $09bf9004ffa4fc12$export$28e4e3c024cce988 = function markOverrideRuleFor(type) {
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $09bf9004ffa4fc12$var$defaultAllowOverrideBehaviour;
        default:
            return $09bf9004ffa4fc12$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});




parcelRegister("w2fDc", function(module, exports) {
$parcel$export(module.exports, "isAnnotationMark", () => $0604bc4c791a2097$export$855795c145f03402);
$parcel$export(module.exports, "default", () => $0604bc4c791a2097$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $kX1mK = parcelRequire("kX1mK");

var $fpW0x = parcelRequire("fpW0x");
function $0604bc4c791a2097$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0604bc4c791a2097$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0604bc4c791a2097$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0604bc4c791a2097$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0604bc4c791a2097$export$855795c145f03402 = function isAnnotationMark(mark) {
    return mark && mark.type && mark.type.name === 'annotation';
};
var $0604bc4c791a2097$var$AnnotationComponent = function AnnotationComponent(_ref) {
    var id = _ref.id, annotationType = _ref.annotationType, children = _ref.children, dataAttributes = _ref.dataAttributes, _ref$annotationParent = _ref.annotationParentIds, annotationParentIds = _ref$annotationParent === void 0 ? [] : _ref$annotationParent, allowAnnotations = _ref.allowAnnotations, useBlockLevel = _ref.useBlockLevel, isMediaInline = _ref.isMediaInline;
    var data = $0604bc4c791a2097$var$_objectSpread($0604bc4c791a2097$var$_objectSpread({}, dataAttributes), (0, $kX1mK.buildDataAttributes)({
        id: id,
        annotationType: annotationType
    }));
    if (allowAnnotations) return isMediaInline ? /*#__PURE__*/ // Inline comment on mediaInline is not supported as part of comments on media project,
    // hence skip any styling/event handling for annotations on mediaInline.
    // `id` is still needed so that comment view component can be correct positioned
    // when using comment navigation to access comments on mediaInline
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        id: id
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fpW0x.MarkElement), {
        id: id,
        dataAttributes: data,
        annotationParentIds: annotationParentIds,
        annotationType: annotationType,
        useBlockLevel: useBlockLevel
    }, children);
    return(/*#__PURE__*/ // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        id: id
    }, data), children));
};
var $0604bc4c791a2097$export$2e2bcd8739ae039 = $0604bc4c791a2097$var$AnnotationComponent;

});
parcelRegister("fpW0x", function(module, exports) {
$parcel$export(module.exports, "MarkElement", () => $b3962fe9d6209a66$export$f3069f755c1eba0b);

var $5FkrB = parcelRequire("5FkrB");

var $kX1mK = parcelRequire("kX1mK");

var $1xyIw = parcelRequire("1xyIw");

var $gtPYB = parcelRequire("gtPYB");

var $fDwDe = parcelRequire("fDwDe");

var $2pzUn = parcelRequire("2pzUn");

var $71QIw = parcelRequire("71QIw");

var $8vb4Q = parcelRequire("8vb4Q");

var $gn91R = parcelRequire("gn91R");
var $b3962fe9d6209a66$export$f3069f755c1eba0b = function MarkElement(_ref) {
    var annotationParentIds = _ref.annotationParentIds, children = _ref.children, dataAttributes = _ref.dataAttributes, id = _ref.id, useBlockLevel = _ref.useBlockLevel;
    var updateSubscriber = (0, $71QIw.useInlineCommentSubscriberContext)();
    var states = (0, $5FkrB.useContext)((0, $gtPYB.InlineCommentsStateContext));
    var _useHasFocusEvent = (0, $2pzUn.useHasFocusEvent)({
        id: id,
        updateSubscriber: updateSubscriber
    }), hasFocus = _useHasFocusEvent.hasFocus, isHovered = _useHasFocusEvent.isHovered;
    var dataAttributesMemorized = (0, $5FkrB.useMemo)(function() {
        return dataAttributes;
    }, [
        dataAttributes
    ]);
    var _useAnnotationManager = (0, $fDwDe.useAnnotationManagerDispatch)(), dispatch = _useAnnotationManager.dispatch, annotationManager = _useAnnotationManager.annotationManager;
    var onClick = (0, $5FkrB.useCallback)(function(props) {
        if (!updateSubscriber) return;
        if (useBlockLevel) return;
        var eventTarget = props.eventTarget, annotationIds = props.annotationIds;
        if (annotationManager) {
            if (hasFocus) {
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return;
            }
            annotationManager.checkPreemptiveGate().then(function(canSelect) {
                if (canSelect) {
                    // if there is a draft, clear it first
                    annotationManager === null || annotationManager === void 0 || annotationManager.clearDraft();
                    // use setIsAnnotationSelected won't work here if there is a draft in progress
                    // so we need to use dispatch to update the state directly
                    dispatch({
                        type: 'updateAnnotation',
                        data: {
                            id: annotationIds[0],
                            selected: true
                        }
                    });
                    dispatch({
                        type: 'setSelectedMarkRef',
                        data: {
                            markRef: eventTarget
                        }
                    });
                }
            }).catch(function(_error) {
            // TODO: EDITOR-595 - An error occurred while checking the preemptive gate. We should report this error.
            });
        } else updateSubscriber.emit((0, $1xyIw.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: annotationIds,
            eventTarget: eventTarget
        });
    }, [
        updateSubscriber,
        useBlockLevel,
        dispatch,
        annotationManager,
        hasFocus
    ]);
    var activeParentIds = (0, $8vb4Q.useInlineCommentsFilter)({
        annotationIds: annotationParentIds,
        filter: {
            state: (0, $kX1mK.AnnotationMarkStates).ACTIVE
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gn91R.MarkComponent), {
        id: id,
        dataAttributes: dataAttributesMemorized,
        annotationParentIds: activeParentIds,
        onClick: onClick,
        hasFocus: hasFocus,
        isHovered: isHovered,
        state: states[id],
        useBlockLevel: useBlockLevel
    }, children);
};

});
parcelRegister("1xyIw", function(module, exports) {
$parcel$export(module.exports, "AnnotationUpdateEvent", () => $11f3cd9cc2822d28$export$c1c4b33b4e7b1c70);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $gV2pc = parcelRequire("gV2pc");
var $11f3cd9cc2822d28$export$c1c4b33b4e7b1c70 = /*#__PURE__*/ function(AnnotationUpdateEvent) {
    AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["SET_ANNOTATION_HOVERED"] = "SET_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_HOVERED"] = "REMOVE_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
    AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
    return AnnotationUpdateEvent;
}({});
var $11f3cd9cc2822d28$export$7cc60aa9ef845515 = /*#__PURE__*/ function() {
    function AnnotationUpdateEmitter() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnnotationUpdateEmitter);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "emitter", new (0, (/*@__PURE__*/$parcel$interopDefault($gV2pc)))());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnnotationUpdateEmitter, [
        {
            key: "emit",
            value: function emit(event, params) {
                if (typeof params === 'undefined') return this.emitter.emit(event);
                return this.emitter.emit(event, params);
            }
        },
        {
            key: "on",
            value: // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            function on(event, listener) {
                return this.emitter.on(event, listener);
            }
        },
        {
            key: "off",
            value: // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            function off(event, listener) {
                return this.emitter.removeListener(event, listener);
            }
        },
        {
            key: "listeners",
            value: function listeners(event) {
                return this.emitter.listeners(event);
            }
        }
    ]);
}();

});
parcelRegister("gV2pc", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $c513d5e44021461d$var$R = typeof Reflect === 'object' ? Reflect : null;
var $c513d5e44021461d$var$ReflectApply = $c513d5e44021461d$var$R && typeof $c513d5e44021461d$var$R.apply === 'function' ? $c513d5e44021461d$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $c513d5e44021461d$var$ReflectOwnKeys;
if ($c513d5e44021461d$var$R && typeof $c513d5e44021461d$var$R.ownKeys === 'function') $c513d5e44021461d$var$ReflectOwnKeys = $c513d5e44021461d$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $c513d5e44021461d$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $c513d5e44021461d$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $c513d5e44021461d$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $c513d5e44021461d$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $c513d5e44021461d$var$EventEmitter() {
    $c513d5e44021461d$var$EventEmitter.init.call(this);
}
module.exports = $c513d5e44021461d$var$EventEmitter;
module.exports.once = $c513d5e44021461d$var$once;
// Backwards-compat with node 0.10.x
$c513d5e44021461d$var$EventEmitter.EventEmitter = $c513d5e44021461d$var$EventEmitter;
$c513d5e44021461d$var$EventEmitter.prototype._events = undefined;
$c513d5e44021461d$var$EventEmitter.prototype._eventsCount = 0;
$c513d5e44021461d$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $c513d5e44021461d$var$defaultMaxListeners = 10;
function $c513d5e44021461d$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($c513d5e44021461d$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $c513d5e44021461d$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $c513d5e44021461d$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $c513d5e44021461d$var$defaultMaxListeners = arg;
    }
});
$c513d5e44021461d$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$c513d5e44021461d$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $c513d5e44021461d$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $c513d5e44021461d$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $c513d5e44021461d$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$c513d5e44021461d$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $c513d5e44021461d$var$_getMaxListeners(this);
};
$c513d5e44021461d$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $c513d5e44021461d$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $c513d5e44021461d$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$c513d5e44021461d$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $c513d5e44021461d$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $c513d5e44021461d$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $c513d5e44021461d$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $c513d5e44021461d$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$c513d5e44021461d$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $c513d5e44021461d$var$_addListener(this, type, listener, false);
};
$c513d5e44021461d$var$EventEmitter.prototype.on = $c513d5e44021461d$var$EventEmitter.prototype.addListener;
$c513d5e44021461d$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $c513d5e44021461d$var$_addListener(this, type, listener, true);
};
function $c513d5e44021461d$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $c513d5e44021461d$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $c513d5e44021461d$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$c513d5e44021461d$var$EventEmitter.prototype.once = function once(type, listener) {
    $c513d5e44021461d$var$checkListener(listener);
    this.on(type, $c513d5e44021461d$var$_onceWrap(this, type, listener));
    return this;
};
$c513d5e44021461d$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $c513d5e44021461d$var$checkListener(listener);
    this.prependListener(type, $c513d5e44021461d$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$c513d5e44021461d$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $c513d5e44021461d$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $c513d5e44021461d$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$c513d5e44021461d$var$EventEmitter.prototype.off = $c513d5e44021461d$var$EventEmitter.prototype.removeListener;
$c513d5e44021461d$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $c513d5e44021461d$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $c513d5e44021461d$var$unwrapListeners(evlistener) : $c513d5e44021461d$var$arrayClone(evlistener, evlistener.length);
}
$c513d5e44021461d$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $c513d5e44021461d$var$_listeners(this, type, true);
};
$c513d5e44021461d$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $c513d5e44021461d$var$_listeners(this, type, false);
};
$c513d5e44021461d$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $c513d5e44021461d$var$listenerCount.call(emitter, type);
};
$c513d5e44021461d$var$EventEmitter.prototype.listenerCount = $c513d5e44021461d$var$listenerCount;
function $c513d5e44021461d$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$c513d5e44021461d$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $c513d5e44021461d$var$ReflectOwnKeys(this._events) : [];
};
function $c513d5e44021461d$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $c513d5e44021461d$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $c513d5e44021461d$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $c513d5e44021461d$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $c513d5e44021461d$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $c513d5e44021461d$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $c513d5e44021461d$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $c513d5e44021461d$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $c513d5e44021461d$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});


parcelRegister("gtPYB", function(module, exports) {
$parcel$export(module.exports, "ProvidersContext", () => $bff7ac333263fe0d$export$6a26b015ac619737);
$parcel$export(module.exports, "InlineCommentsStateContext", () => $bff7ac333263fe0d$export$aafe46a36ef535ba);

var $5FkrB = parcelRequire("5FkrB");
var $bff7ac333263fe0d$export$6a26b015ac619737 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $bff7ac333263fe0d$export$aafe46a36ef535ba = /*#__PURE__*/ (0, $5FkrB.createContext)({});

});

parcelRegister("fDwDe", function(module, exports) {
$parcel$export(module.exports, "AnnotationManagerProvider", () => $b623cf848f8f071e$export$f21fb05766361bb3);
$parcel$export(module.exports, "useAnnotationManagerState", () => $b623cf848f8f071e$export$654a1fb45487f838);
$parcel$export(module.exports, "useAnnotationManagerDispatch", () => $b623cf848f8f071e$export$12cbbb89fb7702d0);

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $kX1mK = parcelRequire("kX1mK");

var $1xyIw = parcelRequire("1xyIw");

var $lMzAH = parcelRequire("lMzAH");
function $b623cf848f8f071e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b623cf848f8f071e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b623cf848f8f071e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b623cf848f8f071e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b623cf848f8f071e$var$initState = {
    isDrafting: false,
    draftId: undefined,
    draftMarkRef: undefined,
    draftActionResult: undefined,
    annotations: {},
    currentSelectedAnnotationId: undefined,
    currentSelectedMarkRef: undefined,
    currentHoveredAnnotationId: undefined
};
var $b623cf848f8f071e$var$AnnotationManagerStateContext = /*#__PURE__*/ (0, $5FkrB.createContext)($b623cf848f8f071e$var$initState);
var $b623cf848f8f071e$var$AnnotationManagerDispatchContext = /*#__PURE__*/ (0, $5FkrB.createContext)({
    annotationManager: undefined,
    dispatch: function dispatch() {}
});
function $b623cf848f8f071e$var$reducer(state, action) {
    switch(action.type){
        case 'reset':
            return $b623cf848f8f071e$var$_objectSpread($b623cf848f8f071e$var$_objectSpread({}, state), $b623cf848f8f071e$var$initState);
        case 'loadAnnotation':
            var currentIds = Object.keys(state.annotations);
            var uids = Array.from(new Set(currentIds.concat(action.data.map(function(a) {
                return a.id;
            }))));
            var updates = [];
            var _loop = function _loop() {
                var _state$annotations$id, _state$annotations$id2;
                var id = _uids[_i];
                var loadedAnnotation = action.data.find(function(a) {
                    return a.id === id;
                });
                if (!loadedAnnotation && ((_state$annotations$id = state.annotations[id]) === null || _state$annotations$id === void 0 ? void 0 : _state$annotations$id.markState) === (0, $kX1mK.AnnotationMarkStates).ACTIVE) {
                    // If the annotation is not in the loaded data, we need to remove it from the state. However,
                    // rather then removing it, we will set the mark state to resolved. This is to align it better with
                    // how the editor works.
                    updates.push({
                        id: id,
                        markState: (0, $kX1mK.AnnotationMarkStates).RESOLVED
                    });
                    return 0; // continue
                }
                if (!!(loadedAnnotation !== null && loadedAnnotation !== void 0 && loadedAnnotation.markState) && ((_state$annotations$id2 = state.annotations[id]) === null || _state$annotations$id2 === void 0 ? void 0 : _state$annotations$id2.markState) !== loadedAnnotation.markState) {
                    updates.push({
                        id: id,
                        markState: loadedAnnotation.markState
                    });
                    return 0; // continue
                }
            }, _ret;
            for(var _i = 0, _uids = uids; _i < _uids.length; _i++){
                _ret = _loop();
                if (_ret === 0) continue;
            }
            if (updates.length > 0) return $b623cf848f8f071e$var$_objectSpread($b623cf848f8f071e$var$_objectSpread({}, state), {}, {
                annotations: updates.reduce(function(nextAnnotations, update) {
                    return $b623cf848f8f071e$var$_objectSpread($b623cf848f8f071e$var$_objectSpread({}, nextAnnotations), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, update.id, $b623cf848f8f071e$var$_objectSpread($b623cf848f8f071e$var$_objectSpread({}, nextAnnotations[update.id]), update)));
                }, state.annotations)
            });
            return state;
        case 'updateAnnotation':
            var current = state.annotations[action.data.id];
            var _action$data = action.data, id = _action$data.id, selected = _action$data.selected, hovered = _action$data.hovered, _action$data$markStat = _action$data.markState, markState = _action$data$markStat === void 0 ? current === null || current === void 0 ? void 0 : current.markState : _action$data$markStat;
            var _updates = [];
            // If the annotation is not currently in the state, we need to add it to the state.
            if (!current) _updates.push({
                id: id,
                markState: markState !== null && markState !== void 0 ? markState : (0, $kX1mK.AnnotationMarkStates).ACTIVE
            });
            // The goal of the following is to enforce a single selection and a single hover state across all annotations.
            var nextSelectedId = state.currentSelectedAnnotationId;
            if (selected && nextSelectedId !== id) nextSelectedId = id;
            // If the annotation is currently selected and it's being unselected, we need to remove it from the
            // current selected annotation id.
            if (selected === false && nextSelectedId === id) nextSelectedId = undefined;
            var nextHoveredId = state.currentHoveredAnnotationId;
            if (hovered && nextHoveredId !== id) nextHoveredId = id;
            // If the annotation is currently hovered and it's being unhovered, we need to remove it from the
            // current hovered annotation id.
            if (hovered === false && nextHoveredId === id) nextHoveredId = undefined;
            // If the annotations mark state is not the same as the current mark state, we need to update it.
            if ((current === null || current === void 0 ? void 0 : current.markState) !== markState) {
                _updates.push({
                    id: id,
                    markState: markState !== null && markState !== void 0 ? markState : (0, $kX1mK.AnnotationMarkStates).ACTIVE
                });
                // If the annotation is currently selected and it's being resolved, then we need to remove it from the
                // current selected annotation id also.
                if (markState === (0, $kX1mK.AnnotationMarkStates).RESOLVED && nextSelectedId === id) nextSelectedId = undefined;
            }
            if (_updates.length > 0 || nextSelectedId !== state.currentSelectedAnnotationId || nextHoveredId !== state.currentHoveredAnnotationId) return $b623cf848f8f071e$var$_objectSpread($b623cf848f8f071e$var$_objectSpread({}, state), {}, {
                currentSelectedAnnotationId: nextSelectedId,
                currentHoveredAnnotationId: nextHoveredId,
                annotations: _updates.reduce(function(nextAnnotations, update) {
                    return $b623cf848f8f071e$var$_objectSpread($b623cf848f8f071e$var$_objectSpread({}, nextAnnotations), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, update.id, $b623cf848f8f071e$var$_objectSpread($b623cf848f8f071e$var$_objectSpread({}, nextAnnotations[update.id]), update)));
                }, state.annotations)
            });
            return state;
        case 'resetSelectedAnnotation':
            if (state.currentSelectedAnnotationId !== undefined) return $b623cf848f8f071e$var$_objectSpread($b623cf848f8f071e$var$_objectSpread({}, state), {}, {
                currentSelectedAnnotationId: undefined,
                currentSelectedMarkRef: undefined
            });
            return state;
        case 'resetHoveredAnnotation':
            if (state.currentHoveredAnnotationId !== undefined) return $b623cf848f8f071e$var$_objectSpread($b623cf848f8f071e$var$_objectSpread({}, state), {}, {
                currentHoveredAnnotationId: undefined
            });
            return state;
        case 'setDrafting':
            if (state.isDrafting !== action.data.isDrafting || state.draftId !== action.data.draftId || state.draftActionResult !== action.data.draftActionResult) // XXX: When a draft is open the current selected annotation should no longer be selected. We need
            // to decide what is better UX,
            // 1 - do we want to deselct the selected annotation on draft open, if so then when draft is closed the s
            // selected annotation will not come back
            // 2 - do we want to still allow the selected annotation to be selected when draft is open, however the underlying
            // mark style just shows the annotation as not selected when a draft is active. Then when a draft closes
            // we can reopen the previous selected annotation.
            return $b623cf848f8f071e$var$_objectSpread($b623cf848f8f071e$var$_objectSpread({}, state), {}, {
                isDrafting: action.data.isDrafting,
                draftId: action.data.draftId,
                draftActionResult: action.data.draftActionResult
            });
            return state;
        case 'setDraftMarkRef':
            if (state.draftMarkRef !== action.data.draftMarkRef) return $b623cf848f8f071e$var$_objectSpread($b623cf848f8f071e$var$_objectSpread({}, state), {}, {
                draftMarkRef: action.data.draftMarkRef
            });
            return state;
        case 'setSelectedMarkRef':
            if (state.currentSelectedMarkRef !== action.data.markRef) return $b623cf848f8f071e$var$_objectSpread($b623cf848f8f071e$var$_objectSpread({}, state), {}, {
                currentSelectedMarkRef: action.data.markRef
            });
            return state;
    }
}
var $b623cf848f8f071e$export$f21fb05766361bb3 = function AnnotationManagerProvider(_ref) {
    var children = _ref.children, annotationManager = _ref.annotationManager, updateSubscriber = _ref.updateSubscriber;
    var _useReducer = (0, $5FkrB.useReducer)($b623cf848f8f071e$var$reducer, $b623cf848f8f071e$var$initState), _useReducer2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var actionContext = (0, $5FkrB.useContext)((0, $lMzAH.RendererContext));
    (0, $5FkrB.useEffect)(function() {
        var getDraft = function getDraft() {
            var _state$draftActionRes;
            if (!state.isDrafting || !state.draftActionResult || !state.draftMarkRef || !state.draftId) return {
                success: false,
                reason: 'draft-not-started'
            };
            return {
                success: true,
                inlineNodeTypes: (_state$draftActionRes = state.draftActionResult.inlineNodeTypes) !== null && _state$draftActionRes !== void 0 ? _state$draftActionRes : [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            };
        };
        annotationManager === null || annotationManager === void 0 || annotationManager.hook('getDraft', getDraft);
        return function() {
            annotationManager === null || annotationManager === void 0 || annotationManager.unhook('getDraft', getDraft);
        };
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    // We need to watch for the draft mark element to exist, so we can inform any listeners that the draft has been started
    // and give them a reference to the element
    (0, $5FkrB.useEffect)(function() {
        if (state.isDrafting && state.draftId && state.draftMarkRef && state.draftActionResult) {
            var _state$draftActionRes2;
            annotationManager === null || annotationManager === void 0 || annotationManager.emit({
                name: 'draftAnnotationStarted',
                data: {
                    inlineNodeTypes: (_state$draftActionRes2 = state.draftActionResult.inlineNodeTypes) !== null && _state$draftActionRes2 !== void 0 ? _state$draftActionRes2 : [],
                    targetElement: state.draftMarkRef,
                    actionResult: {
                        step: state.draftActionResult.step,
                        doc: state.draftActionResult.doc,
                        inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                        targetNodeType: state.draftActionResult.targetNodeType,
                        originalSelection: state.draftActionResult.originalSelection,
                        numMatches: state.draftActionResult.numMatches,
                        matchIndex: state.draftActionResult.matchIndex,
                        pos: state.draftActionResult.pos
                    }
                }
            });
        }
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    (0, $5FkrB.useEffect)(function() {
        var setIsAnnotationSelected = function setIsAnnotationSelected(id, isSelected) {
            var _state$annotations;
            if (state.isDrafting) return {
                success: false,
                reason: 'draft-in-progress'
            };
            if (!((_state$annotations = state.annotations) !== null && _state$annotations !== void 0 && _state$annotations[id])) return {
                success: false,
                reason: 'id-not-valid'
            };
            // the annotation is currently not selected and is being selected
            if (id !== state.currentSelectedAnnotationId && isSelected) {
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true
                    }
                });
                dispatch({
                    type: 'setSelectedMarkRef',
                    data: {
                        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- resolve mark node by id in the document
                        markRef: document.getElementById(id) || undefined
                    }
                });
            } else if (id === state.currentSelectedAnnotationId && !isSelected) dispatch({
                type: 'resetSelectedAnnotation'
            });
            return {
                success: true,
                isSelected: isSelected
            };
        };
        annotationManager === null || annotationManager === void 0 || annotationManager.hook('setIsAnnotationSelected', setIsAnnotationSelected);
        return function() {
            annotationManager === null || annotationManager === void 0 || annotationManager.unhook('setIsAnnotationSelected', setIsAnnotationSelected);
        };
    }, [
        annotationManager,
        state.isDrafting,
        state.annotations,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    var prevSelectedAnnotationId = (0, $5FkrB.useRef)(undefined);
    (0, $5FkrB.useEffect)(function() {
        if (prevSelectedAnnotationId.current) annotationManager === null || annotationManager === void 0 || annotationManager.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: prevSelectedAnnotationId.current,
                isSelected: false,
                inlineNodeTypes: []
            }
        });
        prevSelectedAnnotationId.current = state.currentSelectedAnnotationId;
    }, [
        state.currentSelectedAnnotationId,
        annotationManager
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (state.currentSelectedAnnotationId && state.currentSelectedMarkRef && state.currentSelectedMarkRef.id === state.currentSelectedAnnotationId) annotationManager === null || annotationManager === void 0 || annotationManager.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: state.currentSelectedAnnotationId,
                isSelected: true,
                inlineNodeTypes: []
            }
        });
    }, [
        annotationManager,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    (0, $5FkrB.useEffect)(function() {
        var setIsAnnotationHovered = function setIsAnnotationHovered(id, isHovered) {
            var _state$annotations2;
            if (!((_state$annotations2 = state.annotations) !== null && _state$annotations2 !== void 0 && _state$annotations2[id])) return {
                success: false,
                reason: 'id-not-valid'
            };
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: id,
                    hovered: isHovered
                }
            });
            return {
                success: true,
                isHovered: isHovered
            };
        };
        annotationManager === null || annotationManager === void 0 || annotationManager.hook('setIsAnnotationHovered', setIsAnnotationHovered);
        return function() {
            annotationManager === null || annotationManager === void 0 || annotationManager.unhook('setIsAnnotationHovered', setIsAnnotationHovered);
        };
    }, [
        annotationManager,
        state.annotations
    ]);
    (0, $5FkrB.useEffect)(function() {
        var clearAnnotation = function clearAnnotation(id) {
            var _state$annotations3;
            if (!((_state$annotations3 = state.annotations) !== null && _state$annotations3 !== void 0 && _state$annotations3[id])) return {
                success: false,
                reason: 'id-not-valid'
            };
            var result = actionContext.deleteAnnotation(id, (0, $kX1mK.AnnotationTypes).INLINE_COMMENT);
            if (!result) return {
                success: false,
                reason: 'clear-failed'
            };
            var step = result.step, doc = result.doc;
            return {
                success: true,
                actionResult: {
                    step: step,
                    doc: doc
                }
            };
        };
        annotationManager === null || annotationManager === void 0 || annotationManager.hook('clearAnnotation', clearAnnotation);
        return function() {
            annotationManager === null || annotationManager === void 0 || annotationManager.unhook('clearAnnotation', clearAnnotation);
        };
    }, [
        annotationManager,
        state.annotations,
        actionContext
    ]);
    /**
   * This is a temporary solution to ensure that the annotation manager state is in sync with the
   * old updateSubscriber. The updateSubscriber will eventually be deprecated and the state will be managed
   * by the annotation manager itself.
   */ (0, $5FkrB.useEffect)(function() {
        var onSetAnnotationState = function onSetAnnotationState(payload) {
            if (!payload) return;
            Object.values(payload).forEach(function(annotation) {
                if (annotation.id && annotation.annotationType === (0, $kX1mK.AnnotationTypes).INLINE_COMMENT) {
                    var _annotation$state;
                    dispatch({
                        type: 'updateAnnotation',
                        data: {
                            id: annotation.id,
                            markState: (_annotation$state = annotation.state) !== null && _annotation$state !== void 0 ? _annotation$state : undefined
                        }
                    });
                }
            });
        };
        var onAnnotationSelected = function onAnnotationSelected(payload) {
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    selected: true
                }
            });
        };
        var onAnnotationHovered = function onAnnotationHovered(payload) {
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    hovered: true
                }
            });
        };
        var onAnnotationSelectedRemoved = function onAnnotationSelectedRemoved() {
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        var onAnnotationHoveredRemoved = function onAnnotationHoveredRemoved() {
            dispatch({
                type: 'resetHoveredAnnotation'
            });
        };
        var onAnnotationClick = function onAnnotationClick(_ref2) {
            var annotationIds = _ref2.annotationIds, eventTarget = _ref2.eventTarget, _eventTargetType = _ref2.eventTargetType, _viewMethod = _ref2.viewMethod;
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: annotationIds[0],
                    selected: true
                }
            });
            dispatch({
                type: 'setSelectedMarkRef',
                data: {
                    markRef: eventTarget
                }
            });
        };
        var onAnnotationDeselect = function onAnnotationDeselect() {
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        return function() {
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        };
    }, [
        updateSubscriber
    ]);
    var dispatchData = (0, $5FkrB.useMemo)(function() {
        return {
            annotationManager: annotationManager,
            dispatch: dispatch
        };
    }, [
        annotationManager,
        dispatch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($b623cf848f8f071e$var$AnnotationManagerStateContext.Provider, {
        value: state
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($b623cf848f8f071e$var$AnnotationManagerDispatchContext.Provider, {
        value: dispatchData
    }, children));
};
var $b623cf848f8f071e$export$654a1fb45487f838 = function useAnnotationManagerState() {
    return (0, $5FkrB.useContext)($b623cf848f8f071e$var$AnnotationManagerStateContext);
};
var $b623cf848f8f071e$export$12cbbb89fb7702d0 = function useAnnotationManagerDispatch() {
    return (0, $5FkrB.useContext)($b623cf848f8f071e$var$AnnotationManagerDispatchContext);
};

});
parcelRegister("lMzAH", function(module, exports) {
$parcel$export(module.exports, "RendererContext", () => $fdb9b0466c2c6c3d$export$1e9ea4edb6d1bfe6);
$parcel$export(module.exports, "RendererActionsContext", () => $fdb9b0466c2c6c3d$export$66feffbad722f9d4);
/* eslint-disable jsdoc/require-jsdoc */ 
var $5FkrB = parcelRequire("5FkrB");

var $6EZ2P = parcelRequire("6EZ2P");

var $bDUuG = parcelRequire("bDUuG");

var $jJH6F = parcelRequire("jJH6F");

var $50U6m = parcelRequire("50U6m");

var $hFyhw = parcelRequire("hFyhw");
var $fdb9b0466c2c6c3d$export$1e9ea4edb6d1bfe6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext(new (0, $hFyhw.default)());
function $fdb9b0466c2c6c3d$export$66feffbad722f9d4(_ref) {
    var children = _ref.children, context = _ref.context;
    var _useAnalyticsEvents = (0, $bDUuG.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var actions = (0, $5FkrB.useMemo)(function() {
        return new (0, $hFyhw.default)(true);
    }, []);
    // Remove this eventually when root cause is assessed
    if ((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.count(children) > 1 && (0, $50U6m.fg)('confluence_frontend_fix_view_page_slo')) // Send event when we get more than 1 child
    try {
        throw new Error('Too many children');
    } catch (e) {
        var _ref2 = e, stack = _ref2.stack;
        createAnalyticsEvent({
            eventType: (0, $jJH6F.EVENT_TYPE).TRACK,
            action: 'rendered',
            actionSubject: 'multipleChildren',
            actionSubjectId: 'rendererActionsContext',
            attributes: {
                numChildren: (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.count(children),
                stackTrace: stack
            }
        }).fire((0, $6EZ2P.FabricChannel).editor);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($fdb9b0466c2c6c3d$export$1e9ea4edb6d1bfe6.Provider, {
        value: context || actions
    }, (0, $50U6m.fg)('confluence_frontend_fix_view_page_slo') ? (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.only(children) : children);
}
var $fdb9b0466c2c6c3d$export$d5fcf151601331bc = $fdb9b0466c2c6c3d$export$1e9ea4edb6d1bfe6.Consumer;

});
parcelRegister("6EZ2P", function(module, exports) {
$parcel$export(module.exports, "FabricChannel", () => $4d95d4b198e6ac0b$export$8faa0b115ef0268b);
var $4d95d4b198e6ac0b$export$8faa0b115ef0268b = /*#__PURE__*/ function(FabricChannel) {
    FabricChannel["a2ui"] = "a2ui";
    FabricChannel["atlaskit"] = "atlaskit";
    FabricChannel["elements"] = "fabric-elements";
    FabricChannel["navigation"] = "navigation";
    FabricChannel["editor"] = "editor";
    FabricChannel["media"] = "media";
    FabricChannel["peopleTeams"] = "peopleTeams";
    FabricChannel["notifications"] = "notifications";
    FabricChannel["recentWork"] = "recentWork";
    FabricChannel["atlas"] = "atlas";
    FabricChannel["crossFlow"] = "crossFlow";
    FabricChannel["linkingPlatform"] = "linkingPlatform";
    FabricChannel["postOffice"] = "postOffice";
    FabricChannel["aiMate"] = "aiMate";
    FabricChannel["avp"] = "avp";
    FabricChannel["growth"] = "growth";
    FabricChannel["omniChannel"] = "omniChannel";
    FabricChannel["townsquareHome"] = "townsquareHome";
    FabricChannel["rovoExtension"] = "rovoExtension";
    FabricChannel["teamworkGraph"] = "teamworkGraph";
    return FabricChannel;
}({});

});

parcelRegister("hFyhw", function(module, exports) {
$parcel$export(module.exports, "default", () => $cdd0db9bf3992173$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $kX1mK = parcelRequire("kX1mK");

var $jJH6F = parcelRequire("jJH6F");

var $ht7Bg = parcelRequire("ht7Bg");

var $4i2rC = parcelRequire("4i2rC");

var $cc08P = parcelRequire("cc08P");

var $lh06P = parcelRequire("lh06P");

var $50U6m = parcelRequire("50U6m");

var $1IPWy = parcelRequire("1IPWy");

var $35DNJ = parcelRequire("35DNJ");

var $7KUde = parcelRequire("7KUde");

var $3qUJT = parcelRequire("3qUJT");
var $cdd0db9bf3992173$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    // Any kind of refence is allowed
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function RendererActions() {
        var initFromContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, RendererActions);
        // This is our psuedo feature flag for now
        // This module can only be used when wrapped with
        // the <RendererContext> component for now.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initFromContext", false);
        this.initFromContext = initFromContext;
        this.transformer = new (0, $4i2rC.JSONTransformer)();
    }
    //#region private
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(RendererActions, [
        {
            key: "_privateRegisterRenderer",
            value: function _privateRegisterRenderer(ref, doc, schema, onAnalyticsEvent) {
                if (!this.initFromContext) return;
                else if (!this.ref) this.ref = ref;
                else if (this.ref !== ref) throw new Error("Renderer has already been registered! It's not allowed to re-register with another new Renderer instance.");
                this.doc = doc;
                this.schema = schema;
                this.onAnalyticsEvent = onAnalyticsEvent;
            }
        },
        {
            key: "_privateUnregisterRenderer",
            value: function _privateUnregisterRenderer() {
                this.doc = undefined;
                this.ref = undefined;
                this.schema = undefined;
            }
        },
        {
            key: "_privateValidatePositionsForAnnotation",
            value: function _privateValidatePositionsForAnnotation(from, to) {
                if (!this.doc || !this.schema) return false;
                var currentSelection = (0, $cc08P.TextSelection).create(this.doc, from, to);
                if ((0, $ht7Bg.isEmptyTextSelectionRenderer)(currentSelection, this.schema)) return false;
                var result = (0, $ht7Bg.canApplyAnnotationOnRange)({
                    from: from,
                    to: to
                }, this.doc, this.schema);
                return result;
            }
        },
        {
            key: "deleteAnnotation",
            value: function deleteAnnotation(annotationId, annotationType) {
                if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
                var mark = this.schema.marks.annotation.create({
                    id: annotationId,
                    annotationType: annotationType
                });
                var from;
                var to;
                var nodePos;
                var step;
                this.doc.descendants(function(node, pos) {
                    var found = mark.isInSet(node.marks);
                    if (found && node.type.name === 'media') nodePos = pos;
                    if (found && !from) {
                        // Set both here incase it only spans one node.
                        from = pos;
                        to = pos + node.nodeSize;
                    } else if (found && from) // If the mark spans multiple nodes,
                    // we'll keep setting the end until no longer found.
                    to = pos + node.nodeSize;
                    return true;
                });
                if (nodePos !== undefined) step = new (0, $lh06P.RemoveNodeMarkStep)(nodePos, mark);
                else {
                    if (from === undefined || to === undefined) return false;
                    step = new (0, $lh06P.RemoveMarkStep)(from, to, mark);
                }
                var _step$apply = step.apply(this.doc), doc = _step$apply.doc, failed = _step$apply.failed;
                if (this.onAnalyticsEvent) {
                    var payload = {
                        action: (0, $jJH6F.ACTION).DELETED,
                        actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANNOTATION,
                        actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).INLINE_COMMENT,
                        eventType: (0, $jJH6F.EVENT_TYPE).TRACK,
                        attributes: {
                            inlineNodeNames: step instanceof (0, $lh06P.RemoveMarkStep) ? (0, $35DNJ.getRendererRangeInlineNodeNames)({
                                // Ignored via go/ees005
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                pos: {
                                    from: from,
                                    to: to
                                },
                                actions: this
                            }) : undefined
                        }
                    };
                    this.onAnalyticsEvent(payload);
                }
                if (!failed && doc) return {
                    step: step,
                    doc: this.transformer.encode(doc)
                };
                return false;
            }
        },
        {
            key: "annotate",
            value: function annotate(range, annotationId, _annotationType) {
                if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
                var pos = (0, $1IPWy.getPosFromRange)(range);
                if (!pos) return false;
                var from = pos.from, to = pos.to;
                var validPositions = this._privateValidatePositionsForAnnotation(from, to);
                if (!validPositions) return false;
                return this.applyAnnotation(pos, {
                    annotationId: annotationId,
                    annotationType: (0, $kX1mK.AnnotationTypes).INLINE_COMMENT
                });
            }
        },
        {
            key: "isValidAnnotationRange",
            value: function isValidAnnotationRange(range) {
                if (!range) return false;
                if ((0, $50U6m.fg)('editor_inline_comments_on_inline_nodes')) {
                    if (this.isRendererWithinRange(range)) return false;
                }
                var pos = (0, $1IPWy.getPosFromRange)(range);
                if (!pos || !this.doc) return false;
                return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
            }
        },
        {
            key: "isRangeAnnotatable",
            value: function isRangeAnnotatable(range) {
                try {
                    var _startContainer$paren, _endContainer$parentE;
                    if (!range) return false;
                    var startContainer = range.startContainer, endContainer = range.endContainer;
                    if ((_startContainer$paren = startContainer.parentElement) !== null && _startContainer$paren !== void 0 && _startContainer$paren.closest('.ak-renderer-extension') || (_endContainer$parentE = endContainer.parentElement) !== null && _endContainer$parentE !== void 0 && _endContainer$parentE.closest('.ak-renderer-extension')) return false;
                    return this.isValidAnnotationRange(range);
                } catch (_unused) {
                    // isValidAnnotationRange can fail when called inside nested renderers.
                    // while isRendererWithinRange guards against this to some degree -- the classnames
                    // are controlled by product -- and we don't have platform guarantees on them.
                    //
                    // Currently there is a mix of logic across the platform and confluence on determining
                    // positions that are annotatable. This is a defensive check to ensure we don't throw an error
                    // in cases where the range is not valid.
                    return false;
                }
            }
        },
        {
            key: "isRendererWithinRange",
            value: function isRendererWithinRange(range) {
                var startContainer = range.startContainer, endContainer = range.endContainer;
                if (startContainer.parentElement && startContainer.parentElement.closest('.ak-renderer-extension') || endContainer.parentElement && endContainer.parentElement.closest('.ak-renderer-extension')) return true;
                return false;
            }
        },
        {
            key: "isValidAnnotationPosition",
            value: function isValidAnnotationPosition(pos) {
                if (!pos || !this.doc) return false;
                return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
            }
        },
        {
            key: "getPositionFromRange",
            value: function getPositionFromRange(range) {
                if (!this.doc || !this.schema || !range) return false;
                return (0, $1IPWy.getPosFromRange)(range);
            }
        },
        {
            key: "getSelectionContext",
            value: function getSelectionContext() {
                return (0, $3qUJT.getSelectionContext)({
                    doc: this.doc,
                    schema: this.schema
                });
            }
        },
        {
            key: "getAnnotationMarks",
            value: function getAnnotationMarks() {
                var schema = this.schema, doc = this.doc;
                if (!schema || !doc) return [];
                var annotationMarkType = schema.marks.annotation;
                if (!annotationMarkType) return [];
                var marks = [];
                doc.descendants(function(node) {
                    var annotationsMark = node.marks.filter(function(m) {
                        return m.type === annotationMarkType;
                    });
                    if (!annotationsMark || !annotationsMark.length) return true;
                    marks.push.apply(marks, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(annotationsMark));
                    return false;
                });
                var uniqueMarks = new Map();
                marks.forEach(function(m) {
                    uniqueMarks.set(m.attrs.id, m);
                });
                return Array.from(uniqueMarks.values());
            }
        },
        {
            key: "getMediaNodeContext",
            value: function getMediaNodeContext(identifier) {
                if (!this.doc) return {
                    status: 'missing'
                };
                var candidates = [];
                this.doc.descendants(function(node, position) {
                    if (node.type.name !== 'media' || node.attrs.type !== 'file' || node.attrs.id !== identifier.id) return true;
                    candidates.push({
                        fileId: identifier.id,
                        annotationIds: node.marks.filter(function(mark) {
                            return mark.type.name === 'annotation' && mark.attrs.annotationType === (0, $kX1mK.AnnotationTypes).INLINE_COMMENT;
                        }).map(function(mark) {
                            return mark.attrs.id;
                        }).filter(function(id) {
                            return typeof id === 'string';
                        }),
                        position: position,
                        displayText: node.attrs.alt || node.attrs.__fileName || node.attrs.fileName || node.attrs.name,
                        occurrenceKey: typeof node.attrs.occurrenceKey === 'string' ? node.attrs.occurrenceKey : undefined
                    });
                    return false;
                });
                var exactMatches = identifier.occurrenceKey ? candidates.filter(function(candidate) {
                    return candidate.occurrenceKey === identifier.occurrenceKey;
                }) : [];
                var matches = exactMatches.length > 0 ? exactMatches : candidates;
                if (matches.length === 0) return {
                    status: 'missing'
                };
                if (matches.length > 1) return {
                    status: 'ambiguous'
                };
                return {
                    status: 'resolved',
                    context: matches[0]
                };
            }
        },
        {
            key: "getAnnotationsByPosition",
            value: function getAnnotationsByPosition(range) {
                if (!this.doc || !this.schema) return [];
                var pos = (0, $1IPWy.getPosFromRange)(range);
                if (!pos || !this.doc) return [];
                return (0, $ht7Bg.getAnnotationIdsFromRange)(pos, this.doc, this.schema);
            }
        },
        {
            key: "applyAnnotation",
            value: function applyAnnotation(pos, annotation) {
                if (!this.doc || !pos || !this.schema) return false;
                var from = pos.from, to = pos.to;
                var annotationId = annotation.annotationId, annotationType = annotation.annotationType;
                var step;
                var targetNodeType;
                // As part of fix for RAP, `from` points to the position right before media node
                // hence, -1 is not needed
                var beforeNodePos = from;
                var possibleNode = this.doc.nodeAt(beforeNodePos);
                if ((possibleNode === null || possibleNode === void 0 ? void 0 : possibleNode.type.name) === 'media') {
                    targetNodeType = 'media';
                    step = new (0, $lh06P.AddNodeMarkStep)(beforeNodePos, this.schema.marks.annotation.create({
                        id: annotationId,
                        type: annotationType
                    }));
                } else {
                    var resolvedNode = this.doc.resolve(from).node();
                    // annotation is technically on text, but the context is caption
                    targetNodeType = resolvedNode.type.name === 'caption' ? 'caption' : 'text';
                    step = (0, $1IPWy.createAnnotationStep)(from, to, {
                        annotationId: annotationId,
                        annotationType: annotationType,
                        schema: this.schema
                    });
                }
                var _step$apply2 = step.apply(this.doc), doc = _step$apply2.doc, failed = _step$apply2.failed;
                if (failed || !doc) return false;
                var originalSelection = doc.textBetween(from, to);
                var _getIndexMatch = (0, $7KUde.getIndexMatch)(this.doc, this.schema, originalSelection, from), numMatches = _getIndexMatch.numMatches, matchIndex = _getIndexMatch.matchIndex, blockNodePos = _getIndexMatch.blockNodePos;
                return {
                    step: step,
                    doc: this.transformer.encode(doc),
                    inlineNodeTypes: (0, $35DNJ.getRendererRangeInlineNodeNames)({
                        actions: this,
                        pos: {
                            from: from,
                            to: to
                        }
                    }),
                    ancestorNodeTypes: (0, $35DNJ.getRendererRangeAncestorNodeNames)({
                        actions: this,
                        pos: {
                            from: from,
                            to: to
                        }
                    }),
                    originalSelection: originalSelection,
                    numMatches: numMatches,
                    matchIndex: matchIndex,
                    pos: blockNodePos,
                    targetNodeType: targetNodeType
                };
            }
        },
        {
            key: "generateAnnotationIndexMatch",
            value: function generateAnnotationIndexMatch(pos) {
                if (!this.doc || !pos || !this.schema) return false;
                var from = pos.from, to = pos.to;
                var originalSelection = this.doc.textBetween(from, to);
                var _getIndexMatch2 = (0, $7KUde.getIndexMatch)(this.doc, this.schema, originalSelection, from), numMatches = _getIndexMatch2.numMatches, matchIndex = _getIndexMatch2.matchIndex, blockNodePos = _getIndexMatch2.blockNodePos;
                return {
                    originalSelection: originalSelection,
                    numMatches: numMatches,
                    matchIndex: matchIndex,
                    pos: blockNodePos
                };
            }
        },
        {
            key: "getInlineNodeTypes",
            value: function getInlineNodeTypes(annotationId) {
                if (!this.doc || !this.schema) return [];
                return (0, $ht7Bg.getAnnotationInlineNodeTypes)({
                    doc: this.doc,
                    schema: this.schema
                }, annotationId);
            }
        }
    ]);
}();

});
parcelRegister("ht7Bg", function(module, exports) {
$parcel$export(module.exports, "canApplyAnnotationOnRange", () => $cb7b0a5052cddeaa$export$77ddf8216f9eb904);
$parcel$export(module.exports, "getAnnotationIdsFromRange", () => $cb7b0a5052cddeaa$export$badbcc229c848aec);
$parcel$export(module.exports, "getRangeInlineNodeNames", () => $cb7b0a5052cddeaa$export$35054451202ed5d9);
$parcel$export(module.exports, "getRangeAncestorNodeNames", () => $cb7b0a5052cddeaa$export$2a160f09551a3adc);
$parcel$export(module.exports, "getAnnotationInlineNodeTypes", () => $cb7b0a5052cddeaa$export$8261bc1f662f3f6e);
$parcel$export(module.exports, "isEmptyTextSelectionRenderer", () => $cb7b0a5052cddeaa$export$a35880e7ecdcf47b);

var $fC8ib = parcelRequire("fC8ib");

var $kX1mK = parcelRequire("kX1mK");

var $50U6m = parcelRequire("50U6m");
var $cb7b0a5052cddeaa$export$77ddf8216f9eb904 = function canApplyAnnotationOnRange(rangeSelection, doc, schema) {
    var from = rangeSelection.from, to = rangeSelection.to;
    if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return false;
    var foundInvalid = false;
    doc.nodesBetween(rangeSelection.from, rangeSelection.to, function(node, _pos, parent) {
        // Special exception for hardBreak nodes
        if (schema.nodes.hardBreak === node.type) return false;
        // For block elements or text nodes, we want to check
        // if annotations are allowed inside this tree
        // or if we're leaf and not text
        if ((0, $50U6m.fg)('editor_inline_comments_on_inline_nodes')) {
            var isAllowedInlineNode = [
                'emoji',
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(node.type.name);
            if (node.isInline && !node.isText && !isAllowedInlineNode || node.isLeaf && !node.isText && !isAllowedInlineNode || node.isText && !(parent !== null && parent !== void 0 && parent.type.allowsMarkType(schema.marks.annotation))) {
                foundInvalid = true;
                return false;
            }
        } else if (node.isInline && !node.isText || node.isLeaf && !node.isText || node.isText && !(parent !== null && parent !== void 0 && parent.type.allowsMarkType(schema.marks.annotation))) {
            foundInvalid = true;
            return false;
        }
        return true;
    });
    return !foundInvalid;
};
var $cb7b0a5052cddeaa$export$badbcc229c848aec = function getAnnotationIdsFromRange(rangeSelection, doc, schema) {
    var from = rangeSelection.from, to = rangeSelection.to;
    var annotations = new Set();
    doc.nodesBetween(from, to, function(node) {
        if (!node.marks) return true;
        node.marks.forEach(function(mark) {
            if (mark.type === schema.marks.annotation && mark.attrs) annotations.add(mark.attrs.id);
        });
        return true;
    });
    return Array.from(annotations);
};
function $cb7b0a5052cddeaa$export$5fe1412b20386053(node, state) {
    var annotationMark = state.schema.marks.annotation;
    return !!(annotationMark && node && node.marks.length && annotationMark.isInSet(node.marks));
}
function $cb7b0a5052cddeaa$export$1976770b876b2728(slice, state) {
    if (!slice.content.size) return false;
    var hasAnnotation = false;
    slice.content.forEach(function(node) {
        hasAnnotation = hasAnnotation || $cb7b0a5052cddeaa$export$5fe1412b20386053(node, state);
        // return early if annotation found already
        if (hasAnnotation) return true;
        // check annotations in descendants
        node.descendants(function(node) {
            if ($cb7b0a5052cddeaa$export$5fe1412b20386053(node, state)) {
                hasAnnotation = true;
                return false;
            }
            return true;
        });
    });
    return hasAnnotation;
}
function $cb7b0a5052cddeaa$export$35054451202ed5d9(_ref) {
    var doc = _ref.doc, pos = _ref.pos;
    if (!(0, $50U6m.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    var nodeNames = new Set();
    try {
        doc.nodesBetween(pos.from, pos.to, function(node) {
            if (node.isInline) nodeNames.add(node.type.name);
        });
        // We sort the list alphabetically to make human consumption of the list easier (in tools like the analytics extension)
        var sortedNames = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(nodeNames).sort();
        return sortedNames;
    } catch (_unused) {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $cb7b0a5052cddeaa$export$2a160f09551a3adc(_ref2) {
    var doc = _ref2.doc, pos = _ref2.pos;
    if (!(0, $50U6m.fg)('cc_comments_log_draft_annotation_ancestor_nodes')) return undefined;
    var nodeNames = new Set();
    try {
        // For a range, we can get ancestors at both from and to positions
        // or just use the from position if you want ancestors at the start
        var resolvedFromPos = doc.resolve(pos.from);
        var resolvedToPos = doc.resolve(pos.to);
        // Collect ancestors at the 'from' position
        for(var depth = resolvedFromPos.depth; depth > 0; depth--){
            var ancestorNode = resolvedFromPos.node(depth);
            nodeNames.add(ancestorNode.type.name);
        }
        // Use nodesBetween to collect parent types without additional resolve() calls
        // This isn't as precise as calling resolve() on each parent, but it's a lot faster
        // and should hopefully provide a good approximation of the ancestor nodes
        var seenParents = new Set();
        doc.nodesBetween(pos.from, pos.to, function(_node, _nodePos, parent) {
            // Collect parent chain using the parent parameter
            var currentParent = parent;
            if (!!currentParent && !seenParents.has(currentParent)) {
                seenParents.add(currentParent);
                nodeNames.add(currentParent.type.name);
            // Note: We can't easily get the parent's parent from this context
            // without additional resolve calls, so this approach has limitations
            }
            return true;
        });
        // Optionally collect ancestors at the 'to' position if different
        // This ensures we capture all ancestor contexts across the range
        if (pos.from !== pos.to) for(var _depth = resolvedToPos.depth; _depth > 0; _depth--){
            var _ancestorNode = resolvedToPos.node(_depth);
            nodeNames.add(_ancestorNode.type.name);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(nodeNames);
    } catch (_unused2) {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $cb7b0a5052cddeaa$export$8261bc1f662f3f6e(state, annotationId) {
    if (!(0, $50U6m.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    var mark = state.schema.marks.annotation.create({
        id: annotationId,
        annotationType: (0, $kX1mK.AnnotationTypes).INLINE_COMMENT
    });
    var inlineNodeNames = new Set();
    state.doc.descendants(function(node, _pos) {
        if (mark.isInSet(node.marks)) inlineNodeNames.add(node.type.name);
        return true;
    });
    // This sorting is done to make human consumption easier (ie. in dev tools, test snapshots, analytics events, ...)
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(inlineNodeNames).sort();
}
function $cb7b0a5052cddeaa$export$bb1945a828f2864b(pos) {
    var annotationMarks = pos.marks().filter(function(mark) {
        return mark.type === pos.doc.type.schema.marks.annotation;
    });
    return annotationMarks;
}
function $cb7b0a5052cddeaa$export$2efbc6d84ea0fbec(selection, schema) {
    var _schema$nodes = schema.nodes, text = _schema$nodes.text, paragraph = _schema$nodes.paragraph;
    var hasContent = false;
    selection.content().content.descendants(function(node) {
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for not a text or nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type !== text || !node.textContent) hasContent = true;
        return !hasContent;
    });
    return !hasContent;
}
function $cb7b0a5052cddeaa$export$a35880e7ecdcf47b(selection, schema) {
    var _schema$nodes2 = schema.nodes, text = _schema$nodes2.text, paragraph = _schema$nodes2.paragraph;
    var hasContent = false;
    selection.content().content.descendants(function(node) {
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for inline elements - consider nonempty
        if (node.type !== text && node.type.isInline) hasContent = true;
        // for nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type === text && !!node.textContent) hasContent = true;
        // for other non-text nodes - continue descending
        return !hasContent;
    });
    return !hasContent;
}

});

parcelRegister("1IPWy", function(module, exports) {
$parcel$export(module.exports, "getStartPos", () => $14123162341d1c59$export$aabc9b13a308cc43);
$parcel$export(module.exports, "findParent", () => $14123162341d1c59$export$25245567f53f158f);
$parcel$export(module.exports, "getPosFromRange", () => $14123162341d1c59$export$243cdddc5b21d8c1);
$parcel$export(module.exports, "createAnnotationStep", () => $14123162341d1c59$export$74899f7e5acb5cd3);
/* eslint-disable jsdoc/require-jsdoc -- internal step helpers */ 
var $lh06P = parcelRequire("lh06P");

var $50U6m = parcelRequire("50U6m");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $14123162341d1c59$var$MEDIA_OR_MEDIA_SINGLE_REGEX = /media|mediaSingle/;
function $14123162341d1c59$export$aabc9b13a308cc43(element) {
    return parseInt(element.dataset.rendererStartPos || '-1', 10);
}
var $14123162341d1c59$var$getNodeType = function getNodeType(element) {
    return element.dataset.nodeType;
};
function $14123162341d1c59$var$isPositionPointer(element) {
    return $14123162341d1c59$export$aabc9b13a308cc43(element) > -1;
}
function $14123162341d1c59$export$25245567f53f158f(element) {
    var parentElement = element.parentElement;
    if (!parentElement || $14123162341d1c59$export$9d1d5d87ae7da22f(parentElement)) return null;
    if ($14123162341d1c59$var$isPositionPointer(parentElement)) return parentElement;
    return $14123162341d1c59$export$25245567f53f158f(parentElement);
}
function $14123162341d1c59$var$findMediaParent(element) {
    var parentElement = element.parentElement;
    if (!parentElement || $14123162341d1c59$export$9d1d5d87ae7da22f(parentElement)) return null;
    if (parentElement.dataset.nodeType === 'mediaSingle') return parentElement;
    return $14123162341d1c59$var$findMediaParent(parentElement);
}
function $14123162341d1c59$var$findParentBeforePointer(element) {
    var parentElement = element.parentElement;
    if ($14123162341d1c59$export$9d1d5d87ae7da22f(parentElement) || !parentElement) return null;
    if ($14123162341d1c59$var$isPositionPointer(parentElement)) return element;
    return $14123162341d1c59$var$findParentBeforePointer(parentElement);
}
function $14123162341d1c59$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $14123162341d1c59$var$isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $14123162341d1c59$var$isHighlightTextNode(node) {
    var _dataset;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return !!(node !== null && node !== void 0 && (_dataset = node.dataset) !== null && _dataset !== void 0 && _dataset.highlighted);
}
function $14123162341d1c59$var$isNodeInlineMark(node) {
    return $14123162341d1c59$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
}
function $14123162341d1c59$var$isElementInlineMark(element) {
    return !!element && Boolean(element.dataset.rendererMark);
}
function $14123162341d1c59$var$isNodeInlineTextMark(node) {
    if (node === null) return false;
    var isInlineMark = $14123162341d1c59$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
    if (!isInlineMark) return false;
    /**
   * This checks if the element has any descendents with the data-inline-card
   * attribute set to 'true'. If it does, we should not consider it as an
   * inline text mark.
   **/ if ($14123162341d1c59$var$hasInlineNodeDescendant(node)) return false;
    return true;
}
/**
 * This checks all the descendents of a node and returns true if it reaches
 * a descendant with the data-inline-card attribute set to 'true'.
 */ function $14123162341d1c59$var$hasInlineNodeDescendant(node) {
    if ($14123162341d1c59$var$isElementNode(node)) {
        if ((0, $50U6m.fg)('editor_inline_comments_on_inline_nodes')) {
            if (node.dataset.annotationInlineNode === 'true') return true;
        } else {
            if (node.dataset.inlineCard === 'true') return true;
        }
        return Array.from(node.childNodes).some($14123162341d1c59$var$hasInlineNodeDescendant);
    }
    return false;
}
function $14123162341d1c59$var$resolveNodePos(node) {
    var resolvedPos = 0;
    var prev = node.previousSibling;
    while(prev){
        if (prev.nodeType === Node.COMMENT_NODE) {
            // Comment nodes should not result in the position being
            // incremented, so we skip them.
            prev = prev.previousSibling;
            continue;
        }
        if (prev && ($14123162341d1c59$var$isTextNode(prev) || $14123162341d1c59$var$isHighlightTextNode(prev))) resolvedPos += (prev.textContent || '').length;
        else if (prev) {
            if ((0, $50U6m.fg)('editor_inline_comments_on_inline_nodes')) {
                if ($14123162341d1c59$var$isNodeInlineTextMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                else resolvedPos += 1;
            } else if ($14123162341d1c59$var$isNodeInlineMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
            else resolvedPos += 1;
        }
        prev = prev.previousSibling;
    }
    return resolvedPos;
}
function $14123162341d1c59$export$9d1d5d87ae7da22f(element) {
    return !!element && element.classList.contains('ak-renderer-document');
}
function $14123162341d1c59$export$5db587db55468da7(node, offset) {
    var findEnd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // If the passed node doesn't exist, we should abort
    if (!node) return false;
    if ((0, $50U6m.fg)('editor_inline_comments_on_inline_nodes')) {
        var _node$parentElement;
        var startPosAncestor = (_node$parentElement = node.parentElement) === null || _node$parentElement === void 0 ? void 0 : _node$parentElement.closest('[data-renderer-start-pos');
        var potentialParent = (0, $50U6m.fg)('editor_inline_comments_on_inline_nodes') ? 'data-annotation-mark' : 'data-inline-card';
        if (startPosAncestor !== null && startPosAncestor !== void 0 && startPosAncestor.hasAttribute(potentialParent)) {
            if (findEnd) return parseInt((startPosAncestor === null || startPosAncestor === void 0 ? void 0 : startPosAncestor.getAttribute('data-renderer-start-pos')) || '-1', 10) + 1;
            else return parseInt((startPosAncestor === null || startPosAncestor === void 0 ? void 0 : startPosAncestor.getAttribute('data-renderer-start-pos')) || '-1', 10);
        }
    }
    /**
   * If anchor node is an element (e.g. after a triple click) the anchorOffset
   * is the number of child nodes preceding the anchor.
   * https://developer.mozilla.org/en-US/docs/Web/API/Selection/anchorOffset
   *
   * For end pos we calculate the number of characters by stepping through
   * each of the node's children.
   */ if (node instanceof HTMLElement && $14123162341d1c59$var$isPositionPointer(node)) {
        if (findEnd) {
            var count = $14123162341d1c59$export$aabc9b13a308cc43(node);
            var children = node.childNodes;
            for(var i = 0; i < offset; i++){
                var _children$i;
                count += ((_children$i = children[i]) === null || _children$i === void 0 || (_children$i = _children$i.textContent) === null || _children$i === void 0 ? void 0 : _children$i.length) || 1;
            }
            return count;
        }
        return $14123162341d1c59$export$aabc9b13a308cc43(node) + offset;
    }
    var parent = $14123162341d1c59$export$25245567f53f158f(node);
    // Similar to above, if we cant find a parent position pointer
    // we should not proceed.
    if (!parent) return false;
    var resolvedPos = $14123162341d1c59$export$aabc9b13a308cc43(parent);
    var current = node;
    if (current.parentElement && current.parentElement !== parent) {
        // Find the parent element that is a direct child of the position pointer
        // the outer most element from our text position.
        var preParentPointer = $14123162341d1c59$var$findParentBeforePointer(current.parentElement);
        // If our range is inside an inline node
        // We need to move our pointers to parent element
        // since we don't want to count text inside inline nodes at all
        if ((0, $50U6m.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!($14123162341d1c59$var$isNodeInlineTextMark(preParentPointer) || $14123162341d1c59$var$isHighlightTextNode(preParentPointer))) {
                current = current.parentElement;
                offset = 0;
            }
        } else if (!($14123162341d1c59$var$isElementInlineMark(preParentPointer) || $14123162341d1c59$var$isHighlightTextNode(preParentPointer))) {
            current = current.parentElement;
            offset = 0;
        }
        resolvedPos += $14123162341d1c59$var$resolveNodePos(current);
        while(current && current.parentElement !== parent){
            current = current.parentNode;
            if (current) {
                var nodePos = $14123162341d1c59$var$resolveNodePos(current);
                resolvedPos += nodePos;
            }
        }
    } else resolvedPos += $14123162341d1c59$var$resolveNodePos(current);
    return resolvedPos + offset;
}
function $14123162341d1c59$export$243cdddc5b21d8c1(range) {
    var startContainer = range.startContainer, startOffset = range.startOffset, endContainer = range.endContainer, endOffset = range.endOffset;
    var possibleMediaOrMediaSingleElement = $14123162341d1c59$export$25245567f53f158f(startContainer);
    // Video hover targets return media single, not media, thus, the extra check in condition.
    var isMediaOrMediaSingle = possibleMediaOrMediaSingleElement && $14123162341d1c59$var$MEDIA_OR_MEDIA_SINGLE_REGEX.test($14123162341d1c59$var$getNodeType(possibleMediaOrMediaSingleElement) || '');
    if (isMediaOrMediaSingle) {
        var pos;
        var mediaSingleElement = $14123162341d1c59$var$getNodeType(possibleMediaOrMediaSingleElement) === 'mediaSingle' ? possibleMediaOrMediaSingleElement : $14123162341d1c59$var$findMediaParent(possibleMediaOrMediaSingleElement);
        if (mediaSingleElement) pos = $14123162341d1c59$export$aabc9b13a308cc43(mediaSingleElement);
        if (pos !== undefined) return {
            from: pos,
            to: pos
        };
    }
    var from = $14123162341d1c59$export$5db587db55468da7(startContainer, startOffset);
    var findEnd = true;
    var to = $14123162341d1c59$export$5db587db55468da7(endContainer, endOffset, findEnd);
    if (from === false || to === false) return false;
    return {
        from: from,
        to: to
    };
}
function $14123162341d1c59$export$74899f7e5acb5cd3(from, to, opts) {
    return new (0, $lh06P.AddMarkStep)(Math.min(from, to), Math.max(from, to), opts.schema.marks.annotation.create({
        id: opts.annotationId,
        annotationType: opts.annotationType
    }));
}

});

parcelRegister("35DNJ", function(module, exports) {
$parcel$export(module.exports, "getRendererRangeInlineNodeNames", () => $2400b66c914289a7$export$b0ea72d31617ccea);
$parcel$export(module.exports, "getRendererRangeAncestorNodeNames", () => $2400b66c914289a7$export$1726c23d64498b6);

var $ht7Bg = parcelRequire("ht7Bg");

var $50U6m = parcelRequire("50U6m");
function $2400b66c914289a7$export$b0ea72d31617ccea(_ref) {
    var actions = _ref.actions, pos = _ref.pos;
    if (!(0, $50U6m.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    var doc = actions.doc;
    if (!pos || !doc) return undefined;
    var inlineNodeNames = (0, $ht7Bg.getRangeInlineNodeNames)({
        doc: doc,
        pos: pos
    });
    return inlineNodeNames;
}
function $2400b66c914289a7$export$1726c23d64498b6(_ref2) {
    var actions = _ref2.actions, pos = _ref2.pos;
    if (!(0, $50U6m.fg)('cc_comments_log_draft_annotation_ancestor_nodes')) return undefined;
    var doc = actions.doc;
    if (!pos || !doc) return undefined;
    var ancestorNodeNames = (0, $ht7Bg.getRangeAncestorNodeNames)({
        doc: doc,
        pos: pos
    });
    return ancestorNodeNames;
}

});

parcelRegister("7KUde", function(module, exports) {
$parcel$export(module.exports, "getIndexMatch", () => $5a586ee42600f998$export$fb7dab895a0d310e);
// Finds a string position using the Confluence annotation backend's serialisation rules.
function $5a586ee42600f998$export$fb7dab895a0d310e(doc, schema, selectedText, startIndex) {
    var textContent = '';
    var matchIndex = 0;
    var numMatches = 0;
    var blockNodePos;
    doc.descendants(function(node, pos) {
        var nodeType = node.type;
        var media = schema.nodes.media;
        var isBlockContainer = nodeType.isBlock && !nodeType.isLeaf && !nodeType.inlineContent;
        // Containers may allow annotations for their children; skip their own text to avoid double-counting.
        if ((node.isText || !nodeType.allowsMarkType(schema.marks.annotation) || isBlockContainer) && nodeType !== media) return true;
        var nodeStart = pos;
        var nodeEnd = nodeStart + node.nodeSize;
        if (startIndex >= nodeStart && startIndex <= nodeEnd) {
            // MAUI-1255 will add eligible extensions as block annotation targets.
            if (nodeType === media) blockNodePos = pos;
            // If the start of the annotation selection is within the current node, we scan the document for previous occurrences
            // Find the index by counting all previous instances of the selectedText in the partial textContent
            // Need to scan from start, up to `startIndex` (which includes partial of the current node)
            textContent += doc.textBetween(nodeStart, startIndex - 1);
            matchIndex = $5a586ee42600f998$export$3c2359e76fc742da(textContent, selectedText);
            // Complete appending of the node
            textContent += doc.textBetween(startIndex, nodeEnd);
        } else textContent += node.textContent;
        return true;
    });
    // Count total number of matches in final text
    numMatches = $5a586ee42600f998$export$3c2359e76fc742da(textContent, selectedText);
    return {
        numMatches: numMatches,
        matchIndex: matchIndex,
        textContent: textContent,
        blockNodePos: blockNodePos
    };
}
function $5a586ee42600f998$export$3c2359e76fc742da(searchString, query) {
    if (searchString === '' || query === '') return 0;
    // Escape characters that would trigger as syntax in a regex query before converting to the query
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var reg = new RegExp(query.replace(/(?=[.\\+*?[^\]$(){}\|])/g, '\\'), 'g');
    return (searchString.match(reg) || []).length;
}

});

parcelRegister("3qUJT", function(module, exports) {
$parcel$export(module.exports, "getSelectionContext", () => $27ffd00dc29daa17$export$3726c4866ce829b5);

var $InKrQ = parcelRequire("InKrQ");
var $lrnnn = parcelRequire("lrnnn");

var $cc08P = parcelRequire("cc08P");

var $1IPWy = parcelRequire("1IPWy");
var $27ffd00dc29daa17$export$3726c4866ce829b5 = function getSelectionContext(_ref) {
    var doc = _ref.doc, schema = _ref.schema;
    if (!doc || !schema) return null;
    var selection = document.getSelection();
    if (!selection || selection.type !== 'Range' || selection.rangeCount !== 1) return null;
    var range = selection.getRangeAt(0);
    if (range.collapsed) return null;
    var startNode = (0, $1IPWy.findParent)(range.startContainer);
    var endNode = (0, $1IPWy.findParent)(range.endContainer);
    if (!startNode || !endNode) return null;
    var startPos = (0, $1IPWy.getStartPos)(startNode);
    var endPos = (0, $1IPWy.getStartPos)(endNode);
    if (startPos === null || endPos === null) return null;
    var pos = (0, $1IPWy.getPosFromRange)(range);
    if (!pos) return null;
    var from = Math.min(pos.from, pos.to);
    var to = Math.max(pos.from, pos.to);
    if (from === to) return null;
    var pmSelection;
    try {
        pmSelection = (0, $cc08P.TextSelection).create(doc, from, to);
    } catch (_unused) {
        return null;
    }
    var startIndex = from - startPos;
    var endIndex = to - endPos;
    if (startIndex < 0 || endIndex < 0) return null;
    var selectionFragment = (0, $InKrQ.getFragmentsFromSelection)(pmSelection);
    var localIds = (0, $lrnnn.getLocalIdsFromSelection)(pmSelection);
    return {
        localIds: localIds,
        selectionFragment: selectionFragment,
        selectionMarkdown: null,
        startIndex: startIndex,
        endIndex: endIndex
    };
};

});
parcelRegister("InKrQ", function(module, exports) {
$parcel$export(module.exports, "getFragmentsFromSelection", () => $08568810cabcc7d6$export$dae3dcae007fe30);

var $icTRb = parcelRequire("icTRb");

var $gUIku = parcelRequire("gUIku");
var $08568810cabcc7d6$export$dae3dcae007fe30 = function getFragmentsFromSelection(selection) {
    if (!selection || selection.empty) return null;
    var slice = (0, $gUIku.getSliceFromSelection)(selection);
    var content = slice.content;
    var fragment = [];
    content.forEach(function(node) {
        fragment.push((0, $icTRb.nodeToJSON)(node, {
            keepNestedTables: true
        }));
    });
    return fragment;
};

});
parcelRegister("icTRb", function(module, exports) {
$parcel$export(module.exports, "nodeToJSON", () => $d414acf6a120b23f$export$3a858d3babd60825);

var $hBZ09 = parcelRequire("hBZ09");

var $a9ljh = parcelRequire("a9ljh");

var $8OAR1 = parcelRequire("8OAR1");




var $d414acf6a120b23f$export$996213f7c272fc6f = function validateNodes(nodes) {
    return nodes.every((0, $8OAR1.validNode));
};
var $d414acf6a120b23f$export$26b9f946b448f23e = function isType(node, type) {
    return type && node && node.type === type;
};
var $d414acf6a120b23f$export$d7ae8c533ae18832 = function isParagraph(node, schema) {
    return $d414acf6a120b23f$export$26b9f946b448f23e(node, schema.nodes.paragraph);
};
var $d414acf6a120b23f$export$1879817ac5c922b7 = function isText(node, schema) {
    return $d414acf6a120b23f$export$26b9f946b448f23e(node, schema.nodes.text);
};
var $d414acf6a120b23f$export$5dfeda3a9e6fe056 = function isLinkMark(node, schema) {
    return $d414acf6a120b23f$export$26b9f946b448f23e(node, schema.marks.link);
};
var $d414acf6a120b23f$export$5125f50e751e84db = function isNodeSelectedOrInRange(anchorPosition, headPosition, nodePosition, nodeSize) {
    if (typeof nodePosition !== 'number') return null;
    var rangeStart = Math.min(anchorPosition, headPosition);
    var rangeEnd = Math.max(anchorPosition, headPosition);
    var nodeStart = nodePosition;
    var nodeEnd = nodePosition + nodeSize;
    if (anchorPosition === headPosition) return null;
    if (rangeStart <= nodeStart && nodeEnd < rangeEnd || rangeStart < nodeStart && nodeEnd <= rangeEnd) return (0, $a9ljh.SelectedState).selectedInRange;
    if (nodeStart <= anchorPosition && headPosition <= nodeEnd) return (0, $a9ljh.SelectedState).selectedInside;
    return null;
};
var $d414acf6a120b23f$var$transformer = new (0, $hBZ09.JSONTransformer)();
function $d414acf6a120b23f$export$54fd2c36b5cc6731(node) {
    return $d414acf6a120b23f$var$transformer.encode(node);
}
function $d414acf6a120b23f$export$3a858d3babd60825(node, options) {
    return $d414acf6a120b23f$var$transformer.encodeNode(node, options);
}

});
parcelRegister("hBZ09", function(module, exports) {
$parcel$export(module.exports, "JSONTransformer", () => $cd2535fda3f8a09d$export$98cb1d9308d0944d);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $bTFoW = parcelRequire("bTFoW");

var $kYLlQ = parcelRequire("kYLlQ");

var $aPGKU = parcelRequire("aPGKU");

var $9v6s8 = parcelRequire("9v6s8");
var $cd2535fda3f8a09d$var$createDocFromContent = function createDocFromContent(content) {
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
var $cd2535fda3f8a09d$var$emptyDoc = $cd2535fda3f8a09d$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
var $cd2535fda3f8a09d$export$98cb1d9308d0944d = /*#__PURE__*/ function() {
    /**
   * Creates a new JSONTransformer instance.
   * @param schema The current editor schema
   * @param mentionMap An optional mapping of user IDs to mention names. This is used by the encoder to substitute empty
   * mention node.attr.text values with mapped names.
   */ function JSONTransformer() {
        var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $kYLlQ.defaultSchema);
        var mentionMap = arguments.length > 1 ? arguments[1] : undefined;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, JSONTransformer);
        this.schema = schema;
        this.mentionMap = mentionMap;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(JSONTransformer, [
        {
            key: "encode",
            value: function encode(node) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var content = [];
                node.content.forEach(function(child) {
                    content.push((0, $aPGKU.sanitizeNode)((0, $9v6s8.toJSON)(child, _this.mentionMap), options));
                });
                if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($bTFoW)))(content, $cd2535fda3f8a09d$var$emptyDoc.content)) return $cd2535fda3f8a09d$var$createDocFromContent([]);
                return $cd2535fda3f8a09d$var$createDocFromContent(content);
            }
        },
        {
            key: "internalParse",
            value: function internalParse(content, schema) {
                var doc = schema.nodeFromJSON(content);
                doc.check();
                return doc;
            }
        },
        {
            key: "parse",
            value: function parse(content, stage) {
                if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
                var schema = !!stage ? (0, $kYLlQ.getSchemaBasedOnStage)(stage) : this.schema;
                if (!content.content || content.content.length === 0) return this.internalParse($cd2535fda3f8a09d$var$emptyDoc, schema);
                return this.internalParse(content, schema);
            }
        },
        {
            key: "encodeNode",
            value: function encodeNode(node) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return (0, $aPGKU.sanitizeNode)((0, $9v6s8.toJSON)(node, this.mentionMap), options);
            }
        }
    ]);
}();

});
parcelRegister("aPGKU", function(module, exports) {
$parcel$export(module.exports, "sanitizeNode", () => $7e2fd52fc7748aba$export$48b382180baf8e88);

var $25nEq = parcelRequire("25nEq");

var $4JYPw = parcelRequire("4JYPw");

var $kbnxS = parcelRequire("kbnxS");

var $259Od = parcelRequire("259Od");

var $b5ArQ = parcelRequire("b5ArQ");
function $7e2fd52fc7748aba$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7e2fd52fc7748aba$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7e2fd52fc7748aba$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7e2fd52fc7748aba$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7e2fd52fc7748aba$var$hasNestedTable = function hasNestedTable(tableCellNode) {
    var _tableCellNode$conten;
    return (_tableCellNode$conten = tableCellNode.content) === null || _tableCellNode$conten === void 0 ? void 0 : _tableCellNode$conten.some(function(node) {
        return (node === null || node === void 0 ? void 0 : node.type) === 'table';
    });
};
function $7e2fd52fc7748aba$export$48b382180baf8e88(json) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$keepNestedTa = options.keepNestedTables, keepNestedTables = _options$keepNestedTa === void 0 ? false : _options$keepNestedTa;
    var sanitizedJSON = (0, $kbnxS.traverse)(json, {
        text: function text(node) {
            if (!node || !Array.isArray(node.marks)) return node;
            return $7e2fd52fc7748aba$var$_objectSpread($7e2fd52fc7748aba$var$_objectSpread({}, node), {}, {
                marks: node.marks.filter(function(mark) {
                    return mark.type !== 'typeAheadQuery';
                })
            });
        },
        status: function status(node) {
            if (node.attrs && !!node.attrs.text) return (0, $b5ArQ.removeNonAnnotationMarks)(node);
            return false; // empty status
        },
        caption: function caption(node) {
            if (node.content) return node;
            return false; // empty caption
        },
        tableCell: function tableCell(node) {
            if ($7e2fd52fc7748aba$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $4JYPw.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        tableHeader: function tableHeader(node) {
            if ($7e2fd52fc7748aba$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $4JYPw.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        panel_c1: function panel_c1(node) {
            return $7e2fd52fc7748aba$var$_objectSpread($7e2fd52fc7748aba$var$_objectSpread({}, node), {}, {
                type: 'panel'
            });
        },
        emoji: (0, $b5ArQ.removeNonAnnotationMarks),
        mention: (0, $b5ArQ.removeNonAnnotationMarks),
        date: (0, $b5ArQ.removeNonAnnotationMarks),
        hardBreak: (0, $259Od.removeMarks),
        inlineCard: (0, $b5ArQ.removeNonAnnotationMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("259Od", function(module, exports) {
$parcel$export(module.exports, "removeMarks", () => $1843a841727ad0a5$export$9bf001d8ef76e497);

var $25nEq = parcelRequire("25nEq");
function $1843a841727ad0a5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1843a841727ad0a5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1843a841727ad0a5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1843a841727ad0a5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1843a841727ad0a5$export$9bf001d8ef76e497(node) {
    var newNode = $1843a841727ad0a5$var$_objectSpread({}, node);
    delete newNode.marks;
    return newNode;
}

});

parcelRegister("b5ArQ", function(module, exports) {
$parcel$export(module.exports, "removeNonAnnotationMarks", () => $812c6f2ce99be8dd$export$8cae9126fc577085);

var $25nEq = parcelRequire("25nEq");
function $812c6f2ce99be8dd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $812c6f2ce99be8dd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $812c6f2ce99be8dd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $812c6f2ce99be8dd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $812c6f2ce99be8dd$export$8cae9126fc577085(node) {
    var newNode = $812c6f2ce99be8dd$var$_objectSpread({}, node);
    if (node.marks) newNode.marks = node.marks.filter(function(mark) {
        return mark.type === 'annotation';
    });
    return newNode;
}

});


parcelRegister("9v6s8", function(module, exports) {
$parcel$export(module.exports, "toJSON", () => $6eac03b6e0217d30$export$54fd2c36b5cc6731);

var $ekGgq = parcelRequire("ekGgq");

var $1Vcia = parcelRequire("1Vcia");

var $25nEq = parcelRequire("25nEq");

var $fkqjY = parcelRequire("fkqjY");

var $enrSO = parcelRequire("enrSO");

var $2InDy = parcelRequire("2InDy");

var $4eHHu = parcelRequire("4eHHu");

var $iDfRT = parcelRequire("iDfRT");

var $kZNkK = parcelRequire("kZNkK");

var $gc8Zd = parcelRequire("gc8Zd");

var $eQlOO = parcelRequire("eQlOO");

var $69D6c = parcelRequire("69D6c");

var $cZSaz = parcelRequire("cZSaz");
function $6eac03b6e0217d30$var$_toPropertyKey(t) {
    var i = $6eac03b6e0217d30$var$_toPrimitive(t, "string");
    return "symbol" == (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(i) ? i : i + "";
}
function $6eac03b6e0217d30$var$_toPrimitive(t, r) {
    if ("object" != (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $6eac03b6e0217d30$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6eac03b6e0217d30$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6eac03b6e0217d30$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6eac03b6e0217d30$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6eac03b6e0217d30$var$isType = function isType(type) {
    return function(node) {
        return node.type.name === type;
    };
};
// Create a Set of node types that should have empty attrs removed
var $6eac03b6e0217d30$var$NODES_WITH_EMPTY_ATTRS_REMOVAL = new Set([
    'paragraph',
    'layoutSection',
    'blockquote',
    'nestedExpand',
    'bulletList',
    'listItem',
    'orderedList',
    'rule',
    'caption',
    'tableRow',
    'media',
    'mediaSingle',
    'mediaInline'
]);
var $6eac03b6e0217d30$var$isCodeBlock = $6eac03b6e0217d30$var$isType('codeBlock');
var $6eac03b6e0217d30$var$isMediaNode = $6eac03b6e0217d30$var$isType('media');
var $6eac03b6e0217d30$var$isMediaInline = $6eac03b6e0217d30$var$isType('mediaInline');
var $6eac03b6e0217d30$var$isMediaSingleNode = $6eac03b6e0217d30$var$isType('mediaSingle');
var $6eac03b6e0217d30$var$isMentionNode = $6eac03b6e0217d30$var$isType('mention');
var $6eac03b6e0217d30$var$isParagraph = $6eac03b6e0217d30$var$isType('paragraph');
var $6eac03b6e0217d30$var$isHeading = $6eac03b6e0217d30$var$isType('heading');
var $6eac03b6e0217d30$var$isTable = $6eac03b6e0217d30$var$isType('table');
var $6eac03b6e0217d30$var$isTableCell = $6eac03b6e0217d30$var$isType('tableCell');
var $6eac03b6e0217d30$var$isTableHeader = $6eac03b6e0217d30$var$isType('tableHeader');
var $6eac03b6e0217d30$var$isLinkMark = $6eac03b6e0217d30$var$isType('link');
var $6eac03b6e0217d30$var$isUnsupportedMark = $6eac03b6e0217d30$var$isType('unsupportedMark');
var $6eac03b6e0217d30$var$isUnsupportedNodeAttributeMark = $6eac03b6e0217d30$var$isType('unsupportedNodeAttribute');
var $6eac03b6e0217d30$var$isExpand = $6eac03b6e0217d30$var$isType('expand');
var $6eac03b6e0217d30$var$isNestedExpand = $6eac03b6e0217d30$var$isType('nestedExpand');
var $6eac03b6e0217d30$var$isExtensionNode = $6eac03b6e0217d30$var$isType('extension');
var $6eac03b6e0217d30$var$isUnsupportedNode = function isUnsupportedNode(node) {
    return $6eac03b6e0217d30$var$isType('unsupportedBlock')(node) || $6eac03b6e0217d30$var$isType('unsupportedInline')(node);
};
var $6eac03b6e0217d30$var$isDataConsumer = $6eac03b6e0217d30$var$isType('dataConsumer');
var $6eac03b6e0217d30$var$isFragmentMark = $6eac03b6e0217d30$var$isType('fragment');
var $6eac03b6e0217d30$var$isAnnotationMark = $6eac03b6e0217d30$var$isType('annotation');
var $6eac03b6e0217d30$var$isAllowedNodeForAnnotation = function isAllowedNodeForAnnotation(node) {
    return !node.type.isBlock || $6eac03b6e0217d30$var$isMediaNode(node) || $6eac03b6e0217d30$var$isExtensionNode(node);
};
var $6eac03b6e0217d30$var$isHardBreak = $6eac03b6e0217d30$var$isType('hardBreak');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $6eac03b6e0217d30$var$_filterNull = function filterNull(subject) {
    var output = $6eac03b6e0217d30$var$_objectSpread({}, subject);
    // eslint-disable-next-line guard-for-in
    for(var key in output){
        var current = output[key];
        if (current === null) {
            var _output = output, unusedKey = _output[key], filteredObj = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_output, [
                key
            ].map($6eac03b6e0217d30$var$_toPropertyKey));
            output = filteredObj;
        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(current) === 'object' && !Array.isArray(current)) output[key] = $6eac03b6e0217d30$var$_filterNull(current);
    }
    return output;
};
var $6eac03b6e0217d30$var$canOverrideMark = function canOverrideMark(mark, existingMarks) {
    if (existingMarks.some(function(e) {
        return mark.attrs.originalValue.type === e.type.name;
    })) return (0, $cZSaz.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
var $6eac03b6e0217d30$var$getUnwrappedNodeAttributes = function getUnwrappedNodeAttributes(node, mark, obj) {
    var nodeAttributes = node.type.spec.attrs;
    var attributes = $6eac03b6e0217d30$var$_objectSpread($6eac03b6e0217d30$var$_objectSpread({}, mark.attrs.unsupported), obj.attrs);
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        var attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return $6eac03b6e0217d30$var$_objectSpread($6eac03b6e0217d30$var$_objectSpread({}, attributes), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, mark.attrs.unsupported[key]));
        }
    }
    return attributes;
};
/**
 * Transforms a Prosemirror node into a JSON representation. Compared with
 * native Prosemirror JSON, this representation ensures we have valid ADF attrs.
 *
 * @param node The Prosemirror node to transform.
 * @param mentionMap A map of mention IDs to their display names.
 * @returns The JSON representation of the node.
 */ var $6eac03b6e0217d30$export$54fd2c36b5cc6731 = function toJSON(node, mentionMap) {
    var obj = {
        type: node.type.name
    };
    if ($6eac03b6e0217d30$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($6eac03b6e0217d30$var$isMediaNode(node)) obj.attrs = (0, $69D6c.toJSON)(node).attrs;
    else if ($6eac03b6e0217d30$var$isMediaSingleNode(node)) obj.attrs = (0, $eQlOO.toJSON)(node).attrs;
    else if ($6eac03b6e0217d30$var$isMediaInline(node)) obj.attrs = (0, $69D6c.toJSON)(node).attrs;
    else if ($6eac03b6e0217d30$var$isMentionNode(node)) obj.attrs = (0, $kZNkK.toJSON)(node).attrs;
    else if ($6eac03b6e0217d30$var$isCodeBlock(node)) obj.attrs = (0, $enrSO.toJSON)(node).attrs;
    else if ($6eac03b6e0217d30$var$isTable(node)) obj.attrs = (0, $gc8Zd.tableToJSON)(node).attrs;
    else if ($6eac03b6e0217d30$var$isTableCell(node)) obj.attrs = (0, $gc8Zd.toJSONTableCell)(node).attrs;
    else if ($6eac03b6e0217d30$var$isTableHeader(node)) obj.attrs = (0, $gc8Zd.toJSONTableHeader)(node).attrs;
    else if ($6eac03b6e0217d30$var$isExpand(node) || $6eac03b6e0217d30$var$isNestedExpand(node)) obj.attrs = (0, $4eHHu.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $6eac03b6e0217d30$var$_filterNull(obj.attrs);
    if ($6eac03b6e0217d30$var$isMentionNode(node) && mentionMap) {
        var _text, _obj$attrs;
        // If the mentionMap exists and has a name defined then we should use it and prepend @ to the begining of it.
        var name = !!(mentionMap !== null && mentionMap !== void 0 && mentionMap[node.attrs.id]) ? "@".concat(mentionMap[node.attrs.id]) : '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var text = (_text = (_obj$attrs = obj.attrs) === null || _obj$attrs === void 0 ? void 0 : _obj$attrs.text) !== null && _text !== void 0 ? _text : '';
        obj.attrs = $6eac03b6e0217d30$var$_objectSpread($6eac03b6e0217d30$var$_objectSpread({}, obj.attrs), {}, {
            // If an explicit text value is set on the mention then that should take priority over the mentionMap value.
            text: !!text ? text : name
        });
    }
    if ($6eac03b6e0217d30$var$NODES_WITH_EMPTY_ATTRS_REMOVAL.has(node.type.name) && obj.attrs && !Object.keys(obj.attrs).length || $6eac03b6e0217d30$var$isHardBreak(node)) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach(function(child) {
        obj.content = obj.content || [];
        obj.content.push($6eac03b6e0217d30$export$54fd2c36b5cc6731(child, mentionMap));
    });
    if ($6eac03b6e0217d30$var$isParagraph(node) || $6eac03b6e0217d30$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        var parsedMarks = node.marks.map(function(mark) {
            if ($6eac03b6e0217d30$var$isAnnotationMark(mark) && !$6eac03b6e0217d30$var$isAllowedNodeForAnnotation(node)) return null;
            else if ($6eac03b6e0217d30$var$isUnsupportedMark(mark)) return $6eac03b6e0217d30$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($6eac03b6e0217d30$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($6eac03b6e0217d30$var$isLinkMark(mark)) return (0, $fkqjY.toJSON)(mark);
            else if ($6eac03b6e0217d30$var$isDataConsumer(mark)) {
                var _serialised$attrs$sou;
                var serialised = (0, $2InDy.toJSON)(mark);
                return !serialised.attrs.sources || ((_serialised$attrs$sou = serialised.attrs.sources) === null || _serialised$attrs$sou === void 0 ? void 0 : _serialised$attrs$sou.length) === 0 ? null : serialised;
            } else if ($6eac03b6e0217d30$var$isFragmentMark(mark)) {
                var fragmentMark = (0, $iDfRT.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter(function(maybeMark) {
            return maybeMark !== null;
        });
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = (parsedMarks === null || parsedMarks === void 0 ? void 0 : parsedMarks.length) > 0 ? parsedMarks : undefined;
        var nodeAttributeMark = node.marks.find($6eac03b6e0217d30$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = $6eac03b6e0217d30$var$_objectSpread({}, $6eac03b6e0217d30$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj));
    }
    return obj;
};

});
parcelRegister("cZSaz", function(module, exports) {
$parcel$export(module.exports, "markOverrideRuleFor", () => $9765337fa91cf6e5$export$28e4e3c024cce988);
var $9765337fa91cf6e5$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: function canOverrideUnsupportedMark() {
        return true;
    }
};
var $9765337fa91cf6e5$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: function canOverrideUnsupportedMark() {
        return false;
    }
};
var $9765337fa91cf6e5$export$28e4e3c024cce988 = function markOverrideRuleFor(type) {
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $9765337fa91cf6e5$var$defaultAllowOverrideBehaviour;
        default:
            return $9765337fa91cf6e5$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});



parcelRegister("a9ljh", function(module, exports) {
$parcel$export(module.exports, "SelectedState", () => $763b4662f2a4cb95$export$a6212ae0c82963af);
var $763b4662f2a4cb95$export$a6212ae0c82963af = /*#__PURE__*/ function(SelectedState) {
    SelectedState[SelectedState["selectedInRange"] = 0] = "selectedInRange";
    SelectedState[SelectedState["selectedInside"] = 1] = "selectedInside";
    return SelectedState;
}({});

});

parcelRegister("8OAR1", function(module, exports) {
$parcel$export(module.exports, "validNode", () => $66af94bcfbbeedaa$export$4c39e41e39b3c449);
var $66af94bcfbbeedaa$export$4c39e41e39b3c449 = function validNode(node) {
    try {
        node.check(); // this will throw an error if the node is invalid
    } catch (error) {
        return false;
    }
    return true;
};

});


parcelRegister("gUIku", function(module, exports) {
$parcel$export(module.exports, "getSliceFromSelection", () => $c5044338cd52445a$export$4fd509032ef7561b);

var $fC8ib = parcelRequire("fC8ib");

var $9Jwkl = parcelRequire("9Jwkl");

var $cc08P = parcelRequire("cc08P");


function $c5044338cd52445a$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $c5044338cd52445a$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $c5044338cd52445a$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $c5044338cd52445a$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $c5044338cd52445a$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $c5044338cd52445a$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $c5044338cd52445a$var$listDepth = 3;
var $c5044338cd52445a$export$8701765a689d47ab = function selectionCoversAllListItems($from, $to) {
    // Block level lists
    var listParents = [
        'bulletList',
        'orderedList'
    ];
    if ($from.depth >= $c5044338cd52445a$var$listDepth && $to.depth >= $c5044338cd52445a$var$listDepth && $from.depth === $to.depth) {
        var _greatGrandparentFrom, _greatGrandparentFrom2;
        // Get grandparents (from)
        var grandparentFrom = $from.node($from.depth - 1);
        var greatGrandparentFrom = $from.node($from.depth - 2);
        // Get grandparents (to)
        var grandparentTo = $to.node($from.depth - 1);
        var greatGrandparentTo = $to.node($from.depth - 2);
        if (greatGrandparentTo.eq(greatGrandparentFrom) && listParents.includes(greatGrandparentFrom.type.name) && // Selection covers entire list
        (_greatGrandparentFrom = greatGrandparentFrom.firstChild) !== null && _greatGrandparentFrom !== void 0 && _greatGrandparentFrom.eq(grandparentFrom) && (_greatGrandparentFrom2 = greatGrandparentFrom.lastChild) !== null && _greatGrandparentFrom2 !== void 0 && _greatGrandparentFrom2.eq(grandparentTo)) return true;
    }
    return false;
};
var $c5044338cd52445a$export$4fd509032ef7561b = function getSliceFromSelection(selection) {
    var from = selection.from, to = selection.to;
    if (from === to) return (0, $9Jwkl.Fragment).empty;
    var frag = (0, $9Jwkl.Fragment).empty;
    var sortedRanges = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(selection.ranges.slice()).sort(function(a, b) {
        return a.$from.pos - b.$from.pos;
    });
    var _iterator = $c5044338cd52445a$var$_createForOfIteratorHelper(sortedRanges), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var range = _step.value;
            var $from = range.$from, $to = range.$to;
            var _to = $to.pos;
            var depth = // If we're in a text selection, and share the parent node across the anchor->head
            // make the depth the parent node
            selection instanceof (0, $cc08P.TextSelection) && $from.parent.eq($to.parent) ? Math.max(0, $from.sharedDepth(_to) - 1) : $from.sharedDepth(_to);
            var finalDepth = depth;
            // For block-level lists (non-nested) specifically use the selection
            if ($c5044338cd52445a$export$8701765a689d47ab($from, $to)) finalDepth = $from.depth - $c5044338cd52445a$var$listDepth;
            var start = $from.start(finalDepth);
            var node = $from.node(finalDepth);
            var content = node.content.cut($from.pos - start, $to.pos - start);
            frag = frag.append(content);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return frag;
};

});


parcelRegister("lrnnn", function(module, exports) {
$parcel$export(module.exports, "getLocalIdsFromSelection", () => $f9be4093ebe9d1b4$export$9ce8378d786d4035);

var $fC8ib = parcelRequire("fC8ib");

var $cc08P = parcelRequire("cc08P");

var $fwvBn = parcelRequire("fwvBn");

var $50U6m = parcelRequire("50U6m");

var $gUIku = parcelRequire("gUIku");
var $f9be4093ebe9d1b4$export$9ce8378d786d4035 = function getLocalIdsFromSelection(selection) {
    if (!selection) return null;
    if (selection instanceof (0, $cc08P.NodeSelection)) {
        if ((0, $50U6m.fg)('platform_editor_ai_selection_local_ids')) {
            var _selection$node$attrs;
            var _ids = [];
            var rootLocalId = (_selection$node$attrs = selection.node.attrs) === null || _selection$node$attrs === void 0 ? void 0 : _selection$node$attrs.localId;
            if (rootLocalId) _ids.push(rootLocalId);
            selection.node.descendants(function(node) {
                var _node$attrs;
                if (node.isInline) return false;
                var localId = (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId;
                if (localId) _ids.push(localId);
            });
            return _ids;
        }
        return [
            selection.node.attrs.localId
        ];
    } else if (selection instanceof (0, $fwvBn.CellSelection)) {
        if ((0, $50U6m.fg)('platform_editor_ai_selection_local_ids')) {
            var _ids2 = [];
            var ancestorIds = new Set();
            // Collect localIds from each selected cell and its descendants
            selection.forEachCell(function(cellNode, cellPos) {
                var _cellNode$attrs;
                var cellLocalId = (_cellNode$attrs = cellNode.attrs) === null || _cellNode$attrs === void 0 ? void 0 : _cellNode$attrs.localId;
                if (cellLocalId) _ids2.push(cellLocalId);
                cellNode.descendants(function(node) {
                    var _node$attrs2;
                    if (node.isInline) return false;
                    var localId = (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId;
                    if (localId) _ids2.push(localId);
                });
                // Collect ancestor localIds (row, table) separately
                var $cell = selection.$anchorCell.doc.resolve(cellPos + 1);
                for(var depth = $cell.depth - 1; depth >= 1; depth--){
                    var _ancestor$attrs;
                    var ancestor = $cell.node(depth);
                    var localId = (_ancestor$attrs = ancestor.attrs) === null || _ancestor$attrs === void 0 ? void 0 : _ancestor$attrs.localId;
                    if (localId) ancestorIds.add(localId);
                }
            });
            var uniqueIds = new Set(_ids2);
            var uniqueAncestors = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(ancestorIds).filter(function(id) {
                return !uniqueIds.has(id);
            });
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(uniqueIds), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(uniqueAncestors));
        }
    } else if (selection.empty) return [
        selection.$from.parent.attrs.localId
    ];
    var slice = (0, $gUIku.getSliceFromSelection)(selection);
    var content = slice.content;
    var ids = [];
    content.forEach(function(node) {
        var _node$attrs3;
        var localId = (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.localId;
        if (localId) ids.push(localId);
    });
    return ids;
};

});
parcelRegister("fwvBn", function(module, exports) {
$parcel$export(module.exports, "CellSelection", () => $b4d25baa1ccdc40b$export$831cc7e2a83afa94);

var $25nEq = parcelRequire("25nEq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $9Jwkl = parcelRequire("9Jwkl");

var $cc08P = parcelRequire("cc08P");

var $ilKuK = parcelRequire("ilKuK");

var $gkGnm = parcelRequire("gkGnm");

var $gLwm0 = parcelRequire("gLwm0");

var $8LyPa = parcelRequire("8LyPa");

var $1ukdt = parcelRequire("1ukdt");

var $60myh = parcelRequire("60myh");
function $b4d25baa1ccdc40b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b4d25baa1ccdc40b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b4d25baa1ccdc40b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b4d25baa1ccdc40b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b4d25baa1ccdc40b$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $b4d25baa1ccdc40b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $b4d25baa1ccdc40b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b4d25baa1ccdc40b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $b4d25baa1ccdc40b$export$831cc7e2a83afa94 = /*#__PURE__*/ function(_Selection) {
    // :: (ResolvedPos, ?ResolvedPos)
    // A table selection is identified by its anchor and head cells. The
    // positions given to this constructor should point _before_ two
    // cells in the same table. They may be the same, to select a single
    // cell.
    function CellSelection($anchorCell) {
        var _this;
        var $headCell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $anchorCell;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, CellSelection);
        var ranges = (0, $gLwm0.getCellSelectionRanges)($anchorCell, $headCell);
        _this = $b4d25baa1ccdc40b$var$_callSuper(this, CellSelection, [
            ranges[0].$from,
            ranges[0].$to,
            ranges
        ]);
        // :: ResolvedPos
        // A resolved position pointing _in front of_ the anchor cell (the one
        // that doesn't move when extending the selection).
        _this.$anchorCell = $anchorCell;
        // :: ResolvedPos
        // A resolved position pointing in front of the head cell (the one
        // moves when extending the selection).
        _this.$headCell = $headCell;
        _this.visible = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(CellSelection, _Selection);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(CellSelection, [
        {
            key: "map",
            value: function map(doc, mapping) {
                var $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
                var $headCell = doc.resolve(mapping.map(this.$headCell.pos));
                if ((0, $1ukdt.pointsAtCell)($anchorCell) && (0, $1ukdt.pointsAtCell)($headCell) && (0, $8LyPa.inSameTable)($anchorCell, $headCell)) {
                    var tableChanged = this.$anchorCell.node(-1) !== $anchorCell.node(-1);
                    if (tableChanged && this.isRowSelection()) return CellSelection.rowSelection($anchorCell, $headCell);
                    if (tableChanged && this.isColSelection()) return CellSelection.colSelection($anchorCell, $headCell);
                    return new CellSelection($anchorCell, $headCell);
                }
                return (0, $cc08P.TextSelection).between($anchorCell, $headCell);
            }
        },
        {
            key: "content",
            value: function content() {
                var table = this.$anchorCell.node(-1);
                var map = (0, $gkGnm.TableMap).get(table);
                var start = this.$anchorCell.start(-1);
                var rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
                var seen = {};
                var rows = [];
                for(var row = rect.top; row < rect.bottom; row++){
                    var rowContent = [];
                    for(var index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++){
                        var pos = map.map[index];
                        if (!seen[pos]) {
                            seen[pos] = true;
                            var cellRect = map.findCell(pos);
                            var cell = table.nodeAt(pos);
                            if (cell === null || cell === undefined) throw new Error("No cell at position ".concat(pos));
                            var extraLeft = rect.left - cellRect.left;
                            var extraRight = cellRect.right - rect.right;
                            if (extraLeft > 0 || extraRight > 0) {
                                var _cell = cell, attrs = _cell.attrs;
                                if (!attrs) throw new Error("No cell at position ".concat(pos));
                                if (extraLeft > 0) attrs = (0, $60myh.removeColSpan)(attrs, 0, extraLeft);
                                if (extraRight > 0) // Ignored via go/ees005
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                attrs = (0, $60myh.removeColSpan)(attrs, attrs.colspan - extraRight, extraRight);
                                if (cellRect.left < rect.left) cell = cell.type.createAndFill(attrs);
                                else cell = cell.type.create(attrs, cell.content);
                            }
                            if (cell === null || cell === undefined) throw new Error("No cell at position after create/createAndFill");
                            if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
                                var _attrs = $b4d25baa1ccdc40b$var$_objectSpread($b4d25baa1ccdc40b$var$_objectSpread({}, cell.attrs), {}, {
                                    rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
                                });
                                if (cellRect.top < rect.top) cell = cell.type.createAndFill(_attrs);
                                else cell = cell.type.create(_attrs, cell.content);
                            }
                            if (cell === null || cell === undefined) throw new Error("No cell at position before rowContent.push");
                            rowContent.push(cell);
                        }
                    }
                    var rowNode = table.child(row).copy((0, $9Jwkl.Fragment).from(rowContent));
                    rows.push(rowNode);
                }
                var fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
                return new (0, $9Jwkl.Slice)((0, $9Jwkl.Fragment).from(fragment), 1, 1);
            }
        },
        {
            key: "replace",
            value: function replace(tr) {
                var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $9Jwkl.Slice).empty;
                var mapFrom = tr.steps.length;
                var ranges = this.ranges;
                for(var i = 0; i < ranges.length; i++){
                    var _ranges$i = ranges[i], $from = _ranges$i.$from, $to = _ranges$i.$to;
                    var mapping = tr.mapping.slice(mapFrom);
                    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $9Jwkl.Slice).empty : content);
                }
                var sel = (0, $cc08P.Selection).findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
                if (sel) tr.setSelection(sel);
            }
        },
        {
            key: "replaceWith",
            value: function replaceWith(tr, node) {
                this.replace(tr, new (0, $9Jwkl.Slice)((0, $9Jwkl.Fragment).from(node), 0, 0));
            }
        },
        {
            key: "forEachCell",
            value: function forEachCell(f) {
                var table = this.$anchorCell.node(-1);
                var map = (0, $gkGnm.TableMap).get(table);
                var start = this.$anchorCell.start(-1);
                var cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
                for(var i = 0; i < cells.length; i++){
                    var cell = table.nodeAt(cells[i]);
                    if (cell === null || cell === undefined) throw new Error("undefined cell at pos ".concat(cells[i]));
                    f(cell, start + cells[i]);
                }
            }
        },
        {
            key: "isColSelection",
            value: function isColSelection() {
                if (!this.$anchorCell || !this.$headCell) throw new Error('invalid $anchorCell or $headCell');
                var anchorTop = this.$anchorCell.index(-1);
                var headTop = this.$headCell.index(-1);
                if (Math.min(anchorTop, headTop) > 0) return false;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                var anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                var headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
                return Math.max(anchorBot, headBot) === this.$headCell.node(-1).childCount;
            }
        },
        {
            key: "isRowSelection",
            value: // :: () → bool
            // True if this selection goes all the way from the left to the
            // right of the table.
            function isRowSelection() {
                if (!this.$anchorCell || !this.$headCell) return false;
                var start = this.$anchorCell.start(-1);
                var map = (0, $gkGnm.TableMap).get(this.$anchorCell.node(-1));
                var rowAtAnchorCell = map.rowCount(this.$anchorCell.pos - start);
                var rowAtHeadCell = map.rowCount(this.$headCell.pos - start);
                var isSelectionSameRow = rowAtAnchorCell === rowAtHeadCell;
                // if anchor and head in the same line, counting how many cells
                // should be in the row except merged cell
                var maxColumnInSelectedRow = map.getMaxColInRow(this.$anchorCell);
                // if selected cells less than table max column amount, and
                // the anchor/head not in a merged cell
                // it should be select maxColumnInSelectedRow to be TRUE
                if (isSelectionSameRow && this.ranges.length <= map.width && !map.isPosMerged(this.$anchorCell.pos - start) && !map.isPosMerged(this.$headCell.pos - start)) return this.ranges.length === maxColumnInSelectedRow;
                // If anchor and head in different row, it should be always in first and
                // last column to select the whole row.
                var anchorLeft = map.colCount(this.$anchorCell.pos - start);
                var headLeft = map.colCount(this.$headCell.pos - start);
                if (Math.min(anchorLeft, headLeft) > 0) return false;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                var anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                var headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
                return Math.max(anchorRight, headRight) === map.width;
            }
        },
        {
            key: "eq",
            value: function eq(other) {
                return other instanceof CellSelection && other.$anchorCell.pos === this.$anchorCell.pos && other.$headCell.pos === this.$headCell.pos;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    type: 'cell',
                    anchor: this.$anchorCell.pos,
                    head: this.$headCell.pos
                };
            }
        },
        {
            key: "getBookmark",
            value: function getBookmark() {
                return new (0, $ilKuK.CellBookmark)(this.$anchorCell.pos, this.$headCell.pos);
            }
        }
    ], [
        {
            key: "colSelection",
            value: function colSelection($anchorCell) {
                var $headCell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $anchorCell;
                var $calculatedAnchorCell = $anchorCell;
                var $calculatedHeadCell = $headCell;
                var map = (0, $gkGnm.TableMap).get($calculatedAnchorCell.node(-1));
                var start = $calculatedAnchorCell.start(-1);
                var anchorRect = map.findCell($calculatedAnchorCell.pos - start);
                var headRect = map.findCell($calculatedHeadCell.pos - start);
                var doc = $calculatedAnchorCell.node(0);
                if (anchorRect.top <= headRect.top) {
                    if (anchorRect.top > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.left]);
                    if (headRect.bottom < map.height) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]);
                } else {
                    if (headRect.top > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.left]);
                    if (anchorRect.bottom < map.height) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
                }
                return new CellSelection($calculatedAnchorCell, $calculatedHeadCell);
            }
        },
        {
            key: "rowSelection",
            value: function rowSelection($anchorCell) {
                var $headCell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $anchorCell;
                var reverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var $calculatedAnchorCell = $anchorCell;
                var $calculatedHeadCell = $headCell;
                var map = (0, $gkGnm.TableMap).get($calculatedAnchorCell.node(-1));
                var start = $calculatedAnchorCell.start(-1);
                var anchorRect = map.findCell($calculatedAnchorCell.pos - start);
                var headRect = map.findCell($calculatedHeadCell.pos - start);
                var doc = $calculatedAnchorCell.node(0);
                if (anchorRect.left <= headRect.left) {
                    if (anchorRect.left > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]);
                    if (headRect.right < map.width) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]);
                } else {
                    if (headRect.left > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.top * map.width]);
                    if (anchorRect.right < map.width) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]);
                }
                return reverse ? new CellSelection($calculatedHeadCell, $calculatedAnchorCell) : new CellSelection($calculatedAnchorCell, $calculatedHeadCell);
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(doc, json) {
                return new CellSelection(doc.resolve(json.anchor), doc.resolve(json.head));
            }
        },
        {
            key: "create",
            value: function create(doc, anchorCell) {
                var headCell = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : anchorCell;
                return new CellSelection(doc.resolve(anchorCell), doc.resolve(headCell));
            }
        }
    ]);
}((0, $cc08P.Selection));
(0, $cc08P.Selection).jsonID('cell', $b4d25baa1ccdc40b$export$831cc7e2a83afa94);

});
parcelRegister("ilKuK", function(module, exports) {
$parcel$export(module.exports, "CellBookmark", () => $d5be41131738196c$export$ca751a6394ad160e);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $cc08P = parcelRequire("cc08P");

var $8LyPa = parcelRequire("8LyPa");
var $d5be41131738196c$export$ca751a6394ad160e = /*#__PURE__*/ function() {
    function CellBookmark(anchor, head) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, CellBookmark);
        this.anchor = anchor;
        this.head = head;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(CellBookmark, [
        {
            key: "map",
            value: function map(mapping) {
                return new CellBookmark(mapping.map(this.anchor), mapping.map(this.head));
            }
        },
        {
            key: "resolve",
            value: function resolve(doc) {
                var $anchorCell = doc.resolve(this.anchor);
                var $headCell = doc.resolve(this.head);
                if ($anchorCell.parent.type.spec.tableRole === 'row' && $headCell.parent.type.spec.tableRole === 'row' && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && (0, $8LyPa.inSameTable)($anchorCell, $headCell)) {
                    var data = {
                        type: 'cell',
                        anchor: $anchorCell.pos,
                        head: $headCell.pos
                    };
                    return (0, $cc08P.Selection).fromJSON(doc, data);
                }
                return (0, $cc08P.Selection).near($headCell, 1);
            }
        }
    ]);
}();

});
parcelRegister("8LyPa", function(module, exports) {
$parcel$export(module.exports, "inSameTable", () => $661db9e6fd10014f$export$debd62b44eb7e281);
function $661db9e6fd10014f$export$debd62b44eb7e281($a, $b) {
    return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
}

});


parcelRegister("gkGnm", function(module, exports) {
$parcel$export(module.exports, "TableProblemTypes", () => $be3f6291b33bf3ca$export$d8cd393a71edca79);
$parcel$export(module.exports, "tableNewColumnMinWidth", () => $be3f6291b33bf3ca$export$c60fae4049791eae);
$parcel$export(module.exports, "TableMap", () => $be3f6291b33bf3ca$export$493da463fed0a57a);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $hCU0I = parcelRequire("hCU0I");

var $5OadW = parcelRequire("5OadW");

var $c1UOn = parcelRequire("c1UOn");

var $e719i = parcelRequire("e719i");


var $be3f6291b33bf3ca$export$d8cd393a71edca79 = /*#__PURE__*/ function(TableProblemTypes) {
    TableProblemTypes["COLLISION"] = "collision";
    TableProblemTypes["OVERLONG_ROWSPAN"] = "overlong_rowspan";
    TableProblemTypes["MISSING"] = "missing";
    TableProblemTypes["COLWIDTH_MISMATCH"] = "colwidth mismatch";
    return TableProblemTypes;
}({});
var $be3f6291b33bf3ca$export$c60fae4049791eae = 140;
var $be3f6291b33bf3ca$export$493da463fed0a57a = /*#__PURE__*/ function() {
    function TableMap(width, height, map, problems, mapByColumn, mapByRow) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, TableMap);
        // The width of the table
        // The table's height
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "mapByColumn", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "mapByRow", []);
        this.width = width;
        this.height = height;
        this.mapByColumn = mapByColumn || [];
        this.mapByRow = mapByRow || [];
        // :: [number] A width * height array with the start position of
        // the cell covering that part of the table in each slot
        this.map = map;
        // An optional array of problems (cell overlap or non-rectangular
        // shape) for the table, used by the table normalizer.
        this.problems = problems;
    }
    // :: (number) → Rect
    // Find the dimensions of the cell at the given position.
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(TableMap, [
        {
            key: "findCell",
            value: function findCell(pos) {
                for(var i = 0; i < this.map.length; i++){
                    var curPos = this.map[i];
                    if (curPos !== pos) continue;
                    var left = i % this.width;
                    var top = i / this.width | 0;
                    var right = left + 1;
                    var bottom = top + 1;
                    for(var j = 1; right < this.width && this.map[i + j] === curPos; j++)right++;
                    for(var _j = 1; bottom < this.height && this.map[i + this.width * _j] === curPos; _j++)bottom++;
                    return new (0, $e719i.Rect)(left, top, right, bottom);
                }
                throw new RangeError('No cell with offset ' + pos + ' found');
            }
        },
        {
            key: "colCount",
            value: function colCount(pos) {
                for(var i = 0; i < this.map.length; i++){
                    if (this.map[i] === pos) return i % this.width;
                }
                throw new RangeError('No cell with offset ' + pos + ' found');
            }
        },
        {
            key: "rowCount",
            value: function rowCount(pos) {
                if (this.width <= 0) throw new RangeError('Wrong table width found');
                for(var i = 0; i < this.map.length; i++){
                    if (this.map[i] === pos) return Math.floor(i / this.width);
                }
                throw new RangeError('No cell with offset ' + pos + ' found');
            }
        },
        {
            key: "isPosMerged",
            value: function isPosMerged(pos) {
                return this.map.includes(pos, this.map.indexOf(pos) + 1);
            }
        },
        {
            key: "isCellMerged",
            value: function isCellMerged(row, col) {
                return this.isCellMergedTopLeft(row, col) || this.isCellMergedBottomRight(row, col);
            }
        },
        {
            key: "isCellMergedTopLeft",
            value: function isCellMergedTopLeft(row, col) {
                var pos = this.map[row * this.width + col];
                return(// top
                row > 0 && pos === this.map[(row - 1) * this.width + col] || // left
                col > 0 && pos === this.map[row * this.width + (col - 1)]);
            }
        },
        {
            key: "isCellMergedBottomRight",
            value: function isCellMergedBottomRight(row, col) {
                var pos = this.map[row * this.width + col];
                return(// bottom
                row < this.height - 1 && pos === this.map[(row + 1) * this.width + col] || // right
                col < this.width - 1 && pos === this.map[row * this.width + (col + 1)]);
            }
        },
        {
            key: "nextCell",
            value: function nextCell(pos, axis, dir) {
                var _this$findCell = this.findCell(pos), left = _this$findCell.left, right = _this$findCell.right, top = _this$findCell.top, bottom = _this$findCell.bottom;
                if (axis === 'horiz') {
                    if (dir < 0 ? left === 0 : right === this.width) return null;
                    return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
                } else {
                    if (dir < 0 ? top === 0 : bottom === this.height) return null;
                    return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
                }
            }
        },
        {
            key: "rectBetween",
            value: function rectBetween(a, b) {
                var _this$findCell2 = this.findCell(a), leftA = _this$findCell2.left, rightA = _this$findCell2.right, topA = _this$findCell2.top, bottomA = _this$findCell2.bottom;
                var _this$findCell3 = this.findCell(b), leftB = _this$findCell3.left, rightB = _this$findCell3.right, topB = _this$findCell3.top, bottomB = _this$findCell3.bottom;
                return new (0, $e719i.Rect)(Math.min(leftA, leftB), Math.min(topA, topB), Math.max(rightA, rightB), Math.max(bottomA, bottomB));
            }
        },
        {
            key: "cellsInRect",
            value: function cellsInRect(rect) {
                var result = [];
                var seen = {};
                for(var row = rect.top; row < rect.bottom; row++)for(var col = rect.left; col < rect.right; col++){
                    var index = row * this.width + col;
                    var pos = this.map[index];
                    if (seen[pos]) continue;
                    seen[pos] = true;
                    if ((col !== rect.left || !col || this.map[index - 1] !== pos) && (row !== rect.top || !row || this.map[index - this.width] !== pos)) result.push(pos);
                }
                return result;
            }
        },
        {
            key: "positionAt",
            value: function positionAt(row, col, table) {
                for(var i = 0, rowStart = 0;; i++){
                    var rowEnd = rowStart + table.child(i).nodeSize;
                    if (i === row) {
                        var index = col + row * this.width;
                        var rowEndIndex = (row + 1) * this.width;
                        // Skip past cells from previous rows (via rowspan)
                        while(index < rowEndIndex && this.map[index] < rowStart)index++;
                        return index === rowEndIndex ? rowEnd - 1 : this.map[index];
                    }
                    rowStart = rowEnd;
                }
            }
        },
        {
            key: "getMaxColInRow",
            value: function getMaxColInRow(pos) {
                var parentRowNode = pos.parent;
                if (parentRowNode.type.name === 'tableRow') return parentRowNode.childCount;
            }
        },
        {
            key: "hasMergedCells",
            value: function hasMergedCells() {
                var uniquePositions = new Set(this.map);
                return uniquePositions.size !== this.map.length;
            }
        }
    ], [
        {
            key: "get",
            value: function get(table) {
                return (0, $c1UOn.readFromCache)(table) || (0, $hCU0I.addToCache)(table, (0, $5OadW.computeMap)(table));
            }
        }
    ]);
}();

});
parcelRegister("hCU0I", function(module, exports) {
$parcel$export(module.exports, "addToCache", () => $cd516ecab437c721$export$d6414c810925a1da);

var $5PCTp = parcelRequire("5PCTp");
function $cd516ecab437c721$export$d6414c810925a1da(key, value) {
    return (0, $5PCTp.tableMapCache).set(key, value);
}

});
parcelRegister("5PCTp", function(module, exports) {
$parcel$export(module.exports, "tableMapCache", () => $43efe26e59651e95$export$8972ebb43002a388);

var $iYJcE = parcelRequire("iYJcE");
// Share the same cache between readers and writers. Table maps are relative to
// immutable table nodes, so changing the document produces a different key.
var $43efe26e59651e95$var$readFromCache;
var $43efe26e59651e95$var$addToCache;
if (typeof WeakMap !== 'undefined') {
    var $43efe26e59651e95$var$cache = new WeakMap();
    $43efe26e59651e95$var$readFromCache = function readFromCache(key) {
        return $43efe26e59651e95$var$cache.get(key);
    };
    $43efe26e59651e95$var$addToCache = function addToCache(key, value) {
        $43efe26e59651e95$var$cache.set(key, value);
        return value;
    };
} else {
    // The original fallback stores five pairs in a ten-slot circular cache.
    var $43efe26e59651e95$var$_cache = [];
    var $43efe26e59651e95$var$cacheSize = 5;
    var $43efe26e59651e95$var$cachePos = 0;
    $43efe26e59651e95$var$readFromCache = function readFromCache(key) {
        for(var _i = 0, _cache2 = $43efe26e59651e95$var$_cache; _i < _cache2.length; _i++){
            var _cache2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_cache2[_i], 2), node = _cache2$_i[0], map = _cache2$_i[1];
            if (node === key) return map;
        }
        return undefined;
    };
    $43efe26e59651e95$var$addToCache = function addToCache(key, value) {
        if ($43efe26e59651e95$var$cachePos === $43efe26e59651e95$var$cacheSize) $43efe26e59651e95$var$cachePos = 0;
        $43efe26e59651e95$var$_cache[$43efe26e59651e95$var$cachePos++] = [
            key,
            value
        ];
        return value;
    };
}
var $43efe26e59651e95$export$8972ebb43002a388 = {
    get: $43efe26e59651e95$var$readFromCache,
    set: $43efe26e59651e95$var$addToCache
};

});


parcelRegister("5OadW", function(module, exports) {
$parcel$export(module.exports, "computeMap", () => $43a98d8632055c00$export$b00423e42c344284);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $nSczk = parcelRequire("nSczk");

var $jCMom = parcelRequire("jCMom");

var $gkGnm = parcelRequire("gkGnm");
function $43a98d8632055c00$export$b00423e42c344284(table) {
    if (table.type.spec.tableRole !== 'table') throw new RangeError('Not a table node: ' + table.type.name);
    var width = (0, $jCMom.findWidth)(table);
    var height = table.childCount;
    var map = [];
    var colWidths = [];
    var mapPos = 0, problems = null;
    for(var i = 0, e = width * height; i < e; i++)map[i] = 0;
    for(var row = 0, pos = 0; row < height; row++){
        var rowNode = table.child(row);
        pos++;
        for(var _i = 0;; _i++){
            while(mapPos < map.length && map[mapPos] !== 0)mapPos++;
            if (_i === rowNode.childCount) break;
            var cellNode = rowNode.child(_i), _cellNode$attrs = cellNode.attrs, colspan = _cellNode$attrs.colspan, rowspan = _cellNode$attrs.rowspan, colwidth = _cellNode$attrs.colwidth;
            for(var h = 0; h < rowspan; h++){
                if (h + row >= height) {
                    (problems || (problems = [])).push({
                        type: (0, $gkGnm.TableProblemTypes).OVERLONG_ROWSPAN,
                        pos: pos,
                        n: rowspan - h
                    });
                    break;
                }
                var start = mapPos + h * width;
                for(var w = 0; w < colspan; w++){
                    if (map[start + w] === 0) map[start + w] = pos;
                    else (problems || (problems = [])).push({
                        type: (0, $gkGnm.TableProblemTypes).COLLISION,
                        row: row,
                        pos: pos,
                        n: colspan - w
                    });
                    var colW = colwidth && colwidth[w];
                    if (colW) {
                        var widthIndex = (start + w) % width * 2, prev = colWidths[widthIndex];
                        if (prev == null || prev !== colW && colWidths[widthIndex + 1] === 1) {
                            colWidths[widthIndex] = colW;
                            colWidths[widthIndex + 1] = 1;
                        } else if (prev === colW) colWidths[widthIndex + 1]++;
                    }
                }
            }
            mapPos += colspan;
            pos += cellNode.nodeSize;
        }
        var expectedPos = (row + 1) * width;
        var missing = 0;
        while(mapPos < expectedPos)if (map[mapPos++] === 0) missing++;
        if (missing) (problems || (problems = [])).push({
            type: (0, $gkGnm.TableProblemTypes).MISSING,
            row: row,
            n: missing
        });
        pos++;
    }
    var mapByRow = Array(height);
    var mapByColumn = Array(width);
    for(var _i2 = 0; _i2 < map.length; _i2++){
        var _mapByColumn$columnIn, _mapByRow$rowIndex;
        var columnIndex = _i2 % width;
        mapByColumn[columnIndex] = (_mapByColumn$columnIn = mapByColumn[columnIndex]) !== null && _mapByColumn$columnIn !== void 0 ? _mapByColumn$columnIn : [];
        mapByColumn[columnIndex].push(map[_i2]);
        var rowIndex = Math.trunc(_i2 / width);
        mapByRow[rowIndex] = (_mapByRow$rowIndex = mapByRow[rowIndex]) !== null && _mapByRow$rowIndex !== void 0 ? _mapByRow$rowIndex : [];
        mapByRow[rowIndex].push(map[_i2]);
    }
    var tableMap = new (0, $gkGnm.TableMap)(width, height, map, problems, mapByColumn, mapByRow);
    var badWidths = false;
    // For columns that have defined widths, but whose widths disagree
    // between rows, fix up the cells whose width doesn't match the
    // computed one.
    for(var _i3 = 0; !badWidths && _i3 < colWidths.length; _i3 += 2)if (colWidths[_i3] != null && colWidths[_i3 + 1] < height) badWidths = true;
    // colWidths is an array of numbers, it can look like this
    // const colWidths = [255, 3, 125, 3, 150, 2, 130, 1];
    // 255 is a colWidth and 3 is a number of cells with this colwidth.
    // This check exists to make sure that the table has been resized,
    // which means there will be elements in the colWidths array.
    if (colWidths.length > 0 && colWidths.length !== width * 2) {
        for(var _i4 = 0; _i4 < width * 2 - colWidths.length; _i4++)colWidths.push((0, $gkGnm.tableNewColumnMinWidth), 0);
        badWidths = true;
    }
    if (badWidths) (0, $nSczk.findBadColWidths)(tableMap, colWidths, table);
    return tableMap;
}

});
parcelRegister("nSczk", function(module, exports) {
$parcel$export(module.exports, "findBadColWidths", () => $047c316e113e50fe$export$3c60fa892a0c95fe);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $gkGnm = parcelRequire("gkGnm");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $047c316e113e50fe$var$freshColWidth(attrs) {
    if (attrs.colwidth) return attrs.colwidth.slice();
    var result = [];
    for(var i = 0; i < attrs.colspan; i++)result.push(0);
    return result;
}
function $047c316e113e50fe$export$3c60fa892a0c95fe(map, colWidths, table) {
    if (!map.problems) map.problems = [];
    var seen = {};
    for(var i = 0; i < map.map.length; i++){
        var pos = map.map[i];
        if (seen[pos]) continue;
        seen[pos] = true;
        var node = table.nodeAt(pos);
        var updated = null;
        for(var j = 0; j < node.attrs.colspan; j++){
            var col = (i + j) % map.width, colWidth = colWidths[col * 2];
            if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] !== colWidth)) (updated || (updated = $047c316e113e50fe$var$freshColWidth(node.attrs)))[j] = colWidth;
        }
        if (updated) map.problems.unshift({
            type: (0, $gkGnm.TableProblemTypes).COLWIDTH_MISMATCH,
            pos: pos,
            colwidth: updated
        });
    }
}

});

parcelRegister("jCMom", function(module, exports) {
$parcel$export(module.exports, "findWidth", () => $e4971a94aeaa6c52$export$f7bee8f27db3cd05);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
function $e4971a94aeaa6c52$export$f7bee8f27db3cd05(table) {
    var width = -1;
    var hasRowSpan = false;
    for(var row = 0; row < table.childCount; row++){
        var rowNode = table.child(row);
        var rowWidth = 0;
        if (hasRowSpan) for(var j = 0; j < row; j++){
            var prevRow = table.child(j);
            for(var i = 0; i < prevRow.childCount; i++){
                var cell = prevRow.child(i);
                if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
            }
        }
        for(var _i = 0; _i < rowNode.childCount; _i++){
            var _cell = rowNode.child(_i);
            rowWidth += _cell.attrs.colspan;
            if (_cell.attrs.rowspan > 1) hasRowSpan = true;
        }
        if (width === -1) width = rowWidth;
        else if (width !== rowWidth) width = Math.max(width, rowWidth);
    }
    return width;
}

});


parcelRegister("c1UOn", function(module, exports) {
$parcel$export(module.exports, "readFromCache", () => $8c21a5a2c776030b$export$42a80a4a4ad0dbe3);

var $5PCTp = parcelRequire("5PCTp");
function $8c21a5a2c776030b$export$42a80a4a4ad0dbe3(key) {
    return (0, $5PCTp.tableMapCache).get(key);
}

});

parcelRegister("e719i", function(module, exports) {
$parcel$export(module.exports, "Rect", () => $a4629c443f3e4a59$export$c79fc6492f3af13d);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");
var $a4629c443f3e4a59$export$c79fc6492f3af13d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(function Rect(left, top, right, bottom) {
    (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Rect);
    this.left = left;
    this.top = top;
    this.right = right;
    this.bottom = bottom;
});

});


parcelRegister("gLwm0", function(module, exports) {
$parcel$export(module.exports, "getCellSelectionRanges", () => $c34a21f50a4a8dbc$export$a60a444208fd5099);

var $cc08P = parcelRequire("cc08P");

var $gkGnm = parcelRequire("gkGnm");
function $c34a21f50a4a8dbc$export$a60a444208fd5099($anchorCell, $headCell) {
    var table = $anchorCell.node(-1);
    var map = (0, $gkGnm.TableMap).get(table);
    var start = $anchorCell.start(-1);
    var rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    var doc = $anchorCell.node(0);
    var cells = map.cellsInRect(rect).filter(function(p) {
        return p !== $headCell.pos - start;
    });
    // Make the head cell the first range, so that it counts as the
    // primary part of the selection
    cells.unshift($headCell.pos - start);
    return cells.map(function(pos) {
        var cell = table.nodeAt(pos);
        if (cell === null) throw new Error("No cell at position ".concat(pos));
        var from = pos + start + 1;
        return new (0, $cc08P.SelectionRange)(doc.resolve(from), doc.resolve(from + cell.content.size));
    });
}

});

parcelRegister("1ukdt", function(module, exports) {
$parcel$export(module.exports, "pointsAtCell", () => $115846504c16103b$export$3c89e45c7dff9619);
function $115846504c16103b$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}

});

parcelRegister("60myh", function(module, exports) {
$parcel$export(module.exports, "removeColSpan", () => $45f43c7d7bd8f271$export$b24d9c3cc95412e0);

var $25nEq = parcelRequire("25nEq");
function $45f43c7d7bd8f271$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $45f43c7d7bd8f271$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $45f43c7d7bd8f271$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $45f43c7d7bd8f271$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $45f43c7d7bd8f271$export$b24d9c3cc95412e0(attrs, pos) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    if (!attrs.colspan) throw new Error('removeColSpan(): attrs.colspan not defined');
    var result = $45f43c7d7bd8f271$var$_objectSpread($45f43c7d7bd8f271$var$_objectSpread({}, attrs), {}, {
        colspan: attrs.colspan - n
    });
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        result.colwidth.splice(pos, n);
        if (!result.colwidth.some(function(w) {
            return w > 0;
        })) result.colwidth = undefined;
    }
    return result;
}

});







parcelRegister("2pzUn", function(module, exports) {
$parcel$export(module.exports, "useAnnotationStateByTypeEvent", () => $1c19c53ae2ba15da$export$95f9f9045e92d283);
$parcel$export(module.exports, "useHasFocusEvent", () => $1c19c53ae2ba15da$export$48f5d7f6702be07c);
$parcel$export(module.exports, "useAnnotationClickEvent", () => $1c19c53ae2ba15da$export$26cf539704e444c1);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $kX1mK = parcelRequire("kX1mK");

var $6EZ2P = parcelRequire("6EZ2P");

var $jJH6F = parcelRequire("jJH6F");

var $1xyIw = parcelRequire("1xyIw");

var $fDwDe = parcelRequire("fDwDe");
function $1c19c53ae2ba15da$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1c19c53ae2ba15da$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1c19c53ae2ba15da$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1c19c53ae2ba15da$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1c19c53ae2ba15da$export$95f9f9045e92d283 = function useAnnotationStateByTypeEvent(_ref) {
    var type = _ref.type, updateSubscriber = _ref.updateSubscriber;
    var _useState = (0, $5FkrB.useState)({}), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), states = _useState2[0], setStates = _useState2[1];
    var _useAnnotationManager = (0, $fDwDe.useAnnotationManagerDispatch)(), annotationManager = _useAnnotationManager.annotationManager, dispatch = _useAnnotationManager.dispatch;
    var _useAnnotationManager2 = (0, $fDwDe.useAnnotationManagerState)(), annotations = _useAnnotationManager2.annotations;
    var isAnnotationManagerEnabled = !!annotationManager;
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!updateSubscriber) return;
        var cb = function cb(payload) {
            if (!payload) return;
            var nextStates = Object.values(payload).reduce(function(acc, curr) {
                if (curr.id && curr.annotationType === type) {
                    // Check for empty state to prevent additional renders
                    var isEmpty = curr.state === null || curr.state === undefined;
                    return $1c19c53ae2ba15da$var$_objectSpread($1c19c53ae2ba15da$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, curr.id, !isEmpty ? curr.state : states[curr.id]));
                }
                return acc;
            }, {});
            setStates($1c19c53ae2ba15da$var$_objectSpread($1c19c53ae2ba15da$var$_objectSpread({}, states), nextStates));
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            return function() {
                updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            };
        }
    }, [
        states,
        type,
        updateSubscriber,
        dispatch,
        isAnnotationManagerEnabled
    ]);
    var annotationMarkStates = (0, $5FkrB.useMemo)(function() {
        return Object.values(annotations).reduce(function(acc, curr) {
            return $1c19c53ae2ba15da$var$_objectSpread($1c19c53ae2ba15da$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, curr.id, curr.markState));
        }, {});
    }, [
        annotations
    ]);
    if (isAnnotationManagerEnabled) return annotationMarkStates;
    else return states;
};
var $1c19c53ae2ba15da$export$48f5d7f6702be07c = function useHasFocusEvent(_ref2) {
    var id = _ref2.id, updateSubscriber = _ref2.updateSubscriber;
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), hasFocus = _useState4[0], setHasFocus = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), isHovered = _useState6[0], setIsHovered = _useState6[1];
    var _useAnnotationManager3 = (0, $fDwDe.useAnnotationManagerState)(), currentSelectedAnnotationId = _useAnnotationManager3.currentSelectedAnnotationId, currentHoveredAnnotationId = _useAnnotationManager3.currentHoveredAnnotationId;
    var _useAnnotationManager4 = (0, $fDwDe.useAnnotationManagerDispatch)(), annotationManager = _useAnnotationManager4.annotationManager;
    var isAnnotationManagerEnabled = !!annotationManager;
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!updateSubscriber) return;
        var cb = function cb(payload) {
            setHasFocus(payload && payload.annotationId === id);
        };
        var callbackForHoveredAnnotation = function callbackForHoveredAnnotation(payload) {
            setIsHovered(payload && payload.annotationId === id);
        };
        var removeFocus = function removeFocus() {
            setHasFocus(false);
        };
        var removeHoverEffect = function removeHoverEffect() {
            setIsHovered(false);
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
            updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
            updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
            updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, removeHoverEffect);
            return function() {
                updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
                updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
                updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
                updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, removeHoverEffect);
            };
        }
    }, [
        id,
        updateSubscriber,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return {
        hasFocus: currentSelectedAnnotationId === id,
        isHovered: currentHoveredAnnotationId === id
    };
    else return {
        hasFocus: hasFocus,
        isHovered: isHovered
    };
};
var $1c19c53ae2ba15da$var$NO_ANNOTATION_SELECTED = {
    annotations: [],
    clickElementTarget: undefined
};
var $1c19c53ae2ba15da$export$26cf539704e444c1 = function useAnnotationClickEvent(props) {
    var _useState7 = (0, $5FkrB.useState)(null), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState7, 2), annotationClickEvent = _useState8[0], setAnnotationClickEvent = _useState8[1];
    var updateSubscriber = props.updateSubscriber, createAnalyticsEvent = props.createAnalyticsEvent, isNestedRender = props.isNestedRender;
    var _useAnnotationManager5 = (0, $fDwDe.useAnnotationManagerDispatch)(), annotationManager = _useAnnotationManager5.annotationManager;
    var isAnnotationManagerEnabled = !!annotationManager;
    var _useAnnotationManager6 = (0, $fDwDe.useAnnotationManagerState)(), currentSelectedAnnotationId = _useAnnotationManager6.currentSelectedAnnotationId, currentSelectedMarkRef = _useAnnotationManager6.currentSelectedMarkRef;
    var selectedAnnotation = (0, $5FkrB.useMemo)(function() {
        return currentSelectedAnnotationId && currentSelectedMarkRef && currentSelectedMarkRef.id === currentSelectedAnnotationId ? {
            annotations: [
                {
                    id: currentSelectedAnnotationId,
                    type: (0, $kX1mK.AnnotationTypes).INLINE_COMMENT
                }
            ],
            clickElementTarget: currentSelectedMarkRef
        } : // This is a constant to represent the case when no annotation is selected.
        // When creating a new annotation, currentSelectedAnnotationId and currentSelectedMarkRef will be set one after another,
        // if this isn't a const, it will cause useMemo to return two different "empty" objects and causes infinite re-renders.
        $1c19c53ae2ba15da$var$NO_ANNOTATION_SELECTED;
    }, [
        currentSelectedAnnotationId,
        currentSelectedMarkRef
    ]);
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!updateSubscriber || isNestedRender) return;
        var clickCb = function clickCb(_ref3) {
            var annotationIds = _ref3.annotationIds, eventTarget = _ref3.eventTarget, eventTargetType = _ref3.eventTargetType, viewMethod = _ref3.viewMethod;
            var annotationsByType = annotationIds.filter(function(id) {
                return !!id;
            }).map(function(id) {
                return {
                    id: id,
                    type: (0, $kX1mK.AnnotationTypes).INLINE_COMMENT
                };
            });
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $jJH6F.ACTION).VIEWED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $jJH6F.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: annotationsByType.length || 0,
                    targetNodeType: eventTargetType,
                    method: viewMethod
                }
            }).fire((0, $6EZ2P.FabricChannel).editor);
            setAnnotationClickEvent({
                annotations: annotationsByType,
                clickElementTarget: eventTarget
            });
        };
        var deselectCb = function deselectCb() {
            setAnnotationClickEvent({
                annotations: [],
                clickElementTarget: undefined
            });
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
            updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            return function() {
                updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
                updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            };
        }
    }, [
        updateSubscriber,
        createAnalyticsEvent,
        isNestedRender,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return isNestedRender ? null : selectedAnnotation;
    else return annotationClickEvent;
};

});

parcelRegister("71QIw", function(module, exports) {
$parcel$export(module.exports, "useInlineCommentSubscriberContext", () => $51e184ee0f1fdd60$export$b46737175cffd396);

var $5FkrB = parcelRequire("5FkrB");

var $gtPYB = parcelRequire("gtPYB");
var $51e184ee0f1fdd60$export$b46737175cffd396 = function useInlineCommentSubscriberContext() {
    var providers = (0, $5FkrB.useContext)((0, $gtPYB.ProvidersContext));
    if (!providers) return null;
    var updateSubscriber = providers.inlineComment.updateSubscriber;
    return updateSubscriber || null;
};

});

parcelRegister("8vb4Q", function(module, exports) {
$parcel$export(module.exports, "useInlineCommentsFilter", () => $6309cfab0c111d17$export$8e7d47f9e38ad4f1);

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $gtPYB = parcelRequire("gtPYB");
var $6309cfab0c111d17$export$8e7d47f9e38ad4f1 = function useInlineCommentsFilter(_ref) {
    var annotationIds = _ref.annotationIds, stateFilter = _ref.filter.state;
    var states = (0, $5FkrB.useContext)((0, $gtPYB.InlineCommentsStateContext));
    return (0, $5FkrB.useMemo)(function() {
        return annotationIds.reduce(function(acc, id) {
            if (states && states[id] === stateFilter) return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(acc), [
                id
            ]);
            return acc;
        }, []);
    }, [
        annotationIds,
        states,
        stateFilter
    ]);
};

});

parcelRegister("gn91R", function(module, exports) {
$parcel$export(module.exports, "MarkComponent", () => $beb5cc4ddf5a93f5$export$4f5a51511304fdd0);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $hrVKU = parcelRequire("hrVKU");

var $kX1mK = parcelRequire("kX1mK");

var $50U6m = parcelRequire("50U6m");

var $3cXxO = parcelRequire("3cXxO");

var $fDwDe = parcelRequire("fDwDe");
function $beb5cc4ddf5a93f5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $beb5cc4ddf5a93f5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $beb5cc4ddf5a93f5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $beb5cc4ddf5a93f5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $beb5cc4ddf5a93f5$var$markStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent'
}, "&[data-mark-annotation-state='".concat((0, $kX1mK.AnnotationMarkStates).ACTIVE, "']"), {
    // was from blur in AnnotationSharedCSSByState().blur
    background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    borderBottom: "var(--ds-border-width-selected, 2px)".concat(" solid ", "var(--ds-border-accent-yellow, #B38600)"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&[data-has-focus="true"]': {
        background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        borderBottom: "var(--ds-border-width-selected, 2px)".concat(" solid ", "var(--ds-border-accent-yellow, #B38600)"),
        // TODO: DSP-4147 - Annotation shadow
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
        cursor: 'pointer'
    }
}));
var $beb5cc4ddf5a93f5$var$markStylesLayeringFix = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "&[data-mark-annotation-state='".concat((0, $kX1mK.AnnotationMarkStates).ACTIVE, "']"), {
    // Only apply transparency to nested marks when parent is focused
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&[data-has-focus="true"] mark': {
        backgroundColor: 'transparent'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.fabric-background-color-mark &[data-has-focus="true"], &[data-has-focus="true"]': {
        background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
    }
}));
var $beb5cc4ddf5a93f5$var$markStylesWithUpdatedShadow = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "&[data-mark-annotation-state='".concat((0, $kX1mK.AnnotationMarkStates).ACTIVE, "']"), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&[data-has-focus="true"]': {
        background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
    }
}));
var $beb5cc4ddf5a93f5$var$markStylesWithInlineComments = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "&[data-mark-annotation-state='".concat((0, $kX1mK.AnnotationMarkStates).ACTIVE, "']"), {
    // was from common in AnnotationSharedCSSByState().common
    borderBottom: "var(--ds-border-width-selected, 2px)".concat(" solid transparent"),
    cursor: 'pointer',
    padding: "1px 0 ".concat("var(--ds-space-025, 2px)"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.card), &:has([data-inline-card])': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.date-lozenger-container)': {
        paddingTop: "var(--ds-space-025, 2px)"
    },
    // was from blur in AnnotationSharedCSSByState().blur
    background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&[data-has-focus="true"]': {
        background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
    }
}));
var $beb5cc4ddf5a93f5$var$markStylesWithCommentsPanel = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "&[data-mark-annotation-state='".concat((0, $kX1mK.AnnotationMarkStates).ACTIVE, "']"), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&[data-is-hovered="true"]:not([data-has-focus="true"])': {
        background: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
    }
}));
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $beb5cc4ddf5a93f5$var$MOBILE_USER_AGENT_REGEX = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
var $beb5cc4ddf5a93f5$var$isMobile = function isMobile() {
    return $beb5cc4ddf5a93f5$var$MOBILE_USER_AGENT_REGEX.test(navigator.userAgent);
};
var $beb5cc4ddf5a93f5$var$accessibilityStylesNew = (0, $74Zh5.css)({
    '&::before, &::after': {
        clipPath: 'inset(100%)',
        clip: 'rect(1px, 1px, 1px, 1px)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    },
    '&::before': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: [
            'var(--ak-renderer-annotation-startmarker)'
        ]
    },
    '&::after': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: [
            'var(--ak-renderer-annotation-endmarker)'
        ]
    }
});
var $beb5cc4ddf5a93f5$export$4f5a51511304fdd0 = function MarkComponent(_ref) {
    var annotationParentIds = _ref.annotationParentIds, children = _ref.children, dataAttributes = _ref.dataAttributes, id = _ref.id, state = _ref.state, hasFocus = _ref.hasFocus, isHovered = _ref.isHovered, onClick = _ref.onClick, useBlockLevel = _ref.useBlockLevel;
    var intl = (0, $hrVKU.default)();
    var annotationIds = (0, $5FkrB.useMemo)(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(annotationParentIds), [
            id
        ])));
    }, [
        id,
        annotationParentIds
    ]);
    var _useAnnotationManager = (0, $fDwDe.useAnnotationManagerDispatch)(), annotationManager = _useAnnotationManager.annotationManager, dispatch = _useAnnotationManager.dispatch;
    var _useAnnotationManager2 = (0, $fDwDe.useAnnotationManagerState)(), currentSelectedAnnotationId = _useAnnotationManager2.currentSelectedAnnotationId;
    var isAnnotationManagerEnabled = !!annotationManager;
    // after creating a new annotation, we need to set the markRef to the new mark
    var markRef = (0, $5FkrB.useCallback)(function(node) {
        if (id === currentSelectedAnnotationId && node) dispatch({
            type: 'setSelectedMarkRef',
            data: {
                markRef: node
            }
        });
    }, [
        dispatch,
        id,
        currentSelectedAnnotationId
    ]);
    var onMarkClick = (0, $5FkrB.useCallback)(function(event) {
        // prevent inline mark logic for media block marks
        if (event.currentTarget instanceof HTMLElement && event.currentTarget.getAttribute('data-block-mark')) return;
        // prevents multiple callback on overlapping annotations
        if (event.defaultPrevented || state !== (0, $kX1mK.AnnotationMarkStates).ACTIVE) return;
        if ((0, $50U6m.fg)('editor_inline_comments_on_inline_nodes')) // We only want to interfere with click events if the click is on some ui inside the renderer document
        // This is to prevent the click events from portaled content (such as link previews and mention profiles)
        {
            if (event.target instanceof HTMLElement && event.target.closest('.ak-renderer-document')) {
                if (event.target.closest('[data-mention-id]')) ;
                else {
                    // prevents from opening link URL inside webView in Safari
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        } else // prevents from opening link URL inside webView in Safari
        event.preventDefault();
        if (isAnnotationManagerEnabled) // currentTarget is the right element if there are multiple overlapping annotations
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.currentTarget,
            annotationIds: annotationIds
        });
        else // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.target,
            annotationIds: annotationIds
        });
    }, [
        annotationIds,
        onClick,
        state,
        isAnnotationManagerEnabled
    ]);
    var onMarkEnter = function onMarkEnter(evt) {
        var _document$activeEleme;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- keyboard focus for mark / Enter handling
        var focusedElementTag = (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.tagName;
        if (focusedElementTag === 'MARK' && evt.key === 'Enter') onMarkClick(evt);
    };
    var overriddenData = !state ? dataAttributes : $beb5cc4ddf5a93f5$var$_objectSpread($beb5cc4ddf5a93f5$var$_objectSpread({}, dataAttributes), {}, {
        'data-mark-annotation-state': state,
        'data-has-focus': hasFocus,
        'data-is-hovered': isHovered
    });
    var desktopAccessibilityAttributes = $beb5cc4ddf5a93f5$var$isMobile() ? {} : {
        role: 'button',
        tabIndex: 0,
        onKeyDown: onMarkEnter,
        'aria-expanded': hasFocus
    };
    var accessibility = state !== (0, $kX1mK.AnnotationMarkStates).ACTIVE ? {
        'aria-disabled': true
    } : $beb5cc4ddf5a93f5$var$_objectSpread({
        'aria-details': annotationIds.join(', ')
    }, desktopAccessibilityAttributes);
    return (0, $74Zh5.jsx)(useBlockLevel ? 'div' : 'mark', $beb5cc4ddf5a93f5$var$_objectSpread($beb5cc4ddf5a93f5$var$_objectSpread($beb5cc4ddf5a93f5$var$_objectSpread((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
        ref: id === currentSelectedAnnotationId ? markRef : undefined,
        id: id
    }, (0, $50U6m.fg)('editor_inline_comments_on_inline_nodes') ? 'onClickCapture' : 'onClick', onMarkClick), accessibility), overriddenData), !useBlockLevel && {
        css: [
            $beb5cc4ddf5a93f5$var$markStyles,
            $beb5cc4ddf5a93f5$var$markStylesLayeringFix,
            (0, $50U6m.fg)('editor_inline_comments_on_inline_nodes') && $beb5cc4ddf5a93f5$var$markStylesWithInlineComments,
            $beb5cc4ddf5a93f5$var$markStylesWithCommentsPanel,
            !$beb5cc4ddf5a93f5$var$isMobile() && $beb5cc4ddf5a93f5$var$accessibilityStylesNew,
            $beb5cc4ddf5a93f5$var$markStylesWithUpdatedShadow
        ],
        style: {
            '--ak-renderer-annotation-startmarker': "\"".concat(intl.formatMessage((0, $3cXxO.inlineCommentMessages).contentRendererInlineCommentMarkerStart), "\""),
            '--ak-renderer-annotation-endmarker': "\"".concat(intl.formatMessage((0, $3cXxO.inlineCommentMessages).contentRendererInlineCommentMarkerEnd), "\"")
        }
    }), children);
};

});
parcelRegister("3cXxO", function(module, exports) {
$parcel$export(module.exports, "collapsibleHeadingMessages", () => $2560ae608c660717$export$7f5b2987e1dbb312);
$parcel$export(module.exports, "headingAnchorLinkMessages", () => $2560ae608c660717$export$74bada844422036d);
$parcel$export(module.exports, "tableCellMessages", () => $2560ae608c660717$export$c79ebc36348824d1);
$parcel$export(module.exports, "inlineCommentMessages", () => $2560ae608c660717$export$9f52c375a6ef34fc);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $6bnW7 = parcelRequire("6bnW7");
var $2560ae608c660717$export$7f5b2987e1dbb312 = (0, $6bnW7.defineMessages)({
    collapseSection: {
        id: 'fabric.editor.collapsibleHeading.collapseSection.ai-non-final',
        defaultMessage: 'Collapse section',
        description: 'Accessible label and tooltip for the button beside an expanded renderer heading. Activating the button hides the content in that heading section.'
    },
    expandSection: {
        id: 'fabric.editor.collapsibleHeading.expandSection.ai-non-final',
        defaultMessage: 'Expand section',
        description: 'Accessible label and tooltip for the button beside a collapsed renderer heading. Activating the button reveals the content in that heading section.'
    }
});
var $2560ae608c660717$export$74bada844422036d = (0, $6bnW7.defineMessages)({
    copyHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copyAnchorLink',
        defaultMessage: 'Copy link to heading',
        description: 'Tooltip and aria-label for the button that copies an anchor link to a heading in the rendered document to the clipboard.'
    },
    copyLinkToClipboard: {
        id: 'fabric.editor.headingLink.copyAnchorLinkTo',
        defaultMessage: 'Copy link to',
        description: 'Copy heading link to clipboard. Will be used as part of a 2-part a11y label ("Copy link to", "{heading text}")'
    },
    copyHeadingLinkLabelledBy: {
        id: 'fabric.editor.headingLink.copyAnchorLinkLabelledBy',
        defaultMessage: '{copyLink} {heading}',
        description: 'The order in which to read the parts of the aria-labelledby for the copy heading link button depending on the grammar of the language. {copyLink} will be replaced with the "Copy link to" text and {heading} will be replaced with the actual heading text'
    },
    copiedHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copied',
        defaultMessage: 'Copied!',
        description: 'Confirmation text shown briefly on the copy button after the heading anchor link has been successfully copied to the clipboard.'
    },
    failedToCopyHeadingLink: {
        id: 'fabric.editor.headingLink.failedToCopy',
        defaultMessage: 'Copy failed',
        description: 'failed to copy heading link to clipboard'
    },
    copyAriaLabel: {
        id: 'fabric.editor.headingLink.copyAriaLabel',
        defaultMessage: 'Copy',
        description: 'Aria label for the copy link button displayed next to a heading. Used by screen readers to describe the button that copies the heading anchor link to the clipboard.'
    }
});
var $2560ae608c660717$export$c79ebc36348824d1 = (0, $6bnW7.defineMessages)({
    noneSortingLabel: {
        id: 'fabric.editor.headingLink.noneSortingLabel',
        defaultMessage: 'none',
        description: 'Accessible label for a table column sort indicator when no sorting is applied to that column.'
    },
    ascSortingLabel: {
        id: 'fabric.editor.headingLink.ascSortingLabel',
        defaultMessage: 'ascending',
        description: 'this table column is sorted in ascending order'
    },
    descSortingLabel: {
        id: 'fabric.editor.headingLink.descSortingLabel',
        defaultMessage: 'descending',
        description: 'this table column is sorted in descending order'
    }
});
var $2560ae608c660717$export$9f52c375a6ef34fc = (0, $6bnW7.defineMessages)({
    contentRendererInlineCommentMarkerStart: {
        id: 'fabric.editor.inlineComment.marker.start',
        defaultMessage: 'inline comment start',
        description: 'Starting marker to indicate that text is highlighted with an inline comment by a screen reader.'
    },
    contentRendererInlineCommentMarkerEnd: {
        id: 'fabric.editor.inlineComment.marker.end',
        defaultMessage: 'inline comment end',
        description: 'Ending marker to indicate that text was highlighted with an inline comment by a screen reader.'
    }
});

});




parcelRegister("jLsC1", function(module, exports) {
$parcel$export(module.exports, "useThemeObserver", () => $e63899ecc922e32c$export$3dd7971102e44fa8);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $hQjaP = parcelRequire("hQjaP");

var $1Za0O = parcelRequire("1Za0O");
var $e63899ecc922e32c$export$3dd7971102e44fa8 = function useThemeObserver() {
    var _useState = (0, $5FkrB.useState)((0, $hQjaP.getGlobalTheme)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        var observer = new (0, $1Za0O.default)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $e63899ecc922e32c$export$2e2bcd8739ae039 = $e63899ecc922e32c$export$3dd7971102e44fa8;

});
parcelRegister("hQjaP", function(module, exports) {
$parcel$export(module.exports, "getGlobalTheme", () => $cfd62a790ef0448a$export$813ecdf77207a053);

var $25nEq = parcelRequire("25nEq");

var $f3FlH = parcelRequire("f3FlH");

var $3eF5u = parcelRequire("3eF5u");

var $iblkR = parcelRequire("iblkR");
function $cfd62a790ef0448a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cfd62a790ef0448a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cfd62a790ef0448a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cfd62a790ef0448a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cfd62a790ef0448a$export$813ecdf77207a053 = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $f3FlH.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $f3FlH.THEME_DATA_ATTRIBUTE)) || '';
    return $cfd62a790ef0448a$var$_objectSpread($cfd62a790ef0448a$var$_objectSpread({}, (0, $iblkR.themeStringToObject)(theme)), (0, $3eF5u.isThemeColorMode)(colorMode) && {
        colorMode: colorMode
    });
};

});
parcelRegister("f3FlH", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $af6735e58aca415b$export$4ef52930e33717cd);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $af6735e58aca415b$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $af6735e58aca415b$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $af6735e58aca415b$export$352e418ed5b6193a);
var $af6735e58aca415b$export$4ef52930e33717cd = 'data-theme';
var $af6735e58aca415b$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $af6735e58aca415b$export$a00eac3f8684bcd0 = 'data-color-mode';
var $af6735e58aca415b$export$2112803007239c61 = 'data-contrast-mode';
var $af6735e58aca415b$export$352e418ed5b6193a = 'data-custom-theme';
var $af6735e58aca415b$export$6f0c6fb8c80fcc92 = 'ds';
var $af6735e58aca415b$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $af6735e58aca415b$export$dddac1532e822863 = "--".concat($af6735e58aca415b$export$6f0c6fb8c80fcc92, "-token-not-found");
var $af6735e58aca415b$export$9d7b58831ae93caa = "--".concat($af6735e58aca415b$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("3eF5u", function(module, exports) {
$parcel$export(module.exports, "isThemeColorMode", () => $25b28d05f165c1a1$export$fcfb1976c88f9f75);

var $53ufR = parcelRequire("53ufR");
var $25b28d05f165c1a1$export$fcfb1976c88f9f75 = function isThemeColorMode(colorMode) {
    return (0, $53ufR.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};

});
parcelRegister("53ufR", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", () => $3ae4b38a53c9b561$export$83993de8eb66733);
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $3ae4b38a53c9b561$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];

});


parcelRegister("iblkR", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", () => $d3c9cde0613984fa$export$f19b488f7c0547ee);

var $iYJcE = parcelRequire("iYJcE");

var $lIeyl = parcelRequire("lIeyl");

var $6QWic = parcelRequire("6QWic");

var $973w1 = parcelRequire("973w1");
var $d3c9cde0613984fa$var$customThemeOptions = 'UNSAFE_themeOptions';
var $d3c9cde0613984fa$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ').map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && (0, $lIeyl.isColorMode)(id)) themeObject[kind] = id;
        if ((0, $973w1.isThemeKind)(kind) && (0, $6QWic.isThemeIds)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $d3c9cde0613984fa$var$customThemeOptions) try {
            themeObject[$d3c9cde0613984fa$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};

});
parcelRegister("lIeyl", function(module, exports) {
$parcel$export(module.exports, "isColorMode", () => $fce8fef365d6c6eb$export$4a14e169b1de4ee7);
var $fce8fef365d6c6eb$export$4a14e169b1de4ee7 = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};

});

parcelRegister("6QWic", function(module, exports) {
$parcel$export(module.exports, "isThemeIds", () => $4fd4d11ccaab446e$export$ea35b8958c39dd07);

var $3UYdI = parcelRequire("3UYdI");
var $4fd4d11ccaab446e$export$ea35b8958c39dd07 = function isThemeIds(themeId) {
    return (0, $3UYdI.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};

});
parcelRegister("3UYdI", function(module, exports) {
$parcel$export(module.exports, "themeIds", () => $2da550876df4f8dc$export$7d43e72a58e3283f);
/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */ var $2da550876df4f8dc$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'UNSAFE-test-light',
    'dark',
    'UNSAFE-test-dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];

});


parcelRegister("973w1", function(module, exports) {
$parcel$export(module.exports, "isThemeKind", () => $6a277e9513dadbfb$export$958fa026be3a263e);
var $6a277e9513dadbfb$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $6a277e9513dadbfb$export$958fa026be3a263e = function isThemeKind(themeKind) {
    return $6a277e9513dadbfb$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};

});



parcelRegister("1Za0O", function(module, exports) {
$parcel$export(module.exports, "default", () => $17234123196e21f2$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $f3FlH = parcelRequire("f3FlH");

var $hQjaP = parcelRequire("hQjaP");
var $17234123196e21f2$export$b741a7c3bcb1c635 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $hQjaP.getGlobalTheme)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $f3FlH.THEME_DATA_ATTRIBUTE),
                            (0, $f3FlH.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($17234123196e21f2$export$b741a7c3bcb1c635, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($17234123196e21f2$export$b741a7c3bcb1c635, "callbacks", new Set());
var $17234123196e21f2$export$2e2bcd8739ae039 = $17234123196e21f2$export$b741a7c3bcb1c635;

});


parcelRegister("53SBn", function(module, exports) {
$parcel$export(module.exports, "RendererCssClassName", () => $3af7965b79b0b5e5$export$91f3bbbf974496e2);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
var $3af7965b79b0b5e5$var$clPrefix = 'ak-renderer-';
var $3af7965b79b0b5e5$export$91f3bbbf974496e2 = {
    FLEX_CENTER_WRAPPER: "".concat($3af7965b79b0b5e5$var$clPrefix, "flex-center-wrapper"),
    DOCUMENT: "".concat($3af7965b79b0b5e5$var$clPrefix, "document"),
    EXTENSION: "".concat($3af7965b79b0b5e5$var$clPrefix, "extension"),
    EXTENSION_AS_INLINE: "".concat($3af7965b79b0b5e5$var$clPrefix, "extension-as-inline"),
    EXTENSION_CENTER_ALIGN: "".concat($3af7965b79b0b5e5$var$clPrefix, "extension-center-align"),
    EXTENSION_OVERFLOW_CONTAINER: "".concat($3af7965b79b0b5e5$var$clPrefix, "extension-overflow-container"),
    EXTENSION_INNER_WRAPPER: "".concat($3af7965b79b0b5e5$var$clPrefix, "extension-inner-wrapper"),
    /** Wrapper for center-aligned extensions/MBE; margin here so it participates in collapse */ STICKY_SAFE_CENTER_WRAPPER: "".concat($3af7965b79b0b5e5$var$clPrefix, "sticky-safe-center-wrapper"),
    /** Wrapper for center-aligned embed card (wide/full-width); margin here so it participates in collapse */ EMBED_CARD_CENTER_WRAPPER: "".concat($3af7965b79b0b5e5$var$clPrefix, "embed-card-center-wrapper"),
    /** Wrapper for center-aligned block card datasource (wide/full-width); margin here so it participates in collapse */ BLOCK_CARD_DATASOURCE_CENTER_WRAPPER: "".concat($3af7965b79b0b5e5$var$clPrefix, "block-card-datasource-center-wrapper"),
    /** Outer flex wrapper for sticky-safe breakout (has vertical margin); zero margin when first in doc */ STICKY_SAFE_BREAKOUT_WRAPPER: "".concat($3af7965b79b0b5e5$var$clPrefix, "sticky-safe-breakout-wrapper"),
    /** Flex item in sticky-safe breakout; zero first/last child margin so flex container height matches legacy */ STICKY_SAFE_BREAKOUT_INNER: "".concat($3af7965b79b0b5e5$var$clPrefix, "sticky-safe-breakout-inner"),
    NUMBER_COLUMN: "".concat($3af7965b79b0b5e5$var$clPrefix, "table-number-column"),
    SORTABLE_COLUMN_WRAPPER: "".concat($3af7965b79b0b5e5$var$clPrefix, "tableHeader-sortable-column__wrapper"),
    SORTABLE_COLUMN: "".concat($3af7965b79b0b5e5$var$clPrefix, "tableHeader-sortable-column"),
    SORTABLE_COLUMN_ICON_WRAPPER: "".concat($3af7965b79b0b5e5$var$clPrefix, "tableHeader-sorting-icon__wrapper"),
    SORTABLE_COLUMN_NO_ORDER: "".concat($3af7965b79b0b5e5$var$clPrefix, "tableHeader-sorting-icon__no-order")
};

});

parcelRegister("j6Z9H", function(module, exports) {
$parcel$export(module.exports, "default", () => $de9e04140e5b09e0$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $3Csso = parcelRequire("3Csso");
function $de9e04140e5b09e0$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $de9e04140e5b09e0$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $de9e04140e5b09e0$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $de9e04140e5b09e0$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $de9e04140e5b09e0$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $de9e04140e5b09e0$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $de9e04140e5b09e0$export$2e2bcd8739ae039(originalText, decorate) {
    var matches = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(originalText.matchAll((0, $3Csso.bidiCharacterRegex)));
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    var children = [];
    var mappedTo = 0;
    var _iterator = $de9e04140e5b09e0$var$_createForOfIteratorHelper(matches), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var match = _step.value;
            if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
            // mapped to the children.
            // Add them as plain text.
            children.push(originalText.substring(mappedTo, match.index));
            children.push(decorate({
                bidiCharacter: match[0],
                index: match.index
            }));
            // While index is guaranteed to be present, it needs to be asserted due
            // to a limitation of typescripts regex handling
            //
            // https://github.com/microsoft/TypeScript/issues/36788
            // Decorate bidi character
            mappedTo = match.index + match[0].length;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});
parcelRegister("3Csso", function(module, exports) {
$parcel$export(module.exports, "bidiCharacterRegex", () => $2a2afeae2f11986e$export$ecb256e6a1f5ee7e);
var $2a2afeae2f11986e$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;

});


parcelRegister("7BUTc", function(module, exports) {
$parcel$export(module.exports, "default", () => $58a81e26a3bc4876$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $4mzlU = parcelRequire("4mzlU");

var $3CcPt = parcelRequire("3CcPt");
var $58a81e26a3bc4876$var$_excluded = [
    "children"
];
function $58a81e26a3bc4876$export$2e2bcd8739ae039(_ref) {
    var testId = _ref.testId, bidiCharacter = _ref.bidiCharacter, skipChildren = _ref.skipChildren, shouldSkipChildren = _ref.shouldSkipChildren, tooltipEnabled = _ref.tooltipEnabled, isTooltipEnabled = _ref.isTooltipEnabled, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' : _ref$label;
    // Use new props if provided, otherwise fall back to deprecated props
    var shouldEnableTooltip = isTooltipEnabled !== undefined ? isTooltipEnabled : tooltipEnabled;
    var shouldSkip = shouldSkipChildren !== undefined ? shouldSkipChildren : skipChildren;
    if (shouldEnableTooltip) return(/*#__PURE__*/ // Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4mzlU.default), {
        content: label,
        tag: $58a81e26a3bc4876$var$CustomizedTagWithRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3CcPt.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, shouldSkip ? null : bidiCharacter)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3CcPt.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, shouldSkip ? null : bidiCharacter);
}
var $58a81e26a3bc4876$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(props, ref) {
    var children = props.children, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $58a81e26a3bc4876$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        ref: ref
    }), children);
});

});
parcelRegister("3CcPt", function(module, exports) {
$parcel$export(module.exports, "Decorator", () => $2a1edf5604e79d25$export$a592b67c93d52467);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $e8kqY = parcelRequire("e8kqY");
var $2a1edf5604e79d25$var$decoration = {
    root: "_kqswh2mm _szplfhey _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6rzzfg _1uakf6fq _1kt9y7el _is061xn9 _1rus1917 _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rba1xn9 _1xqc19zu"
};
function $2a1edf5604e79d25$export$a592b67c93d52467(_ref) {
    var bidiCharacter = _ref.bidiCharacter, children = _ref.children, testId = _ref.testId;
    var bidiCharacterCode = $2a1edf5604e79d25$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        "data-bidi-character-code": bidiCharacterCode,
        "aria-hidden": "true",
        className: (0, $970q7.default)([
            $2a1edf5604e79d25$var$decoration.root
        ])
    }, children), /*#__PURE__*/ $5FkrB.createElement((0, $e8kqY.default), {
        testId: testId && "".concat(testId, "--visually-hidden")
    }, /*#__PURE__*/ $5FkrB.createElement("mark", null, bidiCharacterCode)));
}
function $2a1edf5604e79d25$var$getBidiCharacterCode(bidiCharacter) {
    var _bidiCharacter$codePo;
    var bidiCharacterCode = (_bidiCharacter$codePo = bidiCharacter.codePointAt(0)) === null || _bidiCharacter$codePo === void 0 ? void 0 : _bidiCharacter$codePo.toString(16);
    return "U+".concat(bidiCharacterCode);
}

});


parcelRegister("h0il1", function(module, exports) {
$parcel$export(module.exports, "componentWithCondition", () => $c610a95125366a50$export$6e8ea24b15199873);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");
function $c610a95125366a50$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    var ComponentWithCondition = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
        return condition() ? /*#__PURE__*/ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(ComponentTrue, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
            ref: ref
        })) : /*#__PURE__*/ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(ComponentFalse, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
            ref: ref
        }));
    });
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = "ComponentWithCondition[".concat(condition.name, "]");
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});

parcelRegister("aP6HU", function(module, exports) {
$parcel$export(module.exports, "PLATFORM", () => $7e13deb8d79c3374$export$88c4881e092abcaf);
$parcel$export(module.exports, "MODE", () => $7e13deb8d79c3374$export$e48589d9e4824227);
var $7e13deb8d79c3374$export$88c4881e092abcaf = /*#__PURE__*/ function(PLATFORM) {
    PLATFORM["NATIVE"] = "mobileNative";
    PLATFORM["HYBRID"] = "mobileHybrid";
    PLATFORM["WEB"] = "web";
    return PLATFORM;
}({});
var $7e13deb8d79c3374$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $7e13deb8d79c3374$var$RESOLVE_METHOD = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}($7e13deb8d79c3374$var$RESOLVE_METHOD || {});

});

parcelRegister("cLkP4", function(module, exports) {
$parcel$export(module.exports, "default", () => $94aa06c49d1fa9d8$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $kFNli = parcelRequire("kFNli");

var $6AXWM = parcelRequire("6AXWM");

var $kFdTR = parcelRequire("kFdTR");

var $by6zf = parcelRequire("by6zf");

var $hbdZB = parcelRequire("hbdZB");

var $h6eHf = parcelRequire("h6eHf");
var $94aa06c49d1fa9d8$var$_excluded = [
    "href",
    "children",
    "checkSafety",
    "onClick",
    "testId",
    "isLinkComponent",
    "enableResolve"
], $94aa06c49d1fa9d8$var$_excluded2 = [
    "isLinkSafe",
    "showSafetyWarningModal"
];
var $94aa06c49d1fa9d8$var$PACKAGE_DATA = {
    packageName: "@atlaskit/smart-card",
    packageVersion: "45.28.4",
    componentName: 'linkUrl'
};
var $94aa06c49d1fa9d8$var$LinkUrl = function LinkUrl(_ref) {
    var href = _ref.href, children = _ref.children, _ref$checkSafety = _ref.checkSafety, checkSafety = _ref$checkSafety === void 0 ? true : _ref$checkSafety, _onClick = _ref.onClick, _ref$testId = _ref.testId, testId = _ref$testId === void 0 ? 'link-with-safety' : _ref$testId, _ref$isLinkComponent = _ref.isLinkComponent, isLinkComponent = _ref$isLinkComponent === void 0 ? false : _ref$isLinkComponent, _ref$enableResolve = _ref.enableResolve, enableResolve = _ref$enableResolve === void 0 ? false : _ref$enableResolve, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $94aa06c49d1fa9d8$var$_excluded);
    var _useLinkWarningModal = (0, $h6eHf.useLinkWarningModal)(), isLinkSafe = _useLinkWarningModal.isLinkSafe, showSafetyWarningModal = _useLinkWarningModal.showSafetyWarningModal, linkWarningModalProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_useLinkWarningModal, $94aa06c49d1fa9d8$var$_excluded2);
    var Link = enableResolve ? (0, $by6zf.HyperlinkWithSmartLinkResolver) : (0, $kFdTR.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6AXWM.LinkAnalyticsContext), {
        url: href,
        display: "url"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Link, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        href: href,
        testId: testId,
        isLinkComponent: isLinkComponent,
        onClick: function onClick(e) {
            if (!checkSafety) {
                _onClick && _onClick(e);
                return;
            }
            // Only call the onClick if the link is safe
            if (isLinkSafe(e, href)) _onClick && _onClick(e);
            else showSafetyWarningModal(e, href);
        }
    }, props), children)), checkSafety && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $hbdZB.default), linkWarningModalProps));
};
var $94aa06c49d1fa9d8$export$56ff87f78018e459 = (0, $kFNli.default)($94aa06c49d1fa9d8$var$PACKAGE_DATA)($94aa06c49d1fa9d8$var$LinkUrl);
var $94aa06c49d1fa9d8$export$2e2bcd8739ae039 = $94aa06c49d1fa9d8$export$56ff87f78018e459;

});
parcelRegister("6AXWM", function(module, exports) {
$parcel$export(module.exports, "LinkAnalyticsContext", () => $4cd49b1669da37f1$export$9458cdec663b9ff1);

var $5FkrB = parcelRequire("5FkrB");

var $l9NcB = parcelRequire("l9NcB");
var $4cd49b1669da37f1$export$9458cdec663b9ff1 = function LinkAnalyticsContext(_ref) {
    var display = _ref.display, id = _ref.id, children = _ref.children, source = _ref.source;
    var displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $l9NcB.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        }
    }, children);
};

});

parcelRegister("kFdTR", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0b26b3a2b312bb4$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $8F9hT = parcelRequire("8F9hT");

var $5uP8i = parcelRequire("5uP8i");
var $f0b26b3a2b312bb4$var$_excluded = [
    "href",
    "children",
    "testId",
    "isLinkComponent"
];
var $f0b26b3a2b312bb4$var$Anchor = (0, $5uP8i.withLinkClickedEvent)('a');
var $f0b26b3a2b312bb4$export$8c0773eab230d49e = (0, $5uP8i.withLinkClickedEvent)((0, $8F9hT.default));
var $f0b26b3a2b312bb4$var$Hyperlink = function Hyperlink(_ref) {
    var href = _ref.href, children = _ref.children, testId = _ref.testId, _ref$isLinkComponent = _ref.isLinkComponent, isLinkComponent = _ref$isLinkComponent === void 0 ? false : _ref$isLinkComponent, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $f0b26b3a2b312bb4$var$_excluded);
    var Link = isLinkComponent ? $f0b26b3a2b312bb4$export$8c0773eab230d49e : $f0b26b3a2b312bb4$var$Anchor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Link, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, isLinkComponent ? {
        testId: testId
    } : {
        'data-testid': testId
    }, {
        href: href || ''
    }, props), children);
};
var $f0b26b3a2b312bb4$export$2e2bcd8739ae039 = $f0b26b3a2b312bb4$var$Hyperlink;

});
parcelRegister("5uP8i", function(module, exports) {
$parcel$export(module.exports, "withLinkClickedEvent", () => $40076aff525b3da3$export$263352d59c0c5966);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $2hUC0 = parcelRequire("2hUC0");

var $acAK6 = parcelRequire("acAK6");
function $40076aff525b3da3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $40076aff525b3da3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $40076aff525b3da3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $40076aff525b3da3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $40076aff525b3da3$var$getDisplayName = function getDisplayName(WrappedComponent) {
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $40076aff525b3da3$export$263352d59c0c5966(WrappedComponent) {
    var Component = function Component(props) {
        var onClick = (0, $2hUC0.useLinkClicked)(props.onClick);
        var onMouseDown = (0, $acAK6.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, $40076aff525b3da3$var$_objectSpread($40076aff525b3da3$var$_objectSpread({}, props), {}, {
            onClick: onClick,
            onMouseDown: onMouseDown
        }));
    };
    Component.displayName = "withLinkClickedEvent(".concat($40076aff525b3da3$var$getDisplayName(WrappedComponent), ")");
    return Component;
}

});
parcelRegister("2hUC0", function(module, exports) {
$parcel$export(module.exports, "useLinkClicked", () => $1aa9153f316b7a97$export$5993d3ca6c85f774);

var $5FkrB = parcelRequire("5FkrB");

var $bDUuG = parcelRequire("bDUuG");

var $2jMwp = parcelRequire("2jMwp");
var $1aa9153f316b7a97$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
var $1aa9153f316b7a97$export$5993d3ca6c85f774 = function useLinkClicked(handler, predicate) {
    var _useAnalyticsEvents = (0, $bDUuG.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    return (0, $5FkrB.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var event = args[0];
        handler === null || handler === void 0 || handler.apply(null, args);
        if (!predicate || predicate !== null && predicate !== void 0 && predicate(event)) (0, $2jMwp.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};

});
parcelRegister("2jMwp", function(module, exports) {
$parcel$export(module.exports, "fireLinkClickedEvent", () => $1b02fe8aa9a17bcc$export$7987de3055fbdcb0);

var $25nEq = parcelRequire("25nEq");

var $8ckEN = parcelRequire("8ckEN");

var $bXERR = parcelRequire("bXERR");
function $1b02fe8aa9a17bcc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1b02fe8aa9a17bcc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1b02fe8aa9a17bcc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1b02fe8aa9a17bcc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1b02fe8aa9a17bcc$export$7987de3055fbdcb0 = function fireLinkClickedEvent(createAnalyticsEvent) {
    return function(event) {
        var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var payload = (0, $bXERR.createLinkClickedPayload)(event);
        if (payload) createAnalyticsEvent($1b02fe8aa9a17bcc$var$_objectSpread($1b02fe8aa9a17bcc$var$_objectSpread($1b02fe8aa9a17bcc$var$_objectSpread({}, payload), overrides), {}, {
            attributes: $1b02fe8aa9a17bcc$var$_objectSpread($1b02fe8aa9a17bcc$var$_objectSpread({}, payload.attributes), overrides === null || overrides === void 0 ? void 0 : overrides.attributes),
            nonPrivacySafeAttributes: $1b02fe8aa9a17bcc$var$_objectSpread($1b02fe8aa9a17bcc$var$_objectSpread({}, payload.nonPrivacySafeAttributes), overrides === null || overrides === void 0 ? void 0 : overrides.nonPrivacySafeAttributes)
        })).fire((0, $8ckEN.ANALYTICS_CHANNEL));
    };
};

});
parcelRegister("8ckEN", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $5f7f77cabcf8cd3d$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $5f7f77cabcf8cd3d$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $5f7f77cabcf8cd3d$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $5f7f77cabcf8cd3d$export$c89e475f7f7174c2);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 

var $5f7f77cabcf8cd3d$export$85183a312807388d = 'media';
var $5f7f77cabcf8cd3d$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "@atlaskit/smart-card",
    packageVersion: "45.28.4"
};
var $5f7f77cabcf8cd3d$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $5f7f77cabcf8cd3d$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});

});

parcelRegister("bXERR", function(module, exports) {
$parcel$export(module.exports, "createLinkClickedPayload", () => $8b54e7df4101c638$export$7fedc699766c16de);

var $25nEq = parcelRequire("25nEq");

var $5bCL3 = parcelRequire("5bCL3");

var $u4inJ = parcelRequire("u4inJ");

var $ljFgJ = parcelRequire("ljFgJ");
function $8b54e7df4101c638$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8b54e7df4101c638$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8b54e7df4101c638$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8b54e7df4101c638$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8b54e7df4101c638$var$linkClickedEvent = function linkClickedEvent(_ref) {
    var clickType = _ref.clickType, clickOutcome = _ref.clickOutcome, keysHeld = _ref.keysHeld, defaultPrevented = _ref.defaultPrevented;
    return {
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    };
};
var $8b54e7df4101c638$export$7fedc699766c16de = function createLinkClickedPayload(event) {
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    var isKeyboard = event.nativeEvent.detail === 0;
    var clickType = isKeyboard ? 'keyboard' : (0, $5bCL3.buttonMap).get(event.button);
    if (!clickType) return;
    var clickOutcome = (0, $ljFgJ.getLinkClickOutcome)(event, clickType);
    var keysHeld = (0, $u4inJ.getKeys)(event);
    var defaultPrevented = event.defaultPrevented;
    var linkClickedEventResult = $8b54e7df4101c638$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        var url = event.currentTarget.href;
        return $8b54e7df4101c638$var$_objectSpread($8b54e7df4101c638$var$_objectSpread({}, linkClickedEventResult), {}, {
            nonPrivacySafeAttributes: {
                url: url
            }
        });
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};

});
parcelRegister("5bCL3", function(module, exports) {
$parcel$export(module.exports, "buttonMap", () => $3c6c0b59a145c1e0$export$cfb45d54e1604f6c);
var $3c6c0b59a145c1e0$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);

});

parcelRegister("u4inJ", function(module, exports) {
$parcel$export(module.exports, "getKeys", () => $05a62273148eeb48$export$74743eda5dda3ccf);
var $05a62273148eeb48$export$74743eda5dda3ccf = function getKeys(e) {
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter(function(key) {
        return e["".concat(key, "Key")] === true;
    });
};

});

parcelRegister("ljFgJ", function(module, exports) {
$parcel$export(module.exports, "getLinkClickOutcome", () => $f84b627c36397812$export$d2a83e3b34be812b);

var $lde4p = parcelRequire("lde4p");
var $f84b627c36397812$var$isContentEditable = function isContentEditable(el) {
    return el instanceof HTMLElement && el.isContentEditable;
};
function $f84b627c36397812$export$d2a83e3b34be812b(e, clickType) {
    var _browser = (0, $lde4p.browser)(), mac = _browser.mac, safari = _browser.safari;
    /**
   * If the link/parent is content editable then left click won't have typical effect
   */ if ($f84b627c36397812$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
            // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
            if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
            if (e.shiftKey) {
                // Alt/option click in safari typically adds the link to bookmarks
                if (safari) return 'alt';
                return 'clickThroughNewTabOrWindow';
            }
            if (e.ctrlKey) {
                // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                // but if this behaviour is disabled, likely outcome is clickThrough
                if (mac) return 'clickThrough';
                return 'clickThroughNewTabOrWindow';
            }
            if (e.altKey) return 'alt';
            var target = e.currentTarget.getAttribute('target');
            if (target === '_blank') return 'clickThroughNewTabOrWindow';
            return 'clickThrough';
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}

});
parcelRegister("lde4p", function(module, exports) {
$parcel$export(module.exports, "browser", () => $f715b9e43bbe848e$export$3f2684e5d7cb1006);
var $f715b9e43bbe848e$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    var $f715b9e43bbe848e$var$ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    var $f715b9e43bbe848e$var$ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    var $f715b9e43bbe848e$var$ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $f715b9e43bbe848e$var$result.mac = /Mac/.test(navigator.platform);
    var $f715b9e43bbe848e$var$ie = $f715b9e43bbe848e$var$result.ie = !!($f715b9e43bbe848e$var$ieUpTo10 || $f715b9e43bbe848e$var$ie11up || $f715b9e43bbe848e$var$ieEdge);
    $f715b9e43bbe848e$var$result.ie_version = $f715b9e43bbe848e$var$ieUpTo10 ? document.documentMode || 6 : $f715b9e43bbe848e$var$ie11up ? +$f715b9e43bbe848e$var$ie11up[1] : $f715b9e43bbe848e$var$ieEdge ? +$f715b9e43bbe848e$var$ieEdge[1] : null;
    $f715b9e43bbe848e$var$result.gecko = !$f715b9e43bbe848e$var$ie && /gecko\/\d/i.test(navigator.userAgent);
    $f715b9e43bbe848e$var$result.chrome = !$f715b9e43bbe848e$var$ie && /Chrome\//.test(navigator.userAgent);
    $f715b9e43bbe848e$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $f715b9e43bbe848e$var$result.android = /Android \d/.test(navigator.userAgent);
    $f715b9e43bbe848e$var$result.ios = !$f715b9e43bbe848e$var$ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $f715b9e43bbe848e$var$result.webkit = !$f715b9e43bbe848e$var$ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $f715b9e43bbe848e$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $f715b9e43bbe848e$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $f715b9e43bbe848e$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $f715b9e43bbe848e$export$3f2684e5d7cb1006() {
    return $f715b9e43bbe848e$var$result;
}

});





parcelRegister("acAK6", function(module, exports) {
$parcel$export(module.exports, "useMouseDownEvent", () => $76d786b107bc80fb$export$df67f318ded0283c);

var $2hUC0 = parcelRequire("2hUC0");
var $76d786b107bc80fb$var$isNotLeftClick = function isNotLeftClick(event) {
    return event.button !== 0;
};
var $76d786b107bc80fb$export$df67f318ded0283c = function useMouseDownEvent(onMouseDown) {
    return (0, $2hUC0.useLinkClicked)(onMouseDown, $76d786b107bc80fb$var$isNotLeftClick);
};

});



parcelRegister("by6zf", function(module, exports) {
$parcel$export(module.exports, "HyperlinkWithSmartLinkResolver", () => $8687f6d5cd20f2ea$export$1fdb4f77fe528a52);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $3spbj = parcelRequire("3spbj");

var $ach6K = parcelRequire("ach6K");

var $k3si0 = parcelRequire("k3si0");

var $9Qo3G = parcelRequire("9Qo3G");

var $oVkm1 = parcelRequire("oVkm1");

var $fGRFy = parcelRequire("fGRFy");

var $LjX2F = parcelRequire("LjX2F");

var $5wLt1 = parcelRequire("5wLt1");

var $6OJWS = parcelRequire("6OJWS");

var $2LB3L = parcelRequire("2LB3L");

var $kFdTR = parcelRequire("kFdTR");
var $8687f6d5cd20f2ea$var$_excluded = [
    "onClick"
];
var $8687f6d5cd20f2ea$var$HyperlinkFallbackComponent = function HyperlinkFallbackComponent() {
    return null;
};
var $8687f6d5cd20f2ea$var$withValidator = function withValidator(Component, DefaultComponent) {
    return function(props) {
        var shouldResolveHyperlink = (0, $fGRFy.default)(props === null || props === void 0 ? void 0 : props.href);
        return shouldResolveHyperlink && props.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $LjX2F.SmartLinkAnalyticsContext), {
            url: props.href,
            display: "url"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Component, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(DefaultComponent, props);
    };
};
var $8687f6d5cd20f2ea$var$HyperlinkWithSmartLinkResolverInner = function HyperlinkWithSmartLinkResolverInner(_ref) {
    var onClickCallback = _ref.onClick, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $8687f6d5cd20f2ea$var$_excluded);
    var _useResolveHyperlink = (0, $oVkm1.default)({
        href: props.href || ''
    }), state = _useResolveHyperlink.state;
    var thirdPartyARI = (0, $9Qo3G.getThirdPartyARI)(state === null || state === void 0 ? void 0 : state.details);
    var firstPartyIdentifier = (0, $k3si0.getFirstPartyIdentifier)();
    var fire3PClickEvent = (0, $2LB3L.useFire3PWorkflowsClickEvent)(firstPartyIdentifier, thirdPartyARI);
    // Shared scope guard for all 3P-click handlers.
    var shouldFire3PClickEvent = (state === null || state === void 0 ? void 0 : state.status) === 'resolved' && fire3PClickEvent;
    var onClick = (0, $5FkrB.useCallback)(function(e) {
        // button === 0 is left-click, see
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
        if (shouldFire3PClickEvent && (e === null || e === void 0 ? void 0 : e.button) === 0) fire3PClickEvent === null || fire3PClickEvent === void 0 || fire3PClickEvent();
        onClickCallback === null || onClickCallback === void 0 || onClickCallback(e);
    }, [
        onClickCallback,
        fire3PClickEvent,
        shouldFire3PClickEvent
    ]);
    var onAuxClick = (0, $5FkrB.useCallback)(function(e) {
        // isAuxClick guards against Windows right-clicks firing onAuxClick with button === 2.
        if ((0, $5wLt1.isAuxClick)(e) && shouldFire3PClickEvent) fire3PClickEvent === null || fire3PClickEvent === void 0 || fire3PClickEvent({
            isAuxClick: true
        });
    }, [
        fire3PClickEvent,
        shouldFire3PClickEvent
    ]);
    var onContextMenu = (0, $5FkrB.useCallback)(function(_e) {
        if (shouldFire3PClickEvent) fire3PClickEvent === null || fire3PClickEvent === void 0 || fire3PClickEvent({
            isContextMenu: true
        });
    }, [
        fire3PClickEvent,
        shouldFire3PClickEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kFdTR.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu
    }));
};
var $8687f6d5cd20f2ea$export$1fdb4f77fe528a52 = (0, $3spbj.withErrorBoundary)($8687f6d5cd20f2ea$var$withValidator((0, $ach6K.default)((0, $6OJWS.default)($8687f6d5cd20f2ea$var$HyperlinkWithSmartLinkResolverInner), {
    enforceContext: false
}), (0, $kFdTR.default)), {
    FallbackComponent: $8687f6d5cd20f2ea$var$HyperlinkFallbackComponent
});

});
parcelRegister("3spbj", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("5FkrB")));
})(module.exports, function(exports1, React) {
    'use strict';
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || 'Unknown';
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("k3si0", function(module, exports) {
$parcel$export(module.exports, "getFirstPartyIdentifier", () => $e99a082284d8c9af$export$48b4e58cdb8031ba);
// Helper function to extract page ID from standard Confluence page URLs
var $e99a082284d8c9af$var$extractPageIdFromURL = function extractPageIdFromURL(url) {
    try {
        var urlObj = new URL(url);
        // Following this pattern for confluence URL -> /wiki/spaces/{space}/pages/{pageId}/{title}
        var pagesMatch = urlObj.pathname.match(/\/wiki\/spaces\/[^\/]+\/pages\/(\d+)(?:\/|$)/);
        if (pagesMatch && pagesMatch[1]) return pagesMatch[1];
        // Following this pattern for confluence URL -> /wiki/pages/viewpage.action?pageId={pageId}
        var pageIdParam = urlObj.searchParams.get('pageId');
        if (pageIdParam) return pageIdParam;
        // Following this pattern for confluence URL -> /wiki/display/{space}/{pageId}
        var displayMatch = urlObj.pathname.match(/\/wiki\/display\/[^\/]+\/(\d+)/);
        if (displayMatch && displayMatch[1]) return displayMatch[1];
    } catch (_unused) {
        return undefined;
    }
    return undefined;
};
var $e99a082284d8c9af$var$extractContentIdFromURL = function extractContentIdFromURL(url) {
    try {
        var urlObj = new URL(url);
        // Pattern: ?content.id={contentId} (for app connector URLs and plugin servlet URLs)
        var contentId = urlObj.searchParams.get('content.id');
        if (contentId) return contentId;
        // Also support URLs where content.id is in the query string but not parsed by URL (edge case)
        // e.g., /wiki/plugins/servlet/ac/com.atlassian.perspectiveretros/perspective-retros?content.id=5662725850
        var match = url.match(/[?&]content\.id=(\d+)/);
        if (match && match[1]) return match[1];
    } catch (_unused2) {
        return undefined;
    }
    return undefined;
};
var $e99a082284d8c9af$var$extractJiraIssueIdFromURL = function extractJiraIssueIdFromURL(url) {
    try {
        var urlObj = new URL(url);
        // Support any case for Jira keys (e.g., AI3W-864, ai3w-864, Ai3W-864)
        var browseMatch = urlObj.pathname.match(/\/browse\/([A-Za-z0-9]+-\d+)/);
        if (browseMatch && browseMatch[1]) return browseMatch[1];
        // /jira/browse/{issueKey}
        var jiraBrowseMatch = urlObj.pathname.match(/\/jira\/browse\/([A-Za-z0-9]+-\d+)/);
        if (jiraBrowseMatch && jiraBrowseMatch[1]) return jiraBrowseMatch[1];
        // Query parameter ?selectedIssue={issueKey}
        var selectedIssue = urlObj.searchParams.get('selectedIssue');
        if (selectedIssue && /^[A-Za-z0-9]+-\d+$/.test(selectedIssue)) return selectedIssue;
        // Query parameter ?issueKey={issueKey}
        var issueKeyParam = urlObj.searchParams.get('issueKey');
        if (issueKeyParam && /^[A-Za-z0-9]+-\d+$/.test(issueKeyParam)) return issueKeyParam;
    } catch (_unused3) {
        return undefined;
    }
    return undefined;
};
var $e99a082284d8c9af$var$getProductFromWindowURL = function getProductFromWindowURL() {
    try {
        var currentUrl = window.location.href;
        var urlObj = new URL(currentUrl);
        var hostname = urlObj.hostname.toLowerCase();
        var pathname = urlObj.pathname.toLowerCase();
        // Check for Confluence patterns
        if (hostname.includes('confluence') || pathname.includes('/wiki/') || pathname.includes('/display/') || pathname.includes('/spaces/')) return 'confluence';
        // Check for Jira patterns
        if (hostname.includes('jira') || pathname.includes('/browse/') || pathname.includes('/projects/') || pathname.includes('/secure/')) return 'jira';
    } catch (_unused4) {
        return undefined;
    }
    return undefined;
};
var $e99a082284d8c9af$export$48b4e58cdb8031ba = function getFirstPartyIdentifier() {
    if (typeof window === 'undefined') return undefined;
    var product = $e99a082284d8c9af$var$getProductFromWindowURL();
    var currentURL = window.location.href;
    if (product === 'confluence') {
        if (currentURL.includes('content.id')) {
            var contentId = $e99a082284d8c9af$var$extractContentIdFromURL(currentURL);
            if (contentId) return "ConfluenceContentId:".concat(contentId);
        }
        var pageId = $e99a082284d8c9af$var$extractPageIdFromURL(currentURL);
        if (pageId) return "ConfluencePageId:".concat(pageId);
    } else if (product === 'jira') {
        var issueKey = $e99a082284d8c9af$var$extractJiraIssueIdFromURL(currentURL);
        if (issueKey) return "JiraIssueKey:".concat(issueKey);
    }
    return undefined;
};

});

parcelRegister("9Qo3G", function(module, exports) {
$parcel$export(module.exports, "getThirdPartyARI", () => $72aba1dbfb694744$export$e029950864672b4);
var $72aba1dbfb694744$export$e029950864672b4 = function getThirdPartyARI(details) {
    if (details !== null && details !== void 0 && details.entityData && 'thirdPartyAri' in details.entityData && details.entityData.thirdPartyAri) return details.entityData.thirdPartyAri;
    if (details !== null && details !== void 0 && details.data && 'atlassian:ari' in details.data && typeof details.data['atlassian:ari'] === 'string') {
        var ari = details.data['atlassian:ari'];
        if (ari.includes('ari:third-party')) return ari;
    }
    return undefined;
};

});

parcelRegister("oVkm1", function(module, exports) {
$parcel$export(module.exports, "default", () => $04aeb6032c4349ca$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $6JfQX = parcelRequire("6JfQX");

var $96IWe = parcelRequire("96IWe");

var $5igD7 = parcelRequire("5igD7");

var $767sR = parcelRequire("767sR");

var $QWcgg = parcelRequire("QWcgg");

var $g8q8G = parcelRequire("g8q8G");

var $gfaWa = parcelRequire("gfaWa");

var $asPvc = parcelRequire("asPvc");

var $1J71a = parcelRequire("1J71a");

var $eDkLs = parcelRequire("eDkLs");

var $l9vtt = parcelRequire("l9vtt");
var $04aeb6032c4349ca$var$useResolveHyperlink = function useResolveHyperlink(_ref) {
    var href = _ref.href;
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    var _useState = (0, $5FkrB.useState)(function() {
        return (0, $6JfQX.default)();
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 1), id = _useState2[0];
    var state = (0, $eDkLs.useSmartCardState)(href);
    var definitionId = (0, $gfaWa.getDefinitionId)(state.details);
    var extensionKey = (0, $asPvc.getExtensionKey)(state.details);
    var resourceType = (0, $1J71a.getResourceType)(state.details);
    var actions = (0, $g8q8G.useSmartCardActions)(id, href);
    var scheduledRegister = (0, $l9vtt.useScheduledRegister)(href, actions.register);
    var _useAnalyticsEvents = (0, $96IWe.useAnalyticsEvents)(), fireEvent = _useAnalyticsEvents.fireEvent;
    (0, $5FkrB.useEffect)(function() {
        scheduledRegister().catch(function(error) {
            throw error;
        });
    }, [
        scheduledRegister
    ]);
    (0, $5FkrB.useEffect)(function() {
        (0, $QWcgg.mark)(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            var _state$error, _state$error2, _state$error3;
            (0, $5igD7.create)(id, state.status);
            if (state.status === 'resolved') {
                var _getMeasure$duration, _getMeasure;
                fireEvent('operational.hyperlink.resolved', {
                    definitionId: definitionId !== null && definitionId !== void 0 ? definitionId : null,
                    extensionKey: extensionKey !== null && extensionKey !== void 0 ? extensionKey : null,
                    resourceType: resourceType !== null && resourceType !== void 0 ? resourceType : null,
                    duration: (_getMeasure$duration = (_getMeasure = (0, $767sR.getMeasure)(id, state.status)) === null || _getMeasure === void 0 ? void 0 : _getMeasure.duration) !== null && _getMeasure$duration !== void 0 ? _getMeasure$duration : null
                });
            } else if (((_state$error = state.error) === null || _state$error === void 0 ? void 0 : _state$error.type) !== 'ResolveUnsupportedError' && ((_state$error2 = state.error) === null || _state$error2 === void 0 ? void 0 : _state$error2.type) !== 'UnsupportedError' && ((_state$error3 = state.error) === null || _state$error3 === void 0 ? void 0 : _state$error3.name) !== 'InvalidUrlError') fireEvent('operational.hyperlink.unresolved', {
                definitionId: definitionId !== null && definitionId !== void 0 ? definitionId : null,
                extensionKey: extensionKey !== null && extensionKey !== void 0 ? extensionKey : null,
                resourceType: resourceType !== null && resourceType !== void 0 ? resourceType : null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    return {
        state: state,
        actions: actions
    };
};
var $04aeb6032c4349ca$export$2e2bcd8739ae039 = $04aeb6032c4349ca$var$useResolveHyperlink;

});
parcelRegister("96IWe", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $6a1788687212c434$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::7d3d9083d0211b0990b4c41be73c44fd>>
 * @codegenCommand afm workspace @atlassian/analytics-tooling analytics:codegen smart-card
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $bDUuG = parcelRequire("bDUuG");

var $jCYzm = parcelRequire("jCYzm");

var $aZSNw = parcelRequire("aZSNw");
var $6a1788687212c434$export$5bf35293e545f20c = function useAnalyticsEvents() {
    var _useAnalyticsNextEven = (0, $bDUuG.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsNextEven.createAnalyticsEvent;
    var fireEvent = (0, $5FkrB.useCallback)(function() {
        var event = createAnalyticsEvent((0, $aZSNw.default).apply(void 0, arguments));
        event.fire((0, $jCYzm.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
parcelRegister("jCYzm", function(module, exports) {
$parcel$export(module.exports, "EVENT_CHANNEL", () => $e4a08cbb891afb3e$export$3f072f06b90c3985);
var $e4a08cbb891afb3e$export$3f072f06b90c3985 = 'media';

});

parcelRegister("aZSNw", function(module, exports) {
$parcel$export(module.exports, "default", () => $801a1b94db6f8f4f$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::fe05c93b9e82ab4b7ef821abc44c49bb>>
 * @codegenCommand afm workspace @atlassian/analytics-tooling analytics:codegen smart-card
 */ var $801a1b94db6f8f4f$var$createEventPayload = function createEventPayload(eventKey) {
    for(var _len = arguments.length, _ref = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)_ref[_key - 1] = arguments[_key];
    var attributes = _ref[0];
    var _ref2 = eventKey.split('.'), _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 4), eventType = _ref3[0], actionSubject = _ref3[1], action = _ref3[2], actionSubjectId = _ref3[3];
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $801a1b94db6f8f4f$export$2e2bcd8739ae039 = $801a1b94db6f8f4f$var$createEventPayload;

});


parcelRegister("5igD7", function(module, exports) {
$parcel$export(module.exports, "create", () => $3dab8889dbde7cf3$export$185802fd694ee1f5);

var $4Nddo = parcelRequire("4Nddo");

var $767sR = parcelRequire("767sR");

var $arRXV = parcelRequire("arRXV");

var $1aOIB = parcelRequire("1aOIB");
var $3dab8889dbde7cf3$var$getMark = function getMark(id, status) {
    if (0, $1aOIB.hasPerformanceAPIAvailable) {
        var name = (0, $4Nddo.getMarkName)(id, status);
        var marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
var $3dab8889dbde7cf3$export$185802fd694ee1f5 = function create(id, status) {
    if (0, $1aOIB.hasPerformanceAPIAvailable) {
        var name = (0, $arRXV.getMeasureName)(id, status);
        var measure = (0, $767sR.getMeasure)(id, status);
        if (!measure) {
            var startMark = $3dab8889dbde7cf3$var$getMark(id, 'pending');
            var endMark = $3dab8889dbde7cf3$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});
parcelRegister("4Nddo", function(module, exports) {
$parcel$export(module.exports, "getMarkName", () => $37d5fd3d922790b5$export$fcff3185c7ce7f2b);
var $37d5fd3d922790b5$export$fcff3185c7ce7f2b = function getMarkName(id, status) {
    return "".concat(status, ":").concat(id);
};

});

parcelRegister("767sR", function(module, exports) {
$parcel$export(module.exports, "getMeasure", () => $52aee23654ca855b$export$d6e97a903ae9a3aa);

var $arRXV = parcelRequire("arRXV");

var $1aOIB = parcelRequire("1aOIB");
var $52aee23654ca855b$export$d6e97a903ae9a3aa = function getMeasure(id, status) {
    if (0, $1aOIB.hasPerformanceAPIAvailable) {
        var name = (0, $arRXV.getMeasureName)(id, status);
        var measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};

});
parcelRegister("arRXV", function(module, exports) {
$parcel$export(module.exports, "getMeasureName", () => $79b649731cccacf0$export$984df7f61dd7928f);
var $79b649731cccacf0$export$984df7f61dd7928f = function getMeasureName(id, status) {
    return "time-to-".concat(status, ":").concat(id);
};

});

parcelRegister("1aOIB", function(module, exports) {
$parcel$export(module.exports, "hasPerformanceAPIAvailable", () => $0dae113f6bd9f189$export$8dfeb9778591bc94);

var $baFyc = parcelRequire("baFyc");
var $0dae113f6bd9f189$export$8dfeb9778591bc94 = (0, $baFyc.isPerformanceAPIAvailable)();

});
parcelRegister("baFyc", function(module, exports) {
$parcel$export(module.exports, "isPerformanceAPIAvailable", () => $8220dbfbb230722a$export$b5717a625dd4a3eb);
var $8220dbfbb230722a$export$b5717a625dd4a3eb = function isPerformanceAPIAvailable() {
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every(function(api) {
        return !!performance[api];
    });
};

});




parcelRegister("QWcgg", function(module, exports) {
$parcel$export(module.exports, "mark", () => $09f2001bbd40141c$export$bf7f2fce5c1cf636);

var $4Nddo = parcelRequire("4Nddo");

var $1aOIB = parcelRequire("1aOIB");
var $09f2001bbd40141c$export$bf7f2fce5c1cf636 = function mark(id, status) {
    if (0, $1aOIB.hasPerformanceAPIAvailable) {
        var name = (0, $4Nddo.getMarkName)(id, status);
        performance.mark(name);
    }
};

});

parcelRegister("g8q8G", function(module, exports) {
$parcel$export(module.exports, "useSmartCardActions", () => $bbf1ab5ebd8fa76c$export$f7c340395f31e832);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $5FkrB = parcelRequire("5FkrB");

var $aTjqN = parcelRequire("aTjqN");

var $laW2y = parcelRequire("laW2y");

var $2mGTc = parcelRequire("2mGTc");

var $jFX1F = parcelRequire("jFX1F");

var $hlAuF = parcelRequire("hlAuF");

var $50U6m = parcelRequire("50U6m");

var $bjUKB = parcelRequire("bjUKB");

var $bC7my = parcelRequire("bC7my");

var $96IWe = parcelRequire("96IWe");

var $fXlyu = parcelRequire("fXlyu");

var $kCC2S = parcelRequire("kCC2S");

var $aRJoq = parcelRequire("aRJoq");

var $2fxyA = parcelRequire("2fxyA");

var $gfaWa = parcelRequire("gfaWa");

var $asPvc = parcelRequire("asPvc");

var $eih7r = parcelRequire("eih7r");

var $cSxNG = parcelRequire("cSxNG");

var $9ULzi = parcelRequire("9ULzi");

var $186iK = parcelRequire("186iK");
var $bbf1ab5ebd8fa76c$var$POST_AUTH_CHAT_EXTENSION_KEY = 'google-object-provider';
// Smart Card resolver key differs from the consumer-facing Rovo payload key.
var $bbf1ab5ebd8fa76c$var$POST_AUTH_CHAT_PAYLOAD_EXTENSION_KEY = 'google-drive';
var $bbf1ab5ebd8fa76c$var$SMART_LINK_3P_POST_AUTH_SOURCE = 'smart-link-3p-post-auth';
var $bbf1ab5ebd8fa76c$var$getPostAuthChatPayloadId = function getPostAuthChatPayloadId() {
    if (typeof crypto !== 'undefined') {
        if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
        if (typeof crypto.getRandomValues === 'function') {
            var values = new Uint32Array(4);
            crypto.getRandomValues(values);
            return "smart-link-post-auth-chat-".concat(Array.from(values, function(value) {
                return value.toString(16);
            }).join('-'));
        }
    }
    return "smart-link-post-auth-chat-".concat(Date.now());
};
var $bbf1ab5ebd8fa76c$var$sendPostAuthChatOpenMessage = function sendPostAuthChatOpenMessage(url, documentTitle) {
    var _window$parent;
    if (typeof window === 'undefined' || typeof ((_window$parent = window.parent) === null || _window$parent === void 0 ? void 0 : _window$parent.postMessage) !== 'function') return;
    var payload = {
        type: 'chat-smartlink-3p-post-auth-launch',
        source: $bbf1ab5ebd8fa76c$var$SMART_LINK_3P_POST_AUTH_SOURCE,
        openChat: true,
        openChatMode: 'mini-modal',
        data: {
            extensionKey: $bbf1ab5ebd8fa76c$var$POST_AUTH_CHAT_PAYLOAD_EXTENSION_KEY,
            provider: 'Google Drive',
            projectContext: {
                projectId: url,
                projectName: documentTitle !== null && documentTitle !== void 0 ? documentTitle : 'Google Drive',
                projectUrl: url
            }
        }
    };
    window.parent.postMessage({
        eventType: (0, $bjUKB.ROVO_POST_MESSAGE_EVENT_TYPE),
        payload: payload,
        payloadId: $bbf1ab5ebd8fa76c$var$getPostAuthChatPayloadId()
    }, '*');
};
var $bbf1ab5ebd8fa76c$export$f7c340395f31e832 = function useSmartCardActions(id, url) {
    var resolveUrl = (0, $186iK.default)();
    var invokeClientAction = (0, $9ULzi.default)({});
    var _useAnalyticsEvents = (0, $96IWe.useAnalyticsEvents)(), fireEvent = _useAnalyticsEvents.fireEvent;
    var flags = (0, $cSxNG.default)();
    var _useSmartLinkContext = (0, $2mGTc.useSmartLinkContext)(), store = _useSmartLinkContext.store, rovoOptions = _useSmartLinkContext.rovoOptions;
    var rovoOptionsRef = (0, $5FkrB.useRef)(rovoOptions);
    rovoOptionsRef.current = rovoOptions;
    var getState = store.getState, dispatch = store.dispatch;
    var getSmartLinkState = (0, $5FkrB.useCallback)(function() {
        var _getState$url;
        var _ref = (_getState$url = getState()[url]) !== null && _getState$url !== void 0 ? _getState$url : {
            status: (0, $fXlyu.SmartLinkStatus).Pending
        }, details = _ref.details, status = _ref.status, metadataStatus = _ref.metadataStatus;
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    var setMetadataStatus = (0, $5FkrB.useCallback)(function(metadataStatus) {
        dispatch((0, $jFX1F.cardAction)((0, $jFX1F.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    // Original resolve function — signature kept intact for maximum safety when FG is off.
    var resolve = (0, $5FkrB.useCallback)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
        var resourceUrl, isReloading, isMetadataRequest, _args = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    resourceUrl = _args.length > 0 && _args[0] !== undefined ? _args[0] : url;
                    isReloading = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
                    isMetadataRequest = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
                    return _context.abrupt("return", resolveUrl({
                        url: resourceUrl,
                        isReloading: isReloading,
                        isMetadataRequest: isMetadataRequest,
                        id: id
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    })), [
        id,
        resolveUrl,
        url
    ]);
    // New resolve function accepting ResolveUrlParams (minus 'id' which is closed over).
    // Used when FG is enabled to pass appearance to ORS.
    var resolveNew = (0, $5FkrB.useCallback)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2() {
        var params, _params$url, resourceUrl, _params$isReloading, isReloading, _params$isMetadataReq, isMetadataRequest, appearance, _args2 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    params = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
                    _params$url = params.url, resourceUrl = _params$url === void 0 ? url : _params$url, _params$isReloading = params.isReloading, isReloading = _params$isReloading === void 0 ? false : _params$isReloading, _params$isMetadataReq = params.isMetadataRequest, isMetadataRequest = _params$isMetadataReq === void 0 ? false : _params$isMetadataReq, appearance = params.appearance;
                    return _context2.abrupt("return", resolveUrl({
                        url: resourceUrl,
                        isReloading: isReloading,
                        isMetadataRequest: isMetadataRequest,
                        id: id,
                        appearance: appearance
                    }));
                case 1:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    })), [
        id,
        resolveUrl,
        url
    ]);
    /**
   * Register a smart link for resolution.
   * @param appearance - Card appearance hint for ORS to optimize response payload.
   *                     When 'inline', ORS returns minimal data (title, status).
   *                     When 'block' or 'embed', ORS returns full data including summary.
   */ var register = (0, $5FkrB.useCallback)(function(appearance) {
        var _getSmartLinkState = getSmartLinkState(), details = _getSmartLinkState.details;
        if (!details) {
            dispatch((0, $jFX1F.cardAction)((0, $jFX1F.ACTION_RESOLVING), {
                url: url
            }));
            // Always set metadataStatus to 'pending' during registration to prevent
            // loadMetadata from firing a duplicate concurrent fetch if a hover card
            // mounts while registration is in-flight. This matches pre-PR behaviour.
            setMetadataStatus('pending');
        }
        if ((0, $50U6m.fg)('platform_smartlink_inline_resolve_optimization')) return resolveNew({
            url: url,
            appearance: appearance
        });
        return resolve(url);
    }, [
        getSmartLinkState,
        resolve,
        resolveNew,
        dispatch,
        url,
        setMetadataStatus
    ]);
    var reload = (0, $5FkrB.useCallback)(function(appearance) {
        var _getSmartLinkState2 = getSmartLinkState(), details = _getSmartLinkState2.details;
        var definitionId = (0, $gfaWa.getDefinitionId)(details);
        if ((0, $50U6m.fg)('platform_smartlink_inline_resolve_optimization')) {
            if (definitionId) (0, $2fxyA.getByDefinitionId)(definitionId, getState()).map(function(reloadUrl) {
                return resolveNew({
                    url: reloadUrl,
                    isReloading: true,
                    appearance: appearance
                });
            });
            else resolveNew({
                url: url,
                isReloading: true,
                appearance: appearance
            });
        } else if (definitionId) (0, $2fxyA.getByDefinitionId)(definitionId, getState()).map(function(reloadUrl) {
            return resolve(reloadUrl, true);
        });
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve,
        resolveNew
    ]);
    /**
   * Load metadata for hover card preview.
   * This always requests 'block' appearance to get full data including summary.
   *
   * Inline optimized and SSR-resolved links keep metadataStatus pending until hover
   * requests the full block response.
   */ var loadMetadata = (0, $5FkrB.useCallback)(function() {
        var _getSmartLinkState3 = getSmartLinkState(), metadataStatus = _getSmartLinkState3.metadataStatus;
        var needsBlockData = metadataStatus === undefined || metadataStatus === 'pending' && (0, $50U6m.fg)('platform_smartlink_inline_resolve_optimization');
        if (needsBlockData) {
            setMetadataStatus('pending');
            if ((0, $50U6m.fg)('platform_smartlink_inline_resolve_optimization')) // Always request 'block' appearance for hover card metadata to get full data
            return resolveNew({
                url: url,
                isMetadataRequest: true,
                appearance: 'block'
            });
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        resolveNew,
        setMetadataStatus,
        url
    ]);
    var authorize = (0, $5FkrB.useCallback)(function(appearance) {
        var _getSmartLinkState4 = getSmartLinkState(), details = _getSmartLinkState4.details, status = _getSmartLinkState4.status;
        var definitionId = (0, $gfaWa.getDefinitionId)(details);
        var extensionKey = (0, $asPvc.getExtensionKey)(details);
        var isSupportedPostAuthChatExtensionKey = extensionKey === $bbf1ab5ebd8fa76c$var$POST_AUTH_CHAT_EXTENSION_KEY;
        var services = (0, $eih7r.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') fireEvent('ui.button.clicked.connectAccount', {
            display: appearance,
            definitionId: definitionId !== null && definitionId !== void 0 ? definitionId : null
        });
        if (status === 'forbidden') fireEvent('ui.smartLink.clicked.tryAnotherAccount', {
            display: appearance,
            definitionId: definitionId !== null && definitionId !== void 0 ? definitionId : null
        });
        if (services.length > 0) {
            fireEvent('screen.consentModal.viewed', {
                definitionId: definitionId !== null && definitionId !== void 0 ? definitionId : null
            });
            (0, $hlAuF.auth)(services[0].url).then(function() {
                fireEvent('track.applicationAccount.connected', {
                    definitionId: definitionId !== null && definitionId !== void 0 ? definitionId : null
                });
                (0, $aRJoq.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                fireEvent('operational.smartLink.connectSucceeded', {
                    definitionId: definitionId !== null && definitionId !== void 0 ? definitionId : null
                });
                // Post-auth Chat onboarding: auto-open Rovo Chat mini-modal with the
                // authed 3P link as context, for supported providers (e.g. Google Drive).
                // Provider eligibility is derived from the pre-auth SmartLink state.
                var isEligibleForPostAuthChat = status === 'unauthorized' && isSupportedPostAuthChatExtensionKey && (0, $50U6m.fg)('platform_sl_3p_post_auth_chat_open_fg') && (0, $kCC2S.getIsRovoChatEnabled)(rovoOptionsRef.current);
                // Experiment check: fires exposure for both control and treatment.
                // Only reached after eligibility preconditions + kill switch pass, so
                // exposure is counted for the triggered eligible pool.
                var isPostAuthChatTreatment = isEligibleForPostAuthChat && (0, $bC7my.expValEquals)('platform_sl_3p_post_auth_chat_open_exp', 'isEnabled', true);
                if (status === 'unauthorized' && !isPostAuthChatTreatment) {
                    var provider = (0, $aTjqN.extractSmartLinkProvider)(details);
                    flags.showConnectFlag({
                        id: "smart-link-connect-success-".concat(extensionKey),
                        provider: provider
                    });
                }
                reload();
                if (isPostAuthChatTreatment) $bbf1ab5ebd8fa76c$var$sendPostAuthChatOpenMessage(url, (0, $laW2y.extractSmartLinkTitle)(details));
            }, function(err) {
                var _err$type;
                (0, $aRJoq.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: err.type
                });
                fireEvent('operational.smartLink.connectFailed', {
                    definitionId: definitionId !== null && definitionId !== void 0 ? definitionId : null,
                    reason: (_err$type = err.type) !== null && _err$type !== void 0 ? _err$type : null
                });
                if (err.type === 'auth_window_closed') fireEvent('ui.consentModal.closed', {
                    display: appearance,
                    definitionId: definitionId !== null && definitionId !== void 0 ? definitionId : null
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        id,
        reload,
        fireEvent,
        flags,
        url
    ]);
    var invoke = (0, $5FkrB.useCallback)(/*#__PURE__*/ function() {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(opts, appearance) {
            var key, action, source;
            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                while(true)switch(_context3.prev = _context3.next){
                    case 0:
                        key = opts.key, action = opts.action;
                        source = opts.source || appearance;
                        if (!(opts.type === 'client')) {
                            _context3.next = 2;
                            break;
                        }
                        _context3.next = 1;
                        return invokeClientAction({
                            actionFn: opts.action.promise,
                            actionType: action.type,
                            display: source,
                            extensionKey: key
                        });
                    case 1:
                        return _context3.abrupt("return", _context3.sent);
                    case 2:
                    case "end":
                        return _context3.stop();
                }
            }, _callee3);
        }));
        return function(_x, _x2) {
            return _ref4.apply(this, arguments);
        };
    }(), [
        invokeClientAction
    ]);
    return (0, $5FkrB.useMemo)(function() {
        return {
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        };
    }, [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};

});
parcelRegister("aTjqN", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkProvider", () => $7ede1d0cff8283ec$export$ff753ed519e96e9e);

var $7azLm = parcelRequire("7azLm");

var $8z1lr = parcelRequire("8z1lr");

var $lfOjW = parcelRequire("lfOjW");
var $7ede1d0cff8283ec$export$ff753ed519e96e9e = function extractSmartLinkProvider(response) {
    if ((0, $lfOjW.isEntityPresent)(response)) return (0, $7azLm.extractEntityProvider)(response);
    return (response === null || response === void 0 ? void 0 : response.data) && (0, $8z1lr.extractProvider)(response === null || response === void 0 ? void 0 : response.data);
};

});
parcelRegister("7azLm", function(module, exports) {
$parcel$export(module.exports, "extractEntityProvider", () => $5385355c0ff9d3ad$export$ad879f2c9d5100a0);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $ggsb9 = parcelRequire("ggsb9");

var $4W3Ko = parcelRequire("4W3Ko");

var $50U6m = parcelRequire("50U6m");

var $gtKKv = parcelRequire("gtKKv");

var $lyRCI = parcelRequire("lyRCI");

var $h2ZXv = parcelRequire("h2ZXv");
function $5385355c0ff9d3ad$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5385355c0ff9d3ad$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5385355c0ff9d3ad$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5385355c0ff9d3ad$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5385355c0ff9d3ad$export$ad879f2c9d5100a0 = function extractEntityProvider(response) {
    var _response$meta;
    if (!(response !== null && response !== void 0 && (_response$meta = response.meta) !== null && _response$meta !== void 0 && _response$meta.generator)) return undefined;
    if (!(0, $50U6m.fg)('platform_lp_use_generator_icon_for_provider')) {
        var entityIcon = (0, $h2ZXv.extractEntityIcon)(response);
        if (entityIcon) return (0, $gtKKv.rebrandProvider)({
            text: response.meta.generator.name,
            icon: entityIcon.url,
            id: response.meta.generator.id,
            image: entityIcon.url,
            iconLabel: entityIcon.label
        });
    }
    var _ref = response.meta.generator, icon = _ref.icon, id = _ref.id, image = _ref.image, name = _ref.name;
    if (!name || !icon) throw Error('Link.generator requires a name and icon.');
    var providerIcon;
    switch(id){
        case 0, $lyRCI.CONFLUENCE_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ggsb9.ConfluenceIcon), {
                appearance: "brand",
                size: "xxsmall"
            });
            break;
        case 0, $lyRCI.JIRA_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4W3Ko.JiraIcon), {
                appearance: "brand",
                size: "xxsmall"
            });
            break;
        default:
            providerIcon = icon.url;
    }
    return (0, $gtKKv.rebrandProvider)($5385355c0ff9d3ad$var$_objectSpread({
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url
    }, {
        iconLabel: name
    }));
};

});
parcelRegister("ggsb9", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", () => $bd73ffae3b77435b$export$68f3db7f6af48bcb);

var $gpCpU = parcelRequire("gpCpU");

var $af9o7 = parcelRequire("af9o7");

var $1VIl7 = parcelRequire("1VIl7");
/**
 * __Confluence icon__
 *
 * The Confluence icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $bd73ffae3b77435b$export$68f3db7f6af48bcb = (0, $af9o7.createFeatureFlaggedComponent)((0, $1VIl7.ConfluenceIcon), (0, $gpCpU.ConfluenceIcon));

});
parcelRegister("gpCpU", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", () => $bf2cc7f049a6186c$export$68f3db7f6af48bcb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2264fa822c5f74cedf4229a8911c73b4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $bf2cc7f049a6186c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673\"/>\n</svg>\n";
var $bf2cc7f049a6186c$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135\"/>\n</svg>\n";
function $bf2cc7f049a6186c$export$68f3db7f6af48bcb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $bf2cc7f049a6186c$var$svg,
        customThemeSvg: $bf2cc7f049a6186c$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("dkXTa", function(module, exports) {
$parcel$export(module.exports, "IconWrapper", () => $9b5b994dd561b600$export$be58b4326e23250f);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $50U6m = parcelRequire("50U6m");

var $fDucD = parcelRequire("fDucD");
var $9b5b994dd561b600$var$styles = {
    root: "_1e0c1o8l",
    TEMP_assets: "_9aea1fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b5b994dd561b600$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b5b994dd561b600$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b5b994dd561b600$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b5b994dd561b600$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $9b5b994dd561b600$var$rovoDarkAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $9b5b994dd561b600$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b5b994dd561b600$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl",
    '12': "_4t3i1crf",
    '16': "_4t3i7vkz",
    '20': "_4t3igktf",
    '24': "_4t3i1tcg",
    '32': "_4t3izwfg"
};
function $9b5b994dd561b600$export$be58b4326e23250f(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? '20' : _ref$size, label = _ref.label, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, userDefinedTestId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, customIconColor = _ref.iconColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? 'tile' : _ref$type;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && customIconColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $970q7.default)([
            $9b5b994dd561b600$var$styles.root,
            $9b5b994dd561b600$var$sizeMap[size],
            colorMode === 'dark' ? $9b5b994dd561b600$var$dataCenterDarkAppearanceMap[appearance] : $9b5b994dd561b600$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $9b5b994dd561b600$var$rovoDarkAppearanceMap[appearance] : $9b5b994dd561b600$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $9b5b994dd561b600$var$cloudDarkAppearanceMap[appearance] : $9b5b994dd561b600$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $50U6m.fg)('assets-platform-branding') || (0, $50U6m.fg)('assets-platform-branding-v2')) && $9b5b994dd561b600$var$styles.TEMP_assets
        ])
    });
}

});
parcelRegister("fDucD", function(module, exports) {
$parcel$export(module.exports, "useThemeObserver", () => $b621ed2cc6a05fa8$export$3dd7971102e44fa8);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $esL3B = parcelRequire("esL3B");

var $cGp5R = parcelRequire("cGp5R");
var $b621ed2cc6a05fa8$export$3dd7971102e44fa8 = function useThemeObserver() {
    var _useState = (0, $5FkrB.useState)((0, $esL3B.getGlobalTheme)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        var observer = new (0, $cGp5R.default)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $b621ed2cc6a05fa8$export$2e2bcd8739ae039 = $b621ed2cc6a05fa8$export$3dd7971102e44fa8;

});
parcelRegister("esL3B", function(module, exports) {
$parcel$export(module.exports, "getGlobalTheme", () => $a8782ec33073b15d$export$813ecdf77207a053);

var $25nEq = parcelRequire("25nEq");

var $aDcyF = parcelRequire("aDcyF");

var $iCwbR = parcelRequire("iCwbR");

var $aIjIb = parcelRequire("aIjIb");
function $a8782ec33073b15d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a8782ec33073b15d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a8782ec33073b15d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a8782ec33073b15d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a8782ec33073b15d$export$813ecdf77207a053 = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $aDcyF.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $aDcyF.THEME_DATA_ATTRIBUTE)) || '';
    return $a8782ec33073b15d$var$_objectSpread($a8782ec33073b15d$var$_objectSpread({}, (0, $aIjIb.themeStringToObject)(theme)), (0, $iCwbR.isThemeColorMode)(colorMode) && {
        colorMode: colorMode
    });
};

});
parcelRegister("aDcyF", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $7bd749b634282905$export$4ef52930e33717cd);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $7bd749b634282905$export$a00eac3f8684bcd0);
var $7bd749b634282905$export$4ef52930e33717cd = 'data-theme';
var $7bd749b634282905$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $7bd749b634282905$export$a00eac3f8684bcd0 = 'data-color-mode';
var $7bd749b634282905$export$2112803007239c61 = 'data-contrast-mode';
var $7bd749b634282905$export$352e418ed5b6193a = 'data-custom-theme';
var $7bd749b634282905$export$6f0c6fb8c80fcc92 = 'ds';
var $7bd749b634282905$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $7bd749b634282905$export$dddac1532e822863 = "--".concat($7bd749b634282905$export$6f0c6fb8c80fcc92, "-token-not-found");
var $7bd749b634282905$export$9d7b58831ae93caa = "--".concat($7bd749b634282905$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("iCwbR", function(module, exports) {
$parcel$export(module.exports, "isThemeColorMode", () => $d8e4beedf248c8b6$export$fcfb1976c88f9f75);

var $2KPS9 = parcelRequire("2KPS9");
var $d8e4beedf248c8b6$export$fcfb1976c88f9f75 = function isThemeColorMode(colorMode) {
    return (0, $2KPS9.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};

});
parcelRegister("2KPS9", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", () => $20181d6b959f2849$export$83993de8eb66733);
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $20181d6b959f2849$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];

});


parcelRegister("aIjIb", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", () => $7ccd4dc160991d61$export$f19b488f7c0547ee);

var $iYJcE = parcelRequire("iYJcE");

var $7g858 = parcelRequire("7g858");

var $i7OQo = parcelRequire("i7OQo");

var $gArDJ = parcelRequire("gArDJ");
var $7ccd4dc160991d61$var$customThemeOptions = 'UNSAFE_themeOptions';
var $7ccd4dc160991d61$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ').map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && (0, $7g858.isColorMode)(id)) themeObject[kind] = id;
        if ((0, $gArDJ.isThemeKind)(kind) && (0, $i7OQo.isThemeIds)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $7ccd4dc160991d61$var$customThemeOptions) try {
            themeObject[$7ccd4dc160991d61$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};

});
parcelRegister("7g858", function(module, exports) {
$parcel$export(module.exports, "isColorMode", () => $54904be5c47f9e25$export$4a14e169b1de4ee7);
var $54904be5c47f9e25$export$4a14e169b1de4ee7 = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};

});

parcelRegister("i7OQo", function(module, exports) {
$parcel$export(module.exports, "isThemeIds", () => $d32052090c4f55ce$export$ea35b8958c39dd07);

var $a43HS = parcelRequire("a43HS");
var $d32052090c4f55ce$export$ea35b8958c39dd07 = function isThemeIds(themeId) {
    return (0, $a43HS.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};

});
parcelRegister("a43HS", function(module, exports) {
$parcel$export(module.exports, "themeIds", () => $753d272bf154c489$export$7d43e72a58e3283f);
/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */ var $753d272bf154c489$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];

});


parcelRegister("gArDJ", function(module, exports) {
$parcel$export(module.exports, "isThemeKind", () => $c13572cdffd3965e$export$958fa026be3a263e);
var $c13572cdffd3965e$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $c13572cdffd3965e$export$958fa026be3a263e = function isThemeKind(themeKind) {
    return $c13572cdffd3965e$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};

});



parcelRegister("cGp5R", function(module, exports) {
$parcel$export(module.exports, "default", () => $93bcdf5970b55ff7$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $aDcyF = parcelRequire("aDcyF");

var $esL3B = parcelRequire("esL3B");
var $93bcdf5970b55ff7$export$b741a7c3bcb1c635 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $esL3B.getGlobalTheme)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $aDcyF.THEME_DATA_ATTRIBUTE),
                            (0, $aDcyF.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($93bcdf5970b55ff7$export$b741a7c3bcb1c635, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($93bcdf5970b55ff7$export$b741a7c3bcb1c635, "callbacks", new Set());
var $93bcdf5970b55ff7$export$2e2bcd8739ae039 = $93bcdf5970b55ff7$export$b741a7c3bcb1c635;

});




parcelRegister("af9o7", function(module, exports) {
$parcel$export(module.exports, "createFeatureFlaggedComponent", () => $7752965ed79b5f2a$export$e30d2ddc605f6bb);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
var $7752965ed79b5f2a$var$_excluded = [
    "size",
    "shouldUseNewLogoDesign"
];
/**
 * Creates a component that renders the new logo design.
 *
 * @param LegacyComponent - The legacy logo component (no longer used).
 * @param NewComponent - The new logo component.
 * @returns A component that renders the new logo.
 */ var $7752965ed79b5f2a$export$e30d2ddc605f6bb = function createFeatureFlaggedComponent(_LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref) {
        var size = _ref.size, _shouldUseNewLogoDesign = _ref.shouldUseNewLogoDesign, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $7752965ed79b5f2a$var$_excluded);
        // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            size: size || 'medium'
        }, props));
    };
};

});

parcelRegister("1VIl7", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", () => $167d8239415b0009$export$68f3db7f6af48bcb);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $167d8239415b0009$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098\"/>\n    </svg>");
};
var $167d8239415b0009$export$68f3db7f6af48bcb = function ConfluenceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $167d8239415b0009$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("8onqJ", function(module, exports) {
$parcel$export(module.exports, "defaultLogoParams", () => $61c2bd5f28c47c3c$export$438460117ae6b7ee);
$parcel$export(module.exports, "legacyDefaultLogoParams", () => $61c2bd5f28c47c3c$export$793fba32aed8942a);
/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ var $61c2bd5f28c47c3c$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
var $61c2bd5f28c47c3c$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
}; /**
 * The props for the <Wrapper /> that takes the svg and turns it into a component.
 */ 

});

parcelRegister("cVyt1", function(module, exports) {
$parcel$export(module.exports, "default", () => $96958b5ae3603ec3$export$2e2bcd8739ae039);
/* wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $96958b5ae3603ec3$var$_excluded = [
    "label",
    "svg",
    "size",
    "appearance",
    "iconColor",
    "textColor",
    "testId"
];
var $96958b5ae3603ec3$var$CSS_VAR_COLOR = '--logo-color';
var $96958b5ae3603ec3$var$CSS_VAR_FILL = '--logo-fill';
var $96958b5ae3603ec3$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ var $96958b5ae3603ec3$var$Wrapper = function Wrapper(_ref) {
    var label = _ref.label, svg = _ref.svg, size = _ref.size, appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor, userDefinedTestId = _ref.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $96958b5ae3603ec3$var$_excluded);
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    var shouldApplyStopColor = appearance === undefined;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-testid": testId,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $96958b5ae3603ec3$var$CSS_VAR_COLOR, iconColor), $96958b5ae3603ec3$var$CSS_VAR_FILL, textColor),
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest, {
        className: (0, $970q7.default)([
            $96958b5ae3603ec3$var$styles.root,
            shouldApplyStopColor && $96958b5ae3603ec3$var$styles.stop,
            size && $96958b5ae3603ec3$var$styles[size]
        ])
    }));
};
var $96958b5ae3603ec3$export$2e2bcd8739ae039 = $96958b5ae3603ec3$var$Wrapper;

});

parcelRegister("hyx75", function(module, exports) {
$parcel$export(module.exports, "getColorsFromAppearance", () => $cc7f4c450b6535cc$export$bbacc3980e0f3029);
var $cc7f4c450b6535cc$export$bbacc3980e0f3029 = function getColorsFromAppearance(appearance, colorMode) {
    var iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};

});



parcelRegister("4W3Ko", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", () => $397f7c568327b20e$export$c4b5b1f965d8b3eb);

var $aEDe1 = parcelRequire("aEDe1");

var $af9o7 = parcelRequire("af9o7");

var $Y36zi = parcelRequire("Y36zi");
/**
 * __Jira icon__
 *
 * The Jira icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $397f7c568327b20e$export$c4b5b1f965d8b3eb = (0, $af9o7.createFeatureFlaggedComponent)((0, $Y36zi.JiraIcon), (0, $aEDe1.JiraIcon));

});
parcelRegister("aEDe1", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", () => $7c1c11195d413b75$export$c4b5b1f965d8b3eb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b225283860ba91a6c228b8f4fa0e1d39>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $7c1c11195d413b75$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z\"/>\n</svg>\n";
var $7c1c11195d413b75$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z\"/>\n</svg>\n";
function $7c1c11195d413b75$export$c4b5b1f965d8b3eb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $7c1c11195d413b75$var$svg,
        customThemeSvg: $7c1c11195d413b75$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("Y36zi", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", () => $0b480349a5d37260$export$c4b5b1f965d8b3eb);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $0b480349a5d37260$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n    </svg>");
};
var $0b480349a5d37260$export$c4b5b1f965d8b3eb = function JiraIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $0b480349a5d37260$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("gtKKv", function(module, exports) {
$parcel$export(module.exports, "rebrandProvider", () => $bff39e2ab23aed65$export$df1b15aebbcf717e);

var $25nEq = parcelRequire("25nEq");
function $bff39e2ab23aed65$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bff39e2ab23aed65$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bff39e2ab23aed65$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bff39e2ab23aed65$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bff39e2ab23aed65$var$GOOGLE_DRIVE = 'Google Drive';
var $bff39e2ab23aed65$export$df1b15aebbcf717e = function rebrandProvider(provider) {
    switch(provider === null || provider === void 0 ? void 0 : provider.text){
        case 'Google':
            return $bff39e2ab23aed65$var$_objectSpread($bff39e2ab23aed65$var$_objectSpread($bff39e2ab23aed65$var$_objectSpread({}, provider), {
                iconLabel: $bff39e2ab23aed65$var$GOOGLE_DRIVE
            }), {}, {
                text: $bff39e2ab23aed65$var$GOOGLE_DRIVE
            });
        default:
            return provider;
    }
};

});

parcelRegister("lyRCI", function(module, exports) {
$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $fb265e6f7717e2c0$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $fb265e6f7717e2c0$export$f654d825189934a7);
$parcel$export(module.exports, "JIRA_TASK", () => $fb265e6f7717e2c0$export$84a73a0383f58180);
$parcel$export(module.exports, "JIRA_SUB_TASK", () => $fb265e6f7717e2c0$export$c6c83963a9378a67);
$parcel$export(module.exports, "JIRA_STORY", () => $fb265e6f7717e2c0$export$58af3c426c111a6d);
$parcel$export(module.exports, "JIRA_BUG", () => $fb265e6f7717e2c0$export$ac9898a63417219e);
$parcel$export(module.exports, "JIRA_EPIC", () => $fb265e6f7717e2c0$export$54db5e3fb12e39cd);
$parcel$export(module.exports, "JIRA_INCIDENT", () => $fb265e6f7717e2c0$export$2f54a5a217202c85);
$parcel$export(module.exports, "JIRA_SERVICE_REQUEST", () => $fb265e6f7717e2c0$export$d097371052bfc411);
$parcel$export(module.exports, "JIRA_CHANGE", () => $fb265e6f7717e2c0$export$efd9452ad16c6676);
$parcel$export(module.exports, "JIRA_PROBLEM", () => $fb265e6f7717e2c0$export$2e7e70abb5d81f67);
$parcel$export(module.exports, "JIRA_CUSTOM_TASK_TYPE", () => $fb265e6f7717e2c0$export$ce25cfc40b280dbc);
$parcel$export(module.exports, "SmartLinkSize", () => $fb265e6f7717e2c0$export$51f13ced115cbdae);
$parcel$export(module.exports, "IconType", () => $fb265e6f7717e2c0$export$13ff1290a9e22e77);
var $fb265e6f7717e2c0$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
var $fb265e6f7717e2c0$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
var $fb265e6f7717e2c0$export$84a73a0383f58180 = 'JiraTask';
var $fb265e6f7717e2c0$export$c6c83963a9378a67 = 'JiraSubTask';
var $fb265e6f7717e2c0$export$58af3c426c111a6d = 'JiraStory';
var $fb265e6f7717e2c0$export$ac9898a63417219e = 'JiraBug';
var $fb265e6f7717e2c0$export$54db5e3fb12e39cd = 'JiraEpic';
var $fb265e6f7717e2c0$export$2f54a5a217202c85 = 'JiraIncident';
var $fb265e6f7717e2c0$export$d097371052bfc411 = 'JiraServiceRequest';
var $fb265e6f7717e2c0$export$efd9452ad16c6676 = 'JiraChange';
var $fb265e6f7717e2c0$export$2e7e70abb5d81f67 = 'JiraProblem';
var $fb265e6f7717e2c0$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
var $fb265e6f7717e2c0$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $fb265e6f7717e2c0$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Video"] = "FileType:Video";
    return IconType;
}({});

});

parcelRegister("h2ZXv", function(module, exports) {
$parcel$export(module.exports, "extractEntityIcon", () => $c692af46a0015d06$export$19346520e937a99f);

var $csH1I = parcelRequire("csH1I");
var $jiYsQ = parcelRequire("jiYsQ");
var $cbLP6 = parcelRequire("cbLP6");

var $gGVCN = parcelRequire("gGVCN");
var $c692af46a0015d06$export$19346520e937a99f = function extractEntityIcon(response) {
    var entity = (0, $gGVCN.extractEntity)(response);
    if (!entity) return undefined;
    if (!(0, $csH1I.isBaseEntity)(entity)) return undefined;
    if ((0, $jiYsQ.isDesignEntity)(entity) && entity.iconUrl) return {
        url: entity.iconUrl,
        label: entity.type
    };
    if ((0, $cbLP6.isDocumentEntity)(entity) && entity.type.iconUrl) return {
        url: entity.type.iconUrl,
        label: entity.type.category
    };
    // When JSON-LD is deprecated, we can change this to returning entity provider icon.
    // For now code upstream will return better result when this method returns undefined.
    return undefined;
};

});
parcelRegister("csH1I", function(module, exports) {
$parcel$export(module.exports, "isBaseEntity", () => $912979c14eb90a65$export$12af7c5462954d1e);

var $c2BKx = parcelRequire("c2BKx");
var $912979c14eb90a65$export$12af7c5462954d1e = function isBaseEntity(value) {
    return (0, $c2BKx.isObject)(value) && typeof value.displayName === 'string' && typeof value.id === 'string' && typeof value.url === 'string';
};

});
parcelRegister("c2BKx", function(module, exports) {
$parcel$export(module.exports, "isObject", () => $8c42f43cf8a2be99$export$a6cdc56e425d0d0a);

var $ekGgq = parcelRequire("ekGgq");
var $8c42f43cf8a2be99$export$a6cdc56e425d0d0a = function isObject(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && value !== null;
};

});


parcelRegister("jiYsQ", function(module, exports) {
$parcel$export(module.exports, "isDesignEntity", () => $e0de99b6a3ec39f1$export$8dc9be81b5b6266b);

var $d9IlH = parcelRequire("d9IlH");

var $5Akza = parcelRequire("5Akza");

var $csH1I = parcelRequire("csH1I");

var $l6QMT = parcelRequire("l6QMT");
var $e0de99b6a3ec39f1$export$8dc9be81b5b6266b = function isDesignEntity(value) {
    return (0, $csH1I.isBaseEntity)(value) && (0, $l6QMT.isOneOf)((0, $5Akza.DESIGN_STATUSES), (0, $d9IlH.asRecord)(value).status) && (0, $l6QMT.isOneOf)((0, $5Akza.DESIGN_TYPES), (0, $d9IlH.asRecord)(value).type);
};

});
parcelRegister("d9IlH", function(module, exports) {
$parcel$export(module.exports, "asRecord", () => $993e846aace57444$export$badcc9423dc3e1c1);
var $993e846aace57444$export$badcc9423dc3e1c1 = function asRecord(value) {
    return value;
};

});

parcelRegister("5Akza", function(module, exports) {
$parcel$export(module.exports, "DESIGN_TYPES", () => $41104496824bb2fd$export$7d4721a36ceb2894);
$parcel$export(module.exports, "DESIGN_STATUSES", () => $41104496824bb2fd$export$fcc968815a3eb9c5);
$parcel$export(module.exports, "DOCUMENT_CATEGORIES", () => $41104496824bb2fd$export$892192ec11178e3c);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $csH1I = parcelRequire("csH1I");

var $jiYsQ = parcelRequire("jiYsQ");




var $cbLP6 = parcelRequire("cbLP6");







var $41104496824bb2fd$export$7d4721a36ceb2894 = [
    'FILE',
    'CANVAS',
    'GROUP',
    'NODE',
    'PROTOTYPE',
    'OTHER'
];
var $41104496824bb2fd$export$fcc968815a3eb9c5 = [
    'READY_FOR_DEVELOPMENT',
    'UNKNOWN',
    'NONE'
];
var $41104496824bb2fd$export$a544329e8f55f05 = [
    'document',
    'alert',
    'test',
    'security',
    'logFile',
    'prototype',
    'coverage',
    'bugReport',
    'releaseNotes',
    'other'
];
var $41104496824bb2fd$var$APPEARANCES = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed',
    'success'
];
var $41104496824bb2fd$export$cfae73bab05203cf = [
    'task',
    'bug',
    'story',
    'epic',
    'feature',
    'question',
    'other',
    'incident',
    'problem',
    'approval',
    'section',
    'milestone',
    'work_item',
    'default_task'
];
var $41104496824bb2fd$export$892192ec11178e3c = [
    'folder',
    'document',
    'presentation',
    'spreadsheet',
    'image',
    'audio',
    'video',
    'pdf',
    'shortcut',
    'code',
    'archive',
    'form',
    'web-page',
    'other'
];

});
parcelRegister("cbLP6", function(module, exports) {
$parcel$export(module.exports, "isDocumentEntity", () => $8dfb9bcf939bd65e$export$32c06ee7e0e9b79e);

var $d9IlH = parcelRequire("d9IlH");

var $5Akza = parcelRequire("5Akza");

var $csH1I = parcelRequire("csH1I");

var $c2BKx = parcelRequire("c2BKx");

var $l6QMT = parcelRequire("l6QMT");
var $8dfb9bcf939bd65e$export$32c06ee7e0e9b79e = function isDocumentEntity(value) {
    if (!(0, $csH1I.isBaseEntity)(value)) return false;
    var entityType = (0, $d9IlH.asRecord)(value).type;
    return (0, $c2BKx.isObject)(entityType) && (entityType.category === undefined || (0, $l6QMT.isOneOf)((0, $5Akza.DOCUMENT_CATEGORIES), entityType.category)) && (entityType.iconUrl === undefined || typeof entityType.iconUrl === 'string') && ((0, $l6QMT.isOneOf)((0, $5Akza.DOCUMENT_CATEGORIES), entityType.category) || typeof entityType.iconUrl === 'string');
};

});
parcelRegister("l6QMT", function(module, exports) {
$parcel$export(module.exports, "isOneOf", () => $f5e31b052e4424aa$export$532a90c0e5e8e48c);
/**
 * Runtime membership check for string literal tuples.
 * Keeps guard logic aligned with tuple-derived union types.
 */ var $f5e31b052e4424aa$export$532a90c0e5e8e48c = function isOneOf(values, value) {
    return typeof value === 'string' && values.includes(value);
};

});




parcelRegister("gGVCN", function(module, exports) {
$parcel$export(module.exports, "extractEntity", () => $c26d44a34ed04f65$export$8beff7405d020ddf);
/*
 * ###########################################################################
 * Entity extraction
 * ###########################################################################
 *
 * Extractors for Smart Link entity data and entity-backed provider metadata.
 */ var $c26d44a34ed04f65$export$8beff7405d020ddf = function extractEntity(response) {
    return response === null || response === void 0 ? void 0 : response.entityData;
};

});



parcelRegister("8z1lr", function(module, exports) {
$parcel$export(module.exports, "extractProvider", () => $63c2a2a72aace7d7$export$a832871718466647);

var $25nEq = parcelRequire("25nEq");

var $gtKKv = parcelRequire("gtKKv");

var $aZpIO = parcelRequire("aZpIO");

var $lDXo7 = parcelRequire("lDXo7");
function $63c2a2a72aace7d7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $63c2a2a72aace7d7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $63c2a2a72aace7d7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $63c2a2a72aace7d7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $63c2a2a72aace7d7$var$extractProviderImage = function extractProviderImage(image) {
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $lDXo7.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $lDXo7.extractUrlFromLinkJsonLd)(image.url);
        }
    }
    return undefined;
};
var $63c2a2a72aace7d7$export$a832871718466647 = function extractProvider(jsonLd) {
    var generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return (0, $gtKKv.rebrandProvider)({
                text: generator.name
            });
        } else if (generator.name) {
            var id = generator['@id'];
            return (0, $gtKKv.rebrandProvider)($63c2a2a72aace7d7$var$_objectSpread($63c2a2a72aace7d7$var$_objectSpread({
                text: generator.name,
                icon: (0, $aZpIO.extractProviderIcon)(generator.icon, id)
            }, {
                iconLabel: generator.name
            }), {}, {
                id: id,
                image: $63c2a2a72aace7d7$var$extractProviderImage(generator.image)
            }));
        }
    }
    return undefined;
};

});
parcelRegister("aZpIO", function(module, exports) {
$parcel$export(module.exports, "extractProviderIcon", () => $021092cd1af8e147$export$6fb636a2ac885215);

var $5FkrB = parcelRequire("5FkrB");

var $ggsb9 = parcelRequire("ggsb9");

var $4W3Ko = parcelRequire("4W3Ko");

var $lyRCI = parcelRequire("lyRCI");

var $b2LXZ = parcelRequire("b2LXZ");
var $021092cd1af8e147$export$6fb636a2ac885215 = function extractProviderIcon(icon, id) {
    if (id) {
        if (id === (0, $lyRCI.CONFLUENCE_GENERATOR_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ggsb9.ConfluenceIcon), {
            appearance: "brand",
            size: "xxsmall"
        });
        else if (id === (0, $lyRCI.JIRA_GENERATOR_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4W3Ko.JiraIcon), {
            appearance: "brand",
            size: "xxsmall"
        });
    }
    if (icon) return (0, $b2LXZ.extractUrlFromIconJsonLd)(icon);
    return undefined;
};

});
parcelRegister("b2LXZ", function(module, exports) {
$parcel$export(module.exports, "extractUrlFromIconJsonLd", () => $80a516ca5bb7cdd0$export$67f3d92c824fd850);

var $lDXo7 = parcelRequire("lDXo7");
var $80a516ca5bb7cdd0$export$67f3d92c824fd850 = function extractUrlFromIconJsonLd(icon) {
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return (0, $lDXo7.extractUrlFromLinkJsonLd)(icon);
    else {
        if (icon.url) return (0, $lDXo7.extractUrlFromLinkJsonLd)(icon.url);
    }
    return undefined;
};

});
parcelRegister("lDXo7", function(module, exports) {
$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $fc1b4ebd3213f6c0$export$396ba4ef2e37dc65);
/*
 * ###########################################################################
 * URL extraction
 * ###########################################################################
 *
 * Helpers for normalising JSON-LD Link and Image URL shapes into strings.
 */ var $fc1b4ebd3213f6c0$export$396ba4ef2e37dc65 = function extractUrlFromLinkJsonLd(link) {
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $fc1b4ebd3213f6c0$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
    return undefined;
};

});




parcelRegister("lfOjW", function(module, exports) {
$parcel$export(module.exports, "isEntityPresent", () => $f792084bb02b6652$export$c7168210b81d9383);

var $gGVCN = parcelRequire("gGVCN");
var $f792084bb02b6652$export$c7168210b81d9383 = function isEntityPresent(response) {
    return Boolean((0, $gGVCN.extractEntity)(response));
};

});


parcelRegister("laW2y", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkTitle", () => $f6a78dbb0210925f$export$3eda18658b66108);

var $gGVCN = parcelRequire("gGVCN");

var $hFJoF = parcelRequire("hFJoF");

var $lfOjW = parcelRequire("lfOjW");
var $f6a78dbb0210925f$export$3eda18658b66108 = function extractSmartLinkTitle(response, removeTextHighlightingFromTitle) {
    if ((0, $lfOjW.isEntityPresent)(response)) {
        var _extractEntity;
        return (_extractEntity = (0, $gGVCN.extractEntity)(response)) === null || _extractEntity === void 0 ? void 0 : _extractEntity.displayName;
    }
    return (0, $hFJoF.extractTitle)(response === null || response === void 0 ? void 0 : response.data, removeTextHighlightingFromTitle);
};

});
parcelRegister("hFJoF", function(module, exports) {
$parcel$export(module.exports, "extractTitle", () => $cdd97ae00f34970a$export$b05803156e5015b6);

var $iYJcE = parcelRequire("iYJcE");

var $aZ14l = parcelRequire("aZ14l");

var $lm0VT = parcelRequire("lm0VT");
var $cdd97ae00f34970a$export$b05803156e5015b6 = function extractTitle(jsonLd, removeTextHighlightingFromTitle) {
    var _jsonLd$name;
    if (!jsonLd) return undefined;
    var name = (_jsonLd$name = jsonLd.name) === null || _jsonLd$name === void 0 ? void 0 : _jsonLd$name.replace(/[\r\n]+/g, '');
    var id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    var context = (0, $aZ14l.extractContext)(jsonLd);
    var type = (0, $lm0VT.extractType)(jsonLd);
    var hasContextType = context && context.type;
    var hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        var contextName = context.name && "".concat(context.name, ": ") || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            var _id$split = id.split(':'), _id$split2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_id$split, 2), hashContent = _id$split2[1];
            var hash = hashContent && "".concat(hashContent.substring(0, 8), " ");
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            var pullRequest = jsonLd;
            var internalId = pullRequest['atlassian:internalId'];
            var internalIdRef = internalId && "#".concat(internalId, " ");
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        var textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        var truncated = name === null || name === void 0 ? void 0 : name.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};

});
parcelRegister("aZ14l", function(module, exports) {
$parcel$export(module.exports, "extractContext", () => $7ff06e31c30cd84c$export$efdbd45f3e77a161);

var $lm0VT = parcelRequire("lm0VT");

var $b2LXZ = parcelRequire("b2LXZ");
var $7ff06e31c30cd84c$export$efdbd45f3e77a161 = function extractContext(jsonLd) {
    var context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && (0, $b2LXZ.extractUrlFromIconJsonLd)(context.icon),
                type: (0, $lm0VT.extractType)(context)
            };
        }
    }
    return undefined;
};

});
parcelRegister("lm0VT", function(module, exports) {
$parcel$export(module.exports, "extractType", () => $f8bc604870c13a5c$export$2e9ae379995d99e3);
/*
 * ###########################################################################
 * Primitive JSON-LD extraction
 * ###########################################################################
 *
 * Low-level extractors for scalar values and JSON-LD primitive metadata.
 */ var $f8bc604870c13a5c$export$2e9ae379995d99e3 = function extractType(jsonLd) {
    var type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
    return undefined;
};

});




parcelRegister("2mGTc", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkContext", () => $1b8ee7c54e13a31c$export$e1d190b530cf0ee9);

var $5FkrB = parcelRequire("5FkrB");

var $9kTNw = parcelRequire("9kTNw");
function $1b8ee7c54e13a31c$export$e1d190b530cf0ee9() {
    var context = (0, $5FkrB.useContext)((0, $9kTNw.SmartCardContext));
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}

});
parcelRegister("9kTNw", function(module, exports) {
$parcel$export(module.exports, "SmartCardContext", () => $6cc14395f5da269b$export$156b523e63b4f63a);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $5FkrB = parcelRequire("5FkrB");





var $6cc14395f5da269b$export$156b523e63b4f63a = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $6cc14395f5da269b$export$2e2bcd8739ae039 = $6cc14395f5da269b$export$156b523e63b4f63a;

});


parcelRegister("jFX1F", function(module, exports) {
$parcel$export(module.exports, "ACTION_RESOLVING", () => $e52fa1fe3c79a578$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $e52fa1fe3c79a578$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $e52fa1fe3c79a578$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $e52fa1fe3c79a578$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $e52fa1fe3c79a578$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $e52fa1fe3c79a578$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $e52fa1fe3c79a578$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
var $e52fa1fe3c79a578$export$6e470aad5ba8952e = 'pending';
var $e52fa1fe3c79a578$export$9a6a932a0a39498e = 'resolving';
var $e52fa1fe3c79a578$export$63ec8bc7a8a75482 = 'resolved';
var $e52fa1fe3c79a578$export$b8cfaa842c9ab487 = 'reloading';
var $e52fa1fe3c79a578$export$6d8ed3f9433dd372 = 'errored';
var $e52fa1fe3c79a578$export$cfbbb7126bc8a0c6 = 'fallback';
var $e52fa1fe3c79a578$export$76b5c1aca20759c6 = 'preload';
var $e52fa1fe3c79a578$export$2c5edb971b673330 = 'metadata';
var $e52fa1fe3c79a578$export$a884a52152489cc3 = function cardAction(type, _ref, payload, error, metadataStatus, ignoreStatusCheck) {
    var url = _ref.url;
    return {
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    };
};

});

parcelRegister("hlAuF", function(module, exports) {
$parcel$export(module.exports, "auth", () => $ca10b4b14d76ea82$export$73693bad9f5880b0);

var $ekGgq = parcelRequire("ekGgq");

var $2EfRC = parcelRequire("2EfRC");

var $imQ9z = parcelRequire("imQ9z");
function $ca10b4b14d76ea82$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise(function(resolve, reject) {
        var authWindow = null;
        var authWindowInterval;
        var handleAuthWindowMessage = function handleAuthWindowMessage(event) {
            if (event.source !== authWindow) return;
            var data = event.data;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(data) !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    var errorType = data.errorType.toLowerCase();
                    if ((0, $imQ9z.isOfTypeAuthError)(errorType)) reject(new (0, $2EfRC.AuthError)(data.message, errorType));
                    else reject(new (0, $2EfRC.AuthError)(data.message));
                    break;
            }
        };
        var handleAuthWindowInterval = function handleAuthWindowInterval() {
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $2EfRC.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        var start = function start() {
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        var finish = function finish() {
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("2EfRC", function(module, exports) {
$parcel$export(module.exports, "AuthError", () => $1edb9f68b30de640$export$145273558d58e0ac);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $1edb9f68b30de640$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $1edb9f68b30de640$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $1edb9f68b30de640$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1edb9f68b30de640$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $1edb9f68b30de640$export$145273558d58e0ac = /*#__PURE__*/ function(_Error) {
    function AuthError(message, type) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AuthError);
        _this = $1edb9f68b30de640$var$_callSuper(this, AuthError, [
            message
        ]);
        _this.message = message;
        _this.type = type;
        _this.name = 'AuthError';
        _this.type = type;
        _this.message = message;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(AuthError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AuthError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});

parcelRegister("imQ9z", function(module, exports) {
$parcel$export(module.exports, "isOfTypeAuthError", () => $d5f2bca406531d6c$export$400e64c8451aa84f);
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
var $d5f2bca406531d6c$export$400e64c8451aa84f = function isOfTypeAuthError(inputString) {
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};

});


parcelRegister("bjUKB", function(module, exports) {
$parcel$export(module.exports, "ROVO_POST_MESSAGE_EVENT_TYPE", () => $022079c4745b9c56$export$cabfb6cc8c48b099);
$parcel$export(module.exports, "useRovoPostMessageToPubsub", () => $022079c4745b9c56$export$5340cc94dd0ecbea);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $lv3ls = parcelRequire("lv3ls");
var $022079c4745b9c56$export$cabfb6cc8c48b099 = 'rovo-post-message';
var $022079c4745b9c56$export$25a11ea4740a334 = 'rovo-post-message-ack';
// allow subdomains of these domains
var $022079c4745b9c56$var$allowedSubdomains = [
    '.jira-dev.com',
    '.jira.atlassian.cloud',
    '.atlassian.com',
    '.atlassian.net',
    '.atl-paas.net'
];
var $022079c4745b9c56$var$allowedOrigins = [
    'bitbucket.org',
    'trello.com'
];
var $022079c4745b9c56$export$c9fe6aef04e3544f = function isAllowedOrigin(origin) {
    if (!origin) return false;
    var url = new URL(origin);
    var hostname = url.hostname;
    return hostname === 'localhost' || url.protocol === 'https:' && ($022079c4745b9c56$var$allowedSubdomains.some(function(subdomain) {
        return hostname.endsWith(subdomain);
    }) || $022079c4745b9c56$var$allowedOrigins.includes(hostname));
};
var $022079c4745b9c56$export$e5e1a9c59c299631 = function RovoPostMessagePubsubListener() {
    var publish = (0, $lv3ls.usePublish)('ai-mate');
    (0, $5FkrB.useEffect)(function() {
        var handlerUnbind = (0, $7QpUe.bind)(window, {
            type: 'message',
            listener: function listener(event) {
                if (!$022079c4745b9c56$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType === $022079c4745b9c56$export$cabfb6cc8c48b099) {
                    var _event$source;
                    var eventData = event.data;
                    var ackPayload = {
                        eventType: $022079c4745b9c56$export$25a11ea4740a334,
                        payloadId: eventData.payloadId
                    };
                    (_event$source = event.source) === null || _event$source === void 0 || _event$source.postMessage(ackPayload, {
                        targetOrigin: '*'
                    });
                    publish(event.data.payload);
                }
            }
        });
        return handlerUnbind;
    }, [
        publish
    ]);
    return null;
};
var $022079c4745b9c56$var$TIMEOUT_WAIT_FOR_ACK = 100;
var $022079c4745b9c56$export$5340cc94dd0ecbea = function useRovoPostMessageToPubsub() {
    var onAcknowledgeTimeoutTimeoutRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isWaitingForAck = _useState2[0], setIsWaitingForAck = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        var handlerUnbind = (0, $7QpUe.bind)(window, {
            type: 'message',
            // handler for acknowledgment from parent
            listener: function listener(event) {
                if (!$022079c4745b9c56$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType !== $022079c4745b9c56$export$25a11ea4740a334 || onAcknowledgeTimeoutTimeoutRef.current === null) return;
                var eventData = event.data;
                // if the parent acknowledges different payload (e.g. from different hook instance)
                // disregard the event
                if (eventData.payloadId !== onAcknowledgeTimeoutTimeoutRef.current.lastPayloadId) return;
                // Clear the onAcknowledgeTimeoutTimeout if acknowledgment is received
                clearTimeout(onAcknowledgeTimeoutTimeoutRef.current.timeout);
                onAcknowledgeTimeoutTimeoutRef.current = null;
                setIsWaitingForAck(false);
            }
        });
        return handlerUnbind;
    }, []);
    var publishWithPostMessage = (0, $5FkrB.useCallback)(function(_ref) {
        var _ref$targetWindow = _ref.targetWindow, targetWindow = _ref$targetWindow === void 0 ? window.parent : _ref$targetWindow, payload = _ref.payload, onAcknowledgeTimeout = _ref.onAcknowledgeTimeout;
        if (!targetWindow) return;
        var payloadId = Math.floor(Math.random() * 1e6).toString();
        targetWindow.postMessage({
            eventType: $022079c4745b9c56$export$cabfb6cc8c48b099,
            payload: payload,
            payloadId: payloadId
        }, '*');
        // waiting for acknowledgment from parent
        // if no acknowledgment is received, call onAcknowledgeTimeout
        setIsWaitingForAck(true);
        var timeout = window.setTimeout(function() {
            onAcknowledgeTimeout({
                payload: payload
            });
            onAcknowledgeTimeoutTimeoutRef.current = null;
            setIsWaitingForAck(false);
        }, $022079c4745b9c56$var$TIMEOUT_WAIT_FOR_ACK);
        onAcknowledgeTimeoutTimeoutRef.current = {
            timeout: timeout,
            lastPayloadId: payloadId
        };
    }, []);
    return {
        publishWithPostMessage: publishWithPostMessage,
        isWaitingForAck: isWaitingForAck
    };
};

});
parcelRegister("lv3ls", function(module, exports) {
$parcel$export(module.exports, "usePublish", () => $fa6f167fd22937ac$export$d55c81786220731c);

var $25nEq = parcelRequire("25nEq");

var $2BL4q = parcelRequire("2BL4q");

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");
function $fa6f167fd22937ac$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fa6f167fd22937ac$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fa6f167fd22937ac$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fa6f167fd22937ac$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fa6f167fd22937ac$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $fa6f167fd22937ac$var$MAX_CONSUMED_EVENT_KEYS = 5000;
var $fa6f167fd22937ac$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload',
    'agent-changed',
    // Internal signals that must never overwrite the publish queue — they would
    // cause `triggerLatest` subscribers (e.g. PubSubListener) to replay them
    // instead of the real action event (e.g. open-browse-agent-modal) that
    // originally opened the chat.
    'smartlinks-subscription-changed',
    'smartlinks-context-payload',
    'set-message-context',
    'jira-create-context-payload',
    'submit-rovo-remix',
    'rovo-remix-handoff-failed'
]);
var $fa6f167fd22937ac$var$isIgnoredForTriggerLatest = function isIgnoredForTriggerLatest(type) {
    return $fa6f167fd22937ac$var$ignoredTriggerLatestEvents.has(type);
};
var $fa6f167fd22937ac$var$createPubSub = function createPubSub() {
    var subscribedEvents = {};
    var publishQueue = {};
    var wildcardEvents = [];
    var consumedEventKeys = new Set();
    var consumedEventKeyQueue = [];
    var subIdCounter = 0;
    var eventIdCounter = 0;
    var generateSubId = function generateSubId() {
        subIdCounter += 1;
        return subIdCounter.toString();
    };
    var createEvent = function createEvent(payload) {
        eventIdCounter += 1;
        return {
            id: eventIdCounter.toString(),
            payload: payload
        };
    };
    var rememberConsumedEventKey = function rememberConsumedEventKey(claimKey) {
        consumedEventKeys.add(claimKey);
        consumedEventKeyQueue = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(consumedEventKeyQueue), [
            claimKey
        ]);
        if (consumedEventKeyQueue.length > $fa6f167fd22937ac$var$MAX_CONSUMED_EVENT_KEYS) {
            var _consumedEventKeyQueu = consumedEventKeyQueue, _consumedEventKeyQueu2 = (0, (/*@__PURE__*/$parcel$interopDefault($2BL4q)))(_consumedEventKeyQueu), oldestClaimKey = _consumedEventKeyQueu2[0], remainingClaimKeys = $fa6f167fd22937ac$var$_arrayLikeToArray(_consumedEventKeyQueu2).slice(1);
            consumedEventKeyQueue = remainingClaimKeys;
            if (oldestClaimKey) consumedEventKeys.delete(oldestClaimKey);
        }
    };
    var claimConsumeOnceEvent = function claimConsumeOnceEvent(_ref) {
        var event = _ref.event, consumeOnceKey = _ref.consumeOnceKey;
        if (!event.payload.consumeOnce || !consumeOnceKey) return true;
        var claimKey = "".concat(consumeOnceKey, ":").concat(event.id);
        if (consumedEventKeys.has(claimKey)) return false;
        rememberConsumedEventKey(claimKey);
        return true;
    };
    var subscribe = function subscribe(_ref2, callback) {
        var _subscribedEvents$top;
        var topic = _ref2.topic, triggerLatest = _ref2.triggerLatest, consumeOnceKey = _ref2.consumeOnceKey;
        var events = (_subscribedEvents$top = subscribedEvents[topic]) !== null && _subscribedEvents$top !== void 0 ? _subscribedEvents$top : [];
        var subId = generateSubId();
        var subExists = events.some(function(_ref3) {
            var id = _ref3.id;
            return id === subId;
        });
        var callbackWithConsumption = function callbackWithConsumption(event) {
            if (!claimConsumeOnceEvent({
                event: event,
                consumeOnceKey: consumeOnceKey
            })) return;
            callback(event.payload);
        };
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = $fa6f167fd22937ac$var$_objectSpread($fa6f167fd22937ac$var$_objectSpread({}, subscribedEvents), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, topic, [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(events), [
                {
                    callback: callbackWithConsumption,
                    id: subId
                }
            ])));
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                var _event = publishQueue[topic];
                callbackWithConsumption(_event);
                delete publishQueue[topic];
            }
        }
        return function() {
            // Remove from Topic stack
            subscribedEvents = $fa6f167fd22937ac$var$_objectSpread($fa6f167fd22937ac$var$_objectSpread({}, subscribedEvents), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, topic, (subscribedEvents[topic] || []).filter(function(_ref4) {
                var id = _ref4.id;
                return id !== subId;
            })));
        };
    };
    var subscribeAll = function subscribeAll(callback) {
        var subId = wildcardEvents.length.toString();
        wildcardEvents = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(wildcardEvents), [
            {
                callback: callback,
                id: subId
            }
        ]);
        return function() {
            wildcardEvents = wildcardEvents.filter(function(_ref5) {
                var id = _ref5.id;
                return id !== subId;
            });
        };
    };
    var publish = function publish(topic, payload) {
        var event = createEvent(payload);
        /**
     * Log that this Topic received a published event, regardless of whether it has subscribers or not.
     * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
     */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$fa6f167fd22937ac$var$isIgnoredForTriggerLatest(payload.type)) publishQueue[topic] = event;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(function(_ref6) {
            var callback = _ref6.callback;
            return callback(event.payload);
        });
        var topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(function(_ref7) {
            var callback = _ref7.callback;
            return callback(event);
        });
    };
    var flushQueue = function flushQueue() {
        publishQueue = {};
    };
    var clearLatest = function clearLatest(topic) {
        delete publishQueue[topic];
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish,
        flushQueue: flushQueue,
        clearLatest: clearLatest
    };
};
var $fa6f167fd22937ac$var$pubSub = $fa6f167fd22937ac$var$createPubSub();
var $fa6f167fd22937ac$export$89b472e03be495df = function publish(topic, payload) {
    $fa6f167fd22937ac$var$pubSub.publish(topic, payload);
};
var $fa6f167fd22937ac$var$usePubSub = function usePubSub() {
    return $fa6f167fd22937ac$var$pubSub;
};
var $fa6f167fd22937ac$export$d3d523392640272 = function useSubscribe(_ref8, callback) {
    var topic = _ref8.topic, triggerLatest = _ref8.triggerLatest, clearLatestOnUnmount = _ref8.clearLatestOnUnmount, consumeOnceKey = _ref8.consumeOnceKey;
    var _usePubSub = $fa6f167fd22937ac$var$usePubSub(), subscribe = _usePubSub.subscribe, clearLatest = _usePubSub.clearLatest;
    var callbackRef = (0, $5FkrB.useRef)(callback);
    callbackRef.current = callback;
    (0, $5FkrB.useEffect)(function() {
        var unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest,
            consumeOnceKey: consumeOnceKey
        }, function() {
            return callbackRef.current.apply(callbackRef, arguments);
        });
        return function() {
            unsubscribe();
            if (clearLatestOnUnmount) clearLatest(topic);
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic,
        clearLatestOnUnmount,
        consumeOnceKey
    ]);
};
var $fa6f167fd22937ac$export$2570c8aa24b6d327 = function useSubscribeAll(callback) {
    var _usePubSub2 = $fa6f167fd22937ac$var$usePubSub(), subscribeAll = _usePubSub2.subscribeAll;
    var callbackRef = (0, $5FkrB.useRef)(callback);
    callbackRef.current = callback;
    (0, $5FkrB.useEffect)(function() {
        var unsubscribe = subscribeAll(function() {
            return callbackRef.current.apply(callbackRef, arguments);
        });
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
var $fa6f167fd22937ac$var$useFlushOnUnmount = function useFlushOnUnmount() {
    var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _usePubSub3 = $fa6f167fd22937ac$var$usePubSub(), flushQueue = _usePubSub3.flushQueue;
    (0, $5FkrB.useLayoutEffect)(function() {
        return function() {
            if (active) flushQueue();
        };
    }, [
        active,
        flushQueue
    ]);
};
var $fa6f167fd22937ac$export$d55c81786220731c = function usePublish(topic) {
    var _usePubSub4 = $fa6f167fd22937ac$var$usePubSub(), publish = _usePubSub4.publish;
    var publishFn = (0, $5FkrB.useCallback)(function(payload) {
        return publish(topic, payload);
    }, [
        publish,
        topic
    ]);
    return publishFn;
};
var $fa6f167fd22937ac$export$60959659b2c22881 = function Subscriber(_ref9) {
    var topic = _ref9.topic, triggerLatest = _ref9.triggerLatest, onEvent = _ref9.onEvent, flushQueueOnUnmount = _ref9.flushQueueOnUnmount, consumeOnceKey = _ref9.consumeOnceKey;
    $fa6f167fd22937ac$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest,
        consumeOnceKey: consumeOnceKey
    }, onEvent);
    $fa6f167fd22937ac$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
};

});
parcelRegister("2BL4q", function(module, exports) {

var $4rHdx = parcelRequire("4rHdx");

var $2XfV2 = parcelRequire("2XfV2");

var $ccaOk = parcelRequire("ccaOk");

var $lzFPZ = parcelRequire("lzFPZ");
function $1e638cafe0c7118a$var$_toArray(r) {
    return $4rHdx(r) || $2XfV2(r) || $ccaOk(r) || $lzFPZ();
}
module.exports = $1e638cafe0c7118a$var$_toArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("bC7my", function(module, exports) {
$parcel$export(module.exports, "expValEquals", () => $8748f4649f3753ad$export$45abdb3f977b5b14);

var $4jHwJ = parcelRequire("4jHwJ");
function $8748f4649f3753ad$export$45abdb3f977b5b14(experimentName, experimentParam, experimentExpectedValue) {
    var experimentDefaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return (0, $4jHwJ.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, true);
}

});
parcelRegister("4jHwJ", function(module, exports) {
$parcel$export(module.exports, "expValEqualsInternal", () => $324ab34d51fffccf$export$58e581060588c6bb);

var $bAG7O = parcelRequire("bAG7O");

var $4KAQU = parcelRequire("4KAQU");

var $7mjXs = parcelRequire("7mjXs");

var $dNDkt = parcelRequire("dNDkt");
// This internal representation doesn't currently support productKeys
// the way expVal(...) does, this adds temporary support for some keys while
// we determine our preferred approach forward
var $324ab34d51fffccf$var$allowsProductKeys = [
    'cc-maui-experiment',
    'cc_maui_create_keyword',
    'cc_maui_create_keyword_aa',
    'platform_use_unicode_emojis'
];
function $324ab34d51fffccf$export$58e581060588c6bb(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, experimentExposure) {
    var _editorExperimentsCon, _editorExperimentsCon2;
    if ((0, $dNDkt._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $dNDkt._overrides)[experimentName] === experimentExpectedValue;
    // If client is not initialized, we compare with the default value
    if (!(0, $bAG7O.default).initializeCompleted()) return experimentDefaultValue === experimentExpectedValue;
    // Typescript is complaining here about accessing the productKeys property
    var experimentKeyName = $324ab34d51fffccf$var$allowsProductKeys.includes(experimentName) ? (_editorExperimentsCon = (_editorExperimentsCon2 = (0, $7mjXs.editorExperimentsConfig)[experimentName]) === null || _editorExperimentsCon2 === void 0 || (_editorExperimentsCon2 = _editorExperimentsCon2.productKeys) === null || _editorExperimentsCon2 === void 0 ? void 0 : _editorExperimentsCon2[0, $dNDkt._product]) !== null && _editorExperimentsCon !== void 0 ? _editorExperimentsCon : experimentName : experimentName;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $bAG7O.default).getExperimentValue(experimentKeyName, experimentParam, experimentDefaultValue, {
        fireExperimentExposure: experimentExposure
    });
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $bAG7O.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $4KAQU.addFeatureFlagAccessed)("".concat(experimentKeyName, ":").concat(experimentParam), experimentValue);
    return experimentValue === experimentExpectedValue;
}

});
parcelRegister("bAG7O", function(module, exports) {
$parcel$export(module.exports, "default", () => $8703bba7d09fb26b$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $deqfH = parcelRequire("deqfH");

var $iV3LX = parcelRequire("iV3LX");



var $8703bba7d09fb26b$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $8703bba7d09fb26b$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$8703bba7d09fb26b$var$_FeatureGates = $8703bba7d09fb26b$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "client", new (0, $deqfH.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$8703bba7d09fb26b$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $8703bba7d09fb26b$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $8703bba7d09fb26b$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$8703bba7d09fb26b$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $8703bba7d09fb26b$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $8703bba7d09fb26b$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "initializeCalled", $8703bba7d09fb26b$var$_FeatureGates.client.initializeCalled.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "initializeCompleted", $8703bba7d09fb26b$var$_FeatureGates.client.initializeCompleted.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "waitUntilInitializeCompleted", $8703bba7d09fb26b$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "initialize", $8703bba7d09fb26b$var$_FeatureGates.client.initialize.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "initializeWithProvider", $8703bba7d09fb26b$var$_FeatureGates.client.initializeWithProvider.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "initializeFromValues", $8703bba7d09fb26b$var$_FeatureGates.client.initializeFromValues.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "manuallyLogGateExposure", $8703bba7d09fb26b$var$_FeatureGates.client.manuallyLogGateExposure.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "getExperiment", $8703bba7d09fb26b$var$_FeatureGates.client.getExperiment.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "manuallyLogExperimentExposure", $8703bba7d09fb26b$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "manuallyLogLayerExposure", $8703bba7d09fb26b$var$_FeatureGates.client.manuallyLogLayerExposure.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "shutdownStatsig", $8703bba7d09fb26b$var$_FeatureGates.client.shutdownStatsig.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "overrideGate", $8703bba7d09fb26b$var$_FeatureGates.client.overrideGate.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "clearGateOverride", $8703bba7d09fb26b$var$_FeatureGates.client.clearGateOverride.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "overrideConfig", $8703bba7d09fb26b$var$_FeatureGates.client.overrideConfig.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "clearConfigOverride", $8703bba7d09fb26b$var$_FeatureGates.client.clearConfigOverride.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "setOverrides", $8703bba7d09fb26b$var$_FeatureGates.client.setOverrides.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "getOverrides", $8703bba7d09fb26b$var$_FeatureGates.client.getOverrides.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "clearAllOverrides", $8703bba7d09fb26b$var$_FeatureGates.client.clearAllOverrides.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "isCurrentUser", $8703bba7d09fb26b$var$_FeatureGates.client.isCurrentUser.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "onGateUpdated", $8703bba7d09fb26b$var$_FeatureGates.client.onGateUpdated.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "onExperimentValueUpdated", $8703bba7d09fb26b$var$_FeatureGates.client.onExperimentValueUpdated.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "onAnyUpdated", $8703bba7d09fb26b$var$_FeatureGates.client.onAnyUpdated.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "updateUser", $8703bba7d09fb26b$var$_FeatureGates.client.updateUser.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "updateUserWithProvider", $8703bba7d09fb26b$var$_FeatureGates.client.updateUserWithProvider.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "updateUserWithValues", $8703bba7d09fb26b$var$_FeatureGates.client.updateUserWithValues.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "getPackageVersion", $8703bba7d09fb26b$var$_FeatureGates.client.getPackageVersion.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "getTargetApp", $8703bba7d09fb26b$var$_FeatureGates.client.getTargetApp.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "getLayer", $8703bba7d09fb26b$var$_FeatureGates.client.getLayer.bind($8703bba7d09fb26b$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8703bba7d09fb26b$var$FeatureGates, "getLayerValue", $8703bba7d09fb26b$var$_FeatureGates.client.getLayerValue.bind($8703bba7d09fb26b$var$_FeatureGates.client));
var $8703bba7d09fb26b$var$boundFGJS = $8703bba7d09fb26b$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $8703bba7d09fb26b$var$FeatureGates;
    else {
        var $8703bba7d09fb26b$var$_boundFGJS, $8703bba7d09fb26b$var$_boundFGJS$getPackage;
        $8703bba7d09fb26b$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $8703bba7d09fb26b$var$boundVersion = (($8703bba7d09fb26b$var$_boundFGJS = $8703bba7d09fb26b$var$boundFGJS) === null || $8703bba7d09fb26b$var$_boundFGJS === void 0 || ($8703bba7d09fb26b$var$_boundFGJS$getPackage = $8703bba7d09fb26b$var$_boundFGJS.getPackageVersion) === null || $8703bba7d09fb26b$var$_boundFGJS$getPackage === void 0 ? void 0 : $8703bba7d09fb26b$var$_boundFGJS$getPackage.call($8703bba7d09fb26b$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($8703bba7d09fb26b$var$boundVersion !== (0, $iV3LX.CLIENT_VERSION)) {
            var $8703bba7d09fb26b$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($8703bba7d09fb26b$var$boundVersion, " when module version ").concat((0, $iV3LX.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($8703bba7d09fb26b$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $8703bba7d09fb26b$export$2e2bcd8739ae039 = $8703bba7d09fb26b$var$boundFGJS;

});
parcelRegister("deqfH", function(module, exports) {
$parcel$export(module.exports, "Client", () => $9a20f2520d8cba6d$export$1f2bb630327ac4b6);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");

var $1nJHg = parcelRequire("1nJHg");

var $cVLzW = parcelRequire("cVLzW");

var $hiRzR = parcelRequire("hiRzR");

var $diBRz = parcelRequire("diBRz");

var $iN1Fl = parcelRequire("iN1Fl");

var $8KhEl = parcelRequire("8KhEl");

var $5Gwtc = parcelRequire("5Gwtc");

var $bPmyl = parcelRequire("bPmyl");

var $3uvHw = parcelRequire("3uvHw");

var $78y5q = parcelRequire("78y5q");

var $g3Xf7 = parcelRequire("g3Xf7");

var $fbCBs = parcelRequire("fbCBs");

var $7EZnb = parcelRequire("7EZnb");

var $iV3LX = parcelRequire("iV3LX");
var $9a20f2520d8cba6d$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $9a20f2520d8cba6d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9a20f2520d8cba6d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9a20f2520d8cba6d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9a20f2520d8cba6d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9a20f2520d8cba6d$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $9a20f2520d8cba6d$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $9a20f2520d8cba6d$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $78y5q.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscriptions", new (0, $1nJHg.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "dataAdapter", new (0, $3uvHw.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $78y5q.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $5Gwtc.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 1;
                                    break;
                                }
                                if (!(0, $g3Xf7.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $5Gwtc.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 1;
                                    break;
                                }
                                if (!(0, $g3Xf7.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $iV3LX.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $9a20f2520d8cba6d$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $iV3LX.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $7EZnb.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $5Gwtc.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 1;
                                    break;
                                }
                                if (!(0, $g3Xf7.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 1:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $5Gwtc.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $8KhEl.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 1;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 1:
                                _context5.next = 2;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 2:
                                _context5.next = 3;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 1:
                                if (!this.initCompleted) {
                                    _context7.next = 2;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 2:
                                _context7.next = 3;
                                return this.initPromise;
                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $cVLzW.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $cVLzW.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $diBRz.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $g3Xf7.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $g3Xf7.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $9a20f2520d8cba6d$var$_objectSpread({}, clientOptions);
                                if (!clientOptions.localMode) {
                                    _context8.next = 2;
                                    break;
                                }
                                _context8.next = 1;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 1:
                                return _context8.abrupt("return");
                            case 2:
                                _context8.prev = 2;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $8KhEl.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $8KhEl.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 6;
                                break;
                            case 4:
                                _context8.prev = 4;
                                _t = _context8["catch"](2);
                                if (_t instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t === null || _t === void 0 ? void 0 : _t.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t;
                            case 6:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            2,
                            4
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $9a20f2520d8cba6d$var$_objectSpread($9a20f2520d8cba6d$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 2;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 2:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 6;
                                break;
                            case 4:
                                _context9.prev = 4;
                                _t2 = _context9["catch"](1);
                                if (_t2 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t2 === null || _t2 === void 0 ? void 0 : _t2.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t2;
                            case 6:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            4
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, _args0 = arguments, _t3;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $bPmyl.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $9a20f2520d8cba6d$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $9a20f2520d8cba6d$var$_objectSpread($9a20f2520d8cba6d$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $9a20f2520d8cba6d$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $7EZnb.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(newClientOptions, $9a20f2520d8cba6d$var$_excluded);
                                frontendUser = (0, $fbCBs.toStatsigUser)(identifiers, customAttributes);
                                this.user = (0, $iN1Fl.deepAssign)({}, initializeValues.user, frontendUser);
                                statsigOptions = $9a20f2520d8cba6d$var$_objectSpread($9a20f2520d8cba6d$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 1;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 2;
                                return this.statsigClient.initializeAsync();
                            case 2:
                                _context0.next = 5;
                                break;
                            case 3:
                                _context0.prev = 3;
                                _t3 = _context0["catch"](1);
                                if (_t3 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_t3 === null || _t3 === void 0 ? void 0 : _t3.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($9a20f2520d8cba6d$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 4;
                                return this.statsigClient.initializeAsync();
                            case 4:
                                this.initWithDefaults = true;
                                throw _t3;
                            case 5:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise, _t4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 1:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 2;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 2:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 3;
                                _context10.next = 4;
                                return this.initPromise;
                            case 4:
                                _context10.next = 6;
                                break;
                            case 5:
                                _context10.prev = 5;
                                _t4 = _context10["catch"](3);
                            case 6:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 1;
                                                    break;
                                                }
                                                _context1.next = 1;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 1:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 7:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            3,
                            5
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, frontendUser, _updateUserCompletion, _ref4, errMsg, success, errorMessage, _t5, _t6;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 2;
                                return initializeValuesPromise;
                            case 2:
                                initializeValues = _context11.sent;
                                frontendUser = (0, $fbCBs.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, $iN1Fl.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
                                _context11.next = 4;
                                break;
                            case 3:
                                _context11.prev = 3;
                                _t5 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _t5 instanceof Error ? _t5.message : JSON.stringify(_t5);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _t5;
                            case 4:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 5;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 6;
                                    break;
                                }
                                _context11.next = 6;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 6:
                                _context11.next = 8;
                                break;
                            case 7:
                                _context11.prev = 7;
                                _t6 = _context11["catch"](5);
                                success = false;
                                errorMessage = String(_t6);
                            case 8:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 9;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 10;
                                break;
                            case 9:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 10:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            3
                        ],
                        [
                            5,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $iV3LX.CLIENT_VERSION;
            }
        },
        {
            key: "getTargetApp",
            value: function getTargetApp() {
                var _this$initOptions2;
                return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $hiRzR.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $hiRzR.Layer).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("1nJHg", function(module, exports) {
$parcel$export(module.exports, "default", () => $101b62d7db2fdadf$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $hLfKH = parcelRequire("hLfKH");
function $101b62d7db2fdadf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $101b62d7db2fdadf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $101b62d7db2fdadf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $101b62d7db2fdadf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $101b62d7db2fdadf$export$a66cbd9b2289cd78 = '@all-features';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $101b62d7db2fdadf$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $101b62d7db2fdadf$var$_objectSpread($101b62d7db2fdadf$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $101b62d7db2fdadf$var$_objectSpread($101b62d7db2fdadf$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $101b62d7db2fdadf$var$_objectSpread($101b62d7db2fdadf$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $101b62d7db2fdadf$var$_objectSpread($101b62d7db2fdadf$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($101b62d7db2fdadf$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($101b62d7db2fdadf$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($101b62d7db2fdadf$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $101b62d7db2fdadf$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("cVLzW", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $969fb7070515aae9$export$6dc24881a3d96325);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6m0RJ = parcelRequire("6m0RJ");

var $25Y3K = parcelRequire("25Y3K");
var $969fb7070515aae9$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $6m0RJ.migrateEvaluationDetails)(experiment.details), (0, $25Y3K.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("6m0RJ", function(module, exports) {
$parcel$export(module.exports, "migrateEvaluationDetails", () => $4a0578074d85fe61$export$18ad168d3dbac899);

var $iYJcE = parcelRequire("iYJcE");

var $diBRz = parcelRequire("diBRz");
var $4a0578074d85fe61$var$evaluationReasonMappings = Object.entries((0, $diBRz.EvaluationReason)).map(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $4a0578074d85fe61$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $4a0578074d85fe61$var$evaluationReasonMappings.find(function(_ref3) {
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 1), key = _ref4[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $diBRz.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};

});
parcelRegister("diBRz", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $9aea53997775d3e7$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $9aea53997775d3e7$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
}; // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});


parcelRegister("25Y3K", function(module, exports) {
$parcel$export(module.exports, "migrateSecondaryExposures", () => $186aa2f8cd2c68c2$export$55fd683752d01e67);
var $186aa2f8cd2c68c2$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});


parcelRegister("hiRzR", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $c98dad77a5afd203$export$936d0764594b6eb3);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6m0RJ = parcelRequire("6m0RJ");

var $25Y3K = parcelRequire("25Y3K");
var $c98dad77a5afd203$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $6m0RJ.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $25Y3K.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $25Y3K.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("iN1Fl", function(module, exports) {
$parcel$export(module.exports, "deepAssign", () => $dade186746a4ed10$export$1148cb79ceecd5fa);

var $ekGgq = parcelRequire("ekGgq");

var $iYJcE = parcelRequire("iYJcE");

var $fC8ib = parcelRequire("fC8ib");
function $dade186746a4ed10$export$1148cb79ceecd5fa(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return $dade186746a4ed10$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sources)));
    for(var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], src = _Object$entries$_i[1];
        var dst = target[key];
        var srcIsObj = src && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(src) === 'object' && !Array.isArray(src);
        var dstIsObj = dst && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(dst) === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $dade186746a4ed10$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $dade186746a4ed10$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sources)));
}

});

parcelRegister("8KhEl", function(module, exports) {
$parcel$export(module.exports, "default", () => $65e04f731ed4fd60$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $7EZnb = parcelRequire("7EZnb");

var $iV3LX = parcelRequire("iV3LX");

var $6XVMh = parcelRequire("6XVMh");
function $65e04f731ed4fd60$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $65e04f731ed4fd60$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $65e04f731ed4fd60$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $65e04f731ed4fd60$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $65e04f731ed4fd60$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $65e04f731ed4fd60$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $65e04f731ed4fd60$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $65e04f731ed4fd60$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $65e04f731ed4fd60$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $65e04f731ed4fd60$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $65e04f731ed4fd60$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $65e04f731ed4fd60$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $65e04f731ed4fd60$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $65e04f731ed4fd60$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $65e04f731ed4fd60$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(fetcherOptions) {
                    var targetApp, url, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 1;
                                _context.next = 2;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                                _context.prev = 3;
                                _t = _context["catch"](1);
                                if (!(_t instanceof Error)) {
                                    _context.next = 4;
                                    break;
                                }
                                throw _t;
                            case 4:
                                throw Error('Failed to retrieve client sdk key');
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 2;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                                _context2.prev = 3;
                                _t2 = _context2["catch"](1);
                                if (!(_t2 instanceof Error)) {
                                    _context2.next = 4;
                                    break;
                                }
                                throw _t2;
                            case 4:
                                throw Error('Failed to retrieve experiment values');
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 2;
                                    break;
                                }
                                _context3.next = 1;
                                return response.text();
                            case 1:
                                body = _context3.sent;
                                throw new (0, $6XVMh.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 2:
                                if (!(response.status === 204)) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new (0, $6XVMh.ResponseError)('Unexpected 204 response');
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return response.text();
                            case 1:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $65e04f731ed4fd60$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $7EZnb.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $7EZnb.FeatureGateEnvironment).Production:
                        return $65e04f731ed4fd60$export$18c93900db9358a4;
                    case (0, $7EZnb.FeatureGateEnvironment).Staging:
                        return $65e04f731ed4fd60$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $7EZnb.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $7EZnb.FeatureGateEnvironment).Development:
                        return $65e04f731ed4fd60$export$f058dbf75c3bc647;
                    case (0, $7EZnb.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $65e04f731ed4fd60$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $65e04f731ed4fd60$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $65e04f731ed4fd60$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 1;
                                return fetch("".concat(baseUrl).concat(path), $65e04f731ed4fd60$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $iV3LX.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 1:
                                response = _context5.sent;
                                _context5.next = 2;
                                return this.handleResponseError(response);
                            case 2:
                                _context5.next = 3;
                                return this.extractResponseBody(response);
                            case 3:
                                return _context5.abrupt("return", _context5.sent);
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $65e04f731ed4fd60$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($65e04f731ed4fd60$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($65e04f731ed4fd60$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("7EZnb", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $593be0361b97029b$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $593be0361b97029b$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $593be0361b97029b$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
var $593be0361b97029b$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
var $593be0361b97029b$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});

parcelRegister("iV3LX", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $dc6079ffa8c82c46$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $dc6079ffa8c82c46$export$a59f8d67326bd1cb = "6.0.2";

});

parcelRegister("6XVMh", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $51251235b73cf341$export$286baf652d0b1206);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $51251235b73cf341$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $51251235b73cf341$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $51251235b73cf341$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($51251235b73cf341$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $51251235b73cf341$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ResponseError);
        return $51251235b73cf341$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});


parcelRegister("5Gwtc", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $423a0fd3ca5dc561$export$d119b37e5f788b43);

var $25nEq = parcelRequire("25nEq");

var $ygbGG = parcelRequire("ygbGG");

var $7EZnb = parcelRequire("7EZnb");
function $423a0fd3ca5dc561$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $423a0fd3ca5dc561$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $423a0fd3ca5dc561$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $423a0fd3ca5dc561$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $423a0fd3ca5dc561$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $423a0fd3ca5dc561$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $ygbGG.isFedRamp)() ? (0, $7EZnb.PerimeterType).FEDRAMP_MODERATE : (0, $7EZnb.PerimeterType).COMMERCIAL
    }, options);
};

});

parcelRegister("bPmyl", function(module, exports) {
$parcel$export(module.exports, "migrateInitializationOptions", () => $89c5f3a99cc91151$export$202946b690d26d22);

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");
var $89c5f3a99cc91151$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $89c5f3a99cc91151$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $89c5f3a99cc91151$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $89c5f3a99cc91151$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $89c5f3a99cc91151$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $89c5f3a99cc91151$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(options, $89c5f3a99cc91151$var$_excluded);
    return $89c5f3a99cc91151$var$_objectSpread($89c5f3a99cc91151$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};

});

parcelRegister("3uvHw", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $28acc39d16f53b7e$export$55fffef3474104af);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");
function $28acc39d16f53b7e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $28acc39d16f53b7e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $28acc39d16f53b7e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $28acc39d16f53b7e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $28acc39d16f53b7e$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $28acc39d16f53b7e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $28acc39d16f53b7e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($28acc39d16f53b7e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $28acc39d16f53b7e$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $28acc39d16f53b7e$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoFetchDataAdapter);
        _this = $28acc39d16f53b7e$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $28acc39d16f53b7e$var$_objectSpread($28acc39d16f53b7e$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $28acc39d16f53b7e$var$_objectSpread($28acc39d16f53b7e$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $28acc39d16f53b7e$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $28acc39d16f53b7e$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));

});

parcelRegister("78y5q", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $5323b8a27a01f5c9$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $5323b8a27a01f5c9$export$bcb28fbac1def494);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $dtn6l = parcelRequire("dtn6l");
function $5323b8a27a01f5c9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5323b8a27a01f5c9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5323b8a27a01f5c9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5323b8a27a01f5c9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5323b8a27a01f5c9$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $5323b8a27a01f5c9$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $5323b8a27a01f5c9$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5323b8a27a01f5c9$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5323b8a27a01f5c9$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $5323b8a27a01f5c9$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $5323b8a27a01f5c9$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $5323b8a27a01f5c9$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $5323b8a27a01f5c9$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $5323b8a27a01f5c9$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $5323b8a27a01f5c9$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $5323b8a27a01f5c9$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PersistentOverrideAdapter);
        this._overrides = $5323b8a27a01f5c9$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $5323b8a27a01f5c9$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $5323b8a27a01f5c9$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $5323b8a27a01f5c9$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($5323b8a27a01f5c9$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.removeItem($5323b8a27a01f5c9$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $5323b8a27a01f5c9$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $5323b8a27a01f5c9$var$_objectSpread($5323b8a27a01f5c9$var$_objectSpread({}, $5323b8a27a01f5c9$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($5323b8a27a01f5c9$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($5323b8a27a01f5c9$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($5323b8a27a01f5c9$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($5323b8a27a01f5c9$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $5323b8a27a01f5c9$var$_objectSpread($5323b8a27a01f5c9$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $5323b8a27a01f5c9$var$_objectSpread($5323b8a27a01f5c9$var$_objectSpread({}, current.details), {}, {
                        reason: $5323b8a27a01f5c9$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($5323b8a27a01f5c9$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($5323b8a27a01f5c9$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($5323b8a27a01f5c9$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($5323b8a27a01f5c9$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($5323b8a27a01f5c9$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($5323b8a27a01f5c9$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $5323b8a27a01f5c9$var$makeEmptyStore();
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($5323b8a27a01f5c9$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $5323b8a27a01f5c9$var$_objectSpread($5323b8a27a01f5c9$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $5323b8a27a01f5c9$var$_objectSpread($5323b8a27a01f5c9$var$_objectSpread({}, current.details), {}, {
                        reason: $5323b8a27a01f5c9$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($5323b8a27a01f5c9$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $5323b8a27a01f5c9$var$_objectSpread($5323b8a27a01f5c9$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $5323b8a27a01f5c9$var$_objectSpread($5323b8a27a01f5c9$var$_objectSpread({}, current.details), {}, {
                        reason: $5323b8a27a01f5c9$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});

parcelRegister("g3Xf7", function(module, exports) {
$parcel$export(module.exports, "shallowEquals", () => $bb1ae18953e2f6a7$export$fa1c2bbf4100b8bc);

var $iYJcE = parcelRequire("iYJcE");
var $bb1ae18953e2f6a7$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};

});

parcelRegister("fbCBs", function(module, exports) {
$parcel$export(module.exports, "toStatsigUser", () => $b0e5d3e74438c5a1$export$3dad1db244472f32);

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");
var $b0e5d3e74438c5a1$var$_excluded = [
    "stableId"
];
function $b0e5d3e74438c5a1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b0e5d3e74438c5a1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b0e5d3e74438c5a1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b0e5d3e74438c5a1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b0e5d3e74438c5a1$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    var stableId = identifiers.stableId, otherIdentifiers = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(identifiers, $b0e5d3e74438c5a1$var$_excluded);
    var user = {
        customIDs: $b0e5d3e74438c5a1$var$_objectSpread($b0e5d3e74438c5a1$var$_objectSpread({}, otherIdentifiers), stableId !== undefined ? {
            stableID: stableId
        } : {}),
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};

});



parcelRegister("4KAQU", function(module, exports) {
$parcel$export(module.exports, "addFeatureFlagAccessed", () => $37580b6795b12104$export$47fade9662f71000);

var $6Qkln = parcelRequire("6Qkln");
var $37580b6795b12104$export$5b78c989c8db2561 = new Map();
var $37580b6795b12104$export$2a5c8df26bb89760 = new Map();
function $37580b6795b12104$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    var value = (0, $6Qkln.redactValue)(featureFlagValue);
    $37580b6795b12104$export$5b78c989c8db2561.set(featureFlagName, value);
    $37580b6795b12104$export$2a5c8df26bb89760.set(featureFlagName, value);
}

});
parcelRegister("6Qkln", function(module, exports) {
$parcel$export(module.exports, "redactValue", () => $4fb7613eae854254$export$fcc03ee4c944962f);

var $8C4in = parcelRequire("8C4in");

var $frpF5 = parcelRequire("frpF5");
function $4fb7613eae854254$export$fcc03ee4c944962f(featureFlagValue) {
    return (0, $frpF5.shouldRedactValue)(featureFlagValue) ? (0, $8C4in.NON_BOOLEAN_VALUE) : featureFlagValue;
}

});
parcelRegister("8C4in", function(module, exports) {
$parcel$export(module.exports, "NON_BOOLEAN_VALUE", () => $6455344a995cea58$export$42f4885608027d0c);
var $6455344a995cea58$export$42f4885608027d0c = 'non_boolean';

});

parcelRegister("frpF5", function(module, exports) {
$parcel$export(module.exports, "shouldRedactValue", () => $02e6aa75c6096373$export$7b4abba432e57989);

var $ekGgq = parcelRequire("ekGgq");
function $02e6aa75c6096373$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch (_unused) {
        return false;
    }
    return false;
}
function $02e6aa75c6096373$var$isObject(value) {
    return value && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && value.constructor === Object;
}
function $02e6aa75c6096373$var$isString(input) {
    var result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (_unused2) {
        // swallow any errors
        result = false;
    }
    return result;
}
function $02e6aa75c6096373$export$7b4abba432e57989(value) {
    return $02e6aa75c6096373$var$isString(value) && $02e6aa75c6096373$var$startsAsObject(value) || $02e6aa75c6096373$var$isObject(value);
}

});



parcelRegister("7mjXs", function(module, exports) {
$parcel$export(module.exports, "editorExperimentsConfig", () => $55ba11b4135b0d6b$export$6cbb856f286b07ef);
/* eslint-disable perfectionist/sort-object-types */ /* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $cfjrj = parcelRequire("cfjrj");

var $cjtlS = parcelRequire("cjtlS");
var $55ba11b4135b0d6b$export$5c897d5297c5b7fd = [
    'platform_editor_blocks',
    'platform_editor_controls',
    'advanced_layouts',
    'single_column_layouts',
    'platform_editor_preview_panel_responsiveness',
    'platform_editor_toolbar_aifc'
];
var $55ba11b4135b0d6b$export$6cbb856f286b07ef = {
    // new format to avoid collisions with other users when updating the file
    // Added 2026-07-18
    cc_maui_remix_button_hover_corridor: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_remix_button_hover_corridor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-24
    platform_editor_layout_column_delete_shortcut_fix: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_delete_shortcut_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-21
    // `isEnabled` is the gating param; the experiment's dynamic config also carries the numeric
    // `shimmerDurationMs` (skeleton) and `highlightDurationMs` (purple highlight) durations, read at
    // runtime via `expVal`.
    platform_editor_agent_be_streaming: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_agent_be_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Editor Platform experiments
    // lwoollard experiments
    // Added 2026-04-21
    cwr_page_tree_auto_finalize: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr_page_tree_auto_finalize'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 02-12-2025
    cc_fix_hydration_ttvc: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_hydration_ttvc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    'editor_a11y__enghealth-46814_fy26': (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y__enghealth-46814_fy26'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19
    'enghealth-53346_fix_redaction_marker_editor': (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            jira: 'enghealth-53346_fix_redaction_marker_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-16
    platform_editor_remove_important_in_render_ext: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_important_in_render_ext'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-06
    confluence_comment_nudgebar_improvement: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_comment_nudgebar_improvement'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_quick_insert_embeds: (0, $cjtlS.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_quick_insert_embeds'
        },
        param: 'cohort',
        values: [
            'control',
            'prioritizeLinkInQIM',
            'prioritizeEmbedInQIM'
        ],
        defaultValue: 'control'
    }),
    confluence_remix_icon_right_side: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_remix_icon_right_side'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_editor_insm_doc_size_stats: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_doc_size_stats'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-26
    cc_editor_fix_insm_inp_buffer: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_fix_insm_inp_buffer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    cwr_blank_object_experiment: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr_blank_object_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-08
    confluence_inline_comments_fix_stale_selection: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_inline_comments_fix_stale_selection'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    rovo_remix_experience_context: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'rovo_remix_experience_context'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-05
    'databases-native-embeds-v2': (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'databases-native-embeds-v2'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    cc_editor_insm_outlier_events: (0, $cjtlS.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_outlier_events'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-17
    platform_editor_renderer_extension_width_fix: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_extension_width_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-24
    platform_editor_media_external_badge_bbc_fix: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_external_badge_bbc_fix',
            bitbucket: 'platform_editor_media_external_badge_bbc_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-20
    platform_editor_annotations_sync_on_docchange: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_annotations_sync_on_docchange'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $cjtlS.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_per_plugin_error_boundary: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_per_plugin_error_boundary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-05
    'company_hub_carousel_thumbnails-refactor': (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'company_hub_carousel_thumbnails-refactor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $cjtlS.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_paste_actions_menu: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-19
    platform_editor_controls_reliable_anchor: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_reliable_anchor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $cjtlS.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls',
            jira: 'platform_editor_controls_jira'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-07-21
    confluence_cwr_3p_connection_suggested_prompts: (0, $cjtlS.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_cwr_3p_connection_suggested_prompts'
        },
        param: 'cohort',
        values: [
            'control',
            'variant_a',
            'variant_b'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-05-26
    platform_editor_agent_mentions: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_agent_mentions',
            jira: 'platform_editor_agent_mentions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    platform_editor_reduced_agent_profile_cards: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_reduced_agent_profile_cards',
            jira: 'platform_editor_reduced_agent_profile_cards'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-30
    platform_editor_fix_link_paste_menu: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_link_paste_menu',
            jira: 'platform_editor_fix_link_paste_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_code_block_q4_lovability: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_code_block_q4_lovability',
            jira: 'platform_editor_code_block_q4_lovability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-17-03
    platform_editor_media_name_fallback: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_name_fallback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-12
    platform_editor_media_name_fallback_viewer_card: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_name_fallback_viewer_card'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-16
    platform_editor_enable_single_player_step_merging: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enable_single_player_step_merging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_hide_overflow_menu: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_hide_overflow_menu',
            jira: 'platform_editor_toolbar_hide_overflow_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_responsiveness'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $cjtlS.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-06-25
    jira_editor_a11y_toolbar_fixes: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'jira_editor_a11y_toolbar_fixes',
            jira: 'jira_editor_a11y_toolbar_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-09
    platform_editor_blocks: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocks_conf',
            jira: 'platform_editor_blocks_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-23
    //Added 2025-07-16
    platform_editor_toolbar_aifc: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_confluence'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_breakout_interaction_rerender: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_interaction_rerender'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_blocktaskitem_node_tenantid: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_node_tenantid'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_with_dnd: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_with_dnd'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    'editor-a11y-fy26-keyboard-move-row-column': (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor-a11y-fy26-keyboard-move-row-column',
            jira: 'editor-a11y-fy26-keyboard-move-row-column'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-28
    editor_enable_image_alignment_in_expand: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enable_image_alignment_in_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_august_a11y: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_august_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-01
    cc_editor_ai_content_mode: (0, $cjtlS.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_ai_content_mode'
        },
        param: 'variant',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-01-09
    platform_editor_render_bodied_extension_as_inline: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_render_bodied_extension_as_inline'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-03
    platform_editor_ai_quick_prompt_iw_cc: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quick_prompt_iw_cc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_use_llm_space_recommendations: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_llm_space_recommendations'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-01
    // Added 2025-10-13
    platform_editor_media_error_analytics: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_error_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-27
    platform_editor_table_sticky_header_improvements: (0, $cjtlS.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_improvements'
        },
        param: 'cohort',
        values: [
            'control',
            'test_with_overflow',
            'test_without_overflow'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-29
    platform_editor_lovability_inline_code: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_inline_code'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_lovability_emoji_scaling: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_emoji_scaling'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-18
    editor_a11y_7152_profile_card_tab_order: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y_7152_profile_card_tab_order'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-19
    platform_editor_lovability_navigation_fixes: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_navigation_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-27 — Pre-auth unauthorised inline hover card UX
    platform_sl_3p_preauth_better_hovercard: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_preauth_better_hovercard',
            jira: 'platform_sl_3p_preauth_better_hovercard'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-21 — Post-auth GDrive Smart Link to Rovo Chat auto-open
    platform_sl_3p_post_auth_chat_open_exp: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_post_auth_chat_open_exp',
            jira: 'platform_sl_3p_post_auth_chat_open_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-29 — Social proof inline CTA for unauthorised 3P inline smart links
    platform_sl_3p_preauth_social_proof_inline_cta: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_preauth_social_proof_inline_cta',
            jira: 'platform_sl_3p_preauth_social_proof_inline_cta'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15 — Embed card footer rovo action for resolved 3P smart links in confluence
    platform_sl_3p_auth_rovo_embed_footer_exp: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_auth_rovo_embed_footer_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_submenu_open_click: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_submenu_open_click'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-13
    platform_editor_hide_extension_renderer_support: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hide_extension_renderer_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-23
    platform_editor_fix_new_line_after_heading: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_new_line_after_heading',
            jira: 'platform_editor_fix_new_line_after_heading'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-21
    platform_editor_copy_link_a11y_inconsistency_fix: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_copy_link_a11y_inconsistency_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_editor_fix_lagging_embed_resize_handle: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_lagging_embed_resize_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-30
    platform_editor_fix_cross_origin_editor_focus: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_cross_origin_editor_focus'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_ttvc_inline_extensions: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_ttvc_inline_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-03
    platform_editor_enghealth_a11y_jan_fixes: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enghealth_a11y_jan_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    cc_fd_db_top_editor_toolbar: (0, $cjtlS.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_fd_db_top_editor_toolbar'
        },
        param: 'cohort',
        values: [
            'control',
            'new-description',
            'orig-description'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-04-01
    cc_page_experiences_editor_image_generation: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_page_experiences_editor_image_generation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-23
    'cc-maui-experiment': (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-maui-experiment',
            jira: 'jira_maui_remix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_maui_create_keyword: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_create_keyword'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // A/A experiment paired with cc_maui_create_keyword, used only to balance exposures.
    cc_maui_create_keyword_aa: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_create_keyword_aa'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-13
    confluence_native_tabs_experiment: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_native_tabs_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-29
    cc_maui_polish_changes_batch_4: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_polish_changes_batch_4'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    'cc-mui-slides-experiment': (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-mui-slides-experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-27
    confluence_frontend_cwr_outcome_type_picker: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_frontend_cwr_outcome_type_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    cfe_cwr_outcome_picker_respect_site_settings: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'cfe_cwr_outcome_picker_respect_site_settings'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-12
    prompt_tile_content_type_localizaiton: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'prompt_tile_content_type_localizaiton'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-24
    'cwr-modal-ui-refresh': (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-modal-ui-refresh'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-08
    'cc-disambiguation-in-cwr': (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-disambiguation-in-cwr'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    'cwr-reduce-prompt-suggestion-max-chars': (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-reduce-prompt-suggestion-max-chars'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15
    'cwr-staging-area-close-as-minimize-button': (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-staging-area-close-as-minimize-button'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-08
    cc_cwr_prompt_strength_indicator: (0, $cjtlS.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_cwr_prompt_strength_indicator'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1',
            'variant2'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-02-12
    platform_editor_a11y_escape_link_dialog: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_a11y_escape_link_dialog',
            jira: 'platform_editor_a11y_escape_link_dialog'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_vc90_transition_panel_icon: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vc90_transition_panel_icon'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_emoji_default_scale: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_default_scale',
            jira: 'platform_editor_emoji_default_scale'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-17
    platform_editor_emoji_hover_show_tooltip: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_hover_show_tooltip',
            jira: 'platform_editor_emoji_hover_show_tooltip'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    platform_teamoji_26_refresh_emoji_picker: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_teamoji_26_refresh_emoji_picker',
            jira: 'platform_teamoji_26_refresh_emoji_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-16
    platform_use_unicode_emojis: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_unicode_emojis_confluence',
            jira: 'platform_use_unicode_emojis_jira',
            bitbucket: 'platform_use_unicode_emojis_bitbucket'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-26
    platform_editor_toolbar_update_jira_config: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_toolbar_update_jira_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_ai_blockmenu_integration: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_blockmenu_integration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-26
    platform_editor_remix_in_block_menu: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remix_in_block_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19 — fix table text length calculation for Remix/Improve Writing hero prompts
    remix_iw_block_menu_table_calc_fix: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'remix_iw_block_menu_table_calc_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_rovobutton_smartlink_toolbar_exp: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_rovobutton_smartlink_toolbar_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_a11y_scrollable_region: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_a11y_scrollable_region'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    confluence_fe_renderer_inline_node_mark_color_fix: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_renderer_inline_node_mark_color_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_diff_plugin_extended: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_diff_plugin_extended'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_fix_media_toolbar_border_dropdown: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_media_toolbar_border_dropdown'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-06
    platform_editor_single_player_expand: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_player_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_fit_to_content_on_demand: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_fit_to_content_on_demand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-09
    platform_editor_remove_collab_step_metrics: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_collab_step_metrics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    platform_editor_ai_normalized_telemetry: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_normalized_telemetry'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-15
    platform_editor_sync_block_ssr_config: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_sync_block_ssr_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-06
    confluence_fe_create_page_suggestion: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_create_page_suggestion'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-18
    platform_editor_selection_toolbar_block_handle: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_selection_toolbar_block_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    platform_editor_improve_preset_builder_logging: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_improve_preset_builder_logging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-23
    'cc-markdown-mode': (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-markdown-mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_ai_xstate_migration: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_xstate_migration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-31
    platform_editor_dnd_accessibility_fixes_expand: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_dnd_accessibility_fixes_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-15
    platform_editor_ai_no_stream_skip_pacer: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_no_stream_skip_pacer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-07
    platform_editor_layout_column_menu: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-29
    platform_editor_layout_column_selection_fix: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_selection_fix',
            jira: 'platform_editor_layout_column_selection_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15
    platform_editor_layout_column_valign_rendering: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_valign_rendering'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    platform_editor_external_embed_grid_fix: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_external_embed_grid_fix',
            jira: 'platform_editor_external_embed_grid_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-08
    cc_fd_wb_jira_quick_insert_experiment: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            jira: 'cc_fd_wb_jira_quick_insert_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-30
    cc_fix_editor_context_on_cwr_followups: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_editor_context_on_cwr_followups'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    cc_fix_ephemeral_preview_staging_area_registration: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_ephemeral_preview_staging_area_registration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    platform_editor_hydration_skip_react_portal: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hydration_skip_react_portal'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-28
    platform_editor_use_markdown_plus_parser: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_markdown_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_use_html_plus_parser: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_html_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    platform_editor_core_static_css: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_static_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_core_non_ecc_static_css: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_non_ecc_static_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_q4_loveability: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_q4_loveability',
            jira: 'platform_editor_table_q4_loveability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    platform_editor_table_menu_updates: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_menu_updates',
            jira: 'platform_editor_table_menu_updates'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-06
    confluence_live_doc_table_sort_bugfix: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_live_doc_table_sort_bugfix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    confluence_fe_disable_comment_if_offline_fix: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_disable_comment_if_offline_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    platform_editor_sync_block_activation: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_sync_block_activation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_paste_actions_menu_v2: (0, $cjtlS.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu_v2',
            jira: 'platform_editor_paste_actions_menu_v2'
        },
        param: 'variant',
        values: [
            'control',
            'hasSpellingAndGrammar',
            'hasAltAiActions'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-05-01 — Social proof experiment for unauthorized 3P block cards
    social_proof_3p_unauth_block_exp: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'social_proof_3p_unauth_block_exp',
            jira: 'social_proof_3p_unauth_block_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_replace_doc/setup
    platform_editor_ai_replace_doc: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_replace_doc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-18
    platform_editor_nest_table_in_panel: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nest_table_in_panel'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_rovo_support_create_inline_comment: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_rovo_support_create_inline_comment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_fix_sticky_header_malfunction: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_sticky_header_malfunction'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-17
    platform_editor_fix_sticky_header_row: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_sticky_header_row'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-10
    confluence_editor_paste_3p_link_actions_menu: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_paste_3p_link_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-29
    'a11y-fixes-week3-may-2026': (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'a11y-fixes-week3-may-2026',
            jira: 'a11y-fixes-week3-may-2026'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_reactions_selector_list: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_reactions_selector_list',
            jira: 'platform_a11y_fixes_reactions_selector_list'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_emoji_picker_list: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_emoji_picker_list',
            jira: 'platform_a11y_fixes_emoji_picker_list'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_emoji_title_shortname: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_emoji_title_shortname',
            jira: 'platform_a11y_fixes_emoji_title_shortname'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-25
    // HTML+ v2 incremental tool-call streaming contract — gates the new
    // PartialStreamParserV2 / ToolCallProcessorV2 / AdfChunkStrategyV2 stack
    // in `@atlassian/editor-rovo-bridge`, the `replaceValue` orchestrator
    // action, and the `toolCallsStreaming.supportsProvisionalToolCalls`
    // capability advert on `PageContentCommandResult`.
    platform_editor_use_html_plus_streaming_parser: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_html_plus_streaming_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_wide_slash_trigger: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_wide_slash_trigger'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11 — [CCI-15904] New AIFC Editor Experience (Full Page Staging Area + Post Stream Review Toolbar)
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_new_aifc_editor_experience/setup
    platform_editor_ai_new_aifc_editor_experience: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_new_aifc_editor_experience'
        },
        param: 'isBackendReviewMomentEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    // Gates the `GhostIconWave` animation primitive in
    // `@atlassian/rovo-platform-ui-components` — rendered as a loading cue on
    // Confluence's 3p-in-CWR (Rovo) surfaces. When off the primitive renders
    // nothing.
    confluence_3p_in_cwr_ghost_icons: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_3p_in_cwr_ghost_icons'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    platform_editor_lovability_text_bg_color: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_text_bg_color',
            jira: 'platform_editor_lovability_text_bg_color'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-20
    platform_editor_ssr_toolbar_optimistic: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ssr_toolbar_optimistic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19
    platform_editor_lovability_resize_dividers_panels: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_resize_dividers_panels'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_editor_add_breakout_marks_on_page_load: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_breakout_marks_on_page_load'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-23
    'aifc-confluence-editor-csp-fix': (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'aifc-confluence-editor-csp-fix',
            jira: 'aifc-confluence-editor-csp-fix'
        },
        param: 'value',
        defaultValue: false
    }),
    // Added 2026-07-02
    platform_editor_media_download_fallback_name: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_download_fallback_name'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-01
    platform_editor_remove_pause_streaming: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_pause_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-17
    revert_remix_ephemeral_iframe_sizing_fix: (0, $cfjrj.createBooleanExperiment)({
        productKeys: {
            confluence: 'revert_remix_ephemeral_iframe_sizing_fix',
            jira: 'revert_remix_ephemeral_iframe_sizing_fix'
        },
        param: 'value',
        defaultValue: false
    }),
    // Added 2026-07-28
    cwr_publish_flow_live_doc_toggle_exp: (0, $cjtlS.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cwr_publish_flow_live_doc_toggle_exp'
        },
        param: 'cohort',
        defaultValue: 'control',
        values: [
            'control',
            'variantA',
            'variantB',
            'variantC'
        ]
    })
};

});
parcelRegister("cfjrj", function(module, exports) {
$parcel$export(module.exports, "createBooleanExperiment", () => $8ea5f705173a5a1d$export$456f1587c9c92021);

var $25nEq = parcelRequire("25nEq");

var $dlfwe = parcelRequire("dlfwe");
function $8ea5f705173a5a1d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8ea5f705173a5a1d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8ea5f705173a5a1d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8ea5f705173a5a1d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8ea5f705173a5a1d$export$456f1587c9c92021(config) {
    return $8ea5f705173a5a1d$var$_objectSpread($8ea5f705173a5a1d$var$_objectSpread({}, config), {}, {
        typeGuard: (0, $dlfwe.isBoolean),
        defaultValue: config.defaultValue
    });
}

});
parcelRegister("dlfwe", function(module, exports) {
$parcel$export(module.exports, "isBoolean", () => $9b69463d41d5e4f0$export$f9ce7b637dfbe238);
function $9b69463d41d5e4f0$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}

});


parcelRegister("cjtlS", function(module, exports) {
$parcel$export(module.exports, "createMultivariateExperiment", () => $8f6e0712e3468c65$export$fb89e8a786694d1);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $bhz7T = parcelRequire("bhz7T");
function $8f6e0712e3468c65$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8f6e0712e3468c65$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8f6e0712e3468c65$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8f6e0712e3468c65$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8f6e0712e3468c65$export$fb89e8a786694d1(config) {
    var values = config.values;
    return $8f6e0712e3468c65$var$_objectSpread($8f6e0712e3468c65$var$_objectSpread({}, config), {}, {
        values: (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(values),
        // Maintains the tuple
        typeGuard: (0, $bhz7T.oneOf)(config.values),
        defaultValue: config.defaultValue
    });
}

});
parcelRegister("bhz7T", function(module, exports) {
$parcel$export(module.exports, "oneOf", () => $836c87941e7f736c$export$a9a18ae5ba42aeab);

var $3ZMUU = parcelRequire("3ZMUU");
var $836c87941e7f736c$var$_process, $836c87941e7f736c$var$_process2;
var $836c87941e7f736c$var$IS_TESTING_ENV = typeof $3ZMUU !== 'undefined' && ((($836c87941e7f736c$var$_process = $3ZMUU) === null || $836c87941e7f736c$var$_process === void 0 || ($836c87941e7f736c$var$_process = $836c87941e7f736c$var$_process.env) === null || $836c87941e7f736c$var$_process === void 0 ? void 0 : $836c87941e7f736c$var$_process.NODE_ENV) === 'test' || (($836c87941e7f736c$var$_process2 = $3ZMUU) === null || $836c87941e7f736c$var$_process2 === void 0 || ($836c87941e7f736c$var$_process2 = $836c87941e7f736c$var$_process2.env) === null || $836c87941e7f736c$var$_process2 === void 0 ? void 0 : $836c87941e7f736c$var$_process2.JEST_WORKER_ID) !== undefined);
function $836c87941e7f736c$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
   * This is used by test utils to get the variants when running describe.each
   */ if ($836c87941e7f736c$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}

});



parcelRegister("dNDkt", function(module, exports) {
$parcel$export(module.exports, "_overrides", () => $a0be5bf42e8ad89c$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_product", () => $a0be5bf42e8ad89c$export$cf7305fc65acbf0d);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $lmc3R = parcelRequire("lmc3R");

var $7mjXs = parcelRequire("7mjXs");
function $a0be5bf42e8ad89c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a0be5bf42e8ad89c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a0be5bf42e8ad89c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a0be5bf42e8ad89c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a0be5bf42e8ad89c$export$e5d73bf4f8e2ae96 = {};
var $a0be5bf42e8ad89c$export$4e849416bb5c5b52 = {};
var $a0be5bf42e8ad89c$export$cf7305fc65acbf0d;
function $a0be5bf42e8ad89c$export$1c2b6dbf79eb3560(product, /**
 * Overrides are used to set the group of an experiment for testing purposes.
 * This is useful when you want to test a specific experiment group.
 */ groupOverrides, /**
 * Param overrides are used to set the experiment parameters for testing purposes.
 * This is useful when you want to tweak the experiment parameters for testing.
 */ paramOverrides, options) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        groupOverrides = Object.entries(groupOverrides).reduce(function(acc, _ref) {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
            var config = (0, $7mjXs.editorExperimentsConfig)[key];
            if (config) acc = $a0be5bf42e8ad89c$var$_objectSpread($a0be5bf42e8ad89c$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, config.typeGuard(value) ? value : config.defaultValue));
            return acc;
        }, {});
        $a0be5bf42e8ad89c$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test' && !(options !== null && options !== void 0 && options.disableTestOverrides)) {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        var testOverrides = Object.fromEntries(Object.entries((0, $7mjXs.editorExperimentsConfig)).map(function(_ref3) {
            var _ref5, _ref6, _groupOverrides, _groupOverrides2;
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), key = _ref4[0], value = _ref4[1];
            var defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                (_ref5 = (_ref6 = (_groupOverrides = (_groupOverrides2 = groupOverrides) === null || _groupOverrides2 === void 0 ? void 0 : _groupOverrides2[key]) !== null && _groupOverrides !== void 0 ? _groupOverrides : (0, $lmc3R.testMultivariateOverrides)[key]) !== null && _ref6 !== void 0 ? _ref6 : (0, $lmc3R.testBooleanOverrides)[key]) !== null && _ref5 !== void 0 ? _ref5 : defaultValue
            ];
        }));
        $a0be5bf42e8ad89c$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $a0be5bf42e8ad89c$export$cf7305fc65acbf0d = product;
    $a0be5bf42e8ad89c$export$4e849416bb5c5b52 = paramOverrides || {};
}

});
parcelRegister("lmc3R", function(module, exports) {
$parcel$export(module.exports, "testMultivariateOverrides", () => $f8c5022fb25f4bd1$export$7e849a84a00ffd1c);
$parcel$export(module.exports, "testBooleanOverrides", () => $f8c5022fb25f4bd1$export$54960937bb713f97);
var $f8c5022fb25f4bd1$export$7e849a84a00ffd1c = {
    cwr_publish_flow_live_doc_toggle_exp: 'control',
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_controls: 'control',
    cc_editor_ai_content_mode: 'control',
    platform_hover_card_preview_panel: 'control',
    cc_editor_insm_outlier_events: 'test',
    platform_editor_table_sticky_header_improvements: 'test_with_overflow',
    cc_fd_db_top_editor_toolbar: 'control',
    platform_editor_paste_actions_menu_v2: 'control',
    confluence_quick_insert_embeds: 'control',
    cc_cwr_prompt_strength_indicator: 'control',
    confluence_cwr_3p_connection_suggested_prompts: 'control'
};
var $f8c5022fb25f4bd1$export$54960937bb713f97 = {
    cc_maui_polish_changes_batch_4: false,
    social_proof_3p_unauth_block_exp: false,
    platform_sl_3p_preauth_better_hovercard: true,
    cwr_blank_object_experiment: false,
    platform_editor_preview_panel_responsiveness: false,
    'enghealth-53346_fix_redaction_marker_editor': false,
    platform_editor_toolbar_aifc: false,
    'test-new-experiments-package': false,
    platform_renderer_table_sticky_scrollbar: false,
    advanced_layouts: false,
    single_column_layouts: false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_editor_tables_table_selector: false,
    platform_renderer_fix_analytics_memo_callback: false,
    'jira-work-sync-desc-comment-summary': false,
    platform_editor_breakout_resizing: false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_enable_single_player_step_merging: false,
    platform_editor_paste_actions_menu: false,
    platform_editor_table_fit_to_content_on_demand: false,
    platform_editor_table_q4_loveability: false,
    platform_editor_table_menu_updates: false,
    'cwr-modal-ui-refresh': false,
    'cc-disambiguation-in-cwr': false,
    'cwr-reduce-prompt-suggestion-max-chars': false,
    'cwr-staging-area-close-as-minimize-button': false,
    prompt_tile_content_type_localizaiton: false,
    // [CCI-15904] New AIFC Editor Experience — read by the inline chat prompt view
    // in `conversation-assistant-chat-prompt-input`. Review moment eligibility is a
    // separate check (`editor-plugin-ai/src/ui/utils/review-moment-enabled.ts`) and
    // does not read this key.
    platform_editor_ai_new_aifc_editor_experience: false,
    cc_page_experiences_editor_image_generation: false,
    platform_use_unicode_emojis: false,
    platform_editor_emoji_hover_show_tooltip: false,
    'aifc-confluence-editor-csp-fix': false
};

});




parcelRegister("fXlyu", function(module, exports) {
$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $b9dd161ee11f453b$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $b9dd161ee11f453b$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_ROVO", () => $b9dd161ee11f453b$export$c36142a78ab570c5);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $b9dd161ee11f453b$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $b9dd161ee11f453b$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $b9dd161ee11f453b$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $b9dd161ee11f453b$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $b9dd161ee11f453b$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $b9dd161ee11f453b$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $b9dd161ee11f453b$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $b9dd161ee11f453b$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $b9dd161ee11f453b$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $b9dd161ee11f453b$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $b9dd161ee11f453b$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $b9dd161ee11f453b$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $b9dd161ee11f453b$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $b9dd161ee11f453b$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $b9dd161ee11f453b$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $b9dd161ee11f453b$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardAction", () => $b9dd161ee11f453b$export$f40b7e0b762b928b);
$parcel$export(module.exports, "CardDisplay", () => $b9dd161ee11f453b$export$6ca4ef8b3dc2c804);
var $b9dd161ee11f453b$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
var $b9dd161ee11f453b$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
var $b9dd161ee11f453b$export$c36142a78ab570c5 = 'https://www.atlassian.com/trust/ai';
var $b9dd161ee11f453b$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
var $b9dd161ee11f453b$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $b9dd161ee11f453b$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $b9dd161ee11f453b$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $b9dd161ee11f453b$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $b9dd161ee11f453b$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $b9dd161ee11f453b$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $b9dd161ee11f453b$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $b9dd161ee11f453b$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $b9dd161ee11f453b$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $b9dd161ee11f453b$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AppliedToComponentsCount"] = "AppliedToComponentsCount";
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["TeamMemberCount"] = "TeamMemberCount";
    ElementName["Title"] = "Title";
    ElementName["UserAttributes"] = "UserAttributes";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    ElementName["HostName"] = "HostName";
    return ElementName;
}({});
var $b9dd161ee11f453b$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    ActionName["RovoChatAction"] = "RovoChatAction";
    return ActionName;
}({});
var $b9dd161ee11f453b$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["UnresolvedAction"] = "UnresolvedAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $b9dd161ee11f453b$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["Component"] = "Badge:Component";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $b9dd161ee11f453b$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $b9dd161ee11f453b$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $b9dd161ee11f453b$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["RovoChatAction"] = "RovoChatAction";
    CardAction["ViewAction"] = "ViewAction";
    return CardAction;
}({});
var $b9dd161ee11f453b$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});

});

parcelRegister("kCC2S", function(module, exports) {
$parcel$export(module.exports, "getIsRovoChatEnabled", () => $f034de4240b91143$export$e9a534e68169723d);
var $f034de4240b91143$export$e9a534e68169723d = function getIsRovoChatEnabled(rovoConfig) {
    return rovoConfig !== null && rovoConfig !== void 0 && rovoConfig.isRovoEnabled && rovoConfig !== null && rovoConfig !== void 0 && rovoConfig.isRovoLLMEnabled ? true : false;
};

});

parcelRegister("aRJoq", function(module, exports) {
$parcel$export(module.exports, "startUfoExperience", () => $7e9210b115612e6f$export$5e9287b6a10f8075);

var $hZBUK = parcelRequire("hZBUK");
var $7e9210b115612e6f$export$5e9287b6a10f8075 = function startUfoExperience(experienceName, id, properties) {
    var experience = (0, $hZBUK.ufoExperiences)[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};

});
parcelRegister("hZBUK", function(module, exports) {
$parcel$export(module.exports, "ufoExperiences", () => $d1958b2a2ecd12fe$export$615f888019c45765);

var $ePkZi = parcelRequire("ePkZi");

var $7oc2l = parcelRequire("7oc2l");
var $d1958b2a2ecd12fe$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $7oc2l.ExperienceTypes).Experience,
    performanceType: (0, $7oc2l.ExperiencePerformanceTypes).InlineResult
};
var $d1958b2a2ecd12fe$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $7oc2l.ExperienceTypes).Load,
    performanceType: (0, $7oc2l.ExperiencePerformanceTypes).PageSegmentLoad
};
var $d1958b2a2ecd12fe$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $7oc2l.ExperienceTypes).Experience,
    performanceType: (0, $7oc2l.ExperiencePerformanceTypes).InlineResult
};
var $d1958b2a2ecd12fe$export$615f888019c45765 = {
    'smart-link-rendered': new (0, $ePkZi.ConcurrentExperience)('smart-link-rendered', $d1958b2a2ecd12fe$var$renderExperience),
    'smart-link-authenticated': new (0, $ePkZi.ConcurrentExperience)('smart-link-authenticated', $d1958b2a2ecd12fe$var$inlineExperience),
    'smart-link-action-invocation': new (0, $ePkZi.ConcurrentExperience)('smart-link-action-invocation', $d1958b2a2ecd12fe$var$inlineExperience),
    'smart-link-ai-summary': new (0, $ePkZi.ConcurrentExperience)('smart-link-ai-summary', $d1958b2a2ecd12fe$var$aiExperience)
};

});
parcelRegister("ePkZi", function(module, exports) {
$parcel$export(module.exports, "ConcurrentExperience", () => $acb61bceefbcd0f9$export$ac1cddfee07ba6ac);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $j4euC = parcelRequire("j4euC");

var $az5Jp = parcelRequire("az5Jp");
var $acb61bceefbcd0f9$export$ac1cddfee07ba6ac = /*#__PURE__*/ function() {
    function ConcurrentExperience(experienceId, config) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ConcurrentExperience);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "instances", {});
        this.experienceId = experienceId;
        this.config = config;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ConcurrentExperience, [
        {
            key: "getInstance",
            value: function getInstance(instanceId) {
                if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $az5Jp.UFOExperience)(this.experienceId, this.config, instanceId);
                return this.instances[instanceId];
            }
        },
        {
            key: "release",
            value: function release(instanceId) {
                (0, $j4euC.ufolog)('instanceId', instanceId);
                if (this.instances[instanceId]) this.instances[instanceId].abort();
                delete this.instances[instanceId];
            }
        }
    ]);
}();

});
parcelRegister("j4euC", function(module, exports) {
$parcel$export(module.exports, "ufolog", () => $de19a202b0063319$export$b4958caff08a0960);

var $j0gDF = parcelRequire("j0gDF");
var $de19a202b0063319$export$b4958caff08a0960 = function ufolog() {
    (0, $j0gDF.ufologger).log.apply((0, $j0gDF.ufologger), arguments);
};

});
parcelRegister("j0gDF", function(module, exports) {
$parcel$export(module.exports, "ufologger", () => $dd5aec83d86d7a81$export$4ab84f6f04f6566d);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");


var $dd5aec83d86d7a81$var$UFOLogger = /*#__PURE__*/ function() {
    function UFOLogger() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UFOLogger);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "enabled", false);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UFOLogger, [
        {
            key: "log",
            value: function log() {
                var _console;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // eslint-disable-next-line no-console
                this.enabled && (_console = console).log.apply(_console, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "warn",
            value: function warn() {
                var _console2;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                // eslint-disable-next-line no-console
                this.enabled && (_console2 = console).warn.apply(_console2, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.enabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.enabled = false;
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($dd5aec83d86d7a81$var$UFOLogger, "UFOprefix", "[ufo\uD83D\uDEF8]");
var $dd5aec83d86d7a81$export$4ab84f6f04f6566d = new $dd5aec83d86d7a81$var$UFOLogger();

});


parcelRegister("az5Jp", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", () => $7b119e62d9cbd3cc$export$c00d22927c60484a);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $fV4BZ = parcelRequire("fV4BZ");
function $7b119e62d9cbd3cc$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $7b119e62d9cbd3cc$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $7b119e62d9cbd3cc$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7b119e62d9cbd3cc$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $7b119e62d9cbd3cc$export$c00d22927c60484a = /*#__PURE__*/ function(_UFOAbstractExperienc) {
    function UFOExperience() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UFOExperience);
        return $7b119e62d9cbd3cc$var$_callSuper(this, UFOExperience, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UFOExperience, _UFOAbstractExperienc);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UFOExperience);
}((0, $fV4BZ.UFOAbstractExperience));

});
parcelRegister("fV4BZ", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", () => $b96fc1ad375d30cd$export$d31c89db257648c);

var $fC8ib = parcelRequire("fC8ib");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $6JfQX = parcelRequire("6JfQX");

var $2OcC1 = parcelRequire("2OcC1");

var $dGcLp = parcelRequire("dGcLp");

var $7jLCQ = parcelRequire("7jLCQ");

var $3jtNd = parcelRequire("3jtNd");

var $i91aS = parcelRequire("i91aS");

var $j4euC = parcelRequire("j4euC");

var $7i7hv = parcelRequire("7i7hv");

var $6IS0q = parcelRequire("6IS0q");

var $ffOwq = parcelRequire("ffOwq");

var $dH2EV = parcelRequire("dH2EV");

var $2ILCQ = parcelRequire("2ILCQ");

var $72rFx = parcelRequire("72rFx");

var $7oc2l = parcelRequire("7oc2l");

var $fM0Tx = parcelRequire("fM0Tx");
function $b96fc1ad375d30cd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b96fc1ad375d30cd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b96fc1ad375d30cd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b96fc1ad375d30cd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b96fc1ad375d30cd$var$getPageVisibleState = function getPageVisibleState() {
    return !(0, $dH2EV.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $ffOwq.PageVisibleState).VISIBLE : (0, $ffOwq.PageVisibleState).HIDDEN;
};
var $b96fc1ad375d30cd$export$d31c89db257648c = /*#__PURE__*/ function() {
    function UFOAbstractExperience(id, config) {
        var _this = this;
        var instanceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UFOAbstractExperience);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "state", (0, $2ILCQ.UFOExperienceState).NOT_STARTED);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "instanceId", null);
        // for concurrent
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "parent", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "category", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "metadata", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "onDoneCallbacks", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "childExperiences", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "explicitTimings", {});
        // @todo move to page load experience when proper classes/inheritance prepared
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "isSSROutputAsFMP", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "uuid", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_until", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "metrics", {
            startTime: null,
            endTime: null,
            marks: []
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "performanceConfig", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setPageVisibleStateToMixed", function() {
            _this.pageVisibleState = (0, $ffOwq.PageVisibleState).MIXED;
            (0, $6IS0q.visibilityChangeObserver).unsubscribe(_this.setPageVisibleStateToMixed);
        });
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $b96fc1ad375d30cd$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $7oc2l.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $7oc2l.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UFOAbstractExperience, [
        {
            key: "transition",
            value: function() {
                var _transition = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(newState, timestamp) {
                    var data;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                (0, $j4euC.ufolog)('async transition', this.id, this.state.id, newState.id);
                                if (!(0, $72rFx.canTransition)(this.state, newState)) {
                                    _context.next = 3;
                                    break;
                                }
                                (0, $j4euC.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " successful"), this.state.final, !newState.final);
                                if (newState === (0, $2ILCQ.UFOExperienceState).STARTED) this._reset();
                                if (this.state.final && !newState.final) {
                                    this.metrics.startTime = (0, $fM0Tx.perfNowOrTimestamp)(timestamp);
                                    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                                    this.uuid = (0, $6JfQX.default)();
                                }
                                this.state = newState;
                                if (!newState.final) {
                                    _context.next = 2;
                                    break;
                                }
                                this.metrics.endTime = (0, $fM0Tx.perfNowOrTimestamp)(timestamp);
                                if (!this._isManualStateEnabled()) (0, $7jLCQ.getGlobalEventStream)().push((0, $i91aS.unsubscribeEvent)((0, $ffOwq.SUBSCRIBE_ALL), this.handleDoneBind));
                                _context.next = 1;
                                return this.exportData();
                            case 1:
                                data = _context.sent;
                                (0, $j4euC.ufolog)('this.parent', this.parent);
                                (0, $7jLCQ.getGlobalEventStream)().push((0, $dGcLp.experiencePayloadEvent)(data));
                            case 2:
                                return _context.abrupt("return", true);
                            case 3:
                                (0, $j4euC.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " unsuccessful"));
                                (0, $7i7hv.ufowarn)("transition of ".concat(this.id, " from ").concat(this.state, " to ").concat(newState, " is not possible"));
                                return _context.abrupt("return", false);
                            case 4:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function transition(_x, _x2) {
                    return _transition.apply(this, arguments);
                }
                return transition;
            }()
        },
        {
            key: "start",
            value: function() {
                var _start = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(startTime) {
                    var transitionSuccessful;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 1;
                                return this.transition((0, $2ILCQ.UFOExperienceState).STARTED, startTime);
                            case 1:
                                transitionSuccessful = _context2.sent;
                                if (transitionSuccessful) {
                                    this.pageVisibleState = $b96fc1ad375d30cd$var$getPageVisibleState();
                                    (0, $6IS0q.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                                    if (!this._isManualStateEnabled()) {
                                        (0, $j4euC.ufolog)('subscribed', this.id);
                                        (0, $7jLCQ.getGlobalEventStream)().push((0, $3jtNd.subscribeEvent)((0, $ffOwq.SUBSCRIBE_ALL), this.handleDoneBind));
                                    }
                                }
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function start(_x3) {
                    return _start.apply(this, arguments);
                }
                return start;
            }()
        },
        {
            key: "mark",
            value: function mark(name, timestamp) {
                if (name !== (0, $ffOwq.FMP_MARK) && name !== (0, $ffOwq.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
                else (0, $7i7hv.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
            }
        },
        {
            key: "_mark",
            value: function _mark(name, timestamp) {
                this.metrics.marks.push({
                    name: name,
                    time: (0, $fM0Tx.perfNowOrTimestamp)(timestamp)
                });
                this.transition((0, $2ILCQ.UFOExperienceState).IN_PROGRESS);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                this._mark((0, $ffOwq.FMP_MARK), timestamp);
            }
        },
        {
            key: "markInlineResponse",
            value: function markInlineResponse(timestamp) {
                this._mark((0, $ffOwq.INLINE_RESPONSE_MARK), timestamp);
            }
        },
        {
            key: "_isManualStateEnabled",
            value: function _isManualStateEnabled() {
                return this.until === null;
            }
        },
        {
            key: "_validateManualState",
            value: function _validateManualState() {
                if (!this._isManualStateEnabled()) {
                    (0, $7i7hv.ufowarn)('manual change of state not allowed as "until" is defined');
                    return false;
                }
                return true;
            }
        },
        {
            key: "switchToEndState",
            value: function switchToEndState(state, config) {
                if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
                if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
                (0, $6IS0q.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
                return this.transition(state);
            }
        },
        {
            key: "success",
            value: function() {
                var _success = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", this.switchToEndState((0, $2ILCQ.UFOExperienceState).SUCCEEDED, config));
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function success(_x4) {
                    return _success.apply(this, arguments);
                }
                return success;
            }()
        },
        {
            key: "failure",
            value: function() {
                var _failure = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                return _context4.abrupt("return", this.switchToEndState((0, $2ILCQ.UFOExperienceState).FAILED, config));
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function failure(_x5) {
                    return _failure.apply(this, arguments);
                }
                return failure;
            }()
        },
        {
            key: "abort",
            value: function() {
                var _abort = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                return _context5.abrupt("return", this.switchToEndState((0, $2ILCQ.UFOExperienceState).ABORTED, config));
                            case 1:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function abort(_x6) {
                    return _abort.apply(this, arguments);
                }
                return abort;
            }()
        },
        {
            key: "addMetadata",
            value: function addMetadata(data) {
                Object.assign(this.metadata, data);
            }
        },
        {
            key: "_handleDoneExperience",
            value: function _handleDoneExperience(data) {
                (0, $j4euC.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
                if (data.state.final) {
                    if (this._until !== null) {
                        var _this$_until = this._until(data), done = _this$_until.done, state = _this$_until.state;
                        if (done && !this.state.final) this.transition(state);
                    }
                }
            }
        },
        {
            key: "getId",
            value: function() {
                var _getId = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                return _context6.abrupt("return", this.id);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function getId() {
                    return _getId.apply(this, arguments);
                }
                return getId;
            }()
        },
        {
            key: "exportData",
            value: function() {
                var _exportData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7() {
                    var _t, _t2, _t3, _t4, _t5, _t6, _t7, _t8, _t9, _t0, _t1, _t10, _t11, _t12, _t13, _t14, _t15, _t16;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                _context7.next = 1;
                                return this.getId();
                            case 1:
                                _t = _context7.sent;
                                _t2 = this.uuid;
                                _t3 = this.type;
                                _t4 = (0, $2OcC1.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown';
                                _t5 = this.performanceType;
                                _t6 = this.category;
                                _t7 = this.state;
                                _t8 = $b96fc1ad375d30cd$var$_objectSpread({}, this.metadata);
                                _t9 = $b96fc1ad375d30cd$var$_objectSpread({}, this.metrics);
                                _t0 = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(this.childExperiences);
                                _t1 = {
                                    success: !!this.state.success,
                                    startTime: this.metrics.startTime,
                                    duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
                                };
                                _t10 = this.config.platform || null;
                                _t11 = this.pageVisibleState;
                                _t12 = this.featureFlags;
                                _t13 = this.isSSROutputAsFMP;
                                _t14 = this.timings;
                                _t15 = this.explicitTimings;
                                _t16 = this.performanceConfig;
                                return _context7.abrupt("return", {
                                    id: _t,
                                    uuid: _t2,
                                    type: _t3,
                                    schemaVersion: _t4,
                                    performanceType: _t5,
                                    category: _t6,
                                    state: _t7,
                                    metadata: _t8,
                                    metrics: _t9,
                                    children: _t0,
                                    result: _t1,
                                    platform: _t10,
                                    pageVisibleState: _t11,
                                    featureFlags: _t12,
                                    isSSROutputAsFMP: _t13,
                                    timings: _t14,
                                    explicitTimings: _t15,
                                    performanceConfig: _t16
                                });
                            case 2:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function exportData() {
                    return _exportData.apply(this, arguments);
                }
                return exportData;
            }()
        },
        {
            key: "_reset",
            value: function _reset() {
                this.parent = null;
                this.metadata = {};
                this.onDoneCallbacks = [];
                this.childExperiences = [];
                this.metrics = {
                    startTime: null,
                    endTime: null,
                    marks: []
                };
                this._until = this.until ? this.until() : null;
            }
        }
    ]);
}();

});
parcelRegister("2OcC1", function(module, exports) {
$parcel$export(module.exports, "UFO_EXPERIMENTAL_BUILD_VERSION", () => $20ba08d2c46ac4bd$export$2295b861f318254a);
// temp solution until we can get it automated
var $20ba08d2c46ac4bd$export$2295b861f318254a = '0.1.5';

});

parcelRegister("dGcLp", function(module, exports) {
$parcel$export(module.exports, "experiencePayloadEvent", () => $9f59193a07e3e974$export$7c957416596ca127);

var $ffOwq = parcelRequire("ffOwq");
var $9f59193a07e3e974$export$7c957416596ca127 = function experiencePayloadEvent(data) {
    return {
        type: (0, $ffOwq.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("ffOwq", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $b1af725e2539f6a3$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $b1af725e2539f6a3$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $b1af725e2539f6a3$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $b1af725e2539f6a3$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $b1af725e2539f6a3$export$837e0f79a8056912);
var $b1af725e2539f6a3$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $b1af725e2539f6a3$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $b1af725e2539f6a3$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $b1af725e2539f6a3$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $b1af725e2539f6a3$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $b1af725e2539f6a3$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
var $b1af725e2539f6a3$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
var $b1af725e2539f6a3$export$9f2bf58999404c75 = 'fmp';
var $b1af725e2539f6a3$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("7jLCQ", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", () => $553f403183399f59$export$6123a44dc2384540);

var $gNMzv = parcelRequire("gNMzv");
var $553f403183399f59$export$6123a44dc2384540 = function getGlobalEventStream() {
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        var earlyStream = function() {
            var stream = [];
            return {
                __buffer_only__: true,
                push: function push(event) {
                    if (stream.length < (0, $gNMzv.MAX_EARLY_QUEUE_LENGTH)) stream.push(event);
                },
                getStream: function getStream() {
                    return stream;
                }
            };
        }();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};

});
parcelRegister("gNMzv", function(module, exports) {
$parcel$export(module.exports, "MAX_EARLY_QUEUE_LENGTH", () => $c3b6e6426966f763$export$d8b468db8a225bc9);





var $c3b6e6426966f763$export$d8b468db8a225bc9 = 250;

});


parcelRegister("3jtNd", function(module, exports) {
$parcel$export(module.exports, "subscribeEvent", () => $269a41a9a393160a$export$37863216db4b714d);

var $ffOwq = parcelRequire("ffOwq");
var $269a41a9a393160a$export$37863216db4b714d = function subscribeEvent(experienceId, callback) {
    return {
        type: (0, $ffOwq.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};

});

parcelRegister("i91aS", function(module, exports) {
$parcel$export(module.exports, "unsubscribeEvent", () => $d359fa7cec55dc3f$export$ee1a7bd1fc9ea85e);

var $ffOwq = parcelRequire("ffOwq");
var $d359fa7cec55dc3f$export$ee1a7bd1fc9ea85e = function unsubscribeEvent(experienceId, callback) {
    return {
        type: (0, $ffOwq.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};

});

parcelRegister("7i7hv", function(module, exports) {
$parcel$export(module.exports, "ufowarn", () => $54efdcc0dbf02945$export$d53d07b6034c4560);

var $j0gDF = parcelRequire("j0gDF");
var $54efdcc0dbf02945$export$d53d07b6034c4560 = function ufowarn() {
    (0, $j0gDF.ufologger).warn.apply((0, $j0gDF.ufologger), arguments);
};

});

parcelRegister("6IS0q", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $4e50be9490615645$export$13e680397ec8f3eb);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $dH2EV = parcelRequire("dH2EV");
var $4e50be9490615645$var$VisibilityChangeObserver = /*#__PURE__*/ function() {
    function VisibilityChangeObserver() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, VisibilityChangeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "started", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "observers", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "broadcast", function() {
            _this.observers.forEach(function(fn) {
                return fn();
            });
            _this.observers = [];
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(VisibilityChangeObserver, [
        {
            key: "start",
            value: function start() {
                if (this.started) return;
                this.started = true;
                document.addEventListener('visibilitychange', this.broadcast);
                /**
       * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
       * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
       * so for that case, you need to also include code to listen for the pagehide event.
       */ if ((0, $dH2EV.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                this.observers.push(callback);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(callback) {
                this.observers = this.observers.filter(function(fn) {
                    return fn !== callback;
                });
            }
        }
    ]);
}();
var $4e50be9490615645$export$13e680397ec8f3eb = new $4e50be9490615645$var$VisibilityChangeObserver();

});
parcelRegister("dH2EV", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", () => $9f815a8f6872b689$export$15e172712955e18f);
var $9f815a8f6872b689$export$15e172712955e18f = function isWindowObjectAvailable() {
    return typeof window !== 'undefined';
};

});


parcelRegister("2ILCQ", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", () => $1fb4a23f63bb5dbb$export$81b70111112841a0);
var $1fb4a23f63bb5dbb$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("72rFx", function(module, exports) {
$parcel$export(module.exports, "canTransition", () => $51fe2ed02dd10b73$export$178881f329fdb81f);

var $25nEq = parcelRequire("25nEq");

var $2ILCQ = parcelRequire("2ILCQ");
var $51fe2ed02dd10b73$var$UFOStateAvailableTransitions = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $2ILCQ.UFOExperienceState).NOT_STARTED.id, [
    (0, $2ILCQ.UFOExperienceState).STARTED.id
]), (0, $2ILCQ.UFOExperienceState).STARTED.id, [
    (0, $2ILCQ.UFOExperienceState).IN_PROGRESS.id,
    (0, $2ILCQ.UFOExperienceState).BLOCKED.id,
    (0, $2ILCQ.UFOExperienceState).SUCCEEDED.id,
    (0, $2ILCQ.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $2ILCQ.UFOExperienceState).FAILED.id,
    (0, $2ILCQ.UFOExperienceState).ABORTED.id
]), (0, $2ILCQ.UFOExperienceState).IN_PROGRESS.id, [
    (0, $2ILCQ.UFOExperienceState).BLOCKED.id,
    (0, $2ILCQ.UFOExperienceState).SUCCEEDED.id,
    (0, $2ILCQ.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $2ILCQ.UFOExperienceState).FAILED.id,
    (0, $2ILCQ.UFOExperienceState).ABORTED.id
]), (0, $2ILCQ.UFOExperienceState).BLOCKED.id, [
    (0, $2ILCQ.UFOExperienceState).RECOVERED.id,
    (0, $2ILCQ.UFOExperienceState).ABORTED.id
]), (0, $2ILCQ.UFOExperienceState).RECOVERED.id, [
    (0, $2ILCQ.UFOExperienceState).STARTED.id,
    (0, $2ILCQ.UFOExperienceState).SUCCEEDED.id,
    (0, $2ILCQ.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $2ILCQ.UFOExperienceState).FAILED.id,
    (0, $2ILCQ.UFOExperienceState).ABORTED.id
]), (0, $2ILCQ.UFOExperienceState).SUCCEEDED.id, [
    (0, $2ILCQ.UFOExperienceState).STARTED.id
]), (0, $2ILCQ.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id, [
    (0, $2ILCQ.UFOExperienceState).SUCCEEDED.id,
    (0, $2ILCQ.UFOExperienceState).FAILED.id,
    (0, $2ILCQ.UFOExperienceState).ABORTED.id
]), (0, $2ILCQ.UFOExperienceState).FAILED.id, [
    (0, $2ILCQ.UFOExperienceState).STARTED.id
]), (0, $2ILCQ.UFOExperienceState).ABORTED.id, [
    (0, $2ILCQ.UFOExperienceState).STARTED.id
]);
var $51fe2ed02dd10b73$export$178881f329fdb81f = function canTransition(state1, state2) {
    return $51fe2ed02dd10b73$var$UFOStateAvailableTransitions[state1.id] && $51fe2ed02dd10b73$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("7oc2l", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", () => $56141c8ae654000f$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $56141c8ae654000f$export$cc26007c03242fff);
var $56141c8ae654000f$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $56141c8ae654000f$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("fM0Tx", function(module, exports) {
$parcel$export(module.exports, "perfNowOrTimestamp", () => $b7bc086190255ce1$export$c753e8669d30c8ad);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $h1jVk = parcelRequire("h1jVk");
var $b7bc086190255ce1$export$c753e8669d30c8ad = function perfNowOrTimestamp(timestamp) {
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $h1jVk.roundPerfNow)();
};

});
parcelRegister("h1jVk", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", () => $c641fc19a363bf9f$export$5f490af6b2b115cf);
var $c641fc19a363bf9f$export$5f490af6b2b115cf = function roundPerfNow() {
    return ~~performance.now();
};

});







parcelRegister("2fxyA", function(module, exports) {
$parcel$export(module.exports, "getByDefinitionId", () => $1a370329d645eb29$export$f75b0b690ab4dfb9);
var $1a370329d645eb29$export$f75b0b690ab4dfb9 = function getByDefinitionId(definitionId, store) {
    var urls = Object.keys(store);
    return urls.filter(function(url) {
        var details = store[url].details;
        return details && details.meta.definitionId === definitionId;
    });
};

});

parcelRegister("gfaWa", function(module, exports) {
$parcel$export(module.exports, "getDefinitionId", () => $bd3687f0b592103e$export$46fa3e7718c82e41);
var $bd3687f0b592103e$export$46fa3e7718c82e41 = function getDefinitionId(details) {
    var _details$meta;
    return details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.definitionId;
};

});

parcelRegister("asPvc", function(module, exports) {
$parcel$export(module.exports, "getExtensionKey", () => $79e4782c4223c49b$export$218d96312e385949);
var $79e4782c4223c49b$export$218d96312e385949 = function getExtensionKey(details) {
    var _details$meta;
    return details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.key;
};

});

parcelRegister("eih7r", function(module, exports) {
$parcel$export(module.exports, "getServices", () => $a68006a239ced43e$export$a009e3a1163d46fb);
var $a68006a239ced43e$export$a009e3a1163d46fb = function getServices(details) {
    return details && details.meta.auth || [];
};

});

parcelRegister("cSxNG", function(module, exports) {
$parcel$export(module.exports, "default", () => $9604bf3ea68f300c$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $hrVKU = parcelRequire("hrVKU");

var $aSVEw = parcelRequire("aSVEw");

var $hanqH = parcelRequire("hanqH");

var $bOkxB = parcelRequire("bOkxB");
var $9604bf3ea68f300c$var$_excluded = [
    "provider"
];
function $9604bf3ea68f300c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9604bf3ea68f300c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9604bf3ea68f300c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9604bf3ea68f300c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9604bf3ea68f300c$var$FLAG_ICON_SIZE = '16px';
var $9604bf3ea68f300c$var$renderIcon = function renderIcon(iconUrlOrElement) {
    if (!iconUrlOrElement) return;
    var icon = iconUrlOrElement && typeof iconUrlOrElement === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $hanqH.default), {
        height: $9604bf3ea68f300c$var$FLAG_ICON_SIZE,
        testId: "sl-flag",
        url: iconUrlOrElement,
        width: $9604bf3ea68f300c$var$FLAG_ICON_SIZE
    }) : iconUrlOrElement;
    return icon;
};
// Safe wrapper — returns null if IntlProvider is not in the tree
var $9604bf3ea68f300c$var$useIntlSafe = function useIntlSafe() {
    try {
        return (0, $hrVKU.default)();
    } catch (_unused) {
        return null;
    }
};
var $9604bf3ea68f300c$var$useActionFlags = function useActionFlags() {
    var intl = $9604bf3ea68f300c$var$useIntlSafe();
    var showConnectFlag = (0, $5FkrB.useCallback)(function() {
        var _provider$text;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var provider = _ref.provider, flagArgs = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $9604bf3ea68f300c$var$_excluded);
        if (!intl) return;
        var context = (_provider$text = provider === null || provider === void 0 ? void 0 : provider.text) !== null && _provider$text !== void 0 ? _provider$text : intl.formatMessage((0, $aSVEw.messages).connect_link_account_success_flag_title_default);
        (0, $bOkxB.showFlag)($9604bf3ea68f300c$var$_objectSpread({
            icon: $9604bf3ea68f300c$var$renderIcon(provider === null || provider === void 0 ? void 0 : provider.icon),
            title: intl.formatMessage((0, $aSVEw.messages).connect_link_account_success_flag_title, {
                context: context
            }),
            description: intl.formatMessage((0, $aSVEw.messages).connect_link_account_success_flag_description)
        }, flagArgs));
    }, [
        intl
    ]);
    return (0, $5FkrB.useMemo)(function() {
        return {
            showConnectFlag: showConnectFlag
        };
    }, [
        showConnectFlag
    ]);
};
var $9604bf3ea68f300c$export$2e2bcd8739ae039 = $9604bf3ea68f300c$var$useActionFlags;

});
parcelRegister("aSVEw", function(module, exports) {
$parcel$export(module.exports, "messages", () => $7ecbab23daaa9fc5$export$defe85febe8b728c);

var $6bnW7 = parcelRequire("6bnW7");
var $7ecbab23daaa9fc5$export$defe85febe8b728c = (0, $6bnW7.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: 'Title for a section or menu containing available actions for a resource.'
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Button label that allows the user to add and connect a new external account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summary_error_generic_rebrand: {
        id: 'fabric.linking.ai_summary_error_generic_rebrand',
        defaultMessage: "Rovo isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    change_status: {
        id: 'fabric.linking.change_status',
        defaultMessage: 'Change status: {status}',
        description: 'Aria label for the button to change the status of a linked resource.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'Cancel the current action or close the modal.'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Text shown in a lozenge badge on a smart link or card to indicate the feature is currently in beta.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: 'Label for a button or icon that closes the currently open modal dialog or overlay screen.'
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Heading shown at the top of the link safety warning modal, prompting the user to verify a potentially unsafe link before proceeding.'
    },
    compass_applied_components_count: {
        id: 'compass.applied_components_count.non-final',
        defaultMessage: 'Applied to {numberOfComponents, plural, one {{numberOfComponents, number} component}  other {{numberOfComponents, number} components}}',
        description: 'Indicates the number of components the resource is applied to.'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_link_account_embed_carousel_dot_label: {
        id: 'fabric.linking.connect_link_account_embed_carousel_dot_label.non-final',
        defaultMessage: 'Go to slide {index} of {total}',
        description: 'Accessible label for a dot indicator button in the teaser carousel, describing which slide it navigates to'
    },
    connect_link_account_embed_carousel_dot_row_label: {
        id: 'fabric.linking.connect_link_account_embed_carousel_dot_row_label.non-final',
        defaultMessage: 'Slides',
        description: 'Accessible label for the group of dot indicator buttons in the teaser carousel'
    },
    connect_link_account_embed_carousel_button_next: {
        id: 'fabric.linking.connect_link_account_embed_carousel_button_next.non-final',
        defaultMessage: 'Next',
        description: 'A button to view next teaser on benefit of connecting account on Smart Link embed'
    },
    connect_link_account_embed_carousel_sl_description: {
        id: 'fabric.linking.connect_link_account_embed_carousel_sl_description.non-final',
        defaultMessage: "Embed live previews of {context, select,\n\t\t\t\tGoogle {Google Docs, Sheets, and Slides}\n\t\t\t\tother {{context}}} {product, select,\n\t\t\t\tBITBUCKET {right inside Bitbucket}\n\t\t\t\tCONFLUENCE {right inside Confluence and Jira}\n\t\t\t\tJIRA {right inside Confluence and Jira}\n\t\t\t\tTRELLO {right inside Trello}\n\t\t\t\tother {across Atlassian}}.",
        description: "A description on a teaser slide 1 on benefit of connecting account on Smart Link embed. Example Google+CONFLUENCE: Embed live previews of Google Docs, Sheets, and Slides right inside Confluence and Jira. Example Google+TRELLO: Embed live previews of Google Docs, Sheets, and Slides right inside Trello. Example other+TRELLO: Embed live previews of Figma right inside Trello. Example other+other: Embed live previews of Figma across Atlassian."
    },
    connect_link_account_embed_carousel_sl_title: {
        id: 'fabric.linking.connect_link_account_embed_carousel_sl_title.non-final',
        defaultMessage: 'Turn smart links into rich previews',
        description: 'A title on a teaser slide 1 on benefit of connecting account on Smart Link embed'
    },
    connect_link_account_embed_carousel_rovo_title: {
        id: 'fabric.linking.connect_link_account_embed_carousel_rovo_title.non-final',
        defaultMessage: 'Find everything in one search',
        description: 'A title on a teaser slide 2 on benefit of connecting account on Smart Link embed'
    },
    connect_link_account_embed_carousel_rovo_description: {
        id: 'fabric.linking.connect_link_account_embed_carousel_rovo_description.non-final',
        defaultMessage: "Access {context} files alongside your work in {product, select,\n\t\t\t\tBITBUCKET {Bitbucket}\n\t\t\t\tCONFLUENCE {Confluence and Jira}\n\t\t\t\tJIRA {Confluence and Jira}\n\t\t\t\tTRELLO {Trello}\n\t\t\t\tother {Atlassian}}. We'll always respect your {context} permissions.",
        description: "A description on a teaser slide 2 on benefit of connecting account on Smart Link embed. Example Figma+JIRA: Access Figma files alongside your work in Confluence and Jira. We'll always respect your Figma permissions. Example Figma+BITBUCKET: Access Figma files alongside your work in Bitbucket. We'll always respect your Figma permissions. Example Figma+other: Access Figma files alongside your work in Atlassian. We'll always respect your Figma permissions."
    },
    connect_link_account_embed_carousel_rovochat_title: {
        id: 'fabric.linking.connect_link_account_embed_carousel_rovochat_title.non-final',
        defaultMessage: 'Get help from Rovo',
        description: 'A title on a teaser slide 3 on benefit of connecting account on Smart Link embed'
    },
    connect_link_account_embed_carousel_rovochat_description: {
        id: 'fabric.linking.connect_link_account_embed_carousel_rovochat_description.non-final',
        defaultMessage: "Rovo uses your {context} content to answer questions, summarise docs, and draft updates using the work you\u2019ve already done.",
        description: 'A description on a teaser slide 3 on benefit of connecting account on Smart Link embed'
    },
    connect_link_account_success_flag_description: {
        id: 'fabric.linking.connect_link_account_success_flag_description',
        defaultMessage: 'Shared links now display rich previews.',
        description: 'Shown in a flag after user successfully connect 3P account and Smart Link reload with metadata'
    },
    connect_link_account_success_flag_title: {
        id: 'fabric.linking.connect_link_account_success_flag_title',
        defaultMessage: '{context} is connected',
        description: 'Shown in a flag after user successfully connect 3P account. {context} is the name of link provider, e.g. Google, Figma, etc.'
    },
    connect_link_account_success_flag_title_default: {
        id: 'fabric.linking.connect_link_account_success_flag_title_default',
        defaultMessage: 'Smart Link',
        description: 'Default context for connect_link_account_success_flag_title when link provider name (Google, Figma, etc.) is not provided'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_3p_account: {
        id: 'fabric.linking.connect_3p_account.non-final',
        defaultMessage: 'Connect {context}',
        description: 'Shown on a button to connect user external 3P account to their Atlassian account, e.g. Connect Figma'
    },
    connect_inline_social_proof: {
        id: 'fabric.linking.connect_inline_social_proof',
        defaultMessage: 'Connect',
        description: 'Shown on a button for unauthorised inline smart links when the social proof inline CTA experiment is active. Replaces the longer "Connect your {context} account" label.'
    },
    social_proof_inline_cta_tag_high_with_context: {
        id: 'fabric.linking.social_proof_inline_cta_tag_high_with_context',
        defaultMessage: '<b>{connectedPct}%</b> of your team sees {context} previews',
        description: 'Social-proof tag pill beside the shortcut "Connect" on an unauthorised inline smart link when adoption is not in the exploratory range. {connectedPct} is the approximate share seeing previews for the integration; {context} is the provider display name.'
    },
    social_proof_inline_cta_tag_high_no_context: {
        id: 'fabric.linking.social_proof_inline_cta_tag_high_no_context',
        defaultMessage: '<b>{connectedPct}%</b> of your team sees richer previews',
        description: 'Social-proof tag pill when adoption is above the exploratory threshold and no provider display name is available; {connectedPct} is the approximate share seeing richer previews.'
    },
    social_proof_inline_cta_tag_low_with_context: {
        id: 'fabric.linking.social_proof_inline_cta_tag_low_with_context',
        defaultMessage: 'Your team sees richer {context} previews',
        description: 'Social-proof tag pill when share is below the percentage headline threshold; shown only when a provider display name is available. Omit the pill entirely when personalization is unavailable or the provider name is unknown.'
    },
    social_proof_inline_cta_tag_low_no_context: {
        id: 'fabric.linking.social_proof_inline_cta_tag_low_no_context',
        defaultMessage: 'Your team sees richer previews',
        description: 'Social-proof tag pill for the case when neither percentage nor provider display name are available.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'Label for a button that advances the user to the next step, e.g. in the link safety warning modal flow.'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: 'Action to copy the URL of the link to the clipboard.'
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Confirmation text shown briefly after the user copies a URL to the clipboard using the copy link action.'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Label for the delete action in a smart link or card action menu, allowing the user to remove the linked item.'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: 'Label for the download action in a smart link or card action menu, initiating a file download.'
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: "Tooltip or description text for the download action, explaining it saves the file to the user's local storage."
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Label for the download file action in a smart link or card action menu, allowing the user to save the linked file locally.'
    },
    ai_summary_action_rebrand: {
        id: 'fabric.linking.ai_summary_action_rebrand',
        defaultMessage: 'Summarize with Rovo',
        description: 'Label for the AI summarize action in a smart link or hover card action menu, allowing the user to generate an AI summary of the linked content.'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    ai_summary_action_description_rebrand: {
        id: 'fabric.linking.ai_summary_action_description_rebrand',
        defaultMessage: 'Summarize the content of this link using Rovo.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Label for the edit action in a smart link or card action menu, allowing the user to modify the linked item.'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Label for the follow button on a smart link card, allowing the user to subscribe to updates for the linked project or resource.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Tooltip or description text for the follow project button, explaining that clicking it enables notifications for the project.'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Label for the follow project button on a smart link card, allowing the user to subscribe to updates for the linked Atlassian project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Tooltip or description text for the follow goal button, explaining that clicking it enables notifications for updates to the goal.'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Label for the follow goal button on a smart link card, allowing the user to subscribe to updates for the linked Atlas goal.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'Label for a navigation button that returns the user to the previous step or screen in a modal flow.'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Label for the action button on a smart link card that opens the linked Jira issue in Jira.'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Label for the action button on a smart link card that opens the linked resource in a new browser tab.'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    owned_by_override: {
        id: 'fabric.linking.owned_by_override',
        defaultMessage: 'By {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Tooltip or description text for the preview action on a smart link card, explaining it opens a full-screen embed preview of the linked content.'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_modal: {
        id: 'fabric.linking.preview_modal',
        defaultMessage: 'Open preview modal',
        description: 'Button used to view a modal view of your content without needing to navigate to it.'
    },
    preview_panel: {
        id: 'fabric.linking.preview_panel',
        defaultMessage: 'Open preview panel',
        description: 'Button used to view a side panel view of your content without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Label for the button that closes the embed preview modal dialog on a smart link card.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Blocker priority.'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Critical priority.'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has High priority.'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Highest priority.'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Low priority.'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Lowest priority.'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Major priority.'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Medium priority.'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Minor priority.'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Trivial priority.'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Label for a priority badge on a Jira issue smart link card when the priority level is not defined or unknown.'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Text shown on a smart link card displaying the estimated reading time. The placeholder {context} is substituted with the number of minutes.'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Label for a retry button shown on a smart link card after an error, allowing the user to attempt the failed action again.'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: "Label for a save button on a smart link card or action, confirming and persisting the user's changes."
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Label for a button shown on a smart link error state, prompting the user to retry the failed load or action.'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Warning message shown in the link safety modal. The placeholder {unsafeLinkText} is substituted with the suspicious link text, and <a> wraps the actual destination URL.'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    rovo_actions_explore: {
        id: 'fabric.linking.rovo_actions_explore-non-final',
        defaultMessage: 'Explore',
        description: 'Label for the Rovo Actions button that allows users to explore AI actions for a link'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Label for the unfollow button on a smart link card, allowing the user to stop receiving updates for the linked project or resource.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Tooltip or description for the unfollow project button, explaining that clicking it stops project update notifications.'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Label for the unfollow project button on a smart link card, allowing the user to stop following the linked Atlassian project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Tooltip or description for the unfollow goal button, explaining that clicking it stops notifications for the linked Atlas goal.'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Label for the unfollow goal button on a smart link card, allowing the user to stop following the linked Atlas goal.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewInProvider: {
        id: 'fabric.linking.viewinprovider',
        defaultMessage: 'View in {providerName}',
        description: 'We have a link in our preview modals to the original document. This text tells the user where it will open'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'Generic error message shown on a smart link card when an unspecified error occurs and no more specific message is available.'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Related links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls',
        defaultMessage: 'View recent links',
        description: 'Action to view related links to the given resource'
    },
    related_links_view_related_links: {
        id: 'fabric.linking.related_links_view_related_links',
        defaultMessage: 'View related links',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found in',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes links to',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_title: {
        id: 'fabric.linking.related_links_modal_error_title',
        defaultMessage: "We're having trouble loading related links",
        description: 'Heading shown in the related links modal when related links fail to load due to a network or server error.'
    },
    related_links_modal_unavailable_title: {
        id: 'fabric.linking.related_links_modal_unavailable_title',
        defaultMessage: "We couldn't find any related links",
        description: 'Heading shown in the related links modal when no related links are available for the current resource.'
    },
    related_links_modal_error_description: {
        id: 'fabric.linking.related_links_modal_error_description',
        defaultMessage: 'Check your connection or refresh the page to try again',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_description: {
        id: 'fabric.linking.related_links_modal_unavailable_description',
        defaultMessage: 'We continuously review and add related links for updated pages or other content types',
        description: 'Informs the user that there was a problem loading related links'
    },
    join_to_viewIssueTermRefresh: {
        id: 'fabric.linking.join_to_view-issue-term-refresh',
        defaultMessage: 'Join {context} to view this work item',
        description: 'Allows the user join the product or service immediately'
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: 'fabric.linking.open_issue_in_jira-issue-term-refresh',
        defaultMessage: 'Open work item in Jira',
        description: 'Label for the action button on a smart link card that opens the linked Jira work item in Jira (issue term refresh variant).'
    },
    request_access_to_viewIssueTermRefresh: {
        id: 'fabric.linking.request_access_to_view-issue-term-refresh',
        defaultMessage: 'Request access to {context} to view this work item',
        description: 'Allows the user to request access to a product or service'
    },
    status_change_permission_errorIssueTermRefresh: {
        id: 'fabric.linking.status_change_permission_error-issue-term-refresh',
        defaultMessage: "You don\u2019t have permission to transition this work item. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    team_members_count: {
        id: 'fabric.linking.team_members_count',
        defaultMessage: '{context} members',
        description: 'Text shown on a smart link card displaying the number of members in a team. The placeholder {context} is substituted with the member count.'
    },
    user_attributes: {
        id: 'fabric.linking.user_attributes',
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: '{context}',
        description: 'Displays user attributes like role, department, location, and pronouns'
    },
    follow_project_descriptionGalaxia: {
        id: 'fabric.linking.follow_project_description-galaxia',
        defaultMessage: 'Follow to get notifications on this space',
        description: 'Tooltip or description for the follow space button (Galaxia variant), explaining that clicking it enables notifications for the Confluence space.'
    },
    follow_project_errorGalaxia: {
        id: 'fabric.linking.follow_project_error-galaxia',
        defaultMessage: 'We encountered an error while trying to follow the space. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    unfollow_project_descriptionGalaxia: {
        id: 'fabric.linking.unfollow_project_description-galaxia',
        defaultMessage: 'Unfollow to stop receiving space notifications',
        description: 'Tooltip or description for the unfollow space button (Galaxia variant), explaining that clicking it stops notifications for the Confluence space.'
    },
    unfollow_project_errorGalaxia: {
        id: 'fabric.linking.unfollow_project_error-galaxia',
        defaultMessage: 'We encountered an error while trying to unfollow the space. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    connect_unauthorised_account_description_appify: {
        id: 'fabric.linking.connect_unauthorised_account_description-appify',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian apps.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider_appify: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider-appify',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian apps.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    learn_more_about_connecting_account_appify: {
        id: 'fabric.linking.learn_more_about_connecting_account-appify',
        defaultMessage: 'Learn more about connecting your account to Atlassian apps.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    learn_more_about_connecting_account_experiment_shorter: {
        id: 'fabric.linking.learn_more_about_connecting_account_experiment_short',
        defaultMessage: 'Turn your URLs into rich, interactive previews.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    rovo_summary_loading: {
        id: 'fabric.linking.rovo_summary.loading.non-final',
        defaultMessage: 'Rovo is thinking',
        description: 'Shown when a Rovo summary is loading, indicating that the AI is generating a summary for the user.'
    },
    ai_disclaimer: {
        id: 'fabric.linking.rovo_summary.ai_disclaimer.non-final',
        defaultMessage: 'Uses AI. Verify Results.',
        description: 'Shown on a Rovo summary to indicate that the summary was generated by AI and should be verified by the user for accuracy.'
    },
    rovo_unauthorised_title: {
        id: 'fabric.linking.rovo_unauthorised.title',
        defaultMessage: 'Get smarter workflows by connecting your {context} account',
        description: 'Banner headline in Rovo unauthorised hover card header. {context} is the third-party provider name (e.g. Google).'
    },
    rovo_unauthorised_title_no_provider: {
        id: 'fabric.linking.rovo_unauthorised.title_no_provider',
        defaultMessage: 'Get smarter workflows by connecting your account',
        description: 'Banner headline in Rovo unauthorised hover card header when the provider name is unknown.'
    },
    rovo_unauthorised_feature_clear_link_names: {
        id: 'fabric.linking.rovo_unauthorised.feature.clear_link_names',
        defaultMessage: 'Turn long URLs into clear link names',
        description: 'First feature bullet in Rovo unauthorised hover card.'
    },
    rovo_unauthorised_feature_understand_linked_docs: {
        id: 'fabric.linking.rovo_unauthorised.feature.understand_linked_docs',
        defaultMessage: 'Understand linked docs in seconds',
        description: 'Second feature bullet in Rovo unauthorised hover card.'
    },
    rovo_unauthorised_feature_go_deeper_smart_suggestions: {
        id: 'fabric.linking.rovo_unauthorised.feature.go_deeper_smart_suggestions',
        defaultMessage: 'Go deeper with smart suggestions',
        description: 'Third feature bullet in Rovo unauthorised hover card.'
    },
    rovo_unauthorised_connect_account: {
        id: 'fabric.linking.rovo_unauthorised.connect_account',
        defaultMessage: 'Connect',
        description: 'Primary action button in Rovo unauthorised hover card.'
    },
    rovo_unauthorised_not_now: {
        id: 'fabric.linking.rovo_unauthorised.not_now',
        defaultMessage: 'Maybe later',
        description: 'Secondary action in Rovo unauthorised hover card.'
    },
    rovo_prompt_context_generic: {
        id: 'fabric.linking.rovo_prompt_context_confluence_page.non-final',
        defaultMessage: 'page',
        description: 'The location the user see Smart Link in, to be used as the {context} for Rovo prompt message'
    },
    rovo_prompt_context_generic_plural: {
        id: 'fabric.linking.rovo_prompt_context_confluence_page.non-final',
        defaultMessage: 'pages',
        description: 'The site-wide location the user see Smart Link in, to be used as the {context} for Rovo prompt message'
    },
    rovo_prompt_context_confluence_page: {
        id: 'fabric.linking.rovo_prompt_context_confluence_page.non-final',
        defaultMessage: 'Confluence page',
        description: 'The Confluence page the user see Smart Link in, to be used as the {context} for Rovo prompt message'
    },
    rovo_prompt_context_jira_work_item: {
        id: 'fabric.linking.rovo_prompt_context_jira_work_item.non-final',
        defaultMessage: 'Jira work item',
        description: 'The Jira work item the user see Smart Link in, to be used as the {context} for Rovo prompt message'
    },
    rovo_prompt_message_summarize: {
        id: 'fabric.linking.rovo_prompt_message_summarize.non-final',
        defaultMessage: '<p>Summarize the main ideas and key points of <a>{url}</a> in 3-5 clear, complete bullet points (markdown list).</p><p>Preserve important details such as names, dates, and key decisions.</p>',
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_ask_rovo_anything: {
        id: 'fabric.linking.rovo_prompt_button_ask_rovo.non-final',
        defaultMessage: 'Ask Rovo',
        description: 'The name of the action to open Rovo Chat and ask a question in relation to current Smart Link'
    },
    rovo_prompt_message_ask_rovo_anything: {
        id: 'fabric.linking.rovo_prompt_message_ask_rovo_anything.non-final',
        defaultMessage: '`I have a question about this linked item` {url}',
        description: "The placeholder prompt message pre-filled in Rovo Chat input. {url} refers to the Smart Link URL. This is not auto-submitted \u2014 the user types their question."
    },
    rovo_prompt_button_highlight_relevant_content: {
        id: 'fabric.linking.rovo_prompt_button_highlight_relevant_content',
        defaultMessage: "Highlight what's relevant",
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_highlight_relevant_content: {
        id: 'fabric.linking.rovo_prompt_message_highlight_relevant_content',
        defaultMessage: "<p>Based on this linked item (<a>{url}</a>) and the {context} I'm currently viewing, highlight the parts of the linked content that are most relevant to this work. Explain briefly why each part is relevant.</p>",
        description: 'The prompt message to send to Rovo Chat. {context} refers to the content the user triggered from, e.g. Confluence page or Jira work item. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_identify_key_trends: {
        id: 'fabric.linking.rovo_prompt_button_identify_key_trends',
        defaultMessage: "Identify key trends",
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_identify_key_trends: {
        id: 'fabric.linking.rovo_prompt_message_identify_key_trends',
        defaultMessage: '<p>From this <a>{url}</a>, identify the key trends, anomalies, and headline numbers. Call out anything increasing/decreasing significantly, noteworthy comparisons, and any risks or opportunities the data suggests.</p>',
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_identify_key_points: {
        id: 'fabric.linking.rovo_prompt_button_identify_key_points',
        defaultMessage: "Identify key points",
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_identify_key_points: {
        id: 'fabric.linking.rovo_prompt_message_identify_key_points',
        defaultMessage: '<p>From this <a>{url}</a>, identify the key points, proposals, and decisions. Focus on what someone skimming the deck should know in order to understand the main message.</p>',
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_find_open_questions: {
        id: 'fabric.linking.rovo_prompt_button_find_open_questions',
        defaultMessage: "Find open questions",
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_find_open_questions: {
        id: 'fabric.linking.rovo_prompt_message_find_open_questions',
        defaultMessage: "<p>Look at this <a>{url}</a> and list any open questions, unresolved decisions, or asks that still need follow\u2011up. Group them by owner if possible and keep it concise.</p>",
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_key_highlights: {
        id: 'fabric.linking.rovo_prompt_button_key_highlights',
        defaultMessage: "Key highlights",
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_key_highlights: {
        id: 'fabric.linking.rovo_prompt_message_key_highlights',
        defaultMessage: "<p>Based on this <a>{url}</a> and the page or ticket I\u2019m currently viewing, highlight the parts of the linked content that are most relevant to this work. Explain briefly why each part is relevant.</p>",
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_chat_action_section_header: {
        id: 'fabric.linking.rovo_chat_action_section_header.non-final',
        defaultMessage: 'Ask Rovo',
        description: 'Heading shown above the Rovo prompt action buttons in the smart link hover card, alongside the Rovo logo, to introduce the AI prompt suggestions.'
    },
    rovo_prompt_button_summarize_this: {
        id: 'fabric.linking.rovo_prompt_button_summarize_this.non-final',
        defaultMessage: 'Summarize this for me',
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_button_ask_a_specific_question: {
        id: 'fabric.linking.rovo_prompt_button_ask_a_specific_question.non-final',
        defaultMessage: 'Ask a specific question',
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_button_show_me_whats_relevant: {
        id: 'fabric.linking.rovo_prompt_button_show_me_whats_relevant.non-final',
        defaultMessage: "Show me what's relevant",
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_summarize_document: {
        id: 'fabric.linking.rovo_prompt_message_summarize_document',
        defaultMessage: "<p>Summarize this doc <a>{url}</a> into a concise, easy-to-scan overview. Adapt to whatever the content is and focus on the main ideas, important decisions, key updates, and next steps, only include these if they exist; don't mention their absence. Avoid unnecessary detail, repetition, or formatting commentary. Write in plain language and optimize for a quick 5\u201310 second read</p>",
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_message_summarize_presentation: {
        id: 'fabric.linking.rovo_prompt_message_summarize_presentation',
        defaultMessage: "<p>Summarize this Google Slides deck <a>{url}</a> into a concise executive overview. Focus on the tldr, key findings, decisions, metrics, risks, and next steps, if there are any. Use a short executive summary followed by 2-3 bullet points. Avoid slide-by-slide narration, design details, repetition, and filler.</p>",
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_explain_code: {
        id: 'fabric.linking.rovo_prompt_button_explain_code',
        defaultMessage: "Explain",
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_explain_code: {
        id: 'fabric.linking.rovo_prompt_message_explain_code',
        defaultMessage: "<p>Explain this code, pull request, or commit <a>{url}</a> in clear, plain language for a non-technical audience.</p><p>Cover:</p><ol><li><strong>Purpose</strong> \u2014 What problem does it solve or what goal does it achieve?</li><li><strong>How it works</strong> \u2014 High-level mechanics (no implementation detail unless critical to understanding).</li><li><strong>Why</strong> \u2014 Motivation for the change or design choice.</li><li><strong>Impact</strong> \u2014 Key behavior changes, risks, or downstream effects worth noting.</li></ol><p>Constraints:</p><ul><li>3\u20135 sentences or 100\u2013150 words max.</li><li>Omit sections with nothing meaningful to say.</li><li>Prefer concrete language over abstract descriptions (e.g., \"speeds up page load by caching results\" over \"improves performance\").</li></ul>",
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_catch_up: {
        id: 'fabric.linking.rovo_prompt_button_catch_up',
        defaultMessage: "Catch up",
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_catch_up: {
        id: 'fabric.linking.rovo_prompt_message_catch_up',
        defaultMessage: "<p>Catch me up on the latest {provider} conversations or channel activity in <a>{url}</a> from the last two weeks. If there's no activity in the past two weeks, expand the window to the most recent 30 days (or until meaningful activity is found). Summarize the most important updates, decisions, and discussions so the user can quickly understand what they missed. Focus on key changes, unresolved questions, and any action items or follow-ups. Prioritize recent messages with the most activity. Keep the response concise \u2014 ideally 80\u2013150 words or a short set of 3\u20135 key bullets.</p>",
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. {provider} is the 3P app name (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_salesforce_prep: {
        id: 'fabric.linking.rovo_prompt_button_salesforce_prep',
        defaultMessage: "Prep",
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_salesforce_prep: {
        id: 'fabric.linking.rovo_prompt_message_salesforce_prep',
        defaultMessage: "<p>Prep me for this Salesforce record <a>{url}</a>. What's the current state, what's the recent activity, what risks or opportunities should I be aware of, and what would be useful to know before a conversation about it?</p>",
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    // TODO: remove when social-proof-3p-unauth-block-fg is cleaned up
    pre_auth_block_social_proof_not_low: {
        id: 'fabric.linking.pre_auth_block_social_proof_not_low',
        defaultMessage: '<b>{percentage}%</b> of your team sees <b>{provider}</b> previews.',
        description: 'Social proof message shown on unauthorized 3P block cards when 30% or more of the tenant has connected the provider. {percentage} is a number, {provider} is the 3P app name (e.g. OneDrive).'
    },
    pre_auth_block_social_proof_low: {
        id: 'fabric.linking.pre_auth_block_social_proof_low',
        defaultMessage: 'Your team sees richer <b>{provider}</b> previews.',
        description: 'Social proof message shown on unauthorized 3P block cards when less than 30% of the tenant has connected the provider. {provider} is the 3P app name (e.g. OneDrive).'
    }
});

});

parcelRegister("hanqH", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7f58b7be10a4210$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $6bnW7 = parcelRequire("6bnW7");
var $hrVKU = parcelRequire("hrVKU");

var $iAhw9 = parcelRequire("iAhw9");

var $50U6m = parcelRequire("50U6m");

var $aeT4q = parcelRequire("aeT4q");
var $c7f58b7be10a4210$var$styles = {
    roundImg: "_2rko1rr0"
};
var $c7f58b7be10a4210$var$messages = (0, $6bnW7.defineMessages)({
    imageAltText: {
        id: 'smart-link.image-icon.altText',
        defaultMessage: 'Link Icon',
        description: 'Alternative text for the link icon image displayed on a flexible smart link card, used by screen readers and when the image cannot be rendered.'
    }
});
var $c7f58b7be10a4210$var$ImageIcon = function ImageIcon(_ref) {
    var label = _ref.label, defaultIcon = _ref.defaultIcon, testId = _ref.testId, url = _ref.url, width = _ref.width, height = _ref.height, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'square' : _ref$appearance, onError = _ref.onError, onLoad = _ref.onLoad, _ref$hideLoadingSkele = _ref.hideLoadingSkeleton, hideLoadingSkeleton = _ref$hideLoadingSkele === void 0 ? false : _ref$hideLoadingSkele;
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    var _useIntl = (0, $hrVKU.default)(), formatMessage = _useIntl.formatMessage;
    // If url changes, reset state
    (0, $5FkrB.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        url
    ]);
    if (hasImageErrored) return defaultIcon;
    if (hideLoadingSkeleton) {
        var _label$trim;
        return /*#__PURE__*/ $5FkrB.createElement("img", {
            src: url,
            "data-testid": "".concat(testId, "-image"),
            alt: (0, $50U6m.fg)('platform_navx_smart_link_icon_label_a11y') ? (_label$trim = label === null || label === void 0 ? void 0 : label.trim()) !== null && _label$trim !== void 0 ? _label$trim : '' : '',
            style: {
                width: width,
                height: height
            },
            onError: function onError() {
                return setHasImageErrored(true);
            },
            className: (0, $970q7.default)([
                appearance === 'round' && $c7f58b7be10a4210$var$styles.roundImg
            ])
        });
    } else {
        var _label$trim2;
        return /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iAhw9))), {
            src: url,
            loading: /*#__PURE__*/ $5FkrB.createElement((0, $aeT4q.LoadingSkeleton), {
                testId: "".concat(testId, "-loading"),
                width: width,
                height: height
            }),
            loaded: /*#__PURE__*/ $5FkrB.createElement("img", {
                src: url,
                "data-testid": "".concat(testId, "-image"),
                alt: (0, $50U6m.fg)('platform_navx_smart_link_icon_label_a11y') ? (_label$trim2 = label === null || label === void 0 ? void 0 : label.trim()) !== null && _label$trim2 !== void 0 ? _label$trim2 : '' : formatMessage($c7f58b7be10a4210$var$messages.imageAltText),
                style: {
                    width: width,
                    height: height
                },
                className: (0, $970q7.default)([
                    appearance === 'round' && $c7f58b7be10a4210$var$styles.roundImg
                ])
            }),
            errored: defaultIcon,
            onError: onError,
            onLoad: onLoad
        });
    }
};
var $c7f58b7be10a4210$export$2e2bcd8739ae039 = $c7f58b7be10a4210$var$ImageIcon;

});
parcelRegister("iAhw9", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d8792d6a804e2cc9$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5FkrB = parcelRequire("5FkrB");
var $d8792d6a804e2cc9$var$React = $d8792d6a804e2cc9$var$_interopRequireWildcard($5FkrB);
function $d8792d6a804e2cc9$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $d8792d6a804e2cc9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d8792d6a804e2cc9$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d8792d6a804e2cc9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $d8792d6a804e2cc9$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $d8792d6a804e2cc9$var$loaded() {
    return {
        isLoaded: true
    };
}
function $d8792d6a804e2cc9$var$errored() {
    return {
        isErrored: true
    };
}
function $d8792d6a804e2cc9$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $d8792d6a804e2cc9$var$ImageRenderer = function(_React$Component) {
    $d8792d6a804e2cc9$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $d8792d6a804e2cc9$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $d8792d6a804e2cc9$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($d8792d6a804e2cc9$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($d8792d6a804e2cc9$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $d8792d6a804e2cc9$var$_possibleConstructorReturn(_this, _ret);
    }
    $d8792d6a804e2cc9$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($d8792d6a804e2cc9$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($d8792d6a804e2cc9$var$hasPropsChanged(this.props, nextProps)) this.setState($d8792d6a804e2cc9$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($d8792d6a804e2cc9$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($d8792d6a804e2cc9$var$React.Component);
module.exports.default = $d8792d6a804e2cc9$var$ImageRenderer;

});

parcelRegister("aeT4q", function(module, exports) {
$parcel$export(module.exports, "LoadingSkeleton", () => $7745ee0130fc3824$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $7745ee0130fc3824$var$animationNameStyles = null;
var $7745ee0130fc3824$var$loadingSkeletonStyle = null;
var $7745ee0130fc3824$export$44c18d210d5de37b = function LoadingSkeleton(_ref) {
    var testId = _ref.testId, width = _ref.width, height = _ref.height;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        style: {
            width: width,
            height: height
        },
        className: (0, $970q7.default)([
            "_2rkolb4i _uiztglyw _bfhkvkf5 _1itkfj9x _12vemgnk _1lrw6rms _1e0c1o8l _5sag9cwz _1o51q7pw _tip812c5 _j7hqqkar _1pglp3kn"
        ])
    });
};

});


parcelRegister("bOkxB", function(module, exports) {
$parcel$export(module.exports, "showFlag", () => $89944c3e45b24927$export$e12b2cc6b75b006b);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $cITiu = parcelRequire("cITiu");

var $9Pk7k = parcelRequire("9Pk7k");

var $9aeFz = parcelRequire("9aeFz");

var $j5ILV = parcelRequire("j5ILV");

var $as7Bx = parcelRequire("as7Bx");
function $89944c3e45b24927$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $89944c3e45b24927$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $89944c3e45b24927$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $89944c3e45b24927$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $89944c3e45b24927$var$FLAG_GROUP_MOUNT_POINT_ID = 'smart-link-flags-mount';
// ---------------------------------------------------------------------------
// Module-level singleton state
// Lives for the entire page session — independent of any React component tree.
//
// The sequence:
// 1. ensureRoot()
//    └── flushSync(() => root.render(<empty FlagGroup>))
//        └── ExitingPersistence mounts with appear=false
//        └── pendingFirstRender = true
//
// 2. showFlag() detects pendingFirstRender=true
//    └── pendingFirstRender = false
//    └── setTimeout(0, () => renderToRoot())
//        ← deferred: runs AFTER useEffect fires
//
// 3. [async] ExitingPersistence's useEffect fires
//    └── appear flips false → true
//
// 4. [async] setTimeout(0) fires → renderToRoot()
//    └── FlagGroup receives flag as new child
//    └── ExitingPersistence sees new child with appear=true → ANIMATES
// ---------------------------------------------------------------------------
var $89944c3e45b24927$var$flagGroupState = [];
var $89944c3e45b24927$var$root = null;
// True after ensureRoot() creates a new root but before ExitingPersistence's useEffect
// has flipped `appear` to true. While pending, the first renderToRoot is deferred via
// setTimeout so that the enter animation fires correctly.
var $89944c3e45b24927$var$pendingFirstRender = false;
var $89944c3e45b24927$var$removeFlag = function removeFlag(id) {
    $89944c3e45b24927$var$flagGroupState = $89944c3e45b24927$var$flagGroupState.filter(function(f) {
        return f.id !== id;
    });
    $89944c3e45b24927$var$renderToRoot();
};
var $89944c3e45b24927$var$renderToRoot = function renderToRoot() {
    if (!$89944c3e45b24927$var$root) return;
    $89944c3e45b24927$var$root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9Pk7k.default), {
        locale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $j5ILV.default), {
        onDismissed: $89944c3e45b24927$var$removeFlag
    }, $89944c3e45b24927$var$flagGroupState.map(function(flagProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $as7Bx.default), {
            borderRadius: 'large',
            isVisible: true,
            key: flagProps.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9aeFz.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, flagProps, {
            key: flagProps.id
        })));
    }))));
};
var $89944c3e45b24927$var$ensureRoot = function ensureRoot() {
    if ($89944c3e45b24927$var$root !== null || typeof document === 'undefined') return;
    var container = document.getElementById($89944c3e45b24927$var$FLAG_GROUP_MOUNT_POINT_ID);
    if (!container) {
        container = document.createElement('div');
        container.id = $89944c3e45b24927$var$FLAG_GROUP_MOUNT_POINT_ID;
        document.body.appendChild(container);
    }
    $89944c3e45b24927$var$root = (0, $cITiu.createRoot)(container);
    var locale = typeof navigator !== 'undefined' ? navigator.language || 'en' : 'en';
    // Render an empty FlagGroup immediately so React has a "before" state to diff against.
    // Without this, the first flag has no previous render to compare to — React mounts it
    // directly and the FlagGroup animation library sees it as "already present" rather than
    // "just entered", skipping the slide-in animation.
    // Subsequent flags always have the previous (possibly empty) render to diff against,
    // which is why they animate correctly.
    var renderEmptyFlagGroup = function renderEmptyFlagGroup() {
        return $89944c3e45b24927$var$root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9Pk7k.default), {
            locale: locale
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $j5ILV.default), {
            onDismissed: $89944c3e45b24927$var$removeFlag
        })));
    };
    // Use flushSync to synchronously commit an empty FlagGroup before any flag is added.
    // This mounts ExitingPersistence (inside FlagGroup) in an empty state so that when the
    // first flag arrives (deferred via setTimeout below), ExitingPersistence recognises it
    // as a genuinely new child and runs the slide-in animation.
    try {
        (0, $aLeHs.flushSync)(renderEmptyFlagGroup);
    } catch (_unused) {
        // flushSync cannot be called during React rendering or from a lifecycle (e.g. useEffect).
        // We try it and fall back to a regular async render if React throws — in that case the
        // first flag may appear without a slide-in animation, but all subsequent flags will
        // animate correctly (ExitingPersistence will have mounted and flipped appear=true by then).
        renderEmptyFlagGroup();
    }
    // After flushSync commits the empty FlagGroup, ExitingPersistence's useEffect runs
    // asynchronously to flip `appear` from false → true (enabling enter animations).
    // We store a pending flag to signal that the first renderToRoot should be deferred.
    $89944c3e45b24927$var$pendingFirstRender = true;
};
var $89944c3e45b24927$export$e12b2cc6b75b006b = function showFlag(options) {
    var flagProps = $89944c3e45b24927$var$_objectSpread($89944c3e45b24927$var$_objectSpread({}, options), {}, {
        id: options.id || crypto.randomUUID()
    });
    var index = $89944c3e45b24927$var$flagGroupState.findIndex(function(f) {
        return f.id === flagProps.id;
    });
    if (index === -1) $89944c3e45b24927$var$flagGroupState = [
        flagProps
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))($89944c3e45b24927$var$flagGroupState));
    else $89944c3e45b24927$var$flagGroupState = $89944c3e45b24927$var$flagGroupState.map(function(f, i) {
        return i === index ? flagProps : f;
    });
    $89944c3e45b24927$var$ensureRoot();
    if ($89944c3e45b24927$var$pendingFirstRender) {
        // ensureRoot() just created a new root and committed an empty FlagGroup via flushSync.
        // ExitingPersistence's useEffect (which flips `appear` false→true) runs asynchronously
        // after the commit. We defer renderToRoot via setTimeout(0) to ensure that useEffect
        // has already fired before the flag is added — only then will ExitingPersistence
        // treat it as a new entering child and run the slide-in animation.
        $89944c3e45b24927$var$pendingFirstRender = false;
        setTimeout(function() {
            $89944c3e45b24927$var$renderToRoot();
        }, 0);
    } else $89944c3e45b24927$var$renderToRoot();
};
var $89944c3e45b24927$export$3dd8302481493c99 = function _resetFlagsForTesting() {
    $89944c3e45b24927$var$flagGroupState = [];
    $89944c3e45b24927$var$pendingFirstRender = false;
    if ($89944c3e45b24927$var$root) {
        $89944c3e45b24927$var$root.unmount();
        $89944c3e45b24927$var$root = null;
    }
    if (typeof document !== 'undefined') {
        var _document$getElementB;
        (_document$getElementB = document.getElementById($89944c3e45b24927$var$FLAG_GROUP_MOUNT_POINT_ID)) === null || _document$getElementB === void 0 || _document$getElementB.remove();
    }
};

});
parcelRegister("9aeFz", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ac06d452aab26aa$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $aLEtb = parcelRequire("aLEtb");

var $eVb4V = parcelRequire("eVb4V");

var $jBW28 = parcelRequire("jBW28");

var $3wlgk = parcelRequire("3wlgk");
var $6ac06d452aab26aa$var$packageName = "@atlaskit/flag";
var $6ac06d452aab26aa$var$packageVersion = "18.5.6";
var $6ac06d452aab26aa$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ var $6ac06d452aab26aa$var$AutoDismissFlag = function AutoDismissFlag(props) {
    var id = props.id, analyticsContext = props.analyticsContext, _props$onDismissed = props.onDismissed, onDismissedProp = _props$onDismissed === void 0 ? (0, $eVb4V.default) : _props$onDismissed, _props$autoDismissSec = props.autoDismissSeconds, autoDismissSeconds = _props$autoDismissSec === void 0 ? $6ac06d452aab26aa$export$66c3d409977b5615 : _props$autoDismissSec;
    var autoDismissTimer = (0, $5FkrB.useRef)(null);
    var _useFlagGroup = (0, $3wlgk.useFlagGroup)(), onDismissedFromFlagGroup = _useFlagGroup.onDismissed, isDismissAllowed = _useFlagGroup.isDismissAllowed;
    var onDismissed = (0, $5FkrB.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var onDismissedAnalytics = (0, $aLEtb.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        componentName: 'flag',
        packageName: $6ac06d452aab26aa$var$packageName,
        packageVersion: $6ac06d452aab26aa$var$packageVersion
    });
    var isAutoDismissAllowed = isDismissAllowed && onDismissed;
    var dismissFlag = (0, $5FkrB.useCallback)(function() {
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    var stopAutoDismissTimer = (0, $5FkrB.useCallback)(function() {
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    var startAutoDismissTimer = (0, $5FkrB.useCallback)(function() {
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, autoDismissSeconds * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed,
        autoDismissSeconds
    ]);
    (0, $5FkrB.useEffect)(function() {
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jBW28.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    }));
};
var $6ac06d452aab26aa$export$2e2bcd8739ae039 = $6ac06d452aab26aa$var$AutoDismissFlag;

});
parcelRegister("jBW28", function(module, exports) {
$parcel$export(module.exports, "default", () => $e46e7d3f13e42a77$export$2e2bcd8739ae039);
/* flag.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $cAVP0 = parcelRequire("cAVP0");

var $aLEtb = parcelRequire("aLEtb");

var $eVb4V = parcelRequire("eVb4V");

var $87eCL = parcelRequire("87eCL");

var $50U6m = parcelRequire("50U6m");

var $auVZV = parcelRequire("auVZV");
var $m5IEn = parcelRequire("m5IEn");
var $9FlpM = parcelRequire("9FlpM");

var $e8kqY = parcelRequire("e8kqY");

var $I6eOw = parcelRequire("I6eOw");

var $dAkJn = parcelRequire("dAkJn");

var $gHqSA = parcelRequire("gHqSA");

var $9Og9W = parcelRequire("9Og9W");

var $fNBOT = parcelRequire("fNBOT");

var $gmjbj = parcelRequire("gmjbj");

var $ekUFP = parcelRequire("ekUFP");

var $hBt3i = parcelRequire("hBt3i");

var $cHmLx = parcelRequire("cHmLx");

var $3wlgk = parcelRequire("3wlgk");
function $e46e7d3f13e42a77$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e46e7d3f13e42a77$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e46e7d3f13e42a77$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e46e7d3f13e42a77$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e46e7d3f13e42a77$var$styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rko1mok _1reo15vq _18m915vq _v564z97a _16qs130s _1pbyni7l _1bsb1osq",
    contentStack: "_k8m01vax _1oec1mzy _156yru3m"
};
var $e46e7d3f13e42a77$var$CSS_VAR_ICON_COLOR = '--flag-icon-color';
var $e46e7d3f13e42a77$var$descriptionStyles = null;
var $e46e7d3f13e42a77$var$flagWrapperStyles = null;
var $e46e7d3f13e42a77$var$iconWrapperStyles = null;
var $e46e7d3f13e42a77$var$transitionStyles = null;
var $e46e7d3f13e42a77$var$analyticsAttributes = {
    componentName: 'flag',
    packageName: "@atlaskit/flag",
    packageVersion: "18.5.6"
};
/**
 * __Flag__
 *
 * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
 * often displayed using a flag group.
 *
 * - [Examples](https://atlassian.design/components/flag/examples)
 * - [Code](https://atlassian.design/components/flag/code)
 * - [Usage](https://atlassian.design/components/flag/usage)
 */ var $e46e7d3f13e42a77$var$Flag = function Flag(props) {
    var _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $I6eOw.DEFAULT_APPEARANCE) : _props$appearance, icon = props.icon, title = props.title, description = props.description, linkComponent = props.linkComponent, onMouseOver = props.onMouseOver, _props$onFocus = props.onFocus, onFocus = _props$onFocus === void 0 ? (0, $eVb4V.default) : _props$onFocus, onMouseOut = props.onMouseOut, _props$onBlur = props.onBlur, onBlur = _props$onBlur === void 0 ? (0, $eVb4V.default) : _props$onBlur, _props$onDismissed = props.onDismissed, onDismissedProp = _props$onDismissed === void 0 ? (0, $eVb4V.default) : _props$onDismissed, testId = props.testId, id = props.id, analyticsContext = props.analyticsContext, delayAnnouncement = props.delayAnnouncement, _props$headingLevel = props.headingLevel, headingLevel = _props$headingLevel === void 0 ? 2 : _props$headingLevel;
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isDelayToAnnounce = _useState2[0], setIsDelayToAnnounce = _useState2[1];
    var _useFlagGroup = (0, $3wlgk.useFlagGroup)(), onDismissedFromFlagGroup = _useFlagGroup.onDismissed, isDismissAllowed = _useFlagGroup.isDismissAllowed;
    var onDismissed = (0, $5FkrB.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), isExpanded = _useState4[0], setIsExpanded = _useState4[1];
    var onDismissedAnalytics = (0, $aLEtb.usePlatformLeafEventHandler)($e46e7d3f13e42a77$var$_objectSpread({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext
    }, $e46e7d3f13e42a77$var$analyticsAttributes));
    var isBold = appearance !== (0, $I6eOw.DEFAULT_APPEARANCE);
    var toggleExpand = (0, $5FkrB.useCallback)(function() {
        setIsExpanded(function(previous) {
            return !previous;
        });
    }, []);
    var buttonActionCallback = (0, $5FkrB.useCallback)(function() {
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $5FkrB.useEffect)(function() {
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (!delayAnnouncement) return;
        setTimeout(function() {
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    var onFocusAnalytics = (0, $aLEtb.usePlatformLeafEventHandler)($e46e7d3f13e42a77$var$_objectSpread({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext
    }, $e46e7d3f13e42a77$var$analyticsAttributes));
    var onBlurAnalytics = (0, $aLEtb.usePlatformLeafEventHandler)($e46e7d3f13e42a77$var$_objectSpread({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext
    }, $e46e7d3f13e42a77$var$analyticsAttributes));
    var autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    var textColor = (0, $gmjbj.flagTextColor)[appearance];
    var iconColor = (0, $9Og9W.flagIconColor)[appearance];
    var iconGlyph = (0, $fNBOT.flagIconGlyph)[appearance];
    var isDismissable = isBold || isDismissAllowed;
    var shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
    var isCollapseAnimationEnabled = (0, $50U6m.fg)('platform-dst-flag-collapse-animation-fix');
    // when delayAnnouncement is available we will use a hidden content for announcement
    var delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ $5FkrB.createElement((0, $e8kqY.default), null, title, description) : undefined;
    // A11y improvement opportunity: all flags currently use role="alert" (assertive),
    // but non-critical flags (e.g. info, success) should use role="status" (polite)
    // to avoid interrupting screen reader users. See WCAG 4.1.3.
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        role: "alert",
        "data-testid": testId
    }, autoDismissProps, {
        className: (0, $970q7.default)([
            "_1bsb1osq"
        ])
    }), /*#__PURE__*/ $5FkrB.createElement((0, $auVZV.Box), {
        padding: "space.200",
        backgroundColor: (0, $gHqSA.flagBackgroundColor)[appearance],
        xcss: $e46e7d3f13e42a77$var$styles.flag
    }, /*#__PURE__*/ $5FkrB.createElement((0, $m5IEn.Inline), {
        alignBlock: "start",
        space: "space.200"
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": testId && "".concat(testId, "-icon-container"),
        className: (0, $970q7.default)([
            "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz16r9"
        ]),
        style: $e46e7d3f13e42a77$var$_objectSpread($e46e7d3f13e42a77$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $e46e7d3f13e42a77$var$CSS_VAR_ICON_COLOR, iconColor)), {}, {
            "--_11v68d2": (0, $cAVP0.default)("var(".concat($e46e7d3f13e42a77$var$CSS_VAR_ICON_COLOR, ")"))
        })
    }, icon || iconGlyph), /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            "_v5641hdc _1ul9idpf _16jlkb7n"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $9FlpM.Stack), {
        space: shouldRenderGap ? 'space.100' : 'space.0' // Gap exists even when not expanded due to Expander internals always being in the DOM
        ,
        xcss: isCollapseAnimationEnabled ? $e46e7d3f13e42a77$var$styles.contentStack : undefined,
        testId: testId && "".concat(testId, "-content-stack")
    }, isDelayToAnnounce && delayedAnnouncement, /*#__PURE__*/ $5FkrB.createElement((0, $m5IEn.Inline), {
        alignBlock: "stretch",
        space: "space.100",
        spread: "space-between"
    }, /*#__PURE__*/ $5FkrB.createElement((0, $auVZV.Box), {
        paddingBlockStart: "space.050",
        paddingBlockEnd: "space.025",
        xcss: $e46e7d3f13e42a77$var$styles.overflowWrap
    }, /*#__PURE__*/ $5FkrB.createElement((0, $87eCL.default), {
        as: "h".concat(headingLevel),
        size: "xsmall",
        color: textColor
    }, /*#__PURE__*/ $5FkrB.createElement("span", {
        /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce
    }, title))), isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ $5FkrB.createElement((0, $hBt3i.default), {
        testId: testId,
        appearance: appearance,
        isBold: isBold,
        isExpanded: isExpanded,
        onClick: isBold ? toggleExpand : buttonActionCallback
    }) : null), /*#__PURE__*/ $5FkrB.createElement((0, $cHmLx.default), {
        isExpanded: !isBold || isExpanded,
        testId: testId
    }, description && /*#__PURE__*/ $5FkrB.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            color: (0, $ekUFP.flagTextColorToken)[appearance]
        },
        "data-testid": testId && "".concat(testId, "-description"),
        "aria-hidden": isDelayToAnnounce,
        className: (0, $970q7.default)([
            "_11c8fhey _1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
        ])
    }, description), /*#__PURE__*/ $5FkrB.createElement((0, $dAkJn.default), {
        actions: actions,
        appearance: appearance,
        linkComponent: linkComponent,
        testId: testId
    })))))));
};
var $e46e7d3f13e42a77$export$2e2bcd8739ae039 = $e46e7d3f13e42a77$var$Flag;

});
parcelRegister("87eCL", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e8a523a7d4ffb69$export$2e2bcd8739ae039);
/* heading.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $a3VXv = parcelRequire("a3VXv");

var $99N5z = parcelRequire("99N5z");

var $1dAq9 = parcelRequire("1dAq9");

var $3ZMUU = parcelRequire("3ZMUU");
var $5e8a523a7d4ffb69$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $5e8a523a7d4ffb69$var$styles = {
    reset: "_dxsyidpf _1i144jg8 _nmk4glyw"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $5e8a523a7d4ffb69$var$headingColorStyles = {
    'color.text': "_1w90i7uo",
    'color.text.inverse': "_1w9015cr",
    'color.text.warning.inverse': "_1w901yd3"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $5e8a523a7d4ffb69$var$headingSizeStyles = {
    xxlarge: "_fqox1iff",
    xlarge: "_fqox12ln",
    large: "_fqox10sd",
    medium: "_fqox1af2",
    small: "_fqox1e3o",
    xsmall: "_fqox1qyo",
    xxsmall: "_fqoxi4vh"
};
/**
 * @codegenEnd
 */ var $5e8a523a7d4ffb69$var$useColor = function useColor(colorProp) {
    var surface = (0, $99N5z.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $a3VXv.inverseColorMap).hasOwnProperty(surface)) return (0, $a3VXv.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $5e8a523a7d4ffb69$var$Heading = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    typeof $3ZMUU;
    var _useHeading = (0, $1dAq9.useHeading)($5e8a523a7d4ffb69$var$sizeTagMap[size]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === 'div' && hLevel;
    var color = $5e8a523a7d4ffb69$var$useColor(colorProp);
    return /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $970q7.default)([
            $5e8a523a7d4ffb69$var$styles.reset,
            $5e8a523a7d4ffb69$var$headingSizeStyles[size],
            $5e8a523a7d4ffb69$var$headingColorStyles[color]
        ])
    }, children);
});
var $5e8a523a7d4ffb69$export$2e2bcd8739ae039 = $5e8a523a7d4ffb69$var$Heading;

});
parcelRegister("1dAq9", function(module, exports) {
$parcel$export(module.exports, "useHeading", () => $0e3341c721c30a2c$export$97a37b1befbbf9b1);

var $dbmGd = parcelRequire("dbmGd");
var $0e3341c721c30a2c$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = (0, $dbmGd.useHeadingLevel)();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : "h".concat(hLevel)) || fallback
    ];
};

});
parcelRegister("dbmGd", function(module, exports) {
$parcel$export(module.exports, "useHeadingLevel", () => $998de52d6355e75c$export$6a64a1e2d0bbbf75);

var $5FkrB = parcelRequire("5FkrB");

var $5kQN8 = parcelRequire("5kQN8");
var $998de52d6355e75c$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $5FkrB.useContext)((0, $5kQN8.HeadingLevelContext));
};

});
parcelRegister("5kQN8", function(module, exports) {
$parcel$export(module.exports, "HeadingLevelContext", () => $3e27c54c11866c49$export$d1fa8a19e192bc63);

var $5FkrB = parcelRequire("5FkrB");
var $3e27c54c11866c49$export$d1fa8a19e192bc63 = /*#__PURE__*/ (0, $5FkrB.createContext)(0);

});




parcelRegister("I6eOw", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_APPEARANCE", () => $0848f2e621b3f640$export$d6830277b06edd6);
var $0848f2e621b3f640$export$d6830277b06edd6 = 'normal';
var $0848f2e621b3f640$export$1eee5ddc4f6d41c5 = 400;

});

parcelRegister("dAkJn", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e3eb7e382344f7e$export$2e2bcd8739ae039);
/* flag-actions.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $Ew7GJ = parcelRequire("Ew7GJ");

var $50U6m = parcelRequire("50U6m");

var $m5IEn = parcelRequire("m5IEn");

var $diSiT = parcelRequire("diSiT");

var $I6eOw = parcelRequire("I6eOw");

var $88RlI = parcelRequire("88RlI");
var $9e3eb7e382344f7e$var$buttonStylesOld = null;
var $9e3eb7e382344f7e$var$buttonStyles = null;
var $9e3eb7e382344f7e$var$fontStyles = null;
var $9e3eb7e382344f7e$var$appearanceNormalButtonStyles = null;
var $9e3eb7e382344f7e$var$appearanceBoldButtonStyles = null;
var $9e3eb7e382344f7e$var$appearanceNormalActionsContainerStyles = null;
var $9e3eb7e382344f7e$var$FlagActions = function FlagActions(props) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $I6eOw.DEFAULT_APPEARANCE) : _props$appearance, _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, linkComponent = props.linkComponent, testId = props.testId;
    if (!actions.length) return null;
    var isBold = appearance !== (0, $I6eOw.DEFAULT_APPEARANCE);
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            !isBold && "_1g4l107e _y8dn107e",
            "_11c8fhey"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $m5IEn.Inline), {
        space: "space.100",
        shouldWrap: true,
        alignBlock: "center",
        separator: isBold ? undefined : "\xb7",
        testId: testId && "".concat(testId, "-actions")
    }, actions.map(function(action, index) {
        return (0, $50U6m.fg)('platform_dst_flag_action_padding_fix') ? /*#__PURE__*/ $5FkrB.createElement((0, $Ew7GJ.default), {
            onClick: action.onClick,
            href: action.href,
            target: action.target,
            appearance: isBold ? 'default' : 'link',
            component: linkComponent,
            spacing: "compact",
            testId: action.testId,
            key: index,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                '--color': (0, $diSiT.actionTextColor)[appearance],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color': (0, $88RlI.actionBackgroundColor)[appearance].default,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color-hover': (0, $88RlI.actionBackgroundColor)[appearance].pressed,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color-active': (0, $88RlI.actionBackgroundColor)[appearance].active
            },
            className: (0, $970q7.default)([
                "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                isBold ? "_1dltgrf3 _h03xgrf3 _w8sq1a66 _1iys1a66 _fjwrgrf3 _cwkngrf3 _1yxx1a66 _z7cd1a66" : "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
            ])
        }, action.content) : /*#__PURE__*/ $5FkrB.createElement((0, $Ew7GJ.default), {
            onClick: action.onClick,
            href: action.href,
            target: action.target,
            appearance: isBold ? 'default' : 'link',
            component: linkComponent,
            spacing: "compact",
            testId: action.testId,
            key: index,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                '--color': (0, $diSiT.actionTextColor)[appearance],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color': (0, $88RlI.actionBackgroundColor)[appearance].default,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color-hover': (0, $88RlI.actionBackgroundColor)[appearance].pressed,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color-active': (0, $88RlI.actionBackgroundColor)[appearance].active
            },
            className: (0, $970q7.default)([
                "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk61a66 _1wy61a66 _b3g31a66 _eqps1a66 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                !isBold && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
            ])
        }, action.content);
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9e3eb7e382344f7e$export$2e2bcd8739ae039 = $9e3eb7e382344f7e$var$FlagActions;

});
parcelRegister("Ew7GJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $079ca7802c1bfb5a$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $9sbnV = parcelRequire("9sbnV");

var $8cfv1 = parcelRequire("8cfv1");

var $6R7Di = parcelRequire("6R7Di");

var $7PjTL = parcelRequire("7PjTL");

var $lBNhN = parcelRequire("lBNhN");

var $3VBK4 = parcelRequire("3VBK4");

var $e2OEo = parcelRequire("e2OEo");
var $079ca7802c1bfb5a$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isSelected",
    "shouldFitContainer",
    "spacing",
    "isLoading",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseDown",
    "onMouseUp",
    "onFocus",
    "onBlur",
    "theme"
];
function $079ca7802c1bfb5a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $079ca7802c1bfb5a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $079ca7802c1bfb5a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $079ca7802c1bfb5a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $079ca7802c1bfb5a$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
var $079ca7802c1bfb5a$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use `Button` from `@atlaskit/button/default/button`.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var $079ca7802c1bfb5a$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'default' : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $lBNhN.defaultThemeFn) : _ref2$theme, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $079ca7802c1bfb5a$var$_excluded);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $079ca7802c1bfb5a$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $5FkrB.useState)($079ca7802c1bfb5a$var$initial), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $5FkrB.useCallback)(function(event) {
        setState(function(current) {
            return $079ca7802c1bfb5a$var$_objectSpread($079ca7802c1bfb5a$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $5FkrB.useCallback)(function(event) {
        setState(function(current) {
            return $079ca7802c1bfb5a$var$_objectSpread($079ca7802c1bfb5a$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $5FkrB.useCallback)(function(event) {
        setState(function(current) {
            return $079ca7802c1bfb5a$var$_objectSpread($079ca7802c1bfb5a$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $5FkrB.useCallback)(function(event) {
        setState(function(current) {
            return $079ca7802c1bfb5a$var$_objectSpread($079ca7802c1bfb5a$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $5FkrB.useCallback)(function(event) {
        setState(function(current) {
            return $079ca7802c1bfb5a$var$_objectSpread($079ca7802c1bfb5a$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $5FkrB.useCallback)(function(event) {
        setState(function(current) {
            return $079ca7802c1bfb5a$var$_objectSpread($079ca7802c1bfb5a$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e2OEo.default).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9sbnV.default).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e2OEo.default).Consumer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            mode: mode,
            state: $079ca7802c1bfb5a$var$getInteractionState($079ca7802c1bfb5a$var$_objectSpread($079ca7802c1bfb5a$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $6R7Di.default)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8cfv1.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7PjTL.default), restProps) : null,
                "aria-disabled": isLoading || restProps['aria-disabled'],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $3VBK4.getSpecifiers)(buttonStyles)
            }));
        });
    }));
}));
// Tools including enzyme rely on components having a display name
$079ca7802c1bfb5a$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $079ca7802c1bfb5a$export$2e2bcd8739ae039 = $079ca7802c1bfb5a$var$CustomThemeButton;

});
parcelRegister("9sbnV", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e1f8f60750fb56d$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $ijvhH = parcelRequire("ijvhH");
// Create default global light theme
var $6e1f8f60750fb56d$var$dest = (0, $ijvhH.createTheme)(function() {
    return {
        mode: 'light'
    };
});
var $6e1f8f60750fb56d$var$Provider = $6e1f8f60750fb56d$var$dest.Provider;
var $6e1f8f60750fb56d$var$Consumer = $6e1f8f60750fb56d$var$dest.Consumer;
var $6e1f8f60750fb56d$export$7692396083754928 = $6e1f8f60750fb56d$var$dest.useTheme;
var $6e1f8f60750fb56d$var$Theme = {
    Provider: $6e1f8f60750fb56d$var$Provider,
    Consumer: $6e1f8f60750fb56d$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6e1f8f60750fb56d$export$2e2bcd8739ae039 = $6e1f8f60750fb56d$var$Theme;

});
parcelRegister("ijvhH", function(module, exports) {
$parcel$export(module.exports, "createTheme", () => $d55244cb311b88fe$export$25d302a5b900a763);

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
var $d55244cb311b88fe$var$_excluded = [
    "children"
];
function $d55244cb311b88fe$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $5FkrB.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $5FkrB.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $d55244cb311b88fe$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $5FkrB.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $5FkrB.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("7PjTL", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b2cbb3d7b661df7$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $9ztDu = parcelRequire("9ztDu");
function $5b2cbb3d7b661df7$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $5b2cbb3d7b661df7$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing;
    var size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9ztDu.default), {
        size: size,
        label: ", Loading",
        appearance: $5b2cbb3d7b661df7$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});

parcelRegister("lBNhN", function(module, exports) {
$parcel$export(module.exports, "defaultThemeFn", () => $fbb348df5db62d46$export$437a7f77d13d7916);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $fbb348df5db62d46$export$437a7f77d13d7916(current, values) {
    return current(values);
}

});

parcelRegister("3VBK4", function(module, exports) {
$parcel$export(module.exports, "getSpecifiers", () => $2dc3f8bcebb95279$export$643db0b8d8778e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// This styling approach works by generating a 'style' and applying with maximum specificity
// To do this we are overwriting all pseudo selectors
function $2dc3f8bcebb95279$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}

});

parcelRegister("e2OEo", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3988abed06d3f6c$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $ijvhH = parcelRequire("ijvhH");

var $f6xtX = parcelRequire("f6xtX");
var $a3988abed06d3f6c$var$Theme = (0, $ijvhH.createTheme)(function(themeProps) {
    return {
        buttonStyles: (0, $f6xtX.getCustomCss)(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a3988abed06d3f6c$export$2e2bcd8739ae039 = $a3988abed06d3f6c$var$Theme;

});
parcelRegister("f6xtX", function(module, exports) {
$parcel$export(module.exports, "getCustomCss", () => $aff16366337b085e$export$31512de7fa606fa4);

var $25nEq = parcelRequire("25nEq");

var $74pZe = parcelRequire("74pZe");
function $aff16366337b085e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $aff16366337b085e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $aff16366337b085e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $aff16366337b085e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $aff16366337b085e$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $aff16366337b085e$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $74pZe.getCss)({
        appearance: appearance,
        spacing: spacing,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    var selector = $aff16366337b085e$var$stateToSelectorMap[state];
    if (selector) result = $aff16366337b085e$var$_objectSpread($aff16366337b085e$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $aff16366337b085e$var$_objectSpread($aff16366337b085e$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}

});



parcelRegister("diSiT", function(module, exports) {
$parcel$export(module.exports, "actionTextColor", () => $9af714699839bfa5$export$7bcfe3cca4dd78b6);
var $9af714699839bfa5$export$7bcfe3cca4dd78b6 = {
    success: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    error: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)",
    normal: "var(--ds-link, #1868DB)"
};

});

parcelRegister("88RlI", function(module, exports) {
$parcel$export(module.exports, "actionBackgroundColor", () => $5ed87426c6aab4a2$export$81ba6b63eedb299f);
// TODO: DSP-2519 Interaction tokens should be used for hovered and pressed states
// https://product-fabric.atlassian.net/browse/DSP-2519






var $5ed87426c6aab4a2$export$81ba6b63eedb299f = {
    success: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    info: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    error: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    warning: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};

});


parcelRegister("gHqSA", function(module, exports) {
$parcel$export(module.exports, "flagBackgroundColor", () => $c2858332f8075851$export$59e42969c95d314);
var $c2858332f8075851$export$59e42969c95d314 = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};

});

parcelRegister("9Og9W", function(module, exports) {
$parcel$export(module.exports, "flagIconColor", () => $7245517759a901fb$export$7f70afe2167f8235);
var $7245517759a901fb$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #505258)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #292A2E)"
};

});

parcelRegister("fNBOT", function(module, exports) {
$parcel$export(module.exports, "flagIconGlyph", () => $b808c4db42b1904d$export$73f08aee70487cd4);

var $5FkrB = parcelRequire("5FkrB");

var $cMVCI = parcelRequire("cMVCI");

var $7bxOu = parcelRequire("7bxOu");

var $lcW9s = parcelRequire("lcW9s");

var $lNKbd = parcelRequire("lNKbd");
var $b808c4db42b1904d$export$73f08aee70487cd4 = {
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cMVCI))), {
        label: ""
    }),
    info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7bxOu))), {
        label: ""
    }),
    normal: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7bxOu))), {
        label: ""
    }),
    success: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lcW9s))), {
        label: ""
    }),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lNKbd))), {
        label: ""
    })
};

});

parcelRegister("gmjbj", function(module, exports) {
$parcel$export(module.exports, "flagTextColor", () => $be8d94748d4920db$export$f50075b2584087f);
var $be8d94748d4920db$export$f50075b2584087f = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};

});

parcelRegister("ekUFP", function(module, exports) {
$parcel$export(module.exports, "flagTextColorToken", () => $a6fee5261a1fb132$export$13b42cd9d596bfe0);
var $a6fee5261a1fb132$export$13b42cd9d596bfe0 = {
    error: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    normal: "var(--ds-text, #292A2E)",
    success: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)"
};

});

parcelRegister("hBt3i", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd0c6d881b0b09b3$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $5yfDB = parcelRequire("5yfDB");

var $h19KG = parcelRequire("h19KG");

var $71r6p = parcelRequire("71r6p");

var $ac8VW = parcelRequire("ac8VW");

var $ekUFP = parcelRequire("ekUFP");
var $cd0c6d881b0b09b3$var$DismissButtonComponent = function DismissButtonComponent(_ref) {
    var appearance = _ref.appearance, onClick = _ref.onClick, isBold = _ref.isBold, isExpanded = _ref.isExpanded, testId = _ref.testId;
    var ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($ac8VW)));
    var buttonLabel = 'Dismiss';
    var buttonTestId = testId && "".concat(testId, "-dismiss");
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($71r6p))) : (0, (/*@__PURE__*/$parcel$interopDefault($h19KG)));
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        buttonTestId = testId && "".concat(testId, "-toggle");
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5yfDB.default), {
        icon: function icon(iconProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(ButtonIcon, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, iconProps, {
                size: "small",
                label: "",
                color: (0, $ekUFP.flagTextColorToken)[appearance]
            }));
        },
        appearance: "subtle",
        spacing: "compact",
        label: buttonLabel,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    });
};
var $cd0c6d881b0b09b3$var$DismissButton = /*#__PURE__*/ (0, $5FkrB.memo)($cd0c6d881b0b09b3$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cd0c6d881b0b09b3$export$2e2bcd8739ae039 = $cd0c6d881b0b09b3$var$DismissButton;

});
parcelRegister("71r6p", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd264112f4a6872d04b33e03dd95c892>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $51cda659fee75760$var$_react = $51cda659fee75760$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $51cda659fee75760$var$_iconNew = $51cda659fee75760$var$_interopRequireDefault((parcelRequire("gDzom")));
function $51cda659fee75760$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-up
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $51cda659fee75760$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $51cda659fee75760$var$_react.default.createElement($51cda659fee75760$var$_iconNew.default, Object.assign({
        name: "ChevronUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
$51cda659fee75760$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $51cda659fee75760$var$_default = module.exports.default = $51cda659fee75760$var$ChevronUpIcon;

});


parcelRegister("cHmLx", function(module, exports) {
$parcel$export(module.exports, "default", () => $93eb290032b021bc$export$2e2bcd8739ae039);
/* expander.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");


var $hRJ5R = parcelRequire("hRJ5R");

var $9Et5g = parcelRequire("9Et5g");

var $7ujRa = parcelRequire("7ujRa");

var $50U6m = parcelRequire("50U6m");

var $auVZV = parcelRequire("auVZV");
var $9FlpM = parcelRequire("9FlpM");
var $93eb290032b021bc$var$styles = {
    expander: "_1bsb1osq",
    expanderTransition: "_k8m0wor5 _1oec1mzy _156yru3m",
    expanderCollapsed: "_1reo15vq _18m915vq",
    container: "_v5641xzp"
};
var $93eb290032b021bc$var$Expander = function Expander(_ref) {
    var children = _ref.children, isExpanded = _ref.isExpanded, testId = _ref.testId;
    var isCollapseAnimationEnabled = (0, $50U6m.fg)('platform-dst-flag-collapse-animation-fix');
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ $5FkrB.createElement((0, $auVZV.Box), {
        xcss: (0, $hRJ5R.cx)($93eb290032b021bc$var$styles.expander, isCollapseAnimationEnabled && $93eb290032b021bc$var$styles.expanderTransition, isCollapseAnimationEnabled && !isExpanded && $93eb290032b021bc$var$styles.expanderCollapsed),
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && "".concat(testId, "-expander")
    }, /*#__PURE__*/ $5FkrB.createElement((0, $9Et5g.default), {
        appear: true
    }, isExpanded && /*#__PURE__*/ $5FkrB.createElement((0, $7ujRa.default), null, function(props) {
        return /*#__PURE__*/ $5FkrB.createElement((0, $auVZV.Box), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            xcss: (0, $hRJ5R.cx)(!isCollapseAnimationEnabled && $93eb290032b021bc$var$styles.container)
        }, props), /*#__PURE__*/ $5FkrB.createElement((0, $9FlpM.Stack), {
            space: "space.100"
        }, children));
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$93eb290032b021bc$export$2e2bcd8739ae039 = $93eb290032b021bc$var$Expander;

});
parcelRegister("9Et5g", function(module, exports) {
$parcel$export(module.exports, "ExitingContext", () => $706e68f369439541$export$b9c4904d7a6929e6);
$parcel$export(module.exports, "default", () => $706e68f369439541$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $50U6m = parcelRequire("50U6m");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $706e68f369439541$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isInsideExitingPersistence: false,
    isExiting: false
};
var $706e68f369439541$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $5FkrB.createContext)($706e68f369439541$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $706e68f369439541$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $706e68f369439541$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($706e68f369439541$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $706e68f369439541$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $706e68f369439541$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $706e68f369439541$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $706e68f369439541$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $706e68f369439541$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $706e68f369439541$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false,
            isInsideExitingPersistence: true
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false,
            isInsideExitingPersistence: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $706e68f369439541$var$childrenToArray(previousChildren);
    var current = $706e68f369439541$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var nextChildren = currentChildren !== children ? $706e68f369439541$var$childrenToArray(children) : current;
    var missingKeys = $706e68f369439541$var$getMissingKeys(nextChildren, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $706e68f369439541$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $50U6m.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $706e68f369439541$var$wrapChildWithContextProvider(child, {
            appear: true,
            isInsideExitingPersistence: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $706e68f369439541$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$706e68f369439541$export$2e2bcd8739ae039 = $706e68f369439541$var$ExitingPersistence;
$706e68f369439541$var$ExitingPersistence.displayName = 'ExitingPersistence';

});

parcelRegister("7ujRa", function(module, exports) {
$parcel$export(module.exports, "default", () => $573abcdb18932d22$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $7RWCv = parcelRequire("7RWCv");
var $573abcdb18932d22$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $573abcdb18932d22$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $573abcdb18932d22$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7RWCv.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $573abcdb18932d22$export$2e2bcd8739ae039 = $573abcdb18932d22$var$FadeIn;

});
parcelRegister("7RWCv", function(module, exports) {
$parcel$export(module.exports, "default", () => $5baaf4612228c082$export$2e2bcd8739ae039);
/* keyframes-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $VfFcJ = parcelRequire("VfFcJ");

var $6NPoI = parcelRequire("6NPoI");

var $9TyD0 = parcelRequire("9TyD0");

var $UpTAg = parcelRequire("UpTAg");

var $dZoDs = parcelRequire("dZoDs");

var $b2MTI = parcelRequire("b2MTI");
var $5baaf4612228c082$var$zoomIn = null;
var $5baaf4612228c082$var$zoomOut = null;
var $5baaf4612228c082$var$fadeIn = null;
var $5baaf4612228c082$var$fadeOut = null;
var $5baaf4612228c082$var$fadeInFromTop = null;
var $5baaf4612228c082$var$fadeOutFromTop = null;
var $5baaf4612228c082$var$fadeInFromLeft = null;
var $5baaf4612228c082$var$fadeOutFromLeft = null;
var $5baaf4612228c082$var$fadeInFromBottom = null;
var $5baaf4612228c082$var$fadeOutFromBottom = null;
var $5baaf4612228c082$var$fadeInFromRight = null;
var $5baaf4612228c082$var$fadeOutFromRight = null;
var $5baaf4612228c082$var$fadeInFromTopConstant = null;
var $5baaf4612228c082$var$fadeOutFromTopConstant = null;
var $5baaf4612228c082$var$fadeInFromLeftConstant = null;
var $5baaf4612228c082$var$fadeOutFromLeftConstant = null;
var $5baaf4612228c082$var$fadeInFromBottomConstant = null;
var $5baaf4612228c082$var$fadeOutFromBottomConstant = null;
var $5baaf4612228c082$var$fadeInFromRightConstant = null;
var $5baaf4612228c082$var$fadeOutFromRightConstant = null;
var $5baaf4612228c082$var$slideInFromTop = null;
var $5baaf4612228c082$var$slideOutFromTop = null;
var $5baaf4612228c082$var$slideInFromRight = null;
var $5baaf4612228c082$var$slideOutFromRight = null;
var $5baaf4612228c082$var$slideInFromBottom = null;
var $5baaf4612228c082$var$slideOutFromBottom = null;
var $5baaf4612228c082$var$slideInFromLeft = null;
var $5baaf4612228c082$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $5baaf4612228c082$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $b2MTI.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $dZoDs.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $UpTAg.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $5FkrB.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $9TyD0.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $6NPoI.exitingDurations)[duration] : (0, $VfFcJ.durations)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $970q7.default)([
            (0, $970q7.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $970q7.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $970q7.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $970q7.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $970q7.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $970q7.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $970q7.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $970q7.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $970q7.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $970q7.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $970q7.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $970q7.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $970q7.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $970q7.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $970q7.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $970q7.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $970q7.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $970q7.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $970q7.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $970q7.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $970q7.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $970q7.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $970q7.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $970q7.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $970q7.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $970q7.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $970q7.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $970q7.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $970q7.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $970q7.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $970q7.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $970q7.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $970q7.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $970q7.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $970q7.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $970q7.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $970q7.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $970q7.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $970q7.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $970q7.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $970q7.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $970q7.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $970q7.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $970q7.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $970q7.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $970q7.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $970q7.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $970q7.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $970q7.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $970q7.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $970q7.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $5baaf4612228c082$export$2e2bcd8739ae039 = $5baaf4612228c082$var$EnteringMotion;

});
parcelRegister("VfFcJ", function(module, exports) {
$parcel$export(module.exports, "durations", () => $0ac17972b568e600$export$38b928a7167ce124);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $0ac17972b568e600$export$368bacef0dacbe05 = 25;
var $0ac17972b568e600$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};

});

parcelRegister("6NPoI", function(module, exports) {
$parcel$export(module.exports, "exitingDurations", () => $4f3f30288deccd1e$export$30fa1a2e62ae150c);

var $VfFcJ = parcelRequire("VfFcJ");
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $4f3f30288deccd1e$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $4f3f30288deccd1e$export$30fa1a2e62ae150c = {
    none: (0, $VfFcJ.durations).none,
    small: (0, $VfFcJ.durations).small * $4f3f30288deccd1e$var$EXITING_MOTION_MULTIPLIER,
    medium: (0, $VfFcJ.durations).medium * $4f3f30288deccd1e$var$EXITING_MOTION_MULTIPLIER,
    large: (0, $VfFcJ.durations).large * $4f3f30288deccd1e$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("9TyD0", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $73441c8981523377$export$b7baf7667a68d87c);

var $jIcxg = parcelRequire("jIcxg");
var $73441c8981523377$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!(0, $jIcxg.isMatchMediaAvailable)()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};

});
parcelRegister("jIcxg", function(module, exports) {
$parcel$export(module.exports, "isMatchMediaAvailable", () => $e59bd9b1823e1e4f$export$c5406bd59b374abd);
var $e59bd9b1823e1e4f$export$c5406bd59b374abd = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};

});


parcelRegister("UpTAg", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", () => $0a9951631de89842$export$4f34107a2b00f39c);

var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $0a9951631de89842$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $0a9951631de89842$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $0a9951631de89842$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("dZoDs", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $a2f414f465ca2877$export$3b6f38abbdcbd000);

var $5FkrB = parcelRequire("5FkrB");

var $9Et5g = parcelRequire("9Et5g");
var $a2f414f465ca2877$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)((0, $9Et5g.ExitingContext));
};

});

parcelRegister("b2MTI", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $80a5cfaa5c252cb1$export$25c7213fc07ec080);

var $5FkrB = parcelRequire("5FkrB");

var $ile2D = parcelRequire("ile2D");

var $k0MSS = parcelRequire("k0MSS");
var $80a5cfaa5c252cb1$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var identifier = (0, $ile2D.useUniqueId)();
    var context = (0, $5FkrB.useContext)((0, $k0MSS.StaggeredEntranceContext));
    return context(identifier);
};

});
parcelRegister("ile2D", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $d5a5147f99037ecf$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $d5a5147f99037ecf$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});

parcelRegister("k0MSS", function(module, exports) {
$parcel$export(module.exports, "StaggeredEntranceContext", () => $e919ba1527cc5d5b$export$5e65d7d58ae96ad8);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");

var $TkNEP = parcelRequire("TkNEP");
var $e919ba1527cc5d5b$export$5e65d7d58ae96ad8 = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $eVb4V.default)
    };
});
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $e919ba1527cc5d5b$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $TkNEP.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($e919ba1527cc5d5b$export$5e65d7d58ae96ad8.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$e919ba1527cc5d5b$export$2e2bcd8739ae039 = $e919ba1527cc5d5b$var$StaggeredEntrance;

});
parcelRegister("TkNEP", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $0a654599dda37512$export$e5c5a5f917a5871c);

var $5FkrB = parcelRequire("5FkrB");
var $0a654599dda37512$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);

});






parcelRegister("3wlgk", function(module, exports) {
$parcel$export(module.exports, "useFlagGroup", () => $2904da89f622f952$export$e91ea202abb66350);

var $5FkrB = parcelRequire("5FkrB");

var $cC68N = parcelRequire("cC68N");
function $2904da89f622f952$export$e91ea202abb66350() {
    return (0, $5FkrB.useContext)((0, $cC68N.FlagGroupContext));
}

});
parcelRegister("cC68N", function(module, exports) {
$parcel$export(module.exports, "FlagGroupContext", () => $92edcc1c07273ac9$export$c57ba665aaa722be);

var $5FkrB = parcelRequire("5FkrB");

var $lyDdh = parcelRequire("lyDdh");
var $92edcc1c07273ac9$export$c57ba665aaa722be = /*#__PURE__*/ (0, $5FkrB.createContext)((0, $lyDdh.defaultFlagGroupContext));

});
parcelRegister("lyDdh", function(module, exports) {
$parcel$export(module.exports, "defaultFlagGroupContext", () => $fb1b30df0e85c6b8$export$643760c4938da30d);

var $eVb4V = parcelRequire("eVb4V");
var $fb1b30df0e85c6b8$export$643760c4938da30d = {
    onDismissed: (0, $eVb4V.default),
    isDismissAllowed: false
};

});





parcelRegister("j5ILV", function(module, exports) {
$parcel$export(module.exports, "default", () => $de6136be995014ab$export$2e2bcd8739ae039);
/* flag-group.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $7QpUe = parcelRequire("7QpUe");

var $bDUuG = parcelRequire("bDUuG");

var $lFhdZ = parcelRequire("lFhdZ");

var $hRJ5R = parcelRequire("hRJ5R");

var $eVb4V = parcelRequire("eVb4V");

var $aAQBJ = parcelRequire("aAQBJ");

var $9Et5g = parcelRequire("9Et5g");

var $8NeeD = parcelRequire("8NeeD");

var $50U6m = parcelRequire("50U6m");

var $fV8Mu = parcelRequire("fV8Mu");

var $auVZV = parcelRequire("auVZV");

var $64A04 = parcelRequire("64A04");

var $bVYhO = parcelRequire("bVYhO");

var $e8kqY = parcelRequire("e8kqY");

var $lyDdh = parcelRequire("lyDdh");

var $cC68N = parcelRequire("cC68N");


// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
var $de6136be995014ab$var$groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
};
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
var $de6136be995014ab$var$groupStylesNew = {
    root: "_v564t8bh _kqswstnw _u7coidpf _1bsb1kdj _1eqkauwl",
    first: "_t9ec1ygq _1pbyqfx8",
    second: "_t9ec1pi4 _1pbyegat",
    nth: "_t9ec15wd",
    hidden: "_3um015vq"
};
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
var $de6136be995014ab$var$dismissAllowedStyles = null;
var $de6136be995014ab$var$flagGroupContainerStyles = null;
// When rendering in top layer, z-index is redundant (top layer stacks above everything).
// Override to avoid leaving an explicit z-index on the container.
var $de6136be995014ab$var$flagGroupContainerStylesTopLayer = null;
// cc_mohiti_flag_anchoring: update left inset from space.1000 (80px) to space.600 (48px)
// to match the bottom inset and produce a symmetric 48px × 48px anchor.
// The 80px left offset was a legacy artefact from the old left-rail nav sidebar.
// The mobile reset is mirrored from the base style so the override is self-contained
// and doesn't depend on @compiled's atomic CSS emit order at the ≤560px breakpoint.
var $de6136be995014ab$var$flagGroupContainerStylesSymmetric = null;
var $de6136be995014ab$export$a2c3479950310d7d = function FlagGroup(props) {
    var id = props.id, _props$label = props.label, label = _props$label === void 0 ? 'Flag notifications' : _props$label, _props$labelTag = props.labelTag, LabelTag = _props$labelTag === void 0 ? 'h2' : _props$labelTag, _props$shouldRenderTo = props.shouldRenderToParent, shouldRenderToParent = _props$shouldRenderTo === void 0 ? false : _props$shouldRenderTo, children = props.children, _props$onDismissed = props.onDismissed, onDismissed = _props$onDismissed === void 0 ? (0, $eVb4V.default) : _props$onDismissed;
    var hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    var dismissFlagContext = (0, $5FkrB.useMemo)(function() {
        return {
            onDismissed: onDismissed,
            isDismissAllowed: true
        };
    }, [
        onDismissed
    ]);
    // Keep a stable reference to the latest children, dismiss handler, and
    // analytics creator so the keydown listener never reads stale closures.
    var _useAnalyticsEvents = (0, $bDUuG.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var latestRef = (0, $5FkrB.useRef)({
        children: children,
        onDismissed: onDismissed,
        createAnalyticsEvent: createAnalyticsEvent
    });
    latestRef.current = {
        children: children,
        onDismissed: onDismissed,
        createAnalyticsEvent: createAnalyticsEvent
    };
    // Accessibility (JRACLOUD-97876): allow keyboard-only and assistive
    // technology users to dismiss the topmost (and only dismissable) flag with
    // the Escape key, without having to tab through the entire page to reach
    // the dismiss button. Behaviour is gated behind a feature flag so it can
    // be rolled out and validated incrementally.
    (0, $5FkrB.useEffect)(function() {
        if (!(0, $50U6m.fg)('platform_dst_flag_keyboard_dismiss')) return;
        if (!hasFlags) return;
        var doc = (0, $lFhdZ.getDocument)();
        if (!doc) return;
        var timeoutIds = new Set();
        var unbind = (0, $7QpUe.bind)(doc, {
            type: 'keydown',
            listener: function listener(event) {
                var _props;
                if (event.key !== 'Escape' || event.defaultPrevented) return;
                var currentChildren = latestRef.current.children;
                var firstFlag = Array.isArray(currentChildren) ? currentChildren.find(Boolean) : currentChildren;
                if (!firstFlag || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(firstFlag) !== 'object') return;
                var id = (_props = firstFlag.props) === null || _props === void 0 ? void 0 : _props.id;
                if (id === undefined || id === null || id === '') return;
                var analyticsEvent = latestRef.current.createAnalyticsEvent({
                    action: 'dismissed',
                    actionSubject: 'flag',
                    attributes: {
                        dismissedVia: 'keyboardShortcut',
                        key: 'Escape'
                    }
                });
                var timeoutId = setTimeout(function() {
                    var _latestRef$current$on, _latestRef$current;
                    timeoutIds.delete(timeoutId);
                    if (event.defaultPrevented) return;
                    event.preventDefault();
                    (_latestRef$current$on = (_latestRef$current = latestRef.current).onDismissed) === null || _latestRef$current$on === void 0 || _latestRef$current$on.call(_latestRef$current, id, analyticsEvent);
                });
                timeoutIds.add(timeoutId);
            },
            options: {
                capture: true
            }
        });
        return function() {
            unbind();
            timeoutIds.forEach(clearTimeout);
            timeoutIds.clear();
        };
    }, [
        hasFlags
    ]);
    var renderChildren = function renderChildren() {
        return children && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(children) === 'object' ? (0, $5FkrB.Children).map(children, function(flag, index) {
            var isDismissAllowed = index === 0;
            return (0, $50U6m.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ $5FkrB.createElement((0, $auVZV.Box), {
                xcss: (0, $hRJ5R.cx)($de6136be995014ab$var$groupStylesNew.root, index === 0 && $de6136be995014ab$var$groupStylesNew.first, index === 1 && $de6136be995014ab$var$groupStylesNew.second, index >= 2 && $de6136be995014ab$var$groupStylesNew.nth, index >= 3 && $de6136be995014ab$var$groupStylesNew.hidden),
                "data-vc-oob": true
            }, /*#__PURE__*/ $5FkrB.createElement((0, $aAQBJ.default), {
                enteringAnimation: "var(--ds-flag-enter, 250ms cubic-bezier(0, 0.4, 0, 1) SlideIn50PercentLeft, 250ms cubic-bezier(0, 0.4, 0, 1) FadeIn0to100)",
                exitingAnimation: "var(--ds-flag-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOut15PercentLeft, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
            }, /*#__PURE__*/ $5FkrB.createElement((0, $cC68N.FlagGroupContext).Provider, {
                value: // Only the first flag should be able to be dismissed.
                isDismissAllowed ? dismissFlagContext : (0, $lyDdh.defaultFlagGroupContext)
            }, flag))) : /*#__PURE__*/ $5FkrB.createElement((0, $8NeeD.default), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in"
            }, function(_ref) {
                var className = _ref.className, ref = _ref.ref;
                return /*#__PURE__*/ $5FkrB.createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $970q7.default)([
                        $de6136be995014ab$var$groupStyles.root,
                        index === 0 && $de6136be995014ab$var$groupStyles.first,
                        index === 1 && $de6136be995014ab$var$groupStyles.second,
                        index >= 1 && $de6136be995014ab$var$groupStyles.nth,
                        index >= 2 && $de6136be995014ab$var$groupStyles.hidden,
                        isDismissAllowed && "_12a7luct",
                        className
                    ]),
                    ref: ref,
                    "data-vc-oob": true
                }, /*#__PURE__*/ $5FkrB.createElement((0, $cC68N.FlagGroupContext).Provider, {
                    value: // Only the first flag should be able to be dismissed.
                    isDismissAllowed ? dismissFlagContext : (0, $lyDdh.defaultFlagGroupContext)
                }, flag));
            });
        }) : false;
    };
    var useTopLayer = (0, $50U6m.fg)('platform-dst-top-layer');
    var useSymmetricAnchor = (0, $50U6m.fg)('cc_mohiti_flag_anchoring');
    var isKeyboardDismissEnabled = (0, $50U6m.fg)('platform_dst_flag_keyboard_dismiss');
    // When the keyboard dismiss shortcut is available, surface it to assistive
    // technology users via the existing visually-hidden landmark heading so they
    // know they can press Escape to dismiss the topmost flag.
    var screenReaderLabel = isKeyboardDismissEnabled ? "".concat(label, ". Press Escape to dismiss.") : label;
    var flags = /*#__PURE__*/ $5FkrB.createElement("div", {
        id: id,
        "data-vc-oob": true,
        className: (0, $970q7.default)([
            "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf",
            useTopLayer && "_1pby1wug",
            useSymmetricAnchor && "_1e02oahv _il0widpf"
        ])
    }, hasFlags ? /*#__PURE__*/ $5FkrB.createElement((0, $e8kqY.default), null, /*#__PURE__*/ $5FkrB.createElement(LabelTag, null, screenReaderLabel)) : null, /*#__PURE__*/ $5FkrB.createElement((0, $9Et5g.default), {
        appear: false
    }, renderChildren()));
    if (useTopLayer) return /*#__PURE__*/ $5FkrB.createElement((0, $bVYhO.Popover), {
        mode: "manual",
        isOpen: true
    }, flags);
    return shouldRenderToParent ? flags : /*#__PURE__*/ $5FkrB.createElement((0, $fV8Mu.default), {
        zIndex: (0, $64A04.layers).flag()
    }, flags);
};
var /* eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /**
 * @deprecated Use `import { FlagGroup } from '@atlaskit/flag/flag-group'` instead.
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports -- VOLTC-139 tracks removal of this deprecated default export shim.
$de6136be995014ab$export$2e2bcd8739ae039 = $de6136be995014ab$export$a2c3479950310d7d;

});
parcelRegister("aAQBJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b6612ee838e16de$export$2e2bcd8739ae039);
/* motion.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $hRJ5R = parcelRequire("hRJ5R");

var $iO8GM = parcelRequire("iO8GM");

var $50U6m = parcelRequire("50U6m");

var $fcYqT = parcelRequire("fcYqT");

var $keCPA = parcelRequire("keCPA");

var $9TyD0 = parcelRequire("9TyD0");

var $9rIHj = parcelRequire("9rIHj");

var $j9KvQ = parcelRequire("j9KvQ");

var $dZoDs = parcelRequire("dZoDs");

var $hTJcq = parcelRequire("hTJcq");

var $b2MTI = parcelRequire("b2MTI");
function $7b6612ee838e16de$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7b6612ee838e16de$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7b6612ee838e16de$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7b6612ee838e16de$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7b6612ee838e16de$var$styles = {
    base: "_1y0co91m _1bumglyw _sedtglyw",
    hidden: "_3um015vq"
};
/**
 * Legacy implementation of `Motion` that inlines the animation lifecycle.
 * Used when the `platform-dst-use-motion` feature gate is off.
 */ var $7b6612ee838e16de$var$MotionLegacy = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, enteringAnimation = _ref.enteringAnimation, enteringAnimationXcss = _ref.enteringAnimationXcss, exitingAnimation = _ref.exitingAnimation, exitingAnimationXcss = _ref.exitingAnimationXcss, onFinishMotion = _ref.onFinish, xcss = _ref.xcss, styleProp = _ref.style, testId = _ref.testId;
    var staggered = (0, $b2MTI.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $dZoDs.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var staggeredDelay = isExiting ? 0 : staggered.delay;
    var staggedIsReady = staggered.isReady;
    var _useState = (0, $5FkrB.useState)(appear ? staggedIsReady && !staggeredDelay ? 'entering' : 'init' : 'idle'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var elementRef = (0, $5FkrB.useRef)(null);
    var reanimateRef = (0, $5FkrB.useRef)();
    var animationRef = (0, $5FkrB.useRef)();
    var staggeredEntryRef = (0, $5FkrB.useRef)();
    (0, $5FkrB.useEffect)(function() {
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]);
    // Handles staggered entry
    (0, $5FkrB.useEffect)(function() {
        if (state !== 'init') return;
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(function() {
            setState('entering');
        }, staggeredDelay);
        return function() {
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        state,
        staggedIsReady,
        staggeredDelay
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ var onAnimationEnd = (0, $5FkrB.useCallback)(function(state, cancelled) {
        // We are done animating, so we set the state to idle
        var newState = 'idle';
        if (state === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('exiting');
        }
        if (state === 'entering') onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('entering');
        if (reanimateRef.current === (0, $j9KvQ.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $j9KvQ.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (!staggedIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is idle or init, we don't need to do anything
        if (state === 'idle' || state === 'init') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if ((0, $9TyD0.isReducedMotion)() || !exitingAnimation && !exitingAnimationXcss) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        var animationDuration = 0;
        if (state === 'entering' || state === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    var animationTimings = (0, $keCPA.getDurationMs)((0, $9rIHj.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    var _styles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $fcYqT.getComputedAnimationDurationMs)(_styles.animationName, _styles.animationDuration, _styles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting' && (exitingAnimation || exitingAnimationXcss)) animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration);
        else if (state === 'entering' && (enteringAnimation || enteringAnimationXcss)) animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration);
        return function() {
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        exitingAnimation,
        enteringAnimation,
        exitingAnimationXcss,
        enteringAnimationXcss,
        staggeredDelay,
        staggedIsReady
    ]);
    (0, $5FkrB.useImperativeHandle)(ref, function() {
        return {
            reanimate: function reanimate(value) {
                animationRef.current && clearTimeout(animationRef.current);
                reanimateRef.current = value;
                if (value === (0, $j9KvQ.Reanimate).exit_then_enter) setState('exiting');
                else if (value === (0, $j9KvQ.Reanimate).enter) setState('entering');
            }
        };
    });
    var style = {};
    var customAnimation;
    if (state === 'entering') {
        if (enteringAnimation) style.animation = enteringAnimation;
        else if (enteringAnimationXcss) customAnimation = enteringAnimationXcss;
    } else if (state === 'exiting') {
        if (exitingAnimation) style.animation = exitingAnimation;
        else if (exitingAnimationXcss) customAnimation = exitingAnimationXcss;
    }
    var hasAnimationStyles = state !== 'idle' && state !== 'init';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            hasAnimationStyles && $7b6612ee838e16de$var$styles.base,
            state === 'init' && $7b6612ee838e16de$var$styles.hidden,
            (0, $hRJ5R.cx)(xcss, customAnimation)
        ]),
        ref: (0, $iO8GM.default)([
            staggered.ref,
            elementRef
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: styleProp || hasAnimationStyles ? $7b6612ee838e16de$var$_objectSpread($7b6612ee838e16de$var$_objectSpread({}, styleProp), style) : undefined,
        "data-testid": testId
    }, children);
});
/**
 * Implementation of `Motion` built on top of the `useMotion` hook.
 * Used when the `platform-dst-use-motion` feature gate is on.
 */ var $7b6612ee838e16de$var$MotionNext = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var children = _ref2.children, enteringAnimation = _ref2.enteringAnimation, enteringAnimationXcss = _ref2.enteringAnimationXcss, exitingAnimation = _ref2.exitingAnimation, exitingAnimationXcss = _ref2.exitingAnimationXcss, onFinishMotion = _ref2.onFinish, xcss = _ref2.xcss, styleProp = _ref2.style, testId = _ref2.testId;
    var _useMotion = (0, $hTJcq.useMotion)({
        onFinish: onFinishMotion
    }), state = _useMotion.state, motionRef = _useMotion.ref, reanimate = _useMotion.reanimate;
    (0, $5FkrB.useImperativeHandle)(ref, function() {
        return {
            reanimate: reanimate
        };
    }, [
        reanimate
    ]);
    // `xcss` and `style` apply to the wrapper `<div>` the `Motion` component renders,
    // so they are merged here (not in the hook) alongside the hook's animation output.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            state === 'init' && $7b6612ee838e16de$var$styles.hidden,
            (0, $hRJ5R.cx)(xcss, state === 'entering' && enteringAnimationXcss, state === 'exiting' && exitingAnimationXcss)
        ]),
        ref: motionRef,
        style: $7b6612ee838e16de$var$_objectSpread($7b6612ee838e16de$var$_objectSpread({}, styleProp), {}, {
            animation: state === 'entering' ? enteringAnimation : state === 'exiting' ? exitingAnimation : undefined
        }),
        "data-testid": testId
    }, children);
});
/**
 * __Motion__
 *
 * A motion primitive that can be used to animate the entry and exit of components.
 */ var $7b6612ee838e16de$var$Motion = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    if ((0, $50U6m.fg)('platform-dst-use-motion')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($7b6612ee838e16de$var$MotionNext, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        ref: ref
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($7b6612ee838e16de$var$MotionLegacy, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        ref: ref
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$7b6612ee838e16de$export$2e2bcd8739ae039 = $7b6612ee838e16de$var$Motion;

});
parcelRegister("fcYqT", function(module, exports) {
$parcel$export(module.exports, "getComputedAnimationDurationMs", () => $b126dab730f1bae8$export$dd9b73a7482d05b6);

var $eAVz7 = parcelRequire("eAVz7");
var $b126dab730f1bae8$var$cssTimePattern = /^-?(?:\d+\.?\d*|\.\d+)(?:ms|s)$/;
var $b126dab730f1bae8$var$toCssList = function toCssList(value) {
    return value.split(',').map(function(item) {
        return item.trim();
    }).filter(Boolean);
};
var $b126dab730f1bae8$var$toTimeList = function toTimeList(value) {
    return $b126dab730f1bae8$var$toCssList(value).filter(function(time) {
        return $b126dab730f1bae8$var$cssTimePattern.test(time);
    }).map((0, $eAVz7.convertToMs));
};
var $b126dab730f1bae8$export$dd9b73a7482d05b6 = function getComputedAnimationDurationMs(animationName, animationDuration, animationDelay) {
    var names = $b126dab730f1bae8$var$toCssList(animationName);
    var durations = $b126dab730f1bae8$var$toTimeList(animationDuration);
    var delays = $b126dab730f1bae8$var$toTimeList(animationDelay);
    if (names.length === 0 || durations.length === 0) return 0;
    var longestDuration = 0;
    for(var index = 0; index < names.length; index++){
        if (names[index] === 'none') continue;
        var duration = durations[index % durations.length];
        var delay = delays.length > 0 ? delays[index % delays.length] : 0;
        longestDuration = Math.max(longestDuration, duration + delay);
    }
    return longestDuration;
};

});
parcelRegister("eAVz7", function(module, exports) {
$parcel$export(module.exports, "convertToMs", () => $aa0114c7b8a666c5$export$75eee42ff540d8ae);
var $aa0114c7b8a666c5$export$75eee42ff540d8ae = function convertToMs(duration) {
    // Use regex to separate the number and the unit
    var matches = duration.match(/^(-?(?:\d+\.?\d*|\.\d+))(s|ms)$/);
    if (!matches) return 0; // Or return for invalid format
    var value = parseFloat(matches[1]);
    var unit = matches[2];
    if (unit === 's') return value * 1000; // Convert seconds to milliseconds
    else return value; // Already in milliseconds
};

});


parcelRegister("keCPA", function(module, exports) {
$parcel$export(module.exports, "getDurationMs", () => $ebb33c82d6a74d8b$export$d0038b6e47881463);

var $fC8ib = parcelRequire("fC8ib");
var $ebb33c82d6a74d8b$export$d0038b6e47881463 = function getDurationMs(animation) {
    var animations = animation.split(/,(?![^()]*\))/).map(function(value) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(value.trim().matchAll(/(-?\d*\.?\d+)(ms|s)\b/g));
    }).filter(function(matches) {
        return matches.length > 0;
    });
    if (animations.length === 0) return {
        duration: 0,
        delay: 0
    };
    return animations.reduce(function(longest, matches) {
        var toMilliseconds = function toMilliseconds(match) {
            var value = parseFloat(match[1]);
            return match[2] === 's' ? value * 1000 : value;
        };
        var timing = {
            duration: toMilliseconds(matches[0]),
            delay: matches[1] ? toMilliseconds(matches[1]) : 0
        };
        return timing.duration + timing.delay > longest.duration + longest.delay ? timing : longest;
    }, {
        duration: 0,
        delay: 0
    });
};

});

parcelRegister("9rIHj", function(module, exports) {
$parcel$export(module.exports, "resolveMotionToken", () => $6e094eb37feb5542$export$82b92541889a035d);

var $lFhdZ = parcelRequire("lFhdZ");
var $6e094eb37feb5542$export$82b92541889a035d = function resolveMotionToken(token) {
    var cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    var cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        var _getDocument;
        var documentElement = (_getDocument = (0, $lFhdZ.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};

});

parcelRegister("j9KvQ", function(module, exports) {
$parcel$export(module.exports, "Reanimate", () => $df22f00bc829feba$export$569340a66b14e0dc);
/**
 * Supported reanimate values.
 * 'enter' will re-enter the animation.
 * 'exit-then-enter' will exit the animation and then enter it again.
 */ var $df22f00bc829feba$export$569340a66b14e0dc = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    Reanimate["exit"] = "exit";
    return Reanimate;
}({});

});

parcelRegister("hTJcq", function(module, exports) {
$parcel$export(module.exports, "useMotion", () => $d07aa260cd838004$export$2a51cfe9390d36ef);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $iO8GM = parcelRequire("iO8GM");

var $fcYqT = parcelRequire("fcYqT");

var $keCPA = parcelRequire("keCPA");

var $9TyD0 = parcelRequire("9TyD0");

var $TkNEP = parcelRequire("TkNEP");

var $9rIHj = parcelRequire("9rIHj");

var $j9KvQ = parcelRequire("j9KvQ");

var $dZoDs = parcelRequire("dZoDs");

var $b2MTI = parcelRequire("b2MTI");
function $d07aa260cd838004$export$2a51cfe9390d36ef() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, onFinishMotion = _ref.onFinish, onStartMotion = _ref.onStart, initialState = _ref.initialState;
    var reducedMotion = (0, $9TyD0.isReducedMotion)();
    var staggered = (0, $b2MTI.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $dZoDs.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var staggeredDelay = isExiting ? 0 : staggered.delay;
    var staggeredIsReady = staggered.isReady;
    var _useState = (0, $5FkrB.useState)(initialState !== null && initialState !== void 0 ? initialState : appear ? staggeredIsReady && !staggeredDelay ? 'entering' : 'init' : 'visible'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    // ExitingPersistence must win during render so consumers apply exit styles before layout effects.
    // The lifecycle effect below uses the same value to measure and finish that exit.
    var motionState = isExiting ? 'exiting' : state;
    var elementRef = (0, $5FkrB.useRef)(null);
    var onStartMotionRef = (0, $5FkrB.useRef)(onStartMotion);
    onStartMotionRef.current = onStartMotion;
    var reanimateRef = (0, $5FkrB.useRef)();
    var animationRef = (0, $5FkrB.useRef)();
    var staggeredEntryRef = (0, $5FkrB.useRef)();
    (0, $TkNEP.useLayoutEffect)(function() {
        if (motionState === 'exiting') {
            var _onStartMotionRef$cur;
            (_onStartMotionRef$cur = onStartMotionRef.current) === null || _onStartMotionRef$cur === void 0 || _onStartMotionRef$cur.call(onStartMotionRef, 'exiting');
        }
        if (motionState === 'entering') {
            var _onStartMotionRef$cur2;
            (_onStartMotionRef$cur2 = onStartMotionRef.current) === null || _onStartMotionRef$cur2 === void 0 || _onStartMotionRef$cur2.call(onStartMotionRef, 'entering');
        }
    }, [
        motionState
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ var onAnimationEnd = (0, $5FkrB.useCallback)(function(currentState, cancelled) {
        // We are done animating, so we set the state to visible
        var newState = 'visible';
        if (currentState === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('exiting');
        }
        if (currentState === 'entering') onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('entering');
        if (reanimateRef.current === (0, $j9KvQ.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $j9KvQ.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current === (0, $j9KvQ.Reanimate).enter) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        else if (reanimateRef.current === (0, $j9KvQ.Reanimate).exit) {
            // We are done reanimating, so we clear the reanimate state
            reanimateRef.current = undefined;
            newState = 'hidden';
        }
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    // Handles staggered entry
    (0, $5FkrB.useEffect)(function() {
        if (state !== 'init') return;
        if (reducedMotion) {
            onAnimationEnd('entering', false);
            return;
        }
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(function() {
            setState('entering');
        }, staggeredDelay);
        return function() {
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        onAnimationEnd,
        state,
        staggeredIsReady,
        staggeredDelay,
        reducedMotion
    ]);
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (!staggeredIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is visible, hidden or init, we don't need to do anything
        if (motionState === 'visible' || motionState === 'init' || motionState === 'hidden') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if (reducedMotion) {
            onAnimationEnd(motionState, isCancelled);
            return;
        }
        var animationDuration = 0;
        if (motionState === 'entering' || motionState === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    var animationTimings = (0, $keCPA.getDurationMs)((0, $9rIHj.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    var computedStyles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $fcYqT.getComputedAnimationDurationMs)(computedStyles.animationName, computedStyles.animationDuration, computedStyles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (motionState === 'exiting') animationRef.current = setTimeout(function() {
            return onAnimationEnd(motionState, isCancelled);
        }, animationDuration);
        else if (motionState === 'entering') animationRef.current = setTimeout(function() {
            return onAnimationEnd(motionState, isCancelled);
        }, animationDuration);
        return function() {
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        motionState,
        appear,
        staggeredDelay,
        staggeredIsReady,
        reducedMotion
    ]);
    var reanimate = (0, $5FkrB.useCallback)(function(value) {
        animationRef.current && clearTimeout(animationRef.current);
        reanimateRef.current = value;
        if (value === (0, $j9KvQ.Reanimate).exit_then_enter) setState('exiting');
        else if (value === (0, $j9KvQ.Reanimate).enter) setState('entering');
        else if (value === (0, $j9KvQ.Reanimate).exit) setState('exiting');
    }, []);
    var ref = (0, $5FkrB.useMemo)(function() {
        return (0, $iO8GM.default)([
            staggered.ref,
            elementRef
        ]);
    }, [
        staggered.ref
    ]);
    return {
        ref: ref,
        reanimate: reanimate,
        state: motionState
    };
}

});


parcelRegister("8NeeD", function(module, exports) {
$parcel$export(module.exports, "default", () => $666df1238ac4fb08$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $7RWCv = parcelRequire("7RWCv");
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion).
 */ var $666df1238ac4fb08$var$SlideIn = function SlideIn(_ref) {
    var children = _ref.children, enterFrom = _ref.enterFrom, exitTo = _ref.exitTo, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'medium' : _ref$duration, isPaused = _ref.isPaused, onFinish = _ref.onFinish, _ref$animationTimingF = _ref.animationTimingFunction, animationTimingFunction = _ref$animationTimingF === void 0 ? 'ease-out' : _ref$animationTimingF, _ref$animationTimingF2 = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF2 === void 0 ? 'ease-in' : _ref$animationTimingF2;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7RWCv.default), {
        duration: duration,
        enteringAnimation: "slide-in-from-".concat(enterFrom),
        exitingAnimation: "slide-out-from-".concat(exitTo || enterFrom),
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish
    }, children);
};
var $666df1238ac4fb08$export$2e2bcd8739ae039 = $666df1238ac4fb08$var$SlideIn;

});

parcelRegister("bVYhO", function(module, exports) {
$parcel$export(module.exports, "Popover", () => $8b03c82ed7bcdd6a$export$5b6b19405a83ff9d);
/* popover.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $hUFig = parcelRequire("hUFig");

var $7QpUe = parcelRequire("7QpUe");

var $iO8GM = parcelRequire("iO8GM");

var $bvsoE = parcelRequire("bvsoE");

var $iUCre = parcelRequire("iUCre");

var $3iTCp = parcelRequire("3iTCp");

var $8dRzc = parcelRequire("8dRzc");

var $fsSfs = parcelRequire("fsSfs");

var $2QJ6b = parcelRequire("2QJ6b");

var $cBDfx = parcelRequire("cBDfx");
/**
 * Native restoration only covers the first popover in an auto/hint stack, not each nested popover.
 * This fallback also supports manual popovers, which have no native restoration target.
 * See https://html.spec.whatwg.org/multipage/popover.html#show-popover (step 15.8).
 */ function $8b03c82ed7bcdd6a$var$restoreFocus(_ref) {
    var popover = _ref.popover, focusRestorationTarget = _ref.focusRestorationTarget;
    if (!focusRestorationTarget) return;
    var ownerDocument = popover.ownerDocument;
    // Native restoration has finished. Preserve focus moved outside the popover.
    var activeElementAfterClose = ownerDocument.activeElement;
    // Before close, we checked that focus was inside. Body can now mean focus was lost during close.
    if (activeElementAfterClose === ownerDocument.body || popover.contains(activeElementAfterClose)) // Match native popover restoration, which does not scroll the viewport.
    focusRestorationTarget.focus({
        preventScroll: true
    });
}
/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ var $8b03c82ed7bcdd6a$var$supportsPopoverHint = (0, $bvsoE.default)(function() {
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    var element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
// Surface reset — neutralises inherited interaction and text-layout properties
// (e.g. `pointer-events: none` from an overlaid controls container and
// `white-space: nowrap` from an `@atlaskit/select` option) that leak into a
// top-layer element because, for CSS inheritance, it is still a DOM child of its
// trigger (top-layer promotion is paint/stacking only; the legacy portal path
// avoided this by rendering at `<body>`). Excludes `color`/`font` (theming) and
// `direction`/`unicode-bidi` (RTL must inherit).
//
// Not `all: initial`: the target is what `<body>` gave the portal path, not the
// spec initial values (UA serif, black, `color-scheme: normal`), and as an author
// declaration it would also override the UA `[popover]` rules (`position: fixed`,
// `display: none` when closed).
//
// KEEP IN SYNC with the identical `surfaceResetStyles` in `dialog/dialog-content.tsx`.
// ADS forbids sharing styles across files (`no-exported-styles` /
// `no-imported-style-values` — Compiled styles are null at runtime), so the reset is
// co-located and duplicated deliberately. The `satisfies` check below fails the
// build if either copy drifts.
var $8b03c82ed7bcdd6a$var$surfaceResetStyles = {
    root: "_lcxv1wug _o5724jg8 _1nmz4jg8 _1i4q4jg8 _y3gnv2br _azhwidpf _1p1dglyw"
};
var $8b03c82ed7bcdd6a$var$styles = {
    root: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r041wug _1reoewfl _18m9ewfl _bfhk1j28 _4t3i1wug _p6861txw _51hckb7n _1yp3idpf _f5r5idpf",
    motion: "_k8m011k7 _1oecdn4k _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v179n",
    exit: "_y44vof1f"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
var $8b03c82ed7bcdd6a$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ var $8b03c82ed7bcdd6a$var$POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
var $8b03c82ed7bcdd6a$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function Popover(_ref2, ref) {
    var children = _ref2.children, _ref2$mode = _ref2.mode, modeProp = _ref2$mode === void 0 ? 'auto' : _ref2$mode, onClose = _ref2.onClose, onEnterFinish = _ref2.onEnterFinish, onExitFinish = _ref2.onExitFinish, _ref2$shouldAnimate = _ref2.shouldAnimate, shouldAnimate = _ref2$shouldAnimate === void 0 ? false : _ref2$shouldAnimate, placement = _ref2.placement, testId = _ref2.testId, isOpen = _ref2.isOpen, enteringAnimationXcss = _ref2.enteringAnimationXcss, exitingAnimationXcss = _ref2.exitingAnimationXcss, role = _ref2.role, label = _ref2.label, labelledBy = _ref2.labelledBy, idProp = _ref2.id;
    var autoId = (0, $5FkrB.useId)();
    var ownRef = (0, $5FkrB.useRef)(null);
    var combinedRef = (0, $iO8GM.default)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    var popoverId = idProp !== null && idProp !== void 0 ? idProp : "popover-".concat(autoId.replace(/:/g, ''));
    // Keep the semantic callback current without rebinding native lifecycle
    // listeners during the same commit that calls showPopover()/hidePopover().
    var onCloseRef = (0, $5FkrB.useRef)(onClose);
    (0, $5FkrB.useLayoutEffect)(function() {
        onCloseRef.current = onClose;
    }, [
        onClose
    ]);
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined.
    var handleObserverClose = (0, $5FkrB.useCallback)(function() {
        var _onCloseRef$current;
        (_onCloseRef$current = onCloseRef.current) === null || _onCloseRef$current === void 0 || _onCloseRef$current.call(onCloseRef, {
            reason: 'programmatic'
        });
    }, []);
    (0, $iUCre.useNotifyOpenLayerObserver)({
        type: role && $8b03c82ed7bcdd6a$var$POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen: isOpen,
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    var mode = modeProp === 'hint' && !$8b03c82ed7bcdd6a$var$supportsPopoverHint() ? 'auto' : modeProp;
    var popupMotionStyle = (0, $5FkrB.useMemo)(function() {
        if (!placement || !shouldAnimate) return undefined;
        var _resolvePlacement = (0, $8dRzc.resolvePlacement)({
            placement: placement
        }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge;
        return $8b03c82ed7bcdd6a$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]);
    // Tracks the close reason, including our own hidePopover() calls.
    var closeReasonRef = (0, $5FkrB.useRef)('light-dismiss');
    // Pre-open focus target, cleared before close when restoration is not eligible.
    var focusRestorationTargetRef = (0, $5FkrB.useRef)(null);
    var handleBeforeToggle = (0, $5FkrB.useCallback)(function(event) {
        var popover = event.currentTarget;
        if (!(popover instanceof HTMLElement)) return;
        var ownerDocument = popover.ownerDocument;
        var activeElement = ownerDocument.activeElement;
        if (event.newState === 'open') {
            focusRestorationTargetRef.current = activeElement instanceof HTMLElement ? activeElement : null;
            return;
        }
        /**
     * Like native restoration, leave external focus alone and skip light dismiss.
     * Check before closing so focus already on body is not mistaken for focus lost during close.
     * See https://html.spec.whatwg.org/multipage/popover.html#hide-popover-algorithm (step 20.2).
     */ if (closeReasonRef.current === 'light-dismiss' || !popover.contains(activeElement)) focusRestorationTargetRef.current = null;
    }, []);
    var handleToggleClosed = (0, $5FkrB.useCallback)(function(event) {
        var popover = event.currentTarget;
        if (!(popover instanceof HTMLElement)) return;
        var focusRestorationTarget = focusRestorationTargetRef.current;
        focusRestorationTargetRef.current = null;
        var reason = closeReasonRef.current;
        // Reset reason so a stale 'escape' from a race with Escape keydown
        // does not corrupt the next browser-dismiss cycle.
        closeReasonRef.current = 'light-dismiss';
        // Run after native restoration, before notifying the consumer, which may move focus itself.
        $8b03c82ed7bcdd6a$var$restoreFocus({
            popover: popover,
            focusRestorationTarget: focusRestorationTarget
        });
        // Programmatic closes are already known to the consumer.
        if (reason !== 'programmatic') {
            var _onCloseRef$current2;
            (_onCloseRef$current2 = onCloseRef.current) === null || _onCloseRef$current2 === void 0 || _onCloseRef$current2.call(onCloseRef, {
                reason: reason
            });
        }
    }, []);
    var _useAnimatedVisibilit = (0, $fsSfs.useAnimatedVisibility)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    }), phase = _useAnimatedVisibilit.phase, isMounted = _useAnimatedVisibilit.isMounted, onBeforeToggle = _useAnimatedVisibilit.onBeforeToggle, onToggle = _useAnimatedVisibilit.onToggle;
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // popovers are handled above via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus.md.
    (0, $2QJ6b.useFocusWrap)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    (0, $cBDfx.useInitialFocus)({
        elementRef: ownRef,
        phase: phase,
        role: role
    });
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `focusRestorationTargetRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        var unbindEscape = (0, $7QpUe.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                // Ignore Escape events dispatched after native close.
                if (event.key === 'Escape' && (0, $3iTCp.isNativeElementOpen)({
                    element: element
                })) closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        var unbindToggle = (0, $7QpUe.bind)(element, {
            type: 'toggle',
            listener: function listener(event) {
                if (event.newState === 'closed') handleToggleClosed(event);
                onToggle(event);
            }
        });
        // Snapshot the active element before `useInitialFocus` moves it,
        // then advance the shared visibility lifecycle.
        var unbindBeforeToggle = (0, $7QpUe.bind)(element, {
            type: 'beforetoggle',
            listener: function listener(event) {
                handleBeforeToggle(event);
                onBeforeToggle(event);
            }
        });
        return function() {
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleBeforeToggle,
        handleToggleClosed,
        isMounted,
        onBeforeToggle,
        onToggle
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and interrupted close lifecycles may not reach
            // `handleToggleClosed` to reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch (_unused) {}
            return function() {
                closeReasonRef.current = 'programmatic';
                try {
                    element.hidePopover();
                } catch (_unused2) {}
            };
        }
        closeReasonRef.current = 'programmatic';
        try {
            element.hidePopover();
        } catch (_unused3) {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isMounted) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        ref: combinedRef,
        id: popoverId,
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        style: popupMotionStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $8b03c82ed7bcdd6a$var$styles.root,
            $8b03c82ed7bcdd6a$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $8b03c82ed7bcdd6a$var$styles.enter,
            shouldAnimate && phase === 'exiting' && $8b03c82ed7bcdd6a$var$styles.exit,
            shouldAnimate && $8b03c82ed7bcdd6a$var$styles.motion,
            (0, $hUFig.cx)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ])
    }, children);
});

});
parcelRegister("3iTCp", function(module, exports) {
$parcel$export(module.exports, "isNativeElementOpen", () => $267e32323dcba040$export$89b923e18c14644d);
function $267e32323dcba040$export$89b923e18c14644d(_ref) {
    var element = _ref.element;
    if (element instanceof HTMLDialogElement) return element.open;
    // Some DOM implementations throw for unsupported pseudo-classes.
    try {
        return element.matches(':popover-open');
    } catch (_unused) {
        return false;
    }
}

});

parcelRegister("8dRzc", function(module, exports) {
$parcel$export(module.exports, "resolvePlacement", () => $5fc916ddcacd196c$export$63044d21bc3d3fa2);

var $9TUzG = parcelRequire("9TUzG");
/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ var $5fc916ddcacd196c$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $5fc916ddcacd196c$export$63044d21bc3d3fa2(_ref) {
    var _placement$axis, _placement$edge, _placement$align, _placement$offset$gap, _placement$offset, _placement$offset$cro, _placement$offset2, _placement$offset$cro2, _placement$offset3;
    var placement = _ref.placement;
    return {
        axis: (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block',
        edge: (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end',
        align: (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center',
        // Not `??`: `undefined` must survive, so "not specified" stays
        // distinguishable from an explicit `0`.
        minSize: placement.minSize === undefined ? undefined : (0, $9TUzG.toCssLengthString)({
            value: placement.minSize
        }),
        offset: {
            gap: (0, $9TUzG.toCssLengthString)({
                value: (_placement$offset$gap = (_placement$offset = placement.offset) === null || _placement$offset === void 0 ? void 0 : _placement$offset.gap) !== null && _placement$offset$gap !== void 0 ? _placement$offset$gap : $5fc916ddcacd196c$var$DEFAULT_GAP
            }),
            crossAxisShift: {
                value: (0, $9TUzG.toCssLengthString)({
                    value: (_placement$offset$cro = (_placement$offset2 = placement.offset) === null || _placement$offset2 === void 0 || (_placement$offset2 = _placement$offset2.crossAxisShift) === null || _placement$offset2 === void 0 ? void 0 : _placement$offset2.value) !== null && _placement$offset$cro !== void 0 ? _placement$offset$cro : 0
                }),
                direction: (_placement$offset$cro2 = (_placement$offset3 = placement.offset) === null || _placement$offset3 === void 0 || (_placement$offset3 = _placement$offset3.crossAxisShift) === null || _placement$offset3 === void 0 ? void 0 : _placement$offset3.direction) !== null && _placement$offset$cro2 !== void 0 ? _placement$offset$cro2 : 'forwards'
            }
        }
    };
}

});
parcelRegister("9TUzG", function(module, exports) {
$parcel$export(module.exports, "toCssLengthString", () => $735522a0132733ce$export$63b6b0ff65d84d47);
/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $735522a0132733ce$export$63b6b0ff65d84d47(_ref) {
    var value = _ref.value;
    if (typeof value === 'number') return "".concat(value, "px");
    return value;
}

});


parcelRegister("fsSfs", function(module, exports) {
$parcel$export(module.exports, "useAnimatedVisibility", () => $b4238d19e2557759$export$1bccb45daf07907f);

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $3iTCp = parcelRequire("3iTCp");

var $hf9iT = parcelRequire("hf9iT");
function $b4238d19e2557759$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b4238d19e2557759$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b4238d19e2557759$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b4238d19e2557759$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b4238d19e2557759$var$runCancellableSettlement(_ref) {
    var schedule = _ref.schedule, onSettled = _ref.onSettled;
    var isCancelled = false;
    schedule(function() {
        if (isCancelled) return;
        onSettled();
    });
    return function() {
        // Prevent an interrupted or unmounted lifecycle from firing a stale callback.
        isCancelled = true;
    };
}
/**
 * Fires `onSettled` once all animations currently applied to `element`
 * finish or are cancelled. Returns a cleanup that prevents stale settlement.
 */ function $b4238d19e2557759$var$runOnAnimationsSettled(_ref2) {
    var element = _ref2.element, onSettled = _ref2.onSettled;
    return $b4238d19e2557759$var$runCancellableSettlement({
        onSettled: onSettled,
        schedule: function schedule(settle) {
            var _element$getAnimation, _element$getAnimation2;
            var animations = (_element$getAnimation = (_element$getAnimation2 = element.getAnimations) === null || _element$getAnimation2 === void 0 ? void 0 : _element$getAnimation2.call(element)) !== null && _element$getAnimation !== void 0 ? _element$getAnimation : [];
            Promise.allSettled(animations.map(function(animation) {
                return animation.finished;
            })).then(settle);
        }
    });
}
/**
 * Visibility lifecycle phase shared between `useAnimatedVisibility`,
 * `useFocusWrap`, `useInitialFocus`, and the `Popover` / `Dialog`
 * components.
 *
 * - `closed`: host element is unmounted. No DOM presence.
 * - `entering`: host element is mounted and the CSS entry transition
 *   is playing. **Only emitted when animation is enabled.** With
 *   animation disabled the lifecycle goes directly `closed → open`.
 * - `open`: host element is mounted and settled. No transition is
 *   playing.
 * - `exiting`: a native close has begun but the host element remains
 *   mounted. Usually this follows `isOpen` changing to `false`, but it can
 *   also begin with a browser-initiated dismissal while controlled intent
 *   is still open. With animation disabled, this phase lasts until the
 *   browser's closed `toggle` fires so native focus restoration can finish.
 *
 * State machine:
 * ```
 *   animation ON:   closed → entering → open → exiting → closed
 *   animation OFF:  closed →            open → exiting → closed
 *   interrupts:     entering → exiting (close mid-entry)
 *                   exiting  → entering (reopen mid-exit, animated)
 *                   exiting  → open     (reopen mid-handshake, non-animated)
 * ```
 */ function $b4238d19e2557759$var$getInitialVisibilityState(_ref3) {
    var isOpen = _ref3.isOpen, willAnimate = _ref3.willAnimate;
    if (!isOpen) return {
        phase: 'closed',
        controlledIntent: 'closed'
    };
    if (willAnimate) return {
        phase: 'entering',
        controlledIntent: 'open'
    };
    return {
        phase: 'open',
        controlledIntent: 'open'
    };
}
/**
 * Applies one lifecycle event to the current visibility phase.
 *
 * Events that are stale for the current phase are ignored. This allows
 * animation callbacks and native close events to settle safely after an
 * interrupted lifecycle.
 */ function $b4238d19e2557759$var$getNextVisibilityState(state, action) {
    if (action.type === 'open-requested') {
        var shouldEnter = state.phase === 'closed' || state.phase === 'exiting' && state.controlledIntent === 'closed';
        if (shouldEnter && action.willAnimate) return {
            phase: 'entering',
            controlledIntent: 'open'
        };
        if (shouldEnter) return {
            phase: 'open',
            controlledIntent: 'open'
        };
        return $b4238d19e2557759$var$_objectSpread($b4238d19e2557759$var$_objectSpread({}, state), {}, {
            controlledIntent: 'open'
        });
    }
    if (action.type === 'close-requested') return $b4238d19e2557759$var$_objectSpread($b4238d19e2557759$var$_objectSpread({}, state), {}, {
        controlledIntent: 'closed'
    });
    if (action.type === 'exit-started') {
        if (state.phase !== 'open' && state.phase !== 'entering') return state;
        return $b4238d19e2557759$var$_objectSpread($b4238d19e2557759$var$_objectSpread({}, state), {}, {
            phase: 'exiting'
        });
    }
    if (action.type === 'entry-settled') {
        if (state.phase !== 'entering') return state;
        return $b4238d19e2557759$var$_objectSpread($b4238d19e2557759$var$_objectSpread({}, state), {}, {
            phase: 'open'
        });
    }
    if (action.type === 'exit-settled') {
        if (state.phase !== 'exiting') return state;
        return $b4238d19e2557759$var$_objectSpread($b4238d19e2557759$var$_objectSpread({}, state), {}, {
            phase: 'closed'
        });
    }
    return state;
}
function $b4238d19e2557759$export$1bccb45daf07907f(_ref4) {
    var isOpen = _ref4.isOpen, shouldAnimate = _ref4.shouldAnimate, elementRef = _ref4.elementRef, onEnterFinish = _ref4.onEnterFinish, onExitFinish = _ref4.onExitFinish;
    var willAnimate = shouldAnimate && !(0, $hf9iT.prefersReducedMotion)();
    var _useReducer = (0, $5FkrB.useReducer)($b4238d19e2557759$var$getNextVisibilityState, {
        isOpen: isOpen,
        willAnimate: willAnimate
    }, $b4238d19e2557759$var$getInitialVisibilityState), _useReducer2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useReducer, 2), visibilityState = _useReducer2[0], dispatch = _useReducer2[1];
    var phase = visibilityState.phase, controlledIntent = visibilityState.controlledIntent;
    // Keep stable refs to the latest callbacks so effects and animation settlement closures
    // always call the current callback without needing them in dependency arrays.
    var onEnterFinishRef = (0, $5FkrB.useRef)(onEnterFinish);
    var onExitFinishRef = (0, $5FkrB.useRef)(onExitFinish);
    var willAnimateRef = (0, $5FkrB.useRef)(willAnimate);
    (0, $5FkrB.useLayoutEffect)(function() {
        onEnterFinishRef.current = onEnterFinish;
        onExitFinishRef.current = onExitFinish;
        willAnimateRef.current = willAnimate;
    }, [
        onEnterFinish,
        onExitFinish,
        willAnimate
    ]);
    // Synchronize controlled intent during render so opening mounts the host in
    // the same commit. Keeping the processed intent in reducer state prevents a
    // browser-driven exit from being mistaken for a new controlled open request.
    if (isOpen && controlledIntent === 'closed') dispatch({
        type: 'open-requested',
        willAnimate: willAnimate
    });
    if (!isOpen && controlledIntent === 'open') dispatch({
        type: 'close-requested'
    });
    // Entry can commit `open` before its callback because the host stays mounted.
    // This ensures consumers observe the settled DOM rather than entering styles.
    // Treat the phase before the initial commit as closed so an initially open host
    // notifies consumers.
    var prevPhaseRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        if (prevPhase === phase) return;
        if (phase === 'open') {
            var _onEnterFinishRef$cur;
            (_onEnterFinishRef$cur = onEnterFinishRef.current) === null || _onEnterFinishRef$cur === void 0 || _onEnterFinishRef$cur.call(onEnterFinishRef);
        }
    }, [
        phase
    ]);
    var isMounted = phase !== 'closed';
    var cancelExitSettlementRef = (0, $5FkrB.useRef)(function() {});
    // Exit must notify consumers before `closed` unmounts the host.
    var settleExit = (0, $5FkrB.useCallback)(function() {
        var _onExitFinishRef$curr;
        (_onExitFinishRef$curr = onExitFinishRef.current) === null || _onExitFinishRef$curr === void 0 || _onExitFinishRef$curr.call(onExitFinishRef);
        dispatch({
            type: 'exit-settled'
        });
    }, []);
    // Primitives bind these stable callbacks to their native lifecycle events.
    // This keeps event ownership at the primitive while the hook owns state transitions.
    var onBeforeToggle = (0, $5FkrB.useCallback)(function(event) {
        // Any native transition supersedes a previous exit snapshot. This prevents
        // a stale settlement from closing a host that is reopening or closing again.
        cancelExitSettlementRef.current();
        // Snapshot currentTarget because the DOM clears it after event dispatch.
        var element = event.currentTarget;
        if (event.newState === 'open' && element instanceof HTMLElement) {
            element.removeAttribute('inert');
            element.removeAttribute('aria-hidden');
        }
        if (event.newState === 'closed') {
            if (element instanceof HTMLElement) // We use a microtask to let native focus restoration happen before making the element inert.
            // The browser restores focus after beforetoggle returns, during its close steps.
            queueMicrotask(function() {
                // A controlled close can be interrupted by isOpen changing back to true,
                // which reopens the element before this microtask runs.
                if ((0, $3iTCp.isNativeElementOpen)({
                    element: element
                })) return;
                // Exit animations keep closed content rendered, so make it non-interactive and hide it from assistive technology.
                element.setAttribute('inert', '');
                // Tooling does not consistently treat inert content as hidden, even though the browser does.
                element.setAttribute('aria-hidden', 'true');
            });
            dispatch({
                type: 'exit-started'
            });
        }
    }, []);
    var onToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState !== 'closed') return;
        if (!willAnimateRef.current) {
            cancelExitSettlementRef.current = $b4238d19e2557759$var$runCancellableSettlement({
                schedule: queueMicrotask,
                onSettled: settleExit
            });
            return;
        }
        var element = elementRef.current;
        if (!element) return;
        // The closed `toggle` is task-queued after synchronous `beforetoggle`.
        // Snapshot here so the exiting phase styles have committed and the list
        // represents the animations that actually govern exit settlement.
        cancelExitSettlementRef.current = $b4238d19e2557759$var$runOnAnimationsSettled({
            element: element,
            onSettled: settleExit
        });
    }, [
        elementRef,
        settleExit
    ]);
    (0, $5FkrB.useLayoutEffect)(function() {
        return function() {
            // Prevent a pending animation or microtask from notifying after unmount.
            cancelExitSettlementRef.current();
        };
    }, []);
    // Entry settlement only removes entering styles. Its callback runs after the
    // resulting `open` commit in the effect above.
    (0, $5FkrB.useEffect)(function settleEntry() {
        if (phase !== 'entering') return;
        if (!willAnimate) {
            dispatch({
                type: 'entry-settled'
            });
            return;
        }
        var element = elementRef.current;
        if (!element) return;
        return $b4238d19e2557759$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                dispatch({
                    type: 'entry-settled'
                });
            }
        });
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    return {
        phase: phase,
        isMounted: isMounted,
        onBeforeToggle: onBeforeToggle,
        onToggle: onToggle
    };
}

});
parcelRegister("hf9iT", function(module, exports) {
$parcel$export(module.exports, "prefersReducedMotion", () => $c8db0de57e42440f$export$ff7706047246b98b);

var $bvsoE = parcelRequire("bvsoE");
var $c8db0de57e42440f$export$ff7706047246b98b = (0, $bvsoE.default)(function() {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});

});


parcelRegister("2QJ6b", function(module, exports) {
$parcel$export(module.exports, "useFocusWrap", () => $21336bc132010760$export$4f6462e86a70abe5);

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $eF6wF = parcelRequire("eF6wF");

var $2ZNA8 = parcelRequire("2ZNA8");

var $dQveQ = parcelRequire("dQveQ");

var $4TRi6 = parcelRequire("4TRi6");
/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/outputs/menu-keyboard-decision.md
 */ function $21336bc132010760$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $21336bc132010760$export$4f6462e86a70abe5(_ref) {
    var elementRef = _ref.elementRef, role = _ref.role, phase = _ref.phase;
    var isVisible = phase !== 'closed';
    (0, $5FkrB.useEffect)(function() {
        var element = elementRef.current;
        if (!element || !$21336bc132010760$var$roleRequiresFocusWrap(role) || !isVisible) return;
        var unbind = (0, $7QpUe.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $4TRi6.isNestedLayerFocused)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                var direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                var next = (0, $dQveQ.getNextFocusable)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                var fallback = direction === 'forwards' ? (0, $eF6wF.getFirstFocusable)({
                    container: element
                }) : (0, $2ZNA8.getLastFocusable)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}

});
parcelRegister("eF6wF", function(module, exports) {
$parcel$export(module.exports, "getFirstFocusable", () => $aac9f4efdd02aa54$export$748138f04a69bf21);

var $ex5rt = parcelRequire("ex5rt");
function $aac9f4efdd02aa54$export$748138f04a69bf21(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $ex5rt.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}

});
parcelRegister("ex5rt", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $a9485e71cb7f7253$export$f6768025e418420e);

var $ceX6u = parcelRequire("ceX6u");
var $a9485e71cb7f7253$var$focusableExclusions = [
    '[tabindex="-1"]',
    ':disabled',
    '[aria-disabled="true"]',
    '[aria-hidden="true"]'
];
var $a9485e71cb7f7253$var$exclusionSelector = $a9485e71cb7f7253$var$focusableExclusions.map(function(selector) {
    return ":not(".concat(selector, ")");
}).join('');
var $a9485e71cb7f7253$var$focusableSelector = [
    'a[href]',
    'area[href]',
    'input:not([type="hidden"])',
    'select',
    'textarea',
    'button',
    'iframe',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])',
    '[tabindex]'
].map(function(selector) {
    return "".concat(selector).concat($a9485e71cb7f7253$var$exclusionSelector);
}).join(',');
function $a9485e71cb7f7253$var$isVisible(element) {
    // Visibility filtering must not break focus navigation when the API is unsupported.
    if (typeof element.checkVisibility !== 'function') return true;
    try {
        // Exclude elements hidden by display, content-visibility or visibility because
        // they cannot receive focus. Offscreen, occluded and opacity-zero elements can
        // receive focus, so they intentionally remain included.
        return element.checkVisibility({
            checkVisibilityCSS: true
        });
    } catch (_unused) {
        return true;
    }
}
function $a9485e71cb7f7253$export$f6768025e418420e(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var containerLayer = (0, $ceX6u.getClosestLayer)({
        element: container
    });
    return Array.from(container.querySelectorAll($a9485e71cb7f7253$var$focusableSelector)).filter(function(element) {
        if (!(element instanceof HTMLElement)) return false;
        if ((0, $ceX6u.getClosestLayer)({
            element: element
        }) !== containerLayer) return false;
        if (element.closest('[inert]')) return false;
        if (!$a9485e71cb7f7253$var$isVisible(element)) return false;
        return !filter || filter(element, container);
    });
}

});
parcelRegister("ceX6u", function(module, exports) {
$parcel$export(module.exports, "getClosestLayer", () => $8e94a39ea18254de$export$3c9385904be131db);
function $8e94a39ea18254de$export$3c9385904be131db(_ref) {
    var element = _ref.element;
    return element.closest('[popover], dialog');
}

});



parcelRegister("2ZNA8", function(module, exports) {
$parcel$export(module.exports, "getLastFocusable", () => $22e7bd30fb24a14d$export$73e81fa65335a75b);

var $ex5rt = parcelRequire("ex5rt");
function $22e7bd30fb24a14d$export$73e81fa65335a75b(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $ex5rt.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}

});

parcelRegister("dQveQ", function(module, exports) {
$parcel$export(module.exports, "getNextFocusable", () => $a1485cf77d1ea43e$export$a7db88e6d491b450);
/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * The currently focused element does not need to be tabbable. This prevents
 * navigation from getting stuck on an element that was programmatically or
 * pointer focused with `tabindex="-1"`. Negative-tab-index elements remain
 * excluded as destinations.
 *
 * Returns `null` if there is no focused element within the container.
 */ 
var $ex5rt = parcelRequire("ex5rt");
function $a1485cf77d1ea43e$export$a7db88e6d491b450(_ref) {
    var _all3;
    var container = _ref.container, direction = _ref.direction, filter = _ref.filter;
    var all = (0, $ex5rt.getFocusables)({
        container: container,
        filter: filter
    });
    var first = all[0];
    var last = all[all.length - 1];
    // Checking the elements directly narrows types from `HTMLElement | undefined`.
    if (!first || !last) return null;
    var current = container.ownerDocument.activeElement;
    if (!(current instanceof HTMLElement) || !container.contains(current)) return null;
    var index = all.indexOf(current);
    // The focused element can be absent from `all` when it is non-tabbable or
    // excluded by the filter. Find the first focusable element that follows it in
    // the DOM, which identifies the nearest focusable destination in either direction.
    if (index === -1) {
        var _all;
        var followingIndex = all.findIndex(function(element) {
            return Boolean(current.compareDocumentPosition(element) & current.DOCUMENT_POSITION_FOLLOWING);
        });
        if (direction === 'forwards') {
            var _all$followingIndex;
            // If nothing follows the current element, then wrap to the start.
            return (_all$followingIndex = all[followingIndex]) !== null && _all$followingIndex !== void 0 ? _all$followingIndex : first;
        }
        // The closest preceding element is immediately before the first following one.
        // A missing adjacent entry means the backward sequence wraps to the end.
        return (_all = all[followingIndex - 1]) !== null && _all !== void 0 ? _all : last;
    }
    // The current element is tabbable, so use its adjacent list entry and wrap
    // when it is already at the boundary.
    if (direction === 'forwards') {
        var _all2;
        return (_all2 = all[index + 1]) !== null && _all2 !== void 0 ? _all2 : first;
    }
    return (_all3 = all[index - 1]) !== null && _all3 !== void 0 ? _all3 : last;
}

});

parcelRegister("4TRi6", function(module, exports) {
$parcel$export(module.exports, "isNestedLayerFocused", () => $3915a2f8e986ebf8$export$b9590fdfeb5f722f);

var $ceX6u = parcelRequire("ceX6u");
function $3915a2f8e986ebf8$export$b9590fdfeb5f722f(_ref) {
    var container = _ref.container;
    var focused = container.ownerDocument.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return (0, $ceX6u.getClosestLayer)({
        element: focused
    }) !== (0, $ceX6u.getClosestLayer)({
        element: container
    });
}

});


parcelRegister("cBDfx", function(module, exports) {
$parcel$export(module.exports, "useInitialFocus", () => $92d762dfd0799aa1$export$e992c40175757a22);

var $5FkrB = parcelRequire("5FkrB");

var $eF6wF = parcelRequire("eF6wF");
/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox regardless of role. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, or menu), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
var $92d762dfd0799aa1$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $92d762dfd0799aa1$var$isTextboxLikeElement(element) {
    var role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    var tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        var _element$getAttribute;
        var type = ((_element$getAttribute = element.getAttribute('type')) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : 'text').toLowerCase();
        return $92d762dfd0799aa1$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $92d762dfd0799aa1$var$isComboboxControllingPopup(_ref) {
    var _active$getAttribute;
    var container = _ref.container;
    var ownerDocument = container.ownerDocument;
    var active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$92d762dfd0799aa1$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    var idRefs = (_active$getAttribute = active.getAttribute('aria-controls')) !== null && _active$getAttribute !== void 0 ? _active$getAttribute : active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    var referencedIds = idRefs.split(/\s+/).filter(function(id) {
        return id !== '';
    });
    return referencedIds.some(function(id) {
        var referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function $92d762dfd0799aa1$var$getInitialFocusTarget(_ref2) {
    var container = _ref2.container, role = _ref2.role;
    if (role === 'dialog' || role === 'alertdialog') {
        // Prefer element with the native HTML autofocus attribute.
        var autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $eF6wF.getFirstFocusable)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific (menu / listbox) rather
    // than hoisted. Hoisting it over-matched on dialog popups that contain
    // a nested combobox (e.g. datetime-picker's dialog hosts a react-select),
    // where the active combobox's `aria-controls` falsely matched the
    // container and suppressed the dialog's own focus contract.
    if (role === 'menu') {
        if ($92d762dfd0799aa1$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/outputs/menu-keyboard-decision.md
        return (0, $eF6wF.getFirstFocusable)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($92d762dfd0799aa1$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        var selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        var firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $eF6wF.getFirstFocusable)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $92d762dfd0799aa1$export$e992c40175757a22(_ref3) {
    var elementRef = _ref3.elementRef, phase = _ref3.phase, role = _ref3.role;
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    var prevPhaseRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var _getInitialFocusTarge;
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        var element = elementRef.current;
        if (!element) return;
        (_getInitialFocusTarge = $92d762dfd0799aa1$var$getInitialFocusTarget({
            container: element,
            role: role
        })) === null || _getInitialFocusTarge === void 0 || _getInitialFocusTarge.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}

});



parcelRegister("as7Bx", function(module, exports) {
$parcel$export(module.exports, "default", () => $79c26afa31e12d92$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $jLsC1 = parcelRequire("jLsC1");

var $3MRWq = parcelRequire("3MRWq");

var $hGA8b = parcelRequire("hGA8b");
var $79c26afa31e12d92$var$contentStyles = null;
var $79c26afa31e12d92$var$contentStylesPrismVisible = null;
var $79c26afa31e12d92$var$animatedSvgContainerStyles = {
    true: "_v564fs5d _tzy4kb7n",
    false: "_v564fs5d _tzy4idpf"
};
var $79c26afa31e12d92$var$borderRadiusStyles = {
    large: "_2rko1mok",
    small: "_2rko12b0"
};
var $79c26afa31e12d92$var$popupContainerStyles = null;
var $79c26afa31e12d92$var$AIPrism = function AIPrism(_ref) {
    var _AI_BORDER_PALETTE$co;
    var borderRadius = _ref.borderRadius, children = _ref.children, _ref$isGlowing = _ref.isGlowing, isGlowing = _ref$isGlowing === void 0 ? true : _ref$isGlowing, _ref$isMoving = _ref.isMoving, isMoving = _ref$isMoving === void 0 ? true : _ref$isMoving, isVisible = _ref.isVisible, testId = _ref.testId;
    var _useThemeObserver = (0, $jLsC1.useThemeObserver)(), _useThemeObserver$col = _useThemeObserver.colorMode, colorMode = _useThemeObserver$col === void 0 ? 'light' : _useThemeObserver$col;
    return /*#__PURE__*/ $5FkrB.createElement((0, $3MRWq.default), {
        palette: (_AI_BORDER_PALETTE$co = (0, $hGA8b.AI_BORDER_PALETTE)[colorMode]) !== null && _AI_BORDER_PALETTE$co !== void 0 ? _AI_BORDER_PALETTE$co : (0, $hGA8b.AI_BORDER_PALETTE).light,
        isGlowing: isGlowing,
        isMoving: isMoving,
        testId: testId,
        className: (0, $970q7.default)([
            $79c26afa31e12d92$var$animatedSvgContainerStyles[isVisible ? 'true' : 'false'],
            borderRadius && $79c26afa31e12d92$var$borderRadiusStyles[borderRadius]
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            "_2rko1mok _bfhk1bhr _16qs130s",
            "_v5649spz",
            isVisible && "_16qs1aef"
        ])
    }, children));
};
var $79c26afa31e12d92$export$2e2bcd8739ae039 = $79c26afa31e12d92$var$AIPrism;

});
parcelRegister("3MRWq", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c1fb26b60d9b06e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $4pmuv = parcelRequire("4pmuv");
var $2c1fb26b60d9b06e$var$borderContainerStyles = null;
var $2c1fb26b60d9b06e$var$borderContentStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ var $2c1fb26b60d9b06e$var$AIGlowingBorder = function AIGlowingBorder(_ref) {
    var children = _ref.children, palette = _ref.palette, _ref$isMoving = _ref.isMoving, isMoving = _ref$isMoving === void 0 ? true : _ref$isMoving, isGlowing = _ref.isGlowing, testId = _ref.testId, className = _ref.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": testId,
        className: (0, $970q7.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1bsb1ns9"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $4pmuv.default), {
        palette: palette,
        isMoving: isMoving,
        className: className
    }), isGlowing && /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    $5FkrB.createElement((0, $4pmuv.default), {
        palette: palette,
        isMoving: isMoving,
        isGlowing: true,
        className: className
    }), /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            "_2rko1mok _16jlkb7n _1pbykb7n"
        ])
    }, children, " "));
};
var $2c1fb26b60d9b06e$export$2e2bcd8739ae039 = $2c1fb26b60d9b06e$var$AIGlowingBorder;

});
parcelRegister("4pmuv", function(module, exports) {
$parcel$export(module.exports, "default", () => $335af177e06789db$export$2e2bcd8739ae039);
/* animated-svg-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $335af177e06789db$var$namespaceUUID = 0;
var $335af177e06789db$var$svgStyles = null;
var $335af177e06789db$var$blurredStyles = null;
var $335af177e06789db$var$notBlurredStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ var $335af177e06789db$var$AnimatedSvgContainer = function AnimatedSvgContainer(_ref) {
    var palette = _ref.palette, isMoving = _ref.isMoving, isGlowing = _ref.isGlowing, className = _ref.className;
    var svgRef = (0, $5FkrB.useRef)(null);
    var namespaceId = (0, $5FkrB.useRef)();
    if (namespaceId.current === undefined) {
        namespaceId.current = $335af177e06789db$var$namespaceUUID;
        $335af177e06789db$var$namespaceUUID += 1;
    }
    (0, $5FkrB.useEffect)(function() {
        if (isMoving) {
            var svg = svgRef.current;
            // Schedule animation to begin before next browser paint
            var beginReq = requestAnimationFrame(function() {
                svg === null || svg === void 0 || svg.querySelectorAll('animate').forEach(function(node) {
                    return node.beginElement();
                });
            });
            return function() {
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(function() {
                    svg === null || svg === void 0 || svg.querySelectorAll('animate').forEach(function(node) {
                        return node.endElement();
                    });
                });
            };
        }
        return undefined;
    }, [
        isMoving
    ]);
    return /*#__PURE__*/ $5FkrB.createElement("svg", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            "_2rko19bv _kqswstnw",
            isGlowing ? "_1bsb1wgc _4t3i1wgc _154i1b66 _1ltv1b66 _kdam1rfl _w6ng15vq _t9ec161g" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            className
        ]),
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none"
    }, /*#__PURE__*/ $5FkrB.createElement("defs", null, /*#__PURE__*/ $5FkrB.createElement("linearGradient", {
        id: "".concat(namespaceId.current, "_lg1"),
        gradientUnits: "userSpaceOnUse",
        x1: "0%",
        y1: "0",
        x2: "400%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $5FkrB.createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "0%",
        to: "400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $5FkrB.createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "400%",
        to: "800%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $5FkrB.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $5FkrB.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $5FkrB.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $5FkrB.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $5FkrB.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ $5FkrB.createElement("linearGradient", {
        id: "".concat(namespaceId.current, "_lg2"),
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "-100%",
        x2: "0",
        y2: "300%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $5FkrB.createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "-100%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $5FkrB.createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "300%",
        to: "700%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $5FkrB.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $5FkrB.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $5FkrB.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $5FkrB.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $5FkrB.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ $5FkrB.createElement("linearGradient", {
        id: "".concat(namespaceId.current, "_lg3"),
        gradientUnits: "userSpaceOnUse",
        x1: "300%",
        y1: "0",
        x2: "700%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $5FkrB.createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "300%",
        to: "-100%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $5FkrB.createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "700%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $5FkrB.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $5FkrB.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $5FkrB.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $5FkrB.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $5FkrB.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ $5FkrB.createElement("linearGradient", {
        id: "".concat(namespaceId.current, "_lg4"),
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "400%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $5FkrB.createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "0%",
        to: "-400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $5FkrB.createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "400%",
        to: "0%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $5FkrB.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $5FkrB.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $5FkrB.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $5FkrB.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $5FkrB.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    }))), /*#__PURE__*/ $5FkrB.createElement("g", {
        strokeWidth: "8"
    }, /*#__PURE__*/ $5FkrB.createElement("path", {
        stroke: "url(#".concat(namespaceId.current, "_lg1)"),
        d: "M0 0h24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ $5FkrB.createElement("path", {
        stroke: "url(#".concat(namespaceId.current, "_lg2)"),
        d: "M24 0v24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ $5FkrB.createElement("path", {
        stroke: "url(#".concat(namespaceId.current, "_lg3)"),
        d: "M24 24H0",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ $5FkrB.createElement("path", {
        stroke: "url(#".concat(namespaceId.current, "_lg4)"),
        d: "M0 24V0",
        vectorEffect: "non-scaling-stroke"
    })));
};
var $335af177e06789db$export$2e2bcd8739ae039 = $335af177e06789db$var$AnimatedSvgContainer;

});


parcelRegister("hGA8b", function(module, exports) {
$parcel$export(module.exports, "AI_BORDER_PALETTE", () => $ce0262c31b953ad4$export$23b7b83c7063ccfe);
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ // We don't yet have design system tokens representing the AI prism colour palette. We should replace this with
// equivalent tokens when available
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ var $ce0262c31b953ad4$export$3088ed82e2905d1e = {
    blueUniqueGradientLight: '#00ACF8',
    blueUniqueGradientDark: '#008BD2',
    blue1000: '#092957',
    blue800: '#0055CC',
    blue700: '#0C66E4',
    blue600: '#1D7AFC',
    blue500: '#388BFF',
    blue300: '#85B8FF',
    blue200: '#CCE0FF',
    blue100: '#E9F2FF',
    teal500: '#37B4C3',
    teal300: '#8BDBE5',
    yellow500: '#CF9F02',
    yellow200: '#F8E6A0',
    red800: '#AE2A19',
    red600: '#E34935',
    orange500: '#F18D13',
    orange300: '#FEC57B'
};
var $ce0262c31b953ad4$export$23b7b83c7063ccfe = {
    dark: {
        blue: $ce0262c31b953ad4$export$3088ed82e2905d1e.blue800,
        teal: $ce0262c31b953ad4$export$3088ed82e2905d1e.teal500,
        yellow: $ce0262c31b953ad4$export$3088ed82e2905d1e.yellow500
    },
    light: {
        blue: $ce0262c31b953ad4$export$3088ed82e2905d1e.blue600,
        teal: $ce0262c31b953ad4$export$3088ed82e2905d1e.teal300,
        yellow: $ce0262c31b953ad4$export$3088ed82e2905d1e.yellow200
    }
};

});




parcelRegister("9ULzi", function(module, exports) {
$parcel$export(module.exports, "default", () => $737e3e1bd20a0070$export$2e2bcd8739ae039);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $5FkrB = parcelRequire("5FkrB");

var $6JfQX = parcelRequire("6JfQX");

var $96IWe = parcelRequire("96IWe");

var $767sR = parcelRequire("767sR");

var $QWcgg = parcelRequire("QWcgg");

var $gNh66 = parcelRequire("gNh66");

var $aRJoq = parcelRequire("aRJoq");

var $1rhWa = parcelRequire("1rhWa");
var $737e3e1bd20a0070$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ var $737e3e1bd20a0070$var$useInvokeClientAction = function useInvokeClientAction(_ref) {
    var fireEventProp = _ref.fireEvent;
    var _useAnalyticsEvents = (0, $96IWe.useAnalyticsEvents)(), defaultFireEvent = _useAnalyticsEvents.fireEvent;
    var fireEvent = fireEventProp !== null && fireEventProp !== void 0 ? fireEventProp : defaultFireEvent;
    return (0, $5FkrB.useCallback)(/*#__PURE__*/ function() {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_ref2) {
            var actionSubjectId, actionType, actionFn, _ref2$definitionId, definitionId, extensionKey, display, id, prompt, _ref2$resourceType, resourceType, experienceId, markName, _getMeasure$duration, _getMeasure, result, _getMeasure$duration2, _getMeasure2, reason, _t;
            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        actionSubjectId = _ref2.actionSubjectId, actionType = _ref2.actionType, actionFn = _ref2.actionFn, _ref2$definitionId = _ref2.definitionId, definitionId = _ref2$definitionId === void 0 ? null : _ref2$definitionId, extensionKey = _ref2.extensionKey, display = _ref2.display, id = _ref2.id, prompt = _ref2.prompt, _ref2$resourceType = _ref2.resourceType, resourceType = _ref2$resourceType === void 0 ? null : _ref2$resourceType;
                        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                        experienceId = (0, $6JfQX.default)(); // Begin performance instrumentation.
                        markName = "".concat(experienceId, "-").concat(actionType);
                        (0, $QWcgg.mark)(markName, 'pending');
                        _context.prev = 1;
                        // Begin UFO experience
                        (0, $aRJoq.startUfoExperience)($737e3e1bd20a0070$var$ACTION_EXPERIENCE_NAME, experienceId, {
                            actionType: actionType,
                            display: display,
                            extensionKey: extensionKey,
                            invokeType: 'client'
                        });
                        // Begin analytics instrumentation.
                        if (actionSubjectId !== undefined) fireEvent("ui.button.clicked.".concat(actionSubjectId), {
                            actionType: actionType !== null && actionType !== void 0 ? actionType : null,
                            definitionId: definitionId,
                            display: display !== null && display !== void 0 ? display : null,
                            id: id !== null && id !== void 0 ? id : experienceId,
                            resourceType: resourceType,
                            prompt: prompt
                        });
                        // Invoke action
                        _context.next = 2;
                        return actionFn();
                    case 2:
                        result = _context.sent;
                        (0, $QWcgg.mark)(markName, 'resolved');
                        (0, $1rhWa.succeedUfoExperience)($737e3e1bd20a0070$var$ACTION_EXPERIENCE_NAME, experienceId);
                        fireEvent('operational.smartLinkAction.resolved', {
                            actionType: actionType !== null && actionType !== void 0 ? actionType : null,
                            definitionId: definitionId,
                            display: display !== null && display !== void 0 ? display : null,
                            duration: (_getMeasure$duration = (_getMeasure = (0, $767sR.getMeasure)(markName, 'resolved')) === null || _getMeasure === void 0 ? void 0 : _getMeasure.duration) !== null && _getMeasure$duration !== void 0 ? _getMeasure$duration : null,
                            id: id !== null && id !== void 0 ? id : experienceId,
                            resourceType: resourceType
                        });
                        return _context.abrupt("return", result);
                    case 3:
                        _context.prev = 3;
                        _t = _context["catch"](1);
                        (0, $QWcgg.mark)(markName, 'errored');
                        (0, $gNh66.failUfoExperience)($737e3e1bd20a0070$var$ACTION_EXPERIENCE_NAME, experienceId);
                        reason = typeof _t === 'string' ? _t : _t === null || _t === void 0 ? void 0 : _t.message;
                        fireEvent('operational.smartLinkAction.unresolved', {
                            actionType: actionType !== null && actionType !== void 0 ? actionType : null,
                            definitionId: definitionId,
                            display: display !== null && display !== void 0 ? display : null,
                            duration: (_getMeasure$duration2 = (_getMeasure2 = (0, $767sR.getMeasure)(markName, 'errored')) === null || _getMeasure2 === void 0 ? void 0 : _getMeasure2.duration) !== null && _getMeasure$duration2 !== void 0 ? _getMeasure$duration2 : null,
                            id: id !== null && id !== void 0 ? id : experienceId,
                            reason: reason,
                            resourceType: resourceType
                        });
                    case 4:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    1,
                    3
                ]
            ]);
        }));
        return function(_x) {
            return _ref3.apply(this, arguments);
        };
    }(), [
        fireEvent
    ]);
};
var $737e3e1bd20a0070$export$2e2bcd8739ae039 = $737e3e1bd20a0070$var$useInvokeClientAction;

});
parcelRegister("gNh66", function(module, exports) {
$parcel$export(module.exports, "failUfoExperience", () => $c39e7c243de0b3b9$export$8dda83bafca11b77);

var $hZBUK = parcelRequire("hZBUK");
var $c39e7c243de0b3b9$export$8dda83bafca11b77 = function failUfoExperience(experienceName, id, properties) {
    var experience = (0, $hZBUK.ufoExperiences)[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};

});

parcelRegister("1rhWa", function(module, exports) {
$parcel$export(module.exports, "succeedUfoExperience", () => $10c63a093c1fd2b1$export$c5a5cf072c836c0e);

var $hZBUK = parcelRequire("hZBUK");
var $10c63a093c1fd2b1$export$c5a5cf072c836c0e = function succeedUfoExperience(experienceName, id, properties) {
    var experience = (0, $hZBUK.ufoExperiences)[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};

});


parcelRegister("186iK", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d2b6d20e0e4eb7b$export$2e2bcd8739ae039);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $5FkrB = parcelRequire("5FkrB");

var $lfOjW = parcelRequire("lfOjW");

var $2mGTc = parcelRequire("2mGTc");

var $50U6m = parcelRequire("50U6m");

var $fXlyu = parcelRequire("fXlyu");

var $aMMSX = parcelRequire("aMMSX");

var $3lLQT = parcelRequire("3lLQT");
var $0d2b6d20e0e4eb7b$var$useResolve = function useResolve() {
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    var _useSmartLinkContext = (0, $2mGTc.useSmartLinkContext)(), store = _useSmartLinkContext.store, connections = _useSmartLinkContext.connections;
    var getState = store.getState;
    var _useResponse = (0, $3lLQT.default)(), handleResolvedLinkResponse = _useResponse.handleResolvedLinkResponse, handleResolvedLinkError = _useResponse.handleResolvedLinkError;
    return (0, $5FkrB.useCallback)(/*#__PURE__*/ function() {
        var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(params) {
            var url, _params$isReloading, isReloading, _params$isMetadataReq, isMetadataRequest, _params$id, id, appearance, isInlineResolveOptimizationEnabled, isOptimizedBlockRequest, _ref2, details, currentMetadataStatus, hasData, needsOptimizedBlockData, shouldReplaceExistingData, shouldForceFetch, metadataStatus;
            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        url = params.url, _params$isReloading = params.isReloading, isReloading = _params$isReloading === void 0 ? false : _params$isReloading, _params$isMetadataReq = params.isMetadataRequest, isMetadataRequest = _params$isMetadataReq === void 0 ? false : _params$isMetadataReq, _params$id = params.id, id = _params$id === void 0 ? '' : _params$id, appearance = params.appearance;
                        isInlineResolveOptimizationEnabled = (0, $50U6m.fg)('platform_smartlink_inline_resolve_optimization');
                        isOptimizedBlockRequest = appearance === 'block' && isInlineResolveOptimizationEnabled;
                        _ref2 = getState()[url] || {
                            status: (0, $fXlyu.SmartLinkStatus).Pending,
                            details: undefined
                        }, details = _ref2.details, currentMetadataStatus = _ref2.metadataStatus;
                        hasData = !!(details && details.data || (0, $lfOjW.isEntityPresent)(details));
                        needsOptimizedBlockData = isOptimizedBlockRequest && currentMetadataStatus !== 'resolved';
                        if (!(isReloading || !hasData || isMetadataRequest || needsOptimizedBlockData)) {
                            _context.next = 1;
                            break;
                        }
                        // ORS caches each appearance separately, so optimized block requests can reuse the
                        // block cache. Preserve the existing replacement decision so a cached full response
                        // still replaces any reduced inline data already in the store.
                        shouldReplaceExistingData = isReloading || needsOptimizedBlockData;
                        shouldForceFetch = isInlineResolveOptimizationEnabled ? isReloading : shouldReplaceExistingData;
                        metadataStatus = appearance === 'inline' && !isMetadataRequest && isInlineResolveOptimizationEnabled ? 'pending' : undefined;
                        return _context.abrupt("return", connections.client.fetchData(url, shouldForceFetch, appearance).then(function(response) {
                            return handleResolvedLinkResponse(url, response, shouldReplaceExistingData, isMetadataRequest, metadataStatus);
                        }).catch(function(error) {
                            return handleResolvedLinkError(url, error, undefined, isMetadataRequest);
                        }));
                    case 1:
                        (0, $aMMSX.addMetadataToExperience)('smart-link-rendered', id, {
                            cached: true
                        });
                    case 2:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function(_x) {
            return _ref.apply(this, arguments);
        };
    }(), [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $0d2b6d20e0e4eb7b$export$2e2bcd8739ae039 = $0d2b6d20e0e4eb7b$var$useResolve;

});
parcelRegister("aMMSX", function(module, exports) {
$parcel$export(module.exports, "addMetadataToExperience", () => $7da44eb0a8fcbdfe$export$4084c0df4a03a6af);

var $hZBUK = parcelRequire("hZBUK");
var $7da44eb0a8fcbdfe$export$4084c0df4a03a6af = function addMetadataToExperience(experienceName, id, properties) {
    (0, $hZBUK.ufoExperiences)[experienceName].getInstance(id).addMetadata(properties);
};

});

parcelRegister("3lLQT", function(module, exports) {
$parcel$export(module.exports, "default", () => $270873b03b515926$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $2mGTc = parcelRequire("2mGTc");

var $jFX1F = parcelRequire("jFX1F");

var $jEI3n = parcelRequire("jEI3n");

var $e4T0y = parcelRequire("e4T0y");

var $50U6m = parcelRequire("50U6m");

var $fXlyu = parcelRequire("fXlyu");

var $knzcB = parcelRequire("knzcB");

var $frn9t = parcelRequire("frn9t");
var $270873b03b515926$var$useResponse = function useResponse() {
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    var _useSmartLinkContext = (0, $2mGTc.useSmartLinkContext)(), store = _useSmartLinkContext.store, config = _useSmartLinkContext.config;
    var getState = store.getState, dispatch = store.dispatch;
    var hasAuthFlowSupported = config.authFlow !== 'disabled';
    var setMetadataStatus = (0, $5FkrB.useCallback)(function(url, metadataStatus) {
        dispatch((0, $jFX1F.cardAction)((0, $jFX1F.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    var handleResolvedLinkError = (0, $5FkrB.useCallback)(function(url, error, response, isMetadataRequest) {
        var newState = {
            status: (0, $fXlyu.SmartLinkStatus).Pending,
            details: undefined
        };
        var _ref = getState()[url] || newState, details = _ref.details;
        var hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $jFX1F.cardAction)((0, $jFX1F.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $jFX1F.cardAction)((0, $jFX1F.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $jFX1F.cardAction)((0, $jFX1F.ACTION_RESOLVED), {
            url: url
        }, (0, $knzcB.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $jFX1F.cardAction)((0, $jFX1F.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $jFX1F.cardAction)((0, $jFX1F.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    var handleResolvedLinkSuccess = (0, $5FkrB.useCallback)(function(resourceUrl, response, isReloading, isMetadataRequest) {
        var _getState$resourceUrl;
        var metadataStatus = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'resolved';
        /**
     * Metadata status scenarios:
     * - Gate off, or a non-resolved response: use `resolved`, preserving legacy behavior and
     *   avoiding a gate exposure when the result would not affect the status.
     * - Gate on with full metadata: use the provided/default `resolved` status.
     * - Gate on with reduced inline metadata: use the provided `pending` status so block or
     *   hover rendering knows to request the full metadata later.
     * - Reduced inline metadata arriving after full metadata: keep the existing `resolved`
     *   status so an out-of-order response cannot trigger another full request.
     * - Explicit reload: allow `pending` even after full metadata, because the caller is
     *   intentionally replacing the existing data.
     */ var shouldUseProvidedMetadataStatus = (0, $e4T0y.getStatus)(response) === 'resolved' && (0, $50U6m.fg)('platform_smartlink_inline_resolve_optimization');
        var shouldPreserveResolvedMetadata = shouldUseProvidedMetadataStatus && metadataStatus === 'pending' && !isReloading && ((_getState$resourceUrl = getState()[resourceUrl]) === null || _getState$resourceUrl === void 0 ? void 0 : _getState$resourceUrl.metadataStatus) === 'resolved';
        var nextMetadataStatus = shouldUseProvidedMetadataStatus && !shouldPreserveResolvedMetadata ? metadataStatus : 'resolved';
        setMetadataStatus(resourceUrl, nextMetadataStatus);
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $jFX1F.cardAction)((0, $jFX1F.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $jFX1F.cardAction)((0, $jFX1F.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    var handleResolvedLinkResponse = (0, $5FkrB.useCallback)(function(resourceUrl, response) {
        var isReloading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var isMetadataRequest = arguments.length > 3 ? arguments[3] : undefined;
        var metadataStatus = arguments.length > 4 ? arguments[4] : undefined;
        if (!resourceUrl) return;
        var hostname = new URL(resourceUrl).hostname;
        var nextStatus = response ? (0, $e4T0y.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $jEI3n.APIError)('fallback', hostname, (0, $frn9t.ERROR_MESSAGE_OAUTH)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $jEI3n.APIError)('fatal', hostname, (0, $frn9t.ERROR_MESSAGE_FATAL)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $jEI3n.APIError)('error', hostname, (0, $frn9t.ERROR_MESSAGE_METADATA)), response, isMetadataRequest);
            return;
        }
        /**
     * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
     * more info:
     * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
     * https://react-redux.js.org/api/batch
     */ (0, $aLeHs.unstable_batchedUpdates)(function() {
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest, metadataStatus);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $5FkrB.useMemo)(function() {
        return {
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        };
    }, [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $270873b03b515926$export$2e2bcd8739ae039 = $270873b03b515926$var$useResponse;

});
parcelRegister("jEI3n", function(module, exports) {
$parcel$export(module.exports, "APIError", () => $e4f3ecd9464170fd$export$3e5b797e39668f84);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $e4f3ecd9464170fd$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $e4f3ecd9464170fd$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $e4f3ecd9464170fd$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e4f3ecd9464170fd$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $e4f3ecd9464170fd$export$3e5b797e39668f84 = /*#__PURE__*/ function(_Error) {
    function APIError(kind, hostname, message, type, extensionKey) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, APIError);
        _this = $e4f3ecd9464170fd$var$_callSuper(this, APIError, [
            "".concat(kind, ": ").concat(message)
        ]);
        _this.kind = kind;
        _this.hostname = hostname;
        _this.message = message;
        _this.type = type;
        _this.extensionKey = extensionKey;
        _this.name = 'APIError';
        // The error type received from the server.
        _this.type = type;
        // The kind mapped to on the client.
        _this.kind = kind;
        // The message received from the server.
        _this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        _this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        _this.extensionKey = extensionKey;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(APIError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(APIError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});

parcelRegister("e4T0y", function(module, exports) {
$parcel$export(module.exports, "getStatus", () => $a3fc1bdd9a416199$export$b70265791d2079d4);
var $a3fc1bdd9a416199$var$getStatusForNotFoundVisibility = function getStatusForNotFoundVisibility(meta) {
    var _meta$requestAccess;
    var accessType = (_meta$requestAccess = meta.requestAccess) === null || _meta$requestAccess === void 0 ? void 0 : _meta$requestAccess.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
var $a3fc1bdd9a416199$export$b70265791d2079d4 = function getStatus(_ref) {
    var meta = _ref.meta;
    var access = meta.access, visibility = meta.visibility;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $a3fc1bdd9a416199$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});

parcelRegister("knzcB", function(module, exports) {
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $ed614317b5367166$export$b9482e0f6d365cc7);

var $25nEq = parcelRequire("25nEq");

var $9MF4G = parcelRequire("9MF4G");
function $ed614317b5367166$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ed614317b5367166$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ed614317b5367166$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ed614317b5367166$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ed614317b5367166$export$b9482e0f6d365cc7 = function getUnauthorizedJsonLd() {
    return {
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: $ed614317b5367166$var$_objectSpread({}, (0, $9MF4G.emptyData))
    };
};

});
parcelRegister("9MF4G", function(module, exports) {
$parcel$export(module.exports, "emptyData", () => $71f875462e622a15$export$49de42a13d6e867c);
var $71f875462e622a15$export$49de42a13d6e867c = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};

});


parcelRegister("frn9t", function(module, exports) {
$parcel$export(module.exports, "ERROR_MESSAGE_OAUTH", () => $b3db561c4eeb9cf7$export$3e81ce851ffda0ad);
$parcel$export(module.exports, "ERROR_MESSAGE_FATAL", () => $b3db561c4eeb9cf7$export$45e7dda0d43d7f55);
$parcel$export(module.exports, "ERROR_MESSAGE_METADATA", () => $b3db561c4eeb9cf7$export$338f7d9ccca1975d);
var $b3db561c4eeb9cf7$export$297c39c8b9bfca0 = 'resolving';
var $b3db561c4eeb9cf7$export$b64a888338c24e0e = 'errored';
var $b3db561c4eeb9cf7$export$677b6edfa0002c70 = 'fallback';
var $b3db561c4eeb9cf7$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
var $b3db561c4eeb9cf7$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
var $b3db561c4eeb9cf7$export$338f7d9ccca1975d = 'Error resolving metadata.';

});




parcelRegister("1J71a", function(module, exports) {
$parcel$export(module.exports, "getResourceType", () => $141f70063f4a54dd$export$16c0ebb0de9b767b);
var $141f70063f4a54dd$export$16c0ebb0de9b767b = function getResourceType(details) {
    var _details$meta;
    return details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.resourceType;
};

});

parcelRegister("eDkLs", function(module, exports) {
$parcel$export(module.exports, "useSmartCardState", () => $aa74d091a869321b$export$b0444d00ba7313c6);

var $2hCy3 = parcelRequire("2hCy3");

var $2mGTc = parcelRequire("2mGTc");
var $aa74d091a869321b$var$PENDING_STATE = {
    status: 'pending'
};
function $aa74d091a869321b$export$b0444d00ba7313c6(url) {
    var _useSmartLinkContext = (0, $2mGTc.useSmartLinkContext)(), store = _useSmartLinkContext.store;
    var cardState = (0, $2hCy3.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, function(state) {
        return state[url];
    });
    return cardState !== null && cardState !== void 0 ? cardState : $aa74d091a869321b$var$PENDING_STATE;
}

});
parcelRegister("2hCy3", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1fF0z"));

});
parcelRegister("1fF0z", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $0e970089a187f9cc$export$bf730a2d8bf68b42, (v) => $0e970089a187f9cc$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0e970089a187f9cc$export$bf730a2d8bf68b42;
"use strict";

var $5FkrB = parcelRequire("5FkrB");

var $h209R = parcelRequire("h209R");
function $0e970089a187f9cc$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $0e970089a187f9cc$var$objectIs = "function" === typeof Object.is ? Object.is : $0e970089a187f9cc$var$is, $0e970089a187f9cc$var$useSyncExternalStore = $h209R.useSyncExternalStore, $0e970089a187f9cc$var$useRef = $5FkrB.useRef, $0e970089a187f9cc$var$useEffect = $5FkrB.useEffect, $0e970089a187f9cc$var$useMemo = $5FkrB.useMemo, $0e970089a187f9cc$var$useDebugValue = $5FkrB.useDebugValue;
$0e970089a187f9cc$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $0e970089a187f9cc$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $0e970089a187f9cc$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($0e970089a187f9cc$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $0e970089a187f9cc$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $0e970089a187f9cc$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $0e970089a187f9cc$var$useDebugValue(value);
    return value;
};

});



parcelRegister("l9vtt", function(module, exports) {
$parcel$export(module.exports, "useScheduledRegister", () => $f662da5fe91e2f67$export$db80d61271e4d5af);
/**
 * This is a scheduled batched register mechanism for resolving blue hyperlinks while the page is idle.
 * i.e. SharePoint tenants with the same hostname will be grouped together before the register is made.
 */ 
var $5FkrB = parcelRequire("5FkrB");
var $f662da5fe91e2f67$var$batchQueue = new Map();
var $f662da5fe91e2f67$var$batchTimeouts = new Map();
var $f662da5fe91e2f67$var$BATCH_DELAY = 250;
var $f662da5fe91e2f67$var$executeBatch = function executeBatch(hostname) {
    var items = $f662da5fe91e2f67$var$batchQueue.get(hostname) || [];
    if (items.length === 0) return;
    $f662da5fe91e2f67$var$batchQueue.delete(hostname);
    $f662da5fe91e2f67$var$batchTimeouts.delete(hostname);
    items.forEach(function(_ref) {
        var register = _ref.register, resolve = _ref.resolve, reject = _ref.reject;
        register().then(resolve).catch(reject);
    });
};
var $f662da5fe91e2f67$var$addToBatch = function addToBatch(hostname, item) {
    if (!$f662da5fe91e2f67$var$batchQueue.has(hostname)) $f662da5fe91e2f67$var$batchQueue.set(hostname, []);
    $f662da5fe91e2f67$var$batchQueue.get(hostname).push(item);
    if ($f662da5fe91e2f67$var$batchTimeouts.has(hostname)) clearTimeout($f662da5fe91e2f67$var$batchTimeouts.get(hostname));
    $f662da5fe91e2f67$var$batchTimeouts.set(hostname, setTimeout(function() {
        $f662da5fe91e2f67$var$executeBatch(hostname);
    }, $f662da5fe91e2f67$var$BATCH_DELAY));
};
var $f662da5fe91e2f67$export$db80d61271e4d5af = function useScheduledRegister(href, register) {
    var isScheduled = (0, $5FkrB.useRef)(false);
    var scheduledRegister = (0, $5FkrB.useCallback)(function() {
        if (!href || !register || isScheduled.current) return Promise.resolve();
        isScheduled.current = true;
        return new Promise(function(_resolve, _reject) {
            var scheduleRegister = function scheduleRegister() {
                try {
                    var hostname = new URL(href).hostname;
                    $f662da5fe91e2f67$var$addToBatch(hostname, {
                        href: href,
                        register: register,
                        resolve: function resolve(value) {
                            isScheduled.current = false;
                            _resolve(value);
                        },
                        reject: function reject(error) {
                            isScheduled.current = false;
                            _reject(error);
                        }
                    });
                } catch (error) {
                    isScheduled.current = false;
                    register().then(_resolve).catch(_reject);
                }
            };
            if (typeof window !== 'undefined') {
                if ('requestIdleCallback' in window) window.requestIdleCallback(scheduleRegister);
                else setTimeout(scheduleRegister, 0);
            } else scheduleRegister();
        });
    }, [
        href,
        register
    ]);
    return scheduledRegister;
};

});


parcelRegister("fGRFy", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6c468dabe0284aa$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $9kTNw = parcelRequire("9kTNw");

var $iUVrp = parcelRequire("iUVrp");
var $b6c468dabe0284aa$var$useResolveHyperlinkValidator = function useResolveHyperlinkValidator() {
    var href = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var hasSmartCardProvider = !!(0, $5FkrB.useContext)((0, $9kTNw.SmartCardContext));
    return hasSmartCardProvider && (0, $iUVrp.shouldResolveUrl)(href);
};
var $b6c468dabe0284aa$export$2e2bcd8739ae039 = $b6c468dabe0284aa$var$useResolveHyperlinkValidator;

});
parcelRegister("iUVrp", function(module, exports) {
$parcel$export(module.exports, "shouldResolveUrl", () => $dc5a038dc1a34f14$export$aa45d36a96427452);
var $dc5a038dc1a34f14$var$allowedHostnames = [
    'sharepoint.com',
    'onedrive.live.com',
    'docs.google.com',
    'drive.google.com'
];
var $dc5a038dc1a34f14$export$aa45d36a96427452 = function shouldResolveUrl(href) {
    try {
        var hostname = new URL(href).hostname.toLowerCase();
        return $dc5a038dc1a34f14$var$allowedHostnames.some(function(allowedHostname) {
            return hostname.includes(allowedHostname);
        });
    } catch (_unused) {
        return false;
    }
};

});


parcelRegister("LjX2F", function(module, exports) {
$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $08e3ddcfc1ab5f1e$export$eaff10f7ec59c455);

var $5FkrB = parcelRequire("5FkrB");

var $l9NcB = parcelRequire("l9NcB");

var $50U6m = parcelRequire("50U6m");

var $eDkLs = parcelRequire("eDkLs");

var $5dx1A = parcelRequire("5dx1A");
var $08e3ddcfc1ab5f1e$export$eaff10f7ec59c455 = function SmartLinkAnalyticsContext(_ref) {
    var children = _ref.children, display = _ref.display, id = _ref.id, source = _ref.source, url = _ref.url;
    var _useSmartLinkState = (0, $eDkLs.useSmartCardState)(url), details = _useSmartLinkState.details, status = _useSmartLinkState.status, error = _useSmartLinkState.error;
    var data = (0, $5dx1A.getSmartLinkAnalyticsContext)({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url,
        error: (0, $50U6m.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? error : undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $l9NcB.default), {
        data: data
    }, children);
};

});
parcelRegister("5dx1A", function(module, exports) {
$parcel$export(module.exports, "getSmartLinkAnalyticsContext", () => $3cc7c8a21ef8b4b6$export$5732565218b28467);

var $25nEq = parcelRequire("25nEq");

var $l7zul = parcelRequire("l7zul");

var $8ckEN = parcelRequire("8ckEN");
function $3cc7c8a21ef8b4b6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3cc7c8a21ef8b4b6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3cc7c8a21ef8b4b6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3cc7c8a21ef8b4b6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3cc7c8a21ef8b4b6$var$getExtendedResolvedAttributes = function getExtendedResolvedAttributes(linkDetails, details, linkStatus, error) {
    var _details$meta$definit, _details$meta, _details$meta$resourc, _details$meta2;
    return $3cc7c8a21ef8b4b6$var$_objectSpread({
        definitionId: (_details$meta$definit = details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.definitionId) !== null && _details$meta$definit !== void 0 ? _details$meta$definit : null,
        resourceType: (_details$meta$resourc = details === null || details === void 0 || (_details$meta2 = details.meta) === null || _details$meta2 === void 0 ? void 0 : _details$meta2.resourceType) !== null && _details$meta$resourc !== void 0 ? _details$meta$resourc : null
    }, (0, $l7zul.getResolvedAttributes)(linkDetails, details, linkStatus, error));
};
var $3cc7c8a21ef8b4b6$export$5732565218b28467 = function getSmartLinkAnalyticsContext(_ref) {
    var display = _ref.display, id = _ref.id, response = _ref.response, source = _ref.source, status = _ref.status, url = _ref.url, error = _ref.error;
    var resolvedAttributes = $3cc7c8a21ef8b4b6$var$getExtendedResolvedAttributes({
        url: url,
        displayCategory: display === 'url' ? 'link' : 'smartLink'
    }, response, status, error);
    return {
        source: source,
        attributes: $3cc7c8a21ef8b4b6$var$_objectSpread($3cc7c8a21ef8b4b6$var$_objectSpread({}, (0, $8ckEN.context)), {}, {
            display: display,
            id: id
        }, resolvedAttributes)
    };
};

});
parcelRegister("l7zul", function(module, exports) {
$parcel$export(module.exports, "getResolvedAttributes", () => $f605c7b500ebfbc5$export$7243431f5325a7b);

var $gBPpF = parcelRequire("gBPpF");

var $7eB7B = parcelRequire("7eB7B");

var $50U6m = parcelRequire("50U6m");
var $f605c7b500ebfbc5$export$7243431f5325a7b = function getResolvedAttributes(linkDetails, details, linkStatus, error) {
    var _details$meta$request, _details$meta, _ref, _details$meta$key, _details$meta2, _details$meta$key2, _details$meta3, _details$meta$tenantI, _details$meta4, _details$meta$activat, _details$meta5, _details$meta$contain, _details$meta6, _details$meta$categor, _details$meta7, _details$meta$product, _details$meta8, _details$meta$subprod, _details$meta9, _details$meta$objectI, _details$meta0, _details$meta$resourc, _details$meta1;
    var status = linkStatus !== null && linkStatus !== void 0 ? linkStatus : details && (0, $gBPpF.getStatus)(details);
    var displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $7eB7B.getDisplayCategory)(status);
    return {
        status: status !== null && status !== void 0 ? status : null,
        statusDetails: (_details$meta$request = details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 || (_details$meta = _details$meta.requestAccess) === null || _details$meta === void 0 ? void 0 : _details$meta.accessType) !== null && _details$meta$request !== void 0 ? _details$meta$request : null,
        displayCategory: displayCategory,
        extensionKey: (0, $50U6m.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? (_ref = (_details$meta$key = details === null || details === void 0 || (_details$meta2 = details.meta) === null || _details$meta2 === void 0 ? void 0 : _details$meta2.key) !== null && _details$meta$key !== void 0 ? _details$meta$key : error === null || error === void 0 ? void 0 : error.extensionKey) !== null && _ref !== void 0 ? _ref : null : (_details$meta$key2 = details === null || details === void 0 || (_details$meta3 = details.meta) === null || _details$meta3 === void 0 ? void 0 : _details$meta3.key) !== null && _details$meta$key2 !== void 0 ? _details$meta$key2 : null,
        destinationTenantId: (_details$meta$tenantI = details === null || details === void 0 || (_details$meta4 = details.meta) === null || _details$meta4 === void 0 ? void 0 : _details$meta4.tenantId) !== null && _details$meta$tenantI !== void 0 ? _details$meta$tenantI : null,
        destinationActivationId: (_details$meta$activat = details === null || details === void 0 || (_details$meta5 = details.meta) === null || _details$meta5 === void 0 ? void 0 : _details$meta5.activationId) !== null && _details$meta$activat !== void 0 ? _details$meta$activat : null,
        destinationContainerId: (_details$meta$contain = details === null || details === void 0 || (_details$meta6 = details.meta) === null || _details$meta6 === void 0 ? void 0 : _details$meta6.containerId) !== null && _details$meta$contain !== void 0 ? _details$meta$contain : null,
        destinationCategory: (_details$meta$categor = details === null || details === void 0 || (_details$meta7 = details.meta) === null || _details$meta7 === void 0 ? void 0 : _details$meta7.category) !== null && _details$meta$categor !== void 0 ? _details$meta$categor : null,
        destinationProduct: (_details$meta$product = details === null || details === void 0 || (_details$meta8 = details.meta) === null || _details$meta8 === void 0 ? void 0 : _details$meta8.product) !== null && _details$meta$product !== void 0 ? _details$meta$product : null,
        destinationSubproduct: (_details$meta$subprod = details === null || details === void 0 || (_details$meta9 = details.meta) === null || _details$meta9 === void 0 ? void 0 : _details$meta9.subproduct) !== null && _details$meta$subprod !== void 0 ? _details$meta$subprod : null,
        destinationObjectId: (_details$meta$objectI = details === null || details === void 0 || (_details$meta0 = details.meta) === null || _details$meta0 === void 0 ? void 0 : _details$meta0.objectId) !== null && _details$meta$objectI !== void 0 ? _details$meta$objectI : null,
        destinationObjectType: (_details$meta$resourc = details === null || details === void 0 || (_details$meta1 = details.meta) === null || _details$meta1 === void 0 ? void 0 : _details$meta1.resourceType) !== null && _details$meta$resourc !== void 0 ? _details$meta$resourc : null,
        canBeDatasource: ((details === null || details === void 0 ? void 0 : details.datasources) || []).length > 0
    };
};

});
parcelRegister("gBPpF", function(module, exports) {
$parcel$export(module.exports, "getStatus", () => $c177fb96f8007561$export$b70265791d2079d4);
var $c177fb96f8007561$var$getStatusForNotFoundVisibility = function getStatusForNotFoundVisibility(meta) {
    var _meta$requestAccess;
    var accessType = (_meta$requestAccess = meta.requestAccess) === null || _meta$requestAccess === void 0 ? void 0 : _meta$requestAccess.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
var $c177fb96f8007561$export$b70265791d2079d4 = function getStatus(_ref) {
    var meta = _ref.meta;
    var access = meta.access, visibility = meta.visibility;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $c177fb96f8007561$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});

parcelRegister("7eB7B", function(module, exports) {
$parcel$export(module.exports, "getDisplayCategory", () => $5446a2cd3fdc9c35$export$28ddbae335bd80b5);
var $5446a2cd3fdc9c35$export$28ddbae335bd80b5 = function getDisplayCategory(status) {
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});




parcelRegister("5wLt1", function(module, exports) {
$parcel$export(module.exports, "isAuxClick", () => $4064c2dde0817d93$export$15213acd7ac7d39a);
/**
 * Returns true for genuine middle-clicks (button === 1).
 * Filters out Windows right-clicks, which fire onAuxClick with button === 2
 * in addition to onContextMenu, to prevent double-counting.
 */ var $4064c2dde0817d93$export$15213acd7ac7d39a = function isAuxClick(e) {
    return e.button === 1;
};

});

parcelRegister("6OJWS", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f6b0e09cf2ff659$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $9Pk7k = parcelRequire("9Pk7k");
/**
 * HOC to wrap component with IntlProvider if not available
 */ var $4f6b0e09cf2ff659$var$withIntlProvider = function withIntlProvider(Component) {
    return function(props) {
        var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Component, props);
        return props !== null && props !== void 0 && props.intl ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9Pk7k.default), {
            locale: "en"
        }, content);
    };
};
var $4f6b0e09cf2ff659$export$2e2bcd8739ae039 = $4f6b0e09cf2ff659$var$withIntlProvider;

});

parcelRegister("2LB3L", function(module, exports) {
$parcel$export(module.exports, "useFire3PWorkflowsClickEvent", () => $203cb7dd11db7bd3$export$e682245dc886cff2);

var $bDUuG = parcelRequire("bDUuG");
function $203cb7dd11db7bd3$export$e682245dc886cff2(firstPartyIdentifier, thirdPartyARI) {
    var _useAnalyticsEventsNe = (0, $bDUuG.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEventsNe.createAnalyticsEvent;
    return function() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$isAuxClick = _ref.isAuxClick, isAuxClick = _ref$isAuxClick === void 0 ? false : _ref$isAuxClick, _ref$isContextMenu = _ref.isContextMenu, isContextMenu = _ref$isContextMenu === void 0 ? false : _ref$isContextMenu;
        var smartlinkClickAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'smartLink',
            actionSubjectId: 'smartlinkClickAnalyticsWorkflows',
            eventType: 'ui',
            attributes: {
                eventName: 'smartLinkClickAnalyticsThirdPartyWorkflows',
                firstPartyIdentifier: firstPartyIdentifier,
                isAuxClick: isAuxClick,
                isContextMenu: isContextMenu
            },
            nonPrivacySafeAttributes: {
                thirdPartyARI: thirdPartyARI
            }
        });
        smartlinkClickAnalyticsEvent.fire('media');
    };
}

});


parcelRegister("hbdZB", function(module, exports) {
$parcel$export(module.exports, "default", () => $c81e5166218a95c2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $bgNpv = parcelRequire("bgNpv");
var $ach6K = parcelRequire("ach6K");
var $9Pk7k = parcelRequire("9Pk7k");

var $jgNUw = parcelRequire("jgNUw");

var $8F9hT = parcelRequire("8F9hT");

var $jh6Of = parcelRequire("jh6Of");

var $fv8CT = parcelRequire("fv8CT");

var $3oYKE = parcelRequire("3oYKE");

var $acmdv = parcelRequire("acmdv");

var $ayzaw = parcelRequire("ayzaw");

var $lh9Pt = parcelRequire("lh9Pt");

var $aSVEw = parcelRequire("aSVEw");
var $c81e5166218a95c2$var$breakWordsCss = null;
var $c81e5166218a95c2$var$WarningModal = function WarningModal(props) {
    var isOpen = props.isOpen, unsafeLinkText = props.unsafeLinkText, url = props.url, onClose = props.onClose, onContinue = props.onContinue, intl = props.intl;
    var content = /*#__PURE__*/ $5FkrB.createElement((0, $lh9Pt.default), null, isOpen && /*#__PURE__*/ $5FkrB.createElement((0, $fv8CT.default), {
        onClose: onClose,
        testId: "link-with-safety-warning"
    }, /*#__PURE__*/ $5FkrB.createElement((0, $acmdv.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $5FkrB.createElement((0, $ayzaw.default), {
        appearance: "warning"
    }, /*#__PURE__*/ $5FkrB.createElement((0, $bgNpv.default), (0, $aSVEw.messages).check_this_link))), /*#__PURE__*/ $5FkrB.createElement((0, $jh6Of.default), null, /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            "_o5726vc6 _1nmz9jpi"
        ])
    }, url && unsafeLinkText && /*#__PURE__*/ $5FkrB.createElement((0, $bgNpv.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, (0, $aSVEw.messages).link_safety_warning_message, {
        values: {
            unsafeLinkText: unsafeLinkText,
            a: function a() {
                return /*#__PURE__*/ $5FkrB.createElement((0, $8F9hT.default), {
                    href: url,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, url);
            }
        }
    })))), /*#__PURE__*/ $5FkrB.createElement((0, $3oYKE.default), null, /*#__PURE__*/ $5FkrB.createElement((0, $jgNUw.default), {
        appearance: "subtle",
        onClick: onClose
    }, /*#__PURE__*/ $5FkrB.createElement((0, $bgNpv.default), (0, $aSVEw.messages).go_back)), /*#__PURE__*/ $5FkrB.createElement((0, $jgNUw.default), {
        appearance: "warning",
        onClick: onContinue,
        autoFocus: true
    }, /*#__PURE__*/ $5FkrB.createElement((0, $bgNpv.default), (0, $aSVEw.messages).continue)))));
    return intl ? content : /*#__PURE__*/ $5FkrB.createElement((0, $9Pk7k.default), {
        locale: "en"
    }, content);
};
var $c81e5166218a95c2$var$_default_1 = (0, $ach6K.default)($c81e5166218a95c2$var$WarningModal, {
    enforceContext: false
});
var $c81e5166218a95c2$export$2e2bcd8739ae039 = $c81e5166218a95c2$var$_default_1;

});
parcelRegister("jh6Of", function(module, exports) {
$parcel$export(module.exports, "default", () => $e084e30e97499a91$export$2e2bcd8739ae039);
/* modal-body.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $3FlkA = parcelRequire("3FlkA");

var $k8Idm = parcelRequire("k8Idm");

var $9R5s9 = parcelRequire("9R5s9");

var $6nKMA = parcelRequire("6nKMA");
var $e084e30e97499a91$var$styles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _11c8fhey",
    paddingBlock: "_1rjcv77o",
    paddingInline: "_18zr1ejb"
};
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $e084e30e97499a91$var$ModalBody = function ModalBody(props) {
    var children = props.children, userDefinedTestId = props.testId, _props$hasInlinePaddi = props.hasInlinePadding, hasInlinePadding = _props$hasInlinePaddi === void 0 ? true : _props$hasInlinePaddi;
    var _useModal = (0, $k8Idm.useModal)(), modalTestId = _useModal.testId;
    var shouldScrollInViewport = (0, $6nKMA.default)();
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--body");
    return shouldScrollInViewport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        "data-testid": testId,
        className: (0, $970q7.default)([
            $e084e30e97499a91$var$styles.root,
            hasInlinePadding && $e084e30e97499a91$var$styles.paddingInline
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3FlkA.TouchScrollable), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9R5s9.default), {
        testId: userDefinedTestId || modalTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        "data-testid": testId,
        className: (0, $970q7.default)([
            $e084e30e97499a91$var$styles.root,
            /**
     * Adding block padding for scroll keylines, which are only shown when the scrolling
     * is on the container.
     */ $e084e30e97499a91$var$styles.paddingBlock,
            hasInlinePadding && $e084e30e97499a91$var$styles.paddingInline
        ])
    }, children)));
};
var $e084e30e97499a91$export$2e2bcd8739ae039 = $e084e30e97499a91$var$ModalBody;

});
parcelRegister("k8Idm", function(module, exports) {
$parcel$export(module.exports, "useModal", () => $ea96da15490aa5e1$export$33ffd74ebf07f060);

var $5FkrB = parcelRequire("5FkrB");

var $fAYgP = parcelRequire("fAYgP");
var $ea96da15490aa5e1$export$33ffd74ebf07f060 = function useModal() {
    var modalContext = (0, $5FkrB.useContext)((0, $fAYgP.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});
parcelRegister("fAYgP", function(module, exports) {
$parcel$export(module.exports, "ModalContext", () => $b5a8f83d2810f673$export$ab57792b9b6974a6);

var $5FkrB = parcelRequire("5FkrB");
var $b5a8f83d2810f673$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});


parcelRegister("9R5s9", function(module, exports) {
$parcel$export(module.exports, "default", () => $72cd4b2b8adc7c2e$export$2e2bcd8739ae039);
/* scroll-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $iYJcE = parcelRequire("iYJcE");


var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $45Zis = parcelRequire("45Zis");

var $hRJ5R = parcelRequire("hRJ5R");

var $iO8GM = parcelRequire("iO8GM");

var $eVb4V = parcelRequire("eVb4V");

var $Xr0F9 = parcelRequire("Xr0F9");

var $5yoeA = parcelRequire("5yoeA");
var $72cd4b2b8adc7c2e$var$keylineColor = "var(--ds-border, #0B120E24)";
var $72cd4b2b8adc7c2e$var$styles = {
    base: "_kkes1kw7 _1e0c1kw7 _2lx21kw7 _16jlkb7n _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1reo15vq _18m91wug _1jykn7od _wzg61wug",
    topKeyline: "_mqm2ia51",
    bottomKeyline: "_179ria51"
};
var $72cd4b2b8adc7c2e$var$keylineHeight = 1;
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ var $72cd4b2b8adc7c2e$var$ScrollContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, children = _ref.children;
    var scrollableRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), showTopKeyline = _useState2[0], setTopKeyline = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), showBottomKeyline = _useState4[0], setBottomKeyline = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), showContentFocus = _useState6[0], setContentFocus = _useState6[1];
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $5FkrB.useEffect)(function() {
        var schedule = (0, $45Zis.default)(function() {
            var target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    var setLazyKeylines = (0, $Xr0F9.default)((0, $45Zis.default)(function() {
        var target = scrollableRef.current;
        if (target) {
            var scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $72cd4b2b8adc7c2e$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $72cd4b2b8adc7c2e$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $5FkrB.useEffect)(function() {
        var target = scrollableRef.current;
        setLazyKeylines();
        var unbindWindowEvent = (0, $7QpUe.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        var unbindTargetEvent = target ? (0, $7QpUe.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $eVb4V.default);
        return function() {
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5yoeA.Focusable), {
        as: "div",
        isInset: true,
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        testId: testId && "".concat(testId, "--scrollable"),
        ref: (0, $iO8GM.default)([
            ref,
            scrollableRef
        ]),
        xcss: (0, $hRJ5R.cx)($72cd4b2b8adc7c2e$var$styles.base, showTopKeyline && $72cd4b2b8adc7c2e$var$styles.topKeyline, showBottomKeyline && $72cd4b2b8adc7c2e$var$styles.bottomKeyline)
    }, children);
});
$72cd4b2b8adc7c2e$var$ScrollContainer.displayName = 'ScrollContainer';
var $72cd4b2b8adc7c2e$export$2e2bcd8739ae039 = $72cd4b2b8adc7c2e$var$ScrollContainer;

});
parcelRegister("Xr0F9", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b2a765d61005f29$export$2e2bcd8739ae039);

var $b9s5x = parcelRequire("b9s5x");
function $0b2a765d61005f29$export$2e2bcd8739ae039(callback) {
    var ref = (0, $b9s5x.default)(function() {
        return callback;
    });
    return ref.current;
}

});


parcelRegister("6nKMA", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a592e18864cff1e$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $27rGG = parcelRequire("27rGG");
function $4a592e18864cff1e$export$2e2bcd8739ae039() {
    var shouldScrollInViewport = (0, $5FkrB.useContext)((0, $27rGG.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});
parcelRegister("27rGG", function(module, exports) {
$parcel$export(module.exports, "ScrollContext", () => $18b1b6608eccade9$export$dece24112a937f92);

var $5FkrB = parcelRequire("5FkrB");
var $18b1b6608eccade9$export$dece24112a937f92 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});



parcelRegister("fv8CT", function(module, exports) {
$parcel$export(module.exports, "default", () => $b49071420a48032f$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $9REMj = parcelRequire("9REMj");
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $b49071420a48032f$var$ModalWrapper = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9REMj.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        isFullScreen: false,
        ref: ref
    }));
});
$b49071420a48032f$var$ModalWrapper.displayName = 'ModalWrapper';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b49071420a48032f$export$2e2bcd8739ae039 = $b49071420a48032f$var$ModalWrapper;

});
parcelRegister("9REMj", function(module, exports) {
$parcel$export(module.exports, "default", () => $72e8b2045ea4c80b$export$2e2bcd8739ae039);
/* modal-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $7QpUe = parcelRequire("7QpUe");

var $69J3E = parcelRequire("69J3E");

var $3FlkA = parcelRequire("3FlkA");

var $aLEtb = parcelRequire("aLEtb");

var $1qBWl = parcelRequire("1qBWl");

var $eVb4V = parcelRequire("eVb4V");

var $gpUQB = parcelRequire("gpUQB");

var $h8qvJ = parcelRequire("h8qvJ");

var $ezd8U = parcelRequire("ezd8U");

var $iUCre = parcelRequire("iUCre");

var $aAQBJ = parcelRequire("aAQBJ");

var $dZoDs = parcelRequire("dZoDs");

var $7ujRa = parcelRequire("7ujRa");

var $50U6m = parcelRequire("50U6m");

var $fV8Mu = parcelRequire("fV8Mu");

var $fGFYU = parcelRequire("fGFYU");

var $64A04 = parcelRequire("64A04");

var $gk5MQ = parcelRequire("gk5MQ");

var $90MLH = parcelRequire("90MLH");

var $a39W7 = parcelRequire("a39W7");

var $fAYgP = parcelRequire("fAYgP");

var $bL9ob = parcelRequire("bL9ob");

var $izyyW = parcelRequire("izyyW");

var $5YyDq = parcelRequire("5YyDq");

var $amgLb = parcelRequire("amgLb");

var $6fqgi = parcelRequire("6fqgi");

var $27rGG = parcelRequire("27rGG");

var $cTagc = parcelRequire("cTagc");

var $4tRFQ = parcelRequire("4tRFQ");
var $72e8b2045ea4c80b$var$fillScreenStyles = null;
/**
 * Styles applied to the <dialog> wrapper, NOT the visual modal surface.
 */ var $72e8b2045ea4c80b$var$dialogStyles = {
    'body-scroll': "_1reoewfl _18m9ewfl _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1sg41wqb _maxs1wug _1jvh1wqb _1uca1wug",
    'viewport-scroll': "_ln19p27b _1bsbauwl _4t3i1kxc",
    'full-screen': ""
};
// Visual styles for modal content inside native <dialog>.
// Uses cssMap (not css) to avoid triggering no-nested-styles lint rule.
var $72e8b2045ea4c80b$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
/**
 * Styles applied to the visual modal surface.
 */ var $72e8b2045ea4c80b$var$surfaceStyles = {
    root: "_1e0c1txw _2lx21bp4 _bfhk1bhr _syazi7uo _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _zg7p130s",
    borderRadius: "_2rkoidpf _epkxpb1k"
};
var $72e8b2045ea4c80b$var$topLayerScrollModeStyles = {
    'full-screen': "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
    'viewport-scroll': "_4t3i1kxc _1sg41wqb _maxs1wug _1jvh1wqb _1uca1wug _1mpv184x _1jyk17ks _g7116m9r _we1i18uh",
    'body-scroll': "_1bsbauwl _4t3i1kxc _1jyk17ks _g7116m9r _we1i18uh"
};
var $72e8b2045ea4c80b$var$topLayerAutoHeightStyles = null;
var $72e8b2045ea4c80b$var$allowlistElements = function allowlistElements(element, callback) {
    // Allow focus outside modal when AUI dialog is visible
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- legacy FocusLock allowlist
    if (document.querySelector('.aui-blanket:not([hidden])')) return false;
    // Optional callback to let consumers exclude elements from focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
};
// Analytics-wrapped close handler. Extracted so both rendering paths build it
// identically.
function $72e8b2045ea4c80b$var$useModalCloseHandler(providedOnClose) {
    return (0, $aLEtb.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, $eVb4V.default),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: "@atlaskit/modal-dialog",
        packageVersion: "16.6.6"
    });
}
function $72e8b2045ea4c80b$var$getScrollMode(_ref) {
    var shouldScrollInViewport = _ref.shouldScrollInViewport, isFullScreen = _ref.isFullScreen;
    if (isFullScreen) return 'full-screen';
    if (shouldScrollInViewport) return 'viewport-scroll';
    return 'body-scroll';
}
function $72e8b2045ea4c80b$var$isWidthName(value) {
    return (0, $cTagc.width).values.includes(value);
}
function $72e8b2045ea4c80b$var$getTopLayerSurfaceWidth(input) {
    if (!input) return 'auto';
    if (typeof input === 'number') return "".concat(input, "px");
    if ($72e8b2045ea4c80b$var$isWidthName(input)) return "".concat((0, $cTagc.width).widths[input], "px");
    if (input.endsWith('%')) // Percentage widths need special handling in the top layer.
    // In legacy, the percentage resolved against the Positioner's max-width
    // (100vw - 120px). In the top layer, the <dialog>'s containing block is the
    // viewport (100vw), so a raw percentage would produce a wider modal.
    // Transform e.g. '42%' → 'calc(42 * (100vw - 120px) / 100)' to match legacy.
    return "calc(".concat(parseFloat(input), " * (100vw - 120px) / 100)");
    return input;
}
function $72e8b2045ea4c80b$var$getTopLayerSurfaceHeight(input) {
    if (!input) // Although this value would ordinarily fill the viewport height,
    // there is also a `max-height: max-content` applied to keep it constrained.
    // But we need to provide the modal with a fixed height (non-keyword, non-percentage)
    // in order for child elements with 100% height to work correctly.
    return 'calc(100vh - 120px)';
    if (typeof input === 'number') return "".concat(input, "px");
    if (input.endsWith('%')) // Percentage heights need special handling in the top layer.
    // In legacy, the percentage resolved against the Positioner's max-height
    // (100vh - 120px). In the top layer, the <dialog>'s containing block is the
    // viewport (100vh), so a raw percentage would produce a taller modal.
    // Transform e.g. '42%' → 'calc(42 * (100vh - 120px) / 100)' to match legacy.
    return "calc(".concat(parseFloat(input), " * (100vh - 120px) / 100)");
    return input;
}
function $72e8b2045ea4c80b$var$getDialogDismissedBy(_ref2) {
    var shouldCloseOnEscapePress = _ref2.shouldCloseOnEscapePress, shouldCloseOnOverlayClick = _ref2.shouldCloseOnOverlayClick;
    if (shouldCloseOnEscapePress && shouldCloseOnOverlayClick) return 'escape-and-outside-click';
    if (shouldCloseOnEscapePress) return 'escape';
    return 'none';
}
/**
 * Top-layer rendering path (platform-dst-top-layer).
 *
 * Replaces Portal, FocusLock, ScrollLock, Blanket, Positioner, and z-index
 * management with native <dialog> via @atlaskit/top-layer/dialog.
 *
 * Key decisions:
 * - Animation: CSS transitions via @starting-style / allow-discrete.
 * - Close gating: Dialog only forwards allowed reasons.
 * - onClose event param: undefined - consumers should use close reason.
 * - Focus restoration: native <dialog> behavior replaces react-focus-lock's
 *   returnFocus (see accessibility-criteria.md).
 *
 * Every hook here runs unconditionally: this component only mounts on the
 * top-layer path, so it never shares a hook sequence with the legacy path.
 */ function $72e8b2045ea4c80b$var$ModalWrapperTopLayer(props) {
    var autoFocus = props.autoFocus, _props$shouldCloseOnE = props.shouldCloseOnEscapePress, shouldCloseOnEscapePress = _props$shouldCloseOnE === void 0 ? true : _props$shouldCloseOnE, _props$shouldCloseOnO = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _props$shouldCloseOnO === void 0 ? true : _props$shouldCloseOnO, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, _props$shouldReturnFo = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo === void 0 ? true : _props$shouldReturnFo, providedOnClose = props.onClose, _props$onStackChange = props.onStackChange, onStackChange = _props$onStackChange === void 0 ? (0, $eVb4V.default) : _props$onStackChange, isBlanketHidden = props.isBlanketHidden, children = props.children, height = props.height, _props$width = props.width, width = _props$width === void 0 ? 'medium' : _props$width, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, label = props.label, testId = props.testId, _props$isFullScreen = props.isFullScreen, isFullScreen = _props$isFullScreen === void 0 ? false : _props$isFullScreen;
    (0, $bL9ob.default)({
        onStackChange: onStackChange
    });
    var onCloseHandler = $72e8b2045ea4c80b$var$useModalCloseHandler(providedOnClose);
    var _useExitingPersistenc = (0, $dZoDs.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinish = _useExitingPersistenc.onFinish;
    // Native <dialog> always restores focus on close - no opt-out via shouldReturnFocus.
    var defaultTestId = testId || 'modal-dialog';
    var id = (0, $h8qvJ.useId)();
    var titleId = "modal-dialog-title-".concat(id);
    // Content container ref - used for onOpenComplete/onCloseComplete callbacks.
    var contentRef = (0, $5FkrB.useRef)(null);
    // Cache last content element for onCloseComplete after children unmount
    // (with reduced motion, contentRef clears before onExitFinish fires).
    var lastContentElRef = (0, $5FkrB.useRef)(null);
    if (contentRef.current) lastContentElRef.current = contentRef.current;
    // Native <dialog> ref - needed for ExitingPersistence to call dialog.close().
    var dialogRef = (0, $5FkrB.useRef)(null);
    var modalDialogContext = (0, $5FkrB.useMemo)(function() {
        return {
            testId: defaultTestId,
            titleId: titleId,
            onClose: onCloseHandler,
            hasProvidedOnClose: Boolean(providedOnClose),
            isFullScreen: isFullScreen !== null && isFullScreen !== void 0 ? isFullScreen : false
        };
    }, [
        defaultTestId,
        titleId,
        onCloseHandler,
        providedOnClose,
        isFullScreen
    ]);
    // Dialog has already applied the close behavior configured by `dismissedBy`.
    // Pass a synthetic event to satisfy the KeyboardOrMouseEvent contract.
    var onDialogClose = (0, $5FkrB.useCallback)(function(_ref3) {
        var reason = _ref3.reason;
        onCloseHandler((0, $gk5MQ.createCloseEvent)({
            reason: reason
        }));
    }, [
        onCloseHandler
    ]);
    var dismissedBy = $72e8b2045ea4c80b$var$getDialogDismissedBy({
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick
    });
    var shouldShimCloseOnOverlayClick = shouldCloseOnOverlayClick && !shouldCloseOnEscapePress;
    // Required until we fully remove `shouldCloseOnEscapePress`.
    // Dialog's `dismissedBy` options do not support outside click without Escape (because it is a bad pattern)
    (0, $5FkrB.useEffect)(function() {
        var dialog = dialogRef.current;
        if (!dialog || !shouldShimCloseOnOverlayClick) return;
        return (0, $7QpUe.bind)(dialog, {
            type: 'click',
            listener: function listener(event) {
                if (event.target === event.currentTarget) onDialogClose({
                    reason: 'overlay-click'
                });
            }
        });
    }, [
        onDialogClose,
        shouldShimCloseOnOverlayClick
    ]);
    // ExitingPersistence: isExiting → isOpen={false} → Dialog exit animation →
    // onExitFinish → onCloseComplete + unmount.
    var handleDialogExitFinish = (0, $5FkrB.useCallback)(function() {
        var _contentRef$current;
        var el = (_contentRef$current = contentRef.current) !== null && _contentRef$current !== void 0 ? _contentRef$current : lastContentElRef.current;
        if (onCloseComplete && el) onCloseComplete(el);
        lastContentElRef.current = null;
        onExitFinish === null || onExitFinish === void 0 || onExitFinish();
    }, [
        onExitFinish,
        onCloseComplete
    ]);
    var handleDialogEnterFinish = (0, $5FkrB.useCallback)(function() {
        if (onOpenComplete && contentRef.current) onOpenComplete(contentRef.current, true);
    }, [
        onOpenComplete
    ]);
    // Honor `shouldReturnFocus={ref}` on unmount.
    // Native <dialog>.close() restores focus to the trigger that opened it,
    // but the consumer asked for focus to go to a specific element instead.
    // Run this in an unmount cleanup so it fires after dialog.close()
    // (which fires in the Dialog's effect cleanup).
    var shouldReturnFocusRef = (0, $5FkrB.useRef)(shouldReturnFocus);
    shouldReturnFocusRef.current = shouldReturnFocus;
    (0, $5FkrB.useEffect)(function() {
        return function() {
            var target = shouldReturnFocusRef.current;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(target) === 'object' && target.current) target.current.focus();
        };
    }, []);
    // Focus a ref-targeted element after mount (when autoFocus is a ref).
    // When true, native <dialog>.showModal() handles focus automatically.
    (0, $gpUQB.default)((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(autoFocus) === 'object' ? autoFocus : undefined, (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(autoFocus) === 'object');
    // Chrome cross-origin iframe DnD workaround (crbug.com/362301053)
    (0, $5FkrB.useEffect)(function() {
        return (0, $fGFYU.combine)((0, $5YyDq.disableDraggingToCrossOriginIFramesForElement)(), (0, $6fqgi.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $amgLb.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    var scrollMode = $72e8b2045ea4c80b$var$getScrollMode({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ $5FkrB.createElement((0, $90MLH.Dialog), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: dialogRef,
        onClose: onDialogClose,
        dismissedBy: dismissedBy,
        onExitFinish: handleDialogExitFinish,
        shouldAnimate: !isFullScreen,
        isOpen: !isExiting,
        onEnterFinish: handleDialogEnterFinish,
        shouldHideBackdrop: isBlanketHidden
    }, label ? {
        label: label
    } : {
        labelledBy: titleId
    }, {
        testId: defaultTestId,
        xcss: $72e8b2045ea4c80b$var$dialogStyles[scrollMode]
    }), /*#__PURE__*/ $5FkrB.createElement((0, $a39W7.DialogScrollLock), {
        isOpen: true
    }), /*#__PURE__*/ $5FkrB.createElement("div", {
        ref: contentRef,
        style: {
            '--modal-dialog-height': $72e8b2045ea4c80b$var$getTopLayerSurfaceHeight(height),
            '--modal-dialog-width': $72e8b2045ea4c80b$var$getTopLayerSurfaceWidth(width)
        },
        className: (0, $970q7.default)([
            $72e8b2045ea4c80b$var$surfaceStyles.root,
            !isFullScreen && $72e8b2045ea4c80b$var$surfaceStyles.borderRadius,
            $72e8b2045ea4c80b$var$topLayerScrollModeStyles[scrollMode],
            !height && !isFullScreen && "_e8uo1ris"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $fAYgP.ModalContext).Provider, {
        value: modalDialogContext
    }, /*#__PURE__*/ $5FkrB.createElement((0, $27rGG.ScrollContext).Provider, {
        value: shouldScrollInViewport
    }, children))));
}
/**
 * Legacy rendering path (Portal + FocusLock + ScrollLock + Blanket).
 *
 * Every hook here runs unconditionally: this component only mounts on the
 * legacy path, so it never shares a hook sequence with the top-layer path.
 */ var $72e8b2045ea4c80b$var$ModalWrapperLegacy = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var autoFocus = props.autoFocus, focusLockAllowlist = props.focusLockAllowlist, _props$shouldCloseOnE2 = props.shouldCloseOnEscapePress, shouldCloseOnEscapePress = _props$shouldCloseOnE2 === void 0 ? true : _props$shouldCloseOnE2, _props$shouldCloseOnO2 = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _props$shouldCloseOnO2 === void 0 ? true : _props$shouldCloseOnO2, _props$shouldScrollIn2 = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn2 === void 0 ? false : _props$shouldScrollIn2, _props$shouldReturnFo2 = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo2 === void 0 ? true : _props$shouldReturnFo2, stackIndexOverride = props.stackIndex, providedOnClose = props.onClose, _props$onStackChange2 = props.onStackChange, onStackChange = _props$onStackChange2 === void 0 ? (0, $eVb4V.default) : _props$onStackChange2, isBlanketHidden = props.isBlanketHidden, children = props.children, height = props.height, width = props.width, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, label = props.label, testId = props.testId, isFullScreen = props.isFullScreen, _props$UNSAFE_shouldD = props.UNSAFE_shouldDisableMotionUplift, UNSAFE_shouldDisableMotionUplift = _props$UNSAFE_shouldD === void 0 ? false : _props$UNSAFE_shouldD;
    var calculatedStackIndex = (0, $bL9ob.default)({
        onStackChange: onStackChange
    });
    var stackIndex = stackIndexOverride || calculatedStackIndex;
    var isForeground = stackIndex === 0;
    // If no ref is provided, autofocus on first element
    var autoFocusLock = !((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(autoFocus) === 'object');
    var onCloseHandler = $72e8b2045ea4c80b$var$useModalCloseHandler(providedOnClose);
    var onBlanketClicked = (0, $5FkrB.useCallback)(function(e) {
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // Stable callback to avoid re-renders when focusLockAllowlist is not provided.
    var allowListCallback = (0, $5FkrB.useCallback)(function(element) {
        return $72e8b2045ea4c80b$var$allowlistElements(element, focusLockAllowlist);
    }, [
        focusLockAllowlist
    ]);
    // Prevent background scroll (top-layer path uses DialogScrollLock instead).
    (0, $izyyW.default)();
    // Register with the open layer observer. On the top-layer path the Dialog
    // primitive does this itself, which is why it lives in this legacy-only
    // component rather than the shared dispatcher.
    (0, $iUCre.useNotifyOpenLayerObserver)({
        type: 'modal',
        // Always open — modal is conditionally rendered when visible.
        isOpen: true,
        // No-op: no current use case for programmatic close via OpenLayerObserver.
        onClose: (0, $eVb4V.default)
    });
    var modalDialogWithBlanket = /*#__PURE__*/ $5FkrB.createElement((0, $1qBWl.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && "".concat(testId, "--blanket")
    }, /*#__PURE__*/ $5FkrB.createElement((0, $4tRFQ.default), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete,
        hasProvidedOnClose: Boolean(providedOnClose),
        isFullScreen: isFullScreen,
        UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift,
        ref: ref
    }, children));
    var returnFocus = true;
    var onDeactivation = (0, $eVb4V.default);
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = function onDeactivation() {
        window.setTimeout(function() {
            var _shouldReturnFocus$cu;
            (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return /*#__PURE__*/ $5FkrB.createElement((0, $ezd8U.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ $5FkrB.createElement((0, $fV8Mu.default), {
        zIndex: (0, $64A04.layers).modal()
    }, !UNSAFE_shouldDisableMotionUplift && (0, $50U6m.fg)('platform-dst-motion-uplift-modal') ? /*#__PURE__*/ $5FkrB.createElement((0, $aAQBJ.default), {
        enteringAnimation: "var(--ds-blanket-enter, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)",
        exitingAnimation: "var(--ds-blanket-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        "aria-hidden": !isForeground,
        className: (0, $970q7.default)([
            "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $69J3E.default), {
        autoFocus: autoFocusLock,
        returnFocus: returnFocus,
        onDeactivation: onDeactivation,
        whiteList: allowListCallback
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3FlkA))), null), shouldScrollInViewport ? /*#__PURE__*/ $5FkrB.createElement((0, $3FlkA.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket))) : /*#__PURE__*/ $5FkrB.createElement((0, $7ujRa.default), null, function(fadeInProps) {
        return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, fadeInProps, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $970q7.default)([
                "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
                fadeInProps.className
            ]),
            "aria-hidden": !isForeground
        }), /*#__PURE__*/ $5FkrB.createElement((0, $69J3E.default), {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3FlkA))), null), shouldScrollInViewport ? /*#__PURE__*/ $5FkrB.createElement((0, $3FlkA.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket));
    })));
});
// Choose the rendering implementation at the component boundary rather than
// gating hooks inside a single component. Each implementation owns its own
// hooks unconditionally, so a runtime feature-flag change swaps component types
// (a clean remount) instead of changing the hook order of a mounted component.
var $72e8b2045ea4c80b$var$InternalModalWrapper = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    if ((0, $50U6m.fg)('platform-dst-top-layer')) // TODO: the top-layer path does not forward the external `ref` (parity
    // with the pre-refactor behavior, where the top-layer branch never
    // consumed it). The public type still advertises `RefAttributes`, so a
    // consumer ref silently no-ops here. Follow up by forwarding `ref` to a
    // sensible element (for example the content `div`) once ref parity is
    // intentionally desired.
    return /*#__PURE__*/ $5FkrB.createElement($72e8b2045ea4c80b$var$ModalWrapperTopLayer, props);
    return /*#__PURE__*/ $5FkrB.createElement($72e8b2045ea4c80b$var$ModalWrapperLegacy, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: ref
    }, props));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$72e8b2045ea4c80b$export$2e2bcd8739ae039 = $72e8b2045ea4c80b$var$InternalModalWrapper;

});
parcelRegister("1qBWl", function(module, exports) {
$parcel$export(module.exports, "default", () => $10a5a63f6ce4b0e3$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $aLEtb = parcelRequire("aLEtb");

var $eVb4V = parcelRequire("eVb4V");

function $10a5a63f6ce4b0e3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $10a5a63f6ce4b0e3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $10a5a63f6ce4b0e3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $10a5a63f6ce4b0e3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $10a5a63f6ce4b0e3$var$packageName = "@atlaskit/blanket";
var $10a5a63f6ce4b0e3$var$packageVersion = "16.4.3";
var $10a5a63f6ce4b0e3$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $10a5a63f6ce4b0e3$var$packageName,
    packageVersion: $10a5a63f6ce4b0e3$var$packageVersion
};
var $10a5a63f6ce4b0e3$var$baseStyles = null;
var $10a5a63f6ce4b0e3$var$shouldAllowClickThroughStyles = null;
var $10a5a63f6ce4b0e3$var$invisibleStyles = null;
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ var $10a5a63f6ce4b0e3$var$Blanket = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function Blanket(_ref, ref) {
    var _ref$shouldAllowClick = _ref.shouldAllowClickThrough, shouldAllowClickThrough = _ref$shouldAllowClick === void 0 ? false : _ref$shouldAllowClick, _ref$isTinted = _ref.isTinted, isTinted = _ref$isTinted === void 0 ? false : _ref$isTinted, _ref$onBlanketClicked = _ref.onBlanketClicked, onBlanketClicked = _ref$onBlanketClicked === void 0 ? (0, $eVb4V.default) : _ref$onBlanketClicked, testId = _ref.testId, children = _ref.children, analyticsContext = _ref.analyticsContext;
    var mouseDownTarget = (0, $5FkrB.useRef)(null);
    var onBlanketClickedWithAnalytics = (0, $aLEtb.usePlatformLeafEventHandler)($10a5a63f6ce4b0e3$var$_objectSpread({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext
    }, $10a5a63f6ce4b0e3$var$analyticsAttributes));
    var blanketClickOutsideChildren = (0, $5FkrB.useCallback)(function(e) {
        return e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined;
    }, [
        onBlanketClickedWithAnalytics
    ]);
    var onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    var onMouseDown = (0, $5FkrB.useCallback)(function(e) {
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $970q7.default)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk1i5c _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk1j28"
        ])
    }, children);
}));
$10a5a63f6ce4b0e3$var$Blanket.displayName = 'Blanket';
var $10a5a63f6ce4b0e3$export$2e2bcd8739ae039 = $10a5a63f6ce4b0e3$var$Blanket;

});

parcelRegister("fGFYU", function(module, exports) {
$parcel$export(module.exports, "combine", () => $b6bb57e4a4d18bce$export$1be1fc439b849fdf);
/** Create a new combined function that will call all the provided functions */ function $b6bb57e4a4d18bce$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function cleanup() {
        fns.forEach(function(fn) {
            return fn();
        });
    };
}

});

parcelRegister("gk5MQ", function(module, exports) {
$parcel$export(module.exports, "createCloseEvent", () => $be2300bf19587cef$export$330cd73b9da5838b);
/**
 * Creates a synthetic DOM event from a `TDialogCloseReason`.
 *
 * Useful when bridging the Dialog primitive's `onClose({ reason })` callback
 * to a legacy API that expects a `KeyboardEvent` or `MouseEvent` - for example,
 * `@atlaskit/modal-dialog`'s `onClose(event, analyticsEvent)` contract.
 *
 * - `'escape'` → `KeyboardEvent('keydown', { key: 'Escape' })`
 * - `'overlay-click'` → `MouseEvent('click')`
 *
 * @example
 * ```tsx
 * import { createCloseEvent, type TDialogCloseReason } from '@atlaskit/top-layer/dialog';
 *
 * function onDialogClose({ reason }: { reason: TDialogCloseReason }) {
 *   legacyOnClose(createCloseEvent({ reason }));
 * }
 * ```
 */ function $be2300bf19587cef$export$330cd73b9da5838b(_ref) {
    var reason = _ref.reason;
    if (reason === 'escape') return new KeyboardEvent('keydown', {
        key: 'Escape',
        bubbles: true
    });
    return new MouseEvent('click', {
        bubbles: true,
        cancelable: true
    });
}

});

parcelRegister("90MLH", function(module, exports) {
$parcel$export(module.exports, "Dialog", () => $68f9f18ab7f55b54$export$3ddf2d174ce01153);
/* dialog-content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $hUFig = parcelRequire("hUFig");

var $7QpUe = parcelRequire("7QpUe");

var $iO8GM = parcelRequire("iO8GM");

var $eVb4V = parcelRequire("eVb4V");

var $iUCre = parcelRequire("iUCre");

var $fsSfs = parcelRequire("fsSfs");

var $2QJ6b = parcelRequire("2QJ6b");

var $5hZBX = parcelRequire("5hZBX");
// Surface reset — see the rationale on `surfaceResetStyles` in `popover/popover.tsx`.
// Neutralises inherited interaction and text-layout properties (e.g.
// `pointer-events: none` and `white-space: nowrap`) that leak into the top-layer
// surface. Excludes `color`/`font` (theming) and `direction`/`unicode-bidi` (RTL
// must inherit). The reset has no box side-effects, so it does not reintroduce
// the `margin: auto` centering problem that kept `height: auto` off `Dialog`.
//
// KEEP IN SYNC with the identical `surfaceResetStyles` in `popover/popover.tsx`
// (ADS forbids sharing styles across files, so it is co-located and duplicated).
// The `satisfies` check below fails the build if either copy drifts.
var $68f9f18ab7f55b54$var$surfaceResetStyles = {
    root: "_lcxv1wug _o5724jg8 _1nmz4jg8 _1i4q4jg8 _y3gnv2br _azhwidpf _1p1dglyw"
};
var $68f9f18ab7f55b54$var$dialogStyles = {
    root: "_19itglyw _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _p12fglyw _c71lglyw _bfhk1j28",
    motion: "_k8m011k7 _1oeci9qs _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v7kvq",
    exit: "_y44vgeqi"
};
var $68f9f18ab7f55b54$var$backdropStyles = {
    root: "_1ltk1i5c",
    hidden: "_1ltk1j28",
    enter: "_1m5exbuz",
    exit: "_1m5e1op4"
};
var $68f9f18ab7f55b54$export$3ddf2d174ce01153 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function Dialog(_ref, ref) {
    var children = _ref.children, isOpen = _ref.isOpen, onClose = _ref.onClose, _ref$dismissedBy = _ref.dismissedBy, dismissedBy = _ref$dismissedBy === void 0 ? 'escape-and-outside-click' : _ref$dismissedBy, onEnterFinish = _ref.onEnterFinish, onExitFinish = _ref.onExitFinish, _ref$shouldAnimate = _ref.shouldAnimate, shouldAnimate = _ref$shouldAnimate === void 0 ? false : _ref$shouldAnimate, consumerXcss = _ref.xcss, enteringAnimationXcss = _ref.enteringAnimationXcss, exitingAnimationXcss = _ref.exitingAnimationXcss, style = _ref.style, testId = _ref.testId, providedId = _ref.id, label = _ref.label, labelledBy = _ref.labelledBy, shouldHideBackdrop = _ref.shouldHideBackdrop;
    var generatedId = (0, $5FkrB.useId)();
    var dialogId = providedId !== null && providedId !== void 0 ? providedId : generatedId;
    var ownRef = (0, $5FkrB.useRef)(null);
    var combinedRef = (0, $iO8GM.default)([
        ownRef,
        ref
    ]);
    var closeReasonRef = (0, $5FkrB.useRef)(null);
    var dismissedByRef = (0, $5FkrB.useRef)(dismissedBy);
    var onCloseRef = (0, $5FkrB.useRef)(onClose);
    // Keep native event handlers stable while ensuring they read the latest committed props.
    (0, $5FkrB.useLayoutEffect)(function() {
        dismissedByRef.current = dismissedBy;
        onCloseRef.current = onClose;
    }, [
        dismissedBy,
        onClose
    ]);
    var _useAnimatedVisibilit = (0, $fsSfs.useAnimatedVisibility)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    }), phase = _useAnimatedVisibilit.phase, isMounted = _useAnimatedVisibilit.isMounted, onBeforeToggle = _useAnimatedVisibilit.onBeforeToggle, onToggle = _useAnimatedVisibilit.onToggle;
    // Ordering is important: bind native lifecycle listeners before the later
    // layout effect calls showModal() or close(), because `beforetoggle` fires
    // synchronously during those calls.
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!isMounted) return;
        var dialog = ownRef.current;
        if (!dialog) return;
        return (0, $7QpUe.bindAll)(dialog, [
            {
                type: 'beforetoggle',
                listener: onBeforeToggle
            },
            {
                // Browsers retarget clicks on ::backdrop to the <dialog> element.
                // Close on backdrop click when outside-click dismissal is enabled.
                type: 'click',
                listener: function listener(event) {
                    if (event.target === event.currentTarget && dismissedByRef.current === 'escape-and-outside-click') {
                        closeReasonRef.current = 'overlay-click';
                        dialog.close();
                    }
                }
            },
            {
                type: 'toggle',
                listener: function listener(event) {
                    if (event.newState === 'closed') {
                        var reason = closeReasonRef.current;
                        closeReasonRef.current = null;
                        // A reason is only set for user-initiated closes. When React closes the
                        // dialog because isOpen changed, the consumer already knows.
                        if (reason) onCloseRef.current({
                            reason: reason
                        });
                    }
                    onToggle(event);
                }
            }
        ]);
    }, [
        isMounted,
        onBeforeToggle,
        onToggle
    ]);
    // Native `<dialog>.showModal()` traps focus but wraps through `<body>` at
    // the boundary (A → B → C → body → A). This hook intercepts Tab to wrap
    // directly (A → B → C → A), matching the WAI-ARIA APG pattern. Passing
    // `phase` keeps the listener attached through the animated-exit window
    // (WCAG 2.4.3 Focus Order regression guard).
    (0, $2QJ6b.useFocusWrap)({
        elementRef: ownRef,
        role: 'dialog',
        phase: phase
    });
    // Notify the open layer observer so app-coordination features
    // (open-count subscriptions) work with top-layer dialogs.
    (0, $iUCre.useNotifyOpenLayerObserver)({
        type: 'modal',
        isOpen: isOpen,
        // No-op: no current use case for programmatic close via OpenLayerObserver.
        onClose: (0, $eVb4V.default)
    });
    (0, $5FkrB.useLayoutEffect)(function() {
        var dialog = ownRef.current;
        if (!dialog) return;
        if (isOpen) {
            closeReasonRef.current = null;
            if (!dialog.open) dialog.showModal();
            return function() {
                if (dialog.open) dialog.close();
            };
        }
        if (dialog.open) dialog.close();
    }, [
        isOpen
    ]);
    // Safari bug: escape closes open dialog and popovers, rather than just innermost popover
    // See notes/decisions/safari-escape-nested-popover-in-dialog.md
    var _useSafariEscapeFix = (0, $5hZBX.useSafariEscapeFix)({
        dialogRef: ownRef,
        isVisible: isMounted
    }), shouldIgnoreEscape = _useSafariEscapeFix.shouldIgnoreEscape;
    // Handle native Escape (cancel event)
    var handleCancel = (0, $5FkrB.useCallback)(function(event) {
        // Only handle a cancel targeting THIS dialog. Native `cancel` does not
        // bubble, but React's synthetic event bubbles up the component tree, so
        // for nested dialogs (one rendered inside another's DOM subtree) the
        // inner dialog's Escape would otherwise also fire an ancestor dialog's
        // handler and close it too. Mirrors the backdrop-click target guard below.
        if (event.target !== event.currentTarget) return;
        // Spurious Safari `cancel`: the keydown snapshot saw an open child
        // popover, so this Escape belongs to that popover (light-dismissed
        // natively). Keep the dialog open instead of forwarding to `onClose`.
        if (shouldIgnoreEscape()) {
            event.preventDefault();
            return;
        }
        // Without native `closedby`, cancel Escape only when dismissal is disabled.
        // Allowed dismissal follows Popover behavior: the browser closes the element
        // and `onClose` notifies the controlled owner of the reason.
        if (dismissedBy === 'none') {
            event.preventDefault();
            return;
        }
        closeReasonRef.current = 'escape';
    }, [
        dismissedBy,
        shouldIgnoreEscape
    ]);
    // Unmount the `<dialog>` once exit completes so it does not leave an
    // empty `role="dialog"` element in the accessibility tree. A later open
    // remounts a fresh element, so the listener-binding and native-visibility
    // effects run against that element.
    if (!isMounted) return null;
    var shouldAnimateBackdrop = !shouldHideBackdrop && shouldAnimate;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("dialog", {
        ref: combinedRef,
        id: dialogId,
        "aria-label": label,
        "aria-labelledby": label ? undefined : labelledBy,
        style: style,
        onCancel: handleCancel,
        "data-testid": testId,
        className: (0, $970q7.default)([
            // Dialog styles
            $68f9f18ab7f55b54$var$dialogStyles.root,
            $68f9f18ab7f55b54$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $68f9f18ab7f55b54$var$dialogStyles.enter,
            shouldAnimate && phase === 'exiting' && $68f9f18ab7f55b54$var$dialogStyles.exit,
            shouldAnimate && $68f9f18ab7f55b54$var$dialogStyles.motion,
            shouldHideBackdrop ? $68f9f18ab7f55b54$var$backdropStyles.hidden : $68f9f18ab7f55b54$var$backdropStyles.root,
            shouldAnimateBackdrop && phase === 'entering' && $68f9f18ab7f55b54$var$backdropStyles.enter,
            shouldAnimateBackdrop && phase === 'exiting' && $68f9f18ab7f55b54$var$backdropStyles.exit,
            (0, $hUFig.cx)(consumerXcss, shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ])
    }, children);
});

});
parcelRegister("5hZBX", function(module, exports) {
$parcel$export(module.exports, "useSafariEscapeFix", () => $3d9e54f96377422f$export$52c229d83e45be61);

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $dsVPZ = parcelRequire("dsVPZ");
function $3d9e54f96377422f$export$52c229d83e45be61(_ref) {
    var dialogRef = _ref.dialogRef, isVisible = _ref.isVisible;
    var childPopoverOpenAtEscapeRef = (0, $5FkrB.useRef)(false);
    (0, $5FkrB.useEffect)(function() {
        if (!(0, $dsVPZ.isSafari)()) return;
        var dialog = dialogRef.current;
        if (!dialog) return;
        // Bind to `document`, not the dialog: on Safari focus can be on `<body>`
        // (buttons are not focused on click), where a dialog-scoped listener would
        // never fire. The query below stays scoped to this dialog's subtree.
        return (0, $7QpUe.bind)(document, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key !== 'Escape') return;
                try {
                    childPopoverOpenAtEscapeRef.current = Boolean(dialog.querySelector('[popover="auto"]:popover-open, [popover="hint"]:popover-open'));
                } catch (_unused) {
                    // `:popover-open` is unsupported in some environments (e.g. jsdom);
                    // treat as "no child popover" so a plain Escape still closes the dialog.
                    childPopoverOpenAtEscapeRef.current = false;
                }
            },
            options: {
                capture: true
            }
        });
    }, [
        dialogRef,
        isVisible
    ]);
    var api = (0, $5FkrB.useMemo)(function() {
        return {
            shouldIgnoreEscape: function shouldIgnoreEscape() {
                if (childPopoverOpenAtEscapeRef.current) {
                    childPopoverOpenAtEscapeRef.current = false;
                    return true;
                }
                return false;
            }
        };
    }, []);
    return api;
}

});


parcelRegister("a39W7", function(module, exports) {
$parcel$export(module.exports, "DialogScrollLock", () => $7511e45759cee55f$export$e458030908e2d723);

var $5FkrB = parcelRequire("5FkrB");

var $lFhdZ = parcelRequire("lFhdZ");
function $7511e45759cee55f$export$e458030908e2d723(_ref) {
    var isOpen = _ref.isOpen;
    (0, $5FkrB.useLayoutEffect)(function() {
        var _getDocument;
        if (!isOpen) return;
        var body = (_getDocument = (0, $lFhdZ.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.body;
        if (!body) return;
        var previousOverflow = body.style.overflow;
        body.style.overflow = 'hidden';
        return function() {
            body.style.overflow = previousOverflow;
        };
    }, [
        isOpen
    ]);
    return null;
}

});

parcelRegister("bL9ob", function(module, exports) {
$parcel$export(module.exports, "default", () => $88fb5df7fc5c6e51$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $Xr0F9 = parcelRequire("Xr0F9");

var $8iJkX = parcelRequire("8iJkX");

var $9NSoN = parcelRequire("9NSoN");

var $dZoDs = parcelRequire("dZoDs");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ var $88fb5df7fc5c6e51$var$modalStackRegister = [];
function $88fb5df7fc5c6e51$export$2e2bcd8739ae039(_ref) {
    var onStackChange = _ref.onStackChange;
    var _useExitingPersistenc = (0, $dZoDs.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting;
    var _useStateRef = (0, $9NSoN.default)(0), _useStateRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useStateRef, 2), stackIndexRef = _useStateRef2[0], setStackIndex = _useStateRef2[1];
    var currentStackIndex = stackIndexRef.current;
    var previousStackIndex = (0, $8iJkX.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    var updateStack = (0, $Xr0F9.default)(function() {
        var newStackIndex = $88fb5df7fc5c6e51$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $5FkrB.useEffect)(function() {
        var currentStackIndex = $88fb5df7fc5c6e51$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $88fb5df7fc5c6e51$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $88fb5df7fc5c6e51$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $88fb5df7fc5c6e51$var$modalStackRegister.forEach(function(cb) {
            return cb();
        });
    }, [
        updateStack,
        isExiting
    ]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            var currentStackIndex = $88fb5df7fc5c6e51$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $88fb5df7fc5c6e51$var$modalStackRegister.splice(currentStackIndex, 1);
                $88fb5df7fc5c6e51$var$modalStackRegister.forEach(function(cb) {
                    return cb();
                });
            }
        };
    }, [
        updateStack
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("8iJkX", function(module, exports) {
$parcel$export(module.exports, "default", () => $60b32c220ba1ae7f$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $60b32c220ba1ae7f$export$2e2bcd8739ae039(value) {
    var ref = (0, $5FkrB.useRef)();
    (0, $5FkrB.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("9NSoN", function(module, exports) {
$parcel$export(module.exports, "default", () => $7232e324d909781d$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $7232e324d909781d$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $5FkrB.useState)(initialState), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueRef = (0, $5FkrB.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});


parcelRegister("izyyW", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8564e4c13cd335a$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $d8564e4c13cd335a$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $d8564e4c13cd335a$export$2e2bcd8739ae039() {
    var _useState = (0, $5FkrB.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), scrollTopOffset = _useState2[0], setScrollTopOffset = _useState2[1];
    (0, $5FkrB.useLayoutEffect)(function() {
        setScrollTopOffset($d8564e4c13cd335a$var$getScrollDistance());
    }, []);
    var onWindowScroll = (0, $5FkrB.useCallback)(function() {
        if ($d8564e4c13cd335a$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});

parcelRegister("5YyDq", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", () => $459d6c181f35bf76$export$ec28e97c7d8b1b35);

var $7QpUe = parcelRequire("7QpUe");

var $f8loy = parcelRequire("f8loy");

var $fGFYU = parcelRequire("fGFYU");

var $hcsdE = parcelRequire("hcsdE");
function $459d6c181f35bf76$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var unbindEvents = (0, $7QpUe.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $f8loy.monitorForElements)({
        onGenerateDragPreview: function onGenerateDragPreview() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $fGFYU.combine)(unbindEvents, unbindMonitor);
}
function $459d6c181f35bf76$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $7QpUe.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener(event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
var $459d6c181f35bf76$var$api = (0, $hcsdE.makeFixForAdapter)({
    watchForInteractionStart: $459d6c181f35bf76$var$watchForInteractionStart,
    watchForInteractionEnd: $459d6c181f35bf76$var$watchForInteractionEnd
});
function $459d6c181f35bf76$export$ec28e97c7d8b1b35() {
    return $459d6c181f35bf76$var$api.registerUsage();
}

});
parcelRegister("f8loy", function(module, exports) {
$parcel$export(module.exports, "dropTargetForElements", () => $b04832f95b4a814c$export$e7140b68045b5036);
$parcel$export(module.exports, "monitorForElements", () => $b04832f95b4a814c$export$59a074bac4c54f54);
$parcel$export(module.exports, "draggable", () => $b04832f95b4a814c$export$c746a5152d4ba26c);

var $iYJcE = parcelRequire("iYJcE");

var $7QpUe = parcelRequire("7QpUe");

var $dYpf0 = parcelRequire("dYpf0");

var $9yVBQ = parcelRequire("9yVBQ");

var $96VL5 = parcelRequire("96VL5");

var $fGFYU = parcelRequire("fGFYU");

var $hqNxG = parcelRequire("hqNxG");

var $dfTau = parcelRequire("dfTau");

var $2NDx0 = parcelRequire("2NDx0");

var $dM1qa = parcelRequire("dM1qa");

var $egYGR = parcelRequire("egYGR");

var $WZ6t3 = parcelRequire("WZ6t3");

var $ivIaH = parcelRequire("ivIaH");
// Payload for the draggable being dragged
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-re-exports
var $b04832f95b4a814c$var$draggableRegistry = new WeakMap();
function $b04832f95b4a814c$var$addToRegistry(args) {
    $b04832f95b4a814c$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $b04832f95b4a814c$var$draggableRegistry.delete(args.element);
    };
}
var $b04832f95b4a814c$var$honeyPotFix = (0, $9yVBQ.makeHoneyPotFix)();
var $b04832f95b4a814c$var$adapter = (0, $96VL5.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount: function mount(api) {
        /**  Binding event listeners the `document` rather than `window` so that
     * this adapter always gets preference over the text adapter.
     * `document` is the first `EventTarget` under `window`
     * https://twitter.com/alexandereardon/status/1604658588311465985
     */ return (0, $fGFYU.combine)($b04832f95b4a814c$var$honeyPotFix.bindEvents(), (0, $7QpUe.bind)(document, {
            type: 'dragstart',
            listener: function listener(event) {
                var _entry$dragHandle, _entry$getInitialData, _entry$getInitialData2, _entry$dragHandle2, _entry$getInitialData3, _entry$getInitialData4;
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                var target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return;
                // see if the thing being dragged is owned by us
                var entry = $b04832f95b4a814c$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return;
                /**
         * A text selection drag _can_ have the `draggable` element be
         * the `event.target` if the user is dragging the text selection
         * from the `draggable`.
         *
         * To know if the `draggable` is being dragged, we look at whether any
         * `"text/plain"` data is being dragged. If it is, then a text selection
         * drag is occurring.
         *
         * This behaviour has been validated on:
         *
         * - Chrome@128 on Android@14
         * - Chrome@128 on iOS@17.6.1
         * - Chrome@128 on Windows@11
         * - Chrome@128 on MacOS@14.6.1
         * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
         * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
         *
         * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
         * but unfortunately ProseMirror is always setting `""` as the dragged text
         *
         * Note: Unfortunately editor is (heavily) leaning on the current functionality today
         * and unwinding it will be a decent amount of effort. So for now, a text selection
         * where the `event.target` is a `draggable` element will still trigger the
         * element adapter.
         *
         * // Future state:
         * if(event.dataTransfer.getData(textMediaType)) {
         * 	return;
         * }
         *
         */ var input = (0, $dM1qa.getInput)(event);
                var feedback = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle = entry.dragHandle) !== null && _entry$dragHandle !== void 0 ? _entry$dragHandle : null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    var over = (0, $dYpf0.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return;
                    }
                }
                /**
         *  **Goal**
         *  Pass information to other applications
         *
         * **Approach**
         *  Put data into the native data store
         *
         *  **What about the native adapter?**
         *  When the element adapter puts native data into the native data store
         *  the native adapter is not triggered in the current window,
         *  but a native adapter in an external window _can_ be triggered
         *
         *  **Why bake this into core?**
         *  This functionality could be pulled out and exposed inside of
         *  `onGenerateDragPreview`. But decided to make it a part of the
         *  base API as it felt like a common enough use case and ended
         *  up being a similar amount of code to include this function as
         *  it was to expose the hook for it
         */ var nativeData = (_entry$getInitialData = (_entry$getInitialData2 = entry.getInitialDataForExternal) === null || _entry$getInitialData2 === void 0 ? void 0 : _entry$getInitialData2.call(entry, feedback)) !== null && _entry$getInitialData !== void 0 ? _entry$getInitialData : null;
                if (nativeData) for(var _i = 0, _Object$entries = Object.entries(nativeData); _i < _Object$entries.length; _i++){
                    var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], data = _Object$entries$_i[1];
                    event.dataTransfer.setData(key, data !== null && data !== void 0 ? data : '');
                }
                /**
         *  📱 For Android devices, a drag operation will not start unless
         * "text/plain" or "text/uri-list" data exists in the native data store
         * https://twitter.com/alexandereardon/status/1732189803754713424
         *
         * Tested on:
         * Device: Google Pixel 5
         * Android version: 14 (November 5, 2023)
         * Chrome version: 120.0
         */ if ((0, $2NDx0.isAndroid)() && !event.dataTransfer.types.includes((0, $egYGR.textMediaType)) && !event.dataTransfer.types.includes((0, $WZ6t3.URLMediaType))) event.dataTransfer.setData((0, $egYGR.textMediaType), (0, $2NDx0.androidFallbackText));
                /**
         * 1. Must set any media type for `iOS15` to work
         * 2. We are also doing adding data so that the native adapter
         * can know that the element adapter has handled this drag
         *
         * We used to wrap this `setData()` in a `try/catch` for Firefox,
         * but it looks like that was not needed.
         *
         * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
         *
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
         * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
         *
         * // just checking a few more combinations to be super safe
         *
         * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
         * - ✅ Chrome@78 (Oct 2019) on Windows 10
         * - ✅ Safari@14.1 on macOS Big Sur
         */ event.dataTransfer.setData((0, $ivIaH.elementAdapterNativeDataKey), '');
                var payload = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle2 = entry.dragHandle) !== null && _entry$dragHandle2 !== void 0 ? _entry$dragHandle2 : null,
                    data: (_entry$getInitialData3 = (_entry$getInitialData4 = entry.getInitialData) === null || _entry$getInitialData4 === void 0 ? void 0 : _entry$getInitialData4.call(entry, feedback)) !== null && _entry$getInitialData3 !== void 0 ? _entry$getInitialData3 : {}
                };
                var dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: function dispatchEventToSource(_ref) {
        var _draggableRegistry$ge, _draggableRegistry$ge2;
        var eventName = _ref.eventName, payload = _ref.payload;
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        (_draggableRegistry$ge = $b04832f95b4a814c$var$draggableRegistry.get(payload.source.element)) === null || _draggableRegistry$ge === void 0 || (_draggableRegistry$ge2 = _draggableRegistry$ge[eventName]) === null || _draggableRegistry$ge2 === void 0 || _draggableRegistry$ge2.call(_draggableRegistry$ge, // I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $b04832f95b4a814c$var$honeyPotFix.getOnPostDispatch()
});
var $b04832f95b4a814c$export$e7140b68045b5036 = $b04832f95b4a814c$var$adapter.dropTarget;
var $b04832f95b4a814c$export$59a074bac4c54f54 = $b04832f95b4a814c$var$adapter.monitor;
function $b04832f95b4a814c$export$c746a5152d4ba26c(args) {
    var existing;
    var cleanup = (0, $fGFYU.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $b04832f95b4a814c$var$adapter.registerUsage(), $b04832f95b4a814c$var$addToRegistry(args), (0, $dfTau.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, $hqNxG.once)(cleanup);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrag()`) on for a `draggable()` */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForElements()` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForElements` */ 

});
parcelRegister("dYpf0", function(module, exports) {
$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => $a2c4754b0fac697b$export$81d0353f25f5dd);

var $iYJcE = parcelRequire("iYJcE");

var $iz1zp = parcelRequire("iz1zp");
function $a2c4754b0fac697b$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    var _document$elementsFro = document.elementsFromPoint(client.x, client.y), _document$elementsFro2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_document$elementsFro, 2), top = _document$elementsFro2[0], second = _document$elementsFro2[1];
    if (!top) return null;
    if ((0, $iz1zp.isHoneyPotElement)(top)) return second !== null && second !== void 0 ? second : null;
    return top;
}

});
parcelRegister("iz1zp", function(module, exports) {
$parcel$export(module.exports, "isHoneyPotElement", () => $d83cb6a881bf6431$export$821bdcd739a2706b);

var $hNgn9 = parcelRequire("hNgn9");
function $d83cb6a881bf6431$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $hNgn9.honeyPotDataAttribute));
}

});
parcelRegister("hNgn9", function(module, exports) {
$parcel$export(module.exports, "honeyPotDataAttribute", () => $cf43b67caec6451d$export$6eafea55f7947469);
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
var $cf43b67caec6451d$export$6eafea55f7947469 = 'data-pdnd-honey-pot';

});



parcelRegister("9yVBQ", function(module, exports) {
$parcel$export(module.exports, "makeHoneyPotFix", () => $6f63fa0f2e945f3a$export$8ecad27c959e89e0);

var $25nEq = parcelRequire("25nEq");

var $7QpUe = parcelRequire("7QpUe");

var $e6RxJ = parcelRequire("e6RxJ");

var $1UQfB = parcelRequire("1UQfB");

var $dYsRq = parcelRequire("dYsRq");

var $hNgn9 = parcelRequire("hNgn9");
function $6f63fa0f2e945f3a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6f63fa0f2e945f3a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6f63fa0f2e945f3a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6f63fa0f2e945f3a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6f63fa0f2e945f3a$var$honeyPotSize = 2;
var $6f63fa0f2e945f3a$var$halfHoneyPotSize = $6f63fa0f2e945f3a$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $6f63fa0f2e945f3a$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $6f63fa0f2e945f3a$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $6f63fa0f2e945f3a$var$halfHoneyPotSize,
        y: point.y - $6f63fa0f2e945f3a$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $6f63fa0f2e945f3a$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $6f63fa0f2e945f3a$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $6f63fa0f2e945f3a$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $6f63fa0f2e945f3a$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $6f63fa0f2e945f3a$var$getHoneyPotRectFor(_ref) {
    var client = _ref.client;
    var point = $6f63fa0f2e945f3a$var$preventGoingForwardsOffScreen($6f63fa0f2e945f3a$var$preventGoingBackwardsOffScreen($6f63fa0f2e945f3a$var$pullBackByHalfHoneyPotSize($6f63fa0f2e945f3a$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $6f63fa0f2e945f3a$var$honeyPotSize,
        height: $6f63fa0f2e945f3a$var$honeyPotSize
    });
}
function $6f63fa0f2e945f3a$var$getRectStyles(_ref2) {
    var clientRect = _ref2.clientRect;
    return {
        left: "".concat(clientRect.left, "px"),
        top: "".concat(clientRect.top, "px"),
        width: "".concat(clientRect.width, "px"),
        height: "".concat(clientRect.height, "px")
    };
}
function $6f63fa0f2e945f3a$var$isWithin(_ref3) {
    var client = _ref3.client, clientRect = _ref3.clientRect;
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $6f63fa0f2e945f3a$var$mountHoneyPot(_ref4) {
    var initial = _ref4.initial;
    var element = document.createElement('div');
    element.setAttribute((0, $hNgn9.honeyPotDataAttribute), 'true');
    // Using popover="manual" to place the element in the browser's top layer.
    // This ensures the honey pot is visually on top of everything else,
    // including elements using z-index and other stacking contexts.
    // "manual" means no light dismiss — we manage the lifecycle ourselves.
    // Falls back to position:fixed + maxZIndex when the popover API is not available.
    if ((0, $dYsRq.supportsPopover)()) element.setAttribute('popover', 'manual');
    // can shift during the drag thanks to Firefox
    var clientRect = $6f63fa0f2e945f3a$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, $6f63fa0f2e945f3a$var$_objectSpread($6f63fa0f2e945f3a$var$_objectSpread({
        position: 'fixed'
    }, (0, $dYsRq.supportsPopover)() ? // needs to come first as it has 'inset: unset' which
    // needs to be overridden by our top / left values
    (0, $1UQfB.popoverResetUserAgentStyles) : {
        // Fallback: using maximum possible z-index so that this element
        // will always be on top of other positioned content.
        zIndex: (0, $e6RxJ.maxZIndex)
    }), {}, {
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box',
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto'
    }, $6f63fa0f2e945f3a$var$getRectStyles({
        clientRect: clientRect
    })));
    document.body.appendChild(element);
    if ((0, $dYsRq.supportsPopover)()) element.showPopover();
    /**
   *  🦊 In firefox we can get `"pointermove"` events after the drag
   * has started, which is a spec violation.
   * The final `"pointermove"` will reveal where the "depressed" position
   * is for our honey pot fix.
   */ var unbindPointerMove = (0, $7QpUe.bind)(window, {
        type: 'pointermove',
        listener: function listener(event) {
            var client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $6f63fa0f2e945f3a$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $6f63fa0f2e945f3a$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish(_ref5) {
        var current = _ref5.current;
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($6f63fa0f2e945f3a$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        var unbindPostDragEvents = (0, $7QpUe.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $6f63fa0f2e945f3a$export$8ecad27c959e89e0() {
    var latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $7QpUe.bind)(window, {
            type: 'pointermove',
            listener: function listener(event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        var finish = null;
        return function onPostEvent(_ref6) {
            var eventName = _ref6.eventName, payload = _ref6.payload;
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                var input = payload.location.initial.input;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                var initial = latestPointerMove !== null && latestPointerMove !== void 0 ? latestPointerMove : {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $6f63fa0f2e945f3a$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                var _finish;
                var _input = payload.location.current.input;
                (_finish = finish) === null || _finish === void 0 || _finish({
                    current: {
                        x: _input.clientX,
                        y: _input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
parcelRegister("e6RxJ", function(module, exports) {
$parcel$export(module.exports, "maxZIndex", () => $a45b28c75c72f22f$export$7d0a15ee70427305);
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
var $a45b28c75c72f22f$export$7d0a15ee70427305 = 2147483647;

});

parcelRegister("1UQfB", function(module, exports) {
$parcel$export(module.exports, "popoverResetUserAgentStyles", () => $16538d4e28dfeca9$export$74004cb910cdc478);
/**
 * Resets user agent styles for `[popover]` elements.
 *
 * Browsers apply these defaults to popovers (per the WHATWG HTML spec rendering section):
 * - `inset: 0` + `margin: auto` → centers the popover in the viewport
 * - `border: solid` → visible border
 * - `padding: 0.25em` → internal spacing
 * - `overflow: auto` → scrollbars when content overflows
 * - `color: CanvasText` + `background-color: Canvas` → system theme colors
 *
 * This object neutralizes those defaults so the popover behaves like a plain
 * positioned `<div>`, matching the sizing of the legacy (non-popover)
 * fallback container exactly.
 *
 * **Width and height (`auto`)**
 *
 * `width` and `height` override the spec user agent value of `fit-content`
 * with `auto`.
 *
 * _Why?_
 *
 * - When a `[popover]` is sized with `fit-content` and contains a flex
 *   container, Safari collapses any flex item that uses `overflow: auto`
 *   to `0px`.
 * - Setting the popover's `width` and `height` to `auto` skips the `fit-content`
 *   pass and avoids the bug in Safari
 * - Chromium and Firefox tolerate `fit-content` here, but `auto` is safe
 *   everywhere and matches our non-popover path
 */ var $16538d4e28dfeca9$export$74004cb910cdc478 = {
    inset: 'unset',
    border: 'none',
    padding: 0,
    margin: 0,
    overflow: 'visible',
    color: 'inherit',
    background: 'transparent',
    width: 'auto',
    height: 'auto'
};

});

parcelRegister("dYsRq", function(module, exports) {
$parcel$export(module.exports, "supportsPopover", () => $a2c744185860d995$export$1150b66d0ff92823);

var $hqNxG = parcelRequire("hqNxG");
var $a2c744185860d995$export$1150b66d0ff92823 = (0, $hqNxG.once)(function supportsPopover() {
    return typeof HTMLElement !== 'undefined' && typeof HTMLElement.prototype.showPopover === 'function';
});

});
parcelRegister("hqNxG", function(module, exports) {
$parcel$export(module.exports, "once", () => $cb0b4b6c09f939a3$export$d2de3aaeafa91619);
/** Provide a function that you only ever want to be called a single time */ function $cb0b4b6c09f939a3$export$d2de3aaeafa91619(fn) {
    var cache = null;
    return function wrapped() {
        if (!cache) {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});



parcelRegister("96VL5", function(module, exports) {
$parcel$export(module.exports, "makeAdapter", () => $6a217a393a3f33e2$export$2aa3a33160990d96);

var $c3hQN = parcelRequire("c3hQN");

var $aCyzs = parcelRequire("aCyzs");

var $kEq2l = parcelRequire("kEq2l");

var $7EPoC = parcelRequire("7EPoC");
function $6a217a393a3f33e2$export$2aa3a33160990d96(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount, dispatchEventToSource = _ref.dispatchEventToSource, onPostDispatch = _ref.onPostDispatch, defaultDropEffect = _ref.defaultDropEffect;
    var monitorAPI = (0, $7EPoC.makeMonitor)();
    var dropTargetAPI = (0, $kEq2l.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource === null || dispatchEventToSource === void 0 || dispatchEventToSource(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch === null || onPostDispatch === void 0 || onPostDispatch(args);
    }
    function start(_ref2) {
        var event = _ref2.event, dragType = _ref2.dragType;
        (0, $c3hQN.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            var api = {
                canStart: (0, $c3hQN.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $aCyzs.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("c3hQN", function(module, exports) {
$parcel$export(module.exports, "lifecycle", () => $8c639c980a1d0fd5$export$3efdceeb8ca25c51);

var $fC8ib = parcelRequire("fC8ib");

var $7QpUe = parcelRequire("7QpUe");

var $dYpf0 = parcelRequire("dYpf0");

var $iz1zp = parcelRequire("iz1zp");

var $3yJwy = parcelRequire("3yJwy");

var $b5JMg = parcelRequire("b5JMg");

var $dM1qa = parcelRequire("dM1qa");

var $bD8GS = parcelRequire("bD8GS");
var $8c639c980a1d0fd5$var$globalState = {
    isActive: false
};
function $8c639c980a1d0fd5$var$canStart() {
    return !$8c639c980a1d0fd5$var$globalState.isActive;
}
function $8c639c980a1d0fd5$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $8c639c980a1d0fd5$var$hasHierarchyChanged(_ref) {
    var current = _ref.current, next = _ref.next;
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(var i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $8c639c980a1d0fd5$var$start(_ref2) {
    var event = _ref2.event, dragType = _ref2.dragType, getDropTargetsOver = _ref2.getDropTargetsOver, dispatchEvent = _ref2.dispatchEvent;
    if (!$8c639c980a1d0fd5$var$canStart()) return;
    var initial = $8c639c980a1d0fd5$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $8c639c980a1d0fd5$var$globalState.isActive = true;
    var state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $8c639c980a1d0fd5$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    var dispatch = (0, $bD8GS.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        var hasChanged = $8c639c980a1d0fd5$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        var input = (0, $dM1qa.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        var target = (0, $iz1zp.isHoneyPotElement)(event.target) ? (0, $dYpf0.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        var nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $8c639c980a1d0fd5$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $8c639c980a1d0fd5$var$globalState.isActive = false;
        unbindEvents();
    }
    var unbindEvents = (0, $7QpUe.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener: function listener(event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                if (!(0, $3yJwy.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
       * At this point we don't know if a drag is being cancelled,
       * or if a drag is leaving the `window`.
       *
       * Both have:
       *   1. "dragleave" (with `relatedTarget: null`)
       *   2. "dragend" (a "dragend" can occur when outside the `window`)
       *
       * **Clearing drop targets**
       *
       * For either case we are clearing the the drop targets
       *
       * - cancelling: we clear drop targets in `"dragend"` anyway
       * - leaving the `window`: we clear the drop targets (to clear stickiness)
       *
       * **Leaving the window and finishing the drag**
       *
       * _internal drags_
       *
       * - The drag continues when the user is outside the `window`
       *   and can resume if the user drags back over the `window`,
       *   or end when the user drops in an external `window`.
       * - We will get a `"dragend"`, or we can listen for other
       *   events to determine the drag is finished when the user re-enters the `window`).
       *
       * _external drags_
       *
       * - We conclude the drag operation.
       * - We have no idea if the user will drag back over the `window`,
       *   or if the drag ends elsewhere.
       * - We will create a new drag if the user re-enters the `window`.
       *
       * **Not updating `input`**
       *
       * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
       * Workaround: intentionally not updating `input` in "dragleave"
       * rather than the users current input values
       * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
       * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
       **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener: function listener(event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $dM1qa.getInput)(event)
                };
                /** If there are no drop targets, then we will get
       * a "drop" event if:
       * - `preventUnhandled()` is being used
       * - there is an unmanaged drop target (eg another library)
       * In these cases, it's up to the consumer
       * to handle the drop if it's not over one of our drop targets
       * - `preventUnhandled()` will cancel the "drop"
       * - unmanaged drop targets can handle the "drop" how they want to
       * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $8c639c980a1d0fd5$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener: function listener(event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $dM1qa.getInput)(event)
                };
                cancel();
            }
        }
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((0, $b5JMg.getBindingsForBrokenDrags)({
        onDragEnd: cancel
    }))), // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $8c639c980a1d0fd5$var$getNativeSetDragImage(event)
    });
}
function $8c639c980a1d0fd5$var$setDropEffectOnEvent(_ref3) {
    var _current$;
    var event = _ref3.event, current = _ref3.current;
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    var innerMost = (_current$ = current[0]) === null || _current$ === void 0 ? void 0 : _current$.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $8c639c980a1d0fd5$var$getStartLocation(_ref4) {
    var event = _ref4.event, dragType = _ref4.dragType, getDropTargetsOver = _ref4.getDropTargetsOver;
    var input = (0, $dM1qa.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    var dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
var $8c639c980a1d0fd5$export$3efdceeb8ca25c51 = {
    canStart: $8c639c980a1d0fd5$var$canStart,
    start: $8c639c980a1d0fd5$var$start
};

});
parcelRegister("3yJwy", function(module, exports) {
$parcel$export(module.exports, "isLeavingWindow", () => $2977dc31a4f0daf8$export$57d220c74e84a273);

var $f7oM5 = parcelRequire("f7oM5");

var $8nu2B = parcelRequire("8nu2B");

var $2eElm = parcelRequire("2eElm");

var $hbieR = parcelRequire("hbieR");
function $2977dc31a4f0daf8$export$57d220c74e84a273(_ref) {
    var dragLeave = _ref.dragLeave;
    var type = dragLeave.type, relatedTarget = dragLeave.relatedTarget;
    if (type !== 'dragleave') return false;
    if ((0, $8nu2B.isSafari)()) return (0, $hbieR.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   * (foreign element)
   */ if ((0, $f7oM5.isFirefox)()) return (0, $2eElm.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is `null` *(standard check)*
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("f7oM5", function(module, exports) {
$parcel$export(module.exports, "isFirefox", () => $b01aba297b4ce34f$export$b7d78993b74f766d);

var $hqNxG = parcelRequire("hqNxG");
var $b01aba297b4ce34f$export$b7d78993b74f766d = (0, $hqNxG.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});

parcelRegister("8nu2B", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $6197c6371b414d1f$export$95df08bae54cb4df);

var $hqNxG = parcelRequire("hqNxG");
var $6197c6371b414d1f$export$95df08bae54cb4df = (0, $hqNxG.once)(function isSafari() {
    var _navigator = navigator, userAgent = _navigator.userAgent;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("2eElm", function(module, exports) {
$parcel$export(module.exports, "isFromAnotherWindow", () => $1a0c2ef27ee6e05a$export$e46810fef53b5b0e);
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $1a0c2ef27ee6e05a$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $1a0c2ef27ee6e05a$export$e46810fef53b5b0e(eventTarget) {
    return $1a0c2ef27ee6e05a$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});

parcelRegister("hbieR", function(module, exports) {
$parcel$export(module.exports, "isLeavingWindowInSafari", () => $c8219c917b2646fb$export$f21837c338005454);

var $8nu2B = parcelRequire("8nu2B");

var $7FN5w = parcelRequire("7FN5w");
function $c8219c917b2646fb$export$f21837c338005454(_ref) {
    var dragLeave = _ref.dragLeave;
    if (!(0, $8nu2B.isSafari)()) return false;
    return dragLeave.hasOwnProperty((0, $7FN5w.symbols).isLeavingWindow);
}

});
parcelRegister("7FN5w", function(module, exports) {
$parcel$export(module.exports, "symbols", () => $5962709fc58bfb50$export$47616e9f7f5fe113);

var $7QpUe = parcelRequire("7QpUe");

var $8nu2B = parcelRequire("8nu2B");
var $5962709fc58bfb50$export$47616e9f7f5fe113 = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $8nu2B.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    var state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragstart',
            listener: function listener() {
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: function listener(event) {
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                event[$5962709fc58bfb50$export$47616e9f7f5fe113.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    event[$5962709fc58bfb50$export$47616e9f7f5fe113.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});



parcelRegister("b5JMg", function(module, exports) {
$parcel$export(module.exports, "getBindingsForBrokenDrags", () => $8133abce30b35113$export$ac5e5b0daf997b2);
function $8133abce30b35113$export$ac5e5b0daf997b2(_ref) {
    var onDragEnd = _ref.onDragEnd;
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            }()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("dM1qa", function(module, exports) {
$parcel$export(module.exports, "getInput", () => $a070dc391d41a0d6$export$7c112ceec8941e67);
function $a070dc391d41a0d6$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("bD8GS", function(module, exports) {
$parcel$export(module.exports, "makeDispatch", () => $877a140085167b69$export$9f13ecc44e83d682);

var $45Zis = parcelRequire("45Zis");
var $877a140085167b69$var$scheduleOnDrag = (0, $45Zis.default)(function(fn) {
    return fn();
});
var $877a140085167b69$var$dragStart = function() {
    var scheduled = null;
    function schedule(fn) {
        var frameId = requestAnimationFrame(function() {
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
}();
function $877a140085167b69$export$9f13ecc44e83d682(_ref) {
    var source = _ref.source, initial = _ref.initial, dispatchEvent = _ref.dispatchEvent;
    var previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    var dispatch = {
        start: function start(_ref2) {
            var nativeSetDragImage = _ref2.nativeSetDragImage;
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            var location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $877a140085167b69$var$dragStart.schedule(function() {
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate: function dragUpdate(_ref3) {
            var current = _ref3.current;
            $877a140085167b69$var$dragStart.flush();
            $877a140085167b69$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag: function drag(_ref4) {
            var current = _ref4.current;
            $877a140085167b69$var$scheduleOnDrag(function() {
                $877a140085167b69$var$dragStart.flush();
                var location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop: function drop(_ref5) {
            var current = _ref5.current, updatedSourcePayload = _ref5.updatedSourcePayload;
            $877a140085167b69$var$dragStart.flush();
            $877a140085167b69$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload !== null && updatedSourcePayload !== void 0 ? updatedSourcePayload : source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});


parcelRegister("aCyzs", function(module, exports) {
$parcel$export(module.exports, "register", () => $7bb8450b5527e11b$export$6503ec6e8aabbaf);
// Extending `Map` to allow us to link Key and Values together
var $7bb8450b5527e11b$var$ledger = new Map();
function $7bb8450b5527e11b$var$registerUsage(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount;
    var entry = $7bb8450b5527e11b$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    var initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $7bb8450b5527e11b$var$ledger.set(typeKey, initial);
    return initial;
}
function $7bb8450b5527e11b$export$6503ec6e8aabbaf(args) {
    var entry = $7bb8450b5527e11b$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $7bb8450b5527e11b$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("kEq2l", function(module, exports) {
$parcel$export(module.exports, "makeDropTarget", () => $f08bbd6b15e5cf31$export$47d10e7bd9c81890);

var $25nEq = parcelRequire("25nEq");

var $fC8ib = parcelRequire("fC8ib");

var $fGFYU = parcelRequire("fGFYU");

var $hqNxG = parcelRequire("hqNxG");

var $dfTau = parcelRequire("dfTau");
function $f08bbd6b15e5cf31$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f08bbd6b15e5cf31$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f08bbd6b15e5cf31$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f08bbd6b15e5cf31$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f08bbd6b15e5cf31$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $f08bbd6b15e5cf31$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $f08bbd6b15e5cf31$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f08bbd6b15e5cf31$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f08bbd6b15e5cf31$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $f08bbd6b15e5cf31$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $f08bbd6b15e5cf31$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $f08bbd6b15e5cf31$export$47d10e7bd9c81890(_ref) {
    var typeKey = _ref.typeKey, defaultDropEffect = _ref.defaultDropEffect;
    var registry = new WeakMap();
    var dropTargetDataAtt = "data-drop-target-for-".concat(typeKey);
    var dropTargetSelector = "[".concat(dropTargetDataAtt, "]");
    function addToRegistry(args) {
        registry.set(args.element, args);
        return function() {
            return registry.delete(args.element);
        };
    }
    function dropTargetForConsumers(args) {
        var existing;
        var cleanup = (0, $fGFYU.combine)((0, $dfTau.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $hqNxG.once)(cleanup);
    }
    function getActualDropTargets(_ref2) {
        var _args$getData, _args$getData2, _args$getDropEffect, _args$getDropEffect2;
        var source = _ref2.source, target = _ref2.target, input = _ref2.input, _ref2$result = _ref2.result, result = _ref2$result === void 0 ? [] : _ref2$result;
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        var closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        var args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        var feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        var data = (_args$getData = (_args$getData2 = args.getData) === null || _args$getData2 === void 0 ? void 0 : _args$getData2.call(args, feedback)) !== null && _args$getData !== void 0 ? _args$getData : {};
        var dropEffect = (_args$getDropEffect = (_args$getDropEffect2 = args.getDropEffect) === null || _args$getDropEffect2 === void 0 ? void 0 : _args$getDropEffect2.call(args, feedback)) !== null && _args$getDropEffect !== void 0 ? _args$getDropEffect : defaultDropEffect;
        var record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result), [
                record
            ])
        });
    }
    function notifyCurrent(_ref3) {
        var eventName = _ref3.eventName, payload = _ref3.payload;
        var _iterator = $f08bbd6b15e5cf31$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _entry$eventName;
                var record = _step.value;
                var entry = registry.get(record.element);
                var args = $f08bbd6b15e5cf31$var$_objectSpread($f08bbd6b15e5cf31$var$_objectSpread({}, payload), {}, {
                    self: record
                });
                entry === null || entry === void 0 || (_entry$eventName = entry[eventName]) === null || _entry$eventName === void 0 || _entry$eventName.call(entry, // I cannot seem to get the types right here.
                // TS doesn't seem to like that one event can need `nativeSetDragImage`
                // @ts-expect-error
                args);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    var actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: function onDropTargetChange(_ref4) {
            var payload = _ref4.payload;
            var isCurrent = new Set(payload.location.current.dropTargets.map(function(record) {
                return record.element;
            }));
            var visited = new Set();
            var _iterator2 = $f08bbd6b15e5cf31$var$_createForOfIteratorHelper(payload.location.previous.dropTargets), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _entry$onDropTargetCh;
                    var record = _step2.value;
                    visited.add(record.element);
                    var entry = registry.get(record.element);
                    var isOver = isCurrent.has(record.element);
                    var args = $f08bbd6b15e5cf31$var$_objectSpread($f08bbd6b15e5cf31$var$_objectSpread({}, payload), {}, {
                        self: record
                    });
                    entry === null || entry === void 0 || (_entry$onDropTargetCh = entry.onDropTargetChange) === null || _entry$onDropTargetCh === void 0 || _entry$onDropTargetCh.call(entry, args);
                    // if we cannot find the drop target in the current array, then it has been left
                    if (!isOver) {
                        var _entry$onDragLeave;
                        entry === null || entry === void 0 || (_entry$onDragLeave = entry.onDragLeave) === null || _entry$onDragLeave === void 0 || _entry$onDragLeave.call(entry, args);
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var _iterator3 = $f08bbd6b15e5cf31$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var _entry$onDropTargetCh2, _entry$onDragEnter;
                    var _record = _step3.value;
                    // already published an update to this drop target
                    if (visited.has(_record.element)) continue;
                    // at this point we have a new drop target that is being entered into
                    var _args = $f08bbd6b15e5cf31$var$_objectSpread($f08bbd6b15e5cf31$var$_objectSpread({}, payload), {}, {
                        self: _record
                    });
                    var _entry = registry.get(_record.element);
                    _entry === null || _entry === void 0 || (_entry$onDropTargetCh2 = _entry.onDropTargetChange) === null || _entry$onDropTargetCh2 === void 0 || _entry$onDropTargetCh2.call(_entry, _args);
                    _entry === null || _entry === void 0 || (_entry$onDragEnter = _entry.onDragEnter) === null || _entry$onDragEnter === void 0 || _entry$onDragEnter.call(_entry, _args);
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver(_ref5) {
        var source = _ref5.source, target = _ref5.target, input = _ref5.input, current = _ref5.current;
        var actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        var lastCaptureOrdered = $f08bbd6b15e5cf31$var$copyReverse(current);
        var actualCaptureOrdered = $f08bbd6b15e5cf31$var$copyReverse(actual);
        var resultCaptureOrdered = [];
        for(var index = 0; index < lastCaptureOrdered.length; index++){
            var _argsForLast$getIsSti;
            var last = lastCaptureOrdered[index];
            var fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            var parent = resultCaptureOrdered[index - 1];
            var lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if ((parent === null || parent === void 0 ? void 0 : parent.element) !== (lastParent === null || lastParent === void 0 ? void 0 : lastParent.element)) break;
            // We need to check whether the old drop target can still be dropped on
            var argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            var feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!((_argsForLast$getIsSti = argsForLast.getIsSticky) !== null && _argsForLast$getIsSti !== void 0 && _argsForLast$getIsSti.call(argsForLast, feedback))) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push($f08bbd6b15e5cf31$var$_objectSpread($f08bbd6b15e5cf31$var$_objectSpread({}, last), {}, {
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            }));
        }
        // return bubble ordered result
        return $f08bbd6b15e5cf31$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("dfTau", function(module, exports) {
$parcel$export(module.exports, "addAttribute", () => $9a67785920e46268$export$5dcb5c23b6ba980a);
function $9a67785920e46268$export$5dcb5c23b6ba980a(element, _ref) {
    var attribute = _ref.attribute, value = _ref.value;
    element.setAttribute(attribute, value);
    return function() {
        return element.removeAttribute(attribute);
    };
}

});


parcelRegister("7EPoC", function(module, exports) {
$parcel$export(module.exports, "makeMonitor", () => $5934230967ac1c51$export$5dd4ed888d5b12ca);

var $25nEq = parcelRequire("25nEq");

var $hqNxG = parcelRequire("hqNxG");
function $5934230967ac1c51$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $5934230967ac1c51$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $5934230967ac1c51$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5934230967ac1c51$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5934230967ac1c51$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $5934230967ac1c51$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $5934230967ac1c51$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5934230967ac1c51$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5934230967ac1c51$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5934230967ac1c51$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5934230967ac1c51$export$5dd4ed888d5b12ca() {
    var registry = new Set();
    var dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        var entry = $5934230967ac1c51$var$_objectSpread({}, args);
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $hqNxG.once)(cleanup);
    }
    function dispatchEvent(_ref) {
        var eventName = _ref.eventName, payload = _ref.payload;
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            var _iterator = $5934230967ac1c51$var$_createForOfIteratorHelper(registry), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var monitor = _step.value;
                    tryAddToActive(monitor);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        var active = Array.from(dragging.active);
        for(var _i = 0, _active = active; _i < _active.length; _i++){
            var _monitor = _active[_i];
            // A monitor can be removed by another monitor during an event.
            // We need to check that the monitor is still registered before calling it
            if (dragging.active.has(_monitor)) {
                var _monitor$eventName;
                // @ts-expect-error: I cannot get this type working!
                (_monitor$eventName = _monitor[eventName]) === null || _monitor$eventName === void 0 || _monitor$eventName.call(_monitor, payload);
            }
        }
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("2NDx0", function(module, exports) {
$parcel$export(module.exports, "isAndroid", () => $209ed274009a1d32$export$a11b0059900ceec8);
$parcel$export(module.exports, "androidFallbackText", () => $209ed274009a1d32$export$aceb3ed8b7f7bd2c);

var $hqNxG = parcelRequire("hqNxG");
var $209ed274009a1d32$export$a11b0059900ceec8 = (0, $hqNxG.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
var $209ed274009a1d32$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

parcelRegister("egYGR", function(module, exports) {
$parcel$export(module.exports, "textMediaType", () => $a641a3213db5433a$export$fd3d00026297c0ad);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $a641a3213db5433a$export$fd3d00026297c0ad = 'text/plain';

});

parcelRegister("WZ6t3", function(module, exports) {
$parcel$export(module.exports, "URLMediaType", () => $0b14d0bd7b3695e8$export$4c44a460f123106);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $0b14d0bd7b3695e8$export$4c44a460f123106 = 'text/uri-list';

});

parcelRegister("ivIaH", function(module, exports) {
$parcel$export(module.exports, "elementAdapterNativeDataKey", () => $d79d62cc1f9c3c9d$export$c9c4cc54e73b125d);
/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ var $d79d62cc1f9c3c9d$export$c9c4cc54e73b125d = 'application/vnd.pdnd';

});


parcelRegister("hcsdE", function(module, exports) {
$parcel$export(module.exports, "makeFixForAdapter", () => $c859726891399d7b$export$a74bff2507e6126b);

var $fC8ib = parcelRequire("fC8ib");

var $fGFYU = parcelRequire("fGFYU");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $c859726891399d7b$var$setStyle(el, _ref) {
    var property = _ref.property, rule = _ref.rule, _ref$priority = _ref.priority, priority = _ref$priority === void 0 ? '' : _ref$priority;
    var originalValue = el.style.getPropertyValue(property);
    var originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $c859726891399d7b$var$hasSameOrigin(href1, href2) {
    var url1;
    var url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (_unused) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $c859726891399d7b$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith('data:')) return false;
    return !$c859726891399d7b$var$hasSameOrigin(window.location.href, iframe.src);
}
var $c859726891399d7b$var$registry = new Map();
function $c859726891399d7b$var$applyFix(watchForEndOfInteraction) {
    var iframes = Array.from(document.querySelectorAll('iframe')).filter($c859726891399d7b$var$isIframeOnAnotherDomain);
    var cleanups = iframes.map(function(iframe) {
        var entry = $c859726891399d7b$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $c859726891399d7b$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $c859726891399d7b$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $c859726891399d7b$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $fGFYU.combine).apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(cleanups))();
    }
    var cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $c859726891399d7b$export$a74bff2507e6126b(_ref2) {
    var watchForInteractionStart = _ref2.watchForInteractionStart, watchForInteractionEnd = _ref2.watchForInteractionEnd;
    var registrationCount = 0;
    var stopWatchingInteractionStart = null;
    function start() {
        $c859726891399d7b$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            var _stopWatchingInteract;
            registrationCount--;
            if (registrationCount !== 0) return;
            (_stopWatchingInteract = stopWatchingInteractionStart) === null || _stopWatchingInteract === void 0 || _stopWatchingInteract();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

});


parcelRegister("amgLb", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", () => $78a8f5a56061ae1c$export$27d79116d3a4e7d5);

var $4wZyM = parcelRequire("4wZyM");

var $hcsdE = parcelRequire("hcsdE");
function $78a8f5a56061ae1c$var$watchForInteractionStart(_ref) {
    var start = _ref.start;
    return (0, $4wZyM.monitorForExternal)({
        onDragStart: function onDragStart() {
            start();
        }
    });
}
function $78a8f5a56061ae1c$var$watchForInteractionEnd(_ref2) {
    var stop = _ref2.stop;
    return (0, $4wZyM.monitorForExternal)({
        onDrop: function onDrop() {
            stop();
        }
    });
}
var $78a8f5a56061ae1c$var$api = (0, $hcsdE.makeFixForAdapter)({
    watchForInteractionStart: $78a8f5a56061ae1c$var$watchForInteractionStart,
    watchForInteractionEnd: $78a8f5a56061ae1c$var$watchForInteractionEnd
});
function $78a8f5a56061ae1c$export$27d79116d3a4e7d5() {
    return $78a8f5a56061ae1c$var$api.registerUsage();
}

});
parcelRegister("4wZyM", function(module, exports) {
$parcel$export(module.exports, "monitorForExternal", () => $34c9e71aaa887be0$export$bb1740f3194979c1);

var $h6ZPT = parcelRequire("h6ZPT");
function $34c9e71aaa887be0$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return (0, $h6ZPT.adapter).monitor(args);
}

});
parcelRegister("h6ZPT", function(module, exports) {
$parcel$export(module.exports, "adapter", () => $c752f68697c59bdc$export$e00c9c6684b0ace);

var $fC8ib = parcelRequire("fC8ib");

var $7QpUe = parcelRequire("7QpUe");

var $96VL5 = parcelRequire("96VL5");

var $jBWab = parcelRequire("jBWab");

var $b5JMg = parcelRequire("b5JMg");

var $kHjVU = parcelRequire("kHjVU");

var $bYWWe = parcelRequire("bYWWe");

var $dd1Yv = parcelRequire("dd1Yv");
var $c752f68697c59bdc$var$didDragStartLocally = false;
var $c752f68697c59bdc$export$e00c9c6684b0ace = (0, $96VL5.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $7QpUe.bind)(window, {
            type: 'dragenter',
            listener: function listener(event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($c752f68697c59bdc$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $jBWab.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                var types = (0, $bYWWe.getAvailableTypes)(event.dataTransfer);
                if (!types.length) return;
                var locked = {
                    types: types,
                    items: [],
                    getStringData: function getStringData() {
                        return null;
                    }
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload: function getDropPayload(event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            var items = (0, $kHjVU.getAvailableItems)(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            var nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData: function getStringData(mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    var value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!(0, $dd1Yv.isAnAvailableType)({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
/** Common event payload for all events */ /** A map containing payloads for all events */ /** Common event payload for all drop target events */ /** A map containing payloads for all events on drop targets */ /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */ /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ (function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $c752f68697c59bdc$export$e00c9c6684b0ace.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    var idle = {
        type: 'idle'
    };
    var state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $c752f68697c59bdc$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $7QpUe.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((0, $b5JMg.getBindingsForBrokenDrags)({
            onDragEnd: clear
        }))), // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $7QpUe.bind)(window, {
        type: 'dragstart',
        listener: function listener() {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $c752f68697c59bdc$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})();

});
parcelRegister("jBWab", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindow", () => $e46e970932b10f13$export$d1c6f249e893cdf4);

var $f7oM5 = parcelRequire("f7oM5");

var $8nu2B = parcelRequire("8nu2B");

var $7YDd2 = parcelRequire("7YDd2");

var $2eElm = parcelRequire("2eElm");
function $e46e970932b10f13$export$d1c6f249e893cdf4(_ref) {
    var dragEnter = _ref.dragEnter;
    var type = dragEnter.type, relatedTarget = dragEnter.relatedTarget;
    if (type !== 'dragenter') return false;
    if ((0, $8nu2B.isSafari)()) return (0, $7YDd2.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is the `iframe` element in the parent `window`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is an element inside the child `iframe`
   * (foreign element)
   */ if ((0, $f7oM5.isFirefox)()) return (0, $2eElm.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is `null` *(standard check)*
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is the `iframe` element in the parent `window`
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("7YDd2", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindowInSafari", () => $5cec8d235f309112$export$de68634bd94ed596);

var $8nu2B = parcelRequire("8nu2B");

var $7FN5w = parcelRequire("7FN5w");
function $5cec8d235f309112$export$de68634bd94ed596(_ref) {
    var dragEnter = _ref.dragEnter;
    if (!(0, $8nu2B.isSafari)()) return false;
    return dragEnter.hasOwnProperty((0, $7FN5w.symbols).isEnteringWindow);
}

});


parcelRegister("kHjVU", function(module, exports) {
$parcel$export(module.exports, "getAvailableItems", () => $f117491253ed6030$export$8d28cfecded8dcab);

var $dd1Yv = parcelRequire("dd1Yv");
function $f117491253ed6030$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter(function(item) {
        return item.kind === 'file' || (0, $dd1Yv.isAnAvailableType)({
            type: item.type,
            value: dataTransfer.getData(item.type)
        });
    });
}

});
parcelRegister("dd1Yv", function(module, exports) {
$parcel$export(module.exports, "isAnAvailableType", () => $99de057338b8ec6f$export$a8e56a860d7957c7);

var $2NDx0 = parcelRequire("2NDx0");

var $egYGR = parcelRequire("egYGR");

var $ivIaH = parcelRequire("ivIaH");
function $99de057338b8ec6f$export$a8e56a860d7957c7(_ref) {
    var type = _ref.type, value = _ref.value;
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $ivIaH.elementAdapterNativeDataKey)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $egYGR.textMediaType) && value === (0, $2NDx0.androidFallbackText)) return false;
    return true;
}

});


parcelRegister("bYWWe", function(module, exports) {
$parcel$export(module.exports, "getAvailableTypes", () => $8b9304358bc6c5fb$export$8c257a3856120a77);

var $dd1Yv = parcelRequire("dd1Yv");
function $8b9304358bc6c5fb$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter(function(type) {
        return (0, $dd1Yv.isAnAvailableType)({
            type: type,
            value: transfer.getData(type)
        });
    });
}

});




parcelRegister("6fqgi", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", () => $48c883d283507441$export$9c0606fcefb5d1e2);

var $7QpUe = parcelRequire("7QpUe");

var $9JGnG = parcelRequire("9JGnG");

var $fGFYU = parcelRequire("fGFYU");

var $hcsdE = parcelRequire("hcsdE");
function $48c883d283507441$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var frameId = null;
    var unbindEvents = (0, $7QpUe.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener: function listener() {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(function() {
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $9JGnG.monitorForTextSelection)({
        onDragStart: function onDragStart() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $fGFYU.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $48c883d283507441$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $7QpUe.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener() {
            // A text selection drag will only start when there is
            // an active text selection.
            var selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
var $48c883d283507441$var$api = (0, $hcsdE.makeFixForAdapter)({
    watchForInteractionStart: $48c883d283507441$var$watchForInteractionStart,
    watchForInteractionEnd: $48c883d283507441$var$watchForInteractionEnd
});
function $48c883d283507441$export$9c0606fcefb5d1e2() {
    return $48c883d283507441$var$api.registerUsage();
}

});
parcelRegister("9JGnG", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", () => $71693104405c4606$export$2e178e3647f5e6e9);

var $5O7Kz = parcelRequire("5O7Kz");
function $71693104405c4606$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return (0, $5O7Kz.adapter).monitor(args);
}

});
parcelRegister("5O7Kz", function(module, exports) {
$parcel$export(module.exports, "adapter", () => $43a7a24835c609f6$export$e00c9c6684b0ace);

var $7QpUe = parcelRequire("7QpUe");

var $96VL5 = parcelRequire("96VL5");

var $fGFYU = parcelRequire("fGFYU");

var $ltjac = parcelRequire("ltjac");

var $egYGR = parcelRequire("egYGR");

var $ivIaH = parcelRequire("ivIaH");

var $bWnPL = parcelRequire("bWnPL");

var $5OMIL = parcelRequire("5OMIL");
var $43a7a24835c609f6$export$e00c9c6684b0ace = (0, $96VL5.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $fGFYU.combine)((0, $5OMIL.honeyPotFix).bindEvents(), (0, $7QpUe.bind)(window, {
            type: 'dragstart',
            listener: function listener(event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $ivIaH.elementAdapterNativeDataKey))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $egYGR.textMediaType))) return;
                var target = (0, $bWnPL.findTextNode)(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                var payload = {
                    // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target: target,
                    plain: event.dataTransfer.getData((0, $egYGR.textMediaType)),
                    HTML: event.dataTransfer.getData((0, $ltjac.HTMLMediaType))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: (0, $5OMIL.honeyPotFix).getOnPostDispatch()
});
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $43a7a24835c609f6$export$e00c9c6684b0ace.registerUsage();
})();

});
parcelRegister("ltjac", function(module, exports) {
$parcel$export(module.exports, "HTMLMediaType", () => $fa1b2bde86a492fb$export$338a9f6c7a1f02b0);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $fa1b2bde86a492fb$export$338a9f6c7a1f02b0 = 'text/html';

});

parcelRegister("bWnPL", function(module, exports) {
$parcel$export(module.exports, "findTextNode", () => $8b1799692ab29771$export$c15c0fde2d293bb4);

var $8nu2B = parcelRequire("8nu2B");

var $egYGR = parcelRequire("egYGR");
function $8b1799692ab29771$export$c15c0fde2d293bb4(event) {
    var _event$dataTransfer;
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $8nu2B.isSafari)()) return null;
    /**
   * According to the spec, `event.target` should be the `Text` node that
   * the drag started from when dragging a text selection.
   *
   * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
   *
   * However, in Safari the closest `HTMLElement` is returned.
   * So we need to figure out if text is dragging ourselves.
   *
   * → https://bugs.webkit.org/show_bug.cgi?id=268959
   */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!((_event$dataTransfer = event.dataTransfer) !== null && _event$dataTransfer !== void 0 && _event$dataTransfer.getData((0, $egYGR.textMediaType)))) return null;
    /**
   * Grab the first Text node and use that.
   * Only doing a single level search as that is all we need for this bug.
   */ var text = Array.from(event.target.childNodes).find(function(node) {
        return node.nodeType === Node.TEXT_NODE;
    });
    return text !== null && text !== void 0 ? text : null;
}

});

parcelRegister("5OMIL", function(module, exports) {
$parcel$export(module.exports, "honeyPotFix", () => $43c76a38e4e1906b$export$f17744ed5439c0ab);

var $9yVBQ = parcelRequire("9yVBQ");
var $43c76a38e4e1906b$export$f17744ed5439c0ab = (0, $9yVBQ.makeHoneyPotFix)();

});




parcelRegister("cTagc", function(module, exports) {
$parcel$export(module.exports, "width", () => $9622949245924131$export$7e3df82ee760448c);
var $9622949245924131$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};

});

parcelRegister("4tRFQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $34338163c6f3d5c9$export$2e2bcd8739ae039);
/* modal-dialog.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hRJ5R = parcelRequire("hRJ5R");

var $iO8GM = parcelRequire("iO8GM");

var $gpUQB = parcelRequire("gpUQB");

var $h8qvJ = parcelRequire("h8qvJ");

var $3X1Kk = parcelRequire("3X1Kk");

var $aOu6p = parcelRequire("aOu6p");

var $aAQBJ = parcelRequire("aAQBJ");

var $7ujRa = parcelRequire("7ujRa");

var $50U6m = parcelRequire("50U6m");

var $fGFYU = parcelRequire("fGFYU");

var $fAYgP = parcelRequire("fAYgP");

var $gPZ7j = parcelRequire("gPZ7j");

var $5YyDq = parcelRequire("5YyDq");

var $amgLb = parcelRequire("amgLb");

var $6fqgi = parcelRequire("6fqgi");

var $27rGG = parcelRequire("27rGG");

var $k2Sdf = parcelRequire("k2Sdf");

var $3hvaf = parcelRequire("3hvaf");

var $fA8Gf = parcelRequire("fA8Gf");
var $34338163c6f3d5c9$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
var $34338163c6f3d5c9$var$dialogStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _1bsb1osq _p12fauwl _4t3i1osq _1tkeidpf _c71l1kxc _2lx21bp4 _bfhk1bhr _syazi7uo _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y _we1i1kw7 _zg7p130s _yakv1kw7 _4lht1kw7 _1xlt6m9r",
    borderRadius: "_epkxpb1k",
    motion: "_c71l1kw7 _p12f1kw7 _1e0c1txw _1jyk1jm9 _1if81osq",
    rootMotion: "_yakv1wug _4lht1wug",
    fullscreen: "_1jyk1osq"
};
var $34338163c6f3d5c9$var$viewportScrollStyles = null;
var $34338163c6f3d5c9$var$bodyScrollStyles = null;
var $34338163c6f3d5c9$var$ModalDialog = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var _props$width = props.width, width = _props$width === void 0 ? 'medium' : _props$width, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, shouldCloseOnEscapePress = props.shouldCloseOnEscapePress, autoFocus = props.autoFocus, stackIndex = props.stackIndex, onClose = props.onClose, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, height = props.height, hasProvidedOnClose = props.hasProvidedOnClose, children = props.children, label = props.label, testId = props.testId, _props$isFullScreen = props.isFullScreen, isFullScreen = _props$isFullScreen === void 0 ? false : _props$isFullScreen, _props$UNSAFE_shouldD = props.UNSAFE_shouldDisableMotionUplift, UNSAFE_shouldDisableMotionUplift = _props$UNSAFE_shouldD === void 0 ? false : _props$UNSAFE_shouldD;
    var id = (0, $h8qvJ.useId)();
    var titleId = "modal-dialog-title-".concat(id);
    var defaultTestId = testId || 'modal-dialog';
    (0, $5FkrB.useEffect)(function() {
        return(// Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        (0, $fGFYU.combine)((0, $5YyDq.disableDraggingToCrossOriginIFramesForElement)(), (0, $6fqgi.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $amgLb.disableDraggingToCrossOriginIFramesForExternal)()));
    }, []);
    (0, $gpUQB.default)(autoFocus, // When a user supplies  a ref to focus we enable this hook
    (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(autoFocus) === 'object');
    var _useOnMotionFinish = (0, $gPZ7j.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    }), _useOnMotionFinish2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useOnMotionFinish, 2), motionRef = _useOnMotionFinish2[0], onMotionFinish = _useOnMotionFinish2[1];
    var modalDialogContext = (0, $5FkrB.useMemo)(function() {
        return {
            testId: defaultTestId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen
        };
    }, [
        defaultTestId,
        titleId,
        onClose,
        hasProvidedOnClose,
        isFullScreen
    ]);
    (0, $3X1Kk.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    var _useLayering = (0, $aOu6p.useLayering)(), currentLevel = _useLayering.currentLevel;
    return /*#__PURE__*/ $5FkrB.createElement((0, $fA8Gf.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: defaultTestId,
        isFullScreen: isFullScreen
    }, /*#__PURE__*/ $5FkrB.createElement((0, $fAYgP.ModalContext).Provider, {
        value: modalDialogContext
    }, /*#__PURE__*/ $5FkrB.createElement((0, $27rGG.ScrollContext).Provider, {
        value: shouldScrollInViewport
    }, !UNSAFE_shouldDisableMotionUplift && (0, $50U6m.fg)('platform-dst-motion-uplift-modal') ? /*#__PURE__*/ $5FkrB.createElement((0, $aAQBJ.default), {
        enteringAnimation: "var(--ds-modal-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100)",
        exitingAnimation: "var(--ds-modal-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95)",
        onFinish: onMotionFinish,
        xcss: (0, $hRJ5R.cx)($34338163c6f3d5c9$var$dialogStyles.motion, isFullScreen && $34338163c6f3d5c9$var$dialogStyles.fullscreen),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-width': (0, $3hvaf.dialogWidth)(width),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-height': (0, $k2Sdf.dialogHeight)(height)
        }
    }, /*#__PURE__*/ $5FkrB.createElement("section", {
        "aria-label": label,
        ref: (0, $iO8GM.default)([
            motionRef,
            ref
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-width': (0, $3hvaf.dialogWidth)(width),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-height': (0, $k2Sdf.dialogHeight)(height)
        },
        role: "dialog",
        "aria-labelledby": label ? undefined : titleId,
        "data-testid": defaultTestId,
        "data-modal-stack": stackIndex,
        tabIndex: -1,
        "aria-modal": true,
        "data-ds--level": currentLevel,
        className: (0, $970q7.default)([
            $34338163c6f3d5c9$var$dialogStyles.root,
            $34338163c6f3d5c9$var$dialogStyles.rootMotion,
            !isFullScreen && $34338163c6f3d5c9$var$dialogStyles.borderRadius,
            shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7"
        ])
    }, children)) : /*#__PURE__*/ $5FkrB.createElement((0, $7ujRa.default), {
        entranceDirection: isFullScreen ? undefined : 'bottom',
        onFinish: onMotionFinish
    }, function(bottomFadeInProps) {
        return /*#__PURE__*/ $5FkrB.createElement("section", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, bottomFadeInProps, {
            "aria-label": label,
            ref: (0, $iO8GM.default)([
                bottomFadeInProps.ref,
                motionRef,
                ref
            ]),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-width': (0, $3hvaf.dialogWidth)(width),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-height': (0, $k2Sdf.dialogHeight)(height)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $970q7.default)([
                $34338163c6f3d5c9$var$dialogStyles.root,
                !isFullScreen && $34338163c6f3d5c9$var$dialogStyles.borderRadius,
                shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7",
                bottomFadeInProps.className
            ]),
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": defaultTestId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true,
            "data-ds--level": currentLevel
        }), children);
    }))));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc, @atlaskit/volt-strict-mode/no-multiple-exports
$34338163c6f3d5c9$export$2e2bcd8739ae039 = $34338163c6f3d5c9$var$ModalDialog;

});
parcelRegister("3X1Kk", function(module, exports) {
$parcel$export(module.exports, "useCloseOnEscapePress", () => $2e083c8a77606a79$export$4a4bf067ea9e7886);

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $aOu6p = parcelRequire("aOu6p");
var $2e083c8a77606a79$var$ESCAPE = 'Escape';
function $2e083c8a77606a79$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var _useLayering = (0, $aOu6p.useLayering)(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $2e083c8a77606a79$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});

parcelRegister("gPZ7j", function(module, exports) {
$parcel$export(module.exports, "default", () => $c420d149c35f2219$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $c420d149c35f2219$export$2e2bcd8739ae039(_ref) {
    var onOpenComplete = _ref.onOpenComplete, onCloseComplete = _ref.onCloseComplete;
    var motionRef = (0, $5FkrB.useRef)(null);
    var onMotionFinish = (0, $5FkrB.useCallback)(function(state) {
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("k2Sdf", function(module, exports) {
$parcel$export(module.exports, "dialogHeight", () => $e97e0c1190b1ccc8$export$ceba93bf0bdd16f2);
var $e97e0c1190b1ccc8$export$ceba93bf0bdd16f2 = function dialogHeight(input) {
    if (!input) return 'auto';
    return typeof input === 'number' ? "".concat(input, "px") : input;
};

});

parcelRegister("3hvaf", function(module, exports) {
$parcel$export(module.exports, "dialogWidth", () => $263b2239137cfda4$export$a3da89b899389ed8);

var $cTagc = parcelRequire("cTagc");
var $263b2239137cfda4$export$a3da89b899389ed8 = function dialogWidth(input) {
    if (!input) return 'auto';
    var isWidthName = (0, $cTagc.width).values.indexOf(input.toString()) !== -1;
    var widthName = isWidthName && input;
    if (widthName) return "".concat((0, $cTagc.width).widths[widthName], "px");
    return typeof input === 'number' ? "".concat(input, "px") : input;
};

});

parcelRegister("fA8Gf", function(module, exports) {
$parcel$export(module.exports, "default", () => $b580f38a937ff05b$export$2e2bcd8739ae039);
/* positioner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $2ToBd = parcelRequire("2ToBd");

var $VfFcJ = parcelRequire("VfFcJ");

// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
var $b580f38a937ff05b$var$positionerStyles = null;
var $b580f38a937ff05b$var$stackStyles = {
    stackTransition: "_k8m01e03 _1bumglyw _sedtglyw",
    stackTransform: "_t9ec1b95",
    stackIdle: "_t9ecglyw"
};
// Hardcoded pixels are based off a 60px base gutter
var $b580f38a937ff05b$var$scrollStyles = {
    viewport: "_4t3i1wug _kqswh2mm _1f6n1wqb _1eot1wug _eoawglyw",
    body: "_we1i18uh _e8uozwhf _y1k5stnw _5ee41nf8 _1urridpf _1juqidpf _yakv1wug _4lht1wug _eoawglyw",
    fullScreen: ""
};
function $b580f38a937ff05b$var$getScrollBehavior(_ref) {
    var isFullScreen = _ref.isFullScreen, shouldScrollInViewport = _ref.shouldScrollInViewport;
    if (isFullScreen) return 'fullScreen';
    if (shouldScrollInViewport) return 'viewport';
    return 'body';
}
var $b580f38a937ff05b$var$Positioner = function Positioner(props) {
    var children = props.children, stackIndex = props.stackIndex, shouldScrollInViewport = props.shouldScrollInViewport, testId = props.testId, isFullScreen = props.isFullScreen;
    var scrollBehavior = $b580f38a937ff05b$var$getScrollBehavior({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        style: {
            '--modal-dialog-translate-y': "calc(".concat(stackIndex, "px * ", "var(--ds-space-100, 8px)", ")"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            transitionDuration: "".concat((0, $VfFcJ.durations).medium, "ms"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transitionTimingFunction: (0, $2ToBd.easeInOut)
        },
        "data-testid": testId && "".concat(testId, "--positioner"),
        className: (0, $970q7.default)([
            "_1e0c1txw _1bsb1osq _p12f1osq _4t3i1osq _kqsw1n9t _1pby16oo _2lx21bp4 _152tidpf _1e02idpf",
            $b580f38a937ff05b$var$stackStyles.stackTransition,
            stackIndex > 0 ? $b580f38a937ff05b$var$stackStyles.stackTransform : $b580f38a937ff05b$var$stackStyles.stackIdle,
            $b580f38a937ff05b$var$scrollStyles[scrollBehavior]
        ])
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b580f38a937ff05b$export$2e2bcd8739ae039 = $b580f38a937ff05b$var$Positioner;

});
parcelRegister("2ToBd", function(module, exports) {
$parcel$export(module.exports, "easeInOut", () => $21b3ccb8584b7523$export$c07234257a03d5e9);
var $21b3ccb8584b7523$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
var $21b3ccb8584b7523$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
var $21b3ccb8584b7523$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
var $21b3ccb8584b7523$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
var $21b3ccb8584b7523$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
var $21b3ccb8584b7523$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
var $21b3ccb8584b7523$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

});





parcelRegister("3oYKE", function(module, exports) {
$parcel$export(module.exports, "default", () => $27a2bcf6b5739b95$export$2e2bcd8739ae039);
/* modal-footer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $k8Idm = parcelRequire("k8Idm");
var $27a2bcf6b5739b95$var$footerStyles = null;
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $27a2bcf6b5739b95$var$ModalFooter = function ModalFooter(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $k8Idm.useModal)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--footer");
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": testId,
        className: (0, $970q7.default)([
            "_zulpu2gc _18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bahesu3 _1pfh1i6y _85i51ejb _1q51pxbi"
        ])
    }, children);
};
var $27a2bcf6b5739b95$export$2e2bcd8739ae039 = $27a2bcf6b5739b95$var$ModalFooter;

});

parcelRegister("acmdv", function(module, exports) {
$parcel$export(module.exports, "default", () => $76cc42296ea847b3$export$2e2bcd8739ae039);
/* modal-header.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $018Xo = parcelRequire("018Xo");

var $83z99 = parcelRequire("83z99");

var $k8Idm = parcelRequire("k8Idm");
var $76cc42296ea847b3$var$styles = {
    header: "_18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bah1yb4 _6rth1i6y _85i5pxbi _1q511ejb",
    flex: "_2lx21sbv _1bsb1osq",
    titleContainer: "_1ul9idpf"
};
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $76cc42296ea847b3$var$ModalHeader = function ModalHeader(props) {
    var children = props.children, userDefinedTestId = props.testId, _props$hasCloseButton = props.hasCloseButton, hasCloseButton = _props$hasCloseButton === void 0 ? false : _props$hasCloseButton;
    var _useModal = (0, $k8Idm.useModal)(), hasProvidedOnClose = _useModal.hasProvidedOnClose, onClose = _useModal.onClose, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--header");
    // Only show if an onClose was provided for the modal dialog
    var shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        "data-testid": testId,
        className: (0, $970q7.default)([
            $76cc42296ea847b3$var$styles.header
        ])
    }, shouldShowCloseButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $018Xo.Flex), {
        gap: "space.200",
        justifyContent: "space-between",
        xcss: $76cc42296ea847b3$var$styles.flex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $018Xo.Flex), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $83z99.CloseButton), {
        onClick: onClose,
        testId: modalTestId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $018Xo.Flex), {
        justifyContent: "start",
        alignItems: "center",
        xcss: $76cc42296ea847b3$var$styles.titleContainer
    }, children)) : children);
};
var $76cc42296ea847b3$export$2e2bcd8739ae039 = $76cc42296ea847b3$var$ModalHeader;

});
parcelRegister("83z99", function(module, exports) {
$parcel$export(module.exports, "CloseButton", () => $5dd9ddf25210aa84$export$de65de8213222d10);

var $5FkrB = parcelRequire("5FkrB");

var $5yfDB = parcelRequire("5yfDB");

var $ac8VW = parcelRequire("ac8VW");
var $5dd9ddf25210aa84$export$de65de8213222d10 = function CloseButton(_ref) {
    var label = _ref.label, onBlur = _ref.onBlur, onClick = _ref.onClick, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5yfDB.default), {
        testId: testId && "".concat(testId, "--close-button"),
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ac8VW))),
        label: label || 'Close Modal',
        onBlur: onBlur,
        onClick: onClick
    });
};

});


parcelRegister("ayzaw", function(module, exports) {
$parcel$export(module.exports, "default", () => $7af85c26c1507548$export$2e2bcd8739ae039);
/* modal-title.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $cMVCI = parcelRequire("cMVCI");

var $lNKbd = parcelRequire("lNKbd");

var $k8Idm = parcelRequire("k8Idm");
var $7af85c26c1507548$var$iconColor = {
    danger: "var(--ds-icon-danger, #C9372C)",
    warning: "var(--ds-icon-warning, #E06C00)"
};
var $7af85c26c1507548$var$iconStyles = null;
var $7af85c26c1507548$var$titleStyles = null;
var $7af85c26c1507548$var$textStyles = null;
var $7af85c26c1507548$var$truncatedTextStyles = null;
var $7af85c26c1507548$var$TitleIcon = function TitleIcon(_ref) {
    var appearance = _ref.appearance;
    var Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($cMVCI))) : (0, (/*@__PURE__*/$parcel$interopDefault($lNKbd)));
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _syaz1kw7 _1wyb1kw7 _zg8l1kw7 _k48p1kw7 _1dyz1kw7 _vwz41kw7"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement(Icon, {
        label: appearance,
        color: $7af85c26c1507548$var$iconColor[appearance],
        spacing: "spacious"
    }));
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $7af85c26c1507548$var$ModalTitle = function ModalTitle(props) {
    var appearance = props.appearance, children = props.children, _props$isMultiline = props.isMultiline, isMultiline = _props$isMultiline === void 0 ? true : _props$isMultiline, userDefinedTestId = props.testId;
    var _useModal = (0, $k8Idm.useModal)(), titleId = _useModal.titleId, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--title");
    return /*#__PURE__*/ $5FkrB.createElement("h1", {
        "data-testid": testId,
        className: (0, $970q7.default)([
            "_zulpu2gc _11c81af2 _1e0c1txw _1ul9idpf _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t"
        ])
    }, appearance && /*#__PURE__*/ $5FkrB.createElement($7af85c26c1507548$var$TitleIcon, {
        appearance: appearance
    }), /*#__PURE__*/ $5FkrB.createElement("span", {
        id: titleId,
        "data-testid": testId && "".concat(testId, "-text"),
        className: (0, $970q7.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _11c81af2 _1ul9idpf _slp31hna",
            !isMultiline && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ])
    }, children));
};
var $7af85c26c1507548$export$2e2bcd8739ae039 = $7af85c26c1507548$var$ModalTitle;

});

parcelRegister("lh9Pt", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7d2cf5bbc14db36$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $9Et5g = parcelRequire("9Et5g");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $f7d2cf5bbc14db36$var$ModalTransition = function ModalTransition(props) {
    var _props$children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9Et5g.default), {
        appear: true
    }, (_props$children = props.children) !== null && _props$children !== void 0 ? _props$children : null);
};
var $f7d2cf5bbc14db36$export$2e2bcd8739ae039 = $f7d2cf5bbc14db36$var$ModalTransition;

});


parcelRegister("h6eHf", function(module, exports) {
$parcel$export(module.exports, "useLinkWarningModal", () => $c72e65a2d8b8655e$export$32b76c003683c2ec);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $bDUuG = parcelRequire("bDUuG");

var $6vYyW = parcelRequire("6vYyW");

var $8ckEN = parcelRequire("8ckEN");
var $c72e65a2d8b8655e$var$toUrl = function toUrl(url, base) {
    try {
        return new URL(url, base);
    } catch (_unused) {
        return undefined;
    }
};
var $c72e65a2d8b8655e$export$32b76c003683c2ec = function useLinkWarningModal() {
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), unsafeLinkText = _useState2[0], setUnsafeLinkText = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), url = _useState4[0], setUrl = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), isOpen = _useState6[0], setIsOpen = _useState6[1];
    var _useAnalyticsEvents = (0, $bDUuG.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var sendWarningModalViewedEvent = function sendWarningModalViewedEvent() {
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'linkSafetyWarningModal',
            eventType: 'screen',
            name: 'linkSafetyWarningModal'
        }).fire((0, $8ckEN.ANALYTICS_CHANNEL));
    };
    var sendContinueClickedEvent = function sendContinueClickedEvent() {
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'linkSafetyWarningModalContinue',
            eventType: 'ui',
            screen: 'linkSafetyWarningModal'
        }).fire((0, $8ckEN.ANALYTICS_CHANNEL));
    };
    /**
   * It checks and warns if a link text is a URL and different from an actual link destination
   */ var isLinkSafe = function isLinkSafe(event, href) {
        if (!href) return true;
        var anchor = event.currentTarget;
        var linkText = anchor.innerText;
        var normalisedUrlFromLinkText = (0, $6vYyW.normalizeUrl)(linkText);
        if (!normalisedUrlFromLinkText) return true;
        var anchorLinkRegex = new RegExp(/^#/im);
        var isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
        var isAnchorLink = anchorLinkRegex.test(href);
        if (isAnchorLink || isLinkTextAnchorLink) return true;
        var relativeLinkRegex = new RegExp(/^\//im);
        var isRelativeHrefLink = relativeLinkRegex.test(href);
        if (isRelativeHrefLink) return true;
        var hrefUrl = $c72e65a2d8b8655e$var$toUrl(href, window.location.origin);
        var linkTextUrl = $c72e65a2d8b8655e$var$toUrl(normalisedUrlFromLinkText, hrefUrl === null || hrefUrl === void 0 ? void 0 : hrefUrl.origin);
        if (!hrefUrl || !linkTextUrl) return true;
        var currentAtlassianProductOrigin = window.location.origin;
        var isSafeToIgnoreNonOriginDifferences = (hrefUrl === null || hrefUrl === void 0 ? void 0 : hrefUrl.origin) === currentAtlassianProductOrigin && (linkTextUrl === null || linkTextUrl === void 0 ? void 0 : linkTextUrl.origin) === currentAtlassianProductOrigin;
        if (isSafeToIgnoreNonOriginDifferences) return true;
        var httpProtocols = [
            'http:',
            'https:'
        ];
        var areProtocolsEquivalent;
        if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
            var noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
            areProtocolsEquivalent = noUserNameAndPassword;
        } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
        var areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
        if (!areEquivalentLinks) return false;
        return true;
    };
    var showSafetyWarningModal = function showSafetyWarningModal(event, href) {
        event.preventDefault();
        var anchor = event.currentTarget;
        var linkText = anchor.innerText;
        setUnsafeLinkText(linkText);
        href && setUrl(href);
        setIsOpen(true);
        sendWarningModalViewedEvent();
    };
    var onClose = function onClose() {
        setIsOpen(false);
        setUnsafeLinkText(null);
        setUrl(null);
    };
    var onContinue = function onContinue() {
        onClose();
        sendContinueClickedEvent();
        url && window.open(url, '_blank', 'noopener noreferrer');
    };
    return {
        isLinkSafe: isLinkSafe,
        isOpen: isOpen,
        onClose: onClose,
        onContinue: onContinue,
        showSafetyWarningModal: showSafetyWarningModal,
        unsafeLinkText: unsafeLinkText,
        url: url
    };
};

});
parcelRegister("6vYyW", function(module, exports) {
$parcel$export(module.exports, "normalizeUrl", () => $4be49dc805e37634$export$6535eb414fa2c8b6);
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $840z9 = parcelRequire("840z9");

var $2x31m = parcelRequire("2x31m");

var $kR6gZ = parcelRequire("kR6gZ");
var $4be49dc805e37634$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
var $4be49dc805e37634$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
var $4be49dc805e37634$var$linkify = new (0, $840z9.default)();
$4be49dc805e37634$var$linkify.add('sourcetree:', 'http:');
$4be49dc805e37634$var$linkify.add('jamfselfservice:', 'http:');
$4be49dc805e37634$var$linkify.add('notes:', 'http:');
$4be49dc805e37634$var$tlds.push($4be49dc805e37634$var$tlds2Char);
$4be49dc805e37634$var$linkify.tlds($4be49dc805e37634$var$tlds, false);
var $4be49dc805e37634$var$normaliseLinkHref = function normaliseLinkHref(url) {
    var match = $4be49dc805e37634$var$getLinkMatch(url);
    return match && match.url || null;
};
var $4be49dc805e37634$var$getLinkMatch = function getLinkMatch(str) {
    if (!str) return null;
    var match = (0, $kR6gZ.linkifyMatch)(str);
    if (!match || !match.length) match = $4be49dc805e37634$var$linkify.match(str);
    return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
};
function $4be49dc805e37634$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    var urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
    if ((0, $2x31m.isSafeUrl)(urlWithoutNewlines)) return urlWithoutNewlines.trim();
    return $4be49dc805e37634$var$normaliseLinkHref(urlWithoutNewlines);
}

});
parcelRegister("2x31m", function(module, exports) {
$parcel$export(module.exports, "isSafeUrl", () => $1d8101b6181f1b92$export$c9f92f5469372e0f);
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ var $1d8101b6181f1b92$var$whitelistedURLPatterns = [
    /^https?:\/\/[^\s]*$/im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\/[^\s]*$/im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:[^\s]*$/im,
    /^facetime:[^\s]*$/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^foo:/im,
    /^#/im
];
var $1d8101b6181f1b92$export$c9f92f5469372e0f = function isSafeUrl(url) {
    var urlTrimmed = url.trim();
    return $1d8101b6181f1b92$var$whitelistedURLPatterns.some(function(p) {
        return p.test(urlTrimmed);
    });
};

});

parcelRegister("kR6gZ", function(module, exports) {
$parcel$export(module.exports, "linkifyMatch", () => $f2ed9f943885ea5e$export$6f7d7761b97f967);
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ var $f2ed9f943885ea5e$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
var $f2ed9f943885ea5e$export$6f7d7761b97f967 = function linkifyMatch(text) {
    var matches = [];
    if (!$f2ed9f943885ea5e$var$LINK_REGEXP.test(text)) return matches;
    var startpos = 0;
    var substr;
    while(substr = text.substr(startpos)){
        var link = (substr.match($f2ed9f943885ea5e$var$LINK_REGEXP) || [
            ''
        ])[0];
        if (link) {
            var index = substr.search($f2ed9f943885ea5e$var$LINK_REGEXP);
            var start = index >= 0 ? index + startpos : index;
            var end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos = end;
        } else break;
    }
    return matches;
};

});




parcelRegister("9M0Oh", function(module, exports) {
$parcel$export(module.exports, "InlineCard", () => $71d9399e774f8bc8$export$aff6291803939b05);
$parcel$export(module.exports, "toReact", () => $71d9399e774f8bc8$export$d4334b129116aad7);
$parcel$export(module.exports, "mergeTextNodes", () => $71d9399e774f8bc8$export$8045509d14b5046f);
$parcel$export(module.exports, "isTextWrapper", () => $71d9399e774f8bc8$export$d4ebd3557ee7fac1);
$parcel$export(module.exports, "isTextNode", () => $71d9399e774f8bc8$export$ccbedd67ef6e9417);
$parcel$export(module.exports, "Doc", () => (parcelRequire("ac0Rs")).default);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => (parcelRequire("ac0Rs")).DocWithSelectAllTrap);

var $25nEq = parcelRequire("25nEq");

var $bhmkE = parcelRequire("bhmkE");

var $5dFQJ = parcelRequire("5dFQJ");
var $2wYtd = parcelRequire("2wYtd");

var $anuR6 = parcelRequire("anuR6");

var $21Umc = parcelRequire("21Umc");

var $aJQyW = parcelRequire("aJQyW");

var $4piwi = parcelRequire("4piwi");

var $ac0Rs = parcelRequire("ac0Rs");

var $ksTq8 = parcelRequire("ksTq8");

var $bHdFw = parcelRequire("bHdFw");

var $2BMm8 = parcelRequire("2BMm8");

var $cLcT3 = parcelRequire("cLcT3");

var $iXLPT = parcelRequire("iXLPT");

var $7n8xE = parcelRequire("7n8xE");

var $betLp = parcelRequire("betLp");

var $fMHNb = parcelRequire("fMHNb");

var $geLdv = parcelRequire("geLdv");

var $1KF3y = parcelRequire("1KF3y");

var $jwO6B = parcelRequire("jwO6B");

var $7UBSy = parcelRequire("7UBSy");

var $1BsF5 = parcelRequire("1BsF5");

var $8tCqL = parcelRequire("8tCqL");

var $65d1I = parcelRequire("65d1I");

var $5FiyC = parcelRequire("5FiyC");

var $fK54y = parcelRequire("fK54y");
function $71d9399e774f8bc8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $71d9399e774f8bc8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $71d9399e774f8bc8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $71d9399e774f8bc8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

var $71d9399e774f8bc8$export$a22ee8f907eecb5f = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("92uBc")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$6c415d1fdae3dfdb = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("90piW")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$771a55a10b0a40ae = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("ahHfv")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$27c4189b8be1bf93 = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("1enik")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$b458dfa720128865 = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("bfIlp")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$b6f73a2b0b0de599 = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("laTH3")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$6341f9a885713487 = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("1Oi6Q")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$96e9906d6d93a972 = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("bAEpH")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$56cc48506ff790a = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("1D8Lz")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$2ddb90ad54e5f587 = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("6y0yn")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$6789d7ecdc77631b = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("4IGrB")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$aff6291803939b05 = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("g6NBo")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$d18ccd25c0d2c6b0 = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("8Ld8e")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$7fc53215244aec38 = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("agnp1")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$d7858be3df00d59 = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("2bcaO")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$462ea7c2a1c4cb1f = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("i524b")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$888d74bc001c3a5d = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("eRkfx")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$e891316fea657d90 = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("1MCh5")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$49bd1dfb0ad29c40 = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("1o3cc")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$var$SyncBlockLoader = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("61mDg")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$var$BodiedSyncBlock = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("8GAYC")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});
var $71d9399e774f8bc8$export$3931063f6a5f290e = {
    blockquote: (0, $anuR6.default),
    bulletList: (0, $aJQyW.default),
    blockCard: $71d9399e774f8bc8$export$d18ccd25c0d2c6b0,
    caption: (0, $4piwi.default),
    date: $71d9399e774f8bc8$export$6341f9a885713487,
    decisionItem: $71d9399e774f8bc8$export$b6f73a2b0b0de599,
    decisionList: $71d9399e774f8bc8$export$b458dfa720128865,
    doc: (0, $ac0Rs.default),
    emoji: $71d9399e774f8bc8$export$56cc48506ff790a,
    extension: (0, $ksTq8.default),
    bodiedExtension: (0, $21Umc.default),
    multiBodiedExtension: (0, $geLdv.default),
    extensionFrame: (0, $bHdFw.default),
    hardBreak: (0, $2BMm8.default),
    heading: (0, $cLcT3.default),
    inlineCard: $71d9399e774f8bc8$export$aff6291803939b05,
    inlineExtension: (0, $iXLPT.default),
    layoutSection: (0, $betLp.default),
    layoutColumn: (0, $7n8xE.default),
    listItem: (0, $fMHNb.default),
    media: $71d9399e774f8bc8$export$7fc53215244aec38,
    mediaGroup: $71d9399e774f8bc8$export$d7858be3df00d59,
    mediaInline: $71d9399e774f8bc8$export$462ea7c2a1c4cb1f,
    mediaSingle: $71d9399e774f8bc8$export$888d74bc001c3a5d,
    mention: $71d9399e774f8bc8$export$e891316fea657d90,
    orderedList: (0, $1KF3y.default),
    panel: $71d9399e774f8bc8$export$2ddb90ad54e5f587,
    panel_c1: $71d9399e774f8bc8$export$2ddb90ad54e5f587,
    paragraph: (0, $jwO6B.default),
    placeholder: (0, $7UBSy.default),
    rule: (0, $1BsF5.default),
    status: $71d9399e774f8bc8$export$96e9906d6d93a972,
    taskItem: $71d9399e774f8bc8$export$27c4189b8be1bf93,
    taskList: $71d9399e774f8bc8$export$771a55a10b0a40ae,
    table: (0, $8tCqL.default),
    tableCell: (0, $65d1I.TableCell),
    tableHeader: (0, $65d1I.TableHeader),
    tableRow: (0, $5FiyC.default),
    unknownBlock: (0, $fK54y.default),
    unsupportedBlock: (0, $5dFQJ.default),
    unsupportedInline: (0, $2wYtd.default),
    expand: $71d9399e774f8bc8$export$49bd1dfb0ad29c40,
    syncBlock: $71d9399e774f8bc8$var$SyncBlockLoader,
    bodiedSyncBlock: $71d9399e774f8bc8$var$BodiedSyncBlock,
    nestedExpand: $71d9399e774f8bc8$export$49bd1dfb0ad29c40,
    embedCard: $71d9399e774f8bc8$export$6789d7ecdc77631b,
    blockTaskItem: $71d9399e774f8bc8$export$27c4189b8be1bf93
};
var $71d9399e774f8bc8$export$d4334b129116aad7 = function toReact(node, flags, nodeComponents) {
    if (node.type.name === 'doc' && (flags === null || flags === void 0 ? void 0 : flags.allowSelectAllTrap) === true) return 0, $ac0Rs.DocWithSelectAllTrap;
    // Allowing custom components to override those provided in nodeToReact
    var nodes = $71d9399e774f8bc8$var$_objectSpread($71d9399e774f8bc8$var$_objectSpread({}, $71d9399e774f8bc8$export$3931063f6a5f290e), nodeComponents);
    if (node.type.name === 'codeBlock') {
        var _nodes$codeBlock;
        if ((flags === null || flags === void 0 ? void 0 : flags.allowWindowedCodeBlock) === true) {
            var _nodes$windowedCodeBl;
            return (_nodes$windowedCodeBl = nodes.windowedCodeBlock) !== null && _nodes$windowedCodeBl !== void 0 ? _nodes$windowedCodeBl : $71d9399e774f8bc8$export$a22ee8f907eecb5f;
        }
        return (_nodes$codeBlock = nodes.codeBlock) !== null && _nodes$codeBlock !== void 0 ? _nodes$codeBlock : $71d9399e774f8bc8$export$6c415d1fdae3dfdb;
    }
    nodes['multiBodiedExtension'] = (0, $geLdv.default);
    return nodes[node.type.name];
};
var $71d9399e774f8bc8$export$8045509d14b5046f = function mergeTextNodes(nodes) {
    return nodes.reduce(function(acc, current) {
        if (!$71d9399e774f8bc8$export$1879817ac5c922b7(current.type.name)) {
            acc.push(current);
            return acc;
        }
        // Append node to previous node, if it was a text wrapper
        if (acc.length > 0 && $71d9399e774f8bc8$export$d4ebd3557ee7fac1(acc[acc.length - 1])) {
            var textWrapper = acc[acc.length - 1];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            textWrapper.content.push(current);
            textWrapper.nodeSize += current.nodeSize;
        } else acc.push({
            type: {
                name: 'textWrapper'
            },
            content: [
                current
            ],
            nodeSize: current.nodeSize
        });
        return acc;
    }, []);
};
var $71d9399e774f8bc8$export$1879817ac5c922b7 = function isText(type) {
    return type === 'text';
};
var $71d9399e774f8bc8$export$d4ebd3557ee7fac1 = function isTextWrapper(node) {
    return node.type.name === 'textWrapper';
};
function $71d9399e774f8bc8$export$ccbedd67ef6e9417(node) {
    return node.type.name === 'text';
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $71d9399e774f8bc8$var$whitespaceRegex = /^\s*$/;
var $71d9399e774f8bc8$export$dd0c7365db1f79a5 = function isEmojiDoc(doc) {
    if (doc.childCount !== 1) return false;
    var parentNodes = [];
    doc.forEach(function(child) {
        return parentNodes.push(child);
    });
    var node = parentNodes[0];
    return node.type.name === 'paragraph' && $71d9399e774f8bc8$var$isEmojiBlock(node.content);
};
var $71d9399e774f8bc8$var$isEmojiBlock = function isEmojiBlock(pnode) {
    var content = [];
    // Optimisation for long documents - worst case block will be space-emoji-space
    if (pnode.childCount > 7) return false;
    pnode.forEach(function(child) {
        return content.push(child);
    });
    var emojiCount = 0;
    for(var i = 0; i < content.length; ++i){
        var node = content[i];
        switch(node.type.name){
            case 'text':
                if (node.text && !node.text.match($71d9399e774f8bc8$var$whitespaceRegex)) return false;
                continue;
            case 'emoji':
                if (++emojiCount > 3) return false;
                continue;
            default:
                // Only text and emoji nodes are allowed
                return false;
        }
    }
    return emojiCount > 0;
};

});
parcelRegister("bhmkE", function(module, exports) {
"use strict";
var $83629ae75cf58ece$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $83629ae75cf58ece$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $83629ae75cf58ece$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $83629ae75cf58ece$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $5FkrB = parcelRequire("5FkrB");

var $8vJ0V = parcelRequire("8vJ0V");
var $83629ae75cf58ece$var$ALL_INITIALIZERS = [];
var $83629ae75cf58ece$var$READY_INITIALIZERS = [];
function $83629ae75cf58ece$var$isWebpackReady(getModuleIds) {
    if ((typeof __webpack_modules__ === "undefined" ? "undefined" : $83629ae75cf58ece$var$_typeof(__webpack_modules__)) !== "object") return false;
    return getModuleIds().every(function(moduleId) {
        return typeof moduleId !== "undefined" && typeof __webpack_modules__[moduleId] !== "undefined";
    });
}
function $83629ae75cf58ece$var$load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function $83629ae75cf58ece$var$loadMap(obj) {
    var state = {
        loading: false,
        loaded: {},
        error: null
    };
    var promises = [];
    try {
        Object.keys(obj).forEach(function(key) {
            var result = $83629ae75cf58ece$var$load(obj[key]);
            if (!result.loading) {
                state.loaded[key] = result.loaded;
                state.error = result.error;
            } else state.loading = true;
            promises.push(result.promise);
            result.promise.then(function(res) {
                state.loaded[key] = res;
            }).catch(function(err) {
                state.error = err;
            });
        });
    } catch (err) {
        state.error = err;
    }
    state.promise = Promise.all(promises).then(function(res) {
        state.loading = false;
        return res;
    }).catch(function(err) {
        state.loading = false;
        throw err;
    });
    return state;
}
function $83629ae75cf58ece$var$resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function $83629ae75cf58ece$var$render(loaded, props) {
    return $5FkrB.createElement($83629ae75cf58ece$var$resolve(loaded), props);
}
function $83629ae75cf58ece$var$createLoadableComponent(loadFn, options) {
    var _class, _temp;
    if (!options.loading) throw new Error("react-loadable requires a `loading` component");
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        render: $83629ae75cf58ece$var$render,
        webpack: null,
        modules: null
    }, options);
    var res = null;
    function init() {
        if (!res) res = loadFn(opts.loader);
        return res.promise;
    }
    $83629ae75cf58ece$var$ALL_INITIALIZERS.push(init);
    if (typeof opts.webpack === "function") $83629ae75cf58ece$var$READY_INITIALIZERS.push(function() {
        if ($83629ae75cf58ece$var$isWebpackReady(opts.webpack)) return init();
    });
    return _temp = _class = function(_React$Component) {
        $83629ae75cf58ece$var$_inherits(LoadableComponent, _React$Component);
        function LoadableComponent(props) {
            $83629ae75cf58ece$var$_classCallCheck(this, LoadableComponent);
            var _this = $83629ae75cf58ece$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.retry = function() {
                _this.setState({
                    error: null,
                    loading: true,
                    timedOut: false
                });
                res = loadFn(opts.loader);
                _this._loadModule();
            };
            init();
            _this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: false,
                loading: res.loading,
                loaded: res.loaded
            };
            return _this;
        }
        LoadableComponent.preload = function preload() {
            return init();
        };
        LoadableComponent.prototype.componentWillMount = function componentWillMount() {
            this._mounted = true;
            this._loadModule();
        };
        LoadableComponent.prototype._loadModule = function _loadModule() {
            var _this2 = this;
            if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                _this2.context.loadable.report(moduleName);
            });
            if (!res.loading) return;
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) this.setState({
                    pastDelay: true
                });
                else this._delay = setTimeout(function() {
                    _this2.setState({
                        pastDelay: true
                    });
                }, opts.delay);
            }
            if (typeof opts.timeout === "number") this._timeout = setTimeout(function() {
                _this2.setState({
                    timedOut: true
                });
            }, opts.timeout);
            var update = function update() {
                if (!_this2._mounted) return;
                _this2.setState({
                    error: res.error,
                    loaded: res.loaded,
                    loading: res.loading
                });
                _this2._clearTimeouts();
            };
            res.promise.then(function() {
                update();
            }).catch(function(err) {
                update();
            });
        };
        LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            this._mounted = false;
            this._clearTimeouts();
        };
        LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
            clearTimeout(this._delay);
            clearTimeout(this._timeout);
        };
        LoadableComponent.prototype.render = function render() {
            if (this.state.loading || this.state.error) return $5FkrB.createElement(opts.loading, {
                isLoading: this.state.loading,
                pastDelay: this.state.pastDelay,
                timedOut: this.state.timedOut,
                error: this.state.error,
                retry: this.retry
            });
            else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
            else return null;
        };
        return LoadableComponent;
    }($5FkrB.Component), _class.contextTypes = {
        loadable: $8vJ0V.shape({
            report: $8vJ0V.func.isRequired
        })
    }, _temp;
}
function $83629ae75cf58ece$var$Loadable(opts) {
    return $83629ae75cf58ece$var$createLoadableComponent($83629ae75cf58ece$var$load, opts);
}
function $83629ae75cf58ece$var$LoadableMap(opts) {
    if (typeof opts.render !== "function") throw new Error("LoadableMap requires a `render(loaded, props)` function");
    return $83629ae75cf58ece$var$createLoadableComponent($83629ae75cf58ece$var$loadMap, opts);
}
$83629ae75cf58ece$var$Loadable.Map = $83629ae75cf58ece$var$LoadableMap;
var $83629ae75cf58ece$var$Capture = function(_React$Component2) {
    $83629ae75cf58ece$var$_inherits(Capture, _React$Component2);
    function Capture() {
        $83629ae75cf58ece$var$_classCallCheck(this, Capture);
        return $83629ae75cf58ece$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
    }
    Capture.prototype.getChildContext = function getChildContext() {
        return {
            loadable: {
                report: this.props.report
            }
        };
    };
    Capture.prototype.render = function render() {
        return $5FkrB.Children.only(this.props.children);
    };
    return Capture;
}($5FkrB.Component);
$83629ae75cf58ece$var$Capture.propTypes = {
    report: $8vJ0V.func.isRequired
};
$83629ae75cf58ece$var$Capture.childContextTypes = {
    loadable: $8vJ0V.shape({
        report: $8vJ0V.func.isRequired
    }).isRequired
};
$83629ae75cf58ece$var$Loadable.Capture = $83629ae75cf58ece$var$Capture;
function $83629ae75cf58ece$var$flushInitializers(initializers) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init());
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) return $83629ae75cf58ece$var$flushInitializers(initializers);
    });
}
$83629ae75cf58ece$var$Loadable.preloadAll = function() {
    return new Promise(function(resolve, reject) {
        $83629ae75cf58ece$var$flushInitializers($83629ae75cf58ece$var$ALL_INITIALIZERS).then(resolve, reject);
    });
};
$83629ae75cf58ece$var$Loadable.preloadReady = function() {
    return new Promise(function(resolve, reject) {
        // We always will resolve, errors should be handled within loading UIs.
        $83629ae75cf58ece$var$flushInitializers($83629ae75cf58ece$var$READY_INITIALIZERS).then(resolve, resolve);
    });
};
module.exports = $83629ae75cf58ece$var$Loadable;

});

parcelRegister("2wYtd", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d7d7a085d2842c2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $ach6K = parcelRequire("ach6K");

var $1LBcl = parcelRequire("1LBcl");

var $f8aZY = parcelRequire("f8aZY");

var $4mzlU = parcelRequire("4mzlU");

var $jJH6F = parcelRequire("jJH6F");

var $c0oX9 = parcelRequire("c0oX9");

var $fpooh = parcelRequire("fpooh");

var $iY18h = parcelRequire("iY18h");
var $1d7d7a085d2842c2$var$inlineNodeStyle = (0, $74Zh5.css)({
    alignItems: 'center',
    background: "var(--ds-background-disabled, #0515240F)",
    border: "var(--ds-border-width, 1px)".concat(" dashed ", "var(--ds-border-disabled, #0515240F)"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'inline-flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $1LBcl.relativeFontSizeToBase16)(14),
    margin: "0 ".concat("var(--ds-space-025, 2px)"),
    minHeight: '24px',
    padding: "0 ".concat("var(--ds-space-100, 8px)"),
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
});
var $1d7d7a085d2842c2$var$UnsupportedInlineNode = function UnsupportedInlineNode(_ref) {
    var node = _ref.node, intl = _ref.intl, dispatchAnalyticsEvent = _ref.dispatchAnalyticsEvent;
    var message = (0, $iY18h.getUnsupportedContent)((0, $c0oX9.unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
    var tooltipContent = intl.formatMessage((0, $c0oX9.unsupportedContentMessages).unsupportedContentTooltip);
    var _useRef = (0, $5FkrB.useRef)({
        padding: '4px'
    }), style = _useRef.current;
    var originalNodeType = node === null || node === void 0 ? void 0 : node.attrs.originalValue.type;
    var tooltipOnShowHandler = (0, $5FkrB.useCallback)(function() {
        return dispatchAnalyticsEvent && (0, $fpooh.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $jJH6F.ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, originalNodeType);
    }, [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return (0, $74Zh5.jsx)("span", {
        css: $1d7d7a085d2842c2$var$inlineNodeStyle
    }, message, (0, $74Zh5.jsx)((0, $4mzlU.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, (0, $74Zh5.jsx)("span", {
        style: style
    }, (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f8aZY))), {
        label: "?"
    }))));
};
// eslint-disable-next-line @typescript-eslint/no-restricted-types
var $1d7d7a085d2842c2$var$_default_1 = (0, $ach6K.default)($1d7d7a085d2842c2$var$UnsupportedInlineNode);
var $1d7d7a085d2842c2$export$2e2bcd8739ae039 = $1d7d7a085d2842c2$var$_default_1;

});

parcelRegister("anuR6", function(module, exports) {
$parcel$export(module.exports, "default", () => $78e3fc9ce0f3cdbe$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $78e3fc9ce0f3cdbe$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("blockquote", {
        "data-local-id": props.localId
    }, props.children);
}

});

parcelRegister("21Umc", function(module, exports) {
$parcel$export(module.exports, "default", () => $17a76414978970eb$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $bDUuG = parcelRequire("bDUuG");

var $jJH6F = parcelRequire("jJH6F");

var $8KWVV = parcelRequire("8KWVV");

var $nOuq8 = parcelRequire("nOuq8");

var $4chaE = parcelRequire("4chaE");

var $enqEB = parcelRequire("enqEB");

var $caYHb = parcelRequire("caYHb");

var $ksTq8 = parcelRequire("ksTq8");
var $17a76414978970eb$var$BodiedExtension = function BodiedExtension(props) {
    var children = props.children, _props$layout = props.layout, layout = _props$layout === void 0 ? 'default' : _props$layout, _props$path = props.path, path = _props$path === void 0 ? [] : _props$path, extensionKey = props.extensionKey, extensionType = props.extensionType, parameters = props.parameters, extensionViewportSizes = props.extensionViewportSizes, localId = props.localId, shouldDisplayExtensionAsInline = props.shouldDisplayExtensionAsInline, fireAnalyticsEvent = props.fireAnalyticsEvent;
    var _useAnalyticsEvents = (0, $bDUuG.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map(function(child) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).isValidElement(child) ? child.props.nodeType === 'table' : false;
    }).every(Boolean);
    var validationContextValue = (0, $5FkrB.useMemo)(function() {
        return {
            allowNestedTables: true
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $enqEB.ErrorBoundary), {
        component: (0, $8KWVV.ACTION_SUBJECT).RENDERER,
        componentId: (0, $jJH6F.ACTION_SUBJECT_ID).EXTENSION_BODIED,
        createAnalyticsEvent: createAnalyticsEvent,
        additionalInfo: "".concat(extensionType, ": ").concat(extensionKey, " ")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $nOuq8.AnnotationsPositionContext).Provider, {
        value: {
            startPos: props.startPos + 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $caYHb.ValidationContextProvider), {
        value: validationContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4chaE.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        type: "bodiedExtension"
    }), function(_ref) {
        var node = _ref.node, result = _ref.result;
        try {
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
            return (0, $ksTq8.renderExtension)(result, layout, {
                isTopLevel: path.length < 1,
                rendererAppearance: props.rendererAppearance,
                fireAnalyticsEvent: fireAnalyticsEvent
            }, removeOverflow, parameters === null || parameters === void 0 ? void 0 : parameters.extensionId, extensionViewportSizes, undefined, localId, shouldDisplayExtensionAsInline, node);
        } catch (_unused) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return (0, $ksTq8.renderExtension)(children, layout, {
            isTopLevel: path.length < 1,
            rendererAppearance: props.rendererAppearance,
            fireAnalyticsEvent: fireAnalyticsEvent
        }, removeOverflow, parameters === null || parameters === void 0 ? void 0 : parameters.extensionId, extensionViewportSizes, undefined, localId, shouldDisplayExtensionAsInline, node);
    }))));
};
var $17a76414978970eb$export$2e2bcd8739ae039 = $17a76414978970eb$var$BodiedExtension;

});
parcelRegister("8KWVV", function(module, exports) {
$parcel$export(module.exports, "EVENT_TYPE", () => $6600558643eed006$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $6600558643eed006$export$9523889e0a5da4ba);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $6600558643eed006$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $6600558643eed006$export$9957974f8b4d8f74);
var $6600558643eed006$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $6600558643eed006$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["STARTED"] = "started";
    ACTION["RENDERED"] = "rendered";
    ACTION["CRASHED"] = "unhandledErrorCaught";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["CLICKED"] = "clicked";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["INSERTED"] = "inserted";
    ACTION["OPENED"] = "opened";
    ACTION["CLOSED"] = "closed";
    ACTION["DELETED"] = "deleted";
    ACTION["EDITED"] = "edited";
    ACTION["RESOLVED"] = "resolved";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["TABLE_WIDTH_INFO"] = "tableWidthInfo";
    return ACTION;
}({});
var $6600558643eed006$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    return ACTION_SUBJECT;
}({});
var $6600558643eed006$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["HOVER_LABEL"] = "hoverLabel";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_DOWNLOAD"] = "codeBlockDownload";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    return ACTION_SUBJECT_ID;
}({});

});

parcelRegister("nOuq8", function(module, exports) {
$parcel$export(module.exports, "AnnotationsPositionContext", () => $0479504a5498162f$export$8c8c3e12db6c0591);
$parcel$export(module.exports, "AnnotationsWrapper", () => $0479504a5498162f$export$cef0157dd42cbb3f);

var $5FkrB = parcelRequire("5FkrB");

var $kX1mK = parcelRequire("kX1mK");

var $bDUuG = parcelRequire("bDUuG");

var $gtPYB = parcelRequire("gtPYB");

var $7bLYW = parcelRequire("7bLYW");

var $fDwDe = parcelRequire("fDwDe");

var $38vNc = parcelRequire("38vNc");

var $2pzUn = parcelRequire("2pzUn");

var $lh3H1 = parcelRequire("lh3H1");

var $bCYQR = parcelRequire("bCYQR");

var $ePfJP = parcelRequire("ePfJP");
var $0479504a5498162f$var$LoadAnnotations = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(function(_ref) {
    var adfDocument = _ref.adfDocument, isNestedRender = _ref.isNestedRender, onLoadComplete = _ref.onLoadComplete;
    (0, $lh3H1.useLoadAnnotations)({
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    });
    return null;
});
var $0479504a5498162f$export$8c8c3e12db6c0591 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext({
    startPos: 1
});
var $0479504a5498162f$export$7121915072388536 = function AnnotationsWrapperInner(props) {
    var _providers$inlineComm, _providers$inlineComm2;
    var children = props.children, rendererRef = props.rendererRef, adfDocument = props.adfDocument, isNestedRender = props.isNestedRender, onLoadComplete = props.onLoadComplete;
    var providers = (0, $5FkrB.useContext)((0, $gtPYB.ProvidersContext));
    var updateSubscriber = providers && providers.inlineComment && providers.inlineComment.updateSubscriber;
    var inlineCommentAnnotationsState = (0, $2pzUn.useAnnotationStateByTypeEvent)({
        type: (0, $kX1mK.AnnotationTypes).INLINE_COMMENT,
        updateSubscriber: updateSubscriber || null
    });
    var _useAnalyticsEvents = (0, $bDUuG.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gtPYB.InlineCommentsStateContext).Provider, {
        value: inlineCommentAnnotationsState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $38vNc.AnnotationRangeProvider), {
        allowCommentsOnMedia: (_providers$inlineComm = providers === null || providers === void 0 || (_providers$inlineComm2 = providers.inlineComment) === null || _providers$inlineComm2 === void 0 ? void 0 : _providers$inlineComm2.allowCommentsOnMedia) !== null && _providers$inlineComm !== void 0 ? _providers$inlineComm : false,
        isNestedRender: isNestedRender
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7bLYW.AnnotationHoverContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ePfJP.AnnotationsContextWrapper), {
        createAnalyticsEvent: createAnalyticsEvent,
        rendererRef: rendererRef,
        isNestedRender: isNestedRender
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($0479504a5498162f$var$LoadAnnotations, {
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bCYQR.AnnotationView), {
        isNestedRender: isNestedRender,
        createAnalyticsEvent: createAnalyticsEvent
    }), children))));
};
var $0479504a5498162f$export$cef0157dd42cbb3f = function AnnotationsWrapper(props) {
    var children = props.children, annotationProvider = props.annotationProvider, rendererRef = props.rendererRef, adfDocument = props.adfDocument, isNestedRender = props.isNestedRender, onLoadComplete = props.onLoadComplete;
    if (!isNestedRender && annotationProvider !== null && annotationProvider !== void 0 && annotationProvider.annotationManager) {
        var _annotationProvider$i, _annotationProvider$i2;
        // We need to ensure there is a single instance of the annotation manager for the whole document
        // and that it is the same instance for all annotations.
        // This is because the annotation manager is responsible for managing the state of ALL annotations.
        // This includes annotations inside extensions.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gtPYB.ProvidersContext).Provider, {
            value: annotationProvider
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fDwDe.AnnotationManagerProvider), {
            annotationManager: annotationProvider.annotationManager,
            updateSubscriber: (_annotationProvider$i = annotationProvider === null || annotationProvider === void 0 || (_annotationProvider$i2 = annotationProvider.inlineComment) === null || _annotationProvider$i2 === void 0 ? void 0 : _annotationProvider$i2.updateSubscriber) !== null && _annotationProvider$i !== void 0 ? _annotationProvider$i : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($0479504a5498162f$export$7121915072388536, {
            rendererRef: rendererRef,
            adfDocument: adfDocument,
            isNestedRender: isNestedRender,
            onLoadComplete: onLoadComplete
        }, children)));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gtPYB.ProvidersContext).Provider, {
        value: annotationProvider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($0479504a5498162f$export$7121915072388536, {
        rendererRef: rendererRef,
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    }, children));
};

});
parcelRegister("7bLYW", function(module, exports) {
$parcel$export(module.exports, "AnnotationHoverContext", () => $53bec7b5a0d2c17a$export$b3db0feb20552fc3);
$parcel$export(module.exports, "useAnnotationHoverContext", () => $53bec7b5a0d2c17a$export$a02bfcbbbf920306);
$parcel$export(module.exports, "useAnnotationHoverDispatch", () => $53bec7b5a0d2c17a$export$c288883964405c82);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
var $53bec7b5a0d2c17a$var$AnnotationHoverStateContext = /*#__PURE__*/ (0, $5FkrB.createContext)({
    isWithinRange: false
});
var $53bec7b5a0d2c17a$var$AnnotationHoverDispatchContext = /*#__PURE__*/ (0, $5FkrB.createContext)({
    cancelTimeout: function cancelTimeout() {},
    initiateTimeout: function initiateTimeout() {},
    setIsWithinRange: function setIsWithinRange() {}
});
var $53bec7b5a0d2c17a$export$b3db0feb20552fc3 = function AnnotationHoverContext(_ref) {
    var children = _ref.children;
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isWithinRange = _useState2[0], setIsWithinRange = _useState2[1];
    var timeoutHandler = (0, $5FkrB.useRef)();
    var cancelTimeout = (0, $5FkrB.useCallback)(function() {
        if (timeoutHandler) clearTimeout(timeoutHandler.current);
    }, [
        timeoutHandler
    ]);
    var initiateTimeout = (0, $5FkrB.useCallback)(function() {
        if (isWithinRange) timeoutHandler.current = setTimeout(function() {
            setIsWithinRange(false);
        }, 500);
    }, [
        isWithinRange
    ]);
    var stateData = (0, $5FkrB.useMemo)(function() {
        return {
            isWithinRange: isWithinRange
        };
    }, [
        isWithinRange
    ]);
    var dispatchData = (0, $5FkrB.useMemo)(function() {
        return {
            cancelTimeout: cancelTimeout,
            initiateTimeout: initiateTimeout,
            setIsWithinRange: setIsWithinRange
        };
    }, [
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($53bec7b5a0d2c17a$var$AnnotationHoverStateContext.Provider, {
        value: stateData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($53bec7b5a0d2c17a$var$AnnotationHoverDispatchContext.Provider, {
        value: dispatchData
    }, children));
};
var $53bec7b5a0d2c17a$export$a02bfcbbbf920306 = function useAnnotationHoverContext() {
    return (0, $5FkrB.useContext)($53bec7b5a0d2c17a$var$AnnotationHoverStateContext);
};
var $53bec7b5a0d2c17a$export$c288883964405c82 = function useAnnotationHoverDispatch() {
    return (0, $5FkrB.useContext)($53bec7b5a0d2c17a$var$AnnotationHoverDispatchContext);
};

});

parcelRegister("38vNc", function(module, exports) {
$parcel$export(module.exports, "AnnotationRangeProvider", () => $248ac7c5d12222d0$export$30384a6aedd19fee);
$parcel$export(module.exports, "useAnnotationRangeState", () => $248ac7c5d12222d0$export$e07ee6d6cc95d9a0);
$parcel$export(module.exports, "useAnnotationRangeDispatch", () => $248ac7c5d12222d0$export$708fc397e2b6f08d);

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");
function $248ac7c5d12222d0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $248ac7c5d12222d0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $248ac7c5d12222d0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $248ac7c5d12222d0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $248ac7c5d12222d0$var$initialState = {
    type: null,
    selectionRange: null,
    hoverRange: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
};
function $248ac7c5d12222d0$var$reducer(state, action) {
    switch(action.type){
        case 'clearSelection':
            if (state.selectionRange !== null) return $248ac7c5d12222d0$var$_objectSpread($248ac7c5d12222d0$var$_objectSpread({}, state), {}, {
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type
            });
            return state;
        case 'clearHover':
            if (state.hoverRange !== null) return $248ac7c5d12222d0$var$_objectSpread($248ac7c5d12222d0$var$_objectSpread({}, state), {}, {
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type
            });
            return state;
        case 'setSelection':
            if (state.selectionRange !== action.range) return $248ac7c5d12222d0$var$_objectSpread($248ac7c5d12222d0$var$_objectSpread({}, state), {}, {
                selectionRange: action.range,
                type: 'selection'
            });
            return state;
        case 'setHover':
            if (state.hoverRange !== action.range) return $248ac7c5d12222d0$var$_objectSpread($248ac7c5d12222d0$var$_objectSpread({}, state), {}, {
                hoverRange: action.range,
                type: 'hover'
            });
            return state;
        case 'promoteSelectionToDraft':
            // we should only promote the range to a draft if the current range type is a selection
            // we should also store the promotion type, so that a clear will not accidently clear the draft of a
            // different type
            if (state.selectionDraftRange !== state.selectionRange) return $248ac7c5d12222d0$var$_objectSpread($248ac7c5d12222d0$var$_objectSpread({}, state), {}, {
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type,
                selectionDraftRange: state.selectionRange,
                selectionDraftDocumentPosition: action.position
            });
            return state;
        case 'promoteHoverToDraft':
            if (state.hoverDraftRange !== state.hoverRange) return $248ac7c5d12222d0$var$_objectSpread($248ac7c5d12222d0$var$_objectSpread({}, state), {}, {
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type,
                hoverDraftRange: state.hoverRange,
                hoverDraftDocumentPosition: action.position
            });
            return state;
        case 'clearSelectionDraft':
            if (state.selectionDraftRange !== null) return $248ac7c5d12222d0$var$_objectSpread($248ac7c5d12222d0$var$_objectSpread({}, state), {}, {
                selectionDraftRange: null,
                selectionDraftDocumentPosition: null
            });
            return state;
        case 'clearHoverDraft':
            if (state.hoverDraftRange !== null) return $248ac7c5d12222d0$var$_objectSpread($248ac7c5d12222d0$var$_objectSpread({}, state), {}, {
                hoverDraftRange: null,
                hoverDraftDocumentPosition: null
            });
            return state;
    }
}
var $248ac7c5d12222d0$export$145b9bb655c3d220 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    range: null,
    type: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
});
var $248ac7c5d12222d0$export$efb0d1c8cbaac647 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    clearSelectionRange: function clearSelectionRange() {},
    clearHoverRange: function clearHoverRange() {},
    setSelectionRange: function setSelectionRange() {},
    promoteSelectionToDraft: function promoteSelectionToDraft() {},
    promoteHoverToDraft: function promoteHoverToDraft() {},
    clearSelectionDraft: function clearSelectionDraft() {},
    clearHoverDraft: function clearHoverDraft() {}
});
var $248ac7c5d12222d0$export$7cf774ce920e4bbd = function AnnotationRangeProviderInner(_ref) {
    var children = _ref.children, allowCommentsOnMedia = _ref.allowCommentsOnMedia;
    var _useReducer = (0, $5FkrB.useReducer)($248ac7c5d12222d0$var$reducer, $248ac7c5d12222d0$var$initialState), _useReducer2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useReducer, 2), _useReducer2$ = _useReducer2[0], selectionRange = _useReducer2$.selectionRange, hoverRange = _useReducer2$.hoverRange, type = _useReducer2$.type, selectionDraftRange = _useReducer2$.selectionDraftRange, selectionDraftDocumentPosition = _useReducer2$.selectionDraftDocumentPosition, hoverDraftRange = _useReducer2$.hoverDraftRange, hoverDraftDocumentPosition = _useReducer2$.hoverDraftDocumentPosition, dispatch = _useReducer2[1];
    var clearSelectionRange = (0, $5FkrB.useCallback)(function() {
        return dispatch({
            type: 'clearSelection'
        });
    }, []);
    var clearHoverRange = (0, $5FkrB.useCallback)(function() {
        return dispatch({
            type: 'clearHover'
        });
    }, []);
    var setSelectionRange = (0, $5FkrB.useCallback)(function(range) {
        return dispatch({
            type: 'setSelection',
            range: range
        });
    }, []);
    var setHoverTarget = (0, $5FkrB.useCallback)(function(target) {
        // the HoverComponent expects an element deeply nested inside media, these classes work with the current implementation
        var mediaNode = target.querySelector('.media-card-inline-player, .media-file-card-view');
        if (!mediaNode) return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- range for media hover highlight
        var range = document.createRange();
        range.setStartBefore(mediaNode);
        range.setEndAfter(mediaNode);
        dispatch({
            type: 'setHover',
            range: range
        });
    }, []);
    var promoteSelectionToDraft = (0, $5FkrB.useCallback)(function(position) {
        dispatch({
            type: 'promoteSelectionToDraft',
            position: position
        });
    }, []);
    var clearSelectionDraft = (0, $5FkrB.useCallback)(function() {
        dispatch({
            type: 'clearSelectionDraft'
        });
    }, []);
    var promoteHoverToDraft = (0, $5FkrB.useCallback)(function(position) {
        dispatch({
            type: 'promoteHoverToDraft',
            position: position
        });
    }, []);
    var clearHoverDraft = (0, $5FkrB.useCallback)(function() {
        dispatch({
            type: 'clearHoverDraft'
        });
    }, []);
    var stateData = (0, $5FkrB.useMemo)(function() {
        return {
            // We techinically have two ranges, however we only want to expose one of them at a time, because only one draft
            // can be active at a time. The type of range is used to determine which range is active.
            range: type === 'selection' ? selectionRange : hoverRange,
            type: type,
            selectionDraftRange: selectionDraftRange,
            hoverDraftRange: hoverDraftRange,
            selectionDraftDocumentPosition: selectionDraftDocumentPosition,
            hoverDraftDocumentPosition: hoverDraftDocumentPosition
        };
    }, [
        selectionRange,
        hoverRange,
        type,
        selectionDraftRange,
        selectionDraftDocumentPosition,
        hoverDraftRange,
        hoverDraftDocumentPosition
    ]);
    var dispatchData = (0, $5FkrB.useMemo)(function() {
        return {
            clearSelectionRange: clearSelectionRange,
            clearHoverRange: clearHoverRange,
            setSelectionRange: setSelectionRange,
            setHoverTarget: !!allowCommentsOnMedia ? setHoverTarget : undefined,
            promoteSelectionToDraft: promoteSelectionToDraft,
            promoteHoverToDraft: promoteHoverToDraft,
            clearSelectionDraft: clearSelectionDraft,
            clearHoverDraft: clearHoverDraft
        };
    }, [
        allowCommentsOnMedia,
        clearSelectionRange,
        clearHoverRange,
        setSelectionRange,
        setHoverTarget,
        promoteSelectionToDraft,
        promoteHoverToDraft,
        clearSelectionDraft,
        clearHoverDraft
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($248ac7c5d12222d0$export$145b9bb655c3d220.Provider, {
        value: stateData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($248ac7c5d12222d0$export$efb0d1c8cbaac647.Provider, {
        value: dispatchData
    }, children));
};
var $248ac7c5d12222d0$export$30384a6aedd19fee = function AnnotationRangeProvider(_ref2) {
    var children = _ref2.children, allowCommentsOnMedia = _ref2.allowCommentsOnMedia, isNestedRender = _ref2.isNestedRender;
    /*
   * If this is a nested render, we do not provide the context
   * because it has already been provided higher up the component tree
   * and we need the original context to create annotations on extensions.
   */ return isNestedRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($248ac7c5d12222d0$export$7cf774ce920e4bbd, {
        allowCommentsOnMedia: allowCommentsOnMedia
    }, children);
};
var $248ac7c5d12222d0$export$e07ee6d6cc95d9a0 = function useAnnotationRangeState() {
    return (0, $5FkrB.useContext)($248ac7c5d12222d0$export$145b9bb655c3d220);
};
var $248ac7c5d12222d0$export$708fc397e2b6f08d = function useAnnotationRangeDispatch() {
    return (0, $5FkrB.useContext)($248ac7c5d12222d0$export$efb0d1c8cbaac647);
};

});

parcelRegister("lh3H1", function(module, exports) {
$parcel$export(module.exports, "useLoadAnnotations", () => $f7ce0cd297733cf6$export$39f7c1a861a0d41c);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $1xyIw = parcelRequire("1xyIw");

var $lMzAH = parcelRequire("lMzAH");

var $gtPYB = parcelRequire("gtPYB");

var $fDwDe = parcelRequire("fDwDe");
function $f7ce0cd297733cf6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f7ce0cd297733cf6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f7ce0cd297733cf6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f7ce0cd297733cf6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f7ce0cd297733cf6$export$39f7c1a861a0d41c = function useLoadAnnotations(_ref) {
    var adfDocument = _ref.adfDocument, isNestedRender = _ref.isNestedRender, onLoadComplete = _ref.onLoadComplete;
    var actions = (0, $5FkrB.useContext)((0, $lMzAH.RendererContext));
    var providers = (0, $5FkrB.useContext)((0, $gtPYB.ProvidersContext));
    var _useAnnotationManager = (0, $fDwDe.useAnnotationManagerDispatch)(), annotationManager = _useAnnotationManager.annotationManager, dispatch = _useAnnotationManager.dispatch;
    var isAnnotationManagerEnabled = !!annotationManager;
    (0, $5FkrB.useEffect)(function() {
        if (!providers) return;
        var _providers$inlineComm = providers.inlineComment, inlineCommentGetState = _providers$inlineComm.getState, updateSubscriberInlineComment = _providers$inlineComm.updateSubscriber;
        var annotations = actions.getAnnotationMarks();
        // we don't want to request integrators for state with an empty list of ids.
        if (!annotations.length) {
            if (!isNestedRender) // inlineCommentGetState handles empty lists gracefully. It has a side-effect of clearing state, which is why this call is needed
            inlineCommentGetState([], isNestedRender);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: 0
            });
            return;
        }
        var ids = annotations.map(function(mark) {
            return mark.attrs.id;
        });
        var cb = function cb(data) {
            if (!updateSubscriberInlineComment) return;
            var payload = data.reduce(function(acc, value) {
                return $f7ce0cd297733cf6$var$_objectSpread($f7ce0cd297733cf6$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, value.id, value));
            }, {});
            if (isAnnotationManagerEnabled) dispatch({
                type: 'loadAnnotation',
                data: Object.keys(payload).map(function(id) {
                    var _payload$id$state;
                    return {
                        id: id,
                        markState: (_payload$id$state = payload[id].state) !== null && _payload$id$state !== void 0 ? _payload$id$state : undefined
                    };
                })
            });
            else updateSubscriberInlineComment.emit((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_STATE, payload);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: data.filter(function(data) {
                    return data.state === 'active';
                }).length
            });
        };
        inlineCommentGetState(ids, isNestedRender).then(cb);
    }, [
        actions,
        providers,
        adfDocument,
        isNestedRender,
        onLoadComplete,
        dispatch,
        isAnnotationManagerEnabled
    ]);
};

});

parcelRegister("bCYQR", function(module, exports) {
$parcel$export(module.exports, "AnnotationView", () => $8772723048e67397$export$41cd4a02859c2806);

var $5FkrB = parcelRequire("5FkrB");

var $lMzAH = parcelRequire("lMzAH");

var $gtPYB = parcelRequire("gtPYB");

var $2pzUn = parcelRequire("2pzUn");
var $8772723048e67397$export$41cd4a02859c2806 = function AnnotationView(props) {
    var providers = (0, $5FkrB.useContext)((0, $gtPYB.ProvidersContext));
    var actionContext = (0, $5FkrB.useContext)((0, $lMzAH.RendererContext));
    var inlineCommentProvider = providers && providers.inlineComment;
    var updateSubscriber = inlineCommentProvider && inlineCommentProvider.updateSubscriber || null;
    var viewComponentProps = (0, $2pzUn.useAnnotationClickEvent)({
        updateSubscriber: updateSubscriber,
        createAnalyticsEvent: props.createAnalyticsEvent,
        isNestedRender: props.isNestedRender
    });
    var ViewComponent = inlineCommentProvider && inlineCommentProvider.viewComponent;
    var deleteAnnotation = (0, $5FkrB.useMemo)(function() {
        return function(annotationInfo) {
            return actionContext.deleteAnnotation(annotationInfo.id, annotationInfo.type);
        };
    }, [
        actionContext
    ]);
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    var getInlineNodeTypes = (0, $5FkrB.useCallback)(function(annotationId) {
        return actionContext.getInlineNodeTypes(annotationId);
    }, [
        actionContext
    ]);
    if (ViewComponent && viewComponentProps) {
        var annotations = viewComponentProps.annotations, clickElementTarget = viewComponentProps.clickElementTarget;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(ViewComponent, {
            annotations: annotations,
            clickElementTarget: clickElementTarget,
            deleteAnnotation: deleteAnnotation,
            getInlineNodeTypes: getInlineNodeTypes
        });
    }
    return null;
};

});

parcelRegister("ePfJP", function(module, exports) {
$parcel$export(module.exports, "AnnotationsContextWrapper", () => $acb209651792431a$export$787af8a111ff3c03);

var $5FkrB = parcelRequire("5FkrB");

var $gtPYB = parcelRequire("gtPYB");

var $mAJgs = parcelRequire("mAJgs");

var $1yLa0 = parcelRequire("1yLa0");
var $acb209651792431a$export$787af8a111ff3c03 = function AnnotationsContextWrapper(props) {
    var providers = (0, $5FkrB.useContext)((0, $gtPYB.ProvidersContext));
    var rendererRef = props.rendererRef, createAnalyticsEvent = props.createAnalyticsEvent, children = props.children;
    var inlineCommentProvider = providers && providers.inlineComment;
    var selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
    var hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
    if (!selectionComponent && !hoverComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children, !!hoverComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $mAJgs.RangeValidator), {
        createAnalyticsEvent: createAnalyticsEvent,
        rendererRef: rendererRef,
        component: hoverComponent
    }), !!selectionComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1yLa0.SelectionRangeValidator), {
        createAnalyticsEvent: createAnalyticsEvent,
        rendererRef: rendererRef,
        selectionComponent: selectionComponent
    }));
};

});
parcelRegister("mAJgs", function(module, exports) {
$parcel$export(module.exports, "RangeValidator", () => $043e8bd14c222153$export$6d8376a902cb8aa7);

var $5FkrB = parcelRequire("5FkrB");

var $lMzAH = parcelRequire("lMzAH");

var $7bLYW = parcelRequire("7bLYW");

var $38vNc = parcelRequire("38vNc");

var $cxORw = parcelRequire("cxORw");
var $043e8bd14c222153$export$6d8376a902cb8aa7 = function RangeValidator(props) {
    var component = props.component, rendererRef = props.rendererRef, createAnalyticsEvent = props.createAnalyticsEvent;
    var actions = (0, $5FkrB.useContext)((0, $lMzAH.RendererContext));
    var _useAnnotationRangeDi = (0, $38vNc.useAnnotationRangeDispatch)(), clearHoverRange = _useAnnotationRangeDi.clearHoverRange;
    var _useAnnotationRangeSt = (0, $38vNc.useAnnotationRangeState)(), range = _useAnnotationRangeSt.range, type = _useAnnotationRangeSt.type;
    var _useAnnotationHoverCo = (0, $7bLYW.useAnnotationHoverContext)(), isWithinRange = _useAnnotationHoverCo.isWithinRange;
    if (!range || type !== 'hover') return null;
    var documentPosition = actions.getPositionFromRange(range);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cxORw.Mounter), {
        isWithinRange: isWithinRange,
        range: range,
        wrapperDOM: rendererRef,
        component: component,
        onClose: clearHoverRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: true,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$043e8bd14c222153$export$6d8376a902cb8aa7.displayName = 'HoverRangeValidator';

});
parcelRegister("cxORw", function(module, exports) {
$parcel$export(module.exports, "Mounter", () => $92200545d098e80e$export$2109cd350bcf6eda);

var $5FkrB = parcelRequire("5FkrB");

var $kX1mK = parcelRequire("kX1mK");

var $6EZ2P = parcelRequire("6EZ2P");

var $jJH6F = parcelRequire("jJH6F");

var $drUcN = parcelRequire("drUcN");

var $lMzAH = parcelRequire("lMzAH");

var $38vNc = parcelRequire("38vNc");

var $eyRpM = parcelRequire("eyRpM");
var $92200545d098e80e$export$2109cd350bcf6eda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(function(props) {
    var Component = props.component, range = props.range, isWithinRange = props.isWithinRange, isAnnotationAllowed = props.isAnnotationAllowed, wrapperDOM = props.wrapperDOM, onCloseProps = props.onClose, documentPosition = props.documentPosition, applyAnnotation = props.applyAnnotation, createAnalyticsEvent = props.createAnalyticsEvent, generateIndexMatch = props.generateIndexMatch;
    var _useAnnotationRangeDi = (0, $38vNc.useAnnotationRangeDispatch)(), promoteHoverToDraft = _useAnnotationRangeDi.promoteHoverToDraft, clearHoverDraft = _useAnnotationRangeDi.clearHoverDraft;
    var _useAnnotationRangeSt = (0, $38vNc.useAnnotationRangeState)(), hoverDraftDocumentPosition = _useAnnotationRangeSt.hoverDraftDocumentPosition;
    var actions = (0, $5FkrB.useContext)((0, $lMzAH.RendererContext));
    var onCreateCallback = (0, $5FkrB.useCallback)(function(annotationId) {
        // Always use documentPosition directly when gate is on — hoverDraftDocumentPosition
        // in this closure may be stale (captured before state update) (COMMENTS-6594).
        var positionToAnnotate = (0, $drUcN.expValEquals)('confluence_inline_comments_fix_stale_selection', 'isEnabled', true) ? documentPosition : hoverDraftDocumentPosition || documentPosition;
        if (!isAnnotationAllowed || !positionToAnnotate || !applyAnnotation) return false;
        var annotation = {
            annotationId: annotationId,
            annotationType: (0, $kX1mK.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $jJH6F.ACTION).INSERTED,
            actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {},
            eventType: (0, $jJH6F.EVENT_TYPE).TRACK
        }).fire((0, $6EZ2P.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        isAnnotationAllowed,
        documentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        hoverDraftDocumentPosition
    ]);
    var createIndexCallback = (0, $5FkrB.useCallback)(function() {
        if (!documentPosition || !generateIndexMatch) return false;
        var result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    var applyDraftModeCallback = (0, $5FkrB.useCallback)(function(options) {
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $jJH6F.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    documentPosition: documentPosition,
                    isAnnotationAllowed: isAnnotationAllowed
                },
                eventType: (0, $jJH6F.EVENT_TYPE).TRACK
            }).fire((0, $6EZ2P.FabricChannel).editor);
            return false;
        }
        // Clear any stale draft position before promoting the new one.
        // Without this, if a previous draft was not explicitly closed, hoverDraftDocumentPosition
        // retains the old position and the comment anchors to the wrong text (COMMENTS-6594).
        if ((0, $drUcN.expValEquals)('confluence_inline_comments_fix_stale_selection', 'isEnabled', true)) clearHoverDraft();
        promoteHoverToDraft(documentPosition);
        if (createAnalyticsEvent) {
            var uniqueAnnotationsInRange = actions.getAnnotationsByPosition(range);
            createAnalyticsEvent({
                action: (0, $jJH6F.ACTION).OPENED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $jJH6F.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length
                }
            }).fire((0, $6EZ2P.FabricChannel).editor);
        }
        window.requestAnimationFrame(function() {
            if (options.keepNativeSelection) (0, $eyRpM.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                var sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        // Always use documentPosition directly when gate is on — hoverDraftDocumentPosition
        // in this closure may be stale (captured before state update) (COMMENTS-6594).
        var positionToAnnotate = (0, $drUcN.expValEquals)('confluence_inline_comments_fix_stale_selection', 'isEnabled', true) ? documentPosition : hoverDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $jJH6F.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    positionToAnnotate: positionToAnnotate,
                    applyAnnotationMissing: !applyAnnotation,
                    annotationId: options.annotationId
                },
                eventType: (0, $jJH6F.EVENT_TYPE).TRACK
            }).fire((0, $6EZ2P.FabricChannel).editor);
            return false;
        }
        var annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $kX1mK.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        hoverDraftDocumentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        promoteHoverToDraft,
        clearHoverDraft
    ]);
    var removeDraftModeCallback = (0, $5FkrB.useCallback)(function() {
        clearHoverDraft();
        var sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearHoverDraft
    ]);
    var onCloseCallback = (0, $5FkrB.useCallback)(function() {
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $jJH6F.ACTION).CLOSED,
            actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $jJH6F.EVENT_TYPE).TRACK,
            attributes: {}
        }).fire((0, $6EZ2P.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Component, {
        range: range,
        isWithinRange: isWithinRange,
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback
    });
});

});
parcelRegister("eyRpM", function(module, exports) {
$parcel$export(module.exports, "dataAttributes", () => $a99dacbc9874dca0$export$15d6ddc168d35719);
$parcel$export(module.exports, "updateWindowSelectionAroundDraft", () => $a99dacbc9874dca0$export$e14699d956e87e73);

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");
var $a99dacbc9874dca0$export$15d6ddc168d35719 = function dataAttributes(_ref) {
    var from = _ref.from, to = _ref.to;
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, 'data-annotation-draft-mark', true), 'data-draft-start-at', from), 'data-draft-end-at', to);
};
var $a99dacbc9874dca0$var$buildDataAttributesQuery = function buildDataAttributesQuery(pos) {
    var a = $a99dacbc9874dca0$export$15d6ddc168d35719(pos);
    return Object.entries(a).map(function(_ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), k = _ref4[0], v = _ref4[1];
        return "[".concat(k, "=\"").concat(v, "\"]");
    }).join('');
};
var $a99dacbc9874dca0$export$e14699d956e87e73 = function updateWindowSelectionAroundDraft(pos) {
    var sel = window.getSelection();
    if (!sel) return false;
    var draftNodes = document.querySelectorAll($a99dacbc9874dca0$var$buildDataAttributesQuery(pos));
    if (!draftNodes || draftNodes.length === 0) return false;
    sel.removeAllRanges();
    var range = document.createRange();
    range.setStart(draftNodes[0], 0);
    range.setEndAfter(draftNodes[draftNodes.length - 1]);
    sel.addRange(range);
    return true;
};

});



parcelRegister("1yLa0", function(module, exports) {
$parcel$export(module.exports, "SelectionRangeValidator", () => $122d8c7ce0dee5eb$export$74435b85e23b84d9);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $lMzAH = parcelRequire("lMzAH");

var $lWfP7 = parcelRequire("lWfP7");

var $hSqHE = parcelRequire("hSqHE");
var $122d8c7ce0dee5eb$export$74435b85e23b84d9 = function SelectionRangeValidator(props) {
    var selectionComponent = props.selectionComponent, rendererRef = props.rendererRef, createAnalyticsEvent = props.createAnalyticsEvent;
    var actions = (0, $5FkrB.useContext)((0, $lMzAH.RendererContext));
    var _useUserSelectionRang = (0, $lWfP7.useUserSelectionRange)({
        rendererRef: rendererRef
    }), _useUserSelectionRang2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useUserSelectionRang, 4), type = _useUserSelectionRang2[0], range = _useUserSelectionRang2[1], draftRange = _useUserSelectionRang2[2], clearRange = _useUserSelectionRang2[3];
    var selectionRange = type === 'selection' ? range : null;
    // !!! the draft range will become invalid after the mark DOM is inserted
    if (!selectionRange && !draftRange) return null;
    var documentPosition = actions.getPositionFromRange(range);
    // This property is drilled down to consumers when a new range is selected to test it's validity
    var isAnnotationAllowedOnRange = false;
    try {
        isAnnotationAllowedOnRange = documentPosition && actions.isValidAnnotationPosition(documentPosition);
    } catch (_unused) {
        isAnnotationAllowedOnRange = false;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $hSqHE.SelectionInlineCommentMounter), {
        range: selectionRange,
        draftRange: draftRange,
        wrapperDOM: rendererRef,
        component: selectionComponent,
        onClose: clearRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: isAnnotationAllowedOnRange,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$122d8c7ce0dee5eb$export$74435b85e23b84d9.displayName = 'SelectionRangeValidator';

});
parcelRegister("lWfP7", function(module, exports) {
$parcel$export(module.exports, "useUserSelectionRange", () => $ff8b49f4191e9037$export$47201332e612f5a4);

var $5FkrB = parcelRequire("5FkrB");

var $drUcN = parcelRequire("drUcN");

var $fDwDe = parcelRequire("fDwDe");

var $38vNc = parcelRequire("38vNc");

var $8aXvJ = parcelRequire("8aXvJ");
var $ff8b49f4191e9037$export$47201332e612f5a4 = function useUserSelectionRange(props) {
    var rendererDOM = props.rendererRef.current;
    var selectionTimeoutRef = (0, $5FkrB.useRef)();
    var _useAnnotationRangeDi = (0, $38vNc.useAnnotationRangeDispatch)(), clearSelectionRange = _useAnnotationRangeDi.clearSelectionRange, setSelectionRange = _useAnnotationRangeDi.setSelectionRange;
    var _useAnnotationRangeSt = (0, $38vNc.useAnnotationRangeState)(), range = _useAnnotationRangeSt.range, type = _useAnnotationRangeSt.type, selectionDraftRange = _useAnnotationRangeSt.selectionDraftRange;
    var _useAnnotationManager = (0, $fDwDe.useAnnotationManagerDispatch)(), annotationManager = _useAnnotationManager.annotationManager;
    var lastRangeRef = (0, $5FkrB.useRef)(null);
    var isAnnotationManagerEnabled = !!annotationManager;
    var onSelectionChange = (0, $5FkrB.useCallback)(function(_event) {
        var _document$body;
        if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
        /*
     * The 100ms debounce batches rapid `selectionchange` events during user drag/extend
     * operations into a single React update. When the nudge button triggers a programmatic
     * `addRange`, it fires exactly ONE `selectionchange` — no batching needed. Skipping the
     * debounce ensures annotation position is computed synchronously so the first click
     * applies the yellow highlight immediately. `data-nudge-selection-active` is set
     * exclusively by the Confluence comment nudge feature and is double-gated:
     * (1) `expValEquals('confluence_comment_nudgebar_improvement', ...)` — explicit experiment
     * gate; (2) `data-nudge-selection-active` — ensures 0ms only fires during an actual nudge
     * click, not on every selectionchange for experiment-ON users. Zero behavioral change for
     * other products or experiment-OFF users.
     */ var nudgeDelay = typeof document !== 'undefined' && ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.getAttribute('data-nudge-selection-active')) === 'true' && (0, $drUcN.expValEquals)('confluence_comment_nudgebar_improvement', 'isEnabled', true) ? 0 : 100;
        selectionTimeoutRef.current = setTimeout(function() {
            var sel = document.getSelection();
            if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) {
                lastRangeRef.current = null; // Clear last range if selection is invalid
                if (isAnnotationManagerEnabled) clearSelectionRange();
                return;
            }
            var _range = sel.getRangeAt(0);
            // Skip if the selection hasn't changed
            if (lastRangeRef.current && _range.compareBoundaryPoints(Range.START_TO_START, lastRangeRef.current) === 0 && _range.compareBoundaryPoints(Range.END_TO_END, lastRangeRef.current) === 0) return;
            if (rendererDOM && (0, $8aXvJ.isRangeInsideOfRendererContainer)(rendererDOM, _range)) {
                var _range2 = _range, startContainer = _range2.startContainer, endContainer = _range2.endContainer;
                var isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                if (isTripleClick) {
                    var p = startContainer;
                    while(p && p.nodeName !== 'P' && p !== rendererDOM)p = p.parentNode;
                    if (p && p.nodeName === 'P' && p instanceof Element) {
                        var _range3 = document.createRange();
                        _range3.selectNodeContents(p);
                        sel.removeAllRanges();
                        sel.addRange(_range3);
                        _range = sel.getRangeAt(0);
                    }
                }
                setSelectionRange(_range.cloneRange());
                lastRangeRef.current = _range;
            }
        }, nudgeDelay);
    }, [
        rendererDOM,
        setSelectionRange,
        clearSelectionRange,
        isAnnotationManagerEnabled
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (!document || !rendererDOM) return;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('selectionchange', onSelectionChange);
        return function() {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('selectionchange', onSelectionChange);
            clearSelectionRange();
        };
    }, [
        rendererDOM,
        onSelectionChange,
        clearSelectionRange
    ]);
    return [
        type,
        range,
        selectionDraftRange,
        clearSelectionRange
    ];
};

});
parcelRegister("8aXvJ", function(module, exports) {
$parcel$export(module.exports, "isRangeInsideOfRendererContainer", () => $5f3d6b826ccb6432$export$90ee8f2d9317f430);
/** Exists in its own module to allow mocking in unit tests */ var $5f3d6b826ccb6432$export$90ee8f2d9317f430 = function isRangeInsideOfRendererContainer(rendererDOM, range) {
    var sourceRange = document.createRange();
    sourceRange.selectNode(rendererDOM);
    var isSelectionStartsAfterRenderer = range.compareBoundaryPoints(Range.START_TO_START, sourceRange) === 1;
    var isSelectionStartsBeforeRenderer = range.compareBoundaryPoints(Range.START_TO_END, sourceRange) === 1;
    var isSelectionEndsAfterRenderer = range.compareBoundaryPoints(Range.END_TO_END, sourceRange) === 1;
    return isSelectionStartsAfterRenderer && isSelectionStartsBeforeRenderer && !isSelectionEndsAfterRenderer;
};

});


parcelRegister("hSqHE", function(module, exports) {
$parcel$export(module.exports, "SelectionInlineCommentMounter", () => $d03c317538671a16$export$ca7741472ed8ba00);

var $5FkrB = parcelRequire("5FkrB");

var $6JfQX = parcelRequire("6JfQX");

var $kX1mK = parcelRequire("kX1mK");

var $6EZ2P = parcelRequire("6EZ2P");

var $jJH6F = parcelRequire("jJH6F");

var $50U6m = parcelRequire("50U6m");

var $drUcN = parcelRequire("drUcN");

var $35DNJ = parcelRequire("35DNJ");

var $lMzAH = parcelRequire("lMzAH");

var $fDwDe = parcelRequire("fDwDe");

var $38vNc = parcelRequire("38vNc");

var $eyRpM = parcelRequire("eyRpM");
var $d03c317538671a16$export$ca7741472ed8ba00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(function(props) {
    var Component = props.component, range = props.range, draftRange = props.draftRange, isAnnotationAllowed = props.isAnnotationAllowed, wrapperDOM = props.wrapperDOM, onCloseProps = props.onClose, documentPosition = props.documentPosition, applyAnnotation = props.applyAnnotation, createAnalyticsEvent = props.createAnalyticsEvent, generateIndexMatch = props.generateIndexMatch;
    var _useAnnotationRangeDi = (0, $38vNc.useAnnotationRangeDispatch)(), promoteSelectionToDraft = _useAnnotationRangeDi.promoteSelectionToDraft, clearSelectionDraft = _useAnnotationRangeDi.clearSelectionDraft;
    var _useAnnotationRangeSt = (0, $38vNc.useAnnotationRangeState)(), selectionDraftDocumentPosition = _useAnnotationRangeSt.selectionDraftDocumentPosition;
    var actions = (0, $5FkrB.useContext)((0, $lMzAH.RendererContext));
    var _useAnnotationManager = (0, $fDwDe.useAnnotationManagerState)(), isDrafting = _useAnnotationManager.isDrafting, draftId = _useAnnotationManager.draftId;
    var _useAnnotationManager2 = (0, $fDwDe.useAnnotationManagerDispatch)(), annotationManager = _useAnnotationManager2.annotationManager, dispatch = _useAnnotationManager2.dispatch;
    var inlineNodeTypes = (0, $5FkrB.useMemo)(function() {
        if (!actions.isRangeAnnotatable(range)) return undefined;
        return (0, $35DNJ.getRendererRangeInlineNodeNames)({
            pos: documentPosition,
            actions: actions
        });
    }, [
        documentPosition,
        actions,
        range
    ]);
    var onCreateCallback = (0, $5FkrB.useCallback)(function(annotationId) {
        // Use documentPosition directly when gate is on — selectionDraftDocumentPosition may be stale
        // (from a previous selection) causing the comment to anchor to the wrong text (COMMENTS-6594).
        var positionToAnnotate = (0, $drUcN.expValEquals)('confluence_inline_comments_fix_stale_selection', 'isEnabled', true) ? documentPosition : selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation) return false;
        // Evaluate position validity when the user commits the position to be annotated
        var isCreateAllowedOnPosition = actions.isValidAnnotationPosition(positionToAnnotate);
        if (!isCreateAllowedOnPosition) return false;
        var annotation = {
            annotationId: annotationId,
            annotationType: (0, $kX1mK.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $jJH6F.ACTION).INSERTED,
            actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            },
            eventType: (0, $jJH6F.EVENT_TYPE).TRACK
        }).fire((0, $6EZ2P.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        actions,
        documentPosition,
        selectionDraftDocumentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    var createIndexCallback = (0, $5FkrB.useCallback)(function() {
        if (!documentPosition || !generateIndexMatch) return false;
        var result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    var applyDraftModeCallback = (0, $5FkrB.useCallback)(function(options) {
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $jJH6F.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    inlineNodeNames: inlineNodeTypes,
                    documentPosition: documentPosition,
                    isAnnotationAllowed: isAnnotationAllowed
                },
                eventType: (0, $jJH6F.EVENT_TYPE).TRACK
            }).fire((0, $6EZ2P.FabricChannel).editor);
            return false;
        }
        // Clear any stale draft position before promoting the new one (COMMENTS-6594).
        if ((0, $drUcN.expValEquals)('confluence_inline_comments_fix_stale_selection', 'isEnabled', true)) clearSelectionDraft();
        promoteSelectionToDraft(documentPosition);
        if (createAnalyticsEvent) {
            var uniqueAnnotationsInRange = range ? actions.getAnnotationsByPosition(range) : [];
            createAnalyticsEvent({
                action: (0, $jJH6F.ACTION).OPENED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $jJH6F.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length,
                    inlineNodeNames: inlineNodeTypes
                }
            }).fire((0, $6EZ2P.FabricChannel).editor);
        }
        window.requestAnimationFrame(function() {
            if (options.keepNativeSelection) (0, $eyRpM.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                var sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        // Use documentPosition directly when either:
        // - platform_editor_comments_api_manager is on (existing behaviour), OR
        // - COMMENTS-6594 experiment is on (fix: avoids stale closure value)
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning
        var positionToAnnotate = (0, $50U6m.fg)('platform_editor_comments_api_manager') || (0, $drUcN.expValEquals)('confluence_inline_comments_fix_stale_selection', 'isEnabled', true) ? documentPosition : selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $jJH6F.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    positionToAnnotate: positionToAnnotate,
                    applyAnnotationMissing: !applyAnnotation,
                    annotationId: options.annotationId
                },
                eventType: (0, $jJH6F.EVENT_TYPE).TRACK
            }).fire((0, $6EZ2P.FabricChannel).editor);
            return false;
        }
        var annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $kX1mK.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        inlineNodeTypes,
        promoteSelectionToDraft,
        clearSelectionDraft,
        selectionDraftDocumentPosition
    ]);
    var removeDraftModeCallback = (0, $5FkrB.useCallback)(function() {
        clearSelectionDraft();
        var sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearSelectionDraft
    ]);
    var onCloseCallback = (0, $5FkrB.useCallback)(function() {
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $jJH6F.ACTION).CLOSED,
            actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $jJH6F.EVENT_TYPE).TRACK,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            }
        }).fire((0, $6EZ2P.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (annotationManager) {
            var allowAnnotation = function allowAnnotation() {
                if (isDrafting) return false;
                return isAnnotationAllowed;
            };
            annotationManager.hook('allowAnnotation', allowAnnotation);
            return function() {
                annotationManager.unhook('allowAnnotation', allowAnnotation);
            };
        }
    }, [
        annotationManager,
        isAnnotationAllowed,
        isDrafting
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (annotationManager) {
            var startDraft = function startDraft() {
                var _result$inlineNodeTyp;
                // if there is a draft in progress, we ignore it and start a new draft
                // this is because clearing the draft will remove the mark node from the DOM, which will cause the selection range to be invalid
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                var id = (0, $6JfQX.default)();
                var result = applyDraftModeCallback({
                    annotationId: id,
                    keepNativeSelection: false
                });
                if (!result) return {
                    success: false,
                    reason: 'invalid-range'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: true,
                        draftId: id,
                        draftActionResult: result
                    }
                });
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return {
                    success: true,
                    // We cannot get a ref to the target element here
                    // because the draft is not yet applied to the DOM
                    targetElement: undefined,
                    inlineNodeTypes: (_result$inlineNodeTyp = result.inlineNodeTypes) !== null && _result$inlineNodeTyp !== void 0 ? _result$inlineNodeTyp : [],
                    actionResult: {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    }
                };
            };
            annotationManager.hook('startDraft', startDraft);
            return function() {
                annotationManager.unhook('startDraft', startDraft);
            };
        }
    }, [
        annotationManager,
        isDrafting,
        applyDraftModeCallback,
        actions,
        range,
        dispatch
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (annotationManager) {
            var clearDraft = function clearDraft() {
                if (!isDrafting) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                onCloseCallback();
                return {
                    success: true
                };
            };
            annotationManager.hook('clearDraft', clearDraft);
            return function() {
                annotationManager.unhook('clearDraft', clearDraft);
            };
        }
    }, [
        annotationManager,
        onCloseCallback,
        isDrafting,
        dispatch
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (annotationManager) {
            var applyDraft = function applyDraft(id) {
                if (!isDrafting || !draftId) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                var result = onCreateCallback(id);
                if (!result) return {
                    success: false,
                    reason: 'range-no-longer-exists'
                };
                onCloseCallback();
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true,
                        markState: (0, $kX1mK.AnnotationMarkStates).ACTIVE
                    }
                });
                return {
                    success: true,
                    targetElement: undefined,
                    actionResult: id !== draftId ? {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    } : undefined
                };
            };
            annotationManager.hook('applyDraft', applyDraft);
            return function() {
                annotationManager.unhook('applyDraft', applyDraft);
            };
        }
    }, [
        annotationManager,
        onCreateCallback,
        onCloseCallback,
        isDrafting,
        draftId,
        dispatch
    ]);
    // Please remove this NOP function when the flag platform_editor_comments_api_manager is removed.
    var nop = (0, $5FkrB.useMemo)(function() {
        return function() {
            return false;
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Component, {
        range: range,
        draftRange: draftRange,
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: annotationManager ? nop : onCloseCallback,
        onCreate: annotationManager ? nop : onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: annotationManager ? nop : applyDraftModeCallback,
        removeDraftMode: annotationManager ? nop : removeDraftModeCallback,
        inlineNodeTypes: inlineNodeTypes
    });
});

});




parcelRegister("4chaE", function(module, exports) {
$parcel$export(module.exports, "default", () => $30e59a26a841843b$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $cvlyC = parcelRequire("cvlyC");

var $5hQFA = parcelRequire("5hQFA");

var $qprXf = parcelRequire("qprXf");

var $fIf3B = parcelRequire("fIf3B");
var $30e59a26a841843b$var$inlineExtensionStyle = (0, $74Zh5.css)({
    display: 'inline-block',
    maxWidth: '100%',
    verticalAlign: 'middle',
    // 0px margin top is important here.
    // When running on server-side emotion will generate style tags before elements.
    // This caused packages/editor/editor-common/src/styles/shared/block-marks.ts to override the margin-top.
    // However as soon as the styles are extracted to <head> it adds back the margin.
    // The timing is tricky as it happens to be when UFO collects the dimension for the placeholder for TTVC calculation.
    // This resulted 1px mismatch on the image. Further cause everything on page to shift by 1px.
    // es-lint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: "0px 1px ".concat("var(--ds-space-050, 4px)"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .rich-media-item': {
        maxWidth: '100%'
    }
});
var $30e59a26a841843b$var$plainTextMacroStyle = (0, $74Zh5.css)({
    display: 'inline',
    verticalAlign: 'baseline',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-macro-body]': {
        display: 'inline'
    }
});
function $30e59a26a841843b$export$2e2bcd8739ae039(props) {
    var extensionHandlers = props.extensionHandlers, rendererContext = props.rendererContext, extensionType = props.extensionType, extensionKey = props.extensionKey, parameters = props.parameters, getContent = props.getContent, text = props.text, type = props.type, localId = props.localId, marks = props.marks, actions = props.actions, children = props.children;
    var isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(true);
    var localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        return (0, $cvlyC.default)((0, $5hQFA.getNodeRenderer));
    }, []);
    /**
   * null -> provider promise not yet settled (pending)
   * undefined -> provider promise rejected (settled, no provider available)
   * <provider> -> provider promise resolved
   */ var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(null), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState, 2), extensionProvider = _React$useState2[0], setExtensionProvider = _React$useState2[1];
    var handleProvider = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function(_name, providerPromise) {
        providerPromise === null || providerPromise === void 0 || providerPromise.then(function(provider) {
            if (isMounted.current) setExtensionProvider(provider);
        }, function() {
            // Consumers can use this to distinguish a rejected provider from a pending one
            if (isMounted.current) setExtensionProvider(undefined);
        });
    }, []);
    var renderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function(extensionProvider, isExtensionProviderPending) {
        var _marks$find, _node$parameters;
        var fragmentLocalId = marks === null || marks === void 0 || (_marks$find = marks.find(function(m) {
            return m.type.name === 'fragment';
        })) === null || _marks$find === void 0 || (_marks$find = _marks$find.attrs) === null || _marks$find === void 0 ? void 0 : _marks$find.localId;
        // Extension handlers read the macro body off `node.content`, so this is the one place that
        // always has to serialize. `getContent` is what makes it a single pass instead of one per
        // ancestor node.
        var node = {
            type: type,
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: (getContent === null || getContent === void 0 ? void 0 : getContent()) || text,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        var isPlainTextMacro = Boolean(node === null || node === void 0 || (_node$parameters = node.parameters) === null || _node$parameters === void 0 || (_node$parameters = _node$parameters.macroParams) === null || _node$parameters === void 0 ? void 0 : _node$parameters.__bodyContent);
        var result = null;
        try {
            if (extensionHandlers && extensionHandlers[extensionType]) {
                var render = (0, $fIf3B.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, rendererContext.adDoc);
            }
            if (!result && extensionProvider) {
                var NodeRenderer = localGetNodeRenderer(extensionProvider, extensionType, extensionKey);
                if (node.type === 'multiBodiedExtension') result = (0, $74Zh5.jsx)(NodeRenderer, {
                    node: node,
                    actions: actions
                });
                else if (node.type === 'inlineExtension') result = (0, $74Zh5.jsx)($30e59a26a841843b$export$f41ccc3bd3324832, {
                    isPlainTextMacro: isPlainTextMacro
                }, (0, $74Zh5.jsx)(NodeRenderer, {
                    node: node
                }));
                else result = (0, $74Zh5.jsx)(NodeRenderer, {
                    node: node
                });
            }
        } catch (_unused) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return children({
            isExtensionProviderPending: isExtensionProviderPending,
            node: node,
            result: result
        });
    }, [
        actions,
        children,
        getContent,
        extensionHandlers,
        extensionKey,
        extensionType,
        localGetNodeRenderer,
        localId,
        marks,
        parameters,
        rendererContext === null || rendererContext === void 0 ? void 0 : rendererContext.adDoc,
        text,
        type
    ]);
    var setupAndRenderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function(providers) {
        if (extensionProvider === null && providers.extensionProvider) handleProvider('extensionProvider', providers.extensionProvider);
        return renderExtensionNode(extensionProvider, Boolean(providers.extensionProvider) && extensionProvider === null);
    }, [
        extensionProvider,
        handleProvider,
        renderExtensionNode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    if (!props.providers) return setupAndRenderExtensionNode({});
    return (0, $74Zh5.jsx)((0, $qprXf.WithProviders), {
        providers: [
            'extensionProvider'
        ],
        providerFactory: props.providers,
        renderNode: setupAndRenderExtensionNode
    });
}
var $30e59a26a841843b$export$f41ccc3bd3324832 = function InlineNodeRendererWrapper(_ref) {
    var children = _ref.children, isPlainTextMacro = _ref.isPlainTextMacro, ssrPlaceholder = _ref.ssrPlaceholder, ssrPlaceholderReplace = _ref.ssrPlaceholderReplace;
    return (0, $74Zh5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "inline-extension-renderer ".concat(isPlainTextMacro ? 'plain-text-macro' : ''),
        css: [
            $30e59a26a841843b$var$inlineExtensionStyle,
            isPlainTextMacro && $30e59a26a841843b$var$plainTextMacroStyle
        ],
        "data-ssr-placeholder": ssrPlaceholder,
        "data-ssr-placeholder-replace": ssrPlaceholderReplace
    }, children);
};

});
parcelRegister("5hQFA", function(module, exports) {
$parcel$export(module.exports, "getExtensionModuleNodePrivateProps", () => $3d976561732cc216$export$426f8efd8690d8aa);
$parcel$export(module.exports, "getNodeRenderer", () => $3d976561732cc216$export$67a7d49db68d30a0);

var $kqp0i = parcelRequire("kqp0i");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $5FkrB = parcelRequire("5FkrB");

var $hrVKU = parcelRequire("hrVKU");

var $bhmkE = parcelRequire("bhmkE");
parcelRequire("dt3gj");
var $1Djk2 = parcelRequire("1Djk2");
var $hrJIU = parcelRequire("hrJIU");

var $jkJfI = parcelRequire("jkJfI");

var $cqR4L = parcelRequire("cqR4L");

var $7mos3 = parcelRequire("7mos3");

var $bwwSO = parcelRequire("bwwSO");

var $bISAN = parcelRequire("bISAN");

function $3d976561732cc216$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $3d976561732cc216$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $3d976561732cc216$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3d976561732cc216$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $3d976561732cc216$var$getNodeFromManifest(// eslint-disable-next-line @typescript-eslint/no-explicit-any
manifest, extKey, nodeKey, extensionType, extensionKey) {
    if (!manifest) throw new Error("Extension with key \"".concat(extKey, "\" and type \"").concat(extensionType, "\" not found!"));
    if (!manifest.modules.nodes) throw new Error("Couldn't find any node for extension type \"".concat(extensionType, "\" and key \"").concat(extensionKey, "\"!"));
    var node = manifest.modules.nodes[nodeKey];
    if (!node) throw new Error("Node with key \"".concat(extensionKey, "\" not found on manifest for extension type \"").concat(extensionType, "\" and key \"").concat(extensionKey, "\"!"));
    return node;
}
function $3d976561732cc216$export$82dd45c2db936caf(_x, _x2, _x3) {
    return $3d976561732cc216$var$_getExtensionModuleNode.apply(this, arguments);
}
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $3d976561732cc216$var$_getExtensionModuleNode() {
    $3d976561732cc216$var$_getExtensionModuleNode = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(extensionProvider, extensionType, extensionKey) {
        var _getExtensionKeyAndNo3, _getExtensionKeyAndNo4, extKey, nodeKey, manifest;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _getExtensionKeyAndNo3 = (0, $cqR4L.getExtensionKeyAndNodeKey)(extensionKey, extensionType), _getExtensionKeyAndNo4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_getExtensionKeyAndNo3, 2), extKey = _getExtensionKeyAndNo4[0], nodeKey = _getExtensionKeyAndNo4[1];
                    _context.next = 1;
                    return extensionProvider.getExtension(extensionType, extKey);
                case 1:
                    manifest = _context.sent;
                    return _context.abrupt("return", $3d976561732cc216$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey));
                case 2:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $3d976561732cc216$var$_getExtensionModuleNode.apply(this, arguments);
}
function $3d976561732cc216$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey) {
    var _extensionProvider$ge;
    var _getExtensionKeyAndNo = (0, $cqR4L.getExtensionKeyAndNodeKey)(extensionKey, extensionType), _getExtensionKeyAndNo2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_getExtensionKeyAndNo, 2), extKey = _getExtensionKeyAndNo2[0], nodeKey = _getExtensionKeyAndNo2[1];
    var manifest = extensionProvider === null || extensionProvider === void 0 || (_extensionProvider$ge = extensionProvider.getPreloadedExtension) === null || _extensionProvider$ge === void 0 ? void 0 : _extensionProvider$ge.call(extensionProvider, extensionType, extKey);
    if (manifest) return $3d976561732cc216$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
    else return extensionProvider.getExtension(extensionType, extKey).then(function(manifest) {
        return $3d976561732cc216$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
    });
}
function $3d976561732cc216$export$426f8efd8690d8aa(_x4, _x5, _x6) {
    return $3d976561732cc216$var$_getExtensionModuleNodePrivateProps.apply(this, arguments);
}
function $3d976561732cc216$var$_getExtensionModuleNodePrivateProps() {
    $3d976561732cc216$var$_getExtensionModuleNodePrivateProps = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(extensionProvider, extensionType, extensionKey) {
        var moduleNode;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 1;
                    return $3d976561732cc216$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey);
                case 1:
                    moduleNode = _context2.sent;
                    return _context2.abrupt("return", Object.keys(moduleNode).filter(function(key) {
                        return key.startsWith('__');
                    }).reduce(function(acc, key) {
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        acc[key] = moduleNode[key];
                        return acc;
                    }, {}));
                case 2:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $3d976561732cc216$var$_getExtensionModuleNodePrivateProps.apply(this, arguments);
}
function $3d976561732cc216$var$isUnknownConfluenceMacroWithBody(extensionNode) {
    var _extensionNode$parame;
    return extensionNode !== null && extensionNode.type === 'extension' && extensionNode.extensionType === 'com.atlassian.confluence.macro.core' && !!((_extensionNode$parame = extensionNode.parameters) !== null && _extensionNode$parame !== void 0 && (_extensionNode$parame = _extensionNode$parame.macroParams) !== null && _extensionNode$parame !== void 0 && (_extensionNode$parame = _extensionNode$parame.__bodyContent) !== null && _extensionNode$parame !== void 0 && _extensionNode$parame.value);
}
// eslint-disable-next-line @repo/internal/react/no-class-components -- error boundaries require a class component
var $3d976561732cc216$var$ExtensionRendererErrorBoundary = /*#__PURE__*/ function(_React$Component) {
    function ExtensionRendererErrorBoundary() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ExtensionRendererErrorBoundary);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $3d976561732cc216$var$_callSuper(this, ExtensionRendererErrorBoundary, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "state", {});
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ExtensionRendererErrorBoundary, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ExtensionRendererErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error) {
                // eslint-disable-next-line no-console
                console.error('Error rendering extension', error);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error ? $3d976561732cc216$var$renderExtensionLoadingError(this.state.error, this.props.fallbackProps) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component);
var $3d976561732cc216$var$noop = function noop() {};
function $3d976561732cc216$var$renderExtensionLoadingError(error, props) {
    // Needed because the old react-loadable (older code-splitting library) error handling behaviour might be relied on by extensions.
    // https://unpkg.com/react-loadable@5.2.2/lib/index.js
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($3d976561732cc216$var$ExtensionLoading, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        isLoading: false,
        pastDelay: true,
        timedOut: false,
        error: error,
        retry: $3d976561732cc216$var$noop
    }, props));
}
function $3d976561732cc216$var$ExtensionLoading(props) {
    var intl = (0, $hrVKU.default)();
    var extensionNode = props.node;
    if (!props.error && !props.timedOut && props.loadingFallback) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, props.loadingFallback);
    if (props.error || props.timedOut) {
        // eslint-disable-next-line no-console
        console.error('Error rendering extension', props.error);
        if (props.error && props.showUnknownMacroPlaceholder && extensionNode && $3d976561732cc216$var$isUnknownConfluenceMacroWithBody(extensionNode)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bISAN.UnknownMacroPlaceholder), {
            extensionNode: extensionNode
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", null, intl.formatMessage((0, $7mos3.messages).extensionLoadingError));
    } else return null;
}
function $3d976561732cc216$export$67a7d49db68d30a0(extensionProvider, extensionType, extensionKey) {
    var loadNodeRenderer = function loadNodeRenderer() {
        var _renderSync, _ref;
        var maybePromise = $3d976561732cc216$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey);
        if (maybePromise instanceof Promise) return maybePromise.then(function(node) {
            return (0, $cqR4L.resolveImport)(node.render());
        });
        var preloaded = maybePromise === null || maybePromise === void 0 || (_renderSync = (_ref = maybePromise).renderSync) === null || _renderSync === void 0 ? void 0 : _renderSync.call(_ref);
        // Only product implemented preloading will return sync result
        // However the out-of-box won't handle this. Confluence uses a custom implementation
        return preloaded ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, $bwwSO.resolveImportSync)(preloaded) : (0, $cqR4L.resolveImport)(maybePromise.render());
    };
    var LazyNodeRenderer = (0, $1Djk2.lazy)(function() {
        return loadNodeRenderer();
    });
    LazyNodeRenderer.displayName = 'lazy(NodeRenderer)';
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var LoadableNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
        loader: loadNodeRenderer,
        // react-loadable passes all props from <NodeRenderer> to the loading component at runtime,
        // but its TypeScript types only expect LoadingComponentProps. We cast here because
        // ExtensionLoading accepts additional props (node, showUnknownMacroPlaceholder) that
        // react-loadable will pass through but doesn't know about in its type definitions.
        loading: $3d976561732cc216$var$ExtensionLoading
    });
    var NodeRenderer = function NodeRenderer(props) {
        var _props$loadingFallbac;
        if (!(0, $jkJfI.isExperimentEnabled)('platform_editor_loosely_lazy_migration')) // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LoadableNodeRenderer, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($3d976561732cc216$var$ExtensionRendererErrorBoundary, {
            fallbackProps: props
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $hrJIU.LazySuspense), {
            fallback: (_props$loadingFallbac = props.loadingFallback) !== null && _props$loadingFallbac !== void 0 ? _props$loadingFallbac : null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LazyNodeRenderer, props)));
    };
    NodeRenderer.preload = function() {
        return (0, $jkJfI.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? LazyNodeRenderer.preload() : LoadableNodeRenderer.preload();
    };
    return NodeRenderer;
}

});
parcelRegister("dt3gj", function(module, exports) {
$parcel$export(module.exports, "lazy", () => (parcelRequire("1Djk2")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("hrJIU")).LazySuspense);
parcelRequire("fCt8O");
var $8sTE5 = parcelRequire("8sTE5");

var $aOXaX = parcelRequire("aOXaX");

var $1Djk2 = parcelRequire("1Djk2");
parcelRequire("61ipC");
var $2ASv9 = parcelRequire("2ASv9");
var $a9rwy = parcelRequire("a9rwy");
parcelRequire("eHPOU");
var $hrJIU = parcelRequire("hrJIU");

var $jXJsB = parcelRequire("jXJsB");

var $5EDtT = parcelRequire("5EDtT");

});
parcelRegister("fCt8O", function(module, exports) {
$parcel$export(module.exports, "getConfig", () => $b5f1027314b3e70f$export$44487a86467333c3);
$parcel$export(module.exports, "setConfig", () => $b5f1027314b3e70f$export$940a7873bb071df8);
$parcel$export(module.exports, "MODE", () => (parcelRequire("8sTE5")).MODE);

var $8sTE5 = parcelRequire("8sTE5");
const $b5f1027314b3e70f$var$DEFAULT_CROSS_ORIGIN = undefined;
const $b5f1027314b3e70f$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $b5f1027314b3e70f$var$DEFAULT_MODE = (0, $8sTE5.MODE).HYDRATE;
const $b5f1027314b3e70f$var$DEFAULT_RETRY = 2;
const $b5f1027314b3e70f$var$config = {
    crossOrigin: $b5f1027314b3e70f$var$DEFAULT_CROSS_ORIGIN,
    manifest: $b5f1027314b3e70f$var$DEFAULT_MANIFEST,
    mode: $b5f1027314b3e70f$var$DEFAULT_MODE,
    retry: $b5f1027314b3e70f$var$DEFAULT_RETRY
};
const $b5f1027314b3e70f$export$44487a86467333c3 = ()=>$b5f1027314b3e70f$var$config;
const $b5f1027314b3e70f$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $b5f1027314b3e70f$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $b5f1027314b3e70f$var$DEFAULT_CROSS_ORIGIN;
    $b5f1027314b3e70f$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $b5f1027314b3e70f$var$DEFAULT_MANIFEST;
    $b5f1027314b3e70f$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $b5f1027314b3e70f$var$DEFAULT_MODE;
    $b5f1027314b3e70f$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $b5f1027314b3e70f$var$DEFAULT_RETRY;
};

});
parcelRegister("8sTE5", function(module, exports) {
$parcel$export(module.exports, "MODE", () => $629c1a4da7d2e3be$export$e48589d9e4824227);
const $629c1a4da7d2e3be$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};

});


parcelRegister("aOXaX", function(module, exports) {

var $8hBkG = parcelRequire("8hBkG");

var $fCt8O = parcelRequire("fCt8O");
parcelRequire("jXJsB");
var $gHzWq = parcelRequire("gHzWq");
var $aKMz4 = parcelRequire("aKMz4");

var $dvpuk = parcelRequire("dvpuk");
const $7e0c79f9b1cfd1ed$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $fCt8O.setConfig)(config);
        (0, $gHzWq.LISTENERS).length = 0;
        (0, $aKMz4.setCurrent)(0);
        if (!(0, $dvpuk.isNodeEnvironment)()) (0, $8hBkG.collect)();
    }
};

});
parcelRegister("8hBkG", function(module, exports) {
$parcel$export(module.exports, "collect", () => $607cdeba6e88cc3a$export$bb44f104e3c54dae);

var $fCt8O = parcelRequire("fCt8O");
var $8sTE5 = parcelRequire("8sTE5");

var $fGTut = parcelRequire("fGTut");

var $k47Hn = parcelRequire("k47Hn");

var $9wxa1 = parcelRequire("9wxa1");
const $607cdeba6e88cc3a$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $fCt8O.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $8sTE5.MODE).RENDER ? (0, $k47Hn.cloneElements)(markers[i], lazyBegin) : (0, $9wxa1.refElements)(markers[i], lazyBegin);
        if ((0, $fGTut.COLLECTED).has(lazyBegin)) (0, $fGTut.COLLECTED).get(lazyBegin).push(value);
        else (0, $fGTut.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};

});
parcelRegister("fGTut", function(module, exports) {
$parcel$export(module.exports, "PHASE", () => $b6c5d284fc1c3b33$export$2cc7a2eaaea7809f);
$parcel$export(module.exports, "COLLECTED", () => $b6c5d284fc1c3b33$export$4831ef3968ea94ef);
const $b6c5d284fc1c3b33$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $b6c5d284fc1c3b33$export$4831ef3968ea94ef = new Map();

});

parcelRegister("k47Hn", function(module, exports) {
$parcel$export(module.exports, "cloneElements", () => $e9ba272a418d0f34$export$c42217d53a7ebafb);
const $e9ba272a418d0f34$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};

});

parcelRegister("9wxa1", function(module, exports) {
$parcel$export(module.exports, "refElements", () => $6ef0d33701aa7c50$export$c69443129766a7fc);
const $6ef0d33701aa7c50$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};

});


parcelRegister("jXJsB", function(module, exports) {
$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("aKMz4")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("aKMz4")).setCurrent);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("gHzWq")).LISTENERS);

var $aKMz4 = parcelRequire("aKMz4");

var $gHzWq = parcelRequire("gHzWq");

var $hYeJh = parcelRequire("hYeJh");

});
parcelRegister("aKMz4", function(module, exports) {
$parcel$export(module.exports, "setCurrent", () => $7d43df31e2119a0a$export$5f80f094fd31fffd);
$parcel$export(module.exports, "LazyPhaseContext", () => $7d43df31e2119a0a$export$5a25eca35e5debcb);

var $5FkrB = parcelRequire("5FkrB");

var $fGTut = parcelRequire("fGTut");

var $gHzWq = parcelRequire("gHzWq");

var $hYeJh = parcelRequire("hYeJh");
let $7d43df31e2119a0a$var$CURRENT_PHASE = (0, $fGTut.PHASE).PAINT;
const $7d43df31e2119a0a$export$5f80f094fd31fffd = (phase)=>{
    $7d43df31e2119a0a$var$CURRENT_PHASE = phase;
    (0, $gHzWq.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $7d43df31e2119a0a$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $5FkrB.createContext)({
    subscribe: (0, $hYeJh.createSubscribe)((0, $gHzWq.LISTENERS)),
    currentValue: ()=>$7d43df31e2119a0a$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $7d43df31e2119a0a$export$5f80f094fd31fffd((0, $fGTut.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$7d43df31e2119a0a$export$5f80f094fd31fffd((0, $fGTut.PHASE).PAINT)
    }
});
const $7d43df31e2119a0a$export$1dc361b277327f88 = ()=>{
    const v = (0, $5FkrB.useContext)($7d43df31e2119a0a$export$5a25eca35e5debcb);
    return v.api;
};

});
parcelRegister("gHzWq", function(module, exports) {
$parcel$export(module.exports, "LISTENERS", () => $c28c8ab762db15a7$export$81b9c458a026d68f);
const $c28c8ab762db15a7$export$81b9c458a026d68f = [];

});

parcelRegister("hYeJh", function(module, exports) {
$parcel$export(module.exports, "createSubscribe", () => $d15377362e3cf8c7$export$364097d812234b3f);
const $d15377362e3cf8c7$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };

});



parcelRegister("dvpuk", function(module, exports) {
$parcel$export(module.exports, "getExport", () => $9d51f10a042b4452$export$d4c07b1daf44a7f);
$parcel$export(module.exports, "displayNameFromId", () => $9d51f10a042b4452$export$4429f98ef60d2d87);
$parcel$export(module.exports, "isNodeEnvironment", () => $9d51f10a042b4452$export$283635c04a02cc36);
$parcel$export(module.exports, "attrToProp", () => $9d51f10a042b4452$export$62bf630d0de3d781);
$parcel$export(module.exports, "hash", () => (parcelRequire("9thR5")).default);

var $9thR5 = parcelRequire("9thR5");
const $9d51f10a042b4452$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $9d51f10a042b4452$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $9d51f10a042b4452$export$283635c04a02cc36 = ()=>{
    return globalThis !== globalThis.window;
};
function $9d51f10a042b4452$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}

});
parcelRegister("9thR5", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e54ac2a6e5f0faf$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $6e54ac2a6e5f0faf$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});



parcelRegister("1Djk2", function(module, exports) {
$parcel$export(module.exports, "lazy", () => $13086bec4db3cef3$export$488013bae63b21da);

var $ephF7 = parcelRequire("ephF7");

var $fCt8O = parcelRequire("fCt8O");

var $fGTut = parcelRequire("fGTut");

var $dvpuk = parcelRequire("dvpuk");
var $9thR5 = parcelRequire("9thR5");

var $l9UVf = parcelRequire("l9UVf");

var $fiJwT = parcelRequire("fiJwT");

var $g4zqO = parcelRequire("g4zqO");

var $7xlym = parcelRequire("7xlym");

var $k2XKm = parcelRequire("k2XKm");

var $7JWBI = parcelRequire("7JWBI");

var $61Otq = parcelRequire("61Otq");
function $13086bec4db3cef3$var$_extends() {
    $13086bec4db3cef3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $13086bec4db3cef3$var$_extends.apply(this, arguments);
}
function $13086bec4db3cef3$var$lazyProxy(_loader, { defer: defer = (0, $fGTut.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $dvpuk.isNodeEnvironment)();
    const dataLazyId = (0, $9thR5.default)(moduleId);
    const LazyInternal = isServer ? (0, $g4zqO.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $fiJwT.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $7xlym.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $fCt8O.getConfig)();
                return (0, $7JWBI.retry)(_loader, {
                    delay: (0, $l9UVf.RETRY_DELAY),
                    factor: (0, $l9UVf.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $dvpuk.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $fCt8O.getConfig)();
        return (0, $ephF7.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $fGTut.PHASE).PAINT ? (0, $l9UVf.PRIORITY).HIGH : (0, $l9UVf.PRIORITY).LOW;
        return (0, $k2XKm.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $13086bec4db3cef3$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $fGTut.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $fGTut.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $fGTut.PHASE).LAZY
    }
};
function $13086bec4db3cef3$export$c952e5f94576010e(loader, opts) {
    return $13086bec4db3cef3$var$lazyProxy(loader, $13086bec4db3cef3$var$_extends({}, $13086bec4db3cef3$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $13086bec4db3cef3$export$291dd592399bdafa(loader, opts) {
    return $13086bec4db3cef3$var$lazyProxy(loader, $13086bec4db3cef3$var$_extends({}, $13086bec4db3cef3$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $13086bec4db3cef3$export$488013bae63b21da(loader, opts) {
    return $13086bec4db3cef3$var$lazyProxy(loader, $13086bec4db3cef3$var$_extends({}, $13086bec4db3cef3$export$93ca5d3f8675ae4c.lazy, opts || {}));
}

});
parcelRegister("ephF7", function(module, exports) {
$parcel$export(module.exports, "getAssetUrlsFromId", () => $a7d119cf864a5d06$export$303f43e55cf1ef2f);
const $a7d119cf864a5d06$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};

});

parcelRegister("l9UVf", function(module, exports) {
$parcel$export(module.exports, "PRIORITY", () => $f67697d468b8fda0$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "RETRY_DELAY", () => $f67697d468b8fda0$export$a339266ad71b2447);
$parcel$export(module.exports, "RETRY_FACTOR", () => $f67697d468b8fda0$export$ba64c908e55507fe);
const $f67697d468b8fda0$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $f67697d468b8fda0$export$a339266ad71b2447 = 300;
const $f67697d468b8fda0$export$ba64c908e55507fe = 1;

});

parcelRegister("fiJwT", function(module, exports) {
$parcel$export(module.exports, "createComponentClient", () => $b23bdaa718e54616$export$6898b5504b58699a);

var $5FkrB = parcelRequire("5FkrB");

var $fCt8O = parcelRequire("fCt8O");
var $8sTE5 = parcelRequire("8sTE5");

var $fGTut = parcelRequire("fGTut");
parcelRequire("61ipC");
var $a9rwy = parcelRequire("a9rwy");
parcelRequire("jXJsB");
var $aKMz4 = parcelRequire("aKMz4");
parcelRequire("eHPOU");
var $e0ImM = parcelRequire("e0ImM");

var $l9UVf = parcelRequire("l9UVf");

var $61Otq = parcelRequire("61Otq");

var $lbO8r = parcelRequire("lbO8r");

var $dbzD1 = parcelRequire("dbzD1");

var $k2XKm = parcelRequire("k2XKm");

var $5EDtT = parcelRequire("5EDtT");

var $kKnMI = parcelRequire("kKnMI");
function $b23bdaa718e54616$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const { requestIdleCallback: requestIdleCallback = setTimeout } = window;
    const ResolvedLazy = /*#__PURE__*/ (0, $5FkrB.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $5FkrB.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $fGTut.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $fGTut.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $5FkrB.useContext)((0, $5EDtT.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $61Otq.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        // Subscribe to LazyWait context, triggering load when until is true
        (0, $kKnMI.useSubscription)({
            context: (0, $a9rwy.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $fGTut.PHASE).AFTER_PAINT) {
            // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $kKnMI.useSubscription)({
                context: (0, $aKMz4.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
            // Schedule preloading as will be needed soon
            (0, $5FkrB.useMemo)(()=>{
                if (!status.preloaded) {
                    status.preloaded = true;
                    requestIdleCallback(()=>{
                        if (status.started) return;
                        (0, $k2XKm.preloadAsset)({
                            loader: deferred.preload,
                            moduleId: moduleId,
                            priority: (0, $l9UVf.PRIORITY).LOW
                        });
                    });
                }
            }, [
                status
            ]);
        }
        const { setFallback: setFallback } = (0, $5FkrB.useContext)((0, $e0ImM.LazySuspenseContext));
        (0, $5FkrB.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $fGTut.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $fCt8O.getConfig)().mode === (0, $8sTE5.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $lbO8r.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dbzD1.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(ResolvedLazy, props);
    };
}

});
parcelRegister("61ipC", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => (parcelRequire("a9rwy")).WaitContext);

var $a9rwy = parcelRequire("a9rwy");

var $2ASv9 = parcelRequire("2ASv9");

});
parcelRegister("a9rwy", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => $7640185f213279a6$export$9ba3fe09d15de47b);

var $5FkrB = parcelRequire("5FkrB");

var $cd6E9 = parcelRequire("cd6E9");
const $7640185f213279a6$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $5FkrB.createContext)({
    subscribe: ()=>(0, $cd6E9.noopCleanup),
    currentValue: ()=>1
});

});
parcelRegister("cd6E9", function(module, exports) {
$parcel$export(module.exports, "noopCleanup", () => $8e3bdacfc2cdcb7c$export$276c7dbda7675aec);
const $8e3bdacfc2cdcb7c$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};

});


parcelRegister("2ASv9", function(module, exports) {

var $5FkrB = parcelRequire("5FkrB");

var $a9rwy = parcelRequire("a9rwy");
const $1e39386a86fa7f28$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $5FkrB.useContext)((0, $a9rwy.WaitContext));
    const value = (0, $5FkrB.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $5FkrB.useRef)(new Set());
    const api = (0, $5FkrB.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $5FkrB.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a9rwy.WaitContext).Provider, {
        value: api.current
    }, children);
};

});


parcelRegister("eHPOU", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("hrJIU")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("e0ImM")).LazySuspenseContext);

var $hrJIU = parcelRequire("hrJIU");

var $e0ImM = parcelRequire("e0ImM");

});
parcelRegister("hrJIU", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => $cb386d0035b1ad86$export$256c542058532d6f);

var $5FkrB = parcelRequire("5FkrB");

var $dvpuk = parcelRequire("dvpuk");

var $e0ImM = parcelRequire("e0ImM");
class $cb386d0035b1ad86$export$256c542058532d6f extends (0, $5FkrB.Component) {
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback;
                // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            }
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $5FkrB.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e0ImM.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e0ImM.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $dvpuk.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
}

});
parcelRegister("e0ImM", function(module, exports) {
$parcel$export(module.exports, "LazySuspenseContext", () => $a3337b09a8b61c76$export$c33990e84065970c);

var $5FkrB = parcelRequire("5FkrB");
const $a3337b09a8b61c76$export$c33990e84065970c = /*#__PURE__*/ (0, $5FkrB.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});

});



parcelRegister("61Otq", function(module, exports) {
$parcel$export(module.exports, "createLoaderError", () => $4639fd13082e3a91$export$c73a6a6f0bf7d425);
const $4639fd13082e3a91$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $4639fd13082e3a91$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$4639fd13082e3a91$export$6aa69c1258005366]: true
    });
    return error;
};
const $4639fd13082e3a91$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($4639fd13082e3a91$export$6aa69c1258005366);

});

parcelRegister("lbO8r", function(module, exports) {
$parcel$export(module.exports, "PlaceholderFallbackRender", () => $f6d183dbb192b526$export$d55db778a3e1446b);

var $5FkrB = parcelRequire("5FkrB");
function $f6d183dbb192b526$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $f6d183dbb192b526$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $5FkrB.useRef)(null);
    const { current: ssrDomNodes } = (0, $5FkrB.useRef)(content || []);
    (0, $5FkrB.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($f6d183dbb192b526$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $f6d183dbb192b526$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $f6d183dbb192b526$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};

});

parcelRegister("dbzD1", function(module, exports) {
$parcel$export(module.exports, "PlaceholderFallbackHydrate", () => $9997f07aadb68c2d$export$ca5b8fbc835d95e4);

var $5FkrB = parcelRequire("5FkrB");

var $dvpuk = parcelRequire("dvpuk");
function $9997f07aadb68c2d$var$_extends() {
    $9997f07aadb68c2d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9997f07aadb68c2d$var$_extends.apply(this, arguments);
}
const $9997f07aadb68c2d$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $dvpuk.attrToProp), {
            key: String(i)
        });
        // text node
        if (!tagName) return /*#__PURE__*/ (0, $5FkrB.createElement)((0, $5FkrB.Fragment), props, el.textContent);
        // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $5FkrB.createElement)(tagName.toLowerCase(), props);
        // tag with content
        return /*#__PURE__*/ (0, $5FkrB.createElement)(tagName.toLowerCase(), $9997f07aadb68c2d$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};

});

parcelRegister("k2XKm", function(module, exports) {
$parcel$export(module.exports, "preloadAsset", () => $e9825702b13b5bde$export$25bad4aa00c45355);

var $ephF7 = parcelRequire("ephF7");

var $cd6E9 = parcelRequire("cd6E9");

var $fCt8O = parcelRequire("fCt8O");

var $dvpuk = parcelRequire("dvpuk");

var $l9UVf = parcelRequire("l9UVf");

var $2DDid = parcelRequire("2DDid");

var $5EDtT = parcelRequire("5EDtT");
function $e9825702b13b5bde$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $fCt8O.getConfig)();
    const assets = (0, $ephF7.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $2DDid.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $e9825702b13b5bde$var$fakePromise = {
    then: ()=>$e9825702b13b5bde$var$fakePromise,
    catch: ()=>$e9825702b13b5bde$var$fakePromise,
    finally: ()=>$e9825702b13b5bde$var$fakePromise
};
function $e9825702b13b5bde$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $2DDid.insertLinkTag)(href, rel));
        return $e9825702b13b5bde$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $e9825702b13b5bde$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $cd6E9.noopCleanup;
}
function $e9825702b13b5bde$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $dvpuk.isNodeEnvironment)()) return 0, $cd6E9.noopCleanup;
    (_GlobalReactLooselyLa = (0, $5EDtT.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $l9UVf.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $e9825702b13b5bde$export$3af04dbcb01bad4d,
        $e9825702b13b5bde$export$1046fd6a49d5e7a,
        $e9825702b13b5bde$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $cd6E9.noopCleanup;
}

});
parcelRegister("2DDid", function(module, exports) {
$parcel$export(module.exports, "insertLinkTag", () => $1ebdb4043e117620$export$6610512821c8a4ce);

var $5EDtT = parcelRequire("5EDtT");

var $cd6E9 = parcelRequire("cd6E9");

var $fCt8O = parcelRequire("fCt8O");
function $1ebdb4043e117620$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $cd6E9.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $fCt8O.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $5EDtT.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}

});
parcelRegister("5EDtT", function(module, exports) {
$parcel$export(module.exports, "GlobalReactLooselyLazyProfiler", () => $41df505416e98303$export$e2d53c0cbedd2710);
$parcel$export(module.exports, "ProfilerContext", () => $41df505416e98303$export$8146ab57a3f7a7cb);

var $5FkrB = parcelRequire("5FkrB");
const $41df505416e98303$export$e2d53c0cbedd2710 = {
    current: null
};
const $41df505416e98303$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $5FkrB.createContext)($41df505416e98303$export$e2d53c0cbedd2710);

});



parcelRegister("kKnMI", function(module, exports) {
$parcel$export(module.exports, "useSubscription", () => $f1aa8daaa778e637$export$368b4214baeb914c);

var $5FkrB = parcelRequire("5FkrB");
function $f1aa8daaa778e637$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $5FkrB.useContext)(context);
    (0, $5FkrB.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("g4zqO", function(module, exports) {
$parcel$export(module.exports, "createComponentServer", () => $bb388109aff92530$export$eb2e4b04351cdd9e);

var $ephF7 = parcelRequire("ephF7");

var $5FkrB = parcelRequire("5FkrB");

var $fCt8O = parcelRequire("fCt8O");

var $fGTut = parcelRequire("fGTut");
parcelRequire("eHPOU");
var $e0ImM = parcelRequire("e0ImM");

var $dvpuk = parcelRequire("dvpuk");

var $61Otq = parcelRequire("61Otq");
function $bb388109aff92530$var$load(moduleId, loader) {
    try {
        return (0, $dvpuk.getExport)(loader());
    } catch (err) {
        throw (0, $61Otq.createLoaderError)(err);
    }
}
function $bb388109aff92530$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $bb388109aff92530$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $5FkrB.useContext)((0, $e0ImM.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $fCt8O.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $fGTut.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $ephF7.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("link", {
                key: url,
                rel: defer === (0, $fGTut.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}

});

parcelRegister("7xlym", function(module, exports) {
$parcel$export(module.exports, "createDeferred", () => $57cc5576d54eb729$export$e673efccd97e4223);
const $57cc5576d54eb729$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};

});

parcelRegister("7JWBI", function(module, exports) {
$parcel$export(module.exports, "retry", () => $5a2a328e7007b141$export$9369b12211e1fce4);
const $5a2a328e7007b141$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $5a2a328e7007b141$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $5a2a328e7007b141$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $5a2a328e7007b141$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $5a2a328e7007b141$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $5a2a328e7007b141$var$calculateDelay(context, policy);
        if (delay) await $5a2a328e7007b141$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}

});



parcelRegister("cqR4L", function(module, exports) {
$parcel$export(module.exports, "getExtensionKeyAndNodeKey", () => $90d1158250efa640$export$8a49818572e1d105);
$parcel$export(module.exports, "resolveImport", () => $90d1158250efa640$export$d69c9b451c47653b);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $iYJcE = parcelRequire("iYJcE");

var $6HG4S = parcelRequire("6HG4S");

var $IcDXU = parcelRequire("IcDXU");

var $bwwSO = parcelRequire("bwwSO");
function $90d1158250efa640$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $90d1158250efa640$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $90d1158250efa640$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $90d1158250efa640$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $90d1158250efa640$export$a7d04c836550045a = 'com.atlassian.ecosystem';
var $90d1158250efa640$export$862c0e8acc7585d7 = 'com.atlassian.confluence.macro.core';
var $90d1158250efa640$export$b343a94058bea058 = 'native-embed';
var $90d1158250efa640$export$e400f4d17a615c24 = 'agent-managed-block';
var $90d1158250efa640$export$8a49818572e1d105 = function getExtensionKeyAndNodeKey(extensionKey, extensionType) {
    // Forge macro extensionKey has a user generated string, so splitting on
    // a colon is unstable for their particular use case. They only have one
    // node in the relevant manifest so we can hardcode nodeKey to 'default'.
    if (extensionType === $90d1158250efa640$export$a7d04c836550045a) return [
        extensionKey,
        'default'
    ];
    var _extensionKey$split = extensionKey.split(':'), _extensionKey$split2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_extensionKey$split, 2), extKey = _extensionKey$split2[0], _extensionKey$split2$ = _extensionKey$split2[1], nodeKey = _extensionKey$split2$ === void 0 ? 'default' : _extensionKey$split2$;
    return [
        extKey,
        nodeKey
    ];
};
function $90d1158250efa640$export$bb33bcdd9a10a608(action, manifest) {
    if (typeof action === 'function') return action;
    if (action.type === 'node' && manifest.modules.nodes) return $90d1158250efa640$export$33863d887d6f4bfd(action, manifest);
}
var $90d1158250efa640$export$d69c9b451c47653b = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(importPromise) {
        var _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _t = (0, $bwwSO.resolveImportSync);
                    _context.next = 1;
                    return importPromise;
                case 1:
                    return _context.abrupt("return", _t(_context.sent));
                case 2:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function resolveImport(_x) {
        return _ref.apply(this, arguments);
    };
}();
function $90d1158250efa640$export$33863d887d6f4bfd(action, manifest) {
    if (!manifest.modules.nodes) return;
    var node = manifest.modules.nodes[action.key];
    var extensionKey = (0, $IcDXU.buildExtensionKeyAndNodeKey)(manifest.key, action.key);
    var extension = {
        type: node.type,
        attrs: {
            extensionType: manifest.type,
            extensionKey: extensionKey,
            parameters: action.parameters
        }
    };
    if (node.type === 'bodiedExtension') return $90d1158250efa640$var$_objectSpread($90d1158250efa640$var$_objectSpread({}, extension), {}, {
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    });
    else if (node.type === 'multiBodiedExtension') return $90d1158250efa640$var$_objectSpread($90d1158250efa640$var$_objectSpread({}, extension), {}, {
        content: [
            {
                type: 'extensionFrame',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            }
        ]
    });
    return extension;
}

});
parcelRegister("IcDXU", function(module, exports) {
$parcel$export(module.exports, "buildExtensionKeyAndNodeKey", () => $084deaee5f6166f5$export$5f3eb042babacbbd);
var $084deaee5f6166f5$export$5f3eb042babacbbd = function buildExtensionKeyAndNodeKey(extensionKey, nodeKey) {
    if (!nodeKey || nodeKey === 'default') return extensionKey;
    return "".concat(extensionKey, ":").concat(nodeKey);
};

});

parcelRegister("bwwSO", function(module, exports) {
$parcel$export(module.exports, "resolveImportSync", () => $863c30c06ddede67$export$dca2026e63034304);
var $863c30c06ddede67$export$dca2026e63034304 = function resolveImportSync(importedModule) {
    return importedModule && importedModule.__esModule ? importedModule.default : importedModule;
};

});


parcelRegister("7mos3", function(module, exports) {
$parcel$export(module.exports, "messages", () => $55bd8e04676325da$export$defe85febe8b728c);

var $6bnW7 = parcelRequire("6bnW7");

var $55bd8e04676325da$export$defe85febe8b728c = (0, $6bnW7.defineMessages)({
    edit: {
        id: 'fabric.editor.edit',
        defaultMessage: 'Edit',
        description: 'The text is shown as a button label in the extension context menu. Triggers opening the properties editor for the selected extension to modify its configuration.'
    },
    deleteElementTitle: {
        id: 'fabric.editor.extension.deleteElementTitle',
        defaultMessage: 'Delete element',
        description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
    },
    unnamedSource: {
        id: 'fabric.editor.extension.sourceNoTitledName',
        defaultMessage: 'this element',
        description: 'The current element without preset name been selected'
    },
    confirmDeleteLinkedModalOKButton: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalOKButton',
        defaultMessage: 'Delete',
        description: 'Action button label for confirm modal when deleting an extension linked to a data consumer.'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a extension linked to an data consumer.'
    },
    confirmModalCheckboxLabel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
        defaultMessage: 'Also delete connected elements',
        description: 'Label for a checkbox in a confirm modal that allows the user to also delete connected elements when deleting an extension.'
    },
    saveIndicator: {
        id: 'fabric.editor.extensions.config-panel.save-indicator',
        defaultMessage: 'All changes are always autosaved',
        description: 'Informational message displayed in the extension configuration panel to reassure users that their changes are being saved automatically without requiring manual save action.'
    },
    panelLoadingError: {
        id: 'fabric.editor.extensions.config-panel.loading-error.non-final',
        defaultMessage: 'We ran into a bit of trouble. Refresh to try again.',
        description: 'Error message displayed when the extension configuration panel fails to load. Instructs users to refresh the page to attempt loading the panel again.'
    },
    extensionLoadingError: {
        id: 'fabric.editor.extension.loading-error',
        defaultMessage: 'Error loading the extension!',
        description: 'Error message displayed when an extension fails to load in the editor. Indicates a problem occurred during the extension initialization or rendering process.'
    },
    unknownMacroPlaceholderAriaLabel: {
        id: 'fabric.editor.extension.unknownMacroPlaceholderAriaLabel',
        defaultMessage: 'Unknown macro placeholder',
        description: 'Accessible label for the unknown macro fallback block shown when a Confluence macro cannot be resolved.'
    },
    unknownMacroHeader: {
        id: 'fabric.editor.extension.unknownMacroHeader',
        defaultMessage: "Unknown macro: ''{macroTitle}''",
        description: 'Header text for an unresolved Confluence macro placeholder.'
    }
});

});

parcelRegister("bISAN", function(module, exports) {
$parcel$export(module.exports, "UnknownMacroPlaceholder", () => $888e26acd7f7cae9$export$414b5225f50e455b);
/* UnknownMacroPlaceholder.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $cAVP0 = parcelRequire("cAVP0");

var $hrVKU = parcelRequire("hrVKU");

var $jkJfI = parcelRequire("jkJfI");

var $7mos3 = parcelRequire("7mos3");
// Unknown macro placeholder styling aligned with Legacy Content Macro (LCM) for consistent look
var $888e26acd7f7cae9$var$neutralBorder = "var(--ds-background-neutral, #0515240F)";
var $888e26acd7f7cae9$var$unknownMacroContainerStyles = null;
// Match LCM header exactly: lcmHeaderStyles from LegacyContentHeader/index.tsx
var $888e26acd7f7cae9$var$unknownMacroHeaderStyles = null;
// Match LCM content area: white surface, text color inherits
var $888e26acd7f7cae9$var$unknownMacroBodyStyles = null;
var $888e26acd7f7cae9$var$unknownMacroPreStyles = null;
var $888e26acd7f7cae9$var$formatParam = function formatParam(key, param) {
    var _param$value;
    var value = String((_param$value = param === null || param === void 0 ? void 0 : param.value) !== null && _param$value !== void 0 ? _param$value : '').trim();
    return "".concat(key, " = ").concat(value);
};
var $888e26acd7f7cae9$var$EMPTY_MACRO_PARAMS = {};
function $888e26acd7f7cae9$export$414b5225f50e455b(_ref) {
    var _extensionNode$parame, _extensionNode$parame2, _extensionNode$parame3, _extensionNode$parame4, _extensionNode$parame5, _extensionNode$parame6;
    var extensionNode = _ref.extensionNode;
    var intl = (0, $hrVKU.default)();
    var macroTitle = ((_extensionNode$parame = extensionNode.parameters) === null || _extensionNode$parame === void 0 || (_extensionNode$parame = _extensionNode$parame.macroMetadata) === null || _extensionNode$parame === void 0 ? void 0 : _extensionNode$parame.title) || extensionNode.extensionKey;
    var bodyContent = (_extensionNode$parame2 = extensionNode.parameters) === null || _extensionNode$parame2 === void 0 || (_extensionNode$parame2 = _extensionNode$parame2.macroParams) === null || _extensionNode$parame2 === void 0 || (_extensionNode$parame2 = _extensionNode$parame2.__bodyContent) === null || _extensionNode$parame2 === void 0 ? void 0 : _extensionNode$parame2.value;
    var macroParamsOld = (_extensionNode$parame3 = (_extensionNode$parame4 = extensionNode.parameters) === null || _extensionNode$parame4 === void 0 ? void 0 : _extensionNode$parame4.macroParams) !== null && _extensionNode$parame3 !== void 0 ? _extensionNode$parame3 : {};
    var macroParams = (_extensionNode$parame5 = (_extensionNode$parame6 = extensionNode.parameters) === null || _extensionNode$parame6 === void 0 ? void 0 : _extensionNode$parame6.macroParams) !== null && _extensionNode$parame5 !== void 0 ? _extensionNode$parame5 : $888e26acd7f7cae9$var$EMPTY_MACRO_PARAMS;
    var formatParamInline = function formatParamInline(key, param) {
        var _param$value2;
        var value = String((_param$value2 = param === null || param === void 0 ? void 0 : param.value) !== null && _param$value2 !== void 0 ? _param$value2 : '').trim();
        return "".concat(key, " = ").concat(value);
    };
    var memoizedVisibleParams = (0, $5FkrB.useMemo)(function() {
        return Object.entries(macroParams).filter(function(_ref2) {
            var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), key = _ref3[0];
            return !key.startsWith('_');
        }).map(function(_ref4) {
            var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref4, 2), key = _ref5[0], param = _ref5[1];
            return $888e26acd7f7cae9$var$formatParam(key, param);
        }).join(' | ');
    }, [
        macroParams
    ]);
    var visibleParams = (0, $jkJfI.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedVisibleParams : // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- intentional fallback for experiment off path
    Object.entries(macroParamsOld).filter(function(_ref6) {
        var _ref7 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref6, 1), key = _ref7[0];
        return !key.startsWith('_');
    }).map(function(_ref8) {
        var _ref9 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref8, 2), key = _ref9[0], param = _ref9[1];
        return formatParamInline(key, param);
    }).join(' | ');
    var headerText = visibleParams ? "".concat(intl.formatMessage((0, $7mos3.messages).unknownMacroHeader, {
        macroTitle: macroTitle
    }), " | ").concat(visibleParams) : intl.formatMessage((0, $7mos3.messages).unknownMacroHeader, {
        macroTitle: macroTitle
    });
    return /*#__PURE__*/ $5FkrB.createElement("section", {
        "aria-label": intl.formatMessage((0, $7mos3.messages).unknownMacroPlaceholderAriaLabel),
        className: (0, $970q7.default)([
            "_19it7tl1 _2rko12b0 _1reo15vq _18m915vq _bfhkhp5a"
        ]),
        style: {
            "--_98ihdp": (0, $cAVP0.default)("1px solid ".concat($888e26acd7f7cae9$var$neutralBorder))
        }
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            "_2rko14xi _11c8wadc _n7zl1q32 _bfhki8nm _ca0qu2gc _u5f3pxbi _n3td1b66 _19bvpxbi _kqswh2mm _154i1n1a"
        ]),
        style: {
            "--_1e0q5w0": (0, $cAVP0.default)("var(--ds-border-width, 1px)".concat(" solid ", $888e26acd7f7cae9$var$neutralBorder))
        }
    }, headerText), /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhkvuon _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("pre", {
        className: (0, $970q7.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c8fhey _o5721jtm _1nmz1hna _6z24egat"
        ])
    }, bodyContent)));
}

});


parcelRegister("qprXf", function(module, exports) {
$parcel$export(module.exports, "WithProviders", () => $04f62ba387148165$export$d498ee8be33e096f);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");
function $04f62ba387148165$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $04f62ba387148165$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $04f62ba387148165$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $04f62ba387148165$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $04f62ba387148165$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $04f62ba387148165$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $04f62ba387148165$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($04f62ba387148165$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $04f62ba387148165$export$d498ee8be33e096f = /*#__PURE__*/ function(_PureComponent) {
    function WithProviders(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, WithProviders);
        _this = $04f62ba387148165$var$_callSuper(this, WithProviders, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "mounted", false);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "handleProviderIfMounted", function(name, provider) {
            if (!_this.mounted) return;
            _this.handleProvider(name, provider);
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "handleProvider", function(name, provider) {
            _this.setState(function(_ref) {
                var providers = _ref.providers;
                return {
                    providers: $04f62ba387148165$var$_objectSpread($04f62ba387148165$var$_objectSpread({}, providers), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, name, provider))
                };
            });
        });
        _this.mounted = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var _providers = {};
        _this.props.providers.forEach(function(name) {
            var providerPromise = props.providerFactory.subscribe(name, _this.handleProviderIfMounted);
            _providers[name] = providerPromise;
        });
        _this.state = {
            providers: _providers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(WithProviders, _PureComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(WithProviders, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.mounted = true;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var _this2 = this;
                var _this$props = this.props, providers = _this$props.providers, providerFactory = _this$props.providerFactory;
                providers.forEach(function(name) {
                    providerFactory.unsubscribe(name, _this2.handleProviderIfMounted);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var state = this.state, props = this.props;
                var renderNode = props.renderNode;
                return renderNode(state.providers);
            }
        }
    ]);
}((0, $5FkrB.PureComponent));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($04f62ba387148165$export$d498ee8be33e096f, "displayName", 'WithProviders');

});

parcelRegister("fIf3B", function(module, exports) {
$parcel$export(module.exports, "getExtensionRenderer", () => $b706a520e42ab334$export$9214452ef07eda7);

var $ekGgq = parcelRequire("ekGgq");
function $b706a520e42ab334$export$9214452ef07eda7(extensionHandler) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(extensionHandler) === 'object') return extensionHandler.render;
    else return extensionHandler;
}

});


parcelRegister("enqEB", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $a777e3904fb2911a$export$e926676385687eaf);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $6EZ2P = parcelRequire("6EZ2P");

var $jJH6F = parcelRequire("jJH6F");

var $7bmOa = parcelRequire("7bmOa");

var $aP6HU = parcelRequire("aP6HU");
function $a777e3904fb2911a$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $a777e3904fb2911a$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $a777e3904fb2911a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a777e3904fb2911a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $a777e3904fb2911a$var$FAILED_TO_EXECUTE_REGEX = /Failed to execute.*on 'Node'.*/;
var $a777e3904fb2911a$export$e926676385687eaf = /*#__PURE__*/ function(_React$Component) {
    function ErrorBoundary() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ErrorBoundary);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $a777e3904fb2911a$var$_callSuper(this, ErrorBoundary, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "state", {
            errorCaptured: false,
            domError: false,
            domErrorCount: 0
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ErrorBoundary, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ErrorBoundary, [
        {
            key: "fireAnalyticsEvent",
            value: function fireAnalyticsEvent(event) {
                var createAnalyticsEvent = this.props.createAnalyticsEvent;
                if (createAnalyticsEvent) {
                    var channel = (0, $6EZ2P.FabricChannel).editor;
                    createAnalyticsEvent(event).fire(channel);
                }
            }
        },
        {
            key: "hasFallback",
            value: function hasFallback() {
                return typeof this.props.fallbackComponent !== 'undefined';
            }
        },
        {
            key: "shouldRecover",
            value: function shouldRecover() {
                return this.hasFallback() && this.state.errorCaptured;
            }
        },
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                var _this$props$additiona, _this2 = this;
                var additionalInfo = (_this$props$additiona = this.props.additionalInfo) !== null && _this$props$additiona !== void 0 ? _this$props$additiona : '';
                this.fireAnalyticsEvent({
                    action: (0, $jJH6F.ACTION).CRASHED,
                    actionSubject: this.props.component,
                    actionSubjectId: this.props.componentId,
                    eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        platform: (0, $aP6HU.PLATFORM).WEB,
                        errorMessage: "".concat(additionalInfo).concat(error === null || error === void 0 ? void 0 : error.message),
                        componentStack: (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.componentStack) || undefined,
                        errorRethrown: Boolean(this.props.rethrowError)
                    }
                });
                (0, $7bmOa.logException)(error, {
                    location: 'renderer'
                });
                var matchesPattern = $a777e3904fb2911a$var$FAILED_TO_EXECUTE_REGEX.test(error.message);
                if (matchesPattern) {
                    this.fireAnalyticsEvent({
                        action: (0, $jJH6F.ACTION).CAUGHT_DOM_ERROR,
                        actionSubject: this.props.component,
                        actionSubjectId: this.props.componentId,
                        eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL,
                        attributes: {
                            platform: (0, $aP6HU.PLATFORM).WEB,
                            errorMessage: "".concat(additionalInfo).concat(error === null || error === void 0 ? void 0 : error.message)
                        }
                    });
                    this.setState(function(prevState) {
                        return {
                            domError: true,
                            domErrorCount: prevState.domErrorCount + 1
                        };
                    });
                }
                if (this.hasFallback()) this.setState({
                    errorCaptured: true
                }, function() {
                    if (_this2.props.rethrowError) throw error;
                });
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.domError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, {
                    key: this.state.domErrorCount
                }, this.props.children);
                if (this.shouldRecover()) return this.props.fallbackComponent;
                return this.props.children;
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component);

});
parcelRegister("7bmOa", function(module, exports) {
$parcel$export(module.exports, "logException", () => $53ab40b2cd5b21c2$export$f86b2a1a2ce291b3);

var $25nEq = parcelRequire("25nEq");

var $fC8ib = parcelRequire("fC8ib");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $7RT42 = parcelRequire("7RT42");

var $74GWP = parcelRequire("74GWP");

var $e6MoK = parcelRequire("e6MoK");
function $53ab40b2cd5b21c2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $53ab40b2cd5b21c2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $53ab40b2cd5b21c2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $53ab40b2cd5b21c2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $53ab40b2cd5b21c2$var$NETWORK_ERROR_REGEX = /^network error/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $53ab40b2cd5b21c2$var$NETWORK_FAILURE_REGEX = /^network failure/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $53ab40b2cd5b21c2$var$RESIZE_OBSERVER_LOOP_REGEX = /ResizeObserver loop completed with undelivered notifications/;
var $53ab40b2cd5b21c2$var$SENTRY_DSN = 'https://0b10c8e02fb44d8796c047b102c9bee8@o55978.ingest.sentry.io/4505129224110080';
var $53ab40b2cd5b21c2$var$packageName = 'editor-common'; // Sentry doesn't accept '/' in its releases https://docs.sentry.io/platforms/javascript/configuration/releases/
var $53ab40b2cd5b21c2$var$packageVersion = "125.1.0";
var $53ab40b2cd5b21c2$var$sanitiseSentryEvents = function sanitiseSentryEvents(data, _hint) {
    // Remove URL as it has UGC
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Sanitise the URL instead of just removing it
    if (data.request) delete data.request.url;
    return data;
};


var $53ab40b2cd5b21c2$export$f86b2a1a2ce291b3 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(error, tags) {
        var _process$env$CLOUD_EN, _yield$import, BrowserClient, defaultIntegrations, getCurrentHub, _yield$import2, ExtraErrorData, breadcrumbsIntegration, sentryOptions, client, hub, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.prev = 0;
                    _context.next = 1;
                    break;
                    return _context.abrupt("return");
                case 1:
                    _context.next = 2;
                    return Promise.resolve((parcelRequire("7RT42")));
                case 2:
                    _yield$import = _context.sent;
                    BrowserClient = _yield$import.BrowserClient;
                    defaultIntegrations = _yield$import.defaultIntegrations;
                    getCurrentHub = _yield$import.getCurrentHub;
                    _context.next = 3;
                    return (parcelRequire("jYDPM"));
                case 3:
                    _yield$import2 = _context.sent;
                    ExtraErrorData = _yield$import2.ExtraErrorData;
                    breadcrumbsIntegration = new (0, $7RT42.Integrations).Breadcrumbs({
                        // only enable breadcrumbs for dom (UI clicks and inputs)
                        // include 'data-test-id', 'data-testid' in the breadcrumbs if they are found
                        dom: {
                            serializeAttribute: (0, $e6MoK.SERIALIZABLE_ATTRIBUTES)
                        },
                        fetch: false,
                        xhr: false,
                        console: false,
                        history: false,
                        sentry: false
                    });
                    sentryOptions = {
                        dsn: (0, $74GWP.isFedRamp)() ? undefined : $53ab40b2cd5b21c2$var$SENTRY_DSN,
                        release: "".concat($53ab40b2cd5b21c2$var$packageName, "@").concat($53ab40b2cd5b21c2$var$packageVersion),
                        environment: (_process$env$CLOUD_EN = undefined, _process$env$CLOUD_EN !== void 0) ? _process$env$CLOUD_EN : 'unknown',
                        beforeBreadcrumb: (0, $e6MoK.normaliseSentryBreadcrumbs),
                        ignoreErrors: [
                            // Network issues
                            $53ab40b2cd5b21c2$var$NETWORK_ERROR_REGEX,
                            $53ab40b2cd5b21c2$var$NETWORK_FAILURE_REGEX,
                            'TypeError: Failed to fetch',
                            // A benign error, see https://stackoverflow.com/a/50387233/2645305
                            'ResizeObserver loop limit exceeded',
                            $53ab40b2cd5b21c2$var$RESIZE_OBSERVER_LOOP_REGEX
                        ],
                        autoSessionTracking: false,
                        integrations: function integrations(_integrations) {
                            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(defaultIntegrations.filter(function(_ref2) {
                                var name = _ref2.name;
                                return name !== 'Breadcrumbs';
                            })), [
                                breadcrumbsIntegration,
                                // Extracts all non-native attributes from the error object and attaches them to the event as the extra data
                                // https://docs.sentry.io/platforms/javascript/configuration/integrations/plugin/?original_referrer=https%3A%2F%2Fduckduckgo.com%2F#extraerrordata
                                new ExtraErrorData()
                            ]);
                        },
                        beforeSend: $53ab40b2cd5b21c2$var$sanitiseSentryEvents
                    }; // Use a client to avoid picking up the errors from parent applications
                    client = new BrowserClient(sentryOptions);
                    hub = getCurrentHub();
                    hub.bindClient(client);
                    hub.withScope(function(scope) {
                        var _buildInfo;
                        scope.setTags($53ab40b2cd5b21c2$var$_objectSpread({
                            // Jira environment variables
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            'jira-bundler': window.BUNDLER_VERSION,
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            'jira-variant': window.BUILD_VARIANT,
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            'jira-release': window.BUILD_KEY,
                            // Confluence environment variables
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            'confluence-frontend-version': (_buildInfo = window.__buildInfo) === null || _buildInfo === void 0 ? void 0 : _buildInfo.FRONTEND_VERSION
                        }, tags));
                        // Explicitly remove the breadcrumbs as it's too likely to log UGC/PII to side-step the hub integrations not being respected
                        scope.clearBreadcrumbs();
                        hub.captureException(error);
                    });
                    return _context.abrupt("return", client.close());
                case 4:
                    _context.prev = 4;
                    _t = _context["catch"](0);
                case 5:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                0,
                4
            ]
        ]);
    }));
    return function logException(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("7RT42", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $5ba83237ec7091f5$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("e3MRU")));

var $iTWOe = parcelRequire("iTWOe");

var $1hL7y = parcelRequire("1hL7y");

var $2zF9F = parcelRequire("2zF9F");
parcelRequire("i0afJ");
var $lrp9R = parcelRequire("lrp9R");

var $g55ns = parcelRequire("g55ns");

var $e3MRU = parcelRequire("e3MRU");
var $5ba83237ec7091f5$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $5ba83237ec7091f5$var$_window = (0, $lrp9R.getGlobalObject)();
if ($5ba83237ec7091f5$var$_window.Sentry && $5ba83237ec7091f5$var$_window.Sentry.Integrations) $5ba83237ec7091f5$var$windowIntegrations = $5ba83237ec7091f5$var$_window.Sentry.Integrations;
var $5ba83237ec7091f5$export$99d02219d259eb94 = (0, $iTWOe.__assign)((0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, $5ba83237ec7091f5$var$windowIntegrations), (0, $2zF9F)), $g55ns);
$parcel$exportWildcard(module.exports, $1hL7y);

});
parcelRegister("iTWOe", function(module, exports) {
$parcel$export(module.exports, "__extends", () => $dc2afb5696871518$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $dc2afb5696871518$export$18ce0697a983be9b);
$parcel$export(module.exports, "__values", () => $dc2afb5696871518$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $dc2afb5696871518$export$8d051b38c9118094);
$parcel$export(module.exports, "__spread", () => $dc2afb5696871518$export$afc72e2116322959);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $dc2afb5696871518$var$extendStatics = function(d, b) {
    $dc2afb5696871518$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $dc2afb5696871518$var$extendStatics(d, b);
};
function $dc2afb5696871518$export$a8ba968b8961cb8a(d, b) {
    $dc2afb5696871518$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $dc2afb5696871518$export$18ce0697a983be9b = function() {
    $dc2afb5696871518$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dc2afb5696871518$export$18ce0697a983be9b.apply(this, arguments);
};
function $dc2afb5696871518$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $dc2afb5696871518$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $dc2afb5696871518$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $dc2afb5696871518$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $dc2afb5696871518$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $dc2afb5696871518$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $dc2afb5696871518$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $dc2afb5696871518$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $dc2afb5696871518$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $dc2afb5696871518$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $dc2afb5696871518$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($dc2afb5696871518$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $dc2afb5696871518$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $dc2afb5696871518$export$10c90e4f7922046c(v) {
    return this instanceof $dc2afb5696871518$export$10c90e4f7922046c ? (this.v = v, this) : new $dc2afb5696871518$export$10c90e4f7922046c(v);
}
function $dc2afb5696871518$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $dc2afb5696871518$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $dc2afb5696871518$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $dc2afb5696871518$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $dc2afb5696871518$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $dc2afb5696871518$export$19a8beecd37a4c45 === "function" ? $dc2afb5696871518$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $dc2afb5696871518$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $dc2afb5696871518$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $dc2afb5696871518$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $dc2afb5696871518$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $dc2afb5696871518$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("1hL7y", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("iYYET")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("FnrKW")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("kD78n")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("kD78n")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("kD78n")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("kD78n")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("kD78n")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("ir14T")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("ir14T")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("ir14T")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("ir14T")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("FnrKW")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("vfED8")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("kD78n")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("egk2u")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("kD78n")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("kD78n")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("kD78n")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("kD78n")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("kD78n")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("kD78n")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("kD78n")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("7bmvO")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("iuPyo")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("QEOc2")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("QEOc2")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("5R1Wi")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("5R1Wi")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("5R1Wi")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("5R1Wi")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("5R1Wi")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("5R1Wi")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("5R1Wi")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("5R1Wi")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("5R1Wi")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("7sZPK")).SDK_NAME);

var $iYYET = parcelRequire("iYYET");

var $kD78n = parcelRequire("kD78n");
var $FnrKW = parcelRequire("FnrKW");
var $ir14T = parcelRequire("ir14T");
var $egk2u = parcelRequire("egk2u");
var $vfED8 = parcelRequire("vfED8");

var $7bmvO = parcelRequire("7bmvO");

var $iuPyo = parcelRequire("iuPyo");

var $QEOc2 = parcelRequire("QEOc2");

var $5R1Wi = parcelRequire("5R1Wi");

var $7sZPK = parcelRequire("7sZPK");

});
parcelRegister("iYYET", function(module, exports) {
$parcel$export(module.exports, "Severity", () => $dd1ce21d7a983db9$export$918a9776c0a3cf27);
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */ var $dd1ce21d7a983db9$export$918a9776c0a3cf27;
(function(Severity) {
    /** JSDoc */ Severity["Fatal"] = "fatal";
    /** JSDoc */ Severity["Error"] = "error";
    /** JSDoc */ Severity["Warning"] = "warning";
    /** JSDoc */ Severity["Log"] = "log";
    /** JSDoc */ Severity["Info"] = "info";
    /** JSDoc */ Severity["Debug"] = "debug";
    /** JSDoc */ Severity["Critical"] = "critical";
})($dd1ce21d7a983db9$export$918a9776c0a3cf27 || ($dd1ce21d7a983db9$export$918a9776c0a3cf27 = {}));
var $dd1ce21d7a983db9$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});

parcelRegister("kD78n", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $f04cfbdc3f8db658$export$f5282963edea4a68);
$parcel$export(module.exports, "captureMessage", () => $f04cfbdc3f8db658$export$45654777c133ae80);
$parcel$export(module.exports, "captureEvent", () => $f04cfbdc3f8db658$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "configureScope", () => $f04cfbdc3f8db658$export$99d44f04437e9cb8);
$parcel$export(module.exports, "addBreadcrumb", () => $f04cfbdc3f8db658$export$efda9a273d7a036d);
$parcel$export(module.exports, "setContext", () => $f04cfbdc3f8db658$export$2f04de43fe27971a);
$parcel$export(module.exports, "setExtras", () => $f04cfbdc3f8db658$export$bb4922da0dd51b92);
$parcel$export(module.exports, "setTags", () => $f04cfbdc3f8db658$export$74a8fb34822092e6);
$parcel$export(module.exports, "setExtra", () => $f04cfbdc3f8db658$export$8e8e7789d42ed61d);
$parcel$export(module.exports, "setTag", () => $f04cfbdc3f8db658$export$a37d07ee78eb4569);
$parcel$export(module.exports, "setUser", () => $f04cfbdc3f8db658$export$8b6bb3dd62a01be2);
$parcel$export(module.exports, "withScope", () => $f04cfbdc3f8db658$export$ec58d9285c204497);
$parcel$export(module.exports, "startTransaction", () => $f04cfbdc3f8db658$export$e262da7ae6480481);

var $jxXLe = parcelRequire("jxXLe");

var $ir14T = parcelRequire("ir14T");
/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f04cfbdc3f8db658$var$callOnHub(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var hub = (0, $ir14T.getCurrentHub)();
    if (hub && hub[method]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return hub[method].apply(hub, (0, $jxXLe.__spread)(args));
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
function $f04cfbdc3f8db658$export$f5282963edea4a68(exception, captureContext) {
    var syntheticException = new Error('Sentry syntheticException');
    return $f04cfbdc3f8db658$var$callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException
    });
}
function $f04cfbdc3f8db658$export$45654777c133ae80(message, captureContext) {
    var syntheticException = new Error(message);
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return $f04cfbdc3f8db658$var$callOnHub('captureMessage', message, level, (0, $jxXLe.__assign)({
        originalException: message,
        syntheticException: syntheticException
    }, context));
}
function $f04cfbdc3f8db658$export$1462b974fdcf6ba2(event) {
    return $f04cfbdc3f8db658$var$callOnHub('captureEvent', event);
}
function $f04cfbdc3f8db658$export$99d44f04437e9cb8(callback) {
    $f04cfbdc3f8db658$var$callOnHub('configureScope', callback);
}
function $f04cfbdc3f8db658$export$efda9a273d7a036d(breadcrumb) {
    $f04cfbdc3f8db658$var$callOnHub('addBreadcrumb', breadcrumb);
}
function $f04cfbdc3f8db658$export$2f04de43fe27971a(name, context) {
    $f04cfbdc3f8db658$var$callOnHub('setContext', name, context);
}
function $f04cfbdc3f8db658$export$bb4922da0dd51b92(extras) {
    $f04cfbdc3f8db658$var$callOnHub('setExtras', extras);
}
function $f04cfbdc3f8db658$export$74a8fb34822092e6(tags) {
    $f04cfbdc3f8db658$var$callOnHub('setTags', tags);
}
function $f04cfbdc3f8db658$export$8e8e7789d42ed61d(key, extra) {
    $f04cfbdc3f8db658$var$callOnHub('setExtra', key, extra);
}
function $f04cfbdc3f8db658$export$a37d07ee78eb4569(key, value) {
    $f04cfbdc3f8db658$var$callOnHub('setTag', key, value);
}
function $f04cfbdc3f8db658$export$8b6bb3dd62a01be2(user) {
    $f04cfbdc3f8db658$var$callOnHub('setUser', user);
}
function $f04cfbdc3f8db658$export$ec58d9285c204497(callback) {
    $f04cfbdc3f8db658$var$callOnHub('withScope', callback);
}
function $f04cfbdc3f8db658$export$5b9bc6fc91daaf9f(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    $f04cfbdc3f8db658$var$callOnHub.apply(void 0, (0, $jxXLe.__spread)([
        '_invokeClient',
        method
    ], args));
}
function $f04cfbdc3f8db658$export$e262da7ae6480481(context, customSamplingContext) {
    return $f04cfbdc3f8db658$var$callOnHub('startTransaction', (0, $jxXLe.__assign)({}, context), customSamplingContext);
}

});
parcelRegister("jxXLe", function(module, exports) {
$parcel$export(module.exports, "__assign", () => $e3af749fec978079$export$18ce0697a983be9b);
$parcel$export(module.exports, "__spread", () => $e3af749fec978079$export$afc72e2116322959);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $e3af749fec978079$var$extendStatics = function(d, b) {
    $e3af749fec978079$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $e3af749fec978079$var$extendStatics(d, b);
};
function $e3af749fec978079$export$a8ba968b8961cb8a(d, b) {
    $e3af749fec978079$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e3af749fec978079$export$18ce0697a983be9b = function() {
    $e3af749fec978079$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e3af749fec978079$export$18ce0697a983be9b.apply(this, arguments);
};
function $e3af749fec978079$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e3af749fec978079$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e3af749fec978079$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e3af749fec978079$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e3af749fec978079$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e3af749fec978079$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $e3af749fec978079$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $e3af749fec978079$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $e3af749fec978079$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e3af749fec978079$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e3af749fec978079$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e3af749fec978079$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e3af749fec978079$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e3af749fec978079$export$10c90e4f7922046c(v) {
    return this instanceof $e3af749fec978079$export$10c90e4f7922046c ? (this.v = v, this) : new $e3af749fec978079$export$10c90e4f7922046c(v);
}
function $e3af749fec978079$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e3af749fec978079$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e3af749fec978079$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e3af749fec978079$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $e3af749fec978079$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e3af749fec978079$export$19a8beecd37a4c45 === "function" ? $e3af749fec978079$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e3af749fec978079$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $e3af749fec978079$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $e3af749fec978079$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e3af749fec978079$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $e3af749fec978079$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("ir14T", function(module, exports) {
$parcel$export(module.exports, "Hub", () => $d6bb95a59bff69df$export$8c41bb232f1008b1);
$parcel$export(module.exports, "makeMain", () => $d6bb95a59bff69df$export$4188a14ad302d1bc);
$parcel$export(module.exports, "getHubFromCarrier", () => $d6bb95a59bff69df$export$bfa8a924a84a76b7);
$parcel$export(module.exports, "getCurrentHub", () => $d6bb95a59bff69df$export$a07cdf6544bbd7c);

var $fClYD = parcelRequire("fClYD");
parcelRequire("i0afJ");
var $1v4ZC = parcelRequire("1v4ZC");
var $chTsM = parcelRequire("chTsM");
var $lrp9R = parcelRequire("lrp9R");
var $dBSRM = parcelRequire("dBSRM");
var $73JtC = parcelRequire("73JtC");

var $dzx2d = parcelRequire("dzx2d");

var $FnrKW = parcelRequire("FnrKW");

var $vfED8 = parcelRequire("vfED8");
var $d6bb95a59bff69df$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var $d6bb95a59bff69df$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ var $d6bb95a59bff69df$export$8c41bb232f1008b1 = /** @class */ function() {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */ function Hub(client, scope, _version) {
        if (scope === void 0) scope = new (0, $FnrKW.Scope)();
        if (_version === void 0) _version = $d6bb95a59bff69df$export$24a86ef7798177e4;
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */ this._stack = [
            {}
        ];
        this.getStackTop().scope = scope;
        if (client) this.bindClient(client);
    }
    /**
     * @inheritDoc
     */ Hub.prototype.isOlderThan = function(version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.bindClient = function(client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.pushScope = function() {
        // We want to clone the content of prev scope
        var scope = (0, $FnrKW.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.popScope = function() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.withScope = function(callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getClient = function() {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */ Hub.prototype.getScope = function() {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */ Hub.prototype.getStack = function() {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */ Hub.prototype.getStackTop = function() {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function(exception, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $73JtC.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureException', exception, (0, $fClYD.__assign)((0, $fClYD.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureMessage = function(message, level, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $73JtC.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureMessage', message, level, (0, $fClYD.__assign)((0, $fClYD.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureEvent = function(event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : (0, $73JtC.uuid4)();
        if (event.type !== 'transaction') this._lastEventId = eventId;
        this._invokeClient('captureEvent', event, (0, $fClYD.__assign)((0, $fClYD.__assign)({}, hint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.lastEventId = function() {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.addBreadcrumb = function(breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client) return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = client.getOptions && client.getOptions() || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? $d6bb95a59bff69df$var$DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0) return;
        var timestamp = (0, $chTsM.dateTimestampInSeconds)();
        var mergedBreadcrumb = (0, $fClYD.__assign)({
            timestamp: timestamp
        }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb ? (0, $1v4ZC.consoleSandbox)(function() {
            return beforeBreadcrumb(mergedBreadcrumb, hint);
        }) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setUser = function(user) {
        var scope = this.getScope();
        if (scope) scope.setUser(user);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTags = function(tags) {
        var scope = this.getScope();
        if (scope) scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtras = function(extras) {
        var scope = this.getScope();
        if (scope) scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTag = function(key, value) {
        var scope = this.getScope();
        if (scope) scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtra = function(key, extra) {
        var scope = this.getScope();
        if (scope) scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function(name, context) {
        var scope = this.getScope();
        if (scope) scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.configureScope = function(callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) callback(scope);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.run = function(callback) {
        var oldHub = $d6bb95a59bff69df$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $d6bb95a59bff69df$export$4188a14ad302d1bc(oldHub);
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getIntegration = function(integration) {
        var client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $dzx2d.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSpan = function(context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startTransaction = function(context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.traceHeaders = function() {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureSession = function(endSession) {
        if (endSession === void 0) endSession = false;
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.endSession = function() {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) session.close();
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) scope.setSession();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSession = function(context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = client && client.getOptions() || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = (0, $lrp9R.getGlobalObject)();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new (0, $vfED8.Session)((0, $fClYD.__assign)((0, $fClYD.__assign)((0, $fClYD.__assign)({
            release: release,
            environment: environment
        }, scope && {
            user: scope.getUser()
        }), userAgent && {
            userAgent: userAgent
        }), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === 'ok') currentSession.update({
                status: 'exited'
            });
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */ Hub.prototype._sendSessionUpdate = function() {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope) return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) client.captureSession(session);
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function(method) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        (_a = client)[method].apply(_a, (0, $fClYD.__spread)(args, [
            scope
        ]));
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var carrier = $d6bb95a59bff69df$export$19eade501500c6c1();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $dzx2d.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}();
function $d6bb95a59bff69df$export$19eade501500c6c1() {
    var carrier = (0, $lrp9R.getGlobalObject)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return carrier;
}
function $d6bb95a59bff69df$export$4188a14ad302d1bc(hub) {
    var registry = $d6bb95a59bff69df$export$19eade501500c6c1();
    var oldHub = $d6bb95a59bff69df$export$bfa8a924a84a76b7(registry);
    $d6bb95a59bff69df$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
function $d6bb95a59bff69df$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    var registry = $d6bb95a59bff69df$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$d6bb95a59bff69df$var$hasHubOnCarrier(registry) || $d6bb95a59bff69df$export$bfa8a924a84a76b7(registry).isOlderThan($d6bb95a59bff69df$export$24a86ef7798177e4)) $d6bb95a59bff69df$export$849f05434e95d2f2(registry, new $d6bb95a59bff69df$export$8c41bb232f1008b1());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, $dBSRM.isNodeEnv)()) return $d6bb95a59bff69df$var$getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return $d6bb95a59bff69df$export$bfa8a924a84a76b7(registry);
}
function $d6bb95a59bff69df$export$1c4d656130202699() {
    (0, $dzx2d.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
    var sentry = $d6bb95a59bff69df$export$19eade501500c6c1().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */ function $d6bb95a59bff69df$var$getHubFromActiveDomain(registry) {
    try {
        var sentry = $d6bb95a59bff69df$export$19eade501500c6c1().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) return $d6bb95a59bff69df$export$bfa8a924a84a76b7(registry);
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!$d6bb95a59bff69df$var$hasHubOnCarrier(activeDomain) || $d6bb95a59bff69df$export$bfa8a924a84a76b7(activeDomain).isOlderThan($d6bb95a59bff69df$export$24a86ef7798177e4)) {
            var registryHubTopStack = $d6bb95a59bff69df$export$bfa8a924a84a76b7(registry).getStackTop();
            $d6bb95a59bff69df$export$849f05434e95d2f2(activeDomain, new $d6bb95a59bff69df$export$8c41bb232f1008b1(registryHubTopStack.client, (0, $FnrKW.Scope).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return $d6bb95a59bff69df$export$bfa8a924a84a76b7(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return $d6bb95a59bff69df$export$bfa8a924a84a76b7(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $d6bb95a59bff69df$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
function $d6bb95a59bff69df$export$bfa8a924a84a76b7(carrier) {
    return (0, $lrp9R.getGlobalSingleton)('hub', function() {
        return new $d6bb95a59bff69df$export$8c41bb232f1008b1();
    }, carrier);
}
function $d6bb95a59bff69df$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("fClYD", function(module, exports) {
$parcel$export(module.exports, "__assign", () => $b5eb73cfb73be12c$export$18ce0697a983be9b);
$parcel$export(module.exports, "__spread", () => $b5eb73cfb73be12c$export$afc72e2116322959);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $b5eb73cfb73be12c$var$extendStatics = function(d, b) {
    $b5eb73cfb73be12c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $b5eb73cfb73be12c$var$extendStatics(d, b);
};
function $b5eb73cfb73be12c$export$a8ba968b8961cb8a(d, b) {
    $b5eb73cfb73be12c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b5eb73cfb73be12c$export$18ce0697a983be9b = function() {
    $b5eb73cfb73be12c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b5eb73cfb73be12c$export$18ce0697a983be9b.apply(this, arguments);
};
function $b5eb73cfb73be12c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b5eb73cfb73be12c$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b5eb73cfb73be12c$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b5eb73cfb73be12c$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b5eb73cfb73be12c$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b5eb73cfb73be12c$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $b5eb73cfb73be12c$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $b5eb73cfb73be12c$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $b5eb73cfb73be12c$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b5eb73cfb73be12c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b5eb73cfb73be12c$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b5eb73cfb73be12c$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b5eb73cfb73be12c$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b5eb73cfb73be12c$export$10c90e4f7922046c(v) {
    return this instanceof $b5eb73cfb73be12c$export$10c90e4f7922046c ? (this.v = v, this) : new $b5eb73cfb73be12c$export$10c90e4f7922046c(v);
}
function $b5eb73cfb73be12c$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b5eb73cfb73be12c$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b5eb73cfb73be12c$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b5eb73cfb73be12c$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $b5eb73cfb73be12c$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b5eb73cfb73be12c$export$19a8beecd37a4c45 === "function" ? $b5eb73cfb73be12c$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b5eb73cfb73be12c$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $b5eb73cfb73be12c$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $b5eb73cfb73be12c$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b5eb73cfb73be12c$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $b5eb73cfb73be12c$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("i0afJ", function(module, exports) {
$parcel$export(module.exports, "forget", () => (parcelRequire("lQOiJ")).forget);
$parcel$export(module.exports, "getLocationHref", () => (parcelRequire("f9iVj")).getLocationHref);
$parcel$export(module.exports, "htmlTreeAsString", () => (parcelRequire("f9iVj")).htmlTreeAsString);
$parcel$export(module.exports, "dsnToString", () => (parcelRequire("62yRy")).dsnToString);
$parcel$export(module.exports, "makeDsn", () => (parcelRequire("62yRy")).makeDsn);
$parcel$export(module.exports, "SentryError", () => (parcelRequire("iMWNA")).SentryError);
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("lrp9R")).getGlobalObject);
$parcel$export(module.exports, "getGlobalSingleton", () => (parcelRequire("lrp9R")).getGlobalSingleton);
$parcel$export(module.exports, "addInstrumentationHandler", () => (parcelRequire("aVmXt")).addInstrumentationHandler);
$parcel$export(module.exports, "isDOMError", () => (parcelRequire("8rX8J")).isDOMError);
$parcel$export(module.exports, "isDOMException", () => (parcelRequire("8rX8J")).isDOMException);
$parcel$export(module.exports, "isError", () => (parcelRequire("8rX8J")).isError);
$parcel$export(module.exports, "isErrorEvent", () => (parcelRequire("8rX8J")).isErrorEvent);
$parcel$export(module.exports, "isEvent", () => (parcelRequire("8rX8J")).isEvent);
$parcel$export(module.exports, "isInstanceOf", () => (parcelRequire("8rX8J")).isInstanceOf);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("8rX8J")).isPlainObject);
$parcel$export(module.exports, "isPrimitive", () => (parcelRequire("8rX8J")).isPrimitive);
$parcel$export(module.exports, "isString", () => (parcelRequire("8rX8J")).isString);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("8rX8J")).isThenable);
$parcel$export(module.exports, "CONSOLE_LEVELS", () => (parcelRequire("1v4ZC")).CONSOLE_LEVELS);
$parcel$export(module.exports, "consoleSandbox", () => (parcelRequire("1v4ZC")).consoleSandbox);
$parcel$export(module.exports, "logger", () => (parcelRequire("1v4ZC")).logger);
$parcel$export(module.exports, "addExceptionMechanism", () => (parcelRequire("73JtC")).addExceptionMechanism);
$parcel$export(module.exports, "addExceptionTypeValue", () => (parcelRequire("73JtC")).addExceptionTypeValue);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => (parcelRequire("73JtC")).checkOrSetAlreadyCaught);
$parcel$export(module.exports, "getEventDescription", () => (parcelRequire("73JtC")).getEventDescription);
$parcel$export(module.exports, "parseUrl", () => (parcelRequire("73JtC")).parseUrl);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("73JtC")).uuid4);
$parcel$export(module.exports, "normalize", () => (parcelRequire("bZWF1")).normalize);
$parcel$export(module.exports, "normalizeToSize", () => (parcelRequire("bZWF1")).normalizeToSize);
$parcel$export(module.exports, "addNonEnumerableProperty", () => (parcelRequire("909Vl")).addNonEnumerableProperty);
$parcel$export(module.exports, "dropUndefinedKeys", () => (parcelRequire("909Vl")).dropUndefinedKeys);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => (parcelRequire("909Vl")).extractExceptionKeysForMessage);
$parcel$export(module.exports, "fill", () => (parcelRequire("909Vl")).fill);
$parcel$export(module.exports, "getOriginalFunction", () => (parcelRequire("909Vl")).getOriginalFunction);
$parcel$export(module.exports, "markFunctionWrapped", () => (parcelRequire("909Vl")).markFunctionWrapped);
$parcel$export(module.exports, "urlEncode", () => (parcelRequire("909Vl")).urlEncode);
$parcel$export(module.exports, "basename", () => (parcelRequire("39Zfw")).basename);
$parcel$export(module.exports, "relative", () => (parcelRequire("39Zfw")).relative);
$parcel$export(module.exports, "makePromiseBuffer", () => (parcelRequire("bUAoW")).makePromiseBuffer);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("kpXMz")).severityFromString);
$parcel$export(module.exports, "createStackParser", () => (parcelRequire("b8srE")).createStackParser);
$parcel$export(module.exports, "getFunctionName", () => (parcelRequire("b8srE")).getFunctionName);
$parcel$export(module.exports, "eventStatusFromHttpCode", () => (parcelRequire("9P6Bi")).eventStatusFromHttpCode);
$parcel$export(module.exports, "isMatchingPattern", () => (parcelRequire("9k3Oz")).isMatchingPattern);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("9k3Oz")).safeJoin);
$parcel$export(module.exports, "truncate", () => (parcelRequire("9k3Oz")).truncate);
$parcel$export(module.exports, "isNativeFetch", () => (parcelRequire("7YVaQ")).isNativeFetch);
$parcel$export(module.exports, "supportsFetch", () => (parcelRequire("7YVaQ")).supportsFetch);
$parcel$export(module.exports, "supportsReferrerPolicy", () => (parcelRequire("7YVaQ")).supportsReferrerPolicy);
$parcel$export(module.exports, "supportsReportingObserver", () => (parcelRequire("7YVaQ")).supportsReportingObserver);
$parcel$export(module.exports, "rejectedSyncPromise", () => (parcelRequire("bdF5c")).rejectedSyncPromise);
$parcel$export(module.exports, "resolvedSyncPromise", () => (parcelRequire("bdF5c")).resolvedSyncPromise);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("bdF5c")).SyncPromise);
$parcel$export(module.exports, "createEnvelope", () => (parcelRequire("9G22S")).createEnvelope);
$parcel$export(module.exports, "getEnvelopeType", () => (parcelRequire("9G22S")).getEnvelopeType);
$parcel$export(module.exports, "serializeEnvelope", () => (parcelRequire("9G22S")).serializeEnvelope);
$parcel$export(module.exports, "createClientReportEnvelope", () => (parcelRequire("diVdC")).createClientReportEnvelope);
$parcel$export(module.exports, "disabledUntil", () => (parcelRequire("etGw0")).disabledUntil);
$parcel$export(module.exports, "isRateLimited", () => (parcelRequire("etGw0")).isRateLimited);
$parcel$export(module.exports, "updateRateLimits", () => (parcelRequire("etGw0")).updateRateLimits);
parcelRequire("lQOiJ");
parcelRequire("f9iVj");
parcelRequire("62yRy");

parcelRequire("iMWNA");
parcelRequire("lrp9R");
parcelRequire("aVmXt");
parcelRequire("8rX8J");
parcelRequire("1v4ZC");

parcelRequire("73JtC");

var $dBSRM = parcelRequire("dBSRM");
parcelRequire("bZWF1");
parcelRequire("909Vl");
parcelRequire("39Zfw");
parcelRequire("bUAoW");
parcelRequire("kpXMz");
parcelRequire("b8srE");
parcelRequire("9P6Bi");
parcelRequire("9k3Oz");
parcelRequire("7YVaQ");
parcelRequire("bdF5c");

var $chTsM = parcelRequire("chTsM");


parcelRequire("9G22S");
parcelRequire("diVdC");
parcelRequire("etGw0");
$parcel$exportWildcard(module.exports, $dBSRM);
$parcel$exportWildcard(module.exports, $chTsM);

});
parcelRegister("lQOiJ", function(module, exports) {
$parcel$export(module.exports, "forget", () => $fe85790f9b07e485$export$93c25f2590a5b540);
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $fe85790f9b07e485$export$93c25f2590a5b540(promise) {
    promise.then(null, function(e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}

});

parcelRegister("f9iVj", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $b076601639d1314e$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $b076601639d1314e$export$1cfafeee2987818b);

var $lrp9R = parcelRequire("lrp9R");

var $8rX8J = parcelRequire("8rX8J");
function $b076601639d1314e$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $b076601639d1314e$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $b076601639d1314e$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $8rX8J.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $b076601639d1314e$export$1cfafeee2987818b() {
    var global = (0, $lrp9R.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});
parcelRegister("lrp9R", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => $f9bfa2789ec923a7$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $f9bfa2789ec923a7$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $dBSRM = parcelRequire("dBSRM");
var $f9bfa2789ec923a7$var$fallbackGlobalObject = {};
function $f9bfa2789ec923a7$export$256479dc0cea61c4() {
    return (0, $dBSRM.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $f9bfa2789ec923a7$var$fallbackGlobalObject;
}
function $f9bfa2789ec923a7$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $f9bfa2789ec923a7$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("dBSRM", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $b8WCc = parcelRequire("b8WCc");

var $3ZMUU = parcelRequire("3ZMUU");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $b8WCc.isBrowserBundle)() && Object.prototype.toString.call(typeof $3ZMUU !== 'undefined' ? $3ZMUU : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("b8WCc", function(module, exports) {
$parcel$export(module.exports, "isBrowserBundle", () => $81cde8cb5e9c669f$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $81cde8cb5e9c669f$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("8rX8J", function(module, exports) {
$parcel$export(module.exports, "isError", () => $626eb84a64d84c41$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $626eb84a64d84c41$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $626eb84a64d84c41$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $626eb84a64d84c41$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $626eb84a64d84c41$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $626eb84a64d84c41$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $626eb84a64d84c41$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $626eb84a64d84c41$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $626eb84a64d84c41$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $626eb84a64d84c41$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $626eb84a64d84c41$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $626eb84a64d84c41$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $626eb84a64d84c41$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $626eb84a64d84c41$export$c9f5652083b8129d);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $626eb84a64d84c41$var$objectToString = Object.prototype.toString;
function $626eb84a64d84c41$export$e6127cc7fe7395c3(wat) {
    switch($626eb84a64d84c41$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $626eb84a64d84c41$export$49034edbe6b62415(wat, Error);
    }
}
function $626eb84a64d84c41$var$isBuiltin(wat, ty) {
    return $626eb84a64d84c41$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $626eb84a64d84c41$export$9f9636d330b71954(wat) {
    return $626eb84a64d84c41$var$isBuiltin(wat, 'ErrorEvent');
}
function $626eb84a64d84c41$export$ef9e2056653f0c8e(wat) {
    return $626eb84a64d84c41$var$isBuiltin(wat, 'DOMError');
}
function $626eb84a64d84c41$export$12e869b2a583f783(wat) {
    return $626eb84a64d84c41$var$isBuiltin(wat, 'DOMException');
}
function $626eb84a64d84c41$export$844ec244b1367d54(wat) {
    return $626eb84a64d84c41$var$isBuiltin(wat, 'String');
}
function $626eb84a64d84c41$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $626eb84a64d84c41$export$53b83ca8eaab0383(wat) {
    return $626eb84a64d84c41$var$isBuiltin(wat, 'Object');
}
function $626eb84a64d84c41$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $626eb84a64d84c41$export$49034edbe6b62415(wat, Event);
}
function $626eb84a64d84c41$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $626eb84a64d84c41$export$49034edbe6b62415(wat, Element);
}
function $626eb84a64d84c41$export$49841c62b9eff15(wat) {
    return $626eb84a64d84c41$var$isBuiltin(wat, 'RegExp');
}
function $626eb84a64d84c41$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $626eb84a64d84c41$export$bc2894c7158efbac(wat) {
    return $626eb84a64d84c41$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $626eb84a64d84c41$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $626eb84a64d84c41$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});


parcelRegister("62yRy", function(module, exports) {
$parcel$export(module.exports, "dsnToString", () => $465df9040833ef74$export$44d472fbb931a776);
$parcel$export(module.exports, "makeDsn", () => $465df9040833ef74$export$128827c3562ec0cb);

var $dT3VW = parcelRequire("dT3VW");

var $iMWNA = parcelRequire("iMWNA");

var $iuc9e = parcelRequire("iuc9e");
/** Regular expression used to parse a Dsn. */ var $465df9040833ef74$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $465df9040833ef74$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
function $465df9040833ef74$export$44d472fbb931a776(dsn, withPassword) {
    if (withPassword === void 0) withPassword = false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') + ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId);
}
function $465df9040833ef74$var$dsnFromString(str) {
    var match = $465df9040833ef74$var$DSN_REGEX.exec(str);
    if (!match) throw new (0, $iMWNA.SentryError)("Invalid Sentry Dsn: " + str);
    var _a = (0, $dT3VW.__read)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $465df9040833ef74$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $465df9040833ef74$var$dsnFromComponents(components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ('user' in components && !('publicKey' in components)) components.publicKey = components.user;
    return {
        user: components.publicKey || '',
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $465df9040833ef74$var$validateDsn(dsn) {
    if (!(0, $iuc9e.IS_DEBUG_BUILD)) return;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    requiredComponents.forEach(function(component) {
        if (!dsn[component]) throw new (0, $iMWNA.SentryError)("Invalid Sentry Dsn: " + component + " missing");
    });
    if (!projectId.match(/^\d+$/)) throw new (0, $iMWNA.SentryError)("Invalid Sentry Dsn: Invalid projectId " + projectId);
    if (!$465df9040833ef74$var$isValidProtocol(protocol)) throw new (0, $iMWNA.SentryError)("Invalid Sentry Dsn: Invalid protocol " + protocol);
    if (port && isNaN(parseInt(port, 10))) throw new (0, $iMWNA.SentryError)("Invalid Sentry Dsn: Invalid port " + port);
    return true;
}
function $465df9040833ef74$export$128827c3562ec0cb(from) {
    var components = typeof from === 'string' ? $465df9040833ef74$var$dsnFromString(from) : $465df9040833ef74$var$dsnFromComponents(from);
    $465df9040833ef74$var$validateDsn(components);
    return components;
}

});
parcelRegister("dT3VW", function(module, exports) {
$parcel$export(module.exports, "__extends", () => $a1c3768bad0ada2b$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $a1c3768bad0ada2b$export$18ce0697a983be9b);
$parcel$export(module.exports, "__values", () => $a1c3768bad0ada2b$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $a1c3768bad0ada2b$export$8d051b38c9118094);
$parcel$export(module.exports, "__spread", () => $a1c3768bad0ada2b$export$afc72e2116322959);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $a1c3768bad0ada2b$var$extendStatics = function(d, b) {
    $a1c3768bad0ada2b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $a1c3768bad0ada2b$var$extendStatics(d, b);
};
function $a1c3768bad0ada2b$export$a8ba968b8961cb8a(d, b) {
    $a1c3768bad0ada2b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a1c3768bad0ada2b$export$18ce0697a983be9b = function() {
    $a1c3768bad0ada2b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a1c3768bad0ada2b$export$18ce0697a983be9b.apply(this, arguments);
};
function $a1c3768bad0ada2b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a1c3768bad0ada2b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a1c3768bad0ada2b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a1c3768bad0ada2b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a1c3768bad0ada2b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a1c3768bad0ada2b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $a1c3768bad0ada2b$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $a1c3768bad0ada2b$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $a1c3768bad0ada2b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a1c3768bad0ada2b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a1c3768bad0ada2b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a1c3768bad0ada2b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a1c3768bad0ada2b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a1c3768bad0ada2b$export$10c90e4f7922046c(v) {
    return this instanceof $a1c3768bad0ada2b$export$10c90e4f7922046c ? (this.v = v, this) : new $a1c3768bad0ada2b$export$10c90e4f7922046c(v);
}
function $a1c3768bad0ada2b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a1c3768bad0ada2b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a1c3768bad0ada2b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a1c3768bad0ada2b$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $a1c3768bad0ada2b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a1c3768bad0ada2b$export$19a8beecd37a4c45 === "function" ? $a1c3768bad0ada2b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a1c3768bad0ada2b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $a1c3768bad0ada2b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $a1c3768bad0ada2b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a1c3768bad0ada2b$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $a1c3768bad0ada2b$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("iMWNA", function(module, exports) {
$parcel$export(module.exports, "SentryError", () => $dada51e7b2168637$export$5949942ba2a7c0e2);

var $dT3VW = parcelRequire("dT3VW");

var $aN905 = parcelRequire("aN905");
/** An error emitted by Sentry SDKs and related utilities. */ var $dada51e7b2168637$export$5949942ba2a7c0e2 = /** @class */ function(_super) {
    (0, $dT3VW.__extends)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        (0, $aN905.setPrototypeOf)(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error);

});
parcelRegister("aN905", function(module, exports) {
$parcel$export(module.exports, "setPrototypeOf", () => $7db57640fe0b53a7$export$1cb0d91350beb6cc);
var $7db57640fe0b53a7$export$1cb0d91350beb6cc = Object.setPrototypeOf || (({
    __proto__: []
}) instanceof Array ? $7db57640fe0b53a7$var$setProtoOf : $7db57640fe0b53a7$var$mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $7db57640fe0b53a7$var$setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $7db57640fe0b53a7$var$mixinProperties(obj, proto) {
    for(var prop in proto)if (!Object.prototype.hasOwnProperty.call(obj, prop)) // @ts-ignore typescript complains about indexing so we remove
    obj[prop] = proto[prop];
    return obj;
}

});


parcelRegister("iuc9e", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $d75473a211326e79$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $d75473a211326e79$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("aVmXt", function(module, exports) {
$parcel$export(module.exports, "addInstrumentationHandler", () => $7f41094ed33359b4$export$285b9172a3741fb7);

var $dT3VW = parcelRequire("dT3VW");

var $iuc9e = parcelRequire("iuc9e");

var $lrp9R = parcelRequire("lrp9R");

var $8rX8J = parcelRequire("8rX8J");

var $1v4ZC = parcelRequire("1v4ZC");

var $909Vl = parcelRequire("909Vl");

var $b8srE = parcelRequire("b8srE");

var $7YVaQ = parcelRequire("7YVaQ");
var $7f41094ed33359b4$var$global = (0, $lrp9R.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ var $7f41094ed33359b4$var$handlers = {};
var $7f41094ed33359b4$var$instrumented = {};
/** Instruments given API */ function $7f41094ed33359b4$var$instrument(type) {
    if ($7f41094ed33359b4$var$instrumented[type]) return;
    $7f41094ed33359b4$var$instrumented[type] = true;
    switch(type){
        case 'console':
            $7f41094ed33359b4$var$instrumentConsole();
            break;
        case 'dom':
            $7f41094ed33359b4$var$instrumentDOM();
            break;
        case 'xhr':
            $7f41094ed33359b4$var$instrumentXHR();
            break;
        case 'fetch':
            $7f41094ed33359b4$var$instrumentFetch();
            break;
        case 'history':
            $7f41094ed33359b4$var$instrumentHistory();
            break;
        case 'error':
            $7f41094ed33359b4$var$instrumentError();
            break;
        case 'unhandledrejection':
            $7f41094ed33359b4$var$instrumentUnhandledRejection();
            break;
        default:
            (0, $iuc9e.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn('unknown instrumentation type:', type);
            return;
    }
}
function $7f41094ed33359b4$export$285b9172a3741fb7(type, callback) {
    $7f41094ed33359b4$var$handlers[type] = $7f41094ed33359b4$var$handlers[type] || [];
    $7f41094ed33359b4$var$handlers[type].push(callback);
    $7f41094ed33359b4$var$instrument(type);
}
/** JSDoc */ function $7f41094ed33359b4$var$triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !$7f41094ed33359b4$var$handlers[type]) return;
    try {
        for(var _b = (0, $dT3VW.__values)($7f41094ed33359b4$var$handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()){
            var handler = _c.value;
            try {
                handler(data);
            } catch (e) {
                (0, $iuc9e.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0, $b8srE.getFunctionName)(handler) + "\nError:", e);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/** JSDoc */ function $7f41094ed33359b4$var$instrumentConsole() {
    if (!('console' in $7f41094ed33359b4$var$global)) return;
    (0, $1v4ZC.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in $7f41094ed33359b4$var$global.console)) return;
        (0, $909Vl.fill)($7f41094ed33359b4$var$global.console, level, function(originalConsoleMethod) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                $7f41094ed33359b4$var$triggerHandlers('console', {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($7f41094ed33359b4$var$global.console, args);
            };
        });
    });
}
/** JSDoc */ function $7f41094ed33359b4$var$instrumentFetch() {
    if (!(0, $7YVaQ.supportsNativeFetch)()) return;
    (0, $909Vl.fill)($7f41094ed33359b4$var$global, 'fetch', function(originalFetch) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var handlerData = {
                args: args,
                fetchData: {
                    method: $7f41094ed33359b4$var$getFetchMethod(args),
                    url: $7f41094ed33359b4$var$getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            $7f41094ed33359b4$var$triggerHandlers('fetch', (0, $dT3VW.__assign)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($7f41094ed33359b4$var$global, args).then(function(response) {
                $7f41094ed33359b4$var$triggerHandlers('fetch', (0, $dT3VW.__assign)((0, $dT3VW.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                }));
                return response;
            }, function(error) {
                $7f41094ed33359b4$var$triggerHandlers('fetch', (0, $dT3VW.__assign)((0, $dT3VW.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Extract `method` from fetch call arguments */ function $7f41094ed33359b4$var$getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if ('Request' in $7f41094ed33359b4$var$global && (0, $8rX8J.isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return 'GET';
}
/** Extract `url` from fetch call arguments */ function $7f41094ed33359b4$var$getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if (typeof fetchArgs[0] === 'string') return fetchArgs[0];
    if ('Request' in $7f41094ed33359b4$var$global && (0, $8rX8J.isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */ /** JSDoc */ function $7f41094ed33359b4$var$instrumentXHR() {
    if (!('XMLHttpRequest' in $7f41094ed33359b4$var$global)) return;
    var xhrproto = XMLHttpRequest.prototype;
    (0, $909Vl.fill)(xhrproto, 'open', function(originalOpen) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $8rX8J.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $8rX8J.isString)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    $7f41094ed33359b4$var$triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') (0, $909Vl.fill)(xhr, 'onreadystatechange', function(original) {
                return function() {
                    var readyStateArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)readyStateArgs[_i] = arguments[_i];
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, $909Vl.fill)(xhrproto, 'send', function(originalSend) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
            $7f41094ed33359b4$var$triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
var $7f41094ed33359b4$var$lastHref;
/** JSDoc */ function $7f41094ed33359b4$var$instrumentHistory() {
    if (!(0, $7YVaQ.supportsHistory)()) return;
    var oldOnPopState = $7f41094ed33359b4$var$global.onpopstate;
    $7f41094ed33359b4$var$global.onpopstate = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var to = $7f41094ed33359b4$var$global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = $7f41094ed33359b4$var$lastHref;
        $7f41094ed33359b4$var$lastHref = to;
        $7f41094ed33359b4$var$triggerHandlers('history', {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = $7f41094ed33359b4$var$lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $7f41094ed33359b4$var$lastHref = to;
                $7f41094ed33359b4$var$triggerHandlers('history', {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $909Vl.fill)($7f41094ed33359b4$var$global.history, 'pushState', historyReplacementFunction);
    (0, $909Vl.fill)($7f41094ed33359b4$var$global.history, 'replaceState', historyReplacementFunction);
}
var $7f41094ed33359b4$var$debounceDuration = 1000;
var $7f41094ed33359b4$var$debounceTimerID;
var $7f41094ed33359b4$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $7f41094ed33359b4$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $7f41094ed33359b4$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') return false;
    try {
        var target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $7f41094ed33359b4$var$makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) globalListener = false;
    return function(event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $7f41094ed33359b4$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($7f41094ed33359b4$var$shouldSkipDOMEvent(event)) return;
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($7f41094ed33359b4$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $7f41094ed33359b4$var$lastCapturedEvent = event;
        } else if ($7f41094ed33359b4$var$shouldShortcircuitPreviousDebounce($7f41094ed33359b4$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $7f41094ed33359b4$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($7f41094ed33359b4$var$debounceTimerID);
        $7f41094ed33359b4$var$debounceTimerID = $7f41094ed33359b4$var$global.setTimeout(function() {
            $7f41094ed33359b4$var$debounceTimerID = undefined;
        }, $7f41094ed33359b4$var$debounceDuration);
    };
}
/** JSDoc */ function $7f41094ed33359b4$var$instrumentDOM() {
    if (!('document' in $7f41094ed33359b4$var$global)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = $7f41094ed33359b4$var$triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = $7f41094ed33359b4$var$makeDOMEventHandler(triggerDOMHandler, true);
    $7f41094ed33359b4$var$global.document.addEventListener('click', globalDOMEventHandler, false);
    $7f41094ed33359b4$var$global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach(function(target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = $7f41094ed33359b4$var$global[target] && $7f41094ed33359b4$var$global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $909Vl.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_1 = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_1[type] = handlers_1[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        var handler = $7f41094ed33359b4$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount += 1;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $909Vl.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_2[type];
                    if (handlerForType) {
                        handlerForType.refCount -= 1;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers_2).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var $7f41094ed33359b4$var$_oldOnErrorHandler = null;
/** JSDoc */ function $7f41094ed33359b4$var$instrumentError() {
    $7f41094ed33359b4$var$_oldOnErrorHandler = $7f41094ed33359b4$var$global.onerror;
    $7f41094ed33359b4$var$global.onerror = function(msg, url, line, column, error) {
        $7f41094ed33359b4$var$triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($7f41094ed33359b4$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $7f41094ed33359b4$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
var $7f41094ed33359b4$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $7f41094ed33359b4$var$instrumentUnhandledRejection() {
    $7f41094ed33359b4$var$_oldOnUnhandledRejectionHandler = $7f41094ed33359b4$var$global.onunhandledrejection;
    $7f41094ed33359b4$var$global.onunhandledrejection = function(e) {
        $7f41094ed33359b4$var$triggerHandlers('unhandledrejection', e);
        if ($7f41094ed33359b4$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $7f41094ed33359b4$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
}

});
parcelRegister("1v4ZC", function(module, exports) {
$parcel$export(module.exports, "CONSOLE_LEVELS", () => $117c8f31aa65bddd$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "consoleSandbox", () => $117c8f31aa65bddd$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $117c8f31aa65bddd$export$af88d00dbe7f521);

var $dT3VW = parcelRequire("dT3VW");

var $iuc9e = parcelRequire("iuc9e");

var $lrp9R = parcelRequire("lrp9R");
// TODO: Implement different loggers for different environments
var $117c8f31aa65bddd$var$global = (0, $lrp9R.getGlobalObject)();
/** Prefix for logging strings */ var $117c8f31aa65bddd$var$PREFIX = 'Sentry Logger ';
var $117c8f31aa65bddd$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $117c8f31aa65bddd$export$cda52e2a8927a2ca(callback) {
    var global = (0, $lrp9R.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $117c8f31aa65bddd$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $117c8f31aa65bddd$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $iuc9e.IS_DEBUG_BUILD) $117c8f31aa65bddd$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $117c8f31aa65bddd$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $117c8f31aa65bddd$var$global.console)[name].apply(_a, (0, $dT3VW.__spread)([
                    $117c8f31aa65bddd$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $117c8f31aa65bddd$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $117c8f31aa65bddd$export$af88d00dbe7f521;
if (0, $iuc9e.IS_DEBUG_BUILD) $117c8f31aa65bddd$export$af88d00dbe7f521 = (0, $lrp9R.getGlobalSingleton)('logger', $117c8f31aa65bddd$var$makeLogger);
else $117c8f31aa65bddd$export$af88d00dbe7f521 = $117c8f31aa65bddd$var$makeLogger();

});

parcelRegister("909Vl", function(module, exports) {
$parcel$export(module.exports, "fill", () => $68dbcfd11e00a6d4$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $68dbcfd11e00a6d4$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $68dbcfd11e00a6d4$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $68dbcfd11e00a6d4$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $68dbcfd11e00a6d4$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $68dbcfd11e00a6d4$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $68dbcfd11e00a6d4$export$b0244d5063c0b61b);
$parcel$export(module.exports, "dropUndefinedKeys", () => $68dbcfd11e00a6d4$export$d25f2688db1bb433);

var $dT3VW = parcelRequire("dT3VW");

var $f9iVj = parcelRequire("f9iVj");

var $8rX8J = parcelRequire("8rX8J");

var $9k3Oz = parcelRequire("9k3Oz");
function $68dbcfd11e00a6d4$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $68dbcfd11e00a6d4$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $68dbcfd11e00a6d4$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $68dbcfd11e00a6d4$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $68dbcfd11e00a6d4$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $68dbcfd11e00a6d4$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $68dbcfd11e00a6d4$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $68dbcfd11e00a6d4$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $8rX8J.isError)(value)) newObj = (0, $dT3VW.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $68dbcfd11e00a6d4$var$getOwnProperties(value));
    else if ((0, $8rX8J.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $dT3VW.__assign)({
            type: event_1.type,
            target: $68dbcfd11e00a6d4$var$serializeEventTarget(event_1.target),
            currentTarget: $68dbcfd11e00a6d4$var$serializeEventTarget(event_1.currentTarget)
        }, $68dbcfd11e00a6d4$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $8rX8J.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $68dbcfd11e00a6d4$var$serializeEventTarget(target) {
    try {
        return (0, $8rX8J.isElement)(target) ? (0, $f9iVj.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $68dbcfd11e00a6d4$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $68dbcfd11e00a6d4$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($68dbcfd11e00a6d4$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $9k3Oz.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $9k3Oz.truncate)(serialized, maxLength);
    }
    return '';
}
function $68dbcfd11e00a6d4$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $8rX8J.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $dT3VW.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $68dbcfd11e00a6d4$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($68dbcfd11e00a6d4$export$d25f2688db1bb433);
    return val;
}
function $68dbcfd11e00a6d4$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $8rX8J.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("9k3Oz", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $6c98f0cd61ae7fe0$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $6c98f0cd61ae7fe0$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $6c98f0cd61ae7fe0$export$465e9d514283d4fd);
$parcel$export(module.exports, "isMatchingPattern", () => $6c98f0cd61ae7fe0$export$cdded5b28a5f8c6d);

var $8rX8J = parcelRequire("8rX8J");
function $6c98f0cd61ae7fe0$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $6c98f0cd61ae7fe0$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $6c98f0cd61ae7fe0$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $6c98f0cd61ae7fe0$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $8rX8J.isString)(value)) return false;
    if ((0, $8rX8J.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $6c98f0cd61ae7fe0$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});


parcelRegister("b8srE", function(module, exports) {
$parcel$export(module.exports, "createStackParser", () => $81b681a083912fb6$export$a5739666fb2d03d4);
$parcel$export(module.exports, "getFunctionName", () => $81b681a083912fb6$export$aad197c7121a6651);

var $dT3VW = parcelRequire("dT3VW");
var $81b681a083912fb6$var$STACKTRACE_LIMIT = 50;
function $81b681a083912fb6$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $dT3VW.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $dT3VW.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $81b681a083912fb6$export$c55c24c0eeba0205(frames);
    };
}
function $81b681a083912fb6$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $81b681a083912fb6$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $dT3VW.__assign)((0, $dT3VW.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $81b681a083912fb6$var$defaultFunctionName = '<anonymous>';
function $81b681a083912fb6$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $81b681a083912fb6$var$defaultFunctionName;
        return fn.name || $81b681a083912fb6$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $81b681a083912fb6$var$defaultFunctionName;
    }
}

});

parcelRegister("7YVaQ", function(module, exports) {
$parcel$export(module.exports, "supportsFetch", () => $5cfa7c881be62025$export$edf3cb81fd7d2a3e);
$parcel$export(module.exports, "isNativeFetch", () => $5cfa7c881be62025$export$18cf36ed71d733e7);
$parcel$export(module.exports, "supportsNativeFetch", () => $5cfa7c881be62025$export$c82d238e23c40b21);
$parcel$export(module.exports, "supportsReportingObserver", () => $5cfa7c881be62025$export$531055a6c684a70a);
$parcel$export(module.exports, "supportsReferrerPolicy", () => $5cfa7c881be62025$export$2d308b428295192f);
$parcel$export(module.exports, "supportsHistory", () => $5cfa7c881be62025$export$67fc34576016d6ec);

var $iuc9e = parcelRequire("iuc9e");

var $lrp9R = parcelRequire("lrp9R");

var $1v4ZC = parcelRequire("1v4ZC");
function $5cfa7c881be62025$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
function $5cfa7c881be62025$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
function $5cfa7c881be62025$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
function $5cfa7c881be62025$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in (0, $lrp9R.getGlobalObject)())) return false;
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function $5cfa7c881be62025$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $5cfa7c881be62025$export$c82d238e23c40b21() {
    if (!$5cfa7c881be62025$export$edf3cb81fd7d2a3e()) return false;
    var global = (0, $lrp9R.getGlobalObject)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($5cfa7c881be62025$export$18cf36ed71d733e7(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $5cfa7c881be62025$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $iuc9e.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
function $5cfa7c881be62025$export$531055a6c684a70a() {
    return 'ReportingObserver' in (0, $lrp9R.getGlobalObject)();
}
function $5cfa7c881be62025$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$5cfa7c881be62025$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}
function $5cfa7c881be62025$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, $lrp9R.getGlobalObject)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRegister("73JtC", function(module, exports) {
$parcel$export(module.exports, "uuid4", () => $523c16f3b9d02706$export$19f53698e68b2496);
$parcel$export(module.exports, "parseUrl", () => $523c16f3b9d02706$export$7a5253c0f62e0150);
$parcel$export(module.exports, "getEventDescription", () => $523c16f3b9d02706$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $523c16f3b9d02706$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $523c16f3b9d02706$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $523c16f3b9d02706$export$6de4ffac6a2f1098);

var $dT3VW = parcelRequire("dT3VW");

var $lrp9R = parcelRequire("lrp9R");

var $909Vl = parcelRequire("909Vl");

var $9k3Oz = parcelRequire("9k3Oz");
function $523c16f3b9d02706$export$19f53698e68b2496() {
    var global = (0, $lrp9R.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $523c16f3b9d02706$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $523c16f3b9d02706$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $523c16f3b9d02706$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $523c16f3b9d02706$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $523c16f3b9d02706$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $523c16f3b9d02706$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $523c16f3b9d02706$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $dT3VW.__assign)((0, $dT3VW.__assign)((0, $dT3VW.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $dT3VW.__assign)((0, $dT3VW.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $523c16f3b9d02706$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $523c16f3b9d02706$export$d364f2020ab30578(input) {
    var match = input.match($523c16f3b9d02706$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $523c16f3b9d02706$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $9k3Oz.snipLine)(line, 0);
    });
    frame.context_line = (0, $9k3Oz.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $9k3Oz.snipLine)(line, 0);
    });
}
function $523c16f3b9d02706$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $523c16f3b9d02706$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $909Vl.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});

parcelRegister("bZWF1", function(module, exports) {
$parcel$export(module.exports, "normalize", () => $8bc2e4fa750aec36$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $8bc2e4fa750aec36$export$23fbbb20bed71033);

var $dT3VW = parcelRequire("dT3VW");

var $8rX8J = parcelRequire("8rX8J");

var $6ncOC = parcelRequire("6ncOC");

var $909Vl = parcelRequire("909Vl");

var $b8srE = parcelRequire("b8srE");
function $8bc2e4fa750aec36$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $8bc2e4fa750aec36$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $8bc2e4fa750aec36$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $8bc2e4fa750aec36$export$a3295358bff77e(object, depth);
    if ($8bc2e4fa750aec36$var$jsonSize(normalized) > maxSize) return $8bc2e4fa750aec36$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $8bc2e4fa750aec36$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $6ncOC.memoBuilder)();
    var _a = (0, $dT3VW.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $8rX8J.isNaN)(value)) return value;
    var stringified = $8bc2e4fa750aec36$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $8rX8J.isError)(value) || (0, $8rX8J.isEvent)(value) ? (0, $909Vl.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $8bc2e4fa750aec36$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $8bc2e4fa750aec36$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $8rX8J.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $b8srE.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $8bc2e4fa750aec36$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $8bc2e4fa750aec36$var$jsonSize(value) {
    return $8bc2e4fa750aec36$var$utf8Length(JSON.stringify(value));
}

});
parcelRegister("6ncOC", function(module, exports) {
$parcel$export(module.exports, "memoBuilder", () => $4a3ed4eafd8f719a$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $4a3ed4eafd8f719a$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});


parcelRegister("39Zfw", function(module, exports) {
$parcel$export(module.exports, "relative", () => $24d1b93b84f78f43$export$f0e7d1106eeabbe6);
$parcel$export(module.exports, "basename", () => $24d1b93b84f78f43$export$9bf319d8f74f51d1);
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
/** JSDoc */ function $24d1b93b84f78f43$var$normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = parts.length - 1; i >= 0; i--){
        var last = parts[i];
        if (last === '.') parts.splice(i, 1);
        else if (last === '..') {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up++;
        } else if (up) {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) // eslint-disable-next-line no-plusplus
    for(; up--; up)parts.unshift('..');
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var $24d1b93b84f78f43$var$splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
/** JSDoc */ function $24d1b93b84f78f43$var$splitPath(filename) {
    var parts = $24d1b93b84f78f43$var$splitPathRe.exec(filename);
    return parts ? parts.slice(1) : [];
}
function $24d1b93b84f78f43$export$f7ad0328861e2f03() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var resolvedPath = '';
    var resolvedAbsolute = false;
    for(var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        var path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) continue;
        resolvedPath = path + "/" + resolvedPath;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = $24d1b93b84f78f43$var$normalizeArray(resolvedPath.split('/').filter(function(p) {
        return !!p;
    }), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */ function $24d1b93b84f78f43$var$trim(arr) {
    var start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== '') break;
    }
    var end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== '') break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
function $24d1b93b84f78f43$export$f0e7d1106eeabbe6(from, to) {
    /* eslint-disable no-param-reassign */ from = $24d1b93b84f78f43$export$f7ad0328861e2f03(from).substr(1);
    to = $24d1b93b84f78f43$export$f7ad0328861e2f03(to).substr(1);
    /* eslint-enable no-param-reassign */ var fromParts = $24d1b93b84f78f43$var$trim(from.split('/'));
    var toParts = $24d1b93b84f78f43$var$trim(to.split('/'));
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for(var i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    var outputParts = [];
    for(var i = samePartsLength; i < fromParts.length; i++)outputParts.push('..');
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
function $24d1b93b84f78f43$export$6af368f973c74c5(path) {
    var isPathAbsolute = $24d1b93b84f78f43$export$e434c7255acda994(path);
    var trailingSlash = path.substr(-1) === '/';
    // Normalize the path
    var normalizedPath = $24d1b93b84f78f43$var$normalizeArray(path.split('/').filter(function(p) {
        return !!p;
    }), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) normalizedPath = '.';
    if (normalizedPath && trailingSlash) normalizedPath += '/';
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
function $24d1b93b84f78f43$export$e434c7255acda994(path) {
    return path.charAt(0) === '/';
}
function $24d1b93b84f78f43$export$f7e2c8231c57a8bd() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $24d1b93b84f78f43$export$6af368f973c74c5(args.join('/'));
}
function $24d1b93b84f78f43$export$7f7b8152cc673abe(path) {
    var result = $24d1b93b84f78f43$var$splitPath(path);
    var root = result[0];
    var dir = result[1];
    if (!root && !dir) // No dirname whatsoever
    return '.';
    if (dir) // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
    return root + dir;
}
function $24d1b93b84f78f43$export$9bf319d8f74f51d1(path, ext) {
    var f = $24d1b93b84f78f43$var$splitPath(path)[2];
    if (ext && f.substr(ext.length * -1) === ext) f = f.substr(0, f.length - ext.length);
    return f;
}

});

parcelRegister("bUAoW", function(module, exports) {
$parcel$export(module.exports, "makePromiseBuffer", () => $8ac12939fa13e8f5$export$85a4f67f852183e6);

var $iMWNA = parcelRequire("iMWNA");

var $bdF5c = parcelRequire("bdF5c");
function $8ac12939fa13e8f5$export$85a4f67f852183e6(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */ function add(taskProducer) {
        if (!isReady()) return (0, $bdF5c.rejectedSyncPromise)(new (0, $iMWNA.SentryError)('Not adding Promise due to buffer limit reached.'));
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(function() {
            return remove(task);
        })// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, function() {
            return remove(task).then(null, function() {
            // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */ function drain(timeout) {
        return new (0, $bdF5c.SyncPromise)(function(resolve, reject) {
            var counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function(item) {
                (0, $bdF5c.resolvedSyncPromise)(item).then(function() {
                    // eslint-disable-next-line no-plusplus
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});
parcelRegister("bdF5c", function(module, exports) {
$parcel$export(module.exports, "resolvedSyncPromise", () => $82b0c6d0fe80f282$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $82b0c6d0fe80f282$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $82b0c6d0fe80f282$export$78e43115b553f358);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $8rX8J = parcelRequire("8rX8J");
function $82b0c6d0fe80f282$export$1fda8aa4d135f8aa(value) {
    return new $82b0c6d0fe80f282$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $82b0c6d0fe80f282$export$78e43115b553f358(reason) {
    return new $82b0c6d0fe80f282$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $82b0c6d0fe80f282$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $8rX8J.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});


parcelRegister("kpXMz", function(module, exports) {
$parcel$export(module.exports, "severityFromString", () => $edd483f6e1ec83f5$export$e01cef29b4327697);

var $iYYET = parcelRequire("iYYET");

var $jf6CL = parcelRequire("jf6CL");
function $edd483f6e1ec83f5$var$isSupportedSeverity(level) {
    return (0, $jf6CL.SeverityLevels).indexOf(level) !== -1;
}
function $edd483f6e1ec83f5$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $iYYET.Severity).Warning;
    if ($edd483f6e1ec83f5$var$isSupportedSeverity(level)) return level;
    return (0, $iYYET.Severity).Log;
}

});
parcelRegister("jf6CL", function(module, exports) {
$parcel$export(module.exports, "SeverityLevels", () => $e0248e759d5a0186$export$484b1ea9aec914c);
var $e0248e759d5a0186$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});


parcelRegister("9P6Bi", function(module, exports) {
$parcel$export(module.exports, "eventStatusFromHttpCode", () => $726dff3bf31be795$export$82713360d763c449);
/**
 * Converts an HTTP status code to sentry status {@link EventStatus}.
 *
 * @param code number HTTP status code
 * @returns EventStatus
 */ function $726dff3bf31be795$export$82713360d763c449(code) {
    if (code >= 200 && code < 300) return 'success';
    if (code === 429) return 'rate_limit';
    if (code >= 400 && code < 500) return 'invalid';
    if (code >= 500) return 'failed';
    return 'unknown';
}

});

parcelRegister("chTsM", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);
$parcel$export(module.exports, "timestampInSeconds", () => timestampInSeconds, (v) => timestampInSeconds = v);
$parcel$export(module.exports, "timestampWithMs", () => timestampWithMs, (v) => timestampWithMs = v);

var $lrp9R = parcelRequire("lrp9R");

var $dBSRM = parcelRequire("dBSRM");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $lrp9R.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $dBSRM.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $dBSRM.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $lrp9R.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});

parcelRegister("9G22S", function(module, exports) {
$parcel$export(module.exports, "createEnvelope", () => $70b99f77072cf559$export$f93f7f385160c44e);
$parcel$export(module.exports, "getEnvelopeType", () => $70b99f77072cf559$export$d84939284bbafcd4);
$parcel$export(module.exports, "serializeEnvelope", () => $70b99f77072cf559$export$32f9b428425aac85);

var $dT3VW = parcelRequire("dT3VW");

var $8rX8J = parcelRequire("8rX8J");
function $70b99f77072cf559$export$f93f7f385160c44e(headers, items) {
    if (items === void 0) items = [];
    return [
        headers,
        items
    ];
}
function $70b99f77072cf559$export$d650323442802f6f(envelope, newItem) {
    var _a = (0, $dT3VW.__read)(envelope, 2), headers = _a[0], items = _a[1];
    return [
        headers,
        (0, $dT3VW.__spread)(items, [
            newItem
        ])
    ];
}
function $70b99f77072cf559$export$d84939284bbafcd4(envelope) {
    var _a = (0, $dT3VW.__read)(envelope, 2), _b = (0, $dT3VW.__read)(_a[1], 1), _c = (0, $dT3VW.__read)(_b[0], 1), firstItemHeader = _c[0];
    return firstItemHeader.type;
}
function $70b99f77072cf559$export$32f9b428425aac85(envelope) {
    var _a = (0, $dT3VW.__read)(envelope, 2), headers = _a[0], items = _a[1];
    var serializedHeaders = JSON.stringify(headers);
    // Have to cast items to any here since Envelope is a union type
    // Fixed in Typescript 4.2
    // TODO: Remove any[] cast when we upgrade to TS 4.2
    // https://github.com/microsoft/TypeScript/issues/36390
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return items.reduce(function(acc, item) {
        var _a = (0, $dT3VW.__read)(item, 2), itemHeaders = _a[0], payload = _a[1];
        // We do not serialize payloads that are primitives
        var serializedPayload = (0, $8rX8J.isPrimitive)(payload) ? String(payload) : JSON.stringify(payload);
        return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
    }, serializedHeaders);
}

});

parcelRegister("diVdC", function(module, exports) {
$parcel$export(module.exports, "createClientReportEnvelope", () => $9af9573e0ba8bc4b$export$f3b9ed77c03eeb00);

var $9G22S = parcelRequire("9G22S");

var $chTsM = parcelRequire("chTsM");
function $9af9573e0ba8bc4b$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $chTsM.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $9G22S.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("etGw0", function(module, exports) {
$parcel$export(module.exports, "disabledUntil", () => $a8a4c0c2698a0fad$export$b89fc7b2e4c799e7);
$parcel$export(module.exports, "isRateLimited", () => $a8a4c0c2698a0fad$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $a8a4c0c2698a0fad$export$699aff705e0d49d4);

var $dT3VW = parcelRequire("dT3VW");
var $a8a4c0c2698a0fad$export$b09ce39faaeb1e7c = 60000; // 60 seconds
function $a8a4c0c2698a0fad$export$615352e17ed7741(header, now) {
    if (now === void 0) now = Date.now();
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) return headerDate - now;
    return $a8a4c0c2698a0fad$export$b09ce39faaeb1e7c;
}
function $a8a4c0c2698a0fad$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
function $a8a4c0c2698a0fad$export$6c91fec22056810a(limits, category, now) {
    if (now === void 0) now = Date.now();
    return $a8a4c0c2698a0fad$export$b89fc7b2e4c799e7(limits, category) > now;
}
function $a8a4c0c2698a0fad$export$699aff705e0d49d4(limits, headers, now) {
    var e_1, _a, e_2, _b;
    if (now === void 0) now = Date.now();
    var updatedRateLimits = (0, $dT3VW.__assign)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers['retry-after'];
    if (rateLimitHeader) try {
        /**
             * rate limit headers are of the form
             *     <header>,<header>,..
             * where each <header> is of the form
             *     <retry_after>: <categories>: <scope>: <reason_code>
             * where
             *     <retry_after> is a delay in seconds
             *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
             *         <category>;<category>;...
             *     <scope> is what's being limited (org, project, or key) - ignored by SDK
             *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
             */ for(var _c = (0, $dT3VW.__values)(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()){
            var limit = _d.value;
            var parameters = limit.split(':', 2);
            var headerDelay = parseInt(parameters[0], 10);
            var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
            if (!parameters[1]) updatedRateLimits.all = now + delay;
            else try {
                for(var _e = (e_2 = void 0, (0, $dT3VW.__values)(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()){
                    var category = _f.value;
                    updatedRateLimits[category] = now + delay;
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $a8a4c0c2698a0fad$export$615352e17ed7741(retryAfterHeader, now);
    return updatedRateLimits;
}

});


parcelRegister("dzx2d", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $9e182b40f0733892$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $9e182b40f0733892$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("FnrKW", function(module, exports) {
$parcel$export(module.exports, "Scope", () => $07c60478cbfa65e0$export$775b6bb06e53a214);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $07c60478cbfa65e0$export$8e4e25f54d456511);

var $fClYD = parcelRequire("fClYD");
parcelRequire("i0afJ");
var $chTsM = parcelRequire("chTsM");
var $lrp9R = parcelRequire("lrp9R");
var $8rX8J = parcelRequire("8rX8J");
var $bdF5c = parcelRequire("bdF5c");
/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */ var $07c60478cbfa65e0$var$MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var $07c60478cbfa65e0$export$775b6bb06e53a214 = /** @class */ function() {
    function Scope() {
        /** Flag if notifying is happening. */ this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */ this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */ this._eventProcessors = [];
        /** Array of breadcrumbs. */ this._breadcrumbs = [];
        /** User */ this._user = {};
        /** Tags */ this._tags = {};
        /** Extra */ this._extra = {};
        /** Contexts */ this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */ this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */ Scope.clone = function(scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0, $fClYD.__spread)(scope._breadcrumbs);
            newScope._tags = (0, $fClYD.__assign)({}, scope._tags);
            newScope._extra = (0, $fClYD.__assign)({}, scope._extra);
            newScope._contexts = (0, $fClYD.__assign)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0, $fClYD.__spread)(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */ Scope.prototype.addScopeListener = function(callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addEventProcessor = function(callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setUser = function(user) {
        this._user = user || {};
        if (this._session) this._session.update({
            user: user
        });
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getUser = function() {
        return this._user;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getRequestSession = function() {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setRequestSession = function(requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTags = function(tags) {
        this._tags = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTag = function(key, value) {
        var _a;
        this._tags = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtras = function(extras) {
        this._extra = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtra = function(key, extra) {
        var _a;
        this._extra = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setFingerprint = function(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setLevel = function(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTransactionName = function(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */ Scope.prototype.setTransaction = function(name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setContext = function(key, context) {
        var _a;
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSpan = function(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSpan = function() {
        return this._span;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getTransaction = function() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSession = function(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSession = function() {
        return this._session;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.update = function(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._tags), captureContext._tags);
            this._extra = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._extra), captureContext._extra);
            this._contexts = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
        } else if ((0, $8rX8J.isPlainObject)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._tags), captureContext.tags);
            this._extra = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._extra), captureContext.extra);
            this._contexts = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
        }
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clear = function() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addBreadcrumb = function(breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, $07c60478cbfa65e0$var$MAX_BREADCRUMBS) : $07c60478cbfa65e0$var$MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        var mergedBreadcrumb = (0, $fClYD.__assign)({
            timestamp: (0, $chTsM.dateTimestampInSeconds)()
        }, breadcrumb);
        this._breadcrumbs = (0, $fClYD.__spread)(this._breadcrumbs, [
            mergedBreadcrumb
        ]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clearBreadcrumbs = function() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */ Scope.prototype.applyToEvent = function(event, hint) {
        if (this._extra && Object.keys(this._extra).length) event.extra = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._extra), event.extra);
        if (this._tags && Object.keys(this._tags).length) event.tags = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._tags), event.tags);
        if (this._user && Object.keys(this._user).length) event.user = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._user), event.user);
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._contexts), event.contexts);
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = (0, $fClYD.__assign)({
                trace: this._span.getTraceContext()
            }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) event.tags = (0, $fClYD.__assign)({
                transaction: transactionName
            }, event.tags);
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0, $fClYD.__spread)(event.breadcrumbs || [], this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors((0, $fClYD.__spread)($07c60478cbfa65e0$var$getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */ Scope.prototype.setSDKProcessingMetadata = function(newData) {
        this._sdkProcessingMetadata = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */ Scope.prototype._notifyEventProcessors = function(processors, event, hint, index) {
        var _this = this;
        if (index === void 0) index = 0;
        return new (0, $bdF5c.SyncPromise)(function(resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') resolve(event);
            else {
                var result = processor((0, $fClYD.__assign)({}, event), hint);
                if ((0, $8rX8J.isThenable)(result)) result.then(function(final) {
                    return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                }).then(null, reject);
                else _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    };
    /**
     * This will be called on every set call.
     */ Scope.prototype._notifyScopeListeners = function() {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function(callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */ Scope.prototype._applyFingerprint = function(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
            event.fingerprint
        ] : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    };
    return Scope;
}();
/**
 * Returns the global event processors.
 */ function $07c60478cbfa65e0$var$getGlobalEventProcessors() {
    return (0, $lrp9R.getGlobalSingleton)('globalEventProcessors', function() {
        return [];
    });
}
function $07c60478cbfa65e0$export$8e4e25f54d456511(callback) {
    $07c60478cbfa65e0$var$getGlobalEventProcessors().push(callback);
}

});

parcelRegister("vfED8", function(module, exports) {
$parcel$export(module.exports, "Session", () => $05df09fd05f805c0$export$1fb4852a55678982);
parcelRequire("i0afJ");
var $909Vl = parcelRequire("909Vl");
var $chTsM = parcelRequire("chTsM");
var $73JtC = parcelRequire("73JtC");
/**
 * @inheritdoc
 */ var $05df09fd05f805c0$export$1fb4852a55678982 = /** @class */ function() {
    function Session(context) {
        this.errors = 0;
        this.sid = (0, $73JtC.uuid4)();
        this.duration = 0;
        this.status = 'ok';
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = (0, $chTsM.timestampInSeconds)();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) this.update(context);
    }
    /** JSDoc */ // eslint-disable-next-line complexity
    Session.prototype.update = function(context) {
        if (context === void 0) context = {};
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) this.ipAddress = context.user.ip_address;
            if (!this.did && !context.did) this.did = context.user.id || context.user.email || context.user.username;
        }
        this.timestamp = context.timestamp || (0, $chTsM.timestampInSeconds)();
        if (context.ignoreDuration) this.ignoreDuration = context.ignoreDuration;
        if (context.sid) // Good enough uuid validation. — Kamil
        this.sid = context.sid.length === 32 ? context.sid : (0, $73JtC.uuid4)();
        if (context.init !== undefined) this.init = context.init;
        if (!this.did && context.did) this.did = "" + context.did;
        if (typeof context.started === 'number') this.started = context.started;
        if (this.ignoreDuration) this.duration = undefined;
        else if (typeof context.duration === 'number') this.duration = context.duration;
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) this.release = context.release;
        if (context.environment) this.environment = context.environment;
        if (!this.ipAddress && context.ipAddress) this.ipAddress = context.ipAddress;
        if (!this.userAgent && context.userAgent) this.userAgent = context.userAgent;
        if (typeof context.errors === 'number') this.errors = context.errors;
        if (context.status) this.status = context.status;
    };
    /** JSDoc */ Session.prototype.close = function(status) {
        if (status) this.update({
            status: status
        });
        else if (this.status === 'ok') this.update({
            status: 'exited'
        });
        else this.update();
    };
    /** JSDoc */ Session.prototype.toJSON = function() {
        return (0, $909Vl.dropUndefinedKeys)({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent
            }
        });
    };
    return Session;
}();

});



parcelRegister("egk2u", function(module, exports) {
$parcel$export(module.exports, "SDK_VERSION", () => $a6221aaf52616c2a$export$31499a9cd224b78c);
var $a6221aaf52616c2a$export$31499a9cd224b78c = '6.19.7';

});

parcelRegister("7bmvO", function(module, exports) {
$parcel$export(module.exports, "BrowserClient", () => $53ab05e71f1546f1$export$1df9218a526d318d);

var $iTWOe = parcelRequire("iTWOe");

var $5veNv = parcelRequire("5veNv");
var $egk2u = parcelRequire("egk2u");
parcelRequire("i0afJ");
var $lrp9R = parcelRequire("lrp9R");
var $1v4ZC = parcelRequire("1v4ZC");

var $1R0KG = parcelRequire("1R0KG");

var $dMTNw = parcelRequire("dMTNw");

var $iuPyo = parcelRequire("iuPyo");

var $3UPj8 = parcelRequire("3UPj8");
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var $53ab05e71f1546f1$export$1df9218a526d318d = /** @class */ function(_super) {
    (0, $iTWOe.__extends)(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */ function BrowserClient(options) {
        if (options === void 0) options = {};
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: (0, $egk2u.SDK_VERSION)
                }
            ],
            version: (0, $egk2u.SDK_VERSION)
        };
        _this = _super.call(this, (0, $1R0KG.BrowserBackend), options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */ BrowserClient.prototype.showReportDialog = function(options) {
        if (options === void 0) options = {};
        // doesn't work without a document (React Native)
        var document = (0, $lrp9R.getGlobalObject)().document;
        if (!document) return;
        if (!this._isEnabled()) {
            (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        (0, $iuPyo.injectReportDialog)((0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, options), {
            dsn: options.dsn || this.getDsn()
        }));
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._prepareEvent = function(event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._sendEvent = function(event) {
        var integration = this.getIntegration((0, $3UPj8.Breadcrumbs));
        if (integration) integration.addSentryBreadcrumb(event);
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}((0, $5veNv.BaseClient));

});
parcelRegister("5veNv", function(module, exports) {
$parcel$export(module.exports, "BaseClient", () => $401b5375f9585e23$export$4f22f74eddb7716a);

var $iTWOe = parcelRequire("iTWOe");

var $FnrKW = parcelRequire("FnrKW");
parcelRequire("i0afJ");
var $73JtC = parcelRequire("73JtC");
var $chTsM = parcelRequire("chTsM");
var $8rX8J = parcelRequire("8rX8J");
var $1v4ZC = parcelRequire("1v4ZC");
var $62yRy = parcelRequire("62yRy");
var $bZWF1 = parcelRequire("bZWF1");
var $bdF5c = parcelRequire("bdF5c");
var $iMWNA = parcelRequire("iMWNA");
var $9k3Oz = parcelRequire("9k3Oz");

var $kT3vf = parcelRequire("kT3vf");

var $kn57e = parcelRequire("kn57e");
var $401b5375f9585e23$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */ var $401b5375f9585e23$export$4f22f74eddb7716a = /** @class */ function() {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */ function BaseClient(backendClass, options) {
        /** Array of used integrations. */ this._integrations = {};
        /** Number of calls being processed */ this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) this._dsn = (0, $62yRy.makeDsn)(options.dsn);
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function(exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if ((0, $73JtC.checkOrSetAlreadyCaught)(exception)) {
            (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).log($401b5375f9585e23$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend().eventFromException(exception, hint).then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureMessage = function(message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = (0, $8rX8J.isPrimitive)(message) ? this._getBackend().eventFromMessage(String(message), level, hint) : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent.then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureEvent = function(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $73JtC.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).log($401b5375f9585e23$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureSession = function(session) {
        if (!this._isEnabled()) {
            (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn('Discarded session because of missing or non-string release');
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({
                init: false
            });
        }
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getDsn = function() {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getOptions = function() {
        return this._options;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getTransport = function() {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.flush = function(timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
            return _this.getTransport().close(timeout).then(function(transportFlushed) {
                return clientFinished && transportFlushed;
            });
        });
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.close = function(timeout) {
        var _this = this;
        return this.flush(timeout).then(function(result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */ BaseClient.prototype.setupIntegrations = function() {
        if (this._isEnabled() && !this._integrations.initialized) this._integrations = (0, $kn57e.setupIntegrations)(this._options);
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getIntegration = function(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */ BaseClient.prototype._updateSessionFromEvent = function(session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for(var exceptions_1 = (0, $iTWOe.__values)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()){
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === 'ok';
        var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            session.update((0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, crashed && {
                status: 'crashed'
            }), {
                errors: session.errors || Number(errored || crashed)
            }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */ BaseClient.prototype._sendSession = function(session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */ BaseClient.prototype._isClientDoneProcessing = function(timeout) {
        var _this = this;
        return new (0, $bdF5c.SyncPromise)(function(resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function() {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */ BaseClient.prototype._getBackend = function() {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ BaseClient.prototype._isEnabled = function() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */ BaseClient.prototype._prepareEvent = function(event, scope, hint) {
        var _this = this;
        var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
        var prepared = (0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, event), {
            event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0, $73JtC.uuid4)()),
            timestamp: event.timestamp || (0, $chTsM.dateTimestampInSeconds)()
        });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) finalScope = (0, $FnrKW.Scope).clone(finalScope).update(hint.captureContext);
        // We prepare the result here with a resolved Event.
        var result = (0, $bdF5c.resolvedSyncPromise)(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
        return result.then(function(evt) {
            if (evt) // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
            // it is only attached as extra data to the event if the event somehow skips being normalized
            evt.sdkProcessingMetadata = (0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, evt.sdkProcessingMetadata), {
                normalizeDepth: (0, $bZWF1.normalize)(normalizeDepth) + " (" + typeof normalizeDepth + ")"
            });
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */ BaseClient.prototype._normalizeEvent = function(event, depth, maxBreadth) {
        if (!event) return null;
        var normalized = (0, $iTWOe.__assign)((0, $iTWOe.__assign)((0, $iTWOe.__assign)((0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, event), event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function(b) {
                return (0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, b), b.data && {
                    data: (0, $bZWF1.normalize)(b.data, depth, maxBreadth)
                });
            })
        }), event.user && {
            user: (0, $bZWF1.normalize)(event.user, depth, maxBreadth)
        }), event.contexts && {
            contexts: (0, $bZWF1.normalize)(event.contexts, depth, maxBreadth)
        }), event.extra && {
            extra: (0, $bZWF1.normalize)(event.extra, depth, maxBreadth)
        });
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        normalized.contexts.trace = event.contexts.trace;
        normalized.sdkProcessingMetadata = (0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, normalized.sdkProcessingMetadata), {
            baseClientNormalized: true
        });
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */ BaseClient.prototype._applyClientOptions = function(event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) event.environment = 'environment' in options ? environment : 'production';
        if (event.release === undefined && release !== undefined) event.release = release;
        if (event.dist === undefined && dist !== undefined) event.dist = dist;
        if (event.message) event.message = (0, $9k3Oz.truncate)(event.message, maxValueLength);
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) exception.value = (0, $9k3Oz.truncate)(exception.value, maxValueLength);
        var request = event.request;
        if (request && request.url) request.url = (0, $9k3Oz.truncate)(request.url, maxValueLength);
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */ BaseClient.prototype._applyIntegrationsMetadata = function(event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = (0, $iTWOe.__spread)(event.sdk.integrations || [], integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */ BaseClient.prototype._sendEvent = function(event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */ BaseClient.prototype._captureEvent = function(event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function(finalEvent) {
            return finalEvent.event_id;
        }, function(reason) {
            (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */ BaseClient.prototype._processEvent = function(event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        var transport = this.getTransport();
        function recordLostEvent(outcome, category) {
            if (transport.recordLostEvent) transport.recordLostEvent(outcome, category);
        }
        if (!this._isEnabled()) return (0, $bdF5c.rejectedSyncPromise)(new (0, $iMWNA.SentryError)('SDK not enabled, will not capture event.'));
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            recordLostEvent('sample_rate', 'event');
            return (0, $bdF5c.rejectedSyncPromise)(new (0, $iMWNA.SentryError)("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint).then(function(prepared) {
            if (prepared === null) {
                recordLostEvent('event_processor', event.type || 'event');
                throw new (0, $iMWNA.SentryError)('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) return prepared;
            var beforeSendResult = beforeSend(prepared, hint);
            return $401b5375f9585e23$var$_ensureBeforeSendRv(beforeSendResult);
        }).then(function(processedEvent) {
            if (processedEvent === null) {
                recordLostEvent('before_send', event.type || 'event');
                throw new (0, $iMWNA.SentryError)('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) _this._updateSessionFromEvent(session, processedEvent);
            _this._sendEvent(processedEvent);
            return processedEvent;
        }).then(null, function(reason) {
            if (reason instanceof (0, $iMWNA.SentryError)) throw reason;
            _this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $iMWNA.SentryError)("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */ BaseClient.prototype._process = function(promise) {
        var _this = this;
        this._numProcessing += 1;
        promise.then(function(value) {
            _this._numProcessing -= 1;
            return value;
        }, function(reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */ function $401b5375f9585e23$var$_ensureBeforeSendRv(rv) {
    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
    if ((0, $8rX8J.isThenable)(rv)) return rv.then(function(event) {
        if (!((0, $8rX8J.isPlainObject)(event) || event === null)) throw new (0, $iMWNA.SentryError)(nullErr);
        return event;
    }, function(e) {
        throw new (0, $iMWNA.SentryError)("beforeSend rejected with " + e);
    });
    else if (!((0, $8rX8J.isPlainObject)(rv) || rv === null)) throw new (0, $iMWNA.SentryError)(nullErr);
    return rv;
}

});
parcelRegister("kT3vf", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $f34ba958b299549d$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $f34ba958b299549d$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("kn57e", function(module, exports) {
$parcel$export(module.exports, "setupIntegrations", () => $ed49ec7a550738bc$export$51abed9797baa598);

var $iTWOe = parcelRequire("iTWOe");

var $FnrKW = parcelRequire("FnrKW");
var $ir14T = parcelRequire("ir14T");
parcelRequire("i0afJ");
var $909Vl = parcelRequire("909Vl");
var $1v4ZC = parcelRequire("1v4ZC");

var $kT3vf = parcelRequire("kT3vf");
var $ed49ec7a550738bc$export$b14a8888f80a0b3e = [];
/**
 * @private
 */ function $ed49ec7a550738bc$var$filterDuplicates(integrations) {
    return integrations.reduce(function(acc, integrations) {
        if (acc.every(function(accIntegration) {
            return integrations.name !== accIntegration.name;
        })) acc.push(integrations);
        return acc;
    }, []);
}
function $ed49ec7a550738bc$export$68bc4c01ab8ae766(options) {
    var defaultIntegrations = options.defaultIntegrations && (0, $iTWOe.__spread)(options.defaultIntegrations) || [];
    var userIntegrations = options.integrations;
    var integrations = (0, $iTWOe.__spread)($ed49ec7a550738bc$var$filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) // Filter out integrations that are also included in user options
    integrations = (0, $iTWOe.__spread)(integrations.filter(function(integrations) {
        return userIntegrations.every(function(userIntegration) {
            return userIntegration.name !== integrations.name;
        });
    }), $ed49ec7a550738bc$var$filterDuplicates(userIntegrations));
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [
            integrations
        ];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function(i) {
        return i.name;
    });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) integrations.push.apply(integrations, (0, $iTWOe.__spread)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    return integrations;
}
function $ed49ec7a550738bc$export$e7390a03b70a6f2f(integration) {
    if ($ed49ec7a550738bc$export$b14a8888f80a0b3e.indexOf(integration.name) !== -1) return;
    integration.setupOnce((0, $FnrKW.addGlobalEventProcessor), (0, $ir14T.getCurrentHub));
    $ed49ec7a550738bc$export$b14a8888f80a0b3e.push(integration.name);
    (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).log("Integration installed: " + integration.name);
}
function $ed49ec7a550738bc$export$51abed9797baa598(options) {
    var integrations = {};
    $ed49ec7a550738bc$export$68bc4c01ab8ae766(options).forEach(function(integration) {
        integrations[integration.name] = integration;
        $ed49ec7a550738bc$export$e7390a03b70a6f2f(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    (0, $909Vl.addNonEnumerableProperty)(integrations, 'initialized', true);
    return integrations;
}

});


parcelRegister("1R0KG", function(module, exports) {
$parcel$export(module.exports, "BrowserBackend", () => $159b530227e0a7dd$export$2526e21aec9d0ce7);

var $iTWOe = parcelRequire("iTWOe");

var $10WBH = parcelRequire("10WBH");
var $fvs8x = parcelRequire("fvs8x");

var $iYYET = parcelRequire("iYYET");
parcelRequire("i0afJ");
var $7YVaQ = parcelRequire("7YVaQ");

var $QEOc2 = parcelRequire("QEOc2");

var $bixL8 = parcelRequire("bixL8");
var $315mi = parcelRequire("315mi");
var $tw7ZC = parcelRequire("tw7ZC");
var $kV3i0 = parcelRequire("kV3i0");
/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */ var $159b530227e0a7dd$export$2526e21aec9d0ce7 = /** @class */ function(_super) {
    (0, $iTWOe.__extends)(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromException = function(exception, hint) {
        return (0, $QEOc2.eventFromException)(exception, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromMessage = function(message, level, hint) {
        if (level === void 0) level = (0, $iYYET.Severity).Info;
        return (0, $QEOc2.eventFromMessage)(message, level, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype._setupTransport = function() {
        if (!this._options.dsn) // We return the noop transport here in case there is no Dsn.
        return _super.prototype._setupTransport.call(this);
        var transportOptions = (0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, this._options.transportOptions), {
            dsn: this._options.dsn,
            tunnel: this._options.tunnel,
            sendClientReports: this._options.sendClientReports,
            _metadata: this._options._metadata
        });
        var api = (0, $fvs8x.initAPIDetails)(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
        var url = (0, $fvs8x.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel);
        if (this._options.transport) return new this._options.transport(transportOptions);
        if ((0, $7YVaQ.supportsFetch)()) {
            var requestOptions = (0, $iTWOe.__assign)({}, transportOptions.fetchParameters);
            this._newTransport = (0, $315mi.makeNewFetchTransport)({
                requestOptions: requestOptions,
                url: url
            });
            return new (0, $bixL8.FetchTransport)(transportOptions);
        }
        this._newTransport = (0, $tw7ZC.makeNewXHRTransport)({
            url: url,
            headers: transportOptions.headers
        });
        return new (0, $kV3i0.XHRTransport)(transportOptions);
    };
    return BrowserBackend;
}((0, $10WBH.BaseBackend));

});
parcelRegister("10WBH", function(module, exports) {
$parcel$export(module.exports, "BaseBackend", () => $0bd340aa354f6a9a$export$8f43a53a38d7e95f);

var $iTWOe = parcelRequire("iTWOe");
parcelRequire("i0afJ");
var $1v4ZC = parcelRequire("1v4ZC");
var $iMWNA = parcelRequire("iMWNA");

var $fvs8x = parcelRequire("fvs8x");

var $kT3vf = parcelRequire("kT3vf");

var $eOYVP = parcelRequire("eOYVP");

var $3bNx0 = parcelRequire("3bNx0");
/**
 * This is the base implemention of a Backend.
 * @hidden
 */ var $0bd340aa354f6a9a$export$8f43a53a38d7e95f = /** @class */ function() {
    /** Creates a new backend instance. */ function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn('No DSN provided, backend will not do anything.');
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function(_exception, _hint) {
        throw new (0, $iMWNA.SentryError)('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.eventFromMessage = function(_message, _level, _hint) {
        throw new (0, $iMWNA.SentryError)('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendEvent = function(event) {
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $fvs8x.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var env = (0, $eOYVP.createEventEnvelope)(event, api);
            this._newTransport.send(env).then(null, function(reason) {
                (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).error('Error while sending event:', reason);
            });
        } else this._transport.sendEvent(event).then(null, function(reason) {
            (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).error('Error while sending event:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendSession = function(session) {
        if (!this._transport.sendSession) {
            (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $fvs8x.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var _a = (0, $iTWOe.__read)((0, $eOYVP.createSessionEnvelope)(session, api), 1), env = _a[0];
            this._newTransport.send(env).then(null, function(reason) {
                (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).error('Error while sending session:', reason);
            });
        } else this._transport.sendSession(session).then(null, function(reason) {
            (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).error('Error while sending session:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.getTransport = function() {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */ BaseBackend.prototype._setupTransport = function() {
        return new (0, $3bNx0.NoopTransport)();
    };
    return BaseBackend;
}();

});
parcelRegister("fvs8x", function(module, exports) {
$parcel$export(module.exports, "getStoreEndpointWithUrlEncodedAuth", () => $b49f939dcd0814a6$export$c1677e22ac2217a5);
$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", () => $b49f939dcd0814a6$export$9964600bfe84e6a3);
$parcel$export(module.exports, "initAPIDetails", () => $b49f939dcd0814a6$export$ad00a06efb2a29cb);
$parcel$export(module.exports, "getReportDialogEndpoint", () => $b49f939dcd0814a6$export$671c7ed8e40a7a57);
parcelRequire("i0afJ");
var $62yRy = parcelRequire("62yRy");
var $909Vl = parcelRequire("909Vl");
var $b49f939dcd0814a6$var$SENTRY_API_VERSION = '7';
/**
 * Helper class to provide urls, headers and metadata that can be used to form
 * different types of requests to Sentry endpoints.
 * Supports both envelopes and regular event requests.
 *
 * @deprecated Please use APIDetails
 **/ var $b49f939dcd0814a6$export$2c4e825dc9120f87 = /** @class */ function() {
    /** Create a new instance of API */ function API(dsn, metadata, tunnel) {
        if (metadata === void 0) metadata = {};
        this.dsn = dsn;
        this._dsnObject = (0, $62yRy.makeDsn)(dsn);
        this.metadata = metadata;
        this._tunnel = tunnel;
    }
    /** Returns the Dsn object. */ API.prototype.getDsn = function() {
        return this._dsnObject;
    };
    /** Does this transport force envelopes? */ API.prototype.forceEnvelope = function() {
        return !!this._tunnel;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */ API.prototype.getBaseApiEndpoint = function() {
        return $b49f939dcd0814a6$var$getBaseApiEndpoint(this._dsnObject);
    };
    /** Returns the store endpoint URL. */ API.prototype.getStoreEndpoint = function() {
        return $b49f939dcd0814a6$var$getStoreEndpoint(this._dsnObject);
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getStoreEndpointWithUrlEncodedAuth = function() {
        return $b49f939dcd0814a6$export$c1677e22ac2217a5(this._dsnObject);
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function() {
        return $b49f939dcd0814a6$export$9964600bfe84e6a3(this._dsnObject, this._tunnel);
    };
    return API;
}();
function $b49f939dcd0814a6$export$ad00a06efb2a29cb(dsn, metadata, tunnel) {
    return {
        initDsn: dsn,
        metadata: metadata || {},
        dsn: (0, $62yRy.makeDsn)(dsn),
        tunnel: tunnel
    };
}
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $b49f939dcd0814a6$var$getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
    var port = dsn.port ? ":" + dsn.port : '';
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
}
/** Returns the ingest API endpoint for target. */ function $b49f939dcd0814a6$var$_getIngestEndpoint(dsn, target) {
    return "" + $b49f939dcd0814a6$var$getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $b49f939dcd0814a6$var$_encodedAuth(dsn) {
    return (0, $909Vl.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $b49f939dcd0814a6$var$SENTRY_API_VERSION
    });
}
/** Returns the store endpoint URL. */ function $b49f939dcd0814a6$var$getStoreEndpoint(dsn) {
    return $b49f939dcd0814a6$var$_getIngestEndpoint(dsn, 'store');
}
function $b49f939dcd0814a6$export$c1677e22ac2217a5(dsn) {
    return $b49f939dcd0814a6$var$getStoreEndpoint(dsn) + "?" + $b49f939dcd0814a6$var$_encodedAuth(dsn);
}
/** Returns the envelope endpoint URL. */ function $b49f939dcd0814a6$var$_getEnvelopeEndpoint(dsn) {
    return $b49f939dcd0814a6$var$_getIngestEndpoint(dsn, 'envelope');
}
function $b49f939dcd0814a6$export$9964600bfe84e6a3(dsn, tunnel) {
    return tunnel ? tunnel : $b49f939dcd0814a6$var$_getEnvelopeEndpoint(dsn) + "?" + $b49f939dcd0814a6$var$_encodedAuth(dsn);
}
function $b49f939dcd0814a6$export$1e4d4724de7b199e(dsn, clientName, clientVersion) {
    // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
    var header = [
        "Sentry sentry_version=" + $b49f939dcd0814a6$var$SENTRY_API_VERSION
    ];
    header.push("sentry_client=" + clientName + "/" + clientVersion);
    header.push("sentry_key=" + dsn.publicKey);
    if (dsn.pass) header.push("sentry_secret=" + dsn.pass);
    return {
        'Content-Type': 'application/json',
        'X-Sentry-Auth': header.join(', ')
    };
}
function $b49f939dcd0814a6$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    var dsn = (0, $62yRy.makeDsn)(dsnLike);
    var endpoint = $b49f939dcd0814a6$var$getBaseApiEndpoint(dsn) + "embed/error-page/";
    var encodedOptions = "dsn=" + (0, $62yRy.dsnToString)(dsn);
    for(var key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'user') {
            if (!dialogOptions.user) continue;
            if (dialogOptions.user.name) encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
            if (dialogOptions.user.email) encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
        } else encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
    }
    return endpoint + "?" + encodedOptions;
}

});

parcelRegister("eOYVP", function(module, exports) {
$parcel$export(module.exports, "createSessionEnvelope", () => $aca4fffc7a46a82d$export$124b03c077baa2f3);
$parcel$export(module.exports, "sessionToSentryRequest", () => $aca4fffc7a46a82d$export$977ee6eda1884ec3);
$parcel$export(module.exports, "createEventEnvelope", () => $aca4fffc7a46a82d$export$c31057337a18010f);
$parcel$export(module.exports, "eventToSentryRequest", () => $aca4fffc7a46a82d$export$2006389de558b996);

var $iTWOe = parcelRequire("iTWOe");
parcelRequire("i0afJ");
var $9G22S = parcelRequire("9G22S");
var $62yRy = parcelRequire("62yRy");
var $bZWF1 = parcelRequire("bZWF1");

var $fvs8x = parcelRequire("fvs8x");
/** Extract sdk info from from the API metadata */ function $aca4fffc7a46a82d$var$getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) return;
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $aca4fffc7a46a82d$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0, $iTWOe.__spread)(event.sdk.integrations || [], sdkInfo.integrations || []);
    event.sdk.packages = (0, $iTWOe.__spread)(event.sdk.packages || [], sdkInfo.packages || []);
    return event;
}
function $aca4fffc7a46a82d$export$124b03c077baa2f3(session, api) {
    var sdkInfo = $aca4fffc7a46a82d$var$getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = (0, $iTWOe.__assign)((0, $iTWOe.__assign)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $62yRy.dsnToString)(api.dsn)
    });
    // I know this is hacky but we don't want to add `sessions` to request type since it's never rate limited
    var type = 'aggregates' in session ? 'sessions' : 'session';
    // TODO (v7) Have to cast type because envelope items do not accept a `SentryRequestType`
    var envelopeItem = [
        {
            type: type
        },
        session
    ];
    var envelope = (0, $9G22S.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
    return [
        envelope,
        type
    ];
}
function $aca4fffc7a46a82d$export$977ee6eda1884ec3(session, api) {
    var _a = (0, $iTWOe.__read)($aca4fffc7a46a82d$export$124b03c077baa2f3(session, api), 2), envelope = _a[0], type = _a[1];
    return {
        body: (0, $9G22S.serializeEnvelope)(envelope),
        type: type,
        url: (0, $fvs8x.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel)
    };
}
function $aca4fffc7a46a82d$export$c31057337a18010f(event, api) {
    var sdkInfo = $aca4fffc7a46a82d$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $aca4fffc7a46a82d$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var envelopeHeaders = (0, $iTWOe.__assign)((0, $iTWOe.__assign)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $62yRy.dsnToString)(api.dsn)
    });
    var eventItem = [
        {
            type: eventType,
            sample_rates: [
                {
                    id: samplingMethod,
                    rate: sampleRate
                }
            ]
        },
        event
    ];
    return (0, $9G22S.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
function $aca4fffc7a46a82d$export$2006389de558b996(event, api) {
    var sdkInfo = $aca4fffc7a46a82d$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $aca4fffc7a46a82d$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var body;
    try {
        // 99.9% of events should get through just fine - no change in behavior for them
        body = JSON.stringify(event);
    } catch (err) {
        // Record data about the error without replacing original event data, then force renormalization
        event.tags.JSONStringifyError = true;
        event.extra.JSONStringifyError = err;
        try {
            body = JSON.stringify((0, $bZWF1.normalize)(event));
        } catch (newErr) {
            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
            // debug with this hack, we won't ever land here.
            var innerErr = newErr;
            body = JSON.stringify({
                message: 'JSON.stringify error after renormalization',
                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
                extra: {
                    message: innerErr.message,
                    stack: innerErr.stack
                }
            });
        }
    }
    var req = {
        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
        // the mystery
        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        body: body,
        type: eventType,
        url: useEnvelope ? (0, $fvs8x.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel) : (0, $fvs8x.getStoreEndpointWithUrlEncodedAuth)(api.dsn)
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = (0, $iTWOe.__assign)((0, $iTWOe.__assign)({
            event_id: event.event_id,
            sent_at: new Date().toISOString()
        }, sdkInfo && {
            sdk: sdkInfo
        }), !!api.tunnel && {
            dsn: (0, $62yRy.dsnToString)(api.dsn)
        });
        var eventItem = [
            {
                type: eventType,
                sample_rates: [
                    {
                        id: samplingMethod,
                        rate: sampleRate
                    }
                ]
            },
            req.body
        ];
        var envelope = (0, $9G22S.createEnvelope)(envelopeHeaders, [
            eventItem
        ]);
        req.body = (0, $9G22S.serializeEnvelope)(envelope);
    }
    return req;
}

});

parcelRegister("3bNx0", function(module, exports) {
$parcel$export(module.exports, "NoopTransport", () => $2528d20e6df164a7$export$6f2767450ea1346c);
parcelRequire("i0afJ");
var $bdF5c = parcelRequire("bdF5c");
/** Noop transport */ var $2528d20e6df164a7$export$6f2767450ea1346c = /** @class */ function() {
    function NoopTransport() {}
    /**
     * @inheritDoc
     */ NoopTransport.prototype.sendEvent = function(_) {
        return (0, $bdF5c.resolvedSyncPromise)({
            reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
            status: 'skipped'
        });
    };
    /**
     * @inheritDoc
     */ NoopTransport.prototype.close = function(_) {
        return (0, $bdF5c.resolvedSyncPromise)(true);
    };
    return NoopTransport;
}();

});


parcelRegister("QEOc2", function(module, exports) {
$parcel$export(module.exports, "exceptionFromError", () => $09e4832cb98fb9cd$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $09e4832cb98fb9cd$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $09e4832cb98fb9cd$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $09e4832cb98fb9cd$export$5425b53185d13d6c);

var $iTWOe = parcelRequire("iTWOe");

var $iYYET = parcelRequire("iYYET");
parcelRequire("i0afJ");
var $73JtC = parcelRequire("73JtC");
var $b8srE = parcelRequire("b8srE");
var $909Vl = parcelRequire("909Vl");
var $8rX8J = parcelRequire("8rX8J");
var $bZWF1 = parcelRequire("bZWF1");
var $bdF5c = parcelRequire("bdF5c");

var $9WSf6 = parcelRequire("9WSf6");
function $09e4832cb98fb9cd$export$a6c2d27607295951(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = $09e4832cb98fb9cd$export$d478b2c12fbcfdda(ex);
    var exception = {
        type: ex && ex.name,
        value: $09e4832cb98fb9cd$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $09e4832cb98fb9cd$export$a6a5dd73e489caf(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0, $8rX8J.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + (0, $909Vl.extractExceptionKeysForMessage)(exception)
                }
            ]
        },
        extra: {
            __serialized__: (0, $bZWF1.normalizeToSize)(exception)
        }
    };
    if (syntheticException) {
        var frames_1 = $09e4832cb98fb9cd$export$d478b2c12fbcfdda(syntheticException);
        if (frames_1.length) event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
function $09e4832cb98fb9cd$export$73fbea5a0a5234af(ex) {
    return {
        exception: {
            values: [
                $09e4832cb98fb9cd$export$a6c2d27607295951(ex)
            ]
        }
    };
}
function $09e4832cb98fb9cd$export$d478b2c12fbcfdda(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = $09e4832cb98fb9cd$var$getPopSize(ex);
    try {
        return (0, $b8srE.createStackParser)((0, $9WSf6.opera10StackParser), (0, $9WSf6.opera11StackParser), (0, $9WSf6.chromeStackParser), (0, $9WSf6.winjsStackParser), (0, $9WSf6.geckoStackParser))(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $09e4832cb98fb9cd$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $09e4832cb98fb9cd$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($09e4832cb98fb9cd$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $09e4832cb98fb9cd$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
function $09e4832cb98fb9cd$export$ea3ec7e569b823fc(exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $09e4832cb98fb9cd$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace);
    (0, $73JtC.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = (0, $iYYET.Severity).Error;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $bdF5c.resolvedSyncPromise)(event);
}
function $09e4832cb98fb9cd$export$5425b53185d13d6c(message, level, hint, attachStacktrace) {
    if (level === void 0) level = (0, $iYYET.Severity).Info;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $09e4832cb98fb9cd$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $bdF5c.resolvedSyncPromise)(event);
}
function $09e4832cb98fb9cd$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0, $8rX8J.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return $09e4832cb98fb9cd$export$73fbea5a0a5234af(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $8rX8J.isDOMError)(exception) || (0, $8rX8J.isDOMException)(exception)) {
        var domException = exception;
        if ('stack' in exception) event = $09e4832cb98fb9cd$export$73fbea5a0a5234af(exception);
        else {
            var name_1 = domException.name || ((0, $8rX8J.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = $09e4832cb98fb9cd$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
            (0, $73JtC.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) event.tags = (0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, event.tags), {
            'DOMException.code': "" + domException.code
        });
        return event;
    }
    if ((0, $8rX8J.isError)(exception)) // we have a real Error object, do nothing
    return $09e4832cb98fb9cd$export$73fbea5a0a5234af(exception);
    if ((0, $8rX8J.isPlainObject)(exception) || (0, $8rX8J.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = $09e4832cb98fb9cd$export$a6a5dd73e489caf(objectException, syntheticException, isUnhandledRejection);
        (0, $73JtC.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $09e4832cb98fb9cd$export$47d86ae4b3c9994(exception, syntheticException, attachStacktrace);
    (0, $73JtC.addExceptionTypeValue)(event, "" + exception, undefined);
    (0, $73JtC.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $09e4832cb98fb9cd$export$47d86ae4b3c9994(input, syntheticException, attachStacktrace) {
    var event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = $09e4832cb98fb9cd$export$d478b2c12fbcfdda(syntheticException);
        if (frames_2.length) event.stacktrace = {
            frames: frames_2
        };
    }
    return event;
}

});
parcelRegister("9WSf6", function(module, exports) {
$parcel$export(module.exports, "chromeStackParser", () => $73e39b4aefc69ec5$export$c693d9295441d8f9);
$parcel$export(module.exports, "geckoStackParser", () => $73e39b4aefc69ec5$export$c9ddf1e2b5d48bff);
$parcel$export(module.exports, "winjsStackParser", () => $73e39b4aefc69ec5$export$b6d155d85c1dcba5);
$parcel$export(module.exports, "opera10StackParser", () => $73e39b4aefc69ec5$export$966ec832d9699d6);
$parcel$export(module.exports, "opera11StackParser", () => $73e39b4aefc69ec5$export$989a1824b4734ce6);

var $iTWOe = parcelRequire("iTWOe");
// global reference to slice
var $73e39b4aefc69ec5$var$UNKNOWN_FUNCTION = '?';
var $73e39b4aefc69ec5$var$OPERA10_PRIORITY = 10;
var $73e39b4aefc69ec5$var$OPERA11_PRIORITY = 20;
var $73e39b4aefc69ec5$var$CHROME_PRIORITY = 30;
var $73e39b4aefc69ec5$var$WINJS_PRIORITY = 40;
var $73e39b4aefc69ec5$var$GECKO_PRIORITY = 50;
function $73e39b4aefc69ec5$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $73e39b4aefc69ec5$var$chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $73e39b4aefc69ec5$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var $73e39b4aefc69ec5$var$chrome = function(line) {
    var parts = $73e39b4aefc69ec5$var$chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = $73e39b4aefc69ec5$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = (0, $iTWOe.__read)($73e39b4aefc69ec5$var$extractSafariExtensionDetails(parts[1] || $73e39b4aefc69ec5$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return $73e39b4aefc69ec5$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var $73e39b4aefc69ec5$export$c693d9295441d8f9 = [
    $73e39b4aefc69ec5$var$CHROME_PRIORITY,
    $73e39b4aefc69ec5$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $73e39b4aefc69ec5$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $73e39b4aefc69ec5$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $73e39b4aefc69ec5$var$gecko = function(line) {
    var _a;
    var parts = $73e39b4aefc69ec5$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = $73e39b4aefc69ec5$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || $73e39b4aefc69ec5$var$UNKNOWN_FUNCTION;
        _a = (0, $iTWOe.__read)($73e39b4aefc69ec5$var$extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return $73e39b4aefc69ec5$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var $73e39b4aefc69ec5$export$c9ddf1e2b5d48bff = [
    $73e39b4aefc69ec5$var$GECKO_PRIORITY,
    $73e39b4aefc69ec5$var$gecko
];
var $73e39b4aefc69ec5$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $73e39b4aefc69ec5$var$winjs = function(line) {
    var parts = $73e39b4aefc69ec5$var$winjsRegex.exec(line);
    return parts ? $73e39b4aefc69ec5$var$createFrame(parts[2], parts[1] || $73e39b4aefc69ec5$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var $73e39b4aefc69ec5$export$b6d155d85c1dcba5 = [
    $73e39b4aefc69ec5$var$WINJS_PRIORITY,
    $73e39b4aefc69ec5$var$winjs
];
var $73e39b4aefc69ec5$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $73e39b4aefc69ec5$var$opera10 = function(line) {
    var parts = $73e39b4aefc69ec5$var$opera10Regex.exec(line);
    return parts ? $73e39b4aefc69ec5$var$createFrame(parts[2], parts[3] || $73e39b4aefc69ec5$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var $73e39b4aefc69ec5$export$966ec832d9699d6 = [
    $73e39b4aefc69ec5$var$OPERA10_PRIORITY,
    $73e39b4aefc69ec5$var$opera10
];
var $73e39b4aefc69ec5$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $73e39b4aefc69ec5$var$opera11 = function(line) {
    var parts = $73e39b4aefc69ec5$var$opera11Regex.exec(line);
    return parts ? $73e39b4aefc69ec5$var$createFrame(parts[5], parts[3] || parts[4] || $73e39b4aefc69ec5$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var $73e39b4aefc69ec5$export$989a1824b4734ce6 = [
    $73e39b4aefc69ec5$var$OPERA11_PRIORITY,
    $73e39b4aefc69ec5$var$opera11
];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var $73e39b4aefc69ec5$var$extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $73e39b4aefc69ec5$var$UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename
    ] : [
        func,
        filename
    ];
};

});


parcelRegister("bixL8", function(module, exports) {
$parcel$export(module.exports, "FetchTransport", () => $839b900621c46fa5$export$2bdee3f9b92f4e82);

var $iTWOe = parcelRequire("iTWOe");
parcelRequire("i0afJ");
var $iMWNA = parcelRequire("iMWNA");
var $7YVaQ = parcelRequire("7YVaQ");
var $bdF5c = parcelRequire("bdF5c");

var $6aT3D = parcelRequire("6aT3D");

var $8UlxH = parcelRequire("8UlxH");
/** `fetch` based transport */ var $839b900621c46fa5$export$2bdee3f9b92f4e82 = /** @class */ function(_super) {
    (0, $iTWOe.__extends)(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) fetchImpl = (0, $8UlxH.getNativeFetchImplementation)();
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ FetchTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
            // (see https://caniuse.com/#feat=referrer-policy),
            // it doesn't. And it throws an exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (0, $7YVaQ.supportsReferrerPolicy)() ? 'origin' : ''
        };
        if (this.options.fetchParameters !== undefined) Object.assign(options, this.options.fetchParameters);
        if (this.options.headers !== undefined) options.headers = this.options.headers;
        return this._buffer.add(function() {
            return new (0, $bdF5c.SyncPromise)(function(resolve, reject) {
                _this._fetch(sentryRequest.url, options).then(function(response) {
                    var headers = {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject
                    });
                }).catch(reject);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $iMWNA.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return FetchTransport;
}((0, $6aT3D.BaseTransport));

});
parcelRegister("6aT3D", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => $47ee628c27b8c5d2$export$74b99d619e90f481);

var $iTWOe = parcelRequire("iTWOe");

var $eOYVP = parcelRequire("eOYVP");
var $fvs8x = parcelRequire("fvs8x");
parcelRequire("i0afJ");
var $diVdC = parcelRequire("diVdC");
var $etGw0 = parcelRequire("etGw0");
var $62yRy = parcelRequire("62yRy");
var $9P6Bi = parcelRequire("9P6Bi");
var $lrp9R = parcelRequire("lrp9R");
var $1v4ZC = parcelRequire("1v4ZC");
var $bUAoW = parcelRequire("bUAoW");
var $9G22S = parcelRequire("9G22S");

var $dMTNw = parcelRequire("dMTNw");

var $8UlxH = parcelRequire("8UlxH");
function $47ee628c27b8c5d2$var$requestTypeToCategory(ty) {
    var tyStr = ty;
    return tyStr === 'event' ? 'error' : tyStr;
}
var $47ee628c27b8c5d2$var$global = (0, $lrp9R.getGlobalObject)();
/** Base Transport class implementation */ var $47ee628c27b8c5d2$export$74b99d619e90f481 = /** @class */ function() {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */ this._buffer = (0, $bUAoW.makePromiseBuffer)(30);
        /** Locks transport after receiving rate limits in a response */ this._rateLimits = {};
        this._outcomes = {};
        this._api = (0, $fvs8x.initAPIDetails)(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = (0, $fvs8x.getStoreEndpointWithUrlEncodedAuth)(this._api.dsn);
        if (this.options.sendClientReports && $47ee628c27b8c5d2$var$global.document) $47ee628c27b8c5d2$var$global.document.addEventListener('visibilitychange', function() {
            if ($47ee628c27b8c5d2$var$global.document.visibilityState === 'hidden') _this._flushOutcomes();
        });
    }
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendEvent = function(event) {
        return this._sendRequest((0, $eOYVP.eventToSentryRequest)(event, this._api), event);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendSession = function(session) {
        return this._sendRequest((0, $eOYVP.sessionToSentryRequest)(session, this._api), session);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.close = function(timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.recordLostEvent = function(reason, category) {
        var _a;
        if (!this.options.sendClientReports) return;
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = $47ee628c27b8c5d2$var$requestTypeToCategory(category) + ":" + reason;
        (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], _a !== null && _a !== void 0 ? _a : 0) + 1;
    };
    /**
     * Send outcomes as an envelope
     */ BaseTransport.prototype._flushOutcomes = function() {
        if (!this.options.sendClientReports) return;
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).log('No outcomes to flush');
            return;
        }
        (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = (0, $fvs8x.getEnvelopeEndpointWithUrlEncodedAuth)(this._api.dsn, this._api.tunnel);
        var discardedEvents = Object.keys(outcomes).map(function(key) {
            var _a = (0, $iTWOe.__read)(key.split(':'), 2), category = _a[0], reason = _a[1];
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        // TODO: Improve types on discarded_events to get rid of cast
        });
        var envelope = (0, $diVdC.createClientReportEnvelope)(discardedEvents, this._api.tunnel && (0, $62yRy.dsnToString)(this._api.dsn));
        try {
            (0, $8UlxH.sendReport)(url, (0, $9G22S.serializeEnvelope)(envelope));
        } catch (e) {
            (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */ BaseTransport.prototype._handleResponse = function(_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = (0, $9P6Bi.eventStatusFromHttpCode)(response.status);
        this._rateLimits = (0, $etGw0.updateRateLimits)(this._rateLimits, headers);
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(requestType)) (0, $dMTNw.IS_DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
        (0, $1v4ZC.logger).warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        if (status === 'success') {
            resolve({
                status: status
            });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     *
     * @deprecated Please use `disabledUntil` from @sentry/utils
     */ BaseTransport.prototype._disabledUntil = function(requestType) {
        var category = $47ee628c27b8c5d2$var$requestTypeToCategory(requestType);
        return new Date((0, $etGw0.disabledUntil)(this._rateLimits, category));
    };
    /**
     * Checks if a category is rate limited
     *
     * @deprecated Please use `isRateLimited` from @sentry/utils
     */ BaseTransport.prototype._isRateLimited = function(requestType) {
        var category = $47ee628c27b8c5d2$var$requestTypeToCategory(requestType);
        return (0, $etGw0.isRateLimited)(this._rateLimits, category);
    };
    return BaseTransport;
}();

});
parcelRegister("dMTNw", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $a09b0a5534eb220e$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $a09b0a5534eb220e$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("8UlxH", function(module, exports) {
$parcel$export(module.exports, "getNativeFetchImplementation", () => $67c4439c099d3ecd$export$8be2119ce08e3379);
$parcel$export(module.exports, "sendReport", () => $67c4439c099d3ecd$export$84bb63b2c17ec44d);
parcelRequire("i0afJ");
var $lQOiJ = parcelRequire("lQOiJ");
var $lrp9R = parcelRequire("lrp9R");
var $7YVaQ = parcelRequire("7YVaQ");
var $1v4ZC = parcelRequire("1v4ZC");

var $dMTNw = parcelRequire("dMTNw");
var $67c4439c099d3ecd$var$global = (0, $lrp9R.getGlobalObject)();
var $67c4439c099d3ecd$var$cachedFetchImpl;
function $67c4439c099d3ecd$export$8be2119ce08e3379() {
    if ($67c4439c099d3ecd$var$cachedFetchImpl) return $67c4439c099d3ecd$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $7YVaQ.isNativeFetch)($67c4439c099d3ecd$var$global.fetch)) return $67c4439c099d3ecd$var$cachedFetchImpl = $67c4439c099d3ecd$var$global.fetch.bind($67c4439c099d3ecd$var$global);
    var document = $67c4439c099d3ecd$var$global.document;
    var fetchImpl = $67c4439c099d3ecd$var$global.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        var sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $67c4439c099d3ecd$var$cachedFetchImpl = fetchImpl.bind($67c4439c099d3ecd$var$global);
/* eslint-enable @typescript-eslint/unbound-method */ }
function $67c4439c099d3ecd$export$84bb63b2c17ec44d(url, body) {
    var isRealNavigator = Object.prototype.toString.call($67c4439c099d3ecd$var$global && $67c4439c099d3ecd$var$global.navigator) === '[object Navigator]';
    var hasSendBeacon = isRealNavigator && typeof $67c4439c099d3ecd$var$global.navigator.sendBeacon === 'function';
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = $67c4439c099d3ecd$var$global.navigator.sendBeacon.bind($67c4439c099d3ecd$var$global.navigator);
        return sendBeacon(url, body);
    }
    if ((0, $7YVaQ.supportsFetch)()) {
        var fetch_1 = $67c4439c099d3ecd$export$8be2119ce08e3379();
        return (0, $lQOiJ.forget)(fetch_1(url, {
            body: body,
            method: 'POST',
            credentials: 'omit',
            keepalive: true
        }));
    }
}

});



parcelRegister("315mi", function(module, exports) {
$parcel$export(module.exports, "makeNewFetchTransport", () => $23259f303e4bc615$export$1c57e6bfd09bad13);

var $iTWOe = parcelRequire("iTWOe");

var $96fA7 = parcelRequire("96fA7");

var $8UlxH = parcelRequire("8UlxH");
function $23259f303e4bc615$export$1c57e6bfd09bad13(options, nativeFetch) {
    if (nativeFetch === void 0) nativeFetch = (0, $8UlxH.getNativeFetchImplementation)();
    function makeRequest(request) {
        var requestOptions = (0, $iTWOe.__assign)({
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin'
        }, options.requestOptions);
        return nativeFetch(options.url, requestOptions).then(function(response) {
            return response.text().then(function(body) {
                return {
                    body: body,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    },
                    reason: response.statusText,
                    statusCode: response.status
                };
            });
        });
    }
    return (0, $96fA7.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});
parcelRegister("96fA7", function(module, exports) {
$parcel$export(module.exports, "createTransport", () => $6a00c2bfdd3876d6$export$d09f50d9ab7f7b69);
parcelRequire("i0afJ");
var $etGw0 = parcelRequire("etGw0");
var $9P6Bi = parcelRequire("9P6Bi");
var $9G22S = parcelRequire("9G22S");
var $bUAoW = parcelRequire("bUAoW");
var $bdF5c = parcelRequire("bdF5c");
var $6a00c2bfdd3876d6$export$d8a725a7dce95622 = 'error';
var $6a00c2bfdd3876d6$export$99adc6fe67a3c63e = 'transaction';
var $6a00c2bfdd3876d6$export$9d7ad34f132fe68f = 'attachment';
var $6a00c2bfdd3876d6$export$42d9e7b5fc564c45 = 'session';
var $6a00c2bfdd3876d6$export$e515cf6dfd2f98b8 = 30;
function $6a00c2bfdd3876d6$export$d09f50d9ab7f7b69(options, makeRequest, buffer) {
    if (buffer === void 0) buffer = (0, $bUAoW.makePromiseBuffer)(options.bufferSize || $6a00c2bfdd3876d6$export$e515cf6dfd2f98b8);
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    function send(envelope) {
        var envCategory = (0, $9G22S.getEnvelopeType)(envelope);
        var category = envCategory === 'event' ? 'error' : envCategory;
        var request = {
            category: category,
            body: (0, $9G22S.serializeEnvelope)(envelope)
        };
        // Don't add to buffer if transport is already rate-limited
        if ((0, $etGw0.isRateLimited)(rateLimits, category)) return (0, $bdF5c.rejectedSyncPromise)({
            status: 'rate_limit',
            reason: $6a00c2bfdd3876d6$var$getRateLimitReason(rateLimits, category)
        });
        var requestTask = function() {
            return makeRequest(request).then(function(_a) {
                var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
                var status = (0, $9P6Bi.eventStatusFromHttpCode)(statusCode);
                if (headers) rateLimits = (0, $etGw0.updateRateLimits)(rateLimits, headers);
                if (status === 'success') return (0, $bdF5c.resolvedSyncPromise)({
                    status: status,
                    reason: reason
                });
                return (0, $bdF5c.rejectedSyncPromise)({
                    status: status,
                    reason: reason || body || (status === 'rate_limit' ? $6a00c2bfdd3876d6$var$getRateLimitReason(rateLimits, category) : 'Unknown transport error')
                });
            });
        };
        return buffer.add(requestTask);
    }
    return {
        send: send,
        flush: flush
    };
}
function $6a00c2bfdd3876d6$var$getRateLimitReason(rateLimits, category) {
    return "Too many " + category + " requests, backing off until: " + new Date((0, $etGw0.disabledUntil)(rateLimits, category)).toISOString();
}

});


parcelRegister("tw7ZC", function(module, exports) {
$parcel$export(module.exports, "makeNewXHRTransport", () => $058ba17bc7b60c8d$export$4c0ac1dd4bbf4921);

var $96fA7 = parcelRequire("96fA7");
parcelRequire("i0afJ");
var $bdF5c = parcelRequire("bdF5c");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ var $058ba17bc7b60c8d$var$XHR_READYSTATE_DONE = 4;
function $058ba17bc7b60c8d$export$4c0ac1dd4bbf4921(options) {
    function makeRequest(request) {
        return new (0, $bdF5c.SyncPromise)(function(resolve, _reject) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (xhr.readyState === $058ba17bc7b60c8d$var$XHR_READYSTATE_DONE) {
                    var response = {
                        body: xhr.response,
                        headers: {
                            'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': xhr.getResponseHeader('Retry-After')
                        },
                        reason: xhr.statusText,
                        statusCode: xhr.status
                    };
                    resolve(response);
                }
            };
            xhr.open('POST', options.url);
            for(var header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $96fA7.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});

parcelRegister("kV3i0", function(module, exports) {
$parcel$export(module.exports, "XHRTransport", () => $f3abaeb981645c66$export$874a283af77e8e62);

var $iTWOe = parcelRequire("iTWOe");
parcelRequire("i0afJ");
var $iMWNA = parcelRequire("iMWNA");
var $bdF5c = parcelRequire("bdF5c");

var $6aT3D = parcelRequire("6aT3D");
/** `XHR` based transport */ var $f3abaeb981645c66$export$874a283af77e8e62 = /** @class */ function(_super) {
    (0, $iTWOe.__extends)(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ XHRTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        return this._buffer.add(function() {
            return new (0, $bdF5c.SyncPromise)(function(resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function() {
                    if (request.readyState === 4) {
                        var headers = {
                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': request.getResponseHeader('Retry-After')
                        };
                        _this._handleResponse({
                            requestType: sentryRequest.type,
                            response: request,
                            headers: headers,
                            resolve: resolve,
                            reject: reject
                        });
                    }
                };
                request.open('POST', sentryRequest.url);
                for(var header in _this.options.headers)if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) request.setRequestHeader(header, _this.options.headers[header]);
                request.send(sentryRequest.body);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $iMWNA.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return XHRTransport;
}((0, $6aT3D.BaseTransport));

});


parcelRegister("iuPyo", function(module, exports) {
$parcel$export(module.exports, "shouldIgnoreOnError", () => $d77304d140466795$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $d77304d140466795$export$4997ffc0176396a6);
$parcel$export(module.exports, "injectReportDialog", () => $d77304d140466795$export$deb9aac8ea0b576c);

var $iTWOe = parcelRequire("iTWOe");

var $kD78n = parcelRequire("kD78n");
var $fvs8x = parcelRequire("fvs8x");
parcelRequire("i0afJ");
var $73JtC = parcelRequire("73JtC");
var $909Vl = parcelRequire("909Vl");
var $lrp9R = parcelRequire("lrp9R");
var $1v4ZC = parcelRequire("1v4ZC");

var $dMTNw = parcelRequire("dMTNw");
var $d77304d140466795$var$global = (0, $lrp9R.getGlobalObject)();
var $d77304d140466795$var$ignoreOnError = 0;
function $d77304d140466795$export$b79738ab10c590b2() {
    return $d77304d140466795$var$ignoreOnError > 0;
}
function $d77304d140466795$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $d77304d140466795$var$ignoreOnError += 1;
    setTimeout(function() {
        $d77304d140466795$var$ignoreOnError -= 1;
    });
}
function $d77304d140466795$export$4997ffc0176396a6(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) options = {};
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $909Vl.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return $d77304d140466795$export$4997ffc0176396a6(arg, options);
            });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $d77304d140466795$export$1265a142ff5ba165();
            (0, $kD78n.withScope)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0, $73JtC.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $73JtC.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $kD78n.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $909Vl.markFunctionWrapped)(sentryWrapped, fn);
    (0, $909Vl.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get: function() {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}
function $d77304d140466795$export$deb9aac8ea0b576c(options) {
    if (options === void 0) options = {};
    if (!$d77304d140466795$var$global.document) return;
    if (!options.eventId) {
        (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).error('Missing eventId option in showReportDialog call');
        return;
    }
    if (!options.dsn) {
        (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).error('Missing dsn option in showReportDialog call');
        return;
    }
    var script = $d77304d140466795$var$global.document.createElement('script');
    script.async = true;
    script.src = (0, $fvs8x.getReportDialogEndpoint)(options.dsn, options);
    if (options.onLoad) // eslint-disable-next-line @typescript-eslint/unbound-method
    script.onload = options.onLoad;
    var injectionPoint = $d77304d140466795$var$global.document.head || $d77304d140466795$var$global.document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
}

});

parcelRegister("3UPj8", function(module, exports) {
$parcel$export(module.exports, "Breadcrumbs", () => $2d9e66b17b884fa3$export$2dc68d50d56fbbd);

var $iTWOe = parcelRequire("iTWOe");

var $ir14T = parcelRequire("ir14T");

var $iYYET = parcelRequire("iYYET");
parcelRequire("i0afJ");
var $aVmXt = parcelRequire("aVmXt");
var $73JtC = parcelRequire("73JtC");
var $lrp9R = parcelRequire("lrp9R");
var $f9iVj = parcelRequire("f9iVj");
var $9k3Oz = parcelRequire("9k3Oz");
var $kpXMz = parcelRequire("kpXMz");
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ var $2d9e66b17b884fa3$export$2dc68d50d56fbbd = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */ this.name = Breadcrumbs.id;
        this._options = (0, $iTWOe.__assign)({
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true
        }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */ Breadcrumbs.prototype.addSentryBreadcrumb = function(event) {
        if (!this._options.sentry) return;
        (0, $ir14T.getCurrentHub)().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: (0, $73JtC.getEventDescription)(event)
        }, {
            event: event
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */ Breadcrumbs.prototype.setupOnce = function() {
        if (this._options.console) (0, $aVmXt.addInstrumentationHandler)('console', $2d9e66b17b884fa3$var$_consoleBreadcrumb);
        if (this._options.dom) (0, $aVmXt.addInstrumentationHandler)('dom', $2d9e66b17b884fa3$var$_domBreadcrumb(this._options.dom));
        if (this._options.xhr) (0, $aVmXt.addInstrumentationHandler)('xhr', $2d9e66b17b884fa3$var$_xhrBreadcrumb);
        if (this._options.fetch) (0, $aVmXt.addInstrumentationHandler)('fetch', $2d9e66b17b884fa3$var$_fetchBreadcrumb);
        if (this._options.history) (0, $aVmXt.addInstrumentationHandler)('history', $2d9e66b17b884fa3$var$_historyBreadcrumb);
    };
    /**
     * @inheritDoc
     */ Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}();
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2d9e66b17b884fa3$var$_domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target ? (0, $f9iVj.htmlTreeAsString)(handlerData.event.target, keyAttrs) : (0, $f9iVj.htmlTreeAsString)(handlerData.event, keyAttrs);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        (0, $ir14T.getCurrentHub)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2d9e66b17b884fa3$var$_consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console'
        },
        level: (0, $kpXMz.severityFromString)(handlerData.level),
        message: (0, $9k3Oz.safeJoin)(handlerData.args, ' ')
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + ((0, $9k3Oz.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $ir14T.getCurrentHub)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2d9e66b17b884fa3$var$_xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) return;
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        (0, $ir14T.getCurrentHub)().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code
            },
            type: 'http'
        }, {
            xhr: handlerData.xhr,
            input: body
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2d9e66b17b884fa3$var$_fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) (0, $ir14T.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: handlerData.fetchData,
        level: (0, $iYYET.Severity).Error,
        type: 'http'
    }, {
        data: handlerData.error,
        input: handlerData.args
    });
    else (0, $ir14T.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: (0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, handlerData.fetchData), {
            status_code: handlerData.response.status
        }),
        type: 'http'
    }, {
        input: handlerData.args,
        response: handlerData.response
    });
}
/**
 * Creates breadcrumbs from history API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2d9e66b17b884fa3$var$_historyBreadcrumb(handlerData) {
    var global = (0, $lrp9R.getGlobalObject)();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = (0, $73JtC.parseUrl)(global.location.href);
    var parsedFrom = (0, $73JtC.parseUrl)(from);
    var parsedTo = (0, $73JtC.parseUrl)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $ir14T.getCurrentHub)().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
}

});


parcelRegister("5R1Wi", function(module, exports) {
$parcel$export(module.exports, "defaultIntegrations", () => $4433681b335e918c$export$5ef831fccfce35e5);
$parcel$export(module.exports, "init", () => $4433681b335e918c$export$2cd8252107eb640b);
$parcel$export(module.exports, "showReportDialog", () => $4433681b335e918c$export$3a8fd680da42627b);
$parcel$export(module.exports, "lastEventId", () => $4433681b335e918c$export$5d4e9fd7fac8e617);
$parcel$export(module.exports, "forceLoad", () => $4433681b335e918c$export$a3f323d81eede727);
$parcel$export(module.exports, "onLoad", () => $4433681b335e918c$export$4e4d8b287d028b6b);
$parcel$export(module.exports, "flush", () => $4433681b335e918c$export$4909b86c8034bf73);
$parcel$export(module.exports, "close", () => $4433681b335e918c$export$8360e631d277ea4d);
$parcel$export(module.exports, "wrap", () => $4433681b335e918c$export$4997ffc0176396a6);

var $iTWOe = parcelRequire("iTWOe");

var $ir14T = parcelRequire("ir14T");
var $c9Yw8 = parcelRequire("c9Yw8");
var $2zF9F = parcelRequire("2zF9F");
parcelRequire("i0afJ");
var $aVmXt = parcelRequire("aVmXt");
var $lrp9R = parcelRequire("lrp9R");
var $1v4ZC = parcelRequire("1v4ZC");
var $bdF5c = parcelRequire("bdF5c");

var $7bmvO = parcelRequire("7bmvO");

var $dMTNw = parcelRequire("dMTNw");

var $iuPyo = parcelRequire("iuPyo");

var $3UPj8 = parcelRequire("3UPj8");
var $8P1DV = parcelRequire("8P1DV");
var $1AZSA = parcelRequire("1AZSA");
var $bE3Cg = parcelRequire("bE3Cg");
var $6VlkC = parcelRequire("6VlkC");
var $35gFN = parcelRequire("35gFN");
var $4433681b335e918c$export$5ef831fccfce35e5 = [
    new (0, $2zF9F).InboundFilters(),
    new (0, $2zF9F).FunctionToString(),
    new (0, $6VlkC.TryCatch)(),
    new (0, $3UPj8.Breadcrumbs)(),
    new (0, $1AZSA.GlobalHandlers)(),
    new (0, $bE3Cg.LinkedErrors)(),
    new (0, $8P1DV.Dedupe)(),
    new (0, $35gFN.UserAgent)()
];
function $4433681b335e918c$export$2cd8252107eb640b(options) {
    if (options === void 0) options = {};
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $4433681b335e918c$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        var window_1 = (0, $lrp9R.getGlobalObject)();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) options.release = window_1.SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    (0, $c9Yw8.initAndBind)((0, $7bmvO.BrowserClient), options);
    if (options.autoSessionTracking) $4433681b335e918c$var$startSessionTracking();
}
function $4433681b335e918c$export$3a8fd680da42627b(options) {
    if (options === void 0) options = {};
    var hub = (0, $ir14T.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) options.user = (0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, scope.getUser()), options.user);
    if (!options.eventId) options.eventId = hub.lastEventId();
    var client = hub.getClient();
    if (client) client.showReportDialog(options);
}
function $4433681b335e918c$export$5d4e9fd7fac8e617() {
    return (0, $ir14T.getCurrentHub)().lastEventId();
}
function $4433681b335e918c$export$a3f323d81eede727() {
// Noop
}
function $4433681b335e918c$export$4e4d8b287d028b6b(callback) {
    callback();
}
function $4433681b335e918c$export$4909b86c8034bf73(timeout) {
    var client = (0, $ir14T.getCurrentHub)().getClient();
    if (client) return client.flush(timeout);
    (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn('Cannot flush events. No client defined.');
    return (0, $bdF5c.resolvedSyncPromise)(false);
}
function $4433681b335e918c$export$8360e631d277ea4d(timeout) {
    var client = (0, $ir14T.getCurrentHub)().getClient();
    if (client) return client.close(timeout);
    (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return (0, $bdF5c.resolvedSyncPromise)(false);
}
function $4433681b335e918c$export$4997ffc0176396a6(fn) {
    return (0, $iuPyo.wrap)(fn)();
}
function $4433681b335e918c$var$startSessionOnHub(hub) {
    hub.startSession({
        ignoreDuration: true
    });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $4433681b335e918c$var$startSessionTracking() {
    var window = (0, $lrp9R.getGlobalObject)();
    var document = window.document;
    if (typeof document === 'undefined') {
        (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    var hub = (0, $ir14T.getCurrentHub)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) return;
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    $4433681b335e918c$var$startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0, $aVmXt.addInstrumentationHandler)('history', function(_a) {
        var from = _a.from, to = _a.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) $4433681b335e918c$var$startSessionOnHub((0, $ir14T.getCurrentHub)());
    });
}

});
parcelRegister("c9Yw8", function(module, exports) {
$parcel$export(module.exports, "initAndBind", () => $0248dbf2af0a53d3$export$5333c3f1c58d9bc1);

var $ir14T = parcelRequire("ir14T");
parcelRequire("i0afJ");
var $1v4ZC = parcelRequire("1v4ZC");

var $kT3vf = parcelRequire("kT3vf");
function $0248dbf2af0a53d3$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $kT3vf.IS_DEBUG_BUILD) (0, $1v4ZC.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        // eslint-disable-next-line no-console
        console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
    var hub = (0, $ir14T.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) scope.update(options.initialScope);
    var client = new clientClass(options);
    hub.bindClient(client);
}

});

parcelRegister("2zF9F", function(module, exports) {
$parcel$export(module.exports, "FunctionToString", () => (parcelRequire("gE0zC")).FunctionToString);
$parcel$export(module.exports, "InboundFilters", () => (parcelRequire("bRs5l")).InboundFilters);

var $gE0zC = parcelRequire("gE0zC");

var $bRs5l = parcelRequire("bRs5l");

});
parcelRegister("gE0zC", function(module, exports) {
$parcel$export(module.exports, "FunctionToString", () => $0320878b0eb1bc48$export$da4704525c20ae79);
parcelRequire("i0afJ");
var $909Vl = parcelRequire("909Vl");
var $0320878b0eb1bc48$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ var $0320878b0eb1bc48$export$da4704525c20ae79 = /** @class */ function() {
    function FunctionToString() {
        /**
         * @inheritDoc
         */ this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */ FunctionToString.prototype.setupOnce = function() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        $0320878b0eb1bc48$var$originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var context = (0, $909Vl.getOriginalFunction)(this) || this;
            return $0320878b0eb1bc48$var$originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */ FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}();

});

parcelRegister("bRs5l", function(module, exports) {
$parcel$export(module.exports, "InboundFilters", () => $8a2a6e19902cb07e$export$2ffbb5359dcc6be4);

var $iTWOe = parcelRequire("iTWOe");
parcelRequire("i0afJ");
var $73JtC = parcelRequire("73JtC");
var $9k3Oz = parcelRequire("9k3Oz");
var $1v4ZC = parcelRequire("1v4ZC");

var $kT3vf = parcelRequire("kT3vf");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var $8a2a6e19902cb07e$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
/** Inbound filters configurable by the user */ var $8a2a6e19902cb07e$export$2ffbb5359dcc6be4 = /** @class */ function() {
    function InboundFilters(_options) {
        if (_options === void 0) _options = {};
        this._options = _options;
        /**
         * @inheritDoc
         */ this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */ InboundFilters.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var hub = getCurrentHub();
            if (hub) {
                var self_1 = hub.getIntegration(InboundFilters);
                if (self_1) {
                    var client = hub.getClient();
                    var clientOptions = client ? client.getOptions() : {};
                    var options = $8a2a6e19902cb07e$export$6620a151868b99aa(self_1._options, clientOptions);
                    return $8a2a6e19902cb07e$export$3c6361fddf6cd929(event, options) ? null : event;
                }
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}();
function $8a2a6e19902cb07e$export$6620a151868b99aa(internalOptions, clientOptions) {
    if (internalOptions === void 0) internalOptions = {};
    if (clientOptions === void 0) clientOptions = {};
    return {
        allowUrls: (0, $iTWOe.__spread)(internalOptions.whitelistUrls || [], internalOptions.allowUrls || [], clientOptions.whitelistUrls || [], clientOptions.allowUrls || []),
        denyUrls: (0, $iTWOe.__spread)(internalOptions.blacklistUrls || [], internalOptions.denyUrls || [], clientOptions.blacklistUrls || [], clientOptions.denyUrls || []),
        ignoreErrors: (0, $iTWOe.__spread)(internalOptions.ignoreErrors || [], clientOptions.ignoreErrors || [], $8a2a6e19902cb07e$var$DEFAULT_IGNORE_ERRORS),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $8a2a6e19902cb07e$export$3c6361fddf6cd929(event, options) {
    if (options.ignoreInternal && $8a2a6e19902cb07e$var$_isSentryError(event)) {
        (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn("Event dropped due to being internal Sentry Error.\nEvent: " + (0, $73JtC.getEventDescription)(event));
        return true;
    }
    if ($8a2a6e19902cb07e$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + (0, $73JtC.getEventDescription)(event));
        return true;
    }
    if ($8a2a6e19902cb07e$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + (0, $73JtC.getEventDescription)(event) + ".\nUrl: " + $8a2a6e19902cb07e$var$_getEventFilterUrl(event));
        return true;
    }
    if (!$8a2a6e19902cb07e$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + (0, $73JtC.getEventDescription)(event) + ".\nUrl: " + $8a2a6e19902cb07e$var$_getEventFilterUrl(event));
        return true;
    }
    return false;
}
function $8a2a6e19902cb07e$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors || !ignoreErrors.length) return false;
    return $8a2a6e19902cb07e$var$_getPossibleEventMessages(event).some(function(message) {
        return ignoreErrors.some(function(pattern) {
            return (0, $9k3Oz.isMatchingPattern)(message, pattern);
        });
    });
}
function $8a2a6e19902cb07e$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    var url = $8a2a6e19902cb07e$var$_getEventFilterUrl(event);
    return !url ? false : denyUrls.some(function(pattern) {
        return (0, $9k3Oz.isMatchingPattern)(url, pattern);
    });
}
function $8a2a6e19902cb07e$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    var url = $8a2a6e19902cb07e$var$_getEventFilterUrl(event);
    return !url ? true : allowUrls.some(function(pattern) {
        return (0, $9k3Oz.isMatchingPattern)(url, pattern);
    });
}
function $8a2a6e19902cb07e$var$_getPossibleEventMessages(event) {
    if (event.message) return [
        event.message
    ];
    if (event.exception) try {
        var _a = event.exception.values && event.exception.values[0] || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
        return [
            "" + value,
            type + ": " + value
        ];
    } catch (oO) {
        (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).error("Cannot extract message for event " + (0, $73JtC.getEventDescription)(event));
        return [];
    }
    return [];
}
function $8a2a6e19902cb07e$var$_isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $8a2a6e19902cb07e$var$_getLastValidUrl(frames) {
    if (frames === void 0) frames = [];
    for(var i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $8a2a6e19902cb07e$var$_getEventFilterUrl(event) {
    try {
        if (event.stacktrace) return $8a2a6e19902cb07e$var$_getLastValidUrl(event.stacktrace.frames);
        var frames_1;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames_1 = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames_1 ? $8a2a6e19902cb07e$var$_getLastValidUrl(frames_1) : null;
    } catch (oO) {
        (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).error("Cannot extract url for event " + (0, $73JtC.getEventDescription)(event));
        return null;
    }
}

});


parcelRegister("8P1DV", function(module, exports) {
$parcel$export(module.exports, "Dedupe", () => $66c45c6668ea1dba$export$688d98c249d31ad3);
parcelRequire("i0afJ");
var $1v4ZC = parcelRequire("1v4ZC");

var $dMTNw = parcelRequire("dMTNw");
/** Deduplication filter */ var $66c45c6668ea1dba$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($66c45c6668ea1dba$var$_shouldDropEvent(currentEvent, self._previousEvent)) {
                        (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
/** JSDoc */ function $66c45c6668ea1dba$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($66c45c6668ea1dba$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($66c45c6668ea1dba$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $66c45c6668ea1dba$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$66c45c6668ea1dba$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$66c45c6668ea1dba$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $66c45c6668ea1dba$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $66c45c6668ea1dba$var$_getExceptionFromEvent(previousEvent);
    var currentException = $66c45c6668ea1dba$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$66c45c6668ea1dba$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$66c45c6668ea1dba$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $66c45c6668ea1dba$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $66c45c6668ea1dba$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $66c45c6668ea1dba$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $66c45c6668ea1dba$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $66c45c6668ea1dba$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $66c45c6668ea1dba$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}

});

parcelRegister("1AZSA", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => $12992736a5b27478$export$204155decbc90e5a);

var $iTWOe = parcelRequire("iTWOe");

var $ir14T = parcelRequire("ir14T");

var $iYYET = parcelRequire("iYYET");
parcelRequire("i0afJ");
var $73JtC = parcelRequire("73JtC");
var $aVmXt = parcelRequire("aVmXt");
var $f9iVj = parcelRequire("f9iVj");
var $8rX8J = parcelRequire("8rX8J");
var $1v4ZC = parcelRequire("1v4ZC");

var $QEOc2 = parcelRequire("QEOc2");

var $dMTNw = parcelRequire("dMTNw");

var $iuPyo = parcelRequire("iuPyo");
/** Global handlers */ var $12992736a5b27478$export$204155decbc90e5a = /** @class */ function() {
    /** JSDoc */ function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */ this.name = GlobalHandlers.id;
        /**
         * Stores references functions to installing handlers. Will set to undefined
         * after they have been run so that they are not used twice.
         */ this._installFunc = {
            onerror: $12992736a5b27478$var$_installGlobalOnErrorHandler,
            onunhandledrejection: $12992736a5b27478$var$_installGlobalOnUnhandledRejectionHandler
        };
        this._options = (0, $iTWOe.__assign)({
            onerror: true,
            onunhandledrejection: true
        }, options);
    }
    /**
     * @inheritDoc
     */ GlobalHandlers.prototype.setupOnce = function() {
        Error.stackTraceLimit = 50;
        var options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for(var key in options){
            var installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                $12992736a5b27478$var$globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    };
    /**
     * @inheritDoc
     */ GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}();
/** JSDoc */ function $12992736a5b27478$var$_installGlobalOnErrorHandler() {
    (0, $aVmXt.addInstrumentationHandler)('error', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(data) {
        var _a = (0, $iTWOe.__read)($12992736a5b27478$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($12992736a5b27478$export$204155decbc90e5a)) return;
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        if ((0, $iuPyo.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return;
        var event = error === undefined && (0, $8rX8J.isString)(msg) ? $12992736a5b27478$var$_eventFromIncompleteOnError(msg, url, line, column) : $12992736a5b27478$var$_enhanceEventWithInitialFrame((0, $QEOc2.eventFromUnknownInput)(error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = (0, $iYYET.Severity).Error;
        $12992736a5b27478$var$addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */ function $12992736a5b27478$var$_installGlobalOnUnhandledRejectionHandler() {
    (0, $aVmXt.addInstrumentationHandler)('unhandledrejection', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(e) {
        var _a = (0, $iTWOe.__read)($12992736a5b27478$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($12992736a5b27478$export$204155decbc90e5a)) return;
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) error = e.reason;
            else if ('detail' in e && 'reason' in e.detail) error = e.detail.reason;
        } catch (_oO) {
        // no-empty
        }
        if ((0, $iuPyo.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return true;
        var event = (0, $8rX8J.isPrimitive)(error) ? $12992736a5b27478$var$_eventFromRejectionWithPrimitive(error) : (0, $QEOc2.eventFromUnknownInput)(error, undefined, attachStacktrace, true);
        event.level = (0, $iYYET.Severity).Error;
        $12992736a5b27478$var$addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $12992736a5b27478$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: " + String(reason)
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $12992736a5b27478$var$_eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = (0, $8rX8J.isErrorEvent)(msg) ? msg.message : msg;
    var name = 'Error';
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $12992736a5b27478$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $12992736a5b27478$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = event.exception = event.exception || {};
    // event.exception.values
    var ev = e.values = e.values || [];
    // event.exception.values[0]
    var ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    var ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    var ev0sf = ev0s.frames = ev0s.frames || [];
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0, $8rX8J.isString)(url) && url.length > 0 ? url : (0, $f9iVj.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $12992736a5b27478$var$globalHandlerLog(type) {
    (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).log("Global Handler attached: " + type);
}
function $12992736a5b27478$var$addMechanismAndCapture(hub, error, event, type) {
    (0, $73JtC.addExceptionMechanism)(event, {
        handled: false,
        type: type
    });
    hub.captureEvent(event, {
        originalException: error
    });
}
function $12992736a5b27478$var$getHubAndAttachStacktrace() {
    var hub = (0, $ir14T.getCurrentHub)();
    var client = hub.getClient();
    var attachStacktrace = client && client.getOptions().attachStacktrace;
    return [
        hub,
        attachStacktrace
    ];
}

});

parcelRegister("bE3Cg", function(module, exports) {
$parcel$export(module.exports, "LinkedErrors", () => $87a63c3cb8501c4d$export$8d1e60aaf616fb4f);

var $iTWOe = parcelRequire("iTWOe");

var $FnrKW = parcelRequire("FnrKW");
var $ir14T = parcelRequire("ir14T");
parcelRequire("i0afJ");
var $8rX8J = parcelRequire("8rX8J");

var $QEOc2 = parcelRequire("QEOc2");
var $87a63c3cb8501c4d$var$DEFAULT_KEY = 'cause';
var $87a63c3cb8501c4d$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ var $87a63c3cb8501c4d$export$8d1e60aaf616fb4f = /** @class */ function() {
    /**
     * @inheritDoc
     */ function LinkedErrors(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = LinkedErrors.id;
        this._key = options.key || $87a63c3cb8501c4d$var$DEFAULT_KEY;
        this._limit = options.limit || $87a63c3cb8501c4d$var$DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */ LinkedErrors.prototype.setupOnce = function() {
        (0, $FnrKW.addGlobalEventProcessor)(function(event, hint) {
            var self = (0, $ir14T.getCurrentHub)().getIntegration(LinkedErrors);
            return self ? $87a63c3cb8501c4d$export$7bd713d0612d8839(self._key, self._limit, event, hint) : event;
        });
    };
    /**
     * @inheritDoc
     */ LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}();
function $87a63c3cb8501c4d$export$7bd713d0612d8839(key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $8rX8J.isInstanceOf)(hint.originalException, Error)) return event;
    var linkedErrors = $87a63c3cb8501c4d$export$e4e3ecf6f8f76c75(limit, hint.originalException, key);
    event.exception.values = (0, $iTWOe.__spread)(linkedErrors, event.exception.values);
    return event;
}
function $87a63c3cb8501c4d$export$e4e3ecf6f8f76c75(limit, error, key, stack) {
    if (stack === void 0) stack = [];
    if (!(0, $8rX8J.isInstanceOf)(error[key], Error) || stack.length + 1 >= limit) return stack;
    var exception = (0, $QEOc2.exceptionFromError)(error[key]);
    return $87a63c3cb8501c4d$export$e4e3ecf6f8f76c75(limit, error[key], key, (0, $iTWOe.__spread)([
        exception
    ], stack));
}

});

parcelRegister("6VlkC", function(module, exports) {
$parcel$export(module.exports, "TryCatch", () => $50a89cf54a64a306$export$f1a018517668e6d3);

var $iTWOe = parcelRequire("iTWOe");
parcelRequire("i0afJ");
var $909Vl = parcelRequire("909Vl");
var $b8srE = parcelRequire("b8srE");
var $lrp9R = parcelRequire("lrp9R");

var $iuPyo = parcelRequire("iuPyo");
var $50a89cf54a64a306$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ var $50a89cf54a64a306$export$f1a018517668e6d3 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function TryCatch(options) {
        /**
         * @inheritDoc
         */ this.name = TryCatch.id;
        this._options = (0, $iTWOe.__assign)({
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true
        }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */ TryCatch.prototype.setupOnce = function() {
        var global = (0, $lrp9R.getGlobalObject)();
        if (this._options.setTimeout) (0, $909Vl.fill)(global, 'setTimeout', $50a89cf54a64a306$var$_wrapTimeFunction);
        if (this._options.setInterval) (0, $909Vl.fill)(global, 'setInterval', $50a89cf54a64a306$var$_wrapTimeFunction);
        if (this._options.requestAnimationFrame) (0, $909Vl.fill)(global, 'requestAnimationFrame', $50a89cf54a64a306$var$_wrapRAF);
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) (0, $909Vl.fill)(XMLHttpRequest.prototype, 'send', $50a89cf54a64a306$var$_wrapXHR);
        var eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $50a89cf54a64a306$var$DEFAULT_EVENT_TARGET;
            eventTarget.forEach($50a89cf54a64a306$var$_wrapEventTarget);
        }
    };
    /**
     * @inheritDoc
     */ TryCatch.id = 'TryCatch';
    return TryCatch;
}();
/** JSDoc */ function $50a89cf54a64a306$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var originalCallback = args[0];
        args[0] = (0, $iuPyo.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $b8srE.getFunctionName)(original)
                },
                handled: true,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $50a89cf54a64a306$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $iuPyo.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $b8srE.getFunctionName)(original)
                    },
                    handled: true,
                    type: 'instrument'
                }
            })
        ]);
    };
}
/** JSDoc */ function $50a89cf54a64a306$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach(function(prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $909Vl.fill)(xhr, prop, function(original) {
                var wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $b8srE.getFunctionName)(original)
                        },
                        handled: true,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                var originalFunction = (0, $909Vl.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $b8srE.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $iuPyo.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */ function $50a89cf54a64a306$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = (0, $lrp9R.getGlobalObject)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = global[target] && global[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $909Vl.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') fn.handleEvent = (0, $iuPyo.wrap)(fn.handleEvent.bind(fn), {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $b8srE.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $iuPyo.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $b8srE.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $909Vl.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
             * There are 2 possible scenarios here:
             *
             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
             * as a pass-through, and call original `removeEventListener` with it.
             *
             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
             *
             * When someone adds a handler prior to initialization, and then do it again, but after,
             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
             * to get rid of the initial handler and it'd stick there forever.
             */ var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});

parcelRegister("35gFN", function(module, exports) {
$parcel$export(module.exports, "UserAgent", () => $23eec5ae3af9d036$export$5fba5e10934a4faf);

var $iTWOe = parcelRequire("iTWOe");

var $FnrKW = parcelRequire("FnrKW");
var $ir14T = parcelRequire("ir14T");
parcelRequire("i0afJ");
var $lrp9R = parcelRequire("lrp9R");
var $23eec5ae3af9d036$var$global = (0, $lrp9R.getGlobalObject)();
/** UserAgent */ var $23eec5ae3af9d036$export$5fba5e10934a4faf = /** @class */ function() {
    function UserAgent() {
        /**
         * @inheritDoc
         */ this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */ UserAgent.prototype.setupOnce = function() {
        (0, $FnrKW.addGlobalEventProcessor)(function(event) {
            if ((0, $ir14T.getCurrentHub)().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!$23eec5ae3af9d036$var$global.navigator && !$23eec5ae3af9d036$var$global.location && !$23eec5ae3af9d036$var$global.document) return event;
                // grab as much info as exists and add it to the event
                var url = event.request && event.request.url || $23eec5ae3af9d036$var$global.location && $23eec5ae3af9d036$var$global.location.href;
                var referrer = ($23eec5ae3af9d036$var$global.document || {}).referrer;
                var userAgent = ($23eec5ae3af9d036$var$global.navigator || {}).userAgent;
                var headers = (0, $iTWOe.__assign)((0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, event.request && event.request.headers), referrer && {
                    Referer: referrer
                }), userAgent && {
                    'User-Agent': userAgent
                });
                var request = (0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, url && {
                    url: url
                }), {
                    headers: headers
                });
                return (0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, event), {
                    request: request
                });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ UserAgent.id = 'UserAgent';
    return UserAgent;
}();

});


parcelRegister("7sZPK", function(module, exports) {
$parcel$export(module.exports, "SDK_NAME", () => $56fb1cccf452cb35$export$ca61d37259221480);
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $56fb1cccf452cb35$export$ca61d37259221480 = 'sentry.javascript.browser';

});


parcelRegister("g55ns", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("1AZSA")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("6VlkC")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("3UPj8")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("bE3Cg")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("35gFN")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("8P1DV")).Dedupe);

var $1AZSA = parcelRequire("1AZSA");

var $6VlkC = parcelRequire("6VlkC");

var $3UPj8 = parcelRequire("3UPj8");

var $bE3Cg = parcelRequire("bE3Cg");

var $35gFN = parcelRequire("35gFN");

var $8P1DV = parcelRequire("8P1DV");

});

parcelRegister("e3MRU", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("6aT3D")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("bixL8")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("kV3i0")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("315mi")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("tw7ZC")).makeNewXHRTransport);

var $6aT3D = parcelRequire("6aT3D");

var $bixL8 = parcelRequire("bixL8");

var $kV3i0 = parcelRequire("kV3i0");

var $315mi = parcelRequire("315mi");

var $tw7ZC = parcelRequire("tw7ZC");

});


parcelRegister("74GWP", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $526a38a87f3794d6$export$64d6499adf9b2e51);
var $526a38a87f3794d6$var$FEDRAMP_MODERATE = 'fedramp-moderate';
// Ignored via go/ees005
/* eslint-disable require-unicode-regexp */ var $526a38a87f3794d6$var$FEDRAMP_HOSTNAME_REGEX = /atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/;
function $526a38a87f3794d6$export$64d6499adf9b2e51() {
    var _global$location;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === $526a38a87f3794d6$var$FEDRAMP_MODERATE;
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match($526a38a87f3794d6$var$FEDRAMP_HOSTNAME_REGEX);
    return matches ? matches.length > 0 : false;
}

});

parcelRegister("e6MoK", function(module, exports) {
$parcel$export(module.exports, "SERIALIZABLE_ATTRIBUTES", () => $a4572b1af67efb60$export$b5bdb04ea16a02e3);
$parcel$export(module.exports, "normaliseSentryBreadcrumbs", () => $a4572b1af67efb60$export$6f14342128c6eaa4);
var $a4572b1af67efb60$export$b5bdb04ea16a02e3 = [
    'data-test-id',
    'data-testid'
];
var $a4572b1af67efb60$var$WHITELISTED_ATTRIBNUTES = [
    'type',
    'name'
].concat($a4572b1af67efb60$export$b5bdb04ea16a02e3);
var $a4572b1af67efb60$var$REG_MATCH_NOTALLOWED_ATTRIBUTES = new RegExp("\\[(?!".concat($a4572b1af67efb60$var$WHITELISTED_ATTRIBNUTES.join('|'), ").*?\\]"), 'gmu');
// attributes may contain UGC that we need to strip out
// only allow type and name attributes
var $a4572b1af67efb60$var$sanitiseUiBreadcrumbMessage = function sanitiseUiBreadcrumbMessage(message) {
    return message.replace($a4572b1af67efb60$var$REG_MATCH_NOTALLOWED_ATTRIBUTES, '');
};
var $a4572b1af67efb60$export$6f14342128c6eaa4 = function normaliseSentryBreadcrumbs(breadcrumb) {
    var _ref = breadcrumb || {}, category = _ref.category;
    // allow "ui*"" category breadcrumbs, that include clicks and inputs on DOM elements
    // they may contain UGC that needs to be stripped out
    if (category !== null && category !== void 0 && category.startsWith('ui')) {
        // sentry can include the element attributes in the data
        // which may contain UGC that we need to strip out
        var sanitisedBreadCrumb = breadcrumb;
        var message = sanitisedBreadCrumb.message;
        if (message !== null && message !== undefined) sanitisedBreadCrumb.message = $a4572b1af67efb60$var$sanitiseUiBreadcrumbMessage(message);
        return breadcrumb;
    }
    return breadcrumb;
};

});

parcelRegister("jYDPM", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("8euzK").then(()=>parcelRequire('7xb0p'));

});



parcelRegister("caYHb", function(module, exports) {
$parcel$export(module.exports, "ValidationContext", () => $8dd5801438f5053b$export$d452675449e81987);
$parcel$export(module.exports, "ValidationContextProvider", () => $8dd5801438f5053b$export$5b655fe45447a548);

var $5FkrB = parcelRequire("5FkrB");
var $8dd5801438f5053b$export$d452675449e81987 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $8dd5801438f5053b$export$5b655fe45447a548 = $8dd5801438f5053b$export$d452675449e81987.Provider;

});

parcelRegister("ksTq8", function(module, exports) {
$parcel$export(module.exports, "renderExtension", () => $ee61698df3dcfcb6$export$b7482bdc8aff85e4);
$parcel$export(module.exports, "default", () => $ee61698df3dcfcb6$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $jJH6F = parcelRequire("jJH6F");

var $c6bEO = parcelRequire("c6bEO");
var $01HkO = parcelRequire("01HkO");

var $2XMn4 = parcelRequire("2XMn4");

var $50U6m = parcelRequire("50U6m");

var $drUcN = parcelRequire("drUcN");

var $53SBn = parcelRequire("53SBn");

var $4chaE = parcelRequire("4chaE");

var $2TWiQ = parcelRequire("2TWiQ");
var $ee61698df3dcfcb6$var$FORGE_EXTENSION_TYPE = 'com.atlassian.ecosystem';
/**
 * Mirrors `FORGE_INLINE_BODIED_PARAM` in `@atlassian/xen-editor-provider`. Duplicated rather than
 * imported: the renderer must not depend on a Forge package, and this is a stored parameter name,
 * so it is part of the document contract rather than that package's API.
 */ var $ee61698df3dcfcb6$var$FORGE_INLINE_BODIED_PARAM = 'atlassianForgeInlineBodied';
var $ee61698df3dcfcb6$var$viewportSizes = [
    'small',
    'medium',
    'default',
    'large',
    'xlarge'
];
// Mirrors sizes from https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/platform/packages/forge/xen-editor-provider/src/render/renderers/ForgeUIExtension.tsx
var $ee61698df3dcfcb6$var$macroHeights = {
    small: '112px',
    medium: '262px',
    default: '262px',
    large: '524px',
    xlarge: '1048px'
};
var $ee61698df3dcfcb6$var$getViewportSize = function getViewportSize(extensionId, extensionViewportSizes) {
    if (!Array.isArray(extensionViewportSizes) || !extensionId) return;
    var extension = extensionViewportSizes.find(function(extension) {
        return extension.extensionId === extensionId;
    });
    if (extension) {
        var viewportSize = extension.viewportSize && $ee61698df3dcfcb6$var$viewportSizes.includes(extension.viewportSize) ? extension.viewportSize : 'default';
        return $ee61698df3dcfcb6$var$macroHeights[viewportSize];
    }
};
var $ee61698df3dcfcb6$var$containerStyle = (0, $74Zh5.css)({
    containerType: 'inline-size'
});
/**
 * Fires an analytics event once on mount when a bodied extension is rendered as an inline element.
 * The node is stored in a ref to avoid re-firing if the node reference changes.
 */ var $ee61698df3dcfcb6$var$FireExtensionAsInlineAnalytics = function FireExtensionAsInlineAnalytics(_ref) {
    var fireAnalyticsEvent = _ref.fireAnalyticsEvent, node = _ref.node;
    var nodeRef = (0, $5FkrB.useRef)(node);
    (0, $5FkrB.useEffect)(function() {
        fireAnalyticsEvent({
            action: (0, $jJH6F.ACTION).RENDERED,
            actionSubject: (0, $jJH6F.ACTION_SUBJECT).EXTENSION_AS_INLINE,
            actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).EXTENSION_BODIED,
            attributes: {
                extensionKey: nodeRef.current.extensionKey,
                extensionType: nodeRef.current.extensionType
            },
            eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL
        });
    }, [
        fireAnalyticsEvent
    ]);
    return null;
};
var $ee61698df3dcfcb6$export$b7482bdc8aff85e4 = function renderExtension(content, layout) {
    var _node$parameters, _node$parameters2;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var removeOverflow = arguments.length > 3 ? arguments[3] : undefined;
    var extensionId = arguments.length > 4 ? arguments[4] : undefined;
    var extensionViewportSizes = arguments.length > 5 ? arguments[5] : undefined;
    var nodeHeight = arguments.length > 6 ? arguments[6] : undefined;
    var localId = arguments.length > 7 ? arguments[7] : undefined;
    var shouldDisplayExtensionAsInline = arguments.length > 8 ? arguments[8] : undefined;
    var node = arguments.length > 9 ? arguments[9] : undefined;
    var isInsideOfInlineExtension = arguments.length > 10 ? arguments[10] : undefined;
    var overflowContainerClass = !removeOverflow ? (0, $53SBn.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    // by default, we assume the extension is at top level, (direct child of doc node)
    var _ref2 = options || {}, _ref2$isTopLevel = _ref2.isTopLevel, isTopLevel = _ref2$isTopLevel === void 0 ? true : _ref2$isTopLevel, rendererAppearance = _ref2.rendererAppearance, fireAnalyticsEvent = _ref2.fireAnalyticsEvent;
    // we should only use custom layout for full-page appearance
    var canUseCustomLayout = (0, $drUcN.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? rendererAppearance === 'full-page' : true;
    var isCustomLayout = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && canUseCustomLayout;
    var centerAlignClass = isCustomLayout ? (0, $53SBn.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    /**
   * To reduce cumulative layout shift, we check installed manifest values (viewportSize) for Forge and extension node parameters
   * for Connect (legacy). As Connect is being phased out, we want Forge to also start to store its expected height
   * in node parameters, especially for dynamic content macros. LegacyMacroStyledElements implements logic similar to here
   * as the extension handler in CFE for legacy macros and Connect.
   */ var viewportSize = $ee61698df3dcfcb6$var$getViewportSize(extensionId, extensionViewportSizes);
    var extensionHeight = nodeHeight || viewportSize;
    /**
   * Scoped to nodes inserted by an app declaring `layout: inline-bodied`, which is what writes
   * `atlassianForgeInlineBodied`. The output-type marker alone would also match migrated Connect
   * content — it carries the same marker, and after an upgrade plus a storage round trip in the
   * same shape — so keying on it would change how existing content renders. The renderer only
   * ever sees the stored node, never the manifest, so a parameter this code writes is the only
   * available signal.
   *
   * Evaluated once and shared with `isNativeForgeInline` below, so the gate is read a single time
   * per render, and the cheap checks stay in front of it so anything ineligible short-circuits
   * without firing an exposure it can never act on.
   */ var hasForgeInlineBodiedMarker = Boolean((node === null || node === void 0 ? void 0 : node.extensionType) === $ee61698df3dcfcb6$var$FORGE_EXTENSION_TYPE && (node === null || node === void 0 ? void 0 : node.content) && (node === null || node === void 0 || (_node$parameters = node.parameters) === null || _node$parameters === void 0 || (_node$parameters = _node$parameters.guestParams) === null || _node$parameters === void 0 ? void 0 : _node$parameters[$ee61698df3dcfcb6$var$FORGE_INLINE_BODIED_PARAM]) === 'true');
    var isForgeInlineBodiedEnabled = hasForgeInlineBodiedMarker && (0, $50U6m.fg)('platform_forge_inline_bodied_macro');
    var isInlineBodiedLayoutEnabled = (node === null || node === void 0 ? void 0 : node.extensionType) === $ee61698df3dcfcb6$var$FORGE_EXTENSION_TYPE && (node === null || node === void 0 ? void 0 : node.type) === 'bodiedExtension' && (node === null || node === void 0 || (_node$parameters2 = node.parameters) === null || _node$parameters2 === void 0 ? void 0 : _node$parameters2.layout) === 'inline-bodied' && (0, $50U6m.fg)('platform_forge_inline_bodied_layout_switch') && (0, $50U6m.fg)('platform_forge_inline_bodied_macro');
    /**
   * The pass that marks the sibling textblocks around an inline extension resolves their
   * positions without a depth term, so it only ever matches at the top level. Inlining a nested
   * container without joining its neighbours leaves a shrink-wrapped box alone on its own line,
   * which is worse than leaving it a block — so keep nested inline-bodied Forge macros as
   * blocks until the sibling marking works at depth.
   */ var isNestedForgeInlineBodied = !isTopLevel && (isForgeInlineBodiedEnabled || isInlineBodiedLayoutEnabled);
    var isInline = (shouldDisplayExtensionAsInline === null || shouldDisplayExtensionAsInline === void 0 ? void 0 : shouldDisplayExtensionAsInline(node)) && (0, $drUcN.expValEquals)('platform_editor_render_bodied_extension_as_inline', 'isEnabled', true) && !isNestedForgeInlineBodied;
    var inlineClassName = isInline ? (0, $53SBn.RendererCssClassName).EXTENSION_AS_INLINE : '';
    /**
   * A native Forge macro does not have its body rendered by the product — the body ADF is
   * sent to the app over the bridge and the app renders it with its own nested renderer.
   * The inline styling above stops at the outer wrapper, so mark these nodes to let the
   * nested document's block spacing be collapsed too.
   */ var isNativeForgeInline = Boolean(isInline && isForgeInlineBodiedEnabled);
    /**
   * Migrated inline-bodied macros intentionally do not receive the native Forge marker. Mark the
   * rendered wrapper instead so the stylesheet can fix only the surrounding text flow without
   * applying the native nested-renderer, overflow or sizing rules to migrated content.
   * Custom UI also uses this outer text-flow treatment, without styling inside its iframe.
   */ var isMigratedInlineBodied = Boolean(isInline && (node === null || node === void 0 ? void 0 : node.content) && !hasForgeInlineBodiedMarker && (0, $50U6m.fg)('platform_forge_inline_bodied_macro'));
    var asInlineAnalytics = isInline && fireAnalyticsEvent && node ? (0, $74Zh5.jsx)($ee61698df3dcfcb6$var$FireExtensionAsInlineAnalytics, {
        fireAnalyticsEvent: fireAnalyticsEvent,
        node: node
    }) : null;
    if ((0, $drUcN.expValEquals)('platform_editor_renderer_extension_width_fix', 'isEnabled', true)) {
        var extensionDiv = (0, $74Zh5.jsx)("div", {
            ref: options.handleRef,
            className: "".concat((0, $53SBn.RendererCssClassName).EXTENSION, " ").concat(inlineClassName, " ").concat(options.shadowClassNames, " ").concat(centerAlignClass),
            style: {
                width: isInline ? undefined : ((0, $drUcN.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $2TWiQ.calcBreakoutWidthCss)(layout) : (0, $drUcN.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? undefined : '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                minHeight: isInline ? undefined : extensionHeight && "".concat(extensionHeight, "px")
            },
            "data-layout": layout,
            "data-local-id": localId,
            "data-testid": "extension--wrapper",
            "data-node-type": "extension",
            "data-top-level": isTopLevel || undefined,
            "data-forge-inline": isNativeForgeInline || undefined,
            "data-migrated-inline": isMigratedInlineBodied || undefined
        }, (0, $74Zh5.jsx)("div", {
            tabIndex: options.tabIndex,
            className: "".concat((0, $53SBn.RendererCssClassName).EXTENSION_INNER_WRAPPER, " ").concat(overflowContainerClass),
            css: [
                !isInsideOfInlineExtension && $ee61698df3dcfcb6$var$containerStyle
            ]
        }, asInlineAnalytics, content));
        return centerAlignClass ? (0, $74Zh5.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $53SBn.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $53SBn.RendererCssClassName).FLEX_CENTER_WRAPPER
        }, extensionDiv) : extensionDiv;
    }
    return (0, $74Zh5.jsx)((0, $01HkO.WidthConsumer), null, function(_ref3) {
        var width = _ref3.width;
        var extensionDiv = (0, $74Zh5.jsx)("div", {
            ref: options.handleRef,
            className: "".concat((0, $53SBn.RendererCssClassName).EXTENSION, " ").concat(inlineClassName, " ").concat(options.shadowClassNames, " ").concat(centerAlignClass),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: isInline ? undefined : ((0, $drUcN.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $2XMn4.calcBreakoutWidth)(layout, width) : (0, $drUcN.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? undefined : '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                minHeight: isInline ? undefined : "".concat(extensionHeight, "px")
            },
            "data-layout": layout,
            "data-local-id": localId,
            "data-top-level": isTopLevel || undefined,
            "data-forge-inline": isNativeForgeInline || undefined,
            "data-migrated-inline": isMigratedInlineBodied || undefined
        }, (0, $74Zh5.jsx)("div", {
            tabIndex: options.tabIndex,
            className: "".concat((0, $53SBn.RendererCssClassName).EXTENSION_INNER_WRAPPER, " ").concat(overflowContainerClass),
            css: [
                !isInsideOfInlineExtension && $ee61698df3dcfcb6$var$containerStyle
            ]
        }, asInlineAnalytics, content));
        return centerAlignClass ? (0, $74Zh5.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $53SBn.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $53SBn.RendererCssClassName).FLEX_CENTER_WRAPPER
        }, extensionDiv) : extensionDiv;
    });
};
var $ee61698df3dcfcb6$var$Extension = function Extension(props) {
    var text = props.text, _props$layout = props.layout, layout = _props$layout === void 0 ? 'default' : _props$layout, handleRef = props.handleRef, shadowClassNames = props.shadowClassNames, _props$path = props.path, path = _props$path === void 0 ? [] : _props$path, extensionViewportSizes = props.extensionViewportSizes, parameters = props.parameters, nodeHeight = props.nodeHeight, localId = props.localId, isInsideOfInlineExtension = props.isInsideOfInlineExtension;
    return (0, $74Zh5.jsx)((0, $4chaE.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        type: "extension"
    }), function(_ref4) {
        var _props$hideExtensionK;
        var isExtensionProviderPending = _ref4.isExtensionProviderPending, result = _ref4.result;
        try {
            // Return the result directly if it's a valid JSX.Element
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).isValidElement(result)) return $ee61698df3dcfcb6$export$b7482bdc8aff85e4(result, layout, {
                isTopLevel: path.length < 1,
                handleRef: handleRef,
                shadowClassNames: shadowClassNames,
                tabIndex: props.tabIndex,
                rendererAppearance: props.rendererAppearance
            }, undefined, parameters === null || parameters === void 0 ? void 0 : parameters.extensionId, extensionViewportSizes, nodeHeight, localId, undefined, undefined, isInsideOfInlineExtension);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        if (isExtensionProviderPending && (_props$hideExtensionK = props.hideExtensionKeysWhilePending) !== null && _props$hideExtensionK !== void 0 && _props$hideExtensionK.includes(props.extensionKey)) return (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null);
        // Always return default content if anything goes wrong
        return $ee61698df3dcfcb6$export$b7482bdc8aff85e4(text || 'extension', layout, {
            isTopLevel: path.length < 1,
            handleRef: handleRef,
            shadowClassNames: shadowClassNames,
            tabIndex: props.tabIndex,
            rendererAppearance: props.rendererAppearance
        }, undefined, parameters === null || parameters === void 0 ? void 0 : parameters.extensionId, extensionViewportSizes, nodeHeight, localId, undefined, undefined, isInsideOfInlineExtension);
    });
};
var $ee61698df3dcfcb6$var$_default_1 = (0, $c6bEO.default)($ee61698df3dcfcb6$var$Extension, {
    overflowSelector: ".".concat((0, $53SBn.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER)
});
var $ee61698df3dcfcb6$export$2e2bcd8739ae039 = $ee61698df3dcfcb6$var$_default_1;

});
parcelRegister("c6bEO", function(module, exports) {
$parcel$export(module.exports, "shadowClassNames", () => $8cef167b7eff7b79$export$4735dd2b0fa88aa5);
$parcel$export(module.exports, "default", () => $8cef167b7eff7b79$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $3ytat = parcelRequire("3ytat");

var $fcr5B = parcelRequire("fcr5B");
function $8cef167b7eff7b79$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $8cef167b7eff7b79$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $8cef167b7eff7b79$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($8cef167b7eff7b79$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $8cef167b7eff7b79$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
function $8cef167b7eff7b79$export$2e2bcd8739ae039(Component, options) {
    return /*#__PURE__*/ function(_React$Component) {
        function OverflowShadow() {
            var _this;
            (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, OverflowShadow);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = $8cef167b7eff7b79$var$_callSuper(this, OverflowShadow, [].concat(args));
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "overflowContainerWidth", 0);
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "state", {
                showLeftShadow: false,
                showRightShadow: false
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "handleScroll", function(event) {
                if (!_this.overflowContainer || event.target !== _this.overflowContainer || options.useShadowObserver) return;
                _this.updateShadows();
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "updateShadows", function() {
                if (options.useShadowObserver) return;
                _this.setState(function(prevState) {
                    if (!_this.overflowContainer) return;
                    var diff = _this.calcOverflowDiff();
                    var showRightShadow = diff > 0 && diff > _this.overflowContainer.scrollLeft;
                    var showLeftShadow = _this.showLeftShadow(_this.overflowContainer);
                    if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== _this.state.showRightShadow) return {
                        showLeftShadow: showLeftShadow,
                        showRightShadow: showRightShadow
                    };
                    return null;
                });
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "showLeftShadow", function(overflowContainer) {
                return !!overflowContainer && overflowContainer.scrollLeft > 0;
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "calcOverflowDiff", function() {
                if (!_this.overflowContainer) return 0;
                _this.diff = _this.calcScrollableWidth();
                return _this.diff - _this.overflowContainer.offsetWidth;
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "calcScrollableWidth", function() {
                if (!_this.scrollable && _this.overflowContainer) return _this.overflowContainer.scrollWidth;
                if (!_this.scrollable) return 0;
                var width = 0;
                for(var i = 0; i < _this.scrollable.length; i++){
                    var scrollableElement = _this.scrollable[i];
                    if ($8cef167b7eff7b79$var$isElementNode(scrollableElement)) width += scrollableElement.scrollWidth;
                }
                return width;
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "handleContainer", function(container) {
                if (!container || _this.container) return;
                _this.container = container;
                _this.overflowContainer = container.querySelector(options.overflowSelector);
                if (!_this.overflowContainer) _this.overflowContainer = container;
                if (options.useShadowObserver) {
                    _this.initShadowObserver();
                    return;
                }
                _this.updateShadows();
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                _this.overflowContainer.addEventListener('scroll', _this.handleScroll);
            });
            return _this;
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(OverflowShadow, _React$Component);
        return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(OverflowShadow, [
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (options.useShadowObserver) return this.shadowObserver && this.shadowObserver.dispose();
                    if (this.overflowContainer) // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.overflowContainer.removeEventListener('scroll', this.handleScroll);
                    this.updateShadows();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate() {
                    if (!options.useShadowObserver) this.updateShadows();
                }
            },
            {
                key: "initShadowObserver",
                value: function initShadowObserver() {
                    var _this2 = this;
                    if (this.shadowObserver || !this.overflowContainer) return;
                    this.shadowObserver = new (0, $3ytat.ShadowObserver)({
                        scrollContainer: this.overflowContainer,
                        onUpdateShadows: function onUpdateShadows(shadowStates) {
                            _this2.setState(function(prevState) {
                                var showLeftShadow = shadowStates.showLeftShadow, showRightShadow = shadowStates.showRightShadow;
                                if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== prevState.showRightShadow) return {
                                    showLeftShadow: showLeftShadow,
                                    showRightShadow: showRightShadow
                                };
                                return null;
                            });
                        }
                    });
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$props, _this$props2;
                    var _this$state = this.state, showLeftShadow = _this$state.showLeftShadow, showRightShadow = _this$state.showRightShadow;
                    var classNames = [
                        !((_this$props = this.props) !== null && _this$props !== void 0 && _this$props.disableTableOverflowShadow) && showRightShadow && $8cef167b7eff7b79$export$4735dd2b0fa88aa5.RIGHT_SHADOW,
                        !((_this$props2 = this.props) !== null && _this$props2 !== void 0 && _this$props2.disableTableOverflowShadow) && showLeftShadow && $8cef167b7eff7b79$export$4735dd2b0fa88aa5.LEFT_SHADOW,
                        options.useShadowObserver && (0, $fcr5B.shadowObserverClassNames).SHADOW_CONTAINER
                    ].filter(Boolean).join(' ');
                    /**
         * The widths have already been calculated to determine
         * showRightShadow and showLeftShadow. If either is true,
         * then the content is scrollable and we need to set the
         * tabIndex to 0 to allow the user to scroll the content
         * for a11y purposes.
         */ var hasOverflowScroll = showRightShadow || showLeftShadow;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                        handleRef: this.handleContainer,
                        tabIndex: hasOverflowScroll ? 0 : undefined,
                        shadowClassNames: classNames
                    }, this.props));
                }
            }
        ]);
    }((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component);
}
// Helper function to check if the passed node is of Element class
function $8cef167b7eff7b79$var$isElementNode(node) {
    return node.nodeType === 1;
}

});
parcelRegister("3ytat", function(module, exports) {
$parcel$export(module.exports, "ShadowObserver", () => $296b2c378a6b7159$export$51a5b28e4fb2dba2);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $aRQgo = parcelRequire("aRQgo");

var $fcr5B = parcelRequire("fcr5B");
var $296b2c378a6b7159$var$requestIdleCallback = function requestIdleCallback(fn) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.requestIdleCallback ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn) : window.requestAnimationFrame(fn);
};
var $296b2c378a6b7159$var$cancelIdleCallback = function cancelIdleCallback(id) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.cancelIdleCallback ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.cancelIdleCallback(id) : window.cancelAnimationFrame(id);
};
var $296b2c378a6b7159$export$51a5b28e4fb2dba2 = /*#__PURE__*/ function() {
    function ShadowObserver(_ref) {
        var _this = this;
        var scrollContainer = _ref.scrollContainer, onUpdateShadows = _ref.onUpdateShadows;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ShadowObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sentinels", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "shadowStates", (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $aRQgo.ShadowKeys).SHOW_LEFT_SHADOW, false), (0, $aRQgo.ShadowKeys).SHOW_RIGHT_SHADOW, false));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "init", function() {
            if (!_this.scrollContainer || _this.intersectionObserver) return;
            _this.sentinels.right = document.createElement('div');
            _this.sentinels.right.classList.add((0, $fcr5B.shadowObserverClassNames).SENTINEL_RIGHT);
            _this.scrollContainer.appendChild(_this.sentinels.right);
            _this.sentinels.left = document.createElement('div');
            _this.sentinels.left.classList.add((0, $fcr5B.shadowObserverClassNames).SENTINEL_LEFT);
            _this.scrollContainer.prepend(_this.sentinels.left);
            _this.intersectionObserver = new IntersectionObserver(function(entries, _) {
                entries.forEach(_this.onIntersect);
            }, {
                root: _this.scrollContainer,
                rootMargin: '1px'
            });
            _this.intersectionObserver.observe(_this.sentinels.left);
            _this.intersectionObserver.observe(_this.sentinels.right);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "onIntersect", function(entry) {
            _this.requestCallbackId = $296b2c378a6b7159$var$requestIdleCallback(function() {
                if (entry.target.classList.contains((0, $fcr5B.shadowObserverClassNames).SENTINEL_LEFT)) _this.shadowStates[(0, $aRQgo.ShadowKeys).SHOW_LEFT_SHADOW] = !entry.isIntersecting;
                if (entry.target.classList.contains((0, $fcr5B.shadowObserverClassNames).SENTINEL_RIGHT)) _this.shadowStates[(0, $aRQgo.ShadowKeys).SHOW_RIGHT_SHADOW] = !entry.isIntersecting;
                _this.onUpdateShadows(_this.shadowStates);
            });
        });
        this.scrollContainer = scrollContainer;
        this.onUpdateShadows = onUpdateShadows;
        this.init();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ShadowObserver, [
        {
            key: "dispose",
            value: function dispose() {
                var _this$sentinels$left, _this$sentinels$right;
                if (this.intersectionObserver) {
                    this.intersectionObserver.disconnect();
                    this.intersectionObserver = undefined;
                    this.requestCallbackId && $296b2c378a6b7159$var$cancelIdleCallback(this.requestCallbackId);
                }
                (_this$sentinels$left = this.sentinels.left) === null || _this$sentinels$left === void 0 || _this$sentinels$left.remove();
                (_this$sentinels$right = this.sentinels.right) === null || _this$sentinels$right === void 0 || _this$sentinels$right.remove();
                this.sentinels = {};
            }
        }
    ]);
}();

});
parcelRegister("aRQgo", function(module, exports) {
$parcel$export(module.exports, "ShadowKeys", () => $7e97650ef7f54909$export$ebeea2fe2e93862e);
var $7e97650ef7f54909$export$ebeea2fe2e93862e = /*#__PURE__*/ function(ShadowKeys) {
    ShadowKeys["SHOW_LEFT_SHADOW"] = "showLeftShadow";
    ShadowKeys["SHOW_RIGHT_SHADOW"] = "showRightShadow";
    return ShadowKeys;
}({});

});

parcelRegister("fcr5B", function(module, exports) {
$parcel$export(module.exports, "shadowObserverClassNames", () => $b10cfd63efa24eba$export$1cbe0bb16052178d);
var $b10cfd63efa24eba$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};

});



parcelRegister("2XMn4", function(module, exports) {
$parcel$export(module.exports, "breakoutConsts", () => $22869cf5d7d3b0ac$export$ead1fecec2ecf57c);
$parcel$export(module.exports, "absoluteBreakoutWidth", () => $22869cf5d7d3b0ac$export$b34ea040d1533a3);
$parcel$export(module.exports, "calcWideWidth", () => $22869cf5d7d3b0ac$export$86325001fe8f3adc);
$parcel$export(module.exports, "calcBreakoutWidth", () => $22869cf5d7d3b0ac$export$5f4502874a28dfce);

var $1LBcl = parcelRequire("1LBcl");

var $kMHA5 = parcelRequire("kMHA5");

var $01HkO = parcelRequire("01HkO");

var $d9gaQ = parcelRequire("d9gaQ");




/**
 * Variables required to construct a context for breakout ssr inline script.
 *
 * TODO: Clean this up after: https://product-fabric.atlassian.net/browse/ED-8942
 *
 */ var $22869cf5d7d3b0ac$export$ead1fecec2ecf57c = {
    padding: (0, $1LBcl.akEditorBreakoutPadding),
    defaultLayoutWidth: (0, $1LBcl.akEditorDefaultLayoutWidth),
    wideScaleRatio: (0, $1LBcl.breakoutWideScaleRatio),
    fullWidthLayoutWidth: (0, $1LBcl.akEditorFullWidthLayoutWidth),
    wideLayoutWidth: (0, $1LBcl.akEditorWideLayoutWidth),
    mapBreakpointToLayoutMaxWidth: (0, $kMHA5.mapBreakpointToLayoutMaxWidth),
    getBreakpoint: (0, $01HkO.getBreakpoint),
    /**
   * This function can return percentage value or px value depending upon the inputs
   */ calcBreakoutWidth: function calcBreakoutWidth(breakoutConsts) {
        return function(layout, containerWidth, padding) {
            var effectiveFullWidth = containerWidth - (padding !== null && padding !== void 0 ? padding : breakoutConsts.padding);
            switch(layout){
                case 'full-width':
                    return "".concat(Math.min(effectiveFullWidth, breakoutConsts.fullWidthLayoutWidth), "px");
                case 'wide':
                    if (effectiveFullWidth <= 0) return '100%';
                    var wideWidth = breakoutConsts.calcWideWidth(breakoutConsts)(containerWidth, undefined, undefined, padding);
                    if (wideWidth.endsWith('%')) return "".concat(Math.min(effectiveFullWidth, breakoutConsts.fullWidthLayoutWidth), "px");
                    return wideWidth;
                default:
                    return '100%';
            }
        };
    },
    calcBreakoutWithCustomWidth: function calcBreakoutWithCustomWidth(breakoutConsts) {
        return function(mode, width, editorContainerWidth) {
            if (width !== null && width > 0) {
                var effectiveFullWidth = editorContainerWidth - breakoutConsts.padding;
                // if below 0 then expect we're rendering in SSR
                return "".concat(Math.min(width, effectiveFullWidth), "px");
            }
            return breakoutConsts.calcBreakoutWidth(breakoutConsts)(mode, editorContainerWidth);
        };
    },
    calcLineLength: function calcLineLength(breakoutConsts) {
        return function() {
            return breakoutConsts.defaultLayoutWidth;
        };
    },
    calcWideWidth: function calcWideWidth(breakoutConsts) {
        return function() {
            var containerWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : breakoutConsts.defaultLayoutWidth;
            var maxWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
            var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '100%';
            var padding = arguments.length > 3 ? arguments[3] : undefined;
            var effectiveFullWidth = containerWidth - (padding !== null && padding !== void 0 ? padding : breakoutConsts.padding);
            var layoutMaxWidth = breakoutConsts.mapBreakpointToLayoutMaxWidth(breakoutConsts.getBreakpoint(containerWidth));
            var wideWidth = Math.min(Math.ceil(layoutMaxWidth * breakoutConsts.wideScaleRatio), effectiveFullWidth);
            return layoutMaxWidth > wideWidth ? fallback : "".concat(Math.min(maxWidth, wideWidth), "px");
        };
    }
};
var $22869cf5d7d3b0ac$export$b34ea040d1533a3 = function absoluteBreakoutWidth(layout, containerWidth) {
    var breakoutWidth = $22869cf5d7d3b0ac$export$ead1fecec2ecf57c.calcBreakoutWidth($22869cf5d7d3b0ac$export$ead1fecec2ecf57c)(layout, containerWidth);
    // If it's percent, map to max layout size
    if (breakoutWidth.endsWith('%')) switch(layout){
        case 'full-width':
            return 0, $1LBcl.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $1LBcl.akEditorWideLayoutWidth;
        default:
            return $22869cf5d7d3b0ac$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($22869cf5d7d3b0ac$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
    }
    return parseInt(breakoutWidth, 10);
};
var $22869cf5d7d3b0ac$export$86325001fe8f3adc = $22869cf5d7d3b0ac$export$ead1fecec2ecf57c.calcWideWidth($22869cf5d7d3b0ac$export$ead1fecec2ecf57c);
var $22869cf5d7d3b0ac$export$5f4502874a28dfce = $22869cf5d7d3b0ac$export$ead1fecec2ecf57c.calcBreakoutWidth($22869cf5d7d3b0ac$export$ead1fecec2ecf57c);
var $22869cf5d7d3b0ac$export$ccc0a02edddeed39 = $22869cf5d7d3b0ac$export$ead1fecec2ecf57c.calcBreakoutWithCustomWidth($22869cf5d7d3b0ac$export$ead1fecec2ecf57c);
function $22869cf5d7d3b0ac$export$c377853ecdd53e5b(_ref) {
    var mode = _ref.mode, widthStateLineLength = _ref.widthStateLineLength, widthStateWidth = _ref.widthStateWidth;
    var breakoutWidth = $22869cf5d7d3b0ac$export$5f4502874a28dfce(mode, widthStateWidth);
    var breakoutWidthPx = (0, $d9gaQ.parsePx)(breakoutWidth);
    if (!widthStateLineLength) // lineLength is not normally undefined when this is run for,
    // consumers but can be in SSR, initial render or test (jsdom)
    // environments.
    //
    // this approach doesn't work well with position: fixed, so
    // it breaks things like sticky headers.
    //
    // It can also cause bluriness for some child content (such as iframes)
    return {
        type: 'line-length-unknown',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        display: 'flex',
        justifyContent: 'center',
        transform: 'none',
        transition: "min-width 0.5s ".concat((0, $1LBcl.akEditorSwoopCubicBezier))
    };
    // NOTE
    // At time of writing -- when toggling between full-width and
    // full-page appearance modes. There is a slight delay before
    // the widthState is updated.
    // During this period -- the marginLeftPx will be incorrect.
    // const marginLeftPx = -(breakoutWidthPx - widthStateLineLength) / 2;
    return {
        type: 'line-length-known',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        transition: "min-width 0.5s ".concat((0, $1LBcl.akEditorSwoopCubicBezier)),
        transform: "translateX(-50%)",
        marginLeft: "50%"
    };
}
function $22869cf5d7d3b0ac$export$586300c53bd298dd(mode, widthStateWidth, padding) {
    return (0, $d9gaQ.parsePx)($22869cf5d7d3b0ac$export$5f4502874a28dfce(mode, widthStateWidth, padding));
}

});
parcelRegister("kMHA5", function(module, exports) {
$parcel$export(module.exports, "mapBreakpointToLayoutMaxWidth", () => $f21a18a56af76a1e$export$b5ccf4d25d2c5af1);
$parcel$export(module.exports, "BaseTheme", () => $f21a18a56af76a1e$export$a1a213d350ca51ca);

var $5FkrB = parcelRequire("5FkrB");

var $rxpl9 = parcelRequire("rxpl9");

var $1LBcl = parcelRequire("1LBcl");

var $01HkO = parcelRequire("01HkO");
function $f21a18a56af76a1e$export$b5ccf4d25d2c5af1(breakpoint) {
    switch(breakpoint){
        case 'M':
        case 'L':
            return 760;
        default:
            return 680;
    }
}
function $f21a18a56af76a1e$export$3de34996b814f0f0(_ref) {
    var baseFontSize = _ref.baseFontSize, children = _ref.children;
    var memoizedTheme = (0, $5FkrB.useMemo)(function() {
        return {
            baseFontSize: baseFontSize || 14,
            layoutMaxWidth: (0, $1LBcl.akEditorDefaultLayoutWidth)
        };
    }, [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $rxpl9.b), {
        theme: memoizedTheme
    }, children);
}
function $f21a18a56af76a1e$export$a1a213d350ca51ca(_ref2) {
    var children = _ref2.children, baseFontSize = _ref2.baseFontSize;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $01HkO.WidthConsumer), null, function(_ref3) {
        var breakpoint = _ref3.breakpoint;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($f21a18a56af76a1e$export$3de34996b814f0f0, {
            breakpoint: breakpoint,
            baseFontSize: baseFontSize
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children));
    });
}

});

parcelRegister("d9gaQ", function(module, exports) {
$parcel$export(module.exports, "parsePx", () => $9928a96f92ddf0bd$export$b0eef8cd00b29d5c);
/**
 * Util for converting a css pixel size value to a number (of pixels).
 *
 * ie.
 * ```ts
 * const pixels = parsePx('10px')
 * //    ^$ const pixels: number
 * ```
 * * ```ts
 * const pixels = parsePx('10')
 * //    ^$ const pixels: number | undefined
 * ```
 */ // At time of writting prettier would strip the extend here.
// prettier-ignore
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $9928a96f92ddf0bd$export$b0eef8cd00b29d5c(pxStr) {
    if (!pxStr.endsWith('px')) return undefined;
    var maybeNumber = parseInt(pxStr, 10);
    return !Number.isNaN(maybeNumber) ? maybeNumber : undefined;
}

});


parcelRegister("2TWiQ", function(module, exports) {
$parcel$export(module.exports, "calcBreakoutWidthCss", () => $21cdf1999293e34b$export$87eeb477611c8fe);
var $21cdf1999293e34b$export$87eeb477611c8fe = function calcBreakoutWidthCss(layout) {
    if (layout === 'full-width') return 'min(var(--ak-editor--breakout-container-without-gutter-width), var(--ak-editor--full-width-layout-width))';
    if (layout === 'wide') return 'min(var(--ak-editor--breakout-container-without-gutter-width), var(--ak-editor--breakout-wide-layout-width))';
    return '100%';
};

});



parcelRegister("aJQyW", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d16e128cef916e6$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $gBea6 = parcelRequire("gBea6");

var $7q4H1 = parcelRequire("7q4H1");
function $7d16e128cef916e6$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("ul", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $gBea6.bulletListSelector).substr(1),
        "data-local-id": props.localId,
        "data-indent-level": props.path ? (0, $7q4H1.getListIndentLevel)(props.path) : 1
    }, props.children);
}

});
parcelRegister("7q4H1", function(module, exports) {
$parcel$export(module.exports, "getListIndentLevel", () => $566e9a0b72f23ba4$export$75aa84e85754623e);
function $566e9a0b72f23ba4$export$75aa84e85754623e(path) {
    var count = 1;
    path.forEach(function(node) {
        if (node.type.name === 'bulletList' || node.type.name === 'orderedList') count++;
    });
    return count;
}

});


parcelRegister("4piwi", function(module, exports) {
$parcel$export(module.exports, "default", () => $3357dcdf4d2a16f4$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $h2boL = parcelRequire("h2boL");
var $3357dcdf4d2a16f4$var$RenderCaption = function RenderCaption(_ref) {
    var children = _ref.children, dataAttributes = _ref.dataAttributes;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $h2boL.default), {
        hasContent: true,
        dataAttributes: dataAttributes
    }, children);
};
var $3357dcdf4d2a16f4$export$2e2bcd8739ae039 = $3357dcdf4d2a16f4$var$RenderCaption;

});
parcelRegister("h2boL", function(module, exports) {
$parcel$export(module.exports, "default", () => $c66b771491fe9957$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $ach6K = parcelRequire("ach6K");

var $4Pn6z = parcelRequire("4Pn6z");
var $ifpPH = parcelRequire("ifpPH");
var $gDiFE = parcelRequire("gDiFE");

var $cGH6O = parcelRequire("cGH6O");
function $c66b771491fe9957$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $c66b771491fe9957$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $c66b771491fe9957$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c66b771491fe9957$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $c66b771491fe9957$var$captionWrapperStyle = (0, $74Zh5.css)({
    marginTop: "var(--ds-space-100, 8px)",
    textAlign: 'center',
    position: 'relative',
    color: "var(--ds-text-subtle, #505258)"
});
var $c66b771491fe9957$var$placeholderStyle = (0, $gDiFE.xcss)({
    color: 'color.text.subtlest',
    position: 'absolute',
    top: 'space.0',
    width: '100%'
});
var $c66b771491fe9957$export$f7feb87190a94c76 = /*#__PURE__*/ function(_React$Component) {
    function CaptionComponent() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, CaptionComponent);
        return $c66b771491fe9957$var$_callSuper(this, CaptionComponent, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(CaptionComponent, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(CaptionComponent, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, selected = _this$props.selected, hasContent = _this$props.hasContent, children = _this$props.children, dataAttributes = _this$props.dataAttributes, formatMessage = _this$props.intl.formatMessage;
                var showPlaceholder = !selected && !hasContent;
                return (0, $74Zh5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                    "data-media-caption": true,
                    "data-testid": "media-caption"
                }, dataAttributes, {
                    css: $c66b771491fe9957$var$captionWrapperStyle
                }), showPlaceholder ? (0, $74Zh5.jsx)((0, $4Pn6z.Box), {
                    xcss: $c66b771491fe9957$var$placeholderStyle
                }, (0, $74Zh5.jsx)((0, $ifpPH.Text), null, formatMessage((0, $cGH6O.messages).placeholder))) : null, children);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component);
// eslint-disable-next-line @typescript-eslint/no-restricted-types
var $c66b771491fe9957$var$_default_1 = (0, $ach6K.default)($c66b771491fe9957$export$f7feb87190a94c76);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$c66b771491fe9957$export$2e2bcd8739ae039 = $c66b771491fe9957$var$_default_1;

});
parcelRegister("cGH6O", function(module, exports) {
$parcel$export(module.exports, "messages", () => $02623d4d982ffa32$export$defe85febe8b728c);

var $6bnW7 = parcelRequire("6bnW7");
var $02623d4d982ffa32$export$defe85febe8b728c = (0, $6bnW7.defineMessages)({
    placeholder: {
        id: 'fabric.editor.captionPlaceholder',
        defaultMessage: 'Add a caption',
        description: 'Placeholder description for an empty (new) caption in the editor'
    }
});

});



parcelRegister("ac0Rs", function(module, exports) {
$parcel$export(module.exports, "default", () => $76bbb165680518ac$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => $76bbb165680518ac$export$41121a410ca2f650);

var $5FkrB = parcelRequire("5FkrB");

var $53SBn = parcelRequire("53SBn");

var $lXWgS = parcelRequire("lXWgS");
function $76bbb165680518ac$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        className: (0, $53SBn.RendererCssClassName).DOCUMENT
    }, props.children);
}
function $76bbb165680518ac$export$41121a410ca2f650(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        ref: (0, $lXWgS.useSelectAllTrap)(),
        className: (0, $53SBn.RendererCssClassName).DOCUMENT
    }, props.children);
}

});
parcelRegister("lXWgS", function(module, exports) {
$parcel$export(module.exports, "useSelectAllTrap", () => $ffdc4f16ec2303eb$export$98871b245ee25215);

var $5FkrB = parcelRequire("5FkrB");

var $jJH6F = parcelRequire("jJH6F");

var $gPdZj = parcelRequire("gPdZj");

var $cYcab = parcelRequire("cYcab");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $ffdc4f16ec2303eb$var$MAC_PLATFORM_REGEX = /Mac/;
var $ffdc4f16ec2303eb$export$98871b245ee25215 = function useSelectAllTrap() {
    var _React$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useContext((0, $gPdZj.default)), fireAnalyticsEvent = _React$useContext.fireAnalyticsEvent;
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(null);
    var clicked = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(false);
    var caught = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef();
    var mac = typeof navigator !== 'undefined' ? $ffdc4f16ec2303eb$var$MAC_PLATFORM_REGEX.test(navigator.platform) : false;
    var onKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function(e) {
        var _e$target, _e$target$matches;
        var el = ref.current;
        if (!el) return;
        var modKey = mac ? e.metaKey : e.ctrlKey;
        if (!modKey || e.code !== 'KeyA' || e.shiftKey) return;
        var elementSelection = (0, $cYcab.ElementSelection).fromWindow();
        var isInput = (_e$target = e.target) === null || _e$target === void 0 || (_e$target$matches = _e$target.matches) === null || _e$target$matches === void 0 ? void 0 : _e$target$matches.call(_e$target, 'input');
        if (elementSelection.eq(caught.current) || isInput) {
            fireAnalyticsEvent({
                eventType: (0, $jJH6F.EVENT_TYPE).TRACK,
                action: (0, $jJH6F.ACTION).SELECT_ALL_ESCAPED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).RENDERER
            });
            return;
        }
        if (elementSelection.inside(el) || elementSelection.type === 'None' && clicked.current) {
            fireAnalyticsEvent({
                eventType: (0, $jJH6F.EVENT_TYPE).TRACK,
                action: (0, $jJH6F.ACTION).SELECT_ALL_CAUGHT,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).RENDERER
            });
            e.preventDefault();
            caught.current = elementSelection.select(el);
        }
    }, [
        mac,
        ref,
        fireAnalyticsEvent,
        clicked,
        caught
    ]);
    var onClick = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function(e) {
        var _ref$current$contains, _ref$current;
        clicked.current = (_ref$current$contains = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.contains(e.target)) !== null && _ref$current$contains !== void 0 ? _ref$current$contains : false;
    }, [
        ref,
        clicked
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('keydown', onKeyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('click', onClick);
        return function() {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('keydown', onKeyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('click', onClick);
        };
    }, [
        onKeyDown,
        onClick
    ]);
    return ref;
};

});
parcelRegister("gPdZj", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3fc4273f9997a70$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
var $c3fc4273f9997a70$var$AnalyticsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext({
    fireAnalyticsEvent: function fireAnalyticsEvent(_event) {
        return null;
    }
});
var $c3fc4273f9997a70$export$2e2bcd8739ae039 = $c3fc4273f9997a70$var$AnalyticsContext;

});

parcelRegister("cYcab", function(module, exports) {
$parcel$export(module.exports, "ElementSelection", () => $971485fb58fb0558$export$6e6724d89f27411);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");
var $971485fb58fb0558$export$6e6724d89f27411 = /*#__PURE__*/ function() {
    function ElementSelection(selection) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ElementSelection);
        this.type = selection ? selection.type : 'None';
        if (selection && this.type !== 'None') this.range = selection.getRangeAt(0);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ElementSelection, [
        {
            key: "eq",
            value: function eq(selection) {
                if (!selection) return false;
                if (this.range && selection.range) {
                    var _this$range, _this$range2;
                    var startMatches = ((_this$range = this.range) === null || _this$range === void 0 ? void 0 : _this$range.compareBoundaryPoints(Range.START_TO_START, selection.range)) === 0;
                    var endMatches = ((_this$range2 = this.range) === null || _this$range2 === void 0 ? void 0 : _this$range2.compareBoundaryPoints(Range.END_TO_END, selection.range)) === 0;
                    return startMatches && endMatches;
                }
                return this.type === 'None' && selection.type === 'None';
            }
        },
        {
            key: "inside",
            value: function inside(el) {
                var _this$range$commonAnc, _this$range3;
                return el.contains((_this$range$commonAnc = (_this$range3 = this.range) === null || _this$range3 === void 0 ? void 0 : _this$range3.commonAncestorContainer) !== null && _this$range$commonAnc !== void 0 ? _this$range$commonAnc : null);
            }
        },
        {
            key: "select",
            value: function select(el) {
                var range = document.createRange();
                range.selectNodeContents(el);
                var selection = window.getSelection();
                if (selection) {
                    selection.removeAllRanges();
                    selection.addRange(range);
                }
                return ElementSelection.fromWindow();
            }
        }
    ], [
        {
            key: "fromWindow",
            value: function fromWindow() {
                var win = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
                return new ElementSelection(win.getSelection());
            }
        }
    ]);
}();

});



parcelRegister("bHdFw", function(module, exports) {
$parcel$export(module.exports, "default", () => $883e5034413346f2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $74Zh5 = parcelRequire("74Zh5");
var $883e5034413346f2$var$containerCSS = (0, $74Zh5.css)({
    padding: "var(--ds-space-100, 8px)",
    minHeight: '100px',
    // by default all frames are hidden, this style is overridden in multiBodiedExtensions for active frame
    display: 'none'
});
var $883e5034413346f2$var$ExtensionFrame = function ExtensionFrame(props) {
    return (0, $74Zh5.jsx)("div", {
        css: [
            $883e5034413346f2$var$containerCSS
        ],
        "data-extension-frame": "true"
    }, props.children);
};
var $883e5034413346f2$export$2e2bcd8739ae039 = $883e5034413346f2$var$ExtensionFrame;

});

parcelRegister("2BMm8", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e648bfa1e354ef2$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
var $1e648bfa1e354ef2$var$HardBreak = function HardBreak(_ref) {
    var _ref$forceNewLine = _ref.forceNewLine, forceNewLine = _ref$forceNewLine === void 0 ? false : _ref$forceNewLine;
    // To display an empty line using Shift+Enter, ProseMirror inserts a
    // double <br>. The second <br> is not part of the document, it's just
    // there to make browsers behave properly. The forceNewLine prop in this
    // component replicates this behaviour. If the last child node is a
    // hardBreak, it will also insert a double <br>.
    if (forceNewLine) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("br", null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("br", null);
};
var $1e648bfa1e354ef2$export$2e2bcd8739ae039 = $1e648bfa1e354ef2$var$HardBreak;

});

parcelRegister("cLcT3", function(module, exports) {
$parcel$export(module.exports, "default", () => $94a3dee679077c6e$export$2e2bcd8739ae039);
/* heading.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $970q7 = parcelRequire("970q7");
var $cAVP0 = parcelRequire("cAVP0");

var $5FkrB = parcelRequire("5FkrB");

var $hrVKU = parcelRequire("hrVKU");

var $5yfDB = parcelRequire("5yfDB");

var $jJH6F = parcelRequire("jJH6F");

var $1LBcl = parcelRequire("1LBcl");

var $aMiKe = parcelRequire("aMiKe");

var $l0l26 = parcelRequire("l0l26");

var $drUcN = parcelRequire("drUcN");

var $e8kqY = parcelRequire("e8kqY");

var $gPdZj = parcelRequire("gPdZj");

var $3cXxO = parcelRequire("3cXxO");

var $9fs6o = parcelRequire("9fs6o");

var $bXlPp = parcelRequire("bXlPp");

var $fq8Dd = parcelRequire("fq8Dd");
var $94a3dee679077c6e$var$RENDERER_HEADING_WRAPPER = 'renderer-heading-wrapper';
var $94a3dee679077c6e$var$RENDERER_COLLAPSIBLE_HEADING_WRAPPER = 'renderer-collapsible-heading-wrapper';
var $94a3dee679077c6e$var$getCurrentUrlWithHash = function getCurrentUrlWithHash() {
    var hash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var url = new URL(window.location.href);
    url.search = ''; // clear any query params so that the page will correctly scroll to the anchor
    url.hash = encodeURIComponent(hash);
    return url.href;
};
function $94a3dee679077c6e$var$hasRightAlignmentMark(marks) {
    if (!marks || !marks.length) return false;
    return marks.some(function(mark) {
        return mark.type.name === 'alignment' && mark.attrs.align === 'end';
    });
}
var $94a3dee679077c6e$var$wrapperStyles = null;
var $94a3dee679077c6e$var$collapsibleHeadingWrapperStyles = null;
var $94a3dee679077c6e$var$collapsibleHeadingButtonStyles = null;
var $94a3dee679077c6e$var$collapsibleHeadingButtonExpandedStyles = null;
var $94a3dee679077c6e$var$collapsibleHeadingButtonHiddenStyles = null;
var $94a3dee679077c6e$var$ChevronRightSmallIcon = function ChevronRightSmallIcon() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aMiKe))), {
        label: "",
        size: "small"
    });
};
var $94a3dee679077c6e$var$hasFocusVisible = function hasFocusVisible(target) {
    try {
        return target.matches(':focus-visible');
    } catch (_unused) {
        return true;
    }
};
var $94a3dee679077c6e$var$getHeadingAnchorLinksConfig = function getHeadingAnchorLinksConfig(allowHeadingAnchorLinks) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(allowHeadingAnchorLinks) === 'object' ? allowHeadingAnchorLinks : undefined;
};
function $94a3dee679077c6e$var$WrappedHeadingAnchor(_ref) {
    var enableNestedHeaderLinks = _ref.enableNestedHeaderLinks, getHeadingLink = _ref.getHeadingLink, level = _ref.level, headingId = _ref.headingId, hideFromScreenReader = _ref.hideFromScreenReader;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gPdZj.default).Consumer, null, function(_ref2) {
        var fireAnalyticsEvent = _ref2.fireAnalyticsEvent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fq8Dd.default), {
            enableNestedHeaderLinks: enableNestedHeaderLinks,
            level: level,
            onCopyText: function onCopyText() {
                var _getHeadingLink;
                fireAnalyticsEvent({
                    action: (0, $jJH6F.ACTION).CLICKED,
                    actionSubject: (0, $jJH6F.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
                    eventType: (0, $jJH6F.EVENT_TYPE).UI
                });
                return (0, $bXlPp.copyTextToClipboard)((_getHeadingLink = getHeadingLink === null || getHeadingLink === void 0 ? void 0 : getHeadingLink(headingId)) !== null && _getHeadingLink !== void 0 ? _getHeadingLink : $94a3dee679077c6e$var$getCurrentUrlWithHash(headingId));
            },
            hideFromScreenReader: hideFromScreenReader,
            headingId: headingId
        });
    });
}
function $94a3dee679077c6e$var$CollapsibleHeadingButton(_ref3) {
    var collapsibleHeading = _ref3.collapsibleHeading, headingLevel = _ref3.headingLevel, isHeadingHovered = _ref3.isHeadingHovered;
    var intl = (0, $hrVKU.default)();
    var _React$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useContext((0, $gPdZj.default)), fireAnalyticsEvent = _React$useContext.fireAnalyticsEvent;
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(false), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState, 2), isFocused = _React$useState2[0], setIsFocused = _React$useState2[1];
    var isCollapsed = collapsibleHeading.isCollapsed, toggle = collapsibleHeading.toggle;
    var isVisible = isCollapsed || isFocused || isHeadingHovered;
    var handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function(event) {
        event.stopPropagation();
        fireAnalyticsEvent({
            action: (0, $jJH6F.ACTION).TOGGLED,
            actionSubject: (0, $jJH6F.ACTION_SUBJECT).HEADING,
            attributes: {
                expanded: isCollapsed,
                headingLevel: headingLevel
            },
            eventType: (0, $jJH6F.EVENT_TYPE).TRACK
        });
        toggle();
    }, [
        fireAnalyticsEvent,
        headingLevel,
        isCollapsed,
        toggle
    ]);
    var handleFocus = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function(event) {
        setIsFocused($94a3dee679077c6e$var$hasFocusVisible(event.target));
    }, []);
    var handleBlur = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function() {
        return setIsFocused(false);
    }, []);
    var handleKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function() {
        return setIsFocused(true);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        className: (0, $970q7.default)([
            "_kqswstnw _152tidpf _1e02idpf _1pbykb7n _l8kuuqm3 _wxvuglyw",
            !isCollapsed && "_12hn14w8",
            !isVisible && "_tzy4idpf _lcxvglyw _tza3kb7n _12yg1wug _xrqrkb7n _l4c51wug"
        ]),
        style: {
            "--_1vzp3at": (0, $cAVP0.default)("transform 0.2s ".concat((0, $1LBcl.akEditorSwoopCubicBezier)))
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5yfDB.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: $94a3dee679077c6e$var$ChevronRightSmallIcon,
        label: intl.formatMessage(isCollapsed ? (0, $3cXxO.collapsibleHeadingMessages).expandSection : (0, $3cXxO.collapsibleHeadingMessages).collapseSection),
        "aria-expanded": !isCollapsed,
        isTooltipDisabled: false,
        testId: "collapsible-heading-button",
        onClick: handleClick,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onKeyDown: handleKeyDown
    }));
}
function $94a3dee679077c6e$var$CollapsibleHeadingContainer(_ref4) {
    var children = _ref4.children, collapsibleHeading = _ref4.collapsibleHeading, headingLevel = _ref4.headingLevel;
    var mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(false);
    var _React$useState3 = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(false), _React$useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState3, 2), isHovered = _React$useState4[0], setIsHovered = _React$useState4[1];
    var _React$useState5 = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(false), _React$useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState5, 2), isFocused = _React$useState6[0], setIsFocused = _React$useState6[1];
    var mouseEnterHandler = function mouseEnterHandler() {
        if (!mouseEntered.current) {
            (0, $l0l26.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        "data-testid": $94a3dee679077c6e$var$RENDERER_COLLAPSIBLE_HEADING_WRAPPER,
        "data-level": headingLevel,
        onMouseEnter: function onMouseEnter() {
            mouseEnterHandler();
            setIsHovered(true);
        },
        onMouseLeave: function onMouseLeave() {
            return setIsHovered(false);
        },
        onFocus: function onFocus(event) {
            return setIsFocused($94a3dee679077c6e$var$hasFocusVisible(event.target));
        },
        onBlur: function onBlur() {
            return setIsFocused(false);
        },
        className: (0, $970q7.default)([
            "_ahbqukr8 _bozgxy5q _kqswh2mm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($94a3dee679077c6e$var$CollapsibleHeadingButton, {
        collapsibleHeading: collapsibleHeading,
        headingLevel: headingLevel,
        isHeadingHovered: isHovered || isFocused
    }), children);
}
/**
 * Old heading structure (before a11y fix):
 * - headning anchor is rendered INSIDE the heading element
 * - A duplicate anchor is rendered in VisuallyHidden for screen readers
 * - The visible button has hideFromScreenReader={true}
 *
 */ function $94a3dee679077c6e$var$HeadingWithDuplicateAnchor(props) {
    var headingId = props.headingId, dataAttributes = props.dataAttributes, allowHeadingAnchorLinks = props.allowHeadingAnchorLinks, marks = props.marks, invisible = props.invisible, localId = props.localId, asInline = props.asInline;
    var HX = "h".concat(props.level);
    var mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(false);
    var showAnchorLink = !!props.showAnchorLink;
    var isRightAligned = $94a3dee679077c6e$var$hasRightAlignmentMark(marks);
    var headingAnchorLinksConfig = $94a3dee679077c6e$var$getHeadingAnchorLinksConfig(allowHeadingAnchorLinks);
    var enableNestedHeaderLinks = headingAnchorLinksConfig === null || headingAnchorLinksConfig === void 0 ? void 0 : headingAnchorLinksConfig.allowNestedHeaderLinks;
    var getHeadingLink = headingAnchorLinksConfig === null || headingAnchorLinksConfig === void 0 ? void 0 : headingAnchorLinksConfig.getHeadingLink;
    var headingIdToUse = invisible ? undefined : headingId;
    var mouseEnterHandler = function mouseEnterHandler() {
        if (showAnchorLink && !mouseEntered.current) {
            // Abort TTVC calculation when the mouse hovers over heading. Hovering over
            // heading render heading anchor and inline comment buttons. These user-induced
            // DOM changes are valid reasons to abort the TTVC calculation.
            (0, $l0l26.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(HX, {
        id: headingIdToUse,
        "data-local-id": localId,
        "data-renderer-start-pos": dataAttributes['data-renderer-start-pos'],
        "data-as-inline": asInline,
        onMouseEnter: mouseEnterHandler,
        tabIndex: -1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($94a3dee679077c6e$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        getHeadingLink: getHeadingLink,
        headingId: headingId,
        hideFromScreenReader: true
    }), props.children, showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($94a3dee679077c6e$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        getHeadingLink: getHeadingLink,
        headingId: headingId,
        hideFromScreenReader: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e8kqY.default), {
        testId: "visually-hidden-heading-anchor"
    }, showAnchorLink && headingId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($94a3dee679077c6e$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        getHeadingLink: getHeadingLink,
        headingId: headingId
    })));
}
/**
 * New heading structure (a11y fix):
 * - Heading anchor is rendered OUTSIDE the heading element in a .renderer-heading-wrapper div
 * - Uses data-level attribute for CSS styling
 * - Better accessibility: heading contains only text, button is a sibling
 */ function $94a3dee679077c6e$var$HeadingWithWrapper(props) {
    var headingId = props.headingId, dataAttributes = props.dataAttributes, allowHeadingAnchorLinks = props.allowHeadingAnchorLinks, marks = props.marks, invisible = props.invisible, localId = props.localId, asInline = props.asInline, collapsibleHeading = props.collapsibleHeading;
    var HX = "h".concat(props.level);
    var mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(false);
    var _React$useState7 = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(false), _React$useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState7, 2), isHovered = _React$useState8[0], setIsHovered = _React$useState8[1];
    var _React$useState9 = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(false), _React$useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState9, 2), isFocused = _React$useState0[0], setIsFocused = _React$useState0[1];
    var showAnchorLink = !!props.showAnchorLink;
    var isRightAligned = $94a3dee679077c6e$var$hasRightAlignmentMark(marks);
    var headingAnchorLinksConfig = $94a3dee679077c6e$var$getHeadingAnchorLinksConfig(allowHeadingAnchorLinks);
    var enableNestedHeaderLinks = headingAnchorLinksConfig === null || headingAnchorLinksConfig === void 0 ? void 0 : headingAnchorLinksConfig.allowNestedHeaderLinks;
    var getHeadingLink = headingAnchorLinksConfig === null || headingAnchorLinksConfig === void 0 ? void 0 : headingAnchorLinksConfig.getHeadingLink;
    var headingIdToUse = invisible ? undefined : headingId;
    var mouseEnterHandler = function mouseEnterHandler() {
        if ((showAnchorLink || collapsibleHeading) && !mouseEntered.current) {
            // Abort TTVC calculation when the mouse hovers over heading. Hovering over
            // heading render heading anchor and inline comment buttons. These user-induced
            // DOM changes are valid reasons to abort the TTVC calculation.
            (0, $l0l26.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    var handleWrapperMouseEnter = function handleWrapperMouseEnter() {
        mouseEnterHandler();
        setIsHovered(true);
    };
    var handleWrapperMouseLeave = function handleWrapperMouseLeave() {
        return setIsHovered(false);
    };
    var handleWrapperFocus = function handleWrapperFocus(event) {
        return setIsFocused($94a3dee679077c6e$var$hasFocusVisible(event.target));
    };
    var handleWrapperBlur = function handleWrapperBlur() {
        return setIsFocused(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            "_1e0c1ule",
            collapsibleHeading && "_ahbqukr8 _bozgxy5q _kqswh2mm",
            $94a3dee679077c6e$var$RENDERER_HEADING_WRAPPER
        ]),
        "data-testid": $94a3dee679077c6e$var$RENDERER_HEADING_WRAPPER,
        "data-level": props.level,
        onMouseEnter: collapsibleHeading ? handleWrapperMouseEnter : undefined,
        onMouseLeave: collapsibleHeading ? handleWrapperMouseLeave : undefined,
        onFocus: collapsibleHeading ? handleWrapperFocus : undefined,
        onBlur: collapsibleHeading ? handleWrapperBlur : undefined
    }, collapsibleHeading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($94a3dee679077c6e$var$CollapsibleHeadingButton, {
        collapsibleHeading: collapsibleHeading,
        headingLevel: props.level,
        isHeadingHovered: isHovered || isFocused
    }), showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($94a3dee679077c6e$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        getHeadingLink: getHeadingLink,
        headingId: headingId,
        hideFromScreenReader: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(HX, {
        id: headingIdToUse,
        "data-local-id": localId,
        "data-renderer-start-pos": dataAttributes['data-renderer-start-pos'],
        "data-as-inline": asInline,
        onMouseEnter: collapsibleHeading ? undefined : mouseEnterHandler,
        tabIndex: -1
    }, props.children), showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($94a3dee679077c6e$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        getHeadingLink: getHeadingLink,
        headingId: headingId,
        hideFromScreenReader: false
    }));
}
/**
 * Gated Heading component:
 * - When platform_editor_copy_link_a11y_inconsistency_fix experiment is enabled,
 *   returns HeadingWithWrapper (new a11y-improved structure)
 * - Otherwise preserves HeadingWithDuplicateAnchor (old structure), adding only the collapse
 *   container when the top-level heading is collapsible
 */ function $94a3dee679077c6e$var$Heading(_ref5) {
    var allowHeadingAnchorLinks = _ref5.allowHeadingAnchorLinks, children = _ref5.children, dataAttributes = _ref5.dataAttributes, headingId = _ref5.headingId, invisible = _ref5.invisible, level = _ref5.level, localId = _ref5.localId, marks = _ref5.marks, nodeType = _ref5.nodeType, path = _ref5.path, showAnchorLink = _ref5.showAnchorLink, serializer = _ref5.serializer, asInline = _ref5.asInline;
    var collapsibleHeading = (0, $9fs6o.useCollapsibleHeading)(dataAttributes['data-renderer-start-pos'], (path === null || path === void 0 ? void 0 : path.length) === 0);
    if ((0, $drUcN.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($94a3dee679077c6e$var$HeadingWithWrapper, {
        allowHeadingAnchorLinks: allowHeadingAnchorLinks,
        dataAttributes: dataAttributes,
        headingId: headingId,
        invisible: invisible,
        level: level,
        localId: localId,
        marks: marks,
        nodeType: nodeType,
        serializer: serializer,
        showAnchorLink: showAnchorLink,
        asInline: asInline,
        collapsibleHeading: collapsibleHeading
    }, children);
    var headingWithDuplicateAnchor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($94a3dee679077c6e$var$HeadingWithDuplicateAnchor, {
        allowHeadingAnchorLinks: allowHeadingAnchorLinks,
        dataAttributes: dataAttributes,
        headingId: headingId,
        invisible: invisible,
        level: level,
        localId: localId,
        marks: marks,
        nodeType: nodeType,
        serializer: serializer,
        showAnchorLink: showAnchorLink,
        asInline: asInline
    }, children);
    if (collapsibleHeading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($94a3dee679077c6e$var$CollapsibleHeadingContainer, {
        collapsibleHeading: collapsibleHeading,
        headingLevel: level
    }, headingWithDuplicateAnchor);
    return headingWithDuplicateAnchor;
}
var $94a3dee679077c6e$export$2e2bcd8739ae039 = $94a3dee679077c6e$var$Heading;

});
parcelRegister("l0l26", function(module, exports) {
$parcel$export(module.exports, "getActiveInteraction", () => $f4a9e9c030243ab6$export$2b3954d2e8509985);
$parcel$export(module.exports, "abortAll", () => $f4a9e9c030243ab6$export$614a7af2affc5dff);

var $fL8KA = parcelRequire("fL8KA");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $fC8ib = parcelRequire("fC8ib");

var $6HG4S = parcelRequire("6HG4S");

var $6JfQX = parcelRequire("6JfQX");

var $4g5L8 = parcelRequire("4g5L8");

var $9gPQ0 = parcelRequire("9gPQ0");

var $rHZri = parcelRequire("rHZri");

var $6XIot = parcelRequire("6XIot");

var $hueS2 = parcelRequire("hueS2");

var $2U3Me = parcelRequire("2U3Me");

var $3Mlfh = parcelRequire("3Mlfh");

var $67sOe = parcelRequire("67sOe");

var $hcjVr = parcelRequire("hcjVr");

var $it7am = parcelRequire("it7am");

var $3Mmjz = parcelRequire("3Mmjz");

var $epPfj = parcelRequire("epPfj");

var $3Ammo = parcelRequire("3Ammo");

var $cik7q = parcelRequire("cik7q");
function $f4a9e9c030243ab6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f4a9e9c030243ab6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f4a9e9c030243ab6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f4a9e9c030243ab6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f4a9e9c030243ab6$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $f4a9e9c030243ab6$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $f4a9e9c030243ab6$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f4a9e9c030243ab6$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f4a9e9c030243ab6$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $f4a9e9c030243ab6$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $f4a9e9c030243ab6$export$dbba6cdedab4e68b = {
    id: undefined,
    name: undefined,
    type: undefined,
    isAborted: undefined,
    timestamp: undefined
};
var $f4a9e9c030243ab6$export$d8f52e8f804021e8 = new (0, $cik7q.default)();
var $f4a9e9c030243ab6$var$interactionQueue = [];
var $f4a9e9c030243ab6$var$segmentCache = new Map();
var $f4a9e9c030243ab6$export$a2b14406ded37d60 = new Map(); // Temporarily store segment unmount counts
var $f4a9e9c030243ab6$var$segmentObservers = [];
function $f4a9e9c030243ab6$export$2b3954d2e8509985() {
    var interactionId = (0, $hcjVr.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $3Ammo.interactions).get(interactionId.current);
}
function $f4a9e9c030243ab6$var$isPerformanceTracingEnabled() {
    var _getConfig;
    return ((_getConfig = (0, $rHZri.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.enableAdditionalPerformanceMarks) || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
var $f4a9e9c030243ab6$var$performanceEventObserver;
var $f4a9e9c030243ab6$export$17afbba0f16b4b19 = function getPerformanceObserver() {
    $f4a9e9c030243ab6$var$performanceEventObserver = $f4a9e9c030243ab6$var$performanceEventObserver || new PerformanceObserver(function(entries) {
        var list = entries.getEntries();
        var _iterator = $f4a9e9c030243ab6$var$_createForOfIteratorHelper(list), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var entry = _step.value;
                if (entry.name === 'click') $f4a9e9c030243ab6$export$e6be05b411ce21a6(entry);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    });
    return $f4a9e9c030243ab6$var$performanceEventObserver;
};
var $f4a9e9c030243ab6$export$e6be05b411ce21a6 = function setInteractionPerformanceEvent(entry) {
    var interaction = $f4a9e9c030243ab6$export$2b3954d2e8509985();
    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') {
        var responsiveness = interaction.responsiveness || {};
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already
        // been set up
        responsiveness.experimentalInputToNextPaint = responsiveness.experimentalInputToNextPaint || entry.duration;
        responsiveness.inputDelay = responsiveness.experimentalInputToNextPaint || entry.processingStart - entry.startTime;
        interaction.responsiveness = responsiveness;
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        if (entry.startTime < interaction.start) interaction.start = entry.startTime;
    }
};
function $f4a9e9c030243ab6$var$labelStackToString(labelStack, name) {
    var _stack$map;
    var stack = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(labelStack !== null && labelStack !== void 0 ? labelStack : []);
    if (name) stack.push({
        name: name
    });
    return (_stack$map = stack.map(function(l) {
        return l.name;
    })) === null || _stack$map === void 0 ? void 0 : _stack$map.join('/');
}
function $f4a9e9c030243ab6$var$labelStackToIdString(labelStack) {
    var _labelStack$map;
    return labelStack === null || labelStack === void 0 || (_labelStack$map = labelStack.map(function(l) {
        return 'segmentId' in l ? "".concat(l.name, ":").concat(l.segmentId) : "".concat(l.name);
    })) === null || _labelStack$map === void 0 ? void 0 : _labelStack$map.join('/');
}
function $f4a9e9c030243ab6$var$addSegmentObserver(observer) {
    $f4a9e9c030243ab6$var$segmentObservers.push(observer);
    var _iterator2 = $f4a9e9c030243ab6$var$_createForOfIteratorHelper($f4a9e9c030243ab6$var$segmentCache.values()), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var segmentInfo = _step2.value;
            observer.onAdd(segmentInfo);
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $f4a9e9c030243ab6$var$removeSegmentObserver(observer) {
    var index = $f4a9e9c030243ab6$var$segmentObservers.findIndex(function(obs) {
        return obs === observer;
    });
    if (index !== -1) $f4a9e9c030243ab6$var$segmentObservers.splice(index, 1);
}
function $f4a9e9c030243ab6$export$cd7f480d6b8286c3(interactionId) {
    (0, $3Ammo.interactions).delete(interactionId);
}
function $f4a9e9c030243ab6$export$f6f1cf5bedf83c71(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    var interaction = $f4a9e9c030243ab6$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $f4a9e9c030243ab6$export$12f2b6cb85d59904(interactionId, data) {
    var interaction = (0, $3Ammo.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(key) {
        interaction.metaData[key] = data[key];
    });
}
function $f4a9e9c030243ab6$export$e4380431c2bdabee(interactionId, labelStack, data) {
    var interaction = (0, $3Ammo.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(i) {
        interaction.customData.push({
            labelStack: labelStack,
            data: (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, i, data[i])
        });
    });
}
function $f4a9e9c030243ab6$export$9bfdf89f35702b2e(interactionId, segmentId, data) {
    var interaction = (0, $3Ammo.interactions).get(interactionId);
    if (interaction != null) {
        var _interaction$excluded;
        ((_interaction$excluded = interaction.excluded3pSegmentData) !== null && _interaction$excluded !== void 0 ? _interaction$excluded : interaction.excluded3pSegmentData = {})[segmentId] = $f4a9e9c030243ab6$var$_objectSpread($f4a9e9c030243ab6$var$_objectSpread({
            segmentId: segmentId
        }, interaction.excluded3pSegmentData[segmentId]), data);
    }
}
function $f4a9e9c030243ab6$export$35723c3772fda7dd(interactionId, segmentId, data) {
    var interaction = (0, $3Ammo.interactions).get(interactionId);
    if (interaction != null) {
        if (!interaction.segmentExtraData) interaction.segmentExtraData = {};
        interaction.segmentExtraData[segmentId] = $f4a9e9c030243ab6$var$_objectSpread($f4a9e9c030243ab6$var$_objectSpread({}, interaction.segmentExtraData[segmentId]), data);
    }
}
/**
 * Builds a stable cross-segment dedup key for a segment3pTimings entry.
 *
 * For `resource-timing`, query-stripped backend labels + timing fields identify a request without
 * depending on query parameters. Shared CSS/JS asset timings dedupe across segments, but backend
 * fetch/XHR entries are scoped by `segmentId` because each iframe can make its own backend request
 * to the same URL.
 *
 * For all other labels the data objects are small (a handful of fields), so we use a full
 * JSON fingerprint which is cheap and collision-free.
 */ function $f4a9e9c030243ab6$var$buildCrossSegmentDedupKey(entry, segmentId) {
    if (entry.label === 'resource-timing') {
        var _ref = entry.data, resourceLabel = _ref.label, startTime = _ref.startTime, duration = _ref.duration, requestStart = _ref.requestStart, fetchStart = _ref.fetchStart, ttfb = _ref.ttfb, type = _ref.type;
        if ((0, $it7am.BACKEND_RESOURCE_TIMING_INITIATOR_TYPES).has(String(type))) // Backend calls are separate requests per segment; include extra timings and segment scope.
        return "resource-timing|".concat(resourceLabel, "|").concat(startTime, "|").concat(duration, "|").concat(fetchStart, "|").concat(requestStart, "|").concat(ttfb, "|").concat(segmentId);
        // Shared CSS/JS assets keep the original B3 key so they can dedupe across segments.
        return "resource-timing|".concat(resourceLabel, "|").concat(startTime, "|").concat(duration);
    }
    return "".concat(entry.label, "|").concat(JSON.stringify(entry.data));
}
function $f4a9e9c030243ab6$export$c227d812a1e08d80(interactionId, segmentId, entry) {
    var interaction = (0, $3Ammo.interactions).get(interactionId);
    if (interaction != null) {
        // B3: dedup by content — drops identical entries within and across iframes.
        // Abort markers are excluded so every segment's abort is recorded.
        if (entry.label !== 'segment-timing-abort') {
            if (!interaction.segment3pCrossSegmentSeen) interaction.segment3pCrossSegmentSeen = new Set();
            var key = $f4a9e9c030243ab6$var$buildCrossSegmentDedupKey(entry, segmentId);
            if (interaction.segment3pCrossSegmentSeen.has(key)) return;
            interaction.segment3pCrossSegmentSeen.add(key);
        }
        if (!interaction.segment3pTimings) interaction.segment3pTimings = {};
        if (!interaction.segment3pTimings[segmentId]) interaction.segment3pTimings[segmentId] = [];
        interaction.segment3pTimings[segmentId].push(entry);
    }
}
function $f4a9e9c030243ab6$export$20265b12c6625451(interactionId, key, value) {
    var interaction = (0, $3Ammo.interactions).get(interactionId);
    if (interaction == null) return;
    // Allow null and undefined values
    if (value === null || value === undefined) {
        interaction.cohortingCustomData.set(key, value);
        return;
    }
    // Validate that the value is a primitive (number, boolean, or string)
    if (typeof value !== 'number' && typeof value !== 'boolean' && typeof value !== 'string') return;
    // Validate string length (max 50 characters)
    if (typeof value === 'string' && value.length > 50) return;
    interaction.cohortingCustomData.set(key, value);
}
function $f4a9e9c030243ab6$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    var interaction = (0, $3Ammo.interactions).get(interactionId);
    if (interaction != null) {
        var sanitizedData = Object.fromEntries(Object.entries(data).map(function(_ref2) {
            var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 2), key = _ref3[0], timingData = _ref3[1];
            return [
                (0, $9gPQ0.sanitizeTimingName)(key),
                timingData
            ];
        }));
        interaction.customTimings.push({
            labelStack: labelStack,
            data: sanitizedData
        });
        if ($f4a9e9c030243ab6$var$isPerformanceTracingEnabled()) for(var _i = 0, _Object$entries = Object.entries(sanitizedData); _i < _Object$entries.length; _i++){
            var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], timingData = _Object$entries$_i[1];
            var startTime = timingData.startTime, endTime = timingData.endTime;
            try {
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat($f4a9e9c030243ab6$var$labelStackToString(labelStack, key), " [custom_timing]"), {
                    start: startTime,
                    end: endTime,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary-light'
                        }
                    }
                });
            } catch (_unused) {
            // do nothing
            }
        }
    }
}
function $f4a9e9c030243ab6$export$728e28c22a0fba4(interactionId, type, name, labelStack) {
    var time = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var interaction = (0, $3Ammo.interactions).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($f4a9e9c030243ab6$var$isPerformanceTracingEnabled()) performance.mark("\uD83D\uDEF8 ".concat($f4a9e9c030243ab6$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
        startTime: time
    });
}
function $f4a9e9c030243ab6$export$85d1eb835f669bf(_interactionId, _labelStack, _time) {}
function $f4a9e9c030243ab6$export$c4b23cc624bd2fb(type, name, labelStack) {
    var time = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : performance.now();
    (0, $3Ammo.interactions).forEach(function(interaction) {
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($f4a9e9c030243ab6$var$isPerformanceTracingEnabled()) performance.mark("\uD83D\uDEF8 ".concat($f4a9e9c030243ab6$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
        startTime: time
    });
}
function $f4a9e9c030243ab6$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start) {
    var end = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : performance.now();
    var size = arguments.length > 6 ? arguments[6] : undefined;
    var interaction = (0, $3Ammo.interactions).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($f4a9e9c030243ab6$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat($f4a9e9c030243ab6$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary'
                    }
                }
            });
        } catch (_unused2) {
        // do nothing
        }
    }
}
function $f4a9e9c030243ab6$export$943a8b2b5d6b1809(type, name, labelStack, start) {
    var end = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var size = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    (0, $3Ammo.interactions).forEach(function(interaction) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($f4a9e9c030243ab6$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat($f4a9e9c030243ab6$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
            start: start,
            end: end,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary'
                }
            }
        });
    } catch (_unused3) {
    // do nothing
    }
}
function $f4a9e9c030243ab6$export$9e04fe1a58571ec(moduleId, timestamp) {
    $f4a9e9c030243ab6$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
}
function $f4a9e9c030243ab6$export$6f228d1fdc911d7(identifier, start, end) {
    $f4a9e9c030243ab6$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
}
var $f4a9e9c030243ab6$var$moduleLoadingRequests = {};
function $f4a9e9c030243ab6$export$f5a8f10de74904da(input) {
    var result = input !== null && input !== void 0 ? input : '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function $f4a9e9c030243ab6$var$addHoldCriterion(id, labelStack, name, startTime) {
    var _window$__CRITERION__;
    if (!((_window$__CRITERION__ = window.__CRITERION__) !== null && _window$__CRITERION__ !== void 0 && _window$__CRITERION__.addUFOHold)) return;
    window.__CRITERION__.addUFOHold(id, $f4a9e9c030243ab6$var$labelStackToString(labelStack), name, startTime);
}
function $f4a9e9c030243ab6$var$removeHoldCriterion(id) {
    var _window$__CRITERION__2;
    if (!((_window$__CRITERION__2 = window.__CRITERION__) !== null && _window$__CRITERION__2 !== void 0 && _window$__CRITERION__2.removeUFOHold)) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $f4a9e9c030243ab6$export$7606887303596f82(interactionId, labelStack, name, _experimental, holdStartedAt) {
    var interaction = (0, $3Ammo.interactions).get(interactionId);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    var id = (0, $6JfQX.default)();
    if (!interaction) // add hold timestamp to post interaction log if interaction is complete
    $f4a9e9c030243ab6$export$d8f52e8f804021e8.addHoldInfo(labelStack, name, holdStartedAt !== null && holdStartedAt !== void 0 ? holdStartedAt : performance.now());
    if (interaction != null) {
        var start = holdStartedAt !== null && holdStartedAt !== void 0 ? holdStartedAt : performance.now();
        var holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        if ($f4a9e9c030243ab6$var$shouldMoveHoldToExtendedBucket(interaction, holdActive)) $f4a9e9c030243ab6$var$ensureExtendedHoldActive(interaction).set(id, $f4a9e9c030243ab6$var$_objectSpread($f4a9e9c030243ab6$var$_objectSpread({}, holdActive), {}, {
            start: start
        }));
        else {
            interaction.holdActive.set(id, $f4a9e9c030243ab6$var$_objectSpread($f4a9e9c030243ab6$var$_objectSpread({}, holdActive), {}, {
                start: start
            }));
            $f4a9e9c030243ab6$var$addHoldCriterion(id, labelStack, name, start);
        }
        return function() {
            var end = performance.now();
            if ($f4a9e9c030243ab6$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat($f4a9e9c030243ab6$var$labelStackToString(labelStack, name), " [hold]"), {
                    start: start,
                    end: end,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'secondary-light'
                        }
                    }
                });
            } catch (_unused4) {
            // do nothing
            }
            $f4a9e9c030243ab6$var$removeHoldCriterion(id);
            var currentInteraction = (0, $3Ammo.interactions).get(interactionId);
            var currentHold = interaction.holdActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push($f4a9e9c030243ab6$var$_objectSpread($f4a9e9c030243ab6$var$_objectSpread({}, currentHold), {}, {
                        end: end
                    }));
                    interaction.holdActive.delete(id);
                }
                if (interaction.hold3pActive) {
                    var current3pHold = interaction.hold3pActive.get(id);
                    if (current3pHold != null) {
                        $f4a9e9c030243ab6$var$recordMetricVariantCategoryEnd(currentInteraction, current3pHold.labelStack, end);
                        if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                        currentInteraction.hold3pInfo.push($f4a9e9c030243ab6$var$_objectSpread($f4a9e9c030243ab6$var$_objectSpread({}, current3pHold), {}, {
                            end: end
                        }));
                        interaction.hold3pActive.delete(id);
                    }
                }
            }
        };
    }
    return function() {};
}
function $f4a9e9c030243ab6$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    var interaction = (0, $3Ammo.interactions).get(interactionId);
    if (interaction != null) {
        var start = performance.now();
        var holdActive = {
            labelStack: labelStack,
            name: name,
            start: start,
            ignoreOnSubmit: ignoreOnSubmit
        };
        if ($f4a9e9c030243ab6$var$shouldMoveHoldToExtendedBucket(interaction, holdActive)) $f4a9e9c030243ab6$var$ensureExtendedHoldActive(interaction).set(id, holdActive);
        else {
            interaction.holdActive.set(id, holdActive);
            $f4a9e9c030243ab6$var$addHoldCriterion(id, labelStack, name, start);
        }
    }
    return function() {};
}
function $f4a9e9c030243ab6$export$d6cf9650acfb0dab(interactionId, labelStack, name, start, end) {
    var interaction = (0, $3Ammo.interactions).get(interactionId);
    if (interaction != null) {
        // `recordMetricVariantCategoryEnd` skips excluded (background-script) holds, so the completed
        // hold is retained in `hold3pInfo` for observability but never contributes a third-party
        // category end.
        $f4a9e9c030243ab6$var$recordMetricVariantCategoryEnd(interaction, labelStack, end);
        $f4a9e9c030243ab6$var$ensureExtendedHoldInfo(interaction).push({
            labelStack: labelStack,
            name: name,
            start: start,
            end: end
        });
    }
}
function $f4a9e9c030243ab6$export$4983dfbbb996f7ae(interactionId, id) {
    var interaction = (0, $3Ammo.interactions).get(interactionId);
    if (interaction != null) {
        var end = performance.now();
        var currentInteraction = (0, $3Ammo.interactions).get(interactionId);
        var currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            if ($f4a9e9c030243ab6$var$shouldMoveHoldToExtendedBucket(currentInteraction, currentHold)) $f4a9e9c030243ab6$var$ensureExtendedHoldInfo(currentInteraction).push($f4a9e9c030243ab6$var$_objectSpread($f4a9e9c030243ab6$var$_objectSpread({}, currentHold), {}, {
                end: end
            }));
            else currentInteraction.holdInfo.push($f4a9e9c030243ab6$var$_objectSpread($f4a9e9c030243ab6$var$_objectSpread({}, currentHold), {}, {
                end: end
            }));
            interaction.holdActive.delete(id);
            $f4a9e9c030243ab6$var$removeHoldCriterion(id);
        }
        if (interaction.hold3pActive) {
            var current3pHold = interaction.hold3pActive.get(id);
            if (currentInteraction != null && current3pHold != null) {
                $f4a9e9c030243ab6$var$recordMetricVariantCategoryEnd(currentInteraction, current3pHold.labelStack, end);
                if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                currentInteraction.hold3pInfo.push($f4a9e9c030243ab6$var$_objectSpread($f4a9e9c030243ab6$var$_objectSpread({}, current3pHold), {}, {
                    end: end
                }));
                interaction.hold3pActive.delete(id);
            }
        }
    }
}
function $f4a9e9c030243ab6$export$2df109852219d16e(interactionId) {
    var interaction = (0, $3Ammo.interactions).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
function $f4a9e9c030243ab6$export$b1ce94abc72c69d7(interactionId, info) {
    var interaction = (0, $3Ammo.interactions).get(interactionId);
    if (interaction == null) return function() {};
    var preloadRow = {
        source: info.source,
        preloadStartedAt: info.preloadStartedAt,
        adoptedAt: info.adoptedAt
    };
    interaction.preloadInfo.push(preloadRow);
    var releaseHold = $f4a9e9c030243ab6$export$7606887303596f82(interactionId, [], "preload:".concat(info.source), false, interaction.start);
    var released = false;
    return function() {
        if (released) return;
        released = true;
        preloadRow.settledAt = performance.now();
        releaseHold();
    };
}
function $f4a9e9c030243ab6$export$43f87b52eb8fc449(args) {
    var interaction = $f4a9e9c030243ab6$export$2b3954d2e8509985();
    if (interaction == null || interaction.ufoName !== args.experienceKey || args.preloadKey !== undefined && interaction.preloadKey !== undefined && interaction.preloadKey !== args.preloadKey) return null;
    return $f4a9e9c030243ab6$export$b1ce94abc72c69d7(interaction.id, {
        source: args.source,
        preloadStartedAt: args.preloadStartedAt,
        adoptedAt: args.adoptedAt
    });
}
var $f4a9e9c030243ab6$var$onInteractionStartForPreloadHolds = null;
function $f4a9e9c030243ab6$export$e96f751b1e82abda(hook) {
    $f4a9e9c030243ab6$var$onInteractionStartForPreloadHolds = hook;
}
var $f4a9e9c030243ab6$export$9591b52b33ccc510 = {
    onPreload: function onPreload(moduleId, _priority) {
        $f4a9e9c030243ab6$export$9e04fe1a58571ec($f4a9e9c030243ab6$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart: function onLoadStart(info) {
        var timeoutId = setTimeout(function() {
            delete $f4a9e9c030243ab6$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        var request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $f4a9e9c030243ab6$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete: function onLoadComplete(info) {
        var request = $f4a9e9c030243ab6$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $f4a9e9c030243ab6$var$moduleLoadingRequests[info.identifier];
            $f4a9e9c030243ab6$export$6f228d1fdc911d7($f4a9e9c030243ab6$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted: function placeholderFallBackMounted(id, moduleId) {
        var interactionId = (0, $hcjVr.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $f4a9e9c030243ab6$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted: function placeholderFallBackUnmounted(id) {
        var interactionId = (0, $hcjVr.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $f4a9e9c030243ab6$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $f4a9e9c030243ab6$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError, errorHash, errorStatusCode) {
    var interaction = (0, $3Ammo.interactions).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError,
        errorHash: errorHash,
        errorStatusCode: errorStatusCode
    });
}
function $f4a9e9c030243ab6$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack, errorHash, errorStatusCode) {
    (0, $3Ammo.interactions).forEach(function(interaction) {
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack,
            errorHash: errorHash,
            errorStatusCode: errorStatusCode
        });
    });
}
function $f4a9e9c030243ab6$export$53d6f611de951a13(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    var _getConfig2;
    if ($f4a9e9c030243ab6$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat($f4a9e9c030243ab6$var$labelStackToString(labelStack), " [react-profiler] ").concat(type), {
            start: startTime,
            duration: actualDuration,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary-dark'
                }
            }
        });
    } catch (_unused5) {
    // do nothing
    }
    var interaction = (0, $3Ammo.interactions).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((_getConfig2 = (0, $rHZri.getConfig)()) !== null && _getConfig2 !== void 0 && (_getConfig2 = _getConfig2.postInteractionLog) !== null && _getConfig2 !== void 0 && _getConfig2.enabled) $f4a9e9c030243ab6$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
}
function $f4a9e9c030243ab6$var$pushToQueue(id, data) {
    $f4a9e9c030243ab6$var$interactionQueue.push({
        id: id,
        data: data
    });
}
var $f4a9e9c030243ab6$var$handleInteraction = $f4a9e9c030243ab6$var$pushToQueue;
var $f4a9e9c030243ab6$var$isKnownMetricVariantCategory = function isKnownMetricVariantCategory(type) {
    return type === 'third-party' || type === 'gen-ai';
};
var $f4a9e9c030243ab6$var$hasMetricVariantCategory = function hasMetricVariantCategory(labelStack, category) {
    var _labelStack$some;
    return (_labelStack$some = labelStack === null || labelStack === void 0 ? void 0 : labelStack.some(function(label) {
        return 'type' in label && label.type === category;
    })) !== null && _labelStack$some !== void 0 ? _labelStack$some : false;
};
var $f4a9e9c030243ab6$var$hasAnyMetricVariantCategory = function hasAnyMetricVariantCategory(labelStack) {
    var _labelStack$some2;
    return (_labelStack$some2 = labelStack === null || labelStack === void 0 ? void 0 : labelStack.some(function(label) {
        return 'type' in label && $f4a9e9c030243ab6$var$isKnownMetricVariantCategory(label.type);
    })) !== null && _labelStack$some2 !== void 0 ? _labelStack$some2 : false;
};
/**
 * A hold is fully excluded from every metric window (standard and include-third-party) and from
 * completion gating iff its labelStack contains a single label that is BOTH `type: 'third-party'`
 * AND `excludeFromMetrics: true`. Requiring both on the same label guarantees exclusion can only
 * ever apply to third-party work, never first-party. Such holds are dropped at creation time, so
 * they never enter `holdActive`/`hold3pActive`, never block completion.
 */ var $f4a9e9c030243ab6$var$isExcludedThirdPartyHold = function isExcludedThirdPartyHold(labelStack) {
    var _labelStack$some3;
    return (_labelStack$some3 = labelStack === null || labelStack === void 0 ? void 0 : labelStack.some(function(label) {
        return 'type' in label && label.type === 'third-party' && 'excludeFromMetrics' in label && label.excludeFromMetrics === true;
    })) !== null && _labelStack$some3 !== void 0 ? _labelStack$some3 : false;
};
var $f4a9e9c030243ab6$var$getMetricVariantCategories = function getMetricVariantCategories(labelStack) {
    var categories = new Set();
    labelStack === null || labelStack === void 0 || labelStack.forEach(function(label) {
        if ('type' in label && $f4a9e9c030243ab6$var$isKnownMetricVariantCategory(label.type)) categories.add(label.type);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(categories);
};
var $f4a9e9c030243ab6$var$hasMetricVariantCategoryInHoldData = function hasMetricVariantCategoryInHoldData(interaction, category) {
    var _interaction$holdActi, _interaction$hold3pIn, _interaction$hold3pAc, _interaction$hold3pAc2;
    return interaction.holdInfo.some(function(hold) {
        return $f4a9e9c030243ab6$var$hasMetricVariantCategory(hold.labelStack, category);
    }) || (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((_interaction$holdActi = interaction.holdActive.values()) !== null && _interaction$holdActi !== void 0 ? _interaction$holdActi : []).some(function(hold) {
        return $f4a9e9c030243ab6$var$hasMetricVariantCategory(hold.labelStack, category);
    }) || (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((_interaction$hold3pIn = interaction.hold3pInfo) !== null && _interaction$hold3pIn !== void 0 ? _interaction$hold3pIn : []).some(function(hold) {
        return $f4a9e9c030243ab6$var$hasMetricVariantCategory(hold.labelStack, category);
    }) || (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((_interaction$hold3pAc = (_interaction$hold3pAc2 = interaction.hold3pActive) === null || _interaction$hold3pAc2 === void 0 ? void 0 : _interaction$hold3pAc2.values()) !== null && _interaction$hold3pAc !== void 0 ? _interaction$hold3pAc : []).some(function(hold) {
        return $f4a9e9c030243ab6$var$hasMetricVariantCategory(hold.labelStack, category);
    });
};
var $f4a9e9c030243ab6$var$recordMetricVariantCategoryEnd = function recordMetricVariantCategoryEnd(interaction, labelStack, end) {
    var _interaction$metricCa;
    // Excluded third-party holds (e.g. Forge background scripts) still live in `hold3pActive` and
    // gate completion like any third-party hold, but they must never contribute a third-party
    // category end. Skipping here covers every caller at once: the normal-release closure in
    // `addHold`, `removeHoldByID`, `addCompletedHold`, and the abort/timeout iterator
    // `recordActiveMetricVariantCategoryEnds`.
    if ($f4a9e9c030243ab6$var$isExcludedThirdPartyHold(labelStack)) return;
    var categories = $f4a9e9c030243ab6$var$getMetricVariantCategories(labelStack);
    if (categories.length === 0) return;
    interaction.metricCategoryEnds = (_interaction$metricCa = interaction.metricCategoryEnds) !== null && _interaction$metricCa !== void 0 ? _interaction$metricCa : {};
    categories.forEach(function(category) {
        var _category;
        interaction.metricCategoryEnds[category] = Math.max((_category = interaction.metricCategoryEnds[category]) !== null && _category !== void 0 ? _category : 0, end);
    });
};
var $f4a9e9c030243ab6$var$recordActiveMetricVariantCategoryEnds = function recordActiveMetricVariantCategoryEnds(interaction, end) {
    var _interaction$hold3pAc3;
    (_interaction$hold3pAc3 = interaction.hold3pActive) === null || _interaction$hold3pAc3 === void 0 || _interaction$hold3pAc3.forEach(function(hold) {
        $f4a9e9c030243ab6$var$recordMetricVariantCategoryEnd(interaction, hold.labelStack, end);
    });
};
var $f4a9e9c030243ab6$var$hasActiveMetricVariantCategory = function hasActiveMetricVariantCategory(interaction, category) {
    var _interaction$hold3pAc4, _interaction$hold3pAc5;
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((_interaction$hold3pAc4 = (_interaction$hold3pAc5 = interaction.hold3pActive) === null || _interaction$hold3pAc5 === void 0 ? void 0 : _interaction$hold3pAc5.values()) !== null && _interaction$hold3pAc4 !== void 0 ? _interaction$hold3pAc4 : []).some(function(hold) {
        return $f4a9e9c030243ab6$var$hasMetricVariantCategory(hold.labelStack, category);
    });
};
function $f4a9e9c030243ab6$var$shouldMoveHoldToExtendedBucket(interaction, hold) {
    // Excluded third-party holds (e.g. Forge background scripts) are routed to the extended
    // (`hold3pActive`) bucket exactly like any other third-party hold: they carry `type: 'third-party'`
    // so `hasAnyMetricVariantCategory` is true. They therefore keep gating completion (which preserves
    // the standard-bucket VC parity), and are excluded ONLY at the third-party accounting sites
    // (`recordMetricVariantCategoryEnd` and the `end3p` computation via `getNonExcludedThirdPartyEnd`).
    return $f4a9e9c030243ab6$var$hasAnyMetricVariantCategory(hold.labelStack) || interaction.end !== 0 && hold.start > interaction.end;
}
/**
 * The third-party end marker (`end3p`), used as the `include-third-party` window end whenever no
 * genuine third-party category end was recorded, must reflect only NON-excluded third-party work.
 *
 * `currentTime` is the timestamp the caller would otherwise have used verbatim (e.g. the abort
 * time, or the interaction end on the success path). If there is any genuine (non-excluded)
 * third-party hold that is still ACTIVE at this point, that work legitimately extends to
 * `currentTime`, so we keep it. Otherwise the only active third-party holds are excluded
 * background scripts, which must NOT drag the marker, so we fall back to the latest end among the
 * already-released non-excluded holds, clamped to at least `interactionEnd`. This preserves the
 * pre-fix behaviour for real third-party work while preventing background scripts from inflating
 * `end3p` / the include-third-party window.
 *
 * Note the released entries in `hold3pInfo` are `HoldActive & { end: number }`, so we read `h.end`.
 */ var $f4a9e9c030243ab6$var$getNonExcludedThirdPartyEnd = function getNonExcludedThirdPartyEnd(interaction, currentTime, interactionEnd) {
    var _interaction$hold3pAc6, _interaction$hold3pAc7, _interaction$hold3pIn2;
    var activeHolds = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((_interaction$hold3pAc6 = (_interaction$hold3pAc7 = interaction.hold3pActive) === null || _interaction$hold3pAc7 === void 0 ? void 0 : _interaction$hold3pAc7.values()) !== null && _interaction$hold3pAc6 !== void 0 ? _interaction$hold3pAc6 : []);
    var releasedHolds = (_interaction$hold3pIn2 = interaction.hold3pInfo) !== null && _interaction$hold3pIn2 !== void 0 ? _interaction$hold3pIn2 : [];
    // If this interaction never involved an excluded (background-script) hold at all
    // (none active AND none released), it is unaffected by an exclusion logic.
    // The derivation below only runs when at least one excluded hold actually exists.
    var hasAnyExcludedThirdParty = activeHolds.some(function(hold) {
        return $f4a9e9c030243ab6$var$isExcludedThirdPartyHold(hold.labelStack);
    }) || releasedHolds.some(function(hold) {
        return $f4a9e9c030243ab6$var$isExcludedThirdPartyHold(hold.labelStack);
    });
    if (!hasAnyExcludedThirdParty) return currentTime;
    // If a genuine (non-excluded) third-party hold is still active, the interaction is legitimately
    // being kept open by real third-party work, so the marker is the current time
    var hasActiveNonExcludedThirdParty = activeHolds.some(function(hold) {
        return !$f4a9e9c030243ab6$var$isExcludedThirdPartyHold(hold.labelStack);
    });
    if (hasActiveNonExcludedThirdParty) return currentTime;
    // Otherwise, only excluded background-script holds (if any) remain active. `currentTime` may have
    // been pushed out purely by a background script, so derive the marker from the latest genuine
    // (non-excluded) third-party work instead, floored to the interaction end so it is never reported
    // earlier than the interaction itself and a background script can never drag it late.
    return Math.max.apply(Math, [
        interactionEnd
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(releasedHolds.filter(function(hold) {
        return !$f4a9e9c030243ab6$var$isExcludedThirdPartyHold(hold.labelStack);
    }).map(function(hold) {
        return hold.end;
    }))));
};
function $f4a9e9c030243ab6$var$ensureExtendedHoldActive(interaction) {
    var _interaction$hold3pAc8;
    interaction.hold3pActive = (_interaction$hold3pAc8 = interaction.hold3pActive) !== null && _interaction$hold3pAc8 !== void 0 ? _interaction$hold3pAc8 : new Map();
    return interaction.hold3pActive;
}
function $f4a9e9c030243ab6$var$ensureExtendedHoldInfo(interaction) {
    var _interaction$hold3pIn3;
    interaction.hold3pInfo = (_interaction$hold3pIn3 = interaction.hold3pInfo) !== null && _interaction$hold3pIn3 !== void 0 ? _interaction$hold3pIn3 : [];
    return interaction.hold3pInfo;
}
function $f4a9e9c030243ab6$var$moveLateActiveHoldsToExtendedBucket(interaction) {
    if (interaction.end === 0) return;
    var holdsToMove = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(interaction.holdActive.entries()).filter(function(_ref4) {
        var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref4, 2), hold = _ref5[1];
        return $f4a9e9c030243ab6$var$shouldMoveHoldToExtendedBucket(interaction, hold);
    });
    holdsToMove.forEach(function(_ref6) {
        var _ref7 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref6, 2), id = _ref7[0], hold = _ref7[1];
        $f4a9e9c030243ab6$var$ensureExtendedHoldActive(interaction).set(id, hold);
        interaction.holdActive.delete(id);
    });
}
function $f4a9e9c030243ab6$var$ensureMetricWindows(interaction) {
    var _interaction$metricCa2, _interaction$metricCa3;
    if (interaction.end === 0) return;
    var hasGenAI = $f4a9e9c030243ab6$var$hasMetricVariantCategoryInHoldData(interaction, 'gen-ai');
    var hasThirdParty = $f4a9e9c030243ab6$var$hasMetricVariantCategoryInHoldData(interaction, 'third-party');
    var includeThirdPartyEnd = ((_interaction$metricCa2 = interaction.metricCategoryEnds) === null || _interaction$metricCa2 === void 0 ? void 0 : _interaction$metricCa2['third-party']) !== undefined ? Math.max(interaction.metricCategoryEnds['third-party'], interaction.end) : interaction.end3p;
    var includeGenAIEnd = ((_interaction$metricCa3 = interaction.metricCategoryEnds) === null || _interaction$metricCa3 === void 0 ? void 0 : _interaction$metricCa3['gen-ai']) !== undefined ? Math.max(interaction.metricCategoryEnds['gen-ai'], interaction.end) : undefined;
    interaction.metricWindows = $f4a9e9c030243ab6$var$_objectSpread($f4a9e9c030243ab6$var$_objectSpread({}, interaction.metricWindows), {}, {
        standard: {
            start: interaction.start,
            end: interaction.end,
            includeCategories: [],
            excludeCategories: [
                'third-party',
                'gen-ai'
            ]
        }
    });
    if (includeThirdPartyEnd !== undefined && (hasThirdParty || !hasGenAI)) interaction.metricWindows['include-third-party'] = {
        start: interaction.start,
        end: includeThirdPartyEnd,
        includeCategories: [
            'third-party'
        ],
        excludeCategories: []
    };
    if (hasGenAI && includeGenAIEnd !== undefined) interaction.metricWindows['include-gen-ai'] = {
        start: interaction.start,
        end: includeGenAIEnd,
        includeCategories: [
            'gen-ai'
        ],
        excludeCategories: []
    };
}
function $f4a9e9c030243ab6$var$addLifecycleObservation(interaction, observation) {
    var _interaction$lifecycl;
    interaction.lifecycleObservations = (_interaction$lifecycl = interaction.lifecycleObservations) !== null && _interaction$lifecycl !== void 0 ? _interaction$lifecycl : [];
    interaction.lifecycleObservations.push(observation);
}
function $f4a9e9c030243ab6$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach(function(cleanUpCallback) {
        cleanUpCallback();
    });
}
function $f4a9e9c030243ab6$var$finishInteraction(id, data) {
    var endTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    data.end = endTime;
    $f4a9e9c030243ab6$var$ensureMetricWindows(data);
    try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 [".concat(data.type, "] ").concat(data.ufoName, " [ttai]"), {
            start: data.start,
            end: data.end,
            detail: {
                devtools: {
                    track: 'main metrics',
                    trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                    color: 'tertiary'
                }
            }
        });
        performance.mark("TTAI", {
            startTime: data.end,
            detail: {
                devtools: {
                    dataType: 'marker'
                }
            }
        });
    } catch (_unused6) {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $67sOe.currentFeatureFlagsAccessed));
    (0, $3Mlfh.clearActiveTrace)();
    $f4a9e9c030243ab6$var$callCleanUpCallbacks(data);
    (0, $3Mmjz.flushSsrRenderProfilerTraces)();
    if (data.type === 'page_load') data.hydration = (0, $rHZri.getReactHydrationStats)();
    // By this time, stop the post interaction log observer if coinflip rate is 0
    if (!(0, $4g5L8.default)((0, $rHZri.getPostInteractionRate)((0, $hueS2.sanitizeUfoName)(data.ufoName), data.type))) $f4a9e9c030243ab6$export$d8f52e8f804021e8.stopVCObserver();
    $f4a9e9c030243ab6$export$cd7f480d6b8286c3(id);
    $f4a9e9c030243ab6$export$dbba6cdedab4e68b.id = data.id;
    $f4a9e9c030243ab6$export$dbba6cdedab4e68b.type = data.type;
    $f4a9e9c030243ab6$export$dbba6cdedab4e68b.timestamp = data.end;
    $f4a9e9c030243ab6$export$dbba6cdedab4e68b.name = data.ufoName || 'unknown';
    $f4a9e9c030243ab6$export$dbba6cdedab4e68b.isAborted = data.abortReason != null;
    if (data.ufoName) $f4a9e9c030243ab6$var$handleInteraction(id, data);
    if ($f4a9e9c030243ab6$var$isPerformanceTracingEnabled()) {
        var profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach(function(profilerTiming) {
            var labelStackId = $f4a9e9c030243ab6$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                var _profilerTimingMap$ge, _timing$start, _timing$end;
                var timing = (_profilerTimingMap$ge = profilerTimingMap.get(labelStackId)) !== null && _profilerTimingMap$ge !== void 0 ? _profilerTimingMap$ge : {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < ((_timing$start = timing.start) !== null && _timing$start !== void 0 ? _timing$start : Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > ((_timing$end = timing.end) !== null && _timing$end !== void 0 ? _timing$end : Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            var _iterator3 = $f4a9e9c030243ab6$var$_createForOfIteratorHelper(profilerTimingMap.entries()), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var _step3$value = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_step3.value, 2), _step3$value$ = _step3$value[1], labelStack = _step3$value$.labelStack, start = _step3$value$.start, end = _step3$value$.end;
                    performance.measure("\uD83D\uDEF8 ".concat($f4a9e9c030243ab6$var$labelStackToString(labelStack), " [segment_ttai]"), {
                        start: start,
                        end: end,
                        detail: {
                            devtools: {
                                track: "\uD83D\uDEF8 reactUFO detailed timings",
                                color: 'secondary-dark'
                            }
                        }
                    });
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        } catch (_unused7) {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch (_unused8) {
    // do nothing
    }
}
function $f4a9e9c030243ab6$export$9e614a29a1ac213e(sinkFn) {
    if ($f4a9e9c030243ab6$var$handleInteraction === $f4a9e9c030243ab6$var$pushToQueue) {
        $f4a9e9c030243ab6$var$handleInteraction = sinkFn;
        $f4a9e9c030243ab6$var$interactionQueue.forEach(function(interaction) {
            sinkFn(interaction.id, interaction.data);
        });
        $f4a9e9c030243ab6$var$interactionQueue.length = 0;
    }
}
function $f4a9e9c030243ab6$export$8a1ba7bef607358a(sinkFn) {
    $f4a9e9c030243ab6$export$d8f52e8f804021e8.sinkHandler(sinkFn);
}
// a flag to prevent multiple submitting
var $f4a9e9c030243ab6$var$activeSubmitted = false;
function $f4a9e9c030243ab6$export$673be905888f8839(interactionId, endTime) {
    var interaction = (0, $3Ammo.interactions).get(interactionId);
    if (interaction != null) {
        var _interaction$hold3pAc9;
        var noMoreActiveHolds = interaction.holdActive.size === 0;
        var shouldUseRawDataThirdParty = (0, $rHZri.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        var postInteraction = /*#__PURE__*/ function() {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
                var _getConfig3;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if ((_getConfig3 = (0, $rHZri.getConfig)()) !== null && _getConfig3 !== void 0 && (_getConfig3 = _getConfig3.postInteractionLog) !== null && _getConfig3 !== void 0 && _getConfig3.enabled) $f4a9e9c030243ab6$export$d8f52e8f804021e8.onInteractionComplete(interaction);
                            $f4a9e9c030243ab6$var$activeSubmitted = false;
                        case 1:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function postInteraction() {
                return _ref8.apply(this, arguments);
            };
        }();
        var noMoreActiveMetricVariantHolds = ((_interaction$hold3pAc9 = interaction.hold3pActive) === null || _interaction$hold3pAc9 === void 0 ? void 0 : _interaction$hold3pAc9.size) === 0 || interaction.hold3pActive === undefined;
        var shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $f4a9e9c030243ab6$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If using separated metric variant behavior, wait for extended category holds to clear.
        // The backing fields still use their legacy 3P names because they are part of the existing
        // third-party payload contract, but this bucket now also drives client metric windows.
        if (shouldUseSeparatedMetricVariantBehavior) {
            // If there are no standard holds active, mark the interaction as successful
            // but don't finish until extended metric variant holds are cleared.
            if (noMoreActiveHolds && !noMoreActiveMetricVariantHolds) {
                // Mark interaction as successful by setting endTime, but don't finish yet
                if (endTime !== undefined && interaction.end === 0) interaction.end = endTime;
                $f4a9e9c030243ab6$var$moveLateActiveHoldsToExtendedBucket(interaction);
                $f4a9e9c030243ab6$var$ensureMetricWindows(interaction);
                // Wait for extended metric variant holds to clear before finishing.
                return;
            }
            // If all holds, including extended metric variant holds, are cleared, finish the interaction.
            if (noMoreActiveHolds && noMoreActiveMetricVariantHolds) {
                if (!$f4a9e9c030243ab6$var$activeSubmitted) {
                    var _getConfig4, _getConfig5;
                    // Set the legacy third-party end marker when extended metric variant holds clear,
                    // preserving existing 3P payload behavior while category-specific end times are
                    // recorded separately in metricCategoryEnds. When a genuine third-party hold is still
                    // active (or was the last to release), `getNonExcludedThirdPartyEnd` returns the same
                    // clamped current time as before. When only excluded background-script holds remain,
                    // the marker is derived from the non-excluded third-party holds and floored to the
                    // interaction end, so a background script cannot drag it late.
                    var currentTime = endTime !== null && endTime !== void 0 ? endTime : performance.now();
                    interaction.end3p = $f4a9e9c030243ab6$var$getNonExcludedThirdPartyEnd(interaction, interaction.end !== 0 && currentTime < interaction.end ? interaction.end : currentTime, interaction.end !== 0 ? interaction.end : currentTime);
                    $f4a9e9c030243ab6$var$ensureMetricWindows(interaction);
                    $f4a9e9c030243ab6$var$finishInteraction(interactionId, interaction, interaction.end !== 0 ? interaction.end : endTime);
                    if ((_getConfig4 = (0, $rHZri.getConfig)()) !== null && _getConfig4 !== void 0 && (_getConfig4 = _getConfig4.extraSearchPageInteraction) !== null && _getConfig4 !== void 0 && _getConfig4.enabled && interaction.ufoName === ((_getConfig5 = (0, $rHZri.getConfig)()) === null || _getConfig5 === void 0 || (_getConfig5 = _getConfig5.extraSearchPageInteraction) === null || _getConfig5 === void 0 ? void 0 : _getConfig5.searchPageMetricName)) (0, $6XIot.onSearchPageInteractionComplete)(interactionId, interaction);
                    $f4a9e9c030243ab6$var$activeSubmitted = true;
                }
                postInteraction();
            }
        } else if (noMoreActiveHolds) {
            if (!$f4a9e9c030243ab6$var$activeSubmitted) {
                var _getConfig6, _getConfig7;
                $f4a9e9c030243ab6$var$finishInteraction(interactionId, interaction, endTime);
                if ((_getConfig6 = (0, $rHZri.getConfig)()) !== null && _getConfig6 !== void 0 && (_getConfig6 = _getConfig6.extraSearchPageInteraction) !== null && _getConfig6 !== void 0 && _getConfig6.enabled && interaction.ufoName === ((_getConfig7 = (0, $rHZri.getConfig)()) === null || _getConfig7 === void 0 || (_getConfig7 = _getConfig7.extraSearchPageInteraction) === null || _getConfig7 === void 0 ? void 0 : _getConfig7.searchPageMetricName)) (0, $6XIot.onSearchPageInteractionComplete)(interactionId, interaction);
                $f4a9e9c030243ab6$var$activeSubmitted = true;
            }
            postInteraction();
        }
    }
}
function $f4a9e9c030243ab6$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach(function(cancelCallback) {
        cancelCallback();
    });
}
function $f4a9e9c030243ab6$export$5def58af4fd46132(interactionId, abortReason) {
    var interaction = (0, $3Ammo.interactions).get(interactionId);
    if (interaction != null) {
        var _interaction$hold3pAc10, _interaction$hold3pAc11;
        var shouldUseRawDataThirdParty = (0, $rHZri.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        var noMoreActiveHolds = interaction.holdActive.size === 0;
        var has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        var shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $f4a9e9c030243ab6$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            var _interaction$hold3pAc0, _interaction$hold3pAc1;
            var endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Excluded background-script holds that are still active at abort/timeout must not drag
            // `end3p` (and thus the include-third-party window) past the real interaction end. Derive it
            // from the non-excluded third-party holds only. `recordActiveMetricVariantCategoryEnds`
            // likewise skips excluded holds internally.
            interaction.end3p = $f4a9e9c030243ab6$var$getNonExcludedThirdPartyEnd(interaction, performance.now(), endTime);
            $f4a9e9c030243ab6$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $f4a9e9c030243ab6$var$addLifecycleObservation(interaction, {
                type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
                timestamp: interaction.end3p,
                activeHoldCount: (_interaction$hold3pAc0 = (_interaction$hold3pAc1 = interaction.hold3pActive) === null || _interaction$hold3pAc1 === void 0 ? void 0 : _interaction$hold3pAc1.size) !== null && _interaction$hold3pAc0 !== void 0 ? _interaction$hold3pAc0 : 0
            });
            $f4a9e9c030243ab6$var$ensureMetricWindows(interaction);
            $f4a9e9c030243ab6$var$finishInteraction(interactionId, interaction, endTime);
            $f4a9e9c030243ab6$export$d8f52e8f804021e8.reset();
            $f4a9e9c030243ab6$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        $f4a9e9c030243ab6$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $f4a9e9c030243ab6$var$addLifecycleObservation(interaction, {
            type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
            timestamp: performance.now(),
            activeHoldCount: interaction.holdActive.size + ((_interaction$hold3pAc10 = (_interaction$hold3pAc11 = interaction.hold3pActive) === null || _interaction$hold3pAc11 === void 0 ? void 0 : _interaction$hold3pAc11.size) !== null && _interaction$hold3pAc10 !== void 0 ? _interaction$hold3pAc10 : 0)
        });
        $f4a9e9c030243ab6$var$finishInteraction(interactionId, interaction);
        $f4a9e9c030243ab6$export$d8f52e8f804021e8.reset();
        $f4a9e9c030243ab6$export$d8f52e8f804021e8.stopVCObserver();
    }
}
function $f4a9e9c030243ab6$export$c4a545284f55edf2(interactionId, interactionName) {
    var interaction = (0, $3Ammo.interactions).get(interactionId);
    if (interaction != null) {
        var shouldUseRawDataThirdParty = (0, $rHZri.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        var noMoreActiveHolds = interaction.holdActive.size === 0;
        var has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        var shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $f4a9e9c030243ab6$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            var endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Excluded background-script holds still active at this point must not drag `end3p` (and
            // thus the include-third-party window) past the real interaction end. Derive it from the
            // non-excluded third-party holds only, clamped to at least the interaction end.
            interaction.end3p = $f4a9e9c030243ab6$var$getNonExcludedThirdPartyEnd(interaction, performance.now(), endTime);
            $f4a9e9c030243ab6$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $f4a9e9c030243ab6$var$addLifecycleObservation(interaction, {
                type: 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: interactionName
            });
            $f4a9e9c030243ab6$var$ensureMetricWindows(interaction);
            $f4a9e9c030243ab6$var$finishInteraction(interactionId, interaction, endTime);
            $f4a9e9c030243ab6$export$d8f52e8f804021e8.reset();
            $f4a9e9c030243ab6$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        $f4a9e9c030243ab6$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $f4a9e9c030243ab6$var$addLifecycleObservation(interaction, {
            type: 'new_interaction_started',
            timestamp: performance.now(),
            triggerName: interactionName
        });
        $f4a9e9c030243ab6$var$finishInteraction(interactionId, interaction);
        $f4a9e9c030243ab6$export$d8f52e8f804021e8.reset();
        $f4a9e9c030243ab6$export$d8f52e8f804021e8.stopVCObserver();
    } else {
        // post-interaction log is active after interaction is aborted by new one
        $f4a9e9c030243ab6$export$d8f52e8f804021e8.reset();
        $f4a9e9c030243ab6$export$d8f52e8f804021e8.stopVCObserver();
    }
}
function $f4a9e9c030243ab6$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    var activeInteraction = $f4a9e9c030243ab6$export$2b3954d2e8509985();
    var finishInteractions = (0, $rHZri.getFinishInteractionOnTransition)();
    (0, $3Ammo.interactions).forEach(function(interaction, interactionId) {
        var isActiveInteraction = activeInteraction === interaction;
        var hasFinished = interaction.holdActive.size === 0;
        if (isActiveInteraction && abortReason === 'transition' && interaction.type === 'press' && finishInteractions !== null && finishInteractions !== void 0 && finishInteractions.includes(interaction.ufoName)) hasFinished = true;
        var shouldUseRawDataThirdParty = (0, $rHZri.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        var noMoreActiveHolds = interaction.holdActive.size === 0;
        var has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        var shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $f4a9e9c030243ab6$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            var endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Excluded background-script holds still active at transition/new-interaction abort must not
            // drag `end3p` (and thus the include-third-party window) past the real interaction end.
            // Derive it from the non-excluded third-party holds only, clamped to at least the end.
            interaction.end3p = $f4a9e9c030243ab6$var$getNonExcludedThirdPartyEnd(interaction, performance.now(), endTime);
            $f4a9e9c030243ab6$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $f4a9e9c030243ab6$var$addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: abortedByInteractionName
            });
            $f4a9e9c030243ab6$var$ensureMetricWindows(interaction);
            $f4a9e9c030243ab6$var$finishInteraction(interactionId, interaction, endTime);
            $f4a9e9c030243ab6$export$d8f52e8f804021e8.reset();
            $f4a9e9c030243ab6$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        if (!hasFinished) {
            $f4a9e9c030243ab6$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
            $f4a9e9c030243ab6$var$addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: performance.now(),
                triggerName: abortedByInteractionName
            });
        }
        $f4a9e9c030243ab6$var$finishInteraction(interactionId, interaction);
        $f4a9e9c030243ab6$export$d8f52e8f804021e8.reset();
        $f4a9e9c030243ab6$export$d8f52e8f804021e8.stopVCObserver();
    });
}
function $f4a9e9c030243ab6$export$7b9261a96cfe427b(id, cancelCallback) {
    var interaction = (0, $3Ammo.interactions).get(id);
    interaction === null || interaction === void 0 || interaction.cancelCallbacks.push(cancelCallback);
}
function $f4a9e9c030243ab6$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName) {
    var _config$extraSearchPa, _config$extraSearchPa2;
    var trace = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
    var preloadKey = arguments.length > 8 ? arguments[8] : undefined;
    $f4a9e9c030243ab6$export$d8f52e8f804021e8.reset();
    var vcObserver;
    var previousTime = startTime;
    var timeoutTime = (0, $rHZri.getInteractionTimeout)(ufoName);
    var timerID = setTimeout(function() {
        $f4a9e9c030243ab6$export$5def58af4fd46132(interactionId, 'timeout');
    }, timeoutTime);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        var currentTime = performance.now();
        var timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        var newTimerID = setTimeout(function() {
            $f4a9e9c030243ab6$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    var addFeatureFlagsToInteraction = (0, $4g5L8.default)((0, $rHZri.getCapabilityRate)('feature_flag_access'));
    var config = (0, $rHZri.getConfig)();
    var searchPageConfig = {
        enableSmartAnswersMutations: config === null || config === void 0 || (_config$extraSearchPa = config.extraSearchPageInteraction) === null || _config$extraSearchPa === void 0 ? void 0 : _config$extraSearchPa.enabled,
        searchPageRoute: config === null || config === void 0 || (_config$extraSearchPa2 = config.extraSearchPageInteraction) === null || _config$extraSearchPa2 === void 0 ? void 0 : _config$extraSearchPa2.searchPageRoute
    };
    if (config && config.vc) {
        var vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, $rHZri.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders,
            searchPageConfig: searchPageConfig
        };
        vcObserver = (0, $epPfj.newVCObserver)(vcOptions);
    }
    var priorAccessedFg = type === 'press' ? {} : Object.fromEntries((0, $67sOe.allFeatureFlagsAccessed));
    var metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        preloadKey: preloadKey,
        type: type,
        previousInteractionName: $f4a9e9c030243ab6$export$dbba6cdedab4e68b.name,
        isPreviousInteractionAborted: $f4a9e9c030243ab6$export$dbba6cdedab4e68b.isAborted === true,
        marks: [],
        customData: [],
        cohortingCustomData: new Map(),
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdActive: new Map(),
        preloadInfo: [],
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        excluded3pSegmentData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName !== null && routeName !== void 0 ? routeName : ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: priorAccessedFg,
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace,
        vcObserver: vcObserver,
        hold3pActive: new Map(),
        hold3pInfo: [],
        minorInteractions: []
    };
    if (addFeatureFlagsToInteraction) (0, $67sOe.currentFeatureFlagsAccessed).clear();
    (0, $3Ammo.interactions).set(interactionId, metrics);
    var segmentObserver = {
        onAdd: function onAdd(segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove: function onRemove() {}
    };
    $f4a9e9c030243ab6$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(function() {
        $f4a9e9c030243ab6$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(function() {
        clearTimeout(metrics.timerID);
    });
    // Add cleanup for per-interaction VC observer
    if (vcObserver) metrics.cleanupCallbacks.push(function() {
        vcObserver.stop(ufoName);
    });
    var awaitBM3TTIList = (0, $rHZri.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $f4a9e9c030243ab6$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition' || type === 'page_load') {
        var _getConfig8;
        // Use per-interaction VC observer if available, otherwise fall back to global
        var observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
        // Start post interaction observer for all if config is enabled
        // in case ufoName is updated at later time
        if ((_getConfig8 = (0, $rHZri.getConfig)()) !== null && _getConfig8 !== void 0 && (_getConfig8 = _getConfig8.postInteractionLog) !== null && _getConfig8 !== void 0 && _getConfig8.enabled) $f4a9e9c030243ab6$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
    }
    if (type === 'press') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        var _observer = vcObserver;
        if (_observer) _observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
    }
    if ($f4a9e9c030243ab6$var$onInteractionStartForPreloadHolds) try {
        $f4a9e9c030243ab6$var$onInteractionStartForPreloadHolds(interactionId, ufoName, preloadKey);
    } catch (_unused9) {
    // Preload instrumentation must not break interaction creation.
    }
}
function $f4a9e9c030243ab6$export$4a759336b50e86e3(event) {
    var interaction = $f4a9e9c030243ab6$export$2b3954d2e8509985();
    if (interaction) {
        var _event$config;
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && ((_event$config = event.config) === null || _event$config === void 0 ? void 0 : _event$config.type) === 'PAGE_LOAD') $f4a9e9c030243ab6$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
    }
}
function $f4a9e9c030243ab6$export$ad216cc25852d44b(apdex) {
    (0, $3Ammo.interactions).forEach(function(interaction, key) {
        interaction.apdex.push(apdex);
        try {
            var _apdex$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdex.key, " [bm3_tti]"), {
                start: (_apdex$startTime = apdex.startTime) !== null && _apdex$startTime !== void 0 ? _apdex$startTime : interaction.start,
                end: apdex.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark("[bm3] TTI", {
                startTime: apdex.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch (_unused0) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $f4a9e9c030243ab6$export$4983dfbbb996f7ae(key, interaction.ufoName);
    });
}
function $f4a9e9c030243ab6$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    var interaction = (0, $3Ammo.interactions).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            var _apdexInfo$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdexInfo.key, " [bm3_tti]"), {
                start: (_apdexInfo$startTime = apdexInfo.startTime) !== null && _apdexInfo$startTime !== void 0 ? _apdexInfo$startTime : interaction.start,
                end: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark("[bm3] TTI", {
                startTime: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch (_unused1) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $f4a9e9c030243ab6$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
    }
}
function $f4a9e9c030243ab6$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    var interaction = (0, $3Ammo.interactions).get(interactionId);
    if (interaction != null) interaction.requestInfo.push($f4a9e9c030243ab6$var$_objectSpread({
        labelStack: labelStack
    }, requestInfo));
}
function $f4a9e9c030243ab6$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $f4a9e9c030243ab6$var$getSegmentCacheKey(labelStack) {
    return labelStack.map(function(l) {
        if ($f4a9e9c030243ab6$var$isSegmentLabel(l)) return "".concat(l.name, "_").concat(l.segmentId);
        return l.name;
    }).join('|');
}
function $f4a9e9c030243ab6$export$1c43f9ac826b6462(labelStack) {
    var key = $f4a9e9c030243ab6$var$getSegmentCacheKey(labelStack);
    var existingSegment = $f4a9e9c030243ab6$var$segmentCache.get(key);
    if (!existingSegment) {
        var segmentInfo = {
            labelStack: labelStack
        };
        $f4a9e9c030243ab6$var$segmentCache.set(key, segmentInfo);
        $f4a9e9c030243ab6$var$segmentObservers.forEach(function(observer) {
            observer.onAdd(segmentInfo);
        });
    }
}
function $f4a9e9c030243ab6$export$d0365e48b58231c3(labelStack) {
    var key = $f4a9e9c030243ab6$var$getSegmentCacheKey(labelStack);
    var segmentInfo = $f4a9e9c030243ab6$var$segmentCache.get(key);
    if (segmentInfo) {
        $f4a9e9c030243ab6$var$segmentCache.delete(JSON.stringify(labelStack));
        var cacheKey = (0, $2U3Me.stringifyLabelStackFully)(labelStack);
        $f4a9e9c030243ab6$export$a2b14406ded37d60.set(cacheKey, ($f4a9e9c030243ab6$export$a2b14406ded37d60.get(cacheKey) || 0) + 1);
        $f4a9e9c030243ab6$var$segmentObservers.forEach(function(observer) {
            observer.onRemove(segmentInfo);
        });
    }
}
function $f4a9e9c030243ab6$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    var interaction = (0, $3Ammo.interactions).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($f4a9e9c030243ab6$var$isPerformanceTracingEnabled()) {
            var prevRedirect = interaction.redirects.at(-2);
            try {
                var _prevRedirect$time;
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat(nextUfoName, " [redirect]"), {
                    start: (_prevRedirect$time = prevRedirect === null || prevRedirect === void 0 ? void 0 : prevRedirect.time) !== null && _prevRedirect$time !== void 0 ? _prevRedirect$time : interaction.start,
                    end: time,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary'
                        }
                    }
                });
            } catch (_unused10) {
            // do nothing
            }
        }
    }
}
var $f4a9e9c030243ab6$export$6ce04c7ca6810a7e = [];
var $f4a9e9c030243ab6$var$defaultLabelStack = [
    {
        name: 'custom'
    }
];
function $f4a9e9c030243ab6$export$5342dcad19138a1c(name, start) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var labelStack = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : $f4a9e9c030243ab6$var$defaultLabelStack;
    var customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $f4a9e9c030243ab6$export$6ce04c7ca6810a7e.push(customSpan);
}

});
parcelRegister("4g5L8", function(module, exports) {
$parcel$export(module.exports, "default", () => $319d1fb8691fcadc$export$2e2bcd8739ae039);
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $319d1fb8691fcadc$var$coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}
var $319d1fb8691fcadc$export$2e2bcd8739ae039 = $319d1fb8691fcadc$var$coinflip;

});

parcelRegister("9gPQ0", function(module, exports) {
$parcel$export(module.exports, "sanitizeTimingName", () => $6bfdd191733a8877$export$23e69abaca7d0236);
var $6bfdd191733a8877$export$4c07c8a3507ce307 = 255;
var $6bfdd191733a8877$var$GQL_OPERATION_PARAMS = [
    'operation',
    'operationName',
    'q'
];
function $6bfdd191733a8877$var$isGqlUrl(name) {
    try {
        var url = new URL(name);
        var searchParams = url.search ? new URLSearchParams(url.search) : null;
        return $6bfdd191733a8877$var$GQL_OPERATION_PARAMS.some(function(param) {
            return Boolean(searchParams === null || searchParams === void 0 ? void 0 : searchParams.get(param));
        });
    } catch (_unused) {
        return false;
    }
}
function $6bfdd191733a8877$export$23e69abaca7d0236(name) {
    if (name.length <= $6bfdd191733a8877$export$4c07c8a3507ce307) return name;
    if ($6bfdd191733a8877$var$isGqlUrl(name)) return name;
    return name.slice(0, $6bfdd191733a8877$export$4c07c8a3507ce307);
}

});

parcelRegister("rHZri", function(module, exports) {
$parcel$export(module.exports, "isFedrampOverrideActive", () => $0534a538692c007a$export$1133b5e2873baa7a);
$parcel$export(module.exports, "getConfig", () => $0534a538692c007a$export$44487a86467333c3);
$parcel$export(module.exports, "getSelectorConfig", () => $0534a538692c007a$export$59e1f072477dfb48);
$parcel$export(module.exports, "isUFOEnabled", () => $0534a538692c007a$export$74bdb753f1cf4860);
$parcel$export(module.exports, "isVCRevisionEnabled", () => $0534a538692c007a$export$4babcefc81a3ef0b);
$parcel$export(module.exports, "getReactHydrationStats", () => $0534a538692c007a$export$2d8f8d64dc343d7b);
$parcel$export(module.exports, "shouldUseRawDataThirdPartyBehavior", () => $0534a538692c007a$export$9c69f5a724f05f38);
$parcel$export(module.exports, "getPostInteractionRate", () => $0534a538692c007a$export$1d459f020c06ae34);
$parcel$export(module.exports, "getCapabilityRate", () => $0534a538692c007a$export$29b9ffb14861a1d);
$parcel$export(module.exports, "getAwaitBM3TTIList", () => $0534a538692c007a$export$2d311b3fd18dcab1);
$parcel$export(module.exports, "getFinishInteractionOnTransition", () => $0534a538692c007a$export$20e8108b8ccdd0bd);
$parcel$export(module.exports, "getInteractionTimeout", () => $0534a538692c007a$export$c681731847989445);

var $25nEq = parcelRequire("25nEq");

var $fC8ib = parcelRequire("fC8ib");

var $ekGgq = parcelRequire("ekGgq");

var $9hbpv = parcelRequire("9hbpv");

var $50U6m = parcelRequire("50U6m");
function $0534a538692c007a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0534a538692c007a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0534a538692c007a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0534a538692c007a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0534a538692c007a$var$config;
/**
 * Cached result of `isFedrampModerate()` so we don't re-parse cookies on
 * every selector lookup. Reset via `__resetFedrampOverrideCacheForTests` in
 * unit tests only.
 */ var $0534a538692c007a$var$cachedIsFedrampModerate;
function $0534a538692c007a$var$detectIsFedrampModerate() {
    if ($0534a538692c007a$var$cachedIsFedrampModerate !== undefined) return $0534a538692c007a$var$cachedIsFedrampModerate;
    try {
        $0534a538692c007a$var$cachedIsFedrampModerate = (0, $9hbpv.isFedrampModerate)();
    } catch (_unused) {
        // Defensive default: if perimeter detection throws, treat as non-FedRAMP
        // so UFO behaviour is unchanged. Mirrors `analyticsWebClient` pattern.
        $0534a538692c007a$var$cachedIsFedrampModerate = false;
    }
    return $0534a538692c007a$var$cachedIsFedrampModerate;
}
function $0534a538692c007a$export$89dc2b6be8cc261() {
    $0534a538692c007a$var$cachedIsFedrampModerate = undefined;
}
function $0534a538692c007a$export$1133b5e2873baa7a() {
    try {
        return $0534a538692c007a$var$detectIsFedrampModerate();
    } catch (_unused2) {
        return false;
    }
}
var $0534a538692c007a$var$FEDRAMP_DISABLED_SELECTOR_CONFIG = Object.freeze({
    id: false,
    testId: false,
    role: false,
    className: false,
    dataVC: false
});
var $0534a538692c007a$export$f9bb3bb330fb9609 = 'fy26.04';
function $0534a538692c007a$export$2182e73d31080cbc() {
    return $0534a538692c007a$export$f9bb3bb330fb9609;
}
var $0534a538692c007a$export$d50dacda7fe6392b = 1000;
function $0534a538692c007a$export$10d6139a8fb42158(newConfig) {
    var _newConfig$vc;
    // Handle edge cases with `enabledVCRevisions`
    var _ref = (_newConfig$vc = newConfig === null || newConfig === void 0 ? void 0 : newConfig.vc) !== null && _newConfig$vc !== void 0 ? _newConfig$vc : {}, enabledVCRevisions = _ref.enabledVCRevisions;
    if (enabledVCRevisions) {
        var _enabledVCRevisions$a;
        var byExperience = (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.byExperience) === 'object' ? enabledVCRevisions.byExperience : {};
        var allRevisions = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((_enabledVCRevisions$a = enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.all) !== null && _enabledVCRevisions$a !== void 0 ? _enabledVCRevisions$a : []), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Object.values(byExperience).flat()));
        $0534a538692c007a$var$config = $0534a538692c007a$var$_objectSpread($0534a538692c007a$var$_objectSpread({}, newConfig), {}, {
            vc: $0534a538692c007a$var$_objectSpread($0534a538692c007a$var$_objectSpread({}, newConfig.vc), {}, {
                enabledVCRevisions: {
                    all: Array.from(new Set(allRevisions)),
                    byExperience: byExperience
                }
            })
        });
    } else $0534a538692c007a$var$config = newConfig;
}
function $0534a538692c007a$export$44487a86467333c3() {
    return $0534a538692c007a$var$config;
}
function $0534a538692c007a$export$59e1f072477dfb48(callerOverride, defaultConfig) {
    var _ref2, _config;
    // 1. FedRAMP override always wins.
    if ($0534a538692c007a$var$detectIsFedrampModerate()) return $0534a538692c007a$var$FEDRAMP_DISABLED_SELECTOR_CONFIG;
    // 2. Then caller-provided.
    // 3. Then centrally configured.
    // 4. Then caller-provided default.
    return (_ref2 = callerOverride !== null && callerOverride !== void 0 ? callerOverride : (_config = $0534a538692c007a$var$config) === null || _config === void 0 || (_config = _config.vc) === null || _config === void 0 ? void 0 : _config.selectorConfig) !== null && _ref2 !== void 0 ? _ref2 : defaultConfig;
}
function $0534a538692c007a$export$74bdb753f1cf4860() {
    var _config2;
    // Default to enabled if config is not set or enabled is not explicitly false
    return ((_config2 = $0534a538692c007a$var$config) === null || _config2 === void 0 ? void 0 : _config2.enabled) !== false;
}
var $0534a538692c007a$var$isValidConfigArray = function isValidConfigArray(array) {
    return Array.isArray(array) && array.length > 0;
};
function $0534a538692c007a$export$87fbc8e01b137811() {
    var experienceKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    try {
        var _config$vc;
        if (!$0534a538692c007a$var$config) return [];
        if ((_config$vc = $0534a538692c007a$var$config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled) {
            var _config$vc2, _enabledVCRevisions$b;
            var _ref3 = (_config$vc2 = $0534a538692c007a$var$config.vc) !== null && _config$vc2 !== void 0 ? _config$vc2 : {}, enabledVCRevisions = _ref3.enabledVCRevisions;
            if ($0534a538692c007a$var$isValidConfigArray(enabledVCRevisions === null || enabledVCRevisions === void 0 || (_enabledVCRevisions$b = enabledVCRevisions.byExperience) === null || _enabledVCRevisions$b === void 0 ? void 0 : _enabledVCRevisions$b[experienceKey])) {
                var _enabledVCRevisions$b2;
                return (_enabledVCRevisions$b2 = enabledVCRevisions.byExperience) === null || _enabledVCRevisions$b2 === void 0 ? void 0 : _enabledVCRevisions$b2[experienceKey];
            }
            // When the disable flag is on, treat an explicitly-set empty array as
            // "no client-side revisions" rather than falling back to the default revision.
            var allRevisions = enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.all;
            if (Array.isArray(allRevisions) && allRevisions.length === 0 && (0, $50U6m.fg)('ufo_disable_ttvc_v4')) return allRevisions;
            if ($0534a538692c007a$var$isValidConfigArray(allRevisions)) return allRevisions;
            return [
                $0534a538692c007a$export$2182e73d31080cbc()
            ];
        }
        return [];
    } catch (_unused3) {
        return [];
    }
}
function $0534a538692c007a$export$4babcefc81a3ef0b(revision, experienceKey) {
    return $0534a538692c007a$export$87fbc8e01b137811(experienceKey).includes(revision);
}
function $0534a538692c007a$export$70184d6e2c753893() {
    var experienceKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var enabledVCRevisions = $0534a538692c007a$export$87fbc8e01b137811(experienceKey);
    if (enabledVCRevisions.length === 0) return $0534a538692c007a$export$2182e73d31080cbc();
    return enabledVCRevisions[enabledVCRevisions.length - 1];
}
function $0534a538692c007a$export$2d8f8d64dc343d7b() {
    if (!$0534a538692c007a$var$config) return undefined;
    try {
        var _config3, _config3$getReactHydr;
        var stats = (_config3 = $0534a538692c007a$var$config) === null || _config3 === void 0 || (_config3$getReactHydr = _config3.getReactHydrationStats) === null || _config3$getReactHydr === void 0 ? void 0 : _config3$getReactHydr.call(_config3);
        return stats !== null && stats !== void 0 ? stats : undefined;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('getReactHydrationStats threw an error: ', e);
        return undefined;
    }
}
function $0534a538692c007a$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$0534a538692c007a$var$config) return 0;
        var _config4 = $0534a538692c007a$var$config, killswitch = _config4.killswitch, rates = _config4.rates, rules = _config4.rules, kind = _config4.kind, autoGeneratedRate = _config4.autoGeneratedRate;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        var isUnknown = name === 'unknown';
        if (isUnknown) {
            if ((rates === null || rates === void 0 ? void 0 : rates[name]) != null) return rates[name];
            // Return default rate for unknown events when no explicit rate is configured
            return $0534a538692c007a$export$d50dacda7fe6392b;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(var i = 0; i < rules.length; i++){
            var rule = rules[i];
            var test = rule.test, rate = rule.rate;
            if (test != null && rate != null) {
                var regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        var isAutogenerated = name === null || name === void 0 ? void 0 : name.startsWith('auto-generated');
        if (isAutogenerated) {
            var _rate = autoGeneratedRate;
            if (_rate != null) return _rate;
        }
        if (kind != null) {
            var _rate2 = kind[interactionKind];
            if (_rate2 != null) return _rate2;
        }
        return 0;
    } catch (_unused4) {
        // Fallback
        return 0;
    }
}
function $0534a538692c007a$export$48f4e0d964030a96(name, interactionType) {
    return $0534a538692c007a$var$getConfigRate(name, interactionType, 'enableVCRawDataRates');
}
function $0534a538692c007a$export$9c69f5a724f05f38(name, interactionType) {
    return $0534a538692c007a$export$48f4e0d964030a96(name, interactionType) > 0;
}
function $0534a538692c007a$export$1d459f020c06ae34(name, interactionType) {
    return $0534a538692c007a$var$getConfigRate(name, interactionType, 'postInteractionLog');
}
function $0534a538692c007a$export$29b9ffb14861a1d(capability) {
    if ((0, $50U6m.fg)('platform_ufo_remove_deprecated_config_fields')) return 1;
    try {
        if (!$0534a538692c007a$var$config) return 0;
        var _config5 = $0534a538692c007a$var$config, capabilityRate = _config5.capability;
        if (capabilityRate != null) {
            var rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch (_unused5) {
        return 0;
    }
}
function $0534a538692c007a$var$getConfigRate(name, interactionType, configName) {
    try {
        if (!$0534a538692c007a$var$config) return 0;
        var gotConfig = $0534a538692c007a$var$config[configName];
        if (!(gotConfig !== null && gotConfig !== void 0 && gotConfig.enabled)) return 0;
        if (interactionType !== 'page_load' && interactionType !== 'transition') return 0;
        if (gotConfig.rates && typeof gotConfig.rates[name] === 'number') return gotConfig.rates[name];
        if ('kind' in gotConfig && gotConfig.kind && typeof gotConfig.kind[interactionType] === 'number') return gotConfig.kind[interactionType];
        return 0;
    } catch (_unused6) {
        return 0;
    }
}
var $0534a538692c007a$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function $0534a538692c007a$export$7e32aae12bf9b50f() {
    var defaultMethod = 'timeout';
    try {
        if (!$0534a538692c007a$var$config) return defaultMethod;
        var _config6 = $0534a538692c007a$var$config, typingMethod = _config6.typingMethod;
        if (typingMethod != null && $0534a538692c007a$var$validTypingMethods.find(function(m) {
            return m === typingMethod;
        })) return typingMethod;
        else return defaultMethod;
    } catch (_unused7) {
        return defaultMethod;
    }
}
function $0534a538692c007a$export$2d311b3fd18dcab1() {
    try {
        if (!$0534a538692c007a$var$config) return [];
        var _config7 = $0534a538692c007a$var$config, awaitBM3TTI = _config7.awaitBM3TTI;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch (_unused8) {
        return [];
    }
}
function $0534a538692c007a$export$4f4649ef27b6f5d6() {
    try {
        if (!$0534a538692c007a$var$config) return undefined;
        var _config8 = $0534a538692c007a$var$config, ufoNameOverrides = _config8.ufoNameOverrides;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch (_unused9) {
        return undefined;
    }
}
function $0534a538692c007a$export$b150ddad71c80d77() {
    try {
        if (!$0534a538692c007a$var$config) return undefined;
        var _config9 = $0534a538692c007a$var$config, minorInteractions = _config9.minorInteractions;
        return minorInteractions;
    } catch (_unused0) {
        return undefined;
    }
}
function $0534a538692c007a$export$3c170167645a0eff() {
    try {
        if (!$0534a538692c007a$var$config) return undefined;
        var _config0 = $0534a538692c007a$var$config, doNotAbortActivePressInteraction = _config0.doNotAbortActivePressInteraction;
        return doNotAbortActivePressInteraction;
    } catch (_unused1) {
        return undefined;
    }
}
function $0534a538692c007a$export$d6dc9444bd15f70f() {
    try {
        if (!$0534a538692c007a$var$config) return undefined;
        var _config1 = $0534a538692c007a$var$config, doNotAbortActivePressInteractionOnTransition = _config1.doNotAbortActivePressInteractionOnTransition;
        return doNotAbortActivePressInteractionOnTransition;
    } catch (_unused10) {
        return undefined;
    }
}
function $0534a538692c007a$export$20e8108b8ccdd0bd() {
    try {
        if (!$0534a538692c007a$var$config) return undefined;
        var _config10 = $0534a538692c007a$var$config, finishInteractionOnTransition = _config10.finishInteractionOnTransition;
        return finishInteractionOnTransition;
    } catch (_unused11) {
        return undefined;
    }
}
var $0534a538692c007a$export$2a8604960d7d23d9 = 60000;
function $0534a538692c007a$export$c681731847989445(ufoName) {
    try {
        if (!$0534a538692c007a$var$config) return $0534a538692c007a$export$2a8604960d7d23d9;
        var _config11 = $0534a538692c007a$var$config, interactionTimeout = _config11.interactionTimeout;
        if (interactionTimeout != null && interactionTimeout[ufoName] != null) return interactionTimeout[ufoName];
        if (interactionTimeout != null && interactionTimeout.__globalInteractionTimeout != null) return interactionTimeout.__globalInteractionTimeout;
        else return $0534a538692c007a$export$2a8604960d7d23d9;
    } catch (_unused12) {
        return $0534a538692c007a$export$2a8604960d7d23d9;
    }
}

});
parcelRegister("9hbpv", function(module, exports) {
$parcel$export(module.exports, "isFedrampModerate", () => $6c0e8d791e0d797b$export$104cb891a6e90b3a);

var $bztRu = parcelRequire("bztRu");

var $kLD0I = parcelRequire("kLD0I");
function $6c0e8d791e0d797b$export$104cb891a6e90b3a() {
    if (typeof document === 'undefined') {
        var _globalThis$ssrContex, _globalThis$ssrContex2;
        // @ts-ignore
        return (_globalThis$ssrContex = (_globalThis$ssrContex2 = globalThis.ssrContext) === null || _globalThis$ssrContex2 === void 0 ? void 0 : _globalThis$ssrContex2.isInFedramp) !== null && _globalThis$ssrContex !== void 0 ? _globalThis$ssrContex : false;
    }
    var atlCtxCookieValues = (0, $kLD0I.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $bztRu.FEDRAMP_MODERATE);
}

});
parcelRegister("bztRu", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $86ca207dc1d610a8$export$ce553301d55c2fd8);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $86ca207dc1d610a8$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $86ca207dc1d610a8$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $86ca207dc1d610a8$export$a0ffa0598c95dfb7);
var $86ca207dc1d610a8$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $86ca207dc1d610a8$export$f005e2e9f707cb5f = 'commercial';
var $86ca207dc1d610a8$export$17b81a3d6c98013c = 'isolated-cloud';
var $86ca207dc1d610a8$export$a739cd5aac835909 = 'staging';
var $86ca207dc1d610a8$export$42dd0cdd351a4a9 = 'prod';
var $86ca207dc1d610a8$export$404582bc18fe4d9e = 'dev';
var $86ca207dc1d610a8$export$87285944378c596 = 'Atl-Ctx-Perimeter';
var $86ca207dc1d610a8$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
var $86ca207dc1d610a8$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
var $86ca207dc1d610a8$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
var $86ca207dc1d610a8$export$b61e047ddcc35726 = 'GCP';
var $86ca207dc1d610a8$export$1baf17f3e645a2b2 = 'AWS';

});

parcelRegister("kLD0I", function(module, exports) {
$parcel$export(module.exports, "parseAtlCtxCookies", () => $f1e6751ca95f0841$export$3fa7b7af96286cc9);

var $bztRu = parcelRequire("bztRu");

var $7bXX8 = parcelRequire("7bXX8");
function $f1e6751ca95f0841$export$3fa7b7af96286cc9() {
    var global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        var cookies = global.document.cookie;
        var perimeter = (0, $7bXX8.getRawCookieValue)((0, $bztRu.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        var icDomain = (0, $7bXX8.getRawCookieValue)((0, $bztRu.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        var icId = (0, $7bXX8.getRawCookieValue)((0, $bztRu.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        var emptyIcDomain = !icDomain || icDomain.length === 0;
        var emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});
parcelRegister("7bXX8", function(module, exports) {
$parcel$export(module.exports, "getRawCookieValue", () => $53c810d8602944f6$export$aa09aab30a92256c);

var $iYJcE = parcelRequire("iYJcE");
function $53c810d8602944f6$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $53c810d8602944f6$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $53c810d8602944f6$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $53c810d8602944f6$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $53c810d8602944f6$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $53c810d8602944f6$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $53c810d8602944f6$export$aa09aab30a92256c(cookieName, cookieString) {
    if (!cookieString) return undefined;
    var cookies = cookieString.split(';');
    var _iterator = $53c810d8602944f6$var$_createForOfIteratorHelper(cookies), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var cookie = _step.value;
            var _cookie$trim$split = cookie.trim().split('='), _cookie$trim$split2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_cookie$trim$split, 2), name = _cookie$trim$split2[0], value = _cookie$trim$split2[1];
            if (name === cookieName) return value;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return undefined;
}

});




parcelRegister("6XIot", function(module, exports) {
$parcel$export(module.exports, "onSearchPageInteractionComplete", () => $511ab06b3dea6298$export$74b9ce7e9d206a8);

var $ec2Sa = parcelRequire("ec2Sa");
function $511ab06b3dea6298$export$74b9ce7e9d206a8(interactionId, data) {
    if (data.ufoName) {
        (0, $ec2Sa.interactionBufferState).bufferInteractionData(interactionId, data);
        (0, $ec2Sa.interactionBufferState).interactionBuffer.length = 0;
    }
}

});
parcelRegister("ec2Sa", function(module, exports) {
$parcel$export(module.exports, "interactionBufferState", () => $a5546a1d1e630061$export$af15cc1c63c2807a);
var $a5546a1d1e630061$var$interactionBuffer = [];
var $a5546a1d1e630061$export$af15cc1c63c2807a = {
    interactionBuffer: $a5546a1d1e630061$var$interactionBuffer,
    bufferInteractionData: function bufferInteractionData(interactionId, data) {
        $a5546a1d1e630061$var$interactionBuffer.push({
            interactionId: interactionId,
            data: data
        });
    }
};

});


parcelRegister("hueS2", function(module, exports) {
$parcel$export(module.exports, "sanitizeUfoName", () => $cbb0c5f9c6fa31fb$export$e08487ea3ae92adb);
function $cbb0c5f9c6fa31fb$export$e08487ea3ae92adb(name) {
    return name.replace(/_/g, '-');
}

});

parcelRegister("2U3Me", function(module, exports) {
$parcel$export(module.exports, "stringifyLabelStackFully", () => $21d3bdc44affe4c8$export$caeee352b541de1f);

var $h66Ph = parcelRequire("h66Ph");

var $bavRs = parcelRequire("bavRs");
function $21d3bdc44affe4c8$export$caeee352b541de1f(labelStack) {
    return labelStack.map(function(l) {
        var name = (0, $bavRs.sanitizeLabelStackName)(l.name);
        if ((0, $h66Ph.isSegmentLabel)(l)) return "".concat(name, ":").concat(l.segmentId);
        return name;
    }).join('/');
}

});
parcelRegister("h66Ph", function(module, exports) {
$parcel$export(module.exports, "isSegmentLabel", () => $c7284abbe9101393$export$1adbaf5c2363e4ae);
function $c7284abbe9101393$export$1adbaf5c2363e4ae(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}

});

parcelRegister("bavRs", function(module, exports) {
$parcel$export(module.exports, "sanitizeLabelStackName", () => $821957db8642a35a$export$3535cd9da4961282);
function $821957db8642a35a$export$3535cd9da4961282(name) {
    if (name.startsWith('/')) name = name.replace(/^\/+/, '');
    if (name.endsWith('/')) name = name.replace(/\/+$/, '');
    return name;
}

});


parcelRegister("3Mlfh", function(module, exports) {
$parcel$export(module.exports, "clearActiveTrace", () => $2c0655b7d9512bfd$export$17ab21d7be720b);

var $eRfZr = parcelRequire("eRfZr");

var $50U6m = parcelRequire("50U6m");

var $ex4s7 = parcelRequire("ex4s7");

var $eCPba = parcelRequire("eCPba");
function $2c0655b7d9512bfd$export$17ab21d7be720b() {
    if ((0, $50U6m.fg)('platform_ufo_enable_otel_context_manager')) // Now we need to get the global Context Manager and set the active context
    // Using type assertion because we've "extended" the ContextManager type
    {
        if ((0, $ex4s7.getContextManager)() instanceof (0, $ex4s7.UFOContextManager)) {
            var contextManager = (0, $ex4s7.getContextManager)();
            // ROOT_CONTEXT is an empty context used to initialise ContextManagers
            contextManager.setActive((0, $eRfZr.ROOT_CONTEXT));
        }
    } else (0, $eCPba.state).context = null;
}

});
parcelRegister("ex4s7", function(module, exports) {
$parcel$export(module.exports, "getContextManager", () => $a94799f0eab058e3$export$831109c9f7727010);
$parcel$export(module.exports, "UFOContextManager", () => $a94799f0eab058e3$export$dd301b96c16f583d);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $eRfZr = parcelRequire("eRfZr");
/**
 * We need to store a reference to the Context manager so that we can get it later.
 * This is because the OTel JS API doesn't allow us to get the registered context manager,
 * and we need to get it because we need to call a function that's not available in the OTel API:
 * `setActive`. The OTel JS API design doesn't allow us to manually set the active context
 * despite the spec allowing for the capability. Sigh.
 *
 * I imagine this situation might not be permanent if we can move to a system were we can rely
 * solely on the API, but for the purposes of the first change being React UFO API compatible,
 * we'll need to do this.
 */ var $a94799f0eab058e3$var$contextManager;
function $a94799f0eab058e3$export$4a00ab8a5dd9b5cf(ctxMgr) {
    $a94799f0eab058e3$var$contextManager = ctxMgr;
}
function $a94799f0eab058e3$export$831109c9f7727010() {
    return $a94799f0eab058e3$var$contextManager;
}
var $a94799f0eab058e3$export$dd301b96c16f583d = /*#__PURE__*/ function() {
    function UFOContextManager() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UFOContextManager);
        /**
     * whether the context manager is enabled or not
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_enabled", false);
        /**
     * Keeps the reference to current context
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_currentContext", (0, $eRfZr.ROOT_CONTEXT));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UFOContextManager, [
        {
            key: "_bindFunction",
            value: /**
     *
     * @param context
     * @param target Function to be executed within the context
     */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
            function _bindFunction() {
                var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $eRfZr.ROOT_CONTEXT);
                var target = arguments.length > 1 ? arguments[1] : undefined;
                // eslint-disable-next-line @typescript-eslint/no-this-alias
                var manager = this;
                var contextWrapper = function contextWrapper() {
                    var _this = this;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return manager.with(context, function() {
                        return target.apply(_this, args);
                    });
                };
                Object.defineProperty(contextWrapper, 'length', {
                    enumerable: false,
                    configurable: true,
                    writable: false,
                    value: target.length
                });
                return contextWrapper;
            }
        },
        {
            key: "active",
            value: function active() {
                return this._currentContext;
            }
        },
        {
            key: "bind",
            value: function bind(context, target) {
                // if no specific context to propagate is given, we use the current one
                if (context === undefined) context = this.active();
                if (typeof target === 'function') return this._bindFunction(context, target);
                return target;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this._currentContext = (0, $eRfZr.ROOT_CONTEXT);
                this._enabled = false;
                return this;
            }
        },
        {
            key: "enable",
            value: function enable() {
                if (this._enabled) return this;
                this._enabled = true;
                this._currentContext = (0, $eRfZr.ROOT_CONTEXT);
                return this;
            }
        },
        {
            key: "with",
            value: function _with(context, fn, thisArg) {
                var previousContext = this._currentContext;
                this._currentContext = context || (0, $eRfZr.ROOT_CONTEXT);
                try {
                    for(var _len2 = arguments.length, args = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++)args[_key2 - 3] = arguments[_key2];
                    return fn.call.apply(fn, [
                        thisArg
                    ].concat(args));
                } finally{
                    this._currentContext = previousContext;
                }
            }
        },
        {
            key: "setActive",
            value: function setActive(context) {
                if (this._enabled) this._currentContext = context;
            }
        }
    ]);
}();

});

parcelRegister("eCPba", function(module, exports) {
$parcel$export(module.exports, "state", () => $aa5c5066f4a6fcb4$export$ca000e230c0caa3e);
var $aa5c5066f4a6fcb4$export$ca000e230c0caa3e = {
    context: null
};

});


parcelRegister("hcjVr", function(module, exports) {
$parcel$export(module.exports, "getInteractionId", () => $033b25376c77ba71$export$37bca3107733ac1e);

var $kS8qg = parcelRequire("kS8qg");
var $033b25376c77ba71$export$37bca3107733ac1e = function getInteractionId() {
    return 0, $kS8qg.default;
};

});
parcelRegister("kS8qg", function(module, exports) {
$parcel$export(module.exports, "default", () => $f31f625da2acf361$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $7q7Oe = parcelRequire("7q7Oe");
// Same structure as react's useRef.
// This allows modals to use a ref to scope their value
// const id = useRef(null);
// <InteractionIDContext.Provider value={id}>...<
var $f31f625da2acf361$var$ObservableInteractionID = /*#__PURE__*/ function() {
    function ObservableInteractionID() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ObservableInteractionID);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_current", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ObservableInteractionID, [
        {
            key: "current",
            get: function get() {
                return this._current;
            },
            set: function set(newId) {
                var oldId = this._current;
                this._current = newId;
                if (oldId !== newId) (0, $7q7Oe.listeners).forEach(function(listener) {
                    return listener(newId);
                });
            }
        }
    ]);
}();
var $f31f625da2acf361$var$initializeGlobalDefaultInteractionID = function initializeGlobalDefaultInteractionID() {
    if (globalThis.__UFO_DEFAULT_INTERACTION_ID__) return globalThis.__UFO_DEFAULT_INTERACTION_ID__;
    var instance = new $f31f625da2acf361$var$ObservableInteractionID();
    globalThis.__UFO_DEFAULT_INTERACTION_ID__ = instance;
    return instance;
};
var $f31f625da2acf361$var$DefaultInteractionID = $f31f625da2acf361$var$initializeGlobalDefaultInteractionID();
var $f31f625da2acf361$export$2e2bcd8739ae039 = $f31f625da2acf361$var$DefaultInteractionID;

});
parcelRegister("7q7Oe", function(module, exports) {
$parcel$export(module.exports, "listeners", () => $567104d7bd2dfc11$export$58bed631278dbc67);
$parcel$export(module.exports, "subscribeToInteractionIdChanges", () => $567104d7bd2dfc11$export$3e0c3023952f6774);
// Subscription system for interaction ID changes
var $567104d7bd2dfc11$export$58bed631278dbc67 = new Set();
var $567104d7bd2dfc11$export$3e0c3023952f6774 = function subscribeToInteractionIdChanges(listener) {
    $567104d7bd2dfc11$export$58bed631278dbc67.add(listener);
    return function() {
        $567104d7bd2dfc11$export$58bed631278dbc67.delete(listener);
    };
};

});



parcelRegister("it7am", function(module, exports) {
$parcel$export(module.exports, "BACKEND_RESOURCE_TIMING_INITIATOR_TYPES", () => $d7207e7990a1db2f$export$c3b002e13fbb9ef2);
var $d7207e7990a1db2f$export$c3b002e13fbb9ef2 = new Set([
    'fetch',
    'xmlhttprequest'
]);

});

parcelRegister("3Mmjz", function(module, exports) {
$parcel$export(module.exports, "flushSsrRenderProfilerTraces", () => $2c072a0258f42fe2$export$c8760e11c713fafc);

var $6lm17 = parcelRequire("6lm17");
var $2c072a0258f42fe2$export$c8760e11c713fafc = function flushSsrRenderProfilerTraces() {
    (0, $6lm17.default).spanStates.forEach(function(spanState) {
        if (spanState.latestEndTime != null) spanState.span.end(spanState.latestEndTime);
    });
    (0, $6lm17.default).spanStates.clear();
};

});
parcelRegister("6lm17", function(module, exports) {
$parcel$export(module.exports, "default", () => $49e5c85c2c150619$export$2e2bcd8739ae039);
// Shared across profiler renders and the public reset/flush entry points. Keep this
// outside React context so Suspense restarts cannot discard the initial render.
var $49e5c85c2c150619$var$state = {
    startTimes: new Map(),
    spanStates: new Map(),
    lastActiveInteraction: undefined
};
var $49e5c85c2c150619$export$2e2bcd8739ae039 = $49e5c85c2c150619$var$state;

});


parcelRegister("epPfj", function(module, exports) {
$parcel$export(module.exports, "newVCObserver", () => $a7eb26dac776679f$export$c69731bddfc24d85);

var $4UxzA = parcelRequire("4UxzA");

var $3EIxL = parcelRequire("3EIxL");

var $58uSL = parcelRequire("58uSL");
function $a7eb26dac776679f$export$c69731bddfc24d85() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var shouldMockVCObserver = !(0, $4UxzA.isEnvironmentSupported)();
    var observer = shouldMockVCObserver ? new (0, $3EIxL.VCObserverNOOP)() : new (0, $58uSL.VCObserverWrapper)(opts);
    return observer;
}

});
parcelRegister("4UxzA", function(module, exports) {
$parcel$export(module.exports, "isEnvironmentSupported", () => $39366f47841f5608$export$68d57b133e88584d);

var $3ZMUU = parcelRequire("3ZMUU");
var $39366f47841f5608$var$_process;
// Some products set this variable to indicate it is running in SSR
var $39366f47841f5608$var$isServer = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
var $39366f47841f5608$var$isReactSSR = typeof $3ZMUU !== 'undefined' && Boolean((($39366f47841f5608$var$_process = $3ZMUU) === null || $39366f47841f5608$var$_process === void 0 || ($39366f47841f5608$var$_process = $39366f47841f5608$var$_process.env) === null || $39366f47841f5608$var$_process === void 0 ? void 0 : $39366f47841f5608$var$_process.REACT_SSR) || false);
function $39366f47841f5608$export$68d57b133e88584d() {
    // SSR environment aren't supported
    if ($39366f47841f5608$var$isReactSSR || $39366f47841f5608$var$isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.WeakRef) !== 'function') return false;
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.MutationObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.IntersectionObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.PerformanceObserver) !== 'function') return false;
    return true;
}

});

parcelRegister("3EIxL", function(module, exports) {
$parcel$export(module.exports, "VCObserverNOOP", () => $2a97a8f4d4c0e82f$export$24d07287b49da906);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");
var $2a97a8f4d4c0e82f$export$24d07287b49da906 = /*#__PURE__*/ function() {
    function VCObserverNOOP() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, VCObserverNOOP);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(VCObserverNOOP, [
        {
            key: "start",
            value: function start(_) {}
        },
        {
            key: "stop",
            value: function stop() {}
        },
        {
            key: "getVCRawData",
            value: function getVCRawData() {
                return null;
            }
        },
        {
            key: "getVCResult",
            value: function getVCResult(_) {
                return Promise.resolve({
                    'ufo:vc:noop': true
                });
            }
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(_) {}
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart(_) {}
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop(_) {}
        }
    ]);
}();

});

parcelRegister("58uSL", function(module, exports) {
$parcel$export(module.exports, "VCObserverWrapper", () => $3bd5a7ac60f86731$export$4a1fe1ab3c13bbf5);

var $fC8ib = parcelRequire("fC8ib");

var $fL8KA = parcelRequire("fL8KA");

var $25nEq = parcelRequire("25nEq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $rHZri = parcelRequire("rHZri");

var $6xLzO = parcelRequire("6xLzO");

var $5kq3l = parcelRequire("5kq3l");

var $1RYQD = parcelRequire("1RYQD");

var $jGnv3 = parcelRequire("jGnv3");
function $3bd5a7ac60f86731$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3bd5a7ac60f86731$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3bd5a7ac60f86731$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3bd5a7ac60f86731$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3bd5a7ac60f86731$export$4a1fe1ab3c13bbf5 = /*#__PURE__*/ function() {
    function VCObserverWrapper() {
        var _opts$ssrEnablePageLa, _opts$ssrEnablePageLa2, _opts$trackLayoutShif;
        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, VCObserverWrapper);
        this.newVCObserver = null;
        this.oldVCObserver = null;
        // Initialize SSR placeholder handler once
        this.ssrPlaceholderHandler = new (0, $jGnv3.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: (_opts$ssrEnablePageLa = opts.ssrEnablePageLayoutPlaceholder) !== null && _opts$ssrEnablePageLa !== void 0 ? _opts$ssrEnablePageLa : false
        });
        this.newVCObserver = new (0, $5kq3l.default)({
            selectorConfig: opts.selectorConfig,
            isPostInteraction: opts.isPostInteraction,
            SSRConfig: {
                enablePageLayoutPlaceholder: (_opts$ssrEnablePageLa2 = opts.ssrEnablePageLayoutPlaceholder) !== null && _opts$ssrEnablePageLa2 !== void 0 ? _opts$ssrEnablePageLa2 : false
            },
            ssrPlaceholderHandler: this.ssrPlaceholderHandler,
            trackLayoutShiftOffenders: (_opts$trackLayoutShif = opts.trackLayoutShiftOffenders) !== null && _opts$trackLayoutShif !== void 0 ? _opts$trackLayoutShif : false,
            searchPageConfig: opts.searchPageConfig
        });
        if ((0, $rHZri.isVCRevisionEnabled)('fy25.01') || (0, $rHZri.isVCRevisionEnabled)('fy25.02')) this.oldVCObserver = new (0, $6xLzO.VCObserver)($3bd5a7ac60f86731$var$_objectSpread($3bd5a7ac60f86731$var$_objectSpread({}, opts), {}, {
            ssrPlaceholderHandler: this.ssrPlaceholderHandler
        }));
    }
    // Helper method to process SSR abort listeners
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(VCObserverWrapper, [
        {
            key: "processSsrAbortListeners",
            value: function processSsrAbortListeners() {
                var _window;
                // Process any SSR abort listeners that remain
                if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
                    // Clean up any event listeners that may have been registered during SSR
                    // This is centralized here so only the wrapper handles unbinding, not individual observers
                    if (window.__SSR_ABORT_LISTENERS__.unbinds && Array.isArray(window.__SSR_ABORT_LISTENERS__.unbinds)) window.__SSR_ABORT_LISTENERS__.unbinds.forEach(function(unbind) {
                        if (typeof unbind === 'function') unbind();
                    });
                    // After all observers had a chance to process abort events,
                    // we can safely delete the SSR_ABORT_LISTENERS object
                    delete window.__SSR_ABORT_LISTENERS__;
                }
            }
        },
        {
            key: "start",
            value: function start(_ref) {
                var _this$newVCObserver;
                var startTime = _ref.startTime, experienceKey = _ref.experienceKey;
                if ((0, $rHZri.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $rHZri.isVCRevisionEnabled)('fy25.02', experienceKey)) {
                    var _this$oldVCObserver;
                    (_this$oldVCObserver = this.oldVCObserver) === null || _this$oldVCObserver === void 0 || _this$oldVCObserver.start({
                        startTime: startTime
                    });
                }
                (_this$newVCObserver = this.newVCObserver) === null || _this$newVCObserver === void 0 || _this$newVCObserver.start({
                    startTime: startTime
                });
                // Clean up any remaining SSR abort listeners after all observers have been started
                this.processSsrAbortListeners();
            }
        },
        {
            key: "stop",
            value: function stop(experienceKey) {
                var _this$newVCObserver2;
                if ((0, $rHZri.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $rHZri.isVCRevisionEnabled)('fy25.02', experienceKey)) {
                    var _this$oldVCObserver2;
                    (_this$oldVCObserver2 = this.oldVCObserver) === null || _this$oldVCObserver2 === void 0 || _this$oldVCObserver2.stop();
                }
                (_this$newVCObserver2 = this.newVCObserver) === null || _this$newVCObserver2 === void 0 || _this$newVCObserver2.stop();
                (0, $1RYQD.RLLPlaceholderHandlers).getInstance().reset();
                // Clear shared SSR placeholder handler
                this.ssrPlaceholderHandler.clear();
            }
        },
        {
            key: "getVCRawData",
            value: function getVCRawData() {
                var _this$oldVCObserver$g, _this$oldVCObserver3;
                return (_this$oldVCObserver$g = (_this$oldVCObserver3 = this.oldVCObserver) === null || _this$oldVCObserver3 === void 0 ? void 0 : _this$oldVCObserver3.getVCRawData()) !== null && _this$oldVCObserver$g !== void 0 ? _this$oldVCObserver$g : null;
            }
        },
        {
            key: "getVCResult",
            value: function() {
                var _getVCResult = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(param) {
                    var _this$oldVCObserver4, _this$newVCObserver3, _v3v4Result$, _ref2;
                    var experienceKey, include3p, excludeSmartAnswersInSearch, includeSSRRatio, includeRawData, v1v2Result, v3v4Result, ssrRatio, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                experienceKey = param.experienceKey, include3p = param.include3p, excludeSmartAnswersInSearch = param.excludeSmartAnswersInSearch, includeSSRRatio = param.includeSSRRatio, includeRawData = param.includeRawData;
                                if (!((0, $rHZri.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $rHZri.isVCRevisionEnabled)('fy25.02', experienceKey))) {
                                    _context.next = 2;
                                    break;
                                }
                                _context.next = 1;
                                return (_this$oldVCObserver4 = this.oldVCObserver) === null || _this$oldVCObserver4 === void 0 ? void 0 : _this$oldVCObserver4.getVCResult(param);
                            case 1:
                                _t = _context.sent;
                                _context.next = 3;
                                break;
                            case 2:
                                _t = {};
                            case 3:
                                v1v2Result = _t;
                                _context.next = 4;
                                return (_this$newVCObserver3 = this.newVCObserver) === null || _this$newVCObserver3 === void 0 ? void 0 : _this$newVCObserver3.getVCResult({
                                    start: param.start,
                                    stop: param.stop,
                                    interactionId: param.interactionId,
                                    ssr: param.ssr,
                                    include3p: include3p,
                                    excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
                                    includeSSRRatio: includeSSRRatio,
                                    interactionType: param.interactionType,
                                    isPageVisible: param.isPageVisible,
                                    interactionAbortReason: param.interactionAbortReason,
                                    includeRawData: includeRawData,
                                    includeSSRInV3: param.includeSSRInV3,
                                    rawDataStopTime: param.rawDataStopTime,
                                    reportLayoutShiftOffenders: param.reportLayoutShiftOffenders
                                });
                            case 4:
                                v3v4Result = _context.sent;
                                if (!(!v3v4Result || v3v4Result.length === 0)) {
                                    _context.next = 5;
                                    break;
                                }
                                return _context.abrupt("return", v1v2Result !== null && v1v2Result !== void 0 ? v1v2Result : {});
                            case 5:
                                ssrRatio = v3v4Result === null || v3v4Result === void 0 || (_v3v4Result$ = v3v4Result[0]) === null || _v3v4Result$ === void 0 ? void 0 : _v3v4Result$.ssrRatio;
                                return _context.abrupt("return", $3bd5a7ac60f86731$var$_objectSpread($3bd5a7ac60f86731$var$_objectSpread($3bd5a7ac60f86731$var$_objectSpread({}, includeSSRRatio && ssrRatio !== undefined ? {
                                    'ufo:vc:ssrRatio': ssrRatio
                                } : {}), v1v2Result), {}, {
                                    'ufo:vc:rev': [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((_ref2 = v1v2Result === null || v1v2Result === void 0 ? void 0 : v1v2Result['ufo:vc:rev']) !== null && _ref2 !== void 0 ? _ref2 : []), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(v3v4Result !== null && v3v4Result !== void 0 ? v3v4Result : []))
                                }));
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getVCResult(_x) {
                    return _getVCResult.apply(this, arguments);
                }
                return getVCResult;
            }()
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {
                var _this$oldVCObserver5, _this$newVCObserver4;
                (_this$oldVCObserver5 = this.oldVCObserver) === null || _this$oldVCObserver5 === void 0 || _this$oldVCObserver5.setSSRElement(element);
                (_this$newVCObserver4 = this.newVCObserver) === null || _this$newVCObserver4 === void 0 || _this$newVCObserver4.setReactRootElement(element);
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart(startTime) {
                var _this$oldVCObserver6, _this$newVCObserver5;
                (_this$oldVCObserver6 = this.oldVCObserver) === null || _this$oldVCObserver6 === void 0 || _this$oldVCObserver6.setReactRootRenderStart(startTime || performance.now());
                (_this$newVCObserver5 = this.newVCObserver) === null || _this$newVCObserver5 === void 0 || _this$newVCObserver5.setReactRootRenderStart(startTime || performance.now());
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop(stopTime) {
                var _this$oldVCObserver7, _this$newVCObserver6;
                (_this$oldVCObserver7 = this.oldVCObserver) === null || _this$oldVCObserver7 === void 0 || _this$oldVCObserver7.setReactRootRenderStop(stopTime || performance.now());
                (_this$newVCObserver6 = this.newVCObserver) === null || _this$newVCObserver6 === void 0 || _this$newVCObserver6.setReactRootRenderStop(stopTime || performance.now());
            }
        },
        {
            key: "collectSSRPlaceholders",
            value: function collectSSRPlaceholders() {
                this.ssrPlaceholderHandler.collectExistingPlaceholders();
            }
        }
    ]);
}();

});
parcelRegister("6xLzO", function(module, exports) {
$parcel$export(module.exports, "VCObserver", () => $013ac0f30250df34$export$1f70d263701b1d01);

var $fC8ib = parcelRequire("fC8ib");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $6HG4S = parcelRequire("6HG4S");

var $50U6m = parcelRequire("50U6m");

var $rHZri = parcelRequire("rHZri");

var $l0l26 = parcelRequire("l0l26");

var $kxqVS = parcelRequire("kxqVS");

var $bRZyj = parcelRequire("bRZyj");

var $lmt4o = parcelRequire("lmt4o");

var $2XIG1 = parcelRequire("2XIG1");

var $4xHLc = parcelRequire("4xHLc");

var $bxwuw = parcelRequire("bxwuw");
var $013ac0f30250df34$var$_excluded = [
    "__debug__element"
];
function $013ac0f30250df34$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $013ac0f30250df34$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $013ac0f30250df34$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $013ac0f30250df34$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $013ac0f30250df34$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
var $013ac0f30250df34$var$UNUSED_SECTOR = 0;
function $013ac0f30250df34$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), timestamp = _ref2[0], entries = _ref2[1];
        return [
            Number(timestamp),
            entries.map(function(entry) {
                var __debug__element = entry.__debug__element, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(entry, $013ac0f30250df34$var$_excluded);
                return rest;
            })
        ];
    }));
}
var $013ac0f30250df34$export$1f70d263701b1d01 = /*#__PURE__*/ function() {
    function VCObserver(options) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, VCObserver);
        /* abort logic */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "abortReason", {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "outOfBoundaryInfo", '');
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "viewport", {
            w: 0,
            h: 0
        });
        /* heatmap */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "arraySize", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "componentsLog", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "vcRatios", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "active", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "totalTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "startTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_startMeasureTimestamp", -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "ssr", {
            reactRendered: -1
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "unbind", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getAbortReasonInfo", function() {
            if (_this.abortReason.reason === null) return null;
            var info = _this.abortReason.info !== '' ? " ".concat(_this.abortReason.info) : '';
            return "".concat(_this.abortReason.reason).concat(info);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getVCRawData", function() {
            _this.measureStart();
            if (!_this.active) {
                _this.measureStop();
                return null;
            }
            _this.stop();
            var abortReasonInfo = _this.getAbortReasonInfo();
            _this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: $013ac0f30250df34$var$_objectSpread({}, _this.abortReason),
                heatmap: _this.heatmap,
                heatmapNext: _this.heatmapNext,
                outOfBoundaryInfo: _this.outOfBoundaryInfo,
                totalTime: Math.round(_this.totalTime + _this.observers.getTotalTime()),
                componentsLog: $013ac0f30250df34$var$_objectSpread({}, _this.componentsLog),
                viewport: $013ac0f30250df34$var$_objectSpread({}, _this.viewport),
                oldDomUpdatesEnabled: _this.oldDomUpdatesEnabled,
                devToolsEnabled: _this.devToolsEnabled,
                ratios: _this.vcRatios
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getVCResult", /*#__PURE__*/ function() {
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_ref3) {
                var start, stop, tti, prefix, ssr, vc, isEventAborted, experienceKey, interactionId, includeSSRRatio, startTime, fullPrefix, rawData, abortReason, abortReasonInfo, heatmap, heatmapNext, outOfBoundaryInfo, totalTime, componentsLog, viewport, devToolsEnabled, ratios, isTTVCv1Disabled, vcAbortedResultWithRevisions, ttvcV1Result, VC, VCBox, VCEntries, totalPainted, _componentsLog, vcNext, outOfBoundary, stopTime, ttvcV1DevToolInfo, ttvcV2DevToolInfo, shouldCreateDebugDetails, v1RevisionDebugDetails, v2RevisionDebugDetails, _window$__ufo_devtool2, _window2, _window$__ufo_devtool, _window, _window$__on_ufo_vc_d2, _window4, _window$__on_ufo_vc_d, _window3, isVCClean, revisionsData, speedIndex, SSRRatio, SSRRatioNext, SSRRatioPayload, isTTVCv3Enabled;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            start = _ref3.start, stop = _ref3.stop, tti = _ref3.tti, prefix = _ref3.prefix, ssr = _ref3.ssr, vc = _ref3.vc, isEventAborted = _ref3.isEventAborted, experienceKey = _ref3.experienceKey, interactionId = _ref3.interactionId, includeSSRRatio = _ref3.includeSSRRatio;
                            startTime = performance.now(); // add local measurement
                            fullPrefix = prefix !== undefined && prefix !== '' ? "".concat(prefix, ":") : '';
                            rawData = vc !== undefined ? vc : _this.getVCRawData();
                            if (!(rawData === null)) {
                                _context.next = 1;
                                break;
                            }
                            return _context.abrupt("return", {});
                        case 1:
                            abortReason = rawData.abortReason, abortReasonInfo = rawData.abortReasonInfo, heatmap = rawData.heatmap, heatmapNext = rawData.heatmapNext, outOfBoundaryInfo = rawData.outOfBoundaryInfo, totalTime = rawData.totalTime, componentsLog = rawData.componentsLog, viewport = rawData.viewport, devToolsEnabled = rawData.devToolsEnabled, ratios = rawData.ratios;
                            isTTVCv1Disabled = !(0, $rHZri.isVCRevisionEnabled)('fy25.01', experienceKey);
                            if (!(abortReasonInfo !== null)) {
                                _context.next = 2;
                                break;
                            }
                            // exposing data to devtools
                            try {
                                if (devToolsEnabled && !_this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                            } catch (_unused) {}
                            vcAbortedResultWithRevisions = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:rev"), [
                                {
                                    revision: 'fy25.02',
                                    clean: false,
                                    'metric:vc90': null,
                                    abortReason: abortReason.reason,
                                    abortTimestamp: Math.round(abortReason.timestamp)
                                }
                            ]);
                            if (!isTTVCv1Disabled) vcAbortedResultWithRevisions["".concat(fullPrefix, "vc:rev")].push({
                                revision: 'fy25.01',
                                clean: false,
                                'metric:vc90': null,
                                abortReason: abortReason.reason,
                                abortTimestamp: Math.round(abortReason.timestamp)
                            });
                            return _context.abrupt("return", vcAbortedResultWithRevisions);
                        case 2:
                            ttvcV1Result = isTTVCv1Disabled ? {
                                VC: {},
                                VCBox: {},
                                VCEntries: {
                                    abs: [],
                                    rel: [],
                                    speedIndex: -1
                                },
                                totalPainted: -1
                            } : VCObserver.calculateVC({
                                heatmap: heatmap,
                                ssr: ssr,
                                componentsLog: $013ac0f30250df34$var$_objectSpread({}, componentsLog),
                                viewport: viewport,
                                fixSSRAttribution: includeSSRRatio
                            });
                            VC = ttvcV1Result.VC, VCBox = ttvcV1Result.VCBox, VCEntries = ttvcV1Result.VCEntries, totalPainted = ttvcV1Result.totalPainted;
                            _componentsLog = {};
                            Object.entries(_this.componentsLog).forEach(function(_ref5) {
                                var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref5, 2), _timestamp = _ref6[0], value = _ref6[1];
                                var timestamp = Number(_timestamp);
                                if (stop > timestamp) _componentsLog[timestamp] = value;
                            });
                            vcNext = VCObserver.calculateVC({
                                heatmap: heatmapNext,
                                ssr: ssr,
                                componentsLog: _componentsLog,
                                viewport: viewport,
                                fixSSRAttribution: includeSSRRatio
                            });
                            outOfBoundary = outOfBoundaryInfo ? (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:oob"), outOfBoundaryInfo) : {}; //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
                            stopTime = performance.now(); // exposing data to devtools
                            try {
                                if (!_this.isPostInteraction && devToolsEnabled) {
                                    ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                                        entries: VCEntries.rel,
                                        log: componentsLog,
                                        metrics: {
                                            '75': VC['75'],
                                            '80': VC['80'],
                                            '85': VC['85'],
                                            '90': VC['90'],
                                            '95': VC['95'],
                                            '98': VC['98'],
                                            '99': VC['99'],
                                            tti: tti,
                                            ttai: stop - start
                                        },
                                        start: start,
                                        stop: stop,
                                        heatmap: heatmap,
                                        ratios: ratios
                                    };
                                    ttvcV2DevToolInfo = {
                                        entries: vcNext.VCEntries.rel,
                                        log: componentsLog,
                                        metrics: {
                                            '75': vcNext.VC['75'],
                                            '80': vcNext.VC['80'],
                                            '85': vcNext.VC['85'],
                                            '90': vcNext.VC['90'],
                                            '95': vcNext.VC['95'],
                                            '98': vcNext.VC['98'],
                                            '99': vcNext.VC['99'],
                                            tti: tti,
                                            ttai: stop - start
                                        },
                                        start: start,
                                        stop: stop,
                                        heatmap: heatmapNext,
                                        ratios: ratios
                                    };
                                    if (isTTVCv1Disabled) {
                                        window.__vc = ttvcV2DevToolInfo;
                                        window.__vcNext = ttvcV2DevToolInfo;
                                    } else {
                                        window.__vc = ttvcV1DevToolInfo;
                                        window.__vcNext = ttvcV2DevToolInfo;
                                    }
                                    // Emitting a custom event to make it available in the Chrome extension
                                    window.dispatchEvent(new CustomEvent('vcReady', {
                                        detail: {
                                            log: $013ac0f30250df34$var$filterComponentsLog(componentsLog),
                                            entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                                        }
                                    }));
                                }
                                if (!_this.isPostInteraction) {
                                    // Only create revision debug details if callbacks exist
                                    shouldCreateDebugDetails = typeof window.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window.__on_ufo_vc_debug_data_ready === 'function';
                                    if (shouldCreateDebugDetails) {
                                        v1RevisionDebugDetails = (0, $bRZyj.getVCRevisionDebugDetails)({
                                            revision: 'fy25.01',
                                            isClean: !abortReasonInfo,
                                            abortReason: abortReason.reason,
                                            VCEntries: VCEntries.rel,
                                            componentsLog: componentsLog,
                                            interactionId: interactionId
                                        });
                                        v2RevisionDebugDetails = (0, $bRZyj.getVCRevisionDebugDetails)({
                                            revision: 'fy25.02',
                                            isClean: !abortReasonInfo,
                                            abortReason: abortReason.reason,
                                            VCEntries: vcNext.VCEntries.rel,
                                            componentsLog: componentsLog,
                                            interactionId: interactionId
                                        }); // Add devtool callback for both v1 and v2
                                        if (typeof window.__ufo_devtool_onVCRevisionReady__ === 'function') {
                                            // Handle v1 if not disabled
                                            if (!isTTVCv1Disabled) (_window$__ufo_devtool = (_window = window).__ufo_devtool_onVCRevisionReady__) === null || _window$__ufo_devtool === void 0 || _window$__ufo_devtool.call(_window, v1RevisionDebugDetails);
                                            // Handle v2
                                            (_window$__ufo_devtool2 = (_window2 = window).__ufo_devtool_onVCRevisionReady__) === null || _window$__ufo_devtool2 === void 0 || _window$__ufo_devtool2.call(_window2, v2RevisionDebugDetails);
                                        }
                                        if (typeof window.__on_ufo_vc_debug_data_ready === 'function') {
                                            if (!isTTVCv1Disabled) (_window$__on_ufo_vc_d = (_window3 = window).__on_ufo_vc_debug_data_ready) === null || _window$__on_ufo_vc_d === void 0 || _window$__on_ufo_vc_d.call(_window3, v1RevisionDebugDetails);
                                            (_window$__on_ufo_vc_d2 = (_window4 = window).__on_ufo_vc_debug_data_ready) === null || _window$__on_ufo_vc_d2 === void 0 || _window$__on_ufo_vc_d2.call(_window4, v2RevisionDebugDetails);
                                        }
                                    }
                                }
                            } catch (_unused2) {
                            /*  do nothing */ }
                            isVCClean = !abortReasonInfo;
                            revisionsData = (0, $lmt4o.getVCRevisionsData)({
                                fullPrefix: fullPrefix,
                                interaction: {
                                    start: start,
                                    end: stop
                                },
                                isVCClean: isVCClean,
                                calculatedVC: {
                                    VC: VC,
                                    VCBox: VCBox
                                },
                                calculatedVCNext: {
                                    VC: vcNext.VC,
                                    VCBox: vcNext.VCBox
                                },
                                isEventAborted: isEventAborted,
                                experienceKey: experienceKey,
                                ratios: ratios
                            });
                            speedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "ufo:speedIndex", isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex), "ufo:next:speedIndex", vcNext.VCEntries.speedIndex);
                            SSRRatio = VCObserver.getSSRRatio(VCEntries.rel, ssr);
                            SSRRatioNext = VCObserver.getSSRRatio(vcNext.VCEntries.rel, ssr);
                            SSRRatioPayload = includeSSRRatio ? (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:ssrRatio"), isTTVCv1Disabled ? SSRRatioNext : SSRRatio), "".concat(fullPrefix, "vc:next:ssrRatio"), SSRRatioNext) : {};
                            if (!isTTVCv1Disabled) {
                                _context.next = 3;
                                break;
                            }
                            return _context.abrupt("return", $013ac0f30250df34$var$_objectSpread($013ac0f30250df34$var$_objectSpread($013ac0f30250df34$var$_objectSpread($013ac0f30250df34$var$_objectSpread((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:size"), viewport), "".concat(fullPrefix, "vc:time"), Math.round(totalTime + (stopTime - startTime))), "".concat(fullPrefix, "vc:ratios"), ratios), outOfBoundary), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:ignored"), _this.getIgnoredElements(componentsLog)), SSRRatioPayload), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:ssrRatio"), SSRRatioNext), revisionsData), speedIndex));
                        case 3:
                            isTTVCv3Enabled = (0, $rHZri.isVCRevisionEnabled)('fy25.03', experienceKey);
                            return _context.abrupt("return", $013ac0f30250df34$var$_objectSpread($013ac0f30250df34$var$_objectSpread($013ac0f30250df34$var$_objectSpread($013ac0f30250df34$var$_objectSpread((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
                                'metrics:vc': VC
                            }, "".concat(fullPrefix, "vc:state"), true), "".concat(fullPrefix, "vc:clean"), isVCClean), "".concat(fullPrefix, "vc:dom"), VCBox), "".concat(fullPrefix, "vc:updates"), isTTVCv3Enabled ? undefined : VCEntries.rel.slice(0, 50)), "".concat(fullPrefix, "vc:size"), viewport), "".concat(fullPrefix, "vc:time"), Math.round(totalTime + (stopTime - startTime))), "".concat(fullPrefix, "vc:total"), totalPainted), "".concat(fullPrefix, "vc:ratios"), ratios), "".concat(fullPrefix, "vc:ssrRatio"), SSRRatio), outOfBoundary), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:next"), vcNext.VC), "".concat(fullPrefix, "vc:next:updates"), isTTVCv3Enabled ? undefined : vcNext.VCEntries.rel.slice(0, 50)), "".concat(fullPrefix, "vc:next:dom"), vcNext.VCBox), SSRRatioPayload), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:ignored"), _this.getIgnoredElements(componentsLog)), revisionsData), speedIndex));
                        case 4:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x) {
                return _ref4.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "handleUpdate", function(rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue) {
            if (_this.abortReason.reason === null || _this.abortReason.blocking === false) {
                var time = Math.round(rawTime - _this.startTime);
                var mappedValues = _this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                _this.vcRatios[targetName] = _this.getElementRatio(mappedValues);
                if (!ignoreReason) _this.applyChangesToHeatMap(mappedValues, time, _this.heatmapNext);
                var interaction = (0, $l0l26.getActiveInteraction)();
                var isTTVCv1Disabled = !(0, $rHZri.isVCRevisionEnabled)('fy25.01', interaction === null || interaction === void 0 ? void 0 : interaction.ufoName);
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') _this.applyChangesToHeatMap(mappedValues, time, _this.heatmap);
                if (!_this.componentsLog[time]) _this.componentsLog[time] = [];
                _this.componentsLog[time].push({
                    __debug__element: _this.devToolsEnabled ? new WeakRef(element) : null,
                    type: type,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "mapPixelsToHeatmap", function(left, top, width, height) {
            var _this$viewport = _this.viewport, w = _this$viewport.w, h = _this$viewport.h;
            var l = Math.floor(left / w * _this.arraySize);
            var t = Math.floor(top / h * _this.arraySize);
            var r = Math.ceil((left + width) / w * _this.arraySize);
            var b = Math.ceil((top + height) / h * _this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (_this.outOfBoundaryInfo === '') {
                var outOfBoundaryInfo = '';
                if (r > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(left, " ").concat(width);
                if (b > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(top, " ").concat(height);
                _this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            var result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(_this.arraySize, r),
                b: Math.min(_this.arraySize, b)
            };
            return result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getElementRatio", function(mappedValues) {
            var r = mappedValues.r, l = mappedValues.l, b = mappedValues.b, t = mappedValues.t;
            return (r - l) * (b - t) / (_this.arraySize * _this.arraySize);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "abortReasonCallback", function(key, time) {
            switch(key){
                case 'wheel':
                    _this.setAbortReason($013ac0f30250df34$var$abortReason.scroll, time);
                    break;
                case 'keydown':
                    // Don't abort press interactions on keydown events, as keydown is expected
                    // when users press Enter/Space to activate buttons or other interactive elements
                    if ((0, $50U6m.fg)('platform_ufo_keypress_interaction_abort')) {
                        var interaction = (0, $l0l26.getActiveInteraction)();
                        if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') break;
                    }
                    _this.setAbortReason($013ac0f30250df34$var$abortReason.keypress, time);
                    break;
                case 'resize':
                    _this.setAbortReason($013ac0f30250df34$var$abortReason.resize, time);
                    break;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "attachAbortListeners", function() {
            var _window5;
            _this.detachAbortListeners();
            var unbinds = (0, $kxqVS.attachAbortListeners)(window, _this.viewport, _this.abortReasonCallback);
            if ((_window5 = window) !== null && _window5 !== void 0 && _window5.__SSR_ABORT_LISTENERS__) Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(function(_ref9) {
                var _ref0 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref9, 2), key = _ref0[0], time = _ref0[1];
                if (time) _this.abortReasonCallback(key, time);
            });
            _this.unbind = unbinds;
        });
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        var ssrEnablePageLayoutPlaceholder = options.ssrEnablePageLayoutPlaceholder, ssrPlaceholderHandler = options.ssrPlaceholderHandler;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It enforces FedRAMP-override > caller-override >
        // centrally configured > caller default. When `getSelectorConfig()`
        // returns `undefined` we fall back to the legacy hard-coded default
        // to preserve pre-existing behaviour for callers that don't pass an
        // explicit `selectorConfig`.
        var LEGACY_DEFAULT_SELECTOR_CONFIG = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.observers = new (0, $bxwuw.Observers)({
            selectorConfig: (0, $rHZri.getSelectorConfig)(options.selectorConfig, LEGACY_DEFAULT_SELECTOR_CONFIG) || options.selectorConfig || LEGACY_DEFAULT_SELECTOR_CONFIG,
            SSRConfig: {
                enablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder || false
            },
            ssrPlaceholderHandler: ssrPlaceholderHandler
        });
        this.heatmap = !(0, $rHZri.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.isPostInteraction = options.isPostInteraction || false;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(VCObserver, [
        {
            key: "start",
            value: function start(_ref1) {
                var startTime = _ref1.startTime;
                this.active = true;
                if (this.observers.isBrowserSupported()) {
                    this.setViewportSize();
                    this.resetState();
                    this.startTime = startTime;
                    this.attachAbortListeners();
                    this.observers.subscribeResults(this.handleUpdate);
                    this.observers.observe();
                } else this.setAbortReason('not-supported', startTime);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.observers.disconnect();
                this.detachAbortListeners();
            }
        },
        {
            key: "getIgnoredElements",
            value: function getIgnoredElements(componentsLog) {
                return Object.values(componentsLog).flat().filter(function(_ref10) {
                    var ignoreReason = _ref10.ignoreReason;
                    return Boolean(ignoreReason);
                }).map(function(_ref11) {
                    var targetName = _ref11.targetName, ignoreReason = _ref11.ignoreReason;
                    return {
                        targetName: targetName,
                        ignoreReason: ignoreReason
                    };
                });
            }
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {
                this.observers.setReactRootElement(element);
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStart(startTime);
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStop(stopTime);
            }
        },
        {
            key: "collectSSRPlaceholders",
            value: function collectSSRPlaceholders() {
            // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
            // Individual observers don't need to implement this
            }
        },
        {
            key: "setAbortReason",
            value: function setAbortReason(abort, timestamp) {
                var info = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
                if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                    this.abortReason.reason = abort;
                    this.abortReason.info = info;
                    this.abortReason.timestamp = timestamp;
                    this.abortReason.blocking = abort !== $013ac0f30250df34$var$abortReason.scroll;
                    if (this.abortReason.blocking) this.detachAbortListeners();
                }
            }
        },
        {
            key: "resetState",
            value: function resetState() {
                this.abortReason = {
                    reason: null,
                    info: '',
                    timestamp: -1,
                    blocking: false
                };
                this.detachAbortListeners();
                this.heatmap = !(0, $rHZri.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
                this.heatmapNext = this.getCleanHeatmap();
                this.totalTime = 0;
                this.componentsLog = {};
                this.vcRatios = {};
            }
        },
        {
            key: "getCleanHeatmap",
            value: function getCleanHeatmap() {
                var _this2 = this;
                return Array(this.arraySize).fill('').map(function() {
                    return Array(_this2.arraySize).fill($013ac0f30250df34$var$UNUSED_SECTOR);
                });
            }
        },
        {
            key: "setViewportSize",
            value: function setViewportSize() {
                this.viewport.w = (0, $4xHLc.getViewportWidth)();
                this.viewport.h = (0, $2XIG1.getViewportHeight)();
            }
        },
        {
            key: "applyChangesToHeatMap",
            value: function applyChangesToHeatMap(a, time, heatmap) {
                var l = a.l, t = a.t, r = a.r, b = a.b;
                var localHeatmap = heatmap;
                for(var row = t; row < b; row++){
                    for(var col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                        try {
                            this.setAbortReason($013ac0f30250df34$var$abortReason.error, time, "index - ".concat(row));
                        } catch (_unused3) {
                            this.setAbortReason($013ac0f30250df34$var$abortReason.error, time, 'row error');
                        }
                        return;
                    } else localHeatmap[row][col] = time;
                }
            }
        },
        {
            key: "detachAbortListeners",
            value: function detachAbortListeners() {
                if (this.unbind) {
                    var unbind = this.unbind;
                    for(var i = 0; i < unbind.length; i++)unbind[i]();
                    this.unbind.length = 0;
                }
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ], [
        {
            key: "getSSRRatio",
            value: function getSSRRatio(entries, ssr) {
                if (ssr === undefined || entries.length === 0) return undefined;
                var maybeSSR = entries[0];
                if (maybeSSR.elements[0] === 'SSR') return maybeSSR.vc;
                return 0;
            }
        },
        {
            key: "calculateVC",
            value: function calculateVC(_ref12) {
                var heatmap = _ref12.heatmap, _ref12$ssr = _ref12.ssr, ssr = _ref12$ssr === void 0 ? $013ac0f30250df34$var$UNUSED_SECTOR : _ref12$ssr, componentsLog = _ref12.componentsLog, viewport = _ref12.viewport, fixSSRAttribution = _ref12.fixSSRAttribution;
                var lastUpdate = {};
                var totalPainted = 0;
                var ssrTime = fixSSRAttribution ? Math.floor(ssr) : ssr;
                if (ssrTime !== $013ac0f30250df34$var$UNUSED_SECTOR) {
                    var _window$document;
                    var element = {
                        __debug__element: new WeakRef((_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.body),
                        intersectionRect: {
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            x: 0,
                            y: 0,
                            width: viewport.w,
                            height: viewport.h,
                            toJSON: function toJSON() {
                                return {};
                            }
                        },
                        targetName: 'SSR'
                    };
                    if (!componentsLog[ssrTime]) componentsLog[ssrTime] = [];
                    componentsLog[ssrTime].push(element);
                }
                heatmap.forEach(function(line) {
                    line.forEach(function(entry) {
                        var rounded = Math.floor(entry === $013ac0f30250df34$var$UNUSED_SECTOR && ssrTime !== $013ac0f30250df34$var$UNUSED_SECTOR ? ssrTime : entry);
                        totalPainted += rounded !== $013ac0f30250df34$var$UNUSED_SECTOR ? 1 : 0;
                        if (rounded !== $013ac0f30250df34$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
                    });
                });
                var entries = Object.entries(lastUpdate).map(function(a) {
                    return [
                        parseInt(a[0], 10),
                        a[1]
                    ];
                }).sort(function(a, b) {
                    return a[0] > b[0] ? 1 : -1;
                });
                var VC = VCObserver.makeVCReturnObj();
                var VCBox = VCObserver.makeVCReturnObj();
                entries.reduce(function() {
                    var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var v = arguments.length > 1 ? arguments[1] : undefined;
                    var currRatio = v[1] / totalPainted;
                    var VCRatio = currRatio + acc;
                    var preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
                    var preciseAccRatio = Math.round(acc * 100);
                    VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
                    var time = v[0];
                    VCObserver.VCParts.forEach(function(key) {
                        var value = parseInt(key, 10);
                        if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                            var _componentsLog$time;
                            VC[key] = time;
                            VCBox[key] = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set((_componentsLog$time = componentsLog[time]) === null || _componentsLog$time === void 0 ? void 0 : _componentsLog$time.filter(function(v) {
                                return !v.ignoreReason;
                            }).map(function(v) {
                                return v.targetName;
                            })));
                        }
                    });
                    return VCRatio;
                }, 0);
                var VCEntries = entries.reduce(function(acc, _ref13, i) {
                    var _acc$abs, _componentsLog$timest, _acc$rel$vc, _acc$rel;
                    var _ref14 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref13, 2), timestamp = _ref14[0], entryPainted = _ref14[1];
                    var currentlyPainted = entryPainted + (((_acc$abs = acc.abs[i - 1]) === null || _acc$abs === void 0 ? void 0 : _acc$abs[1]) || 0);
                    var currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
                    var logEntry = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set((_componentsLog$timest = componentsLog[timestamp]) === null || _componentsLog$timest === void 0 ? void 0 : _componentsLog$timest.filter(function(v) {
                        return !v.ignoreReason;
                    }).map(function(v) {
                        return v.targetName;
                    })));
                    var ratioDelta = (currentlyPaintedRatio - ((_acc$rel$vc = (_acc$rel = acc.rel[i - 1]) === null || _acc$rel === void 0 ? void 0 : _acc$rel.vc) !== null && _acc$rel$vc !== void 0 ? _acc$rel$vc : 0)) / 100;
                    var speedIndex = timestamp * ratioDelta;
                    acc.speedIndex += speedIndex;
                    acc.abs.push([
                        timestamp,
                        currentlyPainted
                    ]);
                    acc.rel.push({
                        time: timestamp,
                        vc: currentlyPaintedRatio,
                        elements: logEntry
                    });
                    return acc;
                }, {
                    abs: [],
                    rel: [],
                    speedIndex: 0
                });
                VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
                return {
                    VC: VC,
                    VCBox: VCBox,
                    VCEntries: VCEntries,
                    totalPainted: totalPainted
                };
            }
        },
        {
            key: "makeVCReturnObj",
            value: function makeVCReturnObj() {
                var vc = {};
                VCObserver.VCParts.forEach(function(v) {
                    vc[v] = null;
                });
                return vc;
            }
        }
    ]);
}();
/** config * */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($013ac0f30250df34$export$1f70d263701b1d01, "VCParts", [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
]);

});
parcelRegister("kxqVS", function(module, exports) {
$parcel$export(module.exports, "attachAbortListeners", () => $ef3bc7ecc0841304$export$9010aa71841a6887);

var $7QpUe = parcelRequire("7QpUe");

var $9eT1F = parcelRequire("9eT1F");

var $2XIG1 = parcelRequire("2XIG1");

var $4xHLc = parcelRequire("4xHLc");
function $ef3bc7ecc0841304$export$9010aa71841a6887(window, initialViewPort, callback) {
    var unbindWheel = (0, $7QpUe.bind)(window, {
        type: (0, $9eT1F.AbortEvent).wheel,
        listener: function listener(e) {
            callback((0, $9eT1F.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    var unbindKeydown = (0, $7QpUe.bind)(window, {
        type: (0, $9eT1F.AbortEvent).keydown,
        listener: function listener(e) {
            callback((0, $9eT1F.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    var unbindResize = (0, $7QpUe.bind)(window, {
        type: (0, $9eT1F.AbortEvent).resize,
        listener: function listener(e) {
            if ((0, $4xHLc.getViewportWidth)() !== initialViewPort.w || (0, $2XIG1.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $9eT1F.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}

});
parcelRegister("9eT1F", function(module, exports) {
$parcel$export(module.exports, "AbortEvent", () => $6ba01ad880612318$export$199edc0307b5587f);
var $6ba01ad880612318$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};

});

parcelRegister("2XIG1", function(module, exports) {
$parcel$export(module.exports, "getViewportHeight", () => $2283bf50754fc59e$export$4f01c15d21ef9cc6);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $2283bf50754fc59e$export$4f01c15d21ef9cc6() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (_unused) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

});

parcelRegister("4xHLc", function(module, exports) {
$parcel$export(module.exports, "getViewportWidth", () => $34ec30592a6b51a0$export$a497a1dcb4408212);
function $34ec30592a6b51a0$export$a497a1dcb4408212() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (_unused) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}

});


parcelRegister("bRZyj", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionDebugDetails", () => $8a4464003b7a0677$export$72e6dda9d5859230);

var $iYJcE = parcelRequire("iYJcE");

var $fC8ib = parcelRequire("fC8ib");
function $8a4464003b7a0677$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $8a4464003b7a0677$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $8a4464003b7a0677$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $8a4464003b7a0677$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $8a4464003b7a0677$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $8a4464003b7a0677$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $8a4464003b7a0677$export$72e6dda9d5859230(_ref) {
    var revision = _ref.revision, isClean = _ref.isClean, abortReason = _ref.abortReason, VCEntries = _ref.VCEntries, componentsLog = _ref.componentsLog, interactionId = _ref.interactionId;
    // Pre-sort VCEntries by time for efficient lookups
    var sortedVCEntries = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(VCEntries).sort(function(a, b) {
        return a.time - b.time;
    });
    // Pre-calculate max viewport percentage up to each time for efficient lookups
    var maxViewportPercentageAtTime = new Map();
    var maxSoFar = 0;
    var _iterator = $8a4464003b7a0677$var$_createForOfIteratorHelper(sortedVCEntries), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var entry = _step.value;
            maxSoFar = Math.max(maxSoFar, entry.vc);
            maxViewportPercentageAtTime.set(entry.time, maxSoFar);
        }
    // Helper function to find the biggest previous viewport percentage
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var getBiggestPreviousViewportPercentage = function getBiggestPreviousViewportPercentage(targetTime) {
        // Binary search for the largest time <= targetTime
        var left = 0;
        var right = sortedVCEntries.length - 1;
        var result = -1;
        while(left <= right){
            var mid = Math.floor((left + right) / 2);
            if (sortedVCEntries[mid].time <= targetTime) {
                result = mid;
                left = mid + 1;
            } else right = mid - 1;
        }
        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVCEntries[result].time) || null : null;
    };
    var allVcLogs = [];
    // Add regular VC entries
    var _iterator2 = $8a4464003b7a0677$var$_createForOfIteratorHelper(VCEntries), _step2;
    try {
        var _loop = function _loop() {
            var entry = _step2.value;
            var timeLogEntries = componentsLog[entry.time];
            allVcLogs.push({
                time: entry.time,
                viewportPercentage: entry.vc,
                entries: entry.elements.map(function(element) {
                    var logEntry = timeLogEntries === null || timeLogEntries === void 0 ? void 0 : timeLogEntries.find(function(log) {
                        return log.targetName === element;
                    });
                    return {
                        elementName: element,
                        type: logEntry === null || logEntry === void 0 ? void 0 : logEntry.type,
                        rect: logEntry === null || logEntry === void 0 ? void 0 : logEntry.intersectionRect,
                        visible: true,
                        attributeName: logEntry === null || logEntry === void 0 ? void 0 : logEntry.attributeName,
                        oldValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.oldValue,
                        newValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.newValue,
                        ignoreReason: logEntry === null || logEntry === void 0 ? void 0 : logEntry.ignoreReason
                    };
                })
            });
        };
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;)_loop();
    // Add ignored elements - only process timestamps that have ignored elements
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    for(var _i = 0, _Object$entries = Object.entries(componentsLog); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i], 2), timestamp = _Object$entries$_i[0], timeLogEntries = _Object$entries$_i[1];
        var ignoredElements = timeLogEntries.filter(function(log) {
            return log.ignoreReason;
        });
        if (ignoredElements.length === 0) continue;
        var time = Number(timestamp);
        var viewportPercentage = getBiggestPreviousViewportPercentage(time);
        allVcLogs.push({
            time: time,
            viewportPercentage: viewportPercentage,
            entries: ignoredElements.map(function(logEntry) {
                return {
                    elementName: logEntry.targetName,
                    type: logEntry.type,
                    rect: logEntry.intersectionRect,
                    visible: false,
                    attributeName: logEntry.attributeName,
                    oldValue: logEntry.oldValue,
                    newValue: logEntry.newValue,
                    ignoreReason: logEntry.ignoreReason
                };
            })
        });
    }
    // Sort once at the end
    allVcLogs.sort(function(a, b) {
        return a.time - b.time;
    });
    return {
        revision: revision,
        isClean: isClean,
        abortReason: abortReason,
        vcLogs: allVcLogs,
        interactionId: interactionId
    };
}

});

parcelRegister("lmt4o", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionsData", () => $f8d233bc505877b6$export$5c86a34c9becd6d0);

var $25nEq = parcelRequire("25nEq");

var $rHZri = parcelRequire("rHZri");

var $9DHn2 = parcelRequire("9DHn2");
function $f8d233bc505877b6$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $f8d233bc505877b6$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $f8d233bc505877b6$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f8d233bc505877b6$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f8d233bc505877b6$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $f8d233bc505877b6$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $f8d233bc505877b6$var$VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
var $f8d233bc505877b6$var$READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
function $f8d233bc505877b6$var$createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    var details = {};
    var VC = calculatedVC.VC, VCBox = calculatedVC.VCBox; // Destructure once to avoid repeated property access
    var _iterator = $f8d233bc505877b6$var$_createForOfIteratorHelper($f8d233bc505877b6$var$VCParts), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            details[key] = {
                t: VC[key] || -1,
                e: VCBox[key] || $f8d233bc505877b6$var$READONLY_EMPTY_ARRAY
            };
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return details;
}
function $f8d233bc505877b6$export$5c86a34c9becd6d0(_ref) {
    var fullPrefix = _ref.fullPrefix, interaction = _ref.interaction, isVCClean = _ref.isVCClean, isEventAborted = _ref.isEventAborted, calculatedVC = _ref.calculatedVC, calculatedVCNext = _ref.calculatedVCNext, experienceKey = _ref.experienceKey, ratios = _ref.ratios;
    var pageVisibilityUpToTTAI = (0, $9DHn2.getPageVisibilityState)(interaction.start, interaction.end);
    var isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    var shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    var availableVCRevisionPayloads = [];
    if ((0, $rHZri.isVCRevisionEnabled)('fy25.01', experienceKey)) {
        var revision = {
            revision: 'fy25.01',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
            vcDetails: $f8d233bc505877b6$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    if ((0, $rHZri.isVCRevisionEnabled)('fy25.02', experienceKey)) {
        var _revision = {
            revision: 'fy25.02',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
            vcDetails: $f8d233bc505877b6$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) _revision.ratios = ratios;
        availableVCRevisionPayloads.push(_revision);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:rev"), availableVCRevisionPayloads);
}

});
parcelRegister("9DHn2", function(module, exports) {
$parcel$export(module.exports, "getEarliestHiddenTiming", () => $70496612669769d8$export$754443ce7c615bd7);
$parcel$export(module.exports, "getPageVisibilityState", () => $70496612669769d8$export$768b2008623433e1);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $7QpUe = parcelRequire("7QpUe");

var $50U6m = parcelRequire("50U6m");
var $70496612669769d8$var$timings = [];
var $70496612669769d8$var$wasHiddenFlag;
var $70496612669769d8$var$setupFlag = false;
// Threshold for determining if page was opened in background.
// If setup runs within this time and page is hidden, we assume it was opened in a background tab.
var $70496612669769d8$var$OPENED_IN_BACKGROUND_THRESHOLD_MS = 100;
var $70496612669769d8$var$openedInBackground = null;
function $70496612669769d8$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
var $70496612669769d8$var$SIZE = 50;
var $70496612669769d8$var$insertIndex = 0;
function $70496612669769d8$export$754443ce7c615bd7(startTime, endTime) {
    var _timings$find;
    var earliestHiddenTiming = (_timings$find = $70496612669769d8$var$timings.find(function(_ref) {
        var hidden = _ref.hidden, time = _ref.time;
        return hidden && time > 0 && time >= startTime && time <= endTime;
    })) === null || _timings$find === void 0 ? void 0 : _timings$find.time;
    if (typeof earliestHiddenTiming === 'number') return Math.round(earliestHiddenTiming - startTime);
}
function $70496612669769d8$export$21a1a62a307062f1(interactionType) {
    if (interactionType !== 'page_load') return false;
    // Check native visibility-state entries first (most reliable, Chromium only)
    try {
        var entries = performance.getEntriesByType('visibility-state');
        if (entries.length > 0) return entries.some(function(entry) {
            return entry.name === 'hidden' && entry.startTime <= $70496612669769d8$var$OPENED_IN_BACKGROUND_THRESHOLD_MS;
        });
    } catch (_unused) {
    // visibility-state not supported (Firefox/Safari)
    }
    // Fallback to cached value from setup (determined using time threshold)
    return $70496612669769d8$var$openedInBackground === true;
}
function $70496612669769d8$var$pushHidden(isPageHiddenFlag, time) {
    $70496612669769d8$var$timings[$70496612669769d8$var$insertIndex] = {
        time: time !== null && time !== void 0 ? time : performance.now(),
        hidden: isPageHiddenFlag
    };
    $70496612669769d8$var$insertIndex = ($70496612669769d8$var$insertIndex + 1) % $70496612669769d8$var$SIZE;
    $70496612669769d8$var$wasHiddenFlag = isPageHiddenFlag;
}
function $70496612669769d8$var$handleChange() {
    var isPageHiddenFlag = $70496612669769d8$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$70496612669769d8$var$wasHiddenFlag) $70496612669769d8$var$pushHidden(isPageHiddenFlag);
        $70496612669769d8$var$wasHiddenFlag = true;
    } else {
        if ($70496612669769d8$var$wasHiddenFlag) $70496612669769d8$var$pushHidden(isPageHiddenFlag);
        $70496612669769d8$var$wasHiddenFlag = false;
    }
}
var $70496612669769d8$var$hasHiddenTimingBeforeSetup = false;
function $70496612669769d8$export$95f048bd8bcdda23() {
    return $70496612669769d8$var$hasHiddenTimingBeforeSetup;
}
function $70496612669769d8$var$setup() {
    try {
        var results = performance.getEntriesByType('visibility-state');
        results === null || results === void 0 || results.forEach(function(result) {
            if ((0, $50U6m.fg)('platform_ufo_use_native_page_visibility_api')) $70496612669769d8$var$pushHidden(result.name === 'hidden', result.startTime);
            if (result.name === 'hidden') $70496612669769d8$var$hasHiddenTimingBeforeSetup = true;
        });
    } catch (_unused2) {
    /* do nothing */ /* note: visibility-state entry types are not available in Firefox/Safari: https://developer.mozilla.org/en-US/docs/Web/API/VisibilityStateEntry#browser_compatibility */ }
    (0, $7QpUe.bind)(window, {
        type: 'pageshow',
        listener: $70496612669769d8$var$handleChange
    });
    (0, $7QpUe.bind)(window, {
        type: 'pagehide',
        listener: $70496612669769d8$var$handleChange
    });
    (0, $7QpUe.bind)(document, {
        type: 'visibilitychange',
        listener: $70496612669769d8$var$handleChange
    });
}
function $70496612669769d8$export$554cefe0f0373da4() {
    if (!$70496612669769d8$var$setupFlag) {
        var isPageHiddenFlag = $70496612669769d8$var$isPageHidden();
        var setupTime = performance.now();
        // Determine if page was opened in background.
        // If we're early in page lifecycle (< threshold) and page is hidden,
        // it's likely the page was opened in a background tab.
        if ($70496612669769d8$var$openedInBackground === null) $70496612669769d8$var$openedInBackground = isPageHiddenFlag && setupTime < $70496612669769d8$var$OPENED_IN_BACKGROUND_THRESHOLD_MS;
        $70496612669769d8$var$pushHidden(isPageHiddenFlag, 0);
        $70496612669769d8$var$setup();
        $70496612669769d8$var$setupFlag = true;
    }
}
function $70496612669769d8$export$768b2008623433e1(start, end) {
    // Input validation - return default for invalid inputs
    if (!Number.isFinite(start) || !Number.isFinite(end)) return 'visible';
    // Desirable default value is visible
    if ($70496612669769d8$var$timings.length === 0) return 'visible';
    var currentSize = $70496612669769d8$var$timings.length;
    var hiddenState = 'mixed';
    var startIdx = $70496612669769d8$var$insertIndex;
    var endIdx = $70496612669769d8$var$insertIndex;
    // currentSize is capped at SIZE.
    for(var i = 0; i < currentSize; i++){
        var tmpIdx = ($70496612669769d8$var$insertIndex + i) % currentSize;
        // Add bounds checking before accessing array element
        if ($70496612669769d8$var$timings[tmpIdx] && $70496612669769d8$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($70496612669769d8$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    // Add bounds checking before accessing timings array
    if (endIdx - startIdx === 0 && $70496612669769d8$var$timings[startIdx]) hiddenState = $70496612669769d8$var$timings[startIdx].hidden ? 'hidden' : 'visible';
    return hiddenState;
}
// Throttle detection configuration
// Expected interval for timer checks (in milliseconds)
var $70496612669769d8$var$THROTTLE_CHECK_INTERVAL_MS = 1000;
// Threshold for considering a timer as throttled (50% drift tolerance)
var $70496612669769d8$var$THROTTLE_DRIFT_THRESHOLD = 1.5;
// Maximum number of throttle measurements to store (circular buffer)
var $70496612669769d8$var$THROTTLE_BUFFER_SIZE = 120;
// Circular buffer to store throttle measurements
var $70496612669769d8$var$throttleMeasurements = [];
var $70496612669769d8$var$throttleInsertIndex = 0;
var $70496612669769d8$var$throttleIntervalId = null;
var $70496612669769d8$var$lastThrottleCheckTime = null;
var $70496612669769d8$var$throttleSetupDone = false;
function $70496612669769d8$var$recordThrottleMeasurement(expectedElapsed, actualElapsed) {
    var isThrottled = actualElapsed > expectedElapsed * $70496612669769d8$var$THROTTLE_DRIFT_THRESHOLD;
    $70496612669769d8$var$throttleMeasurements[$70496612669769d8$var$throttleInsertIndex] = {
        time: performance.now(),
        expectedElapsed: expectedElapsed,
        actualElapsed: actualElapsed,
        isThrottled: isThrottled
    };
    $70496612669769d8$var$throttleInsertIndex = ($70496612669769d8$var$throttleInsertIndex + 1) % $70496612669769d8$var$THROTTLE_BUFFER_SIZE;
}
function $70496612669769d8$var$throttleCheckCallback() {
    var currentTime = performance.now();
    if ($70496612669769d8$var$lastThrottleCheckTime !== null) {
        var actualElapsed = currentTime - $70496612669769d8$var$lastThrottleCheckTime;
        $70496612669769d8$var$recordThrottleMeasurement($70496612669769d8$var$THROTTLE_CHECK_INTERVAL_MS, actualElapsed);
    }
    $70496612669769d8$var$lastThrottleCheckTime = currentTime;
}
function $70496612669769d8$export$fa0d29a9c87052da() {
    if ($70496612669769d8$var$throttleSetupDone) return;
    $70496612669769d8$var$throttleSetupDone = true;
    // Record the initial timestamp
    $70496612669769d8$var$lastThrottleCheckTime = performance.now();
    // Start the periodic timer for throttle detection
    $70496612669769d8$var$throttleIntervalId = setInterval($70496612669769d8$var$throttleCheckCallback, $70496612669769d8$var$THROTTLE_CHECK_INTERVAL_MS);
}
function $70496612669769d8$export$3279694d66e4a1() {
    if ($70496612669769d8$var$throttleIntervalId !== null) {
        clearInterval($70496612669769d8$var$throttleIntervalId);
        $70496612669769d8$var$throttleIntervalId = null;
    }
    $70496612669769d8$var$lastThrottleCheckTime = null;
    $70496612669769d8$var$throttleSetupDone = false;
    $70496612669769d8$var$throttleMeasurements.length = 0;
    $70496612669769d8$var$throttleInsertIndex = 0;
}
function $70496612669769d8$export$62a28c860277b3bf(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return false;
    // No measurements available
    if ($70496612669769d8$var$throttleMeasurements.length === 0) return false;
    // Check if any measurement within the time window indicates throttling
    for(var i = 0; i < $70496612669769d8$var$throttleMeasurements.length; i++){
        var measurement = $70496612669769d8$var$throttleMeasurements[i];
        if (measurement && measurement.time >= startTime && measurement.time <= endTime && measurement.isThrottled) return true;
    }
    return false;
}
function $70496612669769d8$export$77aaa9b1ce57d9bc(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    return $70496612669769d8$var$throttleMeasurements.filter(function(measurement) {
        return measurement && measurement.time >= startTime && measurement.time <= endTime;
    });
}
function $70496612669769d8$export$9332de935653b687(measurement) {
    $70496612669769d8$var$throttleMeasurements[$70496612669769d8$var$throttleInsertIndex] = measurement;
    $70496612669769d8$var$throttleInsertIndex = ($70496612669769d8$var$throttleInsertIndex + 1) % $70496612669769d8$var$THROTTLE_BUFFER_SIZE;
}
function $70496612669769d8$export$5a06b84e47ad70d9(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    if ($70496612669769d8$var$timings.length === 0) return [];
    var result = [];
    // Find the most recent entry at or before startTime to establish initial state
    var initialEntry;
    var currentSize = $70496612669769d8$var$timings.length;
    for(var i = 0; i < currentSize; i++){
        var idx = ($70496612669769d8$var$insertIndex + i) % currentSize;
        var entry = $70496612669769d8$var$timings[idx];
        if (entry && entry.time <= startTime) initialEntry = entry;
    }
    // Add the initial visibility state at the start of the window
    if (initialEntry) result.push({
        time: 0,
        hidden: initialEntry.hidden
    });
    // Add all entries within the time window
    for(var _i = 0; _i < currentSize; _i++){
        var _idx = ($70496612669769d8$var$insertIndex + _i) % currentSize;
        var _entry = $70496612669769d8$var$timings[_idx];
        if (_entry && _entry.time > startTime && _entry.time <= endTime) result.push({
            time: Math.round(_entry.time - startTime),
            hidden: _entry.hidden
        });
    }
    return result;
}
// Expose testing API on window for integration tests
if (typeof window !== 'undefined') window.__reactUfoHiddenTiming = {
    __injectThrottleMeasurementForTesting: $70496612669769d8$export$9332de935653b687
};

});


parcelRegister("bxwuw", function(module, exports) {
$parcel$export(module.exports, "Observers", () => $866bfae48c8cfe8a$export$b65d046240060e78);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $rHZri = parcelRequire("rHZri");

var $buzIJ = parcelRequire("buzIJ");

var $2Dn2q = parcelRequire("2Dn2q");

var $1RYQD = parcelRequire("1RYQD");

var $jGnv3 = parcelRequire("jGnv3");
function $866bfae48c8cfe8a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $866bfae48c8cfe8a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $866bfae48c8cfe8a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $866bfae48c8cfe8a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $866bfae48c8cfe8a$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function $866bfae48c8cfe8a$var$isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    var isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
var $866bfae48c8cfe8a$export$b65d046240060e78 = /*#__PURE__*/ function() {
    function Observers(opts) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Observers);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "observedMutations", new WeakMap());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "elementsInView", new Set());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "callbacks", new Set());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "totalTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_startMeasureTimestamp", -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "ssr", {
            state: $866bfae48c8cfe8a$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "selectorConfig", {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscribeResults", function(cb) {
            _this.callbacks.add(cb);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "observeElement", function(node, mutation, type, ignoreReason, attributeName) {
            var _this$intersectionObs;
            var oldValue = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
            var newValue = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.observe(node);
            _this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        });
        // Selector-config resolution is centralised in `getSelectorConfig()`.
        // It enforces FedRAMP-override > caller-override > centrally
        // configured > caller default.
        var resolved = (0, $rHZri.getSelectorConfig)(opts.selectorConfig, this.selectorConfig);
        this.selectorConfig = resolved !== null && resolved !== void 0 ? resolved : $866bfae48c8cfe8a$var$_objectSpread($866bfae48c8cfe8a$var$_objectSpread({}, this.selectorConfig), opts.selectorConfig);
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        // Use shared SSR placeholder handler if provided, otherwise create new one
        if (opts.ssrPlaceholderHandler) this.ssrPlaceholderHandler = opts.ssrPlaceholderHandler;
        else {
            var _opts$SSRConfig;
            this.ssrPlaceholderHandler = new (0, $jGnv3.SSRPlaceholderHandlers)({
                enablePageLayoutPlaceholder: (_opts$SSRConfig = opts.SSRConfig) === null || _opts$SSRConfig === void 0 ? void 0 : _opts$SSRConfig.enablePageLayoutPlaceholder
            });
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Observers, [
        {
            key: "isBrowserSupported",
            value: function isBrowserSupported() {
                return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
            }
        },
        {
            key: "observe",
            value: function observe() {
                var _this$mutationObserve;
                this.totalTime = 0;
                this.ssr = {
                    state: $866bfae48c8cfe8a$var$state.normal,
                    reactRootElement: null,
                    renderStart: -1,
                    renderStop: -1
                };
                (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
                    attributeFilter: [
                        'hidden',
                        'style',
                        'src',
                        'class'
                    ],
                    attributeOldValue: true,
                    attributes: true,
                    childList: true,
                    subtree: true
                });
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this$mutationObserve2, _this$intersectionObs2;
                (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
                (_this$intersectionObs2 = this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.disconnect();
                this.observedMutations = new WeakMap();
                this.elementsInView.clear();
                this.callbacks.clear();
                this.ssr.reactRootElement = null;
                this.ssrPlaceholderHandler.clear();
            }
        },
        {
            key: "getTotalTime",
            value: function getTotalTime() {
                return this.totalTime;
            }
        },
        {
            key: "setReactRootElement",
            value: function setReactRootElement(element) {
                this.ssr.reactRootElement = element;
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStart = startTime;
                this.ssr.state = $866bfae48c8cfe8a$var$state.waitingForFirstRender;
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStop = stopTime;
            }
        },
        {
            key: "getMutationObserver",
            value: function getMutationObserver() {
                var _this2 = this;
                if (!this.isBrowserSupported()) return null;
                return new MutationObserver(function(mutations) {
                    _this2.measureStart();
                    mutations.forEach(function(mutation) {
                        // patching element if timestamp not automatically added
                        // eslint-disable-next-line no-param-reassign
                        mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                        var ignoreReason = '';
                        if (_this2.ssr.state === $866bfae48c8cfe8a$var$state.waitingForFirstRender && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            _this2.ssr.state = $866bfae48c8cfe8a$var$state.ignoring;
                            if (_this2.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                            _this2.ssr.renderStop = mutation.timestamp + 500;
                            ignoreReason = 'ssr-hydration';
                        }
                        if (_this2.ssr.state === $866bfae48c8cfe8a$var$state.ignoring && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            if (mutation.timestamp <= _this2.ssr.renderStop) ignoreReason = 'ssr-hydration';
                            else _this2.ssr.state = $866bfae48c8cfe8a$var$state.normal;
                        }
                        if (mutation.type === 'childList') {
                            mutation.addedNodes.forEach(function(node) {
                                if ((0, $buzIJ.isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                                if (node instanceof HTMLElement) {
                                    if (_this2.ssrPlaceholderHandler.isPlaceholder(node) || _this2.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                        _this2.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, 'html', ignoreReason);
                                        });
                                        return;
                                    }
                                    if (_this2.ssrPlaceholderHandler.isPlaceholderReplacement(node) || _this2.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                        _this2.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, 'html', ignoreReason);
                                        });
                                        return;
                                    }
                                    _this2.observeElement(node, mutation, 'html', ignoreReason);
                                }
                                if (node instanceof Text && node.parentElement != null) _this2.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                            });
                            mutation.removedNodes.forEach(function(node) {
                                if (node instanceof Element) {
                                    var _this2$intersectionOb;
                                    _this2.elementsInView.delete(node);
                                    (_this2$intersectionOb = _this2.intersectionObserver) === null || _this2$intersectionOb === void 0 || _this2$intersectionOb.unobserve(node);
                                }
                            });
                        } else if (mutation.type === 'attributes') {
                            if (mutation.target instanceof HTMLElement) {
                                var _mutation$oldValue;
                                var attributeName = mutation.attributeName;
                                /*
              	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
              	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
              	Conceptually there is after all a mutation: there is an old value replaced with a new one,
              	and whether or not they are the same doesn't really matter.
              	And Custom elements should work the same way as MutationObserver."
              	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
              */ var oldValue = (_mutation$oldValue = mutation.oldValue) !== null && _mutation$oldValue !== void 0 ? _mutation$oldValue : undefined;
                                var newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                                if (oldValue !== newValue) {
                                    if ((0, $2Dn2q.default)(mutation)) ignoreReason = 'non-visual-style';
                                    if ((0, $buzIJ.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = 'image';
                                    _this2.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                                }
                            }
                        }
                    });
                });
            }
        },
        {
            key: "getElementName",
            value: function getElementName(element) {
                try {
                    var tagName = element.localName;
                    var dataVCAttr = element.getAttribute('data-vc');
                    var dataVC = this.selectorConfig.dataVC && dataVCAttr ? "[data-vc=\"".concat(dataVCAttr, "\"]") : '';
                    var id = this.selectorConfig.id && element.id ? "#".concat(element.id) : '';
                    var testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
                    testId = testId ? "[testid=".concat(testId, "]") : '';
                    var role = this.selectorConfig.role ? element.getAttribute('role') : '';
                    role = role ? "[role=".concat(role, "]") : '';
                    var classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
                    classList = classList === '' ? '' : ".".concat(classList);
                    var attrs = dataVC ? dataVC : [
                        id,
                        testId,
                        role
                    ].join('');
                    var idString = '';
                    if (attrs === '' && classList === '') {
                        var parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                        idString = "".concat(parent, " > ").concat(tagName);
                    } else idString = [
                        tagName,
                        attrs || classList
                    ].join('');
                    return idString;
                } catch (_unused) {
                    return 'error';
                }
            }
        },
        {
            key: "getIntersectionObserver",
            value: function getIntersectionObserver() {
                var _this3 = this;
                if (!this.isBrowserSupported()) return null;
                return new IntersectionObserver(function(entries) {
                    _this3.measureStart();
                    entries.forEach(function(_ref) {
                        var isIntersecting = _ref.isIntersecting, ir = _ref.intersectionRect, target = _ref.target;
                        var data = _this3.observedMutations.get(target);
                        _this3.observedMutations.delete(target);
                        if (isIntersecting && ir.width > 0 && ir.height > 0) {
                            if (!(target instanceof HTMLElement)) return;
                            if (!(data !== null && data !== void 0 && data.mutation)) // ignore intersection report without recent mutation
                            return;
                            if (!$866bfae48c8cfe8a$var$isElementVisible(target)) data.ignoreReason = 'not-visible';
                            if ((0, $1RYQD.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(ir)) data.ignoreReason = 'rll-placeholder';
                            _this3.callbacks.forEach(function(callback) {
                                var elementName;
                                try {
                                    elementName = _this3.getElementName(target);
                                } catch (_unused2) {
                                    elementName = 'error';
                                }
                                callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                            });
                            _this3.elementsInView.add(target);
                        } else _this3.elementsInView.delete(target);
                    });
                    _this3.measureStop();
                });
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ]);
}();

});
parcelRegister("buzIJ", function(module, exports) {
$parcel$export(module.exports, "isContainedWithinMediaWrapper", () => $85de346108a52c5d$export$f61fbc3b9c4a9019);

var $L3ELk = parcelRequire("L3ELk");
function $85de346108a52c5d$export$f61fbc3b9c4a9019(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $L3ELk.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
}

});
parcelRegister("L3ELk", function(module, exports) {
$parcel$export(module.exports, "MEDIA_WRAPPER_TAG", () => $08d739ff599f3f70$export$7674290405cc25b0);
$parcel$export(module.exports, "VcMediaWrapperProps", () => $08d739ff599f3f70$export$7028e9efe569888c);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");
var $08d739ff599f3f70$export$7674290405cc25b0 = 'data-media-vc-wrapper';
var $08d739ff599f3f70$export$7028e9efe569888c = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $08d739ff599f3f70$export$7674290405cc25b0, true);
function $08d739ff599f3f70$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", $08d739ff599f3f70$export$7028e9efe569888c, children);
}

});


parcelRegister("2Dn2q", function(module, exports) {
$parcel$export(module.exports, "default", () => $1eb1182bc4f85f58$export$2e2bcd8739ae039);
/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ function $1eb1182bc4f85f58$var$isNonVisualStyleMutation(_ref) {
    var target = _ref.target, attributeName = _ref.attributeName;
    if (!(target instanceof Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}
var $1eb1182bc4f85f58$export$2e2bcd8739ae039 = $1eb1182bc4f85f58$var$isNonVisualStyleMutation;

});

parcelRegister("1RYQD", function(module, exports) {
$parcel$export(module.exports, "RLLPlaceholderHandlers", () => $15c9f0d27b41f931$export$166779fc0f49d4df);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
var $15c9f0d27b41f931$var$GLOBAL_RLL_HANDLERS_KEY = '__REACT_UFO_RLL_PLACEHOLDER_HANDLERS__';
var $15c9f0d27b41f931$export$166779fc0f49d4df = /*#__PURE__*/ function() {
    function RLLPlaceholderHandlers() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, RLLPlaceholderHandlers);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "placeholders", []);
        if (typeof window !== 'undefined' && typeof document !== 'undefined' && typeof window.document !== 'undefined') this.collectRLLPlaceholders();
    }
    /**
   * Gets the global singleton instance of RLLPlaceholderHandlers.
   * Creates the instance if it doesn't exist and stores it in globalThis.
   * @returns The singleton instance of RLLPlaceholderHandlers
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(RLLPlaceholderHandlers, [
        {
            key: "reset",
            value: function reset() {
                this.placeholders = [];
            }
        },
        {
            key: "collectRLLPlaceholders",
            value: function collectRLLPlaceholders() {
                if (typeof window === 'undefined' || typeof document === 'undefined' || typeof window.document === 'undefined') return;
                var beginElements = document.querySelectorAll('input[data-lazy-begin]');
                var beginCount = beginElements.length;
                if (beginCount === 0) return;
                // Performance optimization: pre-allocate array with estimated size
                var allElements = [];
                // Performance optimization: use traditional for loop instead of forEach
                for(var i = 0; i < beginCount; i++){
                    var beginEl = beginElements[i];
                    var id = beginEl.getAttribute('data-lazy-begin');
                    if (!id) continue;
                    var elements = this.refElements(beginEl, id);
                    if (elements.length > 0) allElements.push.apply(allElements, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(elements));
                }
                // Second pass: batch all getBoundingClientRect calls to minimize reflow cycles
                var allElementsLength = allElements.length;
                if (allElementsLength > 0) {
                    // Performance optimization: pre-allocate array with exact size
                    var intersectingRects = [];
                    var windowWidth = window.innerWidth;
                    var windowHeight = window.innerHeight;
                    for(var _i = 0; _i < allElementsLength; _i++){
                        var rect = allElements[_i].getBoundingClientRect();
                        // Performance optimization: inline intersection calculation to avoid function call overhead
                        var left = Math.max(rect.left, 0);
                        var top = Math.max(rect.top, 0);
                        var right = Math.min(rect.right, windowWidth);
                        var bottom = Math.min(rect.bottom, windowHeight);
                        // Check if there's a valid intersection with non-zero width and height
                        if (left < right && top < bottom) intersectingRects.push(new DOMRect(left, top, right - left, bottom - top));
                    }
                    this.placeholders = intersectingRects;
                }
            }
        },
        {
            key: "refElements",
            value: function refElements(fromEl, id) {
                var result = [];
                var el = fromEl.nextSibling;
                // Performance optimization: use while loop instead of recursive calls
                while(el){
                    var _el$dataset;
                    if (((_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.lazyEnd) === id) break;
                    if (el.nodeType === Node.ELEMENT_NODE) result.push(el);
                    el = el.nextSibling;
                }
                return result;
            }
        },
        {
            key: "getPlaceholders",
            value: function getPlaceholders() {
                return this.placeholders;
            }
        },
        {
            key: "isRLLPlaceholderHydration",
            value: function isRLLPlaceholderHydration(intersectingRect) {
                var placeholdersLength = this.placeholders.length;
                if (placeholdersLength === 0) return false;
                // Performance optimization: cache array length and use traditional for loop
                for(var i = 0; i < placeholdersLength; i++){
                    var placeholderRect = this.placeholders[i];
                    if (this.areRectsEqual(intersectingRect, placeholderRect)) return true;
                }
                return false;
            }
        },
        {
            key: "areRectsEqual",
            value: function areRectsEqual(rect1, rect2) {
                // Early exit for exact matches (most common case)
                if (rect1.left === rect2.left && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom) return true;
                // Performance optimization: check largest differences first for early exit
                var leftDiff = rect1.left - rect2.left;
                if (leftDiff > 1 || leftDiff < -1) return false;
                var rightDiff = rect1.right - rect2.right;
                if (rightDiff > 1 || rightDiff < -1) return false;
                var topDiff = rect1.top - rect2.top;
                if (topDiff > 1 || topDiff < -1) return false;
                var bottomDiff = rect1.bottom - rect2.bottom;
                if (bottomDiff > 1 || bottomDiff < -1) return false;
                return true;
            }
        }
    ], [
        {
            key: "getInstance",
            value: function getInstance() {
                if (typeof globalThis !== 'undefined') {
                    if (!globalThis[$15c9f0d27b41f931$var$GLOBAL_RLL_HANDLERS_KEY]) globalThis[$15c9f0d27b41f931$var$GLOBAL_RLL_HANDLERS_KEY] = new RLLPlaceholderHandlers();
                    return globalThis[$15c9f0d27b41f931$var$GLOBAL_RLL_HANDLERS_KEY];
                }
                // Fallback for environments without globalThis (should be rare)
                return new RLLPlaceholderHandlers();
            }
        }
    ]);
}();

});

parcelRegister("jGnv3", function(module, exports) {
$parcel$export(module.exports, "SSRPlaceholderHandlers", () => $e5442b28a14893b1$export$c0102f1a1198d10f);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
var $e5442b28a14893b1$var$ANCESTOR_LOOKUP_LIMIT = 10;
var $e5442b28a14893b1$var$PAGE_LAYOUT_ID = 'page-layout.root';
var $e5442b28a14893b1$export$c0102f1a1198d10f = /*#__PURE__*/ function() {
    function SSRPlaceholderHandlers(_ref) {
        var _this = this;
        var _ref$enablePageLayout = _ref.enablePageLayoutPlaceholder, enablePageLayoutPlaceholder = _ref$enablePageLayout === void 0 ? false : _ref$enablePageLayout;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, SSRPlaceholderHandlers);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "staticPlaceholders", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "callbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getSizeCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "reactValidateCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "EQUALITY_THRESHOLD", 1);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getPlaceholderId", function(el) {
            var _el$dataset;
            var ssrPlaceholderId = el === null || el === void 0 || (_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.ssrPlaceholder;
            if (!!ssrPlaceholderId) return ssrPlaceholderId;
            if (_this.enablePageLayoutPlaceholder && (el === null || el === void 0 ? void 0 : el.dataset.testid) === $e5442b28a14893b1$var$PAGE_LAYOUT_ID) return $e5442b28a14893b1$var$PAGE_LAYOUT_ID;
            return '';
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getPlaceholderReplacementId", function(el) {
            var _el$dataset2;
            var ssrPlaceholderReplaceId = el === null || el === void 0 || (_el$dataset2 = el.dataset) === null || _el$dataset2 === void 0 ? void 0 : _el$dataset2.ssrPlaceholderReplace;
            if (!!ssrPlaceholderReplaceId) return ssrPlaceholderReplaceId;
            if (_this.enablePageLayoutPlaceholder && (el === null || el === void 0 ? void 0 : el.dataset.testid) === $e5442b28a14893b1$var$PAGE_LAYOUT_ID) return $e5442b28a14893b1$var$PAGE_LAYOUT_ID;
            return '';
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "intersectionObserverCallback", function(_ref2) {
            var _this$intersectionObs;
            var target = _ref2.target, boundingClientRect = _ref2.boundingClientRect;
            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            var staticKey = _this.getPlaceholderId(target);
            if (staticKey) {
                if (_this.staticPlaceholders.has(staticKey) && _this.callbacks.has(staticKey)) {
                    // validation
                    var _resolve = _this.callbacks.get(staticKey);
                    if (!_resolve) return;
                    var rect = _this.staticPlaceholders.get(staticKey);
                    var hasSameSizePosition = _this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || _this.isDummyRect(rect)) _resolve(hasSameSizePosition);
                    else requestAnimationFrame(function() {
                        var targetRect = _this.getEffectiveBoundingRect(target);
                        var hasSameSizePosition = _this.hasSameSizePosition(rect, targetRect);
                        _resolve(hasSameSizePosition);
                    });
                    _this.callbacks.delete(staticKey);
                }
            } else {
                var key = _this.getPlaceholderReplacementId(target);
                var _resolve2 = _this.reactValidateCallbacks.get(key);
                if (!_resolve2) return;
                var _rect = _this.staticPlaceholders.get(key);
                var _hasSameSizePosition = _this.hasSameSizePosition(_rect, boundingClientRect);
                if (_hasSameSizePosition || _this.isDummyRect(_rect)) _resolve2(_hasSameSizePosition);
                else requestAnimationFrame(function() {
                    var targetRect = _this.getEffectiveBoundingRect(target);
                    var hasSameSizePosition = _this.hasSameSizePosition(_rect, targetRect);
                    _resolve2(hasSameSizePosition);
                });
                _this.staticPlaceholders.delete(staticKey);
                _this.reactValidateCallbacks.delete(staticKey);
            }
        });
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver(function(entries) {
            return entries.filter(function(entry) {
                return entry.intersectionRatio > 0;
            }).forEach(_this.intersectionObserverCallback);
        });
        this.enablePageLayoutPlaceholder = enablePageLayoutPlaceholder;
        if (window.document) try {
            // Collect initial placeholders using SSR dimensions. __SSR_PLACEHOLDERS_DIMENSIONS__ is
            // deliberately left in place: several VCObserverWrappers are built per page load and each
            // builds its own handler, so dropping it here would leave every later handler measuring
            // each placeholder with getBoundingClientRect() — a synchronous style recalc and a
            // full-document layout mid-hydration. Keeping it costs one small map per document.
            this.collectPlaceholdersInternal();
        } catch (_unused) {}
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(SSRPlaceholderHandlers, [
        {
            key: "clear",
            value: function clear() {
                this.staticPlaceholders = new Map();
                this.callbacks = new Map();
                this.getSizeCallbacks = new Map();
                this.reactValidateCallbacks = new Map();
            }
        },
        {
            key: "collectPlaceholdersInternal",
            value: function collectPlaceholdersInternal() {
                var _this2 = this;
                var selector = this.enablePageLayoutPlaceholder ? '[data-ssr-placeholder],[data-testid="page-layout.root"]' : '[data-ssr-placeholder]';
                var existingElements = document.querySelectorAll(selector);
                existingElements.forEach(function(el) {
                    var placeholderId = el instanceof HTMLElement && _this2.getPlaceholderId(el);
                    if (placeholderId && !_this2.staticPlaceholders.has(placeholderId)) {
                        var _window$__SSR_PLACEHO, _this2$intersectionOb;
                        var width = -1;
                        var height = -1;
                        var x = -1;
                        var y = -1;
                        // Use SSR dimensions from window global if available
                        var boundingClientRect = (_window$__SSR_PLACEHO = window.__SSR_PLACEHOLDERS_DIMENSIONS__) === null || _window$__SSR_PLACEHO === void 0 ? void 0 : _window$__SSR_PLACEHO[placeholderId];
                        if (boundingClientRect) {
                            width = boundingClientRect.width;
                            height = boundingClientRect.height;
                            x = boundingClientRect.x;
                            y = boundingClientRect.y;
                        } else {
                            // Fallback to current bounding rect if SSR dimensions not available
                            var rect = el.getBoundingClientRect();
                            width = rect.width;
                            height = rect.height;
                            x = rect.x;
                            y = rect.y;
                        }
                        _this2.staticPlaceholders.set(placeholderId, {
                            width: width,
                            height: height,
                            x: x,
                            y: y
                        });
                        (_this2$intersectionOb = _this2.intersectionObserver) === null || _this2$intersectionOb === void 0 || _this2$intersectionOb.observe(el);
                    }
                });
            }
        },
        {
            key: "collectExistingPlaceholders",
            value: function collectExistingPlaceholders() {
                if (!window.document) return;
                try {
                    // Collect placeholders using SSR dimensions or fallback to live dimensions
                    this.collectPlaceholdersInternal();
                } catch (_unused2) {
                // Silently fail if there are any issues
                }
            }
        },
        {
            key: "isPlaceholder",
            value: function isPlaceholder(element) {
                return Boolean(this.getPlaceholderId(element));
            }
        },
        {
            key: "isPlaceholderReplacement",
            value: function isPlaceholderReplacement(element) {
                return Boolean(this.getPlaceholderReplacementId(element));
            }
        },
        {
            key: "isPlaceholderIgnored",
            value: function isPlaceholderIgnored(element) {
                // data-ssr-placeholder-ignored doesn't have a value.
                return 'ssrPlaceholderIgnored' in element.dataset;
            }
        },
        {
            key: "isPlaceholderV4",
            value: function isPlaceholderV4(element) {
                var currentElement = element;
                var i = 0;
                while(currentElement && i < $e5442b28a14893b1$var$ANCESTOR_LOOKUP_LIMIT){
                    if (Boolean(this.getPlaceholderId(currentElement))) return true;
                    currentElement = currentElement.parentElement;
                    i++;
                }
                return false;
            }
        },
        {
            key: "isPlaceholderReplacementV4",
            value: function isPlaceholderReplacementV4(element) {
                var currentElement = element;
                var i = 0;
                while(currentElement && i < $e5442b28a14893b1$var$ANCESTOR_LOOKUP_LIMIT){
                    if (Boolean(this.getPlaceholderReplacementId(currentElement))) return true;
                    currentElement = currentElement.parentElement;
                    i++;
                }
                return false;
            }
        },
        {
            key: "findNearestPlaceholderContainerIfIgnored",
            value: function findNearestPlaceholderContainerIfIgnored(element) {
                if (!this.isPlaceholderIgnored(element)) return element;
                var ancestor = element.parentElement;
                var i = 0;
                while(ancestor && i < $e5442b28a14893b1$var$ANCESTOR_LOOKUP_LIMIT){
                    if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
                    ancestor = ancestor.parentElement;
                    i++;
                }
                return element;
            }
        },
        {
            key: "findNearestPlaceholderOrContainer",
            value: function findNearestPlaceholderOrContainer(element) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e5442b28a14893b1$var$ANCESTOR_LOOKUP_LIMIT;
                var ancestor = element;
                if (this.isPlaceholderIgnored(element) && element.parentElement) ancestor = element.parentElement;
                var i = 0;
                while(ancestor && i < limit){
                    if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
                    if (ancestor.parentElement) {
                        ancestor = ancestor.parentElement;
                        i++;
                    } else break;
                }
                return element;
            }
        },
        {
            key: "checkIfExistedAndSizeMatching",
            value: function checkIfExistedAndSizeMatching(el) {
                var _this3 = this;
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = this.getPlaceholderId(el);
                return new Promise(function(resolve) {
                    if (!_this3.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        var _this3$intersectionOb;
                        _this3.callbacks.set(id, resolve);
                        (_this3$intersectionOb = _this3.intersectionObserver) === null || _this3$intersectionOb === void 0 || _this3$intersectionOb.observe(el);
                    }
                });
            }
        },
        {
            key: "checkIfExistedAndSizeMatchingV3",
            value: function checkIfExistedAndSizeMatchingV3(el) {
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = this.getPlaceholderId(el);
                var placeholderRects = this.staticPlaceholders.get(id);
                if (!placeholderRects) return false;
                return this.hasSameSizePosition(placeholderRects, this.getEffectiveBoundingRect(el));
            }
        },
        {
            key: "getSize",
            value: function getSize(el) {
                var _this4 = this;
                return new Promise(function(resolve) {
                    var _this4$intersectionOb;
                    _this4.getSizeCallbacks.set(_this4.getPlaceholderId(el), resolve);
                    (_this4$intersectionOb = _this4.intersectionObserver) === null || _this4$intersectionOb === void 0 || _this4$intersectionOb.observe(el);
                });
            }
        },
        {
            key: "validateReactComponentMatchToPlaceholder",
            value: function validateReactComponentMatchToPlaceholder(el) {
                var _this5 = this;
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = this.getPlaceholderReplacementId(el);
                return new Promise(function(resolve) {
                    if (!_this5.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        var _this5$intersectionOb;
                        _this5.reactValidateCallbacks.set(id, resolve);
                        (_this5$intersectionOb = _this5.intersectionObserver) === null || _this5$intersectionOb === void 0 || _this5$intersectionOb.observe(el);
                    }
                });
            }
        },
        {
            key: "validateReactComponentMatchToPlaceholderV4",
            value: function validateReactComponentMatchToPlaceholderV4(el) {
                el = this.findNearestPlaceholderOrContainer(el, 2); // We are using 2 due to over-eagerness of the default, only check itself and 1 ancestor
                var id = this.getPlaceholderReplacementId(el);
                return this.staticPlaceholders.has(id);
            }
        },
        {
            key: "hasSameSizePosition",
            value: function hasSameSizePosition(rect, boundingClientRect) {
                if (!rect) return false;
                var horizontalCheck = Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD;
                var verticalCheck = Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD;
                return horizontalCheck && verticalCheck || false;
            }
        },
        {
            key: "getEffectiveBoundingRect",
            value: function getEffectiveBoundingRect(el) {
                var computedStyle = window.getComputedStyle(el);
                // If element has display: contents, collect bounding rect from children
                if (computedStyle.display === 'contents') {
                    var children = Array.from(el.children);
                    if (children.length === 0) // No children, return zero rect
                    return new DOMRect(0, 0, 0, 0);
                    // Calculate union of all children's bounding rects
                    var minX = Infinity;
                    var minY = Infinity;
                    var maxX = -Infinity;
                    var maxY = -Infinity;
                    children.forEach(function(child) {
                        var childRect = child.getBoundingClientRect();
                        // Skip children with zero dimensions (likely also display: contents)
                        if (childRect.width > 0 || childRect.height > 0) {
                            minX = Math.min(minX, childRect.left);
                            minY = Math.min(minY, childRect.top);
                            maxX = Math.max(maxX, childRect.right);
                            maxY = Math.max(maxY, childRect.bottom);
                        }
                    });
                    // If no children with dimensions found, return zero rect
                    if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
                    return new DOMRect(minX, minY, maxX - minX, maxY - minY);
                }
                // Normal element, return its bounding rect
                return el.getBoundingClientRect();
            }
        },
        {
            key: "isDummyRect",
            value: function isDummyRect(rect) {
                return rect && rect.width < 0 && rect.height < 0 || false;
            }
        }
    ]);
}();

});



parcelRegister("5kq3l", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e13078f5c9961f2$export$2e2bcd8739ae039);

var $fL8KA = parcelRequire("fL8KA");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $50U6m = parcelRequire("50U6m");

var $rHZri = parcelRequire("rHZri");

var $bavRs = parcelRequire("bavRs");

var $l0l26 = parcelRequire("l0l26");

var $jGnv3 = parcelRequire("jGnv3");

var $1W6ON = parcelRequire("1W6ON");

var $ge9G8 = parcelRequire("ge9G8");

var $k98NJ = parcelRequire("k98NJ");

var $5LGgH = parcelRequire("5LGgH");

var $6q4aZ = parcelRequire("6q4aZ");

var $ilLDJ = parcelRequire("ilLDJ");

var $aCyje = parcelRequire("aCyje");

var $gk0Pa = parcelRequire("gk0Pa");

var $immZA = parcelRequire("immZA");

var $54Hqn = parcelRequire("54Hqn");
function $3e13078f5c9961f2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3e13078f5c9961f2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3e13078f5c9961f2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3e13078f5c9961f2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3e13078f5c9961f2$var$SSRState = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
var $3e13078f5c9961f2$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $3e13078f5c9961f2$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function VCObserverNew(config) {
        var _config$isPostInterac, _ref, _getSelectorConfig, _config$trackLayoutSh, _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, VCObserverNew);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "viewportObserver", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "windowEventObserver", null);
        // SSR related properties
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "ssrPlaceholderHandler", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "ssr", {
            state: $3e13078f5c9961f2$var$SSRState.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        });
        this.entriesTimeline = new (0, $1W6ON.default)();
        this.isPostInteraction = (_config$isPostInterac = config.isPostInteraction) !== null && _config$isPostInterac !== void 0 ? _config$isPostInterac : false;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It applies the FedRAMP all-`false` override when
        // `isFedrampModerate()` is true; otherwise it returns `caller-override
        // → setUFOConfig value → historical default`.
        this.selectorConfig = (_ref = (_getSelectorConfig = (0, $rHZri.getSelectorConfig)(config.selectorConfig, $3e13078f5c9961f2$var$DEFAULT_SELECTOR_CONFIG)) !== null && _getSelectorConfig !== void 0 ? _getSelectorConfig : config.selectorConfig) !== null && _ref !== void 0 ? _ref : $3e13078f5c9961f2$var$DEFAULT_SELECTOR_CONFIG;
        // Use shared SSR placeholder handler if provided, otherwise create new one if feature flag is enabled
        if (config.ssrPlaceholderHandler) this.ssrPlaceholderHandler = config.ssrPlaceholderHandler;
        else {
            var _config$SSRConfig$ena, _config$SSRConfig;
            this.ssrPlaceholderHandler = new (0, $jGnv3.SSRPlaceholderHandlers)({
                enablePageLayoutPlaceholder: (_config$SSRConfig$ena = (_config$SSRConfig = config.SSRConfig) === null || _config$SSRConfig === void 0 ? void 0 : _config$SSRConfig.enablePageLayoutPlaceholder) !== null && _config$SSRConfig$ena !== void 0 ? _config$SSRConfig$ena : false
            });
        }
        this.trackLayoutShiftOffenders = (_config$trackLayoutSh = config.trackLayoutShiftOffenders) !== null && _config$trackLayoutSh !== void 0 ? _config$trackLayoutSh : false;
        this.viewportObserver = new (0, $immZA.default)({
            onChange: function onChange(onChangeArg) {
                var time = onChangeArg.time, type = onChangeArg.type, elementRef = onChangeArg.elementRef, visible = onChangeArg.visible, rect = onChangeArg.rect, previousRect = onChangeArg.previousRect, mutationData = onChangeArg.mutationData;
                var elementName = 'unknown';
                var element = elementRef.deref();
                if (element) elementName = _this.getElementName(element);
                var data = {
                    type: type,
                    elementName: elementName,
                    rect: rect,
                    previousRect: previousRect,
                    visible: visible,
                    attributeName: mutationData === null || mutationData === void 0 ? void 0 : mutationData.attributeName,
                    oldValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.oldValue,
                    newValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.newValue,
                    originalMutationTimestamp: mutationData === null || mutationData === void 0 ? void 0 : mutationData.timestamp
                };
                if (element) {
                    var labelStacks = $3e13078f5c9961f2$var$getLabelStacks(element);
                    if (labelStacks) Object.assign(data, {
                        labelStacks: labelStacks
                    });
                }
                _this.entriesTimeline.push({
                    time: time,
                    data: data
                });
            },
            // Pass SSR context to ViewportObserver
            getSSRState: function getSSRState() {
                return _this.getSSRState();
            },
            getSSRPlaceholderHandler: function getSSRPlaceholderHandler() {
                return _this.getSSRPlaceholderHandler();
            },
            searchPageConfig: config.searchPageConfig,
            trackLayoutShiftOffenders: this.trackLayoutShiftOffenders
        });
        this.windowEventObserver = new (0, $54Hqn.default)({
            onEvent: function onEvent(_ref2) {
                var time = _ref2.time, type = _ref2.type, event = _ref2.event;
                // Don't abort press interactions on keydown events, as keydown is expected
                // when users press Enter/Space to activate buttons or other interactive elements
                if (type === 'keydown' && (0, $50U6m.fg)('platform_ufo_keypress_interaction_abort')) {
                    var interaction = (0, $l0l26.getActiveInteraction)();
                    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') return;
                }
                var abortEventTargetElement = $3e13078f5c9961f2$var$isAbortEventTargetSupported(type) && event ? $3e13078f5c9961f2$var$getAbortEventTargetElement(event.target) : null;
                var elementName = abortEventTargetElement ? _this.getElementName(abortEventTargetElement) : undefined;
                _this.entriesTimeline.push({
                    time: time,
                    data: $3e13078f5c9961f2$var$_objectSpread({
                        type: 'window:event',
                        eventType: type
                    }, elementName ? {
                        elementName: elementName
                    } : {})
                });
            }
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(VCObserverNew, [
        {
            key: "start",
            value: function start(_) {
                var _this$viewportObserve, _window, _this2 = this, _this$windowEventObse;
                // Reset SSR state on start (matches old VCObserver behavior)
                this.ssr = {
                    state: $3e13078f5c9961f2$var$SSRState.normal,
                    reactRootElement: null,
                    // Reset to null (matches old VCObserver)
                    renderStart: -1,
                    renderStop: -1
                };
                (_this$viewportObserve = this.viewportObserver) === null || _this$viewportObserve === void 0 || _this$viewportObserve.start();
                this.entriesTimeline.clear();
                if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
                    var abortListeners = window.__SSR_ABORT_LISTENERS__;
                    var aborts = abortListeners.aborts;
                    if (aborts && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(aborts) === 'object') Object.entries(aborts).forEach(function(_ref3) {
                        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), key = _ref4[0], time = _ref4[1];
                        if (typeof time === 'number') _this2.entriesTimeline.push({
                            time: time,
                            data: {
                                type: 'window:event',
                                eventType: key
                            }
                        });
                    });
                }
                (_this$windowEventObse = this.windowEventObserver) === null || _this$windowEventObse === void 0 || _this$windowEventObse.start();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$viewportObserve2, _this$windowEventObse2;
                (_this$viewportObserve2 = this.viewportObserver) === null || _this$viewportObserve2 === void 0 || _this$viewportObserve2.stop();
                (_this$windowEventObse2 = this.windowEventObserver) === null || _this$windowEventObse2 === void 0 || _this$windowEventObse2.stop();
                // Clear SSR state on stop (matches old VCObserver behavior)
                this.ssr.reactRootElement = null;
            }
        },
        {
            key: "setReactRootElement",
            value: function setReactRootElement(element) {
                this.ssr.reactRootElement = element;
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStart = startTime;
                this.ssr.state = $3e13078f5c9961f2$var$SSRState.waitingForFirstRender;
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStop = stopTime;
            }
        },
        {
            key: "collectSSRPlaceholders",
            value: function collectSSRPlaceholders() {
            // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
            // Individual observers don't need to implement this
            }
        },
        {
            key: "getSSRState",
            value: function getSSRState() {
                return this.ssr;
            }
        },
        {
            key: "getSSRPlaceholderHandler",
            value: function getSSRPlaceholderHandler() {
                return this.ssrPlaceholderHandler;
            }
        },
        {
            key: "addSSR",
            value: function addSSR(ssr) {
                this.entriesTimeline.push({
                    time: ssr,
                    data: {
                        elementName: 'SSR',
                        type: 'mutation:element',
                        rect: {
                            height: (0, $6q4aZ.default)(),
                            width: (0, $ilLDJ.default)(),
                            left: 0,
                            top: 0,
                            x: 0,
                            y: 0,
                            bottom: (0, $6q4aZ.default)(),
                            right: (0, $ilLDJ.default)(),
                            toJSON: function toJSON() {
                                return null;
                            }
                        },
                        visible: true
                    }
                });
            }
        },
        {
            key: "getVCResult",
            value: function() {
                var _getVCResult = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(param) {
                    var start, stop, interactionId, interactionType, interactionAbortReason, isPageVisible, include3p, includeSSRRatio, excludeSmartAnswersInSearch, rawDataStopTime, results, feVCCalculationStartTime, calculator_fy25_03, orderedEntries, fy25_03, calculator_fy26_04, calculator_next, calculatorParams, isFy2604Enabled, _yield$Promise$all, _yield$Promise$all2, fy26_04, vcNext, feVCCalculationEndTime, rawVCCalculationStartTime, rawHandler, rawStopTime, rawOrderedEntries, raw, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                start = param.start, stop = param.stop, interactionId = param.interactionId, interactionType = param.interactionType, interactionAbortReason = param.interactionAbortReason, isPageVisible = param.isPageVisible, include3p = param.include3p, includeSSRRatio = param.includeSSRRatio, excludeSmartAnswersInSearch = param.excludeSmartAnswersInSearch, rawDataStopTime = param.rawDataStopTime;
                                results = [];
                                this.addStartEntry(start);
                                feVCCalculationStartTime = performance.now();
                                calculator_fy25_03 = new (0, $k98NJ.default)();
                                if (param.includeSSRInV3 && param.ssr) this.addSSR(param.ssr);
                                orderedEntries = this.entriesTimeline.getOrderedEntries({
                                    start: start,
                                    stop: stop
                                });
                                if (!(0, $rHZri.isVCRevisionEnabled)('fy25.03')) {
                                    _context.next = 2;
                                    break;
                                }
                                _context.next = 1;
                                return calculator_fy25_03.calculate({
                                    orderedEntries: orderedEntries,
                                    startTime: start,
                                    stopTime: stop,
                                    interactionId: interactionId,
                                    interactionType: interactionType,
                                    isPostInteraction: this.isPostInteraction,
                                    include3p: include3p,
                                    excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
                                    includeSSRRatio: includeSSRRatio,
                                    isPageVisible: isPageVisible,
                                    interactionAbortReason: interactionAbortReason,
                                    reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
                                });
                            case 1:
                                _t = _context.sent;
                                _context.next = 3;
                                break;
                            case 2:
                                _t = null;
                            case 3:
                                fy25_03 = _t;
                                if (fy25_03) results.push(fy25_03);
                                // From TTVC v4 onwards, ensuring that SSR entry is always auto-added, whenever it is configured.
                                if (param.ssr) this.addSSR(param.ssr);
                                calculator_fy26_04 = new (0, $5LGgH.default)();
                                calculator_next = new (0, $aCyje.default)();
                                calculatorParams = {
                                    orderedEntries: orderedEntries,
                                    startTime: start,
                                    stopTime: stop,
                                    interactionId: interactionId,
                                    interactionType: interactionType,
                                    isPostInteraction: this.isPostInteraction,
                                    include3p: include3p,
                                    excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
                                    includeSSRRatio: includeSSRRatio,
                                    isPageVisible: isPageVisible,
                                    interactionAbortReason: interactionAbortReason,
                                    reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
                                };
                                isFy2604Enabled = (0, $rHZri.isVCRevisionEnabled)('fy26.04');
                                _context.next = 4;
                                return Promise.all([
                                    isFy2604Enabled ? calculator_fy26_04.calculate(calculatorParams) : null,
                                    (0, $rHZri.isVCRevisionEnabled)('next') ? calculator_next.calculate(calculatorParams) : null
                                ]);
                            case 4:
                                _yield$Promise$all = _context.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all, 2);
                                fy26_04 = _yield$Promise$all2[0];
                                vcNext = _yield$Promise$all2[1];
                                if (fy26_04) results.push(fy26_04);
                                if (vcNext) results.push(vcNext);
                                feVCCalculationEndTime = performance.now(); // Always include raw data so the server can recalculate metrics
                                // (ssrRatio, labelStacks, speedIndex) from raw observations.
                                rawVCCalculationStartTime = performance.now();
                                rawHandler = new (0, $gk0Pa.default)(); // Use rawDataStopTime (end3p) when available to capture observations during 3p holds
                                rawStopTime = rawDataStopTime !== null && rawDataStopTime !== void 0 ? rawDataStopTime : stop;
                                rawOrderedEntries = rawDataStopTime ? this.entriesTimeline.getOrderedEntries({
                                    start: start,
                                    stop: rawStopTime
                                }) : orderedEntries;
                                _context.next = 5;
                                return rawHandler.getRawData({
                                    entries: rawOrderedEntries,
                                    startTime: start,
                                    stopTime: rawStopTime,
                                    isPageVisible: isPageVisible
                                });
                            case 5:
                                raw = _context.sent;
                                results.forEach(function(result) {
                                    delete result.vcDetails;
                                    delete result.ratios;
                                });
                                if (raw) {
                                    raw.rawVCTime = Number((performance.now() - rawVCCalculationStartTime).toFixed(2));
                                    raw.feVCTime = Number((feVCCalculationEndTime - feVCCalculationStartTime).toFixed(2));
                                    results.push(raw);
                                }
                                return _context.abrupt("return", results);
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getVCResult(_x) {
                    return _getVCResult.apply(this, arguments);
                }
                return getVCResult;
            }()
        },
        {
            key: "addStartEntry",
            value: function addStartEntry(startTime) {
                this.entriesTimeline.push({
                    time: startTime,
                    data: {
                        type: 'mutation:element',
                        elementName: 'START',
                        visible: true,
                        rect: {
                            x: 0,
                            y: 0,
                            width: window.innerWidth,
                            height: window.innerHeight,
                            top: 0,
                            left: 0,
                            bottom: window.innerHeight,
                            right: window.innerWidth,
                            toJSON: function toJSON() {
                                return {
                                    x: this.x,
                                    y: this.y,
                                    width: this.width,
                                    height: this.height,
                                    top: this.top,
                                    left: this.left,
                                    bottom: this.bottom,
                                    right: this.right
                                };
                            }
                        }
                    }
                });
            }
        },
        {
            key: "getElementName",
            value: function getElementName(element) {
                return (0, $ge9G8.default)(this.selectorConfig, element);
            }
        }
    ]);
}();
function $3e13078f5c9961f2$var$labelStackFromFiber(fiber) {
    var _fiber$child;
    var value = fiber === null || fiber === void 0 || (_fiber$child = fiber.child) === null || _fiber$child === void 0 || (_fiber$child = _fiber$child.memoizedProps) === null || _fiber$child === void 0 ? void 0 : _fiber$child.value;
    return Array.isArray(value === null || value === void 0 ? void 0 : value.labelStack) ? value.labelStack : [];
}
function $3e13078f5c9961f2$var$labelStackToString(labelStack) {
    return labelStack.map(function(label) {
        return (0, $bavRs.sanitizeLabelStackName)(label.name);
    }).join('/');
}
function $3e13078f5c9961f2$var$labelStackToSegment(labelStack) {
    var segmentIndex = -1;
    for(var i = labelStack.length - 1; i >= 0; i--)if (labelStack[i].segmentId) {
        segmentIndex = i;
        break;
    }
    return labelStack.slice(0, segmentIndex + 1).map(function(label) {
        return (0, $bavRs.sanitizeLabelStackName)(label.name);
    }).join('/');
}
function $3e13078f5c9961f2$var$traverseFiber(fiber) {
    var segment = 'unknown';
    var labelStackString = 'unknown';
    var currentFiber = fiber;
    while(currentFiber){
        if (currentFiber.type) {
            var componentName = currentFiber.type.displayName || currentFiber.type.name;
            if (componentName === 'UFOSegment' || componentName === 'UFOLabel') {
                var labelStack = $3e13078f5c9961f2$var$labelStackFromFiber(currentFiber);
                labelStackString = $3e13078f5c9961f2$var$labelStackToString(labelStack) || 'unknown';
                segment = $3e13078f5c9961f2$var$labelStackToSegment(labelStack) || 'unknown';
                break;
            }
        }
        currentFiber = currentFiber.return;
    }
    return {
        segment: segment,
        labelStack: labelStackString
    };
}
function $3e13078f5c9961f2$var$getLabelStacks(element) {
    var reactFiberKey = Object.keys(element).find(function(key) {
        return key.startsWith('__reactFiber$');
    });
    if (!reactFiberKey) return null;
    var fiber = element[reactFiberKey];
    return fiber ? $3e13078f5c9961f2$var$traverseFiber(fiber) : null;
}
var $3e13078f5c9961f2$var$SUPPORTED_ABORT_EVENT_TARGET_TYPES = new Set([
    'scroll-container',
    'scroll',
    'wheel'
]);
function $3e13078f5c9961f2$var$isAbortEventTargetSupported(type) {
    return $3e13078f5c9961f2$var$SUPPORTED_ABORT_EVENT_TARGET_TYPES.has(type);
}
function $3e13078f5c9961f2$var$getAbortEventTargetElement(target) {
    if (target instanceof HTMLElement) return target;
    if (target instanceof Document) {
        var _target$documentEleme;
        var scrollingElement = target.scrollingElement;
        if (scrollingElement instanceof HTMLElement) return scrollingElement;
        return (_target$documentEleme = target.documentElement) !== null && _target$documentEleme !== void 0 ? _target$documentEleme : null;
    }
    if (target instanceof Window) {
        var _target$document$docu;
        var _scrollingElement = target.document.scrollingElement;
        if (_scrollingElement instanceof HTMLElement) return _scrollingElement;
        return (_target$document$docu = target.document.documentElement) !== null && _target$document$docu !== void 0 ? _target$document$docu : null;
    }
    if (target instanceof Node) return target.parentElement;
    return null;
}

});
parcelRegister("1W6ON", function(module, exports) {
$parcel$export(module.exports, "default", () => $16907f373a1782f1$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");
var $16907f373a1782f1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function EntriesTimeline() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, EntriesTimeline);
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(EntriesTimeline, [
        {
            key: "push",
            value: function push(entry) {
                this.unorderedEntries.push(entry);
                this.sortedEntriesCache.clear();
            }
        },
        {
            key: "getCacheKey",
            value: function getCacheKey(start, stop) {
                return "".concat(start !== null && start !== void 0 ? start : 'null', "_").concat(stop !== null && stop !== void 0 ? stop : 'null');
            }
        },
        {
            key: "getOrderedEntries",
            value: function getOrderedEntries(_ref) {
                var _this$sortedEntriesCa;
                var start = _ref.start, stop = _ref.stop;
                var cacheKey = this.getCacheKey(start, stop);
                var cachedSortedEntries = (_this$sortedEntriesCa = this.sortedEntriesCache.get(cacheKey)) === null || _this$sortedEntriesCa === void 0 ? void 0 : _this$sortedEntriesCa.deref();
                if (cachedSortedEntries) return cachedSortedEntries;
                var filteredEntries = this.unorderedEntries.filter(function(e) {
                    return e.time >= (start !== null && start !== void 0 ? start : 0) && e.time <= (stop !== null && stop !== void 0 ? stop : performance.now());
                });
                var sortedEntries = filteredEntries.sort(function(a, b) {
                    return a.time - b.time;
                });
                this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
                return sortedEntries;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.unorderedEntries = [];
                this.sortedEntriesCache.clear();
            }
        }
    ]);
}();

});

parcelRegister("ge9G8", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd05761e08522abb$export$2e2bcd8739ae039);
var $bd05761e08522abb$var$nameCache = new WeakMap();
function $bd05761e08522abb$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) {
        var elementInstance = 'Unknown';
        // Types of elements according to LLM
        if (element instanceof Text) elementInstance = 'Text';
        else if (element instanceof DocumentFragment) elementInstance = 'DocumentFragment';
        else if (element instanceof Document) elementInstance = 'Document';
        else if (element instanceof Comment) elementInstance = 'Comment';
        else if (element instanceof ProcessingInstruction) elementInstance = 'ProcessingInstruction';
        else if (element instanceof Attr) elementInstance = 'Attr';
        else if (element instanceof CDATASection) elementInstance = 'CDATASection';
        if (element.parentElement && element.parentElement instanceof HTMLElement) {
            var parentElementSelector = $bd05761e08522abb$var$getElementName(selectorConfig, element.parentElement);
            return "".concat(parentElementSelector, " > ").concat(elementInstance);
        } else return elementInstance;
    }
    var cachedName = $bd05761e08522abb$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    var tagName = element.localName;
    var encodeValue = function encodeValue(s) {
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch (_unused) {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    var getAttributeSelector = function getAttributeSelector(attributeName) {
        var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        if (element && typeof element.getAttribute !== 'function') return '';
        var attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        var encondedAttrValue = encodeValue(attrValue);
        return "".concat(prefix, "[").concat(attributeName, "=\"").concat(encondedAttrValue, "\"]");
    };
    // Construct the data-vc attribute selector if specified in the config.
    var dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    var id = selectorConfig.id && element.id ? "#".concat(encodeValue(element.id)) : '';
    // Construct the test ID selector if specified in the config.
    var testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    var role = selectorConfig.role ? getAttributeSelector('role') : '';
    var classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    var classList = selectorConfig.className && classNames ? ".".concat(classNames) : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    var primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    var attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        var parentName = element.parentElement ? $bd05761e08522abb$var$getElementName(selectorConfig, element.parentElement) : 'unknown';
        return "".concat(parentName, " > ").concat(tagName);
    }
    // Return the final constructed name: tagName + attributes or classList.
    var name = "".concat(tagName).concat(attributes || classList);
    $bd05761e08522abb$var$nameCache.set(element, name);
    return name;
}
var $bd05761e08522abb$export$2e2bcd8739ae039 = $bd05761e08522abb$var$getElementName;

});

parcelRegister("k98NJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $eaab79a4fff9f92f$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $50U6m = parcelRequire("50U6m");

var $fRIsY = parcelRequire("fRIsY");

var $5C5YK = parcelRequire("5C5YK");

var $bnjtj = parcelRequire("bnjtj");

var $jW9Uy = parcelRequire("jW9Uy");

var $8WpTJ = parcelRequire("8WpTJ");
function $eaab79a4fff9f92f$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $eaab79a4fff9f92f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $eaab79a4fff9f92f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($eaab79a4fff9f92f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $eaab79a4fff9f92f$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
var $eaab79a4fff9f92f$var$REVISION_NO = 'fy25.03';
var $eaab79a4fff9f92f$var$getConsideredEntryTypes = function getConsideredEntryTypes(include3p, excludeSmartAnswersInSearch) {
    var entryTypes = [
        'mutation:child-element',
        'mutation:element',
        'mutation:attribute',
        'layout-shift',
        'layout-shift:same-rect',
        'window:event'
    ];
    // Only include third-party elements in TTVC calculation when explicitly requested.
    // GenAI elements intentionally remain excluded from core TTVC; a server-side metric variant
    // can derive "including GenAI" from the emitted metricWindows payload.
    if (include3p) {
        entryTypes.push('mutation:third-party-element');
        entryTypes.push('mutation:third-party-attribute');
    }
    if (!excludeSmartAnswersInSearch) {
        entryTypes.push('mutation:smart-answers-element');
        entryTypes.push('mutation:smart-answers-attribute');
    }
    entryTypes.push('mutation:media');
    // Still included as part of TTVC v3
    entryTypes.push('mutation:attribute:non-visual-input-name');
    return entryTypes;
};
var $eaab79a4fff9f92f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractVCCalculator) {
    function VCCalculator_FY25_03(revisionNo) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, VCCalculator_FY25_03);
        return $eaab79a4fff9f92f$var$_callSuper(this, VCCalculator_FY25_03, [
            revisionNo !== null && revisionNo !== void 0 ? revisionNo : $eaab79a4fff9f92f$var$REVISION_NO
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(VCCalculator_FY25_03, _AbstractVCCalculator);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(VCCalculator_FY25_03, [
        {
            key: "isEntryIncluded",
            value: function isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
                if (!$eaab79a4fff9f92f$var$getConsideredEntryTypes(include3p, excludeSmartAnswersInSearch).includes(entry.data.type)) return false;
                if (entry.data.type === 'mutation:attribute:framework-routing') return false;
                if (entry.data.type === 'mutation:media' && (0, $50U6m.fg)('media-perf-uplift-mutation-fix')) {
                    var entryData = entry.data;
                    var attributeName = entryData.attributeName;
                    if (attributeName && (/data-(test|file|context)-\S+/g.test(attributeName) || attributeName === 'data-cursor' || attributeName === 'alt' || (attributeName === 'localid' || attributeName === 'contenteditable' || attributeName === 'anchor-name') && (0, $fRIsY.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false))) return false;
                    // special case for style attribute to ignore only anchor-name changes
                    if ((0, $fRIsY.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false)) {
                        if ((0, $5C5YK.containsAnchorNameMutationInStyle)({
                            attributeName: entryData.attributeName,
                            oldValue: entryData.oldValue,
                            newValue: entryData.newValue
                        })) return false;
                    }
                }
                if (entry.data.type === 'mutation:attribute') {
                    var _entryData = entry.data;
                    var _attributeName = _entryData.attributeName;
                    if (!_attributeName || (0, $jW9Uy.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(_attributeName)) return false;
                    if (_attributeName.startsWith('data-test') || (0, $jW9Uy.NON_VISUAL_ARIA_ATTRIBUTES).includes(_attributeName) || (0, $jW9Uy.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES).includes(_attributeName) || (0, $jW9Uy.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES).includes(_attributeName) && (0, $50U6m.fg)('platform_ufo_exclude_fdprocessedid_attribute')) return false;
                    return true;
                }
                if ((0, $8WpTJ.default)(entry.data) && !entry.data.visible) return false;
                return true;
            }
        },
        {
            key: "getVCCleanStatus",
            value: function getVCCleanStatus(filteredEntries) {
                var dirtyReason = '';
                var abortTimestamp = -1;
                var hasAbortEvent = filteredEntries.some(function(entry) {
                    if (entry.data.type === 'window:event') {
                        var data = entry.data;
                        var eventType = data.eventType;
                        if ($eaab79a4fff9f92f$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                            dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                            abortTimestamp = Math.round(entry.time);
                            return true;
                        }
                    }
                    return false;
                });
                if (hasAbortEvent && dirtyReason) return {
                    isVCClean: false,
                    dirtyReason: dirtyReason,
                    abortTimestamp: abortTimestamp
                };
                return {
                    isVCClean: true
                };
            }
        }
    ]);
}((0, $bnjtj.default));

});
parcelRegister("fRIsY", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $b8ce4c5474d482fc$export$9db1624a8af791a4);

var $ISKn7 = parcelRequire("ISKn7");

var $67sOe = parcelRequire("67sOe");
var $b8ce4c5474d482fc$export$9db1624a8af791a4 = function expVal(experimentName, experimentParam, defaultValue) {
    // If client is not initialized, we return the default value
    if (!(0, $ISKn7.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $ISKn7.default).getExperimentValue(experimentName, experimentParam, defaultValue);
    (0, $67sOe.addFeatureFlagAccessed)("".concat(experimentName, ":").concat(experimentParam), experimentValue);
    return experimentValue;
};

});

parcelRegister("5C5YK", function(module, exports) {
$parcel$export(module.exports, "containsAnchorNameMutationInStyle", () => $4165239f9c1f0d20$export$f83f33200c1a234e);
$parcel$export(module.exports, "default", () => $4165239f9c1f0d20$export$2e2bcd8739ae039);

var $50U6m = parcelRequire("50U6m");
function $4165239f9c1f0d20$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $4165239f9c1f0d20$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $4165239f9c1f0d20$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $4165239f9c1f0d20$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $4165239f9c1f0d20$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $4165239f9c1f0d20$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
/**
 * Matches only the editor drag and drop anchors. This is the pre-gate behaviour.
 */ var $4165239f9c1f0d20$var$isDnDAnchorNameDeclaration = function isDnDAnchorNameDeclaration(declaration) {
    return declaration.startsWith('anchor-name: --node-anchor');
};
/**
 * Matches any `anchor-name` declaration.
 *
 * `anchor-name` (CSS Anchor Positioning) only names an element so that _other_
 * elements can position themselves against it. It never changes how the named
 * element itself renders, so adding or removing it is never a visual change.
 *
 * `@atlaskit/top-layer` writes `anchor-name` onto a popover's trigger as soon as
 * the popover host element exists, which for `Popover`-based consumers is first
 * open (for example, hovering an `@atlaskit/tooltip` trigger). Without this
 * exclusion that write is recorded as a repaint of the trigger at hover time,
 * which shifts TTVC in sessions where a user hovers a trigger before the page
 * has settled. See COPPER-1736.
 */ var $4165239f9c1f0d20$var$isAnyAnchorNameDeclaration = function isAnyAnchorNameDeclaration(declaration) {
    return declaration.startsWith('anchor-name:');
};
var $4165239f9c1f0d20$var$parseStyleSet = function parseStyleSet(style) {
    if (!style) return null;
    var set = new Set();
    var _iterator = $4165239f9c1f0d20$var$_createForOfIteratorHelper(style.split(';')), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var part = _step.value;
            var t = part.trim();
            if (t) set.add(t);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return set;
};
/**
 * Checks if a mutation record represents a `style` change that consists only
 * of `anchor-name` declarations being added or removed.
 *
 * Without `platform_ufo_exclude_anchor_name_from_ttvc` this is limited to the
 * editor's drag and drop anchors (`--node-anchor…`), which is where the check
 * originated. With the gate on, every `anchor-name` is treated as non-visual,
 * because the property never affects the rendering of the element it is set on.
 *
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is an anchor-name-only style mutation
 */ function $4165239f9c1f0d20$export$7a0b59cebcbf44ec(_ref) {
    var target = _ref.target, attributeName = _ref.attributeName, oldValue = _ref.oldValue, newValue = _ref.newValue;
    if (!(target instanceof Element)) return false;
    return $4165239f9c1f0d20$export$f83f33200c1a234e({
        attributeName: attributeName,
        oldValue: oldValue,
        newValue: newValue
    });
}
function $4165239f9c1f0d20$export$f83f33200c1a234e(_ref2) {
    var attributeName = _ref2.attributeName, oldValue = _ref2.oldValue, newValue = _ref2.newValue;
    if (attributeName !== 'style') return false;
    // Resolved once per mutation rather than once per declaration: this runs
    // inside the MutationObserver callback.
    var isIgnoredDeclaration = (0, $50U6m.fg)('platform_ufo_exclude_anchor_name_from_ttvc') ? $4165239f9c1f0d20$var$isAnyAnchorNameDeclaration : $4165239f9c1f0d20$var$isDnDAnchorNameDeclaration;
    var oldStyles = $4165239f9c1f0d20$var$parseStyleSet(oldValue);
    var newStyles = $4165239f9c1f0d20$var$parseStyleSet(newValue);
    var isAnchorNameMutation = false;
    var _iterator2 = $4165239f9c1f0d20$var$_createForOfIteratorHelper(oldStyles !== null && oldStyles !== void 0 ? oldStyles : []), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var s = _step2.value;
            if (!(newStyles !== null && newStyles !== void 0 && newStyles.has(s))) {
                if (!isIgnoredDeclaration(s)) return false;
                isAnchorNameMutation = true;
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    var _iterator3 = $4165239f9c1f0d20$var$_createForOfIteratorHelper(newStyles !== null && newStyles !== void 0 ? newStyles : []), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var _s = _step3.value;
            if (!(oldStyles !== null && oldStyles !== void 0 && oldStyles.has(_s))) {
                if (!isIgnoredDeclaration(_s)) return false;
                isAnchorNameMutation = true;
            }
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
    return isAnchorNameMutation;
}
var $4165239f9c1f0d20$export$2e2bcd8739ae039 = $4165239f9c1f0d20$export$7a0b59cebcbf44ec;

});

parcelRegister("bnjtj", function(module, exports) {
$parcel$export(module.exports, "default", () => $8480f261c1f2c8a7$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $fC8ib = parcelRequire("fC8ib");

var $fL8KA = parcelRequire("fL8KA");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $8xIjh = parcelRequire("8xIjh");

var $eybTT = parcelRequire("eybTT");

var $6q4aZ = parcelRequire("6q4aZ");

var $ilLDJ = parcelRequire("ilLDJ");

var $8WpTJ = parcelRequire("8WpTJ");
function $8480f261c1f2c8a7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8480f261c1f2c8a7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8480f261c1f2c8a7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8480f261c1f2c8a7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8480f261c1f2c8a7$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $8480f261c1f2c8a7$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $8480f261c1f2c8a7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $8480f261c1f2c8a7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $8480f261c1f2c8a7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $8480f261c1f2c8a7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
// Create comprehensive debug details including ignored entries
// Helper function for reporting ratios
function $8480f261c1f2c8a7$var$roundDecimal(value) {
    var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    var factor = Math.pow(10, decimals);
    return Math.round(value * factor) / factor;
}
var $8480f261c1f2c8a7$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AbstractVCCalculatorBase(revisionNo) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AbstractVCCalculatorBase);
        this.revisionNo = revisionNo;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AbstractVCCalculatorBase, [
        {
            key: "filterViewportEntries",
            value: function filterViewportEntries(entries) {
                return entries.filter(function(entry) {
                    return 'rect' in entry.data;
                });
            }
        },
        {
            key: "calculateRatios",
            value: function calculateRatios(filteredEntries) {
                var ratios = {};
                var viewportWidth = (0, $ilLDJ.default)();
                var viewportHeight = (0, $6q4aZ.default)();
                var totalViewportArea = viewportWidth * viewportHeight;
                if (totalViewportArea === 0) return ratios;
                var elementRects = new Map();
                var _iterator = $8480f261c1f2c8a7$var$_createForOfIteratorHelper(filteredEntries), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _entry = _step.value;
                        if ('rect' in _entry.data) {
                            var viewportEntry = _entry.data;
                            elementRects.set(viewportEntry.elementName, viewportEntry.rect);
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                var _iterator2 = $8480f261c1f2c8a7$var$_createForOfIteratorHelper(elementRects), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var _step2$value = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_step2.value, 2), elementName = _step2$value[0], rect = _step2$value[1];
                        var elementArea = rect.width * rect.height;
                        ratios[elementName] = $8480f261c1f2c8a7$var$roundDecimal(elementArea / totalViewportArea);
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
                return ratios;
            }
        },
        {
            key: "getLabelStacks",
            value: function getLabelStacks(filteredEntries, isPostInteraction) {
                var labelStacks = {};
                var _iterator3 = $8480f261c1f2c8a7$var$_createForOfIteratorHelper(filteredEntries), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var _entry2 = _step3.value;
                        if ((0, $8WpTJ.default)(_entry2.data) && _entry2.data.labelStacks) {
                            if (isPostInteraction) labelStacks[_entry2.data.elementName] = {
                                segment: _entry2.data.labelStacks.segment,
                                labelStack: _entry2.data.labelStacks.labelStack
                            };
                            else labelStacks[_entry2.data.elementName] = _entry2.data.labelStacks.labelStack;
                        }
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                return labelStacks;
            }
        },
        {
            key: "calculateWithDebugInfo",
            value: function() {
                var _calculateWithDebugInfo = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, allEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders) {
                    var _window, _window2, _window3, _window4, _window6;
                    var percentiles, viewportEntries, _yield$calculateTTVCP, vcLogs, speedIndex, vcDetails, percentileIndex, entryDataBuffer, ssrRatio, layoutShiftInsights, previousViewportPercentage, _iterator4, _step4, _entry3, time, viewportPercentage, entries, elementNames, layoutShiftEntries, previousResult, i, percentile, enhancedVcLogs, shouldCalculate3p, shouldCalculateDebugDetails, sortedVcLogs, maxViewportPercentageAtTime, maxSoFar, _iterator5, _step5, log, getBiggestPreviousViewportPercentage, ignoredEntriesByTime, _iterator6, _step6, _entry4, _ignoredEntriesByTime, _viewportData$rect, _viewportData$previou, viewportData, timestamp, additionalVcLogs, _iterator7, _step7, _step7$value, _timestamp, ignoredEntries, _viewportPercentage, v3RevisionDebugDetails, _window5, _window5$__ufo_devtoo, _window7, _window7$__on_ufo_vc_, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                percentiles = [
                                    25,
                                    50,
                                    75,
                                    80,
                                    85,
                                    90,
                                    95,
                                    98,
                                    99,
                                    100
                                ];
                                viewportEntries = this.filterViewportEntries(filteredEntries);
                                _context.next = 1;
                                return (0, $8xIjh.calculateTTVCPercentilesWithDebugInfo)({
                                    viewport: {
                                        width: (0, $ilLDJ.default)(),
                                        height: (0, $6q4aZ.default)()
                                    },
                                    startTime: startTime,
                                    stopTime: stopTime,
                                    orderedEntries: viewportEntries
                                });
                            case 1:
                                _yield$calculateTTVCP = _context.sent;
                                vcLogs = _yield$calculateTTVCP.entries;
                                speedIndex = _yield$calculateTTVCP.speedIndex;
                                vcDetails = {};
                                percentileIndex = 0;
                                entryDataBuffer = new Set();
                                ssrRatio = -1;
                                layoutShiftInsights = null;
                                previousViewportPercentage = 0;
                                if (!vcLogs) {
                                    _context.next = 9;
                                    break;
                                }
                                _iterator4 = $8480f261c1f2c8a7$var$_createForOfIteratorHelper(vcLogs);
                                _context.prev = 2;
                                _iterator4.s();
                            case 3:
                                if ((_step4 = _iterator4.n()).done) {
                                    _context.next = 6;
                                    break;
                                }
                                _entry3 = _step4.value;
                                time = _entry3.time, viewportPercentage = _entry3.viewportPercentage, entries = _entry3.entries;
                                if (includeSSRRatio && ssrRatio === -1 && entries.some(function(e) {
                                    return e.elementName === 'SSR';
                                })) ssrRatio = viewportPercentage;
                                // Only process entries if we haven't reached all percentiles
                                if (!(percentileIndex >= percentiles.length)) {
                                    _context.next = 4;
                                    break;
                                }
                                return _context.abrupt("continue", 6);
                            case 4:
                                // Check if this entry matches any checkpoint percentiles
                                if (viewportPercentage >= percentiles[percentileIndex]) {
                                    elementNames = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set(entries.map(function(e) {
                                        return e.elementName;
                                    }))); // Process all matching percentiles in one go
                                    while(percentileIndex < percentiles.length && viewportPercentage >= percentiles[percentileIndex]){
                                        vcDetails["".concat(percentiles[percentileIndex])] = {
                                            t: Math.round(time),
                                            e: elementNames
                                        };
                                        if (reportLayoutShiftOffenders && percentiles[percentileIndex] === 90 && entries.some(function(e) {
                                            return e.type === 'layout-shift';
                                        })) {
                                            layoutShiftEntries = entries.filter(function(e) {
                                                return e.type === 'layout-shift';
                                            });
                                            layoutShiftInsights = {
                                                layoutShiftOffendersResult: (0, $eybTT.detectLayoutShiftCause)({
                                                    viewportEntries: viewportEntries,
                                                    layoutShiftEntries: layoutShiftEntries,
                                                    time: time,
                                                    startTime: startTime
                                                }),
                                                layoutShiftEntriesCount: layoutShiftEntries.length,
                                                layoutShiftImpact: viewportPercentage - previousViewportPercentage
                                            };
                                        }
                                        percentileIndex++;
                                    }
                                    // Clear buffer after processing all matching percentiles
                                    entryDataBuffer.clear();
                                } else // Only add to buffer if we haven't reached all percentiles
                                entries.forEach(function(e) {
                                    return entryDataBuffer.add(e);
                                });
                                previousViewportPercentage = viewportPercentage;
                            case 5:
                                _context.next = 3;
                                break;
                            case 6:
                                _context.next = 8;
                                break;
                            case 7:
                                _context.prev = 7;
                                _t = _context["catch"](2);
                                _iterator4.e(_t);
                            case 8:
                                _context.prev = 8;
                                _iterator4.f();
                                return _context.finish(8);
                            case 9:
                                // Fill in any missing percentiles with the last known values
                                previousResult = {
                                    t: 0,
                                    e: []
                                };
                                for(i = 0; i < percentiles.length; i++){
                                    percentile = percentiles[i];
                                    if (!(percentile in vcDetails)) vcDetails["".concat(percentile)] = previousResult;
                                    else previousResult = vcDetails["".concat(percentile)];
                                }
                                enhancedVcLogs = vcLogs ? vcLogs.map(function(log) {
                                    return $8480f261c1f2c8a7$var$_objectSpread($8480f261c1f2c8a7$var$_objectSpread({}, log), {}, {
                                        entries: log.entries.map(function(entry) {
                                            var _entry$rect, _entry$previousRect;
                                            return $8480f261c1f2c8a7$var$_objectSpread($8480f261c1f2c8a7$var$_objectSpread({}, entry), {}, {
                                                rect: (_entry$rect = entry.rect) === null || _entry$rect === void 0 ? void 0 : _entry$rect.toJSON(),
                                                previousRect: (_entry$previousRect = entry.previousRect) === null || _entry$previousRect === void 0 ? void 0 : _entry$previousRect.toJSON()
                                            });
                                        }),
                                        viewportPercentage: log.viewportPercentage
                                    });
                                }) : []; // If 3p metric enabled - calculate the debug details
                                shouldCalculate3p = include3p; // Only calculate enhanced debug details if devtool callbacks exist
                                shouldCalculateDebugDetails = !isPostInteraction && (typeof ((_window = window) === null || _window === void 0 ? void 0 : _window.__ufo_devtool_onVCRevisionReady__) === 'function' || typeof ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.__on_ufo_vc_debug_data_ready) === 'function' || typeof ((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.__ufo_devtool_vc_3p_debug_data) === 'function');
                                if (shouldCalculateDebugDetails && allEntries && vcLogs) {
                                    // Pre-sort vcLogs by time for efficient lookups
                                    sortedVcLogs = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(vcLogs).sort(function(a, b) {
                                        return a.time - b.time;
                                    }); // Pre-calculate max viewport percentage up to each time for efficient lookups
                                    maxViewportPercentageAtTime = new Map();
                                    maxSoFar = 0;
                                    _iterator5 = $8480f261c1f2c8a7$var$_createForOfIteratorHelper(sortedVcLogs);
                                    try {
                                        for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                            log = _step5.value;
                                            if (log.viewportPercentage !== null) {
                                                maxSoFar = Math.max(maxSoFar, log.viewportPercentage);
                                                maxViewportPercentageAtTime.set(log.time, maxSoFar);
                                            }
                                        }
                                    // Helper function to find the biggest previous viewport percentage
                                    } catch (err) {
                                        _iterator5.e(err);
                                    } finally{
                                        _iterator5.f();
                                    }
                                    getBiggestPreviousViewportPercentage = function getBiggestPreviousViewportPercentage(targetTime) {
                                        // Binary search for the largest time <= targetTime
                                        var left = 0;
                                        var right = sortedVcLogs.length - 1;
                                        var result = -1;
                                        while(left <= right){
                                            var mid = Math.floor((left + right) / 2);
                                            if (sortedVcLogs[mid].time <= targetTime) {
                                                result = mid;
                                                left = mid + 1;
                                            } else right = mid - 1;
                                        }
                                        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVcLogs[result].time) || null : null;
                                    }; // Group ignored entries by timestamp
                                    ignoredEntriesByTime = new Map();
                                    _iterator6 = $8480f261c1f2c8a7$var$_createForOfIteratorHelper(allEntries);
                                    try {
                                        for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                                            _entry4 = _step6.value;
                                            if ('rect' in _entry4.data && !this.isEntryIncluded(_entry4, include3p, excludeSmartAnswersInSearch)) {
                                                viewportData = _entry4.data;
                                                timestamp = Math.round(_entry4.time);
                                                if (!ignoredEntriesByTime.has(timestamp)) ignoredEntriesByTime.set(timestamp, []);
                                                (_ignoredEntriesByTime = ignoredEntriesByTime.get(timestamp)) === null || _ignoredEntriesByTime === void 0 || _ignoredEntriesByTime.push($8480f261c1f2c8a7$var$_objectSpread($8480f261c1f2c8a7$var$_objectSpread({}, viewportData), {}, {
                                                    rect: (_viewportData$rect = viewportData.rect) === null || _viewportData$rect === void 0 ? void 0 : _viewportData$rect.toJSON(),
                                                    previousRect: (_viewportData$previou = viewportData.previousRect) === null || _viewportData$previou === void 0 ? void 0 : _viewportData$previou.toJSON(),
                                                    ignoreReason: viewportData.visible ? viewportData.type : 'not-visible'
                                                }));
                                            }
                                        }
                                    // Add ignored entries to vcLogs
                                    } catch (err) {
                                        _iterator6.e(err);
                                    } finally{
                                        _iterator6.f();
                                    }
                                    additionalVcLogs = [];
                                    _iterator7 = $8480f261c1f2c8a7$var$_createForOfIteratorHelper(ignoredEntriesByTime);
                                    try {
                                        for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                                            _step7$value = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_step7.value, 2), _timestamp = _step7$value[0], ignoredEntries = _step7$value[1];
                                            if (ignoredEntries.length > 0) {
                                                _viewportPercentage = getBiggestPreviousViewportPercentage(_timestamp);
                                                additionalVcLogs.push({
                                                    time: _timestamp,
                                                    viewportPercentage: _viewportPercentage,
                                                    entries: ignoredEntries
                                                });
                                            }
                                        }
                                    // Combine and sort all vcLogs
                                    } catch (err) {
                                        _iterator7.e(err);
                                    } finally{
                                        _iterator7.f();
                                    }
                                    enhancedVcLogs = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(enhancedVcLogs), additionalVcLogs).sort(function(a, b) {
                                        return a.time - b.time;
                                    });
                                }
                                // Only create debug details if callbacks exist
                                v3RevisionDebugDetails = null;
                                if (shouldCalculateDebugDetails) v3RevisionDebugDetails = {
                                    revision: this.revisionNo,
                                    isClean: isVCClean && !interactionAbortReason && isPageVisible,
                                    abortReason: !isPageVisible ? 'browser_backgrounded' : dirtyReason !== null && dirtyReason !== void 0 ? dirtyReason : interactionAbortReason,
                                    vcLogs: enhancedVcLogs,
                                    interactionId: interactionId,
                                    interactionType: interactionType
                                };
                                // Handle devtool callback
                                if (v3RevisionDebugDetails && typeof ((_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.__ufo_devtool_onVCRevisionReady__) === 'function' && !include3p) try {
                                    (_window5 = window) === null || _window5 === void 0 || (_window5$__ufo_devtoo = _window5.__ufo_devtool_onVCRevisionReady__) === null || _window5$__ufo_devtoo === void 0 || _window5$__ufo_devtoo.call(_window5, v3RevisionDebugDetails);
                                } catch (e) {
                                    // if any error communicating with devtool, we don't want to break the app
                                    // eslint-disable-next-line no-console
                                    console.error('Error in onVCRevisionReady', e);
                                }
                                if (v3RevisionDebugDetails && typeof ((_window6 = window) === null || _window6 === void 0 ? void 0 : _window6.__on_ufo_vc_debug_data_ready) === 'function' && !include3p) try {
                                    (_window7 = window) === null || _window7 === void 0 || (_window7$__on_ufo_vc_ = _window7.__on_ufo_vc_debug_data_ready) === null || _window7$__on_ufo_vc_ === void 0 || _window7$__on_ufo_vc_.call(_window7, v3RevisionDebugDetails);
                                } catch (e) {
                                    // eslint-disable-next-line no-console
                                    console.error('Error in onVCRevisionReady', e);
                                }
                                if (v3RevisionDebugDetails && shouldCalculate3p) try {
                                    // Log vc details with 3p for debugging
                                    window.__ufo_devtool_vc_3p_debug_data = v3RevisionDebugDetails;
                                } catch (e) {
                                    // eslint-disable-next-line no-console
                                    console.error('Error in 3pDebugData', e);
                                }
                                return _context.abrupt("return", {
                                    vcDetails: vcDetails,
                                    ssrRatio: ssrRatio,
                                    speedIndex: speedIndex,
                                    VC90layoutShiftInsights: layoutShiftInsights
                                });
                            case 10:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            7,
                            8,
                            9
                        ]
                    ]);
                }));
                function calculateWithDebugInfo(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8, _x9, _x0, _x1, _x10, _x11, _x12, _x13) {
                    return _calculateWithDebugInfo.apply(this, arguments);
                }
                return calculateWithDebugInfo;
            }()
        },
        {
            key: "calculate",
            value: function() {
                var _calculate = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_ref) {
                    var _this = this, _vcDetails$90$t, _vcDetails$;
                    var startTime, stopTime, orderedEntries, interactionId, isPostInteraction, include3p, excludeSmartAnswersInSearch, includeSSRRatio, interactionType, isPageVisible, interactionAbortReason, reportLayoutShiftOffenders, filteredEntries, isVCClean, dirtyReason, getVCCleanStatusResult, _yield$this$calculate, vcDetails, ssrRatio, speedIndex, VC90layoutShiftInsights, layoutShiftInsightsPayload, _layoutShiftOffenders, _layoutShiftOffenders2, _layoutShiftOffenders3, layoutShiftOffendersResult, layoutShiftEntriesCount, layoutShiftImpact, result;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                startTime = _ref.startTime, stopTime = _ref.stopTime, orderedEntries = _ref.orderedEntries, interactionId = _ref.interactionId, isPostInteraction = _ref.isPostInteraction, include3p = _ref.include3p, excludeSmartAnswersInSearch = _ref.excludeSmartAnswersInSearch, includeSSRRatio = _ref.includeSSRRatio, interactionType = _ref.interactionType, isPageVisible = _ref.isPageVisible, interactionAbortReason = _ref.interactionAbortReason, reportLayoutShiftOffenders = _ref.reportLayoutShiftOffenders;
                                filteredEntries = orderedEntries.filter(function(entry) {
                                    return _this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
                                });
                                getVCCleanStatusResult = this.getVCCleanStatus(filteredEntries);
                                isVCClean = getVCCleanStatusResult.isVCClean;
                                dirtyReason = getVCCleanStatusResult.dirtyReason;
                                if (isVCClean) {
                                    _context2.next = 1;
                                    break;
                                }
                                return _context2.abrupt("return", {
                                    revision: this.revisionNo,
                                    'metric:vc90': null,
                                    clean: false,
                                    abortReason: dirtyReason,
                                    abortTimestamp: getVCCleanStatusResult.abortTimestamp
                                });
                            case 1:
                                _context2.next = 2;
                                return this.calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, orderedEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders);
                            case 2:
                                _yield$this$calculate = _context2.sent;
                                vcDetails = _yield$this$calculate.vcDetails;
                                ssrRatio = _yield$this$calculate.ssrRatio;
                                speedIndex = _yield$this$calculate.speedIndex;
                                VC90layoutShiftInsights = _yield$this$calculate.VC90layoutShiftInsights;
                                if (VC90layoutShiftInsights !== null && reportLayoutShiftOffenders) {
                                    layoutShiftOffendersResult = VC90layoutShiftInsights.layoutShiftOffendersResult, layoutShiftEntriesCount = VC90layoutShiftInsights.layoutShiftEntriesCount, layoutShiftImpact = VC90layoutShiftInsights.layoutShiftImpact;
                                    layoutShiftInsightsPayload = {
                                        impact: layoutShiftImpact,
                                        sources: layoutShiftEntriesCount !== null && layoutShiftEntriesCount !== void 0 ? layoutShiftEntriesCount : 0,
                                        same: {
                                            dir: (_layoutShiftOffenders = layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftVariables.allMovedSameWay) !== null && _layoutShiftOffenders !== void 0 ? _layoutShiftOffenders : false,
                                            dist: (_layoutShiftOffenders2 = layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftVariables.allMovedSameAmount) !== null && _layoutShiftOffenders2 !== void 0 ? _layoutShiftOffenders2 : false
                                        },
                                        total_mut: (_layoutShiftOffenders3 = layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftOffenders.length) !== null && _layoutShiftOffenders3 !== void 0 ? _layoutShiftOffenders3 : 0,
                                        mut: layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftOffenders.sort(function(a, b) {
                                            return Math.abs(a.distanceToLS) - Math.abs(b.distanceToLS);
                                        }).slice(0, 5).map(function(offender) {
                                            return {
                                                e: offender.offender,
                                                size: -1,
                                                // @todo: calculate size
                                                attr: {
                                                    t_before: offender.happenedBefore,
                                                    t_distance: offender.distanceToLS,
                                                    p_above: offender.isAbove,
                                                    p_left: offender.isLeft,
                                                    p_right: offender.isRight,
                                                    p_h_overlap: offender.hasHorizontalOverlap,
                                                    p_v_overlap: offender.hasVerticalOverlap,
                                                    p_same_offset: offender.matchesLayoutShiftDelta ? 'all' : 'none'
                                                }
                                            };
                                        })
                                    };
                                }
                                result = {
                                    revision: this.revisionNo,
                                    clean: true,
                                    'metric:vc90': (_vcDetails$90$t = vcDetails === null || vcDetails === void 0 || (_vcDetails$ = vcDetails['90']) === null || _vcDetails$ === void 0 ? void 0 : _vcDetails$.t) !== null && _vcDetails$90$t !== void 0 ? _vcDetails$90$t : null,
                                    vcDetails: vcDetails !== null && vcDetails !== void 0 ? vcDetails : undefined,
                                    'vc90:ls': layoutShiftInsightsPayload !== null && layoutShiftInsightsPayload !== void 0 ? layoutShiftInsightsPayload : undefined
                                };
                                result.ratios = this.calculateRatios(filteredEntries);
                                if (ssrRatio !== -1) result.ssrRatio = ssrRatio;
                                // speedIndex is only included in the result when it has a meaningful value (> 0)
                                if (speedIndex > 0) result.speedIndex = speedIndex;
                                result.labelStacks = this.getLabelStacks(filteredEntries, isPostInteraction);
                                return _context2.abrupt("return", result);
                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function calculate(_x14) {
                    return _calculate.apply(this, arguments);
                }
                return calculate;
            }()
        }
    ]);
}();

});
parcelRegister("8xIjh", function(module, exports) {
$parcel$export(module.exports, "calculateTTVCPercentilesWithDebugInfo", () => $6383c6cef6f4c0d6$export$96ea73435089b05a);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $50U6m = parcelRequire("50U6m");

var $bscNB = parcelRequire("bscNB");

var $crtl5 = parcelRequire("crtl5");

var $6TWzQ = parcelRequire("6TWzQ");
function $6383c6cef6f4c0d6$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $6383c6cef6f4c0d6$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $6383c6cef6f4c0d6$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $6383c6cef6f4c0d6$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $6383c6cef6f4c0d6$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $6383c6cef6f4c0d6$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $6383c6cef6f4c0d6$var$calculateTTVCPercentiles(_x) {
    return $6383c6cef6f4c0d6$var$_calculateTTVCPercentiles.apply(this, arguments);
}
function $6383c6cef6f4c0d6$var$_calculateTTVCPercentiles() {
    $6383c6cef6f4c0d6$var$_calculateTTVCPercentiles = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_ref) {
        var viewport, orderedEntries, percentiles, startTime, canvas, elementMap, _iterator, _step, entry, rect, elementName, timePixelCounts, canvasDimenstions, totalPixels, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    viewport = _ref.viewport, orderedEntries = _ref.orderedEntries, percentiles = _ref.percentiles, startTime = _ref.startTime;
                    canvas = new (0, $6TWzQ.ViewportCanvas)(viewport, (0, $50U6m.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
                    elementMap = new Map();
                    _iterator = $6383c6cef6f4c0d6$var$_createForOfIteratorHelper(orderedEntries);
                    _context.prev = 1;
                    _iterator.s();
                case 2:
                    if ((_step = _iterator.n()).done) {
                        _context.next = 5;
                        break;
                    }
                    entry = _step.value;
                    if ('rect' in entry.data) {
                        _context.next = 3;
                        break;
                    }
                    return _context.abrupt("continue", 4);
                case 3:
                    rect = entry.data.rect;
                    elementName = entry.data.elementName;
                    canvas.drawRect(rect, entry.time);
                    if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
                    elementMap.get(entry.time).add(elementName);
                case 4:
                    _context.next = 2;
                    break;
                case 5:
                    _context.next = 7;
                    break;
                case 6:
                    _context.prev = 6;
                    _t = _context["catch"](1);
                    _iterator.e(_t);
                case 7:
                    _context.prev = 7;
                    _iterator.f();
                    return _context.finish(7);
                case 8:
                    _context.next = 9;
                    return canvas.getPixelCounts();
                case 9:
                    timePixelCounts = _context.sent;
                    canvasDimenstions = canvas.getScaledDimensions();
                    totalPixels = canvasDimenstions.width * canvasDimenstions.height;
                    return _context.abrupt("return", (0, $bscNB.calculatePercentiles)(timePixelCounts, elementMap, percentiles, totalPixels, startTime));
                case 10:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                1,
                6,
                7,
                8
            ]
        ]);
    }));
    return $6383c6cef6f4c0d6$var$_calculateTTVCPercentiles.apply(this, arguments);
}
function $6383c6cef6f4c0d6$export$96ea73435089b05a(_x2) {
    return $6383c6cef6f4c0d6$var$_calculateTTVCPercentilesWithDebugInfo.apply(this, arguments);
}
function $6383c6cef6f4c0d6$var$_calculateTTVCPercentilesWithDebugInfo() {
    $6383c6cef6f4c0d6$var$_calculateTTVCPercentilesWithDebugInfo = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_ref2) {
        var viewport, orderedEntries, startTime, canvas, elementMap, _iterator2, _step2, entry, rect, timePixelCounts, canvasDimensions, totalPixels, _t2;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    viewport = _ref2.viewport, orderedEntries = _ref2.orderedEntries, startTime = _ref2.startTime;
                    canvas = new (0, $6TWzQ.ViewportCanvas)(viewport, (0, $50U6m.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
                    elementMap = new Map();
                    _iterator2 = $6383c6cef6f4c0d6$var$_createForOfIteratorHelper(orderedEntries);
                    _context2.prev = 1;
                    _iterator2.s();
                case 2:
                    if ((_step2 = _iterator2.n()).done) {
                        _context2.next = 5;
                        break;
                    }
                    entry = _step2.value;
                    if ('rect' in entry.data) {
                        _context2.next = 3;
                        break;
                    }
                    return _context2.abrupt("continue", 4);
                case 3:
                    rect = entry.data.rect;
                    canvas.drawRect(rect, entry.time);
                    if (!elementMap.has(entry.time)) elementMap.set(entry.time, []);
                    elementMap.get(entry.time).push(entry.data);
                case 4:
                    _context2.next = 2;
                    break;
                case 5:
                    _context2.next = 7;
                    break;
                case 6:
                    _context2.prev = 6;
                    _t2 = _context2["catch"](1);
                    _iterator2.e(_t2);
                case 7:
                    _context2.prev = 7;
                    _iterator2.f();
                    return _context2.finish(7);
                case 8:
                    _context2.next = 9;
                    return canvas.getPixelCounts();
                case 9:
                    timePixelCounts = _context2.sent;
                    canvasDimensions = canvas.getScaledDimensions();
                    totalPixels = canvasDimensions.width * canvasDimensions.height;
                    return _context2.abrupt("return", (0, $crtl5.calculatePercentilesWithDebugInfo)(timePixelCounts, elementMap, totalPixels, startTime));
                case 10:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                1,
                6,
                7,
                8
            ]
        ]);
    }));
    return $6383c6cef6f4c0d6$var$_calculateTTVCPercentilesWithDebugInfo.apply(this, arguments);
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$6383c6cef6f4c0d6$export$2e2bcd8739ae039 = $6383c6cef6f4c0d6$var$calculateTTVCPercentiles;

});
parcelRegister("bscNB", function(module, exports) {
$parcel$export(module.exports, "calculatePercentiles", () => $856c3cdd1a14fa25$export$89c8da9b65eff678);

var $iYJcE = parcelRequire("iYJcE");
function $856c3cdd1a14fa25$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $856c3cdd1a14fa25$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $856c3cdd1a14fa25$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $856c3cdd1a14fa25$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $856c3cdd1a14fa25$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $856c3cdd1a14fa25$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $856c3cdd1a14fa25$export$89c8da9b65eff678(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    var results = {};
    var cumulativePixels = 0;
    var percentiles = unorderedPercentiles.sort(function(a, b) {
        return a - b;
    });
    // Sort entries by timestamp for consistent processing
    var sortedEntries = Array.from(timePixelCounts.entries()).sort(function(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), timeA = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), timeB = _ref4[0];
        return Number(timeA) - Number(timeB);
    });
    var percentileIndex = 0;
    var domElementsBuffer = new Set();
    var _iterator = $856c3cdd1a14fa25$var$_createForOfIteratorHelper(sortedEntries), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_step.value, 2), time = _step$value[0], pixelCount = _step$value[1];
            cumulativePixels += pixelCount;
            var percentCovered = cumulativePixels / totalPixels * 100;
            var elementNames = elementMap.get(time) || new Set();
            elementNames.forEach(function(elName) {
                return domElementsBuffer.add(elName);
            });
            var matchesAnyCheckpoints = false;
            while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
                results["".concat(percentiles[percentileIndex])] = {
                    t: Math.round(Number(time - startTime)),
                    e: Array.from(domElementsBuffer)
                };
                percentileIndex++;
                matchesAnyCheckpoints = true;
            }
            if (matchesAnyCheckpoints) domElementsBuffer.clear();
            if (percentileIndex >= percentiles.length) break;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var previousResult = {
        t: 0,
        e: []
    };
    for(var i = 0; i < percentiles.length; i++){
        var percentile = percentiles[i];
        if (!(percentile in results)) results["".concat(percentile)] = previousResult;
        previousResult = results["".concat(percentile)];
    }
    return results;
}

});

parcelRegister("crtl5", function(module, exports) {
$parcel$export(module.exports, "calculatePercentilesWithDebugInfo", () => $90eec3c39b63fb34$export$a532ce01ea38d882);

var $iYJcE = parcelRequire("iYJcE");
function $90eec3c39b63fb34$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime) {
    var entries = new Array(elementMap.size);
    var cumulativePixels = 0;
    var speedIndex = 0;
    var previousPercentCovered = 0;
    var sortedEntries = Array.from(timePixelCounts.entries()).sort(function(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), timeA = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), timeB = _ref4[0];
        return Number(timeA) - Number(timeB);
    });
    for(var i = 0; i < sortedEntries.length; i++){
        var _sortedEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(sortedEntries[i], 2), time = _sortedEntries$i[0], pixelCount = _sortedEntries$i[1];
        cumulativePixels += pixelCount;
        var percentCovered = cumulativePixels / totalPixels * 100;
        var entryDatas = elementMap.get(time) || [];
        var relativeTime = Math.round(Number(time - startTime));
        entries[i] = {
            time: relativeTime,
            viewportPercentage: percentCovered,
            entries: Array.from(entryDatas)
        };
        // Speed index calculation: sum of (time × incremental viewport percentage)
        var ratioDelta = (percentCovered - previousPercentCovered) / 100;
        speedIndex += relativeTime * ratioDelta;
        previousPercentCovered = percentCovered;
    }
    return {
        entries: entries,
        speedIndex: Math.round(speedIndex)
    };
}

});

parcelRegister("6TWzQ", function(module, exports) {
$parcel$export(module.exports, "ViewportCanvas", () => $506551522b0b92eb$export$3e59ac9de7402fb1);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $iNd5V = parcelRequire("iNd5V");

var $5hUuW = parcelRequire("5hUuW");
var $506551522b0b92eb$export$3e59ac9de7402fb1 = /*#__PURE__*/ function() {
    /** The underlying Canvas instance (either OffscreenCanvas or HTMLCanvasElement) */ /** The 2D rendering context of the canvas */ /** Scale factor applied to the canvas (affects final pixel counts) */ /** Maps unique colors to their corresponding timestamps */ /** Counter used to generate unique colors */ /**
   * Creates a new ViewportCanvas instance.
   * @param viewport - The dimensions of the viewport
   * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
   * @throws {Error} If canvas context cannot be obtained
   */ function ViewportCanvas(viewport) {
        var scaleFactor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ViewportCanvas);
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        var safeViewportWidth = Math.max(viewport.width, 1);
        var safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize canvas with scaled dimensions
        this.canvas = this.createCanvas(this.scaledWidth, this.scaledHeight);
        var ctx = this.canvas.getContext('2d', {
            alpha: false,
            // Disable alpha channel for better performance
            willReadFrequently: true,
            // Optimize for frequent pixel reading
            colorSpace: 'srgb' // Use standard RGB color space
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        this.ctx.imageSmoothingEnabled = false; // Disable image smoothing for better performance
        this.clear();
    }
    /**
   * Creates a canvas instance, falling back to HTMLCanvasElement if OffscreenCanvas is not available
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ViewportCanvas, [
        {
            key: "createCanvas",
            value: function createCanvas(width, height) {
                if (typeof OffscreenCanvas !== 'undefined') return new OffscreenCanvas(width, height);
                var canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                return canvas;
            }
        },
        {
            key: "getScaledDimensions",
            value: function getScaledDimensions() {
                return {
                    width: this.scaledWidth,
                    height: this.scaledHeight
                };
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            }
        },
        {
            key: "generateColor",
            value: function generateColor() {
                // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
                var rgbColor = this.colorCounter++ % 0x00ffffff;
                return (0, $5hUuW.getRGBComponents)(rgbColor);
            }
        },
        {
            key: "drawRect",
            value: function drawRect(rect, timestamp) {
                var color = this.generateColor();
                this.colorTimeMap.set(color, timestamp);
                this.ctx.fillStyle = color;
                if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
                var scaledX = rect.x * this.scaleX;
                var scaledY = rect.y * this.scaleY;
                var scaledWidth = rect.width * this.scaleX;
                var scaledHeight = rect.height * this.scaleY;
                this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
            }
        },
        {
            key: "getPixelCounts",
            value: function() {
                var _getPixelCounts = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
                    var imageData, timestampsAmount, pixelCounts, timePixelCounts, i, count, color, rgbColor, timestamp;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
                                timestampsAmount = this.colorTimeMap.size;
                                _context.next = 1;
                                return (0, $iNd5V.calculateDrawnPixelsRaw)(imageData, this.scaleFactor, timestampsAmount);
                            case 1:
                                pixelCounts = _context.sent;
                                // Convert color counts to timestamp counts
                                timePixelCounts = new Map();
                                i = 0;
                            case 2:
                                if (!(i < pixelCounts.length)) {
                                    _context.next = 5;
                                    break;
                                }
                                count = pixelCounts[i];
                                if (!(typeof count !== 'number')) {
                                    _context.next = 3;
                                    break;
                                }
                                return _context.abrupt("continue", 4);
                            case 3:
                                color = i + 1;
                                rgbColor = (0, $5hUuW.getRGBComponents)(color);
                                timestamp = this.colorTimeMap.get(rgbColor);
                                if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
                            case 4:
                                i++;
                                _context.next = 2;
                                break;
                            case 5:
                                return _context.abrupt("return", timePixelCounts);
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getPixelCounts() {
                    return _getPixelCounts.apply(this, arguments);
                }
                return getPixelCounts;
            }()
        }
    ]);
}();

});
parcelRegister("iNd5V", function(module, exports) {
$parcel$export(module.exports, "calculateDrawnPixelsRaw", () => $dae6f5e8a1e3e55a$export$fafc9be44839f9c8);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $NPpSV = parcelRequire("NPpSV");
function $dae6f5e8a1e3e55a$export$fafc9be44839f9c8(_x, _x2, _x3) {
    return $dae6f5e8a1e3e55a$var$_calculateDrawnPixelsRaw.apply(this, arguments);
}
function $dae6f5e8a1e3e55a$var$_calculateDrawnPixelsRaw() {
    $dae6f5e8a1e3e55a$var$_calculateDrawnPixelsRaw = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(imageData, _, arraySize) {
        var data, arr, i, color, colorIndex;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    data = imageData.data;
                    arr = new Uint32Array(arraySize);
                    i = 0;
                case 1:
                    if (!(i < data.length)) {
                        _context.next = 3;
                        break;
                    }
                    // Check alpha
                    if (data[i + 3] !== 0) {
                        // Combine RGB components into a single 24-bit color value:
                        // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
                        // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
                        // data[i + 2]       - Blue component stays as is         (bits 0-7)
                        // The | operator combines all bits together
                        color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
                        colorIndex = color - 1;
                        arr[colorIndex] = (arr[colorIndex] || 0) + 1;
                    }
                    if (!(i % 10000 === 0)) {
                        _context.next = 2;
                        break;
                    }
                    _context.next = 2;
                    return (0, $NPpSV.default)();
                case 2:
                    i += 4;
                    _context.next = 1;
                    break;
                case 3:
                    return _context.abrupt("return", arr);
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $dae6f5e8a1e3e55a$var$_calculateDrawnPixelsRaw.apply(this, arguments);
}

});
parcelRegister("NPpSV", function(module, exports) {
$parcel$export(module.exports, "default", () => $095c75f6938de339$export$2e2bcd8739ae039);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");
// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
function $095c75f6938de339$var$taskYield() {
    return $095c75f6938de339$var$_taskYield.apply(this, arguments);
}
function $095c75f6938de339$var$_taskYield() {
    $095c75f6938de339$var$_taskYield = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
        var resolve, p;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!('scheduler' in globalThis && // @ts-ignore
                    'yield' in globalThis.scheduler)) {
                        _context.next = 2;
                        break;
                    }
                    _context.next = 1;
                    return scheduler.yield();
                case 1:
                    return _context.abrupt("return");
                case 2:
                    resolve = function resolve() {};
                    p = new Promise(function(a) {
                        resolve = a;
                    });
                    setTimeout(resolve, 0);
                    _context.next = 3;
                    return p;
                case 3:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $095c75f6938de339$var$_taskYield.apply(this, arguments);
}
var $095c75f6938de339$export$2e2bcd8739ae039 = $095c75f6938de339$var$taskYield;

});


parcelRegister("5hUuW", function(module, exports) {
$parcel$export(module.exports, "getRGBComponents", () => $3d9a5da12e41fcd3$export$54591583ed0b20ce);
/**
 * Converts a number into RGB components in such a way that they can be recombined
 * to form the original number using bitwise operations.
 * @param number - The input number to be split into RGB components.
 * @returns The RGB color string in the format "rgb(r, g, b)".
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $3d9a5da12e41fcd3$export$54591583ed0b20ce(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    var blue = n & 0xff;
    // Extract green component (bits 8-15)
    var green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    var red = n >> 16 & 0xff;
    return "rgb(".concat(red, ", ").concat(green, ", ").concat(blue, ")");
}

});



parcelRegister("eybTT", function(module, exports) {
$parcel$export(module.exports, "detectLayoutShiftCause", () => $a97d78dfd31bfb03$export$93ce39b765ea2cd3);
function $a97d78dfd31bfb03$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $a97d78dfd31bfb03$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $a97d78dfd31bfb03$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $a97d78dfd31bfb03$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $a97d78dfd31bfb03$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $a97d78dfd31bfb03$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $a97d78dfd31bfb03$var$calculateOffenderState = function calculateOffenderState(current, matchesCurrentEntry) {
    // Once we know it's mixed across entries, we can short-circuit.
    if (current === 'some') return 'some';
    var entryState = matchesCurrentEntry ? 'all' : 'none';
    if (current == null) return entryState;
    // If the state flips between entries (all <-> none), it's "some".
    if (current !== entryState) return 'some';
    return current;
};
var $a97d78dfd31bfb03$var$calculateLayoutShiftMovement = function calculateLayoutShiftMovement(layoutShiftEntries) {
    var movements = layoutShiftEntries.map(function(lsEntry) {
        var rect = lsEntry.rect;
        var previousRect = lsEntry.previousRect;
        if (!rect || !previousRect) return null;
        var dx = rect.x - previousRect.x;
        var dy = rect.y - previousRect.y;
        return {
            dx: dx,
            dy: dy,
            movedX: dx !== 0,
            movedY: dy !== 0,
            dirX: Math.sign(dx),
            dirY: Math.sign(dy),
            absDx: Math.abs(dx),
            absDy: Math.abs(dy)
        };
    });
    var hasMovement = function hasMovement(m) {
        return m !== null;
    };
    var validMovements = movements.filter(hasMovement);
    var allHaveRects = layoutShiftEntries.length > 0 && validMovements.length === layoutShiftEntries.length;
    if (!allHaveRects) return {
        allHaveRects: allHaveRects,
        allMovedSameWay: false,
        allMovedSameAmount: false
    };
    var first = validMovements[0];
    var allMovedSameWay = validMovements.every(function(m) {
        return m.movedX === first.movedX && m.movedY === first.movedY && m.dirX === first.dirX && m.dirY === first.dirY;
    });
    var allMovedSameAmount = allMovedSameWay && validMovements.every(function(m) {
        return m.absDx === first.absDx && m.absDy === first.absDy;
    });
    return {
        allHaveRects: allHaveRects,
        allMovedSameWay: allMovedSameWay,
        allMovedSameAmount: allMovedSameAmount,
        deltaX: first.dx,
        deltaY: first.dy
    };
};
var $a97d78dfd31bfb03$export$93ce39b765ea2cd3 = function detectLayoutShiftCause(_ref) {
    var viewportEntries = _ref.viewportEntries, layoutShiftEntries = _ref.layoutShiftEntries, time = _ref.time, startTime = _ref.startTime, _ref$offenderWindowMs = _ref.offenderWindowMs, offenderWindowMs = _ref$offenderWindowMs === void 0 ? 250 : _ref$offenderWindowMs;
    var checkpointTimestamp = startTime + time;
    var filteredLSPotentialOffenders = viewportEntries.filter(function(viewportEntry) {
        return (viewportEntry.time < checkpointTimestamp && viewportEntry.time > checkpointTimestamp - offenderWindowMs || viewportEntry.time > checkpointTimestamp && viewportEntry.time < checkpointTimestamp + offenderWindowMs) && viewportEntry.data.type !== 'layout-shift';
    });
    // Summarize whether all layout-shift entries moved in a consistent direction and by the same amount.
    var layoutShiftVariables = $a97d78dfd31bfb03$var$calculateLayoutShiftMovement(layoutShiftEntries);
    // Classify each offender against *all* layout-shift entries when the layout shift is consistently moving in a
    // single axis (pure X or pure Y) so we can reason about whether an offender could have caused the movement.
    var layoutShiftOffenders = filteredLSPotentialOffenders.reduce(function(acc, offender) {
        var _offenderData$origina;
        var offenderData = offender.data;
        var offenderRect = offenderData.rect;
        if (!offenderRect) return acc;
        var offenderTimestamp = (_offenderData$origina = offenderData.originalMutationTimestamp) !== null && _offenderData$origina !== void 0 ? _offenderData$origina : offender.time;
        var happenedBefore = offenderTimestamp <= checkpointTimestamp;
        var offenderLeft = offenderRect.x;
        var offenderRight = offenderRect.x + offenderRect.width;
        var offenderTop = offenderRect.y;
        var offenderBottom = offenderRect.y + offenderRect.height;
        var shouldClassifyAgainstAllEntries = layoutShiftVariables.allMovedSameWay && 'deltaX' in layoutShiftVariables && 'deltaY' in layoutShiftVariables && layoutShiftVariables.deltaX === 0 !== (layoutShiftVariables.deltaY === 0);
        var isAbove = null;
        var isLeft = null;
        var isRight = null;
        var hasHorizontalOverlap = null;
        var hasVerticalOverlap = null;
        if (shouldClassifyAgainstAllEntries) {
            var _iterator = $a97d78dfd31bfb03$var$_createForOfIteratorHelper(layoutShiftEntries), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var lsEntry = _step.value;
                    var lsRect = lsEntry.rect;
                    if (!lsRect) continue;
                    var lsLeft = lsRect.x;
                    var lsRight = lsRect.x + lsRect.width;
                    var lsTop = lsRect.y;
                    var lsBottom = lsRect.y + lsRect.height;
                    isAbove = $a97d78dfd31bfb03$var$calculateOffenderState(isAbove, offenderBottom <= lsTop);
                    isLeft = $a97d78dfd31bfb03$var$calculateOffenderState(isLeft, offenderRight <= lsLeft);
                    isRight = $a97d78dfd31bfb03$var$calculateOffenderState(isRight, offenderLeft >= lsRight);
                    hasHorizontalOverlap = $a97d78dfd31bfb03$var$calculateOffenderState(hasHorizontalOverlap, offenderLeft < lsRight && offenderRight > lsLeft);
                    hasVerticalOverlap = $a97d78dfd31bfb03$var$calculateOffenderState(hasVerticalOverlap, offenderTop < lsBottom && offenderBottom > lsTop);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
        var matchesLayoutShiftDelta = false;
        if (shouldClassifyAgainstAllEntries && layoutShiftVariables.allMovedSameAmount && offenderData.previousRect) {
            var dx = offenderRect.x - offenderData.previousRect.x;
            var dy = offenderRect.y - offenderData.previousRect.y;
            var isPureX = layoutShiftVariables.deltaX !== 0 && layoutShiftVariables.deltaY === 0;
            var isPureY = layoutShiftVariables.deltaY !== 0 && layoutShiftVariables.deltaX === 0;
            if (isPureX) matchesLayoutShiftDelta = dx === layoutShiftVariables.deltaX && dy === 0;
            else if (isPureY) matchesLayoutShiftDelta = dy === layoutShiftVariables.deltaY && dx === 0;
        }
        acc.push({
            offender: offenderData.elementName,
            happenedBefore: happenedBefore,
            distanceToLS: Math.round(offenderTimestamp - checkpointTimestamp),
            isAbove: isAbove !== null && isAbove !== void 0 ? isAbove : 'none',
            isLeft: isLeft !== null && isLeft !== void 0 ? isLeft : 'none',
            isRight: isRight !== null && isRight !== void 0 ? isRight : 'none',
            hasHorizontalOverlap: hasHorizontalOverlap !== null && hasHorizontalOverlap !== void 0 ? hasHorizontalOverlap : 'none',
            hasVerticalOverlap: hasVerticalOverlap !== null && hasVerticalOverlap !== void 0 ? hasVerticalOverlap : 'none',
            matchesLayoutShiftDelta: matchesLayoutShiftDelta
        });
        return acc;
    }, []);
    return {
        layoutShiftVariables: layoutShiftVariables,
        layoutShiftOffenders: layoutShiftOffenders
    };
};

});

parcelRegister("6q4aZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ac86919702752bd$export$2e2bcd8739ae039);
function $4ac86919702752bd$var$getViewportHeight() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (_unused) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
var $4ac86919702752bd$export$2e2bcd8739ae039 = $4ac86919702752bd$var$getViewportHeight;

});

parcelRegister("ilLDJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5bf246fabb1814e$export$2e2bcd8739ae039);
function $d5bf246fabb1814e$var$getViewportWidth() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (_unused) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
var $d5bf246fabb1814e$export$2e2bcd8739ae039 = $d5bf246fabb1814e$var$getViewportWidth;

});

parcelRegister("8WpTJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $6827d450c38b3264$export$2e2bcd8739ae039);
function $6827d450c38b3264$var$isViewportEntryData(data) {
    if (data) {
        var hasElementName = typeof data.elementName === 'string';
        var hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}
var $6827d450c38b3264$export$2e2bcd8739ae039 = $6827d450c38b3264$var$isViewportEntryData;

});


parcelRegister("jW9Uy", function(module, exports) {
$parcel$export(module.exports, "KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS", () => $e83b1f443d455089$export$98812f4e79596e2b);
$parcel$export(module.exports, "NON_VISUAL_ARIA_ATTRIBUTES", () => $e83b1f443d455089$export$44331555a87fcd9e);
$parcel$export(module.exports, "THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES", () => $e83b1f443d455089$export$c4351da6279bef53);
$parcel$export(module.exports, "MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES", () => $e83b1f443d455089$export$2492353b2cc31cc0);
$parcel$export(module.exports, "DARK_READER_BROWSER_EXTENSION_ATTRIBUTES", () => $e83b1f443d455089$export$5a7b359ee5e32a5b);
// TODO: AFO-3523
// Those are the attributes we have found when testing the 'fy25.03' manually.
// We still need to replace this hardcoded list with a proper automation
var $e83b1f443d455089$export$98812f4e79596e2b = [
    'data-drop-target-for-element',
    'data-drop-target-for-external',
    'draggable',
    'data-is-observed',
    'data-aui-version',
    'data-testid',
    'data-vc',
    'data-ssr-placeholder',
    'data-ssr-placeholder-replace',
    'data-vc-nvs',
    'data-media-vc-wrapper',
    'data-renderer-start-pos',
    'data-table-local-id',
    'spellcheck',
    'data-auto-scrollable',
    'id',
    'tabindex',
    'data-is-ttvc-ready',
    'contenteditable',
    'data-has-collab-initialised',
    'translate',
    'data-comment-id',
    'data-access-level'
];
var $e83b1f443d455089$export$44331555a87fcd9e = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-hidden',
    'aria-expanded',
    'aria-controls',
    'aria-selected',
    'aria-checked',
    'aria-disabled',
    'aria-required',
    'aria-current',
    'aria-haspopup',
    'aria-pressed',
    'aria-atomic',
    'aria-live'
];
var $e83b1f443d455089$export$c4351da6279bef53 = [
    'bis_skin_checked',
    'cz-shortcut-listen',
    'monica-version',
    'data-gr-ext-installed',
    'data-dashlane-rid',
    'sapling-installed',
    'data-gptw',
    // grammarly extensions
    'data-new-gr-c-s-loaded',
    'data-gr-aaa-notch-connection-id',
    'data-gr-aaa-loaded'
];
var $e83b1f443d455089$export$2492353b2cc31cc0 = [
    'fdprocessedid',
    'data-dashlane-classification'
];
var $e83b1f443d455089$export$5a7b359ee5e32a5b = [
    // dark reader extension
    'data-darkreader-inline-bgcolor',
    'data-darkreader-inline-bgimage',
    'data-darkreader-inline-border',
    'data-darkreader-inline-border-bottom',
    'data-darkreader-inline-border-left',
    'data-darkreader-inline-border-right',
    'data-darkreader-inline-border-top',
    'data-darkreader-inline-boxshadow',
    'data-darkreader-inline-color',
    'data-darkreader-inline-fill',
    'data-darkreader-inline-stroke',
    'data-darkreader-inline-outline',
    'data-darkreader-inline-stopcolor',
    'data-darkreader-inline-bg',
    'data-darkreader-inline-border-short',
    'data-darkreader-inline-border-bottom-short',
    'data-darkreader-inline-border-left-short',
    'data-darkreader-inline-border-right-short',
    'data-darkreader-inline-border-top-short'
];

});


parcelRegister("5LGgH", function(module, exports) {
$parcel$export(module.exports, "default", () => $433221249648d55f$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $50U6m = parcelRequire("50U6m");

var $k98NJ = parcelRequire("k98NJ");

var $jW9Uy = parcelRequire("jW9Uy");
function $433221249648d55f$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $433221249648d55f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $433221249648d55f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($433221249648d55f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $433221249648d55f$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $433221249648d55f$var$getConsideredEntryTypes = function getConsideredEntryTypes() {
    var consideredEntryTypes = [
        'mutation:display-contents-children-element'
    ];
    consideredEntryTypes.push('mutation:display-contents-children-attribute');
    return consideredEntryTypes;
};
var $433221249648d55f$var$getExcludedEntryTypes = function getExcludedEntryTypes() {
    var excludedEntryTypes = [
        'layout-shift:same-rect',
        'mutation:attribute:non-visual-input-name'
    ];
    return excludedEntryTypes;
};
var $433221249648d55f$var$fy26_04_excluded_attributes = [
    'data-is-hovered' // non-visual attribute
];
var $433221249648d55f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_VCCalculator_FY25_) {
    function VCCalculator_FY26_04() {
        var revisionNo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'fy26.04';
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, VCCalculator_FY26_04);
        return $433221249648d55f$var$_callSuper(this, VCCalculator_FY26_04, [
            revisionNo
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(VCCalculator_FY26_04, _VCCalculator_FY25_);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(VCCalculator_FY26_04, [
        {
            key: "isEntryIncluded",
            value: function isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
                var extra_fy26_04_excluded_attributes = [
                    'data-fabric-mode'
                ];
                var entryData = entry.data;
                var attributeName = entryData.attributeName;
                if (entry.data.type === 'mutation:attribute' && attributeName && extra_fy26_04_excluded_attributes.includes(attributeName)) return false;
                var isEntryIncludedInV3 = $433221249648d55f$var$_superPropGet(VCCalculator_FY26_04, "isEntryIncluded", this, 3)([
                    entry,
                    include3p,
                    excludeSmartAnswersInSearch
                ]);
                if (isEntryIncludedInV3 && !$433221249648d55f$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
                if (entry.data.type === 'mutation:attribute' && (!attributeName || $433221249648d55f$var$fy26_04_excluded_attributes.includes(attributeName) && (0, $50U6m.fg)('platform_ufo_data-is-hovered-v4-exclusion'))) return false;
                var thirdPartyAttributes = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((0, $jW9Uy.THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES)), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((0, $jW9Uy.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES)), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((0, $50U6m.fg)('platform_ufo_exclude_fdprocessedid_attribute') ? (0, $jW9Uy.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES) : []));
                if (entryData.type === 'mutation:display-contents-children-attribute') {
                    if (!attributeName || attributeName.startsWith('data-test') || (0, $jW9Uy.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(attributeName) || (0, $jW9Uy.NON_VISUAL_ARIA_ATTRIBUTES).includes(attributeName) || thirdPartyAttributes.includes(attributeName)) return false;
                    return true;
                }
                return $433221249648d55f$var$getConsideredEntryTypes().includes(entry.data.type);
            }
        }
    ]);
}((0, $k98NJ.default));

});

parcelRegister("aCyje", function(module, exports) {
$parcel$export(module.exports, "default", () => $7bb811123029ca3c$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $5LGgH = parcelRequire("5LGgH");
function $7bb811123029ca3c$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $7bb811123029ca3c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $7bb811123029ca3c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7bb811123029ca3c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $7bb811123029ca3c$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $7bb811123029ca3c$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize',
    'scroll-container'
];
var $7bb811123029ca3c$var$getConsideredEntryTypes = function getConsideredEntryTypes() {
    var consideredEntryTypes = [];
    return consideredEntryTypes;
};
var $7bb811123029ca3c$var$getExcludedEntryTypes = function getExcludedEntryTypes() {
    var excludedEntryTypes = [];
    return excludedEntryTypes;
};
var $7bb811123029ca3c$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_VCCalculator_FY26_) {
    function VCCalculator_Next() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, VCCalculator_Next);
        return $7bb811123029ca3c$var$_callSuper(this, VCCalculator_Next, [
            'next'
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(VCCalculator_Next, _VCCalculator_FY26_);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(VCCalculator_Next, [
        {
            key: "isEntryIncluded",
            value: function isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
                var isEntryIncludedInV4 = $7bb811123029ca3c$var$_superPropGet(VCCalculator_Next, "isEntryIncluded", this, 3)([
                    entry,
                    include3p,
                    excludeSmartAnswersInSearch
                ]);
                if (isEntryIncludedInV4 && !$7bb811123029ca3c$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
                return $7bb811123029ca3c$var$getConsideredEntryTypes().includes(entry.data.type);
            }
        },
        {
            key: "getVCCleanStatus",
            value: function getVCCleanStatus(filteredEntries) {
                var dirtyReason = '';
                var abortTimestamp = -1;
                var hasAbortEvent = filteredEntries.some(function(entry) {
                    if (entry.data.type === 'window:event') {
                        var data = entry.data;
                        var eventType = data.eventType;
                        if ($7bb811123029ca3c$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                            if (eventType === 'keydown') dirtyReason = 'keypress';
                            else if (eventType === 'scroll-container') dirtyReason = 'scroll';
                            else dirtyReason = eventType;
                            abortTimestamp = Math.round(entry.time);
                            return true;
                        }
                    }
                    return false;
                });
                if (hasAbortEvent && dirtyReason) return {
                    isVCClean: false,
                    dirtyReason: dirtyReason,
                    abortTimestamp: abortTimestamp
                };
                return {
                    isVCClean: true
                };
            }
        }
    ]);
}((0, $5LGgH.default));

});

parcelRegister("gk0Pa", function(module, exports) {
$parcel$export(module.exports, "default", () => $be1f274a5c05d4bf$export$2e2bcd8739ae039);

var $1Vcia = parcelRequire("1Vcia");

var $fC8ib = parcelRequire("fC8ib");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $rHZri = parcelRequire("rHZri");

var $9DHn2 = parcelRequire("9DHn2");

var $6q4aZ = parcelRequire("6q4aZ");

var $ilLDJ = parcelRequire("ilLDJ");
var $be1f274a5c05d4bf$var$_excluded = [
    "att"
];
function $be1f274a5c05d4bf$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $be1f274a5c05d4bf$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $be1f274a5c05d4bf$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $be1f274a5c05d4bf$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $be1f274a5c05d4bf$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $be1f274a5c05d4bf$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $be1f274a5c05d4bf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $be1f274a5c05d4bf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $be1f274a5c05d4bf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $be1f274a5c05d4bf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $be1f274a5c05d4bf$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
var $be1f274a5c05d4bf$var$MAX_OBSERVATIONS = 200;
var $be1f274a5c05d4bf$var$encodeRect = function encodeRect(rect) {
    return [
        Math.round(rect.left * 10) / 10,
        Math.round(rect.top * 10) / 10,
        Math.round(rect.right * 10) / 10,
        Math.round(rect.bottom * 10) / 10
    ];
};
var $be1f274a5c05d4bf$var$areRectsEqual = function areRectsEqual(left, right) {
    return left.every(function(value, index) {
        return value === right[index];
    });
};
function $be1f274a5c05d4bf$var$isWindowEventEntryData(data) {
    return data.type === 'window:event' && 'eventType' in data;
}
var $be1f274a5c05d4bf$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function RawDataHandler() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, RawDataHandler);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "revisionNo", 'raw-handler');
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(RawDataHandler, [
        {
            key: "getVCCleanStatus",
            value: function getVCCleanStatus(filteredEntries) {
                var dirtyReason = '';
                var abortTimestamp = -1;
                var hasAbortEvent = filteredEntries.some(function(entry) {
                    if (entry.data.type === 'window:event') {
                        var data = entry.data;
                        var eventType = data.eventType;
                        if ($be1f274a5c05d4bf$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                            dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                            abortTimestamp = Math.round(entry.time);
                            return true;
                        }
                    }
                    return false;
                });
                if (hasAbortEvent && dirtyReason) return {
                    isVCClean: false,
                    dirtyReason: dirtyReason,
                    abortTimestamp: abortTimestamp
                };
                return {
                    isVCClean: true
                };
            }
        },
        {
            key: "getRawData",
            value: function() {
                var _getRawData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_ref) {
                    var entries, startTime, stopTime, isPageVisible, isVCClean, dirtyReason, getVCCleanStatusResult, _getEarliestHiddenTim, viewportEntries, windowEventEntries, targetNameToIdMap, elementMapEntriesMap, nextElementId, typeMap, typeMapEntriesMap, nextTypeId, attributeMap, attributeEntriesMap, nextAttributeId, eventTypeMap, eventTypeMapEntriesMap, nextEventTypeId, labelStacksMap, rawObservations, rawEventObservations, shouldTrimEventObservations, shouldTrimViewportObservations, firstEventObservation, lastEventObservations, firstObservation, lastObservations, ssrEid, ssrObservation, ssrAlreadyIncluded, referencedEids, referencedChgs, referencedAtts, referencedEvts, referencedEventTargetEids, _iterator, _step, observation, _iterator2, _step2, _observation, _iterator3, _step3, eid, _iterator4, _step4, chg, _iterator5, _step5, att, _iterator6, _step6, evt, isFedrampScrubbed, scrubbedObservations, result;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                entries = _ref.entries, startTime = _ref.startTime, stopTime = _ref.stopTime, isPageVisible = _ref.isPageVisible;
                                getVCCleanStatusResult = this.getVCCleanStatus(entries);
                                isVCClean = getVCCleanStatusResult.isVCClean;
                                dirtyReason = getVCCleanStatusResult.dirtyReason;
                                if (isPageVisible) {
                                    _context.next = 1;
                                    break;
                                }
                                return _context.abrupt("return", {
                                    revision: this.revisionNo,
                                    clean: false,
                                    'metric:vc90': null,
                                    abortReason: 'browser_backgrounded',
                                    abortTimestamp: (_getEarliestHiddenTim = (0, $9DHn2.getEarliestHiddenTiming)(startTime, stopTime)) !== null && _getEarliestHiddenTim !== void 0 ? _getEarliestHiddenTim : -1,
                                    viewport: {
                                        w: (0, $ilLDJ.default)(),
                                        h: (0, $6q4aZ.default)()
                                    }
                                });
                            case 1:
                                viewportEntries = entries.filter(function(entry) {
                                    return entry.time >= startTime && entry.time <= stopTime && entry.data && entry.data.visible;
                                });
                                windowEventEntries = entries.filter(function(entry) {
                                    return entry.time >= startTime && entry.time <= stopTime && entry.data && $be1f274a5c05d4bf$var$isWindowEventEntryData(entry.data);
                                });
                                targetNameToIdMap = new Map();
                                elementMapEntriesMap = {};
                                nextElementId = 1;
                                typeMap = new Map();
                                typeMapEntriesMap = {};
                                nextTypeId = 1;
                                attributeMap = new Map();
                                attributeEntriesMap = {};
                                nextAttributeId = 1;
                                eventTypeMap = new Map();
                                eventTypeMapEntriesMap = {};
                                nextEventTypeId = 1;
                                labelStacksMap = {};
                                rawObservations = viewportEntries.map(function(entry) {
                                    var viewportEntry = entry.data;
                                    var targetName = viewportEntry.elementName || '';
                                    var type = viewportEntry.type || '';
                                    var rect = viewportEntry.rect;
                                    var attributeName = viewportEntry.attributeName || '';
                                    var eid = targetNameToIdMap.get(viewportEntry.elementName || '') || 0;
                                    if (eid === 0) {
                                        eid = nextElementId;
                                        nextElementId += 1;
                                        targetNameToIdMap.set(targetName, eid);
                                        elementMapEntriesMap[eid] = targetName;
                                    }
                                    // Capture labelStacks per element (only stored once per unique element)
                                    if (viewportEntry.labelStacks && !(eid in labelStacksMap)) {
                                        var labelInfo = {
                                            s: viewportEntry.labelStacks.segment,
                                            l: viewportEntry.labelStacks.labelStack
                                        };
                                        var shouldCompactImplicitUnknown = labelInfo.s === 'unknown' && labelInfo.l === 'unknown';
                                        labelStacksMap[eid] = shouldCompactImplicitUnknown ? 'u' : labelInfo;
                                    }
                                    var chg = typeMap.get(type || '') || 0;
                                    if (chg === 0) {
                                        chg = nextTypeId;
                                        nextTypeId += 1;
                                        typeMap.set(type, chg);
                                        typeMapEntriesMap[chg] = type;
                                    }
                                    var att = 0;
                                    if (attributeName) {
                                        att = attributeMap.get(attributeName) || 0;
                                        if (att === 0) {
                                            att = nextAttributeId;
                                            nextAttributeId += 1;
                                            attributeMap.set(attributeName, att);
                                            attributeEntriesMap[att] = attributeName;
                                        }
                                    }
                                    var encodedRect = $be1f274a5c05d4bf$var$encodeRect(rect);
                                    var encodedPreviousRect = viewportEntry.previousRect ? $be1f274a5c05d4bf$var$encodeRect(viewportEntry.previousRect) : null;
                                    var shouldIncludePreviousRect = encodedPreviousRect === null || !$be1f274a5c05d4bf$var$areRectsEqual(encodedRect, encodedPreviousRect);
                                    var observation = $be1f274a5c05d4bf$var$_objectSpread($be1f274a5c05d4bf$var$_objectSpread({
                                        t: Math.round(entry.time - startTime),
                                        r: encodedRect
                                    }, shouldIncludePreviousRect ? {
                                        pr: encodedPreviousRect
                                    } : {}), {}, {
                                        chg: chg,
                                        eid: eid || 0
                                    }, att > 0 ? {
                                        att: att
                                    } : {});
                                    return observation;
                                });
                                rawEventObservations = windowEventEntries.map(function(entry) {
                                    var windowEventEntry = entry.data;
                                    var eventType = windowEventEntry.eventType;
                                    var evtId = eventTypeMap.get(eventType) || 0;
                                    if (evtId === 0) {
                                        evtId = nextEventTypeId;
                                        nextEventTypeId += 1;
                                        eventTypeMap.set(eventType, evtId);
                                        eventTypeMapEntriesMap[evtId] = eventType;
                                    }
                                    var eventTargetId = 0;
                                    var eventTargetName = windowEventEntry.elementName || '';
                                    if (eventTargetName) {
                                        eventTargetId = targetNameToIdMap.get(eventTargetName) || 0;
                                        if (eventTargetId === 0) {
                                            eventTargetId = nextElementId;
                                            nextElementId += 1;
                                            targetNameToIdMap.set(eventTargetName, eventTargetId);
                                            elementMapEntriesMap[eventTargetId] = eventTargetName;
                                        }
                                    }
                                    var eventObservation = $be1f274a5c05d4bf$var$_objectSpread({
                                        t: Math.round(entry.time - startTime),
                                        evt: evtId
                                    }, eventTargetId > 0 ? {
                                        eid: eventTargetId
                                    } : {});
                                    return eventObservation;
                                });
                                shouldTrimEventObservations = rawEventObservations.length > $be1f274a5c05d4bf$var$MAX_OBSERVATIONS;
                                shouldTrimViewportObservations = rawObservations.length > $be1f274a5c05d4bf$var$MAX_OBSERVATIONS; // If the number of event observations is greater than the maximum allowed, we need to trim the event observations to the maximum allowed.
                                // We do this by keeping the first observation and the last MAX_OBSERVATIONS observations.
                                if (shouldTrimEventObservations) {
                                    firstEventObservation = rawEventObservations[0];
                                    lastEventObservations = rawEventObservations.slice(-$be1f274a5c05d4bf$var$MAX_OBSERVATIONS);
                                    rawEventObservations = [
                                        firstEventObservation
                                    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(lastEventObservations));
                                }
                                // If the number of observations is greater than the maximum allowed, we need to trim the observations to the maximum allowed.
                                // We do this by keeping the first observation, the SSR observation (if present), and the last MAX_OBSERVATIONS observations.
                                if (shouldTrimViewportObservations) {
                                    firstObservation = rawObservations[0];
                                    lastObservations = rawObservations.slice(-$be1f274a5c05d4bf$var$MAX_OBSERVATIONS); // Find the SSR observation by looking up the eid that corresponds to 'SSR' element name
                                    ssrEid = targetNameToIdMap.get('SSR');
                                    ssrObservation = ssrEid ? rawObservations.find(function(obs) {
                                        return obs.eid === ssrEid && obs !== firstObservation;
                                    }) : undefined; // Include SSR observation if it exists and is not already in the kept observations
                                    ssrAlreadyIncluded = ssrObservation && lastObservations.some(function(obs) {
                                        return obs === ssrObservation;
                                    });
                                    rawObservations = [
                                        firstObservation
                                    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(ssrObservation && !ssrAlreadyIncluded ? [
                                        ssrObservation
                                    ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(lastObservations));
                                }
                                if (shouldTrimViewportObservations || shouldTrimEventObservations) {
                                    // Collect referenced IDs from final retained observations. Keep this inside the trim
                                    // guard so the common untrimmed path avoids extra Set allocations and scans.
                                    referencedEids = new Set();
                                    referencedChgs = new Set();
                                    referencedAtts = new Set();
                                    referencedEvts = new Set();
                                    referencedEventTargetEids = new Set();
                                    _iterator = $be1f274a5c05d4bf$var$_createForOfIteratorHelper(rawObservations);
                                    try {
                                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                                            observation = _step.value;
                                            if (observation.eid > 0) referencedEids.add(observation.eid);
                                            if (typeof observation.chg === 'number' && observation.chg > 0) referencedChgs.add(observation.chg);
                                            if (observation.att !== undefined && observation.att > 0) referencedAtts.add(observation.att);
                                        }
                                    } catch (err) {
                                        _iterator.e(err);
                                    } finally{
                                        _iterator.f();
                                    }
                                    _iterator2 = $be1f274a5c05d4bf$var$_createForOfIteratorHelper(rawEventObservations);
                                    try {
                                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                            _observation = _step2.value;
                                            if (_observation.evt > 0) referencedEvts.add(_observation.evt);
                                            if (_observation.eid !== undefined && _observation.eid > 0) referencedEventTargetEids.add(_observation.eid);
                                        }
                                    } catch (err) {
                                        _iterator2.e(err);
                                    } finally{
                                        _iterator2.f();
                                    }
                                    _iterator3 = $be1f274a5c05d4bf$var$_createForOfIteratorHelper(Object.keys(elementMapEntriesMap).map(Number));
                                    try {
                                        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                            eid = _step3.value;
                                            if (!referencedEids.has(eid) && !referencedEventTargetEids.has(eid)) {
                                                delete elementMapEntriesMap[eid];
                                                delete labelStacksMap[eid];
                                            }
                                        }
                                    } catch (err) {
                                        _iterator3.e(err);
                                    } finally{
                                        _iterator3.f();
                                    }
                                    if (shouldTrimViewportObservations) {
                                        _iterator4 = $be1f274a5c05d4bf$var$_createForOfIteratorHelper(Object.keys(typeMapEntriesMap).map(Number));
                                        try {
                                            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                                chg = _step4.value;
                                                if (!referencedChgs.has(chg)) delete typeMapEntriesMap[chg];
                                            }
                                        } catch (err) {
                                            _iterator4.e(err);
                                        } finally{
                                            _iterator4.f();
                                        }
                                        _iterator5 = $be1f274a5c05d4bf$var$_createForOfIteratorHelper(Object.keys(attributeEntriesMap).map(Number));
                                        try {
                                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                                att = _step5.value;
                                                if (!referencedAtts.has(att)) delete attributeEntriesMap[att];
                                            }
                                        } catch (err) {
                                            _iterator5.e(err);
                                        } finally{
                                            _iterator5.f();
                                        }
                                    }
                                    if (shouldTrimEventObservations) {
                                        // Event type map cleanup is only needed when event observations were trimmed.
                                        // If only viewport observations were trimmed, all event observations remain and
                                        // therefore every event type ID in the map is still referenced.
                                        _iterator6 = $be1f274a5c05d4bf$var$_createForOfIteratorHelper(Object.keys(eventTypeMapEntriesMap).map(Number));
                                        try {
                                            for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                                                evt = _step6.value;
                                                if (!referencedEvts.has(evt)) delete eventTypeMapEntriesMap[evt];
                                            }
                                        } catch (err) {
                                            _iterator6.e(err);
                                        } finally{
                                            _iterator6.f();
                                        }
                                    }
                                }
                                // FedRAMP-Moderate scrubbing.
                                //
                                // In commercial environments the raw-handler payload includes:
                                //   - `rawData.att` / `obs[].att`  → DOM attribute names from
                                //     `MutationRecord.attributeName`. These are *names* (not values),
                                //     but custom product attributes can in principle embed
                                //     identifiers (e.g. `data-user-{id}-state`).
                                //   - `rawData.lbl`                → UFO labelStacks. Generally
                                //     curated product paths but in poorly-instrumented call sites
                                //     could embed dynamic identifiers.
                                //
                                // Server-side TTVC reconstruction does not require these fields
                                // (it is driven by timestamps, rectangles, and mutation kind),
                                // so dropping them in FedRAMP is safe and removes residual PII risk.
                                isFedrampScrubbed = (0, $rHZri.isFedrampOverrideActive)();
                                scrubbedObservations = isFedrampScrubbed ? rawObservations.map(function(_ref2) {
                                    var _att = _ref2.att, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $be1f274a5c05d4bf$var$_excluded);
                                    return rest;
                                }) : rawObservations;
                                result = {
                                    revision: this.revisionNo,
                                    clean: isVCClean,
                                    'metric:vc90': null,
                                    rawData: {
                                        obs: scrubbedObservations !== null && scrubbedObservations !== void 0 ? scrubbedObservations : undefined,
                                        eid: elementMapEntriesMap !== null && elementMapEntriesMap !== void 0 ? elementMapEntriesMap : undefined,
                                        chg: typeMapEntriesMap !== null && typeMapEntriesMap !== void 0 ? typeMapEntriesMap : undefined,
                                        att: isFedrampScrubbed ? undefined : attributeEntriesMap !== null && attributeEntriesMap !== void 0 ? attributeEntriesMap : undefined,
                                        evts: rawEventObservations.length > 0 ? rawEventObservations : undefined,
                                        evt: Object.keys(eventTypeMapEntriesMap).length > 0 ? eventTypeMapEntriesMap : undefined,
                                        lbl: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? labelStacksMap : undefined,
                                        lblMode: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? 'sentinel-v1' : undefined
                                    },
                                    abortReason: dirtyReason,
                                    abortTimestamp: getVCCleanStatusResult.abortTimestamp,
                                    viewport: {
                                        w: (0, $ilLDJ.default)(),
                                        h: (0, $6q4aZ.default)()
                                    }
                                };
                                return _context.abrupt("return", result);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getRawData(_x) {
                    return _getRawData.apply(this, arguments);
                }
                return getRawData;
            }()
        }
    ]);
}();

});

parcelRegister("immZA", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5dc1de3005c0795$export$2e2bcd8739ae039);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $50U6m = parcelRequire("50U6m");

var $buzIJ = parcelRequire("buzIJ");

var $5C5YK = parcelRequire("5C5YK");

var $2Dn2q = parcelRequire("2Dn2q");

var $7qdyA = parcelRequire("7qdyA");

var $1RYQD = parcelRequire("1RYQD");

var $eTpQp = parcelRequire("eTpQp");

var $hON7O = parcelRequire("hON7O");

var $loGoN = parcelRequire("loGoN");

var $eet9p = parcelRequire("eet9p");

var $eEoV1 = parcelRequire("eEoV1");

var $gr4nx = parcelRequire("gr4nx");

var $d4wOE = parcelRequire("d4wOE");

var $d7jnl = parcelRequire("d7jnl");

var $gGEEm = parcelRequire("gGEEm");

var $fCtGI = parcelRequire("fCtGI");

var $4GZDD = parcelRequire("4GZDD");
function $d5dc1de3005c0795$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $d5dc1de3005c0795$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $d5dc1de3005c0795$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $d5dc1de3005c0795$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $d5dc1de3005c0795$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $d5dc1de3005c0795$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $d5dc1de3005c0795$var$createElementMutationsWatcher = function createElementMutationsWatcher(removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler) {
    return function(_ref) {
        var target = _ref.target, rect = _ref.rect;
        if (getSSRState) {
            var ssrState = getSSRState();
            var SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return 'ssr-hydration';
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return 'ssr-hydration';
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            var ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return 'mutation:ssr-placeholder';
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return 'mutation:ssr-placeholder';
            }
        }
        if (hasSameDeletedNode && (0, $d7jnl.default)(target)) return 'mutation:remount';
        if ((0, $buzIJ.isContainedWithinMediaWrapper)(target)) return 'mutation:media';
        if (isWithinThirdPartySegment) return 'mutation:third-party-element';
        if (isWithinGenAISegment) return 'mutation:gen-ai-element';
        if (isWithinSmartAnswersSegment) return 'mutation:smart-answers-element';
        var isInIgnoreLsMarker = (0, $d7jnl.default)(target);
        if (!isInIgnoreLsMarker) return 'mutation:element';
        var isRLLPlaceholder = (0, $1RYQD.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return 'mutation:rll-placeholder';
        var wasDeleted = removedNodeRects.some(function(nr) {
            return (0, $fCtGI.isSameRectDimensions)(nr, rect);
        });
        if (wasDeleted && isInIgnoreLsMarker) return 'mutation:element-replacement';
        return 'mutation:element';
    };
};
var $d5dc1de3005c0795$var$createElementMutationsWatcherNew = function createElementMutationsWatcherNew(removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler) {
    return function(_ref2) {
        var target = _ref2.target, rect = _ref2.rect;
        if (getSSRState) {
            var ssrState = getSSRState();
            var SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            var ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
        }
        if (hasSameDeletedNode && (0, $d7jnl.default)(target)) return {
            type: 'mutation:remount',
            mutationData: {
                timestamp: timestamp
            }
        };
        if ((0, $buzIJ.isContainedWithinMediaWrapper)(target)) return {
            type: 'mutation:media',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinThirdPartySegment) return {
            type: 'mutation:third-party-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinGenAISegment) return {
            type: 'mutation:gen-ai-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinSmartAnswersSegment) return {
            type: 'mutation:smart-answers-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        var isInIgnoreLsMarker = (0, $d7jnl.default)(target);
        if (!isInIgnoreLsMarker) return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
        var isRLLPlaceholder = (0, $1RYQD.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return {
            type: 'mutation:rll-placeholder',
            mutationData: {
                timestamp: timestamp
            }
        };
        var wasDeleted = removedNodeRects.some(function(nr) {
            return (0, $fCtGI.isSameRectDimensions)(nr, rect);
        });
        if (wasDeleted && isInIgnoreLsMarker) return {
            type: 'mutation:element-replacement',
            mutationData: {
                timestamp: timestamp
            }
        };
        return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
    };
};
var $d5dc1de3005c0795$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    // SSR context functions
    function ViewportObserver(_ref3) {
        var _this = this;
        var onChange = _ref3.onChange, getSSRState = _ref3.getSSRState, getSSRPlaceholderHandler = _ref3.getSSRPlaceholderHandler, _ref3$trackLayoutShif = _ref3.trackLayoutShiftOffenders, trackLayoutShiftOffenders = _ref3$trackLayoutShif === void 0 ? false : _ref3$trackLayoutShif, searchPageConfig = _ref3.searchPageConfig;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ViewportObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "handleIntersectionEntry", function(_ref4) {
            var target = _ref4.target, rect = _ref4.rect, time = _ref4.time, type = _ref4.type, mutationData = _ref4.mutationData;
            if (!target) return;
            var visible = (0, $d4wOE.isElementVisible)(target);
            var lastElementRect = _this.mapVisibleNodeRects.get(target);
            _this.mapVisibleNodeRects.set(target, rect);
            _this.onChange({
                time: time,
                type: type,
                elementRef: new WeakRef(target),
                visible: visible,
                rect: rect,
                previousRect: lastElementRect,
                mutationData: mutationData
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "handleChildListMutation", /*#__PURE__*/ function() {
            var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_ref5) {
                var target, addedNodes, removedNodes, timestamp, removedNodeRects, targetNode, _iterator, _step, _loop, _t;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            target = _ref5.target, addedNodes = _ref5.addedNodes, removedNodes = _ref5.removedNodes, timestamp = _ref5.timestamp;
                            removedNodeRects = removedNodes.map(function(ref) {
                                var n = ref.deref();
                                if (!n) return;
                                return _this.mapVisibleNodeRects.get(n);
                            });
                            targetNode = target.deref();
                            _iterator = $d5dc1de3005c0795$var$_createForOfIteratorHelper(addedNodes);
                            _context2.prev = 1;
                            _loop = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _loop() {
                                var _this$getSSRState, _this$intersectionObs;
                                var addedNodeRef, addedNode, hasSameDeletedNode, _checkWithinComponent, isWithinThirdPartySegment, _checkWithinComponent2, isWithinGenAISegment, isWithinSmartAnswersSegment, isTargetReactRoot;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                                    while(true)switch(_context.prev = _context.next){
                                        case 0:
                                            addedNodeRef = _step.value;
                                            addedNode = addedNodeRef.deref();
                                            if (addedNode) {
                                                _context.next = 1;
                                                break;
                                            }
                                            return _context.abrupt("return", 1);
                                        case 1:
                                            hasSameDeletedNode = removedNodes.find(function(ref) {
                                                var n = ref.deref();
                                                if (!n || !addedNode) return false;
                                                return n.isEqualNode(addedNode);
                                            });
                                            _checkWithinComponent = (0, $eet9p.default)(addedNode, 'UFOThirdPartySegment', _this.mapIs3pResult), isWithinThirdPartySegment = _checkWithinComponent.isWithin;
                                            _checkWithinComponent2 = (0, $eet9p.default)(addedNode, 'UFOGenAISegment', _this.mapIsGenAIResult), isWithinGenAISegment = _checkWithinComponent2.isWithin;
                                            isWithinSmartAnswersSegment = Boolean(_this.shouldCheckSmartAnswersMutations() && (0, $gr4nx.isContainedWithinSmartAnswers)(addedNode));
                                            isTargetReactRoot = targetNode === ((_this$getSSRState = _this.getSSRState) === null || _this$getSSRState === void 0 || (_this$getSSRState = _this$getSSRState.call(_this)) === null || _this$getSSRState === void 0 ? void 0 : _this$getSSRState.reactRootElement);
                                            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.watchAndTag(addedNode, (_this.trackLayoutShiftOffenders ? $d5dc1de3005c0795$var$createElementMutationsWatcherNew : $d5dc1de3005c0795$var$createElementMutationsWatcher)(removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, !!hasSameDeletedNode, timestamp, isTargetReactRoot, _this.getSSRState, _this.getSSRPlaceholderHandler));
                                        case 2:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _loop);
                            });
                            _iterator.s();
                        case 2:
                            if ((_step = _iterator.n()).done) {
                                _context2.next = 5;
                                break;
                            }
                            return _context2.delegateYield(_loop(), "t0", 3);
                        case 3:
                            if (!_context2.t0) {
                                _context2.next = 4;
                                break;
                            }
                            return _context2.abrupt("continue", 4);
                        case 4:
                            _context2.next = 2;
                            break;
                        case 5:
                            _context2.next = 7;
                            break;
                        case 6:
                            _context2.prev = 6;
                            _t = _context2["catch"](1);
                            _iterator.e(_t);
                        case 7:
                            _context2.prev = 7;
                            _iterator.f();
                            return _context2.finish(7);
                        case 8:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        6,
                        7,
                        8
                    ]
                ]);
            }));
            return function(_x) {
                return _ref6.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "handleAttributeMutation", function(_ref7) {
            var _this$intersectionObs2;
            var target = _ref7.target, attributeName = _ref7.attributeName, oldValue = _ref7.oldValue, newValue = _ref7.newValue, timestamp = _ref7.timestamp;
            (_this$intersectionObs2 = _this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.watchAndTag(target, function(_ref8) {
                var target = _ref8.target, rect = _ref8.rect;
                if ((0, $buzIJ.isContainedWithinMediaWrapper)(target)) return {
                    type: 'mutation:media',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                var _checkWithinComponent3 = (0, $eet9p.default)(target, 'UFOThirdPartySegment', _this.mapIs3pResult), isWithinThirdPartySegment = _checkWithinComponent3.isWithin;
                var _checkWithinComponent4 = (0, $eet9p.default)(target, 'UFOGenAISegment', _this.mapIsGenAIResult), isWithinGenAISegment = _checkWithinComponent4.isWithin;
                if (isWithinThirdPartySegment) return {
                    type: 'mutation:third-party-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if (isWithinGenAISegment) return {
                    type: 'mutation:gen-ai-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if (_this.shouldCheckSmartAnswersMutations() && (0, $gr4nx.isContainedWithinSmartAnswers)(target)) return {
                    type: 'mutation:smart-answers-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, $5C5YK.default)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $2Dn2q.default)({
                    target: target,
                    attributeName: attributeName,
                    type: 'attributes'
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                // Pragmatic Drag and Drop attributes added during post-paint
                // registration; do not affect layout or paint.
                if ((0, $7qdyA.default)({
                    target: target,
                    attributeName: attributeName
                }) && (0, $50U6m.fg)('platform_ufo_exclude_pdnd_attributes_from_vc')) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $gGEEm.isInputNameMutation)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-input-name',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                var isRLLPlaceholder = (0, $1RYQD.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
                if (isRLLPlaceholder) return {
                    type: 'mutation:rll-placeholder',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                var lastElementRect = _this.mapVisibleNodeRects.get(target);
                if (lastElementRect && (0, $4GZDD.isSameRectSize)(rect, lastElementRect)) return {
                    type: 'mutation:attribute:no-layout-shift',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                return {
                    type: 'mutation:attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "handleLayoutShift", function(_ref9) {
            var time = _ref9.time, changedRects = _ref9.changedRects;
            var _iterator2 = $d5dc1de3005c0795$var$_createForOfIteratorHelper(changedRects), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var changedRect = _step2.value;
                    var target = changedRect.node;
                    if (target) {
                        var isSameCurrentAndPreviousRects = (0, $fCtGI.isSameRectDimensions)(changedRect.rect, changedRect.previousRect);
                        _this.onChange({
                            time: time,
                            elementRef: new WeakRef(target),
                            visible: true,
                            rect: changedRect.rect,
                            previousRect: changedRect.previousRect,
                            type: isSameCurrentAndPreviousRects ? 'layout-shift:same-rect' : 'layout-shift'
                        });
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "shouldCheckSmartAnswersMutations", function() {
            var _this$searchPageConfi, _this$searchPageConfi2, _window;
            return ((_this$searchPageConfi = _this.searchPageConfig) === null || _this$searchPageConfi === void 0 ? void 0 : _this$searchPageConfi.enableSmartAnswersMutations) && ((_this$searchPageConfi2 = _this.searchPageConfig) === null || _this$searchPageConfi2 === void 0 ? void 0 : _this$searchPageConfi2.searchPageRoute) && ((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.pathname) && window.location.pathname === _this.searchPageConfig.searchPageRoute;
        });
        this.mapVisibleNodeRects = new WeakMap();
        this.mapIs3pResult = new WeakMap();
        this.mapIsGenAIResult = new WeakMap();
        this.onChange = onChange;
        this.isStarted = false;
        this.intersectionObserver = null;
        this.mutationObserver = null;
        this.performanceObserver = null;
        this.trackLayoutShiftOffenders = trackLayoutShiftOffenders;
        // Initialize SSR context functions
        this.getSSRState = getSSRState;
        this.getSSRPlaceholderHandler = getSSRPlaceholderHandler;
        this.searchPageConfig = searchPageConfig;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ViewportObserver, [
        {
            key: "initializeObservers",
            value: function initializeObservers() {
                if (this.isStarted) return;
                this.intersectionObserver = (0, $eTpQp.createIntersectionObserver)({
                    onEntry: this.handleIntersectionEntry
                });
                this.mutationObserver = (0, $hON7O.default)({
                    onChildListMutation: this.handleChildListMutation,
                    onAttributeMutation: this.handleAttributeMutation
                });
                this.performanceObserver = (0, $loGoN.default)({
                    onLayoutShift: this.handleLayoutShift
                });
            }
        },
        {
            key: "start",
            value: function start() {
                var _this$mutationObserve, _this$performanceObse;
                if (this.isStarted) return;
                this.initializeObservers();
                (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
                    attributeOldValue: true,
                    attributes: true,
                    childList: true,
                    subtree: true
                });
                (_this$performanceObse = this.performanceObserver) === null || _this$performanceObse === void 0 || _this$performanceObse.observe({
                    type: 'layout-shift',
                    buffered: true,
                    // @ts-ignore -error
                    durationThreshold: 30
                });
                this.isStarted = true;
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$mutationObserve2, _this$intersectionObs3, _this$performanceObse2;
                if (!this.isStarted) return;
                (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
                (_this$intersectionObs3 = this.intersectionObserver) === null || _this$intersectionObs3 === void 0 || _this$intersectionObs3.disconnect();
                (_this$performanceObse2 = this.performanceObserver) === null || _this$performanceObse2 === void 0 || _this$performanceObse2.disconnect();
                this.isStarted = false;
                // Clean up caches when stopping
                (0, $eEoV1.cleanupCaches)(this.mapIs3pResult);
            }
        }
    ]);
}();

});
parcelRegister("7qdyA", function(module, exports) {
$parcel$export(module.exports, "default", () => $56757a3e8042b510$export$2e2bcd8739ae039);
/**
 * Attributes that Pragmatic Drag and Drop adds via `setAttribute` during its
 * post-paint registration step. They are used purely for hit testing and
 * registration bookkeeping, and do not affect layout, paint, or visible
 * styling, so they are safe to ignore for VC measurement.
 *
 * Drop target attributes follow `data-drop-target-for-<typeKey>` and are
 * handled by the prefix below (covers shipped and custom adapters).
 */ var $56757a3e8042b510$export$bcd335ae574a0717 = new Set([
    // @atlaskit/pragmatic-drag-and-drop (core)
    'draggable',
    // Honey pot lives on a transient element; included for completeness.
    'data-pdnd-honey-pot',
    // @atlaskit/pragmatic-drag-and-drop-auto-scroll
    'data-auto-scrollable',
    // @atlaskit/pragmatic-drag-and-drop/react-beautiful-dnd-migration
    'data-rbd-draggable-droppable-id',
    'data-rbd-draggable-index',
    'data-rbd-droppable-type',
    'data-rbd-droppable-direction',
    'data-rbd-droppable-id',
    'data-rbd-droppable-context-id',
    'data-rbd-style-context-id'
]);
var $56757a3e8042b510$export$846396c2d8be3710 = 'data-drop-target-for-';
function $56757a3e8042b510$export$2e2bcd8739ae039(_ref) {
    var target = _ref.target, attributeName = _ref.attributeName;
    if (!(target instanceof Element)) return false;
    if (!attributeName) return false;
    if ($56757a3e8042b510$export$bcd335ae574a0717.has(attributeName)) return true;
    if (attributeName.startsWith($56757a3e8042b510$export$846396c2d8be3710)) return true;
    return false;
}

});

parcelRegister("eTpQp", function(module, exports) {
$parcel$export(module.exports, "createIntersectionObserver", () => $ad7a3fe649bd1117$export$c3799d33e0ae80a5);

var $8C13h = parcelRequire("8C13h");
function $ad7a3fe649bd1117$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $ad7a3fe649bd1117$export$c3799d33e0ae80a5(_ref) {
    var onEntry = _ref.onEntry, onObserved = _ref.onObserved;
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    var callbacksPerElement = new WeakMap();
    var intersectionObserverCallback = function intersectionObserverCallback(entries) {
        var validEntries = [];
        var startTime = performance.now();
        entries.forEach(function(entry) {
            if (!(entry.target instanceof HTMLElement)) return;
            var tagOrCallback = callbacksPerElement.get(entry.target);
            if ((0, $8C13h.isZeroDimensionRectangle)(entry.intersectionRect)) {
                var zeroDimensionRectangleTagCallback = function zeroDimensionRectangleTagCallback(props) {
                    var tagOrCallbackResult = typeof tagOrCallback === 'function' ? tagOrCallback(props) : tagOrCallback;
                    // override as display-contents mutation
                    if (tagOrCallbackResult === 'mutation:element') return 'mutation:display-contents-children-element';
                    // override as display-contents mutation
                    if (tagOrCallbackResult && typeof tagOrCallbackResult !== 'string' && tagOrCallbackResult.type === 'mutation:attribute' && 'oldValue' in tagOrCallbackResult.mutationData) {
                        var _tagOrCallbackResult$ = tagOrCallbackResult.mutationData, attributeName = _tagOrCallbackResult$.attributeName, oldValue = _tagOrCallbackResult$.oldValue, newValue = _tagOrCallbackResult$.newValue;
                        var isRoutingMutation = attributeName === 'style' && (!oldValue && newValue === 'display: none !important;' || oldValue === 'display: none !important;' && !newValue);
                        if (isRoutingMutation) return {
                            type: 'mutation:attribute:framework-routing',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                        return {
                            type: 'mutation:display-contents-children-attribute',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                    }
                    return tagOrCallbackResult;
                };
                for(var _i = 0, _Array$from = Array.from(entry.target.children); _i < _Array$from.length; _i++){
                    var child = _Array$from[_i];
                    observer.observe(child);
                    callbacksPerElement.set(child, zeroDimensionRectangleTagCallback);
                }
                return;
            }
            if (!$ad7a3fe649bd1117$var$isValidEntry(entry)) return;
            var mutationTag = null;
            var mutationData = null;
            if (typeof tagOrCallback === 'function') {
                var tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag !== null && mutationTag !== void 0 ? mutationTag : 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved === null || onObserved === void 0 || onObserved({
            time: startTime,
            elements: validEntries
        });
    };
    var observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: function disconnect() {
            observer.disconnect();
        },
        unobserve: function unobserve(target) {
            observer.unobserve(target);
        },
        watchAndTag: function watchAndTag(target, tagOrCallback) {
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}

});
parcelRegister("8C13h", function(module, exports) {
$parcel$export(module.exports, "isZeroDimensionRectangle", () => $6452b03591d688dc$export$80d6b07c2266a1c6);
function $6452b03591d688dc$export$80d6b07c2266a1c6(rect) {
    return rect.bottom === 0 && rect.top === 0 && rect.left === 0 && rect.right === 0 && rect.x === 0 && rect.y === 0 && rect.width === 0 && rect.height === 0;
}

});


parcelRegister("hON7O", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf8d3665dd4d837b$export$2e2bcd8739ae039);

var $fRIsY = parcelRequire("fRIsY");
function $cf8d3665dd4d837b$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $cf8d3665dd4d837b$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $cf8d3665dd4d837b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $cf8d3665dd4d837b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $cf8d3665dd4d837b$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $cf8d3665dd4d837b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
// Batched mutation data for performance optimization
function $cf8d3665dd4d837b$var$createMutationObserver(_ref) {
    var onAttributeMutation = _ref.onAttributeMutation, onChildListMutation = _ref.onChildListMutation, onMutationFinished = _ref.onMutationFinished;
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    var mutationObserverCallback = function mutationObserverCallback(mutations) {
        var targets = [];
        // Use nested Maps for O(1) batching performance
        // Short-lived Maps are safe since they're discarded after each callback
        var batchedMutations = new Map();
        var _iterator = $cf8d3665dd4d837b$var$_createForOfIteratorHelper(mutations), _step;
        try {
            var _loop = function _loop() {
                var mut = _step.value;
                if (!(mut.target instanceof HTMLElement)) return 0; // continue
                if ((0, $fRIsY.expVal)('cc_editor_vc_exclude_flags', 'isEnabled', false)) {
                    // Intended for excluding out of band mutations such as tooltips on hover, and page flags
                    // Currently being tested in Confluence
                    // Skip elements with data-vc-oob attribute
                    if (mut.target.dataset.vcOob) return {
                        v: void 0
                    };
                }
                if (mut.type === 'attributes') {
                    var _mut$oldValue;
                    /*
            	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
            	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
            	Conceptually there is after all a mutation: there is an old value replaced with a new one,
            	and whether or not they are the same doesn't really matter.
            	And Custom elements should work the same way as MutationObserver."
            	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
            */ var oldValue = (_mut$oldValue = mut.oldValue) !== null && _mut$oldValue !== void 0 ? _mut$oldValue : undefined;
                    var newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                    if (oldValue !== newValue) {
                        var _mut$attributeName;
                        onAttributeMutation({
                            target: mut.target,
                            attributeName: (_mut$attributeName = mut.attributeName) !== null && _mut$attributeName !== void 0 ? _mut$attributeName : 'unknown',
                            oldValue: oldValue,
                            newValue: newValue,
                            timestamp: mut.timestamp || performance.now()
                        });
                    }
                    return 0; // continue
                } else if (mut.type === 'childList') {
                    var _mut$addedNodes, _mut$removedNodes;
                    // In chromium browser MutationRecord has timestamp field, which we should use.
                    var timestamp = Math.round(mut.timestamp || performance.now());
                    // Get or create timestamp bucket
                    var timestampBucket = batchedMutations.get(timestamp);
                    if (!timestampBucket) {
                        timestampBucket = new Map();
                        batchedMutations.set(timestamp, timestampBucket);
                    }
                    // Get or create target batch within timestamp bucket
                    var batch = timestampBucket.get(mut.target);
                    if (!batch) {
                        batch = {
                            target: new WeakRef(mut.target),
                            addedNodes: [],
                            removedNodes: [],
                            timestamp: timestamp
                        };
                        timestampBucket.set(mut.target, batch);
                    }
                    // Accumulate added nodes
                    ((_mut$addedNodes = mut.addedNodes) !== null && _mut$addedNodes !== void 0 ? _mut$addedNodes : []).forEach(function(node) {
                        if (node instanceof HTMLElement) batch.addedNodes.push(new WeakRef(node));
                    });
                    // Accumulate removed nodes
                    ((_mut$removedNodes = mut.removedNodes) !== null && _mut$removedNodes !== void 0 ? _mut$removedNodes : []).forEach(function(node) {
                        if (node instanceof HTMLElement) batch.removedNodes.push(new WeakRef(node));
                    });
                }
                targets.push(mut.target);
            }, _ret;
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                _ret = _loop();
                if (_ret === 0) continue;
                if (_ret) return _ret.v;
            }
        // Process all batched childList mutations
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        var _iterator2 = $cf8d3665dd4d837b$var$_createForOfIteratorHelper(batchedMutations.values()), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var timestampBucket = _step2.value;
                var _iterator3 = $cf8d3665dd4d837b$var$_createForOfIteratorHelper(timestampBucket.values()), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var batch = _step3.value;
                        onChildListMutation({
                            target: batch.target,
                            addedNodes: batch.addedNodes,
                            removedNodes: batch.removedNodes,
                            timestamp: batch.timestamp
                        });
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        onMutationFinished === null || onMutationFinished === void 0 || onMutationFinished({
            targets: targets
        });
    };
    var observer = new MutationObserver(mutationObserverCallback);
    return observer;
}
var $cf8d3665dd4d837b$export$2e2bcd8739ae039 = $cf8d3665dd4d837b$var$createMutationObserver;

});

parcelRegister("loGoN", function(module, exports) {
$parcel$export(module.exports, "default", () => $f93cba6e42897569$export$2e2bcd8739ae039);

var $eekrg = parcelRequire("eekrg");
function $f93cba6e42897569$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $f93cba6e42897569$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $f93cba6e42897569$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f93cba6e42897569$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f93cba6e42897569$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $f93cba6e42897569$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $f93cba6e42897569$var$createPerformanceObserver(_ref) {
    var onLayoutShift = _ref.onLayoutShift;
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    var performanceObserverCallback = function performanceObserverCallback(entries) {
        var _iterator = $f93cba6e42897569$var$_createForOfIteratorHelper(entries.getEntries()), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var entry = _step.value;
                if (entry.entryType === 'layout-shift' && 'sources' in entry) {
                    // see https://developer.mozilla.org/en-US/docs/Web/API/LayoutShiftAttribution for more info
                    var changedRects = entry.sources.reduceRight(function(acc, attr) {
                        acc.push({
                            rect: (0, $eekrg.convertPhysicalToLogicalResolution)(attr.currentRect),
                            previousRect: (0, $eekrg.convertPhysicalToLogicalResolution)(attr.previousRect),
                            node: attr.node
                        });
                        return acc;
                    }, []);
                    onLayoutShift({
                        time: entry.startTime,
                        changedRects: changedRects
                    });
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
    var observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$f93cba6e42897569$export$2e2bcd8739ae039 = $f93cba6e42897569$var$createPerformanceObserver;

});
parcelRegister("eekrg", function(module, exports) {
$parcel$export(module.exports, "convertPhysicalToLogicalResolution", () => $a5c23a2fae20fffa$export$5e3f54cad8cb65e2);
// The LayoutShiftAttribution API is returning the numbers on physical dimension
function $a5c23a2fae20fffa$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}

});


parcelRegister("eet9p", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5c8fc35e423f46c$export$2e2bcd8739ae039);

var $50U6m = parcelRequire("50U6m");

var $4g5L8 = parcelRequire("4g5L8");

var $4hKKo = parcelRequire("4hKKo");

var $l2Dde = parcelRequire("l2Dde");

var $eEoV1 = parcelRequire("eEoV1");

var $lyUKH = parcelRequire("lyUKH");
var $a5c8fc35e423f46c$var$OLD_DOM_WALK_MAX_LEVEL = 40;
var $a5c8fc35e423f46c$var$OLD_FIBER_WALK_MAX_LEVEL = 40;
var $a5c8fc35e423f46c$var$NEW_DOM_WALK_MAX_LEVEL = 400;
var $a5c8fc35e423f46c$var$NEW_FIBER_WALK_MAX_LEVEL = 400;
var $a5c8fc35e423f46c$var$CLEANUP_THRESHOLD = 50;
function $a5c8fc35e423f46c$var$maybeCleanup(resultCache) {
    (0, $4hKKo.cacheCleanupState).callCount++;
    if ((0, $4hKKo.cacheCleanupState).callCount >= $a5c8fc35e423f46c$var$CLEANUP_THRESHOLD && (0, $4g5L8.default)(0.3)) (0, $eEoV1.cleanupCaches)(resultCache);
}
function $a5c8fc35e423f46c$export$2e2bcd8739ae039(node, targetComponentName, resultCache) {
    $a5c8fc35e423f46c$var$maybeCleanup(resultCache);
    if (resultCache.has(node)) {
        var _resultCache$get;
        return {
            isWithin: (_resultCache$get = resultCache.get(node)) !== null && _resultCache$get !== void 0 ? _resultCache$get : false
        };
    }
    var checkedNodes = [];
    var shouldUseBumpedWalkLevels = (0, $50U6m.fg)('ufo-bump-walk-levels');
    var DOM_WALK_MAX_LEVEL = shouldUseBumpedWalkLevels ? $a5c8fc35e423f46c$var$NEW_DOM_WALK_MAX_LEVEL : $a5c8fc35e423f46c$var$OLD_DOM_WALK_MAX_LEVEL;
    var FIBER_WALK_MAX_LEVEL = shouldUseBumpedWalkLevels ? $a5c8fc35e423f46c$var$NEW_FIBER_WALK_MAX_LEVEL : $a5c8fc35e423f46c$var$OLD_FIBER_WALK_MAX_LEVEL;
    // Always use cached fiber strategy to handle non-React elements reliably
    var _findFiberWithCache = (0, $lyUKH.default)(node, DOM_WALK_MAX_LEVEL, checkedNodes, shouldUseBumpedWalkLevels ? resultCache : undefined), fiber = _findFiberWithCache.fiber, cachedResult = _findFiberWithCache.cachedResult;
    if (cachedResult !== undefined) {
        checkedNodes.forEach(function(checkedNode) {
            resultCache.set(checkedNode, cachedResult);
        });
        return {
            isWithin: cachedResult
        };
    }
    if (!fiber) {
        checkedNodes.forEach(function(checkedNode) {
            resultCache.set(checkedNode, false);
        });
        return {
            isWithin: false
        };
    }
    var isWithin = (0, $l2Dde.default)(fiber, targetComponentName, FIBER_WALK_MAX_LEVEL);
    checkedNodes.forEach(function(checkedNode) {
        resultCache.set(checkedNode, isWithin);
    });
    return {
        isWithin: isWithin
    };
}

});
parcelRegister("4hKKo", function(module, exports) {
$parcel$export(module.exports, "cacheCleanupState", () => $31ed02fdf3d7e722$export$2d67c094e7802413);
var $31ed02fdf3d7e722$export$2d67c094e7802413 = {
    callCount: 0
};

});

parcelRegister("l2Dde", function(module, exports) {
$parcel$export(module.exports, "default", () => $f51833a5803b8c5e$export$2e2bcd8739ae039);

var $h2ewz = parcelRequire("h2ewz");
function $f51833a5803b8c5e$export$2e2bcd8739ae039(fiber, targetComponentName, maxLevel) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return false;
    if (!fiber) return false;
    var componentName = (0, $h2ewz.default)(fiber);
    if (componentName === targetComponentName) return true;
    // Recursively traverse up the fiber tree
    return $f51833a5803b8c5e$export$2e2bcd8739ae039(fiber.return, targetComponentName, maxLevel - 1);
}

});
parcelRegister("h2ewz", function(module, exports) {
$parcel$export(module.exports, "default", () => $c66de3d1cfac56dd$export$2e2bcd8739ae039);

var $ekGgq = parcelRequire("ekGgq");
function $c66de3d1cfac56dd$export$2e2bcd8739ae039(fiber) {
    var type = fiber === null || fiber === void 0 ? void 0 : fiber.type;
    if (!type) return undefined;
    if (typeof type === 'function' || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(type) === 'object') return type.displayName || type.name;
    return undefined;
}

});


parcelRegister("eEoV1", function(module, exports) {
$parcel$export(module.exports, "cleanupCaches", () => $aaa821756c194c8e$export$6a35c3789c327630);

var $4hKKo = parcelRequire("4hKKo");
function $aaa821756c194c8e$export$6a35c3789c327630(resultCache) {
    resultCache = new WeakMap();
    (0, $4hKKo.cacheCleanupState).callCount = 0;
    return resultCache;
}

});

parcelRegister("lyUKH", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb28cbc24175dc49$export$2e2bcd8739ae039);

var $9CM5f = parcelRequire("9CM5f");
function $fb28cbc24175dc49$export$2e2bcd8739ae039(element, maxLevel, checkedNodes, resultCache) {
    var currentElement = element;
    var remainingLevels = maxLevel;
    while(currentElement && remainingLevels > 0){
        var cachedResult = resultCache === null || resultCache === void 0 ? void 0 : resultCache.get(currentElement);
        if (cachedResult !== undefined) return {
            fiber: null,
            cachedResult: cachedResult
        };
        checkedNodes.push(currentElement);
        var fiber = (0, $9CM5f.default)(currentElement);
        if (fiber) return {
            fiber: fiber
        };
        currentElement = currentElement.parentElement;
        remainingLevels--;
    }
    return {
        fiber: null
    };
}

});
parcelRegister("9CM5f", function(module, exports) {
$parcel$export(module.exports, "default", () => $701cf613cfe08e15$export$2e2bcd8739ae039);
// Helper function to find React fiber on an element
function $701cf613cfe08e15$export$2e2bcd8739ae039(element) {
    // Use for...in loop instead of Object.keys().find() to avoid creating an array
    for(var key in element){
        if (key.startsWith('__reactFiber$') || key.startsWith('__reactInternalInstance$')) return element[key];
    }
    return null;
}

});



parcelRegister("gr4nx", function(module, exports) {
$parcel$export(module.exports, "isContainedWithinSmartAnswers", () => $bf7290717f6a0e58$export$16c2770458939f21);

var $lFhdZ = parcelRequire("lFhdZ");
function $bf7290717f6a0e58$export$16c2770458939f21(node) {
    var doc = (0, $lFhdZ.getDocument)();
    if (!doc) return false;
    var smartAnswersElement = doc.getElementById('search-page-smart-answers');
    if (!smartAnswersElement) return false;
    // When the node is the smart answer element, .contains() still returns true
    return smartAnswersElement.contains(node);
}

});

parcelRegister("d4wOE", function(module, exports) {
$parcel$export(module.exports, "isElementVisible", () => $98451aa8c053b22f$export$e989c0fffaa6b27a);
function $98451aa8c053b22f$export$e989c0fffaa6b27a(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        var visible = element.checkVisibility({
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch (_unused) {
        // there is no support for checkVisibility
        return true;
    }
}

});

parcelRegister("d7jnl", function(module, exports) {
$parcel$export(module.exports, "default", () => $98caf5679faaf648$export$2e2bcd8739ae039);
/**
 * Check if the element is in the VC ignore if no layout shift marker.
 * @param element - The element to check.
 * @returns True if the element has the data-vc-ignore-if-no-layout-shift attribute == 'true or its parent has it, false otherwise.
 */ function $98caf5679faaf648$export$2e2bcd8739ae039(element) {
    if (!element) return false;
    return element.getAttribute('data-vc-ignore-if-no-layout-shift') === 'true' || $98caf5679faaf648$export$2e2bcd8739ae039(element.parentElement);
}

});

parcelRegister("gGEEm", function(module, exports) {
$parcel$export(module.exports, "isInputNameMutation", () => $c26019cdd00f679c$export$80a5724ceedcfd3d);
// Detecting this is required due to a React/Chromium bug, where React itself triggers an attribute mutation for input elements
// Reference: https://atlassian.slack.com/archives/C08EK6TCUP6/p1764129900970719
function $c26019cdd00f679c$export$80a5724ceedcfd3d(_ref) {
    var target = _ref.target, attributeName = _ref.attributeName, oldValue = _ref.oldValue, newValue = _ref.newValue;
    return target instanceof HTMLInputElement && attributeName === 'name' && (oldValue === '' || newValue === '');
}

});

parcelRegister("fCtGI", function(module, exports) {
$parcel$export(module.exports, "isSameRectDimensions", () => $b5f16f06ef0516bd$export$fde63bc968551821);
var $b5f16f06ef0516bd$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $b5f16f06ef0516bd$export$fde63bc968551821(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $b5f16f06ef0516bd$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $b5f16f06ef0516bd$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.x - b.x) <= $b5f16f06ef0516bd$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.y - b.y) <= $b5f16f06ef0516bd$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});

parcelRegister("4GZDD", function(module, exports) {
$parcel$export(module.exports, "isSameRectSize", () => $36aae5b82389b10e$export$597b41700f7dcd36);
var $36aae5b82389b10e$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $36aae5b82389b10e$export$597b41700f7dcd36(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $36aae5b82389b10e$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $36aae5b82389b10e$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});


parcelRegister("54Hqn", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b1f02adf2aa2cf3$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $7QpUe = parcelRequire("7QpUe");
var $3b1f02adf2aa2cf3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function WindowEventObserver(opts) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, WindowEventObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "unbindFns", []);
        this.onEvent = opts.onEvent;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(WindowEventObserver, [
        {
            key: "bindEvent",
            value: function bindEvent(type) {
                var _this = this;
                var unbindCallback = (0, $7QpUe.bind)(window, {
                    type: type,
                    listener: function listener(event) {
                        if (!event.isTrusted) return;
                        _this.onEvent({
                            time: event.timeStamp,
                            type: type,
                            event: event
                        });
                    },
                    options: {
                        passive: true,
                        once: true
                    }
                });
                this.unbindFns.push(unbindCallback);
            }
        },
        {
            key: "bindCaptureScrollEvent",
            value: function bindCaptureScrollEvent() {
                var _this2 = this;
                var unbindCallback = (0, $7QpUe.bind)(document, {
                    type: 'scroll',
                    listener: function listener(event) {
                        if (!event.isTrusted) return;
                        _this2.onEvent({
                            time: event.timeStamp,
                            type: 'scroll-container',
                            event: event
                        });
                    },
                    options: {
                        capture: true,
                        passive: true,
                        once: true
                    }
                });
                this.unbindFns.push(unbindCallback);
            }
        },
        {
            key: "start",
            value: function start() {
                this.bindEvent('wheel');
                this.bindEvent('scroll');
                this.bindEvent('keydown');
                this.bindEvent('resize');
                this.bindCaptureScrollEvent();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.unbindFns.forEach(function(cb) {
                    cb();
                });
                this.unbindFns = [];
            }
        }
    ]);
}();

});




parcelRegister("3Ammo", function(module, exports) {
$parcel$export(module.exports, "interactions", () => $29c614266a937c8a$export$cc97b17ef9aeb088);
var $29c614266a937c8a$export$cc97b17ef9aeb088 = new Map();

});

parcelRegister("cik7q", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f36c5aa321a24c8$export$2e2bcd8739ae039);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $rHZri = parcelRequire("rHZri");

var $9DHn2 = parcelRequire("9DHn2");

var $58uSL = parcelRequire("58uSL");
function $8f36c5aa321a24c8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8f36c5aa321a24c8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8f36c5aa321a24c8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8f36c5aa321a24c8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8f36c5aa321a24c8$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
var $8f36c5aa321a24c8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PostInteractionLog() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PostInteractionLog);
        /**
     * Basic info about interaction that has just finished
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "lastInteractionFinish", null);
        /**
     * Array of observed react render timings
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "reactProfilerTimings", []);
        /**
     * Store the scheduled sink timeout Id so that it can be cancelled when needed
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sinkTimeoutId", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "holdInfo", []);
        /**
     * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "vcObserver", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "vcObserverSSRConfig", null);
        /**
     * Handler function to process / send the observation data
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sinkHandlerFn", function() {});
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PostInteractionLog, [
        {
            key: "initializeVCObserver",
            value: function initializeVCObserver(options) {
                this.vcObserver = new (0, $58uSL.VCObserverWrapper)($8f36c5aa321a24c8$var$_objectSpread($8f36c5aa321a24c8$var$_objectSpread({}, options), {}, {
                    isPostInteraction: true
                }));
            }
        },
        {
            key: "startVCObserver",
            value: function startVCObserver(_ref) {
                var _this$vcObserver;
                var startTime = _ref.startTime;
                (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
                    startTime: startTime
                });
            }
        },
        {
            key: "stopVCObserver",
            value: function stopVCObserver() {
                var _this$vcObserver2;
                (_this$vcObserver2 = this.vcObserver) === null || _this$vcObserver2 === void 0 || _this$vcObserver2.stop();
            }
        },
        {
            key: "setVCObserverSSRConfig",
            value: function setVCObserverSSRConfig(vcObserverSSRConfig) {
                this.vcObserverSSRConfig = vcObserverSSRConfig;
            }
        },
        {
            key: "setLastInteractionFinishVCResult",
            value: function setLastInteractionFinishVCResult(result) {
                this.lastInteractionFinishVCResult = result;
            }
        },
        {
            key: "sinkHandler",
            value: /**
     * Set the fn that would be invoked to process / send the observation data
     */ function sinkHandler(sinkHandlerFn) {
                this.sinkHandlerFn = sinkHandlerFn;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.lastInteractionFinish = null;
                this.reactProfilerTimings = [];
                this.holdInfo = [];
                if (this.sinkTimeoutId != null) {
                    clearTimeout(this.sinkTimeoutId);
                    this.sinkTimeoutId = null;
                }
                this.setVCObserverSSRConfig(null);
            }
        },
        {
            key: "hasData",
            value: function hasData() {
                var _this$reactProfilerTi;
                return ((_this$reactProfilerTi = this.reactProfilerTimings) === null || _this$reactProfilerTi === void 0 ? void 0 : _this$reactProfilerTi.length) > 0;
            }
        },
        {
            key: "sendPostInteractionLog",
            value: function() {
                var _sendPostInteractionLog = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
                    var _this$vcObserver4, _config$vc, _config$vc2, _this$vcObserver5;
                    var _this$vcObserver3, pageVisibilityState, isPageVisible, config, postInteractionFinishVCResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!(!this.lastInteractionFinish || !this.sinkHandlerFn)) {
                                    _context.next = 1;
                                    break;
                                }
                                this.reset();
                                (_this$vcObserver3 = this.vcObserver) === null || _this$vcObserver3 === void 0 || _this$vcObserver3.stop();
                                return _context.abrupt("return");
                            case 1:
                                pageVisibilityState = (0, $9DHn2.getPageVisibilityState)(this.lastInteractionFinish.start, this.lastInteractionFinish.end);
                                isPageVisible = pageVisibilityState === 'visible';
                                config = (0, $rHZri.getConfig)();
                                _context.next = 2;
                                return (_this$vcObserver4 = this.vcObserver) === null || _this$vcObserver4 === void 0 ? void 0 : _this$vcObserver4.getVCResult($8f36c5aa321a24c8$var$_objectSpread($8f36c5aa321a24c8$var$_objectSpread({
                                    start: this.lastInteractionFinish.start,
                                    stop: performance.now(),
                                    tti: -1,
                                    // no need for TTI value here
                                    isEventAborted: !!this.lastInteractionFinish.abortReason,
                                    prefix: 'ufo',
                                    experienceKey: this.lastInteractionFinish.ufoName,
                                    interactionId: this.lastInteractionFinish.id,
                                    includeSSRInV3: config === null || config === void 0 || (_config$vc = config.vc) === null || _config$vc === void 0 ? void 0 : _config$vc.includeSSRInV3,
                                    includeSSRRatio: config === null || config === void 0 || (_config$vc2 = config.vc) === null || _config$vc2 === void 0 ? void 0 : _config$vc2.includeSSRRatio
                                }, this.vcObserverSSRConfig), {}, {
                                    interactionType: this.lastInteractionFinish.type,
                                    isPageVisible: isPageVisible,
                                    interactionAbortReason: this.lastInteractionFinish.abortReason
                                }));
                            case 2:
                                postInteractionFinishVCResult = _context.sent;
                                (_this$vcObserver5 = this.vcObserver) === null || _this$vcObserver5 === void 0 || _this$vcObserver5.stop();
                                this.sinkHandlerFn({
                                    lastInteractionFinish: this.lastInteractionFinish,
                                    reactProfilerTimings: this.reactProfilerTimings,
                                    postInteractionFinishVCResult: postInteractionFinishVCResult,
                                    lastInteractionFinishVCResult: this.lastInteractionFinishVCResult,
                                    postInteractionHoldInfo: this.holdInfo
                                });
                                this.reset();
                            case 3:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function sendPostInteractionLog() {
                    return _sendPostInteractionLog.apply(this, arguments);
                }
                return sendPostInteractionLog;
            }()
        },
        {
            key: "onInteractionComplete",
            value: function onInteractionComplete(_ref2) {
                var _getConfig, _this = this;
                var ufoName = _ref2.ufoName, start = _ref2.start, end = _ref2.end, id = _ref2.id, abortReason = _ref2.abortReason, abortedByInteractionName = _ref2.abortedByInteractionName, routeName = _ref2.routeName, type = _ref2.type, errors = _ref2.errors;
                this.lastInteractionFinish = {
                    ufoName: ufoName,
                    start: start,
                    end: end,
                    id: id,
                    abortReason: abortReason,
                    abortedByInteractionName: abortedByInteractionName,
                    routeName: routeName,
                    type: type,
                    errors: errors
                };
                var timeout = ((_getConfig = (0, $rHZri.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.timeWindowForLateMutationsInMilliseconds) || $8f36c5aa321a24c8$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
                this.sinkTimeoutId = window.setTimeout(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 1;
                                return _this.sendPostInteractionLog();
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                })), timeout);
            }
        },
        {
            key: "addProfilerTimings",
            value: function addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
                if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
                    type: type,
                    actualDuration: actualDuration,
                    baseDuration: baseDuration,
                    startTime: startTime,
                    commitTime: commitTime,
                    labelStack: labelStack
                });
            }
        },
        {
            key: "addHoldInfo",
            value: function addHoldInfo(labelStack, name, start) {
                this.holdInfo.push({
                    name: name,
                    labelStack: labelStack,
                    start: start
                });
            }
        }
    ]);
}();

});


parcelRegister("9fs6o", function(module, exports) {
$parcel$export(module.exports, "CollapsibleHeadingsProvider", () => $6bbb50415b55c251$export$158f0ca2ade2cf24);
$parcel$export(module.exports, "useCollapsibleHeading", () => $6bbb50415b55c251$export$3df123b939d40b52);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $bTFoW = parcelRequire("bTFoW");

var $ki7NT = parcelRequire("ki7NT");

var $68qyM = parcelRequire("68qyM");
var $6bbb50415b55c251$var$CollapsibleHeadingsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext(null);
var $6bbb50415b55c251$var$emptyCollapsedHeadings = new Set();
function $6bbb50415b55c251$var$isSameDocument(currentDocument, nextDocument) {
    if (currentDocument === nextDocument) return true;
    if (!currentDocument || !nextDocument) return false;
    // Node.eq compares node-type identity. The shared schema cache can be evicted by another
    // renderer, producing different node types for identical content on the next render.
    return currentDocument.type.schema === nextDocument.type.schema ? currentDocument.eq(nextDocument) : (0, (/*@__PURE__*/$parcel$interopDefault($bTFoW)))(currentDocument.toJSON(), nextDocument.toJSON());
}
function $6bbb50415b55c251$var$supportsHiddenUntilFound(rendererRef) {
    var _rendererRef$current;
    var body = (_rendererRef$current = rendererRef.current) === null || _rendererRef$current === void 0 ? void 0 : _rendererRef$current.ownerDocument.body;
    return body ? 'onbeforematch' in body : false;
}
function $6bbb50415b55c251$export$158f0ca2ade2cf24(_ref) {
    var children = _ref.children, isEnabled = _ref.isEnabled, pmDocument = _ref.pmDocument, rendererRef = _ref.rendererRef;
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isBrowserFindSupported = _useState2[0], setIsBrowserFindSupported = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)({
        pmDocument: pmDocument,
        positions: new Set()
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), state = _useState4[0], setState = _useState4[1];
    var originalHiddenAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(new WeakMap()).current;
    var sections = (0, $5FkrB.useMemo)(function() {
        return (0, $68qyM.buildTopLevelHeadingSections)(pmDocument);
    }, [
        pmDocument
    ]);
    var collapsibleSectionPositions = (0, $5FkrB.useMemo)(function() {
        return new Set(sections.filter(function(section) {
            return section.contentFrom < section.to;
        }).map(function(section) {
            return section.headingPos;
        }));
    }, [
        sections
    ]);
    var isCurrentDocument = $6bbb50415b55c251$var$isSameDocument(state.pmDocument, pmDocument);
    var collapsedHeadings = isCurrentDocument ? state.positions : $6bbb50415b55c251$var$emptyCollapsedHeadings;
    var isActive = isEnabled && isBrowserFindSupported && Boolean(pmDocument);
    (0, $5FkrB.useEffect)(function() {
        setIsBrowserFindSupported(isEnabled && $6bbb50415b55c251$var$supportsHiddenUntilFound(rendererRef));
    }, [
        isEnabled,
        rendererRef
    ]);
    var updateCollapsedHeadings = (0, $5FkrB.useCallback)(function(update) {
        setState(function(currentState) {
            var isStillCurrentDocument = $6bbb50415b55c251$var$isSameDocument(currentState.pmDocument, pmDocument);
            var positions = new Set(isStillCurrentDocument ? currentState.positions : $6bbb50415b55c251$var$emptyCollapsedHeadings);
            if (!update(positions)) return isStillCurrentDocument ? currentState : {
                pmDocument: pmDocument,
                positions: positions
            };
            return {
                pmDocument: pmDocument,
                positions: positions
            };
        });
    }, [
        pmDocument
    ]);
    var collapse = (0, $5FkrB.useCallback)(function(headingPos) {
        if (!collapsibleSectionPositions.has(headingPos)) return;
        updateCollapsedHeadings(function(positions) {
            if (positions.has(headingPos)) return false;
            positions.add(headingPos);
            return true;
        });
    }, [
        collapsibleSectionPositions,
        updateCollapsedHeadings
    ]);
    var expand = (0, $5FkrB.useCallback)(function(headingPos) {
        updateCollapsedHeadings(function(positions) {
            return positions.delete(headingPos);
        });
    }, [
        updateCollapsedHeadings
    ]);
    var expandMany = (0, $5FkrB.useCallback)(function(headingPositions) {
        var positionsToExpand = new Set(headingPositions);
        updateCollapsedHeadings(function(positions) {
            var didChange = false;
            positionsToExpand.forEach(function(headingPos) {
                didChange = positions.delete(headingPos) || didChange;
            });
            return didChange;
        });
    }, [
        updateCollapsedHeadings
    ]);
    var expandContainingPosition = (0, $5FkrB.useCallback)(function(position) {
        expandMany(sections.filter(function(section) {
            return position >= section.contentFrom && position < section.to;
        }).map(function(section) {
            return section.headingPos;
        }));
    }, [
        expandMany,
        sections
    ]);
    var toggle = (0, $5FkrB.useCallback)(function(headingPos) {
        if (!collapsibleSectionPositions.has(headingPos)) return;
        updateCollapsedHeadings(function(positions) {
            if (positions.has(headingPos)) positions.delete(headingPos);
            else positions.add(headingPos);
            return true;
        });
    }, [
        collapsibleSectionPositions,
        updateCollapsedHeadings
    ]);
    var contextValue = (0, $5FkrB.useMemo)(function() {
        return isActive ? {
            canCollapse: function canCollapse(headingPos) {
                return collapsibleSectionPositions.has(headingPos);
            },
            collapse: collapse,
            expand: expand,
            expandContainingPosition: expandContainingPosition,
            expandMany: expandMany,
            isCollapsed: function isCollapsed(headingPos) {
                return collapsedHeadings.has(headingPos);
            },
            toggle: toggle
        } : null;
    }, [
        collapse,
        collapsedHeadings,
        collapsibleSectionPositions,
        expand,
        expandContainingPosition,
        expandMany,
        isActive,
        toggle
    ]);
    (0, $5FkrB.useEffect)(function() {
        var rendererRoot = rendererRef.current;
        if (!rendererRoot) return;
        var positions = isActive ? collapsedHeadings : $6bbb50415b55c251$var$emptyCollapsedHeadings;
        var sync = function sync() {
            return (0, $ki7NT.reconcileCollapsedHeadingContent)({
                collapsedHeadings: positions,
                originalHiddenAttributes: originalHiddenAttributes,
                rendererRoot: rendererRoot,
                sections: sections
            });
        };
        sync();
        if (!isActive || positions.size === 0) return;
        var rendererDocuments = (0, $ki7NT.getOwnedRendererDocuments)(rendererRoot);
        var rendererDocumentSet = new Set(rendererDocuments);
        var handleBeforeMatch = function handleBeforeMatch(event) {
            var _rendererRoot$ownerDo;
            var target = event.target;
            var HTMLElementConstructor = (_rendererRoot$ownerDo = rendererRoot.ownerDocument.defaultView) === null || _rendererRoot$ownerDo === void 0 ? void 0 : _rendererRoot$ownerDo.HTMLElement;
            if (!HTMLElementConstructor || !(target instanceof HTMLElementConstructor)) return;
            var collapsedContent = target.closest("[".concat((0, $ki7NT.COLLAPSED_CONTENT_OWNERS_ATTRIBUTE), "]"));
            if (!collapsedContent) return;
            var rendererDocument = collapsedContent.closest('.ak-renderer-document');
            if (!rendererDocument || !rendererDocumentSet.has(rendererDocument)) return;
            expandMany((0, $ki7NT.getCollapsedContentOwners)(collapsedContent));
        };
        var unbindBeforeMatchListeners = rendererDocuments.map(function(rendererDocument) {
            return (0, $7QpUe.bind)(rendererDocument, {
                type: 'beforematch',
                listener: handleBeforeMatch,
                options: {
                    capture: true
                }
            });
        });
        var observer = typeof MutationObserver === 'undefined' ? undefined : new MutationObserver(sync);
        rendererDocuments.forEach(function(rendererDocument) {
            observer === null || observer === void 0 || observer.observe(rendererDocument, {
                childList: true
            });
        });
        return function() {
            observer === null || observer === void 0 || observer.disconnect();
            unbindBeforeMatchListeners.forEach(function(unbindBeforeMatch) {
                return unbindBeforeMatch();
            });
        };
    }, [
        collapsedHeadings,
        expandMany,
        isActive,
        originalHiddenAttributes,
        rendererRef,
        sections
    ]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            var rendererRoot = rendererRef.current;
            if (rendererRoot) (0, $ki7NT.reconcileCollapsedHeadingContent)({
                collapsedHeadings: $6bbb50415b55c251$var$emptyCollapsedHeadings,
                originalHiddenAttributes: originalHiddenAttributes,
                rendererRoot: rendererRoot,
                sections: []
            });
        };
    }, [
        originalHiddenAttributes,
        rendererRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($6bbb50415b55c251$var$CollapsibleHeadingsContext.Provider, {
        value: contextValue
    }, children);
}
function $6bbb50415b55c251$export$3df123b939d40b52(startPos, isTopLevel) {
    var context = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useContext($6bbb50415b55c251$var$CollapsibleHeadingsContext);
    var contextToggle = context === null || context === void 0 ? void 0 : context.toggle;
    var isCollapsible = Boolean(context && isTopLevel && context.canCollapse(startPos));
    var isCollapsed = Boolean(isCollapsible && (context === null || context === void 0 ? void 0 : context.isCollapsed(startPos)));
    var toggle = (0, $5FkrB.useCallback)(function() {
        return contextToggle === null || contextToggle === void 0 ? void 0 : contextToggle(startPos);
    }, [
        contextToggle,
        startPos
    ]);
    return (0, $5FkrB.useMemo)(function() {
        return isCollapsible ? {
            isCollapsed: isCollapsed,
            toggle: toggle
        } : null;
    }, [
        isCollapsed,
        isCollapsible,
        toggle
    ]);
}
function $6bbb50415b55c251$export$16b4e68f51f04e9e() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useContext($6bbb50415b55c251$var$CollapsibleHeadingsContext);
}

});
parcelRegister("ki7NT", function(module, exports) {
$parcel$export(module.exports, "COLLAPSED_CONTENT_OWNERS_ATTRIBUTE", () => $ec5b8ac3dc943aca$export$2116c0d2c1e9b9e4);
$parcel$export(module.exports, "getOwnedRendererDocuments", () => $ec5b8ac3dc943aca$export$236858493fcc483b);
$parcel$export(module.exports, "reconcileCollapsedHeadingContent", () => $ec5b8ac3dc943aca$export$371cf0cf237e6c69);
$parcel$export(module.exports, "getCollapsedContentOwners", () => $ec5b8ac3dc943aca$export$18ccec9830a10d6e);
var $ec5b8ac3dc943aca$var$RENDERER_DOCUMENT_SELECTOR = '.ak-renderer-document';
var $ec5b8ac3dc943aca$var$RENDERER_START_POS_ATTRIBUTE = 'data-renderer-start-pos';
var $ec5b8ac3dc943aca$var$HEADING_SELECTOR = [
    1,
    2,
    3,
    4,
    5,
    6
].map(function(level) {
    return "h".concat(level, "[").concat($ec5b8ac3dc943aca$var$RENDERER_START_POS_ATTRIBUTE, "]");
}).join(',');
var $ec5b8ac3dc943aca$export$2116c0d2c1e9b9e4 = 'data-renderer-collapsed-content-owners';
function $ec5b8ac3dc943aca$var$getDirectRendererChild(rendererDocument, element) {
    var _currentElement;
    var currentElement = element;
    while(currentElement && currentElement.parentElement !== rendererDocument)currentElement = currentElement.parentElement;
    return ((_currentElement = currentElement) === null || _currentElement === void 0 ? void 0 : _currentElement.parentElement) === rendererDocument ? currentElement : null;
}
function $ec5b8ac3dc943aca$var$getTopLevelHeadingPositionsByContainer(rendererDocument, topLevelHeadingPositions) {
    var headingPositionsByContainer = new Map();
    rendererDocument.querySelectorAll($ec5b8ac3dc943aca$var$HEADING_SELECTOR).forEach(function(headingElement) {
        if (headingElement.closest($ec5b8ac3dc943aca$var$RENDERER_DOCUMENT_SELECTOR) !== rendererDocument) return;
        var position = Number(headingElement.getAttribute($ec5b8ac3dc943aca$var$RENDERER_START_POS_ATTRIBUTE));
        if (!Number.isFinite(position) || !topLevelHeadingPositions.has(position)) return;
        var headingContainer = $ec5b8ac3dc943aca$var$getDirectRendererChild(rendererDocument, headingElement);
        if (headingContainer) headingPositionsByContainer.set(headingContainer, position);
    });
    return headingPositionsByContainer;
}
function $ec5b8ac3dc943aca$var$restoreHiddenAttribute(element, originalHiddenAttributes) {
    if (!originalHiddenAttributes.has(element)) return;
    var originalHiddenAttribute = originalHiddenAttributes.get(element);
    if (originalHiddenAttribute === null || originalHiddenAttribute === undefined) element.removeAttribute('hidden');
    else element.setAttribute('hidden', originalHiddenAttribute);
    originalHiddenAttributes.delete(element);
}
function $ec5b8ac3dc943aca$var$setCollapsedOwners(element, owners, originalHiddenAttributes) {
    if (!originalHiddenAttributes.has(element)) originalHiddenAttributes.set(element, element.getAttribute('hidden'));
    element.setAttribute($ec5b8ac3dc943aca$export$2116c0d2c1e9b9e4, Array.from(owners).join(','));
    element.setAttribute('hidden', 'until-found');
}
function $ec5b8ac3dc943aca$var$getDesiredCollapsedContentOwners(rendererDocuments, collapsedHeadings, sections) {
    var desiredOwners = new Map();
    if (collapsedHeadings.size === 0) return desiredOwners;
    var topLevelHeadingPositions = new Set(sections.map(function(section) {
        return section.headingPos;
    }));
    var sectionsByHeadingPosition = new Map(sections.map(function(section) {
        return [
            section.headingPos,
            section
        ];
    }));
    rendererDocuments.forEach(function(rendererDocument) {
        // Index headings once, then reconcile every top-level renderer child in DOM order.
        var headingPositionsByContainer = $ec5b8ac3dc943aca$var$getTopLevelHeadingPositionsByContainer(rendererDocument, topLevelHeadingPositions);
        var activeCollapsedSections = [];
        var contentElements = Array.from(rendererDocument.children);
        contentElements.forEach(function(contentElement) {
            var headingPosition = headingPositionsByContainer.get(contentElement);
            if (headingPosition !== undefined) activeCollapsedSections = activeCollapsedSections.filter(function(section) {
                return section.to > headingPosition;
            });
            if (activeCollapsedSections.length > 0) desiredOwners.set(contentElement, new Set(activeCollapsedSections.map(function(section) {
                return section.headingPos;
            })));
            if (headingPosition !== undefined && collapsedHeadings.has(headingPosition)) {
                var section = sectionsByHeadingPosition.get(headingPosition);
                if (section) activeCollapsedSections.push(section);
            }
        });
    });
    return desiredOwners;
}
function $ec5b8ac3dc943aca$export$236858493fcc483b(rendererRoot) {
    return Array.from(rendererRoot.querySelectorAll($ec5b8ac3dc943aca$var$RENDERER_DOCUMENT_SELECTOR)).filter(function(rendererDocument) {
        var _rendererDocument$par;
        var parentRendererDocument = (_rendererDocument$par = rendererDocument.parentElement) === null || _rendererDocument$par === void 0 ? void 0 : _rendererDocument$par.closest($ec5b8ac3dc943aca$var$RENDERER_DOCUMENT_SELECTOR);
        return !parentRendererDocument || !rendererRoot.contains(parentRendererDocument);
    });
}
function $ec5b8ac3dc943aca$export$371cf0cf237e6c69(_ref) {
    var collapsedHeadings = _ref.collapsedHeadings, originalHiddenAttributes = _ref.originalHiddenAttributes, rendererRoot = _ref.rendererRoot, sections = _ref.sections;
    var rendererDocuments = $ec5b8ac3dc943aca$export$236858493fcc483b(rendererRoot);
    var desiredOwners = $ec5b8ac3dc943aca$var$getDesiredCollapsedContentOwners(rendererDocuments, collapsedHeadings, sections);
    rendererDocuments.forEach(function(rendererDocument) {
        rendererDocument.querySelectorAll("[".concat($ec5b8ac3dc943aca$export$2116c0d2c1e9b9e4, "]")).forEach(function(element) {
            if (element.closest($ec5b8ac3dc943aca$var$RENDERER_DOCUMENT_SELECTOR) === rendererDocument && !desiredOwners.has(element)) {
                element.removeAttribute($ec5b8ac3dc943aca$export$2116c0d2c1e9b9e4);
                $ec5b8ac3dc943aca$var$restoreHiddenAttribute(element, originalHiddenAttributes);
            }
        });
    });
    desiredOwners.forEach(function(owners, element) {
        var desiredOwnersAttribute = Array.from(owners).join(',');
        if (element.getAttribute($ec5b8ac3dc943aca$export$2116c0d2c1e9b9e4) !== desiredOwnersAttribute || element.getAttribute('hidden') !== 'until-found') $ec5b8ac3dc943aca$var$setCollapsedOwners(element, owners, originalHiddenAttributes);
    });
}
function $ec5b8ac3dc943aca$export$18ccec9830a10d6e(element) {
    var _element$getAttribute;
    return ((_element$getAttribute = element.getAttribute($ec5b8ac3dc943aca$export$2116c0d2c1e9b9e4)) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : '').split(',').filter(function(owner) {
        return owner !== '';
    }).map(Number).filter(Number.isFinite);
}

});

parcelRegister("68qyM", function(module, exports) {
$parcel$export(module.exports, "buildTopLevelHeadingSections", () => $477817b4a50c15a3$export$640970ddc72cf5cf);
var $477817b4a50c15a3$var$RENDERER_DOCUMENT_POSITION_OFFSET = 1;
function $477817b4a50c15a3$export$640970ddc72cf5cf(pmDocument) {
    if (!pmDocument) return [];
    var sections = [];
    var openSections = [];
    var documentEnd = pmDocument.content.size + $477817b4a50c15a3$var$RENDERER_DOCUMENT_POSITION_OFFSET;
    pmDocument.forEach(function(node, offset) {
        if (node.type.name !== 'heading') return;
        var headingPos = offset + $477817b4a50c15a3$var$RENDERER_DOCUMENT_POSITION_OFFSET;
        var level = Number(node.attrs.level);
        while(openSections.length > 0 && openSections[openSections.length - 1].level >= level){
            var _section = openSections.pop();
            if (_section) _section.to = headingPos;
        }
        var section = {
            contentFrom: headingPos + node.nodeSize,
            headingPos: headingPos,
            level: level,
            to: documentEnd
        };
        sections.push(section);
        openSections.push(section);
    });
    return sections;
}

});


parcelRegister("bXlPp", function(module, exports) {
$parcel$export(module.exports, "copyTextToClipboard", () => $8b46230357357c0e$export$f980440e1ab4537d);
var $8b46230357357c0e$export$f980440e1ab4537d = function copyTextToClipboard(text) {
    return new Promise(function(resolve, reject) {
        var isApiSupported = !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
        if (isApiSupported) navigator.clipboard.writeText(text).then(function() {
            return resolve();
        }, function(e) {
            return reject(e);
        });
        else reject('Clipboard API is not supported');
    });
};

});

parcelRegister("fq8Dd", function(module, exports) {
$parcel$export(module.exports, "HeadingAnchorWrapperClassName", () => $b39ffac6b64a69e3$export$3c9cedc52604835d);
$parcel$export(module.exports, "default", () => $b39ffac6b64a69e3$export$2e2bcd8739ae039);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $6HG4S = parcelRequire("6HG4S");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $ach6K = parcelRequire("ach6K");

var $1buT4 = parcelRequire("1buT4");

var $jkJfI = parcelRequire("jkJfI");

var $drUcN = parcelRequire("drUcN");

var $4mzlU = parcelRequire("4mzlU");

var $3cXxO = parcelRequire("3cXxO");

var $8ER20 = parcelRequire("8ER20");
var $b39ffac6b64a69e3$var$_excluded = [
    "children"
];
function $b39ffac6b64a69e3$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $b39ffac6b64a69e3$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $b39ffac6b64a69e3$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b39ffac6b64a69e3$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $b39ffac6b64a69e3$export$3c9cedc52604835d = 'heading-anchor-wrapper';
var $b39ffac6b64a69e3$var$headingAnchorWrapperTargetSizeStyles = (0, $74Zh5.css)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
    verticalAlign: 'middle'
});
var $b39ffac6b64a69e3$var$CopyAnchorWrapperWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(props, ref) {
    var children = props.children, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $b39ffac6b64a69e3$var$_excluded);
    return (0, $74Zh5.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $b39ffac6b64a69e3$export$3c9cedc52604835d,
        css: (0, $jkJfI.isExperimentEnabled)('platform_editor_heading_link_target_size') ? $b39ffac6b64a69e3$var$headingAnchorWrapperTargetSizeStyles : undefined,
        ref: ref
    }), children);
});
var $b39ffac6b64a69e3$var$copyAnchorButtonStyles = (0, $74Zh5.css)({
    display: 'inline',
    outline: 'none',
    backgroundColor: 'transparent',
    border: 'none',
    color: "var(--ds-icon, #292A2E)",
    cursor: 'pointer',
    right: 0
});
var $b39ffac6b64a69e3$var$scaledLinkIconStyles = (0, $74Zh5.css)({
    display: 'inline-flex',
    transform: 'scale(1.5)',
    transformOrigin: 'center'
});
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
var $b39ffac6b64a69e3$var$HeadingAnchor = /*#__PURE__*/ function(_React$PureComponent) {
    function HeadingAnchor(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, HeadingAnchor);
        _this = $b39ffac6b64a69e3$var$_callSuper(this, HeadingAnchor, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "state", {
            tooltipMessage: '',
            isClicked: false
        });
        // Stable reference for Tooltip content prop to avoid recreating on each render
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "renderTooltipContent", function(_ref) {
            var update = _ref.update;
            _this._tooltipUpdate = update;
            return _this.state.tooltipMessage;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "setTooltipState", function(message) {
            var isClicked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            _this.setState({
                // TODO: ED-14403 - investigate why this does not translate
                tooltipMessage: _this.props.intl.formatMessage(message),
                isClicked: isClicked
            }, function() {
                // Reposition tooltip after content change (replaces the key-based remount)
                if ((0, $jkJfI.isExperimentEnabled)('a11y-fixes-week4-may-2026')) {
                    var _this$_tooltipUpdate, _this2;
                    (_this$_tooltipUpdate = (_this2 = _this)._tooltipUpdate) === null || _this$_tooltipUpdate === void 0 || _this$_tooltipUpdate.call(_this2);
                }
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getCopyAriaLabel", function() {
            var copyAriaLabel = (0, $3cXxO.headingAnchorLinkMessages).copyAriaLabel;
            return _this.props.intl.formatMessage(copyAriaLabel);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "copyToClipboard", /*#__PURE__*/ function() {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(event) {
                var copiedHeadingLinkToClipboard, failedToCopyHeadingLink, _t;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            copiedHeadingLinkToClipboard = (0, $3cXxO.headingAnchorLinkMessages).copiedHeadingLinkToClipboard, failedToCopyHeadingLink = (0, $3cXxO.headingAnchorLinkMessages).failedToCopyHeadingLink;
                            event.stopPropagation();
                            _context.prev = 1;
                            _context.next = 2;
                            return _this.props.onCopyText();
                        case 2:
                            _this.setTooltipState(copiedHeadingLinkToClipboard, true);
                            _context.next = 4;
                            break;
                        case 3:
                            _context.prev = 3;
                            _t = _context["catch"](1);
                            _this.setTooltipState(failedToCopyHeadingLink);
                        case 4:
                        case "end":
                            return _context.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        3
                    ]
                ]);
            }));
            return function(_x) {
                return _ref2.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "resetMessage", function() {
            var tooltip = (0, $drUcN.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? (0, $3cXxO.headingAnchorLinkMessages).copyLinkToClipboard : (0, $3cXxO.headingAnchorLinkMessages).copyHeadingLinkToClipboard;
            _this.setTooltipState(tooltip);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "renderAnchorButton", function() {
            var _this$props = _this.props, _this$props$hideFromS = _this$props.hideFromScreenReader, hideFromScreenReader = _this$props$hideFromS === void 0 ? false : _this$props$hideFromS, headingId = _this$props.headingId;
            var labelledBy = (0, $drUcN.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? _this.props.intl.formatMessage((0, $3cXxO.headingAnchorLinkMessages).copyHeadingLinkLabelledBy, {
                copyLink: _this.copyLinkId,
                heading: headingId
            }) : headingId;
            var tabIndex = (0, $drUcN.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? 0 : hideFromScreenReader ? undefined : -1;
            if ((0, $jkJfI.isExperimentEnabled)('platform_editor_heading_link_target_size')) return (0, $74Zh5.jsx)((0, $8ER20.default), {
                "data-testid": "anchor-button",
                id: _this.copyLinkId,
                onMouseLeave: _this.resetMessage,
                onBlur: _this.resetMessage,
                onClick: _this.copyToClipboard,
                "aria-hidden": hideFromScreenReader,
                tabIndex: tabIndex,
                "aria-label": hideFromScreenReader ? undefined : _this.state.tooltipMessage,
                "aria-labelledby": hideFromScreenReader ? undefined : labelledBy,
                type: "button"
            }, (0, $74Zh5.jsx)("span", {
                css: $b39ffac6b64a69e3$var$scaledLinkIconStyles,
                "data-testid": "scaled-link-icon"
            }, (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1buT4))), {
                label: _this.getCopyAriaLabel(),
                size: "medium",
                color: _this.state.isClicked ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)"
            })));
            return (0, $74Zh5.jsx)("button", {
                "data-testid": "anchor-button",
                id: _this.copyLinkId,
                css: $b39ffac6b64a69e3$var$copyAnchorButtonStyles,
                onMouseLeave: _this.resetMessage,
                onBlur: _this.resetMessage,
                onClick: _this.copyToClipboard,
                "aria-hidden": hideFromScreenReader,
                tabIndex: tabIndex,
                "aria-label": hideFromScreenReader ? undefined : _this.state.tooltipMessage,
                "aria-labelledby": hideFromScreenReader ? undefined : labelledBy,
                type: "button"
            }, (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1buT4))), {
                label: _this.getCopyAriaLabel(),
                color: _this.state.isClicked ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)"
            }));
        });
        _this.copyLinkId = (0, $drUcN.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? crypto.randomUUID() : undefined;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(HeadingAnchor, _React$PureComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(HeadingAnchor, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.resetMessage();
            }
        },
        {
            key: "render",
            value: function render() {
                var tooltipMessage = this.state.tooltipMessage;
                if (tooltipMessage) {
                    if ((0, $jkJfI.isExperimentEnabled)('a11y-fixes-week4-may-2026')) // Fix for A11Y-30972: Use content as a function with update callback so
                    // the Tooltip repositions without unmounting (which caused focus loss).
                    // @see https://hello.jira.atlassian.cloud/browse/A11Y-30972
                    return (0, $74Zh5.jsx)((0, $4mzlU.default), {
                        tag: $b39ffac6b64a69e3$var$CopyAnchorWrapperWithRef,
                        content: this.renderTooltipContent,
                        position: "top",
                        delay: 0,
                        isScreenReaderAnnouncementDisabled: (0, $drUcN.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? true : false
                    }, this.renderAnchorButton());
                    // We set the key to the message to ensure it remounts when the message
                    // changes, so that it correctly repositions.
                    // @see https://ecosystem.atlassian.net/projects/AK/queues/issue/AK-6548
                    return (0, $74Zh5.jsx)((0, $4mzlU.default), {
                        tag: $b39ffac6b64a69e3$var$CopyAnchorWrapperWithRef,
                        content: tooltipMessage,
                        position: "top",
                        delay: 0,
                        key: tooltipMessage,
                        isScreenReaderAnnouncementDisabled: (0, $drUcN.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? true : false
                    }, this.renderAnchorButton());
                }
                return this.renderAnchorButton();
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).PureComponent); // eslint-disable-next-line @typescript-eslint/no-restricted-types
var $b39ffac6b64a69e3$var$_default_1 = (0, $ach6K.default)($b39ffac6b64a69e3$var$HeadingAnchor);
var $b39ffac6b64a69e3$export$2e2bcd8739ae039 = $b39ffac6b64a69e3$var$_default_1;

});
parcelRegister("1buT4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d2795fc1ebee30d2a3977d5783012a5a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0dcec71ac857133b$var$_react = $0dcec71ac857133b$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $0dcec71ac857133b$var$_iconNew = $0dcec71ac857133b$var$_interopRequireDefault((parcelRequire("gDzom")));
function $0dcec71ac857133b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/link
 * Usage guidance:
 * Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0dcec71ac857133b$var$LinkIcon = (props)=>/*#__PURE__*/ $0dcec71ac857133b$var$_react.default.createElement($0dcec71ac857133b$var$_iconNew.default, Object.assign({
        name: "LinkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$0dcec71ac857133b$var$LinkIcon.displayName = 'LinkIcon';
var $0dcec71ac857133b$var$_default = module.exports.default = $0dcec71ac857133b$var$LinkIcon;

});

parcelRegister("8ER20", function(module, exports) {
$parcel$export(module.exports, "default", () => $64db3218578c65f8$export$2e2bcd8739ae039);
/* heading-anchor-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $64db3218578c65f8$var$buttonStyles = null;
function $64db3218578c65f8$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line react/jsx-props-no-spreading -- Forward the existing heading anchor's accessibility and event props.
    return /*#__PURE__*/ $5FkrB.createElement("button", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        type: "button",
        className: (0, $970q7.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _1dqoglyw _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1bsb1tcg _4t3i1tcg _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _s7n4nkob _bfhk1j28 _80omtlke"
        ])
    }));
}

});



parcelRegister("iXLPT", function(module, exports) {
$parcel$export(module.exports, "default", () => $dce2d7eb202c1794$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $4chaE = parcelRequire("4chaE");
var $dce2d7eb202c1794$var$InlineExtension = function InlineExtension(props) {
    var text = props.text;
    return(/*#__PURE__*/ // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4chaE.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        type: "inlineExtension"
    }), function(_ref) {
        var result = _ref.result;
        try {
            // Return the result directly if it's a valid JSX.Element
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).isValidElement(result)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", null, result);
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", null, text || 'inlineExtension');
    }));
};
var $dce2d7eb202c1794$export$2e2bcd8739ae039 = $dce2d7eb202c1794$var$InlineExtension;

});

parcelRegister("7n8xE", function(module, exports) {
$parcel$export(module.exports, "default", () => $55e14e9ead21bc7a$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $jkJfI = parcelRequire("jkJfI");

var $h0il1 = parcelRequire("h0il1");

var $4Mx1v = parcelRequire("4Mx1v");

var $lUQME = parcelRequire("lUQME");
var $55e14e9ead21bc7a$var$LayoutSectionMigration = (0, $h0il1.componentWithCondition)(function() {
    return (0, $jkJfI.isExperimentEnabled)('platform_editor_renderer_static_css');
}, (0, $4Mx1v.LayoutSectionCompiled), (0, $lUQME.LayoutSectionEmotion));
function $55e14e9ead21bc7a$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($55e14e9ead21bc7a$var$LayoutSectionMigration, props);
}

});
parcelRegister("4Mx1v", function(module, exports) {
$parcel$export(module.exports, "LayoutSectionCompiled", () => $37b542da9f826adc$export$417b5700bb65fae1);
/* layoutColumn-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ /**
 * Compiled branch of the `platform_editor_renderer_static_css` experiment.
 * Used via `componentWithCondition` in `layoutColumn.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $01HkO = parcelRequire("01HkO");

var $50U6m = parcelRequire("50U6m");

var $drUcN = parcelRequire("drUcN");
// localized styles, was from clearNextSiblingMarginTopStyle in @atlaskit/editor-common/ui
var $37b542da9f826adc$var$clearNextSiblingMarginTopStyle = null;
var $37b542da9f826adc$var$verticalAlignMiddleStyles = null;
var $37b542da9f826adc$var$verticalAlignBottomStyles = null;
var $37b542da9f826adc$var$multipleWrappedImagesStyle = null;
// localized styles, was from clearNextSiblingBlockMarkMarginTopStyle in @atlaskit/editor-common/ui
var $37b542da9f826adc$var$clearNextSiblingBlockMarkMarginTopStyle = null;
var $37b542da9f826adc$export$417b5700bb65fae1 = function LayoutSectionCompiled(props) {
    var isLayoutColumnMenuEnabled = (0, $drUcN.expValEquals)('platform_editor_layout_column_menu', 'isEnabled', true);
    var isLayoutColumnValignRenderingEnabled = (0, $drUcN.expValEquals)('platform_editor_layout_column_valign_rendering', 'isEnabled', true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        "data-valign": props.valign,
        style: {
            flexBasis: "".concat(props.width, "%")
        },
        className: (0, $970q7.default)([
            (isLayoutColumnValignRenderingEnabled || isLayoutColumnMenuEnabled) && props.valign === 'middle' && "_1e0c1txw _2lx21bp4 _1bah1h6o",
            (isLayoutColumnValignRenderingEnabled || isLayoutColumnMenuEnabled) && props.valign === 'bottom' && "_1e0c1txw _2lx21bp4 _1bahesu3",
            "_1tihidpf _12kpidpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $01HkO.WidthProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        "data-layout-column-start": (0, $50U6m.fg)('platform_renderer_ssr_block_margin_fix') ? 'true' : undefined,
        className: (0, $970q7.default)([
            "_1skbgrf3",
            "_19segrf3 _1ki1grf3 _bmdegrf3 _166hgrf3 _7g1ogrf3 _sk2jgrf3 _hgeogrf3"
        ])
    }), props.children));
};

});

parcelRegister("lUQME", function(module, exports) {
$parcel$export(module.exports, "LayoutSectionEmotion", () => $ff47c5a7ff933e39$export$2cc1a43fb56df180);

var $25nEq = parcelRequire("25nEq");
parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $01HkO = parcelRequire("01HkO");

var $50U6m = parcelRequire("50U6m");

var $drUcN = parcelRequire("drUcN");
// localized styles, was from clearNextSiblingMarginTopStyle in @atlaskit/editor-common/ui
var $ff47c5a7ff933e39$var$clearNextSiblingMarginTopStyle = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + *': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: '0 !important'
    }
});
var $ff47c5a7ff933e39$var$verticalAlignMiddleStyles = (0, $74Zh5.css)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
});
var $ff47c5a7ff933e39$var$verticalAlignBottomStyles = (0, $74Zh5.css)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end'
});
var $ff47c5a7ff933e39$var$multipleWrappedImagesStyle = (0, $74Zh5.css)({
    // Given the first wrapped mediaSingle has 0 marginTop (see clearNextSiblingMarginTopStyle),
    // update all wrapped mediaSingle inside layout to have 0 margin top unless they don't have sibling wrapped mediaSingle
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,  @atlaskit/ui-styling-standard/no-unsafe-selectors
    '& [class*="image-wrap-"] + [class*="image-wrap-"], & [class*="image-wrap-"]:has( + [class*="image-wrap-"])': {
        marginTop: '0'
    }
});
// localized styles, was from clearNextSiblingBlockMarkMarginTopStyle in @atlaskit/editor-common/ui
var $ff47c5a7ff933e39$var$clearNextSiblingBlockMarkMarginTopStyle = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "+ .fabric-editor-block-mark > p,\n\t  + .fabric-editor-block-mark > h1,\n\t  + .fabric-editor-block-mark > h2,\n\t  + .fabric-editor-block-mark > h3,\n\t  + .fabric-editor-block-mark > h4,\n\t  + .fabric-editor-block-mark > h5,\n\t  + .fabric-editor-block-mark > h6\n\t", {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    marginTop: '0 !important'
}));
var $ff47c5a7ff933e39$export$2cc1a43fb56df180 = function LayoutSectionEmotion(props) {
    var isLayoutColumnMenuEnabled = (0, $drUcN.expValEquals)('platform_editor_layout_column_menu', 'isEnabled', true);
    var isLayoutColumnValignRenderingEnabled = (0, $drUcN.expValEquals)('platform_editor_layout_column_valign_rendering', 'isEnabled', true);
    return (0, $74Zh5.jsx)("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        "data-valign": props.valign,
        style: {
            flexBasis: "".concat(props.width, "%")
        },
        css: [
            // Keep separate: Compiled crashes on ternary/object lookup here.
            (isLayoutColumnValignRenderingEnabled || isLayoutColumnMenuEnabled) && props.valign === 'middle' && $ff47c5a7ff933e39$var$verticalAlignMiddleStyles,
            (isLayoutColumnValignRenderingEnabled || isLayoutColumnMenuEnabled) && props.valign === 'bottom' && $ff47c5a7ff933e39$var$verticalAlignBottomStyles,
            $ff47c5a7ff933e39$var$multipleWrappedImagesStyle
        ]
    }, (0, $74Zh5.jsx)((0, $01HkO.WidthProvider), null, (0, $74Zh5.jsx)("div", {
        "data-layout-column-start": (0, $50U6m.fg)('platform_renderer_ssr_block_margin_fix') ? 'true' : undefined,
        css: [
            $ff47c5a7ff933e39$var$clearNextSiblingMarginTopStyle,
            $ff47c5a7ff933e39$var$clearNextSiblingBlockMarkMarginTopStyle
        ]
    }), props.children));
};

});


parcelRegister("betLp", function(module, exports) {
$parcel$export(module.exports, "default", () => $82d816efe2d68914$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $j3BGx = parcelRequire("j3BGx");
function $82d816efe2d68914$export$2e2bcd8739ae039(props) {
    var _props$getContent;
    var columnCount = (_props$getContent = props.getContent) === null || _props$getContent === void 0 || (_props$getContent = _props$getContent.call(props)) === null || _props$getContent === void 0 ? void 0 : _props$getContent.length;
    return (0, $j3BGx.editorExperiment)('advanced_layouts', true) ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        className: "layout-section-container",
        "data-local-id": props.localId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        "data-layout-section": true,
        "data-layout-columns": columnCount
    }, props.children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        "data-layout-section": true,
        "data-local-id": props.localId
    }, props.children);
}

});

parcelRegister("fMHNb", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7dd4ef636c225fa$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $b7dd4ef636c225fa$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("li", null, props.children);
}

});

parcelRegister("geLdv", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd229469dfadfb0e$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $lAD7C = parcelRequire("lAD7C");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $01HkO = parcelRequire("01HkO");

var $2XMn4 = parcelRequire("2XMn4");

var $50U6m = parcelRequire("50U6m");

var $drUcN = parcelRequire("drUcN");

var $gPdZj = parcelRequire("gPdZj");

var $53SBn = parcelRequire("53SBn");

var $2TWiQ = parcelRequire("2TWiQ");

var $hm5SD = parcelRequire("hm5SD");

var $5ZkfV = parcelRequire("5ZkfV");
var $bd229469dfadfb0e$var$_templateObject, $bd229469dfadfb0e$var$_templateObject2;
var $bd229469dfadfb0e$var$containerStyles = (0, $74Zh5.css)({
    // Remove top margin if MBE is the first on the doc/page (MBE can only be on the first level)
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    '&:first-child > .ak-renderer-extension': {
        marginTop: 0
    },
    // When patch is on, direct child is center wrapper (not extension); same first-child behaviour
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    '&:first-child > .ak-renderer-sticky-safe-center-wrapper': {
        marginTop: 0
    }
});
var $bd229469dfadfb0e$var$getFramesActiveFrameStyles = function getFramesActiveFrameStyles(activeChildIndex) {
    if (!(0, $50U6m.fg)('platform_editor_nested_mbe_frames')) return undefined;
    // Apply the active-frame rule on the frames article itself so nested MBEs
    // only target their own direct frames.
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    return (0, $74Zh5.css)($bd229469dfadfb0e$var$_templateObject || ($bd229469dfadfb0e$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($lAD7C)))([
        "\n\t\t& > [data-extension-frame='true']:nth-of-type(",
        ") {\n\t\t\tdisplay: block;\n\t\t}\n\t"
    ])), activeChildIndex + 1);
};
var $bd229469dfadfb0e$var$getContainerActiveFrameStyles = function getContainerActiveFrameStyles(activeChildIndex) {
    if ((0, $50U6m.fg)('platform_editor_nested_mbe_frames')) return undefined;
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    return (0, $74Zh5.css)($bd229469dfadfb0e$var$_templateObject2 || ($bd229469dfadfb0e$var$_templateObject2 = (0, (/*@__PURE__*/$parcel$interopDefault($lAD7C)))([
        "\n\t\t& [data-extension-frame='true']:nth-of-type(",
        ") {\n\t\t\tdisplay: block;\n\t\t}\n\t"
    ])), activeChildIndex + 1);
};
var $bd229469dfadfb0e$var$MultiBodiedExtensionChildrenContainer = function MultiBodiedExtensionChildrenContainer(_ref) {
    var activeChildIndex = _ref.activeChildIndex, children = _ref.children;
    return (0, $74Zh5.jsx)("article", {
        css: $bd229469dfadfb0e$var$getFramesActiveFrameStyles(activeChildIndex),
        "data-testid": "multiBodiedExtension--frames"
    }, children);
};
var $bd229469dfadfb0e$var$MultiBodiedExtensionNavigation = function MultiBodiedExtensionNavigation(_ref2) {
    var children = _ref2.children;
    return (0, $74Zh5.jsx)("nav", {
        "data-testid": "multiBodiedExtension-navigation"
    }, children);
};
var $bd229469dfadfb0e$var$MultiBodiedExtensionWrapperLegacy = function MultiBodiedExtensionWrapperLegacy(_ref3) {
    var width = _ref3.width, path = _ref3.path, layout = _ref3.layout, rendererAppearance = _ref3.rendererAppearance, children = _ref3.children;
    var isTopLevel = path.length < 1;
    // we should only use custom layout for full-page appearance
    var canUseCustomLayout = (0, $drUcN.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? rendererAppearance === 'full-page' : true;
    var isCustomLayout = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && canUseCustomLayout;
    var centerAlignClass = isCustomLayout ? (0, $53SBn.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    // This hierarchy is copied from regular extension (see extension.tsx)
    return (0, $74Zh5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "".concat((0, $53SBn.RendererCssClassName).EXTENSION, " ").concat(centerAlignClass),
        style: {
            width: ((0, $drUcN.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $2XMn4.calcBreakoutWidth)(layout, width) : (0, $drUcN.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? undefined : '100%'
        },
        "data-layout": layout,
        "data-testid": "multiBodiedExtension--wrapper-renderer",
        "data-top-level": isTopLevel || undefined
    }, (0, $74Zh5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: "".concat((0, $53SBn.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER)
    }, children));
};
var $bd229469dfadfb0e$var$MultiBodiedExtensionWrapperNext = function MultiBodiedExtensionWrapperNext(_ref4) {
    var path = _ref4.path, layout = _ref4.layout, rendererAppearance = _ref4.rendererAppearance, children = _ref4.children;
    var isTopLevel = path.length < 1;
    // we should only use custom layout for full-page appearance
    var canUseCustomLayout = (0, $drUcN.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? rendererAppearance === 'full-page' : true;
    var isCustomLayout = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && canUseCustomLayout;
    var centerAlignClass = isCustomLayout ? (0, $53SBn.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    // This hierarchy is copied from regular extension (see extension.tsx)
    return (0, $74Zh5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "".concat((0, $53SBn.RendererCssClassName).EXTENSION, " ").concat(centerAlignClass),
        style: {
            width: ((0, $drUcN.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $2TWiQ.calcBreakoutWidthCss)(layout) : (0, $drUcN.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? undefined : '100%'
        },
        "data-layout": layout,
        "data-testid": "multiBodiedExtension--wrapper-renderer",
        "data-top-level": isTopLevel || undefined
    }, (0, $74Zh5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: "".concat((0, $53SBn.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER)
    }, children));
};
var $bd229469dfadfb0e$var$MultiBodiedExtension = function MultiBodiedExtension(props) {
    var _extensionContext$pri;
    var children = props.children, _props$layout = props.layout, layout = _props$layout === void 0 ? 'default' : _props$layout, _props$path = props.path, path = _props$path === void 0 ? [] : _props$path, parameters = props.parameters, extensionType = props.extensionType, extensionKey = props.extensionKey, extensionHandlers = props.extensionHandlers, getContent = props.getContent, marks = props.marks, localId = props.localId, rendererAppearance = props.rendererAppearance;
    var _useState = (0, $5FkrB.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), activeChildIndex = _useState2[0], setActiveChildIndex = _useState2[1];
    var _useContext = (0, $5FkrB.useContext)((0, $gPdZj.default)), fireAnalyticsEvent = _useContext.fireAnalyticsEvent;
    var _useMultiBodiedExtens = (0, $5ZkfV.useMultiBodiedExtensionContext)({
        extensionHandlers: extensionHandlers,
        extensionType: extensionType,
        extensionKey: extensionKey
    }), loading = _useMultiBodiedExtens.loading, extensionContext = _useMultiBodiedExtens.extensionContext;
    var actions = (0, $hm5SD.useMultiBodiedExtensionActions)({
        updateActiveChild: setActiveChildIndex,
        children: children,
        childrenContainer: (0, $74Zh5.jsx)($bd229469dfadfb0e$var$MultiBodiedExtensionChildrenContainer, {
            activeChildIndex: activeChildIndex
        }, children),
        allowBodiedOverride: extensionContext === null || extensionContext === void 0 || (_extensionContext$pri = extensionContext.privateProps) === null || _extensionContext$pri === void 0 ? void 0 : _extensionContext$pri.__allowBodiedOverride,
        extensionKey: extensionKey,
        extensionType: extensionType,
        fireAnalyticsEvent: fireAnalyticsEvent
    });
    var renderContent = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function() {
        var _marks$find;
        if (loading || !extensionContext) return null;
        var NodeRenderer = extensionContext.NodeRenderer, privateProps = extensionContext.privateProps;
        var fragmentLocalId = marks === null || marks === void 0 || (_marks$find = marks.find(function(m) {
            return m.type.name === 'fragment';
        })) === null || _marks$find === void 0 || (_marks$find = _marks$find.attrs) === null || _marks$find === void 0 ? void 0 : _marks$find.localId;
        var node = {
            type: 'multiBodiedExtension',
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: getContent === null || getContent === void 0 ? void 0 : getContent(),
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        if (privateProps.__allowBodiedOverride) return (0, $74Zh5.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        });
        else return (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, (0, $74Zh5.jsx)($bd229469dfadfb0e$var$MultiBodiedExtensionNavigation, null, (0, $74Zh5.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        })), (0, $74Zh5.jsx)($bd229469dfadfb0e$var$MultiBodiedExtensionChildrenContainer, {
            activeChildIndex: activeChildIndex
        }, children));
    }, [
        activeChildIndex,
        loading,
        extensionContext,
        marks,
        extensionKey,
        extensionType,
        parameters,
        getContent,
        localId,
        actions,
        children
    ]);
    // make the frame visible
    var containerActiveFrameStyles = $bd229469dfadfb0e$var$getContainerActiveFrameStyles(activeChildIndex);
    if ((0, $drUcN.expValEquals)('platform_editor_renderer_extension_width_fix', 'isEnabled', true)) {
        var _isTopLevel = path.length < 1;
        var _useCenterWrapper = _isTopLevel && [
            'wide',
            'full-width'
        ].includes(layout);
        var wrapper = (0, $74Zh5.jsx)($bd229469dfadfb0e$var$MultiBodiedExtensionWrapperNext, {
            layout: layout,
            path: path,
            rendererAppearance: rendererAppearance
        }, renderContent());
        return (0, $74Zh5.jsx)("section", {
            css: [
                $bd229469dfadfb0e$var$containerStyles,
                containerActiveFrameStyles
            ],
            "data-testid": "multiBodiedExtension--container",
            "data-multiBodiedExtension-container": true,
            "data-active-child-index": activeChildIndex,
            "data-layout": layout,
            "data-local-id": localId,
            "data-node-type": "multiBodiedExtension"
        }, _useCenterWrapper ? (0, $74Zh5.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $53SBn.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $53SBn.RendererCssClassName).FLEX_CENTER_WRAPPER
        }, wrapper) : wrapper);
    }
    var isTopLevel = path.length < 1;
    var useCenterWrapper = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout);
    return (0, $74Zh5.jsx)("section", {
        css: [
            $bd229469dfadfb0e$var$containerStyles,
            containerActiveFrameStyles
        ],
        "data-testid": "multiBodiedExtension--container",
        "data-multiBodiedExtension-container": true,
        "data-active-child-index": activeChildIndex,
        "data-layout": layout,
        "data-local-id": localId
    }, (0, $74Zh5.jsx)((0, $01HkO.WidthConsumer), null, function(_ref5) {
        var width = _ref5.width;
        var wrapper = (0, $74Zh5.jsx)($bd229469dfadfb0e$var$MultiBodiedExtensionWrapperLegacy, {
            layout: layout,
            width: width,
            path: path,
            rendererAppearance: rendererAppearance
        }, renderContent());
        return useCenterWrapper ? (0, $74Zh5.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $53SBn.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $53SBn.RendererCssClassName).FLEX_CENTER_WRAPPER
        }, wrapper) : wrapper;
    }));
};
var $bd229469dfadfb0e$export$2e2bcd8739ae039 = $bd229469dfadfb0e$var$MultiBodiedExtension;

});
parcelRegister("hm5SD", function(module, exports) {
$parcel$export(module.exports, "useMultiBodiedExtensionActions", () => $ca290d6a53ebbd9b$export$3c7139d93ecb4f1f);

var $5FkrB = parcelRequire("5FkrB");

var $jJH6F = parcelRequire("jJH6F");

var $drUcN = parcelRequire("drUcN");
var $ca290d6a53ebbd9b$export$3c7139d93ecb4f1f = function useMultiBodiedExtensionActions(_ref) {
    var updateActiveChild = _ref.updateActiveChild, children = _ref.children, allowBodiedOverride = _ref.allowBodiedOverride, childrenContainer = _ref.childrenContainer, _ref$extensionKey = _ref.extensionKey, extensionKey = _ref$extensionKey === void 0 ? '' : _ref$extensionKey, _ref$extensionType = _ref.extensionType, extensionType = _ref$extensionType === void 0 ? '' : _ref$extensionType, fireAnalyticsEvent = _ref.fireAnalyticsEvent;
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        return {
            changeActive: function changeActive(index) {
                if (!Number.isInteger(index)) return false;
                updateActiveChild(index);
                if ((0, $drUcN.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true)) fireAnalyticsEvent === null || fireAnalyticsEvent === void 0 || fireAnalyticsEvent({
                    action: (0, $jJH6F.ACTION).CHANGE_ACTIVE,
                    actionSubject: (0, $jJH6F.ACTION_SUBJECT).MULTI_BODIED_EXTENSION,
                    attributes: {
                        extensionType: extensionType,
                        extensionKey: extensionKey
                    },
                    eventType: (0, $jJH6F.EVENT_TYPE).TRACK
                });
                return true;
            },
            addChild: function addChild() {
                return false;
            },
            getChildrenCount: function getChildrenCount() {
                return children && Array.isArray(children) ? children.length : 0;
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            removeChild: function removeChild(_index) {
                return false;
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            reorderChildren: function reorderChildren(_fromIndex, _toIndex) {
                return false;
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            updateParameters: function updateParameters(_parameters) {
                return false;
            },
            getChildren: function getChildren() {
                return [];
            },
            getChildrenContainer: function getChildrenContainer() {
                return allowBodiedOverride ? childrenContainer : null;
            }
        };
    }, [
        updateActiveChild,
        children,
        allowBodiedOverride,
        childrenContainer,
        extensionKey,
        extensionType,
        fireAnalyticsEvent
    ]);
};

});

parcelRegister("5ZkfV", function(module, exports) {
$parcel$export(module.exports, "useMultiBodiedExtensionContext", () => $45c25ca64ace5164$export$e55394818db35473);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $cvlyC = parcelRequire("cvlyC");

var $5hQFA = parcelRequire("5hQFA");

var $d0n7Z = parcelRequire("d0n7Z");

var $fIf3B = parcelRequire("fIf3B");

var $drUcN = parcelRequire("drUcN");
var $45c25ca64ace5164$var$getExtensionHandlerNode = function getExtensionHandlerNode(extensionHandler) {
    return function(_ref) {
        var node = _ref.node, doc = _ref.doc, actions = _ref.actions;
        return extensionHandler(node, doc, actions);
    };
};
var $45c25ca64ace5164$export$e55394818db35473 = function useMultiBodiedExtensionContext(_ref2) {
    var extensionHandlers = _ref2.extensionHandlers, extensionType = _ref2.extensionType, extensionKey = _ref2.extensionKey;
    var isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(true);
    var localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        return (0, $cvlyC.default)((0, $5hQFA.getNodeRenderer));
    }, []);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState, 2), provider = _React$useState2[0], setProvider = _React$useState2[1];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var _React$useState3 = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(), _React$useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState3, 2), privateProps = _React$useState4[0], setPrivateProps = _React$useState4[1];
    var providerPromise = (0, $d0n7Z.useProvider)('extensionProvider');
    var ExtensionHandlerNode = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        var extensionHandler = extensionHandlers && extensionHandlers[extensionType] && (0, $fIf3B.getExtensionRenderer)(extensionHandlers[extensionType]);
        if (extensionHandler) return $45c25ca64ace5164$var$getExtensionHandlerNode(extensionHandler);
        return null;
    }, [
        extensionHandlers,
        extensionType
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        if (providerPromise) providerPromise.then(function(p) {
            if (isMounted.current) setProvider(p);
            return (0, $5hQFA.getExtensionModuleNodePrivateProps)(p, extensionType, extensionKey);
        }).then(function(pr) {
            if (isMounted.current) setPrivateProps(pr);
        });
    }, [
        providerPromise,
        extensionType,
        extensionKey
    ]);
    var ExtensionProviderNode = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        if (!provider) return null;
        return localGetNodeRenderer(provider, extensionType, extensionKey);
    }, [
        provider,
        extensionType,
        extensionKey,
        localGetNodeRenderer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        if (ExtensionHandlerNode && (0, $drUcN.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true)) return {
            extensionContext: {
                NodeRenderer: ExtensionHandlerNode,
                privateProps: {
                    __allowBodiedOverride: true
                }
            },
            loading: false
        };
        if (!provider || !ExtensionProviderNode || !privateProps) return {
            extensionContext: null,
            loading: true
        };
        return {
            extensionContext: {
                NodeRenderer: ExtensionProviderNode,
                privateProps: privateProps
            },
            loading: false
        };
    }, [
        ExtensionHandlerNode,
        provider,
        ExtensionProviderNode,
        privateProps
    ]);
};

});


parcelRegister("1KF3y", function(module, exports) {
$parcel$export(module.exports, "default", () => $1469ef440d7c049e$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $5MY3X = parcelRequire("5MY3X");

var $14WDN = parcelRequire("14WDN");

var $eskLW = parcelRequire("eskLW");
var $6jcTe = parcelRequire("6jcTe");

var $7q4H1 = parcelRequire("7q4H1");
function $1469ef440d7c049e$export$2e2bcd8739ae039(props) {
    var _props$getContent;
    var extraProps = {};
    // Item count drives the marker column width, so losing it narrows the gutter by a digit.
    var itemsCount = (_props$getContent = props.getContent) === null || _props$getContent === void 0 || (_props$getContent = _props$getContent.call(props)) === null || _props$getContent === void 0 ? void 0 : _props$getContent.length;
    var itemCounterDigitsSize = (0, $eskLW.getItemCounterDigitsSize)({
        order: props.order,
        itemsCount: itemsCount
    });
    if (itemCounterDigitsSize && itemCounterDigitsSize > 1) extraProps.style = (0, $14WDN.getOrderedListInlineStyles)(itemCounterDigitsSize, 'object');
    if (props.order !== undefined) extraProps.start = (0, $6jcTe.resolveOrder)(props.order);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("ol", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $5MY3X.orderedListSelector).substr(1),
        "data-local-id": props.localId,
        "data-indent-level": props.path ? (0, $7q4H1.getListIndentLevel)(props.path) : 1,
        start: props.start
    }, extraProps), props.children);
}

});
parcelRegister("14WDN", function(module, exports) {
$parcel$export(module.exports, "listItemCounterPadding", () => $0c93a70a73f78a3d$export$bafd6beec0797f87);
$parcel$export(module.exports, "getOrderedListInlineStyles", () => $0c93a70a73f78a3d$export$6d31fdb1d74cee3e);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");
var $0c93a70a73f78a3d$export$bafd6beec0797f87 = 24;
var $0c93a70a73f78a3d$var$CSS_VAR_NAMES = /*#__PURE__*/ function(CSS_VAR_NAMES) {
    CSS_VAR_NAMES["ITEM_COUNTER_PADDING"] = "--ed--list--item-counter--padding";
    return CSS_VAR_NAMES;
}($0c93a70a73f78a3d$var$CSS_VAR_NAMES || {});
var $0c93a70a73f78a3d$var$getItemCounterLeftPadding = function getItemCounterLeftPadding(itemCounterDigitsSize) {
    // Previous padding-left was approximately 24px. We approximate that
    // same value using "ch" units (which represent the width of a "0" digit
    // character). We use "ch" so that this computed padding can now grow if
    //  the font-size ever enlarges.
    var paddingLeft = "2.385ch";
    if (itemCounterDigitsSize >= 2) {
        // When there are 2 or more digits, we use a combination of "ch" units and
        // pixel values so that while the computed padding grows if font-size ever
        // enlarges, it doesn't over-scale with each digit (because of the fixed pixel
        // portion of the computed value). This way, very large item counters will not
        // become overly left-padded.
        var fixedBasePx = 2;
        paddingLeft = "calc(".concat(itemCounterDigitsSize + 1, "ch - ").concat(fixedBasePx, "px)");
    }
    return paddingLeft;
};
var $0c93a70a73f78a3d$var$stringifyStyle = function stringifyStyle(style) {
    return Object.entries(style).reduce(function(str, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        return "".concat(str).concat(key, ":").concat(value, ";");
    }, "");
};
function $0c93a70a73f78a3d$export$6d31fdb1d74cee3e(itemCounterDigitsSize, styleFormat) {
    var style = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $0c93a70a73f78a3d$var$CSS_VAR_NAMES.ITEM_COUNTER_PADDING, $0c93a70a73f78a3d$var$getItemCounterLeftPadding(itemCounterDigitsSize));
    if (styleFormat === 'string') return $0c93a70a73f78a3d$var$stringifyStyle(style);
    return style;
}

});

parcelRegister("eskLW", function(module, exports) {
$parcel$export(module.exports, "getItemCounterDigitsSize", () => $a863cb2158f9759f$export$320582fc14ba1e0f);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/list.ts
// If changes are made to this file, please make the same update in the linked file.

var $6jcTe = parcelRequire("6jcTe");




var $a863cb2158f9759f$export$8ef94ae42a3729bd = 1;
var $a863cb2158f9759f$export$cbefb5b89ef0719f = function getOrderFromOrderedListNode(orderedListNode) {
    var _orderedListNode$attr, _resolveOrder;
    var order = orderedListNode === null || orderedListNode === void 0 || (_orderedListNode$attr = orderedListNode.attrs) === null || _orderedListNode$attr === void 0 ? void 0 : _orderedListNode$attr.order;
    return (_resolveOrder = (0, $6jcTe.resolveOrder)(order)) !== null && _resolveOrder !== void 0 ? _resolveOrder : $a863cb2158f9759f$export$8ef94ae42a3729bd;
};
var $a863cb2158f9759f$export$320582fc14ba1e0f = function getItemCounterDigitsSize(options) {
    var _resolveOrder2, _String;
    var order = (_resolveOrder2 = (0, $6jcTe.resolveOrder)(options.order)) !== null && _resolveOrder2 !== void 0 ? _resolveOrder2 : $a863cb2158f9759f$export$8ef94ae42a3729bd;
    var itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
    var largestCounter = order + (itemsCount - 1);
    return (_String = String(largestCounter)) === null || _String === void 0 || (_String = _String.split('.')) === null || _String === void 0 || (_String = _String[0]) === null || _String === void 0 ? void 0 : _String.length;
};

});
parcelRegister("6jcTe", function(module, exports) {
$parcel$export(module.exports, "resolveOrder", () => $497e84127fa8d0a6$export$d445360e2a3c026b);
// resolve "order" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveStart"
// in packages/editor/adf-schema/src/schema/nodes/ordered-list.ts
var $497e84127fa8d0a6$export$d445360e2a3c026b = function resolveOrder(order) {
    var num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};

});



parcelRegister("jwO6B", function(module, exports) {
$parcel$export(module.exports, "default", () => $e377df60540b5f4b$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $eS9fF = parcelRequire("eS9fF");
function $e377df60540b5f4b$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, dataAttributes = _ref.dataAttributes, localId = _ref.localId, asInline = _ref.asInline;
    return(/*#__PURE__*/ // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("p", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, dataAttributes, {
        "data-local-id": localId,
        "data-as-inline": asInline
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $eS9fF.default), null, children)));
}

});
parcelRegister("eS9fF", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad3d490d42c7e378$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $ad3d490d42c7e378$export$2e2bcd8739ae039(props) {
    var children = props.children;
    var childCount = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.toArray(children).length;
    if (!childCount) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, "\xA0");
    return children;
}

});


parcelRegister("7UBSy", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c2b2555a7521c16$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $5c2b2555a7521c16$export$2e2bcd8739ae039(props) {
    if (props.allowPlaceholderText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-placeholder": "".concat(props.text)
    }, props.text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", null);
}

});

parcelRegister("1BsF5", function(module, exports) {
$parcel$export(module.exports, "default", () => $12af7abf61242b45$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $12af7abf61242b45$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("hr", {
        role: "presentation"
    });
}

});

parcelRegister("8tCqL", function(module, exports) {
$parcel$export(module.exports, "isTableResizingEnabled", () => isTableResizingEnabled);
$parcel$export(module.exports, "isStickyScrollbarEnabled", () => isStickyScrollbarEnabled);
$parcel$export(module.exports, "orderChildren", () => orderChildren);
$parcel$export(module.exports, "hasRowspan", () => hasRowspan);
$parcel$export(module.exports, "getRefTop", () => getRefTop);
$parcel$export(module.exports, "shouldHeaderStick", () => shouldHeaderStick);
$parcel$export(module.exports, "shouldHeaderPinBottom", () => shouldHeaderPinBottom);
$parcel$export(module.exports, "addSortableColumn", () => addSortableColumn);
$parcel$export(module.exports, "isHeaderRowEnabled", () => isHeaderRowEnabled);
$parcel$export(module.exports, "tableCanBeSticky", () => tableCanBeSticky);
$parcel$export(module.exports, "RefSyncBlockFakeBorders", () => RefSyncBlockFakeBorders);
$parcel$export(module.exports, "TableContainer", () => TableContainer);
$parcel$export(module.exports, "TableProcessorWithContainerStyles", () => TableProcessorWithContainerStyles);
$parcel$export(module.exports, "default", () => $62bed7ae84e05238$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $hrVpF = parcelRequire("hrVpF");

var $fMtrl = parcelRequire("fMtrl");
var $7NyDw = parcelRequire("7NyDw");

var $eCI84 = parcelRequire("eCI84");

var $gmeX4 = parcelRequire("gmeX4");

var $c6bEO = parcelRequire("c6bEO");

var $3s4hn = parcelRequire("3s4hn");
var $lvHsm = parcelRequire("lvHsm");
var $1fkTi = parcelRequire("1fkTi");
var $6g4cz = parcelRequire("6g4cz");

var $1LBcl = parcelRequire("1LBcl");

var $50U6m = parcelRequire("50U6m");

var $j3BGx = parcelRequire("j3BGx");

var $drUcN = parcelRequire("drUcN");

var $53SBn = parcelRequire("53SBn");

var $ky5Ao = parcelRequire("ky5Ao");

var $13ECD = parcelRequire("13ECD");

var $4qXRD = parcelRequire("4qXRD");

var $KYtRS = parcelRequire("KYtRS");

var $ABxtu = parcelRequire("ABxtu");

var $lAKm0 = parcelRequire("lAKm0");

var $dhEtU = parcelRequire("dhEtU");

var $65d1I = parcelRequire("65d1I");

var $gdaDF = parcelRequire("gdaDF");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var stickyContainerStyles = {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    height: "var(--ds-space-250, 20px)",
    // MAX_BROWSER_SCROLLBAR_HEIGHT
    // Follow editor to hide by default so it does not show empty gap in SSR
    // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    display: 'block',
    width: '100%',
    visibility: 'hidden',
    overflowX: 'auto',
    position: 'sticky',
    bottom: "var(--ds-space-0, 0px)",
    zIndex: 1
};
var isTableResizingEnabled = function isTableResizingEnabled(appearance) {
    return (0, $KYtRS.isFullWidthOrFullPageAppearance)(appearance) || (0, $KYtRS.isCommentAppearance)(appearance);
};
var isStickyScrollbarEnabled = function isStickyScrollbarEnabled(appearance) {
    return (0, $KYtRS.isFullWidthOrFullPageAppearance)(appearance) && (0, $j3BGx.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
};
var orderChildren = function orderChildren(children, tableNode, smartCardStorage, tableOrderStatus) {
    if (!tableOrderStatus || tableOrderStatus.order === (0, $gmeX4.SortOrder).NO_ORDER) return children;
    var order = tableOrderStatus.order, columnIndex = tableOrderStatus.columnIndex;
    var compareNodesInOrder = (0, $1fkTi.createCompareNodes)({
        getInlineCardTextFromStore: function getInlineCardTextFromStore(attrs) {
            var _ref = attrs, url = _ref.url;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    var tableArray = (0, $lvHsm.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    var tableArrayWithChildren = tableArray.map(function(rowNodes, index) {
        return {
            rowNodes: rowNodes,
            rowReact: children[index]
        };
    });
    var headerRow = tableArrayWithChildren.shift();
    var sortedTable = tableArrayWithChildren.sort(function(rowA, rowB) {
        return compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]);
    });
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map(function(elem) {
        return elem.rowReact;
    });
};
var hasRowspan = function hasRowspan(row) {
    var hasRowspan = false;
    row.forEach(function(cell) {
        return hasRowspan = hasRowspan || cell.attrs.rowspan > 1;
    });
    return hasRowspan;
};
var getRefTop = function getRefTop(refElement) {
    return Math.round(refElement.getBoundingClientRect().top);
};
var shouldHeaderStick = function shouldHeaderStick(scrollTop, tableTop, tableBottom, rowHeight) {
    return tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
};
var shouldHeaderPinBottom = function shouldHeaderPinBottom(scrollTop, tableBottom, rowHeight) {
    return tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
};
var addSortableColumn = function addSortableColumn(rows, tableOrderStatus, onSorting) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.map(rows, function(row, index) {
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
var isHeaderRowEnabled = function isHeaderRowEnabled(rows) {
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var children = rows[0].props.children;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $65d1I.TableHeader);
    return children.every(function(node) {
        return node.type === (0, $65d1I.TableHeader);
    });
};
var tableCanBeSticky = function tableCanBeSticky(node, children) {
    return isHeaderRowEnabled(children) && node && node.firstChild && !hasRowspan(node.firstChild);
};
/**
 * Fake left/right borders rendered as direct children of TABLE_CONTAINER
 * (the non-scrolling parent of the horizontally scrolling TABLE_NODE_WRAPPER).
 *
 * The visible styling for these divs lives in `tableFakeBorderStyles`
 * (`renderer/src/ui/Renderer/RendererStyleContainer.tsx`), which is applied
 * when `isInsideSyncBlock` is true.
 */ var TableFakeBorders = function TableFakeBorders(_ref2) {
    var isNumberColumnEnabled = _ref2.isNumberColumnEnabled;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        className: (0, $7NyDw.TableSharedCssClassName).TABLE_LEFT_BORDER,
        "data-with-numbered-table": isNumberColumnEnabled ? 'true' : undefined,
        "data-testid": "table-left-border"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        className: (0, $7NyDw.TableSharedCssClassName).TABLE_RIGHT_BORDER,
        "data-with-numbered-table": isNumberColumnEnabled ? 'true' : undefined,
        "data-testid": "table-right-border"
    }));
};
var RefSyncBlockFakeBorders = function RefSyncBlockFakeBorders(_ref3) {
    var isNumberColumnEnabled = _ref3.isNumberColumnEnabled;
    var _useRendererContext = (0, $ky5Ao.useRendererContext)(), nestedRendererType = _useRendererContext.nestedRendererType;
    var isInsideOfRefSyncBlock = nestedRendererType === 'syncedBlock';
    if (!isInsideOfRefSyncBlock) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(TableFakeBorders, {
        isNumberColumnEnabled: isNumberColumnEnabled
    });
};
var TableContainer = /*#__PURE__*/ function(_React$Component) {
    function TableContainer() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, TableContainer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _callSuper(this, TableContainer, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "state", {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "tableRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createRef());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "stickyHeaderRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createRef());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "stickyScrollbarRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createRef());
        // used for sync scroll + copying wrapper width to sticky header
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "stickyWrapperRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createRef());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "wrapperRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createRef());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "overflowParent", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "containerRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isInsideNestedRenderer", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isInsideTableCell", null);
        // Stores the last computed style values from render() for use by applyNestedRendererTableFix().
        // This avoids reading from the DOM which can be stale when React removes properties between renders.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "lastComputedStyle", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "resizeObserver", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "applyResizerChange", function(entries) {
            var wrapperWidth = _this.state.wrapperWidth;
            var headerRowHeight = _this.state.headerRowHeight;
            var _iterator = _createForOfIteratorHelper(entries), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var entry = _step.value;
                    if (entry.target === _this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                    else if (entry.target === _this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
            if (headerRowHeight !== _this.state.headerRowHeight || wrapperWidth !== _this.state.wrapperWidth) _this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        });
        /**
     * Callback ref that captures the container DOM element and also forwards
     * to the handleRef prop from the overflow shadow HOC.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "setContainerRef", function(el) {
            if (_this.containerRef !== el) {
                _this._isInsideNestedRenderer = null;
                _this._isInsideTableCell = null;
            }
            _this.containerRef = el;
            var handleRef = _this.props.handleRef;
            if (typeof handleRef === 'function') handleRef(el);
            else if (handleRef && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(handleRef) === 'object') // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            handleRef.current = el;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "componentWillUnmount", function() {
            if (_this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            _this.overflowParent.removeEventListener('scroll', _this.onScroll);
            if (_this.nextFrame) cancelAnimationFrame(_this.nextFrame);
            if (_this.resizeObserver) _this.resizeObserver.disconnect();
            if (_this.stickyScrollbar) _this.stickyScrollbar.dispose();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getScrollTop", function() {
            var stickyHeaders = _this.props.stickyHeaders;
            var offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (_this.overflowParent ? _this.overflowParent.top : 0) + offsetTop;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "updateSticky", function() {
            var tableElem = _this.tableRef.current;
            var refElem = _this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            var scrollTop = _this.getScrollTop() + (0, $lAKm0.tableStickyPadding);
            var tableTop = getRefTop(tableElem);
            var tableBottom = tableTop + tableElem.clientHeight;
            var shouldSticky = shouldHeaderStick(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            var shouldPin = shouldHeaderPinBottom(scrollTop, tableBottom, refElem.clientHeight);
            var stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (_this.state.stickyMode !== stickyMode) _this.setState({
                stickyMode: stickyMode
            });
            _this.nextFrame = undefined;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onScroll", function() {
            if (!_this.nextFrame) _this.nextFrame = requestAnimationFrame(_this.updateSticky);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onWrapperScrolled", function() {
            if (!_this.wrapperRef.current || !_this.stickyWrapperRef.current) return;
            _this.stickyWrapperRef.current.scrollLeft = _this.wrapperRef.current.scrollLeft;
            if (_this.stickyScrollbarRef.current) _this.stickyScrollbarRef.current.scrollLeft = _this.wrapperRef.current.scrollLeft;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "grabFirstRowRef", function(children) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.map(children || false, function(child, idx) {
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).cloneElement(child, {
                    innerRef: _this.stickyHeaderRef
                });
                return child;
            });
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(TableContainer, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(TableContainer, [
        {
            key: "isInsideNestedRenderer",
            value: /**
     * Checks if this table is inside a nested renderer (e.g. Include Page macro)
     * by looking for multiple .ak-renderer-document ancestors in the DOM.
     * The result is cached since a table's position in the DOM tree is stable after mount.
     */ function isInsideNestedRenderer() {
                if (this._isInsideNestedRenderer !== null) return this._isInsideNestedRenderer;
                if (!this.containerRef) return false;
                var docAncestorCount = 0;
                var el = this.containerRef.parentElement;
                while(el){
                    if (el.classList.contains((0, $53SBn.RendererCssClassName).DOCUMENT)) {
                        docAncestorCount++;
                        if (docAncestorCount >= 2) {
                            this._isInsideNestedRenderer = true;
                            return true;
                        }
                    }
                    el = el.parentElement;
                }
                this._isInsideNestedRenderer = false;
                return false;
            }
        },
        {
            key: "isInsideTableCell",
            value: function isInsideTableCell() {
                if (this._isInsideTableCell !== null) return this._isInsideTableCell;
                if (!this.containerRef) return false;
                this._isInsideTableCell = Boolean(this.containerRef.closest('td, th'));
                return this._isInsideTableCell;
            }
        },
        {
            key: "isInsideTableContext",
            value: function isInsideTableContext() {
                return Boolean(this.props.isInsideOfTable || this.isInsideTableCell());
            }
        },
        {
            key: "applyNestedRendererTableFix",
            value: function applyNestedRendererTableFix() {
                var _this$props$tableNode;
                if (!this.containerRef || !(0, $50U6m.fg)('platform_nested_table_style_override')) return;
                if (!this.isInsideNestedRenderer() || this.isInsideTableContext()) return;
                var _this$lastComputedSty = this.lastComputedStyle, width = _this$lastComputedSty.width, left = _this$lastComputedSty.left, marginLeft = _this$lastComputedSty.marginLeft;
                var style = this.containerRef.style;
                // A table is "explicitly resized" when the author set a width on the node.
                // Non-resized tables instead take a default layout cap (e.g. 760px/1800px)
                // derived from the outer renderer's appearance.
                var isExplicitlyResized = Boolean((_this$props$tableNode = this.props.tableNode) === null || _this$props$tableNode === void 0 ? void 0 : _this$props$tableNode.attrs.width);
                if (!isExplicitlyResized && (0, $50U6m.fg)('platform_nested_table_style_override_2')) {
                    // PGXT-10421: For a NON-resized table inside a nested renderer (e.g. an
                    // Excerpt macro body), the computed width is a default layout cap
                    // (760px/1800px, or a `cqw` length for full-page appearances) taken from
                    // the *outer* renderer's width context. That value does not match the
                    // macro's own box, so promoting it to inline `!important` makes the table
                    // ignore the available space and collapse to its first columns.
                    //
                    // These tables have no author-chosen size to preserve, so re-assert the
                    // parent stylesheet's intent — fill the available box (`width: 100%`) —
                    // with inline `!important` priority so it survives React re-renders and
                    // wins over the stylesheet rule that leaks into nested renderers.
                    style.setProperty('width', '100%', 'important');
                    style.setProperty('max-width', '100%', 'important');
                    style.setProperty('left', '0', 'important');
                    style.setProperty('margin-left', '0', 'important');
                    return;
                }
                // PGXT-10226: An explicitly resized table inside a nested renderer (e.g.
                // Include Page macro) must keep its author-chosen width and position. The
                // parent stylesheet forces `width: 100% !important; left: 0 !important`,
                // which would stretch and indent it, so we promote the component's own
                // computed width/left with inline `!important` to win the cascade.
                style.setProperty('width', width || 'auto', 'important');
                style.setProperty('max-width', '100%', 'important');
                style.setProperty('left', left || 'auto', 'important');
                style.setProperty('margin-left', marginLeft || '0', 'important');
            }
        },
        {
            key: "componentDidMount",
            value: /**
     * Starts observing table dimensions and wires sticky header/scrollbar behavior after mount.
     *
     * @example
     */ function componentDidMount() {
                this.resizeObserver = new ResizeObserver(this.applyResizerChange);
                if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
                if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
                if (this.props.stickyHeaders) {
                    var _this$props$stickyHea;
                    this.overflowParent = (0, $lAKm0.OverflowParent).fromElement(this.tableRef.current, (_this$props$stickyHea = this.props.stickyHeaders) === null || _this$props$stickyHea === void 0 ? void 0 : _this$props$stickyHea.defaultScrollRootId_DO_NOT_USE);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.overflowParent.addEventListener('scroll', this.onScroll);
                }
                if (this.wrapperRef.current && isStickyScrollbarEnabled(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $gdaDF.TableStickyScrollbar)(this.wrapperRef.current);
                this.applyNestedRendererTableFix();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                // toggling sticky headers visiblity
                if (this.props.stickyHeaders && !this.overflowParent) {
                    var _this$props$stickyHea2;
                    this.overflowParent = (0, $lAKm0.OverflowParent).fromElement(this.tableRef.current, (_this$props$stickyHea2 = this.props.stickyHeaders) === null || _this$props$stickyHea2 === void 0 ? void 0 : _this$props$stickyHea2.defaultScrollRootId_DO_NOT_USE);
                } else if (!this.props.stickyHeaders && this.overflowParent) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.overflowParent.removeEventListener('scroll', this.onScroll);
                    this.overflowParent = null;
                }
                // offsetTop might have changed, re-position sticky header
                if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
                // sync horizontal scroll in floating div when toggling modes
                if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
                // React re-applies the style prop on every render, which overwrites the
                // !important priorities set at mount time. Re-apply after each update.
                this.applyNestedRendererTableFix();
            }
        },
        {
            key: "pinTop",
            get: /**
     * Calculates the top offset used when the sticky header is pinned to the table bottom.
     */ function get() {
                if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
                return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $fMtrl.tableMarginTop) - (0, $lAKm0.tableStickyPadding);
            }
        },
        {
            key: "shouldAddOverflowParentOffsetTop_DO_NOT_USE",
            get: function get() {
                // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
                // AND the StickyHeaderConfig specifies a default scroll root id
                // AND the OverflowParent is the corresponding element
                // THEN we should add the OverflowParent offset top (RETURN TRUE)
                return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
            }
        },
        {
            key: "stickyTop",
            get: function get() {
                switch(this.state.stickyMode){
                    case 'pin-bottom':
                        return this.pinTop;
                    case 'stick':
                        var offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                        if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                            var overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                            return offsetTop + overflowParentOffsetTop;
                        } else return offsetTop;
                    default:
                        return undefined;
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, isNumberColumnEnabled = _this$props.isNumberColumnEnabled, layout = _this$props.layout, columnWidths = _this$props.columnWidths, stickyHeaders = _this$props.stickyHeaders, tableNode = _this$props.tableNode, rendererAppearance = _this$props.rendererAppearance, isInsideOfBlockNode = _this$props.isInsideOfBlockNode, isInsideOfNestedRenderer = _this$props.isInsideOfNestedRenderer, isInsideOfTable = _this$props.isInsideOfTable, isinsideMultiBodiedExtension = _this$props.isinsideMultiBodiedExtension, allowTableAlignment = _this$props.allowTableAlignment, allowTableResizing = _this$props.allowTableResizing, isPresentational = _this$props.isPresentational, allowFixedColumnWidthOption = _this$props.allowFixedColumnWidthOption;
                var stickyMode = this.state.stickyMode;
                var lineLengthFixedWidth = (0, $1LBcl.akEditorDefaultLayoutWidth);
                var updatedLayout;
                var fullPageRendererWidthCSS = (0, $j3BGx.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                    exposure: true
                }) ? 'calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)' : "100cqw - ".concat((0, $13ECD.FullPagePadding), "px * 2");
                var renderWidthCSS = rendererAppearance === 'full-page' ? fullPageRendererWidthCSS : "100cqw";
                var calcDefaultLayoutWidthByAppearance = function calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode) {
                    if (rendererAppearance === 'max' && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width)) return "min(".concat((0, $1LBcl.akEditorMaxWidthLayoutWidth), "px, ").concat(renderWidthCSS, ")");
                    else if (rendererAppearance === 'full-width' && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width)) return "min(".concat((0, $1LBcl.akEditorFullWidthLayoutWidth), "px, ").concat(renderWidthCSS, ")");
                    else if (rendererAppearance === 'comment' && allowTableResizing && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width)) return renderWidthCSS;
                    else {
                        // custom width, or width mapped to breakpoint
                        var tableContainerWidth = (0, $hrVpF.getTableContainerWidth)(tableNode);
                        return "min(".concat(tableContainerWidth, "px, ").concat(renderWidthCSS, ")");
                    }
                };
                var tableWidthCSS = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
                // Logic for table alignment in renderer
                var isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
                var fullWidthLineLengthCSS = "min(".concat((0, $1LBcl.akEditorFullWidthLayoutWidth), "px, ").concat(renderWidthCSS, ")");
                var maxWidthLineLengthCSS = "min(".concat((0, $1LBcl.akEditorMaxWidthLayoutWidth), "px, ").concat(renderWidthCSS, ")");
                var isCommentAppearanceAndTableAlignmentEnabled = (0, $KYtRS.isCommentAppearance)(rendererAppearance) && allowTableAlignment;
                var lineLengthCSS = (0, $KYtRS.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLengthCSS : (0, $KYtRS.isMaxWidthAppearance)(rendererAppearance) ? maxWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : "".concat(lineLengthFixedWidth, "px");
                var tableWidthNew = (0, $hrVpF.getTableContainerWidth)(tableNode);
                var shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $KYtRS.isFullPageAppearance)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $KYtRS.isFullWidthAppearance)(rendererAppearance) || (0, $KYtRS.isMaxWidthAppearance)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
                var leftCSS;
                if (shouldCalculateLeftForAlignment) leftCSS = "(".concat(tableWidthCSS, " - ").concat(lineLengthCSS, ") / 2");
                if (!shouldCalculateLeftForAlignment && (0, $KYtRS.isFullPageAppearance)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
                // When the screen is super wide we want table to break out.
                // However if screen is smaller than 760px. We want table align to left.
                leftCSS = "min(0px, ".concat(lineLengthCSS, " - ").concat(tableWidthCSS, ") / 2");
                var children = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.toArray(this.props.children);
                // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
                // This check caters for those tables and helps with SSR logic
                var isFullWidth = !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) && rendererAppearance === 'full-width' && layout !== 'full-width';
                if (isFullWidth) updatedLayout = 'full-width';
                else if (tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) updatedLayout = 'custom';
                else updatedLayout = layout;
                var finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
                // We can only use CSS to determine the width when we have a known width in container.
                // When appearance is full-page, full-width or comment we use CSS based width calculation.
                // Otherwise it's fixed table width (customized width) or inherit.
                if (rendererAppearance === 'full-page' || rendererAppearance === 'full-width' || rendererAppearance === 'max') finalTableContainerWidth = allowTableResizing ? "calc(".concat(tableWidthCSS, ")") : 'inherit';
                if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
                // it is most likely a table created before "Support Table in Comments" FF was enabled
                // and we would see a bug ED-24795. A table created before "Support Table in Comments",
                // should inhirit the width of the renderer container.
                // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
                // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
                finalTableContainerWidth = tableNode !== null && tableNode !== void 0 && tableNode.attrs.width && (tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.width) !== (0, $1LBcl.akEditorDefaultLayoutWidth) ? "calc(".concat(tableWidthCSS, ")") : 'inherit';
                if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
                // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
                // instead of 760 that was set on tableNode when the table had been published.
                finalTableContainerWidth = ((tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout) === 'align-start' || (tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout) === 'center') && tableNode !== null && tableNode !== void 0 && tableNode.attrs.width ? "calc(".concat(tableWidthCSS, ")") : 'inherit';
                var isContentModeTable = (0, $eCI84.isTableInContentMode)({
                    tableNode: tableNode,
                    isSupported: (0, $ABxtu.isContentModeSupported)({
                        allowTableResizing: allowTableResizing,
                        rendererAppearance: rendererAppearance
                    }),
                    isTableNested: isInsideOfBlockNode || isInsideOfNestedRenderer || isInsideOfTable
                });
                var style = _objectSpread(_objectSpread({}, isContentModeTable && {
                    '--renderer-table-max-width': renderWidthCSS
                }), {}, {
                    width: finalTableContainerWidth,
                    left: leftCSS ? "calc(".concat(leftCSS, ")") : undefined,
                    marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? "calc(-1 * (".concat(leftCSS, "))") : undefined
                });
                // Store computed style values for applyNestedRendererTableFix() to use.
                // Reading from props rather than the DOM ensures correctness when React
                // removes properties (transitions from set to undefined) between renders.
                this.lastComputedStyle = {
                    width: typeof style.width === 'number' ? "".concat(style.width, "px") : style.width,
                    left: style.left,
                    marginLeft: style.marginLeft
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: "".concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, " ").concat(this.props.shadowClassNames || ''),
                    "data-layout": updatedLayout,
                    "data-testid": "table-container",
                    ref: this.setContainerRef,
                    style: style
                }, isStickyScrollbarEnabled(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                    "data-testid": "sticky-scrollbar-sentinel-top"
                }), stickyHeaders && tableNode && !isContentModeTable && tableCanBeSticky(tableNode, children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $lAKm0.StickyTable), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    tableWidth: "inherit",
                    renderWidth: 0,
                    layout: layout,
                    handleRef: this.props.handleRef,
                    shadowClassNames: this.props.shadowClassNames,
                    top: this.stickyTop,
                    mode: stickyMode,
                    innerRef: this.stickyWrapperRef,
                    wrapperWidth: this.state.wrapperWidth,
                    columnWidths: columnWidths,
                    rowHeight: this.state.headerRowHeight,
                    tableNode: tableNode,
                    rendererAppearance: rendererAppearance,
                    allowTableResizing: allowTableResizing,
                    allowFixedColumnWidthOption: allowFixedColumnWidthOption
                }, [
                    children && children[0]
                ]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER,
                    ref: this.wrapperRef,
                    "data-number-column": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.isNumberColumnEnabled,
                    "data-layout": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout,
                    "data-autosize": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.__autoSize,
                    "data-table-local-id": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.localId,
                    "data-table-width": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.width,
                    "data-vc": "table-node-wrapper",
                    onScroll: this.props.stickyHeaders && this.onWrapperScrolled
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dhEtU.Table), {
                    innerRef: this.tableRef,
                    columnWidths: columnWidths,
                    layout: layout,
                    renderWidth: 0,
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    tableNode: tableNode,
                    rendererAppearance: rendererAppearance,
                    isInsideOfBlockNode: isInsideOfBlockNode,
                    isInsideOfNestedRenderer: isInsideOfNestedRenderer,
                    isInsideOfTable: isInsideOfTable,
                    isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                    allowTableResizing: allowTableResizing,
                    isPresentational: isPresentational,
                    allowFixedColumnWidthOption: allowFixedColumnWidthOption
                }, this.grabFirstRowRef(children))), isStickyScrollbarEnabled(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: "".concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER, "-view-page"),
                    ref: this.stickyScrollbarRef,
                    "data-vc": "table-sticky-scrollbar-container",
                    style: stickyContainerStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                    style: {
                        width: '100%',
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        height: '100%'
                    }
                })), isStickyScrollbarEnabled(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                    "data-testid": "sticky-scrollbar-sentinel-bottom"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(RefSyncBlockFakeBorders, {
                    isNumberColumnEnabled: isNumberColumnEnabled
                })));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component);
var getCellEdgePropsByCellOffset = function getCellEdgePropsByCellOffset(tableNode, isNumberColumnEnabled) {
    var cellEdgePropsByCellOffset = new Map();
    var cellRightByCellOffset = new Map();
    var occupiedGrid = [];
    var tableWidth = 0;
    var cellOffset = 0;
    tableNode.forEach(function(rowNode, _rowOffset, rowIndex) {
        var _occupiedGrid$rowInde;
        occupiedGrid[rowIndex] = (_occupiedGrid$rowInde = occupiedGrid[rowIndex]) !== null && _occupiedGrid$rowInde !== void 0 ? _occupiedGrid$rowInde : [];
        var columnIndex = 0;
        cellOffset += 1;
        rowNode.forEach(function(cellNode) {
            while(occupiedGrid[rowIndex][columnIndex])columnIndex += 1;
            var colspan = cellNode.attrs.colspan || 1;
            var rowspan = cellNode.attrs.rowspan || 1;
            var cellLeft = columnIndex;
            var cellRight = cellLeft + colspan;
            var cellTop = rowIndex;
            var cellBottom = cellTop + rowspan;
            for(var row = cellTop; row < cellBottom; row += 1){
                var _occupiedGrid$row;
                occupiedGrid[row] = (_occupiedGrid$row = occupiedGrid[row]) !== null && _occupiedGrid$row !== void 0 ? _occupiedGrid$row : [];
                for(var column = cellLeft; column < cellRight; column += 1)occupiedGrid[row][column] = true;
            }
            tableWidth = Math.max(tableWidth, cellRight);
            cellRightByCellOffset.set(cellOffset, cellRight);
            cellEdgePropsByCellOffset.set(cellOffset, {
                reachesBottom: cellBottom >= tableNode.childCount,
                // With number column enabled, PM column 0 is not visually leftmost and must not get `data-reaches-left`.
                reachesLeft: cellLeft === 0 && !isNumberColumnEnabled,
                reachesRight: false,
                reachesTop: cellTop === 0
            });
            columnIndex = cellRight;
            cellOffset += cellNode.nodeSize;
        });
        cellOffset += 1;
    });
    cellRightByCellOffset.forEach(function(cellRight, currentCellOffset) {
        var edgeProps = cellEdgePropsByCellOffset.get(currentCellOffset);
        if (edgeProps) edgeProps.reachesRight = cellRight >= tableWidth;
    });
    return cellEdgePropsByCellOffset;
};
var isRenderedTableCell = function isRenderedTableCell(element) {
    var _ref4 = element.props, nodeType = _ref4.nodeType;
    return nodeType === 'tableCell' || nodeType === 'tableHeader' || element.type === (0, $65d1I.TableCell) || element.type === (0, $65d1I.TableHeader);
};
var addTableCellEdgePropsThroughWrappers = function addTableCellEdgePropsThroughWrappers(rows, tableNode, isNumberColumnEnabled) {
    try {
        if (!tableNode) return rows;
        var cellEdgePropsByCellOffset = getCellEdgePropsByCellOffset(tableNode, isNumberColumnEnabled);
        var cellOffset = 0;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.map(rows, function(row, rowIndex) {
            var rowNode = tableNode.child(rowIndex);
            cellOffset += 1;
            var cellIndex = 0;
            var _addEdgePropsToRenderedCells = function addEdgePropsToRenderedCells(element) {
                if (isRenderedTableCell(element)) {
                    var cellNode = rowNode.child(cellIndex);
                    var edgeProps = cellEdgePropsByCellOffset.get(cellOffset);
                    cellIndex += 1;
                    cellOffset += cellNode.nodeSize;
                    return edgeProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).cloneElement(element, edgeProps) : element;
                }
                var _ref5 = element.props, children = _ref5.children;
                if (children === undefined) return element;
                var childrenWithEdgeProps = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.map(children, function(child) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).isValidElement(child) ? _addEdgePropsToRenderedCells(child) : child;
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).cloneElement(element, undefined, childrenWithEdgeProps);
            };
            var rowWithEdgeProps = _addEdgePropsToRenderedCells(row);
            if (cellIndex !== rowNode.childCount) throw new Error('Rendered table row does not match its document node');
            cellOffset += 1;
            return rowWithEdgeProps;
        });
    } catch (_unused) {
        // Renderer can receive malformed historical ADF. If the table shape cannot
        // be described safely, keep rendering without rounded edge metadata.
        return rows;
    }
};
var TableProcessorWithContainerStyles = /*#__PURE__*/ function(_React$Component2) {
    function TableProcessorWithContainerStyles() {
        var _this2;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, TableProcessorWithContainerStyles);
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        _this2 = _callSuper(this, TableProcessorWithContainerStyles, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this2, "state", {
            tableOrderStatus: undefined
        });
        // adds sortable + re-orders children
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this2, "addSortableColumn", function(childrenArray) {
            var _this2$props = _this2.props, tableNode = _this2$props.tableNode, allowColumnSorting = _this2$props.allowColumnSorting, smartCardStorage = _this2$props.smartCardStorage;
            var tableOrderStatus = _this2.state.tableOrderStatus;
            if (allowColumnSorting && isHeaderRowEnabled(childrenArray) && tableNode && !(0, $6g4cz.hasMergedCell)(tableNode)) return addSortableColumn(orderChildren(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, _this2.changeSortOrder);
            return childrenArray;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this2, "changeSortOrder", function(columnIndex, sortOrder) {
            _this2.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this2, "addNumberColumnIndexes", function(rows) {
            var isNumberColumnEnabled = _this2.props.isNumberColumnEnabled;
            var headerRowEnabled = isHeaderRowEnabled(rows);
            var lastRowIndex = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.count(rows) - 1;
            return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.map(rows, function(row, index) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1,
                    isFirstRow: index === 0,
                    isLastRow: index === lastRowIndex
                });
            });
        });
        return _this2;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(TableProcessorWithContainerStyles, _React$Component2);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(TableProcessorWithContainerStyles, [
        {
            key: "render",
            value: /**
     * Renders processed table children inside the table container.
     *
     * @example
     */ function render() {
                var _this$props2 = this.props, allowColumnSorting = _this$props2.allowColumnSorting, allowFixedColumnWidthOption = _this$props2.allowFixedColumnWidthOption, allowTableAlignment = _this$props2.allowTableAlignment, allowTableResizing = _this$props2.allowTableResizing, children = _this$props2.children, columnWidths = _this$props2.columnWidths, disableTableOverflowShadow = _this$props2.disableTableOverflowShadow, handleRef = _this$props2.handleRef, isinsideMultiBodiedExtension = _this$props2.isinsideMultiBodiedExtension, isInsideOfBlockNode = _this$props2.isInsideOfBlockNode, isInsideOfNestedRenderer = _this$props2.isInsideOfNestedRenderer, isInsideOfTable = _this$props2.isInsideOfTable, isNumberColumnEnabled = _this$props2.isNumberColumnEnabled, isPresentational = _this$props2.isPresentational, layout = _this$props2.layout, rendererAppearance = _this$props2.rendererAppearance, renderWidth = _this$props2.renderWidth, shadowClassNames = _this$props2.shadowClassNames, smartCardStorage = _this$props2.smartCardStorage, stickyHeaders = _this$props2.stickyHeaders, tabIndex = _this$props2.tabIndex, tableNode = _this$props2.tableNode;
                if (!children) return null;
                var childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.toArray(children);
                var childrenWithTableEdgeProps = (0, $drUcN.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? addTableCellEdgePropsThroughWrappers(childrenArray, tableNode, isNumberColumnEnabled) : childrenArray;
                var orderedChildren = (0, $3s4hn.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenWithTableEdgeProps);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(TableContainer, {
                    allowColumnSorting: allowColumnSorting,
                    allowFixedColumnWidthOption: allowFixedColumnWidthOption,
                    allowTableAlignment: allowTableAlignment,
                    allowTableResizing: allowTableResizing,
                    columnWidths: columnWidths,
                    disableTableOverflowShadow: disableTableOverflowShadow,
                    handleRef: handleRef,
                    isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                    isInsideOfBlockNode: isInsideOfBlockNode,
                    isInsideOfNestedRenderer: isInsideOfNestedRenderer,
                    isInsideOfTable: isInsideOfTable,
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    isPresentational: isPresentational,
                    layout: layout,
                    rendererAppearance: rendererAppearance,
                    renderWidth: renderWidth,
                    shadowClassNames: shadowClassNames,
                    smartCardStorage: smartCardStorage,
                    stickyHeaders: stickyHeaders,
                    tabIndex: tabIndex,
                    tableNode: tableNode
                }, orderedChildren);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var TableWithShadowsAndContainerStyles = (0, $c6bEO.default)(TableProcessorWithContainerStyles, {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: ":scope > .".concat((0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER),
    useShadowObserver: true
});
var TableWithWidth = function TableWithWidth(props) {
    var _props$columnWidths;
    var _useRendererContext2 = (0, $ky5Ao.useRendererContext)(), isTopLevelRenderer = _useRendererContext2.isTopLevelRenderer;
    var isInsideOfNestedRenderer = isTopLevelRenderer === false;
    var colWidthsSum = // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    ((_props$columnWidths = props.columnWidths) === null || _props$columnWidths === void 0 ? void 0 : _props$columnWidths.reduce(function(total, val) {
        return total + val;
    }, 0)) || 0;
    if (colWidthsSum || props.allowTableResizing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(TableWithShadowsAndContainerStyles, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        isInsideOfNestedRenderer: isInsideOfNestedRenderer
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(TableProcessorWithContainerStyles, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        isInsideOfNestedRenderer: isInsideOfNestedRenderer
    }));
};
var _default_1 = (0, $4qXRD.withSmartCardStorage)(TableWithWidth);
var $62bed7ae84e05238$export$2e2bcd8739ae039 = _default_1;

});
parcelRegister("hrVpF", function(module, exports) {
$parcel$export(module.exports, "getTableContainerWidth", () => $cb417e52aeae7756$export$3930799be057b305);

var $4inI8 = parcelRequire("4inI8");

var $1LBcl = parcelRequire("1LBcl");

var $3jgn3 = parcelRequire("3jgn3");

var $2q0Pn = parcelRequire("2q0Pn");

var $fMtrl = parcelRequire("fMtrl");

var $2XMn4 = parcelRequire("2XMn4");
var $cb417e52aeae7756$var$GRID_SIZE = 8;
var $cb417e52aeae7756$var$NESTED_DND_GUTTER_OFFSET = 8;
var $cb417e52aeae7756$var$NESTED_DND_MARGIN_OFFSET = 12;
var $cb417e52aeae7756$export$9b77d38feba5446 = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    default: (0, $1LBcl.akEditorDefaultLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    wide: (0, $1LBcl.akEditorWideLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    'full-width': (0, $1LBcl.akEditorFullWidthLayoutWidth)
};
var $cb417e52aeae7756$export$d76cc081ce1449a8 = function getParentNodeWidth(pos, state, containerWidth, isFullWidthModeEnabled) {
    var _contextPanelPluginKe, _contextPanelPluginKe2;
    if (!pos) return;
    var node = $cb417e52aeae7756$export$84f6ca4f6812e69a(pos, state);
    if (!node) return;
    var layout = node.attrs.layout || 'default';
    var schema = state.schema;
    var breakoutMark = schema.marks.breakout && schema.marks.breakout.isInSet(node.marks);
    if (breakoutMark && breakoutMark.attrs.mode) layout = breakoutMark.attrs.mode;
    var breakoutWidth = breakoutMark ? breakoutMark.attrs.width : undefined;
    var parentWidth = $cb417e52aeae7756$var$calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled, breakoutWidth);
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    var contextPanelPluginKey = {
        key: 'contextPanelPluginKey$',
        getState: function getState(state) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return state['contextPanelPluginKey$'];
        }
    };
    switch(node.type){
        case schema.nodes.layoutSection:
            // Calculate width of parent layout column when
            // Parallel layout with viewport greater than 1024px
            // OR side panel of an extension is open and change the node width to smaller than containerWidth
            if (containerWidth.width > (0, $1LBcl.gridMediumMaxWidth) || ((_contextPanelPluginKe = contextPanelPluginKey.getState(state)) === null || _contextPanelPluginKe === void 0 ? void 0 : _contextPanelPluginKe.contents.length) > 0 && ((_contextPanelPluginKe2 = contextPanelPluginKey.getState(state)) === null || _contextPanelPluginKe2 === void 0 ? void 0 : _contextPanelPluginKe2.contents[0]) !== undefined) {
                // margin between sections
                parentWidth -= ((0, $2q0Pn.LAYOUT_SECTION_MARGIN) + $cb417e52aeae7756$var$NESTED_DND_MARGIN_OFFSET + 2) * (node.childCount - 1);
                var $pos = state.doc.resolve(pos);
                var column = (0, $4inI8.findParentNodeOfTypeClosestToPos)($pos, [
                    state.schema.nodes.layoutColumn
                ]);
                if (column && column.node && !isNaN(column.node.attrs.width)) // get exact width of parent layout column using node attrs
                parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
            }
            // account for the padding of the parent node
            parentWidth -= ((0, $2q0Pn.LAYOUT_COLUMN_PADDING) + $cb417e52aeae7756$var$NESTED_DND_GUTTER_OFFSET) * 2;
            break;
        case schema.nodes.bodiedExtension:
            parentWidth -= (0, $3jgn3.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.extensionFrame:
            parentWidth -= (0, $3jgn3.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.expand:
            // padding
            parentWidth -= $cb417e52aeae7756$var$GRID_SIZE * 2;
            // gutter offset
            parentWidth += $cb417e52aeae7756$var$GRID_SIZE * 3;
            // padding right
            parentWidth -= $cb417e52aeae7756$var$GRID_SIZE;
            // padding left
            parentWidth -= $cb417e52aeae7756$var$GRID_SIZE * 4 - $cb417e52aeae7756$var$GRID_SIZE / 2;
            break;
        case schema.nodes.tableCell:
        case schema.nodes.tableHeader:
            // Calculate the available column width
            if (Array.isArray(node.attrs.colwidth)) parentWidth = node.attrs.colwidth.slice(0, node.attrs.colspan).reduce(function(sum, width) {
                return sum + width;
            }, 0);
            // Compensate for padding
            parentWidth -= (0, $fMtrl.tableCellPadding) * 2;
            break;
    }
    parentWidth -= 2; // border
    return parentWidth;
};
var $cb417e52aeae7756$export$84f6ca4f6812e69a = function getNestedParentNode(tablePos, state) {
    if (tablePos === undefined) return null;
    var $pos = state.doc.resolve(tablePos);
    var parent = (0, $4inI8.findParentNodeOfTypeClosestToPos)($pos, [
        state.schema.nodes.bodiedExtension,
        state.schema.nodes.extensionFrame,
        state.schema.nodes.layoutSection,
        state.schema.nodes.expand,
        state.schema.nodes.tableCell,
        state.schema.nodes.tableHeader,
        state.schema.nodes.bodiedSyncBlock
    ]);
    return parent ? parent.node : null;
};
var $cb417e52aeae7756$var$calcBreakoutNodeWidth = function calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled, breakoutWidth) {
    if (breakoutWidth) return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, breakoutWidth) : // container width minus breakout padding
    // --ak-editor--breakout-full-page-guttering-padding = (--ak-editor--large-gutter-padding * 2) + --ak-editor--default-gutter-padding
    Math.min(containerWidth.width - ((0, $1LBcl.akEditorGutterPaddingDynamic)() * 2 + (0, $1LBcl.akEditorGutterPadding)), breakoutWidth);
    return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, (0, $1LBcl.akEditorFullWidthLayoutWidth)) : (0, $2XMn4.absoluteBreakoutWidth)(layout, containerWidth.width);
};
var $cb417e52aeae7756$export$3930799be057b305 = function getTableContainerWidth(node) {
    if (node !== null && node !== void 0 && node.attrs.width) return node.attrs.width;
    return $cb417e52aeae7756$export$9b77d38feba5446[node === null || node === void 0 ? void 0 : node.attrs.layout] || (0, $1LBcl.akEditorDefaultLayoutWidth);
};
var $cb417e52aeae7756$export$9724081a0d43786a = function getTableWidthWithNumberColumn(node, offset) {
    var isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
    if (isNumberColumnEnabled && offset > 0) return $cb417e52aeae7756$export$3930799be057b305(node) - offset;
    return $cb417e52aeae7756$export$3930799be057b305(node);
};

});
parcelRegister("3jgn3", function(module, exports) {
$parcel$export(module.exports, "BODIED_EXT_PADDING", () => $268fd85975958ef1$export$5ac5087fe1217160);
var $268fd85975958ef1$export$f5ecdce4c60ff98b = 8;
var $268fd85975958ef1$export$5ac5087fe1217160 = $268fd85975958ef1$export$f5ecdce4c60ff98b * 2;
var $268fd85975958ef1$export$91624ec52c59c24c = 12;

});

parcelRegister("2q0Pn", function(module, exports) {
$parcel$export(module.exports, "LAYOUT_SECTION_MARGIN", () => $1c2ea6dac5ad5bac$export$cd04f19842abff0);
$parcel$export(module.exports, "LAYOUT_COLUMN_PADDING", () => $1c2ea6dac5ad5bac$export$a1bb91aa2d5fcce8);
var $1c2ea6dac5ad5bac$export$cd04f19842abff0 = 8;
var $1c2ea6dac5ad5bac$export$a1bb91aa2d5fcce8 = $1c2ea6dac5ad5bac$export$cd04f19842abff0 * 1.5;
var $1c2ea6dac5ad5bac$export$e5ee675b2c7e739b = 50;

});

parcelRegister("fMtrl", function(module, exports) {
$parcel$export(module.exports, "tableMarginTop", () => $b7d22ce51fe68d56$export$808015ab1dd6897a);
$parcel$export(module.exports, "tableCellMinWidth", () => $b7d22ce51fe68d56$export$531f77930bf508de);
$parcel$export(module.exports, "tableCellBorderWidth", () => $b7d22ce51fe68d56$export$72aad729077aa0fb);
$parcel$export(module.exports, "tableCellPadding", () => $b7d22ce51fe68d56$export$e56b8ca552b280f6);

var $lAD7C = parcelRequire("lAD7C");

var $74Zh5 = parcelRequire("74Zh5");

var $1LBcl = parcelRequire("1LBcl");
var $5wL5P = parcelRequire("5wL5P");

var $50U6m = parcelRequire("50U6m");

var $3tz1M = parcelRequire("3tz1M");

var $6TmbT = parcelRequire("6TmbT");

var $4vXmi = parcelRequire("4vXmi");

var $knSf2 = parcelRequire("knSf2");

var $iv75Q = parcelRequire("iv75Q");

var $7NyDw = parcelRequire("7NyDw");

var $b7d22ce51fe68d56$var$_templateObject, $b7d22ce51fe68d56$var$_templateObject2;
var $b7d22ce51fe68d56$export$808015ab1dd6897a = 24;
var $b7d22ce51fe68d56$export$afe1899c3eea9823 = 16;
var $b7d22ce51fe68d56$export$910bf0d22c3d10f2 = 14;
var $b7d22ce51fe68d56$export$a43e30915fab3ccf = 8;
var $b7d22ce51fe68d56$export$531f77930bf508de = 48;
var $b7d22ce51fe68d56$export$c60fae4049791eae = 140;
var $b7d22ce51fe68d56$export$72aad729077aa0fb = 1;
var $b7d22ce51fe68d56$export$e56b8ca552b280f6 = 8;
var $b7d22ce51fe68d56$export$bba39e724bc39451 = 6;
var $b7d22ce51fe68d56$export$e5ff276883773ffd = 8;
var $b7d22ce51fe68d56$export$880976487022eb5 = $b7d22ce51fe68d56$export$808015ab1dd6897a + $b7d22ce51fe68d56$export$e5ff276883773ffd - $b7d22ce51fe68d56$export$72aad729077aa0fb;
/* first block node has 0 top margin */ var $b7d22ce51fe68d56$var$firstNodeWithNotMarginTop = function firstNodeWithNotMarginTop() {
    return (0, $74Zh5.css)($b7d22ce51fe68d56$var$_templateObject || ($b7d22ce51fe68d56$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($lAD7C)))([
        "\n\t\t> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)) {\n\t\t\tmargin-top: 0;\n\t\t}\n\t"
    ])));
};
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required
/**
 * The style is mirrored in:
 * - packages/editor/renderer/src/ui/Renderer/RendererStyleContainer.tsx ( seems outdated )
 * - packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
 *
 * If you are updating this, please also update the above files.
 *
 * @deprecated This Emotion-based style function is being phased out as part of the
 * `platform_editor_core_static_css` experiment migration to Compiled CSS. While the experiment
 * is running, any changes here MUST also be reflected in `EditorContentContainer-compiled.tsx`
 * (look for `tableSharedStyle`, `tableSharedStyle_with_*`, `tableSharedStyle_without_*` entries
 * in the `editorContentStyles` cssMap). Failure to do so will cause visual regressions when the
 * compiled version is active.
 */ var $b7d22ce51fe68d56$export$c2bf8eea75aa9302 = function tableSharedStyle() {
    var browser = (0, $4vXmi.getBrowserInfo)();
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Appears safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing
    return (0, $74Zh5.css)($b7d22ce51fe68d56$var$_templateObject2 || ($b7d22ce51fe68d56$var$_templateObject2 = (0, (/*@__PURE__*/$parcel$interopDefault($lAD7C)))([
        "\n\t\t",
        "\n\t\t.",
        " {\n\t\t\tposition: relative;\n\t\t\tmargin: 0 auto ",
        ";\n\t\t\tbox-sizing: border-box;\n\n\t\t\t/**\n\t\t\t * Fix block top alignment inside table cells.\n\t\t\t */\n\t\t\t.decisionItemView-content-wrap:first-of-type > div {\n\t\t\t\tmargin-top: 0;\n\t\t\t}\n\t\t\t",
        "\n\t\t}\n\t\t.",
        "[data-number-column='true'] {\n\t\t\tpadding-left: ",
        "px;\n\t\t\tclear: both;\n\t\t}\n\n\t\t.",
        " {\n\t\t\twill-change: width, margin-left;\n\t\t}\n\n\t\t.",
        " table {\n\t\t\twill-change: width;\n\t\t}\n\t\t.",
        " > table {\n\t\t\tmargin: ",
        " 0 0 0;\n\t\t}\n\n\t\t.",
        " > table,\n\t\t.",
        " > table {\n\t\t\tmargin: ",
        " ",
        " 0 0;\n\t\t}\n\n\t\t/* support panel nested in table */\n\t\t",
        "\n\n\t\t/* avoid applying styles to nested tables (possible via extensions) */\n\t.",
        " > table,\n\t.",
        " > table,\n\t.",
        " > table {\n\t\t\tborder-collapse: collapse;\n\t\t\t",
        "\n\t\t\ttable-layout: fixed;\n\t\t\tfont-size: 1em;\n\t\t\twidth: 100%;\n\t\t\t",
        "\n\n\t\t\t&[data-autosize='true'] {\n\t\t\t\ttable-layout: auto;\n\t\t\t}\n\n\t\t\t& {\n\t\t\t\t* {\n\t\t\t\t\tbox-sizing: border-box;\n\t\t\t\t}\n\t\t\t\thr {\n\t\t\t\t\tbox-sizing: content-box;\n\t\t\t\t}\n\n\t\t\t\ttbody {\n\t\t\t\t\tborder-bottom: none;\n\t\t\t\t}\n\t\t\t\tth td {\n\t\t\t\t\tbackground-color: ",
        ";\n\t\t\t\t}\n\n\t\t\t\t> tbody > tr > th,\n\t\t\t\t> tbody > tr > td {\n\t\t\t\t\tmin-width: ",
        "px;\n\t\t\t\t\tfont-weight: ",
        ";\n\t\t\t\t\tvertical-align: top;\n\t\t\t\t\t",
        "\n\t\t\t\t\tborder: 1px solid ",
        ";\n\t\t\t\t\tborder-right-width: 0;\n\t\t\t\t\tborder-bottom-width: 0;\n\n\t\t\t\t\tpadding: ",
        ";\n\t\t\t\t\t/* https://stackoverflow.com/questions/7517127/borders-not-shown-in-firefox-with-border-collapse-on-table-position-relative-o */\n\t\t\t\t\t",
        "\n\n\t\t\t\t\t",
        "\n\n\t\t\t\tth p:not(:first-of-type),\n\t\t\t\ttd p:not(:first-of-type) {\n\t\t\t\t\t\tmargin-top: ",
        ";\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t/* Ensures nested tables are compatible with parent table background color - uses specificity to ensure tables nested by extensions are not affected */\n\t\t\t\t> tbody > tr > td {\n\t\t\t\t\tbackground-color: ",
        ";\n\t\t\t\t}\n\n\t\t\t\t",
        "\n\t\t\t\tth {\n\t\t\t\t\tbackground-color: ",
        ";\n\t\t\t\t\ttext-align: left;\n\n\t\t\t\t\t/* only apply this styling to codeblocks in default background headercells */\n\t\t\t\t\t/* TODO this needs to be overhauled as it relies on unsafe selectors */\n\t\t\t\t\t",
        " {\n\t\t\t\t\t\t.",
        ":not(.danger) {\n\t\t\t\t\t\t\tbackground-color: ",
        ";\n\n\t\t\t\t\t\t\t:not(.",
        ") {\n\t\t\t\t\t\t\t\tbox-shadow: 0px 0px 0px 1px ",
        ";\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t.",
        " {\n\t\t\t\t\t\t\t\tbackground-image: ",
        ";\n\n\t\t\t\t\t\t\t\tbackground-color: ",
        ";\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t.",
        " {\n\t\t\t\t\t\t\t\tbackground-color: ",
        ";\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t/* this is only relevant to the element taken care of by renderer */\n\t\t\t\t\t\t\t> [data-ds--code--code-block] {\n\t\t\t\t\t\t\t\tbackground-image: ",
        "!important;\n\n\t\t\t\t\t\t\t\tbackground-color: ",
        "!important;\n\n\t\t\t\t\t\t\t\t/* selector lives inside @atlaskit/code */\n\t\t\t\t\t\t\t\t--ds--code--line-number-bg-color: ",
        ";\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t",
        "\n\t"
    ])), (0, $iv75Q.tableCellBackgroundStyleOverride)(), (0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, "var(--ds-space-200, 16px)", (0, $3tz1M.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? "/* Fake side borders are not needed when the rounded overlay owns the outer border. */\n\t\t\t\t.".concat((0, $7NyDw.TableSharedCssClassName).TABLE_RIGHT_BORDER, ",\n\t\t\t\t.").concat((0, $7NyDw.TableSharedCssClassName).TABLE_LEFT_BORDER, " {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t\t\t") : ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_RIGHT_BORDER, ",\n\t\t\t.").concat((0, $7NyDw.TableSharedCssClassName).TABLE_LEFT_BORDER, " {\n\t\t\t\tdisplay: block;\n\t\t\t\twidth: 1px;\n\t\t\t\theight: calc(100% - ", "var(--ds-space-300, 24px)", ");\n\t\t\t\tbackground: ", "var(--ds-background-accent-gray-subtler, #DDDEE1)", ";\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: ", "var(--ds-space-300, 24px)", ";\n\t\t\t}\n\t\t\t.").concat((0, $7NyDw.TableSharedCssClassName).TABLE_RIGHT_BORDER, " {\n\t\t\t\tright: 0;\n\t\t\t}\n\t\t\t.").concat((0, $7NyDw.TableSharedCssClassName).TABLE_LEFT_BORDER, " {\n\t\t\t\tleft: 0;\n\t\t\t}\n\t\t\t.").concat((0, $7NyDw.TableSharedCssClassName).TABLE_LEFT_BORDER, "[data-with-numbered-table='true'] {\n\t\t\t\tleft: ").concat((0, $1LBcl.akEditorTableNumberColumnWidth) - 1, "px;\n\t\t\t}"), (0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, (0, $1LBcl.akEditorTableNumberColumnWidth) - 1, (0, $7NyDw.TableSharedCssClassName).TABLE_RESIZER_CONTAINER, (0, $7NyDw.TableSharedCssClassName).TABLE_RESIZER_CONTAINER, (0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER, "var(--ds-space-300, 24px)", (0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, (0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_WRAPPER, "var(--ds-space-300, 24px)", "var(--ds-space-100, 8px)", (0, $50U6m.fg)('platform_editor_bordered_panel_nested_in_table') ? ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER, " .ak-editor-panel {\n\t\t\tborder: ", "var(--ds-border-width, 1px)", " solid ", "var(--ds-border, #0B120E24)", ";\n\t\t}") : '', (0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, (0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER, (0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_WRAPPER, (0, $3tz1M.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? "/* Keep a transparent border so the collapsed border model reserves the same 1px slot\n\t\t\t   on the table edge; the ::after overlay draws the visible rounded border instead. */\n\t\t\tborder: ".concat($b7d22ce51fe68d56$export$72aad729077aa0fb, "px solid transparent;") : "border: ".concat($b7d22ce51fe68d56$export$72aad729077aa0fb, "px solid ", "var(--ds-background-accent-gray-subtler, #DDDEE1)", ";\n\t\t\tborder-left-color: transparent;\n\t\t\tborder-right-color: transparent;"), (0, $3tz1M.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? "position: relative;\n\n\t\t\t/* Table-width outer-border owner for overflow-safe rounded corners. */\n\t\t\t&::after {\n\t\t\t\tcontent: '';\n\t\t\t\tposition: absolute;\n\t\t\t\tinset: -0.5px;\n\t\t\t\tborder: ".concat($b7d22ce51fe68d56$export$72aad729077aa0fb, "px solid ", "var(--ds-background-accent-gray-subtler, #DDDEE1)", ";\n\t\t\t\tborder-radius: ", "var(--ds-radius-xlarge, 12px)", ";\n\t\t\t\tpointer-events: none;\n\t\t\t\tz-index: 1;\n\t\t\t}\n\n\t\t\t/* When content-visibility is applied to the table (see editor-plugin-table nodeview), the\n\t\t\t   implied `contain: paint` clips descendant painting to the table's border-box. The\n\t\t\t   overlay above sits at `inset: -0.5px` (half a pixel outside), so it would be shaved \u2014\n\t\t\t   most visibly along the bottom. Pull it flush to the edge so it paints inside the clip. */\n\t\t\t&[data-content-visibility]::after {\n\t\t\t\tinset: 0;\n\t\t\t}") : '', "var(--ds-background-neutral-subtle, #00000000)", $b7d22ce51fe68d56$export$531f77930bf508de, "var(--ds-font-weight-regular, 400)", (0, $6TmbT.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true) ? "&[data-valign='middle'] {\n\t\t\t\t\t\t\t\tvertical-align: middle;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&[data-valign='bottom'] {\n\t\t\t\t\t\t\t\tvertical-align: bottom;\n\t\t\t\t\t\t\t}" : '', "var(--ds-background-accent-gray-subtler, #DDDEE1)", "var(--ds-space-100, 8px)", browser.gecko || browser.ie || browser.mac && browser.chrome ? 'background-clip: padding-box;' : '', $b7d22ce51fe68d56$var$firstNodeWithNotMarginTop(), "var(--ds-space-150, 12px)", "var(--ds-surface, #FFFFFF)", (0, $3tz1M.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? "/* Let the wrapper overlay own the outer table perimeter.\n\t\t\t\t   data-reaches-* attributes are set by the TableCell node view. */\n\t\t\t\t> tbody > tr > th[data-reaches-top],\n\t\t\t\t> tbody > tr > td[data-reaches-top] {\n\t\t\t\t\tborder-top-color: transparent;\n\t\t\t\t}\n\n\t\t\t\t> tbody > tr > th[data-reaches-left],\n\t\t\t\t> tbody > tr > td[data-reaches-left] {\n\t\t\t\t\tborder-left-color: transparent;\n\t\t\t\t}\n\n\t\t\t\t> tbody > tr > td[data-reaches-left]::after {\n\t\t\t\t\tborder-left-color: transparent;\n\t\t\t\t}\n\n\t\t\t\t> tbody > tr > td[data-reaches-bottom]::after,\n\t\t\t\t> tbody > tr > th[data-reaches-bottom]::after {\n\t\t\t\t\tborder-bottom-color: transparent;\n\t\t\t\t}\n\n\t\t\t\t/* The rounded-table overlay owns transparent perimeter borders.\n\t\t\t\t   Paint edge cell backgrounds into that reserved border area so coloured\n\t\t\t\t   first/last rows do not show the page background through 1px seams. */\n\t\t\t\t> tbody > tr > th[data-reaches-top],\n\t\t\t\t> tbody > tr > td[data-reaches-top],\n\t\t\t\t> tbody > tr > th[data-reaches-bottom],\n\t\t\t\t> tbody > tr > td[data-reaches-bottom] {\n\t\t\t\t\tbackground-clip: border-box;\n\t\t\t\t}" : '', "var(--ds-background-accent-gray-subtlest, #F0F1F2)", (0, $3tz1M.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? '&:not(.danger)' : '&:not([style]):not(.danger)', (0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "var(--ds-surface-raised, #FFFFFF)", (0, $1LBcl.akEditorSelectedNodeClassName), "var(--ds-border, #0B120E24)", (0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, (0, $5wL5P.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), "var(--ds-background-neutral, #0515240F)", (0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "var(--ds-background-neutral, #0515240F)", (0, $5wL5P.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), "var(--ds-background-neutral, #0515240F)", "var(--ds-background-neutral, #0515240F)", (0, $3tz1M.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? "/* When the number column is enabled, the left visual edge belongs to the number column.\n\t\t   Remove the left border-radius and left border from the table's ::after overlay\n\t\t   so it doesn't double-up or round where the number column already provides that edge. */\n\t\t.".concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, "[data-number-column='true'] {\n\t\t\t> .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table::after,\n\t\t\t> .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table::after {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t\tborder-left-color: transparent;\n\t\t\t}\n\t\t}") : '');
};

});
parcelRegister("5wL5P", function(module, exports) {
$parcel$export(module.exports, "overflowShadow", () => $40647893eba0d518$export$c5c1e4f4640336fb);

var $lAD7C = parcelRequire("lAD7C");

var $74Zh5 = parcelRequire("74Zh5");
var $40647893eba0d518$var$_templateObject;
var $40647893eba0d518$export$c5c1e4f4640336fb = function overflowShadow(_ref) {
    var leftCoverWidth = _ref.leftCoverWidth, rightCoverWidth = _ref.rightCoverWidth;
    var width = "var(--ds-space-100, 8px)";
    var leftCoverWidthResolved = leftCoverWidth || width;
    var rightCoverWidthResolved = rightCoverWidth || width;
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return (0, $74Zh5.css)($40647893eba0d518$var$_templateObject || ($40647893eba0d518$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($lAD7C)))([
        "\n/* shadow cover left */\n  linear-gradient(\n    to right,\n    ",
        " ",
        ",\n    transparent ",
        "\n  ),\n/* shadow cover background left */\n  linear-gradient(\n    to right,\n    ",
        " ",
        ",\n    transparent ",
        "\n  ),\n/* shadow cover right */\n  linear-gradient(\n    to left,\n    ",
        " ",
        ",\n    transparent ",
        "\n  ),\n/* shadow cover background right */\n  linear-gradient(\n    to left,\n    ",
        " ",
        ",\n    transparent ",
        "\n  ),\n/* overflow shadow right spread */\n  linear-gradient(\n    to left,\n    ",
        " 0,\n    ",
        "  ",
        "\n  ),\n  /* overflow shadow right perimeter */\n  linear-gradient(\n    to left,\n    ",
        " 0,\n    ",
        "  ",
        "\n  ),\n  /* overflow shadow left spread */\n  linear-gradient(\n    to right,\n    ",
        " 0,\n    ",
        "  ",
        "\n  ),\n  /* overflow shadow left perimeter */\n  linear-gradient(\n    to right,\n    ",
        " 0,\n    ",
        "  ",
        "\n  )\n"
    ])), "var(--ds-background-neutral, #0515240F)", leftCoverWidthResolved, leftCoverWidthResolved, "var(--ds-surface-raised, #FFFFFF)", leftCoverWidthResolved, leftCoverWidthResolved, "var(--ds-background-neutral, #0515240F)", rightCoverWidthResolved, rightCoverWidthResolved, "var(--ds-surface-raised, #FFFFFF)", rightCoverWidthResolved, rightCoverWidthResolved, "var(--ds-shadow-overflow-spread, #1E1F2129)", "var(--ds-UNSAFE-transparent, transparent)", width, "var(--ds-shadow-overflow-perimeter, #1E1F211f)", "var(--ds-UNSAFE-transparent, transparent)", width, "var(--ds-shadow-overflow-spread, #1E1F2129)", "var(--ds-UNSAFE-transparent, transparent)", width, "var(--ds-shadow-overflow-perimeter, #1E1F211f)", "var(--ds-UNSAFE-transparent, transparent)", width);
};

});

parcelRegister("6TmbT", function(module, exports) {
$parcel$export(module.exports, "expValEqualsNoExposure", () => $504917c3c7aefe17$export$63eebf86443a0a61);

var $kE9E8 = parcelRequire("kE9E8");
function $504917c3c7aefe17$export$63eebf86443a0a61(experimentName, experimentParam, experimentExpectedValue) {
    var experimentDefaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return (0, $kE9E8.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, false);
}

});

parcelRegister("4vXmi", function(module, exports) {
$parcel$export(module.exports, "getBrowserInfo", () => $34981a11f81fcf93$export$6c724a6ffa2dc3e1);

var $cvlyC = parcelRequire("cvlyC");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $34981a11f81fcf93$var$IE_EDGE_REGEX = /\sedg\//i;
// eslint-disable-next-line require-unicode-regexp
var $34981a11f81fcf93$var$IE_EDGE2_REGEX = /edg([ea]|ios)/i;
// eslint-disable-next-line require-unicode-regexp
var $34981a11f81fcf93$var$INTERNET_EXPLORER_REGEX = /msie|trident/i;
// eslint-disable-next-line require-unicode-regexp
var $34981a11f81fcf93$var$MAC_REGEX = /Mac/;
// eslint-disable-next-line require-unicode-regexp
var $34981a11f81fcf93$var$WINDOWS_REGEX = /Windows|Win\d+/i;
// eslint-disable-next-line require-unicode-regexp
var $34981a11f81fcf93$var$IE_EDGE_VERSION_REGEX = /\sedg\/(\d+(\.?_?\d+)+)/i;
// eslint-disable-next-line require-unicode-regexp
var $34981a11f81fcf93$var$IE_EDGE2_VERSION_REGEX = /edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i;
// eslint-disable-next-line require-unicode-regexp
var $34981a11f81fcf93$var$IE_VERSION_REGEX = /(?:msie |rv:)(\d+(\.?_?\d+)+)/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $34981a11f81fcf93$var$GECKO_REGEX = /gecko\/\d/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $34981a11f81fcf93$var$FIREFOX_VERSION_REGEX = /Firefox\/(\d+)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $34981a11f81fcf93$var$CHROME_REGEX = /Chrome\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $34981a11f81fcf93$var$CHROME_VERSION_REGEX = /Chrome\/(\d+)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $34981a11f81fcf93$var$ANDROID_REGEX = /Android \d/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $34981a11f81fcf93$var$APPLE_WEBKIT_REGEX = /AppleWebKit/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $34981a11f81fcf93$var$MOBILE_REGEX = /Mobile\/\w+/;
// eslint-disable-next-line require-unicode-regexp
var $34981a11f81fcf93$var$SAFARI_REGEX = /safari|applewebkit/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $34981a11f81fcf93$var$SAFARI_VERSION_REGEX = /Version\/([0-9\._]+).*Safari/;
// eslint-disable-next-line require-unicode-regexp
var $34981a11f81fcf93$var$WEBKIT_REGEX = /(apple)?webkit/i;
var $34981a11f81fcf93$var$getFirstMatch = function getFirstMatch(regexp, ua) {
    var match = ua.match(regexp);
    return match && match.length > 0 && match[1] || '';
};
var $34981a11f81fcf93$var$getSecondMatch = function getSecondMatch(regexp, ua) {
    var match = ua.match(regexp);
    return match && match.length > 0 && match[2] || '';
};
// Helper functions to safely access browser properties
var $34981a11f81fcf93$var$getSafeUserAgent = function getSafeUserAgent() {
    var _window$navigator;
    if (typeof window === 'undefined') return undefined;
    var ssrUserAgent;
    // Fallback to navigator.userAgent with proper null checking
    return (_window$navigator = window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent;
};
var $34981a11f81fcf93$var$getSafePlatform = function getSafePlatform() {
    var _window$navigator2;
    if (typeof window === 'undefined') return undefined;
    return (_window$navigator2 = window.navigator) === null || _window$navigator2 === void 0 ? void 0 : _window$navigator2.platform;
};
var $34981a11f81fcf93$var$hasIntersectionObserver = function hasIntersectionObserver() {
    return typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'intersectionRatio' in window.IntersectionObserverEntry.prototype;
};
var $34981a11f81fcf93$var$hasResizeObserver = function hasResizeObserver() {
    return typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
};
var $34981a11f81fcf93$export$6c724a6ffa2dc3e1 = (0, $cvlyC.default)(function() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var result = {
        mac: false,
        windows: false,
        ie: false,
        ie_version: 0,
        gecko: false,
        gecko_version: 0,
        chrome: false,
        chrome_version: 0,
        android: false,
        ios: false,
        webkit: false,
        safari: false,
        safari_version: 0,
        supportsIntersectionObserver: false,
        supportsResizeObserver: false
    };
    var userAgent = $34981a11f81fcf93$var$getSafeUserAgent();
    var platform = $34981a11f81fcf93$var$getSafePlatform();
    if (userAgent) {
        // inspired from https://github.com/bowser-js/bowser/blob/master/src/parser-browsers.js
        var ieEdge = $34981a11f81fcf93$var$IE_EDGE_REGEX.test(userAgent);
        var ieEdge2 = $34981a11f81fcf93$var$IE_EDGE2_REGEX.test(userAgent);
        var internetExplorer = $34981a11f81fcf93$var$INTERNET_EXPLORER_REGEX.test(userAgent);
        // Ideally we should use userAgent instead of platform, but we have lots of keymap tests failure when we change it
        // So leave it as is for now.
        result.mac = platform && $34981a11f81fcf93$var$MAC_REGEX.test(platform);
        // Previously relied on navigator.userAgentData?.platform and userAgent, now used only userAgent
        result.windows = $34981a11f81fcf93$var$WINDOWS_REGEX.test(userAgent);
        // used userAgent rather than relying on documentMode
        var ie = ieEdge || ieEdge2 || internetExplorer;
        result.ie = ie;
        // inspired from https://github.com/bowser-js/bowser/blob/master/src/parser-browsers.js
        result.ie_version = ieEdge ? parseInt($34981a11f81fcf93$var$getFirstMatch($34981a11f81fcf93$var$IE_EDGE_VERSION_REGEX, userAgent), 10) : ieEdge2 ? parseInt($34981a11f81fcf93$var$getSecondMatch($34981a11f81fcf93$var$IE_EDGE2_VERSION_REGEX, userAgent), 10) : parseInt($34981a11f81fcf93$var$getFirstMatch($34981a11f81fcf93$var$IE_VERSION_REGEX, userAgent), 10);
        result.gecko = !ie && $34981a11f81fcf93$var$GECKO_REGEX.test(userAgent);
        result.gecko_version = parseInt((userAgent.match($34981a11f81fcf93$var$FIREFOX_VERSION_REGEX) || [])[1], 10);
        result.chrome = !ie && $34981a11f81fcf93$var$CHROME_REGEX.test(userAgent);
        result.chrome_version = parseInt((userAgent.match($34981a11f81fcf93$var$CHROME_VERSION_REGEX) || [])[1], 10);
        result.android = $34981a11f81fcf93$var$ANDROID_REGEX.test(userAgent);
        result.ios = !ie && $34981a11f81fcf93$var$APPLE_WEBKIT_REGEX.test(userAgent) && $34981a11f81fcf93$var$MOBILE_REGEX.test(userAgent);
        // Previously relied on navigator.vendor, now used userAgent
        result.safari = !result.chrome && !result.ie && !result.gecko && !result.android && !userAgent.includes('CriOS') && !userAgent.includes('FxiOS') && $34981a11f81fcf93$var$SAFARI_REGEX.test(userAgent);
        result.safari_version = parseInt((userAgent.match($34981a11f81fcf93$var$SAFARI_VERSION_REGEX) || [])[1], 10);
        // Previously we relied on documentElement.style.WebkitAppearance, now changed to userAgent
        result.webkit = $34981a11f81fcf93$var$WEBKIT_REGEX.test(userAgent);
        result.supportsIntersectionObserver = $34981a11f81fcf93$var$hasIntersectionObserver();
        result.supportsResizeObserver = $34981a11f81fcf93$var$hasResizeObserver();
    }
    return result;
});

});

parcelRegister("knSf2", function(module, exports) {
$parcel$export(module.exports, "CodeBlockSharedCssClassName", () => $ed7007e19d6d79d9$export$42659c26f026f6ea);
// Constant variables here has been inlined in css from EditorContentContainer, if you need to make
// update here, please also update packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
var $ed7007e19d6d79d9$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    CODEBLOCK_CONTENT_WRAPPED: 'code-content--wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped'
};

});

parcelRegister("iv75Q", function(module, exports) {
$parcel$export(module.exports, "tableCellBackgroundStyleOverride", () => $d7809fd0775f876c$export$677e93f0f5f9623a);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");

var $6aATw = parcelRequire("6aATw");
var $d7809fd0775f876c$export$677e93f0f5f9623a = function tableCellBackgroundStyleOverride() {
    return (0, $74Zh5.css)((0, $6aATw.mapBackgroundColors)());
};

});
parcelRegister("6aATw", function(module, exports) {
$parcel$export(module.exports, "mapBackgroundColors", () => $47e04bb934583481$export$35c9e86e192acb85);

var $gc8Zd = parcelRequire("gc8Zd");

var $b6T7g = parcelRequire("b6T7g");
var $47e04bb934583481$export$35c9e86e192acb85 = function mapBackgroundColors() {
    var cssString = '';
    (0, $gc8Zd.tableBackgroundColorNames).forEach(function(value, key) {
        var paletteColorValue = (0, $b6T7g.hexToEditorBackgroundPaletteColor)(value);
        if (paletteColorValue) cssString += "\n        td[colorname='".concat(key, "' i],\n        th[colorname='").concat(key, "' i] {\n          background-color: ").concat(paletteColorValue, " !important;\n        }\n      ");
    });
    return cssString;
};

});
parcelRegister("b6T7g", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBackgroundPaletteColor", () => $816b0228f3b23cfb$export$5f6a44a42a4b38c2);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $816b0228f3b23cfb$export$a270511a0e7fd61a);

var $25nEq = parcelRequire("25nEq");

var $ZZ05K = parcelRequire("ZZ05K");
var $816b0228f3b23cfb$var$_editorBackgroundPale;
function $816b0228f3b23cfb$export$5f6a44a42a4b38c2(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    var tokenData = $816b0228f3b23cfb$export$2462741d70e6a62f[hexColor.toUpperCase()];
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return tokenData ? tokenData.token : undefined;
}
function $816b0228f3b23cfb$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    var tokenData = $816b0228f3b23cfb$export$2462741d70e6a62f[hexColor.toUpperCase()];
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
var $816b0228f3b23cfb$export$2462741d70e6a62f = ($816b0228f3b23cfb$var$_editorBackgroundPale = {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($816b0228f3b23cfb$var$_editorBackgroundPale, '#DEEBFF', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.blue.subtlest', fallback);
    },
    token: "var(--ds-background-accent-blue-subtlest, #E9F2FE)"
}), '#B3D4FF', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.blue.subtler', fallback);
    },
    token: "var(--ds-background-accent-blue-subtler, #CFE1FD)"
}), '#4C9AFF', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.blue.subtle', fallback);
    },
    token: "var(--ds-background-accent-blue-subtle, #669DF1)"
}), '#ADCBFB', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.blue.subtler.hovered', fallback);
    },
    token: "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)"
}), '#E6FCFF', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.teal.subtlest', fallback);
    },
    token: "var(--ds-background-accent-teal-subtlest, #E7F9FF)" // source for hex code was legacy token T50,
}), '#B3F5FF', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.teal.subtler', fallback);
    },
    token: "var(--ds-background-accent-teal-subtler, #C6EDFB)" // source for hex code was legacy token T75,
}), '#79E2F2', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.teal.subtle', fallback);
    },
    token: "var(--ds-background-accent-teal-subtle, #6CC3E0)" // source for hex code was legacy token T100,
}), '#B1E4F7', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.teal.subtler.hovered', fallback);
    },
    token: "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)"
}), '#E3FCEF', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.green.subtlest', fallback);
    },
    token: "var(--ds-background-accent-green-subtlest, #DCFFF1)" // source for hex code was legacy token G50,
}), '#ABF5D1', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.green.subtler', fallback);
    },
    token: "var(--ds-background-accent-green-subtler, #BAF3DB)" // source for hex code was legacy token G75,
}), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($816b0228f3b23cfb$var$_editorBackgroundPale, '#57D9A3', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.green.subtle', fallback);
    },
    token: "var(--ds-background-accent-green-subtle, #4BCE97)" // source for hex code was legacy token G200,
}), '#97EDC9', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.green.subtler.hovered', fallback);
    },
    token: "var(--ds-background-accent-green-subtler-hovered, #97EDC9)"
}), '#EFFFD6', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.lime.subtlest', fallback);
    },
    token: "var(--ds-background-accent-lime-subtlest, #EFFFD6)"
}), '#D3F1A7', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.lime.subtler', fallback);
    },
    token: "var(--ds-background-accent-lime-subtler, #D3F1A7)"
}), '#BDE97C', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.lime.subtler.hovered', fallback);
    },
    token: "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)"
}), '#FFFAE6', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.yellow.subtlest', fallback);
    },
    token: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)" // source for hex code was legacy token Y50,
}), '#FFF0B3', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.yellow.subtler', fallback);
    },
    token: "var(--ds-background-accent-yellow-subtler, #F5E989)" // source for hex code was legacy token Y75,
}), '#FFC400', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.orange.subtle', fallback);
    },
    token: "var(--ds-background-accent-orange-subtle, #FCA700)" // source for hex code was legacy token Y200,
}), '#EFDD4E', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.yellow.subtler.hovered', fallback);
    },
    token: "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)"
}), '#FFF5DB', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.orange.subtlest', fallback);
    },
    token: "var(--ds-background-accent-orange-subtlest, #FFF5DB)"
}), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($816b0228f3b23cfb$var$_editorBackgroundPale, '#FCE4A6', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.orange.subtler', fallback);
    },
    token: "var(--ds-background-accent-orange-subtler, #FCE4A6)"
}), '#FBD779', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.orange.subtler.hovered', fallback);
    },
    token: "var(--ds-background-accent-orange-subtler-hovered, #FBD779)"
}), '#FFEBE6', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.red.subtlest', fallback);
    },
    token: "var(--ds-background-accent-red-subtlest, #FFECEB)" // source for hex code was legacy token R50,
}), '#FFBDAD', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.red.subtler', fallback);
    },
    token: "var(--ds-background-accent-red-subtler, #FFD5D2)" // source for hex code was legacy token R75,
}), '#FF8F73', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.red.subtle', fallback);
    },
    token: "var(--ds-background-accent-red-subtle, #F87168)" // source for hex code was legacy token R100,
}), '#FFB8B2', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.red.subtler.hovered', fallback);
    },
    token: "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)"
}), '#FFECF8', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.magenta.subtlest', fallback);
    },
    token: "var(--ds-background-accent-magenta-subtlest, #FFECF8)"
}), '#FDD0EC', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.magenta.subtler', fallback);
    },
    token: "var(--ds-background-accent-magenta-subtler, #FDD0EC)"
}), '#FCB6E1', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.magenta.subtler.hovered', fallback);
    },
    token: "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)"
}), '#EAE6FF', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.purple.subtlest', fallback);
    },
    token: "var(--ds-background-accent-purple-subtlest, #F8EEFE)" // source for hex code was legacy token P50,
}), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($816b0228f3b23cfb$var$_editorBackgroundPale, '#C0B6F2', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.purple.subtler', fallback);
    },
    token: "var(--ds-background-accent-purple-subtler, #EED7FC)" // source for hex code was legacy token P75,
}), '#998DD9', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.purple.subtle', fallback);
    },
    token: "var(--ds-background-accent-purple-subtle, #C97CF4)" // source for hex code was legacy token P100,
}), '#E3BDFA', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.purple.subtler.hovered', fallback);
    },
    token: "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)"
}), '#FFFFFF', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('elevation.surface', fallback);
    },
    token: "var(--ds-surface, #FFFFFF)" // source for hex code was legacy token N0,
}), '#F4F5F7', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.gray.subtlest', fallback);
    },
    token: "var(--ds-background-accent-gray-subtlest, #F0F1F2)" // source for hex code was legacy token N20,
}), '#B3BAC5', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.gray.subtle', fallback);
    },
    token: "var(--ds-background-accent-gray-subtle, #8C8F97)" // source for hex code was legacy token N60,
}), '#B7B9BE', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.getTokenValue)('color.background.accent.gray.subtler.hovered', fallback);
    },
    token: "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)"
}));

});
parcelRegister("ZZ05K", function(module, exports) {
$parcel$export(module.exports, "getTokenValue", () => $0ba5040b50b8cb6c$export$37e2c47c7e49c28a);


var $4Is3S = parcelRequire("4Is3S");

var $3ZMUU = parcelRequire("3ZMUU");
function $0ba5040b50b8cb6c$export$37e2c47c7e49c28a(tokenId) {
    var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var token = (0, $4Is3S.default)[tokenId];
    var tokenValue = fallback;
    typeof $3ZMUU;
    if (typeof window === 'undefined') return tokenValue;
    tokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    tokenValue = tokenValue || fallback;
    return tokenValue;
}
var $0ba5040b50b8cb6c$export$2e2bcd8739ae039 = $0ba5040b50b8cb6c$export$37e2c47c7e49c28a;

});
parcelRegister("4Is3S", function(module, exports) {
$parcel$export(module.exports, "default", () => $36f109edfb21e392$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c7bf23ec9330aefbe8dbb595dde9d1c3>>
 * @codegenCommand yarn build tokens
 */ var $36f109edfb21e392$var$tokens = {
    'motion.avatar.enter': '--ds-avatar-enter',
    'motion.avatar.exit': '--ds-avatar-exit',
    'motion.avatar.hovered': '--ds-avatar-hovered',
    'motion.blanket.enter': '--ds-blanket-enter',
    'motion.blanket.exit': '--ds-blanket-exit',
    'motion.button.hovered': '--ds-button-hovered',
    'motion.button.pressed': '--ds-button-pressed',
    'motion.duration.instant': '--ds-duration-instant',
    'motion.duration.long': '--ds-duration-long',
    'motion.duration.medium': '--ds-duration-medium',
    'motion.duration.short': '--ds-duration-short',
    'motion.duration.xlong': '--ds-duration-xlong',
    'motion.duration.xshort': '--ds-duration-xshort',
    'motion.duration.xxlong': '--ds-duration-xxlong',
    'motion.duration.xxshort': '--ds-duration-xxshort',
    'motion.easing.in.practical': '--ds-easing-in-practical',
    'motion.easing.inout.bold': '--ds-easing-inout-bold',
    'motion.easing.out.practical': '--ds-easing-out-practical',
    'motion.easing.out.bold': '--ds-easing-out-bold',
    'motion.easing.spring': '--ds-easing-spring',
    'motion.flag.enter': '--ds-flag-enter',
    'motion.flag.exit': '--ds-flag-exit',
    'motion.flag.reposition': '--ds-flag-reposition',
    'motion.input': '--ds-input',
    'motion.keyframe.fade.in': '--ds-keyframe-fade-in',
    'motion.keyframe.fade.out': '--ds-keyframe-fade-out',
    'motion.keyframe.grid.column.in': '--ds-keyframe-grid-column-in',
    'motion.keyframe.grid.column.out': '--ds-keyframe-grid-column-out',
    'motion.keyframe.scale.in.medium': '--ds-keyframe-scale-in-medium',
    'motion.keyframe.scale.in.small': '--ds-keyframe-scale-in-small',
    'motion.keyframe.scale.out.medium': '--ds-keyframe-scale-out-medium',
    'motion.keyframe.scale.out.small': '--ds-keyframe-scale-out-small',
    'motion.keyframe.slide.in.bottom.short': '--ds-keyframe-slide-in-bottom-short',
    'motion.keyframe.slide.in.left.half': '--ds-keyframe-slide-in-left-half',
    'motion.keyframe.slide.in.left.short': '--ds-keyframe-slide-in-left-short',
    'motion.keyframe.slide.in.right.short': '--ds-keyframe-slide-in-right-short',
    'motion.keyframe.slide.in.top.short': '--ds-keyframe-slide-in-top-short',
    'motion.keyframe.slide.out.bottom.short': '--ds-keyframe-slide-out-bottom-short',
    'motion.keyframe.slide.out.left.half': '--ds-keyframe-slide-out-left-half',
    'motion.keyframe.slide.out.left.short': '--ds-keyframe-slide-out-left-short',
    'motion.keyframe.slide.out.right.short': '--ds-keyframe-slide-out-right-short',
    'motion.keyframe.slide.out.top.short': '--ds-keyframe-slide-out-top-short',
    'motion.label.enter': '--ds-label-enter',
    'motion.label.exit': '--ds-label-exit',
    'motion.listitem.hovered': '--ds-listitem-hovered',
    'motion.listitem.pressed': '--ds-listitem-pressed',
    'motion.listitem.selected': '--ds-listitem-selected',
    'motion.modal.enter': '--ds-modal-enter',
    'motion.modal.exit': '--ds-modal-exit',
    'motion.panel.content.enter': '--ds-panel-content-enter',
    'motion.panel.content.exit': '--ds-panel-content-exit',
    'motion.panel.enter': '--ds-panel-enter',
    'motion.panel.enter.left': '--ds-panel-enter-left',
    'motion.panel.enter.right': '--ds-panel-enter-right',
    'motion.panel.exit': '--ds-panel-exit',
    'motion.panel.exit.left': '--ds-panel-exit-left',
    'motion.panel.exit.right': '--ds-panel-exit-right',
    'motion.popup.enter.bottom': '--ds-popup-enter-bottom',
    'motion.popup.enter.left': '--ds-popup-enter-left',
    'motion.popup.enter.right': '--ds-popup-enter-right',
    'motion.popup.enter.top': '--ds-popup-enter-top',
    'motion.popup.exit.bottom': '--ds-popup-exit-bottom',
    'motion.popup.exit.left': '--ds-popup-exit-left',
    'motion.popup.exit.right': '--ds-popup-exit-right',
    'motion.popup.exit.top': '--ds-popup-exit-top',
    'motion.sidenav.enter.left': '--ds-sidenav-enter-left',
    'motion.sidenav.enter.right': '--ds-sidenav-enter-right',
    'motion.sidenav.exit.left': '--ds-sidenav-exit-left',
    'motion.sidenav.exit.right': '--ds-sidenav-exit-right',
    'motion.spotlight.enter': '--ds-spotlight-enter',
    'motion.spotlight.exit': '--ds-spotlight-exit',
    'motion.tab': '--ds-tab',
    'motion.tab.indicator.enter.left': '--ds-tab-indicator-enter-left',
    'motion.tab.indicator.enter.right': '--ds-tab-indicator-enter-right',
    'motion.tab.indicator.exit.left': '--ds-tab-indicator-exit-left',
    'motion.tab.indicator.exit.right': '--ds-tab-indicator-exit-right',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.code.added.highlight': '--ds-background-code-added-highlight',
    'color.background.code.added.line': '--ds-background-code-added-line',
    'color.background.code.default': '--ds-background-code-default',
    'color.background.code.gutter': '--ds-background-code-gutter',
    'color.background.code.highlight': '--ds-background-code-highlight',
    'color.background.code.removed.highlight': '--ds-background-code-removed-highlight',
    'color.background.code.removed.line': '--ds-background-code-removed-line',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.subtle': '--ds-background-danger-subtle',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.subtle': '--ds-background-warning-subtle',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.subtle': '--ds-background-success-subtle',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.subtle': '--ds-background-discovery-subtle',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.subtle': '--ds-background-information-subtle',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.lime.subtle': '--ds-border-accent-lime-subtle',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.red.subtle': '--ds-border-accent-red-subtle',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.orange.subtle': '--ds-border-accent-orange-subtle',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.yellow.subtle': '--ds-border-accent-yellow-subtle',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.green.subtle': '--ds-border-accent-green-subtle',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.teal.subtle': '--ds-border-accent-teal-subtle',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.blue.subtle': '--ds-border-accent-blue-subtle',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.purple.subtle': '--ds-border-accent-purple-subtle',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.magenta.subtle': '--ds-border-accent-magenta-subtle',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.accent.gray.subtle': '--ds-border-accent-gray-subtle',
    'color.border.code': '--ds-border-code',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.input.search': '--ds-border-input-search',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.danger.subtle': '--ds-border-danger-subtle',
    'color.border.warning': '--ds-border-warning',
    'color.border.warning.subtle': '--ds-border-warning-subtle',
    'color.border.success': '--ds-border-success',
    'color.border.success.subtle': '--ds-border-success-subtle',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.discovery.subtle': '--ds-border-discovery-subtle',
    'color.border.information': '--ds-border-information',
    'color.border.information.subtle': '--ds-border-information-subtle',
    'color.border.bold': '--ds-border-bold',
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.code.accent.1': '--ds-text-code-accent-1',
    'color.text.code.accent.2': '--ds-text-code-accent-2',
    'color.text.code.comments': '--ds-text-code-comments',
    'color.text.code.default': '--ds-text-code-default',
    'color.text.code.functions': '--ds-text-code-functions',
    'color.text.code.gutter': '--ds-text-code-gutter',
    'color.text.code.keywords': '--ds-text-code-keywords',
    'color.text.code.numbers': '--ds-text-code-numbers',
    'color.text.code.operators': '--ds-text-code-operators',
    'color.text.code.strings': '--ds-text-code-strings',
    'color.text.code.tags': '--ds-text-code-tags',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'color.rovo.background.brand.bold': '--ds-rovo-background-brand-bold',
    'color.rovo.background.brand.bold.hovered': '--ds-rovo-background-brand-bold-hovered',
    'color.rovo.background.brand.bold.pressed': '--ds-rovo-background-brand-bold-pressed',
    'color.rovo.border.lime': '--ds-rovo-border-lime',
    'color.rovo.border.saffron': '--ds-rovo-border-saffron',
    'color.rovo.border.blue': '--ds-rovo-border-blue',
    'color.rovo.border.purple': '--ds-rovo-border-purple',
    'color.rovo.icon.lime': '--ds-rovo-icon-lime',
    'color.rovo.icon.saffron': '--ds-rovo-icon-saffron',
    'color.rovo.icon.blue': '--ds-rovo-icon-blue',
    'color.rovo.icon.purple': '--ds-rovo-icon-purple',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.container': '--ds-surface-container',
    'elevation.surface.container.hovered': '--ds-surface-container-hovered',
    'elevation.surface.container.pressed': '--ds-surface-container-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.rovo.surface.overlay': '--ds-rovo-surface-overlay',
    'elevation.rovo.surface.overlay.hovered': '--ds-rovo-surface-overlay-hovered',
    'elevation.rovo.surface.overlay.pressed': '--ds-rovo-surface-overlay-pressed',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $36f109edfb21e392$export$2e2bcd8739ae039 = $36f109edfb21e392$var$tokens;

});





parcelRegister("7NyDw", function(module, exports) {
$parcel$export(module.exports, "TableSharedCssClassName", () => $5ad7fa1a066b90dc$export$c096bca5477eb7ad);

var $gc8Zd = parcelRequire("gc8Zd");
var $5ad7fa1a066b90dc$export$c096bca5477eb7ad = {
    TABLE_CONTAINER: "".concat((0, $gc8Zd.tablePrefixSelector), "-container"),
    TABLE_NODE_WRAPPER: "".concat((0, $gc8Zd.tablePrefixSelector), "-wrapper"),
    TABLE_NODE_WRAPPER_NO_OVERFLOW: "".concat((0, $gc8Zd.tablePrefixSelector), "-wrapper-no-overflow"),
    TABLE_SCROLL_INLINE_SHADOW: "".concat((0, $gc8Zd.tablePrefixSelector), "-scroll-inline-shadow"),
    TABLE_RIGHT_BORDER: "".concat((0, $gc8Zd.tablePrefixSelector), "-right-border"),
    TABLE_LEFT_BORDER: "".concat((0, $gc8Zd.tablePrefixSelector), "-left-border"),
    TABLE_NATIVE_STICKY: "".concat((0, $gc8Zd.tablePrefixSelector), "-row-native-sticky"),
    TABLE_STICKY_WRAPPER: "".concat((0, $gc8Zd.tablePrefixSelector), "-sticky-wrapper"),
    TABLE_STICKY_SCROLLBAR_CONTAINER: "".concat((0, $gc8Zd.tablePrefixSelector), "-sticky-scrollbar-container"),
    TABLE_STICKY_SENTINEL_TOP: "".concat((0, $gc8Zd.tablePrefixSelector), "-sticky-sentinel-top"),
    TABLE_STICKY_SENTINEL_BOTTOM: "".concat((0, $gc8Zd.tablePrefixSelector), "-sticky-sentinel-bottom"),
    TABLE_STICKY_SCROLLBAR_SENTINEL_TOP: "".concat((0, $gc8Zd.tablePrefixSelector), "-sticky-scrollbar-sentinel-top"),
    TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM: "".concat((0, $gc8Zd.tablePrefixSelector), "-sticky-scrollbar-sentinel-bottom"),
    TABLE_STICKY: "".concat((0, $gc8Zd.tablePrefixSelector), "-sticky"),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_NODEVIEW_CONTENT_DOM: (0, $gc8Zd.tableCellContentDomSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_WRAPPER: (0, $gc8Zd.tableCellSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_HEADER_CELL_WRAPPER: (0, $gc8Zd.tableHeaderSelector),
    TABLE_ROW_CONTROLS_WRAPPER: "".concat((0, $gc8Zd.tablePrefixSelector), "-row-controls-wrapper"),
    TABLE_COLUMN_CONTROLS_DECORATIONS: "".concat((0, $gc8Zd.tablePrefixSelector), "-column-controls-decoration"),
    TABLE_RESIZER_CONTAINER: "".concat((0, $gc8Zd.tablePrefixSelector), "-resizer-container"),
    TABLE_VIEW_CONTENT_WRAP: 'tableView-content-wrap'
};

});



parcelRegister("eCI84", function(module, exports) {
$parcel$export(module.exports, "isTableInContentMode", () => $aa56d8740a8bad94$export$90b9840b2d94b80a);

var $jt8UI = parcelRequire("jt8UI");
var $aa56d8740a8bad94$export$8c07f44cea64e3c7 = function hasTableBeenResized(tableNode) {
    return tableNode.attrs.width !== null || (0, $jt8UI.hasTableColumnBeenResized)(tableNode);
};
var $aa56d8740a8bad94$export$90b9840b2d94b80a = function isTableInContentMode(_ref) {
    var tableNode = _ref.tableNode, isSupported = _ref.isSupported, isTableNested = _ref.isTableNested;
    if (!tableNode || isTableNested) return false;
    return isSupported && !$aa56d8740a8bad94$export$8c07f44cea64e3c7(tableNode) && tableNode.attrs.layout === 'align-start';
};

});
parcelRegister("jt8UI", function(module, exports) {
$parcel$export(module.exports, "hasTableColumnBeenResized", () => $e2c7a3d9eb982d82$export$b44a013e4f554514);
/**
 * Returns true if any cell in the first row of the table has a colwidth attribute set.
 *
 * Used by both the editor (as `hasTableColumnBeenResized`) and the renderer (as `hasColWidths`)
 * to determine whether a table has had its columns manually resized.
 */ var $e2c7a3d9eb982d82$export$b44a013e4f554514 = function hasTableColumnBeenResized(tableNode) {
    var firstRow = tableNode.content.firstChild;
    if (!firstRow) return false;
    for(var i = 0; i < firstRow.childCount; i++){
        if (firstRow.child(i).attrs.colwidth) return true;
    }
    return false;
};

});


parcelRegister("gmeX4", function(module, exports) {
$parcel$export(module.exports, "SortOrder", () => $be8a4c82821a90ef$export$7ae723045d45777a);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $1xyIw = parcelRequire("1xyIw");






var $be8a4c82821a90ef$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    SortOrder["NO_ORDER"] = "no_order";
    return SortOrder;
}({});

});

parcelRegister("3s4hn", function(module, exports) {
$parcel$export(module.exports, "compose", () => $28374e629f0028ec$export$f672e0b6f7222cd7);
/** Helper type for single arg function */ /**
 * Compose 1 to n functions.
 * @param func first function
 * @param funcs additional functions
 */ function $28374e629f0028ec$export$f672e0b6f7222cd7(func) {
    for(var _len = arguments.length, funcs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)funcs[_key - 1] = arguments[_key];
    var allFuncs = [
        func
    ].concat(funcs);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function composed(raw) {
        return allFuncs.reduceRight(function(memo, func) {
            return func(memo);
        }, raw);
    };
}

});

parcelRegister("lvHsm", function(module, exports) {
$parcel$export(module.exports, "convertProsemirrorTableNodeToArrayOfRows", () => $fa8e33c297951c18$export$69fbfaf01f2fd534);
/**
 *
 * @param tableNode
 * @example
 */ function $fa8e33c297951c18$export$69fbfaf01f2fd534(tableNode) {
    var result = [];
    tableNode.forEach(function(rowNode) {
        if (rowNode.type.name === 'tableRow') {
            var row = [];
            rowNode.forEach(function(n) {
                return row.push(n);
            });
            result.push(row);
        }
    });
    return result;
}

});

parcelRegister("1fkTi", function(module, exports) {
$parcel$export(module.exports, "createCompareNodes", () => $0e8765a50c144ac1$export$49215374a8bec29c);

var $iYJcE = parcelRequire("iYJcE");

var $gmeX4 = parcelRequire("gmeX4");

var $gTlxC = parcelRequire("gTlxC");
function $0e8765a50c144ac1$var$getLinkMark(node) {
    var _node$marks$filter = node.marks.filter(function(mark) {
        return mark.type.name === 'link';
    }), _node$marks$filter2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_node$marks$filter, 1), linkMark = _node$marks$filter2[0];
    return linkMark || null;
}
function $0e8765a50c144ac1$var$parseLocaleNumber(stringNumber, groupPattern, fractionPattern) {
    if (!stringNumber.trim().length) return null;
    var maybeANumber = Number.parseFloat(stringNumber.replace(groupPattern, '').replace(fractionPattern, '.'));
    if (Number.isNaN(maybeANumber)) return null;
    return maybeANumber;
}
function $0e8765a50c144ac1$export$8ebf986086b1866f() {
    // Source: https://stackoverflow.com/questions/12004808/does-javascript-take-local-decimal-separators-into-account
    var locale = window.navigator.language;
    var thousandSeparator = Intl.NumberFormat(locale).format(11111).replace(/(?:[0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]|\uD800[\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23\uDF41\uDF4A\uDFD1-\uDFD5]|\uD801[\uDCA0-\uDCA9]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE48\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD803[\uDCFA-\uDCFF\uDD30-\uDD39\uDD40-\uDD49\uDE60-\uDE7E\uDF1D-\uDF26\uDF51-\uDF54\uDFC5-\uDFCB]|\uD804[\uDC52-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDDE1-\uDDF4\uDEF0-\uDEF9]|\uD805[\uDC50-\uDC59\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDED0-\uDEE3\uDF30-\uDF3B]|\uD806[\uDCE0-\uDCF2\uDD50-\uDD59\uDFF0-\uDFF9]|\uD807[\uDC50-\uDC6C\uDD50-\uDD59\uDDA0-\uDDA9\uDDE0-\uDDE9\uDF50-\uDF59\uDFC0-\uDFD4]|\uD809[\uDC00-\uDC6E]|\uD818[\uDD30-\uDD39]|\uD81A[\uDE60-\uDE69\uDEC0-\uDEC9\uDF50-\uDF59\uDF5B-\uDF61]|\uD81B[\uDD70-\uDD79\uDE80-\uDE96\uDFF4-\uDFF6]|\uD833[\uDCF0-\uDCF9]|\uD834[\uDEC0-\uDED3\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDFCE-\uDFFF]|\uD838[\uDD40-\uDD49\uDEF0-\uDEF9]|\uD839[\uDCF0-\uDCF9\uDDF1-\uDDFA]|\uD83A[\uDCC7-\uDCCF\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9])/g, '');
    var decimalSeparator = Intl.NumberFormat(locale).format(1.1).replace(/(?:[0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]|\uD800[\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23\uDF41\uDF4A\uDFD1-\uDFD5]|\uD801[\uDCA0-\uDCA9]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE48\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD803[\uDCFA-\uDCFF\uDD30-\uDD39\uDD40-\uDD49\uDE60-\uDE7E\uDF1D-\uDF26\uDF51-\uDF54\uDFC5-\uDFCB]|\uD804[\uDC52-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDDE1-\uDDF4\uDEF0-\uDEF9]|\uD805[\uDC50-\uDC59\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDED0-\uDEE3\uDF30-\uDF3B]|\uD806[\uDCE0-\uDCF2\uDD50-\uDD59\uDFF0-\uDFF9]|\uD807[\uDC50-\uDC6C\uDD50-\uDD59\uDDA0-\uDDA9\uDDE0-\uDDE9\uDF50-\uDF59\uDFC0-\uDFD4]|\uD809[\uDC00-\uDC6E]|\uD818[\uDD30-\uDD39]|\uD81A[\uDE60-\uDE69\uDEC0-\uDEC9\uDF50-\uDF59\uDF5B-\uDF61]|\uD81B[\uDD70-\uDD79\uDE80-\uDE96\uDFF4-\uDFF6]|\uD833[\uDCF0-\uDCF9]|\uD834[\uDEC0-\uDED3\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDFCE-\uDFFF]|\uD838[\uDD40-\uDD49\uDEF0-\uDEF9]|\uD839[\uDCF0-\uDCF9\uDDF1-\uDDFA]|\uD83A[\uDCC7-\uDCCF\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9])/g, '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var numericPattern = new RegExp("(\\d+(?:[".concat(thousandSeparator).concat(decimalSeparator, "]?\\d+)*)"), 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var thousandSeparatorPattern = new RegExp('\\' + thousandSeparator, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var decimalSeparatorPattern = new RegExp('\\' + decimalSeparator);
    return function(text) {
        if (!text.trim().length) return null;
        // This will break the text apart at the locations of the formatted numbers
        var result = text.split(numericPattern);
        // We then put the text back together but with all the formatted numbers converted back to plain numerals,
        // for example a sentence like "What is 1,000.01% of 10,000.01" would be normalized and sorted as
        // if it's saying "What is 1000.01% of 10000.01". This way the Intl.Collator can use the numeric setting to sort
        // numeral values within string correctly.
        var tokens = result.reduce(function(acc, stringNumber) {
            if (!(stringNumber !== null && stringNumber !== void 0 && stringNumber.length)) return acc;
            var maybeANumber = $0e8765a50c144ac1$var$parseLocaleNumber(stringNumber, thousandSeparatorPattern, decimalSeparatorPattern);
            // NOTE: We know there can only be a single decimal separator. So we can assume that if the first found separator
            // is not at the same position as the last found one, then we can assume the locale used to format the number
            // is different to our locale. This will result in the value being treated as a string.
            if (maybeANumber !== null && stringNumber.indexOf(decimalSeparator) === stringNumber.lastIndexOf(decimalSeparator)) acc.push(maybeANumber);
            else acc.push(stringNumber);
            return acc;
        }, []);
        if (tokens.length === 1) return tokens[0];
        return tokens.join('');
    };
}
function $0e8765a50c144ac1$export$7cc053f549ed70b8(textNode, normalizeTextParser) {
    // treat as a link if contain a link
    var linkMark = $0e8765a50c144ac1$var$getLinkMark(textNode);
    if (linkMark) {
        var value = textNode.text || '';
        return {
            type: (0, $gTlxC.ContentType).LINK,
            value: value
        };
    }
    var text = textNode.text || '';
    var normalizedText = normalizeTextParser(text);
    if (typeof normalizedText === 'number') return {
        type: (0, $gTlxC.ContentType).NUMBER,
        value: normalizedText
    };
    return {
        type: (0, $gTlxC.ContentType).TEXT,
        value: normalizedText !== null && normalizedText !== void 0 ? normalizedText : text
    };
}
function $0e8765a50c144ac1$var$getMetaFromNode(node, options, normalizeTextParser) {
    if (!node) return null;
    var firstChild = node.firstChild;
    if (!firstChild) return null;
    switch(firstChild.type.name){
        // Text case
        /*
        Get Meta value from the first child if the cell is of type
          * Heading (Any cell where the text is set to a heading type)
          * Paragraph (Normal text)
       */ case 'heading':
        case 'paragraph':
            return $0e8765a50c144ac1$var$getMetaFromNode(firstChild, options, normalizeTextParser);
        case 'inlineCard':
            var attrs = firstChild.attrs;
            var maybeTitle = options.getInlineCardTextFromStore(attrs);
            if (maybeTitle) return {
                type: (0, $gTlxC.ContentType).LINK,
                value: maybeTitle
            };
            var url = attrs.url;
            return {
                type: (0, $gTlxC.ContentType).LINK,
                value: url ? url : ''
            };
        case 'text':
            return $0e8765a50c144ac1$export$7cc053f549ed70b8(firstChild, normalizeTextParser);
        case 'status':
            var _text = firstChild.attrs.text;
            return {
                type: (0, $gTlxC.ContentType).STATUS,
                value: _text
            };
        case 'date':
            var timestamp = Number.parseInt(firstChild.attrs.timestamp, 20);
            return {
                type: (0, $gTlxC.ContentType).DATE,
                value: timestamp
            };
        case 'mention':
            var _text2 = firstChild.attrs.text || '';
            return {
                type: (0, $gTlxC.ContentType).MENTION,
                value: _text2.toLowerCase()
            };
        default:
            return null;
    }
}
function $0e8765a50c144ac1$var$compareValue(valueA, valueB) {
    if (valueA === valueB) return 0;
    if (typeof valueA === 'string' && typeof valueB === 'string') return valueA.localeCompare(valueB, window.navigator.language, {
        caseFirst: 'upper',
        numeric: true
    });
    return valueA > valueB ? 1 : -1;
}
var $0e8765a50c144ac1$export$49215374a8bec29c = function createCompareNodes(options) {
    var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $gmeX4.SortOrder).ASC;
    var normalizeTextParser = $0e8765a50c144ac1$export$8ebf986086b1866f();
    return function(nodeA, nodeB) {
        var metaNodeA = $0e8765a50c144ac1$var$getMetaFromNode(nodeA, options, normalizeTextParser);
        var metaNodeB = $0e8765a50c144ac1$var$getMetaFromNode(nodeB, options, normalizeTextParser);
        /*
        Donot switch the order (Asec or Desc) if either node is null.
        This will ensure that empty cells are always at the bottom during sorting.
      */ if (metaNodeA === null || metaNodeB === null) return $0e8765a50c144ac1$var$compareMetaFromNode(metaNodeA, metaNodeB);
        return (order === (0, $gmeX4.SortOrder).DESC ? -1 : 1) * $0e8765a50c144ac1$var$compareMetaFromNode(metaNodeA, metaNodeB);
    };
};
function $0e8765a50c144ac1$var$compareMetaFromNode(metaNodeA, metaNodeB) {
    if (metaNodeA === metaNodeB) return 0;
    if (metaNodeA === null || metaNodeB === null) return metaNodeB === null ? -1 : 1;
    if (metaNodeA.type === (0, $gTlxC.ContentType).TEXT && metaNodeB.type === (0, $gTlxC.ContentType).NUMBER || metaNodeA.type === (0, $gTlxC.ContentType).NUMBER && metaNodeB.type === (0, $gTlxC.ContentType).TEXT) return $0e8765a50c144ac1$var$compareValue(String(metaNodeA.value), String(metaNodeB.value));
    if (metaNodeA.type !== metaNodeB.type) return metaNodeA.type > metaNodeB.type ? 1 : -1;
    return $0e8765a50c144ac1$var$compareValue(metaNodeA.value, metaNodeB.value);
}

});
parcelRegister("gTlxC", function(module, exports) {
$parcel$export(module.exports, "ContentType", () => $c4c27e056987430a$export$e2e108cbe2e4f865);
var $c4c27e056987430a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType[ContentType["NUMBER"] = 0] = "NUMBER";
    ContentType[ContentType["TEXT"] = 5] = "TEXT";
    ContentType[ContentType["MENTION"] = 10] = "MENTION";
    ContentType[ContentType["DATE"] = 15] = "DATE";
    ContentType[ContentType["STATUS"] = 20] = "STATUS";
    ContentType[ContentType["LINK"] = 25] = "LINK";
    return ContentType;
}({});

});


parcelRegister("6g4cz", function(module, exports) {
$parcel$export(module.exports, "hasMergedCell", () => $48e77f1509cfee61$export$f9d610bfbb78949b);
/**
 *
 * @param tableNode
 * @example
 */ function $48e77f1509cfee61$export$f9d610bfbb78949b(tableNode) {
    var hasSpan = false;
    tableNode.descendants(function(node) {
        if (node.type.name === 'tableRow') return true;
        var _node$attrs = node.attrs, colspan = _node$attrs.colspan, rowspan = _node$attrs.rowspan;
        if (colspan > 1 || rowspan > 1) hasSpan = true;
        return false;
    });
    return hasSpan;
}

});

parcelRegister("ky5Ao", function(module, exports) {
$parcel$export(module.exports, "useRendererContext", () => $ef5b50e852fe2b42$export$a906432540ed7ed8);
$parcel$export(module.exports, "RendererContextProvider", () => $ef5b50e852fe2b42$export$ca5df47902194781);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $5FkrB = parcelRequire("5FkrB");
var $ef5b50e852fe2b42$var$RendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext({});
var $ef5b50e852fe2b42$export$a906432540ed7ed8 = function useRendererContext() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useContext($ef5b50e852fe2b42$var$RendererContext);
};
var $ef5b50e852fe2b42$export$ca5df47902194781 = $ef5b50e852fe2b42$var$RendererContext.Provider;

});

parcelRegister("13ECD", function(module, exports) {
$parcel$export(module.exports, "FullPagePadding", () => $0c5594f72c7837da$export$12fd658e5eef0d79);
$parcel$export(module.exports, "TELEPOINTER_ID", () => $0c5594f72c7837da$export$74b525449cc7cbd1);
var $0c5594f72c7837da$export$12fd658e5eef0d79 = 32;
var $0c5594f72c7837da$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';

});

parcelRegister("4qXRD", function(module, exports) {
$parcel$export(module.exports, "Provider", () => $33a806e87b8f2642$export$2881499e37b75b9a);
$parcel$export(module.exports, "withSmartCardStorage", () => $33a806e87b8f2642$export$65e2d5a272a382b0);

var $kqp0i = parcelRequire("kqp0i");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $5FkrB = parcelRequire("5FkrB");
function $33a806e87b8f2642$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $33a806e87b8f2642$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $33a806e87b8f2642$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($33a806e87b8f2642$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $33a806e87b8f2642$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext(new Map());
var $33a806e87b8f2642$export$2881499e37b75b9a = function Provider(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($33a806e87b8f2642$export$841858b892ce1f4c.Provider, {
        value: new Map()
    }, children);
};
var $33a806e87b8f2642$export$65e2d5a272a382b0 = function withSmartCardStorage(WrappedComponent) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/prefer-stateless-function
    return /*#__PURE__*/ function(_React$Component) {
        function _class() {
            (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, _class);
            return $33a806e87b8f2642$var$_callSuper(this, _class, arguments);
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(_class, _React$Component);
        return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(_class, [
            {
                key: "render",
                value: function render() {
                    var _this = this;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($33a806e87b8f2642$export$841858b892ce1f4c.Consumer, null, function(storage) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, _this.props, {
                            smartCardStorage: storage
                        }));
                    });
                }
            }
        ]);
    }((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component);
};

});

parcelRegister("KYtRS", function(module, exports) {
$parcel$export(module.exports, "isFullWidthAppearance", () => $08d336355350b722$export$c0112b8340d4924b);
$parcel$export(module.exports, "isMaxWidthAppearance", () => $08d336355350b722$export$ab050440a1241762);
$parcel$export(module.exports, "isFullPageAppearance", () => $08d336355350b722$export$a64737a81cde10b4);
$parcel$export(module.exports, "isCommentAppearance", () => $08d336355350b722$export$f77d2ff45b2c53ed);
$parcel$export(module.exports, "isFullWidthOrFullPageAppearance", () => $08d336355350b722$export$33331a99fac775a1);
var $08d336355350b722$export$c0112b8340d4924b = function isFullWidthAppearance(appearance) {
    return appearance === 'full-width';
};
var $08d336355350b722$export$ab050440a1241762 = function isMaxWidthAppearance(appearance) {
    return appearance === 'max';
};
var $08d336355350b722$export$a64737a81cde10b4 = function isFullPageAppearance(appearance) {
    return appearance === 'full-page';
};
var $08d336355350b722$export$f77d2ff45b2c53ed = function isCommentAppearance(appearance) {
    return appearance === 'comment';
};
var $08d336355350b722$export$33331a99fac775a1 = function isFullWidthOrFullPageAppearance(appearance) {
    return $08d336355350b722$export$a64737a81cde10b4(appearance) || $08d336355350b722$export$c0112b8340d4924b(appearance) || $08d336355350b722$export$ab050440a1241762(appearance);
};

});

parcelRegister("ABxtu", function(module, exports) {
$parcel$export(module.exports, "isContentModeSupported", () => $06e07b5a99b08b76$export$e217d2a535d6ae45);
var $06e07b5a99b08b76$export$e217d2a535d6ae45 = function isContentModeSupported(_ref) {
    var allowTableResizing = _ref.allowTableResizing, rendererAppearance = _ref.rendererAppearance;
    return !!allowTableResizing && (rendererAppearance === 'full-page' || rendererAppearance === 'full-width' || rendererAppearance === 'max');
};

});

parcelRegister("lAKm0", function(module, exports) {
$parcel$export(module.exports, "tableStickyPadding", () => $fb80eab4330438e9$export$3de6413b528017ca);
$parcel$export(module.exports, "StickyTable", () => $fb80eab4330438e9$export$fd9654fc359d55a3);
$parcel$export(module.exports, "OverflowParent", () => $fb80eab4330438e9$export$e97bc6692974bd0b);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");
parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $7NyDw = parcelRequire("7NyDw");

var $1LBcl = parcelRequire("1LBcl");

var $50U6m = parcelRequire("50U6m");

var $drUcN = parcelRequire("drUcN");

var $a0WZy = parcelRequire("a0WZy");

var $dhEtU = parcelRequire("dhEtU");
var $fb80eab4330438e9$export$3de6413b528017ca = 8;
var $fb80eab4330438e9$var$modeSpecficStyles = {
    none: (0, $74Zh5.css)({
        display: 'none'
    }),
    stick: (0, $74Zh5.css)({
        position: 'fixed'
    }),
    'pin-bottom': (0, $74Zh5.css)({
        position: 'absolute'
    })
};
var $fb80eab4330438e9$var$suppressExternalStickStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Override external renderer wrapper styles targeting div[mode='stick']
    "&.fixed-table-div-custom-table-resizing[mode='stick']": {
        background: "var(--ds-surface, #FFFFFF)"
    }
});
var $fb80eab4330438e9$var$panelAwareStickyTableStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Override external renderer wrapper styles targeting div[mode='stick']
    "&.fixed-table-div-custom-table-resizing[mode='stick']": {
        background: "var(--ak-renderer-panel-bg-color, ".concat("var(--ds-surface, #FFFFFF)", ")")
    }
}, "& .".concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, ", & .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    tr: {
        background: "var(--ak-renderer-panel-bg-color, ".concat("var(--ds-surface, #FFFFFF)", ")")
    }
}), "borderTopColor", "var(--ak-renderer-panel-bg-color, ".concat("var(--ds-surface, #FFFFFF)", ")")), "background", "var(--ak-renderer-panel-bg-color, ".concat("var(--ds-surface-overlay, #FFFFFF)", ")")));
// refactored based on fixedTableDivStaticStyles
// TODO: DSP-4123 - Quality ticket
var $fb80eab4330438e9$var$fixedTableDivStaticStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    zIndex: 'var(--ak-renderer-sticky-header-zindex)'
}, "& .".concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, ", & .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), {
    marginTop: 0,
    marginBottom: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    tr: {
        background: "var(--ds-surface, #FFFFFF)"
    }
}), "borderTop", "".concat($fb80eab4330438e9$export$3de6413b528017ca, "px solid ", "var(--ds-surface, #FFFFFF)")), "background", "var(--ds-surface-overlay, #FFFFFF)"), "boxShadow", "0 6px 4px -4px ".concat("var(--ds-shadow-overflow-perimeter, #1E1F211f)")), "div[data-expanded='false'] &", {
    display: 'none'
}), "& .".concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, ".is-sticky.right-shadow::after, & .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, ".is-sticky.left-shadow::before"), {
    top: '0px',
    height: '100%'
}), "&.fixed-table-div-custom-table-resizing[mode='stick']", {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: 'var(--ak-renderer-sticky-header-zindex)'
}));
var $fb80eab4330438e9$var$FixedTableDiv = function FixedTableDiv(props) {
    var top = props.top, wrapperWidth = props.wrapperWidth, mode = props.mode, allowTableResizing = props.allowTableResizing;
    var stickyHeaderZIndex;
    if (allowTableResizing) stickyHeaderZIndex = 13;
    else stickyHeaderZIndex = (0, $1LBcl.akEditorStickyHeaderZIndex);
    var attrs = {
        mode: mode
    };
    return (0, $74Zh5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, attrs, {
        "data-testid": "sticky-table-fixed",
        className: allowTableResizing ? 'fixed-table-div-custom-table-resizing' : '',
        css: [
            $fb80eab4330438e9$var$fixedTableDivStaticStyles,
            $fb80eab4330438e9$var$modeSpecficStyles === null || $fb80eab4330438e9$var$modeSpecficStyles === void 0 ? void 0 : $fb80eab4330438e9$var$modeSpecficStyles[mode],
            (0, $drUcN.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && $fb80eab4330438e9$var$suppressExternalStickStyles,
            (0, $drUcN.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) && (0, $50U6m.fg)('platform_editor_nest_table_in_panel_patch_3') && $fb80eab4330438e9$var$panelAwareStickyTableStyles
        ],
        style: {
            '--ak-renderer-sticky-header-zindex': stickyHeaderZIndex,
            width: "".concat(wrapperWidth, "px"),
            top: typeof top === 'number' ? "".concat(top, "px") : undefined
        }
    }), props.children);
};
var $fb80eab4330438e9$export$fd9654fc359d55a3 = function StickyTable(_ref) {
    var top = _ref.top, left = _ref.left, mode = _ref.mode, shadowClassNames = _ref.shadowClassNames, innerRef = _ref.innerRef, wrapperWidth = _ref.wrapperWidth, tableWidth = _ref.tableWidth, isNumberColumnEnabled = _ref.isNumberColumnEnabled, layout = _ref.layout, children = _ref.children, columnWidths = _ref.columnWidths, renderWidth = _ref.renderWidth, rowHeight = _ref.rowHeight, tableNode = _ref.tableNode, rendererAppearance = _ref.rendererAppearance, allowTableResizing = _ref.allowTableResizing, allowFixedColumnWidthOption = _ref.allowFixedColumnWidthOption;
    var styles;
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ if (allowTableResizing) styles = (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'absolute'
    });
    else styles = (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: left && left < 0 ? left : undefined,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'relative'
    });
    /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    (0, $74Zh5.jsx)("div", {
        css: styles
    }, (0, $74Zh5.jsx)($fb80eab4330438e9$var$FixedTableDiv, {
        top: mode === 'stick' ? top : undefined,
        mode: rowHeight > 300 ? 'none' : mode,
        wrapperWidth: wrapperWidth,
        allowTableResizing: allowTableResizing
    }, (0, $74Zh5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "".concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, " is-sticky ").concat(shadowClassNames || ''),
        "data-layout": layout,
        style: {
            width: tableWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: 0
        }
    }, (0, $74Zh5.jsx)("div", {
        ref: innerRef,
        className: "".concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_WRAPPER),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden'
        }
    }, (0, $74Zh5.jsx)((0, $dhEtU.Table), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance,
        fixTableSSRResizing: true,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption
    }, /**
     * @see https://product-fabric.atlassian.net/browse/ED-10235
     * We pass prop 'invisible' to our table's children nodes meaning
     * they exist inside of the 'invisible' duplicated table component that
     * enables sticky headers.
     */ (0, $a0WZy.recursivelyInjectProps)(children, {
        invisible: true
    })))))));
};
/**
 * Traverse DOM Tree upwards looking for table parents with "overflow: scroll".
 * @param table
 * @param defaultScrollRootId
 * @example
 */ function $fb80eab4330438e9$var$findHorizontalOverflowScrollParent(table, defaultScrollRootId) {
    var parent = table;
    if (!parent) return null;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        var style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowY === 'scroll') return parent;
        if (!!defaultScrollRootId && parent.id === defaultScrollRootId) // If a defaultScrollRootId was specified and we reached the element with this id without finding a closer
        // scroll parent, use this element as the scroll parent
        return parent;
    }
    return null;
}
var $fb80eab4330438e9$export$e97bc6692974bd0b = /*#__PURE__*/ function() {
    function OverflowParent(ref) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, OverflowParent);
        this.ref = ref;
        this.ref = ref;
    }
    /**
   *
   * @param el
   * @param defaultScrollRootId
   * @example
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(OverflowParent, [
        {
            key: "isElement",
            get: /**
     *
     */ function get() {
                return this.ref instanceof HTMLElement;
            }
        },
        {
            key: "id",
            get: function get() {
                if (this.ref instanceof HTMLElement) return this.ref.id;
                return '';
            }
        },
        {
            key: "top",
            get: function get() {
                if (this.ref instanceof HTMLElement) return this.ref.getBoundingClientRect().top;
                return 0;
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(type, cb) {
                var _this$ref;
                for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                (_this$ref = this.ref).addEventListener.apply(_this$ref, [
                    type,
                    cb
                ].concat(args));
            }
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(type, cb) {
                var _this$ref2;
                for(var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                (_this$ref2 = this.ref).removeEventListener.apply(_this$ref2, [
                    type,
                    cb
                ].concat(args));
            }
        }
    ], [
        {
            key: "fromElement",
            value: function fromElement(el, defaultScrollRootId) {
                return new OverflowParent($fb80eab4330438e9$var$findHorizontalOverflowScrollParent(el, defaultScrollRootId) || window);
            }
        }
    ]);
}();

});
parcelRegister("a0WZy", function(module, exports) {
$parcel$export(module.exports, "recursivelyInjectProps", () => $74a7aa0640e1d4dc$export$40e12ce8e0a76b0c);

var $5FkrB = parcelRequire("5FkrB");
function $74a7aa0640e1d4dc$export$40e12ce8e0a76b0c(children, propsToInject) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.toArray(children).map(function(child) {
        // Cannot add a prop to an invalid element, so just return the child
        if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).isValidElement(child)) return child;
        // Recursive call if child has nested children
        if (child.props.children) child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).cloneElement(child, {
            children: $74a7aa0640e1d4dc$export$40e12ce8e0a76b0c(child.props.children, propsToInject)
        });
        // Add props to react child node
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).cloneElement(child, propsToInject);
    });
}

});

parcelRegister("dhEtU", function(module, exports) {
$parcel$export(module.exports, "Table", () => $9abc43ad65de416a$export$54ec01a60f47d33d);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $hrVpF = parcelRequire("hrVpF");

var $eCI84 = parcelRequire("eCI84");

var $1LBcl = parcelRequire("1LBcl");

var $50U6m = parcelRequire("50U6m");

var $bSj2D = parcelRequire("bSj2D");

var $ABxtu = parcelRequire("ABxtu");
var $9abc43ad65de416a$export$54ec01a60f47d33d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(function(_ref) {
    var _tableNode$attrs;
    var innerRef = _ref.innerRef, isNumberColumnEnabled = _ref.isNumberColumnEnabled, columnWidths = _ref.columnWidths, layout = _ref.layout, renderWidth = _ref.renderWidth, children = _ref.children, tableNode = _ref.tableNode, rendererAppearance = _ref.rendererAppearance, isInsideOfBlockNode = _ref.isInsideOfBlockNode, isInsideOfNestedRenderer = _ref.isInsideOfNestedRenderer, isInsideOfTable = _ref.isInsideOfTable, isinsideMultiBodiedExtension = _ref.isinsideMultiBodiedExtension, allowTableResizing = _ref.allowTableResizing, isPresentational = _ref.isPresentational, _ref$fixTableSSRResiz = _ref.fixTableSSRResizing, fixTableSSRResizing = _ref$fixTableSSRResiz === void 0 ? false : _ref$fixTableSSRResiz, _ref$allowFixedColumn = _ref.allowFixedColumnWidthOption, allowFixedColumnWidthOption = _ref$allowFixedColumn === void 0 ? false : _ref$allowFixedColumn;
    var tableWidth = tableNode ? (0, $hrVpF.getTableContainerWidth)(tableNode) : (0, $1LBcl.akEditorDefaultLayoutWidth);
    var tableColumnWidths = columnWidths;
    if (rendererAppearance === 'comment' && allowTableResizing && tableNode && !((_tableNode$attrs = tableNode.attrs) !== null && _tableNode$attrs !== void 0 && _tableNode$attrs.width)) tableWidth = 'inherit';
    // for columns that are evenly distributed, do not return `colgroup` since existing table containerQuery
    // scales up the columns width. This ensures columns always have 42px.
    if (rendererAppearance === 'comment') tableColumnWidths = columnWidths && (0, $bSj2D.colWidthSum)(columnWidths) ? columnWidths : undefined;
    var tableLayout = tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout;
    var tableDisplayMode = tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.displayMode;
    var isContentMode = (0, $eCI84.isTableInContentMode)({
        tableNode: tableNode,
        isSupported: (0, $ABxtu.isContentModeSupported)({
            allowTableResizing: allowTableResizing,
            rendererAppearance: rendererAppearance
        }),
        isTableNested: isInsideOfBlockNode || isInsideOfNestedRenderer || isInsideOfTable
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("table", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, (0, $50U6m.fg)('platform_renderer_isPresentational') && {
        role: isPresentational ? 'presentation' : undefined
    }, {
        "data-testid": "renderer-table",
        "data-number-column": isNumberColumnEnabled,
        "data-table-width": tableWidth,
        "data-layout": tableLayout,
        "data-table-display-mode": tableDisplayMode,
        "data-initial-width-mode": isContentMode ? 'content' : undefined,
        ref: innerRef,
        style: {
            marginTop: fixTableSSRResizing ? '0px' : ''
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bSj2D.Colgroup), {
        columnWidths: tableColumnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance,
        isInsideOfBlockNode: isInsideOfBlockNode,
        isInsideOfTable: isInsideOfTable,
        isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
        allowTableResizing: allowTableResizing,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("tbody", null, children));
});

});
parcelRegister("bSj2D", function(module, exports) {
$parcel$export(module.exports, "colWidthSum", () => $8a538216a4f48875$export$2d9bdaa5b8cd99f0);
$parcel$export(module.exports, "Colgroup", () => $8a538216a4f48875$export$89efc2d0ceeaa030);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $hrVpF = parcelRequire("hrVpF");

var $fMtrl = parcelRequire("fMtrl");

var $01HkO = parcelRequire("01HkO");

var $1LBcl = parcelRequire("1LBcl");

var $50U6m = parcelRequire("50U6m");

var $ky5Ao = parcelRequire("ky5Ao");
function $8a538216a4f48875$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8a538216a4f48875$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8a538216a4f48875$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8a538216a4f48875$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// we allow scaling down column widths by no more than 30%
// this intends to reduce unwanted scrolling in the Renderer in these scenarios:
// User A creates a table with column widths → User B views it on a smaller screen
// User A creates a table with column widths → User A views it with reduced viewport space (eg. Confluence sidebar is open)
var $8a538216a4f48875$var$MAX_SCALING_PERCENT = 0.3;
var $8a538216a4f48875$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION = 0.4;
var $8a538216a4f48875$var$isTableColumnResized = function isTableColumnResized(columnWidths) {
    var filteredWidths = columnWidths.filter(function(width) {
        return width !== 0;
    });
    return !!filteredWidths.length;
};
var $8a538216a4f48875$var$fixColumnWidth = function fixColumnWidth(_ref) {
    var columnWidth = _ref.columnWidth, zeroWidthColumnsCount = _ref.zeroWidthColumnsCount, scaleDownPercent = _ref.scaleDownPercent, skipMinWidth = _ref.skipMinWidth;
    if (columnWidth === 0) return columnWidth;
    // If the tables total width (including no zero widths col or cols without width) is less than the current layout
    // We scale up the columns to meet the minimum of the table layout.
    if (zeroWidthColumnsCount === 0 && scaleDownPercent) {
        var scaled = Math.floor((1 - scaleDownPercent) * columnWidth);
        return skipMinWidth ? scaled : Math.max(scaled, (0, $fMtrl.tableCellMinWidth));
    }
    var adjusted = columnWidth - (0, $fMtrl.tableCellBorderWidth);
    if (skipMinWidth) return adjusted;
    return Math.max(adjusted, zeroWidthColumnsCount ? (0, $1LBcl.akEditorTableLegacyCellMinWidth) : (0, $fMtrl.tableCellMinWidth));
};
var $8a538216a4f48875$var$calcScalePercent = function calcScalePercent(_ref2) {
    var renderWidth = _ref2.renderWidth, tableWidth = _ref2.tableWidth, maxScale = _ref2.maxScale, isNumberColumnEnabled = _ref2.isNumberColumnEnabled;
    var noNumColumnScalePercent = renderWidth / tableWidth;
    // when numbered column is enabled, we need to calculate the scale percent without the akEditorTableNumberColumnWidth
    // As numbered column width is not scaled down
    var numColumnScalePercent = (renderWidth - (0, $1LBcl.akEditorTableNumberColumnWidth)) / (tableWidth - (0, $1LBcl.akEditorTableNumberColumnWidth));
    var diffPercent = 1 - noNumColumnScalePercent;
    return diffPercent < maxScale ? isNumberColumnEnabled ? 1 - numColumnScalePercent : diffPercent : maxScale;
};
var $8a538216a4f48875$export$2d9bdaa5b8cd99f0 = function colWidthSum(columnWidths) {
    return columnWidths.reduce(function(prev, curr) {
        return curr + prev;
    }, 0);
};
/**
 * Returns the data-column available width: total width minus the fixed number column if enabled.
 */ var $8a538216a4f48875$var$getDataColumnWidth = function getDataColumnWidth(totalWidth, isNumberColumnEnabled) {
    return isNumberColumnEnabled ? totalWidth - (0, $1LBcl.akEditorTableNumberColumnWidth) : totalWidth;
};
/**
 * Scales column widths proportionally to fit within availableWidth, matching the editor's
 * scaleTableTo(): floors each column to the nearest pixel, then redistributes any rounding
 * remainder to the first column that can absorb it without going below tableCellMinWidth.
 */ var $8a538216a4f48875$var$scaleColumnsToWidth = function scaleColumnsToWidth(columnWidths, availableWidth) {
    var rawTotalWidth = columnWidths.reduce(function(sum, w) {
        return sum + w;
    }, 0);
    var scaleFactor = availableWidth / rawTotalWidth;
    var scaledWidths = columnWidths.map(function(colWidth) {
        return Math.max(Math.floor(colWidth * scaleFactor), (0, $fMtrl.tableCellMinWidth));
    });
    var totalScaled = scaledWidths.reduce(function(sum, w) {
        return sum + w;
    }, 0);
    var diff = availableWidth - totalScaled;
    if (diff !== 0 && Math.abs(diff) < (0, $fMtrl.tableCellMinWidth)) {
        for(var i = 0; i < scaledWidths.length; i++)if (scaledWidths[i] + diff > (0, $fMtrl.tableCellMinWidth)) {
            scaledWidths[i] += diff;
            break;
        }
    }
    return scaledWidths.map(function(width) {
        return {
            width: "".concat(width, "px")
        };
    });
};
/**
 * Computes column widths for tables inside sync blocks, matching the editor's scaleTableTo() exactly.
 * Returns null if not inside a sync block.
 *
 * For nested tables (isInsideOfTable=true), we use getTableContainerWidth(tableNode) as the
 * reference — the width the editor saved, which already accounts for the parent cell's available
 * space (colwidth minus tableCellPadding * 2). This matches bodiedSyncBlock where isRendererNested=false,
 * so renderScaleDownColgroup uses getTableContainerWidth(tableNode). For syncBlock the nested
 * renderer has isRendererNested=true, which incorrectly overrides tableContainerWidth with renderWidth
 * (the full container), causing overflow by 2 * tableCellPadding (16px).
 */ var $8a538216a4f48875$var$renderSyncBlockColgroup = function renderSyncBlockColgroup(_ref3) {
    var isInsideOfSyncBlock = _ref3.isInsideOfSyncBlock, isInsideOfTable = _ref3.isInsideOfTable, tableNode = _ref3.tableNode, columnWidths = _ref3.columnWidths, isNumberColumnEnabled = _ref3.isNumberColumnEnabled, renderWidthProp = _ref3.renderWidth, contextWidth = _ref3.contextWidth;
    if (!isInsideOfSyncBlock) return null;
    var rawTotalWidth = columnWidths.reduce(function(sum, w) {
        return sum + w;
    }, 0);
    if (isInsideOfTable) return null;
    // SSR / first client render before WidthObserver measures. Output % of original ADF
    // proportions so columns are stable — the CSS container query (100cqw) handles actual
    // scaling width. We key off renderWidthProp alone because WidthProvider initialises with
    // document.body.offsetWidth (non-zero on the client), so contextWidth > 0 even before
    // WidthObserver has measured the real container, which would skip this branch and produce
    // column widths scaled to the full viewport.
    if (renderWidthProp <= 0) {
        var fullTableWidth = isNumberColumnEnabled ? rawTotalWidth + (0, $1LBcl.akEditorTableNumberColumnWidth) : rawTotalWidth;
        return columnWidths.map(function(colWidth) {
            return {
                width: "".concat(colWidth / fullTableWidth * 100, "%")
            };
        });
    }
    // contextWidth measures the sync block content area. Subtract 2 to match the editor's
    // getParentNodeWidth() border offset. Fall back to renderWidthProp for the non-CSS path.
    var effectiveRenderWidth = contextWidth > 0 ? contextWidth - 2 : renderWidthProp;
    var availableWidth = $8a538216a4f48875$var$getDataColumnWidth(effectiveRenderWidth, isNumberColumnEnabled);
    // Only scale down if the table is actually wider than the available space.
    // If the table fits, return original widths with the same tableCellBorderWidth (2px) adjustment
    // that renderScaleDownColgroup applies via fixColumnWidth's no-scale path.
    if (availableWidth >= rawTotalWidth) return columnWidths.map(function(colWidth) {
        return {
            width: "".concat(Math.max(colWidth - (0, $fMtrl.tableCellBorderWidth), (0, $fMtrl.tableCellMinWidth)), "px")
        };
    });
    // Cap scaling at MAX_SCALING_PERCENT (30%), matching renderScaleDownColgroup's calcScalePercent.
    //
    // Both `availableWidth` and `rawTotalWidth` are already in data-column space (number column
    // excluded via getDataColumnWidth), so `diffPercent = 1 - availableWidth / rawTotalWidth` is
    // equivalent to calcScalePercent's `numColumnScalePercent` path when isNumberColumnEnabled,
    // and to the `noNumColumnScalePercent` path otherwise. We express the cap as a target width
    // (clampedAvailableWidth) rather than a scale-down percentage, but the result is the same:
    // columns are scaled by at most MAX_SCALING_PERCENT (30%).
    var diffPercent = 1 - availableWidth / rawTotalWidth;
    var clampedAvailableWidth = diffPercent <= $8a538216a4f48875$var$MAX_SCALING_PERCENT ? availableWidth : Math.floor(rawTotalWidth * (1 - $8a538216a4f48875$var$MAX_SCALING_PERCENT));
    return $8a538216a4f48875$var$scaleColumnsToWidth(columnWidths, clampedAvailableWidth);
};
var $8a538216a4f48875$var$renderScaleDownColgroup = function renderScaleDownColgroup(props) {
    var _props$tableNode;
    var columnWidths = props.columnWidths, isNumberColumnEnabled = props.isNumberColumnEnabled, renderWidth = props.renderWidth, tableNode = props.tableNode, rendererAppearance = props.rendererAppearance, isInsideOfBlockNode = props.isInsideOfBlockNode, isInsideOfTable = props.isInsideOfTable, isinsideMultiBodiedExtension = props.isinsideMultiBodiedExtension, isTableScalingEnabled = props.isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled = props.isTableFixedColumnWidthsOptionEnabled, allowTableResizing = props.allowTableResizing, isTopLevelRenderer = props.isTopLevelRenderer, isInsideOfSyncBlock = props.isInsideOfSyncBlock;
    var skipMinWidth = !!(isInsideOfTable && isInsideOfSyncBlock);
    if (!columnWidths || columnWidths.every(function(width) {
        return width === 0;
    }) && (0, $50U6m.fg)('platform_editor_numbered_column_in_include')) return [];
    var tableColumnResized = $8a538216a4f48875$var$isTableColumnResized(columnWidths);
    var noOfColumns = columnWidths.length;
    var targetWidths;
    // This is a fix for ED-23259
    // Some extensions (for ex: Page Properties or Excerpt) do not renderer tables directly inside themselves. They use ReactRenderer.
    // So if we add a check like isInsideExtension (similar to exising isInsideBlockNode), it will fail, and to the only way to learn
    // if the table is rendered inside another node, is to check if the Renderer itself is nested.
    var isRendererNested = isTopLevelRenderer === false;
    // appearance == comment && allowTableResizing && !tableNode?.attrs.width, means it is a comment
    // appearance == comment && !allowTableResizing && !tableNode?.attrs.width, means it is a inline comment
    // When comment and inline comment table width inherits from the parent container, we want tableContainerWidth === renderWidth
    // Tables with numbered columns inside of extensions cannot use the renderWidth when it is 0. In this case, it should
    // explicitly use the width coming from the table node as the final table container width.
    var tableContainerWidth = rendererAppearance === 'comment' && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) || isRendererNested && !isNumberColumnEnabled ? renderWidth : (0, $hrVpF.getTableContainerWidth)(tableNode);
    if (allowTableResizing && !isInsideOfBlockNode && !isInsideOfTable && !isinsideMultiBodiedExtension && !tableColumnResized) {
        // when no columns are resized, each column should have equal width, equals to tableWidth / noOfColumns
        var _tableWidth = (isNumberColumnEnabled ? tableContainerWidth - (0, $1LBcl.akEditorTableNumberColumnWidth) : tableContainerWidth) - 1;
        var defaultColumnWidth = _tableWidth / noOfColumns;
        targetWidths = new Array(noOfColumns).fill(defaultColumnWidth);
    } else if (!tableColumnResized) return null;
    var sumOfColumns = $8a538216a4f48875$export$2d9bdaa5b8cd99f0(columnWidths);
    // tables in the wild may be smaller than table container width (col resizing bugs, created before custom widths etc.)
    // this causes issues with num column scaling as we add a new table column in renderer
    var isTableSmallerThanContainer = sumOfColumns < tableContainerWidth - 1;
    var forceScaleForNumColumn = isTableScalingEnabled && isNumberColumnEnabled && tableColumnResized;
    // when table resized and number column is enabled, we need to scale down the table in render
    if (forceScaleForNumColumn) {
        var calculatedTableContainerWidth = rendererAppearance === 'comment' ? sumOfColumns : tableContainerWidth;
        var scalePercentage = +((calculatedTableContainerWidth - (0, $1LBcl.akEditorTableNumberColumnWidth)) / calculatedTableContainerWidth);
        var targetMaxWidth = calculatedTableContainerWidth - (0, $1LBcl.akEditorTableNumberColumnWidth);
        var totalWidthAfterScale = 0;
        var newScaledTargetWidths = columnWidths.map(function(width) {
            // we need to scale each column UP, to ensure total width of table matches table container
            var patchedWidth = isTableSmallerThanContainer ? width / sumOfColumns * (calculatedTableContainerWidth - 1) : width;
            var newWidth = Math.floor(patchedWidth * scalePercentage);
            totalWidthAfterScale += newWidth;
            return newWidth;
        });
        var diff = targetMaxWidth - totalWidthAfterScale;
        targetWidths = newScaledTargetWidths;
        if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $fMtrl.tableCellMinWidth)) {
            var updated = false;
            targetWidths = targetWidths.map(function(width) {
                if (!updated && width + diff > (0, $fMtrl.tableCellMinWidth)) {
                    updated = true;
                    width += diff;
                }
                return width;
            });
        }
    }
    targetWidths = targetWidths || columnWidths;
    // @see ED-6056
    var maxTableWidth = renderWidth < tableContainerWidth ? renderWidth : tableContainerWidth;
    var tableWidth = isNumberColumnEnabled ? (0, $1LBcl.akEditorTableNumberColumnWidth) : 0;
    var minTableWidth = tableWidth;
    var zeroWidthColumnsCount = 0;
    targetWidths.forEach(function(width) {
        if (width) tableWidth += Math.ceil(width);
        else zeroWidthColumnsCount += 1;
        minTableWidth += Math.ceil(width) || (0, $1LBcl.akEditorTableLegacyCellMinWidth);
    });
    var cellMinWidth = 0;
    var scaleDownPercent = 0;
    var isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    var isTableWidthFixed = isTableScalingWithFixedColumnWidthsOptionEnabled && ((_props$tableNode = props.tableNode) === null || _props$tableNode === void 0 ? void 0 : _props$tableNode.attrs.displayMode) === 'fixed';
    var maxScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && rendererAppearance === 'comment' ? $8a538216a4f48875$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION : $8a538216a4f48875$var$MAX_SCALING_PERCENT;
    // fixes migration tables with zero-width columns
    if (zeroWidthColumnsCount > 0) {
        if (minTableWidth > maxTableWidth) {
            var minWidth = Math.ceil((maxTableWidth - tableWidth) / zeroWidthColumnsCount);
            cellMinWidth = minWidth < (0, $1LBcl.akEditorTableLegacyCellMinWidth) ? (0, $1LBcl.akEditorTableLegacyCellMinWidth) : minWidth;
        }
    } else if (renderWidth < tableWidth && !isTableWidthFixed) scaleDownPercent = $8a538216a4f48875$var$calcScalePercent({
        renderWidth: renderWidth,
        tableWidth: tableWidth,
        maxScale: maxScalingPercent,
        isNumberColumnEnabled: isNumberColumnEnabled
    });
    if (isNumberColumnEnabled && (tableWidth < maxTableWidth || maxTableWidth === 0)) {
        var fixedColWidths = targetWidths.map(function(width) {
            return $8a538216a4f48875$var$fixColumnWidth({
                columnWidth: width,
                zeroWidthColumnsCount: zeroWidthColumnsCount,
                scaleDownPercent: scaleDownPercent,
                skipMinWidth: skipMinWidth
            }) || cellMinWidth;
        });
        var sumFixedColumnWidths = $8a538216a4f48875$export$2d9bdaa5b8cd99f0(fixedColWidths);
        return fixedColWidths.map(function(colWidth) {
            var width = Math.max(colWidth, cellMinWidth);
            if (colWidth > (0, $1LBcl.akEditorTableCellMinWidth)) // To make sure the numbered column isn't scaled, use
            // percentages for the other columns.
            // Calculate the percentage based on the sum of the fixed column widths
            return {
                width: "".concat(width / sumFixedColumnWidths * 100, "%")
            };
            else {
                // If the column is equal to or less than the minimum cell width, we need to return a fixed pixel width.
                // This is to prevent columns being scaled below the minimum cell width.
                var style = width ? {
                    width: "".concat(width, "px")
                } : {};
                return style;
            }
        });
    }
    return targetWidths.map(function(colWidth) {
        var width = $8a538216a4f48875$var$fixColumnWidth({
            columnWidth: colWidth,
            zeroWidthColumnsCount: zeroWidthColumnsCount,
            scaleDownPercent: scaleDownPercent,
            skipMinWidth: skipMinWidth
        }) || cellMinWidth;
        var style = width ? {
            width: "".concat(width, "px")
        } : {};
        return style;
    });
};
var $8a538216a4f48875$export$89efc2d0ceeaa030 = function Colgroup(props) {
    var _props$allowFixedColu, _renderSyncBlockColgr;
    var _useRendererContext = (0, $ky5Ao.useRendererContext)(), isTopLevelRenderer = _useRendererContext.isTopLevelRenderer, nestedRendererType = _useRendererContext.nestedRendererType;
    var columnWidths = props.columnWidths, isNumberColumnEnabled = props.isNumberColumnEnabled;
    var _useContext = (0, $5FkrB.useContext)((0, $01HkO.WidthContext)), contextWidth = _useContext.width;
    if (!columnWidths) return null;
    var isTableFixedColumnWidthsOptionEnabled = (_props$allowFixedColu = props.allowFixedColumnWidthOption) !== null && _props$allowFixedColu !== void 0 ? _props$allowFixedColu : false;
    // For referenced sync blocks, nestedRendererType='syncedBlock' is set via RendererContextProvider
    // in AKRendererWrapper. ReactSerializer is a class and cannot read React context, so we detect
    // it here in the Colgroup component via useRendererContext() instead of prop-drilling.
    var isInsideOfSyncBlock = nestedRendererType === 'syncedBlock';
    // renderSyncBlockColgroup returns null when not applicable (flag off, SSR, not a sync block),
    // in which case ?? falls back to the standard renderScaleDownColgroup path.
    var colStyles = (_renderSyncBlockColgr = $8a538216a4f48875$var$renderSyncBlockColgroup({
        isInsideOfSyncBlock: isInsideOfSyncBlock,
        isInsideOfTable: !!props.isInsideOfTable,
        tableNode: props.tableNode,
        columnWidths: columnWidths,
        isNumberColumnEnabled: !!isNumberColumnEnabled,
        renderWidth: props.renderWidth,
        contextWidth: contextWidth
    })) !== null && _renderSyncBlockColgr !== void 0 ? _renderSyncBlockColgr : $8a538216a4f48875$var$renderScaleDownColgroup($8a538216a4f48875$var$_objectSpread($8a538216a4f48875$var$_objectSpread({}, props), {}, {
        isTopLevelRenderer: isTopLevelRenderer,
        isInsideOfSyncBlock: isInsideOfSyncBlock,
        isTableScalingEnabled: props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'max' || props.rendererAppearance === 'comment',
        isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled && (props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'max')
    }));
    if (!colStyles) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("colgroup", null, isNumberColumnEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("col", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            width: (0, $1LBcl.akEditorTableNumberColumnWidth)
        },
        "data-test-id": 'num'
    }), colStyles.map(function(style, idx) {
        return(/*#__PURE__*/ // Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("col", {
            key: idx,
            style: style
        }));
    }));
};

});



parcelRegister("65d1I", function(module, exports) {
$parcel$export(module.exports, "TableHeader", () => $46dd508ed67d6196$export$f850895b287ef28e);
$parcel$export(module.exports, "TableCell", () => $46dd508ed67d6196$export$1e4baea7053fc0e3);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $hrVKU = parcelRequire("hrVKU");

var $cQBqP = parcelRequire("cQBqP");

var $gc8Zd = parcelRequire("gc8Zd");

var $jJH6F = parcelRequire("jJH6F");

var $blliI = parcelRequire("blliI");

var $gmeX4 = parcelRequire("gmeX4");

var $b6T7g = parcelRequire("b6T7g");

var $drUcN = parcelRequire("drUcN");

var $eqmEx = parcelRequire("eqmEx");

var $jLsC1 = parcelRequire("jLsC1");

var $aP6HU = parcelRequire("aP6HU");

var $53SBn = parcelRequire("53SBn");

var $3cXxO = parcelRequire("3cXxO");
var $46dd508ed67d6196$var$IgnoreSorting = [
    'LABEL',
    'INPUT'
];
var $46dd508ed67d6196$var$nextStatusOrder = function nextStatusOrder(currentSortOrder) {
    switch(currentSortOrder){
        case (0, $gmeX4.SortOrder).NO_ORDER:
            return (0, $gmeX4.SortOrder).ASC;
        case (0, $gmeX4.SortOrder).ASC:
            return (0, $gmeX4.SortOrder).DESC;
        case (0, $gmeX4.SortOrder).DESC:
            return (0, $gmeX4.SortOrder).NO_ORDER;
    }
    return (0, $gmeX4.SortOrder).NO_ORDER;
};
var $46dd508ed67d6196$var$getSortOrderLabel = function getSortOrderLabel(intl, currentSortOrder) {
    var noneSortingLabel = (0, $3cXxO.tableCellMessages).noneSortingLabel, ascSortingLabel = (0, $3cXxO.tableCellMessages).ascSortingLabel, descSortingLabel = (0, $3cXxO.tableCellMessages).descSortingLabel;
    switch(currentSortOrder){
        case (0, $gmeX4.SortOrder).NO_ORDER:
            return intl.formatMessage(noneSortingLabel);
        case (0, $gmeX4.SortOrder).ASC:
            return intl.formatMessage(ascSortingLabel);
        case (0, $gmeX4.SortOrder).DESC:
            return intl.formatMessage(descSortingLabel);
        default:
            return intl.formatMessage(noneSortingLabel);
    }
};
var $46dd508ed67d6196$var$getDataAttributes = function getDataAttributes(colwidth, background, cellEdgeProps, valign) {
    var attrs = {};
    if (colwidth) attrs['data-colwidth'] = colwidth.join(',');
    if ((0, $drUcN.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true)) {
        if (cellEdgeProps !== null && cellEdgeProps !== void 0 && cellEdgeProps.reachesTop) attrs['data-reaches-top'] = true;
        if (cellEdgeProps !== null && cellEdgeProps !== void 0 && cellEdgeProps.reachesBottom) attrs['data-reaches-bottom'] = true;
        if (cellEdgeProps !== null && cellEdgeProps !== void 0 && cellEdgeProps.reachesLeft) attrs['data-reaches-left'] = true;
        if (cellEdgeProps !== null && cellEdgeProps !== void 0 && cellEdgeProps.reachesRight) attrs['data-reaches-right'] = true;
    }
    /**
   * Storing hex code in data-cell-background because
   *  we want to have DST token (css variable) or
   *  DST token value (value (hex code) of css variable) in
   *  inline style to correct render table cell background
   *  based on selected theme.
   * Currently we rely on background color hex code stored in
   *  inline style.
   * Because of that when we copy and paste table, we end up
   *  having DST token or DST token value in ADF instead of
   *  original hex code which we map to DST token.
   * So, introducing data-cell-background.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ if (background) attrs['data-cell-background'] = background;
    if (valign && (0, $eqmEx.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true)) attrs['data-valign'] = valign;
    return attrs;
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $46dd508ed67d6196$var$cssVariablePattern = /^var\(--.*\)$/;
var $46dd508ed67d6196$var$getStyle = function getStyle(_ref) {
    var background = _ref.background, colGroupWidth = _ref.colGroupWidth, offsetTop = _ref.offsetTop, colorMode = _ref.colorMode, valign = _ref.valign;
    var style = {};
    if (background && // ignore setting inline styles if ds neutral token is detected
    !background.includes('--ds-background-neutral')) {
        /**
     * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
     * backgrounds persisted.
     *
     * This feature predates the introduction of dark mode.
     *
     * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-cell-background), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $b6T7g.hexToEditorBackgroundPaletteRawValue)(background);
        if (tokenColor) style.backgroundColor = tokenColor;
        else if (/**
     * There was previously a bug in dark mode where we would attempt to invert
     * a design token in `getDarkModeLCHColor` causing issues.
     * If it's a design token we should return it as is.
     */ $46dd508ed67d6196$var$cssVariablePattern.test(background)) style.backgroundColor = background;
        else // if we have a custom color, we need to check if we are in dark mode
        if (colorMode === 'dark') // if we are in dark mode, we need to invert the color
        style.backgroundColor = (0, $cQBqP.getDarkModeLCHColor)(background);
        else // if we are in light mode, we can just set the color
        style.backgroundColor = background;
    }
    if (colGroupWidth) {
        style.width = colGroupWidth;
        style.minWidth = colGroupWidth;
    }
    if (offsetTop !== undefined) style.top = offsetTop;
    if (valign && (0, $eqmEx.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true)) style.verticalAlign = valign;
    return style;
};
var $46dd508ed67d6196$var$getWithCellProps = function getWithCellProps(WrapperComponent) {
    return function WithCellProps(props) {
        var _useThemeObserver = (0, $jLsC1.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
        var children = props.children, className = props.className, onClick = props.onClick, colwidth = props.colwidth, colGroupWidth = props.colGroupWidth, rowspan = props.rowspan, colspan = props.colspan, background = props.background, offsetTop = props.offsetTop, ariaSort = props.ariaSort, reachesTop = props.reachesTop, reachesBottom = props.reachesBottom, reachesLeft = props.reachesLeft, reachesRight = props.reachesRight, valign = props.valign;
        // This is used to set the background color of the cell
        // to a dark mode color in mobile dark mode
        var backgroundHex = background === null || background === void 0 ? void 0 : background.toLowerCase();
        var colorName = backgroundHex ? (0, $gc8Zd.tableBackgroundColorNameByHex).get(backgroundHex) : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrapperComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            rowSpan: rowspan,
            colSpan: colspan,
            style: $46dd508ed67d6196$var$getStyle({
                background: background,
                colGroupWidth: colGroupWidth,
                offsetTop: offsetTop,
                colorMode: colorMode,
                valign: valign
            }),
            colorname: colorName,
            onClick: onClick,
            className: className
        }, $46dd508ed67d6196$var$getDataAttributes(colwidth, background, {
            reachesTop: reachesTop,
            reachesBottom: reachesBottom,
            reachesLeft: reachesLeft,
            reachesRight: reachesRight
        }, valign), {
            "aria-sort": ariaSort
        }), children);
    };
};
var $46dd508ed67d6196$var$TH = $46dd508ed67d6196$var$getWithCellProps('th');
var $46dd508ed67d6196$export$cfca40ca5c56a38e = function withSortableColumn(WrapperComponent) {
    return function THWithSortableColumn(props) {
        var intl = (0, $hrVKU.default)();
        var allowColumnSorting = props.allowColumnSorting, onSorting = props.onSorting, children = props.children, sortOrdered = props.sortOrdered, isHeaderRow = props.isHeaderRow;
        var sortOrderedClassName = sortOrdered === (0, $gmeX4.SortOrder).NO_ORDER ? (0, $53SBn.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER : '';
        if (!allowColumnSorting || !isHeaderRow) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrapperComponent, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrapperComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $53SBn.RendererCssClassName).SORTABLE_COLUMN_WRAPPER,
            ariaSort: $46dd508ed67d6196$var$getSortOrderLabel(intl, sortOrdered)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
            className: (0, $53SBn.RendererCssClassName).SORTABLE_COLUMN
        }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("figure", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "".concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER, " ").concat(sortOrderedClassName)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $blliI.default), {
            isSortingAllowed: !!onSorting,
            sortOrdered: sortOrdered,
            onClick: sort,
            onKeyDown: onKeyPress
        }))));
        function onKeyPress(event) {
            var keys = [
                ' ',
                'Enter',
                'Spacebar'
            ];
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            var _ref2 = event.target, tagName = _ref2.tagName;
            // trigger sorting if space or enter are clicked but not when in an input field (template variables)
            if (keys.includes(event.key) && !$46dd508ed67d6196$var$IgnoreSorting.includes(tagName)) {
                event.preventDefault();
                sort();
            }
        }
        function sort() {
            var fireAnalyticsEvent = props.fireAnalyticsEvent, onSorting = props.onSorting, columnIndex = props.columnIndex, sortOrdered = props.sortOrdered;
            if (onSorting && columnIndex != null) {
                var sortOrder = $46dd508ed67d6196$var$nextStatusOrder(sortOrdered);
                onSorting(columnIndex, sortOrder);
                fireAnalyticsEvent && fireAnalyticsEvent({
                    action: (0, $jJH6F.ACTION).SORT_COLUMN,
                    actionSubject: (0, $jJH6F.ACTION_SUBJECT).TABLE,
                    attributes: {
                        platform: (0, $aP6HU.PLATFORM).WEB,
                        mode: (0, $aP6HU.MODE).RENDERER,
                        columnIndex: columnIndex,
                        sortOrder: sortOrder
                    },
                    eventType: (0, $jJH6F.EVENT_TYPE).TRACK
                });
            } else fireAnalyticsEvent && fireAnalyticsEvent({
                action: (0, $jJH6F.ACTION).SORT_COLUMN_NOT_ALLOWED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).TABLE,
                attributes: {
                    platform: (0, $aP6HU.PLATFORM).WEB,
                    mode: (0, $aP6HU.MODE).RENDERER
                },
                eventType: (0, $jJH6F.EVENT_TYPE).TRACK
            });
        }
    };
};
var $46dd508ed67d6196$export$f850895b287ef28e = $46dd508ed67d6196$export$cfca40ca5c56a38e($46dd508ed67d6196$var$TH);
var $46dd508ed67d6196$var$TD = $46dd508ed67d6196$var$getWithCellProps('td');
var $46dd508ed67d6196$export$1e4baea7053fc0e3 = $46dd508ed67d6196$var$TD;

});
parcelRegister("blliI", function(module, exports) {
$parcel$export(module.exports, "default", () => $84222dc4e6677658$export$2e2bcd8739ae039);

var $lAD7C = parcelRequire("lAD7C");

var $74Zh5 = parcelRequire("74Zh5");

var $ach6K = parcelRequire("ach6K");

var $3tz1M = parcelRequire("3tz1M");

var $4mzlU = parcelRequire("4mzlU");

var $gmeX4 = parcelRequire("gmeX4");

var $4VBpm = parcelRequire("4VBpm");

var $hcGlG = parcelRequire("hcGlG");

var $9VYMP = parcelRequire("9VYMP");

var $3jlP8 = parcelRequire("3jlP8");

var $eA6P6 = parcelRequire("eA6P6");
var $84222dc4e6677658$var$_templateObject, $84222dc4e6677658$var$_templateObject2;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
var $84222dc4e6677658$var$buttonStyles = (0, $74Zh5.css)($84222dc4e6677658$var$_templateObject || ($84222dc4e6677658$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($lAD7C)))([
    "\n\tposition: absolute;\n\tdisplay: flex;\n\theight: 28px;\n\twidth: 28px;\n\tmargin: ",
    ";\n\tright: 0;\n\ttop: 0;\n\tborder: ",
    " solid ",
    ";\n\tborder-radius: ",
    ";\n\tbackground-color: ",
    ";\n\tjustify-content: center;\n\talign-items: center;\n\tcursor: pointer;\n\n\t&:hover {\n\t\tbackground-color: ",
    ";\n\t}\n\n\t&:active {\n\t\tbackground-color: ",
    ";\n\t}\n\n\t&.",
    "__not-allowed {\n\t\tcursor: not-allowed;\n\t}\n"
])), "var(--ds-space-075, 6px)", "var(--ds-border-width-selected, 2px)", "var(--ds-border, #0B120E24)", "var(--ds-radius-small, 4px)", "var(--ds-surface-overlay, #FFFFFF)", "var(--ds-surface-overlay-hovered, #F0F1F2)", "var(--ds-surface-overlay-pressed, #DDDEE1)", (0, $4VBpm.SORTABLE_COLUMN_ICON_CLASSNAME));
// Keep the sort button above header content nodes that the editor's native-anchor DnD
// styles give a z-index in live docs, which otherwise cover the button's clickable body.
var $84222dc4e6677658$var$sortButtonElevatedStyles = (0, $74Zh5.css)({
    zIndex: 1
});
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
var $84222dc4e6677658$var$iconWrapperStyles = (0, $74Zh5.css)($84222dc4e6677658$var$_templateObject2 || ($84222dc4e6677658$var$_templateObject2 = (0, (/*@__PURE__*/$parcel$interopDefault($lAD7C)))([
    "\n\twidth: 8px;\n\theight: 12px;\n\ttransition: transform 0.3s cubic-bezier(0.15, 1, 0.3, 1);\n\ttransform-origin: 50% 50%;\n\tdisplay: flex;\n\tjustify-content: center;\n\n\t&.",
    " {\n\t\ttransform: rotate(-180deg);\n\t}\n\n\t&.",
    "-inactive {\n\t\topacity: 0.7;\n\t}\n"
])), (0, $eA6P6.StatusClassNames).DESC, (0, $4VBpm.SORTABLE_COLUMN_ICON_CLASSNAME));
// The icon is created with CSS due to the following Firefox issue: https://product-fabric.atlassian.net/browse/ED-8001
// The TL;DR is that svg's in tables mess up how HTML is copied in Firefox. Using a styled div instead solves the problem.
// For this reason, svg's should be avoided in tables until this issue is fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=1664350
var $84222dc4e6677658$var$iconStyles = (0, $74Zh5.css)({
    height: '100%',
    width: '2px',
    borderRadius: "var(--ds-radius-full, 9999px)",
    background: "var(--ds-icon, #292A2E)",
    userSelect: 'none',
    '&::before, &::after': {
        background: "var(--ds-icon, #292A2E)",
        content: "''",
        height: '2px',
        width: '6px',
        position: 'absolute',
        borderRadius: "var(--ds-radius-full, 9999px)"
    },
    '&::before': {
        transform: 'rotate(45deg) translate(3.4px, 8.5px)'
    },
    '&::after': {
        transform: 'rotate(-45deg) translate(-6.3px, 5.7px)'
    }
});
var $84222dc4e6677658$var$getIconClassName = function getIconClassName(isSortingAllowed, sortOrdered) {
    var activated = sortOrdered !== (0, $gmeX4.SortOrder).NO_ORDER;
    var activeStatusClass = "".concat((0, $4VBpm.SORTABLE_COLUMN_ICON_CLASSNAME), "-").concat(activated ? 'active' : 'inactive');
    if (!isSortingAllowed) return "".concat((0, $eA6P6.StatusClassNames).SORTING_NOT_ALLOWED, " ").concat(activeStatusClass);
    switch(sortOrdered){
        case (0, $gmeX4.SortOrder).ASC:
            return "".concat((0, $eA6P6.StatusClassNames).ASC, " ").concat(activeStatusClass);
        case (0, $gmeX4.SortOrder).DESC:
            return "".concat((0, $eA6P6.StatusClassNames).DESC, " ").concat(activeStatusClass);
        default:
            return "".concat((0, $eA6P6.StatusClassNames).NO_ORDER, " ").concat(activeStatusClass);
    }
};
var $84222dc4e6677658$var$getTooltipTitle = function getTooltipTitle(intl, isSortingAllowed, sortOrdered) {
    var noOrderLabel = (0, $3jlP8.sortingIconMessages).noOrderLabel, ascOrderLabel = (0, $3jlP8.sortingIconMessages).ascOrderLabel, descOrderLabel = (0, $3jlP8.sortingIconMessages).descOrderLabel, invalidLabel = (0, $3jlP8.sortingIconMessages).invalidLabel;
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $gmeX4.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $gmeX4.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $gmeX4.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return '';
};
var $84222dc4e6677658$var$getAriaLabel = function getAriaLabel(intl, isSortingAllowed, sortOrdered) {
    var noOrderLabel = (0, $9VYMP.sortingAriaLabelMessages).noOrderLabel, ascOrderLabel = (0, $9VYMP.sortingAriaLabelMessages).ascOrderLabel, descOrderLabel = (0, $9VYMP.sortingAriaLabelMessages).descOrderLabel, invalidLabel = (0, $9VYMP.sortingAriaLabelMessages).invalidLabel, defaultLabel = (0, $9VYMP.sortingAriaLabelMessages).defaultLabel;
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $gmeX4.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $gmeX4.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $gmeX4.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return intl.formatMessage(defaultLabel);
};
var $84222dc4e6677658$var$SortingIcon = function SortingIcon(_ref) {
    var isSortingAllowed = _ref.isSortingAllowed, sortOrdered = _ref.sortOrdered, intl = _ref.intl, onClick = _ref.onClick, onKeyDown = _ref.onKeyDown;
    var buttonClassName = "".concat((0, $4VBpm.SORTABLE_COLUMN_ICON_CLASSNAME), " ").concat(sortOrdered !== (0, $gmeX4.SortOrder).NO_ORDER ? 'is-active' : '').concat(isSortingAllowed ? '' : " ".concat((0, $4VBpm.SORTABLE_COLUMN_ICON_CLASSNAME), "__not-allowed "));
    var content = $84222dc4e6677658$var$getTooltipTitle(intl, isSortingAllowed, sortOrdered);
    var ariaLabel = $84222dc4e6677658$var$getAriaLabel(intl, isSortingAllowed, sortOrdered);
    var handleClick = function handleClick() {
        if (isSortingAllowed) onClick();
    };
    var handleKeyDown = function handleKeyDown(event) {
        if (isSortingAllowed) onKeyDown(event);
    };
    return (0, $74Zh5.jsx)((0, $4mzlU.default), {
        delay: 0,
        content: content,
        position: "top"
    }, (0, $74Zh5.jsx)("div", {
        css: [
            $84222dc4e6677658$var$buttonStyles,
            (0, $3tz1M.expValEquals)('confluence_live_doc_table_sort_bugfix', 'isEnabled', true) && $84222dc4e6677658$var$sortButtonElevatedStyles
        ],
        className: buttonClassName,
        role: "button",
        tabIndex: isSortingAllowed ? 0 : -1,
        "aria-label": ariaLabel,
        "aria-disabled": !isSortingAllowed,
        "aria-hidden": !isSortingAllowed,
        onClick: handleClick,
        onKeyDown: handleKeyDown
    }, (0, $3tz1M.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true) ? (0, $74Zh5.jsx)((0, $hcGlG.NewSortingIcon), {
        sortOrdered: sortOrdered
    }) : (0, $74Zh5.jsx)("div", {
        css: $84222dc4e6677658$var$iconWrapperStyles,
        className: $84222dc4e6677658$var$getIconClassName(isSortingAllowed, sortOrdered)
    }, (0, $74Zh5.jsx)("div", {
        css: [
            $84222dc4e6677658$var$iconStyles
        ]
    }))));
};
var $84222dc4e6677658$var$_default_1 = (0, $ach6K.default)($84222dc4e6677658$var$SortingIcon);
var $84222dc4e6677658$export$2e2bcd8739ae039 = $84222dc4e6677658$var$_default_1;

});
parcelRegister("4VBpm", function(module, exports) {
$parcel$export(module.exports, "SORTABLE_COLUMN_ICON_CLASSNAME", () => $396980bc0f5b5002$export$bd4f24d8b1e86b23);
var $396980bc0f5b5002$export$bd4f24d8b1e86b23 = "ak-renderer-tableHeader-sorting-icon";

});

parcelRegister("hcGlG", function(module, exports) {
$parcel$export(module.exports, "NewSortingIcon", () => $c86468376ba75e2b$export$4be21af7f864512e);
/* NewSortingIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $gjJGl = parcelRequire("gjJGl");
var $dSwmL = parcelRequire("dSwmL");

var $gmeX4 = parcelRequire("gmeX4");
var $c86468376ba75e2b$var$newIconWrapperStyles = {
    base: "_v5642l60 _1bsb7vkz _4t3i7vkz _1e0c1txw _1bah1h6o _4cvr1h6o _8hrz1qre",
    inactive: "_tzy415iw"
};
var $c86468376ba75e2b$export$4be21af7f864512e = function NewSortingIcon(_ref) {
    var sortOrdered = _ref.sortOrdered;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            $c86468376ba75e2b$var$newIconWrapperStyles.base,
            sortOrdered === (0, $gmeX4.SortOrder).NO_ORDER && $c86468376ba75e2b$var$newIconWrapperStyles.inactive
        ])
    }, sortOrdered === (0, $gmeX4.SortOrder).DESC ? /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gjJGl))), {
        spacing: "none",
        label: ""
    }) : /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dSwmL))), {
        spacing: "none",
        label: ""
    }));
};

});
parcelRegister("gjJGl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::982535952b0b997873182b9102c6defc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be11db2e40b9c9b3$var$_react = $be11db2e40b9c9b3$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $be11db2e40b9c9b3$var$_iconNew = $be11db2e40b9c9b3$var$_interopRequireDefault((parcelRequire("awDJQ")));
function $be11db2e40b9c9b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SortAscending".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/sort-ascending
 * Usage guidance:
 * Single purpose - Reserved for sorting data.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $be11db2e40b9c9b3$var$SortAscendingIcon = (props)=>/*#__PURE__*/ $be11db2e40b9c9b3$var$_react.default.createElement($be11db2e40b9c9b3$var$_iconNew.default, Object.assign({
        name: "SortAscendingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 12.5H1V14h14zm-1.75-3.75V3.56l1.72 1.72 1.06-1.06-3-3a.75.75 0 0 0-1.06 0l-3 3 1.06 1.06 1.72-1.72v5.19zM8 7.25H1v1.5h7zM6 2H1v1.5h5z" clip-rule="evenodd"/>`
    }, props));
$be11db2e40b9c9b3$var$SortAscendingIcon.displayName = 'SortAscendingIcon';
var $be11db2e40b9c9b3$var$_default = module.exports.default = $be11db2e40b9c9b3$var$SortAscendingIcon;

});
parcelRegister("awDJQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Icon", () => $7a9bb7c0b3d71703$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $7a9bb7c0b3d71703$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $7a9bb7c0b3d71703$var$svgStyles = null;
var $7a9bb7c0b3d71703$var$iconStyles = null;
var $7a9bb7c0b3d71703$var$smallIconStyles = null;
var $7a9bb7c0b3d71703$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $7a9bb7c0b3d71703$var$baseHcmStyles = null;
var $7a9bb7c0b3d71703$var$scaleSize = null;
var $7a9bb7c0b3d71703$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $7a9bb7c0b3d71703$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $7a9bb7c0b3d71703$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $7a9bb7c0b3d71703$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $7a9bb7c0b3d71703$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $970q7.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $970q7.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $7a9bb7c0b3d71703$var$coreSizeSmall[spacing] : $7a9bb7c0b3d71703$var$coreSizeMedium[spacing]
        ])
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$7a9bb7c0b3d71703$export$2e2bcd8739ae039 = $7a9bb7c0b3d71703$export$f04a61298a47a40f;

});


parcelRegister("dSwmL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::07f197be0bf4c2b3f61c32ad2572b521>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1a96cbde4952f0d$var$_react = $a1a96cbde4952f0d$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $a1a96cbde4952f0d$var$_iconNew = $a1a96cbde4952f0d$var$_interopRequireDefault((parcelRequire("awDJQ")));
function $a1a96cbde4952f0d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SortDescending".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/sort-descending
 * Usage guidance:
 * Single purpose - Reserved for sorting data.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1a96cbde4952f0d$var$SortDescendingIcon = (props)=>/*#__PURE__*/ $a1a96cbde4952f0d$var$_react.default.createElement($a1a96cbde4952f0d$var$_iconNew.default, Object.assign({
        name: "SortDescendingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-1.75 3.75v5.19l1.72-1.72 1.06 1.06-3 3a.75.75 0 0 1-1.06 0l-3-3 1.06-1.06 1.72 1.72V7.25zM8 8.75H1v-1.5h7zM6 14H1v-1.5h5z" clip-rule="evenodd"/>`
    }, props));
$a1a96cbde4952f0d$var$SortDescendingIcon.displayName = 'SortDescendingIcon';
var $a1a96cbde4952f0d$var$_default = module.exports.default = $a1a96cbde4952f0d$var$SortDescendingIcon;

});


parcelRegister("9VYMP", function(module, exports) {
$parcel$export(module.exports, "sortingAriaLabelMessages", () => $73b896db6b0838bd$export$f142573f51a67577);

var $6bnW7 = parcelRequire("6bnW7");
var $73b896db6b0838bd$export$f142573f51a67577 = (0, $6bnW7.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.no',
        defaultMessage: 'No sort applied to the column',
        description: 'Aria-label for Sort column button when sorting was not applied or the sorting has been cleared'
    },
    ascOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.asc',
        defaultMessage: 'Ascending sort applied',
        description: 'Aria-label for Sort column button when ascending sorting was applied'
    },
    descOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.desc',
        defaultMessage: 'Descending sort applied',
        description: 'Aria-label for Sort column button when descending sorting was applied'
    },
    invalidLabel: {
        id: 'fabric.editor.tableHeader.sorting.invalid',
        defaultMessage: "You can't sort a table with merged cells",
        description: 'Aria-label for Sort column button when sorting is not possible'
    },
    defaultLabel: {
        id: 'fabric.editor.tableHeader.sorting.default',
        defaultMessage: 'Sort the column',
        description: 'Default aria-label for Sort column button'
    }
});

});

parcelRegister("3jlP8", function(module, exports) {
$parcel$export(module.exports, "sortingIconMessages", () => $2694133243f15f08$export$458c50917513cd1a);

var $6bnW7 = parcelRequire("6bnW7");
var $2694133243f15f08$export$458c50917513cd1a = (0, $6bnW7.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.headingLink.noOrderLabel',
        defaultMessage: 'Sort column A to Z',
        description: 'Label shown on a table column header sort button to sort the column alphabetically from A to Z (ascending order).'
    },
    ascOrderLabel: {
        id: 'fabric.editor.headingLink.ascOrderLabel',
        defaultMessage: 'Sort column Z to A',
        description: 'Label shown on a table column header sort button to sort the column alphabetically from Z to A (descending order).'
    },
    descOrderLabel: {
        id: 'fabric.editor.headingLink.descOrderLabel',
        defaultMessage: 'Clear sorting',
        description: 'Label shown on a table column header sort button to remove any active sorting and restore the default column order.'
    },
    invalidLabel: {
        id: 'fabric.editor.headingLink.invalidLabel',
        // eslint-disable-next-line @atlassian/i18n/no-multiple-whitespaces
        defaultMessage: "\u26A0\uFE0F  You can't sort a table with merged cells",
        description: 'Warning message shown in a table column header when sorting cannot be applied because the table contains merged cells.'
    }
});

});

parcelRegister("eA6P6", function(module, exports) {
$parcel$export(module.exports, "StatusClassNames", () => $a9d9b86cb957d0ff$export$c3618f310f725028);
var $a9d9b86cb957d0ff$export$c3618f310f725028 = /*#__PURE__*/ function(StatusClassNames) {
    StatusClassNames["ASC"] = "sorting-icon-svg__asc";
    StatusClassNames["DESC"] = "sorting-icon-svg__desc";
    StatusClassNames["NO_ORDER"] = "sorting-icon-svg__no_order";
    StatusClassNames["SORTING_NOT_ALLOWED"] = "sorting-icon-svg__not-allowed";
    return StatusClassNames;
}({});

});


parcelRegister("eqmEx", function(module, exports) {
$parcel$export(module.exports, "expValEqualsNoExposure", () => $a80510c2c27ddc5b$export$63eebf86443a0a61);

var $77PRV = parcelRequire("77PRV");
function $a80510c2c27ddc5b$export$63eebf86443a0a61(experimentName, experimentParam, experimentExpectedValue) {
    var experimentDefaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return (0, $77PRV.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, false);
}

});


parcelRegister("gdaDF", function(module, exports) {
$parcel$export(module.exports, "TableStickyScrollbar", () => $bcd61ce4d6efd477$export$8c072780619cfc83);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $7NyDw = parcelRequire("7NyDw");

var $50U6m = parcelRequire("50U6m");
var $bcd61ce4d6efd477$export$8c072780619cfc83 = /*#__PURE__*/ function() {
    function TableStickyScrollbar(wrapper) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, TableStickyScrollbar);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sentinels", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "handleScroll", function(event) {
            if (!_this.stickyScrollbarContainerElement || !_this.wrapper || event.target !== _this.stickyScrollbarContainerElement) return;
            _this.wrapper.scrollLeft = _this.stickyScrollbarContainerElement.scrollLeft;
        });
        this.wrapper = wrapper;
        this.init();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(TableStickyScrollbar, [
        {
            key: "dispose",
            value: function dispose() {
                if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
                this.deleteIntersectionObserver();
            }
        },
        {
            key: "scrollLeft",
            value: function scrollLeft(left) {
                if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
            }
        },
        {
            key: "init",
            value: function init() {
                var _this$wrapper$parentE, _this$wrapper$parentE2;
                if (!this.wrapper) return;
                var scrollbarContainers = (_this$wrapper$parentE = this.wrapper.parentElement) === null || _this$wrapper$parentE === void 0 ? void 0 : _this$wrapper$parentE.querySelectorAll(".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER));
                // eslint-disable-next-line @atlaskit/editor/no-as-casting, @atlaskit/platform/valid-gate-name
                this.stickyScrollbarContainerElement = (0, $50U6m.fg)('platform_editor_querySelector_fix_table_renderer') ? scrollbarContainers === null || scrollbarContainers === void 0 ? void 0 : scrollbarContainers.item(scrollbarContainers.length - 1) : (_this$wrapper$parentE2 = this.wrapper.parentElement) === null || _this$wrapper$parentE2 === void 0 ? void 0 : _this$wrapper$parentE2.querySelector(".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER));
                if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
                    passive: true
                });
                this.createIntersectionObserver();
            }
        },
        {
            key: "createIntersectionObserver",
            value: function createIntersectionObserver() {
                var _this2 = this, _this$wrapper, _this$wrapper2, _this$wrapper3;
                this.rendererScrollableElement = window.document;
                if (!this.rendererScrollableElement || !this.wrapper) return;
                this.intersectionObserver = new IntersectionObserver(function(entries, _) {
                    if (!_this2.stickyScrollbarContainerElement) return;
                    entries.forEach(function(entry) {
                        // Ignored via go/ees005
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        var target = entry.target;
                        if (target.classList.contains((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) _this2.sentinelBottomCallback(entry);
                        if (target.classList.contains((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) _this2.sentinelTopCallback(entry);
                    });
                }, {
                    root: this.rendererScrollableElement
                });
                var bottomSentinels = (_this$wrapper = this.wrapper) === null || _this$wrapper === void 0 || (_this$wrapper = _this$wrapper.parentElement) === null || _this$wrapper === void 0 ? void 0 : _this$wrapper.getElementsByClassName((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM);
                // eslint-disable-next-line @atlaskit/platform/valid-gate-name
                this.sentinels.bottom = (0, $50U6m.fg)('platform_editor_querySelector_fix_table_renderer') ? bottomSentinels === null || bottomSentinels === void 0 ? void 0 : bottomSentinels.item(bottomSentinels.length - 1) : (_this$wrapper2 = this.wrapper) === null || _this$wrapper2 === void 0 || (_this$wrapper2 = _this$wrapper2.parentElement) === null || _this$wrapper2 === void 0 || (_this$wrapper2 = _this$wrapper2.getElementsByClassName((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) === null || _this$wrapper2 === void 0 ? void 0 : _this$wrapper2.item(0);
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                this.sentinels.top = (_this$wrapper3 = this.wrapper) === null || _this$wrapper3 === void 0 || (_this$wrapper3 = _this$wrapper3.parentElement) === null || _this$wrapper3 === void 0 || (_this$wrapper3 = _this$wrapper3.getElementsByClassName((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) === null || _this$wrapper3 === void 0 ? void 0 : _this$wrapper3.item(0);
                [
                    this.sentinels.bottom,
                    this.sentinels.top
                ].forEach(function(el) {
                    return(// Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    _this2.intersectionObserver.observe(el));
                });
            }
        },
        {
            key: "deleteIntersectionObserver",
            value: function deleteIntersectionObserver() {
                if (this.intersectionObserver) {
                    if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
                    this.intersectionObserver.disconnect();
                }
            }
        },
        {
            key: "sentinelBottomCallback",
            value: function sentinelBottomCallback(entry) {
                var _entry$rootBounds;
                var sentinelIsAboveScrollArea = entry.boundingClientRect.top < (((_entry$rootBounds = entry.rootBounds) === null || _entry$rootBounds === void 0 ? void 0 : _entry$rootBounds.top) || 0);
                this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
                this.toggle();
            }
        },
        {
            key: "sentinelTopCallback",
            value: function sentinelTopCallback(entry) {
                var _entry$rootBounds2;
                var sentinelIsBelowScrollArea = (((_entry$rootBounds2 = entry.rootBounds) === null || _entry$rootBounds2 === void 0 ? void 0 : _entry$rootBounds2.bottom) || 0) < entry.boundingClientRect.top;
                this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
                this.toggle();
            }
        },
        {
            key: "toggle",
            value: function toggle() {
                if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
                else this.hide();
            }
        },
        {
            key: "hide",
            value: function hide() {
                if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'hidden') this.stickyScrollbarContainerElement.style.visibility = 'hidden';
            }
        },
        {
            key: "show",
            value: function show() {
                if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'visible') this.stickyScrollbarContainerElement.style.visibility = 'visible';
            }
        }
    ]);
}();

});


parcelRegister("5FiyC", function(module, exports) {
$parcel$export(module.exports, "default", () => $41ff2d2e501c158e$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $gmeX4 = parcelRequire("gmeX4");

var $53SBn = parcelRequire("53SBn");
function $41ff2d2e501c158e$export$2e2bcd8739ae039(_ref) {
    var allowColumnSorting = _ref.allowColumnSorting, children = _ref.children, index = _ref.index, innerRef = _ref.innerRef, isFirstRow = _ref.isFirstRow, isLastRow = _ref.isLastRow, isNumberColumnEnabled = _ref.isNumberColumnEnabled, onSorting = _ref.onSorting, tableOrderStatus = _ref.tableOrderStatus;
    var isHeaderRow = !index;
    var childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.toArray(children);
    var cells = allowColumnSorting && isHeaderRow ? childrenArray.map(function(child, columnIndex) {
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).cloneElement(child, {
            columnIndex: columnIndex,
            onSorting: onSorting,
            sortOrdered: (tableOrderStatus === null || tableOrderStatus === void 0 ? void 0 : tableOrderStatus.columnIndex) === columnIndex ? tableOrderStatus.order : (0, $gmeX4.SortOrder).NO_ORDER,
            isHeaderRow: isHeaderRow
        });
    }) : childrenArray;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("tr", {
        ref: innerRef
    }, isNumberColumnEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $53SBn.RendererCssClassName).NUMBER_COLUMN,
        "data-reaches-left": true,
        "data-reaches-top": isFirstRow || undefined,
        "data-reaches-bottom": isLastRow || undefined
    }, index), cells);
}

});

parcelRegister("fK54y", function(module, exports) {
$parcel$export(module.exports, "default", () => $b75f1629470d9b1b$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $b75f1629470d9b1b$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        className: "UnknownBlock"
    }, props.children);
}

});

parcelRegister("92uBc", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("l9sRl"),
    $iKwew("j4QBD")
]).then(()=>parcelRequire('4hE9f'));

});

parcelRegister("90piW", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("51kC7"),
    $iKwew("l9sRl"),
    $iKwew("g0TIv")
]).then(()=>parcelRequire('5CR1A'));

});

parcelRegister("ahHfv", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("luehB").then(()=>parcelRequire('lKUgJ'));

});

parcelRegister("1enik", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("1c9eM").then(()=>parcelRequire('7Gk8b'));

});

parcelRegister("bfIlp", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("lTFer").then(()=>parcelRequire('hmytH'));

});

parcelRegister("laTH3", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("dXLwt").then(()=>parcelRequire('cat7i'));

});

parcelRegister("1Oi6Q", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("ZeF87").then(()=>parcelRequire('5Kz7L'));

});

parcelRegister("bAEpH", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("1Nc0s").then(()=>parcelRequire('laBdk'));

});

parcelRegister("1D8Lz", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("i9Jv4"),
    $iKwew("cuqoB"),
    $iKwew("dB391")
]).then(()=>parcelRequire('fNWSO'));

});

parcelRegister("6y0yn", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("i9Jv4"),
    $iKwew("cuqoB"),
    $iKwew("dB391"),
    $iKwew("daJIT")
]).then(()=>parcelRequire('6fzc3'));

});

parcelRegister("4IGrB", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("lbyJJ"),
    $iKwew("k8Hxy"),
    $iKwew("bTD0f"),
    $iKwew("9Q4Fd"),
    $iKwew("chJ63"),
    $iKwew("bWZor")
]).then(()=>parcelRequire('1t1Nh'));

});

parcelRegister("g6NBo", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("lbyJJ"),
    $iKwew("k8Hxy"),
    $iKwew("bTD0f"),
    $iKwew("9Q4Fd")
]).then(()=>parcelRequire('5UpN9'));

});

parcelRegister("8Ld8e", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("lbyJJ"),
    $iKwew("k8Hxy"),
    $iKwew("bTD0f"),
    $iKwew("9Q4Fd"),
    $iKwew("chJ63")
]).then(()=>parcelRequire('lEFXS'));

});

parcelRegister("agnp1", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("51b3U"),
    $iKwew("hPp8h"),
    $iKwew("knhFz"),
    $iKwew("e3dbm"),
    $iKwew("hZLj1"),
    $iKwew("fxnVM"),
    $iKwew("8z7xJ"),
    $iKwew("jaqgk"),
    $iKwew("9KlEX"),
    $iKwew("ldt0C"),
    $iKwew("4yN8Z"),
    $iKwew("2GrMW"),
    $iKwew("1Ah6C"),
    $iKwew("lxGQI"),
    $iKwew("HrFTV")
]).then(()=>parcelRequire('drRJk'));

});

parcelRegister("2bcaO", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("9Q5nO").then(()=>parcelRequire('fDe2F'));

});

parcelRegister("i524b", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("51b3U"),
    $iKwew("idaDY"),
    $iKwew("hPp8h"),
    $iKwew("knhFz"),
    $iKwew("e3dbm"),
    $iKwew("hZLj1"),
    $iKwew("fxnVM"),
    $iKwew("8z7xJ"),
    $iKwew("jaqgk"),
    $iKwew("9KlEX"),
    $iKwew("ldt0C"),
    $iKwew("4yN8Z"),
    $iKwew("2GrMW"),
    $iKwew("1Ah6C"),
    $iKwew("lxGQI"),
    $iKwew("iTKQz")
]).then(()=>parcelRequire('yvHLt'));

});

parcelRegister("eRkfx", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("ii3mC").then(()=>parcelRequire('2olcs'));

});

parcelRegister("1MCh5", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("i9Jv4"),
    $iKwew("k0PNK")
]).then(()=>parcelRequire('fHLTP'));

});

parcelRegister("1o3cc", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("jZMhO").then(()=>parcelRequire('PMdqA'));

});

parcelRegister("61mDg", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("9uy2k").then(()=>parcelRequire('dVBiK'));

});

parcelRegister("8GAYC", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("6yob9").then(()=>parcelRequire('7kspH'));

});


parcelRegister("lknPo", function(module, exports) {
$parcel$export(module.exports, "getMediaClient", () => $f86df2f0f83a1bce$export$c9ecbc1b719fd417);

var $leKip = parcelRequire("leKip");
var $f86df2f0f83a1bce$export$f92e83e86b03c398 = new Map();
var $f86df2f0f83a1bce$export$c9ecbc1b719fd417 = function getMediaClient(mediaClientConfig) {
    // The Provider defines mediaClientConfig as required,
    // but integrators may skip it when using Media Card to display external images
    // i.e. a Media Client is not needed.
    // An empty mediaClientConfig object `{}` won't fall into this case,
    // but that case is handled internally by Media Client.
    if (!mediaClientConfig) return new (0, $leKip.MediaClient)({
        authProvider: function authProvider() {
            return Promise.resolve({
                clientId: '',
                token: '',
                baseUrl: ''
            });
        }
    });
    var mediaClient = $f86df2f0f83a1bce$export$f92e83e86b03c398.get(mediaClientConfig);
    if (!mediaClient) {
        mediaClient = new (0, $leKip.MediaClient)(mediaClientConfig);
        $f86df2f0f83a1bce$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
    }
    return mediaClient;
};

});
parcelRegister("leKip", function(module, exports) {
$parcel$export(module.exports, "MediaClient", () => $f75ed12f3f0589c1$export$fba8b4ca6d386aec);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $fxEK3 = parcelRequire("fxEK3");

var $k9W36 = parcelRequire("k9W36");

var $i0hJq = parcelRequire("i0hJq");

var $kT0zX = parcelRequire("kT0zX");

var $elHy7 = parcelRequire("elHy7");

var $c0iRm = parcelRequire("c0iRm");

var $f75ed12f3f0589c1$export$fba8b4ca6d386aec = /*#__PURE__*/ function() {
    // mobile upload is lazily loaded
    // Deprecated value introduced for backward compatibility with Context
    function MediaClient(mediaClientConfig) {
        var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $i0hJq.mediaStore);
        var mediaApi = arguments.length > 2 ? arguments[2] : undefined;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, MediaClient);
        this.mediaClientConfig = mediaClientConfig;
        this.store = store;
        this.mediaStore = mediaApi !== null && mediaApi !== void 0 ? mediaApi : new (0, $elHy7.MediaStore)({
            authProvider: mediaClientConfig.authProvider,
            initialAuth: mediaClientConfig.initialAuth,
            chunkHashAlgorithm: (0, $k9W36.ChunkHashAlgorithm).Sha256,
            authProviderTimeout: mediaClientConfig.authProviderTimeoutMs
        });
        this.config = mediaClientConfig;
        this.file = new (0, $kT0zX.FileFetcherImpl)(this.mediaStore, this.store);
        this.eventEmitter = new (0, $fxEK3.EventEmitter2)();
        this.stargate = new (0, $c0iRm.StargateClient)(mediaClientConfig.stargateBaseUrl);
    }
    /**
   * @internal
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(MediaClient, [
        {
            key: "__DO_NOT_USE__getMediaStore",
            value: function __DO_NOT_USE__getMediaStore() {
                return this.store;
            }
        },
        {
            key: "getImage",
            value: function getImage(id, params, controller, fetchMaxRes, traceContext) {
                return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
            }
        },
        {
            key: "getImageUrl",
            value: function getImageUrl(id, params) {
                return this.mediaStore.getFileImageURL(id, params);
            }
        },
        {
            key: "getImageUrlSync",
            value: function getImageUrlSync(id, params, seededCdnUrl) {
                return this.mediaStore.getFileImageURLSync(id, params, seededCdnUrl);
            }
        },
        {
            key: "getClientId",
            value: function() {
                var _getClientId = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(collectionName) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                return _context.abrupt("return", this.mediaStore.getClientId(collectionName));
                            case 1:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getClientId(_x) {
                    return _getClientId.apply(this, arguments);
                }
                return getClientId;
            }()
        },
        {
            key: "getClientIdSync",
            value: function getClientIdSync() {
                return this.mediaStore.getClientIdSync();
            }
        },
        {
            key: "getImageMetadata",
            value: function() {
                var _getImageMetadata = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(id, params) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 1;
                                return this.mediaStore.getImageMetadata(id, params);
                            case 1:
                                return _context2.abrupt("return", _context2.sent.metadata);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getImageMetadata(_x2, _x3) {
                    return _getImageMetadata.apply(this, arguments);
                }
                return getImageMetadata;
            }()
        },
        {
            key: "mobileUploadPromise",
            value: function() {
                var _mobileUploadPromise = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3() {
                    var module;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (!this.mobileUpload) {
                                    _context3.next = 1;
                                    break;
                                }
                                return _context3.abrupt("return", this.mobileUpload);
                            case 1:
                                _context3.next = 2;
                                return (parcelRequire("2k2gx"));
                            case 2:
                                module = _context3.sent;
                                this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
                                return _context3.abrupt("return", this.mobileUpload);
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function mobileUploadPromise() {
                    return _mobileUploadPromise.apply(this, arguments);
                }
                return mobileUploadPromise;
            }()
        },
        {
            key: "removeFileFromCollection",
            value: function() {
                var _removeFileFromCollection = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(id, collectionName, occurrenceKey, traceContext) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function removeFileFromCollection(_x4, _x5, _x6, _x7) {
                    return _removeFileFromCollection.apply(this, arguments);
                }
                return removeFileFromCollection;
            }()
        },
        {
            key: "on",
            value: function on(event, listener) {
                this.eventEmitter.on(event, listener);
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                this.eventEmitter.off(event, listener);
            }
        },
        {
            key: "emit",
            value: function emit(event, payload) {
                return this.eventEmitter.emit(event, payload);
            }
        }
    ]);
}();

});
parcelRegister("fxEK3", function(module, exports) {
/*!
 * EventEmitter2
 * https://github.com/hij1nx/EventEmitter2
 *
 * Copyright (c) 2013 hij1nx
 * Licensed under the MIT license.
 */ 
var $3ZMUU = parcelRequire("3ZMUU");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        if (typeof $3ZMUU !== 'undefined' && $3ZMUU.emitWarning) {
            var e = new Error(errorMsg);
            e.name = 'MaxListenersExceededWarning';
            e.emitter = this;
            e.count = count;
            $3ZMUU.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});

parcelRegister("k9W36", function(module, exports) {
$parcel$export(module.exports, "ChunkHashAlgorithm", () => $ead1ad433ee1ff44$export$d3e73a50cc549c2e);
var $ead1ad433ee1ff44$export$d3e73a50cc549c2e = /*#__PURE__*/ function(ChunkHashAlgorithm) {
    ChunkHashAlgorithm["Sha256"] = "sha256";
    return ChunkHashAlgorithm;
}({});

});

parcelRegister("i0hJq", function(module, exports) {
$parcel$export(module.exports, "mediaStore", () => $d1b5fb3d06bd417e$export$5785580dea19518d);

var $bwahW = parcelRequire("bwahW");

var $iODEY = parcelRequire("iODEY");

var $hzmic = parcelRequire("hzmic");
var $d1b5fb3d06bd417e$var$mediaStoreWithoutDevtools = (0, $hzmic.createStore)()((0, $bwahW.subscribeWithSelector)((0, $iODEY.immer)(function() {
    return {
        files: {}
    };
})));
var $d1b5fb3d06bd417e$var$mediaStoreWithDevtools = (0, $hzmic.createStore)()((0, $bwahW.devtools)((0, $bwahW.subscribeWithSelector)((0, $iODEY.immer)(function() {
    return {
        files: {}
    };
}))));
var $d1b5fb3d06bd417e$export$5785580dea19518d = $d1b5fb3d06bd417e$var$mediaStoreWithoutDevtools;

});
parcelRegister("bwahW", function(module, exports) {
$parcel$export(module.exports, "devtools", () => $862aa9eeacf6588d$export$6922d3b3a607469e, (v) => $862aa9eeacf6588d$export$6922d3b3a607469e = v);
$parcel$export(module.exports, "subscribeWithSelector", () => $862aa9eeacf6588d$export$5c593627aef9f076, (v) => $862aa9eeacf6588d$export$5c593627aef9f076 = v);
var $862aa9eeacf6588d$export$1be1fc439b849fdf;
var $862aa9eeacf6588d$export$95a3b7b12ab518f9;
var $862aa9eeacf6588d$export$6922d3b3a607469e;
var $862aa9eeacf6588d$export$9a6132153fba2e0;
var $862aa9eeacf6588d$export$4feba8a1bc8e9afd;
var $862aa9eeacf6588d$export$5c593627aef9f076;
'use strict';
function $862aa9eeacf6588d$var$_extends() {
    return $862aa9eeacf6588d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $862aa9eeacf6588d$var$_extends.apply(null, arguments);
}
function $862aa9eeacf6588d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $862aa9eeacf6588d$var$reduxImpl = function reduxImpl(reducer, initial) {
    return function(set, _get, api) {
        api.dispatch = function(action) {
            set(function(state) {
                return reducer(state, action);
            }, false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return $862aa9eeacf6588d$var$_extends({
            dispatch: function dispatch() {
                var _ref;
                return (_ref = api).dispatch.apply(_ref, arguments);
            }
        }, initial);
    };
};
var $862aa9eeacf6588d$var$redux = $862aa9eeacf6588d$var$reduxImpl;
var $862aa9eeacf6588d$var$_excluded = [
    "enabled",
    "anonymousActionType",
    "store"
], $862aa9eeacf6588d$var$_excluded2 = [
    "connection"
];
var $862aa9eeacf6588d$var$trackedConnections = new Map();
var $862aa9eeacf6588d$var$getTrackedConnectionState = function getTrackedConnectionState(name) {
    var api = $862aa9eeacf6588d$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(function(_ref) {
        var key = _ref[0], api = _ref[1];
        return [
            key,
            api.getState()
        ];
    }));
};
var $862aa9eeacf6588d$var$extractConnectionInformation = function extractConnectionInformation(store, extensionConnector, options) {
    if (store === undefined) return {
        type: 'untracked',
        connection: extensionConnector.connect(options)
    };
    var existingConnection = $862aa9eeacf6588d$var$trackedConnections.get(options.name);
    if (existingConnection) return $862aa9eeacf6588d$var$_extends({
        type: 'tracked',
        store: store
    }, existingConnection);
    var newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $862aa9eeacf6588d$var$trackedConnections.set(options.name, newConnection);
    return $862aa9eeacf6588d$var$_extends({
        type: 'tracked',
        store: store
    }, newConnection);
};
var $862aa9eeacf6588d$var$devtoolsImpl = function devtoolsImpl(fn, devtoolsOptions) {
    if (devtoolsOptions === void 0) devtoolsOptions = {};
    return function(set, get, api) {
        var _devtoolsOptions = devtoolsOptions, enabled = _devtoolsOptions.enabled, anonymousActionType = _devtoolsOptions.anonymousActionType, store = _devtoolsOptions.store, options = $862aa9eeacf6588d$var$_objectWithoutPropertiesLoose(_devtoolsOptions, $862aa9eeacf6588d$var$_excluded);
        var extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : false) && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (_e) {}
        if (!extensionConnector) return fn(set, get, api);
        var _extractConnectionInf = $862aa9eeacf6588d$var$extractConnectionInformation(store, extensionConnector, options), connection = _extractConnectionInf.connection, connectionInformation = $862aa9eeacf6588d$var$_objectWithoutPropertiesLoose(_extractConnectionInf, $862aa9eeacf6588d$var$_excluded2);
        var isRecording = true;
        api.setState = function(state, replace, nameOrAction) {
            var _extends2;
            var r = set(state, replace);
            if (!isRecording) return r;
            var action = nameOrAction === undefined ? {
                type: anonymousActionType || 'anonymous'
            } : typeof nameOrAction === 'string' ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === undefined) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send($862aa9eeacf6588d$var$_extends({}, action, {
                type: store + "/" + action.type
            }), $862aa9eeacf6588d$var$_extends({}, $862aa9eeacf6588d$var$getTrackedConnectionState(options.name), (_extends2 = {}, _extends2[store] = api.getState(), _extends2)));
            return r;
        };
        var setStateFromDevtools = function setStateFromDevtools() {
            var originalIsRecording = isRecording;
            isRecording = false;
            set.apply(void 0, arguments);
            isRecording = originalIsRecording;
        };
        var initialState = fn(api.setState, get, api);
        if (connectionInformation.type === 'untracked') connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(function(_ref2) {
                var key = _ref2[0], store = _ref2[1];
                return [
                    key,
                    key === connectionInformation.store ? initialState : store.getState()
                ];
            })));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === 'function') {
            var didWarnAboutReservedActionType = false;
            var originalDispatch = api.dispatch;
            api.dispatch = function() {
                for(var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++)a[_key] = arguments[_key];
                originalDispatch.apply(void 0, a);
            };
        }
        connection.subscribe(function(message) {
            switch(message.type){
                case 'ACTION':
                    if (typeof message.payload !== 'string') {
                        console.error('[zustand devtools middleware] Unsupported action format');
                        return;
                    }
                    return $862aa9eeacf6588d$var$parseJsonThen(message.payload, function(action) {
                        if (action.type === '__setState') {
                            if (store === undefined) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error("\n                    [zustand devtools middleware] Unsupported __setState action format. \n                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),\n                    and value of this only key should be a state object. Example: { \"type\": \"__setState\", \"state\": { \"abc123Store\": { \"foo\": \"bar\" } } }\n                    ");
                            var stateFromDevtools = action.state[store];
                            if (stateFromDevtools === undefined || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== 'function') return;
                        api.dispatch(action);
                    });
                case 'DISPATCH':
                    switch(message.payload.type){
                        case 'RESET':
                            setStateFromDevtools(initialState);
                            if (store === undefined) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($862aa9eeacf6588d$var$getTrackedConnectionState(options.name));
                        case 'COMMIT':
                            if (store === undefined) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($862aa9eeacf6588d$var$getTrackedConnectionState(options.name));
                        case 'ROLLBACK':
                            return $862aa9eeacf6588d$var$parseJsonThen(message.state, function(state) {
                                if (store === undefined) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($862aa9eeacf6588d$var$getTrackedConnectionState(options.name));
                            });
                        case 'JUMP_TO_STATE':
                        case 'JUMP_TO_ACTION':
                            return $862aa9eeacf6588d$var$parseJsonThen(message.state, function(state) {
                                if (store === undefined) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case 'IMPORT_STATE':
                            var _nextLiftedState$comp;
                            var nextLiftedState = message.payload.nextLiftedState;
                            var lastComputedState = (_nextLiftedState$comp = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _nextLiftedState$comp.state;
                            if (!lastComputedState) return;
                            if (store === undefined) setStateFromDevtools(lastComputedState);
                            else setStateFromDevtools(lastComputedState[store]);
                            connection == null || connection.send(null, nextLiftedState);
                            return;
                        case 'PAUSE_RECORDING':
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
};
var $862aa9eeacf6588d$var$devtools = $862aa9eeacf6588d$var$devtoolsImpl;
var $862aa9eeacf6588d$var$parseJsonThen = function parseJsonThen(stringified, f) {
    var parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error('[zustand devtools middleware] Could not parse the received json', e);
    }
    if (parsed !== undefined) f(parsed);
};
var $862aa9eeacf6588d$var$subscribeWithSelectorImpl = function subscribeWithSelectorImpl(fn) {
    return function(set, get, api) {
        var origSubscribe = api.subscribe;
        api.subscribe = function(selector, optListener, options) {
            var listener = selector;
            if (optListener) {
                var equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                var currentSlice = selector(api.getState());
                listener = function listener(state) {
                    var nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        var previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options != null && options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        var initialState = fn(set, get, api);
        return initialState;
    };
};
var $862aa9eeacf6588d$var$subscribeWithSelector = $862aa9eeacf6588d$var$subscribeWithSelectorImpl;
var $862aa9eeacf6588d$var$combine = function combine(initialState, create) {
    return function() {
        return Object.assign({}, initialState, create.apply(void 0, arguments));
    };
};
function $862aa9eeacf6588d$var$createJSONStorage(getStorage, options) {
    var storage;
    try {
        storage = getStorage();
    } catch (_e) {
        return;
    }
    var persistStorage = {
        getItem: function getItem(name) {
            var _getItem;
            var parse = function parse(str) {
                if (str === null) return null;
                return JSON.parse(str, options == null ? void 0 : options.reviver);
            };
            var str = (_getItem = storage.getItem(name)) != null ? _getItem : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: function setItem(name, newValue) {
            return storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer));
        },
        removeItem: function removeItem(name) {
            return storage.removeItem(name);
        }
    };
    return persistStorage;
}
var $862aa9eeacf6588d$var$_toThenable = function toThenable(fn) {
    return function(input) {
        try {
            var result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then: function then(onFulfilled) {
                    return $862aa9eeacf6588d$var$_toThenable(onFulfilled)(result);
                },
                catch: function _catch(_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then: function then(_onFulfilled) {
                    return this;
                },
                catch: function _catch(onRejected) {
                    return $862aa9eeacf6588d$var$_toThenable(onRejected)(e);
                }
            };
        }
    };
};
var $862aa9eeacf6588d$var$oldImpl = function oldImpl(config, baseOptions) {
    return function(set, get, api) {
        var options = $862aa9eeacf6588d$var$_extends({
            getStorage: function getStorage() {
                return localStorage;
            },
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: function partialize(state) {
                return state;
            },
            version: 0,
            merge: function merge(persistedState, currentState) {
                return $862aa9eeacf6588d$var$_extends({}, currentState, persistedState);
            }
        }, baseOptions);
        var _hasHydrated = false;
        var hydrationListeners = new Set();
        var finishHydrationListeners = new Set();
        var storage;
        try {
            storage = options.getStorage();
        } catch (_e) {}
        if (!storage) return config(function() {
            console.warn("[zustand persist middleware] Unable to update item '" + options.name + "', the given storage is currently unavailable.");
            set.apply(void 0, arguments);
        }, get, api);
        var thenableSerialize = $862aa9eeacf6588d$var$_toThenable(options.serialize);
        var setItem = function setItem() {
            var state = options.partialize($862aa9eeacf6588d$var$_extends({}, get()));
            var errorInSync;
            var thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then(function(serializedValue) {
                return storage.setItem(options.name, serializedValue);
            }).catch(function(e) {
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        var savedSetState = api.setState;
        api.setState = function(state, replace) {
            savedSetState(state, replace);
            setItem();
        };
        var configResult = config(function() {
            set.apply(void 0, arguments);
            setItem();
        }, get, api);
        var stateFromStorage;
        var hydrate = function hydrate() {
            if (!storage) return;
            _hasHydrated = false;
            hydrationListeners.forEach(function(cb) {
                return cb(get());
            });
            var postRehydrationCallback = (options.onRehydrateStorage == null ? void 0 : options.onRehydrateStorage(get())) || undefined;
            return $862aa9eeacf6588d$var$_toThenable(storage.getItem.bind(storage))(options.name).then(function(storageValue) {
                if (storageValue) return options.deserialize(storageValue);
            }).then(function(deserializedStorageValue) {
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === 'number' && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return deserializedStorageValue.state;
                }
            }).then(function(migratedState) {
                var _get;
                stateFromStorage = options.merge(migratedState, (_get = get()) != null ? _get : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(function() {
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, undefined);
                _hasHydrated = true;
                finishHydrationListeners.forEach(function(cb) {
                    return cb(stateFromStorage);
                });
            }).catch(function(e) {
                postRehydrationCallback == null || postRehydrationCallback(undefined, e);
            });
        };
        api.persist = {
            setOptions: function setOptions(newOptions) {
                options = $862aa9eeacf6588d$var$_extends({}, options, newOptions);
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: function clearStorage() {
                var _storage;
                (_storage = storage) == null || _storage.removeItem(options.name);
            },
            getOptions: function getOptions() {
                return options;
            },
            rehydrate: function rehydrate() {
                return hydrate();
            },
            hasHydrated: function hasHydrated() {
                return _hasHydrated;
            },
            onHydrate: function onHydrate(cb) {
                hydrationListeners.add(cb);
                return function() {
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: function onFinishHydration(cb) {
                finishHydrationListeners.add(cb);
                return function() {
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
};
var $862aa9eeacf6588d$var$newImpl = function newImpl(config, baseOptions) {
    return function(set, get, api) {
        var options = $862aa9eeacf6588d$var$_extends({
            storage: $862aa9eeacf6588d$var$createJSONStorage(function() {
                return localStorage;
            }),
            partialize: function partialize(state) {
                return state;
            },
            version: 0,
            merge: function merge(persistedState, currentState) {
                return $862aa9eeacf6588d$var$_extends({}, currentState, persistedState);
            }
        }, baseOptions);
        var _hasHydrated2 = false;
        var hydrationListeners = new Set();
        var finishHydrationListeners = new Set();
        var storage = options.storage;
        if (!storage) return config(function() {
            console.warn("[zustand persist middleware] Unable to update item '" + options.name + "', the given storage is currently unavailable.");
            set.apply(void 0, arguments);
        }, get, api);
        var setItem = function setItem() {
            var state = options.partialize($862aa9eeacf6588d$var$_extends({}, get()));
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        var savedSetState = api.setState;
        api.setState = function(state, replace) {
            savedSetState(state, replace);
            setItem();
        };
        var configResult = config(function() {
            set.apply(void 0, arguments);
            setItem();
        }, get, api);
        api.getInitialState = function() {
            return configResult;
        };
        var stateFromStorage;
        var hydrate = function hydrate() {
            var _get3;
            if (!storage) return;
            _hasHydrated2 = false;
            hydrationListeners.forEach(function(cb) {
                var _get2;
                return cb((_get2 = get()) != null ? _get2 : configResult);
            });
            var postRehydrationCallback = (options.onRehydrateStorage == null ? void 0 : options.onRehydrateStorage((_get3 = get()) != null ? _get3 : configResult)) || undefined;
            return $862aa9eeacf6588d$var$_toThenable(storage.getItem.bind(storage))(options.name).then(function(deserializedStorageValue) {
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === 'number' && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return [
                            true,
                            options.migrate(deserializedStorageValue.state, deserializedStorageValue.version)
                        ];
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return [
                        false,
                        deserializedStorageValue.state
                    ];
                }
                return [
                    false,
                    undefined
                ];
            }).then(function(migrationResult) {
                var _get4;
                var migrated = migrationResult[0], migratedState = migrationResult[1];
                stateFromStorage = options.merge(migratedState, (_get4 = get()) != null ? _get4 : configResult);
                set(stateFromStorage, true);
                if (migrated) return setItem();
            }).then(function() {
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, undefined);
                stateFromStorage = get();
                _hasHydrated2 = true;
                finishHydrationListeners.forEach(function(cb) {
                    return cb(stateFromStorage);
                });
            }).catch(function(e) {
                postRehydrationCallback == null || postRehydrationCallback(undefined, e);
            });
        };
        api.persist = {
            setOptions: function setOptions(newOptions) {
                options = $862aa9eeacf6588d$var$_extends({}, options, newOptions);
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: function clearStorage() {
                var _storage2;
                (_storage2 = storage) == null || _storage2.removeItem(options.name);
            },
            getOptions: function getOptions() {
                return options;
            },
            rehydrate: function rehydrate() {
                return hydrate();
            },
            hasHydrated: function hasHydrated() {
                return _hasHydrated2;
            },
            onHydrate: function onHydrate(cb) {
                hydrationListeners.add(cb);
                return function() {
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: function onFinishHydration(cb) {
                finishHydrationListeners.add(cb);
                return function() {
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
};
var $862aa9eeacf6588d$var$persistImpl = function persistImpl(config, baseOptions) {
    if ('getStorage' in baseOptions || 'serialize' in baseOptions || 'deserialize' in baseOptions) return $862aa9eeacf6588d$var$oldImpl(config, baseOptions);
    return $862aa9eeacf6588d$var$newImpl(config, baseOptions);
};
var $862aa9eeacf6588d$var$persist = $862aa9eeacf6588d$var$persistImpl;
$862aa9eeacf6588d$export$1be1fc439b849fdf = $862aa9eeacf6588d$var$combine;
$862aa9eeacf6588d$export$95a3b7b12ab518f9 = $862aa9eeacf6588d$var$createJSONStorage;
$862aa9eeacf6588d$export$6922d3b3a607469e = $862aa9eeacf6588d$var$devtools;
$862aa9eeacf6588d$export$9a6132153fba2e0 = $862aa9eeacf6588d$var$persist;
$862aa9eeacf6588d$export$4feba8a1bc8e9afd = $862aa9eeacf6588d$var$redux;
$862aa9eeacf6588d$export$5c593627aef9f076 = $862aa9eeacf6588d$var$subscribeWithSelector;

});

parcelRegister("iODEY", function(module, exports) {
$parcel$export(module.exports, "immer", () => $db2ba92673f2acbb$export$428de7ec69ac95c, (v) => $db2ba92673f2acbb$export$428de7ec69ac95c = v);
var $db2ba92673f2acbb$export$428de7ec69ac95c;
'use strict';

var $cEJXU = parcelRequire("cEJXU");
var $db2ba92673f2acbb$var$immerImpl = function immerImpl(initializer) {
    return function(set, get, store) {
        store.setState = function(updater, replace) {
            var nextState = typeof updater === 'function' ? $cEJXU.produce(updater) : updater;
            for(var _len = arguments.length, a = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)a[_key - 2] = arguments[_key];
            return set.apply(void 0, [
                nextState,
                replace
            ].concat(a));
        };
        return initializer(store.setState, get, store);
    };
};
var $db2ba92673f2acbb$var$immer = $db2ba92673f2acbb$var$immerImpl;
$db2ba92673f2acbb$export$428de7ec69ac95c = $db2ba92673f2acbb$var$immer;

});
parcelRegister("cEJXU", function(module, exports) {
$parcel$export(module.exports, "produce", () => $936ce038e559daa3$export$b46cabe22e78bc00);
var $936ce038e559daa3$var$__defProp = Object.defineProperty;
var $936ce038e559daa3$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $936ce038e559daa3$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $936ce038e559daa3$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $936ce038e559daa3$var$__defNormalProp = (obj, key, value)=>key in obj ? $936ce038e559daa3$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $936ce038e559daa3$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($936ce038e559daa3$var$__hasOwnProp.call(b, prop)) $936ce038e559daa3$var$__defNormalProp(a, prop, b[prop]);
    if ($936ce038e559daa3$var$__getOwnPropSymbols) {
        for (var prop of $936ce038e559daa3$var$__getOwnPropSymbols(b))if ($936ce038e559daa3$var$__propIsEnum.call(b, prop)) $936ce038e559daa3$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $936ce038e559daa3$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $936ce038e559daa3$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $936ce038e559daa3$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $936ce038e559daa3$var$errors = [];
function $936ce038e559daa3$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $936ce038e559daa3$var$O = Object;
var $936ce038e559daa3$var$getPrototypeOf = $936ce038e559daa3$var$O.getPrototypeOf;
var $936ce038e559daa3$var$CONSTRUCTOR = "constructor";
var $936ce038e559daa3$var$PROTOTYPE = "prototype";
var $936ce038e559daa3$var$CONFIGURABLE = "configurable";
var $936ce038e559daa3$var$ENUMERABLE = "enumerable";
var $936ce038e559daa3$var$WRITABLE = "writable";
var $936ce038e559daa3$var$VALUE = "value";
var $936ce038e559daa3$export$541ac630993a4c84 = (value)=>!!value && !!value[$936ce038e559daa3$var$DRAFT_STATE];
function $936ce038e559daa3$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $936ce038e559daa3$var$isPlainObject(value) || $936ce038e559daa3$var$isArray(value) || !!value[$936ce038e559daa3$export$6ee2082928bcb0ee] || !!((_a = value[$936ce038e559daa3$var$CONSTRUCTOR]) == null ? void 0 : _a[$936ce038e559daa3$export$6ee2082928bcb0ee]) || $936ce038e559daa3$var$isMap(value) || $936ce038e559daa3$var$isSet(value);
}
var $936ce038e559daa3$var$objectCtorString = $936ce038e559daa3$var$O[$936ce038e559daa3$var$PROTOTYPE][$936ce038e559daa3$var$CONSTRUCTOR].toString();
var $936ce038e559daa3$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $936ce038e559daa3$var$isPlainObject(value) {
    if (!value || !$936ce038e559daa3$var$isObjectish(value)) return false;
    const proto = $936ce038e559daa3$var$getPrototypeOf(value);
    if (proto === null || proto === $936ce038e559daa3$var$O[$936ce038e559daa3$var$PROTOTYPE]) return true;
    const Ctor = $936ce038e559daa3$var$O.hasOwnProperty.call(proto, $936ce038e559daa3$var$CONSTRUCTOR) && proto[$936ce038e559daa3$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$936ce038e559daa3$var$isFunction(Ctor)) return false;
    let ctorString = $936ce038e559daa3$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $936ce038e559daa3$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $936ce038e559daa3$var$objectCtorString;
}
function $936ce038e559daa3$export$22e8af3f75a010e3(value) {
    if (!$936ce038e559daa3$export$541ac630993a4c84(value)) $936ce038e559daa3$var$die(15, value);
    return value[$936ce038e559daa3$var$DRAFT_STATE].base_;
}
function $936ce038e559daa3$var$each(obj, iter, strict = true) {
    if ($936ce038e559daa3$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $936ce038e559daa3$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $936ce038e559daa3$var$getArchtype(thing) {
    const state = thing[$936ce038e559daa3$var$DRAFT_STATE];
    return state ? state.type_ : $936ce038e559daa3$var$isArray(thing) ? 1 /* Array */  : $936ce038e559daa3$var$isMap(thing) ? 2 /* Map */  : $936ce038e559daa3$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $936ce038e559daa3$var$has = (thing, prop, type = $936ce038e559daa3$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $936ce038e559daa3$var$O[$936ce038e559daa3$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $936ce038e559daa3$var$get = (thing, prop, type = $936ce038e559daa3$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $936ce038e559daa3$var$set = (thing, propOrOldValue, value, type = $936ce038e559daa3$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $936ce038e559daa3$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $936ce038e559daa3$var$isArray = Array.isArray;
var $936ce038e559daa3$var$isMap = (target)=>target instanceof Map;
var $936ce038e559daa3$var$isSet = (target)=>target instanceof Set;
var $936ce038e559daa3$var$isObjectish = (target)=>typeof target === "object";
var $936ce038e559daa3$var$isFunction = (target)=>typeof target === "function";
var $936ce038e559daa3$var$isBoolean = (target)=>typeof target === "boolean";
function $936ce038e559daa3$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $936ce038e559daa3$var$getProxyDraft = (value)=>{
    if (!$936ce038e559daa3$var$isObjectish(value)) return null;
    return value == null ? void 0 : value[$936ce038e559daa3$var$DRAFT_STATE];
};
var $936ce038e559daa3$var$latest = (state)=>state.copy_ || state.base_;
var $936ce038e559daa3$var$getValue = (value)=>{
    var _a;
    const proxyDraft = $936ce038e559daa3$var$getProxyDraft(value);
    return proxyDraft ? (_a = proxyDraft.copy_) != null ? _a : proxyDraft.base_ : value;
};
var $936ce038e559daa3$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $936ce038e559daa3$var$shallowCopy(base, strict) {
    if ($936ce038e559daa3$var$isMap(base)) return new Map(base);
    if ($936ce038e559daa3$var$isSet(base)) return new Set(base);
    if ($936ce038e559daa3$var$isArray(base)) return Array[$936ce038e559daa3$var$PROTOTYPE].slice.call(base);
    const isPlain = $936ce038e559daa3$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $936ce038e559daa3$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$936ce038e559daa3$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$936ce038e559daa3$var$WRITABLE] === false) {
                desc[$936ce038e559daa3$var$WRITABLE] = true;
                desc[$936ce038e559daa3$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$936ce038e559daa3$var$CONFIGURABLE]: true,
                [$936ce038e559daa3$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$936ce038e559daa3$var$ENUMERABLE]: desc[$936ce038e559daa3$var$ENUMERABLE],
                [$936ce038e559daa3$var$VALUE]: base[key]
            };
        }
        return $936ce038e559daa3$var$O.create($936ce038e559daa3$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $936ce038e559daa3$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $936ce038e559daa3$var$__spreadValues({}, base);
        const obj = $936ce038e559daa3$var$O.create(proto);
        return $936ce038e559daa3$var$O.assign(obj, base);
    }
}
function $936ce038e559daa3$export$792f3d81ea979f55(obj, deep = false) {
    if ($936ce038e559daa3$var$isFrozen(obj) || $936ce038e559daa3$export$541ac630993a4c84(obj) || !$936ce038e559daa3$export$16e3aed3edb85946(obj)) return obj;
    if ($936ce038e559daa3$var$getArchtype(obj) > 1) $936ce038e559daa3$var$O.defineProperties(obj, {
        set: $936ce038e559daa3$var$dontMutateMethodOverride,
        add: $936ce038e559daa3$var$dontMutateMethodOverride,
        clear: $936ce038e559daa3$var$dontMutateMethodOverride,
        delete: $936ce038e559daa3$var$dontMutateMethodOverride
    });
    $936ce038e559daa3$var$O.freeze(obj);
    if (deep) $936ce038e559daa3$var$each(obj, (_key, value)=>{
        $936ce038e559daa3$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $936ce038e559daa3$var$dontMutateFrozenCollections() {
    $936ce038e559daa3$var$die(2);
}
var $936ce038e559daa3$var$dontMutateMethodOverride = {
    [$936ce038e559daa3$var$VALUE]: $936ce038e559daa3$var$dontMutateFrozenCollections
};
function $936ce038e559daa3$var$isFrozen(obj) {
    if (obj === null || !$936ce038e559daa3$var$isObjectish(obj)) return true;
    return $936ce038e559daa3$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $936ce038e559daa3$var$PluginMapSet = "MapSet";
var $936ce038e559daa3$var$PluginPatches = "Patches";
var $936ce038e559daa3$var$PluginArrayMethods = "ArrayMethods";
var $936ce038e559daa3$var$plugins = {};
function $936ce038e559daa3$var$getPlugin(pluginKey) {
    const plugin = $936ce038e559daa3$var$plugins[pluginKey];
    if (!plugin) $936ce038e559daa3$var$die(0, pluginKey);
    return plugin;
}
var $936ce038e559daa3$var$isPluginLoaded = (pluginKey)=>!!$936ce038e559daa3$var$plugins[pluginKey];
function $936ce038e559daa3$var$loadPlugin(pluginKey, implementation) {
    if (!$936ce038e559daa3$var$plugins[pluginKey]) $936ce038e559daa3$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $936ce038e559daa3$var$currentScope;
var $936ce038e559daa3$var$getCurrentScope = ()=>$936ce038e559daa3$var$currentScope;
var $936ce038e559daa3$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $936ce038e559daa3$var$isPluginLoaded($936ce038e559daa3$var$PluginMapSet) ? $936ce038e559daa3$var$getPlugin($936ce038e559daa3$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $936ce038e559daa3$var$isPluginLoaded($936ce038e559daa3$var$PluginArrayMethods) ? $936ce038e559daa3$var$getPlugin($936ce038e559daa3$var$PluginArrayMethods) : void 0
    });
function $936ce038e559daa3$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $936ce038e559daa3$var$getPlugin($936ce038e559daa3$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $936ce038e559daa3$var$revokeScope(scope) {
    $936ce038e559daa3$var$leaveScope(scope);
    scope.drafts_.forEach($936ce038e559daa3$var$revokeDraft);
    scope.drafts_ = null;
}
function $936ce038e559daa3$var$leaveScope(scope) {
    if (scope === $936ce038e559daa3$var$currentScope) $936ce038e559daa3$var$currentScope = scope.parent_;
}
var $936ce038e559daa3$var$enterScope = (immer2)=>$936ce038e559daa3$var$currentScope = $936ce038e559daa3$var$createScope($936ce038e559daa3$var$currentScope, immer2);
function $936ce038e559daa3$var$revokeDraft(draft) {
    const state = draft[$936ce038e559daa3$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $936ce038e559daa3$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$936ce038e559daa3$var$DRAFT_STATE].modified_) {
            $936ce038e559daa3$var$revokeScope(scope);
            $936ce038e559daa3$var$die(4);
        }
        if ($936ce038e559daa3$export$16e3aed3edb85946(result)) result = $936ce038e559daa3$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$936ce038e559daa3$var$DRAFT_STATE].base_, result, scope);
    } else result = $936ce038e559daa3$var$finalize(scope, baseDraft);
    $936ce038e559daa3$var$maybeFreeze(scope, result, true);
    $936ce038e559daa3$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $936ce038e559daa3$export$45b790e32b2810ee ? result : void 0;
}
function $936ce038e559daa3$var$finalize(rootScope, value) {
    if ($936ce038e559daa3$var$isFrozen(value)) return value;
    const state = value[$936ce038e559daa3$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $936ce038e559daa3$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$936ce038e559daa3$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $936ce038e559daa3$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $936ce038e559daa3$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $936ce038e559daa3$export$792f3d81ea979f55(value, deep);
}
function $936ce038e559daa3$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $936ce038e559daa3$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $936ce038e559daa3$var$EMPTY_LOCATIONS_RESULT = [];
function $936ce038e559daa3$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    var _a;
    const parentCopy = $936ce038e559daa3$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $936ce038e559daa3$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $936ce038e559daa3$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $936ce038e559daa3$var$each(parentCopy, (key, value)=>{
            if ($936ce038e559daa3$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = (_a = parent.draftLocations_.get(draftValue)) != null ? _a : $936ce038e559daa3$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$936ce038e559daa3$var$set(parentCopy, location, finalizedValue, parentType);
}
function $936ce038e559daa3$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        var _a, _b;
        const state = child;
        if (!state || !$936ce038e559daa3$var$isSameScope(state, rootScope)) return;
        (_a = rootScope.mapSetPlugin_) == null || _a.fixSetContents(state);
        const finalizedValue = $936ce038e559daa3$var$getFinalValue(state);
        $936ce038e559daa3$var$updateDraftInParent(parent, (_b = state.draft_) != null ? _b : state, finalizedValue, key);
        $936ce038e559daa3$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $936ce038e559daa3$var$generatePatchesAndFinalize(state, rootScope) {
    var _a, _b;
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || ((_b = (_a = state.assigned_) == null ? void 0 : _a.size) != null ? _b : 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $936ce038e559daa3$var$markStateFinalized(state);
    }
}
function $936ce038e559daa3$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($936ce038e559daa3$export$541ac630993a4c84(value)) {
        const state = value[$936ce038e559daa3$var$DRAFT_STATE];
        if ($936ce038e559daa3$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $936ce038e559daa3$var$prepareCopy(target);
            const finalizedValue = $936ce038e559daa3$var$getFinalValue(state);
            $936ce038e559daa3$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($936ce038e559daa3$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        var _a;
        const targetCopy = $936ce038e559daa3$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $936ce038e559daa3$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($936ce038e559daa3$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && ((_a = target.assigned_.get(key)) != null ? _a : false) === true && target.copy_) $936ce038e559daa3$var$handleValue($936ce038e559daa3$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $936ce038e559daa3$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($936ce038e559daa3$export$541ac630993a4c84(target) || handledSet.has(target) || !$936ce038e559daa3$export$16e3aed3edb85946(target) || $936ce038e559daa3$var$isFrozen(target)) return target;
    handledSet.add(target);
    $936ce038e559daa3$var$each(target, (key, value)=>{
        if ($936ce038e559daa3$export$541ac630993a4c84(value)) {
            const state = value[$936ce038e559daa3$var$DRAFT_STATE];
            if ($936ce038e559daa3$var$isSameScope(state, rootScope)) {
                const updatedValue = $936ce038e559daa3$var$getFinalValue(state);
                $936ce038e559daa3$var$set(target, key, updatedValue, target.type_);
                $936ce038e559daa3$var$markStateFinalized(state);
            }
        } else if ($936ce038e559daa3$export$16e3aed3edb85946(value)) $936ce038e559daa3$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $936ce038e559daa3$var$createProxyProxy(base, parent) {
    const baseIsArray = $936ce038e559daa3$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $936ce038e559daa3$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $936ce038e559daa3$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $936ce038e559daa3$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $936ce038e559daa3$var$objectTraps = {
    get (state, prop) {
        if (prop === $936ce038e559daa3$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin == null ? void 0 : arrayPlugin.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $936ce038e559daa3$var$latest(state);
        if (!$936ce038e559daa3$var$has(source, prop, state.type_)) return $936ce038e559daa3$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$936ce038e559daa3$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && (arrayPlugin == null ? void 0 : arrayPlugin.isMutatingArrayMethod(state.operationMethod)) && $936ce038e559daa3$var$isArrayIndex(prop)) return value;
        if (value === $936ce038e559daa3$var$peek(state.base_, prop)) {
            $936ce038e559daa3$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $936ce038e559daa3$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $936ce038e559daa3$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($936ce038e559daa3$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $936ce038e559daa3$var$getDescriptorFromProto($936ce038e559daa3$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $936ce038e559daa3$var$peek($936ce038e559daa3$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$936ce038e559daa3$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if ($936ce038e559daa3$var$is(value, current2) && (value !== void 0 || $936ce038e559daa3$var$has(state.base_, prop, state.type_))) return true;
            $936ce038e559daa3$var$prepareCopy(state);
            $936ce038e559daa3$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $936ce038e559daa3$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $936ce038e559daa3$var$prepareCopy(state);
        if ($936ce038e559daa3$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $936ce038e559daa3$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $936ce038e559daa3$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$936ce038e559daa3$var$WRITABLE]: true,
            [$936ce038e559daa3$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$936ce038e559daa3$var$ENUMERABLE]: desc[$936ce038e559daa3$var$ENUMERABLE],
            [$936ce038e559daa3$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $936ce038e559daa3$var$die(11);
    },
    getPrototypeOf (state) {
        return $936ce038e559daa3$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $936ce038e559daa3$var$die(12);
    }
};
var $936ce038e559daa3$var$arrayTraps = {};
for(let key in $936ce038e559daa3$var$objectTraps){
    let fn = $936ce038e559daa3$var$objectTraps[key];
    $936ce038e559daa3$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$936ce038e559daa3$var$arrayTraps.deleteProperty = function(state, prop) {
    return $936ce038e559daa3$var$arrayTraps.set.call(this, state, prop, void 0);
};
$936ce038e559daa3$var$arrayTraps.set = function(state, prop, value) {
    return $936ce038e559daa3$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $936ce038e559daa3$var$peek(draft, prop) {
    const state = draft[$936ce038e559daa3$var$DRAFT_STATE];
    const source = state ? $936ce038e559daa3$var$latest(state) : draft;
    return source[prop];
}
function $936ce038e559daa3$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $936ce038e559daa3$var$getDescriptorFromProto(source, prop);
    return desc ? $936ce038e559daa3$var$VALUE in desc ? desc[$936ce038e559daa3$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $936ce038e559daa3$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $936ce038e559daa3$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $936ce038e559daa3$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $936ce038e559daa3$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $936ce038e559daa3$var$markChanged(state.parent_);
    }
}
function $936ce038e559daa3$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $936ce038e559daa3$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $936ce038e559daa3$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($936ce038e559daa3$var$isFunction(base) && !$936ce038e559daa3$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$936ce038e559daa3$var$isFunction(recipe)) $936ce038e559daa3$var$die(6);
            if (patchListener !== void 0 && !$936ce038e559daa3$var$isFunction(patchListener)) $936ce038e559daa3$var$die(7);
            let result;
            if ($936ce038e559daa3$export$16e3aed3edb85946(base)) {
                const scope = $936ce038e559daa3$var$enterScope(this);
                const proxy = $936ce038e559daa3$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $936ce038e559daa3$var$revokeScope(scope);
                    else $936ce038e559daa3$var$leaveScope(scope);
                }
                $936ce038e559daa3$var$usePatchesInScope(scope, patchListener);
                return $936ce038e559daa3$var$processResult(result, scope);
            } else if (!base || !$936ce038e559daa3$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $936ce038e559daa3$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $936ce038e559daa3$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $936ce038e559daa3$var$getPlugin($936ce038e559daa3$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $936ce038e559daa3$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($936ce038e559daa3$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($936ce038e559daa3$var$isBoolean(config == null ? void 0 : config.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($936ce038e559daa3$var$isBoolean(config == null ? void 0 : config.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($936ce038e559daa3$var$isBoolean(config == null ? void 0 : config.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$936ce038e559daa3$export$16e3aed3edb85946(base)) $936ce038e559daa3$var$die(8);
        if ($936ce038e559daa3$export$541ac630993a4c84(base)) base = $936ce038e559daa3$export$97aac956da55dae9(base);
        const scope = $936ce038e559daa3$var$enterScope(this);
        const proxy = $936ce038e559daa3$var$createProxy(scope, base, void 0);
        proxy[$936ce038e559daa3$var$DRAFT_STATE].isManual_ = true;
        $936ce038e559daa3$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$936ce038e559daa3$var$DRAFT_STATE];
        if (!state || !state.isManual_) $936ce038e559daa3$var$die(9);
        const { scope_: scope } = state;
        $936ce038e559daa3$var$usePatchesInScope(scope, patchListener);
        return $936ce038e559daa3$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $936ce038e559daa3$var$getPlugin($936ce038e559daa3$var$PluginPatches).applyPatches_;
        if ($936ce038e559daa3$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $936ce038e559daa3$var$createProxy(rootScope, value, parent, key) {
    var _a, _b;
    const [draft, state] = $936ce038e559daa3$var$isMap(value) ? $936ce038e559daa3$var$getPlugin($936ce038e559daa3$var$PluginMapSet).proxyMap_(value, parent) : $936ce038e559daa3$var$isSet(value) ? $936ce038e559daa3$var$getPlugin($936ce038e559daa3$var$PluginMapSet).proxySet_(value, parent) : $936ce038e559daa3$var$createProxyProxy(value, parent);
    const scope = (_a = parent == null ? void 0 : parent.scope_) != null ? _a : $936ce038e559daa3$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = (_b = parent == null ? void 0 : parent.callbacks_) != null ? _b : [];
    state.key_ = key;
    if (parent && key !== void 0) $936ce038e559daa3$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        var _a2;
        (_a2 = rootScope2.mapSetPlugin_) == null || _a2.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $936ce038e559daa3$export$97aac956da55dae9(value) {
    if (!$936ce038e559daa3$export$541ac630993a4c84(value)) $936ce038e559daa3$var$die(10, value);
    return $936ce038e559daa3$var$currentImpl(value);
}
function $936ce038e559daa3$var$currentImpl(value) {
    if (!$936ce038e559daa3$export$16e3aed3edb85946(value) || $936ce038e559daa3$var$isFrozen(value)) return value;
    const state = value[$936ce038e559daa3$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $936ce038e559daa3$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $936ce038e559daa3$var$shallowCopy(value, true);
    $936ce038e559daa3$var$each(copy, (key, childValue)=>{
        $936ce038e559daa3$var$set(copy, key, $936ce038e559daa3$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $936ce038e559daa3$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        var _a;
        if (state.key_ !== void 0) {
            const parentCopy = (_a = state.parent_.copy_) != null ? _a : state.parent_.base_;
            const proxyDraft = $936ce038e559daa3$var$getProxyDraft($936ce038e559daa3$var$get(parentCopy, state.key_));
            const valueAtKey = $936ce038e559daa3$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $936ce038e559daa3$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $936ce038e559daa3$var$get(current2, key);
            if (!$936ce038e559daa3$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || (assigned_ == null ? void 0 : assigned_.get(i.toString()));
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem == null ? void 0 : copiedItem[$936ce038e559daa3$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $936ce038e559daa3$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $936ce038e559daa3$var$get(base_, key, type_);
            const value = $936ce038e559daa3$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $936ce038e559daa3$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $936ce038e559daa3$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $936ce038e559daa3$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $936ce038e559daa3$var$CONSTRUCTOR)) $936ce038e559daa3$var$die(errorOffset + 3);
                if ($936ce038e559daa3$var$isFunction(base) && p === $936ce038e559daa3$var$PROTOTYPE) $936ce038e559daa3$var$die(errorOffset + 3);
                base = $936ce038e559daa3$var$get(base, p);
                if (!$936ce038e559daa3$var$isObjectish(base)) $936ce038e559daa3$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $936ce038e559daa3$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $936ce038e559daa3$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $936ce038e559daa3$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$936ce038e559daa3$export$16e3aed3edb85946(obj)) return obj;
        if ($936ce038e559daa3$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($936ce038e559daa3$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($936ce038e559daa3$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($936ce038e559daa3$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($936ce038e559daa3$var$has(obj, $936ce038e559daa3$export$6ee2082928bcb0ee)) cloned[$936ce038e559daa3$export$6ee2082928bcb0ee] = obj[$936ce038e559daa3$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($936ce038e559daa3$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $936ce038e559daa3$var$loadPlugin($936ce038e559daa3$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
function $936ce038e559daa3$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$936ce038e559daa3$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $936ce038e559daa3$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            return $936ce038e559daa3$var$latest(this[$936ce038e559daa3$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $936ce038e559daa3$var$latest(this[$936ce038e559daa3$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$936ce038e559daa3$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$936ce038e559daa3$var$latest(state).has(key) || $936ce038e559daa3$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $936ce038e559daa3$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $936ce038e559daa3$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$936ce038e559daa3$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $936ce038e559daa3$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$936ce038e559daa3$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($936ce038e559daa3$var$latest(state).size) {
                prepareMapCopy(state);
                $936ce038e559daa3$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $936ce038e559daa3$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$936ce038e559daa3$var$DRAFT_STATE];
            $936ce038e559daa3$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$936ce038e559daa3$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $936ce038e559daa3$var$latest(state).get(key);
            if (state.finalized_ || !$936ce038e559daa3$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $936ce038e559daa3$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $936ce038e559daa3$var$latest(this[$936ce038e559daa3$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($936ce038e559daa3$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$936ce038e559daa3$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$936ce038e559daa3$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $936ce038e559daa3$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            return $936ce038e559daa3$var$latest(this[$936ce038e559daa3$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$936ce038e559daa3$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$936ce038e559daa3$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $936ce038e559daa3$var$markChanged(state);
                state.copy_.add(value);
                $936ce038e559daa3$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$936ce038e559daa3$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $936ce038e559daa3$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$936ce038e559daa3$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($936ce038e559daa3$var$latest(state).size) {
                prepareSetCopy(state);
                $936ce038e559daa3$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$936ce038e559daa3$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$936ce038e559daa3$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($936ce038e559daa3$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$936ce038e559daa3$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($936ce038e559daa3$export$16e3aed3edb85946(value)) {
                    const draft = $936ce038e559daa3$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $936ce038e559daa3$var$die(3, JSON.stringify($936ce038e559daa3$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($936ce038e559daa3$var$getValue(value));
            });
        }
    }
    $936ce038e559daa3$var$loadPlugin($936ce038e559daa3$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $936ce038e559daa3$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $936ce038e559daa3$var$prepareCopy(state);
        const result = operation();
        $936ce038e559daa3$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
        return result;
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleInsertedValues(state, startIndex, values) {
        for(let i = 0; i < values.length; i++){
            const index = startIndex + i;
            state.assigned_.set(index, true);
            $936ce038e559daa3$var$handleCrossReference(state, index, values[i]);
        }
    }
    function handleSimpleOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            const lengthBefore = state.copy_.length;
            const result = state.copy_[method](...args);
            if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
            if (method === "push" && args.length > 0) handleInsertedValues(state, lengthBefore, args);
            else if (method === "unshift" && args.length > 0) handleInsertedValues(state, 0, args);
            return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
        });
    }
    function handleReorderingOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            var _a;
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const res = executeArrayMethod(state, ()=>state.copy_.splice(...args));
                        markAllIndicesReassigned(state);
                        if (args.length > 2) {
                            const startIndex = normalizeSliceIndex((_a = args[0]) != null ? _a : 0, state.copy_.length);
                            handleInsertedValues(state, startIndex, args.slice(2));
                        }
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        var _a, _b;
        const source = $936ce038e559daa3$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate(source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = (_a = args[0]) != null ? _a : 0;
            const rawEnd = (_b = args[1]) != null ? _b : source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $936ce038e559daa3$var$loadPlugin($936ce038e559daa3$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $936ce038e559daa3$var$immer = new $936ce038e559daa3$export$aaadc6ff0f822719();
var $936ce038e559daa3$export$b46cabe22e78bc00 = $936ce038e559daa3$var$immer.produce;
var $936ce038e559daa3$export$4da66d41c9492c78 = /* @__PURE__ */ $936ce038e559daa3$var$immer.produceWithPatches.bind($936ce038e559daa3$var$immer);
var $936ce038e559daa3$export$573f26f60825c493 = /* @__PURE__ */ $936ce038e559daa3$var$immer.setAutoFreeze.bind($936ce038e559daa3$var$immer);
var $936ce038e559daa3$export$333ce65961cbe047 = /* @__PURE__ */ $936ce038e559daa3$var$immer.setUseStrictShallowCopy.bind($936ce038e559daa3$var$immer);
var $936ce038e559daa3$export$1045b3be3904c489 = /* @__PURE__ */ $936ce038e559daa3$var$immer.setUseStrictIteration.bind($936ce038e559daa3$var$immer);
var $936ce038e559daa3$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $936ce038e559daa3$var$immer.applyPatches.bind($936ce038e559daa3$var$immer);
var $936ce038e559daa3$export$3c3214997190395f = /* @__PURE__ */ $936ce038e559daa3$var$immer.createDraft.bind($936ce038e559daa3$var$immer);
var $936ce038e559daa3$export$c60f5e69c521b528 = /* @__PURE__ */ $936ce038e559daa3$var$immer.finishDraft.bind($936ce038e559daa3$var$immer);
var $936ce038e559daa3$export$c05b21e3257751e5 = (value)=>value;
var $936ce038e559daa3$export$20f911b3f8cf0b74 = (value)=>value;

});


parcelRegister("hzmic", function(module, exports) {
'use strict';
var $cca6ff6512463c21$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === 'function' ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== 'object' || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var getInitialState = function getInitialState() {
        return initialState;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    var initialState = state = createState(setState, getState, api);
    return api;
};
var $cca6ff6512463c21$var$createStore = function createStore(createState) {
    return createState ? $cca6ff6512463c21$var$createStoreImpl(createState) : $cca6ff6512463c21$var$createStoreImpl;
};
var $cca6ff6512463c21$var$vanilla = function(createState) {
    return $cca6ff6512463c21$var$createStore(createState);
};
module.exports.createStore = $cca6ff6512463c21$var$createStore;
module.exports.default = $cca6ff6512463c21$var$vanilla;
module.exports = $cca6ff6512463c21$var$vanilla;
module.exports.createStore = $cca6ff6512463c21$var$createStore;
module.exports.default = module.exports;

});


parcelRegister("kT0zX", function(module, exports) {
$parcel$export(module.exports, "FileFetcherImpl", () => $f34964b16e71547c$export$fe17eabf77aabacb);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $hW2Eg = parcelRequire("hW2Eg");

var $blmL7 = parcelRequire("blmL7");

var $lSgto = parcelRequire("lSgto");

var $6JfQX = parcelRequire("6JfQX");

var $g7x2h = parcelRequire("g7x2h");

var $zMV7W = parcelRequire("zMV7W");

var $7VCF9 = parcelRequire("7VCF9");

var $6Gdy5 = parcelRequire("6Gdy5");

var $i0hJq = parcelRequire("i0hJq");

var $jkJfI = parcelRequire("jkJfI");

var $eW8Rv = parcelRequire("eW8Rv");

var $6wdjf = parcelRequire("6wdjf");

var $kL5wX = parcelRequire("kL5wX");

var $hP1cj = parcelRequire("hP1cj");

var $cxmef = parcelRequire("cxmef");

var $5c5VR = parcelRequire("5c5VR");

var $4iAx6 = parcelRequire("4iAx6");

var $17rlx = parcelRequire("17rlx");

var $k4lMe = parcelRequire("k4lMe");

var $52yBi = parcelRequire("52yBi");

var $6ozP5 = parcelRequire("6ozP5");

var $iPJdn = parcelRequire("iPJdn");

var $ey77r = parcelRequire("ey77r");

var $jDqk1 = parcelRequire("jDqk1");

var $FwEaA = parcelRequire("FwEaA");

var $9gnZf = parcelRequire("9gnZf");

var $h8QRB = parcelRequire("h8QRB");

var $3uEc1 = parcelRequire("3uEc1");

var $3J535 = parcelRequire("3J535");

var $kbmH2 = parcelRequire("kbmH2");

var $ulNU1 = parcelRequire("ulNU1");

var $9iDns = parcelRequire("9iDns");

var $5ULj5 = parcelRequire("5ULj5");

var $aKw8h = parcelRequire("aKw8h");

var $432Wm = parcelRequire("432Wm");

var $f84Q2 = parcelRequire("f84Q2");

var $8kXu2 = parcelRequire("8kXu2");

var $elHy7 = parcelRequire("elHy7");

var $gjcf9 = parcelRequire("gjcf9");

function $f34964b16e71547c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f34964b16e71547c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f34964b16e71547c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f34964b16e71547c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f34964b16e71547c$var$isCopySourceFileWithToken = function isCopySourceFileWithToken(token) {
    return !!token.authProvider;
};
var $f34964b16e71547c$var$isCopyDestinationWithToken = function isCopyDestinationWithToken(token) {
    return !!token.authProvider;
};
var $f34964b16e71547c$export$fe17eabf77aabacb = /*#__PURE__*/ function() {
    function FileFetcherImpl(mediaApi) {
        var _this = this;
        var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $i0hJq.mediaStore);
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FileFetcherImpl);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getErrorFileState", function(error, id, occurrenceKey) {
            if ((0, $4iAx6.isCommonMediaClientError)(error)) return (0, $5c5VR.fromCommonMediaClientError)(id, occurrenceKey, error);
            // ________________________________________________
            // Legacy serializers
            // We need to revisit all the incoming error types and ensure all the "reason" values are known
            // We need to change the input error: any for a known type.
            if (typeof error === 'string') {
                var err = new (0, $cxmef.CommonMediaClientError)(error);
                return (0, $5c5VR.fromCommonMediaClientError)(id, occurrenceKey, err);
            } else {
                var _err = new (0, $cxmef.CommonMediaClientError)((error === null || error === void 0 ? void 0 : error.reason) || 'unknown', error === null || error === void 0 ? void 0 : error.metadata, error === null || error === void 0 ? void 0 : error.innerError);
                return (0, $5c5VR.fromCommonMediaClientError)(id, occurrenceKey, _err);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setFileState", function(id, fileState) {
            _this.store.setState(function(state) {
                state.files[id] = fileState;
            });
        });
        // TODO: ----- ADD TICKET TO PASS TRACE ID to this.dataloader.load
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "createDownloadFileStream", function(id, collectionName, occurrenceKey, includeHashForDuplicateFiles, forceRefresh, initialFileState) {
            var subject = (0, $3uEc1.createMediaSubject)(initialFileState);
            var poll = new (0, $432Wm.PollingFunction)();
            // ensure subject errors if polling exceeds max iterations or uncaught exception in executor
            poll.onError = function(error) {
                return subject.error(error);
            };
            poll.execute(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
                var response, fileState, _t;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!(!forceRefresh && (initialFileState === null || initialFileState === void 0 ? void 0 : initialFileState.status) === 'processed')) {
                                _context.next = 1;
                                break;
                            }
                            subject.complete();
                            return _context.abrupt("return");
                        case 1:
                            if (forceRefresh) _this.dataloader.clear({
                                id: id,
                                collectionName: collectionName,
                                includeHashForDuplicateFiles: includeHashForDuplicateFiles
                            });
                            _context.next = 2;
                            return _this.dataloader.load({
                                id: id,
                                collectionName: collectionName,
                                includeHashForDuplicateFiles: includeHashForDuplicateFiles
                            });
                        case 2:
                            response = _context.sent;
                            if (!(0, $52yBi.isNotFoundMediaItemDetails)(response)) {
                                _context.next = 3;
                                break;
                            }
                            throw new (0, $gjcf9.FileFetcherError)('emptyItems', {
                                id: id,
                                collectionName: collectionName,
                                occurrenceKey: occurrenceKey,
                                traceContext: response.metadataTraceContext
                            });
                        case 3:
                            if (!(0, $3J535.isEmptyFile)(response)) {
                                _context.next = 4;
                                break;
                            }
                            throw new (0, $gjcf9.FileFetcherError)('zeroVersionFile', {
                                id: id,
                                collectionName: collectionName,
                                occurrenceKey: occurrenceKey,
                                traceContext: response.metadataTraceContext
                            });
                        case 4:
                            fileState = (0, $ey77r.mapMediaItemToFileState)(id, response);
                            subject.next(fileState);
                            _t = fileState.status;
                            _context.next = _t === 'processing' ? 5 : _t === 'processed' ? 6 : 7;
                            break;
                        case 5:
                            // the only case for continuing polling, otherwise this function is run once only
                            poll.next();
                            return _context.abrupt("continue", 7);
                        case 6:
                            subject.complete();
                            return _context.abrupt("continue", 7);
                        case 7:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            })));
            return subject;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getUploadingFileStateBase", function(file, upfrontId) {
            // TODO: DO not modify the input parameter 'content' attribute
            if (typeof file.content === 'string') file.content = (0, $FwEaA.convertBase64ToBlob)(file.content);
            var content = file.content, _file$name = file.name, name = _file$name === void 0 ? '' : _file$name;
            var id = upfrontId.id, occurrenceKey = upfrontId.occurrenceKey;
            var preview;
            // TODO [MSW-796]: get file size for base64
            var size = 0;
            var mimeType = '';
            if (content instanceof Blob) {
                size = content.size;
                mimeType = content.type;
                preview = {
                    value: content,
                    origin: 'local'
                };
            }
            var mediaType = (0, $ulNU1.getMediaTypeFromUploadableFile)(file);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: mimeType,
                preview: preview
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "uploadArtifact", /*#__PURE__*/ function() {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(id, file, params, collectionName, traceContext) {
                var _yield$_this$mediaApi, data, _yield$_this$mediaApi2, altData, itemDetails;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            _context2.next = 1;
                            return _this.mediaApi.uploadArtifact(id, file, params, collectionName, traceContext);
                        case 1:
                            _yield$_this$mediaApi = _context2.sent;
                            data = _yield$_this$mediaApi.data;
                            _context2.next = 2;
                            return _this.mediaApi.getItems([
                                id
                            ], collectionName, traceContext);
                        case 2:
                            _yield$_this$mediaApi2 = _context2.sent;
                            altData = _yield$_this$mediaApi2.data;
                            itemDetails = altData.items[0].details; // ------------------------------------------------------------
                            _this.setFileState(id, (0, $ey77r.mapMediaItemToFileState)(id, itemDetails));
                            return _context2.abrupt("return", data);
                        case 3:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee2);
            }));
            return function(_x, _x2, _x3, _x4, _x5) {
                return _ref2.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "deleteArtifact", /*#__PURE__*/ function() {
            var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(id, artifactName, collectionName, traceContext) {
                var file, updatedArtifacts, updatedFileState;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                    while(true)switch(_context3.prev = _context3.next){
                        case 0:
                            _context3.next = 1;
                            return _this.mediaApi.deleteArtifact(id, artifactName, collectionName, traceContext);
                        case 1:
                            // Manually remove the artifact from file state instead of re-requesting the entire payload.
                            file = _this.store.getState().files[id];
                            if (file && file.status === 'processed' && file.artifacts) {
                                updatedArtifacts = $f34964b16e71547c$var$_objectSpread({}, file.artifacts);
                                delete updatedArtifacts[artifactName];
                                updatedFileState = $f34964b16e71547c$var$_objectSpread($f34964b16e71547c$var$_objectSpread({}, file), {}, {
                                    artifacts: updatedArtifacts
                                });
                                _this.setFileState(id, updatedFileState);
                            }
                        case 2:
                        case "end":
                            return _context3.stop();
                    }
                }, _callee3);
            }));
            return function(_x6, _x7, _x8, _x9) {
                return _ref3.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getOrFetchFileState", /*#__PURE__*/ function() {
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(id, collectionName) {
                var fileState, _t2;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                    while(true)switch(_context4.prev = _context4.next){
                        case 0:
                            fileState = _this.store.getState().files[id];
                            if (!(fileState !== null && fileState !== void 0)) {
                                _context4.next = 1;
                                break;
                            }
                            _t2 = fileState;
                            _context4.next = 3;
                            break;
                        case 1:
                            _context4.next = 2;
                            return _this.getCurrentState(id, {
                                collectionName: collectionName
                            });
                        case 2:
                            _t2 = _context4.sent;
                        case 3:
                            return _context4.abrupt("return", _t2);
                        case 4:
                        case "end":
                            return _context4.stop();
                    }
                }, _callee4);
            }));
            return function(_x0, _x1) {
                return _ref4.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getDurationOfVideo", /*#__PURE__*/ function() {
            var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(id, collectionName) {
                var _fileState$mediaMetad;
                var fileState, artifactUrlString, artifactUrl, artifactPath, res, arrayBuffer, uint8Array, mvhdBytes, mvhdIndex, i, j, dataView, start, timeScale, duration, videoLength;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                    while(true)switch(_context5.prev = _context5.next){
                        case 0:
                            _context5.next = 1;
                            return _this.getOrFetchFileState(id, collectionName);
                        case 1:
                            fileState = _context5.sent;
                            if (!(fileState.status !== 'processed' || fileState.mediaType !== 'video' || !fileState.artifacts['video.mp4'])) {
                                _context5.next = 2;
                                break;
                            }
                            throw new Error('File is not a video');
                        case 2:
                            if (!('mediaMetadata' in fileState && (_fileState$mediaMetad = fileState.mediaMetadata) !== null && _fileState$mediaMetad !== void 0 && _fileState$mediaMetad.duration)) {
                                _context5.next = 3;
                                break;
                            }
                            return _context5.abrupt("return", fileState.mediaMetadata.duration);
                        case 3:
                            _context5.next = 4;
                            return _this.getArtifactURL(fileState.artifacts, 'video.mp4', collectionName);
                        case 4:
                            artifactUrlString = _context5.sent;
                            artifactUrl = new URL(artifactUrlString);
                            artifactPath = "".concat(artifactUrl.pathname).concat(artifactUrl.search);
                            _context5.next = 5;
                            return _this.mediaApi.request(artifactPath, {
                                headers: {
                                    Range: 'bytes=0-199'
                                }
                            });
                        case 5:
                            res = _context5.sent;
                            _context5.next = 6;
                            return res.arrayBuffer();
                        case 6:
                            arrayBuffer = _context5.sent;
                            uint8Array = new Uint8Array(arrayBuffer);
                            mvhdBytes = new Uint8Array([
                                109,
                                118,
                                104,
                                100
                            ]); // "mvhd" in ASCII
                            mvhdIndex = -1;
                            i = 0;
                        case 7:
                            if (!(i <= uint8Array.length - mvhdBytes.length)) {
                                _context5.next = 12;
                                break;
                            }
                            mvhdIndex = i;
                            j = 0;
                        case 8:
                            if (!(j < mvhdBytes.length)) {
                                _context5.next = 10;
                                break;
                            }
                            if (!(uint8Array[i + j] !== mvhdBytes[j])) {
                                _context5.next = 9;
                                break;
                            }
                            mvhdIndex = -1;
                            return _context5.abrupt("continue", 10);
                        case 9:
                            j++;
                            _context5.next = 8;
                            break;
                        case 10:
                            if (!(mvhdIndex !== -1)) {
                                _context5.next = 11;
                                break;
                            }
                            return _context5.abrupt("continue", 12);
                        case 11:
                            i++;
                            _context5.next = 7;
                            break;
                        case 12:
                            if (!(mvhdIndex === -1)) {
                                _context5.next = 13;
                                break;
                            }
                            throw new Error('Unable to find mvhd bytes');
                        case 13:
                            // Create DataView for reading big-endian integers
                            dataView = new DataView(arrayBuffer);
                            start = mvhdIndex + 16; // Skip atom header and version/flags
                            // Check if we have enough bytes to read timescale and duration
                            if (!(start + 8 > arrayBuffer.byteLength)) {
                                _context5.next = 14;
                                break;
                            }
                            return _context5.abrupt("return", 0);
                        case 14:
                            // flase as second parameter indicates big-endian 32-bit integers
                            timeScale = dataView.getUint32(start, false);
                            duration = dataView.getUint32(start + 4, false);
                            if (!(timeScale === 0)) {
                                _context5.next = 15;
                                break;
                            }
                            throw new Error('Timescale is invalid');
                        case 15:
                            // get the video length in seconds
                            videoLength = Math.floor(duration / timeScale);
                            return _context5.abrupt("return", videoLength);
                        case 16:
                        case "end":
                            return _context5.stop();
                    }
                }, _callee5);
            }));
            return function(_x10, _x11) {
                return _ref5.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getVideoDurations", /*#__PURE__*/ function() {
            var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7(files) {
                var promises, durations;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context7) {
                    while(true)switch(_context7.prev = _context7.next){
                        case 0:
                            // get all the duration promises
                            promises = files.map(/*#__PURE__*/ function() {
                                var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(_ref7) {
                                    var id, collectionName, _t3;
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context6) {
                                        while(true)switch(_context6.prev = _context6.next){
                                            case 0:
                                                id = _ref7.id, collectionName = _ref7.collectionName;
                                                _context6.prev = 1;
                                                _context6.next = 2;
                                                return _this.getDurationOfVideo(id, collectionName);
                                            case 2:
                                                return _context6.abrupt("return", _context6.sent);
                                            case 3:
                                                _context6.prev = 3;
                                                _t3 = _context6["catch"](1);
                                                return _context6.abrupt("return", -1);
                                            case 4:
                                            case "end":
                                                return _context6.stop();
                                        }
                                    }, _callee6, null, [
                                        [
                                            1,
                                            3
                                        ]
                                    ]);
                                }));
                                return function(_x13) {
                                    return _ref8.apply(this, arguments);
                                };
                            }());
                            _context7.next = 1;
                            return Promise.all(promises);
                        case 1:
                            durations = _context7.sent;
                            return _context7.abrupt("return", durations.reduce(function(acc, curr, i) {
                                if (curr !== -1) {
                                    var _id = files[i].id;
                                    acc[_id] = curr;
                                }
                                return acc;
                            }, {}));
                        case 2:
                        case "end":
                            return _context7.stop();
                    }
                }, _callee7);
            }));
            return function(_x12) {
                return _ref6.apply(this, arguments);
            };
        }());
        this.mediaApi = mediaApi;
        this.store = store;
        this.dataloader = (0, $h8QRB.createFileDataloader)(mediaApi);
        this.copyIntentRegisterationBatcher = (0, $9gnZf.createCopyIntentRegisterationBatcher)(mediaApi);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FileFetcherImpl, [
        {
            key: "getFileState",
            value: function getFileState(id) {
                var _this2 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var collectionName = options.collectionName, occurrenceKey = options.occurrenceKey, includeHashForDuplicateFiles = options.includeHashForDuplicateFiles, forceRefresh = options.forceRefresh, initialFileState = options.initialFileState;
                if (!(0, $zMV7W.isValidUuid)(id)) {
                    // Do NOT pass initialFileState here — for an invalid UUID the SSR seed
                    // is meaningless and would cause subscribers to briefly see a
                    // valid-looking file state before the error is emitted.
                    var subject = (0, $3uEc1.createMediaSubject)();
                    var err = new (0, $gjcf9.FileFetcherError)('invalidFileId', {
                        id: id,
                        collectionName: collectionName,
                        occurrenceKey: occurrenceKey
                    });
                    var errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    subject.error(err);
                    this.setFileState(id, errorFileState);
                    return (0, $9iDns.fromObservable)(subject);
                }
                if (forceRefresh) (0, $kL5wX.getFileStreamsCache)().remove(id);
                return (0, $9iDns.fromObservable)((0, $kL5wX.getFileStreamsCache)().getOrInsert(id, function() {
                    var subject = _this2.createDownloadFileStream(id, collectionName, undefined, includeHashForDuplicateFiles, forceRefresh, initialFileState);
                    subject.subscribe({
                        next: function next(fileState) {
                            _this2.setFileState(id, fileState);
                        },
                        error: function error(err) {
                            var errorFileState = _this2.getErrorFileState(err, id, occurrenceKey);
                            _this2.setFileState(id, errorFileState);
                        }
                    });
                    return subject;
                }));
            }
        },
        {
            key: "getCurrentState",
            value: function getCurrentState(id, options) {
                return (0, $5ULj5.toPromise)(this.getFileState(id, options));
            }
        },
        {
            key: "getArtifactURL",
            value: function getArtifactURL(artifacts, artifactName, collectionName) {
                return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
            }
        },
        {
            key: "getFileBinaryURL",
            value: function getFileBinaryURL(id, collectionName, maxAge, name) {
                return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge, name);
            }
        },
        {
            key: "touchFiles",
            value: function touchFiles(descriptors, collection, traceContext, expectedFileSize) {
                return this.mediaApi.touchFiles({
                    descriptors: descriptors
                }, {
                    collection: collection
                }, traceContext, {
                    expectedFileSize: expectedFileSize
                }).then(function(_ref9) {
                    var data = _ref9.data;
                    return data;
                });
            }
        },
        {
            key: "generateUploadableFileUpfrontIds",
            value: function generateUploadableFileUpfrontIds(collection, traceContext, expectedFileSize) {
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                var id = (0, $6JfQX.default)();
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                var occurrenceKey = (0, $6JfQX.default)();
                var touchFileDescriptor = {
                    fileId: id,
                    occurrenceKey: occurrenceKey,
                    collection: collection
                };
                var deferredUploadId = this.touchFiles([
                    touchFileDescriptor
                ], collection, traceContext, expectedFileSize).then(function(touchedFiles) {
                    return touchedFiles.created[0].uploadId;
                });
                return {
                    id: id,
                    occurrenceKey: occurrenceKey,
                    deferredUploadId: deferredUploadId
                };
            }
        },
        {
            key: "uploadExternal",
            value: function() {
                var _uploadExternal = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(url, collection, traceContext, anonymizeFilename) {
                    var _this3 = this;
                    var uploadableFileUpfrontIds, id, occurrenceKey, subject, deferredBlob, preview, initialName, fileState;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
                                id = uploadableFileUpfrontIds.id, occurrenceKey = uploadableFileUpfrontIds.occurrenceKey;
                                subject = (0, $3uEc1.createMediaSubject)();
                                deferredBlob = fetch(url).then(function(response) {
                                    return response.blob();
                                }).catch(function() {
                                    return undefined;
                                });
                                preview = new Promise(/*#__PURE__*/ function() {
                                    var _ref0 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(resolve, reject) {
                                        var blob;
                                        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context8) {
                                            while(true)switch(_context8.prev = _context8.next){
                                                case 0:
                                                    _context8.next = 1;
                                                    return deferredBlob;
                                                case 1:
                                                    blob = _context8.sent;
                                                    if (!blob) reject('Could not fetch the blob');
                                                    resolve({
                                                        value: blob,
                                                        origin: 'remote'
                                                    });
                                                case 2:
                                                case "end":
                                                    return _context8.stop();
                                            }
                                        }, _callee8);
                                    }));
                                    return function(_x18, _x19) {
                                        return _ref0.apply(this, arguments);
                                    };
                                }());
                                initialName = anonymizeFilename ? crypto.randomUUID() : url.split('/').pop() || ''; // we create a initial fileState with the minimum info that we have at this point
                                fileState = {
                                    status: 'processing',
                                    name: initialName,
                                    size: 0,
                                    mediaType: 'unknown',
                                    mimeType: '',
                                    id: id,
                                    occurrenceKey: occurrenceKey,
                                    preview: preview
                                };
                                subject.next(fileState);
                                // we save it into the cache as soon as possible, in case someone subscribes
                                (0, $kL5wX.getFileStreamsCache)().set(id, subject);
                                this.setFileState(id, fileState);
                                return _context0.abrupt("return", new Promise(/*#__PURE__*/ function() {
                                    var _ref1 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(resolve, reject) {
                                        var blob, type, size, extension, name, file, mediaType, dimensions, _t4;
                                        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context9) {
                                            while(true)switch(_context9.prev = _context9.next){
                                                case 0:
                                                    _context9.next = 1;
                                                    return deferredBlob;
                                                case 1:
                                                    blob = _context9.sent;
                                                    if (blob) {
                                                        _context9.next = 2;
                                                        break;
                                                    }
                                                    return _context9.abrupt("return", reject('Could not download remote file'));
                                                case 2:
                                                    type = blob.type, size = blob.size;
                                                    extension = anonymizeFilename && (0, $jkJfI.isExperimentEnabled)('cc_maui_polish_changes_batch_8') ? (0, $hW2Eg.getExtension)(type) : undefined;
                                                    name = extension ? "".concat(initialName, ".").concat(extension) : initialName;
                                                    file = {
                                                        content: blob,
                                                        mimeType: type,
                                                        collection: collection,
                                                        name: name,
                                                        size: size
                                                    };
                                                    mediaType = (0, $7VCF9.getMediaTypeFromMimeType)(type); // we emit a richer state after the blob is fetched
                                                    subject.next({
                                                        status: 'processing',
                                                        name: name,
                                                        size: size,
                                                        mediaType: mediaType,
                                                        mimeType: type,
                                                        id: id,
                                                        occurrenceKey: occurrenceKey,
                                                        preview: preview
                                                    });
                                                    // we don't want to wait for the file to be upload
                                                    _this3.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
                                                    _context9.prev = 3;
                                                    _context9.next = 4;
                                                    return (0, $kbmH2.getDimensionsFromBlob)(mediaType, blob);
                                                case 4:
                                                    dimensions = _context9.sent;
                                                    _context9.next = 6;
                                                    break;
                                                case 5:
                                                    _context9.prev = 5;
                                                    _t4 = _context9["catch"](3);
                                                    reject(_t4);
                                                    return _context9.abrupt("return");
                                                case 6:
                                                    resolve({
                                                        dimensions: dimensions,
                                                        mimeType: type,
                                                        uploadableFileUpfrontIds: uploadableFileUpfrontIds
                                                    });
                                                case 7:
                                                case "end":
                                                    return _context9.stop();
                                            }
                                        }, _callee9, null, [
                                            [
                                                3,
                                                5
                                            ]
                                        ]);
                                    }));
                                    return function(_x20, _x21) {
                                        return _ref1.apply(this, arguments);
                                    };
                                }()));
                            case 1:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this);
                }));
                function uploadExternal(_x14, _x15, _x16, _x17) {
                    return _uploadExternal.apply(this, arguments);
                }
                return uploadExternal;
            }()
        },
        {
            key: "upload",
            value: function upload(file, controller, uploadableFileUpfrontIds, traceContext) {
                var _this4 = this;
                var collection = file.collection;
                var upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext, file.size);
                var id = upfrontId.id, occurrenceKey = upfrontId.occurrenceKey;
                var stateBase = this.getUploadingFileStateBase(file, upfrontId);
                var subject = (0, $3uEc1.createMediaSubject)();
                (0, $kL5wX.getFileStreamsCache)().set(id, subject);
                var onProgress = function onProgress(progress) {
                    var fileState = $f34964b16e71547c$var$_objectSpread($f34964b16e71547c$var$_objectSpread({
                        status: 'uploading'
                    }, stateBase), {}, {
                        progress: progress
                    });
                    subject.next(fileState);
                    _this4.setFileState(id, fileState);
                };
                var processingSubscription = new (0, $lSgto.Subscription)();
                var onUploadFinish = function onUploadFinish(error) {
                    if (error) {
                        var errorFileState = _this4.getErrorFileState(error, id, occurrenceKey);
                        _this4.setFileState(id, errorFileState);
                        return subject.error(error);
                    }
                    processingSubscription = _this4.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $blmL7.map)(function(remoteFileState) {
                        return $f34964b16e71547c$var$_objectSpread($f34964b16e71547c$var$_objectSpread($f34964b16e71547c$var$_objectSpread({}, stateBase), remoteFileState), (0, $aKw8h.overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType));
                    })).subscribe({
                        next: function next(fileState) {
                            subject.next(fileState);
                            _this4.setFileState(id, fileState);
                        },
                        error: function error(err) {
                            var errorFileState = _this4.getErrorFileState(err, id, occurrenceKey);
                            subject.error(err);
                            _this4.setFileState(id, errorFileState);
                        },
                        complete: subject.complete
                    });
                };
                var _uploadFile = (0, $jDqk1.uploadFile)(file, this.mediaApi, upfrontId, {
                    onUploadFinish: onUploadFinish,
                    onProgress: onProgress
                }, traceContext), cancel = _uploadFile.cancel;
                controller === null || controller === void 0 || controller.setAbort(function() {
                    cancel();
                    // TODO: filestate should turn to "Aborted" or something.
                    // Consider canceling an upload that is already finished
                    processingSubscription.unsubscribe();
                });
                // We should report progress asynchronously, since this is what consumer expects
                // (otherwise in newUploadService file-converting event will be emitted before files-added)
                setTimeout(onProgress, 0, 0);
                return (0, $9iDns.fromObservable)(subject);
            }
        },
        {
            key: "downloadBinary",
            value: function() {
                var _downloadBinary = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1(id, name, collectionName, traceContext) {
                    var downloadName, url, _t5;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context1) {
                        while(true)switch(_context1.prev = _context1.next){
                            case 0:
                                downloadName = name !== null && name !== void 0 ? name : 'download';
                                if (!(0, $eW8Rv.expValEquals)('platform_editor_media_download_fallback_name', 'isEnabled', true)) {
                                    _context1.next = 2;
                                    break;
                                }
                                _context1.next = 1;
                                return this.mediaApi.getFileBinaryURL(id, collectionName, undefined, name);
                            case 1:
                                _t5 = _context1.sent;
                                _context1.next = 4;
                                break;
                            case 2:
                                _context1.next = 3;
                                return this.mediaApi.getFileBinaryURL(id, collectionName);
                            case 3:
                                _t5 = _context1.sent;
                            case 4:
                                url = _t5;
                                (0, $g7x2h.downloadUrl)(url, {
                                    name: downloadName
                                });
                                (0, $hP1cj.globalMediaEventEmitter).emit('media-viewed', {
                                    fileId: id,
                                    isUserCollection: collectionName === (0, $6wdjf.RECENTS_COLLECTION),
                                    viewingLevel: 'download'
                                });
                                // Test the download after initiated the Browser process to catch any potential errors.
                                _context1.next = 5;
                                return this.mediaApi.testUrl(url, {
                                    traceContext: traceContext
                                });
                            case 5:
                            case "end":
                                return _context1.stop();
                        }
                    }, _callee1, this);
                }));
                function downloadBinary(_x22, _x23, _x24, _x25) {
                    return _downloadBinary.apply(this, arguments);
                }
                return downloadBinary;
            }()
        },
        {
            key: "registerCopyIntent",
            value: function() {
                var _registerCopyIntent = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10(id, collectionName) {
                    var auth, key, error;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                _context10.next = 1;
                                return this.mediaApi.resolveAuth({
                                    collectionName: collectionName
                                });
                            case 1:
                                auth = _context10.sent;
                                key = {
                                    id: id,
                                    collectionName: collectionName,
                                    resolvedAuth: auth
                                };
                                _context10.next = 2;
                                return this.copyIntentRegisterationBatcher.load(key);
                            case 2:
                                error = _context10.sent;
                                if (!error) {
                                    _context10.next = 3;
                                    break;
                                }
                                // if the error is retryable then it should not be cached
                                if ((0, $f84Q2.defaultShouldRetryError)(error)) this.copyIntentRegisterationBatcher.clear(key);
                                throw error;
                            case 3:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this);
                }));
                function registerCopyIntent(_x26, _x27) {
                    return _registerCopyIntent.apply(this, arguments);
                }
                return registerCopyIntent;
            }()
        },
        {
            key: "copyFileWithToken",
            value: function() {
                var _copyFileWithToken = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(source, destination, traceContext) {
                    var authProvider, sourceCollection, id, destinationAuthProvider, destinationCollectionName, replaceFileId, occurrenceKey, mediaStore, owner, body, params, _yield$mediaStore$cop, data, _t6;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                authProvider = source.authProvider, sourceCollection = source.collection, id = source.id;
                                destinationAuthProvider = destination.authProvider, destinationCollectionName = destination.collection, replaceFileId = destination.replaceFileId, occurrenceKey = destination.occurrenceKey;
                                mediaStore = destination.mediaStore || new (0, $elHy7.MediaStore)({
                                    authProvider: destinationAuthProvider
                                });
                                _t6 = (0, $6Gdy5.authToOwner);
                                _context11.next = 1;
                                return authProvider({
                                    collectionName: sourceCollection
                                });
                            case 1:
                                owner = _t6(_context11.sent);
                                body = {
                                    sourceFile: {
                                        id: id,
                                        collection: sourceCollection,
                                        owner: owner
                                    }
                                };
                                params = {
                                    collection: destinationCollectionName,
                                    replaceFileId: replaceFileId,
                                    occurrenceKey: occurrenceKey
                                };
                                _context11.next = 2;
                                return mediaStore.copyFileWithToken(body, params, traceContext);
                            case 2:
                                _yield$mediaStore$cop = _context11.sent;
                                data = _yield$mediaStore$cop.data;
                                return _context11.abrupt("return", data);
                            case 3:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11);
                }));
                function copyFileWithToken(_x28, _x29, _x30) {
                    return _copyFileWithToken.apply(this, arguments);
                }
                return copyFileWithToken;
            }()
        },
        {
            key: "copyFileWithIntent",
            value: function() {
                var _copyFileWithIntent = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee12(source, destination, traceContext) {
                    var res, data;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                _context12.next = 1;
                                return this.mediaApi.copyFile(source.id, {
                                    sourceCollection: source.collection,
                                    collection: destination.collection,
                                    replaceFileId: destination.replaceFileId
                                }, traceContext, source.clientId);
                            case 1:
                                res = _context12.sent;
                                data = res.data;
                                return _context12.abrupt("return", data);
                            case 2:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, this);
                }));
                function copyFileWithIntent(_x31, _x32, _x33) {
                    return _copyFileWithIntent.apply(this, arguments);
                }
                return copyFileWithIntent;
            }()
        },
        {
            key: "copyFile",
            value: function() {
                var _copyFile = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee13(source, destination) {
                    var _this5 = this;
                    var options, traceContext, id, destinationCollectionName, replaceFileId, occurrenceKey, preview, mimeType, cache, processingSubscription, copiedFile, copiedFileWithMimeType, copiedId, copiedMimeType, mediaType, copiedFileState, fileCache, subject, previewOverride, fileState, _fileState, _fileCache, replaceFileState, key, errorFileState, _args13 = arguments, _t7, _t8;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context13) {
                        while(true)switch(_context13.prev = _context13.next){
                            case 0:
                                options = _args13.length > 2 && _args13[2] !== undefined ? _args13[2] : {};
                                traceContext = _args13.length > 3 ? _args13[3] : undefined;
                                id = source.id;
                                destinationCollectionName = destination.collection, replaceFileId = destination.replaceFileId, occurrenceKey = destination.occurrenceKey;
                                preview = options.preview, mimeType = options.mimeType;
                                cache = (0, $kL5wX.getFileStreamsCache)();
                                _context13.prev = 1;
                                if (!($f34964b16e71547c$var$isCopySourceFileWithToken(source) && $f34964b16e71547c$var$isCopyDestinationWithToken(destination))) {
                                    _context13.next = 3;
                                    break;
                                }
                                _context13.next = 2;
                                return this.copyFileWithToken(source, destination, traceContext);
                            case 2:
                                copiedFile = _context13.sent;
                                _context13.next = 5;
                                break;
                            case 3:
                                _context13.next = 4;
                                return this.copyFileWithIntent(source, destination, traceContext);
                            case 4:
                                copiedFile = _context13.sent;
                            case 5:
                                // if we were passed a "mimeType", we propagate it into copiedFileWithMimeType
                                copiedFileWithMimeType = $f34964b16e71547c$var$_objectSpread($f34964b16e71547c$var$_objectSpread({}, copiedFile), mimeType ? {
                                    mimeType: mimeType
                                } : undefined);
                                copiedId = copiedFileWithMimeType.id, copiedMimeType = copiedFileWithMimeType.mimeType; // backend may return an "unknown" mediaType just after the copy
                                // it's better to deduce it from "copiedMimeType" using getMediaTypeFromMimeType()
                                mediaType = copiedMimeType ? (0, $7VCF9.getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
                                copiedFileState = (0, $iPJdn.mapMediaFileToFileState)({
                                    data: copiedFileWithMimeType
                                });
                                fileCache = cache.get(copiedId);
                                subject = fileCache || (0, $3uEc1.createMediaSubject)(); // if we were passed a "preview", we propagate it into the copiedFileState
                                previewOverride = !(0, $17rlx.isErrorFileState)(copiedFileState) && !!preview ? {
                                    preview: preview
                                } : {};
                                _t7 = !(0, $k4lMe.isFinalFileState)(copiedFileState) && // mimeType should always be returned by "copyFileWithToken"
                                // but in case it's not, we don't want to penalize "copyFile"
                                copiedMimeType;
                                if (!_t7) {
                                    _context13.next = 7;
                                    break;
                                }
                                _context13.next = 6;
                                return (0, $8kXu2.shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview);
                            case 6:
                                _t7 = _context13.sent;
                            case 7:
                                if (!_t7) {
                                    _context13.next = 8;
                                    break;
                                }
                                fileState = $f34964b16e71547c$var$_objectSpread($f34964b16e71547c$var$_objectSpread($f34964b16e71547c$var$_objectSpread({}, copiedFileState), (0, $aKw8h.overrideMediaTypeIfUnknown)(copiedFileState, mediaType)), previewOverride);
                                subject.next(fileState);
                                this.setFileState(copiedId, fileState);
                                processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                                    next: function next(remoteFileState) {
                                        var fileState = $f34964b16e71547c$var$_objectSpread($f34964b16e71547c$var$_objectSpread($f34964b16e71547c$var$_objectSpread({}, remoteFileState), (0, $aKw8h.overrideMediaTypeIfUnknown)(remoteFileState, mediaType)), !(0, $17rlx.isErrorFileState)(remoteFileState) && previewOverride);
                                        _this5.setFileState(copiedId, fileState);
                                        return subject.next(fileState);
                                    },
                                    error: function error(err) {
                                        var errorFileState = _this5.getErrorFileState(err, id, occurrenceKey);
                                        _this5.setFileState(copiedId, errorFileState);
                                        return subject.error(err);
                                    },
                                    complete: function complete() {
                                        return subject.complete();
                                    }
                                });
                                _context13.next = 9;
                                break;
                            case 8:
                                if (!(0, $6ozP5.isProcessingFileState)(copiedFileState)) {
                                    _fileState = $f34964b16e71547c$var$_objectSpread($f34964b16e71547c$var$_objectSpread({}, copiedFileState), !(0, $17rlx.isErrorFileState)(copiedFileState) && previewOverride);
                                    subject.next(_fileState);
                                    this.setFileState(copiedId, _fileState);
                                }
                            case 9:
                                if (!cache.has(copiedId)) (0, $kL5wX.getFileStreamsCache)().set(copiedId, subject);
                                return _context13.abrupt("return", copiedFile);
                            case 10:
                                _context13.prev = 10;
                                _t8 = _context13["catch"](1);
                                if (processingSubscription) processingSubscription.unsubscribe();
                                if (replaceFileId) {
                                    _fileCache = cache.get(replaceFileId);
                                    replaceFileState = this.store.getState().files[replaceFileId];
                                    if (_fileCache) _fileCache.error(_t8);
                                    else // Create a new subject with the error state for new subscriptions
                                    cache.set(id, (0, $3uEc1.createMediaSubject)(_t8));
                                    key = replaceFileState ? replaceFileId : id;
                                    errorFileState = this.getErrorFileState(_t8, id, occurrenceKey);
                                    this.setFileState(key, errorFileState);
                                }
                                throw _t8;
                            case 11:
                            case "end":
                                return _context13.stop();
                        }
                    }, _callee13, this, [
                        [
                            1,
                            10
                        ]
                    ]);
                }));
                function copyFile(_x34, _x35) {
                    return _copyFile.apply(this, arguments);
                }
                return copyFile;
            }()
        }
    ]);
}();

});
parcelRegister("hW2Eg", function(module, exports) {
'use strict';

var $jLYAH = parcelRequire("jLYAH");


module.exports = new $jLYAH((parcelRequire("hLeES")), (parcelRequire("4BATb")));

});
parcelRegister("jLYAH", function(module, exports) {
'use strict';
/**
 * @param typeMap [Object] Map of MIME type -> Array[extensions]
 * @param ...
 */ function $e65168361b481dff$var$Mime() {
    this._types = Object.create(null);
    this._extensions = Object.create(null);
    for(let i = 0; i < arguments.length; i++)this.define(arguments[i]);
    this.define = this.define.bind(this);
    this.getType = this.getType.bind(this);
    this.getExtension = this.getExtension.bind(this);
}
/**
 * Define mimetype -> extension mappings.  Each key is a mime-type that maps
 * to an array of extensions associated with the type.  The first extension is
 * used as the default extension for the type.
 *
 * e.g. mime.define({'audio/ogg', ['oga', 'ogg', 'spx']});
 *
 * If a type declares an extension that has already been defined, an error will
 * be thrown.  To suppress this error and force the extension to be associated
 * with the new type, pass `force`=true.  Alternatively, you may prefix the
 * extension with "*" to map the type to extension, without mapping the
 * extension to the type.
 *
 * e.g. mime.define({'audio/wav', ['wav']}, {'audio/x-wav', ['*wav']});
 *
 *
 * @param map (Object) type definitions
 * @param force (Boolean) if true, force overriding of existing definitions
 */ $e65168361b481dff$var$Mime.prototype.define = function(typeMap, force) {
    for(let type in typeMap){
        let extensions = typeMap[type].map(function(t) {
            return t.toLowerCase();
        });
        type = type.toLowerCase();
        for(let i = 0; i < extensions.length; i++){
            const ext = extensions[i];
            // '*' prefix = not the preferred type for this extension.  So fixup the
            // extension, and skip it.
            if (ext[0] === '*') continue;
            if (!force && ext in this._types) throw new Error('Attempt to change mapping for "' + ext + '" extension from "' + this._types[ext] + '" to "' + type + '". Pass `force=true` to allow this, otherwise remove "' + ext + '" from the list of extensions for "' + type + '".');
            this._types[ext] = type;
        }
        // Use first extension as default
        if (force || !this._extensions[type]) {
            const ext = extensions[0];
            this._extensions[type] = ext[0] !== '*' ? ext : ext.substr(1);
        }
    }
};
/**
 * Lookup a mime type based on extension
 */ $e65168361b481dff$var$Mime.prototype.getType = function(path) {
    path = String(path);
    let last = path.replace(/^.*[/\\]/, '').toLowerCase();
    let ext = last.replace(/^.*\./, '').toLowerCase();
    let hasPath = last.length < path.length;
    let hasDot = ext.length < last.length - 1;
    return (hasDot || !hasPath) && this._types[ext] || null;
};
/**
 * Return file extension associated with a mime type
 */ $e65168361b481dff$var$Mime.prototype.getExtension = function(type) {
    type = /^\s*([^;\s]*)/.test(type) && RegExp.$1;
    return type && this._extensions[type.toLowerCase()] || null;
};
module.exports = $e65168361b481dff$var$Mime;

});

parcelRegister("hLeES", function(module, exports) {
module.exports = {
    "application/andrew-inset": [
        "ez"
    ],
    "application/applixware": [
        "aw"
    ],
    "application/atom+xml": [
        "atom"
    ],
    "application/atomcat+xml": [
        "atomcat"
    ],
    "application/atomdeleted+xml": [
        "atomdeleted"
    ],
    "application/atomsvc+xml": [
        "atomsvc"
    ],
    "application/atsc-dwd+xml": [
        "dwd"
    ],
    "application/atsc-held+xml": [
        "held"
    ],
    "application/atsc-rsat+xml": [
        "rsat"
    ],
    "application/bdoc": [
        "bdoc"
    ],
    "application/calendar+xml": [
        "xcs"
    ],
    "application/ccxml+xml": [
        "ccxml"
    ],
    "application/cdfx+xml": [
        "cdfx"
    ],
    "application/cdmi-capability": [
        "cdmia"
    ],
    "application/cdmi-container": [
        "cdmic"
    ],
    "application/cdmi-domain": [
        "cdmid"
    ],
    "application/cdmi-object": [
        "cdmio"
    ],
    "application/cdmi-queue": [
        "cdmiq"
    ],
    "application/cu-seeme": [
        "cu"
    ],
    "application/dash+xml": [
        "mpd"
    ],
    "application/davmount+xml": [
        "davmount"
    ],
    "application/docbook+xml": [
        "dbk"
    ],
    "application/dssc+der": [
        "dssc"
    ],
    "application/dssc+xml": [
        "xdssc"
    ],
    "application/ecmascript": [
        "es",
        "ecma"
    ],
    "application/emma+xml": [
        "emma"
    ],
    "application/emotionml+xml": [
        "emotionml"
    ],
    "application/epub+zip": [
        "epub"
    ],
    "application/exi": [
        "exi"
    ],
    "application/express": [
        "exp"
    ],
    "application/fdt+xml": [
        "fdt"
    ],
    "application/font-tdpfr": [
        "pfr"
    ],
    "application/geo+json": [
        "geojson"
    ],
    "application/gml+xml": [
        "gml"
    ],
    "application/gpx+xml": [
        "gpx"
    ],
    "application/gxf": [
        "gxf"
    ],
    "application/gzip": [
        "gz"
    ],
    "application/hjson": [
        "hjson"
    ],
    "application/hyperstudio": [
        "stk"
    ],
    "application/inkml+xml": [
        "ink",
        "inkml"
    ],
    "application/ipfix": [
        "ipfix"
    ],
    "application/its+xml": [
        "its"
    ],
    "application/java-archive": [
        "jar",
        "war",
        "ear"
    ],
    "application/java-serialized-object": [
        "ser"
    ],
    "application/java-vm": [
        "class"
    ],
    "application/javascript": [
        "js",
        "mjs"
    ],
    "application/json": [
        "json",
        "map"
    ],
    "application/json5": [
        "json5"
    ],
    "application/jsonml+json": [
        "jsonml"
    ],
    "application/ld+json": [
        "jsonld"
    ],
    "application/lgr+xml": [
        "lgr"
    ],
    "application/lost+xml": [
        "lostxml"
    ],
    "application/mac-binhex40": [
        "hqx"
    ],
    "application/mac-compactpro": [
        "cpt"
    ],
    "application/mads+xml": [
        "mads"
    ],
    "application/manifest+json": [
        "webmanifest"
    ],
    "application/marc": [
        "mrc"
    ],
    "application/marcxml+xml": [
        "mrcx"
    ],
    "application/mathematica": [
        "ma",
        "nb",
        "mb"
    ],
    "application/mathml+xml": [
        "mathml"
    ],
    "application/mbox": [
        "mbox"
    ],
    "application/mediaservercontrol+xml": [
        "mscml"
    ],
    "application/metalink+xml": [
        "metalink"
    ],
    "application/metalink4+xml": [
        "meta4"
    ],
    "application/mets+xml": [
        "mets"
    ],
    "application/mmt-aei+xml": [
        "maei"
    ],
    "application/mmt-usd+xml": [
        "musd"
    ],
    "application/mods+xml": [
        "mods"
    ],
    "application/mp21": [
        "m21",
        "mp21"
    ],
    "application/mp4": [
        "mp4s",
        "m4p"
    ],
    "application/msword": [
        "doc",
        "dot"
    ],
    "application/mxf": [
        "mxf"
    ],
    "application/n-quads": [
        "nq"
    ],
    "application/n-triples": [
        "nt"
    ],
    "application/node": [
        "cjs"
    ],
    "application/octet-stream": [
        "bin",
        "dms",
        "lrf",
        "mar",
        "so",
        "dist",
        "distz",
        "pkg",
        "bpk",
        "dump",
        "elc",
        "deploy",
        "exe",
        "dll",
        "deb",
        "dmg",
        "iso",
        "img",
        "msi",
        "msp",
        "msm",
        "buffer"
    ],
    "application/oda": [
        "oda"
    ],
    "application/oebps-package+xml": [
        "opf"
    ],
    "application/ogg": [
        "ogx"
    ],
    "application/omdoc+xml": [
        "omdoc"
    ],
    "application/onenote": [
        "onetoc",
        "onetoc2",
        "onetmp",
        "onepkg"
    ],
    "application/oxps": [
        "oxps"
    ],
    "application/p2p-overlay+xml": [
        "relo"
    ],
    "application/patch-ops-error+xml": [
        "xer"
    ],
    "application/pdf": [
        "pdf"
    ],
    "application/pgp-encrypted": [
        "pgp"
    ],
    "application/pgp-signature": [
        "asc",
        "sig"
    ],
    "application/pics-rules": [
        "prf"
    ],
    "application/pkcs10": [
        "p10"
    ],
    "application/pkcs7-mime": [
        "p7m",
        "p7c"
    ],
    "application/pkcs7-signature": [
        "p7s"
    ],
    "application/pkcs8": [
        "p8"
    ],
    "application/pkix-attr-cert": [
        "ac"
    ],
    "application/pkix-cert": [
        "cer"
    ],
    "application/pkix-crl": [
        "crl"
    ],
    "application/pkix-pkipath": [
        "pkipath"
    ],
    "application/pkixcmp": [
        "pki"
    ],
    "application/pls+xml": [
        "pls"
    ],
    "application/postscript": [
        "ai",
        "eps",
        "ps"
    ],
    "application/provenance+xml": [
        "provx"
    ],
    "application/pskc+xml": [
        "pskcxml"
    ],
    "application/raml+yaml": [
        "raml"
    ],
    "application/rdf+xml": [
        "rdf",
        "owl"
    ],
    "application/reginfo+xml": [
        "rif"
    ],
    "application/relax-ng-compact-syntax": [
        "rnc"
    ],
    "application/resource-lists+xml": [
        "rl"
    ],
    "application/resource-lists-diff+xml": [
        "rld"
    ],
    "application/rls-services+xml": [
        "rs"
    ],
    "application/route-apd+xml": [
        "rapd"
    ],
    "application/route-s-tsid+xml": [
        "sls"
    ],
    "application/route-usd+xml": [
        "rusd"
    ],
    "application/rpki-ghostbusters": [
        "gbr"
    ],
    "application/rpki-manifest": [
        "mft"
    ],
    "application/rpki-roa": [
        "roa"
    ],
    "application/rsd+xml": [
        "rsd"
    ],
    "application/rss+xml": [
        "rss"
    ],
    "application/rtf": [
        "rtf"
    ],
    "application/sbml+xml": [
        "sbml"
    ],
    "application/scvp-cv-request": [
        "scq"
    ],
    "application/scvp-cv-response": [
        "scs"
    ],
    "application/scvp-vp-request": [
        "spq"
    ],
    "application/scvp-vp-response": [
        "spp"
    ],
    "application/sdp": [
        "sdp"
    ],
    "application/senml+xml": [
        "senmlx"
    ],
    "application/sensml+xml": [
        "sensmlx"
    ],
    "application/set-payment-initiation": [
        "setpay"
    ],
    "application/set-registration-initiation": [
        "setreg"
    ],
    "application/shf+xml": [
        "shf"
    ],
    "application/sieve": [
        "siv",
        "sieve"
    ],
    "application/smil+xml": [
        "smi",
        "smil"
    ],
    "application/sparql-query": [
        "rq"
    ],
    "application/sparql-results+xml": [
        "srx"
    ],
    "application/srgs": [
        "gram"
    ],
    "application/srgs+xml": [
        "grxml"
    ],
    "application/sru+xml": [
        "sru"
    ],
    "application/ssdl+xml": [
        "ssdl"
    ],
    "application/ssml+xml": [
        "ssml"
    ],
    "application/swid+xml": [
        "swidtag"
    ],
    "application/tei+xml": [
        "tei",
        "teicorpus"
    ],
    "application/thraud+xml": [
        "tfi"
    ],
    "application/timestamped-data": [
        "tsd"
    ],
    "application/toml": [
        "toml"
    ],
    "application/trig": [
        "trig"
    ],
    "application/ttml+xml": [
        "ttml"
    ],
    "application/ubjson": [
        "ubj"
    ],
    "application/urc-ressheet+xml": [
        "rsheet"
    ],
    "application/urc-targetdesc+xml": [
        "td"
    ],
    "application/voicexml+xml": [
        "vxml"
    ],
    "application/wasm": [
        "wasm"
    ],
    "application/widget": [
        "wgt"
    ],
    "application/winhlp": [
        "hlp"
    ],
    "application/wsdl+xml": [
        "wsdl"
    ],
    "application/wspolicy+xml": [
        "wspolicy"
    ],
    "application/xaml+xml": [
        "xaml"
    ],
    "application/xcap-att+xml": [
        "xav"
    ],
    "application/xcap-caps+xml": [
        "xca"
    ],
    "application/xcap-diff+xml": [
        "xdf"
    ],
    "application/xcap-el+xml": [
        "xel"
    ],
    "application/xcap-ns+xml": [
        "xns"
    ],
    "application/xenc+xml": [
        "xenc"
    ],
    "application/xhtml+xml": [
        "xhtml",
        "xht"
    ],
    "application/xliff+xml": [
        "xlf"
    ],
    "application/xml": [
        "xml",
        "xsl",
        "xsd",
        "rng"
    ],
    "application/xml-dtd": [
        "dtd"
    ],
    "application/xop+xml": [
        "xop"
    ],
    "application/xproc+xml": [
        "xpl"
    ],
    "application/xslt+xml": [
        "*xsl",
        "xslt"
    ],
    "application/xspf+xml": [
        "xspf"
    ],
    "application/xv+xml": [
        "mxml",
        "xhvml",
        "xvml",
        "xvm"
    ],
    "application/yang": [
        "yang"
    ],
    "application/yin+xml": [
        "yin"
    ],
    "application/zip": [
        "zip"
    ],
    "audio/3gpp": [
        "*3gpp"
    ],
    "audio/adpcm": [
        "adp"
    ],
    "audio/amr": [
        "amr"
    ],
    "audio/basic": [
        "au",
        "snd"
    ],
    "audio/midi": [
        "mid",
        "midi",
        "kar",
        "rmi"
    ],
    "audio/mobile-xmf": [
        "mxmf"
    ],
    "audio/mp3": [
        "*mp3"
    ],
    "audio/mp4": [
        "m4a",
        "mp4a"
    ],
    "audio/mpeg": [
        "mpga",
        "mp2",
        "mp2a",
        "mp3",
        "m2a",
        "m3a"
    ],
    "audio/ogg": [
        "oga",
        "ogg",
        "spx",
        "opus"
    ],
    "audio/s3m": [
        "s3m"
    ],
    "audio/silk": [
        "sil"
    ],
    "audio/wav": [
        "wav"
    ],
    "audio/wave": [
        "*wav"
    ],
    "audio/webm": [
        "weba"
    ],
    "audio/xm": [
        "xm"
    ],
    "font/collection": [
        "ttc"
    ],
    "font/otf": [
        "otf"
    ],
    "font/ttf": [
        "ttf"
    ],
    "font/woff": [
        "woff"
    ],
    "font/woff2": [
        "woff2"
    ],
    "image/aces": [
        "exr"
    ],
    "image/apng": [
        "apng"
    ],
    "image/avif": [
        "avif"
    ],
    "image/bmp": [
        "bmp"
    ],
    "image/cgm": [
        "cgm"
    ],
    "image/dicom-rle": [
        "drle"
    ],
    "image/emf": [
        "emf"
    ],
    "image/fits": [
        "fits"
    ],
    "image/g3fax": [
        "g3"
    ],
    "image/gif": [
        "gif"
    ],
    "image/heic": [
        "heic"
    ],
    "image/heic-sequence": [
        "heics"
    ],
    "image/heif": [
        "heif"
    ],
    "image/heif-sequence": [
        "heifs"
    ],
    "image/hej2k": [
        "hej2"
    ],
    "image/hsj2": [
        "hsj2"
    ],
    "image/ief": [
        "ief"
    ],
    "image/jls": [
        "jls"
    ],
    "image/jp2": [
        "jp2",
        "jpg2"
    ],
    "image/jpeg": [
        "jpeg",
        "jpg",
        "jpe"
    ],
    "image/jph": [
        "jph"
    ],
    "image/jphc": [
        "jhc"
    ],
    "image/jpm": [
        "jpm"
    ],
    "image/jpx": [
        "jpx",
        "jpf"
    ],
    "image/jxr": [
        "jxr"
    ],
    "image/jxra": [
        "jxra"
    ],
    "image/jxrs": [
        "jxrs"
    ],
    "image/jxs": [
        "jxs"
    ],
    "image/jxsc": [
        "jxsc"
    ],
    "image/jxsi": [
        "jxsi"
    ],
    "image/jxss": [
        "jxss"
    ],
    "image/ktx": [
        "ktx"
    ],
    "image/ktx2": [
        "ktx2"
    ],
    "image/png": [
        "png"
    ],
    "image/sgi": [
        "sgi"
    ],
    "image/svg+xml": [
        "svg",
        "svgz"
    ],
    "image/t38": [
        "t38"
    ],
    "image/tiff": [
        "tif",
        "tiff"
    ],
    "image/tiff-fx": [
        "tfx"
    ],
    "image/webp": [
        "webp"
    ],
    "image/wmf": [
        "wmf"
    ],
    "message/disposition-notification": [
        "disposition-notification"
    ],
    "message/global": [
        "u8msg"
    ],
    "message/global-delivery-status": [
        "u8dsn"
    ],
    "message/global-disposition-notification": [
        "u8mdn"
    ],
    "message/global-headers": [
        "u8hdr"
    ],
    "message/rfc822": [
        "eml",
        "mime"
    ],
    "model/3mf": [
        "3mf"
    ],
    "model/gltf+json": [
        "gltf"
    ],
    "model/gltf-binary": [
        "glb"
    ],
    "model/iges": [
        "igs",
        "iges"
    ],
    "model/mesh": [
        "msh",
        "mesh",
        "silo"
    ],
    "model/mtl": [
        "mtl"
    ],
    "model/obj": [
        "obj"
    ],
    "model/step+xml": [
        "stpx"
    ],
    "model/step+zip": [
        "stpz"
    ],
    "model/step-xml+zip": [
        "stpxz"
    ],
    "model/stl": [
        "stl"
    ],
    "model/vrml": [
        "wrl",
        "vrml"
    ],
    "model/x3d+binary": [
        "*x3db",
        "x3dbz"
    ],
    "model/x3d+fastinfoset": [
        "x3db"
    ],
    "model/x3d+vrml": [
        "*x3dv",
        "x3dvz"
    ],
    "model/x3d+xml": [
        "x3d",
        "x3dz"
    ],
    "model/x3d-vrml": [
        "x3dv"
    ],
    "text/cache-manifest": [
        "appcache",
        "manifest"
    ],
    "text/calendar": [
        "ics",
        "ifb"
    ],
    "text/coffeescript": [
        "coffee",
        "litcoffee"
    ],
    "text/css": [
        "css"
    ],
    "text/csv": [
        "csv"
    ],
    "text/html": [
        "html",
        "htm",
        "shtml"
    ],
    "text/jade": [
        "jade"
    ],
    "text/jsx": [
        "jsx"
    ],
    "text/less": [
        "less"
    ],
    "text/markdown": [
        "markdown",
        "md"
    ],
    "text/mathml": [
        "mml"
    ],
    "text/mdx": [
        "mdx"
    ],
    "text/n3": [
        "n3"
    ],
    "text/plain": [
        "txt",
        "text",
        "conf",
        "def",
        "list",
        "log",
        "in",
        "ini"
    ],
    "text/richtext": [
        "rtx"
    ],
    "text/rtf": [
        "*rtf"
    ],
    "text/sgml": [
        "sgml",
        "sgm"
    ],
    "text/shex": [
        "shex"
    ],
    "text/slim": [
        "slim",
        "slm"
    ],
    "text/spdx": [
        "spdx"
    ],
    "text/stylus": [
        "stylus",
        "styl"
    ],
    "text/tab-separated-values": [
        "tsv"
    ],
    "text/troff": [
        "t",
        "tr",
        "roff",
        "man",
        "me",
        "ms"
    ],
    "text/turtle": [
        "ttl"
    ],
    "text/uri-list": [
        "uri",
        "uris",
        "urls"
    ],
    "text/vcard": [
        "vcard"
    ],
    "text/vtt": [
        "vtt"
    ],
    "text/xml": [
        "*xml"
    ],
    "text/yaml": [
        "yaml",
        "yml"
    ],
    "video/3gpp": [
        "3gp",
        "3gpp"
    ],
    "video/3gpp2": [
        "3g2"
    ],
    "video/h261": [
        "h261"
    ],
    "video/h263": [
        "h263"
    ],
    "video/h264": [
        "h264"
    ],
    "video/iso.segment": [
        "m4s"
    ],
    "video/jpeg": [
        "jpgv"
    ],
    "video/jpm": [
        "*jpm",
        "jpgm"
    ],
    "video/mj2": [
        "mj2",
        "mjp2"
    ],
    "video/mp2t": [
        "ts"
    ],
    "video/mp4": [
        "mp4",
        "mp4v",
        "mpg4"
    ],
    "video/mpeg": [
        "mpeg",
        "mpg",
        "mpe",
        "m1v",
        "m2v"
    ],
    "video/ogg": [
        "ogv"
    ],
    "video/quicktime": [
        "qt",
        "mov"
    ],
    "video/webm": [
        "webm"
    ]
};

});

parcelRegister("4BATb", function(module, exports) {
module.exports = {
    "application/prs.cww": [
        "cww"
    ],
    "application/vnd.1000minds.decision-model+xml": [
        "1km"
    ],
    "application/vnd.3gpp.pic-bw-large": [
        "plb"
    ],
    "application/vnd.3gpp.pic-bw-small": [
        "psb"
    ],
    "application/vnd.3gpp.pic-bw-var": [
        "pvb"
    ],
    "application/vnd.3gpp2.tcap": [
        "tcap"
    ],
    "application/vnd.3m.post-it-notes": [
        "pwn"
    ],
    "application/vnd.accpac.simply.aso": [
        "aso"
    ],
    "application/vnd.accpac.simply.imp": [
        "imp"
    ],
    "application/vnd.acucobol": [
        "acu"
    ],
    "application/vnd.acucorp": [
        "atc",
        "acutc"
    ],
    "application/vnd.adobe.air-application-installer-package+zip": [
        "air"
    ],
    "application/vnd.adobe.formscentral.fcdt": [
        "fcdt"
    ],
    "application/vnd.adobe.fxp": [
        "fxp",
        "fxpl"
    ],
    "application/vnd.adobe.xdp+xml": [
        "xdp"
    ],
    "application/vnd.adobe.xfdf": [
        "xfdf"
    ],
    "application/vnd.ahead.space": [
        "ahead"
    ],
    "application/vnd.airzip.filesecure.azf": [
        "azf"
    ],
    "application/vnd.airzip.filesecure.azs": [
        "azs"
    ],
    "application/vnd.amazon.ebook": [
        "azw"
    ],
    "application/vnd.americandynamics.acc": [
        "acc"
    ],
    "application/vnd.amiga.ami": [
        "ami"
    ],
    "application/vnd.android.package-archive": [
        "apk"
    ],
    "application/vnd.anser-web-certificate-issue-initiation": [
        "cii"
    ],
    "application/vnd.anser-web-funds-transfer-initiation": [
        "fti"
    ],
    "application/vnd.antix.game-component": [
        "atx"
    ],
    "application/vnd.apple.installer+xml": [
        "mpkg"
    ],
    "application/vnd.apple.keynote": [
        "key"
    ],
    "application/vnd.apple.mpegurl": [
        "m3u8"
    ],
    "application/vnd.apple.numbers": [
        "numbers"
    ],
    "application/vnd.apple.pages": [
        "pages"
    ],
    "application/vnd.apple.pkpass": [
        "pkpass"
    ],
    "application/vnd.aristanetworks.swi": [
        "swi"
    ],
    "application/vnd.astraea-software.iota": [
        "iota"
    ],
    "application/vnd.audiograph": [
        "aep"
    ],
    "application/vnd.balsamiq.bmml+xml": [
        "bmml"
    ],
    "application/vnd.blueice.multipass": [
        "mpm"
    ],
    "application/vnd.bmi": [
        "bmi"
    ],
    "application/vnd.businessobjects": [
        "rep"
    ],
    "application/vnd.chemdraw+xml": [
        "cdxml"
    ],
    "application/vnd.chipnuts.karaoke-mmd": [
        "mmd"
    ],
    "application/vnd.cinderella": [
        "cdy"
    ],
    "application/vnd.citationstyles.style+xml": [
        "csl"
    ],
    "application/vnd.claymore": [
        "cla"
    ],
    "application/vnd.cloanto.rp9": [
        "rp9"
    ],
    "application/vnd.clonk.c4group": [
        "c4g",
        "c4d",
        "c4f",
        "c4p",
        "c4u"
    ],
    "application/vnd.cluetrust.cartomobile-config": [
        "c11amc"
    ],
    "application/vnd.cluetrust.cartomobile-config-pkg": [
        "c11amz"
    ],
    "application/vnd.commonspace": [
        "csp"
    ],
    "application/vnd.contact.cmsg": [
        "cdbcmsg"
    ],
    "application/vnd.cosmocaller": [
        "cmc"
    ],
    "application/vnd.crick.clicker": [
        "clkx"
    ],
    "application/vnd.crick.clicker.keyboard": [
        "clkk"
    ],
    "application/vnd.crick.clicker.palette": [
        "clkp"
    ],
    "application/vnd.crick.clicker.template": [
        "clkt"
    ],
    "application/vnd.crick.clicker.wordbank": [
        "clkw"
    ],
    "application/vnd.criticaltools.wbs+xml": [
        "wbs"
    ],
    "application/vnd.ctc-posml": [
        "pml"
    ],
    "application/vnd.cups-ppd": [
        "ppd"
    ],
    "application/vnd.curl.car": [
        "car"
    ],
    "application/vnd.curl.pcurl": [
        "pcurl"
    ],
    "application/vnd.dart": [
        "dart"
    ],
    "application/vnd.data-vision.rdz": [
        "rdz"
    ],
    "application/vnd.dbf": [
        "dbf"
    ],
    "application/vnd.dece.data": [
        "uvf",
        "uvvf",
        "uvd",
        "uvvd"
    ],
    "application/vnd.dece.ttml+xml": [
        "uvt",
        "uvvt"
    ],
    "application/vnd.dece.unspecified": [
        "uvx",
        "uvvx"
    ],
    "application/vnd.dece.zip": [
        "uvz",
        "uvvz"
    ],
    "application/vnd.denovo.fcselayout-link": [
        "fe_launch"
    ],
    "application/vnd.dna": [
        "dna"
    ],
    "application/vnd.dolby.mlp": [
        "mlp"
    ],
    "application/vnd.dpgraph": [
        "dpg"
    ],
    "application/vnd.dreamfactory": [
        "dfac"
    ],
    "application/vnd.ds-keypoint": [
        "kpxx"
    ],
    "application/vnd.dvb.ait": [
        "ait"
    ],
    "application/vnd.dvb.service": [
        "svc"
    ],
    "application/vnd.dynageo": [
        "geo"
    ],
    "application/vnd.ecowin.chart": [
        "mag"
    ],
    "application/vnd.enliven": [
        "nml"
    ],
    "application/vnd.epson.esf": [
        "esf"
    ],
    "application/vnd.epson.msf": [
        "msf"
    ],
    "application/vnd.epson.quickanime": [
        "qam"
    ],
    "application/vnd.epson.salt": [
        "slt"
    ],
    "application/vnd.epson.ssf": [
        "ssf"
    ],
    "application/vnd.eszigno3+xml": [
        "es3",
        "et3"
    ],
    "application/vnd.ezpix-album": [
        "ez2"
    ],
    "application/vnd.ezpix-package": [
        "ez3"
    ],
    "application/vnd.fdf": [
        "fdf"
    ],
    "application/vnd.fdsn.mseed": [
        "mseed"
    ],
    "application/vnd.fdsn.seed": [
        "seed",
        "dataless"
    ],
    "application/vnd.flographit": [
        "gph"
    ],
    "application/vnd.fluxtime.clip": [
        "ftc"
    ],
    "application/vnd.framemaker": [
        "fm",
        "frame",
        "maker",
        "book"
    ],
    "application/vnd.frogans.fnc": [
        "fnc"
    ],
    "application/vnd.frogans.ltf": [
        "ltf"
    ],
    "application/vnd.fsc.weblaunch": [
        "fsc"
    ],
    "application/vnd.fujitsu.oasys": [
        "oas"
    ],
    "application/vnd.fujitsu.oasys2": [
        "oa2"
    ],
    "application/vnd.fujitsu.oasys3": [
        "oa3"
    ],
    "application/vnd.fujitsu.oasysgp": [
        "fg5"
    ],
    "application/vnd.fujitsu.oasysprs": [
        "bh2"
    ],
    "application/vnd.fujixerox.ddd": [
        "ddd"
    ],
    "application/vnd.fujixerox.docuworks": [
        "xdw"
    ],
    "application/vnd.fujixerox.docuworks.binder": [
        "xbd"
    ],
    "application/vnd.fuzzysheet": [
        "fzs"
    ],
    "application/vnd.genomatix.tuxedo": [
        "txd"
    ],
    "application/vnd.geogebra.file": [
        "ggb"
    ],
    "application/vnd.geogebra.tool": [
        "ggt"
    ],
    "application/vnd.geometry-explorer": [
        "gex",
        "gre"
    ],
    "application/vnd.geonext": [
        "gxt"
    ],
    "application/vnd.geoplan": [
        "g2w"
    ],
    "application/vnd.geospace": [
        "g3w"
    ],
    "application/vnd.gmx": [
        "gmx"
    ],
    "application/vnd.google-apps.document": [
        "gdoc"
    ],
    "application/vnd.google-apps.presentation": [
        "gslides"
    ],
    "application/vnd.google-apps.spreadsheet": [
        "gsheet"
    ],
    "application/vnd.google-earth.kml+xml": [
        "kml"
    ],
    "application/vnd.google-earth.kmz": [
        "kmz"
    ],
    "application/vnd.grafeq": [
        "gqf",
        "gqs"
    ],
    "application/vnd.groove-account": [
        "gac"
    ],
    "application/vnd.groove-help": [
        "ghf"
    ],
    "application/vnd.groove-identity-message": [
        "gim"
    ],
    "application/vnd.groove-injector": [
        "grv"
    ],
    "application/vnd.groove-tool-message": [
        "gtm"
    ],
    "application/vnd.groove-tool-template": [
        "tpl"
    ],
    "application/vnd.groove-vcard": [
        "vcg"
    ],
    "application/vnd.hal+xml": [
        "hal"
    ],
    "application/vnd.handheld-entertainment+xml": [
        "zmm"
    ],
    "application/vnd.hbci": [
        "hbci"
    ],
    "application/vnd.hhe.lesson-player": [
        "les"
    ],
    "application/vnd.hp-hpgl": [
        "hpgl"
    ],
    "application/vnd.hp-hpid": [
        "hpid"
    ],
    "application/vnd.hp-hps": [
        "hps"
    ],
    "application/vnd.hp-jlyt": [
        "jlt"
    ],
    "application/vnd.hp-pcl": [
        "pcl"
    ],
    "application/vnd.hp-pclxl": [
        "pclxl"
    ],
    "application/vnd.hydrostatix.sof-data": [
        "sfd-hdstx"
    ],
    "application/vnd.ibm.minipay": [
        "mpy"
    ],
    "application/vnd.ibm.modcap": [
        "afp",
        "listafp",
        "list3820"
    ],
    "application/vnd.ibm.rights-management": [
        "irm"
    ],
    "application/vnd.ibm.secure-container": [
        "sc"
    ],
    "application/vnd.iccprofile": [
        "icc",
        "icm"
    ],
    "application/vnd.igloader": [
        "igl"
    ],
    "application/vnd.immervision-ivp": [
        "ivp"
    ],
    "application/vnd.immervision-ivu": [
        "ivu"
    ],
    "application/vnd.insors.igm": [
        "igm"
    ],
    "application/vnd.intercon.formnet": [
        "xpw",
        "xpx"
    ],
    "application/vnd.intergeo": [
        "i2g"
    ],
    "application/vnd.intu.qbo": [
        "qbo"
    ],
    "application/vnd.intu.qfx": [
        "qfx"
    ],
    "application/vnd.ipunplugged.rcprofile": [
        "rcprofile"
    ],
    "application/vnd.irepository.package+xml": [
        "irp"
    ],
    "application/vnd.is-xpr": [
        "xpr"
    ],
    "application/vnd.isac.fcs": [
        "fcs"
    ],
    "application/vnd.jam": [
        "jam"
    ],
    "application/vnd.jcp.javame.midlet-rms": [
        "rms"
    ],
    "application/vnd.jisp": [
        "jisp"
    ],
    "application/vnd.joost.joda-archive": [
        "joda"
    ],
    "application/vnd.kahootz": [
        "ktz",
        "ktr"
    ],
    "application/vnd.kde.karbon": [
        "karbon"
    ],
    "application/vnd.kde.kchart": [
        "chrt"
    ],
    "application/vnd.kde.kformula": [
        "kfo"
    ],
    "application/vnd.kde.kivio": [
        "flw"
    ],
    "application/vnd.kde.kontour": [
        "kon"
    ],
    "application/vnd.kde.kpresenter": [
        "kpr",
        "kpt"
    ],
    "application/vnd.kde.kspread": [
        "ksp"
    ],
    "application/vnd.kde.kword": [
        "kwd",
        "kwt"
    ],
    "application/vnd.kenameaapp": [
        "htke"
    ],
    "application/vnd.kidspiration": [
        "kia"
    ],
    "application/vnd.kinar": [
        "kne",
        "knp"
    ],
    "application/vnd.koan": [
        "skp",
        "skd",
        "skt",
        "skm"
    ],
    "application/vnd.kodak-descriptor": [
        "sse"
    ],
    "application/vnd.las.las+xml": [
        "lasxml"
    ],
    "application/vnd.llamagraphics.life-balance.desktop": [
        "lbd"
    ],
    "application/vnd.llamagraphics.life-balance.exchange+xml": [
        "lbe"
    ],
    "application/vnd.lotus-1-2-3": [
        "123"
    ],
    "application/vnd.lotus-approach": [
        "apr"
    ],
    "application/vnd.lotus-freelance": [
        "pre"
    ],
    "application/vnd.lotus-notes": [
        "nsf"
    ],
    "application/vnd.lotus-organizer": [
        "org"
    ],
    "application/vnd.lotus-screencam": [
        "scm"
    ],
    "application/vnd.lotus-wordpro": [
        "lwp"
    ],
    "application/vnd.macports.portpkg": [
        "portpkg"
    ],
    "application/vnd.mapbox-vector-tile": [
        "mvt"
    ],
    "application/vnd.mcd": [
        "mcd"
    ],
    "application/vnd.medcalcdata": [
        "mc1"
    ],
    "application/vnd.mediastation.cdkey": [
        "cdkey"
    ],
    "application/vnd.mfer": [
        "mwf"
    ],
    "application/vnd.mfmp": [
        "mfm"
    ],
    "application/vnd.micrografx.flo": [
        "flo"
    ],
    "application/vnd.micrografx.igx": [
        "igx"
    ],
    "application/vnd.mif": [
        "mif"
    ],
    "application/vnd.mobius.daf": [
        "daf"
    ],
    "application/vnd.mobius.dis": [
        "dis"
    ],
    "application/vnd.mobius.mbk": [
        "mbk"
    ],
    "application/vnd.mobius.mqy": [
        "mqy"
    ],
    "application/vnd.mobius.msl": [
        "msl"
    ],
    "application/vnd.mobius.plc": [
        "plc"
    ],
    "application/vnd.mobius.txf": [
        "txf"
    ],
    "application/vnd.mophun.application": [
        "mpn"
    ],
    "application/vnd.mophun.certificate": [
        "mpc"
    ],
    "application/vnd.mozilla.xul+xml": [
        "xul"
    ],
    "application/vnd.ms-artgalry": [
        "cil"
    ],
    "application/vnd.ms-cab-compressed": [
        "cab"
    ],
    "application/vnd.ms-excel": [
        "xls",
        "xlm",
        "xla",
        "xlc",
        "xlt",
        "xlw"
    ],
    "application/vnd.ms-excel.addin.macroenabled.12": [
        "xlam"
    ],
    "application/vnd.ms-excel.sheet.binary.macroenabled.12": [
        "xlsb"
    ],
    "application/vnd.ms-excel.sheet.macroenabled.12": [
        "xlsm"
    ],
    "application/vnd.ms-excel.template.macroenabled.12": [
        "xltm"
    ],
    "application/vnd.ms-fontobject": [
        "eot"
    ],
    "application/vnd.ms-htmlhelp": [
        "chm"
    ],
    "application/vnd.ms-ims": [
        "ims"
    ],
    "application/vnd.ms-lrm": [
        "lrm"
    ],
    "application/vnd.ms-officetheme": [
        "thmx"
    ],
    "application/vnd.ms-outlook": [
        "msg"
    ],
    "application/vnd.ms-pki.seccat": [
        "cat"
    ],
    "application/vnd.ms-pki.stl": [
        "*stl"
    ],
    "application/vnd.ms-powerpoint": [
        "ppt",
        "pps",
        "pot"
    ],
    "application/vnd.ms-powerpoint.addin.macroenabled.12": [
        "ppam"
    ],
    "application/vnd.ms-powerpoint.presentation.macroenabled.12": [
        "pptm"
    ],
    "application/vnd.ms-powerpoint.slide.macroenabled.12": [
        "sldm"
    ],
    "application/vnd.ms-powerpoint.slideshow.macroenabled.12": [
        "ppsm"
    ],
    "application/vnd.ms-powerpoint.template.macroenabled.12": [
        "potm"
    ],
    "application/vnd.ms-project": [
        "mpp",
        "mpt"
    ],
    "application/vnd.ms-word.document.macroenabled.12": [
        "docm"
    ],
    "application/vnd.ms-word.template.macroenabled.12": [
        "dotm"
    ],
    "application/vnd.ms-works": [
        "wps",
        "wks",
        "wcm",
        "wdb"
    ],
    "application/vnd.ms-wpl": [
        "wpl"
    ],
    "application/vnd.ms-xpsdocument": [
        "xps"
    ],
    "application/vnd.mseq": [
        "mseq"
    ],
    "application/vnd.musician": [
        "mus"
    ],
    "application/vnd.muvee.style": [
        "msty"
    ],
    "application/vnd.mynfc": [
        "taglet"
    ],
    "application/vnd.neurolanguage.nlu": [
        "nlu"
    ],
    "application/vnd.nitf": [
        "ntf",
        "nitf"
    ],
    "application/vnd.noblenet-directory": [
        "nnd"
    ],
    "application/vnd.noblenet-sealer": [
        "nns"
    ],
    "application/vnd.noblenet-web": [
        "nnw"
    ],
    "application/vnd.nokia.n-gage.ac+xml": [
        "*ac"
    ],
    "application/vnd.nokia.n-gage.data": [
        "ngdat"
    ],
    "application/vnd.nokia.n-gage.symbian.install": [
        "n-gage"
    ],
    "application/vnd.nokia.radio-preset": [
        "rpst"
    ],
    "application/vnd.nokia.radio-presets": [
        "rpss"
    ],
    "application/vnd.novadigm.edm": [
        "edm"
    ],
    "application/vnd.novadigm.edx": [
        "edx"
    ],
    "application/vnd.novadigm.ext": [
        "ext"
    ],
    "application/vnd.oasis.opendocument.chart": [
        "odc"
    ],
    "application/vnd.oasis.opendocument.chart-template": [
        "otc"
    ],
    "application/vnd.oasis.opendocument.database": [
        "odb"
    ],
    "application/vnd.oasis.opendocument.formula": [
        "odf"
    ],
    "application/vnd.oasis.opendocument.formula-template": [
        "odft"
    ],
    "application/vnd.oasis.opendocument.graphics": [
        "odg"
    ],
    "application/vnd.oasis.opendocument.graphics-template": [
        "otg"
    ],
    "application/vnd.oasis.opendocument.image": [
        "odi"
    ],
    "application/vnd.oasis.opendocument.image-template": [
        "oti"
    ],
    "application/vnd.oasis.opendocument.presentation": [
        "odp"
    ],
    "application/vnd.oasis.opendocument.presentation-template": [
        "otp"
    ],
    "application/vnd.oasis.opendocument.spreadsheet": [
        "ods"
    ],
    "application/vnd.oasis.opendocument.spreadsheet-template": [
        "ots"
    ],
    "application/vnd.oasis.opendocument.text": [
        "odt"
    ],
    "application/vnd.oasis.opendocument.text-master": [
        "odm"
    ],
    "application/vnd.oasis.opendocument.text-template": [
        "ott"
    ],
    "application/vnd.oasis.opendocument.text-web": [
        "oth"
    ],
    "application/vnd.olpc-sugar": [
        "xo"
    ],
    "application/vnd.oma.dd2+xml": [
        "dd2"
    ],
    "application/vnd.openblox.game+xml": [
        "obgx"
    ],
    "application/vnd.openofficeorg.extension": [
        "oxt"
    ],
    "application/vnd.openstreetmap.data+xml": [
        "osm"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": [
        "pptx"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.slide": [
        "sldx"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.slideshow": [
        "ppsx"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.template": [
        "potx"
    ],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        "xlsx"
    ],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template": [
        "xltx"
    ],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
        "docx"
    ],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.template": [
        "dotx"
    ],
    "application/vnd.osgeo.mapguide.package": [
        "mgp"
    ],
    "application/vnd.osgi.dp": [
        "dp"
    ],
    "application/vnd.osgi.subsystem": [
        "esa"
    ],
    "application/vnd.palm": [
        "pdb",
        "pqa",
        "oprc"
    ],
    "application/vnd.pawaafile": [
        "paw"
    ],
    "application/vnd.pg.format": [
        "str"
    ],
    "application/vnd.pg.osasli": [
        "ei6"
    ],
    "application/vnd.picsel": [
        "efif"
    ],
    "application/vnd.pmi.widget": [
        "wg"
    ],
    "application/vnd.pocketlearn": [
        "plf"
    ],
    "application/vnd.powerbuilder6": [
        "pbd"
    ],
    "application/vnd.previewsystems.box": [
        "box"
    ],
    "application/vnd.proteus.magazine": [
        "mgz"
    ],
    "application/vnd.publishare-delta-tree": [
        "qps"
    ],
    "application/vnd.pvi.ptid1": [
        "ptid"
    ],
    "application/vnd.quark.quarkxpress": [
        "qxd",
        "qxt",
        "qwd",
        "qwt",
        "qxl",
        "qxb"
    ],
    "application/vnd.rar": [
        "rar"
    ],
    "application/vnd.realvnc.bed": [
        "bed"
    ],
    "application/vnd.recordare.musicxml": [
        "mxl"
    ],
    "application/vnd.recordare.musicxml+xml": [
        "musicxml"
    ],
    "application/vnd.rig.cryptonote": [
        "cryptonote"
    ],
    "application/vnd.rim.cod": [
        "cod"
    ],
    "application/vnd.rn-realmedia": [
        "rm"
    ],
    "application/vnd.rn-realmedia-vbr": [
        "rmvb"
    ],
    "application/vnd.route66.link66+xml": [
        "link66"
    ],
    "application/vnd.sailingtracker.track": [
        "st"
    ],
    "application/vnd.seemail": [
        "see"
    ],
    "application/vnd.sema": [
        "sema"
    ],
    "application/vnd.semd": [
        "semd"
    ],
    "application/vnd.semf": [
        "semf"
    ],
    "application/vnd.shana.informed.formdata": [
        "ifm"
    ],
    "application/vnd.shana.informed.formtemplate": [
        "itp"
    ],
    "application/vnd.shana.informed.interchange": [
        "iif"
    ],
    "application/vnd.shana.informed.package": [
        "ipk"
    ],
    "application/vnd.simtech-mindmapper": [
        "twd",
        "twds"
    ],
    "application/vnd.smaf": [
        "mmf"
    ],
    "application/vnd.smart.teacher": [
        "teacher"
    ],
    "application/vnd.software602.filler.form+xml": [
        "fo"
    ],
    "application/vnd.solent.sdkm+xml": [
        "sdkm",
        "sdkd"
    ],
    "application/vnd.spotfire.dxp": [
        "dxp"
    ],
    "application/vnd.spotfire.sfs": [
        "sfs"
    ],
    "application/vnd.stardivision.calc": [
        "sdc"
    ],
    "application/vnd.stardivision.draw": [
        "sda"
    ],
    "application/vnd.stardivision.impress": [
        "sdd"
    ],
    "application/vnd.stardivision.math": [
        "smf"
    ],
    "application/vnd.stardivision.writer": [
        "sdw",
        "vor"
    ],
    "application/vnd.stardivision.writer-global": [
        "sgl"
    ],
    "application/vnd.stepmania.package": [
        "smzip"
    ],
    "application/vnd.stepmania.stepchart": [
        "sm"
    ],
    "application/vnd.sun.wadl+xml": [
        "wadl"
    ],
    "application/vnd.sun.xml.calc": [
        "sxc"
    ],
    "application/vnd.sun.xml.calc.template": [
        "stc"
    ],
    "application/vnd.sun.xml.draw": [
        "sxd"
    ],
    "application/vnd.sun.xml.draw.template": [
        "std"
    ],
    "application/vnd.sun.xml.impress": [
        "sxi"
    ],
    "application/vnd.sun.xml.impress.template": [
        "sti"
    ],
    "application/vnd.sun.xml.math": [
        "sxm"
    ],
    "application/vnd.sun.xml.writer": [
        "sxw"
    ],
    "application/vnd.sun.xml.writer.global": [
        "sxg"
    ],
    "application/vnd.sun.xml.writer.template": [
        "stw"
    ],
    "application/vnd.sus-calendar": [
        "sus",
        "susp"
    ],
    "application/vnd.svd": [
        "svd"
    ],
    "application/vnd.symbian.install": [
        "sis",
        "sisx"
    ],
    "application/vnd.syncml+xml": [
        "xsm"
    ],
    "application/vnd.syncml.dm+wbxml": [
        "bdm"
    ],
    "application/vnd.syncml.dm+xml": [
        "xdm"
    ],
    "application/vnd.syncml.dmddf+xml": [
        "ddf"
    ],
    "application/vnd.tao.intent-module-archive": [
        "tao"
    ],
    "application/vnd.tcpdump.pcap": [
        "pcap",
        "cap",
        "dmp"
    ],
    "application/vnd.tmobile-livetv": [
        "tmo"
    ],
    "application/vnd.trid.tpt": [
        "tpt"
    ],
    "application/vnd.triscape.mxs": [
        "mxs"
    ],
    "application/vnd.trueapp": [
        "tra"
    ],
    "application/vnd.ufdl": [
        "ufd",
        "ufdl"
    ],
    "application/vnd.uiq.theme": [
        "utz"
    ],
    "application/vnd.umajin": [
        "umj"
    ],
    "application/vnd.unity": [
        "unityweb"
    ],
    "application/vnd.uoml+xml": [
        "uoml"
    ],
    "application/vnd.vcx": [
        "vcx"
    ],
    "application/vnd.visio": [
        "vsd",
        "vst",
        "vss",
        "vsw"
    ],
    "application/vnd.visionary": [
        "vis"
    ],
    "application/vnd.vsf": [
        "vsf"
    ],
    "application/vnd.wap.wbxml": [
        "wbxml"
    ],
    "application/vnd.wap.wmlc": [
        "wmlc"
    ],
    "application/vnd.wap.wmlscriptc": [
        "wmlsc"
    ],
    "application/vnd.webturbo": [
        "wtb"
    ],
    "application/vnd.wolfram.player": [
        "nbp"
    ],
    "application/vnd.wordperfect": [
        "wpd"
    ],
    "application/vnd.wqd": [
        "wqd"
    ],
    "application/vnd.wt.stf": [
        "stf"
    ],
    "application/vnd.xara": [
        "xar"
    ],
    "application/vnd.xfdl": [
        "xfdl"
    ],
    "application/vnd.yamaha.hv-dic": [
        "hvd"
    ],
    "application/vnd.yamaha.hv-script": [
        "hvs"
    ],
    "application/vnd.yamaha.hv-voice": [
        "hvp"
    ],
    "application/vnd.yamaha.openscoreformat": [
        "osf"
    ],
    "application/vnd.yamaha.openscoreformat.osfpvg+xml": [
        "osfpvg"
    ],
    "application/vnd.yamaha.smaf-audio": [
        "saf"
    ],
    "application/vnd.yamaha.smaf-phrase": [
        "spf"
    ],
    "application/vnd.yellowriver-custom-menu": [
        "cmp"
    ],
    "application/vnd.zul": [
        "zir",
        "zirz"
    ],
    "application/vnd.zzazz.deck+xml": [
        "zaz"
    ],
    "application/x-7z-compressed": [
        "7z"
    ],
    "application/x-abiword": [
        "abw"
    ],
    "application/x-ace-compressed": [
        "ace"
    ],
    "application/x-apple-diskimage": [
        "*dmg"
    ],
    "application/x-arj": [
        "arj"
    ],
    "application/x-authorware-bin": [
        "aab",
        "x32",
        "u32",
        "vox"
    ],
    "application/x-authorware-map": [
        "aam"
    ],
    "application/x-authorware-seg": [
        "aas"
    ],
    "application/x-bcpio": [
        "bcpio"
    ],
    "application/x-bdoc": [
        "*bdoc"
    ],
    "application/x-bittorrent": [
        "torrent"
    ],
    "application/x-blorb": [
        "blb",
        "blorb"
    ],
    "application/x-bzip": [
        "bz"
    ],
    "application/x-bzip2": [
        "bz2",
        "boz"
    ],
    "application/x-cbr": [
        "cbr",
        "cba",
        "cbt",
        "cbz",
        "cb7"
    ],
    "application/x-cdlink": [
        "vcd"
    ],
    "application/x-cfs-compressed": [
        "cfs"
    ],
    "application/x-chat": [
        "chat"
    ],
    "application/x-chess-pgn": [
        "pgn"
    ],
    "application/x-chrome-extension": [
        "crx"
    ],
    "application/x-cocoa": [
        "cco"
    ],
    "application/x-conference": [
        "nsc"
    ],
    "application/x-cpio": [
        "cpio"
    ],
    "application/x-csh": [
        "csh"
    ],
    "application/x-debian-package": [
        "*deb",
        "udeb"
    ],
    "application/x-dgc-compressed": [
        "dgc"
    ],
    "application/x-director": [
        "dir",
        "dcr",
        "dxr",
        "cst",
        "cct",
        "cxt",
        "w3d",
        "fgd",
        "swa"
    ],
    "application/x-doom": [
        "wad"
    ],
    "application/x-dtbncx+xml": [
        "ncx"
    ],
    "application/x-dtbook+xml": [
        "dtb"
    ],
    "application/x-dtbresource+xml": [
        "res"
    ],
    "application/x-dvi": [
        "dvi"
    ],
    "application/x-envoy": [
        "evy"
    ],
    "application/x-eva": [
        "eva"
    ],
    "application/x-font-bdf": [
        "bdf"
    ],
    "application/x-font-ghostscript": [
        "gsf"
    ],
    "application/x-font-linux-psf": [
        "psf"
    ],
    "application/x-font-pcf": [
        "pcf"
    ],
    "application/x-font-snf": [
        "snf"
    ],
    "application/x-font-type1": [
        "pfa",
        "pfb",
        "pfm",
        "afm"
    ],
    "application/x-freearc": [
        "arc"
    ],
    "application/x-futuresplash": [
        "spl"
    ],
    "application/x-gca-compressed": [
        "gca"
    ],
    "application/x-glulx": [
        "ulx"
    ],
    "application/x-gnumeric": [
        "gnumeric"
    ],
    "application/x-gramps-xml": [
        "gramps"
    ],
    "application/x-gtar": [
        "gtar"
    ],
    "application/x-hdf": [
        "hdf"
    ],
    "application/x-httpd-php": [
        "php"
    ],
    "application/x-install-instructions": [
        "install"
    ],
    "application/x-iso9660-image": [
        "*iso"
    ],
    "application/x-iwork-keynote-sffkey": [
        "*key"
    ],
    "application/x-iwork-numbers-sffnumbers": [
        "*numbers"
    ],
    "application/x-iwork-pages-sffpages": [
        "*pages"
    ],
    "application/x-java-archive-diff": [
        "jardiff"
    ],
    "application/x-java-jnlp-file": [
        "jnlp"
    ],
    "application/x-keepass2": [
        "kdbx"
    ],
    "application/x-latex": [
        "latex"
    ],
    "application/x-lua-bytecode": [
        "luac"
    ],
    "application/x-lzh-compressed": [
        "lzh",
        "lha"
    ],
    "application/x-makeself": [
        "run"
    ],
    "application/x-mie": [
        "mie"
    ],
    "application/x-mobipocket-ebook": [
        "prc",
        "mobi"
    ],
    "application/x-ms-application": [
        "application"
    ],
    "application/x-ms-shortcut": [
        "lnk"
    ],
    "application/x-ms-wmd": [
        "wmd"
    ],
    "application/x-ms-wmz": [
        "wmz"
    ],
    "application/x-ms-xbap": [
        "xbap"
    ],
    "application/x-msaccess": [
        "mdb"
    ],
    "application/x-msbinder": [
        "obd"
    ],
    "application/x-mscardfile": [
        "crd"
    ],
    "application/x-msclip": [
        "clp"
    ],
    "application/x-msdos-program": [
        "*exe"
    ],
    "application/x-msdownload": [
        "*exe",
        "*dll",
        "com",
        "bat",
        "*msi"
    ],
    "application/x-msmediaview": [
        "mvb",
        "m13",
        "m14"
    ],
    "application/x-msmetafile": [
        "*wmf",
        "*wmz",
        "*emf",
        "emz"
    ],
    "application/x-msmoney": [
        "mny"
    ],
    "application/x-mspublisher": [
        "pub"
    ],
    "application/x-msschedule": [
        "scd"
    ],
    "application/x-msterminal": [
        "trm"
    ],
    "application/x-mswrite": [
        "wri"
    ],
    "application/x-netcdf": [
        "nc",
        "cdf"
    ],
    "application/x-ns-proxy-autoconfig": [
        "pac"
    ],
    "application/x-nzb": [
        "nzb"
    ],
    "application/x-perl": [
        "pl",
        "pm"
    ],
    "application/x-pilot": [
        "*prc",
        "*pdb"
    ],
    "application/x-pkcs12": [
        "p12",
        "pfx"
    ],
    "application/x-pkcs7-certificates": [
        "p7b",
        "spc"
    ],
    "application/x-pkcs7-certreqresp": [
        "p7r"
    ],
    "application/x-rar-compressed": [
        "*rar"
    ],
    "application/x-redhat-package-manager": [
        "rpm"
    ],
    "application/x-research-info-systems": [
        "ris"
    ],
    "application/x-sea": [
        "sea"
    ],
    "application/x-sh": [
        "sh"
    ],
    "application/x-shar": [
        "shar"
    ],
    "application/x-shockwave-flash": [
        "swf"
    ],
    "application/x-silverlight-app": [
        "xap"
    ],
    "application/x-sql": [
        "sql"
    ],
    "application/x-stuffit": [
        "sit"
    ],
    "application/x-stuffitx": [
        "sitx"
    ],
    "application/x-subrip": [
        "srt"
    ],
    "application/x-sv4cpio": [
        "sv4cpio"
    ],
    "application/x-sv4crc": [
        "sv4crc"
    ],
    "application/x-t3vm-image": [
        "t3"
    ],
    "application/x-tads": [
        "gam"
    ],
    "application/x-tar": [
        "tar"
    ],
    "application/x-tcl": [
        "tcl",
        "tk"
    ],
    "application/x-tex": [
        "tex"
    ],
    "application/x-tex-tfm": [
        "tfm"
    ],
    "application/x-texinfo": [
        "texinfo",
        "texi"
    ],
    "application/x-tgif": [
        "*obj"
    ],
    "application/x-ustar": [
        "ustar"
    ],
    "application/x-virtualbox-hdd": [
        "hdd"
    ],
    "application/x-virtualbox-ova": [
        "ova"
    ],
    "application/x-virtualbox-ovf": [
        "ovf"
    ],
    "application/x-virtualbox-vbox": [
        "vbox"
    ],
    "application/x-virtualbox-vbox-extpack": [
        "vbox-extpack"
    ],
    "application/x-virtualbox-vdi": [
        "vdi"
    ],
    "application/x-virtualbox-vhd": [
        "vhd"
    ],
    "application/x-virtualbox-vmdk": [
        "vmdk"
    ],
    "application/x-wais-source": [
        "src"
    ],
    "application/x-web-app-manifest+json": [
        "webapp"
    ],
    "application/x-x509-ca-cert": [
        "der",
        "crt",
        "pem"
    ],
    "application/x-xfig": [
        "fig"
    ],
    "application/x-xliff+xml": [
        "*xlf"
    ],
    "application/x-xpinstall": [
        "xpi"
    ],
    "application/x-xz": [
        "xz"
    ],
    "application/x-zmachine": [
        "z1",
        "z2",
        "z3",
        "z4",
        "z5",
        "z6",
        "z7",
        "z8"
    ],
    "audio/vnd.dece.audio": [
        "uva",
        "uvva"
    ],
    "audio/vnd.digital-winds": [
        "eol"
    ],
    "audio/vnd.dra": [
        "dra"
    ],
    "audio/vnd.dts": [
        "dts"
    ],
    "audio/vnd.dts.hd": [
        "dtshd"
    ],
    "audio/vnd.lucent.voice": [
        "lvp"
    ],
    "audio/vnd.ms-playready.media.pya": [
        "pya"
    ],
    "audio/vnd.nuera.ecelp4800": [
        "ecelp4800"
    ],
    "audio/vnd.nuera.ecelp7470": [
        "ecelp7470"
    ],
    "audio/vnd.nuera.ecelp9600": [
        "ecelp9600"
    ],
    "audio/vnd.rip": [
        "rip"
    ],
    "audio/x-aac": [
        "aac"
    ],
    "audio/x-aiff": [
        "aif",
        "aiff",
        "aifc"
    ],
    "audio/x-caf": [
        "caf"
    ],
    "audio/x-flac": [
        "flac"
    ],
    "audio/x-m4a": [
        "*m4a"
    ],
    "audio/x-matroska": [
        "mka"
    ],
    "audio/x-mpegurl": [
        "m3u"
    ],
    "audio/x-ms-wax": [
        "wax"
    ],
    "audio/x-ms-wma": [
        "wma"
    ],
    "audio/x-pn-realaudio": [
        "ram",
        "ra"
    ],
    "audio/x-pn-realaudio-plugin": [
        "rmp"
    ],
    "audio/x-realaudio": [
        "*ra"
    ],
    "audio/x-wav": [
        "*wav"
    ],
    "chemical/x-cdx": [
        "cdx"
    ],
    "chemical/x-cif": [
        "cif"
    ],
    "chemical/x-cmdf": [
        "cmdf"
    ],
    "chemical/x-cml": [
        "cml"
    ],
    "chemical/x-csml": [
        "csml"
    ],
    "chemical/x-xyz": [
        "xyz"
    ],
    "image/prs.btif": [
        "btif"
    ],
    "image/prs.pti": [
        "pti"
    ],
    "image/vnd.adobe.photoshop": [
        "psd"
    ],
    "image/vnd.airzip.accelerator.azv": [
        "azv"
    ],
    "image/vnd.dece.graphic": [
        "uvi",
        "uvvi",
        "uvg",
        "uvvg"
    ],
    "image/vnd.djvu": [
        "djvu",
        "djv"
    ],
    "image/vnd.dvb.subtitle": [
        "*sub"
    ],
    "image/vnd.dwg": [
        "dwg"
    ],
    "image/vnd.dxf": [
        "dxf"
    ],
    "image/vnd.fastbidsheet": [
        "fbs"
    ],
    "image/vnd.fpx": [
        "fpx"
    ],
    "image/vnd.fst": [
        "fst"
    ],
    "image/vnd.fujixerox.edmics-mmr": [
        "mmr"
    ],
    "image/vnd.fujixerox.edmics-rlc": [
        "rlc"
    ],
    "image/vnd.microsoft.icon": [
        "ico"
    ],
    "image/vnd.ms-dds": [
        "dds"
    ],
    "image/vnd.ms-modi": [
        "mdi"
    ],
    "image/vnd.ms-photo": [
        "wdp"
    ],
    "image/vnd.net-fpx": [
        "npx"
    ],
    "image/vnd.pco.b16": [
        "b16"
    ],
    "image/vnd.tencent.tap": [
        "tap"
    ],
    "image/vnd.valve.source.texture": [
        "vtf"
    ],
    "image/vnd.wap.wbmp": [
        "wbmp"
    ],
    "image/vnd.xiff": [
        "xif"
    ],
    "image/vnd.zbrush.pcx": [
        "pcx"
    ],
    "image/x-3ds": [
        "3ds"
    ],
    "image/x-cmu-raster": [
        "ras"
    ],
    "image/x-cmx": [
        "cmx"
    ],
    "image/x-freehand": [
        "fh",
        "fhc",
        "fh4",
        "fh5",
        "fh7"
    ],
    "image/x-icon": [
        "*ico"
    ],
    "image/x-jng": [
        "jng"
    ],
    "image/x-mrsid-image": [
        "sid"
    ],
    "image/x-ms-bmp": [
        "*bmp"
    ],
    "image/x-pcx": [
        "*pcx"
    ],
    "image/x-pict": [
        "pic",
        "pct"
    ],
    "image/x-portable-anymap": [
        "pnm"
    ],
    "image/x-portable-bitmap": [
        "pbm"
    ],
    "image/x-portable-graymap": [
        "pgm"
    ],
    "image/x-portable-pixmap": [
        "ppm"
    ],
    "image/x-rgb": [
        "rgb"
    ],
    "image/x-tga": [
        "tga"
    ],
    "image/x-xbitmap": [
        "xbm"
    ],
    "image/x-xpixmap": [
        "xpm"
    ],
    "image/x-xwindowdump": [
        "xwd"
    ],
    "message/vnd.wfa.wsc": [
        "wsc"
    ],
    "model/vnd.collada+xml": [
        "dae"
    ],
    "model/vnd.dwf": [
        "dwf"
    ],
    "model/vnd.gdl": [
        "gdl"
    ],
    "model/vnd.gtw": [
        "gtw"
    ],
    "model/vnd.mts": [
        "mts"
    ],
    "model/vnd.opengex": [
        "ogex"
    ],
    "model/vnd.parasolid.transmit.binary": [
        "x_b"
    ],
    "model/vnd.parasolid.transmit.text": [
        "x_t"
    ],
    "model/vnd.sap.vds": [
        "vds"
    ],
    "model/vnd.usdz+zip": [
        "usdz"
    ],
    "model/vnd.valve.source.compiled-map": [
        "bsp"
    ],
    "model/vnd.vtu": [
        "vtu"
    ],
    "text/prs.lines.tag": [
        "dsc"
    ],
    "text/vnd.curl": [
        "curl"
    ],
    "text/vnd.curl.dcurl": [
        "dcurl"
    ],
    "text/vnd.curl.mcurl": [
        "mcurl"
    ],
    "text/vnd.curl.scurl": [
        "scurl"
    ],
    "text/vnd.dvb.subtitle": [
        "sub"
    ],
    "text/vnd.fly": [
        "fly"
    ],
    "text/vnd.fmi.flexstor": [
        "flx"
    ],
    "text/vnd.graphviz": [
        "gv"
    ],
    "text/vnd.in3d.3dml": [
        "3dml"
    ],
    "text/vnd.in3d.spot": [
        "spot"
    ],
    "text/vnd.sun.j2me.app-descriptor": [
        "jad"
    ],
    "text/vnd.wap.wml": [
        "wml"
    ],
    "text/vnd.wap.wmlscript": [
        "wmls"
    ],
    "text/x-asm": [
        "s",
        "asm"
    ],
    "text/x-c": [
        "c",
        "cc",
        "cxx",
        "cpp",
        "h",
        "hh",
        "dic"
    ],
    "text/x-component": [
        "htc"
    ],
    "text/x-fortran": [
        "f",
        "for",
        "f77",
        "f90"
    ],
    "text/x-handlebars-template": [
        "hbs"
    ],
    "text/x-java-source": [
        "java"
    ],
    "text/x-lua": [
        "lua"
    ],
    "text/x-markdown": [
        "mkd"
    ],
    "text/x-nfo": [
        "nfo"
    ],
    "text/x-opml": [
        "opml"
    ],
    "text/x-org": [
        "*org"
    ],
    "text/x-pascal": [
        "p",
        "pas"
    ],
    "text/x-processing": [
        "pde"
    ],
    "text/x-sass": [
        "sass"
    ],
    "text/x-scss": [
        "scss"
    ],
    "text/x-setext": [
        "etx"
    ],
    "text/x-sfv": [
        "sfv"
    ],
    "text/x-suse-ymp": [
        "ymp"
    ],
    "text/x-uuencode": [
        "uu"
    ],
    "text/x-vcalendar": [
        "vcs"
    ],
    "text/x-vcard": [
        "vcf"
    ],
    "video/vnd.dece.hd": [
        "uvh",
        "uvvh"
    ],
    "video/vnd.dece.mobile": [
        "uvm",
        "uvvm"
    ],
    "video/vnd.dece.pd": [
        "uvp",
        "uvvp"
    ],
    "video/vnd.dece.sd": [
        "uvs",
        "uvvs"
    ],
    "video/vnd.dece.video": [
        "uvv",
        "uvvv"
    ],
    "video/vnd.dvb.file": [
        "dvb"
    ],
    "video/vnd.fvt": [
        "fvt"
    ],
    "video/vnd.mpegurl": [
        "mxu",
        "m4u"
    ],
    "video/vnd.ms-playready.media.pyv": [
        "pyv"
    ],
    "video/vnd.uvvu.mp4": [
        "uvu",
        "uvvu"
    ],
    "video/vnd.vivo": [
        "viv"
    ],
    "video/x-f4v": [
        "f4v"
    ],
    "video/x-fli": [
        "fli"
    ],
    "video/x-flv": [
        "flv"
    ],
    "video/x-m4v": [
        "m4v"
    ],
    "video/x-matroska": [
        "mkv",
        "mk3d",
        "mks"
    ],
    "video/x-mng": [
        "mng"
    ],
    "video/x-ms-asf": [
        "asf",
        "asx"
    ],
    "video/x-ms-vob": [
        "vob"
    ],
    "video/x-ms-wm": [
        "wm"
    ],
    "video/x-ms-wmv": [
        "wmv"
    ],
    "video/x-ms-wmx": [
        "wmx"
    ],
    "video/x-ms-wvx": [
        "wvx"
    ],
    "video/x-msvideo": [
        "avi"
    ],
    "video/x-sgi-movie": [
        "movie"
    ],
    "video/x-smv": [
        "smv"
    ],
    "x-conference/x-cooltalk": [
        "ice"
    ]
};

});


parcelRegister("blmL7", function(module, exports) {
"use strict";
var $84234f52bc032053$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $deMDi = parcelRequire("deMDi");
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */ function $84234f52bc032053$var$map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== 'function') throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
        return source.lift(new $84234f52bc032053$var$MapOperator(project, thisArg));
    };
}
module.exports.map = $84234f52bc032053$var$map;
var $84234f52bc032053$var$MapOperator = function() {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $84234f52bc032053$var$MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}();
module.exports.MapOperator = $84234f52bc032053$var$MapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $84234f52bc032053$var$MapSubscriber = function(_super) {
    $84234f52bc032053$var$__extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        _super.call(this, destination);
        this.project = project;
        this.count = 0;
        this.thisArg = thisArg || this;
    }
    // NOTE: This looks unoptimized, but it's actually purposefully NOT
    // using try/catch optimizations.
    MapSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}($deMDi.Subscriber);

});
parcelRegister("deMDi", function(module, exports) {
"use strict";
var $9a324e9e88280ef4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $4u8sc = parcelRequire("4u8sc");

var $lSgto = parcelRequire("lSgto");

var $5cSKU = parcelRequire("5cSKU");

var $efmvI = parcelRequire("efmvI");
/**
 * Implements the {@link Observer} interface and extends the
 * {@link Subscription} class. While the {@link Observer} is the public API for
 * consuming the values of an {@link Observable}, all Observers get converted to
 * a Subscriber, in order to provide Subscription-like capabilities such as
 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
 * implementing operators, but it is rarely used as a public API.
 *
 * @class Subscriber<T>
 */ var $9a324e9e88280ef4$var$Subscriber = function(_super) {
    $9a324e9e88280ef4$var$__extends(Subscriber, _super);
    /**
     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
     * defined Observer or a `next` callback function.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     */ function Subscriber(destinationOrNext, error, complete) {
        _super.call(this);
        this.syncErrorValue = null;
        this.syncErrorThrown = false;
        this.syncErrorThrowable = false;
        this.isStopped = false;
        switch(arguments.length){
            case 0:
                this.destination = $5cSKU.empty;
                break;
            case 1:
                if (!destinationOrNext) {
                    this.destination = $5cSKU.empty;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    // HACK(benlesh): To resolve an issue where Node users may have multiple
                    // copies of rxjs in their node_modules directory.
                    if ($9a324e9e88280ef4$var$isTrustedSubscriber(destinationOrNext)) {
                        var trustedSubscriber = destinationOrNext[$efmvI.rxSubscriber]();
                        this.syncErrorThrowable = trustedSubscriber.syncErrorThrowable;
                        this.destination = trustedSubscriber;
                        trustedSubscriber.add(this);
                    } else {
                        this.syncErrorThrowable = true;
                        this.destination = new $9a324e9e88280ef4$var$SafeSubscriber(this, destinationOrNext);
                    }
                    break;
                }
            default:
                this.syncErrorThrowable = true;
                this.destination = new $9a324e9e88280ef4$var$SafeSubscriber(this, destinationOrNext, error, complete);
                break;
        }
    }
    Subscriber.prototype[$efmvI.rxSubscriber] = function() {
        return this;
    };
    /**
     * A static factory for a Subscriber, given a (potentially partial) definition
     * of an Observer.
     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
     * Observer represented by the given arguments.
     */ Subscriber.create = function(next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    /**
     * The {@link Observer} callback to receive notifications of type `next` from
     * the Observable, with a value. The Observable may call this method 0 or more
     * times.
     * @param {T} [value] The `next` value.
     * @return {void}
     */ Subscriber.prototype.next = function(value) {
        if (!this.isStopped) this._next(value);
    };
    /**
     * The {@link Observer} callback to receive notifications of type `error` from
     * the Observable, with an attached {@link Error}. Notifies the Observer that
     * the Observable has experienced an error condition.
     * @param {any} [err] The `error` exception.
     * @return {void}
     */ Subscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    /**
     * The {@link Observer} callback to receive a valueless notification of type
     * `complete` from the Observable. Notifies the Observer that the Observable
     * has finished sending push-based notifications.
     * @return {void}
     */ Subscriber.prototype.complete = function() {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function() {
        this.destination.complete();
        this.unsubscribe();
    };
    /** @deprecated internal use only */ Subscriber.prototype._unsubscribeAndRecycle = function() {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        this._parent = null;
        this._parents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parent = _parent;
        this._parents = _parents;
        return this;
    };
    return Subscriber;
}($lSgto.Subscription);
module.exports.Subscriber = $9a324e9e88280ef4$var$Subscriber;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9a324e9e88280ef4$var$SafeSubscriber = function(_super) {
    $9a324e9e88280ef4$var$__extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        _super.call(this);
        this._parentSubscriber = _parentSubscriber;
        var next;
        var context = this;
        if ($4u8sc.isFunction(observerOrNext)) next = observerOrNext;
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== $5cSKU.empty) {
                context = Object.create(observerOrNext);
                if ($4u8sc.isFunction(context.unsubscribe)) this.add(context.unsubscribe.bind(context));
                context.unsubscribe = this.unsubscribe.bind(this);
            }
        }
        this._context = context;
        this._next = next;
        this._error = error;
        this._complete = complete;
    }
    SafeSubscriber.prototype.next = function(value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!_parentSubscriber.syncErrorThrowable) this.__tryOrUnsub(this._next, value);
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._error) {
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            } else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                throw err;
            } else {
                _parentSubscriber.syncErrorValue = err;
                _parentSubscriber.syncErrorThrown = true;
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function() {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function() {
                    return _this._complete.call(_this._context);
                };
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            } else this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function(fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            this.unsubscribe();
            throw err;
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function(parent, fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            parent.syncErrorValue = err;
            parent.syncErrorThrown = true;
            return true;
        }
        return false;
    };
    /** @deprecated internal use only */ SafeSubscriber.prototype._unsubscribe = function() {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}($9a324e9e88280ef4$var$Subscriber);
function $9a324e9e88280ef4$var$isTrustedSubscriber(obj) {
    return obj instanceof $9a324e9e88280ef4$var$Subscriber || 'syncErrorThrowable' in obj && obj[$efmvI.rxSubscriber];
}

});
parcelRegister("4u8sc", function(module, exports) {
$parcel$export(module.exports, "isFunction", () => $34408588c811449b$export$f6e2535fb5126e54, (v) => $34408588c811449b$export$f6e2535fb5126e54 = v);
var $34408588c811449b$export$f6e2535fb5126e54;
"use strict";
function $34408588c811449b$var$isFunction(x) {
    return typeof x === 'function';
}
$34408588c811449b$export$f6e2535fb5126e54 = $34408588c811449b$var$isFunction;

});

parcelRegister("lSgto", function(module, exports) {
$parcel$export(module.exports, "Subscription", () => $fecb6b5a483b85f8$export$f55210826850c514, (v) => $fecb6b5a483b85f8$export$f55210826850c514 = v);
var $fecb6b5a483b85f8$export$f55210826850c514;
"use strict";

var $PE2Cj = parcelRequire("PE2Cj");

var $9DdIv = parcelRequire("9DdIv");

var $4u8sc = parcelRequire("4u8sc");

var $4kjY4 = parcelRequire("4kjY4");

var $98JVa = parcelRequire("98JVa");

var $03vNo = parcelRequire("03vNo");
/**
 * Represents a disposable resource, such as the execution of an Observable. A
 * Subscription has one important method, `unsubscribe`, that takes no argument
 * and just disposes the resource held by the subscription.
 *
 * Additionally, subscriptions may be grouped together through the `add()`
 * method, which will attach a child Subscription to the current Subscription.
 * When a Subscription is unsubscribed, all its children (and its grandchildren)
 * will be unsubscribed as well.
 *
 * @class Subscription
 */ var $fecb6b5a483b85f8$var$Subscription = function() {
    /**
     * @param {function(): void} [unsubscribe] A function describing how to
     * perform the disposal of resources when the `unsubscribe` method is called.
     */ function Subscription(unsubscribe) {
        /**
         * A flag to indicate whether this Subscription has already been unsubscribed.
         * @type {boolean}
         */ this.closed = false;
        this._parent = null;
        this._parents = null;
        this._subscriptions = null;
        if (unsubscribe) this._unsubscribe = unsubscribe;
    }
    /**
     * Disposes the resources held by the subscription. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     * @return {void}
     */ Subscription.prototype.unsubscribe = function() {
        var hasErrors = false;
        var errors;
        if (this.closed) return;
        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parent = null;
        this._parents = null;
        // null out _subscriptions first so any child subscriptions that attempt
        // to remove themselves from this subscription will noop
        this._subscriptions = null;
        var index = -1;
        var len = _parents ? _parents.length : 0;
        // if this._parent is null, then so is this._parents, and we
        // don't have to remove ourselves from any parent subscriptions.
        while(_parent){
            _parent.remove(this);
            // if this._parents is null or index >= len,
            // then _parent is set to null, and the loop exits
            _parent = ++index < len && _parents[index] || null;
        }
        if ($4u8sc.isFunction(_unsubscribe)) {
            var trial = $4kjY4.tryCatch(_unsubscribe).call(this);
            if (trial === $98JVa.errorObject) {
                hasErrors = true;
                errors = errors || ($98JVa.errorObject.e instanceof $03vNo.UnsubscriptionError ? $fecb6b5a483b85f8$var$flattenUnsubscriptionErrors($98JVa.errorObject.e.errors) : [
                    $98JVa.errorObject.e
                ]);
            }
        }
        if ($PE2Cj.isArray(_subscriptions)) {
            index = -1;
            len = _subscriptions.length;
            while(++index < len){
                var sub = _subscriptions[index];
                if ($9DdIv.isObject(sub)) {
                    var trial = $4kjY4.tryCatch(sub.unsubscribe).call(sub);
                    if (trial === $98JVa.errorObject) {
                        hasErrors = true;
                        errors = errors || [];
                        var err = $98JVa.errorObject.e;
                        if (err instanceof $03vNo.UnsubscriptionError) errors = errors.concat($fecb6b5a483b85f8$var$flattenUnsubscriptionErrors(err.errors));
                        else errors.push(err);
                    }
                }
            }
        }
        if (hasErrors) throw new $03vNo.UnsubscriptionError(errors);
    };
    /**
     * Adds a tear down to be called during the unsubscribe() of this
     * Subscription.
     *
     * If the tear down being added is a subscription that is already
     * unsubscribed, is the same reference `add` is being called on, or is
     * `Subscription.EMPTY`, it will not be added.
     *
     * If this subscription is already in an `closed` state, the passed
     * tear down logic will be executed immediately.
     *
     * @param {TeardownLogic} teardown The additional logic to execute on
     * teardown.
     * @return {Subscription} Returns the Subscription used or created to be
     * added to the inner subscriptions list. This Subscription can be used with
     * `remove()` to remove the passed teardown logic from the inner subscriptions
     * list.
     */ Subscription.prototype.add = function(teardown) {
        if (!teardown || teardown === Subscription.EMPTY) return Subscription.EMPTY;
        if (teardown === this) return this;
        var subscription = teardown;
        switch(typeof teardown){
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription.closed || typeof subscription.unsubscribe !== 'function') return subscription;
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                } else if (typeof subscription._addParent !== 'function' /* quack quack */ ) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [
                        tmp
                    ];
                }
                break;
            default:
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
        var subscriptions = this._subscriptions || (this._subscriptions = []);
        subscriptions.push(subscription);
        subscription._addParent(this);
        return subscription;
    };
    /**
     * Removes a Subscription from the internal list of subscriptions that will
     * unsubscribe during the unsubscribe process of this Subscription.
     * @param {Subscription} subscription The subscription to remove.
     * @return {void}
     */ Subscription.prototype.remove = function(subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) subscriptions.splice(subscriptionIndex, 1);
        }
    };
    Subscription.prototype._addParent = function(parent) {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        if (!_parent || _parent === parent) // If we don't have a parent, or the new parent is the same as the
        // current parent, then set this._parent to the new parent.
        this._parent = parent;
        else if (!_parents) // If there's already one parent, but not multiple, allocate an Array to
        // store the rest of the parent Subscriptions.
        this._parents = [
            parent
        ];
        else if (_parents.indexOf(parent) === -1) // Only add the new parent to the _parents list if it's not already there.
        _parents.push(parent);
    };
    Subscription.EMPTY = function(empty) {
        empty.closed = true;
        return empty;
    }(new Subscription());
    return Subscription;
}();
$fecb6b5a483b85f8$export$f55210826850c514 = $fecb6b5a483b85f8$var$Subscription;
function $fecb6b5a483b85f8$var$flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function(errs, err) {
        return errs.concat(err instanceof $03vNo.UnsubscriptionError ? err.errors : err);
    }, []);
}

});
parcelRegister("PE2Cj", function(module, exports) {
$parcel$export(module.exports, "isArray", () => $09b3d2e2894a2b38$export$43bee75e5e14138e, (v) => $09b3d2e2894a2b38$export$43bee75e5e14138e = v);
var $09b3d2e2894a2b38$export$43bee75e5e14138e;
"use strict";
$09b3d2e2894a2b38$export$43bee75e5e14138e = Array.isArray || function(x) {
    return x && typeof x.length === 'number';
};

});

parcelRegister("9DdIv", function(module, exports) {
$parcel$export(module.exports, "isObject", () => $7032657000ff8bfe$export$a6cdc56e425d0d0a, (v) => $7032657000ff8bfe$export$a6cdc56e425d0d0a = v);
var $7032657000ff8bfe$export$a6cdc56e425d0d0a;
"use strict";
function $7032657000ff8bfe$var$isObject(x) {
    return x != null && typeof x === 'object';
}
$7032657000ff8bfe$export$a6cdc56e425d0d0a = $7032657000ff8bfe$var$isObject;

});

parcelRegister("4kjY4", function(module, exports) {
$parcel$export(module.exports, "tryCatch", () => $326884e25cd9b349$export$d234c058d1d4e435, (v) => $326884e25cd9b349$export$d234c058d1d4e435 = v);
var $326884e25cd9b349$export$d234c058d1d4e435;
"use strict";

var $98JVa = parcelRequire("98JVa");
var $326884e25cd9b349$var$tryCatchTarget;
function $326884e25cd9b349$var$tryCatcher() {
    try {
        return $326884e25cd9b349$var$tryCatchTarget.apply(this, arguments);
    } catch (e) {
        $98JVa.errorObject.e = e;
        return $98JVa.errorObject;
    }
}
function $326884e25cd9b349$var$tryCatch(fn) {
    $326884e25cd9b349$var$tryCatchTarget = fn;
    return $326884e25cd9b349$var$tryCatcher;
}
$326884e25cd9b349$export$d234c058d1d4e435 = $326884e25cd9b349$var$tryCatch;

});
parcelRegister("98JVa", function(module, exports) {
$parcel$export(module.exports, "errorObject", () => $6a787b60d5ba4151$export$fc504b39d7c1176, (v) => $6a787b60d5ba4151$export$fc504b39d7c1176 = v);
// typeof any so that it we don't have to cast when comparing a result to the error object
var $6a787b60d5ba4151$export$fc504b39d7c1176;
"use strict";
$6a787b60d5ba4151$export$fc504b39d7c1176 = {
    e: {}
};

});


parcelRegister("03vNo", function(module, exports) {
"use strict";
var $00a8f1e1504b13fc$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when one or more errors have occurred during the
 * `unsubscribe` of a {@link Subscription}.
 */ var $00a8f1e1504b13fc$var$UnsubscriptionError = function(_super) {
    $00a8f1e1504b13fc$var$__extends(UnsubscriptionError, _super);
    function UnsubscriptionError(errors) {
        _super.call(this);
        this.errors = errors;
        var err = Error.call(this, errors ? errors.length + " errors occurred during unsubscription:\n  " + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '');
        this.name = err.name = 'UnsubscriptionError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return UnsubscriptionError;
}(Error);
module.exports.UnsubscriptionError = $00a8f1e1504b13fc$var$UnsubscriptionError;

});


parcelRegister("5cSKU", function(module, exports) {
$parcel$export(module.exports, "empty", () => $3ca88c0e07e3e3bc$export$6e22c362a0406a2c, (v) => $3ca88c0e07e3e3bc$export$6e22c362a0406a2c = v);
var $3ca88c0e07e3e3bc$export$6e22c362a0406a2c;
"use strict";
$3ca88c0e07e3e3bc$export$6e22c362a0406a2c = {
    closed: true,
    next: function(value) {},
    error: function(err) {
        throw err;
    },
    complete: function() {}
};

});

parcelRegister("efmvI", function(module, exports) {
$parcel$export(module.exports, "rxSubscriber", () => $a5f3ed876410bdb0$export$77f77496d7cade10, (v) => $a5f3ed876410bdb0$export$77f77496d7cade10 = v);
var $a5f3ed876410bdb0$export$77f77496d7cade10;
/**
 * @deprecated use rxSubscriber instead
 */ var $a5f3ed876410bdb0$export$4a2e07ff24d010f0;
"use strict";

var $gvBTr = parcelRequire("gvBTr");
var $a5f3ed876410bdb0$var$Symbol = $gvBTr.root.Symbol;
$a5f3ed876410bdb0$export$77f77496d7cade10 = typeof $a5f3ed876410bdb0$var$Symbol === 'function' && typeof $a5f3ed876410bdb0$var$Symbol.for === 'function' ? $a5f3ed876410bdb0$var$Symbol.for('rxSubscriber') : '@@rxSubscriber';
$a5f3ed876410bdb0$export$4a2e07ff24d010f0 = $a5f3ed876410bdb0$export$77f77496d7cade10;

});
parcelRegister("gvBTr", function(module, exports) {
$parcel$export(module.exports, "root", () => $c04cef60f79b79ed$export$e8e78c978b129247, (v) => $c04cef60f79b79ed$export$e8e78c978b129247 = v);
var $c04cef60f79b79ed$export$e8e78c978b129247;
"use strict";
// CommonJS / Node have global context exposed as "global" variable.
// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
// the global "global" var for now.
var $c04cef60f79b79ed$var$__window = typeof window !== 'undefined' && window;
var $c04cef60f79b79ed$var$__self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope && self;
var $c04cef60f79b79ed$var$__global = typeof $parcel$global !== 'undefined' && $parcel$global;
var $c04cef60f79b79ed$var$_root = $c04cef60f79b79ed$var$__window || $c04cef60f79b79ed$var$__global || $c04cef60f79b79ed$var$__self;
$c04cef60f79b79ed$export$e8e78c978b129247 = $c04cef60f79b79ed$var$_root;
// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
// This is needed when used with angular/tsickle which inserts a goog.module statement.
// Wrap in IIFE
(function() {
    if (!$c04cef60f79b79ed$var$_root) throw new Error('RxJS could not find any global context (window, self, global)');
})();

});




parcelRegister("g7x2h", function(module, exports) {
$parcel$export(module.exports, "downloadUrl", () => $bbc6ed0084190904$export$8a96edb1c96563f4);
var $bbc6ed0084190904$export$8a96edb1c96563f4 = function downloadUrl(url, options) {
    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    var iframeName = 'media-download-iframe';
    var link = document.createElement('a');
    var iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    if (options && options.name) link.download = options.name;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

});

parcelRegister("zMV7W", function(module, exports) {
$parcel$export(module.exports, "isValidUuid", () => $06b937928520443e$export$6ad459db9a6bcc76);
var $06b937928520443e$var$BASIC_UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
var $06b937928520443e$export$6ad459db9a6bcc76 = function isValidUuid(value) {
    if (typeof value !== 'string') return false;
    var normalizedValue = value.toLowerCase();
    if (!$06b937928520443e$var$BASIC_UUID_REGEX.test(normalizedValue)) return false;
    var version = normalizedValue[14];
    if (version === '1' || version === '2') return true;
    if (version === '3' || version === '4' || version === '5') {
        var variant = normalizedValue[19];
        return variant === '8' || variant === '9' || variant === 'a' || variant === 'b';
    }
    return false;
};

});

parcelRegister("7VCF9", function(module, exports) {
$parcel$export(module.exports, "getMediaTypeFromMimeType", () => $5c5bd8e603aea4f5$export$79e1dc0d1801e8ef);
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => (parcelRequire("keEas")).isImageMimeTypeSupportedByBrowser);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => (parcelRequire("keEas")).isVideoMimeTypeSupportedByBrowser);

var $d5qgj = parcelRequire("d5qgj");

var $keEas = parcelRequire("keEas");

var $aWDq9n = parcelRequire("aWDq9n");

var $jlbPs = parcelRequire("jlbPs");
var $5c5bd8e603aea4f5$export$79e1dc0d1801e8ef = function getMediaTypeFromMimeType(mimeType) {
    if ((0, $d5qgj.isArchive)(mimeType)) return 'archive';
    if ((0, $keEas.isImageMimeTypeSupportedByBrowser)(mimeType) || (0, $aWDq9n.isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
    if ((0, $keEas.isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, $aWDq9n.isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
    if ((0, $keEas.isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, $aWDq9n.isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
    if ((0, $keEas.isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, $aWDq9n.isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
    return 'unknown';
};

});
parcelRegister("d5qgj", function(module, exports) {
$parcel$export(module.exports, "isArchive", () => $98701d19cdee6fec$export$f47f3fe506e20fe6);
// Based on https://en.wikipedia.org/wiki/List_of_archive_formats
var $98701d19cdee6fec$export$f47f3fe506e20fe6 = function isArchive(mimeType) {
    return [
        'application/x-archive',
        'application/x-cpio',
        'application/x-shar',
        'application/x-iso9660-image',
        'application/x-sbx',
        'application/x-tar',
        'application/x-bzip2',
        'application/gzip',
        'application/x-gzip',
        'application/x-lzip',
        'application/x-lzma',
        'application/x-lzop',
        'application/x-snappy-framed',
        'application/x-xz',
        'application/x-compress',
        'application/zstd',
        'application/x-7z-compressed',
        'application/x-ace-compressed',
        'application/x-astrotite-afa',
        'application/x-alz-compressed',
        'application/vnd.android.package-archive',
        'application/x-freearc',
        'application/x-arj',
        'application/x-b1',
        'application/vnd.ms-cab-compressed',
        'application/x-cfs-compressed',
        'application/x-dar',
        'application/x-dgc-compressed',
        'application/x-apple-diskimage',
        'application/x-gca-compressed',
        'application/java-archive',
        'application/x-lzh',
        'application/x-lzx',
        'application/x-rar-compressed',
        'application/x-stuffit',
        'application/x-stuffitx',
        'application/x-gtar',
        'application/x-ms-wim',
        'application/x-xar',
        'application/zip',
        'application/x-zoo',
        'application/x-par2'
    ].indexOf(mimeType.toLowerCase()) > -1;
};

});

parcelRegister("keEas", function(module, exports) {
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => $ebb445eb9a9a60c5$export$c021f2623a75015f);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", () => $ebb445eb9a9a60c5$export$74325e3c843a9555);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", () => $ebb445eb9a9a60c5$export$ff36075ea755a717);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => $ebb445eb9a9a60c5$export$87bf945cf31ec2d9);
$parcel$export(module.exports, "isMimeTypeSupportedByBrowser", () => $ebb445eb9a9a60c5$export$55ca6cdaf6093034);
// Based on https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
var $ebb445eb9a9a60c5$export$c021f2623a75015f = function isImageMimeTypeSupportedByBrowser(mimeType) {
    return [
        'image/apng',
        'image/bmp',
        'image/gif',
        'image/x-icon',
        'image/jpeg',
        'image/png',
        'image/webp'
    ].indexOf(mimeType.toLowerCase()) > -1;
};
var $ebb445eb9a9a60c5$export$74325e3c843a9555 = function isDocumentMimeTypeSupportedByBrowser(mimeType) {
    return mimeType.toLowerCase() === 'application/pdf';
};
var $ebb445eb9a9a60c5$export$ff36075ea755a717 = function isAudioMimeTypeSupportedByBrowser(mimeType) {
    return [
        'audio/aac',
        'audio/flac',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/wav',
        'audio/x-wav'
    ].indexOf(mimeType.toLowerCase()) > -1;
};
var $ebb445eb9a9a60c5$export$87bf945cf31ec2d9 = function isVideoMimeTypeSupportedByBrowser(mimeType) {
    return [
        'video/mp4',
        'video/quicktime'
    ].indexOf(mimeType.toLowerCase()) > -1;
};
var $ebb445eb9a9a60c5$export$55ca6cdaf6093034 = function isMimeTypeSupportedByBrowser(mimeType) {
    return $ebb445eb9a9a60c5$export$74325e3c843a9555(mimeType) || $ebb445eb9a9a60c5$export$c021f2623a75015f(mimeType) || $ebb445eb9a9a60c5$export$ff36075ea755a717(mimeType) || $ebb445eb9a9a60c5$export$87bf945cf31ec2d9(mimeType);
};

});

parcelRegister("aWDq9n", function(module, exports) {
$parcel$export(module.exports, "isImageMimeTypeSupportedByServer", () => $7f7de64dd417a83e$export$e9a065a80f76311e);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", () => $7f7de64dd417a83e$export$86baad7a89d908e9);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", () => $7f7de64dd417a83e$export$8cba23825d020bbb);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", () => $7f7de64dd417a83e$export$9c2b4de5fdca2ce3);
$parcel$export(module.exports, "isMimeTypeSupportedByServer", () => $7f7de64dd417a83e$export$548d9148a80556a3);
// Based on https://developer.atlassian.com/platform/media/learning/file-previews/
var $7f7de64dd417a83e$export$e9a065a80f76311e = function isImageMimeTypeSupportedByServer(mimeType) {
    return [
        'image/bmp',
        'image/x-windows-bmp',
        'application/dicom',
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/jp_',
        'application/jpg',
        'application/x-jpg',
        'image/png',
        'application/png',
        'application/x-png',
        'application/vnd.adobe.photoshop',
        'image/vnd.adobe.photoshop',
        'image/photoshop',
        'image/x-photoshop',
        'image/psd',
        'application/photoshop',
        'application/psd',
        'zz-application/zz-winassoc-psd',
        'image/tiff',
        'image/x-tif',
        'image/x-tiff',
        'application/tif',
        'application/x-tif',
        'application/tiff',
        'application/x-tiff',
        'image/svg+xml',
        'image/heif',
        'image/heif-sequence',
        'image/heic',
        'image/heic-sequence'
    ].indexOf(mimeType.toLowerCase()) > -1;
};
var $7f7de64dd417a83e$export$86baad7a89d908e9 = function isDocumentMimeTypeSupportedByServer(mimeType) {
    return [
        // Adobe PDF
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        // Adobe Illustrator
        'application/vnd.adobe.illustrator',
        // Microsoft Office
        'application/vnd.ms-office',
        // Microsoft Word
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroenabled.12',
        'application/vnd.ms-word.template.macroenabled.12',
        // Microsoft Excel
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroenabled.12',
        'application/vnd.ms-excel.template.macroenabled.12',
        'application/vnd.ms-excel.addin.macroenabled.12',
        'application/vnd.ms-excel.sheet.macroenabled',
        'application/vnd.ms-excel.template.macroenabled',
        'application/vnd.ms-excel.addin.macroenabled',
        // Microsoft Powerpoint
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12',
        'application/vnd.ms-powerpoint.template.macroenabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
        // OpenOffice
        'application/vnd.sun.xml.writer',
        'application/vnd.sun.xml.writer.template',
        // OpenDocument
        'application/vnd.sun.xml.draw',
        'application/vnd.sun.xml.draw.template',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.oasis.opendocument.presentation',
        'application/x-vnd.oasis.opendocument.presentation',
        'application/vnd.sun.xml.calc',
        'application/vnd.sun.xml.calc.template',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/x-vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet-template',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template',
        'application/vnd.oasis.opendocument.text-master',
        'application/x-vnd.oasis.opendocument.text',
        'application/x-vnd.oasis.opendocument.text-template',
        'application/x-vnd.oasis.opendocument.text-master',
        // WordPerfect
        'application/vnd.wordperfect',
        // Text files
        'text/csv',
        'text/x-diff',
        'text/x-perl',
        'text/x-python',
        'text/x-ruby',
        'text/rtf',
        'text/richtext',
        'text/plain',
        'application/txt',
        // Rich text
        'application/rtf',
        'application/x-rtf',
        // PostScript
        'application/postscript'
    ].indexOf(mimeType.toLowerCase()) > -1;
};
var $7f7de64dd417a83e$export$8cba23825d020bbb = function isAudioMimeTypeSupportedByServer(mimeType) {
    return [
        'audio/aac',
        'audio/x-hx-aac-adts',
        'audio/vnd.dolby.dd-raw',
        'audio/aiff',
        'audio/x-aiff',
        'audio/x-monkeys-audio',
        'audio/x-ape',
        'audio/basic',
        'audio/flac',
        'audio/mp4',
        'audio/midi',
        'audio/x-matroska',
        'audio/x-mod',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/x-pn-realaudio',
        'audio/wav',
        'audio/x-wav',
        'audio/x-ms-wma'
    ].indexOf(mimeType.toLowerCase()) > -1;
};
var $7f7de64dd417a83e$export$9c2b4de5fdca2ce3 = function isVideoMimeTypeSupportedByServer(mimeType) {
    return [
        'video/3gpp',
        'video/3gpp2',
        'video/x-ms-asf',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/x-dv',
        'video/x-flv',
        'video/m2ts',
        'video/x-m4v',
        'video/x-matroska',
        'video/quicktime',
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/x-ogg',
        'video/webm',
        'video/x-ms-wmv'
    ].indexOf(mimeType.toLowerCase()) > -1;
};
var $7f7de64dd417a83e$export$94e1479e01d2af53 = function isUnknownMimeTypeSupportedByServer(mimeType) {
    return [
        'binary/octet-stream'
    ].indexOf(mimeType.toLowerCase()) > -1;
};
var $7f7de64dd417a83e$export$548d9148a80556a3 = function isMimeTypeSupportedByServer(mimeType) {
    return $7f7de64dd417a83e$export$e9a065a80f76311e(mimeType) || $7f7de64dd417a83e$export$86baad7a89d908e9(mimeType) || $7f7de64dd417a83e$export$8cba23825d020bbb(mimeType) || $7f7de64dd417a83e$export$9c2b4de5fdca2ce3(mimeType) || $7f7de64dd417a83e$export$94e1479e01d2af53(mimeType);
};

});

parcelRegister("jlbPs", function(module, exports) {
$parcel$export(module.exports, "isExcelFile", () => $e149277578f820a3$export$e5fbc944c6f94589);
// MS Excel MIME types — covers all native Microsoft spreadsheet formats.
// Stored in their canonical form (RFC 4288 mimetypes are case-sensitive;
// the media backend always sends them in this exact casing).
var $e149277578f820a3$var$EXCEL_MIME_TYPES = new Set([
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
    'application/vnd.ms-excel.sheet.macroEnabled.12'
]);
var $e149277578f820a3$export$e5fbc944c6f94589 = function isExcelFile(mimeType) {
    return $e149277578f820a3$var$EXCEL_MIME_TYPES.has(mimeType);
};

});


parcelRegister("6Gdy5", function(module, exports) {
$parcel$export(module.exports, "authToOwner", () => $4dd12cd265f723c1$export$17f6055767a8d96a);

var $jva2H = parcelRequire("jva2H");
var $4dd12cd265f723c1$export$17f6055767a8d96a = function authToOwner(auth) {
    if ((0, $jva2H.isAsapBasedAuth)(auth)) return auth;
    var clientAuth = {
        id: auth.clientId,
        baseUrl: auth.baseUrl,
        token: auth.token
    };
    return clientAuth;
};

});
parcelRegister("jva2H", function(module, exports) {
$parcel$export(module.exports, "isAsapBasedAuth", () => $e328b3cb64abe7a3$export$af1ab14f2246ef72);
function $e328b3cb64abe7a3$export$af1ab14f2246ef72(auth) {
    return !!auth.asapIssuer;
}

});


parcelRegister("eW8Rv", function(module, exports) {
$parcel$export(module.exports, "expValEquals", () => $adfd5b455d3f0db1$export$45abdb3f977b5b14);

var $bwvtU = parcelRequire("bwvtU");
function $adfd5b455d3f0db1$export$45abdb3f977b5b14(experimentName, experimentParam, experimentExpectedValue) {
    var experimentDefaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return (0, $bwvtU.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, true);
}

});
parcelRegister("bwvtU", function(module, exports) {
$parcel$export(module.exports, "expValEqualsInternal", () => $863b1a6a68c8215b$export$58e581060588c6bb);

var $3O9DR = parcelRequire("3O9DR");

var $3ISRs = parcelRequire("3ISRs");

var $2e1lj = parcelRequire("2e1lj");

var $chVel = parcelRequire("chVel");
// This internal representation doesn't currently support productKeys
// the way expVal(...) does, this adds temporary support for some keys while
// we determine our preferred approach forward
var $863b1a6a68c8215b$var$allowsProductKeys = [
    'cc-maui-experiment',
    'cc_maui_create_keyword',
    'cc_maui_create_keyword_aa',
    'platform_use_unicode_emojis'
];
function $863b1a6a68c8215b$export$58e581060588c6bb(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, experimentExposure) {
    var _editorExperimentsCon, _editorExperimentsCon2;
    if ((0, $chVel._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $chVel._overrides)[experimentName] === experimentExpectedValue;
    // If client is not initialized, we compare with the default value
    if (!(0, $3O9DR.default).initializeCompleted()) return experimentDefaultValue === experimentExpectedValue;
    // Typescript is complaining here about accessing the productKeys property
    var experimentKeyName = $863b1a6a68c8215b$var$allowsProductKeys.includes(experimentName) ? (_editorExperimentsCon = (_editorExperimentsCon2 = (0, $2e1lj.editorExperimentsConfig)[experimentName]) === null || _editorExperimentsCon2 === void 0 || (_editorExperimentsCon2 = _editorExperimentsCon2.productKeys) === null || _editorExperimentsCon2 === void 0 ? void 0 : _editorExperimentsCon2[0, $chVel._product]) !== null && _editorExperimentsCon !== void 0 ? _editorExperimentsCon : experimentName : experimentName;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $3O9DR.default).getExperimentValue(experimentKeyName, experimentParam, experimentDefaultValue, {
        fireExperimentExposure: experimentExposure
    });
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $3O9DR.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $3ISRs.addFeatureFlagAccessed)("".concat(experimentKeyName, ":").concat(experimentParam), experimentValue);
    return experimentValue === experimentExpectedValue;
}

});
parcelRegister("3O9DR", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c5d85505907d119$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $hnHHO = parcelRequire("hnHHO");

var $d2wgE = parcelRequire("d2wgE");



var $2c5d85505907d119$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $2c5d85505907d119$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$2c5d85505907d119$var$_FeatureGates = $2c5d85505907d119$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "client", new (0, $hnHHO.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$2c5d85505907d119$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $2c5d85505907d119$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $2c5d85505907d119$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$2c5d85505907d119$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $2c5d85505907d119$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $2c5d85505907d119$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "initializeCalled", $2c5d85505907d119$var$_FeatureGates.client.initializeCalled.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "initializeCompleted", $2c5d85505907d119$var$_FeatureGates.client.initializeCompleted.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "waitUntilInitializeCompleted", $2c5d85505907d119$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "initialize", $2c5d85505907d119$var$_FeatureGates.client.initialize.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "initializeWithProvider", $2c5d85505907d119$var$_FeatureGates.client.initializeWithProvider.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "initializeFromValues", $2c5d85505907d119$var$_FeatureGates.client.initializeFromValues.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "manuallyLogGateExposure", $2c5d85505907d119$var$_FeatureGates.client.manuallyLogGateExposure.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "getExperiment", $2c5d85505907d119$var$_FeatureGates.client.getExperiment.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "manuallyLogExperimentExposure", $2c5d85505907d119$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "manuallyLogLayerExposure", $2c5d85505907d119$var$_FeatureGates.client.manuallyLogLayerExposure.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "shutdownStatsig", $2c5d85505907d119$var$_FeatureGates.client.shutdownStatsig.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "overrideGate", $2c5d85505907d119$var$_FeatureGates.client.overrideGate.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "clearGateOverride", $2c5d85505907d119$var$_FeatureGates.client.clearGateOverride.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "overrideConfig", $2c5d85505907d119$var$_FeatureGates.client.overrideConfig.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "clearConfigOverride", $2c5d85505907d119$var$_FeatureGates.client.clearConfigOverride.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "setOverrides", $2c5d85505907d119$var$_FeatureGates.client.setOverrides.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "getOverrides", $2c5d85505907d119$var$_FeatureGates.client.getOverrides.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "clearAllOverrides", $2c5d85505907d119$var$_FeatureGates.client.clearAllOverrides.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "isCurrentUser", $2c5d85505907d119$var$_FeatureGates.client.isCurrentUser.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "onGateUpdated", $2c5d85505907d119$var$_FeatureGates.client.onGateUpdated.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "onExperimentValueUpdated", $2c5d85505907d119$var$_FeatureGates.client.onExperimentValueUpdated.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "onAnyUpdated", $2c5d85505907d119$var$_FeatureGates.client.onAnyUpdated.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "updateUser", $2c5d85505907d119$var$_FeatureGates.client.updateUser.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "updateUserWithProvider", $2c5d85505907d119$var$_FeatureGates.client.updateUserWithProvider.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "updateUserWithValues", $2c5d85505907d119$var$_FeatureGates.client.updateUserWithValues.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "getPackageVersion", $2c5d85505907d119$var$_FeatureGates.client.getPackageVersion.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "getTargetApp", $2c5d85505907d119$var$_FeatureGates.client.getTargetApp.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "getLayer", $2c5d85505907d119$var$_FeatureGates.client.getLayer.bind($2c5d85505907d119$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2c5d85505907d119$var$FeatureGates, "getLayerValue", $2c5d85505907d119$var$_FeatureGates.client.getLayerValue.bind($2c5d85505907d119$var$_FeatureGates.client));
var $2c5d85505907d119$var$boundFGJS = $2c5d85505907d119$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $2c5d85505907d119$var$FeatureGates;
    else {
        var $2c5d85505907d119$var$_boundFGJS, $2c5d85505907d119$var$_boundFGJS$getPackage;
        $2c5d85505907d119$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $2c5d85505907d119$var$boundVersion = (($2c5d85505907d119$var$_boundFGJS = $2c5d85505907d119$var$boundFGJS) === null || $2c5d85505907d119$var$_boundFGJS === void 0 || ($2c5d85505907d119$var$_boundFGJS$getPackage = $2c5d85505907d119$var$_boundFGJS.getPackageVersion) === null || $2c5d85505907d119$var$_boundFGJS$getPackage === void 0 ? void 0 : $2c5d85505907d119$var$_boundFGJS$getPackage.call($2c5d85505907d119$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($2c5d85505907d119$var$boundVersion !== (0, $d2wgE.CLIENT_VERSION)) {
            var $2c5d85505907d119$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($2c5d85505907d119$var$boundVersion, " when module version ").concat((0, $d2wgE.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($2c5d85505907d119$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $2c5d85505907d119$export$2e2bcd8739ae039 = $2c5d85505907d119$var$boundFGJS;

});
parcelRegister("hnHHO", function(module, exports) {
$parcel$export(module.exports, "Client", () => $ca767cada31058db$export$1f2bb630327ac4b6);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");

var $hJ5Ws = parcelRequire("hJ5Ws");

var $gch7u = parcelRequire("gch7u");

var $6eyuY = parcelRequire("6eyuY");

var $4319f = parcelRequire("4319f");

var $2GGG8 = parcelRequire("2GGG8");

var $aaCm4 = parcelRequire("aaCm4");

var $4FLIT = parcelRequire("4FLIT");

var $aRIsI = parcelRequire("aRIsI");

var $1BNqg = parcelRequire("1BNqg");

var $djiCr = parcelRequire("djiCr");

var $s3TIO = parcelRequire("s3TIO");

var $6rcSf = parcelRequire("6rcSf");

var $bZdoy = parcelRequire("bZdoy");

var $d2wgE = parcelRequire("d2wgE");
var $ca767cada31058db$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $ca767cada31058db$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ca767cada31058db$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ca767cada31058db$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ca767cada31058db$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ca767cada31058db$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $ca767cada31058db$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $ca767cada31058db$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $djiCr.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscriptions", new (0, $hJ5Ws.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "dataAdapter", new (0, $1BNqg.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $djiCr.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $4FLIT.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 1;
                                    break;
                                }
                                if (!(0, $s3TIO.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $4FLIT.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 1;
                                    break;
                                }
                                if (!(0, $s3TIO.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $d2wgE.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $ca767cada31058db$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $d2wgE.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $bZdoy.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $4FLIT.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 1;
                                    break;
                                }
                                if (!(0, $s3TIO.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 1:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $4FLIT.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $aaCm4.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 1;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 1:
                                _context5.next = 2;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 2:
                                _context5.next = 3;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 1:
                                if (!this.initCompleted) {
                                    _context7.next = 2;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 2:
                                _context7.next = 3;
                                return this.initPromise;
                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $gch7u.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $gch7u.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $4319f.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $s3TIO.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $s3TIO.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $ca767cada31058db$var$_objectSpread({}, clientOptions);
                                if (!clientOptions.localMode) {
                                    _context8.next = 2;
                                    break;
                                }
                                _context8.next = 1;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 1:
                                return _context8.abrupt("return");
                            case 2:
                                _context8.prev = 2;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $aaCm4.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $aaCm4.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 6;
                                break;
                            case 4:
                                _context8.prev = 4;
                                _t = _context8["catch"](2);
                                if (_t instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t === null || _t === void 0 ? void 0 : _t.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t;
                            case 6:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            2,
                            4
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $ca767cada31058db$var$_objectSpread($ca767cada31058db$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 2;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 2:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 6;
                                break;
                            case 4:
                                _context9.prev = 4;
                                _t2 = _context9["catch"](1);
                                if (_t2 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t2 === null || _t2 === void 0 ? void 0 : _t2.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t2;
                            case 6:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            4
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, _args0 = arguments, _t3;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $aRIsI.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $ca767cada31058db$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $ca767cada31058db$var$_objectSpread($ca767cada31058db$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $ca767cada31058db$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $bZdoy.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(newClientOptions, $ca767cada31058db$var$_excluded);
                                frontendUser = (0, $6rcSf.toStatsigUser)(identifiers, customAttributes);
                                this.user = (0, $2GGG8.deepAssign)({}, initializeValues.user, frontendUser);
                                statsigOptions = $ca767cada31058db$var$_objectSpread($ca767cada31058db$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 1;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 2;
                                return this.statsigClient.initializeAsync();
                            case 2:
                                _context0.next = 5;
                                break;
                            case 3:
                                _context0.prev = 3;
                                _t3 = _context0["catch"](1);
                                if (_t3 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_t3 === null || _t3 === void 0 ? void 0 : _t3.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($ca767cada31058db$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 4;
                                return this.statsigClient.initializeAsync();
                            case 4:
                                this.initWithDefaults = true;
                                throw _t3;
                            case 5:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise, _t4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 1:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 2;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 2:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 3;
                                _context10.next = 4;
                                return this.initPromise;
                            case 4:
                                _context10.next = 6;
                                break;
                            case 5:
                                _context10.prev = 5;
                                _t4 = _context10["catch"](3);
                            case 6:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 1;
                                                    break;
                                                }
                                                _context1.next = 1;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 1:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 7:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            3,
                            5
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, frontendUser, _updateUserCompletion, _ref4, errMsg, success, errorMessage, _t5, _t6;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 2;
                                return initializeValuesPromise;
                            case 2:
                                initializeValues = _context11.sent;
                                frontendUser = (0, $6rcSf.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, $2GGG8.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
                                _context11.next = 4;
                                break;
                            case 3:
                                _context11.prev = 3;
                                _t5 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _t5 instanceof Error ? _t5.message : JSON.stringify(_t5);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _t5;
                            case 4:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 5;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 6;
                                    break;
                                }
                                _context11.next = 6;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 6:
                                _context11.next = 8;
                                break;
                            case 7:
                                _context11.prev = 7;
                                _t6 = _context11["catch"](5);
                                success = false;
                                errorMessage = String(_t6);
                            case 8:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 9;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 10;
                                break;
                            case 9:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 10:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            3
                        ],
                        [
                            5,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $d2wgE.CLIENT_VERSION;
            }
        },
        {
            key: "getTargetApp",
            value: function getTargetApp() {
                var _this$initOptions2;
                return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $6eyuY.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $6eyuY.Layer).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("hJ5Ws", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce7b3f91ec6bc7be$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $hLfKH = parcelRequire("hLfKH");
function $ce7b3f91ec6bc7be$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ce7b3f91ec6bc7be$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ce7b3f91ec6bc7be$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ce7b3f91ec6bc7be$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ce7b3f91ec6bc7be$export$a66cbd9b2289cd78 = '@all-features';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $ce7b3f91ec6bc7be$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $ce7b3f91ec6bc7be$var$_objectSpread($ce7b3f91ec6bc7be$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $ce7b3f91ec6bc7be$var$_objectSpread($ce7b3f91ec6bc7be$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $ce7b3f91ec6bc7be$var$_objectSpread($ce7b3f91ec6bc7be$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $ce7b3f91ec6bc7be$var$_objectSpread($ce7b3f91ec6bc7be$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($ce7b3f91ec6bc7be$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($ce7b3f91ec6bc7be$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($ce7b3f91ec6bc7be$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $ce7b3f91ec6bc7be$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("gch7u", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $bcab0bf7e9760ae0$export$6dc24881a3d96325);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $7z6R4 = parcelRequire("7z6R4");

var $7GDUv = parcelRequire("7GDUv");
var $bcab0bf7e9760ae0$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $7z6R4.migrateEvaluationDetails)(experiment.details), (0, $7GDUv.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("7z6R4", function(module, exports) {
$parcel$export(module.exports, "migrateEvaluationDetails", () => $58211e8c5243cb5e$export$18ad168d3dbac899);

var $iYJcE = parcelRequire("iYJcE");

var $4319f = parcelRequire("4319f");
var $58211e8c5243cb5e$var$evaluationReasonMappings = Object.entries((0, $4319f.EvaluationReason)).map(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $58211e8c5243cb5e$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $58211e8c5243cb5e$var$evaluationReasonMappings.find(function(_ref3) {
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 1), key = _ref4[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $4319f.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};

});
parcelRegister("4319f", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $2f28553a7748d64e$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $2f28553a7748d64e$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
}; // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});


parcelRegister("7GDUv", function(module, exports) {
$parcel$export(module.exports, "migrateSecondaryExposures", () => $598b6a05cbee0250$export$55fd683752d01e67);
var $598b6a05cbee0250$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});


parcelRegister("6eyuY", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $489ecf90c50163e2$export$936d0764594b6eb3);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $7z6R4 = parcelRequire("7z6R4");

var $7GDUv = parcelRequire("7GDUv");
var $489ecf90c50163e2$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $7z6R4.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $7GDUv.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $7GDUv.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("2GGG8", function(module, exports) {
$parcel$export(module.exports, "deepAssign", () => $1f509c1c92e6f7a7$export$1148cb79ceecd5fa);

var $ekGgq = parcelRequire("ekGgq");

var $iYJcE = parcelRequire("iYJcE");

var $fC8ib = parcelRequire("fC8ib");
function $1f509c1c92e6f7a7$export$1148cb79ceecd5fa(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return $1f509c1c92e6f7a7$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sources)));
    for(var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], src = _Object$entries$_i[1];
        var dst = target[key];
        var srcIsObj = src && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(src) === 'object' && !Array.isArray(src);
        var dstIsObj = dst && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(dst) === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $1f509c1c92e6f7a7$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $1f509c1c92e6f7a7$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sources)));
}

});

parcelRegister("aaCm4", function(module, exports) {
$parcel$export(module.exports, "default", () => $767897110cda8942$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $bZdoy = parcelRequire("bZdoy");

var $d2wgE = parcelRequire("d2wgE");

var $gop3x = parcelRequire("gop3x");
function $767897110cda8942$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $767897110cda8942$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $767897110cda8942$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $767897110cda8942$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $767897110cda8942$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $767897110cda8942$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $767897110cda8942$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $767897110cda8942$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $767897110cda8942$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $767897110cda8942$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $767897110cda8942$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $767897110cda8942$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $767897110cda8942$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $767897110cda8942$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $767897110cda8942$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(fetcherOptions) {
                    var targetApp, url, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 1;
                                _context.next = 2;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                                _context.prev = 3;
                                _t = _context["catch"](1);
                                if (!(_t instanceof Error)) {
                                    _context.next = 4;
                                    break;
                                }
                                throw _t;
                            case 4:
                                throw Error('Failed to retrieve client sdk key');
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 2;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                                _context2.prev = 3;
                                _t2 = _context2["catch"](1);
                                if (!(_t2 instanceof Error)) {
                                    _context2.next = 4;
                                    break;
                                }
                                throw _t2;
                            case 4:
                                throw Error('Failed to retrieve experiment values');
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 2;
                                    break;
                                }
                                _context3.next = 1;
                                return response.text();
                            case 1:
                                body = _context3.sent;
                                throw new (0, $gop3x.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 2:
                                if (!(response.status === 204)) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new (0, $gop3x.ResponseError)('Unexpected 204 response');
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return response.text();
                            case 1:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $767897110cda8942$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $bZdoy.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $bZdoy.FeatureGateEnvironment).Production:
                        return $767897110cda8942$export$18c93900db9358a4;
                    case (0, $bZdoy.FeatureGateEnvironment).Staging:
                        return $767897110cda8942$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $bZdoy.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $bZdoy.FeatureGateEnvironment).Development:
                        return $767897110cda8942$export$f058dbf75c3bc647;
                    case (0, $bZdoy.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $767897110cda8942$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $767897110cda8942$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $767897110cda8942$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 1;
                                return fetch("".concat(baseUrl).concat(path), $767897110cda8942$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $d2wgE.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 1:
                                response = _context5.sent;
                                _context5.next = 2;
                                return this.handleResponseError(response);
                            case 2:
                                _context5.next = 3;
                                return this.extractResponseBody(response);
                            case 3:
                                return _context5.abrupt("return", _context5.sent);
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $767897110cda8942$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($767897110cda8942$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($767897110cda8942$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("bZdoy", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $0240833aa956a680$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $0240833aa956a680$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $0240833aa956a680$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
var $0240833aa956a680$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
var $0240833aa956a680$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});

parcelRegister("d2wgE", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $97e47df4b9be832a$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $97e47df4b9be832a$export$a59f8d67326bd1cb = "6.0.2";

});

parcelRegister("gop3x", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $bef252d55b5dcbf9$export$286baf652d0b1206);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $bef252d55b5dcbf9$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $bef252d55b5dcbf9$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $bef252d55b5dcbf9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($bef252d55b5dcbf9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $bef252d55b5dcbf9$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ResponseError);
        return $bef252d55b5dcbf9$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});


parcelRegister("4FLIT", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $367002913ec7dcc9$export$d119b37e5f788b43);

var $25nEq = parcelRequire("25nEq");

var $cH0tm = parcelRequire("cH0tm");

var $bZdoy = parcelRequire("bZdoy");
function $367002913ec7dcc9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $367002913ec7dcc9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $367002913ec7dcc9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $367002913ec7dcc9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $367002913ec7dcc9$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $367002913ec7dcc9$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $cH0tm.isFedRamp)() ? (0, $bZdoy.PerimeterType).FEDRAMP_MODERATE : (0, $bZdoy.PerimeterType).COMMERCIAL
    }, options);
};

});
parcelRegister("cH0tm", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $93d9de04c13a3e95$export$64d6499adf9b2e51);

var $6d3fd = parcelRequire("6d3fd");
function $93d9de04c13a3e95$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $6d3fd.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("6d3fd", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $4856793f5447c46e$export$ce553301d55c2fd8);
var $4856793f5447c46e$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $4856793f5447c46e$export$f005e2e9f707cb5f = 'commercial';
var $4856793f5447c46e$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $4856793f5447c46e$export$a739cd5aac835909 = 'stg';
var $4856793f5447c46e$export$42dd0cdd351a4a9 = 'prod';
var $4856793f5447c46e$export$404582bc18fe4d9e = 'dev';

});



parcelRegister("aRIsI", function(module, exports) {
$parcel$export(module.exports, "migrateInitializationOptions", () => $7e9157e2da86b364$export$202946b690d26d22);

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");
var $7e9157e2da86b364$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $7e9157e2da86b364$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7e9157e2da86b364$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7e9157e2da86b364$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7e9157e2da86b364$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7e9157e2da86b364$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(options, $7e9157e2da86b364$var$_excluded);
    return $7e9157e2da86b364$var$_objectSpread($7e9157e2da86b364$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};

});

parcelRegister("1BNqg", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $12bf95791d73e75b$export$55fffef3474104af);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");
function $12bf95791d73e75b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $12bf95791d73e75b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $12bf95791d73e75b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $12bf95791d73e75b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $12bf95791d73e75b$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $12bf95791d73e75b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $12bf95791d73e75b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($12bf95791d73e75b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $12bf95791d73e75b$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $12bf95791d73e75b$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoFetchDataAdapter);
        _this = $12bf95791d73e75b$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $12bf95791d73e75b$var$_objectSpread($12bf95791d73e75b$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $12bf95791d73e75b$var$_objectSpread($12bf95791d73e75b$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $12bf95791d73e75b$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $12bf95791d73e75b$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));

});

parcelRegister("djiCr", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $9b0b7e15cb638936$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $9b0b7e15cb638936$export$bcb28fbac1def494);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $dtn6l = parcelRequire("dtn6l");
function $9b0b7e15cb638936$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9b0b7e15cb638936$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9b0b7e15cb638936$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9b0b7e15cb638936$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9b0b7e15cb638936$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $9b0b7e15cb638936$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $9b0b7e15cb638936$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $9b0b7e15cb638936$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $9b0b7e15cb638936$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $9b0b7e15cb638936$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $9b0b7e15cb638936$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $9b0b7e15cb638936$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $9b0b7e15cb638936$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $9b0b7e15cb638936$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $9b0b7e15cb638936$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $9b0b7e15cb638936$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PersistentOverrideAdapter);
        this._overrides = $9b0b7e15cb638936$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $9b0b7e15cb638936$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $9b0b7e15cb638936$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $9b0b7e15cb638936$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($9b0b7e15cb638936$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.removeItem($9b0b7e15cb638936$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $9b0b7e15cb638936$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $9b0b7e15cb638936$var$_objectSpread($9b0b7e15cb638936$var$_objectSpread({}, $9b0b7e15cb638936$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($9b0b7e15cb638936$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($9b0b7e15cb638936$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($9b0b7e15cb638936$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($9b0b7e15cb638936$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $9b0b7e15cb638936$var$_objectSpread($9b0b7e15cb638936$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $9b0b7e15cb638936$var$_objectSpread($9b0b7e15cb638936$var$_objectSpread({}, current.details), {}, {
                        reason: $9b0b7e15cb638936$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($9b0b7e15cb638936$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($9b0b7e15cb638936$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($9b0b7e15cb638936$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($9b0b7e15cb638936$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($9b0b7e15cb638936$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($9b0b7e15cb638936$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $9b0b7e15cb638936$var$makeEmptyStore();
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($9b0b7e15cb638936$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $9b0b7e15cb638936$var$_objectSpread($9b0b7e15cb638936$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $9b0b7e15cb638936$var$_objectSpread($9b0b7e15cb638936$var$_objectSpread({}, current.details), {}, {
                        reason: $9b0b7e15cb638936$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($9b0b7e15cb638936$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $9b0b7e15cb638936$var$_objectSpread($9b0b7e15cb638936$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $9b0b7e15cb638936$var$_objectSpread($9b0b7e15cb638936$var$_objectSpread({}, current.details), {}, {
                        reason: $9b0b7e15cb638936$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});

parcelRegister("s3TIO", function(module, exports) {
$parcel$export(module.exports, "shallowEquals", () => $0545a3a6233d4179$export$fa1c2bbf4100b8bc);

var $iYJcE = parcelRequire("iYJcE");
var $0545a3a6233d4179$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};

});

parcelRegister("6rcSf", function(module, exports) {
$parcel$export(module.exports, "toStatsigUser", () => $4aff4031554d82e2$export$3dad1db244472f32);

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");
var $4aff4031554d82e2$var$_excluded = [
    "stableId"
];
function $4aff4031554d82e2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4aff4031554d82e2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4aff4031554d82e2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4aff4031554d82e2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4aff4031554d82e2$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    var stableId = identifiers.stableId, otherIdentifiers = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(identifiers, $4aff4031554d82e2$var$_excluded);
    var user = {
        customIDs: $4aff4031554d82e2$var$_objectSpread($4aff4031554d82e2$var$_objectSpread({}, otherIdentifiers), stableId !== undefined ? {
            stableID: stableId
        } : {}),
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};

});



parcelRegister("3ISRs", function(module, exports) {
$parcel$export(module.exports, "addFeatureFlagAccessed", () => $2b600978df6488b2$export$47fade9662f71000);

var $jG8oN = parcelRequire("jG8oN");
var $2b600978df6488b2$export$5b78c989c8db2561 = new Map();
var $2b600978df6488b2$export$2a5c8df26bb89760 = new Map();
function $2b600978df6488b2$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    var value = (0, $jG8oN.redactValue)(featureFlagValue);
    $2b600978df6488b2$export$5b78c989c8db2561.set(featureFlagName, value);
    $2b600978df6488b2$export$2a5c8df26bb89760.set(featureFlagName, value);
}

});
parcelRegister("jG8oN", function(module, exports) {
$parcel$export(module.exports, "redactValue", () => $e538746fe5d98aae$export$fcc03ee4c944962f);

var $e0epT = parcelRequire("e0epT");

var $43V9E = parcelRequire("43V9E");
function $e538746fe5d98aae$export$fcc03ee4c944962f(featureFlagValue) {
    return (0, $43V9E.shouldRedactValue)(featureFlagValue) ? (0, $e0epT.NON_BOOLEAN_VALUE) : featureFlagValue;
}

});
parcelRegister("e0epT", function(module, exports) {
$parcel$export(module.exports, "NON_BOOLEAN_VALUE", () => $a31c3f9ec8b82d8a$export$42f4885608027d0c);
var $a31c3f9ec8b82d8a$export$42f4885608027d0c = 'non_boolean';

});

parcelRegister("43V9E", function(module, exports) {
$parcel$export(module.exports, "shouldRedactValue", () => $2f53c6f21240c1a6$export$7b4abba432e57989);

var $ekGgq = parcelRequire("ekGgq");
function $2f53c6f21240c1a6$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch (_unused) {
        return false;
    }
    return false;
}
function $2f53c6f21240c1a6$var$isObject(value) {
    return value && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && value.constructor === Object;
}
function $2f53c6f21240c1a6$var$isString(input) {
    var result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (_unused2) {
        // swallow any errors
        result = false;
    }
    return result;
}
function $2f53c6f21240c1a6$export$7b4abba432e57989(value) {
    return $2f53c6f21240c1a6$var$isString(value) && $2f53c6f21240c1a6$var$startsAsObject(value) || $2f53c6f21240c1a6$var$isObject(value);
}

});



parcelRegister("2e1lj", function(module, exports) {
$parcel$export(module.exports, "editorExperimentsConfig", () => $19edee32ea77522b$export$6cbb856f286b07ef);
/* eslint-disable perfectionist/sort-object-types */ /* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $cu86p = parcelRequire("cu86p");

var $ftnoy = parcelRequire("ftnoy");
var $19edee32ea77522b$export$5c897d5297c5b7fd = [
    'platform_editor_blocks',
    'platform_editor_controls',
    'advanced_layouts',
    'single_column_layouts',
    'platform_editor_preview_panel_responsiveness',
    'platform_editor_toolbar_aifc'
];
var $19edee32ea77522b$export$6cbb856f286b07ef = {
    // new format to avoid collisions with other users when updating the file
    // Added 2026-07-18
    cc_maui_remix_button_hover_corridor: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_remix_button_hover_corridor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-24
    platform_editor_layout_column_delete_shortcut_fix: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_delete_shortcut_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-21
    // `isEnabled` is the gating param; the experiment's dynamic config also carries the numeric
    // `shimmerDurationMs` (skeleton) and `highlightDurationMs` (purple highlight) durations, read at
    // runtime via `expVal`.
    platform_editor_agent_be_streaming: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_agent_be_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Editor Platform experiments
    // lwoollard experiments
    // Added 2026-04-21
    cwr_page_tree_auto_finalize: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr_page_tree_auto_finalize'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 02-12-2025
    cc_fix_hydration_ttvc: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_hydration_ttvc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    'editor_a11y__enghealth-46814_fy26': (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y__enghealth-46814_fy26'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19
    'enghealth-53346_fix_redaction_marker_editor': (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            jira: 'enghealth-53346_fix_redaction_marker_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-16
    platform_editor_remove_important_in_render_ext: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_important_in_render_ext'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-06
    confluence_comment_nudgebar_improvement: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_comment_nudgebar_improvement'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_quick_insert_embeds: (0, $ftnoy.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_quick_insert_embeds'
        },
        param: 'cohort',
        values: [
            'control',
            'prioritizeLinkInQIM',
            'prioritizeEmbedInQIM'
        ],
        defaultValue: 'control'
    }),
    confluence_remix_icon_right_side: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_remix_icon_right_side'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_editor_insm_doc_size_stats: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_doc_size_stats'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-26
    cc_editor_fix_insm_inp_buffer: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_fix_insm_inp_buffer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    cwr_blank_object_experiment: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr_blank_object_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-08
    confluence_inline_comments_fix_stale_selection: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_inline_comments_fix_stale_selection'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    rovo_remix_experience_context: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'rovo_remix_experience_context'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-05
    'databases-native-embeds-v2': (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'databases-native-embeds-v2'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    cc_editor_insm_outlier_events: (0, $ftnoy.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_outlier_events'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-17
    platform_editor_renderer_extension_width_fix: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_extension_width_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-24
    platform_editor_media_external_badge_bbc_fix: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_external_badge_bbc_fix',
            bitbucket: 'platform_editor_media_external_badge_bbc_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-20
    platform_editor_annotations_sync_on_docchange: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_annotations_sync_on_docchange'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $ftnoy.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_per_plugin_error_boundary: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_per_plugin_error_boundary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-05
    'company_hub_carousel_thumbnails-refactor': (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'company_hub_carousel_thumbnails-refactor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $ftnoy.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_paste_actions_menu: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-19
    platform_editor_controls_reliable_anchor: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_reliable_anchor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $ftnoy.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls',
            jira: 'platform_editor_controls_jira'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-07-21
    confluence_cwr_3p_connection_suggested_prompts: (0, $ftnoy.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_cwr_3p_connection_suggested_prompts'
        },
        param: 'cohort',
        values: [
            'control',
            'variant_a',
            'variant_b'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-05-26
    platform_editor_agent_mentions: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_agent_mentions',
            jira: 'platform_editor_agent_mentions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    platform_editor_reduced_agent_profile_cards: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_reduced_agent_profile_cards',
            jira: 'platform_editor_reduced_agent_profile_cards'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-30
    platform_editor_fix_link_paste_menu: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_link_paste_menu',
            jira: 'platform_editor_fix_link_paste_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_code_block_q4_lovability: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_code_block_q4_lovability',
            jira: 'platform_editor_code_block_q4_lovability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-17-03
    platform_editor_media_name_fallback: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_name_fallback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-12
    platform_editor_media_name_fallback_viewer_card: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_name_fallback_viewer_card'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-16
    platform_editor_enable_single_player_step_merging: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enable_single_player_step_merging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_hide_overflow_menu: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_hide_overflow_menu',
            jira: 'platform_editor_toolbar_hide_overflow_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_responsiveness'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $ftnoy.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-06-25
    jira_editor_a11y_toolbar_fixes: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'jira_editor_a11y_toolbar_fixes',
            jira: 'jira_editor_a11y_toolbar_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-09
    platform_editor_blocks: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocks_conf',
            jira: 'platform_editor_blocks_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-23
    //Added 2025-07-16
    platform_editor_toolbar_aifc: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_confluence'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_breakout_interaction_rerender: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_interaction_rerender'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_blocktaskitem_node_tenantid: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_node_tenantid'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_with_dnd: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_with_dnd'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    'editor-a11y-fy26-keyboard-move-row-column': (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor-a11y-fy26-keyboard-move-row-column',
            jira: 'editor-a11y-fy26-keyboard-move-row-column'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-28
    editor_enable_image_alignment_in_expand: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enable_image_alignment_in_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_august_a11y: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_august_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-01
    cc_editor_ai_content_mode: (0, $ftnoy.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_ai_content_mode'
        },
        param: 'variant',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-01-09
    platform_editor_render_bodied_extension_as_inline: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_render_bodied_extension_as_inline'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-03
    platform_editor_ai_quick_prompt_iw_cc: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quick_prompt_iw_cc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_use_llm_space_recommendations: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_llm_space_recommendations'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-01
    // Added 2025-10-13
    platform_editor_media_error_analytics: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_error_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-27
    platform_editor_table_sticky_header_improvements: (0, $ftnoy.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_improvements'
        },
        param: 'cohort',
        values: [
            'control',
            'test_with_overflow',
            'test_without_overflow'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-29
    platform_editor_lovability_inline_code: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_inline_code'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_lovability_emoji_scaling: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_emoji_scaling'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-18
    editor_a11y_7152_profile_card_tab_order: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y_7152_profile_card_tab_order'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-19
    platform_editor_lovability_navigation_fixes: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_navigation_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-27 — Pre-auth unauthorised inline hover card UX
    platform_sl_3p_preauth_better_hovercard: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_preauth_better_hovercard',
            jira: 'platform_sl_3p_preauth_better_hovercard'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-21 — Post-auth GDrive Smart Link to Rovo Chat auto-open
    platform_sl_3p_post_auth_chat_open_exp: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_post_auth_chat_open_exp',
            jira: 'platform_sl_3p_post_auth_chat_open_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-29 — Social proof inline CTA for unauthorised 3P inline smart links
    platform_sl_3p_preauth_social_proof_inline_cta: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_preauth_social_proof_inline_cta',
            jira: 'platform_sl_3p_preauth_social_proof_inline_cta'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15 — Embed card footer rovo action for resolved 3P smart links in confluence
    platform_sl_3p_auth_rovo_embed_footer_exp: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_auth_rovo_embed_footer_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_submenu_open_click: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_submenu_open_click'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-13
    platform_editor_hide_extension_renderer_support: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hide_extension_renderer_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-23
    platform_editor_fix_new_line_after_heading: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_new_line_after_heading',
            jira: 'platform_editor_fix_new_line_after_heading'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-21
    platform_editor_copy_link_a11y_inconsistency_fix: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_copy_link_a11y_inconsistency_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_editor_fix_lagging_embed_resize_handle: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_lagging_embed_resize_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-30
    platform_editor_fix_cross_origin_editor_focus: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_cross_origin_editor_focus'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_ttvc_inline_extensions: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_ttvc_inline_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-03
    platform_editor_enghealth_a11y_jan_fixes: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enghealth_a11y_jan_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    cc_fd_db_top_editor_toolbar: (0, $ftnoy.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_fd_db_top_editor_toolbar'
        },
        param: 'cohort',
        values: [
            'control',
            'new-description',
            'orig-description'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-04-01
    cc_page_experiences_editor_image_generation: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_page_experiences_editor_image_generation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-23
    'cc-maui-experiment': (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-maui-experiment',
            jira: 'jira_maui_remix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_maui_create_keyword: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_create_keyword'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // A/A experiment paired with cc_maui_create_keyword, used only to balance exposures.
    cc_maui_create_keyword_aa: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_create_keyword_aa'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-13
    confluence_native_tabs_experiment: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_native_tabs_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-29
    cc_maui_polish_changes_batch_4: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_maui_polish_changes_batch_4'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    'cc-mui-slides-experiment': (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-mui-slides-experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-27
    confluence_frontend_cwr_outcome_type_picker: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_frontend_cwr_outcome_type_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    cfe_cwr_outcome_picker_respect_site_settings: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'cfe_cwr_outcome_picker_respect_site_settings'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-12
    prompt_tile_content_type_localizaiton: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'prompt_tile_content_type_localizaiton'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-24
    'cwr-modal-ui-refresh': (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-modal-ui-refresh'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-08
    'cc-disambiguation-in-cwr': (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-disambiguation-in-cwr'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    'cwr-reduce-prompt-suggestion-max-chars': (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-reduce-prompt-suggestion-max-chars'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15
    'cwr-staging-area-close-as-minimize-button': (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-staging-area-close-as-minimize-button'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-08
    cc_cwr_prompt_strength_indicator: (0, $ftnoy.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_cwr_prompt_strength_indicator'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1',
            'variant2'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-02-12
    platform_editor_a11y_escape_link_dialog: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_a11y_escape_link_dialog',
            jira: 'platform_editor_a11y_escape_link_dialog'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_vc90_transition_panel_icon: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vc90_transition_panel_icon'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_emoji_default_scale: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_default_scale',
            jira: 'platform_editor_emoji_default_scale'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-17
    platform_editor_emoji_hover_show_tooltip: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_hover_show_tooltip',
            jira: 'platform_editor_emoji_hover_show_tooltip'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    platform_teamoji_26_refresh_emoji_picker: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_teamoji_26_refresh_emoji_picker',
            jira: 'platform_teamoji_26_refresh_emoji_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-16
    platform_use_unicode_emojis: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_unicode_emojis_confluence',
            jira: 'platform_use_unicode_emojis_jira',
            bitbucket: 'platform_use_unicode_emojis_bitbucket'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-26
    platform_editor_toolbar_update_jira_config: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_toolbar_update_jira_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_ai_blockmenu_integration: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_blockmenu_integration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-26
    platform_editor_remix_in_block_menu: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remix_in_block_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19 — fix table text length calculation for Remix/Improve Writing hero prompts
    remix_iw_block_menu_table_calc_fix: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'remix_iw_block_menu_table_calc_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_rovobutton_smartlink_toolbar_exp: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_rovobutton_smartlink_toolbar_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_a11y_scrollable_region: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_a11y_scrollable_region'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    confluence_fe_renderer_inline_node_mark_color_fix: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_renderer_inline_node_mark_color_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_diff_plugin_extended: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_diff_plugin_extended'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_fix_media_toolbar_border_dropdown: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_media_toolbar_border_dropdown'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-06
    platform_editor_single_player_expand: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_player_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_fit_to_content_on_demand: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_fit_to_content_on_demand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-09
    platform_editor_remove_collab_step_metrics: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_collab_step_metrics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    platform_editor_ai_normalized_telemetry: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_normalized_telemetry'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-15
    platform_editor_sync_block_ssr_config: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_sync_block_ssr_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-06
    confluence_fe_create_page_suggestion: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_create_page_suggestion'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-18
    platform_editor_selection_toolbar_block_handle: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_selection_toolbar_block_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    platform_editor_improve_preset_builder_logging: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_improve_preset_builder_logging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-23
    'cc-markdown-mode': (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-markdown-mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_ai_xstate_migration: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_xstate_migration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-31
    platform_editor_dnd_accessibility_fixes_expand: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_dnd_accessibility_fixes_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-15
    platform_editor_ai_no_stream_skip_pacer: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_no_stream_skip_pacer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-07
    platform_editor_layout_column_menu: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-29
    platform_editor_layout_column_selection_fix: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_selection_fix',
            jira: 'platform_editor_layout_column_selection_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15
    platform_editor_layout_column_valign_rendering: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_valign_rendering'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    platform_editor_external_embed_grid_fix: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_external_embed_grid_fix',
            jira: 'platform_editor_external_embed_grid_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-08
    cc_fd_wb_jira_quick_insert_experiment: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            jira: 'cc_fd_wb_jira_quick_insert_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-30
    cc_fix_editor_context_on_cwr_followups: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_editor_context_on_cwr_followups'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    cc_fix_ephemeral_preview_staging_area_registration: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_ephemeral_preview_staging_area_registration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    platform_editor_hydration_skip_react_portal: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hydration_skip_react_portal'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-28
    platform_editor_use_markdown_plus_parser: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_markdown_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_use_html_plus_parser: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_html_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    platform_editor_core_static_css: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_static_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_core_non_ecc_static_css: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_non_ecc_static_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_q4_loveability: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_q4_loveability',
            jira: 'platform_editor_table_q4_loveability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    platform_editor_table_menu_updates: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_menu_updates',
            jira: 'platform_editor_table_menu_updates'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-06
    confluence_live_doc_table_sort_bugfix: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_live_doc_table_sort_bugfix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    confluence_fe_disable_comment_if_offline_fix: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_disable_comment_if_offline_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    platform_editor_sync_block_activation: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_sync_block_activation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_paste_actions_menu_v2: (0, $ftnoy.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu_v2',
            jira: 'platform_editor_paste_actions_menu_v2'
        },
        param: 'variant',
        values: [
            'control',
            'hasSpellingAndGrammar',
            'hasAltAiActions'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-05-01 — Social proof experiment for unauthorized 3P block cards
    social_proof_3p_unauth_block_exp: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'social_proof_3p_unauth_block_exp',
            jira: 'social_proof_3p_unauth_block_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_replace_doc/setup
    platform_editor_ai_replace_doc: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_replace_doc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-18
    platform_editor_nest_table_in_panel: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nest_table_in_panel'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_rovo_support_create_inline_comment: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_rovo_support_create_inline_comment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_fix_sticky_header_malfunction: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_sticky_header_malfunction'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-17
    platform_editor_fix_sticky_header_row: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_sticky_header_row'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-10
    confluence_editor_paste_3p_link_actions_menu: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_paste_3p_link_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-29
    'a11y-fixes-week3-may-2026': (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'a11y-fixes-week3-may-2026',
            jira: 'a11y-fixes-week3-may-2026'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_reactions_selector_list: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_reactions_selector_list',
            jira: 'platform_a11y_fixes_reactions_selector_list'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_emoji_picker_list: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_emoji_picker_list',
            jira: 'platform_a11y_fixes_emoji_picker_list'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_emoji_title_shortname: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_a11y_fixes_emoji_title_shortname',
            jira: 'platform_a11y_fixes_emoji_title_shortname'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-25
    // HTML+ v2 incremental tool-call streaming contract — gates the new
    // PartialStreamParserV2 / ToolCallProcessorV2 / AdfChunkStrategyV2 stack
    // in `@atlassian/editor-rovo-bridge`, the `replaceValue` orchestrator
    // action, and the `toolCallsStreaming.supportsProvisionalToolCalls`
    // capability advert on `PageContentCommandResult`.
    platform_editor_use_html_plus_streaming_parser: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_html_plus_streaming_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_wide_slash_trigger: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_wide_slash_trigger'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11 — [CCI-15904] New AIFC Editor Experience (Full Page Staging Area + Post Stream Review Toolbar)
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_new_aifc_editor_experience/setup
    platform_editor_ai_new_aifc_editor_experience: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_new_aifc_editor_experience'
        },
        param: 'isBackendReviewMomentEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    // Gates the `GhostIconWave` animation primitive in
    // `@atlassian/rovo-platform-ui-components` — rendered as a loading cue on
    // Confluence's 3p-in-CWR (Rovo) surfaces. When off the primitive renders
    // nothing.
    confluence_3p_in_cwr_ghost_icons: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_3p_in_cwr_ghost_icons'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    platform_editor_lovability_text_bg_color: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_text_bg_color',
            jira: 'platform_editor_lovability_text_bg_color'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-20
    platform_editor_ssr_toolbar_optimistic: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ssr_toolbar_optimistic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19
    platform_editor_lovability_resize_dividers_panels: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_resize_dividers_panels'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_editor_add_breakout_marks_on_page_load: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_breakout_marks_on_page_load'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-23
    'aifc-confluence-editor-csp-fix': (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'aifc-confluence-editor-csp-fix',
            jira: 'aifc-confluence-editor-csp-fix'
        },
        param: 'value',
        defaultValue: false
    }),
    // Added 2026-07-02
    platform_editor_media_download_fallback_name: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_download_fallback_name'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-01
    platform_editor_remove_pause_streaming: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_pause_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-17
    revert_remix_ephemeral_iframe_sizing_fix: (0, $cu86p.createBooleanExperiment)({
        productKeys: {
            confluence: 'revert_remix_ephemeral_iframe_sizing_fix',
            jira: 'revert_remix_ephemeral_iframe_sizing_fix'
        },
        param: 'value',
        defaultValue: false
    }),
    // Added 2026-07-28
    cwr_publish_flow_live_doc_toggle_exp: (0, $ftnoy.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cwr_publish_flow_live_doc_toggle_exp'
        },
        param: 'cohort',
        defaultValue: 'control',
        values: [
            'control',
            'variantA',
            'variantB',
            'variantC'
        ]
    })
};

});
parcelRegister("cu86p", function(module, exports) {
$parcel$export(module.exports, "createBooleanExperiment", () => $916e9255148e62c6$export$456f1587c9c92021);

var $25nEq = parcelRequire("25nEq");

var $1gAy5 = parcelRequire("1gAy5");
function $916e9255148e62c6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $916e9255148e62c6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $916e9255148e62c6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $916e9255148e62c6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $916e9255148e62c6$export$456f1587c9c92021(config) {
    return $916e9255148e62c6$var$_objectSpread($916e9255148e62c6$var$_objectSpread({}, config), {}, {
        typeGuard: (0, $1gAy5.isBoolean),
        defaultValue: config.defaultValue
    });
}

});
parcelRegister("1gAy5", function(module, exports) {
$parcel$export(module.exports, "isBoolean", () => $0ec3a2e4b53ecbe5$export$f9ce7b637dfbe238);
function $0ec3a2e4b53ecbe5$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}

});


parcelRegister("ftnoy", function(module, exports) {
$parcel$export(module.exports, "createMultivariateExperiment", () => $b43bb63af10a7d17$export$fb89e8a786694d1);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $2Mqum = parcelRequire("2Mqum");
function $b43bb63af10a7d17$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b43bb63af10a7d17$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b43bb63af10a7d17$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b43bb63af10a7d17$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b43bb63af10a7d17$export$fb89e8a786694d1(config) {
    var values = config.values;
    return $b43bb63af10a7d17$var$_objectSpread($b43bb63af10a7d17$var$_objectSpread({}, config), {}, {
        values: (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(values),
        // Maintains the tuple
        typeGuard: (0, $2Mqum.oneOf)(config.values),
        defaultValue: config.defaultValue
    });
}

});
parcelRegister("2Mqum", function(module, exports) {
$parcel$export(module.exports, "oneOf", () => $20649c8e26d312c8$export$a9a18ae5ba42aeab);

var $3ZMUU = parcelRequire("3ZMUU");
var $20649c8e26d312c8$var$_process, $20649c8e26d312c8$var$_process2;
var $20649c8e26d312c8$var$IS_TESTING_ENV = typeof $3ZMUU !== 'undefined' && ((($20649c8e26d312c8$var$_process = $3ZMUU) === null || $20649c8e26d312c8$var$_process === void 0 || ($20649c8e26d312c8$var$_process = $20649c8e26d312c8$var$_process.env) === null || $20649c8e26d312c8$var$_process === void 0 ? void 0 : $20649c8e26d312c8$var$_process.NODE_ENV) === 'test' || (($20649c8e26d312c8$var$_process2 = $3ZMUU) === null || $20649c8e26d312c8$var$_process2 === void 0 || ($20649c8e26d312c8$var$_process2 = $20649c8e26d312c8$var$_process2.env) === null || $20649c8e26d312c8$var$_process2 === void 0 ? void 0 : $20649c8e26d312c8$var$_process2.JEST_WORKER_ID) !== undefined);
function $20649c8e26d312c8$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
   * This is used by test utils to get the variants when running describe.each
   */ if ($20649c8e26d312c8$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}

});



parcelRegister("chVel", function(module, exports) {
$parcel$export(module.exports, "_overrides", () => $8f237756efde1cef$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_product", () => $8f237756efde1cef$export$cf7305fc65acbf0d);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $tbZpy = parcelRequire("tbZpy");

var $2e1lj = parcelRequire("2e1lj");
function $8f237756efde1cef$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8f237756efde1cef$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8f237756efde1cef$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8f237756efde1cef$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8f237756efde1cef$export$e5d73bf4f8e2ae96 = {};
var $8f237756efde1cef$export$4e849416bb5c5b52 = {};
var $8f237756efde1cef$export$cf7305fc65acbf0d;
function $8f237756efde1cef$export$1c2b6dbf79eb3560(product, /**
 * Overrides are used to set the group of an experiment for testing purposes.
 * This is useful when you want to test a specific experiment group.
 */ groupOverrides, /**
 * Param overrides are used to set the experiment parameters for testing purposes.
 * This is useful when you want to tweak the experiment parameters for testing.
 */ paramOverrides, options) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        groupOverrides = Object.entries(groupOverrides).reduce(function(acc, _ref) {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
            var config = (0, $2e1lj.editorExperimentsConfig)[key];
            if (config) acc = $8f237756efde1cef$var$_objectSpread($8f237756efde1cef$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, config.typeGuard(value) ? value : config.defaultValue));
            return acc;
        }, {});
        $8f237756efde1cef$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test' && !(options !== null && options !== void 0 && options.disableTestOverrides)) {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        var testOverrides = Object.fromEntries(Object.entries((0, $2e1lj.editorExperimentsConfig)).map(function(_ref3) {
            var _ref5, _ref6, _groupOverrides, _groupOverrides2;
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), key = _ref4[0], value = _ref4[1];
            var defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                (_ref5 = (_ref6 = (_groupOverrides = (_groupOverrides2 = groupOverrides) === null || _groupOverrides2 === void 0 ? void 0 : _groupOverrides2[key]) !== null && _groupOverrides !== void 0 ? _groupOverrides : (0, $tbZpy.testMultivariateOverrides)[key]) !== null && _ref6 !== void 0 ? _ref6 : (0, $tbZpy.testBooleanOverrides)[key]) !== null && _ref5 !== void 0 ? _ref5 : defaultValue
            ];
        }));
        $8f237756efde1cef$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $8f237756efde1cef$export$cf7305fc65acbf0d = product;
    $8f237756efde1cef$export$4e849416bb5c5b52 = paramOverrides || {};
}

});
parcelRegister("tbZpy", function(module, exports) {
$parcel$export(module.exports, "testMultivariateOverrides", () => $057c0269f244a151$export$7e849a84a00ffd1c);
$parcel$export(module.exports, "testBooleanOverrides", () => $057c0269f244a151$export$54960937bb713f97);
var $057c0269f244a151$export$7e849a84a00ffd1c = {
    cwr_publish_flow_live_doc_toggle_exp: 'control',
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_controls: 'control',
    cc_editor_ai_content_mode: 'control',
    platform_hover_card_preview_panel: 'control',
    cc_editor_insm_outlier_events: 'test',
    platform_editor_table_sticky_header_improvements: 'test_with_overflow',
    cc_fd_db_top_editor_toolbar: 'control',
    platform_editor_paste_actions_menu_v2: 'control',
    confluence_quick_insert_embeds: 'control',
    cc_cwr_prompt_strength_indicator: 'control',
    confluence_cwr_3p_connection_suggested_prompts: 'control'
};
var $057c0269f244a151$export$54960937bb713f97 = {
    cc_maui_polish_changes_batch_4: false,
    social_proof_3p_unauth_block_exp: false,
    platform_sl_3p_preauth_better_hovercard: true,
    cwr_blank_object_experiment: false,
    platform_editor_preview_panel_responsiveness: false,
    'enghealth-53346_fix_redaction_marker_editor': false,
    platform_editor_toolbar_aifc: false,
    'test-new-experiments-package': false,
    platform_renderer_table_sticky_scrollbar: false,
    advanced_layouts: false,
    single_column_layouts: false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_editor_tables_table_selector: false,
    platform_renderer_fix_analytics_memo_callback: false,
    'jira-work-sync-desc-comment-summary': false,
    platform_editor_breakout_resizing: false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_enable_single_player_step_merging: false,
    platform_editor_paste_actions_menu: false,
    platform_editor_table_fit_to_content_on_demand: false,
    platform_editor_table_q4_loveability: false,
    platform_editor_table_menu_updates: false,
    'cwr-modal-ui-refresh': false,
    'cc-disambiguation-in-cwr': false,
    'cwr-reduce-prompt-suggestion-max-chars': false,
    'cwr-staging-area-close-as-minimize-button': false,
    prompt_tile_content_type_localizaiton: false,
    // [CCI-15904] New AIFC Editor Experience — read by the inline chat prompt view
    // in `conversation-assistant-chat-prompt-input`. Review moment eligibility is a
    // separate check (`editor-plugin-ai/src/ui/utils/review-moment-enabled.ts`) and
    // does not read this key.
    platform_editor_ai_new_aifc_editor_experience: false,
    cc_page_experiences_editor_image_generation: false,
    platform_use_unicode_emojis: false,
    platform_editor_emoji_hover_show_tooltip: false,
    'aifc-confluence-editor-csp-fix': false
};

});




parcelRegister("6wdjf", function(module, exports) {
$parcel$export(module.exports, "RECENTS_COLLECTION", () => $4bf00e358f4f576d$export$860a16125e30000b);
$parcel$export(module.exports, "FILE_CACHE_MAX_AGE", () => $4bf00e358f4f576d$export$bd6e8fe09a90927b);
$parcel$export(module.exports, "MAX_RESOLUTION", () => $4bf00e358f4f576d$export$6e70f30e392bc53f);
$parcel$export(module.exports, "CHUNK_SIZE", () => $4bf00e358f4f576d$export$c1abb8bab1e615cd);
$parcel$export(module.exports, "PROCESSING_BATCH_SIZE", () => $4bf00e358f4f576d$export$3d5157f0def70e54);
$parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", () => $4bf00e358f4f576d$export$f14f521f3d306044);
$parcel$export(module.exports, "FILE_READER_FALLBACK_ERROR_NAME", () => $4bf00e358f4f576d$export$b3e78a9a23c941e9);

var $8Jxs4 = parcelRequire("8Jxs4");
var $4bf00e358f4f576d$export$860a16125e30000b = 'recents';
var $4bf00e358f4f576d$export$bd6e8fe09a90927b = 2592000; // Retain for 30 days
var $4bf00e358f4f576d$export$6e70f30e392bc53f = 4096;
var $4bf00e358f4f576d$export$c1abb8bab1e615cd = 5 * (0, $8Jxs4.DATA_UNIT).MB;
var $4bf00e358f4f576d$export$3d5157f0def70e54 = 1000;
var $4bf00e358f4f576d$export$f14f521f3d306044 = 2 * (0, $8Jxs4.DATA_UNIT).TB;
var $4bf00e358f4f576d$export$b3e78a9a23c941e9 = 'FileReaderError';

});
parcelRegister("8Jxs4", function(module, exports) {
$parcel$export(module.exports, "DATA_UNIT", () => $65bc7986605cb6d5$export$76cfea4c354af843);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ // Warning! You can't add new media file processing status!
// See packages/media/media-core/src/__tests__/cache-backward-compatibility.spec.ts


var $65bc7986605cb6d5$export$76cfea4c354af843 = /*#__PURE__*/ function(DATA_UNIT) {
    DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
    DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
    DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
    return DATA_UNIT;
}({});

});


parcelRegister("kL5wX", function(module, exports) {
$parcel$export(module.exports, "getFileStreamsCache", () => $f1cc7cb514970727$export$f2f061938c1e6810);

var $cAzN4 = parcelRequire("cAzN4");
var $f1cc7cb514970727$var$streamCache;

var $f1cc7cb514970727$export$f2f061938c1e6810 = function getFileStreamsCache() {
    if (!$f1cc7cb514970727$var$streamCache) {
        // TODO: we can move this into a static import like
        // import {mediaState} from '@atlaskit/media-core'
        var mediaState = (parcelRequire("k5fWJ")).mediaState;
        $f1cc7cb514970727$var$streamCache = new (0, $cAzN4.StreamsCache)(mediaState.streams);
    }
    return $f1cc7cb514970727$var$streamCache;
};

});
parcelRegister("cAzN4", function(module, exports) {
$parcel$export(module.exports, "StreamsCache", () => $92a49c12a0868447$export$4293896e79732236);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");
var $92a49c12a0868447$export$4293896e79732236 = /*#__PURE__*/ function() {
    function StreamsCache(streams) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, StreamsCache);
        this.streams = streams;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(StreamsCache, [
        {
            key: "has",
            value: function has(id) {
                return !!this.streams.find(id);
            }
        },
        {
            key: "set",
            value: function set(id, stream) {
                this.streams.set(id, stream);
            }
        },
        {
            key: "get",
            value: function get(id) {
                return this.streams.get(id);
            }
        },
        {
            key: "getOrInsert",
            value: function getOrInsert(id, callback) {
                if (!this.has(id)) this.set(id, callback());
                return this.get(id);
            }
        },
        {
            key: "removeAll",
            value: function removeAll() {
                this.streams.clear();
            }
        },
        {
            key: "remove",
            value: function remove(id) {
                this.streams.delete(id);
            }
        },
        {
            key: "size",
            get: function get() {
                return this.streams.size;
            }
        }
    ]);
}();

});

parcelRegister("k5fWJ", function(module, exports) {
$parcel$export(module.exports, "mediaState", () => $e9f0a4dca062f6d2$export$8cef61637918b288);

var $fxEK3 = parcelRequire("fxEK3");

var $eqZL4 = parcelRequire("eqZL4");
var $e9f0a4dca062f6d2$export$8cef61637918b288 = {
    streams: new (0, $eqZL4.LRUMap)(1000),
    stateDeferreds: new Map(),
    eventEmitter: new (0, $fxEK3.EventEmitter2)()
};

});
parcelRegister("eqZL4", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});



parcelRegister("hP1cj", function(module, exports) {
$parcel$export(module.exports, "globalMediaEventEmitter", () => $cf9820ed08c8dff5$export$68d003d3105952ad);

var $k5fWJ = parcelRequire("k5fWJ");
var $cf9820ed08c8dff5$export$68d003d3105952ad = {
    on: function on(event, listener) {
        if ((0, $k5fWJ.mediaState).eventEmitter) (0, $k5fWJ.mediaState).eventEmitter.on(event, listener);
    },
    off: function off(event, listener) {
        if ((0, $k5fWJ.mediaState).eventEmitter) (0, $k5fWJ.mediaState).eventEmitter.off(event, listener);
    },
    emit: function emit(event, payload) {
        if ((0, $k5fWJ.mediaState).eventEmitter) return (0, $k5fWJ.mediaState).eventEmitter.emit(event, payload);
        return undefined;
    }
};

});

parcelRegister("cxmef", function(module, exports) {
$parcel$export(module.exports, "CommonMediaClientError", () => $9209cf44526de122$export$e574d1724215079f);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $ij82I = parcelRequire("ij82I");
function $9209cf44526de122$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $9209cf44526de122$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $9209cf44526de122$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9209cf44526de122$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $9209cf44526de122$export$e574d1724215079f = /*#__PURE__*/ function(_BaseMediaClientError) {
    function CommonMediaClientError(reason, metadata, innerError) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, CommonMediaClientError);
        return $9209cf44526de122$var$_callSuper(this, CommonMediaClientError, [
            reason,
            metadata,
            innerError
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(CommonMediaClientError, _BaseMediaClientError);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(CommonMediaClientError, [
        {
            key: "attributes",
            get: function get() {
                return {
                    reason: this.reason
                };
            }
        }
    ]);
}((0, $ij82I.BaseMediaClientError));

});
parcelRegister("ij82I", function(module, exports) {
$parcel$export(module.exports, "BaseMediaClientError", () => $d5403d732343235c$export$2b0aca14d61c3190);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $d5403d732343235c$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $d5403d732343235c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $d5403d732343235c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d5403d732343235c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $d5403d732343235c$export$2b0aca14d61c3190 = /*#__PURE__*/ function(_Error) {
    function BaseMediaClientError(reason, metadata, innerError) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, BaseMediaClientError);
        _this = $d5403d732343235c$var$_callSuper(this, BaseMediaClientError, [
            reason
        ]);
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        _this.reason = reason;
        _this.metadata = metadata;
        _this.innerError = innerError;
        Object.setPrototypeOf(_this, (this instanceof BaseMediaClientError ? this.constructor : void 0).prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(_this, this instanceof BaseMediaClientError ? this.constructor : void 0);
        return _this;
    }
    // TODO: Deprecate attributes getter https://product-fabric.atlassian.net/browse/CXP-4665
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(BaseMediaClientError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(BaseMediaClientError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});


parcelRegister("5c5VR", function(module, exports) {
$parcel$export(module.exports, "fromCommonMediaClientError", () => $3c82acc6eb208f25$export$c2b89b9a32286816);

var $25nEq = parcelRequire("25nEq");
function $3c82acc6eb208f25$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3c82acc6eb208f25$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3c82acc6eb208f25$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3c82acc6eb208f25$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3c82acc6eb208f25$export$c2b89b9a32286816 = function fromCommonMediaClientError(id, occurrenceKey, error) {
    return {
        status: 'error',
        id: id,
        occurrenceKey: occurrenceKey,
        reason: error.reason,
        details: $3c82acc6eb208f25$var$_objectSpread({
            /** Use this attr to translate back into CommonMediaClientError (toCommonMediaClientError) */ error: {
                reason: error === null || error === void 0 ? void 0 : error.reason,
                metadata: error === null || error === void 0 ? void 0 : error.metadata,
                innerError: error === null || error === void 0 ? void 0 : error.innerError
            }
        }, error === null || error === void 0 ? void 0 : error.attributes),
        message: error === null || error === void 0 ? void 0 : error.message
    };
};

});

parcelRegister("4iAx6", function(module, exports) {
$parcel$export(module.exports, "isCommonMediaClientError", () => $32152e86bde48fda$export$881f0f9bc813e1f3);

var $cxmef = parcelRequire("cxmef");
function $32152e86bde48fda$export$881f0f9bc813e1f3(error) {
    if (!error) return false;
    // Check if the error is an instance of Error
    if (error instanceof (0, $cxmef.CommonMediaClientError)) return true;
    return typeof error.reason === 'string' && ('metadata' in error || error.metadata === undefined) && ('innerError' in error || error.innerError === undefined);
}

});

parcelRegister("17rlx", function(module, exports) {
$parcel$export(module.exports, "isErrorFileState", () => $0d0ba84ea545d8ef$export$f863e1e09c8a926);
var $0d0ba84ea545d8ef$export$f863e1e09c8a926 = function isErrorFileState(fileState) {
    return fileState.status === 'error';
};

});

parcelRegister("k4lMe", function(module, exports) {
$parcel$export(module.exports, "isFinalFileState", () => $e9c512d39140a2c3$export$270b3fc27120edd0);
var $e9c512d39140a2c3$export$270b3fc27120edd0 = function isFinalFileState(fileState) {
    return [
        'processed',
        'failed-processing',
        'error'
    ].includes(fileState.status);
};

});

parcelRegister("52yBi", function(module, exports) {
$parcel$export(module.exports, "isNotFoundMediaItemDetails", () => $3ab7fa988a90b9b2$export$fd27d7abbc4a746d);
var $3ab7fa988a90b9b2$export$fd27d7abbc4a746d = function isNotFoundMediaItemDetails(itemDetails) {
    return 'type' in itemDetails && itemDetails.type === 'not-found';
};

});

parcelRegister("6ozP5", function(module, exports) {
$parcel$export(module.exports, "isProcessingFileState", () => $4a80c5b021e09d6b$export$5c30e6dd75278e66);
var $4a80c5b021e09d6b$export$5c30e6dd75278e66 = function isProcessingFileState(fileState) {
    return fileState.status === 'processing';
};

});

parcelRegister("iPJdn", function(module, exports) {
$parcel$export(module.exports, "mapMediaFileToFileState", () => $db60101d1505a365$export$ddfd67d20657322f);

var $25nEq = parcelRequire("25nEq");
function $db60101d1505a365$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $db60101d1505a365$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $db60101d1505a365$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $db60101d1505a365$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $db60101d1505a365$export$ddfd67d20657322f = function mapMediaFileToFileState(mediaFile) {
    var _mediaFile$data = mediaFile.data, id = _mediaFile$data.id, name = _mediaFile$data.name, size = _mediaFile$data.size, processingStatus = _mediaFile$data.processingStatus, artifacts = _mediaFile$data.artifacts, mediaType = _mediaFile$data.mediaType, mimeType = _mediaFile$data.mimeType, representations = _mediaFile$data.representations, createdAt = _mediaFile$data.createdAt, metadataTraceContext = _mediaFile$data.metadataTraceContext, hash = _mediaFile$data.hash, abuseClassification = _mediaFile$data.abuseClassification, mediaMetadata = _mediaFile$data.mediaMetadata, failReason = _mediaFile$data.failReason, previewCdnUrl = _mediaFile$data.previewCdnUrl;
    var baseState = {
        id: id,
        name: name,
        size: size,
        mediaType: mediaType,
        mimeType: mimeType,
        artifacts: artifacts,
        representations: representations,
        createdAt: createdAt,
        hash: hash,
        metadataTraceContext: metadataTraceContext,
        abuseClassification: abuseClassification,
        mediaMetadata: mediaMetadata,
        previewCdnUrl: previewCdnUrl
    };
    switch(processingStatus){
        case 'pending':
        case undefined:
            return $db60101d1505a365$var$_objectSpread($db60101d1505a365$var$_objectSpread({}, baseState), {}, {
                status: 'processing'
            });
        case 'succeeded':
            return $db60101d1505a365$var$_objectSpread($db60101d1505a365$var$_objectSpread({}, baseState), {}, {
                status: 'processed'
            });
        case 'failed':
            return $db60101d1505a365$var$_objectSpread($db60101d1505a365$var$_objectSpread({}, baseState), {}, {
                status: 'failed-processing',
                failReason: failReason
            });
    }
};

});

parcelRegister("ey77r", function(module, exports) {
$parcel$export(module.exports, "mapMediaItemToFileState", () => $a979c35c532c3848$export$ea3730792e8bebfb);

var $25nEq = parcelRequire("25nEq");

var $iPJdn = parcelRequire("iPJdn");
function $a979c35c532c3848$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a979c35c532c3848$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a979c35c532c3848$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a979c35c532c3848$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a979c35c532c3848$export$ea3730792e8bebfb = function mapMediaItemToFileState(id, item) {
    return (0, $iPJdn.mapMediaFileToFileState)({
        data: $a979c35c532c3848$var$_objectSpread({
            id: id
        }, item)
    });
};

});

parcelRegister("jDqk1", function(module, exports) {
$parcel$export(module.exports, "uploadFile", () => $e4b613d1d0a2d37c$export$a5575dbeeffdad98);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $1zWpA = parcelRequire("1zWpA");

var $hU1R1 = parcelRequire("hU1R1");

var $3Hq8H = parcelRequire("3Hq8H");

var $6wdjf = parcelRequire("6wdjf");

var $ecRkm = parcelRequire("ecRkm");

var $1HOKE = parcelRequire("1HOKE");

var $aOwsm = parcelRequire("aOwsm");
// TODO: Allow to pass multiple files
var $e4b613d1d0a2d37c$var$_hashingFunction = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(blob, hashAlgorithm) {
        var hasher;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 1;
                    return (0, $ecRkm.createHasher)(hashAlgorithm);
                case 1:
                    hasher = _context.sent;
                    return _context.abrupt("return", hasher.hash(blob));
                case 2:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function hashingFunction(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var $e4b613d1d0a2d37c$var$createUploadingFunction = function createUploadingFunction(store, deferredUploadId, collectionName, traceContext) {
    return /*#__PURE__*/ function() {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(chunk) {
            var _t, _t2, _t3;
            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        _t = store;
                        _t2 = chunk.hash;
                        _t3 = chunk.blob;
                        _context2.next = 1;
                        return deferredUploadId;
                    case 1:
                        _context2.next = 2;
                        return _t.uploadChunk.call(_t, _t2, _t3, _context2.sent, chunk.partNumber, collectionName, traceContext);
                    case 2:
                        return _context2.abrupt("return", _context2.sent);
                    case 3:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2);
        }));
        return function(_x3) {
            return _ref2.apply(this, arguments);
        };
    }();
};
var $e4b613d1d0a2d37c$var$createProcessingFunction = function createProcessingFunction(store, deferredUploadId, collection, traceContext, size) {
    var offset = 0;
    return /*#__PURE__*/ function() {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(chunks) {
            var _t4;
            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                while(true)switch(_context3.prev = _context3.next){
                    case 0:
                        _t4 = store;
                        _context3.next = 1;
                        return deferredUploadId;
                    case 1:
                        _context3.next = 2;
                        return _t4.appendChunksToUpload.call(_t4, _context3.sent, {
                            chunks: $e4b613d1d0a2d37c$var$hashedChunks(chunks),
                            offset: offset
                        }, collection, traceContext, {
                            expectedFileSize: size
                        });
                    case 2:
                        offset += chunks.length;
                    case 3:
                    case "end":
                        return _context3.stop();
                }
            }, _callee3);
        }));
        return function(_x4) {
            return _ref3.apply(this, arguments);
        };
    }();
};
var $e4b613d1d0a2d37c$var$createFileFromUpload = /*#__PURE__*/ function() {
    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(file, store, uploadableFileUpfrontIds, uploadId, traceContext) {
        var collection, name, mimeType, content, id, occurrenceKey;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    collection = file.collection, name = file.name, mimeType = file.mimeType, content = file.content;
                    id = uploadableFileUpfrontIds.id, occurrenceKey = uploadableFileUpfrontIds.occurrenceKey; // If the file is a Blob and the size is not passed from consumer, set the file size from file content
                    if (content instanceof Blob && !file.size) file.size = content.size;
                    return _context4.abrupt("return", store.createFileFromUpload({
                        uploadId: uploadId,
                        name: name,
                        mimeType: mimeType,
                        conditions: {
                            size: file.size
                        }
                    }, {
                        occurrenceKey: occurrenceKey,
                        collection: collection,
                        replaceFileId: id
                    }, traceContext, {
                        expectedFileSize: file.size
                    }));
                case 1:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function createFileFromUpload(_x5, _x6, _x7, _x8, _x9) {
        return _ref4.apply(this, arguments);
    };
}();
var $e4b613d1d0a2d37c$export$a5575dbeeffdad98 = function uploadFile(file, store, uploadableFileUpfrontIds, callbacks, traceContext) {
    var content = file.content, collection = file.collection;
    var deferredUploadId = uploadableFileUpfrontIds.deferredUploadId, id = uploadableFileUpfrontIds.id, occurrenceKey = uploadableFileUpfrontIds.occurrenceKey;
    var chunkSize = (0, $6wdjf.CHUNK_SIZE);
    try {
        if (content instanceof Blob) chunkSize = (0, $1HOKE.calculateChunkSize)(content.size);
    } catch (err) {
        if (err instanceof Error && err.message === (0, $1HOKE.fileSizeError)) callbacks === null || callbacks === void 0 || callbacks.onUploadFinish(new (0, $aOwsm.UploaderError)(err.message, {
            id: id,
            collectionName: collection,
            occurrenceKey: occurrenceKey
        }));
        return {
            cancel: function cancel() {
                callbacks === null || callbacks === void 0 || callbacks.onUploadFinish('canceled');
            }
        };
    }
    var chunkinatorObservable = (0, $3Hq8H.chunkinator)(content, {
        hashingFunction: function hashingFunction(blob) {
            return $e4b613d1d0a2d37c$var$_hashingFunction(blob, store.chunkHashAlgorithm);
        },
        hashingConcurrency: 5,
        chunkSize: chunkSize,
        uploadingConcurrency: 3,
        uploadingFunction: $e4b613d1d0a2d37c$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
        processingBatchSize: (0, $6wdjf.PROCESSING_BATCH_SIZE),
        processingFunction: $e4b613d1d0a2d37c$var$createProcessingFunction(store, deferredUploadId, collection, traceContext, file.size)
    }, {
        onProgress: function onProgress(progress) {
            if (callbacks) callbacks.onProgress(progress);
        }
    });
    var onUploadFinish = callbacks && callbacks.onUploadFinish || function() {};
    var subscription = (0, $1zWpA.from)(deferredUploadId).pipe((0, $hU1R1.concatMap)(function(uploadId) {
        return chunkinatorObservable.pipe((0, $hU1R1.concatMap)(function() {
            return (0, $1zWpA.from)($e4b613d1d0a2d37c$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext));
        }));
    })).subscribe({
        error: function error(err) {
            return onUploadFinish(err);
        },
        complete: function complete() {
            return onUploadFinish();
        }
    });
    return {
        cancel: function cancel() {
            subscription.unsubscribe();
            onUploadFinish('canceled');
        }
    };
};
var $e4b613d1d0a2d37c$var$hashedChunks = function hashedChunks(chunks) {
    return chunks.map(function(chunk) {
        return chunk.hash;
    });
};

});
parcelRegister("1zWpA", function(module, exports) {
$parcel$export(module.exports, "from", () => $12665eaa35af72c8$export$6788812c4e6611e6, (v) => $12665eaa35af72c8$export$6788812c4e6611e6 = v);
var $12665eaa35af72c8$export$6788812c4e6611e6;
"use strict";

var $l7nhh = parcelRequire("l7nhh");
$12665eaa35af72c8$export$6788812c4e6611e6 = $l7nhh.FromObservable.create;

});
parcelRegister("l7nhh", function(module, exports) {
"use strict";
var $f5fc4ee3c0e1abb4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $PE2Cj = parcelRequire("PE2Cj");

var $7ZlqO = parcelRequire("7ZlqO");

var $dA7Lt = parcelRequire("dA7Lt");

var $4aw8t = parcelRequire("4aw8t");

var $jb6uA = parcelRequire("jb6uA");

var $603ID = parcelRequire("603ID");

var $7yiVr = parcelRequire("7yiVr");

var $5DE9G = parcelRequire("5DE9G");

var $lryMy = parcelRequire("lryMy");

var $lPK1b = parcelRequire("lPK1b");

var $gZzrm = parcelRequire("gZzrm");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $f5fc4ee3c0e1abb4$var$FromObservable = function(_super) {
    $f5fc4ee3c0e1abb4$var$__extends(FromObservable, _super);
    function FromObservable(ish, scheduler) {
        _super.call(this, null);
        this.ish = ish;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable from an Array, an array-like object, a Promise, an
     * iterable object, or an Observable-like object.
     *
     * <span class="informal">Converts almost anything to an Observable.</span>
     *
     * <img src="./img/from.png" width="100%">
     *
     * Convert various other objects and data types into Observables. `from`
     * converts a Promise or an array-like or an
     * [iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
     * object into an Observable that emits the items in that promise or array or
     * iterable. A String, in this context, is treated as an array of characters.
     * Observable-like objects (contains a function named with the ES2015 Symbol
     * for Observable) can also be converted through this operator.
     *
     * @example <caption>Converts an array to an Observable</caption>
     * var array = [10, 20, 30];
     * var result = Rx.Observable.from(array);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 10 20 30
     *
     * @example <caption>Convert an infinite iterable (from a generator) to an Observable</caption>
     * function* generateDoubles(seed) {
     *   var i = seed;
     *   while (true) {
     *     yield i;
     *     i = 2 * i; // double it
     *   }
     * }
     *
     * var iterator = generateDoubles(3);
     * var result = Rx.Observable.from(iterator).take(10);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 3 6 12 24 48 96 192 384 768 1536
     *
     * @see {@link create}
     * @see {@link fromEvent}
     * @see {@link fromEventPattern}
     * @see {@link fromPromise}
     *
     * @param {ObservableInput<T>} ish A subscribable object, a Promise, an
     * Observable-like, an Array, an iterable or an array-like object to be
     * converted.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * emissions of values.
     * @return {Observable<T>} The Observable whose values are originally from the
     * input object that was converted.
     * @static true
     * @name from
     * @owner Observable
     */ FromObservable.create = function(ish, scheduler) {
        if (ish != null) {
            if (typeof ish[$gZzrm.observable] === 'function') {
                if (ish instanceof $lryMy.Observable && !scheduler) return ish;
                return new FromObservable(ish, scheduler);
            } else if ($PE2Cj.isArray(ish)) return new $603ID.ArrayObservable(ish, scheduler);
            else if ($dA7Lt.isPromise(ish)) return new $4aw8t.PromiseObservable(ish, scheduler);
            else if (typeof ish[$5DE9G.iterator] === 'function' || typeof ish === 'string') return new $jb6uA.IteratorObservable(ish, scheduler);
            else if ($7ZlqO.isArrayLike(ish)) return new $7yiVr.ArrayLikeObservable(ish, scheduler);
        }
        throw new TypeError((ish !== null && typeof ish || ish) + ' is not observable');
    };
    /** @deprecated internal use only */ FromObservable.prototype._subscribe = function(subscriber) {
        var ish = this.ish;
        var scheduler = this.scheduler;
        if (scheduler == null) return ish[$gZzrm.observable]().subscribe(subscriber);
        else return ish[$gZzrm.observable]().subscribe(new $lPK1b.ObserveOnSubscriber(subscriber, scheduler, 0));
    };
    return FromObservable;
}($lryMy.Observable);
module.exports.FromObservable = $f5fc4ee3c0e1abb4$var$FromObservable;

});
parcelRegister("7ZlqO", function(module, exports) {
$parcel$export(module.exports, "isArrayLike", () => $5d0edabddbea6c06$export$1e2f57719e155213, (v) => $5d0edabddbea6c06$export$1e2f57719e155213 = v);
var $5d0edabddbea6c06$export$1e2f57719e155213;
"use strict";
$5d0edabddbea6c06$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === 'number';
};

});

parcelRegister("dA7Lt", function(module, exports) {
$parcel$export(module.exports, "isPromise", () => $9e34a9139b36a2ee$export$4369c812aac99591, (v) => $9e34a9139b36a2ee$export$4369c812aac99591 = v);
var $9e34a9139b36a2ee$export$4369c812aac99591;
"use strict";
function $9e34a9139b36a2ee$var$isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
$9e34a9139b36a2ee$export$4369c812aac99591 = $9e34a9139b36a2ee$var$isPromise;

});

parcelRegister("4aw8t", function(module, exports) {
"use strict";
var $3091060d93ffcfba$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gvBTr = parcelRequire("gvBTr");

var $lryMy = parcelRequire("lryMy");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $3091060d93ffcfba$var$PromiseObservable = function(_super) {
    $3091060d93ffcfba$var$__extends(PromiseObservable, _super);
    function PromiseObservable(promise, scheduler) {
        _super.call(this);
        this.promise = promise;
        this.scheduler = scheduler;
    }
    /**
     * Converts a Promise to an Observable.
     *
     * <span class="informal">Returns an Observable that just emits the Promise's
     * resolved value, then completes.</span>
     *
     * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
     * Observable. If the Promise resolves with a value, the output Observable
     * emits that resolved value as a `next`, and then completes. If the Promise
     * is rejected, then the output Observable emits the corresponding Error.
     *
     * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
     * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link bindCallback}
     * @see {@link from}
     *
     * @param {PromiseLike<T>} promise The promise to be converted.
     * @param {Scheduler} [scheduler] An optional IScheduler to use for scheduling
     * the delivery of the resolved value (or the rejection).
     * @return {Observable<T>} An Observable which wraps the Promise.
     * @static true
     * @name fromPromise
     * @owner Observable
     */ PromiseObservable.create = function(promise, scheduler) {
        return new PromiseObservable(promise, scheduler);
    };
    /** @deprecated internal use only */ PromiseObservable.prototype._subscribe = function(subscriber) {
        var _this = this;
        var promise = this.promise;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    subscriber.next(this.value);
                    subscriber.complete();
                }
            } else promise.then(function(value) {
                _this.value = value;
                _this._isScalar = true;
                if (!subscriber.closed) {
                    subscriber.next(value);
                    subscriber.complete();
                }
            }, function(err) {
                if (!subscriber.closed) subscriber.error(err);
            }).then(null, function(err) {
                // escape the promise trap, throw unhandled errors
                $gvBTr.root.setTimeout(function() {
                    throw err;
                });
            });
        } else if (this._isScalar) {
            if (!subscriber.closed) return scheduler.schedule($3091060d93ffcfba$var$dispatchNext, 0, {
                value: this.value,
                subscriber: subscriber
            });
        } else promise.then(function(value) {
            _this.value = value;
            _this._isScalar = true;
            if (!subscriber.closed) subscriber.add(scheduler.schedule($3091060d93ffcfba$var$dispatchNext, 0, {
                value: value,
                subscriber: subscriber
            }));
        }, function(err) {
            if (!subscriber.closed) subscriber.add(scheduler.schedule($3091060d93ffcfba$var$dispatchError, 0, {
                err: err,
                subscriber: subscriber
            }));
        }).then(null, function(err) {
            // escape the promise trap, throw unhandled errors
            $gvBTr.root.setTimeout(function() {
                throw err;
            });
        });
    };
    return PromiseObservable;
}($lryMy.Observable);
module.exports.PromiseObservable = $3091060d93ffcfba$var$PromiseObservable;
function $3091060d93ffcfba$var$dispatchNext(arg) {
    var value = arg.value, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
    }
}
function $3091060d93ffcfba$var$dispatchError(arg) {
    var err = arg.err, subscriber = arg.subscriber;
    if (!subscriber.closed) subscriber.error(err);
}

});
parcelRegister("lryMy", function(module, exports) {
$parcel$export(module.exports, "Observable", () => $f9c7199560ef97cf$export$77cea355fa80b5f4, (v) => $f9c7199560ef97cf$export$77cea355fa80b5f4 = v);
var $f9c7199560ef97cf$export$77cea355fa80b5f4;
"use strict";

var $gvBTr = parcelRequire("gvBTr");

var $l87q3 = parcelRequire("l87q3");

var $gZzrm = parcelRequire("gZzrm");

var $lKsX2 = parcelRequire("lKsX2");
/**
 * A representation of any set of values over any amount of time. This is the most basic building block
 * of RxJS.
 *
 * @class Observable<T>
 */ var $f9c7199560ef97cf$var$Observable = function() {
    /**
     * @constructor
     * @param {Function} subscribe the function that is called when the Observable is
     * initially subscribed to. This function is given a Subscriber, to which new values
     * can be `next`ed, or an `error` method can be called to raise an error, or
     * `complete` can be called to notify of a successful completion.
     */ function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) this._subscribe = subscribe;
    }
    /**
     * Creates a new Observable, with this Observable as the source, and the passed
     * operator defined as the new observable's operator.
     * @method lift
     * @param {Operator} operator the operator defining the operation to take on the observable
     * @return {Observable} a new observable with the Operator applied
     */ Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    /**
     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
     *
     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
     *
     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
     * thought.
     *
     * Apart from starting the execution of an Observable, this method allows you to listen for values
     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
     * following ways.
     *
     * The first way is creating an object that implements {@link Observer} interface. It should have methods
     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
     * be left uncaught.
     *
     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
     *
     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
     *
     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
     * It is an Observable itself that decides when these functions will be called. For example {@link of}
     * by default emits all its values synchronously. Always check documentation for how given Observable
     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
     *
     * @example <caption>Subscribe with an Observer</caption>
     * const sumObserver = {
     *   sum: 0,
     *   next(value) {
     *     console.log('Adding: ' + value);
     *     this.sum = this.sum + value;
     *   },
     *   error() { // We actually could just remove this method,
     *   },        // since we do not really care about errors right now.
     *   complete() {
     *     console.log('Sum equals: ' + this.sum);
     *   }
     * };
     *
     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
     * .subscribe(sumObserver);
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Subscribe with functions</caption>
     * let sum = 0;
     *
     * Rx.Observable.of(1, 2, 3)
     * .subscribe(
     *   function(value) {
     *     console.log('Adding: ' + value);
     *     sum = sum + value;
     *   },
     *   undefined,
     *   function() {
     *     console.log('Sum equals: ' + sum);
     *   }
     * );
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Cancel a subscription</caption>
     * const subscription = Rx.Observable.interval(1000).subscribe(
     *   num => console.log(num),
     *   undefined,
     *   () => console.log('completed!') // Will not be called, even
     * );                                // when cancelling subscription
     *
     *
     * setTimeout(() => {
     *   subscription.unsubscribe();
     *   console.log('unsubscribed!');
     * }, 2500);
     *
     * // Logs:
     * // 0 after 1s
     * // 1 after 2s
     * // "unsubscribed!" after 2.5s
     *
     *
     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
     *  Observable.
     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
     *  the error will be thrown as unhandled.
     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
     * @return {ISubscription} a subscription reference to the registered handlers
     * @method subscribe
     */ Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = $l87q3.toSubscriber(observerOrNext, error, complete);
        if (operator) operator.call(sink, this.source);
        else sink.add(this.source || !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        if (sink.syncErrorThrowable) {
            sink.syncErrorThrowable = false;
            if (sink.syncErrorThrown) throw sink.syncErrorValue;
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.syncErrorThrown = true;
            sink.syncErrorValue = err;
            sink.error(err);
        }
    };
    /**
     * @method forEach
     * @param {Function} next a handler for each value emitted by the observable
     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
     * @return {Promise} a promise that either resolves on observable completion or
     *  rejects with the handled error
     */ Observable.prototype.forEach = function(next, PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if ($gvBTr.root.Rx && $gvBTr.root.Rx.config && $gvBTr.root.Rx.config.Promise) PromiseCtor = $gvBTr.root.Rx.config.Promise;
            else if ($gvBTr.root.Promise) PromiseCtor = $gvBTr.root.Promise;
        }
        if (!PromiseCtor) throw new Error('no Promise impl found');
        return new PromiseCtor(function(resolve, reject) {
            // Must be declared in a separate statement to avoid a RefernceError when
            // accessing subscription below in the closure due to Temporal Dead Zone.
            var subscription;
            subscription = _this.subscribe(function(value) {
                if (subscription) // if there is a subscription, then we can surmise
                // the next handling is asynchronous. Any errors thrown
                // need to be rejected explicitly and unsubscribe must be
                // called manually
                try {
                    next(value);
                } catch (err) {
                    reject(err);
                    subscription.unsubscribe();
                }
                else // if there is NO subscription, then we're getting a nexted
                // value synchronously during subscription. We can just call it.
                // If it errors, Observable's `subscribe` will ensure the
                // unsubscription logic is called, then synchronously rethrow the error.
                // After that, Promise will trap the error and send it
                // down the rejection path.
                next(value);
            }, reject, resolve);
        });
    };
    /** @deprecated internal use only */ Observable.prototype._subscribe = function(subscriber) {
        return this.source.subscribe(subscriber);
    };
    /**
     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
     * @method Symbol.observable
     * @return {Observable} this instance of the observable
     */ Observable.prototype[$gZzrm.observable] = function() {
        return this;
    };
    /* tslint:enable:max-line-length */ /**
     * Used to stitch together functional operators into a chain.
     * @method pipe
     * @return {Observable} the Observable result of all of the operators having
     * been called in the order they were passed in.
     *
     * @example
     *
     * import { map, filter, scan } from 'rxjs/operators';
     *
     * Rx.Observable.interval(1000)
     *   .pipe(
     *     filter(x => x % 2 === 0),
     *     map(x => x + x),
     *     scan((acc, x) => acc + x)
     *   )
     *   .subscribe(x => console.log(x))
     */ Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i - 0] = arguments[_i];
        if (operations.length === 0) return this;
        return $lKsX2.pipeFromArray(operations)(this);
    };
    /* tslint:enable:max-line-length */ Observable.prototype.toPromise = function(PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if ($gvBTr.root.Rx && $gvBTr.root.Rx.config && $gvBTr.root.Rx.config.Promise) PromiseCtor = $gvBTr.root.Rx.config.Promise;
            else if ($gvBTr.root.Promise) PromiseCtor = $gvBTr.root.Promise;
        }
        if (!PromiseCtor) throw new Error('no Promise impl found');
        return new PromiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    // HACK: Since TypeScript inherits static properties too, we have to
    // fight against TypeScript here so Subject can have a different static create signature
    /**
     * Creates a new cold Observable by calling the Observable constructor
     * @static true
     * @owner Observable
     * @method create
     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
     * @return {Observable} a new cold observable
     */ Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
$f9c7199560ef97cf$export$77cea355fa80b5f4 = $f9c7199560ef97cf$var$Observable;

});
parcelRegister("l87q3", function(module, exports) {
$parcel$export(module.exports, "toSubscriber", () => $f62019a79f564d5a$export$2a12c2cebbfd1087, (v) => $f62019a79f564d5a$export$2a12c2cebbfd1087 = v);
var $f62019a79f564d5a$export$2a12c2cebbfd1087;
"use strict";

var $deMDi = parcelRequire("deMDi");

var $efmvI = parcelRequire("efmvI");

var $5cSKU = parcelRequire("5cSKU");
function $f62019a79f564d5a$var$toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof $deMDi.Subscriber) return nextOrObserver;
        if (nextOrObserver[$efmvI.rxSubscriber]) return nextOrObserver[$efmvI.rxSubscriber]();
    }
    if (!nextOrObserver && !error && !complete) return new $deMDi.Subscriber($5cSKU.empty);
    return new $deMDi.Subscriber(nextOrObserver, error, complete);
}
$f62019a79f564d5a$export$2a12c2cebbfd1087 = $f62019a79f564d5a$var$toSubscriber;

});

parcelRegister("gZzrm", function(module, exports) {
$parcel$export(module.exports, "observable", () => $c5edd58eaa5087c5$export$5ab46cbf6120b33a, (v) => $c5edd58eaa5087c5$export$5ab46cbf6120b33a = v);
var $c5edd58eaa5087c5$export$7e68bb2e8ecea8fe;
var $c5edd58eaa5087c5$export$5ab46cbf6120b33a;
/**
 * @deprecated use observable instead
 */ var $c5edd58eaa5087c5$export$a7c40509ff863847;
"use strict";

var $gvBTr = parcelRequire("gvBTr");
function $c5edd58eaa5087c5$var$getSymbolObservable(context) {
    var $$observable;
    var Symbol = context.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) $$observable = Symbol.observable;
        else {
            $$observable = Symbol('observable');
            Symbol.observable = $$observable;
        }
    } else $$observable = '@@observable';
    return $$observable;
}
$c5edd58eaa5087c5$export$7e68bb2e8ecea8fe = $c5edd58eaa5087c5$var$getSymbolObservable;
$c5edd58eaa5087c5$export$5ab46cbf6120b33a = $c5edd58eaa5087c5$var$getSymbolObservable($gvBTr.root);
$c5edd58eaa5087c5$export$a7c40509ff863847 = $c5edd58eaa5087c5$export$5ab46cbf6120b33a;

});

parcelRegister("lKsX2", function(module, exports) {
$parcel$export(module.exports, "pipe", () => $fd5459f2363759ca$export$a4627e546088548d, (v) => $fd5459f2363759ca$export$a4627e546088548d = v);
$parcel$export(module.exports, "pipeFromArray", () => $fd5459f2363759ca$export$71f88a61afaa14d7, (v) => $fd5459f2363759ca$export$71f88a61afaa14d7 = v);
var $fd5459f2363759ca$export$a4627e546088548d;
var $fd5459f2363759ca$export$71f88a61afaa14d7;
"use strict";

var $isVNb = parcelRequire("isVNb");
/* tslint:enable:max-line-length */ function $fd5459f2363759ca$var$pipe() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i - 0] = arguments[_i];
    return $fd5459f2363759ca$var$pipeFromArray(fns);
}
$fd5459f2363759ca$export$a4627e546088548d = $fd5459f2363759ca$var$pipe;
/* @internal */ function $fd5459f2363759ca$var$pipeFromArray(fns) {
    if (!fns) return $isVNb.noop;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}
$fd5459f2363759ca$export$71f88a61afaa14d7 = $fd5459f2363759ca$var$pipeFromArray;

});
parcelRegister("isVNb", function(module, exports) {
$parcel$export(module.exports, "noop", () => $d717abe1e2078987$export$8793edee2d425525, (v) => $d717abe1e2078987$export$8793edee2d425525 = v);
var $d717abe1e2078987$export$8793edee2d425525;
"use strict";
/* tslint:disable:no-empty */ function $d717abe1e2078987$var$noop() {}
$d717abe1e2078987$export$8793edee2d425525 = $d717abe1e2078987$var$noop;

});




parcelRegister("jb6uA", function(module, exports) {
"use strict";
var $df6414a74b370c12$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gvBTr = parcelRequire("gvBTr");

var $lryMy = parcelRequire("lryMy");

var $5DE9G = parcelRequire("5DE9G");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $df6414a74b370c12$var$IteratorObservable = function(_super) {
    $df6414a74b370c12$var$__extends(IteratorObservable, _super);
    function IteratorObservable(iterator, scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
        if (iterator == null) throw new Error('iterator cannot be null.');
        this.iterator = $df6414a74b370c12$var$getIterator(iterator);
    }
    IteratorObservable.create = function(iterator, scheduler) {
        return new IteratorObservable(iterator, scheduler);
    };
    IteratorObservable.dispatch = function(state) {
        var index = state.index, hasError = state.hasError, iterator = state.iterator, subscriber = state.subscriber;
        if (hasError) {
            subscriber.error(state.error);
            return;
        }
        var result = iterator.next();
        if (result.done) {
            subscriber.complete();
            return;
        }
        subscriber.next(result.value);
        state.index = index + 1;
        if (subscriber.closed) {
            if (typeof iterator.return === 'function') iterator.return();
            return;
        }
        this.schedule(state);
    };
    /** @deprecated internal use only */ IteratorObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, iterator = _a.iterator, scheduler = _a.scheduler;
        if (scheduler) return scheduler.schedule(IteratorObservable.dispatch, 0, {
            index: index,
            iterator: iterator,
            subscriber: subscriber
        });
        else do {
            var result = iterator.next();
            if (result.done) {
                subscriber.complete();
                break;
            } else subscriber.next(result.value);
            if (subscriber.closed) {
                if (typeof iterator.return === 'function') iterator.return();
                break;
            }
        }while (true);
    };
    return IteratorObservable;
}($lryMy.Observable);
module.exports.IteratorObservable = $df6414a74b370c12$var$IteratorObservable;
var $df6414a74b370c12$var$StringIterator = function() {
    function StringIterator(str, idx, len) {
        if (idx === void 0) idx = 0;
        if (len === void 0) len = str.length;
        this.str = str;
        this.idx = idx;
        this.len = len;
    }
    StringIterator.prototype[$5DE9G.iterator] = function() {
        return this;
    };
    StringIterator.prototype.next = function() {
        return this.idx < this.len ? {
            done: false,
            value: this.str.charAt(this.idx++)
        } : {
            done: true,
            value: undefined
        };
    };
    return StringIterator;
}();
var $df6414a74b370c12$var$ArrayIterator = function() {
    function ArrayIterator(arr, idx, len) {
        if (idx === void 0) idx = 0;
        if (len === void 0) len = $df6414a74b370c12$var$toLength(arr);
        this.arr = arr;
        this.idx = idx;
        this.len = len;
    }
    ArrayIterator.prototype[$5DE9G.iterator] = function() {
        return this;
    };
    ArrayIterator.prototype.next = function() {
        return this.idx < this.len ? {
            done: false,
            value: this.arr[this.idx++]
        } : {
            done: true,
            value: undefined
        };
    };
    return ArrayIterator;
}();
function $df6414a74b370c12$var$getIterator(obj) {
    var i = obj[$5DE9G.iterator];
    if (!i && typeof obj === 'string') return new $df6414a74b370c12$var$StringIterator(obj);
    if (!i && obj.length !== undefined) return new $df6414a74b370c12$var$ArrayIterator(obj);
    if (!i) throw new TypeError('object is not iterable');
    return obj[$5DE9G.iterator]();
}
var $df6414a74b370c12$var$maxSafeInteger = Math.pow(2, 53) - 1;
function $df6414a74b370c12$var$toLength(o) {
    var len = +o.length;
    if (isNaN(len)) return 0;
    if (len === 0 || !$df6414a74b370c12$var$numberIsFinite(len)) return len;
    len = $df6414a74b370c12$var$sign(len) * Math.floor(Math.abs(len));
    if (len <= 0) return 0;
    if (len > $df6414a74b370c12$var$maxSafeInteger) return $df6414a74b370c12$var$maxSafeInteger;
    return len;
}
function $df6414a74b370c12$var$numberIsFinite(value) {
    return typeof value === 'number' && $gvBTr.root.isFinite(value);
}
function $df6414a74b370c12$var$sign(value) {
    var valueAsNumber = +value;
    if (valueAsNumber === 0) return valueAsNumber;
    if (isNaN(valueAsNumber)) return valueAsNumber;
    return valueAsNumber < 0 ? -1 : 1;
}

});
parcelRegister("5DE9G", function(module, exports) {
$parcel$export(module.exports, "iterator", () => $41afbe3e4eaf1cad$export$6f58e2338da23f4d, (v) => $41afbe3e4eaf1cad$export$6f58e2338da23f4d = v);
var $41afbe3e4eaf1cad$export$77b88d321d1c84c6;
var $41afbe3e4eaf1cad$export$6f58e2338da23f4d;
/**
 * @deprecated use iterator instead
 */ var $41afbe3e4eaf1cad$export$9785f547d3164dac;
"use strict";

var $gvBTr = parcelRequire("gvBTr");
function $41afbe3e4eaf1cad$var$symbolIteratorPonyfill(root) {
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (!Symbol.iterator) Symbol.iterator = Symbol('iterator polyfill');
        return Symbol.iterator;
    } else {
        // [for Mozilla Gecko 27-35:](https://mzl.la/2ewE1zC)
        var Set_1 = root.Set;
        if (Set_1 && typeof new Set_1()['@@iterator'] === 'function') return '@@iterator';
        var Map_1 = root.Map;
        // required for compatability with es6-shim
        if (Map_1) {
            var keys = Object.getOwnPropertyNames(Map_1.prototype);
            for(var i = 0; i < keys.length; ++i){
                var key = keys[i];
                // according to spec, Map.prototype[@@iterator] and Map.orototype.entries must be equal.
                if (key !== 'entries' && key !== 'size' && Map_1.prototype[key] === Map_1.prototype['entries']) return key;
            }
        }
        return '@@iterator';
    }
}
$41afbe3e4eaf1cad$export$77b88d321d1c84c6 = $41afbe3e4eaf1cad$var$symbolIteratorPonyfill;
$41afbe3e4eaf1cad$export$6f58e2338da23f4d = $41afbe3e4eaf1cad$var$symbolIteratorPonyfill($gvBTr.root);
$41afbe3e4eaf1cad$export$9785f547d3164dac = $41afbe3e4eaf1cad$export$6f58e2338da23f4d;

});


parcelRegister("603ID", function(module, exports) {
"use strict";
var $45e5a0aa2d991ac8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lryMy = parcelRequire("lryMy");

var $k88pL = parcelRequire("k88pL");

var $h0t5h = parcelRequire("h0t5h");

var $UR0Fu = parcelRequire("UR0Fu");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $45e5a0aa2d991ac8$var$ArrayObservable = function(_super) {
    $45e5a0aa2d991ac8$var$__extends(ArrayObservable, _super);
    function ArrayObservable(array, scheduler) {
        _super.call(this);
        this.array = array;
        this.scheduler = scheduler;
        if (!scheduler && array.length === 1) {
            this._isScalar = true;
            this.value = array[0];
        }
    }
    ArrayObservable.create = function(array, scheduler) {
        return new ArrayObservable(array, scheduler);
    };
    /**
     * Creates an Observable that emits some values you specify as arguments,
     * immediately one after the other, and then emits a complete notification.
     *
     * <span class="informal">Emits the arguments you provide, then completes.
     * </span>
     *
     * <img src="./img/of.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the arguments given, and the complete notification thereafter. It can
     * be used for composing with other Observables, such as with {@link concat}.
     * By default, it uses a `null` IScheduler, which means the `next`
     * notifications are sent synchronously, although with a different IScheduler
     * it is possible to determine when those notifications will be delivered.
     *
     * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
     * var numbers = Rx.Observable.of(10, 20, 30);
     * var letters = Rx.Observable.of('a', 'b', 'c');
     * var interval = Rx.Observable.interval(1000);
     * var result = numbers.concat(letters).concat(interval);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link throw}
     *
     * @param {...T} values Arguments that represent `next` values to be emitted.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the `next` notifications.
     * @return {Observable<T>} An Observable that emits each given input value.
     * @static true
     * @name of
     * @owner Observable
     */ ArrayObservable.of = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i - 0] = arguments[_i];
        var scheduler = array[array.length - 1];
        if ($UR0Fu.isScheduler(scheduler)) array.pop();
        else scheduler = null;
        var len = array.length;
        if (len > 1) return new ArrayObservable(array, scheduler);
        else if (len === 1) return new $k88pL.ScalarObservable(array[0], scheduler);
        else return new $h0t5h.EmptyObservable(scheduler);
    };
    ArrayObservable.dispatch = function(state) {
        var array = state.array, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(array[index]);
        if (subscriber.closed) return;
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var array = this.array;
        var count = array.length;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(ArrayObservable.dispatch, 0, {
            array: array,
            index: index,
            count: count,
            subscriber: subscriber
        });
        else {
            for(var i = 0; i < count && !subscriber.closed; i++)subscriber.next(array[i]);
            subscriber.complete();
        }
    };
    return ArrayObservable;
}($lryMy.Observable);
module.exports.ArrayObservable = $45e5a0aa2d991ac8$var$ArrayObservable;

});
parcelRegister("k88pL", function(module, exports) {
"use strict";
var $ea7b14f9062cd5e8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lryMy = parcelRequire("lryMy");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $ea7b14f9062cd5e8$var$ScalarObservable = function(_super) {
    $ea7b14f9062cd5e8$var$__extends(ScalarObservable, _super);
    function ScalarObservable(value, scheduler) {
        _super.call(this);
        this.value = value;
        this.scheduler = scheduler;
        this._isScalar = true;
        if (scheduler) this._isScalar = false;
    }
    ScalarObservable.create = function(value, scheduler) {
        return new ScalarObservable(value, scheduler);
    };
    ScalarObservable.dispatch = function(state) {
        var done = state.done, value = state.value, subscriber = state.subscriber;
        if (done) {
            subscriber.complete();
            return;
        }
        subscriber.next(value);
        if (subscriber.closed) return;
        state.done = true;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ScalarObservable.prototype._subscribe = function(subscriber) {
        var value = this.value;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(ScalarObservable.dispatch, 0, {
            done: false,
            value: value,
            subscriber: subscriber
        });
        else {
            subscriber.next(value);
            if (!subscriber.closed) subscriber.complete();
        }
    };
    return ScalarObservable;
}($lryMy.Observable);
module.exports.ScalarObservable = $ea7b14f9062cd5e8$var$ScalarObservable;

});

parcelRegister("h0t5h", function(module, exports) {
"use strict";
var $c618ff48902a2aae$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lryMy = parcelRequire("lryMy");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $c618ff48902a2aae$var$EmptyObservable = function(_super) {
    $c618ff48902a2aae$var$__extends(EmptyObservable, _super);
    function EmptyObservable(scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits a complete notification.
     *
     * <span class="informal">Just emits 'complete', and nothing else.
     * </span>
     *
     * <img src="./img/empty.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the complete notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then complete.</caption>
     * var result = Rx.Observable.empty().startWith(7);
     * result.subscribe(x => console.log(x));
     *
     * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
     * );
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following to the console:
     * // x is equal to the count on the interval eg(0,1,2,3,...)
     * // x will occur every 1000ms
     * // if x % 2 is equal to 1 print abc
     * // if x % 2 is not equal to 1 nothing will be output
     *
     * @see {@link create}
     * @see {@link never}
     * @see {@link of}
     * @see {@link throw}
     *
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the complete notification.
     * @return {Observable} An "empty" Observable: emits only the complete
     * notification.
     * @static true
     * @name empty
     * @owner Observable
     */ EmptyObservable.create = function(scheduler) {
        return new EmptyObservable(scheduler);
    };
    EmptyObservable.dispatch = function(arg) {
        var subscriber = arg.subscriber;
        subscriber.complete();
    };
    /** @deprecated internal use only */ EmptyObservable.prototype._subscribe = function(subscriber) {
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(EmptyObservable.dispatch, 0, {
            subscriber: subscriber
        });
        else subscriber.complete();
    };
    return EmptyObservable;
}($lryMy.Observable);
module.exports.EmptyObservable = $c618ff48902a2aae$var$EmptyObservable;

});

parcelRegister("UR0Fu", function(module, exports) {
$parcel$export(module.exports, "isScheduler", () => $0aae59b6fd6752fb$export$187e35932e88c15c, (v) => $0aae59b6fd6752fb$export$187e35932e88c15c = v);
var $0aae59b6fd6752fb$export$187e35932e88c15c;
"use strict";
function $0aae59b6fd6752fb$var$isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
$0aae59b6fd6752fb$export$187e35932e88c15c = $0aae59b6fd6752fb$var$isScheduler;

});


parcelRegister("7yiVr", function(module, exports) {
"use strict";
var $57fa63973fb2be8a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lryMy = parcelRequire("lryMy");

var $k88pL = parcelRequire("k88pL");

var $h0t5h = parcelRequire("h0t5h");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $57fa63973fb2be8a$var$ArrayLikeObservable = function(_super) {
    $57fa63973fb2be8a$var$__extends(ArrayLikeObservable, _super);
    function ArrayLikeObservable(arrayLike, scheduler) {
        _super.call(this);
        this.arrayLike = arrayLike;
        this.scheduler = scheduler;
        if (!scheduler && arrayLike.length === 1) {
            this._isScalar = true;
            this.value = arrayLike[0];
        }
    }
    ArrayLikeObservable.create = function(arrayLike, scheduler) {
        var length = arrayLike.length;
        if (length === 0) return new $h0t5h.EmptyObservable();
        else if (length === 1) return new $k88pL.ScalarObservable(arrayLike[0], scheduler);
        else return new ArrayLikeObservable(arrayLike, scheduler);
    };
    ArrayLikeObservable.dispatch = function(state) {
        var arrayLike = state.arrayLike, index = state.index, length = state.length, subscriber = state.subscriber;
        if (subscriber.closed) return;
        if (index >= length) {
            subscriber.complete();
            return;
        }
        subscriber.next(arrayLike[index]);
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayLikeObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, arrayLike = _a.arrayLike, scheduler = _a.scheduler;
        var length = arrayLike.length;
        if (scheduler) return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
            arrayLike: arrayLike,
            index: index,
            length: length,
            subscriber: subscriber
        });
        else {
            for(var i = 0; i < length && !subscriber.closed; i++)subscriber.next(arrayLike[i]);
            subscriber.complete();
        }
    };
    return ArrayLikeObservable;
}($lryMy.Observable);
module.exports.ArrayLikeObservable = $57fa63973fb2be8a$var$ArrayLikeObservable;

});

parcelRegister("lPK1b", function(module, exports) {
"use strict";
var $fe520e9f9d58cb68$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $deMDi = parcelRequire("deMDi");

var $2rXhC = parcelRequire("2rXhC");
/**
 *
 * Re-emits all notifications from source Observable with specified scheduler.
 *
 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
 *
 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
 * notifications emitted by the source Observable. It might be useful, if you do not have control over
 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
 *
 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
 * little bit more, to ensure that they are emitted at expected moments.
 *
 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
 * will delay all notifications - including error notifications - while `delay` will pass through error
 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
 * for notification emissions in general.
 *
 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
 *                                               // with async scheduler by default...
 *
 * intervals
 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
 * .subscribe(val => {                           // scheduler to ensure smooth animation.
 *   someDiv.style.height = val + 'px';
 * });
 *
 * @see {@link delay}
 *
 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
 * but with provided scheduler.
 *
 * @method observeOn
 * @owner Observable
 */ function $fe520e9f9d58cb68$var$observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function observeOnOperatorFunction(source) {
        return source.lift(new $fe520e9f9d58cb68$var$ObserveOnOperator(scheduler, delay));
    };
}
module.exports.observeOn = $fe520e9f9d58cb68$var$observeOn;
var $fe520e9f9d58cb68$var$ObserveOnOperator = function() {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) delay = 0;
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $fe520e9f9d58cb68$var$ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}();
module.exports.ObserveOnOperator = $fe520e9f9d58cb68$var$ObserveOnOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $fe520e9f9d58cb68$var$ObserveOnSubscriber = function(_super) {
    $fe520e9f9d58cb68$var$__extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) delay = 0;
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnSubscriber.dispatch = function(arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function(notification) {
        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new $fe520e9f9d58cb68$var$ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function(value) {
        this.scheduleMessage($2rXhC.Notification.createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function(err) {
        this.scheduleMessage($2rXhC.Notification.createError(err));
    };
    ObserveOnSubscriber.prototype._complete = function() {
        this.scheduleMessage($2rXhC.Notification.createComplete());
    };
    return ObserveOnSubscriber;
}($deMDi.Subscriber);
module.exports.ObserveOnSubscriber = $fe520e9f9d58cb68$var$ObserveOnSubscriber;
var $fe520e9f9d58cb68$var$ObserveOnMessage = function() {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}();
module.exports.ObserveOnMessage = $fe520e9f9d58cb68$var$ObserveOnMessage;

});
parcelRegister("2rXhC", function(module, exports) {
$parcel$export(module.exports, "Notification", () => $1c8c16c9263c2d23$export$14834abbfce3b8cd, (v) => $1c8c16c9263c2d23$export$14834abbfce3b8cd = v);
var $1c8c16c9263c2d23$export$14834abbfce3b8cd;
"use strict";

var $lryMy = parcelRequire("lryMy");
/**
 * Represents a push-based event or value that an {@link Observable} can emit.
 * This class is particularly useful for operators that manage notifications,
 * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
 * others. Besides wrapping the actual delivered value, it also annotates it
 * with metadata of, for instance, what type of push message it is (`next`,
 * `error`, or `complete`).
 *
 * @see {@link materialize}
 * @see {@link dematerialize}
 * @see {@link observeOn}
 *
 * @class Notification<T>
 */ var $1c8c16c9263c2d23$var$Notification = function() {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    /**
     * Delivers to the given `observer` the value wrapped by this Notification.
     * @param {Observer} observer
     * @return
     */ Notification.prototype.observe = function(observer) {
        switch(this.kind){
            case 'N':
                return observer.next && observer.next(this.value);
            case 'E':
                return observer.error && observer.error(this.error);
            case 'C':
                return observer.complete && observer.complete();
        }
    };
    /**
     * Given some {@link Observer} callbacks, deliver the value represented by the
     * current Notification to the correctly corresponding callback.
     * @param {function(value: T): void} next An Observer `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */ Notification.prototype.do = function(next, error, complete) {
        var kind = this.kind;
        switch(kind){
            case 'N':
                return next && next(this.value);
            case 'E':
                return error && error(this.error);
            case 'C':
                return complete && complete();
        }
    };
    /**
     * Takes an Observer or its individual callback functions, and calls `observe`
     * or `do` methods accordingly.
     * @param {Observer|function(value: T): void} nextOrObserver An Observer or
     * the `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */ Notification.prototype.accept = function(nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === 'function') return this.observe(nextOrObserver);
        else return this.do(nextOrObserver, error, complete);
    };
    /**
     * Returns a simple Observable that just delivers the notification represented
     * by this Notification instance.
     * @return {any}
     */ Notification.prototype.toObservable = function() {
        var kind = this.kind;
        switch(kind){
            case 'N':
                return $lryMy.Observable.of(this.value);
            case 'E':
                return $lryMy.Observable.throw(this.error);
            case 'C':
                return $lryMy.Observable.empty();
        }
        throw new Error('unexpected notification kind value');
    };
    /**
     * A shortcut to create a Notification instance of the type `next` from a
     * given value.
     * @param {T} value The `next` value.
     * @return {Notification<T>} The "next" Notification representing the
     * argument.
     */ Notification.createNext = function(value) {
        if (typeof value !== 'undefined') return new Notification('N', value);
        return Notification.undefinedValueNotification;
    };
    /**
     * A shortcut to create a Notification instance of the type `error` from a
     * given error.
     * @param {any} [err] The `error` error.
     * @return {Notification<T>} The "error" Notification representing the
     * argument.
     */ Notification.createError = function(err) {
        return new Notification('E', undefined, err);
    };
    /**
     * A shortcut to create a Notification instance of the type `complete`.
     * @return {Notification<any>} The valueless "complete" Notification.
     */ Notification.createComplete = function() {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    Notification.undefinedValueNotification = new Notification('N', undefined);
    return Notification;
}();
$1c8c16c9263c2d23$export$14834abbfce3b8cd = $1c8c16c9263c2d23$var$Notification;

});




parcelRegister("hU1R1", function(module, exports) {
$parcel$export(module.exports, "concatMap", () => $d0891ad4f97b9723$export$c28c8388be0ab31a, (v) => $d0891ad4f97b9723$export$c28c8388be0ab31a = v);
var $d0891ad4f97b9723$export$c28c8388be0ab31a;
"use strict";

var $gJXF1 = parcelRequire("gJXF1");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */ function $d0891ad4f97b9723$var$concatMap(project, resultSelector) {
    return $gJXF1.mergeMap(project, resultSelector, 1);
}
$d0891ad4f97b9723$export$c28c8388be0ab31a = $d0891ad4f97b9723$var$concatMap;

});
parcelRegister("gJXF1", function(module, exports) {
"use strict";
var $c2ff20ad66810fb7$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5PwgB = parcelRequire("5PwgB");

var $jYuxp = parcelRequire("jYuxp");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */ function $c2ff20ad66810fb7$var$mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return function mergeMapOperatorFunction(source) {
        if (typeof resultSelector === 'number') {
            concurrent = resultSelector;
            resultSelector = null;
        }
        return source.lift(new $c2ff20ad66810fb7$var$MergeMapOperator(project, resultSelector, concurrent));
    };
}
module.exports.mergeMap = $c2ff20ad66810fb7$var$mergeMap;
var $c2ff20ad66810fb7$var$MergeMapOperator = function() {
    function MergeMapOperator(project, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $c2ff20ad66810fb7$var$MergeMapSubscriber(observer, this.project, this.resultSelector, this.concurrent));
    };
    return MergeMapOperator;
}();
module.exports.MergeMapOperator = $c2ff20ad66810fb7$var$MergeMapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $c2ff20ad66810fb7$var$MergeMapSubscriber = function(_super) {
    $c2ff20ad66810fb7$var$__extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) this._tryNext(value);
        else this.buffer.push(value);
    };
    MergeMapSubscriber.prototype._tryNext = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result, value, index);
    };
    MergeMapSubscriber.prototype._innerSub = function(ish, value, index) {
        this.add($5PwgB.subscribeToResult(this, ish, value, index));
    };
    MergeMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
    };
    MergeMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._notifyResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype._notifyResultSelector = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    MergeMapSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapSubscriber;
}($jYuxp.OuterSubscriber);
module.exports.MergeMapSubscriber = $c2ff20ad66810fb7$var$MergeMapSubscriber;

});
parcelRegister("5PwgB", function(module, exports) {
$parcel$export(module.exports, "subscribeToResult", () => $43eabeb18a525937$export$d0604af3321cfb1b, (v) => $43eabeb18a525937$export$d0604af3321cfb1b = v);
var $43eabeb18a525937$export$d0604af3321cfb1b;
"use strict";

var $gvBTr = parcelRequire("gvBTr");

var $7ZlqO = parcelRequire("7ZlqO");

var $dA7Lt = parcelRequire("dA7Lt");

var $9DdIv = parcelRequire("9DdIv");

var $lryMy = parcelRequire("lryMy");

var $5DE9G = parcelRequire("5DE9G");

var $5RidA = parcelRequire("5RidA");

var $gZzrm = parcelRequire("gZzrm");
function $43eabeb18a525937$var$subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
    var destination = new $5RidA.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
    if (destination.closed) return null;
    if (result instanceof $lryMy.Observable) {
        if (result._isScalar) {
            destination.next(result.value);
            destination.complete();
            return null;
        } else {
            destination.syncErrorThrowable = true;
            return result.subscribe(destination);
        }
    } else if ($7ZlqO.isArrayLike(result)) {
        for(var i = 0, len = result.length; i < len && !destination.closed; i++)destination.next(result[i]);
        if (!destination.closed) destination.complete();
    } else if ($dA7Lt.isPromise(result)) {
        result.then(function(value) {
            if (!destination.closed) {
                destination.next(value);
                destination.complete();
            }
        }, function(err) {
            return destination.error(err);
        }).then(null, function(err) {
            // Escaping the Promise trap: globally throw unhandled errors
            $gvBTr.root.setTimeout(function() {
                throw err;
            });
        });
        return destination;
    } else if (result && typeof result[$5DE9G.iterator] === 'function') {
        var iterator = result[$5DE9G.iterator]();
        do {
            var item = iterator.next();
            if (item.done) {
                destination.complete();
                break;
            }
            destination.next(item.value);
            if (destination.closed) break;
        }while (true);
    } else if (result && typeof result[$gZzrm.observable] === 'function') {
        var obs = result[$gZzrm.observable]();
        if (typeof obs.subscribe !== 'function') destination.error(new TypeError('Provided object does not correctly implement Symbol.observable'));
        else return obs.subscribe(new $5RidA.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
    } else {
        var value = $9DdIv.isObject(result) ? 'an invalid object' : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected." + ' You can provide an Observable, Promise, Array, or Iterable.';
        destination.error(new TypeError(msg));
    }
    return null;
}
$43eabeb18a525937$export$d0604af3321cfb1b = $43eabeb18a525937$var$subscribeToResult;

});
parcelRegister("5RidA", function(module, exports) {
"use strict";
var $444008bbc306f96f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $deMDi = parcelRequire("deMDi");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $444008bbc306f96f$var$InnerSubscriber = function(_super) {
    $444008bbc306f96f$var$__extends(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        _super.call(this);
        this.parent = parent;
        this.outerValue = outerValue;
        this.outerIndex = outerIndex;
        this.index = 0;
    }
    InnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}($deMDi.Subscriber);
module.exports.InnerSubscriber = $444008bbc306f96f$var$InnerSubscriber;

});


parcelRegister("jYuxp", function(module, exports) {
"use strict";
var $e8ab4f1ec1b2af94$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $deMDi = parcelRequire("deMDi");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e8ab4f1ec1b2af94$var$OuterSubscriber = function(_super) {
    $e8ab4f1ec1b2af94$var$__extends(OuterSubscriber, _super);
    function OuterSubscriber() {
        _super.apply(this, arguments);
    }
    OuterSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function(error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function(innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}($deMDi.Subscriber);
module.exports.OuterSubscriber = $e8ab4f1ec1b2af94$var$OuterSubscriber;

});



parcelRegister("3Hq8H", function(module, exports) {
$parcel$export(module.exports, "chunkinator", () => $2b19a9f4b2fd27c9$export$9ab6bef3838698f8);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $lVEGo = parcelRequire("lVEGo");
var $2b19a9f4b2fd27c9$export$9ab6bef3838698f8 = function chunkinator(file, options, callbacks) {
    return (0, $lVEGo.getObservableFromFile)(file, options, callbacks);
};

});
parcelRegister("lVEGo", function(module, exports) {
$parcel$export(module.exports, "getObservableFromFile", () => $ff6e7a9b0de9655d$export$88e80b3a0bb31f63);

var $1zWpA = parcelRequire("1zWpA");

var $aG6Au = parcelRequire("aG6Au");

var $jmcbD = parcelRequire("jmcbD");

var $hU1R1 = parcelRequire("hU1R1");

var $kdSxl = parcelRequire("kdSxl");

var $2tNYX = parcelRequire("2tNYX");

var $l4WxA = parcelRequire("l4WxA");

var $govPu = parcelRequire("govPu");

var $9zDuU = parcelRequire("9zDuU");

var $k2B16 = parcelRequire("k2B16");
var $ff6e7a9b0de9655d$export$88e80b3a0bb31f63 = function getObservableFromFile(file, options, callbacks) {
    return (0, $aG6Au.fromPromise)((0, $2tNYX.fetchBlob)(file)).pipe((0, $hU1R1.concatMap)(function(blob) {
        var chunkSize = options.chunkSize;
        var onProgress = callbacks.onProgress;
        var totalChunks = Math.ceil(blob.size / chunkSize);
        var slicenatedBlobs = (0, $9zDuU.slicenator)(blob, {
            size: chunkSize
        });
        var hashinatedBlobs = (0, $l4WxA.hashinator)(slicenatedBlobs, {
            concurrency: options.hashingConcurrency,
            hasher: options.hashingFunction
        });
        var uploadedChunks = 0;
        var uploadedBlobs = (0, $k2B16.uploadinator)(hashinatedBlobs, {
            concurrency: options.uploadingConcurrency,
            uploader: options.uploadingFunction
        });
        if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $kdSxl.tap)(function() {
            uploadedChunks += 1;
            onProgress(uploadedChunks / totalChunks);
        }));
        return (0, $govPu.processinator)(uploadedBlobs, {
            batchSize: options.processingBatchSize,
            processor: options.processingFunction
        }).pipe((0, $hU1R1.concatMap)(function(batchedChunks) {
            return (0, $1zWpA.from)(batchedChunks);
        }), (0, $jmcbD.bufferCount)(totalChunks));
    }));
};

});
parcelRegister("aG6Au", function(module, exports) {
$parcel$export(module.exports, "fromPromise", () => $7c62efc162992332$export$60f45028237c39d1, (v) => $7c62efc162992332$export$60f45028237c39d1 = v);
var $7c62efc162992332$export$60f45028237c39d1;
"use strict";

var $4aw8t = parcelRequire("4aw8t");
$7c62efc162992332$export$60f45028237c39d1 = $4aw8t.PromiseObservable.create;

});

parcelRegister("jmcbD", function(module, exports) {
"use strict";
var $e179866bda1f0b9e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $deMDi = parcelRequire("deMDi");
/**
 * Buffers the source Observable values until the size hits the maximum
 * `bufferSize` given.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when its size reaches `bufferSize`.</span>
 *
 * <img src="./img/bufferCount.png" width="100%">
 *
 * Buffers a number of values from the source Observable by `bufferSize` then
 * emits the buffer and clears it, and starts a new buffer each
 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
 * `null`, then new buffers are started immediately at the start of the source
 * and when each buffer closes and is emitted.
 *
 * @example <caption>Emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>On every click, emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2, 1);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link pairwise}
 * @see {@link windowCount}
 *
 * @param {number} bufferSize The maximum size of the buffer emitted.
 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
 * For example if `startBufferEvery` is `2`, then a new buffer will be started
 * on every other value from the source. A new buffer is started at the
 * beginning of the source by default.
 * @return {Observable<T[]>} An Observable of arrays of buffered values.
 * @method bufferCount
 * @owner Observable
 */ function $e179866bda1f0b9e$var$bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) startBufferEvery = null;
    return function bufferCountOperatorFunction(source) {
        return source.lift(new $e179866bda1f0b9e$var$BufferCountOperator(bufferSize, startBufferEvery));
    };
}
module.exports.bufferCount = $e179866bda1f0b9e$var$bufferCount;
var $e179866bda1f0b9e$var$BufferCountOperator = function() {
    function BufferCountOperator(bufferSize, startBufferEvery) {
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        if (!startBufferEvery || bufferSize === startBufferEvery) this.subscriberClass = $e179866bda1f0b9e$var$BufferCountSubscriber;
        else this.subscriberClass = $e179866bda1f0b9e$var$BufferSkipCountSubscriber;
    }
    BufferCountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
    };
    return BufferCountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e179866bda1f0b9e$var$BufferCountSubscriber = function(_super) {
    $e179866bda1f0b9e$var$__extends(BufferCountSubscriber, _super);
    function BufferCountSubscriber(destination, bufferSize) {
        _super.call(this, destination);
        this.bufferSize = bufferSize;
        this.buffer = [];
    }
    BufferCountSubscriber.prototype._next = function(value) {
        var buffer = this.buffer;
        buffer.push(value);
        if (buffer.length == this.bufferSize) {
            this.destination.next(buffer);
            this.buffer = [];
        }
    };
    BufferCountSubscriber.prototype._complete = function() {
        var buffer = this.buffer;
        if (buffer.length > 0) this.destination.next(buffer);
        _super.prototype._complete.call(this);
    };
    return BufferCountSubscriber;
}($deMDi.Subscriber);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e179866bda1f0b9e$var$BufferSkipCountSubscriber = function(_super) {
    $e179866bda1f0b9e$var$__extends(BufferSkipCountSubscriber, _super);
    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
        _super.call(this, destination);
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        this.buffers = [];
        this.count = 0;
    }
    BufferSkipCountSubscriber.prototype._next = function(value) {
        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
        this.count++;
        if (count % startBufferEvery === 0) buffers.push([]);
        for(var i = buffers.length; i--;){
            var buffer = buffers[i];
            buffer.push(value);
            if (buffer.length === bufferSize) {
                buffers.splice(i, 1);
                this.destination.next(buffer);
            }
        }
    };
    BufferSkipCountSubscriber.prototype._complete = function() {
        var _a = this, buffers = _a.buffers, destination = _a.destination;
        while(buffers.length > 0){
            var buffer = buffers.shift();
            if (buffer.length > 0) destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    return BufferSkipCountSubscriber;
}($deMDi.Subscriber);

});

parcelRegister("kdSxl", function(module, exports) {
"use strict";
var $eb8f536aea4d8728$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $deMDi = parcelRequire("deMDi");
/* tslint:enable:max-line-length */ /**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @name tap
 */ function $eb8f536aea4d8728$var$tap(nextOrObserver, error, complete) {
    return function tapOperatorFunction(source) {
        return source.lift(new $eb8f536aea4d8728$var$DoOperator(nextOrObserver, error, complete));
    };
}
module.exports.tap = $eb8f536aea4d8728$var$tap;
var $eb8f536aea4d8728$var$DoOperator = function() {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $eb8f536aea4d8728$var$DoSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $eb8f536aea4d8728$var$DoSubscriber = function(_super) {
    $eb8f536aea4d8728$var$__extends(DoSubscriber, _super);
    function DoSubscriber(destination, nextOrObserver, error, complete) {
        _super.call(this, destination);
        var safeSubscriber = new $deMDi.Subscriber(nextOrObserver, error, complete);
        safeSubscriber.syncErrorThrowable = true;
        this.add(safeSubscriber);
        this.safeSubscriber = safeSubscriber;
    }
    DoSubscriber.prototype._next = function(value) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.next(value);
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.next(value);
    };
    DoSubscriber.prototype._error = function(err) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.error(err);
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.error(err);
    };
    DoSubscriber.prototype._complete = function() {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.complete();
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.complete();
    };
    return DoSubscriber;
}($deMDi.Subscriber);

});

parcelRegister("2tNYX", function(module, exports) {
$parcel$export(module.exports, "fetchBlob", () => $1ce50f9af7a1bf41$export$14e9cfd4a872cc1e);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");
function $1ce50f9af7a1bf41$export$14e9cfd4a872cc1e(_x) {
    return $1ce50f9af7a1bf41$var$_fetchBlob.apply(this, arguments);
}
function $1ce50f9af7a1bf41$var$_fetchBlob() {
    $1ce50f9af7a1bf41$var$_fetchBlob = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(file) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(typeof file === 'string')) {
                        _context.next = 2;
                        break;
                    }
                    _context.next = 1;
                    return fetch(file).then(function(response) {
                        return response.blob();
                    });
                case 1:
                    return _context.abrupt("return", _context.sent);
                case 2:
                    return _context.abrupt("return", file);
                case 3:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $1ce50f9af7a1bf41$var$_fetchBlob.apply(this, arguments);
}

});

parcelRegister("l4WxA", function(module, exports) {
$parcel$export(module.exports, "hashinator", () => $f58761afa3859fc7$export$d5f5a550a38ec367);

var $9Ef5F = parcelRequire("9Ef5F");

var $joStV = parcelRequire("joStV");
var $f58761afa3859fc7$export$d5f5a550a38ec367 = function hashinator(blobs$, _ref) {
    var hasher = _ref.hasher, concurrency = _ref.concurrency;
    return (0, $9Ef5F.asyncMap)((0, $joStV.blobToHashedBlob)(hasher), concurrency)(blobs$);
};

});
parcelRegister("9Ef5F", function(module, exports) {
$parcel$export(module.exports, "asyncMap", () => $70638e21724174a2$export$707ee4c4c95d39e3);

var $lryMy = parcelRequire("lryMy");

var $gJXF1 = parcelRequire("gJXF1");
var $70638e21724174a2$var$notify = function notify(promise, observer, onReady) {
    var notifier = {
        notifyIfReady: function notifyIfReady() {
            return false;
        }
    };
    promise.then(function(value) {
        notifier.notifyIfReady = function() {
            observer.next(value);
            observer.complete();
            return true;
        };
        onReady(notifier);
    }, function(reason) {
        notifier.notifyIfReady = function() {
            observer.error(reason);
            return true;
        };
        onReady(notifier);
    });
    return notifier;
};
var $70638e21724174a2$var$mapper = function mapper(project) {
    var notifiers = new Array();
    var onReady = function onReady() {
        // find the first non-ready notifier in the queue,
        // while invoking all ready notifiers that we encounter along the way
        var notReadyIdx = notifiers.findIndex(function(notifier) {
            return !notifier.notifyIfReady();
        });
        if (notReadyIdx > 0) // remove all the notifiers we invoked
        notifiers.splice(0, notReadyIdx);
    };
    return function(value) {
        return new (0, $lryMy.Observable)(function(sub) {
            notifiers.push($70638e21724174a2$var$notify(project(value), sub, onReady));
        });
    };
};
var $70638e21724174a2$export$707ee4c4c95d39e3 = function asyncMap(project, concurrent) {
    return (0, $gJXF1.mergeMap)($70638e21724174a2$var$mapper(project), concurrent);
};

});

parcelRegister("joStV", function(module, exports) {
$parcel$export(module.exports, "blobToHashedBlob", () => $e1fa852775f21845$export$28a452a485721473);
var $e1fa852775f21845$export$28a452a485721473 = function blobToHashedBlob(hasher) {
    return function(slicedBlob) {
        return hasher(slicedBlob.blob).then(function(hash) {
            return {
                blob: slicedBlob.blob,
                hash: "".concat(hash, "-").concat(slicedBlob.blob.size),
                partNumber: slicedBlob.partNumber
            };
        });
    };
};

});


parcelRegister("govPu", function(module, exports) {
$parcel$export(module.exports, "processinator", () => $bef793e3760d319a$export$2f21790600302ed);

var $jmcbD = parcelRequire("jmcbD");

var $hU1R1 = parcelRequire("hU1R1");
var $bef793e3760d319a$export$2f21790600302ed = function processinator(blobs$, options) {
    var process = function process(blobs) {
        if (options.processor) return options.processor(blobs).then(function() {
            return blobs;
        });
        else return Promise.resolve(blobs);
    };
    return blobs$.pipe((0, $jmcbD.bufferCount)(options.batchSize)).pipe((0, $hU1R1.concatMap)(process));
};

});

parcelRegister("9zDuU", function(module, exports) {
$parcel$export(module.exports, "slicenator", () => $6f8605540734d9d1$export$5b92d769f2f57509);

var $lKCed = parcelRequire("lKCed");

var $blmL7 = parcelRequire("blmL7");
var $6f8605540734d9d1$export$5b92d769f2f57509 = function slicenator(blob, _ref) {
    var chunkSize = _ref.size;
    var totalChunks = Math.ceil(blob.size / chunkSize);
    return (0, $lKCed.range)(0, totalChunks).pipe((0, $blmL7.map)(function(index) {
        return {
            partNumber: index + 1,
            blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
        };
    }));
};

});
parcelRegister("lKCed", function(module, exports) {
$parcel$export(module.exports, "range", () => $fd5b8c2d9cc59a77$export$d02631cccf789723, (v) => $fd5b8c2d9cc59a77$export$d02631cccf789723 = v);
var $fd5b8c2d9cc59a77$export$d02631cccf789723;
"use strict";

var $3Qhuq = parcelRequire("3Qhuq");
$fd5b8c2d9cc59a77$export$d02631cccf789723 = $3Qhuq.RangeObservable.create;

});
parcelRegister("3Qhuq", function(module, exports) {
"use strict";
var $2cc3cb82bf324c8e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lryMy = parcelRequire("lryMy");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $2cc3cb82bf324c8e$var$RangeObservable = function(_super) {
    $2cc3cb82bf324c8e$var$__extends(RangeObservable, _super);
    function RangeObservable(start, count, scheduler) {
        _super.call(this);
        this.start = start;
        this._count = count;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits a sequence of numbers within a specified
     * range.
     *
     * <span class="informal">Emits a sequence of numbers in a range.</span>
     *
     * <img src="./img/range.png" width="100%">
     *
     * `range` operator emits a range of sequential integers, in order, where you
     * select the `start` of the range and its `length`. By default, uses no
     * IScheduler and just delivers the notifications synchronously, but may use
     * an optional IScheduler to regulate those deliveries.
     *
     * @example <caption>Emits the numbers 1 to 10</caption>
     * var numbers = Rx.Observable.range(1, 10);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link timer}
     * @see {@link interval}
     *
     * @param {number} [start=0] The value of the first integer in the sequence.
     * @param {number} [count=0] The number of sequential integers to generate.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the notifications.
     * @return {Observable} An Observable of numbers that emits a finite range of
     * sequential integers.
     * @static true
     * @name range
     * @owner Observable
     */ RangeObservable.create = function(start, count, scheduler) {
        if (start === void 0) start = 0;
        if (count === void 0) count = 0;
        return new RangeObservable(start, count, scheduler);
    };
    RangeObservable.dispatch = function(state) {
        var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(start);
        if (subscriber.closed) return;
        state.index = index + 1;
        state.start = start + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ RangeObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var start = this.start;
        var count = this._count;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(RangeObservable.dispatch, 0, {
            index: index,
            count: count,
            start: start,
            subscriber: subscriber
        });
        else do {
            if (index++ >= count) {
                subscriber.complete();
                break;
            }
            subscriber.next(start++);
            if (subscriber.closed) break;
        }while (true);
    };
    return RangeObservable;
}($lryMy.Observable);
module.exports.RangeObservable = $2cc3cb82bf324c8e$var$RangeObservable;

});



parcelRegister("k2B16", function(module, exports) {
$parcel$export(module.exports, "uploadinator", () => $e970b54ee8cc29c8$export$94ce0f3fcf999415);

var $9Ef5F = parcelRequire("9Ef5F");
var $e970b54ee8cc29c8$export$94ce0f3fcf999415 = function uploadinator(blobs$, options) {
    var upload = function upload(blob) {
        return options.uploader(blob).then(function() {
            return blob;
        });
    };
    return blobs$.pipe((0, $9Ef5F.asyncMap)(upload, options.concurrency));
};

});



parcelRegister("ecRkm", function(module, exports) {
$parcel$export(module.exports, "createHasher", () => $a57b8d5dd9b3731d$export$14b114effbc08b6b);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $k9W36 = parcelRequire("k9W36");
var $a57b8d5dd9b3731d$var$hasher = null;
var $a57b8d5dd9b3731d$var$sha256Hasher = null;
var $a57b8d5dd9b3731d$export$d9c9d11cd648a505 = function destroyHashers() {
    $a57b8d5dd9b3731d$var$hasher = null;
    $a57b8d5dd9b3731d$var$sha256Hasher = null;
};


var $a57b8d5dd9b3731d$export$14b114effbc08b6b = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(algorithm) {
        var _yield$import, _SimpleHasher, _yield$import2, SimpleHasher, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.prev = 0;
                    if (!(algorithm === (0, $k9W36.ChunkHashAlgorithm).Sha256)) {
                        _context.next = 3;
                        break;
                    }
                    if ($a57b8d5dd9b3731d$var$sha256Hasher) {
                        _context.next = 2;
                        break;
                    }
                    _context.next = 1;
                    return (parcelRequire("1RcIf"));
                case 1:
                    _yield$import = _context.sent;
                    _SimpleHasher = _yield$import.SimpleHasher;
                    $a57b8d5dd9b3731d$var$sha256Hasher = new _SimpleHasher();
                case 2:
                    return _context.abrupt("return", $a57b8d5dd9b3731d$var$sha256Hasher);
                case 3:
                    _context.next = 5;
                    break;
                case 4:
                    _context.prev = 4;
                    _t = _context["catch"](0);
                case 5:
                    _context.next = 6;
                    return (parcelRequire("iNrKD"));
                case 6:
                    _yield$import2 = _context.sent;
                    SimpleHasher = _yield$import2.SimpleHasher;
                    $a57b8d5dd9b3731d$var$hasher = new SimpleHasher();
                    return _context.abrupt("return", $a57b8d5dd9b3731d$var$hasher);
                case 7:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                0,
                4
            ]
        ]);
    }));
    return function createHasher(_x) {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("1RcIf", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("gWebb"),
    $iKwew("kxBGF")
]).then(()=>parcelRequire('bz838'));

});

parcelRegister("iNrKD", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("6v8xP"),
    $iKwew("k2cyY")
]).then(()=>parcelRequire('dACgH'));

});


parcelRegister("1HOKE", function(module, exports) {
$parcel$export(module.exports, "fileSizeError", () => $13e12cc79dff15af$export$b36239e4c33c2902);
$parcel$export(module.exports, "calculateChunkSize", () => $13e12cc79dff15af$export$71f452e02035c1e2);

var $6wdjf = parcelRequire("6wdjf");

var $8Jxs4 = parcelRequire("8Jxs4");
var $13e12cc79dff15af$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
var $13e12cc79dff15af$export$71f452e02035c1e2 = function calculateChunkSize(fileSize) {
    if (fileSize > (0, $6wdjf.MAX_UPLOAD_FILE_SIZE)) throw new Error($13e12cc79dff15af$export$b36239e4c33c2902);
    if (fileSize <= 5 * (0, $8Jxs4.DATA_UNIT).GB) return 5 * (0, $8Jxs4.DATA_UNIT).MB;
    if (fileSize > 5 * (0, $8Jxs4.DATA_UNIT).GB && fileSize <= 50 * (0, $8Jxs4.DATA_UNIT).GB) return 50 * (0, $8Jxs4.DATA_UNIT).MB;
    if (fileSize > 50 * (0, $8Jxs4.DATA_UNIT).GB && fileSize <= 0.95 * (0, $8Jxs4.DATA_UNIT).TB) return 100 * (0, $8Jxs4.DATA_UNIT).MB;
    return 210 * (0, $8Jxs4.DATA_UNIT).MB;
};

});

parcelRegister("aOwsm", function(module, exports) {
$parcel$export(module.exports, "UploaderError", () => $7df7c0126790ffba$export$515240c3f059c807);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $ij82I = parcelRequire("ij82I");
function $7df7c0126790ffba$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $7df7c0126790ffba$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $7df7c0126790ffba$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7df7c0126790ffba$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $7df7c0126790ffba$export$515240c3f059c807 = /*#__PURE__*/ function(_BaseMediaClientError) {
    // Legacy Attribute. Should be removed
    function UploaderError(reason, metadata) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UploaderError);
        _this = $7df7c0126790ffba$var$_callSuper(this, UploaderError, [
            reason,
            metadata,
            undefined
        ]);
        _this.id = metadata.id;
        return _this;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UploaderError, _BaseMediaClientError);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UploaderError, [
        {
            key: "attributes",
            get: function get() {
                var reason = this.reason, _this$metadata = this.metadata, id = _this$metadata.id, collectionName = _this$metadata.collectionName, occurrenceKey = _this$metadata.occurrenceKey;
                return {
                    reason: reason,
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey
                };
            }
        }
    ]);
}((0, $ij82I.BaseMediaClientError));

});


parcelRegister("FwEaA", function(module, exports) {
$parcel$export(module.exports, "convertBase64ToBlob", () => $07cd2771b89b1e93$export$ed17558b11b88056);
var $07cd2771b89b1e93$export$ed17558b11b88056 = function convertBase64ToBlob(base64) {
    var sliceSize = 512;
    var base64Data = base64.split(',')[1];
    var byteCharacters = atob(base64Data);
    var byteArrays = [];
    var _loop = function _loop() {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = slice.split('').map(function(_, i) {
            return slice.charCodeAt(i);
        });
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    };
    for(var offset = 0; offset < byteCharacters.length; offset += sliceSize)_loop();
    // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
    return new Blob(byteArrays, {
        type: 'image/jpeg'
    });
};

});

parcelRegister("9gnZf", function(module, exports) {
$parcel$export(module.exports, "createCopyIntentRegisterationBatcher", () => $6be836fd12d837ff$export$57945b6819e39246);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $8kmor = parcelRequire("8kmor");

var $bVaC0 = parcelRequire("bVaC0");
var $6be836fd12d837ff$export$b79d95ee17a87a = 100;
/**
 * Returns a function that, given Array<DataloaderKey>, resolves to an array of same length containing either DataloaderResult or Error.
 * Such contract is formalised by Dataloader 1.0, @see https://github.com/graphql/dataloader
 *
 * If an Error is resolved in the results, it must be at same position then their corresponding key:
 * - Dataloader will re-throw that Error when accessing/loading that particular key
 *
 * @param mediaStore instance of MediaStore
 */ function $6be836fd12d837ff$var$createBatchCopyIntentRegisterationFunc(mediaStore) {
    return /*#__PURE__*/ function() {
        var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(keys) {
            var keysByToken, items;
            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        keysByToken = keys.reduce(function(acc, key) {
                            var token = key.resolvedAuth.token;
                            acc[token] = acc[token] || [];
                            // de-duplicate ids in collection
                            var hasDuplicates = acc[token].some(function(_ref2) {
                                var id = _ref2.id, collectionName = _ref2.collectionName;
                                return key.id === id && collectionName === key.collectionName;
                            });
                            if (!hasDuplicates) acc[token].push(key);
                            return acc;
                        }, {});
                        items = [];
                        _context2.next = 1;
                        return Promise.all(Object.keys(keysByToken).map(/*#__PURE__*/ function() {
                            var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(batchKey) {
                                var metadataTraceContext, files, resolvedAuth, _t;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                                    while(true)switch(_context.prev = _context.next){
                                        case 0:
                                            metadataTraceContext = {
                                                traceId: (0, $bVaC0.getRandomTelemetryId)(),
                                                spanId: (0, $bVaC0.getRandomTelemetryId)()
                                            };
                                            files = keysByToken[batchKey].map(function(key) {
                                                return {
                                                    id: key.id,
                                                    collection: key.collectionName
                                                };
                                            }); // given these are batched by the token the assumption is that they have the same details.
                                            resolvedAuth = keysByToken[batchKey][0].resolvedAuth;
                                            _context.prev = 1;
                                            _context.next = 2;
                                            return mediaStore.registerCopyIntents(files, metadataTraceContext, resolvedAuth);
                                        case 2:
                                            _context.next = 4;
                                            break;
                                        case 3:
                                            _context.prev = 3;
                                            _t = _context["catch"](1);
                                            files.forEach(function(_ref4) {
                                                var id = _ref4.id, collection = _ref4.collection;
                                                items.push({
                                                    id: id,
                                                    collection: collection,
                                                    error: _t
                                                });
                                            });
                                        case 4:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _callee, null, [
                                    [
                                        1,
                                        3
                                    ]
                                ]);
                            }));
                            return function(_x2) {
                                return _ref3.apply(this, arguments);
                            };
                        }()));
                    case 1:
                        return _context2.abrupt("return", keys.map(function(_ref5) {
                            var _items$find;
                            var id = _ref5.id, collectionName = _ref5.collectionName;
                            return (_items$find = items.find(function(item) {
                                return item.id === id && item.collection === collectionName;
                            })) === null || _items$find === void 0 ? void 0 : _items$find.error;
                        }));
                    case 2:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2);
        }));
        return function(_x) {
            return _ref.apply(this, arguments);
        };
    }();
}
function $6be836fd12d837ff$export$57945b6819e39246(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($8kmor)))($6be836fd12d837ff$var$createBatchCopyIntentRegisterationFunc(mediaStore), {
        maxBatchSize: $6be836fd12d837ff$export$b79d95ee17a87a,
        cacheKeyFn: function cacheKeyFn(_ref6) {
            var id = _ref6.id, _ref6$collectionName = _ref6.collectionName, collectionName = _ref6$collectionName === void 0 ? 'default' : _ref6$collectionName, resolvedAuth = _ref6.resolvedAuth;
            return "".concat(id, "-").concat(collectionName, "-").concat(resolvedAuth.token);
        }
    });
}

});
parcelRegister("8kmor", function(module, exports) {

var $3ZMUU = parcelRequire("3ZMUU");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $61018fcf031b9b93$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $61018fcf031b9b93$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $61018fcf031b9b93$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $61018fcf031b9b93$var$getValidCacheKeyFn(options);
        this._cacheMap = $61018fcf031b9b93$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $61018fcf031b9b93$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $61018fcf031b9b93$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey; // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            cacheKey = this._cacheKeyFn(key);
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    };
    _proto.loadMany = function loadMany(keys) {
        if (!$61018fcf031b9b93$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    };
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    };
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    };
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    };
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $61018fcf031b9b93$var$enqueuePostPromiseJob = typeof $3ZMUU === 'object' && typeof $3ZMUU.nextTick === 'function' ? function(fn) {
    if (!$61018fcf031b9b93$var$resolvedPromise) $61018fcf031b9b93$var$resolvedPromise = Promise.resolve();
    $61018fcf031b9b93$var$resolvedPromise.then(function() {
        $3ZMUU.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $61018fcf031b9b93$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $61018fcf031b9b93$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $61018fcf031b9b93$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $61018fcf031b9b93$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $61018fcf031b9b93$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $61018fcf031b9b93$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $61018fcf031b9b93$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$61018fcf031b9b93$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $61018fcf031b9b93$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var _value = values[i];
            if (_value instanceof Error) batch.callbacks[i].reject(_value);
            else batch.callbacks[i].resolve(_value);
        }
    })["catch"](function(error) {
        $61018fcf031b9b93$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $61018fcf031b9b93$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $61018fcf031b9b93$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $61018fcf031b9b93$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $61018fcf031b9b93$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $61018fcf031b9b93$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $61018fcf031b9b93$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $61018fcf031b9b93$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $61018fcf031b9b93$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $61018fcf031b9b93$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $61018fcf031b9b93$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $61018fcf031b9b93$var$DataLoader;

});

parcelRegister("bVaC0", function(module, exports) {
$parcel$export(module.exports, "isUndefined", () => $8add3fe532423e8e$export$fce6876652108ab);
$parcel$export(module.exports, "omitBy", () => $8add3fe532423e8e$export$d7a617dda645b4e3);
$parcel$export(module.exports, "getRandomHex", () => $8add3fe532423e8e$export$456b25e3a9b4a843);
$parcel$export(module.exports, "getRandomTelemetryId", () => $8add3fe532423e8e$export$2e36de8639bad0ad);

var $fC8ib = parcelRequire("fC8ib");

var $iYJcE = parcelRequire("iYJcE");
var $8add3fe532423e8e$export$fce6876652108ab = function isUndefined(value) {
    return value === undefined;
};
var $8add3fe532423e8e$export$357523c63a2253b9 = function pick(obj) {
    var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    if (obj === undefined) return {};
    return Object.fromEntries(Object.entries(obj).filter(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), k = _ref2[0];
        return keys.includes(k);
    }));
};
var $8add3fe532423e8e$export$d7a617dda645b4e3 = function omitBy(obj, predicate) {
    return Object.fromEntries(Object.entries(obj).filter(function(_ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), v = _ref4[1];
        return !predicate(v);
    }));
};
var $8add3fe532423e8e$export$61fc7d43ac8f84b0 = function debounce(func, wait) {
    var timeout;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            return func.apply(void 0, args);
        }, wait);
    };
};
var $8add3fe532423e8e$export$de994efd351b291c = function matches(srcObj) {
    return function(obj) {
        var key;
        for(key in srcObj){
            if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
        }
        return true;
    };
};
function $8add3fe532423e8e$var$getRandomHexValues(byte) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array(byte * 2)).map(function() {
        return Math.floor(Math.random() * 16).toString(16);
    }).join('');
}
function $8add3fe532423e8e$export$456b25e3a9b4a843(byte) {
    var _window;
    var randomHex;
    if ((_window = window) !== null && _window !== void 0 && _window.crypto) try {
        randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map(function(b) {
            return b.toString(16).padStart(2, '0');
        }).join('');
    } catch (e) {
        randomHex = $8add3fe532423e8e$var$getRandomHexValues(byte);
    }
    else randomHex = $8add3fe532423e8e$var$getRandomHexValues(byte);
    return randomHex;
}
function $8add3fe532423e8e$export$2e36de8639bad0ad() {
    return $8add3fe532423e8e$export$456b25e3a9b4a843(8);
}

});


parcelRegister("h8QRB", function(module, exports) {
$parcel$export(module.exports, "createFileDataloader", () => $c7ac30a1dfd56042$export$ae188fee39529b82);

var $8kmor = parcelRequire("8kmor");

var $6liA7 = parcelRequire("6liA7");

var $dgoe5 = parcelRequire("dgoe5");
function $c7ac30a1dfd56042$export$ae188fee39529b82(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($8kmor)))((0, $6liA7.createBatchLoadingFunc)(mediaStore), {
        maxBatchSize: (0, $dgoe5.MAX_BATCH_SIZE)
    });
}

});
parcelRegister("6liA7", function(module, exports) {
$parcel$export(module.exports, "createBatchLoadingFunc", () => $49e31e2c806a7710$export$4a53beb129e8c49a);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $bVaC0 = parcelRequire("bVaC0");

var $ffC1G = parcelRequire("ffC1G");
function $49e31e2c806a7710$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $49e31e2c806a7710$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $49e31e2c806a7710$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $49e31e2c806a7710$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $49e31e2c806a7710$export$4a53beb129e8c49a(mediaStore) {
    return /*#__PURE__*/ function() {
        var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(keys) {
            var nonCollectionName, includeHashByCollection, fileIdsByCollection, items;
            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        nonCollectionName = '__media-single-file-collection__';
                        includeHashByCollection = keys.reduce(function(acc, key) {
                            var collectionName = key.collectionName || nonCollectionName;
                            if (key.includeHashForDuplicateFiles) acc[collectionName] = key.includeHashForDuplicateFiles;
                            return acc;
                        }, {});
                        fileIdsByCollection = keys.reduce(function(acc, key) {
                            var collectionName = key.collectionName || nonCollectionName;
                            var fileIds = acc[collectionName] || [];
                            // de-duplicate ids in collection
                            if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
                            acc[collectionName] = fileIds;
                            return acc;
                        }, {});
                        items = [];
                        _context2.next = 1;
                        return Promise.all(Object.keys(fileIdsByCollection).map(/*#__PURE__*/ function() {
                            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(collectionNameKey) {
                                var metadataTraceContext, fileIds, includeHashForDuplicateFiles, collectionName, response, itemsWithMetadataTraceContext, itemsIds, fileIdsNotFound, _t;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                                    while(true)switch(_context.prev = _context.next){
                                        case 0:
                                            metadataTraceContext = {
                                                traceId: (0, $bVaC0.getRandomTelemetryId)(),
                                                spanId: (0, $bVaC0.getRandomTelemetryId)()
                                            };
                                            fileIds = fileIdsByCollection[collectionNameKey];
                                            includeHashForDuplicateFiles = includeHashByCollection[collectionNameKey];
                                            collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
                                            _context.prev = 1;
                                            _context.next = 2;
                                            return mediaStore.getItems(fileIds, collectionName, metadataTraceContext, includeHashForDuplicateFiles);
                                        case 2:
                                            response = _context.sent;
                                            itemsWithMetadataTraceContext = response.data.items.map(function(item) {
                                                return $49e31e2c806a7710$var$_objectSpread($49e31e2c806a7710$var$_objectSpread({}, item), {}, {
                                                    metadataTraceContext: metadataTraceContext
                                                });
                                            });
                                            items.push.apply(items, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(itemsWithMetadataTraceContext));
                                            // add EmptyResponseFileItem for each file ID not included in /items response
                                            itemsIds = itemsWithMetadataTraceContext.map(function(item) {
                                                return item.id;
                                            });
                                            fileIdsNotFound = fileIds.filter(function(id) {
                                                return !itemsIds.includes(id);
                                            });
                                            fileIdsNotFound.forEach(function(fileId) {
                                                items.push({
                                                    id: fileId,
                                                    collection: collectionName,
                                                    type: 'not-found',
                                                    metadataTraceContext: metadataTraceContext
                                                });
                                            });
                                            _context.next = 4;
                                            break;
                                        case 3:
                                            _context.prev = 3;
                                            _t = _context["catch"](1);
                                            fileIds.forEach(function(fileId) {
                                                items.push({
                                                    id: fileId,
                                                    collection: collectionName,
                                                    error: _t
                                                });
                                            });
                                        case 4:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _callee, null, [
                                    [
                                        1,
                                        3
                                    ]
                                ]);
                            }));
                            return function(_x2) {
                                return _ref2.apply(this, arguments);
                            };
                        }()));
                    case 1:
                        return _context2.abrupt("return", (0, $ffC1G.getItemsFromKeys)(keys, items));
                    case 2:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2);
        }));
        return function(_x) {
            return _ref.apply(this, arguments);
        };
    }();
}

});
parcelRegister("ffC1G", function(module, exports) {
$parcel$export(module.exports, "getItemsFromKeys", () => $b1a5c0f0ab56f8ed$export$71cd2e8f8162d47b);

var $25nEq = parcelRequire("25nEq");
function $b1a5c0f0ab56f8ed$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b1a5c0f0ab56f8ed$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b1a5c0f0ab56f8ed$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b1a5c0f0ab56f8ed$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b1a5c0f0ab56f8ed$var$isBatchLoadingErrorResult = function isBatchLoadingErrorResult(result) {
    return result.error instanceof Error;
};
var $b1a5c0f0ab56f8ed$var$isResponseFileItem = function isResponseFileItem(fileItem) {
    return 'details' in fileItem;
};
var $b1a5c0f0ab56f8ed$var$makeCacheKey = function makeCacheKey(id, collection) {
    return collection ? "".concat(id, "-").concat(collection) : id;
};
var $b1a5c0f0ab56f8ed$export$71cd2e8f8162d47b = function getItemsFromKeys(dataloaderKeys, fileItems) {
    var itemsByKey = fileItems.reduce(function(prev, fileItem) {
        var id = fileItem.id, collection = fileItem.collection;
        var key = $b1a5c0f0ab56f8ed$var$makeCacheKey(id, collection);
        if ($b1a5c0f0ab56f8ed$var$isBatchLoadingErrorResult(fileItem)) prev[key] = fileItem.error;
        else if ($b1a5c0f0ab56f8ed$var$isResponseFileItem(fileItem)) prev[key] = $b1a5c0f0ab56f8ed$var$_objectSpread($b1a5c0f0ab56f8ed$var$_objectSpread({}, fileItem.details), {}, {
            metadataTraceContext: fileItem.metadataTraceContext
        });
        else prev[key] = {
            id: id,
            collection: collection,
            type: 'not-found',
            metadataTraceContext: fileItem.metadataTraceContext
        };
        return prev;
    }, {});
    return dataloaderKeys.map(function(dataloaderKey) {
        var id = dataloaderKey.id, collectionName = dataloaderKey.collectionName;
        var key = $b1a5c0f0ab56f8ed$var$makeCacheKey(id, collectionName);
        return itemsByKey[key] || {
            id: id,
            type: 'not-found'
        };
    });
};

});


parcelRegister("dgoe5", function(module, exports) {
$parcel$export(module.exports, "MAX_BATCH_SIZE", () => $9a7f8fcd50ed2416$export$b79d95ee17a87a);
var $9a7f8fcd50ed2416$export$b79d95ee17a87a = 100;

});


parcelRegister("3uEc1", function(module, exports) {
$parcel$export(module.exports, "createMediaSubject", () => $28b359e3c2426d72$export$bc76d51553fa5e35);

var $3XPX2 = parcelRequire("3XPX2");
function $28b359e3c2426d72$export$bc76d51553fa5e35(initialState) {
    var subject = new (0, $3XPX2.ReplaySubject)(1);
    if (initialState instanceof Error) subject.error(initialState);
    else if (initialState) subject.next(initialState);
    return subject;
}

});
parcelRegister("3XPX2", function(module, exports) {
"use strict";
var $2e2f2e33bd28a05e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5r7W1 = parcelRequire("5r7W1");

var $KC2hG = parcelRequire("KC2hG");

var $lSgto = parcelRequire("lSgto");

var $lPK1b = parcelRequire("lPK1b");

var $gPIwV = parcelRequire("gPIwV");

var $58oCu = parcelRequire("58oCu");
/**
 * @class ReplaySubject<T>
 */ var $2e2f2e33bd28a05e$var$ReplaySubject = function(_super) {
    $2e2f2e33bd28a05e$var$__extends(ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) bufferSize = Number.POSITIVE_INFINITY;
        if (windowTime === void 0) windowTime = Number.POSITIVE_INFINITY;
        _super.call(this);
        this.scheduler = scheduler;
        this._events = [];
        this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        this._windowTime = windowTime < 1 ? 1 : windowTime;
    }
    ReplaySubject.prototype.next = function(value) {
        var now = this._getNow();
        this._events.push(new $2e2f2e33bd28a05e$var$ReplayEvent(now, value));
        this._trimBufferThenGetEvents();
        _super.prototype.next.call(this, value);
    };
    /** @deprecated internal use only */ ReplaySubject.prototype._subscribe = function(subscriber) {
        var _events = this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var subscription;
        if (this.closed) throw new $gPIwV.ObjectUnsubscribedError();
        else if (this.hasError) subscription = $lSgto.Subscription.EMPTY;
        else if (this.isStopped) subscription = $lSgto.Subscription.EMPTY;
        else {
            this.observers.push(subscriber);
            subscription = new $58oCu.SubjectSubscription(this, subscriber);
        }
        if (scheduler) subscriber.add(subscriber = new $lPK1b.ObserveOnSubscriber(subscriber, scheduler));
        var len = _events.length;
        for(var i = 0; i < len && !subscriber.closed; i++)subscriber.next(_events[i].value);
        if (this.hasError) subscriber.error(this.thrownError);
        else if (this.isStopped) subscriber.complete();
        return subscription;
    };
    ReplaySubject.prototype._getNow = function() {
        return (this.scheduler || $KC2hG.queue).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function() {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        // Trim events that fall out of the time window.
        // Start at the front of the list. Break early once
        // we encounter an event that falls within the window.
        while(spliceCount < eventsCount){
            if (now - _events[spliceCount].time < _windowTime) break;
            spliceCount++;
        }
        if (eventsCount > _bufferSize) spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        if (spliceCount > 0) _events.splice(0, spliceCount);
        return _events;
    };
    return ReplaySubject;
}($5r7W1.Subject);
module.exports.ReplaySubject = $2e2f2e33bd28a05e$var$ReplaySubject;
var $2e2f2e33bd28a05e$var$ReplayEvent = function() {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}();

});
parcelRegister("5r7W1", function(module, exports) {
"use strict";
var $3f55a10ff19d0f31$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lryMy = parcelRequire("lryMy");

var $deMDi = parcelRequire("deMDi");

var $lSgto = parcelRequire("lSgto");

var $gPIwV = parcelRequire("gPIwV");

var $58oCu = parcelRequire("58oCu");

var $efmvI = parcelRequire("efmvI");
/**
 * @class SubjectSubscriber<T>
 */ var $3f55a10ff19d0f31$var$SubjectSubscriber = function(_super) {
    $3f55a10ff19d0f31$var$__extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        _super.call(this, destination);
        this.destination = destination;
    }
    return SubjectSubscriber;
}($deMDi.Subscriber);
module.exports.SubjectSubscriber = $3f55a10ff19d0f31$var$SubjectSubscriber;
/**
 * @class Subject<T>
 */ var $3f55a10ff19d0f31$var$Subject = function(_super) {
    $3f55a10ff19d0f31$var$__extends(Subject, _super);
    function Subject() {
        _super.call(this);
        this.observers = [];
        this.closed = false;
        this.isStopped = false;
        this.hasError = false;
        this.thrownError = null;
    }
    Subject.prototype[$efmvI.rxSubscriber] = function() {
        return new $3f55a10ff19d0f31$var$SubjectSubscriber(this);
    };
    Subject.prototype.lift = function(operator) {
        var subject = new $3f55a10ff19d0f31$var$AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function(value) {
        if (this.closed) throw new $gPIwV.ObjectUnsubscribedError();
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for(var i = 0; i < len; i++)copy[i].next(value);
        }
    };
    Subject.prototype.error = function(err) {
        if (this.closed) throw new $gPIwV.ObjectUnsubscribedError();
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].error(err);
        this.observers.length = 0;
    };
    Subject.prototype.complete = function() {
        if (this.closed) throw new $gPIwV.ObjectUnsubscribedError();
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].complete();
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function(subscriber) {
        if (this.closed) throw new $gPIwV.ObjectUnsubscribedError();
        else return _super.prototype._trySubscribe.call(this, subscriber);
    };
    /** @deprecated internal use only */ Subject.prototype._subscribe = function(subscriber) {
        if (this.closed) throw new $gPIwV.ObjectUnsubscribedError();
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return $lSgto.Subscription.EMPTY;
        } else if (this.isStopped) {
            subscriber.complete();
            return $lSgto.Subscription.EMPTY;
        } else {
            this.observers.push(subscriber);
            return new $58oCu.SubjectSubscription(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function() {
        var observable = new $lryMy.Observable();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $3f55a10ff19d0f31$var$AnonymousSubject(destination, source);
    };
    return Subject;
}($lryMy.Observable);
module.exports.Subject = $3f55a10ff19d0f31$var$Subject;
/**
 * @class AnonymousSubject<T>
 */ var $3f55a10ff19d0f31$var$AnonymousSubject = function(_super) {
    $3f55a10ff19d0f31$var$__extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        _super.call(this);
        this.destination = destination;
        this.source = source;
    }
    AnonymousSubject.prototype.next = function(value) {
        var destination = this.destination;
        if (destination && destination.next) destination.next(value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var destination = this.destination;
        if (destination && destination.error) this.destination.error(err);
    };
    AnonymousSubject.prototype.complete = function() {
        var destination = this.destination;
        if (destination && destination.complete) this.destination.complete();
    };
    /** @deprecated internal use only */ AnonymousSubject.prototype._subscribe = function(subscriber) {
        var source = this.source;
        if (source) return this.source.subscribe(subscriber);
        else return $lSgto.Subscription.EMPTY;
    };
    return AnonymousSubject;
}($3f55a10ff19d0f31$var$Subject);
module.exports.AnonymousSubject = $3f55a10ff19d0f31$var$AnonymousSubject;

});
parcelRegister("gPIwV", function(module, exports) {
"use strict";
var $c413f381f069d03f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an action is invalid because the object has been
 * unsubscribed.
 *
 * @see {@link Subject}
 * @see {@link BehaviorSubject}
 *
 * @class ObjectUnsubscribedError
 */ var $c413f381f069d03f$var$ObjectUnsubscribedError = function(_super) {
    $c413f381f069d03f$var$__extends(ObjectUnsubscribedError, _super);
    function ObjectUnsubscribedError() {
        var err = _super.call(this, 'object unsubscribed');
        this.name = err.name = 'ObjectUnsubscribedError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ObjectUnsubscribedError;
}(Error);
module.exports.ObjectUnsubscribedError = $c413f381f069d03f$var$ObjectUnsubscribedError;

});

parcelRegister("58oCu", function(module, exports) {
"use strict";
var $3bd0cc1474300481$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lSgto = parcelRequire("lSgto");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3bd0cc1474300481$var$SubjectSubscription = function(_super) {
    $3bd0cc1474300481$var$__extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        _super.call(this);
        this.subject = subject;
        this.subscriber = subscriber;
        this.closed = false;
    }
    SubjectSubscription.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) return;
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) observers.splice(subscriberIndex, 1);
    };
    return SubjectSubscription;
}($lSgto.Subscription);
module.exports.SubjectSubscription = $3bd0cc1474300481$var$SubjectSubscription;

});


parcelRegister("KC2hG", function(module, exports) {
$parcel$export(module.exports, "queue", () => $08c1cd1e6b154c01$export$4f7fa46ff53e516f, (v) => $08c1cd1e6b154c01$export$4f7fa46ff53e516f = v);
/**
 *
 * Queue Scheduler
 *
 * <span class="informal">Put every next task on a queue, instead of executing it immediately</span>
 *
 * `queue` scheduler, when used with delay, behaves the same as {@link async} scheduler.
 *
 * When used without delay, it schedules given task synchronously - executes it right when
 * it is scheduled. However when called recursively, that is when inside the scheduled task,
 * another task is scheduled with queue scheduler, instead of executing immediately as well,
 * that task will be put on a queue and wait for current one to finish.
 *
 * This means that when you execute task with `queue` scheduler, you are sure it will end
 * before any other task scheduled with that scheduler will start.
 *
 * @examples <caption>Schedule recursively first, then do something</caption>
 *
 * Rx.Scheduler.queue.schedule(() => {
 *   Rx.Scheduler.queue.schedule(() => console.log('second')); // will not happen now, but will be put on a queue
 *
 *   console.log('first');
 * });
 *
 * // Logs:
 * // "first"
 * // "second"
 *
 *
 * @example <caption>Reschedule itself recursively</caption>
 *
 * Rx.Scheduler.queue.schedule(function(state) {
 *   if (state !== 0) {
 *     console.log('before', state);
 *     this.schedule(state - 1); // `this` references currently executing Action,
 *                               // which we reschedule with new state
 *     console.log('after', state);
 *   }
 * }, 0, 3);
 *
 * // In scheduler that runs recursively, you would expect:
 * // "before", 3
 * // "before", 2
 * // "before", 1
 * // "after", 1
 * // "after", 2
 * // "after", 3
 *
 * // But with queue it logs:
 * // "before", 3
 * // "after", 3
 * // "before", 2
 * // "after", 2
 * // "before", 1
 * // "after", 1
 *
 *
 * @static true
 * @name queue
 * @owner Scheduler
 */ var $08c1cd1e6b154c01$export$4f7fa46ff53e516f;
"use strict";

var $1lCaP = parcelRequire("1lCaP");

var $dabgw = parcelRequire("dabgw");
$08c1cd1e6b154c01$export$4f7fa46ff53e516f = new $dabgw.QueueScheduler($1lCaP.QueueAction);

});
parcelRegister("1lCaP", function(module, exports) {
"use strict";
var $0fb55d13da2025a8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $1ydSg = parcelRequire("1ydSg");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0fb55d13da2025a8$var$QueueAction = function(_super) {
    $0fb55d13da2025a8$var$__extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    QueueAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (delay > 0) return _super.prototype.schedule.call(this, state, delay);
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function(state, delay) {
        return delay > 0 || this.closed ? _super.prototype.execute.call(this, state, delay) : this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        // Otherwise flush the scheduler starting with this action.
        return scheduler.flush(this);
    };
    return QueueAction;
}($1ydSg.AsyncAction);
module.exports.QueueAction = $0fb55d13da2025a8$var$QueueAction;

});
parcelRegister("1ydSg", function(module, exports) {
"use strict";
var $1213ba871890f324$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gvBTr = parcelRequire("gvBTr");

var $dkg3w = parcelRequire("dkg3w");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1213ba871890f324$var$AsyncAction = function(_super) {
    $1213ba871890f324$var$__extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.pending = false;
        this.work = work;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        // Always replace the current state with the new state.
        this.state = state;
        // Set the pending flag indicating that this action has been scheduled, or
        // has recursively rescheduled itself.
        this.pending = true;
        var id = this.id;
        var scheduler = this.scheduler;
        //
        // Important implementation note:
        //
        // Actions only execute once by default, unless rescheduled from within the
        // scheduled callback. This allows us to implement single and repeat
        // actions via the same code path, without adding API surface area, as well
        // as mimic traditional recursion but across asynchronous boundaries.
        //
        // However, JS runtimes and timers distinguish between intervals achieved by
        // serial `setTimeout` calls vs. a single `setInterval` call. An interval of
        // serial `setTimeout` calls can be individually delayed, which delays
        // scheduling the next `setTimeout`, and so on. `setInterval` attempts to
        // guarantee the interval callback will be invoked more precisely to the
        // interval period, regardless of load.
        //
        // Therefore, we use `setInterval` to schedule single and repeat actions.
        // If the action reschedules itself with the same delay, the interval is not
        // canceled. If the action doesn't reschedule, or reschedules with a
        // different delay, the interval will be canceled after scheduled callback
        // execution.
        //
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.delay = delay;
        // If this action has already an async Id, don't request a new one.
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return $gvBTr.root.setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If this action is rescheduled with the same delay time, don't clear the interval id.
        if (delay !== null && this.delay === delay && this.pending === false) return id;
        // Otherwise, if the action's delay time is different from the current delay,
        // or the action has been rescheduled before it's executed, clear the interval id
        return $gvBTr.root.clearInterval(id) && undefined, undefined;
    };
    /**
     * Immediately executes this action and the `work` it contains.
     * @return {any}
     */ AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error('executing a cancelled action');
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) // Dequeue if the action didn't reschedule itself. Don't call
        // unsubscribe(), because the action could reschedule later.
        // For example:
        // ```
        // scheduler.schedule(function doWork(counter) {
        //   /* ... I'm a busy worker bee ... */
        //   var originalAction = this;
        //   /* wait 100ms before rescheduling the action */
        //   setTimeout(function () {
        //     originalAction.schedule(counter + 1);
        //   }, 100);
        // }, 1000);
        // ```
        this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    /** @deprecated internal use only */ AsyncAction.prototype._unsubscribe = function() {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) actions.splice(index, 1);
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
        this.delay = null;
    };
    return AsyncAction;
}($dkg3w.Action);
module.exports.AsyncAction = $1213ba871890f324$var$AsyncAction;

});
parcelRegister("dkg3w", function(module, exports) {
"use strict";
var $9b3998f5fef37039$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lSgto = parcelRequire("lSgto");
/**
 * A unit of work to be executed in a {@link Scheduler}. An action is typically
 * created from within a Scheduler and an RxJS user does not need to concern
 * themselves about creating and manipulating an Action.
 *
 * ```ts
 * class Action<T> extends Subscription {
 *   new (scheduler: Scheduler, work: (state?: T) => void);
 *   schedule(state?: T, delay: number = 0): Subscription;
 * }
 * ```
 *
 * @class Action<T>
 */ var $9b3998f5fef37039$var$Action = function(_super) {
    $9b3998f5fef37039$var$__extends(Action, _super);
    function Action(scheduler, work) {
        _super.call(this);
    }
    /**
     * Schedules this action on its parent Scheduler for execution. May be passed
     * some context object, `state`. May happen at some point in the future,
     * according to the `delay` parameter, if specified.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler.
     * @return {void}
     */ Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}($lSgto.Subscription);
module.exports.Action = $9b3998f5fef37039$var$Action;

});



parcelRegister("dabgw", function(module, exports) {
"use strict";
var $9954f2a10ad9c0de$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $eoP0B = parcelRequire("eoP0B");
var $9954f2a10ad9c0de$var$QueueScheduler = function(_super) {
    $9954f2a10ad9c0de$var$__extends(QueueScheduler, _super);
    function QueueScheduler() {
        _super.apply(this, arguments);
    }
    return QueueScheduler;
}($eoP0B.AsyncScheduler);
module.exports.QueueScheduler = $9954f2a10ad9c0de$var$QueueScheduler;

});
parcelRegister("eoP0B", function(module, exports) {
"use strict";
var $a7badfdc07b6ab7e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $LPnGE = parcelRequire("LPnGE");
var $a7badfdc07b6ab7e$var$AsyncScheduler = function(_super) {
    $a7badfdc07b6ab7e$var$__extends(AsyncScheduler, _super);
    function AsyncScheduler() {
        _super.apply(this, arguments);
        this.actions = [];
        /**
         * A flag to indicate whether the Scheduler is currently executing a batch of
         * queued actions.
         * @type {boolean}
         */ this.active = false;
        /**
         * An internal ID used to track the latest asynchronous task such as those
         * coming from `setTimeout`, `setInterval`, `requestAnimationFrame`, and
         * others.
         * @type {any}
         */ this.scheduled = undefined;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift()); // exhaust the scheduler queue
        this.active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}($LPnGE.Scheduler);
module.exports.AsyncScheduler = $a7badfdc07b6ab7e$var$AsyncScheduler;

});
parcelRegister("LPnGE", function(module, exports) {
$parcel$export(module.exports, "Scheduler", () => $08fc3f1b39f459ba$export$d3e54bb8584cda7c, (v) => $08fc3f1b39f459ba$export$d3e54bb8584cda7c = v);
var $08fc3f1b39f459ba$export$d3e54bb8584cda7c;
"use strict";
/**
 * An execution context and a data structure to order tasks and schedule their
 * execution. Provides a notion of (potentially virtual) time, through the
 * `now()` getter method.
 *
 * Each unit of work in a Scheduler is called an {@link Action}.
 *
 * ```ts
 * class Scheduler {
 *   now(): number;
 *   schedule(work, delay?, state?): Subscription;
 * }
 * ```
 *
 * @class Scheduler
 */ var $08fc3f1b39f459ba$var$Scheduler = function() {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) now = Scheduler.now;
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    /**
     * Schedules a function, `work`, for execution. May happen at some point in
     * the future, according to the `delay` parameter, if specified. May be passed
     * some context object, `state`, which will be passed to the `work` function.
     *
     * The given arguments will be processed an stored as an Action object in a
     * queue of actions.
     *
     * @param {function(state: ?T): ?Subscription} work A function representing a
     * task, or some unit of work to be executed by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler itself.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @return {Subscription} A subscription in order to be able to unsubscribe
     * the scheduled work.
     */ Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = Date.now ? Date.now : function() {
        return +new Date();
    };
    return Scheduler;
}();
$08fc3f1b39f459ba$export$d3e54bb8584cda7c = $08fc3f1b39f459ba$var$Scheduler;

});






parcelRegister("3J535", function(module, exports) {
$parcel$export(module.exports, "isEmptyFile", () => $2b697da744e8cf80$export$728192ce8dd94659);
/**
 * EMPTY_FILE_HOURS_ELAPSED_TOLERANCE - how many hours since this file was
 * created until we give up on expecting metadata?
 *
 * Yes, this is not an exact science. Any value under this tolerance will
 * go undetected, however this is still suitable to catch the majority of
 * cases where empty (files which never finished upload) are being reloaded.
 *
 * Continuous bad renders of empty files will eat our card render SLIs, so until
 * there is a better response from backend we use this technique.
 *
 * Being encapsulated in this function, we can always improve the detection transparently.
 */ var $2b697da744e8cf80$export$d32fc52697b2ec92 = 43200000; /* 12 hours */ 
function $2b697da744e8cf80$export$728192ce8dd94659(fileDetails) {
    var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
    var artifacts = fileDetails.artifacts, mediaType = fileDetails.mediaType, mimeType = fileDetails.mimeType, name = fileDetails.name, processingStatus = fileDetails.processingStatus, representations = fileDetails.representations, size = fileDetails.size, createdAt = fileDetails.createdAt;
    if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
        var msSinceFileCreation = now - createdAt;
        if (msSinceFileCreation > $2b697da744e8cf80$export$d32fc52697b2ec92) return true;
    }
    return false;
}

});

parcelRegister("kbmH2", function(module, exports) {
$parcel$export(module.exports, "getDimensionsFromBlob", () => $eb167017fe1a161a$export$71797c284d89a3e1);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $42UQI = parcelRequire("42UQI");

var $5A7fJ = parcelRequire("5A7fJ");
var $eb167017fe1a161a$export$71797c284d89a3e1 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(mediaType, blob) {
        var url, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _t = mediaType;
                    _context.next = _t === 'image' ? 1 : _t === 'video' ? 5 : 6;
                    break;
                case 1:
                    url = URL.createObjectURL(blob);
                    _context.prev = 2;
                    _context.next = 3;
                    return (0, $42UQI.getImageDimensionsFromBlob)(url);
                case 3:
                    return _context.abrupt("return", _context.sent);
                case 4:
                    _context.prev = 4;
                    URL.revokeObjectURL(url);
                    return _context.finish(4);
                case 5:
                    return _context.abrupt("return", (0, $5A7fJ.getVideoDimensionsFromBlob)(blob));
                case 6:
                    throw new Error("Can't extract dimensions from ".concat(mediaType));
                case 7:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                2,
                ,
                4,
                5
            ]
        ]);
    }));
    return function getDimensionsFromBlob(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("42UQI", function(module, exports) {
$parcel$export(module.exports, "getImageDimensionsFromBlob", () => $2f2372680efa6266$export$a1c3205f28a20414);
var $2f2372680efa6266$export$a1c3205f28a20414 = function getImageDimensionsFromBlob(url) {
    return new Promise(function(resolve, reject) {
        var img = new Image();
        img.src = url;
        img.onload = function() {
            return resolve({
                width: img.width,
                height: img.height
            });
        };
        img.onerror = reject;
    });
};

});

parcelRegister("5A7fJ", function(module, exports) {
$parcel$export(module.exports, "getVideoDimensionsFromBlob", () => $4105f0cc537f5bf1$export$62aabd5ff85d0451);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");
var $4105f0cc537f5bf1$export$62aabd5ff85d0451 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(blob) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", new Promise(function(resolve, reject) {
                        var url = URL.createObjectURL(blob);
                        var video = document.createElement('video');
                        video.preload = 'metadata';
                        video.src = url;
                        video.muted = true;
                        // loadedmetadata, loadeddata, play, playing
                        video.addEventListener('loadedmetadata', function timeupdateHandler() {
                            video.removeEventListener('loadedmetadata', timeupdateHandler);
                            resolve({
                                width: video.videoWidth,
                                height: video.videoHeight
                            });
                            URL.revokeObjectURL(url);
                        });
                        video.addEventListener('error', function() {
                            reject(new Error('failed to load video'));
                            URL.revokeObjectURL(url);
                        });
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function getVideoDimensionsFromBlob(_x) {
        return _ref.apply(this, arguments);
    };
}();

});


parcelRegister("ulNU1", function(module, exports) {
$parcel$export(module.exports, "getMediaTypeFromUploadableFile", () => $05b3b740dc8756c2$export$ac3214931ffd82af);

var $7VCF9 = parcelRequire("7VCF9");
var $05b3b740dc8756c2$export$ac3214931ffd82af = function getMediaTypeFromUploadableFile(file) {
    if (file.content instanceof Blob) {
        var type = file.content.type;
        return (0, $7VCF9.getMediaTypeFromMimeType)(type);
    } else return 'unknown';
};

});

parcelRegister("9iDns", function(module, exports) {
$parcel$export(module.exports, "fromObservable", () => $6c545704f0f378c5$export$4b2432e2d8723823);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
function $6c545704f0f378c5$export$4b2432e2d8723823(observable) {
    return {
        subscribe: function subscribe(observer) {
            var subscription = // This is needed to handle "subscribe" function overload.
            // It allows accepting a single "next" callback function as an argument.
            observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
            return {
                unsubscribe: function unsubscribe() {
                    subscription.unsubscribe();
                }
            };
        }
    };
}

});

parcelRegister("5ULj5", function(module, exports) {
$parcel$export(module.exports, "toPromise", () => $44e6e0d7c2b531bc$export$4dbaaf6c79705e6c);

var $lSgto = parcelRequire("lSgto");
var $44e6e0d7c2b531bc$export$4dbaaf6c79705e6c = function toPromise(mediaSubscribable) {
    var subscription = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new (0, $lSgto.Subscription)();
    return new Promise(function(resolve, reject) {
        return subscription.add(mediaSubscribable.subscribe({
            next: function next(state) {
                resolve(state);
                subscription.unsubscribe();
            },
            error: function error(_error) {
                reject(_error);
                subscription.unsubscribe();
            }
        }));
    });
};

});

parcelRegister("aKw8h", function(module, exports) {
$parcel$export(module.exports, "overrideMediaTypeIfUnknown", () => $7d37201b44649727$export$89097c0ec1e0dee1);

var $17rlx = parcelRequire("17rlx");
var $7d37201b44649727$export$89097c0ec1e0dee1 = function overrideMediaTypeIfUnknown(fileState, mediaType) {
    if (!(0, $17rlx.isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
        mediaType: mediaType
    };
    return {};
};

});

parcelRegister("432Wm", function(module, exports) {
$parcel$export(module.exports, "PollingFunction", () => $2f29b91b0d5bac4b$export$4c54d536f8e37dc2);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $62mGp = parcelRequire("62mGp");

function $2f29b91b0d5bac4b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2f29b91b0d5bac4b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2f29b91b0d5bac4b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2f29b91b0d5bac4b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2f29b91b0d5bac4b$export$9f15a162d6785fc9 = {
    poll_intervalMs: 3000,
    poll_maxAttempts: 30,
    poll_backoffFactor: 1.25,
    poll_maxIntervalMs: 200000
};
var $2f29b91b0d5bac4b$export$4c54d536f8e37dc2 = /*#__PURE__*/ function() {
    function PollingFunction(options) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PollingFunction);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "poll_intervalMs", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "attempt", 1);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "shouldIterate", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "timeoutId", 0);
        this.options = $2f29b91b0d5bac4b$var$_objectSpread($2f29b91b0d5bac4b$var$_objectSpread({}, $2f29b91b0d5bac4b$export$9f15a162d6785fc9), options);
        this.poll_intervalMs = this.options.poll_intervalMs;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PollingFunction, [
        {
            key: "execute",
            value: function() {
                var _execute = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(executor) {
                    var _this = this;
                    var poll_maxAttempts, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                poll_maxAttempts = this.options.poll_maxAttempts;
                                if (!(poll_maxAttempts === 0)) {
                                    _context.next = 1;
                                    break;
                                }
                                return _context.abrupt("return", this.fail(new (0, $62mGp.PollingError)('pollingMaxAttemptsExceeded', {
                                    attempts: this.attempt
                                })));
                            case 1:
                                _context.prev = 1;
                                // executor must explicitly call this.next() for triggering next iteration (pull)
                                this.shouldIterate = false;
                                _context.next = 2;
                                return executor();
                            case 2:
                                if (this.shouldIterate) {
                                    _context.next = 3;
                                    break;
                                }
                                return _context.abrupt("return");
                            case 3:
                                if (!(this.attempt >= poll_maxAttempts)) {
                                    _context.next = 4;
                                    break;
                                }
                                return _context.abrupt("return", this.fail(new (0, $62mGp.PollingError)('pollingMaxAttemptsExceeded', {
                                    attempts: this.attempt
                                })));
                            case 4:
                                this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
                                this.attempt++;
                                this.timeoutId = window.setTimeout(function() {
                                    return _this.execute(executor);
                                }, this.poll_intervalMs);
                                _context.next = 6;
                                break;
                            case 5:
                                _context.prev = 5;
                                _t = _context["catch"](1);
                                this.fail(_t);
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            5
                        ]
                    ]);
                }));
                function execute(_x) {
                    return _execute.apply(this, arguments);
                }
                return execute;
            }()
        },
        {
            key: "fail",
            value: function fail(error) {
                var onError = this.onError;
                this.cancel();
                onError && onError(error);
            }
        },
        {
            key: "getIntervalMsForIteration",
            value: function getIntervalMsForIteration(iteration) {
                var poll_intervalMs = this.options.poll_intervalMs;
                if (iteration === 1) return poll_intervalMs;
                for(var i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
                return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
            }
        },
        {
            key: "next",
            value: function next() {
                this.shouldIterate = true;
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                window.clearTimeout(this.timeoutId);
                this.timeoutId = 0;
            }
        }
    ]);
}();

});
parcelRegister("62mGp", function(module, exports) {
$parcel$export(module.exports, "PollingError", () => $4654865f19e9aef4$export$c3748c310e92340a);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $ij82I = parcelRequire("ij82I");
function $4654865f19e9aef4$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $4654865f19e9aef4$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $4654865f19e9aef4$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4654865f19e9aef4$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $4654865f19e9aef4$export$c3748c310e92340a = /*#__PURE__*/ function(_BaseMediaClientError) {
    function PollingError(reason, metadata) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PollingError);
        return $4654865f19e9aef4$var$_callSuper(this, PollingError, [
            reason,
            metadata,
            undefined
        ]);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(PollingError, _BaseMediaClientError);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PollingError, [
        {
            key: "attributes",
            get: function get() {
                var reason = this.reason, attempts = this.metadata.attempts;
                return {
                    reason: reason,
                    attempts: attempts
                };
            }
        }
    ]);
}((0, $ij82I.BaseMediaClientError));

});


parcelRegister("f84Q2", function(module, exports) {
$parcel$export(module.exports, "defaultShouldRetryError", () => $b03b5b2eaa1ae1f4$export$fee2242cbb339663);

var $3y3gS = parcelRequire("3y3gS");

var $eCc8i = parcelRequire("eCc8i");
var $b03b5b2eaa1ae1f4$export$fee2242cbb339663 = function defaultShouldRetryError(err) {
    var statusCode = (0, $3y3gS.getStatusCode)(err);
    return (0, $eCc8i.isFetchNetworkError)(err) || (statusCode ? statusCode >= 500 : false);
};

});
parcelRegister("3y3gS", function(module, exports) {
$parcel$export(module.exports, "getStatusCode", () => $295715a9bfe93bca$export$68868794c9b58e55);

var $5MquH = parcelRequire("5MquH");
var $295715a9bfe93bca$export$68868794c9b58e55 = function getStatusCode(error) {
    var _error$metadata;
    return (0, $5MquH.isRequestError)(error) && ((_error$metadata = error.metadata) === null || _error$metadata === void 0 ? void 0 : _error$metadata.statusCode) && error.metadata.statusCode;
};

});
parcelRegister("5MquH", function(module, exports) {
$parcel$export(module.exports, "isRequestError", () => $4355fca7559c4c97$export$3717b1ffef4428ea);

var $k7XwF = parcelRequire("k7XwF");
function $4355fca7559c4c97$export$3717b1ffef4428ea(err) {
    return err instanceof (0, $k7XwF.RequestError);
}

});
parcelRegister("k7XwF", function(module, exports) {
$parcel$export(module.exports, "RequestError", () => $ea72a2b72eed1998$export$43ee7d0e4f429743);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $ij82I = parcelRequire("ij82I");
function $ea72a2b72eed1998$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $ea72a2b72eed1998$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $ea72a2b72eed1998$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ea72a2b72eed1998$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ea72a2b72eed1998$export$43ee7d0e4f429743 = /*#__PURE__*/ function(_BaseMediaClientError) {
    function RequestError(reason, metadata, innerError) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, RequestError);
        return $ea72a2b72eed1998$var$_callSuper(this, RequestError, [
            reason,
            metadata,
            innerError
        ]);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(RequestError, _BaseMediaClientError);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(RequestError, [
        {
            key: "attributes",
            get: function get() {
                var reason = this.reason, _this$metadata = this.metadata, _this$metadata2 = _this$metadata === void 0 ? {} : _this$metadata, method = _this$metadata2.method, endpoint = _this$metadata2.endpoint, mediaRegion = _this$metadata2.mediaRegion, mediaEnv = _this$metadata2.mediaEnv, attempts = _this$metadata2.attempts, clientExhaustedRetries = _this$metadata2.clientExhaustedRetries, statusCode = _this$metadata2.statusCode, traceContext = _this$metadata2.traceContext, innerError = this.innerError;
                return {
                    reason: reason,
                    method: method,
                    endpoint: endpoint,
                    mediaRegion: mediaRegion,
                    mediaEnv: mediaEnv,
                    attempts: attempts,
                    clientExhaustedRetries: clientExhaustedRetries,
                    statusCode: statusCode,
                    metadata: {
                        traceContext: traceContext
                    },
                    innerError: innerError
                };
            }
        }
    ]);
}((0, $ij82I.BaseMediaClientError));

});



parcelRegister("eCc8i", function(module, exports) {
$parcel$export(module.exports, "isFetchNetworkError", () => $aa3e069a57fbacd6$export$ad8c5cf7dd4c3caf);
// fetch throws TypeError for network errors
function $aa3e069a57fbacd6$export$ad8c5cf7dd4c3caf(err) {
    return err instanceof TypeError;
}

});


parcelRegister("8kXu2", function(module, exports) {
$parcel$export(module.exports, "shouldFetchRemoteFileStates", () => $611e552a35a3c6b6$export$2ccdd6f9a9eba6a);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $keEas = parcelRequire("keEas");
var $aWDq9n = parcelRequire("aWDq9n");

var $5A7fJ = parcelRequire("5A7fJ");
function $611e552a35a3c6b6$export$2ccdd6f9a9eba6a(_x, _x2, _x3) {
    return $611e552a35a3c6b6$var$_shouldFetchRemoteFileStates.apply(this, arguments);
}
function $611e552a35a3c6b6$var$_shouldFetchRemoteFileStates() {
    $611e552a35a3c6b6$var$_shouldFetchRemoteFileStates = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(mediaType, mimeType, preview) {
        var content, _yield$getVideoDimens, width, height, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!((mediaType === 'doc' || !(0, $keEas.isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, $aWDq9n.isMimeTypeSupportedByServer)(mimeType))) {
                        _context.next = 1;
                        break;
                    }
                    return _context.abrupt("return", true);
                case 1:
                    if (!(mediaType === 'video' && !!preview)) {
                        _context.next = 6;
                        break;
                    }
                    _context.next = 2;
                    return preview;
                case 2:
                    content = _context.sent.value;
                    if (content instanceof Blob) {
                        _context.next = 3;
                        break;
                    }
                    return _context.abrupt("return", false);
                case 3:
                    _context.prev = 3;
                    _context.next = 4;
                    return (0, $5A7fJ.getVideoDimensionsFromBlob)(content);
                case 4:
                    _yield$getVideoDimens = _context.sent;
                    width = _yield$getVideoDimens.width;
                    height = _yield$getVideoDimens.height;
                    return _context.abrupt("return", !width && !height);
                case 5:
                    _context.prev = 5;
                    _t = _context["catch"](3);
                    return _context.abrupt("return", true);
                case 6:
                    return _context.abrupt("return", false);
                case 7:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                3,
                5
            ]
        ]);
    }));
    return $611e552a35a3c6b6$var$_shouldFetchRemoteFileStates.apply(this, arguments);
}

});

parcelRegister("elHy7", function(module, exports) {
$parcel$export(module.exports, "MediaStore", () => $a724ced935606131$export$572b8a2a9fd7cbba);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $k9W36 = parcelRequire("k9W36");

var $5VZM7 = parcelRequire("5VZM7");

var $50U6m = parcelRequire("50U6m");

var $eW8Rv = parcelRequire("eW8Rv");

var $6wdjf = parcelRequire("6wdjf");

var $4w9gA = parcelRequire("4w9gA");

var $kauwE = parcelRequire("kauwE");

var $53jt3 = parcelRequire("53jt3");

var $eaGjU = parcelRequire("eaGjU");

var $gq7UA = parcelRequire("gq7UA");

var $f5wck = parcelRequire("f5wck");

var $5MquH = parcelRequire("5MquH");
var $6xzC8 = parcelRequire("6xzC8");

var $50Quz = parcelRequire("50Quz");

var $4eDLV = parcelRequire("4eDLV");

var $c7qys = parcelRequire("c7qys");

var $f84Q2 = parcelRequire("f84Q2");

var $7zJ8N = parcelRequire("7zJ8N");

var $c3qCW = parcelRequire("c3qCW");

var $kXAOC = parcelRequire("kXAOC");

var $h1dzo = parcelRequire("h1dzo");

var $hr9fJ = parcelRequire("hr9fJ");

var $ex5xh = parcelRequire("ex5xh");

var $kjrF0 = parcelRequire("kjrF0");

var $5Q9tE = parcelRequire("5Q9tE");

var $2mZxN = parcelRequire("2mZxN");



function $a724ced935606131$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a724ced935606131$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a724ced935606131$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a724ced935606131$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a724ced935606131$export$ae7fb0ee64408016 = 'media-api-region';
var $a724ced935606131$export$2e3b0a8a2a2bf81c = 'media-api-environment';
var $a724ced935606131$export$572b8a2a9fd7cbba = /*#__PURE__*/ function() {
    function MediaStore(config) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, MediaStore);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getArtifactBinary", /*#__PURE__*/ function() {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(artifacts, artifactName, _ref) {
                var collectionName, abortController, _ref$maxAge, maxAge, traceContext, metadata, extendedTraceContext, options, artifactUrl;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            collectionName = _ref.collectionName, abortController = _ref.abortController, _ref$maxAge = _ref.maxAge, maxAge = _ref$maxAge === void 0 ? (0, $6wdjf.FILE_CACHE_MAX_AGE) : _ref$maxAge, traceContext = _ref.traceContext;
                            metadata = {
                                method: 'GET',
                                endpoint: "artifact-cdn-url"
                            };
                            extendedTraceContext = (0, $7zJ8N.extendTraceContext)(traceContext);
                            options = $a724ced935606131$var$_objectSpread($a724ced935606131$var$_objectSpread({}, metadata), {}, {
                                traceContext: extendedTraceContext
                            });
                            _context.next = 1;
                            return _this.getArtifactURL(artifacts, artifactName, collectionName, maxAge);
                        case 1:
                            artifactUrl = _context.sent;
                            return _context.abrupt("return", (0, $6xzC8.request)(artifactUrl, options, abortController).then((0, $50Quz.createMapResponseToBlob)(metadata)));
                        case 2:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x, _x2, _x3) {
                return _ref2.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "uploadArtifact", /*#__PURE__*/ function() {
            var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(id, file, params, collectionName, traceContext) {
                var metadata, headers, extendedParams, authContext, options;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            metadata = {
                                method: 'POST',
                                endpoint: '/file/{fileId}/artifact/binary'
                            };
                            headers = {
                                Accept: 'application/json',
                                'Content-Type': file.type
                            };
                            extendedParams = $a724ced935606131$var$_objectSpread($a724ced935606131$var$_objectSpread({}, params), {}, {
                                name: file.name,
                                collection: collectionName
                            });
                            authContext = {
                                collectionName: collectionName,
                                access: [
                                    {
                                        type: 'file',
                                        id: id,
                                        actions: [
                                            'update'
                                        ]
                                    }
                                ]
                            };
                            options = $a724ced935606131$var$_objectSpread($a724ced935606131$var$_objectSpread({}, metadata), {}, {
                                authContext: authContext,
                                headers: headers,
                                params: extendedParams,
                                body: file,
                                traceContext: traceContext
                            });
                            return _context2.abrupt("return", _this.request("/file/".concat(id, "/artifact/binary"), options).then((0, $4eDLV.createMapResponseToJson)(metadata)));
                        case 1:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee2);
            }));
            return function(_x4, _x5, _x6, _x7, _x8) {
                return _ref3.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "deleteArtifact", /*#__PURE__*/ function() {
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(id, artifactName, collectionName, traceContext) {
                var metadata, authContext, options;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                    while(true)switch(_context3.prev = _context3.next){
                        case 0:
                            metadata = {
                                method: 'DELETE',
                                endpoint: '/file/{fileId}/artifact/{artifactName}'
                            };
                            authContext = {
                                collectionName: collectionName,
                                access: [
                                    {
                                        type: 'file',
                                        id: id,
                                        actions: [
                                            'update'
                                        ]
                                    }
                                ]
                            };
                            options = $a724ced935606131$var$_objectSpread($a724ced935606131$var$_objectSpread({}, metadata), {}, {
                                authContext: authContext,
                                traceContext: traceContext,
                                params: {
                                    collection: collectionName
                                }
                            });
                            _context3.next = 1;
                            return _this.request("/file/".concat(id, "/artifact/").concat(artifactName), options);
                        case 1:
                        case "end":
                            return _context3.stop();
                    }
                }, _callee3);
            }));
            return function(_x9, _x0, _x1, _x10) {
                return _ref4.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "resolveAuth", function(authContext) {
            return (0, $kjrF0.resolveAuth)(_this.config.authProvider, authContext, _this.config.authProviderTimeout);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "resolveInitialAuth", function() {
            return (0, $5Q9tE.resolveInitialAuth)(_this.config.initialAuth);
        });
        this.config = config;
        this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $k9W36.ChunkHashAlgorithm).Sha256;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(MediaStore, [
        {
            key: "getClientId",
            value: function() {
                var _getClientId = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(collectionName) {
                    var auth;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return this.resolveAuth({
                                    collectionName: collectionName
                                });
                            case 1:
                                auth = _context4.sent;
                                return _context4.abrupt("return", MediaStore.extractClientIdFromAuth(auth));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function getClientId(_x11) {
                    return _getClientId.apply(this, arguments);
                }
                return getClientId;
            }()
        },
        {
            key: "getClientIdSync",
            value: function getClientIdSync() {
                try {
                    var auth = this.resolveInitialAuth();
                    return MediaStore.extractClientIdFromAuth(auth);
                } catch (_unused) {
                    // initialAuth may not be available, return undefined
                    return undefined;
                }
            }
        },
        {
            key: "removeCollectionFile",
            value: function() {
                var _removeCollectionFile = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(id, collectionName, occurrenceKey, traceContext) {
                    var metadata, body, options;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                metadata = {
                                    method: 'PUT',
                                    endpoint: '/collection/{collectionName}'
                                };
                                body = {
                                    actions: [
                                        {
                                            action: 'remove',
                                            item: {
                                                type: 'file',
                                                id: id,
                                                occurrenceKey: occurrenceKey
                                            }
                                        }
                                    ]
                                };
                                options = $a724ced935606131$var$_objectSpread($a724ced935606131$var$_objectSpread({}, metadata), {}, {
                                    authContext: {
                                        collectionName: collectionName
                                    },
                                    headers: {
                                        Accept: 'application/json',
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify(body),
                                    traceContext: traceContext
                                });
                                _context5.next = 1;
                                return this.request("/collection/".concat(collectionName), options);
                            case 1:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function removeCollectionFile(_x12, _x13, _x14, _x15) {
                    return _removeCollectionFile.apply(this, arguments);
                }
                return removeCollectionFile;
            }()
        },
        {
            key: "createUpload",
            value: function createUpload() {
                var createUpTo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
                var collectionName = arguments.length > 1 ? arguments[1] : undefined;
                var traceContext = arguments.length > 2 ? arguments[2] : undefined;
                var metadata = {
                    method: 'POST',
                    endpoint: '/upload'
                };
                var options = $a724ced935606131$var$_objectSpread($a724ced935606131$var$_objectSpread({}, metadata), {}, {
                    authContext: {
                        collectionName: collectionName
                    },
                    params: {
                        createUpTo: createUpTo,
                        hashAlgorithm: this._chunkHashAlgorithm
                    },
                    headers: {
                        Accept: 'application/json'
                    },
                    traceContext: traceContext
                });
                return this.request("/upload", options).then((0, $4eDLV.createMapResponseToJson)(metadata));
            }
        },
        {
            key: "uploadChunk",
            value: function() {
                var _uploadChunk = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(etag, blob, uploadId, partNumber, collectionName, traceContext) {
                    var metadata, options;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                metadata = {
                                    method: 'PUT',
                                    endpoint: '/chunk/{etag}'
                                };
                                options = $a724ced935606131$var$_objectSpread($a724ced935606131$var$_objectSpread({}, metadata), {}, {
                                    params: {
                                        uploadId: uploadId,
                                        partNumber: partNumber
                                    },
                                    authContext: {
                                        collectionName: collectionName
                                    },
                                    body: blob,
                                    traceContext: traceContext
                                });
                                _context6.next = 1;
                                return this.request("/chunk/".concat(etag), options);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function uploadChunk(_x16, _x17, _x18, _x19, _x20, _x21) {
                    return _uploadChunk.apply(this, arguments);
                }
                return uploadChunk;
            }()
        },
        {
            key: "createFileFromUpload",
            value: function createFileFromUpload(body) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var traceContext = arguments.length > 2 ? arguments[2] : undefined;
                var options = arguments.length > 3 ? arguments[3] : undefined;
                var metadata = {
                    method: 'POST',
                    endpoint: '/file/upload'
                };
                var headers = $a724ced935606131$var$_objectSpread({}, (0, $ex5xh.jsonHeaders));
                if ((options === null || options === void 0 ? void 0 : options.expectedFileSize) !== undefined && (0, $50U6m.fg)('platform_media_upload_expected_size_header')) headers['x-expected-size'] = options.expectedFileSize.toString();
                var requestOptions = $a724ced935606131$var$_objectSpread($a724ced935606131$var$_objectSpread({}, metadata), {}, {
                    authContext: {
                        collectionName: params.collection
                    },
                    params: params,
                    headers: headers,
                    body: JSON.stringify(body),
                    traceContext: traceContext
                });
                return this.request('/file/upload', requestOptions).then((0, $4eDLV.createMapResponseToJson)(metadata));
            }
        },
        {
            key: "getRejectedResponseFromDescriptor",
            value: function getRejectedResponseFromDescriptor(descriptor, limit) {
                return {
                    fileId: descriptor.fileId,
                    error: {
                        code: 'ExceedMaxFileSizeLimit',
                        title: 'The expected file size exceeded the maximum size limit.',
                        href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                        limit: limit,
                        size: descriptor.size
                    }
                };
            }
        },
        {
            key: "touchFiles",
            value: function() {
                var _touchFiles = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7(body) {
                    var params, traceContext, options, metadata, headers, requestOptions, _args7 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                params = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
                                traceContext = _args7.length > 2 ? _args7[2] : undefined;
                                options = _args7.length > 3 ? _args7[3] : undefined;
                                metadata = {
                                    method: 'POST',
                                    endpoint: '/upload/createWithFiles'
                                };
                                headers = $a724ced935606131$var$_objectSpread({}, (0, $ex5xh.jsonHeaders));
                                if ((options === null || options === void 0 ? void 0 : options.expectedFileSize) !== undefined && (0, $50U6m.fg)('platform_media_upload_expected_size_header')) headers['x-expected-size'] = options.expectedFileSize.toString();
                                requestOptions = $a724ced935606131$var$_objectSpread($a724ced935606131$var$_objectSpread({}, metadata), {}, {
                                    authContext: {
                                        collectionName: params.collection
                                    },
                                    headers: headers,
                                    body: JSON.stringify(body),
                                    traceContext: traceContext,
                                    params: {
                                        hashAlgorithm: this._chunkHashAlgorithm
                                    }
                                });
                                return _context7.abrupt("return", this.request('/upload/createWithFiles', requestOptions).then((0, $4eDLV.createMapResponseToJson)(metadata)));
                            case 1:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function touchFiles(_x22) {
                    return _touchFiles.apply(this, arguments);
                }
                return touchFiles;
            }()
        },
        {
            key: "getFile",
            value: function getFile(fileId) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var traceContext = arguments.length > 2 ? arguments[2] : undefined;
                var metadata = {
                    method: 'GET',
                    endpoint: '/file/{fileId}'
                };
                var options = $a724ced935606131$var$_objectSpread($a724ced935606131$var$_objectSpread({}, metadata), {}, {
                    authContext: {
                        collectionName: params.collection
                    },
                    params: params,
                    traceContext: traceContext
                });
                return this.request("/file/".concat(fileId), options).then((0, $4eDLV.createMapResponseToJson)(metadata));
            }
        },
        {
            key: "getFileImageURL",
            value: function() {
                var _getFileImageURL = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(id, params) {
                    var _ref5, collectionName, auth;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                _ref5 = params || {}, collectionName = _ref5.collection;
                                _context8.next = 1;
                                return this.resolveAuth({
                                    collectionName: collectionName
                                });
                            case 1:
                                auth = _context8.sent;
                                return _context8.abrupt("return", this.createFileImageURL(id, auth, params));
                            case 2:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this);
                }));
                function getFileImageURL(_x23, _x24) {
                    return _getFileImageURL.apply(this, arguments);
                }
                return getFileImageURL;
            }() // TODO Create ticket in case Trace Id can be supported through query params
        },
        {
            key: "getFileImageURLSync",
            value: function getFileImageURLSync(id, params, seededCdnUrl) {
                var auth = this.resolveInitialAuth();
                return this.createFileImageURL(id, auth, params, seededCdnUrl);
            }
        },
        {
            key: "createFileImageURL",
            value: function createFileImageURL(id, auth, params, seededCdnUrl) {
                var wmv = (0, $50U6m.fg)('confluence_watermark_admin_ui') ? (0, $c3qCW.getWatermarkVersionFromToken)(auth.token) : undefined;
                var options = {
                    params: $a724ced935606131$var$_objectSpread($a724ced935606131$var$_objectSpread({}, (0, $hr9fJ.extendImageParams)(params)), wmv ? {
                        wmv: wmv
                    } : {}),
                    auth: auth
                };
                var imageEndpoint = (0, $kXAOC.cdnFeatureFlag)('image');
                if (seededCdnUrl && (0, $kauwE.isCDNEnabled)()) return (0, $f5wck.mapToSeedBasedCdnUrl)(seededCdnUrl, options.params);
                if ((0, $53jt3.isPathBasedEnabled)()) return (0, $gq7UA.mapToPathBasedUrl)((0, $c7qys.createUrl)("".concat(auth.baseUrl, "/file/").concat(id, "/").concat(imageEndpoint), options));
                return (0, $eaGjU.mapToMediaCdnUrl)((0, $c7qys.createUrl)("".concat(auth.baseUrl, "/file/").concat(id, "/").concat(imageEndpoint), options), auth.token);
            }
        },
        {
            key: "getFileBinary",
            value: function() {
                var _getFileBinary = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(id, collectionName, abortController) {
                    var maxAge, headers, binaryEndpoint, metadata, options, _args9 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                maxAge = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : (0, $6wdjf.FILE_CACHE_MAX_AGE);
                                headers = {};
                                binaryEndpoint = (0, $kXAOC.cdnFeatureFlag)('binary');
                                metadata = {
                                    method: 'GET',
                                    endpoint: "/file/{fileId}/".concat(binaryEndpoint)
                                };
                                options = $a724ced935606131$var$_objectSpread($a724ced935606131$var$_objectSpread({}, metadata), {}, {
                                    authContext: {
                                        collectionName: collectionName
                                    },
                                    headers: headers,
                                    params: {
                                        collection: collectionName,
                                        'max-age': "".concat(maxAge)
                                    }
                                });
                                return _context9.abrupt("return", this.request("/file/".concat(id, "/").concat(binaryEndpoint), options, abortController, true).then((0, $50Quz.createMapResponseToBlob)(metadata)));
                            case 1:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this);
                }));
                function getFileBinary(_x25, _x26, _x27) {
                    return _getFileBinary.apply(this, arguments);
                }
                return getFileBinary;
            }()
        },
        {
            key: "getFileBinaryURL",
            value: function() {
                var _getFileBinaryURL = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(id, collectionName) {
                    var maxAge, name, auth, options, binaryEndpoint, _args0 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                maxAge = _args0.length > 2 && _args0[2] !== undefined ? _args0[2] : (0, $6wdjf.FILE_CACHE_MAX_AGE);
                                name = _args0.length > 3 ? _args0[3] : undefined;
                                _context0.next = 1;
                                return this.resolveAuth({
                                    collectionName: collectionName
                                });
                            case 1:
                                auth = _context0.sent;
                                options = {
                                    params: $a724ced935606131$var$_objectSpread({
                                        dl: true,
                                        collection: collectionName,
                                        'max-age': maxAge
                                    }, name && (0, $eW8Rv.expValEquals)('platform_editor_media_download_fallback_name', 'isEnabled', true) ? {
                                        name: name
                                    } : {}),
                                    auth: auth
                                };
                                binaryEndpoint = (0, $kXAOC.cdnFeatureFlag)('binary');
                                if (!(0, $53jt3.isPathBasedEnabled)()) {
                                    _context0.next = 2;
                                    break;
                                }
                                return _context0.abrupt("return", (0, $gq7UA.mapToPathBasedUrl)((0, $c7qys.createUrl)("".concat(auth.baseUrl, "/file/").concat(id, "/").concat(binaryEndpoint), options)));
                            case 2:
                                return _context0.abrupt("return", (0, $eaGjU.mapToMediaCdnUrl)((0, $c7qys.createUrl)("".concat(auth.baseUrl, "/file/").concat(id, "/").concat(binaryEndpoint), options), auth.token));
                            case 3:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this);
                }));
                function getFileBinaryURL(_x28, _x29) {
                    return _getFileBinaryURL.apply(this, arguments);
                }
                return getFileBinaryURL;
            }()
        },
        {
            key: "getArtifactURL",
            value: function() {
                var _getArtifactURL = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1(artifacts, artifactName, collectionName) {
                    var maxAge, artifactUrl, auth, options, url, _args1 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context1) {
                        while(true)switch(_context1.prev = _context1.next){
                            case 0:
                                maxAge = _args1.length > 3 && _args1[3] !== undefined ? _args1[3] : (0, $6wdjf.FILE_CACHE_MAX_AGE);
                                // ----- WARNING ----------
                                // DO NOT USE!!!!!
                                // artifact.cdnUrl fails in Jira.
                                // ----------------------------------
                                // getArtifactURL returns a constructed url PATH, not the full Media/CDN Url.
                                // We use the provided cdnUrl from metadata first.
                                /* if (isCommercial() && fg('platform_media_cdn_delivery')) {
              	const cdnUrl = artifacts[artifactName]?.cdnUrl;
              	if (cdnUrl) {
              		return cdnUrl;
              	}
              } */ artifactUrl = (0, $4w9gA.getArtifactUrl)(artifacts, artifactName);
                                if (artifactUrl) {
                                    _context1.next = 1;
                                    break;
                                }
                                throw new Error("artifact ".concat(artifactName, " not found"));
                            case 1:
                                _context1.next = 2;
                                return this.resolveAuth({
                                    collectionName: collectionName
                                });
                            case 2:
                                auth = _context1.sent;
                                options = {
                                    params: {
                                        collection: collectionName,
                                        'max-age': maxAge
                                    },
                                    auth: auth
                                };
                                url = (0, $eaGjU.mapToMediaCdnUrl)((0, $c7qys.createUrl)("".concat(auth.baseUrl).concat(artifactUrl), options), auth.token);
                                if (!(0, $53jt3.isPathBasedEnabled)()) {
                                    _context1.next = 3;
                                    break;
                                }
                                return _context1.abrupt("return", (0, $gq7UA.mapToPathBasedUrl)(url));
                            case 3:
                                return _context1.abrupt("return", url);
                            case 4:
                            case "end":
                                return _context1.stop();
                        }
                    }, _callee1, this);
                }));
                function getArtifactURL(_x30, _x31, _x32) {
                    return _getArtifactURL.apply(this, arguments);
                }
                return getArtifactURL;
            }()
        },
        {
            key: "getImage",
            value: function() {
                var _getImage = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10(id, params, controller, fetchMaxRes, traceContext) {
                    var isWebpSupported, headers, imageEndpoint, metadata, wmvParams, authOptions, auth, wmv, options;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                // TODO add checkWebpSupport() back https://product-fabric.atlassian.net/browse/MPT-584
                                isWebpSupported = false;
                                headers = {};
                                if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
                                imageEndpoint = (0, $kXAOC.cdnFeatureFlag)('image');
                                metadata = {
                                    method: 'GET',
                                    endpoint: "/file/{fileId}/".concat(imageEndpoint)
                                };
                                wmvParams = {};
                                authOptions = {
                                    authContext: {
                                        collectionName: params && params.collection
                                    }
                                };
                                if (!(0, $50U6m.fg)('confluence_watermark_admin_ui')) {
                                    _context10.next = 2;
                                    break;
                                }
                                _context10.next = 1;
                                return this.resolveAuth(authOptions.authContext);
                            case 1:
                                auth = _context10.sent;
                                wmv = (0, $c3qCW.getWatermarkVersionFromToken)(auth.token);
                                if (wmv) wmvParams = {
                                    wmv: wmv
                                };
                                authOptions = {
                                    resolvedAuth: auth
                                };
                            case 2:
                                options = $a724ced935606131$var$_objectSpread($a724ced935606131$var$_objectSpread($a724ced935606131$var$_objectSpread({}, metadata), authOptions), {}, {
                                    params: $a724ced935606131$var$_objectSpread($a724ced935606131$var$_objectSpread({}, (0, $hr9fJ.extendImageParams)(params, fetchMaxRes)), wmvParams),
                                    headers: headers,
                                    traceContext: traceContext,
                                    addMediaClientParam: true
                                });
                                return _context10.abrupt("return", this.request("/file/".concat(id, "/").concat(imageEndpoint), options, controller, true).then((0, $50Quz.createMapResponseToBlob)(metadata)));
                            case 3:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this);
                }));
                function getImage(_x33, _x34, _x35, _x36, _x37) {
                    return _getImage.apply(this, arguments);
                }
                return getImage;
            }()
        },
        {
            key: "getItems",
            value: function() {
                var _getItems = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(ids, collectionName, traceContext, includeHashForDuplicateFiles) {
                    var descriptors, metadata, options;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                descriptors = ids.map(function(id) {
                                    return {
                                        type: 'file',
                                        id: id,
                                        collection: collectionName
                                    };
                                });
                                metadata = {
                                    method: 'POST',
                                    endpoint: '/items'
                                };
                                options = $a724ced935606131$var$_objectSpread($a724ced935606131$var$_objectSpread({}, metadata), {}, {
                                    authContext: {
                                        collectionName: collectionName
                                    },
                                    headers: (0, $ex5xh.jsonHeaders),
                                    body: JSON.stringify({
                                        descriptors: descriptors,
                                        includeHashForDuplicateFiles: includeHashForDuplicateFiles
                                    }),
                                    traceContext: traceContext
                                });
                                return _context11.abrupt("return", this.request('/items', options).then((0, $4eDLV.createMapResponseToJson)(metadata)));
                            case 1:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this);
                }));
                function getItems(_x38, _x39, _x40, _x41) {
                    return _getItems.apply(this, arguments);
                }
                return getItems;
            }()
        },
        {
            key: "getImageMetadata",
            value: function() {
                var _getImageMetadata = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee12(id, params, traceContext) {
                    var metadata, options;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                metadata = {
                                    method: 'GET',
                                    endpoint: '/file/{fileId}/image/metadata'
                                };
                                options = $a724ced935606131$var$_objectSpread($a724ced935606131$var$_objectSpread({}, metadata), {}, {
                                    authContext: {
                                        collectionName: params && params.collection
                                    },
                                    params: params,
                                    traceContext: traceContext
                                });
                                return _context12.abrupt("return", this.request("/file/".concat(id, "/image/metadata"), options).then((0, $4eDLV.createMapResponseToJson)(metadata)));
                            case 1:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, this);
                }));
                function getImageMetadata(_x42, _x43, _x44) {
                    return _getImageMetadata.apply(this, arguments);
                }
                return getImageMetadata;
            }()
        },
        {
            key: "getDocumentContent",
            value: function() {
                var _getDocumentContent = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee13(id, options, traceContext) {
                    var shouldCache, endpoint, metadata, headers, requestOptions;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context13) {
                        while(true)switch(_context13.prev = _context13.next){
                            case 0:
                                // when requesting for password protected document don't use CDN as it won't forward headers
                                // this is deliberate to avoid caching Password protected files
                                // Note: this should be removed once endpoint implements server side Cache-Control headers
                                shouldCache = !options.password;
                                endpoint = shouldCache ? (0, $kXAOC.cdnFeatureFlag)('contents') : 'contents';
                                metadata = {
                                    method: 'GET',
                                    endpoint: "/file/{fileId}/document/".concat(endpoint)
                                };
                                headers = options.password ? {
                                    'x-document-authorization': "Basic ".concat(options.password)
                                } : {};
                                requestOptions = $a724ced935606131$var$_objectSpread($a724ced935606131$var$_objectSpread({}, metadata), {}, {
                                    authContext: {
                                        collectionName: options.collectionName
                                    },
                                    headers: headers,
                                    params: {
                                        collection: options.collectionName,
                                        pageStart: options.pageStart,
                                        pageEnd: options.pageEnd,
                                        'max-age': shouldCache ? (0, $6wdjf.FILE_CACHE_MAX_AGE) : 0
                                    },
                                    traceContext: traceContext
                                });
                                return _context13.abrupt("return", this.request("/file/".concat(id, "/document/").concat(endpoint), requestOptions).then((0, $4eDLV.createMapResponseToJson)(metadata)));
                            case 1:
                            case "end":
                                return _context13.stop();
                        }
                    }, _callee13, this);
                }));
                function getDocumentContent(_x45, _x46, _x47) {
                    return _getDocumentContent.apply(this, arguments);
                }
                return getDocumentContent;
            }()
        },
        {
            key: "getDocumentPageImage",
            value: function() {
                var _getDocumentPageImage = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee14(id, options, traceContext) {
                    var shouldCache, endpoint, metadata, headers, requestOptions;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context14) {
                        while(true)switch(_context14.prev = _context14.next){
                            case 0:
                                // when requesting for password protected document don't use CDN as it won't forward headers
                                // this is deliberate to avoid caching Password protected files
                                // Note: this should be removed once endpoint implements server side Cache-Control headers
                                shouldCache = !options.password;
                                endpoint = shouldCache ? (0, $kXAOC.cdnFeatureFlag)('page') : 'page';
                                metadata = {
                                    method: 'GET',
                                    endpoint: "/file/{fileId}/document/".concat(endpoint)
                                };
                                headers = options.password ? {
                                    'x-document-authorization': "Basic ".concat(options.password)
                                } : {};
                                requestOptions = $a724ced935606131$var$_objectSpread($a724ced935606131$var$_objectSpread({}, metadata), {}, {
                                    authContext: {
                                        collectionName: options.collectionName
                                    },
                                    headers: headers,
                                    params: {
                                        collection: options.collectionName,
                                        page: options.page,
                                        zoom: options.zoom,
                                        'max-age': shouldCache ? (0, $6wdjf.FILE_CACHE_MAX_AGE) : 0
                                    },
                                    traceContext: traceContext
                                });
                                return _context14.abrupt("return", this.request("/file/".concat(id, "/document/").concat(endpoint), requestOptions).then((0, $50Quz.createMapResponseToBlob)(metadata)));
                            case 1:
                            case "end":
                                return _context14.stop();
                        }
                    }, _callee14, this);
                }));
                function getDocumentPageImage(_x48, _x49, _x50) {
                    return _getDocumentPageImage.apply(this, arguments);
                }
                return getDocumentPageImage;
            }()
        },
        {
            key: "appendChunksToUpload",
            value: function() {
                var _appendChunksToUpload = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee15(uploadId, body, collectionName, traceContext, options) {
                    var metadata, headers, requestOptions;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context15) {
                        while(true)switch(_context15.prev = _context15.next){
                            case 0:
                                metadata = {
                                    method: 'PUT',
                                    endpoint: '/upload/{uploadId}/chunks'
                                };
                                headers = $a724ced935606131$var$_objectSpread({}, (0, $ex5xh.jsonHeaders));
                                if ((options === null || options === void 0 ? void 0 : options.expectedFileSize) !== undefined && (0, $50U6m.fg)('platform_media_upload_expected_size_header')) headers['x-expected-size'] = options.expectedFileSize.toString();
                                requestOptions = $a724ced935606131$var$_objectSpread($a724ced935606131$var$_objectSpread({}, metadata), {}, {
                                    authContext: {
                                        collectionName: collectionName
                                    },
                                    headers: headers,
                                    body: JSON.stringify(body),
                                    traceContext: traceContext
                                });
                                _context15.next = 1;
                                return this.request("/upload/".concat(uploadId, "/chunks"), requestOptions);
                            case 1:
                            case "end":
                                return _context15.stop();
                        }
                    }, _callee15, this);
                }));
                function appendChunksToUpload(_x51, _x52, _x53, _x54, _x55) {
                    return _appendChunksToUpload.apply(this, arguments);
                }
                return appendChunksToUpload;
            }()
        },
        {
            key: "copyFileWithToken",
            value: function copyFileWithToken(body, params, traceContext) {
                var metadata = {
                    method: 'POST',
                    endpoint: '/file/copy/withToken'
                };
                var options = $a724ced935606131$var$_objectSpread($a724ced935606131$var$_objectSpread({}, metadata), {}, {
                    authContext: {
                        collectionName: params.collection
                    },
                    // Contains collection name to write to
                    params: params,
                    // Contains collection name to write to
                    headers: (0, $ex5xh.jsonHeaders),
                    body: JSON.stringify(body),
                    // Contains collection name to read from
                    traceContext: traceContext
                });
                return this.request('/file/copy/withToken', options).then((0, $4eDLV.createMapResponseToJson)(metadata));
            }
        },
        {
            key: "copyFile",
            value: function copyFile(id, params, traceContext, clientId) {
                var metadata = {
                    method: 'POST',
                    endpoint: '/v2/file/copy'
                };
                var options = $a724ced935606131$var$_objectSpread($a724ced935606131$var$_objectSpread({}, metadata), {}, {
                    authContext: {
                        collectionName: params.collection
                    },
                    params: params,
                    headers: (0, $ex5xh.jsonHeaders),
                    body: JSON.stringify({
                        id: id,
                        clientId: clientId
                    }),
                    traceContext: traceContext,
                    clientOptions: {
                        retryOptions: {
                            shouldRetryError: function shouldRetryError(err) {
                                var _err$metadata;
                                return (0, $f84Q2.defaultShouldRetryError)(err) || (0, $5MquH.isRequestError)(err) && (err === null || err === void 0 || (_err$metadata = err.metadata) === null || _err$metadata === void 0 ? void 0 : _err$metadata.statusCode) === 401;
                            }
                        }
                    }
                });
                return this.request('/v2/file/copy', options).then((0, $4eDLV.createMapResponseToJson)(metadata));
            }
        },
        {
            key: "registerCopyIntents",
            value: function() {
                var _registerCopyIntents = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee16(files, traceContext, resolvedAuth) {
                    var metadata, options;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context16) {
                        while(true)switch(_context16.prev = _context16.next){
                            case 0:
                                metadata = {
                                    method: 'POST',
                                    endpoint: '/file/copy/intents'
                                };
                                options = $a724ced935606131$var$_objectSpread($a724ced935606131$var$_objectSpread({}, metadata), {}, {
                                    headers: (0, $ex5xh.jsonHeaders),
                                    body: JSON.stringify({
                                        files: files
                                    }),
                                    traceContext: traceContext,
                                    resolvedAuth: resolvedAuth
                                });
                                _context16.next = 1;
                                return this.request('/file/copy/intents', options);
                            case 1:
                            case "end":
                                return _context16.stop();
                        }
                    }, _callee16, this);
                }));
                function registerCopyIntents(_x56, _x57, _x58) {
                    return _registerCopyIntents.apply(this, arguments);
                }
                return registerCopyIntents;
            }()
        },
        {
            key: "request",
            value: function() {
                var _request2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee17(path) {
                    var options, controller, useMediaCdn, method, endpoint, authContext, params, headers, body, clientOptions, traceContext, addMediaClientParam, resolvedAuth, auth, clientId, extendedTraceContext, extendedParams, url, response, _args17 = arguments, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context17) {
                        while(true)switch(_context17.prev = _context17.next){
                            case 0:
                                options = _args17.length > 1 && _args17[1] !== undefined ? _args17[1] : {
                                    method: 'GET',
                                    endpoint: undefined,
                                    authContext: {}
                                };
                                controller = _args17.length > 2 ? _args17[2] : undefined;
                                useMediaCdn = _args17.length > 3 ? _args17[3] : undefined;
                                method = options.method, endpoint = options.endpoint, authContext = options.authContext, params = options.params, headers = options.headers, body = options.body, clientOptions = options.clientOptions, traceContext = options.traceContext, addMediaClientParam = options.addMediaClientParam, resolvedAuth = options.resolvedAuth;
                                if (!(resolvedAuth !== null && resolvedAuth !== void 0)) {
                                    _context17.next = 1;
                                    break;
                                }
                                _t = resolvedAuth;
                                _context17.next = 3;
                                break;
                            case 1:
                                _context17.next = 2;
                                return this.resolveAuth(authContext);
                            case 2:
                                _t = _context17.sent;
                            case 3:
                                auth = _t;
                                clientId = (0, $5VZM7.isClientBasedAuth)(auth) ? auth.clientId : undefined;
                                extendedTraceContext = (0, $7zJ8N.extendTraceContext)(traceContext);
                                extendedParams = addMediaClientParam ? $a724ced935606131$var$_objectSpread($a724ced935606131$var$_objectSpread({}, params), {}, {
                                    clientId: clientId
                                }) : params;
                                url = "".concat(auth.baseUrl).concat(path);
                                if (useMediaCdn) url = (0, $eaGjU.mapToMediaCdnUrl)(url, auth.token);
                                if ((0, $53jt3.isPathBasedEnabled)()) url = (0, $gq7UA.mapToPathBasedUrl)(url);
                                _context17.next = 4;
                                return (0, $6xzC8.request)(url, {
                                    method: method,
                                    endpoint: endpoint,
                                    auth: auth,
                                    params: extendedParams,
                                    headers: headers,
                                    body: body,
                                    clientOptions: clientOptions,
                                    traceContext: extendedTraceContext
                                }, controller);
                            case 4:
                                response = _context17.sent;
                                (0, $2mZxN.setKeyValueInSessionStorage)($a724ced935606131$export$ae7fb0ee64408016, response.headers.get('x-media-region'));
                                (0, $2mZxN.setKeyValueInSessionStorage)($a724ced935606131$export$2e3b0a8a2a2bf81c, response.headers.get('x-media-env'));
                                return _context17.abrupt("return", response);
                            case 5:
                            case "end":
                                return _context17.stop();
                        }
                    }, _callee17, this);
                }));
                function request(_x59) {
                    return _request2.apply(this, arguments);
                }
                return request;
            }()
        },
        {
            key: "testUrl",
            value: function() {
                var _testUrl = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee18(url) {
                    var options, traceContext, _args18 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context18) {
                        while(true)switch(_context18.prev = _context18.next){
                            case 0:
                                options = _args18.length > 1 && _args18[1] !== undefined ? _args18[1] : {};
                                traceContext = options.traceContext;
                                _context18.next = 1;
                                return (0, $6xzC8.request)(url, {
                                    method: 'HEAD',
                                    traceContext: (0, $7zJ8N.extendTraceContext)(traceContext),
                                    clientOptions: {
                                        retryOptions: {
                                            maxAttempts: 1
                                        }
                                    }
                                });
                            case 1:
                            case "end":
                                return _context18.stop();
                        }
                    }, _callee18);
                }));
                function testUrl(_x60) {
                    return _testUrl.apply(this, arguments);
                }
                return testUrl;
            }()
        },
        {
            key: "chunkHashAlgorithm",
            get: function get() {
                return this._chunkHashAlgorithm;
            }
        }
    ], [
        {
            key: "extractClientIdFromAuth",
            value: function extractClientIdFromAuth(auth) {
                if ((0, $5VZM7.isClientBasedAuth)(auth)) return auth.clientId;
                // decode JWT token and get clientId (or iss) from payload
                try {
                    var jwtPayload = (0, $h1dzo.decodeJwtToken)(auth.token);
                    return jwtPayload.clientId;
                } catch (_unused2) {
                // leave clientId as undefined
                }
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("5VZM7", function(module, exports) {
$parcel$export(module.exports, "isClientBasedAuth", () => $452231dbf953f636$export$6ba49fcac9c46e54);
function $452231dbf953f636$export$6ba49fcac9c46e54(auth) {
    return !!auth.clientId;
}

});

parcelRegister("4w9gA", function(module, exports) {
$parcel$export(module.exports, "getArtifactUrl", () => $34a156bee3378120$export$1cc24defa44e7f84);

var $kauwE = parcelRequire("kauwE");
var $34a156bee3378120$export$1cc24defa44e7f84 = function getArtifactUrl(artifacts, prop) {
    var _artifacts$prop, _artifacts$prop3;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $kauwE.isCDNEnabled)() && (_artifacts$prop = artifacts[prop]) !== null && _artifacts$prop !== void 0 && _artifacts$prop.url) {
        var _artifacts$prop2;
        return "".concat((_artifacts$prop2 = artifacts[prop]) === null || _artifacts$prop2 === void 0 ? void 0 : _artifacts$prop2.url, "/cdn");
    }
    return (_artifacts$prop3 = artifacts[prop]) === null || _artifacts$prop3 === void 0 ? void 0 : _artifacts$prop3.url;
};

});
parcelRegister("kauwE", function(module, exports) {
$parcel$export(module.exports, "isCDNEnabled", () => $eaec6b98cb471a0c$export$3e47d0e609e44278);

var $czJPn = parcelRequire("czJPn");

var $dhiPu = parcelRequire("dhiPu");

var $hB60R = parcelRequire("hB60R");

var $50U6m = parcelRequire("50U6m");

var $MxtEw = parcelRequire("MxtEw");

var $53jt3 = parcelRequire("53jt3");
function $eaec6b98cb471a0c$export$3e47d0e609e44278() {
    return (0, $MxtEw.isCommercial)() && !(0, $dhiPu.isIsolatedCloud)() && !((0, $czJPn.isGoogleCloudPlatform)() || (0, $hB60R.isGCPtenant)()) && (0, $50U6m.fg)('platform_media_cdn_delivery') && !(0, $53jt3.isPathBasedEnabled)();
}

});
parcelRegister("czJPn", function(module, exports) {
$parcel$export(module.exports, "isGoogleCloudPlatform", () => $927c4d5170c21eb0$export$d62bd105df52518a);

var $kALLn = parcelRequire("kALLn");

var $lMq2p = parcelRequire("lMq2p");
function $927c4d5170c21eb0$export$d62bd105df52518a() {
    if (typeof document === 'undefined') {
        var _globalThis$ssrContex, _globalThis$ssrContex2;
        // @ts-ignore
        return (_globalThis$ssrContex = (_globalThis$ssrContex2 = globalThis.ssrContext) === null || _globalThis$ssrContex2 === void 0 ? void 0 : _globalThis$ssrContex2.isInGCP) !== null && _globalThis$ssrContex !== void 0 ? _globalThis$ssrContex : false;
    }
    try {
        var cookies = globalThis.document.cookie;
        var cloudServiceProvider = (0, $lMq2p.getRawCookieValue)((0, $kALLn.BIFROST_ATL_CTX_CLOUD_SERVICE_PROVIDER), cookies);
        return cloudServiceProvider === (0, $kALLn.CLOUD_SERVICE_PROVIDER_GCP);
    } catch (e) {
        return false;
    }
}

});
parcelRegister("kALLn", function(module, exports) {
$parcel$export(module.exports, "COMMERCIAL", () => $efdc3833df78d242$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $efdc3833df78d242$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $efdc3833df78d242$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $efdc3833df78d242$export$a0ffa0598c95dfb7);
$parcel$export(module.exports, "BIFROST_ATL_CTX_CLOUD_SERVICE_PROVIDER", () => $efdc3833df78d242$export$74814ca8786924c3);
$parcel$export(module.exports, "CLOUD_SERVICE_PROVIDER_GCP", () => $efdc3833df78d242$export$b61e047ddcc35726);
var $efdc3833df78d242$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $efdc3833df78d242$export$f005e2e9f707cb5f = 'commercial';
var $efdc3833df78d242$export$17b81a3d6c98013c = 'isolated-cloud';
var $efdc3833df78d242$export$a739cd5aac835909 = 'staging';
var $efdc3833df78d242$export$42dd0cdd351a4a9 = 'prod';
var $efdc3833df78d242$export$404582bc18fe4d9e = 'dev';
var $efdc3833df78d242$export$87285944378c596 = 'Atl-Ctx-Perimeter';
var $efdc3833df78d242$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
var $efdc3833df78d242$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
var $efdc3833df78d242$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
var $efdc3833df78d242$export$b61e047ddcc35726 = 'GCP';
var $efdc3833df78d242$export$1baf17f3e645a2b2 = 'AWS';

});

parcelRegister("lMq2p", function(module, exports) {
$parcel$export(module.exports, "getRawCookieValue", () => $fdb247398b78491e$export$aa09aab30a92256c);

var $iYJcE = parcelRequire("iYJcE");
function $fdb247398b78491e$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $fdb247398b78491e$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $fdb247398b78491e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $fdb247398b78491e$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $fdb247398b78491e$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $fdb247398b78491e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $fdb247398b78491e$export$aa09aab30a92256c(cookieName, cookieString) {
    if (!cookieString) return undefined;
    var cookies = cookieString.split(';');
    var _iterator = $fdb247398b78491e$var$_createForOfIteratorHelper(cookies), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var cookie = _step.value;
            var _cookie$trim$split = cookie.trim().split('='), _cookie$trim$split2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_cookie$trim$split, 2), name = _cookie$trim$split2[0], value = _cookie$trim$split2[1];
            if (name === cookieName) return value;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return undefined;
}

});


parcelRegister("dhiPu", function(module, exports) {
$parcel$export(module.exports, "isIsolatedCloud", () => $9aab780fa6939d96$export$9186ccba8effc5de);

var $7gyAz = parcelRequire("7gyAz");

var $gWlDu = parcelRequire("gWlDu");
function $9aab780fa6939d96$export$9186ccba8effc5de() {
    if (typeof document === 'undefined') {
        var _globalThis$ssrContex, _globalThis$ssrContex2;
        // @ts-ignore
        return (_globalThis$ssrContex = (_globalThis$ssrContex2 = globalThis.ssrContext) === null || _globalThis$ssrContex2 === void 0 ? void 0 : _globalThis$ssrContex2.isInIC) !== null && _globalThis$ssrContex !== void 0 ? _globalThis$ssrContex : false;
    }
    var atlCtxCookieValues = (0, $gWlDu.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $7gyAz.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}

});
parcelRegister("7gyAz", function(module, exports) {
$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", () => $54a4dba59a329580$export$d8347b4aae768c2d);

var $kALLn = parcelRequire("kALLn");
var $54a4dba59a329580$export$d8347b4aae768c2d = [
    (0, $kALLn.COMMERCIAL)
];

});

parcelRegister("gWlDu", function(module, exports) {
$parcel$export(module.exports, "parseAtlCtxCookies", () => $c552d8936b9c7daa$export$3fa7b7af96286cc9);

var $kALLn = parcelRequire("kALLn");

var $lMq2p = parcelRequire("lMq2p");
function $c552d8936b9c7daa$export$3fa7b7af96286cc9() {
    var global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        var cookies = global.document.cookie;
        var perimeter = (0, $lMq2p.getRawCookieValue)((0, $kALLn.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        var icDomain = (0, $lMq2p.getRawCookieValue)((0, $kALLn.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        var icId = (0, $lMq2p.getRawCookieValue)((0, $kALLn.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        var emptyIcDomain = !icDomain || icDomain.length === 0;
        var emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});


parcelRegister("hB60R", function(module, exports) {
$parcel$export(module.exports, "isGCPtenant", () => $ccfa8e619f5b18fc$export$1e98abd71682b665);
/**
 * Returns true if the current hostname matches the GCP tenant pattern.
 * GCP tenants follow the pattern: <name>-cdp-<cdp-id>.jira-dev.com
 *
 * CDN (CloudFront) is an AWS service and is not available on GCP tenants.
 * This function is used to gate CDN delivery, mirroring the isIsolatedCloud() pattern.
 *
 * @deprecated This is a staging-only hostname heuristic and should not be used for
 * new code. Prefer `isGoogleCloudPlatform()` from `@atlaskit/atlassian-context/cloud-provider`
 * (cookie/SSR-based) to detect GCP tenants. This helper is retained only as a fallback for
 * staging tenants, which do not reliably have a proper value for the
 * `Bifrost-Atl-Ctx-Cloud-Service-Provider` cookie.
 *
 * @param hostname - Optional hostname override (defaults to globalThis.location?.hostname). Used for testing.
 */ function $ccfa8e619f5b18fc$export$1e98abd71682b665(hostname) {
    var _location;
    var host = hostname !== null && hostname !== void 0 ? hostname : typeof globalThis !== 'undefined' ? (_location = globalThis.location) === null || _location === void 0 ? void 0 : _location.hostname : undefined;
    if (!host) return false;
    var gcpTenantPattern = /^.*-cdp-\w+\.jira-dev\.com$/;
    return gcpTenantPattern.test(host);
}

});

parcelRegister("MxtEw", function(module, exports) {
$parcel$export(module.exports, "isCommercial", () => $091e73b294f92e6f$export$df69ff6733e73e50);
function $091e73b294f92e6f$export$df69ff6733e73e50() {
    var _global$location;
    var global = globalThis;
    var perimeter = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (perimeter) // Note: reference to MICROS_PERIMETER can be found in: https://hello.atlassian.net/wiki/spaces/MICROS/pages/167212650/Runtime+configuration+environment+variables+and+adding+secrets#Micros-provided-variables
    return perimeter === 'commercial';
    // Return true if the current hostname does NOT match any of the forbidden patterns.
    return !((_global$location = global.location) !== null && _global$location !== void 0 && (_global$location = _global$location.hostname) !== null && _global$location !== void 0 && _global$location.match(/(atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net))/));
}

});

parcelRegister("53jt3", function(module, exports) {
$parcel$export(module.exports, "isPathBasedEnabled", () => $3adc556c2882eb74$export$6de3392754e98e65);

var $50U6m = parcelRequire("50U6m");

var $aqJ20 = parcelRequire("aqJ20");
function $3adc556c2882eb74$export$6de3392754e98e65() {
    var _getDocument;
    var isLocalhost = ((_getDocument = (0, $aqJ20.default)()) === null || _getDocument === void 0 || (_getDocument = _getDocument.location) === null || _getDocument === void 0 ? void 0 : _getDocument.hostname) === 'localhost';
    return (0, $50U6m.fg)('platform_media_path_based_route') && !isLocalhost;
}

});
parcelRegister("aqJ20", function(module, exports) {
$parcel$export(module.exports, "default", () => $797f4363b99afb0c$export$2e2bcd8739ae039);
var $797f4363b99afb0c$export$2e2bcd8739ae039 = function() {
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});




parcelRegister("eaGjU", function(module, exports) {
$parcel$export(module.exports, "mapToMediaCdnUrl", () => $a512d3c322a95f67$export$fb88a576cf28364d);

var $czJPn = parcelRequire("czJPn");

var $hB60R = parcelRequire("hB60R");

var $50U6m = parcelRequire("50U6m");

var $kauwE = parcelRequire("kauwE");

var $uEr1o = parcelRequire("uEr1o");
function $a512d3c322a95f67$export$fb88a576cf28364d(url, token) {
    var _token$length;
    var tokenLength = (_token$length = token === null || token === void 0 ? void 0 : token.length) !== null && _token$length !== void 0 ? _token$length : 0;
    if (!(0, $kauwE.isCDNEnabled)() || tokenLength > (0, $uEr1o.MEDIA_TOKEN_LENGTH_LIMIT)) return url;
    var isGcpTenant = (0, $czJPn.isGoogleCloudPlatform)() || (0, $hB60R.isGCPtenant)();
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if (!isGcpTenant && (0, $50U6m.fg)('platform_media_cdn_delivery') && (0, $50U6m.fg)('platform_media_cdn_single_host')) try {
        var parsedUrl = new URL(url);
        var cdnHost = (0, $uEr1o.MEDIA_CDN_MAP)[parsedUrl.host];
        // If no mapping is found, return the original URL
        if (!cdnHost) return url;
        // Replace the host with the CDN host in the original URL
        parsedUrl.host = cdnHost;
        return parsedUrl.toString();
    } catch (error) {
        return url;
    }
    return url;
}

});
parcelRegister("uEr1o", function(module, exports) {
$parcel$export(module.exports, "MEDIA_CDN_MAP", () => $05c22af8b1e40206$export$8a9b6ab3569a543a);
$parcel$export(module.exports, "MEDIA_TOKEN_LENGTH_LIMIT", () => $05c22af8b1e40206$export$9c6324050210f959);

var $05c22af8b1e40206$export$8a9b6ab3569a543a = {
    'api.media.atlassian.com': 'media-cdn.atlassian.com',
    'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
};
var $05c22af8b1e40206$export$9c6324050210f959 = 7000;

});


parcelRegister("gq7UA", function(module, exports) {
$parcel$export(module.exports, "mapToPathBasedUrl", () => $bf45362ad6ee5900$export$774e2add1fbe26aa);

var $aqJ20 = parcelRequire("aqJ20");

var $53jt3 = parcelRequire("53jt3");

var $jpmHT = parcelRequire("jpmHT");
function $bf45362ad6ee5900$var$getRelativeUrl(absoluteUrl) {
    var url = new URL(absoluteUrl);
    return "".concat(url.pathname).concat(url.search).concat(url.hash);
}
function $bf45362ad6ee5900$export$774e2add1fbe26aa(url) {
    if ((0, $53jt3.isPathBasedEnabled)()) {
        var _getDocument;
        var parsedUrl = new URL(url);
        if (!parsedUrl.pathname.startsWith((0, $jpmHT.mediaApiPathPrefix))) parsedUrl.pathname = "".concat((0, $jpmHT.mediaApiPathPrefix)).concat(parsedUrl.pathname);
        var location = (_getDocument = (0, $aqJ20.default)()) === null || _getDocument === void 0 ? void 0 : _getDocument.location;
        // in this case we are most likely in SSR / a non browser environment so just return a relative URL
        if (!location) return $bf45362ad6ee5900$var$getRelativeUrl(parsedUrl.toString());
        parsedUrl.host = location.host;
        return parsedUrl.toString();
    }
    return url;
}

});
parcelRegister("jpmHT", function(module, exports) {
$parcel$export(module.exports, "mediaApiPathPrefix", () => $e211f742246c9e81$export$401b0a9ee44eb977);
var $e211f742246c9e81$export$401b0a9ee44eb977 = '/media-api';

});


parcelRegister("f5wck", function(module, exports) {
$parcel$export(module.exports, "mapToSeedBasedCdnUrl", () => $afc04c7df4b3081d$export$6a61eda13a74de3b);

var $iYJcE = parcelRequire("iYJcE");
var $afc04c7df4b3081d$var$IMAGE_PARAM_KEYS = new Set([
    'width',
    'height',
    'mode',
    'allowAnimated',
    'upscale',
    'version',
    'max-age'
]);
var $afc04c7df4b3081d$export$6a61eda13a74de3b = function mapToSeedBasedCdnUrl(seededCdnUrl, params) {
    var insert = Object.entries(params !== null && params !== void 0 ? params : {}).filter(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        return value != null && $afc04c7df4b3081d$var$IMAGE_PARAM_KEYS.has(key);
    }).map(function(_ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), key = _ref4[0], value = _ref4[1];
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(String(value)));
    }).join('&');
    if (!insert) return seededCdnUrl;
    var wm = seededCdnUrl.search(/[?&]wm-ari=/);
    if (wm !== -1) {
        var separator = seededCdnUrl[wm];
        return "".concat(seededCdnUrl.slice(0, wm)).concat(separator).concat(insert, "&").concat(seededCdnUrl.slice(wm + 1));
    }
    return "".concat(seededCdnUrl).concat(seededCdnUrl.includes('?') ? '&' : '?').concat(insert);
};

});

parcelRegister("6xzC8", function(module, exports) {
$parcel$export(module.exports, "request", () => $4c31735a412c8887$export$b5fe3f66a567bec0);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");


var $5MquH = parcelRequire("5MquH");



var $50U6m = parcelRequire("50U6m");

var $l1zIT = parcelRequire("l1zIT");

var $1W8ay = parcelRequire("1W8ay");

var $k1PDO = parcelRequire("k1PDO");

var $c7qys = parcelRequire("c7qys");

var $f84Q2 = parcelRequire("f84Q2");

var $cEBEp = parcelRequire("cEBEp");

var $5GbsT = parcelRequire("5GbsT");

var $eCc8i = parcelRequire("eCc8i");
function $4c31735a412c8887$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4c31735a412c8887$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4c31735a412c8887$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4c31735a412c8887$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4c31735a412c8887$export$b5fe3f66a567bec0(_x) {
    return $4c31735a412c8887$var$_request.apply(this, arguments);
}
function $4c31735a412c8887$var$_request() {
    $4c31735a412c8887$var$_request = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(url) {
        var options, controller, _options$method, method, endpoint, auth, params, headers, body, _options$clientOption, clientOptions, traceContext, retryOptions, metadata, doFetch, shouldRetryError, _getNavigator2, doFetchWithPathBasedUrl, _args = arguments, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                    controller = _args.length > 2 ? _args[2] : undefined;
                    _options$method = options.method, method = _options$method === void 0 ? 'GET' : _options$method, endpoint = options.endpoint, auth = options.auth, params = options.params, headers = options.headers, body = options.body, _options$clientOption = options.clientOptions, clientOptions = _options$clientOption === void 0 ? {} : _options$clientOption, traceContext = options.traceContext;
                    retryOptions = clientOptions.retryOptions;
                    metadata = {
                        method: method,
                        endpoint: endpoint,
                        traceContext: traceContext
                    }; // TODO BMPT-918: add client timeout feature behing a FF (using clientOptions.clientTimeout + Promise.race)
                    doFetch = function doFetch() {
                        return fetch((0, $c7qys.createUrl)(url, {
                            params: params
                        }), {
                            method: method,
                            body: body,
                            headers: (0, $cEBEp.extendHeaders)(headers, auth, traceContext),
                            signal: controller && controller.signal
                        }).then((0, $k1PDO.createProcessFetchResponse)(metadata));
                    };
                    if (!(0, $50U6m.fg)('platform_media_retry_edge_error')) {
                        _context.next = 5;
                        break;
                    }
                    shouldRetryError = function shouldRetryError(err) {
                        var _getNavigator;
                        if ((0, $eCc8i.isFetchNetworkError)(err) && (_getNavigator = (0, $l1zIT.default)()) !== null && _getNavigator !== void 0 && _getNavigator.userAgent.includes('Edg/')) return false;
                        return (0, $f84Q2.defaultShouldRetryError)(err);
                    };
                    _context.prev = 1;
                    _context.next = 2;
                    return (0, $5GbsT.fetchRetry)(doFetch, metadata, $4c31735a412c8887$var$_objectSpread($4c31735a412c8887$var$_objectSpread({}, retryOptions), {}, {
                        shouldRetryError: shouldRetryError
                    }));
                case 2:
                    return _context.abrupt("return", _context.sent);
                case 3:
                    _context.prev = 3;
                    _t = _context["catch"](1);
                    if (!((0, $eCc8i.isFetchNetworkError)(_t) && (_getNavigator2 = (0, $l1zIT.default)()) !== null && _getNavigator2 !== void 0 && _getNavigator2.userAgent.includes('Edg/'))) {
                        _context.next = 4;
                        break;
                    }
                    doFetchWithPathBasedUrl = function doFetchWithPathBasedUrl() {
                        return fetch((0, $c7qys.createUrl)((0, $1W8ay.mapRetryUrlToPathBasedUrl)(url).toString(), {
                            params: params
                        }), {
                            method: method,
                            body: body,
                            headers: (0, $cEBEp.extendHeaders)(headers, auth, traceContext),
                            signal: controller && controller.signal
                        }).then((0, $k1PDO.createProcessFetchResponse)(metadata));
                    };
                    return _context.abrupt("return", (0, $5GbsT.fetchRetry)(doFetchWithPathBasedUrl, metadata, retryOptions));
                case 4:
                    throw _t;
                case 5:
                    return _context.abrupt("return", (0, $5GbsT.fetchRetry)(doFetch, metadata, retryOptions));
                case 6:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                1,
                3
            ]
        ]);
    }));
    return $4c31735a412c8887$var$_request.apply(this, arguments);
}

});
parcelRegister("l1zIT", function(module, exports) {
$parcel$export(module.exports, "default", () => $03f32f13d679360f$export$2e2bcd8739ae039);
var $03f32f13d679360f$export$2e2bcd8739ae039 = function() {
    if (typeof window === 'undefined') return;
    if (typeof window.navigator === 'undefined') return;
    return window.navigator;
};

});

parcelRegister("1W8ay", function(module, exports) {
$parcel$export(module.exports, "mapRetryUrlToPathBasedUrl", () => $16918b7bbb9b9e25$export$e71b0af0000b3cfa);

var $aqJ20 = parcelRequire("aqJ20");

var $jpmHT = parcelRequire("jpmHT");
function $16918b7bbb9b9e25$export$e71b0af0000b3cfa(url) {
    var _getDocument$location, _getDocument;
    var parsedUrl = new URL(url);
    parsedUrl.host = (_getDocument$location = (_getDocument = (0, $aqJ20.default)()) === null || _getDocument === void 0 ? void 0 : _getDocument.location.host) !== null && _getDocument$location !== void 0 ? _getDocument$location : '';
    // remove CDN from the URL for retry if it exists
    var pathname = parsedUrl.pathname;
    if (pathname.endsWith('/cdn')) parsedUrl.pathname = pathname.replace('/cdn', '');
    if (!parsedUrl.pathname.startsWith((0, $jpmHT.mediaApiPathPrefix))) parsedUrl.pathname = "".concat((0, $jpmHT.mediaApiPathPrefix)).concat(parsedUrl.pathname);
    return parsedUrl;
}

});

parcelRegister("k1PDO", function(module, exports) {
$parcel$export(module.exports, "createProcessFetchResponse", () => $e94bf57f269f46c9$export$6e2e477edb7d6032);

var $8wyF8 = parcelRequire("8wyF8");
function $e94bf57f269f46c9$export$6e2e477edb7d6032(metadata) {
    return function(response) {
        if (response.ok || response.status < 400) return response;
        var requestError = (0, $8wyF8.createRequestErrorFromResponse)(metadata, response);
        throw requestError;
    };
}

});
parcelRegister("8wyF8", function(module, exports) {
$parcel$export(module.exports, "createRequestErrorFromResponse", () => $634c33205c58efa3$export$d171f49f6b4ddc33);

var $25nEq = parcelRequire("25nEq");

var $kJUnL = parcelRequire("kJUnL");

var $st6So = parcelRequire("st6So");

var $k7XwF = parcelRequire("k7XwF");
function $634c33205c58efa3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $634c33205c58efa3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $634c33205c58efa3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $634c33205c58efa3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $634c33205c58efa3$export$d171f49f6b4ddc33(metadata, response) {
    var statusCode = response.status;
    var reason = (0, $kJUnL.createRequestErrorReason)(statusCode);
    return new (0, $k7XwF.RequestError)(reason, $634c33205c58efa3$var$_objectSpread($634c33205c58efa3$var$_objectSpread($634c33205c58efa3$var$_objectSpread({}, metadata), (0, $st6So.extractMediaHeaders)(response)), {}, {
        statusCode: statusCode
    }));
}

});
parcelRegister("kJUnL", function(module, exports) {
$parcel$export(module.exports, "createRequestErrorReason", () => $f193bef39202c965$export$6397609af718d008);
function $f193bef39202c965$export$6397609af718d008(statusCode) {
    switch(statusCode){
        case 400:
            return 'serverBadRequest';
        case 401:
            return 'serverUnauthorized';
        case 403:
            return 'serverForbidden';
        case 404:
            return 'serverNotFound';
        case 422:
            return 'serverUnprocessableEntity';
        case 423:
            return 'serverEntityLocked';
        case 429:
            return 'serverRateLimited';
        case 500:
            return 'serverInternalError';
        case 502:
            return 'serverBadGateway';
        default:
            return 'serverUnexpectedError';
    }
}

});

parcelRegister("st6So", function(module, exports) {
$parcel$export(module.exports, "extractMediaHeaders", () => $05593242c612ee18$export$ea175c0c5497224);
function $05593242c612ee18$export$ea175c0c5497224(response) {
    var headers = response.headers;
    var mediaRegion = headers.get('x-media-region') || 'unknown';
    var mediaEnv = headers.get('x-media-env') || 'unknown';
    return {
        mediaRegion: mediaRegion,
        mediaEnv: mediaEnv
    };
}

});



parcelRegister("c7qys", function(module, exports) {
$parcel$export(module.exports, "createUrl", () => $8d2abcb4d1db495f$export$7138c24907de3954);

var $fC8ib = parcelRequire("fC8ib");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $e4TqZ = parcelRequire("e4TqZ");
function $8d2abcb4d1db495f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8d2abcb4d1db495f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8d2abcb4d1db495f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8d2abcb4d1db495f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8d2abcb4d1db495f$export$7138c24907de3954(url, _ref) {
    var params = _ref.params, auth = _ref.auth;
    var parsedUrl = new URL(url, auth === null || auth === void 0 ? void 0 : auth.baseUrl);
    var authParams = auth && (0, $e4TqZ.mapAuthToQueryParameters)(auth) || {};
    var paramsToAppend = $8d2abcb4d1db495f$var$_objectSpread($8d2abcb4d1db495f$var$_objectSpread({}, params), authParams);
    Object.entries(paramsToAppend).filter(function(_ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 2), _ = _ref3[0], value = _ref3[1];
        return value != null;
    }).forEach(function(pair) {
        var _parsedUrl$searchPara;
        (_parsedUrl$searchPara = parsedUrl.searchParams).set.apply(_parsedUrl$searchPara, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(pair));
    });
    parsedUrl.searchParams.sort();
    return parsedUrl.toString();
}

});
parcelRegister("e4TqZ", function(module, exports) {
$parcel$export(module.exports, "mapAuthToQueryParameters", () => $a3fc70830f29cc81$export$6833b130611df767);

var $5VZM7 = parcelRequire("5VZM7");
function $a3fc70830f29cc81$export$6833b130611df767(auth) {
    if ((0, $5VZM7.isClientBasedAuth)(auth)) return {
        client: auth.clientId,
        token: auth.token
    };
    else return {
        issuer: auth.asapIssuer,
        token: auth.token
    };
}

});


parcelRegister("cEBEp", function(module, exports) {
$parcel$export(module.exports, "extendHeaders", () => $93666d1a1de85840$export$18cfbabc415d771c);

var $25nEq = parcelRequire("25nEq");

var $5GXZG = parcelRequire("5GXZG");

var $2SvFj = parcelRequire("2SvFj");
function $93666d1a1de85840$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $93666d1a1de85840$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $93666d1a1de85840$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $93666d1a1de85840$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $93666d1a1de85840$var$mapTraceIdToRequestHeaders = function mapTraceIdToRequestHeaders(traceContext) {
    return traceContext ? (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $5GXZG.ZipkinHeaderKeys).traceId, traceContext.traceId), (0, $5GXZG.ZipkinHeaderKeys).spanId, traceContext.spanId) : {};
};
function $93666d1a1de85840$export$18cfbabc415d771c(headers, auth, traceContext) {
    if (!auth && !traceContext && !headers) return undefined;
    return $93666d1a1de85840$var$_objectSpread($93666d1a1de85840$var$_objectSpread($93666d1a1de85840$var$_objectSpread({}, headers !== null && headers !== void 0 ? headers : {}), (0, $2SvFj.mapAuthToRequestHeaders)(auth)), $93666d1a1de85840$var$mapTraceIdToRequestHeaders(traceContext));
}

});
parcelRegister("5GXZG", function(module, exports) {
$parcel$export(module.exports, "ZipkinHeaderKeys", () => $424f698b176cb0eb$export$922566b90d0535ce);
$parcel$export(module.exports, "DEFAULT_RETRY_OPTIONS", () => $424f698b176cb0eb$export$c65cfa70960d8fe5);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 

















var $424f698b176cb0eb$export$922566b90d0535ce = {
    traceId: 'x-b3-traceid',
    spanId: 'x-b3-spanid',
    parentSpanId: 'x-b3-parentspanid',
    sampled: 'x-b3-sampled',
    flags: 'x-b3-flags'
};
var $424f698b176cb0eb$export$c65cfa70960d8fe5 = {
    startTimeoutInMs: 1000,
    // 1 second is generally a good timeout to start
    maxAttempts: 5,
    // Current test delay is 60s, so retries should finish before if a promise takes < 1s
    factor: 2 // Good for polling, which is out main use case
};

});

parcelRegister("2SvFj", function(module, exports) {
$parcel$export(module.exports, "mapAuthToRequestHeaders", () => $21892ff77ceafe91$export$eaf4479116d2f925);

var $5VZM7 = parcelRequire("5VZM7");
function $21892ff77ceafe91$export$eaf4479116d2f925(auth) {
    if (!auth) return {};
    if ((0, $5VZM7.isClientBasedAuth)(auth)) return {
        'X-Client-Id': auth.clientId,
        Authorization: "Bearer ".concat(auth.token)
    };
    return {
        'X-Issuer': auth.asapIssuer,
        Authorization: "Bearer ".concat(auth.token)
    };
}

});


parcelRegister("5GbsT", function(module, exports) {
$parcel$export(module.exports, "fetchRetry", () => $4229c4b9993ee1b2$export$782df2acbe10b22c);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $lfHUO = parcelRequire("lfHUO");

var $f84Q2 = parcelRequire("f84Q2");

var $5GXZG = parcelRequire("5GXZG");

var $5I9LS = parcelRequire("5I9LS");

var $5MquH = parcelRequire("5MquH");

var $k7XwF = parcelRequire("k7XwF");

var $21I6z = parcelRequire("21I6z");
function $4229c4b9993ee1b2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4229c4b9993ee1b2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4229c4b9993ee1b2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4229c4b9993ee1b2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4229c4b9993ee1b2$export$782df2acbe10b22c(_x, _x2) {
    return $4229c4b9993ee1b2$var$_fetchRetry.apply(this, arguments);
}
function $4229c4b9993ee1b2$var$_fetchRetry() {
    $4229c4b9993ee1b2$var$_fetchRetry = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(functionToRetry, metadata) {
        var overwriteOptions, options, startTimeoutInMs, maxAttempts, factor, _options$shouldRetryE, shouldRetryError, attempts, timeoutInMs, lastError, waitAndBumpTimeout, _args2 = arguments, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    overwriteOptions = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
                    options = $4229c4b9993ee1b2$var$_objectSpread($4229c4b9993ee1b2$var$_objectSpread({}, (0, $5GXZG.DEFAULT_RETRY_OPTIONS)), overwriteOptions);
                    startTimeoutInMs = options.startTimeoutInMs, maxAttempts = options.maxAttempts, factor = options.factor, _options$shouldRetryE = options.shouldRetryError, shouldRetryError = _options$shouldRetryE === void 0 ? (0, $f84Q2.defaultShouldRetryError) : _options$shouldRetryE;
                    attempts = 0;
                    timeoutInMs = startTimeoutInMs;
                    waitAndBumpTimeout = /*#__PURE__*/ function() {
                        var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 1;
                                        return (0, $21I6z.waitPromise)(timeoutInMs);
                                    case 1:
                                        timeoutInMs *= factor;
                                        attempts += 1;
                                    case 2:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function waitAndBumpTimeout() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                case 1:
                    if (!(attempts < maxAttempts)) {
                        _context2.next = 8;
                        break;
                    }
                    _context2.prev = 2;
                    _context2.next = 3;
                    return functionToRetry();
                case 3:
                    return _context2.abrupt("return", _context2.sent);
                case 4:
                    _context2.prev = 4;
                    _t = _context2["catch"](2);
                    lastError = _t;
                    // don't retry if request was aborted by user
                    if (!(0, $5I9LS.isAbortedRequestError)(_t)) {
                        _context2.next = 5;
                        break;
                    }
                    throw new (0, $k7XwF.RequestError)('clientAbortedRequest', metadata, _t);
                case 5:
                    if (shouldRetryError(_t)) {
                        _context2.next = 6;
                        break;
                    }
                    throw _t;
                case 6:
                    _context2.next = 7;
                    return waitAndBumpTimeout();
                case 7:
                    _context2.next = 1;
                    break;
                case 8:
                    if (!(0, $5MquH.isRequestError)(lastError)) {
                        _context2.next = 9;
                        break;
                    }
                    throw (0, $lfHUO.cloneRequestError)(lastError, {
                        attempts: attempts,
                        clientExhaustedRetries: true
                    });
                case 9:
                    throw new (0, $k7XwF.RequestError)('serverUnexpectedError', $4229c4b9993ee1b2$var$_objectSpread($4229c4b9993ee1b2$var$_objectSpread({}, metadata), {}, {
                        attempts: attempts,
                        clientExhaustedRetries: true
                    }), lastError);
                case 10:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                2,
                4
            ]
        ]);
    }));
    return $4229c4b9993ee1b2$var$_fetchRetry.apply(this, arguments);
}

});
parcelRegister("lfHUO", function(module, exports) {
$parcel$export(module.exports, "cloneRequestError", () => $f78d1062203a11c2$export$359f19ca51f9eba1);

var $25nEq = parcelRequire("25nEq");

var $k7XwF = parcelRequire("k7XwF");
function $f78d1062203a11c2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f78d1062203a11c2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f78d1062203a11c2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f78d1062203a11c2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f78d1062203a11c2$export$359f19ca51f9eba1(error, extraMetadata) {
    var reason = error.reason, metadata = error.metadata, innerError = error.innerError;
    return new (0, $k7XwF.RequestError)(reason, $f78d1062203a11c2$var$_objectSpread($f78d1062203a11c2$var$_objectSpread({}, metadata), extraMetadata), innerError);
}

});

parcelRegister("5I9LS", function(module, exports) {
$parcel$export(module.exports, "isAbortedRequestError", () => $4288a42bb5ed4c5d$export$de0b576cf7ce4a53);
function $4288a42bb5ed4c5d$export$de0b576cf7ce4a53(err) {
    return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
}

});

parcelRegister("21I6z", function(module, exports) {
$parcel$export(module.exports, "waitPromise", () => $179de31f02673de5$export$80c51ea1e89203dd);
function $179de31f02673de5$export$80c51ea1e89203dd(timeout) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, timeout);
    });
}

});



parcelRegister("50Quz", function(module, exports) {
$parcel$export(module.exports, "createMapResponseToBlob", () => $3a65abb1498b693a$export$5cc7b0795397da86);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $st6So = parcelRequire("st6So");

var $k7XwF = parcelRequire("k7XwF");
function $3a65abb1498b693a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3a65abb1498b693a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3a65abb1498b693a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3a65abb1498b693a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3a65abb1498b693a$export$5cc7b0795397da86(metadata) {
    return /*#__PURE__*/ function() {
        var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(response) {
            var _t;
            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.prev = 0;
                        _context.next = 1;
                        return response.blob();
                    case 1:
                        return _context.abrupt("return", _context.sent);
                    case 2:
                        _context.prev = 2;
                        _t = _context["catch"](0);
                        throw new (0, $k7XwF.RequestError)('serverInvalidBody', $3a65abb1498b693a$var$_objectSpread($3a65abb1498b693a$var$_objectSpread($3a65abb1498b693a$var$_objectSpread({}, metadata), (0, $st6So.extractMediaHeaders)(response)), {}, {
                            statusCode: response.status
                        }), _t instanceof Error ? _t : undefined);
                    case 3:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    0,
                    2
                ]
            ]);
        }));
        return function(_x) {
            return _ref.apply(this, arguments);
        };
    }();
}

});

parcelRegister("4eDLV", function(module, exports) {
$parcel$export(module.exports, "createMapResponseToJson", () => $3157521df54962c2$export$e0519b126b73efa6);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $st6So = parcelRequire("st6So");

var $k7XwF = parcelRequire("k7XwF");
function $3157521df54962c2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3157521df54962c2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3157521df54962c2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3157521df54962c2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3157521df54962c2$export$e0519b126b73efa6(metadata) {
    return /*#__PURE__*/ function() {
        var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(response) {
            var _t;
            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.prev = 0;
                        _context.next = 1;
                        return response.json();
                    case 1:
                        return _context.abrupt("return", _context.sent);
                    case 2:
                        _context.prev = 2;
                        _t = _context["catch"](0);
                        throw new (0, $k7XwF.RequestError)('serverInvalidBody', $3157521df54962c2$var$_objectSpread($3157521df54962c2$var$_objectSpread($3157521df54962c2$var$_objectSpread({}, metadata), (0, $st6So.extractMediaHeaders)(response)), {}, {
                            statusCode: response.status
                        }), _t instanceof Error ? _t : undefined);
                    case 3:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    0,
                    2
                ]
            ]);
        }));
        return function(_x) {
            return _ref.apply(this, arguments);
        };
    }();
}

});

parcelRegister("7zJ8N", function(module, exports) {
$parcel$export(module.exports, "extendTraceContext", () => $583ed1546bb47f54$export$ee24a95986dfd173);

var $25nEq = parcelRequire("25nEq");

var $bVaC0 = parcelRequire("bVaC0");
function $583ed1546bb47f54$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $583ed1546bb47f54$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $583ed1546bb47f54$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $583ed1546bb47f54$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $583ed1546bb47f54$export$ee24a95986dfd173 = function extendTraceContext(traceContext) {
    return traceContext ? $583ed1546bb47f54$var$_objectSpread($583ed1546bb47f54$var$_objectSpread({}, traceContext), {}, {
        spanId: (traceContext === null || traceContext === void 0 ? void 0 : traceContext.spanId) || (0, $bVaC0.getRandomTelemetryId)()
    }) : undefined;
};

});

parcelRegister("c3qCW", function(module, exports) {
$parcel$export(module.exports, "getWatermarkVersionFromToken", () => $8c6a6b6e3ad7a126$export$5296269cf74e58e);
/**
 * Extracts the watermark version string from a JWT auth token.
 *
 * The token payload may contain a `watermark` field, which is a JSON-encoded
 * string like `{"v":"WjtFdA","ari":"ari:cloud:confluence:..."}`.
 *
 * Returns the `v` value if present, or `undefined` if the token has no
 * watermark or cannot be decoded.
 */ function $8c6a6b6e3ad7a126$export$5296269cf74e58e(token) {
    try {
        var parts = token.split('.');
        if (parts.length < 2) return undefined;
        var payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
        if (!payload.watermark) return undefined;
        var watermarkData = JSON.parse(payload.watermark);
        return watermarkData.v;
    } catch (_unused) {
        return undefined;
    }
}

});

parcelRegister("kXAOC", function(module, exports) {
$parcel$export(module.exports, "cdnFeatureFlag", () => $f425e016f448e394$export$fca9c48f5ff2eb1a);

var $kauwE = parcelRequire("kauwE");
var $f425e016f448e394$export$fca9c48f5ff2eb1a = function cdnFeatureFlag(endpoint) {
    var result = endpoint;
    if ((0, $kauwE.isCDNEnabled)()) result += '/cdn';
    return result;
};

});

parcelRegister("h1dzo", function(module, exports) {
$parcel$export(module.exports, "decodeJwtToken", () => $c63d0e60c8dc1040$export$a8b71bcb3b2f6325);
var $c63d0e60c8dc1040$export$a8b71bcb3b2f6325 = function decodeJwtToken(token) {
    return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
};

});

parcelRegister("hr9fJ", function(module, exports) {
$parcel$export(module.exports, "extendImageParams", () => $cb1c22adb71461cf$export$1f6f5681971a5e73);

var $25nEq = parcelRequire("25nEq");

var $6wdjf = parcelRequire("6wdjf");
function $cb1c22adb71461cf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cb1c22adb71461cf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cb1c22adb71461cf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cb1c22adb71461cf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cb1c22adb71461cf$export$1f6f5681971a5e73 = function extendImageParams(params) {
    var _params$maxAge, _params$allowAnimated, _params$mode;
    var fetchMaxRes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return $cb1c22adb71461cf$var$_objectSpread($cb1c22adb71461cf$var$_objectSpread({}, params), {}, {
        'max-age': (_params$maxAge = params === null || params === void 0 ? void 0 : params['max-age']) !== null && _params$maxAge !== void 0 ? _params$maxAge : (0, $6wdjf.FILE_CACHE_MAX_AGE),
        allowAnimated: (_params$allowAnimated = params === null || params === void 0 ? void 0 : params.allowAnimated) !== null && _params$allowAnimated !== void 0 ? _params$allowAnimated : true,
        mode: (_params$mode = params === null || params === void 0 ? void 0 : params.mode) !== null && _params$mode !== void 0 ? _params$mode : 'crop'
    }, fetchMaxRes ? {
        width: (0, $6wdjf.MAX_RESOLUTION),
        height: (0, $6wdjf.MAX_RESOLUTION)
    } : {});
};

});

parcelRegister("ex5xh", function(module, exports) {
$parcel$export(module.exports, "jsonHeaders", () => $a948710f7c9efeba$export$dd23d116120d45cc);
var $a948710f7c9efeba$export$dd23d116120d45cc = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};

});

parcelRegister("kjrF0", function(module, exports) {
$parcel$export(module.exports, "resolveAuth", () => $ec9b09c05506f9f2$export$4b4cec3dcdfce972);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $50U6m = parcelRequire("50U6m");

var $hP1cj = parcelRequire("hP1cj");

var $ioK23 = parcelRequire("ioK23");

var $a6KiR = parcelRequire("a6KiR");
var $ec9b09c05506f9f2$export$560085fe411c0660 = 10000;
var $ec9b09c05506f9f2$export$4b4cec3dcdfce972 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(authProvider, authContext) {
        var authProviderTimeout, startTime, eventEmitted, authProviderPromise, auth, _args = arguments, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    authProviderTimeout = _args.length > 2 && _args[2] !== undefined ? _args[2] : $ec9b09c05506f9f2$export$560085fe411c0660;
                    startTime = performance.now();
                    eventEmitted = false; // Feature flag: wrap authProvider with analytics event emission
                    authProviderPromise = (0, $50U6m.fg)('platform_media_auth_provider_analytics') ? authProvider(authContext).then(function(result) {
                        var durationMs = performance.now() - startTime;
                        if (!eventEmitted) {
                            eventEmitted = true;
                            (0, $hP1cj.globalMediaEventEmitter).emit('auth-provider-succeeded', {
                                durationMs: durationMs,
                                timeoutMs: authProviderTimeout,
                                authContext: authContext
                            });
                        } else {
                            // Timeout already fired - auth arrived too late
                            var timeoutError = new (0, $a6KiR.MediaStoreError)('authProviderTimedOut');
                            (0, $hP1cj.globalMediaEventEmitter).emit('auth-provider-failed', {
                                durationMs: durationMs,
                                timeoutMs: authProviderTimeout,
                                authContext: authContext,
                                error: timeoutError
                            });
                        }
                        return result;
                    }).catch(function(error) {
                        var durationMs = performance.now() - startTime;
                        eventEmitted = true;
                        (0, $hP1cj.globalMediaEventEmitter).emit('auth-provider-failed', {
                            durationMs: durationMs,
                            timeoutMs: authProviderTimeout,
                            authContext: authContext,
                            error: error
                        });
                        throw error;
                    }) : authProvider(authContext); // Original behavior when FG off
                    _context.prev = 1;
                    _context.next = 2;
                    return Promise.race([
                        authProviderPromise,
                        (0, $ioK23.rejectTimeout)(authProviderTimeout, new (0, $a6KiR.MediaStoreError)('authProviderTimedOut'))
                    ]);
                case 2:
                    auth = _context.sent;
                    _context.next = 5;
                    break;
                case 3:
                    _context.prev = 3;
                    _t = _context["catch"](1);
                    // Mark as emitted so late arrivals are handled correctly by .then()/.catch()
                    if (!eventEmitted && (0, $50U6m.fg)('platform_media_auth_provider_analytics')) eventEmitted = true;
                    // PRESERVE ORIGINAL ERROR HANDLING
                    if (!(_t instanceof (0, $a6KiR.MediaStoreError))) {
                        _context.next = 4;
                        break;
                    }
                    throw _t;
                case 4:
                    throw new (0, $a6KiR.MediaStoreError)('failedAuthProvider', _t instanceof Error ? _t : undefined);
                case 5:
                    if (auth) {
                        _context.next = 6;
                        break;
                    }
                    throw new (0, $a6KiR.MediaStoreError)('emptyAuth');
                case 6:
                    if (!('clientId' in auth && !auth.clientId && (0, $50U6m.fg)('platform_media_validate_client_id'))) {
                        _context.next = 7;
                        break;
                    }
                    throw new (0, $a6KiR.MediaStoreError)('emptyClientId');
                case 7:
                    return _context.abrupt("return", auth);
                case 8:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                1,
                3
            ]
        ]);
    }));
    return function resolveAuth(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("ioK23", function(module, exports) {
$parcel$export(module.exports, "rejectTimeout", () => $d64e2ced7d4a1b55$export$cf2d2a1124beacb2);
var $d64e2ced7d4a1b55$export$cf2d2a1124beacb2 = function rejectTimeout(timeout, rejectWith) {
    return new Promise(function(_resolve, reject) {
        setTimeout(reject, timeout, rejectWith);
    });
};

});

parcelRegister("a6KiR", function(module, exports) {
$parcel$export(module.exports, "MediaStoreError", () => $75be61c51262124a$export$b78480bd311630bc);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $ij82I = parcelRequire("ij82I");
function $75be61c51262124a$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $75be61c51262124a$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $75be61c51262124a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($75be61c51262124a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $75be61c51262124a$export$b78480bd311630bc = /*#__PURE__*/ function(_BaseMediaClientError) {
    function MediaStoreError(reason, innerError) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, MediaStoreError);
        return $75be61c51262124a$var$_callSuper(this, MediaStoreError, [
            reason,
            undefined,
            innerError
        ]);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(MediaStoreError, _BaseMediaClientError);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(MediaStoreError, [
        {
            key: "attributes",
            get: function get() {
                var reason = this.reason, innerError = this.innerError;
                return {
                    reason: reason,
                    innerError: innerError
                };
            }
        }
    ]);
}((0, $ij82I.BaseMediaClientError));

});


parcelRegister("5Q9tE", function(module, exports) {
$parcel$export(module.exports, "resolveInitialAuth", () => $4409290c4ba88625$export$5211e1371264aec3);

var $a6KiR = parcelRequire("a6KiR");
var $4409290c4ba88625$export$5211e1371264aec3 = function resolveInitialAuth(auth) {
    if (!auth) throw new (0, $a6KiR.MediaStoreError)('missingInitialAuth');
    return auth;
};

});

parcelRegister("2mZxN", function(module, exports) {
$parcel$export(module.exports, "setKeyValueInSessionStorage", () => $1b9d603d79ea3c63$export$be4c63de2c8c945);
var $1b9d603d79ea3c63$export$be4c63de2c8c945 = function setKeyValueInSessionStorage(key, value) {
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    if (!value || !(window && window.sessionStorage)) return;
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    var currentValue = window.sessionStorage.getItem(key);
    if (currentValue !== value) // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    window.sessionStorage.setItem(key, value);
};

});


parcelRegister("gjcf9", function(module, exports) {
$parcel$export(module.exports, "FileFetcherError", () => $bdf7eaf3b7af99ff$export$e3e60f0dab8641de);

var $25nEq = parcelRequire("25nEq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $ij82I = parcelRequire("ij82I");
function $bdf7eaf3b7af99ff$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bdf7eaf3b7af99ff$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bdf7eaf3b7af99ff$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bdf7eaf3b7af99ff$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $bdf7eaf3b7af99ff$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $bdf7eaf3b7af99ff$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $bdf7eaf3b7af99ff$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($bdf7eaf3b7af99ff$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $bdf7eaf3b7af99ff$export$e3e60f0dab8641de = /*#__PURE__*/ function(_BaseMediaClientError) {
    // Legacy Attribute. Should be removed
    function FileFetcherError(reason, metadata) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FileFetcherError);
        _this = $bdf7eaf3b7af99ff$var$_callSuper(this, FileFetcherError, [
            reason,
            metadata,
            undefined
        ]);
        _this.id = metadata.id;
        return _this;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(FileFetcherError, _BaseMediaClientError);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FileFetcherError, [
        {
            key: "attributes",
            get: function get() {
                var reason = this.reason, _this$metadata = this.metadata, id = _this$metadata.id, collectionName = _this$metadata.collectionName, occurrenceKey = _this$metadata.occurrenceKey, traceContext = _this$metadata.traceContext;
                return $bdf7eaf3b7af99ff$var$_objectSpread({
                    reason: reason,
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey
                }, traceContext && {
                    metadata: {
                        traceContext: traceContext
                    }
                });
            }
        }
    ]);
}((0, $ij82I.BaseMediaClientError));

});


parcelRegister("c0iRm", function(module, exports) {
$parcel$export(module.exports, "StargateClient", () => $8bd41d3de9c9f58d$export$c66ca190f89caaac);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");
var $8bd41d3de9c9f58d$export$c66ca190f89caaac = /*#__PURE__*/ function() {
    function StargateClient(baseUrl) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, StargateClient);
        this.baseUrl = baseUrl || '/gateway/api';
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(StargateClient, [
        {
            key: "fetchToken",
            value: function() {
                var _fetchToken = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(clientId) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 1;
                                return fetch("".concat(this.baseUrl, "/media/auth/smartedge"), {
                                    credentials: 'include',
                                    headers: {
                                        'x-client-id': clientId
                                    }
                                });
                            case 1:
                                return _context.abrupt("return", _context.sent.json());
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function fetchToken(_x) {
                    return _fetchToken.apply(this, arguments);
                }
                return fetchToken;
            }()
        },
        {
            key: "isTokenExpired",
            value: function isTokenExpired(token) {
                var currentTimeInSeconds = new Date().getTime() / 1000;
                return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
            }
        }
    ]);
}();

});

parcelRegister("2k2gx", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("dZRKf"),
    $iKwew("a5UyZ")
]).then(()=>parcelRequire('lAreV'));

});



parcelRegister("3cF57", function(module, exports) {
$parcel$export(module.exports, "MediaClientContext", () => $25525c0bf34b7183$export$ba5d7212f2b4619f);

var $5FkrB = parcelRequire("5FkrB");

var $lknPo = parcelRequire("lknPo");
var $25525c0bf34b7183$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext(undefined);
var $25525c0bf34b7183$export$5bff351c86f56d97 = function MediaClientProvider(_ref) {
    var children = _ref.children, clientConfig = _ref.clientConfig;
    var mediaClient = (0, $5FkrB.useMemo)(function() {
        return (0, $lknPo.getMediaClient)(clientConfig);
    }, [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($25525c0bf34b7183$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient
    }, children);
};

});

parcelRegister("lVo0h", function(module, exports) {
$parcel$export(module.exports, "ActiveHeaderIdProvider", () => $ff618a72c80bcd34$export$20439b49fdd0d26c);
$parcel$export(module.exports, "ActiveHeaderIdConsumer", () => $ff618a72c80bcd34$export$cddc3c6ebe2d2cec);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
var $ff618a72c80bcd34$var$dest = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext(undefined);
var $ff618a72c80bcd34$export$20439b49fdd0d26c = $ff618a72c80bcd34$var$dest.Provider;
var $ff618a72c80bcd34$var$Consumer = $ff618a72c80bcd34$var$dest.Consumer;
/**
 * We need to expose this abstraction on top of the native Consumer in order to control when
 * The consumer will get notified when a match has happened. If we use the Consumer directly in
 * Expand components without this inner state, everytime a new prop comes in, and the `newActiveHeaderId`
 * is the same as before, we will set the expand to true forever, until the active header id changes.
 * Thus, the user won't be able to collapse the expand.
 *
 * By exposing `onNestedHeaderIdMatch` here we can control when will consumers be notified:
 * only when a `newActiveHeaderId` comes in from the Provider and the list of header ids includes it.
 */ var $ff618a72c80bcd34$export$cddc3c6ebe2d2cec = function ActiveHeaderIdConsumer(_ref) {
    var nestedHeaderIds = _ref.nestedHeaderIds, onNestedHeaderIdMatch = _ref.onNestedHeaderIdMatch;
    var _useState = (0, $5FkrB.useState)(), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), activeHeaderId = _useState2[0], setActiveHeaderId = _useState2[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($ff618a72c80bcd34$var$Consumer, null, function(newActiveHeaderId) {
        if (!newActiveHeaderId || !nestedHeaderIds.includes(newActiveHeaderId)) setActiveHeaderId(undefined);
        else if (newActiveHeaderId !== activeHeaderId && nestedHeaderIds.includes(newActiveHeaderId)) {
            setActiveHeaderId(newActiveHeaderId);
            onNestedHeaderIdMatch();
        }
        return null;
    });
};

});

parcelRegister("a4VNM", function(module, exports) {
$parcel$export(module.exports, "fileCardImageViewSelector", () => $75671d5fe47f5d71$export$7a6526d4be3b7eb3);
var $75671d5fe47f5d71$export$7a6526d4be3b7eb3 = 'media-file-card-view';
var $75671d5fe47f5d71$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';

});

parcelRegister("eTqtO", function(module, exports) {
$parcel$export(module.exports, "mediaViewerPopupClass", () => $ad7abe14c5c27837$export$42c8d07e41ed1e74);
/**
 * Classname for the media viewer popup that appears adjacent to the editor div. Use this to check
 * if the media viewer has appeared.
 */ var $ad7abe14c5c27837$export$42c8d07e41ed1e74 = 'media-viewer-popup';

});

parcelRegister("aOpeL", function(module, exports) {
$parcel$export(module.exports, "PortalContext", () => $7df22672e154e506$export$60d741e20e0aa309);
$parcel$export(module.exports, "usePortal", () => $7df22672e154e506$export$b1072f43c67b540c);
/* eslint-disable jsdoc/require-jsdoc -- thin portal context helpers */ 
var $5FkrB = parcelRequire("5FkrB");
var $7df22672e154e506$export$60d741e20e0aa309 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext(undefined);
function $7df22672e154e506$export$b1072f43c67b540c(props) {
    var portalFromContext = (0, $5FkrB.useContext)($7df22672e154e506$export$60d741e20e0aa309);
    return (props === null || props === void 0 ? void 0 : props.portal) || portalFromContext;
}

});

parcelRegister("9DPK6", function(module, exports) {
$parcel$export(module.exports, "customCategory", () => $704fe49252f7647d$export$5e4e3d1c3e43156a);
$parcel$export(module.exports, "frequentCategory", () => $704fe49252f7647d$export$78ccdc4be403c468);
$parcel$export(module.exports, "dataURLPrefix", () => $704fe49252f7647d$export$8ac325bfd32359b0);
$parcel$export(module.exports, "deleteEmojiLabel", () => $704fe49252f7647d$export$a330961542edfe6f);
$parcel$export(module.exports, "MAX_ORDINAL", () => $704fe49252f7647d$export$1a817f1886276c6d);
$parcel$export(module.exports, "scaledEmojiHeightH1", () => $704fe49252f7647d$export$2e7088017339c92);
$parcel$export(module.exports, "scaledEmojiHeightH2", () => $704fe49252f7647d$export$4cb591b57c224c0);
$parcel$export(module.exports, "scaledEmojiHeightH3", () => $704fe49252f7647d$export$b31a41e904161dc1);
$parcel$export(module.exports, "scaledEmojiHeightH4", () => $704fe49252f7647d$export$7dd039b460c61389);
$parcel$export(module.exports, "denseEmojiHeightH1", () => $704fe49252f7647d$export$96ee6614460413a0);
$parcel$export(module.exports, "denseEmojiHeightH2", () => $704fe49252f7647d$export$103771a4cd74af90);
$parcel$export(module.exports, "denseEmojiHeightH3", () => $704fe49252f7647d$export$5cc2afcf38309ce9);
$parcel$export(module.exports, "denseEmojiHeightH4", () => $704fe49252f7647d$export$9a9984214a4bd724);
$parcel$export(module.exports, "defaultEmojiHeight", () => $704fe49252f7647d$export$3f99ac31dc0406db);
$parcel$export(module.exports, "defaultDenseEmojiHeight", () => $704fe49252f7647d$export$8efb414216030943);
$parcel$export(module.exports, "defaultInlineEmojiHeight", () => $704fe49252f7647d$export$4adebc94e462aea5);
$parcel$export(module.exports, "localStoragePrefix", () => $704fe49252f7647d$export$e394a0c530ae5631);
$parcel$export(module.exports, "selectedToneStorageKey", () => $704fe49252f7647d$export$79ee4ef84c545f8f);
$parcel$export(module.exports, "defaultCategories", () => $704fe49252f7647d$export$d7ab74456f1aa1ad);
$parcel$export(module.exports, "KeyboardKeys", () => $704fe49252f7647d$export$70f9e5bc10d7eac);
$parcel$export(module.exports, "EMOJI_KEYBOARD_KEYS_SUPPORTED", () => $704fe49252f7647d$export$84b035f8d01101cc);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RENDERED_EXP", () => $704fe49252f7647d$export$83aab2ae64548423);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP", () => $704fe49252f7647d$export$66cabad5e268b05e);
var $704fe49252f7647d$export$5e4e3d1c3e43156a = 'CUSTOM';
var $704fe49252f7647d$export$78ccdc4be403c468 = 'FREQUENT';
var $704fe49252f7647d$export$2c4b04c3aacdf1b3 = 'SITE';
var $704fe49252f7647d$export$1b0258512be88334 = 'SEARCH';
var $704fe49252f7647d$export$42b510423367f354 = 'USER_CUSTOM';
var $704fe49252f7647d$export$5d0f2d8ee50f86f5 = 'allUploadsCustomCategory';
var $704fe49252f7647d$export$1debc2f10cc69389 = 'userUploadsCustomCategory';
var $704fe49252f7647d$export$8ac325bfd32359b0 = 'data:';
var $704fe49252f7647d$export$a330961542edfe6f = 'delete-emoji';
var $704fe49252f7647d$export$1a817f1886276c6d = 100000;
var $704fe49252f7647d$export$2e7088017339c92 = 28;
var $704fe49252f7647d$export$4cb591b57c224c0 = 26;
var $704fe49252f7647d$export$b31a41e904161dc1 = 24;
var $704fe49252f7647d$export$7dd039b460c61389 = 22;
var $704fe49252f7647d$export$96ee6614460413a0 = 24.25;
var $704fe49252f7647d$export$103771a4cd74af90 = 22.25;
var $704fe49252f7647d$export$5cc2afcf38309ce9 = 20.25;
var $704fe49252f7647d$export$9a9984214a4bd724 = 18.25;
var $704fe49252f7647d$export$3f99ac31dc0406db = 20;
var $704fe49252f7647d$export$8efb414216030943 = 16.25;
var $704fe49252f7647d$export$4adebc94e462aea5 = 16;
var $704fe49252f7647d$export$d171dc12fee2b1da = 350;
var $704fe49252f7647d$export$c10ac8125a260041 = 80;
var $704fe49252f7647d$export$5248fb9e0cccc41f = 'medium';
var $704fe49252f7647d$export$94f75d625e7801d3 = 260;
var $704fe49252f7647d$export$7ed599d166d65aea = 295;
var $704fe49252f7647d$export$7722b8e9522021df = $704fe49252f7647d$export$7ed599d166d65aea - 58; // picker height - actions height
var $704fe49252f7647d$export$9f36457335d8859f = $704fe49252f7647d$export$7ed599d166d65aea - 102; // picker height - actions height - preview height
var $704fe49252f7647d$export$e218e5cb105a0e22 = 54;
var $704fe49252f7647d$export$e67f617938b111f1 = $704fe49252f7647d$export$7ed599d166d65aea + $704fe49252f7647d$export$e218e5cb105a0e22;
var $704fe49252f7647d$export$e394a0c530ae5631 = 'fabric.emoji';
var $704fe49252f7647d$export$79ee4ef84c545f8f = "".concat($704fe49252f7647d$export$e394a0c530ae5631, ".selectedTone");
var $704fe49252f7647d$export$ec5e3f6f684720d7 = "".concat($704fe49252f7647d$export$e394a0c530ae5631, ".selectedProductivityColor");
var $704fe49252f7647d$export$d7ab74456f1aa1ad = [
    'PEOPLE',
    'NATURE',
    'FOODS',
    'ACTIVITY',
    'PLACES',
    'OBJECTS',
    'SYMBOLS',
    'FLAGS'
];
var $704fe49252f7647d$export$70f9e5bc10d7eac = /*#__PURE__*/ function(KeyboardKeys) {
    KeyboardKeys["ArrowLeft"] = "ArrowLeft";
    KeyboardKeys["ArrowRight"] = "ArrowRight";
    KeyboardKeys["ArrowUp"] = "ArrowUp";
    KeyboardKeys["ArrowDown"] = "ArrowDown";
    KeyboardKeys["PageUp"] = "PageUp";
    KeyboardKeys["PageDown"] = "PageDown";
    KeyboardKeys["Home"] = "Home";
    KeyboardKeys["End"] = "End";
    KeyboardKeys["Enter"] = "Enter";
    KeyboardKeys["Tab"] = "Tab";
    KeyboardKeys["Space"] = " ";
    KeyboardKeys["Backspace"] = "Backspace";
    return KeyboardKeys;
}({});
var $704fe49252f7647d$export$1c4f2adc1f8e19d3 = /*#__PURE__*/ function(KeyboardNavigationDirection) {
    KeyboardNavigationDirection["Down"] = "Down";
    KeyboardNavigationDirection["Up"] = "Up";
    KeyboardNavigationDirection["Left"] = "Left";
    KeyboardNavigationDirection["Right"] = "Right";
    return KeyboardNavigationDirection;
}({});
var $704fe49252f7647d$export$99130b698ea188ae = [
    $704fe49252f7647d$export$70f9e5bc10d7eac.ArrowRight,
    $704fe49252f7647d$export$70f9e5bc10d7eac.ArrowLeft,
    $704fe49252f7647d$export$70f9e5bc10d7eac.Home,
    $704fe49252f7647d$export$70f9e5bc10d7eac.End
];
var $704fe49252f7647d$export$84b035f8d01101cc = [
    $704fe49252f7647d$export$70f9e5bc10d7eac.Enter,
    $704fe49252f7647d$export$70f9e5bc10d7eac.Backspace,
    $704fe49252f7647d$export$70f9e5bc10d7eac.Space
];
var $704fe49252f7647d$export$e27d4e477c0cd4ec = [
    $704fe49252f7647d$export$70f9e5bc10d7eac.Enter,
    $704fe49252f7647d$export$70f9e5bc10d7eac.Tab,
    $704fe49252f7647d$export$70f9e5bc10d7eac.Space
];
var $704fe49252f7647d$export$97027974dc06eeee = [
    $704fe49252f7647d$export$70f9e5bc10d7eac.ArrowRight,
    $704fe49252f7647d$export$70f9e5bc10d7eac.ArrowLeft,
    $704fe49252f7647d$export$70f9e5bc10d7eac.Home,
    $704fe49252f7647d$export$70f9e5bc10d7eac.End,
    $704fe49252f7647d$export$70f9e5bc10d7eac.ArrowUp,
    $704fe49252f7647d$export$70f9e5bc10d7eac.ArrowDown,
    $704fe49252f7647d$export$70f9e5bc10d7eac.PageUp,
    $704fe49252f7647d$export$70f9e5bc10d7eac.PageDown
];
var $704fe49252f7647d$export$4f0ee90b28d6efc5 = 0;
var $704fe49252f7647d$export$9f7de4293d27f3aa = 50;
var $704fe49252f7647d$export$41388d9a435030e6 = 'hipchat_migration_emoticons';
var $704fe49252f7647d$export$273d18db3ba5f6b1 = 'atlassian.fabric.emoji.picker';
var $704fe49252f7647d$export$2829f3ec323f8ec0 = 8;
var $704fe49252f7647d$export$ce3a0e7d2d7d6ba2 = 5;
var $704fe49252f7647d$export$858e8dc100a97278 = 150;
var $704fe49252f7647d$export$83aab2ae64548423 = 20;
var $704fe49252f7647d$export$66cabad5e268b05e = 100;

});

parcelRegister("8Upo7", function(module, exports) {
$parcel$export(module.exports, "commonSelectedStyles", () => $67c73f3f32c78692$export$8633a0edef8e95dd);
$parcel$export(module.exports, "selectOnHoverStyles", () => $67c73f3f32c78692$export$860109dfd198259b);
$parcel$export(module.exports, "emojiSprite", () => $67c73f3f32c78692$export$1c10634420a08d8a);
$parcel$export(module.exports, "emojiNodeStyles", () => $67c73f3f32c78692$export$b06c4aab1d012063);
$parcel$export(module.exports, "emojiImage", () => $67c73f3f32c78692$export$da61cef1c8919f7c);
$parcel$export(module.exports, "emojiDeleteButton", () => $67c73f3f32c78692$export$b11fa39b56a371f6);
$parcel$export(module.exports, "emojiMainStyle", () => $67c73f3f32c78692$export$11462c0756c24ab6);
$parcel$export(module.exports, "deletableEmoji", () => $67c73f3f32c78692$export$22b19c311e9caa4);
$parcel$export(module.exports, "placeholder", () => $67c73f3f32c78692$export$c7187bbd1a7a9244);
var $67c73f3f32c78692$export$8633a0edef8e95dd = 'emoji-common-selected';
var $67c73f3f32c78692$export$860109dfd198259b = 'emoji-common-select-on-hover';
var $67c73f3f32c78692$export$1c10634420a08d8a = 'emoji-common-emoji-sprite';
var $67c73f3f32c78692$export$b06c4aab1d012063 = 'emoji-common-node';
var $67c73f3f32c78692$export$da61cef1c8919f7c = 'emoji-common-emoji-image';
var $67c73f3f32c78692$export$b11fa39b56a371f6 = 'emoji-common-deleteButton';
var $67c73f3f32c78692$export$11462c0756c24ab6 = 'emoji-common-main-styles';
var $67c73f3f32c78692$export$22b19c311e9caa4 = 'emoji-common-deletable';
var $67c73f3f32c78692$export$c7187bbd1a7a9244 = 'emoji-common-placeholder';
var $67c73f3f32c78692$export$b0fe756d87022806 = 'emoji-picker-add-emoji';

});

parcelRegister("5qFVM", function(module, exports) {
$parcel$export(module.exports, "INLINE_IMAGE_WRAPPER_CLASS_NAME", () => $3f3fe80f1045fc8d$export$dd2e16f83ae6aa78);
$parcel$export(module.exports, "INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY", () => $3f3fe80f1045fc8d$export$7ab34e219ce6eef);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY", () => $3f3fe80f1045fc8d$export$263a8a844c370a89);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY", () => $3f3fe80f1045fc8d$export$b0d1f1e1fb3c4b46);
$parcel$export(module.exports, "wrapperStyle", () => $3f3fe80f1045fc8d$export$c4d4f06a25de97f);
$parcel$export(module.exports, "selectedStyle", () => $3f3fe80f1045fc8d$export$a7abb1b3dc25813f);
$parcel$export(module.exports, "borderStyle", () => $3f3fe80f1045fc8d$export$4d0a7f76ad443516);

var $lAD7C = parcelRequire("lAD7C");

var $74Zh5 = parcelRequire("74Zh5");

var $5gDus = parcelRequire("5gDus");
var $3f3fe80f1045fc8d$var$_templateObject, $3f3fe80f1045fc8d$var$_templateObject2;
var $3f3fe80f1045fc8d$export$dd2e16f83ae6aa78 = 'media-inline-image-wrapper';
var $3f3fe80f1045fc8d$export$7ab34e219ce6eef = '--editor-media-inline-image-aspect-ratio';
var $3f3fe80f1045fc8d$export$263a8a844c370a89 = '--editor-media-inline-image-border-size';
var $3f3fe80f1045fc8d$export$b0d1f1e1fb3c4b46 = '--editor-media-inline-image-border-color';
// We implemented such selectors to ensure specificity:
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Nested and dynamic css calls are violations, needs manual remediation
var $3f3fe80f1045fc8d$var$inlineImageHeight = function inlineImageHeight(height) {
    var margin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return (0, $74Zh5.css)($3f3fe80f1045fc8d$var$_templateObject || ($3f3fe80f1045fc8d$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($lAD7C)))([
        "\n\t/* Editor style */\n\t> .mediaInlineView-content-wrap > .",
        ",\n  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .",
        ",\n  /* Renderer style */\n  > .",
        ",\n  > :is(a, span[data-mark-type='border']) .",
        " {\n\t\theight: ",
        "px;\n\t\ttransform: translateY(",
        "px);\n\t}\n"
    ])), $3f3fe80f1045fc8d$export$dd2e16f83ae6aa78, $3f3fe80f1045fc8d$export$dd2e16f83ae6aa78, $3f3fe80f1045fc8d$export$dd2e16f83ae6aa78, $3f3fe80f1045fc8d$export$dd2e16f83ae6aa78, height, margin);
};
var $3f3fe80f1045fc8d$export$dee15762144889b7 = (0, $74Zh5.css)($3f3fe80f1045fc8d$var$_templateObject2 || ($3f3fe80f1045fc8d$var$_templateObject2 = (0, (/*@__PURE__*/$parcel$interopDefault($lAD7C)))([
    "\n\t/* p, h3, and action items */\n\t.",
    " {\n\t\theight: ",
    "px;\n\t\ttransform: translateY(-2px);\n\t}\n\n\th1 {\n\t\t",
    "\n\t}\n\n\th2 {\n\t\t",
    "\n\t}\n\n\th3 {\n\t\t",
    "\n\t}\n\n\th4 {\n\t\t",
    "\n\t}\n\n\th5 {\n\t\t",
    "\n\t}\n\n\th6 {\n\t\t",
    "\n\t}\n"
])), $3f3fe80f1045fc8d$export$dd2e16f83ae6aa78, (0, $5gDus.referenceHeights)['p'], $3f3fe80f1045fc8d$var$inlineImageHeight((0, $5gDus.referenceHeights)['h1'], -3), $3f3fe80f1045fc8d$var$inlineImageHeight((0, $5gDus.referenceHeights)['h2'], -3), $3f3fe80f1045fc8d$var$inlineImageHeight((0, $5gDus.referenceHeights)['h3'], -2), $3f3fe80f1045fc8d$var$inlineImageHeight((0, $5gDus.referenceHeights)['h4'], -2), $3f3fe80f1045fc8d$var$inlineImageHeight((0, $5gDus.referenceHeights)['h5'], -2), $3f3fe80f1045fc8d$var$inlineImageHeight((0, $5gDus.referenceHeights)['h6'], -2));
var $3f3fe80f1045fc8d$export$c4d4f06a25de97f = (0, $74Zh5.css)({
    display: 'inline-flex',
    cursor: 'pointer',
    justifyContent: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    overflow: 'hidden',
    borderRadius: "var(--ds-radius-small, 3px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    aspectRatio: "var(".concat($3f3fe80f1045fc8d$export$7ab34e219ce6eef, ", ").concat((0, $5gDus.DEFAULT_INLINE_IMAGE_ASPECT_RATIO), ")"),
    maxWidth: '100%'
});
var $3f3fe80f1045fc8d$export$a7abb1b3dc25813f = (0, $74Zh5.css)({
    boxShadow: "0 0 0 1px ".concat("var(--ds-border-selected, #1868DB)"),
    outline: 'none'
});
var $3f3fe80f1045fc8d$export$4d0a7f76ad443516 = (0, $74Zh5.css)({
    borderColor: "var(".concat($3f3fe80f1045fc8d$export$b0d1f1e1fb3c4b46, ")"),
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "calc(var(".concat($3f3fe80f1045fc8d$export$263a8a844c370a89, ", ").concat((0, $5gDus.DEFAULT_INLINE_IMAGE_BORDER_SIZE), ") * 2px)"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderWidth: "calc(var(".concat($3f3fe80f1045fc8d$export$263a8a844c370a89, ", ").concat((0, $5gDus.DEFAULT_INLINE_IMAGE_BORDER_SIZE), ") * 1px)"),
    boxSizing: "border-box"
});

});
parcelRegister("5gDus", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_ASPECT_RATIO", () => $3d5d144fcea2bce0$export$286cf28b87ad4b4f);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_BORDER_SIZE", () => $3d5d144fcea2bce0$export$64fe09732fb8680);
$parcel$export(module.exports, "referenceHeights", () => $3d5d144fcea2bce0$export$c1317a9224e4d798);
var $3d5d144fcea2bce0$export$d722b7527b1834a8 = 250;
var $3d5d144fcea2bce0$export$da894f7669b4e67c = 200;
var $3d5d144fcea2bce0$export$286cf28b87ad4b4f = $3d5d144fcea2bce0$export$d722b7527b1834a8 / $3d5d144fcea2bce0$export$da894f7669b4e67c;
var $3d5d144fcea2bce0$export$64fe09732fb8680 = 0;
var $3d5d144fcea2bce0$export$c1317a9224e4d798 = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};

});


parcelRegister("hyfkz", function(module, exports) {
$parcel$export(module.exports, "DateSharedCssClassName", () => $cc71810a0ba0d0fe$export$99cdf122d0bb9f95);
var $cc71810a0ba0d0fe$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: "date-lozenger-container",
    DATE_CONTAINER: 'dateView-content-wrap'
};

});

parcelRegister("cFTJ2", function(module, exports) {
$parcel$export(module.exports, "SyncBlockSharedCssClassName", () => $93a48a43aa2f53c2$export$84840734cffb342f);
$parcel$export(module.exports, "BodiedSyncBlockSharedCssClassName", () => $93a48a43aa2f53c2$export$628f41eb22ec9a2);
var $93a48a43aa2f53c2$var$prefix = 'ak-editor-sync-block';
var $93a48a43aa2f53c2$export$84840734cffb342f = {
    prefix: $93a48a43aa2f53c2$var$prefix,
    renderer: "".concat($93a48a43aa2f53c2$var$prefix, "__renderer"),
    error: "".concat($93a48a43aa2f53c2$var$prefix, "__error_state"),
    loading: "".concat($93a48a43aa2f53c2$var$prefix, "__loading_state")
};
var $93a48a43aa2f53c2$export$8c57d8325d08218b = 'data-sync-block-renderer';
var $93a48a43aa2f53c2$var$bodiedPrefix = 'ak-editor-bodied-sync-block';
var $93a48a43aa2f53c2$export$628f41eb22ec9a2 = {
    prefix: $93a48a43aa2f53c2$var$bodiedPrefix,
    renderer: "".concat($93a48a43aa2f53c2$var$bodiedPrefix, "__renderer"),
    content: "".concat($93a48a43aa2f53c2$var$bodiedPrefix, "__content"),
    selectionInside: "".concat($93a48a43aa2f53c2$var$bodiedPrefix, "__selection_inside"),
    // Applied by the node view when the block holds nothing but a single empty paragraph.
    // Emptiness is derived from the ProseMirror document rather than the rendered DOM, because
    // decorations (for example the selection marker's cursor widget) and ProseMirror's own
    // separator/trailing-break hack nodes are injected as children of that paragraph and make
    // DOM-shape heuristics unreliable. See EDITOR-8327.
    empty: "".concat($93a48a43aa2f53c2$var$bodiedPrefix, "__empty")
};
// Constant labelClassName value here has been inlined in css from EditorContentContainer, if you need to make
// update here, please also update packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
var $93a48a43aa2f53c2$var$labelClassName = 'ak-editor-sync-block__label';
var $93a48a43aa2f53c2$export$f75b6075afbd73af = {
    labelClassName: $93a48a43aa2f53c2$var$labelClassName
};
var $93a48a43aa2f53c2$export$7e44804769d54f36 = 'disabled';
var $93a48a43aa2f53c2$export$da351099a95c41a2 = 'view-mode';
var $93a48a43aa2f53c2$export$ddb90512ea536019 = 'creation-loading';
var $93a48a43aa2f53c2$export$52ab9fe57e8e4c2e = 'user-is-dragging';
var $93a48a43aa2f53c2$export$9b10dd4c500e3ce8 = {
    disabledClassName: $93a48a43aa2f53c2$export$7e44804769d54f36,
    viewModeClassName: $93a48a43aa2f53c2$export$da351099a95c41a2,
    creationLoadingClassName: $93a48a43aa2f53c2$export$ddb90512ea536019,
    draggingClassName: $93a48a43aa2f53c2$export$52ab9fe57e8e4c2e
};

});

parcelRegister("7J4nJ", function(module, exports) {
$parcel$export(module.exports, "LightWeightCodeBlockCssClassName", () => $5a00227b8693b7ab$export$afbde0e7339bed51);
$parcel$export(module.exports, "default", () => $5a00227b8693b7ab$export$2e2bcd8739ae039);

var $lAD7C = parcelRequire("lAD7C");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $knSf2 = parcelRequire("knSf2");

var $1LBcl = parcelRequire("1LBcl");
var $5wL5P = parcelRequire("5wL5P");

var $53SBn = parcelRequire("53SBn");
var $5a00227b8693b7ab$var$_templateObject;
var $5a00227b8693b7ab$var$codeBlockSharedStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPED, "\n\t\t> .").concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "\n\t\t> .").concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT), {
    marginRight: "var(--ds-space-100, 8px)",
    code: {
        display: 'block',
        wordBreak: 'break-word',
        whiteSpace: 'pre-wrap'
    }
}), ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "\n\t\t> .").concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT), {
    display: 'flex',
    flex: 1,
    code: {
        flexGrow: 1,
        whiteSpace: 'pre'
    }
}), ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    position: 'relative',
    backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
    borderRadius: "var(--ds-radius-small, 3px)",
    margin: "".concat((0, $1LBcl.blockNodesVerticalMargin), " 0 0 0"),
    fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    minWidth: "".concat((0, $1LBcl.akEditorTableCellMinWidth), "px"),
    cursor: 'pointer',
    clear: 'both',
    '--ds--code--bg-color': 'transparent',
    '.code-block-gutter-pseudo-element::before': {
        content: '"attr(data-label)"'
    },
    /* This is necessary to allow for arrow key navigation in/out of code blocks in Firefox. */ whiteSpace: 'normal'
}, ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_START), {
    position: 'absolute',
    visibility: 'hidden',
    height: '1.5rem',
    top: '0px',
    left: '0px'
}), "".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_END), {
    position: 'absolute',
    visibility: 'hidden',
    height: '1.5rem',
    bottom: '0px',
    right: '0px'
}), ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER), {
    position: 'relative',
    backgroundColor: "var(--ds-background-neutral, #0515240F)",
    display: 'flex',
    borderRadius: "var(--ds-radius-small, 3px)",
    width: '100%',
    counterReset: 'line',
    overflowX: 'auto',
    backgroundImage: 'var(--ak-renderer-codeblock-content-wrapper-bg-img)',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
    backgroundSize: "var(--ds-space-300, 24px)".concat(" 100%,\n\t\t\t\t", "var(--ds-space-300, 24px)", " 100%,\n\t\t\t\t", "var(--ds-space-100, 8px)", " 100%,\n\t\t\t\t", "var(--ds-space-100, 8px)", " 100%,\n\t\t\t\t", "var(--ds-space-100, 8px)", " 100%,\n\t\t\t\t1px 100%,\n\t\t\t\t", "var(--ds-space-100, 8px)", " 100%,\n\t\t\t\t1px 100%"),
    backgroundPosition: "0 0,\n\t\t\t\t0 0,\n\t\t\t\t100% 0,\n\t\t\t\t100% 0,\n\t\t\t\t100% 0,\n\t\t\t\t100% 0,\n\t\t\t\t0 0,\n\t\t\t\t0 0",
    /* Be careful if refactoring this; it is needed to keep arrow key navigation in Firefox consistent with other browsers. */ overflowY: 'hidden'
}), ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER), {
    backgroundColor: "var(--ds-background-neutral, #0515240F)",
    position: 'relative',
    width: 'var(--lineNumberGutterWidth, 2rem)',
    padding: "var(--ds-space-100, 8px)",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: "".concat(0.875, "rem"),
    boxSizing: 'content-box'
}), ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "::before"), {
    content: '"1"',
    visibility: 'hidden',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: "".concat(0.875, "rem"),
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '1.5rem'
}), ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT), {
    code: {
        tabSize: 4,
        cursor: 'text',
        color: "var(--ds-text, #292A2E)",
        borderRadius: "var(--ds-radius-small, 3px)",
        margin: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: "".concat(0.875, "rem"),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '1.5rem'
    }
}), ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET), {
    pointerEvents: 'none',
    userSelect: 'none',
    width: 'var(--lineNumberGutterWidth, 2rem)',
    left: 0,
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: "".concat(0.875, "rem"),
    padding: "0px ".concat("var(--ds-space-100, 8px)"),
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '1.5rem',
    textAlign: 'right',
    color: "var(--ds-text-subtlest, #6B6E76)",
    boxSizing: 'content-box'
})));
var $5a00227b8693b7ab$var$lightWeightCodeBlockStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER), {
    cursor: 'text'
}));
var $5a00227b8693b7ab$export$afbde0e7339bed51 = {
    CONTAINER: 'light-weight-code-block'
};
var $5a00227b8693b7ab$export$3f1ff491ca7c4c4a = function getLightWeightCodeBlockStylesForRootRendererStyleSheet() {
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return (0, $74Zh5.css)($5a00227b8693b7ab$var$_templateObject || ($5a00227b8693b7ab$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($lAD7C)))([
        "\n\t\t.",
        "\n\t\t\t> .",
        "\n\t\t\t.",
        " {\n\t\t\tmargin-top: ",
        ";\n\t\t}\n\t"
    ])), (0, $53SBn.RendererCssClassName).DOCUMENT, $5a00227b8693b7ab$export$afbde0e7339bed51.CONTAINER, (0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, (0, $1LBcl.blockNodesVerticalMargin));
};
var $5a00227b8693b7ab$var$LightWeightCodeBlock = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var text = _ref.text, _ref$hideLineNumbers = _ref.hideLineNumbers, hideLineNumbers = _ref$hideLineNumbers === void 0 ? false : _ref$hideLineNumbers, className = _ref.className;
    var textRows = (0, $5FkrB.useMemo)(function() {
        return (text !== null && text !== void 0 ? text : '').split('\n');
    }, [
        text
    ]);
    var classNames = [
        $5a00227b8693b7ab$export$afbde0e7339bed51.CONTAINER,
        className
    ].join(' ');
    var codeBlockBackgroundImage = (0, $5wL5P.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    });
    return (0, $74Zh5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        ref: ref,
        css: [
            $5a00227b8693b7ab$var$codeBlockSharedStyles,
            $5a00227b8693b7ab$var$lightWeightCodeBlockStyles
        ],
        style: {
            '--ak-renderer-codeblock-content-wrapper-bg-img': codeBlockBackgroundImage
        }
    }, (0, $74Zh5.jsx)("div", {
        className: (0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER
    }, (0, $74Zh5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER
    }, !hideLineNumbers && (0, $74Zh5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER
    }, textRows.map(function(_, index) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        (0, $74Zh5.jsx)("span", {
            key: index
        }));
    })), (0, $74Zh5.jsx)("div", {
        className: (0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
    }, (0, $74Zh5.jsx)("code", null, text)))));
});
var $5a00227b8693b7ab$export$2e2bcd8739ae039 = $5a00227b8693b7ab$var$LightWeightCodeBlock;

});

parcelRegister("c4Up0", function(module, exports) {
"use strict";
var $8cb19c1afc4eedec$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useExperimentValue = module.exports.useFeatureGate = void 0;

var $5FkrB = parcelRequire("5FkrB");

const $8cb19c1afc4eedec$var$feature_gate_js_client_1 = $8cb19c1afc4eedec$var$__importDefault((parcelRequire("jcX3Q")));
const $8cb19c1afc4eedec$var$useFeatureGate = (gateName, options = {})=>{
    const [gate, setGate] = (0, $5FkrB.useState)(()=>$8cb19c1afc4eedec$var$feature_gate_js_client_1.default.checkGate(gateName, options));
    (0, $5FkrB.useEffect)(()=>{
        const onGateChange = (newValue)=>setGate(newValue);
        return $8cb19c1afc4eedec$var$feature_gate_js_client_1.default.onGateUpdated(gateName, onGateChange, options);
    }, [
        gateName,
        options
    ]);
    return gate;
};
module.exports.useFeatureGate = $8cb19c1afc4eedec$var$useFeatureGate;
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
const $8cb19c1afc4eedec$var$useExperimentValue = (experimentName, parameterName, defaultValue, options = {})=>{
    const [experimentValue, setExperimentValue] = (0, $5FkrB.useState)(()=>$8cb19c1afc4eedec$var$feature_gate_js_client_1.default.getExperimentValue(experimentName, parameterName, defaultValue, options));
    (0, $5FkrB.useEffect)(()=>{
        const onExperimentValueChange = (newValue)=>setExperimentValue(newValue);
        return $8cb19c1afc4eedec$var$feature_gate_js_client_1.default.onExperimentValueUpdated(experimentName, parameterName, defaultValue, onExperimentValueChange, options);
    }, [
        experimentName,
        parameterName,
        defaultValue,
        options
    ]);
    return experimentValue;
};
module.exports.useExperimentValue = $8cb19c1afc4eedec$var$useExperimentValue;

});
parcelRegister("jcX3Q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("ISKn7")).default);
$parcel$export(module.exports, "FeatureGateEnvironment", () => (parcelRequire("hiARP")).FeatureGateEnvironment);
$parcel$export(module.exports, "PerimeterType", () => (parcelRequire("hiARP")).PerimeterType);
$parcel$export(module.exports, "CLIENT_VERSION", () => (parcelRequire("7HOhT")).CLIENT_VERSION);
$parcel$export(module.exports, "DynamicConfig", () => (parcelRequire("kkQZA")).DynamicConfig);
$parcel$export(module.exports, "Layer", () => (parcelRequire("eVlof")).Layer);
$parcel$export(module.exports, "EvaluationReason", () => (parcelRequire("48eYA")).EvaluationReason);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /**
 * @deprecated Use `import type { AnalyticsWebClient, BaseClientOptions, CheckGateOptions, ClientOptions, CustomAttributes, FrontendExperimentsResult, FromValuesClientOptions, GetExperimentOptions, GetExperimentValueOptions, Identifiers, InitializeValues, UpdateUserCompletionCallback, OptionsWithDefaults, Provider } from '@atlaskit/feature-gate-js-client/feature-gates'` instead.
 */ /**
 * @deprecated Use `import type { LocalOverrides } from '@atlaskit/feature-gate-js-client/persistent-override-adapter'` instead.
 */ /**
 * @deprecated Use `import { boundFGJS, FeatureGateEnvironment, PerimeterType, CLIENT_VERSION } from '@atlaskit/feature-gate-js-client/feature-gates'` instead.
 */ parcelRequire("ISKn7");
var $7HOhT = parcelRequire("7HOhT");
var $ISKn7 = parcelRequire("ISKn7");
var $hiARP = parcelRequire("hiARP");

var $kkQZA = parcelRequire("kkQZA");

var $eVlof = parcelRequire("eVlof");

var $48eYA = parcelRequire("48eYA");

});


parcelRegister("fb6VX", function(module, exports) {
"use strict";
var $b0cd42ffbfb0b3a7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitialization = void 0;

var $5FkrB = parcelRequire("5FkrB");

const $b0cd42ffbfb0b3a7$var$feature_gate_js_client_1 = $b0cd42ffbfb0b3a7$var$__importDefault((parcelRequire("jcX3Q")));

var $14MvJ = parcelRequire("14MvJ");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $b0cd42ffbfb0b3a7$var$FeatureGatesInitialization = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializingComponent: initializingComponent, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $5FkrB.useState)(!overrides && (0, $14MvJ.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $5FkrB.useRef)(options);
    (0, $5FkrB.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $5FkrB.useEffect)(()=>{
        if (enabled) {
            if ((0, $14MvJ.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $14MvJ.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $b0cd42ffbfb0b3a7$var$feature_gate_js_client_1.default.initializeCalled() ? $b0cd42ffbfb0b3a7$var$feature_gate_js_client_1.default.updateUser(optionsRef.current, identifiers, customAttributes) : $b0cd42ffbfb0b3a7$var$feature_gate_js_client_1.default.initialize(optionsRef.current, identifiers, customAttributes);
                initPromise.catch((err)=>(0, $14MvJ.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $14MvJ.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $14MvJ.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $14MvJ.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
module.exports.FeatureGatesInitialization = $b0cd42ffbfb0b3a7$var$FeatureGatesInitialization;
module.exports.default = module.exports.FeatureGatesInitialization;

});
parcelRegister("14MvJ", function(module, exports) {
"use strict";
var $0c8bcb631f9fa522$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isClientAlreadyInCorrectState = $0c8bcb631f9fa522$var$isClientAlreadyInCorrectState;
module.exports.pickChildToRender = $0c8bcb631f9fa522$var$pickChildToRender;
module.exports.toError = $0c8bcb631f9fa522$var$toError;
module.exports.applyOverrides = $0c8bcb631f9fa522$var$applyOverrides;
module.exports.clearOverrides = $0c8bcb631f9fa522$var$clearOverrides;

const $0c8bcb631f9fa522$var$react_1 = $0c8bcb631f9fa522$var$__importDefault((parcelRequire("5FkrB")));

const $0c8bcb631f9fa522$var$feature_gate_js_client_1 = $0c8bcb631f9fa522$var$__importDefault((parcelRequire("jcX3Q")));
let $0c8bcb631f9fa522$var$hasWarnedAboutMissingOverrideSupport = false;
function $0c8bcb631f9fa522$var$isClientAlreadyInCorrectState(identifiers, customAttributes) {
    var _a, _b;
    // If either of these methods don't exist (ie. if the product is using <v4.2.0), then this method will always return false
    return ((_a = $0c8bcb631f9fa522$var$feature_gate_js_client_1.default.initializeCompleted) === null || _a === void 0 ? void 0 : _a.call($0c8bcb631f9fa522$var$feature_gate_js_client_1.default)) && ((_b = $0c8bcb631f9fa522$var$feature_gate_js_client_1.default.isCurrentUser) === null || _b === void 0 ? void 0 : _b.call($0c8bcb631f9fa522$var$feature_gate_js_client_1.default, identifiers, customAttributes));
}
function $0c8bcb631f9fa522$var$pickChildToRender(enabled, isInitialized, children, initializingComponent) {
    if (!enabled || isInitialized) return $0c8bcb631f9fa522$var$react_1.default.createElement($0c8bcb631f9fa522$var$react_1.default.Fragment, null, children);
    if (initializingComponent != null) return $0c8bcb631f9fa522$var$react_1.default.createElement($0c8bcb631f9fa522$var$react_1.default.Fragment, null, initializingComponent);
    return null;
}
function $0c8bcb631f9fa522$var$toError(err) {
    if (err instanceof Error) return err;
    return new Error(err === null || err === void 0 ? void 0 : err.toString());
}
function $0c8bcb631f9fa522$var$applyOverrides(overrides) {
    // Allow newer versions of the React SDK to be used with older v3.x JS client versions,
    // provided the caller does not try to leverage the overrides which were introduced in v4.
    if (overrides && (!$0c8bcb631f9fa522$var$feature_gate_js_client_1.default.overrideGate || !$0c8bcb631f9fa522$var$feature_gate_js_client_1.default.overrideConfig)) {
        if (!$0c8bcb631f9fa522$var$hasWarnedAboutMissingOverrideSupport) {
            console.warn('Overrides are only supported in @atlaskit/feature-gate-js-client v4.0.0+');
            $0c8bcb631f9fa522$var$hasWarnedAboutMissingOverrideSupport = true;
        }
        return;
    }
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach(([gateName, value])=>{
        var _a;
        (_a = $0c8bcb631f9fa522$var$feature_gate_js_client_1.default.overrideGate) === null || _a === void 0 || _a.call($0c8bcb631f9fa522$var$feature_gate_js_client_1.default, gateName, value);
    });
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach(([configName, values])=>{
        var _a;
        (_a = $0c8bcb631f9fa522$var$feature_gate_js_client_1.default.overrideConfig) === null || _a === void 0 || _a.call($0c8bcb631f9fa522$var$feature_gate_js_client_1.default, configName, values);
    });
}
function $0c8bcb631f9fa522$var$clearOverrides(overrides) {
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach((gateName)=>{
        var _a;
        (_a = $0c8bcb631f9fa522$var$feature_gate_js_client_1.default.clearGateOverride) === null || _a === void 0 || _a.call($0c8bcb631f9fa522$var$feature_gate_js_client_1.default, gateName);
    });
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach((configName)=>{
        var _a;
        (_a = $0c8bcb631f9fa522$var$feature_gate_js_client_1.default.clearConfigOverride) === null || _a === void 0 || _a.call($0c8bcb631f9fa522$var$feature_gate_js_client_1.default, configName);
    });
}

});


parcelRegister("jlxKU", function(module, exports) {
"use strict";
var $e15a29a50c470b63$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithProvider = void 0;

var $5FkrB = parcelRequire("5FkrB");

const $e15a29a50c470b63$var$feature_gate_js_client_1 = $e15a29a50c470b63$var$__importDefault((parcelRequire("jcX3Q")));

var $14MvJ = parcelRequire("14MvJ");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $e15a29a50c470b63$var$FeatureGatesInitializationWithProvider = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializingComponent: initializingComponent, overrides: overrides, onReady: onReady, provider: provider })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $5FkrB.useState)(!overrides && (0, $14MvJ.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options and provider, so that we can use them within the following useEffect
    // without adding options and provider as dependencies.
    // This avoids the user updating every time an option or provider is attempted to be changed.
    const optionsRef = (0, $5FkrB.useRef)(options);
    const providerRef = (0, $5FkrB.useRef)(provider);
    (0, $5FkrB.useEffect)(()=>{
        optionsRef.current = options;
        providerRef.current = provider;
    }, [
        options,
        provider
    ]);
    (0, $5FkrB.useEffect)(()=>{
        if (enabled) {
            if ((0, $14MvJ.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $14MvJ.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $e15a29a50c470b63$var$feature_gate_js_client_1.default.initializeCalled() ? $e15a29a50c470b63$var$feature_gate_js_client_1.default.updateUserWithProvider(identifiers, customAttributes) : $e15a29a50c470b63$var$feature_gate_js_client_1.default.initializeWithProvider(options, provider, identifiers, customAttributes);
                initPromise.catch((err)=>(0, $14MvJ.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $14MvJ.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $14MvJ.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $14MvJ.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
module.exports.FeatureGatesInitializationWithProvider = $e15a29a50c470b63$var$FeatureGatesInitializationWithProvider;
module.exports.default = module.exports.FeatureGatesInitializationWithProvider;

});

parcelRegister("glblS", function(module, exports) {
"use strict";
var $be5769be92103314$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithDefaults = void 0;

var $5FkrB = parcelRequire("5FkrB");

const $be5769be92103314$var$feature_gate_js_client_1 = $be5769be92103314$var$__importDefault((parcelRequire("jcX3Q")));

var $14MvJ = parcelRequire("14MvJ");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $be5769be92103314$var$FeatureGatesInitializationWithDefaults = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $5FkrB.useState)(!overrides && (0, $14MvJ.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $5FkrB.useRef)(options);
    (0, $5FkrB.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $5FkrB.useEffect)(()=>{
        if (enabled) {
            if ((0, $14MvJ.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $14MvJ.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $be5769be92103314$var$feature_gate_js_client_1.default.initializeCalled() ? $be5769be92103314$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes) : $be5769be92103314$var$feature_gate_js_client_1.default.initializeFromValues(Object.assign({
                    sdkKey: 'client-default-key'
                }, optionsRef.current || {}), identifiers, customAttributes);
                initPromise.catch((err)=>(0, $14MvJ.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $14MvJ.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $14MvJ.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $14MvJ.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithDefaults = $be5769be92103314$var$FeatureGatesInitializationWithDefaults;
module.exports.default = module.exports.FeatureGatesInitializationWithDefaults;

});

parcelRegister("hn1YZ", function(module, exports) {
"use strict";
var $ca561f5aec499d8d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithValues = void 0;

var $5FkrB = parcelRequire("5FkrB");

const $ca561f5aec499d8d$var$feature_gate_js_client_1 = $ca561f5aec499d8d$var$__importDefault((parcelRequire("jcX3Q")));

var $14MvJ = parcelRequire("14MvJ");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $ca561f5aec499d8d$var$FeatureGatesInitializationWithValues = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializeValues: initializeValues, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $5FkrB.useState)(!overrides && (0, $14MvJ.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $5FkrB.useRef)(options);
    (0, $5FkrB.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $5FkrB.useEffect)(()=>{
        if (enabled) {
            if ((0, $14MvJ.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $14MvJ.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $ca561f5aec499d8d$var$feature_gate_js_client_1.default.initializeCalled() ? $ca561f5aec499d8d$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes, initializeValues) : $ca561f5aec499d8d$var$feature_gate_js_client_1.default.initializeFromValues(optionsRef.current, identifiers, customAttributes, initializeValues);
                initPromise.catch((err)=>(0, $14MvJ.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $14MvJ.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $14MvJ.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        initializeValues,
        overrides
    ]);
    return (0, $14MvJ.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithValues = $ca561f5aec499d8d$var$FeatureGatesInitializationWithValues;
module.exports.default = module.exports.FeatureGatesInitializationWithValues;

});

parcelRegister("6ldPa", function(module, exports) {
$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $49df6d75f4092ae2$export$a4def92db6fc8e17);
var $49df6d75f4092ae2$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("cIS95", function(module, exports) {
$parcel$export(module.exports, "EntriesBuffer", () => $94339846ca1d299e$export$f7dc16cbd16f7bbe);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6ldPa = parcelRequire("6ldPa");
var $94339846ca1d299e$export$2c6e86519c9e8188 = /*#__PURE__*/ function() {
    function BufferWithMaxLength() {
        var maxLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, BufferWithMaxLength);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "buffer", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "full", false);
        this.maxLength = maxLength;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(BufferWithMaxLength, [
        {
            key: "push",
            value: function push(item) {
                if (this.full || this.maxLength === this.buffer.length) {
                    this.full = true;
                    this.buffer.shift();
                }
                this.buffer.push(item);
            }
        },
        {
            key: "getAll",
            value: function getAll() {
                return this.buffer;
            }
        }
    ]);
}();
var $94339846ca1d299e$export$f7dc16cbd16f7bbe = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $6ldPa.PerformanceObserverEntryTypes).LongTask, new $94339846ca1d299e$export$2c6e86519c9e8188()), (0, $6ldPa.PerformanceObserverEntryTypes).LayoutShift, new $94339846ca1d299e$export$2c6e86519c9e8188());

});

parcelRegister("1gQdg", function(module, exports) {
$parcel$export(module.exports, "createPressureStateReport", () => $0ecfc97a8169a0bc$export$1f0ff35da084986e);
$parcel$export(module.exports, "createMemoryStateReport", () => $0ecfc97a8169a0bc$export$3b47ebb9832b4e24);
$parcel$export(module.exports, "initialisePressureObserver", () => $0ecfc97a8169a0bc$export$117ebc554c6e9f2f);
$parcel$export(module.exports, "initialiseMemoryObserver", () => $0ecfc97a8169a0bc$export$a3271f53e91faab7);

var $fC8ib = parcelRequire("fC8ib");
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ var $0ecfc97a8169a0bc$var$BUFFER_MAX_LENGTH = 1000; // ensure we don't blow up this buffer
var $0ecfc97a8169a0bc$var$pressureRecordBuffer = [];
var $0ecfc97a8169a0bc$var$pressureObserver = null;
var $0ecfc97a8169a0bc$var$memoryRecordBuffer = [];
var $0ecfc97a8169a0bc$var$memoryInterval;
function $0ecfc97a8169a0bc$export$6c1060bed5fea050() {
    $0ecfc97a8169a0bc$var$pressureRecordBuffer.length = 0;
}
function $0ecfc97a8169a0bc$export$aa672c7221b183b0() {
    $0ecfc97a8169a0bc$var$memoryRecordBuffer.length = 0;
}
function $0ecfc97a8169a0bc$export$ec86686c1d2e65bc(filter) {
    $0ecfc97a8169a0bc$var$pressureRecordBuffer = $0ecfc97a8169a0bc$var$pressureRecordBuffer.filter(function(_ref) {
        var time = _ref.time;
        return time > filter;
    });
}
function $0ecfc97a8169a0bc$export$c0142ac82f5d0c28(filter) {
    $0ecfc97a8169a0bc$var$memoryRecordBuffer = $0ecfc97a8169a0bc$var$memoryRecordBuffer.filter(function(_ref2) {
        var time = _ref2.time;
        return time > filter;
    });
}
function $0ecfc97a8169a0bc$export$1f0ff35da084986e(start, end) {
    try {
        // To differentiate between the API not available, vs no PressureRecords added
        if (!('PressureObserver' in globalThis)) return null;
        var pressureStateCount = $0ecfc97a8169a0bc$var$pressureRecordBuffer.reduce(function(pressureReport, _ref3) {
            var time = _ref3.time, state = _ref3.state;
            if (time >= start && time <= end) pressureReport[state] += 1;
            return pressureReport;
        }, {
            nominal: 0,
            fair: 0,
            serious: 0,
            critical: 0
        });
        var pressureStateTotal = Object.values(pressureStateCount).reduce(function(total, count) {
            return total + count;
        }) || 1;
        $0ecfc97a8169a0bc$export$ec86686c1d2e65bc(end);
        return {
            count: pressureStateCount,
            percentage: {
                nominal: Math.round(pressureStateCount.nominal / pressureStateTotal * 100),
                fair: Math.round(pressureStateCount.fair / pressureStateTotal * 100),
                serious: Math.round(pressureStateCount.serious / pressureStateTotal * 100),
                critical: Math.round(pressureStateCount.critical / pressureStateTotal * 100)
            }
        };
    } catch (_unused) {
        return null;
    }
}
function $0ecfc97a8169a0bc$var$convertBytesToMegabytes(bytes) {
    return Math.round(Math.round(bytes / 1048576 * 100) / 100);
}
function $0ecfc97a8169a0bc$export$3b47ebb9832b4e24(start, end) {
    try {
        if (!('memory' in performance)) return null;
        var accumulatedMemoryUsage = $0ecfc97a8169a0bc$var$memoryRecordBuffer.reduce(function(acc, snapshot) {
            if (snapshot.time >= start && snapshot.time <= end) {
                acc.totalJSHeapSize += snapshot.totalJSHeapSize;
                acc.usedJSHeapSize += snapshot.usedJSHeapSize;
                acc.snapshotCount += 1;
            }
            return acc;
        }, {
            totalJSHeapSize: 0,
            usedJSHeapSize: 0,
            snapshotCount: 0
        });
        var memoryStateReport = {
            jsHeapSizeLimitInMB: $0ecfc97a8169a0bc$var$convertBytesToMegabytes($0ecfc97a8169a0bc$var$memoryRecordBuffer[0].jsHeapSizeLimit),
            // just use the first record, since this value always remains the same over time
            avgTotalJSHeapSizeInMB: $0ecfc97a8169a0bc$var$convertBytesToMegabytes(accumulatedMemoryUsage.totalJSHeapSize / accumulatedMemoryUsage.snapshotCount),
            avgUsedJSHeapSizeInMB: $0ecfc97a8169a0bc$var$convertBytesToMegabytes(accumulatedMemoryUsage.usedJSHeapSize / accumulatedMemoryUsage.snapshotCount)
        };
        $0ecfc97a8169a0bc$export$c0142ac82f5d0c28(end);
        return memoryStateReport;
    } catch (_unused2) {
        return null;
    }
}
function $0ecfc97a8169a0bc$export$117ebc554c6e9f2f() {
    try {
        if ('PressureObserver' in globalThis) {
            $0ecfc97a8169a0bc$var$pressureObserver = new PressureObserver(function(records) {
                if ($0ecfc97a8169a0bc$var$pressureRecordBuffer.length + records.length <= $0ecfc97a8169a0bc$var$BUFFER_MAX_LENGTH) {
                    var _pressureRecordBuffer;
                    (_pressureRecordBuffer = $0ecfc97a8169a0bc$var$pressureRecordBuffer).push.apply(_pressureRecordBuffer, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(records));
                }
            });
            $0ecfc97a8169a0bc$var$pressureObserver.observe('cpu', {
                sampleInterval: 100
            }).catch(function() {
            // Silently handle permission policy restrictions or other observe failures
            // This prevents unhandled promise rejections from being reported to Sentry
            });
        }
    } catch (_unused3) {
    /* do nothing, this is a best efforts metric */ }
}
function $0ecfc97a8169a0bc$export$a3271f53e91faab7() {
    try {
        // only set up the interval if `performance.memory` is available in the browser
        if ('memory' in performance) $0ecfc97a8169a0bc$var$memoryInterval = setInterval(function() {
            // another check of `performance.memory` availability to satisfy typescript
            if ('memory' in performance) {
                var memory = performance.memory;
                if ($0ecfc97a8169a0bc$var$memoryRecordBuffer.length <= $0ecfc97a8169a0bc$var$BUFFER_MAX_LENGTH) $0ecfc97a8169a0bc$var$memoryRecordBuffer.push({
                    time: performance.now(),
                    jsHeapSizeLimit: memory.jsHeapSizeLimit,
                    totalJSHeapSize: memory.totalJSHeapSize,
                    usedJSHeapSize: memory.usedJSHeapSize
                });
            }
        }, 100);
    } catch (_unused4) {
    /* do nothing, this is a best efforts metric */ }
}
function $0ecfc97a8169a0bc$export$10899ada382f2ae3() {
    clearInterval($0ecfc97a8169a0bc$var$memoryInterval);
}
function $0ecfc97a8169a0bc$export$b9fdd785f0fc1d40() {
    var _pressureObserver;
    (_pressureObserver = $0ecfc97a8169a0bc$var$pressureObserver) === null || _pressureObserver === void 0 || _pressureObserver.disconnect();
}

});

parcelRegister("jFDZt", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("lemzv"),
    $iKwew("dE57g")
]).then(()=>parcelRequire('fXLYo'));

});

parcelRegister("kPRfH", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("lemzv"),
    $iKwew("cSKiB")
]).then(()=>parcelRequire('crYhX'));

});

parcelRegister("gyFaN", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("jcyZO").then(()=>parcelRequire('7YvAm'));

});

parcelRegister("2HSTn", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("dxVBj").then(()=>parcelRequire('4iO1Y'));

});

parcelRegister("8ksGL", function(module, exports) {
$parcel$export(module.exports, "isNestedTableExtension", () => $610671fe3480720a$export$f45e7335ec874bfe);

var $9pttu = parcelRequire("9pttu");
var $610671fe3480720a$export$f45e7335ec874bfe = function isNestedTableExtension(extensionNode) {
    var _extensionNode$attrs, _extensionNode$attrs2;
    return ((_extensionNode$attrs = extensionNode.attrs) === null || _extensionNode$attrs === void 0 ? void 0 : _extensionNode$attrs.extensionType) === (0, $9pttu.NESTED_TABLE_EXTENSION_TYPE) && ((_extensionNode$attrs2 = extensionNode.attrs) === null || _extensionNode$attrs2 === void 0 ? void 0 : _extensionNode$attrs2.extensionKey) === (0, $9pttu.NESTED_TABLE_EXTENSION_KEY);
};

});

parcelRegister("jiQPK", function(module, exports) {
$parcel$export(module.exports, "transformNestedTablesIncomingDocument", () => $e0d8ae6986ec9d55$export$18544d0b5f43e4a1);

var $kbnxS = parcelRequire("kbnxS");

var $PcCHT = parcelRequire("PcCHT");

var $8ksGL = parcelRequire("8ksGL");
var $e0d8ae6986ec9d55$var$transformNestedTableExtension = function transformNestedTableExtension(nestedTableExtension) {
    var _nestedTableExtension;
    // No content - drop the extension node
    if (!((_nestedTableExtension = nestedTableExtension.attrs) !== null && _nestedTableExtension !== void 0 && (_nestedTableExtension = _nestedTableExtension.parameters) !== null && _nestedTableExtension !== void 0 && _nestedTableExtension.adf)) return false;
    try {
        var _nestedTableExtension2;
        var adf = JSON.parse((_nestedTableExtension2 = nestedTableExtension.attrs) === null || _nestedTableExtension2 === void 0 || (_nestedTableExtension2 = _nestedTableExtension2.parameters) === null || _nestedTableExtension2 === void 0 ? void 0 : _nestedTableExtension2.adf);
        if (!adf.content || adf.content.length === 0) return false;
        return adf.content[0];
    } catch (e) {
        throw new (0, $PcCHT.NodeNestingTransformError)('Failed to parse nested table content');
    }
};
var $e0d8ae6986ec9d55$export$18544d0b5f43e4a1 = function transformNestedTablesIncomingDocument(adf) {
    var isTransformed = false;
    var transformedAdf = (0, $kbnxS.traverse)(adf, {
        extension: function extension(node) {
            if ((0, $8ksGL.isNestedTableExtension)(node)) {
                isTransformed = true;
                return $e0d8ae6986ec9d55$var$transformNestedTableExtension(node);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

var $faf30355a80342e4$exports = {};
'use strict';

$faf30355a80342e4$exports = (parcelRequire("8Oe8o"));



var $cITiu = parcelRequire("cITiu");

var $6lN5g = parcelRequire("6lN5g");

var $aZgxu = parcelRequire("aZgxu");

var $3BOiJ = parcelRequire("3BOiJ");
var $f17f0f6b501ed4b1$export$b11e9bebbf62b20e = function enableGlobalTheme() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $6lN5g.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $6lN5g.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $6lN5g.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $6lN5g.themeStateDefaults)['light'] : _ref$light, _ref$motion = _ref.motion, motion = _ref$motion === void 0 ? (0, $6lN5g.themeStateDefaults)['motion']() : _ref$motion, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $6lN5g.themeStateDefaults)['shape'] : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $6lN5g.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $6lN5g.themeStateDefaults)['typography'] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $6lN5g.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeLoader = arguments.length > 1 ? arguments[1] : undefined;
    var themeState = {
        colorMode: colorMode,
        contrastMode: contrastMode,
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography,
        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
    };
    // Determine what to load and call theme loader
    var themePreferences = (0, $3BOiJ.getThemePreferences)(themeState);
    if (themeLoader) themePreferences.map(function(themeId) {
        return themeLoader(themeId);
    });
    var autoUnbind = (0, $aZgxu.default)(themeState);
    return autoUnbind;
};
var $f17f0f6b501ed4b1$export$2e2bcd8739ae039 = $f17f0f6b501ed4b1$export$b11e9bebbf62b20e;



var $fC8ib = parcelRequire("fC8ib");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $50U6m = parcelRequire("50U6m");

var $N6ReQ = parcelRequire("N6ReQ");

var $6lN5g = parcelRequire("6lN5g");

var $koLca = parcelRequire("koLca");

var $3BOiJ = parcelRequire("3BOiJ");

var $6clIx = parcelRequire("6clIx");

var $j7IrW = parcelRequire("j7IrW");

var $9e4e6a70439714f4$export$a3fc04b8551e006a = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(preferences) {
        var themePreferences, themeOverridePreferences, themeState, results;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    themeOverridePreferences = [];
                    if (preferences === 'all') {
                        themePreferences = (0, $N6ReQ.themeIdsWithOverrides);
                        if (!(0, $50U6m.fg)('platform-dst-tokens-finesse')) themePreferences = themePreferences.filter(function(themeId) {
                            return !(0, $N6ReQ.themeOverrideIds).includes(themeId);
                        });
                        // CLEANUP: Remove
                        if (!(0, $50U6m.fg)('platform_increased-contrast-themes')) themePreferences = themePreferences.filter(function(n) {
                            return n !== 'light-increased-contrast' && n !== 'dark-increased-contrast' && n !== 'light-increased-contrast-finesse' && n !== 'dark-increased-contrast-finesse';
                        });
                    } else {
                        themeState = {
                            colorMode: (preferences === null || preferences === void 0 ? void 0 : preferences.colorMode) || (0, $6lN5g.themeStateDefaults)['colorMode'],
                            contrastMode: (preferences === null || preferences === void 0 ? void 0 : preferences.contrastMode) || (0, $6lN5g.themeStateDefaults)['contrastMode'],
                            dark: (preferences === null || preferences === void 0 ? void 0 : preferences.dark) || (0, $6lN5g.themeStateDefaults)['dark'],
                            light: (preferences === null || preferences === void 0 ? void 0 : preferences.light) || (0, $6lN5g.themeStateDefaults)['light'],
                            motion: (preferences === null || preferences === void 0 ? void 0 : preferences.motion) || (0, $6lN5g.themeStateDefaults)['motion'](),
                            shape: (preferences === null || preferences === void 0 ? void 0 : preferences.shape) || (0, $6lN5g.themeStateDefaults)['shape'],
                            spacing: (preferences === null || preferences === void 0 ? void 0 : preferences.spacing) || (0, $6lN5g.themeStateDefaults)['spacing'],
                            typography: (preferences === null || preferences === void 0 ? void 0 : preferences.typography) || (0, $6lN5g.themeStateDefaults)['typography']
                        };
                        themePreferences = (0, $3BOiJ.getThemePreferences)(themeState);
                        themeOverridePreferences = (0, $koLca.getThemeOverridePreferences)(themeState);
                    }
                    _context3.next = 1;
                    return Promise.all([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(themePreferences), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(themeOverridePreferences)).map(/*#__PURE__*/ function() {
                        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
                            var css, _t;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.prev = 0;
                                        _context.next = 1;
                                        return (0, $j7IrW.loadThemeCss)(themeId);
                                    case 1:
                                        css = _context.sent;
                                        return _context.abrupt("return", {
                                            id: themeId,
                                            attrs: {
                                                'data-theme': themeId
                                            },
                                            css: css
                                        });
                                    case 2:
                                        _context.prev = 2;
                                        _t = _context["catch"](0);
                                        return _context.abrupt("return", undefined);
                                    case 3:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee, null, [
                                [
                                    0,
                                    2
                                ]
                            ]);
                        }));
                        return function(_x2) {
                            return _ref2.apply(this, arguments);
                        };
                    }())), [
                        // Add custom themes if they're present
                        (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2() {
                            var _preferences$UNSAFE_t;
                            var _yield$import, getCustomThemeStyles, customThemeStyles, _t2;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        if (!(preferences !== 'all' && preferences !== null && preferences !== void 0 && preferences.UNSAFE_themeOptions && (0, $6clIx.isValidBrandHex)(preferences === null || preferences === void 0 || (_preferences$UNSAFE_t = preferences.UNSAFE_themeOptions) === null || _preferences$UNSAFE_t === void 0 ? void 0 : _preferences$UNSAFE_t.brandColor))) {
                                            _context2.next = 5;
                                            break;
                                        }
                                        _context2.prev = 1;
                                        _context2.next = 2;
                                        return (parcelRequire("8OJT1"));
                                    case 2:
                                        _yield$import = _context2.sent;
                                        getCustomThemeStyles = _yield$import.getCustomThemeStyles;
                                        _context2.next = 3;
                                        return getCustomThemeStyles({
                                            colorMode: (preferences === null || preferences === void 0 ? void 0 : preferences.colorMode) || (0, $6lN5g.themeStateDefaults)['colorMode'],
                                            UNSAFE_themeOptions: preferences === null || preferences === void 0 ? void 0 : preferences.UNSAFE_themeOptions
                                        });
                                    case 3:
                                        customThemeStyles = _context2.sent;
                                        return _context2.abrupt("return", customThemeStyles);
                                    case 4:
                                        _context2.prev = 4;
                                        _t2 = _context2["catch"](1);
                                        return _context2.abrupt("return", undefined);
                                    case 5:
                                        return _context2.abrupt("return", undefined);
                                    case 6:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2, null, [
                                [
                                    1,
                                    4
                                ]
                            ]);
                        }))()
                    ]));
                case 1:
                    results = _context3.sent;
                    return _context3.abrupt("return", results.flat().filter(function(theme) {
                        return theme !== undefined;
                    }));
                case 2:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function getThemeStyles(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $9e4e6a70439714f4$export$2e2bcd8739ae039 = $9e4e6a70439714f4$export$a3fc04b8551e006a;




var $5FkrB = parcelRequire("5FkrB");
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $l2Z7B = parcelRequire("l2Z7B");

var $5FkrB = parcelRequire("5FkrB");

var $l2Z7B = parcelRequire("l2Z7B");

var $5FkrB = parcelRequire("5FkrB");

var $knBeW = parcelRequire("knBeW");

var $l2Z7B = parcelRequire("l2Z7B");

var $5FkrB = parcelRequire("5FkrB");

var $kVTHJ = parcelRequire("kVTHJ");

var $ftB2S = parcelRequire("ftB2S");
function $ee8cd37431c4074b$export$45c4bbf6e55bba1f(intl) {
    (0, $kVTHJ.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $ee8cd37431c4074b$export$b52f8d6fc0d47415 = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, (0, $ftB2S.DEFAULT_INTL_CONFIG)), {
    textComponent: $5FkrB.Fragment
});
function $ee8cd37431c4074b$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($5FkrB.Children.toArray(parts));
    };
}
function $ee8cd37431c4074b$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}


function $2b44d392c4a4ed5c$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// TODO: We should provide initial value here
var $2b44d392c4a4ed5c$var$IntlContext = $5FkrB.createContext(null);
var $2b44d392c4a4ed5c$var$IntlConsumer = $2b44d392c4a4ed5c$var$IntlContext.Consumer, $2b44d392c4a4ed5c$var$IntlProvider = $2b44d392c4a4ed5c$var$IntlContext.Provider;
var $2b44d392c4a4ed5c$export$2881499e37b75b9a = $2b44d392c4a4ed5c$var$IntlProvider;
var $2b44d392c4a4ed5c$export$841858b892ce1f4c = $2b44d392c4a4ed5c$var$IntlContext;
function $2b44d392c4a4ed5c$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $5FkrB.createElement($2b44d392c4a4ed5c$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $ee8cd37431c4074b$export$45c4bbf6e55bba1f)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $5FkrB.createElement(WrappedComponent, (0, $l2Z7B.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($2b44d392c4a4ed5c$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($knBeW)))($5FkrB.forwardRef(function(props, ref) {
        return $5FkrB.createElement(WithIntl, (0, $l2Z7B.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($knBeW)))(WithIntl, WrappedComponent);
}




var $htSVt = parcelRequire("htSVt");
var $ftB2S = parcelRequire("ftB2S");
var $2k5ES = parcelRequire("2k5ES");

var $b1zcR = parcelRequire("b1zcR");
function $1ec054bf15c60dc8$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $1ec054bf15c60dc8$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $b1zcR.isFormatXMLElementFn)(v) ? (0, $ee8cd37431c4074b$export$cfec03d26465fa63)(v) : v;
        return acc;
    }, {});
}
var $1ec054bf15c60dc8$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $1ec054bf15c60dc8$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $2k5ES.formatMessage).apply(void 0, (0, $l2Z7B.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $5FkrB.Children.toArray(chunks);
    return chunks;
};
var $1ec054bf15c60dc8$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $l2Z7B.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $1ec054bf15c60dc8$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $htSVt.createIntl)((0, $l2Z7B.__assign)((0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, (0, $ee8cd37431c4074b$export$b52f8d6fc0d47415)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    return (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, coreIntl), {
        formatMessage: $1ec054bf15c60dc8$var$formatMessage.bind(null, {
            locale: coreIntl.locale,
            timeZone: coreIntl.timeZone,
            fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
            formats: coreIntl.formats,
            defaultLocale: coreIntl.defaultLocale,
            defaultFormats: coreIntl.defaultFormats,
            messages: coreIntl.messages,
            onError: coreIntl.onError,
            defaultRichTextElements: defaultRichTextElements
        }, coreIntl.formatters)
    });
};
var $1ec054bf15c60dc8$var$IntlProvider = /** @class */ function(_super) {
    (0, $l2Z7B.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $ftB2S.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: $1ec054bf15c60dc8$export$7e4cbedfdd7b4c0d($1ec054bf15c60dc8$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $1ec054bf15c60dc8$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $1ec054bf15c60dc8$var$processIntlConfig(props);
        if (!(0, $ee8cd37431c4074b$export$d36bdfa510afb180)(prevConfig, config)) return {
            intl: $1ec054bf15c60dc8$export$7e4cbedfdd7b4c0d(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $ee8cd37431c4074b$export$45c4bbf6e55bba1f)(this.state.intl);
        return $5FkrB.createElement((0, $2b44d392c4a4ed5c$export$2881499e37b75b9a), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $ee8cd37431c4074b$export$b52f8d6fc0d47415);
    return IntlProvider;
}($5FkrB.PureComponent);
var $1ec054bf15c60dc8$export$2e2bcd8739ae039 = $1ec054bf15c60dc8$var$IntlProvider;



var $5FkrB = parcelRequire("5FkrB");

"use client";
//#region src/QueryClientProvider.tsx
/**
* The context that `useQueryClient` reads from. `QueryClientProvider` is the normal way to set it.
*/ const $a0fe68b284b4365c$export$da112d31b0149f31 = $5FkrB.createContext(void 0);
/**
* The `useQueryClient` hook returns the current `QueryClient` instance.
*
* @param queryClient - Use this to use a custom `QueryClient`. Otherwise, the one from the nearest context will
* be used.
* @returns The current `QueryClient` instance.
* @throws If no `queryClient` argument is passed and no `QueryClientProvider` is found in the component tree.
*/ const $a0fe68b284b4365c$export$22e77b9572c4fded = (queryClient)=>{
    const client = $5FkrB.useContext($a0fe68b284b4365c$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
/**
* Use the `QueryClientProvider` component to connect and provide a `QueryClient` to your application. Also
* calls `client.mount()`/`client.unmount()` as this component mounts/unmounts, which subscribes the client to
* focus/online events (resuming any paused mutations and refetching as needed when the app regains focus or
* comes back online).
*
* @returns The provided `children`, wrapped so they can read the `QueryClient` via `useQueryClient`.
*
* @example
* ```tsx
* import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
*
* const queryClient = new QueryClient()
*
* function App() {
*   return <QueryClientProvider client={queryClient}>...</QueryClientProvider>
* }
* ```
*/ const $a0fe68b284b4365c$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $5FkrB.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $faf30355a80342e4$exports.jsx)($a0fe68b284b4365c$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};



var $4Pn6z = parcelRequire("4Pn6z");
var $2kuK2 = parcelRequire("2kuK2");
var $gDiFE = parcelRequire("gDiFE");

var $9ztDu = parcelRequire("9ztDu");

var $d1G9Q = parcelRequire("d1G9Q");
/**
 * Actions represent the type of change to a location value.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#action
 */ var $c29d101a2cf08ade$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($c29d101a2cf08ade$export$e19cd5f9376f8cee || ($c29d101a2cf08ade$export$e19cd5f9376f8cee = {}));
var $c29d101a2cf08ade$var$readOnly = function(obj) {
    return obj;
};
function $c29d101a2cf08ade$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== 'undefined') console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
var $c29d101a2cf08ade$var$BeforeUnloadEventType = 'beforeunload';
var $c29d101a2cf08ade$var$HashChangeEventType = 'hashchange';
var $c29d101a2cf08ade$var$PopStateEventType = 'popstate';
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $c29d101a2cf08ade$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    var _options = options, _options$window = _options.window, window = _options$window === void 0 ? document.defaultView : _options$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $c29d101a2cf08ade$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation = getIndexAndLocation(), nextIndex = _getIndexAndLocation[0], nextLocation = _getIndexAndLocation[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($c29d101a2cf08ade$var$PopStateEventType, handlePop);
    var action = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation2 = getIndexAndLocation(), index = _getIndexAndLocation2[0], location = _getIndexAndLocation2[1];
    var listeners = $c29d101a2cf08ade$var$createEvents();
    var blockers = $c29d101a2cf08ade$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $d1G9Q.default)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function createHref(to) {
        return typeof to === 'string' ? to : $c29d101a2cf08ade$export$fe53371bee54353d(to);
    } // state defaults to `null` because `window.history.state` does
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $c29d101a2cf08ade$var$readOnly((0, $d1G9Q.default)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? $c29d101a2cf08ade$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $c29d101a2cf08ade$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation3 = getIndexAndLocation();
        index = _getIndexAndLocation3[0];
        location = _getIndexAndLocation3[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr[0], url = _getHistoryStateAndUr[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr2[0], url = _getHistoryStateAndUr2[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($c29d101a2cf08ade$var$BeforeUnloadEventType, $c29d101a2cf08ade$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($c29d101a2cf08ade$var$BeforeUnloadEventType, $c29d101a2cf08ade$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $c29d101a2cf08ade$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    var _options2 = options, _options2$window = _options2.window, window = _options2$window === void 0 ? document.defaultView : _options2$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _parsePath = $c29d101a2cf08ade$export$8ccf933b0513f8d0(window.location.hash.substr(1)), _parsePath$pathname = _parsePath.pathname, pathname = _parsePath$pathname === void 0 ? '/' : _parsePath$pathname, _parsePath$search = _parsePath.search, search = _parsePath$search === void 0 ? '' : _parsePath$search, _parsePath$hash = _parsePath.hash, hash = _parsePath$hash === void 0 ? '' : _parsePath$hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $c29d101a2cf08ade$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation4 = getIndexAndLocation(), nextIndex = _getIndexAndLocation4[0], nextLocation = _getIndexAndLocation4[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($c29d101a2cf08ade$var$PopStateEventType, handlePop); // popstate does not fire on hashchange in IE 11 and old (trident) Edge
    // https://developer.mozilla.org/de/docs/Web/API/Window/popstate_event
    window.addEventListener($c29d101a2cf08ade$var$HashChangeEventType, function() {
        var _getIndexAndLocation5 = getIndexAndLocation(), nextLocation = _getIndexAndLocation5[1]; // Ignore extraneous hashchange events.
        if ($c29d101a2cf08ade$export$fe53371bee54353d(nextLocation) !== $c29d101a2cf08ade$export$fe53371bee54353d(location)) handlePop();
    });
    var action = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation6 = getIndexAndLocation(), index = _getIndexAndLocation6[0], location = _getIndexAndLocation6[1];
    var listeners = $c29d101a2cf08ade$var$createEvents();
    var blockers = $c29d101a2cf08ade$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $d1G9Q.default)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function getBaseHref() {
        var base = document.querySelector('base');
        var href = '';
        if (base && base.getAttribute('href')) {
            var url = window.location.href;
            var hashIndex = url.indexOf('#');
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href;
    }
    function createHref(to) {
        return getBaseHref() + '#' + (typeof to === 'string' ? to : $c29d101a2cf08ade$export$fe53371bee54353d(to));
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $c29d101a2cf08ade$var$readOnly((0, $d1G9Q.default)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? $c29d101a2cf08ade$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $c29d101a2cf08ade$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation7 = getIndexAndLocation();
        index = _getIndexAndLocation7[0];
        location = _getIndexAndLocation7[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr3 = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr3[0], url = _getHistoryStateAndUr3[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr4 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr4[0], url = _getHistoryStateAndUr4[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($c29d101a2cf08ade$var$BeforeUnloadEventType, $c29d101a2cf08ade$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($c29d101a2cf08ade$var$BeforeUnloadEventType, $c29d101a2cf08ade$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#creatememoryhistory
 */ function $c29d101a2cf08ade$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options3 = options, _options3$initialEntr = _options3.initialEntries, initialEntries = _options3$initialEntr === void 0 ? [
        '/'
    ] : _options3$initialEntr, initialIndex = _options3.initialIndex;
    var entries = initialEntries.map(function(entry) {
        var location = $c29d101a2cf08ade$var$readOnly((0, $d1G9Q.default)({
            pathname: '/',
            search: '',
            hash: '',
            state: null,
            key: $c29d101a2cf08ade$var$createKey()
        }, typeof entry === 'string' ? $c29d101a2cf08ade$export$8ccf933b0513f8d0(entry) : entry));
        return location;
    });
    var index = $c29d101a2cf08ade$var$clamp(initialIndex == null ? entries.length - 1 : initialIndex, 0, entries.length - 1);
    var action = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Pop;
    var location = entries[index];
    var listeners = $c29d101a2cf08ade$var$createEvents();
    var blockers = $c29d101a2cf08ade$var$createEvents();
    function createHref(to) {
        return typeof to === 'string' ? to : $c29d101a2cf08ade$export$fe53371bee54353d(to);
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $c29d101a2cf08ade$var$readOnly((0, $d1G9Q.default)({
            pathname: location.pathname,
            search: '',
            hash: ''
        }, typeof to === 'string' ? $c29d101a2cf08ade$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $c29d101a2cf08ade$var$createKey()
        }));
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction, nextLocation) {
        action = nextAction;
        location = nextLocation;
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            applyTx(nextAction, nextLocation);
        }
    }
    function replace(to, state) {
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            entries[index] = nextLocation;
            applyTx(nextAction, nextLocation);
        }
    }
    function go(delta) {
        var nextIndex = $c29d101a2cf08ade$var$clamp(index + delta, 0, entries.length - 1);
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Pop;
        var nextLocation = entries[nextIndex];
        function retry() {
            go(delta);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index = nextIndex;
            applyTx(nextAction, nextLocation);
        }
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            return blockers.push(blocker);
        }
    };
    return history;
} ////////////////////////////////////////////////////////////////////////////////
// UTILS
////////////////////////////////////////////////////////////////////////////////
function $c29d101a2cf08ade$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
function $c29d101a2cf08ade$var$promptBeforeUnload(event) {
    // Cancel the event.
    event.preventDefault(); // Chrome (and legacy IE) requires returnValue to be set.
    event.returnValue = '';
}
function $c29d101a2cf08ade$var$createEvents() {
    var handlers = [];
    return {
        get length () {
            return handlers.length;
        },
        push: function push(fn) {
            handlers.push(fn);
            return function() {
                handlers = handlers.filter(function(handler) {
                    return handler !== fn;
                });
            };
        },
        call: function call(arg) {
            handlers.forEach(function(fn) {
                return fn && fn(arg);
            });
        }
    };
}
function $c29d101a2cf08ade$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createpath
 */ function $c29d101a2cf08ade$export$fe53371bee54353d(_ref) {
    var _ref$pathname = _ref.pathname, pathname = _ref$pathname === void 0 ? '/' : _ref$pathname, _ref$search = _ref.search, search = _ref$search === void 0 ? '' : _ref$search, _ref$hash = _ref.hash, hash = _ref$hash === void 0 ? '' : _ref$hash;
    if (search && search !== '?') pathname += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') pathname += hash.charAt(0) === '#' ? hash : '#' + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#parsepath
 */ function $c29d101a2cf08ade$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf('#');
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf('?');
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}



var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");


var $5FkrB = parcelRequire("5FkrB");

var $kqp0i = parcelRequire("kqp0i");

var $065a7de35543dd84$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $065a7de35543dd84$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $065a7de35543dd84$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $065a7de35543dd84$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $065a7de35543dd84$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $065a7de35543dd84$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $065a7de35543dd84$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $065a7de35543dd84$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $065a7de35543dd84$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $065a7de35543dd84$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $065a7de35543dd84$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $065a7de35543dd84$var$root = $065a7de35543dd84$var$freeGlobal || $065a7de35543dd84$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $065a7de35543dd84$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $065a7de35543dd84$var$objectToString = $065a7de35543dd84$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $065a7de35543dd84$var$nativeMax = Math.max, $065a7de35543dd84$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $065a7de35543dd84$var$now = function() {
    return $065a7de35543dd84$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $065a7de35543dd84$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($065a7de35543dd84$var$FUNC_ERROR_TEXT);
    wait = $065a7de35543dd84$var$toNumber(wait) || 0;
    if ($065a7de35543dd84$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $065a7de35543dd84$var$nativeMax($065a7de35543dd84$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $065a7de35543dd84$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $065a7de35543dd84$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($065a7de35543dd84$var$now());
    }
    function debounced() {
        var time = $065a7de35543dd84$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $065a7de35543dd84$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $065a7de35543dd84$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $065a7de35543dd84$var$isSymbol(value) {
    return typeof value == 'symbol' || $065a7de35543dd84$var$isObjectLike(value) && $065a7de35543dd84$var$objectToString.call(value) == $065a7de35543dd84$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $065a7de35543dd84$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($065a7de35543dd84$var$isSymbol(value)) return $065a7de35543dd84$var$NAN;
    if ($065a7de35543dd84$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $065a7de35543dd84$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($065a7de35543dd84$var$reTrim, '');
    var isBinary = $065a7de35543dd84$var$reIsBinary.test(value);
    return isBinary || $065a7de35543dd84$var$reIsOctal.test(value) ? $065a7de35543dd84$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $065a7de35543dd84$var$reIsBadHex.test(value) ? $065a7de35543dd84$var$NAN : +value;
}
$065a7de35543dd84$exports = $065a7de35543dd84$var$debounce;


var $0ae6c8b81570b5e1$exports = {};
/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize include="noop" exports="npm" -o ./foo`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * A no-operation function that returns `undefined` regardless of the
 * arguments it receives.
 *
 * @static
 * @memberOf _
 * @category Util
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.noop(object) === undefined;
 * // => true
 */ function $0ae6c8b81570b5e1$var$noop() {
// No operation performed.
}
$0ae6c8b81570b5e1$exports = $0ae6c8b81570b5e1$var$noop;


const $9d4782ee5a008819$var$hasWindow = ()=>typeof window !== 'undefined';
const $9d4782ee5a008819$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports)))
};
const $9d4782ee5a008819$var$getLocation = ()=>{
    // todo - don't force non-optional search and hash
    const { pathname: pathname = '', search: search = '', hash: hash = '' } = $9d4782ee5a008819$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $9d4782ee5a008819$var$createLegacyListener = (updateExposedLocation)=>{
    const node = document.querySelector('#content');
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ];
    // note: window.history.length is capped at 50 entries
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        const currentHref = window.location.href;
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return 'POP';
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return 'POP';
            }
            historyStack[historyStack.length - 1] = currentHref;
            return 'REPLACE';
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        prevHistoryLength = window.history.length;
        return 'PUSH';
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($065a7de35543dd84$exports)))(()=>{
        if (prevHref !== window.location.href) {
            const newLocation = $9d4782ee5a008819$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $9d4782ee5a008819$export$883c3f3b6c000133 = ()=>{
    let currentLocation = $9d4782ee5a008819$var$getLocation();
    let currentAction = 'PUSH';
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        get location () {
            return currentLocation;
        },
        get length () {
            return $9d4782ee5a008819$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        }
    }, $9d4782ee5a008819$var$hasWindow() ? {
        push: (path)=>window.location.assign(typeof path === 'string' ? path : (0, $c29d101a2cf08ade$export$fe53371bee54353d)(path || {})),
        replace: (path)=>window.history.replaceState({}, document.title, typeof path === 'string' ? path : (0, $c29d101a2cf08ade$export$fe53371bee54353d)(path || {})),
        goBack: ()=>window.history.back(),
        goForward: ()=>window.history.forward(),
        listen: $9d4782ee5a008819$var$createLegacyListener(updateExposedLocation),
        block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
        createHref: (location)=>(0, $c29d101a2cf08ade$export$fe53371bee54353d)(location)
    } : $9d4782ee5a008819$var$methodsPlaceholders);
};


/**
 * Tokenize input string.
 */ function $6a0a05a9da8f05fd$var$lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError("Pattern cannot start with \"?\" at ".concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $6a0a05a9da8f05fd$export$98e6a39c04603d36(str, options) {
    if (options === void 0) options = {};
    var tokens = $6a0a05a9da8f05fd$var$lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a, _b = options.delimiter, delimiter = _b === void 0 ? "/#?" : _b;
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    var isSafe = function(value) {
        for(var _i = 0, delimiter_1 = delimiter; _i < delimiter_1.length; _i++){
            var char = delimiter_1[_i];
            if (value.indexOf(char) > -1) return true;
        }
        return false;
    };
    var safePattern = function(prefix) {
        var prev = result[result.length - 1];
        var prevText = prefix || (prev && typeof prev === "string" ? prev : "");
        if (prev && !prevText) throw new TypeError("Must have text between two parameters, missing text after \"".concat(prev.name, "\""));
        if (!prevText || isSafe(prevText)) return "[^".concat($6a0a05a9da8f05fd$var$escapeString(delimiter), "]+?");
        return "(?:(?!".concat($6a0a05a9da8f05fd$var$escapeString(prevText), ")[^").concat($6a0a05a9da8f05fd$var$escapeString(delimiter), "])+?");
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || safePattern(prefix),
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? safePattern(prefix) : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $6a0a05a9da8f05fd$export$ef7acd7185315e22(str, options) {
    return $6a0a05a9da8f05fd$export$5b9bad9e403cf3d9($6a0a05a9da8f05fd$export$98e6a39c04603d36(str, options), options);
}
function $6a0a05a9da8f05fd$export$5b9bad9e403cf3d9(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = $6a0a05a9da8f05fd$var$flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError("Expected \"".concat(token.name, "\" to not repeat, but got an array"));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError("Expected \"".concat(token.name, "\" to not be empty"));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError("Expected all \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError("Expected \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"".concat(token.name, "\" to be ").concat(typeOfMessage));
        }
        return path;
    };
}
function $6a0a05a9da8f05fd$export$4659b591c19bdf3d(str, options) {
    var keys = [];
    var re = $6a0a05a9da8f05fd$export$71304158c7e35877(str, keys, options);
    return $6a0a05a9da8f05fd$export$968e97c88708237a(re, keys, options);
}
function $6a0a05a9da8f05fd$export$968e97c88708237a(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $6a0a05a9da8f05fd$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $6a0a05a9da8f05fd$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $6a0a05a9da8f05fd$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $6a0a05a9da8f05fd$var$arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return $6a0a05a9da8f05fd$export$71304158c7e35877(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), $6a0a05a9da8f05fd$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $6a0a05a9da8f05fd$var$stringToRegexp(path, keys, options) {
    return $6a0a05a9da8f05fd$export$9a9303716def6456($6a0a05a9da8f05fd$export$98e6a39c04603d36(path, options), keys, options);
}
function $6a0a05a9da8f05fd$export$9a9303716def6456(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat($6a0a05a9da8f05fd$var$escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat($6a0a05a9da8f05fd$var$escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += $6a0a05a9da8f05fd$var$escapeString(encode(token));
        else {
            var prefix = $6a0a05a9da8f05fd$var$escapeString(encode(token.prefix));
            var suffix = $6a0a05a9da8f05fd$var$escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else {
                    if (token.modifier === "+" || token.modifier === "*") throw new TypeError("Can not repeat \"".concat(token.name, "\" without a prefix and suffix"));
                    route += "(".concat(token.pattern, ")").concat(token.modifier);
                }
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, $6a0a05a9da8f05fd$var$flags(options));
}
function $6a0a05a9da8f05fd$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $6a0a05a9da8f05fd$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $6a0a05a9da8f05fd$var$arrayToRegexp(path, keys, options);
    return $6a0a05a9da8f05fd$var$stringToRegexp(path, keys, options);
}


var $deb424f7a075f200$exports = {};
'use strict';
var $5654768c7acee223$exports = {};
'use strict';
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ $5654768c7acee223$exports = function required(port, protocol) {
    protocol = protocol.split(':')[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case 'http':
        case 'ws':
            return port !== 80;
        case 'https':
        case 'wss':
            return port !== 443;
        case 'ftp':
            return port !== 21;
        case 'gopher':
            return port !== 70;
        case 'file':
            return false;
    }
    return port !== 0;
};


var $3092e7c4432aeccb$exports = {};
$parcel$export($3092e7c4432aeccb$exports, "stringify", () => $3092e7c4432aeccb$export$fac44ee5b035f737, (v) => $3092e7c4432aeccb$export$fac44ee5b035f737 = v);
$parcel$export($3092e7c4432aeccb$exports, "parse", () => $3092e7c4432aeccb$export$98e6a39c04603d36, (v) => $3092e7c4432aeccb$export$98e6a39c04603d36 = v);
//
// Expose the module.
//
var $3092e7c4432aeccb$export$fac44ee5b035f737;
var $3092e7c4432aeccb$export$98e6a39c04603d36;
'use strict';
var $3092e7c4432aeccb$var$has = Object.prototype.hasOwnProperty, $3092e7c4432aeccb$var$undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $3092e7c4432aeccb$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function $3092e7c4432aeccb$var$encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function $3092e7c4432aeccb$var$querystring(query) {
    var parser = /([^=?#&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = $3092e7c4432aeccb$var$decode(part[1]), value = $3092e7c4432aeccb$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function $3092e7c4432aeccb$var$querystringify(obj, prefix) {
    prefix = prefix || '';
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ('string' !== typeof prefix) prefix = '?';
    for(key in obj)if ($3092e7c4432aeccb$var$has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === $3092e7c4432aeccb$var$undef || isNaN(value))) value = '';
        key = $3092e7c4432aeccb$var$encode(key);
        value = $3092e7c4432aeccb$var$encode(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + '=' + value);
    }
    return pairs.length ? prefix + pairs.join('&') : '';
}
$3092e7c4432aeccb$export$fac44ee5b035f737 = $3092e7c4432aeccb$var$querystringify;
$3092e7c4432aeccb$export$98e6a39c04603d36 = $3092e7c4432aeccb$var$querystring;


var $deb424f7a075f200$var$controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, $deb424f7a075f200$var$CRHTLF = /[\n\r\t]/g, $deb424f7a075f200$var$slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, $deb424f7a075f200$var$port = /:\d+$/, $deb424f7a075f200$var$protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, $deb424f7a075f200$var$windowsDriveLetter = /^[a-zA-Z]:/;
/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */ function $deb424f7a075f200$var$trimLeft(str) {
    return (str ? str : '').toString().replace($deb424f7a075f200$var$controlOrWhitespace, '');
}
/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */ var $deb424f7a075f200$var$rules = [
    [
        '#',
        'hash'
    ],
    [
        '?',
        'query'
    ],
    function sanitize(address, url) {
        return $deb424f7a075f200$var$isSpecial(url.protocol) ? address.replace(/\\/g, '/') : address;
    },
    [
        '/',
        'pathname'
    ],
    [
        '@',
        'auth',
        1
    ],
    [
        NaN,
        'host',
        undefined,
        1,
        1
    ],
    [
        /:(\d*)$/,
        'port',
        undefined,
        1
    ],
    [
        NaN,
        'hostname',
        undefined,
        1,
        1
    ] // Set left over.
];
/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */ var $deb424f7a075f200$var$ignore = {
    hash: 1,
    query: 1
};
/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */ function $deb424f7a075f200$var$lolcation(loc) {
    var globalVar;
    if (typeof window !== 'undefined') globalVar = window;
    else if (typeof $parcel$global !== 'undefined') globalVar = $parcel$global;
    else if (typeof self !== 'undefined') globalVar = self;
    else globalVar = {};
    var location = globalVar.location || {};
    loc = loc || location;
    var finaldestination = {}, type = typeof loc, key;
    if ('blob:' === loc.protocol) finaldestination = new $deb424f7a075f200$var$Url(unescape(loc.pathname), {});
    else if ('string' === type) {
        finaldestination = new $deb424f7a075f200$var$Url(loc, {});
        for(key in $deb424f7a075f200$var$ignore)delete finaldestination[key];
    } else if ('object' === type) {
        for(key in loc){
            if (key in $deb424f7a075f200$var$ignore) continue;
            finaldestination[key] = loc[key];
        }
        if (finaldestination.slashes === undefined) finaldestination.slashes = $deb424f7a075f200$var$slashes.test(loc.href);
    }
    return finaldestination;
}
/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */ function $deb424f7a075f200$var$isSpecial(scheme) {
    return scheme === 'file:' || scheme === 'ftp:' || scheme === 'http:' || scheme === 'https:' || scheme === 'ws:' || scheme === 'wss:';
}
/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */ /**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */ function $deb424f7a075f200$var$extractProtocol(address, location) {
    address = $deb424f7a075f200$var$trimLeft(address);
    address = address.replace($deb424f7a075f200$var$CRHTLF, '');
    location = location || {};
    var match = $deb424f7a075f200$var$protocolre.exec(address);
    var protocol = match[1] ? match[1].toLowerCase() : '';
    var forwardSlashes = !!match[2];
    var otherSlashes = !!match[3];
    var slashesCount = 0;
    var rest;
    if (forwardSlashes) {
        if (otherSlashes) {
            rest = match[2] + match[3] + match[4];
            slashesCount = match[2].length + match[3].length;
        } else {
            rest = match[2] + match[4];
            slashesCount = match[2].length;
        }
    } else if (otherSlashes) {
        rest = match[3] + match[4];
        slashesCount = match[3].length;
    } else rest = match[4];
    if (protocol === 'file:') {
        if (slashesCount >= 2) rest = rest.slice(2);
    } else if ($deb424f7a075f200$var$isSpecial(protocol)) rest = match[4];
    else if (protocol) {
        if (forwardSlashes) rest = rest.slice(2);
    } else if (slashesCount >= 2 && $deb424f7a075f200$var$isSpecial(location.protocol)) rest = match[4];
    return {
        protocol: protocol,
        slashes: forwardSlashes || $deb424f7a075f200$var$isSpecial(protocol),
        slashesCount: slashesCount,
        rest: rest
    };
}
/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */ function $deb424f7a075f200$var$resolve(relative, base) {
    if (relative === '') return base;
    var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/')), i = path.length, last = path[i - 1], unshift = false, up = 0;
    while(i--){
        if (path[i] === '.') path.splice(i, 1);
        else if (path[i] === '..') {
            path.splice(i, 1);
            up++;
        } else if (up) {
            if (i === 0) unshift = true;
            path.splice(i, 1);
            up--;
        }
    }
    if (unshift) path.unshift('');
    if (last === '.' || last === '..') path.push('');
    return path.join('/');
}
/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */ function $deb424f7a075f200$var$Url(address, location, parser) {
    address = $deb424f7a075f200$var$trimLeft(address);
    address = address.replace($deb424f7a075f200$var$CRHTLF, '');
    if (!(this instanceof $deb424f7a075f200$var$Url)) return new $deb424f7a075f200$var$Url(address, location, parser);
    var relative, extracted, parse, instruction, index, key, instructions = $deb424f7a075f200$var$rules.slice(), type = typeof location, url = this, i = 0;
    //
    // The following if statements allows this module two have compatibility with
    // 2 different API:
    //
    // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
    //    where the boolean indicates that the query string should also be parsed.
    //
    // 2. The `URL` interface of the browser which accepts a URL, object as
    //    arguments. The supplied object will be used as default values / fall-back
    //    for relative paths.
    //
    if ('object' !== type && 'string' !== type) {
        parser = location;
        location = null;
    }
    if (parser && 'function' !== typeof parser) parser = $3092e7c4432aeccb$exports.parse;
    location = $deb424f7a075f200$var$lolcation(location);
    //
    // Extract protocol information before running the instructions.
    //
    extracted = $deb424f7a075f200$var$extractProtocol(address || '', location);
    relative = !extracted.protocol && !extracted.slashes;
    url.slashes = extracted.slashes || relative && location.slashes;
    url.protocol = extracted.protocol || location.protocol || '';
    address = extracted.rest;
    //
    // When the authority component is absent the URL starts with a path
    // component.
    //
    if (extracted.protocol === 'file:' && (extracted.slashesCount !== 2 || $deb424f7a075f200$var$windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !$deb424f7a075f200$var$isSpecial(url.protocol))) instructions[3] = [
        /(.*)/,
        'pathname'
    ];
    for(; i < instructions.length; i++){
        instruction = instructions[i];
        if (typeof instruction === 'function') {
            address = instruction(address, url);
            continue;
        }
        parse = instruction[0];
        key = instruction[1];
        if (parse !== parse) url[key] = address;
        else if ('string' === typeof parse) {
            index = parse === '@' ? address.lastIndexOf(parse) : address.indexOf(parse);
            if (~index) {
                if ('number' === typeof instruction[2]) {
                    url[key] = address.slice(0, index);
                    address = address.slice(index + instruction[2]);
                } else {
                    url[key] = address.slice(index);
                    address = address.slice(0, index);
                }
            }
        } else if (index = parse.exec(address)) {
            url[key] = index[1];
            address = address.slice(0, index.index);
        }
        url[key] = url[key] || (relative && instruction[3] ? location[key] || '' : '');
        //
        // Hostname, host and protocol should be lowercased so they can be used to
        // create a proper `origin`.
        //
        if (instruction[4]) url[key] = url[key].toLowerCase();
    }
    //
    // Also parse the supplied query string in to an object. If we're supplied
    // with a custom parser as function use that instead of the default build-in
    // parser.
    //
    if (parser) url.query = parser(url.query);
    //
    // If the URL is relative, resolve the pathname against the base URL.
    //
    if (relative && location.slashes && url.pathname.charAt(0) !== '/' && (url.pathname !== '' || location.pathname !== '')) url.pathname = $deb424f7a075f200$var$resolve(url.pathname, location.pathname);
    //
    // Default to a / for pathname if none exists. This normalizes the URL
    // to always have a /
    //
    if (url.pathname.charAt(0) !== '/' && $deb424f7a075f200$var$isSpecial(url.protocol)) url.pathname = '/' + url.pathname;
    //
    // We should not add port numbers if they are already the default port number
    // for a given protocol. As the host also contains the port number we're going
    // override it with the hostname which contains no port number.
    //
    if (!$5654768c7acee223$exports(url.port, url.protocol)) {
        url.host = url.hostname;
        url.port = '';
    }
    //
    // Parse down the `auth` for the username and password.
    //
    url.username = url.password = '';
    if (url.auth) {
        index = url.auth.indexOf(':');
        if (~index) {
            url.username = url.auth.slice(0, index);
            url.username = encodeURIComponent(decodeURIComponent(url.username));
            url.password = url.auth.slice(index + 1);
            url.password = encodeURIComponent(decodeURIComponent(url.password));
        } else url.username = encodeURIComponent(decodeURIComponent(url.auth));
        url.auth = url.password ? url.username + ':' + url.password : url.username;
    }
    url.origin = url.protocol !== 'file:' && $deb424f7a075f200$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    //
    // The href is just the compiled result.
    //
    url.href = url.toString();
}
/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */ function $deb424f7a075f200$var$set(part, value, fn) {
    var url = this;
    switch(part){
        case 'query':
            if ('string' === typeof value && value.length) value = (fn || $3092e7c4432aeccb$exports.parse)(value);
            url[part] = value;
            break;
        case 'port':
            url[part] = value;
            if (!$5654768c7acee223$exports(value, url.protocol)) {
                url.host = url.hostname;
                url[part] = '';
            } else if (value) url.host = url.hostname + ':' + value;
            break;
        case 'hostname':
            url[part] = value;
            if (url.port) value += ':' + url.port;
            url.host = value;
            break;
        case 'host':
            url[part] = value;
            if ($deb424f7a075f200$var$port.test(value)) {
                value = value.split(':');
                url.port = value.pop();
                url.hostname = value.join(':');
            } else {
                url.hostname = value;
                url.port = '';
            }
            break;
        case 'protocol':
            url.protocol = value.toLowerCase();
            url.slashes = !fn;
            break;
        case 'pathname':
        case 'hash':
            if (value) {
                var char = part === 'pathname' ? '/' : '#';
                url[part] = value.charAt(0) !== char ? char + value : value;
            } else url[part] = value;
            break;
        case 'username':
        case 'password':
            url[part] = encodeURIComponent(value);
            break;
        case 'auth':
            var index = value.indexOf(':');
            if (~index) {
                url.username = value.slice(0, index);
                url.username = encodeURIComponent(decodeURIComponent(url.username));
                url.password = value.slice(index + 1);
                url.password = encodeURIComponent(decodeURIComponent(url.password));
            } else url.username = encodeURIComponent(decodeURIComponent(value));
    }
    for(var i = 0; i < $deb424f7a075f200$var$rules.length; i++){
        var ins = $deb424f7a075f200$var$rules[i];
        if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
    }
    url.auth = url.password ? url.username + ':' + url.password : url.username;
    url.origin = url.protocol !== 'file:' && $deb424f7a075f200$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    url.href = url.toString();
    return url;
}
/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */ function $deb424f7a075f200$var$toString(stringify) {
    if (!stringify || 'function' !== typeof stringify) stringify = $3092e7c4432aeccb$exports.stringify;
    var query, url = this, host = url.host, protocol = url.protocol;
    if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';
    var result = protocol + (url.protocol && url.slashes || $deb424f7a075f200$var$isSpecial(url.protocol) ? '//' : '');
    if (url.username) {
        result += url.username;
        if (url.password) result += ':' + url.password;
        result += '@';
    } else if (url.password) {
        result += ':' + url.password;
        result += '@';
    } else if (url.protocol !== 'file:' && $deb424f7a075f200$var$isSpecial(url.protocol) && !host && url.pathname !== '/') //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += '@';
    //
    // Trailing colon is removed from `url.host` when it is parsed. If it still
    // ends with a colon, then add back the trailing colon that was removed. This
    // prevents an invalid URL from being transformed into a valid one.
    //
    if (host[host.length - 1] === ':' || $deb424f7a075f200$var$port.test(url.hostname) && !url.port) host += ':';
    result += host + url.pathname;
    query = 'object' === typeof url.query ? stringify(url.query) : url.query;
    if (query) result += '?' !== query.charAt(0) ? '?' + query : query;
    if (url.hash) result += url.hash;
    return result;
}
$deb424f7a075f200$var$Url.prototype = {
    set: $deb424f7a075f200$var$set,
    toString: $deb424f7a075f200$var$toString
};
//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
$deb424f7a075f200$var$Url.extractProtocol = $deb424f7a075f200$var$extractProtocol;
$deb424f7a075f200$var$Url.location = $deb424f7a075f200$var$lolcation;
$deb424f7a075f200$var$Url.trimLeft = $deb424f7a075f200$var$trimLeft;
$deb424f7a075f200$var$Url.qs = $3092e7c4432aeccb$exports;
$deb424f7a075f200$exports = $deb424f7a075f200$var$Url;


function $768d36b334678dfa$export$37e0729cc751960b(pattern = '/', options = {}) {
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $deb424f7a075f200$exports.qs).stringify(query, true);
    const pathname = pattern === '/' ? pattern : (0, $6a0a05a9da8f05fd$export$ef7acd7185315e22)(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ''
    };
}



const $de4d1e4f61a87867$export$82476f982757e71e = (pattern = '/', params)=>pattern === '/' ? pattern : (0, $6a0a05a9da8f05fd$export$ef7acd7185315e22)(pattern)(params);


/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $3ZMUU = parcelRequire("3ZMUU");
const $f9f42a63082f8b8d$var$isJsDomEnvironment = ()=>{
    var _navigator, _navigator2;
    return window.name === 'nodejs' || ((_navigator = navigator) == null ? void 0 : _navigator.userAgent.includes('Node.js')) || ((_navigator2 = navigator) == null ? void 0 : _navigator2.userAgent.includes('jsdom'));
};
const $f9f42a63082f8b8d$export$455cc18296abe008 = ()=>{
    if (typeof window === 'undefined' || typeof $3ZMUU !== 'undefined' && $3ZMUU.versions != null && $3ZMUU.versions.node != null) return true;
    if ($f9f42a63082f8b8d$var$isJsDomEnvironment()) return true;
    return false;
};




var $kqp0i = parcelRequire("kqp0i");
// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

const $e7a9aee364b5805f$var$cache = {};
const $e7a9aee364b5805f$var$cacheLimit = 10000;
let $e7a9aee364b5805f$var$cacheCount = 0;
function $e7a9aee364b5805f$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $e7a9aee364b5805f$var$cache[cacheKey] || ($e7a9aee364b5805f$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $6a0a05a9da8f05fd$export$71304158c7e35877)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($e7a9aee364b5805f$var$cacheCount < $e7a9aee364b5805f$var$cacheLimit) {
        pathCache[path] = result;
        $e7a9aee364b5805f$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $e7a9aee364b5805f$var$matchPath(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $e7a9aee364b5805f$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === '/' && url === '' ? '/' : url,
            isExact: // the matched portion of the URL
            isExact,
            // whether or not we matched exactly
            params: keys.reduce((memo, key, index)=>{
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $e7a9aee364b5805f$export$2e2bcd8739ae039 = $e7a9aee364b5805f$var$matchPath;



var $kqp0i = parcelRequire("kqp0i");
/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $3dd31f20fffa4bf7$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, pathMatch, {
        query: queryMatch
    }) : null;
}
var $3dd31f20fffa4bf7$export$2e2bcd8739ae039 = $3dd31f20fffa4bf7$var$matchQuery;


/* This should match what react-router does to compute a root match. */ const $f9b6403fcc99d44d$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $f9b6403fcc99d44d$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $e7a9aee364b5805f$export$2e2bcd8739ae039)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $f9b6403fcc99d44d$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $3dd31f20fffa4bf7$export$2e2bcd8739ae039)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, pathMatch, {
        query: {}
    });
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $f9b6403fcc99d44d$export$2e2bcd8739ae039 = $f9b6403fcc99d44d$var$execRouteMatching;


const $5945d60cd4066b5d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $5945d60cd4066b5d$var$MAX_CACHE_SIZE = 1000;
function $5945d60cd4066b5d$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!$5945d60cd4066b5d$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $5945d60cd4066b5d$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($5945d60cd4066b5d$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $5945d60cd4066b5d$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $5945d60cd4066b5d$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};


/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $e7f860d2e0e9373c$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    // if navigating to to `/` or just basePath, then do not append basePath
    const updatedBasePath = [
        '/',
        basePath
    ].includes(pathname) ? '' : basePath;
    const queryParamObject = typeof queryParams === 'string' ? (0, $deb424f7a075f200$exports.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $5945d60cd4066b5d$export$f594abf16a5ad948).get(pathname, queryParamObject, updatedBasePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $f9b6403fcc99d44d$export$2e2bcd8739ae039)(routes[i], pathname, queryParamObject, updatedBasePath);
        if (matchedRoute) {
            (0, $5945d60cd4066b5d$export$f594abf16a5ad948).set(pathname, queryParamObject, updatedBasePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $e7f860d2e0e9373c$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>$e7f860d2e0e9373c$var$matchRoute(routes, pathname, queryParams, basePath);
const $e7f860d2e0e9373c$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    $e7f860d2e0e9373c$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $e7f860d2e0e9373c$export$2e2bcd8739ae039 = (routes, pathname, queryParams, basePath = '')=>$e7f860d2e0e9373c$var$matchRoute(routes, pathname, queryParams, basePath);





const $0100e5f4b4767f2b$export$7c22f8f9552f689e = {
    pathname: '',
    search: '',
    hash: ''
};
const $0100e5f4b4767f2b$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: '',
    url: '',
    query: {}
};
const $0100e5f4b4767f2b$export$4eadc79233226325 = {
    path: '',
    component: ()=>null,
    name: ''
};
const $0100e5f4b4767f2b$export$39607c9878cf5148 = (0, $9d4782ee5a008819$export$883c3f3b6c000133)();
const $0100e5f4b4767f2b$export$1515254c8c90bebb = {
    location: $0100e5f4b4767f2b$export$7c22f8f9552f689e,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    listen: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    block: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    createHref: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports)))
};
const $0100e5f4b4767f2b$export$fa440ddf675c8a93 = 'POP';




const $10a8bc47d57825ec$export$faed15f35ddc6f99 = (route, options = {})=>{
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    const pathname = (0, $de4d1e4f61a87867$export$82476f982757e71e)(route.path, params);
    const matchedRoute = (0, $e7f860d2e0e9373c$export$2e2bcd8739ae039)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $0100e5f4b4767f2b$export$2de13e891a662beb),
        query: query
    };
};
const $10a8bc47d57825ec$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = '' } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $deb424f7a075f200$exports.qs).parse(search);
    const matchedRoute = (0, $e7f860d2e0e9373c$export$2e2bcd8739ae039)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $0100e5f4b4767f2b$export$4eadc79233226325),
        match: matchedRoute ? matchedRoute.match : (0, $0100e5f4b4767f2b$export$2de13e891a662beb)
    };
};


const $31916272644d9021$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $31916272644d9021$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $31916272644d9021$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $31916272644d9021$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);





var $kqp0i = parcelRequire("kqp0i");


var $6lPP6 = parcelRequire("6lPP6");
var $gNUZr = parcelRequire("gNUZr");
var $dWq0h = parcelRequire("dWq0h");
var $1uA8D = parcelRequire("1uA8D");
var $8i0MQ = parcelRequire("8i0MQ");




const $c21e9538f0e35012$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
const $c21e9538f0e35012$var$addLeadingSlash = (path)=>path.charAt(0) === '/' ? path : '/' + path;
const $c21e9538f0e35012$export$b8ce2e8154d1dff1 = (path, prefix = '')=>{
    if (prefix) {
        prefix = $c21e9538f0e35012$var$stripTrailingSlash(prefix);
        prefix = $c21e9538f0e35012$var$addLeadingSlash(prefix);
        path = $c21e9538f0e35012$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $c21e9538f0e35012$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp('^([a-z]+://|//)', 'i');
    return regex.test(path);
};
const $c21e9538f0e35012$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== 'string' || !$c21e9538f0e35012$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($deb424f7a075f200$exports)))(path).hostname;
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($deb424f7a075f200$exports)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $c21e9538f0e35012$export$ae9fda833d91ed65 = (path, prefix = '')=>{
    if (typeof path !== 'string') return path;
    if (!$c21e9538f0e35012$export$e83e3719fc818ee5(path)) {
        path = $c21e9538f0e35012$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($deb424f7a075f200$exports)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $c21e9538f0e35012$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $deb424f7a075f200$exports.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $c21e9538f0e35012$export$9ae1c7c875ef309d = (location)=>{
    return `${location.pathname}${location.search}${location.hash}`;
};
const $c21e9538f0e35012$export$c9237620ff7fdf7c = ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
    const sameRoute = (0, $31916272644d9021$export$5997e70fc4543270)({
        prevContextMatch: prevContext.match,
        nextContextMatch: context.match
    });
    // keep old behaviour for Resources plugin
    // load Route only if path/query/params changed, and ignore the rest of query-params
    const defaultShouldReload = pluginId === 'resources-plugin' || !sameRoute;
    if (context.route === prevContext.route && context.route.EXPERIMENTAL__shouldReload) {
        const routeChoice = context.route.EXPERIMENTAL__shouldReload({
            context: context,
            prevContext: prevContext,
            pluginId: pluginId,
            defaultShouldReload: defaultShouldReload
        });
        if (typeof routeChoice === 'boolean') return routeChoice;
    }
    return defaultShouldReload;
};


const $1ddaa6502d719738$export$36d128238e6b60f5 = {
    action: (0, $0100e5f4b4767f2b$export$fa440ddf675c8a93),
    basePath: '',
    location: (0, $0100e5f4b4767f2b$export$39607c9878cf5148).location,
    history: (0, $0100e5f4b4767f2b$export$39607c9878cf5148),
    match: (0, $0100e5f4b4767f2b$export$2de13e891a662beb),
    onPrefetch: undefined,
    query: {},
    route: (0, $0100e5f4b4767f2b$export$4eadc79233226325),
    routes: [],
    unlisten: null,
    plugins: []
};
const $1ddaa6502d719738$var$actions = {
    /**
   * Bootstraps the store with initial data.
   *
   */ bootstrapStore: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { basePath: basePath = '', history: history, initialRoute: initialRoute, onPrefetch: onPrefetch, routes: routes, plugins: plugins } = props;
            const routerContext = (0, $10a8bc47d57825ec$export$a0bd0313cbeabd49)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, routerContext, {
                basePath: basePath,
                history: history,
                onPrefetch: onPrefetch,
                routes: routes,
                location: history.location,
                action: history.action,
                plugins: plugins
            }));
            if (!(0, $f9f42a63082f8b8d$export$455cc18296abe008)()) dispatch($1ddaa6502d719738$var$actions.listen());
        },
    /**
   * Starts listening to browser history and sets the unlisten function in state.
   * Will request route resources on route change.
   *
   */ listen: ()=>({ getState: getState, setState: setState })=>{
            const { history: history, unlisten: unlisten } = getState();
            if (unlisten) unlisten();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { plugins: plugins, routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery } = getState();
                const nextContext = (0, $10a8bc47d57825ec$export$a0bd0313cbeabd49)(routes, {
                    location: location,
                    basePath: basePath
                });
                const prevContext = {
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                };
                const shouldReloadByPlugin = new Map(plugins.map((plugin)=>[
                        plugin.id,
                        (0, $c21e9538f0e35012$export$c9237620ff7fdf7c)({
                            context: nextContext,
                            prevContext: prevContext,
                            pluginId: plugin.id
                        })
                    ]));
                /* Explicitly batch update
       * as we need resources cleaned + route changed + resource fetch started together
       * If we do not batch, React might be re-render when route changes but resource
       * fetching has not started yet, making the app render with data null */ (0, $6lPP6.batch)(()=>{
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.beforeRouteLoad == null || p.beforeRouteLoad({
                            context: prevContext,
                            nextContext: nextContext
                        });
                    });
                    setState((0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, nextContext, {
                        location: location,
                        action: action
                    }));
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.routeLoad == null || p.routeLoad({
                            context: nextContext,
                            prevContext: prevContext
                        });
                    });
                });
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $c21e9538f0e35012$export$2fa6dede99f181e5)(path)) window.location.assign(path);
            else history.push((0, $c21e9538f0e35012$export$ae9fda833d91ed65)(path, basePath), state);
        },
    pushTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $768d36b334678dfa$export$37e0729cc751960b)(route.path, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, attributes, {
                basePath: basePath
            }));
            (0, $e7f860d2e0e9373c$export$4e76f1d455ef7c95)(route, location.pathname, attributes.query, basePath);
            history.push(location, attributes == null ? void 0 : attributes.state);
        },
    replace: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $c21e9538f0e35012$export$2fa6dede99f181e5)(path)) window.location.replace(path);
            else history.replace((0, $c21e9538f0e35012$export$ae9fda833d91ed65)(path, basePath), state);
        },
    replaceTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $768d36b334678dfa$export$37e0729cc751960b)(route.path, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, attributes, {
                basePath: basePath
            }));
            (0, $e7f860d2e0e9373c$export$4e76f1d455ef7c95)(route, location.pathname, attributes.query, basePath);
            history.replace(location, attributes == null ? void 0 : attributes.state);
        },
    goBack: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goBack(), history@5 uses back()
            if ('goBack' in history) history.goBack();
            else if ('back' in history) history.back();
            else throw new Error('History does not support goBack');
        },
    goForward: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goForward(), history@5 uses forward()
            if ('goForward' in history) history.goForward();
            else if ('forward' in history) history.forward();
            else throw new Error('History does not support goForward');
        },
    registerBlock: (blocker)=>({ getState: getState })=>{
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState: getState })=>{
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>({ getState: getState })=>{
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, existingQueryParams, params);
            // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $c21e9538f0e35012$export$92377f461a797888)(location, existingQueryParams);
            const updatedPath = (0, $c21e9538f0e35012$export$92377f461a797888)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, existingPathParams, params);
            const updatedPath = (0, $de4d1e4f61a87867$export$82476f982757e71e)(pathWithBasePath, updatedPathParams);
            const updatedLocation = (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, location, {
                pathname: updatedPath
            });
            const existingRelativePath = (0, $c21e9538f0e35012$export$9ae1c7c875ef309d)(location);
            const updatedRelativePath = (0, $c21e9538f0e35012$export$9ae1c7c875ef309d)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        },
    loadPlugins: ()=>({ getState: getState })=>{
            const { plugins: plugins, match: match, query: query, route: route } = getState();
            plugins.forEach((p)=>p.routeLoad == null ? void 0 : p.routeLoad({
                    context: {
                        match: match,
                        query: query,
                        route: route
                    }
                }));
        },
    prefetchRoute: (path, nextContext)=>({ getState: getState })=>{
            const { plugins: plugins, routes: routes, basePath: basePath, onPrefetch: onPrefetch } = getState();
            const { route: route, match: match, query: query } = $1ddaa6502d719738$export$ebf37f7e180b13a9();
            if (!nextContext && !(0, $c21e9538f0e35012$export$2fa6dede99f181e5)(path)) {
                const location = (0, $c29d101a2cf08ade$export$8ccf933b0513f8d0)((0, $c21e9538f0e35012$export$ae9fda833d91ed65)(path, basePath));
                nextContext = (0, $10a8bc47d57825ec$export$a0bd0313cbeabd49)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            (0, $6lPP6.batch)(()=>{
                plugins.forEach((p)=>p.routePrefetch == null ? void 0 : p.routePrefetch({
                        context: {
                            route: route,
                            match: match,
                            query: query
                        },
                        nextContext: nextLocationContext
                    }));
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        }
};
const $1ddaa6502d719738$export$1cf0ecab63b1963c = (0, $1uA8D.createStore)({
    initialState: $1ddaa6502d719738$export$36d128238e6b60f5,
    actions: $1ddaa6502d719738$var$actions,
    name: 'router'
});
const $1ddaa6502d719738$export$d6b817abe7a77ea5 = (0, $dWq0h.createContainer)($1ddaa6502d719738$export$1cf0ecab63b1963c, {
    displayName: 'RouterContainer',
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($1ddaa6502d719738$var$actions.bootstrapStore(props));
            !(0, $f9f42a63082f8b8d$export$455cc18296abe008)() && dispatch($1ddaa6502d719738$var$actions.loadPlugins());
        },
    onCleanup: ()=>(state)=>{
            if (!(0, $f9f42a63082f8b8d$export$455cc18296abe008)()) {
                const { unlisten: unlisten } = state.getState();
                unlisten && unlisten();
            }
        }
});
const $1ddaa6502d719738$export$9569010eab09ae9e = (0, $gNUZr.createHook)($1ddaa6502d719738$export$1cf0ecab63b1963c);
const $1ddaa6502d719738$export$ada49399abf7a3a1 = (0, $gNUZr.createActionsHook)($1ddaa6502d719738$export$1cf0ecab63b1963c);
function $1ddaa6502d719738$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $gNUZr.createHook)($1ddaa6502d719738$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector(...args) {
        return useHook(...args)[0];
    };
}
const $1ddaa6502d719738$export$5ccad187366c8494 = ()=>// @ts-ignore calling `getStore` without providing a scopeId
    (0, $8i0MQ.defaultRegistry).getStore($1ddaa6502d719738$export$1cf0ecab63b1963c);
const $1ddaa6502d719738$export$ebf37f7e180b13a9 = ()=>$1ddaa6502d719738$export$5ccad187366c8494().storeState.getState();


const $b421c015f5018cd0$export$9a302a45f65d0572 = (0, $1ddaa6502d719738$export$9569010eab09ae9e);


class $d60bad8df7964b6c$var$Redirector extends (0, $5FkrB.Component) {
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = typeof to === 'object' ? 'path' in to ? (0, $c29d101a2cf08ade$export$fe53371bee54353d)((0, $768d36b334678dfa$export$37e0729cc751960b)(to.path, routeAttributes)) : (0, $c29d101a2cf08ade$export$fe53371bee54353d)(to) : to;
        const currentPath = (0, $c29d101a2cf08ade$export$fe53371bee54353d)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d60bad8df7964b6c$var$Redirector, "defaultProps", {
    push: false
});
const $d60bad8df7964b6c$export$2d8d895a0a0f636e = (props)=>{
    const [{ location: location }, actions] = (0, $b421c015f5018cd0$export$9a302a45f65d0572)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($d60bad8df7964b6c$var$Redirector, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        actions: actions,
        location: location
    }, props));
};



var $kqp0i = parcelRequire("kqp0i");


var $5FkrB = parcelRequire("5FkrB");

const $ddc1dbf2b1f7581e$export$55185c17a0fcbe46 = ({ basePath: basePath, children: children, history: history, initialRoute: initialRoute, isGlobal: isGlobal = true, plugins: plugins, onPrefetch: onPrefetch, routes: routes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1ddaa6502d719738$export$d6b817abe7a77ea5), {
        basePath: basePath,
        history: history,
        initialRoute: initialRoute,
        isGlobal: isGlobal,
        onPrefetch: onPrefetch,
        plugins: plugins != null ? plugins : [],
        routes: routes
    }, children);
};
function $ddc1dbf2b1f7581e$export$ae46f04cfaffe093(props) {
    var _props$plugins;
    const history = (0, $5FkrB.useMemo)(()=>(0, $c29d101a2cf08ade$export$2b76ad033c6e6d08)(props.location ? {
            initialEntries: [
                props.location
            ]
        } : {}), [
        props.location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($ddc1dbf2b1f7581e$export$55185c17a0fcbe46, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        history: history,
        isGlobal: false,
        plugins: (_props$plugins = props == null ? void 0 : props.plugins) != null ? _props$plugins : []
    }));
}



var $5FkrB = parcelRequire("5FkrB");

const $7ffd4dfc86b29f7d$export$402e82ff1b20594b = (0, $1ddaa6502d719738$export$ada49399abf7a3a1);


const $f38a5098ae6c30bf$export$b371fa9cf762ad06 = ({ children: children })=>{
    const actions = (0, $7ffd4dfc86b29f7d$export$402e82ff1b20594b)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children(actions));
};
$f38a5098ae6c30bf$export$b371fa9cf762ad06.displayName = 'RouterActions';



var $19a0g = parcelRequire("19a0g");

var $5FkrB = parcelRequire("5FkrB");


const $a22a4d51e8ac3bb8$var$_excluded = [
    "listen"
];
const $a22a4d51e8ac3bb8$export$672d721d310ff5f0 = ({ children: children })=>{
    const [state, _ref] = (0, $1ddaa6502d719738$export$9569010eab09ae9e)();
    const { listen: listen } = _ref, actions = (0, (/*@__PURE__*/$parcel$interopDefault($19a0g)))(_ref, $a22a4d51e8ac3bb8$var$_excluded);
    if (!state.unlisten && !(0, $f9f42a63082f8b8d$export$455cc18296abe008)()) listen();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children(state, actions));
};




var $5FkrB = parcelRequire("5FkrB");

var $gNUZr = parcelRequire("gNUZr");

const $5b08526dd1b3cd91$var$createPathParamHook = (0, $gNUZr.createHook)((0, $1ddaa6502d719738$export$1cf0ecab63b1963c), {
    selector: ({ match: { params: params } }, { paramKey: paramKey })=>params[paramKey]
});
const $5b08526dd1b3cd91$export$8c8591dcd57728e6 = (paramKey)=>{
    const [paramVal, routerActions] = $5b08526dd1b3cd91$var$createPathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, $5FkrB.useCallback)((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};



var $5FkrB = parcelRequire("5FkrB");

var $gNUZr = parcelRequire("gNUZr");

const $a137eec8ff4dd5ae$var$createQueryParamHook = (0, $gNUZr.createHook)((0, $1ddaa6502d719738$export$1cf0ecab63b1963c), {
    selector: ({ query: query }, { paramKey: paramKey })=>query[paramKey]
});
const $a137eec8ff4dd5ae$export$ae316f0eeb712a36 = (paramKey)=>{
    const [paramVal, routerActions] = $a137eec8ff4dd5ae$var$createQueryParamHook({
        paramKey: paramKey
    });
    const setQueryParam = (0, $5FkrB.useCallback)((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};





var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

const $f541dcf8f1a6c6da$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = 'UNDEFINED';
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $f541dcf8f1a6c6da$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $f541dcf8f1a6c6da$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (props)=>{
        const [{ action: action, history: history, location: location, match: match, query: query, route: route }, { push: push, replace: replace }] = (0, $1ddaa6502d719738$export$9569010eab09ae9e)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
            action: action,
            history: history,
            location: location,
            match: match,
            push: push,
            query: query,
            replace: replace,
            route: route
        }));
    };
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};





var $kqp0i = parcelRequire("kqp0i");

var $19a0g = parcelRequire("19a0g");


var $5FkrB = parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");
const $816a5189e752f4e6$export$d8e6abf214c9ec0f = (delay)=>{
    const timeoutId = (0, $5FkrB.useRef)();
    const schedule = (0, $5FkrB.useCallback)((callback)=>{
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay);
    }, [
        delay
    ]);
    const cancel = (0, $5FkrB.useCallback)(()=>{
        clearTimeout(timeoutId.current);
    }, []);
    return {
        schedule: schedule,
        cancel: cancel
    };
};


const $39281ff350272ced$var$VALID_LINK_TYPES = [
    'a',
    'button'
];
const $39281ff350272ced$export$855ece989b15eb57 = (type)=>$39281ff350272ced$var$VALID_LINK_TYPES.includes(type) ? type : 'a';


const $f169e8fd2c308647$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $f169e8fd2c308647$export$130b789831072f4c = (event)=>[
        'keypress',
        'keydown',
        'keyup'
    ].includes(event.type);


const $05c5e447ce24817b$export$706ad1af8096e280 = (event, { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to, state: state })=>{
    if ((0, $f169e8fd2c308647$export$130b789831072f4c)(event) && event.key !== 'Enter') return;
    onClick && onClick(event);
    if (!event.defaultPrevented && // onClick prevented default
    ((0, $f169e8fd2c308647$export$130b789831072f4c)(event) && event.key === 'Enter' || event.button === 0) && // ignore everything but left clicks and Enter key
    (!target || target === '_self') && // let browser handle "target=_blank" etc.
    !(0, $f169e8fd2c308647$export$642c6f14f6d4bbd5)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to, state);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href, state);
        }
    }
};




const $dba17dfd00ae7d8f$var$_excluded = [
    "children",
    "target",
    "replace",
    "href",
    "to",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onPointerDown",
    "onFocus",
    "onBlur",
    "type",
    "params",
    "query",
    "prefetch",
    "state"
];
const $dba17dfd00ae7d8f$var$PREFETCH_DELAY = 225;
const $dba17dfd00ae7d8f$var$Link = /*#__PURE__*/ (0, $5FkrB.forwardRef)((_ref, ref)=>{
    let { children: children, target: target = '_self', replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerDown: onPointerDown, onFocus: onFocus, onBlur: onBlur, type: linkType = 'a', params: params, query: query, prefetch: prefetch = false, state: state } = _ref, rest = (0, (/*@__PURE__*/$parcel$interopDefault($19a0g)))(_ref, $dba17dfd00ae7d8f$var$_excluded);
    const routerActions = (0, $1ddaa6502d719738$export$ada49399abf7a3a1)();
    const { schedule: schedule, cancel: cancel } = (0, $816a5189e752f4e6$export$d8e6abf214c9ec0f)($dba17dfd00ae7d8f$var$PREFETCH_DELAY);
    const validLinkType = (0, $39281ff350272ced$export$855ece989b15eb57)(linkType);
    const [route, setRoute] = (0, $5FkrB.useState)(()=>{
        if (to && typeof to !== 'string') {
            if ('then' in to) to.then((r)=>setRoute('default' in r ? r.default : r));
            else return to;
        }
    });
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = href != null ? href : typeof to !== 'string' ? route && (0, $c29d101a2cf08ade$export$fe53371bee54353d)((0, $768d36b334678dfa$export$37e0729cc751960b)(route.path, routeAttributes)) || '' : to;
    const IS_ABSOLUTE_LINK_REGEX = /^((?:(http|https):\/\/)|\/\/)/;
    const staticBasePath = href != null && !IS_ABSOLUTE_LINK_REGEX.test(href) || typeof to === 'string' ? routeAttributes.basePath : '';
    const triggerPrefetch = (0, $5FkrB.useCallback)(()=>{
        // ignore if async route not ready yet
        if (typeof to !== 'string' && !route) return;
        const context = typeof to !== 'string' && route ? (0, $10a8bc47d57825ec$export$faed15f35ddc6f99)(route, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchRoute(linkDestination, context);
    // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        linkDestination,
        routerActions
    ]);
    (0, $5FkrB.useEffect)(()=>{
        if (prefetch === 'mount') schedule(triggerPrefetch);
        return cancel;
    }, [
        prefetch,
        schedule,
        cancel,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $05c5e447ce24817b$export$706ad1af8096e280)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: route && [
                route,
                {
                    params: params,
                    query: query
                }
            ],
            state: state
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === 'hover') cancel();
        onMouseLeave && onMouseLeave(e);
    };
    const handleFocus = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onFocus && onFocus(e);
    };
    const handleBlur = (e)=>{
        if (prefetch === 'hover') cancel();
        onBlur && onBlur(e);
    };
    const handlePointerDown = (e)=>{
        if (prefetch === 'hover') {
            cancel();
            triggerPrefetch();
        }
        onPointerDown && onPointerDown(e);
    };
    return /*#__PURE__*/ (0, $5FkrB.createElement)(validLinkType, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        href: `${staticBasePath}${linkDestination}`,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerDown: handlePointerDown,
        ref: ref
    }), children);
});
$dba17dfd00ae7d8f$var$Link.displayName = 'Link';
var $dba17dfd00ae7d8f$export$2e2bcd8739ae039 = $dba17dfd00ae7d8f$var$Link;



var $5FkrB = parcelRequire("5FkrB");

const $56c1ff970910c658$export$7903e4b73fc7d6c3 = ()=>{
    const [{ action: action, location: location, match: match, query: query, route: route }] = (0, $b421c015f5018cd0$export$9a302a45f65d0572)();
    if (!route || !route.component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(route.component, {
        action: action,
        location: location,
        match: match,
        query: query,
        route: route
    });
};






const $5b11c5222dd8637d$export$c36ce69a82764756 = (plugins, { routes: routes, history: history, basePath: basePath })=>{
    const context = (0, $10a8bc47d57825ec$export$a0bd0313cbeabd49)(routes, {
        location: history.location,
        basePath: basePath
    });
    plugins.forEach((p)=>{
        p.routeLoad == null || p.routeLoad({
            context: context
        });
    });
};





var $kqp0i = parcelRequire("kqp0i");

var $19a0g = parcelRequire("19a0g");

var $gNUZr = parcelRequire("gNUZr");
var $dWq0h = parcelRequire("dWq0h");
var $1uA8D = parcelRequire("1uA8D");
var $gNUZr = parcelRequire("gNUZr");
const $56dfe361b58eb7b7$var$_excluded = [
    "children"
];
function $56dfe361b58eb7b7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $56dfe361b58eb7b7$var$hasAdditionalProps(props) {
    for(let i in props)return true;
    return false;
}
function $56dfe361b58eb7b7$export$48f338a7e080595c(Store, _temp) {
    let { selector: selector, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    const useStore = (0, $gNUZr.createHook)(Store, {
        selector: selector
    });
    const Subscriber = function Subscriber(_ref) {
        let { children: children } = _ref, rest = $56dfe361b58eb7b7$var$_objectWithoutPropertiesLoose(_ref, $56dfe361b58eb7b7$var$_excluded);
        const api = useStore($56dfe361b58eb7b7$var$hasAdditionalProps(rest) ? rest : undefined);
        return children(...api);
    };
    Subscriber.displayName = displayName || `Subscriber(${Store.key.split('__')[0]})`;
    return Subscriber;
}


var $8i0MQ = parcelRequire("8i0MQ");


var $kqp0i = parcelRequire("kqp0i");
const $5d57ecbfe3b77e12$export$9ccb639b7a119f61 = ()=>Date.now();



var $kqp0i = parcelRequire("kqp0i");
const $bcec6d01a9b8b822$export$881d135f98d8d7d0 = 100;
const $bcec6d01a9b8b822$export$9ab5bdcb8a1d6c34 = false;
const $bcec6d01a9b8b822$export$12c1dc38ea1692da = 0;



var $kqp0i = parcelRequire("kqp0i");
const $77fa9025423fc23c$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $77fa9025423fc23c$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, slice, {
        expiresAt: $77fa9025423fc23c$export$b65d7ba7fbf150f1(maxAge)
    }) : slice;


const $108ac836d0c63e52$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};


class $7f0f2ac24b55a8af$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super('Resource timed out: ' + message);
        this.name = 'TimeoutError';
    }
}


const $ac913cdf516a6c19$export$37d3126be6549b13 = 10000;


function $9f82c6853cb9305f$export$dc62515c8f0b52dd({ context: context, dependencies: dependencies, options: options, resource: resource, routerStoreContext: routerStoreContext }) {
    var _promiseOrData, _resource$maxAge;
    const { type: type, getData: getData } = resource;
    const { prefetch: prefetch, timeout: timeout } = options;
    // hard errors in dependencies or getData are converted into softer async error
    let promiseOrData;
    try {
        promiseOrData = getData((0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, routerStoreContext, {
            isPrefetch: !!prefetch,
            dependencies: dependencies()
        }), context);
    } catch (error) {
        promiseOrData = Promise.reject(error);
    }
    // ensure the promise includes any timeout error
    const timeoutGuard = timeout ? (0, $108ac836d0c63e52$export$58634b3a58ae66b7)(timeout) : null;
    // check if getData was sync, by looking for a Promise-like shape
    const data = typeof ((_promiseOrData = promiseOrData) == null ? void 0 : _promiseOrData.then) === 'function' ? undefined : promiseOrData;
    const promise = timeout ? Promise.race([
        promiseOrData,
        timeoutGuard == null ? void 0 : timeoutGuard.promise
    ]).then((maybeData)=>{
        if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $7f0f2ac24b55a8af$export$66d311bf29d5c89c)(type);
        (timeoutGuard == null ? void 0 : timeoutGuard.timerId) && clearTimeout(timeoutGuard.timerId);
        return maybeData;
    }) : // if we already have a result, wrap it so consumers can access it via same API
    data !== undefined ? Promise.resolve(data) : promiseOrData;
    const resourceMaxAge = (0, $77fa9025423fc23c$export$b65d7ba7fbf150f1)((_resource$maxAge = resource.maxAge) != null ? _resource$maxAge : (0, $bcec6d01a9b8b822$export$12c1dc38ea1692da));
    return {
        promise: promise,
        data: data,
        expiresAt: prefetch ? Math.max(resourceMaxAge, (0, $77fa9025423fc23c$export$b65d7ba7fbf150f1)((0, $ac913cdf516a6c19$export$37d3126be6549b13))) : resourceMaxAge
    };
}



/**
 * Utility method to created async versions of getData functions
 */ const $7b970af4b8ce2c1d$var$handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const $7b970af4b8ce2c1d$export$edd172c6c83c39cc = (arg)=>{
    var _getData, _arg$depends;
    return {
        type: arg.type,
        getKey: arg.getKey,
        getData: (_getData = arg.getData) != null ? _getData : $7b970af4b8ce2c1d$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === 'number' ? arg.maxAge : (0, $bcec6d01a9b8b822$export$12c1dc38ea1692da),
        maxCache: typeof arg.maxCache === 'number' ? arg.maxCache : (0, $bcec6d01a9b8b822$export$881d135f98d8d7d0),
        isBrowserOnly: typeof arg.isBrowserOnly === 'boolean' ? arg.isBrowserOnly : (0, $bcec6d01a9b8b822$export$9ab5bdcb8a1d6c34),
        depends: (_arg$depends = arg.depends) != null ? _arg$depends : null
    };
};



var $kqp0i = parcelRequire("kqp0i");

var $kqp0i = parcelRequire("kqp0i");



/**
 * The base defaults which should be fed into any factory that needs to derive other props.
 */ const $2fd0617e74ae762e$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};


const $11ddcb99c77f2a5f$export$fa8e33c3301e2e94 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, (0, $2fd0617e74ae762e$export$2df85a734ff5ed27), {
        expiresAt: (0, $77fa9025423fc23c$export$b65d7ba7fbf150f1)((0, $bcec6d01a9b8b822$export$12c1dc38ea1692da)),
        accessedAt: (0, $5d57ecbfe3b77e12$export$9ccb639b7a119f61)()
    });



var $19a0g = parcelRequire("19a0g");

var $kqp0i = parcelRequire("kqp0i");
function $c2289db837328500$var$_toPropertyKey(t) {
    var i = $c2289db837328500$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : String(i);
}
function $c2289db837328500$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $c2289db837328500$export$11374758be89e40 = (type, key)=>({ getState: getState })=>{
        var _prefetching$type;
        const { prefetching: prefetching } = getState();
        const slice = prefetching == null || (_prefetching$type = prefetching[type]) == null ? void 0 : _prefetching$type[key];
        // check if slice is still fresh
        if (slice && Date.now() < Number(slice.expiresAt)) return slice;
        return undefined;
    };
const $c2289db837328500$export$1e32615dc8354436 = (type, key, slice)=>({ setState: setState, getState: getState })=>{
        var _prefetching$type2, _slice$promise;
        const { prefetching: prefetching } = getState();
        // avoid doing extra set if same value
        if ((prefetching == null || (_prefetching$type2 = prefetching[type]) == null ? void 0 : _prefetching$type2[key]) === slice) return;
        // cheap optimisation to provide prefetched result syncronously
        slice == null || (_slice$promise = slice.promise) == null || _slice$promise.then((maybeData)=>slice.data = maybeData);
        setState({
            prefetching: (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, prefetching, {
                [type]: (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, prefetching == null ? void 0 : prefetching[type], {
                    [key]: slice
                })
            })
        });
    };
const $c2289db837328500$export$704f800f263b050e = (type, key, state)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { data: data } = getState();
        // every time we override a resource we kill its prefetched
        dispatch($c2289db837328500$export$1e32615dc8354436(type, key, undefined));
        setState({
            data: (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, data, {
                [type]: (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, data[type] || {}, {
                    [key]: state
                })
            })
        });
    };
const $c2289db837328500$export$5fc90c33b03fffb = (type, key)=>({ getState: getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType == null ? void 0 : resourceDataForType[key];
    };
const $c2289db837328500$export$d40f35dc5952864b = (type, key)=>({ getState: getState, setState: setState })=>{
        const { data: data } = getState();
        const { [type]: resourceForType } = data, remainingData = (0, (/*@__PURE__*/$parcel$interopDefault($19a0g)))(data, [
            type
        ].map($c2289db837328500$var$_toPropertyKey));
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const remainingForType = (0, (/*@__PURE__*/$parcel$interopDefault($19a0g)))(resourceForType, [
                key
            ].map($c2289db837328500$var$_toPropertyKey));
            setState({
                data: (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, remainingData, {
                    [type]: remainingForType
                })
            });
        }
    };


var $1114b4ff1105d34f$var$_Object$fromEntries;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
const $1114b4ff1105d34f$var$fromEntries = ($1114b4ff1105d34f$var$_Object$fromEntries = Object.fromEntries) != null ? $1114b4ff1105d34f$var$_Object$fromEntries : (entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        })));
const $1114b4ff1105d34f$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $1114b4ff1105d34f$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResourceDependencyError';
    }
}
const $1114b4ff1105d34f$export$12600f2e0e7fb2cc = (routeResources, tuples)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _routeResources$some;
        if (getState().executing) throw new Error('execution is already in progress');
        // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = (_routeResources$some = routeResources == null ? void 0 : routeResources.some(({ depends: depends })=>depends == null ? void 0 : depends.length)) != null ? _routeResources$some : false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
        // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources == null ? void 0 : routeResources.some($1114b4ff1105d34f$var$matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        const [dependentTypes] = routeResources.reduce((acc, { type: type, depends: depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!(depends != null && depends.some((dependency)=>executableTypes.includes(dependency)));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type: type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i);
        // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type: type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        const dependentAndDependencyTypes = routeResources.filter(({ type: type })=>dependentTypes.includes(type)).reduce((acc, { type: type, depends: depends })=>depends ? [
                ...acc,
                ...depends,
                type
            ] : [
                ...acc,
                type
            ], []).filter((v, i, a)=>a.indexOf(v) === i);
        // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        const executingTuples = routeResources.filter(({ type: type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>{
            var _tuples$find;
            return (_tuples$find = tuples.find($1114b4ff1105d34f$var$matchType(resource))) != null ? _tuples$find : [
                resource,
                null
            ];
        });
        setState({
            executing: executingTuples
        });
        // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            var _getState$executing;
            const latestTuple = (_getState$executing = getState().executing) == null ? void 0 : _getState$executing[i];
            const [{ type: latestType }, maybeAction] = latestTuple != null ? latestTuple : [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error('execution reached an inconsistent state');
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        });
        // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex($1114b4ff1105d34f$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $1114b4ff1105d34f$export$5f7e1fd85734e71e = (routeResources, resource, action)=>({ dispatch: dispatch })=>dispatch($1114b4ff1105d34f$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const $1114b4ff1105d34f$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$1114b4ff1105d34f$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $1114b4ff1105d34f$export$7d1ffac63c68405d = (resource, actionCreator)=>({ getState: getState, setState: setState })=>{
        var _tuples$findIndex;
        const { executing: tuples } = getState();
        // find the given resource in the currently executing tuples
        const indexForResource = (_tuples$findIndex = tuples == null ? void 0 : tuples.findIndex($1114b4ff1105d34f$var$matchType(resource))) != null ? _tuples$findIndex : -1;
        if (indexForResource < 0) return;
        // find dependent resources following given resource and revise their action
        const executing = tuples.map((tuple, i)=>{
            var _tupleResource$depend;
            const [tupleResource] = tuple;
            return i > indexForResource && (_tupleResource$depend = tupleResource.depends) != null && _tupleResource$depend.includes(resource.type) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $1114b4ff1105d34f$export$75915f81f2a6540a = (resource, routerStoreContext, options)=>({ getState: getState, dispatch: dispatch })=>{
        var _tuples$findIndex2;
        const { type: type, depends: depends } = resource;
        // optimise the case of no dependencies
        if (!(depends != null && depends.length)) return {};
        const { executing: tuples, context: resourceStoreContext } = getState();
        // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = (_tuples$findIndex2 = tuples == null ? void 0 : tuples.findIndex($1114b4ff1105d34f$var$matchType(resource))) != null ? _tuples$findIndex2 : -1;
        if (indexForResource < 0) throw new $1114b4ff1105d34f$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
        // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map((dependency)=>[
                dependency,
                tuples.findIndex($1114b4ff1105d34f$var$matchType({
                    type: dependency
                }))
            ]);
        // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new $1114b4ff1105d34f$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $1114b4ff1105d34f$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $1114b4ff1105d34f$var$fromEntries(dependencyIndexTuples.map(([dependencyType, index])=>{
            const { getKey: getKey } = tuples[index][0];
            const key = getKey(routerStoreContext, resourceStoreContext);
            let slice = dispatch((0, $c2289db837328500$export$5fc90c33b03fffb)(dependencyType, key)) || (0, $11ddcb99c77f2a5f$export$fa8e33c3301e2e94)();
            // when prefetching we provide only the promise to dependands
            const prefetchSlice = options.prefetch ? dispatch((0, $c2289db837328500$export$11374758be89e40)(dependencyType, key)) : undefined;
            if (prefetchSlice) slice = (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, slice, {
                // not spreading prefetchSlice to persist previous slice data
                promise: prefetchSlice.promise,
                expiresAt: prefetchSlice.expiresAt,
                loading: true
            });
            return [
                dependencyType,
                slice
            ];
        }));
    };





const $8f855b3c85bfcd50$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $8f855b3c85bfcd50$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$8f855b3c85bfcd50$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));



const $7ae785bb12efd361$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $7ae785bb12efd361$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;


const $22771f91a0427f12$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $7ae785bb12efd361$export$740886389191c640)(nextRoute)) return [];
    if ((0, $7ae785bb12efd361$export$221027ff1aa38f82)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $8f855b3c85bfcd50$export$cd7fbe7e979df558)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $8f855b3c85bfcd50$export$c616b176adf9ad4a)(resource, nextRouterStoreContext, resourceStoreContext)));
};



const $e5451870b07c58fa$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $e5451870b07c58fa$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $e5451870b07c58fa$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $e5451870b07c58fa$export$89440b7623c2c75c = (resource, key)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $e5451870b07c58fa$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $c2289db837328500$export$d40f35dc5952864b)(type, keyTobeDeleted));
    };




// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $a501e17e10f67e01$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = 'NonError';
        if (Error.captureStackTrace) Error.captureStackTrace(this, $a501e17e10f67e01$var$NonError);
    }
}
const $a501e17e10f67e01$var$commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
const $a501e17e10f67e01$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $a501e17e10f67e01$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const property of $a501e17e10f67e01$var$commonProperties)if (typeof from[property] === 'string') to[property] = from[property];
    return to;
};
const $a501e17e10f67e01$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === 'object' && value !== null) return $a501e17e10f67e01$var$destroyCircular(value, []);
    // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const $a501e17e10f67e01$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $a501e17e10f67e01$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $a501e17e10f67e01$var$NonError(value);
};


const $2f8d085a7807db31$export$b25d2963b8a3488a = ({ expiresAt: expiresAt })=>expiresAt === null;
const $2f8d085a7807db31$var$isFresh = (resource)=>{
    if ($2f8d085a7807db31$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $2f8d085a7807db31$export$399de8c43d0ece3c = (resource)=>{
    var _resource$error;
    if ((resource == null || (_resource$error = resource.error) == null ? void 0 : _resource$error.name) === 'TimeoutError') return false;
    if (resource.loading) return true;
    if ($2f8d085a7807db31$var$isFresh(resource)) return true;
    return false;
};



var $kqp0i = parcelRequire("kqp0i");
const $4798122614ec3b45$export$2e4da1b414980956 = (slice)=>slice.promise === null ? (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, slice, {
        promise: Promise.resolve(slice.data)
    }) : slice;



const $9de411b0b18cf8f2$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});




const $c80879d114529b7c$export$c9ed509724feb827 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    return slice ? (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, slice) : (0, $11ddcb99c77f2a5f$export$fa8e33c3301e2e94)();
};
const $c80879d114529b7c$export$6a0b1779210de0ee = (state)=>state.context;



const $325bbf8ea5f9a12e$var$_excluded = [
    "context"
], $325bbf8ea5f9a12e$var$_excluded2 = [
    "error",
    "expiresAt",
    "loading"
];
const $325bbf8ea5f9a12e$export$3f1be494d407b77a = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   */ clearResource: (resource, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $c2289db837328500$export$d40f35dc5952864b)(type, key));
                dispatch((0, $1114b4ff1105d34f$export$7d1ffac63c68405d)(resource, (dependentResource)=>$325bbf8ea5f9a12e$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $c2289db837328500$export$d40f35dc5952864b)(type));
        },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState = getState(), { context: context } = _getState, resourceStoreState = (0, (/*@__PURE__*/$parcel$interopDefault($19a0g)))(_getState, $325bbf8ea5f9a12e$var$_excluded);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $c80879d114529b7c$export$c9ed509724feb827)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, prevSlice, changes, {
                expiresAt: (0, $77fa9025423fc23c$export$b65d7ba7fbf150f1)(maxAge),
                accessedAt: (0, $5d57ecbfe3b77e12$export$9ccb639b7a119f61)()
            });
            dispatch((0, $c2289db837328500$export$704f800f263b050e)(type, key, newSlice));
            // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $1114b4ff1105d34f$export$7d1ffac63c68405d)(resource, (dependentResource)=>$325bbf8ea5f9a12e$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   */ getResource: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            let cached = dispatch((0, $c2289db837328500$export$5fc90c33b03fffb)(type, key));
            if (cached && (0, $2f8d085a7807db31$export$399de8c43d0ece3c)(cached)) {
                if ((0, $2f8d085a7807db31$export$b25d2963b8a3488a)(cached)) {
                    const withResolvedPromise = (0, $4798122614ec3b45$export$2e4da1b414980956)(cached);
                    cached = (0, $77fa9025423fc23c$export$18d1d420fd588368)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $5d57ecbfe3b77e12$export$9ccb639b7a119f61)();
                dispatch((0, $c2289db837328500$export$704f800f263b050e)(type, key, cached));
                return cached;
            }
            return dispatch($325bbf8ea5f9a12e$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
   * Request a single resource and update the resource cache.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $c2289db837328500$export$5fc90c33b03fffb)(type, key)) || (0, $11ddcb99c77f2a5f$export$fa8e33c3301e2e94)();
            // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $e5451870b07c58fa$export$89440b7623c2c75c)(resource, key));
            const loadingSlice = dispatch((0, $c2289db837328500$export$11374758be89e40)(type, key)) || (0, $9f82c6853cb9305f$export$dc62515c8f0b52dd)({
                context: context,
                dependencies: ()=>dispatch((0, $1114b4ff1105d34f$export$75915f81f2a6540a)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            let resolvedSlice;
            if (loadingSlice.data === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // enter loading state
                dispatch((0, $c2289db837328500$export$704f800f263b050e)(type, key, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, prevSlice, loadingSlice, {
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    accessedAt: (0, $5d57ecbfe3b77e12$export$9ccb639b7a119f61)()
                })));
                // trigger dependent resources to also load
                dispatch((0, $1114b4ff1105d34f$export$7d1ffac63c68405d)(resource, (dependentResource)=>$325bbf8ea5f9a12e$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options)));
                // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    var _loadingSlice$data;
                    const data = (_loadingSlice$data = loadingSlice.data) != null ? _loadingSlice$data : await loadingSlice.promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        // any existing error is cleared
                        loading: false,
                        promise: loadingSlice.promise
                    };
                } catch (error) {
                    if (error instanceof (0, $7f0f2ac24b55a8af$export$66d311bf29d5c89c)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        // this condition cannot recover so must only be present in static/server router
                        promise: null // special case for timeout
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        // @ts-ignore
                        error,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                }
            }
            // ensure most recent data when return occurs
            const recentSlice = dispatch((0, $c2289db837328500$export$5fc90c33b03fffb)(type, key));
            const finalSlice = (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, recentSlice || prevSlice, resolvedSlice, {
                accessedAt: (0, $5d57ecbfe3b77e12$export$9ccb639b7a119f61)(),
                expiresAt: (0, $77fa9025423fc23c$export$b65d7ba7fbf150f1)(maxAge)
            });
            // protect against race conditions: if resources get cleared while await happens, we discard the result
            if (recentSlice || loadingSlice.data !== undefined) dispatch((0, $c2289db837328500$export$704f800f263b050e)(type, key, finalSlice));
            return finalSlice;
        },
    /**
   * Prefetch a single resource and store in the prefetch cache.
   */ prefetchResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const loadingSlice = dispatch((0, $c2289db837328500$export$11374758be89e40)(type, key)) || (0, $9f82c6853cb9305f$export$dc62515c8f0b52dd)({
                context: context,
                dependencies: ()=>dispatch((0, $1114b4ff1105d34f$export$75915f81f2a6540a)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            // save deferred value to be used also by dependants
            dispatch((0, $c2289db837328500$export$1e32615dc8354436)(type, key, loadingSlice));
            // trigger dependent resources to also prefetch
            dispatch((0, $1114b4ff1105d34f$export$7d1ffac63c68405d)(resource, (dependentResource)=>$325bbf8ea5f9a12e$export$3f1be494d407b77a.prefetchResourceFromRemote(dependentResource, routerStoreContext, options)));
        }
};
const $325bbf8ea5f9a12e$export$e324594224ef24da = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   * Execute such that dependencies on current route will be cleared.
   */ clearResource: (resource, routerStoreContext)=>{
        var _routerStoreContext$r;
        return (0, $1114b4ff1105d34f$export$5f7e1fd85734e71e)(routerStoreContext == null || (_routerStoreContext$r = routerStoreContext.route) == null ? void 0 : _routerStoreContext$r.resources, resource, $325bbf8ea5f9a12e$export$3f1be494d407b77a.clearResource(resource, routerStoreContext != null ? routerStoreContext : null));
    },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   * Execute such that dependencies on current route will be updated.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>(0, $1114b4ff1105d34f$export$5f7e1fd85734e71e)(routerStoreContext.route.resources, resource, $325bbf8ea5f9a12e$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, getNewSliceData)),
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   * Execute such that dependencies on current route will be updated.
   */ getResource: (resource, routerStoreContext, options)=>(0, $1114b4ff1105d34f$export$5f7e1fd85734e71e)(routerStoreContext.route.resources, resource, $325bbf8ea5f9a12e$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options)),
    /**
   * Request a single resource and update the resource cache.
   * Execute such that dependencies on current route will be updated.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>(0, $1114b4ff1105d34f$export$5f7e1fd85734e71e)(routerStoreContext.route.resources, resource, $325bbf8ea5f9a12e$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options)),
    /**
   * Request all resources.
   */ requestAllResources: (routerStoreContext, options = {})=>({ dispatch: dispatch })=>{
            const { route: routeDefault } = routerStoreContext || {};
            const route = routeDefault;
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($325bbf8ea5f9a12e$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options)));
        },
    /**
   * Cleans expired resources and resets them back to their initial state.
   * We need to do this when transitioning into a route.
   */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $c2289db837328500$export$5fc90c33b03fffb)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $c2289db837328500$export$d40f35dc5952864b)(type, key));
            });
        },
    /**
   * Requests a specific set of resources.
   */ requestResources: (resources, routerStoreContext, options)=>{
        var _resources;
        const predicate = (0, $f9f42a63082f8b8d$export$455cc18296abe008)() ? ({ isBrowserOnly: isBrowserOnly })=>!isBrowserOnly : ()=>true;
        return (0, $1114b4ff1105d34f$export$f71a65c89c987a02)((_resources = routerStoreContext.route.resources) == null ? void 0 : _resources.filter(predicate), resources.filter(predicate), (resource)=>$325bbf8ea5f9a12e$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
   * Prefetch a specific set of resources.
   */ prefetchResources: (resources, routerStoreContext, options)=>(0, $1114b4ff1105d34f$export$f71a65c89c987a02)(routerStoreContext.route.resources, resources, (resource)=>$325bbf8ea5f9a12e$export$3f1be494d407b77a.prefetchResourceFromRemote(resource, routerStoreContext, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, options, {
                prefetch: true
            }))),
    /**
   * Hydrates the store with state.
   * Will not override pre-hydrated state.
   */ hydrate: ({ resourceData: resourceData, resourceContext: resourceContext })=>({ getState: getState, setState: setState })=>{
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $9de411b0b18cf8f2$export$3ceb62baab058c6b)(getNextStateValue(data, resourceData), (_ref)=>{
                let { error: error, expiresAt: expiresAt, loading: loading } = _ref, rest = (0, (/*@__PURE__*/$parcel$interopDefault($19a0g)))(_ref, $325bbf8ea5f9a12e$var$_excluded2);
                const deserializedError = !error ? null : (0, $a501e17e10f67e01$export$64cddc1e268e9046)(error);
                const isTimeoutError = (deserializedError == null ? void 0 : deserializedError.name) === 'TimeoutError';
                return (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                });
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
   * Gets the store's context
   */ getContext: ()=>({ getState: getState })=>getState().context,
    /**
   * Returns safe, portable and rehydratable data.
   */ getSafeData: ()=>({ getState: getState })=>(0, $9de411b0b18cf8f2$export$3ceb62baab058c6b)(getState().data, ({ data: data, key: key, error: error, loading: loading })=>({
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $a501e17e10f67e01$export$46ff38bc6bdea8fb)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $7f0f2ac24b55a8af$export$66d311bf29d5c89c) ? loading : false
                }))
};
const $325bbf8ea5f9a12e$export$94f50dade551bd01 = (0, $1uA8D.createStore)({
    initialState: {
        data: {},
        context: {},
        executing: null,
        prefetching: null
    },
    actions: $325bbf8ea5f9a12e$export$e324594224ef24da,
    name: 'router-resources'
});
const $325bbf8ea5f9a12e$export$cc90fb9c37c5589d = (0, $dWq0h.createContainer)($325bbf8ea5f9a12e$export$94f50dade551bd01, {
    displayName: 'ResourceContainer'
});
const $325bbf8ea5f9a12e$export$fee1a6213543bd78 = (0, $56dfe361b58eb7b7$export$48f338a7e080595c)($325bbf8ea5f9a12e$export$94f50dade551bd01, {
    displayName: 'ResourceSelectorSubscriber',
    selector: (state, props)=>(0, $c80879d114529b7c$export$c9ed509724feb827)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $325bbf8ea5f9a12e$export$6f6057d42352becb = ()=>// @ts-ignore not providing a scopeId param
    (0, $8i0MQ.defaultRegistry).getStore($325bbf8ea5f9a12e$export$94f50dade551bd01);
const $325bbf8ea5f9a12e$export$ac3608e0bb357c7 = (0, $gNUZr.createHook)($325bbf8ea5f9a12e$export$94f50dade551bd01, {
    selector: (0, $c80879d114529b7c$export$c9ed509724feb827)
});
const $325bbf8ea5f9a12e$export$98e41a62c9bef75e = (0, $gNUZr.createActionsHook)($325bbf8ea5f9a12e$export$94f50dade551bd01);
const $325bbf8ea5f9a12e$export$e59f52df235ac7b3 = (0, $gNUZr.createHook)($325bbf8ea5f9a12e$export$94f50dade551bd01, {
    selector: (0, $c80879d114529b7c$export$6a0b1779210de0ee)
});



const $f97bd143060a0c12$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $f97bd143060a0c12$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $325bbf8ea5f9a12e$export$6f6057d42352becb)().actions;
    const nextResources = (0, $22771f91a0427f12$export$7cbbc763e2f3d65d)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $f97bd143060a0c12$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $325bbf8ea5f9a12e$export$6f6057d42352becb)().actions;
    const nextResources = (0, $22771f91a0427f12$export$7cbbc763e2f3d65d)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $f97bd143060a0c12$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $325bbf8ea5f9a12e$export$6f6057d42352becb)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $f97bd143060a0c12$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $f97bd143060a0c12$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $f97bd143060a0c12$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $325bbf8ea5f9a12e$export$6f6057d42352becb)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $325bbf8ea5f9a12e$export$6f6057d42352becb)().actions;
            const nextResources = (0, $22771f91a0427f12$export$7cbbc763e2f3d65d)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $325bbf8ea5f9a12e$export$6f6057d42352becb)().actions.getSafeData();
        }
    };
};



var $5FkrB = parcelRequire("5FkrB");

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $gNUZr = parcelRequire("gNUZr");


const $5c5601e773daa875$export$9f6abfd74295843b = (resource, options)=>{
    const actions = (0, $325bbf8ea5f9a12e$export$98e41a62c9bef75e)();
    const { getContext: getRouterContext } = (0, $1ddaa6502d719738$export$ada49399abf7a3a1)();
    // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $5FkrB.useMemo)(()=>(0, $gNUZr.createHook)((0, $1ddaa6502d719738$export$1cf0ecab63b1963c), {
            selector: ({ match: match, query: query, route: route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    const key = useKey(options == null ? void 0 : options.routerContext)[0];
    const [slice] = (0, $325bbf8ea5f9a12e$export$ac3608e0bb357c7)({
        type: resource.type,
        key: key
    });
    // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $5FkrB.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    ()=>(options == null ? void 0 : options.routerContext) || getRouterContext(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    const update = (0, $5FkrB.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $5FkrB.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $5FkrB.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $5FkrB.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, slice, {
        update: update,
        key: key,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    });
};


const $b4ab5dace00b8583$export$fee1a6213543bd78 = ({ children: children, resource: resource, options: options })=>{
    const result = (0, $5c5601e773daa875$export$9f6abfd74295843b)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children(result));
};




const $57615bd5aef4bc45$export$dee7bf9fc0ff48c3 = (fn)=>(0, $325bbf8ea5f9a12e$export$6f6057d42352becb)().storeState.subscribe(fn);




const $57d0234526918c1c$export$d4864d13105dc5ed = {
    loading: false,
    error: null,
    data: {
        foo: 'bar'
    },
    promise: null,
    expiresAt: Date.now(),
    accessedAt: Date.now(),
    key: ''
};






// Internationalization configuration skeleton
// This file intentionally does not wire into the app yet.
const $9bc4aff2ff299440$export$d7f512c98c859244 = 'en';
const $9bc4aff2ff299440$export$94d2d72df36bbb16 = [
    'en'
];
const $9bc4aff2ff299440$export$5aae9b6b3e0e7094 = {
    locale: 'locale'
};
const $9bc4aff2ff299440$export$5cc733ac2d215929 = {
};


var $eeccb061c66729e2$exports = {};
$eeccb061c66729e2$exports = JSON.parse('{"navigation.title":"What\'s new across Atlassian","app.updates.title":"What\'s new across Atlassian","app.updates.subtitle":"Discover new cloud features designed to unleash your team\'s potential and see how our latest updates can power your work today.","app.updates.browserTabTitle":"Release Notes | Atlassian Community","appUpdatesDetails.backAction":"Back to release notes","appUpdatesDetails.browserTabTitleSuffix":"Release Notes | Atlassian Community","appUpdatesDetails.notFound":"This release note could not be found. Use the back button to return to release notes.","appUpdatesDetails.error":"Unable to load this release note. Use the back button to return and try again.","appUpdatesDetails.loading":"Loading release note\u2026","appUpdatesDetails.summary":"Summary","appUpdatesDetails.keyChanges":"Key changes","appUpdatesDetails.benefits":"Benefits","appUpdatesDetails.reasonForChange":"Reason for the change","appUpdatesDetails.prepareForChange":"How to prepare for the change","appUpdatesDetails.getStarted":"Getting started","appUpdatesDetails.changelog.release":"Release","appUpdatesDetails.changelog.scheduledStatus":"Scheduled","appUpdatesDetails.changelog.rollingOutStatus":"Rolling Out","appUpdatesDetails.changelog.completedStatus":"Completed","appUpdatesDetails.sidebar.appsImpactedTitle":"Apps impacted","appUpdatesDetails.sidebar.impactRatingTitle":"Change impact","appUpdatesDetails.sidebar.changeTypeTitle":"Contextual tags","appUpdatesDetails.sidebar.impactHigh":"High","appUpdatesDetails.sidebar.impactMedium":"Medium","appUpdatesDetails.sidebar.impactLow":"Low","appUpdates.filters.impactRating.label":"Impact rating","appUpdates.filters.impactRating.high":"High","appUpdates.filters.impactRating.medium":"Medium","appUpdates.filters.impactRating.low":"Low","appUpdates.filters.tags.label":"Contextual tags","appUpdatesTable.column.impactRating":"Impact","appUpdatesTable.column.changeType":"Change type","appUpdatesTable.column.contextualTags":"Contextual tags","appUpdatesTable.impactRating.high":"High","appUpdatesTable.impactRating.medium":"Medium","appUpdatesTable.impactRating.low":"Low","appUpdatesDetails.changelog.changeType":"Change type","appUpdatesDetails.changelog.changeImpact":"Change impact","appUpdatesDetails.changelog.contextualTags":"Contextual tags","appUpdates.aiDisclaimer.beta":"Beta","appUpdates.aiDisclaimer.tooltipText":"Uses AI. Verify results.","appUpdatesDetails.changelog.rolloutSchedule":"Rollout schedule","appUpdatesDetails.changelog.status":"Status","appUpdates.rolloutScheduleCallout.text":"For rollout schedules specific to your organization, visit <appUpdatesLink>App updates</appUpdatesLink> in <adminLink>Atlassian Administration</adminLink>. Organization admin access required.","appUpdatesTable.adminCallout.text":"For rollout schedules specific to your organization, visit <appUpdatesLink>App updates</appUpdatesLink> in <adminLink>Atlassian Administration</adminLink>. Organization admin access required.","app-updates-table.unread-dot.mark-as-read":"Mark as read"}');


var $033860fe7bfd25af$exports = {};
$parcel$export($033860fe7bfd25af$exports, "init", () => $c3b6349452077e3f$export$2cd8252107eb640b);
$parcel$export($033860fe7bfd25af$exports, "captureReactException", () => $d73ec427c982e9ee$export$270be4195468cda9);
$parcel$export($033860fe7bfd25af$exports, "reactErrorHandler", () => $d73ec427c982e9ee$export$1e6f045b27b3cfb1);
$parcel$export($033860fe7bfd25af$exports, "Profiler", () => $eeb2a38f5ea169f2$export$e2c29f18771995cb);
$parcel$export($033860fe7bfd25af$exports, "useProfiler", () => $eeb2a38f5ea169f2$export$972a52cbfaf8cf13);
$parcel$export($033860fe7bfd25af$exports, "withProfiler", () => $eeb2a38f5ea169f2$export$e1e354213dd1a8a7);
$parcel$export($033860fe7bfd25af$exports, "ErrorBoundary", () => $d86fddd54af16059$export$e926676385687eaf);
$parcel$export($033860fe7bfd25af$exports, "withErrorBoundary", () => $d86fddd54af16059$export$f0c7a449e0cfaec7);
$parcel$export($033860fe7bfd25af$exports, "createReduxEnhancer", () => $18b37302a7d113fe$export$c4506dd2040faa8a);
$parcel$export($033860fe7bfd25af$exports, "reactRouterV3BrowserTracingIntegration", () => $31664e4a36abe457$export$8a5d05e8905d7257);
$parcel$export($033860fe7bfd25af$exports, "tanstackRouterBrowserTracingIntegration", () => $9351852664295212$export$6405014438b98f22);
$parcel$export($033860fe7bfd25af$exports, "reactRouterV4BrowserTracingIntegration", () => $19a7bc5e65e39b8b$export$474cac1fc5ec6ff8);
$parcel$export($033860fe7bfd25af$exports, "reactRouterV5BrowserTracingIntegration", () => $19a7bc5e65e39b8b$export$1c913d0c067ca14f);
$parcel$export($033860fe7bfd25af$exports, "withSentryRouting", () => $19a7bc5e65e39b8b$export$51a414dfd89dd222);
$parcel$export($033860fe7bfd25af$exports, "reactRouterV6BrowserTracingIntegration", () => $c159a67177be6b02$export$47113a480541ff59);
$parcel$export($033860fe7bfd25af$exports, "withSentryReactRouterV6Routing", () => $c159a67177be6b02$export$c6111e8561a02a8b);
$parcel$export($033860fe7bfd25af$exports, "wrapCreateBrowserRouterV6", () => $c159a67177be6b02$export$bd33b81dece50867);
$parcel$export($033860fe7bfd25af$exports, "wrapCreateMemoryRouterV6", () => $c159a67177be6b02$export$e61a765bf2bfccdc);
$parcel$export($033860fe7bfd25af$exports, "wrapUseRoutesV6", () => $c159a67177be6b02$export$1ffd7287c0e61f32);
$parcel$export($033860fe7bfd25af$exports, "reactRouterV7BrowserTracingIntegration", () => $5bb87f6d8535ae7e$export$8c58a21c71b0a1de);
$parcel$export($033860fe7bfd25af$exports, "withSentryReactRouterV7Routing", () => $5bb87f6d8535ae7e$export$1d21f1c69f33ffe5);
$parcel$export($033860fe7bfd25af$exports, "wrapCreateBrowserRouterV7", () => $5bb87f6d8535ae7e$export$b070baa27381b3d3);
$parcel$export($033860fe7bfd25af$exports, "wrapCreateMemoryRouterV7", () => $5bb87f6d8535ae7e$export$6d8f60accec7deae);
$parcel$export($033860fe7bfd25af$exports, "wrapUseRoutesV7", () => $5bb87f6d8535ae7e$export$54f60524efa5c3b2);
$parcel$export($033860fe7bfd25af$exports, "reactRouterBrowserTracingIntegration", () => $1d91f75301852e61$export$343e7de6039334f6);
$parcel$export($033860fe7bfd25af$exports, "wrapCreateBrowserRouter", () => $1d91f75301852e61$export$7f4c656bd7ebbb6b);
$parcel$export($033860fe7bfd25af$exports, "wrapCreateMemoryRouter", () => $1d91f75301852e61$export$e196517f4822a972);
$parcel$export($033860fe7bfd25af$exports, "wrapReactRouterRouting", () => $1d91f75301852e61$export$1d92ff690890f59b);
$parcel$export($033860fe7bfd25af$exports, "wrapUseRoutes", () => $1d91f75301852e61$export$1f41b3e298c8040f);
var $054fa894e15f1de5$exports = {};
$parcel$export($054fa894e15f1de5$exports, "feedbackAsyncIntegration", () => $367c450e8ba35148$export$21eeae83e17be6ea);
$parcel$export($054fa894e15f1de5$exports, "feedbackIntegration", () => $3b83570998c5a022$export$4bf8b7bb0f0086df);
$parcel$export($054fa894e15f1de5$exports, "feedbackSyncIntegration", () => $3b83570998c5a022$export$4bf8b7bb0f0086df);
$parcel$export($054fa894e15f1de5$exports, "MULTIPLEXED_TRANSPORT_EXTRA_KEY", () => $b244ff70a28cf637$exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY);
$parcel$export($054fa894e15f1de5$exports, "SDK_VERSION", () => $b244ff70a28cf637$exports.SDK_VERSION);
$parcel$export($054fa894e15f1de5$exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", () => $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_OP);
$parcel$export($054fa894e15f1de5$exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", () => $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN);
$parcel$export($054fa894e15f1de5$exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", () => $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE);
$parcel$export($054fa894e15f1de5$exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", () => $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE);
$parcel$export($054fa894e15f1de5$exports, "Scope", () => $b244ff70a28cf637$exports.Scope);
$parcel$export($054fa894e15f1de5$exports, "addBreadcrumb", () => $b244ff70a28cf637$exports.addBreadcrumb);
$parcel$export($054fa894e15f1de5$exports, "addEventProcessor", () => $b244ff70a28cf637$exports.addEventProcessor);
$parcel$export($054fa894e15f1de5$exports, "addIntegration", () => $b244ff70a28cf637$exports.addIntegration);
$parcel$export($054fa894e15f1de5$exports, "bindScopeToEmitter", () => $b244ff70a28cf637$exports.bindScopeToEmitter);
$parcel$export($054fa894e15f1de5$exports, "captureConsoleIntegration", () => $b244ff70a28cf637$exports.captureConsoleIntegration);
$parcel$export($054fa894e15f1de5$exports, "captureEvent", () => $b244ff70a28cf637$exports.captureEvent);
$parcel$export($054fa894e15f1de5$exports, "captureException", () => $b244ff70a28cf637$exports.captureException);
$parcel$export($054fa894e15f1de5$exports, "captureFeedback", () => $b244ff70a28cf637$exports.captureFeedback);
$parcel$export($054fa894e15f1de5$exports, "captureMessage", () => $b244ff70a28cf637$exports.captureMessage);
$parcel$export($054fa894e15f1de5$exports, "captureSession", () => $b244ff70a28cf637$exports.captureSession);
$parcel$export($054fa894e15f1de5$exports, "close", () => $b244ff70a28cf637$exports.close);
$parcel$export($054fa894e15f1de5$exports, "consoleLoggingIntegration", () => $b244ff70a28cf637$exports.consoleLoggingIntegration);
$parcel$export($054fa894e15f1de5$exports, "continueTrace", () => $b244ff70a28cf637$exports.continueTrace);
$parcel$export($054fa894e15f1de5$exports, "createConsolaReporter", () => $b244ff70a28cf637$exports.createConsolaReporter);
$parcel$export($054fa894e15f1de5$exports, "createLangChainCallbackHandler", () => $b244ff70a28cf637$exports.createLangChainCallbackHandler);
$parcel$export($054fa894e15f1de5$exports, "createTransport", () => $b244ff70a28cf637$exports.createTransport);
$parcel$export($054fa894e15f1de5$exports, "dedupeIntegration", () => $b244ff70a28cf637$exports.dedupeIntegration);
$parcel$export($054fa894e15f1de5$exports, "endSession", () => $b244ff70a28cf637$exports.endSession);
$parcel$export($054fa894e15f1de5$exports, "eventFiltersIntegration", () => $b244ff70a28cf637$exports.eventFiltersIntegration);
$parcel$export($054fa894e15f1de5$exports, "extraErrorDataIntegration", () => $b244ff70a28cf637$exports.extraErrorDataIntegration);
$parcel$export($054fa894e15f1de5$exports, "featureFlagsIntegration", () => $b244ff70a28cf637$exports.featureFlagsIntegration);
$parcel$export($054fa894e15f1de5$exports, "flush", () => $b244ff70a28cf637$exports.flush);
$parcel$export($054fa894e15f1de5$exports, "functionToStringIntegration", () => $b244ff70a28cf637$exports.functionToStringIntegration);
$parcel$export($054fa894e15f1de5$exports, "getActiveSpan", () => $b244ff70a28cf637$exports.getActiveSpan);
$parcel$export($054fa894e15f1de5$exports, "getClient", () => $b244ff70a28cf637$exports.getClient);
$parcel$export($054fa894e15f1de5$exports, "getCurrentScope", () => $b244ff70a28cf637$exports.getCurrentScope);
$parcel$export($054fa894e15f1de5$exports, "getGlobalScope", () => $b244ff70a28cf637$exports.getGlobalScope);
$parcel$export($054fa894e15f1de5$exports, "getIsolationScope", () => $b244ff70a28cf637$exports.getIsolationScope);
$parcel$export($054fa894e15f1de5$exports, "getRootSpan", () => $b244ff70a28cf637$exports.getRootSpan);
$parcel$export($054fa894e15f1de5$exports, "getSpanDescendants", () => $b244ff70a28cf637$exports.getSpanDescendants);
$parcel$export($054fa894e15f1de5$exports, "getSpanStatusFromHttpCode", () => $b244ff70a28cf637$exports.getSpanStatusFromHttpCode);
$parcel$export($054fa894e15f1de5$exports, "getTraceData", () => $b244ff70a28cf637$exports.getTraceData);
$parcel$export($054fa894e15f1de5$exports, "inboundFiltersIntegration", () => $b244ff70a28cf637$exports.inboundFiltersIntegration);
$parcel$export($054fa894e15f1de5$exports, "instrumentAnthropicAiClient", () => $b244ff70a28cf637$exports.instrumentAnthropicAiClient);
$parcel$export($054fa894e15f1de5$exports, "instrumentCreateReactAgent", () => $b244ff70a28cf637$exports.instrumentCreateReactAgent);
$parcel$export($054fa894e15f1de5$exports, "instrumentGoogleGenAIClient", () => $b244ff70a28cf637$exports.instrumentGoogleGenAIClient);
$parcel$export($054fa894e15f1de5$exports, "instrumentLangChainEmbeddings", () => $b244ff70a28cf637$exports.instrumentLangChainEmbeddings);
$parcel$export($054fa894e15f1de5$exports, "instrumentLangGraph", () => $b244ff70a28cf637$exports.instrumentLangGraph);
$parcel$export($054fa894e15f1de5$exports, "instrumentOpenAiClient", () => $b244ff70a28cf637$exports.instrumentOpenAiClient);
$parcel$export($054fa894e15f1de5$exports, "instrumentStateGraph", () => $b244ff70a28cf637$exports.instrumentStateGraph);
$parcel$export($054fa894e15f1de5$exports, "instrumentSupabaseClient", () => $b244ff70a28cf637$exports.instrumentSupabaseClient);
$parcel$export($054fa894e15f1de5$exports, "isEnabled", () => $b244ff70a28cf637$exports.isEnabled);
$parcel$export($054fa894e15f1de5$exports, "isInitialized", () => $b244ff70a28cf637$exports.isInitialized);
$parcel$export($054fa894e15f1de5$exports, "lastEventId", () => $b244ff70a28cf637$exports.lastEventId);
$parcel$export($054fa894e15f1de5$exports, "logger", () => $b244ff70a28cf637$exports.logger);
$parcel$export($054fa894e15f1de5$exports, "makeMultiplexedTransport", () => $b244ff70a28cf637$exports.makeMultiplexedTransport);
$parcel$export($054fa894e15f1de5$exports, "metrics", () => $b244ff70a28cf637$exports.metrics);
$parcel$export($054fa894e15f1de5$exports, "moduleMetadataIntegration", () => $b244ff70a28cf637$exports.moduleMetadataIntegration);
$parcel$export($054fa894e15f1de5$exports, "parameterize", () => $b244ff70a28cf637$exports.parameterize);
$parcel$export($054fa894e15f1de5$exports, "registerSpanErrorInstrumentation", () => $b244ff70a28cf637$exports.registerSpanErrorInstrumentation);
$parcel$export($054fa894e15f1de5$exports, "rewriteFramesIntegration", () => $b244ff70a28cf637$exports.rewriteFramesIntegration);
$parcel$export($054fa894e15f1de5$exports, "setAttribute", () => $b244ff70a28cf637$exports.setAttribute);
$parcel$export($054fa894e15f1de5$exports, "setAttributes", () => $b244ff70a28cf637$exports.setAttributes);
$parcel$export($054fa894e15f1de5$exports, "setContext", () => $b244ff70a28cf637$exports.setContext);
$parcel$export($054fa894e15f1de5$exports, "setConversationId", () => $b244ff70a28cf637$exports.setConversationId);
$parcel$export($054fa894e15f1de5$exports, "setCurrentClient", () => $b244ff70a28cf637$exports.setCurrentClient);
$parcel$export($054fa894e15f1de5$exports, "setExtra", () => $b244ff70a28cf637$exports.setExtra);
$parcel$export($054fa894e15f1de5$exports, "setExtras", () => $b244ff70a28cf637$exports.setExtras);
$parcel$export($054fa894e15f1de5$exports, "setHttpStatus", () => $b244ff70a28cf637$exports.setHttpStatus);
$parcel$export($054fa894e15f1de5$exports, "setMeasurement", () => $b244ff70a28cf637$exports.setMeasurement);
$parcel$export($054fa894e15f1de5$exports, "setTag", () => $b244ff70a28cf637$exports.setTag);
$parcel$export($054fa894e15f1de5$exports, "setTags", () => $b244ff70a28cf637$exports.setTags);
$parcel$export($054fa894e15f1de5$exports, "setUser", () => $b244ff70a28cf637$exports.setUser);
$parcel$export($054fa894e15f1de5$exports, "spanToBaggageHeader", () => $b244ff70a28cf637$exports.spanToBaggageHeader);
$parcel$export($054fa894e15f1de5$exports, "spanToJSON", () => $b244ff70a28cf637$exports.spanToJSON);
$parcel$export($054fa894e15f1de5$exports, "spanToTraceHeader", () => $b244ff70a28cf637$exports.spanToTraceHeader);
$parcel$export($054fa894e15f1de5$exports, "startInactiveSpan", () => $b244ff70a28cf637$exports.startInactiveSpan);
$parcel$export($054fa894e15f1de5$exports, "startNewTrace", () => $b244ff70a28cf637$exports.startNewTrace);
$parcel$export($054fa894e15f1de5$exports, "startSession", () => $b244ff70a28cf637$exports.startSession);
$parcel$export($054fa894e15f1de5$exports, "startSpan", () => $b244ff70a28cf637$exports.startSpan);
$parcel$export($054fa894e15f1de5$exports, "startSpanManual", () => $b244ff70a28cf637$exports.startSpanManual);
$parcel$export($054fa894e15f1de5$exports, "supabaseIntegration", () => $b244ff70a28cf637$exports.supabaseIntegration);
$parcel$export($054fa894e15f1de5$exports, "suppressTracing", () => $b244ff70a28cf637$exports.suppressTracing);
$parcel$export($054fa894e15f1de5$exports, "thirdPartyErrorFilterIntegration", () => $b244ff70a28cf637$exports.thirdPartyErrorFilterIntegration);
$parcel$export($054fa894e15f1de5$exports, "updateSpanName", () => $b244ff70a28cf637$exports.updateSpanName);
$parcel$export($054fa894e15f1de5$exports, "withActiveSpan", () => $b244ff70a28cf637$exports.withActiveSpan);
$parcel$export($054fa894e15f1de5$exports, "withIsolationScope", () => $b244ff70a28cf637$exports.withIsolationScope);
$parcel$export($054fa894e15f1de5$exports, "withScope", () => $b244ff70a28cf637$exports.withScope);
$parcel$export($054fa894e15f1de5$exports, "withStreamedSpan", () => $b244ff70a28cf637$exports.withStreamedSpan);
$parcel$export($054fa894e15f1de5$exports, "zodErrorsIntegration", () => $b244ff70a28cf637$exports.zodErrorsIntegration);
$parcel$export($054fa894e15f1de5$exports, "WINDOW", () => $e62dec891f31852b$export$56d8a8a25bd48b81);
$parcel$export($054fa894e15f1de5$exports, "BrowserClient", () => $4e1ce061c21a5e69$export$1df9218a526d318d);
$parcel$export($054fa894e15f1de5$exports, "makeFetchTransport", () => $366021d20f9daad3$export$b2311068c46d7cc8);
$parcel$export($054fa894e15f1de5$exports, "uiProfiler", () => $61e522e7948b3efb$export$c7cf24e2253024f3);
$parcel$export($054fa894e15f1de5$exports, "chromeStackLineParser", () => $5c2a6884ada474e9$export$263a749fff749872);
$parcel$export($054fa894e15f1de5$exports, "defaultStackLineParsers", () => $5c2a6884ada474e9$export$7197c0fe6554c079);
$parcel$export($054fa894e15f1de5$exports, "defaultStackParser", () => $5c2a6884ada474e9$export$2b2b997d81bf3907);
$parcel$export($054fa894e15f1de5$exports, "geckoStackLineParser", () => $5c2a6884ada474e9$export$cdba47a5dd2804d);
$parcel$export($054fa894e15f1de5$exports, "opera10StackLineParser", () => $5c2a6884ada474e9$export$f892b52c880ffc7a);
$parcel$export($054fa894e15f1de5$exports, "opera11StackLineParser", () => $5c2a6884ada474e9$export$af11af13f09fb0dc);
$parcel$export($054fa894e15f1de5$exports, "winjsStackLineParser", () => $5c2a6884ada474e9$export$179460296da408e8);
$parcel$export($054fa894e15f1de5$exports, "eventFromException", () => $934e8a4b0ce930b6$export$ea3ec7e569b823fc);
$parcel$export($054fa894e15f1de5$exports, "eventFromMessage", () => $934e8a4b0ce930b6$export$5425b53185d13d6c);
$parcel$export($054fa894e15f1de5$exports, "exceptionFromError", () => $934e8a4b0ce930b6$export$a6c2d27607295951);
$parcel$export($054fa894e15f1de5$exports, "createUserFeedbackEnvelope", () => $b80b1f8b91224d00$export$24a4dfcb686ee5bf);
$parcel$export($054fa894e15f1de5$exports, "forceLoad", () => $14d7809dba5d50b0$export$a3f323d81eede727);
$parcel$export($054fa894e15f1de5$exports, "getDefaultIntegrations", () => $14d7809dba5d50b0$export$5783b2920b1d62b9);
$parcel$export($054fa894e15f1de5$exports, "init", () => $14d7809dba5d50b0$export$2cd8252107eb640b);
$parcel$export($054fa894e15f1de5$exports, "onLoad", () => $14d7809dba5d50b0$export$4e4d8b287d028b6b);
$parcel$export($054fa894e15f1de5$exports, "showReportDialog", () => $c145e0c6ce486f3a$export$3a8fd680da42627b);
$parcel$export($054fa894e15f1de5$exports, "breadcrumbsIntegration", () => $0ad9abad7f8d2d66$export$c079d904b326663a);
$parcel$export($054fa894e15f1de5$exports, "globalHandlersIntegration", () => $f1959cdcacc276d1$export$66acc70e8cf2b71a);
$parcel$export($054fa894e15f1de5$exports, "httpContextIntegration", () => $2fcda6dfa3c250e9$export$1378794447170364);
$parcel$export($054fa894e15f1de5$exports, "linkedErrorsIntegration", () => $ce07fe89a71836e2$export$ebabb00eb7f3a395);
$parcel$export($054fa894e15f1de5$exports, "browserApiErrorsIntegration", () => $fa3dc958cc9f40d6$export$59bfe9f1c76150e);
$parcel$export($054fa894e15f1de5$exports, "browserSessionIntegration", () => $9bfd264dc60b3ee5$export$1baa7880e357371c);
$parcel$export($054fa894e15f1de5$exports, "lazyLoadIntegration", () => $3fc94f2ac1572f6d$export$6da56f3ddf2bd0c1);
$parcel$export($054fa894e15f1de5$exports, "reportingObserverIntegration", () => $a0ba0212b29c7bfc$export$609cccfa9f328cc5);
$parcel$export($054fa894e15f1de5$exports, "httpClientIntegration", () => $899ee8298ebc75fb$export$8a3b7aeb379b3907);
$parcel$export($054fa894e15f1de5$exports, "contextLinesIntegration", () => $e5ba3b05859a226d$export$74173d114ed4f354);
$parcel$export($054fa894e15f1de5$exports, "graphqlClientIntegration", () => $09df6a71d9392bb9$export$a934e57cd817247a);
$parcel$export($054fa894e15f1de5$exports, "viewHierarchyIntegration", () => $1b8d06c5085d8bec$export$3264be986dfdbb57);
$parcel$export($054fa894e15f1de5$exports, "getReplay", () => $37d5a74137b0c6f7$export$b28310b2f161456b);
$parcel$export($054fa894e15f1de5$exports, "replayIntegration", () => $37d5a74137b0c6f7$export$d7706faf7ab354bf);
$parcel$export($054fa894e15f1de5$exports, "replayCanvasIntegration", () => $8bd8504558a4e735$export$71ba62165d5c834d);
$parcel$export($054fa894e15f1de5$exports, "getFeedback", () => $79d5e278c02a445b$export$ed85ee0b85ce96e1);
$parcel$export($054fa894e15f1de5$exports, "sendFeedback", () => $79d5e278c02a445b$export$a65d69dd22caceda);
$parcel$export($054fa894e15f1de5$exports, "defaultRequestInstrumentationOptions", () => $b3e0e430d6ae504d$export$cc17fb3c0bc95cd7);
$parcel$export($054fa894e15f1de5$exports, "instrumentOutgoingRequests", () => $b3e0e430d6ae504d$export$864489cb3478db3e);
$parcel$export($054fa894e15f1de5$exports, "browserTracingIntegration", () => $7b5f2a588355dc11$export$b4109253475213e9);
$parcel$export($054fa894e15f1de5$exports, "isBotUserAgent", () => $7b5f2a588355dc11$export$e189d11d152c4191);
$parcel$export($054fa894e15f1de5$exports, "startBrowserTracingNavigationSpan", () => $7b5f2a588355dc11$export$7d159749bd9969ad);
$parcel$export($054fa894e15f1de5$exports, "startBrowserTracingPageLoadSpan", () => $7b5f2a588355dc11$export$aa44a07f82af519f);
$parcel$export($054fa894e15f1de5$exports, "elementTimingIntegration", () => $c367925a6b0c021e$export$653abef5c5d8f324);
$parcel$export($054fa894e15f1de5$exports, "getAbsoluteUrl", () => $fd75502b1c3baf49$export$8ca4f6d95250b4ec);
$parcel$export($054fa894e15f1de5$exports, "normalizeStringifyValue", () => $a464f0062cc3e108$export$4c88c355e6072df5);
$parcel$export($054fa894e15f1de5$exports, "reportPageLoaded", () => $e3f9649a5fcc80c1$export$9e8f428c76bd6d1b);
$parcel$export($054fa894e15f1de5$exports, "setActiveSpanInBrowser", () => $40d8570c26789de3$export$4519ca486fe8649b);
$parcel$export($054fa894e15f1de5$exports, "spanStreamingIntegration", () => $dbac00e0df14d30e$export$6eda3f5129248a75);
$parcel$export($054fa894e15f1de5$exports, "fetchStreamPerformanceIntegration", () => $d3fcc56003188f2b$export$b49e0d1a48dc8754);
$parcel$export($054fa894e15f1de5$exports, "webVitalsIntegration", () => $9477c2bd0ffb81e8$export$1ab4995602e8adaa);
$parcel$export($054fa894e15f1de5$exports, "makeBrowserOfflineTransport", () => $c405876784a7ff78$export$79c8882827636cf2);
$parcel$export($054fa894e15f1de5$exports, "browserProfilingIntegration", () => $ddc68b5832e965a7$export$2c7b5d6dd5622f23);
$parcel$export($054fa894e15f1de5$exports, "spotlightBrowserIntegration", () => $75c15b1f5f212f04$export$a05c07c0f32f730a);
$parcel$export($054fa894e15f1de5$exports, "cultureContextIntegration", () => $5784fbfdd799cccf$export$ec5976aacdc85985);
$parcel$export($054fa894e15f1de5$exports, "buildLaunchDarklyFlagUsedHandler", () => $2849f1c84e195cf6$export$f97714c0986edb0);
$parcel$export($054fa894e15f1de5$exports, "launchDarklyIntegration", () => $2849f1c84e195cf6$export$7cd9c18538ed792e);
$parcel$export($054fa894e15f1de5$exports, "OpenFeatureIntegrationHook", () => $6878dd2c72de26fa$export$f399add65bfd388e);
$parcel$export($054fa894e15f1de5$exports, "openFeatureIntegration", () => $6878dd2c72de26fa$export$a41102cd52abbd1b);
$parcel$export($054fa894e15f1de5$exports, "unleashIntegration", () => $d2291f482b064e01$export$e753ab651e68430d);
$parcel$export($054fa894e15f1de5$exports, "growthbookIntegration", () => $382b31aa5714bdd4$export$c8399a95701fbc9f);
$parcel$export($054fa894e15f1de5$exports, "statsigIntegration", () => $cd57e45df1dff5a4$export$473918ef9c3b2ab7);
$parcel$export($054fa894e15f1de5$exports, "diagnoseSdkConnectivity", () => $7819adec6ec21508$export$fecc80c9f0e9c1b2);
$parcel$export($054fa894e15f1de5$exports, "registerWebWorker", () => $907c5ffa3e02c638$export$86daa8bd1fb8c346);
$parcel$export($054fa894e15f1de5$exports, "webWorkerIntegration", () => $907c5ffa3e02c638$export$88896133e37bd4db);
const $dcd58747d787136d$export$31499a9cd224b78c = "10.75.1";


const $736a69486c86d36c$export$f1a6cdb1459e81d1 = globalThis;


function $e4c75fb63b040566$export$19eade501500c6c1() {
    $e4c75fb63b040566$export$c8bfa33e4e8ae492((0, $736a69486c86d36c$export$f1a6cdb1459e81d1));
    return 0, $736a69486c86d36c$export$f1a6cdb1459e81d1;
}
function $e4c75fb63b040566$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.version = __SENTRY__.version || (0, $dcd58747d787136d$export$31499a9cd224b78c);
    return __SENTRY__[0, $dcd58747d787136d$export$31499a9cd224b78c] = __SENTRY__[0, $dcd58747d787136d$export$31499a9cd224b78c] || {};
}
function $e4c75fb63b040566$export$7e223ec222791509(name, creator, obj = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $dcd58747d787136d$export$31499a9cd224b78c] = __SENTRY__[0, $dcd58747d787136d$export$31499a9cd224b78c] || {};
    return carrier[name] || (carrier[name] = creator());
}



const $19fdbaf7f0830971$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;






const $d11ed0b3cdda6b8d$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
const $d11ed0b3cdda6b8d$var$PREFIX = "Sentry Logger ";
const $d11ed0b3cdda6b8d$export$77c4ce905194557b = {};
function $d11ed0b3cdda6b8d$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $736a69486c86d36c$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($d11ed0b3cdda6b8d$export$77c4ce905194557b);
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $d11ed0b3cdda6b8d$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $d11ed0b3cdda6b8d$var$enable() {
    $d11ed0b3cdda6b8d$var$_getLoggerSettings().enabled = true;
}
function $d11ed0b3cdda6b8d$var$disable() {
    $d11ed0b3cdda6b8d$var$_getLoggerSettings().enabled = false;
}
function $d11ed0b3cdda6b8d$var$isEnabled() {
    return $d11ed0b3cdda6b8d$var$_getLoggerSettings().enabled;
}
function $d11ed0b3cdda6b8d$var$log(...args) {
    $d11ed0b3cdda6b8d$var$_maybeLog("log", ...args);
}
function $d11ed0b3cdda6b8d$var$warn(...args) {
    $d11ed0b3cdda6b8d$var$_maybeLog("warn", ...args);
}
function $d11ed0b3cdda6b8d$var$error(...args) {
    $d11ed0b3cdda6b8d$var$_maybeLog("error", ...args);
}
function $d11ed0b3cdda6b8d$var$_maybeLog(level, ...args) {
    if (!(0, $19fdbaf7f0830971$export$16a28057038b10ef)) return;
    if ($d11ed0b3cdda6b8d$var$isEnabled()) $d11ed0b3cdda6b8d$export$cda52e2a8927a2ca(()=>{
        (0, $736a69486c86d36c$export$f1a6cdb1459e81d1).console[level](`${$d11ed0b3cdda6b8d$var$PREFIX}[${level}]:`, ...args);
    });
}
function $d11ed0b3cdda6b8d$var$_getLoggerSettings() {
    if (!(0, $19fdbaf7f0830971$export$16a28057038b10ef)) return {
        enabled: false
    };
    return (0, $e4c75fb63b040566$export$7e223ec222791509)("loggerSettings", ()=>({
            enabled: false
        }));
}
const $d11ed0b3cdda6b8d$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $d11ed0b3cdda6b8d$var$enable,
    disable: /** Disable logging. */ $d11ed0b3cdda6b8d$var$disable,
    isEnabled: /** Check if logging is enabled. */ $d11ed0b3cdda6b8d$var$isEnabled,
    log: /** Log a message. */ $d11ed0b3cdda6b8d$var$log,
    warn: /** Log a warning. */ $d11ed0b3cdda6b8d$var$warn,
    error: /** Log an error. */ $d11ed0b3cdda6b8d$var$error
};


const $13cf2ed412f405fa$var$objectToString = Object.prototype.toString;
function $13cf2ed412f405fa$export$e6127cc7fe7395c3(wat) {
    switch($13cf2ed412f405fa$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $13cf2ed412f405fa$export$49034edbe6b62415(wat, Error);
    }
}
function $13cf2ed412f405fa$var$isBuiltin(wat, className) {
    return $13cf2ed412f405fa$var$objectToString.call(wat) === `[object ${className}]`;
}
function $13cf2ed412f405fa$export$9f9636d330b71954(wat) {
    return $13cf2ed412f405fa$var$isBuiltin(wat, "ErrorEvent");
}
function $13cf2ed412f405fa$export$ef9e2056653f0c8e(wat) {
    return $13cf2ed412f405fa$var$isBuiltin(wat, "DOMError");
}
function $13cf2ed412f405fa$export$12e869b2a583f783(wat) {
    return $13cf2ed412f405fa$var$isBuiltin(wat, "DOMException");
}
function $13cf2ed412f405fa$export$844ec244b1367d54(wat) {
    return $13cf2ed412f405fa$var$isBuiltin(wat, "String");
}
function $13cf2ed412f405fa$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function $13cf2ed412f405fa$export$c3825b437cbdea5c(wat) {
    return wat === null || $13cf2ed412f405fa$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function $13cf2ed412f405fa$export$53b83ca8eaab0383(wat) {
    return $13cf2ed412f405fa$var$isBuiltin(wat, "Object");
}
function $13cf2ed412f405fa$export$c10d0b04eaa80a43(wat) {
    return typeof wat === "object" && wat !== null;
}
function $13cf2ed412f405fa$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $13cf2ed412f405fa$export$49034edbe6b62415(wat, Event);
}
function $13cf2ed412f405fa$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $13cf2ed412f405fa$export$49034edbe6b62415(wat, Element);
}
function $13cf2ed412f405fa$export$49841c62b9eff15(wat) {
    return $13cf2ed412f405fa$var$isBuiltin(wat, "RegExp");
}
function $13cf2ed412f405fa$export$f5b060c2914b97c8(wat) {
    return Boolean(wat?.then && typeof wat.then === "function");
}
function $13cf2ed412f405fa$export$bc2894c7158efbac(wat) {
    return $13cf2ed412f405fa$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $13cf2ed412f405fa$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
function $13cf2ed412f405fa$export$7916fad0ebc23f48(wat) {
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function $13cf2ed412f405fa$export$6d3d1f317d7cda57(request) {
    return typeof Request !== "undefined" && $13cf2ed412f405fa$export$49034edbe6b62415(request, Request);
}


function $269eeb69635ed414$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    if (typeof wrapped === "function") $269eeb69635ed414$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Failed to replace method "${name}" in object`, source);
    }
}
function $269eeb69635ed414$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
function $269eeb69635ed414$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $269eeb69635ed414$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch  {}
}
function $269eeb69635ed414$export$e00416b3cd122575(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($269eeb69635ed414$export$e6cc1e135e2092e5(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $269eeb69635ed414$export$5c1499e2e5d010ae(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
function $269eeb69635ed414$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $269eeb69635ed414$export$62ff257738bf57f5(value) {
    if ((0, $13cf2ed412f405fa$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$269eeb69635ed414$var$getOwnProperties(value)
    };
    if ((0, $13cf2ed412f405fa$export$9671ea99bd126ace)(value)) {
        const { type: type, target: target, currentTarget: currentTarget, detail: detail } = value;
        return {
            type: type,
            target: target,
            currentTarget: currentTarget,
            ...detail ? {
                detail: detail
            } : {},
            ...$269eeb69635ed414$var$getOwnProperties(value)
        };
    }
    return value;
}
function $269eeb69635ed414$var$getOwnProperties(obj) {
    if ((0, $13cf2ed412f405fa$export$c10d0b04eaa80a43)(obj)) return Object.fromEntries(Object.entries(obj));
    return {};
}
function $269eeb69635ed414$export$b0244d5063c0b61b(exception) {
    const keys = Object.keys($269eeb69635ed414$export$62ff257738bf57f5(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function $269eeb69635ed414$export$d25f2688db1bb433(inputValue) {
    const memoizationMap = /* @__PURE__ */ new Map();
    return $269eeb69635ed414$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $269eeb69635ed414$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) return memoVal;
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($269eeb69635ed414$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($269eeb69635ed414$var$isPojo(inputValue)) {
        const returnValue = {};
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== void 0) returnValue[key] = $269eeb69635ed414$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    return inputValue;
}
function $269eeb69635ed414$var$isPojo(input) {
    const constructor = input.constructor;
    return constructor === Object || constructor === void 0;
}
function $269eeb69635ed414$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == void 0:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $13cf2ed412f405fa$export$c3825b437cbdea5c)(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}



let $c80d7f6644a3b50b$var$RESOLVED_RUNNER;
function $c80d7f6644a3b50b$export$ff239213cb80e2da(cb) {
    if ($c80d7f6644a3b50b$var$RESOLVED_RUNNER !== void 0) return $c80d7f6644a3b50b$var$RESOLVED_RUNNER ? $c80d7f6644a3b50b$var$RESOLVED_RUNNER(cb) : cb();
    const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1);
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $c80d7f6644a3b50b$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $c80d7f6644a3b50b$var$RESOLVED_RUNNER(cb);
    }
    $c80d7f6644a3b50b$var$RESOLVED_RUNNER = null;
    return cb();
}
function $c80d7f6644a3b50b$export$9869d72de32a3917() {
    return $c80d7f6644a3b50b$export$ff239213cb80e2da(()=>Math.random());
}
function $c80d7f6644a3b50b$export$65b1bada40c91b34() {
    return $c80d7f6644a3b50b$export$ff239213cb80e2da(()=>Date.now());
}




const $bc6dd22c95709611$var$SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const $bc6dd22c95709611$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function $bc6dd22c95709611$export$280812de8e91ea53(obj) {
    (0, $269eeb69635ed414$export$e73679ffaf56810e)(obj, $bc6dd22c95709611$var$SENTRY_SKIP_NORMALIZATION, true);
}
function $bc6dd22c95709611$export$610d1422c4bdc4c1(obj, depth) {
    (0, $269eeb69635ed414$export$e73679ffaf56810e)(obj, $bc6dd22c95709611$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function $bc6dd22c95709611$export$c8d26b7b28f926c7(value) {
    return Boolean(value[$bc6dd22c95709611$var$SENTRY_SKIP_NORMALIZATION]);
}
function $bc6dd22c95709611$export$fe95a19841c4b155(value) {
    const v = value[$bc6dd22c95709611$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : void 0;
}



const $9ed2cf4edd0b2db9$var$STACKTRACE_FRAME_LIMIT = 50;
const $9ed2cf4edd0b2db9$export$27c7e15d453fc0ac = "?";
const $9ed2cf4edd0b2db9$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $9ed2cf4edd0b2db9$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function $9ed2cf4edd0b2db9$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            if (line.length > 1024) line = line.slice(0, 1024);
            const cleanedLine = $9ed2cf4edd0b2db9$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($9ed2cf4edd0b2db9$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $9ed2cf4edd0b2db9$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $9ed2cf4edd0b2db9$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
function $9ed2cf4edd0b2db9$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $9ed2cf4edd0b2db9$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
function $9ed2cf4edd0b2db9$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    if (/sentryWrapped/.test($9ed2cf4edd0b2db9$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    localStack.reverse();
    if ($9ed2cf4edd0b2db9$var$STRIP_FRAME_REGEXP.test($9ed2cf4edd0b2db9$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        if ($9ed2cf4edd0b2db9$var$STRIP_FRAME_REGEXP.test($9ed2cf4edd0b2db9$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $9ed2cf4edd0b2db9$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $9ed2cf4edd0b2db9$var$getLastStackFrame(localStack).filename,
            function: frame.function || $9ed2cf4edd0b2db9$export$27c7e15d453fc0ac
        }));
}
function $9ed2cf4edd0b2db9$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $9ed2cf4edd0b2db9$var$defaultFunctionName = "<anonymous>";
function $9ed2cf4edd0b2db9$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $9ed2cf4edd0b2db9$var$defaultFunctionName;
        return fn.name || $9ed2cf4edd0b2db9$var$defaultFunctionName;
    } catch  {
        return $9ed2cf4edd0b2db9$var$defaultFunctionName;
    }
}
function $9ed2cf4edd0b2db9$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            exception.values.forEach((value)=>{
                if (value.stacktrace.frames) frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return void 0;
        }
    }
    return void 0;
}
function $9ed2cf4edd0b2db9$export$60c0d6c8e038267a(path) {
    let filename = path?.startsWith("file://") ? path.slice(7) : path;
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}


let $2d7134eeb4bc669b$var$stringifier;
function $2d7134eeb4bc669b$export$575c40989754ba4d(newStringifier) {
    $2d7134eeb4bc669b$var$stringifier = newStringifier;
}
function $2d7134eeb4bc669b$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        return $2d7134eeb4bc669b$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
function $2d7134eeb4bc669b$export$23fbbb20bed71033(object, depth = 3, maxSize = 102400) {
    const normalized = $2d7134eeb4bc669b$export$a3295358bff77e(object, depth);
    if ($2d7134eeb4bc669b$var$jsonSize(normalized) > maxSize) return $2d7134eeb4bc669b$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
function $2d7134eeb4bc669b$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $2d7134eeb4bc669b$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $2d7134eeb4bc669b$export$a110e5bc79f44a84(key, value);
    if (!stringified.startsWith("[object ")) return stringified;
    if ((0, $bc6dd22c95709611$export$c8d26b7b28f926c7)(value)) return value;
    const overrideDepth = (0, $bc6dd22c95709611$export$fe95a19841c4b155)(value);
    const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
    if (remainingDepth === 0) return stringified.replace("object ", "");
    if (memoize(value)) return "[Circular ~]";
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        return $2d7134eeb4bc669b$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {}
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    const visitable = (0, $269eeb69635ed414$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $2d7134eeb4bc669b$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function $2d7134eeb4bc669b$export$a110e5bc79f44a84(key, value) {
    try {
        if ($2d7134eeb4bc669b$var$stringifier) {
            const stringified = $2d7134eeb4bc669b$var$stringifier(value);
            if (stringified) return stringified;
        }
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $9ed2cf4edd0b2db9$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        const objName = $2d7134eeb4bc669b$var$getConstructorName(value);
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $2d7134eeb4bc669b$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
function $2d7134eeb4bc669b$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function $2d7134eeb4bc669b$var$jsonSize(value) {
    return $2d7134eeb4bc669b$var$utf8Length(JSON.stringify(value));
}
function $2d7134eeb4bc669b$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {}
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
function $2d7134eeb4bc669b$var$memoBuilder() {
    const inner = /* @__PURE__ */ new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}


function $e534db390d1e4996$export$fac44ee5b035f737(value, fallback = "[unserializable]") {
    if (typeof value === "string") return value;
    try {
        return JSON.stringify(value);
    } catch  {
        return typeof fallback === "function" ? fallback(value) : fallback;
    }
}
function $e534db390d1e4996$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function $e534db390d1e4996$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $e534db390d1e4996$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if ((0, $13cf2ed412f405fa$export$c3825b437cbdea5c)(value)) output.push(String(value));
        else if (value instanceof Error) output.push(value.message ? `${value.name}: ${value.message}` : value.name);
        else output.push((0, $2d7134eeb4bc669b$export$a110e5bc79f44a84)(void 0, value));
    }
    return output.join(delimiter);
}
function $e534db390d1e4996$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $13cf2ed412f405fa$export$844ec244b1367d54)(value)) return false;
    if ((0, $13cf2ed412f405fa$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $13cf2ed412f405fa$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
function $e534db390d1e4996$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($e534db390d1e4996$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}



function $cc262db35458e4b3$var$getCrypto() {
    const gbl = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
let $cc262db35458e4b3$var$emptyUuid;
function $cc262db35458e4b3$var$getRandomByte() {
    return (0, $c80d7f6644a3b50b$export$9869d72de32a3917)() * 16;
}
function $cc262db35458e4b3$export$19f53698e68b2496(crypto = $cc262db35458e4b3$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) return (0, $c80d7f6644a3b50b$export$ff239213cb80e2da)(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch  {}
    if (!$cc262db35458e4b3$var$emptyUuid) $cc262db35458e4b3$var$emptyUuid = "10000000100040008000100000000000";
    return $cc262db35458e4b3$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($cc262db35458e4b3$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $cc262db35458e4b3$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
function $cc262db35458e4b3$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $cc262db35458e4b3$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $cc262db35458e4b3$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $cc262db35458e4b3$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $cc262db35458e4b3$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
const $cc262db35458e4b3$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $cc262db35458e4b3$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
function $cc262db35458e4b3$export$d364f2020ab30578(input) {
    const match = input.match($cc262db35458e4b3$var$SEMVER_REGEXP) || [];
    const major = $cc262db35458e4b3$var$_parseInt(match[1]);
    const minor = $cc262db35458e4b3$var$_parseInt(match[2]);
    const patch = $cc262db35458e4b3$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? void 0 : major,
        minor: isNaN(minor) ? void 0 : minor,
        patch: isNaN(patch) ? void 0 : patch,
        prerelease: match[4]
    };
}
function $cc262db35458e4b3$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    if (frame.lineno === void 0) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $e534db390d1e4996$export$4215662d762d6f9d)(line, 0));
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    frame.context_line = (0, $e534db390d1e4996$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $e534db390d1e4996$export$4215662d762d6f9d)(line, 0));
}
function $cc262db35458e4b3$export$6de4ffac6a2f1098(exception) {
    if ($cc262db35458e4b3$export$4a38e013f66150b(exception)) return true;
    try {
        (0, $269eeb69635ed414$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch  {}
    return false;
}
function $cc262db35458e4b3$export$4a38e013f66150b(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {}
}




const $bc81602376c48fa6$var$ONE_SECOND_IN_MS = 1e3;
function $bc81602376c48fa6$export$7740643b9eeaf0c4() {
    return (0, $c80d7f6644a3b50b$export$65b1bada40c91b34)() / $bc81602376c48fa6$var$ONE_SECOND_IN_MS;
}
function $bc81602376c48fa6$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1);
    if (!performance?.now || !performance.timeOrigin) return $bc81602376c48fa6$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    return ()=>{
        return (timeOrigin + (0, $c80d7f6644a3b50b$export$ff239213cb80e2da)(()=>performance.now())) / $bc81602376c48fa6$var$ONE_SECOND_IN_MS;
    };
}
let $bc81602376c48fa6$var$_cachedTimestampInSeconds;
function $bc81602376c48fa6$export$ee52dced521e3e18() {
    const func = $bc81602376c48fa6$var$_cachedTimestampInSeconds ?? ($bc81602376c48fa6$var$_cachedTimestampInSeconds = $bc81602376c48fa6$var$createUnixTimestampInSecondsFunc());
    return func();
}
let $bc81602376c48fa6$var$cachedTimeOrigin = null;
function $bc81602376c48fa6$var$getBrowserTimeOrigin() {
    const { performance: performance } = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1);
    if (!performance?.now) return void 0;
    const threshold = 3e5;
    const performanceNow = (0, $c80d7f6644a3b50b$export$ff239213cb80e2da)(()=>performance.now());
    const dateNow = (0, $c80d7f6644a3b50b$export$65b1bada40c91b34)();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === "number") {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    return dateNow - performanceNow;
}
function $bc81602376c48fa6$export$baf075a948ffc0bf() {
    if ($bc81602376c48fa6$var$cachedTimeOrigin === null) $bc81602376c48fa6$var$cachedTimeOrigin = $bc81602376c48fa6$var$getBrowserTimeOrigin();
    return $bc81602376c48fa6$var$cachedTimeOrigin;
}


function $e6ef9757665bd407$export$14a186326edbb264(context) {
    const startingTime = (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $cc262db35458e4b3$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$e6ef9757665bd407$var$sessionToJSON(session)
    };
    if (context) $e6ef9757665bd407$export$531818e825e774db(session, context);
    return session;
}
function $e6ef9757665bd407$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) session.sid = context.sid.length === 32 ? context.sid : (0, $cc262db35458e4b3$export$19f53698e68b2496)();
    if (context.init !== void 0) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = void 0;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
function $e6ef9757665bd407$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $e6ef9757665bd407$export$531818e825e774db(session, context);
}
function $e6ef9757665bd407$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1e3).toISOString(),
        timestamp: new Date(session.timestamp * 1e3).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}




function $40b0d31022c415bf$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    const output = {
        ...initialObj
    };
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $40b0d31022c415bf$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}




function $ece9bac57decbcb8$export$dc6d7ea554bcce10() {
    return (0, $cc262db35458e4b3$export$19f53698e68b2496)();
}
function $ece9bac57decbcb8$export$295213bc4d0c54ad() {
    return (0, $cc262db35458e4b3$export$19f53698e68b2496)().substring(16);
}





function $ea0bfeddd00a5349$export$f0b98edec95fcb33(value) {
    try {
        const WeakRefImpl = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1).WeakRef;
        if (typeof WeakRefImpl === "function") return new WeakRefImpl(value);
    } catch  {}
    return value;
}
function $ea0bfeddd00a5349$export$a0592ad8c3586cf(ref) {
    if (!ref) return void 0;
    if (typeof ref === "object" && "deref" in ref && typeof ref.deref === "function") try {
        return ref.deref();
    } catch  {
        return void 0;
    }
    return ref;
}


const $dab1970d0c142a42$var$SCOPE_SPAN_FIELD = "_sentrySpan";
function $dab1970d0c142a42$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $269eeb69635ed414$export$e73679ffaf56810e)(scope, $dab1970d0c142a42$var$SCOPE_SPAN_FIELD, (0, $ea0bfeddd00a5349$export$f0b98edec95fcb33)(span));
    else delete scope[$dab1970d0c142a42$var$SCOPE_SPAN_FIELD];
}
function $dab1970d0c142a42$export$91f063ebb8eff307(scope) {
    return (0, $ea0bfeddd00a5349$export$a0592ad8c3586cf)(scope[$dab1970d0c142a42$var$SCOPE_SPAN_FIELD]);
}




const $dd23bca0e7d7618a$var$DEFAULT_MAX_BREADCRUMBS = 100;
class $dd23bca0e7d7618a$export$775b6bb06e53a214 {
    // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $ece9bac57decbcb8$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $c80d7f6644a3b50b$export$9869d72de32a3917)()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $dd23bca0e7d7618a$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        (0, $dab1970d0c142a42$export$3f25fa50c18e20ca)(newScope, (0, $dab1970d0c142a42$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        this._user = user || {
            email: void 0,
            id: void 0,
            ip_address: void 0,
            username: void 0
        };
        if (this._session) (0, $e6ef9757665bd407$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || void 0;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param newAttributes - The attributes to set on the scope, as key-value pairs.
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: 150,
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param key - The attribute key.
   * @param value - The attribute value.
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', 150);
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $dd23bca0e7d7618a$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $13cf2ed412f405fa$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : void 0;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   *
   * @deprecated This method will be removed in v11. To reset scope state, re-initialize the SDK or run
   * your code in a fresh scope via `withScope` instead.
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = void 0;
        this._transactionName = void 0;
        this._fingerprint = void 0;
        this._session = void 0;
        this._conversationId = void 0;
        (0, $dab1970d0c142a42$export$3f25fa50c18e20ca)(this, void 0);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $ece9bac57decbcb8$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $c80d7f6644a3b50b$export$9869d72de32a3917)()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $dd23bca0e7d7618a$var$DEFAULT_MAX_BREADCRUMBS;
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $bc81602376c48fa6$export$7740643b9eeaf0c4)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $e534db390d1e4996$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $dab1970d0c142a42$export$91f063ebb8eff307)(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $40b0d31022c415bf$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $cc262db35458e4b3$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $cc262db35458e4b3$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || (0, $cc262db35458e4b3$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}


function $11e49251e9b07646$export$6f1b9191db9c4d5() {
    return (0, $e4c75fb63b040566$export$7e223ec222791509)("defaultCurrentScope", ()=>new (0, $dd23bca0e7d7618a$export$775b6bb06e53a214)());
}
function $11e49251e9b07646$export$de9862929b76bf57() {
    return (0, $e4c75fb63b040566$export$7e223ec222791509)("defaultIsolationScope", ()=>new (0, $dd23bca0e7d7618a$export$775b6bb06e53a214)());
}



const $fa8c9f9f1040feb6$var$isActualPromise = (p)=>p instanceof Promise && !p[$fa8c9f9f1040feb6$var$kChainedCopy];
const $fa8c9f9f1040feb6$var$kChainedCopy = /* @__PURE__ */ Symbol("chained PromiseLike");
const $fa8c9f9f1040feb6$export$64da0f40b0f924ba = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    return $fa8c9f9f1040feb6$var$isActualPromise(chained) && $fa8c9f9f1040feb6$var$isActualPromise(original) ? chained : $fa8c9f9f1040feb6$var$copyProps(original, chained);
};
const $fa8c9f9f1040feb6$var$copyProps = (original, chained)=>{
    if (!chained) return original;
    let mutated = false;
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === "function") Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$fa8c9f9f1040feb6$var$kChainedCopy]: true
    });
    return chained;
};




class $ca6289cc8b8b8640$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $dd23bca0e7d7618a$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $dd23bca0e7d7618a$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $13cf2ed412f405fa$export$f5b060c2914b97c8)(maybePromiseResult)) return (0, $fa8c9f9f1040feb6$export$64da0f40b0f924ba)(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
function $ca6289cc8b8b8640$var$getAsyncContextStack() {
    const registry = (0, $e4c75fb63b040566$export$19eade501500c6c1)();
    const sentry = (0, $e4c75fb63b040566$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $ca6289cc8b8b8640$export$d36ec451f120cfba((0, $11e49251e9b07646$export$6f1b9191db9c4d5)(), (0, $11e49251e9b07646$export$de9862929b76bf57)());
}
function $ca6289cc8b8b8640$var$withScope(callback) {
    return $ca6289cc8b8b8640$var$getAsyncContextStack().withScope(callback);
}
function $ca6289cc8b8b8640$var$withSetScope(scope, callback) {
    const stack = $ca6289cc8b8b8640$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $ca6289cc8b8b8640$var$withIsolationScope(callback) {
    return $ca6289cc8b8b8640$var$getAsyncContextStack().withScope(()=>{
        return callback($ca6289cc8b8b8640$var$getAsyncContextStack().getIsolationScope());
    });
}
function $ca6289cc8b8b8640$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $ca6289cc8b8b8640$var$withIsolationScope,
        withScope: $ca6289cc8b8b8640$var$withScope,
        withSetScope: $ca6289cc8b8b8640$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $ca6289cc8b8b8640$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$ca6289cc8b8b8640$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$ca6289cc8b8b8640$var$getAsyncContextStack().getIsolationScope()
    };
}


function $a8b8acc568359454$export$774ae0e6b6e444ca(strategy) {
    const registry = (0, $e4c75fb63b040566$export$19eade501500c6c1)();
    const sentry = (0, $e4c75fb63b040566$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
function $a8b8acc568359454$export$f639b0c2752203be(carrier) {
    const sentry = (0, $e4c75fb63b040566$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    return (0, $ca6289cc8b8b8640$export$329d4d4d54e42710)();
}





let $7d48e1ed9f699a01$var$_externalPropagationContextProvider;
function $7d48e1ed9f699a01$export$b5defb3466e9689b(fn) {
    $7d48e1ed9f699a01$var$_externalPropagationContextProvider = fn;
}
function $7d48e1ed9f699a01$export$92547f779c920a71() {
    return $7d48e1ed9f699a01$var$_externalPropagationContextProvider?.();
}
function $7d48e1ed9f699a01$export$53f0ae651a1c4298() {
    return $7d48e1ed9f699a01$var$_externalPropagationContextProvider !== void 0;
}
function $7d48e1ed9f699a01$export$c7be4b0125a10cba() {
    const carrier = (0, $e4c75fb63b040566$export$19eade501500c6c1)();
    const acs = (0, $a8b8acc568359454$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
function $7d48e1ed9f699a01$export$68f3af03034c9e90() {
    const carrier = (0, $e4c75fb63b040566$export$19eade501500c6c1)();
    const acs = (0, $a8b8acc568359454$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
function $7d48e1ed9f699a01$export$aa55d5ab8e05984f() {
    return (0, $e4c75fb63b040566$export$7e223ec222791509)("globalScope", ()=>new (0, $dd23bca0e7d7618a$export$775b6bb06e53a214)());
}
function $7d48e1ed9f699a01$export$ec58d9285c204497(...rest) {
    const carrier = (0, $e4c75fb63b040566$export$19eade501500c6c1)();
    const acs = (0, $a8b8acc568359454$export$f639b0c2752203be)(carrier);
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
function $7d48e1ed9f699a01$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $e4c75fb63b040566$export$19eade501500c6c1)();
    const acs = (0, $a8b8acc568359454$export$f639b0c2752203be)(carrier);
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
function $7d48e1ed9f699a01$export$6bb76d6eba7e258c() {
    return $7d48e1ed9f699a01$export$c7be4b0125a10cba().getClient();
}
function $7d48e1ed9f699a01$export$1e83db7ee4876dc4(scope) {
    const externalContext = $7d48e1ed9f699a01$export$92547f779c920a71();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $ece9bac57decbcb8$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}




const $cbb2da6c78246e45$export$b14a8888f80a0b3e = [];
function $cbb2da6c78246e45$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
function $cbb2da6c78246e45$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $cbb2da6c78246e45$var$filterDuplicates(integrations);
}
function $cbb2da6c78246e45$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        if (integration?.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach((integration)=>{
        if (integration) $cbb2da6c78246e45$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
function $cbb2da6c78246e45$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
function $cbb2da6c78246e45$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    if (!$cbb2da6c78246e45$export$b14a8888f80a0b3e.includes(integration.name) && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $cbb2da6c78246e45$export$b14a8888f80a0b3e.push(integration.name);
    }
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        "processSpan",
        "processSegmentSpan"
    ].forEach((hook)=>{
        const callback = integration[hook];
        if (typeof callback === "function") client.on(hook, (span)=>callback.call(integration, span, client));
    });
    (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Integration installed: ${integration.name}`);
}
function $cbb2da6c78246e45$export$2d8f5188773bcddd(integration) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
function $cbb2da6c78246e45$export$2323046b9414659f(fn) {
    return fn;
}
function $cbb2da6c78246e45$export$92d0786473d2c0a1(integration, extendedIntegration) {
    const wrappedIntegration = {
        ...integration,
        ...extendedIntegration
    };
    for(const key in extendedIntegration){
        const baseValue = integration[key];
        const extendedValue = extendedIntegration[key];
        if (typeof baseValue === "function" && typeof extendedValue === "function") {
            const wrappedFunction = new Proxy(baseValue, {
                apply: (target, thisArg, args)=>{
                    Reflect.apply(target, thisArg, args);
                    return Reflect.apply(extendedValue, thisArg, args);
                }
            });
            wrappedIntegration[key] = wrappedFunction;
        }
    }
    return wrappedIntegration;
}


function $81078705bdbfb4a3$export$3b07f81befe2dd0a(params, hint = {}, scope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)()) {
    const { message: message, name: name, email: email, url: url, source: source, associatedEventId: associatedEventId, tags: tags } = params;
    const feedbackEvent = {
        contexts: {
            feedback: {
                contact_email: email,
                name: name,
                message: message,
                url: url,
                source: source,
                associated_event_id: associatedEventId
            }
        },
        type: "feedback",
        level: "info",
        tags: tags
    };
    const client = scope?.getClient() || (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (client) client.emit("beforeSendFeedback", feedbackEvent, hint);
    const eventId = scope.captureEvent(feedbackEvent, hint);
    return eventId;
}



const $caac489b9d8395b2$var$WINDOW = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1);
const $caac489b9d8395b2$var$DEFAULT_MAX_STRING_LENGTH = 80;
function $caac489b9d8395b2$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $caac489b9d8395b2$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $caac489b9d8395b2$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $caac489b9d8395b2$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    if ($caac489b9d8395b2$var$WINDOW.HTMLElement) {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $13cf2ed412f405fa$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
function $caac489b9d8395b2$export$1cfafeee2987818b() {
    try {
        return $caac489b9d8395b2$var$WINDOW.document.location.href;
    } catch  {
        return "";
    }
}
function $caac489b9d8395b2$export$26727cfcc4d7e0fc(elem, maxTraverseHeight = 5) {
    if (!$caac489b9d8395b2$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}


var $5zmEe = parcelRequire("5zmEe");

function $b1c1ca6bb415cfb2$export$4e09c449d6c407f7() {
    return typeof window !== "undefined" && (!(0, $5zmEe.isNodeEnv)() || $b1c1ca6bb415cfb2$var$isElectronNodeRenderer());
}
function $b1c1ca6bb415cfb2$var$isElectronNodeRenderer() {
    const process = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1).process;
    return process?.type === "renderer";
}


const $79d5e278c02a445b$var$WINDOW = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1);
const $79d5e278c02a445b$var$DOCUMENT = $79d5e278c02a445b$var$WINDOW.document;
const $79d5e278c02a445b$var$NAVIGATOR = $79d5e278c02a445b$var$WINDOW.navigator;
const $79d5e278c02a445b$var$TRIGGER_LABEL = "Report a Bug";
const $79d5e278c02a445b$var$CANCEL_BUTTON_LABEL = "Cancel";
const $79d5e278c02a445b$var$SUBMIT_BUTTON_LABEL = "Send Bug Report";
const $79d5e278c02a445b$var$CONFIRM_BUTTON_LABEL = "Confirm";
const $79d5e278c02a445b$var$FORM_TITLE = "Report a Bug";
const $79d5e278c02a445b$var$EMAIL_PLACEHOLDER = "your.email@example.org";
const $79d5e278c02a445b$var$EMAIL_LABEL = "Email";
const $79d5e278c02a445b$var$MESSAGE_PLACEHOLDER = "What's the bug? What did you expect?";
const $79d5e278c02a445b$var$MESSAGE_LABEL = "Description";
const $79d5e278c02a445b$var$NAME_PLACEHOLDER = "Your Name";
const $79d5e278c02a445b$var$NAME_LABEL = "Name";
const $79d5e278c02a445b$var$SUCCESS_MESSAGE_TEXT = "Thank you for your report!";
const $79d5e278c02a445b$var$IS_REQUIRED_LABEL = "(required)";
const $79d5e278c02a445b$var$ADD_SCREENSHOT_LABEL = "Add a screenshot";
const $79d5e278c02a445b$var$REMOVE_SCREENSHOT_LABEL = "Remove screenshot";
const $79d5e278c02a445b$var$HIGHLIGHT_TOOL_TEXT = "Highlight";
const $79d5e278c02a445b$var$HIDE_TOOL_TEXT = "Hide";
const $79d5e278c02a445b$var$REMOVE_HIGHLIGHT_TEXT = "Remove";
const $79d5e278c02a445b$var$ERROR_EMPTY_MESSAGE_TEXT = "Unable to submit feedback with empty message";
const $79d5e278c02a445b$var$ERROR_NO_CLIENT_TEXT = "No client setup, cannot send feedback.";
const $79d5e278c02a445b$var$ERROR_TIMEOUT_TEXT = "Unable to determine if Feedback was correctly sent.";
const $79d5e278c02a445b$var$ERROR_FORBIDDEN_TEXT = "Unable to send feedback. This could be because this domain is not in your list of allowed domains.";
const $79d5e278c02a445b$var$ERROR_GENERIC_TEXT = "Unable to send feedback. This could be because of network issues, or because you are using an ad-blocker.";
const $79d5e278c02a445b$var$FEEDBACK_WIDGET_SOURCE = "widget";
const $79d5e278c02a445b$var$FEEDBACK_API_SOURCE = "api";
const $79d5e278c02a445b$var$SUCCESS_MESSAGE_TIMEOUT = 5e3;
const $79d5e278c02a445b$var$DEFAULT_MESSAGES = {
    ERROR_EMPTY_MESSAGE: $79d5e278c02a445b$var$ERROR_EMPTY_MESSAGE_TEXT,
    ERROR_NO_CLIENT: $79d5e278c02a445b$var$ERROR_NO_CLIENT_TEXT,
    ERROR_TIMEOUT: $79d5e278c02a445b$var$ERROR_TIMEOUT_TEXT,
    ERROR_FORBIDDEN: $79d5e278c02a445b$var$ERROR_FORBIDDEN_TEXT,
    ERROR_GENERIC: $79d5e278c02a445b$var$ERROR_GENERIC_TEXT
};
function $79d5e278c02a445b$var$resolveFeedbackErrorMessage(code, messages) {
    return messages?.[code] ?? $79d5e278c02a445b$var$DEFAULT_MESSAGES[code];
}
function $79d5e278c02a445b$var$createFeedbackError(code, messages) {
    return new Error($79d5e278c02a445b$var$resolveFeedbackErrorMessage(code, messages));
}
const $79d5e278c02a445b$export$a65d69dd22caceda = (params, hint = {
    includeReplay: true
})=>{
    const errorMessages = hint.errorMessages;
    if (!params.message) throw $79d5e278c02a445b$var$createFeedbackError("ERROR_EMPTY_MESSAGE", errorMessages);
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (!client) throw $79d5e278c02a445b$var$createFeedbackError("ERROR_NO_CLIENT", errorMessages);
    if (params.tags && Object.keys(params.tags).length) (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().setTags(params.tags);
    const eventId = (0, $81078705bdbfb4a3$export$3b07f81befe2dd0a)({
        source: $79d5e278c02a445b$var$FEEDBACK_API_SOURCE,
        url: (0, $caac489b9d8395b2$export$1cfafeee2987818b)(),
        ...params
    }, hint);
    return new Promise((resolve, reject)=>{
        const timeout = setTimeout(()=>{
            cleanup();
            reject($79d5e278c02a445b$var$resolveFeedbackErrorMessage("ERROR_TIMEOUT", errorMessages));
        }, 3e4);
        const cleanup = client.on("afterSendEvent", (event, response)=>{
            if (event.event_id !== eventId) return;
            clearTimeout(timeout);
            cleanup();
            if (response?.statusCode && response.statusCode >= 200 && response.statusCode < 300) return resolve(eventId);
            if (response?.statusCode === 403) return reject($79d5e278c02a445b$var$resolveFeedbackErrorMessage("ERROR_FORBIDDEN", errorMessages));
            return reject($79d5e278c02a445b$var$resolveFeedbackErrorMessage("ERROR_GENERIC", errorMessages));
        });
    });
};
const $79d5e278c02a445b$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
function $79d5e278c02a445b$var$isScreenshotSupported() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test($79d5e278c02a445b$var$NAVIGATOR.userAgent)) return false;
    if (/Macintosh/i.test($79d5e278c02a445b$var$NAVIGATOR.userAgent) && $79d5e278c02a445b$var$NAVIGATOR.maxTouchPoints && $79d5e278c02a445b$var$NAVIGATOR.maxTouchPoints > 1) return false;
    if (!isSecureContext) return false;
    return true;
}
function $79d5e278c02a445b$var$mergeOptions(defaultOptions, optionOverrides) {
    return {
        ...defaultOptions,
        ...optionOverrides,
        tags: {
            ...defaultOptions.tags,
            ...optionOverrides.tags
        },
        onFormOpen: ()=>{
            optionOverrides.onFormOpen?.();
            defaultOptions.onFormOpen?.();
        },
        onFormClose: ()=>{
            optionOverrides.onFormClose?.();
            defaultOptions.onFormClose?.();
        },
        onSubmitSuccess: (data, eventId)=>{
            optionOverrides.onSubmitSuccess?.(data, eventId);
            defaultOptions.onSubmitSuccess?.(data, eventId);
        },
        onSubmitError: (error)=>{
            optionOverrides.onSubmitError?.(error);
            defaultOptions.onSubmitError?.(error);
        },
        onFormSubmitted: ()=>{
            optionOverrides.onFormSubmitted?.();
            defaultOptions.onFormSubmitted?.();
        },
        themeDark: {
            ...defaultOptions.themeDark,
            ...optionOverrides.themeDark
        },
        themeLight: {
            ...defaultOptions.themeLight,
            ...optionOverrides.themeLight
        }
    };
}
function $79d5e278c02a445b$var$createActorStyles(styleNonce) {
    const style = $79d5e278c02a445b$var$DOCUMENT.createElement("style");
    style.textContent = `
.widget__actor {
  position: fixed;
  z-index: var(--z-index);
  margin: var(--page-margin);
  inset: var(--actor-inset);

  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;

  font-family: inherit;
  font-size: var(--font-size);
  font-weight: 600;
  line-height: 1.14em;
  text-decoration: none;

  background: var(--actor-background, var(--background));
  border-radius: var(--actor-border-radius, 1.7em/50%);
  border: var(--actor-border, var(--border));
  box-shadow: var(--actor-box-shadow, var(--box-shadow));
  color: var(--actor-color, var(--foreground));
  fill: var(--actor-color, var(--foreground));
  cursor: pointer;
  opacity: 1;
  transition: transform 0.2s ease-in-out;
  transform: translate(0, 0) scale(1);
}
.widget__actor[aria-hidden="true"] {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
  transform: translate(0, 16px) scale(0.98);
}

.widget__actor:hover {
  background: var(--actor-hover-background, var(--background));
  filter: var(--interactive-filter);
}

.widget__actor svg {
  width: 1.14em;
  height: 1.14em;
}

@media (max-width: 600px) {
  .widget__actor span {
    display: none;
  }
}
`;
    if (styleNonce) style.setAttribute("nonce", styleNonce);
    return style;
}
function $79d5e278c02a445b$var$setAttributesNS(el, attributes) {
    Object.entries(attributes).forEach(([key, val])=>{
        el.setAttributeNS(null, key, val);
    });
    return el;
}
const $79d5e278c02a445b$var$SIZE = 20;
const $79d5e278c02a445b$var$XMLNS$2 = "http://www.w3.org/2000/svg";
function $79d5e278c02a445b$var$FeedbackIcon() {
    const createElementNS = (tagName)=>$79d5e278c02a445b$var$WINDOW.document.createElementNS($79d5e278c02a445b$var$XMLNS$2, tagName);
    const svg = $79d5e278c02a445b$var$setAttributesNS(createElementNS("svg"), {
        width: `${$79d5e278c02a445b$var$SIZE}`,
        height: `${$79d5e278c02a445b$var$SIZE}`,
        viewBox: `0 0 ${$79d5e278c02a445b$var$SIZE} ${$79d5e278c02a445b$var$SIZE}`,
        fill: "var(--actor-color, var(--foreground))"
    });
    const g = $79d5e278c02a445b$var$setAttributesNS(createElementNS("g"), {
        clipPath: "url(#clip0_57_80)"
    });
    const path = $79d5e278c02a445b$var$setAttributesNS(createElementNS("path"), {
        ["fill-rule"]: "evenodd",
        ["clip-rule"]: "evenodd",
        d: "M15.6622 15H12.3997C12.2129 14.9959 12.031 14.9396 11.8747 14.8375L8.04965 12.2H7.49956V19.1C7.4875 19.3348 7.3888 19.5568 7.22256 19.723C7.05632 19.8892 6.83435 19.9879 6.59956 20H2.04956C1.80193 19.9968 1.56535 19.8969 1.39023 19.7218C1.21511 19.5467 1.1153 19.3101 1.11206 19.0625V12.2H0.949652C0.824431 12.2017 0.700142 12.1783 0.584123 12.1311C0.468104 12.084 0.362708 12.014 0.274155 11.9255C0.185602 11.8369 0.115689 11.7315 0.0685419 11.6155C0.0213952 11.4995 -0.00202913 11.3752 -0.00034808 11.25V3.75C-0.00900498 3.62067 0.0092504 3.49095 0.0532651 3.36904C0.0972798 3.24712 0.166097 3.13566 0.255372 3.04168C0.344646 2.94771 0.452437 2.87327 0.571937 2.82307C0.691437 2.77286 0.82005 2.74798 0.949652 2.75H8.04965L11.8747 0.1625C12.031 0.0603649 12.2129 0.00407221 12.3997 0H15.6622C15.9098 0.00323746 16.1464 0.103049 16.3215 0.278167C16.4966 0.453286 16.5964 0.689866 16.5997 0.9375V3.25269C17.3969 3.42959 18.1345 3.83026 18.7211 4.41679C19.5322 5.22788 19.9878 6.32796 19.9878 7.47502C19.9878 8.62209 19.5322 9.72217 18.7211 10.5333C18.1345 11.1198 17.3969 11.5205 16.5997 11.6974V14.0125C16.6047 14.1393 16.5842 14.2659 16.5395 14.3847C16.4948 14.5035 16.4268 14.6121 16.3394 14.7042C16.252 14.7962 16.147 14.8698 16.0307 14.9206C15.9144 14.9714 15.7891 14.9984 15.6622 15ZM1.89695 10.325H1.88715V4.625H8.33715C8.52423 4.62301 8.70666 4.56654 8.86215 4.4625L12.6872 1.875H14.7247V13.125H12.6872L8.86215 10.4875C8.70666 10.3835 8.52423 10.327 8.33715 10.325H2.20217C2.15205 10.3167 2.10102 10.3125 2.04956 10.3125C1.9981 10.3125 1.94708 10.3167 1.89695 10.325ZM2.98706 12.2V18.1625H5.66206V12.2H2.98706ZM16.5997 9.93612V5.01393C16.6536 5.02355 16.7072 5.03495 16.7605 5.04814C17.1202 5.13709 17.4556 5.30487 17.7425 5.53934C18.0293 5.77381 18.2605 6.06912 18.4192 6.40389C18.578 6.73866 18.6603 7.10452 18.6603 7.47502C18.6603 7.84552 18.578 8.21139 18.4192 8.54616C18.2605 8.88093 18.0293 9.17624 17.7425 9.41071C17.4556 9.64518 17.1202 9.81296 16.7605 9.90191C16.7072 9.91509 16.6536 9.9265 16.5997 9.93612Z"
    });
    svg.appendChild(g).appendChild(path);
    const speakerDefs = createElementNS("defs");
    const speakerClipPathDef = $79d5e278c02a445b$var$setAttributesNS(createElementNS("clipPath"), {
        id: "clip0_57_80"
    });
    const speakerRect = $79d5e278c02a445b$var$setAttributesNS(createElementNS("rect"), {
        width: `${$79d5e278c02a445b$var$SIZE}`,
        height: `${$79d5e278c02a445b$var$SIZE}`,
        fill: "white"
    });
    speakerClipPathDef.appendChild(speakerRect);
    speakerDefs.appendChild(speakerClipPathDef);
    svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);
    return svg;
}
function $79d5e278c02a445b$var$Actor({ triggerLabel: triggerLabel, triggerAriaLabel: triggerAriaLabel, shadow: shadow, styleNonce: styleNonce }) {
    const el = $79d5e278c02a445b$var$DOCUMENT.createElement("button");
    el.type = "button";
    el.className = "widget__actor";
    el.ariaHidden = "false";
    el.ariaLabel = triggerAriaLabel || triggerLabel || $79d5e278c02a445b$var$TRIGGER_LABEL;
    el.appendChild($79d5e278c02a445b$var$FeedbackIcon());
    if (triggerLabel) {
        const label = $79d5e278c02a445b$var$DOCUMENT.createElement("span");
        label.appendChild($79d5e278c02a445b$var$DOCUMENT.createTextNode(triggerLabel));
        el.appendChild(label);
    }
    const style = $79d5e278c02a445b$var$createActorStyles(styleNonce);
    return {
        el: el,
        appendToDom () {
            shadow.appendChild(style);
            shadow.appendChild(el);
        },
        removeFromDom () {
            el.remove();
            style.remove();
        },
        show () {
            el.ariaHidden = "false";
        },
        hide () {
            el.ariaHidden = "true";
        }
    };
}
const $79d5e278c02a445b$var$PURPLE = "rgba(88, 74, 192, 1)";
const $79d5e278c02a445b$var$DEFAULT_LIGHT = {
    foreground: "#2b2233",
    background: "#ffffff",
    accentForeground: "white",
    accentBackground: $79d5e278c02a445b$var$PURPLE,
    successColor: "#268d75",
    errorColor: "#df3338",
    border: "1.5px solid rgba(41, 35, 47, 0.13)",
    boxShadow: "0px 4px 24px 0px rgba(43, 34, 51, 0.12)",
    outline: "1px auto var(--accent-background)",
    interactiveFilter: "brightness(95%)"
};
const $79d5e278c02a445b$var$DEFAULT_DARK = {
    foreground: "#ebe6ef",
    background: "#29232f",
    accentForeground: "white",
    accentBackground: $79d5e278c02a445b$var$PURPLE,
    successColor: "#2da98c",
    errorColor: "#f55459",
    border: "1.5px solid rgba(235, 230, 239, 0.15)",
    boxShadow: "0px 4px 24px 0px rgba(43, 34, 51, 0.12)",
    outline: "1px auto var(--accent-background)",
    interactiveFilter: "brightness(150%)"
};
function $79d5e278c02a445b$var$getThemedCssVariables(theme) {
    return `
  --foreground: ${theme.foreground};
  --background: ${theme.background};
  --accent-foreground: ${theme.accentForeground};
  --accent-background: ${theme.accentBackground};
  --success-color: ${theme.successColor};
  --error-color: ${theme.errorColor};
  --border: ${theme.border};
  --box-shadow: ${theme.boxShadow};
  --outline: ${theme.outline};
  --interactive-filter: ${theme.interactiveFilter};
  `;
}
function $79d5e278c02a445b$var$createMainStyles({ colorScheme: colorScheme, themeDark: themeDark, themeLight: themeLight, styleNonce: styleNonce }) {
    const style = $79d5e278c02a445b$var$DOCUMENT.createElement("style");
    style.textContent = `
:host {
  --font-family: system-ui, 'Helvetica Neue', Arial, sans-serif;
  --font-size: 14px;
  --z-index: 100000;

  --page-margin: 16px;
  --inset: auto 0 0 auto;
  --actor-inset: var(--inset);

  font-family: var(--font-family);
  font-size: var(--font-size);

  ${colorScheme !== "system" ? `color-scheme: only ${colorScheme};` : ""}

  ${$79d5e278c02a445b$var$getThemedCssVariables(colorScheme === "dark" ? {
        ...$79d5e278c02a445b$var$DEFAULT_DARK,
        ...themeDark
    } : {
        ...$79d5e278c02a445b$var$DEFAULT_LIGHT,
        ...themeLight
    })}
}

${colorScheme === "system" ? `
@media (prefers-color-scheme: dark) {
  :host {
    color-scheme: only dark;

    ${$79d5e278c02a445b$var$getThemedCssVariables({
        ...$79d5e278c02a445b$var$DEFAULT_DARK,
        ...themeDark
    })}
  }
}` : ""}
`;
    if (styleNonce) style.setAttribute("nonce", styleNonce);
    return style;
}
const $79d5e278c02a445b$export$13a9e5a543258f97 = ({ lazyLoadIntegration: lazyLoadIntegration, getModalIntegration: getModalIntegration, getScreenshotIntegration: getScreenshotIntegration })=>{
    const feedbackIntegration = ({ id: // FeedbackGeneralConfiguration
    id = "sentry-feedback", autoInject: autoInject = true, showBranding: showBranding = true, isEmailRequired: isEmailRequired = false, isNameRequired: isNameRequired = false, showEmail: showEmail = true, showName: showName = true, enableScreenshot: enableScreenshot = true, useSentryUser: useSentryUser = {
        email: "email",
        name: "username"
    }, tags: tags, styleNonce: styleNonce, scriptNonce: scriptNonce, colorScheme: // FeedbackThemeConfiguration
    colorScheme = "system", themeLight: themeLight = {}, themeDark: themeDark = {}, addScreenshotButtonLabel: // FeedbackTextConfiguration
    addScreenshotButtonLabel = $79d5e278c02a445b$var$ADD_SCREENSHOT_LABEL, cancelButtonLabel: cancelButtonLabel = $79d5e278c02a445b$var$CANCEL_BUTTON_LABEL, confirmButtonLabel: confirmButtonLabel = $79d5e278c02a445b$var$CONFIRM_BUTTON_LABEL, emailLabel: emailLabel = $79d5e278c02a445b$var$EMAIL_LABEL, emailPlaceholder: emailPlaceholder = $79d5e278c02a445b$var$EMAIL_PLACEHOLDER, formTitle: formTitle = $79d5e278c02a445b$var$FORM_TITLE, isRequiredLabel: isRequiredLabel = $79d5e278c02a445b$var$IS_REQUIRED_LABEL, messageLabel: messageLabel = $79d5e278c02a445b$var$MESSAGE_LABEL, messagePlaceholder: messagePlaceholder = $79d5e278c02a445b$var$MESSAGE_PLACEHOLDER, nameLabel: nameLabel = $79d5e278c02a445b$var$NAME_LABEL, namePlaceholder: namePlaceholder = $79d5e278c02a445b$var$NAME_PLACEHOLDER, removeScreenshotButtonLabel: removeScreenshotButtonLabel = $79d5e278c02a445b$var$REMOVE_SCREENSHOT_LABEL, submitButtonLabel: submitButtonLabel = $79d5e278c02a445b$var$SUBMIT_BUTTON_LABEL, successMessageText: successMessageText = $79d5e278c02a445b$var$SUCCESS_MESSAGE_TEXT, triggerLabel: triggerLabel = $79d5e278c02a445b$var$TRIGGER_LABEL, triggerAriaLabel: triggerAriaLabel = "", highlightToolText: highlightToolText = $79d5e278c02a445b$var$HIGHLIGHT_TOOL_TEXT, hideToolText: hideToolText = $79d5e278c02a445b$var$HIDE_TOOL_TEXT, removeHighlightText: removeHighlightText = $79d5e278c02a445b$var$REMOVE_HIGHLIGHT_TEXT, errorEmptyMessageText: errorEmptyMessageText = $79d5e278c02a445b$var$ERROR_EMPTY_MESSAGE_TEXT, errorNoClientText: errorNoClientText = $79d5e278c02a445b$var$ERROR_NO_CLIENT_TEXT, errorTimeoutText: errorTimeoutText = $79d5e278c02a445b$var$ERROR_TIMEOUT_TEXT, errorForbiddenText: errorForbiddenText = $79d5e278c02a445b$var$ERROR_FORBIDDEN_TEXT, errorGenericText: errorGenericText = $79d5e278c02a445b$var$ERROR_GENERIC_TEXT, onFormOpen: // FeedbackCallbacks
    onFormOpen, onFormClose: onFormClose, onSubmitSuccess: onSubmitSuccess, onSubmitError: onSubmitError, onFormSubmitted: onFormSubmitted } = {})=>{
        const _options = {
            id: id,
            autoInject: autoInject,
            showBranding: showBranding,
            isEmailRequired: isEmailRequired,
            isNameRequired: isNameRequired,
            showEmail: showEmail,
            showName: showName,
            enableScreenshot: enableScreenshot,
            useSentryUser: useSentryUser,
            tags: tags,
            styleNonce: styleNonce,
            scriptNonce: scriptNonce,
            colorScheme: colorScheme,
            themeDark: themeDark,
            themeLight: themeLight,
            triggerLabel: triggerLabel,
            triggerAriaLabel: triggerAriaLabel,
            cancelButtonLabel: cancelButtonLabel,
            submitButtonLabel: submitButtonLabel,
            confirmButtonLabel: confirmButtonLabel,
            formTitle: formTitle,
            emailLabel: emailLabel,
            emailPlaceholder: emailPlaceholder,
            messageLabel: messageLabel,
            messagePlaceholder: messagePlaceholder,
            nameLabel: nameLabel,
            namePlaceholder: namePlaceholder,
            successMessageText: successMessageText,
            isRequiredLabel: isRequiredLabel,
            addScreenshotButtonLabel: addScreenshotButtonLabel,
            removeScreenshotButtonLabel: removeScreenshotButtonLabel,
            highlightToolText: highlightToolText,
            hideToolText: hideToolText,
            removeHighlightText: removeHighlightText,
            errorEmptyMessageText: errorEmptyMessageText,
            errorNoClientText: errorNoClientText,
            errorTimeoutText: errorTimeoutText,
            errorForbiddenText: errorForbiddenText,
            errorGenericText: errorGenericText,
            onFormClose: onFormClose,
            onFormOpen: onFormOpen,
            onSubmitError: onSubmitError,
            onSubmitSuccess: onSubmitSuccess,
            onFormSubmitted: onFormSubmitted
        };
        let _shadow = null;
        let _mainStyle = null;
        let _subscriptions = [];
        const _createShadow = (options)=>{
            if (!_shadow) {
                const host = $79d5e278c02a445b$var$DOCUMENT.createElement("div");
                host.id = String(options.id);
                $79d5e278c02a445b$var$DOCUMENT.body.appendChild(host);
                _shadow = host.attachShadow({
                    mode: "open"
                });
                _mainStyle = $79d5e278c02a445b$var$createMainStyles(options);
                _shadow.appendChild(_mainStyle);
            }
            return _shadow;
        };
        const _loadAndRenderDialog = async (options)=>{
            const screenshotRequired = options.enableScreenshot && $79d5e278c02a445b$var$isScreenshotSupported();
            let modalIntegration;
            let screenshotIntegration;
            try {
                const modalIntegrationFn = getModalIntegration ? getModalIntegration() : await lazyLoadIntegration("feedbackModalIntegration", scriptNonce);
                modalIntegration = modalIntegrationFn();
                (0, $cbb2da6c78246e45$export$2d8f5188773bcddd)(modalIntegration);
            } catch  {
                $79d5e278c02a445b$var$DEBUG_BUILD && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error("[Feedback] Error when trying to load feedback integrations. Try using `feedbackSyncIntegration` in your `Sentry.init`.");
                throw new Error("[Feedback] Missing feedback modal integration!");
            }
            try {
                const screenshotIntegrationFn = screenshotRequired ? getScreenshotIntegration ? getScreenshotIntegration() : await lazyLoadIntegration("feedbackScreenshotIntegration", scriptNonce) : void 0;
                if (screenshotIntegrationFn) {
                    screenshotIntegration = screenshotIntegrationFn();
                    (0, $cbb2da6c78246e45$export$2d8f5188773bcddd)(screenshotIntegration);
                }
            } catch  {
                $79d5e278c02a445b$var$DEBUG_BUILD && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error("[Feedback] Missing feedback screenshot integration. Proceeding without screenshots.");
            }
            const errorMessages = {
                ERROR_EMPTY_MESSAGE: options.errorEmptyMessageText,
                ERROR_NO_CLIENT: options.errorNoClientText,
                ERROR_TIMEOUT: options.errorTimeoutText,
                ERROR_FORBIDDEN: options.errorForbiddenText,
                ERROR_GENERIC: options.errorGenericText
            };
            const wrappedSendFeedback = (params, hint)=>$79d5e278c02a445b$export$a65d69dd22caceda(params, {
                    includeReplay: true,
                    ...hint,
                    errorMessages: errorMessages
                });
            const dialog = modalIntegration.createDialog({
                options: {
                    ...options,
                    onFormClose: ()=>{
                        dialog?.close();
                        options.onFormClose?.();
                    },
                    onFormSubmitted: ()=>{
                        dialog?.close();
                        options.onFormSubmitted?.();
                    }
                },
                screenshotIntegration: screenshotIntegration,
                sendFeedback: wrappedSendFeedback,
                shadow: _createShadow(options)
            });
            return dialog;
        };
        const _attachTo = (el, optionOverrides = {})=>{
            const mergedOptions = $79d5e278c02a445b$var$mergeOptions(_options, optionOverrides);
            const targetEl = typeof el === "string" ? $79d5e278c02a445b$var$DOCUMENT.querySelector(el) : typeof el.addEventListener === "function" ? el : null;
            if (!targetEl) {
                $79d5e278c02a445b$var$DEBUG_BUILD && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error("[Feedback] Unable to attach to target element");
                throw new Error("Unable to attach to target element");
            }
            let dialog = null;
            const handleClick = async ()=>{
                if (!dialog) dialog = await _loadAndRenderDialog({
                    ...mergedOptions,
                    onFormSubmitted: ()=>{
                        dialog?.removeFromDom();
                        mergedOptions.onFormSubmitted?.();
                    }
                });
                dialog.appendToDom();
                dialog.open();
            };
            targetEl.addEventListener("click", handleClick);
            const unsubscribe = ()=>{
                _subscriptions = _subscriptions.filter((sub)=>sub !== unsubscribe);
                dialog?.removeFromDom();
                dialog = null;
                targetEl.removeEventListener("click", handleClick);
            };
            _subscriptions.push(unsubscribe);
            return unsubscribe;
        };
        const _createActor = (optionOverrides = {})=>{
            const mergedOptions = $79d5e278c02a445b$var$mergeOptions(_options, optionOverrides);
            const shadow = _createShadow(mergedOptions);
            const actor = $79d5e278c02a445b$var$Actor({
                triggerLabel: mergedOptions.triggerLabel,
                triggerAriaLabel: mergedOptions.triggerAriaLabel,
                shadow: shadow,
                styleNonce: styleNonce
            });
            _attachTo(actor.el, {
                ...mergedOptions,
                onFormOpen () {
                    actor.hide();
                },
                onFormClose () {
                    actor.show();
                },
                onFormSubmitted () {
                    actor.show();
                }
            });
            return actor;
        };
        return {
            name: "Feedback",
            setupOnce () {
                if (!(0, $b1c1ca6bb415cfb2$export$4e09c449d6c407f7)() || !_options.autoInject) return;
                if ($79d5e278c02a445b$var$DOCUMENT.readyState === "loading") $79d5e278c02a445b$var$DOCUMENT.addEventListener("DOMContentLoaded", ()=>_createActor().appendToDom());
                else _createActor().appendToDom();
            },
            /**
       * Adds click listener to the element to open a feedback dialog
       *
       * The returned function can be used to remove the click listener
       */ attachTo: _attachTo,
            /**
       * Creates a new widget which is composed of a Button which triggers a Dialog.
       * Accepts partial options to override any options passed to constructor.
       */ createWidget (optionOverrides = {}) {
                const actor = _createActor($79d5e278c02a445b$var$mergeOptions(_options, optionOverrides));
                actor.appendToDom();
                return actor;
            },
            /**
       * Creates a new Form which you can
       * Accepts partial options to override any options passed to constructor.
       */ async createForm (optionOverrides = {}) {
                return _loadAndRenderDialog($79d5e278c02a445b$var$mergeOptions(_options, optionOverrides));
            },
            /**
       * Updates the color scheme of the feedback widget at runtime.
       */ setTheme (colorScheme2) {
                _options.colorScheme = colorScheme2;
                if (_shadow) {
                    const newStyle = $79d5e278c02a445b$var$createMainStyles(_options);
                    if (_mainStyle) _shadow.replaceChild(newStyle, _mainStyle);
                    else _shadow.prepend(newStyle);
                    _mainStyle = newStyle;
                }
            },
            /**
       * Removes the Feedback integration (including host, shadow DOM, and all widgets)
       */ remove () {
                if (_shadow) {
                    _shadow.parentElement?.remove();
                    _shadow = null;
                    _mainStyle = null;
                }
                _subscriptions.forEach((sub)=>sub());
                _subscriptions = [];
            }
        };
    };
    return feedbackIntegration;
};
function $79d5e278c02a445b$export$ed85ee0b85ce96e1() {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    return client?.getIntegrationByName("Feedback");
}
var $79d5e278c02a445b$var$n, $79d5e278c02a445b$var$l$1, $79d5e278c02a445b$var$u$1, $79d5e278c02a445b$var$i$1, $79d5e278c02a445b$var$o$1, $79d5e278c02a445b$var$r$1, $79d5e278c02a445b$var$f$1, $79d5e278c02a445b$var$c$1 = {}, $79d5e278c02a445b$var$s$1 = [], $79d5e278c02a445b$var$a$1 = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $79d5e278c02a445b$var$h$1 = Array.isArray;
function $79d5e278c02a445b$var$v$1(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $79d5e278c02a445b$var$p$1(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $79d5e278c02a445b$var$y$1(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $79d5e278c02a445b$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $79d5e278c02a445b$var$d$1(l, f, i, o, null);
}
function $79d5e278c02a445b$var$d$1(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$79d5e278c02a445b$var$u$1 : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $79d5e278c02a445b$var$l$1.vnode && $79d5e278c02a445b$var$l$1.vnode(f), f;
}
function $79d5e278c02a445b$var$g$1(n) {
    return n.children;
}
function $79d5e278c02a445b$var$b$1(n, l) {
    this.props = n, this.context = l;
}
function $79d5e278c02a445b$var$m$1(n, l) {
    if (null == l) return n.__ ? $79d5e278c02a445b$var$m$1(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $79d5e278c02a445b$var$m$1(n) : null;
}
function $79d5e278c02a445b$var$w$1(n, u, t) {
    var i, o = n.__v, r = o.__e, f = n.__P;
    if (f) return (i = $79d5e278c02a445b$var$v$1({}, o)).__v = o.__v + 1, $79d5e278c02a445b$var$l$1.vnode && $79d5e278c02a445b$var$l$1.vnode(i), $79d5e278c02a445b$var$M(f, i, o, n.__n, void 0 !== f.ownerSVGElement, 32 & o.__u ? [
        r
    ] : null, u, null == r ? $79d5e278c02a445b$var$m$1(o) : r, !!(32 & o.__u), t), i.__.__k[i.__i] = i, i.__d = void 0, i.__e != r && $79d5e278c02a445b$var$k$1(i), i;
}
function $79d5e278c02a445b$var$k$1(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $79d5e278c02a445b$var$k$1(n);
    }
}
function $79d5e278c02a445b$var$x$1(n) {
    (!n.__d && (n.__d = true) && $79d5e278c02a445b$var$i$1.push(n) && !$79d5e278c02a445b$var$C$1.__r++ || $79d5e278c02a445b$var$o$1 !== $79d5e278c02a445b$var$l$1.debounceRendering) && (($79d5e278c02a445b$var$o$1 = $79d5e278c02a445b$var$l$1.debounceRendering) || $79d5e278c02a445b$var$r$1)($79d5e278c02a445b$var$C$1);
}
function $79d5e278c02a445b$var$C$1() {
    var n, u, t, o = [], r = [];
    for($79d5e278c02a445b$var$i$1.sort($79d5e278c02a445b$var$f$1); n = $79d5e278c02a445b$var$i$1.shift();)n.__d && (t = $79d5e278c02a445b$var$i$1.length, u = $79d5e278c02a445b$var$w$1(n, o, r) || u, 0 === t || $79d5e278c02a445b$var$i$1.length > t ? ($79d5e278c02a445b$var$j$1(o, u, r), r.length = o.length = 0, u = void 0, $79d5e278c02a445b$var$i$1.sort($79d5e278c02a445b$var$f$1)) : u && $79d5e278c02a445b$var$l$1.__c && $79d5e278c02a445b$var$l$1.__c(u, $79d5e278c02a445b$var$s$1));
    u && $79d5e278c02a445b$var$j$1(o, u, r), $79d5e278c02a445b$var$C$1.__r = 0;
}
function $79d5e278c02a445b$var$P$1(n, l, u, t, i, o, r, f, e, a, h) {
    var v, p, y, d, _, g = t && t.__k || $79d5e278c02a445b$var$s$1, b = l.length;
    for(u.__d = e, $79d5e278c02a445b$var$S(u, l, g), e = u.__d, v = 0; v < b; v++)null != (y = u.__k[v]) && "boolean" != typeof y && "function" != typeof y && (p = -1 === y.__i ? $79d5e278c02a445b$var$c$1 : g[y.__i] || $79d5e278c02a445b$var$c$1, y.__i = v, $79d5e278c02a445b$var$M(n, y, p, i, o, r, f, e, a, h), d = y.__e, y.ref && p.ref != y.ref && (p.ref && $79d5e278c02a445b$var$N(p.ref, null, y), h.push(y.ref, y.__c || d, y)), null == _ && null != d && (_ = d), 65536 & y.__u || p.__k === y.__k ? e = $79d5e278c02a445b$var$$(y, e, n) : "function" == typeof y.type && void 0 !== y.__d ? e = y.__d : d && (e = d.nextSibling), y.__d = void 0, y.__u &= -196609);
    u.__d = e, u.__e = _;
}
function $79d5e278c02a445b$var$S(n, l, u) {
    var t, i, o, r, f, e = l.length, c = u.length, s = c, a = 0;
    for(n.__k = [], t = 0; t < e; t++)null != (i = n.__k[t] = null == (i = l[t]) || "boolean" == typeof i || "function" == typeof i ? null : "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? $79d5e278c02a445b$var$d$1(null, i, null, null, i) : $79d5e278c02a445b$var$h$1(i) ? $79d5e278c02a445b$var$d$1($79d5e278c02a445b$var$g$1, {
        children: i
    }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? $79d5e278c02a445b$var$d$1(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i) ? (i.__ = n, i.__b = n.__b + 1, f = $79d5e278c02a445b$var$I(i, u, r = t + a, s), i.__i = f, o = null, -1 !== f && (s--, (o = u[f]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == f && a--, "function" != typeof i.type && (i.__u |= 65536)) : f !== r && (f === r + 1 ? a++ : f > r ? s > e - r ? a += f - r : a-- : a = f < r && f == r - 1 ? f - r : 0, f !== t + a && (i.__u |= 65536))) : (o = u[t]) && null == o.key && o.__e && (o.__e == n.__d && (n.__d = $79d5e278c02a445b$var$m$1(o)), $79d5e278c02a445b$var$O(o, o, false), u[t] = null, s--);
    if (s) for(t = 0; t < c; t++)null != (o = u[t]) && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $79d5e278c02a445b$var$m$1(o)), $79d5e278c02a445b$var$O(o, o));
}
function $79d5e278c02a445b$var$$(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $79d5e278c02a445b$var$$(t[i], l, u));
        return l;
    }
    n.__e != l && (u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 === l.nodeType);
    return l;
}
function $79d5e278c02a445b$var$I(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type) return u;
    if (t > (null != e && 0 == (131072 & e.__u) ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function $79d5e278c02a445b$var$T$1(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $79d5e278c02a445b$var$a$1.test(l) ? u : u + "px";
}
function $79d5e278c02a445b$var$A$1(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $79d5e278c02a445b$var$T$1(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $79d5e278c02a445b$var$T$1(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/i, "$1")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = Date.now(), n.addEventListener(l, o ? $79d5e278c02a445b$var$L : $79d5e278c02a445b$var$D$1, o)) : n.removeEventListener(l, o ? $79d5e278c02a445b$var$L : $79d5e278c02a445b$var$D$1, o);
    else {
        if (i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && "rowSpan" !== l && "colSpan" !== l && "role" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || false === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $79d5e278c02a445b$var$D$1(n) {
    if (this.l) {
        var u = this.l[n.type + false];
        if (n.t) {
            if (n.t <= u.u) return;
        } else n.t = Date.now();
        return u($79d5e278c02a445b$var$l$1.event ? $79d5e278c02a445b$var$l$1.event(n) : n);
    }
}
function $79d5e278c02a445b$var$L(n) {
    if (this.l) return this.l[n.type + true]($79d5e278c02a445b$var$l$1.event ? $79d5e278c02a445b$var$l$1.event(n) : n);
}
function $79d5e278c02a445b$var$M(n, u, t, i, o, r, f, e, c, s) {
    var a, p, y, d, _, m, w, k, x, C, S, $, H, I, T, A = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        e = u.__e = t.__e
    ]), (a = $79d5e278c02a445b$var$l$1.__b) && a(u);
    n: if ("function" == typeof A) try {
        if (k = u.props, x = (a = A.contextType) && i[a.__c], C = a ? x ? x.props.value : a.__ : i, t.__c ? w = (p = u.__c = t.__c).__ = p.__E : ("prototype" in A && A.prototype.render ? u.__c = p = new A(k, C) : (u.__c = p = new $79d5e278c02a445b$var$b$1(k, C), p.constructor = A, p.render = $79d5e278c02a445b$var$q$1), x && x.sub(p), p.props = k, p.state || (p.state = {}), p.context = C, p.__n = i, y = p.__d = !0, p.__h = [], p._sb = []), null == p.__s && (p.__s = p.state), null != A.getDerivedStateFromProps && (p.__s == p.state && (p.__s = $79d5e278c02a445b$var$v$1({}, p.__s)), $79d5e278c02a445b$var$v$1(p.__s, A.getDerivedStateFromProps(k, p.__s))), d = p.props, _ = p.state, p.__v = u, y) null == A.getDerivedStateFromProps && null != p.componentWillMount && p.componentWillMount(), null != p.componentDidMount && p.__h.push(p.componentDidMount);
        else {
            if (null == A.getDerivedStateFromProps && k !== d && null != p.componentWillReceiveProps && p.componentWillReceiveProps(k, C), !p.__e && (null != p.shouldComponentUpdate && !1 === p.shouldComponentUpdate(k, p.__s, C) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (p.props = k, p.state = p.__s, p.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.forEach(function(n) {
                    n && (n.__ = u);
                }), S = 0; S < p._sb.length; S++)p.__h.push(p._sb[S]);
                p._sb = [], p.__h.length && f.push(p);
                break n;
            }
            null != p.componentWillUpdate && p.componentWillUpdate(k, p.__s, C), null != p.componentDidUpdate && p.__h.push(function() {
                p.componentDidUpdate(d, _, m);
            });
        }
        if (p.context = C, p.props = k, p.__P = n, p.__e = !1, $ = $79d5e278c02a445b$var$l$1.__r, H = 0, "prototype" in A && A.prototype.render) {
            for(p.state = p.__s, p.__d = !1, $ && $(u), a = p.render(p.props, p.state, p.context), I = 0; I < p._sb.length; I++)p.__h.push(p._sb[I]);
            p._sb = [];
        } else do p.__d = !1, $ && $(u), a = p.render(p.props, p.state, p.context), p.state = p.__s;
        while (p.__d && ++H < 25);
        p.state = p.__s, null != p.getChildContext && (i = $79d5e278c02a445b$var$v$1($79d5e278c02a445b$var$v$1({}, i), p.getChildContext())), y || null == p.getSnapshotBeforeUpdate || (m = p.getSnapshotBeforeUpdate(d, _)), $79d5e278c02a445b$var$P$1(n, $79d5e278c02a445b$var$h$1(T = null != a && a.type === $79d5e278c02a445b$var$g$1 && null == a.key ? a.props.children : a) ? T : [
            T
        ], u, t, i, o, r, f, e, c, s), p.base = u.__e, u.__u &= -161, p.__h.length && f.push(p), w && (p.__E = p.__ = null);
    } catch (n) {
        u.__v = null, c || null != r ? (u.__e = e, u.__u |= c ? 160 : 32, r[r.indexOf(e)] = null) : (u.__e = t.__e, u.__k = t.__k), $79d5e278c02a445b$var$l$1.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $79d5e278c02a445b$var$z$1(t.__e, u, t, i, o, r, f, c, s);
    (a = $79d5e278c02a445b$var$l$1.diffed) && a(u);
}
function $79d5e278c02a445b$var$j$1(n, u, t) {
    for(var i = 0; i < t.length; i++)$79d5e278c02a445b$var$N(t[i], t[++i], t[++i]);
    $79d5e278c02a445b$var$l$1.__c && $79d5e278c02a445b$var$l$1.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $79d5e278c02a445b$var$l$1.__e(n, u.__v);
        }
    });
}
function $79d5e278c02a445b$var$z$1(l, u, t, i, o, r, f, e, s) {
    var a, v, y, d, _, g, b, w = t.props, k = u.props, x = u.type;
    if ("svg" === x && (o = true), null != r) {
        for(a = 0; a < r.length; a++)if ((_ = r[a]) && "setAttribute" in _ == !!x && (x ? _.localName === x : 3 === _.nodeType)) {
            l = _, r[a] = null;
            break;
        }
    }
    if (null == l) {
        if (null === x) return document.createTextNode(k);
        l = o ? document.createElementNS("http://www.w3.org/2000/svg", x) : document.createElement(x, k.is && k), r = null, e = false;
    }
    if (null === x) w === k || e && l.data === k || (l.data = k);
    else {
        if (r = r && $79d5e278c02a445b$var$n.call(l.childNodes), w = t.props || $79d5e278c02a445b$var$c$1, !e && null != r) for(w = {}, a = 0; a < l.attributes.length; a++)w[(_ = l.attributes[a]).name] = _.value;
        for(a in w)_ = w[a], "children" == a || ("dangerouslySetInnerHTML" == a ? y = _ : "key" === a || a in k || $79d5e278c02a445b$var$A$1(l, a, null, _, o));
        for(a in k)_ = k[a], "children" == a ? d = _ : "dangerouslySetInnerHTML" == a ? v = _ : "value" == a ? g = _ : "checked" == a ? b = _ : "key" === a || e && "function" != typeof _ || w[a] === _ || $79d5e278c02a445b$var$A$1(l, a, _, w[a], o);
        if (v) e || y && (v.__html === y.__html || v.__html === l.innerHTML) || (l.innerHTML = v.__html), u.__k = [];
        else if (y && (l.innerHTML = ""), $79d5e278c02a445b$var$P$1(l, $79d5e278c02a445b$var$h$1(d) ? d : [
            d
        ], u, t, i, o && "foreignObject" !== x, r, f, r ? r[0] : t.__k && $79d5e278c02a445b$var$m$1(t, 0), e, s), null != r) for(a = r.length; a--;)null != r[a] && $79d5e278c02a445b$var$p$1(r[a]);
        e || (a = "value", void 0 !== g && (g !== l[a] || "progress" === x && !g || "option" === x && g !== w[a]) && $79d5e278c02a445b$var$A$1(l, a, g, w[a], false), a = "checked", void 0 !== b && b !== l[a] && $79d5e278c02a445b$var$A$1(l, a, b, w[a], false));
    }
    return l;
}
function $79d5e278c02a445b$var$N(n, u, t) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $79d5e278c02a445b$var$l$1.__e(n, t);
    }
}
function $79d5e278c02a445b$var$O(n, u, t) {
    var i, o;
    if ($79d5e278c02a445b$var$l$1.unmount && $79d5e278c02a445b$var$l$1.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $79d5e278c02a445b$var$N(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $79d5e278c02a445b$var$l$1.__e(n, u);
        }
        i.base = i.__P = null, n.__c = void 0;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $79d5e278c02a445b$var$O(i[o], u, t || "function" != typeof n.type);
    t || null == n.__e || $79d5e278c02a445b$var$p$1(n.__e), n.__ = n.__e = n.__d = void 0;
}
function $79d5e278c02a445b$var$q$1(n, l, u) {
    return this.constructor(n, u);
}
function $79d5e278c02a445b$var$B$1(u, t, i) {
    var o, r, f, e;
    $79d5e278c02a445b$var$l$1.__ && $79d5e278c02a445b$var$l$1.__(u, t), r = (o = false, t.__k), f = [], e = [], $79d5e278c02a445b$var$M(t, u = t.__k = $79d5e278c02a445b$var$y$1($79d5e278c02a445b$var$g$1, null, [
        u
    ]), r || $79d5e278c02a445b$var$c$1, $79d5e278c02a445b$var$c$1, void 0 !== t.ownerSVGElement, r ? null : t.firstChild ? $79d5e278c02a445b$var$n.call(t.childNodes) : null, f, r ? r.__e : t.firstChild, o, e), u.__d = void 0, $79d5e278c02a445b$var$j$1(f, u, e);
}
$79d5e278c02a445b$var$n = $79d5e278c02a445b$var$s$1.slice, $79d5e278c02a445b$var$l$1 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $79d5e278c02a445b$var$u$1 = 0, $79d5e278c02a445b$var$b$1.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $79d5e278c02a445b$var$v$1({}, this.state), "function" == typeof n && (n = n($79d5e278c02a445b$var$v$1({}, u), this.props)), n && $79d5e278c02a445b$var$v$1(u, n), null != n && this.__v && (l && this._sb.push(l), $79d5e278c02a445b$var$x$1(this));
}, $79d5e278c02a445b$var$b$1.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = true, n && this.__h.push(n), $79d5e278c02a445b$var$x$1(this));
}, $79d5e278c02a445b$var$b$1.prototype.render = $79d5e278c02a445b$var$g$1, $79d5e278c02a445b$var$i$1 = [], $79d5e278c02a445b$var$r$1 = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $79d5e278c02a445b$var$f$1 = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $79d5e278c02a445b$var$C$1.__r = 0;
var $79d5e278c02a445b$var$t, $79d5e278c02a445b$var$r, $79d5e278c02a445b$var$u, $79d5e278c02a445b$var$i, $79d5e278c02a445b$var$o = 0, $79d5e278c02a445b$var$f = [], $79d5e278c02a445b$var$c = [], $79d5e278c02a445b$var$e = $79d5e278c02a445b$var$l$1, $79d5e278c02a445b$var$a = $79d5e278c02a445b$var$e.__b, $79d5e278c02a445b$var$v = $79d5e278c02a445b$var$e.__r, $79d5e278c02a445b$var$l = $79d5e278c02a445b$var$e.diffed, $79d5e278c02a445b$var$m = $79d5e278c02a445b$var$e.__c, $79d5e278c02a445b$var$s = $79d5e278c02a445b$var$e.unmount, $79d5e278c02a445b$var$d = $79d5e278c02a445b$var$e.__;
function $79d5e278c02a445b$var$h(n, t) {
    $79d5e278c02a445b$var$e.__h && $79d5e278c02a445b$var$e.__h($79d5e278c02a445b$var$r, n, $79d5e278c02a445b$var$o || t), $79d5e278c02a445b$var$o = 0;
    var u = $79d5e278c02a445b$var$r.__H || ($79d5e278c02a445b$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({
        __V: $79d5e278c02a445b$var$c
    }), u.__[n];
}
function $79d5e278c02a445b$var$p(n) {
    return $79d5e278c02a445b$var$o = 1, $79d5e278c02a445b$var$y($79d5e278c02a445b$var$D, n);
}
function $79d5e278c02a445b$var$y(n, u, i) {
    var o = $79d5e278c02a445b$var$h($79d5e278c02a445b$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $79d5e278c02a445b$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $79d5e278c02a445b$var$r, !$79d5e278c02a445b$var$r.u)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return true;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = false;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = true);
                }
            }), !(!i && o.__c.props === n) && (!c || c.call(this, n, t, r));
        };
        $79d5e278c02a445b$var$r.u = true;
        var c = $79d5e278c02a445b$var$r.shouldComponentUpdate, e = $79d5e278c02a445b$var$r.componentWillUpdate;
        $79d5e278c02a445b$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $79d5e278c02a445b$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $79d5e278c02a445b$var$_(n, u) {
    var i = $79d5e278c02a445b$var$h($79d5e278c02a445b$var$t++, 3);
    !$79d5e278c02a445b$var$e.__s && $79d5e278c02a445b$var$C(i.__H, u) && (i.__ = n, i.i = u, $79d5e278c02a445b$var$r.__H.__h.push(i));
}
function $79d5e278c02a445b$var$A(n, u) {
    var i = $79d5e278c02a445b$var$h($79d5e278c02a445b$var$t++, 4);
    !$79d5e278c02a445b$var$e.__s && $79d5e278c02a445b$var$C(i.__H, u) && (i.__ = n, i.i = u, $79d5e278c02a445b$var$r.__h.push(i));
}
function $79d5e278c02a445b$var$F(n) {
    return $79d5e278c02a445b$var$o = 5, $79d5e278c02a445b$var$q(function() {
        return {
            current: n
        };
    }, []);
}
function $79d5e278c02a445b$var$T(n, t, r) {
    $79d5e278c02a445b$var$o = 6, $79d5e278c02a445b$var$A(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $79d5e278c02a445b$var$q(n, r) {
    var u = $79d5e278c02a445b$var$h($79d5e278c02a445b$var$t++, 7);
    return $79d5e278c02a445b$var$C(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function $79d5e278c02a445b$var$x(n, t) {
    return $79d5e278c02a445b$var$o = 8, $79d5e278c02a445b$var$q(function() {
        return n;
    }, t);
}
function $79d5e278c02a445b$var$P(n) {
    var u = $79d5e278c02a445b$var$r.context[n.__c], i = $79d5e278c02a445b$var$h($79d5e278c02a445b$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = true, u.sub($79d5e278c02a445b$var$r)), u.props.value) : n.__;
}
function $79d5e278c02a445b$var$V(n, t) {
    $79d5e278c02a445b$var$e.useDebugValue && $79d5e278c02a445b$var$e.useDebugValue(t ? t(n) : n);
}
function $79d5e278c02a445b$var$b(n) {
    var u = $79d5e278c02a445b$var$h($79d5e278c02a445b$var$t++, 10), i = $79d5e278c02a445b$var$p();
    return u.__ = n, $79d5e278c02a445b$var$r.componentDidCatch || ($79d5e278c02a445b$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $79d5e278c02a445b$var$g() {
    var n = $79d5e278c02a445b$var$h($79d5e278c02a445b$var$t++, 11);
    if (!n.__) {
        for(var u = $79d5e278c02a445b$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $79d5e278c02a445b$var$j() {
    for(var n; n = $79d5e278c02a445b$var$f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach($79d5e278c02a445b$var$z), n.__H.__h.forEach($79d5e278c02a445b$var$B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], $79d5e278c02a445b$var$e.__e(t, n.__v);
    }
}
$79d5e278c02a445b$var$e.__b = function(n) {
    $79d5e278c02a445b$var$r = null, $79d5e278c02a445b$var$a && $79d5e278c02a445b$var$a(n);
}, $79d5e278c02a445b$var$e.__ = function(n, t) {
    t.__k && t.__k.__m && (n.__m = t.__k.__m), $79d5e278c02a445b$var$d && $79d5e278c02a445b$var$d(n, t);
}, $79d5e278c02a445b$var$e.__r = function(n) {
    $79d5e278c02a445b$var$v && $79d5e278c02a445b$var$v(n), $79d5e278c02a445b$var$t = 0;
    var i = ($79d5e278c02a445b$var$r = n.__c).__H;
    i && ($79d5e278c02a445b$var$u === $79d5e278c02a445b$var$r ? (i.__h = [], $79d5e278c02a445b$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = $79d5e278c02a445b$var$c, n.__N = n.i = void 0;
    })) : (i.__h.forEach($79d5e278c02a445b$var$z), i.__h.forEach($79d5e278c02a445b$var$B), i.__h = [], $79d5e278c02a445b$var$t = 0)), $79d5e278c02a445b$var$u = $79d5e278c02a445b$var$r;
}, $79d5e278c02a445b$var$e.diffed = function(n) {
    $79d5e278c02a445b$var$l && $79d5e278c02a445b$var$l(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $79d5e278c02a445b$var$f.push(t) && $79d5e278c02a445b$var$i === $79d5e278c02a445b$var$e.requestAnimationFrame || (($79d5e278c02a445b$var$i = $79d5e278c02a445b$var$e.requestAnimationFrame) || $79d5e278c02a445b$var$w)($79d5e278c02a445b$var$j)), t.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== $79d5e278c02a445b$var$c && (n.__ = n.__V), n.i = void 0, n.__V = $79d5e278c02a445b$var$c;
    })), $79d5e278c02a445b$var$u = $79d5e278c02a445b$var$r = null;
}, $79d5e278c02a445b$var$e.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($79d5e278c02a445b$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $79d5e278c02a445b$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $79d5e278c02a445b$var$e.__e(r, n.__v);
        }
    }), $79d5e278c02a445b$var$m && $79d5e278c02a445b$var$m(n, t);
}, $79d5e278c02a445b$var$e.unmount = function(n) {
    $79d5e278c02a445b$var$s && $79d5e278c02a445b$var$s(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $79d5e278c02a445b$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $79d5e278c02a445b$var$e.__e(t, r.__v));
};
var $79d5e278c02a445b$var$k = "function" == typeof requestAnimationFrame;
function $79d5e278c02a445b$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $79d5e278c02a445b$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $79d5e278c02a445b$var$k && (t = requestAnimationFrame(r));
}
function $79d5e278c02a445b$var$z(n) {
    var t = $79d5e278c02a445b$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $79d5e278c02a445b$var$r = t;
}
function $79d5e278c02a445b$var$B(n) {
    var t = $79d5e278c02a445b$var$r;
    n.__c = n.__(), $79d5e278c02a445b$var$r = t;
}
function $79d5e278c02a445b$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $79d5e278c02a445b$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}
const $79d5e278c02a445b$var$hooks = /*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    useCallback: $79d5e278c02a445b$var$x,
    useContext: $79d5e278c02a445b$var$P,
    useDebugValue: $79d5e278c02a445b$var$V,
    useEffect: $79d5e278c02a445b$var$_,
    useErrorBoundary: $79d5e278c02a445b$var$b,
    useId: $79d5e278c02a445b$var$g,
    useImperativeHandle: $79d5e278c02a445b$var$T,
    useLayoutEffect: $79d5e278c02a445b$var$A,
    useMemo: $79d5e278c02a445b$var$q,
    useReducer: $79d5e278c02a445b$var$y,
    useRef: $79d5e278c02a445b$var$F,
    useState: $79d5e278c02a445b$var$p
}, Symbol.toStringTag, {
    value: 'Module'
});
const $79d5e278c02a445b$var$XMLNS$1 = "http://www.w3.org/2000/svg";
function $79d5e278c02a445b$var$SentryLogo() {
    const createElementNS = (tagName)=>$79d5e278c02a445b$var$DOCUMENT.createElementNS($79d5e278c02a445b$var$XMLNS$1, tagName);
    const svg = $79d5e278c02a445b$var$setAttributesNS(createElementNS("svg"), {
        width: "32",
        height: "30",
        viewBox: "0 0 72 66",
        fill: "inherit"
    });
    const path = $79d5e278c02a445b$var$setAttributesNS(createElementNS("path"), {
        transform: "translate(11, 11)",
        d: "M29,2.26a4.67,4.67,0,0,0-8,0L14.42,13.53A32.21,32.21,0,0,1,32.17,40.19H27.55A27.68,27.68,0,0,0,12.09,17.47L6,28a15.92,15.92,0,0,1,9.23,12.17H4.62A.76.76,0,0,1,4,39.06l2.94-5a10.74,10.74,0,0,0-3.36-1.9l-2.91,5a4.54,4.54,0,0,0,1.69,6.24A4.66,4.66,0,0,0,4.62,44H19.15a19.4,19.4,0,0,0-8-17.31l2.31-4A23.87,23.87,0,0,1,23.76,44H36.07a35.88,35.88,0,0,0-16.41-31.8l4.67-8a.77.77,0,0,1,1.05-.27c.53.29,20.29,34.77,20.66,35.17a.76.76,0,0,1-.68,1.13H40.6q.09,1.91,0,3.81h4.78A4.59,4.59,0,0,0,50,39.43a4.49,4.49,0,0,0-.62-2.28Z"
    });
    svg.appendChild(path);
    return svg;
}
function $79d5e278c02a445b$var$DialogHeader({ options: options }) {
    const logoHtml = $79d5e278c02a445b$var$q(()=>({
            __html: $79d5e278c02a445b$var$SentryLogo().outerHTML
        }), []);
    return /* @__PURE__ */ $79d5e278c02a445b$var$y$1("h2", {
        class: "dialog__header"
    }, /* @__PURE__ */ $79d5e278c02a445b$var$y$1("span", {
        class: "dialog__title"
    }, options.formTitle), options.showBranding ? /* @__PURE__ */ $79d5e278c02a445b$var$y$1("a", {
        class: "brand-link",
        target: "_blank",
        href: "https://sentry.io/welcome/",
        title: "Powered by Sentry",
        rel: "noopener noreferrer",
        dangerouslySetInnerHTML: logoHtml
    }) : null);
}
function $79d5e278c02a445b$var$getMissingFields(feedback, props) {
    const emptyFields = [];
    if (props.isNameRequired && !feedback.name) emptyFields.push(props.nameLabel);
    if (props.isEmailRequired && !feedback.email) emptyFields.push(props.emailLabel);
    if (!feedback.message) emptyFields.push(props.messageLabel);
    return emptyFields;
}
function $79d5e278c02a445b$var$retrieveStringValue(formData, key) {
    const value = formData.get(key);
    if (typeof value === "string") return value.trim();
    return "";
}
function $79d5e278c02a445b$var$Form({ options: options, defaultEmail: defaultEmail, defaultName: defaultName, onFormClose: onFormClose, onSubmit: onSubmit, onSubmitSuccess: onSubmitSuccess, onSubmitError: onSubmitError, showEmail: showEmail, showName: showName, screenshotInput: screenshotInput }) {
    const { tags: tags, addScreenshotButtonLabel: addScreenshotButtonLabel, removeScreenshotButtonLabel: removeScreenshotButtonLabel, cancelButtonLabel: cancelButtonLabel, emailLabel: emailLabel, emailPlaceholder: emailPlaceholder, isEmailRequired: isEmailRequired, isNameRequired: isNameRequired, messageLabel: messageLabel, messagePlaceholder: messagePlaceholder, nameLabel: nameLabel, namePlaceholder: namePlaceholder, submitButtonLabel: submitButtonLabel, isRequiredLabel: isRequiredLabel } = options;
    const [isSubmitting, setIsSubmitting] = $79d5e278c02a445b$var$p(false);
    const [error, setError] = $79d5e278c02a445b$var$p(null);
    const [showScreenshotInput, setShowScreenshotInput] = $79d5e278c02a445b$var$p(false);
    const ScreenshotInputComponent = screenshotInput?.input;
    const [screenshotError, setScreenshotError] = $79d5e278c02a445b$var$p(null);
    const onScreenshotError = $79d5e278c02a445b$var$x((error2)=>{
        setScreenshotError(error2);
        setShowScreenshotInput(false);
    }, []);
    const hasAllRequiredFields = $79d5e278c02a445b$var$x((data)=>{
        const missingFields = $79d5e278c02a445b$var$getMissingFields(data, {
            emailLabel: emailLabel,
            isEmailRequired: isEmailRequired,
            isNameRequired: isNameRequired,
            messageLabel: messageLabel,
            nameLabel: nameLabel
        });
        if (missingFields.length > 0) setError(`Please enter in the following required fields: ${missingFields.join(", ")}`);
        else setError(null);
        return missingFields.length === 0;
    }, [
        emailLabel,
        isEmailRequired,
        isNameRequired,
        messageLabel,
        nameLabel
    ]);
    const handleSubmit = $79d5e278c02a445b$var$x(async (e)=>{
        setIsSubmitting(true);
        try {
            e.preventDefault();
            if (!(e.target instanceof HTMLFormElement)) return;
            const formData = new FormData(e.target);
            const attachment = await (screenshotInput && showScreenshotInput ? screenshotInput.value() : void 0);
            const data = {
                name: $79d5e278c02a445b$var$retrieveStringValue(formData, "name"),
                email: $79d5e278c02a445b$var$retrieveStringValue(formData, "email"),
                message: $79d5e278c02a445b$var$retrieveStringValue(formData, "message"),
                attachments: attachment ? [
                    attachment
                ] : void 0
            };
            if (!hasAllRequiredFields(data)) return;
            try {
                const eventId = await onSubmit({
                    name: data.name,
                    email: data.email,
                    message: data.message,
                    source: $79d5e278c02a445b$var$FEEDBACK_WIDGET_SOURCE,
                    tags: tags
                }, {
                    attachments: data.attachments
                });
                onSubmitSuccess(data, eventId);
            } catch (error2) {
                $79d5e278c02a445b$var$DEBUG_BUILD && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error(error2);
                const err = error2 instanceof Error ? error2 : new Error(String(error2));
                setError(err.message);
                onSubmitError(err);
            }
        } finally{
            setIsSubmitting(false);
        }
    }, [
        screenshotInput && showScreenshotInput,
        onSubmitSuccess,
        onSubmitError
    ]);
    return /* @__PURE__ */ $79d5e278c02a445b$var$y$1("form", {
        class: "form",
        onSubmit: handleSubmit
    }, ScreenshotInputComponent && showScreenshotInput ? /* @__PURE__ */ $79d5e278c02a445b$var$y$1(ScreenshotInputComponent, {
        onError: onScreenshotError
    }) : null, /* @__PURE__ */ $79d5e278c02a445b$var$y$1("fieldset", {
        class: "form__right",
        "data-sentry-feedback": true,
        disabled: isSubmitting
    }, /* @__PURE__ */ $79d5e278c02a445b$var$y$1("div", {
        class: "form__top"
    }, error ? /* @__PURE__ */ $79d5e278c02a445b$var$y$1("div", {
        class: "form__error-container"
    }, error) : null, showName ? /* @__PURE__ */ $79d5e278c02a445b$var$y$1("label", {
        for: "name",
        class: "form__label"
    }, /* @__PURE__ */ $79d5e278c02a445b$var$y$1($79d5e278c02a445b$var$LabelText, {
        label: nameLabel,
        isRequiredLabel: isRequiredLabel,
        isRequired: isNameRequired
    }), /* @__PURE__ */ $79d5e278c02a445b$var$y$1("input", {
        class: "form__input",
        defaultValue: defaultName,
        id: "name",
        name: "name",
        placeholder: namePlaceholder,
        required: isNameRequired,
        type: "text"
    })) : /* @__PURE__ */ $79d5e278c02a445b$var$y$1("input", {
        "aria-hidden": true,
        value: defaultName,
        name: "name",
        type: "hidden"
    }), showEmail ? /* @__PURE__ */ $79d5e278c02a445b$var$y$1("label", {
        for: "email",
        class: "form__label"
    }, /* @__PURE__ */ $79d5e278c02a445b$var$y$1($79d5e278c02a445b$var$LabelText, {
        label: emailLabel,
        isRequiredLabel: isRequiredLabel,
        isRequired: isEmailRequired
    }), /* @__PURE__ */ $79d5e278c02a445b$var$y$1("input", {
        class: "form__input",
        defaultValue: defaultEmail,
        id: "email",
        name: "email",
        placeholder: emailPlaceholder,
        required: isEmailRequired,
        type: "email"
    })) : /* @__PURE__ */ $79d5e278c02a445b$var$y$1("input", {
        "aria-hidden": true,
        value: defaultEmail,
        name: "email",
        type: "hidden"
    }), /* @__PURE__ */ $79d5e278c02a445b$var$y$1("label", {
        for: "message",
        class: "form__label"
    }, /* @__PURE__ */ $79d5e278c02a445b$var$y$1($79d5e278c02a445b$var$LabelText, {
        label: messageLabel,
        isRequiredLabel: isRequiredLabel,
        isRequired: true
    }), /* @__PURE__ */ $79d5e278c02a445b$var$y$1("textarea", {
        autoFocus: true,
        class: "form__input form__input--textarea",
        id: "message",
        name: "message",
        placeholder: messagePlaceholder,
        required: true,
        rows: 5
    })), ScreenshotInputComponent ? /* @__PURE__ */ $79d5e278c02a445b$var$y$1("label", {
        for: "screenshot",
        class: "form__label"
    }, /* @__PURE__ */ $79d5e278c02a445b$var$y$1("button", {
        class: "btn btn--default",
        disabled: isSubmitting,
        type: "button",
        onClick: ()=>{
            setScreenshotError(null);
            setShowScreenshotInput((prev)=>!prev);
        }
    }, showScreenshotInput ? removeScreenshotButtonLabel : addScreenshotButtonLabel), screenshotError ? /* @__PURE__ */ $79d5e278c02a445b$var$y$1("div", {
        class: "form__error-container"
    }, screenshotError.message) : null) : null), /* @__PURE__ */ $79d5e278c02a445b$var$y$1("div", {
        class: "btn-group"
    }, /* @__PURE__ */ $79d5e278c02a445b$var$y$1("button", {
        class: "btn btn--primary",
        disabled: isSubmitting,
        type: "submit"
    }, submitButtonLabel), /* @__PURE__ */ $79d5e278c02a445b$var$y$1("button", {
        class: "btn btn--default",
        disabled: isSubmitting,
        type: "button",
        onClick: onFormClose
    }, cancelButtonLabel))));
}
function $79d5e278c02a445b$var$LabelText({ label: label, isRequired: isRequired, isRequiredLabel: isRequiredLabel }) {
    return /* @__PURE__ */ $79d5e278c02a445b$var$y$1("span", {
        class: "form__label__text"
    }, label, isRequired && /* @__PURE__ */ $79d5e278c02a445b$var$y$1("span", {
        class: "form__label__text--required"
    }, isRequiredLabel));
}
const $79d5e278c02a445b$var$WIDTH = 16;
const $79d5e278c02a445b$var$HEIGHT = 17;
const $79d5e278c02a445b$var$XMLNS = "http://www.w3.org/2000/svg";
function $79d5e278c02a445b$var$SuccessIcon() {
    const createElementNS = (tagName)=>$79d5e278c02a445b$var$WINDOW.document.createElementNS($79d5e278c02a445b$var$XMLNS, tagName);
    const svg = $79d5e278c02a445b$var$setAttributesNS(createElementNS("svg"), {
        width: `${$79d5e278c02a445b$var$WIDTH}`,
        height: `${$79d5e278c02a445b$var$HEIGHT}`,
        viewBox: `0 0 ${$79d5e278c02a445b$var$WIDTH} ${$79d5e278c02a445b$var$HEIGHT}`,
        fill: "inherit"
    });
    const g = $79d5e278c02a445b$var$setAttributesNS(createElementNS("g"), {
        clipPath: "url(#clip0_57_156)"
    });
    const path2 = $79d5e278c02a445b$var$setAttributesNS(createElementNS("path"), {
        ["fill-rule"]: "evenodd",
        ["clip-rule"]: "evenodd",
        d: "M3.55544 15.1518C4.87103 16.0308 6.41775 16.5 8 16.5C10.1217 16.5 12.1566 15.6571 13.6569 14.1569C15.1571 12.6566 16 10.6217 16 8.5C16 6.91775 15.5308 5.37103 14.6518 4.05544C13.7727 2.73985 12.5233 1.71447 11.0615 1.10897C9.59966 0.503466 7.99113 0.34504 6.43928 0.653721C4.88743 0.962403 3.46197 1.72433 2.34315 2.84315C1.22433 3.96197 0.462403 5.38743 0.153721 6.93928C-0.15496 8.49113 0.00346625 10.0997 0.608967 11.5615C1.21447 13.0233 2.23985 14.2727 3.55544 15.1518ZM4.40546 3.1204C5.46945 2.40946 6.72036 2.03 8 2.03C9.71595 2.03 11.3616 2.71166 12.575 3.92502C13.7883 5.13838 14.47 6.78405 14.47 8.5C14.47 9.77965 14.0905 11.0306 13.3796 12.0945C12.6687 13.1585 11.6582 13.9878 10.476 14.4775C9.29373 14.9672 7.99283 15.0953 6.73777 14.8457C5.48271 14.596 4.32987 13.9798 3.42502 13.075C2.52018 12.1701 1.90397 11.0173 1.65432 9.76224C1.40468 8.50718 1.5328 7.20628 2.0225 6.02404C2.5122 4.8418 3.34148 3.83133 4.40546 3.1204Z"
    });
    const path = $79d5e278c02a445b$var$setAttributesNS(createElementNS("path"), {
        d: "M6.68775 12.4297C6.78586 12.4745 6.89218 12.4984 7 12.5C7.11275 12.4955 7.22315 12.4664 7.32337 12.4145C7.4236 12.3627 7.51121 12.2894 7.58 12.2L12 5.63999C12.0848 5.47724 12.1071 5.28902 12.0625 5.11098C12.0178 4.93294 11.9095 4.77744 11.7579 4.67392C11.6064 4.57041 11.4221 4.52608 11.24 4.54931C11.0579 4.57254 10.8907 4.66173 10.77 4.79999L6.88 10.57L5.13 8.56999C5.06508 8.49566 4.98613 8.43488 4.89768 8.39111C4.80922 8.34735 4.713 8.32148 4.61453 8.31498C4.51605 8.30847 4.41727 8.32147 4.32382 8.35322C4.23038 8.38497 4.14413 8.43484 4.07 8.49999C3.92511 8.63217 3.83692 8.81523 3.82387 9.01092C3.81083 9.2066 3.87393 9.39976 4 9.54999L6.43 12.24C6.50187 12.3204 6.58964 12.385 6.68775 12.4297Z"
    });
    svg.appendChild(g).append(path, path2);
    const speakerDefs = createElementNS("defs");
    const speakerClipPathDef = $79d5e278c02a445b$var$setAttributesNS(createElementNS("clipPath"), {
        id: "clip0_57_156"
    });
    const speakerRect = $79d5e278c02a445b$var$setAttributesNS(createElementNS("rect"), {
        width: `${$79d5e278c02a445b$var$WIDTH}`,
        height: `${$79d5e278c02a445b$var$WIDTH}`,
        fill: "white",
        transform: "translate(0 0.5)"
    });
    speakerClipPathDef.appendChild(speakerRect);
    speakerDefs.appendChild(speakerClipPathDef);
    svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);
    return svg;
}
function $79d5e278c02a445b$var$Dialog({ open: open, onFormSubmitted: onFormSubmitted, ...props }) {
    const options = props.options;
    const successIconHtml = $79d5e278c02a445b$var$q(()=>({
            __html: $79d5e278c02a445b$var$SuccessIcon().outerHTML
        }), []);
    const [timeoutId, setTimeoutId] = $79d5e278c02a445b$var$p(null);
    const handleOnSuccessClick = $79d5e278c02a445b$var$x(()=>{
        if (timeoutId) {
            clearTimeout(timeoutId);
            setTimeoutId(null);
        }
        onFormSubmitted();
    }, [
        timeoutId
    ]);
    const onSubmitSuccess = $79d5e278c02a445b$var$x((data, eventId)=>{
        props.onSubmitSuccess(data, eventId);
        setTimeoutId(setTimeout(()=>{
            onFormSubmitted();
            setTimeoutId(null);
        }, $79d5e278c02a445b$var$SUCCESS_MESSAGE_TIMEOUT));
    }, [
        onFormSubmitted
    ]);
    return /* @__PURE__ */ $79d5e278c02a445b$var$y$1($79d5e278c02a445b$var$g$1, null, timeoutId ? /* @__PURE__ */ $79d5e278c02a445b$var$y$1("div", {
        class: "success__position",
        onClick: handleOnSuccessClick
    }, /* @__PURE__ */ $79d5e278c02a445b$var$y$1("div", {
        class: "success__content"
    }, options.successMessageText, /* @__PURE__ */ $79d5e278c02a445b$var$y$1("span", {
        class: "success__icon",
        dangerouslySetInnerHTML: successIconHtml
    }))) : /* @__PURE__ */ $79d5e278c02a445b$var$y$1("dialog", {
        class: "dialog",
        onClick: options.onFormClose,
        open: open
    }, /* @__PURE__ */ $79d5e278c02a445b$var$y$1("div", {
        class: "dialog__position"
    }, /* @__PURE__ */ $79d5e278c02a445b$var$y$1("div", {
        class: "dialog__content",
        onClick: (e)=>{
            e.stopPropagation();
        }
    }, /* @__PURE__ */ $79d5e278c02a445b$var$y$1($79d5e278c02a445b$var$DialogHeader, {
        options: options
    }), /* @__PURE__ */ $79d5e278c02a445b$var$y$1($79d5e278c02a445b$var$Form, {
        ...props,
        onSubmitSuccess: onSubmitSuccess
    })))));
}
const $79d5e278c02a445b$var$DIALOG = `
.dialog {
  position: fixed;
  z-index: var(--z-index);
  margin: 0;
  inset: 0;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  height: 100vh;
  width: 100vw;

  color: var(--dialog-color, var(--foreground));
  fill: var(--dialog-color, var(--foreground));
  line-height: 1.75em;

  background-color: rgba(0, 0, 0, 0.05);
  border: none;
  inset: 0;
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
}

.dialog__position {
  position: fixed;
  z-index: var(--z-index);
  inset: var(--dialog-inset);
  padding: var(--page-margin);
  display: flex;
  max-height: calc(100vh - (2 * var(--page-margin)));
}
@media (max-width: 600px) {
  .dialog__position {
    inset: var(--page-margin);
    padding: 0;
  }
}

.dialog__position:has(.editor) {
  inset: var(--page-margin);
  padding: 0;
}

.dialog:not([open]) {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
}
.dialog:not([open]) .dialog__content {
  transform: translate(0, -16px) scale(0.98);
}

.dialog__content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: var(--dialog-padding, 24px);
  max-width: 100%;
  width: 100%;
  max-height: 100%;
  overflow: auto;

  background: var(--dialog-background, var(--background));
  border-radius: var(--dialog-border-radius, 20px);
  border: var(--dialog-border, var(--border));
  box-shadow: var(--dialog-box-shadow, var(--box-shadow));
  transform: translate(0, 0) scale(1);
  transition: transform 0.2s ease-in-out;
}

`;
const $79d5e278c02a445b$var$DIALOG_HEADER = `
.dialog__header {
  display: flex;
  gap: 4px;
  justify-content: space-between;
  font-weight: var(--dialog-header-weight, 600);
  margin: 0;
}
.dialog__title {
  align-self: center;
  width: var(--form-width, 272px);
}

@media (max-width: 600px) {
  .dialog__title {
    width: auto;
  }
}

.dialog__position:has(.editor) .dialog__title {
  width: auto;
}


.brand-link {
  display: inline-flex;
}
.brand-link:focus-visible {
  outline: var(--outline);
}
`;
const $79d5e278c02a445b$var$FORM = `
.form {
  display: flex;
  overflow: auto;
  flex-direction: row;
  gap: 16px;
  flex: 1 0;
}

.form fieldset {
  border: none;
  margin: 0;
  padding: 0;
}

.form__right {
  flex: 0 0 auto;
  display: flex;
  overflow: auto;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
  width: var(--form-width, 100%);
}

.dialog__position:has(.editor) .form__right {
  width: var(--form-width, 272px);
}

.form__top {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form__error-container {
  color: var(--error-color);
  fill: var(--error-color);
}

.form__label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0px;
}

.form__label__text {
  display: flex;
  gap: 4px;
  align-items: center;
}

.form__label__text--required {
  font-size: 0.85em;
}

.form__input {
  font-family: inherit;
  line-height: inherit;
  background: transparent;
  box-sizing: border-box;
  border: var(--input-border, var(--border));
  border-radius: var(--input-border-radius, 6px);
  color: var(--input-color, inherit);
  fill: var(--input-color, inherit);
  font-size: var(--input-font-size, inherit);
  font-weight: var(--input-font-weight, 500);
  padding: 6px 12px;
}

.form__input::placeholder {
  opacity: 0.65;
  color: var(--input-placeholder-color, inherit);
  filter: var(--interactive-filter);
}

.form__input:focus-visible {
  outline: var(--input-focus-outline, var(--outline));
}

.form__input--textarea {
  font-family: inherit;
  resize: vertical;
}

.error {
  color: var(--error-color);
  fill: var(--error-color);
}
`;
const $79d5e278c02a445b$var$BUTTON = `
.btn-group {
  display: grid;
  gap: 8px;
}

.btn {
  line-height: inherit;
  border: var(--button-border, var(--border));
  border-radius: var(--button-border-radius, 6px);
  cursor: pointer;
  font-family: inherit;
  font-size: var(--button-font-size, inherit);
  font-weight: var(--button-font-weight, 600);
  padding: var(--button-padding, 6px 16px);
}
.btn[disabled] {
  opacity: 0.6;
  pointer-events: none;
}

.btn--primary {
  color: var(--button-primary-color, var(--accent-foreground));
  fill: var(--button-primary-color, var(--accent-foreground));
  background: var(--button-primary-background, var(--accent-background));
  border: var(--button-primary-border, var(--border));
  border-radius: var(--button-primary-border-radius, 6px);
  font-weight: var(--button-primary-font-weight, 500);
}
.btn--primary:hover {
  color: var(--button-primary-hover-color, var(--accent-foreground));
  fill: var(--button-primary-hover-color, var(--accent-foreground));
  background: var(--button-primary-hover-background, var(--accent-background));
  filter: var(--interactive-filter);
}
.btn--primary:focus-visible {
  background: var(--button-primary-hover-background, var(--accent-background));
  filter: var(--interactive-filter);
  outline: var(--button-primary-focus-outline, var(--outline));
}

.btn--default {
  color: var(--button-color, var(--foreground));
  fill: var(--button-color, var(--foreground));
  background: var(--button-background, var(--background));
  border: var(--button-border, var(--border));
  border-radius: var(--button-border-radius, 6px);
  font-weight: var(--button-font-weight, 500);
}
.btn--default:hover {
  color: var(--button-color, var(--foreground));
  fill: var(--button-color, var(--foreground));
  background: var(--button-hover-background, var(--background));
  filter: var(--interactive-filter);
}
.btn--default:focus-visible {
  background: var(--button-hover-background, var(--background));
  filter: var(--interactive-filter);
  outline: var(--button-focus-outline, var(--outline));
}
`;
const $79d5e278c02a445b$var$SUCCESS = `
.success__position {
  position: fixed;
  inset: var(--dialog-inset);
  padding: var(--page-margin);
  z-index: var(--z-index);
}
.success__content {
  background: var(--success-background, var(--background));
  border: var(--success-border, var(--border));
  border-radius: var(--success-border-radius, 1.7em/50%);
  box-shadow: var(--success-box-shadow, var(--box-shadow));
  font-weight: var(--success-font-weight, 600);
  color: var(--success-color);
  fill: var(--success-color);
  padding: 12px 24px;
  line-height: 1.75em;

  display: grid;
  align-items: center;
  grid-auto-flow: column;
  gap: 6px;
  cursor: default;
}

.success__icon {
  display: flex;
}
`;
function $79d5e278c02a445b$var$createDialogStyles(styleNonce) {
    const style = $79d5e278c02a445b$var$DOCUMENT.createElement("style");
    style.textContent = `
:host {
  --dialog-inset: var(--inset);
}

${$79d5e278c02a445b$var$DIALOG}
${$79d5e278c02a445b$var$DIALOG_HEADER}
${$79d5e278c02a445b$var$FORM}
${$79d5e278c02a445b$var$BUTTON}
${$79d5e278c02a445b$var$SUCCESS}
`;
    if (styleNonce) style.setAttribute("nonce", styleNonce);
    return style;
}
function $79d5e278c02a445b$var$getUser() {
    const currentUser = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().getUser();
    const isolationUser = (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)().getUser();
    const globalUser = (0, $7d48e1ed9f699a01$export$aa55d5ab8e05984f)().getUser();
    if (currentUser && Object.keys(currentUser).length) return currentUser;
    if (isolationUser && Object.keys(isolationUser).length) return isolationUser;
    return globalUser;
}
const $79d5e278c02a445b$export$2ed486683e133d58 = ()=>{
    return {
        name: "FeedbackModal",
        setupOnce () {},
        createDialog: ({ options: options, screenshotIntegration: screenshotIntegration, sendFeedback: sendFeedback, shadow: shadow })=>{
            const shadowRoot = shadow;
            const userKey = options.useSentryUser;
            const user = $79d5e278c02a445b$var$getUser();
            const el = $79d5e278c02a445b$var$DOCUMENT.createElement("div");
            const style = $79d5e278c02a445b$var$createDialogStyles(options.styleNonce);
            let originalOverflow = "";
            const dialog = {
                get el () {
                    return el;
                },
                appendToDom () {
                    if (!shadowRoot.contains(style) && !shadowRoot.contains(el)) {
                        shadowRoot.appendChild(style);
                        shadowRoot.appendChild(el);
                    }
                },
                removeFromDom () {
                    el.remove();
                    style.remove();
                    $79d5e278c02a445b$var$DOCUMENT.body.style.overflow = originalOverflow;
                },
                open () {
                    renderContent(true);
                    options.onFormOpen?.();
                    (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)()?.emit("openFeedbackWidget");
                    originalOverflow = $79d5e278c02a445b$var$DOCUMENT.body.style.overflow;
                    $79d5e278c02a445b$var$DOCUMENT.body.style.overflow = "hidden";
                },
                close () {
                    renderContent(false);
                    $79d5e278c02a445b$var$DOCUMENT.body.style.overflow = originalOverflow;
                }
            };
            const screenshotInput = screenshotIntegration?.createInput({
                h: $79d5e278c02a445b$var$y$1,
                hooks: $79d5e278c02a445b$var$hooks,
                dialog: dialog,
                options: options
            });
            const renderContent = (open)=>{
                $79d5e278c02a445b$var$B$1(/* @__PURE__ */ $79d5e278c02a445b$var$y$1($79d5e278c02a445b$var$Dialog, {
                    options: options,
                    screenshotInput: screenshotInput,
                    showName: options.showName || options.isNameRequired,
                    showEmail: options.showEmail || options.isEmailRequired,
                    defaultName: String(userKey && user?.[userKey.name] || ""),
                    defaultEmail: String(userKey && user?.[userKey.email] || ""),
                    onFormClose: ()=>{
                        renderContent(false);
                        options.onFormClose?.();
                    },
                    onSubmit: sendFeedback,
                    onSubmitSuccess: (data, eventId)=>{
                        renderContent(false);
                        options.onSubmitSuccess?.(data, eventId);
                    },
                    onSubmitError: (error)=>{
                        options.onSubmitError?.(error);
                    },
                    onFormSubmitted: ()=>{
                        options.onFormSubmitted?.();
                    },
                    open: open
                }), el);
            };
            return dialog;
        }
    };
};
function $79d5e278c02a445b$var$IconCloseFactory({ h: h }) {
    return function IconClose() {
        return /* @__PURE__ */ h("svg", {
            "data-test-id": "icon-close",
            viewBox: "0 0 16 16",
            fill: "#2B2233",
            height: "25px",
            width: "25px"
        }, /* @__PURE__ */ h("circle", {
            r: "7",
            cx: "8",
            cy: "8",
            fill: "white"
        }), /* @__PURE__ */ h("path", {
            strokeWidth: "1.5",
            d: "M8,16a8,8,0,1,1,8-8A8,8,0,0,1,8,16ZM8,1.53A6.47,6.47,0,1,0,14.47,8,6.47,6.47,0,0,0,8,1.53Z"
        }), /* @__PURE__ */ h("path", {
            strokeWidth: "1.5",
            d: "M5.34,11.41a.71.71,0,0,1-.53-.22.74.74,0,0,1,0-1.06l5.32-5.32a.75.75,0,0,1,1.06,1.06L5.87,11.19A.74.74,0,0,1,5.34,11.41Z"
        }), /* @__PURE__ */ h("path", {
            strokeWidth: "1.5",
            d: "M10.66,11.41a.74.74,0,0,1-.53-.22L4.81,5.87A.75.75,0,0,1,5.87,4.81l5.32,5.32a.74.74,0,0,1,0,1.06A.71.71,0,0,1,10.66,11.41Z"
        }));
    };
}
function $79d5e278c02a445b$var$createScreenshotInputStyles(styleNonce) {
    const style = $79d5e278c02a445b$var$DOCUMENT.createElement("style");
    const surface200 = "#1A141F";
    const gray100 = "#302735";
    style.textContent = `
.editor {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}

.editor__image-container {
  justify-items: center;
  padding: 15px;
  position: relative;
  height: 100%;
  border-radius: var(--menu-border-radius, 6px);

  background-color: ${surface200};
  background-image: repeating-linear-gradient(
      -145deg,
      transparent,
      transparent 8px,
      ${surface200} 8px,
      ${surface200} 11px
    ),
    repeating-linear-gradient(
      -45deg,
      transparent,
      transparent 15px,
      ${gray100} 15px,
      ${gray100} 16px
    );
}

.editor__canvas-container {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.editor__canvas-container > * {
  object-fit: contain;
  position: absolute;
}

.editor__tool-container {
  padding-top: 8px;
  display: flex;
  justify-content: center;
}

.editor__tool-bar {
  display: flex;
  gap: 8px;
}

.editor__tool {
  display: flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  border: var(--button-border, var(--border));
  border-radius: var(--button-border-radius, 6px);
  background: var(--button-background, var(--background));
  color: var(--button-color, var(--foreground));
}

.editor__tool--active {
  background: var(--button-primary-background, var(--accent-background));
  color: var(--button-primary-color, var(--accent-foreground));
}

.editor__rect {
  position: absolute;
  z-index: 2;
}

.editor__rect button {
  opacity: 0;
  position: absolute;
  top: -12px;
  right: -12px;
  cursor: pointer;
  padding: 0;
  z-index: 3;
  border: none;
  background: none;
}

.editor__rect:hover button {
  opacity: 1;
}
`;
    if (styleNonce) style.setAttribute("nonce", styleNonce);
    return style;
}
function $79d5e278c02a445b$var$ToolbarFactory({ h: h }) {
    return function Toolbar({ action: action, setAction: setAction, options: options }) {
        return /* @__PURE__ */ h("div", {
            class: "editor__tool-container"
        }, /* @__PURE__ */ h("div", {
            class: "editor__tool-bar"
        }, /* @__PURE__ */ h("button", {
            type: "button",
            class: `editor__tool ${action === "highlight" ? "editor__tool--active" : ""}`,
            onClick: ()=>{
                setAction(action === "highlight" ? "" : "highlight");
            }
        }, options.highlightToolText), /* @__PURE__ */ h("button", {
            type: "button",
            class: `editor__tool ${action === "hide" ? "editor__tool--active" : ""}`,
            onClick: ()=>{
                setAction(action === "hide" ? "" : "hide");
            }
        }, options.hideToolText)));
    };
}
function $79d5e278c02a445b$var$useTakeScreenshotFactory({ hooks: hooks }) {
    function useDpi() {
        const [dpi, setDpi] = hooks.useState($79d5e278c02a445b$var$WINDOW.devicePixelRatio ?? 1);
        hooks.useEffect(()=>{
            const onChange = ()=>{
                setDpi($79d5e278c02a445b$var$WINDOW.devicePixelRatio);
            };
            const media = matchMedia(`(resolution: ${$79d5e278c02a445b$var$WINDOW.devicePixelRatio}dppx)`);
            media.addEventListener("change", onChange);
            return ()=>{
                media.removeEventListener("change", onChange);
            };
        }, []);
        return dpi;
    }
    return function useTakeScreenshot({ onBeforeScreenshot: onBeforeScreenshot, onScreenshot: onScreenshot, onAfterScreenshot: onAfterScreenshot, onError: onError }) {
        const dpi = useDpi();
        hooks.useEffect(()=>{
            const takeScreenshot = async ()=>{
                onBeforeScreenshot();
                const stream = await $79d5e278c02a445b$var$NAVIGATOR.mediaDevices.getDisplayMedia({
                    video: {
                        width: $79d5e278c02a445b$var$WINDOW.innerWidth * dpi,
                        height: $79d5e278c02a445b$var$WINDOW.innerHeight * dpi
                    },
                    audio: false,
                    // @ts-expect-error experimental flags: https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getDisplayMedia#prefercurrenttab
                    monitorTypeSurfaces: "exclude",
                    preferCurrentTab: true,
                    selfBrowserSurface: "include",
                    surfaceSwitching: "exclude"
                });
                const video = $79d5e278c02a445b$var$DOCUMENT.createElement("video");
                await new Promise((resolve, reject)=>{
                    video.srcObject = stream;
                    video.onloadedmetadata = ()=>{
                        onScreenshot(video, dpi);
                        stream.getTracks().forEach((track)=>track.stop());
                        resolve();
                    };
                    video.play().catch(reject);
                });
                onAfterScreenshot();
            };
            takeScreenshot().catch(onError);
        }, []);
    };
}
function $79d5e278c02a445b$var$drawRect(command, ctx, color) {
    switch(command.type){
        case "highlight":
            ctx.shadowColor = "rgba(0, 0, 0, 0.7)";
            ctx.shadowBlur = 50;
            ctx.fillStyle = color;
            ctx.fillRect(command.x - 1, command.y - 1, command.w + 2, command.h + 2);
            ctx.clearRect(command.x, command.y, command.w, command.h);
            break;
        case "hide":
            ctx.fillStyle = "rgb(0, 0, 0)";
            ctx.fillRect(command.x, command.y, command.w, command.h);
            break;
    }
}
function $79d5e278c02a445b$var$with2dContext(canvas, options, callback) {
    if (!canvas) return;
    const ctx = canvas.getContext("2d", options);
    if (!ctx) return;
    callback(canvas, ctx);
}
function $79d5e278c02a445b$var$paintImage(maybeDest, source) {
    $79d5e278c02a445b$var$with2dContext(maybeDest, {
        alpha: true
    }, (destCanvas, destCtx)=>{
        destCtx.drawImage(source, 0, 0, source.width, source.height, 0, 0, destCanvas.width, destCanvas.height);
    });
}
function $79d5e278c02a445b$var$paintForeground(maybeCanvas, strokeColor, drawCommands) {
    $79d5e278c02a445b$var$with2dContext(maybeCanvas, {
        alpha: true
    }, (canvas, ctx)=>{
        if (drawCommands.length) {
            ctx.fillStyle = "rgba(0, 0, 0, 0.25)";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        }
        drawCommands.forEach((command)=>{
            $79d5e278c02a445b$var$drawRect(command, ctx, strokeColor);
        });
    });
}
function $79d5e278c02a445b$var$ScreenshotEditorFactory({ h: h2, hooks: hooks, outputBuffer: outputBuffer, dialog: dialog, options: options }) {
    const useTakeScreenshot = $79d5e278c02a445b$var$useTakeScreenshotFactory({
        hooks: hooks
    });
    const Toolbar = $79d5e278c02a445b$var$ToolbarFactory({
        h: h2
    });
    const IconClose = $79d5e278c02a445b$var$IconCloseFactory({
        h: h2
    });
    const editorStyleInnerText = {
        __html: $79d5e278c02a445b$var$createScreenshotInputStyles(options.styleNonce).innerText
    };
    const dialogStyle = dialog.el.style;
    const ScreenshotEditor = ({ screenshot: screenshot })=>{
        const [action, setAction] = hooks.useState("highlight");
        const [drawCommands, setDrawCommands] = hooks.useState([]);
        const measurementRef = hooks.useRef(null);
        const backgroundRef = hooks.useRef(null);
        const foregroundRef = hooks.useRef(null);
        const mouseRef = hooks.useRef(null);
        const [scaleFactor, setScaleFactor] = hooks.useState(1);
        const strokeColor = hooks.useMemo(()=>{
            const sentryFeedback = $79d5e278c02a445b$var$DOCUMENT.getElementById(options.id);
            if (!sentryFeedback) return "white";
            const computedStyle = getComputedStyle(sentryFeedback);
            return computedStyle.getPropertyValue("--button-primary-background") || computedStyle.getPropertyValue("--accent-background");
        }, [
            options.id
        ]);
        hooks.useLayoutEffect(()=>{
            const handleResize = ()=>{
                const measurementDiv = measurementRef.current;
                if (!measurementDiv) return;
                $79d5e278c02a445b$var$with2dContext(screenshot.canvas, {
                    alpha: false
                }, (canvas)=>{
                    const scale = Math.min(measurementDiv.clientWidth / canvas.width, measurementDiv.clientHeight / canvas.height);
                    setScaleFactor(scale);
                });
                if (measurementDiv.clientHeight === 0 || measurementDiv.clientWidth === 0) setTimeout(handleResize, 0);
            };
            handleResize();
            $79d5e278c02a445b$var$WINDOW.addEventListener("resize", handleResize);
            return ()=>{
                $79d5e278c02a445b$var$WINDOW.removeEventListener("resize", handleResize);
            };
        }, [
            screenshot
        ]);
        const setCanvasSize = hooks.useCallback((maybeCanvas, scale)=>{
            $79d5e278c02a445b$var$with2dContext(maybeCanvas, {
                alpha: true
            }, (canvas, ctx)=>{
                ctx.scale(scale, scale);
                canvas.width = screenshot.canvas.width;
                canvas.height = screenshot.canvas.height;
            });
        }, [
            screenshot
        ]);
        hooks.useEffect(()=>{
            setCanvasSize(backgroundRef.current, screenshot.dpi);
            $79d5e278c02a445b$var$paintImage(backgroundRef.current, screenshot.canvas);
        }, [
            screenshot
        ]);
        hooks.useEffect(()=>{
            setCanvasSize(foregroundRef.current, screenshot.dpi);
            $79d5e278c02a445b$var$with2dContext(foregroundRef.current, {
                alpha: true
            }, (canvas, ctx)=>{
                ctx.clearRect(0, 0, canvas.width, canvas.height);
            });
            $79d5e278c02a445b$var$paintForeground(foregroundRef.current, strokeColor, drawCommands);
        }, [
            drawCommands,
            strokeColor
        ]);
        hooks.useEffect(()=>{
            setCanvasSize(outputBuffer, screenshot.dpi);
            $79d5e278c02a445b$var$paintImage(outputBuffer, screenshot.canvas);
            $79d5e278c02a445b$var$with2dContext($79d5e278c02a445b$var$DOCUMENT.createElement("canvas"), {
                alpha: true
            }, (foreground, ctx)=>{
                ctx.scale(screenshot.dpi, screenshot.dpi);
                foreground.width = screenshot.canvas.width;
                foreground.height = screenshot.canvas.height;
                $79d5e278c02a445b$var$paintForeground(foreground, strokeColor, drawCommands);
                $79d5e278c02a445b$var$paintImage(outputBuffer, foreground);
            });
        }, [
            drawCommands,
            screenshot,
            strokeColor
        ]);
        const handleMouseDown = (e)=>{
            if (!action || !mouseRef.current) return;
            const boundingRect = mouseRef.current.getBoundingClientRect();
            const startingPoint = {
                type: action,
                x: e.offsetX / scaleFactor,
                y: e.offsetY / scaleFactor
            };
            const getDrawCommand = (startingPoint2, e2)=>{
                const x = (e2.clientX - boundingRect.x) / scaleFactor;
                const y = (e2.clientY - boundingRect.y) / scaleFactor;
                return {
                    type: startingPoint2.type,
                    x: Math.min(startingPoint2.x, x),
                    y: Math.min(startingPoint2.y, y),
                    w: Math.abs(x - startingPoint2.x),
                    h: Math.abs(y - startingPoint2.y)
                };
            };
            const handleMouseMove = (e2)=>{
                $79d5e278c02a445b$var$with2dContext(foregroundRef.current, {
                    alpha: true
                }, (canvas, ctx)=>{
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                });
                $79d5e278c02a445b$var$paintForeground(foregroundRef.current, strokeColor, [
                    ...drawCommands,
                    getDrawCommand(startingPoint, e2)
                ]);
            };
            const handleMouseUp = (e2)=>{
                const drawCommand = getDrawCommand(startingPoint, e2);
                if (drawCommand.w * scaleFactor >= 1 && drawCommand.h * scaleFactor >= 1) setDrawCommands((prev)=>[
                        ...prev,
                        drawCommand
                    ]);
                $79d5e278c02a445b$var$DOCUMENT.removeEventListener("mousemove", handleMouseMove);
                $79d5e278c02a445b$var$DOCUMENT.removeEventListener("mouseup", handleMouseUp);
            };
            $79d5e278c02a445b$var$DOCUMENT.addEventListener("mousemove", handleMouseMove);
            $79d5e278c02a445b$var$DOCUMENT.addEventListener("mouseup", handleMouseUp);
        };
        const deleteRect = hooks.useCallback((index)=>{
            return (e)=>{
                e.preventDefault();
                e.stopPropagation();
                setDrawCommands((prev)=>{
                    const updatedRects = [
                        ...prev
                    ];
                    updatedRects.splice(index, 1);
                    return updatedRects;
                });
            };
        }, []);
        const dimensions = {
            width: `${screenshot.canvas.width * scaleFactor}px`,
            height: `${screenshot.canvas.height * scaleFactor}px`
        };
        const handleStopPropagation = (e)=>{
            e.stopPropagation();
        };
        return /* @__PURE__ */ h2("div", {
            class: "editor"
        }, /* @__PURE__ */ h2("style", {
            nonce: options.styleNonce,
            dangerouslySetInnerHTML: editorStyleInnerText
        }), /* @__PURE__ */ h2("div", {
            class: "editor__image-container"
        }, /* @__PURE__ */ h2("div", {
            class: "editor__canvas-container",
            ref: measurementRef
        }, /* @__PURE__ */ h2("canvas", {
            ref: backgroundRef,
            id: "background",
            style: dimensions
        }), /* @__PURE__ */ h2("canvas", {
            ref: foregroundRef,
            id: "foreground",
            style: dimensions
        }), /* @__PURE__ */ h2("div", {
            ref: mouseRef,
            onMouseDown: handleMouseDown,
            style: dimensions
        }, drawCommands.map((rect, index)=>/* @__PURE__ */ h2("div", {
                key: index,
                class: "editor__rect",
                style: {
                    top: `${rect.y * scaleFactor}px`,
                    left: `${rect.x * scaleFactor}px`,
                    width: `${rect.w * scaleFactor}px`,
                    height: `${rect.h * scaleFactor}px`
                }
            }, /* @__PURE__ */ h2("button", {
                "aria-label": options.removeHighlightText,
                onClick: deleteRect(index),
                onMouseDown: handleStopPropagation,
                onMouseUp: handleStopPropagation,
                type: "button"
            }, /* @__PURE__ */ h2(IconClose, null))))))), /* @__PURE__ */ h2(Toolbar, {
            options: options,
            action: action,
            setAction: setAction
        }));
    };
    return function Wrapper({ onError: onError }) {
        const [screenshot, setScreenshot] = hooks.useState();
        useTakeScreenshot({
            onBeforeScreenshot: hooks.useCallback(()=>{
                dialogStyle.display = "none";
            }, []),
            onScreenshot: hooks.useCallback((screenshotVideo, dpi)=>{
                $79d5e278c02a445b$var$with2dContext($79d5e278c02a445b$var$DOCUMENT.createElement("canvas"), {
                    alpha: false
                }, (canvas, ctx)=>{
                    ctx.scale(dpi, dpi);
                    canvas.width = screenshotVideo.videoWidth;
                    canvas.height = screenshotVideo.videoHeight;
                    ctx.drawImage(screenshotVideo, 0, 0, canvas.width, canvas.height);
                    setScreenshot({
                        canvas: canvas,
                        dpi: dpi
                    });
                });
                outputBuffer.width = screenshotVideo.videoWidth;
                outputBuffer.height = screenshotVideo.videoHeight;
            }, []),
            onAfterScreenshot: hooks.useCallback(()=>{
                dialogStyle.display = "block";
            }, []),
            onError: hooks.useCallback((error)=>{
                dialogStyle.display = "block";
                onError(error);
            }, [])
        });
        if (screenshot) return /* @__PURE__ */ h2(ScreenshotEditor, {
            screenshot: screenshot
        });
        return /* @__PURE__ */ h2("div", null);
    };
}
const $79d5e278c02a445b$export$fd00458861e48ab4 = ()=>{
    return {
        name: "FeedbackScreenshot",
        setupOnce () {},
        createInput: ({ h: h, hooks: hooks, dialog: dialog, options: options })=>{
            const outputBuffer = $79d5e278c02a445b$var$DOCUMENT.createElement("canvas");
            return {
                input: $79d5e278c02a445b$var$ScreenshotEditorFactory({
                    h: h,
                    hooks: hooks,
                    outputBuffer: outputBuffer,
                    dialog: dialog,
                    options: options
                }),
                // eslint-disable-line @typescript-eslint/no-explicit-any
                value: async ()=>{
                    const blob = await new Promise((resolve)=>{
                        outputBuffer.toBlob(resolve, "image/png");
                    });
                    if (blob) {
                        const data = new Uint8Array(await blob.arrayBuffer());
                        const attachment = {
                            data: data,
                            filename: "screenshot.png",
                            contentType: "application/png"
                        };
                        return attachment;
                    }
                    return void 0;
                }
            };
        }
    };
};


var $b244ff70a28cf637$exports = {};
// This file is a compatibility shim for bundlers (e.g. webpack 4) that do not
// support the package.json `exports` field for resolving subpath exports.

$b244ff70a28cf637$exports = (parcelRequire("25LTq"));



const $e62dec891f31852b$export$56d8a8a25bd48b81 = (0, $b244ff70a28cf637$exports.GLOBAL_OBJ);
let $e62dec891f31852b$var$ignoreOnError = 0;
function $e62dec891f31852b$export$b79738ab10c590b2() {
    return $e62dec891f31852b$var$ignoreOnError > 0;
}
function $e62dec891f31852b$export$1265a142ff5ba165() {
    $e62dec891f31852b$var$ignoreOnError++;
    setTimeout(()=>{
        $e62dec891f31852b$var$ignoreOnError--;
    });
}
function $e62dec891f31852b$export$4997ffc0176396a6(fn, options = {}) {
    function isFunction(fn2) {
        return typeof fn2 === "function";
    }
    if (!isFunction(fn)) return fn;
    try {
        const hasOwnWrapper = Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__");
        if (hasOwnWrapper) {
            const wrapper = fn.__sentry_wrapped__;
            if (typeof wrapper === "function") return wrapper;
            else return fn;
        }
        if ((0, $b244ff70a28cf637$exports.getOriginalFunction)(fn)) return fn;
    } catch  {
        return fn;
    }
    const sentryWrapped = function(...args) {
        (0, $b244ff70a28cf637$exports.GLOBAL_OBJ)._sentryWrappedDepth = ((0, $b244ff70a28cf637$exports.GLOBAL_OBJ)._sentryWrappedDepth || 0) + 1;
        try {
            const wrappedArguments = args.map((arg)=>$e62dec891f31852b$export$4997ffc0176396a6(arg, options));
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $e62dec891f31852b$export$1265a142ff5ba165();
            (0, $b244ff70a28cf637$exports.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $b244ff70a28cf637$exports.addExceptionTypeValue)(event, void 0, void 0);
                        (0, $b244ff70a28cf637$exports.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $b244ff70a28cf637$exports.captureException)(ex);
            });
            throw ex;
        } finally{
            (0, $b244ff70a28cf637$exports.GLOBAL_OBJ)._sentryWrappedDepth = ((0, $b244ff70a28cf637$exports.GLOBAL_OBJ)._sentryWrappedDepth || 0) - 1;
        }
    };
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {}
    (0, $b244ff70a28cf637$exports.markFunctionWrapped)(sentryWrapped, fn);
    (0, $b244ff70a28cf637$exports.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    } catch  {}
    return sentryWrapped;
}
function $e62dec891f31852b$export$a3c4a8453e8936f0() {
    const url = (0, $b244ff70a28cf637$exports.getLocationHref)();
    const { referrer: referrer } = $e62dec891f31852b$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $e62dec891f31852b$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: referrer
        },
        ...userAgent && {
            "User-Agent": userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}


const $3fc94f2ac1572f6d$var$LAZY_LOADABLE_NAMES = [
    "replayIntegration",
    "replayCanvasIntegration",
    "feedbackIntegration",
    "feedbackModalIntegration",
    "feedbackScreenshotIntegration",
    "captureConsoleIntegration",
    "contextLinesIntegration",
    "linkedErrorsIntegration",
    "dedupeIntegration",
    "extraErrorDataIntegration",
    "graphqlClientIntegration",
    "httpClientIntegration",
    "reportingObserverIntegration",
    "rewriteFramesIntegration",
    "browserProfilingIntegration",
    "moduleMetadataIntegration",
    "instrumentAnthropicAiClient",
    "instrumentOpenAiClient",
    "instrumentGoogleGenAIClient",
    "instrumentStateGraph",
    "instrumentLangGraph",
    "createLangChainCallbackHandler",
    "instrumentLangChainEmbeddings"
];
const $3fc94f2ac1572f6d$var$HYPHENATED_BUNDLES = {
    replayCanvasIntegration: "replay-canvas",
    feedbackModalIntegration: "feedback-modal",
    feedbackScreenshotIntegration: "feedback-screenshot"
};
function $3fc94f2ac1572f6d$var$getBundleName(name) {
    return $3fc94f2ac1572f6d$var$HYPHENATED_BUNDLES[name] || name.replace("Integration", "").toLowerCase();
}
const $3fc94f2ac1572f6d$var$WindowWithMaybeIntegration = (0, $e62dec891f31852b$export$56d8a8a25bd48b81);
async function $3fc94f2ac1572f6d$export$6da56f3ddf2bd0c1(name, scriptNonce) {
    const bundle = $3fc94f2ac1572f6d$var$LAZY_LOADABLE_NAMES.includes(name) ? $3fc94f2ac1572f6d$var$getBundleName(name) : void 0;
    const sentryOnWindow = $3fc94f2ac1572f6d$var$WindowWithMaybeIntegration.Sentry = $3fc94f2ac1572f6d$var$WindowWithMaybeIntegration.Sentry || {};
    if (!bundle) throw new Error(`Cannot lazy load integration: ${name}`);
    const existing = sentryOnWindow[name];
    if (typeof existing === "function" && !("_isShim" in existing)) return existing;
    const url = $3fc94f2ac1572f6d$var$getScriptURL(bundle);
    const script = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).document.createElement("script");
    script.src = url;
    script.crossOrigin = "anonymous";
    script.referrerPolicy = "strict-origin";
    if (scriptNonce) script.setAttribute("nonce", scriptNonce);
    const waitForLoad = new Promise((resolve, reject)=>{
        script.addEventListener("load", ()=>resolve());
        script.addEventListener("error", reject);
    });
    const currentScript = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).document.currentScript;
    const parent = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).document.body || (0, $e62dec891f31852b$export$56d8a8a25bd48b81).document.head || currentScript?.parentElement;
    if (parent) parent.appendChild(script);
    else throw new Error(`Could not find parent element to insert lazy-loaded ${name} script`);
    try {
        await waitForLoad;
    } catch  {
        throw new Error(`Error when loading integration: ${name}`);
    }
    const integrationFn = sentryOnWindow[name];
    if (typeof integrationFn !== "function") throw new Error(`Could not load integration: ${name}`);
    return integrationFn;
}
function $3fc94f2ac1572f6d$var$getScriptURL(bundle) {
    const client = (0, $b244ff70a28cf637$exports.getClient)();
    const baseURL = client?.getOptions()?.cdnBaseUrl || "https://browser.sentry-cdn.com";
    return new URL(`/${(0, $b244ff70a28cf637$exports.SDK_VERSION)}/${bundle}.min.js`, baseURL).toString();
}


const $367c450e8ba35148$export$21eeae83e17be6ea = (0, $79d5e278c02a445b$export$13a9e5a543258f97)({
    lazyLoadIntegration: $3fc94f2ac1572f6d$export$6da56f3ddf2bd0c1
});



const $3b83570998c5a022$export$4bf8b7bb0f0086df = (0, $79d5e278c02a445b$export$13a9e5a543258f97)({
    getModalIntegration: ()=>(0, $79d5e278c02a445b$export$2ed486683e133d58),
    getScreenshotIntegration: ()=>(0, $79d5e278c02a445b$export$fd00458861e48ab4)
});






function $934e8a4b0ce930b6$export$a6c2d27607295951(stackParser, ex) {
    const frames = $934e8a4b0ce930b6$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $934e8a4b0ce930b6$export$2e9ae379995d99e3(ex),
        value: $934e8a4b0ce930b6$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === void 0 && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $934e8a4b0ce930b6$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $b244ff70a28cf637$exports.getClient)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    const errorFromProp = $934e8a4b0ce930b6$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $b244ff70a28cf637$exports.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $934e8a4b0ce930b6$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $b244ff70a28cf637$exports.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $934e8a4b0ce930b6$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $934e8a4b0ce930b6$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $934e8a4b0ce930b6$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $934e8a4b0ce930b6$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
function $934e8a4b0ce930b6$var$parseStackFrames(stackParser, ex) {
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $934e8a4b0ce930b6$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $934e8a4b0ce930b6$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch  {}
    return [];
}
const $934e8a4b0ce930b6$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $934e8a4b0ce930b6$var$getSkipFirstStackStringLines(ex) {
    if (ex && $934e8a4b0ce930b6$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
function $934e8a4b0ce930b6$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
function $934e8a4b0ce930b6$var$isWebAssemblyException(exception) {
    if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") return exception instanceof WebAssembly.Exception;
    else return false;
}
function $934e8a4b0ce930b6$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    if (!name && $934e8a4b0ce930b6$var$isWebAssemblyException(ex)) {
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
    }
    return name;
}
function $934e8a4b0ce930b6$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($934e8a4b0ce930b6$var$isWebAssemblyException(ex)) {
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return "wasm exception";
    }
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return (0, $b244ff70a28cf637$exports._INTERNAL_enhanceErrorWithSentryInfo)(message.error);
    return (0, $b244ff70a28cf637$exports._INTERNAL_enhanceErrorWithSentryInfo)(ex);
}
function $934e8a4b0ce930b6$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || void 0;
    const event = $934e8a4b0ce930b6$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $b244ff70a28cf637$exports.addExceptionMechanism)(event);
    event.level = "error";
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $b244ff70a28cf637$exports.resolvedSyncPromise)(event);
}
function $934e8a4b0ce930b6$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || void 0;
    const event = $934e8a4b0ce930b6$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $b244ff70a28cf637$exports.resolvedSyncPromise)(event);
}
function $934e8a4b0ce930b6$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $b244ff70a28cf637$exports.isErrorEvent)(exception) && exception.error) {
        const errorEvent = exception;
        return $934e8a4b0ce930b6$var$eventFromError(stackParser, errorEvent.error);
    }
    if ((0, $b244ff70a28cf637$exports.isDOMError)(exception) || (0, $b244ff70a28cf637$exports.isDOMException)(exception)) {
        const domException = exception;
        if ("stack" in exception) {
            event = $934e8a4b0ce930b6$var$eventFromError(stackParser, exception);
            const firstException = event.exception?.values?.[0];
            if (attachStacktrace && syntheticException && firstException && !firstException.stacktrace) {
                const frames = $934e8a4b0ce930b6$var$parseStackFrames(stackParser, syntheticException);
                if (frames.length) {
                    firstException.stacktrace = {
                        frames: frames
                    };
                    (0, $b244ff70a28cf637$exports.addExceptionMechanism)(event, {
                        synthetic: true
                    });
                }
            }
        } else {
            const name = domException.name || ((0, $b244ff70a28cf637$exports.isDOMError)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $934e8a4b0ce930b6$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $b244ff70a28cf637$exports.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $b244ff70a28cf637$exports.isError)(exception)) return $934e8a4b0ce930b6$var$eventFromError(stackParser, exception);
    if ((0, $b244ff70a28cf637$exports.isPlainObject)(exception) || (0, $b244ff70a28cf637$exports.isEvent)(exception)) {
        const objectException = exception;
        event = $934e8a4b0ce930b6$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $b244ff70a28cf637$exports.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    event = $934e8a4b0ce930b6$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $b244ff70a28cf637$exports.addExceptionTypeValue)(event, `${exception}`, void 0);
    (0, $b244ff70a28cf637$exports.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $934e8a4b0ce930b6$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $934e8a4b0ce930b6$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $b244ff70a28cf637$exports.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $b244ff70a28cf637$exports.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $934e8a4b0ce930b6$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $b244ff70a28cf637$exports.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    if ((0, $b244ff70a28cf637$exports.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $b244ff70a28cf637$exports.isEvent)(exception)) {
        const className = $934e8a4b0ce930b6$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $934e8a4b0ce930b6$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch  {}
}
function $934e8a4b0ce930b6$var$getErrorPropertyFromObject(obj) {
    return Object.values(obj).find((0, $b244ff70a28cf637$exports.isError));
}



class $4e1ce061c21a5e69$export$1df9218a526d318d extends (0, $b244ff70a28cf637$exports.Client) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $4e1ce061c21a5e69$export$4e107b20a7f977(options);
        const sdkSource = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $b244ff70a28cf637$exports.getSDKSource)();
        (0, $b244ff70a28cf637$exports.applySdkMetadata)(opts, "browser", [
            "browser"
        ], sdkSource);
        super(opts);
        const { userInfo: userInfo } = this.getDataCollectionOptions();
        if (opts._metadata?.sdk) opts._metadata.sdk.settings = {
            // Only allow IP inferral by Relay if the user opted in via dataCollection
            infer_ip: userInfo ? "auto" : "never",
            // purposefully allowing already passed settings to override the default
            ...opts._metadata.sdk.settings
        };
        const { sendClientReports: sendClientReports } = this._options;
        if ((0, $e62dec891f31852b$export$56d8a8a25bd48b81).document) (0, $e62dec891f31852b$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $e62dec891f31852b$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
                if (sendClientReports) this._flushOutcomes();
                queueMicrotask(()=>{
                    this.flush();
                });
            }
        });
        if (userInfo) this.on("beforeSendSession", (0, $b244ff70a28cf637$exports.addAutoIpAddressToSession));
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $934e8a4b0ce930b6$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $934e8a4b0ce930b6$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
function $4e1ce061c21a5e69$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === "string" ? __SENTRY_RELEASE__ : (0, $e62dec891f31852b$export$56d8a8a25bd48b81).SENTRY_RELEASE?.id,
        // This supports the variable that sentry-webpack-plugin injects
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}






const $133087f5c0803d70$var$WINDOW = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1);
function $133087f5c0803d70$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch  {
        return false;
    }
}
function $133087f5c0803d70$export$1c08bd1a7eb3c472() {
    try {
        new DOMError("");
        return true;
    } catch  {
        return false;
    }
}
function $133087f5c0803d70$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch  {
        return false;
    }
}
function $133087f5c0803d70$export$67fc34576016d6ec() {
    return "history" in $133087f5c0803d70$var$WINDOW && !!$133087f5c0803d70$var$WINDOW.history;
}
const $133087f5c0803d70$export$edf3cb81fd7d2a3e = $133087f5c0803d70$var$_isFetchSupported;
function $133087f5c0803d70$var$_isFetchSupported() {
    if (!("fetch" in $133087f5c0803d70$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("data:,");
        new Response();
        return true;
    } catch  {
        return false;
    }
}
function $133087f5c0803d70$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $133087f5c0803d70$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$133087f5c0803d70$var$_isFetchSupported()) return false;
    if ($133087f5c0803d70$export$d5f608b368e73f38($133087f5c0803d70$var$WINDOW.fetch)) return true;
    let result = false;
    const doc = $133087f5c0803d70$var$WINDOW.document;
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) result = $133087f5c0803d70$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $133087f5c0803d70$export$531055a6c684a70a() {
    return "ReportingObserver" in $133087f5c0803d70$var$WINDOW;
}
function $133087f5c0803d70$export$2d308b428295192f() {
    if (!$133087f5c0803d70$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch  {
        return false;
    }
}


const $c54a9ced88c7488b$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



const $de4f8abdf21afb03$export$56d8a8a25bd48b81 = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1);


const $295fbc3e705f470c$var$cachedImplementations = {};
function $295fbc3e705f470c$export$e464f4a514ac28a8(name) {
    const cached = $295fbc3e705f470c$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81)[name];
    if ((0, $133087f5c0803d70$export$d5f608b368e73f38)(impl)) return $295fbc3e705f470c$var$cachedImplementations[name] = impl.bind((0, $de4f8abdf21afb03$export$56d8a8a25bd48b81));
    const document = (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).document;
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $c54a9ced88c7488b$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    if (!impl) return impl;
    return $295fbc3e705f470c$var$cachedImplementations[name] = impl.bind((0, $de4f8abdf21afb03$export$56d8a8a25bd48b81));
}
function $295fbc3e705f470c$export$8aa36702e8c8978(name) {
    $295fbc3e705f470c$var$cachedImplementations[name] = void 0;
}
function $295fbc3e705f470c$export$e7aa7bc5c1b3cfb3(...rest) {
    return $295fbc3e705f470c$export$e464f4a514ac28a8("fetch")(...rest);
}
function $295fbc3e705f470c$export$831dc9f2ab0a617b(...rest) {
    return $295fbc3e705f470c$export$e464f4a514ac28a8("setTimeout")(...rest);
}


const $366021d20f9daad3$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
function $366021d20f9daad3$export$b2311068c46d7cc8(options, nativeFetch = (0, $295fbc3e705f470c$export$e464f4a514ac28a8)("fetch")) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    async function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "strict-origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 6e4 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            const response = await nativeFetch(options.url, requestOptions);
            return {
                statusCode: response.status,
                headers: {
                    "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                    "retry-after": response.headers.get("Retry-After")
                }
            };
        } catch (e) {
            (0, $295fbc3e705f470c$export$8aa36702e8c8978)("fetch");
            throw e;
        } finally{
            pendingBodySize -= requestSize;
            pendingCount--;
        }
    }
    return (0, $b244ff70a28cf637$exports.createTransport)(options, makeRequest, (0, $b244ff70a28cf637$exports.makePromiseBuffer)(options.bufferSize || $366021d20f9daad3$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE));
}



const $6e9d48dbcf18d05a$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;


function $61e522e7948b3efb$var$startProfiler() {
    const client = (0, $b244ff70a28cf637$exports.getClient)();
    if (!client) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn("No Sentry client available, profiling is not started");
        return;
    }
    const integration = client.getIntegrationByName("BrowserProfiling");
    if (!integration) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn("BrowserProfiling integration is not available");
        return;
    }
    client.emit("startUIProfiler");
}
function $61e522e7948b3efb$var$stopProfiler() {
    const client = (0, $b244ff70a28cf637$exports.getClient)();
    if (!client) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn("No Sentry client available, profiling is not started");
        return;
    }
    const integration = client.getIntegrationByName("BrowserProfiling");
    if (!integration) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn("ProfilingIntegration is not available");
        return;
    }
    client.emit("stopUIProfiler");
}
const $61e522e7948b3efb$export$c7cf24e2253024f3 = {
    startProfiler: $61e522e7948b3efb$var$startProfiler,
    stopProfiler: $61e522e7948b3efb$var$stopProfiler
};



const $5c2a6884ada474e9$var$OPERA10_PRIORITY = 10;
const $5c2a6884ada474e9$var$OPERA11_PRIORITY = 20;
const $5c2a6884ada474e9$var$CHROME_PRIORITY = 30;
const $5c2a6884ada474e9$var$WINJS_PRIORITY = 40;
const $5c2a6884ada474e9$var$GECKO_PRIORITY = 50;
function $5c2a6884ada474e9$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $b244ff70a28cf637$exports.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== void 0) frame.lineno = lineno;
    if (colno !== void 0) frame.colno = colno;
    return frame;
}
const $5c2a6884ada474e9$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
const $5c2a6884ada474e9$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $5c2a6884ada474e9$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const $5c2a6884ada474e9$var$chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
const $5c2a6884ada474e9$var$chromeStackParserFn = (line)=>{
    const dataUriMatch = line.match($5c2a6884ada474e9$var$chromeDataUriRegex);
    if (dataUriMatch) return {
        filename: `<data:${dataUriMatch[2]}>`,
        function: dataUriMatch[1]
    };
    const noFnParts = $5c2a6884ada474e9$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line2, col] = noFnParts;
        return $5c2a6884ada474e9$var$createFrame(filename, (0, $b244ff70a28cf637$exports.UNKNOWN_FUNCTION), +line2, +col);
    }
    const parts = $5c2a6884ada474e9$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2]?.indexOf("eval") === 0;
        if (isEval) {
            const subMatch = $5c2a6884ada474e9$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                parts[2] = subMatch[1];
                parts[3] = subMatch[2];
                parts[4] = subMatch[3];
            }
        }
        const [func, filename] = $5c2a6884ada474e9$var$extractSafariExtensionDetails(parts[1] || (0, $b244ff70a28cf637$exports.UNKNOWN_FUNCTION), parts[2]);
        return $5c2a6884ada474e9$var$createFrame(filename, func, parts[3] ? +parts[3] : void 0, parts[4] ? +parts[4] : void 0);
    }
    return;
};
const $5c2a6884ada474e9$export$263a749fff749872 = [
    $5c2a6884ada474e9$var$CHROME_PRIORITY,
    $5c2a6884ada474e9$var$chromeStackParserFn
];
const $5c2a6884ada474e9$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $5c2a6884ada474e9$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $5c2a6884ada474e9$var$gecko = (line)=>{
    const parts = $5c2a6884ada474e9$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $5c2a6884ada474e9$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = "";
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $b244ff70a28cf637$exports.UNKNOWN_FUNCTION);
        [func, filename] = $5c2a6884ada474e9$var$extractSafariExtensionDetails(func, filename);
        return $5c2a6884ada474e9$var$createFrame(filename, func, parts[4] ? +parts[4] : void 0, parts[5] ? +parts[5] : void 0);
    }
    return;
};
const $5c2a6884ada474e9$export$cdba47a5dd2804d = [
    $5c2a6884ada474e9$var$GECKO_PRIORITY,
    $5c2a6884ada474e9$var$gecko
];
const $5c2a6884ada474e9$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $5c2a6884ada474e9$var$winjs = (line)=>{
    const parts = $5c2a6884ada474e9$var$winjsRegex.exec(line);
    return parts ? $5c2a6884ada474e9$var$createFrame(parts[2], parts[1] || (0, $b244ff70a28cf637$exports.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : void 0) : void 0;
};
const $5c2a6884ada474e9$export$179460296da408e8 = [
    $5c2a6884ada474e9$var$WINJS_PRIORITY,
    $5c2a6884ada474e9$var$winjs
];
const $5c2a6884ada474e9$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $5c2a6884ada474e9$var$opera10 = (line)=>{
    const parts = $5c2a6884ada474e9$var$opera10Regex.exec(line);
    return parts ? $5c2a6884ada474e9$var$createFrame(parts[2], parts[3] || (0, $b244ff70a28cf637$exports.UNKNOWN_FUNCTION), +parts[1]) : void 0;
};
const $5c2a6884ada474e9$export$f892b52c880ffc7a = [
    $5c2a6884ada474e9$var$OPERA10_PRIORITY,
    $5c2a6884ada474e9$var$opera10
];
const $5c2a6884ada474e9$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $5c2a6884ada474e9$var$opera11 = (line)=>{
    const parts = $5c2a6884ada474e9$var$opera11Regex.exec(line);
    return parts ? $5c2a6884ada474e9$var$createFrame(parts[5], parts[3] || parts[4] || (0, $b244ff70a28cf637$exports.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : void 0;
};
const $5c2a6884ada474e9$export$af11af13f09fb0dc = [
    $5c2a6884ada474e9$var$OPERA11_PRIORITY,
    $5c2a6884ada474e9$var$opera11
];
const $5c2a6884ada474e9$export$7197c0fe6554c079 = [
    $5c2a6884ada474e9$export$263a749fff749872,
    $5c2a6884ada474e9$export$cdba47a5dd2804d
];
const $5c2a6884ada474e9$export$2b2b997d81bf3907 = (0, $b244ff70a28cf637$exports.createStackParser)(...$5c2a6884ada474e9$export$7197c0fe6554c079);
const $5c2a6884ada474e9$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $b244ff70a28cf637$exports.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};




function $b80b1f8b91224d00$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: /* @__PURE__ */ new Date().toISOString(),
        ...metadata?.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $b244ff70a28cf637$exports.dsnToString)(dsn)
        }
    };
    const item = $b80b1f8b91224d00$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $b244ff70a28cf637$exports.createEnvelope)(headers, [
        item
    ]);
}
function $b80b1f8b91224d00$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}








const $7b0ad3366f177c67$var$handlers = {};
const $7b0ad3366f177c67$var$instrumented = {};
function $7b0ad3366f177c67$export$a4e09611e30da72e(type, handler) {
    $7b0ad3366f177c67$var$handlers[type] = $7b0ad3366f177c67$var$handlers[type] || [];
    $7b0ad3366f177c67$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $7b0ad3366f177c67$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
function $7b0ad3366f177c67$export$b17eab759a1cb5fe() {
    Object.keys($7b0ad3366f177c67$var$handlers).forEach((key)=>{
        $7b0ad3366f177c67$var$handlers[key] = void 0;
    });
}
function $7b0ad3366f177c67$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$7b0ad3366f177c67$var$instrumented[type]) {
        $7b0ad3366f177c67$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error(`Error while instrumenting ${type}`, e);
        }
    }
}
function $7b0ad3366f177c67$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $7b0ad3366f177c67$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${(0, $9ed2cf4edd0b2db9$export$aad197c7121a6651)(handler)}
Error:`, e);
    }
}



const $65432d81f3633cf8$var$DEBOUNCE_DURATION = 1e3;
let $65432d81f3633cf8$var$debounceTimerID;
let $65432d81f3633cf8$var$lastCapturedEventType;
let $65432d81f3633cf8$var$lastCapturedEventTargetId;
function $65432d81f3633cf8$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $7b0ad3366f177c67$export$a4e09611e30da72e)(type, handler);
    (0, $7b0ad3366f177c67$export$e18d6c5462c01368)(type, $65432d81f3633cf8$export$3014bbf0af0e1d4a);
}
function $65432d81f3633cf8$export$3014bbf0af0e1d4a() {
    if (!(0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).document) return;
    const triggerDOMHandler = (0, $7b0ad3366f177c67$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $65432d81f3633cf8$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).document.addEventListener("keypress", globalDOMEventHandler, false);
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        const globalObject = (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81);
        const proto = globalObject[target]?.prototype;
        if (!proto?.hasOwnProperty?.("addEventListener")) return;
        (0, $269eeb69635ed414$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $65432d81f3633cf8$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch  {}
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $269eeb69635ed414$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = void 0;
                            delete handlers[type];
                        }
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch  {}
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
function $65432d81f3633cf8$var$isSimilarToLastCapturedEvent(event) {
    if (event.type !== $65432d81f3633cf8$var$lastCapturedEventType) return false;
    try {
        if (!event.target || event.target._sentryId !== $65432d81f3633cf8$var$lastCapturedEventTargetId) return false;
    } catch  {}
    return true;
}
function $65432d81f3633cf8$var$shouldSkipDOMEvent(eventType, target) {
    if (eventType !== "keypress") return false;
    if (!target?.tagName) return true;
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
function $65432d81f3633cf8$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        if (!event || event["_sentryCaptured"]) return;
        const target = $65432d81f3633cf8$var$getEventTarget(event);
        if ($65432d81f3633cf8$var$shouldSkipDOMEvent(event.type, target)) return;
        (0, $269eeb69635ed414$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) (0, $269eeb69635ed414$export$e73679ffaf56810e)(target, "_sentryId", (0, $cc262db35458e4b3$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        if (!$65432d81f3633cf8$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $65432d81f3633cf8$var$lastCapturedEventType = event.type;
            $65432d81f3633cf8$var$lastCapturedEventTargetId = target ? target._sentryId : void 0;
        }
        clearTimeout($65432d81f3633cf8$var$debounceTimerID);
        $65432d81f3633cf8$var$debounceTimerID = (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).setTimeout(()=>{
            $65432d81f3633cf8$var$lastCapturedEventTargetId = void 0;
            $65432d81f3633cf8$var$lastCapturedEventType = void 0;
        }, $65432d81f3633cf8$var$DEBOUNCE_DURATION);
    };
}
function $65432d81f3633cf8$var$getEventTarget(event) {
    try {
        return event.target;
    } catch  {
        return null;
    }
}



let $44e96bc00aeade7b$var$lastHref;
function $44e96bc00aeade7b$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $7b0ad3366f177c67$export$a4e09611e30da72e)(type, handler);
    (0, $7b0ad3366f177c67$export$e18d6c5462c01368)(type, $44e96bc00aeade7b$export$d9b613a6254a184e);
}
function $44e96bc00aeade7b$export$d9b613a6254a184e() {
    (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).addEventListener("popstate", ()=>{
        const to = (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).location.href;
        const from = $44e96bc00aeade7b$var$lastHref;
        $44e96bc00aeade7b$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $7b0ad3366f177c67$export$b18c893e424d3127)("history", handlerData);
    });
    if (!(0, $133087f5c0803d70$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : void 0;
            if (url) {
                const from = $44e96bc00aeade7b$var$lastHref;
                const to = $44e96bc00aeade7b$var$getAbsoluteUrl(String(url));
                $44e96bc00aeade7b$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $7b0ad3366f177c67$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $269eeb69635ed414$export$9563e054e6f787fb)((0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).history, "pushState", historyReplacementFunction);
    (0, $269eeb69635ed414$export$9563e054e6f787fb)((0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).history, "replaceState", historyReplacementFunction);
}
function $44e96bc00aeade7b$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).location.origin);
        return url.toString();
    } catch  {
        return urlOrPath;
    }
}



const $447740b7cde7d984$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
function $447740b7cde7d984$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $7b0ad3366f177c67$export$a4e09611e30da72e)(type, handler);
    (0, $7b0ad3366f177c67$export$e18d6c5462c01368)(type, $447740b7cde7d984$export$c67d533bf77cbf54);
}
function $447740b7cde7d984$export$c67d533bf77cbf54() {
    if (!(0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            let virtualError = new Error();
            const startTimestamp = (0, $bc81602376c48fa6$export$ee52dced521e3e18)() * 1e3;
            const method = (0, $13cf2ed412f405fa$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : void 0;
            const url = $447740b7cde7d984$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$447740b7cde7d984$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            if (method === "POST" && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                const xhrInfo = xhrOpenThisArg[$447740b7cde7d984$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch  {}
                    const handlerData = {
                        endTimestamp: (0, $bc81602376c48fa6$export$ee52dced521e3e18)() * 1e3,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $7b0ad3366f177c67$export$b18c893e424d3127)("xhr", handlerData);
                    virtualError = void 0;
                    xhrOpenThisArg.removeEventListener("readystatechange", onreadystatechangeHandler);
                }
            };
            if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$447740b7cde7d984$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $13cf2ed412f405fa$export$844ec244b1367d54)(header) && (0, $13cf2ed412f405fa$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$447740b7cde7d984$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== void 0) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $bc81602376c48fa6$export$ee52dced521e3e18)() * 1e3,
                xhr: sendThisArg
            };
            (0, $7b0ad3366f177c67$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $447740b7cde7d984$var$parseXhrUrlArg(url) {
    if ((0, $13cf2ed412f405fa$export$844ec244b1367d54)(url)) return url;
    try {
        return url.toString();
    } catch  {}
    return void 0;
}


const $25d1cfcd58d5af8d$var$DEFAULT_MAX_STRING_LENGTH = 80;
const $25d1cfcd58d5af8d$var$accessors = {};
try {
    if (typeof Node !== "undefined") $25d1cfcd58d5af8d$var$accessors.parentNode = Object.getOwnPropertyDescriptor(Node.prototype, "parentNode").get;
    if (typeof Element !== "undefined") {
        $25d1cfcd58d5af8d$var$accessors.tagName = Object.getOwnPropertyDescriptor(Element.prototype, "tagName").get;
        $25d1cfcd58d5af8d$var$accessors.id = Object.getOwnPropertyDescriptor(Element.prototype, "id").get;
        $25d1cfcd58d5af8d$var$accessors.className = Object.getOwnPropertyDescriptor(Element.prototype, "className").get;
        $25d1cfcd58d5af8d$var$accessors.getAttribute = Element.prototype.getAttribute;
    }
    if (typeof HTMLElement !== "undefined") $25d1cfcd58d5af8d$var$accessors.dataset = Object.getOwnPropertyDescriptor(HTMLElement.prototype, "dataset").get;
} catch  {}
function $25d1cfcd58d5af8d$var$_safeRead(el, prop, arg) {
    const fn = $25d1cfcd58d5af8d$var$accessors[prop];
    if (fn) try {
        return fn.call(el, arg);
    } catch  {}
    const val = el[prop];
    return typeof val === "function" ? val.call(el, arg) : val;
}
function $25d1cfcd58d5af8d$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $25d1cfcd58d5af8d$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $25d1cfcd58d5af8d$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = $25d1cfcd58d5af8d$var$_safeRead(currentElem, "parentNode");
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $25d1cfcd58d5af8d$var$_htmlElementAsString(el, keyAttrs) {
    const out = [];
    const tagName = $25d1cfcd58d5af8d$var$_safeRead(el, "tagName");
    if (!tagName) return "";
    if (typeof HTMLElement !== "undefined") {
        if (el instanceof HTMLElement) {
            const dataset = $25d1cfcd58d5af8d$var$_safeRead(el, "dataset");
            if (dataset) {
                if (dataset["sentryComponent"]) return dataset["sentryComponent"];
                if (dataset["sentryElement"]) return dataset["sentryElement"];
            }
        }
    }
    out.push(tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>$25d1cfcd58d5af8d$var$_safeRead(el, "getAttribute", keyAttr)).map((keyAttr)=>[
            keyAttr,
            $25d1cfcd58d5af8d$var$_safeRead(el, "getAttribute", keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        const id = $25d1cfcd58d5af8d$var$_safeRead(el, "id");
        if (id) out.push(`#${id}`);
        const className = $25d1cfcd58d5af8d$var$_safeRead(el, "className");
        if (className && (0, $13cf2ed412f405fa$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = $25d1cfcd58d5af8d$var$_safeRead(el, "getAttribute", k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}




const $0ad9abad7f8d2d66$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $0ad9abad7f8d2d66$var$INTEGRATION_NAME = "Breadcrumbs";
const $0ad9abad7f8d2d66$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $0ad9abad7f8d2d66$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $b244ff70a28cf637$exports.addConsoleInstrumentationHandler)($0ad9abad7f8d2d66$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $65432d81f3633cf8$export$5aeffd3db2cf9df7)($0ad9abad7f8d2d66$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $447740b7cde7d984$export$26ace48dd54c9aea)($0ad9abad7f8d2d66$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $b244ff70a28cf637$exports.addFetchInstrumentationHandler)($0ad9abad7f8d2d66$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $44e96bc00aeade7b$export$3f18c56c58114e75)($0ad9abad7f8d2d66$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $0ad9abad7f8d2d66$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $0ad9abad7f8d2d66$export$c079d904b326663a = (0, $b244ff70a28cf637$exports.defineIntegration)($0ad9abad7f8d2d66$var$_breadcrumbsIntegration);
function $0ad9abad7f8d2d66$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $b244ff70a28cf637$exports.getClient)() !== client) return;
        (0, $b244ff70a28cf637$exports.addBreadcrumb)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $b244ff70a28cf637$exports.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
function $0ad9abad7f8d2d66$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $b244ff70a28cf637$exports.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : void 0;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : void 0;
        if (maxStringLength && maxStringLength > $0ad9abad7f8d2d66$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn(`\`dom.maxStringLength\` cannot exceed ${$0ad9abad7f8d2d66$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$0ad9abad7f8d2d66$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $0ad9abad7f8d2d66$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        try {
            const event = handlerData.event;
            const element = $0ad9abad7f8d2d66$var$_isEvent(event) ? event.target : event;
            target = (0, $25d1cfcd58d5af8d$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $b244ff70a28cf637$exports.getComponentName)(element);
        } catch  {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $b244ff70a28cf637$exports.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
function $0ad9abad7f8d2d66$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $b244ff70a28cf637$exports.getClient)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $b244ff70a28cf637$exports.severityLevelFromString)(handlerData.level),
            message: (0, $b244ff70a28cf637$exports.safeJoin)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $b244ff70a28cf637$exports.safeJoin)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else return;
        }
        (0, $b244ff70a28cf637$exports.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
function $0ad9abad7f8d2d66$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $b244ff70a28cf637$exports.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $447740b7cde7d984$export$55b6bb1e45c6cf59];
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: "xhr",
            data: data,
            type: "http",
            level: (0, $b244ff70a28cf637$exports.getBreadcrumbLogLevelFromHttpStatusCode)(status_code)
        };
        client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
        (0, $b244ff70a28cf637$exports.addBreadcrumb)(breadcrumb, hint);
    };
}
function $0ad9abad7f8d2d66$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $b244ff70a28cf637$exports.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") return;
        if (handlerData.error) {
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: handlerData.fetchData,
                level: "error",
                type: "http"
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $b244ff70a28cf637$exports.addBreadcrumb)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: data,
                type: "http",
                level: (0, $b244ff70a28cf637$exports.getBreadcrumbLogLevelFromHttpStatusCode)(data.status_code)
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $b244ff70a28cf637$exports.addBreadcrumb)(breadcrumb, hint);
        }
    };
}
function $0ad9abad7f8d2d66$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $b244ff70a28cf637$exports.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $b244ff70a28cf637$exports.parseUrl)((0, $e62dec891f31852b$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $b244ff70a28cf637$exports.parseUrl)(from) : void 0;
        const parsedTo = (0, $b244ff70a28cf637$exports.parseUrl)(to);
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $b244ff70a28cf637$exports.addBreadcrumb)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $0ad9abad7f8d2d66$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $fa3dc958cc9f40d6$var$DEFAULT_EVENT_TARGET = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,BroadcastChannel,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
const $fa3dc958cc9f40d6$var$INTEGRATION_NAME = "BrowserApiErrors";
const $fa3dc958cc9f40d6$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $fa3dc958cc9f40d6$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $b244ff70a28cf637$exports.fill)((0, $e62dec891f31852b$export$56d8a8a25bd48b81), "setTimeout", $fa3dc958cc9f40d6$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $b244ff70a28cf637$exports.fill)((0, $e62dec891f31852b$export$56d8a8a25bd48b81), "setInterval", $fa3dc958cc9f40d6$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $b244ff70a28cf637$exports.fill)((0, $e62dec891f31852b$export$56d8a8a25bd48b81), "requestAnimationFrame", $fa3dc958cc9f40d6$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $e62dec891f31852b$export$56d8a8a25bd48b81)) (0, $b244ff70a28cf637$exports.fill)(XMLHttpRequest.prototype, "send", $fa3dc958cc9f40d6$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $fa3dc958cc9f40d6$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$fa3dc958cc9f40d6$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
const $fa3dc958cc9f40d6$export$59bfe9f1c76150e = (0, $b244ff70a28cf637$exports.defineIntegration)($fa3dc958cc9f40d6$var$_browserApiErrorsIntegration);
function $fa3dc958cc9f40d6$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $e62dec891f31852b$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                handled: false,
                type: `auto.browser.browserapierrors.${(0, $b244ff70a28cf637$exports.getFunctionName)(original)}`
            }
        });
        return original.apply(this, args);
    };
}
function $fa3dc958cc9f40d6$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $e62dec891f31852b$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        handler: (0, $b244ff70a28cf637$exports.getFunctionName)(original)
                    },
                    handled: false,
                    type: "auto.browser.browserapierrors.requestAnimationFrame"
                }
            })
        ]);
    };
}
function $fa3dc958cc9f40d6$var$_wrapXHR(originalSend) {
    return function(...args) {
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") (0, $b244ff70a28cf637$exports.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            handler: (0, $b244ff70a28cf637$exports.getFunctionName)(original)
                        },
                        handled: false,
                        type: `auto.browser.browserapierrors.xhr.${prop}`
                    }
                };
                const originalFunction = (0, $b244ff70a28cf637$exports.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $b244ff70a28cf637$exports.getFunctionName)(originalFunction);
                return (0, $e62dec891f31852b$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $fa3dc958cc9f40d6$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $e62dec891f31852b$export$56d8a8a25bd48b81);
    const proto = globalObject[target]?.prototype;
    if (!proto?.hasOwnProperty?.("addEventListener")) return;
    (0, $b244ff70a28cf637$exports.fill)(proto, "addEventListener", function(original) {
        return function(eventName, fn, options) {
            try {
                if ($fa3dc958cc9f40d6$var$isEventListenerObject(fn)) fn.handleEvent = (0, $e62dec891f31852b$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            handler: (0, $b244ff70a28cf637$exports.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.handleEvent"
                    }
                });
            } catch  {}
            if (integrationOptions.unregisterOriginalCallbacks) $fa3dc958cc9f40d6$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $e62dec891f31852b$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            handler: (0, $b244ff70a28cf637$exports.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.addEventListener"
                    }
                }),
                options
            ]);
        };
    });
    (0, $b244ff70a28cf637$exports.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            try {
                if (Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__")) {
                    const originalEventHandler = fn.__sentry_wrapped__;
                    if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                }
            } catch  {}
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $fa3dc958cc9f40d6$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === "function";
}
function $fa3dc958cc9f40d6$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === "object" && "removeEventListener" in target && typeof target.removeEventListener === "function") target.removeEventListener(eventName, fn);
}





function $cc264900893ba744$export$26d3d892edc56833(type, listener, options) {
    if ((0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).document) (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).addEventListener(type, listener, options);
}
function $cc264900893ba744$export$324d7b4b46528191(type, listener, options) {
    if ((0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).document) (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).removeEventListener(type, listener, options);
}


const $b94dc5030064c817$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};


const $da71ce648565add7$export$d3314d5863fc1fef = (cb)=>{
    const rIC = (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).requestIdleCallback || (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).setTimeout;
    if ((0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).document?.visibilityState === "hidden") cb();
    else {
        cb = (0, $b94dc5030064c817$export$b841d51e31c12bab)(cb);
        (0, $cc264900893ba744$export$26d3d892edc56833)("visibilitychange", cb, {
            once: true,
            capture: true
        });
        (0, $cc264900893ba744$export$26d3d892edc56833)("pagehide", cb, {
            once: true,
            capture: true
        });
        rIC(()=>{
            cb();
            (0, $cc264900893ba744$export$324d7b4b46528191)("visibilitychange", cb, {
                capture: true
            });
            (0, $cc264900893ba744$export$324d7b4b46528191)("pagehide", cb, {
                capture: true
            });
        });
    }
};




const $9bfd264dc60b3ee5$export$1baa7880e357371c = (0, $b244ff70a28cf637$exports.defineIntegration)((options = {})=>{
    const lifecycle = options.lifecycle ?? "route";
    return {
        name: "BrowserSession",
        setupOnce () {
            if (typeof (0, $e62dec891f31852b$export$56d8a8a25bd48b81).document === "undefined") {
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
                return;
            }
            (0, $b244ff70a28cf637$exports.startSession)({
                ignoreDuration: true
            });
            let initialSessionSent = false;
            (0, $da71ce648565add7$export$d3314d5863fc1fef)(()=>{
                if (!initialSessionSent) {
                    (0, $b244ff70a28cf637$exports.captureSession)();
                    initialSessionSent = true;
                }
            });
            const isolationScope = (0, $b244ff70a28cf637$exports.getIsolationScope)();
            let previousUser = isolationScope.getUser();
            isolationScope.addScopeListener((scope)=>{
                const maybeNewUser = scope.getUser();
                if (previousUser?.id !== maybeNewUser?.id || previousUser?.ip_address !== maybeNewUser?.ip_address) {
                    previousUser = maybeNewUser;
                    if (initialSessionSent) (0, $b244ff70a28cf637$exports.captureSession)();
                }
            });
            if (lifecycle === "route") (0, $44e96bc00aeade7b$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                if (from !== to) {
                    (0, $b244ff70a28cf637$exports.startSession)({
                        ignoreDuration: true
                    });
                    (0, $b244ff70a28cf637$exports.captureSession)();
                    initialSessionSent = true;
                }
            });
        }
    };
});




const $5784fbfdd799cccf$var$INTEGRATION_NAME = "CultureContext";
const $5784fbfdd799cccf$var$_cultureContextIntegration = ()=>{
    return {
        name: $5784fbfdd799cccf$var$INTEGRATION_NAME,
        preprocessEvent (event) {
            const culture = $5784fbfdd799cccf$var$getCultureContext();
            if (culture) event.contexts = {
                ...event.contexts,
                culture: {
                    ...culture,
                    ...event.contexts?.culture
                }
            };
        },
        processSegmentSpan (span) {
            const culture = $5784fbfdd799cccf$var$getCultureContext();
            if (culture) (0, $b244ff70a28cf637$exports.safeSetSpanJSONAttributes)(span, {
                "culture.locale": culture.locale,
                "culture.timezone": culture.timezone,
                "culture.calendar": culture.calendar
            });
        }
    };
};
const $5784fbfdd799cccf$export$ec5976aacdc85985 = (0, $b244ff70a28cf637$exports.defineIntegration)($5784fbfdd799cccf$var$_cultureContextIntegration);
function $5784fbfdd799cccf$var$getCultureContext() {
    try {
        const intl = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).Intl;
        if (!intl) return void 0;
        const options = intl.DateTimeFormat().resolvedOptions();
        return {
            locale: options.locale,
            timezone: options.timeZone,
            calendar: options.calendar
        };
    } catch  {
        return void 0;
    }
}






const $f1959cdcacc276d1$var$INTEGRATION_NAME = "GlobalHandlers";
const $f1959cdcacc276d1$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $f1959cdcacc276d1$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $f1959cdcacc276d1$var$_installGlobalOnErrorHandler(client);
                $f1959cdcacc276d1$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $f1959cdcacc276d1$var$_installGlobalOnUnhandledRejectionHandler(client);
                $f1959cdcacc276d1$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $f1959cdcacc276d1$export$66acc70e8cf2b71a = (0, $b244ff70a28cf637$exports.defineIntegration)($f1959cdcacc276d1$var$_globalHandlersIntegration);
function $f1959cdcacc276d1$var$_installGlobalOnErrorHandler(client) {
    (0, $b244ff70a28cf637$exports.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $f1959cdcacc276d1$var$getOptions();
        if ((0, $b244ff70a28cf637$exports.getClient)() !== client || (0, $e62dec891f31852b$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $f1959cdcacc276d1$var$_enhanceEventWithInitialFrame((0, $934e8a4b0ce930b6$export$9dd56ed1ef0c3420)(stackParser, error || msg, void 0, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $b244ff70a28cf637$exports.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onerror"
            }
        });
    });
}
function $f1959cdcacc276d1$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $b244ff70a28cf637$exports.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $f1959cdcacc276d1$var$getOptions();
        if ((0, $b244ff70a28cf637$exports.getClient)() !== client || (0, $e62dec891f31852b$export$b79738ab10c590b2)()) return;
        const error = $f1959cdcacc276d1$export$b2cc40fa8241780(e);
        const event = (0, $b244ff70a28cf637$exports.isPrimitive)(error) ? $f1959cdcacc276d1$export$1353b5b36844a9ed(error) : (0, $934e8a4b0ce930b6$export$9dd56ed1ef0c3420)(stackParser, error, void 0, attachStacktrace, true);
        event.level = "error";
        (0, $b244ff70a28cf637$exports.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onunhandledrejection"
            }
        });
    });
}
function $f1959cdcacc276d1$export$b2cc40fa8241780(error) {
    if ((0, $b244ff70a28cf637$exports.isPrimitive)(error)) return error;
    try {
        if ("reason" in error) return error.reason;
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch  {}
    return error;
}
function $f1959cdcacc276d1$export$1353b5b36844a9ed(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $f1959cdcacc276d1$var$_enhanceEventWithInitialFrame(event, url, lineno, colno) {
    const e = event.exception = event.exception || {};
    const ev = e.values = e.values || [];
    const ev0 = ev[0] = ev[0] || {};
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    const ev0sf = ev0s.frames = ev0s.frames || [];
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        lineno: lineno,
        filename: $f1959cdcacc276d1$var$getFilenameFromUrl(url) ?? (0, $b244ff70a28cf637$exports.getLocationHref)(),
        function: (0, $b244ff70a28cf637$exports.UNKNOWN_FUNCTION),
        in_app: true
    });
    return event;
}
function $f1959cdcacc276d1$var$globalHandlerLog(type) {
    (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log(`Global Handler attached: ${type}`);
}
function $f1959cdcacc276d1$var$getOptions() {
    const client = (0, $b244ff70a28cf637$exports.getClient)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
function $f1959cdcacc276d1$var$getFilenameFromUrl(url) {
    if (!(0, $b244ff70a28cf637$exports.isString)(url) || url.length === 0) return void 0;
    if (url.startsWith("data:")) return `<${(0, $b244ff70a28cf637$exports.stripDataUrlContent)(url, false)}>`;
    return url;
}





var $3tmPs = parcelRequire("3tmPs");
const $2fcda6dfa3c250e9$export$1378794447170364 = (0, $b244ff70a28cf637$exports.defineIntegration)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event) {
            if (!(0, $e62dec891f31852b$export$56d8a8a25bd48b81).navigator && !(0, $e62dec891f31852b$export$56d8a8a25bd48b81).location && !(0, $e62dec891f31852b$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $e62dec891f31852b$export$a3c4a8453e8936f0)();
            const headers = {
                ...reqData.headers,
                ...event.request?.headers
            };
            event.request = {
                ...reqData,
                ...event.request,
                headers: headers
            };
        },
        processSpan (span) {
            if (!(0, $e62dec891f31852b$export$56d8a8a25bd48b81).navigator && !(0, $e62dec891f31852b$export$56d8a8a25bd48b81).location && !(0, $e62dec891f31852b$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $e62dec891f31852b$export$a3c4a8453e8936f0)();
            (0, $b244ff70a28cf637$exports.safeSetSpanJSONAttributes)(span, {
                // This attribute is used by the "Filter out events from legacy browsers and crawlers" features on the Sentry backend.
                // Therefore, it's set on every span.
                [(0, $3tmPs.USER_AGENT_ORIGINAL)]: reqData.headers["User-Agent"],
                // These attributes, we only need on the segment span (analogous to the `request` context for events)
                ...span.is_segment && {
                    // Coerce empty string to undefined so the helper's nullish check drops it,
                    // rather than writing an empty `url.full` attribute onto the span.
                    [(0, $3tmPs.URL_FULL)]: span.attributes?.[0, $3tmPs.SENTRY_OP] !== "http.client" ? reqData.url : void 0,
                    [`${0, $3tmPs.HTTP_REQUEST_HEADER_KEY_BASE}.referer`]: reqData.headers["Referer"]
                }
            });
        }
    };
});




const $ce07fe89a71836e2$var$DEFAULT_KEY = "cause";
const $ce07fe89a71836e2$var$DEFAULT_LIMIT = 5;
const $ce07fe89a71836e2$var$INTEGRATION_NAME = "LinkedErrors";
const $ce07fe89a71836e2$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $ce07fe89a71836e2$var$DEFAULT_LIMIT;
    const key = options.key || $ce07fe89a71836e2$var$DEFAULT_KEY;
    return {
        name: $ce07fe89a71836e2$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options2 = client.getOptions();
            (0, $b244ff70a28cf637$exports.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $934e8a4b0ce930b6$export$a6c2d27607295951), options2.stackParser, key, limit, event, hint);
        }
    };
};
const $ce07fe89a71836e2$export$ebabb00eb7f3a395 = (0, $b244ff70a28cf637$exports.defineIntegration)($ce07fe89a71836e2$var$_linkedErrorsIntegration);




function $4922422e38ca0ad4$export$45a5e7f76e0caa8d(wat) {
    if (typeof Element === "undefined") return false;
    try {
        return wat instanceof Element;
    } catch  {
        return false;
    }
}


const $a464f0062cc3e108$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX = /^HTML(\w*)Element$/;
function $a464f0062cc3e108$export$4c88c355e6072df5(value) {
    if (typeof window !== "undefined" && value === window) return "[Window]";
    if (typeof document !== "undefined" && value === document) return "[Document]";
    if ((0, $4922422e38ca0ad4$export$45a5e7f76e0caa8d)(value)) {
        const objName = $a464f0062cc3e108$var$getConstructorName(value);
        if ($a464f0062cc3e108$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX.test(objName)) return `[HTMLElement: ${(0, $25d1cfcd58d5af8d$export$5647df6b7814ac86)(value)}]`;
    }
    return void 0;
}
function $a464f0062cc3e108$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}





function $b8730b3801b0c1f4$export$dc236a86065879fc() {
    if ($b8730b3801b0c1f4$var$_isEmbeddedBrowserExtension()) {
        if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $b244ff70a28cf637$exports.consoleSandbox)(()=>{
            console.error("[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return true;
    }
    return false;
}
function $b8730b3801b0c1f4$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $e62dec891f31852b$export$56d8a8a25bd48b81).window === "undefined") return false;
    const _window = (0, $e62dec891f31852b$export$56d8a8a25bd48b81);
    if (_window.nw) return false;
    const extensionObject = _window["chrome"] || _window["browser"];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $b244ff70a28cf637$exports.getLocationHref)();
    const isDedicatedExtensionPage = (0, $e62dec891f31852b$export$56d8a8a25bd48b81) === (0, $e62dec891f31852b$export$56d8a8a25bd48b81).top && /^(?:chrome-extension|moz-extension|ms-browser-extension|safari-web-extension):\/\//.test(href);
    return !isDedicatedExtensionPage;
}


function $14d7809dba5d50b0$export$5783b2920b1d62b9(_options) {
    return [
        // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line typescript/no-deprecated
        (0, $b244ff70a28cf637$exports.inboundFiltersIntegration)(),
        (0, $b244ff70a28cf637$exports.functionToStringIntegration)(),
        (0, $b244ff70a28cf637$exports.conversationIdIntegration)(),
        (0, $fa3dc958cc9f40d6$export$59bfe9f1c76150e)(),
        (0, $0ad9abad7f8d2d66$export$c079d904b326663a)(),
        (0, $f1959cdcacc276d1$export$66acc70e8cf2b71a)(),
        (0, $ce07fe89a71836e2$export$ebabb00eb7f3a395)(),
        (0, $b244ff70a28cf637$exports.dedupeIntegration)(),
        (0, $2fcda6dfa3c250e9$export$1378794447170364)(),
        (0, $5784fbfdd799cccf$export$ec5976aacdc85985)(),
        (0, $9bfd264dc60b3ee5$export$1baa7880e357371c)()
    ];
}
function $14d7809dba5d50b0$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $b8730b3801b0c1f4$export$dc236a86065879fc)();
    let defaultIntegrations = options.defaultIntegrations == null ? $14d7809dba5d50b0$export$5783b2920b1d62b9() : options.defaultIntegrations;
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $b244ff70a28cf637$exports.stackParserFromStackParserOptions)(options.stackParser || (0, $5c2a6884ada474e9$export$2b2b997d81bf3907)),
        integrations: (0, $b244ff70a28cf637$exports.getIntegrationsToSetup)({
            integrations: options.integrations,
            defaultIntegrations: defaultIntegrations
        }),
        transport: options.transport || (0, $366021d20f9daad3$export$b2311068c46d7cc8)
    };
    (0, $b244ff70a28cf637$exports.setNormalizeStringifier)((0, $a464f0062cc3e108$export$4c88c355e6072df5));
    return (0, $b244ff70a28cf637$exports.initAndBind)((0, $4e1ce061c21a5e69$export$1df9218a526d318d), clientOptions);
}
function $14d7809dba5d50b0$export$a3f323d81eede727() {}
function $14d7809dba5d50b0$export$4e4d8b287d028b6b(callback) {
    callback();
}





function $c145e0c6ce486f3a$export$3a8fd680da42627b(options = {}) {
    const optionalDocument = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).document;
    const injectionPoint = optionalDocument?.head || optionalDocument?.body;
    if (!injectionPoint) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).error("[showReportDialog] Global document not defined");
        return;
    }
    const scope = (0, $b244ff70a28cf637$exports.getCurrentScope)();
    const client = (0, $b244ff70a28cf637$exports.getClient)();
    const dsn = client?.getDsn();
    if (!dsn) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).error("[showReportDialog] DSN not configured");
        return;
    }
    const mergedOptions = {
        ...options,
        user: {
            ...scope.getUser(),
            ...options.user
        },
        eventId: options.eventId || (0, $b244ff70a28cf637$exports.lastEventId)()
    };
    const script = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $b244ff70a28cf637$exports.getReportDialogEndpoint)(dsn, mergedOptions);
    const { onLoad: onLoad, onClose: onClose } = mergedOptions;
    if (onLoad) script.onload = onLoad;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $e62dec891f31852b$export$56d8a8a25bd48b81).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $e62dec891f31852b$export$56d8a8a25bd48b81).addEventListener("message", reportDialogClosedMessageHandler);
    }
    injectionPoint.appendChild(script);
}










const $a0ba0212b29c7bfc$var$WINDOW = (0, $b244ff70a28cf637$exports.GLOBAL_OBJ);
const $a0ba0212b29c7bfc$var$INTEGRATION_NAME = "ReportingObserver";
const $a0ba0212b29c7bfc$var$SETUP_CLIENTS = /* @__PURE__ */ new WeakMap();
const $a0ba0212b29c7bfc$var$_reportingObserverIntegration = (options = {})=>{
    const types = options.types || [
        "crash",
        "deprecation",
        "intervention"
    ];
    function handler(reports) {
        if (!$a0ba0212b29c7bfc$var$SETUP_CLIENTS.has((0, $b244ff70a28cf637$exports.getClient)())) return;
        for (const report of reports)(0, $b244ff70a28cf637$exports.withScope)((scope)=>{
            scope.setExtra("url", report.url);
            const label = `ReportingObserver [${report.type}]`;
            let details = "No details available";
            if (report.body) {
                const plainBody = {};
                for(const prop in report.body)plainBody[prop] = report.body[prop];
                scope.setExtra("body", plainBody);
                if (report.type === "crash") {
                    const body = report.body;
                    details = [
                        body.crashId || "",
                        body.reason || ""
                    ].join(" ").trim() || details;
                } else {
                    const body = report.body;
                    details = body.message || details;
                }
            }
            (0, $b244ff70a28cf637$exports.captureMessage)(`${label}: ${details}`);
        });
    }
    return {
        name: $a0ba0212b29c7bfc$var$INTEGRATION_NAME,
        setupOnce () {
            if (!(0, $b244ff70a28cf637$exports.supportsReportingObserver)()) return;
            const observer = new $a0ba0212b29c7bfc$var$WINDOW.ReportingObserver(handler, {
                buffered: true,
                types: types
            });
            observer.observe();
        },
        setup (client) {
            $a0ba0212b29c7bfc$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
const $a0ba0212b29c7bfc$export$609cccfa9f328cc5 = (0, $b244ff70a28cf637$exports.defineIntegration)($a0ba0212b29c7bfc$var$_reportingObserverIntegration);





const $899ee8298ebc75fb$var$INTEGRATION_NAME = "HttpClient";
const $899ee8298ebc75fb$var$_httpClientIntegration = (options = {})=>{
    const _options = {
        failedRequestStatusCodes: [
            [
                500,
                599
            ]
        ],
        failedRequestTargets: [
            /.*/
        ],
        ...options
    };
    return {
        name: $899ee8298ebc75fb$var$INTEGRATION_NAME,
        setup (client) {
            $899ee8298ebc75fb$var$_wrapFetch(client, _options);
            $899ee8298ebc75fb$var$_wrapXHR(client, _options);
        }
    };
};
const $899ee8298ebc75fb$export$8a3b7aeb379b3907 = (0, $b244ff70a28cf637$exports.defineIntegration)($899ee8298ebc75fb$var$_httpClientIntegration);
function $899ee8298ebc75fb$var$_fetchResponseHandler(options, requestInfo, response, requestInit, error) {
    if ($899ee8298ebc75fb$var$_shouldCaptureResponse(options, response.status, response.url)) {
        const request = $899ee8298ebc75fb$var$_getRequest(requestInfo, requestInit);
        let requestHeaders, responseHeaders, requestCookies, responseCookies;
        const dc = $899ee8298ebc75fb$var$_getDataCollectionSettings();
        if (dc.requestHeaders !== false) requestHeaders = (0, $b244ff70a28cf637$exports._INTERNAL_filterKeyValueData)($899ee8298ebc75fb$var$_extractFetchHeaders(request.headers), dc.requestHeaders);
        if (dc.responseHeaders !== false) responseHeaders = (0, $b244ff70a28cf637$exports._INTERNAL_filterKeyValueData)($899ee8298ebc75fb$var$_extractFetchHeaders(response.headers), dc.responseHeaders);
        if (dc.cookies !== false) {
            const reqCookieStr = request.headers.get("Cookie") || void 0;
            if (reqCookieStr) {
                const filtered = (0, $b244ff70a28cf637$exports._INTERNAL_filterCookies)(reqCookieStr, dc.cookies);
                if (typeof filtered === "object") requestCookies = filtered;
            }
            const resCookieStr = response.headers.get("Set-Cookie") || void 0;
            if (resCookieStr) {
                const filtered = (0, $b244ff70a28cf637$exports._INTERNAL_filterCookies)(resCookieStr, dc.cookies);
                if (typeof filtered === "object") responseCookies = filtered;
            }
        }
        const event = $899ee8298ebc75fb$var$_createEvent({
            url: request.url,
            method: request.method,
            status: response.status,
            requestHeaders: requestHeaders,
            responseHeaders: responseHeaders,
            requestCookies: requestCookies,
            responseCookies: responseCookies,
            error: error,
            type: "fetch"
        });
        (0, $b244ff70a28cf637$exports.captureEvent)(event);
    }
}
function $899ee8298ebc75fb$var$_xhrResponseHandler(options, xhr, method, headers, error) {
    if ($899ee8298ebc75fb$var$_shouldCaptureResponse(options, xhr.status, xhr.responseURL)) {
        let requestHeaders, responseCookies, responseHeaders;
        const dc = $899ee8298ebc75fb$var$_getDataCollectionSettings();
        if (dc.cookies !== false) try {
            const cookieString = xhr.getResponseHeader("Set-Cookie") || xhr.getResponseHeader("set-cookie") || void 0;
            if (cookieString) {
                const filtered = (0, $b244ff70a28cf637$exports._INTERNAL_filterCookies)(cookieString, dc.cookies);
                if (typeof filtered === "object") responseCookies = filtered;
            }
        } catch  {}
        if (dc.responseHeaders !== false) try {
            responseHeaders = (0, $b244ff70a28cf637$exports._INTERNAL_filterKeyValueData)($899ee8298ebc75fb$var$_getXHRResponseHeaders(xhr), dc.responseHeaders);
        } catch  {}
        if (dc.requestHeaders !== false) requestHeaders = (0, $b244ff70a28cf637$exports._INTERNAL_filterKeyValueData)(headers, dc.requestHeaders);
        const event = $899ee8298ebc75fb$var$_createEvent({
            url: xhr.responseURL,
            method: method,
            status: xhr.status,
            requestHeaders: requestHeaders,
            responseHeaders: // Can't access request cookies from XHR
            responseHeaders,
            responseCookies: responseCookies,
            error: error,
            type: "xhr"
        });
        (0, $b244ff70a28cf637$exports.captureEvent)(event);
    }
}
function $899ee8298ebc75fb$var$_getResponseSizeFromHeaders(headers) {
    if (headers) {
        const contentLength = headers["Content-Length"] || headers["content-length"];
        if (contentLength) return parseInt(contentLength, 10);
    }
    return void 0;
}
function $899ee8298ebc75fb$var$_extractFetchHeaders(headers) {
    const result = {};
    headers.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}
function $899ee8298ebc75fb$var$_getXHRResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
function $899ee8298ebc75fb$var$_isInGivenRequestTargets(failedRequestTargets, target) {
    return failedRequestTargets.some((givenRequestTarget)=>{
        if (typeof givenRequestTarget === "string") return target.includes(givenRequestTarget);
        return givenRequestTarget.test(target);
    });
}
function $899ee8298ebc75fb$var$_isInGivenStatusRanges(failedRequestStatusCodes, status) {
    return failedRequestStatusCodes.some((range)=>{
        if (typeof range === "number") return range === status;
        return status >= range[0] && status <= range[1];
    });
}
function $899ee8298ebc75fb$var$_wrapFetch(client, options) {
    if (!(0, $b244ff70a28cf637$exports.supportsNativeFetch)()) return;
    (0, $b244ff70a28cf637$exports.addFetchInstrumentationHandler)((handlerData)=>{
        if ((0, $b244ff70a28cf637$exports.getClient)() !== client) return;
        const { response: response, args: args, error: error, virtualError: virtualError } = handlerData;
        const [requestInfo, requestInit] = args;
        if (!response) return;
        $899ee8298ebc75fb$var$_fetchResponseHandler(options, requestInfo, response, requestInit, error || virtualError);
    }, false);
}
function $899ee8298ebc75fb$var$_wrapXHR(client, options) {
    if (!("XMLHttpRequest" in (0, $b244ff70a28cf637$exports.GLOBAL_OBJ))) return;
    (0, $447740b7cde7d984$export$26ace48dd54c9aea)((handlerData)=>{
        if ((0, $b244ff70a28cf637$exports.getClient)() !== client) return;
        const { error: error, virtualError: virtualError } = handlerData;
        const xhr = handlerData.xhr;
        const sentryXhrData = xhr[0, $447740b7cde7d984$export$55b6bb1e45c6cf59];
        if (!sentryXhrData) return;
        const { method: method, request_headers: headers } = sentryXhrData;
        try {
            $899ee8298ebc75fb$var$_xhrResponseHandler(options, xhr, method, headers, error || virtualError);
        } catch (e) {
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn("Error while extracting response event form XHR response", e);
        }
    });
}
function $899ee8298ebc75fb$var$_shouldCaptureResponse(options, status, url) {
    return $899ee8298ebc75fb$var$_isInGivenStatusRanges(options.failedRequestStatusCodes, status) && $899ee8298ebc75fb$var$_isInGivenRequestTargets(options.failedRequestTargets, url) && !(0, $b244ff70a28cf637$exports.isSentryRequestUrl)(url, (0, $b244ff70a28cf637$exports.getClient)());
}
function $899ee8298ebc75fb$var$_createEvent(data) {
    const client = (0, $b244ff70a28cf637$exports.getClient)();
    const virtualStackTrace = client && data.error && data.error instanceof Error ? data.error.stack : void 0;
    const stack = virtualStackTrace && client ? client.getOptions().stackParser(virtualStackTrace, 0, 1) : void 0;
    const message = `HTTP Client Error with status code: ${data.status}`;
    const event = {
        message: message,
        exception: {
            values: [
                {
                    type: "Error",
                    value: message,
                    stacktrace: stack ? {
                        frames: stack
                    } : void 0
                }
            ]
        },
        request: {
            url: data.url,
            method: data.method,
            headers: data.requestHeaders,
            cookies: data.requestCookies
        },
        contexts: {
            response: {
                status_code: data.status,
                headers: data.responseHeaders,
                cookies: data.responseCookies,
                body_size: $899ee8298ebc75fb$var$_getResponseSizeFromHeaders(data.responseHeaders)
            }
        }
    };
    (0, $b244ff70a28cf637$exports.addExceptionMechanism)(event, {
        type: `auto.http.client.${data.type}`,
        handled: false
    });
    return event;
}
function $899ee8298ebc75fb$var$_getRequest(requestInfo, requestInit) {
    if (!requestInit && requestInfo instanceof Request) return requestInfo;
    if (requestInfo instanceof Request && requestInfo.bodyUsed) return requestInfo;
    return new Request(requestInfo, requestInit);
}
function $899ee8298ebc75fb$var$_getDataCollectionSettings() {
    const client = (0, $b244ff70a28cf637$exports.getClient)();
    if (!client) return {
        cookies: false,
        requestHeaders: false,
        responseHeaders: false
    };
    const options = client.getOptions();
    if (options.dataCollection == null) {
        const enabled = Boolean(options.sendDefaultPii);
        return {
            cookies: enabled,
            requestHeaders: enabled,
            responseHeaders: enabled
        };
    }
    const { cookies: cookies, httpHeaders: httpHeaders } = client.getDataCollectionOptions();
    return {
        cookies: cookies,
        requestHeaders: httpHeaders.request,
        responseHeaders: httpHeaders.response
    };
}



const $e5ba3b05859a226d$var$WINDOW = (0, $b244ff70a28cf637$exports.GLOBAL_OBJ);
const $e5ba3b05859a226d$var$DEFAULT_LINES_OF_CONTEXT = 7;
const $e5ba3b05859a226d$var$INTEGRATION_NAME = "ContextLines";
const $e5ba3b05859a226d$var$_contextLinesIntegration = (options = {})=>{
    return {
        name: $e5ba3b05859a226d$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const contextLines = options.frameContextLines ?? client?.getDataCollectionOptions().frameContextLines ?? $e5ba3b05859a226d$var$DEFAULT_LINES_OF_CONTEXT;
            return $e5ba3b05859a226d$var$addSourceContext(event, contextLines);
        }
    };
};
const $e5ba3b05859a226d$export$74173d114ed4f354 = (0, $b244ff70a28cf637$exports.defineIntegration)($e5ba3b05859a226d$var$_contextLinesIntegration);
function $e5ba3b05859a226d$var$addSourceContext(event, contextLines) {
    const doc = $e5ba3b05859a226d$var$WINDOW.document;
    const htmlFilename = $e5ba3b05859a226d$var$WINDOW.location && (0, $b244ff70a28cf637$exports.stripUrlQueryAndFragment)($e5ba3b05859a226d$var$WINDOW.location.href);
    if (!doc || !htmlFilename) return event;
    const exceptions = event.exception?.values;
    if (!exceptions?.length) return event;
    const html = doc.documentElement.innerHTML;
    if (!html) return event;
    const htmlLines = [
        "<!DOCTYPE html>",
        "<html>",
        ...html.split("\n"),
        "</html>"
    ];
    exceptions.forEach((exception)=>{
        const stacktrace = exception.stacktrace;
        if (stacktrace?.frames) stacktrace.frames = stacktrace.frames.map((frame)=>$e5ba3b05859a226d$export$cf59ef3dc46bd2e1(frame, htmlLines, htmlFilename, contextLines));
    });
    return event;
}
function $e5ba3b05859a226d$export$cf59ef3dc46bd2e1(frame, htmlLines, htmlFilename, linesOfContext) {
    if (frame.filename !== htmlFilename || !frame.lineno || !htmlLines.length) return frame;
    (0, $b244ff70a28cf637$exports.addContextToFrame)(htmlLines, frame, linesOfContext);
    return frame;
}





const $b3543acae904e2dc$export$363d064b9116000e = /* @__PURE__ */ Symbol.for("sentry__originalRequestBody");
function $b3543acae904e2dc$export$2f1b0f57f243f270(formData) {
    return new URLSearchParams(formData).toString();
}
function $b3543acae904e2dc$export$945a2d5364608d5(body, _debug = (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05)) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $b3543acae904e2dc$export$2f1b0f57f243f270(body)
        ];
        if (!body) return [
            void 0
        ];
    } catch (error) {
        (0, $c54a9ced88c7488b$export$16a28057038b10ef) && _debug.error(error, "Failed to serialize body", body);
        return [
            void 0,
            "BODY_PARSE_ERROR"
        ];
    }
    (0, $c54a9ced88c7488b$export$16a28057038b10ef) && _debug.log("Skipping network body because of body type", body);
    return [
        void 0,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $b3543acae904e2dc$export$ad44edf8012ec314(fetchArgs = []) {
    if (fetchArgs.length >= 2 && fetchArgs[1] && typeof fetchArgs[1] === "object" && "body" in fetchArgs[1]) return fetchArgs[1].body;
    if (fetchArgs.length >= 1 && fetchArgs[0] instanceof Request) {
        const request = fetchArgs[0];
        const originalBody = request[$b3543acae904e2dc$export$363d064b9116000e];
        if (originalBody !== void 0) return originalBody;
        return void 0;
    }
    return void 0;
}
function $b3543acae904e2dc$export$ce71c337afb62ea(xhr) {
    let headers;
    try {
        headers = xhr.getAllResponseHeaders();
    } catch (error) {
        (0, $c54a9ced88c7488b$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error(error, "Failed to get xhr response headers", xhr);
        return {};
    }
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        if (value) acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}



var $3tmPs = parcelRequire("3tmPs");
const $09df6a71d9392bb9$var$INTEGRATION_NAME = "GraphQLClient";
const $09df6a71d9392bb9$var$_graphqlClientIntegration = (options)=>{
    return {
        name: $09df6a71d9392bb9$var$INTEGRATION_NAME,
        setup (client) {
            $09df6a71d9392bb9$var$_updateSpanWithGraphQLData(client, options);
            $09df6a71d9392bb9$var$_updateBreadcrumbWithGraphQLData(client, options);
        }
    };
};
function $09df6a71d9392bb9$var$_updateSpanWithGraphQLData(client, options) {
    client.on("beforeOutgoingRequestSpan", (span, hint)=>{
        const spanJSON = (0, $b244ff70a28cf637$exports.spanToJSON)(span);
        const spanAttributes = spanJSON.data || {};
        const spanOp = spanAttributes[0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_OP];
        const isHttpClientSpan = spanOp === "http.client";
        if (!isHttpClientSpan) return;
        const httpUrl = spanAttributes[0, $3tmPs.URL_FULL] || spanAttributes["http.url"] || spanAttributes["url"];
        const httpMethod = spanAttributes[0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] || spanAttributes["http.method"];
        if (!(0, $b244ff70a28cf637$exports.isString)(httpUrl) || !(0, $b244ff70a28cf637$exports.isString)(httpMethod)) return;
        const { endpoints: endpoints } = options;
        const isTracedGraphqlEndpoint = (0, $b244ff70a28cf637$exports.stringMatchesSomePattern)(httpUrl, endpoints);
        const payload = $09df6a71d9392bb9$export$ab01d0edbd10f3e8(hint);
        if (isTracedGraphqlEndpoint && payload) {
            const graphqlBody = $09df6a71d9392bb9$export$8a91006ab73e3ea(payload);
            if (graphqlBody) {
                const operationInfo = $09df6a71d9392bb9$export$cac3929c3e0f021b(graphqlBody);
                span.updateName(`${httpMethod} ${httpUrl} (${operationInfo})`);
                if ($09df6a71d9392bb9$var$isStandardRequest(graphqlBody) && client.getDataCollectionOptions().graphQL.document === true) span.setAttribute((0, $3tmPs.GRAPHQL_DOCUMENT), graphqlBody.query);
                if ($09df6a71d9392bb9$var$isPersistedRequest(graphqlBody)) {
                    span.setAttribute("graphql.persisted_query.hash.sha256", graphqlBody.extensions.persistedQuery.sha256Hash);
                    span.setAttribute("graphql.persisted_query.version", graphqlBody.extensions.persistedQuery.version);
                }
            }
        }
    });
}
function $09df6a71d9392bb9$var$_updateBreadcrumbWithGraphQLData(client, options) {
    client.on("beforeOutgoingRequestBreadcrumb", (breadcrumb, handlerData)=>{
        const { category: category, type: type, data: data } = breadcrumb;
        const isFetch = category === "fetch";
        const isXhr = category === "xhr";
        const isHttpBreadcrumb = type === "http";
        if (isHttpBreadcrumb && (isFetch || isXhr)) {
            const httpUrl = data?.url;
            const { endpoints: endpoints } = options;
            const isTracedGraphqlEndpoint = (0, $b244ff70a28cf637$exports.stringMatchesSomePattern)(httpUrl, endpoints);
            const payload = $09df6a71d9392bb9$export$ab01d0edbd10f3e8(handlerData);
            if (isTracedGraphqlEndpoint && data && payload) {
                const graphqlBody = $09df6a71d9392bb9$export$8a91006ab73e3ea(payload);
                if (!data.graphql && graphqlBody) {
                    const operationInfo = $09df6a71d9392bb9$export$cac3929c3e0f021b(graphqlBody);
                    data["graphql.operation"] = operationInfo;
                    if ($09df6a71d9392bb9$var$isStandardRequest(graphqlBody) && client.getDataCollectionOptions().graphQL.document === true) data[0, $3tmPs.GRAPHQL_DOCUMENT] = graphqlBody.query;
                    if ($09df6a71d9392bb9$var$isPersistedRequest(graphqlBody)) {
                        data["graphql.persisted_query.hash.sha256"] = graphqlBody.extensions.persistedQuery.sha256Hash;
                        data["graphql.persisted_query.version"] = graphqlBody.extensions.persistedQuery.version;
                    }
                }
            }
        }
    });
}
function $09df6a71d9392bb9$export$cac3929c3e0f021b(requestBody) {
    if ($09df6a71d9392bb9$var$isPersistedRequest(requestBody)) return `persisted ${requestBody.operationName}`;
    if ($09df6a71d9392bb9$var$isStandardRequest(requestBody)) {
        const { query: graphqlQuery, operationName: graphqlOperationName } = requestBody;
        const { operationName: operationName = graphqlOperationName, operationType: operationType } = $09df6a71d9392bb9$export$cf7a144a1fa44ed4(graphqlQuery);
        const operationInfo = operationName ? `${operationType} ${operationName}` : `${operationType}`;
        return operationInfo;
    }
    return "unknown";
}
function $09df6a71d9392bb9$export$ab01d0edbd10f3e8(hint) {
    const isXhr = "xhr" in hint;
    let body;
    if (isXhr) {
        const sentryXhrData = hint.xhr[0, $447740b7cde7d984$export$55b6bb1e45c6cf59];
        body = sentryXhrData && (0, $b3543acae904e2dc$export$945a2d5364608d5)(sentryXhrData.body)[0];
    } else {
        const sentryFetchData = (0, $b3543acae904e2dc$export$ad44edf8012ec314)(hint.input);
        body = (0, $b3543acae904e2dc$export$945a2d5364608d5)(sentryFetchData)[0];
    }
    return body;
}
function $09df6a71d9392bb9$export$cf7a144a1fa44ed4(query) {
    const namedQueryRe = /^(?:\s*)(query|mutation|subscription)(?:\s*)(\w+)(?:\s*)[{(]/;
    const unnamedQueryRe = /^(?:\s*)(query|mutation|subscription)(?:\s*)[{(]/;
    const namedMatch = query.match(namedQueryRe);
    if (namedMatch) return {
        operationType: namedMatch[1],
        operationName: namedMatch[2]
    };
    const unnamedMatch = query.match(unnamedQueryRe);
    if (unnamedMatch) return {
        operationType: unnamedMatch[1],
        operationName: void 0
    };
    return {
        operationType: void 0,
        operationName: void 0
    };
}
function $09df6a71d9392bb9$var$isStandardRequest(payload) {
    return (0, $b244ff70a28cf637$exports.isObjectLike)(payload) && typeof payload.query === "string";
}
function $09df6a71d9392bb9$var$isPersistedRequest(payload) {
    return (0, $b244ff70a28cf637$exports.isObjectLike)(payload) && typeof payload.operationName === "string" && (0, $b244ff70a28cf637$exports.isObjectLike)(payload.extensions) && (0, $b244ff70a28cf637$exports.isObjectLike)(payload.extensions.persistedQuery) && typeof payload.extensions.persistedQuery.sha256Hash === "string" && typeof payload.extensions.persistedQuery.version === "number";
}
function $09df6a71d9392bb9$export$8a91006ab73e3ea(payload) {
    try {
        const requestBody = JSON.parse(payload);
        if ($09df6a71d9392bb9$var$isStandardRequest(requestBody) || $09df6a71d9392bb9$var$isPersistedRequest(requestBody)) return requestBody;
        return void 0;
    } catch  {
        return void 0;
    }
}
const $09df6a71d9392bb9$export$a934e57cd817247a = (0, $b244ff70a28cf637$exports.defineIntegration)($09df6a71d9392bb9$var$_graphqlClientIntegration);




const $1b8d06c5085d8bec$export$3264be986dfdbb57 = (0, $b244ff70a28cf637$exports.defineIntegration)((options = {})=>{
    const skipHtmlTags = [
        "script"
    ];
    function walk(element, windows, depth = 0) {
        if (!element) return;
        const children = "shadowRoot" in element && element.shadowRoot ? element.shadowRoot.children : element.children;
        for (const child of children){
            if (!(child instanceof HTMLElement)) continue;
            const componentName = (0, $b244ff70a28cf637$exports.getComponentName)(child, 1) || void 0;
            const tagName = child.tagName.toLowerCase();
            if (skipHtmlTags.includes(tagName)) continue;
            const result = options.onElement?.({
                element: child,
                componentName: componentName,
                tagName: tagName,
                depth: depth
            }) || {};
            if (result === "skip") continue;
            if (result === "children") {
                walk(child, windows, depth + 1);
                continue;
            }
            const { x: x, y: y, width: width, height: height } = child.getBoundingClientRect();
            const window = {
                identifier: child.id || void 0,
                type: componentName || tagName,
                visible: true,
                alpha: 1,
                height: height,
                width: width,
                x: x,
                y: y,
                ...result
            };
            const children2 = [];
            window.children = children2;
            walk(child, window.children, depth + 1);
            windows.push(window);
        }
    }
    return {
        name: "ViewHierarchy",
        processEvent: (event, hint)=>{
            if (event.type !== void 0 || options.shouldAttach?.(event, hint) === false) return event;
            const root = {
                rendering_system: "DOM",
                positioning: "absolute",
                windows: []
            };
            walk(options.rootElement?.() || (0, $e62dec891f31852b$export$56d8a8a25bd48b81).document.body, root.windows);
            const attachment = {
                filename: "view-hierarchy.json",
                attachmentType: "event.view_hierarchy",
                contentType: "application/json",
                data: JSON.stringify(root)
            };
            hint.attachments = hint.attachments || [];
            hint.attachments.push(attachment);
            return event;
        }
    };
});





const $777cacbd1bed0b63$var$DEFAULT_BREADCRUMBS = 100;
function $777cacbd1bed0b63$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $777cacbd1bed0b63$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $bc81602376c48fa6$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $d11ed0b3cdda6b8d$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}





const $4e93b773a0d3a86a$export$849dbeeeda01ae98 = "production";
const $4e93b773a0d3a86a$export$6829f580e78306fa = "development";






const $e9661cd6d20ea7e7$var$STATE_PENDING = 0;
const $e9661cd6d20ea7e7$var$STATE_RESOLVED = 1;
const $e9661cd6d20ea7e7$var$STATE_REJECTED = 2;
function $e9661cd6d20ea7e7$export$1fda8aa4d135f8aa(value) {
    return new $e9661cd6d20ea7e7$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
function $e9661cd6d20ea7e7$export$78e43115b553f358(reason) {
    return new $e9661cd6d20ea7e7$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
class $e9661cd6d20ea7e7$export$6f292d4960313241 {
    constructor(executor){
        this._state = $e9661cd6d20ea7e7$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $e9661cd6d20ea7e7$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $e9661cd6d20ea7e7$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $e9661cd6d20ea7e7$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $e9661cd6d20ea7e7$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $e9661cd6d20ea7e7$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $e9661cd6d20ea7e7$var$STATE_PENDING) return;
            if ((0, $13cf2ed412f405fa$export$f5b060c2914b97c8)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($e9661cd6d20ea7e7$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($e9661cd6d20ea7e7$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}


function $516ccaba9c9cf262$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    try {
        const result = $516ccaba9c9cf262$var$_notifyEventProcessors(event, hint, processors, index);
        return (0, $13cf2ed412f405fa$export$f5b060c2914b97c8)(result) ? result : (0, $e9661cd6d20ea7e7$export$1fda8aa4d135f8aa)(result);
    } catch (error) {
        return (0, $e9661cd6d20ea7e7$export$78e43115b553f358)(error);
    }
}
function $516ccaba9c9cf262$var$_notifyEventProcessors(event, hint, processors, index) {
    const processor = processors[index];
    if (!event || !processor) return event;
    const result = processor({
        ...event
    }, hint);
    (0, $19fdbaf7f0830971$export$16a28057038b10ef) && result === null && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Event processor "${processor.id || "?"}" dropped event`);
    if ((0, $13cf2ed412f405fa$export$f5b060c2914b97c8)(result)) return result.then((final)=>$516ccaba9c9cf262$var$_notifyEventProcessors(final, hint, processors, index + 1));
    return $516ccaba9c9cf262$var$_notifyEventProcessors(result, hint, processors, index + 1);
}





let $16a85e60da95d694$var$parsedStackResults;
let $16a85e60da95d694$var$lastSentryKeysCount;
let $16a85e60da95d694$var$lastNativeKeysCount;
let $16a85e60da95d694$var$cachedFilenameDebugIds;
function $16a85e60da95d694$export$e069fee9c632ed00(stackParser) {
    const sentryDebugIdMap = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1)._sentryDebugIds;
    const nativeDebugIdMap = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1)._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    if ($16a85e60da95d694$var$cachedFilenameDebugIds && sentryDebugIdKeys.length === $16a85e60da95d694$var$lastSentryKeysCount && nativeDebugIdKeys.length === $16a85e60da95d694$var$lastNativeKeysCount) return $16a85e60da95d694$var$cachedFilenameDebugIds;
    $16a85e60da95d694$var$lastSentryKeysCount = sentryDebugIdKeys.length;
    $16a85e60da95d694$var$lastNativeKeysCount = nativeDebugIdKeys.length;
    $16a85e60da95d694$var$cachedFilenameDebugIds = {};
    if (!$16a85e60da95d694$var$parsedStackResults) $16a85e60da95d694$var$parsedStackResults = {};
    const processDebugIds = (debugIdKeys, debugIdMap)=>{
        for (const key of debugIdKeys){
            const debugId = debugIdMap[key];
            const result = $16a85e60da95d694$var$parsedStackResults?.[key];
            if (result && $16a85e60da95d694$var$cachedFilenameDebugIds && debugId) {
                $16a85e60da95d694$var$cachedFilenameDebugIds[result[0]] = debugId;
                if ($16a85e60da95d694$var$parsedStackResults) $16a85e60da95d694$var$parsedStackResults[key] = [
                    result[0],
                    debugId
                ];
            } else if (debugId) {
                const parsedStack = stackParser(key);
                for(let i = parsedStack.length - 1; i >= 0; i--){
                    const stackFrame = parsedStack[i];
                    const filename = stackFrame?.filename;
                    if (filename && $16a85e60da95d694$var$cachedFilenameDebugIds && $16a85e60da95d694$var$parsedStackResults) {
                        $16a85e60da95d694$var$cachedFilenameDebugIds[filename] = debugId;
                        $16a85e60da95d694$var$parsedStackResults[key] = [
                            filename,
                            debugId
                        ];
                        break;
                    }
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return $16a85e60da95d694$var$cachedFilenameDebugIds;
}
function $16a85e60da95d694$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $16a85e60da95d694$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths){
        const normalizedPath = (0, $9ed2cf4edd0b2db9$export$60c0d6c8e038267a)(path);
        if (normalizedPath && filenameDebugIdMap[normalizedPath]) images.push({
            type: "sourcemap",
            code_file: path,
            debug_id: filenameDebugIdMap[normalizedPath]
        });
    }
    return images;
}







const $f337c80285f06f80$export$d7a7d984b0791405 = "sentry.source";
const $f337c80285f06f80$export$ccfe0a40627cc34b = "sentry.sample_rate";
const $f337c80285f06f80$export$889fb736668e1ecc = "sentry.previous_trace_sample_rate";
const $f337c80285f06f80$export$1a413bd9a88fdb09 = "sentry.op";
const $f337c80285f06f80$export$cca8dd30f57f805e = "sentry.origin";
const $f337c80285f06f80$export$d9e02c0285078f88 = "sentry.status.message";
const $f337c80285f06f80$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
const $f337c80285f06f80$export$f5f95cff026507b5 = "sentry.measurement_unit";
const $f337c80285f06f80$export$69cd5c610c7bb96a = "sentry.measurement_value";
const $f337c80285f06f80$export$f5cefb258679b29e = "sentry.release";
const $f337c80285f06f80$export$d1b1dbb47f5ba57c = "sentry.environment";
const $f337c80285f06f80$export$4626f2be16112c1c = "sentry.segment.name";
const $f337c80285f06f80$export$25fa4a1832d3736a = "sentry.segment.id";
const $f337c80285f06f80$export$87a4807042e1f1bb = "sentry.sdk.name";
const $f337c80285f06f80$export$301ebe936458e291 = "sentry.sdk.version";
const $f337c80285f06f80$export$bd847b1cc92ae587 = "sentry.sdk.integrations";
const $f337c80285f06f80$export$1f9cc1d34ea098a0 = "user.id";
const $f337c80285f06f80$export$b7466609ef46c07e = "user.email";
const $f337c80285f06f80$export$8d592bdaea63b930 = "user.ip_address";
const $f337c80285f06f80$export$c05ee933d3f74b2b = "user.name";
const $f337c80285f06f80$export$165ce9a229f6f050 = "sentry.custom_span_name";
const $f337c80285f06f80$export$1efec95406bbe327 = "sentry.profile_id";
const $f337c80285f06f80$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $f337c80285f06f80$export$b016f89ac1066ec = "cache.hit";
const $f337c80285f06f80$export$3110e4c3f4386399 = "cache.key";
const $f337c80285f06f80$export$86be76deee227ff2 = "cache.item_size";
const $f337c80285f06f80$export$be7a251980e7e946 = "http.request.method";
const $f337c80285f06f80$export$25dfd73e0e32c6e1 = "url.full";
const $f337c80285f06f80$export$ff77b5fd5b2d627b = "sentry.link.type";
const $f337c80285f06f80$export$71a4a707257f2774 = "gen_ai.conversation.id";





const $8ef2851bd0adcf53$export$6e69537d67fa20f = "sentry-";
const $8ef2851bd0adcf53$export$eb0401070c617ea5 = /^sentry-/;
const $8ef2851bd0adcf53$export$bdd844ddb2def819 = 8192;
function $8ef2851bd0adcf53$export$5b96ee2c8421f107(baggageHeader) {
    const baggageObject = $8ef2851bd0adcf53$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return void 0;
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($8ef2851bd0adcf53$export$6e69537d67fa20f)) {
            const nonPrefixedKey = key.slice($8ef2851bd0adcf53$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return void 0;
}
function $8ef2851bd0adcf53$export$56766feef403f365(dynamicSamplingContext) {
    if (!dynamicSamplingContext) return void 0;
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$8ef2851bd0adcf53$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $8ef2851bd0adcf53$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
function $8ef2851bd0adcf53$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $13cf2ed412f405fa$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return void 0;
    if (Array.isArray(baggageHeader)) return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $8ef2851bd0adcf53$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $8ef2851bd0adcf53$var$baggageHeaderToObject(baggageHeader);
}
function $8ef2851bd0adcf53$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf("=");
        if (eqIdx === -1) return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
function $8ef2851bd0adcf53$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) return void 0;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $8ef2851bd0adcf53$export$bdd844ddb2def819) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}
function $8ef2851bd0adcf53$export$7b8640b7baaa3922(existing, incoming) {
    if (!existing) return incoming;
    const existingEntries = $8ef2851bd0adcf53$export$397de414d189db00(existing);
    const incomingEntries = $8ef2851bd0adcf53$export$397de414d189db00(incoming);
    if (!incomingEntries) return existing;
    const merged = {};
    let hasNewSentryEntries = false;
    const newSentryEntries = {};
    const newNonSentryEntries = {};
    for (const [key, value] of Object.entries(incomingEntries))if (key.startsWith($8ef2851bd0adcf53$export$6e69537d67fa20f)) {
        newSentryEntries[key] = value;
        hasNewSentryEntries = true;
    } else newNonSentryEntries[key] = value;
    if (existingEntries) {
        for (const [key, value] of Object.entries(existingEntries))if (!hasNewSentryEntries || !key.startsWith($8ef2851bd0adcf53$export$6e69537d67fa20f)) merged[key] = value;
    }
    if (hasNewSentryEntries) Object.assign(merged, newSentryEntries);
    for (const [key, value] of Object.entries(newNonSentryEntries))merged[key] ?? (merged[key] = value);
    return $8ef2851bd0adcf53$export$12a7349a29a6e3c2(merged);
}




const $1e1399eeae328b26$var$ORG_ID_REGEX = /^o(\d+)\./;
const $1e1399eeae328b26$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $1e1399eeae328b26$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
function $1e1399eeae328b26$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
function $1e1399eeae328b26$export$b892860177f70a30(str) {
    const match = $1e1399eeae328b26$var$DSN_REGEX.exec(str);
    if (!match) {
        (0, $d11ed0b3cdda6b8d$export$cda52e2a8927a2ca)(()=>{
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return void 0;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $1e1399eeae328b26$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $1e1399eeae328b26$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $1e1399eeae328b26$var$validateDsn(dsn) {
    if (!(0, $19fdbaf7f0830971$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$1e1399eeae328b26$var$isValidProtocol(protocol)) {
        (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
function $1e1399eeae328b26$export$5914f4e7748c29c9(host) {
    const match = host.match($1e1399eeae328b26$var$ORG_ID_REGEX);
    return match?.[1];
}
function $1e1399eeae328b26$export$b7ac9b8efa4bb595(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $1e1399eeae328b26$export$5914f4e7748c29c9(host);
    return org_id;
}
function $1e1399eeae328b26$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $1e1399eeae328b26$export$b892860177f70a30(from) : $1e1399eeae328b26$var$dsnFromComponents(from);
    if (!components || !$1e1399eeae328b26$var$validateDsn(components)) return void 0;
    return components;
}



function $e3827447d651dfc5$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}





function $930f69313cc0b0d6$export$f5706f332d297c38(maybeObj) {
    return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
function $930f69313cc0b0d6$export$f18f8779fed6dfa(rawValue, useFallback) {
    const { value: value, unit: unit } = $930f69313cc0b0d6$export$f5706f332d297c38(rawValue) ? rawValue : {
        value: rawValue,
        unit: void 0
    };
    const attributeValue = $930f69313cc0b0d6$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === "string" ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === "skip-undefined" && value === void 0) return;
    let stringValue = "";
    try {
        stringValue = JSON.stringify(value) ?? "";
    } catch  {}
    return {
        value: stringValue,
        type: "string",
        ...checkedUnit
    };
}
function $930f69313cc0b0d6$export$4954cae66e755861(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $930f69313cc0b0d6$export$f18f8779fed6dfa(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
function $930f69313cc0b0d6$export$97341f7cd97c59f(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        weight += key.length * 2;
        weight += attr.type.length * 2;
        weight += (attr.unit?.length ?? 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) weight += $930f69313cc0b0d6$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ((0, $13cf2ed412f405fa$export$c3825b437cbdea5c)(val)) weight += $930f69313cc0b0d6$var$estimatePrimitiveSizeInBytes(val);
        else weight += 100;
    }
    return weight;
}
function $930f69313cc0b0d6$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "boolean") return 4;
    else if (typeof value === "number") return 8;
    return 0;
}
function $930f69313cc0b0d6$var$getTypedAttributeValue(value) {
    if (Array.isArray(value)) return {
        value: value,
        type: "array"
    };
    const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
    if (primitiveType) return {
        value: value,
        type: primitiveType
    };
}





const $fda37f10dc06a152$export$136e25984ba4a383 = 0;
const $fda37f10dc06a152$export$58f7963109c806fc = 1;
const $fda37f10dc06a152$export$f966a0446ece71e = 2;
function $fda37f10dc06a152$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $fda37f10dc06a152$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $fda37f10dc06a152$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $fda37f10dc06a152$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $fda37f10dc06a152$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $fda37f10dc06a152$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $fda37f10dc06a152$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $fda37f10dc06a152$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $fda37f10dc06a152$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $fda37f10dc06a152$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $fda37f10dc06a152$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $fda37f10dc06a152$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $fda37f10dc06a152$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $fda37f10dc06a152$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $fda37f10dc06a152$export$f966a0446ece71e,
        message: "internal_error"
    };
}
function $fda37f10dc06a152$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $fda37f10dc06a152$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}




const $e54da191c628b5f0$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $e54da191c628b5f0$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
const $e54da191c628b5f0$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceInference");
const $e54da191c628b5f0$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceExplicitlySet");
const $e54da191c628b5f0$var$TRACER_PROVIDER_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.tracerProviderSpan");
function $e54da191c628b5f0$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $269eeb69635ed414$export$e73679ffaf56810e)(span, $e54da191c628b5f0$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, (0, $ea0bfeddd00a5349$export$f0b98edec95fcb33)(isolationScope));
        (0, $269eeb69635ed414$export$e73679ffaf56810e)(span, $e54da191c628b5f0$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
function $e54da191c628b5f0$export$c08fbc656a245d03(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$e54da191c628b5f0$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: (0, $ea0bfeddd00a5349$export$a0592ad8c3586cf)(spanWithScopes[$e54da191c628b5f0$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}
function $e54da191c628b5f0$export$d135494e80cbbcae(span) {
    (0, $269eeb69635ed414$export$e73679ffaf56810e)(span, $e54da191c628b5f0$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD, true);
}
function $e54da191c628b5f0$export$2e69b79005fc86eb(span) {
    return span[$e54da191c628b5f0$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD] === true;
}
function $e54da191c628b5f0$export$c45f16c039fb5033(span) {
    (0, $269eeb69635ed414$export$e73679ffaf56810e)(span, $e54da191c628b5f0$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD, true);
}
function $e54da191c628b5f0$export$aceb4106f395d20e(span) {
    return span[$e54da191c628b5f0$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD] === true;
}
function $e54da191c628b5f0$export$6ba79447c0a2d852(span) {
    (0, $269eeb69635ed414$export$e73679ffaf56810e)(span, $e54da191c628b5f0$var$TRACER_PROVIDER_SPAN_FIELD, true);
}
function $e54da191c628b5f0$export$a9ba2a501dbf6a56(span) {
    return span[$e54da191c628b5f0$var$TRACER_PROVIDER_SPAN_FIELD] === true;
}








function $921fe5f527b40422$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return void 0;
    return rate;
}




const $bcc4fe773b74e41d$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
function $bcc4fe773b74e41d$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return void 0;
    const matches = traceparent.match($bcc4fe773b74e41d$export$394a210812ba3012);
    if (!matches) return void 0;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
function $bcc4fe773b74e41d$export$d6559160aa7f14fa(propagationContext) {
    return !!propagationContext.parentSpanId || !!propagationContext.dsc;
}
function $bcc4fe773b74e41d$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $bcc4fe773b74e41d$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $8ef2851bd0adcf53$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $ece9bac57decbcb8$export$dc6d7ea554bcce10)(),
        sampleRand: (0, $c80d7f6644a3b50b$export$9869d72de32a3917)()
    };
    const sampleRand = $bcc4fe773b74e41d$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
        sampleRand
    };
}
function $bcc4fe773b74e41d$export$f35d907436da45cf(traceId = (0, $ece9bac57decbcb8$export$dc6d7ea554bcce10)(), spanId = (0, $ece9bac57decbcb8$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = "";
    if (sampled !== void 0) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
function $bcc4fe773b74e41d$export$1aff3752542747dd(traceId = (0, $ece9bac57decbcb8$export$dc6d7ea554bcce10)(), spanId = (0, $ece9bac57decbcb8$export$295213bc4d0c54ad)(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? "01" : "00"}`;
}
function $bcc4fe773b74e41d$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    const parsedSampleRand = (0, $921fe5f527b40422$export$a5bd2d81656d9546)(dsc?.sample_rand);
    if (parsedSampleRand !== void 0) return parsedSampleRand;
    const parsedSampleRate = (0, $921fe5f527b40422$export$a5bd2d81656d9546)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== void 0) return traceparentData.parentSampled ? // Returns a sample rand with positive sampling decision [0, sampleRate)
    (0, $c80d7f6644a3b50b$export$9869d72de32a3917)() * parsedSampleRate : // Returns a sample rand with negative sampling decision [sampleRate, 1)
    parsedSampleRate + (0, $c80d7f6644a3b50b$export$9869d72de32a3917)() * (1 - parsedSampleRate);
    else return (0, $c80d7f6644a3b50b$export$9869d72de32a3917)();
}
function $bcc4fe773b74e41d$export$18811bc99eefceaa(client, baggageOrgId) {
    const clientOrgId = (0, $1e1399eeae328b26$export$b7ac9b8efa4bb595)(client);
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false;
    if (strictTraceContinuation) {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}




const $bb9b6447bf4caedb$export$208d5b368507fb8b = 0;
const $bb9b6447bf4caedb$export$eb571cd9b5d98de8 = 1;
let $bb9b6447bf4caedb$var$hasShownSpanDropWarning = false;
function $bb9b6447bf4caedb$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $bb9b6447bf4caedb$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
function $bb9b6447bf4caedb$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    const parent_span_id = isRemote ? spanId : $bb9b6447bf4caedb$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $e54da191c628b5f0$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $ece9bac57decbcb8$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
function $bb9b6447bf4caedb$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $bb9b6447bf4caedb$export$5caecac1caaf3a71(span);
    return (0, $bcc4fe773b74e41d$export$f35d907436da45cf)(traceId, spanId, sampled);
}
function $bb9b6447bf4caedb$export$cda58d87bc594e9f(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $bb9b6447bf4caedb$export$5caecac1caaf3a71(span);
    return (0, $bcc4fe773b74e41d$export$1aff3752542747dd)(traceId, spanId, sampled);
}
function $bb9b6447bf4caedb$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $bb9b6447bf4caedb$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return void 0;
}
function $bb9b6447bf4caedb$export$9015adcf158ef3a5(links) {
    if (links?.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $bb9b6447bf4caedb$export$eb571cd9b5d98de8,
            attributes: attributes
        }));
    else return void 0;
}
function $bb9b6447bf4caedb$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $bb9b6447bf4caedb$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $bb9b6447bf4caedb$var$ensureTimestampInSeconds(input.getTime());
    return (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
}
function $bb9b6447bf4caedb$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $bb9b6447bf4caedb$export$92d8c23565496537(span) {
    if ($bb9b6447bf4caedb$export$50882270da12d911(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($bb9b6447bf4caedb$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $bb9b6447bf4caedb$var$getOtelParentSpanId(span),
            start_timestamp: $bb9b6447bf4caedb$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $bb9b6447bf4caedb$export$3f7581298f56c6d7(endTime) || void 0,
            status: $bb9b6447bf4caedb$export$e238a77ea3a8cd66(status),
            op: attributes[0, $f337c80285f06f80$export$1a413bd9a88fdb09],
            origin: attributes[0, $f337c80285f06f80$export$cca8dd30f57f805e],
            links: $bb9b6447bf4caedb$export$cb3e3a12e0eec16c(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $bb9b6447bf4caedb$export$db0cad9e44f67af8(span) {
    if ($bb9b6447bf4caedb$export$50882270da12d911(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($bb9b6447bf4caedb$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $bb9b6447bf4caedb$var$getOtelParentSpanId(span),
            start_timestamp: $bb9b6447bf4caedb$export$3f7581298f56c6d7(startTime),
            end_timestamp: $bb9b6447bf4caedb$export$3f7581298f56c6d7(endTime),
            is_segment: span === $bb9b6447bf4caedb$export$7a3106f345d83bb6(span),
            status: $bb9b6447bf4caedb$export$d3856a3187d34821(status),
            attributes: $bb9b6447bf4caedb$export$1464a9cb828ba99f(attributes, status),
            links: $bb9b6447bf4caedb$export$9015adcf158ef3a5(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: "",
        end_timestamp: 0,
        status: "ok",
        is_segment: span === $bb9b6447bf4caedb$export$7a3106f345d83bb6(span)
    };
}
function $bb9b6447bf4caedb$var$getOtelParentSpanId(span) {
    return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? span.parentSpanContext?.spanId : void 0;
}
function $bb9b6447bf4caedb$export$5402aa553bcf35f3(spanJson) {
    return {
        ...spanJson,
        attributes: (0, $930f69313cc0b0d6$export$4954cae66e755861)(spanJson.attributes),
        links: spanJson.links?.map((link)=>({
                ...link,
                attributes: (0, $930f69313cc0b0d6$export$4954cae66e755861)(link.attributes)
            }))
    };
}
function $bb9b6447bf4caedb$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
function $bb9b6447bf4caedb$export$50882270da12d911(span) {
    return typeof span.getSpanJSON === "function";
}
function $bb9b6447bf4caedb$export$5caecac1caaf3a71(span) {
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $bb9b6447bf4caedb$export$eb571cd9b5d98de8;
}
function $bb9b6447bf4caedb$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $fda37f10dc06a152$export$136e25984ba4a383)) return void 0;
    if (status.code === (0, $fda37f10dc06a152$export$58f7963109c806fc)) return "ok";
    return status.message || "internal_error";
}
function $bb9b6447bf4caedb$export$d3856a3187d34821(status) {
    return !status || status.code === (0, $fda37f10dc06a152$export$58f7963109c806fc) || status.code === (0, $fda37f10dc06a152$export$136e25984ba4a383) || status.message === "cancelled" ? "ok" : "error";
}
function $bb9b6447bf4caedb$export$1464a9cb828ba99f(attributes, status) {
    const statusMessage = $bb9b6447bf4caedb$export$d3856a3187d34821(status) === "error" ? status?.message : void 0;
    return {
        ...statusMessage && {
            [(0, $f337c80285f06f80$export$d9e02c0285078f88)]: statusMessage
        },
        ...attributes
    };
}
const $bb9b6447bf4caedb$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $bb9b6447bf4caedb$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
function $bb9b6447bf4caedb$export$81397d924722cc65(span, childSpan) {
    const rootSpan = span[$bb9b6447bf4caedb$var$ROOT_SPAN_FIELD] || span;
    (0, $269eeb69635ed414$export$e73679ffaf56810e)(childSpan, $bb9b6447bf4caedb$var$ROOT_SPAN_FIELD, rootSpan);
    if (!$bb9b6447bf4caedb$export$5caecac1caaf3a71(span)) return;
    if (!span.isRecording() && !rootSpan.isRecording()) return;
    if (span[$bb9b6447bf4caedb$var$CHILD_SPANS_FIELD]) span[$bb9b6447bf4caedb$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $269eeb69635ed414$export$e73679ffaf56810e)(span, $bb9b6447bf4caedb$var$CHILD_SPANS_FIELD, /* @__PURE__ */ new Set([
        childSpan
    ]));
}
function $bb9b6447bf4caedb$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$bb9b6447bf4caedb$var$CHILD_SPANS_FIELD]) span[$bb9b6447bf4caedb$var$CHILD_SPANS_FIELD].delete(childSpan);
}
function $bb9b6447bf4caedb$export$340c5c8a13ffc680(span) {
    const resultSet = /* @__PURE__ */ new Set();
    function addSpanChildren(span2) {
        if (resultSet.has(span2)) return;
        else if ($bb9b6447bf4caedb$export$5caecac1caaf3a71(span2)) {
            resultSet.add(span2);
            const childSpans = span2[$bb9b6447bf4caedb$var$CHILD_SPANS_FIELD] ? Array.from(span2[$bb9b6447bf4caedb$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
const $bb9b6447bf4caedb$export$c4c6a79b1260ca1b = $bb9b6447bf4caedb$export$7a3106f345d83bb6;
function $bb9b6447bf4caedb$export$7a3106f345d83bb6(span) {
    return span[$bb9b6447bf4caedb$var$ROOT_SPAN_FIELD] || span;
}
function $bb9b6447bf4caedb$export$1be426a8e585c83e() {
    const carrier = (0, $e4c75fb63b040566$export$19eade501500c6c1)();
    const acs = (0, $a8b8acc568359454$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $dab1970d0c142a42$export$91f063ebb8eff307)((0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)());
}
function $bb9b6447bf4caedb$export$d11691ff45a3e535() {
    if (!$bb9b6447bf4caedb$var$hasShownSpanDropWarning) {
        (0, $d11ed0b3cdda6b8d$export$cda52e2a8927a2ca)(()=>{
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.");
        });
        $bb9b6447bf4caedb$var$hasShownSpanDropWarning = true;
    }
}
function $bb9b6447bf4caedb$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $f337c80285f06f80$export$d7a7d984b0791405)]: "custom",
        [(0, $f337c80285f06f80$export$165ce9a229f6f050)]: name
    });
}





const $057104436ef6f1c5$var$NON_RECORDING_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.nonRecordingSpan");
class $057104436ef6f1c5$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $ece9bac57decbcb8$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $ece9bac57decbcb8$export$295213bc4d0c54ad)();
        this.dropReason = spanContext.dropReason;
        (0, $269eeb69635ed414$export$e73679ffaf56810e)(this, $057104436ef6f1c5$var$NON_RECORDING_SPAN_FIELD, true);
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $bb9b6447bf4caedb$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
}
function $057104436ef6f1c5$export$61cc547d99783aa7(span) {
    return !!span && span[$057104436ef6f1c5$var$NON_RECORDING_SPAN_FIELD] === true;
}



const $09fae5ef8120e803$var$FROZEN_DSC_FIELD = "_frozenDsc";
function $09fae5ef8120e803$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $269eeb69635ed414$export$e73679ffaf56810e)(spanWithMaybeDsc, $09fae5ef8120e803$var$FROZEN_DSC_FIELD, dsc);
}
function $09fae5ef8120e803$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = {
        environment: options.environment || (0, $4e93b773a0d3a86a$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: (0, $1e1399eeae328b26$export$b7ac9b8efa4bb595)(client)
    };
    client.emit("createDsc", dsc);
    return dsc;
}
function $09fae5ef8120e803$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $09fae5ef8120e803$export$366bad00d6815eed(propagationContext.traceId, client);
}
function $09fae5ef8120e803$export$a117f995597e25df(span) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[0, $f337c80285f06f80$export$ccfe0a40627cc34b] ?? rootSpanAttributes[0, $f337c80285f06f80$export$889fb736668e1ecc];
    function applyLocalSampleRateToDsc(dsc2) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc2.sample_rate = `${rootSpanSampleRate}`;
        return dsc2;
    }
    const frozenDsc = rootSpan[$09fae5ef8120e803$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    const isNonRecordingRoot = (0, $057104436ef6f1c5$export$61cc547d99783aa7)(rootSpan);
    const isIgnoredRoot = isNonRecordingRoot && rootSpan.dropReason === "ignored";
    if (isNonRecordingRoot && (!(0, $e3827447d651dfc5$export$1f70765132c3c225)(client.getOptions()) || isIgnoredRoot)) {
        const capturedScope = (0, $e54da191c628b5f0$export$c08fbc656a245d03)(rootSpan).scope;
        if (capturedScope) {
            const dsc2 = {
                ...$09fae5ef8120e803$export$89ef1736f08c6b2b(client, capturedScope)
            };
            if (isIgnoredRoot) dsc2.sampled = "false";
            return applyLocalSampleRateToDsc(dsc2);
        }
    }
    const traceStateDsc = traceState?.get("sentry.dsc");
    const dscOnTraceState = traceStateDsc && (0, $8ef2851bd0adcf53$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    const dsc = $09fae5ef8120e803$export$366bad00d6815eed(span.spanContext().traceId, client);
    const source = rootSpanAttributes[0, $f337c80285f06f80$export$d7a7d984b0791405] ?? rootSpanAttributes["sentry.segment.name.source"];
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    if ((0, $e3827447d651dfc5$export$1f70765132c3c225)()) {
        dsc.sampled = String((0, $bb9b6447bf4caedb$export$5caecac1caaf3a71)(rootSpan));
        dsc.sample_rand = // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $e54da191c628b5f0$export$c08fbc656a245d03)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
function $09fae5ef8120e803$export$95cf936fdacaff7b(span) {
    const dsc = $09fae5ef8120e803$export$a117f995597e25df(span);
    return (0, $8ef2851bd0adcf53$export$56766feef403f365)(dsc);
}




function $9a2c488a2b943a4e$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    $9a2c488a2b943a4e$var$applyDataToEvent(event, data);
    if (span) $9a2c488a2b943a4e$var$applySpanToEvent(event, span);
    $9a2c488a2b943a4e$var$applyFingerprintToEvent(event, fingerprint);
    $9a2c488a2b943a4e$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $9a2c488a2b943a4e$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
function $9a2c488a2b943a4e$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, attributes: attributes, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $9a2c488a2b943a4e$export$b1a120a2871faa46(data, "extra", extra);
    $9a2c488a2b943a4e$export$b1a120a2871faa46(data, "tags", tags);
    $9a2c488a2b943a4e$export$b1a120a2871faa46(data, "attributes", attributes);
    $9a2c488a2b943a4e$export$b1a120a2871faa46(data, "user", user);
    $9a2c488a2b943a4e$export$b1a120a2871faa46(data, "contexts", contexts);
    data.sdkProcessingMetadata = (0, $40b0d31022c415bf$export$4950aa0f605343fb)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
function $9a2c488a2b943a4e$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $40b0d31022c415bf$export$4950aa0f605343fb)(data[prop], mergeVal, 1);
}
function $9a2c488a2b943a4e$export$cc422922fcbb91c6(isolationScope, currentScope) {
    const scopeData = (0, $7d48e1ed9f699a01$export$aa55d5ab8e05984f)().getScopeData();
    isolationScope && $9a2c488a2b943a4e$export$25ac7e259a513db4(scopeData, isolationScope.getScopeData());
    currentScope && $9a2c488a2b943a4e$export$25ac7e259a513db4(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $9a2c488a2b943a4e$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $9a2c488a2b943a4e$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : void 0;
}
function $9a2c488a2b943a4e$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $9a2c488a2b943a4e$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $bb9b6447bf4caedb$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $09fae5ef8120e803$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
function $9a2c488a2b943a4e$var$applyFingerprintToEvent(event, fingerprint) {
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    if (!event.fingerprint.length) delete event.fingerprint;
}





function $e98f8a40c7329053$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $cc262db35458e4b3$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $bc81602376c48fa6$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $e98f8a40c7329053$export$d7e04067a6fbc882(prepared, options);
    $e98f8a40c7329053$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    if (event.type === void 0) $e98f8a40c7329053$export$63042efc86f043e7(prepared, options.stackParser);
    const finalScope = $e98f8a40c7329053$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $cc262db35458e4b3$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    const data = (0, $9a2c488a2b943a4e$export$cc422922fcbb91c6)(isolationScope, finalScope);
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $9a2c488a2b943a4e$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const isInternalException = hint.data && hint.data.__sentry__ === true;
    const result = isInternalException ? (0, $e9661cd6d20ea7e7$export$1fda8aa4d135f8aa)(prepared) : (0, $516ccaba9c9cf262$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) $e98f8a40c7329053$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $e98f8a40c7329053$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
function $e98f8a40c7329053$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength } = options;
    event.environment = event.environment || environment || (0, $4e93b773a0d3a86a$export$849dbeeeda01ae98);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url && maxValueLength) request.url = (0, $e534db390d1e4996$export$6a506b36fdea397d)(request.url, maxValueLength);
    if (maxValueLength) event.exception?.values?.forEach((exception)=>{
        if (exception.value) exception.value = (0, $e534db390d1e4996$export$6a506b36fdea397d)(exception.value, maxValueLength);
    });
}
function $e98f8a40c7329053$export$63042efc86f043e7(event, stackParser) {
    const filenameDebugIdMap = (0, $16a85e60da95d694$export$e069fee9c632ed00)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
function $e98f8a40c7329053$export$1be657ba8ef44ff0(event) {
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
function $e98f8a40c7329053$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
function $e98f8a40c7329053$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $2d7134eeb4bc669b$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $2d7134eeb4bc669b$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $2d7134eeb4bc669b$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $2d7134eeb4bc669b$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $2d7134eeb4bc669b$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $2d7134eeb4bc669b$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, $2d7134eeb4bc669b$export$a3295358bff77e)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $e98f8a40c7329053$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $dd23bca0e7d7618a$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
function $e98f8a40c7329053$export$76b5f966996d1653(hint) {
    if (!hint) return void 0;
    if ($e98f8a40c7329053$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($e98f8a40c7329053$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $e98f8a40c7329053$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $dd23bca0e7d7618a$export$775b6bb06e53a214) || typeof hint === "function";
}
const $e98f8a40c7329053$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "propagationContext"
];
function $e98f8a40c7329053$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$e98f8a40c7329053$var$captureContextKeys.includes(key));
}




function $6918c722b531ff18$export$f5282963edea4a68(exception, hint) {
    return (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().captureException(exception, (0, $e98f8a40c7329053$export$76b5f966996d1653)(hint));
}
function $6918c722b531ff18$export$45654777c133ae80(message, captureContext) {
    const level = typeof captureContext === "string" ? captureContext : void 0;
    const hint = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : void 0;
    return (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().captureMessage(message, level, hint);
}
function $6918c722b531ff18$export$1462b974fdcf6ba2(event, hint) {
    return (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
function $6918c722b531ff18$export$2f04de43fe27971a(name, context) {
    (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)().setContext(name, context);
}
function $6918c722b531ff18$export$bb4922da0dd51b92(extras) {
    (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)().setExtras(extras);
}
function $6918c722b531ff18$export$8e8e7789d42ed61d(key, extra) {
    (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)().setExtra(key, extra);
}
function $6918c722b531ff18$export$74a8fb34822092e6(tags) {
    (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)().setTags(tags);
}
function $6918c722b531ff18$export$a37d07ee78eb4569(key, value) {
    (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)().setTag(key, value);
}
function $6918c722b531ff18$export$74da2cba014bdc09(attributes) {
    (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)().setAttributes(attributes);
}
function $6918c722b531ff18$export$9fec4d97f1922e0b(key, value) {
    (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)().setAttribute(key, value);
}
function $6918c722b531ff18$export$8b6bb3dd62a01be2(user) {
    (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)().setUser(user);
}
function $6918c722b531ff18$export$58213391a19e392(conversationId) {
    (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)().setConversationId(conversationId);
}
function $6918c722b531ff18$export$5d4e9fd7fac8e617() {
    return (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)().lastEventId();
}
async function $6918c722b531ff18$export$4909b86c8034bf73(timeout) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
async function $6918c722b531ff18$export$8360e631d277ea4d(timeout) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
function $6918c722b531ff18$export$3f95c6f800b78024() {
    return !!(0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
}
function $6918c722b531ff18$export$3b029eb57ac4d562() {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
function $6918c722b531ff18$export$9aac0b9f77928fbf(callback) {
    (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)().addEventProcessor(callback);
}
function $6918c722b531ff18$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)();
    const { user: user } = (0, $9a2c488a2b943a4e$export$cc422922fcbb91c6)(isolationScope, (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)());
    const { userAgent: userAgent } = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $e6ef9757665bd407$export$14a186326edbb264)({
        user: user,
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === "ok") (0, $e6ef9757665bd407$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $6918c722b531ff18$export$17a5be43989a0bc1();
    isolationScope.setSession(session);
    return session;
}
function $6918c722b531ff18$export$17a5be43989a0bc1() {
    const isolationScope = (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)();
    const currentScope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $e6ef9757665bd407$export$56521d9ba90f62ee)(session);
    $6918c722b531ff18$var$_sendSessionUpdate();
    isolationScope.setSession();
}
function $6918c722b531ff18$var$_sendSessionUpdate() {
    const isolationScope = (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)();
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
function $6918c722b531ff18$export$667e7b4d445d566b(end = false) {
    if (end) {
        $6918c722b531ff18$export$17a5be43989a0bc1();
        return;
    }
    $6918c722b531ff18$var$_sendSessionUpdate();
}






function $bb063ad93c8b79c7$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
function $bb063ad93c8b79c7$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
function $bb063ad93c8b79c7$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
function $bb063ad93c8b79c7$export$604a45d95a155e2b(envelope, types) {
    return $bb063ad93c8b79c7$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
function $bb063ad93c8b79c7$var$encodeUTF8(input) {
    const carrier = (0, $e4c75fb63b040566$export$c8bfa33e4e8ae492)((0, $736a69486c86d36c$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
function $bb063ad93c8b79c7$var$decodeUTF8(input) {
    const carrier = (0, $e4c75fb63b040566$export$c8bfa33e4e8ae492)((0, $736a69486c86d36c$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
function $bb063ad93c8b79c7$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $bb063ad93c8b79c7$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $bb063ad93c8b79c7$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`
${JSON.stringify(itemHeaders)}
`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                stringifiedPayload = JSON.stringify((0, $2d7134eeb4bc669b$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $bb063ad93c8b79c7$var$concatBuffers(parts);
}
function $bb063ad93c8b79c7$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
function $bb063ad93c8b79c7$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $bb063ad93c8b79c7$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(10);
        if (i < 0) i = buffer.length;
        return JSON.parse($bb063ad93c8b79c7$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : void 0;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
function $bb063ad93c8b79c7$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
function $bb063ad93c8b79c7$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $bb063ad93c8b79c7$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $bb063ad93c8b79c7$var$DATA_CATEGORY_OVERRIDES = {
    sessions: "session",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    raw_security: "security",
    log: "log_item",
    trace_metric: "metric"
};
function $bb063ad93c8b79c7$var$_isOverriddenType(type) {
    return type in $bb063ad93c8b79c7$var$DATA_CATEGORY_OVERRIDES;
}
function $bb063ad93c8b79c7$export$b11169581eeaf237(type) {
    return $bb063ad93c8b79c7$var$_isOverriddenType(type) ? $bb063ad93c8b79c7$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
function $bb063ad93c8b79c7$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
function $bb063ad93c8b79c7$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date((0, $c80d7f6644a3b50b$export$65b1bada40c91b34)()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $1e1399eeae328b26$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}

function $b98d2b6f6f2e87bf$export$61fc7d43ac8f84b0(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options?.maxWait ? Math.max(options.maxWait, wait) : 0;
    const setTimeoutImpl = options?.setTimeoutImpl || setTimeout;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== void 0 && clearTimeout(timerId);
        maxTimerId !== void 0 && clearTimeout(maxTimerId);
        timerId = maxTimerId = void 0;
    }
    function flush() {
        if (timerId !== void 0 || maxTimerId !== void 0) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeoutImpl(invokeFunc, wait);
        if (maxWait && maxTimerId === void 0) maxTimerId = setTimeoutImpl(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}


const $33414f31f3554c40$export$b09ce39faaeb1e7c = 60000;
function $33414f31f3554c40$export$615352e17ed7741(header, now = (0, $c80d7f6644a3b50b$export$65b1bada40c91b34)()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1e3;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $33414f31f3554c40$export$b09ce39faaeb1e7c;
}
function $33414f31f3554c40$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
function $33414f31f3554c40$export$6c91fec22056810a(limits, dataCategory, now = (0, $c80d7f6644a3b50b$export$65b1bada40c91b34)()) {
    return $33414f31f3554c40$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
function $33414f31f3554c40$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = (0, $c80d7f6644a3b50b$export$65b1bada40c91b34)()) {
    const updatedRateLimits = {
        ...limits
    };
    const rateLimitHeader = headers?.["x-sentry-rate-limits"];
    const retryAfterHeader = headers?.["retry-after"];
    if (rateLimitHeader) for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1e3;
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $33414f31f3554c40$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}


var $3tmPs = parcelRequire("3tmPs");

const $0c1b93525a804899$var$DEFAULT_BASE_URL = "thismessage:/";
function $0c1b93525a804899$export$e258e13805402ba7(url) {
    return "isRelative" in url;
}
function $0c1b93525a804899$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    const base = urlBase ?? (isRelative ? $0c1b93525a804899$var$DEFAULT_BASE_URL : void 0);
    try {
        if ("canParse" in URL && !URL.canParse(url, base)) return void 0;
        const fullUrlObject = new URL(url, base);
        if (isRelative) return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {}
    return void 0;
}
function $0c1b93525a804899$export$5339fcdc8e2a427c(url) {
    if ($0c1b93525a804899$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function $0c1b93525a804899$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? "GET";
    const route = routeName ? routeName : urlObject ? kind === "client" ? $0c1b93525a804899$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : "/";
    return `${method} ${route}`;
}
function $0c1b93525a804899$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: spanOrigin,
        [(0, $f337c80285f06f80$export$d7a7d984b0791405)]: "url"
    };
    if (routeName) {
        attributes[kind === "server" ? "http.route" : "url.template"] = routeName;
        attributes[0, $f337c80285f06f80$export$d7a7d984b0791405] = "route";
    }
    if (request?.method) attributes[0, $f337c80285f06f80$export$be7a251980e7e946] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes["url.query"] = urlObject.search;
        if (urlObject.hash) attributes["url.fragment"] = urlObject.hash;
        if (urlObject.pathname) {
            attributes["url.path"] = urlObject.pathname;
            if (urlObject.pathname === "/") attributes[0, $f337c80285f06f80$export$d7a7d984b0791405] = "route";
        }
        if (!$0c1b93525a804899$export$e258e13805402ba7(urlObject)) {
            attributes[0, $3tmPs.URL_FULL] = urlObject.href;
            if (urlObject.port) attributes["url.port"] = urlObject.port;
            if (urlObject.protocol) attributes["url.scheme"] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
        }
    }
    return [
        $0c1b93525a804899$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
function $0c1b93525a804899$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
function $0c1b93525a804899$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
function $0c1b93525a804899$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}
function $0c1b93525a804899$export$8abd806fcaf234fa(url, includeDataPrefix = true) {
    if (url.startsWith("data:")) {
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : "text/plain";
        const isBase64 = url.includes(";base64,");
        const dataStart = url.indexOf(",");
        let dataPrefix = "";
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
    }
    return url;
}


function $7b9954de727fbe52$export$d92e61f5600202af(url, client) {
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    return $7b9954de727fbe52$var$checkDsn(url, dsn) || $7b9954de727fbe52$var$checkTunnel(url, tunnel);
}
function $7b9954de727fbe52$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $7b9954de727fbe52$var$removeTrailingSlash(url) === $7b9954de727fbe52$var$removeTrailingSlash(tunnel);
}
function $7b9954de727fbe52$var$checkDsn(url, dsn) {
    const urlParts = (0, $0c1b93525a804899$export$2004d912a9ead694)(url);
    if (!urlParts || (0, $0c1b93525a804899$export$e258e13805402ba7)(urlParts)) return false;
    if (!dsn) return false;
    return $7b9954de727fbe52$var$hostnameMatchesDsnHost(urlParts.hostname, dsn.host) && /(^|&|\?)sentry_key=/.test(urlParts.search);
}
function $7b9954de727fbe52$var$hostnameMatchesDsnHost(hostname, dsnHost) {
    return hostname === dsnHost || dsnHost.length > 0 && hostname.endsWith(`.${dsnHost}`);
}
function $7b9954de727fbe52$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}






function $97e289d5898f298e$export$d3f49b33a1f44720(callback) {
    (0, $269eeb69635ed414$export$e73679ffaf56810e)(callback, "_streamed", true);
    return callback;
}
function $97e289d5898f298e$export$ca3e1ec3cdcc76ac(callback) {
    return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
}


function $ab8578e6af215e2b$export$3f58558cf4af9c09(contexts) {
    const attrs = {};
    const { response: response, profile: profile, cloud_resource: cloud_resource, culture: culture, state: state } = contexts;
    if (response) {
        if (response.status_code != null) attrs["http.response.status_code"] = response.status_code;
        if (response.body_size != null) attrs["http.response.body.size"] = response.body_size;
    }
    if (profile) {
        if (profile.profile_id) attrs["sentry.profile_id"] = profile.profile_id;
        if (profile.profiler_id) attrs["sentry.profiler_id"] = profile.profiler_id;
    }
    if (cloud_resource) {
        for (const [key, value] of Object.entries(cloud_resource))if (value != null) attrs[key] = value;
    }
    if (culture) {
        if (culture.locale) attrs["culture.locale"] = culture.locale;
        if (culture.timezone) attrs["culture.timezone"] = culture.timezone;
    }
    if (state?.state && typeof state.state.type === "string") attrs["state.type"] = state.state.type;
    const angular = contexts["angular"];
    if (angular) {
        const version = angular["version"];
        if (typeof version === "string" || typeof version === "number") attrs["angular.version"] = version;
    }
    const react = contexts["react"];
    if (react) {
        const version = react["version"];
        if (typeof version === "string" || typeof version === "number") attrs["react.version"] = version;
    }
    return attrs;
}




var $3tmPs = parcelRequire("3tmPs");
function $0166effaf29dbd15$export$b1e72a433efdc918(span, client) {
    const spanJSON = (0, $bb9b6447bf4caedb$export$db0cad9e44f67af8)(span);
    const segmentSpan = (0, $bb9b6447bf4caedb$export$7a3106f345d83bb6)(span);
    const serializedSegmentSpan = (0, $bb9b6447bf4caedb$export$db0cad9e44f67af8)(segmentSpan);
    const { isolationScope: spanIsolationScope, scope: spanScope } = (0, $e54da191c628b5f0$export$c08fbc656a245d03)(span);
    const finalScopeData = (0, $9a2c488a2b943a4e$export$cc422922fcbb91c6)(spanIsolationScope, spanScope);
    $0166effaf29dbd15$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, finalScopeData);
    const spanKind = span.kind;
    client.emit("preprocessSpan", spanJSON, {
        spanKind: spanKind
    });
    if (spanJSON.is_segment) {
        $0166effaf29dbd15$var$applyScopeToSegmentSpan(spanJSON, finalScopeData);
        $0166effaf29dbd15$var$applySdkMetadataToSegmentSpan(spanJSON, client);
        client.emit("processSegmentSpan", spanJSON);
    }
    client.emit("processSpan", spanJSON);
    const { beforeSendSpan: beforeSendSpan } = client.getOptions();
    const processedSpan = beforeSendSpan && (0, $97e289d5898f298e$export$ca3e1ec3cdcc76ac)(beforeSendSpan) ? $0166effaf29dbd15$export$d38dd0f511e8d9ba(spanJSON, beforeSendSpan) : spanJSON;
    const spanNameSource = processedSpan.attributes?.[0, $f337c80285f06f80$export$d7a7d984b0791405];
    if (spanJSON.is_segment && spanNameSource) $0166effaf29dbd15$export$146fcadff0eefcf3(processedSpan, {
        ["sentry.segment.name.source"]: spanNameSource
    });
    return {
        ...(0, $bb9b6447bf4caedb$export$5402aa553bcf35f3)(processedSpan),
        _segmentSpan: segmentSpan
    };
}
function $0166effaf29dbd15$var$applyScopeToSegmentSpan(segmentSpanJSON, scopeData) {
    const contextAttributes = (0, $ab8578e6af215e2b$export$3f58558cf4af9c09)(scopeData.contexts);
    $0166effaf29dbd15$export$146fcadff0eefcf3(segmentSpanJSON, contextAttributes);
}
function $0166effaf29dbd15$export$146fcadff0eefcf3(spanJSON, newAttributes) {
    const originalAttributes = spanJSON.attributes ?? (spanJSON.attributes = {});
    Object.entries(newAttributes).forEach(([key, value])=>{
        if (value != null && !(key in originalAttributes)) originalAttributes[key] = value;
    });
}
function $0166effaf29dbd15$var$applySdkMetadataToSegmentSpan(segmentSpanJSON, client) {
    const integrationNames = client.getIntegrationNames();
    if (!integrationNames.length) return;
    $0166effaf29dbd15$export$146fcadff0eefcf3(segmentSpanJSON, {
        [(0, $f337c80285f06f80$export$bd847b1cc92ae587)]: integrationNames
    });
}
function $0166effaf29dbd15$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, scopeData) {
    const sdk = client.getSdkMetadata();
    const { release: release, environment: environment } = client.getOptions();
    $0166effaf29dbd15$export$146fcadff0eefcf3(spanJSON, {
        [(0, $3tmPs.SENTRY_TRACE_LIFECYCLE)]: "stream",
        [(0, $3tmPs.SENTRY_SEGMENT_NAME)]: serializedSegmentSpan.name,
        [(0, $3tmPs.SENTRY_SEGMENT_ID)]: serializedSegmentSpan.span_id,
        [(0, $3tmPs.SENTRY_SDK_NAME)]: sdk?.sdk?.name,
        [(0, $3tmPs.SENTRY_SDK_VERSION)]: sdk?.sdk?.version,
        [(0, $f337c80285f06f80$export$f5cefb258679b29e)]: release,
        [(0, $f337c80285f06f80$export$d1b1dbb47f5ba57c)]: environment || (0, $4e93b773a0d3a86a$export$849dbeeeda01ae98),
        [(0, $f337c80285f06f80$export$1f9cc1d34ea098a0)]: scopeData.user?.id,
        [(0, $f337c80285f06f80$export$b7466609ef46c07e)]: scopeData.user?.email,
        [(0, $f337c80285f06f80$export$8d592bdaea63b930)]: scopeData.user?.ip_address,
        [(0, $f337c80285f06f80$export$c05ee933d3f74b2b)]: scopeData.user?.username,
        ...scopeData.attributes
    });
}
function $0166effaf29dbd15$export$d38dd0f511e8d9ba(span, beforeSendSpan) {
    const modifedSpan = beforeSendSpan(span);
    if (!modifedSpan) {
        (0, $bb9b6447bf4caedb$export$d11691ff45a3e535)();
        return span;
    }
    return modifedSpan;
}

function $9e4658f0600c3fda$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}





const $e9a2550a8f0d4f81$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return "poor";
    if (value > thresholds[0]) return "needs-improvement";
    return "good";
};
const $e9a2550a8f0d4f81$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue ?? 0);
                if (delta || prevValue === void 0) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $e9a2550a8f0d4f81$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};




const $173177c362404304$export$6431553786c94949 = (checkResponseStart = true)=>{
    const navigationEntry = (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).performance?.getEntriesByType?.("navigation")[0];
    if (// sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) return navigationEntry;
};


const $b9e806a0f3ff4e89$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $173177c362404304$export$6431553786c94949)();
    return navEntry?.activationStart ?? 0;
};



let $e86be68ef7ac046f$var$firstHiddenTime = -1;
const $e86be68ef7ac046f$var$onHiddenFunctions = /* @__PURE__ */ new Set();
const $e86be68ef7ac046f$var$initHiddenTime = ()=>{
    return (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).document?.visibilityState === "hidden" && !(0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).document?.prerendering ? 0 : Infinity;
};
const $e86be68ef7ac046f$var$onVisibilityUpdate = (event)=>{
    if ($e86be68ef7ac046f$var$isPageHidden(event) && $e86be68ef7ac046f$var$firstHiddenTime > -1) {
        if (event.type === "visibilitychange" || event.type === "pagehide") for (const onHiddenFunction of $e86be68ef7ac046f$var$onHiddenFunctions)onHiddenFunction();
        if (!isFinite($e86be68ef7ac046f$var$firstHiddenTime)) {
            $e86be68ef7ac046f$var$firstHiddenTime = event.type === "visibilitychange" ? event.timeStamp : 0;
            (0, $cc264900893ba744$export$324d7b4b46528191)("prerenderingchange", $e86be68ef7ac046f$var$onVisibilityUpdate, true);
        }
    }
};
const $e86be68ef7ac046f$export$443f86b2c77012c4 = ()=>{
    if ((0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).document && $e86be68ef7ac046f$var$firstHiddenTime < 0) {
        const activationStart = (0, $b9e806a0f3ff4e89$export$d3e828b3c7b5b845)();
        const firstVisibilityStateHiddenTime = !(0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).document.prerendering ? globalThis.performance.getEntriesByType("visibility-state").filter((e)=>e.name === "hidden" && e.startTime > activationStart)[0]?.startTime : void 0;
        $e86be68ef7ac046f$var$firstHiddenTime = firstVisibilityStateHiddenTime ?? $e86be68ef7ac046f$var$initHiddenTime();
        (0, $cc264900893ba744$export$26d3d892edc56833)("visibilitychange", $e86be68ef7ac046f$var$onVisibilityUpdate, true);
        (0, $cc264900893ba744$export$26d3d892edc56833)("pagehide", $e86be68ef7ac046f$var$onVisibilityUpdate, true);
        (0, $cc264900893ba744$export$26d3d892edc56833)("prerenderingchange", $e86be68ef7ac046f$var$onVisibilityUpdate, true);
    }
    return {
        get firstHiddenTime () {
            return $e86be68ef7ac046f$var$firstHiddenTime;
        },
        onHidden (cb) {
            $e86be68ef7ac046f$var$onHiddenFunctions.add(cb);
        }
    };
};
function $e86be68ef7ac046f$var$isPageHidden(event) {
    return event.type === "pagehide" || (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).document?.visibilityState === "hidden";
}



const $f6985035f2d3629c$export$407ea409d1f3b539 = ()=>{
    return `v5-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};




const $012da07be07a38d8$export$3c29b44508a0612b = (name, value = -1)=>{
    const navEntry = (0, $173177c362404304$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).document?.prerendering || (0, $b9e806a0f3ff4e89$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else if ((0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).document?.wasDiscarded) navigationType = "restore";
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, "-");
    }
    const entries = [];
    return {
        name: name,
        value: value,
        rating: "good",
        // If needed, will be updated when reported. `const` to keep the type from widening to `string`.
        delta: 0,
        entries: entries,
        id: (0, $f6985035f2d3629c$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


const $2784b657b9919f48$var$instanceMap = /* @__PURE__ */ new WeakMap();
function $2784b657b9919f48$export$7c74c9b2462ddb3c(identityObj, ClassObj) {
    try {
        if (!$2784b657b9919f48$var$instanceMap.get(identityObj)) $2784b657b9919f48$var$instanceMap.set(identityObj, new ClassObj());
        return $2784b657b9919f48$var$instanceMap.get(identityObj);
    } catch (_e) {
        return new ClassObj();
    }
}


class $f58b5ec355d47dc5$export$4050f7f955e19aa0 {
    constructor(){
        // oxlint-disable-next-line sdk/no-class-field-initializers
        this._sessionValue = 0;
        // oxlint-disable-next-line sdk/no-class-field-initializers
        this._sessionEntries = [];
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        if (entry.hadRecentInput) return;
        const firstSessionEntry = this._sessionEntries[0];
        const lastSessionEntry = this._sessionEntries[this._sessionEntries.length - 1];
        if (this._sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1e3 && entry.startTime - firstSessionEntry.startTime < 5e3) {
            this._sessionValue += entry.value;
            this._sessionEntries.push(entry);
        } else {
            this._sessionValue = entry.value;
            this._sessionEntries = [
                entry
            ];
        }
        this._onAfterProcessingUnexpectedShift?.(entry);
    }
}


const $486e29bedb0c69cc$export$d1203567a167490e = (type, callback, opts = {})=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe({
                type: type,
                buffered: true,
                ...opts
            });
            return po;
        }
    } catch  {}
    return;
};









const $24a5c8b7747318e3$export$8bdb38a5671b594e = (callback)=>{
    if ((0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).document?.prerendering) addEventListener("prerenderingchange", ()=>callback(), true);
    else callback();
};


const $747f422a9197db0a$export$e610c735b5510cec = [
    1800,
    3e3
];
const $747f422a9197db0a$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $24a5c8b7747318e3$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $e86be68ef7ac046f$export$443f86b2c77012c4)();
        const metric = (0, $012da07be07a38d8$export$3c29b44508a0612b)("FCP");
        let report;
        const handleEntries = (entries)=>{
            for (const entry of entries)if (entry.name === "first-contentful-paint") {
                po.disconnect();
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    metric.value = Math.max(entry.startTime - (0, $b9e806a0f3ff4e89$export$d3e828b3c7b5b845)(), 0);
                    metric.entries.push(entry);
                    report(true);
                }
            }
        };
        const po = (0, $486e29bedb0c69cc$export$d1203567a167490e)("paint", handleEntries);
        if (po) report = (0, $e9a2550a8f0d4f81$export$17679dccdd551979)(onReport, metric, $747f422a9197db0a$export$e610c735b5510cec, opts.reportAllChanges);
    });
};


const $d933cfe709470dde$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
const $d933cfe709470dde$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    (0, $747f422a9197db0a$export$fe3c86b74e15d5de)((0, $b94dc5030064c817$export$b841d51e31c12bab)(()=>{
        const metric = (0, $012da07be07a38d8$export$3c29b44508a0612b)("CLS", 0);
        let report;
        const visibilityWatcher = (0, $e86be68ef7ac046f$export$443f86b2c77012c4)();
        const layoutShiftManager = (0, $2784b657b9919f48$export$7c74c9b2462ddb3c)(opts, (0, $f58b5ec355d47dc5$export$4050f7f955e19aa0));
        const handleEntries = (entries)=>{
            for (const entry of entries)layoutShiftManager._processEntry(entry);
            if (layoutShiftManager._sessionValue > metric.value) {
                metric.value = layoutShiftManager._sessionValue;
                metric.entries = layoutShiftManager._sessionEntries;
                report();
            }
        };
        const po = (0, $486e29bedb0c69cc$export$d1203567a167490e)("layout-shift", handleEntries);
        if (po) {
            report = (0, $e9a2550a8f0d4f81$export$17679dccdd551979)(onReport, metric, $d933cfe709470dde$export$3f20d8e089ac35b2, opts.reportAllChanges);
            visibilityWatcher.onHidden(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
            (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81)?.setTimeout?.(report);
        }
    }));
};







let $512634349e198dae$var$interactionCountEstimate = 0;
let $512634349e198dae$var$minKnownInteractionId = Infinity;
let $512634349e198dae$var$maxKnownInteractionId = 0;
const $512634349e198dae$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $512634349e198dae$var$minKnownInteractionId = Math.min($512634349e198dae$var$minKnownInteractionId, e.interactionId);
            $512634349e198dae$var$maxKnownInteractionId = Math.max($512634349e198dae$var$maxKnownInteractionId, e.interactionId);
            $512634349e198dae$var$interactionCountEstimate = $512634349e198dae$var$maxKnownInteractionId ? ($512634349e198dae$var$maxKnownInteractionId - $512634349e198dae$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $512634349e198dae$var$po;
const $512634349e198dae$export$8a962f2683a476d1 = ()=>{
    return $512634349e198dae$var$po ? $512634349e198dae$var$interactionCountEstimate : performance.interactionCount || 0;
};
const $512634349e198dae$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $512634349e198dae$var$po) return;
    $512634349e198dae$var$po = (0, $486e29bedb0c69cc$export$d1203567a167490e)("event", $512634349e198dae$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};


const $61c483e428d68fcd$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
let $61c483e428d68fcd$var$prevInteractionCount = 0;
const $61c483e428d68fcd$var$getInteractionCountForNavigation = ()=>{
    return (0, $512634349e198dae$export$8a962f2683a476d1)() - $61c483e428d68fcd$var$prevInteractionCount;
};
class $61c483e428d68fcd$export$aaa80641d584351c {
    constructor(){
        /**
     * A list of longest interactions on the page (by latency) sorted so the
     * longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER
     * long.
     */ // oxlint-disable-next-line sdk/no-class-field-initializers
        this._longestInteractionList = [];
        /**
     * A mapping of longest interactions by their interaction ID.
     * This is used for faster lookup.
     */ // oxlint-disable-next-line sdk/no-class-field-initializers
        this._longestInteractionMap = /* @__PURE__ */ new Map();
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _resetInteractions() {
        $61c483e428d68fcd$var$prevInteractionCount = (0, $512634349e198dae$export$8a962f2683a476d1)();
        this._longestInteractionList.length = 0;
        this._longestInteractionMap.clear();
    }
    /**
   * Returns the estimated p98 longest interaction based on the stored
   * interaction candidates and the interaction count for the current page.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _estimateP98LongestInteraction() {
        const candidateInteractionIndex = Math.min(this._longestInteractionList.length - 1, Math.floor($61c483e428d68fcd$var$getInteractionCountForNavigation() / 50));
        return this._longestInteractionList[candidateInteractionIndex];
    }
    /**
   * Takes a performance entry and adds it to the list of worst interactions
   * if its duration is long enough to make it among the worst. If the
   * entry is part of an existing interaction, it is merged and the latency
   * and entries list is updated as needed.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        this._onBeforeProcessingEntry?.(entry);
        if (!(entry.interactionId || entry.entryType === "first-input")) return;
        const minLongestInteraction = this._longestInteractionList.at(-1);
        let interaction = this._longestInteractionMap.get(entry.interactionId);
        if (interaction || this._longestInteractionList.length < $61c483e428d68fcd$var$MAX_INTERACTIONS_TO_CONSIDER || // If the above conditions are false, `minLongestInteraction` will be set.
        entry.duration > minLongestInteraction._latency) {
            if (interaction) {
                if (entry.duration > interaction._latency) {
                    interaction.entries = [
                        entry
                    ];
                    interaction._latency = entry.duration;
                } else if (entry.duration === interaction._latency && entry.startTime === interaction.entries[0].startTime) interaction.entries.push(entry);
            } else {
                interaction = {
                    id: entry.interactionId,
                    entries: [
                        entry
                    ],
                    _latency: entry.duration
                };
                this._longestInteractionMap.set(interaction.id, interaction);
                this._longestInteractionList.push(interaction);
            }
            this._longestInteractionList.sort((a, b)=>b._latency - a._latency);
            if (this._longestInteractionList.length > $61c483e428d68fcd$var$MAX_INTERACTIONS_TO_CONSIDER) {
                const removedInteractions = this._longestInteractionList.splice($61c483e428d68fcd$var$MAX_INTERACTIONS_TO_CONSIDER);
                for (const interaction2 of removedInteractions)this._longestInteractionMap.delete(interaction2.id);
            }
            this._onAfterProcessingINPCandidate?.(interaction);
        }
    }
}






const $dade83ff6ab10d3c$export$7f4cb060ded9173c = [
    200,
    500
];
const $dade83ff6ab10d3c$var$DEFAULT_DURATION_THRESHOLD = 40;
const $dade83ff6ab10d3c$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    if (!(globalThis.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype)) return;
    const visibilityWatcher = (0, $e86be68ef7ac046f$export$443f86b2c77012c4)();
    (0, $24a5c8b7747318e3$export$8bdb38a5671b594e)(()=>{
        (0, $512634349e198dae$export$67d90cda6b78a2eb)();
        const metric = (0, $012da07be07a38d8$export$3c29b44508a0612b)("INP");
        let report;
        const interactionManager = (0, $2784b657b9919f48$export$7c74c9b2462ddb3c)(opts, (0, $61c483e428d68fcd$export$aaa80641d584351c));
        const handleEntries = (entries)=>{
            (0, $da71ce648565add7$export$d3314d5863fc1fef)(()=>{
                for (const entry of entries)interactionManager._processEntry(entry);
                const inp = interactionManager._estimateP98LongestInteraction();
                if (inp && inp._latency !== metric.value) {
                    metric.value = inp._latency;
                    metric.entries = inp.entries;
                    report();
                }
            });
        };
        const po = (0, $486e29bedb0c69cc$export$d1203567a167490e)("event", handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: opts.durationThreshold ?? $dade83ff6ab10d3c$var$DEFAULT_DURATION_THRESHOLD
        });
        report = (0, $e9a2550a8f0d4f81$export$17679dccdd551979)(onReport, metric, $dade83ff6ab10d3c$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            po.observe({
                type: "first-input",
                buffered: true
            });
            visibilityWatcher.onHidden(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
        }
    });
};








class $a4d8d59f07c321f9$export$6a641ef2a067ec62 {
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _processEntry(entry) {
        this._onBeforeProcessingEntry?.(entry);
    }
}






const $4d7f6e46e3af0e33$export$948521ca5b0e1b17 = [
    2500,
    4e3
];
const $4d7f6e46e3af0e33$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $24a5c8b7747318e3$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $e86be68ef7ac046f$export$443f86b2c77012c4)();
        const metric = (0, $012da07be07a38d8$export$3c29b44508a0612b)("LCP");
        let report;
        const lcpEntryManager = (0, $2784b657b9919f48$export$7c74c9b2462ddb3c)(opts, (0, $a4d8d59f07c321f9$export$6a641ef2a067ec62));
        const handleEntries = (entries)=>{
            if (!opts.reportAllChanges) entries = entries.slice(-1);
            for (const entry of entries){
                if (!entry) continue;
                lcpEntryManager._processEntry(entry);
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    metric.value = Math.max(entry.startTime - (0, $b9e806a0f3ff4e89$export$d3e828b3c7b5b845)(), 0);
                    metric.entries = [
                        entry
                    ];
                    report();
                }
            }
        };
        const po = (0, $486e29bedb0c69cc$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
        if (po) {
            report = (0, $e9a2550a8f0d4f81$export$17679dccdd551979)(onReport, metric, $4d7f6e46e3af0e33$export$948521ca5b0e1b17, opts.reportAllChanges);
            const stopListening = (0, $b94dc5030064c817$export$b841d51e31c12bab)(()=>{
                handleEntries(po.takeRecords());
                po.disconnect();
                report(true);
            });
            const stopListeningWrapper = (event)=>{
                if (event.isTrusted) {
                    (0, $da71ce648565add7$export$d3314d5863fc1fef)(stopListening);
                    (0, $cc264900893ba744$export$324d7b4b46528191)(event.type, stopListeningWrapper, {
                        capture: true
                    });
                }
            };
            for (const type of [
                "keydown",
                "click",
                "visibilitychange"
            ])(0, $cc264900893ba744$export$26d3d892edc56833)(type, stopListeningWrapper, {
                capture: true
            });
        }
    });
};









const $a63ea59fe0cc6e3e$export$65c59ea8064668fc = [
    800,
    1800
];
const $a63ea59fe0cc6e3e$var$whenReady = (callback)=>{
    if ((0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).document?.prerendering) (0, $24a5c8b7747318e3$export$8bdb38a5671b594e)(()=>$a63ea59fe0cc6e3e$var$whenReady(callback));
    else if ((0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).document?.readyState !== "complete") addEventListener("load", ()=>$a63ea59fe0cc6e3e$var$whenReady(callback), true);
    else setTimeout(callback);
};
const $a63ea59fe0cc6e3e$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $012da07be07a38d8$export$3c29b44508a0612b)("TTFB");
    const report = (0, $e9a2550a8f0d4f81$export$17679dccdd551979)(onReport, metric, $a63ea59fe0cc6e3e$export$65c59ea8064668fc, opts.reportAllChanges);
    $a63ea59fe0cc6e3e$var$whenReady(()=>{
        const navigationEntry = (0, $173177c362404304$export$6431553786c94949)();
        if (navigationEntry) {
            metric.value = Math.max(navigationEntry.responseStart - (0, $b9e806a0f3ff4e89$export$d3e828b3c7b5b845)(), 0);
            metric.entries = [
                navigationEntry
            ];
            report(true);
        }
    });
};


const $375623e17d0e1d27$var$handlers = {};
const $375623e17d0e1d27$var$instrumented = {};
let $375623e17d0e1d27$var$_previousCls;
let $375623e17d0e1d27$var$_previousLcp;
let $375623e17d0e1d27$var$_previousTtfb;
let $375623e17d0e1d27$var$_previousInp;
function $375623e17d0e1d27$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $375623e17d0e1d27$var$addMetricObserver("cls", callback, $375623e17d0e1d27$var$instrumentCls, $375623e17d0e1d27$var$_previousCls, stopOnCallback);
}
function $375623e17d0e1d27$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $375623e17d0e1d27$var$addMetricObserver("lcp", callback, $375623e17d0e1d27$var$instrumentLcp, $375623e17d0e1d27$var$_previousLcp, stopOnCallback);
}
function $375623e17d0e1d27$export$699d9529c099a797(callback) {
    return $375623e17d0e1d27$var$addMetricObserver("ttfb", callback, $375623e17d0e1d27$var$instrumentTtfb, $375623e17d0e1d27$var$_previousTtfb);
}
function $375623e17d0e1d27$export$da3b76aa2022cbd7(callback) {
    return $375623e17d0e1d27$var$addMetricObserver("inp", callback, $375623e17d0e1d27$var$instrumentInp, $375623e17d0e1d27$var$_previousInp);
}
function $375623e17d0e1d27$export$69816c1a049f8db6(type, callback) {
    $375623e17d0e1d27$var$addHandler(type, callback);
    if (!$375623e17d0e1d27$var$instrumented[type]) {
        $375623e17d0e1d27$var$instrumentPerformanceObserver(type);
        $375623e17d0e1d27$var$instrumented[type] = true;
    }
    return $375623e17d0e1d27$var$getCleanupCallback(type, callback);
}
function $375623e17d0e1d27$var$triggerHandlers(type, data) {
    const typeHandlers = $375623e17d0e1d27$var$handlers[type];
    if (!typeHandlers?.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $c54a9ced88c7488b$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${(0, $9ed2cf4edd0b2db9$export$aad197c7121a6651)(handler)}
Error:`, e);
    }
}
function $375623e17d0e1d27$var$instrumentCls() {
    return (0, $d933cfe709470dde$export$a7873055838e5ad8)((metric)=>{
        $375623e17d0e1d27$var$triggerHandlers("cls", {
            metric: metric
        });
        $375623e17d0e1d27$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $375623e17d0e1d27$var$instrumentLcp() {
    return (0, $4d7f6e46e3af0e33$export$947b1626ab8d5632)((metric)=>{
        $375623e17d0e1d27$var$triggerHandlers("lcp", {
            metric: metric
        });
        $375623e17d0e1d27$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $375623e17d0e1d27$var$instrumentTtfb() {
    return (0, $a63ea59fe0cc6e3e$export$33a01e6c5f2c7e33)((metric)=>{
        $375623e17d0e1d27$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $375623e17d0e1d27$var$_previousTtfb = metric;
    });
}
function $375623e17d0e1d27$var$instrumentInp() {
    return (0, $dade83ff6ab10d3c$export$7df4b36ecaed99e1)((metric)=>{
        $375623e17d0e1d27$var$triggerHandlers("inp", {
            metric: metric
        });
        $375623e17d0e1d27$var$_previousInp = metric;
    });
}
function $375623e17d0e1d27$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $375623e17d0e1d27$var$addHandler(type, callback);
    let stopListening;
    if (!$375623e17d0e1d27$var$instrumented[type]) {
        stopListening = instrumentFn();
        $375623e17d0e1d27$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $375623e17d0e1d27$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : void 0);
}
function $375623e17d0e1d27$var$instrumentPerformanceObserver(type) {
    const options = {};
    if (type === "event") options.durationThreshold = 0;
    (0, $486e29bedb0c69cc$export$d1203567a167490e)(type, (entries)=>{
        $375623e17d0e1d27$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $375623e17d0e1d27$var$addHandler(type, handler) {
    $375623e17d0e1d27$var$handlers[type] = $375623e17d0e1d27$var$handlers[type] || [];
    $375623e17d0e1d27$var$handlers[type].push(handler);
}
function $375623e17d0e1d27$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $375623e17d0e1d27$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
function $375623e17d0e1d27$export$7affb50b622d8714(entry) {
    return "duration" in entry;
}


const $37d5a74137b0c6f7$var$WINDOW = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1);
const $37d5a74137b0c6f7$var$REPLAY_SESSION_KEY = "sentryReplaySession";
const $37d5a74137b0c6f7$var$REPLAY_EVENT_NAME = "replay_event";
const $37d5a74137b0c6f7$var$UNABLE_TO_SEND_REPLAY = "Unable to send Replay";
const $37d5a74137b0c6f7$var$SESSION_IDLE_PAUSE_DURATION = 3e5;
const $37d5a74137b0c6f7$var$SESSION_IDLE_EXPIRE_DURATION = 9e5;
const $37d5a74137b0c6f7$var$DEFAULT_FLUSH_MIN_DELAY = 5e3;
const $37d5a74137b0c6f7$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
const $37d5a74137b0c6f7$var$BUFFER_CHECKOUT_TIME = 6e4;
const $37d5a74137b0c6f7$var$RETRY_BASE_INTERVAL = 5e3;
const $37d5a74137b0c6f7$var$RETRY_MAX_COUNT = 3;
const $37d5a74137b0c6f7$var$NETWORK_BODY_MAX_SIZE = 15e4;
const $37d5a74137b0c6f7$var$CONSOLE_ARG_MAX_SIZE = 5e3;
const $37d5a74137b0c6f7$var$SLOW_CLICK_THRESHOLD = 3e3;
const $37d5a74137b0c6f7$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
const $37d5a74137b0c6f7$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 2e7;
const $37d5a74137b0c6f7$var$MIN_REPLAY_DURATION = 4999;
const $37d5a74137b0c6f7$var$MIN_REPLAY_DURATION_LIMIT = 5e4;
const $37d5a74137b0c6f7$var$MAX_REPLAY_DURATION = 36e5;
var $37d5a74137b0c6f7$var$__defProp = Object.defineProperty;
var $37d5a74137b0c6f7$var$__defNormalProp = (obj, key, value)=>key in obj ? $37d5a74137b0c6f7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $37d5a74137b0c6f7$var$__publicField = (obj, key, value)=>$37d5a74137b0c6f7$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var $37d5a74137b0c6f7$var$NodeType$1 = /* @__PURE__ */ ((NodeType2)=>{
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
})($37d5a74137b0c6f7$var$NodeType$1 || {});
function $37d5a74137b0c6f7$var$isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $37d5a74137b0c6f7$var$isShadowRoot(n) {
    const host = n?.host;
    return Boolean(host?.shadowRoot === n);
}
function $37d5a74137b0c6f7$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === "[object ShadowRoot]";
}
function $37d5a74137b0c6f7$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(/\sbackground-clip:\s*text;/g, " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $37d5a74137b0c6f7$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        "@import",
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === "") statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(" ") + ";";
}
function $37d5a74137b0c6f7$var$stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? $37d5a74137b0c6f7$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $37d5a74137b0c6f7$var$stringifyRule).join("")) : null;
    } catch (error) {
        return null;
    }
}
function $37d5a74137b0c6f7$var$fixAllCssProperty(rule) {
    let styles = "";
    for(let i2 = 0; i2 < rule.style.length; i2++){
        const styleDeclaration = rule.style;
        const attribute = styleDeclaration[i2];
        const isImportant = styleDeclaration.getPropertyPriority(attribute);
        styles += `${attribute}:${styleDeclaration.getPropertyValue(attribute)}${isImportant ? ` !important` : ""};`;
    }
    return `${rule.selectorText} { ${styles} }`;
}
function $37d5a74137b0c6f7$var$stringifyRule(rule) {
    let importStringified;
    if ($37d5a74137b0c6f7$var$isCSSImportRule(rule)) try {
        importStringified = // we can access the imported stylesheet rules directly
        $37d5a74137b0c6f7$var$stringifyStylesheet(rule.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
        $37d5a74137b0c6f7$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($37d5a74137b0c6f7$var$isCSSStyleRule(rule)) {
        let cssText = rule.cssText;
        const needsSafariColonFix = rule.selectorText.includes(":");
        const needsAllFix = typeof rule.style["all"] === "string" && rule.style["all"];
        if (needsAllFix) cssText = $37d5a74137b0c6f7$var$fixAllCssProperty(rule);
        if (needsSafariColonFix) cssText = $37d5a74137b0c6f7$var$fixSafariColons(cssText);
        if (needsSafariColonFix || needsAllFix) return cssText;
    }
    return importStringified || rule.cssText;
}
function $37d5a74137b0c6f7$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $37d5a74137b0c6f7$var$isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function $37d5a74137b0c6f7$var$isCSSStyleRule(rule) {
    return "selectorText" in rule;
}
class $37d5a74137b0c6f7$var$Mirror {
    constructor(){
        $37d5a74137b0c6f7$var$__publicField(this, "idNodeMap", /* @__PURE__ */ new Map());
        $37d5a74137b0c6f7$var$__publicField(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
    getId(n) {
        if (!n) return -1;
        const id = this.getMeta(n)?.id;
        return id ?? -1;
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    // removes the node from idNodeMap
    // doesn't remove the node from nodeMetaMap
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = /* @__PURE__ */ new Map();
        this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
    }
}
function $37d5a74137b0c6f7$var$createMirror() {
    return new $37d5a74137b0c6f7$var$Mirror();
}
function $37d5a74137b0c6f7$var$shouldMaskInput({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName === "OPTION") tagName = "SELECT";
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === "password" || // Default to "text" option for inputs without a "type" attribute defined
    tagName === "INPUT" && !type && maskInputOptions["text"]);
}
function $37d5a74137b0c6f7$var$maskInputValue({ isMasked: isMasked, element: element, value: value, maskInputFn: maskInputFn }) {
    let text = value || "";
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return "*".repeat(text.length);
}
function $37d5a74137b0c6f7$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $37d5a74137b0c6f7$var$toUpperCase(str) {
    return str.toUpperCase();
}
const $37d5a74137b0c6f7$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $37d5a74137b0c6f7$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $37d5a74137b0c6f7$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$37d5a74137b0c6f7$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(// eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $37d5a74137b0c6f7$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    $37d5a74137b0c6f7$var$toLowerCase(type) : null;
}
function $37d5a74137b0c6f7$var$getInputValue(el, tagName, type) {
    if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) return el.getAttribute("value") || "";
    return el.value;
}
function $37d5a74137b0c6f7$var$extractFileExtension(path, baseURL) {
    let url;
    try {
        url = new URL(path, baseURL ?? window.location.href);
    } catch (err) {
        return null;
    }
    const regex = /\.([0-9a-z]+)(?:$)/i;
    const match = url.pathname.match(regex);
    return match?.[1] ?? null;
}
const $37d5a74137b0c6f7$var$cachedImplementations$1 = {};
function $37d5a74137b0c6f7$var$getImplementation$1(name) {
    const cached = $37d5a74137b0c6f7$var$cachedImplementations$1[name];
    if (cached) return cached;
    const document2 = window.document;
    let impl = window[name];
    if (document2 && typeof document2.createElement === "function") try {
        const sandbox = document2.createElement("iframe");
        sandbox.hidden = true;
        document2.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document2.head.removeChild(sandbox);
    } catch (e) {}
    return $37d5a74137b0c6f7$var$cachedImplementations$1[name] = impl.bind(window);
}
function $37d5a74137b0c6f7$var$setTimeout$1(...rest) {
    return $37d5a74137b0c6f7$var$getImplementation$1("setTimeout")(...rest);
}
function $37d5a74137b0c6f7$var$clearTimeout$1(...rest) {
    return $37d5a74137b0c6f7$var$getImplementation$1("clearTimeout")(...rest);
}
function $37d5a74137b0c6f7$var$getIFrameContentDocument$1(iframe) {
    try {
        return iframe.contentDocument;
    } catch  {}
}
function $37d5a74137b0c6f7$var$getIFrameContentWindow$1(iframe) {
    try {
        return iframe.contentWindow;
    } catch  {}
}
let $37d5a74137b0c6f7$var$_id = 1;
const $37d5a74137b0c6f7$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
const $37d5a74137b0c6f7$var$IGNORED_NODE = -2;
function $37d5a74137b0c6f7$var$genId() {
    return $37d5a74137b0c6f7$var$_id++;
}
function $37d5a74137b0c6f7$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return "form";
    const processedTagName = $37d5a74137b0c6f7$var$toLowerCase(element.tagName);
    if ($37d5a74137b0c6f7$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
function $37d5a74137b0c6f7$var$extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
let $37d5a74137b0c6f7$var$canvasService;
let $37d5a74137b0c6f7$var$canvasCtx;
const $37d5a74137b0c6f7$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $37d5a74137b0c6f7$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $37d5a74137b0c6f7$var$URL_WWW_MATCH = /^www\..*/i;
const $37d5a74137b0c6f7$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $37d5a74137b0c6f7$var$filterCSSPropertiesFromInlineStyle(cssText, ignoredProperties) {
    if (!cssText || ignoredProperties.size === 0) return cssText;
    try {
        const properties = cssText.split(";");
        const filteredProperties = [];
        for (let property of properties){
            property = property.trim();
            if (!property) continue;
            const colonIndex = property.indexOf(":");
            if (colonIndex === -1) {
                filteredProperties.push(property);
                continue;
            }
            const propertyName = property.slice(0, colonIndex).trim();
            if (!ignoredProperties.has(propertyName)) filteredProperties.push(property);
        }
        return filteredProperties.join("; ") + (filteredProperties.length > 0 && cssText.endsWith(";") ? ";" : "");
    } catch (error) {
        console.warn("Error filtering CSS properties:", error);
        return cssText;
    }
}
function $37d5a74137b0c6f7$var$absoluteToStylesheet(cssText, href) {
    return (cssText || "").replace($37d5a74137b0c6f7$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($37d5a74137b0c6f7$var$URL_PROTOCOL_MATCH.test(filePath) || $37d5a74137b0c6f7$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($37d5a74137b0c6f7$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === "/") return `url(${maybeQuote}${$37d5a74137b0c6f7$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
const $37d5a74137b0c6f7$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $37d5a74137b0c6f7$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $37d5a74137b0c6f7$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars2;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars2 = match[0];
            pos += chars2.length;
            return chars2;
        }
        return "";
    }
    const output = [];
    while(true){
        collectCharacters($37d5a74137b0c6f7$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($37d5a74137b0c6f7$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $37d5a74137b0c6f7$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = $37d5a74137b0c6f7$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === "(") inParens = true;
                } else if (c === ")") inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
const $37d5a74137b0c6f7$var$cachedDocument = /* @__PURE__ */ new WeakMap();
function $37d5a74137b0c6f7$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    return $37d5a74137b0c6f7$var$getHref(doc, attributeValue);
}
function $37d5a74137b0c6f7$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $37d5a74137b0c6f7$var$getHref(doc, customHref) {
    let a = $37d5a74137b0c6f7$var$cachedDocument.get(doc);
    if (!a) {
        a = doc.createElement("a");
        $37d5a74137b0c6f7$var$cachedDocument.set(doc, a);
    }
    if (!customHref) customHref = "";
    else if (customHref.startsWith("blob:") || customHref.startsWith("data:")) return customHref;
    a.setAttribute("href", customHref);
    return a.href;
}
function $37d5a74137b0c6f7$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn, ignoreCSSAttributes) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $37d5a74137b0c6f7$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $37d5a74137b0c6f7$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $37d5a74137b0c6f7$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $37d5a74137b0c6f7$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") {
        let processedStyle = $37d5a74137b0c6f7$var$absoluteToStylesheet(value, $37d5a74137b0c6f7$var$getHref(doc));
        if (ignoreCSSAttributes && ignoreCSSAttributes.size > 0) processedStyle = $37d5a74137b0c6f7$var$filterCSSPropertiesFromInlineStyle(processedStyle, ignoreCSSAttributes);
        return processedStyle;
    } else if (tagName === "object" && name === "data") return $37d5a74137b0c6f7$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === "function") return maskAttributeFn(name, value, element);
    return value;
}
function $37d5a74137b0c6f7$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $37d5a74137b0c6f7$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $37d5a74137b0c6f7$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $37d5a74137b0c6f7$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $37d5a74137b0c6f7$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $37d5a74137b0c6f7$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if ($37d5a74137b0c6f7$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch  {
            return false;
        }
    };
}
function $37d5a74137b0c6f7$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === "INPUT") {
            const autocomplete = el.getAttribute("autocomplete");
            const disallowedAutocompleteValues = [
                "current-password",
                "new-password",
                "cc-number",
                "cc-exp",
                "cc-exp-month",
                "cc-exp-year",
                "cc-csc"
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $37d5a74137b0c6f7$var$distanceToMatch(el, $37d5a74137b0c6f7$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $37d5a74137b0c6f7$var$distanceToMatch(el, $37d5a74137b0c6f7$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $37d5a74137b0c6f7$var$distanceToMatch(el, $37d5a74137b0c6f7$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $37d5a74137b0c6f7$var$distanceToMatch(el, $37d5a74137b0c6f7$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e) {}
    return !!maskAllText;
}
function $37d5a74137b0c6f7$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = $37d5a74137b0c6f7$var$getIFrameContentWindow$1(iframeEl);
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = $37d5a74137b0c6f7$var$setTimeout$1(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            $37d5a74137b0c6f7$var$clearTimeout$1(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        $37d5a74137b0c6f7$var$setTimeout$1(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $37d5a74137b0c6f7$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        styleSheetLoaded = null;
    }
    if (styleSheetLoaded) return;
    const timer = $37d5a74137b0c6f7$var$setTimeout$1(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", ()=>{
        $37d5a74137b0c6f7$var$clearTimeout$1(timer);
        fired = true;
        listener();
    });
}
function $37d5a74137b0c6f7$var$serializeNode(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskAttributeFn: maskAttributeFn, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, ignoreCSSAttributes: ignoreCSSAttributes } = options;
    const rootId = $37d5a74137b0c6f7$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== "CSS1Compat") return {
                type: $37d5a74137b0c6f7$var$NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $37d5a74137b0c6f7$var$NodeType$1.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $37d5a74137b0c6f7$var$NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $37d5a74137b0c6f7$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                ignoreCSSAttributes: ignoreCSSAttributes
            });
        case n.TEXT_NODE:
            return $37d5a74137b0c6f7$var$serializeTextNode(n, {
                doc: doc,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $37d5a74137b0c6f7$var$NodeType$1.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $37d5a74137b0c6f7$var$NodeType$1.Comment,
                textContent: n.textContent || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $37d5a74137b0c6f7$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return void 0;
    const docId = mirror.getId(doc);
    return docId === 1 ? void 0 : docId;
}
function $37d5a74137b0c6f7$var$serializeTextNode(n, options) {
    const { maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, maskTextFn: maskTextFn, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, rootId: rootId } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === "STYLE" ? true : void 0;
    const isScript = parentTagName === "SCRIPT" ? true : void 0;
    const isTextarea = parentTagName === "TEXTAREA" ? true : void 0;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if (n.parentNode.sheet?.cssRules) textContent = $37d5a74137b0c6f7$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = $37d5a74137b0c6f7$var$absoluteToStylesheet(textContent, $37d5a74137b0c6f7$var$getHref(options.doc));
    }
    if (isScript) textContent = "SCRIPT_PLACEHOLDER";
    const forceMask = $37d5a74137b0c6f7$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, "*");
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, "*");
    if (parentTagName === "OPTION" && textContent) {
        const isInputMasked = $37d5a74137b0c6f7$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $37d5a74137b0c6f7$var$maskInputValue({
            isMasked: $37d5a74137b0c6f7$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $37d5a74137b0c6f7$var$NodeType$1.Text,
        textContent: textContent || "",
        isStyle: isStyle,
        rootId: rootId
    };
}
function $37d5a74137b0c6f7$var$serializeElementNode(n, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, ignoreCSSAttributes: ignoreCSSAttributes } = options;
    const needBlock = $37d5a74137b0c6f7$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    const tagName = $37d5a74137b0c6f7$var$getValidTagName(n);
    let attributes2 = {};
    const len = n.attributes.length;
    for(let i2 = 0; i2 < len; i2++){
        const attr = n.attributes[i2];
        if (attr.name && !$37d5a74137b0c6f7$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes2[attr.name] = $37d5a74137b0c6f7$var$transformAttribute(doc, tagName, $37d5a74137b0c6f7$var$toLowerCase(attr.name), attr.value, n, maskAttributeFn, ignoreCSSAttributes);
    }
    if (tagName === "link" && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $37d5a74137b0c6f7$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            attributes2.rel = null;
            attributes2.href = null;
            attributes2.crossorigin = null;
            attributes2._cssText = $37d5a74137b0c6f7$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === "style" && n.sheet && // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
    !(n.innerText || n.textContent || "").trim().length) {
        const cssText = $37d5a74137b0c6f7$var$stringifyStylesheet(n.sheet);
        if (cssText) attributes2._cssText = $37d5a74137b0c6f7$var$absoluteToStylesheet(cssText, $37d5a74137b0c6f7$var$getHref(doc));
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
        const el = n;
        const type = $37d5a74137b0c6f7$var$getInputType(el);
        const value = $37d5a74137b0c6f7$var$getInputValue(el, $37d5a74137b0c6f7$var$toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== "submit" && type !== "button" && value) {
            const forceMask = $37d5a74137b0c6f7$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $37d5a74137b0c6f7$var$shouldMaskInput({
                type: type,
                tagName: $37d5a74137b0c6f7$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes2.value = $37d5a74137b0c6f7$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes2.checked = checked;
    }
    if (tagName === "option") {
        if (n.selected && !maskInputOptions["select"]) attributes2.selected = true;
        else delete attributes2.selected;
    }
    if (tagName === "canvas" && recordCanvas) {
        if (n.__context === "2d") {
            if (!$37d5a74137b0c6f7$var$is2DCanvasBlank(n)) attributes2.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = doc.createElement("canvas");
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes2.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$37d5a74137b0c6f7$var$canvasService) {
            $37d5a74137b0c6f7$var$canvasService = doc.createElement("canvas");
            $37d5a74137b0c6f7$var$canvasCtx = $37d5a74137b0c6f7$var$canvasService.getContext("2d");
        }
        const image = n;
        const imageSrc = image.currentSrc || image.getAttribute("src") || "<unknown-src>";
        const priorCrossOrigin = image.crossOrigin;
        const recordInlineImage = ()=>{
            image.removeEventListener("load", recordInlineImage);
            try {
                $37d5a74137b0c6f7$var$canvasService.width = image.naturalWidth;
                $37d5a74137b0c6f7$var$canvasService.height = image.naturalHeight;
                $37d5a74137b0c6f7$var$canvasCtx.drawImage(image, 0, 0);
                attributes2.rr_dataURL = $37d5a74137b0c6f7$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                if (image.crossOrigin !== "anonymous") {
                    image.crossOrigin = "anonymous";
                    if (image.complete && image.naturalWidth !== 0) recordInlineImage();
                    else image.addEventListener("load", recordInlineImage);
                    return;
                } else console.warn(`Cannot inline img src=${imageSrc}! Error: ${err}`);
            }
            if (image.crossOrigin === "anonymous") priorCrossOrigin ? attributes2.crossOrigin = priorCrossOrigin : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        attributes2.rr_mediaState = n.paused ? "paused" : "played";
        attributes2.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes2.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes2.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n.getBoundingClientRect();
        attributes2 = {
            class: attributes2.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes2.src)) {
        if (!needBlock && !$37d5a74137b0c6f7$var$getIFrameContentDocument$1(n)) attributes2.rr_src = attributes2.src;
        delete attributes2.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $37d5a74137b0c6f7$var$NodeType$1.Element,
        tagName: tagName,
        attributes: attributes2,
        childNodes: [],
        isSVG: $37d5a74137b0c6f7$var$isSVGElement(n) || void 0,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $37d5a74137b0c6f7$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === void 0 || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $37d5a74137b0c6f7$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $37d5a74137b0c6f7$var$NodeType$1.Comment) return true;
    else if (sn.type === $37d5a74137b0c6f7$var$NodeType$1.Element) {
        if (slimDOMOptions.script && // script tag
        (sn.tagName === "script" || // (module)preload link
        sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") || // prefetch link
        sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && $37d5a74137b0c6f7$var$extractFileExtension(sn.attributes.href) === "js")) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.name) === "application-name" || $37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.rel) === "icon" || $37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
            $37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.name) === "robots" || $37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.name) === "googlebot" || $37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== void 0) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.name) === "author" || $37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.name) === "generator" || $37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.name) === "framework" || $37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.name) === "publisher" || $37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.name) === "progid" || $37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.name) === "verification" || $37d5a74137b0c6f7$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $37d5a74137b0c6f7$var$serializeNodeWithId(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5e3, onBlockedImageLoad: onBlockedImageLoad, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5e3, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false, ignoreCSSAttributes: ignoreCSSAttributes } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $37d5a74137b0c6f7$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement,
        ignoreCSSAttributes: ignoreCSSAttributes
    });
    if (!_serializedNode) {
        console.warn(n, "not serialized");
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($37d5a74137b0c6f7$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $37d5a74137b0c6f7$var$NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.trim().length) id = $37d5a74137b0c6f7$var$IGNORED_NODE;
    else id = $37d5a74137b0c6f7$var$genId();
    const serializedNode2 = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode2);
    if (id === $37d5a74137b0c6f7$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode2.type === $37d5a74137b0c6f7$var$NodeType$1.Element) {
        recordChild = recordChild && !serializedNode2.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && $37d5a74137b0c6f7$var$isNativeShadowDom(shadowRoot)) serializedNode2.isShadowHost = true;
    }
    if ((serializedNode2.type === $37d5a74137b0c6f7$var$NodeType$1.Document || serializedNode2.type === $37d5a74137b0c6f7$var$NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode2.type === $37d5a74137b0c6f7$var$NodeType$1.Element && serializedNode2.tagName === "head") preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onBlockedImageLoad: onBlockedImageLoad,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn,
            ignoreCSSAttributes: ignoreCSSAttributes
        };
        const childNodes = n.childNodes ? Array.from(n.childNodes) : [];
        for (const childN of childNodes){
            const serializedChildNode = $37d5a74137b0c6f7$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode2.childNodes.push(serializedChildNode);
        }
        if ($37d5a74137b0c6f7$var$isElement$1(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $37d5a74137b0c6f7$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $37d5a74137b0c6f7$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode2.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $37d5a74137b0c6f7$var$isShadowRoot(n.parentNode) && $37d5a74137b0c6f7$var$isNativeShadowDom(n.parentNode)) serializedNode2.isShadow = true;
    if (serializedNode2.type === $37d5a74137b0c6f7$var$NodeType$1.Element && serializedNode2.tagName === "iframe" && !serializedNode2.needBlock) $37d5a74137b0c6f7$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = $37d5a74137b0c6f7$var$getIFrameContentDocument$1(n);
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $37d5a74137b0c6f7$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn,
                ignoreCSSAttributes: ignoreCSSAttributes
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode2.type === $37d5a74137b0c6f7$var$NodeType$1.Element && serializedNode2.tagName === "img" && !n.complete && serializedNode2.needBlock) {
        const image = n;
        const updateImageDimensions = ()=>{
            if (image.isConnected && !image.complete && onBlockedImageLoad) try {
                const rect = image.getBoundingClientRect();
                if (rect.width > 0 && rect.height > 0) onBlockedImageLoad(image, serializedNode2, rect);
            } catch (error) {}
            image.removeEventListener("load", updateImageDimensions);
        };
        if (image.isConnected) image.addEventListener("load", updateImageDimensions);
    }
    if (serializedNode2.type === $37d5a74137b0c6f7$var$NodeType$1.Element && serializedNode2.tagName === "link" && typeof serializedNode2.attributes.rel === "string" && (serializedNode2.attributes.rel === "stylesheet" || serializedNode2.attributes.rel === "preload" && typeof serializedNode2.attributes.href === "string" && $37d5a74137b0c6f7$var$extractFileExtension(serializedNode2.attributes.href) === "css")) $37d5a74137b0c6f7$var$onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $37d5a74137b0c6f7$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn,
                ignoreCSSAttributes: ignoreCSSAttributes
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    if (serializedNode2.type === $37d5a74137b0c6f7$var$NodeType$1.Element) delete serializedNode2.needBlock;
    return serializedNode2;
}
function $37d5a74137b0c6f7$var$snapshot(n, options) {
    const { mirror: mirror = new $37d5a74137b0c6f7$var$Mirror(), blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onBlockedImageLoad: onBlockedImageLoad, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = /* @__PURE__ */ new Set([]) } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? // if true: set of sensible options that should not throw away any information
    {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        // destructive
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $37d5a74137b0c6f7$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onBlockedImageLoad: onBlockedImageLoad,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false,
        ignoreCSSAttributes: ignoreCSSAttributes
    });
}
function $37d5a74137b0c6f7$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $37d5a74137b0c6f7$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $37d5a74137b0c6f7$var$_mirror = {
    map: {},
    getId () {
        console.error($37d5a74137b0c6f7$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($37d5a74137b0c6f7$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($37d5a74137b0c6f7$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($37d5a74137b0c6f7$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($37d5a74137b0c6f7$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $37d5a74137b0c6f7$var$_mirror = new Proxy($37d5a74137b0c6f7$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($37d5a74137b0c6f7$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $37d5a74137b0c6f7$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                $37d5a74137b0c6f7$var$clearTimeout$2(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = $37d5a74137b0c6f7$var$setTimeout$2(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $37d5a74137b0c6f7$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $37d5a74137b0c6f7$var$setTimeout$2(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$37d5a74137b0c6f7$var$hookSetter(target, key, original || {}, true);
}
function $37d5a74137b0c6f7$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch  {
        return ()=>{};
    }
}
let $37d5a74137b0c6f7$var$nowTimestamp = Date.now;
if (!/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString())) $37d5a74137b0c6f7$var$nowTimestamp = ()=>/* @__PURE__ */ new Date().getTime();
function $37d5a74137b0c6f7$var$getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== void 0 ? win.pageXOffset : doc?.documentElement.scrollLeft || doc?.body?.parentElement?.scrollLeft || doc?.body?.scrollLeft || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== void 0 ? win.pageYOffset : doc?.documentElement.scrollTop || doc?.body?.parentElement?.scrollTop || doc?.body?.scrollTop || 0
    };
}
function $37d5a74137b0c6f7$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $37d5a74137b0c6f7$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $37d5a74137b0c6f7$var$closestElementOfNode$1(node) {
    if (!node) return null;
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        return el;
    } catch (error) {
        return null;
    }
}
function $37d5a74137b0c6f7$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $37d5a74137b0c6f7$var$closestElementOfNode$1(node);
    if (!el) return false;
    const blockedPredicate = $37d5a74137b0c6f7$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $37d5a74137b0c6f7$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $37d5a74137b0c6f7$var$distanceToMatch(el, $37d5a74137b0c6f7$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $37d5a74137b0c6f7$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $37d5a74137b0c6f7$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $37d5a74137b0c6f7$var$IGNORED_NODE;
}
function $37d5a74137b0c6f7$var$isAncestorRemoved(target, mirror) {
    if ($37d5a74137b0c6f7$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $37d5a74137b0c6f7$var$isAncestorRemoved(target.parentNode, mirror);
}
function $37d5a74137b0c6f7$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $37d5a74137b0c6f7$var$polyfill(win = window) {
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError("1 argument is required");
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $37d5a74137b0c6f7$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === "IFRAME" && mirror.getMeta(n));
}
function $37d5a74137b0c6f7$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === "LINK" && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute("rel") === "stylesheet" && mirror.getMeta(n));
}
function $37d5a74137b0c6f7$var$hasShadowRoot(n) {
    return Boolean(n?.shadowRoot);
}
class $37d5a74137b0c6f7$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = /* @__PURE__ */ new WeakMap();
        this.idStyleMap = /* @__PURE__ */ new Map();
    }
    getId(stylesheet) {
        return this.styleIDMap.get(stylesheet) ?? -1;
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */ add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === void 0) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = /* @__PURE__ */ new WeakMap();
        this.idStyleMap = /* @__PURE__ */ new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $37d5a74137b0c6f7$var$getShadowHost(n) {
    let shadowHost = null;
    if (n.getRootNode?.()?.nodeType === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $37d5a74137b0c6f7$var$getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while(shadowHost = $37d5a74137b0c6f7$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $37d5a74137b0c6f7$var$shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    const shadowHost = $37d5a74137b0c6f7$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $37d5a74137b0c6f7$var$inDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $37d5a74137b0c6f7$var$shadowHostInDom(n);
}
const $37d5a74137b0c6f7$var$cachedImplementations = {};
function $37d5a74137b0c6f7$var$getImplementation(name) {
    const cached = $37d5a74137b0c6f7$var$cachedImplementations[name];
    if (cached) return cached;
    const document2 = window.document;
    let impl = window[name];
    if (document2 && typeof document2.createElement === "function") try {
        const sandbox = document2.createElement("iframe");
        sandbox.hidden = true;
        document2.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document2.head.removeChild(sandbox);
    } catch (e) {}
    return $37d5a74137b0c6f7$var$cachedImplementations[name] = impl.bind(window);
}
function $37d5a74137b0c6f7$var$onRequestAnimationFrame(...rest) {
    return $37d5a74137b0c6f7$var$getImplementation("requestAnimationFrame")(...rest);
}
function $37d5a74137b0c6f7$var$setTimeout$2(...rest) {
    return $37d5a74137b0c6f7$var$getImplementation("setTimeout")(...rest);
}
function $37d5a74137b0c6f7$var$clearTimeout$2(...rest) {
    return $37d5a74137b0c6f7$var$getImplementation("clearTimeout")(...rest);
}
var $37d5a74137b0c6f7$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($37d5a74137b0c6f7$var$EventType || {});
var $37d5a74137b0c6f7$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($37d5a74137b0c6f7$var$IncrementalSource || {});
var $37d5a74137b0c6f7$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($37d5a74137b0c6f7$var$MouseInteractions || {});
var $37d5a74137b0c6f7$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($37d5a74137b0c6f7$var$PointerTypes || {});
var $37d5a74137b0c6f7$var$MediaInteractions = /* @__PURE__ */ ((MediaInteractions2)=>{
    MediaInteractions2[MediaInteractions2["Play"] = 0] = "Play";
    MediaInteractions2[MediaInteractions2["Pause"] = 1] = "Pause";
    MediaInteractions2[MediaInteractions2["Seeked"] = 2] = "Seeked";
    MediaInteractions2[MediaInteractions2["VolumeChange"] = 3] = "VolumeChange";
    MediaInteractions2[MediaInteractions2["RateChange"] = 4] = "RateChange";
    return MediaInteractions2;
})($37d5a74137b0c6f7$var$MediaInteractions || {});
let $37d5a74137b0c6f7$var$errorHandler;
function $37d5a74137b0c6f7$var$registerErrorHandler(handler) {
    $37d5a74137b0c6f7$var$errorHandler = handler;
}
function $37d5a74137b0c6f7$var$unregisterErrorHandler() {
    $37d5a74137b0c6f7$var$errorHandler = void 0;
}
const $37d5a74137b0c6f7$var$callbackWrapper = (cb)=>{
    if (!$37d5a74137b0c6f7$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($37d5a74137b0c6f7$var$errorHandler && $37d5a74137b0c6f7$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
var $37d5a74137b0c6f7$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $37d5a74137b0c6f7$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var $37d5a74137b0c6f7$var$i = 0; $37d5a74137b0c6f7$var$i < $37d5a74137b0c6f7$var$chars.length; $37d5a74137b0c6f7$var$i++)$37d5a74137b0c6f7$var$lookup[$37d5a74137b0c6f7$var$chars.charCodeAt($37d5a74137b0c6f7$var$i)] = $37d5a74137b0c6f7$var$i;
class $37d5a74137b0c6f7$var$CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
    addWindow() {}
    addShadowRoot() {}
    resetShadowRoots() {}
}
function $37d5a74137b0c6f7$var$getIFrameContentDocument(iframe) {
    try {
        return iframe.contentDocument;
    } catch (e2) {}
}
function $37d5a74137b0c6f7$var$getIFrameContentWindow(iframe) {
    try {
        return iframe.contentWindow;
    } catch (e2) {}
}
class $37d5a74137b0c6f7$var$StyleDeclarationParser {
    constructor(doc){
        this.doc = doc;
        this.unattachedDoc = null;
    }
    parse(styleText) {
        return this.parseWithConstructableStylesheet(styleText) || this.parseWithDetachedElement(styleText);
    }
    parseWithConstructableStylesheet(styleText) {
        if (typeof CSSStyleSheet === "undefined" || typeof CSSStyleSheet.prototype.replaceSync !== "function") return null;
        try {
            const sheet = new CSSStyleSheet();
            sheet.replaceSync(`x { ${styleText} }`);
            const rule = sheet.cssRules[0];
            if (!rule || rule.type !== CSSRule.STYLE_RULE) return null;
            return rule.style;
        } catch  {
            return null;
        }
    }
    parseWithDetachedElement(styleText) {
        const old = this.getUnattachedDoc().createElement("span");
        old.setAttribute("style", styleText);
        return old.style;
    }
    getUnattachedDoc() {
        if (!this.unattachedDoc) try {
            this.unattachedDoc = document.implementation.createHTMLDocument();
        } catch  {
            this.unattachedDoc = this.doc;
        }
        return this.unattachedDoc;
    }
}
function $37d5a74137b0c6f7$var$isNodeInLinkedList(n2) {
    return "__ln" in n2;
}
class $37d5a74137b0c6f7$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        let current = this.head;
        for(let index = 0; index < position; index++)current = current?.next || null;
        return current;
    }
    addNode(n2) {
        const node = {
            value: n2,
            previous: null,
            next: null
        };
        n2.__ln = node;
        if (n2.previousSibling && $37d5a74137b0c6f7$var$isNodeInLinkedList(n2.previousSibling)) {
            const current = n2.previousSibling.__ln.next;
            node.next = current;
            node.previous = n2.previousSibling.__ln;
            n2.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n2.nextSibling && $37d5a74137b0c6f7$var$isNodeInLinkedList(n2.nextSibling) && n2.nextSibling.__ln.previous) {
            const current = n2.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n2.nextSibling.__ln;
            n2.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n2) {
        const current = n2.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n2.__ln) delete n2.__ln;
        this.length--;
    }
}
const $37d5a74137b0c6f7$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $37d5a74137b0c6f7$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = /* @__PURE__ */ new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = /* @__PURE__ */ new Set();
        this.movedSet = /* @__PURE__ */ new Set();
        this.droppedSet = /* @__PURE__ */ new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = /* @__PURE__ */ new Set();
            const addList = new $37d5a74137b0c6f7$var$DoubleLinkedList();
            const getNextId = (n2)=>{
                let ns = n2;
                let nextId = $37d5a74137b0c6f7$var$IGNORED_NODE;
                while(nextId === $37d5a74137b0c6f7$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n2)=>{
                if (!n2.parentNode || !$37d5a74137b0c6f7$var$inDom(n2)) return;
                const parentId = $37d5a74137b0c6f7$var$isShadowRoot(n2.parentNode) ? this.mirror.getId($37d5a74137b0c6f7$var$getShadowHost(n2)) : this.mirror.getId(n2.parentNode);
                const nextId = getNextId(n2);
                if (parentId === -1 || nextId === -1) return addList.addNode(n2);
                const sn = $37d5a74137b0c6f7$var$serializeNodeWithId(n2, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($37d5a74137b0c6f7$var$isSerializedIframe(currentN, this.mirror) && !$37d5a74137b0c6f7$var$isBlocked(currentN, this.blockClass, this.blockSelector, this.unblockSelector, false)) this.iframeManager.addIframe(currentN);
                        if ($37d5a74137b0c6f7$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($37d5a74137b0c6f7$var$hasShadowRoot(n2)) this.shadowDomManager.addShadowRoot(n2.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        if ($37d5a74137b0c6f7$var$isBlocked(iframe, this.blockClass, this.blockSelector, this.unblockSelector, false)) return;
                        this.iframeManager.attachIframe(iframe, childSn);
                        const contentWindow = $37d5a74137b0c6f7$var$getIFrameContentWindow(iframe);
                        if (contentWindow) this.canvasManager.addWindow(contentWindow);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    },
                    onBlockedImageLoad: (_imageEl, serializedNode, { width: width, height: height })=>{
                        this.mutationCb({
                            adds: [],
                            removes: [],
                            texts: [],
                            attributes: [
                                {
                                    id: serializedNode.id,
                                    attributes: {
                                        style: {
                                            width: `${width}px`,
                                            height: `${height}px`
                                        }
                                    }
                                }
                            ]
                        });
                    },
                    ignoreCSSAttributes: this.ignoreCSSAttributes
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n2 of this.movedSet){
                if ($37d5a74137b0c6f7$var$isParentRemoved(this.removes, n2, this.mirror) && !this.movedSet.has(n2.parentNode)) continue;
                pushAdd(n2);
            }
            for (const n2 of this.addedSet){
                if (!$37d5a74137b0c6f7$var$isAncestorInSet(this.droppedSet, n2) && !$37d5a74137b0c6f7$var$isParentRemoved(this.removes, n2, this.mirror)) pushAdd(n2);
                else if ($37d5a74137b0c6f7$var$isAncestorInSet(this.movedSet, n2)) pushAdd(n2);
                else this.droppedSet.add(n2);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId2 = this.mirror.getId(shadowHost);
                                    if (parentId2 !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === "string") {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.attributeMap = /* @__PURE__ */ new WeakMap();
            this.removes = [];
            this.addedSet = /* @__PURE__ */ new Set();
            this.movedSet = /* @__PURE__ */ new Set();
            this.droppedSet = /* @__PURE__ */ new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($37d5a74137b0c6f7$var$isIgnored(m.target, this.mirror)) return;
            switch(m.type){
                case "characterData":
                    {
                        const value = m.target.textContent;
                        if (!$37d5a74137b0c6f7$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $37d5a74137b0c6f7$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value, $37d5a74137b0c6f7$var$closestElementOfNode$1(m.target)) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === "value") {
                            const type = $37d5a74137b0c6f7$var$getInputType(target);
                            const tagName = target.tagName;
                            value = $37d5a74137b0c6f7$var$getInputValue(target, tagName, type);
                            const isInputMasked = $37d5a74137b0c6f7$var$shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            const forceMask = $37d5a74137b0c6f7$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = $37d5a74137b0c6f7$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($37d5a74137b0c6f7$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(value)) {
                            const iframeDoc = $37d5a74137b0c6f7$var$getIFrameContentDocument(target);
                            if (!iframeDoc) attributeName = "rr_src";
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (!$37d5a74137b0c6f7$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $37d5a74137b0c6f7$var$transformAttribute(this.doc, $37d5a74137b0c6f7$var$toLowerCase(target.tagName), $37d5a74137b0c6f7$var$toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === "style") {
                                const oldStyle = m.oldValue ? this.styleDeclarationParser.parse(m.oldValue) : null;
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== (oldStyle?.getPropertyValue(pname) || "") || newPriority !== (oldStyle?.getPropertyPriority(pname) || "")) {
                                        if (newPriority === "") item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                if (oldStyle) {
                                    for (const pname of Array.from(oldStyle))if (target.style.getPropertyValue(pname) === "") item.styleDiff[pname] = false;
                                }
                            }
                        }
                        break;
                    }
                case "childList":
                    if ($37d5a74137b0c6f7$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n2)=>this.genAdds(n2, m.target));
                    m.removedNodes.forEach((n2)=>{
                        const nodeId = this.mirror.getId(n2);
                        const parentId = $37d5a74137b0c6f7$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($37d5a74137b0c6f7$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || $37d5a74137b0c6f7$var$isIgnored(n2, this.mirror) || !$37d5a74137b0c6f7$var$isSerialized(n2, this.mirror)) return;
                        if (this.addedSet.has(n2)) {
                            $37d5a74137b0c6f7$var$deepDelete(this.addedSet, n2);
                            this.droppedSet.add(n2);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($37d5a74137b0c6f7$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n2) && this.movedMap[$37d5a74137b0c6f7$var$moveKey(nodeId, parentId)]) $37d5a74137b0c6f7$var$deepDelete(this.movedSet, n2);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $37d5a74137b0c6f7$var$isShadowRoot(m.target) && $37d5a74137b0c6f7$var$isNativeShadowDom(m.target) ? true : void 0
                        });
                        this.mapRemoves.push(n2);
                    });
                    break;
            }
        };
        this.genAdds = (n2, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n2, this)) return;
            if (this.addedSet.has(n2) || this.movedSet.has(n2)) return;
            if (this.mirror.hasNode(n2)) {
                if ($37d5a74137b0c6f7$var$isIgnored(n2, this.mirror)) return;
                this.movedSet.add(n2);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$37d5a74137b0c6f7$var$moveKey(this.mirror.getId(n2), targetId)] = true;
            } else {
                this.addedSet.add(n2);
                this.droppedSet.delete(n2);
            }
            if (!$37d5a74137b0c6f7$var$isBlocked(n2, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                if (n2.childNodes) n2.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($37d5a74137b0c6f7$var$hasShadowRoot(n2)) n2.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n2);
                });
            }
        };
    }
    init(options) {
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "unblockSelector",
            "maskAllText",
            "maskTextClass",
            "unmaskTextClass",
            "maskTextSelector",
            "unmaskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskAttributeFn",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager",
            "ignoreCSSAttributes"
        ].forEach((key)=>{
            this[key] = options[key];
        });
        this.styleDeclarationParser = new $37d5a74137b0c6f7$var$StyleDeclarationParser(this.doc);
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $37d5a74137b0c6f7$var$deepDelete(addsSet, n2) {
    addsSet.delete(n2);
    n2.childNodes?.forEach((childN)=>$37d5a74137b0c6f7$var$deepDelete(addsSet, childN));
}
function $37d5a74137b0c6f7$var$isParentRemoved(removes, n2, mirror2) {
    if (removes.length === 0) return false;
    return $37d5a74137b0c6f7$var$_isParentRemoved(removes, n2, mirror2);
}
function $37d5a74137b0c6f7$var$_isParentRemoved(removes, n2, mirror2) {
    let node = n2.parentNode;
    while(node){
        const parentId = mirror2.getId(node);
        if (removes.some((r2)=>r2.id === parentId)) return true;
        node = node.parentNode;
    }
    return false;
}
function $37d5a74137b0c6f7$var$isAncestorInSet(set, n2) {
    if (set.size === 0) return false;
    return $37d5a74137b0c6f7$var$_isAncestorInSet(set, n2);
}
function $37d5a74137b0c6f7$var$_isAncestorInSet(set, n2) {
    const { parentNode: parentNode } = n2;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $37d5a74137b0c6f7$var$_isAncestorInSet(set, parentNode);
}
const $37d5a74137b0c6f7$var$mutationBuffers = [];
function $37d5a74137b0c6f7$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch  {}
    return event && event.target;
}
function $37d5a74137b0c6f7$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $37d5a74137b0c6f7$var$MutationBuffer();
    $37d5a74137b0c6f7$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || /**
  * Some websites may disable MutationObserver by removing it from the window object.
  * If someone is using rrweb to build a browser extention or things like it, they
  * could not change the website's code but can have an opportunity to inject some
  * code before the website executing its JS logic.
  * Then they can do this to store the native MutationObserver:
  * window.__rrMutationObserver = MutationObserver
  */ window.__rrMutationObserver;
    const angularZoneSymbol = window?.Zone?.__symbol__?.("MutationObserver");
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($37d5a74137b0c6f7$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $37d5a74137b0c6f7$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror2 }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $37d5a74137b0c6f7$var$throttle$1($37d5a74137b0c6f7$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $37d5a74137b0c6f7$var$callbackWrapper($37d5a74137b0c6f7$var$throttle$1($37d5a74137b0c6f7$var$callbackWrapper((evt)=>{
        const target = $37d5a74137b0c6f7$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $37d5a74137b0c6f7$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $37d5a74137b0c6f7$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror2.getId(target),
            timeOffset: $37d5a74137b0c6f7$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? $37d5a74137b0c6f7$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $37d5a74137b0c6f7$var$IncrementalSource.MouseMove : $37d5a74137b0c6f7$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $37d5a74137b0c6f7$var$on("mousemove", updatePosition, doc),
        $37d5a74137b0c6f7$var$on("touchmove", updatePosition, doc),
        $37d5a74137b0c6f7$var$on("drag", updatePosition, doc)
    ];
    return $37d5a74137b0c6f7$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $37d5a74137b0c6f7$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === void 0 ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $37d5a74137b0c6f7$var$getEventTarget(event);
            if ($37d5a74137b0c6f7$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $37d5a74137b0c6f7$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $37d5a74137b0c6f7$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $37d5a74137b0c6f7$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $37d5a74137b0c6f7$var$PointerTypes.Touch) {
                    if ($37d5a74137b0c6f7$var$MouseInteractions[eventKey] === $37d5a74137b0c6f7$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($37d5a74137b0c6f7$var$MouseInteractions[eventKey] === $37d5a74137b0c6f7$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $37d5a74137b0c6f7$var$PointerTypes.Pen;
            } else if ($37d5a74137b0c6f7$var$legacy_isTouchEvent(event)) pointerType = $37d5a74137b0c6f7$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $37d5a74137b0c6f7$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $37d5a74137b0c6f7$var$PointerTypes.Mouse) pointerType = null;
            } else if ($37d5a74137b0c6f7$var$MouseInteractions[eventKey] === $37d5a74137b0c6f7$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e2 = $37d5a74137b0c6f7$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e2) return;
            const id = mirror2.getId(target);
            const { clientX: clientX, clientY: clientY } = e2;
            $37d5a74137b0c6f7$var$callbackWrapper(mouseInteractionCb)({
                type: $37d5a74137b0c6f7$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($37d5a74137b0c6f7$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $37d5a74137b0c6f7$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($37d5a74137b0c6f7$var$MouseInteractions[eventKey]){
            case $37d5a74137b0c6f7$var$MouseInteractions.MouseDown:
            case $37d5a74137b0c6f7$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $37d5a74137b0c6f7$var$MouseInteractions.TouchStart:
            case $37d5a74137b0c6f7$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($37d5a74137b0c6f7$var$on(eventName, handler, doc));
    });
    return $37d5a74137b0c6f7$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $37d5a74137b0c6f7$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $37d5a74137b0c6f7$var$callbackWrapper($37d5a74137b0c6f7$var$throttle$1($37d5a74137b0c6f7$var$callbackWrapper((evt)=>{
        const target = $37d5a74137b0c6f7$var$getEventTarget(evt);
        if (!target || $37d5a74137b0c6f7$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror2.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $37d5a74137b0c6f7$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $37d5a74137b0c6f7$var$on("scroll", updatePosition, doc);
}
function $37d5a74137b0c6f7$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $37d5a74137b0c6f7$var$callbackWrapper($37d5a74137b0c6f7$var$throttle$1($37d5a74137b0c6f7$var$callbackWrapper(()=>{
        const height = $37d5a74137b0c6f7$var$getWindowHeight();
        const width = $37d5a74137b0c6f7$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $37d5a74137b0c6f7$var$on("resize", updateDimension, win);
}
const $37d5a74137b0c6f7$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const $37d5a74137b0c6f7$var$lastInputValueMap = /* @__PURE__ */ new WeakMap();
function $37d5a74137b0c6f7$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector }) {
    function eventHandler(event) {
        let target = $37d5a74137b0c6f7$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && $37d5a74137b0c6f7$var$toUpperCase(target.tagName);
        if (tagName === "OPTION") target = target.parentElement;
        if (!target || !tagName || $37d5a74137b0c6f7$var$INPUT_TAGS.indexOf(tagName) < 0 || $37d5a74137b0c6f7$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = $37d5a74137b0c6f7$var$getInputType(target);
        let text = $37d5a74137b0c6f7$var$getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = $37d5a74137b0c6f7$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        const forceMask = $37d5a74137b0c6f7$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        text = $37d5a74137b0c6f7$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el2)=>{
            if (el2 !== target) {
                const text2 = $37d5a74137b0c6f7$var$maskInputValue({
                    // share mask behavior of `target`
                    isMasked: forceMask,
                    element: el2,
                    value: $37d5a74137b0c6f7$var$getInputValue(el2, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el2, userTriggeredOnInput ? {
                    text: text2,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text2,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v2) {
        const lastInputValue = $37d5a74137b0c6f7$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v2.text || lastInputValue.isChecked !== v2.isChecked) {
            $37d5a74137b0c6f7$var$lastInputValueMap.set(target, v2);
            const id = mirror2.getId(target);
            $37d5a74137b0c6f7$var$callbackWrapper(inputCb)({
                ...v2,
                id: id
            });
        }
    }
    const events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    const handlers = events.map((eventName)=>$37d5a74137b0c6f7$var$on(eventName, $37d5a74137b0c6f7$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        // Some UI library use selectedIndex to set select value
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$37d5a74137b0c6f7$var$hookSetter(p[0], p[1], {
            set () {
                $37d5a74137b0c6f7$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $37d5a74137b0c6f7$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $37d5a74137b0c6f7$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($37d5a74137b0c6f7$var$hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || $37d5a74137b0c6f7$var$hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || $37d5a74137b0c6f7$var$hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || $37d5a74137b0c6f7$var$hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            const rules2 = Array.from(childRule.parentRule.cssRules);
            const index = rules2.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules2 = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules2.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $37d5a74137b0c6f7$var$getIdAndStyleId(sheet, mirror2, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror2.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $37d5a74137b0c6f7$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror2, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $37d5a74137b0c6f7$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $37d5a74137b0c6f7$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $37d5a74137b0c6f7$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $37d5a74137b0c6f7$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $37d5a74137b0c6f7$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $37d5a74137b0c6f7$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $37d5a74137b0c6f7$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $37d5a74137b0c6f7$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($37d5a74137b0c6f7$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($37d5a74137b0c6f7$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($37d5a74137b0c6f7$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($37d5a74137b0c6f7$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            insertRule: type.prototype.insertRule,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $37d5a74137b0c6f7$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $37d5a74137b0c6f7$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$37d5a74137b0c6f7$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $37d5a74137b0c6f7$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $37d5a74137b0c6f7$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$37d5a74137b0c6f7$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $37d5a74137b0c6f7$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $37d5a74137b0c6f7$var$initAdoptedStyleSheetObserver({ mirror: mirror2, stylesheetManager: stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === "#document") hostId = mirror2.getId(host);
    else hostId = mirror2.getId(host.host);
    const patchTarget = host.nodeName === "#document" ? host.defaultView?.Document : host.ownerDocument?.defaultView?.ShadowRoot;
    const originalPropertyDescriptor = patchTarget?.prototype ? Object.getOwnPropertyDescriptor(patchTarget?.prototype, "adoptedStyleSheets") : void 0;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return originalPropertyDescriptor.get?.call(this);
        },
        set (sheets) {
            const result = originalPropertyDescriptor.set?.call(this, sheets);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e2) {}
            return result;
        }
    });
    return $37d5a74137b0c6f7$var$callbackWrapper(()=>{
        Object.defineProperty(host, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            get: originalPropertyDescriptor.get,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            set: originalPropertyDescriptor.set
        });
    });
}
function $37d5a74137b0c6f7$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror2, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $37d5a74137b0c6f7$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $37d5a74137b0c6f7$var$getIdAndStyleId(thisArg.parentRule?.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $37d5a74137b0c6f7$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $37d5a74137b0c6f7$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $37d5a74137b0c6f7$var$getIdAndStyleId(thisArg.parentRule?.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $37d5a74137b0c6f7$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $37d5a74137b0c6f7$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $37d5a74137b0c6f7$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror2, sampling: sampling, doc: doc }) {
    const handler = $37d5a74137b0c6f7$var$callbackWrapper((type)=>$37d5a74137b0c6f7$var$throttle$1($37d5a74137b0c6f7$var$callbackWrapper((event)=>{
            const target = $37d5a74137b0c6f7$var$getEventTarget(event);
            if (!target || $37d5a74137b0c6f7$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate } = target;
            mediaInteractionCb({
                type: type,
                id: mirror2.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        $37d5a74137b0c6f7$var$on("play", handler($37d5a74137b0c6f7$var$MediaInteractions.Play), doc),
        $37d5a74137b0c6f7$var$on("pause", handler($37d5a74137b0c6f7$var$MediaInteractions.Pause), doc),
        $37d5a74137b0c6f7$var$on("seeked", handler($37d5a74137b0c6f7$var$MediaInteractions.Seeked), doc),
        $37d5a74137b0c6f7$var$on("volumechange", handler($37d5a74137b0c6f7$var$MediaInteractions.VolumeChange), doc),
        $37d5a74137b0c6f7$var$on("ratechange", handler($37d5a74137b0c6f7$var$MediaInteractions.RateChange), doc)
    ];
    return $37d5a74137b0c6f7$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $37d5a74137b0c6f7$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = /* @__PURE__ */ new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace2(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $37d5a74137b0c6f7$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            $37d5a74137b0c6f7$var$setTimeout$2($37d5a74137b0c6f7$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $37d5a74137b0c6f7$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $37d5a74137b0c6f7$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $37d5a74137b0c6f7$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && selection?.isCollapsed) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i2 = 0; i2 < count; i2++){
            const range = selection.getRangeAt(i2);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $37d5a74137b0c6f7$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $37d5a74137b0c6f7$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror2.getId(startContainer),
                startOffset: startOffset,
                end: mirror2.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $37d5a74137b0c6f7$var$on("selectionchange", updateSelection);
}
function $37d5a74137b0c6f7$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $37d5a74137b0c6f7$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e2) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $37d5a74137b0c6f7$var$initObservers(o2, _hooks = {}) {
    const currentWindow = o2.doc.defaultView;
    if (!currentWindow) return ()=>{};
    let mutationObserver;
    if (o2.recordDOM) mutationObserver = $37d5a74137b0c6f7$var$initMutationObserver(o2, o2.doc);
    const mousemoveHandler = $37d5a74137b0c6f7$var$initMoveObserver(o2);
    const mouseInteractionHandler = $37d5a74137b0c6f7$var$initMouseInteractionObserver(o2);
    const scrollHandler = $37d5a74137b0c6f7$var$initScrollObserver(o2);
    const viewportResizeHandler = $37d5a74137b0c6f7$var$initViewportResizeObserver(o2, {
        win: currentWindow
    });
    const inputHandler = $37d5a74137b0c6f7$var$initInputObserver(o2);
    const mediaInteractionHandler = $37d5a74137b0c6f7$var$initMediaInteractionObserver(o2);
    let styleSheetObserver = ()=>{};
    let adoptedStyleSheetObserver = ()=>{};
    let styleDeclarationObserver = ()=>{};
    let fontObserver = ()=>{};
    if (o2.recordDOM) {
        styleSheetObserver = $37d5a74137b0c6f7$var$initStyleSheetObserver(o2, {
            win: currentWindow
        });
        adoptedStyleSheetObserver = $37d5a74137b0c6f7$var$initAdoptedStyleSheetObserver(o2, o2.doc);
        styleDeclarationObserver = $37d5a74137b0c6f7$var$initStyleDeclarationObserver(o2, {
            win: currentWindow
        });
        if (o2.collectFonts) fontObserver = $37d5a74137b0c6f7$var$initFontObserver(o2);
    }
    const selectionObserver = $37d5a74137b0c6f7$var$initSelectionObserver(o2);
    const customElementObserver = $37d5a74137b0c6f7$var$initCustomElementObserver(o2);
    const pluginHandlers = [];
    for (const plugin of o2.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $37d5a74137b0c6f7$var$callbackWrapper(()=>{
        $37d5a74137b0c6f7$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver?.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $37d5a74137b0c6f7$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $37d5a74137b0c6f7$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && // Note: Generally, this check _shouldn't_ be necessary
    // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
    window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
class $37d5a74137b0c6f7$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
        this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
            this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = /* @__PURE__ */ new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = /* @__PURE__ */ new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
class $37d5a74137b0c6f7$var$IframeManagerNoop {
    constructor(){
        this.crossOriginIframeMirror = new $37d5a74137b0c6f7$var$CrossOriginIframeMirror($37d5a74137b0c6f7$var$genId);
        this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
}
class $37d5a74137b0c6f7$var$IframeManager {
    constructor(options){
        this.iframes = /* @__PURE__ */ new WeakMap();
        this.crossOriginIframeMap = /* @__PURE__ */ new WeakMap();
        this.crossOriginIframeMirror = new $37d5a74137b0c6f7$var$CrossOriginIframeMirror($37d5a74137b0c6f7$var$genId);
        this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $37d5a74137b0c6f7$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        const contentWindow = $37d5a74137b0c6f7$var$getIFrameContentWindow(iframeEl);
        if (contentWindow) this.crossOriginIframeMap.set(contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        if (this.recordCrossOriginIframes) $37d5a74137b0c6f7$var$getIFrameContentWindow(iframeEl)?.addEventListener("message", this.handleMessage.bind(this));
        this.loadListener?.(iframeEl);
        const iframeDoc = $37d5a74137b0c6f7$var$getIFrameContentDocument(iframeEl);
        if (iframeDoc && iframeDoc.adoptedStyleSheets && iframeDoc.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeDoc.adoptedStyleSheets, this.mirror.getId(iframeDoc));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
        crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e2) {
        switch(e2.type){
            case $37d5a74137b0c6f7$var$EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e2.data.node, iframeEl);
                    const rootId = e2.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e2.data.node, rootId);
                    return {
                        timestamp: e2.timestamp,
                        type: $37d5a74137b0c6f7$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $37d5a74137b0c6f7$var$IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e2.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $37d5a74137b0c6f7$var$EventType.Meta:
            case $37d5a74137b0c6f7$var$EventType.Load:
            case $37d5a74137b0c6f7$var$EventType.DomContentLoaded:
                return false;
            case $37d5a74137b0c6f7$var$EventType.Plugin:
                return e2;
            case $37d5a74137b0c6f7$var$EventType.Custom:
                this.replaceIds(e2.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e2;
            case $37d5a74137b0c6f7$var$EventType.IncrementalSnapshot:
                switch(e2.data.source){
                    case $37d5a74137b0c6f7$var$IncrementalSource.Mutation:
                        e2.data.adds.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            this.replaceIdOnNode(n2.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n2.node, rootId);
                        });
                        e2.data.removes.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e2.data.attributes.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        e2.data.texts.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $37d5a74137b0c6f7$var$IncrementalSource.Drag:
                    case $37d5a74137b0c6f7$var$IncrementalSource.TouchMove:
                    case $37d5a74137b0c6f7$var$IncrementalSource.MouseMove:
                        e2.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $37d5a74137b0c6f7$var$IncrementalSource.ViewportResize:
                        return false;
                    case $37d5a74137b0c6f7$var$IncrementalSource.MediaInteraction:
                    case $37d5a74137b0c6f7$var$IncrementalSource.MouseInteraction:
                    case $37d5a74137b0c6f7$var$IncrementalSource.Scroll:
                    case $37d5a74137b0c6f7$var$IncrementalSource.CanvasMutation:
                    case $37d5a74137b0c6f7$var$IncrementalSource.Input:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        return e2;
                    case $37d5a74137b0c6f7$var$IncrementalSource.StyleSheetRule:
                    case $37d5a74137b0c6f7$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleId"
                        ]);
                        return e2;
                    case $37d5a74137b0c6f7$var$IncrementalSource.Font:
                        return e2;
                    case $37d5a74137b0c6f7$var$IncrementalSource.Selection:
                        e2.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e2;
                    case $37d5a74137b0c6f7$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleIds"
                        ]);
                        e2.data.styles?.forEach((style)=>{
                            this.replaceStyleIds(style, iframeEl, [
                                "styleId"
                            ]);
                        });
                        return e2;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $37d5a74137b0c6f7$var$NodeType$1.Document && !node.rootId) node.rootId = rootId;
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $37d5a74137b0c6f7$var$ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class $37d5a74137b0c6f7$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = /* @__PURE__ */ new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$37d5a74137b0c6f7$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        this.bypassOptions.canvasManager.addShadowRoot(shadowRoot);
        const observer = $37d5a74137b0c6f7$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($37d5a74137b0c6f7$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
            // scroll is not allowed to pass the boundary, so we need to listen the shadow document
            doc: shadowRoot,
            mirror: this.mirror
        }));
        $37d5a74137b0c6f7$var$setTimeout$2(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($37d5a74137b0c6f7$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */ observeAttachShadow(iframeElement) {
        const iframeDoc = $37d5a74137b0c6f7$var$getIFrameContentDocument(iframeElement);
        const iframeWindow = $37d5a74137b0c6f7$var$getIFrameContentWindow(iframeElement);
        if (!iframeDoc || !iframeWindow) return;
        this.patchAttachShadow(iframeWindow.Element, iframeDoc);
    }
    /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */ patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($37d5a74137b0c6f7$var$patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $37d5a74137b0c6f7$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e2) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = /* @__PURE__ */ new WeakSet();
        this.bypassOptions.canvasManager.resetShadowRoots();
    }
}
class $37d5a74137b0c6f7$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
        this.styleMirror = new $37d5a74137b0c6f7$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r2, index)=>({
                            rule: $37d5a74137b0c6f7$var$stringifyRule(r2),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
    }
    // TODO: take snapshot on stylesheet reload by applying event listener
    trackStylesheetInLinkElement(_linkEl) {}
}
class $37d5a74137b0c6f7$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = /* @__PURE__ */ new WeakMap();
        this.active = false;
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        if (!this.active) {
            this.active = true;
            $37d5a74137b0c6f7$var$onRequestAnimationFrame(()=>{
                this.nodeMap = /* @__PURE__ */ new WeakMap();
                this.active = false;
            });
        }
        this.nodeMap.set(node, (this.nodeMap.get(node) || /* @__PURE__ */ new Set()).add(buffer));
    }
    destroy() {}
}
let $37d5a74137b0c6f7$var$wrappedEmit;
let $37d5a74137b0c6f7$var$_takeFullSnapshot;
try {
    if (Array.from([
        1
    ], (x)=>x * 2)[0] !== 2) {
        const cleanFrame = document.createElement("iframe");
        document.body.appendChild(cleanFrame);
        Array.from = cleanFrame.contentWindow?.Array.from || Array.from;
        document.body.removeChild(cleanFrame);
    }
} catch (err) {
    console.debug("Unable to override Array.from", err);
}
const $37d5a74137b0c6f7$var$mirror = $37d5a74137b0c6f7$var$createMirror();
function $37d5a74137b0c6f7$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = "rr-ignore", ignoreSelector: ignoreSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, maskTextFn: maskTextFn, maxCanvasSize: maxCanvasSize = null, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordDOM: recordDOM = true, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load", userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = /* @__PURE__ */ new Set([]), errorHandler: errorHandler, onMutation: onMutation, getCanvasManager: getCanvasManager } = options;
    $37d5a74137b0c6f7$var$registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e2) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (!inEmittingFrame && !passEmitsToParent) return ()=>{};
    if (mousemoveWait !== void 0 && sampling.mousemove === void 0) sampling.mousemove = mousemoveWait;
    $37d5a74137b0c6f7$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== void 0 ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        // the following are off for slimDOMOptions === true,
        // as they destroy some (hidden) info:
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $37d5a74137b0c6f7$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e2)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e2 = plugin.eventProcessor(e2);
        if (packFn && // Disable packing events which will be emitted to parent frames.
        !passEmitsToParent) e2 = packFn(e2);
        return e2;
    };
    $37d5a74137b0c6f7$var$wrappedEmit = (r2, isCheckout)=>{
        const e2 = r2;
        e2.timestamp = $37d5a74137b0c6f7$var$nowTimestamp();
        if ($37d5a74137b0c6f7$var$mutationBuffers[0]?.isFrozen() && e2.type !== $37d5a74137b0c6f7$var$EventType.FullSnapshot && !(e2.type === $37d5a74137b0c6f7$var$EventType.IncrementalSnapshot && e2.data.source === $37d5a74137b0c6f7$var$IncrementalSource.Mutation)) $37d5a74137b0c6f7$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) emit?.(eventProcessor(e2), isCheckout);
        else if (passEmitsToParent) {
            const message = {
                type: "rrweb",
                event: eventProcessor(e2),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e2.type === $37d5a74137b0c6f7$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e2;
            incrementalSnapshotCount = 0;
        } else if (e2.type === $37d5a74137b0c6f7$var$EventType.IncrementalSnapshot) {
            if (e2.data.source === $37d5a74137b0c6f7$var$IncrementalSource.Mutation && e2.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e2.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot2(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $37d5a74137b0c6f7$var$wrappedEmit({
            type: $37d5a74137b0c6f7$var$EventType.IncrementalSnapshot,
            data: {
                source: $37d5a74137b0c6f7$var$IncrementalSource.Mutation,
                ...m
            }
        });
    };
    const wrappedScrollEmit = (p)=>$37d5a74137b0c6f7$var$wrappedEmit({
            type: $37d5a74137b0c6f7$var$EventType.IncrementalSnapshot,
            data: {
                source: $37d5a74137b0c6f7$var$IncrementalSource.Scroll,
                ...p
            }
        });
    const wrappedCanvasMutationEmit = (p)=>$37d5a74137b0c6f7$var$wrappedEmit({
            type: $37d5a74137b0c6f7$var$EventType.IncrementalSnapshot,
            data: {
                source: $37d5a74137b0c6f7$var$IncrementalSource.CanvasMutation,
                ...p
            }
        });
    const wrappedAdoptedStyleSheetEmit = (a2)=>$37d5a74137b0c6f7$var$wrappedEmit({
            type: $37d5a74137b0c6f7$var$EventType.IncrementalSnapshot,
            data: {
                source: $37d5a74137b0c6f7$var$IncrementalSource.AdoptedStyleSheet,
                ...a2
            }
        });
    const stylesheetManager = new $37d5a74137b0c6f7$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new $37d5a74137b0c6f7$var$IframeManagerNoop() : new $37d5a74137b0c6f7$var$IframeManager({
        mirror: $37d5a74137b0c6f7$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $37d5a74137b0c6f7$var$wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $37d5a74137b0c6f7$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $37d5a74137b0c6f7$var$ProcessedNodeManager();
    const canvasManager = $37d5a74137b0c6f7$var$_getCanvasManager(getCanvasManager, {
        mirror: $37d5a74137b0c6f7$var$mirror,
        win: window,
        mutationCb: (p)=>$37d5a74137b0c6f7$var$wrappedEmit({
                type: $37d5a74137b0c6f7$var$EventType.IncrementalSnapshot,
                data: {
                    source: $37d5a74137b0c6f7$var$IncrementalSource.CanvasMutation,
                    ...p
                }
            }),
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling["canvas"],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $37d5a74137b0c6f7$var$ShadowDomManagerNoop() : new $37d5a74137b0c6f7$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager,
            ignoreCSSAttributes: ignoreCSSAttributes
        },
        mirror: $37d5a74137b0c6f7$var$mirror
    });
    const takeFullSnapshot2 = (isCheckout = false)=>{
        if (!recordDOM) return;
        $37d5a74137b0c6f7$var$wrappedEmit({
            type: $37d5a74137b0c6f7$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $37d5a74137b0c6f7$var$getWindowWidth(),
                height: $37d5a74137b0c6f7$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $37d5a74137b0c6f7$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $37d5a74137b0c6f7$var$snapshot(document, {
            mirror: $37d5a74137b0c6f7$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n2)=>{
                if ($37d5a74137b0c6f7$var$isSerializedIframe(n2, $37d5a74137b0c6f7$var$mirror)) iframeManager.addIframe(n2);
                if ($37d5a74137b0c6f7$var$isSerializedStylesheet(n2, $37d5a74137b0c6f7$var$mirror)) stylesheetManager.trackLinkElement(n2);
                if ($37d5a74137b0c6f7$var$hasShadowRoot(n2)) shadowDomManager.addShadowRoot(n2.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                const contentWindow = $37d5a74137b0c6f7$var$getIFrameContentWindow(iframe);
                if (contentWindow) canvasManager.addWindow(contentWindow);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            onBlockedImageLoad: (_imageEl, serializedNode, { width: width, height: height })=>{
                wrappedMutationEmit({
                    adds: [],
                    removes: [],
                    texts: [],
                    attributes: [
                        {
                            id: serializedNode.id,
                            attributes: {
                                style: {
                                    width: `${width}px`,
                                    height: `${height}px`
                                }
                            }
                        }
                    ]
                });
            },
            keepIframeSrcFn: keepIframeSrcFn,
            ignoreCSSAttributes: ignoreCSSAttributes
        });
        if (!node) return console.warn("Failed to snapshot the document");
        $37d5a74137b0c6f7$var$wrappedEmit({
            type: $37d5a74137b0c6f7$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $37d5a74137b0c6f7$var$getWindowScroll(window)
            }
        });
        $37d5a74137b0c6f7$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $37d5a74137b0c6f7$var$mirror.getId(document));
    };
    $37d5a74137b0c6f7$var$_takeFullSnapshot = takeFullSnapshot2;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return $37d5a74137b0c6f7$var$callbackWrapper($37d5a74137b0c6f7$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$37d5a74137b0c6f7$var$wrappedEmit({
                        type: $37d5a74137b0c6f7$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    }),
                mouseInteractionCb: (d)=>$37d5a74137b0c6f7$var$wrappedEmit({
                        type: $37d5a74137b0c6f7$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $37d5a74137b0c6f7$var$IncrementalSource.MouseInteraction,
                            ...d
                        }
                    }),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$37d5a74137b0c6f7$var$wrappedEmit({
                        type: $37d5a74137b0c6f7$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $37d5a74137b0c6f7$var$IncrementalSource.ViewportResize,
                            ...d
                        }
                    }),
                inputCb: (v2)=>$37d5a74137b0c6f7$var$wrappedEmit({
                        type: $37d5a74137b0c6f7$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $37d5a74137b0c6f7$var$IncrementalSource.Input,
                            ...v2
                        }
                    }),
                mediaInteractionCb: (p)=>$37d5a74137b0c6f7$var$wrappedEmit({
                        type: $37d5a74137b0c6f7$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $37d5a74137b0c6f7$var$IncrementalSource.MediaInteraction,
                            ...p
                        }
                    }),
                styleSheetRuleCb: (r2)=>$37d5a74137b0c6f7$var$wrappedEmit({
                        type: $37d5a74137b0c6f7$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $37d5a74137b0c6f7$var$IncrementalSource.StyleSheetRule,
                            ...r2
                        }
                    }),
                styleDeclarationCb: (r2)=>$37d5a74137b0c6f7$var$wrappedEmit({
                        type: $37d5a74137b0c6f7$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $37d5a74137b0c6f7$var$IncrementalSource.StyleDeclaration,
                            ...r2
                        }
                    }),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$37d5a74137b0c6f7$var$wrappedEmit({
                        type: $37d5a74137b0c6f7$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $37d5a74137b0c6f7$var$IncrementalSource.Font,
                            ...p
                        }
                    }),
                selectionCb: (p)=>{
                    $37d5a74137b0c6f7$var$wrappedEmit({
                        type: $37d5a74137b0c6f7$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $37d5a74137b0c6f7$var$IncrementalSource.Selection,
                            ...p
                        }
                    });
                },
                customElementCb: (c2)=>{
                    $37d5a74137b0c6f7$var$wrappedEmit({
                        type: $37d5a74137b0c6f7$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $37d5a74137b0c6f7$var$IncrementalSource.CustomElement,
                            ...c2
                        }
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordDOM: recordDOM,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $37d5a74137b0c6f7$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: plugins?.filter((p)=>p.observer)?.map((p)=>({
                        observer: p.observer,
                        options: p.options,
                        callback: (payload)=>$37d5a74137b0c6f7$var$wrappedEmit({
                                type: $37d5a74137b0c6f7$var$EventType.Plugin,
                                data: {
                                    plugin: p.name,
                                    payload: payload
                                }
                            })
                    })) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot2();
            handlers.push(observe(document));
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($37d5a74137b0c6f7$var$on("DOMContentLoaded", ()=>{
                $37d5a74137b0c6f7$var$wrappedEmit({
                    type: $37d5a74137b0c6f7$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($37d5a74137b0c6f7$var$on("load", ()=>{
                $37d5a74137b0c6f7$var$wrappedEmit({
                    type: $37d5a74137b0c6f7$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === "load") init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $37d5a74137b0c6f7$var$_takeFullSnapshot = void 0;
            $37d5a74137b0c6f7$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $37d5a74137b0c6f7$var$takeFullSnapshot(isCheckout) {
    if (!$37d5a74137b0c6f7$var$_takeFullSnapshot) throw new Error("please take full snapshot after start recording");
    $37d5a74137b0c6f7$var$_takeFullSnapshot(isCheckout);
}
$37d5a74137b0c6f7$var$record.mirror = $37d5a74137b0c6f7$var$mirror;
$37d5a74137b0c6f7$var$record.takeFullSnapshot = $37d5a74137b0c6f7$var$takeFullSnapshot;
function $37d5a74137b0c6f7$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $37d5a74137b0c6f7$var$CanvasManagerNoop();
    } catch  {
        console.warn("Unable to initialize CanvasManager");
        return new $37d5a74137b0c6f7$var$CanvasManagerNoop();
    }
}
var $37d5a74137b0c6f7$var$n;
!function(t2) {
    t2[t2.NotStarted = 0] = "NotStarted", t2[t2.Running = 1] = "Running", t2[t2.Stopped = 2] = "Stopped";
}($37d5a74137b0c6f7$var$n || ($37d5a74137b0c6f7$var$n = {}));
const $37d5a74137b0c6f7$var$ReplayEventTypeIncrementalSnapshot = 3;
const $37d5a74137b0c6f7$var$ReplayEventTypeCustom = 5;
function $37d5a74137b0c6f7$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1e3;
}
function $37d5a74137b0c6f7$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $37d5a74137b0c6f7$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === "sentry.transaction") return;
    if ([
        "ui.click",
        "ui.input"
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        replay.throttledAddEvent({
            type: $37d5a74137b0c6f7$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1e3,
            data: {
                tag: "breadcrumb",
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $2d7134eeb4bc669b$export$a3295358bff77e)(breadcrumb, 10, 1e3)
            }
        });
        return breadcrumb.category === "console";
    });
}
const $37d5a74137b0c6f7$var$INTERACTIVE_SELECTOR = "button,a";
function $37d5a74137b0c6f7$var$getClosestInteractive(element) {
    const closestInteractive = element.closest($37d5a74137b0c6f7$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
function $37d5a74137b0c6f7$var$getClickTargetNode(event) {
    const target = $37d5a74137b0c6f7$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $37d5a74137b0c6f7$var$getClosestInteractive(target);
}
function $37d5a74137b0c6f7$var$getTargetNode(event) {
    if ($37d5a74137b0c6f7$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $37d5a74137b0c6f7$var$isEventWithTarget(event) {
    return (0, $13cf2ed412f405fa$export$c10d0b04eaa80a43)(event) && "target" in event;
}
let $37d5a74137b0c6f7$var$handlers;
function $37d5a74137b0c6f7$var$onWindowOpen(cb) {
    if (!$37d5a74137b0c6f7$var$handlers) {
        $37d5a74137b0c6f7$var$handlers = [];
        $37d5a74137b0c6f7$var$monkeyPatchWindowOpen();
    }
    $37d5a74137b0c6f7$var$handlers.push(cb);
    return ()=>{
        const pos = $37d5a74137b0c6f7$var$handlers ? $37d5a74137b0c6f7$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $37d5a74137b0c6f7$var$handlers.splice(pos, 1);
    };
}
function $37d5a74137b0c6f7$var$monkeyPatchWindowOpen() {
    (0, $269eeb69635ed414$export$9563e054e6f787fb)($37d5a74137b0c6f7$var$WINDOW, "open", function(originalWindowOpen) {
        return function(...args) {
            if ($37d5a74137b0c6f7$var$handlers) try {
                $37d5a74137b0c6f7$var$handlers.forEach((handler)=>handler());
            } catch  {}
            return originalWindowOpen.apply($37d5a74137b0c6f7$var$WINDOW, args);
        };
    });
}
const $37d5a74137b0c6f7$var$IncrementalMutationSources = /* @__PURE__ */ new Set([
    $37d5a74137b0c6f7$var$IncrementalSource.Mutation,
    $37d5a74137b0c6f7$var$IncrementalSource.StyleSheetRule,
    $37d5a74137b0c6f7$var$IncrementalSource.StyleDeclaration,
    $37d5a74137b0c6f7$var$IncrementalSource.AdoptedStyleSheet,
    $37d5a74137b0c6f7$var$IncrementalSource.CanvasMutation,
    $37d5a74137b0c6f7$var$IncrementalSource.Selection,
    $37d5a74137b0c6f7$var$IncrementalSource.MediaInteraction
]);
function $37d5a74137b0c6f7$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
class $37d5a74137b0c6f7$var$ClickDetector {
    constructor(replay, slowClickConfig, _addBreadcrumbEvent = $37d5a74137b0c6f7$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        this._timeout = slowClickConfig.timeout / 1e3;
        this._threshold = slowClickConfig.threshold / 1e3;
        this._scrollTimeout = slowClickConfig.scrollTimeout / 1e3;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = $37d5a74137b0c6f7$var$onWindowOpen(()=>{
            this._lastMutation = $37d5a74137b0c6f7$var$nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if ($37d5a74137b0c6f7$var$ignoreElement(node, this._ignoreSelector) || !$37d5a74137b0c6f7$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $37d5a74137b0c6f7$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = $37d5a74137b0c6f7$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = $37d5a74137b0c6f7$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = $37d5a74137b0c6f7$var$getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $37d5a74137b0c6f7$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : void 0;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : void 0;
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scrollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        if (isSlowClick) {
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1e3;
            const endReason = timeAfterClickMs < this._timeout * 1e3 ? "mutation" : "timeout";
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.slowClickDetected",
                data: {
                    ...clickBreadcrumb.data,
                    url: $37d5a74137b0c6f7$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        if (clickCount > 1) {
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.multiClick",
                data: {
                    ...clickBreadcrumb.data,
                    url: $37d5a74137b0c6f7$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = (0, $295fbc3e705f470c$export$831dc9f2ab0a617b)(()=>this._checkClicks(), 1e3);
    }
}
const $37d5a74137b0c6f7$var$SLOW_CLICK_TAGS = [
    "A",
    "BUTTON",
    "INPUT"
];
function $37d5a74137b0c6f7$var$ignoreElement(node, ignoreSelector) {
    if (!$37d5a74137b0c6f7$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    if (node.tagName === "INPUT" && ![
        "submit",
        "button"
    ].includes(node.getAttribute("type") || "")) return true;
    if (node.tagName === "A" && (node.hasAttribute("download") || node.hasAttribute("target") && node.getAttribute("target") !== "_self")) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $37d5a74137b0c6f7$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === "number" && breadcrumb.timestamp);
}
function $37d5a74137b0c6f7$var$nowInSeconds() {
    return Date.now() / 1e3;
}
function $37d5a74137b0c6f7$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        if (!$37d5a74137b0c6f7$var$isIncrementalEvent(event)) return;
        const { source: source } = event.data;
        if ($37d5a74137b0c6f7$var$IncrementalMutationSources.has(source)) clickDetector.registerMutation(event.timestamp);
        if (source === $37d5a74137b0c6f7$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($37d5a74137b0c6f7$var$isIncrementalMouseInteraction(event)) {
            const { type: type, id: id } = event.data;
            const node = $37d5a74137b0c6f7$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $37d5a74137b0c6f7$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch  {}
}
function $37d5a74137b0c6f7$var$isIncrementalEvent(event) {
    return event.type === $37d5a74137b0c6f7$var$ReplayEventTypeIncrementalSnapshot;
}
function $37d5a74137b0c6f7$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $37d5a74137b0c6f7$var$IncrementalSource.MouseInteraction;
}
function $37d5a74137b0c6f7$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1e3,
        type: "default",
        ...breadcrumb
    };
}
var $37d5a74137b0c6f7$var$NodeType = /* @__PURE__ */ ((NodeType2)=>{
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
})($37d5a74137b0c6f7$var$NodeType || {});
const $37d5a74137b0c6f7$var$ATTRIBUTES_TO_RECORD = /* @__PURE__ */ new Set([
    "id",
    "class",
    "aria-label",
    "role",
    "name",
    "alt",
    "title",
    "data-test-id",
    "data-testid",
    "disabled",
    "aria-disabled",
    "data-sentry-component"
]);
const $37d5a74137b0c6f7$var$BREADCRUMB_RELEVANT_ATTRIBUTES = /* @__PURE__ */ new Set([
    ...$37d5a74137b0c6f7$var$ATTRIBUTES_TO_RECORD,
    "data-sentry-element"
]);
function $37d5a74137b0c6f7$var$getAttributesToRecord(attributes) {
    const obj = {};
    for(const key in attributes)if ($37d5a74137b0c6f7$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === "data-testid" || key === "data-test-id") normalizedKey = "testId";
        obj[normalizedKey] = attributes[key];
    }
    if (!obj["data-sentry-component"] && attributes["data-sentry-element"]) obj["data-sentry-component"] = attributes["data-sentry-element"];
    return obj;
}
const $37d5a74137b0c6f7$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $37d5a74137b0c6f7$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === "click";
        const event = isClick ? handlerData.event : void 0;
        if (isClick && replay.clickDetector && event?.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $37d5a74137b0c6f7$var$handleClick(replay.clickDetector, result, $37d5a74137b0c6f7$var$getClickTargetNode(handlerData.event));
        $37d5a74137b0c6f7$var$addBreadcrumbEvent(replay, result);
    };
};
function $37d5a74137b0c6f7$var$getBaseDomBreadcrumb(target, message) {
    const nodeId = $37d5a74137b0c6f7$var$record.mirror.getId(target);
    const node = nodeId && $37d5a74137b0c6f7$var$record.mirror.getNode(nodeId);
    const meta = node && $37d5a74137b0c6f7$var$record.mirror.getMeta(node);
    const element = meta && $37d5a74137b0c6f7$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node2)=>node2.type === $37d5a74137b0c6f7$var$NodeType.Text && node2.textContent).filter(Boolean).map((text)=>text.trim()).join(""),
                attributes: $37d5a74137b0c6f7$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
function $37d5a74137b0c6f7$var$handleDom(handlerData) {
    const { target: target, message: message } = $37d5a74137b0c6f7$var$getDomTarget(handlerData);
    return $37d5a74137b0c6f7$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$37d5a74137b0c6f7$var$getBaseDomBreadcrumb(target, message)
    });
}
function $37d5a74137b0c6f7$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === "click";
    let message;
    let target = null;
    try {
        target = isClick ? $37d5a74137b0c6f7$var$getClickTargetNode(handlerData.event) : $37d5a74137b0c6f7$var$getTargetNode(handlerData.event);
        message = (0, $25d1cfcd58d5af8d$export$5647df6b7814ac86)(target, {
            maxStringLength: 200
        }) || "<unknown>";
    } catch  {
        message = "<unknown>";
    }
    return {
        target: target,
        message: message
    };
}
function $37d5a74137b0c6f7$var$isElement(node) {
    return node.type === $37d5a74137b0c6f7$var$NodeType.Element;
}
function $37d5a74137b0c6f7$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    replay.updateUserActivity();
    const breadcrumb = $37d5a74137b0c6f7$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $37d5a74137b0c6f7$var$addBreadcrumbEvent(replay, breadcrumb);
}
function $37d5a74137b0c6f7$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    if (!target || $37d5a74137b0c6f7$var$isInputElement(target) || !key) return null;
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1;
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $25d1cfcd58d5af8d$export$5647df6b7814ac86)(target, {
        maxStringLength: 200
    }) || "<unknown>";
    const baseBreadcrumb = $37d5a74137b0c6f7$var$getBaseDomBreadcrumb(target, message);
    return $37d5a74137b0c6f7$var$createBreadcrumb({
        category: "ui.keyDown",
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $37d5a74137b0c6f7$var$isInputElement(target) {
    return target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable;
}
const $37d5a74137b0c6f7$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $37d5a74137b0c6f7$var$createResourceEntry,
    paint: $37d5a74137b0c6f7$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $37d5a74137b0c6f7$var$createNavigationEntry
};
function $37d5a74137b0c6f7$var$webVitalHandler(getter, replay) {
    return ({ metric: metric })=>void replay.replayPerformanceEntries.push(getter(metric));
}
function $37d5a74137b0c6f7$var$createPerformanceEntries(entries) {
    return entries.map($37d5a74137b0c6f7$var$createPerformanceEntry).filter(Boolean);
}
function $37d5a74137b0c6f7$var$createPerformanceEntry(entry) {
    const entryType = $37d5a74137b0c6f7$var$ENTRY_TYPES[entry.entryType];
    if (!entryType) return null;
    return entryType(entry);
}
function $37d5a74137b0c6f7$var$getAbsoluteTime(time) {
    return (((0, $bc81602376c48fa6$export$baf075a948ffc0bf)() || $37d5a74137b0c6f7$var$WINDOW.performance.timeOrigin) + time) / 1e3;
}
function $37d5a74137b0c6f7$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $37d5a74137b0c6f7$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: void 0
    };
}
function $37d5a74137b0c6f7$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $37d5a74137b0c6f7$var$getAbsoluteTime(startTime),
        end: $37d5a74137b0c6f7$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $37d5a74137b0c6f7$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    if ([
        "fetch",
        "xmlhttprequest"
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $37d5a74137b0c6f7$var$getAbsoluteTime(startTime),
        end: $37d5a74137b0c6f7$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
function $37d5a74137b0c6f7$var$getLargestContentfulPaint(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry?.element ? [
        lastEntry.element
    ] : void 0;
    return $37d5a74137b0c6f7$var$getWebVital(metric, "largest-contentful-paint", node);
}
function $37d5a74137b0c6f7$var$isLayoutShift(entry) {
    return entry.sources !== void 0;
}
function $37d5a74137b0c6f7$var$getCumulativeLayoutShift(metric) {
    const layoutShifts = [];
    const nodes = [];
    for (const entry of metric.entries)if ($37d5a74137b0c6f7$var$isLayoutShift(entry)) {
        const nodeIds = [];
        for (const source of entry.sources)if (source.node) {
            nodes.push(source.node);
            const nodeId = $37d5a74137b0c6f7$var$record.mirror.getId(source.node);
            if (nodeId) nodeIds.push(nodeId);
        }
        layoutShifts.push({
            value: entry.value,
            nodeIds: nodeIds.length ? nodeIds : void 0
        });
    }
    return $37d5a74137b0c6f7$var$getWebVital(metric, "cumulative-layout-shift", nodes, layoutShifts);
}
function $37d5a74137b0c6f7$var$getInteractionToNextPaint(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry?.target ? [
        lastEntry.target
    ] : void 0;
    return $37d5a74137b0c6f7$var$getWebVital(metric, "interaction-to-next-paint", node);
}
function $37d5a74137b0c6f7$var$getWebVital(metric, name, nodes, attributions) {
    const value = metric.value;
    const rating = metric.rating;
    const end = $37d5a74137b0c6f7$var$getAbsoluteTime(value);
    return {
        type: "web-vital",
        name: name,
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            rating: rating,
            nodeIds: nodes ? nodes.map((node)=>$37d5a74137b0c6f7$var$record.mirror.getId(node)) : void 0,
            attributions: attributions
        }
    };
}
function $37d5a74137b0c6f7$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries: entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        "navigation",
        "paint",
        "resource"
    ].forEach((type)=>{
        clearCallbacks.push((0, $375623e17d0e1d27$export$69816c1a049f8db6)(type, onEntries));
    });
    clearCallbacks.push((0, $375623e17d0e1d27$export$3fd4b53331200102)($37d5a74137b0c6f7$var$webVitalHandler($37d5a74137b0c6f7$var$getLargestContentfulPaint, replay)), (0, $375623e17d0e1d27$export$861b82818b37ba5b)($37d5a74137b0c6f7$var$webVitalHandler($37d5a74137b0c6f7$var$getCumulativeLayoutShift, replay)), (0, $375623e17d0e1d27$export$da3b76aa2022cbd7)($37d5a74137b0c6f7$var$webVitalHandler($37d5a74137b0c6f7$var$getInteractionToNextPaint, replay)));
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
const $37d5a74137b0c6f7$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
const $37d5a74137b0c6f7$var$t = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),s=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),a=function(t,e){for(var i=new n(31),s=0;s<31;++s)i[s]=e+=1<<t[s-1];var a=new r(i[30]);for(s=1;s<30;++s)for(var o=i[s];o<i[s+1];++o)a[o]=o-i[s]<<5|s;return{b:i,r:a}},o=a(e,2),h=o.b,f=o.r;h[28]=258,f[258]=28;for(var l=a(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,s=0,a=new n(r);s<i;++s)t[s]&&++a[t[s]-1];var o,h=new n(r);for(s=1;s<r;++s)h[s]=h[s-1]+a[s-1]<<1;if(e){o=new n(1<<r);var f=15-r;for(s=0;s<i;++s)if(t[s])for(var l=s<<4|t[s],c=r-t[s],v=h[t[s]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>f]=l}else for(o=new n(i),s=0;s<i;++s)t[s]&&(o[s]=u[h[t[s]-1]++]>>15-t[s]);return o},p=new t(288);for(c=0;c<144;++c)p[c]=8;for(c=144;c<256;++c)p[c]=9;for(c=256;c<280;++c)p[c]=7;for(c=280;c<288;++c)p[c]=8;var g=new t(32);for(c=0;c<32;++c)g[c]=5;var w=d(p,9,0),y=d(g,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},_=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},x=function(r,e){for(var i=[],s=0;s<r.length;++s)r[s]&&i.push({s:s,f:r[s]});var a=i.length,o=i.slice();if(!a)return{t:F,l:0};if(1==a){var h=new t(i[0].s+1);return h[i[0].s]=1,{t:h,l:1}}i.sort(function(t,n){return t.f-n.f}),i.push({s:-1,f:25001});var f=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:f.f+l.f,l:f,r:l};c!=a-1;)f=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:f.f+l.f,l:f,r:l};var d=o[0].s;for(s=1;s<a;++s)o[s].s>d&&(d=o[s].s);var p=new n(d+1),g=A(i[c-1],p,0);if(g>e){s=0;var w=0,y=g-e,m=1<<y;for(o.sort(function(t,n){return p[n.s]-p[t.s]||t.f-n.f});s<a;++s){var b=o[s].s;if(!(p[b]>e))break;w+=m-(1<<g-p[b]),p[b]=e}for(w>>=y;w>0;){var M=o[s].s;p[M]<e?w-=1<<e-p[M]++-1:++s}for(;s>=0&&w;--s){var E=o[s].s;p[E]==e&&(--p[E],++w)}g=e}return{t:new t(p),l:g}},A=function(t,n,r){return-1==t.s?Math.max(A(t.l,n,r+1),A(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,s=t[0],a=1,o=function(t){e[i++]=t},h=1;h<=r;++h)if(t[h]==s&&h!=r)++a;else{if(!s&&a>2){for(;a>138;a-=138)o(32754);a>2&&(o(a>10?a-11<<5|28690:a-3<<5|12305),a=0)}else if(a>3){for(o(s),--a;a>6;a-=6)o(8304);a>2&&(o(a-3<<5|8208),a=0)}for(;a--;)o(s);a=1,s=t[h]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var s=0;s<e;++s)t[i+s+4]=r[s];return 8*(i+4+e)},U=function(t,r,a,o,h,f,l,u,c,v,m){z(r,m++,a),++h[256];for(var b=x(h,15),M=b.t,E=b.l,A=x(f,15),U=A.t,C=A.l,F=D(M),I=F.c,S=F.n,L=D(U),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=x(q,7),H=G.t,J=G.l,K=19;K>4&&!H[s[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(h,p)+T(f,g)+l,X=T(h,M)+T(f,U)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(U,C,0),R=U;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[s[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=w,P=p,Q=y,R=g;for(B=0;B<u;++B){var rt=o[B];if(rt>255){_(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;_(r,m,Q[et]),m+=R[et],et>3&&(_(r,m,rt>>5&8191),m+=i[et])}else _(r,m,N[rt]),m+=P[rt]}return _(r,m,N[256]),m+P[256]},C=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,s=0|r.length,a=0;a!=s;){for(var o=Math.min(a+2655,s);a<o;++a)i+=e+=r[a];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(s,a,o,h,u){if(!u&&(u={l:1},a.dictionary)){var c=a.dictionary.subarray(-32768),v=new t(c.length+s.length);v.set(c),v.set(s,c.length),s=v,u.w=c.length}return function(s,a,o,h,u,c){var v=c.z||s.length,d=new t(h+v+5*(1+Math.ceil(v/7e3))+u),p=d.subarray(h,d.length-u),g=c.l,w=7&(c.r||0);if(a){w&&(p[0]=c.r>>3);for(var y=C[a-1],M=y>>13,E=8191&y,z=(1<<o)-1,_=c.p||new n(32768),x=c.h||new n(z+1),A=Math.ceil(o/3),D=2*A,T=function(t){return(s[t]^s[t+1]<<A^s[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=x[H];if(_[J]=K,x[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!g)){w=U(s,p,0,F,I,S,O,q,G,j-G,w),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(s[j+Q]==s[j+Q-W]){for(var $=0;$<Z&&s[j+$]==s[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-_[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=_[J])&32767}if(R){F[q++]=268435456|f[Q]<<18|l[R];var it=31&f[Q],st=31&l[R];O+=e[it]+i[st],++I[257+it],++S[st],B=j+Q,++L}else F[q++]=s[j],++I[s[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=s[j],++I[s[j]];w=U(s,p,g,F,I,S,O,q,G,j-G,w),g||(c.r=7&w|p[w/8|0]<<3,w-=7,c.h=x,c.p=_,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+g;j+=65535){var at=j+65535;at>=v&&(p[w/8|0]=g,at=v),w=k(p,w+1,s.subarray(j,at))}c.i=v}return b(d,0,h+m(w)+u)}(s,null==a.level?6:a.level,null==a.mem?u.l?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(s.length)))):20:12+a.mem,o,h,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var s=this.b.length-this.s.z;this.b.set(n.subarray(0,s),this.s.z),this.s.z=this.b.length,this.p(this.b,!1),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(s),32768),this.s.z=n.length-s+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n.prototype.flush=function(){this.ondata||E(5),this.s.l&&E(4),this.p(this.b,!1),this.s.w=this.s.i,this.s.i-=2},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,s=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),a=s.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(s,n),O(s,a-8,r.d()),O(s,a-4,e),s}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t.prototype.flush=function(){j.prototype.flush.call(this)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(G)return G.encode(n);for(var e=n.length,i=new t(n.length+(n.length>>1)),s=0,a=function(t){i[s++]=t},o=0;o<e;++o){if(s+5>i.length){var h=new t(s+8+(e-o<<1));h.set(i),i=h}var f=n.charCodeAt(o);f<128||r?a(f):f<2048?(a(192|f>>6),a(128|63&f)):f>55295&&f<57344?(a(240|(f=65536+(1047552&f)|1023&n.charCodeAt(++o))>>18),a(128|f>>12&63),a(128|f>>6&63),a(128|63&f)):(a(224|f>>12),a(128|f>>6&63),a(128|63&f))}return b(i,0,s)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(const r of t)n+=r.length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J((t,n)=>{this.deflate.push(t,n)}),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}}),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $37d5a74137b0c6f7$var$e() {
    const e2 = new Blob([
        $37d5a74137b0c6f7$var$t
    ], {
        type: "text/javascript"
    });
    return URL.createObjectURL(e2);
}
const $37d5a74137b0c6f7$var$CONSOLE_LEVELS = [
    "log",
    "warn",
    "error"
];
const $37d5a74137b0c6f7$var$PREFIX = "[Replay] ";
function $37d5a74137b0c6f7$var$_addBreadcrumb(message, level = "info") {
    (0, $777cacbd1bed0b63$export$efda9a273d7a036d)({
        category: "console",
        data: {
            logger: "replay"
        },
        level: level,
        message: `${$37d5a74137b0c6f7$var$PREFIX}${message}`
    }, {
        level: level
    });
}
function $37d5a74137b0c6f7$var$makeReplayDebugLogger() {
    let _capture = false;
    let _trace = false;
    const _debug = {
        exception: ()=>void 0,
        infoTick: ()=>void 0,
        setConfig: (opts)=>{
            _capture = !!opts.captureExceptions;
            _trace = !!opts.traceInternals;
        }
    };
    if ($37d5a74137b0c6f7$var$DEBUG_BUILD) {
        $37d5a74137b0c6f7$var$CONSOLE_LEVELS.forEach((name)=>{
            _debug[name] = (...args)=>{
                (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05)[name]($37d5a74137b0c6f7$var$PREFIX, ...args);
                if (_trace) $37d5a74137b0c6f7$var$_addBreadcrumb(args.join(""), (0, $9e4658f0600c3fda$export$d771ef054122c30a)(name));
            };
        });
        _debug.exception = (error, ...message)=>{
            if (message.length && _debug.error) _debug.error(...message);
            (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error($37d5a74137b0c6f7$var$PREFIX, error);
            if (_capture) (0, $6918c722b531ff18$export$f5282963edea4a68)(error, {
                mechanism: {
                    handled: true,
                    type: "auto.function.replay.debug"
                }
            });
            else if (_trace) $37d5a74137b0c6f7$var$_addBreadcrumb(error, "error");
        };
        _debug.infoTick = (...args)=>{
            (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log($37d5a74137b0c6f7$var$PREFIX, ...args);
            if (_trace) setTimeout(()=>$37d5a74137b0c6f7$var$_addBreadcrumb(args[0]), 0);
        };
    } else $37d5a74137b0c6f7$var$CONSOLE_LEVELS.forEach((name)=>{
        _debug[name] = ()=>void 0;
    });
    return _debug;
}
const $37d5a74137b0c6f7$var$debug = $37d5a74137b0c6f7$var$makeReplayDebugLogger();
class $37d5a74137b0c6f7$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$37d5a74137b0c6f7$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
class $37d5a74137b0c6f7$var$WorkerDestroyedError extends Error {
    constructor(){
        super("Worker destroyed");
    }
}
class $37d5a74137b0c6f7$var$EventBufferArray {
    constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
        this.waitForCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return "sync";
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $37d5a74137b0c6f7$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $37d5a74137b0c6f7$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        let ts = null;
        for (const { timestamp: timestamp } of this.events)if (ts === null || timestamp < ts) ts = timestamp;
        return ts === null ? ts : $37d5a74137b0c6f7$var$timestampToMs(ts);
    }
}
class $37d5a74137b0c6f7$var$WorkerHandler {
    constructor(worker){
        this._onMessage = ({ data: data })=>{
            const response = data;
            if (typeof response.id !== "number") return;
            const pending = this._pending.get(response.id);
            if (!pending || pending.method !== response.method) return;
            this._pending.delete(response.id);
            if (!response.success) {
                $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.error("Error in compression worker: ", response.response);
                pending.reject(new Error("Error in compression worker"));
                return;
            }
            pending.resolve(response.response);
        };
        this._worker = worker;
        this._id = 0;
        this._pending = /* @__PURE__ */ new Map();
        this._worker.addEventListener("message", this._onMessage);
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */ ensureReady() {
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener("message", ({ data: data })=>{
                if (data.success) resolve();
                else {
                    $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.warn("Received worker message with unsuccessful status", data);
                    reject(new Error("Received worker message with unsuccessful status"));
                }
            }, {
                once: true
            });
            this._worker.addEventListener("error", (error)=>{
                $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.warn("Failed to load Replay compression worker", error);
                reject(new Error(`Failed to load Replay compression worker: ${error instanceof ErrorEvent && error.message ? error.message : "Unknown error. This can happen due to CSP policy restrictions, network issues, or the worker script failing to load."}`));
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.log("Destroying compression worker");
        this._worker.removeEventListener("message", this._onMessage);
        this._pending.forEach((pending)=>pending.reject(new $37d5a74137b0c6f7$var$WorkerDestroyedError()));
        this._pending.clear();
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            this._pending.set(id, {
                method: method,
                resolve: resolve,
                reject: reject
            });
            try {
                this._worker.postMessage({
                    id: id,
                    method: method,
                    arg: arg
                });
            } catch (error) {
                this._pending.delete(id);
                reject(error);
            }
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
class $37d5a74137b0c6f7$var$EventBufferCompressionWorker {
    constructor(worker){
        this._worker = new $37d5a74137b0c6f7$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        this.waitForCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return "worker";
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully received and processed by worker.
   */ addEvent(event) {
        const timestamp = $37d5a74137b0c6f7$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $37d5a74137b0c6f7$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $37d5a74137b0c6f7$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        this._worker.postMessage("clear").then(null, (e)=>{
            $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.exception(e, 'Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage("addEvent", data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage("finish");
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
class $37d5a74137b0c6f7$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $37d5a74137b0c6f7$var$EventBufferArray();
        this._compression = new $37d5a74137b0c6f7$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get waitForCheckout() {
        return this._used.waitForCheckout;
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
    set waitForCheckout(value) {
        this._used.waitForCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.exception(error, "Failed to load the compression worker, falling back to simple buffer");
            return;
        }
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout, waitForCheckout: waitForCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        this._compression.waitForCheckout = waitForCheckout;
        this._used = this._compression;
        try {
            await Promise.all(addEventPromises);
            this._fallback.clear();
        } catch (error) {
            if (error instanceof $37d5a74137b0c6f7$var$WorkerDestroyedError) return;
            $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.exception(error, "Failed to add events when switching buffers.");
        }
    }
}
function $37d5a74137b0c6f7$var$createEventBuffer({ useCompression: useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = $37d5a74137b0c6f7$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.log("Using simple buffer");
    return new $37d5a74137b0c6f7$var$EventBufferArray();
}
function $37d5a74137b0c6f7$var$_loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || $37d5a74137b0c6f7$var$_getWorkerUrl();
        if (!workerUrl) return;
        $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.log(`Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ""}`);
        const worker = new Worker(workerUrl);
        return new $37d5a74137b0c6f7$var$EventBufferProxy(worker);
    } catch (error) {
        $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.exception(error, "Failed to create compression worker");
    }
}
function $37d5a74137b0c6f7$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === "undefined" || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $37d5a74137b0c6f7$var$e();
    return "";
}
function $37d5a74137b0c6f7$var$hasSessionStorage() {
    try {
        return "sessionStorage" in $37d5a74137b0c6f7$var$WINDOW && !!$37d5a74137b0c6f7$var$WINDOW.sessionStorage;
    } catch  {
        return false;
    }
}
function $37d5a74137b0c6f7$var$clearSession(replay) {
    $37d5a74137b0c6f7$var$deleteSession();
    replay.session = void 0;
}
function $37d5a74137b0c6f7$var$deleteSession() {
    if (!$37d5a74137b0c6f7$var$hasSessionStorage()) return;
    try {
        $37d5a74137b0c6f7$var$WINDOW.sessionStorage.removeItem($37d5a74137b0c6f7$var$REPLAY_SESSION_KEY);
    } catch  {}
}
function $37d5a74137b0c6f7$var$isSampled(sampleRate) {
    if (sampleRate === void 0) return false;
    return Math.random() < sampleRate;
}
function $37d5a74137b0c6f7$var$saveSession(session) {
    if (!$37d5a74137b0c6f7$var$hasSessionStorage()) return;
    try {
        $37d5a74137b0c6f7$var$WINDOW.sessionStorage.setItem($37d5a74137b0c6f7$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch  {}
}
function $37d5a74137b0c6f7$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $cc262db35458e4b3$export$19f53698e68b2496)();
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    const dirty = session.dirty || false;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId,
        dirty: dirty
    };
}
function $37d5a74137b0c6f7$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $37d5a74137b0c6f7$var$isSampled(sessionSampleRate) ? "session" : allowBuffering ? "buffer" : false;
}
function $37d5a74137b0c6f7$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $37d5a74137b0c6f7$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $37d5a74137b0c6f7$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $37d5a74137b0c6f7$var$saveSession(session);
    return session;
}
function $37d5a74137b0c6f7$var$fetchSession() {
    if (!$37d5a74137b0c6f7$var$hasSessionStorage()) return null;
    try {
        const sessionStringFromStorage = $37d5a74137b0c6f7$var$WINDOW.sessionStorage.getItem($37d5a74137b0c6f7$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.infoTick("Loading existing session");
        return $37d5a74137b0c6f7$var$makeSession(sessionObj);
    } catch  {
        return null;
    }
}
function $37d5a74137b0c6f7$var$isExpired(initialTime, expiry, targetTime = +/* @__PURE__ */ new Date()) {
    if (initialTime === null || expiry === void 0 || expiry < 0) return true;
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
function $37d5a74137b0c6f7$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $37d5a74137b0c6f7$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $37d5a74137b0c6f7$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
function $37d5a74137b0c6f7$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    if (!$37d5a74137b0c6f7$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    if (session.sampled === "buffer" && session.segmentId === 0) return false;
    return true;
}
function $37d5a74137b0c6f7$var$loadOrCreateSession({ sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $37d5a74137b0c6f7$var$fetchSession();
    if (!existingSession) {
        $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.infoTick("Creating new session");
        return $37d5a74137b0c6f7$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$37d5a74137b0c6f7$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.infoTick("Session in sessionStorage is expired, creating new one...");
    return $37d5a74137b0c6f7$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $37d5a74137b0c6f7$var$isCustomEvent(event) {
    return event.type === $37d5a74137b0c6f7$var$EventType.Custom;
}
function $37d5a74137b0c6f7$var$addEventSync(replay, event, isCheckout) {
    if (!$37d5a74137b0c6f7$var$shouldAddEvent(replay, event)) return false;
    $37d5a74137b0c6f7$var$_addEvent(replay, event, isCheckout);
    return true;
}
function $37d5a74137b0c6f7$var$addEvent(replay, event, isCheckout) {
    if (!$37d5a74137b0c6f7$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $37d5a74137b0c6f7$var$_addEvent(replay, event, isCheckout);
}
async function $37d5a74137b0c6f7$var$_addEvent(replay, event, isCheckout) {
    const { eventBuffer: eventBuffer } = replay;
    if (!eventBuffer || eventBuffer.waitForCheckout && !isCheckout) return null;
    const isBufferMode = replay.recordingMode === "buffer";
    try {
        if (isCheckout && isBufferMode) eventBuffer.clear();
        if (isCheckout) {
            eventBuffer.hasCheckout = true;
            eventBuffer.waitForCheckout = false;
        }
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $37d5a74137b0c6f7$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        if (!replay.isEnabled()) {
            replay.handleException(error);
            return null;
        }
        const isExceeded = error && error instanceof $37d5a74137b0c6f7$var$EventBufferSizeExceededError;
        const reason = isExceeded ? "eventBufferOverflow" : "eventBufferError";
        const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
        if (client) {
            const dropReason = isExceeded ? "buffer_overflow" : "internal_sdk_error";
            client.recordDroppedEvent(dropReason, "replay");
        }
        if (isExceeded && isBufferMode) {
            eventBuffer.clear();
            eventBuffer.waitForCheckout = true;
            return null;
        }
        replay.handleException(error);
        await replay.stop({
            reason: reason
        });
    }
}
function $37d5a74137b0c6f7$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $37d5a74137b0c6f7$var$timestampToMs(event.timestamp);
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.infoTick(`Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`);
        return false;
    }
    return true;
}
function $37d5a74137b0c6f7$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === "function" && $37d5a74137b0c6f7$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.exception(error, "An error occurred in the `beforeAddRecordingEvent` callback, skipping the event...");
        return null;
    }
    return event;
}
const $37d5a74137b0c6f7$var$MAX_CONTEXT_VALUES = 100;
function $37d5a74137b0c6f7$var$addSegmentDetailsToContext(replay, traceId, segmentName) {
    const replayContext = replay.getContext();
    if (traceId && replayContext.traceIds.size < $37d5a74137b0c6f7$var$MAX_CONTEXT_VALUES) replayContext.traceIds.add(traceId);
    if (segmentName && replayContext.segmentNames.size < $37d5a74137b0c6f7$var$MAX_CONTEXT_VALUES) replayContext.segmentNames.add(segmentName);
}
function $37d5a74137b0c6f7$var$handleProcessSegmentSpan(replay) {
    return (spanJSON)=>{
        if (!replay.isEnabled()) return;
        $37d5a74137b0c6f7$var$addSegmentDetailsToContext(replay, spanJSON.trace_id, spanJSON.name || void 0);
    };
}
function $37d5a74137b0c6f7$var$isErrorEvent(event) {
    return !event.type;
}
function $37d5a74137b0c6f7$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
function $37d5a74137b0c6f7$var$isReplayEvent(event) {
    return event.type === "replay_event";
}
function $37d5a74137b0c6f7$var$isFeedbackEvent(event) {
    return event.type === "feedback";
}
function $37d5a74137b0c6f7$var$handleAfterSendEvent(replay) {
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$37d5a74137b0c6f7$var$isErrorEvent(event) && !$37d5a74137b0c6f7$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse.statusCode;
        if (!statusCode || statusCode < 200 || statusCode >= 300) return;
        if ($37d5a74137b0c6f7$var$isTransactionEvent(event)) {
            $37d5a74137b0c6f7$var$handleTransactionEvent(replay, event);
            return;
        }
        $37d5a74137b0c6f7$var$handleErrorEvent(replay, event);
    };
}
function $37d5a74137b0c6f7$var$handleTransactionEvent(replay, event) {
    $37d5a74137b0c6f7$var$addSegmentDetailsToContext(replay, event.contexts?.trace?.trace_id, event.transaction);
}
function $37d5a74137b0c6f7$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    if (replay.recordingMode !== "buffer" || !event.tags?.replayId) return;
    const { beforeErrorSampling: beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === "function" && !beforeErrorSampling(event)) return;
    (0, $295fbc3e705f470c$export$831dc9f2ab0a617b)(async ()=>{
        try {
            await replay.sendBufferedReplayOrFlush();
        } catch (err) {
            replay.handleException(err);
        }
    });
}
function $37d5a74137b0c6f7$var$handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !$37d5a74137b0c6f7$var$isErrorEvent(event)) return;
        $37d5a74137b0c6f7$var$handleHydrationError(replay, event);
    };
}
function $37d5a74137b0c6f7$var$handleHydrationError(replay, event) {
    const exceptionValue = event.exception?.values?.[0]?.value;
    if (typeof exceptionValue !== "string") return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    // With newer React versions, the messages changed to a different website https://react.dev/errors/418
    exceptionValue.match(/(reactjs\.org\/docs\/error-decoder\.html\?invariant=|react\.dev\/errors\/)(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = $37d5a74137b0c6f7$var$createBreadcrumb({
            category: "replay.hydrate-error",
            data: {
                url: (0, $caac489b9d8395b2$export$1cfafeee2987818b)()
            }
        });
        $37d5a74137b0c6f7$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
function $37d5a74137b0c6f7$var$handleBreadcrumbs(replay) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (!client) return;
    client.on("beforeAddBreadcrumb", (breadcrumb)=>$37d5a74137b0c6f7$var$beforeAddBreadcrumb(replay, breadcrumb));
}
function $37d5a74137b0c6f7$var$beforeAddBreadcrumb(replay, breadcrumb) {
    if (!replay.isEnabled() || !$37d5a74137b0c6f7$var$isBreadcrumbWithCategory(breadcrumb)) return;
    const result = $37d5a74137b0c6f7$var$normalizeBreadcrumb(breadcrumb);
    if (result) $37d5a74137b0c6f7$var$addBreadcrumbEvent(replay, result);
}
function $37d5a74137b0c6f7$var$normalizeBreadcrumb(breadcrumb) {
    if (!$37d5a74137b0c6f7$var$isBreadcrumbWithCategory(breadcrumb) || [
        // fetch & xhr are handled separately,in handleNetworkBreadcrumbs
        "fetch",
        "xhr",
        // These two are breadcrumbs for emitted sentry events, we don't care about them
        "sentry.event",
        "sentry.transaction"
    ].includes(breadcrumb.category) || // We capture UI breadcrumbs separately
    breadcrumb.category.startsWith("ui.")) return null;
    if (breadcrumb.category === "console") return $37d5a74137b0c6f7$var$normalizeConsoleBreadcrumb(breadcrumb);
    return $37d5a74137b0c6f7$var$createBreadcrumb(breadcrumb);
}
function $37d5a74137b0c6f7$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data?.arguments;
    if (!Array.isArray(args) || args.length === 0) return $37d5a74137b0c6f7$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === "string") {
            if (arg.length > $37d5a74137b0c6f7$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $37d5a74137b0c6f7$var$CONSOLE_ARG_MAX_SIZE)}\u2026`;
            }
            return arg;
        }
        if (typeof arg === "object") try {
            const normalizedArg = (0, $2d7134eeb4bc669b$export$a3295358bff77e)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $37d5a74137b0c6f7$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, $37d5a74137b0c6f7$var$CONSOLE_ARG_MAX_SIZE)}\u2026`;
            }
            return normalizedArg;
        } catch  {}
        return arg;
    });
    return $37d5a74137b0c6f7$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        "CONSOLE_ARG_TRUNCATED"
                    ]
                }
            } : {}
        }
    });
}
function $37d5a74137b0c6f7$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
function $37d5a74137b0c6f7$var$isRrwebError(event, hint) {
    if (event.type || !event.exception?.values?.length) return false;
    if (hint.originalException?.__rrweb__) return true;
    return false;
}
function $37d5a74137b0c6f7$var$resetReplayIdOnDynamicSamplingContext() {
    const dsc = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().getPropagationContext().dsc;
    if (dsc) delete dsc.replay_id;
    const activeSpan = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
    if (activeSpan) {
        const dsc2 = (0, $09fae5ef8120e803$export$a117f995597e25df)(activeSpan);
        delete dsc2.replay_id;
    }
}
function $37d5a74137b0c6f7$var$setReplayIdOnDynamicSamplingContext(replayId) {
    const dsc = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().getPropagationContext().dsc;
    if (dsc) dsc.replay_id = replayId;
    const activeSpan = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
    if (activeSpan) {
        const dsc2 = (0, $09fae5ef8120e803$export$a117f995597e25df)(activeSpan);
        dsc2.replay_id = replayId;
    }
}
function $37d5a74137b0c6f7$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) return true;
        replay.throttledAddEvent({
            type: $37d5a74137b0c6f7$var$EventType.Custom,
            timestamp: event.timestamp * 1e3,
            data: {
                tag: "breadcrumb",
                payload: {
                    timestamp: event.timestamp,
                    type: "default",
                    category: "sentry.feedback",
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
function $37d5a74137b0c6f7$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== "buffer") return false;
    if (event.message === $37d5a74137b0c6f7$var$UNABLE_TO_SEND_REPLAY) return false;
    if (!event.exception || event.type) return false;
    return $37d5a74137b0c6f7$var$isSampled(replay.getOptions().errorSampleRate);
}
function $37d5a74137b0c6f7$var$handleGlobalEventListener(replay) {
    return Object.assign((event, hint)=>{
        if (replay.session && $37d5a74137b0c6f7$var$shouldRefreshSession(replay.session, {
            maxReplayDuration: replay.getOptions().maxReplayDuration,
            sessionIdleExpire: replay.timeouts.sessionIdleExpire
        })) $37d5a74137b0c6f7$var$resetReplayIdOnDynamicSamplingContext();
        if (!replay.isEnabled() || replay.isPaused()) return event;
        if ($37d5a74137b0c6f7$var$isReplayEvent(event)) {
            delete event.breadcrumbs;
            return event;
        }
        if (!$37d5a74137b0c6f7$var$isErrorEvent(event) && !$37d5a74137b0c6f7$var$isTransactionEvent(event) && !$37d5a74137b0c6f7$var$isFeedbackEvent(event)) return event;
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            $37d5a74137b0c6f7$var$resetReplayIdOnDynamicSamplingContext();
            return event;
        }
        if ($37d5a74137b0c6f7$var$isFeedbackEvent(event)) {
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            $37d5a74137b0c6f7$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        if ($37d5a74137b0c6f7$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.log("Ignoring error from rrweb internals", event);
            return null;
        }
        const isErrorEventSampled = $37d5a74137b0c6f7$var$shouldSampleForBufferEvent(replay, event);
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === "session";
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        if (isErrorEventSampled && replay.recordingMode === "buffer" && replay.session?.sampled === "buffer") {
            const session = replay.session;
            session.dirty = true;
            if (replay.getOptions().stickySession) $37d5a74137b0c6f7$var$saveSession(session);
        }
        return event;
    }, {
        id: "Replay"
    });
}
function $37d5a74137b0c6f7$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $37d5a74137b0c6f7$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: "performanceSpan",
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        return typeof response === "string" ? Promise.resolve(null) : response;
    });
}
function $37d5a74137b0c6f7$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1e3;
    return {
        type: "navigation.push",
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
function $37d5a74137b0c6f7$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $37d5a74137b0c6f7$var$handleHistory(handlerData);
        if (result === null) return;
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $37d5a74137b0c6f7$var$createPerformanceSpans(replay, [
                result
            ]);
            return false;
        });
    };
}
function $37d5a74137b0c6f7$var$shouldFilterRequest(replay, url) {
    if ($37d5a74137b0c6f7$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $7b9954de727fbe52$export$d92e61f5600202af)(url, (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)());
}
function $37d5a74137b0c6f7$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($37d5a74137b0c6f7$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $37d5a74137b0c6f7$var$createPerformanceSpans(replay, [
            result
        ]);
        return true;
    });
}
function $37d5a74137b0c6f7$var$getBodySize(body) {
    if (!body) return void 0;
    const textEncoder = new TextEncoder();
    try {
        if (typeof body === "string") return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = (0, $b3543acae904e2dc$export$2f1b0f57f243f270)(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    } catch  {}
    return void 0;
}
function $37d5a74137b0c6f7$var$parseContentLengthHeader(header) {
    if (!header) return void 0;
    const size = parseInt(header, 10);
    return isNaN(size) ? void 0 : size;
}
function $37d5a74137b0c6f7$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: void 0,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
function $37d5a74137b0c6f7$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1e3,
        end: endTimestamp / 1e3,
        name: url,
        data: {
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        }
    };
    return result;
}
function $37d5a74137b0c6f7$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                "URL_SKIPPED"
            ]
        }
    };
}
function $37d5a74137b0c6f7$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return void 0;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $37d5a74137b0c6f7$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings?.length) info._meta = {
        warnings: warnings
    };
    return info;
}
function $37d5a74137b0c6f7$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.entries(headers).reduce((filteredHeaders, [key, value])=>{
        const normalizedKey = key.toLowerCase();
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = value;
        return filteredHeaders;
    }, {});
}
function $37d5a74137b0c6f7$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== "string") return {
        body: body
    };
    const exceedsSizeLimit = body.length > $37d5a74137b0c6f7$var$NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = $37d5a74137b0c6f7$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, $37d5a74137b0c6f7$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                "MAYBE_JSON_TRUNCATED"
            ]
        };
        return {
            body: `${truncatedBody}\u2026`,
            warnings: [
                "TEXT_TRUNCATED"
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch  {}
    return {
        body: body
    };
}
function $37d5a74137b0c6f7$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    return first === "[" && last === "]" || first === "{" && last === "}";
}
function $37d5a74137b0c6f7$var$urlMatches(url, urls) {
    const fullUrl = $37d5a74137b0c6f7$var$getFullUrl(url);
    return (0, $e534db390d1e4996$export$a7a5ec66062ea5d)(fullUrl, urls);
}
function $37d5a74137b0c6f7$var$getFullUrl(url, baseURI = $37d5a74137b0c6f7$var$WINDOW.document.baseURI) {
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith($37d5a74137b0c6f7$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    if (!url.endsWith("/") && fullUrl.endsWith("/")) return fullUrl.slice(0, -1);
    return fullUrl;
}
async function $37d5a74137b0c6f7$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $37d5a74137b0c6f7$var$_prepareFetchData(breadcrumb, hint, options);
        const result = $37d5a74137b0c6f7$var$makeNetworkReplayBreadcrumb("resource.fetch", data);
        $37d5a74137b0c6f7$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.exception(error, "Failed to capture fetch breadcrumb");
    }
}
function $37d5a74137b0c6f7$var$enrichFetchBreadcrumb(breadcrumb, hint) {
    const { input: input, response: response } = hint;
    const body = input ? (0, $b3543acae904e2dc$export$ad44edf8012ec314)(input) : void 0;
    const reqSize = $37d5a74137b0c6f7$var$getBodySize(body);
    const resSize = response ? $37d5a74137b0c6f7$var$parseContentLengthHeader(response.headers.get("content-length")) : void 0;
    if (reqSize !== void 0) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== void 0) breadcrumb.data.response_body_size = resSize;
}
async function $37d5a74137b0c6f7$var$_prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $37d5a74137b0c6f7$var$urlMatches(url, options.networkDetailAllowUrls) && !$37d5a74137b0c6f7$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $37d5a74137b0c6f7$var$_getRequestInfo(options, hint.input, requestBodySize) : $37d5a74137b0c6f7$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $37d5a74137b0c6f7$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $37d5a74137b0c6f7$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? $37d5a74137b0c6f7$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $37d5a74137b0c6f7$var$buildNetworkRequestOrResponse(headers, requestBodySize, void 0);
    const requestBody = (0, $b3543acae904e2dc$export$ad44edf8012ec314)(input);
    const [bodyStr, warning] = (0, $b3543acae904e2dc$export$945a2d5364608d5)(requestBody, $37d5a74137b0c6f7$var$debug);
    const data = $37d5a74137b0c6f7$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $37d5a74137b0c6f7$var$mergeWarning(data, warning);
    return data;
}
async function $37d5a74137b0c6f7$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== void 0) return $37d5a74137b0c6f7$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? $37d5a74137b0c6f7$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== void 0) return $37d5a74137b0c6f7$var$buildNetworkRequestOrResponse(headers, responseBodySize, void 0);
    const [bodyText, warning] = await $37d5a74137b0c6f7$var$_parseFetchResponseBody(response);
    const result = $37d5a74137b0c6f7$var$getResponseData(bodyText, {
        networkCaptureBodies: networkCaptureBodies,
        responseBodySize: responseBodySize,
        captureDetails: captureDetails,
        headers: headers
    });
    if (warning) return $37d5a74137b0c6f7$var$mergeWarning(result, warning);
    return result;
}
function $37d5a74137b0c6f7$var$getResponseData(bodyText, { networkCaptureBodies: networkCaptureBodies, responseBodySize: responseBodySize, captureDetails: captureDetails, headers: headers }) {
    try {
        const size = bodyText?.length && responseBodySize === void 0 ? $37d5a74137b0c6f7$var$getBodySize(bodyText) : responseBodySize;
        if (!captureDetails) return $37d5a74137b0c6f7$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $37d5a74137b0c6f7$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $37d5a74137b0c6f7$var$buildNetworkRequestOrResponse(headers, size, void 0);
    } catch (error) {
        $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.exception(error, "Failed to serialize response body");
        return $37d5a74137b0c6f7$var$buildNetworkRequestOrResponse(headers, responseBodySize, void 0);
    }
}
async function $37d5a74137b0c6f7$var$_parseFetchResponseBody(response) {
    const res = $37d5a74137b0c6f7$var$_tryCloneResponse(response);
    if (!res) return [
        void 0,
        "BODY_PARSE_ERROR"
    ];
    try {
        const text = await $37d5a74137b0c6f7$var$_tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        if (error instanceof Error && error.message.indexOf("Timeout") > -1) {
            $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.warn("Parsing text body from response timed out");
            return [
                void 0,
                "BODY_PARSE_TIMEOUT"
            ];
        }
        $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.exception(error, "Failed to get text body from response");
        return [
            void 0,
            "BODY_PARSE_ERROR"
        ];
    }
}
function $37d5a74137b0c6f7$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $37d5a74137b0c6f7$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== "string") return $37d5a74137b0c6f7$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $37d5a74137b0c6f7$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $37d5a74137b0c6f7$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $37d5a74137b0c6f7$var$getAllHeaders(headers, allowedHeaders);
    if (Array.isArray(headers)) return {};
    return $37d5a74137b0c6f7$var$getAllowedHeaders(headers, allowedHeaders);
}
function $37d5a74137b0c6f7$var$_tryCloneResponse(response) {
    try {
        return response.clone();
    } catch (error) {
        $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.exception(error, "Failed to clone response body");
    }
}
function $37d5a74137b0c6f7$var$_tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = (0, $295fbc3e705f470c$export$831dc9f2ab0a617b)(()=>reject(new Error("Timeout while trying to read response body")), 500);
        $37d5a74137b0c6f7$var$_getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function $37d5a74137b0c6f7$var$_getResponseText(response) {
    return await response.text();
}
async function $37d5a74137b0c6f7$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $37d5a74137b0c6f7$var$_prepareXhrData(breadcrumb, hint, options);
        const result = $37d5a74137b0c6f7$var$makeNetworkReplayBreadcrumb("resource.xhr", data);
        $37d5a74137b0c6f7$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.exception(error, "Failed to capture xhr breadcrumb");
    }
}
function $37d5a74137b0c6f7$var$enrichXhrBreadcrumb(breadcrumb, hint) {
    const { xhr: xhr, input: input } = hint;
    if (!xhr) return;
    const reqSize = $37d5a74137b0c6f7$var$getBodySize(input);
    const resSize = xhr.getResponseHeader("content-length") ? $37d5a74137b0c6f7$var$parseContentLengthHeader(xhr.getResponseHeader("content-length")) : $37d5a74137b0c6f7$var$_getBodySize(xhr.response, xhr.responseType);
    if (reqSize !== void 0) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== void 0) breadcrumb.data.response_body_size = resSize;
}
function $37d5a74137b0c6f7$var$_prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !$37d5a74137b0c6f7$var$urlMatches(url, options.networkDetailAllowUrls) || $37d5a74137b0c6f7$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request2 = $37d5a74137b0c6f7$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response2 = $37d5a74137b0c6f7$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request2,
            response: response2
        };
    }
    const xhrInfo = xhr[0, $447740b7cde7d984$export$55b6bb1e45c6cf59];
    const networkRequestHeaders = xhrInfo ? $37d5a74137b0c6f7$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $37d5a74137b0c6f7$var$getAllowedHeaders((0, $b3543acae904e2dc$export$ce71c337afb62ea)(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? (0, $b3543acae904e2dc$export$945a2d5364608d5)(input, $37d5a74137b0c6f7$var$debug) : [
        void 0
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? $37d5a74137b0c6f7$var$_getXhrResponseBody(xhr) : [
        void 0
    ];
    const request = $37d5a74137b0c6f7$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = $37d5a74137b0c6f7$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $37d5a74137b0c6f7$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $37d5a74137b0c6f7$var$mergeWarning(response, responseWarning) : response
    };
}
function $37d5a74137b0c6f7$var$_getXhrResponseBody(xhr) {
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    try {
        return $37d5a74137b0c6f7$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.warn("Failed to get xhr response body", ...errors);
    return [
        void 0
    ];
}
function $37d5a74137b0c6f7$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === "json" && (0, $13cf2ed412f405fa$export$c10d0b04eaa80a43)(body)) return [
            JSON.stringify(body)
        ];
        if (!body) return [
            void 0
        ];
    } catch (error) {
        $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.exception(error, "Failed to serialize body", body);
        return [
            void 0,
            "BODY_PARSE_ERROR"
        ];
    }
    $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.log("Skipping network body because of body type", body);
    return [
        void 0,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $37d5a74137b0c6f7$var$_getBodySize(body, responseType) {
    try {
        const bodyStr = responseType === "json" && (0, $13cf2ed412f405fa$export$c10d0b04eaa80a43)(body) ? JSON.stringify(body) : body;
        return $37d5a74137b0c6f7$var$getBodySize(bodyStr);
    } catch  {
        return void 0;
    }
}
function $37d5a74137b0c6f7$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    try {
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client) client.on("beforeAddBreadcrumb", (breadcrumb, hint)=>$37d5a74137b0c6f7$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
    } catch  {}
}
function $37d5a74137b0c6f7$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($37d5a74137b0c6f7$var$_isXhrBreadcrumb(breadcrumb) && $37d5a74137b0c6f7$var$_isXhrHint(hint)) {
            $37d5a74137b0c6f7$var$enrichXhrBreadcrumb(breadcrumb, hint);
            $37d5a74137b0c6f7$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($37d5a74137b0c6f7$var$_isFetchBreadcrumb(breadcrumb) && $37d5a74137b0c6f7$var$_isFetchHint(hint)) {
            $37d5a74137b0c6f7$var$enrichFetchBreadcrumb(breadcrumb, hint);
            $37d5a74137b0c6f7$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.exception(e, "Error when enriching network breadcrumb");
    }
}
function $37d5a74137b0c6f7$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === "xhr";
}
function $37d5a74137b0c6f7$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === "fetch";
}
function $37d5a74137b0c6f7$var$_isXhrHint(hint) {
    return hint?.xhr;
}
function $37d5a74137b0c6f7$var$_isFetchHint(hint) {
    return hint?.input !== void 0;
}
function $37d5a74137b0c6f7$var$addGlobalListeners(replay) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    (0, $65432d81f3633cf8$export$5aeffd3db2cf9df7)($37d5a74137b0c6f7$var$handleDomListener(replay));
    (0, $44e96bc00aeade7b$export$3f18c56c58114e75)($37d5a74137b0c6f7$var$handleHistorySpanListener(replay));
    $37d5a74137b0c6f7$var$handleBreadcrumbs(replay);
    $37d5a74137b0c6f7$var$handleNetworkBreadcrumbs(replay);
    const eventProcessor = $37d5a74137b0c6f7$var$handleGlobalEventListener(replay);
    (0, $6918c722b531ff18$export$9aac0b9f77928fbf)(eventProcessor);
    if (client) {
        client.on("beforeSendEvent", $37d5a74137b0c6f7$var$handleBeforeSendEvent(replay));
        client.on("afterSendEvent", $37d5a74137b0c6f7$var$handleAfterSendEvent(replay));
        client.on("createDsc", (dsc)=>{
            const replayId = replay.getSessionId();
            if (replayId && replay.isEnabled() && replay.recordingMode === "session") {
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on("processSegmentSpan", $37d5a74137b0c6f7$var$handleProcessSegmentSpan(replay));
        client.on("spanStart", (span)=>{
            replay.lastActiveSpan = span;
        });
        client.on("spanEnd", (span)=>{
            replay.lastActiveSpan = span;
        });
        client.on("beforeSendFeedback", async (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options?.includeReplay && replay.isEnabled() && replayId && feedbackEvent.contexts?.feedback) {
                if (feedbackEvent.contexts.feedback.source === "api") await replay.sendBufferedReplayOrFlush();
                feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
        client.on("openFeedbackWidget", async ()=>{
            await replay.sendBufferedReplayOrFlush();
        });
    }
}
async function $37d5a74137b0c6f7$var$addMemoryEntry(replay) {
    try {
        return Promise.all($37d5a74137b0c6f7$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $37d5a74137b0c6f7$var$createMemoryEntry($37d5a74137b0c6f7$var$WINDOW.performance.memory)
        ]));
    } catch  {
        return [];
    }
}
function $37d5a74137b0c6f7$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    const time = Date.now() / 1e3;
    return {
        type: "memory",
        name: "memory",
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
function $37d5a74137b0c6f7$var$debounce(func, wait, options) {
    return (0, $b98d2b6f6f2e87bf$export$61fc7d43ac8f84b0)(func, wait, {
        ...options,
        // @ts-expect-error - Not quite sure why these types do not match, but this is fine
        setTimeoutImpl: (0, $295fbc3e705f470c$export$831dc9f2ab0a617b)
    });
}
const $37d5a74137b0c6f7$var$NAVIGATOR = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1).navigator;
function $37d5a74137b0c6f7$var$getRecordingSamplingOptions() {
    if (/iPhone|iPad|iPod/i.test($37d5a74137b0c6f7$var$NAVIGATOR?.userAgent ?? "") || /Macintosh/i.test($37d5a74137b0c6f7$var$NAVIGATOR?.userAgent ?? "") && $37d5a74137b0c6f7$var$NAVIGATOR?.maxTouchPoints && $37d5a74137b0c6f7$var$NAVIGATOR?.maxTouchPoints > 1) return {
        sampling: {
            mousemove: false
        }
    };
    return {};
}
function $37d5a74137b0c6f7$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        try {
            if (!replay.checkAndHandleExpiredSession()) {
                $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.warn("Received replay event after session expired.");
                return;
            }
            const isCheckout = _isCheckout || !hadFirstEvent;
            hadFirstEvent = true;
            $37d5a74137b0c6f7$var$syncMirrorAttributesFromMutationEvent(event);
            if (replay.clickDetector) $37d5a74137b0c6f7$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
            replay.addUpdate(()=>{
                if (replay.recordingMode === "buffer" && isCheckout) replay.setInitialState();
                if (!$37d5a74137b0c6f7$var$addEventSync(replay, event, isCheckout)) return true;
                if (!isCheckout) return false;
                const session = replay.session;
                $37d5a74137b0c6f7$var$addSettingsEvent(replay, isCheckout);
                if (replay.recordingMode === "buffer" && session && replay.eventBuffer && !session.dirty) {
                    const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                    if (earliestEvent) {
                        $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.log(`Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`);
                        session.started = earliestEvent;
                        if (replay.getOptions().stickySession) $37d5a74137b0c6f7$var$saveSession(session);
                    }
                }
                if (session?.previousSessionId) return true;
                if (replay.recordingMode === "session") replay.flush();
                return true;
            });
        } catch (error) {
            replay.handleException(error);
        }
    };
}
function $37d5a74137b0c6f7$var$syncMirrorAttributesFromMutationEvent(event) {
    const data = event.data;
    if (event.type !== $37d5a74137b0c6f7$var$EventType.IncrementalSnapshot || !data || typeof data !== "object" || !("source" in data) || data.source !== $37d5a74137b0c6f7$var$IncrementalSource.Mutation || !("attributes" in data) || !Array.isArray(data.attributes)) return;
    for (const mutation of data.attributes){
        const node = $37d5a74137b0c6f7$var$record.mirror.getNode(mutation.id);
        const meta = node && $37d5a74137b0c6f7$var$record.mirror.getMeta(node);
        if (!node || meta?.type !== $37d5a74137b0c6f7$var$NodeType.Element) continue;
        const attributes = {
            ...meta.attributes
        };
        let changed = false;
        for (const [attributeName, value] of Object.entries(mutation.attributes)){
            if (!$37d5a74137b0c6f7$var$BREADCRUMB_RELEVANT_ATTRIBUTES.has(attributeName)) continue;
            if (value === null) delete attributes[attributeName];
            else attributes[attributeName] = value;
            changed = true;
        }
        if (changed) $37d5a74137b0c6f7$var$record.mirror.add(node, {
            ...meta,
            attributes: attributes
        });
    }
}
function $37d5a74137b0c6f7$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $37d5a74137b0c6f7$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: "options",
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === "worker" : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
function $37d5a74137b0c6f7$var$addSettingsEvent(replay, isCheckout) {
    if (!isCheckout || replay.session?.segmentId !== 0) return;
    $37d5a74137b0c6f7$var$addEventSync(replay, $37d5a74137b0c6f7$var$createOptionsEvent(replay), false);
}
function $37d5a74137b0c6f7$var$closestElementOfNode(node) {
    if (!node) return null;
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        return el;
    } catch  {
        return null;
    }
}
function $37d5a74137b0c6f7$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $bb063ad93c8b79c7$export$f93f7f385160c44e)((0, $bb063ad93c8b79c7$export$92b6093782fe661b)(replayEvent, (0, $bb063ad93c8b79c7$export$d369f3b2758f6743)(replayEvent), tunnel, dsn), [
        [
            {
                type: "replay_event"
            },
            replayEvent
        ],
        [
            {
                type: "replay_recording",
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === "string" ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
function $37d5a74137b0c6f7$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === "string") payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        const sequence = enc.encode(replayHeaders);
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
async function $37d5a74137b0c6f7$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client["_integrations"] === "object" && client["_integrations"] !== null && !Array.isArray(client["_integrations"]) ? Object.keys(client["_integrations"]) : void 0;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    client.emit("preprocessEvent", event, eventHint);
    const preparedEvent = await (0, $e98f8a40c7329053$export$2d67fb380bd11267)(client.getOptions(), event, eventHint, scope, client, (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)());
    if (!preparedEvent) return null;
    client.emit("postprocessEvent", preparedEvent, eventHint);
    preparedEvent.platform = preparedEvent.platform || "javascript";
    const metadata = client.getSdkMetadata();
    const { name: name, version: version, settings: settings } = metadata?.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || "sentry.javascript.unknown",
        version: version || "0.0.0",
        settings: settings
    };
    return preparedEvent;
}
async function $37d5a74137b0c6f7$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $37d5a74137b0c6f7$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, segmentNames: segmentNames, initialTimestamp: initialTimestamp } = eventContext;
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    const scope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
    const transport = client?.getTransport();
    const dsn = client?.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return Promise.resolve({});
    const baseEvent = {
        type: $37d5a74137b0c6f7$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1e3,
        timestamp: timestamp / 1e3,
        error_ids: errorIds,
        trace_ids: traceIds,
        segment_names: segmentNames,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $37d5a74137b0c6f7$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        client.recordDroppedEvent("event_processor", "replay");
        $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.log("An event processor returned `null`, will not send event.");
        return Promise.resolve({});
    }
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $37d5a74137b0c6f7$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($37d5a74137b0c6f7$var$UNABLE_TO_SEND_REPLAY);
        try {
            error.cause = err;
        } catch  {}
        throw error;
    }
    const rateLimits = (0, $33414f31f3554c40$export$699aff705e0d49d4)({}, response);
    if ((0, $33414f31f3554c40$export$6c91fec22056810a)(rateLimits, "replay")) throw new $37d5a74137b0c6f7$var$RateLimitError(rateLimits);
    if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) throw new $37d5a74137b0c6f7$var$TransportStatusCodeError(response.statusCode);
    return response;
}
class $37d5a74137b0c6f7$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
class $37d5a74137b0c6f7$var$RateLimitError extends Error {
    constructor(rateLimits){
        super("Rate limit hit");
        this.rateLimits = rateLimits;
    }
}
class $37d5a74137b0c6f7$var$ReplayDurationLimitError extends Error {
    constructor(){
        super("Session is too long, not sending replay");
    }
}
async function $37d5a74137b0c6f7$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $37d5a74137b0c6f7$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, onError: onError } = replayData;
    if (!recordingData.length) return;
    try {
        await $37d5a74137b0c6f7$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $37d5a74137b0c6f7$var$TransportStatusCodeError || err instanceof $37d5a74137b0c6f7$var$RateLimitError) throw err;
        (0, $6918c722b531ff18$export$2f04de43fe27971a)("Replays", {
            _retryCount: retryConfig.count
        });
        if (onError) onError(err);
        if (retryConfig.count >= $37d5a74137b0c6f7$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$37d5a74137b0c6f7$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                error.cause = err;
            } catch  {}
            throw error;
        }
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            (0, $295fbc3e705f470c$export$831dc9f2ab0a617b)(async ()=>{
                try {
                    await $37d5a74137b0c6f7$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err2) {
                    reject(err2);
                }
            }, retryConfig.interval);
        });
    }
}
const $37d5a74137b0c6f7$var$THROTTLED = "__THROTTLED";
const $37d5a74137b0c6f7$var$SKIPPED = "__SKIPPED";
function $37d5a74137b0c6f7$var$throttle(fn, maxCount, durationSeconds) {
    const counter = /* @__PURE__ */ new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        const now = Math.floor(Date.now() / 1e3);
        _cleanup(now);
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $37d5a74137b0c6f7$var$SKIPPED : $37d5a74137b0c6f7$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
class $37d5a74137b0c6f7$var$ReplayContainer {
    constructor({ options: options, recordingOptions: recordingOptions }){
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = "session";
        this.timeouts = {
            sessionIdlePause: $37d5a74137b0c6f7$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $37d5a74137b0c6f7$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._requiresManualStart = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: /* @__PURE__ */ new Set(),
            traceIds: /* @__PURE__ */ new Set(),
            segmentNames: /* @__PURE__ */ new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ""
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $37d5a74137b0c6f7$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $37d5a74137b0c6f7$var$throttle((event, isCheckout)=>$37d5a74137b0c6f7$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($37d5a74137b0c6f7$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $37d5a74137b0c6f7$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(",") : ""
        } : void 0;
        if (slowClickConfig) this.clickDetector = new $37d5a74137b0c6f7$var$ClickDetector(this, slowClickConfig);
        if ($37d5a74137b0c6f7$var$DEBUG_BUILD) {
            const experiments = options._experiments;
            $37d5a74137b0c6f7$var$debug.setConfig({
                captureExceptions: !!experiments.captureExceptions,
                traceInternals: !!experiments.traceInternals
            });
        }
        this._handleVisibilityChange = ()=>{
            if ($37d5a74137b0c6f7$var$WINDOW.document.visibilityState === "visible") this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
        this._handleWindowBlur = ()=>{
            const breadcrumb = $37d5a74137b0c6f7$var$createBreadcrumb({
                category: "ui.blur"
            });
            this._doChangeToBackgroundTasks(breadcrumb);
        };
        this._handleWindowFocus = ()=>{
            const breadcrumb = $37d5a74137b0c6f7$var$createBreadcrumb({
                category: "ui.focus"
            });
            this._doChangeToForegroundTasks(breadcrumb);
        };
        this._handleKeyboardEvent = (event)=>{
            $37d5a74137b0c6f7$var$handleKeyboardEvent(this, event);
        };
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /** A wrapper to conditionally capture exceptions. */ handleException(error) {
        $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.exception(error);
        if (this._options.onError) this._options.onError(error);
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        const requiresManualStart = errorSampleRate <= 0 && sessionSampleRate <= 0;
        this._requiresManualStart = requiresManualStart;
        if (requiresManualStart) return;
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.exception(new Error("Unable to initialize and create session"));
            return;
        }
        if (this.session.sampled === false) return;
        this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session";
        $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.infoTick(`Starting replay in ${this.recordingMode} mode`);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === "session") {
            $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.log("Recording is already in progress");
            return;
        }
        if (this._isEnabled && this.recordingMode === "buffer") {
            $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.log("Buffering is in progress, call `flush()` to save the replay");
            return;
        }
        $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.infoTick("Starting replay in session mode");
        this._updateUserActivity();
        const session = $37d5a74137b0c6f7$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this.recordingMode = "session";
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) {
            $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.log("Buffering is in progress, call `flush()` to save the replay");
            return;
        }
        $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.infoTick("Starting replay in buffer mode");
        const session = $37d5a74137b0c6f7$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = "buffer";
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = $37d5a74137b0c6f7$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === "buffer" ? {
                    checkoutEveryNms: $37d5a74137b0c6f7$var$BUFFER_CHECKOUT_TIME
                } : // Otherwise, use experimental option w/ min checkout time of 6 minutes
                // This is to improve playback seeking as there could potentially be
                // less mutations to process in the worse cases.
                //
                // checkout by "N" events is probably ideal, but means we have less
                // control about the number of checkouts we make (which generally
                // increases replay size)
                this._options._experiments.continuousCheckout && {
                    // Minimum checkout time is 6 minutes
                    checkoutEveryNms: Math.max(36e4, this._options._experiments.continuousCheckout)
                },
                emit: $37d5a74137b0c6f7$var$getHandleRecordingEmit(this),
                ...$37d5a74137b0c6f7$var$getRecordingSamplingOptions(),
                onMutation: this._onMutationHandler.bind(this),
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = void 0;
            }
            return true;
        } catch (err) {
            this.handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        this._isEnabled = false;
        this.recordingMode = "buffer";
        const stopReason = reason ?? "manual";
        (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)()?.emit("replayEnd", {
            sessionId: this.session?.id,
            reason: stopReason
        });
        try {
            $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.log(`Stopping Replay triggered by ${stopReason}`);
            $37d5a74137b0c6f7$var$resetReplayIdOnDynamicSamplingContext();
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            if (forceFlush) await this._flush({
                force: true
            });
            this.eventBuffer?.destroy();
            this.eventBuffer = null;
            $37d5a74137b0c6f7$var$clearSession(this);
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.log("Pausing replay");
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.log("Resuming replay");
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === "session") return this.flushImmediate();
        const activityTime = Date.now();
        $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.log("Converting buffer to session");
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        if (this.recordingMode === "session") return;
        this.recordingMode = "session";
        if (this.session) {
            this.session.dirty = false;
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
            $37d5a74137b0c6f7$var$setReplayIdOnDynamicSamplingContext(this.session.id);
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        const cbResult = cb();
        if (this.recordingMode === "buffer" || !this._isEnabled) return;
        if (cbResult === true) return;
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        if (!this._stopRecording) {
            if (!this._checkSession()) return;
            this.resume();
            return;
        }
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === "buffer") return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of multiple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current session (=replay) ID
   *
   * @param onlyIfSampled - If true, will only return the session ID if the session is sampled.
   */ getSessionId(onlyIfSampled) {
        if (onlyIfSampled && this.session?.sampled === false) return void 0;
        return this.session?.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        if (this._lastActivity && $37d5a74137b0c6f7$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session?.sampled === "session") {
            this.pause();
            return;
        }
        if (!this._checkSession()) return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$37d5a74137b0c6f7$var$WINDOW.location.pathname}${$37d5a74137b0c6f7$var$WINDOW.location.hash}${$37d5a74137b0c6f7$var$WINDOW.location.search}`;
        const url = `${$37d5a74137b0c6f7$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        if (res === $37d5a74137b0c6f7$var$THROTTLED) {
            const breadcrumb = $37d5a74137b0c6f7$var$createBreadcrumb({
                category: "replay.throttled"
            });
            this.addUpdate(()=>{
                return !$37d5a74137b0c6f7$var$addEventSync(this, {
                    type: $37d5a74137b0c6f7$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: "breadcrumb",
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        const lastActiveSpan = this.lastActiveSpan || (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
        const lastRootSpan = lastActiveSpan && (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(lastActiveSpan);
        const attributes = lastRootSpan && (0, $bb9b6447bf4caedb$export$92d8c23565496537)(lastRootSpan).data || {};
        const source = attributes[0, $f337c80285f06f80$export$d7a7d984b0791405];
        if (!lastRootSpan || !source || ![
            "route",
            "custom"
        ].includes(source)) return void 0;
        return (0, $bb9b6447bf4caedb$export$92d8c23565496537)(lastRootSpan).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        this._updateSessionActivity();
        this.eventBuffer = $37d5a74137b0c6f7$var$createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        this._isEnabled = true;
        this._isPaused = false;
        if (this.session) (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)()?.emit("replayStart", {
            sessionId: this.session.id,
            recordingMode: this.recordingMode
        });
        this.startRecording();
        if (this.recordingMode === "session" && this.session) $37d5a74137b0c6f7$var$setReplayIdOnDynamicSamplingContext(this.session.id);
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $37d5a74137b0c6f7$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        if (!this.session) return false;
        const currentSession = this.session;
        if ($37d5a74137b0c6f7$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: "sessionExpired"
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $37d5a74137b0c6f7$var$WINDOW.document.addEventListener("visibilitychange", this._handleVisibilityChange);
            $37d5a74137b0c6f7$var$WINDOW.addEventListener("blur", this._handleWindowBlur);
            $37d5a74137b0c6f7$var$WINDOW.addEventListener("focus", this._handleWindowFocus);
            $37d5a74137b0c6f7$var$WINDOW.addEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            if (!this._hasInitializedCoreListeners) {
                $37d5a74137b0c6f7$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this.handleException(err);
        }
        this._performanceCleanupCallback = $37d5a74137b0c6f7$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $37d5a74137b0c6f7$var$WINDOW.document.removeEventListener("visibilitychange", this._handleVisibilityChange);
            $37d5a74137b0c6f7$var$WINDOW.removeEventListener("blur", this._handleWindowBlur);
            $37d5a74137b0c6f7$var$WINDOW.removeEventListener("focus", this._handleWindowFocus);
            $37d5a74137b0c6f7$var$WINDOW.removeEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $37d5a74137b0c6f7$var$shouldRefreshSession(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) {
            $37d5a74137b0c6f7$var$resetReplayIdOnDynamicSamplingContext();
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.log("Document has become active, but session has expired");
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            this.throttledAddEvent({
                type: $37d5a74137b0c6f7$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: "breadcrumb",
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        let performanceEntries = $37d5a74137b0c6f7$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        if (this._requiresManualStart) {
            const initialTimestampInSeconds = this._context.initialTimestamp / 1e3;
            performanceEntries = performanceEntries.filter((entry)=>entry.start >= initialTimestampInSeconds);
        }
        return Promise.all($37d5a74137b0c6f7$var$createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.segmentNames.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        if (!session || !eventBuffer || this._requiresManualStart) return;
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            segmentNames: Array.from(this._context.segmentNames),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.error("No session or eventBuffer found to flush.");
            return;
        }
        await this._addPerformanceEntries();
        if (!this.eventBuffer?.hasEvents) return;
        await $37d5a74137b0c6f7$var$addMemoryEntry(this);
        if (!this.eventBuffer) return;
        if (replayId !== this.getSessionId()) return;
        try {
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 3e4) throw new $37d5a74137b0c6f7$var$ReplayDurationLimitError();
            const eventContext = this._popEventContext();
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            const recordingData = await this.eventBuffer.finish();
            await $37d5a74137b0c6f7$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                timestamp: timestamp,
                onError: (err)=>this.handleException(err)
            });
        } catch (err) {
            this.handleException(err);
            this.stop({
                reason: "sendError"
            });
            const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
            if (client) {
                let dropReason;
                if (err instanceof $37d5a74137b0c6f7$var$RateLimitError) dropReason = "ratelimit_backoff";
                else if (err instanceof $37d5a74137b0c6f7$var$ReplayDurationLimitError) dropReason = "invalid";
                else dropReason = "send_error";
                client.recordDroppedEvent(dropReason, "replay");
            }
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ async _flush({ force: force = false } = {}) {
        if (!this._isEnabled && !force) return;
        if (!this.checkAndHandleExpiredSession()) {
            $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.error("Attempting to finish replay event after session expired.");
            return;
        }
        if (!this.session) return;
        const start = this.session.started;
        const now = Date.now();
        const duration = now - start;
        this._debouncedFlush.cancel();
        const tooShort = duration < this._options.minReplayDuration;
        const tooLong = duration > this._options.maxReplayDuration + 5e3;
        if (tooShort || tooLong) {
            $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.log(`Session duration (${Math.floor(duration / 1e3)}s) is too ${tooShort ? "short" : "long"}, not sending replay.`);
            if (tooShort) this._debouncedFlush();
            return;
        }
        const eventBuffer = this.eventBuffer;
        if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $37d5a74137b0c6f7$var$DEBUG_BUILD && $37d5a74137b0c6f7$var$debug.log("Flushing initial segment without checkout.");
        const _flushInProgress = !!this._flushLock;
        if (!this._flushLock) this._flushLock = this._runFlush();
        try {
            await this._flushLock;
        } catch (err) {
            this.handleException(err);
        } finally{
            this._flushLock = void 0;
            if (_flushInProgress) this._debouncedFlush();
        }
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $37d5a74137b0c6f7$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ _onMutationHandler(mutations) {
        const { ignoreMutations: ignoreMutations } = this._options._experiments;
        if (ignoreMutations?.length) {
            if (mutations.some((mutation)=>{
                const el = $37d5a74137b0c6f7$var$closestElementOfNode(mutation.target);
                const selector = ignoreMutations.join(",");
                return el?.matches(selector);
            })) return false;
        }
        const count = mutations.length;
        const mutationLimit = this._options.mutationLimit;
        const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
        const overMutationLimit = mutationLimit && count > mutationLimit;
        if (count > mutationBreadcrumbLimit || overMutationLimit) {
            const breadcrumb = $37d5a74137b0c6f7$var$createBreadcrumb({
                category: "replay.mutations",
                data: {
                    count: count,
                    limit: overMutationLimit
                }
            });
            this._createCustomBreadcrumb(breadcrumb);
        }
        if (overMutationLimit) {
            this.stop({
                reason: "mutationLimit",
                forceFlush: this.recordingMode === "session"
            });
            return false;
        }
        return true;
    }
}
function $37d5a74137b0c6f7$var$getOption(selectors, defaultSelectors) {
    return [
        ...selectors,
        // sentry defaults
        ...defaultSelectors
    ].join(",");
}
function $37d5a74137b0c6f7$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore }) {
    const defaultBlockedElements = [
        "base",
        "iframe[srcdoc]:not([src])"
    ];
    const maskSelector = $37d5a74137b0c6f7$var$getOption(mask, [
        ".sentry-mask",
        "[data-sentry-mask]"
    ]);
    const unmaskSelector = $37d5a74137b0c6f7$var$getOption(unmask, []);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $37d5a74137b0c6f7$var$getOption(block, [
            ".sentry-block",
            "[data-sentry-block]",
            ...defaultBlockedElements
        ]),
        unblockSelector: $37d5a74137b0c6f7$var$getOption(unblock, []),
        ignoreSelector: $37d5a74137b0c6f7$var$getOption(ignore, [
            ".sentry-ignore",
            "[data-sentry-ignore]",
            'input[type="file"]'
        ])
    };
    return options;
}
function $37d5a74137b0c6f7$var$maskAttribute({ el: el, key: key, maskAttributes: maskAttributes, maskAllText: maskAllText, privacyOptions: privacyOptions, value: value }) {
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    const masksNamedAttribute = maskAttributes.includes(key);
    const masksSubmitButtonValue = maskAllText && key === "value" && el.tagName === "INPUT" && [
        "submit",
        "button"
    ].includes(el.getAttribute("type") || "");
    if (masksNamedAttribute || masksSubmitButtonValue) return value.replace(/[\S]/g, "*");
    return value;
}
const $37d5a74137b0c6f7$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $37d5a74137b0c6f7$var$DEFAULT_NETWORK_HEADERS = [
    "content-length",
    "content-type",
    "accept"
];
const $37d5a74137b0c6f7$var$ORIGINAL_BODY = /* @__PURE__ */ Symbol.for("sentry__originalRequestBody");
let $37d5a74137b0c6f7$var$_initialized = false;
let $37d5a74137b0c6f7$var$_isRequestInstrumented = false;
function $37d5a74137b0c6f7$var$_INTERNAL_instrumentRequestInterface() {
    if (typeof Request === "undefined" || $37d5a74137b0c6f7$var$_isRequestInstrumented) return;
    const OriginalRequest = Request;
    try {
        const SentryRequest = function(input, init) {
            const request = new OriginalRequest(input, init);
            if (init?.body != null) request[$37d5a74137b0c6f7$var$ORIGINAL_BODY] = init.body;
            return request;
        };
        SentryRequest.prototype = OriginalRequest.prototype;
        (0, $736a69486c86d36c$export$f1a6cdb1459e81d1).Request = SentryRequest;
        $37d5a74137b0c6f7$var$_isRequestInstrumented = true;
    } catch  {}
}
const $37d5a74137b0c6f7$export$d7706faf7ab354bf = (options)=>{
    return new $37d5a74137b0c6f7$var$Replay(options);
};
class $37d5a74137b0c6f7$var$Replay {
    constructor({ flushMinDelay: flushMinDelay = $37d5a74137b0c6f7$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $37d5a74137b0c6f7$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $37d5a74137b0c6f7$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $37d5a74137b0c6f7$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, workerUrl: workerUrl, _experiments: _experiments = {}, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 1e4, slowClickTimeout: slowClickTimeout = 7e3, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], maskAttributes: maskAttributes = [
        "title",
        "placeholder",
        "aria-label"
    ], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, beforeErrorSampling: beforeErrorSampling, onError: onError, attachRawBodyFromRequest: attachRawBodyFromRequest = false } = {}){
        this.name = "Replay";
        const privacyOptions = $37d5a74137b0c6f7$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore
        });
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>$37d5a74137b0c6f7$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: "all",
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch  {}
            },
            // experimental support for recording iframes from different origins
            recordCrossOriginIframes: Boolean(_experiments.recordCrossOriginIframes)
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $37d5a74137b0c6f7$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $37d5a74137b0c6f7$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $37d5a74137b0c6f7$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $37d5a74137b0c6f7$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            onError: onError,
            attachRawBodyFromRequest: attachRawBodyFromRequest,
            _experiments: _experiments
        };
        if (this._initialOptions.blockAllMedia) {
            this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $37d5a74137b0c6f7$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$37d5a74137b0c6f7$var$MEDIA_SELECTORS}`;
            this._recordingOptions.ignoreCSSAttributes = /* @__PURE__ */ new Set([
                "background-image"
            ]);
        }
        if (this._isInitialized && (0, $b1c1ca6bb415cfb2$export$4e09c449d6c407f7)()) throw new Error("Multiple Sentry Session Replay instances are not supported");
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $37d5a74137b0c6f7$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $37d5a74137b0c6f7$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ afterAllSetup(client) {
        if (!(0, $b1c1ca6bb415cfb2$export$4e09c449d6c407f7)() || this._replay) return;
        if (this._initialOptions.attachRawBodyFromRequest) $37d5a74137b0c6f7$var$_INTERNAL_instrumentRequestInterface();
        this._setup(client);
        this._initialize(client);
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   *
   * @param options.flush - Whether to flush the pending replay segment when stopping.
   * When recording in `session` mode, `stop()` flushes the buffered-but-unsent segment by
   * default (`flush: true`), matching the previous behavior. Pass `flush: false` to stop
   * recording without sending that pending segment — useful when a user withdraws consent
   * and no further data should leave the browser.
   *
   * Note: `flush: false` only prevents the *pending* (final) segment from being sent. It does
   * **not** retract segments that were already sent earlier during `session` recording.
   */ stop(options) {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: options?.flush ?? this._replay.recordingMode === "session",
            reason: "manual"
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * If replay is not enabled, a new session replay is started.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay) return Promise.resolve();
        if (!this._replay.isEnabled()) {
            this._replay.start();
            return Promise.resolve();
        }
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   *
   * @param onlyIfSampled - If true, will only return the session ID if the session is sampled.
   *
   */ getReplayId(onlyIfSampled) {
        if (!this._replay?.isEnabled()) return;
        return this._replay.getSessionId(onlyIfSampled);
    }
    /**
   * Get the current recording mode. This can be either `session` or `buffer`.
   *
   * `session`: Recording the whole session, sending it continuously
   * `buffer`: Always keeping the last 60s of recording, requires:
   *   - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *   - or calling `flush()` to send the replay
   */ getRecordingMode() {
        if (!this._replay?.isEnabled()) return;
        return this._replay.recordingMode;
    }
    processSpan(span) {
        const replayId = this.getReplayId(true);
        if (replayId) {
            (0, $0166effaf29dbd15$export$146fcadff0eefcf3)(span, {
                "sentry.replay_id": replayId
            });
            if (this.getRecordingMode() === "buffer") (0, $0166effaf29dbd15$export$146fcadff0eefcf3)(span, {
                "sentry._internal.replay_is_buffering": true
            });
        }
    }
    /**
   * Initializes replay.
   */ _initialize(client) {
        if (!this._replay) return;
        this._maybeLoadFromReplayCanvasIntegration(client);
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup(client) {
        const finalOptions = $37d5a74137b0c6f7$var$loadReplayOptionsFromClient(this._initialOptions, client);
        this._replay = new $37d5a74137b0c6f7$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration(client) {
        try {
            const canvasIntegration = client.getIntegrationByName("ReplayCanvas");
            if (!canvasIntegration) return;
            this._replay["_canvas"] = canvasIntegration.getOptions();
        } catch  {}
    }
}
function $37d5a74137b0c6f7$var$loadReplayOptionsFromClient(initialOptions, client) {
    const opt = client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...initialOptions
    };
    const replaysSessionSampleRate = (0, $921fe5f527b40422$export$a5bd2d81656d9546)(opt.replaysSessionSampleRate);
    const replaysOnErrorSampleRate = (0, $921fe5f527b40422$export$a5bd2d81656d9546)(opt.replaysOnErrorSampleRate);
    if (replaysSessionSampleRate == null && replaysOnErrorSampleRate == null) (0, $d11ed0b3cdda6b8d$export$cda52e2a8927a2ca)(()=>{
        console.warn("Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.");
    });
    if (replaysSessionSampleRate != null) finalOptions.sessionSampleRate = replaysSessionSampleRate;
    if (replaysOnErrorSampleRate != null) finalOptions.errorSampleRate = replaysOnErrorSampleRate;
    return finalOptions;
}
function $37d5a74137b0c6f7$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$37d5a74137b0c6f7$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
function $37d5a74137b0c6f7$export$b28310b2f161456b() {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    return client?.getIntegrationByName("Replay");
}



var $8bd8504558a4e735$var$__defProp = Object.defineProperty;
var $8bd8504558a4e735$var$__defNormalProp = (obj, key, value)=>key in obj ? $8bd8504558a4e735$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8bd8504558a4e735$var$__publicField = (obj, key, value)=>$8bd8504558a4e735$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class $8bd8504558a4e735$var$Mirror {
    constructor(){
        $8bd8504558a4e735$var$__publicField(this, "idNodeMap", /* @__PURE__ */ new Map());
        $8bd8504558a4e735$var$__publicField(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
    getId(n) {
        if (!n) return -1;
        const id = this.getMeta(n)?.id;
        return id ?? -1;
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    // removes the node from idNodeMap
    // doesn't remove the node from nodeMetaMap
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = /* @__PURE__ */ new Map();
        this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
    }
}
function $8bd8504558a4e735$var$createMirror() {
    return new $8bd8504558a4e735$var$Mirror();
}
function $8bd8504558a4e735$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $8bd8504558a4e735$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $8bd8504558a4e735$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $8bd8504558a4e735$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if ($8bd8504558a4e735$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch  {
            return false;
        }
    };
}
const $8bd8504558a4e735$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $8bd8504558a4e735$var$_mirror = {
    map: {},
    getId () {
        console.error($8bd8504558a4e735$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($8bd8504558a4e735$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($8bd8504558a4e735$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($8bd8504558a4e735$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($8bd8504558a4e735$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $8bd8504558a4e735$var$_mirror = new Proxy($8bd8504558a4e735$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($8bd8504558a4e735$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $8bd8504558a4e735$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $8bd8504558a4e735$var$setTimeout(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$8bd8504558a4e735$var$hookSetter(target, key, original || {}, true);
}
function $8bd8504558a4e735$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch  {
        return ()=>{};
    }
}
/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString());
function $8bd8504558a4e735$var$closestElementOfNode(node) {
    if (!node) return null;
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        return el;
    } catch (error) {
        return null;
    }
}
function $8bd8504558a4e735$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $8bd8504558a4e735$var$closestElementOfNode(node);
    if (!el) return false;
    const blockedPredicate = $8bd8504558a4e735$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $8bd8504558a4e735$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $8bd8504558a4e735$var$distanceToMatch(el, $8bd8504558a4e735$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
const $8bd8504558a4e735$var$cachedImplementations = {};
function $8bd8504558a4e735$var$getImplementation(name) {
    const cached = $8bd8504558a4e735$var$cachedImplementations[name];
    if (cached) return cached;
    const document2 = window.document;
    let impl = window[name];
    if (document2 && typeof document2.createElement === "function") try {
        const sandbox = document2.createElement("iframe");
        sandbox.hidden = true;
        document2.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document2.head.removeChild(sandbox);
    } catch (e) {}
    return $8bd8504558a4e735$var$cachedImplementations[name] = impl.bind(window);
}
function $8bd8504558a4e735$var$onRequestAnimationFrame(...rest) {
    return $8bd8504558a4e735$var$getImplementation("requestAnimationFrame")(...rest);
}
function $8bd8504558a4e735$var$setTimeout(...rest) {
    return $8bd8504558a4e735$var$getImplementation("setTimeout")(...rest);
}
var $8bd8504558a4e735$var$CanvasContext = /* @__PURE__ */ ((CanvasContext2)=>{
    CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
    CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
    CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
    return CanvasContext2;
})($8bd8504558a4e735$var$CanvasContext || {});
let $8bd8504558a4e735$var$errorHandler;
function $8bd8504558a4e735$var$registerErrorHandler(handler) {
    $8bd8504558a4e735$var$errorHandler = handler;
}
const $8bd8504558a4e735$var$callbackWrapper = (cb)=>{
    if (!$8bd8504558a4e735$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($8bd8504558a4e735$var$errorHandler && $8bd8504558a4e735$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
var $8bd8504558a4e735$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $8bd8504558a4e735$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var $8bd8504558a4e735$var$i = 0; $8bd8504558a4e735$var$i < $8bd8504558a4e735$var$chars.length; $8bd8504558a4e735$var$i++)$8bd8504558a4e735$var$lookup[$8bd8504558a4e735$var$chars.charCodeAt($8bd8504558a4e735$var$i)] = $8bd8504558a4e735$var$i;
var $8bd8504558a4e735$var$encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i2, len = bytes.length, base64 = "";
    for(i2 = 0; i2 < len; i2 += 3){
        base64 += $8bd8504558a4e735$var$chars[bytes[i2] >> 2];
        base64 += $8bd8504558a4e735$var$chars[(bytes[i2] & 3) << 4 | bytes[i2 + 1] >> 4];
        base64 += $8bd8504558a4e735$var$chars[(bytes[i2 + 1] & 15) << 2 | bytes[i2 + 2] >> 6];
        base64 += $8bd8504558a4e735$var$chars[bytes[i2 + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
const $8bd8504558a4e735$var$canvasVarMap = /* @__PURE__ */ new Map();
function $8bd8504558a4e735$var$variableListFor(ctx, ctor) {
    let contextMap = $8bd8504558a4e735$var$canvasVarMap.get(ctx);
    if (!contextMap) {
        contextMap = /* @__PURE__ */ new Map();
        $8bd8504558a4e735$var$canvasVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) contextMap.set(ctor, []);
    return contextMap.get(ctor);
}
const $8bd8504558a4e735$var$saveWebGLVar = (value, win, ctx)=>{
    if (!value || !($8bd8504558a4e735$var$isInstanceOfWebGLObject(value, win) || typeof value === "object")) return;
    const name = value.constructor.name;
    const list = $8bd8504558a4e735$var$variableListFor(ctx, name);
    let index = list.indexOf(value);
    if (index === -1) {
        index = list.length;
        list.push(value);
    }
    return index;
};
function $8bd8504558a4e735$var$serializeArg(value, win, ctx) {
    if (value instanceof Array) return value.map((arg)=>$8bd8504558a4e735$var$serializeArg(arg, win, ctx));
    else if (value === null) return value;
    else if (value instanceof Float32Array || value instanceof Float64Array || value instanceof Int32Array || value instanceof Uint32Array || value instanceof Uint8Array || value instanceof Uint16Array || value instanceof Int16Array || value instanceof Int8Array || value instanceof Uint8ClampedArray) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                Object.values(value)
            ]
        };
    } else if (// SharedArrayBuffer disabled on most browsers due to spectre.
    // More info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/SharedArrayBuffer
    // value instanceof SharedArrayBuffer ||
    value instanceof ArrayBuffer) {
        const name = value.constructor.name;
        const base64 = $8bd8504558a4e735$var$encode(value);
        return {
            rr_type: name,
            base64: base64
        };
    } else if (value instanceof DataView) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $8bd8504558a4e735$var$serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength
            ]
        };
    } else if (value instanceof HTMLImageElement) {
        const name = value.constructor.name;
        const { src: src } = value;
        return {
            rr_type: name,
            src: src
        };
    } else if (value instanceof HTMLCanvasElement) {
        const name = "HTMLImageElement";
        const src = value.toDataURL();
        return {
            rr_type: name,
            src: src
        };
    } else if (value instanceof ImageData) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $8bd8504558a4e735$var$serializeArg(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if ($8bd8504558a4e735$var$isInstanceOfWebGLObject(value, win) || typeof value === "object") {
        const name = value.constructor.name;
        const index = $8bd8504558a4e735$var$saveWebGLVar(value, win, ctx);
        return {
            rr_type: name,
            index: index
        };
    }
    return value;
}
const $8bd8504558a4e735$var$serializeArgs = (args, win, ctx)=>{
    return args.map((arg)=>$8bd8504558a4e735$var$serializeArg(arg, win, ctx));
};
const $8bd8504558a4e735$var$isInstanceOfWebGLObject = (value, win)=>{
    const webGLConstructorNames = [
        "WebGLActiveInfo",
        "WebGLBuffer",
        "WebGLFramebuffer",
        "WebGLProgram",
        "WebGLRenderbuffer",
        "WebGLShader",
        "WebGLShaderPrecisionFormat",
        "WebGLTexture",
        "WebGLUniformLocation",
        "WebGLVertexArrayObject",
        // In old Chrome versions, value won't be an instanceof WebGLVertexArrayObject.
        "WebGLVertexArrayObjectOES"
    ];
    const supportedWebGLConstructorNames = webGLConstructorNames.filter((name)=>typeof win[name] === "function");
    return Boolean(supportedWebGLConstructorNames.find((name)=>value instanceof win[name]));
};
function $8bd8504558a4e735$var$initCanvas2DMutationObserver(cb, win, blockClass2, blockSelector, unblockSelector) {
    const handlers = [];
    const props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    for (const prop of props2D)try {
        if (typeof win.CanvasRenderingContext2D.prototype[prop] !== "function") continue;
        const restoreHandler = $8bd8504558a4e735$var$patch(win.CanvasRenderingContext2D.prototype, prop, function(original) {
            return function(...args) {
                if (!$8bd8504558a4e735$var$isBlocked(this.canvas, blockClass2, blockSelector, unblockSelector, true)) $8bd8504558a4e735$var$setTimeout(()=>{
                    const recordArgs = $8bd8504558a4e735$var$serializeArgs(args, win, this);
                    cb(this.canvas, {
                        type: $8bd8504558a4e735$var$CanvasContext["2D"],
                        property: prop,
                        args: recordArgs
                    });
                }, 0);
                return original.apply(this, args);
            };
        });
        handlers.push(restoreHandler);
    } catch  {
        const hookHandler = $8bd8504558a4e735$var$hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
            set (v) {
                cb(this.canvas, {
                    type: $8bd8504558a4e735$var$CanvasContext["2D"],
                    property: prop,
                    args: [
                        v
                    ],
                    setter: true
                });
            }
        });
        handlers.push(hookHandler);
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $8bd8504558a4e735$var$getNormalizedContextName(contextType) {
    return contextType === "experimental-webgl" ? "webgl" : contextType;
}
function $8bd8504558a4e735$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, setPreserveDrawingBufferToTrue) {
    const handlers = [];
    try {
        const restoreHandler = $8bd8504558a4e735$var$patch(win.HTMLCanvasElement.prototype, "getContext", function(original) {
            return function(contextType, ...args) {
                if (!$8bd8504558a4e735$var$isBlocked(this, blockClass, blockSelector, unblockSelector, true)) {
                    const ctxName = $8bd8504558a4e735$var$getNormalizedContextName(contextType);
                    if (!("__context" in this)) this.__context = ctxName;
                    if (setPreserveDrawingBufferToTrue && [
                        "webgl",
                        "webgl2"
                    ].includes(ctxName)) {
                        if (args[0] && typeof args[0] === "object") {
                            const contextAttributes = args[0];
                            if (!contextAttributes.preserveDrawingBuffer) contextAttributes.preserveDrawingBuffer = true;
                        } else args.splice(0, 1, {
                            preserveDrawingBuffer: true
                        });
                    }
                }
                return original.apply(this, [
                    contextType,
                    ...args
                ]);
            };
        });
        handlers.push(restoreHandler);
    } catch  {
        console.error("failed to patch HTMLCanvasElement.prototype.getContext");
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $8bd8504558a4e735$var$patchGLPrototype(prototype, type, cb, blockClass2, blockSelector, unblockSelector, _mirror2, win) {
    const handlers = [];
    const props = Object.getOwnPropertyNames(prototype);
    for (const prop of props){
        if (//prop.startsWith('get') ||  // e.g. getProgramParameter, but too risky
        [
            "isContextLost",
            "canvas",
            "drawingBufferWidth",
            "drawingBufferHeight"
        ].includes(prop)) continue;
        try {
            if (typeof prototype[prop] !== "function") continue;
            const restoreHandler = $8bd8504558a4e735$var$patch(prototype, prop, function(original) {
                return function(...args) {
                    const result = original.apply(this, args);
                    $8bd8504558a4e735$var$saveWebGLVar(result, win, this);
                    if ("tagName" in this.canvas && !$8bd8504558a4e735$var$isBlocked(this.canvas, blockClass2, blockSelector, unblockSelector, true)) {
                        const recordArgs = $8bd8504558a4e735$var$serializeArgs(args, win, this);
                        const mutation = {
                            type: type,
                            property: prop,
                            args: recordArgs
                        };
                        cb(this.canvas, mutation);
                    }
                    return result;
                };
            });
            handlers.push(restoreHandler);
        } catch  {
            const hookHandler = $8bd8504558a4e735$var$hookSetter(prototype, prop, {
                set (v) {
                    cb(this.canvas, {
                        type: type,
                        property: prop,
                        args: [
                            v
                        ],
                        setter: true
                    });
                }
            });
            handlers.push(hookHandler);
        }
    }
    return handlers;
}
function $8bd8504558a4e735$var$initCanvasWebGLMutationObserver(cb, win, blockClass2, blockSelector, unblockSelector, mirror) {
    const handlers = [];
    handlers.push(...$8bd8504558a4e735$var$patchGLPrototype(win.WebGLRenderingContext.prototype, $8bd8504558a4e735$var$CanvasContext.WebGL, cb, blockClass2, blockSelector, unblockSelector, mirror, win));
    if (typeof win.WebGL2RenderingContext !== "undefined") handlers.push(...$8bd8504558a4e735$var$patchGLPrototype(win.WebGL2RenderingContext.prototype, $8bd8504558a4e735$var$CanvasContext.WebGL2, cb, blockClass2, blockSelector, unblockSelector, mirror, win));
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
const $8bd8504558a4e735$var$r = `for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",t="undefined"==typeof Uint8Array?[]:new Uint8Array(256),a=0;a<64;a++)t[e.charCodeAt(a)]=a;var n=function(t){var a,n=new Uint8Array(t),r=n.length,s="";for(a=0;a<r;a+=3)s+=e[n[a]>>2],s+=e[(3&n[a])<<4|n[a+1]>>4],s+=e[(15&n[a+1])<<2|n[a+2]>>6],s+=e[63&n[a+2]];return r%3==2?s=s.substring(0,s.length-1)+"=":r%3==1&&(s=s.substring(0,s.length-2)+"=="),s};const r=new Map,s=new Map;const i=self;i.onmessage=async function(e){if(!("OffscreenCanvas"in globalThis))return i.postMessage({id:e.data.id});{const{id:t,bitmap:a,width:o,height:f,maxCanvasSize:c,dataURLOptions:g}=e.data,u=async function(e,t,a){const r=e+"-"+t;if("OffscreenCanvas"in globalThis){if(s.has(r))return s.get(r);const i=new OffscreenCanvas(e,t);i.getContext("2d");const o=await i.convertToBlob(a),f=await o.arrayBuffer(),c=n(f);return s.set(r,c),c}return""}(o,f,g),[h,d]=function(e,t,a){if(!a)return[e,t];const[n,r]=a;if(e<=n&&t<=r)return[e,t];let s=e,i=t;return s>n&&(i=Math.floor(n*t/e),s=n),i>r&&(s=Math.floor(r*e/t),i=r),[s,i]}(o,f,c),l=new OffscreenCanvas(h,d),w=l.getContext("bitmaprenderer"),p=h===o&&d===f?a:await createImageBitmap(a,{resizeWidth:h,resizeHeight:d,resizeQuality:"low"});w?.transferFromImageBitmap(p),a.close();const y=await l.convertToBlob(g),v=y.type,b=await y.arrayBuffer(),m=n(b);if(p.close(),!r.has(t)&&await u===m)return r.set(t,m),i.postMessage({id:t});if(r.get(t)===m)return i.postMessage({id:t});i.postMessage({id:t,type:v,base64:m,width:o,height:f}),r.set(t,m)}};`;
function $8bd8504558a4e735$var$t() {
    const t2 = new Blob([
        $8bd8504558a4e735$var$r
    ]);
    return URL.createObjectURL(t2);
}
class $8bd8504558a4e735$var$CanvasManager {
    constructor(options){
        this.pendingCanvasMutations = /* @__PURE__ */ new Map();
        this.rafStamps = {
            latestId: 0,
            invokeId: null
        };
        this.shadowDoms = /* @__PURE__ */ new Set();
        this.windowsSet = /* @__PURE__ */ new WeakSet();
        this.windows = [];
        this.restoreHandlers = [];
        this.frozen = false;
        this.locked = false;
        this.snapshotInProgressMap = /* @__PURE__ */ new Map();
        this.worker = null;
        this.lastSnapshotTime = 0;
        this.processMutation = (target, mutation)=>{
            const newFrame = this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId;
            if (newFrame || !this.rafStamps.invokeId) this.rafStamps.invokeId = this.rafStamps.latestId;
            if (!this.pendingCanvasMutations.has(target)) this.pendingCanvasMutations.set(target, []);
            this.pendingCanvasMutations.get(target).push(mutation);
        };
        const { enableManualSnapshot: enableManualSnapshot, sampling: sampling = "all", win: win, recordCanvas: recordCanvas, errorHandler: errorHandler2 } = options;
        options.sampling = sampling;
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        this.options = options;
        if (errorHandler2) $8bd8504558a4e735$var$registerErrorHandler(errorHandler2);
        if (recordCanvas && typeof sampling === "number" || enableManualSnapshot) this.worker = this.initFPSWorker();
        this.addWindow(win);
        if (enableManualSnapshot) return;
        $8bd8504558a4e735$var$callbackWrapper(()=>{
            if (recordCanvas && sampling === "all") {
                this.startRAFTimestamping();
                this.startPendingCanvasMutationFlusher();
            }
            if (recordCanvas && typeof sampling === "number") this.initCanvasFPSObserver();
        })();
    }
    reset() {
        this.pendingCanvasMutations.clear();
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e) {}
        });
        this.restoreHandlers = [];
        this.windowsSet = /* @__PURE__ */ new WeakSet();
        this.windows = [];
        this.shadowDoms = /* @__PURE__ */ new Set();
        this.worker?.terminate();
        this.worker = null;
        this.snapshotInProgressMap = /* @__PURE__ */ new Map();
    }
    freeze() {
        this.frozen = true;
    }
    unfreeze() {
        this.frozen = false;
    }
    lock() {
        this.locked = true;
    }
    unlock() {
        this.locked = false;
    }
    addWindow(win) {
        const { sampling: sampling = "all", blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, recordCanvas: recordCanvas, enableManualSnapshot: enableManualSnapshot } = this.options;
        if (this.windowsSet.has(win)) return;
        if (enableManualSnapshot) {
            this.windowsSet.add(win);
            this.windows.push(new WeakRef(win));
            return;
        }
        $8bd8504558a4e735$var$callbackWrapper(()=>{
            if (recordCanvas && sampling === "all") this.initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector);
            if (recordCanvas && typeof sampling === "number") {
                const canvasContextReset = $8bd8504558a4e735$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, true);
                this.restoreHandlers.push(()=>{
                    canvasContextReset();
                });
            }
        })();
        this.windowsSet.add(win);
        this.windows.push(new WeakRef(win));
    }
    addShadowRoot(shadowRoot) {
        this.shadowDoms.add(new WeakRef(shadowRoot));
    }
    resetShadowRoots() {
        this.shadowDoms = /* @__PURE__ */ new Set();
    }
    snapshot(canvasElement, options) {
        if (options?.skipRequestAnimationFrame) {
            this.takeSnapshot(performance.now(), true, canvasElement);
            return;
        }
        $8bd8504558a4e735$var$onRequestAnimationFrame((timestamp)=>this.takeSnapshot(timestamp, true, canvasElement));
    }
    initFPSWorker() {
        const worker = new Worker($8bd8504558a4e735$var$t());
        worker.onmessage = (e)=>{
            const data = e.data;
            const { id: id } = data;
            this.snapshotInProgressMap.set(id, false);
            if (!("base64" in data)) return;
            const { base64: base64, type: type, width: width, height: height } = data;
            this.mutationCb({
                id: id,
                type: $8bd8504558a4e735$var$CanvasContext["2D"],
                commands: [
                    {
                        property: "clearRect",
                        // wipe canvas
                        args: [
                            0,
                            0,
                            width,
                            height
                        ]
                    },
                    {
                        property: "drawImage",
                        // draws (semi-transparent) image
                        args: [
                            {
                                rr_type: "ImageBitmap",
                                args: [
                                    {
                                        rr_type: "Blob",
                                        data: [
                                            {
                                                rr_type: "ArrayBuffer",
                                                base64: base64
                                            }
                                        ],
                                        type: type
                                    }
                                ]
                            },
                            0,
                            0,
                            // The below args are needed if we enforce a max size, we want to
                            // retain the original size when drawing the image (which should be smaller)
                            width,
                            height
                        ]
                    }
                ]
            });
        };
        return worker;
    }
    initCanvasFPSObserver() {
        let rafId;
        if (!this.windows.length && !this.shadowDoms.size) return;
        const rafCallback = (timestamp)=>{
            this.takeSnapshot(timestamp, false);
            rafId = $8bd8504558a4e735$var$onRequestAnimationFrame(rafCallback);
        };
        rafId = $8bd8504558a4e735$var$onRequestAnimationFrame(rafCallback);
        this.restoreHandlers.push(()=>{
            if (rafId) cancelAnimationFrame(rafId);
        });
    }
    initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector) {
        const canvasContextReset = $8bd8504558a4e735$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, false);
        const canvas2DReset = $8bd8504558a4e735$var$initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector);
        const canvasWebGL1and2Reset = $8bd8504558a4e735$var$initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);
        this.restoreHandlers.push(()=>{
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        });
    }
    /**
   * Returns all `canvas` elements that are not blocked by the given selectors. Searches all windows and shadow roots.
   */ getCanvasElements(blockClass, blockSelector, unblockSelector) {
        const matchedCanvas = [];
        const searchCanvas = (root)=>{
            root.querySelectorAll("canvas").forEach((canvas)=>{
                if (!$8bd8504558a4e735$var$isBlocked(canvas, blockClass, blockSelector, unblockSelector, true)) matchedCanvas.push(canvas);
            });
        };
        for (const item of this.windows){
            const window2 = item.deref();
            let _document;
            try {
                _document = window2 && window2.document;
            } catch  {}
            if (_document) searchCanvas(_document);
        }
        for (const item of this.shadowDoms){
            const shadowRoot = item.deref();
            if (shadowRoot) searchCanvas(shadowRoot);
        }
        return matchedCanvas;
    }
    /**
   * Takes a snapshot of the provided canvas element, or will search all windows/shadow roots for canvases. Will self-throttle based on `options.sampling`.
   *
   * @returns `true` if the snapshot was taken, `false` if it was throttled.
   */ takeSnapshot(timestamp, isManualSnapshot, canvasElement) {
        const { sampling: sampling, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, dataURLOptions: dataURLOptions, maxCanvasSize: maxCanvasSize } = this.options;
        const fps = sampling === "all" ? 2 : sampling || 2;
        const timeBetweenSnapshots = 1e3 / fps;
        const shouldThrottle = this.lastSnapshotTime && timestamp - this.lastSnapshotTime < timeBetweenSnapshots;
        if (shouldThrottle) return false;
        this.lastSnapshotTime = timestamp;
        const canvases = canvasElement ? [
            canvasElement
        ] : this.getCanvasElements(blockClass, blockSelector, unblockSelector);
        canvases.forEach((canvas)=>{
            const id = this.mirror.getId(canvas);
            if (!this.mirror.hasNode(canvas) || !canvas.width || !canvas.height || this.snapshotInProgressMap.get(id)) return;
            this.snapshotInProgressMap.set(id, true);
            if (!isManualSnapshot && [
                "webgl",
                "webgl2"
            ].includes(canvas.__context)) {
                const context = canvas.getContext(canvas.__context);
                if (context?.getContextAttributes()?.preserveDrawingBuffer === false) context.clear(context.COLOR_BUFFER_BIT);
            }
            createImageBitmap(canvas).then((bitmap)=>{
                this.worker?.postMessage({
                    id: id,
                    bitmap: bitmap,
                    width: canvas.width,
                    height: canvas.height,
                    dataURLOptions: dataURLOptions,
                    maxCanvasSize: maxCanvasSize
                }, [
                    bitmap
                ]);
            }).catch((error)=>{
                $8bd8504558a4e735$var$callbackWrapper(()=>{
                    this.snapshotInProgressMap.delete(id);
                    throw error;
                })();
            });
        });
        return true;
    }
    startPendingCanvasMutationFlusher() {
        $8bd8504558a4e735$var$onRequestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    startRAFTimestamping() {
        const setLatestRAFTimestamp = (timestamp)=>{
            this.rafStamps.latestId = timestamp;
            $8bd8504558a4e735$var$onRequestAnimationFrame(setLatestRAFTimestamp);
        };
        $8bd8504558a4e735$var$onRequestAnimationFrame(setLatestRAFTimestamp);
    }
    flushPendingCanvasMutations() {
        this.pendingCanvasMutations.forEach((_values, canvas)=>{
            const id = this.mirror.getId(canvas);
            this.flushPendingCanvasMutationFor(canvas, id);
        });
        $8bd8504558a4e735$var$onRequestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    flushPendingCanvasMutationFor(canvas, id) {
        if (this.frozen || this.locked) return;
        const valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1) return;
        const values = valuesWithType.map((value)=>{
            const { type: type2, ...rest } = value;
            return rest;
        });
        const { type: type } = valuesWithType[0];
        this.mutationCb({
            id: id,
            type: type,
            commands: values
        });
        this.pendingCanvasMutations.delete(canvas);
    }
}
try {
    if (Array.from([
        1
    ], (x)=>x * 2)[0] !== 2) {
        const cleanFrame = document.createElement("iframe");
        document.body.appendChild(cleanFrame);
        Array.from = cleanFrame.contentWindow?.Array.from || Array.from;
        document.body.removeChild(cleanFrame);
    }
} catch (err) {
    console.debug("Unable to override Array.from", err);
}
$8bd8504558a4e735$var$createMirror();
var $8bd8504558a4e735$var$n;
!function(t2) {
    t2[t2.NotStarted = 0] = "NotStarted", t2[t2.Running = 1] = "Running", t2[t2.Stopped = 2] = "Stopped";
}($8bd8504558a4e735$var$n || ($8bd8504558a4e735$var$n = {}));
const $8bd8504558a4e735$var$CANVAS_QUALITY = {
    low: {
        sampling: {
            canvas: 1
        },
        dataURLOptions: {
            type: "image/webp",
            quality: 0.25
        }
    },
    medium: {
        sampling: {
            canvas: 2
        },
        dataURLOptions: {
            type: "image/webp",
            quality: 0.4
        }
    },
    high: {
        sampling: {
            canvas: 4
        },
        dataURLOptions: {
            type: "image/webp",
            quality: 0.5
        }
    }
};
const $8bd8504558a4e735$var$INTEGRATION_NAME = "ReplayCanvas";
const $8bd8504558a4e735$var$DEFAULT_MAX_CANVAS_SIZE = 1280;
const $8bd8504558a4e735$var$_replayCanvasIntegration = (options = {})=>{
    const [maxCanvasWidth, maxCanvasHeight] = options.maxCanvasSize || [];
    const _canvasOptions = {
        quality: options.quality || "medium",
        enableManualSnapshot: options.enableManualSnapshot,
        maxCanvasSize: [
            maxCanvasWidth ? Math.min(maxCanvasWidth, $8bd8504558a4e735$var$DEFAULT_MAX_CANVAS_SIZE) : $8bd8504558a4e735$var$DEFAULT_MAX_CANVAS_SIZE,
            maxCanvasHeight ? Math.min(maxCanvasHeight, $8bd8504558a4e735$var$DEFAULT_MAX_CANVAS_SIZE) : $8bd8504558a4e735$var$DEFAULT_MAX_CANVAS_SIZE
        ]
    };
    let currentCanvasManager;
    let canvasManagerResolve;
    const _canvasManager = new Promise((resolve)=>canvasManagerResolve = resolve);
    return {
        name: $8bd8504558a4e735$var$INTEGRATION_NAME,
        getOptions () {
            const { quality: quality, enableManualSnapshot: enableManualSnapshot, maxCanvasSize: maxCanvasSize } = _canvasOptions;
            return {
                enableManualSnapshot: enableManualSnapshot,
                recordCanvas: true,
                getCanvasManager: (getCanvasManagerOptions)=>{
                    const manager = new $8bd8504558a4e735$var$CanvasManager({
                        ...getCanvasManagerOptions,
                        enableManualSnapshot: enableManualSnapshot,
                        maxCanvasSize: maxCanvasSize,
                        errorHandler: (err)=>{
                            try {
                                if (typeof err === "object") err.__rrweb__ = true;
                            } catch  {}
                        }
                    });
                    currentCanvasManager = manager;
                    canvasManagerResolve(manager);
                    return manager;
                },
                ...$8bd8504558a4e735$var$CANVAS_QUALITY[quality] || $8bd8504558a4e735$var$CANVAS_QUALITY.medium
            };
        },
        async snapshot (canvasElement, options2) {
            const canvasManager = currentCanvasManager || await _canvasManager;
            canvasManager.snapshot(canvasElement, options2);
        }
    };
};
const $8bd8504558a4e735$export$71ba62165d5c834d = (0, $cbb2da6c78246e45$export$2323046b9414659f)($8bd8504558a4e735$var$_replayCanvasIntegration);














function $2c3cb4034c24252d$export$18ce21a8b7efd7e9(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $2c3cb4034c24252d$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
function $2c3cb4034c24252d$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ((0, $13cf2ed412f405fa$export$f5b060c2914b97c8)(value)) return (0, $fa8c9f9f1040feb6$export$64da0f40b0f924ba)(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    onFinally();
    onSuccess(value);
    return value;
}






function $18bf74fc9ecc8708$var$logIgnoredSpan(droppedSpan) {
    (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
function $18bf74fc9ecc8708$export$5d569ac97c389400(span, ignoreSpans) {
    if (!ignoreSpans?.length) return false;
    for (const pattern of ignoreSpans){
        if ($18bf74fc9ecc8708$var$isStringOrRegExp(pattern)) {
            if (span.description && (0, $e534db390d1e4996$export$cdded5b28a5f8c6d)(span.description, pattern)) {
                (0, $19fdbaf7f0830971$export$16a28057038b10ef) && $18bf74fc9ecc8708$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && (0, $e534db390d1e4996$export$cdded5b28a5f8c6d)(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && (0, $e534db390d1e4996$export$cdded5b28a5f8c6d)(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>$18bf74fc9ecc8708$var$_matchesAttributeValue(span.attributes?.[key], valuePattern)) : true;
        if (nameMatches && opMatches && attrsMatch) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && $18bf74fc9ecc8708$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function $18bf74fc9ecc8708$var$_matchesAttributeValue(actual, pat) {
    if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) return (0, $e534db390d1e4996$export$cdded5b28a5f8c6d)(actual, pat);
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    return actual === pat;
}
function $18bf74fc9ecc8708$export$ddf57376e818b444(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $18bf74fc9ecc8708$var$isStringOrRegExp(value) {
    return typeof value === "string" || value instanceof RegExp;
}


function $45c38c4db3fc86e7$export$6ea47215d699c04a(client) {
    return client.getOptions().traceLifecycle === "stream";
}












function $33f11695c2072059$export$2f3d84e767c9592b(span) {
    if (!(0, $19fdbaf7f0830971$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $bb9b6447bf4caedb$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op2, description: description2 } = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op2) infoParts.push(`root op: ${op2}`);
        if (description2) infoParts.push(`root description: ${description2}`);
    }
    (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`${header}
  ${infoParts.join("\n  ")}`);
}
function $33f11695c2072059$export$b77c830667a4d630(span) {
    if (!(0, $19fdbaf7f0830971$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(msg);
}






function $ff32a69e7fdcf77e$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    if (!(0, $e3827447d651dfc5$export$1f70765132c3c225)(options)) return [
        false
    ];
    let localSampleRateWasApplied = void 0;
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== void 0) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    const parsedSampleRate = (0, $921fe5f527b40422$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === void 0) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    if (!parsedSampleRate) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    const shouldSample = sampleRand < parsedSampleRate;
    if (!shouldSample) (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}












function $50a1e2eac2a45b83$export$8a6cdb6116a9fd2b(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : void 0
    };
    return event;
}
function $50a1e2eac2a45b83$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $bb063ad93c8b79c7$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date((0, $c80d7f6644a3b50b$export$65b1bada40c91b34)()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $1e1399eeae328b26$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $bb063ad93c8b79c7$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
function $50a1e2eac2a45b83$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $bb063ad93c8b79c7$export$d369f3b2758f6743)(metadata);
    const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $50a1e2eac2a45b83$export$8a6cdb6116a9fd2b(event, metadata?.sdk);
    const envelopeHeaders = (0, $bb063ad93c8b79c7$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $bb063ad93c8b79c7$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
function $50a1e2eac2a45b83$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc2) {
        return !!dsc2.trace_id && !!dsc2.public_key;
    }
    const dsc = (0, $09fae5ef8120e803$export$a117f995597e25df)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date((0, $c80d7f6644a3b50b$export$65b1bada40c91b34)()).toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $1e1399eeae328b26$export$44d472fbb931a776)(dsn)
        }
    };
    const { beforeSendSpan: beforeSendSpan, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>{
        const json = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(span);
        return !(0, $18bf74fc9ecc8708$export$5d569ac97c389400)({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent("before_send", "span", droppedSpans);
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(span);
        const processedSpan = !(0, $97e289d5898f298e$export$ca3e1ec3cdcc76ac)(beforeSendSpan) ? beforeSendSpan(spanJson) : spanJson;
        if (!processedSpan) {
            (0, $bb9b6447bf4caedb$export$d11691ff45a3e535)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $bb9b6447bf4caedb$export$92d8c23565496537);
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $bb063ad93c8b79c7$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $bb063ad93c8b79c7$export$f93f7f385160c44e)(headers, items);
}













function $dbcaa70aa380aaa2$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)()) {
    const rootSpan = activeSpan && (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $f337c80285f06f80$export$69cd5c610c7bb96a)]: value,
            [(0, $f337c80285f06f80$export$f5f95cff026507b5)]: unit
        });
    }
}
function $dbcaa70aa380aaa2$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return void 0;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $f337c80285f06f80$export$f5f95cff026507b5];
        const value = attributes[0, $f337c80285f06f80$export$69cd5c610c7bb96a];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}



function $e34c893ca8572c15$export$39f842ff1b89e918(strategy) {
    (0, $e4c75fb63b040566$export$c8bfa33e4e8ae492)((0, $e4c75fb63b040566$export$19eade501500c6c1)()).segmentSpanCaptureStrategy = strategy;
}
function $e34c893ca8572c15$export$ccd123f3ffd8eb3() {
    return (0, $e4c75fb63b040566$export$c8bfa33e4e8ae492)((0, $e4c75fb63b040566$export$19eade501500c6c1)()).segmentSpanCaptureStrategy;
}




const $32284c1a43c550a4$var$MAX_SPAN_COUNT = 1e3;
class $32284c1a43c550a4$export$a92149b045260d9f {
    /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $ece9bac57decbcb8$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $ece9bac57decbcb8$export$295213bc4d0c54ad)();
        this._startTime = spanContext.startTimestamp || (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: "manual",
            [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._frozen) return this;
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._frozen) return this;
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $bb9b6447bf4caedb$export$eb571cd9b5d98de8) : (0, $bb9b6447bf4caedb$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (this._frozen) return this;
        if (value === void 0) delete this._attributes[key];
        else this._attributes[key] = value;
        if (key === (0, $f337c80285f06f80$export$d7a7d984b0791405) && value !== void 0 && (0, $e54da191c628b5f0$export$2e69b79005fc86eb)(this)) (0, $e54da191c628b5f0$export$c45f16c039fb5033)(this);
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        if (this._frozen) return;
        this._startTime = (0, $bb9b6447bf4caedb$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        if (this._frozen) return this;
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        if (this._frozen) return this;
        this._name = name;
        if (!(0, $e54da191c628b5f0$export$2e69b79005fc86eb)(this)) this.setAttribute((0, $f337c80285f06f80$export$d7a7d984b0791405), "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        if (this._endTime) {
            this._frozen = (0, $e54da191c628b5f0$export$a9ba2a501dbf6a56)(this);
            return;
        }
        this._endTime = (0, $bb9b6447bf4caedb$export$3f7581298f56c6d7)(endTimestamp);
        (0, $33f11695c2072059$export$b77c830667a4d630)(this);
        this._onSpanEnded();
        this._frozen = (0, $e54da191c628b5f0$export$a9ba2a501dbf6a56)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $f337c80285f06f80$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $bb9b6447bf4caedb$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $f337c80285f06f80$export$cca8dd30f57f805e],
            profile_id: this._attributes[0, $f337c80285f06f80$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $f337c80285f06f80$export$fea48ba9f4550879],
            measurements: (0, $dbcaa70aa380aaa2$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(this) === this || void 0,
            segment_id: this._isStandaloneSpan ? (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(this).spanContext().spanId : void 0,
            links: (0, $bb9b6447bf4caedb$export$cb3e3a12e0eec16c)(this._links)
        };
    }
    /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ getStreamedSpanJSON() {
        return {
            name: this._name ?? "",
            span_id: this._spanId,
            trace_id: this._traceId,
            parent_span_id: this._parentSpanId,
            start_timestamp: this._startTime,
            // just in case _endTime is not set, we use the start time (i.e. duration 0)
            end_timestamp: this._endTime ?? this._startTime,
            is_segment: this._isStandaloneSpan || this === (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(this),
            status: (0, $bb9b6447bf4caedb$export$d3856a3187d34821)(this._status),
            attributes: (0, $bb9b6447bf4caedb$export$1464a9cb828ba99f)(this._attributes, this._status),
            links: (0, $bb9b6447bf4caedb$export$9015adcf158ef3a5)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        if (this._frozen) return this;
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log("[Tracing] Adding an event to span:", name);
        const time = $32284c1a43c550a4$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
        const attributes = $32284c1a43c550a4$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $bb9b6447bf4caedb$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
        if (client) {
            client.emit("spanEnd", this);
            if (!this._isStandaloneSpan) client.emit("afterSpanEnd", this);
        }
        const rootSpan = (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(this);
        const isSegmentSpan = this._isStandaloneSpan || this === rootSpan;
        if (this._isStandaloneSpan) {
            if (this._sampled) $32284c1a43c550a4$var$sendSpanEnvelope((0, $50a1e2eac2a45b83$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        }
        if (!isSegmentSpan) {
            const strategy2 = (0, $e34c893ca8572c15$export$ccd123f3ffd8eb3)();
            if (strategy2) {
                const scope2 = (0, $e54da191c628b5f0$export$c08fbc656a245d03)(this).scope || (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
                strategy2.onChildSpanEnded(this, rootSpan, (options)=>this._convertSpanToTransaction(options), scope2);
            }
            return;
        }
        if (client && (0, $45c38c4db3fc86e7$export$6ea47215d699c04a)(client)) {
            client.emit("afterSegmentSpanEnd", this);
            return;
        }
        const scope = (0, $e54da191c628b5f0$export$c08fbc656a245d03)(this).scope || (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
        const strategy = (0, $e34c893ca8572c15$export$ccd123f3ffd8eb3)();
        if (strategy) strategy.onSegmentSpanEnded((options)=>this._convertSpanToTransaction(options), scope);
        else {
            const transactionEvent = this._convertSpanToTransaction();
            if (transactionEvent) scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction(options = {}) {
        if (!$32284c1a43c550a4$var$isFullFinishedSpan((0, $bb9b6447bf4caedb$export$92d8c23565496537)(this))) return void 0;
        if (!this._name) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $e54da191c628b5f0$export$c08fbc656a245d03)(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return void 0;
        options.onSpanCaptured?.(this);
        const spans = [];
        for (const descendant of (0, $bb9b6447bf4caedb$export$340c5c8a13ffc680)(this)){
            if (descendant === this || $32284c1a43c550a4$var$isStandaloneSpan(descendant) || options.isSpanAlreadyCaptured?.(descendant)) continue;
            const spanJSON = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(descendant);
            if (!$32284c1a43c550a4$var$isFullFinishedSpan(spanJSON)) continue;
            options.onSpanCaptured?.(descendant);
            spans.push(spanJSON);
        }
        const source = this._attributes[0, $f337c80285f06f80$export$d7a7d984b0791405];
        delete this._attributes[0, $f337c80285f06f80$export$165ce9a229f6f050];
        let hasGenAiSpans = false;
        spans.forEach((span)=>{
            delete span.data[0, $f337c80285f06f80$export$165ce9a229f6f050];
            if (span.op?.startsWith("gen_ai.")) hasGenAiSpans = true;
        });
        const transaction = {
            contexts: {
                trace: (0, $bb9b6447bf4caedb$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $32284c1a43c550a4$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $32284c1a43c550a4$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: (0, $09fae5ef8120e803$export$a117f995597e25df)(this),
                hasGenAiSpans: hasGenAiSpans
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $dbcaa70aa380aaa2$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, void 0, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $32284c1a43c550a4$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
function $32284c1a43c550a4$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
function $32284c1a43c550a4$var$isStandaloneSpan(span) {
    return span instanceof $32284c1a43c550a4$export$a92149b045260d9f && span.isStandaloneSpan();
}
function $32284c1a43c550a4$var$sendSpanEnvelope(envelope) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    client.sendEnvelope(envelope);
}




const $c9161b67125aefc1$export$61ab4e30f2201736 = "__SENTRY_SUPPRESS_TRACING__";
function $c9161b67125aefc1$export$a1bd95187356f372(options, callback) {
    const acs = $c9161b67125aefc1$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $c9161b67125aefc1$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $7d48e1ed9f699a01$export$ec58d9285c204497)(customForkedScope, ()=>{
        const wrapper = $c9161b67125aefc1$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
            const parentSpan = $c9161b67125aefc1$var$getParentSpan(scope, customParentSpan);
            const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $c9161b67125aefc1$var$startMissingRequiredParentSpan(scope, client) : $c9161b67125aefc1$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$c9161b67125aefc1$export$b0b1bd7d4bdbd54e(activeSpan) || !parentSpan) (0, $dab1970d0c142a42$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $2c3cb4034c24252d$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                const { status: status } = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $fda37f10dc06a152$export$f966a0446ece71e),
                    message: "internal_error"
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
function $c9161b67125aefc1$export$c10292ad04b92aea(options, callback) {
    const acs = $c9161b67125aefc1$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $c9161b67125aefc1$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $7d48e1ed9f699a01$export$ec58d9285c204497)(customForkedScope, ()=>{
        const wrapper = $c9161b67125aefc1$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
            const parentSpan = $c9161b67125aefc1$var$getParentSpan(scope, customParentSpan);
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $c9161b67125aefc1$var$startMissingRequiredParentSpan(scope, (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)()) : $c9161b67125aefc1$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$c9161b67125aefc1$export$b0b1bd7d4bdbd54e(activeSpan) || !parentSpan) (0, $dab1970d0c142a42$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $2c3cb4034c24252d$export$18ce21a8b7efd7e9)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                const { status: status } = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $fda37f10dc06a152$export$f966a0446ece71e),
                    message: "internal_error"
                });
            });
        });
    });
}
function $c9161b67125aefc1$export$63dbba021a6b4047(options) {
    const acs = $c9161b67125aefc1$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    return $c9161b67125aefc1$var$_startInactiveSpanImpl(options);
}
function $c9161b67125aefc1$export$8672cc6c19af377a(options) {
    return $c9161b67125aefc1$var$_startInactiveSpanImpl(options);
}
function $c9161b67125aefc1$var$_startInactiveSpanImpl(options) {
    const spanArguments = $c9161b67125aefc1$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    const wrapper = options.scope ? (callback)=>(0, $7d48e1ed9f699a01$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== void 0 ? (callback)=>$c9161b67125aefc1$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
        const parentSpan = $c9161b67125aefc1$var$getParentSpan(scope, customParentSpan);
        const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
        const missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) return $c9161b67125aefc1$var$startMissingRequiredParentSpan(scope, client);
        return $c9161b67125aefc1$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
const $c9161b67125aefc1$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $e4c75fb63b040566$export$19eade501500c6c1)();
    const acs = (0, $a8b8acc568359454$export$f639b0c2752203be)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    const incomingDsc = (0, $8ef2851bd0adcf53$export$5b96ee2c8421f107)(baggage);
    if (client && !(0, $bcc4fe773b74e41d$export$18811bc99eefceaa)(client, incomingDsc?.org_id)) return $c9161b67125aefc1$export$f90b03291402f553(callback);
    return (0, $7d48e1ed9f699a01$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $bcc4fe773b74e41d$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        (0, $dab1970d0c142a42$export$3f25fa50c18e20ca)(scope, void 0);
        return callback();
    });
};
function $c9161b67125aefc1$export$e57ac09b143d92a2(span, callback) {
    const acs = $c9161b67125aefc1$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $7d48e1ed9f699a01$export$ec58d9285c204497)((scope)=>{
        (0, $dab1970d0c142a42$export$3f25fa50c18e20ca)(scope, span || void 0);
        return callback(scope);
    });
}
function $c9161b67125aefc1$export$869298f9835abc68(callback) {
    const acs = $c9161b67125aefc1$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $7d48e1ed9f699a01$export$ec58d9285c204497)((scope)=>{
        scope.setSDKProcessingMetadata({
            [$c9161b67125aefc1$export$61ab4e30f2201736]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$c9161b67125aefc1$export$61ab4e30f2201736]: void 0
        });
        return res;
    });
}
function $c9161b67125aefc1$export$7d5f2376f7cf513(scope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)()) {
    const acs = $c9161b67125aefc1$var$getAcs();
    if (acs.isTracingSuppressed) return acs.isTracingSuppressed(scope);
    return scope.getScopeData().sdkProcessingMetadata[$c9161b67125aefc1$export$61ab4e30f2201736] === true;
}
function $c9161b67125aefc1$export$f90b03291402f553(callback) {
    const acs = $c9161b67125aefc1$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return (0, $7d48e1ed9f699a01$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $ece9bac57decbcb8$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $c80d7f6644a3b50b$export$9869d72de32a3917)()
        });
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $c9161b67125aefc1$export$e57ac09b143d92a2(null, callback);
    });
}
function $c9161b67125aefc1$var$startMissingRequiredParentSpan(scope, client) {
    client?.recordDroppedEvent("no_parent_span", "span");
    const span = new (0, $057104436ef6f1c5$export$d6636b700b76c516)({
        traceId: scope.getPropagationContext().traceId
    });
    (0, $e54da191c628b5f0$export$cddb4027e3b0dd66)(span, scope, (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)());
    return span;
}
function $c9161b67125aefc1$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    const isolationScope = (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)();
    if (!(0, $e3827447d651dfc5$export$1f70765132c3c225)()) {
        const scopePropagationContext = scope.getPropagationContext();
        const traceId = parentSpan ? parentSpan.spanContext().traceId : scopePropagationContext.traceId;
        const span2 = new (0, $057104436ef6f1c5$export$d6636b700b76c516)({
            traceId: traceId
        });
        if (parentSpan && !forceTransaction) (0, $bb9b6447bf4caedb$export$81397d924722cc65)(parentSpan, span2);
        (0, $e54da191c628b5f0$export$cddb4027e3b0dd66)(span2, scope, isolationScope);
        return span2;
    }
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if ($c9161b67125aefc1$var$_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!$c9161b67125aefc1$export$7d5f2376f7cf513(scope)) client?.recordDroppedEvent("ignored", "span");
        const ignoredSpan = new (0, $057104436ef6f1c5$export$d6636b700b76c516)({
            dropReason: "ignored",
            traceId: parentSpan?.spanContext().traceId ?? scope.getPropagationContext().traceId
        });
        if (parentSpan && !forceTransaction) (0, $bb9b6447bf4caedb$export$81397d924722cc65)(parentSpan, ignoredSpan);
        (0, $e54da191c628b5f0$export$cddb4027e3b0dd66)(ignoredSpan, scope, isolationScope);
        return ignoredSpan;
    }
    let span;
    if (parentSpan && !forceTransaction) {
        span = $c9161b67125aefc1$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope);
        (0, $bb9b6447bf4caedb$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        const dsc = (0, $09fae5ef8120e803$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $bb9b6447bf4caedb$export$5caecac1caaf3a71)(parentSpan);
        span = $c9161b67125aefc1$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, isolationScope, parentSampled);
        (0, $09fae5ef8120e803$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = scope.getPropagationContext();
        span = $c9161b67125aefc1$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, isolationScope, parentSampled);
        if (dsc) (0, $09fae5ef8120e803$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $33f11695c2072059$export$2f3d84e767c9592b)(span);
    return span;
}
function $c9161b67125aefc1$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $bb9b6447bf4caedb$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $c9161b67125aefc1$var$getAcs() {
    const carrier = (0, $e4c75fb63b040566$export$19eade501500c6c1)();
    return (0, $a8b8acc568359454$export$f639b0c2752203be)(carrier);
}
function $c9161b67125aefc1$var$_startRootSpan(spanArguments, scope, isolationScope, parentSampled) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {};
    const { name: name = "" } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    client?.emit("beforeSampling", mutableSpanSamplingData, {
        decision: false
    });
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const _isTracingSuppressed = $c9161b67125aefc1$export$7d5f2376f7cf513(scope);
    const [sampled, sampleRate, localSampleRateWasApplied] = _isTracingSuppressed ? [
        false
    ] : (0, $ff32a69e7fdcf77e$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        normalizedRequest: isolationScope.getScopeData().sdkProcessingMetadata.normalizedRequest,
        parentSampleRate: (0, $921fe5f527b40422$export$a5bd2d81656d9546)(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, $32284c1a43c550a4$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $f337c80285f06f80$export$d7a7d984b0791405)]: "custom",
            [(0, $f337c80285f06f80$export$ccfe0a40627cc34b)]: sampleRate !== void 0 && localSampleRateWasApplied ? sampleRate : void 0,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client && !_isTracingSuppressed) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", (0, $45c38c4db3fc86e7$export$6ea47215d699c04a)(client) ? "span" : "transaction");
    }
    (0, $e54da191c628b5f0$export$cddb4027e3b0dd66)(rootSpan, scope, isolationScope);
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
function $c9161b67125aefc1$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const _isTracingSuppressed = $c9161b67125aefc1$export$7d5f2376f7cf513(scope);
    const sampled = _isTracingSuppressed ? false : (0, $bb9b6447bf4caedb$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $32284c1a43c550a4$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $057104436ef6f1c5$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $bb9b6447bf4caedb$export$81397d924722cc65)(parentSpan, childSpan);
    (0, $e54da191c628b5f0$export$cddb4027e3b0dd66)(childSpan, scope, isolationScope);
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (!client) return childSpan;
    if ((0, $45c38c4db3fc86e7$export$6ea47215d699c04a)(client) && (0, $057104436ef6f1c5$export$61cc547d99783aa7)(childSpan)) {
        if ((0, $057104436ef6f1c5$export$61cc547d99783aa7)(parentSpan) && parentSpan.dropReason) {
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, "span");
        } else if (!_isTracingSuppressed) {
            childSpan.dropReason = "sample_rate";
            client.recordDroppedEvent("sample_rate", "span");
        }
    }
    client.emit("spanStart", childSpan);
    if (spanArguments.endTimestamp) {
        client.emit("spanEnd", childSpan);
        client.emit("afterSpanEnd", childSpan);
    }
    return childSpan;
}
function $c9161b67125aefc1$var$getParentSpan(scope, customParentSpan) {
    if (customParentSpan) return customParentSpan;
    if (customParentSpan === null) return void 0;
    const span = (0, $dab1970d0c142a42$export$91f063ebb8eff307)(scope);
    if (!span) return void 0;
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $c9161b67125aefc1$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== void 0 ? (callback)=>{
        return $c9161b67125aefc1$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}
function $c9161b67125aefc1$var$_shouldIgnoreStreamedSpan(client, spanArguments) {
    const ignoreSpans = client?.getOptions().ignoreSpans;
    if (!client || !(0, $45c38c4db3fc86e7$export$6ea47215d699c04a)(client) || !ignoreSpans?.length) return false;
    return (0, $18bf74fc9ecc8708$export$5d569ac97c389400)({
        description: spanArguments.name || "",
        op: spanArguments.attributes?.[0, $f337c80285f06f80$export$1a413bd9a88fdb09] || spanArguments.op,
        attributes: spanArguments.attributes
    }, ignoreSpans);
}
function $c9161b67125aefc1$export$b0b1bd7d4bdbd54e(span) {
    return (0, $057104436ef6f1c5$export$61cc547d99783aa7)(span) && span.dropReason === "ignored";
}





const $436a0d44b1203b3c$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).document?.visibilityState === "hidden") cb(event);
    };
    (0, $cc264900893ba744$export$26d3d892edc56833)("visibilitychange", onHiddenOrPageHide, {
        capture: true,
        once: true
    });
    (0, $cc264900893ba744$export$26d3d892edc56833)("pagehide", onHiddenOrPageHide, {
        capture: true,
        once: true
    });
};


function $f19bf52440370854$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
function $f19bf52440370854$export$7567a67bdb69a23d(parentSpan, startTimeInSeconds, endTime, { ...ctx }) {
    const parentStartTime = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) {
        if (typeof parentSpan.updateStartTime === "function") parentSpan.updateStartTime(startTimeInSeconds);
    }
    return (0, $c9161b67125aefc1$export$e57ac09b143d92a2)(parentSpan, ()=>{
        const span = (0, $c9161b67125aefc1$export$63dbba021a6b4047)({
            startTime: startTimeInSeconds,
            ...ctx
        });
        if (span) span.end(endTime);
        return span;
    });
}
function $f19bf52440370854$export$b71b9c7b60c5a4aa(options) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (!client) return;
    const { name: name, transaction: transaction, attributes: passedAttributes, startTime: startTime } = options;
    const { release: release, environment: environment } = client.getOptions();
    const { userInfo: userInfo } = client.getDataCollectionOptions();
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId();
    const scope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
    const user = scope.getUser();
    const userDisplay = user !== void 0 ? user.email || user.id || user.ip_address : void 0;
    let profileId;
    try {
        profileId = scope.getScopeData().contexts.profile.profile_id;
    } catch  {}
    const attributes = {
        release: release,
        environment: environment,
        user: userDisplay || void 0,
        profile_id: profileId || void 0,
        replay_id: replayId || void 0,
        transaction: transaction,
        // Web vital score calculation relies on the user agent to account for different
        // browsers setting different thresholds for what is considered a good/meh/bad value.
        // For example: Chrome vs. Chrome Mobile
        "user_agent.original": (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).navigator?.userAgent,
        // This tells Sentry to infer the IP address from the request
        "client.address": userInfo ? "{{auto}}" : void 0,
        ...passedAttributes
    };
    return (0, $c9161b67125aefc1$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        experimental: {
            standalone: true
        }
    });
}
function $f19bf52440370854$export$f72a13c439a30cab() {
    return (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).addEventListener && (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).performance;
}
function $f19bf52440370854$export$b4785dbd4a81b33f(time) {
    return time / 1e3;
}
function $f19bf52440370854$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) name = _name;
    return {
        name: name,
        version: version
    };
}
function $f19bf52440370854$export$c7533a7b4a9f2e94(entryType) {
    try {
        return PerformanceObserver.supportedEntryTypes.includes(entryType);
    } catch  {
        return false;
    }
}
function $f19bf52440370854$export$382ad360b45665ab(client, collectorCallback) {
    let pageloadSpan;
    let collected = false;
    function _runCollectorCallbackOnce(event) {
        if (!collected && pageloadSpan) collectorCallback(event, pageloadSpan.spanContext().spanId, pageloadSpan);
        collected = true;
    }
    (0, $436a0d44b1203b3c$export$91ec2be6fdd8f1b4)(()=>{
        _runCollectorCallbackOnce("pagehide");
    });
    const unsubscribeStartNavigation = client.on("beforeStartNavigationSpan", (_, options)=>{
        if (!options?.isRedirect) {
            _runCollectorCallbackOnce("navigation");
            unsubscribeStartNavigation();
            unsubscribeAfterStartPageLoadSpan();
        }
    });
    const unsubscribeAfterStartPageLoadSpan = client.on("afterStartPageLoadSpan", (span)=>{
        pageloadSpan = span;
        unsubscribeAfterStartPageLoadSpan();
    });
}


function $a0cd2c3ac77c8b77$var$getAbsoluteTime(time) {
    return time ? (((0, $bc81602376c48fa6$export$baf075a948ffc0bf)() || performance.timeOrigin) + time) / 1e3 : time;
}
function $a0cd2c3ac77c8b77$export$ec50b091612e7e00(resourceTiming) {
    const timingSpanData = {};
    if (resourceTiming.nextHopProtocol != void 0) {
        const { name: name, version: version } = (0, $f19bf52440370854$export$57c6f824442f9fe1)(resourceTiming.nextHopProtocol);
        timingSpanData["network.protocol.version"] = version;
        timingSpanData["network.protocol.name"] = name;
    }
    if (!((0, $bc81602376c48fa6$export$baf075a948ffc0bf)() || (0, $f19bf52440370854$export$f72a13c439a30cab)()?.timeOrigin)) return timingSpanData;
    return $a0cd2c3ac77c8b77$var$dropUndefinedKeysFromObject({
        ...timingSpanData,
        "http.request.redirect_start": $a0cd2c3ac77c8b77$var$getAbsoluteTime(resourceTiming.redirectStart),
        "http.request.redirect_end": $a0cd2c3ac77c8b77$var$getAbsoluteTime(resourceTiming.redirectEnd),
        "http.request.worker_start": $a0cd2c3ac77c8b77$var$getAbsoluteTime(resourceTiming.workerStart),
        "http.request.fetch_start": $a0cd2c3ac77c8b77$var$getAbsoluteTime(resourceTiming.fetchStart),
        "http.request.domain_lookup_start": $a0cd2c3ac77c8b77$var$getAbsoluteTime(resourceTiming.domainLookupStart),
        "http.request.domain_lookup_end": $a0cd2c3ac77c8b77$var$getAbsoluteTime(resourceTiming.domainLookupEnd),
        "http.request.connect_start": $a0cd2c3ac77c8b77$var$getAbsoluteTime(resourceTiming.connectStart),
        "http.request.secure_connection_start": $a0cd2c3ac77c8b77$var$getAbsoluteTime(resourceTiming.secureConnectionStart),
        "http.request.connection_end": $a0cd2c3ac77c8b77$var$getAbsoluteTime(resourceTiming.connectEnd),
        "http.request.request_start": $a0cd2c3ac77c8b77$var$getAbsoluteTime(resourceTiming.requestStart),
        "http.request.response_start": $a0cd2c3ac77c8b77$var$getAbsoluteTime(resourceTiming.responseStart),
        "http.request.response_end": $a0cd2c3ac77c8b77$var$getAbsoluteTime(resourceTiming.responseEnd),
        // For TTFB we actually want the relative time from timeOrigin to responseStart
        // This way, TTFB always measures the "first page load" experience.
        // see: https://web.dev/articles/ttfb#measure-resource-requests
        "http.request.time_to_first_byte": resourceTiming.responseStart != null ? resourceTiming.responseStart / 1e3 : void 0
    });
}
function $a0cd2c3ac77c8b77$var$dropUndefinedKeysFromObject(attrs) {
    return Object.fromEntries(Object.entries(attrs).filter(([, value])=>value != null));
}



function $ddee3d8e773cae02$export$8193ac587e359dc0(baggageHeader) {
    return baggageHeader.split(",").some((value)=>value.trim().startsWith("sentry-"));
}
function $ddee3d8e773cae02$export$f2a087db7564c909(url) {
    try {
        const parsed = new URL(url, (0, $e62dec891f31852b$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch  {
        return void 0;
    }
}
function $ddee3d8e773cae02$export$5803eedf1027ce61(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
function $ddee3d8e773cae02$export$9dc5b8b2fb320da0(headers) {
    try {
        return new Headers(headers);
    } catch  {
        return void 0;
    }
}



var $3tmPs = parcelRequire("3tmPs");
const $b3e0e430d6ae504d$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    trackFetchStreamPerformance: false
};
function $b3e0e430d6ae504d$export$864489cb3478db3e(client, _options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, tracePropagationTargets: tracePropagationTargets, onRequestSpanStart: onRequestSpanStart, onRequestSpanEnd: onRequestSpanEnd } = {
        ...$b3e0e430d6ae504d$export$cc17fb3c0bc95cd7,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    const shouldAttachHeadersWithTargets = (url)=>$b3e0e430d6ae504d$export$c260386ab3f0b3dd(url, tracePropagationTargets);
    const spans = {};
    const propagateTraceparent = client.getOptions().propagateTraceparent;
    if (traceFetch) (0, $b244ff70a28cf637$exports.addFetchInstrumentationHandler)((handlerData)=>{
        const createdSpan = (0, $b244ff70a28cf637$exports.instrumentFetchRequest)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, {
            propagateTraceparent: propagateTraceparent,
            onRequestSpanEnd: onRequestSpanEnd
        });
        if (createdSpan) {
            const fullUrl = (0, $ddee3d8e773cae02$export$f2a087db7564c909)(handlerData.fetchData.url);
            const host = fullUrl ? (0, $b244ff70a28cf637$exports.parseUrl)(fullUrl).host : void 0;
            const sanitizedFullUrl = fullUrl ? (0, $b244ff70a28cf637$exports.stripDataUrlContent)(fullUrl) : void 0;
            createdSpan.setAttributes({
                // oxlint-disable-next-line typescript/no-deprecated
                [(0, $3tmPs.HTTP_URL)]: sanitizedFullUrl,
                // `url.full` must match `http.url`. Setting it here ensures parentless `http.client`
                // segment spans don't get `url.full` backfilled with the host page URL (see httpContextIntegration).
                [(0, $3tmPs.URL_FULL)]: sanitizedFullUrl,
                "server.address": host
            });
            if (enableHTTPTimings) $b3e0e430d6ae504d$var$addHTTPTimings(createdSpan, client);
            onRequestSpanStart?.(createdSpan, {
                headers: handlerData.headers
            });
        }
    });
    if (traceXHR) (0, $447740b7cde7d984$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $b3e0e430d6ae504d$var$xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, propagateTraceparent, onRequestSpanEnd);
        if (createdSpan) {
            if (enableHTTPTimings) $b3e0e430d6ae504d$var$addHTTPTimings(createdSpan, client);
            onRequestSpanStart?.(createdSpan, {
                headers: (0, $ddee3d8e773cae02$export$9dc5b8b2fb320da0)(handlerData.xhr.__sentry_xhr_v3__?.request_headers)
            });
        }
    });
}
const $b3e0e430d6ae504d$var$HTTP_TIMING_WAIT_MS = 300;
function $b3e0e430d6ae504d$var$addHTTPTimings(span, client) {
    const { url: url } = (0, $b244ff70a28cf637$exports.spanToJSON)(span).data;
    if (!url || typeof url !== "string") return;
    let onEntryFound = ()=>void setTimeout(unsubscribePerformanceObsever);
    if ((0, $b244ff70a28cf637$exports.hasSpanStreamingEnabled)(client)) {
        const originalEnd = span.end.bind(span);
        span.end = (endTimestamp)=>{
            const capturedEndTimestamp = endTimestamp ?? (0, $b244ff70a28cf637$exports.timestampInSeconds)();
            let isEnded = false;
            const endSpanAndCleanup = ()=>{
                if (isEnded) return;
                isEnded = true;
                setTimeout(unsubscribePerformanceObsever);
                originalEnd(capturedEndTimestamp);
                clearTimeout(fallbackTimeout);
            };
            onEntryFound = endSpanAndCleanup;
            const fallbackTimeout = setTimeout(endSpanAndCleanup, $b3e0e430d6ae504d$var$HTTP_TIMING_WAIT_MS);
        };
    }
    const unsubscribePerformanceObsever = (0, $375623e17d0e1d27$export$69816c1a049f8db6)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ((0, $ddee3d8e773cae02$export$5803eedf1027ce61)(entry) && entry.name.endsWith(url)) {
                span.setAttributes((0, $a0cd2c3ac77c8b77$export$ec50b091612e7e00)(entry));
                onEntryFound();
            }
        });
    });
}
function $b3e0e430d6ae504d$export$c260386ab3f0b3dd(targetUrl, tracePropagationTargets) {
    const href = (0, $b244ff70a28cf637$exports.getLocationHref)();
    if (!href) {
        const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, $b244ff70a28cf637$exports.stringMatchesSomePattern)(targetUrl, tracePropagationTargets);
    } else {
        let resolvedUrl;
        let currentOrigin;
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch  {
            return false;
        }
        const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, $b244ff70a28cf637$exports.stringMatchesSomePattern)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, $b244ff70a28cf637$exports.stringMatchesSomePattern)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
function $b3e0e430d6ae504d$var$xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeaders2, spans, propagateTraceparent, onRequestSpanEnd) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr?.[0, $447740b7cde7d984$export$55b6bb1e45c6cf59];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return void 0;
    const { url: url, method: method } = sentryXhrData;
    const shouldCreateSpanResult = (0, $b244ff70a28cf637$exports.hasSpansEnabled)() && shouldCreateSpan(url);
    if (handlerData.endTimestamp) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span2 = spans[spanId];
        if (span2) {
            if (shouldCreateSpanResult && sentryXhrData.status_code !== void 0) {
                (0, $b244ff70a28cf637$exports.setHttpStatus)(span2, sentryXhrData.status_code);
                span2.end();
                onRequestSpanEnd?.(span2, {
                    headers: (0, $ddee3d8e773cae02$export$9dc5b8b2fb320da0)((0, $b3543acae904e2dc$export$ce71c337afb62ea)(xhr)),
                    error: handlerData.error
                });
            }
            delete spans[spanId];
        }
        return void 0;
    }
    const fullUrl = (0, $ddee3d8e773cae02$export$f2a087db7564c909)(url);
    const parsedUrl = fullUrl ? (0, $b244ff70a28cf637$exports.parseUrl)(fullUrl) : (0, $b244ff70a28cf637$exports.parseUrl)(url);
    const sanitizedFullUrl = fullUrl ? (0, $b244ff70a28cf637$exports.stripDataUrlContent)(fullUrl) : void 0;
    const urlForSpanName = (0, $b244ff70a28cf637$exports.stripDataUrlContent)((0, $b244ff70a28cf637$exports.stripUrlQueryAndFragment)(url));
    const client = (0, $b244ff70a28cf637$exports.getClient)();
    const hasParent = !!(0, $b244ff70a28cf637$exports.getActiveSpan)();
    const shouldEmitSpan = hasParent || !!client && (0, $b244ff70a28cf637$exports.hasSpanStreamingEnabled)(client);
    const span = shouldCreateSpanResult && shouldEmitSpan ? (0, $b244ff70a28cf637$exports.startInactiveSpan)({
        name: `${method} ${urlForSpanName}`,
        attributes: {
            url: (0, $b244ff70a28cf637$exports.stripDataUrlContent)(url),
            type: "xhr",
            "http.method": method,
            "http.url": sanitizedFullUrl,
            // `url.full` must match `http.url`. Setting it here ensures parentless `http.client`
            // segment spans don't get `url.full` backfilled with the host page URL (see httpContextIntegration).
            [(0, $3tmPs.URL_FULL)]: sanitizedFullUrl,
            "server.address": parsedUrl?.host,
            [(0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.http.browser",
            [(0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "http.client",
            ...parsedUrl?.search && {
                "http.query": parsedUrl?.search
            },
            ...parsedUrl?.hash && {
                "http.fragment": parsedUrl?.hash
            }
        }
    }) : new (0, $b244ff70a28cf637$exports.SentryNonRecordingSpan)();
    const spanForTraceHeaders = (0, $b244ff70a28cf637$exports.spanIsIgnored)(span) && hasParent ? void 0 : span;
    if (shouldCreateSpanResult && !shouldEmitSpan) client?.recordDroppedEvent("no_parent_span", "span");
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
    if (shouldAttachHeaders2(url)) $b3e0e430d6ae504d$var$addTracingHeadersToXhrRequest(xhr, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, $b244ff70a28cf637$exports.hasSpansEnabled)() && shouldEmitSpan ? spanForTraceHeaders : void 0, propagateTraceparent);
    if (client) client.emit("beforeOutgoingRequestSpan", span, handlerData);
    return span;
}
function $b3e0e430d6ae504d$var$addTracingHeadersToXhrRequest(xhr, span, propagateTraceparent) {
    const { "sentry-trace": sentryTrace, baggage: baggage, traceparent: traceparent } = (0, $b244ff70a28cf637$exports.getTraceData)({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    if (sentryTrace) $b3e0e430d6ae504d$var$setHeaderOnXhr(xhr, sentryTrace, baggage, traceparent);
}
function $b3e0e430d6ae504d$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader, traceparentHeader) {
    const originalHeaders = xhr.__sentry_xhr_v3__?.request_headers;
    if (originalHeaders?.["sentry-trace"] || !xhr.setRequestHeader) return;
    try {
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (traceparentHeader && !originalHeaders?.["traceparent"]) xhr.setRequestHeader("traceparent", traceparentHeader);
        if (sentryBaggageHeader) {
            const originalBaggageHeader = originalHeaders?.["baggage"];
            if (!originalBaggageHeader || !(0, $ddee3d8e773cae02$export$8193ac587e359dc0)(originalBaggageHeader)) xhr.setRequestHeader("baggage", sentryBaggageHeader);
        }
    } catch  {}
}











function $9b2d35b0e749a66b$export$585bab03c6c18c45(client) {
    let standaloneCLsValue = 0;
    let standaloneClsEntry;
    if (!(0, $f19bf52440370854$export$c7533a7b4a9f2e94)("layout-shift")) return;
    const cleanupClsHandler = (0, $375623e17d0e1d27$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneCLsValue = metric.value;
        standaloneClsEntry = entry;
    }, true);
    (0, $f19bf52440370854$export$382ad360b45665ab)(client, (reportEvent, pageloadSpanId)=>{
        $9b2d35b0e749a66b$export$910bd4e865129f07(standaloneCLsValue, standaloneClsEntry, pageloadSpanId, reportEvent);
        cleanupClsHandler();
    });
}
function $9b2d35b0e749a66b$export$910bd4e865129f07(clsValue, entry, pageloadSpanId, reportEvent) {
    (0, $c54a9ced88c7488b$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Sending CLS span (${clsValue})`);
    const startTime = entry ? (0, $f19bf52440370854$export$b4785dbd4a81b33f)(((0, $bc81602376c48fa6$export$baf075a948ffc0bf)() || 0) + entry.startTime) : (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
    const routeName = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $25d1cfcd58d5af8d$export$5647df6b7814ac86)(entry.sources[0]?.node) : "Layout shift";
    const attributes = {
        [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: "auto.http.browser.cls",
        [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: "ui.webvital.cls",
        [(0, $f337c80285f06f80$export$fea48ba9f4550879)]: 0,
        // attach the pageload span id to the CLS span so that we can link them in the UI
        "sentry.pageload.span_id": pageloadSpanId,
        // describes what triggered the web vital to be reported
        "sentry.report_event": reportEvent
    };
    if (entry?.sources) entry.sources.forEach((source, index)=>{
        attributes[`cls.source.${index + 1}`] = (0, $25d1cfcd58d5af8d$export$5647df6b7814ac86)(source.node);
    });
    const span = (0, $f19bf52440370854$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("cls", {
            [(0, $f337c80285f06f80$export$f5f95cff026507b5)]: "",
            [(0, $f337c80285f06f80$export$69cd5c610c7bb96a)]: clsValue
        });
        span.end(startTime);
    }
}








const $14e7a12c0555fcc7$export$ccce4d286bdc973b = 6e4;
function $14e7a12c0555fcc7$export$e59775b7d17699ba(lcpValue) {
    return lcpValue != null && lcpValue > 0 && lcpValue <= $14e7a12c0555fcc7$export$ccce4d286bdc973b;
}
function $14e7a12c0555fcc7$export$485112b2cb5f79dc(client) {
    let standaloneLcpValue = 0;
    let standaloneLcpEntry;
    if (!(0, $f19bf52440370854$export$c7533a7b4a9f2e94)("largest-contentful-paint")) return;
    const cleanupLcpHandler = (0, $375623e17d0e1d27$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry || !$14e7a12c0555fcc7$export$e59775b7d17699ba(metric.value)) return;
        standaloneLcpValue = metric.value;
        standaloneLcpEntry = entry;
    }, true);
    (0, $f19bf52440370854$export$382ad360b45665ab)(client, (reportEvent, pageloadSpanId)=>{
        $14e7a12c0555fcc7$export$1c28dab7ad4ec937(standaloneLcpValue, standaloneLcpEntry, pageloadSpanId, reportEvent);
        cleanupLcpHandler();
    });
}
function $14e7a12c0555fcc7$export$1c28dab7ad4ec937(lcpValue, entry, pageloadSpanId, reportEvent) {
    if (!$14e7a12c0555fcc7$export$e59775b7d17699ba(lcpValue)) return;
    (0, $c54a9ced88c7488b$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Sending LCP span (${lcpValue})`);
    const startTime = (0, $f19bf52440370854$export$b4785dbd4a81b33f)(((0, $bc81602376c48fa6$export$baf075a948ffc0bf)() || 0) + (entry?.startTime || 0));
    const routeName = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $25d1cfcd58d5af8d$export$5647df6b7814ac86)(entry.element) : "Largest contentful paint";
    const attributes = {
        [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: "auto.http.browser.lcp",
        [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: "ui.webvital.lcp",
        [(0, $f337c80285f06f80$export$fea48ba9f4550879)]: 0,
        // LCP is a point-in-time metric
        // attach the pageload span id to the LCP span so that we can link them in the UI
        "sentry.pageload.span_id": pageloadSpanId,
        // describes what triggered the web vital to be reported
        "sentry.report_event": reportEvent
    };
    if (entry) {
        entry.element && (attributes["lcp.element"] = (0, $25d1cfcd58d5af8d$export$5647df6b7814ac86)(entry.element));
        entry.id && (attributes["lcp.id"] = entry.id);
        entry.url && (attributes["lcp.url"] = entry.url);
        entry.loadTime != null && (attributes["lcp.loadTime"] = entry.loadTime);
        entry.renderTime != null && (attributes["lcp.renderTime"] = entry.renderTime);
        entry.size != null && (attributes["lcp.size"] = entry.size);
    }
    const span = (0, $f19bf52440370854$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("lcp", {
            [(0, $f337c80285f06f80$export$f5f95cff026507b5)]: "millisecond",
            [(0, $f337c80285f06f80$export$69cd5c610c7bb96a)]: lcpValue
        });
        span.end(startTime);
    }
}









var $3tmPs = parcelRequire("3tmPs");
const $a079719030764828$var$MAX_INT_AS_BYTES = 2147483647;
let $a079719030764828$var$_performanceCursor = 0;
let $a079719030764828$var$_measurements = {};
let $a079719030764828$var$_lcpEntry;
let $a079719030764828$var$_clsEntry;
function $a079719030764828$export$7c69f0412d101b88({ recordClsStandaloneSpans: recordClsStandaloneSpans, recordLcpStandaloneSpans: recordLcpStandaloneSpans, client: client }) {
    const performance = (0, $f19bf52440370854$export$f72a13c439a30cab)();
    if (performance && (0, $bc81602376c48fa6$export$baf075a948ffc0bf)()) {
        if (performance.mark) (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        const lcpCleanupCallback = recordLcpStandaloneSpans ? (0, $14e7a12c0555fcc7$export$485112b2cb5f79dc)(client) : recordLcpStandaloneSpans === false ? $a079719030764828$var$_trackLCP() : void 0;
        const clsCleanupCallback = recordClsStandaloneSpans ? (0, $9b2d35b0e749a66b$export$585bab03c6c18c45)(client) : recordClsStandaloneSpans === false ? $a079719030764828$var$_trackCLS() : void 0;
        const ttfbCleanupCallback = $a079719030764828$var$_trackTtfb();
        const fpFcpCleanupCallback = $a079719030764828$var$_trackFpFcp();
        return ()=>{
            ttfbCleanupCallback();
            fpFcpCleanupCallback();
            lcpCleanupCallback?.();
            clsCleanupCallback?.();
        };
    }
    return ()=>void 0;
}
function $a079719030764828$export$f396d19077034ad2() {
    (0, $375623e17d0e1d27$export$69816c1a049f8db6)("longtask", ({ entries: entries })=>{
        const parent = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
        if (!parent) return;
        const { op: parentOp, start_timestamp: parentStartTimestamp } = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(parent);
        for (const entry of entries){
            const startTime = (0, $f19bf52440370854$export$b4785dbd4a81b33f)((0, $bc81602376c48fa6$export$baf075a948ffc0bf)() + entry.startTime);
            const duration = (0, $f19bf52440370854$export$b4785dbd4a81b33f)(entry.duration);
            if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            (0, $f19bf52440370854$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: "Main UI thread blocked",
                op: "ui.long-task",
                attributes: {
                    [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            });
        }
    });
}
function $a079719030764828$export$5b823ab2ccbc801d() {
    const observer = new PerformanceObserver((list)=>{
        const parent = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of list.getEntries()){
            if (!entry.scripts[0]) continue;
            const startTime = (0, $f19bf52440370854$export$b4785dbd4a81b33f)((0, $bc81602376c48fa6$export$baf075a948ffc0bf)() + entry.startTime);
            const { start_timestamp: parentStartTimestamp, op: parentOp } = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(parent);
            if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            const duration = (0, $f19bf52440370854$export$b4785dbd4a81b33f)(entry.duration);
            const attributes = {
                [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            };
            const initialScript = entry.scripts[0];
            const { invoker: invoker, invokerType: invokerType, sourceURL: sourceURL, sourceFunctionName: sourceFunctionName, sourceCharPosition: sourceCharPosition } = initialScript;
            attributes["browser.script.invoker"] = invoker;
            attributes["browser.script.invoker_type"] = invokerType;
            if (sourceURL) attributes["code.filepath"] = sourceURL;
            if (sourceFunctionName) attributes["code.function"] = sourceFunctionName;
            if (sourceCharPosition !== -1) attributes["browser.script.source_char_position"] = sourceCharPosition;
            (0, $f19bf52440370854$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: "Main UI thread blocked",
                op: "ui.long-animation-frame",
                attributes: attributes
            });
        }
    });
    observer.observe({
        type: "long-animation-frame",
        buffered: true
    });
}
function $a079719030764828$export$e27543e0976315e4() {
    (0, $375623e17d0e1d27$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        const parent = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of entries)if (entry.name === "click") {
            const startTime = (0, $f19bf52440370854$export$b4785dbd4a81b33f)((0, $bc81602376c48fa6$export$baf075a948ffc0bf)() + entry.startTime);
            const duration = (0, $f19bf52440370854$export$b4785dbd4a81b33f)(entry.duration);
            const spanOptions = {
                name: (0, $25d1cfcd58d5af8d$export$5647df6b7814ac86)(entry.target),
                op: `ui.interaction.${entry.name}`,
                startTime: startTime,
                attributes: {
                    [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            };
            const componentName = (0, $caac489b9d8395b2$export$26727cfcc4d7e0fc)(entry.target);
            if (componentName) spanOptions.attributes["ui.component_name"] = componentName;
            (0, $f19bf52440370854$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, spanOptions);
        }
    });
}
function $a079719030764828$var$_trackCLS() {
    return (0, $375623e17d0e1d27$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $a079719030764828$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $a079719030764828$var$_clsEntry = entry;
    }, true);
}
function $a079719030764828$var$_trackLCP() {
    return (0, $375623e17d0e1d27$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry || !(0, $14e7a12c0555fcc7$export$e59775b7d17699ba)(metric.value)) return;
        $a079719030764828$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $a079719030764828$var$_lcpEntry = entry;
    }, true);
}
function $a079719030764828$var$_trackTtfb() {
    return (0, $375623e17d0e1d27$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $a079719030764828$var$_measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
function $a079719030764828$var$_trackFpFcp() {
    return (0, $375623e17d0e1d27$export$69816c1a049f8db6)("paint", ({ entries: entries })=>{
        const firstHidden = (0, $e86be68ef7ac046f$export$443f86b2c77012c4)();
        for (const entry of entries){
            const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
            if (entry.name === "first-paint" && shouldRecord) $a079719030764828$var$_measurements["fp"] = {
                value: entry.startTime,
                unit: "millisecond"
            };
            if (entry.name === "first-contentful-paint" && shouldRecord) $a079719030764828$var$_measurements["fcp"] = {
                value: entry.startTime,
                unit: "millisecond"
            };
        }
    });
}
function $a079719030764828$export$5f8fa6b3467a7443(span, options) {
    const performance = (0, $f19bf52440370854$export$f72a13c439a30cab)();
    const origin = (0, $bc81602376c48fa6$export$baf075a948ffc0bf)();
    if (!performance?.getEntries || !origin) return;
    const { spanStreamingEnabled: spanStreamingEnabled, ignorePerformanceApiSpans: ignorePerformanceApiSpans, ignoreResourceSpans: ignoreResourceSpans } = options;
    const timeOrigin = (0, $f19bf52440370854$export$b4785dbd4a81b33f)(origin);
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(span);
    performanceEntries.slice($a079719030764828$var$_performanceCursor).forEach((entry)=>{
        const startTime = (0, $f19bf52440370854$export$b4785dbd4a81b33f)(entry.startTime);
        const duration = (0, $f19bf52440370854$export$b4785dbd4a81b33f)(// Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
        // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
        // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
        // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
        Math.max(0, entry.duration));
        if (op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $a079719030764828$export$90a8fd571ed9a1bc(span, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                $a079719030764828$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans);
                break;
            case "resource":
                $a079719030764828$export$c82fe1a70634f317(span, entry, entry.name, startTime, duration, timeOrigin, ignoreResourceSpans);
                break;
        }
    });
    $a079719030764828$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $a079719030764828$var$_trackNavigator(span, spanStreamingEnabled);
}
function $a079719030764828$export$d14e394b690acc17(span, options) {
    const origin = (0, $bc81602376c48fa6$export$baf075a948ffc0bf)();
    if (!(0, $f19bf52440370854$export$f72a13c439a30cab)()?.getEntries || !origin) {
        $a079719030764828$var$resetWebVitalState();
        return;
    }
    const { spanStreamingEnabled: spanStreamingEnabled, recordClsOnPageloadSpan: recordClsOnPageloadSpan, recordLcpOnPageloadSpan: recordLcpOnPageloadSpan } = options;
    const timeOrigin = (0, $f19bf52440370854$export$b4785dbd4a81b33f)(origin);
    if ((0, $bb9b6447bf4caedb$export$92d8c23565496537)(span).op === "pageload") {
        $a079719030764828$var$_addTtfbRequestTimeToMeasurements($a079719030764828$var$_measurements);
        if (spanStreamingEnabled) {
            const setAttr = (shortWebVitalName, value, customAttrName)=>{
                const attrKey = customAttrName ?? `browser.web_vital.${shortWebVitalName}.value`;
                span.setAttribute(attrKey, value);
                (0, $c54a9ced88c7488b$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log("Setting web vital attribute", {
                    [attrKey]: value
                }, "on pageload span");
            };
            [
                "ttfb",
                "fp",
                "fcp"
            ].forEach((measurementName)=>{
                if ($a079719030764828$var$_measurements[measurementName]) setAttr(measurementName, $a079719030764828$var$_measurements[measurementName].value);
            });
            if ($a079719030764828$var$_measurements["ttfb.requestTime"]) setAttr("ttfb.requestTime", $a079719030764828$var$_measurements["ttfb.requestTime"].value, "browser.web_vital.ttfb.request_time");
        } else {
            if (!recordClsOnPageloadSpan) delete $a079719030764828$var$_measurements.cls;
            if (!recordLcpOnPageloadSpan) delete $a079719030764828$var$_measurements.lcp;
            Object.entries($a079719030764828$var$_measurements).forEach(([measurementName, measurement])=>{
                (0, $dbcaa70aa380aaa2$export$7cc31b475d33a706)(measurementName, measurement.value, measurement.unit, span);
            });
            $a079719030764828$var$_setWebVitalAttributes(span, options);
        }
        span.setAttribute(spanStreamingEnabled ? "browser.performance.time_origin" : "performance.timeOrigin", timeOrigin);
        span.setAttribute(spanStreamingEnabled ? "browser.performance.navigation.activation_start" : "performance.activationStart", (0, $b9e806a0f3ff4e89$export$d3e828b3c7b5b845)());
    }
    $a079719030764828$var$resetWebVitalState();
}
function $a079719030764828$var$resetWebVitalState() {
    $a079719030764828$var$_lcpEntry = void 0;
    $a079719030764828$var$_clsEntry = void 0;
    $a079719030764828$var$_measurements = {};
}
function $a079719030764828$var$isReact19MeasureEntry(entry) {
    if (entry?.entryType !== "measure") return;
    try {
        return entry.detail.devtools.track === "Components \u269B";
    } catch  {
        return;
    }
}
function $a079719030764828$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans) {
    if ($a079719030764828$var$isReact19MeasureEntry(entry)) return;
    if ([
        "mark",
        "measure"
    ].includes(entry.entryType) && (0, $e534db390d1e4996$export$a7a5ec66062ea5d)(entry.name, ignorePerformanceApiSpans)) return;
    const navEntry = (0, $173177c362404304$export$6431553786c94949)(false);
    const requestTime = (0, $f19bf52440370854$export$b4785dbd4a81b33f)(navEntry ? navEntry.requestStart : 0);
    const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
    const startTimeStamp = timeOrigin + startTime;
    const measureEndTimestamp = startTimeStamp + duration;
    const attributes = {
        [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: "auto.resource.browser.metrics"
    };
    if (measureStartTimestamp !== startTimeStamp) {
        attributes["sentry.browser.measure_happened_before_request"] = true;
        attributes["sentry.browser.measure_start_time"] = measureStartTimestamp;
    }
    $a079719030764828$var$_addDetailToSpanAttributes(attributes, entry);
    if (measureStartTimestamp <= measureEndTimestamp) (0, $f19bf52440370854$export$7567a67bdb69a23d)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: attributes
    });
}
function $a079719030764828$var$_addDetailToSpanAttributes(attributes, performanceMeasure) {
    try {
        const detail = performanceMeasure.detail;
        if (!detail) return;
        if (typeof detail === "object") {
            for (const [key, value] of Object.entries(detail)){
                if (value && (0, $13cf2ed412f405fa$export$c3825b437cbdea5c)(value)) attributes[`sentry.browser.measure.detail.${key}`] = value;
                else if (value !== void 0) try {
                    attributes[`sentry.browser.measure.detail.${key}`] = JSON.stringify(value);
                } catch  {}
            }
            return;
        }
        if ((0, $13cf2ed412f405fa$export$c3825b437cbdea5c)(detail)) {
            attributes["sentry.browser.measure.detail"] = detail;
            return;
        }
        try {
            attributes["sentry.browser.measure.detail"] = JSON.stringify(detail);
        } catch  {}
    } catch  {}
}
function $a079719030764828$export$90a8fd571ed9a1bc(span, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $a079719030764828$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    $a079719030764828$var$_addPerformanceNavigationTiming(span, entry, "secureConnection", timeOrigin, "TLS/SSL");
    $a079719030764828$var$_addPerformanceNavigationTiming(span, entry, "fetch", timeOrigin, "cache");
    $a079719030764828$var$_addPerformanceNavigationTiming(span, entry, "domainLookup", timeOrigin, "DNS");
    $a079719030764828$var$_addRequest(span, entry, timeOrigin);
}
function $a079719030764828$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin, name = event) {
    const eventEnd = $a079719030764828$var$_getEndPropertyNameForNavigationTiming(event);
    const end = entry[eventEnd];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $f19bf52440370854$export$7567a67bdb69a23d)(span, timeOrigin + (0, $f19bf52440370854$export$b4785dbd4a81b33f)(start), timeOrigin + (0, $f19bf52440370854$export$b4785dbd4a81b33f)(end), {
        op: `browser.${name}`,
        name: entry.name,
        attributes: {
            [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics",
            ...event === "redirect" && entry.redirectCount != null ? {
                "http.redirect_count": entry.redirectCount
            } : {}
        }
    });
}
function $a079719030764828$var$_getEndPropertyNameForNavigationTiming(event) {
    if (event === "secureConnection") return "connectEnd";
    if (event === "fetch") return "domainLookupStart";
    return `${event}End`;
}
function $a079719030764828$var$_addRequest(span, entry, timeOrigin) {
    const requestStartTimestamp = timeOrigin + (0, $f19bf52440370854$export$b4785dbd4a81b33f)(entry.requestStart);
    const responseEndTimestamp = timeOrigin + (0, $f19bf52440370854$export$b4785dbd4a81b33f)(entry.responseEnd);
    const responseStartTimestamp = timeOrigin + (0, $f19bf52440370854$export$b4785dbd4a81b33f)(entry.responseStart);
    if (entry.responseEnd) {
        (0, $f19bf52440370854$export$7567a67bdb69a23d)(span, requestStartTimestamp, responseEndTimestamp, {
            op: "browser.request",
            name: entry.name,
            attributes: {
                [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            }
        });
        (0, $f19bf52440370854$export$7567a67bdb69a23d)(span, responseStartTimestamp, responseEndTimestamp, {
            op: "browser.response",
            name: entry.name,
            attributes: {
                [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            }
        });
    }
}
function $a079719030764828$export$c82fe1a70634f317(span, entry, resourceUrl, startTime, duration, timeOrigin, ignoredResourceSpanOps) {
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const op = entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other";
    if (ignoredResourceSpanOps?.includes(op)) return;
    const attributes = {
        [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: "auto.resource.browser.metrics"
    };
    const parsedUrl = (0, $0c1b93525a804899$export$7a5253c0f62e0150)(resourceUrl);
    if (parsedUrl.protocol) attributes["url.scheme"] = parsedUrl.protocol.split(":").pop();
    if (parsedUrl.host) attributes["server.address"] = parsedUrl.host;
    attributes["url.same_origin"] = resourceUrl.includes((0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).location.origin);
    attributes[0, $3tmPs.URL_FULL] = resourceUrl;
    $a079719030764828$export$6ce741ceee01ab2f(entry, attributes, [
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus
        [
            "responseStatus",
            "http.response.status_code"
        ],
        [
            "transferSize",
            "http.response_transfer_size"
        ],
        [
            "encodedBodySize",
            "http.response_content_length"
        ],
        [
            "decodedBodySize",
            "http.decoded_response_content_length"
        ],
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/renderBlockingStatus
        [
            "renderBlockingStatus",
            "resource.render_blocking_status"
        ],
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/deliveryType
        [
            "deliveryType",
            "http.response_delivery_type"
        ]
    ]);
    const attributesWithResourceTiming = {
        ...attributes,
        ...(0, $a0cd2c3ac77c8b77$export$ec50b091612e7e00)(entry)
    };
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $f19bf52440370854$export$7567a67bdb69a23d)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).location.origin, ""),
        op: op,
        attributes: attributesWithResourceTiming
    });
}
function $a079719030764828$var$_trackNavigator(span, spanStreamingEnabled) {
    const navigator = (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute(spanStreamingEnabled ? "network.connection.effective_type" : "effectiveConnectionType", connection.effectiveType);
        if (connection.type) span.setAttribute(spanStreamingEnabled ? "network.connection.type" : "connectionType", connection.type);
        if ((0, $f19bf52440370854$export$27169ccae1b439e3)(connection.rtt)) {
            if (spanStreamingEnabled) span.setAttribute("network.connection.rtt", connection.rtt);
            else if ((0, $bb9b6447bf4caedb$export$92d8c23565496537)(span).op === "pageload") (0, $dbcaa70aa380aaa2$export$7cc31b475d33a706)("connection.rtt", connection.rtt, "millisecond");
        }
    }
    if ((0, $f19bf52440370854$export$27169ccae1b439e3)(navigator.deviceMemory)) {
        if (spanStreamingEnabled) span.setAttribute("device.memory.estimated_capacity", navigator.deviceMemory);
        else span.setAttribute("deviceMemory", `${navigator.deviceMemory} GB`);
    }
    if ((0, $f19bf52440370854$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) {
        if (spanStreamingEnabled) span.setAttribute("device.processor_count", navigator.hardwareConcurrency);
        else span.setAttribute("hardwareConcurrency", String(navigator.hardwareConcurrency));
    }
}
function $a079719030764828$var$_setWebVitalAttributes(span, options) {
    if ($a079719030764828$var$_lcpEntry && options.recordLcpOnPageloadSpan) {
        if ($a079719030764828$var$_lcpEntry.element) span.setAttribute("lcp.element", (0, $25d1cfcd58d5af8d$export$5647df6b7814ac86)($a079719030764828$var$_lcpEntry.element));
        if ($a079719030764828$var$_lcpEntry.id) span.setAttribute("lcp.id", $a079719030764828$var$_lcpEntry.id);
        if ($a079719030764828$var$_lcpEntry.url) span.setAttribute("lcp.url", $a079719030764828$var$_lcpEntry.url.trim().slice(0, 200));
        if ($a079719030764828$var$_lcpEntry.loadTime != null) span.setAttribute("lcp.loadTime", $a079719030764828$var$_lcpEntry.loadTime);
        if ($a079719030764828$var$_lcpEntry.renderTime != null) span.setAttribute("lcp.renderTime", $a079719030764828$var$_lcpEntry.renderTime);
        span.setAttribute("lcp.size", $a079719030764828$var$_lcpEntry.size);
    }
    if ($a079719030764828$var$_clsEntry?.sources && options.recordClsOnPageloadSpan) $a079719030764828$var$_clsEntry.sources.forEach((source, index)=>span.setAttribute(`cls.source.${index + 1}`, (0, $25d1cfcd58d5af8d$export$5647df6b7814ac86)(source.node)));
}
function $a079719030764828$export$6ce741ceee01ab2f(entry, attributes, properties) {
    properties.forEach(([entryKey, attributeKey])=>{
        const entryVal = entry[entryKey];
        if (entryVal != null && (typeof entryVal === "number" && entryVal < $a079719030764828$var$MAX_INT_AS_BYTES || typeof entryVal === "string")) attributes[attributeKey] = entryVal;
    });
}
function $a079719030764828$var$_addTtfbRequestTimeToMeasurements(_measurements2) {
    const navEntry = (0, $173177c362404304$export$6431553786c94949)(false);
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) _measurements2["ttfb.requestTime"] = {
        value: responseStart - requestStart,
        unit: "millisecond"
    };
}











function $d5ff33466750b470$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = "fetch";
    const removeHandler = (0, $7b0ad3366f177c67$export$a4e09611e30da72e)(type, handler);
    (0, $7b0ad3366f177c67$export$e18d6c5462c01368)(type, ()=>$d5ff33466750b470$var$instrumentFetch(void 0, skipNativeFetchCheck));
    return removeHandler;
}
function $d5ff33466750b470$export$1a79663eb318fe6a(handler) {
    const type = "fetch-body-resolved";
    const removeHandler = (0, $7b0ad3366f177c67$export$a4e09611e30da72e)(type, handler);
    (0, $7b0ad3366f177c67$export$e18d6c5462c01368)(type, ()=>$d5ff33466750b470$var$instrumentFetch($d5ff33466750b470$var$streamHandler));
    return removeHandler;
}
function $d5ff33466750b470$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $133087f5c0803d70$export$c82d238e23c40b21)()) return;
    (0, $269eeb69635ed414$export$9563e054e6f787fb)((0, $736a69486c86d36c$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            const virtualError = new Error();
            const { method: method, url: url } = $d5ff33466750b470$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $bc81602376c48fa6$export$ee52dced521e3e18)() * 1e3,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $d5ff33466750b470$var$getHeadersFromFetchArgs(args)
            };
            if (!onFetchResolved) (0, $7b0ad3366f177c67$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            return originalFetch.apply((0, $736a69486c86d36c$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $7b0ad3366f177c67$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $bc81602376c48fa6$export$ee52dced521e3e18)() * 1e3,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $7b0ad3366f177c67$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $bc81602376c48fa6$export$ee52dced521e3e18)() * 1e3,
                    error: error
                });
                if ((0, $13cf2ed412f405fa$export$e6127cc7fe7395c3)(error) && error.stack === void 0) {
                    error.stack = virtualError.stack;
                    (0, $269eeb69635ed414$export$e73679ffaf56810e)(error, "framesToPop", 1);
                }
                const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
                const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? "always";
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && (0, $13cf2ed412f405fa$export$e6127cc7fe7395c3)(error) && error.name === "TypeError" && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) try {
                    const url2 = new URL(handlerData.fetchData.url);
                    const hostname = url2.host;
                    if (enhanceOption === "always") error.message = `${error.message} (${hostname})`;
                    else (0, $269eeb69635ed414$export$e73679ffaf56810e)(error, "__sentry_fetch_url_host__", hostname);
                } catch  {}
                throw error;
            });
        };
    });
}
async function $d5ff33466750b470$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{});
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{});
                }, 5e3);
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{});
    }
}
function $d5ff33466750b470$var$streamHandler(response) {
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    $d5ff33466750b470$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $7b0ad3366f177c67$export$b18c893e424d3127)("fetch-body-resolved", {
            endTimestamp: (0, $bc81602376c48fa6$export$ee52dced521e3e18)() * 1e3,
            response: response
        });
    });
}
function $d5ff33466750b470$var$hasProp(obj, prop) {
    return (0, $13cf2ed412f405fa$export$c10d0b04eaa80a43)(obj) && !!obj[prop];
}
function $d5ff33466750b470$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($d5ff33466750b470$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
function $d5ff33466750b470$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $d5ff33466750b470$var$getUrlFromResource(resource),
            method: $d5ff33466750b470$var$hasProp(options, "method") ? String(options.method).toUpperCase() : // Request object as first argument
            (0, $13cf2ed412f405fa$export$6d3d1f317d7cda57)(resource) && $d5ff33466750b470$var$hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $d5ff33466750b470$var$getUrlFromResource(arg),
        method: $d5ff33466750b470$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
function $d5ff33466750b470$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $13cf2ed412f405fa$export$6d3d1f317d7cda57)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {}
    return;
}


const $d3fcc56003188f2b$var$responseToStreamSpan = /* @__PURE__ */ new WeakMap();
const $d3fcc56003188f2b$var$responseToFallbackTimeout = /* @__PURE__ */ new WeakMap();
const $d3fcc56003188f2b$var$STREAM_RESOLVE_FALLBACK_MS = 9e4;
const $d3fcc56003188f2b$var$STREAMING_CONTENT_TYPES = [
    "text/event-stream",
    "application/x-ndjson",
    "application/stream+json"
];
const $d3fcc56003188f2b$export$b49e0d1a48dc8754 = (0, $cbb2da6c78246e45$export$2323046b9414659f)(()=>{
    return {
        name: "FetchStreamPerformance",
        setup () {
            (0, $d5ff33466750b470$export$1a79663eb318fe6a)((handlerData)=>{
                if (handlerData.response) {
                    const streamSpan = $d3fcc56003188f2b$var$responseToStreamSpan.get(handlerData.response);
                    if (streamSpan && handlerData.endTimestamp) {
                        streamSpan.end(handlerData.endTimestamp);
                        const fallbackTimeout = $d3fcc56003188f2b$var$responseToFallbackTimeout.get(handlerData.response);
                        if (fallbackTimeout) clearTimeout(fallbackTimeout);
                    }
                }
            });
            (0, $d5ff33466750b470$export$f75d3c772c923df0)((handlerData)=>{
                if (handlerData.endTimestamp && handlerData.response) {
                    const contentType = handlerData.response.headers?.get("content-type") || "";
                    if (handlerData.response.headers?.get("content-length") || !$d3fcc56003188f2b$var$STREAMING_CONTENT_TYPES.some((t)=>contentType.startsWith(t))) return;
                    const url = handlerData.fetchData?.url || "";
                    const method = handlerData.fetchData?.method || "GET";
                    const parsedUrl = (0, $0c1b93525a804899$export$2004d912a9ead694)(url);
                    const sanitizedUrl = url.startsWith("data:") ? (0, $0c1b93525a804899$export$8abd806fcaf234fa)(url) : parsedUrl ? (0, $0c1b93525a804899$export$5339fcdc8e2a427c)(parsedUrl) : url;
                    const streamSpan = (0, $c9161b67125aefc1$export$63dbba021a6b4047)({
                        name: `${method} ${sanitizedUrl}`,
                        startTime: handlerData.endTimestamp,
                        attributes: {
                            url: (0, $0c1b93525a804899$export$8abd806fcaf234fa)(url),
                            "http.method": method,
                            type: "fetch",
                            [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: "http.client.stream",
                            [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: "auto.http.browser.stream"
                        }
                    });
                    $d3fcc56003188f2b$var$responseToStreamSpan.set(handlerData.response, streamSpan);
                    const fallbackTimeout = setTimeout(()=>{
                        if (streamSpan.isRecording()) streamSpan.end();
                    }, $d3fcc56003188f2b$var$STREAM_RESOLVE_FALLBACK_MS);
                    $d3fcc56003188f2b$var$responseToFallbackTimeout.set(handlerData.response, fallbackTimeout);
                }
            });
        }
    };
});








const $6fa799a2a1351b46$var$LAST_INTERACTIONS = [];
const $6fa799a2a1351b46$var$INTERACTIONS_SPAN_MAP = /* @__PURE__ */ new Map();
const $6fa799a2a1351b46$var$ELEMENT_NAME_TIMESTAMP_MAP = /* @__PURE__ */ new Map();
const $6fa799a2a1351b46$export$619786413bcce1e1 = 60;
function $6fa799a2a1351b46$export$f17d06681a4744a3() {
    const performance = (0, $f19bf52440370854$export$f72a13c439a30cab)();
    if (performance && (0, $bc81602376c48fa6$export$baf075a948ffc0bf)()) {
        const inpCallback = $6fa799a2a1351b46$export$eeab203db0ed99a9();
        return ()=>{
            inpCallback();
        };
    }
    return ()=>void 0;
}
const $6fa799a2a1351b46$export$7cd941f925ded42f = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
function $6fa799a2a1351b46$export$eeab203db0ed99a9() {
    return (0, $375623e17d0e1d27$export$da3b76aa2022cbd7)($6fa799a2a1351b46$export$7bcb98fe01441521);
}
const $6fa799a2a1351b46$export$7bcb98fe01441521 = ({ metric: metric })=>{
    if (metric.value == void 0) return;
    const duration = (0, $f19bf52440370854$export$b4785dbd4a81b33f)(metric.value);
    if (duration > $6fa799a2a1351b46$export$619786413bcce1e1) return;
    const entry = metric.entries.find((entry2)=>entry2.duration === metric.value && $6fa799a2a1351b46$export$7cd941f925ded42f[entry2.name]);
    if (!entry) return;
    const { interactionId: interactionId } = entry;
    const interactionType = $6fa799a2a1351b46$export$7cd941f925ded42f[entry.name];
    const startTime = (0, $f19bf52440370854$export$b4785dbd4a81b33f)((0, $bc81602376c48fa6$export$baf075a948ffc0bf)() + entry.startTime);
    const activeSpan = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
    const rootSpan = activeSpan ? (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(activeSpan) : void 0;
    const cachedInteractionContext = interactionId != null ? $6fa799a2a1351b46$var$INTERACTIONS_SPAN_MAP.get(interactionId) : void 0;
    const spanToUse = cachedInteractionContext?.span || rootSpan;
    const routeName = spanToUse ? (0, $bb9b6447bf4caedb$export$92d8c23565496537)(spanToUse).description : (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = cachedInteractionContext?.elementName || (0, $25d1cfcd58d5af8d$export$5647df6b7814ac86)(entry.target);
    const attributes = {
        [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: "auto.http.browser.inp",
        [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: `ui.interaction.${interactionType}`,
        [(0, $f337c80285f06f80$export$fea48ba9f4550879)]: entry.duration
    };
    const span = (0, $f19bf52440370854$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("inp", {
            [(0, $f337c80285f06f80$export$f5f95cff026507b5)]: "millisecond",
            [(0, $f337c80285f06f80$export$69cd5c610c7bb96a)]: metric.value
        });
        span.end(startTime + duration);
    }
};
function $6fa799a2a1351b46$export$e4a670d077ebcfef(interactionId) {
    return interactionId != null ? $6fa799a2a1351b46$var$INTERACTIONS_SPAN_MAP.get(interactionId) : void 0;
}
function $6fa799a2a1351b46$export$e4e04d43e223cce2() {
    const interactionEvents = Object.keys($6fa799a2a1351b46$export$7cd941f925ded42f);
    if ((0, $b1c1ca6bb415cfb2$export$4e09c449d6c407f7)()) interactionEvents.forEach((eventType)=>{
        (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).addEventListener(eventType, captureElementFromEvent, {
            capture: true,
            passive: true
        });
    });
    function captureElementFromEvent(event) {
        const target = event.target;
        if (!target) return;
        const elementName = (0, $25d1cfcd58d5af8d$export$5647df6b7814ac86)(target);
        const timestamp = Math.round(event.timeStamp);
        $6fa799a2a1351b46$var$ELEMENT_NAME_TIMESTAMP_MAP.set(timestamp, elementName);
        if ($6fa799a2a1351b46$var$ELEMENT_NAME_TIMESTAMP_MAP.size > 50) {
            const firstKey = $6fa799a2a1351b46$var$ELEMENT_NAME_TIMESTAMP_MAP.keys().next().value;
            if (firstKey !== void 0) $6fa799a2a1351b46$var$ELEMENT_NAME_TIMESTAMP_MAP.delete(firstKey);
        }
    }
    function resolveElementNameFromEntry(entry) {
        const timestamp = Math.round(entry.startTime);
        let elementName = $6fa799a2a1351b46$var$ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp);
        if (!elementName) for(let offset = -5; offset <= 5; offset++){
            const nearbyName = $6fa799a2a1351b46$var$ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp + offset);
            if (nearbyName) {
                elementName = nearbyName;
                break;
            }
        }
        return elementName || "<unknown>";
    }
    const handleEntries = ({ entries: entries })=>{
        const activeSpan = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
        const activeRootSpan = activeSpan && (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(activeSpan);
        entries.forEach((entry)=>{
            if (!(0, $375623e17d0e1d27$export$7affb50b622d8714)(entry)) return;
            const interactionId = entry.interactionId;
            if (interactionId == null) return;
            if ($6fa799a2a1351b46$var$INTERACTIONS_SPAN_MAP.has(interactionId)) return;
            const elementName = entry.target ? (0, $25d1cfcd58d5af8d$export$5647df6b7814ac86)(entry.target) : resolveElementNameFromEntry(entry);
            if ($6fa799a2a1351b46$var$LAST_INTERACTIONS.length > 10) {
                const last = $6fa799a2a1351b46$var$LAST_INTERACTIONS.shift();
                $6fa799a2a1351b46$var$INTERACTIONS_SPAN_MAP.delete(last);
            }
            $6fa799a2a1351b46$var$LAST_INTERACTIONS.push(interactionId);
            $6fa799a2a1351b46$var$INTERACTIONS_SPAN_MAP.set(interactionId, {
                span: activeRootSpan,
                elementName: elementName
            });
        });
    };
    (0, $375623e17d0e1d27$export$69816c1a049f8db6)("event", handleEntries);
    (0, $375623e17d0e1d27$export$69816c1a049f8db6)("first-input", handleEntries);
}










var $3tmPs = parcelRequire("3tmPs");
function $8391114f3e3597d2$export$f4adb23e57c1dac6(options) {
    const { name: name, op: op, origin: origin, metricName: metricName, value: value, attributes: passedAttributes, parentSpan: parentSpan, reportEvent: reportEvent, startTime: startTime, endTime: endTime } = options;
    const routeName = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const attributes = {
        [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: origin,
        [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: op,
        [(0, $f337c80285f06f80$export$fea48ba9f4550879)]: 0,
        [`browser.web_vital.${metricName}.value`]: value,
        // oxlint-disable-next-line typescript-eslint/no-deprecated
        [(0, $3tmPs.SENTRY_TRANSACTION)]: routeName,
        [(0, $3tmPs.SENTRY_SEGMENT_NAME)]: routeName,
        // Web vital score calculation relies on the user agent
        "user_agent.original": (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).navigator?.userAgent,
        ...passedAttributes
    };
    if (parentSpan && (0, $bb9b6447bf4caedb$export$db0cad9e44f67af8)(parentSpan).attributes?.[0, $f337c80285f06f80$export$1a413bd9a88fdb09] === "pageload") attributes["sentry.pageload.span_id"] = parentSpan.spanContext().spanId;
    if (reportEvent) attributes[`browser.web_vital.${metricName}.report_event`] = reportEvent;
    const span = (0, $c9161b67125aefc1$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        parentSpan: // if we have a pageload span, we let the web vital span start as its parent. This ensures that
        // it is not started as a segment span, without having to manually set it to a "standalone" v2 span
        // that has `segment: false` but no actual parent span.
        parentSpan
    });
    if (span) span.end(endTime ?? startTime);
}
function $8391114f3e3597d2$export$73747c030e2325c0(client) {
    let lcpValue = 0;
    let lcpEntry;
    if (!(0, $f19bf52440370854$export$c7533a7b4a9f2e94)("largest-contentful-paint")) return;
    const cleanupLcpHandler = (0, $375623e17d0e1d27$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry || !(0, $14e7a12c0555fcc7$export$e59775b7d17699ba)(metric.value)) return;
        lcpValue = metric.value;
        lcpEntry = entry;
    }, true);
    (0, $f19bf52440370854$export$382ad360b45665ab)(client, (reportEvent, _, pageloadSpan)=>{
        $8391114f3e3597d2$export$1adcb85d073cd594(lcpValue, lcpEntry, pageloadSpan, reportEvent);
        cleanupLcpHandler();
    });
}
function $8391114f3e3597d2$export$1adcb85d073cd594(lcpValue, entry, pageloadSpan, reportEvent) {
    if (!(0, $14e7a12c0555fcc7$export$e59775b7d17699ba)(lcpValue)) return;
    (0, $c54a9ced88c7488b$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Sending LCP span (${lcpValue})`);
    const performanceTimeOrigin = (0, $bc81602376c48fa6$export$baf075a948ffc0bf)() || 0;
    const timeOrigin = (0, $f19bf52440370854$export$b4785dbd4a81b33f)(performanceTimeOrigin);
    const endTime = (0, $f19bf52440370854$export$b4785dbd4a81b33f)(performanceTimeOrigin + (entry?.startTime || 0));
    const name = entry ? (0, $25d1cfcd58d5af8d$export$5647df6b7814ac86)(entry.element) : "Largest contentful paint";
    const attributes = {};
    entry?.element && (attributes["browser.web_vital.lcp.element"] = (0, $25d1cfcd58d5af8d$export$5647df6b7814ac86)(entry.element));
    entry?.id && (attributes["browser.web_vital.lcp.id"] = entry.id);
    entry?.url && (attributes["browser.web_vital.lcp.url"] = entry.url);
    entry?.loadTime != null && (attributes["browser.web_vital.lcp.load_time"] = entry.loadTime);
    entry?.renderTime != null && (attributes["browser.web_vital.lcp.render_time"] = entry.renderTime);
    entry?.size != null && (attributes["browser.web_vital.lcp.size"] = entry.size);
    $8391114f3e3597d2$export$f4adb23e57c1dac6({
        name: name,
        op: "ui.webvital.lcp",
        origin: "auto.http.browser.lcp",
        metricName: "lcp",
        value: lcpValue,
        attributes: attributes,
        parentSpan: pageloadSpan,
        reportEvent: reportEvent,
        startTime: timeOrigin,
        endTime: endTime
    });
}
function $8391114f3e3597d2$export$f2ca9ed704743eb2(client) {
    let clsValue = 0;
    let clsEntry;
    if (!(0, $f19bf52440370854$export$c7533a7b4a9f2e94)("layout-shift")) return;
    const cleanupClsHandler = (0, $375623e17d0e1d27$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        clsValue = metric.value;
        clsEntry = entry;
    }, true);
    (0, $f19bf52440370854$export$382ad360b45665ab)(client, (reportEvent, _, pageloadSpan)=>{
        $8391114f3e3597d2$export$736c846d4f7aff83(clsValue, clsEntry, pageloadSpan, reportEvent);
        cleanupClsHandler();
    });
}
function $8391114f3e3597d2$export$736c846d4f7aff83(clsValue, entry, pageloadSpan, reportEvent) {
    (0, $c54a9ced88c7488b$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Sending CLS span (${clsValue})`);
    const startTime = entry ? (0, $f19bf52440370854$export$b4785dbd4a81b33f)(((0, $bc81602376c48fa6$export$baf075a948ffc0bf)() || 0) + entry.startTime) : (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
    const name = entry ? (0, $25d1cfcd58d5af8d$export$5647df6b7814ac86)(entry.sources[0]?.node) : "Layout shift";
    const attributes = {};
    if (entry?.sources) entry.sources.forEach((source, index)=>{
        attributes[`browser.web_vital.cls.source.${index + 1}`] = (0, $25d1cfcd58d5af8d$export$5647df6b7814ac86)(source.node);
    });
    $8391114f3e3597d2$export$f4adb23e57c1dac6({
        name: name,
        op: "ui.webvital.cls",
        origin: "auto.http.browser.cls",
        metricName: "cls",
        value: clsValue,
        attributes: attributes,
        parentSpan: pageloadSpan,
        reportEvent: reportEvent,
        startTime: startTime
    });
}
function $8391114f3e3597d2$export$4a8cbc644515d57b() {
    const performance = (0, $f19bf52440370854$export$f72a13c439a30cab)();
    if (!performance || !(0, $bc81602376c48fa6$export$baf075a948ffc0bf)()) return;
    const onInp = ({ metric: metric })=>{
        if (metric.value == null) return;
        const duration = (0, $f19bf52440370854$export$b4785dbd4a81b33f)(metric.value);
        if (duration > (0, $6fa799a2a1351b46$export$619786413bcce1e1)) return;
        const entry = metric.entries.find((e)=>e.duration === metric.value && (0, $6fa799a2a1351b46$export$7cd941f925ded42f)[e.name]);
        if (!entry) return;
        $8391114f3e3597d2$export$bd315e549441b68a(metric.value, entry);
    };
    (0, $375623e17d0e1d27$export$da3b76aa2022cbd7)(onInp);
}
function $8391114f3e3597d2$export$bd315e549441b68a(inpValue, entry) {
    (0, $c54a9ced88c7488b$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Sending INP span (${inpValue})`);
    const startTime = (0, $f19bf52440370854$export$b4785dbd4a81b33f)((0, $bc81602376c48fa6$export$baf075a948ffc0bf)() + entry.startTime);
    const duration = (0, $f19bf52440370854$export$b4785dbd4a81b33f)(inpValue);
    const interactionType = (0, $6fa799a2a1351b46$export$7cd941f925ded42f)[entry.name];
    const cachedContext = (0, $6fa799a2a1351b46$export$e4a670d077ebcfef)(entry.interactionId);
    const activeSpan = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
    const rootSpan = activeSpan ? (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(activeSpan) : void 0;
    const spanToUse = cachedContext?.span || rootSpan;
    const routeName = spanToUse ? (0, $bb9b6447bf4caedb$export$db0cad9e44f67af8)(spanToUse).name : (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = cachedContext?.elementName || (0, $25d1cfcd58d5af8d$export$5647df6b7814ac86)(entry.target);
    $8391114f3e3597d2$export$f4adb23e57c1dac6({
        name: name,
        op: `ui.interaction.${interactionType}`,
        origin: "auto.http.browser.inp",
        metricName: "inp",
        value: inpValue,
        attributes: {
            [(0, $f337c80285f06f80$export$fea48ba9f4550879)]: entry.duration,
            // oxlint-disable-next-line typescript-eslint/no-deprecated
            [(0, $3tmPs.SENTRY_TRANSACTION)]: routeName,
            [(0, $3tmPs.SENTRY_SEGMENT_NAME)]: routeName
        },
        startTime: startTime,
        endTime: startTime + duration,
        parentSpan: spanToUse
    });
}


const $9477c2bd0ffb81e8$export$8748555bacc7091c = "WebVitals";
const $9477c2bd0ffb81e8$export$1ab4995602e8adaa = (0, $b244ff70a28cf637$exports.defineIntegration)((options = {})=>{
    const ignored = new Set(options.ignore ?? []);
    return {
        name: $9477c2bd0ffb81e8$export$8748555bacc7091c,
        setup (client) {
            const spanStreamingEnabled = (0, $b244ff70a28cf637$exports.hasSpanStreamingEnabled)(client);
            const { enableStandaloneClsSpans: enableStandaloneClsSpans, enableStandaloneLcpSpans: enableStandaloneLcpSpans } = options._experiments ?? {};
            const recordClsStandaloneSpans = spanStreamingEnabled || ignored.has("cls") ? void 0 : enableStandaloneClsSpans || false;
            const recordLcpStandaloneSpans = spanStreamingEnabled || ignored.has("lcp") ? void 0 : enableStandaloneLcpSpans || false;
            const finalizeWebVitals = (0, $a079719030764828$export$7c69f0412d101b88)({
                recordClsStandaloneSpans: recordClsStandaloneSpans,
                recordLcpStandaloneSpans: recordLcpStandaloneSpans,
                client: client
            });
            const pageloadSpans = /* @__PURE__ */ new WeakSet();
            client.on("afterStartPageLoadSpan", (span)=>{
                pageloadSpans.add(span);
            });
            client.on("spanEnd", (span)=>{
                if (!pageloadSpans.delete(span)) return;
                finalizeWebVitals();
                (0, $a079719030764828$export$d14e394b690acc17)(span, {
                    // CLS/LCP are recorded as pageload span measurements only when they're neither
                    // tracked as standalone spans nor handled by span streaming (and not ignored).
                    recordClsOnPageloadSpan: recordClsStandaloneSpans === false,
                    recordLcpOnPageloadSpan: recordLcpStandaloneSpans === false,
                    spanStreamingEnabled: spanStreamingEnabled
                });
            });
            if (spanStreamingEnabled) {
                if (!ignored.has("lcp")) (0, $8391114f3e3597d2$export$73747c030e2325c0)(client);
                if (!ignored.has("cls")) (0, $8391114f3e3597d2$export$f2ca9ed704743eb2)(client);
                if (!ignored.has("inp")) (0, $8391114f3e3597d2$export$4a8cbc644515d57b)();
            } else if (!ignored.has("inp")) (0, $6fa799a2a1351b46$export$f17d06681a4744a3)();
        },
        afterAllSetup () {
            if (!ignored.has("inp")) (0, $6fa799a2a1351b46$export$e4e04d43e223cce2)();
        }
    };
});





function $e2a93f4a13ed6e48$export$6f18f55521af71a1() {
    if ((0, $e62dec891f31852b$export$56d8a8a25bd48b81).document) (0, $e62dec891f31852b$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        const activeSpan = (0, $b244ff70a28cf637$exports.getActiveSpan)();
        if (!activeSpan) return;
        const rootSpan = (0, $b244ff70a28cf637$exports.getRootSpan)(activeSpan);
        if ((0, $e62dec891f31852b$export$56d8a8a25bd48b81).document.hidden && rootSpan) {
            const cancelledStatus = "cancelled";
            const { op: op, status: status } = (0, $b244ff70a28cf637$exports.spanToJSON)(rootSpan);
            if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $b244ff70a28cf637$exports.debug).log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
            if (!status) rootSpan.setStatus({
                code: (0, $b244ff70a28cf637$exports.SPAN_STATUS_ERROR),
                message: cancelledStatus
            });
            rootSpan.setAttribute("sentry.cancellation_reason", "document.hidden");
            rootSpan.end();
        }
    });
    else (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}














const $708fd5b70f5584b2$export$c8d616af96ac729f = 3600;
const $708fd5b70f5584b2$export$16b6aa13b3c0f075 = "sentry_previous_trace";
const $708fd5b70f5584b2$export$237518aee8726f02 = "sentry.previous_trace";
function $708fd5b70f5584b2$export$830d9ee659c6e4c4(client, { linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling }) {
    const useSessionStorage = linkPreviousTrace === "session-storage";
    let inMemoryPreviousTraceInfo = useSessionStorage ? $708fd5b70f5584b2$export$ef546bba8a402d99() : void 0;
    client.on("spanStart", (span)=>{
        if ((0, $b244ff70a28cf637$exports.getRootSpan)(span) !== span) return;
        const oldPropagationContext = (0, $b244ff70a28cf637$exports.getCurrentScope)().getPropagationContext();
        inMemoryPreviousTraceInfo = $708fd5b70f5584b2$export$ae31cf84cbfc630e(inMemoryPreviousTraceInfo, span, oldPropagationContext);
        if (useSessionStorage) $708fd5b70f5584b2$export$e3dcc2666496dd96(inMemoryPreviousTraceInfo);
    });
    let isFirstTraceOnPageload = true;
    if (consistentTraceSampling) client.on("beforeSampling", (mutableSamplingContextData)=>{
        if (!inMemoryPreviousTraceInfo) return;
        const scope = (0, $b244ff70a28cf637$exports.getCurrentScope)();
        const currentPropagationContext = scope.getPropagationContext();
        if (isFirstTraceOnPageload && currentPropagationContext.parentSpanId) {
            isFirstTraceOnPageload = false;
            return;
        }
        scope.setPropagationContext({
            ...currentPropagationContext,
            dsc: {
                ...currentPropagationContext.dsc,
                sample_rate: String(inMemoryPreviousTraceInfo.sampleRate),
                sampled: String($708fd5b70f5584b2$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext))
            },
            sampleRand: inMemoryPreviousTraceInfo.sampleRand
        });
        mutableSamplingContextData.parentSampled = $708fd5b70f5584b2$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext);
        mutableSamplingContextData.parentSampleRate = inMemoryPreviousTraceInfo.sampleRate;
        mutableSamplingContextData.spanAttributes = {
            ...mutableSamplingContextData.spanAttributes,
            [(0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE)]: inMemoryPreviousTraceInfo.sampleRate
        };
    });
}
function $708fd5b70f5584b2$export$ae31cf84cbfc630e(previousTraceInfo, span, oldPropagationContext) {
    const spanJson = (0, $b244ff70a28cf637$exports.spanToJSON)(span);
    function getSampleRate() {
        try {
            const oldSampleRate = Number(spanJson.data?.[0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? oldPropagationContext.dsc?.sample_rate);
            return Number.isNaN(oldSampleRate) ? 0 : oldSampleRate;
        } catch  {
            return 0;
        }
    }
    const updatedPreviousTraceInfo = {
        spanContext: span.spanContext(),
        startTimestamp: spanJson.start_timestamp,
        sampleRate: getSampleRate(),
        sampleRand: oldPropagationContext.sampleRand
    };
    if (!previousTraceInfo) return updatedPreviousTraceInfo;
    const previousTraceSpanCtx = previousTraceInfo.spanContext;
    if (previousTraceSpanCtx.traceId === spanJson.trace_id) return previousTraceInfo;
    if (Date.now() / 1e3 - previousTraceInfo.startTimestamp <= $708fd5b70f5584b2$export$c8d616af96ac729f) {
        if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $b244ff70a28cf637$exports.debug).log(`Adding previous_trace \`${JSON.stringify(previousTraceSpanCtx)}\` link to span \`${JSON.stringify({
            op: spanJson.op,
            ...span.spanContext()
        })}\``);
        span.addLink({
            context: previousTraceSpanCtx,
            attributes: {
                [(0, $b244ff70a28cf637$exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE)]: "previous_trace"
            }
        });
        span.setAttribute($708fd5b70f5584b2$export$237518aee8726f02, `${previousTraceSpanCtx.traceId}-${previousTraceSpanCtx.spanId}-${$708fd5b70f5584b2$export$f394c5f143a7b597(previousTraceSpanCtx) ? 1 : 0}`);
    }
    return updatedPreviousTraceInfo;
}
function $708fd5b70f5584b2$export$e3dcc2666496dd96(previousTraceInfo) {
    try {
        (0, $e62dec891f31852b$export$56d8a8a25bd48b81).sessionStorage.setItem($708fd5b70f5584b2$export$16b6aa13b3c0f075, JSON.stringify(previousTraceInfo));
    } catch (e) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn("Could not store previous trace in sessionStorage", e);
    }
}
function $708fd5b70f5584b2$export$ef546bba8a402d99() {
    try {
        const previousTraceInfo = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).sessionStorage?.getItem($708fd5b70f5584b2$export$16b6aa13b3c0f075);
        return JSON.parse(previousTraceInfo);
    } catch  {
        return void 0;
    }
}
function $708fd5b70f5584b2$export$f394c5f143a7b597(ctx) {
    return ctx.traceFlags === 1;
}




var $3tmPs = parcelRequire("3tmPs");
const $7b5f2a588355dc11$export$bbd2089f30bd3708 = "BrowserTracing";
const $7b5f2a588355dc11$var$BOT_USER_AGENT_RE = /Googlebot|Google-InspectionTool|Storebot-Google|Bingbot|Slurp|DuckDuckBot|Baiduspider|YandexBot|Facebot|facebookexternalhit|LinkedInBot|Twitterbot|Applebot/i;
function $7b5f2a588355dc11$export$e189d11d152c4191() {
    const nav = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).navigator;
    if (!nav?.userAgent) return false;
    return $7b5f2a588355dc11$var$BOT_USER_AGENT_RE.test(nav.userAgent);
}
const $7b5f2a588355dc11$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $b244ff70a28cf637$exports.TRACING_DEFAULTS),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableLongAnimationFrame: true,
    enableInp: true,
    ignoreResourceSpans: [],
    ignorePerformanceApiSpans: [],
    detectRedirects: true,
    linkPreviousTrace: "in-memory",
    consistentTraceSampling: false,
    enableReportPageLoaded: false,
    _experiments: {},
    ...(0, $b3e0e430d6ae504d$export$cc17fb3c0bc95cd7)
};
const $7b5f2a588355dc11$export$b4109253475213e9 = (options = {})=>{
    if ("enableElementTiming" in options) (0, $b244ff70a28cf637$exports.consoleSandbox)(()=>{
        console.warn("[Sentry] `enableElementTiming` is deprecated and no longer has any effect. Use the standalone `elementTimingIntegration` instead.");
    });
    const latestRoute = {
        name: void 0,
        source: void 0
    };
    const optionalWindowDocument = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).document;
    const { enableInp: enableInp, enableLongTask: enableLongTask, enableLongAnimationFrame: enableLongAnimationFrame, _experiments: { enableInteractions: enableInteractions, enableStandaloneClsSpans: enableStandaloneClsSpans, enableStandaloneLcpSpans: enableStandaloneLcpSpans }, beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, childSpanTimeout: childSpanTimeout, markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: // eslint-disable-next-line typescript/no-deprecated
    trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, ignoreResourceSpans: ignoreResourceSpans, ignorePerformanceApiSpans: ignorePerformanceApiSpans, instrumentPageLoad: instrumentPageLoad, instrumentNavigation: instrumentNavigation, detectRedirects: detectRedirects, linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling, enableReportPageLoaded: enableReportPageLoaded, onRequestSpanStart: onRequestSpanStart, onRequestSpanEnd: onRequestSpanEnd } = {
        ...$7b5f2a588355dc11$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ...options
    };
    const _isBot = $7b5f2a588355dc11$export$e189d11d152c4191();
    let lastInteractionTimestamp;
    let _pageloadSpan;
    function _createRouteSpan(client, startSpanOptions, makeActive = true, url) {
        const isPageloadSpan = startSpanOptions.op === "pageload";
        const initialSpanName = startSpanOptions.name;
        const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        const urlObject = (0, $b244ff70a28cf637$exports.parseStringToURLObject)(url || (0, $b244ff70a28cf637$exports.getLocationHref)());
        const attributes = {
            ...urlObject?.pathname && {
                [(0, $3tmPs.URL_PATH)]: urlObject.pathname
            },
            ...urlObject && !(0, $b244ff70a28cf637$exports.isURLObjectRelative)(urlObject) && {
                [(0, $3tmPs.URL_FULL)]: urlObject.href
            },
            ...finalStartSpanOptions.attributes
        };
        if (initialSpanName !== finalStartSpanOptions.name) attributes[0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "custom";
        finalStartSpanOptions.attributes = attributes;
        if (!makeActive) {
            const now = (0, $b244ff70a28cf637$exports.dateTimestampInSeconds)();
            (0, $b244ff70a28cf637$exports.startInactiveSpan)({
                ...finalStartSpanOptions,
                startTime: now
            }).end(now);
            return;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        const idleSpan = (0, $b244ff70a28cf637$exports.startIdleSpan)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadSpan,
            beforeSpanEnd: (span)=>{
                (0, $a079719030764828$export$5f8fa6b3467a7443)(span, {
                    ignoreResourceSpans: ignoreResourceSpans,
                    ignorePerformanceApiSpans: ignorePerformanceApiSpans,
                    spanStreamingEnabled: (0, $b244ff70a28cf637$exports.hasSpanStreamingEnabled)(client)
                });
                $7b5f2a588355dc11$var$setActiveIdleSpan(client, void 0);
                const scope = (0, $b244ff70a28cf637$exports.getCurrentScope)();
                const oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext({
                    ...oldPropagationContext,
                    traceId: idleSpan.spanContext().traceId,
                    sampled: (0, $b244ff70a28cf637$exports.spanIsSampled)(idleSpan),
                    dsc: (0, $b244ff70a28cf637$exports.getDynamicSamplingContextFromSpan)(span)
                });
                if (isPageloadSpan) _pageloadSpan = void 0;
            },
            trimIdleSpanEndTimestamp: !enableReportPageLoaded
        });
        if (isPageloadSpan && enableReportPageLoaded) _pageloadSpan = idleSpan;
        $7b5f2a588355dc11$var$setActiveIdleSpan(client, idleSpan);
        function emitFinish() {
            if (optionalWindowDocument && [
                "interactive",
                "complete"
            ].includes(optionalWindowDocument.readyState)) {
                client.emit("idleSpanEnableAutoFinish", idleSpan);
                optionalWindowDocument.removeEventListener("readystatechange", emitFinish);
            }
        }
        if (isPageloadSpan && !enableReportPageLoaded && optionalWindowDocument) {
            optionalWindowDocument.addEventListener("readystatechange", emitFinish);
            emitFinish();
        }
    }
    return {
        name: $7b5f2a588355dc11$export$bbd2089f30bd3708,
        setup (client) {
            if (_isBot) {
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("[Tracing] Skipping browserTracingIntegration setup for bot user agent.");
                return;
            }
            (0, $b244ff70a28cf637$exports.registerSpanErrorInstrumentation)();
            if (enableLongAnimationFrame && (0, $b244ff70a28cf637$exports.GLOBAL_OBJ).PerformanceObserver && PerformanceObserver.supportedEntryTypes?.includes("long-animation-frame")) (0, $a079719030764828$export$5b823ab2ccbc801d)();
            else if (enableLongTask) (0, $a079719030764828$export$f396d19077034ad2)();
            if (enableInteractions) (0, $a079719030764828$export$e27543e0976315e4)();
            if (detectRedirects && optionalWindowDocument) {
                const interactionHandler = ()=>{
                    lastInteractionTimestamp = (0, $b244ff70a28cf637$exports.timestampInSeconds)();
                };
                addEventListener("click", interactionHandler, {
                    capture: true
                });
                addEventListener("keydown", interactionHandler, {
                    capture: true,
                    passive: true
                });
            }
            function maybeEndActiveSpan() {
                const activeSpan = $7b5f2a588355dc11$var$getActiveIdleSpan(client);
                if (activeSpan && !(0, $b244ff70a28cf637$exports.spanToJSON)(activeSpan).timestamp) {
                    (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log(`[Tracing] Finishing current active span with op: ${(0, $b244ff70a28cf637$exports.spanToJSON)(activeSpan).op}`);
                    activeSpan.setAttribute((0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), "cancelled");
                    activeSpan.end();
                }
            }
            client.on("startNavigationSpan", (startSpanOptions, navigationOptions)=>{
                if ((0, $b244ff70a28cf637$exports.getClient)() !== client) return;
                if (navigationOptions?.isRedirect) {
                    (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn("[Tracing] Detected redirect, navigation span will not be the root span, but a child span.");
                    _createRouteSpan(client, {
                        op: "navigation.redirect",
                        ...startSpanOptions
                    }, false, navigationOptions.url);
                    return;
                }
                lastInteractionTimestamp = void 0;
                maybeEndActiveSpan();
                const scope = (0, $b244ff70a28cf637$exports.getCurrentScope)();
                scope.setPropagationContext({
                    traceId: (0, $b244ff70a28cf637$exports.generateTraceId)(),
                    sampleRand: Math.random(),
                    propagationSpanId: (0, $b244ff70a28cf637$exports.hasSpansEnabled)() ? void 0 : (0, $b244ff70a28cf637$exports.generateSpanId)()
                });
                scope.setSDKProcessingMetadata({
                    normalizedRequest: void 0
                });
                _createRouteSpan(client, {
                    op: "navigation",
                    ...startSpanOptions,
                    // Navigation starts a new trace and is NOT parented under any active interaction (e.g. ui.action.click)
                    parentSpan: null,
                    forceTransaction: true
                }, true, navigationOptions?.url);
            });
            client.on("startPageLoadSpan", (startSpanOptions, traceOptions = {})=>{
                if ((0, $b244ff70a28cf637$exports.getClient)() !== client) return;
                maybeEndActiveSpan();
                const sentryTrace = traceOptions.sentryTrace || $7b5f2a588355dc11$export$f147b32b03c9cf11("sentry-trace") || $7b5f2a588355dc11$export$5bb9693b37f7c2ae("sentry-trace");
                const baggage = traceOptions.baggage || $7b5f2a588355dc11$export$f147b32b03c9cf11("baggage") || $7b5f2a588355dc11$export$5bb9693b37f7c2ae("baggage");
                const propagationContext = (0, $b244ff70a28cf637$exports.propagationContextFromHeaders)(sentryTrace, baggage);
                const scope = (0, $b244ff70a28cf637$exports.getCurrentScope)();
                scope.setPropagationContext(propagationContext);
                if (!(0, $b244ff70a28cf637$exports.hasSpansEnabled)()) scope.getPropagationContext().propagationSpanId = (0, $b244ff70a28cf637$exports.generateSpanId)();
                scope.setSDKProcessingMetadata({
                    normalizedRequest: (0, $e62dec891f31852b$export$a3c4a8453e8936f0)()
                });
                _createRouteSpan(client, {
                    op: "pageload",
                    ...startSpanOptions
                });
            });
            client.on("endPageloadSpan", ()=>{
                if (enableReportPageLoaded && _pageloadSpan) {
                    _pageloadSpan.setAttribute((0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), "reportPageLoaded");
                    _pageloadSpan.end();
                }
            });
        },
        afterAllSetup (client) {
            if (_isBot) return;
            if (client.addIntegration && !client.getIntegrationByName?.((0, $9477c2bd0ffb81e8$export$8748555bacc7091c))) client.addIntegration((0, $9477c2bd0ffb81e8$export$1ab4995602e8adaa)({
                ignore: enableInp ? [] : [
                    "inp"
                ],
                _experiments: {
                    enableStandaloneClsSpans: enableStandaloneClsSpans,
                    enableStandaloneLcpSpans: enableStandaloneLcpSpans
                }
            }));
            let startingUrl = (0, $b244ff70a28cf637$exports.getLocationHref)();
            if (linkPreviousTrace !== "off") (0, $708fd5b70f5584b2$export$830d9ee659c6e4c4)(client, {
                linkPreviousTrace: linkPreviousTrace,
                consistentTraceSampling: consistentTraceSampling
            });
            if ((0, $e62dec891f31852b$export$56d8a8a25bd48b81).location) {
                if (instrumentPageLoad) {
                    const origin = (0, $b244ff70a28cf637$exports.browserPerformanceTimeOrigin)();
                    $7b5f2a588355dc11$export$aa44a07f82af519f(client, {
                        name: (0, $e62dec891f31852b$export$56d8a8a25bd48b81).location.pathname,
                        // pageload should always start at timeOrigin (and needs to be in s, not ms)
                        startTime: origin ? origin / 1e3 : void 0,
                        attributes: {
                            [(0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url",
                            [(0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.pageload.browser"
                        }
                    });
                }
                if (instrumentNavigation) (0, $44e96bc00aeade7b$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                    if (from === void 0 && startingUrl?.indexOf(to) !== -1) {
                        startingUrl = void 0;
                        return;
                    }
                    startingUrl = void 0;
                    const parsed = (0, $b244ff70a28cf637$exports.parseStringToURLObject)(to);
                    const activeSpan = $7b5f2a588355dc11$var$getActiveIdleSpan(client);
                    const navigationIsRedirect = activeSpan && detectRedirects && $7b5f2a588355dc11$var$isRedirect(activeSpan, lastInteractionTimestamp);
                    $7b5f2a588355dc11$export$7d159749bd9969ad(client, {
                        name: parsed?.pathname || (0, $e62dec891f31852b$export$56d8a8a25bd48b81).location.pathname,
                        attributes: {
                            [(0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url",
                            [(0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.navigation.browser"
                        }
                    }, {
                        url: to,
                        isRedirect: navigationIsRedirect
                    });
                });
            }
            if (markBackgroundSpan) (0, $e2a93f4a13ed6e48$export$6f18f55521af71a1)();
            if (enableInteractions) $7b5f2a588355dc11$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            (0, $b3e0e430d6ae504d$export$864489cb3478db3e)(client, {
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings,
                onRequestSpanStart: onRequestSpanStart,
                onRequestSpanEnd: onRequestSpanEnd
            });
            if (trackFetchStreamPerformance) client.addIntegration((0, $d3fcc56003188f2b$export$b49e0d1a48dc8754)());
        }
    };
};
function $7b5f2a588355dc11$export$aa44a07f82af519f(client, spanOptions, traceOptions) {
    client.emit("startPageLoadSpan", spanOptions, traceOptions);
    (0, $b244ff70a28cf637$exports.getCurrentScope)().setTransactionName(spanOptions.name);
    const pageloadSpan = $7b5f2a588355dc11$var$getActiveIdleSpan(client);
    if (pageloadSpan) client.emit("afterStartPageLoadSpan", pageloadSpan);
    return pageloadSpan;
}
function $7b5f2a588355dc11$export$7d159749bd9969ad(client, spanOptions, options) {
    const { url: url, isRedirect: isRedirect2 } = options || {};
    client.emit("beforeStartNavigationSpan", spanOptions, {
        isRedirect: isRedirect2,
        url: url
    });
    client.emit("startNavigationSpan", spanOptions, {
        isRedirect: isRedirect2,
        url: url
    });
    const scope = (0, $b244ff70a28cf637$exports.getCurrentScope)();
    scope.setTransactionName(spanOptions.name);
    if (url && !isRedirect2) scope.setSDKProcessingMetadata({
        normalizedRequest: {
            ...(0, $e62dec891f31852b$export$a3c4a8453e8936f0)(),
            url: url
        }
    });
    return $7b5f2a588355dc11$var$getActiveIdleSpan(client);
}
function $7b5f2a588355dc11$export$f147b32b03c9cf11(metaName) {
    const optionalWindowDocument = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).document;
    const metaTag = optionalWindowDocument?.querySelector(`meta[name=${metaName}]`);
    return metaTag?.getAttribute("content") || void 0;
}
function $7b5f2a588355dc11$export$5bb9693b37f7c2ae(name) {
    const navigation = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).performance?.getEntriesByType?.("navigation")[0];
    const entry = navigation?.serverTiming?.find((entry2)=>entry2.name === name);
    return entry?.description;
}
function $7b5f2a588355dc11$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    const optionalWindowDocument = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).document;
    let inflightInteractionSpan;
    const registerInteractionTransaction = ()=>{
        const op = "ui.action.click";
        const activeIdleSpan = $7b5f2a588355dc11$var$getActiveIdleSpan(client);
        if (activeIdleSpan) {
            const currentRootSpanOp = (0, $b244ff70a28cf637$exports.spanToJSON)(activeIdleSpan).op;
            if ([
                "navigation",
                "pageload"
            ].includes(currentRootSpanOp)) {
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
                return void 0;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), "interactionInterrupted");
            inflightInteractionSpan.end();
            inflightInteractionSpan = void 0;
        }
        if (!latestRoute.name) {
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return void 0;
        }
        inflightInteractionSpan = (0, $b244ff70a28cf637$exports.startIdleSpan)({
            name: latestRoute.name,
            op: op,
            attributes: {
                [(0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: latestRoute.source || "url"
            }
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if (optionalWindowDocument) addEventListener("click", registerInteractionTransaction, {
        capture: true
    });
}
const $7b5f2a588355dc11$var$ACTIVE_IDLE_SPAN_PROPERTY = "_sentry_idleSpan";
function $7b5f2a588355dc11$var$getActiveIdleSpan(client) {
    return client[$7b5f2a588355dc11$var$ACTIVE_IDLE_SPAN_PROPERTY];
}
function $7b5f2a588355dc11$var$setActiveIdleSpan(client, span) {
    (0, $b244ff70a28cf637$exports.addNonEnumerableProperty)(client, $7b5f2a588355dc11$var$ACTIVE_IDLE_SPAN_PROPERTY, span);
}
const $7b5f2a588355dc11$var$REDIRECT_THRESHOLD = 1.5;
function $7b5f2a588355dc11$var$isRedirect(activeSpan, lastInteractionTimestamp) {
    const spanData = (0, $b244ff70a28cf637$exports.spanToJSON)(activeSpan);
    const now = (0, $b244ff70a28cf637$exports.dateTimestampInSeconds)();
    const startTimestamp = spanData.start_timestamp;
    if (now - startTimestamp > $7b5f2a588355dc11$var$REDIRECT_THRESHOLD) return false;
    if (lastInteractionTimestamp && now - lastInteractionTimestamp <= $7b5f2a588355dc11$var$REDIRECT_THRESHOLD) return false;
    return true;
}


var $240914cce3cb7287$exports = {};
$parcel$export($240914cce3cb7287$exports, "count", () => $240914cce3cb7287$export$85b9a36db797e02b);
$parcel$export($240914cce3cb7287$exports, "gauge", () => $240914cce3cb7287$export$b0660673397c6c28);
$parcel$export($240914cce3cb7287$exports, "distribution", () => $240914cce3cb7287$export$fd8e353f0040520a);








const $443993e122065548$var$SEQUENCE_ATTR_KEY = "sentry.timestamp.sequence";
let $443993e122065548$var$_sequenceNumber = 0;
let $443993e122065548$var$_previousTimestampMs;
function $443993e122065548$export$63ada7b125d23ef9(timestampInSeconds) {
    const nowMs = Math.floor(timestampInSeconds * 1e3);
    if ($443993e122065548$var$_previousTimestampMs !== void 0 && nowMs !== $443993e122065548$var$_previousTimestampMs) $443993e122065548$var$_sequenceNumber = 0;
    const value = $443993e122065548$var$_sequenceNumber;
    $443993e122065548$var$_sequenceNumber++;
    $443993e122065548$var$_previousTimestampMs = nowMs;
    return {
        key: $443993e122065548$var$SEQUENCE_ATTR_KEY,
        value: {
            value: value,
            type: "integer"
        }
    };
}





function $79fd34a78625a040$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        void 0,
        void 0
    ];
    return (0, $7d48e1ed9f699a01$export$ec58d9285c204497)(scope, ()=>{
        const span = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
        const traceContext = span ? (0, $bb9b6447bf4caedb$export$46c6fbd1d265ebf0)(span) : (0, $7d48e1ed9f699a01$export$1e83db7ee4876dc4)(scope);
        const dynamicSamplingContext = span ? (0, $09fae5ef8120e803$export$a117f995597e25df)(span) : (0, $09fae5ef8120e803$export$89ef1736f08c6b2b)(client, scope);
        return [
            dynamicSamplingContext,
            traceContext
        ];
    });
}





function $1921770c7aa60e48$export$58e45eb52ad1077d(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "trace_metric",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.trace-metric+json"
        },
        {
            version: 2,
            ...(0, $b1c1ca6bb415cfb2$export$4e09c449d6c407f7)() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
function $1921770c7aa60e48$export$f23eb96e33154901(metrics, metadata, tunnel, dsn, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $1e1399eeae328b26$export$44d472fbb931a776)(dsn);
    return (0, $bb063ad93c8b79c7$export$f93f7f385160c44e)(headers, [
        $1921770c7aa60e48$export$58e45eb52ad1077d(metrics, inferUserData)
    ]);
}


const $8ed8fd97ec1f999f$var$MAX_METRIC_BUFFER_SIZE = 1e3;
function $8ed8fd97ec1f999f$var$setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
function $8ed8fd97ec1f999f$export$84661fd26e6cac96(client, serializedMetric) {
    const bufferMap = $8ed8fd97ec1f999f$var$_getBufferMap();
    const metricBuffer = $8ed8fd97ec1f999f$export$49385134251b08ff(client);
    if (metricBuffer === void 0) bufferMap.set(client, [
        serializedMetric
    ]);
    else if (metricBuffer.length >= $8ed8fd97ec1f999f$var$MAX_METRIC_BUFFER_SIZE) {
        $8ed8fd97ec1f999f$export$91c9ef254b7d0f67(client, metricBuffer);
        bufferMap.set(client, [
            serializedMetric
        ]);
    } else bufferMap.set(client, [
        ...metricBuffer,
        serializedMetric
    ]);
}
function $8ed8fd97ec1f999f$var$_enrichMetricAttributes(beforeMetric, client, user) {
    const { release: release, environment: environment } = client.getOptions();
    const processedMetricAttributes = {
        ...beforeMetric.attributes
    };
    $8ed8fd97ec1f999f$var$setMetricAttribute(processedMetricAttributes, "user.id", user.id, false);
    $8ed8fd97ec1f999f$var$setMetricAttribute(processedMetricAttributes, "user.email", user.email, false);
    $8ed8fd97ec1f999f$var$setMetricAttribute(processedMetricAttributes, "user.name", user.username, false);
    $8ed8fd97ec1f999f$var$setMetricAttribute(processedMetricAttributes, "sentry.release", release);
    $8ed8fd97ec1f999f$var$setMetricAttribute(processedMetricAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $8ed8fd97ec1f999f$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.name", name);
    $8ed8fd97ec1f999f$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $8ed8fd97ec1f999f$var$setMetricAttribute(processedMetricAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $8ed8fd97ec1f999f$var$setMetricAttribute(processedMetricAttributes, "sentry._internal.replay_is_buffering", true);
    return {
        ...beforeMetric,
        attributes: processedMetricAttributes
    };
}
function $8ed8fd97ec1f999f$var$_buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
    const [, traceContext] = (0, $79fd34a78625a040$export$fb7d833b3fdedf5f)(client, currentScope);
    const span = (0, $dab1970d0c142a42$export$91f063ebb8eff307)(currentScope);
    const traceId = span ? span.spanContext().traceId : traceContext?.trace_id;
    const spanId = span ? span.spanContext().spanId : void 0;
    const timestamp = (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
    const sequenceAttr = (0, $443993e122065548$export$63ada7b125d23ef9)(timestamp);
    return {
        timestamp: timestamp,
        trace_id: traceId ?? "",
        span_id: spanId,
        name: metric.name,
        type: metric.type,
        unit: metric.unit,
        value: metric.value,
        attributes: {
            ...(0, $930f69313cc0b0d6$export$4954cae66e755861)(scopeAttributes),
            ...(0, $930f69313cc0b0d6$export$4954cae66e755861)(metric.attributes, "skip-undefined"),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
}
function $8ed8fd97ec1f999f$export$288d896e6652e0c4(beforeMetric, options) {
    const currentScope = options?.scope ?? (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
    const captureSerializedMetric = options?.captureSerializedMetric ?? $8ed8fd97ec1f999f$export$84661fd26e6cac96;
    const client = currentScope?.getClient() ?? (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn("No client available to capture metric.");
        return;
    }
    const { _experiments: _experiments, enableMetrics: enableMetrics, beforeSendMetric: beforeSendMetric } = client.getOptions();
    const metricsEnabled = enableMetrics ?? _experiments?.enableMetrics ?? true;
    if (!metricsEnabled) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn("metrics option not enabled, metric will not be captured.");
        return;
    }
    const { user: user, attributes: scopeAttributes } = (0, $9a2c488a2b943a4e$export$cc422922fcbb91c6)((0, $7d48e1ed9f699a01$export$68f3af03034c9e90)(), currentScope);
    const enrichedMetric = $8ed8fd97ec1f999f$var$_enrichMetricAttributes(beforeMetric, client, user);
    client.emit("processMetric", enrichedMetric);
    const beforeSendCallback = beforeSendMetric || _experiments?.beforeSendMetric;
    const processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
    if (!processedMetric) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log("`beforeSendMetric` returned `null`, will not send metric.");
        return;
    }
    const serializedMetric = $8ed8fd97ec1f999f$var$_buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
    (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log("[Metric]", serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit("afterCaptureMetric", processedMetric);
}
function $8ed8fd97ec1f999f$export$91c9ef254b7d0f67(client, maybeMetricBuffer) {
    const metricBuffer = maybeMetricBuffer ?? $8ed8fd97ec1f999f$export$49385134251b08ff(client) ?? [];
    if (metricBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $1921770c7aa60e48$export$f23eb96e33154901)(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $8ed8fd97ec1f999f$var$_getBufferMap().set(client, []);
    client.emit("flushMetrics");
    client.sendEnvelope(envelope);
}
function $8ed8fd97ec1f999f$export$49385134251b08ff(client) {
    return $8ed8fd97ec1f999f$var$_getBufferMap().get(client);
}
function $8ed8fd97ec1f999f$var$_getBufferMap() {
    return (0, $e4c75fb63b040566$export$7e223ec222791509)("clientToMetricBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}


function $240914cce3cb7287$var$captureMetric(type, name, value, options) {
    (0, $8ed8fd97ec1f999f$export$288d896e6652e0c4)({
        type: type,
        name: name,
        value: value,
        unit: options?.unit,
        attributes: options?.attributes
    }, {
        scope: options?.scope
    });
}
function $240914cce3cb7287$export$85b9a36db797e02b(name, value = 1, options) {
    $240914cce3cb7287$var$captureMetric("counter", name, value, options);
}
function $240914cce3cb7287$export$b0660673397c6c28(name, value, options) {
    $240914cce3cb7287$var$captureMetric("gauge", name, value, options);
}
function $240914cce3cb7287$export$fd8e353f0040520a(name, value, options) {
    $240914cce3cb7287$var$captureMetric("distribution", name, value, options);
}




const $c367925a6b0c021e$var$INTEGRATION_NAME = "ElementTiming";
const $c367925a6b0c021e$var$_elementTimingIntegration = ()=>{
    return {
        name: $c367925a6b0c021e$var$INTEGRATION_NAME,
        setup () {
            const performance = (0, $f19bf52440370854$export$f72a13c439a30cab)();
            if (!performance || !(0, $bc81602376c48fa6$export$baf075a948ffc0bf)()) return;
            (0, $375623e17d0e1d27$export$69816c1a049f8db6)("element", ({ entries: entries })=>{
                for (const entry of entries){
                    const elementEntry = entry;
                    if (!elementEntry.identifier) continue;
                    const identifier = elementEntry.identifier;
                    const paintType = elementEntry.name;
                    const renderTime = elementEntry.renderTime;
                    const loadTime = elementEntry.loadTime;
                    const metricAttributes = {
                        "sentry.origin": "auto.ui.browser.element_timing",
                        "ui.element.identifier": identifier
                    };
                    if (paintType) metricAttributes["ui.element.paint_type"] = paintType;
                    if (elementEntry.id) metricAttributes["ui.element.id"] = elementEntry.id;
                    if (elementEntry.element) metricAttributes["ui.element.type"] = elementEntry.element.tagName.toLowerCase();
                    if (elementEntry.url) metricAttributes["ui.element.url"] = elementEntry.url;
                    if (elementEntry.naturalWidth) metricAttributes["ui.element.width"] = elementEntry.naturalWidth;
                    if (elementEntry.naturalHeight) metricAttributes["ui.element.height"] = elementEntry.naturalHeight;
                    if (renderTime > 0) (0, $240914cce3cb7287$exports).distribution(`ui.element.render_time`, renderTime, {
                        unit: "millisecond",
                        attributes: metricAttributes
                    });
                    if (loadTime > 0) (0, $240914cce3cb7287$exports).distribution(`ui.element.load_time`, loadTime, {
                        unit: "millisecond",
                        attributes: metricAttributes
                    });
                }
            });
        }
    };
};
const $c367925a6b0c021e$export$653abef5c5d8f324 = (0, $cbb2da6c78246e45$export$2323046b9414659f)($c367925a6b0c021e$var$_elementTimingIntegration);
function $c367925a6b0c021e$export$c9ffcf7e2b5ec1b3() {
    return ()=>void 0;
}


function $fd75502b1c3baf49$export$8ca4f6d95250b4ec(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $de4f8abdf21afb03$export$56d8a8a25bd48b81).location.origin);
        return url.toString();
    } catch  {
        return urlOrPath;
    }
}




function $e3f9649a5fcc80c1$export$9e8f428c76bd6d1b(client = (0, $b244ff70a28cf637$exports.getClient)()) {
    client?.emit("endPageloadSpan");
}



function $40d8570c26789de3$export$4519ca486fe8649b(span) {
    const maybePreviousActiveSpan = (0, $b244ff70a28cf637$exports.getActiveSpan)();
    if (maybePreviousActiveSpan === span) return;
    const scope = (0, $b244ff70a28cf637$exports.getCurrentScope)();
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            (0, $b244ff70a28cf637$exports._INTERNAL_setSpanForScope)(scope, maybePreviousActiveSpan);
            return Reflect.apply(target, thisArg, args);
        }
    });
    (0, $b244ff70a28cf637$exports._INTERNAL_setSpanForScope)(scope, span);
}




const $dbac00e0df14d30e$export$6eda3f5129248a75 = (0, $b244ff70a28cf637$exports.defineIntegration)(()=>{
    return {
        name: "SpanStreaming",
        beforeSetup (client) {
            const clientOptions = client.getOptions();
            if (!clientOptions.traceLifecycle) {
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log('[SpanStreaming] setting `traceLifecycle` to "stream"');
                clientOptions.traceLifecycle = "stream";
            }
        },
        setup (client) {
            const initialMessage = "SpanStreaming integration requires";
            const fallbackMsg = "Falling back to static trace lifecycle.";
            const clientOptions = client.getOptions();
            if (!(0, $b244ff70a28cf637$exports.hasSpanStreamingEnabled)(client)) {
                clientOptions.traceLifecycle = "static";
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn(`${initialMessage} \`traceLifecycle\` to be set to "stream"! ${fallbackMsg}`);
                return;
            }
            const beforeSendSpan = clientOptions.beforeSendSpan;
            if (beforeSendSpan && !(0, $b244ff70a28cf637$exports.isStreamedBeforeSendSpanCallback)(beforeSendSpan)) {
                clientOptions.traceLifecycle = "static";
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn(`${initialMessage} a beforeSendSpan callback using \`withStreamedSpan\`! ${fallbackMsg}`);
                return;
            }
            const buffer = new (0, $b244ff70a28cf637$exports.SpanBuffer)(client);
            client.on("afterSpanEnd", (span)=>{
                if (!(0, $b244ff70a28cf637$exports.spanIsSampled)(span)) return;
                buffer.add((0, $b244ff70a28cf637$exports.captureSpan)(span, client));
            });
            client.on("afterSegmentSpanEnd", (segmentSpan)=>{
                const traceId = segmentSpan.spanContext().traceId;
                setTimeout(()=>{
                    buffer.flush(traceId);
                }, 500);
            });
        }
    };
});







function $c405876784a7ff78$var$promisifyRequest(request) {
    return new Promise((resolve, reject)=>{
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $c405876784a7ff78$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $c405876784a7ff78$var$promisifyRequest(request);
    return (callback)=>dbp.then((db)=>callback(db.transaction(storeName, "readwrite").objectStore(storeName)));
}
function $c405876784a7ff78$var$keys(store) {
    return $c405876784a7ff78$var$promisifyRequest(store.getAllKeys());
}
function $c405876784a7ff78$export$4cbf152802aa238(store, value, maxQueueSize) {
    return store((store2)=>{
        return $c405876784a7ff78$var$keys(store2).then((keys2)=>{
            if (keys2.length >= maxQueueSize) return;
            store2.put(value, Math.max(...keys2, 0) + 1);
            return $c405876784a7ff78$var$promisifyRequest(store2.transaction);
        });
    });
}
function $c405876784a7ff78$export$37cdb546b806ae87(store, value, maxQueueSize) {
    return store((store2)=>{
        return $c405876784a7ff78$var$keys(store2).then((keys2)=>{
            if (keys2.length >= maxQueueSize) return;
            store2.put(value, Math.min(...keys2, 0) - 1);
            return $c405876784a7ff78$var$promisifyRequest(store2.transaction);
        });
    });
}
function $c405876784a7ff78$export$fba63a578e423eb(store) {
    return store((store2)=>{
        return $c405876784a7ff78$var$keys(store2).then((keys2)=>{
            const firstKey = keys2[0];
            if (firstKey == null) return void 0;
            return $c405876784a7ff78$var$promisifyRequest(store2.get(firstKey)).then((value)=>{
                store2.delete(firstKey);
                return $c405876784a7ff78$var$promisifyRequest(store2.transaction).then(()=>value);
            });
        });
    });
}
function $c405876784a7ff78$var$createIndexedDbStore(options) {
    let store;
    function getStore() {
        if (store == void 0) store = $c405876784a7ff78$export$f51a9068ac82ea43(options.dbName || "sentry-offline", options.storeName || "queue");
        return store;
    }
    return {
        push: async (env)=>{
            try {
                const serialized = (0, $b244ff70a28cf637$exports.serializeEnvelope)(env);
                await $c405876784a7ff78$export$4cbf152802aa238(getStore(), serialized, options.maxQueueSize || 30);
            } catch  {}
        },
        unshift: async (env)=>{
            try {
                const serialized = (0, $b244ff70a28cf637$exports.serializeEnvelope)(env);
                await $c405876784a7ff78$export$37cdb546b806ae87(getStore(), serialized, options.maxQueueSize || 30);
            } catch  {}
        },
        shift: async ()=>{
            try {
                const deserialized = await $c405876784a7ff78$export$fba63a578e423eb(getStore());
                if (deserialized) return (0, $b244ff70a28cf637$exports.parseEnvelope)(deserialized);
            } catch  {}
            return void 0;
        }
    };
}
function $c405876784a7ff78$var$makeIndexedDbOfflineTransport(createTransport) {
    return (options)=>{
        const transport = createTransport({
            ...options,
            createStore: $c405876784a7ff78$var$createIndexedDbStore
        });
        (0, $e62dec891f31852b$export$56d8a8a25bd48b81).addEventListener("online", async (_)=>{
            await transport.flush();
        });
        return transport;
    };
}
function $c405876784a7ff78$export$79c8882827636cf2(createTransport = (0, $366021d20f9daad3$export$b2311068c46d7cc8)) {
    return $c405876784a7ff78$var$makeIndexedDbOfflineTransport((0, $b244ff70a28cf637$exports.makeOfflineTransport)(createTransport));
}











const $831515ad7ad113dc$var$MS_TO_NS = 1e6;
const $831515ad7ad113dc$var$isMainThread = "window" in (0, $b244ff70a28cf637$exports.GLOBAL_OBJ) && (0, $b244ff70a28cf637$exports.GLOBAL_OBJ).window === (0, $b244ff70a28cf637$exports.GLOBAL_OBJ) && typeof importScripts === "undefined";
const $831515ad7ad113dc$export$fa7490a9fefa3701 = String(0);
const $831515ad7ad113dc$export$71a451cfb2c2816 = $831515ad7ad113dc$var$isMainThread ? "main" : "worker";
const $831515ad7ad113dc$var$navigator = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).navigator;
let $831515ad7ad113dc$var$OS_PLATFORM = "";
let $831515ad7ad113dc$var$OS_PLATFORM_VERSION = "";
let $831515ad7ad113dc$var$OS_ARCH = "";
let $831515ad7ad113dc$var$OS_BROWSER = $831515ad7ad113dc$var$navigator?.userAgent || "";
let $831515ad7ad113dc$var$OS_MODEL = "";
const $831515ad7ad113dc$var$OS_LOCALE = $831515ad7ad113dc$var$navigator?.language || $831515ad7ad113dc$var$navigator?.languages?.[0] || "";
function $831515ad7ad113dc$var$isUserAgentData(data) {
    return typeof data === "object" && data !== null && "getHighEntropyValues" in data;
}
const $831515ad7ad113dc$var$userAgentData = $831515ad7ad113dc$var$navigator?.userAgentData;
if ($831515ad7ad113dc$var$isUserAgentData($831515ad7ad113dc$var$userAgentData)) $831515ad7ad113dc$var$userAgentData.getHighEntropyValues([
    "architecture",
    "model",
    "platform",
    "platformVersion",
    "fullVersionList"
]).then((ua)=>{
    $831515ad7ad113dc$var$OS_PLATFORM = ua.platform || "";
    $831515ad7ad113dc$var$OS_ARCH = ua.architecture || "";
    $831515ad7ad113dc$var$OS_MODEL = ua.model || "";
    $831515ad7ad113dc$var$OS_PLATFORM_VERSION = ua.platformVersion || "";
    if (ua.fullVersionList?.length) {
        const firstUa = ua.fullVersionList[ua.fullVersionList.length - 1];
        $831515ad7ad113dc$var$OS_BROWSER = `${firstUa.brand} ${firstUa.version}`;
    }
}).catch((e)=>void 0);
function $831515ad7ad113dc$var$isProcessedJSSelfProfile(profile) {
    return !("thread_metadata" in profile);
}
function $831515ad7ad113dc$export$7cbe6c4f12ea8325(profile) {
    if (!$831515ad7ad113dc$var$isProcessedJSSelfProfile(profile)) return profile;
    return $831515ad7ad113dc$export$f4122c775dfac1c2(profile);
}
function $831515ad7ad113dc$var$getTraceId(event) {
    const traceId = event.contexts?.trace?.trace_id;
    if (typeof traceId === "string" && traceId.length !== 32) {
        if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $b244ff70a28cf637$exports.debug).log(`[Profiling] Invalid traceId: ${traceId} on profiled event`);
    }
    if (typeof traceId !== "string") return "";
    return traceId;
}
function $831515ad7ad113dc$export$5c9f6e262288b7db(profile_id, start_timestamp, processed_profile, event) {
    if (event.type !== "transaction") throw new TypeError("Profiling events may only be attached to transactions, this should never occur.");
    if (processed_profile === void 0 || processed_profile === null) throw new TypeError(`Cannot construct profiling event envelope without a valid profile. Got ${processed_profile} instead.`);
    const traceId = $831515ad7ad113dc$var$getTraceId(event);
    const enrichedThreadProfile = $831515ad7ad113dc$export$7cbe6c4f12ea8325(processed_profile);
    const transactionStartMs = start_timestamp ? start_timestamp : typeof event.start_timestamp === "number" ? event.start_timestamp * 1e3 : (0, $b244ff70a28cf637$exports.timestampInSeconds)() * 1e3;
    const transactionEndMs = typeof event.timestamp === "number" ? event.timestamp * 1e3 : (0, $b244ff70a28cf637$exports.timestampInSeconds)() * 1e3;
    const profile = {
        event_id: profile_id,
        timestamp: new Date(transactionStartMs).toISOString(),
        platform: "javascript",
        version: "1",
        release: event.release || "",
        environment: event.environment || (0, $b244ff70a28cf637$exports.DEFAULT_ENVIRONMENT),
        runtime: {
            name: "javascript",
            version: (0, $e62dec891f31852b$export$56d8a8a25bd48b81).navigator.userAgent
        },
        os: {
            name: $831515ad7ad113dc$var$OS_PLATFORM,
            version: $831515ad7ad113dc$var$OS_PLATFORM_VERSION,
            build_number: $831515ad7ad113dc$var$OS_BROWSER
        },
        device: {
            locale: $831515ad7ad113dc$var$OS_LOCALE,
            model: $831515ad7ad113dc$var$OS_MODEL,
            manufacturer: $831515ad7ad113dc$var$OS_BROWSER,
            architecture: $831515ad7ad113dc$var$OS_ARCH,
            is_emulator: false
        },
        debug_meta: {
            images: $831515ad7ad113dc$export$4c0b0d8ee0d018b5(processed_profile.resources)
        },
        profile: enrichedThreadProfile,
        transactions: [
            {
                name: event.transaction || "",
                id: event.event_id || (0, $b244ff70a28cf637$exports.uuid4)(),
                trace_id: traceId,
                active_thread_id: $831515ad7ad113dc$export$fa7490a9fefa3701,
                relative_start_ns: "0",
                relative_end_ns: ((transactionEndMs - transactionStartMs) * 1e6).toFixed(0)
            }
        ]
    };
    return profile;
}
function $831515ad7ad113dc$export$4684f29184e0c876(jsSelfProfile, client, profilerId) {
    if (jsSelfProfile == null) throw new TypeError(`Cannot construct profiling event envelope without a valid profile. Got ${jsSelfProfile} instead.`);
    const continuousProfile = $831515ad7ad113dc$var$convertToContinuousProfile(jsSelfProfile);
    const options = client.getOptions();
    const sdk = client.getSdkMetadata?.()?.sdk;
    return {
        chunk_id: (0, $b244ff70a28cf637$exports.uuid4)(),
        client_sdk: {
            name: sdk?.name ?? "sentry.javascript.browser",
            version: sdk?.version ?? "0.0.0"
        },
        profiler_id: profilerId || (0, $b244ff70a28cf637$exports.uuid4)(),
        platform: "javascript",
        version: "2",
        release: options.release ?? "",
        environment: options.environment ?? "production",
        debug_meta: {
            // function name obfuscation
            images: $831515ad7ad113dc$export$4c0b0d8ee0d018b5(jsSelfProfile.resources)
        },
        profile: continuousProfile
    };
}
function $831515ad7ad113dc$export$706bf24a90edd468(chunk) {
    try {
        if (!chunk || typeof chunk !== "object") return {
            reason: "chunk is not an object"
        };
        const isHex32 = (val)=>typeof val === "string" && /^[a-f0-9]{32}$/.test(val);
        if (!isHex32(chunk.profiler_id)) return {
            reason: "missing or invalid profiler_id"
        };
        if (!isHex32(chunk.chunk_id)) return {
            reason: "missing or invalid chunk_id"
        };
        if (!chunk.client_sdk) return {
            reason: "missing client_sdk metadata"
        };
        const profile = chunk.profile;
        if (!profile) return {
            reason: "missing profile data"
        };
        if (!Array.isArray(profile.frames) || !profile.frames.length) return {
            reason: "profile has no frames"
        };
        if (!Array.isArray(profile.stacks) || !profile.stacks.length) return {
            reason: "profile has no stacks"
        };
        if (!Array.isArray(profile.samples) || !profile.samples.length) return {
            reason: "profile has no samples"
        };
        return {
            valid: true
        };
    } catch (e) {
        return {
            reason: `unknown validation error: ${e}`
        };
    }
}
function $831515ad7ad113dc$var$convertToContinuousProfile(input) {
    const frames = [];
    for(let i = 0; i < input.frames.length; i++){
        const frame = input.frames[i];
        if (!frame) continue;
        frames[i] = {
            function: frame.name,
            abs_path: typeof frame.resourceId === "number" ? input.resources[frame.resourceId] : void 0,
            lineno: frame.line,
            colno: frame.column
        };
    }
    const stacks = [];
    for(let i = 0; i < input.stacks.length; i++){
        const stackHead = input.stacks[i];
        if (!stackHead) continue;
        const list = [];
        let current = stackHead;
        while(current){
            list.push(current.frameId);
            current = current.parentId === void 0 ? void 0 : input.stacks[current.parentId];
        }
        stacks[i] = list;
    }
    const perfOrigin = (0, $b244ff70a28cf637$exports.browserPerformanceTimeOrigin)();
    const origin = typeof performance.timeOrigin === "number" ? performance.timeOrigin : perfOrigin || 0;
    const adjustForOriginChange = origin - (perfOrigin || origin);
    const samples = [];
    for(let i = 0; i < input.samples.length; i++){
        const sample = input.samples[i];
        if (!sample) continue;
        const timestampSeconds = (origin + (sample.timestamp - adjustForOriginChange)) / 1e3;
        samples[i] = {
            stack_id: sample.stackId ?? 0,
            thread_id: $831515ad7ad113dc$export$fa7490a9fefa3701,
            timestamp: timestampSeconds
        };
    }
    return {
        frames: frames,
        stacks: stacks,
        samples: samples,
        thread_metadata: {
            [$831515ad7ad113dc$export$fa7490a9fefa3701]: {
                name: $831515ad7ad113dc$export$71a451cfb2c2816
            }
        }
    };
}
function $831515ad7ad113dc$export$563404c5f9ee31f6(span) {
    return (0, $b244ff70a28cf637$exports.spanToJSON)(span).op === "pageload";
}
function $831515ad7ad113dc$export$f4122c775dfac1c2(input) {
    let EMPTY_STACK_ID = void 0;
    let STACK_ID = 0;
    const profile = {
        samples: [],
        stacks: [],
        frames: [],
        thread_metadata: {
            [$831515ad7ad113dc$export$fa7490a9fefa3701]: {
                name: $831515ad7ad113dc$export$71a451cfb2c2816
            }
        }
    };
    const firstSample = input.samples[0];
    if (!firstSample) return profile;
    const start = firstSample.timestamp;
    const perfOrigin = (0, $b244ff70a28cf637$exports.browserPerformanceTimeOrigin)();
    const origin = typeof performance.timeOrigin === "number" ? performance.timeOrigin : perfOrigin || 0;
    const adjustForOriginChange = origin - (perfOrigin || origin);
    input.samples.forEach((jsSample, i)=>{
        if (jsSample.stackId === void 0) {
            if (EMPTY_STACK_ID === void 0) {
                EMPTY_STACK_ID = STACK_ID;
                profile.stacks[EMPTY_STACK_ID] = [];
                STACK_ID++;
            }
            profile["samples"][i] = {
                // convert ms timestamp to ns
                elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * $831515ad7ad113dc$var$MS_TO_NS).toFixed(0),
                stack_id: EMPTY_STACK_ID,
                thread_id: $831515ad7ad113dc$export$fa7490a9fefa3701
            };
            return;
        }
        let stackTop = input.stacks[jsSample.stackId];
        const stack = [];
        while(stackTop){
            stack.push(stackTop.frameId);
            const frame = input.frames[stackTop.frameId];
            if (frame && profile.frames[stackTop.frameId] === void 0) profile.frames[stackTop.frameId] = {
                function: frame.name,
                abs_path: typeof frame.resourceId === "number" ? input.resources[frame.resourceId] : void 0,
                lineno: frame.line,
                colno: frame.column
            };
            stackTop = stackTop.parentId === void 0 ? void 0 : input.stacks[stackTop.parentId];
        }
        const sample = {
            // convert ms timestamp to ns
            elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * $831515ad7ad113dc$var$MS_TO_NS).toFixed(0),
            stack_id: STACK_ID,
            thread_id: $831515ad7ad113dc$export$fa7490a9fefa3701
        };
        profile["stacks"][STACK_ID] = stack;
        profile["samples"][i] = sample;
        STACK_ID++;
    });
    return profile;
}
function $831515ad7ad113dc$export$4df36760a75f76bc(envelope, profiles) {
    if (!profiles.length) return envelope;
    for (const profile of profiles)envelope[1].push([
        {
            type: "profile"
        },
        profile
    ]);
    return envelope;
}
function $831515ad7ad113dc$export$df9bb0fc214ff8cd(envelope) {
    const events = [];
    (0, $b244ff70a28cf637$exports.forEachEnvelopeItem)(envelope, (item, type)=>{
        if (type !== "transaction") return;
        for(let j = 1; j < item.length; j++){
            const event = item[j];
            if (event?.contexts?.profile?.profile_id) events.push(item[j]);
        }
    });
    return events;
}
function $831515ad7ad113dc$export$4c0b0d8ee0d018b5(resource_paths) {
    const client = (0, $b244ff70a28cf637$exports.getClient)();
    const options = client?.getOptions();
    const stackParser = options?.stackParser;
    if (!stackParser) return [];
    return (0, $b244ff70a28cf637$exports.getDebugImagesForResources)(stackParser, resource_paths);
}
function $831515ad7ad113dc$export$2603c8d332a51c42(rate) {
    if (typeof rate !== "number" && typeof rate !== "boolean" || typeof rate === "number" && isNaN(rate)) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn(`[Profiling] Invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    if (rate === true || rate === false) return true;
    if (rate < 0 || rate > 1) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn(`[Profiling] Invalid sample rate. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}
function $831515ad7ad113dc$var$isValidProfile(profile) {
    if (profile.samples.length < 2) {
        if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $b244ff70a28cf637$exports.debug).log("[Profiling] Discarding profile because it contains less than 2 samples");
        return false;
    }
    if (!profile.frames.length) {
        if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $b244ff70a28cf637$exports.debug).log("[Profiling] Discarding profile because it contains no frames");
        return false;
    }
    return true;
}
let $831515ad7ad113dc$var$PROFILING_CONSTRUCTOR_FAILED = false;
const $831515ad7ad113dc$export$8640c0b5c7d98a81 = 3e4;
function $831515ad7ad113dc$var$isJSProfilerSupported(maybeProfiler) {
    return typeof maybeProfiler === "function";
}
function $831515ad7ad113dc$export$9f4f648547a4284f() {
    const JSProfilerConstructor = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).Profiler;
    if (!$831515ad7ad113dc$var$isJSProfilerSupported(JSProfilerConstructor)) {
        if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $b244ff70a28cf637$exports.debug).log("[Profiling] Profiling is not supported by this browser, Profiler interface missing on window object.");
        return;
    }
    const samplingIntervalMS = 10;
    const maxSamples = Math.floor($831515ad7ad113dc$export$8640c0b5c7d98a81 / samplingIntervalMS);
    try {
        return new JSProfilerConstructor({
            sampleInterval: samplingIntervalMS,
            maxBufferSize: maxSamples
        });
    } catch (_e) {
        if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) {
            (0, $b244ff70a28cf637$exports.debug).log("[Profiling] Failed to initialize the Profiling constructor, this is likely due to a missing 'Document-Policy': 'js-profiling' header.");
            (0, $b244ff70a28cf637$exports.debug).log("[Profiling] Disabling profiling for current user session.");
        }
        $831515ad7ad113dc$var$PROFILING_CONSTRUCTOR_FAILED = true;
    }
    return;
}
function $831515ad7ad113dc$export$a3f4959190b2ff33(span) {
    if ($831515ad7ad113dc$var$PROFILING_CONSTRUCTOR_FAILED) {
        if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $b244ff70a28cf637$exports.debug).log("[Profiling] Profiling has been disabled for the duration of the current user session.");
        return false;
    }
    if (!span.isRecording()) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("[Profiling] Discarding profile because root span was not sampled.");
        return false;
    }
    const client = (0, $b244ff70a28cf637$exports.getClient)();
    const options = client?.getOptions();
    if (!options) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("[Profiling] Profiling disabled, no options found.");
        return false;
    }
    const profilesSampleRate = options.profilesSampleRate;
    if (!$831515ad7ad113dc$export$2603c8d332a51c42(profilesSampleRate)) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn("[Profiling] Discarding profile because of invalid sample rate.");
        return false;
    }
    if (!profilesSampleRate) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("[Profiling] Discarding profile because a negative sampling decision was inherited or profileSampleRate is set to 0");
        return false;
    }
    const sampled = profilesSampleRate === true ? true : Math.random() < profilesSampleRate;
    if (!sampled) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log(`[Profiling] Discarding profile because it's not included in the random sample (sampling rate = ${Number(profilesSampleRate)})`);
        return false;
    }
    return true;
}
function $831515ad7ad113dc$export$32ef4798a567c0ec(options) {
    if ($831515ad7ad113dc$var$PROFILING_CONSTRUCTOR_FAILED) {
        if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $b244ff70a28cf637$exports.debug).log("[Profiling] Profiling has been disabled for the duration of the current user session as the JS Profiler could not be started.");
        return false;
    }
    if (options.profileLifecycle !== "trace" && options.profileLifecycle !== "manual") {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn("[Profiling] Session not sampled. Invalid `profileLifecycle` option.");
        return false;
    }
    const profileSessionSampleRate = options.profileSessionSampleRate;
    if (!$831515ad7ad113dc$export$2603c8d332a51c42(profileSessionSampleRate)) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn("[Profiling] Discarding profile because of invalid profileSessionSampleRate.");
        return false;
    }
    if (!profileSessionSampleRate) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("[Profiling] Discarding profile because profileSessionSampleRate is not defined or set to 0");
        return false;
    }
    return Math.random() <= profileSessionSampleRate;
}
function $831515ad7ad113dc$export$9fb56f964fbe825f(options) {
    return typeof options.profilesSampleRate !== "undefined";
}
function $831515ad7ad113dc$export$5c2c5e805edd874f(profile_id, start_timestamp, profile, event) {
    if (!$831515ad7ad113dc$var$isValidProfile(profile)) return null;
    return $831515ad7ad113dc$export$5c9f6e262288b7db(profile_id, start_timestamp, profile, event);
}
const $831515ad7ad113dc$var$PROFILE_MAP = /* @__PURE__ */ new Map();
function $831515ad7ad113dc$export$9d723f414195854a() {
    return $831515ad7ad113dc$var$PROFILE_MAP.size;
}
function $831515ad7ad113dc$export$6285310796363de1(profile_id) {
    const profile = $831515ad7ad113dc$var$PROFILE_MAP.get(profile_id);
    if (profile) $831515ad7ad113dc$var$PROFILE_MAP.delete(profile_id);
    return profile;
}
function $831515ad7ad113dc$export$7ddae68097f7e530(profile_id, profile) {
    $831515ad7ad113dc$var$PROFILE_MAP.set(profile_id, profile);
    if ($831515ad7ad113dc$var$PROFILE_MAP.size > 30) {
        const last = $831515ad7ad113dc$var$PROFILE_MAP.keys().next().value;
        if (last !== void 0) $831515ad7ad113dc$var$PROFILE_MAP.delete(last);
    }
}
const $831515ad7ad113dc$export$b2121224511d2a33 = /* @__PURE__ */ new WeakSet();
function $831515ad7ad113dc$export$c7b72b793c9d9374(span) {
    span.setAttribute("thread.id", $831515ad7ad113dc$export$fa7490a9fefa3701);
    span.setAttribute("thread.name", $831515ad7ad113dc$export$71a451cfb2c2816);
}


function $c7adc874b6bb695a$export$83bcc43b6a2cf5e7(span) {
    let startTimestamp;
    if ((0, $831515ad7ad113dc$export$563404c5f9ee31f6)(span)) startTimestamp = (0, $b244ff70a28cf637$exports.timestampInSeconds)() * 1e3;
    const profiler = (0, $831515ad7ad113dc$export$9f4f648547a4284f)();
    if (!profiler) return;
    if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $b244ff70a28cf637$exports.debug).log(`[Profiling] started profiling span: ${(0, $b244ff70a28cf637$exports.spanToJSON)(span).description}`);
    const profileId = (0, $b244ff70a28cf637$exports.uuid4)();
    let processedProfile = null;
    (0, $b244ff70a28cf637$exports.getCurrentScope)().setContext("profile", {
        profile_id: profileId,
        start_timestamp: startTimestamp
    });
    (0, $831515ad7ad113dc$export$b2121224511d2a33).add(span);
    (0, $831515ad7ad113dc$export$c7b72b793c9d9374)(span);
    async function onProfileHandler() {
        if (!span) return;
        if (!profiler) return;
        if (processedProfile) {
            if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $b244ff70a28cf637$exports.debug).log("[Profiling] profile for:", (0, $b244ff70a28cf637$exports.spanToJSON)(span).description, "already exists, returning early");
            return;
        }
        return profiler.stop().then((profile)=>{
            if (maxDurationTimeoutID) {
                (0, $e62dec891f31852b$export$56d8a8a25bd48b81).clearTimeout(maxDurationTimeoutID);
                maxDurationTimeoutID = void 0;
            }
            if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $b244ff70a28cf637$exports.debug).log(`[Profiling] stopped profiling of span: ${(0, $b244ff70a28cf637$exports.spanToJSON)(span).description}`);
            if (!profile) {
                if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $b244ff70a28cf637$exports.debug).log(`[Profiling] profiler returned null profile for: ${(0, $b244ff70a28cf637$exports.spanToJSON)(span).description}`, "this may indicate an overlapping span or a call to stopProfiling with a profile title that was never started");
                return;
            }
            processedProfile = profile;
            (0, $831515ad7ad113dc$export$7ddae68097f7e530)(profileId, profile);
        }).catch((error)=>{
            if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $b244ff70a28cf637$exports.debug).log("[Profiling] error while stopping profiler:", error);
        });
    }
    let maxDurationTimeoutID = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).setTimeout(()=>{
        if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $b244ff70a28cf637$exports.debug).log("[Profiling] max profile duration elapsed, stopping profiling for:", (0, $b244ff70a28cf637$exports.spanToJSON)(span).description);
        onProfileHandler();
    }, (0, $831515ad7ad113dc$export$8640c0b5c7d98a81));
    const originalEnd = span.end.bind(span);
    function profilingWrappedSpanEnd() {
        if (!span) return originalEnd();
        onProfileHandler().then(()=>{
            originalEnd();
        }, ()=>{
            originalEnd();
        });
        return span;
    }
    span.end = profilingWrappedSpanEnd;
}





const $b01975b7be737c0e$var$CHUNK_INTERVAL_MS = 6e4;
const $b01975b7be737c0e$var$MAX_ROOT_SPAN_PROFILE_MS = 3e5;
class $b01975b7be737c0e$export$20020d6e2aeade43 {
    constructor(){
        this._client = void 0;
        this._profiler = void 0;
        this._chunkTimer = void 0;
        this._profilerId = void 0;
        this._isRunning = false;
        this._sessionSampled = false;
        this._lifecycleMode = void 0;
        this._activeRootSpanIds = /* @__PURE__ */ new Set();
        this._rootSpanTimeouts = /* @__PURE__ */ new Map();
    }
    /**
   * Initialize the profiler with client, session sampling and lifecycle mode.
   */ initialize(client) {
        const lifecycleMode = client.getOptions().profileLifecycle;
        const sessionSampled = (0, $831515ad7ad113dc$export$32ef4798a567c0ec)(client.getOptions());
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log(`[Profiling] Initializing profiler (lifecycle='${lifecycleMode}').`);
        if (!sessionSampled) (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("[Profiling] Session not sampled. Skipping lifecycle profiler initialization.");
        this._profilerId = (0, $b244ff70a28cf637$exports.uuid4)();
        this._client = client;
        this._sessionSampled = sessionSampled;
        this._lifecycleMode = lifecycleMode;
        if (lifecycleMode === "trace") this._setupTraceLifecycleListeners(client);
        client.on("spanStart", (span)=>{
            if (this._isRunning) (0, $831515ad7ad113dc$export$c7b72b793c9d9374)(span);
        });
    }
    /** Starts UI profiling (only effective in 'manual' mode and when sampled). */ start() {
        if (this._lifecycleMode === "trace") {
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn('[Profiling] `profileLifecycle` is set to "trace". Calls to `uiProfiler.start()` are ignored in trace mode.');
            return;
        }
        if (this._isRunning) {
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn("[Profiling] Profile session is already running, `uiProfiler.start()` is a no-op.");
            return;
        }
        if (!this._sessionSampled) {
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn("[Profiling] Session is not sampled, `uiProfiler.start()` is a no-op.");
            return;
        }
        this._beginProfiling();
    }
    /** Stops UI profiling (only effective in 'manual' mode). */ stop() {
        if (this._lifecycleMode === "trace") {
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn('[Profiling] `profileLifecycle` is set to "trace". Calls to `uiProfiler.stop()` are ignored in trace mode.');
            return;
        }
        if (!this._isRunning) {
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn("[Profiling] Profiler is not running, `uiProfiler.stop()` is a no-op.");
            return;
        }
        this._endProfiling();
    }
    /** Handle an already-active root span at integration setup time (used only in trace mode). */ notifyRootSpanActive(rootSpan) {
        if (this._lifecycleMode !== "trace" || !this._sessionSampled) return;
        const spanId = rootSpan.spanContext().spanId;
        if (!spanId || this._activeRootSpanIds.has(spanId)) return;
        this._registerTraceRootSpan(spanId);
        const rootSpanCount = this._activeRootSpanIds.size;
        if (rootSpanCount === 1) {
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("[Profiling] Detected already active root span during setup. Active root spans now:", rootSpanCount);
            this._beginProfiling();
        }
        if (this._isRunning) (0, $831515ad7ad113dc$export$c7b72b793c9d9374)(rootSpan);
    }
    /**
   * Begin profiling if not already running.
   */ _beginProfiling() {
        if (this._isRunning) return;
        this._isRunning = true;
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("[Profiling] Started profiling with profiler ID:", this._profilerId);
        (0, $b244ff70a28cf637$exports.getGlobalScope)().setContext("profile", {
            profiler_id: this._profilerId
        });
        this._startProfilerInstance();
        if (!this._profiler) {
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("[Profiling] Failed to start JS Profiler; stopping.");
            this._resetProfilerInfo();
            return;
        }
        this._startPeriodicChunking();
    }
    /** End profiling session; final chunk will be collected and sent. */ _endProfiling() {
        if (!this._isRunning) return;
        this._isRunning = false;
        if (this._chunkTimer) {
            clearTimeout(this._chunkTimer);
            this._chunkTimer = void 0;
        }
        this._clearAllRootSpanTimeouts();
        this._collectCurrentChunk().catch((e)=>{
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).error("[Profiling] Failed to collect current profile chunk on `stop()`:", e);
        });
        if (this._lifecycleMode === "manual") (0, $b244ff70a28cf637$exports.getGlobalScope)().setContext("profile", {});
    }
    /** Trace-mode: attach spanStart/spanEnd listeners. */ _setupTraceLifecycleListeners(client) {
        client.on("spanStart", (span)=>{
            if (!this._sessionSampled) {
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("[Profiling] Span not profiled because of negative sampling decision for user session.");
                return;
            }
            if (span !== (0, $b244ff70a28cf637$exports.getRootSpan)(span)) return;
            if (!span.isRecording()) {
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("[Profiling] Discarding profile because root span was not sampled.");
                return;
            }
            const spanId = span.spanContext().spanId;
            if (!spanId || this._activeRootSpanIds.has(spanId)) return;
            this._registerTraceRootSpan(spanId);
            const rootSpanCount = this._activeRootSpanIds.size;
            if (rootSpanCount === 1) {
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log(`[Profiling] Root span ${spanId} started. Profiling active while there are active root spans (count=${rootSpanCount}).`);
                this._beginProfiling();
            }
        });
        client.on("spanEnd", (span)=>{
            if (!this._sessionSampled) return;
            const spanId = span.spanContext().spanId;
            if (!spanId || !this._activeRootSpanIds.has(spanId)) return;
            this._activeRootSpanIds.delete(spanId);
            const rootSpanCount = this._activeRootSpanIds.size;
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log(`[Profiling] Root span with ID ${spanId} ended. Will continue profiling for as long as there are active root spans (currently: ${rootSpanCount}).`);
            if (rootSpanCount === 0) {
                this._collectCurrentChunk().catch((e)=>{
                    (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).error("[Profiling] Failed to collect current profile chunk on last `spanEnd`:", e);
                });
                this._endProfiling();
            }
        });
    }
    /**
   * Resets profiling information from scope and resets running state (used on failure)
   */ _resetProfilerInfo() {
        this._isRunning = false;
        (0, $b244ff70a28cf637$exports.getGlobalScope)().setContext("profile", {});
    }
    /**
   * Clear and reset all per-root-span timeouts.
   */ _clearAllRootSpanTimeouts() {
        this._rootSpanTimeouts.forEach((timeout)=>clearTimeout(timeout));
        this._rootSpanTimeouts.clear();
    }
    /** Keep track of root spans and schedule safeguard timeout (trace mode). */ _registerTraceRootSpan(spanId) {
        this._activeRootSpanIds.add(spanId);
        const timeout = setTimeout(()=>this._onRootSpanTimeout(spanId), $b01975b7be737c0e$var$MAX_ROOT_SPAN_PROFILE_MS);
        this._rootSpanTimeouts.set(spanId, timeout);
    }
    /**
   * Start a profiler instance if needed.
   */ _startProfilerInstance() {
        if (this._profiler?.stopped === false) return;
        const profiler = (0, $831515ad7ad113dc$export$9f4f648547a4284f)();
        if (!profiler) {
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("[Profiling] Failed to start JS Profiler.");
            return;
        }
        this._profiler = profiler;
    }
    /**
   * Schedule the next 60s chunk while running.
   * Each tick collects a chunk and restarts the profiler.
   * A chunk should be closed when there are no active root spans anymore OR when the maximum chunk interval is reached.
   */ _startPeriodicChunking() {
        if (!this._isRunning) return;
        this._chunkTimer = setTimeout(()=>{
            this._collectCurrentChunk().catch((e)=>{
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).error("[Profiling] Failed to collect current profile chunk during periodic chunking:", e);
            });
            if (this._isRunning) {
                this._startProfilerInstance();
                if (!this._profiler) {
                    this._resetProfilerInfo();
                    return;
                }
                this._startPeriodicChunking();
            }
        }, $b01975b7be737c0e$var$CHUNK_INTERVAL_MS);
    }
    /**
   * Handle timeout for a specific root span ID to avoid indefinitely running profiler if `spanEnd` never fires.
   * If this was the last active root span, collect the current chunk and stop profiling.
   */ _onRootSpanTimeout(rootSpanId) {
        if (!this._rootSpanTimeouts.has(rootSpanId)) return;
        this._rootSpanTimeouts.delete(rootSpanId);
        if (!this._activeRootSpanIds.has(rootSpanId)) return;
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log(`[Profiling] Reached 5-minute timeout for root span ${rootSpanId}. You likely started a manual root span that never called \`.end()\`.`);
        this._activeRootSpanIds.delete(rootSpanId);
        if (this._activeRootSpanIds.size === 0) this._endProfiling();
    }
    /**
   * Stop current profiler instance, convert profile to chunk & send.
   */ async _collectCurrentChunk() {
        const prevProfiler = this._profiler;
        this._profiler = void 0;
        if (!prevProfiler) return;
        try {
            const profile = await prevProfiler.stop();
            const chunk = (0, $831515ad7ad113dc$export$4684f29184e0c876)(profile, this._client, this._profilerId);
            const validationReturn = (0, $831515ad7ad113dc$export$706bf24a90edd468)(chunk);
            if ("reason" in validationReturn) {
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("[Profiling] Discarding invalid profile chunk (this is probably a bug in the SDK):", validationReturn.reason);
                return;
            }
            this._sendProfileChunk(chunk);
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("[Profiling] Collected browser profile chunk.");
        } catch (e) {
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("[Profiling] Error while stopping JS Profiler for chunk:", e);
        }
    }
    /**
   * Send a profile chunk as a standalone envelope.
   */ _sendProfileChunk(chunk) {
        const client = this._client;
        const sdkInfo = (0, $b244ff70a28cf637$exports.getSdkMetadataForEnvelopeHeader)(client.getSdkMetadata?.());
        const dsn = client.getDsn();
        const tunnel = client.getOptions().tunnel;
        const envelope = (0, $b244ff70a28cf637$exports.createEnvelope)({
            event_id: (0, $b244ff70a28cf637$exports.uuid4)(),
            sent_at: /* @__PURE__ */ new Date().toISOString(),
            ...sdkInfo && {
                sdk: sdkInfo
            },
            ...!!tunnel && dsn && {
                dsn: (0, $b244ff70a28cf637$exports.dsnToString)(dsn)
            }
        }, [
            [
                {
                    type: "profile_chunk",
                    platform: "javascript"
                },
                chunk
            ]
        ]);
        client.sendEnvelope(envelope).then(null, (reason)=>{
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).error("Error while sending profile chunk envelope:", reason);
        });
    }
}



const $ddc68b5832e965a7$var$INTEGRATION_NAME = "BrowserProfiling";
const $ddc68b5832e965a7$var$_browserProfilingIntegration = ()=>{
    return {
        name: $ddc68b5832e965a7$var$INTEGRATION_NAME,
        setup (client) {
            const options = client.getOptions();
            const profiler = new (0, $b01975b7be737c0e$export$20020d6e2aeade43)();
            if (!(0, $831515ad7ad113dc$export$9fb56f964fbe825f)(options) && !options.profileLifecycle) options.profileLifecycle = "manual";
            if ((0, $831515ad7ad113dc$export$9fb56f964fbe825f)(options) && !options.profilesSampleRate) {
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("[Profiling] Profiling disabled, no profiling options found.");
                return;
            }
            const activeSpan = (0, $b244ff70a28cf637$exports.getActiveSpan)();
            const rootSpan = activeSpan && (0, $b244ff70a28cf637$exports.getRootSpan)(activeSpan);
            if ((0, $831515ad7ad113dc$export$9fb56f964fbe825f)(options) && options.profileSessionSampleRate !== void 0) (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn("[Profiling] Both legacy profiling (`profilesSampleRate`) and UI profiling settings are defined. `profileSessionSampleRate` has no effect when legacy profiling is enabled.");
            if (!(0, $831515ad7ad113dc$export$9fb56f964fbe825f)(options)) {
                const lifecycleMode = options.profileLifecycle;
                client.on("startUIProfiler", ()=>profiler.start());
                client.on("stopUIProfiler", ()=>profiler.stop());
                if (lifecycleMode === "manual") profiler.initialize(client);
                else if (lifecycleMode === "trace") {
                    if (!(0, $b244ff70a28cf637$exports.hasSpansEnabled)(options)) {
                        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn("[Profiling] `profileLifecycle` is 'trace' but tracing is disabled. Set a `tracesSampleRate` or `tracesSampler` to enable span tracing.");
                        return;
                    }
                    profiler.initialize(client);
                    if (rootSpan) profiler.notifyRootSpanActive(rootSpan);
                    (0, $e62dec891f31852b$export$56d8a8a25bd48b81).setTimeout(()=>{
                        const laterActiveSpan = (0, $b244ff70a28cf637$exports.getActiveSpan)();
                        const laterRootSpan = laterActiveSpan && (0, $b244ff70a28cf637$exports.getRootSpan)(laterActiveSpan);
                        if (laterRootSpan) profiler.notifyRootSpanActive(laterRootSpan);
                    }, 0);
                }
            } else {
                if (rootSpan && (0, $831515ad7ad113dc$export$563404c5f9ee31f6)(rootSpan)) {
                    if ((0, $831515ad7ad113dc$export$a3f4959190b2ff33)(rootSpan)) (0, $c7adc874b6bb695a$export$83bcc43b6a2cf5e7)(rootSpan);
                }
                client.on("spanStart", (span)=>{
                    const rootSpan2 = (0, $b244ff70a28cf637$exports.getRootSpan)(span);
                    if (span === rootSpan2) {
                        if ((0, $831515ad7ad113dc$export$a3f4959190b2ff33)(span)) (0, $c7adc874b6bb695a$export$83bcc43b6a2cf5e7)(span);
                    } else if ((0, $831515ad7ad113dc$export$b2121224511d2a33).has(rootSpan2)) (0, $831515ad7ad113dc$export$c7b72b793c9d9374)(span);
                });
                client.on("beforeEnvelope", (envelope)=>{
                    if (!(0, $831515ad7ad113dc$export$9d723f414195854a)()) return;
                    const profiledTransactionEvents = (0, $831515ad7ad113dc$export$df9bb0fc214ff8cd)(envelope);
                    if (!profiledTransactionEvents.length) return;
                    const profilesToAddToEnvelope = [];
                    for (const profiledTransaction of profiledTransactionEvents){
                        const context = profiledTransaction?.contexts;
                        const profile_id = context?.profile?.["profile_id"];
                        const start_timestamp = context?.profile?.["start_timestamp"];
                        if (typeof profile_id !== "string") {
                            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("[Profiling] cannot find profile for a span without a profile context");
                            continue;
                        }
                        if (!profile_id) {
                            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("[Profiling] cannot find profile for a span without a profile context");
                            continue;
                        }
                        if (context?.profile) delete context.profile;
                        const profile = (0, $831515ad7ad113dc$export$6285310796363de1)(profile_id);
                        if (!profile) {
                            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log(`[Profiling] Could not retrieve profile for span: ${profile_id}`);
                            continue;
                        }
                        const profileEvent = (0, $831515ad7ad113dc$export$5c2c5e805edd874f)(profile_id, start_timestamp, profile, profiledTransaction);
                        if (profileEvent) profilesToAddToEnvelope.push(profileEvent);
                    }
                    (0, $831515ad7ad113dc$export$4df36760a75f76bc)(envelope, profilesToAddToEnvelope);
                });
            }
        }
    };
};
const $ddc68b5832e965a7$export$2c7b5d6dd5622f23 = (0, $b244ff70a28cf637$exports.defineIntegration)($ddc68b5832e965a7$var$_browserProfilingIntegration);





const $75c15b1f5f212f04$export$63196314a6cfeb0f = "SpotlightBrowser";
const $75c15b1f5f212f04$export$1d78159e9865fcd6 = [
    {
        op: "ui.interaction.click",
        name: "#sentry-spotlight"
    }
];
const $75c15b1f5f212f04$var$_spotlightIntegration = (options = {})=>{
    const sidecarUrl = options.sidecarUrl || "http://localhost:8969/stream";
    return {
        name: $75c15b1f5f212f04$export$63196314a6cfeb0f,
        setup: ()=>{
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("Using Sidecar URL", sidecarUrl);
        },
        beforeSetup (client) {
            const opts = client.getOptions();
            opts.ignoreSpans = [
                ...opts.ignoreSpans || [],
                ...$75c15b1f5f212f04$export$1d78159e9865fcd6
            ];
        },
        afterAllSetup: (client)=>{
            $75c15b1f5f212f04$var$setupSidecarForwarding(client, sidecarUrl);
        }
    };
};
function $75c15b1f5f212f04$var$setupSidecarForwarding(client, sidecarUrl) {
    const makeFetch = (0, $295fbc3e705f470c$export$e464f4a514ac28a8)("fetch");
    let failCount = 0;
    client.on("beforeEnvelope", (envelope)=>{
        if (failCount > 3) {
            (0, $b244ff70a28cf637$exports.debug).warn("[Spotlight] Disabled Sentry -> Spotlight integration due to too many failed requests:", failCount);
            return;
        }
        makeFetch(sidecarUrl, {
            method: "POST",
            body: (0, $b244ff70a28cf637$exports.serializeEnvelope)(envelope),
            headers: {
                "Content-Type": "application/x-sentry-envelope"
            },
            mode: "cors"
        }).then((res)=>{
            if (res.status >= 200 && res.status < 400) failCount = 0;
        }, (err)=>{
            failCount++;
            (0, $b244ff70a28cf637$exports.debug).error("Sentry SDK can't connect to Sidecar is it running? See: https://spotlightjs.com/sidecar/npx/", err);
        });
    });
}
const $75c15b1f5f212f04$export$a05c07c0f32f730a = (0, $b244ff70a28cf637$exports.defineIntegration)($75c15b1f5f212f04$var$_spotlightIntegration);




const $2849f1c84e195cf6$export$7cd9c18538ed792e = (0, $b244ff70a28cf637$exports.defineIntegration)(()=>{
    return {
        name: "LaunchDarkly",
        processEvent (event, _hint, _client) {
            return (0, $b244ff70a28cf637$exports._INTERNAL_copyFlagsFromScopeToEvent)(event);
        }
    };
});
function $2849f1c84e195cf6$export$f97714c0986edb0() {
    return {
        name: "sentry-flag-auditor",
        type: "flag-used",
        synchronous: true,
        /**
     * Handle a flag evaluation by storing its name and value on the current scope.
     */ method: (flagKey, flagDetail, _context)=>{
            (0, $b244ff70a28cf637$exports._INTERNAL_insertFlagToScope)(flagKey, flagDetail.value);
            (0, $b244ff70a28cf637$exports._INTERNAL_addFeatureFlagToActiveSpan)(flagKey, flagDetail.value);
        }
    };
}



const $6878dd2c72de26fa$export$a41102cd52abbd1b = (0, $b244ff70a28cf637$exports.defineIntegration)(()=>{
    return {
        name: "OpenFeature",
        processEvent (event, _hint, _client) {
            return (0, $b244ff70a28cf637$exports._INTERNAL_copyFlagsFromScopeToEvent)(event);
        }
    };
});
class $6878dd2c72de26fa$export$f399add65bfd388e {
    /**
   * Successful evaluation result.
   */ after(_hookContext, evaluationDetails) {
        (0, $b244ff70a28cf637$exports._INTERNAL_insertFlagToScope)(evaluationDetails.flagKey, evaluationDetails.value);
        (0, $b244ff70a28cf637$exports._INTERNAL_addFeatureFlagToActiveSpan)(evaluationDetails.flagKey, evaluationDetails.value);
    }
    /**
   * On error evaluation result.
   */ error(hookContext, _error, _hookHints) {
        (0, $b244ff70a28cf637$exports._INTERNAL_insertFlagToScope)(hookContext.flagKey, hookContext.defaultValue);
        (0, $b244ff70a28cf637$exports._INTERNAL_addFeatureFlagToActiveSpan)(hookContext.flagKey, hookContext.defaultValue);
    }
}




const $d2291f482b064e01$export$e753ab651e68430d = (0, $b244ff70a28cf637$exports.defineIntegration)(({ featureFlagClientClass: unleashClientClass })=>{
    return {
        name: "Unleash",
        setupOnce () {
            const unleashClientPrototype = unleashClientClass.prototype;
            (0, $b244ff70a28cf637$exports.fill)(unleashClientPrototype, "isEnabled", $d2291f482b064e01$var$_wrappedIsEnabled);
        },
        processEvent (event, _hint, _client) {
            return (0, $b244ff70a28cf637$exports._INTERNAL_copyFlagsFromScopeToEvent)(event);
        }
    };
});
function $d2291f482b064e01$var$_wrappedIsEnabled(original) {
    return function(...args) {
        const toggleName = args[0];
        const result = original.apply(this, args);
        if (typeof toggleName === "string" && typeof result === "boolean") {
            (0, $b244ff70a28cf637$exports._INTERNAL_insertFlagToScope)(toggleName, result);
            (0, $b244ff70a28cf637$exports._INTERNAL_addFeatureFlagToActiveSpan)(toggleName, result);
        } else if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $b244ff70a28cf637$exports.debug).error(`[Feature Flags] UnleashClient.isEnabled does not match expected signature. arg0: ${toggleName} (${typeof toggleName}), result: ${result} (${typeof result})`);
        return result;
    };
}



const $382b31aa5714bdd4$export$c8399a95701fbc9f = ({ growthbookClass: growthbookClass })=>(0, $b244ff70a28cf637$exports.growthbookIntegration)({
        growthbookClass: growthbookClass
    });



const $cd57e45df1dff5a4$export$473918ef9c3b2ab7 = (0, $b244ff70a28cf637$exports.defineIntegration)(({ featureFlagClient: statsigClient })=>{
    return {
        name: "Statsig",
        setup (_client) {
            statsigClient.on("gate_evaluation", (event)=>{
                (0, $b244ff70a28cf637$exports._INTERNAL_insertFlagToScope)(event.gate.name, event.gate.value);
                (0, $b244ff70a28cf637$exports._INTERNAL_addFeatureFlagToActiveSpan)(event.gate.name, event.gate.value);
            });
        },
        processEvent (event, _hint, _client) {
            return (0, $b244ff70a28cf637$exports._INTERNAL_copyFlagsFromScopeToEvent)(event);
        }
    };
});



async function $7819adec6ec21508$export$fecc80c9f0e9c1b2() {
    const client = (0, $b244ff70a28cf637$exports.getClient)();
    if (!client) return "no-client-active";
    if (!client.getDsn()) return "no-dsn-configured";
    const tunnel = client.getOptions().tunnel;
    const defaultUrl = "https://o447951.ingest.sentry.io/api/4509632503087104/envelope/?sentry_version=7&sentry_key=c1dfb07d783ad5325c245c1fd3725390&sentry_client=sentry.javascript.browser%2F1.33.7";
    const url = tunnel || defaultUrl;
    try {
        await (0, $b244ff70a28cf637$exports.suppressTracing)(()=>// If fetch throws, there is likely an ad blocker active or there are other connective issues.
            fetch(url, {
                body: "{}",
                method: "POST",
                mode: "cors",
                credentials: "omit"
            }));
    } catch  {
        return "sentry-unreachable";
    }
}







const $907c5ffa3e02c638$export$63196314a6cfeb0f = "WebWorker";
const $907c5ffa3e02c638$export$88896133e37bd4db = (0, $b244ff70a28cf637$exports.defineIntegration)(({ worker: worker })=>({
        name: $907c5ffa3e02c638$export$63196314a6cfeb0f,
        setupOnce: ()=>{
            (Array.isArray(worker) ? worker : [
                worker
            ]).forEach((w)=>$907c5ffa3e02c638$var$listenForSentryMessages(w));
        },
        addWorker: (worker2)=>$907c5ffa3e02c638$var$listenForSentryMessages(worker2)
    }));
function $907c5ffa3e02c638$var$listenForSentryMessages(worker) {
    worker.addEventListener("message", (event)=>{
        if ($907c5ffa3e02c638$var$isSentryMessage(event.data)) {
            event.stopImmediatePropagation();
            if (event.data._sentryDebugIds) {
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("Sentry debugId web worker message received", event.data);
                (0, $e62dec891f31852b$export$56d8a8a25bd48b81)._sentryDebugIds = {
                    ...event.data._sentryDebugIds,
                    // debugIds of the main thread have precedence over the worker's in case of a collision.
                    ...(0, $e62dec891f31852b$export$56d8a8a25bd48b81)._sentryDebugIds
                };
            }
            if (event.data._sentryModuleMetadata) {
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("Sentry module metadata web worker message received", event.data);
                (0, $e62dec891f31852b$export$56d8a8a25bd48b81)._sentryModuleMetadata = {
                    ...event.data._sentryModuleMetadata,
                    // Module metadata of the main thread have precedence over the worker's in case of a collision.
                    ...(0, $e62dec891f31852b$export$56d8a8a25bd48b81)._sentryModuleMetadata
                };
            }
            if (event.data._sentryWasmImages) {
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("Sentry WASM images web worker message received", event.data);
                const existingImages = (0, $e62dec891f31852b$export$56d8a8a25bd48b81)._sentryWasmImages || [];
                const newImages = event.data._sentryWasmImages.filter((newImg)=>(0, $b244ff70a28cf637$exports.isPlainObject)(newImg) && typeof newImg.code_file === "string" && !existingImages.some((existing)=>existing.code_file === newImg.code_file));
                (0, $e62dec891f31852b$export$56d8a8a25bd48b81)._sentryWasmImages = [
                    ...existingImages,
                    ...newImages
                ];
            }
            if (event.data._sentryWorkerError) {
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("Sentry worker rejection message received", event.data._sentryWorkerError);
                $907c5ffa3e02c638$var$handleForwardedWorkerRejection(event.data._sentryWorkerError);
            }
        }
    });
}
function $907c5ffa3e02c638$var$handleForwardedWorkerRejection(workerError) {
    const client = (0, $b244ff70a28cf637$exports.getClient)();
    if (!client) return;
    const stackParser = client.getOptions().stackParser;
    const attachStacktrace = client.getOptions().attachStacktrace;
    const error = workerError.reason;
    const event = (0, $b244ff70a28cf637$exports.isPrimitive)(error) ? (0, $f1959cdcacc276d1$export$1353b5b36844a9ed)(error) : (0, $934e8a4b0ce930b6$export$9dd56ed1ef0c3420)(stackParser, error, void 0, attachStacktrace, true);
    event.level = "error";
    if (workerError.filename) event.contexts = {
        ...event.contexts,
        worker: {
            filename: workerError.filename
        }
    };
    (0, $b244ff70a28cf637$exports.captureEvent)(event, {
        originalException: error,
        mechanism: {
            handled: false,
            type: "auto.browser.web_worker.onunhandledrejection"
        }
    });
    (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("Captured worker unhandled rejection", error);
}
function $907c5ffa3e02c638$export$86daa8bd1fb8c346({ self: self }) {
    self.postMessage({
        _sentryMessage: true,
        _sentryDebugIds: self._sentryDebugIds ?? void 0,
        _sentryModuleMetadata: self._sentryModuleMetadata ?? void 0
    });
    self.addEventListener("unhandledrejection", (event)=>{
        const reason = (0, $f1959cdcacc276d1$export$b2cc40fa8241780)(event);
        const serializedError = {
            reason: reason,
            filename: self.location?.href
        };
        self.postMessage({
            _sentryMessage: true,
            _sentryWorkerError: serializedError
        });
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("[Sentry Worker] Forwarding unhandled rejection to parent", serializedError);
    });
    (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("[Sentry Worker] Registered worker with unhandled rejection handling");
}
function $907c5ffa3e02c638$var$isSentryMessage(eventData) {
    if (!(0, $b244ff70a28cf637$exports.isPlainObject)(eventData) || eventData._sentryMessage !== true) return false;
    const hasDebugIds = "_sentryDebugIds" in eventData;
    const hasModuleMetadata = "_sentryModuleMetadata" in eventData;
    const hasWorkerError = "_sentryWorkerError" in eventData;
    const hasWasmImages = "_sentryWasmImages" in eventData;
    if (!hasDebugIds && !hasModuleMetadata && !hasWorkerError && !hasWasmImages) return false;
    if (hasDebugIds && !((0, $b244ff70a28cf637$exports.isPlainObject)(eventData._sentryDebugIds) || eventData._sentryDebugIds === void 0)) return false;
    if (hasModuleMetadata && !((0, $b244ff70a28cf637$exports.isPlainObject)(eventData._sentryModuleMetadata) || eventData._sentryModuleMetadata === void 0)) return false;
    if (hasWorkerError && !(0, $b244ff70a28cf637$exports.isPlainObject)(eventData._sentryWorkerError)) return false;
    if (hasWasmImages && (!Array.isArray(eventData._sentryWasmImages) || !eventData._sentryWasmImages.every((img)=>(0, $b244ff70a28cf637$exports.isPlainObject)(img) && typeof img.code_file === "string"))) return false;
    return true;
}







var $5FkrB = parcelRequire("5FkrB");

function $d3ad959f6ec69d0e$export$bc2894c7158efbac(wat) {
    return (0, $13cf2ed412f405fa$export$53b83ca8eaab0383)(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}


function $c3b6349452077e3f$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $b244ff70a28cf637$exports.applySdkMetadata)(opts, "react");
    (0, $b244ff70a28cf637$exports.setContext)("react", {
        version: $5FkrB.version
    });
    const client = (0, $14d7809dba5d50b0$export$2cd8252107eb640b)(opts);
    (0, $b244ff70a28cf637$exports.setNormalizeStringifier)($c3b6349452077e3f$var$normalizeStringifyValue);
    return client;
}
function $c3b6349452077e3f$var$normalizeStringifyValue(value) {
    if ((0, $d3ad959f6ec69d0e$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
    return (0, $a464f0062cc3e108$export$4c88c355e6072df5)(value);
}





var $5FkrB = parcelRequire("5FkrB");
function $d73ec427c982e9ee$export$a87138b73900f5b(reactVersion) {
    const reactMajor = reactVersion.match(/^([^.]+)/);
    return reactMajor !== null && parseInt(reactMajor[0]) >= 17;
}
function $d73ec427c982e9ee$export$bc95048bc211a673(error, cause) {
    const seenErrors = /* @__PURE__ */ new WeakSet();
    function recurse(error2, cause2) {
        if (seenErrors.has(error2)) return;
        if (error2.cause) {
            seenErrors.add(error2);
            return recurse(error2.cause, cause2);
        }
        error2.cause = cause2;
    }
    recurse(error, cause);
}
function $d73ec427c982e9ee$export$270be4195468cda9(error, { componentStack: componentStack }, hint) {
    if ($d73ec427c982e9ee$export$a87138b73900f5b((0, $5FkrB.version)) && (0, $b244ff70a28cf637$exports.isError)(error) && componentStack) {
        const errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
        errorBoundaryError.stack = componentStack;
        $d73ec427c982e9ee$export$bc95048bc211a673(error, errorBoundaryError);
    }
    return (0, $b244ff70a28cf637$exports.captureException)(error, hint);
}
function $d73ec427c982e9ee$export$1e6f045b27b3cfb1(callback) {
    return (error, errorInfo)=>{
        const hasCallback = !!callback;
        const eventId = $d73ec427c982e9ee$export$270be4195468cda9(error, errorInfo, {
            mechanism: {
                handled: hasCallback,
                type: "auto.function.react.error_handler"
            }
        });
        if (hasCallback) callback(error, errorInfo, eventId);
    };
}





var $5FkrB = parcelRequire("5FkrB");
const $4a33d92877504aad$export$a5a94ea2f791dca1 = "ui.react.render";
const $4a33d92877504aad$export$ee0f1075b9437852 = "ui.react.update";
const $4a33d92877504aad$export$2c5aa1bf688e9ea1 = "ui.react.mount";


const $2015f24f5be0bafb$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
const $2015f24f5be0bafb$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
const $2015f24f5be0bafb$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
const $2015f24f5be0bafb$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
const $2015f24f5be0bafb$var$ForwardRefType = /* @__PURE__ */ Symbol.for("react.forward_ref");
const $2015f24f5be0bafb$var$MemoType = /* @__PURE__ */ Symbol.for("react.memo");
function $2015f24f5be0bafb$var$isMemo(component) {
    return typeof component === "object" && component !== null && component.$$typeof === $2015f24f5be0bafb$var$MemoType;
}
const $2015f24f5be0bafb$var$TYPE_STATICS = {};
$2015f24f5be0bafb$var$TYPE_STATICS[$2015f24f5be0bafb$var$ForwardRefType] = $2015f24f5be0bafb$var$FORWARD_REF_STATICS;
$2015f24f5be0bafb$var$TYPE_STATICS[$2015f24f5be0bafb$var$MemoType] = $2015f24f5be0bafb$var$MEMO_STATICS;
function $2015f24f5be0bafb$var$getStatics(component) {
    if ($2015f24f5be0bafb$var$isMemo(component)) return $2015f24f5be0bafb$var$MEMO_STATICS;
    const componentType = component.$$typeof;
    return componentType && $2015f24f5be0bafb$var$TYPE_STATICS[componentType] || $2015f24f5be0bafb$var$REACT_STATICS;
}
const $2015f24f5be0bafb$var$defineProperty = Object.defineProperty.bind(Object);
const $2015f24f5be0bafb$var$getOwnPropertyNames = Object.getOwnPropertyNames.bind(Object);
const $2015f24f5be0bafb$var$getOwnPropertySymbols = Object.getOwnPropertySymbols?.bind(Object);
const $2015f24f5be0bafb$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor.bind(Object);
const $2015f24f5be0bafb$var$getPrototypeOf = Object.getPrototypeOf.bind(Object);
const $2015f24f5be0bafb$var$objectPrototype = Object.prototype;
function $2015f24f5be0bafb$export$6c1f0397687d8b2(targetComponent, sourceComponent, excludelist) {
    if (typeof sourceComponent !== "string") {
        if ($2015f24f5be0bafb$var$objectPrototype) {
            const inheritedComponent = $2015f24f5be0bafb$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $2015f24f5be0bafb$var$objectPrototype) $2015f24f5be0bafb$export$6c1f0397687d8b2(targetComponent, inheritedComponent);
        }
        let keys = $2015f24f5be0bafb$var$getOwnPropertyNames(sourceComponent);
        if ($2015f24f5be0bafb$var$getOwnPropertySymbols) keys = keys.concat($2015f24f5be0bafb$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $2015f24f5be0bafb$var$getStatics(targetComponent);
        const sourceStatics = $2015f24f5be0bafb$var$getStatics(sourceComponent);
        for (const key of keys)if (!$2015f24f5be0bafb$var$KNOWN_STATICS[key] && true && !sourceStatics?.[key] && !targetStatics?.[key] && !$2015f24f5be0bafb$var$getOwnPropertyDescriptor(targetComponent, key)) {
            const descriptor = $2015f24f5be0bafb$var$getOwnPropertyDescriptor(sourceComponent, key);
            if (descriptor) try {
                $2015f24f5be0bafb$var$defineProperty(targetComponent, key, descriptor);
            } catch (_e) {}
        }
    }
    return targetComponent;
}


const $eeb2a38f5ea169f2$export$6ef4c0367e27f2d5 = "unknown";
class $eeb2a38f5ea169f2$export$e2c29f18771995cb extends $5FkrB.Component {
    constructor(props){
        super(props);
        const { name: name, disabled: disabled = false } = this.props;
        if (disabled) return;
        this._mountSpan = (0, $b244ff70a28cf637$exports.startInactiveSpan)({
            name: `<${name}>`,
            onlyIfParent: true,
            op: (0, $4a33d92877504aad$export$2c5aa1bf688e9ea1),
            attributes: {
                [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: "auto.ui.react.profiler",
                "ui.component_name": name
            }
        });
    }
    // If a component mounted, we can finish the mount activity.
    componentDidMount() {
        if (this._mountSpan) this._mountSpan.end();
    }
    shouldComponentUpdate({ updateProps: updateProps, includeUpdates: includeUpdates = true }) {
        if (includeUpdates && this._mountSpan && updateProps !== this.props.updateProps) {
            const changedProps = Object.keys(updateProps).filter((k)=>updateProps[k] !== this.props.updateProps[k]);
            if (changedProps.length > 0) {
                const now = (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
                this._updateSpan = (0, $c9161b67125aefc1$export$e57ac09b143d92a2)(this._mountSpan, ()=>{
                    return (0, $b244ff70a28cf637$exports.startInactiveSpan)({
                        name: `<${this.props.name}>`,
                        onlyIfParent: true,
                        op: (0, $4a33d92877504aad$export$ee0f1075b9437852),
                        startTime: now,
                        attributes: {
                            [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: "auto.ui.react.profiler",
                            "ui.component_name": this.props.name,
                            "ui.react.changed_props": changedProps
                        }
                    });
                });
            }
        }
        return true;
    }
    componentDidUpdate() {
        if (this._updateSpan) {
            this._updateSpan.end();
            this._updateSpan = void 0;
        }
    }
    // If a component is unmounted, we can say it is no longer on the screen.
    // This means we can finish the span representing the component render.
    componentWillUnmount() {
        const endTimestamp = (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
        const { name: name, includeRender: includeRender = true } = this.props;
        if (this._mountSpan && includeRender) {
            const startTime = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(this._mountSpan).timestamp;
            (0, $c9161b67125aefc1$export$e57ac09b143d92a2)(this._mountSpan, ()=>{
                const renderSpan = (0, $b244ff70a28cf637$exports.startInactiveSpan)({
                    onlyIfParent: true,
                    name: `<${name}>`,
                    op: (0, $4a33d92877504aad$export$a5a94ea2f791dca1),
                    startTime: startTime,
                    attributes: {
                        [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: "auto.ui.react.profiler",
                        "ui.component_name": name
                    }
                });
                if (renderSpan) renderSpan.end(endTimestamp);
            });
        }
    }
    render() {
        return this.props.children;
    }
}
Object.assign($eeb2a38f5ea169f2$export$e2c29f18771995cb, {
    defaultProps: {
        disabled: false,
        includeRender: true,
        includeUpdates: true
    }
});
function $eeb2a38f5ea169f2$export$e1e354213dd1a8a7(WrappedComponent, options) {
    const componentDisplayName = options?.name || WrappedComponent.displayName || WrappedComponent.name || $eeb2a38f5ea169f2$export$6ef4c0367e27f2d5;
    const Wrapped = (props)=>/* @__PURE__ */ $5FkrB.createElement($eeb2a38f5ea169f2$export$e2c29f18771995cb, {
            ...options,
            name: componentDisplayName,
            updateProps: props
        }, /* @__PURE__ */ $5FkrB.createElement(WrappedComponent, {
            ...props
        }));
    Wrapped.displayName = `profiler(${componentDisplayName})`;
    (0, $2015f24f5be0bafb$export$6c1f0397687d8b2)(Wrapped, WrappedComponent);
    return Wrapped;
}
function $eeb2a38f5ea169f2$export$972a52cbfaf8cf13(name, options = {
    disabled: false,
    hasRenderSpan: true
}) {
    const [mountSpan] = $5FkrB.useState(()=>{
        if (options?.disabled) return void 0;
        return (0, $b244ff70a28cf637$exports.startInactiveSpan)({
            name: `<${name}>`,
            onlyIfParent: true,
            op: (0, $4a33d92877504aad$export$2c5aa1bf688e9ea1),
            attributes: {
                [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: "auto.ui.react.profiler",
                "ui.component_name": name
            }
        });
    });
    $5FkrB.useEffect(()=>{
        if (mountSpan) mountSpan.end();
        return ()=>{
            if (mountSpan && options.hasRenderSpan) {
                const startTime = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(mountSpan).timestamp;
                const endTimestamp = (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
                const renderSpan = (0, $b244ff70a28cf637$exports.startInactiveSpan)({
                    name: `<${name}>`,
                    onlyIfParent: true,
                    op: (0, $4a33d92877504aad$export$a5a94ea2f791dca1),
                    startTime: startTime,
                    attributes: {
                        [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: "auto.ui.react.profiler",
                        "ui.component_name": name
                    }
                });
                if (renderSpan) renderSpan.end(endTimestamp);
            }
        };
    }, []);
}





var $5FkrB = parcelRequire("5FkrB");
const $0ee57f62053fbbae$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;




const $d86fddd54af16059$export$6ef4c0367e27f2d5 = "unknown";
const $d86fddd54af16059$var$INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
class $d86fddd54af16059$export$e926676385687eaf extends $5FkrB.Component {
    constructor(props){
        super(props);
        this.state = $d86fddd54af16059$var$INITIAL_STATE;
        this._openFallbackReportDialog = true;
        const client = (0, $b244ff70a28cf637$exports.getClient)();
        if (client && props.showDialog) {
            this._openFallbackReportDialog = false;
            this._cleanupHook = client.on("afterSendEvent", (event)=>{
                if (!event.type && this._lastEventId && event.event_id === this._lastEventId) (0, $c145e0c6ce486f3a$export$3a8fd680da42627b)({
                    ...props.dialogOptions,
                    eventId: this._lastEventId
                });
            });
        }
    }
    componentDidCatch(error, errorInfo) {
        const { componentStack: componentStack } = errorInfo;
        const { beforeCapture: beforeCapture, onError: onError, showDialog: showDialog, dialogOptions: dialogOptions } = this.props;
        (0, $b244ff70a28cf637$exports.withScope)((scope)=>{
            if (beforeCapture) beforeCapture(scope, error, componentStack);
            const handled = this.props.handled != null ? this.props.handled : !!this.props.fallback;
            const eventId = (0, $d73ec427c982e9ee$export$270be4195468cda9)(error, errorInfo, {
                mechanism: {
                    handled: handled,
                    type: "auto.function.react.error_boundary"
                }
            });
            if (onError) onError(error, componentStack, eventId);
            if (showDialog) {
                this._lastEventId = eventId;
                if (this._openFallbackReportDialog) (0, $c145e0c6ce486f3a$export$3a8fd680da42627b)({
                    ...dialogOptions,
                    eventId: eventId
                });
            }
            this.setState({
                error: error,
                componentStack: componentStack,
                eventId: eventId
            });
        });
    }
    componentDidMount() {
        const { onMount: onMount } = this.props;
        if (onMount) onMount();
    }
    componentWillUnmount() {
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) {
            if (this.state === $d86fddd54af16059$var$INITIAL_STATE) onUnmount(null, null, null);
            else onUnmount(error, componentStack, eventId);
        }
        if (this._cleanupHook) {
            this._cleanupHook();
            this._cleanupHook = void 0;
        }
    }
    resetErrorBoundary() {
        const { onReset: onReset } = this.props;
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        if (onReset) onReset(error, componentStack, eventId);
        this.setState($d86fddd54af16059$var$INITIAL_STATE);
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const state = this.state;
        if (state.componentStack === null) return typeof children === "function" ? children() : children;
        const element = typeof fallback === "function" ? $5FkrB.createElement(fallback, {
            error: state.error,
            componentStack: state.componentStack,
            resetError: ()=>this.resetErrorBoundary(),
            eventId: state.eventId
        }) : fallback;
        if ($5FkrB.isValidElement(element)) return element;
        if (fallback) (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn("fallback did not produce a valid ReactElement");
        return null;
    }
}
function $d86fddd54af16059$export$f0c7a449e0cfaec7(WrappedComponent, errorBoundaryOptions) {
    const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || $d86fddd54af16059$export$6ef4c0367e27f2d5;
    const Wrapped = $5FkrB.memo((props)=>/* @__PURE__ */ $5FkrB.createElement($d86fddd54af16059$export$e926676385687eaf, {
            ...errorBoundaryOptions
        }, /* @__PURE__ */ $5FkrB.createElement(WrappedComponent, {
            ...props
        })));
    Wrapped.displayName = `errorBoundary(${componentDisplayName})`;
    (0, $2015f24f5be0bafb$export$6c1f0397687d8b2)(Wrapped, WrappedComponent);
    return Wrapped;
}



const $18b37302a7d113fe$var$ACTION_BREADCRUMB_CATEGORY = "redux.action";
const $18b37302a7d113fe$var$ACTION_BREADCRUMB_TYPE = "info";
const $18b37302a7d113fe$var$defaultOptions = {
    attachReduxState: true,
    actionTransformer: (action)=>action,
    stateTransformer: (state)=>state || null
};
function $18b37302a7d113fe$export$c4506dd2040faa8a(enhancerOptions) {
    const options = {
        ...$18b37302a7d113fe$var$defaultOptions,
        ...enhancerOptions
    };
    return (next)=>(reducer, initialState)=>{
            options.attachReduxState && (0, $b244ff70a28cf637$exports.getGlobalScope)().addEventProcessor((event, hint)=>{
                try {
                    if (event.type === void 0 && event.contexts.state.state.type === "redux") hint.attachments = [
                        ...hint.attachments || [],
                        // @ts-expect-error try catch to reduce bundle size
                        {
                            filename: "redux_state.json",
                            data: JSON.stringify(event.contexts.state.state.value)
                        }
                    ];
                } catch  {}
                return event;
            });
            function sentryWrapReducer(reducer2) {
                return (state, action)=>{
                    const newState = reducer2(state, action);
                    const scope = (0, $b244ff70a28cf637$exports.getCurrentScope)();
                    const transformedAction = options.actionTransformer(action);
                    if (typeof transformedAction !== "undefined" && transformedAction !== null) (0, $b244ff70a28cf637$exports.addBreadcrumb)({
                        category: $18b37302a7d113fe$var$ACTION_BREADCRUMB_CATEGORY,
                        data: transformedAction,
                        type: $18b37302a7d113fe$var$ACTION_BREADCRUMB_TYPE
                    });
                    const transformedState = options.stateTransformer(newState);
                    if (typeof transformedState !== "undefined" && transformedState !== null) {
                        const client = (0, $b244ff70a28cf637$exports.getClient)();
                        const options2 = client?.getOptions();
                        const normalizationDepth = options2?.normalizeDepth || 3;
                        const newStateContext = {
                            state: {
                                type: "redux",
                                value: transformedState
                            }
                        };
                        (0, $b244ff70a28cf637$exports.setNormalizationDepthOverrideHint)(newStateContext, 3 + // 3 layers for `state.value.transformedState`
                        normalizationDepth);
                        scope.setContext("state", newStateContext);
                    } else scope.setContext("state", null);
                    const { configureScopeWithState: configureScopeWithState } = options;
                    if (typeof configureScopeWithState === "function") configureScopeWithState(scope, newState);
                    return newState;
                };
            }
            const store = next(sentryWrapReducer(reducer), initialState);
            store.replaceReducer = new Proxy(store.replaceReducer, {
                apply: function(target, thisArg, args) {
                    target.apply(thisArg, [
                        sentryWrapReducer(args[0])
                    ]);
                }
            });
            return store;
        };
}





var $3tmPs = parcelRequire("3tmPs");
function $31664e4a36abe457$export$8a5d05e8905d7257(options) {
    const integration = (0, $7b5f2a588355dc11$export$b4109253475213e9)({
        ...options,
        instrumentPageLoad: false,
        instrumentNavigation: false
    });
    const { history: history, routes: routes, match: match, instrumentPageLoad: instrumentPageLoad = true, instrumentNavigation: instrumentNavigation = true } = options;
    return {
        ...integration,
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            if (instrumentPageLoad && (0, $e62dec891f31852b$export$56d8a8a25bd48b81).location) $31664e4a36abe457$var$normalizeTransactionName(routes, (0, $e62dec891f31852b$export$56d8a8a25bd48b81).location, match, (localName, source = "url")=>{
                (0, $7b5f2a588355dc11$export$aa44a07f82af519f)(client, {
                    name: localName,
                    attributes: {
                        [(0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "pageload",
                        [(0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.pageload.react.reactrouter_v3",
                        [(0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: source,
                        ...source === "route" && {
                            [(0, $3tmPs.URL_TEMPLATE)]: localName
                        }
                    }
                });
            });
            if (instrumentNavigation && history.listen) history.listen((location)=>{
                if (location.action === "PUSH" || location.action === "POP") $31664e4a36abe457$var$normalizeTransactionName(routes, location, match, (localName, source = "url")=>{
                    (0, $7b5f2a588355dc11$export$7d159749bd9969ad)(client, {
                        name: localName,
                        attributes: {
                            [(0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "navigation",
                            [(0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.navigation.react.reactrouter_v3",
                            [(0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: source,
                            ...source === "route" && {
                                [(0, $3tmPs.URL_TEMPLATE)]: localName
                            }
                        }
                    });
                });
            });
        }
    };
}
function $31664e4a36abe457$var$normalizeTransactionName(appRoutes, location, match, callback) {
    let name = location.pathname;
    match({
        location: location,
        routes: appRoutes
    }, (error, _redirectLocation, renderProps)=>{
        if (error || !renderProps) return callback(name);
        const routePath = $31664e4a36abe457$var$getRouteStringFromRoutes(renderProps.routes || []);
        if (routePath.length === 0 || routePath === "/*") return callback(name);
        name = routePath;
        return callback(name, "route");
    });
}
function $31664e4a36abe457$var$getRouteStringFromRoutes(routes) {
    if (!Array.isArray(routes) || routes.length === 0) return "";
    const routesWithPaths = routes.filter((route)=>!!route.path);
    let index = -1;
    for(let x = routesWithPaths.length - 1; x >= 0; x--){
        const route = routesWithPaths[x];
        if (route.path?.startsWith("/")) {
            index = x;
            break;
        }
    }
    return routesWithPaths.slice(index).reduce((acc, { path: path })=>{
        const pathSegment = acc === "/" || acc === "" ? path : `/${path}`;
        return `${acc}${pathSegment}`;
    }, "");
}





var $3tmPs = parcelRequire("3tmPs");
function $9351852664295212$export$6405014438b98f22(router, options = {}) {
    const castRouterInstance = router;
    const browserTracingIntegrationInstance = (0, $7b5f2a588355dc11$export$b4109253475213e9)({
        ...options,
        instrumentNavigation: false,
        instrumentPageLoad: false
    });
    const { instrumentPageLoad: instrumentPageLoad = true, instrumentNavigation: instrumentNavigation = true } = options;
    return {
        ...browserTracingIntegrationInstance,
        afterAllSetup (client) {
            browserTracingIntegrationInstance.afterAllSetup(client);
            const resolveRouteMatch = (pathname, search)=>{
                const matchedRoutes = castRouterInstance.matchRoutes(pathname, search, {
                    preload: false,
                    throwOnError: false
                });
                const lastMatch = matchedRoutes[matchedRoutes.length - 1];
                return lastMatch?.routeId !== "__root__" ? lastMatch : void 0;
            };
            const applyRouteMatch = (span, match, toLocation, fallbackName)=>{
                span.updateName(match ? match.routeId : fallbackName);
                span.setAttribute((0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), match ? "route" : "url");
                span.setAttributes({
                    ...match && {
                        [(0, $3tmPs.URL_TEMPLATE)]: match.routeId
                    },
                    ...$9351852664295212$var$locationToSpanUrlAttributes(castRouterInstance, toLocation),
                    ...$9351852664295212$var$routeMatchToParamSpanAttributes(match)
                });
            };
            const initialWindowLocation = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).location;
            if (instrumentPageLoad && initialWindowLocation) {
                const initialRouterLocation = castRouterInstance.state?.location;
                const routeMatch = initialRouterLocation ? resolveRouteMatch(initialRouterLocation.pathname, initialRouterLocation.search) : resolveRouteMatch(initialWindowLocation.pathname, castRouterInstance.options.parseSearch(initialWindowLocation.search));
                const pageloadSpan = (0, $7b5f2a588355dc11$export$aa44a07f82af519f)(client, {
                    name: routeMatch ? routeMatch.routeId : initialWindowLocation.pathname,
                    attributes: {
                        [(0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "pageload",
                        [(0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.pageload.react.tanstack_router",
                        [(0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: routeMatch ? "route" : "url",
                        ...routeMatch && {
                            [(0, $3tmPs.URL_TEMPLATE)]: routeMatch.routeId
                        },
                        ...$9351852664295212$var$routeMatchToParamSpanAttributes(routeMatch)
                    }
                });
                const unsubscribePageloadResolved = castRouterInstance.subscribe("onResolved", (onResolvedArgs)=>{
                    unsubscribePageloadResolved();
                    if (!pageloadSpan) return;
                    const { toLocation: toLocation } = onResolvedArgs;
                    const resolvedMatch = resolveRouteMatch(toLocation.pathname, toLocation.search);
                    applyRouteMatch(pageloadSpan, resolvedMatch, toLocation, toLocation.pathname);
                });
            }
            if (instrumentNavigation) {
                let inFlightNavigationSpan;
                castRouterInstance.subscribe("onBeforeLoad", (onBeforeLoadArgs)=>{
                    const { toLocation: toLocation, fromLocation: fromLocation } = onBeforeLoadArgs;
                    if (!fromLocation || toLocation.state === fromLocation.state) return;
                    const routeMatch = resolveRouteMatch(toLocation.pathname, toLocation.search);
                    const fallbackName = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).location?.pathname || toLocation.pathname;
                    if (inFlightNavigationSpan) {
                        applyRouteMatch(inFlightNavigationSpan, routeMatch, toLocation, fallbackName);
                        return;
                    }
                    inFlightNavigationSpan = (0, $7b5f2a588355dc11$export$7d159749bd9969ad)(client, {
                        name: routeMatch ? routeMatch.routeId : fallbackName,
                        attributes: {
                            [(0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "navigation",
                            [(0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.navigation.react.tanstack_router",
                            [(0, $b244ff70a28cf637$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: routeMatch ? "route" : "url",
                            ...routeMatch && {
                                [(0, $3tmPs.URL_TEMPLATE)]: routeMatch.routeId
                            },
                            ...$9351852664295212$var$routeMatchToParamSpanAttributes(routeMatch)
                        }
                    }, {
                        url: $9351852664295212$var$locationToAbsoluteUrl(castRouterInstance, toLocation)
                    });
                });
                castRouterInstance.subscribe("onResolved", (onResolvedArgs)=>{
                    const span = inFlightNavigationSpan;
                    inFlightNavigationSpan = void 0;
                    if (!span) return;
                    const { toLocation: toLocation } = onResolvedArgs;
                    const resolvedMatch = resolveRouteMatch(toLocation.pathname, toLocation.search);
                    if (resolvedMatch) applyRouteMatch(span, resolvedMatch, toLocation, (0, $e62dec891f31852b$export$56d8a8a25bd48b81).location?.pathname || toLocation.pathname);
                });
            }
        }
    };
}
function $9351852664295212$var$locationToAbsoluteUrl(router, location) {
    const search = router.options.stringifySearch?.(location.search) ?? "";
    const pathWithSearch = `${location.pathname}${search && search !== "?" ? search : ""}`;
    return (0, $fd75502b1c3baf49$export$8ca4f6d95250b4ec)(pathWithSearch);
}
function $9351852664295212$var$locationToSpanUrlAttributes(router, location) {
    const absoluteUrl = $9351852664295212$var$locationToAbsoluteUrl(router, location);
    return {
        [(0, $3tmPs.URL_PATH)]: location.pathname,
        [(0, $3tmPs.URL_FULL)]: absoluteUrl
    };
}
function $9351852664295212$var$routeMatchToParamSpanAttributes(match) {
    if (!match) return {};
    const paramAttributes = {};
    Object.entries(match.params).forEach(([key, value])=>{
        paramAttributes[`url.path.params.${key}`] = value;
        paramAttributes[`${0, $3tmPs.URL_PATH_PARAMETER_KEY_BASE}.${key}`] = value;
        paramAttributes[`${0, $3tmPs.PARAMS_KEY_BASE}.${key}`] = value;
    });
    return paramAttributes;
}





var $5FkrB = parcelRequire("5FkrB");


var $3tmPs = parcelRequire("3tmPs");
function $19a7bc5e65e39b8b$export$474cac1fc5ec6ff8(options) {
    const integration = (0, $7b5f2a588355dc11$export$b4109253475213e9)({
        ...options,
        instrumentPageLoad: false,
        instrumentNavigation: false
    });
    const { history: history, routes: routes, matchPath: matchPath, instrumentPageLoad: instrumentPageLoad = true, instrumentNavigation: instrumentNavigation = true } = options;
    return {
        ...integration,
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            $19a7bc5e65e39b8b$var$instrumentReactRouter(client, instrumentPageLoad, instrumentNavigation, history, "reactrouter_v4", routes, matchPath);
        }
    };
}
function $19a7bc5e65e39b8b$export$1c913d0c067ca14f(options) {
    const integration = (0, $7b5f2a588355dc11$export$b4109253475213e9)({
        ...options,
        instrumentPageLoad: false,
        instrumentNavigation: false
    });
    const { history: history, routes: routes, matchPath: matchPath, instrumentPageLoad: instrumentPageLoad = true, instrumentNavigation: instrumentNavigation = true } = options;
    return {
        ...integration,
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            $19a7bc5e65e39b8b$var$instrumentReactRouter(client, instrumentPageLoad, instrumentNavigation, history, "reactrouter_v5", routes, matchPath);
        }
    };
}
function $19a7bc5e65e39b8b$var$instrumentReactRouter(client, instrumentPageLoad, instrumentNavigation, history, instrumentationName, allRoutes = [], matchPath) {
    function getInitPathName() {
        if (history.location) return history.location.pathname;
        if ((0, $e62dec891f31852b$export$56d8a8a25bd48b81).location) return (0, $e62dec891f31852b$export$56d8a8a25bd48b81).location.pathname;
        return void 0;
    }
    function normalizeTransactionName(pathname) {
        if (allRoutes.length === 0 || !matchPath) return [
            pathname,
            "url"
        ];
        const branches = $19a7bc5e65e39b8b$var$matchRoutes(allRoutes, pathname, matchPath);
        for (const branch of branches){
            if (branch.match.isExact) return [
                branch.match.path,
                "route"
            ];
        }
        return [
            pathname,
            "url"
        ];
    }
    if (instrumentPageLoad) {
        const initPathName = getInitPathName();
        if (initPathName) {
            const [name, source] = normalizeTransactionName(initPathName);
            (0, $7b5f2a588355dc11$export$aa44a07f82af519f)(client, {
                name: name,
                attributes: {
                    [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: "pageload",
                    [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: `auto.pageload.react.${instrumentationName}`,
                    [(0, $f337c80285f06f80$export$d7a7d984b0791405)]: source,
                    ...source === "route" && {
                        [(0, $3tmPs.URL_TEMPLATE)]: name
                    }
                }
            });
        }
    }
    if (instrumentNavigation && history.listen) history.listen((location, action)=>{
        if (action && (action === "PUSH" || action === "POP")) {
            const [name, source] = normalizeTransactionName(location.pathname);
            (0, $7b5f2a588355dc11$export$7d159749bd9969ad)(client, {
                name: name,
                attributes: {
                    [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: "navigation",
                    [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: `auto.navigation.react.${instrumentationName}`,
                    [(0, $f337c80285f06f80$export$d7a7d984b0791405)]: source,
                    ...source === "route" && {
                        [(0, $3tmPs.URL_TEMPLATE)]: name
                    }
                }
            });
        }
    });
}
function $19a7bc5e65e39b8b$var$matchRoutes(routes, pathname, matchPath, branch = []) {
    routes.some((route)=>{
        const match = route.path ? matchPath(pathname, route) : branch.length ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        branch[branch.length - 1].match : $19a7bc5e65e39b8b$var$computeRootMatch(pathname);
        if (match) {
            branch.push({
                route: route,
                match: match
            });
            if (route.routes) $19a7bc5e65e39b8b$var$matchRoutes(route.routes, pathname, matchPath, branch);
        }
        return !!match;
    });
    return branch;
}
function $19a7bc5e65e39b8b$var$computeRootMatch(pathname) {
    return {
        path: "/",
        url: "/",
        params: {},
        isExact: pathname === "/"
    };
}
function $19a7bc5e65e39b8b$export$51a414dfd89dd222(Route) {
    const componentDisplayName = Route.displayName || Route.name;
    const WrappedRoute = (props)=>{
        if (props?.computedMatch?.isExact) {
            const route = props.computedMatch.path;
            const activeRootSpan = $19a7bc5e65e39b8b$var$getActiveRootSpan();
            (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().setTransactionName(route);
            if (activeRootSpan) {
                activeRootSpan.updateName(route);
                activeRootSpan.setAttributes({
                    [(0, $f337c80285f06f80$export$d7a7d984b0791405)]: "route",
                    [(0, $3tmPs.URL_TEMPLATE)]: route
                });
            }
        }
        return /* @__PURE__ */ $5FkrB.createElement(Route, {
            ...props
        });
    };
    WrappedRoute.displayName = `sentryRoute(${componentDisplayName})`;
    (0, $2015f24f5be0bafb$export$6c1f0397687d8b2)(WrappedRoute, Route);
    return WrappedRoute;
}
function $19a7bc5e65e39b8b$var$getActiveRootSpan() {
    const span = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
    const rootSpan = span && (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(span);
    if (!rootSpan) return void 0;
    const op = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(rootSpan).op;
    return op === "navigation" || op === "pageload" ? rootSpan : void 0;
}





var $5FkrB = parcelRequire("5FkrB");









function $875b239877162636$export$7d73ab767c2c99ca(pathname, basename) {
    if (!basename || basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return pathname;
    const startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    const nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return pathname;
    return pathname.slice(startIndex) || "/";
}
const $875b239877162636$var$SORTED_MANIFEST_CACHE = /* @__PURE__ */ new WeakMap();
function $875b239877162636$export$b350ee9894336a9c(pathname, manifest, basename) {
    if (!pathname || !manifest?.length) return null;
    const normalizedPathname = basename ? $875b239877162636$export$7d73ab767c2c99ca(pathname, basename) : pathname;
    let sorted = $875b239877162636$var$SORTED_MANIFEST_CACHE.get(manifest);
    if (!sorted) {
        sorted = $875b239877162636$var$sortBySpecificity(manifest);
        $875b239877162636$var$SORTED_MANIFEST_CACHE.set(manifest, sorted);
        (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("[React Router] Sorted route manifest by specificity:", sorted.length, "patterns");
    }
    for (const pattern of sorted)if ($875b239877162636$var$matchesPattern(normalizedPathname, pattern)) {
        (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("[React Router] Matched pathname", normalizedPathname, "to pattern", pattern);
        return pattern;
    }
    (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).log("[React Router] No manifest match found for pathname:", normalizedPathname);
    return null;
}
function $875b239877162636$var$matchesPattern(pathname, pattern) {
    if (pattern === "/") return pathname === "/" || pathname === "";
    const pathSegments = $875b239877162636$var$splitPath(pathname);
    const patternSegments = $875b239877162636$var$splitPath(pattern);
    const hasWildcard = patternSegments.length > 0 && patternSegments[patternSegments.length - 1] === "*";
    if (hasWildcard) {
        const patternSegmentsWithoutWildcard = patternSegments.slice(0, -1);
        if (pathSegments.length < patternSegmentsWithoutWildcard.length) return false;
        for (const [i, patternSegment] of patternSegmentsWithoutWildcard.entries()){
            if (!$875b239877162636$var$segmentMatches(pathSegments[i], patternSegment)) return false;
        }
        return true;
    }
    if (pathSegments.length !== patternSegments.length) return false;
    for (const [i, patternSegment] of patternSegments.entries()){
        if (!$875b239877162636$var$segmentMatches(pathSegments[i], patternSegment)) return false;
    }
    return true;
}
function $875b239877162636$var$segmentMatches(pathSegment, patternSegment) {
    if (pathSegment === void 0 || patternSegment === void 0) return false;
    if ($875b239877162636$var$PARAM_RE.test(patternSegment)) return true;
    return pathSegment === patternSegment;
}
function $875b239877162636$var$splitPath(path) {
    return path.split("/").filter(Boolean);
}
const $875b239877162636$var$PARAM_RE = /^:[\w-]+$/;
const $875b239877162636$var$STATIC_SEGMENT_SCORE = 10;
const $875b239877162636$var$DYNAMIC_SEGMENT_SCORE = 3;
const $875b239877162636$var$EMPTY_SEGMENT_SCORE = 1;
const $875b239877162636$var$SPLAT_PENALTY = -2;
function $875b239877162636$var$computeScore(pattern) {
    const segments = pattern.split("/");
    let score = segments.length;
    if (segments.includes("*")) score += $875b239877162636$var$SPLAT_PENALTY;
    for (const segment of segments){
        if (segment === "*") continue;
        else if ($875b239877162636$var$PARAM_RE.test(segment)) score += $875b239877162636$var$DYNAMIC_SEGMENT_SCORE;
        else if (segment === "") score += $875b239877162636$var$EMPTY_SEGMENT_SCORE;
        else score += $875b239877162636$var$STATIC_SEGMENT_SCORE;
    }
    return score;
}
function $875b239877162636$var$sortBySpecificity(manifest) {
    return [
        ...manifest
    ].sort((a, b)=>{
        const aScore = $875b239877162636$var$computeScore(a);
        const bScore = $875b239877162636$var$computeScore(b);
        return bScore - aScore;
    });
}


let $4487fbe2e1371231$var$_matchRoutes;
let $4487fbe2e1371231$var$_stripBasename = false;
const $4487fbe2e1371231$var$_navigationContextStack = [];
const $4487fbe2e1371231$var$MAX_CONTEXT_STACK_SIZE = 10;
function $4487fbe2e1371231$export$49f239a397357a7c(targetPath, span) {
    const token = {};
    if ($4487fbe2e1371231$var$_navigationContextStack.length >= $4487fbe2e1371231$var$MAX_CONTEXT_STACK_SIZE) {
        (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $b244ff70a28cf637$exports.debug).warn("[React Router] Navigation context stack overflow - removing oldest context");
        $4487fbe2e1371231$var$_navigationContextStack.shift();
    }
    $4487fbe2e1371231$var$_navigationContextStack.push({
        token: token,
        targetPath: targetPath,
        span: span
    });
    return token;
}
function $4487fbe2e1371231$export$44ec4f5e487fad8c(token) {
    const top = $4487fbe2e1371231$var$_navigationContextStack[$4487fbe2e1371231$var$_navigationContextStack.length - 1];
    if (top?.token === token) $4487fbe2e1371231$var$_navigationContextStack.pop();
}
function $4487fbe2e1371231$export$c51ee4fdd2c5321d() {
    const length = $4487fbe2e1371231$var$_navigationContextStack.length;
    return length > 0 ? $4487fbe2e1371231$var$_navigationContextStack[length - 1] ?? null : null;
}
function $4487fbe2e1371231$export$d5deab901a3788fa(matchRoutes, stripBasename = false) {
    $4487fbe2e1371231$var$_matchRoutes = matchRoutes;
    $4487fbe2e1371231$var$_stripBasename = stripBasename;
}
function $4487fbe2e1371231$var$pickPath(match) {
    return $4487fbe2e1371231$var$trimWildcard(match.route.path || "");
}
function $4487fbe2e1371231$var$pickSplat(match) {
    return match.params["*"] || "";
}
function $4487fbe2e1371231$var$trimWildcard(path) {
    return path[path.length - 1] === "*" ? path.slice(0, -1) : path;
}
function $4487fbe2e1371231$var$trimSlash(path) {
    return path[path.length - 1] === "/" ? path.slice(0, -1) : path;
}
function $4487fbe2e1371231$export$3112bc7a3fd7a30f(path) {
    return path.endsWith("*");
}
function $4487fbe2e1371231$export$73bbd8f1d410fc7c(name) {
    return name.includes("/*") || name.endsWith("*");
}
function $4487fbe2e1371231$export$e45475f5937f105e(path, branch) {
    return $4487fbe2e1371231$export$3112bc7a3fd7a30f(path) && !!branch.route.children?.length || false;
}
function $4487fbe2e1371231$export$2d13d7df6cdaeba4(route) {
    return !!(!route.children && route.element && route.path?.endsWith("/*"));
}
function $4487fbe2e1371231$var$sendIndexPath(pathBuilder, pathname, basename) {
    const reconstructedPath = pathBuilder && pathBuilder.length > 0 ? pathBuilder : $4487fbe2e1371231$var$_stripBasename ? (0, $875b239877162636$export$7d73ab767c2c99ca)(pathname, basename) : pathname;
    let formattedPath = // If the path ends with a wildcard suffix, remove both the slash and the asterisk
    reconstructedPath.slice(-2) === "/*" ? reconstructedPath.slice(0, -2) : reconstructedPath;
    if (formattedPath.length > 1 && formattedPath[formattedPath.length - 1] === "/") formattedPath = formattedPath.slice(0, -1);
    return [
        formattedPath,
        "route"
    ];
}
function $4487fbe2e1371231$export$69dd85280a8d374c(url) {
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
function $4487fbe2e1371231$export$dbbc39b1314b6a40(path) {
    return path[0] === "/" ? path : `/${path}`;
}
function $4487fbe2e1371231$export$c1f7ff5899bfbd37(allRoutes, location) {
    const matchedRoutes = $4487fbe2e1371231$var$_matchRoutes(allRoutes, location);
    if (!matchedRoutes || matchedRoutes.length === 0) return "";
    for (const match of matchedRoutes)if (match.route.path && match.route.path !== "*") {
        const path = $4487fbe2e1371231$var$pickPath(match);
        const strippedPath = (0, $875b239877162636$export$7d73ab767c2c99ca)(location.pathname, $4487fbe2e1371231$export$dbbc39b1314b6a40(match.pathnameBase));
        if (location.pathname === strippedPath) return $4487fbe2e1371231$var$trimSlash(strippedPath);
        return $4487fbe2e1371231$var$trimSlash($4487fbe2e1371231$var$trimSlash(path || "") + $4487fbe2e1371231$export$dbbc39b1314b6a40($4487fbe2e1371231$export$c1f7ff5899bfbd37(allRoutes.filter((route)=>route !== match.route), {
            pathname: strippedPath
        })));
    }
    return "";
}
function $4487fbe2e1371231$var$reconstructNameFromDescendantParent(location, allRoutes, currentName) {
    const descendantParents = allRoutes.filter($4487fbe2e1371231$export$2d13d7df6cdaeba4);
    if (!descendantParents.length) return void 0;
    const matchedParents = $4487fbe2e1371231$var$_matchRoutes(descendantParents, location);
    const parentMatch = matchedParents?.[matchedParents.length - 1];
    if (!parentMatch || !$4487fbe2e1371231$var$pickSplat(parentMatch)) return void 0;
    const parentTemplate = $4487fbe2e1371231$var$trimSlash($4487fbe2e1371231$var$trimWildcard(parentMatch.route.path || ""));
    if (!parentTemplate) return void 0;
    const expectedPrefix = $4487fbe2e1371231$export$dbbc39b1314b6a40(parentTemplate);
    const firstElement = parentTemplate.split("/")[0];
    const hasDynamicLead = firstElement?.startsWith(":") && currentName?.split("/").includes(firstElement);
    if (currentName === expectedPrefix || currentName?.startsWith(`${expectedPrefix}/`) || hasDynamicLead) return void 0;
    const remainingPathname = (0, $875b239877162636$export$7d73ab767c2c99ca)(location.pathname, $4487fbe2e1371231$export$dbbc39b1314b6a40(parentMatch.pathnameBase)) || "/";
    const remainingName = $4487fbe2e1371231$export$c1f7ff5899bfbd37(allRoutes.filter((route)=>route !== parentMatch.route), {
        pathname: remainingPathname
    });
    return remainingName ? $4487fbe2e1371231$export$dbbc39b1314b6a40(`${parentTemplate}${$4487fbe2e1371231$export$dbbc39b1314b6a40(remainingName)}`) : void 0;
}
function $4487fbe2e1371231$export$35be733d25e64e5a(location, routes) {
    const matchedRoutes = $4487fbe2e1371231$var$_matchRoutes(routes, location);
    if (matchedRoutes) for (const match of matchedRoutes){
        if ($4487fbe2e1371231$export$2d13d7df6cdaeba4(match.route) && $4487fbe2e1371231$var$pickSplat(match)) return true;
    }
    return false;
}
function $4487fbe2e1371231$var$getFallbackTransactionName(location, basename) {
    return $4487fbe2e1371231$var$_stripBasename ? (0, $875b239877162636$export$7d73ab767c2c99ca)(location.pathname, basename) : location.pathname || "";
}
function $4487fbe2e1371231$export$b75af9192fcde169(routes, location, branches, basename = "") {
    if (!routes || routes.length === 0) return [
        $4487fbe2e1371231$var$_stripBasename ? (0, $875b239877162636$export$7d73ab767c2c99ca)(location.pathname, basename) : location.pathname,
        "url"
    ];
    if (!branches) return [
        $4487fbe2e1371231$var$getFallbackTransactionName(location, basename),
        "url"
    ];
    let pathBuilder = "";
    for (const branch of branches){
        const route = branch.route;
        if (!route) continue;
        if (route.index) return $4487fbe2e1371231$var$sendIndexPath(pathBuilder, branch.pathname, basename);
        const path = route.path;
        if (!path || $4487fbe2e1371231$export$e45475f5937f105e(path, branch)) continue;
        const newPath = path[0] === "/" || pathBuilder[pathBuilder.length - 1] === "/" ? path : `/${path}`;
        pathBuilder = $4487fbe2e1371231$var$trimSlash(pathBuilder) + $4487fbe2e1371231$export$dbbc39b1314b6a40(newPath);
        if ($4487fbe2e1371231$var$trimSlash(location.pathname) !== $4487fbe2e1371231$var$trimSlash(basename + branch.pathname)) continue;
        if ($4487fbe2e1371231$export$69dd85280a8d374c(pathBuilder) !== $4487fbe2e1371231$export$69dd85280a8d374c(branch.pathname) && !$4487fbe2e1371231$export$3112bc7a3fd7a30f(pathBuilder)) return [
            ($4487fbe2e1371231$var$_stripBasename ? "" : basename) + newPath,
            "route"
        ];
        if ($4487fbe2e1371231$export$e45475f5937f105e(pathBuilder, branch)) pathBuilder = pathBuilder.slice(0, -1);
        return [
            ($4487fbe2e1371231$var$_stripBasename ? "" : basename) + pathBuilder,
            "route"
        ];
    }
    return [
        $4487fbe2e1371231$var$getFallbackTransactionName(location, basename),
        "url"
    ];
}
function $4487fbe2e1371231$export$d0d5aab0e629ad63(location, routes, allRoutes, branches, basename = "", lazyRouteManifest, enableAsyncRouteHandlers) {
    if (enableAsyncRouteHandlers && lazyRouteManifest && lazyRouteManifest.length > 0) {
        const manifestMatch = (0, $875b239877162636$export$b350ee9894336a9c)(location.pathname, lazyRouteManifest, basename);
        if (manifestMatch) return [
            ($4487fbe2e1371231$var$_stripBasename ? "" : basename) + manifestMatch,
            "route"
        ];
    }
    let name;
    let source = "url";
    const isInDescendantRoute = $4487fbe2e1371231$export$35be733d25e64e5a(location, allRoutes);
    if (isInDescendantRoute) {
        name = $4487fbe2e1371231$export$dbbc39b1314b6a40($4487fbe2e1371231$export$c1f7ff5899bfbd37(allRoutes, location));
        source = "route";
    }
    if (!isInDescendantRoute || !name) [name, source] = $4487fbe2e1371231$export$b75af9192fcde169(routes, location, branches, basename);
    const anchoredName = $4487fbe2e1371231$var$reconstructNameFromDescendantParent(location, allRoutes, name);
    if (anchoredName) return [
        anchoredName,
        "route"
    ];
    return [
        name || location.pathname,
        source
    ];
}
function $4487fbe2e1371231$export$6d46479e35ff5f30() {
    const span = (0, $b244ff70a28cf637$exports.getActiveSpan)();
    const rootSpan = span ? (0, $b244ff70a28cf637$exports.getRootSpan)(span) : void 0;
    if (!rootSpan) return void 0;
    const op = (0, $b244ff70a28cf637$exports.spanToJSON)(rootSpan).op;
    return op === "navigation" || op === "pageload" ? rootSpan : void 0;
}


function $eb2165c92b8d4b57$var$captureCurrentLocation() {
    const navContext = (0, $4487fbe2e1371231$export$c51ee4fdd2c5321d)();
    if (navContext) {
        if (navContext.targetPath) return {
            pathname: navContext.targetPath,
            search: "",
            hash: "",
            state: null,
            key: "default"
        };
        return null;
    }
    if (typeof (0, $e62dec891f31852b$export$56d8a8a25bd48b81) !== "undefined") try {
        const windowLocation = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).location;
        if (windowLocation) return {
            pathname: windowLocation.pathname,
            search: windowLocation.search || "",
            hash: windowLocation.hash || "",
            state: null,
            key: "default"
        };
    } catch  {
        (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn("[React Router] Could not access window.location");
    }
    return null;
}
function $eb2165c92b8d4b57$var$captureActiveSpan() {
    const navContext = (0, $4487fbe2e1371231$export$c51ee4fdd2c5321d)();
    if (navContext) return navContext.span;
    return (0, $4487fbe2e1371231$export$6d46479e35ff5f30)();
}
function $eb2165c92b8d4b57$export$ae31fcaba1cddbd8(originalFunction, route, handlerKey, processResolvedRoutes) {
    const proxy = new Proxy(originalFunction, {
        apply (target, thisArg, argArray) {
            const locationAtInvocation = $eb2165c92b8d4b57$var$captureCurrentLocation();
            const spanAtInvocation = $eb2165c92b8d4b57$var$captureActiveSpan();
            const result = target.apply(thisArg, argArray);
            $eb2165c92b8d4b57$export$182dc63b40030b75(result, route, handlerKey, processResolvedRoutes, locationAtInvocation, spanAtInvocation);
            return result;
        }
    });
    (0, $269eeb69635ed414$export$e73679ffaf56810e)(proxy, "__sentry_proxied__", true);
    return proxy;
}
function $eb2165c92b8d4b57$export$182dc63b40030b75(result, route, handlerKey, processResolvedRoutes, currentLocation, capturedSpan) {
    if ((0, $13cf2ed412f405fa$export$f5b060c2914b97c8)(result)) result.then((resolvedRoutes)=>{
        if (Array.isArray(resolvedRoutes)) processResolvedRoutes(resolvedRoutes, route, currentLocation ?? void 0, capturedSpan);
    }).catch((e)=>{
        (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`Error resolving async handler '${handlerKey}' for route`, route, e);
    });
    else if (Array.isArray(result)) processResolvedRoutes(result, route, currentLocation ?? void 0, capturedSpan);
}
function $eb2165c92b8d4b57$export$e9262e29e117b830(route, processResolvedRoutes) {
    if (route.handle && typeof route.handle === "object") for (const key of Object.keys(route.handle)){
        const maybeFn = route.handle[key];
        if (typeof maybeFn === "function" && !maybeFn.__sentry_proxied__) route.handle[key] = $eb2165c92b8d4b57$export$ae31fcaba1cddbd8(maybeFn, route, key, processResolvedRoutes);
    }
    if (Array.isArray(route.children)) for (const child of route.children)$eb2165c92b8d4b57$export$e9262e29e117b830(child, processResolvedRoutes);
}




var $3tmPs = parcelRequire("3tmPs");
let $8097daeff2c3b7c8$var$_useEffect;
let $8097daeff2c3b7c8$var$_useLocation;
let $8097daeff2c3b7c8$var$_useNavigationType;
let $8097daeff2c3b7c8$var$_createRoutesFromChildren;
let $8097daeff2c3b7c8$var$_matchRoutes;
let $8097daeff2c3b7c8$var$_enableAsyncRouteHandlers = false;
let $8097daeff2c3b7c8$var$_lazyRouteTimeout = 3e3;
let $8097daeff2c3b7c8$var$_lazyRouteManifest;
let $8097daeff2c3b7c8$var$_basename = "";
const $8097daeff2c3b7c8$var$CLIENTS_WITH_INSTRUMENT_NAVIGATION = /* @__PURE__ */ new WeakSet();
const $8097daeff2c3b7c8$var$useIsomorphicLayoutEffect = (0, $e62dec891f31852b$export$56d8a8a25bd48b81)?.document ? $5FkrB.useLayoutEffect : $5FkrB.useEffect;
const $8097daeff2c3b7c8$var$activeNavigationSpans = /* @__PURE__ */ new WeakMap();
const $8097daeff2c3b7c8$export$3ef6d4da8160fa32 = /* @__PURE__ */ new Set();
const $8097daeff2c3b7c8$var$pendingLazyRouteLoads = /* @__PURE__ */ new WeakMap();
const $8097daeff2c3b7c8$var$deferredLazyRouteResolvers = /* @__PURE__ */ new WeakMap();
function $8097daeff2c3b7c8$var$scheduleCallback(callback) {
    if ((0, $e62dec891f31852b$export$56d8a8a25bd48b81)?.requestAnimationFrame) return (0, $e62dec891f31852b$export$56d8a8a25bd48b81).requestAnimationFrame(callback);
    return setTimeout(callback, 0);
}
function $8097daeff2c3b7c8$var$cancelScheduledCallback(id) {
    if ((0, $e62dec891f31852b$export$56d8a8a25bd48b81)?.cancelAnimationFrame) (0, $e62dec891f31852b$export$56d8a8a25bd48b81).cancelAnimationFrame(id);
    else clearTimeout(id);
}
function $8097daeff2c3b7c8$export$6da138630728824c(location) {
    return `${location.pathname}${location.search || ""}${location.hash || ""}`;
}
function $8097daeff2c3b7c8$var$isParameterizedRoute(routeName) {
    return routeName.includes(":") || routeName.includes("*");
}
function $8097daeff2c3b7c8$export$74ccc56dfa81ef20(trackedNav, locationKey, proposedName, spanHasEnded) {
    if (!trackedNav) return {
        skip: false,
        shouldUpdate: false
    };
    const isDuplicate = trackedNav.locationKey === locationKey && (trackedNav.isPlaceholder || !spanHasEnded);
    if (isDuplicate) {
        const currentHasWildcard = !!trackedNav.routeName && (0, $4487fbe2e1371231$export$73bbd8f1d410fc7c)(trackedNav.routeName);
        const proposedHasWildcard = (0, $4487fbe2e1371231$export$73bbd8f1d410fc7c)(proposedName);
        const currentIsParameterized = !!trackedNav.routeName && $8097daeff2c3b7c8$var$isParameterizedRoute(trackedNav.routeName);
        const proposedIsParameterized = $8097daeff2c3b7c8$var$isParameterizedRoute(proposedName);
        const isWildcardUpgrade = currentHasWildcard && !proposedHasWildcard;
        const isRawToParameterized = !currentIsParameterized && proposedIsParameterized;
        const isMoreSpecific = proposedName !== trackedNav.routeName && proposedName.length > (trackedNav.routeName?.length || 0) && !proposedHasWildcard;
        const shouldUpdate = !!(trackedNav.routeName && (isWildcardUpgrade || isRawToParameterized || isMoreSpecific));
        return {
            skip: true,
            shouldUpdate: shouldUpdate
        };
    }
    return {
        skip: false,
        shouldUpdate: false
    };
}
function $8097daeff2c3b7c8$export$d443af17fae6e7aa(resolvedRoutes, parentRoute) {
    const existingChildren = parentRoute.children || [];
    const newRoutes = resolvedRoutes.filter((newRoute)=>!existingChildren.some((existing)=>existing === newRoute || newRoute.path && existing.path === newRoute.path || newRoute.id && existing.id === newRoute.id));
    if (newRoutes.length > 0) parentRoute.children = [
        ...existingChildren,
        ...newRoutes
    ];
}
function $8097daeff2c3b7c8$var$trackLazyRouteLoad(span, promise) {
    let promises = $8097daeff2c3b7c8$var$pendingLazyRouteLoads.get(span);
    if (!promises) {
        promises = /* @__PURE__ */ new Set();
        $8097daeff2c3b7c8$var$pendingLazyRouteLoads.set(span, promises);
    }
    promises.add(promise);
    promise.finally(()=>{
        const currentPromises = $8097daeff2c3b7c8$var$pendingLazyRouteLoads.get(span);
        if (currentPromises) currentPromises.delete(promise);
    });
}
function $8097daeff2c3b7c8$var$createDeferredLazyRoutePromise(span) {
    const deferredPromise = new Promise((resolve)=>{
        $8097daeff2c3b7c8$var$deferredLazyRouteResolvers.set(span, resolve);
    });
    $8097daeff2c3b7c8$var$trackLazyRouteLoad(span, deferredPromise);
}
function $8097daeff2c3b7c8$var$resolveDeferredLazyRoutePromise(span) {
    const resolver = $8097daeff2c3b7c8$var$deferredLazyRouteResolvers.get(span);
    if (resolver) {
        resolver();
        $8097daeff2c3b7c8$var$deferredLazyRouteResolvers.delete(span);
        if (span.__sentry_may_have_lazy_routes__) span.__sentry_may_have_lazy_routes__ = false;
    }
}
function $8097daeff2c3b7c8$export$b18942cbaf6837a6(resolvedRoutes, parentRoute, currentLocation = null, capturedSpan) {
    resolvedRoutes.forEach((child)=>{
        $8097daeff2c3b7c8$export$3ef6d4da8160fa32.add(child);
        if ($8097daeff2c3b7c8$var$_enableAsyncRouteHandlers) (0, $eb2165c92b8d4b57$export$e9262e29e117b830)(child, $8097daeff2c3b7c8$export$b18942cbaf6837a6);
    });
    if (parentRoute) $8097daeff2c3b7c8$export$d443af17fae6e7aa(resolvedRoutes, parentRoute);
    const targetSpan = capturedSpan ?? (0, $4487fbe2e1371231$export$6d46479e35ff5f30)();
    if (targetSpan) {
        const spanJson = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(targetSpan);
        if (spanJson.timestamp) {
            (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn("[React Router] Lazy handler resolved after span ended - skipping update");
            return;
        }
        const spanOp = spanJson.op;
        let location = currentLocation;
        if (!location && !capturedSpan) {
            if (typeof (0, $e62dec891f31852b$export$56d8a8a25bd48b81) !== "undefined") {
                const globalLocation = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).location;
                if (globalLocation?.pathname) location = {
                    pathname: globalLocation.pathname
                };
            }
        }
        if (location) {
            if (spanOp === "pageload") $8097daeff2c3b7c8$var$updatePageloadTransaction({
                activeRootSpan: targetSpan,
                location: {
                    pathname: location.pathname
                },
                routes: Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32),
                allRoutes: Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32)
            });
            else if (spanOp === "navigation") $8097daeff2c3b7c8$export$8e00428fd5aa3427(targetSpan, location, Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32), false, $8097daeff2c3b7c8$var$_matchRoutes);
        }
    }
}
function $8097daeff2c3b7c8$export$8e00428fd5aa3427(activeRootSpan, location, allRoutes2, forceUpdate = false, matchRoutes) {
    const spanJson = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(activeRootSpan);
    const currentName = spanJson.description;
    const hasBeenNamed = activeRootSpan?.__sentry_navigation_name_set__;
    const currentNameHasWildcard = currentName && (0, $4487fbe2e1371231$export$73bbd8f1d410fc7c)(currentName);
    const shouldUpdate = !hasBeenNamed || forceUpdate || currentNameHasWildcard;
    if (shouldUpdate && !spanJson.timestamp) {
        const currentBranches = matchRoutes(allRoutes2, location);
        const [name, source] = (0, $4487fbe2e1371231$export$d0d5aab0e629ad63)(location, allRoutes2, allRoutes2, currentBranches || [], $8097daeff2c3b7c8$var$_basename, $8097daeff2c3b7c8$var$_lazyRouteManifest, $8097daeff2c3b7c8$var$_enableAsyncRouteHandlers);
        const currentSource = spanJson.data?.[0, $f337c80285f06f80$export$d7a7d984b0791405];
        const isImprovement = name && (!currentName || // No current name - always set
        !hasBeenNamed && (currentSource !== "route" || source === "route") || // Not finalized - allow unless downgrading route→url
        currentSource !== "route" && source === "route" || // URL → route upgrade
        currentSource === "route" && source === "route" && currentNameHasWildcard);
        if (isImprovement) {
            activeRootSpan.updateName(name);
            activeRootSpan.setAttribute((0, $f337c80285f06f80$export$d7a7d984b0791405), source);
            if (source === "route") activeRootSpan.setAttribute((0, $3tmPs.URL_TEMPLATE), name);
            if (!(0, $4487fbe2e1371231$export$73bbd8f1d410fc7c)(name) && source === "route") (0, $269eeb69635ed414$export$e73679ffaf56810e)(activeRootSpan, "__sentry_navigation_name_set__", true);
        }
    }
}
function $8097daeff2c3b7c8$var$setupRouterSubscription(router, routes, version, basename, activeRootSpan) {
    let isInitialPageloadComplete = false;
    let hasSeenPageloadSpan = !!activeRootSpan && (0, $bb9b6447bf4caedb$export$92d8c23565496537)(activeRootSpan).op === "pageload";
    let hasSeenPopAfterPageload = false;
    let scheduledNavigationHandler = null;
    let lastHandledPathname = null;
    router.subscribe((state)=>{
        if (!isInitialPageloadComplete) {
            const currentRootSpan = (0, $4487fbe2e1371231$export$6d46479e35ff5f30)();
            const isCurrentlyInPageload = currentRootSpan && (0, $bb9b6447bf4caedb$export$92d8c23565496537)(currentRootSpan).op === "pageload";
            if (isCurrentlyInPageload) hasSeenPageloadSpan = true;
            else if (hasSeenPageloadSpan) {
                if (state.historyAction === "POP" && !hasSeenPopAfterPageload) hasSeenPopAfterPageload = true;
                else isInitialPageloadComplete = true;
            }
        }
        const shouldHandleNavigation = state.historyAction === "PUSH" || state.historyAction === "POP" && isInitialPageloadComplete;
        if (shouldHandleNavigation) {
            const currentLocationKey = $8097daeff2c3b7c8$export$6da138630728824c(state.location);
            const navigationHandler = ()=>{
                if (lastHandledPathname === currentLocationKey) return;
                lastHandledPathname = currentLocationKey;
                scheduledNavigationHandler = null;
                $8097daeff2c3b7c8$export$706ad1af8096e280({
                    location: state.location,
                    routes: routes,
                    navigationType: state.historyAction,
                    version: version,
                    basename: basename,
                    allRoutes: Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32)
                });
            };
            if (state.navigation.state !== "idle") {
                if (lastHandledPathname !== currentLocationKey) lastHandledPathname = null;
                if (scheduledNavigationHandler !== null) $8097daeff2c3b7c8$var$cancelScheduledCallback(scheduledNavigationHandler);
                scheduledNavigationHandler = $8097daeff2c3b7c8$var$scheduleCallback(navigationHandler);
            } else {
                if (scheduledNavigationHandler !== null) {
                    $8097daeff2c3b7c8$var$cancelScheduledCallback(scheduledNavigationHandler);
                    scheduledNavigationHandler = null;
                }
                navigationHandler();
            }
        }
    });
}
function $8097daeff2c3b7c8$export$6f08ca2914060d3f(createRouterFunction, version) {
    if (!$8097daeff2c3b7c8$var$_useEffect || !$8097daeff2c3b7c8$var$_useLocation || !$8097daeff2c3b7c8$var$_useNavigationType || !$8097daeff2c3b7c8$var$_matchRoutes) {
        (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`reactRouter${version ? `V${version}` : ""}Instrumentation was unable to wrap the \`createRouter\` function because of one or more missing parameters.`);
        return createRouterFunction;
    }
    return function(routes, opts) {
        $8097daeff2c3b7c8$export$e8ecdda469a42a59(routes);
        if ($8097daeff2c3b7c8$var$_enableAsyncRouteHandlers) for (const route of routes)(0, $eb2165c92b8d4b57$export$e9262e29e117b830)(route, $8097daeff2c3b7c8$export$b18942cbaf6837a6);
        const activeRootSpan = (0, $4487fbe2e1371231$export$6d46479e35ff5f30)();
        const hasPatchRoutesOnNavigation = opts && "patchRoutesOnNavigation" in opts && typeof opts.patchRoutesOnNavigation === "function";
        if (hasPatchRoutesOnNavigation && activeRootSpan) {
            (0, $269eeb69635ed414$export$e73679ffaf56810e)(activeRootSpan, "__sentry_may_have_lazy_routes__", true);
            $8097daeff2c3b7c8$var$createDeferredLazyRoutePromise(activeRootSpan);
        }
        const wrappedOpts = $8097daeff2c3b7c8$var$wrapPatchRoutesOnNavigation(opts, false, activeRootSpan);
        const router = createRouterFunction(routes, wrappedOpts);
        const basename = opts?.basename;
        if (router.state.historyAction === "POP" && activeRootSpan) $8097daeff2c3b7c8$var$updatePageloadTransaction({
            activeRootSpan: activeRootSpan,
            location: router.state.location,
            routes: routes,
            basename: basename,
            allRoutes: Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32)
        });
        $8097daeff2c3b7c8$var$_basename = basename || "";
        $8097daeff2c3b7c8$var$setupRouterSubscription(router, routes, version, basename, activeRootSpan);
        return router;
    };
}
function $8097daeff2c3b7c8$export$ce6d63af7f6f9771(createRouterFunction, version) {
    if (!$8097daeff2c3b7c8$var$_useEffect || !$8097daeff2c3b7c8$var$_useLocation || !$8097daeff2c3b7c8$var$_useNavigationType || !$8097daeff2c3b7c8$var$_matchRoutes) {
        (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`reactRouter${version ? `V${version}` : ""}Instrumentation was unable to wrap the \`createMemoryRouter\` function because of one or more missing parameters.`);
        return createRouterFunction;
    }
    return function(routes, opts) {
        $8097daeff2c3b7c8$export$e8ecdda469a42a59(routes);
        if ($8097daeff2c3b7c8$var$_enableAsyncRouteHandlers) for (const route of routes)(0, $eb2165c92b8d4b57$export$e9262e29e117b830)(route, $8097daeff2c3b7c8$export$b18942cbaf6837a6);
        const memoryActiveRootSpanEarly = (0, $4487fbe2e1371231$export$6d46479e35ff5f30)();
        const hasPatchRoutesOnNavigation = opts && "patchRoutesOnNavigation" in opts && typeof opts.patchRoutesOnNavigation === "function";
        if (hasPatchRoutesOnNavigation && memoryActiveRootSpanEarly) {
            (0, $269eeb69635ed414$export$e73679ffaf56810e)(memoryActiveRootSpanEarly, "__sentry_may_have_lazy_routes__", true);
            $8097daeff2c3b7c8$var$createDeferredLazyRoutePromise(memoryActiveRootSpanEarly);
        }
        const wrappedOpts = $8097daeff2c3b7c8$var$wrapPatchRoutesOnNavigation(opts, true, memoryActiveRootSpanEarly);
        const router = createRouterFunction(routes, wrappedOpts);
        const basename = opts?.basename;
        let initialEntry = void 0;
        const initialEntries = opts?.initialEntries;
        const initialIndex = opts?.initialIndex;
        const hasOnlyOneInitialEntry = initialEntries?.length === 1;
        const hasIndexedEntry = initialIndex !== void 0 && initialEntries?.[initialIndex];
        initialEntry = hasOnlyOneInitialEntry ? initialEntries[0] : hasIndexedEntry ? initialEntries[initialIndex] : void 0;
        const location = initialEntry ? typeof initialEntry === "string" ? {
            pathname: initialEntry
        } : initialEntry : router.state.location;
        const memoryActiveRootSpan = (0, $4487fbe2e1371231$export$6d46479e35ff5f30)();
        if (router.state.historyAction === "POP" && memoryActiveRootSpan) $8097daeff2c3b7c8$var$updatePageloadTransaction({
            activeRootSpan: memoryActiveRootSpan,
            location: location,
            routes: routes,
            basename: basename,
            allRoutes: Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32)
        });
        $8097daeff2c3b7c8$var$_basename = basename || "";
        $8097daeff2c3b7c8$var$setupRouterSubscription(router, routes, version, basename, memoryActiveRootSpan);
        return router;
    };
}
function $8097daeff2c3b7c8$export$7e5bbc7e32f3c098(options, version) {
    const integration = (0, $7b5f2a588355dc11$export$b4109253475213e9)({
        ...options,
        instrumentPageLoad: false,
        instrumentNavigation: false
    });
    const { useEffect: useEffect, useLocation: useLocation, useNavigationType: useNavigationType, createRoutesFromChildren: createRoutesFromChildren, matchRoutes: matchRoutes, stripBasename: stripBasename, enableAsyncRouteHandlers: enableAsyncRouteHandlers = false, instrumentPageLoad: instrumentPageLoad = true, instrumentNavigation: instrumentNavigation = true, lazyRouteTimeout: lazyRouteTimeout, lazyRouteManifest: lazyRouteManifest } = options;
    return {
        ...integration,
        setup (client) {
            integration.setup(client);
            const finalTimeout = options.finalTimeout ?? 3e4;
            const defaultMaxWait = (options.idleTimeout ?? 1e3) * 3;
            const configuredMaxWait = lazyRouteTimeout ?? defaultMaxWait;
            if (configuredMaxWait === Infinity) {
                $8097daeff2c3b7c8$var$_lazyRouteTimeout = finalTimeout;
                (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log("[React Router] lazyRouteTimeout set to Infinity, capping at finalTimeout:", finalTimeout, "ms to prevent indefinite hangs");
            } else if (Number.isNaN(configuredMaxWait)) {
                (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn("[React Router] lazyRouteTimeout must be a number, falling back to default:", defaultMaxWait);
                $8097daeff2c3b7c8$var$_lazyRouteTimeout = defaultMaxWait;
            } else if (configuredMaxWait < 0) {
                (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn("[React Router] lazyRouteTimeout must be non-negative or Infinity, got:", configuredMaxWait, "falling back to:", defaultMaxWait);
                $8097daeff2c3b7c8$var$_lazyRouteTimeout = defaultMaxWait;
            } else $8097daeff2c3b7c8$var$_lazyRouteTimeout = configuredMaxWait;
            $8097daeff2c3b7c8$var$_useEffect = useEffect;
            $8097daeff2c3b7c8$var$_useLocation = useLocation;
            $8097daeff2c3b7c8$var$_useNavigationType = useNavigationType;
            $8097daeff2c3b7c8$var$_matchRoutes = matchRoutes;
            $8097daeff2c3b7c8$var$_createRoutesFromChildren = createRoutesFromChildren;
            $8097daeff2c3b7c8$var$_enableAsyncRouteHandlers = enableAsyncRouteHandlers;
            $8097daeff2c3b7c8$var$_lazyRouteManifest = lazyRouteManifest;
            (0, $4487fbe2e1371231$export$d5deab901a3788fa)(matchRoutes, stripBasename || false);
        },
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            const initPathName = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).location?.pathname;
            if (instrumentPageLoad && initPathName) (0, $7b5f2a588355dc11$export$aa44a07f82af519f)(client, {
                name: initPathName,
                attributes: {
                    [(0, $f337c80285f06f80$export$d7a7d984b0791405)]: "url",
                    [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: "pageload",
                    [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: `auto.pageload.react.reactrouter${version ? `_v${version}` : ""}`
                }
            });
            if (instrumentNavigation) $8097daeff2c3b7c8$var$CLIENTS_WITH_INSTRUMENT_NAVIGATION.add(client);
        }
    };
}
function $8097daeff2c3b7c8$export$3881404ad6870e59(origUseRoutes, version) {
    if (!$8097daeff2c3b7c8$var$_useEffect || !$8097daeff2c3b7c8$var$_useLocation || !$8097daeff2c3b7c8$var$_useNavigationType || !$8097daeff2c3b7c8$var$_matchRoutes) {
        (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn("reactRouterV6Instrumentation was unable to wrap `useRoutes` because of one or more missing parameters.");
        return origUseRoutes;
    }
    const SentryRoutes = (props)=>{
        const isMountRenderPass = $5FkrB.useRef(true);
        const { routes: routes, locationArg: locationArg } = props;
        const Routes = origUseRoutes(routes, locationArg);
        const location = $8097daeff2c3b7c8$var$_useLocation();
        const navigationType = $8097daeff2c3b7c8$var$_useNavigationType();
        const stableLocationParam = typeof locationArg === "string" || locationArg?.pathname ? locationArg : location;
        $8097daeff2c3b7c8$var$useIsomorphicLayoutEffect(()=>{
            const added = $8097daeff2c3b7c8$export$e8ecdda469a42a59(routes);
            return ()=>$8097daeff2c3b7c8$var$removeRoutesFromAllRoutes(added);
        });
        $8097daeff2c3b7c8$var$useIsomorphicLayoutEffect(()=>{
            const normalizedLocation = typeof stableLocationParam === "string" ? {
                pathname: stableLocationParam
            } : stableLocationParam;
            if (isMountRenderPass.current) {
                $8097daeff2c3b7c8$var$updatePageloadTransaction({
                    activeRootSpan: (0, $4487fbe2e1371231$export$6d46479e35ff5f30)(),
                    location: normalizedLocation,
                    routes: routes,
                    allRoutes: Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32)
                });
                isMountRenderPass.current = false;
            } else $8097daeff2c3b7c8$export$706ad1af8096e280({
                location: normalizedLocation,
                routes: routes,
                navigationType: navigationType,
                version: version,
                allRoutes: Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32)
            });
        }, [
            navigationType,
            stableLocationParam
        ]);
        return Routes;
    };
    return (routes, locationArg)=>{
        return /* @__PURE__ */ $5FkrB.createElement(SentryRoutes, {
            routes: routes,
            locationArg: locationArg
        });
    };
}
function $8097daeff2c3b7c8$var$wrapPatchRoutesOnNavigation(opts, isMemoryRouter = false, capturedSpan) {
    if (!opts || !("patchRoutesOnNavigation" in opts) || typeof opts.patchRoutesOnNavigation !== "function") return opts || {};
    const originalPatchRoutes = opts.patchRoutesOnNavigation;
    return {
        ...opts,
        patchRoutesOnNavigation: async (args)=>{
            const targetPath = args?.path;
            const activeRootSpan = (0, $4487fbe2e1371231$export$6d46479e35ff5f30)() ?? capturedSpan;
            if (!isMemoryRouter) {
                const originalPatch = args?.patch;
                const matches = args?.matches;
                if (originalPatch) args.patch = (routeId, children)=>{
                    $8097daeff2c3b7c8$export$e8ecdda469a42a59(children);
                    if (matches && matches.length > 0) {
                        const leafMatch = matches[matches.length - 1];
                        const leafRoute = leafMatch?.route;
                        if (leafRoute) {
                            const matchingRoute = Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32).find((route)=>{
                                const idMatches = route.id !== void 0 && route.id === routeId;
                                const referenceMatches = route === leafRoute;
                                const pathMatches = route.path !== void 0 && leafRoute.path !== void 0 && route.path === leafRoute.path;
                                return idMatches || referenceMatches || pathMatches;
                            });
                            if (matchingRoute) $8097daeff2c3b7c8$export$d443af17fae6e7aa(children, matchingRoute);
                        }
                    }
                    const spanJson = activeRootSpan ? (0, $bb9b6447bf4caedb$export$92d8c23565496537)(activeRootSpan) : void 0;
                    if (targetPath && activeRootSpan && spanJson && !spanJson.timestamp && // Span hasn't ended yet
                    spanJson.op === "navigation") $8097daeff2c3b7c8$export$8e00428fd5aa3427(activeRootSpan, {
                        pathname: targetPath,
                        search: "",
                        hash: "",
                        state: null,
                        key: "default"
                    }, Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32), true, $8097daeff2c3b7c8$var$_matchRoutes);
                    return originalPatch(routeId, children);
                };
            }
            const lazyLoadPromise = (async ()=>{
                const contextToken = (0, $4487fbe2e1371231$export$49f239a397357a7c)(targetPath, activeRootSpan);
                let result;
                try {
                    result = await originalPatchRoutes(args);
                } finally{
                    (0, $4487fbe2e1371231$export$44ec4f5e487fad8c)(contextToken);
                    if (activeRootSpan) $8097daeff2c3b7c8$var$resolveDeferredLazyRoutePromise(activeRootSpan);
                }
                const spanJson = activeRootSpan ? (0, $bb9b6447bf4caedb$export$92d8c23565496537)(activeRootSpan) : void 0;
                if (activeRootSpan && spanJson && !spanJson.timestamp && // Span hasn't ended yet
                spanJson.op === "navigation") {
                    const pathname = targetPath;
                    if (pathname) $8097daeff2c3b7c8$export$8e00428fd5aa3427(activeRootSpan, {
                        pathname: pathname,
                        search: "",
                        hash: "",
                        state: null,
                        key: "default"
                    }, Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32), false, $8097daeff2c3b7c8$var$_matchRoutes);
                }
                return result;
            })();
            if (activeRootSpan) $8097daeff2c3b7c8$var$trackLazyRouteLoad(activeRootSpan, lazyLoadPromise);
            return lazyLoadPromise;
        }
    };
}
function $8097daeff2c3b7c8$export$706ad1af8096e280(opts) {
    const { location: location, routes: routes, navigationType: navigationType, version: version, matches: matches, basename: basename, allRoutes: allRoutes2 } = opts;
    const branches = Array.isArray(matches) ? matches : $8097daeff2c3b7c8$var$_matchRoutes(allRoutes2 || routes, location, basename);
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (!client || !$8097daeff2c3b7c8$var$CLIENTS_WITH_INSTRUMENT_NAVIGATION.has(client)) return;
    const activeRootSpan = (0, $4487fbe2e1371231$export$6d46479e35ff5f30)();
    if (activeRootSpan && (0, $bb9b6447bf4caedb$export$92d8c23565496537)(activeRootSpan).op === "pageload" && navigationType === "POP") return;
    if ((navigationType === "PUSH" || navigationType === "POP") && branches) {
        const [name, source] = (0, $4487fbe2e1371231$export$d0d5aab0e629ad63)(location, allRoutes2 || routes, allRoutes2 || routes, branches, basename, $8097daeff2c3b7c8$var$_lazyRouteManifest, $8097daeff2c3b7c8$var$_enableAsyncRouteHandlers);
        const locationKey = $8097daeff2c3b7c8$export$6da138630728824c(location);
        const trackedNav = $8097daeff2c3b7c8$var$activeNavigationSpans.get(client);
        const trackedSpanHasEnded = trackedNav && !trackedNav.isPlaceholder ? !!(0, $bb9b6447bf4caedb$export$92d8c23565496537)(trackedNav.span).timestamp : false;
        const { skip: skip, shouldUpdate: shouldUpdate } = $8097daeff2c3b7c8$export$74ccc56dfa81ef20(trackedNav, locationKey, name, trackedSpanHasEnded);
        if (skip) {
            if (shouldUpdate && trackedNav) {
                const oldName = trackedNav.routeName;
                if (trackedNav.isPlaceholder) {
                    trackedNav.routeName = name;
                    (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Tracing] Updated placeholder navigation name from "${oldName}" to "${name}" (will apply to real span)`);
                } else {
                    trackedNav.span.updateName(name);
                    trackedNav.span.setAttribute((0, $f337c80285f06f80$export$d7a7d984b0791405), source);
                    if (source === "route") trackedNav.span.setAttribute((0, $3tmPs.URL_TEMPLATE), name);
                    (0, $269eeb69635ed414$export$e73679ffaf56810e)(trackedNav.span, "__sentry_navigation_name_set__", true);
                    trackedNav.routeName = name;
                    (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Tracing] Updated navigation span name from "${oldName}" to "${name}"`);
                }
            } else (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Tracing] Skipping duplicate navigation for location: ${locationKey}`);
            return;
        }
        const placeholderSpan = {
            end: ()=>{}
        };
        const placeholderEntry = {
            span: placeholderSpan,
            routeName: name,
            pathname: location.pathname,
            locationKey: locationKey,
            isPlaceholder: true
        };
        $8097daeff2c3b7c8$var$activeNavigationSpans.set(client, placeholderEntry);
        let navigationSpan;
        try {
            navigationSpan = (0, $7b5f2a588355dc11$export$7d159749bd9969ad)(client, {
                name: placeholderEntry.routeName,
                // Use placeholder's routeName in case it was updated
                attributes: {
                    [(0, $f337c80285f06f80$export$d7a7d984b0791405)]: source,
                    [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: "navigation",
                    [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: `auto.navigation.react.reactrouter${version ? `_v${version}` : ""}`,
                    ...source === "route" && {
                        [(0, $3tmPs.URL_TEMPLATE)]: placeholderEntry.routeName
                    }
                }
            });
        } catch (e) {
            $8097daeff2c3b7c8$var$activeNavigationSpans.delete(client);
            throw e;
        }
        if (navigationSpan) {
            $8097daeff2c3b7c8$var$activeNavigationSpans.set(client, {
                span: navigationSpan,
                routeName: placeholderEntry.routeName,
                // Use the (potentially updated) placeholder routeName
                pathname: location.pathname,
                locationKey: locationKey
            });
            $8097daeff2c3b7c8$var$patchSpanEnd(navigationSpan, location, routes, basename, "navigation");
        } else $8097daeff2c3b7c8$var$activeNavigationSpans.delete(client);
    }
}
function $8097daeff2c3b7c8$export$e8ecdda469a42a59(routes) {
    const added = [];
    routes.forEach((route)=>{
        const extractedChildRoutes = $8097daeff2c3b7c8$var$getChildRoutesRecursively(route);
        extractedChildRoutes.forEach((r)=>{
            $8097daeff2c3b7c8$export$3ef6d4da8160fa32.add(r);
            added.push(r);
        });
    });
    return added;
}
function $8097daeff2c3b7c8$var$removeRoutesFromAllRoutes(routes) {
    routes.forEach((route)=>{
        $8097daeff2c3b7c8$export$3ef6d4da8160fa32.delete(route);
    });
}
function $8097daeff2c3b7c8$var$getChildRoutesRecursively(route, allRoutes2 = /* @__PURE__ */ new Set()) {
    if (!allRoutes2.has(route)) {
        allRoutes2.add(route);
        if (route.children && !route.index) route.children.forEach((child)=>{
            const childRoutes = $8097daeff2c3b7c8$var$getChildRoutesRecursively(child, allRoutes2);
            childRoutes.forEach((r)=>{
                allRoutes2.add(r);
            });
        });
    }
    return allRoutes2;
}
function $8097daeff2c3b7c8$var$updatePageloadTransaction({ activeRootSpan: activeRootSpan, location: location, routes: routes, matches: matches, basename: basename, allRoutes: allRoutes2 }) {
    const branches = Array.isArray(matches) ? matches : $8097daeff2c3b7c8$var$_matchRoutes(allRoutes2 || routes, location, basename);
    if (branches) {
        const [name, source] = (0, $4487fbe2e1371231$export$d0d5aab0e629ad63)(location, allRoutes2 || routes, allRoutes2 || routes, branches, basename, $8097daeff2c3b7c8$var$_lazyRouteManifest, $8097daeff2c3b7c8$var$_enableAsyncRouteHandlers);
        (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().setTransactionName(name || "/");
        if (activeRootSpan) {
            activeRootSpan.updateName(name);
            activeRootSpan.setAttribute((0, $f337c80285f06f80$export$d7a7d984b0791405), source);
            if (source === "route") activeRootSpan.setAttribute((0, $3tmPs.URL_TEMPLATE), name);
            $8097daeff2c3b7c8$var$patchSpanEnd(activeRootSpan, location, routes, basename, "pageload");
        }
    } else if (activeRootSpan) $8097daeff2c3b7c8$var$patchSpanEnd(activeRootSpan, location, routes, basename, "pageload");
}
function $8097daeff2c3b7c8$var$shouldUpdateWildcardSpanName(currentName, currentSource, newName, newSource, allowNoCurrentName = false) {
    if (!newName) return false;
    if (!currentName && allowNoCurrentName) return true;
    const hasWildcard = currentName && (0, $4487fbe2e1371231$export$73bbd8f1d410fc7c)(currentName);
    if (hasWildcard && newSource === "route" && !(0, $4487fbe2e1371231$export$73bbd8f1d410fc7c)(newName)) return true;
    if (currentSource !== "route" && newSource === "route") return true;
    return false;
}
function $8097daeff2c3b7c8$var$tryUpdateSpanNameBeforeEnd(span, spanJson, currentName, location, routes, basename, spanType, allRoutes2) {
    try {
        const currentSource = spanJson.data?.[0, $f337c80285f06f80$export$d7a7d984b0791405];
        if (currentSource === "route" && currentName && !(0, $4487fbe2e1371231$export$73bbd8f1d410fc7c)(currentName)) return;
        const currentAllRoutes = Array.from(allRoutes2);
        const routesToUse = currentAllRoutes.length > 0 ? currentAllRoutes : routes;
        const branches = $8097daeff2c3b7c8$var$_matchRoutes(routesToUse, location, basename);
        if (!branches) return;
        const [name, source] = (0, $4487fbe2e1371231$export$d0d5aab0e629ad63)(location, routesToUse, routesToUse, branches, basename, $8097daeff2c3b7c8$var$_lazyRouteManifest, $8097daeff2c3b7c8$var$_enableAsyncRouteHandlers);
        const isImprovement = $8097daeff2c3b7c8$var$shouldUpdateWildcardSpanName(currentName, currentSource, name, source, true);
        const spanNotEnded = spanType === "pageload" || !spanJson.timestamp;
        if (isImprovement && spanNotEnded) {
            span.updateName(name);
            span.setAttribute((0, $f337c80285f06f80$export$d7a7d984b0791405), source);
            if (source === "route") span.setAttribute((0, $3tmPs.URL_TEMPLATE), name);
        }
    } catch (error) {
        (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`Error updating span details before ending: ${error}`);
    }
}
function $8097daeff2c3b7c8$var$patchSpanEnd(span, location, routes, basename, spanType) {
    const patchedPropertyName = `__sentry_${spanType}_end_patched__`;
    const hasEndBeenPatched = span?.[patchedPropertyName];
    if (hasEndBeenPatched || !span.end) return;
    const originalEnd = span.end.bind(span);
    let endCalled = false;
    span.end = function patchedEnd(...args) {
        if (endCalled) return;
        endCalled = true;
        const endTimestamp = args.length > 0 ? args[0] : Date.now() / 1e3;
        const spanJson = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(span);
        const currentName = spanJson.description;
        const currentSource = spanJson.data?.[0, $f337c80285f06f80$export$d7a7d984b0791405];
        const cleanupNavigationSpan = ()=>{
            const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
            if (client && spanType === "navigation") {
                const trackedNav = $8097daeff2c3b7c8$var$activeNavigationSpans.get(client);
                if (trackedNav && trackedNav.span === span) $8097daeff2c3b7c8$var$activeNavigationSpans.delete(client);
            }
        };
        const pendingPromises = $8097daeff2c3b7c8$var$pendingLazyRouteLoads.get(span);
        const mayHaveLazyRoutes = span.__sentry_may_have_lazy_routes__;
        const hasPendingOrMayHaveLazyRoutes = pendingPromises && pendingPromises.size > 0 || mayHaveLazyRoutes;
        const shouldWaitForLazyRoutes = hasPendingOrMayHaveLazyRoutes && currentName && ((0, $4487fbe2e1371231$export$73bbd8f1d410fc7c)(currentName) || currentSource !== "route");
        if (shouldWaitForLazyRoutes) {
            if ($8097daeff2c3b7c8$var$_lazyRouteTimeout === 0) {
                $8097daeff2c3b7c8$var$tryUpdateSpanNameBeforeEnd(span, spanJson, currentName, location, routes, basename, spanType, $8097daeff2c3b7c8$export$3ef6d4da8160fa32);
                cleanupNavigationSpan();
                originalEnd(endTimestamp);
                return;
            }
            const timeoutPromise = new Promise((r)=>setTimeout(r, $8097daeff2c3b7c8$var$_lazyRouteTimeout));
            let waitPromise;
            if (pendingPromises && pendingPromises.size > 0) {
                const allSettled = Promise.allSettled(pendingPromises).then(()=>{});
                waitPromise = $8097daeff2c3b7c8$var$_lazyRouteTimeout === Infinity ? allSettled : Promise.race([
                    allSettled,
                    timeoutPromise
                ]);
            } else waitPromise = timeoutPromise;
            waitPromise.then(()=>{
                const updatedSpanJson = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(span);
                $8097daeff2c3b7c8$var$tryUpdateSpanNameBeforeEnd(span, updatedSpanJson, updatedSpanJson.description, location, routes, basename, spanType, $8097daeff2c3b7c8$export$3ef6d4da8160fa32);
                cleanupNavigationSpan();
                originalEnd(endTimestamp);
            }).catch(()=>{
                cleanupNavigationSpan();
                originalEnd(endTimestamp);
            });
            return;
        }
        $8097daeff2c3b7c8$var$tryUpdateSpanNameBeforeEnd(span, spanJson, currentName, location, routes, basename, spanType, $8097daeff2c3b7c8$export$3ef6d4da8160fa32);
        cleanupNavigationSpan();
        originalEnd(endTimestamp);
    };
    (0, $269eeb69635ed414$export$e73679ffaf56810e)(span, patchedPropertyName, true);
}
function $8097daeff2c3b7c8$export$b90e0c8f3b3b5df0(Routes, version) {
    if (!$8097daeff2c3b7c8$var$_useEffect || !$8097daeff2c3b7c8$var$_useLocation || !$8097daeff2c3b7c8$var$_useNavigationType || !$8097daeff2c3b7c8$var$_createRoutesFromChildren || !$8097daeff2c3b7c8$var$_matchRoutes) {
        (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`reactRouterV6Instrumentation was unable to wrap Routes because of one or more missing parameters.
      useEffect: ${$8097daeff2c3b7c8$var$_useEffect}. useLocation: ${$8097daeff2c3b7c8$var$_useLocation}. useNavigationType: ${$8097daeff2c3b7c8$var$_useNavigationType}.
      createRoutesFromChildren: ${$8097daeff2c3b7c8$var$_createRoutesFromChildren}. matchRoutes: ${$8097daeff2c3b7c8$var$_matchRoutes}.`);
        return Routes;
    }
    const SentryRoutes = (props)=>{
        const isMountRenderPass = $5FkrB.useRef(true);
        const location = $8097daeff2c3b7c8$var$_useLocation();
        const navigationType = $8097daeff2c3b7c8$var$_useNavigationType();
        const routes = $8097daeff2c3b7c8$var$_createRoutesFromChildren(props.children);
        $8097daeff2c3b7c8$var$useIsomorphicLayoutEffect(()=>{
            const added = $8097daeff2c3b7c8$export$e8ecdda469a42a59(routes);
            return ()=>$8097daeff2c3b7c8$var$removeRoutesFromAllRoutes(added);
        });
        $8097daeff2c3b7c8$var$useIsomorphicLayoutEffect(()=>{
            if (isMountRenderPass.current) {
                $8097daeff2c3b7c8$var$updatePageloadTransaction({
                    activeRootSpan: (0, $4487fbe2e1371231$export$6d46479e35ff5f30)(),
                    location: location,
                    routes: routes,
                    allRoutes: Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32)
                });
                isMountRenderPass.current = false;
            } else $8097daeff2c3b7c8$export$706ad1af8096e280({
                location: location,
                routes: routes,
                navigationType: navigationType,
                version: version,
                allRoutes: Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32)
            });
        }, // Re-run only on location/navigation changes, not children changes
        [
            location,
            navigationType
        ]);
        return /* @__PURE__ */ $5FkrB.createElement(Routes, {
            ...props
        });
    };
    (0, $2015f24f5be0bafb$export$6c1f0397687d8b2)(SentryRoutes, Routes);
    return SentryRoutes;
}





function $c159a67177be6b02$export$47113a480541ff59(options) {
    return (0, $8097daeff2c3b7c8$export$7e5bbc7e32f3c098)(options, "6");
}
function $c159a67177be6b02$export$1ffd7287c0e61f32(origUseRoutes) {
    return (0, $8097daeff2c3b7c8$export$3881404ad6870e59)(origUseRoutes, "6");
}
function $c159a67177be6b02$export$bd33b81dece50867(createRouterFunction) {
    return (0, $8097daeff2c3b7c8$export$6f08ca2914060d3f)(createRouterFunction, "6");
}
function $c159a67177be6b02$export$e61a765bf2bfccdc(createMemoryRouterFunction) {
    return (0, $8097daeff2c3b7c8$export$ce6d63af7f6f9771)(createMemoryRouterFunction, "6");
}
function $c159a67177be6b02$export$c6111e8561a02a8b(routes) {
    return (0, $8097daeff2c3b7c8$export$b90e0c8f3b3b5df0)(routes, "6");
}






function $5bb87f6d8535ae7e$export$8c58a21c71b0a1de(options) {
    return (0, $8097daeff2c3b7c8$export$7e5bbc7e32f3c098)(options, "7");
}
function $5bb87f6d8535ae7e$export$1d21f1c69f33ffe5(routes) {
    return (0, $8097daeff2c3b7c8$export$b90e0c8f3b3b5df0)(routes, "7");
}
function $5bb87f6d8535ae7e$export$b070baa27381b3d3(createRouterFunction) {
    return (0, $8097daeff2c3b7c8$export$6f08ca2914060d3f)(createRouterFunction, "7");
}
function $5bb87f6d8535ae7e$export$6d8f60accec7deae(createMemoryRouterFunction) {
    return (0, $8097daeff2c3b7c8$export$ce6d63af7f6f9771)(createMemoryRouterFunction, "7");
}
function $5bb87f6d8535ae7e$export$54f60524efa5c3b2(origUseRoutes) {
    return (0, $8097daeff2c3b7c8$export$3881404ad6870e59)(origUseRoutes, "7");
}






function $1d91f75301852e61$export$343e7de6039334f6(options) {
    return (0, $8097daeff2c3b7c8$export$7e5bbc7e32f3c098)(options, "");
}
function $1d91f75301852e61$export$1d92ff690890f59b(routes) {
    return (0, $8097daeff2c3b7c8$export$b90e0c8f3b3b5df0)(routes, "");
}
function $1d91f75301852e61$export$7f4c656bd7ebbb6b(createRouterFunction) {
    return (0, $8097daeff2c3b7c8$export$6f08ca2914060d3f)(createRouterFunction, "");
}
function $1d91f75301852e61$export$e196517f4822a972(createMemoryRouterFunction) {
    return (0, $8097daeff2c3b7c8$export$ce6d63af7f6f9771)(createMemoryRouterFunction, "");
}
function $1d91f75301852e61$export$1f41b3e298c8040f(origUseRoutes) {
    return (0, $8097daeff2c3b7c8$export$3881404ad6870e59)(origUseRoutes, "");
}


$parcel$exportWildcard($033860fe7bfd25af$exports, $054fa894e15f1de5$exports);


const $09e3b90497c94454$export$f7fd74025a8bcdc1 = 'ajs_anonymous_id';
function $09e3b90497c94454$export$57570b1603cf6adb() {
    // Use REACT_APP_ENVI env variable to determine the environment.
    const envi = "production";
    if (envi === 'production') return 'production';
    if (envi === 'staging') return 'staging';
    if (envi === 'development') return 'development';
    return 'development';
}
function $09e3b90497c94454$export$bf2f12fe2bb5fabe() {
    return "https://community.atlassian.com" ?? 'https://community.atlassian.com';
}
function $09e3b90497c94454$export$2d47ce6f15e624e5(url) {
    window.location.replace(url);
}
function $09e3b90497c94454$export$e6ab37cc923d2afa() {
    const env = $09e3b90497c94454$export$57570b1603cf6adb();
    if (env === 'development') return 'staging';
    return env;
}



var $3ZMUU = parcelRequire("3ZMUU");
const $9654b596cdf679bc$var$getReleaseIdentifier = ()=>{
    const shortRev = $3ZMUU?.env?.BITBUCKET_COMMIT?.substring(0, 10);
    const buildNumber = $3ZMUU?.env?.BITBUCKET_BUILD_NUMBER;
    if (shortRev && buildNumber) return `${buildNumber}-${shortRev}`;
    if (buildNumber) return buildNumber;
    if (shortRev) return shortRev;
    // Return a stable fallback when CI env vars are absent (e.g. local dev / test)
    // so the release string never contains a literal "undefined".
    return 'local';
};
const $9654b596cdf679bc$export$6c52693ff10aea16 = {
    dsn: 'https://5b81abb385f760bd950717459f42c2d3@o55978.ingest.us.sentry.io/4511072889864192',
    integrations: [
        $7b5f2a588355dc11$export$b4109253475213e9(),
        $37d5a74137b0c6f7$export$d7706faf7ab354bf()
    ],
    release: `app-updates-frontend@1.0.0-build.${$9654b596cdf679bc$var$getReleaseIdentifier()}`,
    // Tracing
    tracesSampleRate: 0.01,
    // Session Replay
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0
};
const $9654b596cdf679bc$var$captureMessage = (message, severityLevel)=>{
    if ($b244ff70a28cf637$exports.isInitialized()) $b244ff70a28cf637$exports.captureMessage(message, severityLevel);
};
const $9654b596cdf679bc$export$17d576c8a9d09daa = (environment, config = $9654b596cdf679bc$export$6c52693ff10aea16)=>{
    if (environment === 'development') return {
        tracesSampleRate: 0,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0
    };
    if (environment === 'staging') return {
        // All sample rates are halved for staging, including replay-on-error
        tracesSampleRate: (config.tracesSampleRate ?? $9654b596cdf679bc$export$6c52693ff10aea16.tracesSampleRate) / 2,
        replaysSessionSampleRate: (config.replaysSessionSampleRate ?? $9654b596cdf679bc$export$6c52693ff10aea16.replaysSessionSampleRate) / 2,
        replaysOnErrorSampleRate: (config.replaysOnErrorSampleRate ?? $9654b596cdf679bc$export$6c52693ff10aea16.replaysOnErrorSampleRate) / 2
    };
    // Prod: use the config values directly, falling back to sentryConfig defaults
    // if an explicit `undefined` was passed in a partial override.
    return {
        tracesSampleRate: config.tracesSampleRate ?? $9654b596cdf679bc$export$6c52693ff10aea16.tracesSampleRate,
        replaysSessionSampleRate: config.replaysSessionSampleRate ?? $9654b596cdf679bc$export$6c52693ff10aea16.replaysSessionSampleRate,
        replaysOnErrorSampleRate: config.replaysOnErrorSampleRate ?? $9654b596cdf679bc$export$6c52693ff10aea16.replaysOnErrorSampleRate
    };
};
const $9654b596cdf679bc$export$f5ae3c4820871661 = (config = {})=>{
    const environment = (0, $09e3b90497c94454$export$57570b1603cf6adb)();
    const resolvedConfig = {
        ...$9654b596cdf679bc$export$6c52693ff10aea16,
        ...config
    };
    if (resolvedConfig.dsn) $c3b6349452077e3f$export$2cd8252107eb640b({
        ...resolvedConfig,
        environment: environment,
        ...$9654b596cdf679bc$export$17d576c8a9d09daa(environment, resolvedConfig),
        // In development, drop all events to prevent any data from being sent
        ...environment === 'development' && {
            beforeSend: ()=>null,
            beforeSendTransaction: ()=>null
        },
        // In all other environments, filter out known third-party library noise
        // that causes no visible user impact. These TypeErrors originate from
        // @atlassian/paginated-filter's bundled react-select when handling touch
        // events on mobile browsers, where DOM ref methods like .contains() and
        // .closest() are unexpectedly unavailable on the ref target.
        ...environment !== 'development' && {
            beforeSend: (event, hint)=>{
                const error = hint?.originalException;
                if (error instanceof TypeError) {
                    const msg = error.message;
                    if (msg.includes('controlRef.contains is not a function') || msg.includes('.closest is not a function')) return null;
                }
                return event;
            }
        }
    });
};
var /**
 * Sentry Logger singleton for error tracking and reporting
 *
 * Example usage:
 *
 * import SentryLogger from '@app/sentry';
 * const error = new Error('Something terrible has happened');
 * SentryLogger.error(error, {
 *   extra: {
 *     userId: '123',
 *     action: 'button-click',
 *   },
 * });
 */ $9654b596cdf679bc$export$2e2bcd8739ae039 = {
    info: (message)=>{
        $9654b596cdf679bc$var$captureMessage(message, 'info');
    },
    warn: (message)=>{
        $9654b596cdf679bc$var$captureMessage(message, 'warning');
    },
    debug: (message)=>{
        $9654b596cdf679bc$var$captureMessage(message, 'debug');
    },
    error: (exception, ...args)=>{
        // Log to the console in every environment, outside the isInitialized gate.
        // Without this, failures are invisible in the browser: TanStack Query v5
        // stores queryFn rejections in query state without logging them, and in
        // development Sentry's beforeSend hook drops every event.
        console.error(exception, ...args);
        if ($b244ff70a28cf637$exports.isInitialized()) $b244ff70a28cf637$exports.captureException(exception, ...args);
    }
};





var $rxpl9 = parcelRequire("rxpl9");
parcelRequire("5FkrB");
parcelRequire("bR2Nz");
parcelRequire("kqp0i");
parcelRequire("1QNjI");

parcelRequire("knBeW");
parcelRequire("eP8dQ");
parcelRequire("ckRFu");
parcelRequire("5qnXH");
var $6bec4f26b2cb3094$export$ffb0004e005737fa = $faf30355a80342e4$exports.Fragment;
var $6bec4f26b2cb3094$export$34b9dba7ce09269b = function jsx(type, props, key) {
    if (!(0, $rxpl9.h).call(props, 'css')) return $faf30355a80342e4$exports.jsx(type, props, key);
    return $faf30355a80342e4$exports.jsx((0, $rxpl9.E), (0, $rxpl9.c)(type, props), key);
};
var $6bec4f26b2cb3094$export$25062201e9e25d76 = function jsxs(type, props, key) {
    if (!(0, $rxpl9.h).call(props, 'css')) return $faf30355a80342e4$exports.jsxs(type, props, key);
    return $faf30355a80342e4$exports.jsxs((0, $rxpl9.E), (0, $rxpl9.c)(type, props), key);
};




/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db26fca19e3969bcba2e77bc6fe6eb89>>
 * @codegenCommand yarn build tokens
 */ var $31b0c47840c659bb$var$tokens = {
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.success': '--ds-text-success',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.information': '--ds-text-information',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.textTransformUppercase': '--ds-UNSAFE-textTransformUppercase',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'border.radius.050': '--ds-border-radius-050',
    'border.radius': '--ds-border-radius',
    'border.radius.100': '--ds-border-radius-100',
    'border.radius.200': '--ds-border-radius-200',
    'border.radius.300': '--ds-border-radius-300',
    'border.radius.400': '--ds-border-radius-400',
    'border.radius.circle': '--ds-border-radius-circle',
    'border.width': '--ds-border-width',
    'border.width.0': '--ds-border-width-0',
    'border.width.indicator': '--ds-border-width-indicator',
    'border.width.outline': '--ds-border-width-outline',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.letterSpacing.0': '--ds-font-letterSpacing-0',
    'font.letterSpacing.100': '--ds-font-letterSpacing-100',
    'font.letterSpacing.200': '--ds-font-letterSpacing-200',
    'font.letterSpacing.300': '--ds-font-letterSpacing-300',
    'font.letterSpacing.400': '--ds-font-letterSpacing-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.monospace': '--ds-font-family-monospace',
    'font.family.sans': '--ds-font-family-sans',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'font.size.050': '--ds-font-size-050',
    'font.size.075': '--ds-font-size-075',
    'font.size.100': '--ds-font-size-100',
    'font.size.200': '--ds-font-size-200',
    'font.size.300': '--ds-font-size-300',
    'font.size.400': '--ds-font-size-400',
    'font.size.500': '--ds-font-size-500',
    'font.size.600': '--ds-font-size-600',
    'font.lineHeight.1': '--ds-font-lineHeight-1',
    'font.lineHeight.100': '--ds-font-lineHeight-100',
    'font.lineHeight.200': '--ds-font-lineHeight-200',
    'font.lineHeight.300': '--ds-font-lineHeight-300',
    'font.lineHeight.400': '--ds-font-lineHeight-400',
    'font.lineHeight.500': '--ds-font-lineHeight-500',
    'font.lineHeight.600': '--ds-font-lineHeight-600'
};
var $31b0c47840c659bb$export$2e2bcd8739ae039 = $31b0c47840c659bb$var$tokens;


var $59e7965bd64289a3$export$4ef52930e33717cd = 'data-theme';
var $59e7965bd64289a3$export$a00eac3f8684bcd0 = 'data-color-mode';
var $59e7965bd64289a3$export$2112803007239c61 = 'data-contrast-mode';
var $59e7965bd64289a3$export$352e418ed5b6193a = 'data-custom-theme';
var $59e7965bd64289a3$export$2faeed762aac6741 = 'light';
var $59e7965bd64289a3$export$6f0c6fb8c80fcc92 = 'ds';
var $59e7965bd64289a3$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $59e7965bd64289a3$export$dddac1532e822863 = "--".concat($59e7965bd64289a3$export$6f0c6fb8c80fcc92, "-token-not-found");
var $59e7965bd64289a3$export$9d7b58831ae93caa = "--".concat($59e7965bd64289a3$export$6f0c6fb8c80fcc92, "-elevation-surface-current");



var $3ZMUU = parcelRequire("3ZMUU");
/**
 * Takes a dot-separated token name and an optional fallback, and returns the CSS custom property for the corresponding token.
 * This should be used to implement design decisions throughout your application.
 *
 * Note: With `@atlaskit/babel-plugin-tokens`, this function can be pre-compiled and a fallback value automatically inserted.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * <div
 *   css={{
 *     backgroundColor: token('elevation.surface.raised', N0),
 *     boxShadow: token('elevation.shadow.raised', `0 20px 32px -8px ${N50A}, 0 0 1px ${N60A}`),
 *     padding: token('spacing.scale.100', '8px'),
 *     fontWeight: token('font.weight.regular', '400'),
 *   }}
 * />
 * ```
 *
 */ function $1ff81f2c5a4c494e$var$token(path, fallback) {
    var token = (0, $31b0c47840c659bb$export$2e2bcd8739ae039)[path];
    typeof $3ZMUU;
    // if the token is not found - replacing it with variable name without any value, to avoid it being undefined which would result in invalid css
    if (!token) token = (0, $59e7965bd64289a3$export$dddac1532e822863);
    var tokenCall = fallback ? "var(".concat(token, ", ").concat(fallback, ")") : "var(".concat(token, ")");
    return tokenCall;
}
var $1ff81f2c5a4c494e$export$2e2bcd8739ae039 = $1ff81f2c5a4c494e$var$token;



var $74Zh5 = parcelRequire("74Zh5");

var $5FkrB = parcelRequire("5FkrB");

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
/**
 * An empty function which does nothing.
 */ function $f82efe3f8c5a6d15$export$2e2bcd8739ae039() {}



var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $e7aece14b0df93a0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e7aece14b0df93a0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e7aece14b0df93a0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e7aece14b0df93a0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e7aece14b0df93a0$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $e7aece14b0df93a0$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $e7aece14b0df93a0$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $e7aece14b0df93a0$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $e7aece14b0df93a0$var$_objectSpread($e7aece14b0df93a0$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $f05edb9907c28653$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $f05edb9907c28653$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $f05edb9907c28653$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f05edb9907c28653$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $f05edb9907c28653$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $f05edb9907c28653$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $f05edb9907c28653$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $f05edb9907c28653$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $f05edb9907c28653$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $f05edb9907c28653$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $e7aece14b0df93a0$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $154e284006fe6994$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $7535bfd69ea188ca$export$5bf35293e545f20c() {
    var analyticsContext = (0, $154e284006fe6994$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $f05edb9907c28653$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $8429e4d975e3d80d$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $e1763a51fe084049$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e1763a51fe084049$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e1763a51fe084049$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e1763a51fe084049$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e1763a51fe084049$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $7535bfd69ea188ca$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $8429e4d975e3d80d$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $8429e4d975e3d80d$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $e1763a51fe084049$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}




var $5FkrB = parcelRequire("5FkrB");
function $4dee7b53309725f3$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $5FkrB.useRef)(true);
    (0, $5FkrB.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
var $748a63cc16fb3015$var$BORDER_WIDTH = 2;
var $748a63cc16fb3015$var$baseFocusOutsideStyles = (0, $74Zh5.css)({
    outline: "var(--ds-border-width-focused, 2px)".concat(" solid ", "var(--ds-border-focused, #4688EC)"),
    outlineOffset: $748a63cc16fb3015$var$BORDER_WIDTH
});
var $748a63cc16fb3015$var$baseInsetStyles = (0, $74Zh5.css)({
    outlineColor: "var(--ds-border-focused, #4688EC)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$748a63cc16fb3015$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
var $748a63cc16fb3015$var$focusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $748a63cc16fb3015$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $748a63cc16fb3015$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: "var(--ds-border-width, 1px)".concat(" solid")
        }
    }
});
var $748a63cc16fb3015$var$insetFocusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $748a63cc16fb3015$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $748a63cc16fb3015$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: "var(--ds-border-width, 1px)".concat(" solid"),
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $748a63cc16fb3015$var$FocusRing = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $748a63cc16fb3015$var$baseInsetStyles : $748a63cc16fb3015$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $748a63cc16fb3015$var$insetFocusRingStyles : $748a63cc16fb3015$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $74Zh5.jsx)((0, $74Zh5.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $5FkrB.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $5FkrB.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$748a63cc16fb3015$var$FocusRing.displayName = 'FocusRing';
var $748a63cc16fb3015$export$2e2bcd8739ae039 = $748a63cc16fb3015$var$FocusRing;



var $5FkrB = parcelRequire("5FkrB");
var $4b5a5d40339b6fdb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $e347e1889cb6b8cb$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $e347e1889cb6b8cb$var$tabKeyCode = 9;
function $e347e1889cb6b8cb$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $e347e1889cb6b8cb$var$tabKeyCode) return;
    $e347e1889cb6b8cb$var$abort(event);
}
var $e347e1889cb6b8cb$var$block = {
    onMouseDownCapture: $e347e1889cb6b8cb$var$abort,
    onMouseUpCapture: $e347e1889cb6b8cb$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $e347e1889cb6b8cb$var$onKey,
    onKeyUpCapture: $e347e1889cb6b8cb$var$onKey,
    onTouchStartCapture: $e347e1889cb6b8cb$var$abort,
    onTouchEndCapture: $e347e1889cb6b8cb$var$abort,
    onPointerDownCapture: $e347e1889cb6b8cb$var$abort,
    onPointerUpCapture: $e347e1889cb6b8cb$var$abort,
    onClickCapture: $e347e1889cb6b8cb$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $e347e1889cb6b8cb$var$abort
};
var $e347e1889cb6b8cb$var$doNotBlock = {};
function $e347e1889cb6b8cb$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $e347e1889cb6b8cb$var$doNotBlock : $e347e1889cb6b8cb$var$block;
}


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");
function $275750b91f5cca23$export$7ad0316cc0dd65a(_ref) {
    var spacing = _ref.spacing;
    return (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : '0 2px',
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");
function $cd9130befc00d2de$export$1b5827d324e945b1(_ref) {
    var hasOverlay = _ref.hasOverlay;
    return (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");
function $95f9a2c57711029d$export$864eea3f4ec3368f(_ref) {
    var spacing = _ref.spacing;
    return (0, $74Zh5.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : "0 2px",
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}



var $5FkrB = parcelRequire("5FkrB");
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $120779d35fab2d6d$var$ATOMIC_GROUP_LENGTH = 5;
function $120779d35fab2d6d$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $120779d35fab2d6d$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


var $e3573d3717f44b5e$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $e3573d3717f44b5e$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $120779d35fab2d6d$export$2e2bcd8739ae039)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
$e3573d3717f44b5e$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $e3573d3717f44b5e$export$2e2bcd8739ae039 = $e3573d3717f44b5e$var$VisuallyHidden;


var $27c271557a878882$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $5FkrB.isValidElement)(children) && children.type === (0, $e3573d3717f44b5e$export$2e2bcd8739ae039);
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var $c694f25f964fe12d$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};


var $f4d0d83b41e20f96$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $f4d0d83b41e20f96$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $f4d0d83b41e20f96$var$iconBeforeSpacingFixStyle = (0, $74Zh5.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $f4d0d83b41e20f96$var$iconAfterSpacingFixStyle = (0, $74Zh5.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $f4d0d83b41e20f96$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $27c271557a878882$export$20bbd2efb0d734c4)(children)) return null;
    return spacingStyles;
};
var $f4d0d83b41e20f96$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $27c271557a878882$export$20bbd2efb0d734c4)(children)) return children;
    return children ? (0, $74Zh5.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $f4d0d83b41e20f96$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'default' : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? 'a' : 'button' : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $f82efe3f8c5a6d15$export$2e2bcd8739ae039) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $f82efe3f8c5a6d15$export$2e2bcd8739ae039) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 'default' : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? 'button' : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $f4d0d83b41e20f96$var$_excluded);
    var ourRef = (0, $5FkrB.useRef)();
    var setRef = (0, $5FkrB.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $4dee7b53309725f3$export$2e2bcd8739ae039)(ourRef, autoFocus);
    var interactionContext = (0, $5FkrB.useContext)((0, $4b5a5d40339b6fdb$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $e1763a51fe084049$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "23.11.7",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $5FkrB.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $5FkrB.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $74Zh5.css)((0, $cd9130befc00d2de$export$1b5827d324e945b1)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-warning-inverse, #292A2E)", " !important")
        }
    };
    return (0, $74Zh5.jsx)((0, $748a63cc16fb3015$export$2e2bcd8739ae039), null, (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $f4d0d83b41e20f96$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $e347e1889cb6b8cb$export$2e2bcd8739ae039)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $74Zh5.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $95f9a2c57711029d$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $f4d0d83b41e20f96$var$getSpacingFix(children, $f4d0d83b41e20f96$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $f4d0d83b41e20f96$var$getChildren(children, [
        fadeStyles,
        (0, $275750b91f5cca23$export$7ad0316cc0dd65a)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $74Zh5.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $95f9a2c57711029d$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $f4d0d83b41e20f96$var$getSpacingFix(children, $f4d0d83b41e20f96$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $74Zh5.jsx)("span", {
        css: [
            (0, $c694f25f964fe12d$export$1a9fe1b84c876bb5),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f4d0d83b41e20f96$export$2e2bcd8739ae039 = $f4d0d83b41e20f96$var$ButtonBase;



var $25nEq = parcelRequire("25nEq");

var $aptQa = parcelRequire("aptQa");
function $7d871a17c8db1732$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7d871a17c8db1732$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7d871a17c8db1732$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7d871a17c8db1732$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7d871a17c8db1732$var$gridSize = 8;
var $7d871a17c8db1732$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
var $7d871a17c8db1732$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: 'auto'
};
var $7d871a17c8db1732$var$lineHeights = {
    default: $7d871a17c8db1732$var$heights.default,
    compact: $7d871a17c8db1732$var$heights.compact,
    none: 'inherit'
};
var $7d871a17c8db1732$var$padding = {
    // 10px gutter
    default: "0 ".concat($7d871a17c8db1732$var$gridSize + $7d871a17c8db1732$var$gridSize / 4, "px"),
    compact: "0 ".concat($7d871a17c8db1732$var$gridSize + $7d871a17c8db1732$var$gridSize / 4, "px"),
    none: '0'
};
var $7d871a17c8db1732$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($7d871a17c8db1732$var$gridSize / 4, "px"),
    default: "0 ".concat($7d871a17c8db1732$var$gridSize / 4, "px"),
    none: '0'
};
var $7d871a17c8db1732$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var $7d871a17c8db1732$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
var $7d871a17c8db1732$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': $7d871a17c8db1732$var$_objectSpread($7d871a17c8db1732$var$_objectSpread({}, $7d871a17c8db1732$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    }),
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $7d871a17c8db1732$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
var $7d871a17c8db1732$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    }
};
var $7d871a17c8db1732$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
var $7d871a17c8db1732$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    }
};
var $7d871a17c8db1732$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
var $7d871a17c8db1732$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $7d871a17c8db1732$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': $7d871a17c8db1732$var$_objectSpread($7d871a17c8db1732$var$_objectSpread({}, $7d871a17c8db1732$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    })
};
var $7d871a17c8db1732$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $7d871a17c8db1732$export$955358618f994a11(_ref) {
    var appearance = _ref.appearance, spacing = _ref.spacing, isSelected = _ref.isSelected, shouldFitContainer = _ref.shouldFitContainer, isOnlySingleIcon = _ref.isOnlySingleIcon;
    return $7d871a17c8db1732$var$_objectSpread($7d871a17c8db1732$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: (0, $aptQa.fg)('platform-dst-shape-theme-default') ? "var(--ds-radius-medium, 6px)" : "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $7d871a17c8db1732$var$heights[spacing],
        lineHeight: $7d871a17c8db1732$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $7d871a17c8db1732$var$singleIconPadding[spacing] : $7d871a17c8db1732$var$padding[spacing],
        verticalAlign: $7d871a17c8db1732$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center'
    }, isSelected ? $7d871a17c8db1732$var$selectedStyles : $7d871a17c8db1732$var$_objectSpread($7d871a17c8db1732$var$_objectSpread($7d871a17c8db1732$var$_objectSpread($7d871a17c8db1732$var$_objectSpread($7d871a17c8db1732$var$_objectSpread($7d871a17c8db1732$var$_objectSpread($7d871a17c8db1732$var$_objectSpread($7d871a17c8db1732$var$_objectSpread({}, appearance === 'default' && $7d871a17c8db1732$var$defaultStyles), appearance === 'primary' && $7d871a17c8db1732$var$primaryStyles), appearance === 'link' && $7d871a17c8db1732$var$linkStyles), appearance === 'subtle' && $7d871a17c8db1732$var$subtleStyles), appearance === 'subtle-link' && $7d871a17c8db1732$var$subtleLinkStyles), appearance === 'warning' && $7d871a17c8db1732$var$warningStyles), appearance === 'danger' && $7d871a17c8db1732$var$dangerStyles), {}, {
        '&[disabled]': {
            color: "var(--ds-text-disabled, #080F214A)",
            backgroundColor: $7d871a17c8db1732$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent',
            cursor: 'not-allowed',
            textDecoration: 'none',
            '&:hovered': {
                backgroundColor: $7d871a17c8db1732$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
            },
            '&:active': {
                backgroundColor: $7d871a17c8db1732$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
            }
        }
    }, $7d871a17c8db1732$var$hasOverlayStyles)), {}, {
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}



function $6d24198731b5a9a6$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $27c271557a878882$export$20bbd2efb0d734c4)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}


var $e015d36248b70172$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $e015d36248b70172$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $e015d36248b70172$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $f82efe3f8c5a6d15$export$2e2bcd8739ae039) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $f82efe3f8c5a6d15$export$2e2bcd8739ae039) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $e015d36248b70172$var$_excluded);
    var isOnlySingleIcon = (0, $6d24198731b5a9a6$export$2e2bcd8739ae039)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    // in Firefox
    var onMouseDown = (0, $5FkrB.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($e015d36248b70172$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $5FkrB.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($e015d36248b70172$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $5FkrB.useMemo)(function() {
        return (0, $7d871a17c8db1732$export$955358618f994a11)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f4d0d83b41e20f96$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$e015d36248b70172$var$Button.displayName = 'Button';
var $e015d36248b70172$export$2e2bcd8739ae039 = $e015d36248b70172$var$Button;


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
/* spinner.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $5FkrB = parcelRequire("5FkrB");

var $c8ef00d2e61af903$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $3595ac2db996a99a$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
var $3595ac2db996a99a$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $3595ac2db996a99a$var$loadIn = null;
var $3595ac2db996a99a$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $3595ac2db996a99a$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $3595ac2db996a99a$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $c8ef00d2e61af903$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $3595ac2db996a99a$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $4b5a5d40339b6fdb$export$2e2bcd8739ae039));
    $3595ac2db996a99a$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $120779d35fab2d6d$export$2e2bcd8739ae039)([
            $3595ac2db996a99a$var$styles.wrapperStyles,
            $3595ac2db996a99a$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $120779d35fab2d6d$export$2e2bcd8739ae039)([
            $3595ac2db996a99a$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $120779d35fab2d6d$export$2e2bcd8739ae039)([
            $3595ac2db996a99a$var$styles.circleStyles
        ])
    })));
}));
var $3595ac2db996a99a$export$2e2bcd8739ae039 = $3595ac2db996a99a$var$Spinner;


function $dd510204f6d75704$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $dd510204f6d75704$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing;
    var size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3595ac2db996a99a$export$2e2bcd8739ae039), {
        size: size,
        label: ", Loading",
        appearance: $dd510204f6d75704$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}


var $a60eb1e63addc72a$var$_excluded = [
    "appearance",
    "isDisabled",
    "isSelected",
    "isLoading",
    "spacing"
];
/**
 * __Loading button__
 *
 * @deprecated Legacy loading buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new` with the `isLoading` prop.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ var $a60eb1e63addc72a$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function LoadingButton(_ref, ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, spacing = _ref.spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $a60eb1e63addc72a$var$_excluded);
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e015d36248b70172$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        ref: ref,
        appearance: appearance,
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dd510204f6d75704$export$2e2bcd8739ae039), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    }));
});
// Tools including enzyme rely on components having a display name
$a60eb1e63addc72a$var$LoadingButton.displayName = 'LoadingButton';
var $a60eb1e63addc72a$export$2e2bcd8739ae039 = $a60eb1e63addc72a$var$LoadingButton;


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $5FkrB = parcelRequire("5FkrB");
var $c78d6c98f7283ff6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $b5e0fe981809a87d$export$4b84fd0e2c617bd = '#FFEBE6';
var $b5e0fe981809a87d$export$b34b069eff244586 = '#FFBDAD';
var $b5e0fe981809a87d$export$be802dd0d8b57f35 = '#FF8F73';
var $b5e0fe981809a87d$export$60847d42f9da92a6 = '#FF7452';
var $b5e0fe981809a87d$export$4a7404f376229999 = '#FF5630';
var $b5e0fe981809a87d$export$2010d0fb4295b346 = '#DE350B';
var $b5e0fe981809a87d$export$2837b5a1a71d5c02 = '#BF2600';
var $b5e0fe981809a87d$export$8d9596b529bbb9cf = '#FFFAE6';
var $b5e0fe981809a87d$export$41060a744ab0b7ae = '#FFF0B3';
var $b5e0fe981809a87d$export$1cc05bbbf340e559 = '#FFE380';
var $b5e0fe981809a87d$export$5aae31392d72caaa = '#FFC400';
var $b5e0fe981809a87d$export$c6930421db9fa514 = '#FFAB00';
var $b5e0fe981809a87d$export$59619663aa6500fb = '#FF991F';
var $b5e0fe981809a87d$export$874739ea9e379ab6 = '#FF8B00';
var $b5e0fe981809a87d$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $b5e0fe981809a87d$export$69a3bf21b9686c2b = '#ABF5D1';
var $b5e0fe981809a87d$export$afbce1382ec95f73 = '#79F2C0';
var $b5e0fe981809a87d$export$747d86715d4175de = '#57D9A3';
var $b5e0fe981809a87d$export$940e1f69e873f202 = '#36B37E';
var $b5e0fe981809a87d$export$a49394138f7b8e85 = '#00875A';
var $b5e0fe981809a87d$export$6fa04827ac68a4fb = '#006644';
var $b5e0fe981809a87d$export$226de0355ed012f8 = '#DEEBFF';
var $b5e0fe981809a87d$export$8c13c2ee36917869 = '#B3D4FF';
var $b5e0fe981809a87d$export$ecfc1dff386a3e7a = '#4C9AFF';
var $b5e0fe981809a87d$export$215b7063051591f1 = '#2684FF';
var $b5e0fe981809a87d$export$e62e8919cca44969 = '#0065FF';
var $b5e0fe981809a87d$export$b3de0ae08da2ce64 = '#0052CC';
var $b5e0fe981809a87d$export$a6ee3d71bc067634 = '#0747A6';
var $b5e0fe981809a87d$export$67f15409e87642a1 = '#669DF1';
var $b5e0fe981809a87d$export$f0539dbc42dbb067 = '#8FB8F6';
var $b5e0fe981809a87d$export$363e4475840015bb = '#EAE6FF';
var $b5e0fe981809a87d$export$4b0a4417ed59760f = '#C0B6F2';
var $b5e0fe981809a87d$export$6011520a64d9a187 = '#998DD9';
var $b5e0fe981809a87d$export$a7175d4e9206bc80 = '#8777D9';
var $b5e0fe981809a87d$export$b48405b95304b5a1 = '#6554C0';
var $b5e0fe981809a87d$export$c71e4279dd54a18d = '#5243AA';
var $b5e0fe981809a87d$export$147899de772240ec = '#403294';
var $b5e0fe981809a87d$export$2cf711fe14c66f06 = '#E6FCFF';
var $b5e0fe981809a87d$export$7a8f4d33f6f9772c = '#B3F5FF';
var $b5e0fe981809a87d$export$776c9c497ef08533 = '#79E2F2';
var $b5e0fe981809a87d$export$69cb3ca10c1e330e = '#00C7E6';
var $b5e0fe981809a87d$export$9dc1ef0f3f48059b = '#00B8D9';
var $b5e0fe981809a87d$export$7c835c78b6fcdef8 = '#00A3BF';
var $b5e0fe981809a87d$export$6036577f95c3877e = '#008DA6';
var $b5e0fe981809a87d$export$29a4f05edc054374 = '#FFFFFF';
var $b5e0fe981809a87d$export$e655ef011c4aa1a2 = '#FAFBFC';
var $b5e0fe981809a87d$export$9fdfb749e33cdf97 = '#F4F5F7';
var $b5e0fe981809a87d$export$3e51e8f1440314ba = '#EBECF0';
var $b5e0fe981809a87d$export$1ce2d1575d444ceb = '#DFE1E6';
var $b5e0fe981809a87d$export$8754fc7e6d8b3000 = '#C1C7D0';
var $b5e0fe981809a87d$export$c2e91cbeada39b8b = '#B3BAC5';
var $b5e0fe981809a87d$export$5f71e19f3a7ad9de = '#A5ADBA';
var $b5e0fe981809a87d$export$eaa8c8a70ac22806 = '#97A0AF';
var $b5e0fe981809a87d$export$7c87d337fb91a97d = '#8993A4';
var $b5e0fe981809a87d$export$d6447c357493214f = '#7A869A';
var $b5e0fe981809a87d$export$f563ee71e9ee74cd = '#6B778C';
var $b5e0fe981809a87d$export$e2ef2124cf4024b1 = '#5E6C84';
var $b5e0fe981809a87d$export$eece5f492e429f08 = '#505F79';
var $b5e0fe981809a87d$export$c39c0fe0f26207ae = '#42526E';
var $b5e0fe981809a87d$export$7090862dc3038a9f = '#344563';
var $b5e0fe981809a87d$export$ad0bacf983b7ddaa = '#253858';
var $b5e0fe981809a87d$export$7d61b15e0da132af = '#172B4D';
var $b5e0fe981809a87d$export$fbda843f0a27fe96 = '#091E42';
var $b5e0fe981809a87d$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $b5e0fe981809a87d$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $b5e0fe981809a87d$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $b5e0fe981809a87d$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $b5e0fe981809a87d$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $b5e0fe981809a87d$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $b5e0fe981809a87d$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $b5e0fe981809a87d$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $b5e0fe981809a87d$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $b5e0fe981809a87d$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $b5e0fe981809a87d$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $b5e0fe981809a87d$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $b5e0fe981809a87d$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $b5e0fe981809a87d$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $b5e0fe981809a87d$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $b5e0fe981809a87d$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $b5e0fe981809a87d$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $b5e0fe981809a87d$export$2f6319cf7d736c2a = '#E6EDFA';
var $b5e0fe981809a87d$export$95126bc8884d6634 = '#DCE5F5';
var $b5e0fe981809a87d$export$8338d8c35d44ff1 = '#CED9EB';
var $b5e0fe981809a87d$export$5368d76ae4fbbda7 = '#B8C7E0';
var $b5e0fe981809a87d$export$9f0a771d16ec8d36 = '#ABBBD6';
var $b5e0fe981809a87d$export$abcf8c38338b4aa5 = '#9FB0CC';
var $b5e0fe981809a87d$export$97e81faa16a182c7 = '#8C9CB8';
var $b5e0fe981809a87d$export$bfe21c59123ecf33 = '#7988A3';
var $b5e0fe981809a87d$export$ee82aa2ea6a1558 = '#67758F';
var $b5e0fe981809a87d$export$682927c6ed76be02 = '#56637A';
var $b5e0fe981809a87d$export$91fd9994c5be9757 = '#455166';
var $b5e0fe981809a87d$export$d281fbfe3cff2df6 = '#3B475C';
var $b5e0fe981809a87d$export$3902c91d8b98a753 = '#313D52';
var $b5e0fe981809a87d$export$8e8133c1ba5845b5 = '#283447';
var $b5e0fe981809a87d$export$33ff357f6620b39 = '#202B3D';
var $b5e0fe981809a87d$export$633847cf062b69e0 = '#1B2638';
var $b5e0fe981809a87d$export$9776a6e503bdbf76 = '#121A29';
var $b5e0fe981809a87d$export$6c813d5160dff5db = '#0E1624';
var $b5e0fe981809a87d$export$3d4f271a500072a = '#0D1424';
var $b5e0fe981809a87d$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $b5e0fe981809a87d$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $b5e0fe981809a87d$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $b5e0fe981809a87d$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $b5e0fe981809a87d$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $b5e0fe981809a87d$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $b5e0fe981809a87d$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $b5e0fe981809a87d$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $b5e0fe981809a87d$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $b5e0fe981809a87d$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $b5e0fe981809a87d$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $b5e0fe981809a87d$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $b5e0fe981809a87d$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $b5e0fe981809a87d$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $b5e0fe981809a87d$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $b5e0fe981809a87d$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $b5e0fe981809a87d$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $b5e0fe981809a87d$export$d2adc5dedf09fced = '#292A2E';
var $b5e0fe981809a87d$export$f51762073d2bb381 = '#94C748';
var $b5e0fe981809a87d$export$95e26d54def96891 = '#B3DF72';


var $1cedf8f2f776e1fc$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $e9bb9e7afd1cf629$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $b5e0fe981809a87d$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $b5e0fe981809a87d$export$29a4f05edc054374), ")");
}
var $e9bb9e7afd1cf629$var$rotate = (0, $74Zh5.keyframes)({
    to: {
        transform: 'rotate(360deg)'
    }
});
var $e9bb9e7afd1cf629$var$rotateStyles = (0, $74Zh5.css)({
    animation: "".concat($e9bb9e7afd1cf629$var$rotate, " 0.86s infinite"),
    animationTimingFunction: 'cubic-bezier(0.4, 0.15, 0.6, 0.85)',
    transformOrigin: 'center'
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $e9bb9e7afd1cf629$var$loadIn = (0, $74Zh5.keyframes)({
    from: {
        transform: 'rotate(50deg)',
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: 'rotate(230deg)',
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $e9bb9e7afd1cf629$var$loadInStyles = (0, $74Zh5.css)({
    animation: "".concat($e9bb9e7afd1cf629$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: 'forwards',
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $e9bb9e7afd1cf629$var$wrapperStyles = (0, $74Zh5.css)({
    display: 'inline-flex',
    /**
   * Align better inline with text.
   */ verticalAlign: 'middle'
});
var $e9bb9e7afd1cf629$var$circleStyles = (0, $74Zh5.css)({
    fill: 'none',
    strokeDasharray: 60,
    strokeDashoffset: 'inherit',
    strokeLinecap: 'round',
    strokeWidth: 1.5,
    '@media screen and (forced-colors: active)': {
        filter: 'grayscale(100%)',
        stroke: 'CanvasText'
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $e9bb9e7afd1cf629$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $e9bb9e7afd1cf629$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $1cedf8f2f776e1fc$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $e9bb9e7afd1cf629$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $c78d6c98f7283ff6$export$2e2bcd8739ae039));
    $e9bb9e7afd1cf629$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $74Zh5.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $e9bb9e7afd1cf629$var$wrapperStyles,
            $e9bb9e7afd1cf629$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $74Zh5.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $e9bb9e7afd1cf629$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none'
    }, (0, $74Zh5.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $e9bb9e7afd1cf629$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $e9bb9e7afd1cf629$export$2e2bcd8739ae039 = $e9bb9e7afd1cf629$var$Spinner;



var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $c78ea150e2ee1656$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c78ea150e2ee1656$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c78ea150e2ee1656$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c78ea150e2ee1656$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c78ea150e2ee1656$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $c78ea150e2ee1656$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $c78ea150e2ee1656$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $c78ea150e2ee1656$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $c78ea150e2ee1656$var$_objectSpread($c78ea150e2ee1656$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $0d0d1b8249bb995c$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $0d0d1b8249bb995c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $0d0d1b8249bb995c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0d0d1b8249bb995c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $0d0d1b8249bb995c$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $0d0d1b8249bb995c$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $0d0d1b8249bb995c$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $0d0d1b8249bb995c$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $0d0d1b8249bb995c$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $0d0d1b8249bb995c$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $c78ea150e2ee1656$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $d4bb7d144175351d$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $d5aceb938b608b4c$export$5bf35293e545f20c() {
    var analyticsContext = (0, $d4bb7d144175351d$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $0d0d1b8249bb995c$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $22dc53065038106d$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $ff1b37318b494b6a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ff1b37318b494b6a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ff1b37318b494b6a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ff1b37318b494b6a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ff1b37318b494b6a$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $d5aceb938b608b4c$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $22dc53065038106d$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $22dc53065038106d$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $ff1b37318b494b6a$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $f55684cf1f3dca29$export$2e2bcd8739ae039() {}



var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
/**
 * Character key codes which can be used in keyboard events.
 */ var $24cbc83a816d03dc$export$390330c10ff2b9a1 = 'ArrowUp';
var $24cbc83a816d03dc$export$a80636c6f41931fe = 'ArrowDown';
var $24cbc83a816d03dc$export$4af703091671bc = 'Home';
var $24cbc83a816d03dc$export$e2bc30913faa5db7 = 'End';
var $24cbc83a816d03dc$export$10f6869ed0a7d75b = 'Tab';
var $24cbc83a816d03dc$export$8152f929a25a0ff4 = 'Enter';
var $24cbc83a816d03dc$export$e51a3576c045c8d5 = 'Space';
var $24cbc83a816d03dc$export$2bb790b9008907b4 = 'Escape';


function $29facb65b1c1eae8$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $24cbc83a816d03dc$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}



var $5FkrB = parcelRequire("5FkrB");
function $3410b820897135a6$export$2e2bcd8739ae039(value) {
    var ref = (0, $5FkrB.useRef)(value);
    (0, $5FkrB.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $375d8fb92f1b53ed$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $3d52fdcb58caf93d$export$469bb693f11edc7f() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$isOpen = _ref.isOpen, isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen;
    var context = (0, $5FkrB.useContext)((0, $375d8fb92f1b53ed$export$5fbf4d7fae6cdc00));
    (0, $5FkrB.useEffect)(function() {
        if (context === null) return;
        if (!isOpen) return;
        context.increment();
        return function() {
            context.decrement();
        };
    }, [
        context,
        isOpen
    ]);
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
var $88b27043491c379a$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $88b27043491c379a$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$88b27043491c379a$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $88b27043491c379a$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $5FkrB.useState)($88b27043491c379a$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        if (!$88b27043491c379a$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $7QpUe.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $88b27043491c379a$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $88b27043491c379a$export$ff7706047246b98b = function prefersReducedMotion() {
    return $88b27043491c379a$export$f0f789643ba5a83c;
};


/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $279dc552abf8fdf8$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $279dc552abf8fdf8$var$ExitingContext = /*#__PURE__*/ (0, $5FkrB.createContext)($279dc552abf8fdf8$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $279dc552abf8fdf8$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $279dc552abf8fdf8$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($279dc552abf8fdf8$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $279dc552abf8fdf8$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $279dc552abf8fdf8$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $279dc552abf8fdf8$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $279dc552abf8fdf8$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $279dc552abf8fdf8$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $279dc552abf8fdf8$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $88b27043491c379a$export$b7baf7667a68d87c)()) return children;
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $279dc552abf8fdf8$var$childrenToArray(previousChildren);
    var current = $279dc552abf8fdf8$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $279dc552abf8fdf8$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $279dc552abf8fdf8$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $279dc552abf8fdf8$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $279dc552abf8fdf8$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $279dc552abf8fdf8$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)($279dc552abf8fdf8$var$ExitingContext);
};
$279dc552abf8fdf8$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $279dc552abf8fdf8$export$2e2bcd8739ae039 = $279dc552abf8fdf8$var$ExitingPersistence;


var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $b632dc1fe882e141$export$368bacef0dacbe05 = 25;
var $b632dc1fe882e141$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $b632dc1fe882e141$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $b632dc1fe882e141$export$30fa1a2e62ae150c = {
    none: $b632dc1fe882e141$export$38b928a7167ce124.none,
    small: $b632dc1fe882e141$export$38b928a7167ce124.small * $b632dc1fe882e141$var$EXITING_MOTION_MULTIPLIER,
    medium: $b632dc1fe882e141$export$38b928a7167ce124.medium * $b632dc1fe882e141$var$EXITING_MOTION_MULTIPLIER,
    large: $b632dc1fe882e141$export$38b928a7167ce124.large * $b632dc1fe882e141$var$EXITING_MOTION_MULTIPLIER
};



var $5FkrB = parcelRequire("5FkrB");
var $35f084c9aaa02784$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $35f084c9aaa02784$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $35f084c9aaa02784$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $35f084c9aaa02784$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $35f084c9aaa02784$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};




var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
var $f54de321827ec3b8$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $3c84ce5e603ab806$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $fa4d83632ab91076$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $f55684cf1f3dca29$export$2e2bcd8739ae039)
    };
});
var $fa4d83632ab91076$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $3c84ce5e603ab806$export$c485849f2e393253)();
    var context = (0, $5FkrB.useContext)($fa4d83632ab91076$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $fa4d83632ab91076$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $f54de321827ec3b8$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($fa4d83632ab91076$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $fa4d83632ab91076$export$2e2bcd8739ae039 = $fa4d83632ab91076$var$StaggeredEntrance;


function $1d16079d945cd06c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1d16079d945cd06c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1d16079d945cd06c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1d16079d945cd06c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $1d16079d945cd06c$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $fa4d83632ab91076$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $279dc552abf8fdf8$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $35f084c9aaa02784$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $5FkrB.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        setTimeout(function() {
            if (state === 'exiting') onExitFinished && onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion && onFinishMotion(state);
        }, isExiting ? (0, $b632dc1fe882e141$export$30fa1a2e62ae150c)[duration] : (0, $b632dc1fe882e141$export$38b928a7167ce124)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $74Zh5.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return children({
            ref: staggered.ref,
            className: hasAnimationStyles ? cx(css($1d16079d945cd06c$var$_objectSpread($1d16079d945cd06c$var$_objectSpread({}, (0, $88b27043491c379a$export$f0f789643ba5a83c)), {}, {
                animationDelay: "".concat(delay, "ms"),
                animationFillMode: 'backwards',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                animationName: (0, $74Zh5.keyframes)(enteringAnimation),
                animationPlayState: 'running'
            })), paused && css({
                animationPlayState: 'paused'
            }), duration === 'small' && css({
                animationDuration: '100ms'
            }), duration === 'medium' && css({
                animationDuration: '350ms'
            }), duration === 'large' && css({
                animationDuration: '700ms'
            }), isExiting && duration === 'small' && css({
                animationDuration: '50ms'
            }), isExiting && duration === 'medium' && css({
                animationDuration: '175ms'
            }), isExiting && duration === 'large' && css({
                animationDuration: '350ms'
            }), isExiting && css({
                animationDelay: '0ms',
                animationFillMode: 'forwards',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                animationName: (0, $74Zh5.keyframes)(exitingAnimation)
            }), !isExiting && animationTimingFunction === 'linear' && css({
                animationTimingFunction: 'cubic-bezier(0,0,1,1)'
            }), !isExiting && animationTimingFunction === 'ease-out' && css({
                animationTimingFunction: 'cubic-bezier(0.2,0,0,1)'
            }), !isExiting && animationTimingFunction === 'ease-in' && css({
                animationTimingFunction: 'cubic-bezier(0.8,0,0,0.8)'
            }), !isExiting && animationTimingFunction === 'ease-in-out' && css({
                animationTimingFunction: 'cubic-bezier(0.15,1,0.3,1)'
            }), isExiting && animationTimingFunction === 'linear' && css({
                animationTimingFunction: 'cubic-bezier(0,0,1,1)'
            }), isExiting && animationTimingFunctionExiting === 'ease-out' && css({
                animationTimingFunction: 'cubic-bezier(0.2,0,0,1)'
            }), isExiting && animationTimingFunctionExiting === 'ease-in' && css({
                animationTimingFunction: 'cubic-bezier(0.8,0,0,0.8)'
            }), isExiting && animationTimingFunctionExiting === 'ease-in-out' && css({
                animationTimingFunction: 'cubic-bezier(0.15,1,0.3,1)'
            })) : ''
        }, state);
    });
};
var $1d16079d945cd06c$export$2e2bcd8739ae039 = $1d16079d945cd06c$var$EnteringMotion;


function $bfc9e4af75d9628a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bfc9e4af75d9628a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bfc9e4af75d9628a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bfc9e4af75d9628a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bfc9e4af75d9628a$var$directionMotions = {
    proportional: {
        bottom: 'translate3d(0, calc(5% + 4px), 0)',
        left: 'translate3d(calc(-5% - 4px), 0, 0)',
        right: 'translate3d(calc(5% + 4px), 0, 0)',
        top: 'translate3d(0, calc(-5% - 4px), 0)'
    },
    constant: {
        bottom: 'translate3d(0, 4px, 0)',
        left: 'translate3d(-4px, 0, 0)',
        right: 'translate3d(4px, 0, 0)',
        top: 'translate3d(0, -4px, 0)'
    }
};
var $bfc9e4af75d9628a$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
var $bfc9e4af75d9628a$export$8497679fcaaeceb = function fadeInAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'proportional';
    return {
        from: $bfc9e4af75d9628a$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $bfc9e4af75d9628a$var$directionMotions[distance][direction]
        }),
        '50%': {
            opacity: 1
        },
        to: {
            transform: direction !== undefined ? 'none' : undefined
        }
    };
};
var $bfc9e4af75d9628a$export$c9190c6659ea755b = function fadeOutAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'proportional';
    return {
        from: {
            opacity: 1,
            transform: direction !== undefined ? 'translate3d(0, 0, 0)' : undefined
        },
        to: $bfc9e4af75d9628a$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $bfc9e4af75d9628a$var$directionMotions[distance][direction]
        })
    };
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $bfc9e4af75d9628a$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection && $bfc9e4af75d9628a$var$invertedDirection[entranceDirection];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1d16079d945cd06c$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: $bfc9e4af75d9628a$export$8497679fcaaeceb(entranceDirection, distance),
        exitingAnimation: $bfc9e4af75d9628a$export$c9190c6659ea755b(exitDirection || invertedEntranceDirection, distance),
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $bfc9e4af75d9628a$export$2e2bcd8739ae039 = $bfc9e4af75d9628a$var$FadeIn;



var $fC8ib = parcelRequire("fC8ib");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $lsgol = parcelRequire("lsgol");

var $iYJcE = parcelRequire("iYJcE");
function $431bfc8a03c16322$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}



// Export types from PopperJS / React Popper
var $735ad51c25367946$var$viewportPadding = 5;
var $735ad51c25367946$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $735ad51c25367946$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $735ad51c25367946$var$defaultChildrenFn() {
    return null;
}
var $735ad51c25367946$var$defaultOffset = [
    0,
    8
];
function $735ad51c25367946$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $735ad51c25367946$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $735ad51c25367946$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $5FkrB.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $735ad51c25367946$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $431bfc8a03c16322$export$6d8c2b45c99d6e3f)({
            viewportPadding: $735ad51c25367946$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($735ad51c25367946$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $5FkrB.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $lsgol.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}



var $5FkrB = parcelRequire("5FkrB");

var $9dOvm = parcelRequire("9dOvm");
var $1597fd734f6e48a1$var$_process, $1597fd734f6e48a1$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $1597fd734f6e48a1$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($1597fd734f6e48a1$var$_process = globalThis.process) === null || $1597fd734f6e48a1$var$_process === void 0 || ($1597fd734f6e48a1$var$_process = $1597fd734f6e48a1$var$_process.env) === null || $1597fd734f6e48a1$var$_process === void 0 ? void 0 : $1597fd734f6e48a1$var$_process.JEST_WORKER_ID) !== undefined;
var $1597fd734f6e48a1$var$DEBUG_MODE = !$1597fd734f6e48a1$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($1597fd734f6e48a1$var$_process2 = globalThis.process) === null || $1597fd734f6e48a1$var$_process2 === void 0 || ($1597fd734f6e48a1$var$_process2 = $1597fd734f6e48a1$var$_process2.env) === null || $1597fd734f6e48a1$var$_process2 === void 0 ? void 0 : $1597fd734f6e48a1$var$_process2.NODE_ENV) !== 'production';
var $1597fd734f6e48a1$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$1597fd734f6e48a1$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $904e775697a81ba5$var$pkgName = '@atlaskit/platform-feature-flags';
var $904e775697a81ba5$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $904e775697a81ba5$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $904e775697a81ba5$var$ENV_ENABLE_PLATFORM_FF = $904e775697a81ba5$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $904e775697a81ba5$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $904e775697a81ba5$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $904e775697a81ba5$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $904e775697a81ba5$var$ENV_ENABLE_PLATFORM_FF || $904e775697a81ba5$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $904e775697a81ba5$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $904e775697a81ba5$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$904e775697a81ba5$var$globalVar[$904e775697a81ba5$export$7e41b1b2bdee3f98] = $904e775697a81ba5$var$globalVar[$904e775697a81ba5$export$7e41b1b2bdee3f98] || $904e775697a81ba5$var$DEFAULT_PFF_GLOBAL;
function $904e775697a81ba5$export$f2b591175b3e424c(resolver) {
    $904e775697a81ba5$var$globalVar[$904e775697a81ba5$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $904e775697a81ba5$export$6333b6aff9fc6275(flagKey) {
    if ($904e775697a81ba5$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $1597fd734f6e48a1$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $904e775697a81ba5$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $904e775697a81ba5$var$globalVar[$904e775697a81ba5$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $904e775697a81ba5$var$globalVar[$904e775697a81ba5$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $9dOvm.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $904e775697a81ba5$var$globalVar[$904e775697a81ba5$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $23a342bf96c83528$export$ba05d765b8392e5e(flagResolver) {
    (0, $904e775697a81ba5$export$f2b591175b3e424c)(flagResolver);
}
function $23a342bf96c83528$export$470e5c2be1411c89(name) {
    return (0, $904e775697a81ba5$export$6333b6aff9fc6275)(name);
}
function $23a342bf96c83528$export$b40ec24ac8275656(name) {
    return (0, $904e775697a81ba5$export$6333b6aff9fc6275)(name);
}



var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");
var $e23d32067a752065$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $e23d32067a752065$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $e23d32067a752065$export$13f57c02915787b3 = 'atlaskit-portal';


var $1e742c1d47ccd862$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $e23d32067a752065$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $1e742c1d47ccd862$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $1e742c1d47ccd862$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $e23d32067a752065$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $e23d32067a752065$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $1e742c1d47ccd862$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $1e742c1d47ccd862$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $1e742c1d47ccd862$var$getPortalParent().removeChild(container);
};
var $1e742c1d47ccd862$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $1e742c1d47ccd862$var$getPortalParent().appendChild(container);
};
var $1e742c1d47ccd862$export$842dfe7a9f24298 = function isDocumentDefined() {
    return document !== undefined;
};
var $1e742c1d47ccd862$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($1e742c1d47ccd862$export$842dfe7a9f24298()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $e23d32067a752065$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $1e742c1d47ccd862$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($1e742c1d47ccd862$export$842dfe7a9f24298()) {
        var parentElement = document.querySelector((0, $e23d32067a752065$export$72f415121273627e));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $e23d32067a752065$export$e4c79eb95c23a0da);
            parent.style.display = 'flex';
            (_getBody2 = $1e742c1d47ccd862$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};


function $c1991d6d9bd46da5$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $5FkrB.useMemo)(function() {
        return (0, $1e742c1d47ccd862$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $1e742c1d47ccd862$export$c582005add11e141)(container);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            (0, $1e742c1d47ccd862$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $aLeHs.createPortal)(children, container);
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");


var $5FkrB = parcelRequire("5FkrB");
var $b8e2dddaa7a08a03$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5FkrB.useLayoutEffect) : (0, $5FkrB.useEffect);



function $8ba2d3c420b3f943$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $b8e2dddaa7a08a03$export$700979bc83e7db82)(function() {
        var tempPortalContainer = (0, $1e742c1d47ccd862$export$fef014d7cef9e543)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $1e742c1d47ccd862$export$95029ca7aca2989e)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * Conditionally wrap ALL portal children with Suspense behind a feature gate for safe rollout.
   *
   * This is here because in React 18 concurrent, if you suspend from _within_ a portal to a
   * suspense boundary _outside_ a portal, our portal gets in an infinite loop of re-rendering.
   */ var conditionallySuspendedChildren = (0, $23a342bf96c83528$export$b40ec24ac8275656)('platform_design_system_suspend_portal_children') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Suspense), {
        fallback: null
    }, children) : children;
    return atlaskitPortal ? /*#__PURE__*/ (0, $aLeHs.createPortal)(conditionallySuspendedChildren, atlaskitPortal) : null;
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $47a7238a4812c9dc$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $b8e2dddaa7a08a03$export$700979bc83e7db82) : (0, $5FkrB.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $47a7238a4812c9dc$export$2e2bcd8739ae039 = $47a7238a4812c9dc$var$useIsSubsequentRender;



var $5FkrB = parcelRequire("5FkrB");
var $de9cd8831c03e991$export$ed5835cc67e87f72 = 'akPortalMount';
var $de9cd8831c03e991$export$80816bd900e5bd00 = 'akPortalUnmount';


var $af305d709bd22dc8$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $af305d709bd22dc8$var$getLayerName = function getLayerName(zIndex) {
    return $af305d709bd22dc8$var$zIndexToName.hasOwnProperty(zIndex) ? $af305d709bd22dc8$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $af305d709bd22dc8$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $af305d709bd22dc8$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $af305d709bd22dc8$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $af305d709bd22dc8$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $317ffa1a2ed520bc$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $5FkrB.useEffect)(function() {
        (0, $af305d709bd22dc8$export$2e2bcd8739ae039)((0, $de9cd8831c03e991$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $af305d709bd22dc8$export$2e2bcd8739ae039)((0, $de9cd8831c03e991$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $317ffa1a2ed520bc$export$2e2bcd8739ae039 = $317ffa1a2ed520bc$var$useFirePortalEvent;


function $3abdb7aea1ec0147$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $47a7238a4812c9dc$export$2e2bcd8739ae039)(mountStrategy);
    (0, $317ffa1a2ed520bc$export$2e2bcd8739ae039)(zIndex);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return !(0, $23a342bf96c83528$export$b40ec24ac8275656)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c1991d6d9bd46da5$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8ba2d3c420b3f943$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children);
}


/* eslint-disable no-console */ var $b3e12cd82bd89e1a$var$printed = {};
function $b3e12cd82bd89e1a$export$2e2bcd8739ae039(message) {
    if ($b3e12cd82bd89e1a$var$printed[message]) return;
    $b3e12cd82bd89e1a$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}



var $3ZMUU = parcelRequire("3ZMUU");
function $3e78f3b7a8138316$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $b3e12cd82bd89e1a$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $3e78f3b7a8138316$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $3ZMUU;
}


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $4748d5438bd47003$export$4b84fd0e2c617bd = '#FFEBE6';
var $4748d5438bd47003$export$b34b069eff244586 = '#FFBDAD';
var $4748d5438bd47003$export$be802dd0d8b57f35 = '#FF8F73';
var $4748d5438bd47003$export$60847d42f9da92a6 = '#FF7452';
var $4748d5438bd47003$export$4a7404f376229999 = '#FF5630';
var $4748d5438bd47003$export$2010d0fb4295b346 = '#DE350B';
var $4748d5438bd47003$export$2837b5a1a71d5c02 = '#BF2600';
var $4748d5438bd47003$export$8d9596b529bbb9cf = '#FFFAE6';
var $4748d5438bd47003$export$41060a744ab0b7ae = '#FFF0B3';
var $4748d5438bd47003$export$1cc05bbbf340e559 = '#FFE380';
var $4748d5438bd47003$export$5aae31392d72caaa = '#FFC400';
var $4748d5438bd47003$export$c6930421db9fa514 = '#FFAB00';
var $4748d5438bd47003$export$59619663aa6500fb = '#FF991F';
var $4748d5438bd47003$export$874739ea9e379ab6 = '#FF8B00';
var $4748d5438bd47003$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $4748d5438bd47003$export$69a3bf21b9686c2b = '#ABF5D1';
var $4748d5438bd47003$export$afbce1382ec95f73 = '#79F2C0';
var $4748d5438bd47003$export$747d86715d4175de = '#57D9A3';
var $4748d5438bd47003$export$940e1f69e873f202 = '#36B37E';
var $4748d5438bd47003$export$a49394138f7b8e85 = '#00875A';
var $4748d5438bd47003$export$6fa04827ac68a4fb = '#006644';
var $4748d5438bd47003$export$226de0355ed012f8 = '#DEEBFF';
var $4748d5438bd47003$export$8c13c2ee36917869 = '#B3D4FF';
var $4748d5438bd47003$export$ecfc1dff386a3e7a = '#4C9AFF';
var $4748d5438bd47003$export$215b7063051591f1 = '#2684FF';
var $4748d5438bd47003$export$e62e8919cca44969 = '#0065FF';
var $4748d5438bd47003$export$b3de0ae08da2ce64 = '#0052CC';
var $4748d5438bd47003$export$a6ee3d71bc067634 = '#0747A6';
var $4748d5438bd47003$export$67f15409e87642a1 = '#669DF1';
var $4748d5438bd47003$export$f0539dbc42dbb067 = '#8FB8F6';
var $4748d5438bd47003$export$363e4475840015bb = '#EAE6FF';
var $4748d5438bd47003$export$4b0a4417ed59760f = '#C0B6F2';
var $4748d5438bd47003$export$6011520a64d9a187 = '#998DD9';
var $4748d5438bd47003$export$a7175d4e9206bc80 = '#8777D9';
var $4748d5438bd47003$export$b48405b95304b5a1 = '#6554C0';
var $4748d5438bd47003$export$c71e4279dd54a18d = '#5243AA';
var $4748d5438bd47003$export$147899de772240ec = '#403294';
var $4748d5438bd47003$export$2cf711fe14c66f06 = '#E6FCFF';
var $4748d5438bd47003$export$7a8f4d33f6f9772c = '#B3F5FF';
var $4748d5438bd47003$export$776c9c497ef08533 = '#79E2F2';
var $4748d5438bd47003$export$69cb3ca10c1e330e = '#00C7E6';
var $4748d5438bd47003$export$9dc1ef0f3f48059b = '#00B8D9';
var $4748d5438bd47003$export$7c835c78b6fcdef8 = '#00A3BF';
var $4748d5438bd47003$export$6036577f95c3877e = '#008DA6';
var $4748d5438bd47003$export$29a4f05edc054374 = '#FFFFFF';
var $4748d5438bd47003$export$e655ef011c4aa1a2 = '#FAFBFC';
var $4748d5438bd47003$export$9fdfb749e33cdf97 = '#F4F5F7';
var $4748d5438bd47003$export$3e51e8f1440314ba = '#EBECF0';
var $4748d5438bd47003$export$1ce2d1575d444ceb = '#DFE1E6';
var $4748d5438bd47003$export$8754fc7e6d8b3000 = '#C1C7D0';
var $4748d5438bd47003$export$c2e91cbeada39b8b = '#B3BAC5';
var $4748d5438bd47003$export$5f71e19f3a7ad9de = '#A5ADBA';
var $4748d5438bd47003$export$eaa8c8a70ac22806 = '#97A0AF';
var $4748d5438bd47003$export$7c87d337fb91a97d = '#8993A4';
var $4748d5438bd47003$export$d6447c357493214f = '#7A869A';
var $4748d5438bd47003$export$f563ee71e9ee74cd = '#6B778C';
var $4748d5438bd47003$export$e2ef2124cf4024b1 = '#5E6C84';
var $4748d5438bd47003$export$eece5f492e429f08 = '#505F79';
var $4748d5438bd47003$export$c39c0fe0f26207ae = '#42526E';
var $4748d5438bd47003$export$7090862dc3038a9f = '#344563';
var $4748d5438bd47003$export$ad0bacf983b7ddaa = '#253858';
var $4748d5438bd47003$export$7d61b15e0da132af = '#172B4D';
var $4748d5438bd47003$export$fbda843f0a27fe96 = '#091E42';
var $4748d5438bd47003$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $4748d5438bd47003$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $4748d5438bd47003$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $4748d5438bd47003$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $4748d5438bd47003$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $4748d5438bd47003$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $4748d5438bd47003$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $4748d5438bd47003$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $4748d5438bd47003$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $4748d5438bd47003$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $4748d5438bd47003$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $4748d5438bd47003$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $4748d5438bd47003$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $4748d5438bd47003$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $4748d5438bd47003$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $4748d5438bd47003$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $4748d5438bd47003$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $4748d5438bd47003$export$2f6319cf7d736c2a = '#E6EDFA';
var $4748d5438bd47003$export$95126bc8884d6634 = '#DCE5F5';
var $4748d5438bd47003$export$8338d8c35d44ff1 = '#CED9EB';
var $4748d5438bd47003$export$5368d76ae4fbbda7 = '#B8C7E0';
var $4748d5438bd47003$export$9f0a771d16ec8d36 = '#ABBBD6';
var $4748d5438bd47003$export$abcf8c38338b4aa5 = '#9FB0CC';
var $4748d5438bd47003$export$97e81faa16a182c7 = '#8C9CB8';
var $4748d5438bd47003$export$bfe21c59123ecf33 = '#7988A3';
var $4748d5438bd47003$export$ee82aa2ea6a1558 = '#67758F';
var $4748d5438bd47003$export$682927c6ed76be02 = '#56637A';
var $4748d5438bd47003$export$91fd9994c5be9757 = '#455166';
var $4748d5438bd47003$export$d281fbfe3cff2df6 = '#3B475C';
var $4748d5438bd47003$export$3902c91d8b98a753 = '#313D52';
var $4748d5438bd47003$export$8e8133c1ba5845b5 = '#283447';
var $4748d5438bd47003$export$33ff357f6620b39 = '#202B3D';
var $4748d5438bd47003$export$633847cf062b69e0 = '#1B2638';
var $4748d5438bd47003$export$9776a6e503bdbf76 = '#121A29';
var $4748d5438bd47003$export$6c813d5160dff5db = '#0E1624';
var $4748d5438bd47003$export$3d4f271a500072a = '#0D1424';
var $4748d5438bd47003$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $4748d5438bd47003$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $4748d5438bd47003$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $4748d5438bd47003$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $4748d5438bd47003$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $4748d5438bd47003$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $4748d5438bd47003$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $4748d5438bd47003$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $4748d5438bd47003$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $4748d5438bd47003$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $4748d5438bd47003$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $4748d5438bd47003$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $4748d5438bd47003$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $4748d5438bd47003$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $4748d5438bd47003$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $4748d5438bd47003$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $4748d5438bd47003$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $4748d5438bd47003$export$d2adc5dedf09fced = '#292A2E';
var $4748d5438bd47003$export$f51762073d2bb381 = '#94C748';
var $4748d5438bd47003$export$95e26d54def96891 = '#B3DF72';


var $0c8e19e93cb2da94$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $0c8e19e93cb2da94$export$c93026a968943f95 = 'light';
var $0c8e19e93cb2da94$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $0c8e19e93cb2da94$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $0c8e19e93cb2da94$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $0c8e19e93cb2da94$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $4748d5438bd47003$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0c8e19e93cb2da94$export$6d8204c2cb2e06b8() / 4;
    (0, $3e78f3b7a8138316$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $0c8e19e93cb2da94$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $0c8e19e93cb2da94$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $0c8e19e93cb2da94$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $3e78f3b7a8138316$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $0c8e19e93cb2da94$export$ba1d834b86d72a09 = $0c8e19e93cb2da94$export$a1b3edb637fb4f35;
var $0c8e19e93cb2da94$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $4748d5438bd47003$export$8d43898f60b96a82), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $4748d5438bd47003$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $4748d5438bd47003$export$920c0d5c49070351), ")")
            }
        }
    };
};


/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $7QpUe = parcelRequire("7QpUe");
var $3fb05a65cf6cee28$var$registrations = new Set();
var $3fb05a65cf6cee28$var$cleanupEndEventListeners = null;
function $3fb05a65cf6cee28$var$onDragStart() {
    if ($3fb05a65cf6cee28$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $3fb05a65cf6cee28$var$cleanupEndEventListeners = (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragend',
            listener: $3fb05a65cf6cee28$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $3fb05a65cf6cee28$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $3fb05a65cf6cee28$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($3fb05a65cf6cee28$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $3fb05a65cf6cee28$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $3fb05a65cf6cee28$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $3fb05a65cf6cee28$var$cleanupEndEventListeners = null;
    var clone = Array.from($3fb05a65cf6cee28$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $3fb05a65cf6cee28$var$bindStartEvents() {
    return (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $3fb05a65cf6cee28$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $3fb05a65cf6cee28$var$onDragStart
        }
    ]);
}
var $3fb05a65cf6cee28$var$cleanupStartEventListeners = null;
function $3fb05a65cf6cee28$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$3fb05a65cf6cee28$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $3fb05a65cf6cee28$var$cleanupStartEventListeners = $3fb05a65cf6cee28$var$bindStartEvents();
    $3fb05a65cf6cee28$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $3fb05a65cf6cee28$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $3fb05a65cf6cee28$var$registrations.delete(registration);
        if ($3fb05a65cf6cee28$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $3fb05a65cf6cee28$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $3fb05a65cf6cee28$var$cleanupStartEventListeners = null;
        }
    };
}


var $70aecbd0a333968d$var$delayId = null;
function $70aecbd0a333968d$export$eaf678f6f93f5250() {
    if ($70aecbd0a333968d$var$delayId != null) {
        window.clearTimeout($70aecbd0a333968d$var$delayId);
        $70aecbd0a333968d$var$delayId = null;
    }
}
function $70aecbd0a333968d$export$5f4d6617421d489b(fn, delay) {
    $70aecbd0a333968d$export$eaf678f6f93f5250();
    $70aecbd0a333968d$var$delayId = window.setTimeout(function() {
        $70aecbd0a333968d$var$delayId = null;
        fn();
    }, delay);
}


// This file is a singleton for managing tooltips
var $5515db908e246707$var$active = null;
function $5515db908e246707$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($5515db908e246707$var$active && $5515db908e246707$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $70aecbd0a333968d$export$eaf678f6f93f5250)();
            $5515db908e246707$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $70aecbd0a333968d$export$eaf678f6f93f5250)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $70aecbd0a333968d$export$eaf678f6f93f5250)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $70aecbd0a333968d$export$5f4d6617421d489b)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($5515db908e246707$var$active && $5515db908e246707$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($5515db908e246707$var$active) {
            (0, $70aecbd0a333968d$export$eaf678f6f93f5250)();
            $5515db908e246707$var$active.entry.hide({
                isImmediate: true
            });
            $5515db908e246707$var$active.entry.done();
            $5515db908e246707$var$active = null;
        }
        // this tooltip is now the active tooltip
        $5515db908e246707$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $70aecbd0a333968d$export$5f4d6617421d489b)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}



var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $9dOvm = parcelRequire("9dOvm");
var $ab1dcb1991467b18$var$_process, $ab1dcb1991467b18$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $ab1dcb1991467b18$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($ab1dcb1991467b18$var$_process = globalThis.process) === null || $ab1dcb1991467b18$var$_process === void 0 || ($ab1dcb1991467b18$var$_process = $ab1dcb1991467b18$var$_process.env) === null || $ab1dcb1991467b18$var$_process === void 0 ? void 0 : $ab1dcb1991467b18$var$_process.JEST_WORKER_ID) !== undefined;
var $ab1dcb1991467b18$var$DEBUG_MODE = !$ab1dcb1991467b18$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($ab1dcb1991467b18$var$_process2 = globalThis.process) === null || $ab1dcb1991467b18$var$_process2 === void 0 || ($ab1dcb1991467b18$var$_process2 = $ab1dcb1991467b18$var$_process2.env) === null || $ab1dcb1991467b18$var$_process2 === void 0 ? void 0 : $ab1dcb1991467b18$var$_process2.NODE_ENV) !== 'production';
var $ab1dcb1991467b18$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$ab1dcb1991467b18$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $437c64e2a29d911e$var$pkgName = '@atlaskit/platform-feature-flags';
var $437c64e2a29d911e$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $437c64e2a29d911e$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $437c64e2a29d911e$var$ENV_ENABLE_PLATFORM_FF = $437c64e2a29d911e$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $437c64e2a29d911e$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $437c64e2a29d911e$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $437c64e2a29d911e$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $437c64e2a29d911e$var$ENV_ENABLE_PLATFORM_FF || $437c64e2a29d911e$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $437c64e2a29d911e$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $437c64e2a29d911e$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$437c64e2a29d911e$var$globalVar[$437c64e2a29d911e$export$7e41b1b2bdee3f98] = $437c64e2a29d911e$var$globalVar[$437c64e2a29d911e$export$7e41b1b2bdee3f98] || $437c64e2a29d911e$var$DEFAULT_PFF_GLOBAL;
function $437c64e2a29d911e$export$f2b591175b3e424c(resolver) {
    $437c64e2a29d911e$var$globalVar[$437c64e2a29d911e$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $437c64e2a29d911e$export$6333b6aff9fc6275(flagKey) {
    if ($437c64e2a29d911e$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $ab1dcb1991467b18$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $437c64e2a29d911e$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $437c64e2a29d911e$var$globalVar[$437c64e2a29d911e$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $437c64e2a29d911e$var$globalVar[$437c64e2a29d911e$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $9dOvm.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $437c64e2a29d911e$var$globalVar[$437c64e2a29d911e$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $4bf30f191507fd9b$export$ba05d765b8392e5e(flagResolver) {
    (0, $437c64e2a29d911e$export$f2b591175b3e424c)(flagResolver);
}
function $4bf30f191507fd9b$export$470e5c2be1411c89(name) {
    return (0, $437c64e2a29d911e$export$6333b6aff9fc6275)(name);
}
function $4bf30f191507fd9b$export$b40ec24ac8275656(name) {
    return (0, $437c64e2a29d911e$export$6333b6aff9fc6275)(name);
}


var $525e27f050c3aec7$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $525e27f050c3aec7$var$react18UseId = ($525e27f050c3aec7$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $525e27f050c3aec7$var$_React$useId !== void 0 ? $525e27f050c3aec7$var$_React$useId : undefined;
function $525e27f050c3aec7$export$f680877a34711e37() {
    if ($525e27f050c3aec7$var$react18UseId && (0, $4bf30f191507fd9b$export$b40ec24ac8275656)('platform.design-system-team.react-18-use-id_mn8q4')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $525e27f050c3aec7$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $525e27f050c3aec7$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($525e27f050c3aec7$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $525e27f050c3aec7$export$6ee17796e3d70de2() {
    if ($525e27f050c3aec7$var$react18UseId && (0, $4bf30f191507fd9b$export$b40ec24ac8275656)('platform.design-system-team.react-18-use-id_mn8q4')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $525e27f050c3aec7$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $b5lkZ.useUIDSeed)();
}


function $7fff18844a4532fa$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $525e27f050c3aec7$export$6ee17796e3d70de2)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}


/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $atP8S = parcelRequire("atP8S");/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $5fe71ee65ce166ce$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}




var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

function $b541aaa6481d2a8e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b541aaa6481d2a8e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b541aaa6481d2a8e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b541aaa6481d2a8e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b541aaa6481d2a8e$var$VAR_PRIMITIVE_ZINDEX = 'tooltipPrimitiveZindex';
var $b541aaa6481d2a8e$var$primitiveStyles = (0, $74Zh5.css)({
    zindex: "var(".concat($b541aaa6481d2a8e$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
/**
 * The lower level component for rendering a tooltip.
 */ var $b541aaa6481d2a8e$var$TooltipPrimitive = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $b541aaa6481d2a8e$var$_objectSpread($b541aaa6481d2a8e$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $b541aaa6481d2a8e$var$VAR_PRIMITIVE_ZINDEX, (0, $0c8e19e93cb2da94$export$7be255094ccdc533).tooltip()));
    return (0, $74Zh5.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $74Zh5.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $b541aaa6481d2a8e$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$b541aaa6481d2a8e$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $b541aaa6481d2a8e$export$2e2bcd8739ae039 = $b541aaa6481d2a8e$var$TooltipPrimitive;


function $f1cc677f1dc309ad$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f1cc677f1dc309ad$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f1cc677f1dc309ad$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f1cc677f1dc309ad$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f1cc677f1dc309ad$var$baseStyles = null;
var $f1cc677f1dc309ad$var$truncateStyles = null;
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $f1cc677f1dc309ad$var$TooltipContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $5FkrB.createElement((0, $b541aaa6481d2a8e$export$2e2bcd8739ae039), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $atP8S.default)([
            "_2rko1sit _11c8qk37 _vchhusvi _p12fp3fh _bfhkpioe _syaz1i9p _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        style: $f1cc677f1dc309ad$var$_objectSpread($f1cc677f1dc309ad$var$_objectSpread({}, style), {}, {
            "--_yr7xfv": (0, $5fe71ee65ce166ce$export$2e2bcd8739ae039)("var(--ds-background-neutral-bold, ".concat((0, $4748d5438bd47003$export$7d61b15e0da132af), ")")),
            "--_ywovvi": (0, $5fe71ee65ce166ce$export$2e2bcd8739ae039)("var(--ds-text-inverse, ".concat((0, $4748d5438bd47003$export$29a4f05edc054374), ")"))
        })
    }, children);
});
$f1cc677f1dc309ad$var$TooltipContainer.displayName = 'TooltipContainer';
var $f1cc677f1dc309ad$export$2e2bcd8739ae039 = $f1cc677f1dc309ad$var$TooltipContainer;


function $ed200d612346c171$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}


function $1ee6819d2d8fb6a1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1ee6819d2d8fb6a1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1ee6819d2d8fb6a1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1ee6819d2d8fb6a1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1ee6819d2d8fb6a1$var$tooltipZIndex = (0, $0c8e19e93cb2da94$export$7be255094ccdc533).tooltip();
var $1ee6819d2d8fb6a1$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "19.2.0"
};
// Inverts motion direction
var $1ee6819d2d8fb6a1$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $1ee6819d2d8fb6a1$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $1ee6819d2d8fb6a1$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $f1cc677f1dc309ad$export$2e2bcd8739ae039) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $f55684cf1f3dca29$export$2e2bcd8739ae039) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $f55684cf1f3dca29$export$2e2bcd8739ae039) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn;
    var tooltipPosition = position === 'mouse' ? mousePosition : position;
    var onShowHandler = (0, $ff1b37318b494b6a$export$1a04351537078b55)($1ee6819d2d8fb6a1$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $1ee6819d2d8fb6a1$var$analyticsAttributes));
    var onHideHandler = (0, $ff1b37318b494b6a$export$1a04351537078b55)($1ee6819d2d8fb6a1$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $1ee6819d2d8fb6a1$var$analyticsAttributes));
    var apiRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $5FkrB.useRef)(null);
    var containerRef = (0, $5FkrB.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $5FkrB.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $3410b820897135a6$export$2e2bcd8739ae039)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $3410b820897135a6$export$2e2bcd8739ae039)(onShowHandler);
    var onHideHandlerStable = (0, $3410b820897135a6$export$2e2bcd8739ae039)(onHideHandler);
    var delayStable = (0, $3410b820897135a6$export$2e2bcd8739ae039)(delay);
    var canAppearStable = (0, $3410b820897135a6$export$2e2bcd8739ae039)(canAppear);
    var hasCalledShowHandler = (0, $5FkrB.useRef)(false);
    var start = (0, $5FkrB.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $5FkrB.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $5FkrB.useRef)(false);
    (0, $5FkrB.useEffect)(function() {
        return (0, $3fb05a65cf6cee28$export$6503ec6e8aabbaf)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $5FkrB.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        var api = (0, $5515db908e246707$export$57bf213be019eeb0)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $29facb65b1c1eae8$export$2e2bcd8739ae039)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $5FkrB.useEffect)(function() {
        if (state === 'hide') return 0, $f55684cf1f3dca29$export$2e2bcd8739ae039;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $ed200d612346c171$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === 'mouse' ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $ed200d612346c171$export$642213d516a9b928)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $5FkrB.useCallback)(function() {
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $5FkrB.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    (0, $3d52fdcb58caf93d$export$469bb693f11edc7f)({
        isOpen: shouldRenderTooltipPopup
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current4;
        if (position === 'mouse' && (_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.mousePosition) {
            var _apiRef$current5;
            return (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 ? void 0 : _apiRef$current5.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $7fff18844a4532fa$export$2e2bcd8739ae039)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $5FkrB.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children($1ee6819d2d8fb6a1$var$_objectSpread($1ee6819d2d8fb6a1$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3abdb7aea1ec0147$export$2e2bcd8739ae039), {
        zIndex: $1ee6819d2d8fb6a1$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $735ad51c25367946$export$badac9ada3a0bdf9), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === 'mouse' ? undefined : $1ee6819d2d8fb6a1$var$invertedDirection[$1ee6819d2d8fb6a1$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $279dc552abf8fdf8$export$2e2bcd8739ae039), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bfc9e4af75d9628a$export$2e2bcd8739ae039), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $1ee6819d2d8fb6a1$var$_objectSpread($1ee6819d2d8fb6a1$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$1ee6819d2d8fb6a1$var$Tooltip.displayName = 'Tooltip';
var $1ee6819d2d8fb6a1$export$2e2bcd8739ae039 = $1ee6819d2d8fb6a1$var$Tooltip;



var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

function $11472afca28cc3f2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $11472afca28cc3f2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $11472afca28cc3f2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $11472afca28cc3f2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $11472afca28cc3f2$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $11472afca28cc3f2$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $11472afca28cc3f2$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $11472afca28cc3f2$export$632685d741f3dbbf = $11472afca28cc3f2$var$_objectSpread($11472afca28cc3f2$var$_objectSpread({}, $11472afca28cc3f2$export$958d0ae7f2977ae4), $11472afca28cc3f2$export$d2dc61f58390201c);
var $11472afca28cc3f2$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $11472afca28cc3f2$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $11472afca28cc3f2$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $11472afca28cc3f2$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $11472afca28cc3f2$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $11472afca28cc3f2$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $11472afca28cc3f2$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $11472afca28cc3f2$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $11472afca28cc3f2$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $11472afca28cc3f2$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $11472afca28cc3f2$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $11472afca28cc3f2$export$6cc560b4dedf3816 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $11472afca28cc3f2$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $11472afca28cc3f2$export$3c7e9587132614b4 = {
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $11472afca28cc3f2$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $11472afca28cc3f2$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $11472afca28cc3f2$export$e615f061ca585a6c = $11472afca28cc3f2$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $11472afca28cc3f2$var$getSerializedStylesMap(spacingProperty, $11472afca28cc3f2$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $11472afca28cc3f2$export$bf46c3f9eeafc71f = $11472afca28cc3f2$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $11472afca28cc3f2$var$getSerializedStylesMap(spacingProperty, $11472afca28cc3f2$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $11472afca28cc3f2$export$e7af83bafe7f9e63 = $11472afca28cc3f2$var$getSerializedStylesMap('backgroundColor', $11472afca28cc3f2$export$d1d79bf68ac056bd);
var $11472afca28cc3f2$export$3a1bcba60b23d7f0 = $11472afca28cc3f2$var$getSerializedStylesMap('color', $11472afca28cc3f2$export$8473307aa00d6ea1);
var $11472afca28cc3f2$export$45f3f4fe16f9f7d5 = $11472afca28cc3f2$var$getSerializedStylesMap('fontWeight', $11472afca28cc3f2$export$303e322c6b1ed114);
var $11472afca28cc3f2$export$68cc305da27dbaa4 = $11472afca28cc3f2$var$getSerializedStylesMap('fontFamily', $11472afca28cc3f2$export$3c7e9587132614b4);
var $11472afca28cc3f2$export$128f10c238242f83 = $11472afca28cc3f2$var$getSerializedStylesMap('font', $11472afca28cc3f2$export$6cc560b4dedf3816);
var $11472afca28cc3f2$export$ff257d957d48c421 = $11472afca28cc3f2$var$getSerializedStylesMap((0, $59e7965bd64289a3$export$9d7b58831ae93caa), $11472afca28cc3f2$export$41a358c9c2356760);
var $11472afca28cc3f2$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $11472afca28cc3f2$export$41a358c9c2356760[color] !== undefined;
};



var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $74Zh5 = parcelRequire("74Zh5");


var $3ZMUU = parcelRequire("3ZMUU");
function $7c2f920c3bda89b1$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $7c2f920c3bda89b1$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $7c2f920c3bda89b1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7c2f920c3bda89b1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7c2f920c3bda89b1$var$_arrayLikeToArray(o, minLen);
}
function $7c2f920c3bda89b1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $7c2f920c3bda89b1$export$9a199fbafee0014e = {
    backgroundColor: (0, $11472afca28cc3f2$export$d1d79bf68ac056bd),
    blockSize: (0, $11472afca28cc3f2$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $11472afca28cc3f2$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $11472afca28cc3f2$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $11472afca28cc3f2$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $11472afca28cc3f2$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $11472afca28cc3f2$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $11472afca28cc3f2$export$e1b83c5210c471b8),
    borderBottomColor: (0, $11472afca28cc3f2$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $11472afca28cc3f2$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $11472afca28cc3f2$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $11472afca28cc3f2$export$e1b83c5210c471b8),
    borderColor: (0, $11472afca28cc3f2$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $11472afca28cc3f2$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $11472afca28cc3f2$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $11472afca28cc3f2$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $11472afca28cc3f2$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $11472afca28cc3f2$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $11472afca28cc3f2$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $11472afca28cc3f2$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $11472afca28cc3f2$export$e1b83c5210c471b8),
    borderLeftColor: (0, $11472afca28cc3f2$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $11472afca28cc3f2$export$e1b83c5210c471b8),
    borderRadius: (0, $11472afca28cc3f2$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $11472afca28cc3f2$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $11472afca28cc3f2$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $11472afca28cc3f2$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $11472afca28cc3f2$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $11472afca28cc3f2$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $11472afca28cc3f2$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $11472afca28cc3f2$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $11472afca28cc3f2$export$e1b83c5210c471b8),
    borderWidth: (0, $11472afca28cc3f2$export$e1b83c5210c471b8),
    bottom: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    boxShadow: (0, $11472afca28cc3f2$export$7aff6e7ba39bb774),
    color: (0, $11472afca28cc3f2$export$8473307aa00d6ea1),
    columnGap: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    gap: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    height: (0, $11472afca28cc3f2$export$6ccdbebca2ee545f),
    inlineSize: (0, $11472afca28cc3f2$export$6ccdbebca2ee545f),
    inset: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    insetBlock: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    insetBlockEnd: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    insetBlockStart: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    insetInline: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    insetInlineEnd: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    insetInlineStart: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    left: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    margin: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    marginBlock: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    marginBlockEnd: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    marginBlockStart: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    marginBottom: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    marginInline: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    marginInlineEnd: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    marginInlineStart: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    marginLeft: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    marginRight: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    marginTop: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    maxBlockSize: (0, $11472afca28cc3f2$export$6ccdbebca2ee545f),
    maxHeight: (0, $11472afca28cc3f2$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $11472afca28cc3f2$export$6ccdbebca2ee545f),
    maxWidth: (0, $11472afca28cc3f2$export$6ccdbebca2ee545f),
    minBlockSize: (0, $11472afca28cc3f2$export$6ccdbebca2ee545f),
    minHeight: (0, $11472afca28cc3f2$export$6ccdbebca2ee545f),
    minInlineSize: (0, $11472afca28cc3f2$export$6ccdbebca2ee545f),
    minWidth: (0, $11472afca28cc3f2$export$6ccdbebca2ee545f),
    opacity: (0, $11472afca28cc3f2$export$daf94a976c798b4f),
    outlineColor: (0, $11472afca28cc3f2$export$1531ad5bb3fbedac),
    outlineOffset: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    outlineWidth: (0, $11472afca28cc3f2$export$e1b83c5210c471b8),
    padding: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    paddingBlock: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    paddingBottom: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    paddingInline: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    paddingLeft: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    paddingRight: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    paddingTop: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    right: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    rowGap: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    top: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    width: (0, $11472afca28cc3f2$export$6ccdbebca2ee545f),
    zIndex: (0, $11472afca28cc3f2$export$b5f31a7e431d2eab)
};
var $7c2f920c3bda89b1$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $7c2f920c3bda89b1$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU.env) === 'object' && false;
};
var $7c2f920c3bda89b1$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $7c2f920c3bda89b1$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $7c2f920c3bda89b1$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && $7c2f920c3bda89b1$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($7c2f920c3bda89b1$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($7c2f920c3bda89b1$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $7c2f920c3bda89b1$export$9a199fbafee0014e)) return;
        var tokenValue = $7c2f920c3bda89b1$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $7c2f920c3bda89b1$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $7c2f920c3bda89b1$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $7c2f920c3bda89b1$var$uniqueSymbol, (0, $74Zh5.css)(transformedStyles));
};
var $7c2f920c3bda89b1$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $7c2f920c3bda89b1$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$7c2f920c3bda89b1$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $7c2f920c3bda89b1$export$f6c783d06584602c(style) {
    return $7c2f920c3bda89b1$var$baseXcss(style);
}



var $5FkrB = parcelRequire("5FkrB");
var $b7f246307f063e1f$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $b7f246307f063e1f$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($b7f246307f063e1f$export$1ca2a26fecb070ae);
};
$b7f246307f063e1f$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $abf94df1a292a623$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $abf94df1a292a623$var$_excluded2 = [
    "className"
];
var $abf94df1a292a623$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $abf94df1a292a623$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $abf94df1a292a623$var$_excluded2);
    var resolvedStyles = (0, $7c2f920c3bda89b1$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $abf94df1a292a623$var$baseStyles,
            backgroundColor && (0, $11472afca28cc3f2$export$e7af83bafe7f9e63)[backgroundColor],
            (0, $11472afca28cc3f2$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $11472afca28cc3f2$export$ff257d957d48c421)[backgroundColor],
            padding && (0, $11472afca28cc3f2$export$e615f061ca585a6c).padding[padding],
            paddingBlock && (0, $11472afca28cc3f2$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $11472afca28cc3f2$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $11472afca28cc3f2$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $11472afca28cc3f2$export$e615f061ca585a6c).paddingInline[paddingInline],
            paddingInlineStart && (0, $11472afca28cc3f2$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $11472afca28cc3f2$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $74Zh5.jsx)((0, $b7f246307f063e1f$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $abf94df1a292a623$export$2e2bcd8739ae039 = $abf94df1a292a623$export$e71c4d32a2263218;
var $abf94df1a292a623$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

/** @jsx jsx */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");


var $0654f583dbdded1e$var$justifyContentMap = {
    start: (0, $74Zh5.css)({
        justifyContent: 'start'
    }),
    center: (0, $74Zh5.css)({
        justifyContent: 'center'
    }),
    end: (0, $74Zh5.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $74Zh5.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $74Zh5.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $74Zh5.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $74Zh5.css)({
        justifyContent: 'stretch'
    })
};
var $0654f583dbdded1e$var$flexDirectionMap = {
    column: (0, $74Zh5.css)({
        flexDirection: 'column'
    }),
    row: (0, $74Zh5.css)({
        flexDirection: 'row'
    })
};
var $0654f583dbdded1e$var$flexWrapMap = {
    wrap: (0, $74Zh5.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $74Zh5.css)({
        flexWrap: 'nowrap'
    })
};
var $0654f583dbdded1e$var$alignItemsMap = {
    start: (0, $74Zh5.css)({
        alignItems: 'start'
    }),
    center: (0, $74Zh5.css)({
        alignItems: 'center'
    }),
    baseline: (0, $74Zh5.css)({
        alignItems: 'baseline'
    }),
    end: (0, $74Zh5.css)({
        alignItems: 'end'
    }),
    stretch: (0, $74Zh5.css)({
        alignItems: 'stretch'
    })
};
var $0654f583dbdded1e$var$baseStyles = (0, $74Zh5.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $0654f583dbdded1e$var$Flex = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $7c2f920c3bda89b1$export$a9c84988c8f81f2d)(xcss);
    return (0, $74Zh5.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $0654f583dbdded1e$var$baseStyles,
            gap && (0, $11472afca28cc3f2$export$bf46c3f9eeafc71f).gap[gap],
            columnGap && (0, $11472afca28cc3f2$export$bf46c3f9eeafc71f).columnGap[columnGap],
            rowGap && (0, $11472afca28cc3f2$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $0654f583dbdded1e$var$alignItemsMap[alignItems],
            direction && $0654f583dbdded1e$var$flexDirectionMap[direction],
            justifyContent && $0654f583dbdded1e$var$justifyContentMap[justifyContent],
            wrap && $0654f583dbdded1e$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$0654f583dbdded1e$var$Flex.displayName = 'Flex';
var $0654f583dbdded1e$export$2e2bcd8739ae039 = $0654f583dbdded1e$var$Flex;


var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");


var $0c22dfc1af284338$var$flexGrowMap = {
    hug: (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
        width: '100%',
        flexGrow: 1
    })
};
var $0c22dfc1af284338$var$separatorStyles = (0, $74Zh5.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $0c22dfc1af284338$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $74Zh5.jsx)("span", {
        css: $0c22dfc1af284338$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $0c22dfc1af284338$var$Inline = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $74Zh5.jsx)($0c22dfc1af284338$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $5FkrB.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $74Zh5.jsx)((0, $5FkrB.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $0c22dfc1af284338$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $74Zh5.jsx)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$0c22dfc1af284338$var$Inline.displayName = 'Inline';
var $0c22dfc1af284338$export$2e2bcd8739ae039 = $0c22dfc1af284338$var$Inline;

/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $cb8cedbc477f5a81$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 109.99rem)',
        xl: '@media (min-width: 110rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110rem)'
    }
};
var $cb8cedbc477f5a81$export$c881183ca713c214 = $cb8cedbc477f5a81$export$987d49ffe1b0900f;


var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");


var $bdfb9b3a36dcb2bb$var$flexGrowMap = {
    hug: (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $bdfb9b3a36dcb2bb$var$Stack = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $bdfb9b3a36dcb2bb$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $74Zh5.jsx)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$bdfb9b3a36dcb2bb$var$Stack.displayName = 'Stack';
var $bdfb9b3a36dcb2bb$export$2e2bcd8739ae039 = $bdfb9b3a36dcb2bb$var$Stack;

/** @jsx jsx */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $afMOk = parcelRequire("afMOk");


var $c9e5a7a14e07f4e4$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $c9e5a7a14e07f4e4$var$resetStyles = (0, $74Zh5.css)({
    margin: 0
});
var $c9e5a7a14e07f4e4$var$strongStyles = (0, $74Zh5.css)({
    fontWeight: 'bold'
});
var $c9e5a7a14e07f4e4$var$emStyles = (0, $74Zh5.css)({
    fontStyle: 'italic'
});
var $c9e5a7a14e07f4e4$var$textAlignMap = {
    center: (0, $74Zh5.css)({
        textAlign: 'center'
    }),
    end: (0, $74Zh5.css)({
        textAlign: 'end'
    }),
    start: (0, $74Zh5.css)({
        textAlign: 'start'
    })
};
var $c9e5a7a14e07f4e4$var$truncationStyles = (0, $74Zh5.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
var $c9e5a7a14e07f4e4$var$wordBreakMap = {
    breakAll: (0, $74Zh5.css)({
        wordBreak: 'break-all'
    })
};
var $c9e5a7a14e07f4e4$var$HasTextAncestorContext = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $c9e5a7a14e07f4e4$var$useHasTextAncestor = function useHasTextAncestor() {
    return (0, $5FkrB.useContext)($c9e5a7a14e07f4e4$var$HasTextAncestorContext);
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $c9e5a7a14e07f4e4$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $b7f246307f063e1f$export$1aeb4f6b93c4540d)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $11472afca28cc3f2$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $11472afca28cc3f2$export$2185ce37f9bdd963)[surface];
    if (colorProp === 'inherit') return undefined;
    if (!colorProp && hasTextAncestor) return undefined;
    return colorProp || 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $c9e5a7a14e07f4e4$var$Text = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $afMOk.default)($c9e5a7a14e07f4e4$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = $c9e5a7a14e07f4e4$var$useHasTextAncestor();
    var color = $c9e5a7a14e07f4e4$var$useColor(colorProp, hasTextAncestor);
    var component = (0, $74Zh5.jsx)(Component, {
        ref: ref,
        css: [
            $c9e5a7a14e07f4e4$var$resetStyles,
            (0, $11472afca28cc3f2$export$128f10c238242f83)[size],
            color && (0, $11472afca28cc3f2$export$3a1bcba60b23d7f0)[color],
            maxLines && $c9e5a7a14e07f4e4$var$truncationStyles,
            maxLines === 1 && $c9e5a7a14e07f4e4$var$wordBreakMap.breakAll,
            align && $c9e5a7a14e07f4e4$var$textAlignMap[align],
            weight && (0, $11472afca28cc3f2$export$45f3f4fe16f9f7d5)[weight],
            Component === 'em' && $c9e5a7a14e07f4e4$var$emStyles,
            Component === 'strong' && $c9e5a7a14e07f4e4$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $74Zh5.jsx)($c9e5a7a14e07f4e4$var$HasTextAncestorContext.Provider, {
        value: true
    }, component);
});
var $c9e5a7a14e07f4e4$export$2e2bcd8739ae039 = $c9e5a7a14e07f4e4$var$Text;


var $fec45b36b8fde091$exports = {};
"use strict";
Object.defineProperty($fec45b36b8fde091$exports, "__esModule", {
    value: true
});
$fec45b36b8fde091$exports.default = void 0;

var $fec45b36b8fde091$var$_react = $fec45b36b8fde091$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $5Y2Mt = parcelRequire("5Y2Mt");

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
var $90d264785f5b1735$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
var $90d264785f5b1735$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
var $90d264785f5b1735$export$62ad7b0c781000e9 = {
    small: {
        width: $90d264785f5b1735$export$c647cb0ee6e282fe.small,
        height: $90d264785f5b1735$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $90d264785f5b1735$export$c647cb0ee6e282fe.medium,
        height: $90d264785f5b1735$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $90d264785f5b1735$export$c647cb0ee6e282fe.large,
        height: $90d264785f5b1735$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $90d264785f5b1735$export$c647cb0ee6e282fe.xlarge,
        height: $90d264785f5b1735$export$c647cb0ee6e282fe.xlarge
    }
};



var $74Zh5 = parcelRequire("74Zh5");
var $7b95aa0adab0444c$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $7b95aa0adab0444c$var$smallStyles = (0, $74Zh5.css)((0, $90d264785f5b1735$export$62ad7b0c781000e9).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $7b95aa0adab0444c$var$mediumStyles = (0, $74Zh5.css)((0, $90d264785f5b1735$export$62ad7b0c781000e9).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $7b95aa0adab0444c$var$largeStyles = (0, $74Zh5.css)((0, $90d264785f5b1735$export$62ad7b0c781000e9).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $7b95aa0adab0444c$var$xlargeStyles = (0, $74Zh5.css)((0, $90d264785f5b1735$export$62ad7b0c781000e9).xlarge);
var $7b95aa0adab0444c$export$ef0ad74202575b64 = {
    small: $7b95aa0adab0444c$var$smallStyles,
    medium: $7b95aa0adab0444c$var$mediumStyles,
    large: $7b95aa0adab0444c$var$largeStyles,
    xlarge: $7b95aa0adab0444c$var$xlargeStyles
};
var $7b95aa0adab0444c$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $90d264785f5b1735$export$62ad7b0c781000e9)[size];
    return undefined;
};


var $7000d2c62822c4fb$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};


function $228a50bc4e3498d7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $228a50bc4e3498d7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $228a50bc4e3498d7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $228a50bc4e3498d7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $228a50bc4e3498d7$var$iconStyles = (0, $74Zh5.css)({
    display: 'inline-block',
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> svg': $228a50bc4e3498d7$var$_objectSpread($228a50bc4e3498d7$var$_objectSpread({}, (0, $7b95aa0adab0444c$export$16374db1c3e6dfba)), {}, {
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    })
});
/**
 * For windows high contrast mode
 */ var $228a50bc4e3498d7$var$baseHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            filter: 'grayscale(1)',
            '--icon-primary-color': 'CanvasText',
            // foreground
            '--icon-secondary-color': 'Canvas' // background
        }
    }
});
var $228a50bc4e3498d7$var$primaryEqualsSecondaryHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            '--icon-primary-color': 'Canvas' // foreground
        }
    }
});
var $228a50bc4e3498d7$var$secondaryTransparentHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            '--icon-secondary-color': 'transparent' // background
        }
    }
});
var $228a50bc4e3498d7$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $74Zh5.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $7b95aa0adab0444c$export$3eb7d6130acfda37)({
        width: width,
        height: height,
        size: size
    });
    return (0, $74Zh5.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor || (0, $7000d2c62822c4fb$export$18cb9425622d4e06)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $228a50bc4e3498d7$var$iconStyles,
            $228a50bc4e3498d7$var$baseHcmStyles,
            primaryColor === secondaryColor && $228a50bc4e3498d7$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $228a50bc4e3498d7$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $74Zh5.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                '> svg': dimensions
            })
        ]
    }));
});
var $228a50bc4e3498d7$export$2e2bcd8739ae039 = $228a50bc4e3498d7$export$f04a61298a47a40f;


var $49a9e186635900ef$var$_excluded = [
    "dangerouslySetGlyph"
];
var $49a9e186635900ef$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
var $49a9e186635900ef$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $5FkrB.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $49a9e186635900ef$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : 'medium';
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $5Y2Mt.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (size === 'small' || size === 'medium')) {
        if (props.iconType === 'utility') {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
                spacing: (0, $5Y2Mt.fg)('platform-visual-refresh-icons-facade-button-fix') ? $49a9e186635900ef$var$sizeSpacingMap['utility'][size] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
                spacing: $49a9e186635900ef$var$sizeSpacingMap['core'][size],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $228a50bc4e3498d7$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});
var $49a9e186635900ef$export$2e2bcd8739ae039 = $49a9e186635900ef$export$3cfb73f70dfca966;



var $fec45b36b8fde091$var$_close = $fec45b36b8fde091$var$_interopRequireDefault((parcelRequire("6eqzM")));
function $fec45b36b8fde091$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fec45b36b8fde091$var$CrossIcon = (props)=>/*#__PURE__*/ $fec45b36b8fde091$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props, {
        newIcon: $fec45b36b8fde091$var$_close.default
    }));
$fec45b36b8fde091$var$CrossIcon.displayName = 'CrossIcon';
var $fec45b36b8fde091$var$_default = $fec45b36b8fde091$exports.default = $fec45b36b8fde091$var$CrossIcon;



var $aBp15 = parcelRequire("aBp15");
var $1595a2df2d5c9f61$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c9e42f0bd2701e924d060f406b40f887>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($1595a2df2d5c9f61$exports, "__esModule", {
    value: true
});
$1595a2df2d5c9f61$exports.default = void 0;

var $1595a2df2d5c9f61$var$_react = $1595a2df2d5c9f61$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $1595a2df2d5c9f61$var$_UNSAFE_baseNew = $1595a2df2d5c9f61$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $1595a2df2d5c9f61$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1595a2df2d5c9f61$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $1595a2df2d5c9f61$var$_react.default.createElement($1595a2df2d5c9f61$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m2 2 4 4m8 8-4-4m4-8-4 4m-8 8 4-4m2-9v3m0 8v3m7-7h-3M4 8H1"/>`
    }, props));
$1595a2df2d5c9f61$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $1595a2df2d5c9f61$var$_default = $1595a2df2d5c9f61$exports.default = $1595a2df2d5c9f61$var$AtlassianIntelligenceIcon;


var $5ec615fd02e164a6$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db9feac5032e1f6cb5923640df1c100>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($5ec615fd02e164a6$exports, "__esModule", {
    value: true
});
$5ec615fd02e164a6$exports.default = void 0;

var $5ec615fd02e164a6$var$_react = $5ec615fd02e164a6$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $5ec615fd02e164a6$var$_UNSAFE_baseNew = $5ec615fd02e164a6$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $5ec615fd02e164a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ec615fd02e164a6$var$CalendarIcon = (props)=>/*#__PURE__*/ $5ec615fd02e164a6$var$_react.default.createElement($5ec615fd02e164a6$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
    }, props));
$5ec615fd02e164a6$var$CalendarIcon.displayName = 'CalendarIcon';
var $5ec615fd02e164a6$var$_default = $5ec615fd02e164a6$exports.default = $5ec615fd02e164a6$var$CalendarIcon;


var $c76c9acbab193ca4$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::48d6c52e2f1120d34c1ed8048cf8da09>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($c76c9acbab193ca4$exports, "__esModule", {
    value: true
});
$c76c9acbab193ca4$exports.default = void 0;

var $c76c9acbab193ca4$var$_react = $c76c9acbab193ca4$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $c76c9acbab193ca4$var$_UNSAFE_baseNew = $c76c9acbab193ca4$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $c76c9acbab193ca4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Compass".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c76c9acbab193ca4$var$CompassIcon = (props)=>/*#__PURE__*/ $c76c9acbab193ca4$var$_react.default.createElement($c76c9acbab193ca4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 15.25A7.25 7.25 0 1 0 8 .75a7.25 7.25 0 0 0 0 14.5Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.75 11.25 4.5-2-2.5-2.5z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m11.25 4.75-4.5 2 2.5 2.5z"/>`
    }, props));
$c76c9acbab193ca4$var$CompassIcon.displayName = 'CompassIcon';
var $c76c9acbab193ca4$var$_default = $c76c9acbab193ca4$exports.default = $c76c9acbab193ca4$var$CompassIcon;



var $exnso = parcelRequire("exnso");
var $d670f5d7c7940d5f$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79997d69990d173364910f60504b3516>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($d670f5d7c7940d5f$exports, "__esModule", {
    value: true
});
$d670f5d7c7940d5f$exports.default = void 0;

var $d670f5d7c7940d5f$var$_react = $d670f5d7c7940d5f$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $d670f5d7c7940d5f$var$_UNSAFE_baseNew = $d670f5d7c7940d5f$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $d670f5d7c7940d5f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d670f5d7c7940d5f$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $d670f5d7c7940d5f$var$_react.default.createElement($d670f5d7c7940d5f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.75H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-3M7 9l6.75-6.75m.5 3.75V1.75H10"/>`
    }, props));
$d670f5d7c7940d5f$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
var $d670f5d7c7940d5f$var$_default = $d670f5d7c7940d5f$exports.default = $d670f5d7c7940d5f$var$LinkExternalIcon;



var $ln0Ih = parcelRequire("ln0Ih");
var $742fae155a6bbd32$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::60edb8db9f6bfb3658759225f550b1d1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($742fae155a6bbd32$exports, "__esModule", {
    value: true
});
$742fae155a6bbd32$exports.default = void 0;

var $742fae155a6bbd32$var$_react = $742fae155a6bbd32$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $742fae155a6bbd32$var$_UNSAFE_baseNew = $742fae155a6bbd32$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $742fae155a6bbd32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: feedback in products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $742fae155a6bbd32$var$MegaphoneIcon = (props)=>/*#__PURE__*/ $742fae155a6bbd32$var$_react.default.createElement($742fae155a6bbd32$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75 4.25H3c-.69 0-1.25.56-1.25 1.25v3.25C1.75 9.44 2.31 10 3 10h1.25m2.5-5.75 5.786-2.314a1.25 1.25 0 0 1 1.714 1.16v8.058a1.25 1.25 0 0 1-1.714 1.16L6.75 10m0-5.75V10m0 0h-2.5m2.5 0v4.25H5.5c-.69 0-1.25-.56-1.25-1.25v-3"/>`
    }, props));
$742fae155a6bbd32$var$MegaphoneIcon.displayName = 'MegaphoneIcon';
var $742fae155a6bbd32$var$_default = $742fae155a6bbd32$exports.default = $742fae155a6bbd32$var$MegaphoneIcon;


var $be2e2d4d6fde7b33$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c2c434ab24649808044e93163bd51c1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($be2e2d4d6fde7b33$exports, "__esModule", {
    value: true
});
$be2e2d4d6fde7b33$exports.default = void 0;

var $be2e2d4d6fde7b33$var$_react = $be2e2d4d6fde7b33$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $be2e2d4d6fde7b33$var$_UNSAFE_baseNew = $be2e2d4d6fde7b33$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $be2e2d4d6fde7b33$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $be2e2d4d6fde7b33$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $be2e2d4d6fde7b33$var$_react.default.createElement($be2e2d4d6fde7b33$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5 9.75H2.625C1.59 9.75.75 10.59.75 11.625V13m14.5 1v-1.5a2.75 2.75 0 0 0-2.75-2.75h-3a2.75 2.75 0 0 0-2.75 2.75V14m7-9.5a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0Zm-8 1a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"/>`
    }, props));
$be2e2d4d6fde7b33$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $be2e2d4d6fde7b33$var$_default = $be2e2d4d6fde7b33$exports.default = $be2e2d4d6fde7b33$var$PeopleGroupIcon;


var $d0d6b2a53e44f9e1$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::42f87835acc0152c23ae77c3bbeeba86>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($d0d6b2a53e44f9e1$exports, "__esModule", {
    value: true
});
$d0d6b2a53e44f9e1$exports.default = void 0;

var $d0d6b2a53e44f9e1$var$_react = $d0d6b2a53e44f9e1$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $d0d6b2a53e44f9e1$var$_UNSAFE_baseNew = $d0d6b2a53e44f9e1$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $d0d6b2a53e44f9e1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d0d6b2a53e44f9e1$var$PersonIcon = (props)=>/*#__PURE__*/ $d0d6b2a53e44f9e1$var$_react.default.createElement($d0d6b2a53e44f9e1$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 15v-2.25a3 3 0 0 0-3-3h-4.5a3 3 0 0 0-3 3V15m8.5-11a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
    }, props));
$d0d6b2a53e44f9e1$var$PersonIcon.displayName = 'PersonIcon';
var $d0d6b2a53e44f9e1$var$_default = $d0d6b2a53e44f9e1$exports.default = $d0d6b2a53e44f9e1$var$PersonIcon;


var $2a5cc7bed34af7d5$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b1290bc5816db04bbec0542a218c285>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($2a5cc7bed34af7d5$exports, "__esModule", {
    value: true
});
$2a5cc7bed34af7d5$exports.default = void 0;

var $2a5cc7bed34af7d5$var$_react = $2a5cc7bed34af7d5$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $2a5cc7bed34af7d5$var$_UNSAFE_baseNew = $2a5cc7bed34af7d5$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $2a5cc7bed34af7d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Project".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for projects in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2a5cc7bed34af7d5$var$ProjectIcon = (props)=>/*#__PURE__*/ $2a5cc7bed34af7d5$var$_react.default.createElement($2a5cc7bed34af7d5$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.25 10.25 3.5 8 1.25 5.75l.884-.884a1.25 1.25 0 0 1 .884-.366H7.25l2.384-2.384a1.25 1.25 0 0 1 .884-.366H13c.69 0 1.25.56 1.25 1.25v2.482c0 .332-.132.65-.366.884L11.5 8.75v4.232c0 .332-.132.65-.366.884l-.884.884L8 12.5l-2.25 2.25m-4.5 0 5-5"/><circle cx="11.375" cy="4.625" r="1.125" fill="currentcolor"/>`
    }, props));
$2a5cc7bed34af7d5$var$ProjectIcon.displayName = 'ProjectIcon';
var $2a5cc7bed34af7d5$var$_default = $2a5cc7bed34af7d5$exports.default = $2a5cc7bed34af7d5$var$ProjectIcon;


var $75ab11f9a6d4b351$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::21cc5e8a48fa1ff0264c5abb7df80aa6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($75ab11f9a6d4b351$exports, "__esModule", {
    value: true
});
$75ab11f9a6d4b351$exports.default = void 0;

var $75ab11f9a6d4b351$var$_react = $75ab11f9a6d4b351$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $75ab11f9a6d4b351$var$_UNSAFE_baseNew = $75ab11f9a6d4b351$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $75ab11f9a6d4b351$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "SidebarCollapse".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for collapsing the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75ab11f9a6d4b351$var$SidebarCollapseIcon = (props)=>/*#__PURE__*/ $75ab11f9a6d4b351$var$_react.default.createElement($75ab11f9a6d4b351$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.75 1.75H2C1.31 1.75.75 2.31.75 3v10c0 .69.56 1.25 1.25 1.25h2.75m0-12.5H14c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25H4.75m0-12.5v12.5M11 5.5 8.5 8l2.5 2.5"/>`
    }, props));
$75ab11f9a6d4b351$var$SidebarCollapseIcon.displayName = 'SidebarCollapseIcon';
var $75ab11f9a6d4b351$var$_default = $75ab11f9a6d4b351$exports.default = $75ab11f9a6d4b351$var$SidebarCollapseIcon;


var $e8ed8fa21860117a$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::67bd8e50f260741b99439472e94111fa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($e8ed8fa21860117a$exports, "__esModule", {
    value: true
});
$e8ed8fa21860117a$exports.default = void 0;

var $e8ed8fa21860117a$var$_react = $e8ed8fa21860117a$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $e8ed8fa21860117a$var$_UNSAFE_baseNew = $e8ed8fa21860117a$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $e8ed8fa21860117a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "SidebarExpand".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e8ed8fa21860117a$var$SidebarExpandIcon = (props)=>/*#__PURE__*/ $e8ed8fa21860117a$var$_react.default.createElement($e8ed8fa21860117a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M11.25 1.75H14c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25h-2.75m0-12.5H2C1.31 1.75.75 2.31.75 3v10c0 .69.56 1.25 1.25 1.25h9.25m0-12.5v12.5M5 5.5 7.5 8 5 10.5"/>`
    }, props));
$e8ed8fa21860117a$var$SidebarExpandIcon.displayName = 'SidebarExpandIcon';
var $e8ed8fa21860117a$var$_default = $e8ed8fa21860117a$exports.default = $e8ed8fa21860117a$var$SidebarExpandIcon;


var $9bde3da3ddd3925b$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f4906a52ca50c71ce3e4b4da49e7ade3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($9bde3da3ddd3925b$exports, "__esModule", {
    value: true
});
$9bde3da3ddd3925b$exports.default = void 0;

var $9bde3da3ddd3925b$var$_react = $9bde3da3ddd3925b$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $9bde3da3ddd3925b$var$_UNSAFE_baseNew = $9bde3da3ddd3925b$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $9bde3da3ddd3925b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ThumbsDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting, feedback in AI.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9bde3da3ddd3925b$var$ThumbsDownIcon = (props)=>/*#__PURE__*/ $9bde3da3ddd3925b$var$_react.default.createElement($9bde3da3ddd3925b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.993 9.24c-1.586.69-3.176 2.118-3.176 4.234 0 1.057-4.202 1.586-2.086-3.702-1.058.475-4.98 1.747-4.98-.897 0-3.173-.25-6.346 3.98-6.346 2.453 0 4.06 0 6.036 1.267m0 0A1.25 1.25 0 0 1 12 2.75h2c.69 0 1.25.56 1.25 1.25v4.5c0 .69-.56 1.25-1.25 1.25h-2c-.69 0-1.25-.56-1.25-1.25V4q0-.105.017-.204Z"/>`
    }, props));
$9bde3da3ddd3925b$var$ThumbsDownIcon.displayName = 'ThumbsDownIcon';
var $9bde3da3ddd3925b$var$_default = $9bde3da3ddd3925b$exports.default = $9bde3da3ddd3925b$var$ThumbsDownIcon;


var $d613dcd7cfbb1e58$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc6198fed855ec7c0bf831f638e93e94>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($d613dcd7cfbb1e58$exports, "__esModule", {
    value: true
});
$d613dcd7cfbb1e58$exports.default = void 0;

var $d613dcd7cfbb1e58$var$_react = $d613dcd7cfbb1e58$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $d613dcd7cfbb1e58$var$_UNSAFE_baseNew = $d613dcd7cfbb1e58$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $d613dcd7cfbb1e58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ThumbsUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting options in Jira, like.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d613dcd7cfbb1e58$var$ThumbsUpIcon = (props)=>/*#__PURE__*/ $d613dcd7cfbb1e58$var$_react.default.createElement($d613dcd7cfbb1e58$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5.007 6.76c1.586-.69 3.176-2.117 3.176-4.233 0-1.057 4.202-1.586 2.086 3.702 1.058-.475 4.981-1.747 4.981.897 0 3.173-.25 6.346-4.48 6.346-2.454 0-3.561 0-5.537-1.267m0 0A1.25 1.25 0 0 1 4 13.251H2c-.69 0-1.25-.56-1.25-1.25v-4.5c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v4.5q0 .105-.017.204Z"/>`
    }, props));
$d613dcd7cfbb1e58$var$ThumbsUpIcon.displayName = 'ThumbsUpIcon';
var $d613dcd7cfbb1e58$var$_default = $d613dcd7cfbb1e58$exports.default = $d613dcd7cfbb1e58$var$ThumbsUpIcon;


var $1a8d9f6b66868ddc$exports = {};
"use strict";
Object.defineProperty($1a8d9f6b66868ddc$exports, "__esModule", {
    value: true
});
$1a8d9f6b66868ddc$exports.default = void 0;

var $1a8d9f6b66868ddc$var$_react = $1a8d9f6b66868ddc$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $1a8d9f6b66868ddc$var$_add = $1a8d9f6b66868ddc$var$_interopRequireDefault((parcelRequire("jfDBU")));
function $1a8d9f6b66868ddc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1a8d9f6b66868ddc$var$AddIcon = (props)=>/*#__PURE__*/ $1a8d9f6b66868ddc$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V3.993A.997.997 0 0 0 12 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 0 0 3 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0 0 21 12c0-.556-.445-1-.993-1z"/></svg>`
    }, props, {
        newIcon: $1a8d9f6b66868ddc$var$_add.default
    }));
$1a8d9f6b66868ddc$var$AddIcon.displayName = 'AddIcon';
var $1a8d9f6b66868ddc$var$_default = $1a8d9f6b66868ddc$exports.default = $1a8d9f6b66868ddc$var$AddIcon;


var $98bc205bd71a8c29$exports = {};
"use strict";
Object.defineProperty($98bc205bd71a8c29$exports, "__esModule", {
    value: true
});
$98bc205bd71a8c29$exports.default = void 0;

var $98bc205bd71a8c29$var$_react = $98bc205bd71a8c29$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $98bc205bd71a8c29$var$_add = $98bc205bd71a8c29$var$_interopRequireDefault((parcelRequire("jfDBU")));
function $98bc205bd71a8c29$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $98bc205bd71a8c29$var$AddCircleIcon = (props)=>/*#__PURE__*/ $98bc205bd71a8c29$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M11.046 7.958v3.088H7.958a.954.954 0 1 0 0 1.908h3.088v3.088a.954.954 0 1 0 1.908 0v-3.088h3.088a.954.954 0 1 0 0-1.908h-3.088V7.958a.954.954 0 1 0-1.908 0"/></g></svg>`
    }, props, {
        newIcon: $98bc205bd71a8c29$var$_add.default
    }));
$98bc205bd71a8c29$var$AddCircleIcon.displayName = 'AddCircleIcon';
var $98bc205bd71a8c29$var$_default = $98bc205bd71a8c29$exports.default = $98bc205bd71a8c29$var$AddCircleIcon;


var $6d9883dd8b1794e3$exports = {};
"use strict";
Object.defineProperty($6d9883dd8b1794e3$exports, "__esModule", {
    value: true
});
$6d9883dd8b1794e3$exports.default = void 0;

var $6d9883dd8b1794e3$var$_react = $6d9883dd8b1794e3$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $6d9883dd8b1794e3$var$_arrowLeft = $6d9883dd8b1794e3$var$_interopRequireDefault((parcelRequire("ldiUp")));
function $6d9883dd8b1794e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6d9883dd8b1794e3$var$ArrowLeftCircleIcon = (props)=>/*#__PURE__*/ $6d9883dd8b1794e3$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M16 10.995h-5.586l1.272-1.279a1.01 1.01 0 0 0 0-1.421.996.996 0 0 0-1.415 0l-2.978 2.994a1.01 1.01 0 0 0 0 1.423l2.978 2.993a1 1 0 0 0 1.415 0 1.01 1.01 0 0 0 0-1.421l-1.272-1.279H16c.552 0 1-.45 1-1.005s-.448-1.005-1-1.005"/></svg>`
    }, props, {
        newIcon: $6d9883dd8b1794e3$var$_arrowLeft.default
    }));
$6d9883dd8b1794e3$var$ArrowLeftCircleIcon.displayName = 'ArrowLeftCircleIcon';
var $6d9883dd8b1794e3$var$_default = $6d9883dd8b1794e3$exports.default = $6d9883dd8b1794e3$var$ArrowLeftCircleIcon;


var $c98a967905aaff91$exports = {};
"use strict";
Object.defineProperty($c98a967905aaff91$exports, "__esModule", {
    value: true
});
$c98a967905aaff91$exports.default = void 0;

var $c98a967905aaff91$var$_react = $c98a967905aaff91$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $c98a967905aaff91$var$_arrowRight = $c98a967905aaff91$var$_interopRequireDefault((parcelRequire("5GKWl")));
function $c98a967905aaff91$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c98a967905aaff91$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c98a967905aaff91$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $c98a967905aaff91$var$_arrowRight.default
    }));
$c98a967905aaff91$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c98a967905aaff91$var$_default = $c98a967905aaff91$exports.default = $c98a967905aaff91$var$ArrowRightIcon;


var $7ef4b2cc5f25a288$exports = {};
"use strict";
Object.defineProperty($7ef4b2cc5f25a288$exports, "__esModule", {
    value: true
});
$7ef4b2cc5f25a288$exports.default = void 0;

var $7ef4b2cc5f25a288$var$_react = $7ef4b2cc5f25a288$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $7ef4b2cc5f25a288$var$_arrowRight = $7ef4b2cc5f25a288$var$_interopRequireDefault((parcelRequire("5GKWl")));
function $7ef4b2cc5f25a288$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7ef4b2cc5f25a288$var$ArrowRightCircleIcon = (props)=>/*#__PURE__*/ $7ef4b2cc5f25a288$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M12.314 8.294a1.01 1.01 0 0 0 0 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005S7.447 13.005 8 13.005h5.585l-1.271 1.279a1.01 1.01 0 0 0 0 1.422 1 1 0 0 0 1.415 0l2.978-2.995a1.01 1.01 0 0 0 0-1.422l-2.978-2.995a1 1 0 0 0-1.415 0"/></g></svg>`
    }, props, {
        newIcon: $7ef4b2cc5f25a288$var$_arrowRight.default
    }));
$7ef4b2cc5f25a288$var$ArrowRightCircleIcon.displayName = 'ArrowRightCircleIcon';
var $7ef4b2cc5f25a288$var$_default = $7ef4b2cc5f25a288$exports.default = $7ef4b2cc5f25a288$var$ArrowRightCircleIcon;


var $9cd1998a3c9cfc99$exports = {};
"use strict";
Object.defineProperty($9cd1998a3c9cfc99$exports, "__esModule", {
    value: true
});
$9cd1998a3c9cfc99$exports.default = void 0;

var $9cd1998a3c9cfc99$var$_react = $9cd1998a3c9cfc99$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $9cd1998a3c9cfc99$var$_arrowUp = $9cd1998a3c9cfc99$var$_interopRequireDefault((parcelRequire("5mlBi")));
function $9cd1998a3c9cfc99$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9cd1998a3c9cfc99$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $9cd1998a3c9cfc99$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.293 5.293-5.5 5.499a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0L11 8.414V18a1 1 0 0 0 2 0V8.414l3.793 3.793a1 1 0 1 0 1.414-1.415l-5.5-5.499A1 1 0 0 0 12 5a1 1 0 0 0-.707.293"/></svg>`
    }, props, {
        newIcon: $9cd1998a3c9cfc99$var$_arrowUp.default
    }));
$9cd1998a3c9cfc99$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $9cd1998a3c9cfc99$var$_default = $9cd1998a3c9cfc99$exports.default = $9cd1998a3c9cfc99$var$ArrowUpIcon;


var $e48f677aac887358$exports = {};
"use strict";
Object.defineProperty($e48f677aac887358$exports, "__esModule", {
    value: true
});
$e48f677aac887358$exports.default = void 0;

var $e48f677aac887358$var$_react = $e48f677aac887358$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $e48f677aac887358$var$_arrowUp = $e48f677aac887358$var$_interopRequireDefault((parcelRequire("5mlBi")));
function $e48f677aac887358$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e48f677aac887358$var$ArrowUpCircleIcon = (props)=>/*#__PURE__*/ $e48f677aac887358$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M11.288 7.293 8.294 10.27a1 1 0 0 0 0 1.416 1.01 1.01 0 0 0 1.421 0l1.279-1.272V16c0 .552.451 1 1.006 1s1.005-.448 1.005-1v-5.586l1.279 1.272a1.01 1.01 0 0 0 1.421 0 1 1 0 0 0 0-1.416l-2.994-2.977a1.01 1.01 0 0 0-1.423 0"/></g></svg>`
    }, props, {
        newIcon: $e48f677aac887358$var$_arrowUp.default
    }));
$e48f677aac887358$var$ArrowUpCircleIcon.displayName = 'ArrowUpCircleIcon';
var $e48f677aac887358$var$_default = $e48f677aac887358$exports.default = $e48f677aac887358$var$ArrowUpCircleIcon;


var $8e55f27140ce88eb$exports = {};
"use strict";
Object.defineProperty($8e55f27140ce88eb$exports, "__esModule", {
    value: true
});
$8e55f27140ce88eb$exports.default = void 0;

var $8e55f27140ce88eb$var$_react = $8e55f27140ce88eb$var$_interopRequireDefault((parcelRequire("5FkrB")));

function $8e55f27140ce88eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8e55f27140ce88eb$var$BitbucketBuildsIcon = (props)=>/*#__PURE__*/ $8e55f27140ce88eb$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 5a1 1 0 0 0 1 1h3.01a1 1 0 0 0 0-2H11c-.55 0-1 .45-1 1M8 5c0-1.66 1.35-3 3-3h3.01a3 3 0 0 1 0 6H11a3 3 0 0 1-3-3m2 7a1 1 0 0 0 1 1h3.01a1 1 0 0 0 0-2H11c-.55 0-1 .45-1 1m-2 0c0-1.66 1.35-3 3-3h3.01a3 3 0 0 1 0 6H11a3 3 0 0 1-3-3m2 7a1 1 0 0 0 1 1h3.01a1 1 0 0 0 0-2H11c-.55 0-1 .45-1 1m-2 0c0-1.66 1.35-3 3-3h3.01a3 3 0 0 1 0 6H11a3 3 0 0 1-3-3"/><path d="M16.06 6h2.42c.81 0 1.47.66 1.47 1.47v1.95c0 .82-.65 1.47-1.47 1.47H16v2h2.47a3.47 3.47 0 0 0 3.48-3.47V7.47A3.47 3.47 0 0 0 18.48 4h-2.41zm-7.17 5H6.47A3.47 3.47 0 0 0 3 14.47v1.95c0 1.92 1.55 3.47 3.47 3.47h2.48v-2H6.47c-.82 0-1.47-.65-1.47-1.47v-1.95c0-.81.66-1.47 1.47-1.47h2.42z"/></g></svg>`
    }, props));
$8e55f27140ce88eb$var$BitbucketBuildsIcon.displayName = 'BitbucketBuildsIcon';
var $8e55f27140ce88eb$var$_default = $8e55f27140ce88eb$exports.default = $8e55f27140ce88eb$var$BitbucketBuildsIcon;


var $873ac5cd1764ee99$exports = {};
"use strict";
Object.defineProperty($873ac5cd1764ee99$exports, "__esModule", {
    value: true
});
$873ac5cd1764ee99$exports.default = void 0;

var $873ac5cd1764ee99$var$_react = $873ac5cd1764ee99$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $873ac5cd1764ee99$var$_checkMark = $873ac5cd1764ee99$var$_interopRequireDefault((parcelRequire("bE62y")));
function $873ac5cd1764ee99$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $873ac5cd1764ee99$var$CheckIcon = (props)=>/*#__PURE__*/ $873ac5cd1764ee99$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $873ac5cd1764ee99$var$_checkMark.default
    }));
$873ac5cd1764ee99$var$CheckIcon.displayName = 'CheckIcon';
var $873ac5cd1764ee99$var$_default = $873ac5cd1764ee99$exports.default = $873ac5cd1764ee99$var$CheckIcon;


var $d5a84db960eef864$exports = {};
"use strict";
Object.defineProperty($d5a84db960eef864$exports, "__esModule", {
    value: true
});
$d5a84db960eef864$exports.default = void 0;

var $d5a84db960eef864$var$_react = $d5a84db960eef864$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $d5a84db960eef864$var$_success = $d5a84db960eef864$var$_interopRequireDefault((parcelRequire("4AP9B")));
function $d5a84db960eef864$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d5a84db960eef864$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $d5a84db960eef864$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $d5a84db960eef864$var$_success.default
    }));
$d5a84db960eef864$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $d5a84db960eef864$var$_default = $d5a84db960eef864$exports.default = $d5a84db960eef864$var$CheckCircleIcon;


var $ade8daf0e7d9a0c6$exports = {};
"use strict";
Object.defineProperty($ade8daf0e7d9a0c6$exports, "__esModule", {
    value: true
});
$ade8daf0e7d9a0c6$exports.default = void 0;

var $ade8daf0e7d9a0c6$var$_react = $ade8daf0e7d9a0c6$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $ade8daf0e7d9a0c6$var$_checkCircle = $ade8daf0e7d9a0c6$var$_interopRequireDefault((parcelRequire("eC7kC")));
function $ade8daf0e7d9a0c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ade8daf0e7d9a0c6$var$CheckCircleOutlineIcon = (props)=>/*#__PURE__*/ $ade8daf0e7d9a0c6$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/><path d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $ade8daf0e7d9a0c6$var$_checkCircle.default
    }));
$ade8daf0e7d9a0c6$var$CheckCircleOutlineIcon.displayName = 'CheckCircleOutlineIcon';
var $ade8daf0e7d9a0c6$var$_default = $ade8daf0e7d9a0c6$exports.default = $ade8daf0e7d9a0c6$var$CheckCircleOutlineIcon;


var $9486f8503a3e67e2$exports = {};
"use strict";
Object.defineProperty($9486f8503a3e67e2$exports, "__esModule", {
    value: true
});
$9486f8503a3e67e2$exports.default = void 0;

var $9486f8503a3e67e2$var$_react = $9486f8503a3e67e2$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $9486f8503a3e67e2$var$_chevronDown = $9486f8503a3e67e2$var$_interopRequireDefault((parcelRequire("5Y5FQ")));
function $9486f8503a3e67e2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9486f8503a3e67e2$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $9486f8503a3e67e2$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $9486f8503a3e67e2$var$_chevronDown.default,
        iconType: "utility"
    }));
$9486f8503a3e67e2$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $9486f8503a3e67e2$var$_default = $9486f8503a3e67e2$exports.default = $9486f8503a3e67e2$var$ChevronDownIcon;


var $e572ec8845a02646$exports = {};
"use strict";
Object.defineProperty($e572ec8845a02646$exports, "__esModule", {
    value: true
});
$e572ec8845a02646$exports.default = void 0;

var $e572ec8845a02646$var$_react = $e572ec8845a02646$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $e572ec8845a02646$var$_chevronDown = $e572ec8845a02646$var$_interopRequireDefault((parcelRequire("5Y5FQ")));
function $e572ec8845a02646$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e572ec8845a02646$var$ChevronDownCircleIcon = (props)=>/*#__PURE__*/ $e572ec8845a02646$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></g></svg>`
    }, props, {
        newIcon: $e572ec8845a02646$var$_chevronDown.default,
        iconType: "utility"
    }));
$e572ec8845a02646$var$ChevronDownCircleIcon.displayName = 'ChevronDownCircleIcon';
var $e572ec8845a02646$var$_default = $e572ec8845a02646$exports.default = $e572ec8845a02646$var$ChevronDownCircleIcon;


var $385bb13f555ba5b8$exports = {};
"use strict";
Object.defineProperty($385bb13f555ba5b8$exports, "__esModule", {
    value: true
});
$385bb13f555ba5b8$exports.default = void 0;

var $385bb13f555ba5b8$var$_react = $385bb13f555ba5b8$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $385bb13f555ba5b8$var$_chevronLeft = $385bb13f555ba5b8$var$_interopRequireDefault((parcelRequire("447N2")));
function $385bb13f555ba5b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $385bb13f555ba5b8$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $385bb13f555ba5b8$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13.706 9.698a.99.99 0 0 0 0-1.407 1.01 1.01 0 0 0-1.419 0l-2.965 2.94a1.09 1.09 0 0 0 0 1.548l2.955 2.93a1.01 1.01 0 0 0 1.42 0 .99.99 0 0 0 0-1.407l-2.318-2.297z"/></svg>`
    }, props, {
        newIcon: $385bb13f555ba5b8$var$_chevronLeft.default,
        iconType: "utility"
    }));
$385bb13f555ba5b8$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $385bb13f555ba5b8$var$_default = $385bb13f555ba5b8$exports.default = $385bb13f555ba5b8$var$ChevronLeftIcon;


var $464fbc8de2c8545a$exports = {};
"use strict";
Object.defineProperty($464fbc8de2c8545a$exports, "__esModule", {
    value: true
});
$464fbc8de2c8545a$exports.default = void 0;

var $464fbc8de2c8545a$var$_react = $464fbc8de2c8545a$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $464fbc8de2c8545a$var$_chevronLeft = $464fbc8de2c8545a$var$_interopRequireDefault((parcelRequire("447N2")));
function $464fbc8de2c8545a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $464fbc8de2c8545a$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $464fbc8de2c8545a$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $464fbc8de2c8545a$var$_chevronLeft.default,
        iconType: "utility"
    }));
$464fbc8de2c8545a$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $464fbc8de2c8545a$var$_default = $464fbc8de2c8545a$exports.default = $464fbc8de2c8545a$var$ChevronLeftLargeIcon;


var $dffd612a245a9817$exports = {};
"use strict";
Object.defineProperty($dffd612a245a9817$exports, "__esModule", {
    value: true
});
$dffd612a245a9817$exports.default = void 0;

var $dffd612a245a9817$var$_react = $dffd612a245a9817$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $dffd612a245a9817$var$_chevronRight = $dffd612a245a9817$var$_interopRequireDefault((parcelRequire("jiU5J")));
function $dffd612a245a9817$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dffd612a245a9817$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $dffd612a245a9817$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M10.294 9.698a.99.99 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .99.99 0 0 1 0-1.407l2.318-2.297z"/></svg>`
    }, props, {
        newIcon: $dffd612a245a9817$var$_chevronRight.default,
        iconType: "utility"
    }));
$dffd612a245a9817$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $dffd612a245a9817$var$_default = $dffd612a245a9817$exports.default = $dffd612a245a9817$var$ChevronRightIcon;


var $30203922e34ab8aa$exports = {};
"use strict";
Object.defineProperty($30203922e34ab8aa$exports, "__esModule", {
    value: true
});
$30203922e34ab8aa$exports.default = void 0;

var $30203922e34ab8aa$var$_react = $30203922e34ab8aa$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $30203922e34ab8aa$var$_chevronUp = $30203922e34ab8aa$var$_interopRequireDefault((parcelRequire("cS1ic")));
function $30203922e34ab8aa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $30203922e34ab8aa$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $30203922e34ab8aa$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.221 9.322-2.929 2.955a1.01 1.01 0 0 0 0 1.419.986.986 0 0 0 1.405 0l2.298-2.317 2.307 2.327a.99.99 0 0 0 1.407 0 1.01 1.01 0 0 0 0-1.419l-2.94-2.965A1.1 1.1 0 0 0 11.991 9c-.279 0-.557.107-.77.322"/></svg>`
    }, props, {
        newIcon: $30203922e34ab8aa$var$_chevronUp.default,
        iconType: "utility"
    }));
$30203922e34ab8aa$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $30203922e34ab8aa$var$_default = $30203922e34ab8aa$exports.default = $30203922e34ab8aa$var$ChevronUpIcon;


var $590d7c6a980c3249$exports = {};
"use strict";
Object.defineProperty($590d7c6a980c3249$exports, "__esModule", {
    value: true
});
$590d7c6a980c3249$exports.default = void 0;

var $590d7c6a980c3249$var$_react = $590d7c6a980c3249$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $590d7c6a980c3249$var$_copy = $590d7c6a980c3249$var$_interopRequireDefault((parcelRequire("gxkfx")));
function $590d7c6a980c3249$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $590d7c6a980c3249$var$CopyIcon = (props)=>/*#__PURE__*/ $590d7c6a980c3249$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $590d7c6a980c3249$var$_copy.default
    }));
$590d7c6a980c3249$var$CopyIcon.displayName = 'CopyIcon';
var $590d7c6a980c3249$var$_default = $590d7c6a980c3249$exports.default = $590d7c6a980c3249$var$CopyIcon;


var $be4a353bf96cd982$exports = {};
"use strict";
Object.defineProperty($be4a353bf96cd982$exports, "__esModule", {
    value: true
});
$be4a353bf96cd982$exports.default = void 0;

var $be4a353bf96cd982$var$_react = $be4a353bf96cd982$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $be4a353bf96cd982$var$_download = $be4a353bf96cd982$var$_interopRequireDefault((parcelRequire("exnso")));
function $be4a353bf96cd982$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $be4a353bf96cd982$var$DownloadIcon = (props)=>/*#__PURE__*/ $be4a353bf96cd982$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props, {
        newIcon: $be4a353bf96cd982$var$_download.default
    }));
$be4a353bf96cd982$var$DownloadIcon.displayName = 'DownloadIcon';
var $be4a353bf96cd982$var$_default = $be4a353bf96cd982$exports.default = $be4a353bf96cd982$var$DownloadIcon;


var $8710dfec56d91aa3$exports = {};
"use strict";
Object.defineProperty($8710dfec56d91aa3$exports, "__esModule", {
    value: true
});
$8710dfec56d91aa3$exports.default = void 0;

var $8710dfec56d91aa3$var$_react = $8710dfec56d91aa3$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $8710dfec56d91aa3$var$_edit = $8710dfec56d91aa3$var$_interopRequireDefault((parcelRequire("dI7Bp")));
function $8710dfec56d91aa3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8710dfec56d91aa3$var$EditIcon = (props)=>/*#__PURE__*/ $8710dfec56d91aa3$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $8710dfec56d91aa3$var$_edit.default
    }));
$8710dfec56d91aa3$var$EditIcon.displayName = 'EditIcon';
var $8710dfec56d91aa3$var$_default = $8710dfec56d91aa3$exports.default = $8710dfec56d91aa3$var$EditIcon;


var $d565c3bdf418c732$exports = {};
"use strict";
Object.defineProperty($d565c3bdf418c732$exports, "__esModule", {
    value: true
});
$d565c3bdf418c732$exports.default = void 0;

var $d565c3bdf418c732$var$_react = $d565c3bdf418c732$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $d565c3bdf418c732$var$_edit = $d565c3bdf418c732$var$_interopRequireDefault((parcelRequire("dI7Bp")));
function $d565c3bdf418c732$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d565c3bdf418c732$var$EditFilledIcon = (props)=>/*#__PURE__*/ $d565c3bdf418c732$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zM19.84 6.71l-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $d565c3bdf418c732$var$_edit.default
    }));
$d565c3bdf418c732$var$EditFilledIcon.displayName = 'EditFilledIcon';
var $d565c3bdf418c732$var$_default = $d565c3bdf418c732$exports.default = $d565c3bdf418c732$var$EditFilledIcon;


var $79f04fcc1fc38f5b$exports = {};
"use strict";
Object.defineProperty($79f04fcc1fc38f5b$exports, "__esModule", {
    value: true
});
$79f04fcc1fc38f5b$exports.default = void 0;

var $79f04fcc1fc38f5b$var$_react = $79f04fcc1fc38f5b$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $79f04fcc1fc38f5b$var$_close = $79f04fcc1fc38f5b$var$_interopRequireDefault((parcelRequire("6eqzM")));
function $79f04fcc1fc38f5b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $79f04fcc1fc38f5b$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $79f04fcc1fc38f5b$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $79f04fcc1fc38f5b$var$_close.default
    }));
$79f04fcc1fc38f5b$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $79f04fcc1fc38f5b$var$_default = $79f04fcc1fc38f5b$exports.default = $79f04fcc1fc38f5b$var$EditorCloseIcon;


var $34e5d1c6c1f4125d$exports = {};
"use strict";
Object.defineProperty($34e5d1c6c1f4125d$exports, "__esModule", {
    value: true
});
$34e5d1c6c1f4125d$exports.default = void 0;

var $34e5d1c6c1f4125d$var$_react = $34e5d1c6c1f4125d$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $34e5d1c6c1f4125d$var$_contentWrapRight = $34e5d1c6c1f4125d$var$_interopRequireDefault((parcelRequire("b37du")));
function $34e5d1c6c1f4125d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $34e5d1c6c1f4125d$var$EditorMediaWrapRightIcon = (props)=>/*#__PURE__*/ $34e5d1c6c1f4125d$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0-8h4a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0 4h4a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m8-4h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1M6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props, {
        newIcon: $34e5d1c6c1f4125d$var$_contentWrapRight.default
    }));
$34e5d1c6c1f4125d$var$EditorMediaWrapRightIcon.displayName = 'EditorMediaWrapRightIcon';
var $34e5d1c6c1f4125d$var$_default = $34e5d1c6c1f4125d$exports.default = $34e5d1c6c1f4125d$var$EditorMediaWrapRightIcon;


var $3f5daf0b07171f08$exports = {};
"use strict";
Object.defineProperty($3f5daf0b07171f08$exports, "__esModule", {
    value: true
});
$3f5daf0b07171f08$exports.default = void 0;

var $3f5daf0b07171f08$var$_react = $3f5daf0b07171f08$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $3f5daf0b07171f08$var$_arrowUpRight = $3f5daf0b07171f08$var$_interopRequireDefault((parcelRequire("aBp15")));
function $3f5daf0b07171f08$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3f5daf0b07171f08$var$EditorOpenIcon = (props)=>/*#__PURE__*/ $3f5daf0b07171f08$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9.873 7.63c-.28 0-.344.159-.147.357l2.436 2.436-4.386 4.386a.51.51 0 0 0 0 .713l.7.7a.495.495 0 0 0 .713.001l4.387-4.386 2.436 2.436c.197.197.357.124.357-.147V8.133a.507.507 0 0 0-.503-.503z"/></svg>`
    }, props, {
        newIcon: $3f5daf0b07171f08$var$_arrowUpRight.default
    }));
$3f5daf0b07171f08$var$EditorOpenIcon.displayName = 'EditorOpenIcon';
var $3f5daf0b07171f08$var$_default = $3f5daf0b07171f08$exports.default = $3f5daf0b07171f08$var$EditorOpenIcon;


var $533ab672e6b1443b$exports = {};
"use strict";
Object.defineProperty($533ab672e6b1443b$exports, "__esModule", {
    value: true
});
$533ab672e6b1443b$exports.default = void 0;

var $533ab672e6b1443b$var$_react = $533ab672e6b1443b$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $533ab672e6b1443b$var$_information = $533ab672e6b1443b$var$_interopRequireDefault((parcelRequire("93YpG")));
function $533ab672e6b1443b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $533ab672e6b1443b$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $533ab672e6b1443b$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $533ab672e6b1443b$var$_information.default
    }));
$533ab672e6b1443b$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $533ab672e6b1443b$var$_default = $533ab672e6b1443b$exports.default = $533ab672e6b1443b$var$EditorPanelIcon;


var $3ac3f969cbb47b8f$exports = {};
"use strict";
Object.defineProperty($3ac3f969cbb47b8f$exports, "__esModule", {
    value: true
});
$3ac3f969cbb47b8f$exports.default = void 0;

var $3ac3f969cbb47b8f$var$_react = $3ac3f969cbb47b8f$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $3ac3f969cbb47b8f$var$_grid = $3ac3f969cbb47b8f$var$_interopRequireDefault((parcelRequire("bWJYo")));
function $3ac3f969cbb47b8f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3ac3f969cbb47b8f$var$EditorTableIcon = (props)=>/*#__PURE__*/ $3ac3f969cbb47b8f$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 6h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2m0 2v3h3V8zm5 0v3h3V8zm-5 5v3h3v-3zm5 0v3h3v-3z"/></svg>`
    }, props, {
        newIcon: $3ac3f969cbb47b8f$var$_grid.default
    }));
$3ac3f969cbb47b8f$var$EditorTableIcon.displayName = 'EditorTableIcon';
var $3ac3f969cbb47b8f$var$_default = $3ac3f969cbb47b8f$exports.default = $3ac3f969cbb47b8f$var$EditorTableIcon;


var $207a5ee071608021$exports = {};
"use strict";
Object.defineProperty($207a5ee071608021$exports, "__esModule", {
    value: true
});
$207a5ee071608021$exports.default = void 0;

var $207a5ee071608021$var$_react = $207a5ee071608021$var$_interopRequireDefault((parcelRequire("5FkrB")));

function $207a5ee071608021$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $207a5ee071608021$var$EmojiAtlassianIcon = (props)=>/*#__PURE__*/ $207a5ee071608021$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M8.7 11.48c-.24-.25-.61-.24-.77.09l-3.88 7.76a.46.46 0 0 0 .42.67h5.41a.45.45 0 0 0 .42-.26c1.17-2.41.46-6.08-1.59-8.27m2.84-7.06c-2.17 3.44-2.03 7.26-.6 10.12l2.61 5.22c.08.16.24.26.42.26h5.41a.46.46 0 0 0 .42-.67S12.53 4.77 12.35 4.41c-.17-.32-.58-.33-.79 0"/></svg>`
    }, props));
$207a5ee071608021$var$EmojiAtlassianIcon.displayName = 'EmojiAtlassianIcon';
var $207a5ee071608021$var$_default = $207a5ee071608021$exports.default = $207a5ee071608021$var$EmojiAtlassianIcon;


var $2bb56a67b3ef2d16$exports = {};
"use strict";
Object.defineProperty($2bb56a67b3ef2d16$exports, "__esModule", {
    value: true
});
$2bb56a67b3ef2d16$exports.default = void 0;

var $2bb56a67b3ef2d16$var$_react = $2bb56a67b3ef2d16$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $2bb56a67b3ef2d16$var$_clock = $2bb56a67b3ef2d16$var$_interopRequireDefault((parcelRequire("cJnPm")));
function $2bb56a67b3ef2d16$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2bb56a67b3ef2d16$var$EmojiFrequentIcon = (props)=>/*#__PURE__*/ $2bb56a67b3ef2d16$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8m0 14.222A6.23 6.23 0 0 1 5.778 12 6.23 6.23 0 0 1 12 5.778 6.23 6.23 0 0 1 18.222 12 6.23 6.23 0 0 1 12 18.222m.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.89.89 0 0 0 1.257 0 .89.89 0 0 0 0-1.256z"/></svg>`
    }, props, {
        newIcon: $2bb56a67b3ef2d16$var$_clock.default
    }));
$2bb56a67b3ef2d16$var$EmojiFrequentIcon.displayName = 'EmojiFrequentIcon';
var $2bb56a67b3ef2d16$var$_default = $2bb56a67b3ef2d16$exports.default = $2bb56a67b3ef2d16$var$EmojiFrequentIcon;


var $88999ebaf76df20a$exports = {};
"use strict";
Object.defineProperty($88999ebaf76df20a$exports, "__esModule", {
    value: true
});
$88999ebaf76df20a$exports.default = void 0;

var $88999ebaf76df20a$var$_react = $88999ebaf76df20a$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $88999ebaf76df20a$var$_heart = $88999ebaf76df20a$var$_interopRequireDefault((parcelRequire("czNKk")));
function $88999ebaf76df20a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $88999ebaf76df20a$var$EmojiSymbolsIcon = (props)=>/*#__PURE__*/ $88999ebaf76df20a$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m12 9.44 1.76-1.744a2.505 2.505 0 0 1 3.52 0 2.45 2.45 0 0 1 0 3.488L12 16.417l-5.28-5.232a2.45 2.45 0 0 1 0-3.49 2.505 2.505 0 0 1 3.52 0v.001zm-6.684 3.143.003.004 6.322 6.266a.51.51 0 0 0 .718 0l6.322-6.266.003-.004.004-.003a4.41 4.41 0 0 0 0-6.28 4.51 4.51 0 0 0-6.336 0l-.003.004-.004.003L12 6.65l-.345-.342-.004-.003-.003-.003a4.51 4.51 0 0 0-6.336 0 4.41 4.41 0 0 0 0 6.279z"/></svg>`
    }, props, {
        newIcon: $88999ebaf76df20a$var$_heart.default
    }));
$88999ebaf76df20a$var$EmojiSymbolsIcon.displayName = 'EmojiSymbolsIcon';
var $88999ebaf76df20a$var$_default = $88999ebaf76df20a$exports.default = $88999ebaf76df20a$var$EmojiSymbolsIcon;


var $ff31d8fb1771b8a0$exports = {};
"use strict";
Object.defineProperty($ff31d8fb1771b8a0$exports, "__esModule", {
    value: true
});
$ff31d8fb1771b8a0$exports.default = void 0;

var $ff31d8fb1771b8a0$var$_react = $ff31d8fb1771b8a0$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $ff31d8fb1771b8a0$var$_error = $ff31d8fb1771b8a0$var$_interopRequireDefault((parcelRequire("4YUxz")));
function $ff31d8fb1771b8a0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ff31d8fb1771b8a0$var$ErrorIcon = (props)=>/*#__PURE__*/ $ff31d8fb1771b8a0$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $ff31d8fb1771b8a0$var$_error.default
    }));
$ff31d8fb1771b8a0$var$ErrorIcon.displayName = 'ErrorIcon';
var $ff31d8fb1771b8a0$var$_default = $ff31d8fb1771b8a0$exports.default = $ff31d8fb1771b8a0$var$ErrorIcon;


var $34d04bfb84685d13$exports = {};
"use strict";
Object.defineProperty($34d04bfb84685d13$exports, "__esModule", {
    value: true
});
$34d04bfb84685d13$exports.default = void 0;

var $34d04bfb84685d13$var$_react = $34d04bfb84685d13$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $34d04bfb84685d13$var$_upload = $34d04bfb84685d13$var$_interopRequireDefault((parcelRequire("ie0cB")));
function $34d04bfb84685d13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $34d04bfb84685d13$var$ExportIcon = (props)=>/*#__PURE__*/ $34d04bfb84685d13$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M13 6.491V16a1 1 0 0 1-2 0V6.491L9.784 7.697a1.05 1.05 0 0 1-1.478 0 1.03 1.03 0 0 1 0-1.465l2.955-2.929a1.05 1.05 0 0 1 1.478 0l2.955 2.93c.408.404.408 1.06 0 1.464a1.05 1.05 0 0 1-1.478 0zM9 9v2H7c-.002 0 0 7.991 0 7.991 0 .004 9.994.009 9.994.009.003 0 .006-7.991.006-7.991 0-.006-2-.009-2-.009V9h2c1.105 0 2 .902 2 2.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01A2 2 0 0 1 7 9z"/></svg>`
    }, props, {
        newIcon: $34d04bfb84685d13$var$_upload.default
    }));
$34d04bfb84685d13$var$ExportIcon.displayName = 'ExportIcon';
var $34d04bfb84685d13$var$_default = $34d04bfb84685d13$exports.default = $34d04bfb84685d13$var$ExportIcon;


var $fb968510c42de8af$exports = {};
"use strict";
Object.defineProperty($fb968510c42de8af$exports, "__esModule", {
    value: true
});
$fb968510c42de8af$exports.default = void 0;

var $fb968510c42de8af$var$_react = $fb968510c42de8af$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $fb968510c42de8af$var$_filter = $fb968510c42de8af$var$_interopRequireDefault((parcelRequire("86XB8")));
function $fb968510c42de8af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fb968510c42de8af$var$FilterIcon = (props)=>/*#__PURE__*/ $fb968510c42de8af$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 13h10l1-2H6zM3.99 6c-.55 0-.79.41-.55.9L4 8h16l.55-1.1c.25-.5.01-.9-.54-.9zm6.79 11.56a.87.87 0 0 0 .73.44h.99c.28 0 .61-.2.73-.44L14 16h-4z"/></svg>`
    }, props, {
        newIcon: $fb968510c42de8af$var$_filter.default
    }));
$fb968510c42de8af$var$FilterIcon.displayName = 'FilterIcon';
var $fb968510c42de8af$var$_default = $fb968510c42de8af$exports.default = $fb968510c42de8af$var$FilterIcon;


var $5d26562b02511d06$exports = {};
"use strict";
Object.defineProperty($5d26562b02511d06$exports, "__esModule", {
    value: true
});
$5d26562b02511d06$exports.default = void 0;

var $5d26562b02511d06$var$_react = $5d26562b02511d06$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $5d26562b02511d06$var$_chevronDown = $5d26562b02511d06$var$_interopRequireDefault((parcelRequire("5Y5FQ")));
function $5d26562b02511d06$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5d26562b02511d06$var$HipchatChevronDownIcon = (props)=>/*#__PURE__*/ $5d26562b02511d06$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.744 8.744a1.053 1.053 0 0 0 0 1.49l4.547 4.557a1 1 0 0 0 1.416 0l4.55-4.558a1.051 1.051 0 1 0-1.488-1.488l-3.77 3.776-3.768-3.776a1.05 1.05 0 0 0-1.487 0"/></svg>`
    }, props, {
        newIcon: $5d26562b02511d06$var$_chevronDown.default,
        iconType: "utility"
    }));
$5d26562b02511d06$var$HipchatChevronDownIcon.displayName = 'HipchatChevronDownIcon';
var $5d26562b02511d06$var$_default = $5d26562b02511d06$exports.default = $5d26562b02511d06$var$HipchatChevronDownIcon;


var $56277a34572e0602$exports = {};
"use strict";
Object.defineProperty($56277a34572e0602$exports, "__esModule", {
    value: true
});
$56277a34572e0602$exports.default = void 0;

var $56277a34572e0602$var$_react = $56277a34572e0602$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $56277a34572e0602$var$_chevronUp = $56277a34572e0602$var$_interopRequireDefault((parcelRequire("cS1ic")));
function $56277a34572e0602$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $56277a34572e0602$var$HipchatChevronUpIcon = (props)=>/*#__PURE__*/ $56277a34572e0602$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.294 8.708-4.549 4.559a1.051 1.051 0 1 0 1.486 1.488l.001-.001 3.77-3.776 3.768 3.776a1.05 1.05 0 0 0 1.486.001h.001a1.054 1.054 0 0 0 .001-1.489L12.71 8.708a1 1 0 0 0-1.415-.001"/></svg>`
    }, props, {
        newIcon: $56277a34572e0602$var$_chevronUp.default,
        iconType: "utility"
    }));
$56277a34572e0602$var$HipchatChevronUpIcon.displayName = 'HipchatChevronUpIcon';
var $56277a34572e0602$var$_default = $56277a34572e0602$exports.default = $56277a34572e0602$var$HipchatChevronUpIcon;


var $a68fb0b0d8dbf79c$exports = {};
"use strict";
Object.defineProperty($a68fb0b0d8dbf79c$exports, "__esModule", {
    value: true
});
$a68fb0b0d8dbf79c$exports.default = void 0;

var $a68fb0b0d8dbf79c$var$_react = $a68fb0b0d8dbf79c$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $a68fb0b0d8dbf79c$var$_image = $a68fb0b0d8dbf79c$var$_interopRequireDefault((parcelRequire("kmK71")));
function $a68fb0b0d8dbf79c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a68fb0b0d8dbf79c$var$ImageIcon = (props)=>/*#__PURE__*/ $a68fb0b0d8dbf79c$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M3 4.995C3 3.893 3.893 3 4.995 3h14.01C20.107 3 21 3.893 21 4.995v14.01A1.995 1.995 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.005zM10.5 16.5 9 15l-3 3h12v-2.7L15 12zM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props, {
        newIcon: $a68fb0b0d8dbf79c$var$_image.default
    }));
$a68fb0b0d8dbf79c$var$ImageIcon.displayName = 'ImageIcon';
var $a68fb0b0d8dbf79c$var$_default = $a68fb0b0d8dbf79c$exports.default = $a68fb0b0d8dbf79c$var$ImageIcon;


var $03d4c1818fb39364$exports = {};
"use strict";
Object.defineProperty($03d4c1818fb39364$exports, "__esModule", {
    value: true
});
$03d4c1818fb39364$exports.default = void 0;

var $03d4c1818fb39364$var$_react = $03d4c1818fb39364$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $03d4c1818fb39364$var$_information = $03d4c1818fb39364$var$_interopRequireDefault((parcelRequire("93YpG")));
function $03d4c1818fb39364$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $03d4c1818fb39364$var$InfoIcon = (props)=>/*#__PURE__*/ $03d4c1818fb39364$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $03d4c1818fb39364$var$_information.default
    }));
$03d4c1818fb39364$var$InfoIcon.displayName = 'InfoIcon';
var $03d4c1818fb39364$var$_default = $03d4c1818fb39364$exports.default = $03d4c1818fb39364$var$InfoIcon;


var $0be4bc1b8cb1f6f1$exports = {};
"use strict";
Object.defineProperty($0be4bc1b8cb1f6f1$exports, "__esModule", {
    value: true
});
$0be4bc1b8cb1f6f1$exports.default = void 0;

var $0be4bc1b8cb1f6f1$var$_react = $0be4bc1b8cb1f6f1$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $0be4bc1b8cb1f6f1$var$_link = $0be4bc1b8cb1f6f1$var$_interopRequireDefault((parcelRequire("bgEmk")));
function $0be4bc1b8cb1f6f1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0be4bc1b8cb1f6f1$var$LinkIcon = (props)=>/*#__PURE__*/ $0be4bc1b8cb1f6f1$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $0be4bc1b8cb1f6f1$var$_link.default
    }));
$0be4bc1b8cb1f6f1$var$LinkIcon.displayName = 'LinkIcon';
var $0be4bc1b8cb1f6f1$var$_default = $0be4bc1b8cb1f6f1$exports.default = $0be4bc1b8cb1f6f1$var$LinkIcon;


var $0035a91c863e72cf$exports = {};
"use strict";
Object.defineProperty($0035a91c863e72cf$exports, "__esModule", {
    value: true
});
$0035a91c863e72cf$exports.default = void 0;

var $0035a91c863e72cf$var$_react = $0035a91c863e72cf$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $0035a91c863e72cf$var$_location = $0035a91c863e72cf$var$_interopRequireDefault((parcelRequire("ln0Ih")));
function $0035a91c863e72cf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0035a91c863e72cf$var$LocationIcon = (props)=>/*#__PURE__*/ $0035a91c863e72cf$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21c-2.28 0-6-8.686-6-12a6 6 0 1 1 12 0c0 3.314-3.72 12-6 12m0-9a2.912 2.912 0 1 0 0-5.824A2.912 2.912 0 0 0 12 12"/></svg>`
    }, props, {
        newIcon: $0035a91c863e72cf$var$_location.default
    }));
$0035a91c863e72cf$var$LocationIcon.displayName = 'LocationIcon';
var $0035a91c863e72cf$var$_default = $0035a91c863e72cf$exports.default = $0035a91c863e72cf$var$LocationIcon;


var $1fb024143896ae8b$exports = {};
"use strict";
Object.defineProperty($1fb024143896ae8b$exports, "__esModule", {
    value: true
});
$1fb024143896ae8b$exports.default = void 0;

var $1fb024143896ae8b$var$_react = $1fb024143896ae8b$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $1fb024143896ae8b$var$_zoomIn = $1fb024143896ae8b$var$_interopRequireDefault((parcelRequire("4cYNL")));
function $1fb024143896ae8b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1fb024143896ae8b$var$MediaServicesZoomInIcon = (props)=>/*#__PURE__*/ $1fb024143896ae8b$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M13.5 11.5a1 1 0 0 0 0-2h-2v-2a1 1 0 0 0-2 0v2h-2a1 1 0 0 0 0 2h2v2a1 1 0 0 0 2 0v-2z"/></svg>`
    }, props, {
        newIcon: $1fb024143896ae8b$var$_zoomIn.default
    }));
$1fb024143896ae8b$var$MediaServicesZoomInIcon.displayName = 'MediaServicesZoomInIcon';
var $1fb024143896ae8b$var$_default = $1fb024143896ae8b$exports.default = $1fb024143896ae8b$var$MediaServicesZoomInIcon;


var $f84ee0cde97a62c2$exports = {};
"use strict";
Object.defineProperty($f84ee0cde97a62c2$exports, "__esModule", {
    value: true
});
$f84ee0cde97a62c2$exports.default = void 0;

var $f84ee0cde97a62c2$var$_react = $f84ee0cde97a62c2$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $f84ee0cde97a62c2$var$_zoomOut = $f84ee0cde97a62c2$var$_interopRequireDefault((parcelRequire("zmEJd")));
function $f84ee0cde97a62c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f84ee0cde97a62c2$var$MediaServicesZoomOutIcon = (props)=>/*#__PURE__*/ $f84ee0cde97a62c2$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M13.5 11.5h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2"/></svg>`
    }, props, {
        newIcon: $f84ee0cde97a62c2$var$_zoomOut.default
    }));
$f84ee0cde97a62c2$var$MediaServicesZoomOutIcon.displayName = 'MediaServicesZoomOutIcon';
var $f84ee0cde97a62c2$var$_default = $f84ee0cde97a62c2$exports.default = $f84ee0cde97a62c2$var$MediaServicesZoomOutIcon;


var $3388360884a36db4$exports = {};
"use strict";
Object.defineProperty($3388360884a36db4$exports, "__esModule", {
    value: true
});
$3388360884a36db4$exports.default = void 0;

var $3388360884a36db4$var$_react = $3388360884a36db4$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $3388360884a36db4$var$_menu = $3388360884a36db4$var$_interopRequireDefault((parcelRequire("3sJq9")));
function $3388360884a36db4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3388360884a36db4$var$MenuIcon = (props)=>/*#__PURE__*/ $3388360884a36db4$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 15h14v2H5zm0-8h14v2H5zm0 4h14v2H5z"/></svg>`
    }, props, {
        newIcon: $3388360884a36db4$var$_menu.default
    }));
$3388360884a36db4$var$MenuIcon.displayName = 'MenuIcon';
var $3388360884a36db4$var$_default = $3388360884a36db4$exports.default = $3388360884a36db4$var$MenuIcon;


var $89ede3cf48e6c473$exports = {};
"use strict";
Object.defineProperty($89ede3cf48e6c473$exports, "__esModule", {
    value: true
});
$89ede3cf48e6c473$exports.default = void 0;

var $89ede3cf48e6c473$var$_react = $89ede3cf48e6c473$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $89ede3cf48e6c473$var$_showMoreVertical = $89ede3cf48e6c473$var$_interopRequireDefault((parcelRequire("iQYaZ")));
function $89ede3cf48e6c473$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $89ede3cf48e6c473$var$MoreVerticalIcon = (props)=>/*#__PURE__*/ $89ede3cf48e6c473$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="12" cy="19" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="12" cy="5" r="2"/></g></svg>`
    }, props, {
        newIcon: $89ede3cf48e6c473$var$_showMoreVertical.default
    }));
$89ede3cf48e6c473$var$MoreVerticalIcon.displayName = 'MoreVerticalIcon';
var $89ede3cf48e6c473$var$_default = $89ede3cf48e6c473$exports.default = $89ede3cf48e6c473$var$MoreVerticalIcon;


var $c7b70d3a2f678352$exports = {};
"use strict";
Object.defineProperty($c7b70d3a2f678352$exports, "__esModule", {
    value: true
});
$c7b70d3a2f678352$exports.default = void 0;

var $c7b70d3a2f678352$var$_react = $c7b70d3a2f678352$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $c7b70d3a2f678352$var$_alignLeft = $c7b70d3a2f678352$var$_interopRequireDefault((parcelRequire("acHUo")));
function $c7b70d3a2f678352$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c7b70d3a2f678352$var$OverviewIcon = (props)=>/*#__PURE__*/ $c7b70d3a2f678352$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.01 18c.546 0 .99-.444.99-1a1 1 0 0 0-.99-1H3.99A.993.993 0 0 0 3 17a1 1 0 0 0 .99 1zM3 7c0 .552.445 1 .993 1h16.014A.994.994 0 0 0 21 7c0-.552-.445-1-.993-1H3.993A.994.994 0 0 0 3 7m10.998 6A1 1 0 0 0 15 12c0-.552-.456-1-1.002-1H4.002A1 1 0 0 0 3 12c0 .552.456 1 1.002 1z"/></svg>`
    }, props, {
        newIcon: $c7b70d3a2f678352$var$_alignLeft.default
    }));
$c7b70d3a2f678352$var$OverviewIcon.displayName = 'OverviewIcon';
var $c7b70d3a2f678352$var$_default = $c7b70d3a2f678352$exports.default = $c7b70d3a2f678352$var$OverviewIcon;


var $4d9bc1cb23b5f81c$exports = {};
"use strict";
Object.defineProperty($4d9bc1cb23b5f81c$exports, "__esModule", {
    value: true
});
$4d9bc1cb23b5f81c$exports.default = void 0;

var $4d9bc1cb23b5f81c$var$_react = $4d9bc1cb23b5f81c$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $4d9bc1cb23b5f81c$var$_questionCircle = $4d9bc1cb23b5f81c$var$_interopRequireDefault((parcelRequire("lEjQC")));
function $4d9bc1cb23b5f81c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4d9bc1cb23b5f81c$var$QuestionIcon = (props)=>/*#__PURE__*/ $4d9bc1cb23b5f81c$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M12 18a1 1 0 0 1 0-2 1 1 0 0 1 0 2m-2-9a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path d="M15.89 8.048a3.97 3.97 0 0 0-2.951-2.94A4.005 4.005 0 0 0 8 9.087l.009.008 1.878.022.112-.116A2 2 0 0 1 12 7c1.103 0 2 .897 2 2s-.897 2-2 2h.008a1 1 0 0 0-.998.987v2.014a1 1 0 1 0 2 0v-.782c0-.217.145-.399.349-.472a3.99 3.99 0 0 0 2.53-4.699"/></g></svg>`
    }, props, {
        newIcon: $4d9bc1cb23b5f81c$var$_questionCircle.default
    }));
$4d9bc1cb23b5f81c$var$QuestionIcon.displayName = 'QuestionIcon';
var $4d9bc1cb23b5f81c$var$_default = $4d9bc1cb23b5f81c$exports.default = $4d9bc1cb23b5f81c$var$QuestionIcon;


var $7f6dfc6f29e99698$exports = {};
"use strict";
Object.defineProperty($7f6dfc6f29e99698$exports, "__esModule", {
    value: true
});
$7f6dfc6f29e99698$exports.default = void 0;

var $7f6dfc6f29e99698$var$_react = $7f6dfc6f29e99698$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $7f6dfc6f29e99698$var$_refresh = $7f6dfc6f29e99698$var$_interopRequireDefault((parcelRequire("1qAa4")));
function $7f6dfc6f29e99698$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7f6dfc6f29e99698$var$RefreshIcon = (props)=>/*#__PURE__*/ $7f6dfc6f29e99698$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $7f6dfc6f29e99698$var$_refresh.default
    }));
$7f6dfc6f29e99698$var$RefreshIcon.displayName = 'RefreshIcon';
var $7f6dfc6f29e99698$var$_default = $7f6dfc6f29e99698$exports.default = $7f6dfc6f29e99698$var$RefreshIcon;


var $47b625f21d7ae4a6$exports = {};
"use strict";
Object.defineProperty($47b625f21d7ae4a6$exports, "__esModule", {
    value: true
});
$47b625f21d7ae4a6$exports.default = void 0;

var $47b625f21d7ae4a6$var$_react = $47b625f21d7ae4a6$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $47b625f21d7ae4a6$var$_search = $47b625f21d7ae4a6$var$_interopRequireDefault((parcelRequire("e3tIz")));
function $47b625f21d7ae4a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $47b625f21d7ae4a6$var$SearchIcon = (props)=>/*#__PURE__*/ $47b625f21d7ae4a6$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11"/></svg>`
    }, props, {
        newIcon: $47b625f21d7ae4a6$var$_search.default
    }));
$47b625f21d7ae4a6$var$SearchIcon.displayName = 'SearchIcon';
var $47b625f21d7ae4a6$var$_default = $47b625f21d7ae4a6$exports.default = $47b625f21d7ae4a6$var$SearchIcon;


var $d93733cd60a2ee2e$exports = {};
"use strict";
Object.defineProperty($d93733cd60a2ee2e$exports, "__esModule", {
    value: true
});
$d93733cd60a2ee2e$exports.default = void 0;

var $d93733cd60a2ee2e$var$_react = $d93733cd60a2ee2e$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $d93733cd60a2ee2e$var$_settings = $d93733cd60a2ee2e$var$_interopRequireDefault((parcelRequire("gmX7n")));
function $d93733cd60a2ee2e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d93733cd60a2ee2e$var$SettingsIcon = (props)=>/*#__PURE__*/ $d93733cd60a2ee2e$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.701 16.7a5.002 5.002 0 1 1 0-10.003 5.002 5.002 0 0 1 0 10.004m8.368-3.117a1.995 1.995 0 0 1-1.346-1.885c0-.876.563-1.613 1.345-1.885a.48.48 0 0 0 .315-.574 9 9 0 0 0-.836-1.993.48.48 0 0 0-.598-.195 2.04 2.04 0 0 1-1.29.08 1.99 1.99 0 0 1-1.404-1.395 2.04 2.04 0 0 1 .076-1.297.48.48 0 0 0-.196-.597 9 9 0 0 0-1.975-.826.48.48 0 0 0-.574.314 1.995 1.995 0 0 1-1.885 1.346 1.99 1.99 0 0 1-1.884-1.345.48.48 0 0 0-.575-.315c-.708.2-1.379.485-2.004.842a.47.47 0 0 0-.198.582A2.002 2.002 0 0 1 4.445 7.06a.48.48 0 0 0-.595.196 9 9 0 0 0-.833 1.994.48.48 0 0 0 .308.572 1.995 1.995 0 0 1 1.323 1.877c0 .867-.552 1.599-1.324 1.877a.48.48 0 0 0-.308.57 9 9 0 0 0 .723 1.79.477.477 0 0 0 .624.194c.595-.273 1.343-.264 2.104.238.117.077.225.185.302.3.527.8.512 1.58.198 2.188a.473.473 0 0 0 .168.628 9 9 0 0 0 2.11.897.474.474 0 0 0 .57-.313 1.995 1.995 0 0 1 1.886-1.353c.878 0 1.618.567 1.887 1.353a.475.475 0 0 0 .57.313 9 9 0 0 0 2.084-.883.473.473 0 0 0 .167-.631c-.318-.608-.337-1.393.191-2.195.077-.116.185-.225.302-.302.772-.511 1.527-.513 2.125-.23a.477.477 0 0 0 .628-.19 9 9 0 0 0 .728-1.793.48.48 0 0 0-.314-.573"/></svg>`
    }, props, {
        newIcon: $d93733cd60a2ee2e$var$_settings.default
    }));
$d93733cd60a2ee2e$var$SettingsIcon.displayName = 'SettingsIcon';
var $d93733cd60a2ee2e$var$_default = $d93733cd60a2ee2e$exports.default = $d93733cd60a2ee2e$var$SettingsIcon;


var $eb718c580db4626b$exports = {};
"use strict";
Object.defineProperty($eb718c580db4626b$exports, "__esModule", {
    value: true
});
$eb718c580db4626b$exports.default = void 0;

var $eb718c580db4626b$var$_react = $eb718c580db4626b$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $eb718c580db4626b$var$_share = $eb718c580db4626b$var$_interopRequireDefault((parcelRequire("ecMhW")));
function $eb718c580db4626b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eb718c580db4626b$var$ShareIcon = (props)=>/*#__PURE__*/ $eb718c580db4626b$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $eb718c580db4626b$var$_share.default
    }));
$eb718c580db4626b$var$ShareIcon.displayName = 'ShareIcon';
var $eb718c580db4626b$var$_default = $eb718c580db4626b$exports.default = $eb718c580db4626b$var$ShareIcon;


var $de0848e68fcb9d68$exports = {};
"use strict";
Object.defineProperty($de0848e68fcb9d68$exports, "__esModule", {
    value: true
});
$de0848e68fcb9d68$exports.default = void 0;

var $de0848e68fcb9d68$var$_react = $de0848e68fcb9d68$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $de0848e68fcb9d68$var$_starUnstarred = $de0848e68fcb9d68$var$_interopRequireDefault((parcelRequire("8heaH")));
function $de0848e68fcb9d68$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $de0848e68fcb9d68$var$StarIcon = (props)=>/*#__PURE__*/ $de0848e68fcb9d68$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m12 16.373 3.98 2.193-.76-4.655 3.276-3.347-4.524-.69L12 5.687l-1.972 4.189-4.524.689L8.78 13.91l-.762 4.655zm0 2.283-3.016 1.662a2 2 0 0 1-2.939-2.075l.599-3.656-2.57-2.624a2 2 0 0 1 1.129-3.377l3.47-.528 1.518-3.224a2 2 0 0 1 3.618 0l1.519 3.224 3.47.528a2 2 0 0 1 1.127 3.377l-2.569 2.624.599 3.656a2 2 0 0 1-2.94 2.075z"/></svg>`
    }, props, {
        newIcon: $de0848e68fcb9d68$var$_starUnstarred.default
    }));
$de0848e68fcb9d68$var$StarIcon.displayName = 'StarIcon';
var $de0848e68fcb9d68$var$_default = $de0848e68fcb9d68$exports.default = $de0848e68fcb9d68$var$StarIcon;


var $7f3db16b7d369d9b$exports = {};
"use strict";
Object.defineProperty($7f3db16b7d369d9b$exports, "__esModule", {
    value: true
});
$7f3db16b7d369d9b$exports.default = void 0;

var $7f3db16b7d369d9b$var$_react = $7f3db16b7d369d9b$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $7f3db16b7d369d9b$var$_starStarred = $7f3db16b7d369d9b$var$_interopRequireDefault((parcelRequire("9ujTo")));
function $7f3db16b7d369d9b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7f3db16b7d369d9b$var$StarFilledIcon = (props)=>/*#__PURE__*/ $7f3db16b7d369d9b$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m12.072 17.284-3.905 2.053a1 1 0 0 1-1.451-1.054l.745-4.349-3.159-3.08a1 1 0 0 1 .554-1.705l4.366-.635 1.953-3.956a1 1 0 0 1 1.794 0l1.952 3.956 4.366.635a1 1 0 0 1 .555 1.705l-3.16 3.08.746 4.349a1 1 0 0 1-1.45 1.054z"/></svg>`
    }, props, {
        newIcon: $7f3db16b7d369d9b$var$_starStarred.default
    }));
$7f3db16b7d369d9b$var$StarFilledIcon.displayName = 'StarFilledIcon';
var $7f3db16b7d369d9b$var$_default = $7f3db16b7d369d9b$exports.default = $7f3db16b7d369d9b$var$StarFilledIcon;


var $fcdbc1d2bc40f8ba$exports = {};
"use strict";
Object.defineProperty($fcdbc1d2bc40f8ba$exports, "__esModule", {
    value: true
});
$fcdbc1d2bc40f8ba$exports.default = void 0;

var $fcdbc1d2bc40f8ba$var$_react = $fcdbc1d2bc40f8ba$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $fcdbc1d2bc40f8ba$var$_warning = $fcdbc1d2bc40f8ba$var$_interopRequireDefault((parcelRequire("72WPR")));
function $fcdbc1d2bc40f8ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fcdbc1d2bc40f8ba$var$WarningIcon = (props)=>/*#__PURE__*/ $fcdbc1d2bc40f8ba$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $fcdbc1d2bc40f8ba$var$_warning.default
    }));
$fcdbc1d2bc40f8ba$var$WarningIcon.displayName = 'WarningIcon';
var $fcdbc1d2bc40f8ba$var$_default = $fcdbc1d2bc40f8ba$exports.default = $fcdbc1d2bc40f8ba$var$WarningIcon;


var $d99a39b11f2828b9$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aeea3452b156c1a88293b0f0d28d725d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($d99a39b11f2828b9$exports, "__esModule", {
    value: true
});
$d99a39b11f2828b9$exports.default = void 0;

var $d99a39b11f2828b9$var$_react = $d99a39b11f2828b9$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $d99a39b11f2828b9$var$_baseNew = $d99a39b11f2828b9$var$_interopRequireDefault((parcelRequire("k6VkH")));
function $d99a39b11f2828b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GenerativeIndicator".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for indicating generative and suggested content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d99a39b11f2828b9$var$GenerativeIndicatorIcon = (props)=>/*#__PURE__*/ $d99a39b11f2828b9$var$_react.default.createElement($d99a39b11f2828b9$var$_baseNew.default, Object.assign({
        name: "GenerativeIndicatorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.117 1.009a.75.75 0 0 1 .588.484l1.55 4.251 4.252 1.55A.75.75 0 0 1 15 8v.002a.75.75 0 0 1-.493.704l-4.252 1.55-1.55 4.252a.75.75 0 0 1-.704.493h-.002a.75.75 0 0 1-.704-.493l-1.55-4.252-4.252-1.55A.75.75 0 0 1 1 8.001v-.002a.75.75 0 0 1 .493-.704l4.251-1.55 1.55-4.252.049-.106A.75.75 0 0 1 7.999 1h.002z"/>`
    }, props));
$d99a39b11f2828b9$var$GenerativeIndicatorIcon.displayName = 'GenerativeIndicatorIcon';
var $d99a39b11f2828b9$var$_default = $d99a39b11f2828b9$exports.default = $d99a39b11f2828b9$var$GenerativeIndicatorIcon;


var $25e8a161b396b80d$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b7be9690353c7bf82b96c9a0cc89ae3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($25e8a161b396b80d$exports, "__esModule", {
    value: true
});
$25e8a161b396b80d$exports.default = void 0;

var $25e8a161b396b80d$var$_react = $25e8a161b396b80d$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $25e8a161b396b80d$var$_baseNew = $25e8a161b396b80d$var$_interopRequireDefault((parcelRequire("k6VkH")));
function $25e8a161b396b80d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RoadmapsPlan".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing plans.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25e8a161b396b80d$var$RoadmapsPlanIcon = (props)=>/*#__PURE__*/ $25e8a161b396b80d$var$_react.default.createElement($25e8a161b396b80d$var$_baseNew.default, Object.assign({
        name: "RoadmapsPlanIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M1 3.5a2.5 2.5 0 0 1 4.886-.75h4.864a3 3 0 1 1 0 6h-5.5a1.5 1.5 0 1 0 0 3h4.865a2.501 2.501 0 1 1 0 1.5H5.25a3 3 0 1 1 0-6h5.5a1.5 1.5 0 0 0 0-3H5.886A2.501 2.501 0 0 1 1 3.5m11.5 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$25e8a161b396b80d$var$RoadmapsPlanIcon.displayName = 'RoadmapsPlanIcon';
var $25e8a161b396b80d$var$_default = $25e8a161b396b80d$exports.default = $25e8a161b396b80d$var$RoadmapsPlanIcon;


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable prefer-rest-params */ /* eslint-disable no-console */ var $7daadcd75c03f17d$var$printed = {};
function $7daadcd75c03f17d$export$2e2bcd8739ae039(message) {
    if ($7daadcd75c03f17d$var$printed[message]) return;
    $7daadcd75c03f17d$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}



var $3ZMUU = parcelRequire("3ZMUU");
function $b89ec1d634bf8f9f$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $7daadcd75c03f17d$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $b89ec1d634bf8f9f$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $3ZMUU;
}



var $0ce0c6f54e6e45da$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $0ce0c6f54e6e45da$export$c93026a968943f95 = 'light';
var $0ce0c6f54e6e45da$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $0ce0c6f54e6e45da$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $0ce0c6f54e6e45da$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $0ce0c6f54e6e45da$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $0ce0c6f54e6e45da$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $0ce0c6f54e6e45da$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $0ce0c6f54e6e45da$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $0ce0c6f54e6e45da$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $54ca2d3948378259$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0ce0c6f54e6e45da$export$6d8204c2cb2e06b8() / 4;
    (0, $b89ec1d634bf8f9f$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $0ce0c6f54e6e45da$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $0ce0c6f54e6e45da$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $0ce0c6f54e6e45da$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $b89ec1d634bf8f9f$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $0ce0c6f54e6e45da$export$ba1d834b86d72a09 = $0ce0c6f54e6e45da$export$a1b3edb637fb4f35;
var $0ce0c6f54e6e45da$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $54ca2d3948378259$export$2a0674ff2eb10214)(), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $54ca2d3948378259$export$2a0674ff2eb10214)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $54ca2d3948378259$export$920c0d5c49070351), ")")
            }
        }
    };
};


function $c72245efbf0a215e$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $0ce0c6f54e6e45da$export$44ffba16bd48dac6) in props.theme) return props.theme[0, $0ce0c6f54e6e45da$export$44ffba16bd48dac6];
        else if ('mode' in props.theme && (0, $0ce0c6f54e6e45da$export$6ba72c8346b4c57e).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $0ce0c6f54e6e45da$export$c93026a968943f95)
    };
}


// Unpack custom variants, and get correct value for the current theme
function $aad78afbdc47a5b9$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $c72245efbf0a215e$export$2e2bcd8739ae039)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return '';
    };
}
function $aad78afbdc47a5b9$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === 'string') return $aad78afbdc47a5b9$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $c72245efbf0a215e$export$2e2bcd8739ae039)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return '';
    };
}


var $54ca2d3948378259$export$4b84fd0e2c617bd = '#FFEBE6';
var $54ca2d3948378259$export$b34b069eff244586 = '#FFBDAD';
var $54ca2d3948378259$export$be802dd0d8b57f35 = '#FF8F73';
var $54ca2d3948378259$export$60847d42f9da92a6 = '#FF7452';
var $54ca2d3948378259$export$4a7404f376229999 = '#FF5630';
var $54ca2d3948378259$export$2010d0fb4295b346 = '#DE350B';
var $54ca2d3948378259$export$2837b5a1a71d5c02 = '#BF2600';
var $54ca2d3948378259$export$8d9596b529bbb9cf = '#FFFAE6';
var $54ca2d3948378259$export$41060a744ab0b7ae = '#FFF0B3';
var $54ca2d3948378259$export$1cc05bbbf340e559 = '#FFE380';
var $54ca2d3948378259$export$5aae31392d72caaa = '#FFC400';
var $54ca2d3948378259$export$c6930421db9fa514 = '#FFAB00';
var $54ca2d3948378259$export$59619663aa6500fb = '#FF991F';
var $54ca2d3948378259$export$874739ea9e379ab6 = '#FF8B00';
var $54ca2d3948378259$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $54ca2d3948378259$export$69a3bf21b9686c2b = '#ABF5D1';
var $54ca2d3948378259$export$afbce1382ec95f73 = '#79F2C0';
var $54ca2d3948378259$export$747d86715d4175de = '#57D9A3';
var $54ca2d3948378259$export$940e1f69e873f202 = '#36B37E';
var $54ca2d3948378259$export$a49394138f7b8e85 = '#00875A';
var $54ca2d3948378259$export$6fa04827ac68a4fb = '#006644';
var $54ca2d3948378259$export$226de0355ed012f8 = '#DEEBFF';
var $54ca2d3948378259$export$8c13c2ee36917869 = '#B3D4FF';
var $54ca2d3948378259$export$ecfc1dff386a3e7a = '#4C9AFF';
var $54ca2d3948378259$export$215b7063051591f1 = '#2684FF';
var $54ca2d3948378259$export$e62e8919cca44969 = '#0065FF';
var $54ca2d3948378259$export$b3de0ae08da2ce64 = '#0052CC';
var $54ca2d3948378259$export$a6ee3d71bc067634 = '#0747A6';
var $54ca2d3948378259$export$363e4475840015bb = '#EAE6FF';
var $54ca2d3948378259$export$4b0a4417ed59760f = '#C0B6F2';
var $54ca2d3948378259$export$6011520a64d9a187 = '#998DD9';
var $54ca2d3948378259$export$a7175d4e9206bc80 = '#8777D9';
var $54ca2d3948378259$export$b48405b95304b5a1 = '#6554C0';
var $54ca2d3948378259$export$c71e4279dd54a18d = '#5243AA';
var $54ca2d3948378259$export$147899de772240ec = '#403294';
var $54ca2d3948378259$export$2cf711fe14c66f06 = '#E6FCFF';
var $54ca2d3948378259$export$7a8f4d33f6f9772c = '#B3F5FF';
var $54ca2d3948378259$export$776c9c497ef08533 = '#79E2F2';
var $54ca2d3948378259$export$69cb3ca10c1e330e = '#00C7E6';
var $54ca2d3948378259$export$9dc1ef0f3f48059b = '#00B8D9';
var $54ca2d3948378259$export$7c835c78b6fcdef8 = '#00A3BF';
var $54ca2d3948378259$export$6036577f95c3877e = '#008DA6';
var $54ca2d3948378259$export$29a4f05edc054374 = '#FFFFFF';
var $54ca2d3948378259$export$e655ef011c4aa1a2 = '#FAFBFC';
var $54ca2d3948378259$export$9fdfb749e33cdf97 = '#F4F5F7';
var $54ca2d3948378259$export$3e51e8f1440314ba = '#EBECF0';
var $54ca2d3948378259$export$1ce2d1575d444ceb = '#DFE1E6';
var $54ca2d3948378259$export$8754fc7e6d8b3000 = '#C1C7D0';
var $54ca2d3948378259$export$c2e91cbeada39b8b = '#B3BAC5';
var $54ca2d3948378259$export$5f71e19f3a7ad9de = '#A5ADBA';
var $54ca2d3948378259$export$eaa8c8a70ac22806 = '#97A0AF';
var $54ca2d3948378259$export$7c87d337fb91a97d = '#8993A4';
var $54ca2d3948378259$export$d6447c357493214f = '#7A869A';
var $54ca2d3948378259$export$f563ee71e9ee74cd = '#6B778C';
var $54ca2d3948378259$export$e2ef2124cf4024b1 = '#5E6C84';
var $54ca2d3948378259$export$eece5f492e429f08 = '#505F79';
var $54ca2d3948378259$export$c39c0fe0f26207ae = '#42526E';
var $54ca2d3948378259$export$7090862dc3038a9f = '#344563';
var $54ca2d3948378259$export$ad0bacf983b7ddaa = '#253858';
var $54ca2d3948378259$export$7d61b15e0da132af = '#172B4D';
var $54ca2d3948378259$export$fbda843f0a27fe96 = '#091E42';
var $54ca2d3948378259$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $54ca2d3948378259$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $54ca2d3948378259$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $54ca2d3948378259$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $54ca2d3948378259$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $54ca2d3948378259$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $54ca2d3948378259$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $54ca2d3948378259$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $54ca2d3948378259$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $54ca2d3948378259$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $54ca2d3948378259$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $54ca2d3948378259$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $54ca2d3948378259$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $54ca2d3948378259$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $54ca2d3948378259$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $54ca2d3948378259$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $54ca2d3948378259$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $54ca2d3948378259$export$2f6319cf7d736c2a = '#E6EDFA';
var $54ca2d3948378259$export$95126bc8884d6634 = '#DCE5F5';
var $54ca2d3948378259$export$8338d8c35d44ff1 = '#CED9EB';
var $54ca2d3948378259$export$5368d76ae4fbbda7 = '#B8C7E0';
var $54ca2d3948378259$export$9f0a771d16ec8d36 = '#ABBBD6';
var $54ca2d3948378259$export$abcf8c38338b4aa5 = '#9FB0CC';
var $54ca2d3948378259$export$97e81faa16a182c7 = '#8C9CB8';
var $54ca2d3948378259$export$bfe21c59123ecf33 = '#7988A3';
var $54ca2d3948378259$export$ee82aa2ea6a1558 = '#67758F';
var $54ca2d3948378259$export$682927c6ed76be02 = '#56637A';
var $54ca2d3948378259$export$91fd9994c5be9757 = '#455166';
var $54ca2d3948378259$export$d281fbfe3cff2df6 = '#3B475C';
var $54ca2d3948378259$export$3902c91d8b98a753 = '#313D52';
var $54ca2d3948378259$export$8e8133c1ba5845b5 = '#283447';
var $54ca2d3948378259$export$33ff357f6620b39 = '#202B3D';
var $54ca2d3948378259$export$633847cf062b69e0 = '#1B2638';
var $54ca2d3948378259$export$9776a6e503bdbf76 = '#121A29';
var $54ca2d3948378259$export$6c813d5160dff5db = '#0E1624';
var $54ca2d3948378259$export$3d4f271a500072a = '#0D1424';
var $54ca2d3948378259$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $54ca2d3948378259$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $54ca2d3948378259$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $54ca2d3948378259$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $54ca2d3948378259$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $54ca2d3948378259$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $54ca2d3948378259$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $54ca2d3948378259$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $54ca2d3948378259$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $54ca2d3948378259$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $54ca2d3948378259$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $54ca2d3948378259$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $54ca2d3948378259$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $54ca2d3948378259$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $54ca2d3948378259$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $54ca2d3948378259$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $54ca2d3948378259$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $54ca2d3948378259$export$8ce1fd94bee2f412 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-surface, ".concat($54ca2d3948378259$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($54ca2d3948378259$export$633847cf062b69e0, ")")
});
var $54ca2d3948378259$export$b861914ea877b580 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-background-selected, ".concat($54ca2d3948378259$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($54ca2d3948378259$export$8c13c2ee36917869, ")")
});
var $54ca2d3948378259$export$3f1b020df94387af = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-background-neutral-hovered, ".concat($54ca2d3948378259$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($54ca2d3948378259$export$d281fbfe3cff2df6, ")")
});
var $54ca2d3948378259$export$c0183dbab98ca63e = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-surface-overlay, ".concat($54ca2d3948378259$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($54ca2d3948378259$export$8e8133c1ba5845b5, ")")
});
var $54ca2d3948378259$export$6f093cfa640b7166 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($54ca2d3948378259$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($54ca2d3948378259$export$5368d76ae4fbbda7, ")")
});
var $54ca2d3948378259$export$42f8e9c698766e7a = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($54ca2d3948378259$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($54ca2d3948378259$export$5368d76ae4fbbda7, ")")
});
var $54ca2d3948378259$export$c2d157ca1c34b6e3 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-text-selected, ".concat($54ca2d3948378259$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($54ca2d3948378259$export$b3de0ae08da2ce64, ")")
});
var $54ca2d3948378259$export$1905ba28d7cf066f = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($54ca2d3948378259$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($54ca2d3948378259$export$97e81faa16a182c7, ")")
});
var $54ca2d3948378259$export$bd9002130d306d39 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($54ca2d3948378259$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($54ca2d3948378259$export$bfe21c59123ecf33, ")")
});
var $54ca2d3948378259$export$46e4a324ac90507f = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($54ca2d3948378259$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($54ca2d3948378259$export$5368d76ae4fbbda7, ")")
});
var $54ca2d3948378259$export$79f3f2b82beb0d36 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($54ca2d3948378259$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($54ca2d3948378259$export$97e81faa16a182c7, ")")
});
var $54ca2d3948378259$export$7bb0d5c671655cc4 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: $54ca2d3948378259$export$9fdfb749e33cdf97,
    dark: $54ca2d3948378259$export$8e8133c1ba5845b5
});
var $54ca2d3948378259$export$9c30223ca0a664fb = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-link, ".concat($54ca2d3948378259$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($54ca2d3948378259$export$ecfc1dff386a3e7a, ")")
});
var $54ca2d3948378259$export$7ed258b0728b004b = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($54ca2d3948378259$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($54ca2d3948378259$export$215b7063051591f1, ")")
});
var $54ca2d3948378259$export$dfa920d8decc8a59 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($54ca2d3948378259$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($54ca2d3948378259$export$ecfc1dff386a3e7a, ")")
});
var $54ca2d3948378259$export$6069e6ad5c78f632 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-border-focused, ".concat($54ca2d3948378259$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($54ca2d3948378259$export$215b7063051591f1, ")")
});
var $54ca2d3948378259$export$9ad721cf3b3debe0 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-background-brand-bold, ".concat($54ca2d3948378259$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($54ca2d3948378259$export$ecfc1dff386a3e7a, ")")
});
var $54ca2d3948378259$export$2aa0182783e7e9de = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: $54ca2d3948378259$export$b3de0ae08da2ce64,
    dark: $54ca2d3948378259$export$ecfc1dff386a3e7a
});
var $54ca2d3948378259$export$8bf7dff220b82b4a = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: $54ca2d3948378259$export$9dc1ef0f3f48059b,
    dark: $54ca2d3948378259$export$69cb3ca10c1e330e
});
var $54ca2d3948378259$export$e13cce2a2d16a9d4 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: $54ca2d3948378259$export$b48405b95304b5a1,
    dark: $54ca2d3948378259$export$6011520a64d9a187
});
var $54ca2d3948378259$export$a90204d1394caf30 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: $54ca2d3948378259$export$4a7404f376229999,
    dark: $54ca2d3948378259$export$4a7404f376229999
});
var $54ca2d3948378259$export$594c5a8758200c32 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: $54ca2d3948378259$export$c6930421db9fa514,
    dark: $54ca2d3948378259$export$c6930421db9fa514
});
var $54ca2d3948378259$export$955a2ebd2fb142ae = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: $54ca2d3948378259$export$940e1f69e873f202,
    dark: $54ca2d3948378259$export$940e1f69e873f202
});
var $54ca2d3948378259$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($54ca2d3948378259$export$8d43898f60b96a82, ")");
};



var $5FkrB = parcelRequire("5FkrB");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $f9ff4343296b19bf$var$n = function(t, e) {
    return ($f9ff4343296b19bf$var$n = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var n in e)e.hasOwnProperty(n) && (t[n] = e[n]);
    })(t, e);
};
var $f9ff4343296b19bf$var$o, $f9ff4343296b19bf$var$r, $f9ff4343296b19bf$var$i = (function(t) {
    /*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ !function() {
        var e = {}.hasOwnProperty;
        function n() {
            for(var t = [], o = 0; o < arguments.length; o++){
                var r = arguments[o];
                if (r) {
                    var i = typeof r;
                    if ("string" === i || "number" === i) t.push(r);
                    else if (Array.isArray(r) && r.length) {
                        var s = n.apply(null, r);
                        s && t.push(s);
                    } else if ("object" === i) for(var l in r)e.call(r, l) && r[l] && t.push(l);
                }
            }
            return t.join(" ");
        }
        t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    }();
}($f9ff4343296b19bf$var$r = {
    path: $f9ff4343296b19bf$var$o,
    exports: {},
    require: function(t, e) {
        return function() {
            throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
        }(null == e && $f9ff4343296b19bf$var$r.path);
    }
}, $f9ff4343296b19bf$var$r.exports), $f9ff4343296b19bf$var$r.exports);
function $f9ff4343296b19bf$var$s(t, e, n) {
    var o, r, i, s, l;
    function a() {
        var c = Date.now() - s;
        c < e && c >= 0 ? o = setTimeout(a, e - c) : (o = null, n || (l = t.apply(i, r), i = r = null));
    }
    null == e && (e = 100);
    var c = function() {
        i = this, r = arguments, s = Date.now();
        var c = n && !o;
        return o || (o = setTimeout(a, e)), c && (l = t.apply(i, r), i = r = null), l;
    };
    return c.clear = function() {
        o && (clearTimeout(o), o = null);
    }, c.flush = function() {
        o && (l = t.apply(i, r), i = r = null, clearTimeout(o), o = null);
    }, c;
}
$f9ff4343296b19bf$var$s.debounce = $f9ff4343296b19bf$var$s;
var $f9ff4343296b19bf$var$l = $f9ff4343296b19bf$var$s;
!function(t, e) {
    void 0 === e && (e = {});
    var n = e.insertAt;
    if (t && "undefined" != typeof document) {
        var o = document.head || document.getElementsByTagName("head")[0], r = document.createElement("style");
        r.type = "text/css", "top" === n && o.firstChild ? o.insertBefore(r, o.firstChild) : o.appendChild(r), r.styleSheet ? r.styleSheet.cssText = t : r.appendChild(document.createTextNode(t));
    }
}(".indiana-scroll-container {\n  overflow: auto;\n}\n.indiana-scroll-container--dragging {\n  scroll-behavior: auto !important;\n}\n.indiana-scroll-container--dragging > * {\n  pointer-events: none;\n  cursor: -webkit-grab;\n  cursor: grab;\n}\n.indiana-scroll-container--hide-scrollbars {\n  overflow: hidden;\n  overflow: -moz-scrollbars-none;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n.indiana-scroll-container--hide-scrollbars::-webkit-scrollbar {\n  display: none !important;\n  height: 0 !important;\n  width: 0 !important;\n  background: transparent !important;\n  -webkit-appearance: none !important;\n}\n.indiana-scroll-container--native-scroll {\n  overflow: auto;\n}\n\n.indiana-dragging {\n  cursor: -webkit-grab;\n  cursor: grab;\n}");
var $f9ff4343296b19bf$var$a, $f9ff4343296b19bf$var$c = ($f9ff4343296b19bf$var$a = "indiana-scroll-container", function(t, e) {
    if (!t) return $f9ff4343296b19bf$var$a;
    var n;
    "string" == typeof t ? n = t : e = t;
    var o = $f9ff4343296b19bf$var$a;
    return n && (o += "__" + n), o + (e ? Object.keys(e).reduce(function(t, n) {
        var r = e[n];
        return r && (t += " " + ("boolean" == typeof r ? o + "--" + n : o + "--" + n + "_" + r)), t;
    }, "") : "");
}), $f9ff4343296b19bf$var$p = function(e) {
    function o(n) {
        var o = e.call(this, n) || this;
        return o.onEndScroll = function() {
            o.scrolling = !1, !o.pressed && o.started && o.processEnd();
        }, o.onScroll = function(t) {
            var e = o.container.current;
            e.scrollLeft === o.scrollLeft && e.scrollTop === o.scrollTop || (o.scrolling = !0, o.processScroll(t), o.onEndScroll());
        }, o.onTouchStart = function(t) {
            var e = o.props.nativeMobileScroll;
            if (o.isDraggable(t.target)) {
                if (o.internal = !0, e && o.scrolling) o.pressed = !0;
                else {
                    var n = t.touches[0];
                    o.processClick(t, n.clientX, n.clientY), !e && o.props.stopPropagation && t.stopPropagation();
                }
            }
        }, o.onTouchEnd = function(t) {
            var e = o.props.nativeMobileScroll;
            o.pressed && (!o.started || o.scrolling && e ? o.pressed = !1 : o.processEnd(), o.forceUpdate());
        }, o.onTouchMove = function(t) {
            var e = o.props.nativeMobileScroll;
            if (o.pressed && (!e || !o.isMobile)) {
                var n = t.touches[0];
                n && o.processMove(t, n.clientX, n.clientY), t.preventDefault(), o.props.stopPropagation && t.stopPropagation();
            }
        }, o.onMouseDown = function(t) {
            o.isDraggable(t.target) && o.isScrollable() && (o.internal = !0, -1 !== o.props.buttons.indexOf(t.button) && (o.processClick(t, t.clientX, t.clientY), t.preventDefault(), o.props.stopPropagation && t.stopPropagation()));
        }, o.onMouseMove = function(t) {
            o.pressed && (o.processMove(t, t.clientX, t.clientY), t.preventDefault(), o.props.stopPropagation && t.stopPropagation());
        }, o.onMouseUp = function(t) {
            o.pressed && (o.started ? o.processEnd() : (o.internal = !1, o.pressed = !1, o.forceUpdate(), o.props.onClick && o.props.onClick(t)), t.preventDefault(), o.props.stopPropagation && t.stopPropagation());
        }, o.container = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createRef(), o.onEndScroll = $f9ff4343296b19bf$var$l(o.onEndScroll, 300), o.scrolling = !1, o.started = !1, o.pressed = !1, o.internal = !1, o.getRef = o.getRef.bind(o), o;
    }
    return function(t, e) {
        function o() {
            this.constructor = t;
        }
        $f9ff4343296b19bf$var$n(t, e), t.prototype = null === e ? Object.create(e) : (o.prototype = e.prototype, new o);
    }(o, e), o.prototype.componentDidMount = function() {
        var t = this.props.nativeMobileScroll, e = this.container.current;
        window.addEventListener("mouseup", this.onMouseUp), window.addEventListener("mousemove", this.onMouseMove), window.addEventListener("touchmove", this.onTouchMove, {
            passive: !1
        }), window.addEventListener("touchend", this.onTouchEnd), e.addEventListener("touchstart", this.onTouchStart, {
            passive: !1
        }), e.addEventListener("mousedown", this.onMouseDown, {
            passive: !1
        }), t && (this.isMobile = this.isMobileDevice(), this.isMobile && this.forceUpdate());
    }, o.prototype.componentWillUnmount = function() {
        window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
    }, o.prototype.getElement = function() {
        return this.container.current;
    }, o.prototype.isMobileDevice = function() {
        return void 0 !== window.orientation || -1 !== navigator.userAgent.indexOf("IEMobile");
    }, o.prototype.isDraggable = function(t) {
        var e = this.props.ignoreElements;
        if (e) {
            var n = t.closest(e);
            return null === n || n.contains(this.getElement());
        }
        return !0;
    }, o.prototype.isScrollable = function() {
        var t = this.container.current;
        return t && (t.scrollWidth > t.clientWidth || t.scrollHeight > t.clientHeight);
    }, o.prototype.processClick = function(t, e, n) {
        var o = this.container.current;
        this.scrollLeft = o.scrollLeft, this.scrollTop = o.scrollTop, this.clientX = e, this.clientY = n, this.pressed = !0;
    }, o.prototype.processStart = function(t) {
        void 0 === t && (t = !0);
        var e = this.props.onStartScroll;
        this.started = !0, t && document.body.classList.add("indiana-dragging"), e && e({
            external: !this.internal
        }), this.forceUpdate();
    }, o.prototype.processScroll = function(t) {
        if (this.started) {
            var e = this.props.onScroll;
            e && e({
                external: !this.internal
            });
        } else this.processStart(!1);
    }, o.prototype.processMove = function(t, e, n) {
        var o = this.props, r = o.horizontal, i = o.vertical, s = o.activationDistance, l = o.onScroll, a = this.container.current;
        this.started ? (r && (a.scrollLeft -= e - this.clientX), i && (a.scrollTop -= n - this.clientY), l && l({
            external: !this.internal
        }), this.clientX = e, this.clientY = n, this.scrollLeft = a.scrollLeft, this.scrollTop = a.scrollTop) : (r && Math.abs(e - this.clientX) > s || i && Math.abs(n - this.clientY) > s) && (this.clientX = e, this.clientY = n, this.processStart());
    }, o.prototype.processEnd = function() {
        var t = this.props.onEndScroll;
        this.container.current && t && t({
            external: !this.internal
        }), this.pressed = !1, this.started = !1, this.scrolling = !1, this.internal = !1, document.body.classList.remove("indiana-dragging"), this.forceUpdate();
    }, o.prototype.getRef = function(t) {
        [
            this.container,
            this.props.innerRef
        ].forEach(function(e) {
            e && ("function" == typeof e ? e(t) : e.current = t);
        });
    }, o.prototype.render = function() {
        var e = this.props, n = e.children, o = e.draggingClassName, r = e.className, s = e.style, l = e.hideScrollbars, a = e.component;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(a, {
            className: $f9ff4343296b19bf$var$i(r, this.pressed && o, $f9ff4343296b19bf$var$c({
                dragging: this.pressed,
                "hide-scrollbars": l,
                "native-scroll": this.isMobile
            })),
            style: s,
            ref: this.getRef,
            onScroll: this.onScroll
        }, n);
    }, o.defaultProps = {
        nativeMobileScroll: !0,
        hideScrollbars: !0,
        activationDistance: 10,
        vertical: !0,
        horizontal: !0,
        stopPropagation: !1,
        style: {},
        component: "div",
        buttons: [
            0
        ]
    }, o;
}((0, $5FkrB.PureComponent));
var $f9ff4343296b19bf$export$2e2bcd8739ae039 = $f9ff4343296b19bf$var$p;



var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
/* button-base.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");


var $5FkrB = parcelRequire("5FkrB");
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ parcelRequire("5FkrB");

const $a1d7498f0e17fcb7$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $a1d7498f0e17fcb7$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};


/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $c1174b6b2fa6c503$var$ATOMIC_GROUP_LENGTH = 5;
function $c1174b6b2fa6c503$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $c1174b6b2fa6c503$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


const $a1cd1f9defc554d9$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $c1174b6b2fa6c503$export$2e2bcd8739ae039)(actualStyles);
};


function $20b80022fc0a2d48$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $a1d7498f0e17fcb7$export$c4df1cb0c2b4d77c)();
        },
        cssMap () {
            throw (0, $a1d7498f0e17fcb7$export$c4df1cb0c2b4d77c)();
        },
        cx: $a1cd1f9defc554d9$export$a274e22fb40f762e,
        XCSSProp () {
            throw (0, $a1d7498f0e17fcb7$export$c4df1cb0c2b4d77c)();
        }
    };
}


var $51c2ad1cc5d37be6$var$strictApi = (0, $20b80022fc0a2d48$export$39716b4af53f4ad)();
var $51c2ad1cc5d37be6$export$dbf350e5966cf602 = $51c2ad1cc5d37be6$var$strictApi.css;
var $51c2ad1cc5d37be6$export$eb1ecd84a24ee424 = $51c2ad1cc5d37be6$var$strictApi.cssMap;
$51c2ad1cc5d37be6$var$strictApi.cssMap;
var $51c2ad1cc5d37be6$export$a274e22fb40f762e = $51c2ad1cc5d37be6$var$strictApi.cx;
var $51c2ad1cc5d37be6$var$XCSSProp = $51c2ad1cc5d37be6$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 



var $ekGgq = parcelRequire("ekGgq");
function $d1a0e9749b65ff00$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref) === 'object') ref.current = value;
        });
    };
}




var $5FkrB = parcelRequire("5FkrB");
function $eae303b7f4b562de$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId().replace(/[:«»]/g, '_');
}



var $aptQa = parcelRequire("aptQa");
/* pressable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


const $e5ad449582742021$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $120779d35fab2d6d$export$2e2bcd8739ae039)(actualStyles);
};



var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $506ce1a15eca601f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $506ce1a15eca601f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $506ce1a15eca601f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $506ce1a15eca601f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $506ce1a15eca601f$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $506ce1a15eca601f$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $506ce1a15eca601f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $506ce1a15eca601f$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $506ce1a15eca601f$var$_objectSpread($506ce1a15eca601f$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $641d3b73eba6c901$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $641d3b73eba6c901$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $641d3b73eba6c901$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($641d3b73eba6c901$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $641d3b73eba6c901$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $641d3b73eba6c901$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $641d3b73eba6c901$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $641d3b73eba6c901$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $641d3b73eba6c901$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $641d3b73eba6c901$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $506ce1a15eca601f$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $700e2181b4577d30$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $51e88b9fa4d8f8fc$export$5bf35293e545f20c() {
    var analyticsContext = (0, $700e2181b4577d30$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $641d3b73eba6c901$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $11128bf676f27053$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $f1b63fd217f30033$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f1b63fd217f30033$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f1b63fd217f30033$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f1b63fd217f30033$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f1b63fd217f30033$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $51e88b9fa4d8f8fc$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $11128bf676f27053$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $11128bf676f27053$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $f1b63fd217f30033$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


function $b713dc34b346cc2d$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use;
        var ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}




/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $f3537773a2f23e62$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $f3537773a2f23e62$var$_excluded2 = [
    "className"
];
var $f3537773a2f23e62$var$focusRingStyles = null;
var $f3537773a2f23e62$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $f3537773a2f23e62$var$Focusable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $f3537773a2f23e62$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $f3537773a2f23e62$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $120779d35fab2d6d$export$2e2bcd8739ae039)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $f3537773a2f23e62$export$2e2bcd8739ae039 = $f3537773a2f23e62$var$Focusable;


var $6dbbe01da48ec968$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $6dbbe01da48ec968$var$_excluded2 = [
    "className"
];
var $6dbbe01da48ec968$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $6dbbe01da48ec968$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $f82efe3f8c5a6d15$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $6dbbe01da48ec968$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $4b5a5d40339b6fdb$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $f1b63fd217f30033$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "19.0.1",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $6dbbe01da48ec968$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement((0, $f3537773a2f23e62$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $b713dc34b346cc2d$export$95df08bae54cb4df)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $e5ad449582742021$export$a274e22fb40f762e)($6dbbe01da48ec968$var$styles.root, isDisabled && $6dbbe01da48ec968$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $6dbbe01da48ec968$export$2e2bcd8739ae039 = $6dbbe01da48ec968$var$Pressable;



/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5FkrB = parcelRequire("5FkrB");
var $3b769c3dfe8fc954$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);



var $5FkrB = parcelRequire("5FkrB");

var $e828e3c52ceeb342$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $5FkrB.useContext)((0, $3b769c3dfe8fc954$export$4b86304b2c0d7e71));
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};


function $5c198466d8586d17$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $5c198466d8586d17$var$tabKeyCode = 9;
function $5c198466d8586d17$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $5c198466d8586d17$var$tabKeyCode) return;
    $5c198466d8586d17$var$abort(event);
}
function $5c198466d8586d17$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $5c198466d8586d17$var$abort,
        onMouseUpCapture: $5c198466d8586d17$var$abort,
        onKeyDownCapture: $5c198466d8586d17$var$onKey,
        onKeyUpCapture: $5c198466d8586d17$var$onKey,
        onTouchStartCapture: $5c198466d8586d17$var$abort,
        onTouchEndCapture: $5c198466d8586d17$var$abort,
        onPointerDownCapture: $5c198466d8586d17$var$abort,
        onPointerUpCapture: $5c198466d8586d17$var$abort,
        onClickCapture: $5c198466d8586d17$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $5c198466d8586d17$var$abort
    } : events;
}



var $5FkrB = parcelRequire("5FkrB");

function $252b241f11c62840$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $252b241f11c62840$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $252b241f11c62840$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3595ac2db996a99a$export$2e2bcd8739ae039), {
        size: $252b241f11c62840$var$getIconSpacing(spacing),
        appearance: $252b241f11c62840$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}


var $11dd84bac22fa83e$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $11dd84bac22fa83e$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $11dd84bac22fa83e$var$LOADING_LABEL = ', Loading';
var $11dd84bac22fa83e$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhkby5v _irr3by5v _1di6by5v",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    spacingCompactT26Shape: "_2rko12b0",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $11dd84bac22fa83e$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $11dd84bac22fa83e$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
var $11dd84bac22fa83e$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _9h8h1yd3",
    interactive: "_30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
var $11dd84bac22fa83e$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
var $11dd84bac22fa83e$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
var $11dd84bac22fa83e$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $11dd84bac22fa83e$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $11dd84bac22fa83e$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $11dd84bac22fa83e$var$_excluded);
    var localRef = (0, $5FkrB.useRef)(null);
    var splitButtonContext = (0, $e828e3c52ceeb342$export$47e2c6fdb142d947)();
    var loadingLabelId = (0, $eae303b7f4b562de$export$f680877a34711e37)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $4dee7b53309725f3$export$2e2bcd8739ae039)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $11dd84bac22fa83e$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6dbbe01da48ec968$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $d1a0e9749b65ff00$export$2e2bcd8739ae039)([
            localRef,
            ref
        ]),
        xcss: (0, $51c2ad1cc5d37be6$export$a274e22fb40f762e)($11dd84bac22fa83e$var$styles.base, (0, $aptQa.fg)('platform-dst-shape-theme-default') && $11dd84bac22fa83e$var$styles.baseT26Shape, appearance === 'default' && $11dd84bac22fa83e$var$defaultStyles.root, appearance === 'default' && isInteractive && $11dd84bac22fa83e$var$defaultStyles.interactive, appearance === 'primary' && $11dd84bac22fa83e$var$primaryStyles.root, appearance === 'primary' && isInteractive && $11dd84bac22fa83e$var$primaryStyles.interactive, appearance === 'warning' && $11dd84bac22fa83e$var$warningStyles.root, appearance === 'warning' && isInteractive && $11dd84bac22fa83e$var$warningStyles.interactive, appearance === 'danger' && $11dd84bac22fa83e$var$dangerStyles.root, appearance === 'danger' && isInteractive && $11dd84bac22fa83e$var$dangerStyles.interactive, appearance === 'discovery' && $11dd84bac22fa83e$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $11dd84bac22fa83e$var$discoveryStyles.interactive, appearance === 'subtle' && $11dd84bac22fa83e$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $11dd84bac22fa83e$var$subtleStyles.interactive, $11dd84bac22fa83e$var$styles.linkDecorationUnset, isSelected && $11dd84bac22fa83e$var$selectedStyles.root, isSelected && isSplitButton && $11dd84bac22fa83e$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $11dd84bac22fa83e$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $11dd84bac22fa83e$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $11dd84bac22fa83e$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $11dd84bac22fa83e$var$selectedStyles.discovery, isDisabled && $11dd84bac22fa83e$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $11dd84bac22fa83e$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $11dd84bac22fa83e$var$defaultStyles.disabled, spacing === 'compact' && $11dd84bac22fa83e$var$styles.spacingCompact, spacing === 'compact' && (0, $aptQa.fg)('platform-dst-shape-theme-default') && $11dd84bac22fa83e$var$styles.spacingCompactT26Shape, // This must come after spacing compact styling as it overrides the border radius
        isCircle && !isSplitButton && $11dd84bac22fa83e$var$styles.circle, shouldFitContainer && $11dd84bac22fa83e$var$styles.fullWidth, hasIconBefore && $11dd84bac22fa83e$var$styles.buttonIconBefore, hasIconAfter && $11dd84bac22fa83e$var$styles.buttonIconAfter, isIconButton && $11dd84bac22fa83e$var$styles.iconButton, isIconButton && spacing === 'compact' && $11dd84bac22fa83e$var$styles.iconButtonCompact, isLoading && $11dd84bac22fa83e$var$styles.loading, isSplitButton && $11dd84bac22fa83e$var$styles.splitButton, isNavigationSplitButton && $11dd84bac22fa83e$var$styles.navigationSplitButton),
        isDisabled: (0, $aptQa.fg)('platform-dst_fix_not_focusable_loading_button') ? isDisabled : isEffectivelyDisabled
    }, (0, $aptQa.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-live': 'polite'
    }, isLoading && (0, $aptQa.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-disabled': true
    }, {
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($11dd84bac22fa83e$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $5c198466d8586d17$export$2e2bcd8739ae039)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3b769c3dfe8fc954$export$4b86304b2c0d7e71).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        className: (0, $120779d35fab2d6d$export$2e2bcd8739ae039)([
            $11dd84bac22fa83e$var$styles.loadingOverlay
        ])
    }, (0, $252b241f11c62840$export$2e2bcd8739ae039)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e3573d3717f44b5e$export$2e2bcd8739ae039), {
        id: loadingLabelId
    }, $11dd84bac22fa83e$var$LOADING_LABEL)));
});
var $11dd84bac22fa83e$export$2e2bcd8739ae039 = $11dd84bac22fa83e$var$ButtonBase;


/* content.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $5FkrB = parcelRequire("5FkrB");
var $53ad6069579b4666$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $53ad6069579b4666$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        className: (0, $120779d35fab2d6d$export$2e2bcd8739ae039)([
            $53ad6069579b4666$var$styles.common,
            type === 'text' && $53ad6069579b4666$var$styles.text,
            type === 'icon' && $53ad6069579b4666$var$styles.icon,
            isLoading && $53ad6069579b4666$var$styles.fade
        ])
    }, children);
};
var $53ad6069579b4666$export$2e2bcd8739ae039 = $53ad6069579b4666$var$Content;



var $5FkrB = parcelRequire("5FkrB");

var $aptQa = parcelRequire("aptQa");
function $a4b6b6a5fbbf2f99$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $a4b6b6a5fbbf2f99$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    var isRenderProp = $a4b6b6a5fbbf2f99$var$isIconRenderProp(Icon);
    var iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $aptQa.fg)('platform_dst_button_chevron_sizing') ? function(iconName) {
            return iconName.startsWith('Chevron') ? 'small' : 'medium';
        } : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, iconProps));
};
var $a4b6b6a5fbbf2f99$export$2e2bcd8739ae039 = $a4b6b6a5fbbf2f99$var$IconRenderer;


var $123ba5aab151a241$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $123ba5aab151a241$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $123ba5aab151a241$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $123ba5aab151a241$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $123ba5aab151a241$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $11dd84bac22fa83e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName
    }, saferRest), iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $53ad6069579b4666$export$2e2bcd8739ae039), {
        type: "icon",
        position: "before",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a4b6b6a5fbbf2f99$export$2e2bcd8739ae039), {
        icon: iconBefore
    })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $53ad6069579b4666$export$2e2bcd8739ae039), {
        isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $53ad6069579b4666$export$2e2bcd8739ae039), {
        type: "icon",
        position: "after",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a4b6b6a5fbbf2f99$export$2e2bcd8739ae039), {
        icon: iconAfter
    })));
}));
$123ba5aab151a241$var$Button.displayName = 'Button';
var $123ba5aab151a241$export$2e2bcd8739ae039 = $123ba5aab151a241$var$Button;


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $73266958f85b555b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $73266958f85b555b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $73266958f85b555b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $73266958f85b555b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $73266958f85b555b$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $73266958f85b555b$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $73266958f85b555b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $73266958f85b555b$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $73266958f85b555b$var$_objectSpread($73266958f85b555b$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $d07f8bf255402eca$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $d07f8bf255402eca$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $d07f8bf255402eca$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d07f8bf255402eca$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $d07f8bf255402eca$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $d07f8bf255402eca$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $d07f8bf255402eca$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $d07f8bf255402eca$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $d07f8bf255402eca$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $d07f8bf255402eca$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $73266958f85b555b$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $5be253f4a552b3dc$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $8a2bae868f7df40b$export$5bf35293e545f20c() {
    var analyticsContext = (0, $5be253f4a552b3dc$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $d07f8bf255402eca$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $b789b54f90b46f06$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $b7360aa377b666ff$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b7360aa377b666ff$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b7360aa377b666ff$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b7360aa377b666ff$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b7360aa377b666ff$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $8a2bae868f7df40b$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $b789b54f90b46f06$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $b789b54f90b46f06$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $b7360aa377b666ff$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}




var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
/**
 * Character key codes which can be used in keyboard events.
 */ var $35a3419541fb6cd3$export$390330c10ff2b9a1 = 'ArrowUp';
var $35a3419541fb6cd3$export$a80636c6f41931fe = 'ArrowDown';
var $35a3419541fb6cd3$export$fc4577f2a2af0ae3 = 'ArrowLeft';
var $35a3419541fb6cd3$export$c40f9845adc73fb5 = 'ArrowRight';
var $35a3419541fb6cd3$export$4af703091671bc = 'Home';
var $35a3419541fb6cd3$export$e2bc30913faa5db7 = 'End';
var $35a3419541fb6cd3$export$10f6869ed0a7d75b = 'Tab';
var $35a3419541fb6cd3$export$8152f929a25a0ff4 = 'Enter';
var $35a3419541fb6cd3$export$e51a3576c045c8d5 = 'Space';
var $35a3419541fb6cd3$export$2bb790b9008907b4 = 'Escape';


function $a1eb371a231d1787$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $35a3419541fb6cd3$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $7QpUe.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}



var $5FkrB = parcelRequire("5FkrB");
function $d996c7f009c82235$export$2e2bcd8739ae039(value) {
    var ref = (0, $5FkrB.useRef)(value);
    (0, $5FkrB.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $362f8b03c3ed5154$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $f712c35ef74f15bd$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $4ad374ed1c992541$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $f712c35ef74f15bd$export$644a49f3b8c50fcd));
    return namespace;
}


function $3a27eaabd1216a32$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $362f8b03c3ed5154$export$5fbf4d7fae6cdc00));
    var namespace = (0, $4ad374ed1c992541$export$1d57e79091cc3046)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $9dOvm = parcelRequire("9dOvm");
var $d11f7230f82c2507$var$_process, $d11f7230f82c2507$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $d11f7230f82c2507$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($d11f7230f82c2507$var$_process = globalThis.process) === null || $d11f7230f82c2507$var$_process === void 0 || ($d11f7230f82c2507$var$_process = $d11f7230f82c2507$var$_process.env) === null || $d11f7230f82c2507$var$_process === void 0 ? void 0 : $d11f7230f82c2507$var$_process.JEST_WORKER_ID) !== undefined;
var $d11f7230f82c2507$var$DEBUG_MODE = !$d11f7230f82c2507$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($d11f7230f82c2507$var$_process2 = globalThis.process) === null || $d11f7230f82c2507$var$_process2 === void 0 || ($d11f7230f82c2507$var$_process2 = $d11f7230f82c2507$var$_process2.env) === null || $d11f7230f82c2507$var$_process2 === void 0 ? void 0 : $d11f7230f82c2507$var$_process2.NODE_ENV) !== 'production';
var $d11f7230f82c2507$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$d11f7230f82c2507$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $247f48d8b31a41ec$var$pkgName = '@atlaskit/platform-feature-flags';
var $247f48d8b31a41ec$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $247f48d8b31a41ec$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $247f48d8b31a41ec$var$ENV_ENABLE_PLATFORM_FF = $247f48d8b31a41ec$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $247f48d8b31a41ec$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $247f48d8b31a41ec$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $247f48d8b31a41ec$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $247f48d8b31a41ec$var$ENV_ENABLE_PLATFORM_FF || $247f48d8b31a41ec$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $247f48d8b31a41ec$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $247f48d8b31a41ec$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$247f48d8b31a41ec$var$globalVar[$247f48d8b31a41ec$export$7e41b1b2bdee3f98] = $247f48d8b31a41ec$var$globalVar[$247f48d8b31a41ec$export$7e41b1b2bdee3f98] || $247f48d8b31a41ec$var$DEFAULT_PFF_GLOBAL;
function $247f48d8b31a41ec$export$f2b591175b3e424c(resolver) {
    $247f48d8b31a41ec$var$globalVar[$247f48d8b31a41ec$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $247f48d8b31a41ec$export$6333b6aff9fc6275(flagKey) {
    if ($247f48d8b31a41ec$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $d11f7230f82c2507$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $247f48d8b31a41ec$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $247f48d8b31a41ec$var$globalVar[$247f48d8b31a41ec$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $247f48d8b31a41ec$var$globalVar[$247f48d8b31a41ec$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $9dOvm.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $247f48d8b31a41ec$var$globalVar[$247f48d8b31a41ec$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $963ac5717e37a8ab$export$ba05d765b8392e5e(flagResolver) {
    (0, $247f48d8b31a41ec$export$f2b591175b3e424c)(flagResolver);
}
function $963ac5717e37a8ab$export$470e5c2be1411c89(name) {
    return (0, $247f48d8b31a41ec$export$6333b6aff9fc6275)(name);
}
function $963ac5717e37a8ab$export$b40ec24ac8275656(name) {
    return (0, $247f48d8b31a41ec$export$6333b6aff9fc6275)(name);
}


/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $0fe6287c12490552$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $0fe6287c12490552$var$ExitingContext = /*#__PURE__*/ (0, $5FkrB.createContext)($0fe6287c12490552$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $0fe6287c12490552$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0fe6287c12490552$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($0fe6287c12490552$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $0fe6287c12490552$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $0fe6287c12490552$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $0fe6287c12490552$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $0fe6287c12490552$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $0fe6287c12490552$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $0fe6287c12490552$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $0fe6287c12490552$var$childrenToArray(previousChildren);
    var current = $0fe6287c12490552$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var nextChildren = currentChildren !== children ? $0fe6287c12490552$var$childrenToArray(children) : current;
    var missingKeys = $0fe6287c12490552$var$getMissingKeys(nextChildren, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $0fe6287c12490552$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $963ac5717e37a8ab$export$b40ec24ac8275656)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $0fe6287c12490552$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $0fe6287c12490552$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $0fe6287c12490552$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)($0fe6287c12490552$var$ExitingContext);
};
$0fe6287c12490552$var$ExitingPersistence.displayName = 'ExitingPersistence';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$0fe6287c12490552$export$2e2bcd8739ae039 = $0fe6287c12490552$var$ExitingPersistence;


var $5FkrB = parcelRequire("5FkrB");
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $b38ecc116bea7d94$var$ATOMIC_GROUP_LENGTH = 5;
function $b38ecc116bea7d94$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $b38ecc116bea7d94$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $3f46f842626a6ed4$export$368bacef0dacbe05 = 25;
var $3f46f842626a6ed4$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};



/**
 * Used to multiply the initial duration for exiting motions.
 */ var $498b6e7e83782d0e$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $498b6e7e83782d0e$export$30fa1a2e62ae150c = {
    none: (0, $3f46f842626a6ed4$export$38b928a7167ce124).none,
    small: (0, $3f46f842626a6ed4$export$38b928a7167ce124).small * $498b6e7e83782d0e$var$EXITING_MOTION_MULTIPLIER,
    medium: (0, $3f46f842626a6ed4$export$38b928a7167ce124).medium * $498b6e7e83782d0e$var$EXITING_MOTION_MULTIPLIER,
    large: (0, $3f46f842626a6ed4$export$38b928a7167ce124).large * $498b6e7e83782d0e$var$EXITING_MOTION_MULTIPLIER
};


var $1b9a90f6f057e4e4$export$c5406bd59b374abd = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};


var $1e16768a721836bc$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!(0, $1b9a90f6f057e4e4$export$c5406bd59b374abd)()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};



var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $8f57e60563dd1d02$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $8f57e60563dd1d02$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $8f57e60563dd1d02$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};




var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
/**
 * An empty function which does nothing.
 */ function $26563f175d1c6c67$export$2e2bcd8739ae039() {}



var $5FkrB = parcelRequire("5FkrB");
var $ddf5c8c411f7d786$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $757344d5499b8033$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $b5825582ff6fd441$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $26563f175d1c6c67$export$2e2bcd8739ae039)
    };
});
var $b5825582ff6fd441$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $757344d5499b8033$export$c485849f2e393253)();
    var context = (0, $5FkrB.useContext)($b5825582ff6fd441$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $b5825582ff6fd441$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $ddf5c8c411f7d786$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($b5825582ff6fd441$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b5825582ff6fd441$export$2e2bcd8739ae039 = $b5825582ff6fd441$var$StaggeredEntrance;


var $9ee674df2e38cf65$var$zoomIn = null;
var $9ee674df2e38cf65$var$zoomOut = null;
var $9ee674df2e38cf65$var$fadeIn = null;
var $9ee674df2e38cf65$var$fadeOut = null;
var $9ee674df2e38cf65$var$fadeInFromTop = null;
var $9ee674df2e38cf65$var$fadeOutFromTop = null;
var $9ee674df2e38cf65$var$fadeInFromLeft = null;
var $9ee674df2e38cf65$var$fadeOutFromLeft = null;
var $9ee674df2e38cf65$var$fadeInFromBottom = null;
var $9ee674df2e38cf65$var$fadeOutFromBottom = null;
var $9ee674df2e38cf65$var$fadeInFromRight = null;
var $9ee674df2e38cf65$var$fadeOutFromRight = null;
var $9ee674df2e38cf65$var$fadeInFromTopConstant = null;
var $9ee674df2e38cf65$var$fadeOutFromTopConstant = null;
var $9ee674df2e38cf65$var$fadeInFromLeftConstant = null;
var $9ee674df2e38cf65$var$fadeOutFromLeftConstant = null;
var $9ee674df2e38cf65$var$fadeInFromBottomConstant = null;
var $9ee674df2e38cf65$var$fadeOutFromBottomConstant = null;
var $9ee674df2e38cf65$var$fadeInFromRightConstant = null;
var $9ee674df2e38cf65$var$fadeOutFromRightConstant = null;
var $9ee674df2e38cf65$var$slideInFromTop = null;
var $9ee674df2e38cf65$var$slideOutFromTop = null;
var $9ee674df2e38cf65$var$slideInFromRight = null;
var $9ee674df2e38cf65$var$slideOutFromRight = null;
var $9ee674df2e38cf65$var$slideInFromBottom = null;
var $9ee674df2e38cf65$var$slideOutFromBottom = null;
var $9ee674df2e38cf65$var$slideInFromLeft = null;
var $9ee674df2e38cf65$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $9ee674df2e38cf65$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $b5825582ff6fd441$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $0fe6287c12490552$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $8f57e60563dd1d02$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $5FkrB.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $1e16768a721836bc$export$b7baf7667a68d87c)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $498b6e7e83782d0e$export$30fa1a2e62ae150c)[duration] : (0, $3f46f842626a6ed4$export$38b928a7167ce124)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
            (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $b38ecc116bea7d94$export$2e2bcd8739ae039)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $9ee674df2e38cf65$export$2e2bcd8739ae039 = $9ee674df2e38cf65$var$EnteringMotion;


var $c6ef6bab38bd84d5$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $c6ef6bab38bd84d5$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $c6ef6bab38bd84d5$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9ee674df2e38cf65$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $c6ef6bab38bd84d5$export$2e2bcd8739ae039 = $c6ef6bab38bd84d5$var$FadeIn;



var $aptQa = parcelRequire("aptQa");

var $fC8ib = parcelRequire("fC8ib");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $lsgol = parcelRequire("lsgol");

var $iYJcE = parcelRequire("iYJcE");
function $720c01460e915946$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}



// Export types from PopperJS / React Popper
var $d5619142005425dd$var$viewportPadding = 5;
var $d5619142005425dd$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $d5619142005425dd$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $d5619142005425dd$var$defaultChildrenFn() {
    return null;
}
var $d5619142005425dd$var$defaultOffset = [
    0,
    8
];
function $d5619142005425dd$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $d5619142005425dd$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $d5619142005425dd$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $5FkrB.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $d5619142005425dd$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $720c01460e915946$export$6d8c2b45c99d6e3f)({
            viewportPadding: $d5619142005425dd$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($d5619142005425dd$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $5FkrB.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $lsgol.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}



var $5FkrB = parcelRequire("5FkrB");

var $aptQa = parcelRequire("aptQa");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $fL8KA = parcelRequire("fL8KA");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");


var $6HG4S = parcelRequire("6HG4S");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $25nEq = parcelRequire("25nEq");

var $aptQa = parcelRequire("aptQa");

var $acaID = parcelRequire("acaID");

var $8Cx0K = parcelRequire("8Cx0K");

var $ekGgq = parcelRequire("ekGgq");

var $iYJcE = parcelRequire("iYJcE");
var $038a6ff3fddc9469$export$4a14e169b1de4ee7 = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};


/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */ var $f0f5fc4e0f1777f0$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];


var $a2e803cfbcb17762$export$ea35b8958c39dd07 = function isThemeIds(themeId) {
    return (0, $f0f5fc4e0f1777f0$export$7d43e72a58e3283f).find(function(id) {
        return id === themeId;
    }) !== undefined;
};


var $90d10890fe5b84ae$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $90d10890fe5b84ae$export$958fa026be3a263e = function isThemeKind(themeKind) {
    return $90d10890fe5b84ae$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};


var $c1a18a8149893c8c$var$customThemeOptions = 'UNSAFE_themeOptions';
var $c1a18a8149893c8c$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && (0, $038a6ff3fddc9469$export$4a14e169b1de4ee7)(id) || // custom theme state
        kind === $c1a18a8149893c8c$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' || // other theme states
        (0, $90d10890fe5b84ae$export$958fa026be3a263e)(kind) && typeof id === 'string' && (0, $a2e803cfbcb17762$export$ea35b8958c39dd07)(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};



var $aLvfY = parcelRequire("aLvfY");
var $805bc847826407c0$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};


function $2eb3ee87a58504ff$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2eb3ee87a58504ff$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2eb3ee87a58504ff$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2eb3ee87a58504ff$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2eb3ee87a58504ff$var$defaultColorMode = 'light';
var $2eb3ee87a58504ff$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $2eb3ee87a58504ff$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $8Cx0K.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $8Cx0K.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $8Cx0K.themeStateDefaults)['light'] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $8Cx0K.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$motion = _ref.motion, motion = _ref$motion === void 0 ? (0, $8Cx0K.themeStateDefaults)['motion']() : _ref$motion, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $8Cx0K.themeStateDefaults)['shape']() : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $8Cx0K.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $8Cx0K.themeStateDefaults)['typography'] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $8Cx0K.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $c1a18a8149893c8c$export$62c37ab81302621a)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $acaID.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $acaID.COLOR_MODE_ATTRIBUTE), colorMode === 'auto' ? $2eb3ee87a58504ff$var$defaultColorMode : colorMode);
    if ((0, $aptQa.fg)('platform_increased-contrast-themes')) result = $2eb3ee87a58504ff$var$_objectSpread($2eb3ee87a58504ff$var$_objectSpread({}, result), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $acaID.CONTRAST_MODE_ATTRIBUTE), contrastMode === 'auto' ? $2eb3ee87a58504ff$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $805bc847826407c0$export$53031ac1ecb71f44)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $aLvfY.hash)(optionString);
        result[0, $acaID.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $2eb3ee87a58504ff$export$2e2bcd8739ae039 = $2eb3ee87a58504ff$var$getThemeHtmlAttrs;


var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $aptQa = parcelRequire("aptQa");

var $25nEq = parcelRequire("25nEq");

var $acaID = parcelRequire("acaID");
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $67bed14037070d5a$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];



var $iYJcE = parcelRequire("iYJcE");



var $66b2ea9e81c7cb33$var$customThemeOptions = 'UNSAFE_themeOptions';
var $66b2ea9e81c7cb33$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && (0, $038a6ff3fddc9469$export$4a14e169b1de4ee7)(id)) themeObject[kind] = id;
        if ((0, $90d10890fe5b84ae$export$958fa026be3a263e)(kind) && (0, $a2e803cfbcb17762$export$ea35b8958c39dd07)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $66b2ea9e81c7cb33$var$customThemeOptions) try {
            themeObject[$66b2ea9e81c7cb33$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};


function $d1a0ee6b2a614f20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d1a0ee6b2a614f20$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d1a0ee6b2a614f20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d1a0ee6b2a614f20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d1a0ee6b2a614f20$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $67bed14037070d5a$export$83993de8eb66733).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $d1a0ee6b2a614f20$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $acaID.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $acaID.THEME_DATA_ATTRIBUTE)) || '';
    return $d1a0ee6b2a614f20$var$_objectSpread($d1a0ee6b2a614f20$var$_objectSpread({}, (0, $66b2ea9e81c7cb33$export$f19b488f7c0547ee)(theme)), $d1a0ee6b2a614f20$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $d1a0ee6b2a614f20$export$2e2bcd8739ae039 = $d1a0ee6b2a614f20$var$getGlobalTheme;



var $8Cx0K = parcelRequire("8Cx0K");

var $iYJcE = parcelRequire("iYJcE");

var $aptQa = parcelRequire("aptQa");


var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $7QpUe = parcelRequire("7QpUe");

var $acaID = parcelRequire("acaID");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $acaID = parcelRequire("acaID");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::a20c72d683b08b594c5be4160eec5f78>>
 * @codegenCommand yarn build tokens
 */ 









var $ac32c4782e80a0b8$var$themeImportsMap = {
    'light': function light() {
        return (parcelRequire("18gtv"));
    },
    'light-future': function lightFuture() {
        return (parcelRequire("bSqvq"));
    },
    'light-increased-contrast': function lightIncreasedContrast() {
        return (parcelRequire("iUd27"));
    },
    'dark': function dark() {
        return (parcelRequire("18Y4O"));
    },
    'dark-future': function darkFuture() {
        return (parcelRequire("58sFO"));
    },
    'dark-increased-contrast': function darkIncreasedContrast() {
        return (parcelRequire("6ayJ7"));
    },
    'spacing': function spacing() {
        return (parcelRequire("fkCaU"));
    },
    'typography': function typography() {
        return (parcelRequire("kZOiD"));
    },
    'shape': function shape() {
        return (parcelRequire("dtbTA"));
    },
    'motion': function motion() {
        return (parcelRequire("QSzo8"));
    }
};
var $ac32c4782e80a0b8$export$2e2bcd8739ae039 = $ac32c4782e80a0b8$var$themeImportsMap;


var $c716282d3b54b220$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 1;
                    return (0, $ac32c4782e80a0b8$export$2e2bcd8739ae039)[themeId]();
                case 1:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 2:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();


var $5fe71dda8a18ce34$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $acaID.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]:not([").concat((0, $acaID.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 1;
                        break;
                    }
                    return _context.abrupt("return");
                case 1:
                    if (themeId) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    _context.next = 3;
                    return (0, $c716282d3b54b220$export$8a48286ed7df6720)(themeId);
                case 3:
                    themeCss = _context.sent;
                    style = document.createElement('style');
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $5fe71dda8a18ce34$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
var $5fe71dda8a18ce34$export$8662df6937d86fcb = '(prefers-contrast: more)';


var $9c09edc3f50c54f6$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $9c09edc3f50c54f6$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $acaID.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
var $9c09edc3f50c54f6$var$darkModeMql = $9c09edc3f50c54f6$var$isMatchMediaAvailable && window.matchMedia((0, $5fe71dda8a18ce34$export$bb1e815119d30f8b));
var $9c09edc3f50c54f6$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ColorModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "unbindThemeChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$9c09edc3f50c54f6$var$darkModeMql) return 'light';
                return $9c09edc3f50c54f6$var$darkModeMql !== null && $9c09edc3f50c54f6$var$darkModeMql !== void 0 && $9c09edc3f50c54f6$var$darkModeMql.matches ? 'dark' : 'light';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($9c09edc3f50c54f6$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $7QpUe.bind)($9c09edc3f50c54f6$var$darkModeMql, {
                    type: 'change',
                    listener: $9c09edc3f50c54f6$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $9c09edc3f50c54f6$var$SingletonColorModeObserver = new $9c09edc3f50c54f6$var$ColorModeObserver();
var $9c09edc3f50c54f6$export$2e2bcd8739ae039 = $9c09edc3f50c54f6$var$SingletonColorModeObserver;



var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $7QpUe = parcelRequire("7QpUe");

var $acaID = parcelRequire("acaID");

var $3f693347753b3e4c$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $3f693347753b3e4c$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $acaID.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
var $3f693347753b3e4c$var$contrastModeMql = $3f693347753b3e4c$var$isMatchMediaAvailable && window.matchMedia((0, $5fe71dda8a18ce34$export$8662df6937d86fcb));
var $3f693347753b3e4c$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ContrastModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "unbindContrastChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$3f693347753b3e4c$var$contrastModeMql) return 'no-preference';
                return $3f693347753b3e4c$var$contrastModeMql !== null && $3f693347753b3e4c$var$contrastModeMql !== void 0 && $3f693347753b3e4c$var$contrastModeMql.matches ? 'more' : 'no-preference';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($3f693347753b3e4c$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $7QpUe.bind)($3f693347753b3e4c$var$contrastModeMql, {
                    type: 'change',
                    listener: $3f693347753b3e4c$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $3f693347753b3e4c$var$SingletonContrastModeObserver = new $3f693347753b3e4c$var$ContrastModeObserver();
var $3f693347753b3e4c$export$2e2bcd8739ae039 = $3f693347753b3e4c$var$SingletonContrastModeObserver;


function $9e2c0f307850650d$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $9c09edc3f50c54f6$export$2e2bcd8739ae039).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $9c09edc3f50c54f6$export$2e2bcd8739ae039).bind();
    } else (0, $9c09edc3f50c54f6$export$2e2bcd8739ae039).unbind();
    if ((0, $aptQa.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $3f693347753b3e4c$export$2e2bcd8739ae039).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $3f693347753b3e4c$export$2e2bcd8739ae039).bind();
        } else (0, $3f693347753b3e4c$export$2e2bcd8739ae039).unbind();
    }
    var themeAttributes = (0, $2eb3ee87a58504ff$export$2e2bcd8739ae039)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $9c09edc3f50c54f6$export$2e2bcd8739ae039).unbind();
        if ((0, $aptQa.fg)('platform_increased-contrast-themes')) (0, $3f693347753b3e4c$export$2e2bcd8739ae039).unbind();
    };
}



var $acaID = parcelRequire("acaID");

var $aLvfY = parcelRequire("aLvfY");
function $09bdba890ca83a33$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $aLvfY.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $acaID.CUSTOM_THEME_ATTRIBUTE), "=\"").concat(uniqueId, "\"][").concat((0, $acaID.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}



var $fC8ib = parcelRequire("fC8ib");
var $c0dfcddea78d030a$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(_themeState) {
    var themeOverridePreferences = [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set(themeOverridePreferences));
};



var $fC8ib = parcelRequire("fC8ib");

var $aptQa = parcelRequire("aptQa");

var $iYJcE = parcelRequire("iYJcE");

var $fC8ib = parcelRequire("fC8ib");



var $8Cx0K = parcelRequire("8Cx0K");
/**
 * Themes: The internal identifier of a theme.
 * These ids are what the actual theme files/folders are called.
 * style-dictionary will attempt to locate these in the file-system.
 */ /**
 * ThemeOverrides: The internal identifier of a theme override. Which are themes that contain
 * a subset of tokens intended to override an existing theme. These ids are what the actual
 * theme files/folders are called. style-dictionary will attempt to locate these in the file-system.
 * Theme overrides are temporary and there may not be any defined at times.
 */ /**
 * Theme kinds: The type of theme.
 * Some themes are entirely focused on Color, whilst others are purely focused on spacing.
 * In the future other types may be introduced such as typography.
 */ /**
 * Contrast preferences: The system contrast preference
 */ var $9186ca9448a45fdc$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $9186ca9448a45fdc$var$themeOverrideIds = [];
var $9186ca9448a45fdc$export$92ba366331403db2 = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((0, $f0f5fc4e0f1777f0$export$7d43e72a58e3283f)), $9186ca9448a45fdc$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $9186ca9448a45fdc$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$9186ca9448a45fdc$export$2e2bcd8739ae039 = $9186ca9448a45fdc$var$themeConfig;


function $41dc838775a8a202$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $9186ca9448a45fdc$export$2e2bcd8739ae039)).find(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}



var $5d4e7e4f4529574a$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography, motion = themeState.motion;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $aptQa.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $41dc838775a8a202$export$2e2bcd8739ae039)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $aptQa.fg)('platform_increased-contrast-themes')) {
            var increasedContrastTheme = (0, $41dc838775a8a202$export$2e2bcd8739ae039)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set(themePreferences));
};




function $6694a48ff3086666$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $6694a48ff3086666$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $6694a48ff3086666$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $6694a48ff3086666$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $6694a48ff3086666$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $6694a48ff3086666$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $6694a48ff3086666$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6694a48ff3086666$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6694a48ff3086666$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6694a48ff3086666$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $6694a48ff3086666$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3() {
        var nextThemeState, themeLoader, _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$motion, motion, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    nextThemeState = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    _ref2 = typeof nextThemeState === 'function' ? nextThemeState($6694a48ff3086666$var$_objectSpread($6694a48ff3086666$var$_objectSpread({}, (0, $8Cx0K.themeStateDefaults)), {}, {
                        typography: (0, $8Cx0K.themeStateDefaults)['typography'],
                        shape: (0, $8Cx0K.themeStateDefaults)['shape'](),
                        motion: (0, $8Cx0K.themeStateDefaults)['motion']()
                    }, (0, $d1a0ee6b2a614f20$export$2e2bcd8739ae039)())) : nextThemeState, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $8Cx0K.themeStateDefaults)['colorMode'] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $8Cx0K.themeStateDefaults)['contrastMode'] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $8Cx0K.themeStateDefaults)['dark'] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $8Cx0K.themeStateDefaults)['light'] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $8Cx0K.themeStateDefaults)['shape']() : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $8Cx0K.themeStateDefaults)['spacing'] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $8Cx0K.themeStateDefaults)['typography'] : _ref2$typography, _ref2$motion = _ref2.motion, motion = _ref2$motion === void 0 ? (0, $8Cx0K.themeStateDefaults)['motion']() : _ref2$motion, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $8Cx0K.themeStateDefaults)['UNSAFE_themeOptions'] : _ref2$UNSAFE_themeOpt; // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $aptQa.fg)('platform_increased-contrast-themes')) {
                        if (light === 'light-increased-contrast') light = 'light';
                        if (dark === 'dark-increased-contrast') dark = 'dark';
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        motion: motion,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $5d4e7e4f4529574a$export$dd6aeb7c823fc03d)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $5fe71dda8a18ce34$export$26cd7ae85c7144e5); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 1;
                                        return loadingStrategy(themeId);
                                    case 1:
                                        return _context.abrupt("return", _context.sent);
                                    case 2:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $805bc847826407c0$export$53031ac1ecb71f44)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $8Cx0K.themeStateDefaults)['colorMode'];
                        attrOfMissingCustomStyles = (0, $09bdba890ca83a33$export$bd1ac9300b0e885a)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 1;
                                        return (parcelRequire("6pzKK"));
                                    case 1:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 2:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 1;
                    return Promise.all(loadingTasks);
                case 1:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $c0dfcddea78d030a$export$5d76d7014f4a5d08)(themeState);
                    _iterator = $6694a48ff3086666$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 2;
                    _iterator.s();
                case 3:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 5;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 4;
                    return loadingStrategy(themeId);
                case 4:
                    _context3.next = 3;
                    break;
                case 5:
                    _context3.next = 7;
                    break;
                case 6:
                    _context3.prev = 6;
                    _t = _context3["catch"](2);
                    _iterator.e(_t);
                case 7:
                    _context3.prev = 7;
                    _iterator.f();
                    return _context3.finish(7);
                case 8:
                    autoUnbind = (0, $9e2c0f307850650d$export$2e2bcd8739ae039)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 9:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                2,
                6,
                7,
                8
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $6694a48ff3086666$export$2e2bcd8739ae039 = $6694a48ff3086666$var$setGlobalTheme;


var $acaID = parcelRequire("acaID");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $34eb664c0bf3ce94$export$d2def9838ca456c0 = /*#__PURE__*/ (0, $5FkrB.createContext)(false);



var $5FkrB = parcelRequire("5FkrB");
var $403da5efaa224afe$export$7981b2444296e410 = /*#__PURE__*/ (0, $5FkrB.createContext)(false);


var $cb6a431717f79bc0$export$26aa23367bfbab0e = function useIsInsideAppProvider() {
    return (0, $5FkrB.useContext)((0, $403da5efaa224afe$export$7981b2444296e410));
};
var $cb6a431717f79bc0$export$a782702263f77544 = function useIsAppProviderThemingEnabled() {
    return (0, $5FkrB.useContext)((0, $34eb664c0bf3ce94$export$d2def9838ca456c0));
};



var $5FkrB = parcelRequire("5FkrB");
var $1ec293b2fcc1ac65$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);



var $5FkrB = parcelRequire("5FkrB");
var $29eec25cd3f79c60$export$332347eeb335453c = /*#__PURE__*/ (0, $5FkrB.createContext)(false);



var $5FkrB = parcelRequire("5FkrB");
var $591de014b81dd7c5$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);



var $5FkrB = parcelRequire("5FkrB");
var $1dcc9000502bb83b$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $1dcc9000502bb83b$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);



var $5FkrB = parcelRequire("5FkrB");

var $64455ca3e7f8a0c2$export$7ca11437599d653d = function useIsInsideThemeProvider() {
    var _useContext;
    return (_useContext = (0, $5FkrB.useContext)((0, $29eec25cd3f79c60$export$332347eeb335453c))) !== null && _useContext !== void 0 ? _useContext : false;
};



var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");
var $4d734fafa08ec969$export$f65ca476c09acec0 = function getDocument() {
    if (typeof document !== 'undefined') return document;
    return null;
};





var $acaID = parcelRequire("acaID");
function $54d70c386d27b290$export$835a0dc855d02822(themeId) {
    var doc = (0, $4d734fafa08ec969$export$f65ca476c09acec0)();
    if (!doc) return false;
    return doc.head.querySelector("style[".concat((0, $acaID.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
}


var $3228089c061b7db2$var$loadThemeCss = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(0, $54d70c386d27b290$export$835a0dc855d02822)(themeId)) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return (0, $ac32c4782e80a0b8$export$2e2bcd8739ae039)[themeId]();
                case 6:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $3228089c061b7db2$var$mountThemeCss = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(css, themeId) {
        var doc, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    // SSR-safe: Only mount on client side
                    doc = (0, $4d734fafa08ec969$export$f65ca476c09acec0)();
                    if (doc) {
                        _context2.next = 3;
                        break;
                    }
                    return _context2.abrupt("return");
                case 3:
                    style = doc.createElement('style');
                    style.textContent = css;
                    style.dataset.theme = themeId;
                    // Prevent duplicate mounting of themes.
                    // It's possible the theme was already being loaded elsewhere.
                    if (!(0, $54d70c386d27b290$export$835a0dc855d02822)(themeId)) {
                        _context2.next = 8;
                        break;
                    }
                    return _context2.abrupt("return");
                case 8:
                    doc.head.appendChild(style);
                case 9:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function mountThemeCss(_x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();
var $3228089c061b7db2$var$loadAndMountThemeCss = /*#__PURE__*/ function() {
    var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(themeId) {
        var themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 2;
                    return $3228089c061b7db2$var$loadThemeCss(themeId);
                case 2:
                    themeCss = _context3.sent;
                    if (themeCss) {
                        _context3.next = 5;
                        break;
                    }
                    return _context3.abrupt("return");
                case 5:
                    $3228089c061b7db2$var$mountThemeCss(themeCss, themeId);
                case 6:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function loadAndMountThemeCss(_x4) {
        return _ref3.apply(this, arguments);
    };
}();
var $3228089c061b7db2$export$7d4a7e812d176b24 = /*#__PURE__*/ function() {
    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(theme) {
        var themesToLoad;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    themesToLoad = Object.values(theme).filter(function(themeId) {
                        return !!themeId;
                    });
                    themesToLoad.forEach($3228089c061b7db2$var$loadAndMountThemeCss);
                case 2:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function loadAndMountThemes(_x5) {
        return _ref4.apply(this, arguments);
    };
}();


function $63d4fe51439be969$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $63d4fe51439be969$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $63d4fe51439be969$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $63d4fe51439be969$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $63d4fe51439be969$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    spacing: 'spacing',
    typography: 'typography'
};
var $63d4fe51439be969$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
var $63d4fe51439be969$var$prefersDarkModeMql = $63d4fe51439be969$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $63d4fe51439be969$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $63d4fe51439be969$var$prefersDarkModeMql !== null && $63d4fe51439be969$var$prefersDarkModeMql !== void 0 && $63d4fe51439be969$var$prefersDarkModeMql.matches ? 'dark' : 'light';
    return colorMode;
}
var $63d4fe51439be969$var$contentStyles = {
    body: "_1e0c1bgi"
};
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 */ function $63d4fe51439be969$var$ThemeProvider(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? 'auto' : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme;
    var _useState = (0, $5FkrB.useState)(defaultColorMode), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), chosenColorMode = _useState2[0], setChosenColorMode = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)($63d4fe51439be969$var$getReconciledColorMode(defaultColorMode)), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), reconciledColorMode = _useState4[0], setReconciledColorMode = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return $63d4fe51439be969$var$_objectSpread($63d4fe51439be969$var$_objectSpread({}, $63d4fe51439be969$var$defaultThemeSettings), defaultTheme);
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), theme = _useState6[0], setTheme = _useState6[1];
    var setColorMode = (0, $5FkrB.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode($63d4fe51439be969$var$getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, $5FkrB.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return $63d4fe51439be969$var$_objectSpread($63d4fe51439be969$var$_objectSpread({}, theme), nextTheme);
        });
    }, []);
    var lastSetGlobalThemePromiseRef = (0, $5FkrB.useRef)(null);
    var isInsideAppProvider = (0, $cb6a431717f79bc0$export$26aa23367bfbab0e)();
    var isAppProviderThemingEnabled = (0, $cb6a431717f79bc0$export$a782702263f77544)();
    var isInsideThemeProvider = (0, $64455ca3e7f8a0c2$export$7ca11437599d653d)();
    /**
   * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
   *
   * This will not use sub-tree theming but instead set the global theme state using the
   * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
   * for compatibility with `@atlaskit/css-reset`.
   *
   * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
   * `html` in order to apply global theme state, which would allow a more consistent approach to
   * theme loading.
   */ var isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled;
    (0, $5FkrB.useEffect)(function() {
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ var cleanupLastFnCall = /*#__PURE__*/ function() {
                var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
                    var unbindFn;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!lastSetGlobalThemePromiseRef.current) {
                                    _context.next = 6;
                                    break;
                                }
                                _context.next = 3;
                                return lastSetGlobalThemePromiseRef.current;
                            case 3:
                                unbindFn = _context.sent;
                                unbindFn();
                                lastSetGlobalThemePromiseRef.current = null;
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function cleanupLastFnCall() {
                    return _ref2.apply(this, arguments);
                };
            }();
            var safelySetGlobalTheme = /*#__PURE__*/ function() {
                var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2() {
                    var promise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return cleanupLastFnCall();
                            case 2:
                                promise = (0, $6694a48ff3086666$export$2e2bcd8739ae039)($63d4fe51439be969$var$_objectSpread($63d4fe51439be969$var$_objectSpread({}, theme), {}, {
                                    colorMode: reconciledColorMode
                                }));
                                lastSetGlobalThemePromiseRef.current = promise;
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                return function safelySetGlobalTheme() {
                    return _ref3.apply(this, arguments);
                };
            }();
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        } else // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $3228089c061b7db2$export$7d4a7e812d176b24)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (!$63d4fe51439be969$var$prefersDarkModeMql) return;
        var unbindListener = (0, $7QpUe.bind)($63d4fe51439be969$var$prefersDarkModeMql, {
            type: 'change',
            listener: function listener(event) {
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    var attrs = $63d4fe51439be969$var$_objectSpread($63d4fe51439be969$var$_objectSpread({}, (0, $2eb3ee87a58504ff$export$2e2bcd8739ae039)($63d4fe51439be969$var$_objectSpread($63d4fe51439be969$var$_objectSpread({}, theme), {}, {
        colorMode: reconciledColorMode
    }))), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $acaID.SUBTREE_THEME_ATTRIBUTE), true));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $29eec25cd3f79c60$export$332347eeb335453c).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1ec293b2fcc1ac65$export$49ddd74a6729fdb0).Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $591de014b81dd7c5$export$b06130bad0bbc70f).Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1dcc9000502bb83b$export$2c657da244d00bd6).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1dcc9000502bb83b$export$f7a97b47760e2a13).Provider, {
        value: setPartialTheme
    }, !isRootThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, attrs, {
        className: (0, $120779d35fab2d6d$export$2e2bcd8739ae039)([
            $63d4fe51439be969$var$contentStyles.body
        ])
    }), children) : children)))));
}
var $63d4fe51439be969$export$2e2bcd8739ae039 = $63d4fe51439be969$var$ThemeProvider;


var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $acaID = parcelRequire("acaID");

/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $8528070faf2745d6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $d1a0ee6b2a614f20$export$2e2bcd8739ae039)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $acaID.THEME_DATA_ATTRIBUTE),
                            (0, $acaID.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8528070faf2745d6$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8528070faf2745d6$export$2e2bcd8739ae039, "callbacks", new Set());



function $c8e37282c15787a5$export$20f3076712c8dfa() {
    var value = (0, $5FkrB.useContext)((0, $1ec293b2fcc1ac65$export$49ddd74a6729fdb0));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    var theme = (0, $d1a0ee6b2a614f20$export$2e2bcd8739ae039)();
    var _useState = (0, $5FkrB.useState)((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), resolvedColorMode = _useState2[0], setResolvedColorMode = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        var observer = new (0, $8528070faf2745d6$export$2e2bcd8739ae039)(function(theme) {
            setResolvedColorMode((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}




var $aptQa = parcelRequire("aptQa");
var $14d7a4b8722a4694$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $14d7a4b8722a4694$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $14d7a4b8722a4694$export$13f57c02915787b3 = 'atlaskit-portal';


/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $f6514808bb3f09e9$export$135b49d4bc2964c6 = function getBody() {
    return document.body;
};


var $cd18afdcbe5782a9$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $14d7a4b8722a4694$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $14d7a4b8722a4694$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $f6514808bb3f09e9$export$135b49d4bc2964c6)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $cd18afdcbe5782a9$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $cd18afdcbe5782a9$var$getPortalParent().appendChild(container);
};



var $accc5db6f70639fb$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $14d7a4b8722a4694$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};




var $b93341bb8ef3c3cb$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $14d7a4b8722a4694$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $14d7a4b8722a4694$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $f6514808bb3f09e9$export$135b49d4bc2964c6)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $b93341bb8ef3c3cb$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    var parent = $b93341bb8ef3c3cb$var$getPortalParent();
    if (parent.contains(container)) parent.removeChild(container);
};


function $5e5d04869e932b26$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children, _props$isClosed = props.isClosed, isClosed = _props$isClosed === void 0 ? false : _props$isClosed;
    var container = (0, $5FkrB.useMemo)(function() {
        return (0, $accc5db6f70639fb$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    var colorMode = (0, $c8e37282c15787a5$export$20f3076712c8dfa)();
    var isInsideThemeProvider = (0, $64455ca3e7f8a0c2$export$7ca11437599d653d)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $cd18afdcbe5782a9$export$c582005add11e141)(container);
    (0, $5FkrB.useEffect)(function() {
        if ((0, $aptQa.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (isClosed) (0, $b93341bb8ef3c3cb$export$da99f98bf3fe55b3)(container);
        }
    }, [
        isClosed,
        container
    ]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            (0, $b93341bb8ef3c3cb$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $aLeHs.createPortal)(isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $63d4fe51439be969$export$2e2bcd8739ae039), {
        defaultColorMode: colorMode
    }, children) : children, container);
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");



var $aptQa = parcelRequire("aptQa");

var $5FkrB = parcelRequire("5FkrB");
var $c7be0b7c141476e4$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5FkrB.useLayoutEffect) : (0, $5FkrB.useEffect);



var $faa9da8235f93811$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $faa9da8235f93811$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($faa9da8235f93811$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $14d7a4b8722a4694$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};




var $ecda12518da0cd6f$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $ecda12518da0cd6f$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($ecda12518da0cd6f$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $14d7a4b8722a4694$export$72f415121273627e));
        if (!parentElement) {
            var _getBody;
            var parent = document.createElement('div');
            parent.className = (0, $14d7a4b8722a4694$export$e4c79eb95c23a0da);
            parent.style.display = 'flex';
            (_getBody = (0, $f6514808bb3f09e9$export$135b49d4bc2964c6)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};



var $597e27541b963d35$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $597e27541b963d35$export$7b20876b2769b301 = function removePortalParent(parentElement) {
    if ($597e27541b963d35$var$isDocumentDefined()) {
        if (parentElement) {
            var _getBody;
            (_getBody = (0, $f6514808bb3f09e9$export$135b49d4bc2964c6)()) === null || _getBody === void 0 || _getBody.removeChild(parentElement);
        }
    }
};


function $0455755c491eddc0$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children, isClosed = props.isClosed;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    var colorMode = (0, $c8e37282c15787a5$export$20f3076712c8dfa)();
    var isInsideThemeProvider = (0, $64455ca3e7f8a0c2$export$7ca11437599d653d)();
    (0, $c7be0b7c141476e4$export$700979bc83e7db82)(function() {
        if ((0, $aptQa.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (!isClosed) {
                var tempPortalContainer = (0, $faa9da8235f93811$export$fef014d7cef9e543)(zIndex);
                setAtlaskitPortal(tempPortalContainer);
                var portalParent = (0, $ecda12518da0cd6f$export$95029ca7aca2989e)();
                if (!tempPortalContainer || !portalParent) return;
                portalParent.appendChild(tempPortalContainer);
                return function() {
                    if (portalParent) {
                        portalParent.removeChild(tempPortalContainer);
                        !portalParent.hasChildNodes() && (0, $597e27541b963d35$export$7b20876b2769b301)(portalParent);
                    }
                    setAtlaskitPortal(null);
                };
            }
        } else {
            var _tempPortalContainer = (0, $faa9da8235f93811$export$fef014d7cef9e543)(zIndex);
            setAtlaskitPortal(_tempPortalContainer);
            var _portalParent = (0, $ecda12518da0cd6f$export$95029ca7aca2989e)();
            if (!_tempPortalContainer || !_portalParent) return;
            _portalParent.appendChild(_tempPortalContainer);
            return function() {
                if (_tempPortalContainer) _portalParent.removeChild(_tempPortalContainer);
                setAtlaskitPortal(null);
            };
        }
    }, [
        zIndex,
        isClosed,
        (0, $aptQa.fg)
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Suspense), {
        fallback: null
    }, isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $63d4fe51439be969$export$2e2bcd8739ae039), {
        defaultColorMode: colorMode
    }, children) : children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $aLeHs.createPortal)(suspendedChildren, atlaskitPortal) : null;
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $ff37d69278aaf607$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $c7be0b7c141476e4$export$700979bc83e7db82) : (0, $5FkrB.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $ff37d69278aaf607$export$2e2bcd8739ae039 = $ff37d69278aaf607$var$useIsSubsequentRender;



var $5FkrB = parcelRequire("5FkrB");
var $9ae86fff47f6e921$export$ed5835cc67e87f72 = 'akPortalMount';
var $9ae86fff47f6e921$export$80816bd900e5bd00 = 'akPortalUnmount';


var $cefa6091c3c92b1d$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $cefa6091c3c92b1d$var$getLayerName = function getLayerName(zIndex) {
    return $cefa6091c3c92b1d$var$zIndexToName.hasOwnProperty(zIndex) ? $cefa6091c3c92b1d$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $cefa6091c3c92b1d$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $cefa6091c3c92b1d$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $cefa6091c3c92b1d$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $cefa6091c3c92b1d$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $985ff9539aa394eb$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $5FkrB.useEffect)(function() {
        (0, $cefa6091c3c92b1d$export$2e2bcd8739ae039)((0, $9ae86fff47f6e921$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $cefa6091c3c92b1d$export$2e2bcd8739ae039)((0, $9ae86fff47f6e921$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $985ff9539aa394eb$export$2e2bcd8739ae039 = $985ff9539aa394eb$var$useFirePortalEvent;


function $d0ccb0b9f3b651c8$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy, _ref$isClosed = _ref.isClosed, isClosed = _ref$isClosed === void 0 ? false : _ref$isClosed;
    var isSubsequentRender = (0, $ff37d69278aaf607$export$2e2bcd8739ae039)(mountStrategy);
    (0, $985ff9539aa394eb$export$2e2bcd8739ae039)(zIndex);
    return !(0, $aptQa.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5e5d04869e932b26$export$2e2bcd8739ae039), {
        zIndex: zIndex,
        isClosed: isClosed
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0455755c491eddc0$export$2e2bcd8739ae039), {
        zIndex: zIndex,
        isClosed: isClosed
    }, children);
}


/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ /* eslint-disable no-console */ var $fb362024ea25a994$var$printed = {};
function $fb362024ea25a994$export$2e2bcd8739ae039(message) {
    if ($fb362024ea25a994$var$printed[message]) return;
    $fb362024ea25a994$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}


function $caf3dc5ec3b8eae7$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $fb362024ea25a994$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}


var $c479ce88f4920702$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $c479ce88f4920702$export$c93026a968943f95 = 'light';
var $c479ce88f4920702$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $c479ce88f4920702$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, #4688EC)";
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $caf3dc5ec3b8eae7$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $c479ce88f4920702$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $c479ce88f4920702$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $c479ce88f4920702$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $caf3dc5ec3b8eae7$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $c479ce88f4920702$export$ba1d834b86d72a09 = $c479ce88f4920702$export$a1b3edb637fb4f35;


/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $03cb6837cf449b70$export$63b6b0ff65d84d47(_ref) {
    var value = _ref.value;
    if (typeof value === 'number') return "".concat(value, "px");
    return value;
}


/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ var $96ffae146696b031$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $96ffae146696b031$export$a9fe23cfa43a7b55(_ref) {
    var _placement$offset, _placement$axis, _placement$edge, _placement$align, _placement$offset$cro, _placement$offset2, _placement$offset$cro2, _placement$offset3;
    var placement = _ref.placement;
    var consumerGap = (_placement$offset = placement.offset) === null || _placement$offset === void 0 ? void 0 : _placement$offset.gap;
    return {
        axis: (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block',
        edge: (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end',
        align: (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center',
        offset: {
            gap: consumerGap === undefined ? $96ffae146696b031$var$DEFAULT_GAP : (0, $03cb6837cf449b70$export$63b6b0ff65d84d47)({
                value: consumerGap
            }),
            crossAxisShift: {
                value: (0, $03cb6837cf449b70$export$63b6b0ff65d84d47)({
                    value: (_placement$offset$cro = (_placement$offset2 = placement.offset) === null || _placement$offset2 === void 0 || (_placement$offset2 = _placement$offset2.crossAxisShift) === null || _placement$offset2 === void 0 ? void 0 : _placement$offset2.value) !== null && _placement$offset$cro !== void 0 ? _placement$offset$cro : 0
                }),
                direction: (_placement$offset$cro2 = (_placement$offset3 = placement.offset) === null || _placement$offset3 === void 0 || (_placement$offset3 = _placement$offset3.crossAxisShift) === null || _placement$offset3 === void 0 ? void 0 : _placement$offset3.direction) !== null && _placement$offset$cro2 !== void 0 ? _placement$offset$cro2 : 'forwards'
            }
        }
    };
}


// ══════════════════════════════════════════════════════════════════════════════
// Popover presets
// ══════════════════════════════════════════════════════════════════════════════
// ── popupMotion ──
var $25ece2499e65f081$var$POPUP_MOTION_CSS = "\n  [data-ds-popover-popup-motion] {\n    animation: var(--ds-popover-motion-exit);\n    animation-fill-mode: forwards;\n    transition:\n      overlay 150ms allow-discrete,\n      display 150ms allow-discrete;\n  }\n\n  [data-ds-popover-popup-motion]:popover-open {\n    animation: var(--ds-popover-motion-enter);\n    animation-fill-mode: backwards;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    [data-ds-popover-popup-motion],\n    [data-ds-popover-popup-motion]:popover-open {\n      animation: none;\n      transition-duration: 0s;\n    }\n  }\n";
function $25ece2499e65f081$var$getPopupMotionProperties(_ref) {
    var placement = _ref.placement;
    var _getPlacement = (0, $96ffae146696b031$export$a9fe23cfa43a7b55)({
        placement: placement
    }), axis = _getPlacement.axis, edge = _getPlacement.edge;
    if (axis === 'block' && edge === 'start') return {
        '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    };
    if (axis === 'inline' && edge === 'start') return {
        '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    };
    if (axis === 'inline' && edge === 'end') return {
        '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    };
    // Default: block/end (popover below trigger)
    return {
        '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    };
}
function $25ece2499e65f081$export$da1762badbfc80a0() {
    return {
        name: 'popup-motion',
        css: $25ece2499e65f081$var$POPUP_MOTION_CSS,
        enterDurationMs: 150,
        exitDurationMs: 100,
        getProperties: function getProperties(_ref2) {
            var placement = _ref2.placement;
            return $25ece2499e65f081$var$getPopupMotionProperties({
                placement: placement
            });
        }
    };
}
// ── slideAndFade ──
function $25ece2499e65f081$var$getSlideAndFadeProperties(_ref3) {
    var placement = _ref3.placement, distance = _ref3.distance;
    var pos = "".concat(distance, "px");
    var neg = "-".concat(distance, "px");
    var _getPlacement2 = (0, $96ffae146696b031$export$a9fe23cfa43a7b55)({
        placement: placement
    }), axis = _getPlacement2.axis, edge = _getPlacement2.edge;
    if (axis === 'block' && edge === 'start') return {
        '--ds-popover-tx': '0',
        '--ds-popover-ty': pos
    };
    if (axis === 'block' && edge === 'end') return {
        '--ds-popover-tx': '0',
        '--ds-popover-ty': neg
    };
    if (axis === 'inline' && edge === 'start') return {
        '--ds-popover-tx': pos,
        '--ds-popover-ty': '0'
    };
    if (axis === 'inline' && edge === 'end') return {
        '--ds-popover-tx': neg,
        '--ds-popover-ty': '0'
    };
    return {
        '--ds-popover-tx': '0',
        '--ds-popover-ty': neg
    };
}
// ℹ️ Note: The `transform` x value is flipped in right-to-left mode using the `[dir='rtl']` selector.
var $25ece2499e65f081$var$SLIDE_AND_FADE_CSS = "\n[data-ds-popover-slide-and-fade] {\n  opacity: 0;\n  transform: translate(var(--ds-popover-tx, 0), var(--ds-popover-ty, 0));\n  transition:\n    opacity 175ms cubic-bezier(0.15, 1, 0.3, 1),\n    transform 175ms cubic-bezier(0.15, 1, 0.3, 1),\n    overlay 175ms allow-discrete,\n    display 175ms allow-discrete;\n}\n\n[dir='rtl'] [data-ds-popover-slide-and-fade] {\n  transform: translate(calc(-1 * var(--ds-popover-tx, 0)), var(--ds-popover-ty, 0));\n}\n\n[data-ds-popover-slide-and-fade]:popover-open {\n  opacity: 1;\n  transform: none;\n  transition-duration: 350ms;\n}\n\n@starting-style {\n  [data-ds-popover-slide-and-fade]:popover-open {\n    opacity: 0;\n    transform: translate(var(--ds-popover-tx, 0), var(--ds-popover-ty, 0));\n  }\n}\n\n@starting-style {\n  [dir='rtl'] [data-ds-popover-slide-and-fade]:popover-open {\n    transform: translate(calc(-1 * var(--ds-popover-tx, 0)), var(--ds-popover-ty, 0));\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  [data-ds-popover-slide-and-fade],\n  [data-ds-popover-slide-and-fade]:popover-open {\n    transition-duration: 0s;\n  }\n}\n";
function $25ece2499e65f081$export$635cc6747ac6ffe0(options) {
    var _options$distance;
    var distance = (_options$distance = options === null || options === void 0 ? void 0 : options.distance) !== null && _options$distance !== void 0 ? _options$distance : 4;
    return {
        name: 'slide-and-fade',
        css: $25ece2499e65f081$var$SLIDE_AND_FADE_CSS,
        getProperties: function getProperties(_ref4) {
            var placement = _ref4.placement;
            return $25ece2499e65f081$var$getSlideAndFadeProperties({
                placement: placement,
                distance: distance
            });
        },
        enterDurationMs: 350,
        exitDurationMs: 175
    };
}
// fade
var $25ece2499e65f081$var$FADE_CSS = "\n[data-ds-popover-fade] {\n  opacity: 0;\n  transition:\n    opacity 175ms cubic-bezier(0.15, 1, 0.3, 1),\n    overlay 175ms allow-discrete,\n    display 175ms allow-discrete;\n}\n\n[data-ds-popover-fade]:popover-open {\n  opacity: 1;\n  transition-duration: 350ms;\n}\n\n@starting-style {\n  [data-ds-popover-fade]:popover-open {\n    opacity: 0;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  [data-ds-popover-fade],\n  [data-ds-popover-fade]:popover-open {\n    transition-duration: 0s;\n  }\n}\n";
function $25ece2499e65f081$export$cbea29d068a2e18f() {
    return {
        name: 'fade',
        css: $25ece2499e65f081$var$FADE_CSS,
        enterDurationMs: 350,
        exitDurationMs: 175
    };
}
// scaleAndFade
var $25ece2499e65f081$var$SCALE_AND_FADE_CSS = "\n[data-ds-popover-scale-and-fade] {\n  opacity: 0;\n  transform: scale(0.95);\n  transition:\n    opacity 175ms cubic-bezier(0.15, 1, 0.3, 1),\n    transform 175ms cubic-bezier(0.15, 1, 0.3, 1),\n    overlay 175ms allow-discrete,\n    display 175ms allow-discrete;\n}\n\n[data-ds-popover-scale-and-fade]:popover-open {\n  opacity: 1;\n  transform: none;\n  transition-duration: 350ms;\n}\n\n@starting-style {\n  [data-ds-popover-scale-and-fade]:popover-open {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  [data-ds-popover-scale-and-fade],\n  [data-ds-popover-scale-and-fade]:popover-open {\n    transition-duration: 0s;\n  }\n}\n";
function $25ece2499e65f081$export$d506ab6b7532b83c() {
    return {
        name: 'scale-and-fade',
        css: $25ece2499e65f081$var$SCALE_AND_FADE_CSS,
        enterDurationMs: 350,
        exitDurationMs: 175
    };
}
// ══════════════════════════════════════════════════════════════════════════════
// Dialog presets
// ══════════════════════════════════════════════════════════════════════════════
// ── dialogMotion ──
var $25ece2499e65f081$var$DIALOG_MOTION_CSS = "\n  [data-ds-dialog-motion] {\n    animation: ".concat("var(--ds-modal-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95)", ";\n    animation-fill-mode: forwards;\n    transition:\n      overlay 200ms allow-discrete,\n      display 200ms allow-discrete;\n  }\n\n  [data-ds-dialog-motion][open] {\n    animation: ", "var(--ds-modal-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100)", ";\n    animation-fill-mode: backwards;\n  }\n\n  [data-ds-dialog-motion]::backdrop {\n    animation: ", "var(--ds-blanket-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)", ";\n    animation-fill-mode: forwards;\n    background-color: var(--ds-blanket, #050C1F75);\n    transition:\n      overlay 200ms allow-discrete,\n      display 200ms allow-discrete;\n  }\n\n  [data-ds-dialog-motion][open]::backdrop {\n    animation: ", "var(--ds-blanket-enter, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)", ";\n    animation-fill-mode: backwards;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    [data-ds-dialog-motion],\n    [data-ds-dialog-motion][open],\n    [data-ds-dialog-motion]::backdrop,\n    [data-ds-dialog-motion][open]::backdrop {\n      animation: none;\n      transition-duration: 0s;\n    }\n  }\n");
function $25ece2499e65f081$export$cbf542c04ce9dc36() {
    // Bare preset name; `Dialog` prefixes it via `data-ds-dialog-{name}`.
    return {
        name: 'motion',
        css: $25ece2499e65f081$var$DIALOG_MOTION_CSS,
        enterDurationMs: 250,
        exitDurationMs: 200
    };
}
// ── dialogSlideUpAndFade ──
var $25ece2499e65f081$var$DIALOG_SLIDE_UP_AND_FADE_CSS = "\n[data-ds-dialog-slide-up-and-fade] {\n  opacity: 0;\n  transform: translateY(calc(-1 * var(--ds-dialog-ty, 12px)));\n  transition:\n    opacity 175ms cubic-bezier(0.15, 1, 0.3, 1),\n    transform 175ms cubic-bezier(0.15, 1, 0.3, 1),\n    overlay 175ms allow-discrete,\n    display 175ms allow-discrete;\n}\n\n[data-ds-dialog-slide-up-and-fade][open] {\n  opacity: 1;\n  transform: none;\n  transition-duration: 350ms;\n}\n\n@starting-style {\n  [data-ds-dialog-slide-up-and-fade][open] {\n    opacity: 0;\n    transform: translateY(var(--ds-dialog-ty, 12px));\n  }\n}\n\n[data-ds-dialog-slide-up-and-fade]::backdrop {\n  background-color: transparent;\n  transition:\n    background-color 175ms cubic-bezier(0.15, 1, 0.3, 1),\n    overlay 175ms allow-discrete,\n    display 175ms allow-discrete;\n}\n\n[data-ds-dialog-slide-up-and-fade][open]::backdrop {\n  background-color: var(--ds-blanket, #050C1F75);\n  transition-duration: 350ms;\n}\n\n@starting-style {\n  [data-ds-dialog-slide-up-and-fade][open]::backdrop {\n    background-color: transparent;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  [data-ds-dialog-slide-up-and-fade],\n  [data-ds-dialog-slide-up-and-fade][open],\n  [data-ds-dialog-slide-up-and-fade]::backdrop,\n  [data-ds-dialog-slide-up-and-fade][open]::backdrop {\n    transition-duration: 0s;\n  }\n}\n";
function $25ece2499e65f081$export$97a5dd1c12355679(options) {
    var _options$distance2;
    var distance = (_options$distance2 = options === null || options === void 0 ? void 0 : options.distance) !== null && _options$distance2 !== void 0 ? _options$distance2 : 12;
    // Bare preset name; `Dialog` prefixes it via `data-ds-dialog-{name}`.
    return {
        name: distance === 12 ? 'slide-up-and-fade' : "slide-up-and-fade-".concat(distance),
        css: distance === 12 ? $25ece2499e65f081$var$DIALOG_SLIDE_UP_AND_FADE_CSS : $25ece2499e65f081$var$DIALOG_SLIDE_UP_AND_FADE_CSS.replace(/12px/g, "".concat(distance, "px")),
        enterDurationMs: 350,
        exitDurationMs: 175
    };
}
// dialogFade
var $25ece2499e65f081$var$DIALOG_FADE_CSS = "\n[data-ds-dialog-fade] {\n  opacity: 0;\n  transition:\n    opacity 175ms cubic-bezier(0.15, 1, 0.3, 1),\n    overlay 175ms allow-discrete,\n    display 175ms allow-discrete;\n}\n\n[data-ds-dialog-fade][open] {\n  opacity: 1;\n  transition-duration: 350ms;\n}\n\n@starting-style {\n  [data-ds-dialog-fade][open] {\n    opacity: 0;\n  }\n}\n\n[data-ds-dialog-fade]::backdrop {\n  background-color: transparent;\n  transition:\n    background-color 175ms cubic-bezier(0.15, 1, 0.3, 1),\n    overlay 175ms allow-discrete,\n    display 175ms allow-discrete;\n}\n\n[data-ds-dialog-fade][open]::backdrop {\n  background-color: var(--ds-blanket, #050C1F75);\n  transition-duration: 350ms;\n}\n\n@starting-style {\n  [data-ds-dialog-fade][open]::backdrop {\n    background-color: transparent;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  [data-ds-dialog-fade],\n  [data-ds-dialog-fade][open],\n  [data-ds-dialog-fade]::backdrop,\n  [data-ds-dialog-fade][open]::backdrop {\n    transition-duration: 0s;\n  }\n}\n";
function $25ece2499e65f081$export$bef0e169dcd0522a() {
    // Bare preset name; `Dialog` prefixes it via `data-ds-dialog-{name}`.
    return {
        name: 'fade',
        css: $25ece2499e65f081$var$DIALOG_FADE_CSS,
        enterDurationMs: 350,
        exitDurationMs: 175
    };
}



var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");
/**
 * The full mapping record. Internal - use `fromLegacyPlacement` from the
 * public entry-point so the offset-tuple translation is applied consistently.
 *
 * Note: `auto`, `auto-start`, `auto-end` map to `block-end` placements. This
 * is a reduction in expressiveness vs Popper.js (which picked the best
 * placement at runtime). CSS `position-try-fallbacks` flips at the edge but
 * the initial placement is fixed. Migration consumers who relied on Popper's
 * dynamic auto-flip should pick an explicit placement instead.
 */ var $9d053b446b63da2e$export$27df359c528b7120 = {
    top: {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'start'
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'end'
    },
    bottom: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    },
    right: {
        axis: 'inline',
        edge: 'end',
        align: 'center'
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'start'
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'end'
    },
    left: {
        axis: 'inline',
        edge: 'start',
        align: 'center'
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'start'
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'end'
    },
    auto: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'auto-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'auto-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    }
};


function $0b6bd0d300639f6a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0b6bd0d300639f6a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0b6bd0d300639f6a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0b6bd0d300639f6a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0b6bd0d300639f6a$export$69e99ed50b2534c9(_ref) {
    var legacy = _ref.legacy, offset = _ref.offset;
    var basePlacement = (0, $9d053b446b63da2e$export$27df359c528b7120)[legacy];
    if (!offset) return basePlacement;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(offset, 2), along = _offset[0], away = _offset[1];
    return $0b6bd0d300639f6a$var$_objectSpread($0b6bd0d300639f6a$var$_objectSpread({}, basePlacement), {}, {
        offset: {
            gap: away,
            crossAxisShift: {
                // Sign is captured in `direction`; `value` is the magnitude.
                value: Math.abs(along),
                direction: along >= 0 ? 'forwards' : 'backwards'
            }
        }
    });
}


/* popover.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $c0d8a668360673d2$var$ATOMIC_GROUP_LENGTH = 5;
function $c0d8a668360673d2$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $c0d8a668360673d2$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $ekGgq = parcelRequire("ekGgq");
function $7a1f56e2ca927fa2$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref) === 'object') ref.current = value;
        });
    };
}


/**
 * Creates a new function that will cache the result of it's first call.
 *
 * ```ts
 * function sayHello(name: string): string {
 *   return `Hello ${name}`;
 * }
 * const cached = once(sayHello);
 *
 * cached('Alex'); // returns "Hello Alex"
 * cached('Sam'); // returns "Hello Alex" (underlying `sayHello` function not called)
 * ```
 *
 * **Notes**
 *
 * - If the `onced` function throws, then the return value of the function is not cached
 * - Respects call site context (`this`) when executing the onced function
 */ function $e1dfa0095d7eba10$export$2e2bcd8739ae039(fn) {
    var cache = null;
    return function result() {
        if (!cache) {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            cache = {
                value: fn.call.apply(fn, [
                    this
                ].concat(args))
            };
        }
        /**
     * Intentionally not adding `.clear()` function property
     *
     * - We currently have no need for it
     * - We don't want to add a `.clear()` to functions that should never be called twice,
     *   for example: `cleanup` functions.
     * - We can add a `onceWithCleanup` variant as a separate export from ds-lib if the
     *   need arises 🧘
     */ return cache.value;
    };
}



/**
 * Valid values for the `aria-haspopup` attribute.
 *
 * Derived from the HTML spec - maps popover roles to what the trigger
 * announces. `undefined` means the attribute is omitted entirely (used for
 * non-popup roles like `tooltip`/`status`/`alert`/`note`/`log` where
 * `aria-haspopup` would be misleading).
 *
 * `true` is intentionally NOT in the union - the runtime only ever produces
 * the explicit string forms, so widening the type would invite consumers to
 * pass `true` and get an `aria-haspopup="true"` serialisation that the
 * runtime no longer emits.
 */ /**
 * Roles that require an accessible name (`label` or `labelledBy`) per WCAG 4.1.2.
 * Without a name, assistive technology cannot identify these landmarks.
 */ /**
 * Roles where the accessible name is derived from content or provided externally
 * (e.g. a combobox labels its listbox, tooltip content IS the accessible name).
 */ // Shared ARIA role discrimination types
//
// These encode the WCAG 4.1.2 constraint: roles like `dialog`, `alertdialog`,
// and `menu` MUST have an accessible name (either `label` or `labelledBy`).
// TypeScript enforces this at compile time via discriminated unions.
/**
 * ARIA role props where a role is always required.
 *
 * Used by `TPopupContentProps`. Popup content must always declare
 * its role so assistive technology can identify the layer.
 */ /**
 * ARIA role props where a role is optional.
 *
 * Used by `TPopoverProps`. The low-level primitive allows omitting
 * the role for cases where it is set externally or not needed.
 */ var $992048c3969a297e$var$rolesThatMoveFocus = new Set([
    'dialog',
    'alertdialog',
    'menu',
    'listbox',
    'tree',
    'grid'
]);
function $992048c3969a297e$export$b12adccf56228c71(_ref) {
    var role = _ref.role;
    if (!role) return false;
    return $992048c3969a297e$var$rolesThatMoveFocus.has(role);
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $4239981161ff8992$export$ff7706047246b98b = (0, $e1dfa0095d7eba10$export$2e2bcd8739ae039)(function() {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});



var $5FkrB = parcelRequire("5FkrB");
/**
 * Per-preset CSS injection.
 *
 * Each preset's CSS is injected at most once into `<head>`.
 * Shared by both PopoverContent and DialogContent.
 *
 * Note: injected `<style>` elements and the tracking Set are append-only -
 * they are never removed. This is intentional: the number of distinct
 * presets is bounded (handful of animation presets), so the
 * memory footprint is negligible. Removing styles would risk breaking
 * other instances of the same preset that are still mounted.
 *
 * Decision (2026-03-17 audit): Accepted as a non-issue. The bounded
 * preset count (~5 presets) makes cleanup unnecessary. We plan to move
 * to a Compiled-based solution which will handle style injection and
 * deduplication natively.
 */ var $b1306236f72f5e0d$var$injectedPresets = new Set();
function $b1306236f72f5e0d$export$9515fe8c2ae33fb5(_ref) {
    var preset = _ref.preset;
    if ($b1306236f72f5e0d$var$injectedPresets.has(preset.name) || typeof document === 'undefined') return;
    $b1306236f72f5e0d$var$injectedPresets.add(preset.name);
    var style = document.createElement('style');
    style.textContent = preset.css;
    document.head.appendChild(style);
}


function $0c99ca1587d4dcb0$export$f09337c691384fe1(_ref) {
    var preset = _ref.preset;
    var resolved = preset != null && preset !== false ? preset : null;
    (0, $5FkrB.useInsertionEffect)(function() {
        if (resolved) (0, $b1306236f72f5e0d$export$9515fe8c2ae33fb5)({
            preset: resolved
        });
    }, [
        resolved
    ]);
    return resolved;
}


/**
 * Fires `onSettled` once when `transitionend` fires on `element`, or after
 * `safetyNetMs` if the event is swallowed (mid-transition unmount, CSS
 * mismatch, browser quirks). Returns a cleanup that cancels both paths.
 */ function $7453370a0d3f1241$var$runOnTransitionEndOrTimeout(_ref) {
    var element = _ref.element, safetyNetMs = _ref.safetyNetMs, onSettled = _ref.onSettled;
    var state = {
        isSettled: false
    };
    function teardown() {
        state.isSettled = true;
        clearTimeout(safetyNetId);
        unbind();
    }
    function settle() {
        if (state.isSettled) return;
        teardown();
        onSettled();
    }
    var unbind = (0, $7QpUe.bind)(element, {
        type: 'transitionend',
        listener: settle,
        options: {
            once: true
        }
    });
    var safetyNetId = setTimeout(settle, safetyNetMs);
    return teardown;
}
function $7453370a0d3f1241$export$1bccb45daf07907f(_ref2) {
    var isOpen = _ref2.isOpen, animate = _ref2.animate, elementRef = _ref2.elementRef, onEnterFinish = _ref2.onEnterFinish, onExitFinish = _ref2.onExitFinish;
    var preset = (0, $0c99ca1587d4dcb0$export$f09337c691384fe1)({
        preset: animate
    });
    // False when there is no preset or `prefers-reduced-motion` is set.
    var willAnimate = Boolean(animate) && !(0, $4239981161ff8992$export$ff7706047246b98b)();
    // Promote `closed → entering`/`closed → open` synchronously during
    // render so the host element mounts in the same commit as the open
    // intent. All other transitions are driven by phase-specific effects.
    var _useState = (0, $5FkrB.useState)(function() {
        if (!isOpen) return 'closed';
        return willAnimate ? 'entering' : 'open';
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), phase = _useState2[0], setPhase = _useState2[1];
    if (isOpen && phase === 'closed') setPhase(willAnimate ? 'entering' : 'open');
    if (!isOpen && (phase === 'open' || phase === 'entering')) // Close intent. Move to `exiting` to gate the unmount on either
    // the exit transition (animated) or the toggle/close event
    // (non-animated). Includes interrupted entry (`entering → exiting`).
    setPhase('exiting');
    if (isOpen && phase === 'exiting') // Reopen mid-exit. With animation, jump back to `entering` and let
    // the entry transition restart from current visual state. Without
    // animation, jump straight to `open` (the handshake we were waiting
    // for is no longer relevant; the consumer wants the host visible
    // again synchronously).
    setPhase(willAnimate ? 'entering' : 'open');
    // Keep stable refs to the latest callbacks so effects and timeout closures
    // always call the current callback without needing them in dependency arrays.
    var onEnterFinishRef = (0, $5FkrB.useRef)(onEnterFinish);
    onEnterFinishRef.current = onEnterFinish;
    var onExitFinishRef = (0, $5FkrB.useRef)(onExitFinish);
    onExitFinishRef.current = onExitFinish;
    // Animated entry: wait for `transitionend` (or a safety-net timeout) and
    // move to `open`. The fallback guarantees settle on swallowed events
    // (zero-duration, browser quirk, mid-transition unmount).
    (0, $5FkrB.useEffect)(function() {
        var _preset$enterDuration;
        if (phase !== 'entering') return;
        var element = elementRef.current;
        if (!element) return;
        return $7453370a0d3f1241$var$runOnTransitionEndOrTimeout({
            element: element,
            safetyNetMs: ((_preset$enterDuration = preset === null || preset === void 0 ? void 0 : preset.enterDurationMs) !== null && _preset$enterDuration !== void 0 ? _preset$enterDuration : 0) + 50,
            onSettled: function onSettled() {
                var _onEnterFinishRef$cur;
                // Fire the consumer callback before transitioning phase so any
                // state the consumer reads (refs, DOM nodes) is still attached
                // in the same synchronous tick, regardless of React batching
                // semantics.
                (_onEnterFinishRef$cur = onEnterFinishRef.current) === null || _onEnterFinishRef$cur === void 0 || _onEnterFinishRef$cur.call(onEnterFinishRef);
                setPhase(function(current) {
                    return current === 'entering' ? 'open' : current;
                });
            }
        });
    }, [
        phase,
        preset === null || preset === void 0 ? void 0 : preset.enterDurationMs,
        elementRef
    ]);
    // Non-animated entry callback. The lifecycle goes `closed → open`
    // directly with no `entering` phase; fire `onEnterFinish` on that jump.
    // A previous-phase ref avoids double-firing on the animated path.
    var prevPhaseForEntryRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForEntryRef.current;
        prevPhaseForEntryRef.current = phase;
        // Animated entry settle goes through `entering` and already fired
        // onEnterFinish above; only handle the non-animated direct jumps.
        if (prevPhase !== 'open' && phase === 'open' && prevPhase !== 'entering') {
            var _onEnterFinishRef$cur2;
            (_onEnterFinishRef$cur2 = onEnterFinishRef.current) === null || _onEnterFinishRef$cur2 === void 0 || _onEnterFinishRef$cur2.call(onEnterFinishRef);
        }
    }, [
        phase
    ]);
    // Animated exit: wait for `transitionend` (or a safety-net timeout),
    // fire `onExitFinish`, then move to `closed` to unmount the host.
    (0, $5FkrB.useEffect)(function() {
        var _preset$exitDurationM;
        if (phase !== 'exiting' || !willAnimate) return;
        var element = elementRef.current;
        if (!element) return;
        return $7453370a0d3f1241$var$runOnTransitionEndOrTimeout({
            element: element,
            safetyNetMs: ((_preset$exitDurationM = preset === null || preset === void 0 ? void 0 : preset.exitDurationMs) !== null && _preset$exitDurationM !== void 0 ? _preset$exitDurationM : 0) + 50,
            onSettled: function onSettled() {
                var _onExitFinishRef$curr;
                // Fire the consumer callback before transitioning phase to
                // `closed`. The phase change drives the host element unmount,
                // and consumers expect to be able to read the element (or a
                // forwarded ref to it) inside `onExitFinish`. Doing this in
                // the safe order avoids relying on React's automatic batching
                // to keep the element attached across the callback.
                (_onExitFinishRef$curr = onExitFinishRef.current) === null || _onExitFinishRef$curr === void 0 || _onExitFinishRef$curr.call(onExitFinishRef);
                setPhase(function(current) {
                    return current === 'exiting' ? 'closed' : current;
                });
            }
        });
    }, [
        phase,
        willAnimate,
        preset === null || preset === void 0 ? void 0 : preset.exitDurationMs,
        elementRef
    ]);
    // Non-animated exit: wait for the browser's `toggle` (closed) or
    // `close` event before unmounting, so the consumer's listener (close
    // reason, nested focus restoration, `onClose`) and the browser's
    // native focus restoration both run against the still-attached
    // element. A naive `setTimeout(0)` occasionally beats the `toggle`
    // task in Chromium and drops focus restoration.
    //
    // `useLayoutEffect` so the listener binds in the same commit as the
    // show/hide layout effect that calls `hidePopover()` / `dialog.close()`.
    // The toggle/close event is queued as a task and cannot run until the
    // frame completes. SSR-safe: `phase` starts at `'closed'`.
    //
    // `onExitFinish` is fired separately (see effect below) so consumers
    // observe it the moment `isOpen` flips to `false`.
    (0, $5FkrB.useLayoutEffect)(function() {
        if (phase !== 'exiting' || willAnimate) return;
        var element = elementRef.current;
        if (!element) return;
        function unmount() {
            setPhase(function(current) {
                return current === 'exiting' ? 'closed' : current;
            });
        }
        return (0, $7QpUe.bindAll)(element, [
            {
                type: 'toggle',
                listener: function listener(event) {
                    if (event.newState === 'closed') unmount();
                }
            },
            {
                type: 'close',
                listener: unmount
            }
        ]);
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    // Non-animated exit callback. No `transitionend` to wait for, so fire
    // `onExitFinish` on the transition into `exiting` (the unmount itself
    // is gated by the toggle/close handshake above).
    var prevPhaseForExitRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForExitRef.current;
        prevPhaseForExitRef.current = phase;
        // Only fire on the non-animated transition into `exiting`. The
        // animated path's `exiting → closed` settle already fires
        // `onExitFinish` from `runOnTransitionEndOrTimeout`.
        if (prevPhase !== 'exiting' && phase === 'exiting' && !willAnimate) {
            var _onExitFinishRef$curr2;
            (_onExitFinishRef$curr2 = onExitFinishRef.current) === null || _onExitFinishRef$curr2 === void 0 || _onExitFinishRef$curr2.call(onExitFinishRef);
        }
    }, [
        phase,
        willAnimate
    ]);
    return {
        phase: phase,
        preset: preset
    };
}



var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
var $5c37079992dfaafb$var$topLayerSelector = '[popover], dialog, [role="dialog"], [role="alertdialog"]';
function $5c37079992dfaafb$export$df8c72c64edc7260(_ref) {
    var element = _ref.element, container = _ref.container;
    var elementLayer = element.closest($5c37079992dfaafb$var$topLayerSelector);
    var containerLayer = container.closest($5c37079992dfaafb$var$topLayerSelector);
    // Both elements are in the "document" layer
    if (!elementLayer && !containerLayer) return true;
    return elementLayer === containerLayer;
}


var $be99b14e6003c4d7$export$e1252723db1c541 = function() {
    // Common exclusion filter applied to every selector.
    var not = ':not([tabindex="-1"]):not([aria-disabled="true"]):not([aria-hidden="true"])';
    var notDisabled = ":not([disabled])".concat(not);
    var focusable = [
        "a[href]".concat(not),
        "area[href]".concat(not),
        "input".concat(notDisabled, ":not([type=\"hidden\"])"),
        "select".concat(notDisabled),
        "textarea".concat(notDisabled),
        "button".concat(notDisabled),
        "iframe".concat(not),
        "audio[controls]".concat(not),
        "video[controls]".concat(not),
        "[contenteditable]:not([contenteditable=\"false\"])".concat(not),
        "[tabindex]".concat(notDisabled).concat(not)
    ];
    return {
        focusable: focusable.join(','),
        // Build the `:focus` selector
        focused: focusable.map(function(selector) {
            return "".concat(selector, ":focus");
        }).join(',')
    };
}();


function $5e312c9bd805125b$export$f6768025e418420e(_ref) {
    var container = _ref.container, filter = _ref.filter;
    return Array.from(container.querySelectorAll((0, $be99b14e6003c4d7$export$e1252723db1c541).focusable)).filter(function(element) {
        return element instanceof HTMLElement;
    }).filter(function(element) {
        return (0, $5c37079992dfaafb$export$df8c72c64edc7260)({
            element: element,
            container: container
        });
    }).filter(function(element) {
        return !filter || filter(element, container);
    });
}


function $f295f87132ae3501$export$748138f04a69bf21(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $5e312c9bd805125b$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}



function $8cae5f233051ad3e$export$73e81fa65335a75b(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $5e312c9bd805125b$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}


/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * Returns `null` if there is no focused element within the container or if
 * the focused element is not in the list of focusable elements.
 */ 

function $e6191d34f211eed7$export$a7db88e6d491b450(_ref) {
    var _all$nextIndex;
    var container = _ref.container, direction = _ref.direction, filter = _ref.filter;
    var all = (0, $5e312c9bd805125b$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    var current = container.querySelector((0, $be99b14e6003c4d7$export$e1252723db1c541).focused);
    if (!(current instanceof HTMLElement)) return null;
    var index = all.indexOf(current);
    if (index === -1) return null;
    var nextIndex = function() {
        if (direction === 'forwards') return (index + 1) % all.length;
        var proposed = index - 1;
        // if going into negative numbers, loop back to the last item
        return proposed < 0 ? all.length - 1 : proposed;
    }();
    return (_all$nextIndex = all[nextIndex]) !== null && _all$nextIndex !== void 0 ? _all$nextIndex : null;
}




function $b6509bdd865203ef$export$b9590fdfeb5f722f(_ref) {
    var _getDocument;
    var container = _ref.container;
    var focused = (_getDocument = (0, $4d734fafa08ec969$export$f65ca476c09acec0)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return !(0, $5c37079992dfaafb$export$df8c72c64edc7260)({
        element: focused,
        container: container
    });
}


/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/outputs/menu-keyboard-decision.md
 */ function $48953ce2bc6a33af$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $48953ce2bc6a33af$export$4f6462e86a70abe5(_ref) {
    var elementRef = _ref.elementRef, role = _ref.role, phase = _ref.phase;
    var isVisible = phase !== 'closed';
    (0, $5FkrB.useEffect)(function() {
        var element = elementRef.current;
        if (!element || !$48953ce2bc6a33af$var$roleRequiresFocusWrap(role) || !isVisible) return;
        var unbind = (0, $7QpUe.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $b6509bdd865203ef$export$b9590fdfeb5f722f)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                var direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                var next = (0, $e6191d34f211eed7$export$a7db88e6d491b450)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                var fallback = direction === 'forwards' ? (0, $f295f87132ae3501$export$748138f04a69bf21)({
                    container: element
                }) : (0, $8cae5f233051ad3e$export$73e81fa65335a75b)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}



var $5FkrB = parcelRequire("5FkrB");

/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox regardless of role. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, or menu), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
var $12eadc60b3d0721a$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $12eadc60b3d0721a$var$isTextboxLikeElement(element) {
    var role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    var tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        var _element$getAttribute;
        var type = ((_element$getAttribute = element.getAttribute('type')) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : 'text').toLowerCase();
        return $12eadc60b3d0721a$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $12eadc60b3d0721a$var$isComboboxControllingPopup(_ref) {
    var _active$getAttribute;
    var container = _ref.container;
    var ownerDocument = container.ownerDocument;
    var active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$12eadc60b3d0721a$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    var idRefs = (_active$getAttribute = active.getAttribute('aria-controls')) !== null && _active$getAttribute !== void 0 ? _active$getAttribute : active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    var referencedIds = idRefs.split(/\s+/).filter(function(id) {
        return id !== '';
    });
    return referencedIds.some(function(id) {
        var referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function $12eadc60b3d0721a$var$getInitialFocusTarget(_ref2) {
    var container = _ref2.container, role = _ref2.role;
    if (role === 'dialog' || role === 'alertdialog') {
        // Prefer element with the native HTML autofocus attribute.
        var autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $f295f87132ae3501$export$748138f04a69bf21)({
            container: container
        });
    }
    if (role === 'menu') {
        if ($12eadc60b3d0721a$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/outputs/menu-keyboard-decision.md
        return (0, $f295f87132ae3501$export$748138f04a69bf21)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($12eadc60b3d0721a$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        var selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        var firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $f295f87132ae3501$export$748138f04a69bf21)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $12eadc60b3d0721a$export$e992c40175757a22(_ref3) {
    var elementRef = _ref3.elementRef, phase = _ref3.phase, role = _ref3.role;
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    var prevPhaseRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var _getInitialFocusTarge;
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        var element = elementRef.current;
        if (!element) return;
        (_getInitialFocusTarge = $12eadc60b3d0721a$var$getInitialFocusTarget({
            container: element,
            role: role
        })) === null || _getInitialFocusTarge === void 0 || _getInitialFocusTarge.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}


/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ var $7af4023e0e9843ad$var$supportsPopoverHint = (0, $e1dfa0095d7eba10$export$2e2bcd8739ae039)(function() {
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    var element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- popover UA reset requires values not in cssMap's type union
var $7af4023e0e9843ad$var$styles = {
    root: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r041wug _1reoewfl _18m9ewfl _bfhk1j28"
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ var $7af4023e0e9843ad$var$POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
var $7af4023e0e9843ad$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function Popover(_ref, ref) {
    var children = _ref.children, _ref$mode = _ref.mode, modeProp = _ref$mode === void 0 ? 'auto' : _ref$mode, onClose = _ref.onClose, onOpenChange = _ref.onOpenChange, onEnterFinish = _ref.onEnterFinish, onExitFinish = _ref.onExitFinish, animate = _ref.animate, placement = _ref.placement, testId = _ref.testId, isOpen = _ref.isOpen, xcssFromProps = _ref.xcss, role = _ref.role, label = _ref.label, labelledBy = _ref.labelledBy, idProp = _ref.id;
    var autoId = (0, $5FkrB.useId)();
    var ownRef = (0, $5FkrB.useRef)(null);
    var combinedRef = (0, $7a1f56e2ca927fa2$export$2e2bcd8739ae039)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    var popoverId = idProp !== null && idProp !== void 0 ? idProp : "popover-".concat(autoId.replace(/:/g, ''));
    var _useAnimatedVisibilit = (0, $7453370a0d3f1241$export$1bccb45daf07907f)({
        isOpen: isOpen,
        animate: animate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    }), phase = _useAnimatedVisibilit.phase, preset = _useAnimatedVisibilit.preset;
    // True while the host element is mounted (any phase except `closed`).
    // Used as a dep so listener-rebind effects re-attach after a remount.
    var isVisible = phase !== 'closed';
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // focus-capturing roles are handled below via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus-restoration.md.
    (0, $48953ce2bc6a33af$export$4f6462e86a70abe5)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    (0, $12eadc60b3d0721a$export$e992c40175757a22)({
        elementRef: ownRef,
        phase: phase,
        role: role
    });
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined.
    var handleObserverClose = (0, $5FkrB.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose({
            reason: 'programmatic'
        });
    }, [
        onClose
    ]);
    (0, $3a27eaabd1216a32$export$469bb693f11edc7f)({
        type: role && $7af4023e0e9843ad$var$POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen: isOpen,
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    var mode = modeProp === 'hint' && !$7af4023e0e9843ad$var$supportsPopoverHint() ? 'auto' : modeProp;
    // Prevents toggle handler from calling onClose for our own hidePopover() calls.
    var programmaticCloseRef = (0, $5FkrB.useRef)(false);
    // Set in capture-phase keydown so the toggle handler knows close reason.
    var closeReasonRef = (0, $5FkrB.useRef)('light-dismiss');
    // Snapshot of pre-open focus, used to restore focus for nested popovers
    // with focus-capturing roles (browser only restores the outermost).
    var previouslyFocusedElementRef = (0, $5FkrB.useRef)(null);
    var handleBeforeToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState !== 'open') return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- need active element snapshot
        var active = document.activeElement;
        previouslyFocusedElementRef.current = active instanceof HTMLElement ? active : null;
    }, []);
    var handleToggle = (0, $5FkrB.useCallback)(function(event) {
        var element = ownRef.current;
        if (event.newState === 'open') {
            if (element) onOpenChange === null || onOpenChange === void 0 || onOpenChange({
                isOpen: true,
                element: element
            });
            return;
        }
        if (event.newState === 'closed') {
            if (element) {
                onOpenChange === null || onOpenChange === void 0 || onOpenChange({
                    isOpen: false,
                    element: element
                });
                // Nested-popover focus restoration fallback (browser only
                // restores outermost; Firefox skips nested entirely).
                // Restore only when the role moved focus in on open AND the
                // close was Escape/programmatic. For light dismiss, the
                // click target keeps focus per HTML spec
                // (`focusPreviousElement=false`).
                var previouslyFocused = previouslyFocusedElementRef.current;
                var _reason = closeReasonRef.current;
                var isProgrammatic = programmaticCloseRef.current;
                var shouldRestore = previouslyFocused !== null && previouslyFocused.isConnected && (0, $992048c3969a297e$export$b12adccf56228c71)({
                    role: role
                }) && (_reason === 'escape' || isProgrammatic);
                if (shouldRestore && previouslyFocused) previouslyFocused.focus({
                    preventScroll: true
                });
                previouslyFocusedElementRef.current = null;
            }
            // Programmatic close: consumer already knows.
            if (programmaticCloseRef.current) {
                // Reset reason so a stale 'escape' from a race with Escape keydown
                // does not corrupt the next browser-dismiss cycle.
                closeReasonRef.current = 'light-dismiss';
                return;
            }
            // Browser dismiss (Escape/click-outside).
            var reason = closeReasonRef.current;
            closeReasonRef.current = 'light-dismiss';
            // Optional: `manual` mode has no `onClose` in the forwarded type.
            onClose === null || onClose === void 0 || onClose({
                reason: reason
            });
        }
    }, [
        onClose,
        onOpenChange,
        role
    ]);
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `previouslyFocusedElementRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        var unbindEscape = (0, $7QpUe.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key === 'Escape') closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        var unbindToggle = (0, $7QpUe.bind)(element, {
            type: 'toggle',
            listener: handleToggle
        });
        // Snapshot `document.activeElement` before `useInitialFocus` moves it.
        var unbindBeforeToggle = (0, $7QpUe.bind)(element, {
            type: 'beforetoggle',
            listener: handleBeforeToggle
        });
        return function() {
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleToggle,
        handleBeforeToggle,
        isVisible
    ]);
    // Placement-dependent animation CSS vars. Kept separate from show/hide
    // so preset reference changes do not re-trigger visibility.
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element || !(preset !== null && preset !== void 0 && preset.getProperties) || !placement) return;
        var props = preset.getProperties({
            placement: placement
        });
        Object.entries(props).forEach(function(_ref2) {
            var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 2), key = _ref3[0], value = _ref3[1];
            element.style.setProperty(key, String(value));
        });
    }, [
        preset,
        placement,
        isVisible
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            programmaticCloseRef.current = false;
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and the no-animation path unmounts before
            // `handleToggle` can reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch (_unused) {}
            return function() {
                programmaticCloseRef.current = true;
                try {
                    element.hidePopover();
                } catch (_unused2) {}
            };
        }
        programmaticCloseRef.current = true;
        try {
            element.hidePopover();
        } catch (_unused3) {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: combinedRef,
        id: popoverId,
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId
    }, preset ? (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "data-ds-popover-".concat(preset.name), '') : undefined, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- xcss prop passes compiled atomic class names
        className: (0, $c0d8a668360673d2$export$2e2bcd8739ae039)([
            $7af4023e0e9843ad$var$styles.root,
            xcssFromProps
        ])
    }), children);
});



var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $45Zis = parcelRequire("45Zis");


var $25nEq = parcelRequire("25nEq");
function $21bf418588e5e15a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $21bf418588e5e15a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $21bf418588e5e15a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $21bf418588e5e15a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * JS fallback positioning math. Used only when the browser does not
 * support CSS Anchor Positioning (less than 6% of users).
 *
 * Consumer-supplied `offset.gap` and `offset.crossAxisShift` are
 * honored: the caller (`useAnchorPosition`) resolves CSS length strings
 * (tokens, calc, var, etc) to pixels via a DOM probe before passing them
 * in. The caller also keeps the popover hidden (`opacity: 0`) until the
 * first measurement completes, so the popover never paints at the wrong
 * position.
 */ /**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function $21bf418588e5e15a$var$computeEdgePosition(_ref) {
    var axis = _ref.axis, edge = _ref.edge, triggerRect = _ref.triggerRect, popoverWidth = _ref.popoverWidth, popoverHeight = _ref.popoverHeight, viewport = _ref.viewport, gap = _ref.gap;
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        var spaceBelow = viewport.height - triggerRect.bottom;
        var spaceAbove = triggerRect.top;
        var fitsBelow = spaceBelow >= popoverHeight + gap;
        var useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        var _spaceAbove = triggerRect.top;
        var _spaceBelow = viewport.height - triggerRect.bottom;
        var fitsAbove = _spaceAbove >= popoverHeight + gap;
        var useAbove = fitsAbove || _spaceAbove >= _spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        var spaceRight = viewport.width - triggerRect.right;
        var spaceLeft = triggerRect.left;
        var fitsRight = spaceRight >= popoverWidth + gap;
        var useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        var _spaceLeft = triggerRect.left;
        var _spaceRight = viewport.width - triggerRect.right;
        var fitsLeft = _spaceLeft >= popoverWidth + gap;
        var useLeft = fitsLeft || _spaceLeft >= _spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function $21bf418588e5e15a$var$applyAlignment(_ref2) {
    var position = _ref2.position, axis = _ref2.axis, align = _ref2.align, triggerRect = _ref2.triggerRect, popoverWidth = _ref2.popoverWidth, popoverHeight = _ref2.popoverHeight;
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return $21bf418588e5e15a$var$_objectSpread($21bf418588e5e15a$var$_objectSpread({}, position), {}, {
            left: triggerRect.left
        });
        // align === 'end'
        return $21bf418588e5e15a$var$_objectSpread($21bf418588e5e15a$var$_objectSpread({}, position), {}, {
            left: triggerRect.right - popoverWidth
        });
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return $21bf418588e5e15a$var$_objectSpread($21bf418588e5e15a$var$_objectSpread({}, position), {}, {
        top: triggerRect.top
    });
    // align === 'end'
    return $21bf418588e5e15a$var$_objectSpread($21bf418588e5e15a$var$_objectSpread({}, position), {}, {
        top: triggerRect.bottom - popoverHeight
    });
}
/**
 * Applies the cross-axis shift offset.
 *
 * The sign mirrors the CSS path (see `crossAxisShiftMargin` in
 * `use-anchor-position.tsx`):
 *   - `align: 'start' | 'center'` + `forwards`  → push toward end (positive)
 *   - `align: 'end'`              + `forwards`  → push toward start (negative)
 *   - `backwards` flips the sign in both cases.
 */ function $21bf418588e5e15a$var$applyCrossAxisShift(_ref3) {
    var position = _ref3.position, axis = _ref3.axis, align = _ref3.align, crossAxisShift = _ref3.crossAxisShift;
    if (crossAxisShift.value === 0) return position;
    var directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    var sideSign = align === 'end' ? -1 : 1;
    var delta = crossAxisShift.value * directionSign * sideSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return $21bf418588e5e15a$var$_objectSpread($21bf418588e5e15a$var$_objectSpread({}, position), {}, {
        left: position.left + delta
    });
    return $21bf418588e5e15a$var$_objectSpread($21bf418588e5e15a$var$_objectSpread({}, position), {}, {
        top: position.top + delta
    });
}
function $21bf418588e5e15a$export$d5ef1dac02135664(_ref4) {
    var triggerRect = _ref4.triggerRect, popoverEl = _ref4.popoverEl, placement = _ref4.placement, viewport = _ref4.viewport, gap = _ref4.gap, crossAxisShift = _ref4.crossAxisShift;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    var popoverWidth = popoverEl.offsetWidth;
    var popoverHeight = popoverEl.offsetHeight;
    var basePosition = $21bf418588e5e15a$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    var alignedPosition = $21bf418588e5e15a$var$applyAlignment({
        position: basePosition,
        axis: axis,
        align: align,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    var shiftedPosition = $21bf418588e5e15a$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        align: align,
        crossAxisShift: crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}


/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $bc3631763f508f95$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, cleanupFns = new Array(_len), _key = 0; _key < _len; _key++)cleanupFns[_key] = arguments[_key];
    return function cleanup() {
        cleanupFns.forEach(function(callback) {
            return callback === null || callback === void 0 ? void 0 : callback();
        });
    };
}



function $973a4c643893e337$export$de49b61f233ddeb9(_ref) {
    var placement = _ref.placement;
    var _getPlacement = (0, $96ffae146696b031$export$a9fe23cfa43a7b55)({
        placement: placement
    }), axis = _getPlacement.axis, edge = _getPlacement.edge, align = _getPlacement.align;
    var edgeValue = "".concat(axis, "-").concat(edge);
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    var spanDir = align === 'start' ? 'end' : 'start';
    return "".concat(edgeValue, " span-").concat(crossAxis, "-").concat(spanDir);
}



var $fC8ib = parcelRequire("fC8ib");

function $48038b8d3ed312ed$export$c4e16947a95d61f1(_ref) {
    var placement = _ref.placement;
    var _getPlacement = (0, $96ffae146696b031$export$a9fe23cfa43a7b55)({
        placement: placement
    }), axis = _getPlacement.axis, edge = _getPlacement.edge, align = _getPlacement.align;
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    var flippedEdge = edge === 'start' ? 'end' : 'start';
    var sameEdge = "".concat(axis, "-").concat(edge);
    var oppositeEdge = "".concat(axis, "-").concat(flippedEdge);
    var flipKeyword = axis === 'block' ? 'flip-block' : 'flip-inline';
    var flipCrossKeyword = axis === 'block' ? 'flip-inline' : 'flip-block';
    // Single algorithm: produce the shift list against any base alignment.
    // For `align: 'start'` the "near" shift expands toward `end`; for
    // `align: 'end'` it expands toward `start`; for `align: 'center'`
    // either order is symmetric (we use end-then-start to match the
    // historical fallback list).
    function shifts(baseAlign, edgeKey) {
        if (baseAlign === 'center') return [
            "".concat(edgeKey, " span-").concat(crossAxis, "-end"),
            "".concat(edgeKey, " span-").concat(crossAxis, "-start")
        ];
        var near = baseAlign === 'start' ? 'end' : 'start';
        var far = baseAlign === 'start' ? 'start' : 'end';
        return [
            "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(near),
            edgeKey,
            "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(far)
        ];
    }
    if (align !== 'center') // Aligned (start/end): try same-edge shifts, then single-axis flip,
    // then diagonal flip for corner overflow, then opposite-edge shifts.
    // Legacy Popper fallback ordering for e.g. bottom-start:
    // [bottom, bottom-end, top-start, top, top-end, auto].
    return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(shifts(align, sameEdge)), [
        flipKeyword,
        "".concat(flipKeyword, " ").concat(flipCrossKeyword)
    ], (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(shifts(align, oppositeEdge))).join(', ');
    // Centered: same-edge shifts, single-axis flip, opposite-edge shifts.
    // Diagonal flip is unnecessary because centered placements expand
    // equally in both cross-axis directions.
    return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(shifts('center', sameEdge)), [
        flipKeyword
    ], (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(shifts('center', oppositeEdge))).join(', ');
}


var $c36249007920e0ef$var$elementCaches = new WeakMap();
function $c36249007920e0ef$var$canCacheResolvedLength(value) {
    // Custom-property values can be retargeted by inline overrides on the
    // consumer's wrapper, so we cannot prove a cached pixel value is still valid.
    return !value.includes('var(');
}
function $c36249007920e0ef$var$getCachedResolvedLength(_ref) {
    var _cacheForElement$get;
    var element = _ref.element, value = _ref.value;
    if (!$c36249007920e0ef$var$canCacheResolvedLength(value)) return null;
    var cacheForElement = $c36249007920e0ef$var$elementCaches.get(element);
    return (_cacheForElement$get = cacheForElement === null || cacheForElement === void 0 ? void 0 : cacheForElement.get(value)) !== null && _cacheForElement$get !== void 0 ? _cacheForElement$get : null;
}
function $c36249007920e0ef$var$cacheResolvedLength(_ref2) {
    var _elementCaches$get;
    var element = _ref2.element, value = _ref2.value, result = _ref2.result;
    if (!$c36249007920e0ef$var$canCacheResolvedLength(value)) return;
    var cacheForElement = (_elementCaches$get = $c36249007920e0ef$var$elementCaches.get(element)) !== null && _elementCaches$get !== void 0 ? _elementCaches$get : new Map();
    cacheForElement.set(value, result);
    $c36249007920e0ef$var$elementCaches.set(element, cacheForElement);
}
function $c36249007920e0ef$export$98721546d2816d9e(_ref3) {
    var value = _ref3.value, container = _ref3.container;
    if (typeof value === 'number') return value;
    // Fast path: unitless zero is universally zero pixels - accept `'0'` and
    // `'-0'` without a probe. (Consumers occasionally pass `'0'` instead of
    // the number `0`.)
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from the consumer normalisation
    // in `getPlacement`. Avoid a reflow when we can.
    var pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    var cached = $c36249007920e0ef$var$getCachedResolvedLength({
        element: container,
        value: value
    });
    if (cached !== null) return cached;
    var probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hide the probe from assistive tech and event targeting; defensive
    // against `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    container.appendChild(probe);
    var resolved = parseFloat(getComputedStyle(probe).marginLeft);
    container.removeChild(probe);
    var result = Number.isFinite(resolved) ? resolved : 0;
    $c36249007920e0ef$var$cacheResolvedLength({
        element: container,
        value: value,
        result: result
    });
    return result;
}



/**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 */ function $9d9ffbe9ab017b9f$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}


// `getPlacement` is intentionally NOT re-exported here - import it directly
// from `./resolve-placement` so search-and-jump lands at the source of truth.
/**
 * Module-scope no-op `ResizeObserver` used in non-DOM jest environments where
 * `ResizeObserver` is `undefined`. Hoisted out of the effect to avoid
 * allocating a new class declaration on every run.
 */ var $c8e983b72fe42760$var$NoopResizeObserver = /*#__PURE__*/ function() {
    function NoopResizeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoopResizeObserver);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoopResizeObserver, [
        {
            key: "observe",
            value: function observe() {}
        },
        {
            key: "unobserve",
            value: function unobserve() {}
        },
        {
            key: "disconnect",
            value: function disconnect() {}
        }
    ]);
}();
/**
 * Returns true when the popover is currently open. Wrapped because the
 * `:popover-open` pseudo-class is not implemented in some test environments
 * (e.g. jsdom), where `matches` throws on unknown selectors.
 */ function $c8e983b72fe42760$var$isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch (_unused) {
        return false;
    }
}
/**
 * Detects whether the browser supports CSS Anchor Positioning.
 * Uses `once()` for lazy evaluation: safe for SSR and avoids hydration mismatches.
 */ var $c8e983b72fe42760$var$supportsAnchorPositioning = (0, $e1dfa0095d7eba10$export$2e2bcd8739ae039)(function() {
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('anchor-name', '--a');
});
/**
 * Returns the CSS margin declaration that creates a gap between the
 * popover and its trigger on the side facing the anchor.
 *
 * For example, a `block-end` placement (popover below) gets
 * `margin-block-start: 8px` to push it away from the trigger's bottom edge.
 */ function $c8e983b72fe42760$var$edgeMargin(_ref) {
    var placement = _ref.placement, offset = _ref.offset;
    var axis = placement.axis, edge = placement.edge;
    var value = offset;
    if (axis === 'block' && edge === 'end') return {
        property: 'margin-block-start',
        value: value
    };
    if (axis === 'block' && edge === 'start') return {
        property: 'margin-block-end',
        value: value
    };
    if (axis === 'inline' && edge === 'end') return {
        property: 'margin-inline-start',
        value: value
    };
    if (axis === 'inline' && edge === 'start') return {
        property: 'margin-inline-end',
        value: value
    };
    return {
        property: 'margin-block-start',
        value: value
    };
}
/**
 * Cross-axis shift margin. Margin side matches the popover's anchored
 * cross-axis edge: `align: 'start'` uses the START margin, `align: 'end'`
 * uses the END margin with the sign inverted (so `forwards` is always
 * positive), `align: 'center'` uses START. Margin on the un-anchored side
 * has no effect under CSS Anchor Positioning.
 */ function $c8e983b72fe42760$var$crossAxisShiftMargin(_ref2) {
    var placement = _ref2.placement, crossAxisShiftCssValue = _ref2.crossAxisShiftCssValue, direction = _ref2.direction;
    var axis = placement.axis, align = placement.align;
    var directionSign = direction === 'forwards' ? 1 : -1;
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    var useEndSide = align === 'end';
    var side = useEndSide ? 'end' : 'start';
    var sideSign = useEndSide ? -1 : 1;
    var finalSign = directionSign * sideSign;
    // Wrap any string in calc() with the sign factor. CSS handles the math.
    var value = finalSign === 1 ? crossAxisShiftCssValue : "calc(-1 * ".concat(crossAxisShiftCssValue, ")");
    return {
        property: "margin-".concat(crossAxis, "-").concat(side),
        value: value
    };
}
/**
 * Returns a referentially-stable, fully-resolved `TPlacement`. The memo is
 * keyed on the resolved primitive fields so a fresh inline `placement` object
 * (or undefined fields vs explicit defaults) does not produce a fresh result.
 */ function $c8e983b72fe42760$var$useStablePlacement(placement) {
    var resolved = (0, $96ffae146696b031$export$a9fe23cfa43a7b55)({
        placement: placement
    });
    var axis = resolved.axis;
    var edge = resolved.edge;
    var align = resolved.align;
    var gap = resolved.offset.gap;
    var shiftValue = resolved.offset.crossAxisShift.value;
    var shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuild inside the memo from primitive deps so the factory does not
    // close over the outer `resolved` reference and exhaustive-deps can verify.
    return (0, $5FkrB.useMemo)(function() {
        return {
            axis: axis,
            edge: edge,
            align: align,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        };
    }, [
        axis,
        edge,
        align,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $c8e983b72fe42760$export$56b02a1e583f953c(_ref3) {
    var anchorRef = _ref3.anchorRef, popoverRef = _ref3.popoverRef, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? {} : _ref3$placement, _ref3$forceFallbackPo = _ref3.forceFallbackPositioning, forceFallbackPositioning = _ref3$forceFallbackPo === void 0 ? false : _ref3$forceFallbackPo, _ref3$isEnabled = _ref3.isEnabled, isEnabled = _ref3$isEnabled === void 0 ? true : _ref3$isEnabled, isOpen = _ref3.isOpen;
    var id = (0, $5FkrB.useId)();
    var stablePlacement = $c8e983b72fe42760$var$useStablePlacement(placement);
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!isEnabled) return;
        var trigger = anchorRef.current;
        var popover = popoverRef.current;
        if (!trigger || !popover) return;
        var gapCssValue = stablePlacement.offset.gap;
        var crossAxisShiftCssValue = stablePlacement.offset.crossAxisShift.value;
        var shouldForceFallback = Boolean(forceFallbackPositioning);
        if ($c8e983b72fe42760$var$supportsAnchorPositioning() && !shouldForceFallback) {
            // Reuse an existing `anchor-name` if the element already has one.
            // Another popover might already be anchored to the old name.
            var anchorName = trigger.style.getPropertyValue('anchor-name') || "--anchor-".concat(id.replace(/:/g, ''));
            var gap = $c8e983b72fe42760$var$edgeMargin({
                placement: stablePlacement,
                offset: gapCssValue
            });
            // Computed once; reused below to populate the active
            // `--ds-cross-axis-shift-margin-*` custom property for the
            // named arrow @position-try rules.
            var crossAxisShift = $c8e983b72fe42760$var$crossAxisShiftMargin({
                placement: stablePlacement,
                crossAxisShiftCssValue: crossAxisShiftCssValue,
                direction: stablePlacement.offset.crossAxisShift.direction
            });
            var popoverStyles = [
                {
                    property: 'position-anchor',
                    value: anchorName
                },
                {
                    property: 'position-area',
                    value: (0, $973a4c643893e337$export$de49b61f233ddeb9)({
                        placement: stablePlacement
                    })
                },
                {
                    property: 'position-try-fallbacks',
                    value: (0, $48038b8d3ed312ed$export$c4e16947a95d61f1)({
                        placement: stablePlacement
                    })
                },
                // Reset browser default popover positioning that conflicts
                // with anchor positioning (UA: `inset: 0; margin: auto;`)
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                },
                {
                    property: gap.property,
                    value: gap.value
                },
                {
                    property: crossAxisShift.property,
                    value: crossAxisShift.value
                }
            ];
            // Expose the active cross-axis shift via custom properties so each
            // named arrow @position-try rule can re-apply it after a flip.
            // One of the four (cross-axis, side) properties is non-zero at a time.
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-start',
                value: '0px'
            });
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-end',
                value: '0px'
            });
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-block-start',
                value: '0px'
            });
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-block-end',
                value: '0px'
            });
            // `crossAxisShift` IS the active margin; reuse instead of recomputing.
            var crossAxisShiftActive = crossAxisShift;
            var customPropertyByMarginProperty = {
                'margin-inline-start': '--ds-cross-axis-shift-margin-start',
                'margin-inline-end': '--ds-cross-axis-shift-margin-end',
                'margin-block-start': '--ds-cross-axis-shift-margin-block-start',
                'margin-block-end': '--ds-cross-axis-shift-margin-block-end'
            };
            var crossAxisShiftCustomProperty = customPropertyByMarginProperty[crossAxisShiftActive.property];
            if (crossAxisShiftCustomProperty) popoverStyles.push({
                property: crossAxisShiftCustomProperty,
                value: crossAxisShiftActive.value
            });
            /**
       * **We are never cleaning up anchor names**
       *
       * _Rationale_
       *
       * - Multiple popovers can share the same anchor element.
       * - Sometimes the `useAnchorPosition` hook and `Popover`
       *   are not in the same component.
       * - There can be times when, even with reference counting, we
       *   could remove the anchor-name while it is still being used
       *   by something else - especially with async react updates
       *   which can cause tearing
       *
       * _More_
       *
       * See `notes/decisions/anchor-name-lifetime.md`
       */ trigger.style.setProperty('anchor-name', anchorName);
            var _undoPositioning = (0, $bc3631763f508f95$export$1be1fc439b849fdf)((0, $9d9ffbe9ab017b9f$export$37a5fde709c1db82)({
                element: popover,
                styles: popoverStyles
            }));
            return _undoPositioning;
        }
        // JS fallback. The popover is already in the top layer via
        // popover="auto", so we only reset UA defaults and set top/left
        // based on measurements.
        var cleanupBaseStyles = (0, $9d9ffbe9ab017b9f$export$37a5fde709c1db82)({
            element: popover,
            styles: [
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                }
            ]
        });
        function update() {
            if (!trigger || !popover) return;
            var triggerRect = trigger.getBoundingClientRect();
            var viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            // Resolve consumer-supplied CSS length strings (tokens, calc, var,
            // px, rem, etc) to pixels. The probe is mounted INSIDE the popover
            // itself so the resolved length matches the scope a token would
            // resolve against from inside the popover content. (The popover
            // lives in the top layer, not the trigger's DOM tree, so probing
            // at `popover.parentElement` would resolve in a different scope
            // than the consumer's token authoring expects.)
            var gapPx = (0, $c36249007920e0ef$export$98721546d2816d9e)({
                value: gapCssValue,
                container: popover
            });
            var crossAxisShiftPx = (0, $c36249007920e0ef$export$98721546d2816d9e)({
                value: crossAxisShiftCssValue,
                container: popover
            });
            var _computeFallbackPosit = (0, $21bf418588e5e15a$export$d5ef1dac02135664)({
                triggerRect: triggerRect,
                popoverEl: popover,
                placement: stablePlacement,
                viewport: viewport,
                gap: gapPx,
                crossAxisShift: {
                    value: crossAxisShiftPx,
                    direction: stablePlacement.offset.crossAxisShift.direction
                }
            }), top = _computeFallbackPosit.top, left = _computeFallbackPosit.left;
            popover.style.setProperty('top', "".concat(top, "px"));
            popover.style.setProperty('left', "".concat(left, "px"));
            // Reveal the popover only after it has been positioned.
            // See the toggle listener below for why we hide on open.
            popover.style.removeProperty('opacity');
        }
        // Throttle scroll/resize updates to one per animation frame
        var scheduledUpdate = (0, $45Zis.default)(update);
        // Wait for the FIRST valid layout before measuring: the popover
        // is `display: none` until `showPopover()`, and some browsers
        // fire `toggle` before layout, so RAF-after-toggle is unreliable.
        // ResizeObserver fires once the browser has real dimensions.
        // Self-disconnects after one valid measurement; ongoing
        // scroll/resize is handled by the window listeners below.
        // `ResizeObserver` is missing in some non-DOM jest environments
        // (e.g. post-office's `node` environment). Fall back to a no-op
        // observer there. The scroll/resize listeners below still keep
        // the popover positioned in the rare case the consumer also
        // polyfilled `showPopover` but not `ResizeObserver`. Real
        // browsers always have it. The `NoopResizeObserver` class is
        // hoisted to module scope (see top of file) so we do not allocate
        // a new constructor on every effect run.
        var ResizeObserverImpl = typeof ResizeObserver !== 'undefined' ? ResizeObserver : $c8e983b72fe42760$var$NoopResizeObserver;
        var resizeObserver = new ResizeObserverImpl(function() {
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                update();
                resizeObserver.disconnect();
            }
        });
        // If the popover is already open by the time this effect runs (for
        // example, the parent `useAnchorPosition` effect runs after the child
        // `Popover` effect that called `showPopover()`), the initial `toggle`
        // event has already fired and our listener below would miss it. Start
        // observing immediately so the first measurement still happens.
        if ($c8e983b72fe42760$var$isPopoverOpen(popover)) {
            popover.style.setProperty('opacity', '0');
            resizeObserver.observe(popover);
        }
        var undoPositioning = (0, $bc3631763f508f95$export$1be1fc439b849fdf)(cleanupBaseStyles, // On every open: hide synchronously so the user never sees
        // the UA-default position, then re-observe for a fresh
        // measurement. We use `opacity: 0` rather than
        // `visibility: hidden` because Firefox skips visibility-hidden
        // elements during `<dialog>` initial-focus traversal. See
        // `form-in-popup.spec.tsx` on `desktop-firefox`.
        (0, $7QpUe.bind)(popover, {
            type: 'toggle',
            listener: function listener(event) {
                var toggleEvent = event;
                if (toggleEvent.newState === 'open') {
                    popover.style.setProperty('opacity', '0');
                    resizeObserver.observe(popover);
                }
            }
        }), function() {
            return resizeObserver.disconnect();
        }, (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: scheduledUpdate,
            options: {
                capture: true,
                passive: true
            }
        }), (0, $7QpUe.bind)(window, {
            type: 'resize',
            listener: scheduledUpdate,
            options: {
                passive: true
            }
        }), function() {
            scheduledUpdate.cancel();
            popover.style.removeProperty('top');
            popover.style.removeProperty('left');
            popover.style.removeProperty('opacity');
        });
        return undoPositioning;
    }, [
        anchorRef,
        popoverRef,
        stablePlacement,
        forceFallbackPositioning,
        isEnabled,
        id,
        isOpen
    ]);
}



var $5FkrB = parcelRequire("5FkrB");

/**
 * A point in viewport coordinates (CSS pixels) at which the synthetic
 * anchor should be placed.
 *
 * Axis-named (`x`/`y`) rather than edge-named (`left`/`top`) so the
 * shape is unambiguous in RTL writing modes - there is no ambiguity
 * about whether a coordinate is logical (`inline-start`/`block-start`)
 * or physical (`left`/`top`). Viewport coordinates are always
 * physical, so we name them with the physical axis labels.
 */ /**
 * Styles the synthetic anchor as an invisible, zero-size point.
 * Dynamic `inset-*` overrides are written by the positioning effect.
 *
 * Uses `Object.assign` rather than Compiled CSS (element is outside the React tree)
 * or the internal `setStyle` helper (we own this element entirely - it is created
 * and removed by this hook - so the snapshot/restore semantics `setStyle`
 * provides for caller-owned elements would be dead work here).
 */ function $0eeca89ed7744b85$var$applyStaticAnchorStyles(element) {
    Object.assign(element.style, {
        position: 'fixed',
        // `top`/`left` rather than `inset-block-start`/`inset-inline-start`
        // for consistency with the dynamic positioning effect below, which
        // uses physical properties (see comment there for the rationale).
        top: '0',
        left: '0',
        // Zero size - placement decides which side the popover sits on.
        width: '0',
        height: '0',
        // Prevent the overlay from intercepting pointer events.
        pointerEvents: 'none'
    });
}
function $0eeca89ed7744b85$export$6f230729189a5b8a(_ref) {
    var popoverRef = _ref.popoverRef, placement = _ref.placement, getPoint = _ref.getPoint, _ref$isEnabled = _ref.isEnabled, isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled, isOpen = _ref.isOpen;
    var syntheticAnchorRef = (0, $5FkrB.useRef)(null);
    // `getPoint` is kept in a ref so the layout effect can call the
    // latest version without listing it as a dep - that would re-fire
    // on every render and re-latch the point.
    var getPointRef = (0, $5FkrB.useRef)(getPoint);
    getPointRef.current = getPoint;
    // Lazy element creation: the `<div>` is only created when both
    // `isEnabled` is true AND `getPoint()` returns a non-null point.
    // `useLayoutEffect` ensures the element exists before the inner
    // `useAnchorPosition` (also a layout effect) reads the ref.
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!isEnabled) return;
        var point = getPointRef.current();
        if (!point) return;
        var anchor = document.createElement('div');
        anchor.setAttribute('aria-hidden', 'true');
        $0eeca89ed7744b85$var$applyStaticAnchorStyles(anchor);
        // `point.x`/`y` are physical viewport coordinates (from
        // `MouseEvent.clientX/Y`), so map directly onto physical
        // `left`/`top`. This is RTL-safe: `position: fixed` + physical
        // insets is direction-independent. Using logical
        // `inset-inline-start` would need `viewportWidth - point.x` in
        // RTL to land at the same physical pixel.
        anchor.style.top = "".concat(point.y, "px");
        anchor.style.left = "".concat(point.x, "px");
        document.body.appendChild(anchor);
        syntheticAnchorRef.current = anchor;
        return function cleanup() {
            anchor.remove();
            syntheticAnchorRef.current = null;
        };
    }, [
        isEnabled
    ]);
    // Mirror `isEnabled` so both hooks stay in sync - when disabled,
    // neither this hook nor the inner one touches the popover, leaving
    // any other positioning the consumer has set up free to take effect.
    (0, $c8e983b72fe42760$export$56b02a1e583f953c)({
        anchorRef: syntheticAnchorRef,
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: isEnabled,
        isOpen: isOpen
    });
}


/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $7QpUe = parcelRequire("7QpUe");
var $04c4752fbeced1ac$var$registrations = new Set();
var $04c4752fbeced1ac$var$cleanupEndEventListeners = null;
function $04c4752fbeced1ac$var$onDragStart() {
    if ($04c4752fbeced1ac$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $04c4752fbeced1ac$var$cleanupEndEventListeners = (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragend',
            listener: $04c4752fbeced1ac$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $04c4752fbeced1ac$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $04c4752fbeced1ac$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($04c4752fbeced1ac$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $04c4752fbeced1ac$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $04c4752fbeced1ac$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $04c4752fbeced1ac$var$cleanupEndEventListeners = null;
    var clone = Array.from($04c4752fbeced1ac$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $04c4752fbeced1ac$var$bindStartEvents() {
    return (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $04c4752fbeced1ac$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $04c4752fbeced1ac$var$onDragStart
        }
    ]);
}
var $04c4752fbeced1ac$var$cleanupStartEventListeners = null;
function $04c4752fbeced1ac$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$04c4752fbeced1ac$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $04c4752fbeced1ac$var$cleanupStartEventListeners = $04c4752fbeced1ac$var$bindStartEvents();
    $04c4752fbeced1ac$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $04c4752fbeced1ac$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $04c4752fbeced1ac$var$registrations.delete(registration);
        if ($04c4752fbeced1ac$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $04c4752fbeced1ac$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $04c4752fbeced1ac$var$cleanupStartEventListeners = null;
        }
    };
}


/**
 * Returns the trigger's X edge for inline-axis placements, or the
 * trigger's horizontal center for block-axis placements.
 *
 * Note: does not account for RTL writing modes.
 */ function $1b23cdb03137230b$var$getTriggerEdgeX(_ref) {
    var triggerRect = _ref.triggerRect, placement = _ref.placement;
    if (placement.axis === 'inline') return placement.edge === 'start' ? triggerRect.left : triggerRect.right;
    return triggerRect.left + triggerRect.width / 2;
}
/**
 * Returns the trigger's Y edge for block-axis placements, or the
 * trigger's vertical center for inline-axis placements.
 */ function $1b23cdb03137230b$var$getTriggerEdgeY(_ref2) {
    var triggerRect = _ref2.triggerRect, placement = _ref2.placement;
    if (placement.axis === 'block') return placement.edge === 'start' ? triggerRect.top : triggerRect.bottom;
    return triggerRect.top + triggerRect.height / 2;
}
function $1b23cdb03137230b$export$d26fd3d066ede49(_ref3) {
    var cursor = _ref3.cursor, triggerRect = _ref3.triggerRect, tooltipPosition = _ref3.tooltipPosition, placement = _ref3.placement;
    if (tooltipPosition === 'mouse-y') return {
        x: $1b23cdb03137230b$var$getTriggerEdgeX({
            triggerRect: triggerRect,
            placement: placement
        }),
        y: cursor.clientY
    };
    if (tooltipPosition === 'mouse-x') return {
        x: cursor.clientX,
        y: $1b23cdb03137230b$var$getTriggerEdgeY({
            triggerRect: triggerRect,
            placement: placement
        })
    };
    // tooltipPosition === 'mouse'
    return {
        x: cursor.clientX,
        y: cursor.clientY
    };
}


function $d6cf05203ccbf436$export$2e68479e0a5d8746(mousePos, _ref) {
    var targetElement = _ref.targetElement, tooltipPosition = _ref.tooltipPosition;
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            });
        }
    };
    var targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            });
        }
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            });
        }
    };
    throw new Error("Invalid tooltip position for virtual element: ".concat(tooltipPosition));
}



var $aptQa = parcelRequire("aptQa");
var $6e217632bbb5b2c1$var$delayId = null;
function $6e217632bbb5b2c1$var$clearScheduled() {
    if ($6e217632bbb5b2c1$var$delayId != null) {
        window.clearTimeout($6e217632bbb5b2c1$var$delayId);
        $6e217632bbb5b2c1$var$delayId = null;
    }
}
function $6e217632bbb5b2c1$var$scheduleTimeout(fn, delay) {
    $6e217632bbb5b2c1$var$clearScheduled();
    $6e217632bbb5b2c1$var$delayId = window.setTimeout(function() {
        $6e217632bbb5b2c1$var$delayId = null;
        fn();
    }, delay);
}
// This file is a singleton for managing tooltips.
//
// Once we roll out top-layer and remove the legacy path, this manager can be simplified:
// - Singleton: Can be removed; the platform (popover="auto" or popover="hint") already enforces
//   only one tooltip open at a time.
// - Phase machine: Can be simplified; drop hide-animating and finishHideAnimation (legacy fade-out).
//   Use e.g. pending-show | visible | pending-hide with immediate hide.
// - API: Can drop or simplify mousePosition/mousePos if no longer needed; keep delay scheduling,
//   keep(), requestHide, abort, and minimal lifecycle.
var $6e217632bbb5b2c1$var$active = null;
function $6e217632bbb5b2c1$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($6e217632bbb5b2c1$var$active && $6e217632bbb5b2c1$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            $6e217632bbb5b2c1$var$clearScheduled();
            $6e217632bbb5b2c1$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            $6e217632bbb5b2c1$var$clearScheduled();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            $6e217632bbb5b2c1$var$clearScheduled();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        // Bug in legacy path: isImmediate hide requests are ignored during waiting-to-hide,
        // meaning Escape/scroll won't instantly dismiss a tooltip that's already fading out.
        // Gated fix: only apply the immediate-hide behavior under the top-layer flag for now.
        if (phase === 'waiting-to-hide') {
            if (isImmediate && (0, $aptQa.fg)('platform-dst-top-layer')) immediatelyHideAndDone();
            return;
        }
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        $6e217632bbb5b2c1$var$scheduleTimeout(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function start() {
        var shouldAlwaysFadeIn = entry.shouldAlwaysFadeIn;
        var showImmediately = Boolean($6e217632bbb5b2c1$var$active && $6e217632bbb5b2c1$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($6e217632bbb5b2c1$var$active) {
            $6e217632bbb5b2c1$var$clearScheduled();
            $6e217632bbb5b2c1$var$active.entry.hide({
                isImmediate: true
            });
            $6e217632bbb5b2c1$var$active.entry.done();
            $6e217632bbb5b2c1$var$active = null;
        }
        // this tooltip is now the active tooltip
        $6e217632bbb5b2c1$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        $6e217632bbb5b2c1$var$scheduleTimeout(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePos: entry.source.type === 'mouse' ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}



function $bed487aeacce2154$export$6ee17796e3d70de2() {
    var uid = (0, $eae303b7f4b562de$export$f680877a34711e37)();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}


function $6671774545117937$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $bed487aeacce2154$export$6ee17796e3d70de2)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}


/* tooltip-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $eaf4ddf998a2f107$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
var $eaf4ddf998a2f107$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $120779d35fab2d6d$export$2e2bcd8739ae039)([
            $eaf4ddf998a2f107$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $5FkrB.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $120779d35fab2d6d$export$2e2bcd8739ae039)([
                $eaf4ddf998a2f107$var$styles.shortcutSegment
            ])
        }, segment);
    }));
};


var $76f42a71da83c271$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $76f42a71da83c271$var$TooltipPrimitive = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut, _ref$role = _ref.role, role = _ref$role === void 0 ? 'tooltip' : _ref$role;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        role: role,
        className: (0, $120779d35fab2d6d$export$2e2bcd8739ae039)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $5FkrB.createElement((0, $eaf4ddf998a2f107$export$5bcbc43c84236222), {
        shortcut: shortcut
    })));
});
$76f42a71da83c271$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $76f42a71da83c271$export$2e2bcd8739ae039 = $76f42a71da83c271$var$TooltipPrimitive;


var $1019c6f57b5eee75$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $1019c6f57b5eee75$var$TooltipContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut, role = _ref.role;
    return /*#__PURE__*/ $5FkrB.createElement((0, $76f42a71da83c271$export$2e2bcd8739ae039), {
        ref: ref,
        style: style,
        className: (0, $120779d35fab2d6d$export$2e2bcd8739ae039)([
            $1019c6f57b5eee75$var$styles.base,
            truncate && $1019c6f57b5eee75$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut,
        role: role
    }, children);
});
$1019c6f57b5eee75$var$TooltipContainer.displayName = 'TooltipContainer';
var $1019c6f57b5eee75$export$2e2bcd8739ae039 = $1019c6f57b5eee75$var$TooltipContainer;


function $a65c42b28ba16ee0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a65c42b28ba16ee0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a65c42b28ba16ee0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a65c42b28ba16ee0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a65c42b28ba16ee0$var$tooltipZIndex = (0, $c479ce88f4920702$export$7be255094ccdc533).tooltip();
var $a65c42b28ba16ee0$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "22.6.4"
};
// Inverts motion direction
var $a65c42b28ba16ee0$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $a65c42b28ba16ee0$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $a65c42b28ba16ee0$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $1019c6f57b5eee75$export$2e2bcd8739ae039) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $f82efe3f8c5a6d15$export$2e2bcd8739ae039) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $f82efe3f8c5a6d15$export$2e2bcd8739ae039) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn, shortcut = _ref.shortcut, _ref$shouldAlwaysFade = _ref.shouldAlwaysFadeIn, shouldAlwaysFadeIn = _ref$shouldAlwaysFade === void 0 ? false : _ref$shouldAlwaysFade, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa;
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    var isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    var tooltipPosition = isMousePosition ? mousePosition : position;
    var onShowHandler = (0, $b7360aa377b666ff$export$1a04351537078b55)($a65c42b28ba16ee0$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $a65c42b28ba16ee0$var$analyticsAttributes));
    var onHideHandler = (0, $b7360aa377b666ff$export$1a04351537078b55)($a65c42b28ba16ee0$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $a65c42b28ba16ee0$var$analyticsAttributes));
    var apiRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $5FkrB.useRef)(null);
    var containerRef = (0, $5FkrB.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $5FkrB.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $d996c7f009c82235$export$2e2bcd8739ae039)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $d996c7f009c82235$export$2e2bcd8739ae039)(onShowHandler);
    var onHideHandlerStable = (0, $d996c7f009c82235$export$2e2bcd8739ae039)(onHideHandler);
    var delayStable = (0, $d996c7f009c82235$export$2e2bcd8739ae039)(delay);
    var canAppearStable = (0, $d996c7f009c82235$export$2e2bcd8739ae039)(canAppear);
    var hasCalledShowHandler = (0, $5FkrB.useRef)(false);
    var shouldAlwaysFadeInStable = (0, $d996c7f009c82235$export$2e2bcd8739ae039)(shouldAlwaysFadeIn);
    var start = (0, $5FkrB.useCallback)(function(api) {
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $5FkrB.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $5FkrB.useRef)(false);
    (0, $5FkrB.useEffect)(function() {
        return (0, $04c4752fbeced1ac$export$6503ec6e8aabbaf)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $5FkrB.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else if ((0, $aptQa.fg)('platform-dst-top-layer')) // Top-layer path: set state to 'top-layer-exit'. The component
                // stays mounted and Popover's isOpen prop transitions to
                // false, triggering the CSS exit animation internally.
                // finishHideAnimation is called after a brief delay matching
                // the CSS exit animation duration.
                setState('top-layer-exit');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: shouldAlwaysFadeInStable.current
        };
        var api = (0, $6e217632bbb5b2c1$export$57bf213be019eeb0)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    var hideTooltipOnEsc = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    // When using top-layer, popover="auto" handles Escape natively
    (0, $a1eb371a231d1787$export$2e2bcd8739ae039)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out' || state === 'top-layer-exit' || (0, $aptQa.fg)('platform-dst-top-layer')
    });
    // ── Top-layer exit animation lifecycle ──
    // When state is 'top-layer-exit', Popover's isOpen transitions to false and
    // the CSS exit animation plays. The Popover's built-in `transitionend`
    // detection (with timeout fallback) calls `onExitFinish` when the exit
    // animation completes, which triggers the tooltip-manager lifecycle
    // (finishHideAnimation → done → onHide, setState('hide'), cleanup).
    var handleExitFinish = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current3;
        (_apiRef$current3 = apiRef.current) === null || _apiRef$current3 === void 0 || _apiRef$current3.finishHideAnimation();
    }, []);
    (0, $5FkrB.useEffect)(function() {
        if (state === 'hide') return 0, $f82efe3f8c5a6d15$export$2e2bcd8739ae039;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = isMousePosition ? {
            type: 'mouse',
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = isMousePosition ? function(event) {
        var _apiRef$current4;
        if ((_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.isActive()) apiRef.current.mousePos = {
            clientX: event.clientX,
            clientY: event.clientY
        };
    } : undefined;
    var onMouseOverTooltip = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $5FkrB.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (_unused) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $5FkrB.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out' && state !== 'top-layer-exit';
    var handleOpenLayerObserverCloseSignal = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current5;
        (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 || _apiRef$current5.requestHide({
            isImmediate: true
        });
    }, []);
    // On the top-layer path, the Popover primitive (used by TopLayerTooltipPopup)
    // registers with the observer directly, so we skip registration here to
    // avoid double-counting.
    // Safe conditional hook: feature flags are resolved once at startup.
    if (!(0, $aptQa.fg)('platform-dst-top-layer')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3a27eaabd1216a32$export$469bb693f11edc7f)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
       * We don't strictly need to provide an onClose callback at this time, as there is
       * already code that handles hiding the tooltip when a drag is started (and the only
       * usage right now is closing all layers when the user resizes the side nav).
       *
       * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
       * whenever the open layer observer requests a close.
       */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current6;
        if (isMousePosition && (_apiRef$current6 = apiRef.current) !== null && _apiRef$current6 !== void 0 && _apiRef$current6.mousePos && targetRef.current) return (0, $d6cf05203ccbf436$export$2e68479e0a5d8746)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $6671774545117937$export$2e2bcd8739ae039)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $5FkrB.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    var PopperWrapper = shouldRenderToParent ? (0, $5FkrB.Fragment) : $a65c42b28ba16ee0$var$TooltipPortal;
    var trigger = typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children($a65c42b28ba16ee0$var$_objectSpread($a65c42b28ba16ee0$var$_objectSpread($a65c42b28ba16ee0$var$_objectSpread({}, tooltipTriggerProps), testId ? {
        testId: "".concat(testId, "--container")
    } : {}), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, tooltipTriggerProps, testId ? {
        'data-testid': "".concat(testId, "--container")
    } : undefined, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent);
    if ((0, $aptQa.fg)('platform-dst-top-layer')) {
        var _apiRef$current$mouse, _apiRef$current7;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, trigger, shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($a65c42b28ba16ee0$var$TopLayerTooltipPopup, {
            targetRef: targetRef,
            tooltipPosition: tooltipPosition,
            mousePos: (_apiRef$current$mouse = (_apiRef$current7 = apiRef.current) === null || _apiRef$current7 === void 0 ? void 0 : _apiRef$current7.mousePos) !== null && _apiRef$current$mouse !== void 0 ? _apiRef$current$mouse : undefined,
            position: position,
            onMouseOut: onMouseOut,
            onMouseOverTooltip: onMouseOverTooltip,
            ignoreTooltipPointerEvents: ignoreTooltipPointerEvents,
            truncate: truncate,
            testId: testId,
            shortcut: shortcut,
            content: content,
            Container: Container,
            onClose: function onClose() {
                var _apiRef$current8;
                return (_apiRef$current8 = apiRef.current) === null || _apiRef$current8 === void 0 ? void 0 : _apiRef$current8.requestHide({
                    isImmediate: true
                });
            },
            onExitFinish: handleExitFinish,
            isOpen: state !== 'hide' && state !== 'top-layer-exit'
        }) : null);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, trigger, shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(PopperWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d5619142005425dd$export$badac9ada3a0bdf9), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        var direction = isMousePosition ? undefined : $a65c42b28ba16ee0$var$invertedDirection[$a65c42b28ba16ee0$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0fe6287c12490552$export$2e2bcd8739ae039), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c6ef6bab38bd84d5$export$2e2bcd8739ae039), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $a65c42b28ba16ee0$var$_objectSpread($a65c42b28ba16ee0$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $a65c42b28ba16ee0$export$2e2bcd8739ae039 = $a65c42b28ba16ee0$var$Tooltip;
var $a65c42b28ba16ee0$var$TooltipPortal = function TooltipPortal(_ref7) {
    var children = _ref7.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d0ccb0b9f3b651c8$export$2e2bcd8739ae039), {
        zIndex: $a65c42b28ba16ee0$var$tooltipZIndex
    }, children);
};
// Module-level preset instance, stable reference, no re-allocation per render.
// Non-mouse tooltips slide in from the direction of the trigger — slide + fade.
var $a65c42b28ba16ee0$var$tooltipAnimation = (0, $25ece2499e65f081$export$635cc6747ac6ffe0)();
// Mouse-position tooltips follow the cursor and have no fixed direction — fade only.
var $a65c42b28ba16ee0$var$tooltipMouseAnimation = (0, $25ece2499e65f081$export$cbea29d068a2e18f)();
/**
 * Top-layer tooltip popup component.
 *
 * Composes `Popover` (top-layer visibility + animation) with one of two
 * positioning hooks:
 *
 *   - `useAnchorPositionAtPoint` — for cursor-tracking positions
 *     (`mouse`, `mouse-x`, `mouse-y`) when a cursor position is
 *     available (i.e. the popup was activated by a pointer). Positions
 *     the popover relative to a hidden synthetic anchor that follows
 *     the cursor according to the `position` / `mousePosition`
 *     semantics. The synthetic anchor element is rendered as a sibling
 *     of the popover.
 *   - `useAnchorPosition` directly — for non-cursor positions, AND
 *     for cursor positions activated via keyboard focus (where there
 *     is no cursor to track). Anchoring directly to the trigger keeps
 *     keyboard-activated tooltips correctly placed next to the target
 *     instead of rendering in the top-left of the viewport.
 *
 * Exactly one positioning strategy is active at a time: `useAnchorPosition`
 * is wired to the trigger only when the mouse strategy is inactive, and
 * `useAnchorPositionAtPoint` is told `isActive: false` when the direct
 * anchor strategy is active. The other hook is still called (Rules of
 * Hooks) but does no work.
 *
 * Exit animation is handled by `Popover`'s `isOpen` prop. When `isOpen`
 * transitions to `false`, the primitive calls `hidePopover()` internally and
 * the CSS exit animation plays via `allow-discrete`. No glue code needed.
 */ function $a65c42b28ba16ee0$var$TopLayerTooltipPopup(_ref8) {
    var targetRef = _ref8.targetRef, tooltipPosition = _ref8.tooltipPosition, mousePos = _ref8.mousePos, position = _ref8.position, onMouseOut = _ref8.onMouseOut, onMouseOverTooltip = _ref8.onMouseOverTooltip, ignoreTooltipPointerEvents = _ref8.ignoreTooltipPointerEvents, truncate = _ref8.truncate, testId = _ref8.testId, shortcut = _ref8.shortcut, content = _ref8.content, Container = _ref8.Container, onClose = _ref8.onClose, onExitFinish = _ref8.onExitFinish, isOpen = _ref8.isOpen;
    var popoverRef = (0, $5FkrB.useRef)(null);
    // Translate the legacy Popper-style placement string ("right",
    // "bottom-start", etc.) once and pass the same object to both hooks.
    var placement = (0, $0b6bd0d300639f6a$export$69e99ed50b2534c9)({
        legacy: tooltipPosition
    });
    var isMousePosition = position === 'mouse' || position === 'mouse-x' || position === 'mouse-y';
    var isMouseStrategyActive = isMousePosition && Boolean(mousePos);
    // Direct anchor strategy: anchors to the trigger element.
    // Disabled when the mouse strategy is active — both hooks writing
    // to the same popover would fight for positioning ownership.
    (0, $c8e983b72fe42760$export$56b02a1e583f953c)({
        anchorRef: targetRef,
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: !isMouseStrategyActive,
        isOpen: isOpen
    });
    // Mouse anchor strategy: the hook calls `getPoint()` exactly once
    // per activation and latches the resulting coordinate. The latch is
    // per-show because `TopLayerTooltipPopup` mounts fresh on every
    // show.
    //
    // `getPoint()` returns `null` for keyboard-activated shows (where
    // `mousePos` is undefined) or before the trigger has mounted —
    // leaving the direct strategy above to own positioning.
    //
    // SSR note: `getBoundingClientRect()` is only called here because
    // `TopLayerTooltipPopup` is gated behind client-only state
    // transitions.
    (0, $0eeca89ed7744b85$export$6f230729189a5b8a)({
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: isMouseStrategyActive,
        isOpen: isOpen,
        getPoint: function getPoint() {
            if (!mousePos || !targetRef.current || !isMousePosition) return null;
            return (0, $1b23cdb03137230b$export$d26fd3d066ede49)({
                cursor: mousePos,
                triggerRect: targetRef.current.getBoundingClientRect(),
                tooltipPosition: position,
                placement: placement
            });
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7af4023e0e9843ad$export$5b6b19405a83ff9d), {
        ref: popoverRef,
        role: "tooltip",
        mode: "hint",
        isOpen: isOpen,
        onClose: onClose,
        onExitFinish: onExitFinish,
        testId: testId ? "".concat(testId, "--popover") : undefined,
        animate: isMouseStrategyActive ? $a65c42b28ba16ee0$var$tooltipMouseAnimation : $a65c42b28ba16ee0$var$tooltipAnimation,
        placement: placement
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, {
        className: "Tooltip",
        style: ignoreTooltipPointerEvents ? {
            pointerEvents: 'none'
        } : undefined,
        truncate: truncate,
        placement: tooltipPosition,
        testId: testId,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOverTooltip,
        shortcut: shortcut,
        role: "presentation"
    }, typeof content === 'function' ? content({
        update: (0, $f82efe3f8c5a6d15$export$2e2bcd8739ae039)
    }) : content));
}






var $0c4c08ddec83e35f$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $0c4c08ddec83e35f$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $0c4c08ddec83e35f$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $0c4c08ddec83e35f$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $0c4c08ddec83e35f$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $11dd84bac22fa83e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $53ad6069579b4666$export$2e2bcd8739ae039), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a4b6b6a5fbbf2f99$export$2e2bcd8739ae039), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e3573d3717f44b5e$export$2e2bcd8739ae039), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a65c42b28ba16ee0$export$2e2bcd8739ae039), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        shortcut: tooltip === null || tooltip === void 0 ? void 0 : tooltip.shortcut
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $11dd84bac22fa83e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $d1a0e9749b65ff00$export$2e2bcd8739ae039)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $53ad6069579b4666$export$2e2bcd8739ae039), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a4b6b6a5fbbf2f99$export$2e2bcd8739ae039), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e3573d3717f44b5e$export$2e2bcd8739ae039), null, label)));
    });
}));
$0c4c08ddec83e35f$var$IconButton.displayName = 'IconButton';
var $0c4c08ddec83e35f$export$2e2bcd8739ae039 = $0c4c08ddec83e35f$var$IconButton;


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ced2179e9e0992ccb4af61b51b4f10a3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $461693459c687c45$var$ATOMIC_GROUP_LENGTH = 5;
function $461693459c687c45$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $461693459c687c45$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $9dOvm = parcelRequire("9dOvm");
var $d22060b1f1a38618$var$_process, $d22060b1f1a38618$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $d22060b1f1a38618$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($d22060b1f1a38618$var$_process = globalThis.process) === null || $d22060b1f1a38618$var$_process === void 0 || ($d22060b1f1a38618$var$_process = $d22060b1f1a38618$var$_process.env) === null || $d22060b1f1a38618$var$_process === void 0 ? void 0 : $d22060b1f1a38618$var$_process.JEST_WORKER_ID) !== undefined;
var $d22060b1f1a38618$var$DEBUG_MODE = !$d22060b1f1a38618$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($d22060b1f1a38618$var$_process2 = globalThis.process) === null || $d22060b1f1a38618$var$_process2 === void 0 || ($d22060b1f1a38618$var$_process2 = $d22060b1f1a38618$var$_process2.env) === null || $d22060b1f1a38618$var$_process2 === void 0 ? void 0 : $d22060b1f1a38618$var$_process2.NODE_ENV) !== 'production';
var $d22060b1f1a38618$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$d22060b1f1a38618$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $c114b75eae3b8f0a$var$pkgName = '@atlaskit/platform-feature-flags';
var $c114b75eae3b8f0a$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $c114b75eae3b8f0a$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $c114b75eae3b8f0a$var$ENV_ENABLE_PLATFORM_FF = $c114b75eae3b8f0a$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $c114b75eae3b8f0a$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $c114b75eae3b8f0a$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $c114b75eae3b8f0a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $c114b75eae3b8f0a$var$ENV_ENABLE_PLATFORM_FF || $c114b75eae3b8f0a$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $c114b75eae3b8f0a$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $c114b75eae3b8f0a$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$c114b75eae3b8f0a$var$globalVar[$c114b75eae3b8f0a$export$7e41b1b2bdee3f98] = $c114b75eae3b8f0a$var$globalVar[$c114b75eae3b8f0a$export$7e41b1b2bdee3f98] || $c114b75eae3b8f0a$var$DEFAULT_PFF_GLOBAL;
function $c114b75eae3b8f0a$export$f2b591175b3e424c(resolver) {
    $c114b75eae3b8f0a$var$globalVar[$c114b75eae3b8f0a$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $c114b75eae3b8f0a$export$6333b6aff9fc6275(flagKey) {
    if ($c114b75eae3b8f0a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $d22060b1f1a38618$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $c114b75eae3b8f0a$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $c114b75eae3b8f0a$var$globalVar[$c114b75eae3b8f0a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $c114b75eae3b8f0a$var$globalVar[$c114b75eae3b8f0a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $9dOvm.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $c114b75eae3b8f0a$var$globalVar[$c114b75eae3b8f0a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $b6ce737b04cf6b7e$export$ba05d765b8392e5e(flagResolver) {
    (0, $c114b75eae3b8f0a$export$f2b591175b3e424c)(flagResolver);
}
function $b6ce737b04cf6b7e$export$470e5c2be1411c89(name) {
    return (0, $c114b75eae3b8f0a$export$6333b6aff9fc6275)(name);
}
function $b6ce737b04cf6b7e$export$b40ec24ac8275656(name) {
    return (0, $c114b75eae3b8f0a$export$6333b6aff9fc6275)(name);
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $25nEq = parcelRequire("25nEq");
var $6bdb5e85ebbc6298$export$4ef52930e33717cd = 'data-theme';
var $6bdb5e85ebbc6298$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $6bdb5e85ebbc6298$export$a00eac3f8684bcd0 = 'data-color-mode';
var $6bdb5e85ebbc6298$export$2112803007239c61 = 'data-contrast-mode';
var $6bdb5e85ebbc6298$export$352e418ed5b6193a = 'data-custom-theme';
var $6bdb5e85ebbc6298$export$6f0c6fb8c80fcc92 = 'ds';
var $6bdb5e85ebbc6298$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $6bdb5e85ebbc6298$export$dddac1532e822863 = "--".concat($6bdb5e85ebbc6298$export$6f0c6fb8c80fcc92, "-token-not-found");
var $6bdb5e85ebbc6298$export$9d7b58831ae93caa = "--".concat($6bdb5e85ebbc6298$export$6f0c6fb8c80fcc92, "-elevation-surface-current");



var $80dcc87888308ce0$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ var $80dcc87888308ce0$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $80dcc87888308ce0$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $80dcc87888308ce0$var$themeOverrideIds = [];
var $80dcc87888308ce0$export$92ba366331403db2 = [].concat($80dcc87888308ce0$export$7d43e72a58e3283f, $80dcc87888308ce0$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $80dcc87888308ce0$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
/**
 * ThemeOptionsSchema: additional configuration options used to customize Atlassian's themes
 */ /**
 * ThemeState: the standard representation of an app's current theme and preferences
 */ /**
 * Can't evaluate typography feature flags at the module level,
 * it will always resolve to false when server side rendered or when flags are loaded async.
 */ function $80dcc87888308ce0$var$getShapeDefault() {
    if ((0, $b6ce737b04cf6b7e$export$b40ec24ac8275656)('platform-dst-shape-theme-default')) return 'shape';
    return undefined;
}
function $80dcc87888308ce0$var$getMotionDefault() {
    if ((0, $b6ce737b04cf6b7e$export$b40ec24ac8275656)('platform-dst-motion-theme-default')) return 'motion';
    return undefined;
}
var $80dcc87888308ce0$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: $80dcc87888308ce0$var$getShapeDefault,
    spacing: 'spacing',
    typography: 'typography',
    motion: $80dcc87888308ce0$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $80dcc87888308ce0$export$2e2bcd8739ae039 = $80dcc87888308ce0$var$themeConfig;



var $ekGgq = parcelRequire("ekGgq");

var $iYJcE = parcelRequire("iYJcE");

var $8c79c91c069af023$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $8c79c91c069af023$var$customThemeOptions = 'UNSAFE_themeOptions';
var $8c79c91c069af023$var$isThemeKind = function isThemeKind(themeKind) {
    return $8c79c91c069af023$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $8c79c91c069af023$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $80dcc87888308ce0$export$7d43e72a58e3283f).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $8c79c91c069af023$var$isColorMode = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
var $8c79c91c069af023$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && $8c79c91c069af023$var$isColorMode(id)) themeObject[kind] = id;
        if ($8c79c91c069af023$var$isThemeKind(kind) && $8c79c91c069af023$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $8c79c91c069af023$var$customThemeOptions) try {
            themeObject[$8c79c91c069af023$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
var $8c79c91c069af023$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $8c79c91c069af023$var$isColorMode(id) || // custom theme state
        kind === $8c79c91c069af023$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' || // other theme states
        $8c79c91c069af023$var$isThemeKind(kind) && typeof id === 'string' && $8c79c91c069af023$var$isThemeIds(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};


function $1fc4301ee09bc816$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1fc4301ee09bc816$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1fc4301ee09bc816$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1fc4301ee09bc816$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1fc4301ee09bc816$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $80dcc87888308ce0$export$83993de8eb66733).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $1fc4301ee09bc816$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $6bdb5e85ebbc6298$export$a00eac3f8684bcd0)) || '';
    var theme = element.getAttribute((0, $6bdb5e85ebbc6298$export$4ef52930e33717cd)) || '';
    return $1fc4301ee09bc816$var$_objectSpread($1fc4301ee09bc816$var$_objectSpread({}, (0, $8c79c91c069af023$export$f19b488f7c0547ee)(theme)), $1fc4301ee09bc816$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $1fc4301ee09bc816$export$2e2bcd8739ae039 = $1fc4301ee09bc816$var$getGlobalTheme;



var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");


/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $3303d62153a39d5f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $1fc4301ee09bc816$export$2e2bcd8739ae039)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $6bdb5e85ebbc6298$export$4ef52930e33717cd),
                            (0, $6bdb5e85ebbc6298$export$a00eac3f8684bcd0)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($3303d62153a39d5f$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($3303d62153a39d5f$export$2e2bcd8739ae039, "callbacks", new Set());


/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $fdb77cc968262235$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $5FkrB.useState)((0, $1fc4301ee09bc816$export$2e2bcd8739ae039)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        var observer = new (0, $3303d62153a39d5f$export$2e2bcd8739ae039)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $fdb77cc968262235$export$2e2bcd8739ae039 = $fdb77cc968262235$var$useThemeObserver;


var $05f9b20d45e480e2$var$styles = {
    root: "_1e0c1o8l",
    TEMP_assets: "_9aea1fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $05f9b20d45e480e2$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $05f9b20d45e480e2$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $05f9b20d45e480e2$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $05f9b20d45e480e2$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $05f9b20d45e480e2$var$rovoDarkAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $05f9b20d45e480e2$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ var $05f9b20d45e480e2$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl",
    '12': "_4t3i1crf",
    '16': "_4t3i7vkz",
    '20': "_4t3igktf",
    '24': "_4t3i1tcg",
    '32': "_4t3izwfg"
};
function $05f9b20d45e480e2$export$be58b4326e23250f(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? '20' : _ref$size, label = _ref.label, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, userDefinedTestId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, customIconColor = _ref.iconColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? 'tile' : _ref$type;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && customIconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $461693459c687c45$export$2e2bcd8739ae039)([
            $05f9b20d45e480e2$var$styles.root,
            $05f9b20d45e480e2$var$sizeMap[size],
            colorMode === 'dark' ? $05f9b20d45e480e2$var$dataCenterDarkAppearanceMap[appearance] : $05f9b20d45e480e2$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $05f9b20d45e480e2$var$rovoDarkAppearanceMap[appearance] : $05f9b20d45e480e2$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $05f9b20d45e480e2$var$cloudDarkAppearanceMap[appearance] : $05f9b20d45e480e2$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && (0, $b6ce737b04cf6b7e$export$b40ec24ac8275656)('assets-platform-branding') && $05f9b20d45e480e2$var$styles.TEMP_assets
        ])
    });
}


// `height` is set to 100% to allow the SVG to scale with the parent element
var $42816eed69858c8d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $42816eed69858c8d$export$ef8e5f836dd989d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $42816eed69858c8d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::58c9ee3b4e44f14aa5c8a2e33c7dac51>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");
/* logo-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
var $5FkrB = parcelRequire("5FkrB");



var $e5724170be447320$var$styles = {
    root: "_1e0c1o8l _vwz4idpf",
    TEMP_assets: "_9aea1fkg"
};
// These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
var $e5724170be447320$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
var $e5724170be447320$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $e5724170be447320$var$textLightAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1e01",
    inverse: "_1wycu67f",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $e5724170be447320$var$textDarkAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1gvk",
    inverse: "_1wyc5a6q",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $e5724170be447320$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $e5724170be447320$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $e5724170be447320$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $e5724170be447320$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $e5724170be447320$var$rovoDarkAppearanceMap = {
    brand: "_1703lrxy _1evoh727 _epb51yy8 _1osdxeun",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $e5724170be447320$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
function $e5724170be447320$export$f827d3c5a9c3f644(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$size = _ref.size, size = _ref$size === void 0 ? 'small' : _ref$size, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, label = _ref.label, userDefinedTestId = _ref.testId, customIconColor = _ref.iconColor, customTextColor = _ref.textColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? 'tile' : _ref$type;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-text-color': customTextColor || 'inherit'
        },
        "data-testid": testId,
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $461693459c687c45$export$2e2bcd8739ae039)([
            $e5724170be447320$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $e5724170be447320$var$logoTextColorMap[colorMode !== null && colorMode !== void 0 ? colorMode : 'light'],
            $e5724170be447320$var$sizeMap[size],
            colorMode === 'dark' ? $e5724170be447320$var$textDarkAppearanceMap[appearance] : $e5724170be447320$var$textLightAppearanceMap[appearance],
            colorMode === 'dark' ? $e5724170be447320$var$dataCenterDarkAppearanceMap[appearance] : $e5724170be447320$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $e5724170be447320$var$rovoDarkAppearanceMap[appearance] : $e5724170be447320$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $e5724170be447320$var$cloudDarkAppearanceMap[appearance] : $e5724170be447320$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && (0, $b6ce737b04cf6b7e$export$b40ec24ac8275656)('assets-platform-branding') && $e5724170be447320$var$styles.TEMP_assets
        ])
    });
}


// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $f75b13e9496c8aa2$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M124.84 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-20.15-10.4c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-14.07-8.52v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.85c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-22.02-4.01c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M13.826 6.4h4.255l1.338 3.569 3.76-.626 2.128 3.684-2.422 2.945 2.421 2.943L23.18 22.6l-3.76-.626-1.338 3.57h-4.255l-1.338-3.57-3.76.625L6.6 18.915l2.421-2.943L6.6 13.028l2.127-3.685 3.76.626zm2.128 13.16a3.59 3.59 0 1 0 0-7.178 3.59 3.59 0 0 0 0 7.179\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $f75b13e9496c8aa2$export$61afcb38c001e19(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $f75b13e9496c8aa2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9c308d558bb8f01b0a6c887a98e5347d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $ef02305e93d38cfe$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z\"/>\n</svg>\n";
function $ef02305e93d38cfe$export$70a0c2f5862937b6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $ef02305e93d38cfe$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d1c9f8765265019cd33e94ea5235515>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5407f49539ceea52$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M105.76 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-19.6 7.75v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52M68.73 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-2.54-.03c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM49.6 21.32c-1.53 0-3.1-.18-4.82-.52l-1.69 4.54H40l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.68 7.43 45.6 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M23.735 23.735c0-2.928-2.396-5.295-5.295-5.295h-4.88v-4.466H8.265v8.785c0 .68.296.976.976.976zM8.265 8.265c0 2.928 2.337 5.295 5.265 5.295h4.91v4.466h5.295V9.241q0-.976-.976-.976z\"/>\n</svg>\n";
function $5407f49539ceea52$export$8b5103382c06639c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $5407f49539ceea52$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5edf47443601d30b199c36fbcc7b1d7c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $483e4eae5b0896bb$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z\"/>\n</svg>\n";
function $483e4eae5b0896bb$export$af3460f51ce3602a(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $483e4eae5b0896bb$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::843c7beab94f5191123277c61cbca79e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $f74d50e4aa1d9379$var$svg = "<svg height=\"100%\" viewBox=\"0 0 161 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M160.66 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.6 1.41v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M129.13 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-7.46-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-14.12 3.77h-1.72L100.77 10h2.82l4.91 13.13L113.41 10h2.82l-5.8 14.84c-1.72 4.39-2.7 6.66-6.59 6.66-1.32 0-2.05-.12-2.82-.43V28.8c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.81m-7.8.94c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM79.5 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM74.1 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-24.66 4.97c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.5 7.83v12.25h4.08V7.83zM7.83 24.17h15.75v-2.33H7.83zm0-4.09v-6.42h4.08v6.42zm5.84-8.75v8.75h4.08v-8.75z\"/>\n</svg>\n";
function $f74d50e4aa1d9379$export$f0bac2b7ac3e3504(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $f74d50e4aa1d9379$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ef8f48b1d072b5b8a0869540d1f52a5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $8373c87ee8f07dfa$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z\"/>\n</svg>\n";
var $8373c87ee8f07dfa$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729\"/>\n</svg>\n";
function $8373c87ee8f07dfa$export$d89497e7f33ca6f5(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $8373c87ee8f07dfa$var$svg,
        customThemeSvg: $8373c87ee8f07dfa$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e04e8bc884193d0eee2f110efb35733>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $bcf55440e1ac49e3$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M125.8 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.77-.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.5c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.13-3.56c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63-.01c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-22.22.15c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M11.667 15.425a4.335 4.335 0 0 0 3.758-3.758h2.742V9.5h-3.023A4.335 4.335 0 1 0 9.5 15.144v3.023h2.167zm-.542-2.675a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M24.67 10.58a2.71 2.71 0 1 1-5.42 0 2.71 2.71 0 0 1 5.42 0M10.58 24.67a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m11.38 0a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m-3.79-3.79h-3.79v2.17h3.79zm2.71-6.5v3.79h2.17v-3.79z\"/>\n</svg>\n";
function $bcf55440e1ac49e3$export$81c47abe19675c4c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $bcf55440e1ac49e3$var$svg,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::74f0ca66b8bc3995f7a9817f08a67d6f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $9e5a8315f2f6dca2$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z\"/>\n</svg>\n";
function $9e5a8315f2f6dca2$export$e812398311cab9a3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $9e5a8315f2f6dca2$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5436ab9ea17c11b656095d6ae713006c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $3a004855a7d196e5$var$svg = "<svg height=\"100%\" viewBox=\"0 0 154 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M146 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-16.68 13.49c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-12.07 5.52c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-21.58-8.82v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.23-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M12.287 16.869a3.665 3.665 0 0 0 3.665 3.656v5.607c-4.71 0-8.602-3.52-9.196-8.06zm12.347 0a.584.584 0 0 1 .581.624c-.295 4.415-3.71 7.986-8.057 8.554l-1.206-5.521a3.67 3.67 0 0 0 3.63-3.161.59.59 0 0 1 .589-.496zm-8.683-3.656a3.664 3.664 0 0 0-3.665 3.656h-5.62v-.088c.044-4.66 3.557-8.498 8.078-9.088zm0-7.964a.58.58 0 0 1 .96-.44l6.432 5.518c.27.232.27.65 0 .883l-6.431 5.517a.581.581 0 0 1-.96-.44z\"/>\n</svg>\n";
function $3a004855a7d196e5$export$7c51958462d750e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $3a004855a7d196e5$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83bd991a11895fc697ec86ba4d2d82c2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $0f19a71cf5ef3443$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582\"/>\n</svg>\n";
var $0f19a71cf5ef3443$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z\"/>\n</svg>\n";
function $0f19a71cf5ef3443$export$5fc1066e677788d4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $0f19a71cf5ef3443$var$svg,
        customThemeSvg: $0f19a71cf5ef3443$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7131ffd6f745f530e9a82fe4842b6a8c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e971c6946cb1c8ba$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.4-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.17-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.27 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.69 5.43z\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.029.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.572 0 .743.285.657.771\"/>\n</svg>\n";
function $e971c6946cb1c8ba$export$f7ef5e5488e4b430(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $e971c6946cb1c8ba$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61dd349b817df11b196de45b8945fcdf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $ec366d15f1e808c3$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m17.843 11.763-.986 6.024c-.065.365-.322.58-.686.58H7.81c-.365 0-.622-.215-.686-.58L5.387 7.047c-.064-.364.129-.6.472-.6h12.262c.343 0 .536.236.472.6l-.472 2.83c-.064.407-.3.579-.686.579h-7.374c-.107 0-.172.064-.15.193l.579 3.558c.021.086.085.15.171.15h2.658c.086 0 .15-.064.172-.15l.407-2.572c.043-.322.257-.45.558-.45h2.894c.428 0 .557.214.493.578\"/>\n</svg>\n";
function $ec366d15f1e808c3$export$d3ab16bbf4f954ee(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $ec366d15f1e808c3$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::68c2bbf4fd6874e93c78c51b9065dc7c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $c4ad96900069ac69$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.85-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.39-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.028.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.571 0 .743.285.657.771\"/>\n</svg>\n";
function $c4ad96900069ac69$export$cc55e2a4c4b40552(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $c4ad96900069ac69$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a833c6410fabd244b1134a630f9a005>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $ed33621c770c8f6f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.125 16.5h8.125V6H5.75v13zM12 12.125a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75m4-.875a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0m-7.125.875a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $ed33621c770c8f6f$export$52cd484a7ef4f2b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $ed33621c770c8f6f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b3a55f079b563dca3c91045ce0a761dc>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $422e6573ccf128d4$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.65m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M24.167 21.834h-10.5l-5.833 3.5v-17.5h16.333zm-12.25-5.833a1.167 1.167 0 1 0 0-2.334 1.167 1.167 0 0 0 0 2.334M16 16a1.167 1.167 0 1 0 0-2.334A1.167 1.167 0 0 0 16 16m5.25-1.167a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.333 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $422e6573ccf128d4$export$a529e78951cd6709(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $422e6573ccf128d4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ad5b8ef64559dc5207c779379dec44c9>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $7712961585b3c6e3$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M18.563 16.688h-8.438L5.438 19.5V5.438h13.125zm-6.83-9.375-.255.647c-.362.92-.543 1.38-.878 1.727-.334.346-.787.543-1.694.938l-.388.17v.535l.388.17c.907.394 1.36.592 1.694.938.335.346.516.807.878 1.727l.255.648h.535l.255-.648c.362-.92.543-1.38.877-1.727.335-.346.788-.544 1.694-.939l.388-.169v-.535l-.388-.17c-.906-.395-1.36-.592-1.694-.938-.334-.347-.515-.807-.877-1.727l-.255-.647z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $7712961585b3c6e3$export$402a257da320c93c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $7712961585b3c6e3$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1eb74baaf9574600817f9bd5473029df>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $eed89fab9307a98b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.95c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M24.75 22.25H13.5L7.25 26V7.25h17.5zm-9.107-12.5-.34.864c-.482 1.226-.724 1.84-1.17 2.302s-1.05.725-2.258 1.251l-.518.226v.714l.518.226c1.209.526 1.813.79 2.259 1.251.445.462.687 1.076 1.17 2.303l.34.863h.714l.34-.864c.482-1.227.724-1.84 1.17-2.302s1.049-.725 2.258-1.251l.517-.226v-.714l-.517-.226c-1.21-.526-1.813-.79-2.259-1.251-.445-.462-.687-1.075-1.17-2.302l-.34-.864z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $eed89fab9307a98b$export$a3af32a9109d706d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $eed89fab9307a98b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5ce5248a23a237688e2341559569305>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $391da3670ec5c41a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z\"/>\n</svg>\n";
function $391da3670ec5c41a$export$f7857fe64d7161d9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $391da3670ec5c41a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbcc7f43e0a51fb6caa253b27359fb22>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a1c2d8d9a6d45234$var$svg = "<svg height=\"100%\" viewBox=\"0 0 162 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.79 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63 0c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-25.9-3.49c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01v-2.7h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97M89.5 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.83c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.69 15.16v4.24h-4.25v-4.24zv-4.24H8.93a.74.74 0 0 0-.74.74v11.25a.74.74 0 0 0 .74.75h11.26a.74.74 0 0 0 .75-.74v-7.76zm0-8.48v4.24h4.26v4.24h4.24V7.42a.74.74 0 0 0-.73-.75h-.01z\"/>\n</svg>\n";
function $a1c2d8d9a6d45234$export$a16f50a81d183ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $a1c2d8d9a6d45234$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2264fa822c5f74cedf4229a8911c73b4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $2f121db3d400a7f2$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673\"/>\n</svg>\n";
var $2f121db3d400a7f2$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135\"/>\n</svg>\n";
function $2f121db3d400a7f2$export$68f3db7f6af48bcb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $2f121db3d400a7f2$var$svg,
        customThemeSvg: $2f121db3d400a7f2$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90f8012e577da50adfff14718da1e4b3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $0b415cb06590d81b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.51-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.24 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.442 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.083.302.388.494l3.135 1.948c.167.11.305.165.444.165.166 0 .277-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.692.22 2.83.768l3.273 1.537c.333.165.693.083.86-.302l1.553-3.403c.167-.384.056-.63-.333-.823M8.761 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.305-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.691 8.29c-.167-.11-.306-.165-.444-.165-.167 0-.278.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.693-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302l-1.554 3.403c-.166.384-.055.63.333.823\"/>\n</svg>\n";
function $0b415cb06590d81b$export$a88b0b0da9ef63ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $0b415cb06590d81b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::daf8acf7c1707ab5f837689f4e92f4a5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $cdf91bfd5129c5de$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617\"/>\n</svg>\n";
function $cdf91bfd5129c5de$export$53305f1f2855d3be(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $cdf91bfd5129c5de$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86f2cdcf615e24dd3ad3f9b48bca5bf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $663307540044c66a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.5-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.23 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.2-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.441 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.084.302.389.494l3.134 1.948c.167.11.306.165.444.165.167 0 .278-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.693.22 2.83.768l3.273 1.537c.333.165.694.083.86-.302l1.554-3.403c.166-.384.055-.63-.333-.823M8.762 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.306-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.69 8.29c-.167-.11-.305-.165-.444-.165-.166 0-.277.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.692-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302L8.43 12.187c-.167.384-.056.63.332.823\"/>\n</svg>\n";
function $663307540044c66a$export$b3e508cb103e1f93(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $663307540044c66a$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9928c9b96accda0f9234a11fc7ddaca0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $7bcc6b150a03baab$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.71 7.463 12 4.993l-6.71 2.47a.44.44 0 0 0-.29.433l.14 3.807c.103 3.148 1.684 5.489 4.163 7.018a.446.446 0 0 0 .646-.204l1.445-3.412a.22.22 0 0 0-.14-.298 2.585 2.585 0 1 1 1.492 0 .22.22 0 0 0-.14.298l1.446 3.412a.446.446 0 0 0 .645.204c2.48-1.529 4.06-3.87 4.163-7.018L19 7.896a.44.44 0 0 0-.29-.433\"/>\n</svg>\n";
function $7bcc6b150a03baab$export$eaf73f391f7103bd(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $7bcc6b150a03baab$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::206fa44ab9c6427ebeb6aaad7e53b58f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $cabff14b4a4d22c8$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.97 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.72 0h-3.37l-2.64-7.42-1.41-4.72-1.41 4.72-2.64 7.42h-3.37L84.45 10h2.91l4.42 13 4.48-13h2.51l4.48 13 4.41-13h2.91zm-28.47.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.77 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-5.76 5.48v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M24.946 9.951 16 6.657 7.054 9.95a.59.59 0 0 0-.387.577l.187 5.076c.137 4.197 2.245 7.319 5.55 9.357.31.19.719.063.86-.272l1.928-4.55a.294.294 0 0 0-.185-.396 3.447 3.447 0 1 1 1.987 0 .294.294 0 0 0-.185.397l1.927 4.549c.142.335.55.463.86.272 3.305-2.038 5.413-5.16 5.55-9.357l.187-5.076a.59.59 0 0 0-.387-.577\"/>\n</svg>\n";
function $cabff14b4a4d22c8$export$3c371bdbcdfcdce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $cabff14b4a4d22c8$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2cbaafcea60527c20df8d8395e491b95>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $d29a2f476ea23fcc$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z\"/>\n</svg>\n";
var $d29a2f476ea23fcc$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5\"/>\n</svg>\n";
function $d29a2f476ea23fcc$export$6da5aa77c402ba0f(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $d29a2f476ea23fcc$var$svg,
        customThemeSvg: $d29a2f476ea23fcc$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b7476897879e097648c054d2783409e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $501906e2812827da$var$svg = "<svg height=\"100%\" viewBox=\"0 0 456 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M451.86 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.08-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.51-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M234.91 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.24 0h-3.53L217.69 10h2.76l4.97 13.09L230.36 10h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.65 2.45 6.65 6.07m-26.4-3.5v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H146.5c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.15-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M94.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45H94.1zm-6.7.58c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.89 2.79v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M21.91 23.23a9.3 9.3 0 0 1-5.91 2.1H8.53v-.62l5.12-5.04a4.34 4.34 0 0 0 2.35.69c.86 0 1.67-.25 2.35-.69zm1.32-1.32a9.3 9.3 0 0 0 2.1-5.91c0-2.24-.79-4.3-2.11-5.91l-3.56 3.56c.43.68.69 1.48.69 2.35s-.25 1.67-.69 2.35zM21.91 8.77l-3.56 3.56a4.34 4.34 0 0 0-2.35-.69c-.86 0-1.67.25-2.35.69l-3.56-3.56A9.3 9.3 0 0 1 16 6.67c2.24 0 4.3.79 5.91 2.11M8.77 10.09A9.3 9.3 0 0 0 6.67 16c0 2.24.79 4.3 2.11 5.91l3.56-3.56a4.34 4.34 0 0 1-.69-2.35c0-.86.25-1.67.69-2.35z\"/>\n</svg>\n";
function $501906e2812827da$export$f597f0f7fadce0b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $501906e2812827da$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe1275028f179c85adabcde30f1dc14d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $dec238ff93319a00$var$svg = "<svg height=\"100%\" viewBox=\"0 0 48 48\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m36.22 26.75 4.9 7.25h-4.78c-.52-.6-1.02-1.31-1.47-1.98-.68-1.02-.68-2.41.03-3.41zm-7.3-5.5L24.02 14h4.78c.52.6 1.02 1.31 1.47 1.98.68 1.02.68 2.41-.02 3.41zm6.98-6.02c.5-.84 1.07-1.16 1.95-1.16l3.9-.07-12.68 19.27a1.46 1.46 0 0 1-1.22.67H23.6c4.07-6.25 8.37-12.37 12.31-18.7M8 33.94h6.89c6.16 0 9.92-3.88 9.92-9.94s-3.76-9.94-9.92-9.94H8l4.28 3.9h-1.76C9.13 17.96 8 19.12 8 20.55v13.38m4.41-3.9V17.96h2.46c3.52 0 5.49 2.38 5.49 6.04 0 3.65-1.97 6.04-5.46 6.04z\"/>\n</svg>\n";
function $dec238ff93319a00$export$9951d02c2d848122(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Dx' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $dec238ff93319a00$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86bc4a90f7eb35fd36ae7c99f20011b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $7b0cb8c2403d85b2$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z\"/>\n</svg>\n";
function $7b0cb8c2403d85b2$export$1e02e7298035a77c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $7b0cb8c2403d85b2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7aca4717e5f7edbaa74141430c7d1f8d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $4997c0e4e5416e87$var$svg = "<svg height=\"100%\" viewBox=\"0 0 117 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.03 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.71 3.58v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M64.6 25.64c-4.6 0-7.3-3.4-7.3-8S60 9.7 64.6 9.7c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.97 5.67h-9.14v7.51h-2.76V5.19h12.94v2.64H45.49v7.36h9.14z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M27.607 16.272c-2.176-2.176-5.712-2.152-7.865 0l-1.812 1.812c-1 1-2.625 1-3.625 0L12.8 16.578l-3.933 3.934 1.505 1.505a8.126 8.126 0 0 0 11.49 0zm-22.982-.541c2.176 2.175 5.668 2.196 7.844.02l1.834-1.834c1-1 2.625-1 3.625 0l1.505 1.505 3.934-3.933-1.505-1.505a8.126 8.126 0 0 0-11.49 0l-5.745 5.745z\"/>\n</svg>\n";
function $4997c0e4e5416e87$export$3a6e8b37e069a69d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $4997c0e4e5416e87$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::691ffc068fd79d2f7585ba74e9375893>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $054a7cc9a77efc09$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $054a7cc9a77efc09$export$9eb74917ea768ed4(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $054a7cc9a77efc09$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fcd237a4e74e8fc6ee2ed98ecae9d02>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $44589a9683d32305$var$svg = "<svg height=\"100%\" viewBox=\"0 0 116 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M115.55 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.12 4.13c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M58.71 24.2c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.36 16a3.36 3.36 0 1 1-6.72 0 3.36 3.36 0 0 1 6.72 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M16 25.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75M21.86 16a5.86 5.86 0 1 1-11.72 0 5.86 5.86 0 0 1 11.72 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $44589a9683d32305$export$c527a545aa426db3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $44589a9683d32305$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9271fe2e99ed03180fc112676167f42e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $22b6ae01216a6a81$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649\"/>\n</svg>\n";
function $22b6ae01216a6a81$export$3f95fcfdc25a741d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $22b6ae01216a6a81$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db6984f13fa8a1f65e3a27814935822a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $0d052c1f365de2d0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 120 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M108.4 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.8-9.04v9.05H96.7V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.86 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-27.42-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-3.98 5.21c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.188 14.644h15.623c.449 0 .688-.24.688-.688V8.688c0-.449-.24-.688-.688-.688h-3.292c-.45 0-.689.24-.689.688v2.664h-1.496V8.688c0-.449-.24-.688-.688-.688h-3.293c-.448 0-.688.24-.688.688v2.664H12.17V8.688c0-.449-.24-.688-.689-.688H8.188c-.449 0-.688.24-.688.688v5.268c0 .449.24.688.688.688m.27 4.609a10.4 10.4 0 0 1-.599-2.993c-.03-.389.15-.598.569-.598H23.57c.42 0 .599.18.599.538q-.09 1.662-.629 3.053c-.18.479-.448.688-.957.688H9.415c-.508 0-.778-.21-.957-.688m13.856 2.484c-1.436 1.766-3.8 2.903-6.314 2.903s-4.939-1.137-6.345-2.903c-.36-.479-.18-.778.18-.778h12.33c.359 0 .538.3.15.778\"/>\n</svg>\n";
function $0d052c1f365de2d0$export$2b896c4d595a4331(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $0d052c1f365de2d0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2dae141e789f6f860676eab772d48c16>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $899d9f8a72fd5810$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z\"/>\n</svg>\n";
function $899d9f8a72fd5810$export$92c8767b874048d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $899d9f8a72fd5810$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f61715fd61f2481e52a0f7c7611f421f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $cacaef9956f97a67$var$svg = "<svg height=\"100%\" viewBox=\"0 0 121 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.57 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM93.3 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.33 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M56.41 5.19h2.76v20.15h-2.76v-8.71H45.8v8.71h-2.76V5.19h2.76v8.8h10.61z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M7.25 14.125V24.75h6.25V18.5h5v6.25h6.25V14.125L16 6z\"/>\n</svg>\n";
function $cacaef9956f97a67$export$8b6b7f1b1b2367d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $cacaef9956f97a67$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::459e9cba95b1e0b094b9b0a89db30ecd>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $012945d8e2fbfa71$var$svg = "<svg height=\"100%\" viewBox=\"0 0 32 32\">\n    <g clip-path=\"url(#clip0_95164_16219)\">\n        <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n        <g clip-path=\"url(#clip1_95164_16219)\">\n            <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n        </g>\n    </g>\n    <defs>\n        <clipPath id=\"clip0_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M0 0h32v32H0z\"/>\n        </clipPath>\n        <clipPath id=\"clip1_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M2 2h28v28H2z\"/>\n        </clipPath>\n    </defs>\n</svg>\n";
function $012945d8e2fbfa71$export$80b8b269d8b5014e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $012945d8e2fbfa71$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::edd23980285704c09d78f5241a37a99c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $d01ef7a6c70afe03$var$svg = "<svg height=\"100%\" viewBox=\"0 0 95 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M91.61 17.67c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-24.52-6.64V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65M56.4 5.19h2.76v20.15H56.4v-8.71H45.79v8.71h-2.76V5.19h2.76v8.8H56.4z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $d01ef7a6c70afe03$export$7a38180641471460(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $d01ef7a6c70afe03$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b225283860ba91a6c228b8f4fa0e1d39>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $701d5396eb72984c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z\"/>\n</svg>\n";
var $701d5396eb72984c$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z\"/>\n</svg>\n";
function $701d5396eb72984c$export$c4b5b1f965d8b3eb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $701d5396eb72984c$var$svg,
        customThemeSvg: $701d5396eb72984c$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ed7d2f84cfdfe8bfef2a295bafed6da>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $840eb01c1734ebe0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.965 20.698h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.423 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.503 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.7zm4.818-4.82h-1.803c-2.72 0-4.67-1.665-4.67-4.104h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $840eb01c1734ebe0$export$bf4c5f97b468e8d6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $840eb01c1734ebe0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61edfa3e375524991498620530471e0e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $7d3956dbe8d63e3e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z\"/>\n</svg>\n";
function $7d3956dbe8d63e3e$export$f8455b5667a3ee0c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $7d3956dbe8d63e3e$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::193cafbd0d66aed78a8eae06654a150d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $69c118aaee2a1243$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M11.965 20.699h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.424 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.502 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.699zm4.818-4.819h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $69c118aaee2a1243$export$3224b07bc93ef23e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $69c118aaee2a1243$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b3ec3c590ed89c431e0f979daa3e25e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $78c17eeb06008ac8$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z\"/>\n</svg>\n";
var $78c17eeb06008ac8$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228\"/>\n</svg>\n";
function $78c17eeb06008ac8$export$21bfbeb62fdcce8d(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $78c17eeb06008ac8$var$svg,
        customThemeSvg: $78c17eeb06008ac8$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8e2d27dec964efc37c6ed5782c3fe57>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $083a696f8e2d95a0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 327 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M317.88 24.35h-1.72L310.62 10h2.82l4.91 13.13 4.9-13.13h2.82l-5.8 14.84c-1.72 4.39-2.7 6.65-6.59 6.65-1.32 0-2.06-.12-2.82-.43v-2.27c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.82m-13.25-8.05v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.72.6h-3.53L268.87 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.39 10.42v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-13.88-1.42c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.7-15.22c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zM207.68 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-13.41-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-14.99-1.32c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.78 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84h-4.02v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14h-3.71v8.28zm-27.87 1.56c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M17.448 6.967c2.544.746 5.113.746 7.656 0 .225-.05.375.1.325.323-.724 2.612-.724 5.025 0 7.637.05.199-.1.373-.325.298a14.3 14.3 0 0 0-7.656 0c-.2.075-.374-.1-.3-.298.674-2.612.674-5.025 0-7.637-.074-.223.1-.373.3-.323m1.023 9.253v.423c0 1.965-1.372 3.408-3.068 3.408a3.04 3.04 0 0 1-3.043-3.06c0-1.691 1.372-3.034 3.292-3.034h.5V8.012c-.25-.025-.5-.025-.749-.025a9.02 9.02 0 0 0-9.028 9.03c0 4.999 4.04 9.004 9.028 9.004s9.053-4.03 9.053-9.005v-.796z\"/>\n</svg>\n";
function $083a696f8e2d95a0$export$602140a6a10b02bf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $083a696f8e2d95a0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cedb5d68059644a06a093aa74d8e3cc5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $508ce61f11a3a789$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z\"/>\n</svg>\n";
var $508ce61f11a3a789$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z\"/>\n</svg>\n";
function $508ce61f11a3a789$export$3c6158790f5e01c4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $508ce61f11a3a789$var$svg,
        customThemeSvg: $508ce61f11a3a789$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf1b6bc0c0712320d6fbdb868500ebb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $4db70b2e6f76ba0c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.268 13.604h5.951c.894 0 1.199.85.654 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.523-8.959zm-4.6 4.577h-5.95c-.894 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $4db70b2e6f76ba0c$export$de148263c75d2bc1(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $4db70b2e6f76ba0c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b3684e2355c28ec62827d09d362b6cf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $c24549e1d7926fb7$var$svg = "<svg height=\"100%\" viewBox=\"0 0 25 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M14.117 10.203h4.464c.67 0 .899.637.49 1.144l-6.98 8.616c-2.257-1.798-2.044-4.643-.393-6.72zm-3.45 3.433H6.205c-.67 0-.899-.638-.49-1.144l6.981-8.617c2.256 1.799 2.011 4.61.376 6.704z\"/>\n</svg>\n";
function $c24549e1d7926fb7$export$65fae0eaf343f2ca(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $c24549e1d7926fb7$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d19396c378541211d8225aae490bcbcf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $4e01efda4183800b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.17-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.268 13.604h5.95c.895 0 1.2.85.655 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.524-8.959zm-4.6 4.577h-5.95c-.895 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $4e01efda4183800b$export$f64bc7a7f04428d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $4e01efda4183800b$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::568f663154fd35333110385dd0c22e41>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $77de63f0b90e2204$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $77de63f0b90e2204$export$8d789f76fde3e05(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $77de63f0b90e2204$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d69248f39a87c063a78e83a58b63bd7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $abb4c183d82eabca$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $abb4c183d82eabca$export$78c0b4d8be34c9b2(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $abb4c183d82eabca$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f5d94b0d7bf822b6ab4c2ad26c21970>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $7b6b7e76773b7419$var$svg = "<svg height=\"100%\" viewBox=\"0 0 100 32\">\n    <path fill=\"var(--icon-color, #101214)\" d=\"M66.71 5.11c0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82 0 .39-.26.62-1.08.62-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.06 0 2.85-.92 2.85-2.26m0 .03c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.5c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16m26.29-2.11v7.32h1.57V4.81l.64 1.46 2.21 4.11h1.95V3.06h-1.54v4.73l-.59-1.39-1.77-3.34zm-9.91 0h-1.7v7.32h1.7zM79.45 8.2c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.47c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16 0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82s-.26.62-1.08.62c-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.03 0 2.85-.92 2.85-2.29M53.5 3.06v7.32h3.49l.54-1.59h-2.34V3.06zm-6.91 0v1.57h1.88v5.75h1.72V4.63h2.03V3.06zm-2.49 0h-2.24l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95c-.03 0-2.57-7.32-2.57-7.32m-1.13 4.75c-.33 0-.64-.05-.93-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m20.06-4.75H60.8l-2.57 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zM61.9 7.81c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m27.32-4.75h-2.23l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zm-1.11 4.75c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19a3.7 3.7 0 0 1-.92.13\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.664-1.775-1.025-2.692 4.664V7.125h-2.048v5.385l-2.694-4.664-1.774 1.025 2.693 4.663-4.664-2.692-1.024 1.774 4.664 2.693H6.958v2.048h5.385L7.68 20.05l1.024 1.775 4.663-2.693-2.692 4.664 1.774 1.024 2.693-4.664v5.386h2.049v-5.385l2.692 4.663 1.774-1.024-2.692-4.664 4.663 2.693 1.025-1.775-4.664-2.692h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.594 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M39.32 27.74v-13.7h2.52v13.7zm24.13-9.31h2.4v1.14c.51-.91 1.7-1.4 2.72-1.4 1.27 0 2.29.55 2.76 1.55.74-1.14 1.72-1.55 2.95-1.55 1.72 0 3.37 1.04 3.37 3.54v6.04h-2.44v-5.53c0-1-.49-1.76-1.65-1.76-1.08 0-1.72.83-1.72 1.84v5.45h-2.49v-5.53c0-1-.51-1.76-1.65-1.76-1.1 0-1.74.81-1.74 1.84v5.45h-2.52zm-15.93 9.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.05 4.93-4.89 4.93m0-7.58a2.65 2.65 0 0 0-2.65 2.65 2.65 2.65 0 0 0 2.65 2.65c1.46 0 2.65-1.19 2.65-2.65a2.65 2.65 0 0 0-2.65-2.65m10.26 7.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.06 4.93-4.89 4.93m0-7.61a2.69 2.69 0 0 0-2.68 2.68 2.69 2.69 0 0 0 2.68 2.68 2.69 2.69 0 0 0 2.68-2.68 2.69 2.69 0 0 0-2.68-2.68\"/>\n</svg>\n";
function $7b6b7e76773b7419$export$68d7391318cdef11(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $7b6b7e76773b7419$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45c3b4b2f73587dee325566fc7978684>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $3977e5b1edd67333$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $3977e5b1edd67333$export$38c7b37a3e5e8d70(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $3977e5b1edd67333$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7f4fa46a3d520008396bf538a250ebef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $04e5c7b99b518b6e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $04e5c7b99b518b6e$export$71743a944cb62e48(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $04e5c7b99b518b6e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bf4732a418598faff0fcffc57f4a7b7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $ef3200acd4dd189e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848\"/>\n</svg>\n";
function $ef3200acd4dd189e$export$eeccc49dc7a12d9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $ef3200acd4dd189e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::032f8fa95ed51413adb506dd076fd343>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $7312026661045ee4$var$svg = "<svg height=\"100%\" viewBox=\"0 0 164 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M156.69 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM143.39 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-3.68-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.47-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.06 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-4.72 3.52c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-16.29-3.49c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3.01v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-20.11.01c-6.22 0-9.72-4.29-9.72-10.43 0-6.07 3.5-10.33 9.72-10.33 6.2 0 9.69 4.26 9.69 10.34 0 6.13-3.5 10.43-9.69 10.43m0-18.12c-4.97 0-6.96 3.53-6.96 7.7 0 4.26 1.99 7.79 6.96 7.79 4.94 0 6.93-3.53 6.93-7.79 0-4.17-1.99-7.7-6.93-7.7\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.905 25.684c-.638.47-.974.437-1.612-.033-3.088-2.216-5.942-4.734-7.855-7.352-.202-.269-.1-.638.201-.806l3.491-2.182q.454-.302.806.1c1.343 1.545 2.652 3.056 4.163 4.13 1.51-1.074 2.82-2.585 4.163-4.13q.352-.402.805-.1l3.491 2.182c.303.168.403.537.202.806-1.914 2.618-4.767 5.136-7.855 7.385m-.806-9.635c2.753 0 5.035-2.249 5.035-5.001s-2.282-5.07-5.035-5.07-5.036 2.283-5.036 5.07c0 2.786 2.216 5.001 5.036 5.001\"/>\n</svg>\n";
function $7312026661045ee4$export$a5b9122e89b32ad3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $7312026661045ee4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bab74cd77291828d528d124967c3552>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $ee859ead2c997d6c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $ee859ead2c997d6c$export$5ed3e1bb3b04fc02(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $ee859ead2c997d6c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::820b1edb3bac4a2b82da6f532724cb11>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $d49a05cc2e75a98d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 145 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M144.54 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.75-.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M99.43 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM83.8 31.25v-2.36c.31.03.49.03.77.03 1.13 0 2.05-.49 2.05-1.87V10h2.64v17.36c0 2.82-1.59 4.02-4.11 4.02-.67 0-1.13-.06-1.35-.12m2.3-25.3c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84M76.07 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M62.3 16.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84H45.8v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14H45.8v8.28z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m6.152 19.486 2.651-2.652-2.651-2.651 2.21-2.21h5.303l3.977-3.977h6.187v6.187l-3.977 3.977v5.304l-2.21 2.21-2.652-2.652-2.651 2.651-2.429-2.428 3.978-3.978-1.326-1.325-3.978 3.977zM20.736 13.3a1.562 1.562 0 1 1-2.21-2.21 1.562 1.562 0 0 1 2.21 2.21\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $d49a05cc2e75a98d$export$e3d1678155aaab99(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $d49a05cc2e75a98d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c09aee6cc96e54887271dd42a7eae172>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $70f94f8ec7b1b295$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691\"/>\n</svg>\n";
function $70f94f8ec7b1b295$export$e23ae35269442b4f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $70f94f8ec7b1b295$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29265478015ee48ec34dc1fd6eae4b81>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $f8f680c2b9153e80$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M98.36 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.87 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896q.017-.046.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682.17-.527.529-.983 1.021-1.267h.002z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1\"/>\n</svg>\n";
function $f8f680c2b9153e80$export$b0e15f0a1c9f4c55(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $f8f680c2b9153e80$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0424c604e8fb1e51fac762a4e1efa562>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $aede3667eebcd473$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M11.26 4.71a1.7 1.7 0 0 1 1.666.017l5.006 2.89c.524.302.848.863.848 1.467v5.78a1.69 1.69 0 0 1-.848 1.467l-3.763 2.172.024-.07c.07-.216.107-.445.107-.679v-5.78c0-.794-.423-1.526-1.112-1.922l-2.805-1.62V6.195q.001-.267.08-.512c.126-.395.396-.737.765-.95l.002-.001z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M9.986 5.45 6.223 7.623a1.69 1.69 0 0 0-.848 1.466v5.78c0 .605.324 1.166.848 1.468l5.006 2.89a1.7 1.7 0 0 0 1.666.016l.03-.02c.37-.214.64-.556.768-.95q.078-.247.079-.513v-2.24l-2.805-1.618a2.22 2.22 0 0 1-1.112-1.922V6.2a2.2 2.2 0 0 1 .13-.75\"/>\n</svg>\n";
function $aede3667eebcd473$export$8b784b3227531b3e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $aede3667eebcd473$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e0f280d200b0e27835aec655dfa5a41e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $1738a389ff1a4b17$var$svg = "<svg height=\"100%\" viewBox=\"0 0 165 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M158.79 25.33h-3.53L149.32 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.64-13.24c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM121.91 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.26.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.86 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682a2.26 2.26 0 0 1 1.021-1.267h.002z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1\"/>\n</svg>\n";
function $1738a389ff1a4b17$export$4145bd793c9ed1d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $1738a389ff1a4b17$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c56e9a05bb3a4c70bfd4cbcb5fa54ba2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $967b8b902cad02df$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M10.7.368a2.75 2.75 0 0 1 2.748 0l8.016 4.626a2.75 2.75 0 0 1 1.375 2.38v9.252c0 .982-.524 1.889-1.375 2.38l-8.016 4.626a2.75 2.75 0 0 1-2.749 0l-8.016-4.626a2.75 2.75 0 0 1-1.374-2.38V7.374c0-.982.524-1.889 1.374-2.38z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.181 6.096 6.777 8.06a1.53 1.53 0 0 0-.768 1.327v5.229c0 .547.294 1.054.768 1.327l.807.466 3.722 2.149a1.54 1.54 0 0 0 1.508.014l.027-.018a1.54 1.54 0 0 0 .766-1.323v-2.026l-1.97-1.137-.568-.327a2 2 0 0 1-1.006-1.74V6.775a2 2 0 0 1 .118-.678\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M12.842 5.441a1.54 1.54 0 0 0-1.508-.014l-.028.019a1.54 1.54 0 0 0-.765 1.323v2.025l1.91 1.102.628.362a2 2 0 0 1 1.006 1.74v5.228a2 2 0 0 1-.118.678l3.404-1.965c.476-.273.767-.778.767-1.327V9.383c0-.546-.293-1.054-.767-1.327l-.868-.501z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $967b8b902cad02df$export$813cff80931d9dbf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev Agent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $967b8b902cad02df$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ca2d332c134816706ee434029a355d3c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $4b1bd776417e729e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 160 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M153.94 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zM136.3 12.42c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-25.13-16.9h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.52h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.25.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M45 8.16h-4.05v7.36H45c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M12.52.49a3.67 3.67 0 0 1 3.666 0l10.688 6.17a3.66 3.66 0 0 1 1.833 3.173v12.336a3.66 3.66 0 0 1-1.833 3.173L16.186 31.51a3.67 3.67 0 0 1-3.665 0L1.833 25.341A3.66 3.66 0 0 1 0 22.168V9.832c0-1.309.7-2.519 1.833-3.173z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m11.83 8.128-4.54 2.62a2.04 2.04 0 0 0-1.022 1.77v6.972c0 .728.39 1.405 1.023 1.77l1.076.62 4.963 2.865a2.05 2.05 0 0 0 2.01.02l.037-.025c.445-.257.771-.67.925-1.146q.094-.297.095-.619v-2.7l-2.627-1.516-.757-.436a2.67 2.67 0 0 1-1.34-2.32v-6.97a2.7 2.7 0 0 1 .157-.904\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M15.377 7.255a2.05 2.05 0 0 0-2.01-.019l-.038.026c-.445.257-.77.67-.924 1.145a2 2 0 0 0-.095.618v2.7l2.545 1.47.839.483a2.67 2.67 0 0 1 1.34 2.319v6.972a2.7 2.7 0 0 1-.157.903l4.54-2.62a2.04 2.04 0 0 0 1.022-1.77v-6.971c0-.729-.39-1.405-1.023-1.77l-1.157-.668z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $4b1bd776417e729e$export$58747af448450872(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev Agent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $4b1bd776417e729e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1fdf93317430cb701429972e6c41dc4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $2e769877b28b6c1c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--rovo-blue-color, #1868db)\" fill-rule=\"evenodd\" d=\"m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-green-color, #6a9a23)\" fill-rule=\"evenodd\" d=\"m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-purple-color, #af59e1)\" fill-rule=\"evenodd\" d=\"m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-yellow-color, #fca700)\" fill-rule=\"evenodd\" d=\"M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $2e769877b28b6c1c$export$9e62346a60cfb459(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $2e769877b28b6c1c$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0e01ef8caae93929e35d346a5091c5ef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e0c14a4c94331bbd$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M93.5 25.97c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.3c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M44.99 8.16h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--rovo-blue-color, #1868db)\" fill-rule=\"evenodd\" d=\"m15.892 22.385-9.538 5.559-4.538-2.613A3.63 3.63 0 0 1 0 22.19V9.821C0 8.524.69 7.33 1.816 6.682l8.058-4.649-.052.152a4.7 4.7 0 0 0-.228 1.452v12.37a4.74 4.74 0 0 0 2.38 4.113z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-green-color, #6a9a23)\" fill-rule=\"evenodd\" d=\"m13.318 20.895-9.591 5.538 8.809 5.082a3.64 3.64 0 0 0 3.568.034l.065-.043a3.63 3.63 0 0 0 1.642-2.034c.11-.35.17-.718.17-1.096v-4.792z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-purple-color, #af59e1)\" fill-rule=\"evenodd\" d=\"M26.893 6.67 21.02 3.285l-7.873 6.52 3.587 2.075a4.74 4.74 0 0 1 2.38 4.115v12.369a4.7 4.7 0 0 1-.28 1.603l8.058-4.649a3.62 3.62 0 0 0 1.816-3.139V9.81a3.63 3.63 0 0 0-1.816-3.139\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-yellow-color, #fca700)\" fill-rule=\"evenodd\" d=\"m15.244 11.022-4.519-2.606V3.625c0-.378.059-.747.17-1.096a3.63 3.63 0 0 1 1.64-2.033l.002-.001.064-.044a3.64 3.64 0 0 1 3.569.034l8.665 5z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $e0c14a4c94331bbd$export$5e38d02efdb45577(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $e0c14a4c94331bbd$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::88ee37f21199df8c4f6de50b597bc415>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $e63a46d3e5ee26b0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M5 10.688a5.69 5.69 0 0 0 5.697 5.687c1.01 0 1.958-.262 2.78-.723L16.832 19 19 16.834l-3.347-3.341c.471-.828.74-1.785.74-2.806A5.69 5.69 0 0 0 10.697 5 5.69 5.69 0 0 0 5 10.688m2.191 0c0 1.932 1.57 3.5 3.506 3.5a3.503 3.503 0 0 0 3.505-3.5c0-1.933-1.57-3.5-3.505-3.5a3.503 3.503 0 0 0-3.506 3.5\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $e63a46d3e5ee26b0$export$82eafebb825fc23f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $e63a46d3e5ee26b0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4165d5d8279c6abbf1ec41290594700b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $b400386b6118e9fc$var$svg = "<svg height=\"100%\" viewBox=\"0 0 130 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M128.82 16.35v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.04 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10H88v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M7.127 14.833a7.583 7.583 0 0 0 11.286 6.62l4.464 4.464 2.887-2.888-4.455-4.455a7.583 7.583 0 1 0-14.181-3.74m2.917 0a4.667 4.667 0 1 0 9.333 0 4.667 4.667 0 0 0-9.333 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $b400386b6118e9fc$export$fa08cbfe393f2a68(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $b400386b6118e9fc$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5fb81b6548e62d67fc83daf888114f8f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $7f925c2c05d86612$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6.625a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.76 17.176a5.791 5.791 0 1 1 5.038-2.935l3.403 3.403-2.205 2.204-3.409-3.408a5.77 5.77 0 0 1-2.827.736m-.274-9.37-.242.615c-.344.874-.516 1.312-.833 1.64-.318.33-.749.518-1.61.893l-.37.16v.51l.37.16c.861.376 1.292.563 1.61.893.317.329.49.766.833 1.64l.242.616h.51l.242-.616c.344-.874.516-1.311.834-1.64.317-.33.748-.517 1.61-.893l.368-.16v-.51l-.369-.16c-.861-.375-1.292-.563-1.61-.892-.317-.33-.489-.766-.833-1.64l-.242-.616z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $7f925c2c05d86612$export$3599582ddc9fc5cf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $7f925c2c05d86612$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::12cecbe0aa290ffe5232721f12ef458f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $4a274402133bcfb4$var$svg = "<svg height=\"100%\" viewBox=\"0 0 130 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M128.82 16.35v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.05 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M14.346 22.068a7.721 7.721 0 1 1 6.718-3.913l4.537 4.536-2.94 2.94-4.545-4.545a7.7 7.7 0 0 1-3.77.982m-.364-12.494-.323.82c-.459 1.167-.688 1.75-1.112 2.188-.423.44-.997.69-2.146 1.19l-.492.214v.68l.492.213c1.149.5 1.723.75 2.146 1.19.424.439.653 1.022 1.112 2.188l.323.82h.679l.323-.82c.459-1.166.688-1.75 1.111-2.188.424-.44.998-.69 2.147-1.19l.491-.214v-.679l-.491-.214c-1.149-.5-1.723-.75-2.147-1.19-.423-.438-.652-1.021-1.111-2.187l-.323-.82z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $4a274402133bcfb4$export$d669f6cbbb67e061(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $4a274402133bcfb4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37c59c3ee979ff8acaf7525e576da094>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $4f9732d887e085b6$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68\"/>\n</svg>\n";
function $4f9732d887e085b6$export$f3f5aa321d88adf9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $4f9732d887e085b6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4e31a509778b74933bf91345a74560c5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $535fb25abeb69827$var$svg = "<svg height=\"100%\" viewBox=\"0 0 192 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M184.96 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-10.55-4.47c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.61-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19H85V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.95-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.26-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M15.896 13.196c-2.464 0-4.86 1.114-6.817 2.835q-.303.304-.607.304c-.169 0-.338-.102-.473-.27l-2.463-2.902c-.135-.17-.202-.338-.202-.473 0-.202.1-.371.303-.573C8.607 9.484 12.217 8 15.896 8c3.678 0 7.29 1.484 10.259 4.117.202.202.303.37.303.573 0 .135-.067.304-.202.473l-2.463 2.902c-.135.168-.304.27-.473.27q-.303 0-.607-.304c-1.958-1.721-4.353-2.835-6.817-2.835m0 10.867c-2.733 0-4.96-2.228-4.96-4.927 0-2.7 2.227-4.927 4.96-4.927s4.96 2.193 4.96 4.927-2.227 4.927-4.96 4.927\"/>\n</svg>\n";
function $535fb25abeb69827$export$2bc88a281410ffa7(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $535fb25abeb69827$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2be4b98bf6f70e39467c5c4d0f75c6d5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $71c085540a543398$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M10.7 11.222V19h7.8v-7.778z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.6 7.609 10.05 5 5.5 7.609v5.217l3.64 2.087V9.667h5.46z\"/>\n</svg>\n";
function $71c085540a543398$export$290a0f24614cde9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $71c085540a543398$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a96e3d2d2d3910fdbea7d20bda091bd2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $dd6e7f6bc9a5125a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 124 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.17 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.125 14.125V24.75H24.75V14.125z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z\"/>\n</svg>\n";
function $dd6e7f6bc9a5125a$export$273fd56580e523ae(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $dd6e7f6bc9a5125a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e6df92ef654dd711bfb690d95b2c06d7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $15c0e7b58291f7da$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.594 18.563v-7.97h7.969v7.97zm3.808-6.488-.163.429c-.235.615-.352.922-.572 1.155s-.52.368-1.12.638l-.222.1v.357l.222.099c.6.27.9.405 1.12.638s.337.54.572 1.156l.163.428h.347l.163-.429c.235-.615.352-.922.572-1.155s.52-.368 1.12-.638l.221-.1v-.357l-.22-.1c-.601-.269-.901-.404-1.121-.637s-.337-.54-.572-1.155l-.164-.429z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.813 7.195 10.125 4.5 5.438 7.195v5.39l3.75 2.157V9.187h5.625z\"/>\n</svg>\n";
function $15c0e7b58291f7da$export$8bb9894377e04e04(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $15c0e7b58291f7da$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::88f184410a9d6dcf22f1ca1246d077a0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $11ae8c55cb332e8a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 124 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M14.125 24.75V14.125H24.75V24.75zm5.078-8.65-.218.571c-.312.82-.469 1.23-.762 1.541s-.694.49-1.494.85l-.295.133v.476l.295.133c.8.36 1.2.54 1.494.85.293.311.45.721.762 1.541l.218.572h.462l.218-.572c.313-.82.469-1.23.762-1.54s.694-.491 1.494-.851l.295-.133v-.476l-.295-.132c-.8-.36-1.2-.54-1.494-.85-.293-.312-.45-.722-.762-1.542l-.218-.571z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z\"/>\n</svg>\n";
function $11ae8c55cb332e8a$export$170353c338ac5f4a(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $11ae8c55cb332e8a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1d8fa09e3a068fb57474a844fe5ab56>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $7d5bd85babd9d964$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $7d5bd85babd9d964$export$4b05688514531169(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $7d5bd85babd9d964$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4af27131cfc453f0f255c3cbe65f158e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $545ed004ae83180d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 122 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M117.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H82.4c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-14.47.57c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m16.577 4.907 3.035 6.763 7.372.797.354 1.09-5.495 4.977 1.52 7.257-.927.672-6.431-3.687-6.433 3.687-.926-.672 1.52-7.257-5.495-4.978.353-1.089 7.372-.797 3.035-6.763zm-.668 11.936a2.476 2.476 0 0 0-2.476 2.477v.904a4.8 4.8 0 0 0 2.369.644h.07a4.8 4.8 0 0 0 2.514-.73v-.818a2.477 2.477 0 0 0-2.477-2.477m0-4.511a1.857 1.857 0 1 0 0 3.714 1.857 1.857 0 0 0 0-3.714\"/>\n</svg>\n";
function $545ed004ae83180d$export$1b3979d995ebbc6e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $545ed004ae83180d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7cfe9311dc5f8070530ce9772b12f3fc>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $ec2f473c5d030159$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63\"/>\n</svg>\n";
function $ec2f473c5d030159$export$1bcbc9c337da86da(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $ec2f473c5d030159$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9a7a0d4583e5a9f22d08a0d2f6ac1f1>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $ec92cf1c4d78f147$var$svg = "<svg height=\"100%\" viewBox=\"0 0 127 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M126.58 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-24.66-4.36v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.33.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM61.99 12.08c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H57.55c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M10.75 14.83a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m10.5 0a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.23 1.75a3.86 3.86 0 0 1 3.86 3.86v3.72h-9.62l2.21-5.23a3.86 3.86 0 0 1 3.55-2.35M6.67 20.67v3.5h6.42l1.75-4.08a3.5 3.5 0 0 0-3.5-3.5h-.58a4.08 4.08 0 0 0-4.08 4.08\"/>\n</svg>\n";
function $ec92cf1c4d78f147$export$bfd8d1c4da84ce71(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $ec92cf1c4d78f147$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fc7b25031952cd94704eefaa85d7de4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $80ddb30da36b08ce$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z\"/>\n</svg>\n";
var $80ddb30da36b08ce$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z\"/>\n</svg>\n";
function $80ddb30da36b08ce$export$4384da9b8b140bf4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $80ddb30da36b08ce$var$svg,
        customThemeSvg: $80ddb30da36b08ce$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b73a20da143650f747e32cb182c99798>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $50e26eff8a8bc584$var$svg = "<svg height=\"100%\" viewBox=\"0 0 113 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M104.97 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M96.21 25.3c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-8 0c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM72.86 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H68.42c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.48-8.44v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M12.9 24c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H8.13C7.51 8 7 8.49 7 9.1v13.8c0 .61.5 1.1 1.13 1.1zm10.97-6.34c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H19.1c-.62 0-1.13.49-1.13 1.1v7.47c0 .61.5 1.1 1.13 1.1z\"/>\n</svg>\n";
function $50e26eff8a8bc584$export$1b13139dfc0336af(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $50e26eff8a8bc584$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}



var $5FkrB = parcelRequire("5FkrB");

/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ var $4695b20c010af541$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
var $4695b20c010af541$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
}; /**
 * The props for the <Wrapper /> that takes the svg and turns it into a component.
 */ 


/* wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $246be689d43c2dd2$var$_excluded = [
    "label",
    "svg",
    "size",
    "appearance",
    "iconColor",
    "textColor",
    "testId"
];
var $246be689d43c2dd2$var$CSS_VAR_COLOR = '--logo-color';
var $246be689d43c2dd2$var$CSS_VAR_FILL = '--logo-fill';
var $246be689d43c2dd2$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ var $246be689d43c2dd2$var$Wrapper = function Wrapper(_ref) {
    var label = _ref.label, svg = _ref.svg, size = _ref.size, appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor, userDefinedTestId = _ref.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $246be689d43c2dd2$var$_excluded);
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    var shouldApplyStopColor = appearance === undefined;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-testid": testId,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $246be689d43c2dd2$var$CSS_VAR_COLOR, iconColor), $246be689d43c2dd2$var$CSS_VAR_FILL, textColor),
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest, {
        className: (0, $461693459c687c45$export$2e2bcd8739ae039)([
            $246be689d43c2dd2$var$styles.root,
            shouldApplyStopColor && $246be689d43c2dd2$var$styles.stop,
            size && $246be689d43c2dd2$var$styles[size]
        ])
    }));
};
var $246be689d43c2dd2$export$2e2bcd8739ae039 = $246be689d43c2dd2$var$Wrapper;


// Reds
var $f7a5f10e00858daf$export$4b84fd0e2c617bd = '#FFEBE6';
var $f7a5f10e00858daf$export$b34b069eff244586 = '#FFBDAD';
var $f7a5f10e00858daf$export$be802dd0d8b57f35 = '#FF8F73';
var $f7a5f10e00858daf$export$60847d42f9da92a6 = '#FF7452';
var $f7a5f10e00858daf$export$4a7404f376229999 = '#FF5630';
var $f7a5f10e00858daf$export$2010d0fb4295b346 = '#DE350B';
var $f7a5f10e00858daf$export$2837b5a1a71d5c02 = '#BF2600';
var $f7a5f10e00858daf$export$8d9596b529bbb9cf = '#FFFAE6';
var $f7a5f10e00858daf$export$41060a744ab0b7ae = '#FFF0B3';
var $f7a5f10e00858daf$export$1cc05bbbf340e559 = '#FFE380';
var $f7a5f10e00858daf$export$5aae31392d72caaa = '#FFC400';
var $f7a5f10e00858daf$export$c6930421db9fa514 = '#FFAB00';
var $f7a5f10e00858daf$export$59619663aa6500fb = '#FF991F';
var $f7a5f10e00858daf$export$874739ea9e379ab6 = '#FF8B00';
var $f7a5f10e00858daf$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $f7a5f10e00858daf$export$69a3bf21b9686c2b = '#ABF5D1';
var $f7a5f10e00858daf$export$afbce1382ec95f73 = '#79F2C0';
var $f7a5f10e00858daf$export$747d86715d4175de = '#57D9A3';
var $f7a5f10e00858daf$export$940e1f69e873f202 = '#36B37E';
var $f7a5f10e00858daf$export$a49394138f7b8e85 = '#00875A';
var $f7a5f10e00858daf$export$6fa04827ac68a4fb = '#006644';
var $f7a5f10e00858daf$export$226de0355ed012f8 = '#DEEBFF';
var $f7a5f10e00858daf$export$8c13c2ee36917869 = '#B3D4FF';
var $f7a5f10e00858daf$export$ecfc1dff386a3e7a = '#4C9AFF';
var $f7a5f10e00858daf$export$215b7063051591f1 = '#2684FF';
var $f7a5f10e00858daf$export$e62e8919cca44969 = '#0065FF';
var $f7a5f10e00858daf$export$b3de0ae08da2ce64 = '#0052CC';
var $f7a5f10e00858daf$export$a6ee3d71bc067634 = '#0747A6';
var $f7a5f10e00858daf$export$67f15409e87642a1 = '#669DF1';
var $f7a5f10e00858daf$export$f0539dbc42dbb067 = '#8FB8F6';
var $f7a5f10e00858daf$export$363e4475840015bb = '#EAE6FF';
var $f7a5f10e00858daf$export$4b0a4417ed59760f = '#C0B6F2';
var $f7a5f10e00858daf$export$6011520a64d9a187 = '#998DD9';
var $f7a5f10e00858daf$export$a7175d4e9206bc80 = '#8777D9';
var $f7a5f10e00858daf$export$b48405b95304b5a1 = '#6554C0';
var $f7a5f10e00858daf$export$c71e4279dd54a18d = '#5243AA';
var $f7a5f10e00858daf$export$147899de772240ec = '#403294';
var $f7a5f10e00858daf$export$2cf711fe14c66f06 = '#E6FCFF';
var $f7a5f10e00858daf$export$7a8f4d33f6f9772c = '#B3F5FF';
var $f7a5f10e00858daf$export$776c9c497ef08533 = '#79E2F2';
var $f7a5f10e00858daf$export$69cb3ca10c1e330e = '#00C7E6';
var $f7a5f10e00858daf$export$9dc1ef0f3f48059b = '#00B8D9';
var $f7a5f10e00858daf$export$7c835c78b6fcdef8 = '#00A3BF';
var $f7a5f10e00858daf$export$6036577f95c3877e = '#008DA6';
var $f7a5f10e00858daf$export$29a4f05edc054374 = '#FFFFFF';
var $f7a5f10e00858daf$export$e655ef011c4aa1a2 = '#FAFBFC';
var $f7a5f10e00858daf$export$9fdfb749e33cdf97 = '#F4F5F7';
var $f7a5f10e00858daf$export$3e51e8f1440314ba = '#EBECF0';
var $f7a5f10e00858daf$export$1ce2d1575d444ceb = '#DFE1E6';
var $f7a5f10e00858daf$export$8754fc7e6d8b3000 = '#C1C7D0';
var $f7a5f10e00858daf$export$c2e91cbeada39b8b = '#B3BAC5';
var $f7a5f10e00858daf$export$5f71e19f3a7ad9de = '#A5ADBA';
var $f7a5f10e00858daf$export$eaa8c8a70ac22806 = '#97A0AF';
var $f7a5f10e00858daf$export$7c87d337fb91a97d = '#8993A4';
var $f7a5f10e00858daf$export$d6447c357493214f = '#7A869A';
var $f7a5f10e00858daf$export$f563ee71e9ee74cd = '#6B778C';
var $f7a5f10e00858daf$export$e2ef2124cf4024b1 = '#5E6C84';
var $f7a5f10e00858daf$export$eece5f492e429f08 = '#505F79';
var $f7a5f10e00858daf$export$c39c0fe0f26207ae = '#42526E';
var $f7a5f10e00858daf$export$7090862dc3038a9f = '#344563';
var $f7a5f10e00858daf$export$ad0bacf983b7ddaa = '#253858';
var $f7a5f10e00858daf$export$7d61b15e0da132af = '#172B4D';
var $f7a5f10e00858daf$export$fbda843f0a27fe96 = '#091E42';
var $f7a5f10e00858daf$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $f7a5f10e00858daf$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $f7a5f10e00858daf$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $f7a5f10e00858daf$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $f7a5f10e00858daf$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $f7a5f10e00858daf$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $f7a5f10e00858daf$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $f7a5f10e00858daf$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $f7a5f10e00858daf$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $f7a5f10e00858daf$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $f7a5f10e00858daf$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $f7a5f10e00858daf$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $f7a5f10e00858daf$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $f7a5f10e00858daf$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $f7a5f10e00858daf$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $f7a5f10e00858daf$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $f7a5f10e00858daf$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $f7a5f10e00858daf$export$2f6319cf7d736c2a = '#E6EDFA';
var $f7a5f10e00858daf$export$95126bc8884d6634 = '#DCE5F5';
var $f7a5f10e00858daf$export$8338d8c35d44ff1 = '#CED9EB';
var $f7a5f10e00858daf$export$5368d76ae4fbbda7 = '#B8C7E0';
var $f7a5f10e00858daf$export$9f0a771d16ec8d36 = '#ABBBD6';
var $f7a5f10e00858daf$export$abcf8c38338b4aa5 = '#9FB0CC';
var $f7a5f10e00858daf$export$97e81faa16a182c7 = '#8C9CB8';
var $f7a5f10e00858daf$export$bfe21c59123ecf33 = '#7988A3';
var $f7a5f10e00858daf$export$ee82aa2ea6a1558 = '#67758F';
var $f7a5f10e00858daf$export$682927c6ed76be02 = '#56637A';
var $f7a5f10e00858daf$export$91fd9994c5be9757 = '#455166';
var $f7a5f10e00858daf$export$d281fbfe3cff2df6 = '#3B475C';
var $f7a5f10e00858daf$export$3902c91d8b98a753 = '#313D52';
var $f7a5f10e00858daf$export$8e8133c1ba5845b5 = '#283447';
var $f7a5f10e00858daf$export$33ff357f6620b39 = '#202B3D';
var $f7a5f10e00858daf$export$633847cf062b69e0 = '#1B2638';
var $f7a5f10e00858daf$export$9776a6e503bdbf76 = '#121A29';
var $f7a5f10e00858daf$export$6c813d5160dff5db = '#0E1624';
var $f7a5f10e00858daf$export$3d4f271a500072a = '#0D1424';
var $f7a5f10e00858daf$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $f7a5f10e00858daf$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $f7a5f10e00858daf$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $f7a5f10e00858daf$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $f7a5f10e00858daf$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $f7a5f10e00858daf$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $f7a5f10e00858daf$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $f7a5f10e00858daf$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $f7a5f10e00858daf$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $f7a5f10e00858daf$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $f7a5f10e00858daf$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $f7a5f10e00858daf$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $f7a5f10e00858daf$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $f7a5f10e00858daf$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $f7a5f10e00858daf$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $f7a5f10e00858daf$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $f7a5f10e00858daf$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $f7a5f10e00858daf$export$d2adc5dedf09fced = '#292A2E';
var $f7a5f10e00858daf$export$f51762073d2bb381 = '#94C748';
var $f7a5f10e00858daf$export$95e26d54def96891 = '#B3DF72';


var $244fe5cbdef580ed$export$362a25f017e2bc8a = function getColorsFromAppearanceOldLogos(appearance, colorMode) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = (0, $f7a5f10e00858daf$export$b3de0ae08da2ce64);
            iconGradientStop = (0, $f7a5f10e00858daf$export$215b7063051591f1);
            iconColor = (0, $f7a5f10e00858daf$export$215b7063051591f1);
            textColor = "var(--ds-text, #292A2E)";
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $f7a5f10e00858daf$export$b3de0ae08da2ce64);
            break;
        case 'neutral':
            iconGradientStart = (0, $f7a5f10e00858daf$export$7090862dc3038a9f);
            iconGradientStop = (0, $f7a5f10e00858daf$export$d6447c357493214f);
            iconColor = (0, $f7a5f10e00858daf$export$d6447c357493214f);
            textColor = (0, $f7a5f10e00858daf$export$eece5f492e429f08);
            atlassianLogoTextColor = (0, $f7a5f10e00858daf$export$eece5f492e429f08);
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $244fe5cbdef580ed$export$bbacc3980e0f3029 = function getColorsFromAppearance(appearance, colorMode) {
    var iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = (0, $f7a5f10e00858daf$export$29a4f05edc054374);
            textColor = (0, $f7a5f10e00858daf$export$29a4f05edc054374);
            atlassianLogoTextColor = (0, $f7a5f10e00858daf$export$29a4f05edc054374);
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $244fe5cbdef580ed$export$7818df200941dbbf = function getColorsForLoom(appearance, colorMode) {
    var iconColor = $244fe5cbdef580ed$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    var textColor = $244fe5cbdef580ed$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};


var $deef3d3b45588f0d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $deef3d3b45588f0d$export$84109e099492cb5f = function AtlassianAdminIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $deef3d3b45588f0d$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $d33c9708982ababa$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 295 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M294.31 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $d33c9708982ababa$export$f845d9b9254f0541 = function AtlassianAdminLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $d33c9708982ababa$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $d8e67cdbc001644b$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $d8e67cdbc001644b$export$74517ed253186308 = function AtlassianAdministrationIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $d8e67cdbc001644b$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $d34bb2adfdd493f4$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 404 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M403.77 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-23.336 9.292c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.57 0 7.237 3.343 7.237 7.943s-2.667 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.489s1.442 5.55 4.723 5.55c3.251 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49zm-13.488-6.195c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-7.461-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.078v2.453h-4.078zm-18.943-2.913c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.637v15.333zm-17.793-9.046v9.046h-2.576V10h2.576v2.699c.89-1.81 2.423-3.098 5.428-2.914v2.576c-3.373-.337-5.428.675-5.428 3.926m-10.037 4.293c0 1.35.797 2.27 2.423 2.27.613 0 1.196-.123 1.656-.215v2.545c-.46.123-.982.245-1.779.245-3.281 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.079v2.453h-4.079zm-6.696.583c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.675-2.974 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.121 2.086 5.121 4.754M297.497 5.952c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-3.678-8.985v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $d34bb2adfdd493f4$export$833abe6c2ce5ebfd = function AtlassianAdministrationLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $d34bb2adfdd493f4$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");
function $8a4e0f31a3c0be30$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId().replace(/[:«»]/g, '_');
}
var $8a4e0f31a3c0be30$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($8a4e0f31a3c0be30$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $8a4e0f31a3c0be30$export$6ee17796e3d70de2() {
    var uid = $8a4e0f31a3c0be30$export$f680877a34711e37();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}






var $f554407486f95716$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$362a25f017e2bc8a)(appearance, colorMode);
    return "<svg height=\"32\" viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"12.595\" x2=\"12.595\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient id=\"").concat(id, "-b\" x1=\"28.595\" x2=\"28.595\" y1=\"40\" y2=\"27\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-c\" x1=\"20.595\" x2=\"20.595\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-d\" x1=\"36.595\" x2=\"36.595\" y2=\"20\"/>\n  </defs>\n  <path d=\"M10.595 30h4v10h-4z\" fill=\"url(#").concat(id, "-a)\"/>\n  <path d=\"M26.595 27h4v13h-4z\" fill=\"url(#").concat(id, "-b)\"/>\n  <path d=\"M18.595 22h4v18h-4z\" fill=\"url(#").concat(id, "-c)\"/>\n  <path d=\"M34.595 20h4v20h-4z\" fill=\"url(#").concat(id, "-d)\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m9.009 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\" />\n</svg>");
};
var $f554407486f95716$export$c42ad8a0b925c762 = function AtlassianAnalyticsIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $8a4e0f31a3c0be30$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $f554407486f95716$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};


var $5FkrB = parcelRequire("5FkrB");





var $95feedc4efaebf57$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        textColor: textColor,
        iconColor: iconColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$362a25f017e2bc8a)(appearance, colorMode);
    return "\n  <svg height=\"32\" viewBox=\"0 0 477 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"447.285\" x2=\"447.285\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-b\" x1=\"463.285\" x2=\"463.285\" y2=\"27\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-c\" x1=\"455.285\" x2=\"455.285\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-d\" x1=\"471.285\" x2=\"471.285\" y2=\"20\"/>\n  </defs>\n  <g fill=\"").concat(colors.atlassianLogoTextColor, "\">\n    <path d=\"M106.72 18.359c0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835m0 0c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445M209.1 10.346v28.455h6.063V17.103l2.556 5.76 8.575 15.938h7.623V10.346h-6.064V28.71l-2.295-5.327-6.886-13.037H209.1zM163.909 10.346h6.626v28.455h-6.626zM156.263 30.399c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445 0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835M55.243 10.346v28.455h13.62l2.145-6.15h-9.095V10.346h-6.67zM28.334 10.346v6.15h7.363v22.305h6.67V16.496h7.882v-6.15H28.334zM18.663 10.346h-8.74L0 38.801h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM92.344 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM194.414 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524Z\"/>\n  </g>\n  <g fill=\"").concat(colors.textColor, "\">\n    <path d=\"m254.776 31.987-2.53 6.809H247.6l11.916-30.225h5.244l11.916 30.225h-4.646l-2.53-6.855c-2.714.552-5.061.828-7.499.828-2.3 0-4.646-.276-7.223-.782Zm13.479-3.496-6.119-16.562-6.119 16.608c2.254.368 4.141.552 5.98.552 1.933 0 3.911-.23 6.257-.598ZM298.984 38.796h-3.957V24.902c0-4.141-1.656-5.981-5.428-5.981-3.681 0-6.211 2.438-6.211 7.085v12.79h-3.957V15.794h3.957v3.772c1.472-2.715 4.187-4.232 7.269-4.232 5.291 0 8.327 3.634 8.327 9.983v13.479ZM320.097 34.656c-1.472 3.036-4.232 4.6-7.775 4.6-6.119 0-9.201-5.199-9.201-11.961 0-6.486 3.22-11.961 9.661-11.961 3.358 0 5.935 1.518 7.314 4.508v-4.048h3.957v23.002h-3.957v-4.14Zm-6.717.92c3.542 0 6.717-2.254 6.717-7.361v-1.84c0-5.106-2.898-7.361-6.256-7.361-4.463 0-6.763 2.944-6.763 8.281 0 5.521 2.208 8.281 6.303 8.281ZM336.196 38.935c-3.772 0-6.165-1.794-6.165-6.027V6.179h3.957v26.269c0 2.07 1.38 2.806 3.083 2.806.414 0 .69 0 1.15-.046v3.542c-.322.092-1.012.184-2.024.184ZM347.328 37.324l-8.327-21.53h4.232l7.361 19.69 7.361-19.69h4.232l-8.695 22.267c-2.576 6.579-4.048 9.983-9.891 9.983-1.979 0-3.083-.184-4.232-.644v-3.404c1.334.414 2.852.552 4.002.552 3.22 0 4.646-2.208 6.533-7.223h-2.576ZM374.698 35.07c.92 0 1.794-.185 2.484-.322v3.818c-.69.184-1.472.368-2.668.368-4.923 0-7.315-2.898-7.315-7.177V19.473h-3.727v-3.68h3.727v-4.877h3.864v4.877h6.119v3.68h-6.119v12.191c0 2.024 1.196 3.405 3.635 3.405ZM384.265 6.961c1.61 0 2.76 1.012 2.76 2.76s-1.15 2.76-2.76 2.76-2.76-1.012-2.76-2.76 1.15-2.76 2.76-2.76Zm-2.024 8.833h3.957v23.002h-3.957V15.794ZM408.416 38.198c-1.38.736-3.496 1.058-5.612 1.058-8.189 0-12.007-4.968-12.007-12.007 0-6.947 3.818-11.915 12.007-11.915 2.07 0 3.68.276 5.475 1.104v3.681c-1.472-.69-3.037-1.104-5.199-1.104-5.98 0-8.419 3.772-8.419 8.235s2.484 8.235 8.511 8.235c2.346 0 3.818-.322 5.244-.828v3.542ZM420.144 39.256c-3.451 0-6.257-.782-8.005-1.702v-4.187c1.978 1.15 5.291 2.254 8.188 2.254 3.037 0 4.601-1.242 4.601-3.036 0-1.749-1.334-2.761-5.705-3.818-5.106-1.242-7.269-3.221-7.269-6.993 0-4.002 3.082-6.44 8.327-6.44 2.99 0 5.705.736 7.407 1.656v4.094c-2.76-1.38-5.014-2.117-7.453-2.117-2.898 0-4.462 1.013-4.462 2.807 0 1.61 1.104 2.622 5.336 3.635 5.106 1.242 7.683 3.128 7.683 7.13 0 3.819-2.484 6.717-8.649 6.717Z\"/>\n  </g>\n  <path fill=\"url(#").concat(id, "-a)\" d=\"M445.285 30h4v10h-4z\"/>\n  <path fill=\"url(#").concat(id, "-b)\" d=\"M461.285 27h4v13h-4z\"/>\n  <path fill=\"url(#").concat(id, "-c)\" d=\"M453.285 22h4v18h-4z\"/>\n  <path fill=\"url(#").concat(id, "-d)\" d=\"M469.285 20h4v20h-4z\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m443.699 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\"/>\n</svg>");
};
var $95feedc4efaebf57$export$e6470bfc39010cc4 = function AtlassianAnalyticsLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $8a4e0f31a3c0be30$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        size: size,
        iconColor: iconColor,
        svg: $95feedc4efaebf57$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $8ad89f28fbf49cde$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95\"/>\n    </svg>");
};
var $8ad89f28fbf49cde$export$5fc1066e677788d4 = function BitbucketIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $8ad89f28fbf49cde$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $19440dcca25229ac$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 158 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill=".concat(colors.iconColor, " d=\"m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95\"/>\n        <path fill=").concat(colors.textColor, " d=\"M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z\"/>\n      </svg>");
};
var $19440dcca25229ac$export$bd40525f5333524b = function BitbucketLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $19440dcca25229ac$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $df6923e07315bf90$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z\"/>\n      </svg>\n    ");
};
var $df6923e07315bf90$export$f7857fe64d7161d9 = function CompassIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $df6923e07315bf90$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $607814e595771710$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 155 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path fill=".concat(colors.iconColor, " d=\"M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z\"/>\n    <path fill=\"").concat(colors.textColor, "\" d=\"M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n  </svg>");
};
var $607814e595771710$export$eb7d748e4f9c9676 = function CompassLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $607814e595771710$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $aa668dadae1ee6cd$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098\"/>\n    </svg>");
};
var $aa668dadae1ee6cd$export$68f3db7f6af48bcb = function ConfluenceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $aa668dadae1ee6cd$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $373ecfd01b587d78$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 180 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n    </svg>\n    ");
};
var $373ecfd01b587d78$export$1b2e4fe6ef471556 = function ConfluenceLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $373ecfd01b587d78$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $bde93df51b3897c4$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 48 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M45.4277 24.5018C41.4108 20.4849 34.8821 20.5276 30.908 24.5018L27.5636 27.8462C25.717 29.6927 22.7177 29.6927 20.8712 27.8462L18.0925 25.0675L10.8309 32.3291L13.6096 35.1078C19.4658 40.9641 28.9654 40.9641 34.8216 35.1078L45.4277 24.5018ZM3 23.5018C7.01684 27.5186 13.4637 27.5578 17.4805 23.5409L20.8676 20.1538C22.7142 18.3073 25.7135 18.3073 27.56 20.1538L30.3387 22.9325L37.6003 15.6709L34.8216 12.8922C28.9654 7.03593 19.4658 7.03593 13.6096 12.8922L3.00356 23.4982L3 23.5018Z\"/>\n\t\t</svg>\n\t\t");
};
var $bde93df51b3897c4$export$1e02e7298035a77c = function FocusIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $bde93df51b3897c4$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $2a97c4bc3293e3ce$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 168 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M42.4277 24.5018C38.4108 20.4849 31.8821 20.5276 27.908 24.5018L24.5636 27.8462C22.717 29.6927 19.7177 29.6927 17.8712 27.8462L15.0925 25.0675L7.83088 32.3291L10.6096 35.1078C16.4658 40.9641 25.9654 40.9641 31.8216 35.1078L42.4277 24.5018ZM0 23.5018C4.01684 27.5186 10.4637 27.5578 14.4805 23.5409L17.8676 20.1538C19.7142 18.3073 22.7135 18.3073 24.56 20.1538L27.3387 22.9325L34.6003 15.6709L31.8216 12.8922C25.9654 7.03593 16.4658 7.03593 10.6096 12.8922L0.00355592 23.4982L0 23.5018Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M167.405 31.746C167.405 35.564 164.921 38.462 158.757 38.462C155.307 38.462 152.501 37.68 150.753 36.76V32.574C152.731 33.724 156.043 34.828 158.941 34.828C161.977 34.828 163.541 33.586 163.541 31.792C163.541 30.044 162.207 29.032 157.837 27.974C152.731 26.732 150.569 24.754 150.569 20.982C150.569 16.98 153.651 14.542 158.895 14.542C161.885 14.542 164.599 15.278 166.301 16.198V20.292C163.541 18.912 161.287 18.176 158.849 18.176C155.951 18.176 154.387 19.188 154.387 20.982C154.387 22.592 155.491 23.604 159.723 24.616C164.829 25.858 167.405 27.744 167.405 31.746Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M126.009 28.48V15.002H129.965V28.894C129.965 33.034 131.621 34.874 135.393 34.874C139.073 34.874 141.603 32.436 141.603 27.79V15.002H145.559V38.002H141.603V34.23C140.131 36.944 137.417 38.462 134.335 38.462C129.045 38.462 126.009 34.828 126.009 28.48Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M121.953 33.862V37.404C120.573 38.14 118.457 38.462 116.341 38.462C108.153 38.462 104.335 33.494 104.335 26.456C104.335 19.51 108.153 14.542 116.341 14.542C118.411 14.542 120.021 14.818 121.815 15.646V19.326C120.343 18.636 118.779 18.222 116.617 18.222C110.637 18.222 108.199 21.994 108.199 26.456C108.199 30.918 110.683 34.69 116.709 34.69C119.055 34.69 120.527 34.368 121.953 33.862Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M90.2616 38.462C83.3616 38.462 79.3136 33.356 79.3136 26.456C79.3136 19.556 83.3616 14.542 90.2616 14.542C97.1156 14.542 101.118 19.556 101.118 26.456C101.118 33.356 97.1156 38.462 90.2616 38.462ZM90.2616 18.222C85.3396 18.222 83.1776 22.086 83.1776 26.456C83.1776 30.826 85.3396 34.782 90.2616 34.782C95.1376 34.782 97.2536 30.826 97.2536 26.456C97.2536 22.086 95.1376 18.222 90.2616 18.222Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M75.298 26.732H61.59V38.002H57.45V7.78003H76.862V11.736H61.59V22.776H75.298V26.732Z\"/>\n\t\t</svg>\n\t\t");
};
var $2a97c4bc3293e3ce$export$33908560ea1b226d = function FocusLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $2a97c4bc3293e3ce$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $053b89dee6a0094b$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M5.584 14.4h20.83c.599 0 .918-.32.918-.918V6.459c0-.599-.319-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v7.023c0 .599.319.918.917.918zm.36 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.199-.799.758-.799h20.191c.559 0 .798.24.798.719q-.12 2.214-.838 4.07c-.24.638-.598.918-1.277.918H7.221c-.679 0-1.038-.28-1.277-.918m18.475 3.312c-1.915 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.478-.638-.239-1.038.24-1.038h16.44c.48 0 .719.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $053b89dee6a0094b$export$3f95fcfdc25a741d = function GuardIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $053b89dee6a0094b$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $fecf9fe2b046b3a2$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 114 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $fecf9fe2b046b3a2$export$a4a891d202775deb = function GuardLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $fecf9fe2b046b3a2$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $807ff5327a76c7fe$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n    </svg>");
};
var $807ff5327a76c7fe$export$c4b5b1f965d8b3eb = function JiraIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $807ff5327a76c7fe$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $d47476c3a75b7640$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 77 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404\"/>\n    </svg>");
};
var $d47476c3a75b7640$export$17d3acb0b4379d02 = function JiraLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $d47476c3a75b7640$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $74e00d71dd66b21c$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path\n      fill=\"".concat(colors.iconColor, "\"\n      d=\"M25.52 25.727c0-3.604-2.949-6.517-6.517-6.517h-6.007v-5.497H6.48v10.813c0 .837.364 1.201 1.201 1.201zM6.48 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\"\n    />\n  </svg>");
};
var $74e00d71dd66b21c$export$407687b2dd89cc68 = function JiraAlignIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $74e00d71dd66b21c$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $1ff2ed273c1e5214$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg viewBox=\"0 0 146 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M19.04 25.727c0-3.604-2.949-6.517-6.517-6.517H6.517v-5.497H0v10.813c0 .837.364 1.201 1.201 1.201zM0 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\" fill=\"".concat(colors.iconColor, "\"/>\n      <path d=\"M144.993 16.555v8.985h-2.638v-9.26c0-2.76-1.104-3.988-3.618-3.988-2.454 0-4.14 1.626-4.14 4.723v8.525h-2.638V10.207h2.638v2.515c.981-1.81 2.79-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-19.589 7.759V22.78c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.465-6.072-7.973 0-4.324 2.116-7.974 6.379-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.054 5.152-4.906m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.975 0-4.508 1.962-4.508 5.52M107.96 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S110.873 8 109.8 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.638Zm-2.537-.03c-.215.061-.675.122-1.349.122-2.515 0-4.11-1.196-4.11-4.017V3.798h2.638v17.51c0 1.38.92 1.871 2.054 1.871.276 0 .46 0 .767-.03v2.36ZM88.83 21.523c-1.534 0-3.098-.184-4.815-.521l-1.687 4.539h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.57c-1.81.368-3.373.552-4.999.552Zm0-2.453c1.287 0 2.606-.153 4.17-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369Zm-27.807-1.196c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925ZM42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.637Zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" fill=\"").concat(colors.textColor, "\"/>\n    </svg>\n  ");
};
var $1ff2ed273c1e5214$export$ee11e928d3d045fd = function JiraAlignLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $1ff2ed273c1e5214$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $4f72d54064feed25$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z\"/>\n    </svg>");
};
var $4f72d54064feed25$export$21bfbeb62fdcce8d = function JiraProductDiscoveryIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $4f72d54064feed25$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $d4ffd9e5f2cef8fe$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 318 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $d4ffd9e5f2cef8fe$export$c49a2b642fe9eef4 = function JiraProductDiscoveryLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $d4ffd9e5f2cef8fe$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $f91c71cad280ca7f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z\"/>\n    </svg>");
};
var $f91c71cad280ca7f$export$3c6158790f5e01c4 = function JiraServiceManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $f91c71cad280ca7f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $07206c874cffd34a$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 362 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z\" />\n      <path fill=").concat(colors.textColor, " d=\"M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $07206c874cffd34a$export$dabef2be6cd28c20 = function JiraServiceManagementLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $07206c874cffd34a$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $3ddf4511117ec2bd$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$7818df200941dbbf)(appearance, colorMode);
    return "<svg\n    fill=\"none\"\n    height=\"32\"\n    viewBox=\"0 0 32 32\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    focusable=\"false\"\n    aria-hidden=\"true\"\n  >\n    <path\n      d=\"M27.333 15.508h-6.628l5.74-3.315-1.26-2.184-5.74 3.314 3.313-5.74-2.184-1.26-3.313 5.74V5.434h-2.522v6.628l-3.314-5.74-2.184 1.26 3.314 5.74-5.74-3.314-1.26 2.184 5.74 3.314H4.667v2.521h6.627l-5.74 3.314 1.261 2.184 5.74-3.313-3.314 5.74 2.184 1.26 3.314-5.74V28.1h2.521v-6.627l3.313 5.74 2.184-1.261-3.314-5.74 5.74 3.313 1.261-2.184-5.74-3.313h6.628zM16 20.198a3.442 3.442 0 1 1 0-6.885 3.442 3.442 0 0 1 0 6.884\"\n      fill=\"".concat(colors.iconColor, "\"\n    />\n  </svg>");
};
var $3ddf4511117ec2bd$export$8d789f76fde3e05 = function LoomIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $3ddf4511117ec2bd$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $63d22dd409edae8e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$7818df200941dbbf)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 98 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M29.657 13.659h-8.672l7.51-4.337-1.649-2.857-7.51 4.336 4.335-7.51-2.857-1.65-4.336 7.51V.479H13.18v8.672l-4.337-7.51-2.856 1.65 4.336 7.51-7.51-4.336-1.65 2.857 7.51 4.336H0v3.299h8.671l-7.51 4.336 1.65 2.858 7.51-4.336-4.336 7.51 2.857 1.65 4.336-7.511v8.672h3.3v-8.671l4.335 7.51 2.857-1.65-4.336-7.51 7.51 4.336 1.65-2.858-7.51-4.335h8.672v-3.3zM14.83 19.794a4.503 4.503 0 1 1 0-9.006 4.503 4.503 0 0 1 0 9.006\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M37.303 26.155V4.459h3.983v21.696zm38.204-14.743h3.803v1.798c.808-1.438 2.696-2.218 4.313-2.218 2.007 0 3.624.87 4.373 2.457 1.167-1.798 2.726-2.457 4.673-2.457 2.725 0 5.33 1.648 5.33 5.604v9.559h-3.862v-8.75c0-1.588-.78-2.786-2.607-2.786-1.707 0-2.726 1.318-2.726 2.907v8.63H84.85v-8.75c0-1.59-.808-2.787-2.606-2.787-1.738 0-2.757 1.288-2.757 2.907v8.63h-3.981zm-25.219 15.17c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.251 7.798-7.737 7.798m0-11.996a4.2 4.2 0 0 0-4.197 4.199c0 2.315 1.883 4.199 4.197 4.199s4.196-1.884 4.196-4.2a4.2 4.2 0 0 0-4.196-4.198m16.245 11.996c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.253 7.798-7.737 7.798m0-12.046c-2.34 0-4.245 1.906-4.245 4.247s1.904 4.247 4.245 4.247a4.25 4.25 0 0 0 4.245-4.247 4.25 4.25 0 0 0-4.245-4.247\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $63d22dd409edae8e$export$94e206806e36c2ec = function LoomLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $63d22dd409edae8e$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");


var $254ae2e514074c6b$export$1bf47cdade1a9fcb = function LoomAttributionIcon(_ref) {
    var appearance = _ref.appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, _ref$size = _ref.size, size = _ref$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref$size, testId = _ref.testId, _ref$iconColor = _ref.iconColor, iconColor = _ref$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref$iconColor, _ref$textColor = _ref.textColor, textColor = _ref$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3ddf4511117ec2bd$export$8d789f76fde3e05), {
        appearance: appearance,
        label: label,
        size: size,
        testId: testId,
        iconColor: iconColor,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $c779b4e9d6dc1521$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$7818df200941dbbf)(appearance, colorMode);
    return "<svg\n\t\tfill=\"none\"\n\t\theight=\"32\"\n\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\tfocusable=\"false\"\n\t\taria-hidden=\"true\"\n\t\tviewBox=\"0 0 88 32\"\n\t>\n\t\t<path\n\t\t\td=\"M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058\"\n\t\t\tfill=\"".concat(colors.iconColor, "\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z\"\n\t\t\tfill=\"").concat(colors.textColor, "\"\n\t\t/>\n\t</svg>");
};
var $c779b4e9d6dc1521$export$6e87ce8d41eda665 = function LoomAttributionLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom Attribution' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $c779b4e9d6dc1521$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $dd57b5534d9c8bad$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.114 28.127c-.785.578-1.199.537-1.984-.041-3.8-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.992.124c1.652 1.9 3.264 3.76 5.123 5.082 1.86-1.322 3.47-3.181 5.123-5.082q.434-.495.992-.124l4.297 2.686c.372.206.496.66.248.991-2.355 3.223-5.867 6.322-9.668 9.09m-.992-11.858c3.388 0 6.198-2.768 6.198-6.156s-2.81-6.239-6.198-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n    </svg>");
};
var $dd57b5534d9c8bad$export$eeccc49dc7a12d9f = function OpsgenieIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $dd57b5534d9c8bad$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $dd86d607cf9e8d92$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 154 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.78 28.127c-.785.578-1.198.537-1.983-.041-3.801-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.991.124c1.653 1.9 3.264 3.76 5.124 5.082 1.859-1.322 3.47-3.181 5.123-5.082q.435-.495.992-.124l4.297 2.686c.371.206.495.66.247.991-2.355 3.223-5.867 6.322-9.668 9.09m-.99-11.857c3.388 0 6.197-2.768 6.197-6.156s-2.81-6.239-6.197-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M146.689 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zM133.385 6.16c0-1.166.767-1.84 1.841-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84c-1.074 0-1.841-.675-1.841-1.84m.491 19.38V10.208h2.638v15.334zm-3.677-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-18.639-.614v-1.533c-.981 2.024-2.821 3.067-5.182 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.378-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.834 0 5.152-2.055 5.152-4.907m-8.678-6.44c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m-4.703 3.497c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.17-.52-5.336-1.134v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.89-1.84-3.802-2.545-3.404-.829-4.846-2.147-4.846-4.662 0-2.668 2.055-4.293 5.55-4.293 1.994 0 3.804.49 4.938 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.121 2.085 5.121 4.753m-16.274-3.496c0-3.68-1.472-5.52-4.202-5.52-2.36 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.509-1.962 4.509-5.52m-3.803 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.637V10.207h2.637v2.76c.981-2.024 2.821-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.147 7.973-6.44 7.973m-20.121 0c-6.225 0-9.721-4.293-9.721-10.426 0-6.072 3.496-10.335 9.721-10.335 6.195 0 9.69 4.263 9.69 10.335 0 6.133-3.495 10.426-9.69 10.426m0-18.124c-4.968 0-6.961 3.527-6.961 7.698 0 4.262 1.993 7.789 6.961 7.789 4.937 0 6.93-3.527 6.93-7.79 0-4.17-1.993-7.697-6.93-7.697\" />\n    </svg>");
};
var $dd86d607cf9e8d92$export$a1c6484cdecc2c4b = function OpsgenieLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $dd86d607cf9e8d92$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $8e27972843b9c298$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n    <g fill=\"".concat(colors.iconColor, "\" fill-rule=\"evenodd\">\n      <path d=\"M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z\"/>\n      <path d=\"m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z\"/>\n    </g>\n  </svg>");
};
var $8e27972843b9c298$export$e23ae35269442b4f = function RovoIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $8e27972843b9c298$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $907ff11a1071d0d7$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 100 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path\n        d=\"M12.393 4.246a2.79 2.79 0 0 0-2.735-.026.4.4 0 0 1-.05.033l-.001.001c-.606.35-1.048.91-1.257 1.558q-.129.404-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566A2.77 2.77 0 0 0 22 20.884v-9.487c0-.991-.532-1.912-1.392-2.408z\"\n        fill=\"".concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"m1.391 9 6.176-3.566a3.6 3.6 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155h.001l4.603 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.85.47-1.89.461-2.734-.026l-8.216-4.743A2.78 2.78 0 0 1 0 20.893v-9.486c0-.996.529-1.912 1.391-2.408z\"\n        fill=\"").concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"M91.688 25.848c-4.6 0-7.298-3.404-7.298-8.004S87.088 9.9 91.688 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004zm0-13.494c-3.28 0-4.722 2.576-4.722 5.49 0 2.913 1.441 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.41-5.49-4.662-5.49M77.675 25.54H74.15L68.2 10.208h2.76l4.968 13.094 4.938-13.095h2.76zm-17.462.308c-4.6 0-7.299-3.404-7.299-8.004s2.7-7.943 7.3-7.943c4.568 0 7.236 3.342 7.236 7.942s-2.668 8.004-7.237 8.004zm0-13.494c-3.281 0-4.723 2.576-4.723 5.49 0 2.913 1.442 5.55 4.723 5.55 3.25 0 4.661-2.637 4.661-5.55 0-2.914-1.41-5.49-4.66-5.49zM43.177 8.03H39.13v7.36h4.048c3.588 0 4.692-1.38 4.692-3.68 0-2.177-1.134-3.68-4.692-3.68zm7.452 3.619c0 3.036-1.288 5.09-3.956 5.949l4.938 7.943H48.36l-4.447-7.514H39.13v7.514h-2.76V5.393h7.115c4.815 0 7.145 2.392 7.145 6.256z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $907ff11a1071d0d7$export$a0f6cb8061290bbb = function RovoLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $907ff11a1071d0d7$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $68bc3c849d9fd0fe$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M16 12.604c-3.033 0-5.981 1.37-8.39 3.489q-.375.373-.748.373c-.208 0-.415-.124-.581-.332l-3.032-3.572c-.166-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706 3.655-3.24 8.1-5.067 12.627-5.067s8.97 1.827 12.626 5.067c.249.249.374.457.374.706 0 .166-.084.374-.25.581l-3.032 3.572c-.166.208-.373.332-.581.332q-.374 0-.748-.374c-2.409-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.365 0-6.106-2.742-6.106-6.064S12.635 13.85 16 13.85s6.106 2.7 6.106 6.064-2.741 6.063-6.105 6.063\"/>\n    </svg>");
};
var $68bc3c849d9fd0fe$export$f3f5aa321d88adf9 = function StatuspageIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $68bc3c849d9fd0fe$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $4821146c88fc2e7a$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 188 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M13 12.604c-3.032 0-5.98 1.37-8.39 3.489q-.373.373-.747.373c-.208 0-.416-.124-.582-.332L.25 12.562c-.167-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706C4.029 8.035 8.473 6.208 13 6.208s8.971 1.827 12.626 5.067c.25.249.374.457.374.706 0 .166-.083.374-.25.581l-3.031 3.572c-.166.208-.374.332-.582.332q-.373 0-.747-.374c-2.41-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.364 0-6.105-2.742-6.105-6.064S9.635 13.85 13 13.85c3.364 0 6.105 2.7 6.105 6.064s-2.74 6.063-6.105 6.063\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M180.293 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.981 2.024-2.821 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.982 2.024-2.822 3.066-5.183 3.066-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-16.091-7.666c0-3.68-1.472-5.52-4.201-5.52-2.361 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.508-1.962 4.508-5.52m-3.802 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.638V10.207h2.638v2.76c.981-2.024 2.821-3.066 5.182-3.066 4.079 0 6.134 3.465 6.134 7.973 0 4.324-2.147 7.973-6.44 7.973m-10.56-4.477c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.52-5.336-1.134v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.829-4.845-2.147-4.845-4.662 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-27.598-2.177v-8.985h2.638v9.26c0 2.76 1.104 3.988 3.618 3.988 2.454 0 4.14-1.626 4.14-4.723v-8.525h2.638V25.54h-2.638v-2.515c-.981 1.81-2.79 2.821-4.845 2.821-3.527 0-5.55-2.422-5.55-6.654m-7.155 1.596c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454H85.39zm-18.943-2.914c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-17.258-4.752c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454h-4.078zm-6.894-.798c0 3.496-2.085 5.858-7.084 5.858-3.894 0-5.704-.767-7.268-1.564v-2.822c1.871.982 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975 0-1.778-1.104-2.729-4.937-3.649-4.539-1.104-6.563-2.668-6.563-5.98 0-3.128 2.392-5.459 7.084-5.459 2.914 0 4.784.706 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.846 3.373 4.262 1.074 6.654 2.454 6.654 6.072\" />\n    </svg>");
};
var $4821146c88fc2e7a$export$bb4ae5b41b43be04 = function StatuspageLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $4821146c88fc2e7a$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $bf3ce5cac71ed0fb$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " clip-rule=\"evenodd\" d=\"M24.286 5.337H7.714a2.585 2.585 0 0 0-2.585 2.585v16.572a2.585 2.585 0 0 0 2.585 2.584h16.572a2.585 2.585 0 0 0 2.585-2.584V7.922a2.585 2.585 0 0 0-2.585-2.585m-9.791 15.66a.86.86 0 0 1-.859.858h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86zm8.362-4.953a.86.86 0 0 1-.859.859h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86z\" fill-rule=\"evenodd\"/>\n    </svg>");
};
var $bf3ce5cac71ed0fb$export$4384da9b8b140bf4 = function TrelloIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $bf3ce5cac71ed0fb$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $d72a3f3cf76878be$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 106 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" clip-rule=\"evenodd\" d=\"M19.157 4.67H2.585A2.585 2.585 0 0 0 0 7.255v16.572a2.585 2.585 0 0 0 2.585 2.585h16.572a2.585 2.585 0 0 0 2.584-2.585V7.255a2.585 2.585 0 0 0-2.584-2.585M9.365 20.33a.86.86 0 0 1-.858.858H4.873a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86zm8.362-4.952a.86.86 0 0 1-.858.858h-3.634a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86z\" fill-rule=\"evenodd\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M97.64 25.848c-4.6 0-7.298-3.404-7.298-8.004S93.04 9.9 97.64 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.494c-3.281 0-4.722 2.576-4.722 5.49 0 2.913 1.44 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.411-5.49-4.662-5.49M88.874 25.51c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-7.996 0c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zM65.532 12.293c-2.79 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.44-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196H61.085c.368 2.606 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zm-19.48-8.434v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M32.943 5.393H48.03V8.03h-6.164v17.511h-2.76V8.031h-6.164z\"/>\n    </svg>");
};
var $d72a3f3cf76878be$export$60e26212f3b61a28 = function TrelloLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $d72a3f3cf76878be$var$svg({
            appearance: appearance,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};




var $5FkrB = parcelRequire("5FkrB");




var $722ae65b25b74a2f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n    <path fill=\"".concat(colors.iconColor, "\" d=\"M27.545 24.817 16.96 3.647c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.126-2.167 8 0 4.002 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.816c-.834-1.25-1.084-1.334-1.292-1.334s-.333.084-.708.834L4.875 24.9c-.167.334-.208.459-.208.626 0 .333.291.666.916.666h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.875.334-2.917 0-2.917-1.292-5.751-2.292-7.251\"/>\n  </svg>\n  ");
};
var $722ae65b25b74a2f$export$94c87d39a54a1894 = function AtlassianMarketplaceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Marketplace' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $722ae65b25b74a2f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $90b44dd97a49007a$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 32 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.126-2.167 8.001 0 4 2.042 7.751 5.042 13.794.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.084-.708.834L4.875 24.462c-.167.333-.208.458-.208.625 0 .333.291.666.916.666h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.875.334-2.917 0-2.917-1.292-5.751-2.292-7.251\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $90b44dd97a49007a$export$a825993f361832f7 = function AtlassianAccessIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Access' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $90b44dd97a49007a$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};




var $5FkrB = parcelRequire("5FkrB");




var $37844134dd17fb96$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251\"/>\n    </svg>");
};
var $37844134dd17fb96$export$8a485e2e7ed91e8f = function AtlassianIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $37844134dd17fb96$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $fefa5e0a15da0ac0$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 198 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\">\n      <path fill=".concat(colors.iconColor, " d=\"M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"/>\n      <path fill=").concat(colors.atlassianLogoTextColor, " d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.265 0 1.061-.708 1.698-2.973 1.698-2.619 0-5.733-.92-7.785-2.123v4.813c1.627.778 3.751 1.698 7.785 1.698 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.298-2.902-.637-3.61-1.274-3.61-2.194 0-1.133 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.698v-4.6c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.17h4.318V9.979l1.769 4.035 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.821-4.883-9.201zm-27.319 0h-4.671v20.17h4.671zm-10.05 14.154c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.708 6.795 1.699v-4.6c-1.557-.78-3.893-1.346-6.653-1.346-5.238 0-7.927 2.265-7.927 5.946 0 2.972 1.344 5.308 6.794 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.618 0-5.733-.92-7.785-2.123v4.812c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.166v20.17h9.625l1.486-4.387h-6.44V5.166zm-19.039 0v4.317h5.167v15.854h4.741V9.483h5.592V5.166zm-6.866 0h-6.157L32 25.336h5.379l.99-3.396c1.204.353 2.478.566 3.752.566s2.548-.213 3.751-.567l.991 3.398h5.379c-.07 0-7.078-20.171-7.078-20.171M42.05 18.259c-.92 0-1.77-.141-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354zM97.326 5.166H91.17l-7.078 20.17h5.38l.99-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.114 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.093h-6.157l-7.007 20.17h5.379l.991-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.043 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354\"/>\n    </svg>");
};
var $fefa5e0a15da0ac0$export$765cacec8b0843f3 = function AtlassianLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $fefa5e0a15da0ac0$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};




var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $32c7a5ef60d1831d$var$_excluded = [
    "size",
    "shouldUseNewLogoDesign"
], $32c7a5ef60d1831d$var$_excluded2 = [
    "size",
    "shouldUseNewLogoDesign"
], $32c7a5ef60d1831d$var$_excluded3 = [
    "shouldUseHexLogo"
], $32c7a5ef60d1831d$var$_excluded4 = [
    "size"
];
/**
 * Creates a feature flagged component that renders the legacy logo or the new logo
 * based on the platform-logo-rebrand feature flag.
 *
 * @param LegacyComponent - The legacy logo component.
 * @param NewComponent - The new logo component.
 * @returns A feature flagged component that renders the legacy logo or the new logo.
 */ var $32c7a5ef60d1831d$export$e30d2ddc605f6bb = function createFeatureFlaggedComponent(LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref) {
        var size = _ref.size, shouldUseNewLogoDesign = _ref.shouldUseNewLogoDesign, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $32c7a5ef60d1831d$var$_excluded);
        if ((0, $b6ce737b04cf6b7e$export$b40ec24ac8275656)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            size: size || 'medium'
        }, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LegacyComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            size: size
        }, props));
    };
};
var $32c7a5ef60d1831d$export$436fcf6e31fbacea = function createFeatureFlaggedServiceCollectionComponent(LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref2) {
        var size = _ref2.size, shouldUseNewLogoDesign = _ref2.shouldUseNewLogoDesign, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $32c7a5ef60d1831d$var$_excluded2);
        if ((0, $b6ce737b04cf6b7e$export$b40ec24ac8275656)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            size: size || 'medium'
        }, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LegacyComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            size: size
        }, props));
    };
};
var $32c7a5ef60d1831d$export$2469203854060337 = function createFeatureFlaggedRovoComponent(LegacyComponent, NewComponent, NewHexComponent) {
    var RovoHexWrapped = $32c7a5ef60d1831d$export$667425256e2e7296(NewHexComponent);
    var RovoServiceCollectionWrapped = $32c7a5ef60d1831d$export$436fcf6e31fbacea(LegacyComponent, NewComponent);
    return function(_ref3) {
        var shouldUseHexLogo = _ref3.shouldUseHexLogo, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref3, $32c7a5ef60d1831d$var$_excluded3);
        // Return hex logo if feature flag enabled. Otherwise revert to old set of components
        if ((0, $b6ce737b04cf6b7e$export$b40ec24ac8275656)('platform-logo-rebrand-rovo-hex') || shouldUseHexLogo) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(RovoHexWrapped, props);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(RovoServiceCollectionWrapped, props);
    };
};
var $32c7a5ef60d1831d$export$667425256e2e7296 = function tempSizeWrapper(NewComponent) {
    return function(_ref4) {
        var size = _ref4.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref4, $32c7a5ef60d1831d$var$_excluded4);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            size: size || 'medium'
        }, props));
    };
};
var $32c7a5ef60d1831d$export$3fe521abfbbe6ab3 = function teamEUFlaggedIcon(LegacyComponent, NewComponent) {
    return function(props) {
        var Logo = (0, $b6ce737b04cf6b7e$export$b40ec24ac8275656)('platform-logo-rebrand-team-eu') ? $32c7a5ef60d1831d$export$667425256e2e7296(NewComponent) : $32c7a5ef60d1831d$export$667425256e2e7296(LegacyComponent);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Logo, props);
    };
};
var $32c7a5ef60d1831d$export$172fd793eb6ecac4 = [
    // Program logos
    {
        name: 'atlassian',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-access',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-marketplace',
        type: 'legacy',
        category: 'program'
    },
    // Home collection
    {
        name: 'home',
        type: 'new',
        category: 'app'
    },
    {
        name: 'hub',
        type: 'new',
        category: 'app'
    },
    // Teamwork collection
    {
        name: 'confluence',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'jira',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom-blurple',
        type: 'new',
        category: 'app',
        skipExample: true
    },
    {
        name: 'loom-attribution',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'rovo',
        type: 'rovo-hex',
        category: 'app'
    },
    // Strategy collection
    {
        name: 'align',
        type: 'new',
        category: 'app'
    },
    {
        name: 'focus',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'talent',
        type: 'new',
        category: 'app'
    },
    // App collection
    {
        name: 'jira-product-discovery',
        type: 'migration',
        category: 'app'
    },
    // Dev collection
    {
        name: 'bitbucket',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'compass',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'dx',
        type: 'new',
        category: 'app',
        skipLogo: true
    },
    {
        name: 'rovo-dev',
        type: 'new',
        category: 'app'
    },
    {
        name: 'rovo-dev-agent',
        type: 'new',
        category: 'agent'
    },
    // Customer collection
    {
        name: 'jira-service-management',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'assets',
        type: 'new',
        category: 'app'
    },
    {
        name: 'customer-service-management',
        type: 'new',
        category: 'app'
    },
    {
        name: 'opsgenie',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'statuspage',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'trello',
        type: 'migration',
        category: 'app'
    },
    // Platform Collection
    {
        name: 'admin',
        type: 'new',
        category: 'app'
    },
    {
        name: 'analytics',
        type: 'new',
        category: 'app'
    },
    {
        name: 'chat',
        type: 'new',
        category: 'app'
    },
    {
        name: 'goals',
        type: 'new',
        category: 'app'
    },
    {
        name: 'guard',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'projects',
        type: 'new',
        category: 'app'
    },
    {
        name: 'search',
        type: 'new',
        category: 'app'
    },
    {
        name: 'studio',
        type: 'new',
        category: 'app'
    },
    {
        name: 'teams',
        type: 'new',
        category: 'app'
    },
    // Data Center
    {
        name: 'jira-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'jira-service-management-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'confluence-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bitbucket-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bamboo',
        type: 'new',
        category: 'app'
    },
    {
        name: 'crowd',
        type: 'new',
        category: 'app'
    },
    // Deprecated
    {
        name: 'atlassian-administration',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-admin',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-analytics',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlas',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-align',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-software',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-work-management',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    }
];
var $32c7a5ef60d1831d$export$62e1212796a86b1b = $32c7a5ef60d1831d$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'program' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $32c7a5ef60d1831d$export$e0dee4a765830f4d = $32c7a5ef60d1831d$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'app' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $32c7a5ef60d1831d$export$a13ce90e90d7bfc1 = $32c7a5ef60d1831d$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'agent' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
}) || [];
var $32c7a5ef60d1831d$export$516fce44c502c1d3 = $32c7a5ef60d1831d$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'legacy';
});
var $32c7a5ef60d1831d$export$b805fae8e798ed39 = $32c7a5ef60d1831d$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'migration';
});
var $32c7a5ef60d1831d$export$3f9abd26214cd85f = $32c7a5ef60d1831d$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'new';
});


/**
 * __Admin icon__
 *
 * The Admin icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $e5c28807f044a60a$export$ef8e5f836dd989d3 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $42816eed69858c8d$export$ef8e5f836dd989d3));
var $e5c28807f044a60a$export$ebcd30672e67406 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $f75b13e9496c8aa2$export$61afcb38c001e19));
var $e5c28807f044a60a$export$af3460f51ce3602a = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $483e4eae5b0896bb$export$af3460f51ce3602a));
var $e5c28807f044a60a$export$c8415b6abe4a8587 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $f74d50e4aa1d9379$export$f0bac2b7ac3e3504));
var $e5c28807f044a60a$export$d89497e7f33ca6f5 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $8373c87ee8f07dfa$export$d89497e7f33ca6f5));
var $e5c28807f044a60a$export$48ca930f3071e3e4 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $bcf55440e1ac49e3$export$81c47abe19675c4c));
var $e5c28807f044a60a$export$52cd484a7ef4f2b9 = (0, $32c7a5ef60d1831d$export$3fe521abfbbe6ab3)((0, $ed33621c770c8f6f$export$52cd484a7ef4f2b9), (0, $7712961585b3c6e3$export$402a257da320c93c));
var $e5c28807f044a60a$export$9ca9881809919df8 = (0, $32c7a5ef60d1831d$export$3fe521abfbbe6ab3)((0, $422e6573ccf128d4$export$a529e78951cd6709), (0, $eed89fab9307a98b$export$a3af32a9109d706d));
/**
 * __Customer Service Management icon__
 *
 * The Customer service management icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $e5c28807f044a60a$export$6da5aa77c402ba0f = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $d29a2f476ea23fcc$export$6da5aa77c402ba0f));
var $e5c28807f044a60a$export$abc95e6180bb1d88 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $501906e2812827da$export$f597f0f7fadce0b9));
var $e5c28807f044a60a$export$9eb74917ea768ed4 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $054a7cc9a77efc09$export$9eb74917ea768ed4));
var $e5c28807f044a60a$export$d2577aa28451395f = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $44589a9683d32305$export$c527a545aa426db3));
var $e5c28807f044a60a$export$92c8767b874048d = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $899d9f8a72fd5810$export$92c8767b874048d));
var $e5c28807f044a60a$export$d5648119d5b68e90 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $cacaef9956f97a67$export$8b6b7f1b1b2367d3));
var $e5c28807f044a60a$export$80b8b269d8b5014e = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $012945d8e2fbfa71$export$80b8b269d8b5014e));
var $e5c28807f044a60a$export$fc9bd6687b80fe3b = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $d01ef7a6c70afe03$export$7a38180641471460));
var $e5c28807f044a60a$export$5ed3e1bb3b04fc02 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $ee859ead2c997d6c$export$5ed3e1bb3b04fc02));
var $e5c28807f044a60a$export$aeefab651bcf2338 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $d49a05cc2e75a98d$export$e3d1678155aaab99));
var $e5c28807f044a60a$export$8b784b3227531b3e = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $aede3667eebcd473$export$8b784b3227531b3e));
var $e5c28807f044a60a$export$f0750468d67c6902 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $1738a389ff1a4b17$export$4145bd793c9ed1d0));
var $e5c28807f044a60a$export$813cff80931d9dbf = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $967b8b902cad02df$export$813cff80931d9dbf));
var $e5c28807f044a60a$export$409b7a5b7f180eba = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $4b1bd776417e729e$export$58747af448450872));
var $e5c28807f044a60a$export$82eafebb825fc23f = (0, $32c7a5ef60d1831d$export$3fe521abfbbe6ab3)((0, $e63a46d3e5ee26b0$export$82eafebb825fc23f), (0, $7f925c2c05d86612$export$3599582ddc9fc5cf));
var $e5c28807f044a60a$export$e4c5487c9a8ae3b1 = (0, $32c7a5ef60d1831d$export$3fe521abfbbe6ab3)((0, $b400386b6118e9fc$export$fa08cbfe393f2a68), (0, $4a274402133bcfb4$export$d669f6cbbb67e061));
var $e5c28807f044a60a$export$290a0f24614cde9f = (0, $32c7a5ef60d1831d$export$3fe521abfbbe6ab3)((0, $71c085540a543398$export$290a0f24614cde9f), (0, $15c0e7b58291f7da$export$8bb9894377e04e04));
var $e5c28807f044a60a$export$8aceb78c659789b6 = (0, $32c7a5ef60d1831d$export$3fe521abfbbe6ab3)((0, $dd6e7f6bc9a5125a$export$273fd56580e523ae), (0, $11ae8c55cb332e8a$export$170353c338ac5f4a));
/**
 * __Talent icon__
 *
 * The Talent icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $e5c28807f044a60a$export$4b05688514531169 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $7d5bd85babd9d964$export$4b05688514531169));
var $e5c28807f044a60a$export$4f6453e012279f89 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $545ed004ae83180d$export$1b3979d995ebbc6e));
var $e5c28807f044a60a$export$1bcbc9c337da86da = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $ec2f473c5d030159$export$1bcbc9c337da86da));
var $e5c28807f044a60a$export$9b1a0a0c574cec2a = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $ec92cf1c4d78f147$export$bfd8d1c4da84ce71));
var $e5c28807f044a60a$export$e812398311cab9a3 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $9e5a8315f2f6dca2$export$e812398311cab9a3));
var $e5c28807f044a60a$export$765f5afcc1a5a7e3 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $3a004855a7d196e5$export$7c51958462d750e));
var $e5c28807f044a60a$export$d3ab16bbf4f954ee = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $ec366d15f1e808c3$export$d3ab16bbf4f954ee));
var $e5c28807f044a60a$export$36044946916e84a0 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $c4ad96900069ac69$export$cc55e2a4c4b40552));
var $e5c28807f044a60a$export$53305f1f2855d3be = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $cdf91bfd5129c5de$export$53305f1f2855d3be));
var $e5c28807f044a60a$export$5e06396bce773a3 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $663307540044c66a$export$b3e508cb103e1f93));
var $e5c28807f044a60a$export$eaf73f391f7103bd = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $7bcc6b150a03baab$export$eaf73f391f7103bd));
var $e5c28807f044a60a$export$6128b385660fd3c6 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $cabff14b4a4d22c8$export$3c371bdbcdfcdce));
var $e5c28807f044a60a$export$f8455b5667a3ee0c = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $7d3956dbe8d63e3e$export$f8455b5667a3ee0c));
var $e5c28807f044a60a$export$eb152ab3801b2ae3 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $69c118aaee2a1243$export$3224b07bc93ef23e));
var $e5c28807f044a60a$export$65fae0eaf343f2ca = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $c24549e1d7926fb7$export$65fae0eaf343f2ca));
var $e5c28807f044a60a$export$fffc0d480fb1ebf1 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $4e01efda4183800b$export$f64bc7a7f04428d0));
var $e5c28807f044a60a$export$74517ed253186308 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $d8e67cdbc001644b$export$74517ed253186308), (0, $42816eed69858c8d$export$ef8e5f836dd989d3));
var $e5c28807f044a60a$export$833abe6c2ce5ebfd = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $d34bb2adfdd493f4$export$833abe6c2ce5ebfd), (0, $f75b13e9496c8aa2$export$61afcb38c001e19));
var $e5c28807f044a60a$export$84109e099492cb5f = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $deef3d3b45588f0d$export$84109e099492cb5f), (0, $42816eed69858c8d$export$ef8e5f836dd989d3));
var $e5c28807f044a60a$export$f845d9b9254f0541 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $d33c9708982ababa$export$f845d9b9254f0541), (0, $f75b13e9496c8aa2$export$61afcb38c001e19));
var $e5c28807f044a60a$export$c42ad8a0b925c762 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $f554407486f95716$export$c42ad8a0b925c762), (0, $483e4eae5b0896bb$export$af3460f51ce3602a));
var $e5c28807f044a60a$export$e6470bfc39010cc4 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $95feedc4efaebf57$export$e6470bfc39010cc4), (0, $f74d50e4aa1d9379$export$f0bac2b7ac3e3504));
var $e5c28807f044a60a$export$5fc1066e677788d4 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $8ad89f28fbf49cde$export$5fc1066e677788d4), (0, $0f19a71cf5ef3443$export$5fc1066e677788d4));
var $e5c28807f044a60a$export$bd40525f5333524b = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $19440dcca25229ac$export$bd40525f5333524b), (0, $e971c6946cb1c8ba$export$f7ef5e5488e4b430));
var $e5c28807f044a60a$export$f7857fe64d7161d9 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $df6923e07315bf90$export$f7857fe64d7161d9), (0, $391da3670ec5c41a$export$f7857fe64d7161d9));
var $e5c28807f044a60a$export$eb7d748e4f9c9676 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $607814e595771710$export$eb7d748e4f9c9676), (0, $a1c2d8d9a6d45234$export$a16f50a81d183ce));
var $e5c28807f044a60a$export$9951d02c2d848122 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $dec238ff93319a00$export$9951d02c2d848122));
var $e5c28807f044a60a$export$68f3db7f6af48bcb = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $aa668dadae1ee6cd$export$68f3db7f6af48bcb), (0, $2f121db3d400a7f2$export$68f3db7f6af48bcb));
var $e5c28807f044a60a$export$1b2e4fe6ef471556 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $373ecfd01b587d78$export$1b2e4fe6ef471556), (0, $0b415cb06590d81b$export$a88b0b0da9ef63ce));
var $e5c28807f044a60a$export$70a0c2f5862937b6 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $ef02305e93d38cfe$export$70a0c2f5862937b6));
var $e5c28807f044a60a$export$1b8596b4b0ef673b = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $5407f49539ceea52$export$8b5103382c06639c));
var $e5c28807f044a60a$export$407687b2dd89cc68 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $74e00d71dd66b21c$export$407687b2dd89cc68), (0, $ef02305e93d38cfe$export$70a0c2f5862937b6));
var $e5c28807f044a60a$export$ee11e928d3d045fd = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $1ff2ed273c1e5214$export$ee11e928d3d045fd), (0, $5407f49539ceea52$export$8b5103382c06639c));
var $e5c28807f044a60a$export$c4b5b1f965d8b3eb = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $807ff5327a76c7fe$export$c4b5b1f965d8b3eb), (0, $701d5396eb72984c$export$c4b5b1f965d8b3eb));
var $e5c28807f044a60a$export$17d3acb0b4379d02 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $d47476c3a75b7640$export$17d3acb0b4379d02), (0, $840eb01c1734ebe0$export$bf4c5f97b468e8d6));
var $e5c28807f044a60a$export$21bfbeb62fdcce8d = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $4f72d54064feed25$export$21bfbeb62fdcce8d), (0, $78c17eeb06008ac8$export$21bfbeb62fdcce8d));
var $e5c28807f044a60a$export$c49a2b642fe9eef4 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $d4ffd9e5f2cef8fe$export$c49a2b642fe9eef4), (0, $083a696f8e2d95a0$export$602140a6a10b02bf));
var $e5c28807f044a60a$export$3c6158790f5e01c4 = (0, $32c7a5ef60d1831d$export$436fcf6e31fbacea)((0, $f91c71cad280ca7f$export$3c6158790f5e01c4), (0, $508ce61f11a3a789$export$3c6158790f5e01c4));
var $e5c28807f044a60a$export$dabef2be6cd28c20 = (0, $32c7a5ef60d1831d$export$436fcf6e31fbacea)((0, $07206c874cffd34a$export$dabef2be6cd28c20), (0, $4db70b2e6f76ba0c$export$de148263c75d2bc1));
var $e5c28807f044a60a$export$8d789f76fde3e05 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $3ddf4511117ec2bd$export$8d789f76fde3e05), (0, $77de63f0b90e2204$export$8d789f76fde3e05));
var $e5c28807f044a60a$export$94e206806e36c2ec = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $63d22dd409edae8e$export$94e206806e36c2ec), (0, $abb4c183d82eabca$export$78c0b4d8be34c9b2));
var $e5c28807f044a60a$export$1bf47cdade1a9fcb = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $254ae2e514074c6b$export$1bf47cdade1a9fcb), (0, $77de63f0b90e2204$export$8d789f76fde3e05));
var $e5c28807f044a60a$export$6e87ce8d41eda665 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $c779b4e9d6dc1521$export$6e87ce8d41eda665), (0, $7b6b7e76773b7419$export$68d7391318cdef11));
var $e5c28807f044a60a$export$e84e925618e0e5bc = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $04e5c7b99b518b6e$export$71743a944cb62e48));
var $e5c28807f044a60a$export$1940ba72c868b663 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $3977e5b1edd67333$export$38c7b37a3e5e8d70));
var $e5c28807f044a60a$export$eeccc49dc7a12d9f = (0, $32c7a5ef60d1831d$export$436fcf6e31fbacea)((0, $dd57b5534d9c8bad$export$eeccc49dc7a12d9f), (0, $ef3200acd4dd189e$export$eeccc49dc7a12d9f));
var $e5c28807f044a60a$export$a1c6484cdecc2c4b = (0, $32c7a5ef60d1831d$export$436fcf6e31fbacea)((0, $dd86d607cf9e8d92$export$a1c6484cdecc2c4b), (0, $7312026661045ee4$export$a5b9122e89b32ad3));
var $e5c28807f044a60a$export$f3f5aa321d88adf9 = (0, $32c7a5ef60d1831d$export$436fcf6e31fbacea)((0, $68bc3c849d9fd0fe$export$f3f5aa321d88adf9), (0, $4f9732d887e085b6$export$f3f5aa321d88adf9));
var $e5c28807f044a60a$export$bb4ae5b41b43be04 = (0, $32c7a5ef60d1831d$export$436fcf6e31fbacea)((0, $4821146c88fc2e7a$export$bb4ae5b41b43be04), (0, $535fb25abeb69827$export$2bc88a281410ffa7));
var $e5c28807f044a60a$export$4384da9b8b140bf4 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $bf3ce5cac71ed0fb$export$4384da9b8b140bf4), (0, $80ddb30da36b08ce$export$4384da9b8b140bf4));
var $e5c28807f044a60a$export$60e26212f3b61a28 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $d72a3f3cf76878be$export$60e26212f3b61a28), (0, $50e26eff8a8bc584$export$1b13139dfc0336af));
var $e5c28807f044a60a$export$e23ae35269442b4f = (0, $32c7a5ef60d1831d$export$2469203854060337)((0, $8e27972843b9c298$export$e23ae35269442b4f), (0, $70f94f8ec7b1b295$export$e23ae35269442b4f), (0, $2e769877b28b6c1c$export$9e62346a60cfb459));
var $e5c28807f044a60a$export$a0f6cb8061290bbb = (0, $32c7a5ef60d1831d$export$2469203854060337)((0, $907ff11a1071d0d7$export$a0f6cb8061290bbb), (0, $f8f680c2b9153e80$export$b0e15f0a1c9f4c55), (0, $e0c14a4c94331bbd$export$5e38d02efdb45577));
var $e5c28807f044a60a$export$3f95fcfdc25a741d = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $053b89dee6a0094b$export$3f95fcfdc25a741d), (0, $22b6ae01216a6a81$export$3f95fcfdc25a741d));
var $e5c28807f044a60a$export$a4a891d202775deb = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $fecf9fe2b046b3a2$export$a4a891d202775deb), (0, $0d052c1f365de2d0$export$2b896c4d595a4331));
var $e5c28807f044a60a$export$1e02e7298035a77c = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $bde93df51b3897c4$export$1e02e7298035a77c), (0, $7b0cb8c2403d85b2$export$1e02e7298035a77c));
var $e5c28807f044a60a$export$33908560ea1b226d = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $2a97c4bc3293e3ce$export$33908560ea1b226d), (0, $4997c0e4e5416e87$export$3a6e8b37e069a69d));



var $5Y5FQ = parcelRequire("5Y5FQ");

var $cS1ic = parcelRequire("cS1ic");

var $25nEq = parcelRequire("25nEq");

var $lAD7C = parcelRequire("lAD7C");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $75f76cf0d51f047e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $75f76cf0d51f047e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $75f76cf0d51f047e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $75f76cf0d51f047e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $75f76cf0d51f047e$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $75f76cf0d51f047e$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $75f76cf0d51f047e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $75f76cf0d51f047e$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $75f76cf0d51f047e$var$_objectSpread($75f76cf0d51f047e$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $1c70d42a822a2f86$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $1c70d42a822a2f86$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $1c70d42a822a2f86$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1c70d42a822a2f86$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1c70d42a822a2f86$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $1c70d42a822a2f86$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $1c70d42a822a2f86$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $1c70d42a822a2f86$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $1c70d42a822a2f86$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $1c70d42a822a2f86$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $75f76cf0d51f047e$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $dd4c2c210233ec7c$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $629ae1a8f7e1c5ec$export$5bf35293e545f20c() {
    var analyticsContext = (0, $dd4c2c210233ec7c$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $1c70d42a822a2f86$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $9dOvm = parcelRequire("9dOvm");
var $0a5917e19a4a8cd6$var$_process, $0a5917e19a4a8cd6$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $0a5917e19a4a8cd6$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($0a5917e19a4a8cd6$var$_process = globalThis.process) === null || $0a5917e19a4a8cd6$var$_process === void 0 || ($0a5917e19a4a8cd6$var$_process = $0a5917e19a4a8cd6$var$_process.env) === null || $0a5917e19a4a8cd6$var$_process === void 0 ? void 0 : $0a5917e19a4a8cd6$var$_process.JEST_WORKER_ID) !== undefined;
var $0a5917e19a4a8cd6$var$DEBUG_MODE = !$0a5917e19a4a8cd6$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($0a5917e19a4a8cd6$var$_process2 = globalThis.process) === null || $0a5917e19a4a8cd6$var$_process2 === void 0 || ($0a5917e19a4a8cd6$var$_process2 = $0a5917e19a4a8cd6$var$_process2.env) === null || $0a5917e19a4a8cd6$var$_process2 === void 0 ? void 0 : $0a5917e19a4a8cd6$var$_process2.NODE_ENV) !== 'production';
var $0a5917e19a4a8cd6$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$0a5917e19a4a8cd6$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $c6a4821229e06dbc$var$pkgName = '@atlaskit/platform-feature-flags';
var $c6a4821229e06dbc$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $c6a4821229e06dbc$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $c6a4821229e06dbc$var$ENV_ENABLE_PLATFORM_FF = $c6a4821229e06dbc$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $c6a4821229e06dbc$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $c6a4821229e06dbc$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $c6a4821229e06dbc$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $c6a4821229e06dbc$var$ENV_ENABLE_PLATFORM_FF || $c6a4821229e06dbc$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $c6a4821229e06dbc$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $c6a4821229e06dbc$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$c6a4821229e06dbc$var$globalVar[$c6a4821229e06dbc$export$7e41b1b2bdee3f98] = $c6a4821229e06dbc$var$globalVar[$c6a4821229e06dbc$export$7e41b1b2bdee3f98] || $c6a4821229e06dbc$var$DEFAULT_PFF_GLOBAL;
function $c6a4821229e06dbc$export$f2b591175b3e424c(resolver) {
    $c6a4821229e06dbc$var$globalVar[$c6a4821229e06dbc$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $c6a4821229e06dbc$export$6333b6aff9fc6275(flagKey) {
    if ($c6a4821229e06dbc$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $0a5917e19a4a8cd6$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $c6a4821229e06dbc$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $c6a4821229e06dbc$var$globalVar[$c6a4821229e06dbc$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $c6a4821229e06dbc$var$globalVar[$c6a4821229e06dbc$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $9dOvm.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $c6a4821229e06dbc$var$globalVar[$c6a4821229e06dbc$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $05870a9c637c37b9$export$ba05d765b8392e5e(flagResolver) {
    (0, $c6a4821229e06dbc$export$f2b591175b3e424c)(flagResolver);
}
function $05870a9c637c37b9$export$470e5c2be1411c89(name) {
    return (0, $c6a4821229e06dbc$export$6333b6aff9fc6275)(name);
}
function $05870a9c637c37b9$export$b40ec24ac8275656(name) {
    return (0, $c6a4821229e06dbc$export$6333b6aff9fc6275)(name);
}


var $c266bfb019ace8e2$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $c266bfb019ace8e2$var$react18UseId = ($c266bfb019ace8e2$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $c266bfb019ace8e2$var$_React$useId !== void 0 ? $c266bfb019ace8e2$var$_React$useId : undefined;
function $c266bfb019ace8e2$export$f680877a34711e37() {
    if ($c266bfb019ace8e2$var$react18UseId && (0, $05870a9c637c37b9$export$b40ec24ac8275656)('platform.design-system-team.react-18-use-id_mn8q4')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $c266bfb019ace8e2$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $c266bfb019ace8e2$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($c266bfb019ace8e2$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $c266bfb019ace8e2$export$6ee17796e3d70de2() {
    if ($c266bfb019ace8e2$var$react18UseId && (0, $05870a9c637c37b9$export$b40ec24ac8275656)('platform.design-system-team.react-18-use-id_mn8q4')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $c266bfb019ace8e2$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $b5lkZ.useUIDSeed)();
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
var $ae7f66a126864790$var$BORDER_WIDTH = 2;
var $ae7f66a126864790$var$baseFocusOutsideStyles = (0, $74Zh5.css)({
    outline: "".concat($ae7f66a126864790$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $ae7f66a126864790$var$BORDER_WIDTH
});
var $ae7f66a126864790$var$baseInsetStyles = (0, $74Zh5.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$ae7f66a126864790$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $ae7f66a126864790$var$focusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $ae7f66a126864790$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $ae7f66a126864790$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $ae7f66a126864790$var$insetFocusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $ae7f66a126864790$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $ae7f66a126864790$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $ae7f66a126864790$var$FocusRing = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $ae7f66a126864790$var$baseInsetStyles : $ae7f66a126864790$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $ae7f66a126864790$var$insetFocusRingStyles : $ae7f66a126864790$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $74Zh5.jsx)((0, $74Zh5.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $5FkrB.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $5FkrB.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$ae7f66a126864790$var$FocusRing.displayName = 'FocusRing';
var $ae7f66a126864790$export$2e2bcd8739ae039 = $ae7f66a126864790$var$FocusRing;



var $c8Tt7 = parcelRequire("c8Tt7");
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $8c59000063260604$export$4b84fd0e2c617bd = '#FFEBE6';
var $8c59000063260604$export$b34b069eff244586 = '#FFBDAD';
var $8c59000063260604$export$be802dd0d8b57f35 = '#FF8F73';
var $8c59000063260604$export$60847d42f9da92a6 = '#FF7452';
var $8c59000063260604$export$4a7404f376229999 = '#FF5630';
var $8c59000063260604$export$2010d0fb4295b346 = '#DE350B';
var $8c59000063260604$export$2837b5a1a71d5c02 = '#BF2600';
var $8c59000063260604$export$8d9596b529bbb9cf = '#FFFAE6';
var $8c59000063260604$export$41060a744ab0b7ae = '#FFF0B3';
var $8c59000063260604$export$1cc05bbbf340e559 = '#FFE380';
var $8c59000063260604$export$5aae31392d72caaa = '#FFC400';
var $8c59000063260604$export$c6930421db9fa514 = '#FFAB00';
var $8c59000063260604$export$59619663aa6500fb = '#FF991F';
var $8c59000063260604$export$874739ea9e379ab6 = '#FF8B00';
var $8c59000063260604$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $8c59000063260604$export$69a3bf21b9686c2b = '#ABF5D1';
var $8c59000063260604$export$afbce1382ec95f73 = '#79F2C0';
var $8c59000063260604$export$747d86715d4175de = '#57D9A3';
var $8c59000063260604$export$940e1f69e873f202 = '#36B37E';
var $8c59000063260604$export$a49394138f7b8e85 = '#00875A';
var $8c59000063260604$export$6fa04827ac68a4fb = '#006644';
var $8c59000063260604$export$226de0355ed012f8 = '#DEEBFF';
var $8c59000063260604$export$8c13c2ee36917869 = '#B3D4FF';
var $8c59000063260604$export$ecfc1dff386a3e7a = '#4C9AFF';
var $8c59000063260604$export$215b7063051591f1 = '#2684FF';
var $8c59000063260604$export$e62e8919cca44969 = '#0065FF';
var $8c59000063260604$export$b3de0ae08da2ce64 = '#0052CC';
var $8c59000063260604$export$a6ee3d71bc067634 = '#0747A6';
var $8c59000063260604$export$67f15409e87642a1 = '#669DF1';
var $8c59000063260604$export$f0539dbc42dbb067 = '#8FB8F6';
var $8c59000063260604$export$363e4475840015bb = '#EAE6FF';
var $8c59000063260604$export$4b0a4417ed59760f = '#C0B6F2';
var $8c59000063260604$export$6011520a64d9a187 = '#998DD9';
var $8c59000063260604$export$a7175d4e9206bc80 = '#8777D9';
var $8c59000063260604$export$b48405b95304b5a1 = '#6554C0';
var $8c59000063260604$export$c71e4279dd54a18d = '#5243AA';
var $8c59000063260604$export$147899de772240ec = '#403294';
var $8c59000063260604$export$2cf711fe14c66f06 = '#E6FCFF';
var $8c59000063260604$export$7a8f4d33f6f9772c = '#B3F5FF';
var $8c59000063260604$export$776c9c497ef08533 = '#79E2F2';
var $8c59000063260604$export$69cb3ca10c1e330e = '#00C7E6';
var $8c59000063260604$export$9dc1ef0f3f48059b = '#00B8D9';
var $8c59000063260604$export$7c835c78b6fcdef8 = '#00A3BF';
var $8c59000063260604$export$6036577f95c3877e = '#008DA6';
var $8c59000063260604$export$29a4f05edc054374 = '#FFFFFF';
var $8c59000063260604$export$e655ef011c4aa1a2 = '#FAFBFC';
var $8c59000063260604$export$9fdfb749e33cdf97 = '#F4F5F7';
var $8c59000063260604$export$3e51e8f1440314ba = '#EBECF0';
var $8c59000063260604$export$1ce2d1575d444ceb = '#DFE1E6';
var $8c59000063260604$export$8754fc7e6d8b3000 = '#C1C7D0';
var $8c59000063260604$export$c2e91cbeada39b8b = '#B3BAC5';
var $8c59000063260604$export$5f71e19f3a7ad9de = '#A5ADBA';
var $8c59000063260604$export$eaa8c8a70ac22806 = '#97A0AF';
var $8c59000063260604$export$7c87d337fb91a97d = '#8993A4';
var $8c59000063260604$export$d6447c357493214f = '#7A869A';
var $8c59000063260604$export$f563ee71e9ee74cd = '#6B778C';
var $8c59000063260604$export$e2ef2124cf4024b1 = '#5E6C84';
var $8c59000063260604$export$eece5f492e429f08 = '#505F79';
var $8c59000063260604$export$c39c0fe0f26207ae = '#42526E';
var $8c59000063260604$export$7090862dc3038a9f = '#344563';
var $8c59000063260604$export$ad0bacf983b7ddaa = '#253858';
var $8c59000063260604$export$7d61b15e0da132af = '#172B4D';
var $8c59000063260604$export$fbda843f0a27fe96 = '#091E42';
var $8c59000063260604$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $8c59000063260604$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $8c59000063260604$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $8c59000063260604$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $8c59000063260604$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $8c59000063260604$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $8c59000063260604$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $8c59000063260604$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $8c59000063260604$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $8c59000063260604$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $8c59000063260604$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $8c59000063260604$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $8c59000063260604$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $8c59000063260604$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $8c59000063260604$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $8c59000063260604$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $8c59000063260604$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $8c59000063260604$export$2f6319cf7d736c2a = '#E6EDFA';
var $8c59000063260604$export$95126bc8884d6634 = '#DCE5F5';
var $8c59000063260604$export$8338d8c35d44ff1 = '#CED9EB';
var $8c59000063260604$export$5368d76ae4fbbda7 = '#B8C7E0';
var $8c59000063260604$export$9f0a771d16ec8d36 = '#ABBBD6';
var $8c59000063260604$export$abcf8c38338b4aa5 = '#9FB0CC';
var $8c59000063260604$export$97e81faa16a182c7 = '#8C9CB8';
var $8c59000063260604$export$bfe21c59123ecf33 = '#7988A3';
var $8c59000063260604$export$ee82aa2ea6a1558 = '#67758F';
var $8c59000063260604$export$682927c6ed76be02 = '#56637A';
var $8c59000063260604$export$91fd9994c5be9757 = '#455166';
var $8c59000063260604$export$d281fbfe3cff2df6 = '#3B475C';
var $8c59000063260604$export$3902c91d8b98a753 = '#313D52';
var $8c59000063260604$export$8e8133c1ba5845b5 = '#283447';
var $8c59000063260604$export$33ff357f6620b39 = '#202B3D';
var $8c59000063260604$export$633847cf062b69e0 = '#1B2638';
var $8c59000063260604$export$9776a6e503bdbf76 = '#121A29';
var $8c59000063260604$export$6c813d5160dff5db = '#0E1624';
var $8c59000063260604$export$3d4f271a500072a = '#0D1424';
var $8c59000063260604$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $8c59000063260604$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $8c59000063260604$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $8c59000063260604$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $8c59000063260604$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $8c59000063260604$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $8c59000063260604$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $8c59000063260604$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $8c59000063260604$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $8c59000063260604$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $8c59000063260604$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $8c59000063260604$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $8c59000063260604$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $8c59000063260604$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $8c59000063260604$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $8c59000063260604$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $8c59000063260604$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $8c59000063260604$export$d2adc5dedf09fced = '#292A2E';
var $8c59000063260604$export$f51762073d2bb381 = '#94C748';
var $8c59000063260604$export$95e26d54def96891 = '#B3DF72';



var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
var $1ec978923a0f4fc0$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::67744cfb74ed451c0181f18c132cbdd7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($1ec978923a0f4fc0$exports, "__esModule", {
    value: true
});
$1ec978923a0f4fc0$exports.default = void 0;

var $1ec978923a0f4fc0$var$_react = $1ec978923a0f4fc0$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $1ec978923a0f4fc0$var$_person = $1ec978923a0f4fc0$var$_interopRequireDefault((parcelRequire("gENTG")));

var $1ec978923a0f4fc0$var$_person2 = $1ec978923a0f4fc0$var$_interopRequireDefault((parcelRequire("fjELu")));
function $1ec978923a0f4fc0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for PersonIcon.
 * This component is PersonIcon, with `UNSAFE_fallbackIcon` set to "PersonIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1ec978923a0f4fc0$var$PersonIcon = (props)=>/*#__PURE__*/ $1ec978923a0f4fc0$var$_react.default.createElement($1ec978923a0f4fc0$var$_person.default, Object.assign({
        LEGACY_fallbackIcon: $1ec978923a0f4fc0$var$_person2.default
    }, props));
$1ec978923a0f4fc0$var$PersonIcon.Name = 'PersonIconMigration';
var $1ec978923a0f4fc0$var$_default = $1ec978923a0f4fc0$exports.default = $1ec978923a0f4fc0$var$PersonIcon;


var $854c41d58fae7bc7$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::553e71e438a60de37e6f93988cb1bfa5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($854c41d58fae7bc7$exports, "__esModule", {
    value: true
});
$854c41d58fae7bc7$exports.default = void 0;

var $854c41d58fae7bc7$var$_react = $854c41d58fae7bc7$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $854c41d58fae7bc7$var$_release = $854c41d58fae7bc7$var$_interopRequireDefault((parcelRequire("3w44K")));

var $854c41d58fae7bc7$var$_ship = $854c41d58fae7bc7$var$_interopRequireDefault((parcelRequire("7EoFn")));
function $854c41d58fae7bc7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ReleaseIcon.
 * This component is ReleaseIcon, with `UNSAFE_fallbackIcon` set to "ShipIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $854c41d58fae7bc7$var$ReleaseIcon = (props)=>/*#__PURE__*/ $854c41d58fae7bc7$var$_react.default.createElement($854c41d58fae7bc7$var$_release.default, Object.assign({
        LEGACY_fallbackIcon: $854c41d58fae7bc7$var$_ship.default
    }, props));
$854c41d58fae7bc7$var$ReleaseIcon.Name = 'ReleaseIconMigration';
var $854c41d58fae7bc7$var$_default = $854c41d58fae7bc7$exports.default = $854c41d58fae7bc7$var$ReleaseIcon;



var $gENTG = parcelRequire("gENTG");

var $3w44K = parcelRequire("3w44K");

var $c8Tt7 = parcelRequire("c8Tt7");

// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
/* eslint-disable no-console */ var $115fe6a3a9d366f1$var$printed = {};
function $115fe6a3a9d366f1$export$2e2bcd8739ae039(message) {
    if ($115fe6a3a9d366f1$var$printed[message]) return;
    $115fe6a3a9d366f1$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}



var $3ZMUU = parcelRequire("3ZMUU");
function $767e9d663f70663d$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $115fe6a3a9d366f1$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $767e9d663f70663d$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $3ZMUU;
}



var $17ac36b9e8166c5c$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $17ac36b9e8166c5c$export$c93026a968943f95 = 'light';
var $17ac36b9e8166c5c$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $17ac36b9e8166c5c$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $17ac36b9e8166c5c$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $17ac36b9e8166c5c$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $8c59000063260604$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $17ac36b9e8166c5c$export$6d8204c2cb2e06b8() / 4;
    (0, $767e9d663f70663d$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $17ac36b9e8166c5c$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $17ac36b9e8166c5c$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $17ac36b9e8166c5c$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $767e9d663f70663d$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $17ac36b9e8166c5c$export$ba1d834b86d72a09 = $17ac36b9e8166c5c$export$a1b3edb637fb4f35;
var $17ac36b9e8166c5c$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $8c59000063260604$export$8d43898f60b96a82), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $8c59000063260604$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $8c59000063260604$export$920c0d5c49070351), ")")
            }
        }
    };
};


var $61e5774f84a75f10$export$9a270941bcff7e77 = {
    xsmall: (0, $17ac36b9e8166c5c$export$6d8204c2cb2e06b8)() * 2,
    small: (0, $17ac36b9e8166c5c$export$6d8204c2cb2e06b8)() * 3,
    medium: (0, $17ac36b9e8166c5c$export$6d8204c2cb2e06b8)() * 4,
    large: (0, $17ac36b9e8166c5c$export$6d8204c2cb2e06b8)() * 5,
    xlarge: (0, $17ac36b9e8166c5c$export$6d8204c2cb2e06b8)() * 12,
    xxlarge: (0, $17ac36b9e8166c5c$export$6d8204c2cb2e06b8)() * 16
};
var $61e5774f84a75f10$export$e6da6efe4d1a5c9b = {
    xsmall: 2,
    small: 2,
    medium: 3,
    large: 3,
    xlarge: 6,
    xxlarge: 12
};
var $61e5774f84a75f10$export$e2bd4c1faded7921 = 2;
var $61e5774f84a75f10$export$89a980dfdf90df51 = 0.9;
var $61e5774f84a75f10$export$3c061e31594ebabe = '--avatar-background-color';
var $61e5774f84a75f10$export$fdc820179f1f9be4 = {
    small: 12,
    medium: 14,
    large: 15,
    xlarge: 18
};
var $61e5774f84a75f10$export$382610e783aa2ae8 = {
    small: 0,
    medium: 0,
    large: 1,
    xlarge: 7
};


function $ab8f08636cc80173$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ab8f08636cc80173$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ab8f08636cc80173$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ab8f08636cc80173$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ab8f08636cc80173$var$avatarDefaultIconStyles = (0, $74Zh5.css)({
    display: 'flex',
    width: '100%',
    height: '100%',
    backgroundColor: "var(--ds-icon-subtle, ".concat((0, $8c59000063260604$export$7c87d337fb91a97d), ")")
});
var $ab8f08636cc80173$var$avatarDefaultIconVisualRefreshStyles = (0, $74Zh5.css)({
    display: 'flex',
    width: '100%',
    height: '100%',
    backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
});
var $ab8f08636cc80173$var$nestedAvatarStyles = Object.entries((0, $61e5774f84a75f10$export$9a270941bcff7e77)).reduce(function(styles, _ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], size = _ref2[1];
    return $ab8f08636cc80173$var$_objectSpread($ab8f08636cc80173$var$_objectSpread({}, styles), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& svg': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: "".concat(size, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: "".concat(size, "px")
        }
    })));
}, {});
var $ab8f08636cc80173$var$avatarImageStyles = (0, $74Zh5.css)({
    display: 'flex',
    width: '100%',
    height: '100%',
    flex: '1 1 100%'
});
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ var $ab8f08636cc80173$var$AvatarImage = function AvatarImage(_ref3) {
    var _ref3$alt = _ref3.alt, alt = _ref3$alt === void 0 ? '' : _ref3$alt, src = _ref3.src, appearance = _ref3.appearance, size = _ref3.size, testId = _ref3.testId;
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    var borderRadius = appearance === 'circle' ? '50%' : "".concat((0, $61e5774f84a75f10$export$e6da6efe4d1a5c9b)[size], "px");
    var isHidden = !alt ? true : undefined;
    // If src changes, reset state
    (0, $5FkrB.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return (0, $74Zh5.jsx)("span", {
        css: [
            (0, $c8Tt7.fg)('platform-component-visual-refresh') ? $ab8f08636cc80173$var$avatarDefaultIconVisualRefreshStyles : $ab8f08636cc80173$var$avatarDefaultIconStyles,
            $ab8f08636cc80173$var$nestedAvatarStyles[size]
        ]
    }, appearance === 'circle' ? (0, $c8Tt7.fg)('platform-component-visual-refresh') ? (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gENTG))), {
        label: alt,
        color: "var(--ds-icon-subtle, #626F86)",
        testId: testId && "".concat(testId, "--person"),
        spacing: "spacious"
    }) : (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1ec978923a0f4fc0$exports))), {
        label: alt,
        color: "var(--ds-icon-inverse, ".concat((0, $8c59000063260604$export$29a4f05edc054374), ")"),
        LEGACY_secondaryColor: "var(--ds-icon-subtle, ".concat((0, $8c59000063260604$export$7c87d337fb91a97d), ")"),
        testId: testId && "".concat(testId, "--person"),
        spacing: "spacious"
    }) : (0, $c8Tt7.fg)('platform-component-visual-refresh') ? (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3w44K))), {
        label: alt,
        color: "var(--ds-icon-subtle, #626F86)",
        testId: testId && "".concat(testId, "--ship"),
        spacing: "spacious"
    }) : (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($854c41d58fae7bc7$exports))), {
        label: alt,
        color: "var(--ds-icon-inverse, ".concat((0, $8c59000063260604$export$29a4f05edc054374), ")"),
        LEGACY_secondaryColor: "var(--ds-icon-subtle, ".concat((0, $8c59000063260604$export$7c87d337fb91a97d), ")"),
        testId: testId && "".concat(testId, "--ship"),
        spacing: "spacious"
    }));
    return (0, $74Zh5.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && "".concat(testId, "--image"),
        css: $ab8f08636cc80173$var$avatarImageStyles,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: borderRadius
        },
        onError: function onError() {
            return setHasImageErrored(true);
        },
        "aria-hidden": isHidden,
        "data-vc": testId ? "".concat(testId, "--image") : 'avatar-image',
        "data-ssr-placeholder-ignored": true
    });
};
var $ab8f08636cc80173$export$2e2bcd8739ae039 = $ab8f08636cc80173$var$AvatarImage;




var $5FkrB = parcelRequire("5FkrB");
var $d52acb751e558d18$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $d52acb751e558d18$export$b50b87a1c4086b23 = function useAvatarContext() {
    return (0, $5FkrB.useContext)($d52acb751e558d18$export$a20dad690e1279e2);
};



var $5FkrB = parcelRequire("5FkrB");


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $74Zh5 = parcelRequire("74Zh5");


var $0397340cd2230f68$var$iconWrapperStyles = (0, $74Zh5.css)({
    display: 'flex',
    boxSizing: 'border-box',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    alignContent: 'center',
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    overflow: 'hidden'
});
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ var $0397340cd2230f68$var$IconWrapper = function IconWrapper(_ref) {
    var _ref$bgColor = _ref.bgColor, bgColor = _ref$bgColor === void 0 ? "var(--ds-surface-overlay, ".concat((0, $8c59000063260604$export$29a4f05edc054374), ")") : _ref$bgColor, children = _ref.children;
    return (0, $74Zh5.jsx)("span", {
        css: $0397340cd2230f68$var$iconWrapperStyles,
        role: "presentation",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            border: "".concat((0, $61e5774f84a75f10$export$e2bd4c1faded7921), "px solid ").concat(bgColor),
            backgroundColor: bgColor
        }
    }, children);
};
var $0397340cd2230f68$export$2e2bcd8739ae039 = $0397340cd2230f68$var$IconWrapper;


var $737ff5795e5646ca$var$BusyIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $8c59000063260604$export$4a7404f376229999), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $8c59000063260604$export$29a4f05edc054374), ")"),
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
var $737ff5795e5646ca$var$FocusIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-icon-discovery, ".concat((0, $8c59000063260604$export$b48405b95304b5a1), ")"),
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
var $737ff5795e5646ca$var$OfflineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-text-subtlest, ".concat((0, $8c59000063260604$export$f563ee71e9ee74cd), ")"),
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $8c59000063260604$export$1ce2d1575d444ceb), ")"),
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
var $737ff5795e5646ca$var$OnlineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $8c59000063260604$export$940e1f69e873f202), ")"),
    cx: "4",
    cy: "4",
    r: "4"
});
function $737ff5795e5646ca$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $737ff5795e5646ca$var$BusyIndicator;
        case 'focus':
            return $737ff5795e5646ca$var$FocusIndicator;
        case 'offline':
            return $737ff5795e5646ca$var$OfflineIndicator;
        case 'online':
            return $737ff5795e5646ca$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ var $737ff5795e5646ca$var$AvatarPresence = function AvatarPresence(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, presence = _ref.presence;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0397340cd2230f68$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $737ff5795e5646ca$var$getPresence(presence)) : children);
};
var $737ff5795e5646ca$export$2e2bcd8739ae039 = $737ff5795e5646ca$var$AvatarPresence;
var $737ff5795e5646ca$export$972c5e90200fa0ef = function PresenceWrapper(_ref2) {
    var size = _ref2.size, appearance = _ref2.appearance, children = _ref2.children, borderColor = _ref2.borderColor, presence = _ref2.presence, testId = _ref2.testId;
    var position = appearance === 'square' ? -4 : (0, $61e5774f84a75f10$export$382610e783aa2ae8)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--presence"),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            pointerEvents: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            bottom: "".concat(position, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            height: "".concat((0, $61e5774f84a75f10$export$fdc820179f1f9be4)[size], "px"),
            right: "".concat(position, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: "".concat((0, $61e5774f84a75f10$export$fdc820179f1f9be4)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($737ff5795e5646ca$var$AvatarPresence, {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};



var $5FkrB = parcelRequire("5FkrB");



var $eecdbe0e7facaeb5$var$ApprovedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $8c59000063260604$export$a49394138f7b8e85), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $8c59000063260604$export$29a4f05edc054374), ")"),
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
var $eecdbe0e7facaeb5$var$DeclinedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $8c59000063260604$export$2010d0fb4295b346), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $8c59000063260604$export$29a4f05edc054374), ")"),
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
var $eecdbe0e7facaeb5$var$LockedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
    fill: "var(--ds-text-subtlest, ".concat((0, $8c59000063260604$export$1ce2d1575d444ceb), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $8c59000063260604$export$c39c0fe0f26207ae), ")"),
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
function $eecdbe0e7facaeb5$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $eecdbe0e7facaeb5$var$ApprovedIndicator;
        case 'declined':
            return $eecdbe0e7facaeb5$var$DeclinedIndicator;
        case 'locked':
            return $eecdbe0e7facaeb5$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ var $eecdbe0e7facaeb5$var$AvatarStatus = function AvatarStatus(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, status = _ref.status;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0397340cd2230f68$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $eecdbe0e7facaeb5$var$getStatus(status)) : children);
};
var $eecdbe0e7facaeb5$export$2e2bcd8739ae039 = $eecdbe0e7facaeb5$var$AvatarStatus;
var $eecdbe0e7facaeb5$export$8045894f255f9726 = function StatusWrapper(_ref2) {
    var size = _ref2.size, status = _ref2.status, appearance = _ref2.appearance, borderColor = _ref2.borderColor, children = _ref2.children, testId = _ref2.testId;
    var position = appearance === 'square' ? 0 : (0, $61e5774f84a75f10$export$382610e783aa2ae8)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--status"),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            height: "".concat((0, $61e5774f84a75f10$export$fdc820179f1f9be4)[size], "px"),
            right: "".concat(position, "px"),
            top: "".concat(position, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: "".concat((0, $61e5774f84a75f10$export$fdc820179f1f9be4)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($eecdbe0e7facaeb5$var$AvatarStatus, {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};


var $359aa0e0a643f965$export$60113ebe1cf0ecf = function getLinkProps(href, target) {
    return {
        href: href,
        rel: target === '_blank' ? 'noopener noreferrer' : null,
        target: target
    };
};
var $359aa0e0a643f965$export$cca6f1bef43616d3 = function getButtonProps(onClick) {
    return {
        type: 'button',
        onClick: onClick
    };
};
var $359aa0e0a643f965$export$83ee468102cdf04c = function getCustomElement(isDisabled, href, onClick) {
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled) return 'button';
    return 'span';
};


var $f31efb9f24b21b67$var$_templateObject;
function $f31efb9f24b21b67$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f31efb9f24b21b67$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f31efb9f24b21b67$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f31efb9f24b21b67$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f31efb9f24b21b67$var$packageName = "@atlaskit/avatar";
var $f31efb9f24b21b67$var$packageVersion = "21.18.4";
var $f31efb9f24b21b67$var$getTestId = function getTestId(testId, children) {
    return !children ? {
        'data-testid': "".concat(testId, "--inner")
    } : {
        testId: "".concat(testId, "--inner")
    };
};
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $f31efb9f24b21b67$var$getStyles = function getStyles(css, _ref) {
    var size = _ref.size, radius = _ref.radius, appearance = _ref.appearance, _ref$borderColor = _ref.borderColor, borderColor = _ref$borderColor === void 0 ? (0, $c8Tt7.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : "var(--ds-surface-overlay, ".concat((0, $8c59000063260604$export$29a4f05edc054374), ")") : _ref$borderColor, stackIndex = _ref.stackIndex, isInteractive = _ref.isInteractive, isDisabled = _ref.isDisabled;
    return css($f31efb9f24b21b67$var$_templateObject || ($f31efb9f24b21b67$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($lAD7C)))([
        "\n\t\theight: ",
        "px;\n\t\twidth: ",
        "px;\n\t\talign-items: stretch;\n\t\tbackground-color: ",
        ";\n\t\tborder-radius: ",
        ";\n\t\tbox-sizing: content-box;\n\t\tcursor: inherit;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\toutline: none;\n\t\toverflow: hidden;\n\t\tposition: static;\n\t\ttransform: translateZ(0);\n\t\ttransition:\n\t\t\ttransform 200ms,\n\t\t\topacity 200ms;\n\t\tbox-shadow: 0 0 0 ",
        "px ",
        ";\n\t\tborder: none;\n\t\tmargin: ",
        ";\n\t\tpadding: ",
        ";\n\n\t\t&::-moz-focus-inner {\n\t\t\tborder: 0;\n\t\t\tmargin: ",
        ";\n\t\t\tpadding: ",
        ";\n\t\t}\n\n\t\t&::after {\n\t\t\tbackground-color: transparent;\n\t\t\tinset: 0px;\n\n\t\t\t/* Added border-radius style to fix hover issue in safari */\n\t\t\tborder-radius: ",
        ";\n\t\t\tcontent: ' ';\n\t\t\topacity: 0;\n\t\t\tpointer-events: none;\n\t\t\tposition: absolute;\n\t\t\ttransition: opacity 200ms;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t:focus-visible {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t",
        "\n\n\t\t",
        "\n\n    ",
        "\n\t"
    ])), size, size, borderColor, appearance === 'circle' ? '50%' : "".concat(radius, "px"), (0, $61e5774f84a75f10$export$e2bd4c1faded7921), borderColor, "var(--ds-space-025, 2px)", "var(--ds-space-0, 0px)", "var(--ds-space-0, 0px)", "var(--ds-space-0, 0px)", appearance === 'circle' ? '50%' : "".concat(radius, "px"), stackIndex && "position: relative;", isInteractive && "\n      cursor: pointer;\n\n      :hover {\n        &::after {\n          background-color: ".concat("var(--ds-interaction-hovered, ".concat((0, $8c59000063260604$export$6e5e7499ff054f6d), ")"), ";\n          opacity: 1;\n        }\n      }\n\n      :active {\n        &::after {\n          background-color: ", "var(--ds-interaction-pressed, ".concat((0, $8c59000063260604$export$6e5e7499ff054f6d), ")"), ";\n          opacity: 1;\n        }\n      }\n\n      :active {\n        transform: scale(", (0, $61e5774f84a75f10$export$89a980dfdf90df51), ");\n      }\n\n      @media screen and (forced-colors: active) {\n        &:focus-visible {\n          outline: 1px solid\n        }\n      }\n    "), isDisabled && "\n        cursor: not-allowed;\n\n        &::after {\n          opacity: ".concat("var(--ds-opacity-disabled, 0.7)", ";\n          pointer-events: none;\n          background-color: ", "var(--ds-surface, ".concat((0, $8c59000063260604$export$29a4f05edc054374), ")"), ";\n        }\n      "));
};
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ var $f31efb9f24b21b67$var$Avatar = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var _ref3;
    var analyticsContext = _ref2.analyticsContext, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'circle' : _ref2$appearance, label = _ref2.label, borderColor = _ref2.borderColor, children = _ref2.children, href = _ref2.href, isDisabled = _ref2.isDisabled, name = _ref2.name, onClick = _ref2.onClick, presence = _ref2.presence, sizeProp = _ref2.size, src = _ref2.src, stackIndex = _ref2.stackIndex, status = _ref2.status, target = _ref2.target, testId = _ref2.testId, _ref2$as = _ref2.as, AvatarContainer = _ref2$as === void 0 ? 'div' : _ref2$as;
    var _useAnalyticsEvents = (0, $629ae1a8f7e1c5ec$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var context = (0, $d52acb751e558d18$export$b50b87a1c4086b23)();
    var size = (_ref3 = sizeProp !== null && sizeProp !== void 0 ? sizeProp : context === null || context === void 0 ? void 0 : context.size) !== null && _ref3 !== void 0 ? _ref3 : 'medium';
    var customPresenceNode = /*#__PURE__*/ (0, $5FkrB.isValidElement)(presence) ? presence : null;
    var customStatusNode = /*#__PURE__*/ (0, $5FkrB.isValidElement)(status) ? status : null;
    var isValidIconSize = size !== 'xxlarge' && size !== 'xsmall';
    var lastAnalytics = (0, $5FkrB.useRef)(analyticsContext);
    var labelId = (0, $c266bfb019ace8e2$export$f680877a34711e37)();
    (0, $5FkrB.useEffect)(function() {
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    var onClickHandler = (0, $5FkrB.useCallback)(function(event) {
        if (isDisabled || typeof onClick !== 'function') return;
        var analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $f31efb9f24b21b67$var$packageName,
                packageVersion: $f31efb9f24b21b67$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ var context = $f31efb9f24b21b67$var$_objectSpread({
            componentName: 'avatar',
            packageName: $f31efb9f24b21b67$var$packageName,
            packageVersion: $f31efb9f24b21b67$var$packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    var componentProps = function componentProps() {
        if (isDisabled) return {
            disabled: true
        };
        // return only relevant props for either anchor or button elements
        return $f31efb9f24b21b67$var$_objectSpread($f31efb9f24b21b67$var$_objectSpread({}, href && (0, $359aa0e0a643f965$export$60113ebe1cf0ecf)(href, target)), onClick && !href ? (0, $359aa0e0a643f965$export$cca6f1bef43616d3)(onClickHandler) : {
            onClick: onClick
        });
    };
    var isPresence = isValidIconSize && presence && !status;
    var isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    var defaultLabel = [
        name,
        isStatus && !customStatusNode && "(".concat(status, ")"),
        isPresence && !customPresenceNode && "(".concat(presence, ")")
    ].filter(Boolean).join(' ');
    var isInteractive = onClick || href || isDisabled;
    var containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return (0, $74Zh5.jsx)(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? 'img' : undefined,
        "aria-labelledby": containerShouldBeImage ? labelId : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            outline: 0,
            zIndex: stackIndex
        }
    }, (0, $74Zh5.jsx)((0, $74Zh5.ClassNames), null, function(_ref4) {
        var css = _ref4.css;
        var props = $f31efb9f24b21b67$var$_objectSpread($f31efb9f24b21b67$var$_objectSpread($f31efb9f24b21b67$var$_objectSpread($f31efb9f24b21b67$var$_objectSpread({
            className: $f31efb9f24b21b67$var$getStyles(css, {
                size: (0, $61e5774f84a75f10$export$9a270941bcff7e77)[size],
                radius: (0, $61e5774f84a75f10$export$e6da6efe4d1a5c9b)[size],
                appearance: appearance,
                borderColor: borderColor,
                stackIndex: stackIndex,
                isInteractive: Boolean(href || onClick) && !isDisabled,
                isDisabled: isDisabled
            })
        }, componentProps()), testId && $f31efb9f24b21b67$var$getTestId(testId, children)), (isInteractive || children) && {
            'aria-label': label || defaultLabel
        }), {}, {
            children: (0, $74Zh5.jsx)((0, $ab8f08636cc80173$export$2e2bcd8739ae039), {
                alt: !containerShouldBeImage && src ? name : undefined,
                appearance: appearance,
                size: size,
                src: src,
                testId: testId
            }),
            ref: ref
        });
        if (children) return children(props);
        var element = (0, $359aa0e0a643f965$export$83ee468102cdf04c)(isDisabled, href, onClick);
        return element === 'a' || element === 'button' ? (0, $74Zh5.jsx)((0, $ae7f66a126864790$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, $5FkrB.createElement)(element, props)) : /*#__PURE__*/ (0, $5FkrB.createElement)(element, props);
    }), isPresence && (0, $74Zh5.jsx)((0, $737ff5795e5646ca$export$972c5e90200fa0ef), {
        appearance: appearance,
        size: size,
        presence: typeof presence === 'string' ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && (0, $74Zh5.jsx)((0, $eecdbe0e7facaeb5$export$8045894f255f9726), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: typeof status === 'string' ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? (0, $74Zh5.jsx)("span", {
        "data-testid": testId && "".concat(testId, "--label"),
        id: labelId,
        hidden: true
    }, defaultLabel) : undefined);
});
$f31efb9f24b21b67$var$Avatar.displayName = 'Avatar';
var $f31efb9f24b21b67$export$2e2bcd8739ae039 = $f31efb9f24b21b67$var$Avatar;



/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $9dOvm = parcelRequire("9dOvm");
var $f028fae028ea8575$var$_process, $f028fae028ea8575$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $f028fae028ea8575$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($f028fae028ea8575$var$_process = globalThis.process) === null || $f028fae028ea8575$var$_process === void 0 || ($f028fae028ea8575$var$_process = $f028fae028ea8575$var$_process.env) === null || $f028fae028ea8575$var$_process === void 0 ? void 0 : $f028fae028ea8575$var$_process.JEST_WORKER_ID) !== undefined;
var $f028fae028ea8575$var$DEBUG_MODE = !$f028fae028ea8575$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($f028fae028ea8575$var$_process2 = globalThis.process) === null || $f028fae028ea8575$var$_process2 === void 0 || ($f028fae028ea8575$var$_process2 = $f028fae028ea8575$var$_process2.env) === null || $f028fae028ea8575$var$_process2 === void 0 ? void 0 : $f028fae028ea8575$var$_process2.NODE_ENV) !== 'production';
var $f028fae028ea8575$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$f028fae028ea8575$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $89e6f7c3b6ac7699$var$pkgName = '@atlaskit/platform-feature-flags';
var $89e6f7c3b6ac7699$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $89e6f7c3b6ac7699$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $89e6f7c3b6ac7699$var$ENV_ENABLE_PLATFORM_FF = $89e6f7c3b6ac7699$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $89e6f7c3b6ac7699$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $89e6f7c3b6ac7699$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $89e6f7c3b6ac7699$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $89e6f7c3b6ac7699$var$ENV_ENABLE_PLATFORM_FF || $89e6f7c3b6ac7699$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $89e6f7c3b6ac7699$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $89e6f7c3b6ac7699$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$89e6f7c3b6ac7699$var$globalVar[$89e6f7c3b6ac7699$export$7e41b1b2bdee3f98] = $89e6f7c3b6ac7699$var$globalVar[$89e6f7c3b6ac7699$export$7e41b1b2bdee3f98] || $89e6f7c3b6ac7699$var$DEFAULT_PFF_GLOBAL;
function $89e6f7c3b6ac7699$export$f2b591175b3e424c(resolver) {
    $89e6f7c3b6ac7699$var$globalVar[$89e6f7c3b6ac7699$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $89e6f7c3b6ac7699$export$6333b6aff9fc6275(flagKey) {
    if ($89e6f7c3b6ac7699$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $f028fae028ea8575$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $89e6f7c3b6ac7699$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $89e6f7c3b6ac7699$var$globalVar[$89e6f7c3b6ac7699$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $89e6f7c3b6ac7699$var$globalVar[$89e6f7c3b6ac7699$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $9dOvm.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $89e6f7c3b6ac7699$var$globalVar[$89e6f7c3b6ac7699$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $07ffd18a06aa0227$export$ba05d765b8392e5e(flagResolver) {
    (0, $89e6f7c3b6ac7699$export$f2b591175b3e424c)(flagResolver);
}
function $07ffd18a06aa0227$export$470e5c2be1411c89(name) {
    return (0, $89e6f7c3b6ac7699$export$6333b6aff9fc6275)(name);
}
function $07ffd18a06aa0227$export$b40ec24ac8275656(name) {
    return (0, $89e6f7c3b6ac7699$export$6333b6aff9fc6275)(name);
}



var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $5FkrB = parcelRequire("5FkrB");
var $5a5dcf11228e3e89$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $5a5dcf11228e3e89$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($5a5dcf11228e3e89$export$1ca2a26fecb070ae);
};
$5a5dcf11228e3e89$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';



var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");
var $79c25bbc4e071f75$export$4ef52930e33717cd = 'data-theme';
var $79c25bbc4e071f75$export$a00eac3f8684bcd0 = 'data-color-mode';
var $79c25bbc4e071f75$export$2112803007239c61 = 'data-contrast-mode';
var $79c25bbc4e071f75$export$352e418ed5b6193a = 'data-custom-theme';
var $79c25bbc4e071f75$export$2faeed762aac6741 = 'light';
var $79c25bbc4e071f75$export$6f0c6fb8c80fcc92 = 'ds';
var $79c25bbc4e071f75$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $79c25bbc4e071f75$export$dddac1532e822863 = "--".concat($79c25bbc4e071f75$export$6f0c6fb8c80fcc92, "-token-not-found");
var $79c25bbc4e071f75$export$9d7b58831ae93caa = "--".concat($79c25bbc4e071f75$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $fda1bdf5cf68a2eb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fda1bdf5cf68a2eb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fda1bdf5cf68a2eb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fda1bdf5cf68a2eb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $fda1bdf5cf68a2eb$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $fda1bdf5cf68a2eb$export$632685d741f3dbbf = $fda1bdf5cf68a2eb$var$_objectSpread($fda1bdf5cf68a2eb$var$_objectSpread({}, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4), $fda1bdf5cf68a2eb$export$d2dc61f58390201c);
var $fda1bdf5cf68a2eb$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $fda1bdf5cf68a2eb$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $fda1bdf5cf68a2eb$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $fda1bdf5cf68a2eb$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $fda1bdf5cf68a2eb$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $fda1bdf5cf68a2eb$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $fda1bdf5cf68a2eb$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $fda1bdf5cf68a2eb$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $fda1bdf5cf68a2eb$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $fda1bdf5cf68a2eb$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $fda1bdf5cf68a2eb$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $fda1bdf5cf68a2eb$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $fda1bdf5cf68a2eb$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $fda1bdf5cf68a2eb$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $fda1bdf5cf68a2eb$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $fda1bdf5cf68a2eb$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $fda1bdf5cf68a2eb$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $fda1bdf5cf68a2eb$export$e615f061ca585a6c = $fda1bdf5cf68a2eb$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $fda1bdf5cf68a2eb$export$ca0f9c2de39ffed7(spacingProperty, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $fda1bdf5cf68a2eb$export$bf46c3f9eeafc71f = $fda1bdf5cf68a2eb$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $fda1bdf5cf68a2eb$export$ca0f9c2de39ffed7(spacingProperty, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $fda1bdf5cf68a2eb$export$e7af83bafe7f9e63 = $fda1bdf5cf68a2eb$export$ca0f9c2de39ffed7('backgroundColor', $fda1bdf5cf68a2eb$export$d1d79bf68ac056bd);
var $fda1bdf5cf68a2eb$export$3a1bcba60b23d7f0 = $fda1bdf5cf68a2eb$export$ca0f9c2de39ffed7('color', $fda1bdf5cf68a2eb$export$8473307aa00d6ea1);
var $fda1bdf5cf68a2eb$export$45f3f4fe16f9f7d5 = $fda1bdf5cf68a2eb$export$ca0f9c2de39ffed7('fontWeight', $fda1bdf5cf68a2eb$export$303e322c6b1ed114);
var $fda1bdf5cf68a2eb$export$68cc305da27dbaa4 = $fda1bdf5cf68a2eb$export$ca0f9c2de39ffed7('fontFamily', $fda1bdf5cf68a2eb$export$3c7e9587132614b4);
var $fda1bdf5cf68a2eb$export$128f10c238242f83 = $fda1bdf5cf68a2eb$export$ca0f9c2de39ffed7('font', $fda1bdf5cf68a2eb$export$6ffa317d5e70375);
var $fda1bdf5cf68a2eb$export$219d364c0da35ae4 = $fda1bdf5cf68a2eb$export$ca0f9c2de39ffed7('font', $fda1bdf5cf68a2eb$export$236bfe3a33ef1292);
var $fda1bdf5cf68a2eb$export$38845ca010b93505 = $fda1bdf5cf68a2eb$export$ca0f9c2de39ffed7('fontWeight', $fda1bdf5cf68a2eb$export$855cfd311192d666);
var $fda1bdf5cf68a2eb$export$ff257d957d48c421 = $fda1bdf5cf68a2eb$export$ca0f9c2de39ffed7((0, $79c25bbc4e071f75$export$9d7b58831ae93caa), $fda1bdf5cf68a2eb$export$41a358c9c2356760);
var $fda1bdf5cf68a2eb$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $fda1bdf5cf68a2eb$export$41a358c9c2356760[color] !== undefined;
};



var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $74Zh5 = parcelRequire("74Zh5");


var $3ZMUU = parcelRequire("3ZMUU");
function $efa3c762c3cee56f$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $efa3c762c3cee56f$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $efa3c762c3cee56f$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $efa3c762c3cee56f$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $efa3c762c3cee56f$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $efa3c762c3cee56f$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $efa3c762c3cee56f$export$9a199fbafee0014e = {
    backgroundColor: (0, $fda1bdf5cf68a2eb$export$d1d79bf68ac056bd),
    blockSize: (0, $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $fda1bdf5cf68a2eb$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $fda1bdf5cf68a2eb$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $fda1bdf5cf68a2eb$export$e1b83c5210c471b8),
    borderBottomColor: (0, $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $fda1bdf5cf68a2eb$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $fda1bdf5cf68a2eb$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $fda1bdf5cf68a2eb$export$e1b83c5210c471b8),
    borderColor: (0, $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $fda1bdf5cf68a2eb$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $fda1bdf5cf68a2eb$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $fda1bdf5cf68a2eb$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $fda1bdf5cf68a2eb$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $fda1bdf5cf68a2eb$export$e1b83c5210c471b8),
    borderLeftColor: (0, $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $fda1bdf5cf68a2eb$export$e1b83c5210c471b8),
    borderRadius: (0, $fda1bdf5cf68a2eb$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $fda1bdf5cf68a2eb$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $fda1bdf5cf68a2eb$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $fda1bdf5cf68a2eb$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $fda1bdf5cf68a2eb$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $fda1bdf5cf68a2eb$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $fda1bdf5cf68a2eb$export$e1b83c5210c471b8),
    borderWidth: (0, $fda1bdf5cf68a2eb$export$e1b83c5210c471b8),
    bottom: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    boxShadow: (0, $fda1bdf5cf68a2eb$export$7aff6e7ba39bb774),
    color: (0, $fda1bdf5cf68a2eb$export$8473307aa00d6ea1),
    columnGap: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    font: (0, $fda1bdf5cf68a2eb$export$6ffa317d5e70375),
    fontFamily: (0, $fda1bdf5cf68a2eb$export$3c7e9587132614b4),
    fontWeight: (0, $fda1bdf5cf68a2eb$export$303e322c6b1ed114),
    gap: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    height: (0, $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f),
    inlineSize: (0, $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f),
    inset: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    insetBlock: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    insetBlockEnd: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    insetBlockStart: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    insetInline: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    insetInlineEnd: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    insetInlineStart: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    left: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    margin: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    marginBlock: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    marginBlockEnd: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    marginBlockStart: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    marginBottom: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    marginInline: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    marginInlineEnd: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    marginInlineStart: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    marginLeft: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    marginRight: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    marginTop: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    maxBlockSize: (0, $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f),
    maxHeight: (0, $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f),
    maxWidth: (0, $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f),
    minBlockSize: (0, $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f),
    minHeight: (0, $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f),
    minInlineSize: (0, $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f),
    minWidth: (0, $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f),
    opacity: (0, $fda1bdf5cf68a2eb$export$daf94a976c798b4f),
    outlineColor: (0, $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac),
    outlineOffset: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    outlineWidth: (0, $fda1bdf5cf68a2eb$export$e1b83c5210c471b8),
    padding: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    paddingBlock: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    paddingBottom: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    paddingInline: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    paddingLeft: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    paddingRight: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    paddingTop: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    right: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    rowGap: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    top: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    width: (0, $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f),
    zIndex: (0, $fda1bdf5cf68a2eb$export$b5f31a7e431d2eab)
};
var $efa3c762c3cee56f$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $efa3c762c3cee56f$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU.env) === 'object' && false;
};
var $efa3c762c3cee56f$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $efa3c762c3cee56f$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $efa3c762c3cee56f$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($efa3c762c3cee56f$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && $efa3c762c3cee56f$var$safeSelectors.test(key)) {
            styleObj[key] = $efa3c762c3cee56f$var$_transformStyles(value);
            return;
        }
        if ($efa3c762c3cee56f$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($efa3c762c3cee56f$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $efa3c762c3cee56f$export$9a199fbafee0014e)) return;
        var tokenValue = $efa3c762c3cee56f$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $efa3c762c3cee56f$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $efa3c762c3cee56f$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $efa3c762c3cee56f$var$uniqueSymbol, (0, $74Zh5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $efa3c762c3cee56f$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $efa3c762c3cee56f$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $efa3c762c3cee56f$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$efa3c762c3cee56f$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $efa3c762c3cee56f$export$f6c783d06584602c(style) {
    return $efa3c762c3cee56f$var$baseXcss(style);
}


var $a014b84d18d0cecf$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $a014b84d18d0cecf$var$_excluded2 = [
    "className"
];
var $a014b84d18d0cecf$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $a014b84d18d0cecf$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $a014b84d18d0cecf$var$_excluded2);
    var resolvedStyles = (0, $efa3c762c3cee56f$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $a014b84d18d0cecf$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $fda1bdf5cf68a2eb$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $fda1bdf5cf68a2eb$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $fda1bdf5cf68a2eb$export$ff257d957d48c421)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $fda1bdf5cf68a2eb$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $fda1bdf5cf68a2eb$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $fda1bdf5cf68a2eb$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $fda1bdf5cf68a2eb$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $fda1bdf5cf68a2eb$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $fda1bdf5cf68a2eb$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $fda1bdf5cf68a2eb$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $74Zh5.jsx)((0, $5a5dcf11228e3e89$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $a014b84d18d0cecf$export$2e2bcd8739ae039 = $a014b84d18d0cecf$export$e71c4d32a2263218;
var $a014b84d18d0cecf$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});


var $31a965b6dd4a0db8$var$baseStylesOld = (0, $efa3c762c3cee56f$export$f6c783d06584602c)({
    display: 'inline-flex',
    borderRadius: 'border.radius',
    blockSize: 'min-content',
    position: 'static',
    overflow: 'hidden'
});
var $31a965b6dd4a0db8$var$styles = {
    container: (0, $74Zh5.css)({
        display: 'inline-flex',
        boxSizing: 'border-box',
        position: 'static',
        blockSize: 'min-content',
        borderRadius: '3px',
        overflow: 'hidden',
        paddingInline: "var(--ds-space-050, 4px)"
    }),
    containerSubtle: (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        outlineOffset: -1
    }),
    background: {
        bold: {
            default: (0, $74Zh5.css)({
                backgroundColor: '#DDDEE1'
            }),
            inprogress: (0, $74Zh5.css)({
                backgroundColor: '#8FB8F6'
            }),
            moved: (0, $74Zh5.css)({
                backgroundColor: '#F9C84E'
            }),
            new: (0, $74Zh5.css)({
                backgroundColor: '#D8A0F7'
            }),
            removed: (0, $74Zh5.css)({
                backgroundColor: '#FD9891'
            }),
            success: (0, $74Zh5.css)({
                backgroundColor: '#B3DF72'
            })
        },
        subtle: {
            default: (0, $74Zh5.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            inprogress: (0, $74Zh5.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            moved: (0, $74Zh5.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            new: (0, $74Zh5.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            removed: (0, $74Zh5.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            success: (0, $74Zh5.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            })
        }
    },
    border: {
        subtle: {
            default: (0, $74Zh5.css)({
                border: "1px solid #B7B9BE"
            }),
            inprogress: (0, $74Zh5.css)({
                border: "1px solid #669DF1"
            }),
            moved: (0, $74Zh5.css)({
                border: "1px solid #FCA700"
            }),
            new: (0, $74Zh5.css)({
                border: "1px solid #C97CF4"
            }),
            removed: (0, $74Zh5.css)({
                border: "1px solid #F87168"
            }),
            success: (0, $74Zh5.css)({
                border: "1px solid #94C748"
            })
        }
    },
    outline: {
        subtle: {
            default: (0, $74Zh5.css)({
                outline: "1px solid #B7B9BE"
            }),
            inprogress: (0, $74Zh5.css)({
                outline: "1px solid #669DF1"
            }),
            moved: (0, $74Zh5.css)({
                outline: "1px solid #FCA700"
            }),
            new: (0, $74Zh5.css)({
                outline: "1px solid #C97CF4"
            }),
            removed: (0, $74Zh5.css)({
                outline: "1px solid #F87168"
            }),
            success: (0, $74Zh5.css)({
                outline: "1px solid #94C748"
            })
        }
    },
    text: {
        subtle: (0, $74Zh5.css)({
            color: "var(--ds-text, #172B4D)"
        }),
        bold: (0, $74Zh5.css)({
            color: '#292A2E'
        })
    }
};
var $31a965b6dd4a0db8$var$textStyles = (0, $74Zh5.css)({
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '11px',
    fontStyle: 'normal',
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    whiteSpace: 'nowrap'
});
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $31a965b6dd4a0db8$var$Lozenge = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? 'bold' : 'subtle';
    var appearanceType = appearance in $31a965b6dd4a0db8$var$styles.background[appearanceStyle] ? appearance : 'default';
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    if ((0, $07ffd18a06aa0227$export$b40ec24ac8275656)('platform-component-visual-refresh')) return (0, $74Zh5.jsx)("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        css: [
            $31a965b6dd4a0db8$var$styles.container,
            $31a965b6dd4a0db8$var$styles.background[appearanceStyle][appearanceType],
            appearanceStyle === 'subtle' && !(0, $07ffd18a06aa0227$export$b40ec24ac8275656)('visual-refresh_drop_5') && $31a965b6dd4a0db8$var$styles.border.subtle[appearanceType],
            appearanceStyle === 'subtle' && (0, $07ffd18a06aa0227$export$b40ec24ac8275656)('visual-refresh_drop_5') && $31a965b6dd4a0db8$var$styles.outline.subtle[appearanceType],
            appearanceStyle === 'subtle' && (0, $07ffd18a06aa0227$export$b40ec24ac8275656)('visual-refresh_drop_5') && $31a965b6dd4a0db8$var$styles.containerSubtle
        ],
        "data-testid": testId
    }, (0, $74Zh5.jsx)("span", {
        css: [
            $31a965b6dd4a0db8$var$textStyles,
            $31a965b6dd4a0db8$var$styles.text[appearanceStyle]
        ],
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text")
    }, children));
    var appearanceTypeOld = appearance in $31a965b6dd4a0db8$var$backgroundColorsOld[appearanceStyle] ? appearance : 'default';
    return (0, $74Zh5.jsx)((0, $a014b84d18d0cecf$export$2e2bcd8739ae039), {
        as: "span",
        backgroundColor: $31a965b6dd4a0db8$var$backgroundColorsOld[appearanceStyle][appearanceTypeOld],
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        paddingInline: "space.050",
        xcss: $31a965b6dd4a0db8$var$baseStylesOld,
        testId: testId
    }, (0, $74Zh5.jsx)("span", {
        css: [
            $31a965b6dd4a0db8$var$textStyles,
            $31a965b6dd4a0db8$var$textColorsOld[appearanceStyle][appearanceType]
        ],
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text")
    }, children));
});
$31a965b6dd4a0db8$var$Lozenge.displayName = 'Lozenge';
var $31a965b6dd4a0db8$export$2e2bcd8739ae039 = $31a965b6dd4a0db8$var$Lozenge;
var $31a965b6dd4a0db8$var$backgroundColorsOld = {
    bold: {
        default: 'color.background.neutral.bold',
        inprogress: 'color.background.information.bold',
        moved: 'color.background.warning.bold',
        new: 'color.background.discovery.bold',
        removed: 'color.background.danger.bold',
        success: 'color.background.success.bold'
    },
    subtle: {
        default: 'color.background.neutral',
        inprogress: 'color.background.information',
        moved: 'color.background.warning',
        new: 'color.background.discovery',
        removed: 'color.background.danger',
        success: 'color.background.success'
    }
};
var $31a965b6dd4a0db8$var$textColorsOld = {
    bold: {
        default: (0, $74Zh5.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        inprogress: (0, $74Zh5.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        moved: (0, $74Zh5.css)({
            color: "var(--ds-text-warning-inverse, #172B4D)"
        }),
        new: (0, $74Zh5.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        removed: (0, $74Zh5.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        success: (0, $74Zh5.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        })
    },
    subtle: {
        default: (0, $74Zh5.css)({
            color: "var(--ds-text-subtle, #42526E)"
        }),
        inprogress: (0, $74Zh5.css)({
            color: "var(--ds-text-information, #0052CC)"
        }),
        moved: (0, $74Zh5.css)({
            color: "var(--ds-text-warning, #974F0C)"
        }),
        new: (0, $74Zh5.css)({
            color: "var(--ds-text-discovery, #403294)"
        }),
        removed: (0, $74Zh5.css)({
            color: "var(--ds-text-danger, #DE350B)"
        }),
        success: (0, $74Zh5.css)({
            color: "var(--ds-text-success, #006644)"
        })
    }
};



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $69J3E = parcelRequire("69J3E");

var $3FlkA = parcelRequire("3FlkA");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $76c9b15f8f2dbc0b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $76c9b15f8f2dbc0b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $76c9b15f8f2dbc0b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $76c9b15f8f2dbc0b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $76c9b15f8f2dbc0b$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $76c9b15f8f2dbc0b$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $76c9b15f8f2dbc0b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $76c9b15f8f2dbc0b$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $76c9b15f8f2dbc0b$var$_objectSpread($76c9b15f8f2dbc0b$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $259b5f12cf1e9dca$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $259b5f12cf1e9dca$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $259b5f12cf1e9dca$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($259b5f12cf1e9dca$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $259b5f12cf1e9dca$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $259b5f12cf1e9dca$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $259b5f12cf1e9dca$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $259b5f12cf1e9dca$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $259b5f12cf1e9dca$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $259b5f12cf1e9dca$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $76c9b15f8f2dbc0b$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $198cc46d8348dafa$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $57689e08a4ac98d0$export$5bf35293e545f20c() {
    var analyticsContext = (0, $198cc46d8348dafa$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $259b5f12cf1e9dca$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $bc093c0471a9c62c$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $e2c415d6ac5c0326$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e2c415d6ac5c0326$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e2c415d6ac5c0326$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e2c415d6ac5c0326$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e2c415d6ac5c0326$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $57689e08a4ac98d0$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $bc093c0471a9c62c$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $bc093c0471a9c62c$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $e2c415d6ac5c0326$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


/* blanket.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $atP8S = parcelRequire("atP8S");

/**
 * An empty function which does nothing.
 */ function $8a830dba6170ca15$export$2e2bcd8739ae039() {}


// Reds
var $887f734e3f3d9893$export$4b84fd0e2c617bd = '#FFEBE6';
var $887f734e3f3d9893$export$b34b069eff244586 = '#FFBDAD';
var $887f734e3f3d9893$export$be802dd0d8b57f35 = '#FF8F73';
var $887f734e3f3d9893$export$60847d42f9da92a6 = '#FF7452';
var $887f734e3f3d9893$export$4a7404f376229999 = '#FF5630';
var $887f734e3f3d9893$export$2010d0fb4295b346 = '#DE350B';
var $887f734e3f3d9893$export$2837b5a1a71d5c02 = '#BF2600';
var $887f734e3f3d9893$export$8d9596b529bbb9cf = '#FFFAE6';
var $887f734e3f3d9893$export$41060a744ab0b7ae = '#FFF0B3';
var $887f734e3f3d9893$export$1cc05bbbf340e559 = '#FFE380';
var $887f734e3f3d9893$export$5aae31392d72caaa = '#FFC400';
var $887f734e3f3d9893$export$c6930421db9fa514 = '#FFAB00';
var $887f734e3f3d9893$export$59619663aa6500fb = '#FF991F';
var $887f734e3f3d9893$export$874739ea9e379ab6 = '#FF8B00';
var $887f734e3f3d9893$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $887f734e3f3d9893$export$69a3bf21b9686c2b = '#ABF5D1';
var $887f734e3f3d9893$export$afbce1382ec95f73 = '#79F2C0';
var $887f734e3f3d9893$export$747d86715d4175de = '#57D9A3';
var $887f734e3f3d9893$export$940e1f69e873f202 = '#36B37E';
var $887f734e3f3d9893$export$a49394138f7b8e85 = '#00875A';
var $887f734e3f3d9893$export$6fa04827ac68a4fb = '#006644';
var $887f734e3f3d9893$export$226de0355ed012f8 = '#DEEBFF';
var $887f734e3f3d9893$export$8c13c2ee36917869 = '#B3D4FF';
var $887f734e3f3d9893$export$ecfc1dff386a3e7a = '#4C9AFF';
var $887f734e3f3d9893$export$215b7063051591f1 = '#2684FF';
var $887f734e3f3d9893$export$e62e8919cca44969 = '#0065FF';
var $887f734e3f3d9893$export$b3de0ae08da2ce64 = '#0052CC';
var $887f734e3f3d9893$export$a6ee3d71bc067634 = '#0747A6';
var $887f734e3f3d9893$export$67f15409e87642a1 = '#669DF1';
var $887f734e3f3d9893$export$f0539dbc42dbb067 = '#8FB8F6';
var $887f734e3f3d9893$export$363e4475840015bb = '#EAE6FF';
var $887f734e3f3d9893$export$4b0a4417ed59760f = '#C0B6F2';
var $887f734e3f3d9893$export$6011520a64d9a187 = '#998DD9';
var $887f734e3f3d9893$export$a7175d4e9206bc80 = '#8777D9';
var $887f734e3f3d9893$export$b48405b95304b5a1 = '#6554C0';
var $887f734e3f3d9893$export$c71e4279dd54a18d = '#5243AA';
var $887f734e3f3d9893$export$147899de772240ec = '#403294';
var $887f734e3f3d9893$export$2cf711fe14c66f06 = '#E6FCFF';
var $887f734e3f3d9893$export$7a8f4d33f6f9772c = '#B3F5FF';
var $887f734e3f3d9893$export$776c9c497ef08533 = '#79E2F2';
var $887f734e3f3d9893$export$69cb3ca10c1e330e = '#00C7E6';
var $887f734e3f3d9893$export$9dc1ef0f3f48059b = '#00B8D9';
var $887f734e3f3d9893$export$7c835c78b6fcdef8 = '#00A3BF';
var $887f734e3f3d9893$export$6036577f95c3877e = '#008DA6';
var $887f734e3f3d9893$export$29a4f05edc054374 = '#FFFFFF';
var $887f734e3f3d9893$export$e655ef011c4aa1a2 = '#FAFBFC';
var $887f734e3f3d9893$export$9fdfb749e33cdf97 = '#F4F5F7';
var $887f734e3f3d9893$export$3e51e8f1440314ba = '#EBECF0';
var $887f734e3f3d9893$export$1ce2d1575d444ceb = '#DFE1E6';
var $887f734e3f3d9893$export$8754fc7e6d8b3000 = '#C1C7D0';
var $887f734e3f3d9893$export$c2e91cbeada39b8b = '#B3BAC5';
var $887f734e3f3d9893$export$5f71e19f3a7ad9de = '#A5ADBA';
var $887f734e3f3d9893$export$eaa8c8a70ac22806 = '#97A0AF';
var $887f734e3f3d9893$export$7c87d337fb91a97d = '#8993A4';
var $887f734e3f3d9893$export$d6447c357493214f = '#7A869A';
var $887f734e3f3d9893$export$f563ee71e9ee74cd = '#6B778C';
var $887f734e3f3d9893$export$e2ef2124cf4024b1 = '#5E6C84';
var $887f734e3f3d9893$export$eece5f492e429f08 = '#505F79';
var $887f734e3f3d9893$export$c39c0fe0f26207ae = '#42526E';
var $887f734e3f3d9893$export$7090862dc3038a9f = '#344563';
var $887f734e3f3d9893$export$ad0bacf983b7ddaa = '#253858';
var $887f734e3f3d9893$export$7d61b15e0da132af = '#172B4D';
var $887f734e3f3d9893$export$fbda843f0a27fe96 = '#091E42';
var $887f734e3f3d9893$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $887f734e3f3d9893$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $887f734e3f3d9893$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $887f734e3f3d9893$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $887f734e3f3d9893$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $887f734e3f3d9893$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $887f734e3f3d9893$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $887f734e3f3d9893$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $887f734e3f3d9893$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $887f734e3f3d9893$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $887f734e3f3d9893$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $887f734e3f3d9893$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $887f734e3f3d9893$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $887f734e3f3d9893$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $887f734e3f3d9893$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $887f734e3f3d9893$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $887f734e3f3d9893$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $887f734e3f3d9893$export$2f6319cf7d736c2a = '#E6EDFA';
var $887f734e3f3d9893$export$95126bc8884d6634 = '#DCE5F5';
var $887f734e3f3d9893$export$8338d8c35d44ff1 = '#CED9EB';
var $887f734e3f3d9893$export$5368d76ae4fbbda7 = '#B8C7E0';
var $887f734e3f3d9893$export$9f0a771d16ec8d36 = '#ABBBD6';
var $887f734e3f3d9893$export$abcf8c38338b4aa5 = '#9FB0CC';
var $887f734e3f3d9893$export$97e81faa16a182c7 = '#8C9CB8';
var $887f734e3f3d9893$export$bfe21c59123ecf33 = '#7988A3';
var $887f734e3f3d9893$export$ee82aa2ea6a1558 = '#67758F';
var $887f734e3f3d9893$export$682927c6ed76be02 = '#56637A';
var $887f734e3f3d9893$export$91fd9994c5be9757 = '#455166';
var $887f734e3f3d9893$export$d281fbfe3cff2df6 = '#3B475C';
var $887f734e3f3d9893$export$3902c91d8b98a753 = '#313D52';
var $887f734e3f3d9893$export$8e8133c1ba5845b5 = '#283447';
var $887f734e3f3d9893$export$33ff357f6620b39 = '#202B3D';
var $887f734e3f3d9893$export$633847cf062b69e0 = '#1B2638';
var $887f734e3f3d9893$export$9776a6e503bdbf76 = '#121A29';
var $887f734e3f3d9893$export$6c813d5160dff5db = '#0E1624';
var $887f734e3f3d9893$export$3d4f271a500072a = '#0D1424';
var $887f734e3f3d9893$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $887f734e3f3d9893$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $887f734e3f3d9893$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $887f734e3f3d9893$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $887f734e3f3d9893$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $887f734e3f3d9893$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $887f734e3f3d9893$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $887f734e3f3d9893$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $887f734e3f3d9893$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $887f734e3f3d9893$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $887f734e3f3d9893$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $887f734e3f3d9893$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $887f734e3f3d9893$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $887f734e3f3d9893$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $887f734e3f3d9893$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $887f734e3f3d9893$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $887f734e3f3d9893$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $887f734e3f3d9893$export$d2adc5dedf09fced = '#292A2E';
var $887f734e3f3d9893$export$f51762073d2bb381 = '#94C748';
var $887f734e3f3d9893$export$95e26d54def96891 = '#B3DF72';



function $b6b00686e959fb35$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b6b00686e959fb35$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b6b00686e959fb35$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b6b00686e959fb35$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b6b00686e959fb35$var$packageName = "@atlaskit/blanket";
var $b6b00686e959fb35$var$packageVersion = "0.0.0-development";
var $b6b00686e959fb35$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $b6b00686e959fb35$var$packageName,
    packageVersion: $b6b00686e959fb35$var$packageVersion
};
var $b6b00686e959fb35$var$baseStyles = null;
var $b6b00686e959fb35$var$shouldAllowClickThroughStyles = null;
var $b6b00686e959fb35$var$invisibleStyles = null;
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ var $b6b00686e959fb35$var$Blanket = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function Blanket(_ref, ref) {
    var _ref$shouldAllowClick = _ref.shouldAllowClickThrough, shouldAllowClickThrough = _ref$shouldAllowClick === void 0 ? false : _ref$shouldAllowClick, _ref$isTinted = _ref.isTinted, isTinted = _ref$isTinted === void 0 ? false : _ref$isTinted, _ref$onBlanketClicked = _ref.onBlanketClicked, onBlanketClicked = _ref$onBlanketClicked === void 0 ? (0, $8a830dba6170ca15$export$2e2bcd8739ae039) : _ref$onBlanketClicked, testId = _ref.testId, children = _ref.children, analyticsContext = _ref.analyticsContext;
    var mouseDownTarget = (0, $5FkrB.useRef)(null);
    var onBlanketClickedWithAnalytics = (0, $e2c415d6ac5c0326$export$a4687b0234b40e28)($b6b00686e959fb35$var$_objectSpread({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext
    }, $b6b00686e959fb35$var$analyticsAttributes));
    var blanketClickOutsideChildren = (0, $5FkrB.useCallback)(function(e) {
        return e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined;
    }, [
        onBlanketClickedWithAnalytics
    ]);
    var onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    var onMouseDown = (0, $5FkrB.useCallback)(function(e) {
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $atP8S.default)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk705f _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk1j28"
        ]),
        style: {
            "--_10avjlk": (0, $5fe71ee65ce166ce$export$2e2bcd8739ae039)("var(--ds-blanket, ".concat((0, $887f734e3f3d9893$export$486ab785e4bac3c6), ")"))
        }
    }, children);
}));
$b6b00686e959fb35$var$Blanket.displayName = 'Blanket';
var $b6b00686e959fb35$export$2e2bcd8739ae039 = $b6b00686e959fb35$var$Blanket;


/**
 * An empty function which does nothing.
 */ function $da390e863547ad56$export$2e2bcd8739ae039() {}



var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");


var $9dOvm = parcelRequire("9dOvm");
var $917f80eb9e328706$var$_process, $917f80eb9e328706$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $917f80eb9e328706$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($917f80eb9e328706$var$_process = globalThis.process) === null || $917f80eb9e328706$var$_process === void 0 || ($917f80eb9e328706$var$_process = $917f80eb9e328706$var$_process.env) === null || $917f80eb9e328706$var$_process === void 0 ? void 0 : $917f80eb9e328706$var$_process.JEST_WORKER_ID) !== undefined;
var $917f80eb9e328706$var$DEBUG_MODE = !$917f80eb9e328706$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($917f80eb9e328706$var$_process2 = globalThis.process) === null || $917f80eb9e328706$var$_process2 === void 0 || ($917f80eb9e328706$var$_process2 = $917f80eb9e328706$var$_process2.env) === null || $917f80eb9e328706$var$_process2 === void 0 ? void 0 : $917f80eb9e328706$var$_process2.NODE_ENV) !== 'production';
var $917f80eb9e328706$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$917f80eb9e328706$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $7f7bbd0205625fb2$var$pkgName = '@atlaskit/platform-feature-flags';
var $7f7bbd0205625fb2$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $7f7bbd0205625fb2$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $7f7bbd0205625fb2$var$ENV_ENABLE_PLATFORM_FF = $7f7bbd0205625fb2$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $7f7bbd0205625fb2$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $7f7bbd0205625fb2$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $7f7bbd0205625fb2$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $7f7bbd0205625fb2$var$ENV_ENABLE_PLATFORM_FF || $7f7bbd0205625fb2$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $7f7bbd0205625fb2$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $7f7bbd0205625fb2$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$7f7bbd0205625fb2$var$globalVar[$7f7bbd0205625fb2$export$7e41b1b2bdee3f98] = $7f7bbd0205625fb2$var$globalVar[$7f7bbd0205625fb2$export$7e41b1b2bdee3f98] || $7f7bbd0205625fb2$var$DEFAULT_PFF_GLOBAL;
function $7f7bbd0205625fb2$export$f2b591175b3e424c(resolver) {
    $7f7bbd0205625fb2$var$globalVar[$7f7bbd0205625fb2$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $7f7bbd0205625fb2$export$6333b6aff9fc6275(flagKey) {
    if ($7f7bbd0205625fb2$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $917f80eb9e328706$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $7f7bbd0205625fb2$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $7f7bbd0205625fb2$var$globalVar[$7f7bbd0205625fb2$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $7f7bbd0205625fb2$var$globalVar[$7f7bbd0205625fb2$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $9dOvm.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $7f7bbd0205625fb2$var$globalVar[$7f7bbd0205625fb2$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $64b3f566deaa9c38$export$ba05d765b8392e5e(flagResolver) {
    (0, $7f7bbd0205625fb2$export$f2b591175b3e424c)(flagResolver);
}
function $64b3f566deaa9c38$export$470e5c2be1411c89(name) {
    return (0, $7f7bbd0205625fb2$export$6333b6aff9fc6275)(name);
}
function $64b3f566deaa9c38$export$b40ec24ac8275656(name) {
    return (0, $7f7bbd0205625fb2$export$6333b6aff9fc6275)(name);
}


function $43f1965ab31d9c6c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $43f1965ab31d9c6c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $43f1965ab31d9c6c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $43f1965ab31d9c6c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $43f1965ab31d9c6c$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $5FkrB.createContext)(0);
var $43f1965ab31d9c6c$export$48b383b280e20440 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    topLevelRef: {
        current: null
    },
    layerList: {
        current: null
    },
    setTopLevel: (0, $da390e863547ad56$export$2e2bcd8739ae039)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $43f1965ab31d9c6c$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $5FkrB.useContext)($43f1965ab31d9c6c$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel, topLevelRef = _useContext.topLevelRef, layerList = _useContext.layerList;
    // This is not unstable, it will run once for ref creation.
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var id = (0, $5FkrB.useRef)((0, $64b3f566deaa9c38$export$b40ec24ac8275656)('layering-top-level-use-array') ? Math.random().toString(36) : '');
    if (!(0, $64b3f566deaa9c38$export$b40ec24ac8275656)('layering-top-level-use-array')) {
        if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    }
    if (!(0, $64b3f566deaa9c38$export$b40ec24ac8275656)('layering-top-level-use-array')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5FkrB.useEffect)(function() {
        return function() {
            // avoid immediate cleanup using setTimeout when component unmount
            // this will make sure non-top layer components can get the correct top level value
            // when multiple layers trigger onClose in sequence
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel,
        topLevelRef
    ]);
    if ((0, $64b3f566deaa9c38$export$b40ec24ac8275656)('layering-top-level-use-array')) // Remove eslint error on FG cleanup
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5FkrB.useEffect)(function() {
        var safeLayerList = layerList === null || layerList === void 0 ? void 0 : layerList.current;
        var safeId = id.current;
        if (!safeLayerList) return;
        safeLayerList.push(safeId);
        return function() {
            var index = safeLayerList.indexOf(safeId);
            if (index > -1) safeLayerList.splice(index, 1);
        };
    }, [
        layerList,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($43f1965ab31d9c6c$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $43f1965ab31d9c6c$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $5FkrB.useRef)(0);
    var layerList = (0, $5FkrB.useRef)([]);
    var value = (0, $5FkrB.useMemo)(function() {
        return $43f1965ab31d9c6c$var$_objectSpread({
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        }, (0, $64b3f566deaa9c38$export$b40ec24ac8275656)('layering-top-level-use-array') ? {
            layerList: layerList
        } : {});
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($43f1965ab31d9c6c$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $43f1965ab31d9c6c$export$7c885f891c940977 = function Layering(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $5FkrB.useContext)($43f1965ab31d9c6c$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($43f1965ab31d9c6c$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($43f1965ab31d9c6c$var$LayeringProvider, null, content);
};



var $5FkrB = parcelRequire("5FkrB");
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $atP8S = parcelRequire("atP8S");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
var $c7146b8d8b91116a$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $c7146b8d8b91116a$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$c7146b8d8b91116a$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $c7146b8d8b91116a$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $5FkrB.useState)($c7146b8d8b91116a$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        if (!$c7146b8d8b91116a$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $7QpUe.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $c7146b8d8b91116a$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $c7146b8d8b91116a$export$ff7706047246b98b = function prefersReducedMotion() {
    return $c7146b8d8b91116a$export$f0f789643ba5a83c;
};


/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $e28ea633b7112ff9$export$368bacef0dacbe05 = 25;
var $e28ea633b7112ff9$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $e28ea633b7112ff9$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $e28ea633b7112ff9$export$30fa1a2e62ae150c = {
    none: $e28ea633b7112ff9$export$38b928a7167ce124.none,
    small: $e28ea633b7112ff9$export$38b928a7167ce124.small * $e28ea633b7112ff9$var$EXITING_MOTION_MULTIPLIER,
    medium: $e28ea633b7112ff9$export$38b928a7167ce124.medium * $e28ea633b7112ff9$var$EXITING_MOTION_MULTIPLIER,
    large: $e28ea633b7112ff9$export$38b928a7167ce124.large * $e28ea633b7112ff9$var$EXITING_MOTION_MULTIPLIER
};



var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $3ebc2f40707ee9ae$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $3ebc2f40707ee9ae$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $3ebc2f40707ee9ae$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $3ebc2f40707ee9ae$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $3ebc2f40707ee9ae$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $1fa46e7402eb7267$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $1fa46e7402eb7267$var$ExitingContext = /*#__PURE__*/ (0, $5FkrB.createContext)($1fa46e7402eb7267$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $1fa46e7402eb7267$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $1fa46e7402eb7267$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($1fa46e7402eb7267$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $1fa46e7402eb7267$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $1fa46e7402eb7267$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $1fa46e7402eb7267$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $1fa46e7402eb7267$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $1fa46e7402eb7267$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $1fa46e7402eb7267$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $1fa46e7402eb7267$var$childrenToArray(previousChildren);
    var current = $1fa46e7402eb7267$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $1fa46e7402eb7267$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $1fa46e7402eb7267$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $1fa46e7402eb7267$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $1fa46e7402eb7267$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $1fa46e7402eb7267$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)($1fa46e7402eb7267$var$ExitingContext);
};
$1fa46e7402eb7267$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $1fa46e7402eb7267$export$2e2bcd8739ae039 = $1fa46e7402eb7267$var$ExitingPersistence;



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
/**
 * An empty function which does nothing.
 */ function $2669c3532376a869$export$2e2bcd8739ae039() {}



var $5FkrB = parcelRequire("5FkrB");
var $485b52a575a0d48e$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $02cb95099a31bdb4$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $6aac604c85032826$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $2669c3532376a869$export$2e2bcd8739ae039)
    };
});
var $6aac604c85032826$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $02cb95099a31bdb4$export$c485849f2e393253)();
    var context = (0, $5FkrB.useContext)($6aac604c85032826$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $6aac604c85032826$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $485b52a575a0d48e$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($6aac604c85032826$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $6aac604c85032826$export$2e2bcd8739ae039 = $6aac604c85032826$var$StaggeredEntrance;


var $b5949596b166afa0$var$zoomIn = null;
var $b5949596b166afa0$var$zoomOut = null;
var $b5949596b166afa0$var$fadeIn = null;
var $b5949596b166afa0$var$fadeOut = null;
var $b5949596b166afa0$var$fadeInFromTop = null;
var $b5949596b166afa0$var$fadeOutFromTop = null;
var $b5949596b166afa0$var$fadeInFromLeft = null;
var $b5949596b166afa0$var$fadeOutFromLeft = null;
var $b5949596b166afa0$var$fadeInFromBottom = null;
var $b5949596b166afa0$var$fadeOutFromBottom = null;
var $b5949596b166afa0$var$fadeInFromRight = null;
var $b5949596b166afa0$var$fadeOutFromRight = null;
var $b5949596b166afa0$var$fadeInFromTopConstant = null;
var $b5949596b166afa0$var$fadeOutFromTopConstant = null;
var $b5949596b166afa0$var$fadeInFromLeftConstant = null;
var $b5949596b166afa0$var$fadeOutFromLeftConstant = null;
var $b5949596b166afa0$var$fadeInFromBottomConstant = null;
var $b5949596b166afa0$var$fadeOutFromBottomConstant = null;
var $b5949596b166afa0$var$fadeInFromRightConstant = null;
var $b5949596b166afa0$var$fadeOutFromRightConstant = null;
var $b5949596b166afa0$var$slideInFromTop = null;
var $b5949596b166afa0$var$slideOutFromTop = null;
var $b5949596b166afa0$var$slideInFromRight = null;
var $b5949596b166afa0$var$slideOutFromRight = null;
var $b5949596b166afa0$var$slideInFromBottom = null;
var $b5949596b166afa0$var$slideOutFromBottom = null;
var $b5949596b166afa0$var$slideInFromLeft = null;
var $b5949596b166afa0$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $b5949596b166afa0$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $6aac604c85032826$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $1fa46e7402eb7267$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $3ebc2f40707ee9ae$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $5FkrB.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $c7146b8d8b91116a$export$b7baf7667a68d87c)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $e28ea633b7112ff9$export$30fa1a2e62ae150c)[duration] : (0, $e28ea633b7112ff9$export$38b928a7167ce124)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $atP8S.default)([
            (0, $atP8S.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $atP8S.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $atP8S.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $atP8S.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $atP8S.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $atP8S.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $atP8S.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $atP8S.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $atP8S.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $atP8S.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $atP8S.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $atP8S.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $atP8S.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $atP8S.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $atP8S.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $atP8S.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $atP8S.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $atP8S.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $atP8S.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $atP8S.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $atP8S.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $atP8S.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $atP8S.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $atP8S.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $atP8S.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $atP8S.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $atP8S.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $atP8S.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $atP8S.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $atP8S.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $atP8S.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $atP8S.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $atP8S.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $atP8S.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $atP8S.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $atP8S.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $atP8S.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $atP8S.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $atP8S.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $atP8S.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $atP8S.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $atP8S.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $atP8S.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $atP8S.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $atP8S.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $atP8S.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $atP8S.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $atP8S.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $atP8S.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $atP8S.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $atP8S.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $b5949596b166afa0$export$2e2bcd8739ae039 = $b5949596b166afa0$var$EnteringMotion;


var $1fb4e133cab6b0bd$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $1fb4e133cab6b0bd$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $1fb4e133cab6b0bd$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b5949596b166afa0$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $1fb4e133cab6b0bd$export$2e2bcd8739ae039 = $1fb4e133cab6b0bd$var$FadeIn;




var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");
var $afd17a2832845011$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $afd17a2832845011$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $afd17a2832845011$export$13f57c02915787b3 = 'atlaskit-portal';


var $4edea02eb2028794$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $afd17a2832845011$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $4edea02eb2028794$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $4edea02eb2028794$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $afd17a2832845011$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $afd17a2832845011$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $4edea02eb2028794$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $4edea02eb2028794$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $4edea02eb2028794$var$getPortalParent().removeChild(container);
};
var $4edea02eb2028794$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $4edea02eb2028794$var$getPortalParent().appendChild(container);
};
var $4edea02eb2028794$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $4edea02eb2028794$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($4edea02eb2028794$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $afd17a2832845011$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};
var $4edea02eb2028794$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($4edea02eb2028794$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $afd17a2832845011$export$72f415121273627e));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $afd17a2832845011$export$e4c79eb95c23a0da);
            parent.style.display = 'flex';
            (_getBody2 = $4edea02eb2028794$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};


function $f20771a0bd71fdf4$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $5FkrB.useMemo)(function() {
        return (0, $4edea02eb2028794$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $4edea02eb2028794$export$c582005add11e141)(container);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            (0, $4edea02eb2028794$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $aLeHs.createPortal)(children, container);
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $5FkrB = parcelRequire("5FkrB");
var $170cb47092015b5c$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5FkrB.useLayoutEffect) : (0, $5FkrB.useEffect);



function $4b631ac6bcfbd682$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $170cb47092015b5c$export$700979bc83e7db82)(function() {
        var tempPortalContainer = (0, $4edea02eb2028794$export$fef014d7cef9e543)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $4edea02eb2028794$export$95029ca7aca2989e)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Suspense), {
        fallback: null
    }, children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $aLeHs.createPortal)(suspendedChildren, atlaskitPortal) : null;
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $45f32acfdab27d59$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $170cb47092015b5c$export$700979bc83e7db82) : (0, $5FkrB.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $45f32acfdab27d59$export$2e2bcd8739ae039 = $45f32acfdab27d59$var$useIsSubsequentRender;



var $5FkrB = parcelRequire("5FkrB");
var $5024562cbe4bd0a6$export$ed5835cc67e87f72 = 'akPortalMount';
var $5024562cbe4bd0a6$export$80816bd900e5bd00 = 'akPortalUnmount';


var $6604c609bdf7ecc9$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $6604c609bdf7ecc9$var$getLayerName = function getLayerName(zIndex) {
    return $6604c609bdf7ecc9$var$zIndexToName.hasOwnProperty(zIndex) ? $6604c609bdf7ecc9$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $6604c609bdf7ecc9$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $6604c609bdf7ecc9$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $6604c609bdf7ecc9$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $6604c609bdf7ecc9$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $974956a0478f07c4$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $5FkrB.useEffect)(function() {
        (0, $6604c609bdf7ecc9$export$2e2bcd8739ae039)((0, $5024562cbe4bd0a6$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $6604c609bdf7ecc9$export$2e2bcd8739ae039)((0, $5024562cbe4bd0a6$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $974956a0478f07c4$export$2e2bcd8739ae039 = $974956a0478f07c4$var$useFirePortalEvent;


function $062c34d20b8b2f54$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $45f32acfdab27d59$export$2e2bcd8739ae039)(mountStrategy);
    (0, $974956a0478f07c4$export$2e2bcd8739ae039)(zIndex);
    return !(0, $64b3f566deaa9c38$export$b40ec24ac8275656)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f20771a0bd71fdf4$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4b631ac6bcfbd682$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children);
}


/* eslint-disable no-console */ var $f37f61d831f45d36$var$printed = {};
function $f37f61d831f45d36$export$2e2bcd8739ae039(message) {
    if ($f37f61d831f45d36$var$printed[message]) return;
    $f37f61d831f45d36$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}



var $3ZMUU = parcelRequire("3ZMUU");
function $b5d2e0354c69b158$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $f37f61d831f45d36$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $b5d2e0354c69b158$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $3ZMUU;
}


// Reds
var $881e75c45a88d9b7$export$4b84fd0e2c617bd = '#FFEBE6';
var $881e75c45a88d9b7$export$b34b069eff244586 = '#FFBDAD';
var $881e75c45a88d9b7$export$be802dd0d8b57f35 = '#FF8F73';
var $881e75c45a88d9b7$export$60847d42f9da92a6 = '#FF7452';
var $881e75c45a88d9b7$export$4a7404f376229999 = '#FF5630';
var $881e75c45a88d9b7$export$2010d0fb4295b346 = '#DE350B';
var $881e75c45a88d9b7$export$2837b5a1a71d5c02 = '#BF2600';
var $881e75c45a88d9b7$export$8d9596b529bbb9cf = '#FFFAE6';
var $881e75c45a88d9b7$export$41060a744ab0b7ae = '#FFF0B3';
var $881e75c45a88d9b7$export$1cc05bbbf340e559 = '#FFE380';
var $881e75c45a88d9b7$export$5aae31392d72caaa = '#FFC400';
var $881e75c45a88d9b7$export$c6930421db9fa514 = '#FFAB00';
var $881e75c45a88d9b7$export$59619663aa6500fb = '#FF991F';
var $881e75c45a88d9b7$export$874739ea9e379ab6 = '#FF8B00';
var $881e75c45a88d9b7$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $881e75c45a88d9b7$export$69a3bf21b9686c2b = '#ABF5D1';
var $881e75c45a88d9b7$export$afbce1382ec95f73 = '#79F2C0';
var $881e75c45a88d9b7$export$747d86715d4175de = '#57D9A3';
var $881e75c45a88d9b7$export$940e1f69e873f202 = '#36B37E';
var $881e75c45a88d9b7$export$a49394138f7b8e85 = '#00875A';
var $881e75c45a88d9b7$export$6fa04827ac68a4fb = '#006644';
var $881e75c45a88d9b7$export$226de0355ed012f8 = '#DEEBFF';
var $881e75c45a88d9b7$export$8c13c2ee36917869 = '#B3D4FF';
var $881e75c45a88d9b7$export$ecfc1dff386a3e7a = '#4C9AFF';
var $881e75c45a88d9b7$export$215b7063051591f1 = '#2684FF';
var $881e75c45a88d9b7$export$e62e8919cca44969 = '#0065FF';
var $881e75c45a88d9b7$export$b3de0ae08da2ce64 = '#0052CC';
var $881e75c45a88d9b7$export$a6ee3d71bc067634 = '#0747A6';
var $881e75c45a88d9b7$export$67f15409e87642a1 = '#669DF1';
var $881e75c45a88d9b7$export$f0539dbc42dbb067 = '#8FB8F6';
var $881e75c45a88d9b7$export$363e4475840015bb = '#EAE6FF';
var $881e75c45a88d9b7$export$4b0a4417ed59760f = '#C0B6F2';
var $881e75c45a88d9b7$export$6011520a64d9a187 = '#998DD9';
var $881e75c45a88d9b7$export$a7175d4e9206bc80 = '#8777D9';
var $881e75c45a88d9b7$export$b48405b95304b5a1 = '#6554C0';
var $881e75c45a88d9b7$export$c71e4279dd54a18d = '#5243AA';
var $881e75c45a88d9b7$export$147899de772240ec = '#403294';
var $881e75c45a88d9b7$export$2cf711fe14c66f06 = '#E6FCFF';
var $881e75c45a88d9b7$export$7a8f4d33f6f9772c = '#B3F5FF';
var $881e75c45a88d9b7$export$776c9c497ef08533 = '#79E2F2';
var $881e75c45a88d9b7$export$69cb3ca10c1e330e = '#00C7E6';
var $881e75c45a88d9b7$export$9dc1ef0f3f48059b = '#00B8D9';
var $881e75c45a88d9b7$export$7c835c78b6fcdef8 = '#00A3BF';
var $881e75c45a88d9b7$export$6036577f95c3877e = '#008DA6';
var $881e75c45a88d9b7$export$29a4f05edc054374 = '#FFFFFF';
var $881e75c45a88d9b7$export$e655ef011c4aa1a2 = '#FAFBFC';
var $881e75c45a88d9b7$export$9fdfb749e33cdf97 = '#F4F5F7';
var $881e75c45a88d9b7$export$3e51e8f1440314ba = '#EBECF0';
var $881e75c45a88d9b7$export$1ce2d1575d444ceb = '#DFE1E6';
var $881e75c45a88d9b7$export$8754fc7e6d8b3000 = '#C1C7D0';
var $881e75c45a88d9b7$export$c2e91cbeada39b8b = '#B3BAC5';
var $881e75c45a88d9b7$export$5f71e19f3a7ad9de = '#A5ADBA';
var $881e75c45a88d9b7$export$eaa8c8a70ac22806 = '#97A0AF';
var $881e75c45a88d9b7$export$7c87d337fb91a97d = '#8993A4';
var $881e75c45a88d9b7$export$d6447c357493214f = '#7A869A';
var $881e75c45a88d9b7$export$f563ee71e9ee74cd = '#6B778C';
var $881e75c45a88d9b7$export$e2ef2124cf4024b1 = '#5E6C84';
var $881e75c45a88d9b7$export$eece5f492e429f08 = '#505F79';
var $881e75c45a88d9b7$export$c39c0fe0f26207ae = '#42526E';
var $881e75c45a88d9b7$export$7090862dc3038a9f = '#344563';
var $881e75c45a88d9b7$export$ad0bacf983b7ddaa = '#253858';
var $881e75c45a88d9b7$export$7d61b15e0da132af = '#172B4D';
var $881e75c45a88d9b7$export$fbda843f0a27fe96 = '#091E42';
var $881e75c45a88d9b7$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $881e75c45a88d9b7$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $881e75c45a88d9b7$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $881e75c45a88d9b7$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $881e75c45a88d9b7$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $881e75c45a88d9b7$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $881e75c45a88d9b7$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $881e75c45a88d9b7$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $881e75c45a88d9b7$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $881e75c45a88d9b7$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $881e75c45a88d9b7$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $881e75c45a88d9b7$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $881e75c45a88d9b7$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $881e75c45a88d9b7$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $881e75c45a88d9b7$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $881e75c45a88d9b7$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $881e75c45a88d9b7$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $881e75c45a88d9b7$export$2f6319cf7d736c2a = '#E6EDFA';
var $881e75c45a88d9b7$export$95126bc8884d6634 = '#DCE5F5';
var $881e75c45a88d9b7$export$8338d8c35d44ff1 = '#CED9EB';
var $881e75c45a88d9b7$export$5368d76ae4fbbda7 = '#B8C7E0';
var $881e75c45a88d9b7$export$9f0a771d16ec8d36 = '#ABBBD6';
var $881e75c45a88d9b7$export$abcf8c38338b4aa5 = '#9FB0CC';
var $881e75c45a88d9b7$export$97e81faa16a182c7 = '#8C9CB8';
var $881e75c45a88d9b7$export$bfe21c59123ecf33 = '#7988A3';
var $881e75c45a88d9b7$export$ee82aa2ea6a1558 = '#67758F';
var $881e75c45a88d9b7$export$682927c6ed76be02 = '#56637A';
var $881e75c45a88d9b7$export$91fd9994c5be9757 = '#455166';
var $881e75c45a88d9b7$export$d281fbfe3cff2df6 = '#3B475C';
var $881e75c45a88d9b7$export$3902c91d8b98a753 = '#313D52';
var $881e75c45a88d9b7$export$8e8133c1ba5845b5 = '#283447';
var $881e75c45a88d9b7$export$33ff357f6620b39 = '#202B3D';
var $881e75c45a88d9b7$export$633847cf062b69e0 = '#1B2638';
var $881e75c45a88d9b7$export$9776a6e503bdbf76 = '#121A29';
var $881e75c45a88d9b7$export$6c813d5160dff5db = '#0E1624';
var $881e75c45a88d9b7$export$3d4f271a500072a = '#0D1424';
var $881e75c45a88d9b7$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $881e75c45a88d9b7$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $881e75c45a88d9b7$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $881e75c45a88d9b7$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $881e75c45a88d9b7$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $881e75c45a88d9b7$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $881e75c45a88d9b7$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $881e75c45a88d9b7$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $881e75c45a88d9b7$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $881e75c45a88d9b7$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $881e75c45a88d9b7$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $881e75c45a88d9b7$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $881e75c45a88d9b7$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $881e75c45a88d9b7$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $881e75c45a88d9b7$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $881e75c45a88d9b7$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $881e75c45a88d9b7$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $881e75c45a88d9b7$export$d2adc5dedf09fced = '#292A2E';
var $881e75c45a88d9b7$export$f51762073d2bb381 = '#94C748';
var $881e75c45a88d9b7$export$95e26d54def96891 = '#B3DF72';


var $4e4d6f9c8d79362c$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $4e4d6f9c8d79362c$export$c93026a968943f95 = 'light';
var $4e4d6f9c8d79362c$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $4e4d6f9c8d79362c$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $4e4d6f9c8d79362c$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $4e4d6f9c8d79362c$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $881e75c45a88d9b7$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $4e4d6f9c8d79362c$export$6d8204c2cb2e06b8() / 4;
    (0, $b5d2e0354c69b158$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $4e4d6f9c8d79362c$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $4e4d6f9c8d79362c$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $4e4d6f9c8d79362c$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $b5d2e0354c69b158$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $4e4d6f9c8d79362c$export$ba1d834b86d72a09 = $4e4d6f9c8d79362c$export$a1b3edb637fb4f35;
var $4e4d6f9c8d79362c$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $881e75c45a88d9b7$export$8d43898f60b96a82), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $881e75c45a88d9b7$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $881e75c45a88d9b7$export$920c0d5c49070351), ")")
            }
        }
    };
};



var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $515a728f55aede1c$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}



var $5FkrB = parcelRequire("5FkrB");
function $12ca9acfdfc10757$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $5FkrB.useRef)(true);
    (0, $5FkrB.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}



var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $e90663b74b3343bb$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $e90663b74b3343bb$var$react18UseId = ($e90663b74b3343bb$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $e90663b74b3343bb$var$_React$useId !== void 0 ? $e90663b74b3343bb$var$_React$useId : undefined;
function $e90663b74b3343bb$export$f680877a34711e37() {
    if ($e90663b74b3343bb$var$react18UseId && (0, $64b3f566deaa9c38$export$b40ec24ac8275656)('platform-dst-react-18-use-id')) return $e90663b74b3343bb$var$react18UseId();
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $e90663b74b3343bb$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($e90663b74b3343bb$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $e90663b74b3343bb$export$6ee17796e3d70de2() {
    if ($e90663b74b3343bb$var$react18UseId && (0, $64b3f566deaa9c38$export$b40ec24ac8275656)('platform-dst-react-18-use-id')) {
        var uid = $e90663b74b3343bb$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $b5lkZ.useUIDSeed)();
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
var $b26b7c64ea7dc6ea$var$BORDER_WIDTH = 2;
var $b26b7c64ea7dc6ea$var$baseFocusOutsideStyles = (0, $74Zh5.css)({
    outline: "var(--ds-border-width-focused, 2px)".concat(" solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $b26b7c64ea7dc6ea$var$BORDER_WIDTH
});
var $b26b7c64ea7dc6ea$var$baseInsetStyles = (0, $74Zh5.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$b26b7c64ea7dc6ea$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
var $b26b7c64ea7dc6ea$var$focusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $b26b7c64ea7dc6ea$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $b26b7c64ea7dc6ea$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: "var(--ds-border-width, 1px)".concat(" solid")
        }
    }
});
var $b26b7c64ea7dc6ea$var$insetFocusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $b26b7c64ea7dc6ea$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $b26b7c64ea7dc6ea$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: "var(--ds-border-width, 1px)".concat(" solid"),
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $b26b7c64ea7dc6ea$var$FocusRing = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $b26b7c64ea7dc6ea$var$baseInsetStyles : $b26b7c64ea7dc6ea$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $b26b7c64ea7dc6ea$var$insetFocusRingStyles : $b26b7c64ea7dc6ea$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $74Zh5.jsx)((0, $74Zh5.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $5FkrB.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $5FkrB.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$b26b7c64ea7dc6ea$var$FocusRing.displayName = 'FocusRing';
var $b26b7c64ea7dc6ea$export$2e2bcd8739ae039 = $b26b7c64ea7dc6ea$var$FocusRing;



var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");


function $50ca8d9fc44121b9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $50ca8d9fc44121b9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $50ca8d9fc44121b9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $50ca8d9fc44121b9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $50ca8d9fc44121b9$var$ESCAPE = 'Escape';
function $50ca8d9fc44121b9$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var _useLayering = $50ca8d9fc44121b9$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $50ca8d9fc44121b9$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $50ca8d9fc44121b9$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $5FkrB.useContext)((0, $43f1965ab31d9c6c$export$650d12d3c2ddb8fc));
    var _useContext = (0, $5FkrB.useContext)((0, $43f1965ab31d9c6c$export$48b383b280e20440)), topLevelRef = _useContext.topLevelRef, layerList = _useContext.layerList;
    var isLayerDisabled = (0, $5FkrB.useCallback)(function() {
        if ((0, $64b3f566deaa9c38$export$b40ec24ac8275656)('layering-top-level-use-array')) {
            var _layerList$current$le, _layerList$current;
            return ((_layerList$current$le = layerList === null || layerList === void 0 || (_layerList$current = layerList.current) === null || _layerList$current === void 0 ? void 0 : _layerList$current.length) !== null && _layerList$current$le !== void 0 ? _layerList$current$le : 0) !== currentLevel;
        }
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef,
        layerList
    ]);
    return $50ca8d9fc44121b9$var$_objectSpread({
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    }, (0, $64b3f566deaa9c38$export$b40ec24ac8275656)('layering-top-level-use-array') ? {
        layerList: layerList
    } : {});
}



/** Create a new combined function that will call all the provided functions */ function $b4c9117eda03c176$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function cleanup() {
        fns.forEach(function(fn) {
            return fn();
        });
    };
}




/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $21b7e6b4b91231d5$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
var $21b7e6b4b91231d5$export$c881183ca713c214 = $21b7e6b4b91231d5$export$987d49ffe1b0900f;



var $e7c942592165b6c5$export$4ef52930e33717cd = 'data-theme';
var $e7c942592165b6c5$export$a00eac3f8684bcd0 = 'data-color-mode';
var $e7c942592165b6c5$export$2112803007239c61 = 'data-contrast-mode';
var $e7c942592165b6c5$export$352e418ed5b6193a = 'data-custom-theme';
var $e7c942592165b6c5$export$6f0c6fb8c80fcc92 = 'ds';
var $e7c942592165b6c5$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $e7c942592165b6c5$export$dddac1532e822863 = "--".concat($e7c942592165b6c5$export$6f0c6fb8c80fcc92, "-token-not-found");
var $e7c942592165b6c5$export$9d7b58831ae93caa = "--".concat($e7c942592165b6c5$export$6f0c6fb8c80fcc92, "-elevation-surface-current");



var $5FkrB = parcelRequire("5FkrB");
var $7168667b2edf2dff$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $7168667b2edf2dff$export$dece24112a937f92 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);



var $5FkrB = parcelRequire("5FkrB");
function $b7efde3c54a58959$export$2e2bcd8739ae039(_ref) {
    var onOpenComplete = _ref.onOpenComplete, onCloseComplete = _ref.onCloseComplete;
    var motionRef = (0, $5FkrB.useRef)(null);
    var onMotionFinish = (0, $5FkrB.useCallback)(function(state) {
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}



var $7QpUe = parcelRequire("7QpUe");


var $iYJcE = parcelRequire("iYJcE");

var $7QpUe = parcelRequire("7QpUe");

var $iYJcE = parcelRequire("iYJcE");
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
var $0b97a7bbae5ff13b$export$6eafea55f7947469 = 'data-pdnd-honey-pot';


function $7fdb9d00e656b56e$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $0b97a7bbae5ff13b$export$6eafea55f7947469));
}


function $f0216dd228dcee5c$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    var _document$elementsFro = document.elementsFromPoint(client.x, client.y), _document$elementsFro2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_document$elementsFro, 2), top = _document$elementsFro2[0], second = _document$elementsFro2[1];
    if (!top) return null;
    if ((0, $7fdb9d00e656b56e$export$821bdcd739a2706b)(top)) return second !== null && second !== void 0 ? second : null;
    return top;
}



var $25nEq = parcelRequire("25nEq");

var $7QpUe = parcelRequire("7QpUe");
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
var $05f68b3859abc068$export$7d0a15ee70427305 = 2147483647;



function $a2db9b16c6a11aa8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a2db9b16c6a11aa8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a2db9b16c6a11aa8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a2db9b16c6a11aa8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a2db9b16c6a11aa8$var$honeyPotSize = 2;
var $a2db9b16c6a11aa8$var$halfHoneyPotSize = $a2db9b16c6a11aa8$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $a2db9b16c6a11aa8$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $a2db9b16c6a11aa8$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $a2db9b16c6a11aa8$var$halfHoneyPotSize,
        y: point.y - $a2db9b16c6a11aa8$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $a2db9b16c6a11aa8$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $a2db9b16c6a11aa8$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $a2db9b16c6a11aa8$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $a2db9b16c6a11aa8$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $a2db9b16c6a11aa8$var$getHoneyPotRectFor(_ref) {
    var client = _ref.client;
    var point = $a2db9b16c6a11aa8$var$preventGoingForwardsOffScreen($a2db9b16c6a11aa8$var$preventGoingBackwardsOffScreen($a2db9b16c6a11aa8$var$pullBackByHalfHoneyPotSize($a2db9b16c6a11aa8$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $a2db9b16c6a11aa8$var$honeyPotSize,
        height: $a2db9b16c6a11aa8$var$honeyPotSize
    });
}
function $a2db9b16c6a11aa8$var$getRectStyles(_ref2) {
    var clientRect = _ref2.clientRect;
    return {
        left: "".concat(clientRect.left, "px"),
        top: "".concat(clientRect.top, "px"),
        width: "".concat(clientRect.width, "px"),
        height: "".concat(clientRect.height, "px")
    };
}
function $a2db9b16c6a11aa8$var$isWithin(_ref3) {
    var client = _ref3.client, clientRect = _ref3.clientRect;
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $a2db9b16c6a11aa8$var$mountHoneyPot(_ref4) {
    var initial = _ref4.initial;
    var element = document.createElement('div');
    element.setAttribute((0, $0b97a7bbae5ff13b$export$6eafea55f7947469), 'true');
    // can shift during the drag thanks to Firefox
    var clientRect = $a2db9b16c6a11aa8$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, $a2db9b16c6a11aa8$var$_objectSpread($a2db9b16c6a11aa8$var$_objectSpread({
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        position: 'fixed',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box'
    }, $a2db9b16c6a11aa8$var$getRectStyles({
        clientRect: clientRect
    })), {}, {
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        // Want to make sure the honey pot is top of everything else.
        // Don't need to worry about native drag previews, as they will
        // have been rendered (and removed) before the honey pot is rendered
        zIndex: (0, $05f68b3859abc068$export$7d0a15ee70427305)
    }));
    document.body.appendChild(element);
    /**
   *  🦊 In firefox we can get `"pointermove"` events after the drag
   * has started, which is a spec violation.
   * The final `"pointermove"` will reveal where the "depressed" position
   * is for our honey pot fix.
   */ var unbindPointerMove = (0, $7QpUe.bind)(window, {
        type: 'pointermove',
        listener: function listener(event) {
            var client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $a2db9b16c6a11aa8$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $a2db9b16c6a11aa8$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish(_ref5) {
        var current = _ref5.current;
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($a2db9b16c6a11aa8$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        var unbindPostDragEvents = (0, $7QpUe.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $a2db9b16c6a11aa8$export$8ecad27c959e89e0() {
    var latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $7QpUe.bind)(window, {
            type: 'pointermove',
            listener: function listener(event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        var finish = null;
        return function onPostEvent(_ref6) {
            var eventName = _ref6.eventName, payload = _ref6.payload;
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                var input = payload.location.initial.input;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                var initial = latestPointerMove !== null && latestPointerMove !== void 0 ? latestPointerMove : {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $a2db9b16c6a11aa8$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                var _finish;
                var _input = payload.location.current.input;
                (_finish = finish) === null || _finish === void 0 || _finish({
                    current: {
                        x: _input.clientX,
                        y: _input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}



var $fC8ib = parcelRequire("fC8ib");

var $7QpUe = parcelRequire("7QpUe");


/** Provide a function that you only ever want to be called a single time */ function $c188b2c4a30bf875$export$d2de3aaeafa91619(fn) {
    var cache = null;
    return function wrapped() {
        if (!cache) {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}


var $99702d4b640e012f$export$b7d78993b74f766d = (0, $c188b2c4a30bf875$export$d2de3aaeafa91619)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});



var $e565f4c1507f7c51$export$95df08bae54cb4df = (0, $c188b2c4a30bf875$export$d2de3aaeafa91619)(function isSafari() {
    var _navigator = navigator, userAgent = _navigator.userAgent;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});



var $7QpUe = parcelRequire("7QpUe");

/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
var $d3ca7e24bbce1da2$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $d3ca7e24bbce1da2$export$de68634bd94ed596(_ref) {
    var dragEnter = _ref.dragEnter;
    if (!(0, $e565f4c1507f7c51$export$95df08bae54cb4df)()) return false;
    return dragEnter.hasOwnProperty($d3ca7e24bbce1da2$var$symbols.isEnteringWindow);
}
function $d3ca7e24bbce1da2$export$f21837c338005454(_ref2) {
    var dragLeave = _ref2.dragLeave;
    if (!(0, $e565f4c1507f7c51$export$95df08bae54cb4df)()) return false;
    return dragLeave.hasOwnProperty($d3ca7e24bbce1da2$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $e565f4c1507f7c51$export$95df08bae54cb4df)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    var state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragstart',
            listener: function listener() {
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: function listener(event) {
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                event[$d3ca7e24bbce1da2$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    event[$d3ca7e24bbce1da2$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();


/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $bfe5a94cf8ebfd80$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $bfe5a94cf8ebfd80$export$e46810fef53b5b0e(eventTarget) {
    return $bfe5a94cf8ebfd80$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}


function $f2a485f03be8c52f$export$57d220c74e84a273(_ref) {
    var dragLeave = _ref.dragLeave;
    var type = dragLeave.type, relatedTarget = dragLeave.relatedTarget;
    if (type !== 'dragleave') return false;
    if ((0, $e565f4c1507f7c51$export$95df08bae54cb4df)()) return (0, $d3ca7e24bbce1da2$export$f21837c338005454)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   * (foreign element)
   */ if ((0, $99702d4b640e012f$export$b7d78993b74f766d)()) return (0, $bfe5a94cf8ebfd80$export$e46810fef53b5b0e)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is `null` *(standard check)*
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}


function $693c045f555a6306$export$ac5e5b0daf997b2(_ref) {
    var onDragEnd = _ref.onDragEnd;
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            }()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}


function $4e7790baf6ea11a1$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}



var $45Zis = parcelRequire("45Zis");
var $27edad9e39b12988$var$scheduleOnDrag = (0, $45Zis.default)(function(fn) {
    return fn();
});
var $27edad9e39b12988$var$dragStart = function() {
    var scheduled = null;
    function schedule(fn) {
        var frameId = requestAnimationFrame(function() {
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
}();
function $27edad9e39b12988$export$9f13ecc44e83d682(_ref) {
    var source = _ref.source, initial = _ref.initial, dispatchEvent = _ref.dispatchEvent;
    var previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    var dispatch = {
        start: function start(_ref2) {
            var nativeSetDragImage = _ref2.nativeSetDragImage;
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            var location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $27edad9e39b12988$var$dragStart.schedule(function() {
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate: function dragUpdate(_ref3) {
            var current = _ref3.current;
            $27edad9e39b12988$var$dragStart.flush();
            $27edad9e39b12988$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag: function drag(_ref4) {
            var current = _ref4.current;
            $27edad9e39b12988$var$scheduleOnDrag(function() {
                $27edad9e39b12988$var$dragStart.flush();
                var location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop: function drop(_ref5) {
            var current = _ref5.current, updatedSourcePayload = _ref5.updatedSourcePayload;
            $27edad9e39b12988$var$dragStart.flush();
            $27edad9e39b12988$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload !== null && updatedSourcePayload !== void 0 ? updatedSourcePayload : source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}


var $d8a04a4ab4cdc78c$var$globalState = {
    isActive: false
};
function $d8a04a4ab4cdc78c$var$canStart() {
    return !$d8a04a4ab4cdc78c$var$globalState.isActive;
}
function $d8a04a4ab4cdc78c$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $d8a04a4ab4cdc78c$var$hasHierarchyChanged(_ref) {
    var current = _ref.current, next = _ref.next;
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(var i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $d8a04a4ab4cdc78c$var$start(_ref2) {
    var event = _ref2.event, dragType = _ref2.dragType, getDropTargetsOver = _ref2.getDropTargetsOver, dispatchEvent = _ref2.dispatchEvent;
    if (!$d8a04a4ab4cdc78c$var$canStart()) return;
    var initial = $d8a04a4ab4cdc78c$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $d8a04a4ab4cdc78c$var$globalState.isActive = true;
    var state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $d8a04a4ab4cdc78c$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    var dispatch = (0, $27edad9e39b12988$export$9f13ecc44e83d682)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        var hasChanged = $d8a04a4ab4cdc78c$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        var input = (0, $4e7790baf6ea11a1$export$7c112ceec8941e67)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        var target = (0, $7fdb9d00e656b56e$export$821bdcd739a2706b)(event.target) ? (0, $f0216dd228dcee5c$export$81d0353f25f5dd)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        var nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $d8a04a4ab4cdc78c$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $d8a04a4ab4cdc78c$var$globalState.isActive = false;
        unbindEvents();
    }
    var unbindEvents = (0, $7QpUe.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener: function listener(event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                if (!(0, $f2a485f03be8c52f$export$57d220c74e84a273)({
                    dragLeave: event
                })) return;
                /**
       * At this point we don't know if a drag is being cancelled,
       * or if a drag is leaving the `window`.
       *
       * Both have:
       *   1. "dragleave" (with `relatedTarget: null`)
       *   2. "dragend" (a "dragend" can occur when outside the `window`)
       *
       * **Clearing drop targets**
       *
       * For either case we are clearing the the drop targets
       *
       * - cancelling: we clear drop targets in `"dragend"` anyway
       * - leaving the `window`: we clear the drop targets (to clear stickiness)
       *
       * **Leaving the window and finishing the drag**
       *
       * _internal drags_
       *
       * - The drag continues when the user is outside the `window`
       *   and can resume if the user drags back over the `window`,
       *   or end when the user drops in an external `window`.
       * - We will get a `"dragend"`, or we can listen for other
       *   events to determine the drag is finished when the user re-enters the `window`).
       *
       * _external drags_
       *
       * - We conclude the drag operation.
       * - We have no idea if the user will drag back over the `window`,
       *   or if the drag ends elsewhere.
       * - We will create a new drag if the user re-enters the `window`.
       *
       * **Not updating `input`**
       *
       * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
       * Workaround: intentionally not updating `input` in "dragleave"
       * rather than the users current input values
       * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
       * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
       **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener: function listener(event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $4e7790baf6ea11a1$export$7c112ceec8941e67)(event)
                };
                /** If there are no drop targets, then we will get
       * a "drop" event if:
       * - `preventUnhandled()` is being used
       * - there is an unmanaged drop target (eg another library)
       * In these cases, it's up to the consumer
       * to handle the drop if it's not over one of our drop targets
       * - `preventUnhandled()` will cancel the "drop"
       * - unmanaged drop targets can handle the "drop" how they want to
       * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $d8a04a4ab4cdc78c$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener: function listener(event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $4e7790baf6ea11a1$export$7c112ceec8941e67)(event)
                };
                cancel();
            }
        }
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((0, $693c045f555a6306$export$ac5e5b0daf997b2)({
        onDragEnd: cancel
    }))), // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $d8a04a4ab4cdc78c$var$getNativeSetDragImage(event)
    });
}
function $d8a04a4ab4cdc78c$var$setDropEffectOnEvent(_ref3) {
    var _current$;
    var event = _ref3.event, current = _ref3.current;
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    var innerMost = (_current$ = current[0]) === null || _current$ === void 0 ? void 0 : _current$.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $d8a04a4ab4cdc78c$var$getStartLocation(_ref4) {
    var event = _ref4.event, dragType = _ref4.dragType, getDropTargetsOver = _ref4.getDropTargetsOver;
    var input = (0, $4e7790baf6ea11a1$export$7c112ceec8941e67)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    var dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
var $d8a04a4ab4cdc78c$export$3efdceeb8ca25c51 = {
    canStart: $d8a04a4ab4cdc78c$var$canStart,
    start: $d8a04a4ab4cdc78c$var$start
};


// Extending `Map` to allow us to link Key and Values together
var $c28f4b218b984a40$var$ledger = new Map();
function $c28f4b218b984a40$var$registerUsage(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount;
    var entry = $c28f4b218b984a40$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    var initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $c28f4b218b984a40$var$ledger.set(typeKey, initial);
    return initial;
}
function $c28f4b218b984a40$export$6503ec6e8aabbaf(args) {
    var entry = $c28f4b218b984a40$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $c28f4b218b984a40$var$ledger.delete(args.typeKey);
    };
}



var $25nEq = parcelRequire("25nEq");

var $fC8ib = parcelRequire("fC8ib");


function $1b90fac4e46b3988$export$5dcb5c23b6ba980a(element, _ref) {
    var attribute = _ref.attribute, value = _ref.value;
    element.setAttribute(attribute, value);
    return function() {
        return element.removeAttribute(attribute);
    };
}


function $5a22e9902af5c746$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5a22e9902af5c746$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5a22e9902af5c746$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5a22e9902af5c746$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5a22e9902af5c746$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $5a22e9902af5c746$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $5a22e9902af5c746$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5a22e9902af5c746$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5a22e9902af5c746$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $5a22e9902af5c746$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $5a22e9902af5c746$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $5a22e9902af5c746$export$47d10e7bd9c81890(_ref) {
    var typeKey = _ref.typeKey, defaultDropEffect = _ref.defaultDropEffect;
    var registry = new WeakMap();
    var dropTargetDataAtt = "data-drop-target-for-".concat(typeKey);
    var dropTargetSelector = "[".concat(dropTargetDataAtt, "]");
    function addToRegistry(args) {
        registry.set(args.element, args);
        return function() {
            return registry.delete(args.element);
        };
    }
    function dropTargetForConsumers(args) {
        var existing;
        var cleanup = (0, $b4c9117eda03c176$export$1be1fc439b849fdf)((0, $1b90fac4e46b3988$export$5dcb5c23b6ba980a)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $c188b2c4a30bf875$export$d2de3aaeafa91619)(cleanup);
    }
    function getActualDropTargets(_ref2) {
        var _args$getData, _args$getData2, _args$getDropEffect, _args$getDropEffect2;
        var source = _ref2.source, target = _ref2.target, input = _ref2.input, _ref2$result = _ref2.result, result = _ref2$result === void 0 ? [] : _ref2$result;
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        var closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        var args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        var feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        var data = (_args$getData = (_args$getData2 = args.getData) === null || _args$getData2 === void 0 ? void 0 : _args$getData2.call(args, feedback)) !== null && _args$getData !== void 0 ? _args$getData : {};
        var dropEffect = (_args$getDropEffect = (_args$getDropEffect2 = args.getDropEffect) === null || _args$getDropEffect2 === void 0 ? void 0 : _args$getDropEffect2.call(args, feedback)) !== null && _args$getDropEffect !== void 0 ? _args$getDropEffect : defaultDropEffect;
        var record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result), [
                record
            ])
        });
    }
    function notifyCurrent(_ref3) {
        var eventName = _ref3.eventName, payload = _ref3.payload;
        var _iterator = $5a22e9902af5c746$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _entry$eventName;
                var record = _step.value;
                var entry = registry.get(record.element);
                var args = $5a22e9902af5c746$var$_objectSpread($5a22e9902af5c746$var$_objectSpread({}, payload), {}, {
                    self: record
                });
                entry === null || entry === void 0 || (_entry$eventName = entry[eventName]) === null || _entry$eventName === void 0 || _entry$eventName.call(entry, // I cannot seem to get the types right here.
                // TS doesn't seem to like that one event can need `nativeSetDragImage`
                // @ts-expect-error
                args);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    var actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: function onDropTargetChange(_ref4) {
            var payload = _ref4.payload;
            var isCurrent = new Set(payload.location.current.dropTargets.map(function(record) {
                return record.element;
            }));
            var visited = new Set();
            var _iterator2 = $5a22e9902af5c746$var$_createForOfIteratorHelper(payload.location.previous.dropTargets), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _entry$onDropTargetCh;
                    var record = _step2.value;
                    visited.add(record.element);
                    var entry = registry.get(record.element);
                    var isOver = isCurrent.has(record.element);
                    var args = $5a22e9902af5c746$var$_objectSpread($5a22e9902af5c746$var$_objectSpread({}, payload), {}, {
                        self: record
                    });
                    entry === null || entry === void 0 || (_entry$onDropTargetCh = entry.onDropTargetChange) === null || _entry$onDropTargetCh === void 0 || _entry$onDropTargetCh.call(entry, args);
                    // if we cannot find the drop target in the current array, then it has been left
                    if (!isOver) {
                        var _entry$onDragLeave;
                        entry === null || entry === void 0 || (_entry$onDragLeave = entry.onDragLeave) === null || _entry$onDragLeave === void 0 || _entry$onDragLeave.call(entry, args);
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var _iterator3 = $5a22e9902af5c746$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var _entry$onDropTargetCh2, _entry$onDragEnter;
                    var _record = _step3.value;
                    // already published an update to this drop target
                    if (visited.has(_record.element)) continue;
                    // at this point we have a new drop target that is being entered into
                    var _args = $5a22e9902af5c746$var$_objectSpread($5a22e9902af5c746$var$_objectSpread({}, payload), {}, {
                        self: _record
                    });
                    var _entry = registry.get(_record.element);
                    _entry === null || _entry === void 0 || (_entry$onDropTargetCh2 = _entry.onDropTargetChange) === null || _entry$onDropTargetCh2 === void 0 || _entry$onDropTargetCh2.call(_entry, _args);
                    _entry === null || _entry === void 0 || (_entry$onDragEnter = _entry.onDragEnter) === null || _entry$onDragEnter === void 0 || _entry$onDragEnter.call(_entry, _args);
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver(_ref5) {
        var source = _ref5.source, target = _ref5.target, input = _ref5.input, current = _ref5.current;
        var actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        var lastCaptureOrdered = $5a22e9902af5c746$var$copyReverse(current);
        var actualCaptureOrdered = $5a22e9902af5c746$var$copyReverse(actual);
        var resultCaptureOrdered = [];
        for(var index = 0; index < lastCaptureOrdered.length; index++){
            var _argsForLast$getIsSti;
            var last = lastCaptureOrdered[index];
            var fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            var parent = resultCaptureOrdered[index - 1];
            var lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if ((parent === null || parent === void 0 ? void 0 : parent.element) !== (lastParent === null || lastParent === void 0 ? void 0 : lastParent.element)) break;
            // We need to check whether the old drop target can still be dropped on
            var argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            var feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!((_argsForLast$getIsSti = argsForLast.getIsSticky) !== null && _argsForLast$getIsSti !== void 0 && _argsForLast$getIsSti.call(argsForLast, feedback))) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push($5a22e9902af5c746$var$_objectSpread($5a22e9902af5c746$var$_objectSpread({}, last), {}, {
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            }));
        }
        // return bubble ordered result
        return $5a22e9902af5c746$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}



var $25nEq = parcelRequire("25nEq");

function $4188fe682b04481f$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $4188fe682b04481f$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $4188fe682b04481f$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $4188fe682b04481f$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $4188fe682b04481f$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $4188fe682b04481f$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $4188fe682b04481f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4188fe682b04481f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4188fe682b04481f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4188fe682b04481f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4188fe682b04481f$export$5dd4ed888d5b12ca() {
    var registry = new Set();
    var dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        var entry = $4188fe682b04481f$var$_objectSpread({}, args);
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $c188b2c4a30bf875$export$d2de3aaeafa91619)(cleanup);
    }
    function dispatchEvent(_ref) {
        var eventName = _ref.eventName, payload = _ref.payload;
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            var _iterator = $4188fe682b04481f$var$_createForOfIteratorHelper(registry), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var monitor = _step.value;
                    tryAddToActive(monitor);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        var active = Array.from(dragging.active);
        for(var _i = 0, _active = active; _i < _active.length; _i++){
            var _monitor = _active[_i];
            // A monitor can be removed by another monitor during an event.
            // We need to check that the monitor is still registered before calling it
            if (dragging.active.has(_monitor)) {
                var _monitor$eventName;
                // @ts-expect-error: I cannot get this type working!
                (_monitor$eventName = _monitor[eventName]) === null || _monitor$eventName === void 0 || _monitor$eventName.call(_monitor, payload);
            }
        }
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}


function $8dafdfaa808fe441$export$2aa3a33160990d96(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount, dispatchEventToSource = _ref.dispatchEventToSource, onPostDispatch = _ref.onPostDispatch, defaultDropEffect = _ref.defaultDropEffect;
    var monitorAPI = (0, $4188fe682b04481f$export$5dd4ed888d5b12ca)();
    var dropTargetAPI = (0, $5a22e9902af5c746$export$47d10e7bd9c81890)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource === null || dispatchEventToSource === void 0 || dispatchEventToSource(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch === null || onPostDispatch === void 0 || onPostDispatch(args);
    }
    function start(_ref2) {
        var event = _ref2.event, dragType = _ref2.dragType;
        (0, $d8a04a4ab4cdc78c$export$3efdceeb8ca25c51).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            var api = {
                canStart: (0, $d8a04a4ab4cdc78c$export$3efdceeb8ca25c51).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $c28f4b218b984a40$export$6503ec6e8aabbaf)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}






var $53e9edefd5e15b6f$export$a11b0059900ceec8 = (0, $c188b2c4a30bf875$export$d2de3aaeafa91619)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
var $53e9edefd5e15b6f$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';



// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $f544359637954bfd$export$fd3d00026297c0ad = 'text/plain';


// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $a760442a65ef664b$export$4c44a460f123106 = 'text/uri-list';


/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ var $22b65a5958722e35$export$c9c4cc54e73b125d = 'application/vnd.pdnd';


var $ff8f70951ad7e94c$var$draggableRegistry = new WeakMap();
function $ff8f70951ad7e94c$var$addToRegistry(args) {
    $ff8f70951ad7e94c$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $ff8f70951ad7e94c$var$draggableRegistry.delete(args.element);
    };
}
var $ff8f70951ad7e94c$var$honeyPotFix = (0, $a2db9b16c6a11aa8$export$8ecad27c959e89e0)();
var $ff8f70951ad7e94c$var$adapter = (0, $8dafdfaa808fe441$export$2aa3a33160990d96)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount: function mount(api) {
        /**  Binding event listeners the `document` rather than `window` so that
     * this adapter always gets preference over the text adapter.
     * `document` is the first `EventTarget` under `window`
     * https://twitter.com/alexandereardon/status/1604658588311465985
     */ return (0, $b4c9117eda03c176$export$1be1fc439b849fdf)($ff8f70951ad7e94c$var$honeyPotFix.bindEvents(), (0, $7QpUe.bind)(document, {
            type: 'dragstart',
            listener: function listener(event) {
                var _entry$dragHandle, _entry$getInitialData, _entry$getInitialData2, _entry$dragHandle2, _entry$getInitialData3, _entry$getInitialData4;
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                var target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return;
                // see if the thing being dragged is owned by us
                var entry = $ff8f70951ad7e94c$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return;
                /**
         * A text selection drag _can_ have the `draggable` element be
         * the `event.target` if the user is dragging the text selection
         * from the `draggable`.
         *
         * To know if the `draggable` is being dragged, we look at whether any
         * `"text/plain"` data is being dragged. If it is, then a text selection
         * drag is occurring.
         *
         * This behaviour has been validated on:
         *
         * - Chrome@128 on Android@14
         * - Chrome@128 on iOS@17.6.1
         * - Chrome@128 on Windows@11
         * - Chrome@128 on MacOS@14.6.1
         * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
         * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
         *
         * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
         * but unfortunately ProseMirror is always setting `""` as the dragged text
         *
         * Note: Unfortunately editor is (heavily) leaning on the current functionality today
         * and unwinding it will be a decent amount of effort. So for now, a text selection
         * where the `event.target` is a `draggable` element will still trigger the
         * element adapter.
         *
         * // Future state:
         * if(event.dataTransfer.getData(textMediaType)) {
         * 	return;
         * }
         *
         */ var input = (0, $4e7790baf6ea11a1$export$7c112ceec8941e67)(event);
                var feedback = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle = entry.dragHandle) !== null && _entry$dragHandle !== void 0 ? _entry$dragHandle : null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    var over = (0, $f0216dd228dcee5c$export$81d0353f25f5dd)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return;
                    }
                }
                /**
         *  **Goal**
         *  Pass information to other applications
         *
         * **Approach**
         *  Put data into the native data store
         *
         *  **What about the native adapter?**
         *  When the element adapter puts native data into the native data store
         *  the native adapter is not triggered in the current window,
         *  but a native adapter in an external window _can_ be triggered
         *
         *  **Why bake this into core?**
         *  This functionality could be pulled out and exposed inside of
         *  `onGenerateDragPreview`. But decided to make it a part of the
         *  base API as it felt like a common enough use case and ended
         *  up being a similar amount of code to include this function as
         *  it was to expose the hook for it
         */ var nativeData = (_entry$getInitialData = (_entry$getInitialData2 = entry.getInitialDataForExternal) === null || _entry$getInitialData2 === void 0 ? void 0 : _entry$getInitialData2.call(entry, feedback)) !== null && _entry$getInitialData !== void 0 ? _entry$getInitialData : null;
                if (nativeData) for(var _i = 0, _Object$entries = Object.entries(nativeData); _i < _Object$entries.length; _i++){
                    var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], data = _Object$entries$_i[1];
                    event.dataTransfer.setData(key, data !== null && data !== void 0 ? data : '');
                }
                /**
         *  📱 For Android devices, a drag operation will not start unless
         * "text/plain" or "text/uri-list" data exists in the native data store
         * https://twitter.com/alexandereardon/status/1732189803754713424
         *
         * Tested on:
         * Device: Google Pixel 5
         * Android version: 14 (November 5, 2023)
         * Chrome version: 120.0
         */ if ((0, $53e9edefd5e15b6f$export$a11b0059900ceec8)() && !event.dataTransfer.types.includes((0, $f544359637954bfd$export$fd3d00026297c0ad)) && !event.dataTransfer.types.includes((0, $a760442a65ef664b$export$4c44a460f123106))) event.dataTransfer.setData((0, $f544359637954bfd$export$fd3d00026297c0ad), (0, $53e9edefd5e15b6f$export$aceb3ed8b7f7bd2c));
                /**
         * 1. Must set any media type for `iOS15` to work
         * 2. We are also doing adding data so that the native adapter
         * can know that the element adapter has handled this drag
         *
         * We used to wrap this `setData()` in a `try/catch` for Firefox,
         * but it looks like that was not needed.
         *
         * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
         *
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
         * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
         *
         * // just checking a few more combinations to be super safe
         *
         * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
         * - ✅ Chrome@78 (Oct 2019) on Windows 10
         * - ✅ Safari@14.1 on macOS Big Sur
         */ event.dataTransfer.setData((0, $22b65a5958722e35$export$c9c4cc54e73b125d), '');
                var payload = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle2 = entry.dragHandle) !== null && _entry$dragHandle2 !== void 0 ? _entry$dragHandle2 : null,
                    data: (_entry$getInitialData3 = (_entry$getInitialData4 = entry.getInitialData) === null || _entry$getInitialData4 === void 0 ? void 0 : _entry$getInitialData4.call(entry, feedback)) !== null && _entry$getInitialData3 !== void 0 ? _entry$getInitialData3 : {}
                };
                var dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: function dispatchEventToSource(_ref) {
        var _draggableRegistry$ge, _draggableRegistry$ge2;
        var eventName = _ref.eventName, payload = _ref.payload;
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        (_draggableRegistry$ge = $ff8f70951ad7e94c$var$draggableRegistry.get(payload.source.element)) === null || _draggableRegistry$ge === void 0 || (_draggableRegistry$ge2 = _draggableRegistry$ge[eventName]) === null || _draggableRegistry$ge2 === void 0 || _draggableRegistry$ge2.call(_draggableRegistry$ge, // I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $ff8f70951ad7e94c$var$honeyPotFix.getOnPostDispatch()
});
var $ff8f70951ad7e94c$export$e7140b68045b5036 = $ff8f70951ad7e94c$var$adapter.dropTarget;
var $ff8f70951ad7e94c$export$59a074bac4c54f54 = $ff8f70951ad7e94c$var$adapter.monitor;
function $ff8f70951ad7e94c$export$c746a5152d4ba26c(args) {
    var existing;
    var cleanup = (0, $b4c9117eda03c176$export$1be1fc439b849fdf)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $ff8f70951ad7e94c$var$adapter.registerUsage(), $ff8f70951ad7e94c$var$addToRegistry(args), (0, $1b90fac4e46b3988$export$5dcb5c23b6ba980a)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, $c188b2c4a30bf875$export$d2de3aaeafa91619)(cleanup);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrag()`) on for a `draggable()` */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForElements()` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForElements` */ 


 // Payload for the draggable being dragged



var $fC8ib = parcelRequire("fC8ib");

/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $ca7ed9508127d4d2$var$setStyle(el, _ref) {
    var property = _ref.property, rule = _ref.rule, _ref$priority = _ref.priority, priority = _ref$priority === void 0 ? '' : _ref$priority;
    var originalValue = el.style.getPropertyValue(property);
    var originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $ca7ed9508127d4d2$var$hasSameOrigin(href1, href2) {
    var url1;
    var url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (error) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $ca7ed9508127d4d2$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith('data:')) return false;
    return !$ca7ed9508127d4d2$var$hasSameOrigin(window.location.href, iframe.src);
}
var $ca7ed9508127d4d2$var$registry = new Map();
function $ca7ed9508127d4d2$var$applyFix(watchForEndOfInteraction) {
    var iframes = Array.from(document.querySelectorAll('iframe')).filter($ca7ed9508127d4d2$var$isIframeOnAnotherDomain);
    var cleanups = iframes.map(function(iframe) {
        var entry = $ca7ed9508127d4d2$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $ca7ed9508127d4d2$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $ca7ed9508127d4d2$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $ca7ed9508127d4d2$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $b4c9117eda03c176$export$1be1fc439b849fdf).apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(cleanups))();
    }
    var cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $ca7ed9508127d4d2$export$a74bff2507e6126b(_ref2) {
    var watchForInteractionStart = _ref2.watchForInteractionStart, watchForInteractionEnd = _ref2.watchForInteractionEnd;
    var registrationCount = 0;
    var stopWatchingInteractionStart = null;
    function start() {
        $ca7ed9508127d4d2$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            var _stopWatchingInteract;
            registrationCount--;
            if (registrationCount !== 0) return;
            (_stopWatchingInteract = stopWatchingInteractionStart) === null || _stopWatchingInteract === void 0 || _stopWatchingInteract();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}


function $83969708bab70d34$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var unbindEvents = (0, $7QpUe.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $ff8f70951ad7e94c$export$59a074bac4c54f54)({
        onGenerateDragPreview: function onGenerateDragPreview() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $b4c9117eda03c176$export$1be1fc439b849fdf)(unbindEvents, unbindMonitor);
}
function $83969708bab70d34$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $7QpUe.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener(event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
var $83969708bab70d34$var$api = (0, $ca7ed9508127d4d2$export$a74bff2507e6126b)({
    watchForInteractionStart: $83969708bab70d34$var$watchForInteractionStart,
    watchForInteractionEnd: $83969708bab70d34$var$watchForInteractionEnd
});
function $83969708bab70d34$export$ec28e97c7d8b1b35() {
    return $83969708bab70d34$var$api.registerUsage();
}



var $fC8ib = parcelRequire("fC8ib");

var $7QpUe = parcelRequire("7QpUe");






function $b52f8b17d3495284$export$d1c6f249e893cdf4(_ref) {
    var dragEnter = _ref.dragEnter;
    var type = dragEnter.type, relatedTarget = dragEnter.relatedTarget;
    if (type !== 'dragenter') return false;
    if ((0, $e565f4c1507f7c51$export$95df08bae54cb4df)()) return (0, $d3ca7e24bbce1da2$export$de68634bd94ed596)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is the `iframe` element in the parent `window`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is an element inside the child `iframe`
   * (foreign element)
   */ if ((0, $99702d4b640e012f$export$b7d78993b74f766d)()) return (0, $bfe5a94cf8ebfd80$export$e46810fef53b5b0e)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is `null` *(standard check)*
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is the `iframe` element in the parent `window`
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}





function $6d96d862b8cd1927$export$a8e56a860d7957c7(_ref) {
    var type = _ref.type, value = _ref.value;
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $22b65a5958722e35$export$c9c4cc54e73b125d)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $f544359637954bfd$export$fd3d00026297c0ad) && value === (0, $53e9edefd5e15b6f$export$aceb3ed8b7f7bd2c)) return false;
    return true;
}
function $6d96d862b8cd1927$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter(function(type) {
        return $6d96d862b8cd1927$export$a8e56a860d7957c7({
            type: type,
            value: transfer.getData(type)
        });
    });
}
function $6d96d862b8cd1927$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter(function(item) {
        return item.kind === 'file' || $6d96d862b8cd1927$export$a8e56a860d7957c7({
            type: item.type,
            value: dataTransfer.getData(item.type)
        });
    });
}
var $6d96d862b8cd1927$var$didDragStartLocally = false;
var $6d96d862b8cd1927$var$adapter = (0, $8dafdfaa808fe441$export$2aa3a33160990d96)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $7QpUe.bind)(window, {
            type: 'dragenter',
            listener: function listener(event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($6d96d862b8cd1927$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $b52f8b17d3495284$export$d1c6f249e893cdf4)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                var types = $6d96d862b8cd1927$export$8c257a3856120a77(event.dataTransfer);
                if (!types.length) return;
                var locked = {
                    types: types,
                    items: [],
                    getStringData: function getStringData() {
                        return null;
                    }
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload: function getDropPayload(event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            var items = $6d96d862b8cd1927$export$8d28cfecded8dcab(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            var nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData: function getStringData(mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    var value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!$6d96d862b8cd1927$export$a8e56a860d7957c7({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function $6d96d862b8cd1927$export$9edc779df9a85289(args) {
    // not removing unused events, just leaning on the type system
    return $6d96d862b8cd1927$var$adapter.dropTarget(args);
}
function $6d96d862b8cd1927$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return $6d96d862b8cd1927$var$adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $6d96d862b8cd1927$var$adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    var idle = {
        type: 'idle'
    };
    var state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $6d96d862b8cd1927$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $7QpUe.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((0, $693c045f555a6306$export$ac5e5b0daf997b2)({
            onDragEnd: clear
        }))), // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $7QpUe.bind)(window, {
        type: 'dragstart',
        listener: function listener() {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $6d96d862b8cd1927$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})(); /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 


 // The data that is being dragged



function $5f80798a6c74042d$var$watchForInteractionStart(_ref) {
    var start = _ref.start;
    return (0, $6d96d862b8cd1927$export$bb1740f3194979c1)({
        onDragStart: function onDragStart() {
            start();
        }
    });
}
function $5f80798a6c74042d$var$watchForInteractionEnd(_ref2) {
    var stop = _ref2.stop;
    return (0, $6d96d862b8cd1927$export$bb1740f3194979c1)({
        onDrop: function onDrop() {
            stop();
        }
    });
}
var $5f80798a6c74042d$var$api = (0, $ca7ed9508127d4d2$export$a74bff2507e6126b)({
    watchForInteractionStart: $5f80798a6c74042d$var$watchForInteractionStart,
    watchForInteractionEnd: $5f80798a6c74042d$var$watchForInteractionEnd
});
function $5f80798a6c74042d$export$27d79116d3a4e7d5() {
    return $5f80798a6c74042d$var$api.registerUsage();
}



var $7QpUe = parcelRequire("7QpUe");


var $7QpUe = parcelRequire("7QpUe");




// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $5c164a55038621b9$export$338a9f6c7a1f02b0 = 'text/html';




function $671816232202d1ca$var$findTextNode(event) {
    var _event$dataTransfer;
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $e565f4c1507f7c51$export$95df08bae54cb4df)()) return null;
    /**
   * According to the spec, `event.target` should be the `Text` node that
   * the drag started from when dragging a text selection.
   *
   * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
   *
   * However, in Safari the closest `HTMLElement` is returned.
   * So we need to figure out if text is dragging ourselves.
   *
   * → https://bugs.webkit.org/show_bug.cgi?id=268959
   */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!((_event$dataTransfer = event.dataTransfer) !== null && _event$dataTransfer !== void 0 && _event$dataTransfer.getData((0, $f544359637954bfd$export$fd3d00026297c0ad)))) return null;
    /**
   * Grab the first Text node and use that.
   * Only doing a single level search as that is all we need for this bug.
   */ var text = Array.from(event.target.childNodes).find(function(node) {
        return node.nodeType === Node.TEXT_NODE;
    });
    return text !== null && text !== void 0 ? text : null;
}
var $671816232202d1ca$var$honeyPotFix = (0, $a2db9b16c6a11aa8$export$8ecad27c959e89e0)();
var $671816232202d1ca$var$adapter = (0, $8dafdfaa808fe441$export$2aa3a33160990d96)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $b4c9117eda03c176$export$1be1fc439b849fdf)($671816232202d1ca$var$honeyPotFix.bindEvents(), (0, $7QpUe.bind)(window, {
            type: 'dragstart',
            listener: function listener(event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $22b65a5958722e35$export$c9c4cc54e73b125d))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $f544359637954bfd$export$fd3d00026297c0ad))) return;
                var target = $671816232202d1ca$var$findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                var payload = {
                    // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target: target,
                    plain: event.dataTransfer.getData((0, $f544359637954bfd$export$fd3d00026297c0ad)),
                    HTML: event.dataTransfer.getData((0, $5c164a55038621b9$export$338a9f6c7a1f02b0))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: $671816232202d1ca$var$honeyPotFix.getOnPostDispatch()
});
function $671816232202d1ca$export$9bfaa8eb182300d1(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $671816232202d1ca$var$adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $671816232202d1ca$var$adapter.registerUsage();
})();
function $671816232202d1ca$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $671816232202d1ca$var$adapter.monitor(args);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Argument given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Argument given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 


 // Payload for the text selection being dragged



function $6d69ce072be2e03a$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var frameId = null;
    var unbindEvents = (0, $7QpUe.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener: function listener() {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(function() {
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $671816232202d1ca$export$2e178e3647f5e6e9)({
        onDragStart: function onDragStart() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $b4c9117eda03c176$export$1be1fc439b849fdf)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $6d69ce072be2e03a$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $7QpUe.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener() {
            // A text selection drag will only start when there is
            // an active text selection.
            var selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
var $6d69ce072be2e03a$var$api = (0, $ca7ed9508127d4d2$export$a74bff2507e6126b)({
    watchForInteractionStart: $6d69ce072be2e03a$var$watchForInteractionStart,
    watchForInteractionEnd: $6d69ce072be2e03a$var$watchForInteractionEnd
});
function $6d69ce072be2e03a$export$9c0606fcefb5d1e2() {
    return $6d69ce072be2e03a$var$api.registerUsage();
}


var $3e53a340f86f7a9c$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};
var $3e53a340f86f7a9c$export$a3da89b899389ed8 = function dialogWidth(input) {
    if (!input) return 'auto';
    var isWidthName = $3e53a340f86f7a9c$export$7e3df82ee760448c.values.indexOf(input.toString()) !== -1;
    var widthName = isWidthName && input;
    if (widthName) return "".concat($3e53a340f86f7a9c$export$7e3df82ee760448c.widths[widthName], "px");
    return typeof input === 'number' ? "".concat(input, "px") : input;
};
var $3e53a340f86f7a9c$export$ceba93bf0bdd16f2 = function dialogHeight(input) {
    if (!input) return 'auto';
    return typeof input === 'number' ? "".concat(input, "px") : input;
};



var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");
var $3bad84a465711183$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
var $3bad84a465711183$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
var $3bad84a465711183$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
var $3bad84a465711183$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
var $3bad84a465711183$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
var $3bad84a465711183$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
var $3bad84a465711183$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';





var $df7cf2c434291638$var$gutter = 60;
var $df7cf2c434291638$var$maxWidthDimensions = "calc(100vw - ".concat($df7cf2c434291638$var$gutter * 2, "px)");
var $df7cf2c434291638$var$maxHeightDimensions = "calc(100vh - ".concat($df7cf2c434291638$var$gutter * 2 - 1, "px)");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
var $df7cf2c434291638$var$positionerStyles = (0, $74Zh5.css)({
    display: 'flex',
    width: '100%',
    maxWidth: '100%',
    height: '100%',
    position: 'fixed',
    zIndex: (0, $4e4d6f9c8d79362c$export$7be255094ccdc533).modal(),
    flexDirection: 'column',
    insetBlockStart: 0,
    insetInlineStart: 0
});
var $df7cf2c434291638$var$viewportScrollStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    height: 'auto',
    position: 'relative'
}, (0, $21b7e6b4b91231d5$export$987d49ffe1b0900f).above.xs, {
    margin: "".concat($df7cf2c434291638$var$gutter, "px auto"),
    pointerEvents: 'none'
}));
var $df7cf2c434291638$var$bodyScrollStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $21b7e6b4b91231d5$export$987d49ffe1b0900f).above.xs, {
    maxWidth: $df7cf2c434291638$var$maxWidthDimensions,
    maxHeight: $df7cf2c434291638$var$maxHeightDimensions,
    position: 'absolute',
    insetBlockStart: "".concat($df7cf2c434291638$var$gutter, "px"),
    insetInlineEnd: 0,
    insetInlineStart: 0,
    marginInlineEnd: 'auto',
    marginInlineStart: 'auto',
    pointerEvents: 'none'
}));
var $df7cf2c434291638$var$stackTransitionStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    transitionDuration: "".concat((0, $e28ea633b7112ff9$export$38b928a7167ce124).medium, "ms"),
    transitionProperty: 'transform',
    transitionTimingFunction: (0, $3bad84a465711183$export$c07234257a03d5e9),
    /**
   * Duplicated from @atlaskit/motion/accessibility
   * because @repo/internal/styles/consistent-style-ordering
   * doesn't work well with object spreading.
   */ '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
});
var $df7cf2c434291638$var$stackTransformStyles = (0, $74Zh5.css)({
    transform: 'translateY(var(--modal-dialog-translate-y))'
});
var $df7cf2c434291638$var$stackIdleStyles = (0, $74Zh5.css)({
    transform: 'none'
});
var $df7cf2c434291638$var$Positioner = function Positioner(props) {
    var children = props.children, stackIndex = props.stackIndex, shouldScrollInViewport = props.shouldScrollInViewport, testId = props.testId;
    return (0, $74Zh5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-translate-y': "calc(".concat(stackIndex, "px * ", "var(--ds-space-100, 8px)", ")")
        },
        css: [
            $df7cf2c434291638$var$positionerStyles,
            $df7cf2c434291638$var$stackTransitionStyles,
            /* We only want to apply transform on modals shifting to the back of the stack. */ stackIndex > 0 ? $df7cf2c434291638$var$stackTransformStyles : $df7cf2c434291638$var$stackIdleStyles,
            shouldScrollInViewport ? $df7cf2c434291638$var$viewportScrollStyles : $df7cf2c434291638$var$bodyScrollStyles
        ],
        "data-testid": testId && "".concat(testId, "--positioner")
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$df7cf2c434291638$export$2e2bcd8739ae039 = $df7cf2c434291638$var$Positioner;


var $f73dacf51e76b762$var$dialogStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    display: 'flex',
    width: '100%',
    maxWidth: '100vw',
    height: '100%',
    minHeight: 0,
    maxHeight: '100vh',
    // Flex-grow set to 0 to prevent this element from filling its parent flexbox container
    flex: '0 1 auto',
    flexDirection: 'column',
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $881e75c45a88d9b7$export$29a4f05edc054374), ")"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: "var(--ds-text, ".concat((0, $881e75c45a88d9b7$export$fbda843f0a27fe96), ")")
}, (0, $e7c942592165b6c5$export$9d7b58831ae93caa), "var(--ds-surface-overlay, ".concat((0, $881e75c45a88d9b7$export$29a4f05edc054374), ")")), "pointerEvents", 'auto'), (0, $21b7e6b4b91231d5$export$987d49ffe1b0900f).above.xs, {
    width: 'var(--modal-dialog-width)',
    maxWidth: 'inherit',
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 0 0 1px ".concat((0, $881e75c45a88d9b7$export$920c0d5c49070351), ", 0 2px 1px ").concat((0, $881e75c45a88d9b7$export$920c0d5c49070351), ", 0 0 20px -6px ").concat((0, $881e75c45a88d9b7$export$d2d3bedfb276cac0)), ")"),
    marginInlineEnd: 'inherit',
    marginInlineStart: 'inherit'
}), '& > form:only-child', {
    display: 'inherit',
    maxHeight: 'inherit',
    flexDirection: 'inherit'
}));
var $f73dacf51e76b762$var$viewportScrollStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    /**
   * This ensures that the element fills the viewport on mobile
   * while also allowing it to overflow if its height is larger than
   * the viewport.
   */ minHeight: '100vh',
    maxHeight: 'none'
}, (0, $21b7e6b4b91231d5$export$987d49ffe1b0900f).above.xs, {
    minHeight: 'var(--modal-dialog-height)'
}));
var $f73dacf51e76b762$var$bodyScrollStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $21b7e6b4b91231d5$export$987d49ffe1b0900f).above.xs, {
    height: 'var(--modal-dialog-height)',
    maxHeight: 'inherit'
}));
var $f73dacf51e76b762$var$ModalDialog = function ModalDialog(props) {
    var _props$width = props.width, width = _props$width === void 0 ? 'medium' : _props$width, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, shouldCloseOnEscapePress = props.shouldCloseOnEscapePress, autoFocus = props.autoFocus, stackIndex = props.stackIndex, onClose = props.onClose, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, height = props.height, children = props.children, label = props.label, testId = props.testId;
    var id = (0, $e90663b74b3343bb$export$f680877a34711e37)();
    var titleId = "modal-dialog-title-".concat(id);
    (0, $5FkrB.useEffect)(function() {
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $b4c9117eda03c176$export$1be1fc439b849fdf)((0, $83969708bab70d34$export$ec28e97c7d8b1b35)(), (0, $6d69ce072be2e03a$export$9c0606fcefb5d1e2)(), (0, $5f80798a6c74042d$export$27d79116d3a4e7d5)());
    }, []);
    (0, $12ca9acfdfc10757$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(autoFocus) === 'object' ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(autoFocus) === 'object');
    var _useOnMotionFinish = (0, $b7efde3c54a58959$export$2e2bcd8739ae039)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    }), _useOnMotionFinish2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useOnMotionFinish, 2), motionRef = _useOnMotionFinish2[0], onMotionFinish = _useOnMotionFinish2[1];
    var modalDialogContext = (0, $5FkrB.useMemo)(function() {
        return {
            testId: testId,
            titleId: titleId,
            onClose: onClose
        };
    }, [
        testId,
        titleId,
        onClose
    ]);
    (0, $50ca8d9fc44121b9$export$4a4bf067ea9e7886)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    var _useLayering = (0, $50ca8d9fc44121b9$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    return (0, $74Zh5.jsx)((0, $df7cf2c434291638$export$2e2bcd8739ae039), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: testId
    }, (0, $74Zh5.jsx)((0, $7168667b2edf2dff$export$ab57792b9b6974a6).Provider, {
        value: modalDialogContext
    }, (0, $74Zh5.jsx)((0, $7168667b2edf2dff$export$dece24112a937f92).Provider, {
        value: shouldScrollInViewport
    }, (0, $74Zh5.jsx)((0, $1fb4e133cab6b0bd$export$2e2bcd8739ae039), {
        entranceDirection: "bottom",
        onFinish: onMotionFinish
    }, function(bottomFadeInProps) {
        return (0, $74Zh5.jsx)((0, $b26b7c64ea7dc6ea$export$2e2bcd8739ae039), null, (0, $74Zh5.jsx)("section", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, bottomFadeInProps, {
            "aria-label": label,
            ref: (0, $515a728f55aede1c$export$2e2bcd8739ae039)([
                bottomFadeInProps.ref,
                motionRef
            ]),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-width': (0, $3e53a340f86f7a9c$export$a3da89b899389ed8)(width),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-height': (0, $3e53a340f86f7a9c$export$ceba93bf0bdd16f2)(height)
            },
            css: [
                $f73dacf51e76b762$var$dialogStyles,
                shouldScrollInViewport ? $f73dacf51e76b762$var$viewportScrollStyles : $f73dacf51e76b762$var$bodyScrollStyles
            ],
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": testId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true,
            "data-ds--level": currentLevel
        }), children));
    }))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f73dacf51e76b762$export$2e2bcd8739ae039 = $f73dacf51e76b762$var$ModalDialog;



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $864965a5b9e9a355$var$uniqueReferencedValue = {};
function $864965a5b9e9a355$export$2e2bcd8739ae039(initializer) {
    var ref = (0, $5FkrB.useRef)($864965a5b9e9a355$var$uniqueReferencedValue);
    if (ref.current === $864965a5b9e9a355$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}


function $877d61a231a715c1$export$2e2bcd8739ae039(callback) {
    var ref = (0, $864965a5b9e9a355$export$2e2bcd8739ae039)(function() {
        return callback;
    });
    return ref.current;
}



var $5FkrB = parcelRequire("5FkrB");
function $e2caa9fe43b5c14b$export$2e2bcd8739ae039(value) {
    var ref = (0, $5FkrB.useRef)();
    (0, $5FkrB.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $a8ffe3327e3b33eb$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $5FkrB.useState)(initialState), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueRef = (0, $5FkrB.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}



/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ var $d60d7d08f9026a79$var$modalStackRegister = [];
function $d60d7d08f9026a79$export$2e2bcd8739ae039(_ref) {
    var onStackChange = _ref.onStackChange;
    var _useExitingPersistenc = (0, $1fa46e7402eb7267$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting;
    var _useStateRef = (0, $a8ffe3327e3b33eb$export$2e2bcd8739ae039)(0), _useStateRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useStateRef, 2), stackIndexRef = _useStateRef2[0], setStackIndex = _useStateRef2[1];
    var currentStackIndex = stackIndexRef.current;
    var previousStackIndex = (0, $e2caa9fe43b5c14b$export$2e2bcd8739ae039)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    var updateStack = (0, $877d61a231a715c1$export$2e2bcd8739ae039)(function() {
        var newStackIndex = $d60d7d08f9026a79$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $5FkrB.useEffect)(function() {
        var currentStackIndex = $d60d7d08f9026a79$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $d60d7d08f9026a79$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $d60d7d08f9026a79$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $d60d7d08f9026a79$var$modalStackRegister.forEach(function(cb) {
            return cb();
        });
    }, [
        updateStack,
        isExiting
    ]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            var currentStackIndex = $d60d7d08f9026a79$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $d60d7d08f9026a79$var$modalStackRegister.splice(currentStackIndex, 1);
                $d60d7d08f9026a79$var$modalStackRegister.forEach(function(cb) {
                    return cb();
                });
            }
        };
    }, [
        updateStack
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $54fd0c2a27623d22$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $54fd0c2a27623d22$export$2e2bcd8739ae039() {
    var _useState = (0, $5FkrB.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), scrollTopOffset = _useState2[0], setScrollTopOffset = _useState2[1];
    (0, $5FkrB.useLayoutEffect)(function() {
        setScrollTopOffset($54fd0c2a27623d22$var$getScrollDistance());
    }, []);
    var onWindowScroll = (0, $5FkrB.useCallback)(function() {
        if ($54fd0c2a27623d22$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}


var $73c4314b1cf0d4b0$var$fillScreenStyles = (0, $74Zh5.css)({
    width: '100vw',
    height: '100vh',
    position: 'fixed',
    insetBlockStart: "var(--ds-space-0, 0)",
    insetInlineStart: "var(--ds-space-0, 0)",
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch'
});
var $73c4314b1cf0d4b0$var$allowlistElements = function allowlistElements(element, callback) {
    var isAuiDialogAllowlisted = (0, $64b3f566deaa9c38$export$b40ec24ac8275656)('platform_dst_allowlist-aui-dialog-for-ak-modal');
    // Allow focus to reach elements outside the modal:
    // if AUI dialog is allowListed and visible
    if (isAuiDialogAllowlisted && !!document.querySelector('.aui-blanket:not([hidden])')) return false;
    // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $73c4314b1cf0d4b0$var$ModalWrapper = function ModalWrapper(props) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, focusLockAllowlist = props.focusLockAllowlist, _props$shouldCloseOnE = props.shouldCloseOnEscapePress, shouldCloseOnEscapePress = _props$shouldCloseOnE === void 0 ? true : _props$shouldCloseOnE, _props$shouldCloseOnO = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _props$shouldCloseOnO === void 0 ? true : _props$shouldCloseOnO, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, _props$shouldReturnFo = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo === void 0 ? true : _props$shouldReturnFo, stackIndexOverride = props.stackIndex, _props$onClose = props.onClose, onClose = _props$onClose === void 0 ? (0, $da390e863547ad56$export$2e2bcd8739ae039) : _props$onClose, _props$onStackChange = props.onStackChange, onStackChange = _props$onStackChange === void 0 ? (0, $da390e863547ad56$export$2e2bcd8739ae039) : _props$onStackChange, isBlanketHidden = props.isBlanketHidden, children = props.children, height = props.height, width = props.width, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, label = props.label, testId = props.testId;
    var calculatedStackIndex = (0, $d60d7d08f9026a79$export$2e2bcd8739ae039)({
        onStackChange: onStackChange
    });
    var stackIndex = stackIndexOverride || calculatedStackIndex;
    var isForeground = stackIndex === 0;
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    var autoFocusLock = typeof autoFocus === 'boolean' ? autoFocus : false;
    var onCloseHandler = (0, $e2c415d6ac5c0326$export$a4687b0234b40e28)({
        fn: onClose,
        action: 'closed',
        componentName: 'modalDialog',
        packageName: "@atlaskit/modal-dialog",
        packageVersion: "13.1.1"
    });
    var onBlanketClicked = (0, $5FkrB.useCallback)(function(e) {
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    var allowListCallback = (0, $5FkrB.useCallback)(function(element) {
        return $73c4314b1cf0d4b0$var$allowlistElements(element, focusLockAllowlist);
    }, [
        focusLockAllowlist
    ]);
    (0, $54fd0c2a27623d22$export$2e2bcd8739ae039)();
    var modalDialogWithBlanket = (0, $74Zh5.jsx)((0, $b6b00686e959fb35$export$2e2bcd8739ae039), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && "".concat(testId, "--blanket")
    }, (0, $74Zh5.jsx)((0, $f73dacf51e76b762$export$2e2bcd8739ae039), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete
    }, children));
    var returnFocus = true;
    var onDeactivation;
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = function onDeactivation() {
        window.setTimeout(function() {
            var _shouldReturnFocus$cu;
            (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return (0, $74Zh5.jsx)((0, $43f1965ab31d9c6c$export$7c885f891c940977), {
        isDisabled: false
    }, (0, $74Zh5.jsx)((0, $062c34d20b8b2f54$export$2e2bcd8739ae039), {
        zIndex: (0, $4e4d6f9c8d79362c$export$7be255094ccdc533).modal()
    }, (0, $74Zh5.jsx)((0, $1fb4e133cab6b0bd$export$2e2bcd8739ae039), null, function(fadeInProps) {
        return (0, $74Zh5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, fadeInProps, {
            css: $73c4314b1cf0d4b0$var$fillScreenStyles,
            "aria-hidden": !isForeground
        }), (0, $74Zh5.jsx)((0, $69J3E.default), {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3FlkA))), null), shouldScrollInViewport ? (0, $74Zh5.jsx)((0, $3FlkA.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket));
    })));
};
var $73c4314b1cf0d4b0$export$2e2bcd8739ae039 = $73c4314b1cf0d4b0$var$ModalWrapper;

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $3FlkA = parcelRequire("3FlkA");

var $5FkrB = parcelRequire("5FkrB");

var $bce5b57c6ca393c3$export$33ffd74ebf07f060 = function useModal() {
    var modalContext = (0, $5FkrB.useContext)((0, $7168667b2edf2dff$export$ab57792b9b6974a6));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};



var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $7QpUe = parcelRequire("7QpUe");

var $45Zis = parcelRequire("45Zis");






var $cd3675e8dd132216$var$keylineColor = "var(--ds-border, ".concat((0, $881e75c45a88d9b7$export$3e51e8f1440314ba), ")");
var $cd3675e8dd132216$var$baseStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    display: 'inherit',
    margin: "var(--ds-space-0, 0px)",
    flex: 'inherit',
    flexDirection: 'inherit',
    flexGrow: 1,
    overflowX: 'hidden',
    overflowY: 'auto'
}, (0, $21b7e6b4b91231d5$export$987d49ffe1b0900f).above.xs, {
    height: 'unset',
    overflowY: 'auto'
}));
var $cd3675e8dd132216$var$keylineHeight = 2;
var $cd3675e8dd132216$var$topKeylineStyles = (0, $74Zh5.css)({
    borderBlockStart: "var(--ds-border-width-outline, 2px)".concat(" solid ", $cd3675e8dd132216$var$keylineColor)
});
var $cd3675e8dd132216$var$bottomKeylineStyles = (0, $74Zh5.css)({
    borderBlockEnd: "var(--ds-border-width-outline, 2px)".concat(" solid ", $cd3675e8dd132216$var$keylineColor)
});
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ var $cd3675e8dd132216$var$ScrollContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, children = _ref.children;
    var scrollableRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), showTopKeyline = _useState2[0], setTopKeyline = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), showBottomKeyline = _useState4[0], setBottomKeyline = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), showContentFocus = _useState6[0], setContentFocus = _useState6[1];
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $5FkrB.useEffect)(function() {
        var schedule = (0, $45Zis.default)(function() {
            var target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    var setLazyKeylines = (0, $877d61a231a715c1$export$2e2bcd8739ae039)((0, $45Zis.default)(function() {
        var target = scrollableRef.current;
        if (target) {
            var scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $cd3675e8dd132216$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $cd3675e8dd132216$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $5FkrB.useEffect)(function() {
        var target = scrollableRef.current;
        setLazyKeylines();
        var unbindWindowEvent = (0, $7QpUe.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        var unbindTargetEvent = target ? (0, $7QpUe.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $da390e863547ad56$export$2e2bcd8739ae039);
        return function() {
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return (0, $74Zh5.jsx)((0, $b26b7c64ea7dc6ea$export$2e2bcd8739ae039), {
        isInset: true
    }, (0, $74Zh5.jsx)("div", {
        // tabindex is allowed here so that keyboard users can scroll content
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        "data-testid": testId && "".concat(testId, "--scrollable"),
        ref: (0, $515a728f55aede1c$export$2e2bcd8739ae039)([
            ref,
            scrollableRef
        ]),
        css: [
            $cd3675e8dd132216$var$baseStyles,
            showTopKeyline && $cd3675e8dd132216$var$topKeylineStyles,
            showBottomKeyline && $cd3675e8dd132216$var$bottomKeylineStyles
        ]
    }, children));
});
$cd3675e8dd132216$var$ScrollContainer.displayName = 'ScrollContainer';
var $cd3675e8dd132216$export$2e2bcd8739ae039 = $cd3675e8dd132216$var$ScrollContainer;



var $5FkrB = parcelRequire("5FkrB");

function $6b0ee122ced171d4$export$2e2bcd8739ae039() {
    var shouldScrollInViewport = (0, $5FkrB.useContext)((0, $7168667b2edf2dff$export$dece24112a937f92));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}


var $883c6fe3d36b669f$var$bodyStyles = (0, $74Zh5.css)({
    /* This ensures the body fills the whole space between header and footer. */ flex: '1 1 auto'
});
/**
 * Adding the padding here avoids cropping the keyline on its sides.
 * The combined vertical spacing is maintained by subtracting the
 * keyline height from header and footer using negative margins.
 */ var $883c6fe3d36b669f$var$bodyScrollStyles = (0, $74Zh5.css)({
    paddingBlock: "var(--ds-border-width-outline, 2px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * Keylines will not be shown if scrolling in viewport so we do
 * not account for them in this case.
 */ var $883c6fe3d36b669f$var$viewportScrollStyles = (0, $74Zh5.css)({
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $883c6fe3d36b669f$var$ModalBody = function ModalBody(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $bce5b57c6ca393c3$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var shouldScrollInViewport = (0, $6b0ee122ced171d4$export$2e2bcd8739ae039)();
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--body");
    return shouldScrollInViewport ? (0, $74Zh5.jsx)("div", {
        css: [
            $883c6fe3d36b669f$var$bodyStyles,
            $883c6fe3d36b669f$var$viewportScrollStyles
        ],
        "data-testid": testId
    }, children) : (0, $74Zh5.jsx)((0, $3FlkA.TouchScrollable), null, (0, $74Zh5.jsx)((0, $cd3675e8dd132216$export$2e2bcd8739ae039), {
        testId: userDefinedTestId || modalTestId
    }, (0, $74Zh5.jsx)("div", {
        css: [
            $883c6fe3d36b669f$var$bodyStyles,
            $883c6fe3d36b669f$var$bodyScrollStyles
        ],
        "data-testid": testId
    }, children)));
};
var $883c6fe3d36b669f$export$2e2bcd8739ae039 = $883c6fe3d36b669f$var$ModalBody;

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");

var $812d3a996ab3db86$var$footerStyles = (0, $74Zh5.css)({
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: "var(--ds-space-100, 8px)",
    marginBlockStart: "calc(-1 * ".concat("var(--ds-border-width-outline, 2px)", ")"),
    paddingBlockEnd: "var(--ds-space-300, 24px)",
    paddingBlockStart: "var(--ds-space-200, 16px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $812d3a996ab3db86$var$ModalFooter = function ModalFooter(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $bce5b57c6ca393c3$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--footer");
    return (0, $74Zh5.jsx)("div", {
        css: $812d3a996ab3db86$var$footerStyles,
        "data-testid": testId
    }, children);
};
var $812d3a996ab3db86$export$2e2bcd8739ae039 = $812d3a996ab3db86$var$ModalFooter;

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $e63db9e78b9f7f9d$var$headerStyles = (0, $74Zh5.css)({
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBlockEnd: "calc(-1 * ".concat("var(--ds-border-width-outline, 2px)", ")"),
    paddingBlockEnd: "var(--ds-space-200, 16px)",
    paddingBlockStart: "var(--ds-space-300, 24px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $e63db9e78b9f7f9d$var$ModalHeader = function ModalHeader(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $bce5b57c6ca393c3$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--header");
    return (0, $74Zh5.jsx)("div", {
        css: $e63db9e78b9f7f9d$var$headerStyles,
        "data-testid": testId
    }, children);
};
var $e63db9e78b9f7f9d$export$2e2bcd8739ae039 = $e63db9e78b9f7f9d$var$ModalHeader;


var $5FkrB = parcelRequire("5FkrB");

/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $58963c306889e449$var$ModalTransition = function ModalTransition(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1fa46e7402eb7267$export$2e2bcd8739ae039), {
        appear: true
    }, props.children);
};
var $58963c306889e449$export$2e2bcd8739ae039 = $58963c306889e449$var$ModalTransition;



var $7KfP5 = parcelRequire("7KfP5");

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $5d12b81cf835d0fa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5d12b81cf835d0fa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5d12b81cf835d0fa$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5d12b81cf835d0fa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5d12b81cf835d0fa$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $5d12b81cf835d0fa$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $5d12b81cf835d0fa$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $5d12b81cf835d0fa$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $5d12b81cf835d0fa$var$_objectSpread($5d12b81cf835d0fa$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $5a5f42fc4617c35b$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $5a5f42fc4617c35b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $5a5f42fc4617c35b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5a5f42fc4617c35b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $5a5f42fc4617c35b$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $5a5f42fc4617c35b$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $5a5f42fc4617c35b$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $5a5f42fc4617c35b$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $5a5f42fc4617c35b$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $5a5f42fc4617c35b$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $5d12b81cf835d0fa$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $726ef29a554b591d$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $6d9e5de0c2a6279b$export$5bf35293e545f20c() {
    var analyticsContext = (0, $726ef29a554b591d$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $5a5f42fc4617c35b$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $73f6b1d7f567637f$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $8fb7a896bc43fd0a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8fb7a896bc43fd0a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8fb7a896bc43fd0a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8fb7a896bc43fd0a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8fb7a896bc43fd0a$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $6d9e5de0c2a6279b$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $73f6b1d7f567637f$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $73f6b1d7f567637f$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $8fb7a896bc43fd0a$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $3a341012e037de4f$export$2e2bcd8739ae039() {}



var $5FkrB = parcelRequire("5FkrB");
var $6aca23134cc0dc0c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);



var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");
var $dfb11b85b532f292$export$4ef52930e33717cd = 'data-theme';
var $dfb11b85b532f292$export$a00eac3f8684bcd0 = 'data-color-mode';
var $dfb11b85b532f292$export$2112803007239c61 = 'data-contrast-mode';
var $dfb11b85b532f292$export$352e418ed5b6193a = 'data-custom-theme';
var $dfb11b85b532f292$export$2faeed762aac6741 = 'light';
var $dfb11b85b532f292$export$6f0c6fb8c80fcc92 = 'ds';
var $dfb11b85b532f292$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $dfb11b85b532f292$export$dddac1532e822863 = "--".concat($dfb11b85b532f292$export$6f0c6fb8c80fcc92, "-token-not-found");
var $dfb11b85b532f292$export$9d7b58831ae93caa = "--".concat($dfb11b85b532f292$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $1d749ea5cf4f6b0d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1d749ea5cf4f6b0d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1d749ea5cf4f6b0d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1d749ea5cf4f6b0d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $1d749ea5cf4f6b0d$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $1d749ea5cf4f6b0d$export$632685d741f3dbbf = $1d749ea5cf4f6b0d$var$_objectSpread($1d749ea5cf4f6b0d$var$_objectSpread({}, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4), $1d749ea5cf4f6b0d$export$d2dc61f58390201c);
var $1d749ea5cf4f6b0d$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $1d749ea5cf4f6b0d$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $1d749ea5cf4f6b0d$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $1d749ea5cf4f6b0d$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $1d749ea5cf4f6b0d$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $1d749ea5cf4f6b0d$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $1d749ea5cf4f6b0d$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $1d749ea5cf4f6b0d$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $1d749ea5cf4f6b0d$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $1d749ea5cf4f6b0d$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $1d749ea5cf4f6b0d$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $1d749ea5cf4f6b0d$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $1d749ea5cf4f6b0d$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $1d749ea5cf4f6b0d$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $1d749ea5cf4f6b0d$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $1d749ea5cf4f6b0d$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $1d749ea5cf4f6b0d$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $1d749ea5cf4f6b0d$export$e615f061ca585a6c = $1d749ea5cf4f6b0d$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $1d749ea5cf4f6b0d$export$ca0f9c2de39ffed7(spacingProperty, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $1d749ea5cf4f6b0d$export$bf46c3f9eeafc71f = $1d749ea5cf4f6b0d$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $1d749ea5cf4f6b0d$export$ca0f9c2de39ffed7(spacingProperty, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $1d749ea5cf4f6b0d$export$e7af83bafe7f9e63 = $1d749ea5cf4f6b0d$export$ca0f9c2de39ffed7('backgroundColor', $1d749ea5cf4f6b0d$export$d1d79bf68ac056bd);
var $1d749ea5cf4f6b0d$export$3a1bcba60b23d7f0 = $1d749ea5cf4f6b0d$export$ca0f9c2de39ffed7('color', $1d749ea5cf4f6b0d$export$8473307aa00d6ea1);
var $1d749ea5cf4f6b0d$export$45f3f4fe16f9f7d5 = $1d749ea5cf4f6b0d$export$ca0f9c2de39ffed7('fontWeight', $1d749ea5cf4f6b0d$export$303e322c6b1ed114);
var $1d749ea5cf4f6b0d$export$68cc305da27dbaa4 = $1d749ea5cf4f6b0d$export$ca0f9c2de39ffed7('fontFamily', $1d749ea5cf4f6b0d$export$3c7e9587132614b4);
var $1d749ea5cf4f6b0d$export$128f10c238242f83 = $1d749ea5cf4f6b0d$export$ca0f9c2de39ffed7('font', $1d749ea5cf4f6b0d$export$6ffa317d5e70375);
var $1d749ea5cf4f6b0d$export$219d364c0da35ae4 = $1d749ea5cf4f6b0d$export$ca0f9c2de39ffed7('font', $1d749ea5cf4f6b0d$export$236bfe3a33ef1292);
var $1d749ea5cf4f6b0d$export$38845ca010b93505 = $1d749ea5cf4f6b0d$export$ca0f9c2de39ffed7('fontWeight', $1d749ea5cf4f6b0d$export$855cfd311192d666);
var $1d749ea5cf4f6b0d$export$ff257d957d48c421 = $1d749ea5cf4f6b0d$export$ca0f9c2de39ffed7((0, $dfb11b85b532f292$export$9d7b58831ae93caa), $1d749ea5cf4f6b0d$export$41a358c9c2356760);
var $1d749ea5cf4f6b0d$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $1d749ea5cf4f6b0d$export$41a358c9c2356760[color] !== undefined;
};



var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $74Zh5 = parcelRequire("74Zh5");


var $3ZMUU = parcelRequire("3ZMUU");
function $a8477e78427cc4b7$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $a8477e78427cc4b7$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $a8477e78427cc4b7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $a8477e78427cc4b7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $a8477e78427cc4b7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $a8477e78427cc4b7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $a8477e78427cc4b7$export$9a199fbafee0014e = {
    backgroundColor: (0, $1d749ea5cf4f6b0d$export$d1d79bf68ac056bd),
    blockSize: (0, $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8),
    borderBottomColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $1d749ea5cf4f6b0d$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $1d749ea5cf4f6b0d$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8),
    borderColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $1d749ea5cf4f6b0d$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $1d749ea5cf4f6b0d$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8),
    borderLeftColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8),
    borderRadius: (0, $1d749ea5cf4f6b0d$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $1d749ea5cf4f6b0d$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $1d749ea5cf4f6b0d$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $1d749ea5cf4f6b0d$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $1d749ea5cf4f6b0d$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8),
    borderWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8),
    bottom: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    boxShadow: (0, $1d749ea5cf4f6b0d$export$7aff6e7ba39bb774),
    color: (0, $1d749ea5cf4f6b0d$export$8473307aa00d6ea1),
    columnGap: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    font: (0, $1d749ea5cf4f6b0d$export$6ffa317d5e70375),
    fontFamily: (0, $1d749ea5cf4f6b0d$export$3c7e9587132614b4),
    fontWeight: (0, $1d749ea5cf4f6b0d$export$303e322c6b1ed114),
    gap: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    height: (0, $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f),
    inlineSize: (0, $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f),
    inset: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    insetBlock: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    insetBlockEnd: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    insetBlockStart: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    insetInline: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    insetInlineEnd: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    insetInlineStart: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    left: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    margin: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    marginBlock: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    marginBlockEnd: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    marginBlockStart: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    marginBottom: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    marginInline: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    marginInlineEnd: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    marginInlineStart: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    marginLeft: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    marginRight: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    marginTop: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    maxBlockSize: (0, $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f),
    maxHeight: (0, $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f),
    maxWidth: (0, $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f),
    minBlockSize: (0, $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f),
    minHeight: (0, $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f),
    minInlineSize: (0, $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f),
    minWidth: (0, $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f),
    opacity: (0, $1d749ea5cf4f6b0d$export$daf94a976c798b4f),
    outlineColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac),
    outlineOffset: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    outlineWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8),
    padding: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    paddingBlock: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    paddingBottom: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    paddingInline: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    paddingLeft: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    paddingRight: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    paddingTop: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    right: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    rowGap: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    top: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    width: (0, $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f),
    zIndex: (0, $1d749ea5cf4f6b0d$export$b5f31a7e431d2eab)
};
var $a8477e78427cc4b7$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $a8477e78427cc4b7$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU.env) === 'object' && false;
};
var $a8477e78427cc4b7$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $a8477e78427cc4b7$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $a8477e78427cc4b7$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($a8477e78427cc4b7$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && $a8477e78427cc4b7$var$safeSelectors.test(key)) {
            styleObj[key] = $a8477e78427cc4b7$var$_transformStyles(value);
            return;
        }
        if ($a8477e78427cc4b7$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($a8477e78427cc4b7$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $a8477e78427cc4b7$export$9a199fbafee0014e)) return;
        var tokenValue = $a8477e78427cc4b7$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $a8477e78427cc4b7$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $a8477e78427cc4b7$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $a8477e78427cc4b7$var$uniqueSymbol, (0, $74Zh5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $a8477e78427cc4b7$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $a8477e78427cc4b7$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $a8477e78427cc4b7$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$a8477e78427cc4b7$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $a8477e78427cc4b7$export$f6c783d06584602c(style) {
    return $a8477e78427cc4b7$var$baseXcss(style);
}


var $d469e5ab074fc4c0$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $d469e5ab074fc4c0$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $d469e5ab074fc4c0$var$focusRingStyles = (0, $74Zh5.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8)['border.width.outline']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $d469e5ab074fc4c0$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
var $d469e5ab074fc4c0$var$enabledStyles = (0, $74Zh5.css)({
    cursor: 'pointer'
});
var $d469e5ab074fc4c0$var$disabledStyles = (0, $74Zh5.css)({
    cursor: 'not-allowed'
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $d469e5ab074fc4c0$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $3a341012e037de4f$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $d469e5ab074fc4c0$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $6aca23134cc0dc0c$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $8fb7a896bc43fd0a$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "13.6.0",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $d469e5ab074fc4c0$var$_excluded2);
    var resolvedStyles = (0, $a8477e78427cc4b7$export$a9c84988c8f81f2d)(xcss);
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
    (0, $74Zh5.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $d469e5ab074fc4c0$var$baseStyles,
            $d469e5ab074fc4c0$var$focusRingStyles,
            isDisabled ? $d469e5ab074fc4c0$var$disabledStyles : $d469e5ab074fc4c0$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $1d749ea5cf4f6b0d$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children));
});
var $d469e5ab074fc4c0$export$2e2bcd8739ae039 = $d469e5ab074fc4c0$var$Pressable;



var $5FkrB = parcelRequire("5FkrB");

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $5FkrB = parcelRequire("5FkrB");
var $108885aefd7aac23$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $108885aefd7aac23$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($108885aefd7aac23$export$1ca2a26fecb070ae);
};
$108885aefd7aac23$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';




var $d007f17589e0f9b9$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $d007f17589e0f9b9$var$_excluded2 = [
    "className"
];
var $d007f17589e0f9b9$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $d007f17589e0f9b9$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $d007f17589e0f9b9$var$_excluded2);
    var resolvedStyles = (0, $a8477e78427cc4b7$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $d007f17589e0f9b9$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $1d749ea5cf4f6b0d$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $1d749ea5cf4f6b0d$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $1d749ea5cf4f6b0d$export$ff257d957d48c421)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $74Zh5.jsx)((0, $108885aefd7aac23$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $d007f17589e0f9b9$export$2e2bcd8739ae039 = $d007f17589e0f9b9$export$e71c4d32a2263218;
var $d007f17589e0f9b9$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});


var $301b23ec1b0d3f05$var$textStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    // content can grow and shrink
    flexGrow: 1,
    flexShrink: 1,
    // ellipsis for overflow text
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
var $301b23ec1b0d3f05$var$iconStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    display: 'flex',
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'center',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    userSelect: 'none'
});
var $301b23ec1b0d3f05$var$commonStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    transition: 'opacity 0.3s'
});
var $301b23ec1b0d3f05$var$fadeStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    opacity: 0
});
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $301b23ec1b0d3f05$var$beforeIconStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    // @ts-ignore
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    // @ts-ignore
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)"
});
var $301b23ec1b0d3f05$var$afterIconStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    // @ts-ignore
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    // @ts-ignore
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)"
});
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $301b23ec1b0d3f05$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d007f17589e0f9b9$export$2e2bcd8739ae039), {
        as: "span",
        xcss: [
            $301b23ec1b0d3f05$var$commonStyles
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(type === 'text' ? [
            $301b23ec1b0d3f05$var$textStyles
        ] : [
            $301b23ec1b0d3f05$var$iconStyles
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(isLoading ? [
            $301b23ec1b0d3f05$var$fadeStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(position === 'before' ? [
            $301b23ec1b0d3f05$var$beforeIconStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(position === 'after' ? [
            $301b23ec1b0d3f05$var$afterIconStyles
        ] : []))
    }, children);
};
var $301b23ec1b0d3f05$export$2e2bcd8739ae039 = $301b23ec1b0d3f05$var$Content;



var $5FkrB = parcelRequire("5FkrB");
function $a2bbd318f52424a1$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $a2bbd318f52424a1$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, $a2bbd318f52424a1$var$isIconRenderProp(Icon) ? Icon({
        label: '',
        color: 'currentColor'
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, {
        label: "",
        color: 'currentColor'
    }));
};
var $a2bbd318f52424a1$export$2e2bcd8739ae039 = $a2bbd318f52424a1$var$IconRenderer;



var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $0d2a37110e22a1c9$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}



var $5FkrB = parcelRequire("5FkrB");
function $65ad6b2d82b5101d$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $5FkrB.useRef)(true);
    (0, $5FkrB.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}



var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $9dOvm = parcelRequire("9dOvm");
var $cbe66bde7ac5f637$var$_process, $cbe66bde7ac5f637$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $cbe66bde7ac5f637$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($cbe66bde7ac5f637$var$_process = globalThis.process) === null || $cbe66bde7ac5f637$var$_process === void 0 || ($cbe66bde7ac5f637$var$_process = $cbe66bde7ac5f637$var$_process.env) === null || $cbe66bde7ac5f637$var$_process === void 0 ? void 0 : $cbe66bde7ac5f637$var$_process.JEST_WORKER_ID) !== undefined;
var $cbe66bde7ac5f637$var$DEBUG_MODE = !$cbe66bde7ac5f637$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($cbe66bde7ac5f637$var$_process2 = globalThis.process) === null || $cbe66bde7ac5f637$var$_process2 === void 0 || ($cbe66bde7ac5f637$var$_process2 = $cbe66bde7ac5f637$var$_process2.env) === null || $cbe66bde7ac5f637$var$_process2 === void 0 ? void 0 : $cbe66bde7ac5f637$var$_process2.NODE_ENV) !== 'production';
var $cbe66bde7ac5f637$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$cbe66bde7ac5f637$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $2c5062b6952f3b7b$var$pkgName = '@atlaskit/platform-feature-flags';
var $2c5062b6952f3b7b$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $2c5062b6952f3b7b$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $2c5062b6952f3b7b$var$ENV_ENABLE_PLATFORM_FF = $2c5062b6952f3b7b$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $2c5062b6952f3b7b$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $2c5062b6952f3b7b$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $2c5062b6952f3b7b$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $2c5062b6952f3b7b$var$ENV_ENABLE_PLATFORM_FF || $2c5062b6952f3b7b$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $2c5062b6952f3b7b$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $2c5062b6952f3b7b$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$2c5062b6952f3b7b$var$globalVar[$2c5062b6952f3b7b$export$7e41b1b2bdee3f98] = $2c5062b6952f3b7b$var$globalVar[$2c5062b6952f3b7b$export$7e41b1b2bdee3f98] || $2c5062b6952f3b7b$var$DEFAULT_PFF_GLOBAL;
function $2c5062b6952f3b7b$export$f2b591175b3e424c(resolver) {
    $2c5062b6952f3b7b$var$globalVar[$2c5062b6952f3b7b$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $2c5062b6952f3b7b$export$6333b6aff9fc6275(flagKey) {
    if ($2c5062b6952f3b7b$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $cbe66bde7ac5f637$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $2c5062b6952f3b7b$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $2c5062b6952f3b7b$var$globalVar[$2c5062b6952f3b7b$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $2c5062b6952f3b7b$var$globalVar[$2c5062b6952f3b7b$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $9dOvm.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $2c5062b6952f3b7b$var$globalVar[$2c5062b6952f3b7b$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $c52fc99465dcc625$export$ba05d765b8392e5e(flagResolver) {
    (0, $2c5062b6952f3b7b$export$f2b591175b3e424c)(flagResolver);
}
function $c52fc99465dcc625$export$470e5c2be1411c89(name) {
    return (0, $2c5062b6952f3b7b$export$6333b6aff9fc6275)(name);
}
function $c52fc99465dcc625$export$b40ec24ac8275656(name) {
    return (0, $2c5062b6952f3b7b$export$6333b6aff9fc6275)(name);
}


var $24526c38f36cc756$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $24526c38f36cc756$var$react18UseId = ($24526c38f36cc756$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $24526c38f36cc756$var$_React$useId !== void 0 ? $24526c38f36cc756$var$_React$useId : undefined;
function $24526c38f36cc756$export$f680877a34711e37() {
    if ($24526c38f36cc756$var$react18UseId && (0, $c52fc99465dcc625$export$b40ec24ac8275656)('platform.design-system-team.react-18-use-id_mn8q4')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $24526c38f36cc756$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $24526c38f36cc756$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($24526c38f36cc756$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $24526c38f36cc756$export$6ee17796e3d70de2() {
    if ($24526c38f36cc756$var$react18UseId && (0, $c52fc99465dcc625$export$b40ec24ac8275656)('platform.design-system-team.react-18-use-id_mn8q4')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $24526c38f36cc756$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $b5lkZ.useUIDSeed)();
}



var $dVGJk = parcelRequire("dVGJk");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $d879fc455f6e75a0$export$4b84fd0e2c617bd = '#FFEBE6';
var $d879fc455f6e75a0$export$b34b069eff244586 = '#FFBDAD';
var $d879fc455f6e75a0$export$be802dd0d8b57f35 = '#FF8F73';
var $d879fc455f6e75a0$export$60847d42f9da92a6 = '#FF7452';
var $d879fc455f6e75a0$export$4a7404f376229999 = '#FF5630';
var $d879fc455f6e75a0$export$2010d0fb4295b346 = '#DE350B';
var $d879fc455f6e75a0$export$2837b5a1a71d5c02 = '#BF2600';
var $d879fc455f6e75a0$export$8d9596b529bbb9cf = '#FFFAE6';
var $d879fc455f6e75a0$export$41060a744ab0b7ae = '#FFF0B3';
var $d879fc455f6e75a0$export$1cc05bbbf340e559 = '#FFE380';
var $d879fc455f6e75a0$export$5aae31392d72caaa = '#FFC400';
var $d879fc455f6e75a0$export$c6930421db9fa514 = '#FFAB00';
var $d879fc455f6e75a0$export$59619663aa6500fb = '#FF991F';
var $d879fc455f6e75a0$export$874739ea9e379ab6 = '#FF8B00';
var $d879fc455f6e75a0$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $d879fc455f6e75a0$export$69a3bf21b9686c2b = '#ABF5D1';
var $d879fc455f6e75a0$export$afbce1382ec95f73 = '#79F2C0';
var $d879fc455f6e75a0$export$747d86715d4175de = '#57D9A3';
var $d879fc455f6e75a0$export$940e1f69e873f202 = '#36B37E';
var $d879fc455f6e75a0$export$a49394138f7b8e85 = '#00875A';
var $d879fc455f6e75a0$export$6fa04827ac68a4fb = '#006644';
var $d879fc455f6e75a0$export$226de0355ed012f8 = '#DEEBFF';
var $d879fc455f6e75a0$export$8c13c2ee36917869 = '#B3D4FF';
var $d879fc455f6e75a0$export$ecfc1dff386a3e7a = '#4C9AFF';
var $d879fc455f6e75a0$export$215b7063051591f1 = '#2684FF';
var $d879fc455f6e75a0$export$e62e8919cca44969 = '#0065FF';
var $d879fc455f6e75a0$export$b3de0ae08da2ce64 = '#0052CC';
var $d879fc455f6e75a0$export$a6ee3d71bc067634 = '#0747A6';
var $d879fc455f6e75a0$export$67f15409e87642a1 = '#669DF1';
var $d879fc455f6e75a0$export$f0539dbc42dbb067 = '#8FB8F6';
var $d879fc455f6e75a0$export$363e4475840015bb = '#EAE6FF';
var $d879fc455f6e75a0$export$4b0a4417ed59760f = '#C0B6F2';
var $d879fc455f6e75a0$export$6011520a64d9a187 = '#998DD9';
var $d879fc455f6e75a0$export$a7175d4e9206bc80 = '#8777D9';
var $d879fc455f6e75a0$export$b48405b95304b5a1 = '#6554C0';
var $d879fc455f6e75a0$export$c71e4279dd54a18d = '#5243AA';
var $d879fc455f6e75a0$export$147899de772240ec = '#403294';
var $d879fc455f6e75a0$export$2cf711fe14c66f06 = '#E6FCFF';
var $d879fc455f6e75a0$export$7a8f4d33f6f9772c = '#B3F5FF';
var $d879fc455f6e75a0$export$776c9c497ef08533 = '#79E2F2';
var $d879fc455f6e75a0$export$69cb3ca10c1e330e = '#00C7E6';
var $d879fc455f6e75a0$export$9dc1ef0f3f48059b = '#00B8D9';
var $d879fc455f6e75a0$export$7c835c78b6fcdef8 = '#00A3BF';
var $d879fc455f6e75a0$export$6036577f95c3877e = '#008DA6';
var $d879fc455f6e75a0$export$29a4f05edc054374 = '#FFFFFF';
var $d879fc455f6e75a0$export$e655ef011c4aa1a2 = '#FAFBFC';
var $d879fc455f6e75a0$export$9fdfb749e33cdf97 = '#F4F5F7';
var $d879fc455f6e75a0$export$3e51e8f1440314ba = '#EBECF0';
var $d879fc455f6e75a0$export$1ce2d1575d444ceb = '#DFE1E6';
var $d879fc455f6e75a0$export$8754fc7e6d8b3000 = '#C1C7D0';
var $d879fc455f6e75a0$export$c2e91cbeada39b8b = '#B3BAC5';
var $d879fc455f6e75a0$export$5f71e19f3a7ad9de = '#A5ADBA';
var $d879fc455f6e75a0$export$eaa8c8a70ac22806 = '#97A0AF';
var $d879fc455f6e75a0$export$7c87d337fb91a97d = '#8993A4';
var $d879fc455f6e75a0$export$d6447c357493214f = '#7A869A';
var $d879fc455f6e75a0$export$f563ee71e9ee74cd = '#6B778C';
var $d879fc455f6e75a0$export$e2ef2124cf4024b1 = '#5E6C84';
var $d879fc455f6e75a0$export$eece5f492e429f08 = '#505F79';
var $d879fc455f6e75a0$export$c39c0fe0f26207ae = '#42526E';
var $d879fc455f6e75a0$export$7090862dc3038a9f = '#344563';
var $d879fc455f6e75a0$export$ad0bacf983b7ddaa = '#253858';
var $d879fc455f6e75a0$export$7d61b15e0da132af = '#172B4D';
var $d879fc455f6e75a0$export$fbda843f0a27fe96 = '#091E42';
var $d879fc455f6e75a0$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $d879fc455f6e75a0$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $d879fc455f6e75a0$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $d879fc455f6e75a0$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $d879fc455f6e75a0$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $d879fc455f6e75a0$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $d879fc455f6e75a0$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $d879fc455f6e75a0$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $d879fc455f6e75a0$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $d879fc455f6e75a0$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $d879fc455f6e75a0$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $d879fc455f6e75a0$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $d879fc455f6e75a0$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $d879fc455f6e75a0$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $d879fc455f6e75a0$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $d879fc455f6e75a0$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $d879fc455f6e75a0$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $d879fc455f6e75a0$export$2f6319cf7d736c2a = '#E6EDFA';
var $d879fc455f6e75a0$export$95126bc8884d6634 = '#DCE5F5';
var $d879fc455f6e75a0$export$8338d8c35d44ff1 = '#CED9EB';
var $d879fc455f6e75a0$export$5368d76ae4fbbda7 = '#B8C7E0';
var $d879fc455f6e75a0$export$9f0a771d16ec8d36 = '#ABBBD6';
var $d879fc455f6e75a0$export$abcf8c38338b4aa5 = '#9FB0CC';
var $d879fc455f6e75a0$export$97e81faa16a182c7 = '#8C9CB8';
var $d879fc455f6e75a0$export$bfe21c59123ecf33 = '#7988A3';
var $d879fc455f6e75a0$export$ee82aa2ea6a1558 = '#67758F';
var $d879fc455f6e75a0$export$682927c6ed76be02 = '#56637A';
var $d879fc455f6e75a0$export$91fd9994c5be9757 = '#455166';
var $d879fc455f6e75a0$export$d281fbfe3cff2df6 = '#3B475C';
var $d879fc455f6e75a0$export$3902c91d8b98a753 = '#313D52';
var $d879fc455f6e75a0$export$8e8133c1ba5845b5 = '#283447';
var $d879fc455f6e75a0$export$33ff357f6620b39 = '#202B3D';
var $d879fc455f6e75a0$export$633847cf062b69e0 = '#1B2638';
var $d879fc455f6e75a0$export$9776a6e503bdbf76 = '#121A29';
var $d879fc455f6e75a0$export$6c813d5160dff5db = '#0E1624';
var $d879fc455f6e75a0$export$3d4f271a500072a = '#0D1424';
var $d879fc455f6e75a0$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $d879fc455f6e75a0$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $d879fc455f6e75a0$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $d879fc455f6e75a0$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $d879fc455f6e75a0$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $d879fc455f6e75a0$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $d879fc455f6e75a0$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $d879fc455f6e75a0$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $d879fc455f6e75a0$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $d879fc455f6e75a0$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $d879fc455f6e75a0$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $d879fc455f6e75a0$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $d879fc455f6e75a0$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $d879fc455f6e75a0$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $d879fc455f6e75a0$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $d879fc455f6e75a0$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $d879fc455f6e75a0$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $d879fc455f6e75a0$export$d2adc5dedf09fced = '#292A2E';
var $d879fc455f6e75a0$export$f51762073d2bb381 = '#94C748';
var $d879fc455f6e75a0$export$95e26d54def96891 = '#B3DF72';


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
var $c2b3658074a39275$var$visuallyHiddenStyles = (0, $74Zh5.css)({
    width: '1px',
    height: '1px',
    padding: '0',
    position: 'absolute',
    border: '0',
    clip: 'rect(1px, 1px, 1px, 1px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $c2b3658074a39275$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return (0, $74Zh5.jsx)("span", {
        id: id,
        "data-testid": testId,
        css: $c2b3658074a39275$var$visuallyHiddenStyles,
        role: role
    }, children);
};
var $c2b3658074a39275$export$2e2bcd8739ae039 = $c2b3658074a39275$var$VisuallyHidden;



var $5FkrB = parcelRequire("5FkrB");
var $cf7ba7cef9450939$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $cf7ba7cef9450939$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $5FkrB.useContext)($cf7ba7cef9450939$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};


function $e55b531334fd90dc$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $e55b531334fd90dc$var$tabKeyCode = 9;
function $e55b531334fd90dc$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $e55b531334fd90dc$var$tabKeyCode) return;
    $e55b531334fd90dc$var$abort(event);
}
function $e55b531334fd90dc$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $e55b531334fd90dc$var$abort,
        onMouseUpCapture: $e55b531334fd90dc$var$abort,
        onKeyDownCapture: $e55b531334fd90dc$var$onKey,
        onKeyUpCapture: $e55b531334fd90dc$var$onKey,
        onTouchStartCapture: $e55b531334fd90dc$var$abort,
        onTouchEndCapture: $e55b531334fd90dc$var$abort,
        onPointerDownCapture: $e55b531334fd90dc$var$abort,
        onPointerUpCapture: $e55b531334fd90dc$var$abort,
        onClickCapture: $e55b531334fd90dc$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $e55b531334fd90dc$var$abort
    } : events;
}


var $84ce6d9f678fc045$export$d4c5499dc806c969 = ', Loading';



var $5FkrB = parcelRequire("5FkrB");
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $atP8S = parcelRequire("atP8S");

var $5FkrB = parcelRequire("5FkrB");


var $62ad4e230a652fb5$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $cd099e806837dee6$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $d879fc455f6e75a0$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $d879fc455f6e75a0$export$29a4f05edc054374), ")");
}
var $cd099e806837dee6$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $cd099e806837dee6$var$loadIn = null;
var $cd099e806837dee6$var$styles = {
    rotateStyles: "_y44v1ozz _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_y44v1a7z _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $cd099e806837dee6$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $cd099e806837dee6$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $62ad4e230a652fb5$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $cd099e806837dee6$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $6aca23134cc0dc0c$export$2e2bcd8739ae039));
    $cd099e806837dee6$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $atP8S.default)([
            $cd099e806837dee6$var$styles.wrapperStyles,
            $cd099e806837dee6$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $atP8S.default)([
            $cd099e806837dee6$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $atP8S.default)([
            $cd099e806837dee6$var$styles.circleStyles
        ])
    })));
}));
var $cd099e806837dee6$export$2e2bcd8739ae039 = $cd099e806837dee6$var$Spinner;


function $f9596edbd527292a$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $f9596edbd527292a$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $f9596edbd527292a$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cd099e806837dee6$export$2e2bcd8739ae039), {
        size: $f9596edbd527292a$var$getIconSpacing(spacing),
        appearance: $f9596edbd527292a$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}


function $8eb35ff6fdad60aa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8eb35ff6fdad60aa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8eb35ff6fdad60aa$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8eb35ff6fdad60aa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// If updating `buttonStyles`, also update `buttonStylesWithRem`.
var $8eb35ff6fdad60aa$var$buttonStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    width: 'auto',
    maxWidth: '100%',
    position: 'relative',
    alignItems: 'baseline',
    justifyContent: 'center',
    columnGap: 'space.050',
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width.0',
    flexShrink: 0,
    height: "".concat(32 / 14, "em"),
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    paddingBlock: 'space.075',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    textAlign: 'center',
    transition: 'background 0.1s ease-out',
    verticalAlign: 'middle',
    '::after': {
        borderRadius: 'inherit',
        inset: 'space.0',
        borderStyle: 'solid',
        borderWidth: "var(--ds-border-width, 1px)",
        pointerEvents: 'none',
        position: 'absolute'
    }
});
var $8eb35ff6fdad60aa$var$buttonStylesWithRem = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    width: 'auto',
    maxWidth: '100%',
    position: 'relative',
    alignItems: 'baseline',
    justifyContent: 'center',
    columnGap: 'space.050',
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width.0',
    flexShrink: 0,
    height: '2rem',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    paddingBlock: 'space.075',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    textAlign: 'center',
    transition: 'background 0.1s ease-out',
    verticalAlign: 'middle',
    '::after': {
        borderRadius: 'inherit',
        inset: 'space.0',
        borderStyle: 'solid',
        borderWidth: "var(--ds-border-width, 1px)",
        pointerEvents: 'none',
        position: 'absolute'
    }
});
var $8eb35ff6fdad60aa$var$defaultInteractiveStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    ':hover': {
        background: "var(--ds-background-neutral-hovered, #091e4214)",
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($d879fc455f6e75a0$export$c39c0fe0f26207ae, ")")
    },
    ':active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-neutral-pressed, ".concat($d879fc455f6e75a0$export$8c13c2ee36917869, ")"),
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($d879fc455f6e75a0$export$b3de0ae08da2ce64, ")")
    }
});
var $8eb35ff6fdad60aa$var$defaultInteractiveRefreshedStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: 'color.text.subtle'
    }
});
var $8eb35ff6fdad60aa$var$defaultStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    background: "var(--ds-background-neutral, ".concat($d879fc455f6e75a0$export$8d43898f60b96a82, ")"),
    // @ts-expect-error — using tokens for explicit fallback usage.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values --  -- Ignored via go/DSP-18766
    color: "var(--ds-text, ".concat($d879fc455f6e75a0$export$c39c0fe0f26207ae, ")"),
    ':visited': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($d879fc455f6e75a0$export$c39c0fe0f26207ae, ")")
    }
});
var $8eb35ff6fdad60aa$var$defaultRefreshedStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: 'color.text.subtle',
    '::after': {
        content: '""',
        borderColor: 'color.border'
    },
    ':visited': {
        color: 'color.text.subtle'
    }
});
var $8eb35ff6fdad60aa$var$primaryStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    background: "var(--ds-background-brand-bold, #0052CC)",
    // @ts-expect-error
    color: "var(--ds-text-inverse, #FFFFFF)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)"
    }
});
var $8eb35ff6fdad60aa$var$primaryInteractiveStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-hovered, #0065FF)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-pressed, #0747A6)"
    }
});
var $8eb35ff6fdad60aa$var$warningStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    background: "var(--ds-background-warning-bold, #FFAB00)",
    // @ts-expect-error
    color: "var(--ds-text-warning-inverse, #172B4D)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)"
    }
});
var $8eb35ff6fdad60aa$var$warningInteractiveStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-hovered, #FFC400)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-pressed, #FF991F)"
    }
});
var $8eb35ff6fdad60aa$var$dangerStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    background: "var(--ds-background-danger-bold, #DE350B)",
    color: 'color.text.inverse',
    ':visited': {
        color: 'color.text.inverse'
    }
});
var $8eb35ff6fdad60aa$var$dangerInteractiveStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    ':hover': {
        color: 'color.text.inverse',
        background: "var(--ds-background-danger-bold-hovered, #FF5630)"
    },
    ':active': {
        color: 'color.text.inverse',
        background: "var(--ds-background-danger-bold-pressed, #BF2600)"
    }
});
var $8eb35ff6fdad60aa$var$discoveryStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    background: "var(--ds-background-discovery-bold, #5243AA)",
    color: 'color.text.inverse',
    ':visited': {
        color: 'color.text.inverse'
    }
});
var $8eb35ff6fdad60aa$var$discoveryInteractiveStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    ':hover': {
        color: 'color.text.inverse',
        background: "var(--ds-background-discovery-bold-hovered, #8777D9)"
    },
    ':active': {
        color: 'color.text.inverse',
        background: "var(--ds-background-discovery-bold-pressed, #5243AA)"
    }
});
var $8eb35ff6fdad60aa$var$subtleStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    // @ts-expect-error
    color: "var(--ds-text, #42526E)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $8eb35ff6fdad60aa$var$subtleRefreshedStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    color: 'color.text.subtle',
    ':visited': {
        color: 'color.text.subtle'
    }
});
var $8eb35ff6fdad60aa$var$subtleInteractiveStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $8eb35ff6fdad60aa$var$subtleInteractiveRefreshedStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        color: 'color.text.subtle'
    }
});
// Required due to Jira's AUI CSS reset: https://product-fabric.atlassian.net/browse/DSP-15687
var $8eb35ff6fdad60aa$var$linkDecorationUnsetStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'none'
    },
    ':active': {
        textDecoration: 'none'
    },
    ':focus': {
        textDecoration: 'none'
    }
});
var $8eb35ff6fdad60aa$var$disabledStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    cursor: 'not-allowed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-disabled, ".concat($d879fc455f6e75a0$export$8d43898f60b96a82, ")"),
    // @ts-expect-error
    color: "var(--ds-text-disabled, #091E424F)",
    ':hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-disabled, ".concat($d879fc455f6e75a0$export$8d43898f60b96a82, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    ':active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-disabled, ".concat($d879fc455f6e75a0$export$8d43898f60b96a82, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    '::after': {
        content: 'none'
    }
});
var $8eb35ff6fdad60aa$var$selectedStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($d879fc455f6e75a0$export$ad0bacf983b7ddaa, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$9fdfb749e33cdf97, ")"),
    ':visited': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$9fdfb749e33cdf97, ")")
    }
});
var $8eb35ff6fdad60aa$var$selectedRefreshedStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    background: "var(--ds-background-selected, #E9F2FF)",
    color: 'color.text.selected',
    '::after': {
        content: '""',
        borderColor: 'color.border.selected'
    },
    ':visited': {
        color: 'color.text.selected'
    }
});
var $8eb35ff6fdad60aa$var$selectedInsideSplitButtonStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    // This is 2 so it appears above the split button divider when selected.
    // See split-button.tsx.
    // @ts-expect-error — We need a local zindex just for button.
    zIndex: 2
});
var $8eb35ff6fdad60aa$var$selectedInteractiveStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$9fdfb749e33cdf97, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected-hovered, ".concat($d879fc455f6e75a0$export$ad0bacf983b7ddaa, ")")
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$9fdfb749e33cdf97, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected-pressed, ".concat($d879fc455f6e75a0$export$ad0bacf983b7ddaa, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $8eb35ff6fdad60aa$var$selectedWarningStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($d879fc455f6e75a0$export$59619663aa6500fb, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$7d61b15e0da132af, ")"),
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$9fdfb749e33cdf97, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($d879fc455f6e75a0$export$59619663aa6500fb, ")")
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$9fdfb749e33cdf97, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($d879fc455f6e75a0$export$59619663aa6500fb, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $8eb35ff6fdad60aa$var$selectedDangerStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($d879fc455f6e75a0$export$2837b5a1a71d5c02, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$9fdfb749e33cdf97, ")"),
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$9fdfb749e33cdf97, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($d879fc455f6e75a0$export$2837b5a1a71d5c02, ")")
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$9fdfb749e33cdf97, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($d879fc455f6e75a0$export$2837b5a1a71d5c02, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $8eb35ff6fdad60aa$var$selectedDiscoveryStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    background: "var(--ds-background-selected, #403294)",
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$9fdfb749e33cdf97, ")"),
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$9fdfb749e33cdf97, ")"),
        background: "var(--ds-background-selected, #403294)"
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$9fdfb749e33cdf97, ")"),
        background: "var(--ds-background-selected, #403294)"
    }
});
// If updating `spacingCompactStyles`, also update `spacingCompactStylesWithRem`.
var $8eb35ff6fdad60aa$var$spacingCompactStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    columnGap: 'space.050',
    height: "".concat(24 / 14, "em"),
    paddingBlock: 'space.025',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    verticalAlign: 'middle'
});
var $8eb35ff6fdad60aa$var$spacingCompactStylesWithRem = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    columnGap: 'space.050',
    height: '1.5rem',
    paddingBlock: 'space.025',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    verticalAlign: 'middle'
});
var $8eb35ff6fdad60aa$var$circleStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    borderRadius: 'border.radius.circle'
});
var $8eb35ff6fdad60aa$var$fullWidthStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    width: '100%'
});
var $8eb35ff6fdad60aa$var$loadingStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    cursor: 'progress'
});
// If updating `iconButtonStyles`, also update `iconButtonStylesWithRem`.
var $8eb35ff6fdad60aa$var$iconButtonStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    height: "".concat(32 / 14, "em"),
    width: "".concat(32 / 14, "em"),
    paddingInlineEnd: 'space.0',
    paddingInlineStart: 'space.0'
});
var $8eb35ff6fdad60aa$var$iconButtonStylesWithRem = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    height: '2rem',
    width: '2rem',
    paddingInlineEnd: 'space.0',
    paddingInlineStart: 'space.0'
});
// If updating `iconButtonCompactStyles`, also update `iconButtonCompactStylesWithRem`.
var $8eb35ff6fdad60aa$var$iconButtonCompactStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    width: "".concat(24 / 14, "em"),
    height: "".concat(24 / 14, "em")
});
var $8eb35ff6fdad60aa$var$iconButtonCompactStylesWithRem = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    width: '1.5rem',
    height: '1.5rem'
});
var $8eb35ff6fdad60aa$var$buttonIconBeforeStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    paddingInlineStart: 'space.100'
});
var $8eb35ff6fdad60aa$var$buttonIconAfterStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    paddingInlineEnd: 'space.100'
});
var $8eb35ff6fdad60aa$var$splitButtonStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    ':focus-visible': {
        zIndex: 'card'
    }
});
var $8eb35ff6fdad60aa$var$navigationSplitButtonStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    width: '24px',
    backgroundColor: 'color.background.neutral.subtle',
    paddingInlineEnd: 'space.075',
    paddingInlineStart: 'space.075'
});
var $8eb35ff6fdad60aa$var$loadingOverlayStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    insetBlockEnd: 'space.0',
    insetBlockStart: 'space.0',
    insetInlineEnd: 'space.0',
    insetInlineStart: 'space.0'
});
/**
 * __Use button base__
 *
 * A React hook that accepts a set of common Button props,
 * and processes them to return consistent base props for usage
 * across various Button components.
 *
 * It also:
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $8eb35ff6fdad60aa$var$useButtonBase = function useButtonBase(_ref) {
    var _ref$appearance = _ref.appearance, propAppearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, children = _ref.children, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, ref = _ref.ref, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, testId = _ref.testId, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy;
    var localRef = (0, $5FkrB.useRef)(null);
    var splitButtonContext = (0, $cf7ba7cef9450939$export$47e2c6fdb142d947)();
    var loadingLabelId = (0, $24526c38f36cc756$export$f680877a34711e37)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton && (0, $dVGJk.fg)('platform-component-visual-refresh') ? 'subtle' : (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || propAppearance;
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $65ad6b2d82b5101d$export$2e2bcd8739ae039)(localRef, autoFocus);
    return $8eb35ff6fdad60aa$var$_objectSpread({
        ref: (0, $0d2a37110e22a1c9$export$2e2bcd8739ae039)([
            localRef,
            ref
        ]),
        xcss: [
            (0, $dVGJk.fg)('platform_dst_button_replace_em_with_rem') ? $8eb35ff6fdad60aa$var$buttonStylesWithRem : $8eb35ff6fdad60aa$var$buttonStyles,
            appearance === 'default' && ((0, $dVGJk.fg)('platform-component-visual-refresh') ? $8eb35ff6fdad60aa$var$defaultRefreshedStyles : $8eb35ff6fdad60aa$var$defaultStyles),
            appearance === 'default' && isInteractive && ((0, $dVGJk.fg)('platform-component-visual-refresh') ? $8eb35ff6fdad60aa$var$defaultInteractiveRefreshedStyles : $8eb35ff6fdad60aa$var$defaultInteractiveStyles),
            appearance === 'primary' && $8eb35ff6fdad60aa$var$primaryStyles,
            appearance === 'primary' && isInteractive && $8eb35ff6fdad60aa$var$primaryInteractiveStyles,
            appearance === 'warning' && $8eb35ff6fdad60aa$var$warningStyles,
            appearance === 'warning' && isInteractive && $8eb35ff6fdad60aa$var$warningInteractiveStyles,
            appearance === 'danger' && $8eb35ff6fdad60aa$var$dangerStyles,
            appearance === 'danger' && isInteractive && $8eb35ff6fdad60aa$var$dangerInteractiveStyles,
            appearance === 'discovery' && $8eb35ff6fdad60aa$var$discoveryStyles,
            appearance === 'discovery' && isInteractive && $8eb35ff6fdad60aa$var$discoveryInteractiveStyles,
            appearance === 'subtle' && ((0, $dVGJk.fg)('platform-component-visual-refresh') ? $8eb35ff6fdad60aa$var$subtleRefreshedStyles : $8eb35ff6fdad60aa$var$subtleStyles),
            appearance === 'subtle' && isInteractive && ((0, $dVGJk.fg)('platform-component-visual-refresh') ? $8eb35ff6fdad60aa$var$subtleInteractiveRefreshedStyles : $8eb35ff6fdad60aa$var$subtleInteractiveStyles),
            $8eb35ff6fdad60aa$var$linkDecorationUnsetStyles,
            isSelected && ((0, $dVGJk.fg)('platform-component-visual-refresh') ? $8eb35ff6fdad60aa$var$selectedRefreshedStyles : $8eb35ff6fdad60aa$var$selectedStyles),
            isSelected && isSplitButton && $8eb35ff6fdad60aa$var$selectedInsideSplitButtonStyles,
            isSelected && isInteractive && $8eb35ff6fdad60aa$var$selectedInteractiveStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'danger' && $8eb35ff6fdad60aa$var$selectedDangerStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'warning' && $8eb35ff6fdad60aa$var$selectedWarningStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'discovery' && $8eb35ff6fdad60aa$var$selectedDiscoveryStyles,
            isDisabled && $8eb35ff6fdad60aa$var$disabledStyles,
            isCircle && !isSplitButton && $8eb35ff6fdad60aa$var$circleStyles,
            spacing === 'compact' && ((0, $dVGJk.fg)('platform_dst_button_replace_em_with_rem') ? $8eb35ff6fdad60aa$var$spacingCompactStylesWithRem : $8eb35ff6fdad60aa$var$spacingCompactStyles),
            hasIconBefore && $8eb35ff6fdad60aa$var$buttonIconBeforeStyles,
            hasIconAfter && $8eb35ff6fdad60aa$var$buttonIconAfterStyles,
            isIconButton && ((0, $dVGJk.fg)('platform_dst_button_replace_em_with_rem') ? $8eb35ff6fdad60aa$var$iconButtonStylesWithRem : $8eb35ff6fdad60aa$var$iconButtonStyles),
            isIconButton && spacing === 'compact' && ((0, $dVGJk.fg)('platform_dst_button_replace_em_with_rem') ? $8eb35ff6fdad60aa$var$iconButtonCompactStylesWithRem : $8eb35ff6fdad60aa$var$iconButtonCompactStyles),
            shouldFitContainer && $8eb35ff6fdad60aa$var$fullWidthStyles,
            isLoading && $8eb35ff6fdad60aa$var$loadingStyles,
            isSplitButton && $8eb35ff6fdad60aa$var$splitButtonStyles,
            isNavigationSplitButton && $8eb35ff6fdad60aa$var$navigationSplitButtonStyles
        ],
        isDisabled: isEffectivelyDisabled,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cf7ba7cef9450939$export$4b86304b2c0d7e71).Provider, {
            value: undefined
        }, children, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d007f17589e0f9b9$export$2e2bcd8739ae039), {
            as: "span",
            xcss: $8eb35ff6fdad60aa$var$loadingOverlayStyles
        }, (0, $f9596edbd527292a$export$2e2bcd8739ae039)({
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected,
            testId: testId
        })) : null, isLoading && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c2b3658074a39275$export$2e2bcd8739ae039), {
            id: loadingLabelId
        }, (0, $84ce6d9f678fc045$export$d4c5499dc806c969))),
        'aria-label': isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat((0, $84ce6d9f678fc045$export$d4c5499dc806c969)) : ariaLabel,
        'aria-labelledby': isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy
    }, (0, $e55b531334fd90dc$export$2e2bcd8739ae039)(isEffectivelyDisabled, {
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }));
};
var $8eb35ff6fdad60aa$export$2e2bcd8739ae039 = $8eb35ff6fdad60aa$var$useButtonBase;


/**
 * __Use default button base__
 *
 * A React hook that accepts a set of default Button props,
 * and processes them to return consistent base props for usage
 * across Button and LinkButton variants.
 *
 * @private
 */ var $0eb17ca5f07eb9cf$var$useDefaultButton = function useDefaultButton(_ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, autoFocus = _ref.autoFocus, buttonType = _ref.buttonType, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, ref = _ref.ref, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId;
    var baseProps = (0, $8eb35ff6fdad60aa$export$2e2bcd8739ae039)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $301b23ec1b0d3f05$export$2e2bcd8739ae039), {
            type: "icon",
            position: "before",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a2bbd318f52424a1$export$2e2bcd8739ae039), {
            icon: iconBefore
        })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $301b23ec1b0d3f05$export$2e2bcd8739ae039), {
            isLoading: isLoading
        }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $301b23ec1b0d3f05$export$2e2bcd8739ae039), {
            type: "icon",
            position: "after",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a2bbd318f52424a1$export$2e2bcd8739ae039), {
            icon: iconAfter
        }))),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter)
    });
    return baseProps;
};
var $0eb17ca5f07eb9cf$export$2e2bcd8739ae039 = $0eb17ca5f07eb9cf$var$useDefaultButton;


var $1fa2d718d507adf5$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $1fa2d718d507adf5$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $1fa2d718d507adf5$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isLoading = _ref.isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $1fa2d718d507adf5$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $1fa2d718d507adf5$var$_excluded2);
    var baseProps = (0, $0eb17ca5f07eb9cf$export$2e2bcd8739ae039)({
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: 'button',
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d469e5ab074fc4c0$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        "aria-label": baseProps['aria-label'],
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "Button"
    }), baseProps.children);
}));
$1fa2d718d507adf5$var$Button.displayName = 'Button';
var $1fa2d718d507adf5$export$2e2bcd8739ae039 = $1fa2d718d507adf5$var$Button;


/**
 * Character key codes which can be used in keyboard events.
 */ var $e27a1598a26ffda3$export$390330c10ff2b9a1 = 'ArrowUp';
var $e27a1598a26ffda3$export$a80636c6f41931fe = 'ArrowDown';
var $e27a1598a26ffda3$export$4af703091671bc = 'Home';
var $e27a1598a26ffda3$export$e2bc30913faa5db7 = 'End';
var $e27a1598a26ffda3$export$10f6869ed0a7d75b = 'Tab';
var $e27a1598a26ffda3$export$8152f929a25a0ff4 = 'Enter';
var $e27a1598a26ffda3$export$e51a3576c045c8d5 = 'Space';
var $e27a1598a26ffda3$export$2bb790b9008907b4 = 'Escape';





var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $f4d287be7eb5fb6d$export$2e2bcd8739ae039(propValue) {
    var getDefaultPropValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
        return propValue;
    };
    var isControlled = propValue !== undefined;
    var _useState = (0, $5FkrB.useState)(getDefaultPropValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), valueState = _useState2[0], setValue = _useState2[1];
    var isControlledRef = (0, $5FkrB.useRef)(isControlled);
    (0, $5FkrB.useEffect)(function() {
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var value = isControlled ? propValue : valueState;
    var setValueIfUncontrolled = (0, $5FkrB.useCallback)(function(newValue) {
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $7632941312f4921f$export$2e2bcd8739ae039() {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isFocused = _useState2[0], setIsFocused = _useState2[1];
    // ensure bindFocus has a stable ref
    var bindFocus = (0, $5FkrB.useRef)({
        onFocus: function onFocus() {
            return setIsFocused(true);
        },
        onBlur: function onBlur() {
            return setIsFocused(false);
        }
    });
    (0, $5FkrB.useEffect)(function() {
        // handle the case where a component might
        // unmount while being focused.
        return function() {
            return setIsFocused(false);
        };
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}


var $c21b397a5a41009b$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f1feec303b173e7de0228adfc7e7782>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($c21b397a5a41009b$exports, "__esModule", {
    value: true
});
$c21b397a5a41009b$exports.default = void 0;

var $c21b397a5a41009b$var$_react = $c21b397a5a41009b$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $c21b397a5a41009b$var$_chevronDown = $c21b397a5a41009b$var$_interopRequireDefault((parcelRequire("8kEM5")));

var $c21b397a5a41009b$var$_chevronDown2 = $c21b397a5a41009b$var$_interopRequireDefault((parcelRequire("kINa4")));
function $c21b397a5a41009b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "ChevronDownIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c21b397a5a41009b$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $c21b397a5a41009b$var$_react.default.createElement($c21b397a5a41009b$var$_chevronDown.default, Object.assign({
        LEGACY_fallbackIcon: $c21b397a5a41009b$var$_chevronDown2.default
    }, props));
$c21b397a5a41009b$var$ChevronDownIcon.Name = 'ChevronDownIconMigration';
var $c21b397a5a41009b$var$_default = $c21b397a5a41009b$exports.default = $c21b397a5a41009b$var$ChevronDownIcon;



var $dVGJk = parcelRequire("dVGJk");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $9dOvm = parcelRequire("9dOvm");
var $813352569d4afa99$var$_process, $813352569d4afa99$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $813352569d4afa99$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($813352569d4afa99$var$_process = globalThis.process) === null || $813352569d4afa99$var$_process === void 0 || ($813352569d4afa99$var$_process = $813352569d4afa99$var$_process.env) === null || $813352569d4afa99$var$_process === void 0 ? void 0 : $813352569d4afa99$var$_process.JEST_WORKER_ID) !== undefined;
var $813352569d4afa99$var$DEBUG_MODE = !$813352569d4afa99$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($813352569d4afa99$var$_process2 = globalThis.process) === null || $813352569d4afa99$var$_process2 === void 0 || ($813352569d4afa99$var$_process2 = $813352569d4afa99$var$_process2.env) === null || $813352569d4afa99$var$_process2 === void 0 ? void 0 : $813352569d4afa99$var$_process2.NODE_ENV) !== 'production';
var $813352569d4afa99$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$813352569d4afa99$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $efa0887b5e796955$var$pkgName = '@atlaskit/platform-feature-flags';
var $efa0887b5e796955$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $efa0887b5e796955$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $efa0887b5e796955$var$ENV_ENABLE_PLATFORM_FF = $efa0887b5e796955$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $efa0887b5e796955$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $efa0887b5e796955$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $efa0887b5e796955$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $efa0887b5e796955$var$ENV_ENABLE_PLATFORM_FF || $efa0887b5e796955$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $efa0887b5e796955$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $efa0887b5e796955$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$efa0887b5e796955$var$globalVar[$efa0887b5e796955$export$7e41b1b2bdee3f98] = $efa0887b5e796955$var$globalVar[$efa0887b5e796955$export$7e41b1b2bdee3f98] || $efa0887b5e796955$var$DEFAULT_PFF_GLOBAL;
function $efa0887b5e796955$export$f2b591175b3e424c(resolver) {
    $efa0887b5e796955$var$globalVar[$efa0887b5e796955$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $efa0887b5e796955$export$6333b6aff9fc6275(flagKey) {
    if ($efa0887b5e796955$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $813352569d4afa99$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $efa0887b5e796955$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $efa0887b5e796955$var$globalVar[$efa0887b5e796955$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $efa0887b5e796955$var$globalVar[$efa0887b5e796955$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $9dOvm.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $efa0887b5e796955$var$globalVar[$efa0887b5e796955$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $cb80f7117c1d7ebd$export$ba05d765b8392e5e(flagResolver) {
    (0, $efa0887b5e796955$export$f2b591175b3e424c)(flagResolver);
}
function $cb80f7117c1d7ebd$export$470e5c2be1411c89(name) {
    return (0, $efa0887b5e796955$export$6333b6aff9fc6275)(name);
}
function $cb80f7117c1d7ebd$export$b40ec24ac8275656(name) {
    return (0, $efa0887b5e796955$export$6333b6aff9fc6275)(name);
}


var $ae9fa784eacafcd8$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $ae9fa784eacafcd8$var$react18UseId = ($ae9fa784eacafcd8$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $ae9fa784eacafcd8$var$_React$useId !== void 0 ? $ae9fa784eacafcd8$var$_React$useId : undefined;
function $ae9fa784eacafcd8$export$f680877a34711e37() {
    if ($ae9fa784eacafcd8$var$react18UseId && (0, $cb80f7117c1d7ebd$export$b40ec24ac8275656)('platform.design-system-team.react-18-use-id_mn8q4')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $ae9fa784eacafcd8$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $ae9fa784eacafcd8$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($ae9fa784eacafcd8$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $ae9fa784eacafcd8$export$6ee17796e3d70de2() {
    if ($ae9fa784eacafcd8$var$react18UseId && (0, $cb80f7117c1d7ebd$export$b40ec24ac8275656)('platform.design-system-team.react-18-use-id_mn8q4')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $ae9fa784eacafcd8$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $b5lkZ.useUIDSeed)();
}



var $5FkrB = parcelRequire("5FkrB");
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $9fa87a5473741e62$export$2e2bcd8739ae039() {}


var $e3acb6a69a5c2a02$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $5FkrB.createContext)(0);
var $e3acb6a69a5c2a02$export$48b383b280e20440 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $9fa87a5473741e62$export$2e2bcd8739ae039)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $e3acb6a69a5c2a02$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $5FkrB.useContext)($e3acb6a69a5c2a02$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel, topLevelRef = _useContext.topLevelRef;
    if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            // avoid immediate cleanup using setTimeout when component unmount
            // this will make sure non-top layer components can get the correct top level value
            // when multiple layers trigger onClose in sequence
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($e3acb6a69a5c2a02$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $e3acb6a69a5c2a02$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $5FkrB.useRef)(0);
    var value = (0, $5FkrB.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($e3acb6a69a5c2a02$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $e3acb6a69a5c2a02$export$7c885f891c940977 = function Layering(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $5FkrB.useContext)($e3acb6a69a5c2a02$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($e3acb6a69a5c2a02$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($e3acb6a69a5c2a02$var$LayeringProvider, null, content);
};



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $806f567bc9d3be85$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $16baedc850e7aff3$export$469bb693f11edc7f() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$isOpen = _ref.isOpen, isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen;
    var context = (0, $5FkrB.useContext)((0, $806f567bc9d3be85$export$5fbf4d7fae6cdc00));
    (0, $5FkrB.useEffect)(function() {
        if (context === null) return;
        if (!isOpen) return;
        context.increment();
        return function() {
            context.decrement();
        };
    }, [
        context,
        isOpen
    ]);
}



var $9dOvm = parcelRequire("9dOvm");
var $d5229a1bd14b4fa3$var$_process, $d5229a1bd14b4fa3$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $d5229a1bd14b4fa3$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($d5229a1bd14b4fa3$var$_process = globalThis.process) === null || $d5229a1bd14b4fa3$var$_process === void 0 || ($d5229a1bd14b4fa3$var$_process = $d5229a1bd14b4fa3$var$_process.env) === null || $d5229a1bd14b4fa3$var$_process === void 0 ? void 0 : $d5229a1bd14b4fa3$var$_process.JEST_WORKER_ID) !== undefined;
var $d5229a1bd14b4fa3$var$DEBUG_MODE = !$d5229a1bd14b4fa3$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($d5229a1bd14b4fa3$var$_process2 = globalThis.process) === null || $d5229a1bd14b4fa3$var$_process2 === void 0 || ($d5229a1bd14b4fa3$var$_process2 = $d5229a1bd14b4fa3$var$_process2.env) === null || $d5229a1bd14b4fa3$var$_process2 === void 0 ? void 0 : $d5229a1bd14b4fa3$var$_process2.NODE_ENV) !== 'production';
var $d5229a1bd14b4fa3$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$d5229a1bd14b4fa3$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $f7983fba981a1117$var$pkgName = '@atlaskit/platform-feature-flags';
var $f7983fba981a1117$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $f7983fba981a1117$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $f7983fba981a1117$var$ENV_ENABLE_PLATFORM_FF = $f7983fba981a1117$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $f7983fba981a1117$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $f7983fba981a1117$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $f7983fba981a1117$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $f7983fba981a1117$var$ENV_ENABLE_PLATFORM_FF || $f7983fba981a1117$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $f7983fba981a1117$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $f7983fba981a1117$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$f7983fba981a1117$var$globalVar[$f7983fba981a1117$export$7e41b1b2bdee3f98] = $f7983fba981a1117$var$globalVar[$f7983fba981a1117$export$7e41b1b2bdee3f98] || $f7983fba981a1117$var$DEFAULT_PFF_GLOBAL;
function $f7983fba981a1117$export$f2b591175b3e424c(resolver) {
    $f7983fba981a1117$var$globalVar[$f7983fba981a1117$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $f7983fba981a1117$export$6333b6aff9fc6275(flagKey) {
    if ($f7983fba981a1117$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $d5229a1bd14b4fa3$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $f7983fba981a1117$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $f7983fba981a1117$var$globalVar[$f7983fba981a1117$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $f7983fba981a1117$var$globalVar[$f7983fba981a1117$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $9dOvm.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $f7983fba981a1117$var$globalVar[$f7983fba981a1117$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $788343a2280faaa5$export$ba05d765b8392e5e(flagResolver) {
    (0, $f7983fba981a1117$export$f2b591175b3e424c)(flagResolver);
}
function $788343a2280faaa5$export$470e5c2be1411c89(name) {
    return (0, $f7983fba981a1117$export$6333b6aff9fc6275)(name);
}
function $788343a2280faaa5$export$b40ec24ac8275656(name) {
    return (0, $f7983fba981a1117$export$6333b6aff9fc6275)(name);
}



var $hvYLl = parcelRequire("hvYLl");
var $agyC9 = parcelRequire("agyC9");


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $5FkrB = parcelRequire("5FkrB");
var $af5fb0353719c780$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $af5fb0353719c780$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($af5fb0353719c780$export$1ca2a26fecb070ae);
};
$af5fb0353719c780$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';



var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");
var $06459409b22be1ec$export$4ef52930e33717cd = 'data-theme';
var $06459409b22be1ec$export$a00eac3f8684bcd0 = 'data-color-mode';
var $06459409b22be1ec$export$2112803007239c61 = 'data-contrast-mode';
var $06459409b22be1ec$export$352e418ed5b6193a = 'data-custom-theme';
var $06459409b22be1ec$export$2faeed762aac6741 = 'light';
var $06459409b22be1ec$export$6f0c6fb8c80fcc92 = 'ds';
var $06459409b22be1ec$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $06459409b22be1ec$export$dddac1532e822863 = "--".concat($06459409b22be1ec$export$6f0c6fb8c80fcc92, "-token-not-found");
var $06459409b22be1ec$export$9d7b58831ae93caa = "--".concat($06459409b22be1ec$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $7ed2b9d3e2d5bbed$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7ed2b9d3e2d5bbed$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7ed2b9d3e2d5bbed$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7ed2b9d3e2d5bbed$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7ed2b9d3e2d5bbed$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $7ed2b9d3e2d5bbed$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $7ed2b9d3e2d5bbed$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $7ed2b9d3e2d5bbed$export$632685d741f3dbbf = $7ed2b9d3e2d5bbed$var$_objectSpread($7ed2b9d3e2d5bbed$var$_objectSpread({}, $7ed2b9d3e2d5bbed$export$958d0ae7f2977ae4), $7ed2b9d3e2d5bbed$export$d2dc61f58390201c);
var $7ed2b9d3e2d5bbed$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $7ed2b9d3e2d5bbed$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $7ed2b9d3e2d5bbed$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $7ed2b9d3e2d5bbed$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $7ed2b9d3e2d5bbed$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $7ed2b9d3e2d5bbed$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $7ed2b9d3e2d5bbed$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $7ed2b9d3e2d5bbed$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $7ed2b9d3e2d5bbed$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $7ed2b9d3e2d5bbed$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $7ed2b9d3e2d5bbed$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $7ed2b9d3e2d5bbed$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $7ed2b9d3e2d5bbed$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $7ed2b9d3e2d5bbed$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $7ed2b9d3e2d5bbed$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $7ed2b9d3e2d5bbed$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $7ed2b9d3e2d5bbed$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $7ed2b9d3e2d5bbed$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $7ed2b9d3e2d5bbed$export$e615f061ca585a6c = $7ed2b9d3e2d5bbed$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $7ed2b9d3e2d5bbed$export$ca0f9c2de39ffed7(spacingProperty, $7ed2b9d3e2d5bbed$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $7ed2b9d3e2d5bbed$export$bf46c3f9eeafc71f = $7ed2b9d3e2d5bbed$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $7ed2b9d3e2d5bbed$export$ca0f9c2de39ffed7(spacingProperty, $7ed2b9d3e2d5bbed$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $7ed2b9d3e2d5bbed$export$e7af83bafe7f9e63 = $7ed2b9d3e2d5bbed$export$ca0f9c2de39ffed7('backgroundColor', $7ed2b9d3e2d5bbed$export$d1d79bf68ac056bd);
var $7ed2b9d3e2d5bbed$export$3a1bcba60b23d7f0 = $7ed2b9d3e2d5bbed$export$ca0f9c2de39ffed7('color', $7ed2b9d3e2d5bbed$export$8473307aa00d6ea1);
var $7ed2b9d3e2d5bbed$export$45f3f4fe16f9f7d5 = $7ed2b9d3e2d5bbed$export$ca0f9c2de39ffed7('fontWeight', $7ed2b9d3e2d5bbed$export$303e322c6b1ed114);
var $7ed2b9d3e2d5bbed$export$68cc305da27dbaa4 = $7ed2b9d3e2d5bbed$export$ca0f9c2de39ffed7('fontFamily', $7ed2b9d3e2d5bbed$export$3c7e9587132614b4);
var $7ed2b9d3e2d5bbed$export$128f10c238242f83 = $7ed2b9d3e2d5bbed$export$ca0f9c2de39ffed7('font', $7ed2b9d3e2d5bbed$export$6ffa317d5e70375);
var $7ed2b9d3e2d5bbed$export$219d364c0da35ae4 = $7ed2b9d3e2d5bbed$export$ca0f9c2de39ffed7('font', $7ed2b9d3e2d5bbed$export$236bfe3a33ef1292);
var $7ed2b9d3e2d5bbed$export$38845ca010b93505 = $7ed2b9d3e2d5bbed$export$ca0f9c2de39ffed7('fontWeight', $7ed2b9d3e2d5bbed$export$855cfd311192d666);
var $7ed2b9d3e2d5bbed$export$ff257d957d48c421 = $7ed2b9d3e2d5bbed$export$ca0f9c2de39ffed7((0, $06459409b22be1ec$export$9d7b58831ae93caa), $7ed2b9d3e2d5bbed$export$41a358c9c2356760);
var $7ed2b9d3e2d5bbed$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $7ed2b9d3e2d5bbed$export$41a358c9c2356760[color] !== undefined;
};



var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $74Zh5 = parcelRequire("74Zh5");


var $3ZMUU = parcelRequire("3ZMUU");
function $a778bd8d95c0241c$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $a778bd8d95c0241c$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $a778bd8d95c0241c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $a778bd8d95c0241c$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $a778bd8d95c0241c$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $a778bd8d95c0241c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $a778bd8d95c0241c$export$9a199fbafee0014e = {
    backgroundColor: (0, $7ed2b9d3e2d5bbed$export$d1d79bf68ac056bd),
    blockSize: (0, $7ed2b9d3e2d5bbed$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $7ed2b9d3e2d5bbed$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $7ed2b9d3e2d5bbed$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $7ed2b9d3e2d5bbed$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $7ed2b9d3e2d5bbed$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $7ed2b9d3e2d5bbed$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $7ed2b9d3e2d5bbed$export$e1b83c5210c471b8),
    borderBottomColor: (0, $7ed2b9d3e2d5bbed$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $7ed2b9d3e2d5bbed$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $7ed2b9d3e2d5bbed$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $7ed2b9d3e2d5bbed$export$e1b83c5210c471b8),
    borderColor: (0, $7ed2b9d3e2d5bbed$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $7ed2b9d3e2d5bbed$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $7ed2b9d3e2d5bbed$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $7ed2b9d3e2d5bbed$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $7ed2b9d3e2d5bbed$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $7ed2b9d3e2d5bbed$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $7ed2b9d3e2d5bbed$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $7ed2b9d3e2d5bbed$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $7ed2b9d3e2d5bbed$export$e1b83c5210c471b8),
    borderLeftColor: (0, $7ed2b9d3e2d5bbed$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $7ed2b9d3e2d5bbed$export$e1b83c5210c471b8),
    borderRadius: (0, $7ed2b9d3e2d5bbed$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $7ed2b9d3e2d5bbed$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $7ed2b9d3e2d5bbed$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $7ed2b9d3e2d5bbed$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $7ed2b9d3e2d5bbed$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $7ed2b9d3e2d5bbed$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $7ed2b9d3e2d5bbed$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $7ed2b9d3e2d5bbed$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $7ed2b9d3e2d5bbed$export$e1b83c5210c471b8),
    borderWidth: (0, $7ed2b9d3e2d5bbed$export$e1b83c5210c471b8),
    bottom: (0, $7ed2b9d3e2d5bbed$export$632685d741f3dbbf),
    boxShadow: (0, $7ed2b9d3e2d5bbed$export$7aff6e7ba39bb774),
    color: (0, $7ed2b9d3e2d5bbed$export$8473307aa00d6ea1),
    columnGap: (0, $7ed2b9d3e2d5bbed$export$958d0ae7f2977ae4),
    font: (0, $7ed2b9d3e2d5bbed$export$6ffa317d5e70375),
    fontFamily: (0, $7ed2b9d3e2d5bbed$export$3c7e9587132614b4),
    fontWeight: (0, $7ed2b9d3e2d5bbed$export$303e322c6b1ed114),
    gap: (0, $7ed2b9d3e2d5bbed$export$958d0ae7f2977ae4),
    height: (0, $7ed2b9d3e2d5bbed$export$6ccdbebca2ee545f),
    inlineSize: (0, $7ed2b9d3e2d5bbed$export$6ccdbebca2ee545f),
    inset: (0, $7ed2b9d3e2d5bbed$export$632685d741f3dbbf),
    insetBlock: (0, $7ed2b9d3e2d5bbed$export$632685d741f3dbbf),
    insetBlockEnd: (0, $7ed2b9d3e2d5bbed$export$632685d741f3dbbf),
    insetBlockStart: (0, $7ed2b9d3e2d5bbed$export$632685d741f3dbbf),
    insetInline: (0, $7ed2b9d3e2d5bbed$export$632685d741f3dbbf),
    insetInlineEnd: (0, $7ed2b9d3e2d5bbed$export$632685d741f3dbbf),
    insetInlineStart: (0, $7ed2b9d3e2d5bbed$export$632685d741f3dbbf),
    left: (0, $7ed2b9d3e2d5bbed$export$632685d741f3dbbf),
    margin: (0, $7ed2b9d3e2d5bbed$export$632685d741f3dbbf),
    marginBlock: (0, $7ed2b9d3e2d5bbed$export$632685d741f3dbbf),
    marginBlockEnd: (0, $7ed2b9d3e2d5bbed$export$632685d741f3dbbf),
    marginBlockStart: (0, $7ed2b9d3e2d5bbed$export$632685d741f3dbbf),
    marginBottom: (0, $7ed2b9d3e2d5bbed$export$632685d741f3dbbf),
    marginInline: (0, $7ed2b9d3e2d5bbed$export$632685d741f3dbbf),
    marginInlineEnd: (0, $7ed2b9d3e2d5bbed$export$632685d741f3dbbf),
    marginInlineStart: (0, $7ed2b9d3e2d5bbed$export$632685d741f3dbbf),
    marginLeft: (0, $7ed2b9d3e2d5bbed$export$632685d741f3dbbf),
    marginRight: (0, $7ed2b9d3e2d5bbed$export$632685d741f3dbbf),
    marginTop: (0, $7ed2b9d3e2d5bbed$export$632685d741f3dbbf),
    maxBlockSize: (0, $7ed2b9d3e2d5bbed$export$6ccdbebca2ee545f),
    maxHeight: (0, $7ed2b9d3e2d5bbed$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $7ed2b9d3e2d5bbed$export$6ccdbebca2ee545f),
    maxWidth: (0, $7ed2b9d3e2d5bbed$export$6ccdbebca2ee545f),
    minBlockSize: (0, $7ed2b9d3e2d5bbed$export$6ccdbebca2ee545f),
    minHeight: (0, $7ed2b9d3e2d5bbed$export$6ccdbebca2ee545f),
    minInlineSize: (0, $7ed2b9d3e2d5bbed$export$6ccdbebca2ee545f),
    minWidth: (0, $7ed2b9d3e2d5bbed$export$6ccdbebca2ee545f),
    opacity: (0, $7ed2b9d3e2d5bbed$export$daf94a976c798b4f),
    outlineColor: (0, $7ed2b9d3e2d5bbed$export$1531ad5bb3fbedac),
    outlineOffset: (0, $7ed2b9d3e2d5bbed$export$958d0ae7f2977ae4),
    outlineWidth: (0, $7ed2b9d3e2d5bbed$export$e1b83c5210c471b8),
    padding: (0, $7ed2b9d3e2d5bbed$export$958d0ae7f2977ae4),
    paddingBlock: (0, $7ed2b9d3e2d5bbed$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $7ed2b9d3e2d5bbed$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $7ed2b9d3e2d5bbed$export$958d0ae7f2977ae4),
    paddingBottom: (0, $7ed2b9d3e2d5bbed$export$958d0ae7f2977ae4),
    paddingInline: (0, $7ed2b9d3e2d5bbed$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $7ed2b9d3e2d5bbed$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $7ed2b9d3e2d5bbed$export$958d0ae7f2977ae4),
    paddingLeft: (0, $7ed2b9d3e2d5bbed$export$958d0ae7f2977ae4),
    paddingRight: (0, $7ed2b9d3e2d5bbed$export$958d0ae7f2977ae4),
    paddingTop: (0, $7ed2b9d3e2d5bbed$export$958d0ae7f2977ae4),
    right: (0, $7ed2b9d3e2d5bbed$export$632685d741f3dbbf),
    rowGap: (0, $7ed2b9d3e2d5bbed$export$958d0ae7f2977ae4),
    top: (0, $7ed2b9d3e2d5bbed$export$632685d741f3dbbf),
    width: (0, $7ed2b9d3e2d5bbed$export$6ccdbebca2ee545f),
    zIndex: (0, $7ed2b9d3e2d5bbed$export$b5f31a7e431d2eab)
};
var $a778bd8d95c0241c$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $a778bd8d95c0241c$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU.env) === 'object' && false;
};
var $a778bd8d95c0241c$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $a778bd8d95c0241c$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $a778bd8d95c0241c$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($a778bd8d95c0241c$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && $a778bd8d95c0241c$var$safeSelectors.test(key)) {
            styleObj[key] = $a778bd8d95c0241c$var$_transformStyles(value);
            return;
        }
        if ($a778bd8d95c0241c$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($a778bd8d95c0241c$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $a778bd8d95c0241c$export$9a199fbafee0014e)) return;
        var tokenValue = $a778bd8d95c0241c$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $a778bd8d95c0241c$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $a778bd8d95c0241c$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $a778bd8d95c0241c$var$uniqueSymbol, (0, $74Zh5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $a778bd8d95c0241c$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $a778bd8d95c0241c$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $a778bd8d95c0241c$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$a778bd8d95c0241c$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $a778bd8d95c0241c$export$f6c783d06584602c(style) {
    return $a778bd8d95c0241c$var$baseXcss(style);
}


var $b85081f2222b7ed2$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $b85081f2222b7ed2$var$_excluded2 = [
    "className"
];
var $b85081f2222b7ed2$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $b85081f2222b7ed2$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $b85081f2222b7ed2$var$_excluded2);
    var resolvedStyles = (0, $a778bd8d95c0241c$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $b85081f2222b7ed2$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $7ed2b9d3e2d5bbed$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $7ed2b9d3e2d5bbed$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $7ed2b9d3e2d5bbed$export$ff257d957d48c421)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $7ed2b9d3e2d5bbed$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $7ed2b9d3e2d5bbed$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $7ed2b9d3e2d5bbed$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $7ed2b9d3e2d5bbed$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $7ed2b9d3e2d5bbed$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $7ed2b9d3e2d5bbed$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $7ed2b9d3e2d5bbed$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $74Zh5.jsx)((0, $af5fb0353719c780$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $b85081f2222b7ed2$export$2e2bcd8739ae039 = $b85081f2222b7ed2$export$e71c4d32a2263218;
var $b85081f2222b7ed2$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});


/* eslint-disable no-console */ var $5a85a4cfa2a21979$var$printed = {};
function $5a85a4cfa2a21979$export$2e2bcd8739ae039(message) {
    if ($5a85a4cfa2a21979$var$printed[message]) return;
    $5a85a4cfa2a21979$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}



var $3ZMUU = parcelRequire("3ZMUU");
function $5b11e527ca33141e$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $5a85a4cfa2a21979$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $5b11e527ca33141e$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $3ZMUU;
}


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $1e7867c084917b44$export$4b84fd0e2c617bd = '#FFEBE6';
var $1e7867c084917b44$export$b34b069eff244586 = '#FFBDAD';
var $1e7867c084917b44$export$be802dd0d8b57f35 = '#FF8F73';
var $1e7867c084917b44$export$60847d42f9da92a6 = '#FF7452';
var $1e7867c084917b44$export$4a7404f376229999 = '#FF5630';
var $1e7867c084917b44$export$2010d0fb4295b346 = '#DE350B';
var $1e7867c084917b44$export$2837b5a1a71d5c02 = '#BF2600';
var $1e7867c084917b44$export$8d9596b529bbb9cf = '#FFFAE6';
var $1e7867c084917b44$export$41060a744ab0b7ae = '#FFF0B3';
var $1e7867c084917b44$export$1cc05bbbf340e559 = '#FFE380';
var $1e7867c084917b44$export$5aae31392d72caaa = '#FFC400';
var $1e7867c084917b44$export$c6930421db9fa514 = '#FFAB00';
var $1e7867c084917b44$export$59619663aa6500fb = '#FF991F';
var $1e7867c084917b44$export$874739ea9e379ab6 = '#FF8B00';
var $1e7867c084917b44$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $1e7867c084917b44$export$69a3bf21b9686c2b = '#ABF5D1';
var $1e7867c084917b44$export$afbce1382ec95f73 = '#79F2C0';
var $1e7867c084917b44$export$747d86715d4175de = '#57D9A3';
var $1e7867c084917b44$export$940e1f69e873f202 = '#36B37E';
var $1e7867c084917b44$export$a49394138f7b8e85 = '#00875A';
var $1e7867c084917b44$export$6fa04827ac68a4fb = '#006644';
var $1e7867c084917b44$export$226de0355ed012f8 = '#DEEBFF';
var $1e7867c084917b44$export$8c13c2ee36917869 = '#B3D4FF';
var $1e7867c084917b44$export$ecfc1dff386a3e7a = '#4C9AFF';
var $1e7867c084917b44$export$215b7063051591f1 = '#2684FF';
var $1e7867c084917b44$export$e62e8919cca44969 = '#0065FF';
var $1e7867c084917b44$export$b3de0ae08da2ce64 = '#0052CC';
var $1e7867c084917b44$export$a6ee3d71bc067634 = '#0747A6';
var $1e7867c084917b44$export$67f15409e87642a1 = '#669DF1';
var $1e7867c084917b44$export$f0539dbc42dbb067 = '#8FB8F6';
var $1e7867c084917b44$export$363e4475840015bb = '#EAE6FF';
var $1e7867c084917b44$export$4b0a4417ed59760f = '#C0B6F2';
var $1e7867c084917b44$export$6011520a64d9a187 = '#998DD9';
var $1e7867c084917b44$export$a7175d4e9206bc80 = '#8777D9';
var $1e7867c084917b44$export$b48405b95304b5a1 = '#6554C0';
var $1e7867c084917b44$export$c71e4279dd54a18d = '#5243AA';
var $1e7867c084917b44$export$147899de772240ec = '#403294';
var $1e7867c084917b44$export$2cf711fe14c66f06 = '#E6FCFF';
var $1e7867c084917b44$export$7a8f4d33f6f9772c = '#B3F5FF';
var $1e7867c084917b44$export$776c9c497ef08533 = '#79E2F2';
var $1e7867c084917b44$export$69cb3ca10c1e330e = '#00C7E6';
var $1e7867c084917b44$export$9dc1ef0f3f48059b = '#00B8D9';
var $1e7867c084917b44$export$7c835c78b6fcdef8 = '#00A3BF';
var $1e7867c084917b44$export$6036577f95c3877e = '#008DA6';
var $1e7867c084917b44$export$29a4f05edc054374 = '#FFFFFF';
var $1e7867c084917b44$export$e655ef011c4aa1a2 = '#FAFBFC';
var $1e7867c084917b44$export$9fdfb749e33cdf97 = '#F4F5F7';
var $1e7867c084917b44$export$3e51e8f1440314ba = '#EBECF0';
var $1e7867c084917b44$export$1ce2d1575d444ceb = '#DFE1E6';
var $1e7867c084917b44$export$8754fc7e6d8b3000 = '#C1C7D0';
var $1e7867c084917b44$export$c2e91cbeada39b8b = '#B3BAC5';
var $1e7867c084917b44$export$5f71e19f3a7ad9de = '#A5ADBA';
var $1e7867c084917b44$export$eaa8c8a70ac22806 = '#97A0AF';
var $1e7867c084917b44$export$7c87d337fb91a97d = '#8993A4';
var $1e7867c084917b44$export$d6447c357493214f = '#7A869A';
var $1e7867c084917b44$export$f563ee71e9ee74cd = '#6B778C';
var $1e7867c084917b44$export$e2ef2124cf4024b1 = '#5E6C84';
var $1e7867c084917b44$export$eece5f492e429f08 = '#505F79';
var $1e7867c084917b44$export$c39c0fe0f26207ae = '#42526E';
var $1e7867c084917b44$export$7090862dc3038a9f = '#344563';
var $1e7867c084917b44$export$ad0bacf983b7ddaa = '#253858';
var $1e7867c084917b44$export$7d61b15e0da132af = '#172B4D';
var $1e7867c084917b44$export$fbda843f0a27fe96 = '#091E42';
var $1e7867c084917b44$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $1e7867c084917b44$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $1e7867c084917b44$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $1e7867c084917b44$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $1e7867c084917b44$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $1e7867c084917b44$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $1e7867c084917b44$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $1e7867c084917b44$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $1e7867c084917b44$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $1e7867c084917b44$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $1e7867c084917b44$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $1e7867c084917b44$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $1e7867c084917b44$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $1e7867c084917b44$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $1e7867c084917b44$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $1e7867c084917b44$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $1e7867c084917b44$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $1e7867c084917b44$export$2f6319cf7d736c2a = '#E6EDFA';
var $1e7867c084917b44$export$95126bc8884d6634 = '#DCE5F5';
var $1e7867c084917b44$export$8338d8c35d44ff1 = '#CED9EB';
var $1e7867c084917b44$export$5368d76ae4fbbda7 = '#B8C7E0';
var $1e7867c084917b44$export$9f0a771d16ec8d36 = '#ABBBD6';
var $1e7867c084917b44$export$abcf8c38338b4aa5 = '#9FB0CC';
var $1e7867c084917b44$export$97e81faa16a182c7 = '#8C9CB8';
var $1e7867c084917b44$export$bfe21c59123ecf33 = '#7988A3';
var $1e7867c084917b44$export$ee82aa2ea6a1558 = '#67758F';
var $1e7867c084917b44$export$682927c6ed76be02 = '#56637A';
var $1e7867c084917b44$export$91fd9994c5be9757 = '#455166';
var $1e7867c084917b44$export$d281fbfe3cff2df6 = '#3B475C';
var $1e7867c084917b44$export$3902c91d8b98a753 = '#313D52';
var $1e7867c084917b44$export$8e8133c1ba5845b5 = '#283447';
var $1e7867c084917b44$export$33ff357f6620b39 = '#202B3D';
var $1e7867c084917b44$export$633847cf062b69e0 = '#1B2638';
var $1e7867c084917b44$export$9776a6e503bdbf76 = '#121A29';
var $1e7867c084917b44$export$6c813d5160dff5db = '#0E1624';
var $1e7867c084917b44$export$3d4f271a500072a = '#0D1424';
var $1e7867c084917b44$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $1e7867c084917b44$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $1e7867c084917b44$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $1e7867c084917b44$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $1e7867c084917b44$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $1e7867c084917b44$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $1e7867c084917b44$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $1e7867c084917b44$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $1e7867c084917b44$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $1e7867c084917b44$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $1e7867c084917b44$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $1e7867c084917b44$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $1e7867c084917b44$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $1e7867c084917b44$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $1e7867c084917b44$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $1e7867c084917b44$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $1e7867c084917b44$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $1e7867c084917b44$export$d2adc5dedf09fced = '#292A2E';
var $1e7867c084917b44$export$f51762073d2bb381 = '#94C748';
var $1e7867c084917b44$export$95e26d54def96891 = '#B3DF72';


var $9720c021806c6070$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $9720c021806c6070$export$c93026a968943f95 = 'light';
var $9720c021806c6070$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $9720c021806c6070$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $9720c021806c6070$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $9720c021806c6070$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $1e7867c084917b44$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9720c021806c6070$export$6d8204c2cb2e06b8() / 4;
    (0, $5b11e527ca33141e$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $9720c021806c6070$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $9720c021806c6070$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $9720c021806c6070$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $5b11e527ca33141e$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $9720c021806c6070$export$ba1d834b86d72a09 = $9720c021806c6070$export$a1b3edb637fb4f35;
var $9720c021806c6070$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $1e7867c084917b44$export$8d43898f60b96a82), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $1e7867c084917b44$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $1e7867c084917b44$export$920c0d5c49070351), ")")
            }
        }
    };
};



var $fC8ib = parcelRequire("fC8ib");

var $iYJcE = parcelRequire("iYJcE");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");


var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $ad7f39708078c000$var$ESCAPE = 'Escape';
function $ad7f39708078c000$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var _useLayering = $ad7f39708078c000$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $ad7f39708078c000$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $ad7f39708078c000$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $5FkrB.useContext)((0, $e3acb6a69a5c2a02$export$650d12d3c2ddb8fc));
    var _useContext = (0, $5FkrB.useContext)((0, $e3acb6a69a5c2a02$export$48b383b280e20440)), topLevelRef = _useContext.topLevelRef;
    var isLayerDisabled = (0, $5FkrB.useCallback)(function() {
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}








var $5FkrB = parcelRequire("5FkrB");
var $960fa34ed42f37c9$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $5FkrB.useRef)(true);
    (0, $5FkrB.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, children);
};


// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");



var $5a7e41fd797cf10f$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
var $5a7e41fd797cf10f$export$3dee5e4542c672d9 = function isInteractiveElement(element) {
    if ($5a7e41fd797cf10f$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};



var $5FkrB = parcelRequire("5FkrB");
var $ebfd369857d98276$export$641fa9c94086b46e = function useAnimationFrame() {
    var animationsRef = (0, $5FkrB.useRef)([]);
    var requestFrame = (0, $5FkrB.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, $5FkrB.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, $5FkrB.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};


var $50c6008a47f29e36$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, capture = _ref.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useLayering = (0, $ad7f39708078c000$export$c8b4d54e03dee6ed)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    var _useAnimationFrame = (0, $ebfd369857d98276$export$641fa9c94086b46e)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    (0, $5FkrB.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $9fa87a5473741e62$export$2e2bcd8739ae039;
        var inIframe = window && window.self !== window.top && (0, $788343a2280faaa5$export$b40ec24ac8275656)('fix-dropdown-close-outside-iframe');
        var closePopup = function closePopup(event) {
            if (onClose) {
                if ((0, $788343a2280faaa5$export$b40ec24ac8275656)('sibling-dropdown-close-issue')) {
                    var _currentLevel = null;
                    if (event.target instanceof HTMLElement) {
                        var _event$target$closest;
                        _currentLevel = (_event$target$closest = event.target.closest("[data-ds--level]")) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.getAttribute('data-ds--level');
                    }
                    _currentLevel ? onClose(event, Number(_currentLevel)) : onClose(event);
                } else onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $788343a2280faaa5$export$b40ec24ac8275656)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist && !inIframe) return;
            if (isLayerDisabled()) {
                if ((0, $788343a2280faaa5$export$b40ec24ac8275656)('design-system-closed-all-when-click-outside')) {
                    if (target instanceof HTMLElement) {
                        var _target$closest;
                        var layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, "[data-ds--level]");
                        if (layeredElement) {
                            var closeType = layeredElement.getAttribute('[data-ds--close--type]');
                            if (closeType === 'single') // if the close type is single, we won't close other disabled layers when clicking outside
                            return;
                            var levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                            if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                            return;
                        }
                    }
                } else return;
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $5a7e41fd797cf10f$export$3dee5e4542c672d9)(document.activeElement) && (0, $788343a2280faaa5$export$b40ec24ac8275656)('platform_dst_popup-disable-focuslock')) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        var onKeyDown = function onKeyDown(event) {
            if ((0, $788343a2280faaa5$export$b40ec24ac8275656)('platform_dst_popup-disable-focuslock')) {
                var key = event.key, shiftKey = event.shiftKey;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                var _key = event.key;
                if (_key === 'Escape' || _key === 'Esc' || shouldCloseOnTab && _key === 'Tab') closePopup(event);
            }
        };
        var parentUnbind;
        // if the popup is inside iframe, we want to listen to click events outside iframe,
        // to close the popup correctly in the iframe.
        if (inIframe && isOpen) parentUnbind = (0, $7QpUe.bind)(window.parent.window, {
            type: 'click',
            listener: onClick,
            options: {
                capture: capture
            }
        });
        var unbind = (0, $7QpUe.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $9fa87a5473741e62$export$2e2bcd8739ae039);
        unbindBlur = (0, $7QpUe.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            var _parentUnbind;
            cancelAllFrames();
            unbind();
            (_parentUnbind = parentUnbind) === null || _parentUnbind === void 0 || _parentUnbind();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};



var $5FkrB = parcelRequire("5FkrB");

var $b6Hjk = parcelRequire("b6Hjk");




var $eee0e262f8415d37$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, shouldReturnFocus = _ref.shouldReturnFocus, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useAnimationFrame = (0, $ebfd369857d98276$export$641fa9c94086b46e)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var _useLayering = (0, $ad7f39708078c000$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    (0, $5FkrB.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $9fa87a5473741e62$export$2e2bcd8739ae039;
        if (shouldDisableFocusTrap && (0, $788343a2280faaa5$export$b40ec24ac8275656)('platform_dst_popup-disable-focuslock')) {
            var isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            var popups = document.querySelectorAll("[data-ds--level=\"".concat(currentLevel - 1, "\"]"));
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(function() {
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $9fa87a5473741e62$export$2e2bcd8739ae039;
            }
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($b6Hjk)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};


var $1f3ab07ea0952923$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children",
    "appearance",
    "xcss"
];
var $1f3ab07ea0952923$var$fullWidthStyles = (0, $74Zh5.css)({
    width: '100%'
});
var $1f3ab07ea0952923$var$rootStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    display: 'block',
    boxSizing: 'border-box',
    zIndex: (0, $9720c021806c6070$export$7be255094ccdc533).layer(),
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $1e7867c084917b44$export$29a4f05edc054374), ")"),
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat((0, $1e7867c084917b44$export$7d3359664e8bb0e5), ", 0 0 1px ").concat((0, $1e7867c084917b44$export$d2d3bedfb276cac0)), ")"),
    // Resetting text color for portal content.
    // Otherwise, when rendering into the parent (not using a portal),
    // the text color can be inherited from the parent.
    color: "var(--ds-text, #172B4D)"
}, (0, $06459409b22be1ec$export$9d7b58831ae93caa), "var(--ds-surface-overlay, ".concat((0, $1e7867c084917b44$export$29a4f05edc054374), ")")), '&:focus', {
    outline: 'none'
}));
var $1f3ab07ea0952923$var$scrollableStyles = (0, $74Zh5.css)({
    overflow: 'auto'
});
var $1f3ab07ea0952923$var$blanketStyles = (0, $74Zh5.css)({
    position: 'fixed',
    inset: 0,
    backgroundColor: "var(--ds-blanket, #091E427D)"
});
var $1f3ab07ea0952923$var$modalStyles = (0, $74Zh5.css)({
    maxHeight: '50vh',
    position: 'fixed',
    insetBlockStart: "var(--ds-space-050, 4px)",
    insetInline: "var(--ds-space-050, 4px)"
});
var $1f3ab07ea0952923$var$DefaultPopupComponent = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, appearance = props.appearance, xcss = props.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $1f3ab07ea0952923$var$_excluded);
    return (0, $74Zh5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- This rule still fails because of the TS assertion
        className: xcss,
        css: [
            $1f3ab07ea0952923$var$rootStyles,
            appearance === 'UNSAFE_modal-below-sm' && $1f3ab07ea0952923$var$modalStyles,
            !shouldRenderToParent && $1f3ab07ea0952923$var$scrollableStyles,
            shouldFitContainer && $1f3ab07ea0952923$var$fullWidthStyles
        ]
    }, htmlAttributes, {
        ref: ref
    }), children);
});
function $1f3ab07ea0952923$var$PopperWrapper(_ref) {
    var xcss = _ref.xcss, isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $1f3ab07ea0952923$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== 'dialog';
    (0, $eee0e262f8415d37$export$10c5169755ce7bd7)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $50c6008a47f29e36$export$92dae2778ae88f9d)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var _useLayering = (0, $ad7f39708078c000$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    var mergedModifiers = (0, $5FkrB.useMemo)(function() {
        return [
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return (0, $74Zh5.jsx)((0, $735ad51c25367946$export$badac9ada3a0bdf9), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update;
        var popupContainer = (0, $74Zh5.jsx)(PopupContainer, {
            xcss: xcss,
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            style: appearance === 'UNSAFE_modal-below-sm' ? {} : style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer
        }, (0, $74Zh5.jsx)((0, $960fa34ed42f37c9$export$51eddd7655ca235a), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        return !initialFocusRef && (0, $788343a2280faaa5$export$b40ec24ac8275656)('platform-design-system-apply-popup-wrapper-focus') ? (0, $74Zh5.jsx)((0, $5FkrB.Fragment), null, (0, $74Zh5.jsx)((0, $ae7f66a126864790$export$2e2bcd8739ae039), null, popupContainer), appearance === 'UNSAFE_modal-below-sm' && (0, $74Zh5.jsx)("div", {
            css: $1f3ab07ea0952923$var$blanketStyles
        })) : (0, $74Zh5.jsx)((0, $5FkrB.Fragment), null, popupContainer, appearance === 'UNSAFE_modal-below-sm' && (0, $74Zh5.jsx)("div", {
            css: $1f3ab07ea0952923$var$blanketStyles
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1f3ab07ea0952923$export$2e2bcd8739ae039 = $1f3ab07ea0952923$var$PopperWrapper;



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $5FkrB = parcelRequire("5FkrB");
var $d78b2ac07af3d8ce$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);


/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $5f030b1d8b735fd9$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
var $5f030b1d8b735fd9$export$c881183ca713c214 = $5f030b1d8b735fd9$export$987d49ffe1b0900f;


var $55a4058a66dd9cbf$var$_window, $55a4058a66dd9cbf$var$_window$matchMedia, $55a4058a66dd9cbf$var$_window2, $55a4058a66dd9cbf$var$_window2$matchMedia, $55a4058a66dd9cbf$var$_window3, $55a4058a66dd9cbf$var$_window3$matchMedia, $55a4058a66dd9cbf$var$_window4, $55a4058a66dd9cbf$var$_window4$matchMedia, $55a4058a66dd9cbf$var$_window5, $55a4058a66dd9cbf$var$_window5$matchMedia, $55a4058a66dd9cbf$var$_window6, $55a4058a66dd9cbf$var$_window6$matchMedia, $55a4058a66dd9cbf$var$_window7, $55a4058a66dd9cbf$var$_window7$matchMedia, $55a4058a66dd9cbf$var$_window8, $55a4058a66dd9cbf$var$_window8$matchMedia, $55a4058a66dd9cbf$var$_window9, $55a4058a66dd9cbf$var$_window9$matchMedia, $55a4058a66dd9cbf$var$_window10, $55a4058a66dd9cbf$var$_window10$matchMedia, $55a4058a66dd9cbf$var$_window11, $55a4058a66dd9cbf$var$_window11$matchMedia;
var $55a4058a66dd9cbf$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($55a4058a66dd9cbf$var$_window = window) === null || $55a4058a66dd9cbf$var$_window === void 0 || ($55a4058a66dd9cbf$var$_window$matchMedia = $55a4058a66dd9cbf$var$_window.matchMedia) === null || $55a4058a66dd9cbf$var$_window$matchMedia === void 0 ? void 0 : $55a4058a66dd9cbf$var$_window$matchMedia.call($55a4058a66dd9cbf$var$_window, (0, $5f030b1d8b735fd9$export$c881183ca713c214).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($55a4058a66dd9cbf$var$_window2 = window) === null || $55a4058a66dd9cbf$var$_window2 === void 0 || ($55a4058a66dd9cbf$var$_window2$matchMedia = $55a4058a66dd9cbf$var$_window2.matchMedia) === null || $55a4058a66dd9cbf$var$_window2$matchMedia === void 0 ? void 0 : $55a4058a66dd9cbf$var$_window2$matchMedia.call($55a4058a66dd9cbf$var$_window2, (0, $5f030b1d8b735fd9$export$c881183ca713c214).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($55a4058a66dd9cbf$var$_window3 = window) === null || $55a4058a66dd9cbf$var$_window3 === void 0 || ($55a4058a66dd9cbf$var$_window3$matchMedia = $55a4058a66dd9cbf$var$_window3.matchMedia) === null || $55a4058a66dd9cbf$var$_window3$matchMedia === void 0 ? void 0 : $55a4058a66dd9cbf$var$_window3$matchMedia.call($55a4058a66dd9cbf$var$_window3, (0, $5f030b1d8b735fd9$export$c881183ca713c214).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($55a4058a66dd9cbf$var$_window4 = window) === null || $55a4058a66dd9cbf$var$_window4 === void 0 || ($55a4058a66dd9cbf$var$_window4$matchMedia = $55a4058a66dd9cbf$var$_window4.matchMedia) === null || $55a4058a66dd9cbf$var$_window4$matchMedia === void 0 ? void 0 : $55a4058a66dd9cbf$var$_window4$matchMedia.call($55a4058a66dd9cbf$var$_window4, (0, $5f030b1d8b735fd9$export$c881183ca713c214).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($55a4058a66dd9cbf$var$_window5 = window) === null || $55a4058a66dd9cbf$var$_window5 === void 0 || ($55a4058a66dd9cbf$var$_window5$matchMedia = $55a4058a66dd9cbf$var$_window5.matchMedia) === null || $55a4058a66dd9cbf$var$_window5$matchMedia === void 0 ? void 0 : $55a4058a66dd9cbf$var$_window5$matchMedia.call($55a4058a66dd9cbf$var$_window5, (0, $5f030b1d8b735fd9$export$c881183ca713c214).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($55a4058a66dd9cbf$var$_window6 = window) === null || $55a4058a66dd9cbf$var$_window6 === void 0 || ($55a4058a66dd9cbf$var$_window6$matchMedia = $55a4058a66dd9cbf$var$_window6.matchMedia) === null || $55a4058a66dd9cbf$var$_window6$matchMedia === void 0 ? void 0 : $55a4058a66dd9cbf$var$_window6$matchMedia.call($55a4058a66dd9cbf$var$_window6, (0, $5f030b1d8b735fd9$export$c881183ca713c214).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($55a4058a66dd9cbf$var$_window7 = window) === null || $55a4058a66dd9cbf$var$_window7 === void 0 || ($55a4058a66dd9cbf$var$_window7$matchMedia = $55a4058a66dd9cbf$var$_window7.matchMedia) === null || $55a4058a66dd9cbf$var$_window7$matchMedia === void 0 ? void 0 : $55a4058a66dd9cbf$var$_window7$matchMedia.call($55a4058a66dd9cbf$var$_window7, (0, $5f030b1d8b735fd9$export$c881183ca713c214).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($55a4058a66dd9cbf$var$_window8 = window) === null || $55a4058a66dd9cbf$var$_window8 === void 0 || ($55a4058a66dd9cbf$var$_window8$matchMedia = $55a4058a66dd9cbf$var$_window8.matchMedia) === null || $55a4058a66dd9cbf$var$_window8$matchMedia === void 0 ? void 0 : $55a4058a66dd9cbf$var$_window8$matchMedia.call($55a4058a66dd9cbf$var$_window8, (0, $5f030b1d8b735fd9$export$c881183ca713c214).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($55a4058a66dd9cbf$var$_window9 = window) === null || $55a4058a66dd9cbf$var$_window9 === void 0 || ($55a4058a66dd9cbf$var$_window9$matchMedia = $55a4058a66dd9cbf$var$_window9.matchMedia) === null || $55a4058a66dd9cbf$var$_window9$matchMedia === void 0 ? void 0 : $55a4058a66dd9cbf$var$_window9$matchMedia.call($55a4058a66dd9cbf$var$_window9, (0, $5f030b1d8b735fd9$export$c881183ca713c214).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($55a4058a66dd9cbf$var$_window10 = window) === null || $55a4058a66dd9cbf$var$_window10 === void 0 || ($55a4058a66dd9cbf$var$_window10$matchMedia = $55a4058a66dd9cbf$var$_window10.matchMedia) === null || $55a4058a66dd9cbf$var$_window10$matchMedia === void 0 ? void 0 : $55a4058a66dd9cbf$var$_window10$matchMedia.call($55a4058a66dd9cbf$var$_window10, (0, $5f030b1d8b735fd9$export$c881183ca713c214).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($55a4058a66dd9cbf$var$_window11 = window) === null || $55a4058a66dd9cbf$var$_window11 === void 0 || ($55a4058a66dd9cbf$var$_window11$matchMedia = $55a4058a66dd9cbf$var$_window11.matchMedia) === null || $55a4058a66dd9cbf$var$_window11$matchMedia === void 0 ? void 0 : $55a4058a66dd9cbf$var$_window11$matchMedia.call($55a4058a66dd9cbf$var$_window11, (0, $5f030b1d8b735fd9$export$c881183ca713c214).below.xl.replace('@media ', '').trim())
};
var $55a4058a66dd9cbf$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $5FkrB.useRef)(listener);
    (0, $5FkrB.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $55a4058a66dd9cbf$var$queries[queryString];
    (0, $d78b2ac07af3d8ce$export$e5c5a5f917a5871c)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $7QpUe.bind)(mq, {
            type: 'change',
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};


function $8529f9ff688eb2d1$export$4065aef1d79a5730(_ref) {
    var _appearance = _ref.appearance, _shouldRenderToParent = _ref.shouldRenderToParent;
    var mq = (0, $55a4058a66dd9cbf$export$49e55ae2c03d6045)('below.sm', function(e) {
        setIsSmallViewport(!!e.matches);
    });
    var _useState = (0, $5FkrB.useState)(!!(mq !== null && mq !== void 0 && mq.matches)), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSmallViewport = _useState2[0], setIsSmallViewport = _useState2[1];
    var appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    var shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $cvlyC = parcelRequire("cvlyC");
var $183b479241577f51$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $5FkrB.useState)(function() {
        return (0, $cvlyC.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $cvlyC = parcelRequire("cvlyC");
var $5cf59a3cad0a0511$export$5d3a2de79e07b376 = function useGetMemoizedMergedTriggerRefNew() {
    var _useState = (0, $5FkrB.useState)(function() {
        return (0, $cvlyC.default)(function(ref, setTriggerRef) {
            return function(node) {
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 1), getMemoizedMergedTriggerRefNew = _useState2[0];
    return getMemoizedMergedTriggerRefNew;
};


var $795af8cc670a1c69$var$defaultLayer = (0, $9720c021806c6070$export$7be255094ccdc533).layer();
var $795af8cc670a1c69$var$wrapperStyles = (0, $a778bd8d95c0241c$export$f6c783d06584602c)({
    position: 'relative'
});
var $795af8cc670a1c69$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var xcss = _ref.xcss, _ref$appearance = _ref.appearance, inAppearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, isOpen = _ref.isOpen, providedId = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? 'viewport' : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $795af8cc670a1c69$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, inShouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldDisableFoc = _ref.shouldDisableFocusLock, shouldDisableFocusLock = _ref$shouldDisableFoc === void 0 ? false : _ref$shouldDisableFoc, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $183b479241577f51$export$7cc5c058dd769dff)();
    var getMergedTriggerRefNew = (0, $5cf59a3cad0a0511$export$5d3a2de79e07b376)();
    var generatedId = (0, $ae9fa784eacafcd8$export$f680877a34711e37)();
    var _usePopupAppearance = (0, $8529f9ff688eb2d1$export$4065aef1d79a5730)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    }), appearance = _usePopupAppearance.appearance, shouldRenderToParent = _usePopupAppearance.shouldRenderToParent;
    var id = providedId || generatedId;
    (0, $16baedc850e7aff3$export$469bb693f11edc7f)({
        isOpen: isOpen
    });
    var renderPopperWrapper = (0, $74Zh5.jsx)((0, $e3acb6a69a5c2a02$export$7c885f891c940977), {
        isDisabled: false
    }, (0, $74Zh5.jsx)((0, $1f3ab07ea0952923$export$2e2bcd8739ae039), {
        xcss: xcss,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        strategy: shouldFitContainer ? 'absolute' : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    var popupContent = (0, $74Zh5.jsx)((0, $hvYLl.Manager), null, (0, $74Zh5.jsx)((0, $agyC9.Reference), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: !(0, $788343a2280faaa5$export$b40ec24ac8275656)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            'aria-controls': isOpen ? id : undefined,
            'aria-expanded': isOpen,
            'aria-haspopup': role === 'dialog' && (0, $788343a2280faaa5$export$b40ec24ac8275656)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
        });
    }), isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : (0, $74Zh5.jsx)((0, $3abdb7aea1ec0147$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, renderPopperWrapper)));
    if (shouldFitContainer) return (0, $74Zh5.jsx)((0, $b85081f2222b7ed2$export$2e2bcd8739ae039), {
        xcss: $795af8cc670a1c69$var$wrapperStyles
    }, popupContent);
    return popupContent;
});
var $795af8cc670a1c69$export$2e2bcd8739ae039 = $795af8cc670a1c69$export$129a32eedafa97c5;


var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b36bab92079a30f2$export$2e2bcd8739ae039 = (0, $795af8cc670a1c69$export$129a32eedafa97c5);


/* eslint-disable no-console */ var $51ab6b853d704d00$var$printed = {};
function $51ab6b853d704d00$export$2e2bcd8739ae039(message) {
    if ($51ab6b853d704d00$var$printed[message]) return;
    $51ab6b853d704d00$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}



var $3ZMUU = parcelRequire("3ZMUU");
function $fec3bc1e5d746c60$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $51ab6b853d704d00$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $fec3bc1e5d746c60$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $3ZMUU;
}



var $10b83e40731cc155$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $10b83e40731cc155$export$c93026a968943f95 = 'light';
var $10b83e40731cc155$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $10b83e40731cc155$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $10b83e40731cc155$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $10b83e40731cc155$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $d879fc455f6e75a0$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $10b83e40731cc155$export$6d8204c2cb2e06b8() / 4;
    (0, $fec3bc1e5d746c60$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $10b83e40731cc155$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $10b83e40731cc155$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $10b83e40731cc155$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $fec3bc1e5d746c60$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $10b83e40731cc155$export$ba1d834b86d72a09 = $10b83e40731cc155$export$a1b3edb637fb4f35;
var $10b83e40731cc155$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $d879fc455f6e75a0$export$8d43898f60b96a82), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $d879fc455f6e75a0$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $d879fc455f6e75a0$export$920c0d5c49070351), ")")
            }
        }
    };
};



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");


var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $5FkrB = parcelRequire("5FkrB");

var $5be177ba607b9a5f$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $5FkrB.createContext)(0);
var $5be177ba607b9a5f$export$48b383b280e20440 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $3a341012e037de4f$export$2e2bcd8739ae039)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $5be177ba607b9a5f$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $5FkrB.useContext)($5be177ba607b9a5f$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel, topLevelRef = _useContext.topLevelRef;
    if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            // avoid immediate cleanup using setTimeout when component unmount
            // this will make sure non-top layer components can get the correct top level value
            // when multiple layers trigger onClose in sequence
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($5be177ba607b9a5f$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $5be177ba607b9a5f$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $5FkrB.useRef)(0);
    var value = (0, $5FkrB.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($5be177ba607b9a5f$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $5be177ba607b9a5f$export$7c885f891c940977 = function Layering(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $5FkrB.useContext)($5be177ba607b9a5f$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($5be177ba607b9a5f$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($5be177ba607b9a5f$var$LayeringProvider, null, content);
};


var $88efd4caf07ed116$var$ESCAPE = 'Escape';
function $88efd4caf07ed116$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var _useLayering = $88efd4caf07ed116$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $88efd4caf07ed116$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $88efd4caf07ed116$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $5FkrB.useContext)((0, $5be177ba607b9a5f$export$650d12d3c2ddb8fc));
    var _useContext = (0, $5FkrB.useContext)((0, $5be177ba607b9a5f$export$48b383b280e20440)), topLevelRef = _useContext.topLevelRef;
    var isLayerDisabled = (0, $5FkrB.useCallback)(function() {
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}



var $25nEq = parcelRequire("25nEq");


var $dVGJk = parcelRequire("dVGJk");

var $ddd3993c923b373a$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $ddd3993c923b373a$export$2e2bcd8739ae039() {
    var id = (0, $24526c38f36cc756$export$f680877a34711e37)();
    return "".concat($ddd3993c923b373a$export$8a682ae47622dbb9).concat(id);
}


var $53c800e14611e521$var$actionMap = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $e27a1598a26ffda3$export$a80636c6f41931fe), 'next'), (0, $e27a1598a26ffda3$export$390330c10ff2b9a1), 'prev'), (0, $e27a1598a26ffda3$export$4af703091671bc), 'first'), (0, $e27a1598a26ffda3$export$e2bc30913faa5db7), 'last');
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ var $53c800e14611e521$var$getNextFocusableElement = function getNextFocusableElement(refs, currentFocusedIdx) {
    while(currentFocusedIdx + 1 < refs.length){
        var element = refs[++currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ var $53c800e14611e521$var$getPrevFocusableElement = function getPrevFocusableElement(refs, currentFocusedIdx) {
    while(currentFocusedIdx > 0){
        var element = refs[--currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
};
function $53c800e14611e521$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return function(e) {
        var _refs$current;
        var currentRefs = (_refs$current = refs.current) !== null && _refs$current !== void 0 ? _refs$current : [];
        var currentFocusedIdx = currentRefs.findIndex(function(_ref) {
            var _document$activeEleme;
            var el = _ref.current;
            return el && ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el));
        });
        if ((0, $dVGJk.fg)('platform_dst_popup-disable-focuslock')) {
            var _document$activeEleme2;
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            var isNestedDropdown = !!((_document$activeEleme2 = document.activeElement) !== null && _document$activeEleme2 !== void 0 && _document$activeEleme2.closest("[id^=".concat((0, $ddd3993c923b373a$export$8a682ae47622dbb9), "]")));
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $e27a1598a26ffda3$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $e27a1598a26ffda3$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        var action = $53c800e14611e521$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < currentRefs.length - 1) {
                    var _nextFocusableElement = $53c800e14611e521$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                    _nextFocusableElement === null || _nextFocusableElement === void 0 || _nextFocusableElement.focus();
                } else {
                    var firstFocusableElement = $53c800e14611e521$var$getNextFocusableElement(currentRefs, -1);
                    firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    var _prevFocusableElement = $53c800e14611e521$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                    _prevFocusableElement === null || _prevFocusableElement === void 0 || _prevFocusableElement.focus();
                } else {
                    var lastFocusableElement = $53c800e14611e521$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                    lastFocusableElement === null || lastFocusableElement === void 0 || lastFocusableElement.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                var nextFocusableElement = $53c800e14611e521$var$getNextFocusableElement(currentRefs, -1);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                var prevFocusableElement = $53c800e14611e521$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}


var $732d8fed4cea8f22$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    menuItemRefs: [],
    registerRef: (0, $3a341012e037de4f$export$2e2bcd8739ae039)
});
/**
 * Focus manager logic.
 */ var $732d8fed4cea8f22$var$FocusManager = function FocusManager(_ref) {
    var children = _ref.children, onClose = _ref.onClose;
    var menuItemRefs = (0, $5FkrB.useRef)([]);
    // Used to force a re-render only
    var _useState = (0, $5FkrB.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), refresh = _useState2[0], setRefresh = _useState2[1];
    var registerMode = (0, $5FkrB.useRef)('ordered');
    registerMode.current = 'ordered';
    var registerRef = (0, $5FkrB.useCallback)(function(ref) {
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error("Unexpected case of ".concat(registerMode.current));
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    var _useLayering = (0, $88efd4caf07ed116$export$c8b4d54e03dee6ed)(), isLayerDisabled = _useLayering.isLayerDisabled;
    // Intentionally rebinding on each render
    (0, $5FkrB.useEffect)(function() {
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bind)(window, {
            type: 'keydown',
            listener: (0, $53c800e14611e521$export$2e2bcd8739ae039)(menuItemRefs, isLayerDisabled, onClose)
        });
    }, [
        isLayerDisabled,
        onClose
    ]);
    var contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($732d8fed4cea8f22$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $732d8fed4cea8f22$export$2e2bcd8739ae039 = $732d8fed4cea8f22$var$FocusManager;


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $74Zh5 = parcelRequire("74Zh5");

var $5FkrB = parcelRequire("5FkrB");
var $029784b0740265a3$export$443076ec7ebce042 = /*#__PURE__*/ (0, $5FkrB.createContext)('cozy');
var $029784b0740265a3$export$9ca534b70725964d = /*#__PURE__*/ (0, $5FkrB.createContext)('border');


var $4dd7739ff03cb484$var$_excluded = [
    "isLoading",
    "maxWidth",
    "minWidth",
    "minHeight",
    "maxHeight",
    "testId",
    "role",
    "spacing",
    "className"
];
var $4dd7739ff03cb484$var$baseStyles = (0, $74Zh5.css)({
    display: 'flex',
    position: 'static',
    flexDirection: 'column',
    overflow: 'auto'
});
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $4dd7739ff03cb484$var$MenuGroup = function MenuGroup(_ref) {
    var isLoading = _ref.isLoading, maxWidth = _ref.maxWidth, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, testId = _ref.testId, role = _ref.role, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'cozy' : _ref$spacing, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $4dd7739ff03cb484$var$_excluded);
    return (0, $74Zh5.jsx)((0, $029784b0740265a3$export$443076ec7ebce042).Provider, {
        value: spacing
    }, (0, $74Zh5.jsx)((0, $029784b0740265a3$export$9ca534b70725964d).Provider, {
        value: "border"
    }, (0, $74Zh5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        css: $4dd7739ff03cb484$var$baseStyles,
        "data-testid": testId,
        role: role,
        className: UNSAFE_className
    }, rest))));
};
var $4dd7739ff03cb484$export$2e2bcd8739ae039 = $4dd7739ff03cb484$var$MenuGroup;




function $8a07363b08703372$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}


function $f60049cc6bf61b68$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}



var $60be549fc44af1f1$var$spinnerContainerStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
var $60be549fc44af1f1$var$LoadingIndicator = function LoadingIndicator(_ref) {
    var _ref$statusLabel = _ref.statusLabel, statusLabel = _ref$statusLabel === void 0 ? 'Loading' : _ref$statusLabel, testId = _ref.testId;
    return (0, $74Zh5.jsx)((0, $d007f17589e0f9b9$export$2e2bcd8739ae039), {
        xcss: $60be549fc44af1f1$var$spinnerContainerStyles
    }, (0, $74Zh5.jsx)((0, $cd099e806837dee6$export$2e2bcd8739ae039), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
};
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ var $60be549fc44af1f1$var$MenuWrapper = function MenuWrapper(_ref2) {
    var children = _ref2.children, isLoading = _ref2.isLoading, maxHeight = _ref2.maxHeight, maxWidth = _ref2.maxWidth, onClose = _ref2.onClose, onUpdate = _ref2.onUpdate, statusLabel = _ref2.statusLabel, setInitialFocusRef = _ref2.setInitialFocusRef, shouldRenderToParent = _ref2.shouldRenderToParent, spacing = _ref2.spacing, testId = _ref2.testId, isTriggeredUsingKeyboard = _ref2.isTriggeredUsingKeyboard, autoFocus = _ref2.autoFocus;
    var _useContext = (0, $5FkrB.useContext)((0, $732d8fed4cea8f22$export$f18c1d4fc7326096)), menuItemRefs = _useContext.menuItemRefs;
    var closeOnMenuItemClick = function closeOnMenuItemClick(e) {
        var isTargetMenuItemOrDescendant = menuItemRefs.some(function(menuItemRef) {
            var menuItem = menuItemRef.current;
            if (!menuItem) return false;
            var isCheckboxOrRadio = (0, $8a07363b08703372$export$2e2bcd8739ae039)(menuItem) || (0, $f60049cc6bf61b68$export$2e2bcd8739ae039)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $5FkrB.useLayoutEffect)(function() {
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $5FkrB.useEffect)(function() {
        var _menuItemRefs$map$fin;
        var firstFocusableRef = (_menuItemRefs$map$fin = menuItemRefs.map(function(_ref3) {
            var current = _ref3.current;
            return current;
        }).find(function(el) {
            return !!el && !el.hasAttribute('disabled');
        })) !== null && _menuItemRefs$map$fin !== void 0 ? _menuItemRefs$map$fin : null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef === null || firstFocusableRef === void 0 || firstFocusableRef.focus();
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return (0, $74Zh5.jsx)((0, $4dd7739ff03cb484$export$2e2bcd8739ae039), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && "".concat(testId, "--menu-group")
    }, isLoading ? (0, $74Zh5.jsx)($60be549fc44af1f1$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && "".concat(testId, "--loading-indicator")
    }) : children);
};
var $60be549fc44af1f1$export$2e2bcd8739ae039 = $60be549fc44af1f1$var$MenuWrapper;



var $5FkrB = parcelRequire("5FkrB");

var $6c8d7d354dcb5a30$export$756f795847463ebd = /*#__PURE__*/ (0, $5FkrB.createContext)({
    setItemState: (0, $3a341012e037de4f$export$2e2bcd8739ae039),
    getItemState: function getItemState() {
        return undefined;
    },
    setGroupState: (0, $3a341012e037de4f$export$2e2bcd8739ae039),
    getGroupState: function getGroupState() {
        return {};
    }
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ var $6c8d7d354dcb5a30$var$SelectionStore = function SelectionStore(props) {
    var children = props.children;
    var store = (0, $5FkrB.useRef)({});
    var context = (0, $5FkrB.useMemo)(function() {
        return {
            setItemState: function setItemState(group, id, value) {
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: function getItemState(group, id) {
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: function setGroupState(group, value) {
                store.current[group] = value;
            },
            getGroupState: function getGroupState(group) {
                return store.current[group] || {};
            }
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($6c8d7d354dcb5a30$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $6c8d7d354dcb5a30$export$2e2bcd8739ae039 = $6c8d7d354dcb5a30$var$SelectionStore;



var $5FkrB = parcelRequire("5FkrB");

var $dVGJk = parcelRequire("dVGJk");

// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $342103062545c958$var$useRegisterItemWithFocusManager() {
    var hasPopup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _useContext = (0, $5FkrB.useContext)((0, $732d8fed4cea8f22$export$f18c1d4fc7326096)), registerRef = _useContext.registerRef;
    var itemRef = (0, $5FkrB.useRef)(null);
    (0, $5FkrB.useEffect)(function() {
        if (hasPopup && (0, $dVGJk.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $342103062545c958$export$2e2bcd8739ae039 = $342103062545c958$var$useRegisterItemWithFocusManager;



var $9e29898158274f39$var$_excluded = [
    "ref",
    "aria-controls",
    "aria-expanded",
    "aria-haspopup"
];
function $9e29898158274f39$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9e29898158274f39$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9e29898158274f39$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9e29898158274f39$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9e29898158274f39$var$gridSize = (0, $10b83e40731cc155$export$6d8204c2cb2e06b8)();
var $9e29898158274f39$var$MAX_HEIGHT = "calc(100vh - ".concat($9e29898158274f39$var$gridSize * 2, "px)");
var $9e29898158274f39$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
var $9e29898158274f39$var$getFallbackPlacements = function getFallbackPlacements(placement) {
    var placementPieces = placement.split('-');
    var mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        var crossAxis = placementPieces[1];
        return [
            "".concat(mainAxis),
            "".concat(mainAxis, "-").concat($9e29898158274f39$var$opposites[crossAxis]),
            "".concat($9e29898158274f39$var$opposites[mainAxis], "-").concat(crossAxis),
            "".concat($9e29898158274f39$var$opposites[mainAxis]),
            "".concat($9e29898158274f39$var$opposites[mainAxis], "-").concat($9e29898158274f39$var$opposites[crossAxis]),
            'auto'
        ];
    } else return [
        "".concat(mainAxis, "-start"),
        "".concat(mainAxis, "-end"),
        "".concat($9e29898158274f39$var$opposites[mainAxis]),
        "".concat($9e29898158274f39$var$opposites[mainAxis], "-start"),
        "".concat($9e29898158274f39$var$opposites[mainAxis], "-end"),
        "auto"
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ var $9e29898158274f39$var$DropdownMenu = function DropdownMenu(_ref) {
    var _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, _ref$defaultOpen = _ref.defaultOpen, defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isOpen = _ref.isOpen, _ref$onOpenChange = _ref.onOpenChange, onOpenChange = _ref$onOpenChange === void 0 ? (0, $3a341012e037de4f$export$2e2bcd8739ae039) : _ref$onOpenChange, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, returnFocusRef = _ref.returnFocusRef, spacing = _ref.spacing, statusLabel = _ref.statusLabel, testId = _ref.testId, _trigger = _ref.trigger, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? (0, $10b83e40731cc155$export$7be255094ccdc533).modal() : _ref$zIndex, label = _ref.label, interactionName = _ref.interactionName, strategy = _ref.strategy;
    var _useControlledState = (0, $f4d287be7eb5fb6d$export$2e2bcd8739ae039)(isOpen, function() {
        return defaultOpen;
    }), _useControlledState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useControlledState, 2), isLocalOpen = _useControlledState2[0], setLocalIsOpen = _useControlledState2[1];
    var triggerRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isTriggeredUsingKeyboard = _useState2[0], setTriggeredUsingKeyboard = _useState2[1];
    var id = (0, $ddd3993c923b373a$export$2e2bcd8739ae039)();
    var itemRef = (0, $342103062545c958$export$2e2bcd8739ae039)();
    var fallbackPlacements = (0, $5FkrB.useMemo)(function() {
        return $9e29898158274f39$var$getFallbackPlacements(placement);
    }, [
        placement
    ]);
    var handleTriggerClicked = (0, $5FkrB.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    function(event) {
        var newValue = !isLocalOpen;
        var clientX = event.clientX, clientY = event.clientY, type = event.type, detail = event.detail;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            var _itemRef$current;
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef === null || itemRef === void 0 || (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || _itemRef$current.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    var handleOnClose = (0, $5FkrB.useCallback)(function(event, currentLevel) {
        var _event$target, _event$target$closest;
        if (event.key !== 'Escape' && event.key !== 'Tab' && (_event$target = event.target) !== null && _event$target !== void 0 && (_event$target$closest = _event$target.closest) !== null && _event$target$closest !== void 0 && _event$target$closest.call(_event$target, "[id^=".concat((0, $ddd3993c923b373a$export$8a682ae47622dbb9), "] [aria-haspopup]"))) {
            var _itemRef$current2;
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            var toCloseLevel = (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 ? void 0 : _itemRef$current2.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(function() {
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        else if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(function() {
            var _itemRef$current3;
            (_itemRef$current3 = itemRef.current) === null || _itemRef$current3 === void 0 || _itemRef$current3.focus();
        });
        else if (triggerRef.current) requestAnimationFrame(function() {
            var _triggerRef$current;
            (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || _triggerRef$current.focus();
        });
        var newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    var _useFocus = (0, $7632941312f4921f$export$2e2bcd8739ae039)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $5FkrB.useEffect)(function() {
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $3a341012e037de4f$export$2e2bcd8739ae039;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $3a341012e037de4f$export$2e2bcd8739ae039;
        return (0, $7QpUe.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                var isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest("[id^=".concat((0, $ddd3993c923b373a$export$8a682ae47622dbb9), "] [aria-haspopup]"));
                if (e.key === (0, $e27a1598a26ffda3$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $e27a1598a26ffda3$export$e51a3576c045c8d5) || e.key === (0, $e27a1598a26ffda3$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $e27a1598a26ffda3$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ var conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6c8d7d354dcb5a30$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b36bab92079a30f2$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
        // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
        returnFocusRef === undefined,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && "".concat(testId, "--content"),
        shouldUseCaptureOnOutsideClick: true
    }, conditionalProps, {
        shouldDisableFocusLock: true,
        trigger: function trigger(_ref2) {
            var ref = _ref2.ref, ariaControls = _ref2['aria-controls'], ariaExpanded = _ref2['aria-expanded'], ariaHasPopup = _ref2['aria-haspopup'], rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $9e29898158274f39$var$_excluded);
            if (typeof _trigger === 'function') return _trigger($9e29898158274f39$var$_objectSpread($9e29898158274f39$var$_objectSpread($9e29898158274f39$var$_objectSpread({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup
            }, rest), bindFocus), {}, {
                triggerRef: (0, $0d2a37110e22a1c9$export$2e2bcd8739ae039)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger")
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1fa2d718d507adf5$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, bindFocus, {
                ref: (0, $0d2a37110e22a1c9$export$2e2bcd8739ae039)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($c21b397a5a41009b$exports))),
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger"),
                "aria-label": label
            }, (0, $dVGJk.fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            }), _trigger);
        },
        content: function content(_ref3) {
            var setInitialFocusRef = _ref3.setInitialFocusRef, update = _ref3.update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $732d8fed4cea8f22$export$2e2bcd8739ae039), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $60be549fc44af1f1$export$2e2bcd8739ae039), {
                spacing: spacing,
                maxHeight: $9e29898158274f39$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && "".concat(testId, "--menu-wrapper")
            }, children));
        }
    })));
};
var $9e29898158274f39$export$2e2bcd8739ae039 = $9e29898158274f39$var$DropdownMenu;


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
/* eslint-disable no-console */ var $ae3cc759f1e5ecdb$var$printed = {};
function $ae3cc759f1e5ecdb$export$2e2bcd8739ae039(message) {
    if ($ae3cc759f1e5ecdb$var$printed[message]) return;
    $ae3cc759f1e5ecdb$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}



var $3ZMUU = parcelRequire("3ZMUU");
function $c6f574dac5b81c12$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $ae3cc759f1e5ecdb$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $c6f574dac5b81c12$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $3ZMUU;
}


/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $f2ed9a22761e3cb5$export$2e2bcd8739ae039() {}



var $5FkrB = parcelRequire("5FkrB");
var $1d30d2a862a7a995$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);



var $9dOvm = parcelRequire("9dOvm");
var $814ffcb26346402f$var$_process, $814ffcb26346402f$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $814ffcb26346402f$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($814ffcb26346402f$var$_process = globalThis.process) === null || $814ffcb26346402f$var$_process === void 0 || ($814ffcb26346402f$var$_process = $814ffcb26346402f$var$_process.env) === null || $814ffcb26346402f$var$_process === void 0 ? void 0 : $814ffcb26346402f$var$_process.JEST_WORKER_ID) !== undefined;
var $814ffcb26346402f$var$DEBUG_MODE = !$814ffcb26346402f$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($814ffcb26346402f$var$_process2 = globalThis.process) === null || $814ffcb26346402f$var$_process2 === void 0 || ($814ffcb26346402f$var$_process2 = $814ffcb26346402f$var$_process2.env) === null || $814ffcb26346402f$var$_process2 === void 0 ? void 0 : $814ffcb26346402f$var$_process2.NODE_ENV) !== 'production';
var $814ffcb26346402f$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$814ffcb26346402f$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $274d81f2ac1d961f$var$pkgName = '@atlaskit/platform-feature-flags';
var $274d81f2ac1d961f$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $274d81f2ac1d961f$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $274d81f2ac1d961f$var$ENV_ENABLE_PLATFORM_FF = $274d81f2ac1d961f$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $274d81f2ac1d961f$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $274d81f2ac1d961f$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $274d81f2ac1d961f$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $274d81f2ac1d961f$var$ENV_ENABLE_PLATFORM_FF || $274d81f2ac1d961f$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $274d81f2ac1d961f$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $274d81f2ac1d961f$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$274d81f2ac1d961f$var$globalVar[$274d81f2ac1d961f$export$7e41b1b2bdee3f98] = $274d81f2ac1d961f$var$globalVar[$274d81f2ac1d961f$export$7e41b1b2bdee3f98] || $274d81f2ac1d961f$var$DEFAULT_PFF_GLOBAL;
function $274d81f2ac1d961f$export$f2b591175b3e424c(resolver) {
    $274d81f2ac1d961f$var$globalVar[$274d81f2ac1d961f$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $274d81f2ac1d961f$export$6333b6aff9fc6275(flagKey) {
    if ($274d81f2ac1d961f$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $814ffcb26346402f$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $274d81f2ac1d961f$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $274d81f2ac1d961f$var$globalVar[$274d81f2ac1d961f$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $274d81f2ac1d961f$var$globalVar[$274d81f2ac1d961f$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $9dOvm.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $274d81f2ac1d961f$var$globalVar[$274d81f2ac1d961f$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $c981c2489638862d$export$ba05d765b8392e5e(flagResolver) {
    (0, $274d81f2ac1d961f$export$f2b591175b3e424c)(flagResolver);
}
function $c981c2489638862d$export$470e5c2be1411c89(name) {
    return (0, $274d81f2ac1d961f$export$6333b6aff9fc6275)(name);
}
function $c981c2489638862d$export$b40ec24ac8275656(name) {
    return (0, $274d81f2ac1d961f$export$6333b6aff9fc6275)(name);
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");



var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $74Zh5 = parcelRequire("74Zh5");

var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");
var $dcc0f48710161fe0$export$4ef52930e33717cd = 'data-theme';
var $dcc0f48710161fe0$export$a00eac3f8684bcd0 = 'data-color-mode';
var $dcc0f48710161fe0$export$2112803007239c61 = 'data-contrast-mode';
var $dcc0f48710161fe0$export$352e418ed5b6193a = 'data-custom-theme';
var $dcc0f48710161fe0$export$2faeed762aac6741 = 'light';
var $dcc0f48710161fe0$export$6f0c6fb8c80fcc92 = 'ds';
var $dcc0f48710161fe0$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $dcc0f48710161fe0$export$dddac1532e822863 = "--".concat($dcc0f48710161fe0$export$6f0c6fb8c80fcc92, "-token-not-found");
var $dcc0f48710161fe0$export$9d7b58831ae93caa = "--".concat($dcc0f48710161fe0$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $9e847408f5b72379$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9e847408f5b72379$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9e847408f5b72379$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9e847408f5b72379$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9e847408f5b72379$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $9e847408f5b72379$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $9e847408f5b72379$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $9e847408f5b72379$export$632685d741f3dbbf = $9e847408f5b72379$var$_objectSpread($9e847408f5b72379$var$_objectSpread({}, $9e847408f5b72379$export$958d0ae7f2977ae4), $9e847408f5b72379$export$d2dc61f58390201c);
var $9e847408f5b72379$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $9e847408f5b72379$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $9e847408f5b72379$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $9e847408f5b72379$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $9e847408f5b72379$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $9e847408f5b72379$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $9e847408f5b72379$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $9e847408f5b72379$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $9e847408f5b72379$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $9e847408f5b72379$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $9e847408f5b72379$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $9e847408f5b72379$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $9e847408f5b72379$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $9e847408f5b72379$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $9e847408f5b72379$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $9e847408f5b72379$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $9e847408f5b72379$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $9e847408f5b72379$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $9e847408f5b72379$export$e615f061ca585a6c = $9e847408f5b72379$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $9e847408f5b72379$export$ca0f9c2de39ffed7(spacingProperty, $9e847408f5b72379$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $9e847408f5b72379$export$bf46c3f9eeafc71f = $9e847408f5b72379$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $9e847408f5b72379$export$ca0f9c2de39ffed7(spacingProperty, $9e847408f5b72379$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $9e847408f5b72379$export$e7af83bafe7f9e63 = $9e847408f5b72379$export$ca0f9c2de39ffed7('backgroundColor', $9e847408f5b72379$export$d1d79bf68ac056bd);
var $9e847408f5b72379$export$3a1bcba60b23d7f0 = $9e847408f5b72379$export$ca0f9c2de39ffed7('color', $9e847408f5b72379$export$8473307aa00d6ea1);
var $9e847408f5b72379$export$45f3f4fe16f9f7d5 = $9e847408f5b72379$export$ca0f9c2de39ffed7('fontWeight', $9e847408f5b72379$export$303e322c6b1ed114);
var $9e847408f5b72379$export$68cc305da27dbaa4 = $9e847408f5b72379$export$ca0f9c2de39ffed7('fontFamily', $9e847408f5b72379$export$3c7e9587132614b4);
var $9e847408f5b72379$export$128f10c238242f83 = $9e847408f5b72379$export$ca0f9c2de39ffed7('font', $9e847408f5b72379$export$6ffa317d5e70375);
var $9e847408f5b72379$export$219d364c0da35ae4 = $9e847408f5b72379$export$ca0f9c2de39ffed7('font', $9e847408f5b72379$export$236bfe3a33ef1292);
var $9e847408f5b72379$export$38845ca010b93505 = $9e847408f5b72379$export$ca0f9c2de39ffed7('fontWeight', $9e847408f5b72379$export$855cfd311192d666);
var $9e847408f5b72379$export$ff257d957d48c421 = $9e847408f5b72379$export$ca0f9c2de39ffed7((0, $dcc0f48710161fe0$export$9d7b58831ae93caa), $9e847408f5b72379$export$41a358c9c2356760);
var $9e847408f5b72379$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $9e847408f5b72379$export$41a358c9c2356760[color] !== undefined;
};



var $3ZMUU = parcelRequire("3ZMUU");
function $30e684ef34ab0a0b$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $30e684ef34ab0a0b$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $30e684ef34ab0a0b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $30e684ef34ab0a0b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $30e684ef34ab0a0b$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $30e684ef34ab0a0b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $30e684ef34ab0a0b$export$9a199fbafee0014e = {
    backgroundColor: (0, $9e847408f5b72379$export$d1d79bf68ac056bd),
    blockSize: (0, $9e847408f5b72379$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $9e847408f5b72379$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $9e847408f5b72379$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $9e847408f5b72379$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $9e847408f5b72379$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $9e847408f5b72379$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $9e847408f5b72379$export$e1b83c5210c471b8),
    borderBottomColor: (0, $9e847408f5b72379$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $9e847408f5b72379$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $9e847408f5b72379$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $9e847408f5b72379$export$e1b83c5210c471b8),
    borderColor: (0, $9e847408f5b72379$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $9e847408f5b72379$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $9e847408f5b72379$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $9e847408f5b72379$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $9e847408f5b72379$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $9e847408f5b72379$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $9e847408f5b72379$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $9e847408f5b72379$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $9e847408f5b72379$export$e1b83c5210c471b8),
    borderLeftColor: (0, $9e847408f5b72379$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $9e847408f5b72379$export$e1b83c5210c471b8),
    borderRadius: (0, $9e847408f5b72379$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $9e847408f5b72379$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $9e847408f5b72379$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $9e847408f5b72379$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $9e847408f5b72379$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $9e847408f5b72379$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $9e847408f5b72379$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $9e847408f5b72379$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $9e847408f5b72379$export$e1b83c5210c471b8),
    borderWidth: (0, $9e847408f5b72379$export$e1b83c5210c471b8),
    bottom: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    boxShadow: (0, $9e847408f5b72379$export$7aff6e7ba39bb774),
    color: (0, $9e847408f5b72379$export$8473307aa00d6ea1),
    columnGap: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    font: (0, $9e847408f5b72379$export$6ffa317d5e70375),
    fontFamily: (0, $9e847408f5b72379$export$3c7e9587132614b4),
    fontWeight: (0, $9e847408f5b72379$export$303e322c6b1ed114),
    gap: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    height: (0, $9e847408f5b72379$export$6ccdbebca2ee545f),
    inlineSize: (0, $9e847408f5b72379$export$6ccdbebca2ee545f),
    inset: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    insetBlock: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    insetBlockEnd: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    insetBlockStart: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    insetInline: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    insetInlineEnd: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    insetInlineStart: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    left: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    margin: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    marginBlock: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    marginBlockEnd: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    marginBlockStart: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    marginBottom: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    marginInline: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    marginInlineEnd: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    marginInlineStart: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    marginLeft: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    marginRight: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    marginTop: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    maxBlockSize: (0, $9e847408f5b72379$export$6ccdbebca2ee545f),
    maxHeight: (0, $9e847408f5b72379$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $9e847408f5b72379$export$6ccdbebca2ee545f),
    maxWidth: (0, $9e847408f5b72379$export$6ccdbebca2ee545f),
    minBlockSize: (0, $9e847408f5b72379$export$6ccdbebca2ee545f),
    minHeight: (0, $9e847408f5b72379$export$6ccdbebca2ee545f),
    minInlineSize: (0, $9e847408f5b72379$export$6ccdbebca2ee545f),
    minWidth: (0, $9e847408f5b72379$export$6ccdbebca2ee545f),
    opacity: (0, $9e847408f5b72379$export$daf94a976c798b4f),
    outlineColor: (0, $9e847408f5b72379$export$1531ad5bb3fbedac),
    outlineOffset: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    outlineWidth: (0, $9e847408f5b72379$export$e1b83c5210c471b8),
    padding: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    paddingBlock: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    paddingBottom: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    paddingInline: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    paddingLeft: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    paddingRight: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    paddingTop: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    right: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    rowGap: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    top: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    width: (0, $9e847408f5b72379$export$6ccdbebca2ee545f),
    zIndex: (0, $9e847408f5b72379$export$b5f31a7e431d2eab)
};
var $30e684ef34ab0a0b$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $30e684ef34ab0a0b$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU.env) === 'object' && false;
};
var $30e684ef34ab0a0b$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $30e684ef34ab0a0b$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $30e684ef34ab0a0b$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($30e684ef34ab0a0b$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && $30e684ef34ab0a0b$var$safeSelectors.test(key)) {
            styleObj[key] = $30e684ef34ab0a0b$var$_transformStyles(value);
            return;
        }
        if ($30e684ef34ab0a0b$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($30e684ef34ab0a0b$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $30e684ef34ab0a0b$export$9a199fbafee0014e)) return;
        var tokenValue = $30e684ef34ab0a0b$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $30e684ef34ab0a0b$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $30e684ef34ab0a0b$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $30e684ef34ab0a0b$var$uniqueSymbol, (0, $74Zh5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $30e684ef34ab0a0b$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $30e684ef34ab0a0b$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $30e684ef34ab0a0b$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$30e684ef34ab0a0b$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $30e684ef34ab0a0b$export$f6c783d06584602c(style) {
    return $30e684ef34ab0a0b$var$baseXcss(style);
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");


var $3cedca516816060e$var$justifyContentMap = {
    start: (0, $74Zh5.css)({
        justifyContent: 'start'
    }),
    center: (0, $74Zh5.css)({
        justifyContent: 'center'
    }),
    end: (0, $74Zh5.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $74Zh5.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $74Zh5.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $74Zh5.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $74Zh5.css)({
        justifyContent: 'stretch'
    })
};
var $3cedca516816060e$var$flexDirectionMap = {
    column: (0, $74Zh5.css)({
        flexDirection: 'column'
    }),
    row: (0, $74Zh5.css)({
        flexDirection: 'row'
    })
};
var $3cedca516816060e$var$flexWrapMap = {
    wrap: (0, $74Zh5.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $74Zh5.css)({
        flexWrap: 'nowrap'
    })
};
var $3cedca516816060e$var$alignItemsMap = {
    start: (0, $74Zh5.css)({
        alignItems: 'start'
    }),
    center: (0, $74Zh5.css)({
        alignItems: 'center'
    }),
    baseline: (0, $74Zh5.css)({
        alignItems: 'baseline'
    }),
    end: (0, $74Zh5.css)({
        alignItems: 'end'
    }),
    stretch: (0, $74Zh5.css)({
        alignItems: 'stretch'
    })
};
var $3cedca516816060e$var$baseStyles = (0, $74Zh5.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $3cedca516816060e$var$Flex = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $30e684ef34ab0a0b$export$a9c84988c8f81f2d)(xcss);
    return (0, $74Zh5.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $3cedca516816060e$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $9e847408f5b72379$export$bf46c3f9eeafc71f).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $9e847408f5b72379$export$bf46c3f9eeafc71f).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $9e847408f5b72379$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $3cedca516816060e$var$alignItemsMap[alignItems],
            direction && $3cedca516816060e$var$flexDirectionMap[direction],
            justifyContent && $3cedca516816060e$var$justifyContentMap[justifyContent],
            wrap && $3cedca516816060e$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$3cedca516816060e$var$Flex.displayName = 'Flex';
var $3cedca516816060e$export$2e2bcd8739ae039 = $3cedca516816060e$var$Flex;


var $27179a0b661c3101$var$flexGrowMap = {
    hug: (0, $30e684ef34ab0a0b$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $30e684ef34ab0a0b$export$f6c783d06584602c)({
        width: '100%',
        flexGrow: 1
    })
};
var $27179a0b661c3101$var$separatorStyles = (0, $74Zh5.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $27179a0b661c3101$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $74Zh5.jsx)("span", {
        css: $27179a0b661c3101$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $27179a0b661c3101$var$Inline = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $74Zh5.jsx)($27179a0b661c3101$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $5FkrB.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $74Zh5.jsx)((0, $5FkrB.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $27179a0b661c3101$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $74Zh5.jsx)((0, $3cedca516816060e$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$27179a0b661c3101$var$Inline.displayName = 'Inline';
var $27179a0b661c3101$export$2e2bcd8739ae039 = $27179a0b661c3101$var$Inline;


var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");


var $7e3cff32e16d4929$var$flexGrowMap = {
    hug: (0, $30e684ef34ab0a0b$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $30e684ef34ab0a0b$export$f6c783d06584602c)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $7e3cff32e16d4929$var$Stack = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $7e3cff32e16d4929$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $74Zh5.jsx)((0, $3cedca516816060e$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$7e3cff32e16d4929$var$Stack.displayName = 'Stack';
var $7e3cff32e16d4929$export$2e2bcd8739ae039 = $7e3cff32e16d4929$var$Stack;


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $1d2890bfdc85c1d1$export$4b84fd0e2c617bd = '#FFEBE6';
var $1d2890bfdc85c1d1$export$b34b069eff244586 = '#FFBDAD';
var $1d2890bfdc85c1d1$export$be802dd0d8b57f35 = '#FF8F73';
var $1d2890bfdc85c1d1$export$60847d42f9da92a6 = '#FF7452';
var $1d2890bfdc85c1d1$export$4a7404f376229999 = '#FF5630';
var $1d2890bfdc85c1d1$export$2010d0fb4295b346 = '#DE350B';
var $1d2890bfdc85c1d1$export$2837b5a1a71d5c02 = '#BF2600';
var $1d2890bfdc85c1d1$export$8d9596b529bbb9cf = '#FFFAE6';
var $1d2890bfdc85c1d1$export$41060a744ab0b7ae = '#FFF0B3';
var $1d2890bfdc85c1d1$export$1cc05bbbf340e559 = '#FFE380';
var $1d2890bfdc85c1d1$export$5aae31392d72caaa = '#FFC400';
var $1d2890bfdc85c1d1$export$c6930421db9fa514 = '#FFAB00';
var $1d2890bfdc85c1d1$export$59619663aa6500fb = '#FF991F';
var $1d2890bfdc85c1d1$export$874739ea9e379ab6 = '#FF8B00';
var $1d2890bfdc85c1d1$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $1d2890bfdc85c1d1$export$69a3bf21b9686c2b = '#ABF5D1';
var $1d2890bfdc85c1d1$export$afbce1382ec95f73 = '#79F2C0';
var $1d2890bfdc85c1d1$export$747d86715d4175de = '#57D9A3';
var $1d2890bfdc85c1d1$export$940e1f69e873f202 = '#36B37E';
var $1d2890bfdc85c1d1$export$a49394138f7b8e85 = '#00875A';
var $1d2890bfdc85c1d1$export$6fa04827ac68a4fb = '#006644';
var $1d2890bfdc85c1d1$export$226de0355ed012f8 = '#DEEBFF';
var $1d2890bfdc85c1d1$export$8c13c2ee36917869 = '#B3D4FF';
var $1d2890bfdc85c1d1$export$ecfc1dff386a3e7a = '#4C9AFF';
var $1d2890bfdc85c1d1$export$215b7063051591f1 = '#2684FF';
var $1d2890bfdc85c1d1$export$e62e8919cca44969 = '#0065FF';
var $1d2890bfdc85c1d1$export$b3de0ae08da2ce64 = '#0052CC';
var $1d2890bfdc85c1d1$export$a6ee3d71bc067634 = '#0747A6';
var $1d2890bfdc85c1d1$export$67f15409e87642a1 = '#669DF1';
var $1d2890bfdc85c1d1$export$f0539dbc42dbb067 = '#8FB8F6';
var $1d2890bfdc85c1d1$export$363e4475840015bb = '#EAE6FF';
var $1d2890bfdc85c1d1$export$4b0a4417ed59760f = '#C0B6F2';
var $1d2890bfdc85c1d1$export$6011520a64d9a187 = '#998DD9';
var $1d2890bfdc85c1d1$export$a7175d4e9206bc80 = '#8777D9';
var $1d2890bfdc85c1d1$export$b48405b95304b5a1 = '#6554C0';
var $1d2890bfdc85c1d1$export$c71e4279dd54a18d = '#5243AA';
var $1d2890bfdc85c1d1$export$147899de772240ec = '#403294';
var $1d2890bfdc85c1d1$export$2cf711fe14c66f06 = '#E6FCFF';
var $1d2890bfdc85c1d1$export$7a8f4d33f6f9772c = '#B3F5FF';
var $1d2890bfdc85c1d1$export$776c9c497ef08533 = '#79E2F2';
var $1d2890bfdc85c1d1$export$69cb3ca10c1e330e = '#00C7E6';
var $1d2890bfdc85c1d1$export$9dc1ef0f3f48059b = '#00B8D9';
var $1d2890bfdc85c1d1$export$7c835c78b6fcdef8 = '#00A3BF';
var $1d2890bfdc85c1d1$export$6036577f95c3877e = '#008DA6';
var $1d2890bfdc85c1d1$export$29a4f05edc054374 = '#FFFFFF';
var $1d2890bfdc85c1d1$export$e655ef011c4aa1a2 = '#FAFBFC';
var $1d2890bfdc85c1d1$export$9fdfb749e33cdf97 = '#F4F5F7';
var $1d2890bfdc85c1d1$export$3e51e8f1440314ba = '#EBECF0';
var $1d2890bfdc85c1d1$export$1ce2d1575d444ceb = '#DFE1E6';
var $1d2890bfdc85c1d1$export$8754fc7e6d8b3000 = '#C1C7D0';
var $1d2890bfdc85c1d1$export$c2e91cbeada39b8b = '#B3BAC5';
var $1d2890bfdc85c1d1$export$5f71e19f3a7ad9de = '#A5ADBA';
var $1d2890bfdc85c1d1$export$eaa8c8a70ac22806 = '#97A0AF';
var $1d2890bfdc85c1d1$export$7c87d337fb91a97d = '#8993A4';
var $1d2890bfdc85c1d1$export$d6447c357493214f = '#7A869A';
var $1d2890bfdc85c1d1$export$f563ee71e9ee74cd = '#6B778C';
var $1d2890bfdc85c1d1$export$e2ef2124cf4024b1 = '#5E6C84';
var $1d2890bfdc85c1d1$export$eece5f492e429f08 = '#505F79';
var $1d2890bfdc85c1d1$export$c39c0fe0f26207ae = '#42526E';
var $1d2890bfdc85c1d1$export$7090862dc3038a9f = '#344563';
var $1d2890bfdc85c1d1$export$ad0bacf983b7ddaa = '#253858';
var $1d2890bfdc85c1d1$export$7d61b15e0da132af = '#172B4D';
var $1d2890bfdc85c1d1$export$fbda843f0a27fe96 = '#091E42';
var $1d2890bfdc85c1d1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $1d2890bfdc85c1d1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $1d2890bfdc85c1d1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $1d2890bfdc85c1d1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $1d2890bfdc85c1d1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $1d2890bfdc85c1d1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $1d2890bfdc85c1d1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $1d2890bfdc85c1d1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $1d2890bfdc85c1d1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $1d2890bfdc85c1d1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $1d2890bfdc85c1d1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $1d2890bfdc85c1d1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $1d2890bfdc85c1d1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $1d2890bfdc85c1d1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $1d2890bfdc85c1d1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $1d2890bfdc85c1d1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $1d2890bfdc85c1d1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $1d2890bfdc85c1d1$export$2f6319cf7d736c2a = '#E6EDFA';
var $1d2890bfdc85c1d1$export$95126bc8884d6634 = '#DCE5F5';
var $1d2890bfdc85c1d1$export$8338d8c35d44ff1 = '#CED9EB';
var $1d2890bfdc85c1d1$export$5368d76ae4fbbda7 = '#B8C7E0';
var $1d2890bfdc85c1d1$export$9f0a771d16ec8d36 = '#ABBBD6';
var $1d2890bfdc85c1d1$export$abcf8c38338b4aa5 = '#9FB0CC';
var $1d2890bfdc85c1d1$export$97e81faa16a182c7 = '#8C9CB8';
var $1d2890bfdc85c1d1$export$bfe21c59123ecf33 = '#7988A3';
var $1d2890bfdc85c1d1$export$ee82aa2ea6a1558 = '#67758F';
var $1d2890bfdc85c1d1$export$682927c6ed76be02 = '#56637A';
var $1d2890bfdc85c1d1$export$91fd9994c5be9757 = '#455166';
var $1d2890bfdc85c1d1$export$d281fbfe3cff2df6 = '#3B475C';
var $1d2890bfdc85c1d1$export$3902c91d8b98a753 = '#313D52';
var $1d2890bfdc85c1d1$export$8e8133c1ba5845b5 = '#283447';
var $1d2890bfdc85c1d1$export$33ff357f6620b39 = '#202B3D';
var $1d2890bfdc85c1d1$export$633847cf062b69e0 = '#1B2638';
var $1d2890bfdc85c1d1$export$9776a6e503bdbf76 = '#121A29';
var $1d2890bfdc85c1d1$export$6c813d5160dff5db = '#0E1624';
var $1d2890bfdc85c1d1$export$3d4f271a500072a = '#0D1424';
var $1d2890bfdc85c1d1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $1d2890bfdc85c1d1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $1d2890bfdc85c1d1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $1d2890bfdc85c1d1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $1d2890bfdc85c1d1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $1d2890bfdc85c1d1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $1d2890bfdc85c1d1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $1d2890bfdc85c1d1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $1d2890bfdc85c1d1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $1d2890bfdc85c1d1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $1d2890bfdc85c1d1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $1d2890bfdc85c1d1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $1d2890bfdc85c1d1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $1d2890bfdc85c1d1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $1d2890bfdc85c1d1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $1d2890bfdc85c1d1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $1d2890bfdc85c1d1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $1d2890bfdc85c1d1$export$d2adc5dedf09fced = '#292A2E';
var $1d2890bfdc85c1d1$export$f51762073d2bb381 = '#94C748';
var $1d2890bfdc85c1d1$export$95e26d54def96891 = '#B3DF72';



var $7e07e48730988c43$var$defaultRender = function defaultRender(Component, props) {
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, $74Zh5.jsx)(Component, props));
};
var $7e07e48730988c43$var$beforeAfterElementStyles = (0, $74Zh5.css)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
});
var $7e07e48730988c43$var$contentStyles = (0, $30e684ef34ab0a0b$export$f6c783d06584602c)({
    outline: 'none',
    overflow: 'hidden',
    textAlign: 'left'
});
var $7e07e48730988c43$var$truncateStyles = (0, $74Zh5.css)({
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
var $7e07e48730988c43$var$titleStyles = (0, $74Zh5.css)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
var $7e07e48730988c43$var$wordBreakStyles = (0, $74Zh5.css)({
    wordBreak: 'break-word'
});
var $7e07e48730988c43$var$descriptionStyles = (0, $74Zh5.css)({
    color: "var(--ds-text-subtlest, ".concat((0, $1d2890bfdc85c1d1$export$f563ee71e9ee74cd), ")"),
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
var $7e07e48730988c43$var$disabledDescriptionStyles = (0, $74Zh5.css)({
    color: "var(--ds-text-disabled, ".concat((0, $1d2890bfdc85c1d1$export$f563ee71e9ee74cd), ")")
});
var $7e07e48730988c43$var$positionRelativeStyles = (0, $74Zh5.css)({
    position: 'relative'
});
var $7e07e48730988c43$var$primitiveStyles = (0, $74Zh5.css)({
    display: 'flex',
    boxSizing: 'border-box',
    width: '100%',
    minHeight: 40,
    margin: "var(--ds-space-0, 0px)",
    alignItems: 'center',
    border: 0,
    outline: 0,
    textDecoration: 'none',
    userSelect: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    '&:hover': {
        textDecoration: 'none'
    }
});
var $7e07e48730988c43$var$spacingMapStyles = {
    cozy: (0, $74Zh5.css)({
        // 8 * 2 (16) + icon (24) === 40
        paddingBlock: "var(--ds-space-100, 8px)",
        paddingInline: "var(--ds-space-200, 16px)"
    }),
    compact: (0, $74Zh5.css)({
        minHeight: 32,
        // 4 * 2 (8) + icon (24) === 32
        paddingBlock: "var(--ds-space-050, 4px)",
        paddingInline: "var(--ds-space-150, 12px)"
    })
};
var $7e07e48730988c43$var$interactiveStyles = (0, $74Zh5.css)({
    cursor: 'pointer'
});
var $7e07e48730988c43$var$unselectedStyles = (0, $74Zh5.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    color: 'currentColor',
    '&:visited': {
        color: 'currentColor'
    },
    '&:hover': {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, ".concat((0, $1d2890bfdc85c1d1$export$9fdfb749e33cdf97), ")"),
        color: 'currentColor'
    },
    '&:active': {
        backgroundColor: "var(--ds-background-neutral-subtle-pressed, ".concat((0, $1d2890bfdc85c1d1$export$3e51e8f1440314ba), ")"),
        boxShadow: 'none',
        color: 'currentColor'
    }
});
var $7e07e48730988c43$var$disabledStyles = (0, $74Zh5.css)({
    cursor: 'not-allowed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&, :hover, :active': {
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        color: "var(--ds-text-disabled, ".concat((0, $1d2890bfdc85c1d1$export$f563ee71e9ee74cd), ")")
    }
});
var $7e07e48730988c43$var$selectedBorderStyles = (0, $74Zh5.css)({
    '&::before': {
        width: 2,
        position: 'absolute',
        background: "var(--ds-border-selected, transparent)",
        content: '""',
        insetBlockEnd: 0,
        insetBlockStart: 0,
        insetInlineStart: 0
    }
});
var $7e07e48730988c43$var$selectedNotchStyles = (0, $74Zh5.css)({
    '&::before': {
        width: 4,
        position: 'absolute',
        background: "var(--ds-border-selected, transparent)",
        borderRadius: "0 ".concat("var(--ds-border-radius, 4px)", " ", "var(--ds-border-radius, 4px)", " 0"),
        content: '""',
        insetBlockEnd: "var(--ds-space-150, 12px)",
        insetBlockStart: "var(--ds-space-150, 12px)",
        insetInlineStart: 0
    }
});
var $7e07e48730988c43$var$selectedStyles = (0, $74Zh5.css)({
    backgroundColor: "var(--ds-background-selected, ".concat((0, $1d2890bfdc85c1d1$export$9fdfb749e33cdf97), ")"),
    // Fallback set as babel plugin inserts one otherwise
    color: "var(--ds-text-selected, currentColor)",
    '&:visited': {
        color: "var(--ds-text-selected, currentColor)"
    },
    '&:hover': {
        backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $1d2890bfdc85c1d1$export$9fdfb749e33cdf97), ")"),
        color: "var(--ds-text-selected, currentColor)"
    },
    '&:active': {
        backgroundColor: "var(--ds-background-selected-pressed, ".concat((0, $1d2890bfdc85c1d1$export$3e51e8f1440314ba), ")"),
        color: "var(--ds-text-selected, currentColor)"
    }
});
var $7e07e48730988c43$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $7e07e48730988c43$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, overrides = _ref.overrides, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, testId = _ref.testId;
    (0, $c6f574dac5b81c12$export$eb1decd851a5ae56)("@atlaskit/menu", 'overrides', overrides !== undefined, '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var spacing = (0, $5FkrB.useContext)((0, $029784b0740265a3$export$443076ec7ebce042));
    var selectionStyle = (0, $5FkrB.useContext)((0, $029784b0740265a3$export$9ca534b70725964d));
    var renderTitle = overrides && overrides.Title && overrides.Title.render || $7e07e48730988c43$var$defaultRender;
    var UNSAFE_className = UNSAFE_externalClassName;
    return (0, $74Zh5.jsx)((0, $74Zh5.ClassNames), null, function(_ref2) {
        var cn = _ref2.css, cx = _ref2.cx;
        return (0, $74Zh5.jsx)((0, $ae7f66a126864790$export$2e2bcd8739ae039), {
            isInset: true
        }, children({
            className: cx([
                cn([
                    $7e07e48730988c43$var$positionRelativeStyles,
                    $7e07e48730988c43$var$primitiveStyles,
                    $7e07e48730988c43$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $7e07e48730988c43$var$unselectedStyles,
                    !isDisabled && isSelected && [
                        $7e07e48730988c43$var$selectedStyles,
                        [
                            selectionStyle === 'border' && $7e07e48730988c43$var$selectedBorderStyles,
                            selectionStyle === 'notch' && $7e07e48730988c43$var$selectedNotchStyles
                        ]
                    ],
                    isDisabled ? $7e07e48730988c43$var$disabledStyles : $7e07e48730988c43$var$interactiveStyles
                ]),
                UNSAFE_className
            ]),
            children: (0, $74Zh5.jsx)((0, $27179a0b661c3101$export$2e2bcd8739ae039), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $7e07e48730988c43$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && (0, $74Zh5.jsx)("span", {
                "data-item-elem-before": true,
                css: $7e07e48730988c43$var$beforeAfterElementStyles,
                "data-testid": testId && "".concat(testId, "--icon-before")
            }, iconBefore), title && (0, $74Zh5.jsx)((0, $7e3cff32e16d4929$export$2e2bcd8739ae039), {
                alignBlock: "center",
                grow: "fill",
                xcss: $7e07e48730988c43$var$contentStyles
            }, renderTitle('span', {
                children: title,
                className: cn($7e07e48730988c43$var$titleStyles, shouldTitleWrap ? $7e07e48730988c43$var$wordBreakStyles : $7e07e48730988c43$var$truncateStyles),
                'data-item-title': true
            }), description && (0, $74Zh5.jsx)("span", {
                "data-item-description": true,
                css: [
                    $7e07e48730988c43$var$descriptionStyles,
                    isDisabled && $7e07e48730988c43$var$disabledDescriptionStyles,
                    shouldDescriptionWrap ? $7e07e48730988c43$var$wordBreakStyles : $7e07e48730988c43$var$truncateStyles
                ]
            }, description)), iconAfter && (0, $74Zh5.jsx)("span", {
                "data-item-elem-after": true,
                css: $7e07e48730988c43$var$beforeAfterElementStyles,
                "data-testid": testId && "".concat(testId, "--icon-after")
            }, iconAfter))
        }));
    });
};
var $7e07e48730988c43$export$2e2bcd8739ae039 = $7e07e48730988c43$var$MenuItemPrimitive;


var $deae49ab7e32e8cd$var$_excluded = [
    "children",
    "cssFn",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "interactionName"
];
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $deae49ab7e32e8cd$var$ButtonItem = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(// Type needed on props to extract types with extract react types.
function(props, ref) {
    var children = props.children, _props$cssFn = props.cssFn, cssFn = _props$cssFn === void 0 ? (0, $f2ed9a22761e3cb5$export$2e2bcd8739ae039) : _props$cssFn, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, overrides = props.overrides, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $deae49ab7e32e8cd$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $5FkrB.useContext)((0, $1d30d2a862a7a995$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    (0, $c6f574dac5b81c12$export$eb1decd851a5ae56)("@atlaskit/menu", 'cssFn', cssFn !== (0, $f2ed9a22761e3cb5$export$2e2bcd8739ae039), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $74Zh5.jsx)((0, $7e07e48730988c43$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        className: UNSAFE_className
    }, rest, {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return (0, $74Zh5.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: (0, $c981c2489638862d$export$b40ec24ac8275656)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }), children);
    });
}));
var $deae49ab7e32e8cd$export$2e2bcd8739ae039 = $deae49ab7e32e8cd$var$ButtonItem;



var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");





var $4935fc4df735be0f$var$_excluded = [
    "component",
    "cssFn",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $4935fc4df735be0f$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
// Dirty hack to get generics working with forward ref [1/2]
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $4935fc4df735be0f$var$CustomItem = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var Component = _ref.component, _ref$cssFn = _ref.cssFn, cssFn = _ref$cssFn === void 0 ? (0, $f2ed9a22761e3cb5$export$2e2bcd8739ae039) : _ref$cssFn, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, onClick = _ref.onClick, testId = _ref.testId, children = _ref.children, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, overrides = _ref.overrides, onMouseDown = _ref.onMouseDown, shouldTitleWrap = _ref.shouldTitleWrap, shouldDescriptionWrap = _ref.shouldDescriptionWrap, UNSAFE_className = _ref.className, UNSAFE_isDraggable = _ref.UNSAFE_isDraggable, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $4935fc4df735be0f$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $5FkrB.useContext)((0, $1d30d2a862a7a995$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    (0, $c6f574dac5b81c12$export$eb1decd851a5ae56)("@atlaskit/menu", 'cssFn', cssFn !== (0, $f2ed9a22761e3cb5$export$2e2bcd8739ae039), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $74Zh5.jsx)((0, $7e07e48730988c43$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        className: UNSAFE_className
    }, rest, {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: (0, $74Zh5.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cssFn({
            isDisabled: isDisabled,
            isSelected: isSelected
        })),
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref2) {
        var children = _ref2.children, className = _ref2.className;
        return (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $4935fc4df735be0f$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $4935fc4df735be0f$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $4935fc4df735be0f$var$preventEvent : (0, $c981c2489638862d$export$b40ec24ac8275656)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled
        }), children);
    });
}));
var $4935fc4df735be0f$export$2e2bcd8739ae039 = $4935fc4df735be0f$var$CustomItem;



var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $9efa5b1edaff374d$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $5FkrB.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $9efa5b1edaff374d$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($9efa5b1edaff374d$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $9efa5b1edaff374d$export$2e2bcd8739ae039 = $9efa5b1edaff374d$var$RouterLinkProvider;


/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $7d1898a7983f51c4$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $5FkrB.useContext)((0, $9efa5b1edaff374d$export$2931e0ee690eee88)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
};
var $7d1898a7983f51c4$export$2e2bcd8739ae039 = $7d1898a7983f51c4$var$useRouterLink;







var $e9e55778a7afa09d$var$_excluded = [
    "children",
    "href",
    "cssFn",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_shouldDisableRouterLink",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $e9e55778a7afa09d$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $e9e55778a7afa09d$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
var $e9e55778a7afa09d$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $e9e55778a7afa09d$var$LinkItem = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(// Type needed on props to extract types with extract react types.
function(props, ref) {
    var children = props.children, href = props.href, _props$cssFn = props.cssFn, cssFn = _props$cssFn === void 0 ? (0, $f2ed9a22761e3cb5$export$2e2bcd8739ae039) : _props$cssFn, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, overrides = props.overrides, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, UNSAFE_shouldDisableRouterLink = props.UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable = props.UNSAFE_isDraggable, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $e9e55778a7afa09d$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var RouterLink = (0, $7d1898a7983f51c4$export$2e2bcd8739ae039)();
    var interactionContext = (0, $5FkrB.useContext)((0, $1d30d2a862a7a995$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    var isExternal = typeof href === 'string' && $e9e55778a7afa09d$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $e9e55778a7afa09d$var$IS_NON_HTTP_BASED.test(href);
    var isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ var isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    var Component = isRouterLink ? RouterLink : 'a';
    (0, $c6f574dac5b81c12$export$eb1decd851a5ae56)("@atlaskit/menu", 'cssFn', cssFn !== (0, $f2ed9a22761e3cb5$export$2e2bcd8739ae039), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $74Zh5.jsx)((0, $7e07e48730988c43$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        title: children,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
            "data-vc": "link-item"
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            href: isDisabled ? undefined : href
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $e9e55778a7afa09d$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $e9e55778a7afa09d$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $e9e55778a7afa09d$var$preventEvent : (0, $c981c2489638862d$export$b40ec24ac8275656)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
            "aria-current": isSelected ? 'page' : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }), children);
    });
}));
var $e9e55778a7afa09d$export$2e2bcd8739ae039 = $e9e55778a7afa09d$var$LinkItem;



var $dVGJk = parcelRequire("dVGJk");

var $896b4f3af893fddb$var$_excluded = [
    "children",
    "component",
    "description",
    "elemAfter",
    "elemBefore",
    "href",
    "isDisabled",
    "isSelected",
    "onClick",
    "rel",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "target",
    "testId",
    "UNSAFE_shouldDisableRouterLink",
    "returnFocusRef",
    "interactionName"
];
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ var $896b4f3af893fddb$var$DropdownMenuItem = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, component = _ref.component, description = _ref.description, elemAfter = _ref.elemAfter, elemBefore = _ref.elemBefore, href = _ref.href, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, rel = _ref.rel, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, target = _ref.target, testId = _ref.testId, UNSAFE_shouldDisableRouterLink = _ref.UNSAFE_shouldDisableRouterLink, returnFocusRef = _ref.returnFocusRef, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $896b4f3af893fddb$var$_excluded);
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    var itemRef = (0, $342103062545c958$export$2e2bcd8739ae039)(!!rest['aria-haspopup']);
    var handleItemClick = (0, $5FkrB.useCallback)(function(event) {
        if (returnFocusRef !== null && returnFocusRef !== void 0 && returnFocusRef.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4935fc4df735be0f$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $0d2a37110e22a1c9$export$2e2bcd8739ae039)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        target: target,
        rel: rel
    }, (0, $dVGJk.fg)('platform_button_item-add-ufo-metrics') && {
        interactionName: interactionName
    }, rest), children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e9e55778a7afa09d$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $0d2a37110e22a1c9$export$2e2bcd8739ae039)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink
    }, (0, $dVGJk.fg)('platform_button_item-add-ufo-metrics') && {
        interactionName: interactionName
    }, rest), children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $deae49ab7e32e8cd$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $0d2a37110e22a1c9$export$2e2bcd8739ae039)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        target: target,
        rel: rel
    }, (0, $dVGJk.fg)('platform_button_item-add-ufo-metrics') && {
        interactionName: interactionName
    }, rest), children);
});
var $896b4f3af893fddb$export$2e2bcd8739ae039 = $896b4f3af893fddb$var$DropdownMenuItem;


var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");




var $dVGJk = parcelRequire("dVGJk");

var $5FkrB = parcelRequire("5FkrB");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $cw16F = parcelRequire("cw16F");

var $1b631 = parcelRequire("1b631");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $1b6d57c283ee4ca6$var$svgStyles = (0, $74Zh5.css)((0, $1b631.commonSVGStyles));
/**
 * __SVG__
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
 */ var $1b6d57c283ee4ca6$var$SVG = /*#__PURE__*/ (0, $5FkrB.memo)(function SVG(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, label = _ref.label, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, testId = _ref.testId, children = _ref.children;
    return (0, $74Zh5.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fill: secondaryColor || (0, $cw16F.getBackground)()
        },
        css: [
            $1b6d57c283ee4ca6$var$svgStyles,
            (0, $1b631.sizeStyleMap)[size]
        ],
        "data-testid": testId,
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation'
    }, children);
});
var $1b6d57c283ee4ca6$export$2e2bcd8739ae039 = $1b6d57c283ee4ca6$var$SVG;



var $dVGJk = parcelRequire("dVGJk");

/**
 * __Checkbox icon__
 *
 * Used to visually represent the selected state in DropdownItemCheckbox
 *
 * @internal
 */ var $be6adeddf968289c$var$CheckboxIcon = function CheckboxIcon(_ref) {
    var checked = _ref.checked;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1b6d57c283ee4ca6$export$2e2bcd8739ae039), {
        label: "",
        size: "medium",
        primaryColor: checked ? "var(--ds-background-selected-bold, ".concat((0, $d879fc455f6e75a0$export$b3de0ae08da2ce64), ")") : "var(--ds-background-input, ".concat((0, $d879fc455f6e75a0$export$e655ef011c4aa1a2), ")"),
        secondaryColor: checked ? "var(--ds-icon-inverse, ".concat((0, $d879fc455f6e75a0$export$e655ef011c4aa1a2), ")") : 'transparent'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("g", {
        fillRule: "evenodd"
    }, // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
    (0, $dVGJk.fg)('platform-visual-refresh-icons') && (0, $dVGJk.fg)('platform-icon-control-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("rect", {
        stroke: checked ? "var(--ds-border-selected, ".concat((0, $d879fc455f6e75a0$export$b3de0ae08da2ce64), ")") : "var(--ds-border-input, ".concat((0, $d879fc455f6e75a0$export$d6447c357493214f), ")"),
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2",
        stroke: checked ? "var(--ds-border-selected, ".concat((0, $d879fc455f6e75a0$export$b3de0ae08da2ce64), ")") : "var(--ds-border-input, ".concat((0, $d879fc455f6e75a0$export$d6447c357493214f), ")"),
        strokeWidth: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
        d: "M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    }))));
};
var $be6adeddf968289c$export$2e2bcd8739ae039 = $be6adeddf968289c$var$CheckboxIcon;



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $0902122f60812d1d$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $5FkrB.createContext)('');



/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ var $55dd3ea434b7a8af$var$useCheckboxState = function useCheckboxState(_ref) {
    var isSelected = _ref.isSelected, id = _ref.id, defaultSelected = _ref.defaultSelected;
    var _useContext = (0, $5FkrB.useContext)((0, $6c8d7d354dcb5a30$export$756f795847463ebd)), setItemState = _useContext.setItemState, getItemState = _useContext.getItemState;
    var groupId = (0, $5FkrB.useContext)((0, $0902122f60812d1d$export$baf37c4be89255b8));
    var persistedIsSelected = getItemState(groupId, id);
    var _useState = (0, $5FkrB.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    function() {
        return persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), localIsSelected = _useState2[0], setLocalIsSelected = _useState2[1];
    var setLocalState = (0, $5FkrB.useCallback)(function(newValue) {
        var nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        function() {
            return false;
        }
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $55dd3ea434b7a8af$export$2e2bcd8739ae039 = $55dd3ea434b7a8af$var$useCheckboxState;




var $3ZMUU = parcelRequire("3ZMUU");
var $9717609675842cd9$var$_excluded = [
    "children",
    "defaultSelected",
    "description",
    "id",
    "isDisabled",
    "isSelected",
    "onClick",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "testId",
    "interactionName"
];
/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ var $9717609675842cd9$var$DropdownItemCheckbox = function DropdownItemCheckbox(_ref) {
    var children = _ref.children, defaultSelected = _ref.defaultSelected, description = _ref.description, id = _ref.id, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $3a341012e037de4f$export$2e2bcd8739ae039) : _ref$onClick, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, testId = _ref.testId, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $9717609675842cd9$var$_excluded);
    typeof $3ZMUU;
    var _useCheckboxState = (0, $55dd3ea434b7a8af$export$2e2bcd8739ae039)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    }), _useCheckboxState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useCheckboxState, 2), selected = _useCheckboxState2[0], setSelected = _useCheckboxState2[1];
    var onClickHandler = (0, $5FkrB.useCallback)(function(event) {
        setSelected(function(selected) {
            return !selected;
        });
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    var itemRef = (0, $342103062545c958$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $029784b0740265a3$export$9ca534b70725964d).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $deae49ab7e32e8cd$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $be6adeddf968289c$export$2e2bcd8739ae039), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: "menuitemcheckbox",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId
    }, (0, $dVGJk.fg)('platform_button_item-add-ufo-metrics') && {
        interactionName: interactionName
    }, rest), children));
};
var $9717609675842cd9$export$2e2bcd8739ae039 = $9717609675842cd9$var$DropdownItemCheckbox;


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");



var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");



var $2dbde3d3788ab954$var$_excluded = [
    "children",
    "testId",
    "headingLevel",
    "id",
    "cssFn",
    "className"
];
var $2dbde3d3788ab954$var$headingStyles = (0, $74Zh5.css)({
    color: "var(--ds-text-subtle, ".concat((0, $1d2890bfdc85c1d1$export$e2ef2124cf4024b1), ")"),
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)"
});
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $2dbde3d3788ab954$var$HeadingItem = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 2 : _ref$headingLevel, id = _ref.id, _ref$cssFn = _ref.cssFn, cssFn = _ref$cssFn === void 0 ? (0, $f2ed9a22761e3cb5$export$2e2bcd8739ae039) : _ref$cssFn, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $2dbde3d3788ab954$var$_excluded);
    (0, $c6f574dac5b81c12$export$eb1decd851a5ae56)("@atlaskit/menu", 'cssFn', cssFn !== (0, $f2ed9a22761e3cb5$export$2e2bcd8739ae039), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var UNSAFE_overrides = (0, $74Zh5.css)(cssFn(undefined));
    return (0, $74Zh5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        css: [
            $2dbde3d3788ab954$var$headingStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            UNSAFE_overrides
        ],
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: UNSAFE_className
    }, rest), children);
});
var $2dbde3d3788ab954$export$2e2bcd8739ae039 = $2dbde3d3788ab954$var$HeadingItem;


var $bb6d010069fda365$var$_excluded = [
    "children",
    "overrides",
    "title",
    "titleId",
    "testId",
    "isScrollable",
    "hasSeparator",
    "id",
    "isList",
    "className"
];
var $bb6d010069fda365$var$gridSize = 8;
var $bb6d010069fda365$var$itemHeadingTopMargin = $bb6d010069fda365$var$gridSize * 2.5;
var $bb6d010069fda365$var$itemHeadingBottomMargin = $bb6d010069fda365$var$gridSize * 0.75;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
var $bb6d010069fda365$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
var $bb6d010069fda365$var$skeletonHeadingHeight = $bb6d010069fda365$var$gridSize;
var $bb6d010069fda365$var$skeletonHeadingMarginOffset = 3;
var $bb6d010069fda365$var$skeletonHeadingTopMargin = $bb6d010069fda365$var$itemHeadingTopMargin + ($bb6d010069fda365$var$itemHeadingContentHeight - $bb6d010069fda365$var$skeletonHeadingHeight) - $bb6d010069fda365$var$skeletonHeadingMarginOffset;
// We want to move the entire body up by 3px without affecting the height of the skeleton container.
var $bb6d010069fda365$var$skeletonHeadingBottomMargin = $bb6d010069fda365$var$itemHeadingBottomMargin + $bb6d010069fda365$var$skeletonHeadingMarginOffset;
var $bb6d010069fda365$var$sectionPaddingTopBottom = $bb6d010069fda365$var$gridSize * 0.75;
var $bb6d010069fda365$var$VAR_SEPARATOR_COLOR = '--ds-menu-seperator-color';
var $bb6d010069fda365$var$sectionStyles = (0, $74Zh5.css)({
    '&::before, &::after': {
        display: 'block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: $bb6d010069fda365$var$sectionPaddingTopBottom,
        content: '""'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-ds--menu--heading-item]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $bb6d010069fda365$var$itemHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $bb6d010069fda365$var$itemHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $bb6d010069fda365$var$itemHeadingTopMargin - $bb6d010069fda365$var$sectionPaddingTopBottom
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-ds--menu--skeleton-heading-item]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $bb6d010069fda365$var$skeletonHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $bb6d010069fda365$var$skeletonHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $bb6d010069fda365$var$skeletonHeadingTopMargin - $bb6d010069fda365$var$sectionPaddingTopBottom
        }
    },
    '&:focus': {
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        // This makes the outline go inside by 1px so it can actually be displayed
        // else it gets cut off from the overflow: scroll from the parent menu group.
        outlineOffset: -1
    }
});
var $bb6d010069fda365$var$scrollableStyles = (0, $74Zh5.css)({
    flexShrink: 1,
    overflow: 'auto'
});
var $bb6d010069fda365$var$unscrollableStyles = (0, $74Zh5.css)({
    flexShrink: 0
});
var $bb6d010069fda365$var$thinSeparatorStyles = (0, $74Zh5.css)({
    borderBlockStart: "1px solid var(".concat($bb6d010069fda365$var$VAR_SEPARATOR_COLOR, ", ", "var(--ds-border, ".concat((0, $1d2890bfdc85c1d1$export$920c0d5c49070351), ")"), ")")
});
var $bb6d010069fda365$var$noSeparatorStyles = (0, $74Zh5.css)({
    // this is to ensure that adjacent sections without separators don't get additional margins.
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '[data-section] + &': {
        marginBlockStart: -6
    }
});
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $bb6d010069fda365$var$Section = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, overrides = _ref.overrides, title = _ref.title, titleId = _ref.titleId, testId = _ref.testId, isScrollable = _ref.isScrollable, hasSeparator = _ref.hasSeparator, id = _ref.id, _ref$isList = _ref.isList, isList = _ref$isList === void 0 ? false : _ref$isList, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $bb6d010069fda365$var$_excluded);
    (0, $c6f574dac5b81c12$export$eb1decd851a5ae56)("@atlaskit/menu", 'overrides', overrides !== undefined, '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var UNSAFE_headingOverrides = overrides && overrides.HeadingItem && overrides.HeadingItem.cssFn;
    var content = isList ? (0, $74Zh5.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $5FkrB.Children).map((0, $5FkrB.Children).toArray(children), function(child, index) {
        return (0, $74Zh5.jsx)("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: 'none',
                margin: 0,
                padding: 0
            },
            key: index
        }, child);
    })) : children;
    var childrenMarkup = title !== undefined ? (0, $74Zh5.jsx)((0, $5FkrB.Fragment), null, (0, $74Zh5.jsx)((0, $2dbde3d3788ab954$export$2e2bcd8739ae039), {
        cssFn: UNSAFE_headingOverrides,
        testId: testId && "".concat(testId, "--heading"),
        "aria-hidden": true
    }, title), content) : (0, $74Zh5.jsx)((0, $5FkrB.Fragment), null, content);
    return (0, $74Zh5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        id: id,
        css: [
            $bb6d010069fda365$var$sectionStyles,
            isScrollable ? $bb6d010069fda365$var$scrollableStyles : $bb6d010069fda365$var$unscrollableStyles,
            hasSeparator ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            $bb6d010069fda365$var$thinSeparatorStyles : $bb6d010069fda365$var$noSeparatorStyles
        ],
        "aria-label": title,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }), childrenMarkup);
});
var $bb6d010069fda365$export$2e2bcd8739ae039 = $bb6d010069fda365$var$Section;



var $5FkrB = parcelRequire("5FkrB");

var $23428f2f9e2005b2$var$headingStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    color: 'color.text.subtle',
    font: 'font.heading.xxsmall',
    paddingBlock: 'space.0',
    paddingInline: 'space.200'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ var $23428f2f9e2005b2$var$GroupTitle = function GroupTitle(_ref) {
    var id = _ref.id, title = _ref.title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d007f17589e0f9b9$export$2e2bcd8739ae039), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $23428f2f9e2005b2$var$headingStyles
    }, title);
};
var $23428f2f9e2005b2$export$2e2bcd8739ae039 = $23428f2f9e2005b2$var$GroupTitle;



var $4efa9b4942c769d7$var$_excluded = [
    "children",
    "hasSeparator",
    "id",
    "isList",
    "isScrollable",
    "overrides",
    "testId",
    "title"
];
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu checkbox items.
 *
 */ var $4efa9b4942c769d7$var$DropdownItemCheckboxGroup = function DropdownItemCheckboxGroup(_ref) {
    var children = _ref.children, hasSeparator = _ref.hasSeparator, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, overrides = _ref.overrides, testId = _ref.testId, title = _ref.title, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $4efa9b4942c769d7$var$_excluded);
    var uid = (0, $24526c38f36cc756$export$f680877a34711e37)();
    var titleId = "dropdown-menu-item-checkbox-group-title-".concat(uid);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0902122f60812d1d$export$baf37c4be89255b8).Provider, {
        value: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bb6d010069fda365$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        hasSeparator: hasSeparator,
        id: id,
        isList: isList,
        isScrollable: isScrollable,
        overrides: overrides,
        testId: testId,
        titleId: title ? titleId : undefined
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $23428f2f9e2005b2$export$2e2bcd8739ae039), {
        id: titleId,
        title: title
    }), children));
};
var $4efa9b4942c769d7$export$2e2bcd8739ae039 = $4efa9b4942c769d7$var$DropdownItemCheckboxGroup;


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");



var $c45aef576c3a1b33$var$_excluded = [
    "children",
    "id",
    "isList",
    "isScrollable",
    "title",
    "testId",
    "hasSeparator",
    "overrides"
];
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ var $c45aef576c3a1b33$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, title = _ref.title, testId = _ref.testId, hasSeparator = _ref.hasSeparator, overrides = _ref.overrides, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $c45aef576c3a1b33$var$_excluded);
    var uid = (0, $24526c38f36cc756$export$f680877a34711e37)();
    var titleId = "dropdown-menu-item-group-title-".concat(uid);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bb6d010069fda365$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        overrides: overrides
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $23428f2f9e2005b2$export$2e2bcd8739ae039), {
        id: titleId,
        title: title
    }), children);
});
var $c45aef576c3a1b33$export$2e2bcd8739ae039 = $c45aef576c3a1b33$var$DropdownMenuItemGroup;


var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");




var $dVGJk = parcelRequire("dVGJk");

var $5FkrB = parcelRequire("5FkrB");


var $dVGJk = parcelRequire("dVGJk");

/**
 * __Radio icon__
 *
 * Used to visually represent the selected state in DropdownItemRadio
 *
 * @internal
 */ var $6f640f39f2f07b66$var$RadioIcon = function RadioIcon(_ref) {
    var checked = _ref.checked;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1b6d57c283ee4ca6$export$2e2bcd8739ae039), {
        label: "",
        size: "medium",
        primaryColor: checked ? "var(--ds-background-selected-bold, ".concat((0, $d879fc455f6e75a0$export$b3de0ae08da2ce64), ")") : "var(--ds-background-input, ".concat((0, $d879fc455f6e75a0$export$e655ef011c4aa1a2), ")"),
        secondaryColor: checked ? "var(--ds-icon-inverse, ".concat((0, $d879fc455f6e75a0$export$e655ef011c4aa1a2), ")") : 'transparent'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("g", {
        fillRule: "evenodd"
    }, // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
    (0, $dVGJk.fg)('platform-visual-refresh-icons') && (0, $dVGJk.fg)('platform-icon-control-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "7.5",
        fill: "currentColor",
        stroke: checked ? "var(--ds-border-selected, ".concat((0, $d879fc455f6e75a0$export$b3de0ae08da2ce64), ")") : "var(--ds-border-input, ".concat((0, $d879fc455f6e75a0$export$d6447c357493214f), ")"),
        strokeWidth: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "3",
        fill: "inherit"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        fill: "currentColor",
        cx: "12",
        cy: "12",
        r: "6",
        stroke: checked ? "var(--ds-border-selected, ".concat((0, $d879fc455f6e75a0$export$b3de0ae08da2ce64), ")") : "var(--ds-border-input, ".concat((0, $d879fc455f6e75a0$export$d6447c357493214f), ")"),
        strokeWidth: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        fill: "inherit",
        cx: "12",
        cy: "12",
        r: "2"
    }))));
};
var $6f640f39f2f07b66$export$2e2bcd8739ae039 = $6f640f39f2f07b66$var$RadioIcon;



var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");






var $25nEq = parcelRequire("25nEq");
function $db8e4a3eb620c41f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $db8e4a3eb620c41f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $db8e4a3eb620c41f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $db8e4a3eb620c41f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $db8e4a3eb620c41f$var$resetOptionsInGroup = function resetOptionsInGroup(group) {
    return Object.keys(group || {}).reduce(function(accumulator, current) {
        return $db8e4a3eb620c41f$var$_objectSpread($db8e4a3eb620c41f$var$_objectSpread({}, accumulator), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, current, typeof group[current] === 'undefined' ? undefined : false));
    }, {});
};
var $db8e4a3eb620c41f$export$2e2bcd8739ae039 = $db8e4a3eb620c41f$var$resetOptionsInGroup;


var $d7f1a7874207c75a$var$_excluded = [
    "children",
    "hasSeparator",
    "id",
    "isList",
    "isScrollable",
    "overrides",
    "testId",
    "title"
];
function $d7f1a7874207c75a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d7f1a7874207c75a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d7f1a7874207c75a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d7f1a7874207c75a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d7f1a7874207c75a$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    id: '',
    radioGroupState: {},
    selectRadioItem: (0, $3a341012e037de4f$export$2e2bcd8739ae039)
});
/**
 * __Dropdown item radio group__
 *  Store which manages the selection state for each DropdownItemRadio
 *  across mount and unmounts.
 *
 */ var $d7f1a7874207c75a$var$DropdownItemRadioGroup = function DropdownItemRadioGroup(_ref) {
    var children = _ref.children, hasSeparator = _ref.hasSeparator, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, overrides = _ref.overrides, testId = _ref.testId, title = _ref.title, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $d7f1a7874207c75a$var$_excluded);
    var _useContext = (0, $5FkrB.useContext)((0, $6c8d7d354dcb5a30$export$756f795847463ebd)), setGroupState = _useContext.setGroupState, getGroupState = _useContext.getGroupState;
    var uid = (0, $24526c38f36cc756$export$f680877a34711e37)();
    var titleId = "dropdown-menu-item-radio-group-title-".concat(uid);
    /**
   *  - initially `radioGroupState` is from selection store, so it's safe to update without re-rendering
   *  - we flush a render by updating this local radio group state
   */ var _useState = (0, $5FkrB.useState)(function() {
        return getGroupState(id);
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), radioGroupState = _useState2[0], setRadioGroupState = _useState2[1];
    var selectRadioItem = function selectRadioItem(childId, value) {
        var newValue = $d7f1a7874207c75a$var$_objectSpread($d7f1a7874207c75a$var$_objectSpread({}, (0, $db8e4a3eb620c41f$export$2e2bcd8739ae039)(getGroupState(id))), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, childId, value));
        setRadioGroupState(newValue);
        setGroupState(id, newValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($d7f1a7874207c75a$export$a79eda4ff50e30b6.Provider, {
        value: {
            id: id,
            radioGroupState: radioGroupState,
            selectRadioItem: selectRadioItem
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bb6d010069fda365$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        hasSeparator: hasSeparator,
        id: id,
        isList: isList,
        isScrollable: isScrollable,
        overrides: overrides,
        testId: testId,
        titleId: title ? titleId : undefined
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $23428f2f9e2005b2$export$2e2bcd8739ae039), {
        id: titleId,
        title: title
    }), children));
};
var $d7f1a7874207c75a$export$2e2bcd8739ae039 = $d7f1a7874207c75a$var$DropdownItemRadioGroup;




function $2bb515b7d71ee3c9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2bb515b7d71ee3c9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2bb515b7d71ee3c9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2bb515b7d71ee3c9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2bb515b7d71ee3c9$var$useRadioState(_ref) {
    var id = _ref.id, isSelected = _ref.isSelected, defaultSelected = _ref.defaultSelected;
    var _useContext = (0, $5FkrB.useContext)((0, $6c8d7d354dcb5a30$export$756f795847463ebd)), setGroupState = _useContext.setGroupState, getGroupState = _useContext.getGroupState;
    var _useContext2 = (0, $5FkrB.useContext)((0, $d7f1a7874207c75a$export$a79eda4ff50e30b6)), group = _useContext2.id, radioGroupState = _useContext2.radioGroupState, selectRadioItem = _useContext2.selectRadioItem;
    var persistedIsSelected = radioGroupState[id];
    var _useState = (0, $5FkrB.useState)(function() {
        return persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), localIsSelected = _useState2[0], setLocalIsSelected = _useState2[1];
    var setLocalState = (0, $5FkrB.useCallback)(function(newValue) {
        if (!persistedIsSelected) {
            var nextValue = newValue(persistedIsSelected);
            selectRadioItem(id, nextValue);
            setLocalIsSelected(nextValue);
        }
    }, [
        persistedIsSelected,
        id,
        selectRadioItem
    ]);
    /**
   * - radio state changes any time a radio child is changed
   * - when it changes we want all radio buttons to update their local state
   * - it takes the value from radio group state and applies it locally if it exists which it will only exist, if it is selected
   */ (0, $5FkrB.useEffect)(function() {
        setLocalIsSelected(function() {
            var existing = radioGroupState[id];
            return existing !== undefined ? existing : defaultSelected || false;
        });
    }, [
        radioGroupState,
        group,
        id,
        defaultSelected
    ]);
    if (typeof isSelected === 'boolean') return [
        isSelected,
        function() {
            return false;
        }
    ];
    if (persistedIsSelected === undefined) {
        var existing = getGroupState(group);
        setGroupState(group, $2bb515b7d71ee3c9$var$_objectSpread($2bb515b7d71ee3c9$var$_objectSpread({}, (0, $db8e4a3eb620c41f$export$2e2bcd8739ae039)(existing || {})), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, id, defaultSelected || false)));
    }
    return [
        localIsSelected,
        setLocalState
    ];
}
var $2bb515b7d71ee3c9$export$2e2bcd8739ae039 = $2bb515b7d71ee3c9$var$useRadioState;



var $16d5fae6b7e2571d$var$canUseDOM = function canUseDOM() {
    return Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
};
/*
 * Making sure we can fallback to browsers doesn't support voice over -
 * we would using menuitemcheckbox / menuitemradio for these that supports voice over, and
 * will fallback to checkbox / radio for these doesn't
 */ var $16d5fae6b7e2571d$var$isVoiceOverSupported = function isVoiceOverSupported() {
    return /Mac OS X/.test($16d5fae6b7e2571d$var$canUseDOM() ? navigator.userAgent : '');
};
var $16d5fae6b7e2571d$export$2e2bcd8739ae039 = $16d5fae6b7e2571d$var$isVoiceOverSupported;



var $3ZMUU = parcelRequire("3ZMUU");
var $2f6caa8af3b1a588$var$_excluded = [
    "children",
    "defaultSelected",
    "testId",
    "id",
    "title",
    "description",
    "isDisabled",
    "isSelected",
    "onClick",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "interactionName"
];
/**
 * __Dropdown item radio__
 *
 * A dropdown item radio displays groups that have a single selection.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/usage)
 */ var $2f6caa8af3b1a588$var$DropdownItemRadio = function DropdownItemRadio(_ref) {
    var children = _ref.children, defaultSelected = _ref.defaultSelected, testId = _ref.testId, id = _ref.id, title = _ref.title, description = _ref.description, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $3a341012e037de4f$export$2e2bcd8739ae039) : _ref$onClick, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $2f6caa8af3b1a588$var$_excluded);
    typeof $3ZMUU;
    var _useRadioState = (0, $2bb515b7d71ee3c9$export$2e2bcd8739ae039)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    }), _useRadioState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useRadioState, 2), selected = _useRadioState2[0], setSelected = _useRadioState2[1];
    var onClickHandler = (0, $5FkrB.useCallback)(function(event) {
        setSelected(function(selected) {
            return !selected;
        });
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    var itemRef = (0, $342103062545c958$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $029784b0740265a3$export$9ca534b70725964d).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $deae49ab7e32e8cd$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6f640f39f2f07b66$export$2e2bcd8739ae039), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: (0, $16d5fae6b7e2571d$export$2e2bcd8739ae039)() ? 'radio' : 'menuitemradio',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        title: title
    }, (0, $dVGJk.fg)('platform_button_item-add-ufo-metrics') && {
        interactionName: interactionName
    }, rest), children));
};
var $2f6caa8af3b1a588$export$2e2bcd8739ae039 = $2f6caa8af3b1a588$var$DropdownItemRadio;




var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $6ILNo = parcelRequire("6ILNo");

var $jOmHm = parcelRequire("jOmHm");

var $117fZ = parcelRequire("117fZ");

var $kpGHk = parcelRequire("kpGHk");

var $6ILNo = parcelRequire("6ILNo");
var $d41e3f84b1285b42$export$fc06342dc8588d3b = function getFirstErrorField(inputs, errors) {
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    var htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === 'hidden') return false;
        // If input ID matches the error, focus
        if (input.id && (0, $6ILNo.getIn)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, $6ILNo.getIn)(errors, input.name);
    });
};


function $916dd591feb93e13$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $916dd591feb93e13$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $916dd591feb93e13$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $916dd591feb93e13$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $916dd591feb93e13$export$c24727297075ec6a = /*#__PURE__*/ (0, $5FkrB.createContext)({
    registerField: function registerField() {
        return function() {};
    },
    getCurrentValue: function getCurrentValue() {
        return undefined;
    },
    subscribe: function subscribe() {
        return function() {};
    }
});
var $916dd591feb93e13$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
function $916dd591feb93e13$export$2e2bcd8739ae039(props) {
    var userProvidedFormProps = props.formProps, onSubmit = props.onSubmit, testId = props.testId;
    var formRef = (0, $5FkrB.useRef)(null);
    var onSubmitRef = (0, $5FkrB.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    var _useState = (0, $5FkrB.useState)(function() {
        // Types here would break the existing API
        var finalForm = (0, $6ILNo.createForm)({
            onSubmit: function onSubmit() {
                return onSubmitRef.current.apply(onSubmitRef, arguments);
            },
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: function setDefaultValue(_ref, state) {
                    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), name = _ref2[0], defaultValue = _ref2[1];
                    if (state.formState.initialValues) {
                        var initialValues = state.formState.initialValues;
                        var values = state.formState.values;
                        var _value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($117fZ)))(initialValues, name, _value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($117fZ)))(values, name, _value);
                    }
                }
            }
        });
        (0, $jOmHm.default)(function() {
            return formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [];
        }, (0, $kpGHk.fg)('platform-form-field-error-focus') ? (0, $d41e3f84b1285b42$export$fc06342dc8588d3b) : undefined)(finalForm);
        return finalForm;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 1), form = _useState2[0];
    var _useState3 = (0, $5FkrB.useState)({
        dirty: false,
        submitting: false
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), state = _useState4[0], setState = _useState4[1];
    (0, $5FkrB.useEffect)(function() {
        var unsubscribe = form.subscribe(function(_ref3) {
            var dirty = _ref3.dirty, submitting = _ref3.submitting;
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    var registerField = (0, $5FkrB.useCallback)(function(name, defaultValue, subscriber, subscription, config) {
        form.pauseValidation();
        var unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    var handleSubmit = function handleSubmit(e) {
        if (e) e.preventDefault();
        form.submit();
    };
    var handleReset = function handleReset(initialValues) {
        form.reset(initialValues);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            var submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    var _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, children = props.children;
    var dirty = state.dirty, submitting = state.submitting;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ var getCurrentValue = (0, $5FkrB.useCallback)(function(name) {
        var formState = form.getState();
        return (formState === null || formState === void 0 ? void 0 : formState.values[name]) || undefined;
    }, [
        form
    ]);
    var FormContextValue = (0, $5FkrB.useMemo)(function() {
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    // Abstracting so we can use the same for both rendering patterns
    var formProps = $916dd591feb93e13$var$_objectSpread({
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: formRef
    }, testId && {
        'data-testid': testId
    });
    var childrenContent = function() {
        if (typeof children === 'function') {
            var result = children.length > 0 ? children($916dd591feb93e13$var$_objectSpread({
                formProps: formProps,
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: function getState() {
                    return form.getState();
                },
                getValues: function getValues() {
                    return form.getState().values;
                },
                setFieldValue: form.change
            }, (0, $kpGHk.fg)('platform-form-reset-field-state') && {
                resetFieldState: form.resetFieldState
            })) : children();
            return result === undefined ? null : result;
        } else return (0, $kpGHk.fg)('platform_design-system-team_form-upgrade') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("form", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, formProps, userProvidedFormProps), children) : children;
    }();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($916dd591feb93e13$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($916dd591feb93e13$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, childrenContent));
}

/* messages.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $atP8S = parcelRequire("atP8S");
var $9768e521609fe02c$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f636032ea4a949f6a3ed21b2a88730cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($9768e521609fe02c$exports, "__esModule", {
    value: true
});
$9768e521609fe02c$exports.default = void 0;

var $9768e521609fe02c$var$_react = $9768e521609fe02c$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $9768e521609fe02c$var$_statusError = $9768e521609fe02c$var$_interopRequireDefault((parcelRequire("coPW0")));

var $9768e521609fe02c$var$_error = $9768e521609fe02c$var$_interopRequireDefault((parcelRequire("1yYLz")));
function $9768e521609fe02c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9768e521609fe02c$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $9768e521609fe02c$var$_react.default.createElement($9768e521609fe02c$var$_statusError.default, Object.assign({
        name: "StatusErrorIcon",
        LEGACY_fallbackIcon: $9768e521609fe02c$var$_error.default
    }, props));
$9768e521609fe02c$var$StatusErrorIcon.displayName = 'StatusErrorIconMigration';
var $9768e521609fe02c$var$_default = $9768e521609fe02c$exports.default = $9768e521609fe02c$var$StatusErrorIcon;


var $b40aa0df80f33508$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::849e146248de3896aa5effb6cb325c8d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($b40aa0df80f33508$exports, "__esModule", {
    value: true
});
$b40aa0df80f33508$exports.default = void 0;

var $b40aa0df80f33508$var$_react = $b40aa0df80f33508$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $b40aa0df80f33508$var$_statusSuccess = $b40aa0df80f33508$var$_interopRequireDefault((parcelRequire("bQGRN")));

var $b40aa0df80f33508$var$_success = $b40aa0df80f33508$var$_interopRequireDefault((parcelRequire("6AF9r")));
function $b40aa0df80f33508$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b40aa0df80f33508$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $b40aa0df80f33508$var$_react.default.createElement($b40aa0df80f33508$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $b40aa0df80f33508$var$_success.default
    }, props));
$b40aa0df80f33508$var$StatusSuccessIcon.displayName = 'StatusSuccessIconMigration';
var $b40aa0df80f33508$var$_default = $b40aa0df80f33508$exports.default = $b40aa0df80f33508$var$StatusSuccessIcon;



var $kpGHk = parcelRequire("kpGHk");

var $5FkrB = parcelRequire("5FkrB");
var $56b9ed80af5bcb03$export$3c4232819458a302 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);


/**
 * API for the internal `<Message />` component. This is not public API.
 */ /**
 * Public API of the various message components.
 */ var $3433a9f6c8d902bf$var$messageStyles = null;
var $3433a9f6c8d902bf$var$messageAppearanceStyles = {
    default: "_syaz1wmz",
    error: "_syaze6sf",
    valid: "_syazy73q"
};
var $3433a9f6c8d902bf$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
var $3433a9f6c8d902bf$var$IconWrapper = function IconWrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $atP8S.default)([
            $3433a9f6c8d902bf$var$iconWrapperStyles.root
        ])
    }, children);
};
var $3433a9f6c8d902bf$var$messageIcons = {
    error: /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9768e521609fe02c$exports))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($b40aa0df80f33508$exports))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success",
        size: "small"
    })
};
var $3433a9f6c8d902bf$var$Message = function Message(_ref2) {
    var children = _ref2.children, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'default' : _ref2$appearance, fieldId = _ref2.fieldId, testId = _ref2.testId;
    var icon = $3433a9f6c8d902bf$var$messageIcons[appearance];
    var _useContext = (0, $5FkrB.useContext)($3433a9f6c8d902bf$var$MessageWrapperContext), isWrapper = _useContext.isWrapper;
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), shouldRenderAfterDelay = _useState2[0], setShouldRenderAfterDelay = _useState2[1];
    // TODO: DSP-23603 - To clean up when removing "platform_dst_form_screenreader_message_fix" feature flag
    var isDelayRenderEnabled = (0, $kpGHk.fg)('platform_dst_form_screenreader_message_fix') && !isWrapper;
    (0, $5FkrB.useEffect)(function() {
        if (isDelayRenderEnabled) {
            // Only delay rendering if there is no wrapper and feature flag is enabled
            var timer = setTimeout(function() {
                setShouldRenderAfterDelay(true);
            }, 10);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        isDelayRenderEnabled
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ var content = typeof children === 'string' ? children : /*#__PURE__*/ $5FkrB.createElement("span", null, children);
    var childrenToRender = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, icon && /*#__PURE__*/ $5FkrB.createElement($3433a9f6c8d902bf$var$IconWrapper, null, icon), content);
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": testId,
        id: fieldId,
        "aria-live": !isWrapper ? 'polite' : undefined,
        className: (0, $atP8S.default)([
            "_zulp12x7 _11c8dcr7 _1e0c1txw _1bah1q9y _1pfh1b66",
            $3433a9f6c8d902bf$var$messageAppearanceStyles[appearance]
        ])
    }, isDelayRenderEnabled ? shouldRenderAfterDelay && childrenToRender : childrenToRender);
};
var $3433a9f6c8d902bf$export$8fbe3c7d0ed2c683 = function HelperMessage(_ref3) {
    var children = _ref3.children, testId = _ref3.testId;
    return /*#__PURE__*/ $5FkrB.createElement((0, $56b9ed80af5bcb03$export$3c4232819458a302).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $5FkrB.createElement($3433a9f6c8d902bf$var$Message, {
            fieldId: fieldId ? "".concat(fieldId, "-helper") : undefined,
            testId: testId
        }, children);
    });
};
var $3433a9f6c8d902bf$export$915e9e7bd4f0f96d = function ErrorMessage(_ref4) {
    var children = _ref4.children, testId = _ref4.testId;
    return /*#__PURE__*/ $5FkrB.createElement((0, $56b9ed80af5bcb03$export$3c4232819458a302).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $5FkrB.createElement($3433a9f6c8d902bf$var$Message, {
            appearance: "error",
            fieldId: fieldId ? "".concat(fieldId, "-error") : undefined,
            testId: testId
        }, children);
    });
};
var $3433a9f6c8d902bf$export$5505afb209a532c8 = function ValidMessage(_ref5) {
    var children = _ref5.children, testId = _ref5.testId;
    return /*#__PURE__*/ $5FkrB.createElement((0, $56b9ed80af5bcb03$export$3c4232819458a302).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $5FkrB.createElement($3433a9f6c8d902bf$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? "".concat(fieldId, "-valid") : undefined,
            testId: testId
        }, children);
    });
};
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ var $3433a9f6c8d902bf$var$MessageWrapperContext = /*#__PURE__*/ (0, $5FkrB.createContext)({
    isWrapper: false
});
var $3433a9f6c8d902bf$export$ec445f12f63100a5 = function MessageWrapper(_ref6) {
    var children = _ref6.children;
    var contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ $5FkrB.createElement($3433a9f6c8d902bf$var$MessageWrapperContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $atP8S = parcelRequire("atP8S");

var $5FkrB = parcelRequire("5FkrB");

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $kpGHk = parcelRequire("kpGHk");
var $c461177f06e9e5de$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $c461177f06e9e5de$var$react18UseId = ($c461177f06e9e5de$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $c461177f06e9e5de$var$_React$useId !== void 0 ? $c461177f06e9e5de$var$_React$useId : undefined;
function $c461177f06e9e5de$export$f680877a34711e37() {
    if ($c461177f06e9e5de$var$react18UseId && (0, $kpGHk.fg)('platform-dst-react-18-use-id')) {
        if ((0, $kpGHk.fg)('platform-dst-react-18-use-id-selector-safe')) // tl;dr: React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`
        // in hundreds of tests. So we replace it with a safe string of `_` to match future
        // React 19 functionality: https://github.com/facebook/react/pull/33422
        return $c461177f06e9e5de$var$react18UseId().replace(/[:«»]/g, '_');
        return $c461177f06e9e5de$var$react18UseId();
    }
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $c461177f06e9e5de$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($c461177f06e9e5de$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $c461177f06e9e5de$export$6ee17796e3d70de2() {
    if ($c461177f06e9e5de$var$react18UseId && (0, $kpGHk.fg)('platform-dst-react-18-use-id')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- cleanup with feature gating
        var uid = $c461177f06e9e5de$export$f680877a34711e37();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $b5lkZ.useUIDSeed)();
}



var $kpGHk = parcelRequire("kpGHk");


/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $atP8S = parcelRequire("atP8S");
var $5ac1013239c7eb7f$var$fieldsetLabelStyles = null;
var $5ac1013239c7eb7f$export$b04be29aa201d4f5 = function Label(_ref) {
    var children = _ref.children, htmlFor = _ref.htmlFor, id = _ref.id, testId = _ref.testId;
    return /*#__PURE__*/ $5FkrB.createElement("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $atP8S.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ])
    }, children);
};
var $5ac1013239c7eb7f$export$ed247974535929c7 = function Legend(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/ $5FkrB.createElement("legend", {
        className: (0, $atP8S.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ])
    }, children);
};



/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $atP8S = parcelRequire("atP8S");
var $83f0848311ef2185$var$requiredIndicatorStyles = null;
function $83f0848311ef2185$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $atP8S.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ])
    }, "*");
}


function $2111f5e4df021534$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2111f5e4df021534$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2111f5e4df021534$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2111f5e4df021534$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2111f5e4df021534$var$fieldWrapperStyles = null;
function $2111f5e4df021534$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $2111f5e4df021534$var$isFunction(x) {
    return typeof x === 'function';
}
// Must be exported to satisfy error TS4023 from Jira builds
// src/packages/servicedesk/virtual-agent/common/src/ui/base-text-field/index.tsx(10,14):
// error TS4023: Exported variable `BaseTextField` has or is using name
// `FieldComponentProps` from external module
// `/opt/atlassian/pipelines/agent/build/jira/tsDist/@atlaskit__form/app/src/field`
// but cannot be named.
function $2111f5e4df021534$var$usePreviousRef(current) {
    var ref = (0, $5FkrB.useRef)(current);
    // will be updated on the next render
    (0, $5FkrB.useEffect)(function() {
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $2111f5e4df021534$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(previousValue) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(currentValue) === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $2111f5e4df021534$export$2e2bcd8739ae039(props) {
    var _getCurrentValue;
    var _props$children = props.children, children = _props$children === void 0 ? function() {
        return null;
    } : _props$children, component = props.component;
    var _useContext = (0, $5FkrB.useContext)((0, $916dd591feb93e13$export$c24727297075ec6a)), registerField = _useContext.registerField, getCurrentValue = _useContext.getCurrentValue;
    var isDisabled = (0, $5FkrB.useContext)((0, $916dd591feb93e13$export$c17cf6b332a82dbc)) || props.isDisabled || false;
    var defaultValue = $2111f5e4df021534$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    var latestPropsRef = $2111f5e4df021534$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ var isDefaultValueChanged = !$2111f5e4df021534$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    var _useState = (0, $5FkrB.useState)({
        fieldProps: {
            onChange: function onChange() {},
            onBlur: function onBlur() {},
            onFocus: function onFocus() {},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
         * effectively made it an optional prop to external consumers of Field. However the
         * prop types defined defaultValue as required, so inside the component it was not
         * valid for defaultValue to be undefined. We need to suppress the error
         * after changing defaultValue to explicitly be an optional prop.
         * If default value has changed we are using new default value.
         * Otherwise we need to check if we already have value for this field
         * (because we are using changing key prop to re-run field level validation, and that
         * cause the component re-mounting) to not override the actual value with the default value.
         */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : (_getCurrentValue = getCurrentValue(props.name)) !== null && _getCurrentValue !== void 0 ? _getCurrentValue : defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var latestStateRef = $2111f5e4df021534$var$usePreviousRef(state);
    (0, $5FkrB.useEffect)(function() {
        function fieldStateToMeta() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        var unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $2111f5e4df021534$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, function(fieldState) {
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ var modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ var modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ var modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            var modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ var modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($2111f5e4df021534$var$isEvent(eventOrValue)) {
                    var currentTarget = eventOrValue.currentTarget;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: function onChange(e) {
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: function getValidator() {
                return function validate(value, formState, fieldState) {
                    var supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                };
            }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    var uid = (0, $c461177f06e9e5de$export$f680877a34711e37)();
    var fieldId = (0, $5FkrB.useMemo)(function() {
        return props.id ? props.id : "".concat(props.name, "-").concat(uid);
    }, [
        props.id,
        props.name,
        uid
    ]);
    var getDescribedBy = function getDescribedBy() {
        var value = '';
        if (state.error) value += "".concat(fieldId, "-error ");
        if (state.valid) value += "".concat(fieldId, "-valid ");
        return "".concat(value).concat(fieldId, "-helper");
    };
    var extendedFieldProps = $2111f5e4df021534$var$_objectSpread($2111f5e4df021534$var$_objectSpread({}, state.fieldProps), {}, {
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': "".concat(fieldId, "-label"),
        id: fieldId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        "data-testid": props.testId,
        className: (0, $atP8S.default)([
            "_1pfhu2gc"
        ])
    }, props.label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
        htmlFor: fieldId,
        id: "".concat(fieldId, "-label"),
        testId: props.testId && "".concat(props.testId, "--label")
    }, props.label, props.isRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $83f0848311ef2185$export$2e2bcd8739ae039), null), props.elementAfterLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $56b9ed80af5bcb03$export$3c4232819458a302).Provider, {
        value: fieldId
    }, component && (0, $kpGHk.fg)('platform_design-system-team_field-upgrade') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, component && component({
        fieldProps: extendedFieldProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3433a9f6c8d902bf$export$ec445f12f63100a5), null, props.helperMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3433a9f6c8d902bf$export$8fbe3c7d0ed2c683), null, props.helperMessage), state.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3433a9f6c8d902bf$export$915e9e7bd4f0f96d), null, props.errorMessage || state.error), state.meta.touched && state.valid && props.validMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3433a9f6c8d902bf$export$5505afb209a532c8), null, props.validMessage))) : children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

/* form-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $atP8S = parcelRequire("atP8S");
var $ab642ec49327e475$var$formFooterWrapperStyles = null;
var $ab642ec49327e475$var$justifyContentStyles = null;
function $ab642ec49327e475$export$2e2bcd8739ae039(_ref) {
    var _ref$align = _ref.align, align = _ref$align === void 0 ? 'end' : _ref$align, children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("footer", {
        className: (0, $atP8S.default)([
            "_1e0c1txw _1bahesu3 _1pfh1ejb",
            align === 'start' && "_1bah1y6m"
        ])
    }, children);
}


var $68426ff7d9d92e39$exports = {};
"use strict";
Object.defineProperty($68426ff7d9d92e39$exports, "__esModule", {
    value: true
});
$68426ff7d9d92e39$exports.default = void 0;

var $68426ff7d9d92e39$var$_react = $68426ff7d9d92e39$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $68426ff7d9d92e39$var$_showMoreHorizontal = $68426ff7d9d92e39$var$_interopRequireDefault((parcelRequire("8dIct")));
function $68426ff7d9d92e39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $68426ff7d9d92e39$var$MoreIcon = (props)=>/*#__PURE__*/ $68426ff7d9d92e39$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></g></svg>`
    }, props, {
        newIcon: $68426ff7d9d92e39$var$_showMoreHorizontal.default
    }));
$68426ff7d9d92e39$var$MoreIcon.displayName = 'MoreIcon';
var $68426ff7d9d92e39$var$_default = $68426ff7d9d92e39$exports.default = $68426ff7d9d92e39$var$MoreIcon;



var $igbF4 = parcelRequire("igbF4");
var $af69d9e57c55d6b7$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b480e25e279369257bb77bb164319fb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($af69d9e57c55d6b7$exports, "__esModule", {
    value: true
});
$af69d9e57c55d6b7$exports.default = void 0;

var $af69d9e57c55d6b7$var$_react = $af69d9e57c55d6b7$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $af69d9e57c55d6b7$var$_UNSAFE_baseNew = $af69d9e57c55d6b7$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $af69d9e57c55d6b7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Camera".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: upload photo in Trello, photos.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af69d9e57c55d6b7$var$CameraIcon = (props)=>/*#__PURE__*/ $af69d9e57c55d6b7$var$_react.default.createElement($af69d9e57c55d6b7$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M14 13.25H2c-.69 0-1.25-.56-1.25-1.25V5.25a2 2 0 0 1 2-2H4.5l1.5-2h4l1.5 2h1.75a2 2 0 0 1 2 2V12c0 .69-.56 1.25-1.25 1.25Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 8.25a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"/>`
    }, props));
$af69d9e57c55d6b7$var$CameraIcon.displayName = 'CameraIcon';
var $af69d9e57c55d6b7$var$_default = $af69d9e57c55d6b7$exports.default = $af69d9e57c55d6b7$var$CameraIcon;


var $1c94bc9aa532188d$exports = {};
typeof navigator === "object" && function(global1, factory) {
    $1c94bc9aa532188d$exports = factory();
}($1c94bc9aa532188d$exports, function() {
    'use strict';
    function _defineProperty$1(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _classCallCheck(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(e, t) {
        for(var n = 0; n < t.length; n++){
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
    }
    function _createClass(e, t, n) {
        return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e;
    }
    function _defineProperty(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n, e;
    }
    function ownKeys(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
        }
        return n;
    }
    function _objectSpread2(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ownKeys(Object(n), !0).forEach(function(t) {
                _defineProperty(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ownKeys(Object(n)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
        }
        return e;
    }
    var defaults$1 = {
        addCSS: !0,
        thumbWidth: 15,
        watch: !0
    };
    function matches$1(e, t) {
        return (function() {
            return Array.from(document.querySelectorAll(t)).includes(this);
        }).call(e, t);
    }
    function trigger(e, t) {
        if (e && t) {
            var n = new Event(t, {
                bubbles: !0
            });
            e.dispatchEvent(n);
        }
    }
    var getConstructor$1 = function(e) {
        return null != e ? e.constructor : null;
    }, instanceOf$1 = function(e, t) {
        return !!(e && t && e instanceof t);
    }, isNullOrUndefined$1 = function(e) {
        return null == e;
    }, isObject$1 = function(e) {
        return getConstructor$1(e) === Object;
    }, isNumber$1 = function(e) {
        return getConstructor$1(e) === Number && !Number.isNaN(e);
    }, isString$1 = function(e) {
        return getConstructor$1(e) === String;
    }, isBoolean$1 = function(e) {
        return getConstructor$1(e) === Boolean;
    }, isFunction$1 = function(e) {
        return getConstructor$1(e) === Function;
    }, isArray$1 = function(e) {
        return Array.isArray(e);
    }, isNodeList$1 = function(e) {
        return instanceOf$1(e, NodeList);
    }, isElement$1 = function(e) {
        return instanceOf$1(e, Element);
    }, isEvent$1 = function(e) {
        return instanceOf$1(e, Event);
    }, isEmpty$1 = function(e) {
        return isNullOrUndefined$1(e) || (isString$1(e) || isArray$1(e) || isNodeList$1(e)) && !e.length || isObject$1(e) && !Object.keys(e).length;
    }, is$1 = {
        nullOrUndefined: isNullOrUndefined$1,
        object: isObject$1,
        number: isNumber$1,
        string: isString$1,
        boolean: isBoolean$1,
        function: isFunction$1,
        array: isArray$1,
        nodeList: isNodeList$1,
        element: isElement$1,
        event: isEvent$1,
        empty: isEmpty$1
    };
    function getDecimalPlaces(e) {
        var t = "".concat(e).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
        return t ? Math.max(0, (t[1] ? t[1].length : 0) - (t[2] ? +t[2] : 0)) : 0;
    }
    function round(e, t) {
        if (1 > t) {
            var n = getDecimalPlaces(t);
            return parseFloat(e.toFixed(n));
        }
        return Math.round(e / t) * t;
    }
    var RangeTouch = function() {
        function e(t, n) {
            _classCallCheck(this, e), is$1.element(t) ? this.element = t : is$1.string(t) && (this.element = document.querySelector(t)), is$1.element(this.element) && is$1.empty(this.element.rangeTouch) && (this.config = _objectSpread2({}, defaults$1, {}, n), this.init());
        }
        return _createClass(e, [
            {
                key: "init",
                value: function() {
                    e.enabled && (this.config.addCSS && (this.element.style.userSelect = "none", this.element.style.webKitUserSelect = "none", this.element.style.touchAction = "manipulation"), this.listeners(!0), this.element.rangeTouch = this);
                }
            },
            {
                key: "destroy",
                value: function() {
                    e.enabled && (this.config.addCSS && (this.element.style.userSelect = "", this.element.style.webKitUserSelect = "", this.element.style.touchAction = ""), this.listeners(!1), this.element.rangeTouch = null);
                }
            },
            {
                key: "listeners",
                value: function(e) {
                    var t = this, n = e ? "addEventListener" : "removeEventListener";
                    [
                        "touchstart",
                        "touchmove",
                        "touchend"
                    ].forEach(function(e) {
                        t.element[n](e, function(e) {
                            return t.set(e);
                        }, !1);
                    });
                }
            },
            {
                key: "get",
                value: function(t) {
                    if (!e.enabled || !is$1.event(t)) return null;
                    var n, r = t.target, i = t.changedTouches[0], o = parseFloat(r.getAttribute("min")) || 0, s = parseFloat(r.getAttribute("max")) || 100, u = parseFloat(r.getAttribute("step")) || 1, c = r.getBoundingClientRect(), a = 100 / c.width * (this.config.thumbWidth / 2) / 100;
                    return 0 > (n = 100 / c.width * (i.clientX - c.left)) ? n = 0 : 100 < n && (n = 100), 50 > n ? n -= (100 - 2 * n) * a : 50 < n && (n += 2 * (n - 50) * a), o + round(n / 100 * (s - o), u);
                }
            },
            {
                key: "set",
                value: function(t) {
                    e.enabled && is$1.event(t) && !t.target.disabled && (t.preventDefault(), t.target.value = this.get(t), trigger(t.target, "touchend" === t.type ? "change" : "input"));
                }
            }
        ], [
            {
                key: "setup",
                value: function(t) {
                    var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, r = null;
                    if (is$1.empty(t) || is$1.string(t) ? r = Array.from(document.querySelectorAll(is$1.string(t) ? t : 'input[type="range"]')) : is$1.element(t) ? r = [
                        t
                    ] : is$1.nodeList(t) ? r = Array.from(t) : is$1.array(t) && (r = t.filter(is$1.element)), is$1.empty(r)) return null;
                    var i = _objectSpread2({}, defaults$1, {}, n);
                    if (is$1.string(t) && i.watch) {
                        var o = new MutationObserver(function(n) {
                            Array.from(n).forEach(function(n) {
                                Array.from(n.addedNodes).forEach(function(n) {
                                    is$1.element(n) && matches$1(n, t) && new e(n, i);
                                });
                            });
                        });
                        o.observe(document.body, {
                            childList: !0,
                            subtree: !0
                        });
                    }
                    return r.map(function(t) {
                        return new e(t, n);
                    });
                }
            },
            {
                key: "enabled",
                get: function() {
                    return "ontouchstart" in document.documentElement;
                }
            }
        ]), e;
    }();
    // ==========================================================================
    // Type checking utils
    // ==========================================================================
    const getConstructor = (input)=>input !== null && typeof input !== 'undefined' ? input.constructor : null;
    const instanceOf = (input, constructor)=>Boolean(input && constructor && input instanceof constructor);
    const isNullOrUndefined = (input)=>input === null || typeof input === 'undefined';
    const isObject = (input)=>getConstructor(input) === Object;
    const isNumber = (input)=>getConstructor(input) === Number && !Number.isNaN(input);
    const isString = (input)=>getConstructor(input) === String;
    const isBoolean = (input)=>getConstructor(input) === Boolean;
    const isFunction = (input)=>typeof input === 'function';
    const isArray = (input)=>Array.isArray(input);
    const isWeakMap = (input)=>instanceOf(input, WeakMap);
    const isNodeList = (input)=>instanceOf(input, NodeList);
    const isTextNode = (input)=>getConstructor(input) === Text;
    const isEvent = (input)=>instanceOf(input, Event);
    const isKeyboardEvent = (input)=>instanceOf(input, KeyboardEvent);
    const isCue = (input)=>instanceOf(input, window.TextTrackCue) || instanceOf(input, window.VTTCue);
    const isTrack = (input)=>instanceOf(input, TextTrack) || !isNullOrUndefined(input) && isString(input.kind);
    const isPromise = (input)=>instanceOf(input, Promise) && isFunction(input.then);
    const isElement = (input)=>input !== null && typeof input === 'object' && input.nodeType === 1 && typeof input.style === 'object' && typeof input.ownerDocument === 'object';
    const isEmpty = (input)=>isNullOrUndefined(input) || (isString(input) || isArray(input) || isNodeList(input)) && !input.length || isObject(input) && !Object.keys(input).length;
    const isUrl = (input)=>{
        // Accept a URL object
        if (instanceOf(input, window.URL)) return true;
        // Must be string from here
        if (!isString(input)) return false;
        // Add the protocol if required
        let string = input;
        if (!input.startsWith('http://') || !input.startsWith('https://')) string = `http://${input}`;
        try {
            return !isEmpty(new URL(string).hostname);
        } catch (_) {
            return false;
        }
    };
    var is = {
        nullOrUndefined: isNullOrUndefined,
        object: isObject,
        number: isNumber,
        string: isString,
        boolean: isBoolean,
        function: isFunction,
        array: isArray,
        weakMap: isWeakMap,
        nodeList: isNodeList,
        element: isElement,
        textNode: isTextNode,
        event: isEvent,
        keyboardEvent: isKeyboardEvent,
        cue: isCue,
        track: isTrack,
        promise: isPromise,
        url: isUrl,
        empty: isEmpty
    };
    // ==========================================================================
    const transitionEndEvent = (()=>{
        const element = document.createElement('span');
        const events = {
            WebkitTransition: 'webkitTransitionEnd',
            MozTransition: 'transitionend',
            OTransition: 'oTransitionEnd otransitionend',
            transition: 'transitionend'
        };
        const type = Object.keys(events).find((event)=>element.style[event] !== undefined);
        return is.string(type) ? events[type] : false;
    })();
    // Force repaint of element
    function repaint(element, delay) {
        setTimeout(()=>{
            try {
                // eslint-disable-next-line no-param-reassign
                element.hidden = true;
                // eslint-disable-next-line no-unused-expressions
                element.offsetHeight;
                // eslint-disable-next-line no-param-reassign
                element.hidden = false;
            } catch (_) {
            // Do nothing
            }
        }, delay);
    }
    // ==========================================================================
    // Browser sniffing
    // Unfortunately, due to mixed support, UA sniffing is required
    // ==========================================================================
    const browser = {
        isIE: Boolean(window.document.documentMode),
        isEdge: /Edge/g.test(navigator.userAgent),
        isWebkit: 'WebkitAppearance' in document.documentElement.style && !/Edge/g.test(navigator.userAgent),
        isIPhone: /iPhone|iPod/gi.test(navigator.userAgent) && navigator.maxTouchPoints > 1,
        isIos: /iPad|iPhone|iPod/gi.test(navigator.userAgent) && navigator.maxTouchPoints > 1
    };
    // ==========================================================================
    // Clone nested objects
    function cloneDeep(object) {
        return JSON.parse(JSON.stringify(object));
    }
    // Get a nested value in an object
    function getDeep(object, path) {
        return path.split('.').reduce((obj, key)=>obj && obj[key], object);
    }
    // Deep extend destination object with N more objects
    function extend(target = {}, ...sources) {
        if (!sources.length) return target;
        const source = sources.shift();
        if (!is.object(source)) return target;
        Object.keys(source).forEach((key)=>{
            if (is.object(source[key])) {
                if (!Object.keys(target).includes(key)) Object.assign(target, {
                    [key]: {}
                });
                extend(target[key], source[key]);
            } else Object.assign(target, {
                [key]: source[key]
            });
        });
        return extend(target, ...sources);
    }
    // ==========================================================================
    // Wrap an element
    function wrap(elements, wrapper) {
        // Convert `elements` to an array, if necessary.
        const targets = elements.length ? elements : [
            elements
        ];
        // Loops backwards to prevent having to clone the wrapper on the
        // first element (see `child` below).
        Array.from(targets).reverse().forEach((element, index)=>{
            const child = index > 0 ? wrapper.cloneNode(true) : wrapper;
            // Cache the current parent and sibling.
            const parent = element.parentNode;
            const sibling = element.nextSibling;
            // Wrap the element (is automatically removed from its current
            // parent).
            child.appendChild(element);
            // If the element had a sibling, insert the wrapper before
            // the sibling to maintain the HTML structure; otherwise, just
            // append it to the parent.
            if (sibling) parent.insertBefore(child, sibling);
            else parent.appendChild(child);
        });
    }
    // Set attributes
    function setAttributes(element, attributes) {
        if (!is.element(element) || is.empty(attributes)) return;
        // Assume null and undefined attributes should be left out,
        // Setting them would otherwise convert them to "null" and "undefined"
        Object.entries(attributes).filter(([, value])=>!is.nullOrUndefined(value)).forEach(([key, value])=>element.setAttribute(key, value));
    }
    // Create a DocumentFragment
    function createElement(type, attributes, text) {
        // Create a new <element>
        const element = document.createElement(type);
        // Set all passed attributes
        if (is.object(attributes)) setAttributes(element, attributes);
        // Add text node
        if (is.string(text)) element.innerText = text;
        // Return built element
        return element;
    }
    // Inaert an element after another
    function insertAfter(element, target) {
        if (!is.element(element) || !is.element(target)) return;
        target.parentNode.insertBefore(element, target.nextSibling);
    }
    // Insert a DocumentFragment
    function insertElement(type, parent, attributes, text) {
        if (!is.element(parent)) return;
        parent.appendChild(createElement(type, attributes, text));
    }
    // Remove element(s)
    function removeElement(element) {
        if (is.nodeList(element) || is.array(element)) {
            Array.from(element).forEach(removeElement);
            return;
        }
        if (!is.element(element) || !is.element(element.parentNode)) return;
        element.parentNode.removeChild(element);
    }
    // Remove all child elements
    function emptyElement(element) {
        if (!is.element(element)) return;
        let { length: length } = element.childNodes;
        while(length > 0){
            element.removeChild(element.lastChild);
            length -= 1;
        }
    }
    // Replace element
    function replaceElement(newChild, oldChild) {
        if (!is.element(oldChild) || !is.element(oldChild.parentNode) || !is.element(newChild)) return null;
        oldChild.parentNode.replaceChild(newChild, oldChild);
        return newChild;
    }
    // Get an attribute object from a string selector
    function getAttributesFromSelector(sel, existingAttributes) {
        // For example:
        // '.test' to { class: 'test' }
        // '#test' to { id: 'test' }
        // '[data-test="test"]' to { 'data-test': 'test' }
        if (!is.string(sel) || is.empty(sel)) return {};
        const attributes = {};
        const existing = extend({}, existingAttributes);
        sel.split(',').forEach((s)=>{
            // Remove whitespace
            const selector = s.trim();
            const className = selector.replace('.', '');
            const stripped = selector.replace(/[[\]]/g, '');
            // Get the parts and value
            const parts = stripped.split('=');
            const [key] = parts;
            const value = parts.length > 1 ? parts[1].replace(/["']/g, '') : '';
            // Get the first character
            const start = selector.charAt(0);
            switch(start){
                case '.':
                    // Add to existing classname
                    if (is.string(existing.class)) attributes.class = `${existing.class} ${className}`;
                    else attributes.class = className;
                    break;
                case '#':
                    // ID selector
                    attributes.id = selector.replace('#', '');
                    break;
                case '[':
                    // Attribute selector
                    attributes[key] = value;
                    break;
            }
        });
        return extend(existing, attributes);
    }
    // Toggle hidden
    function toggleHidden(element, hidden) {
        if (!is.element(element)) return;
        let hide = hidden;
        if (!is.boolean(hide)) hide = !element.hidden;
        // eslint-disable-next-line no-param-reassign
        element.hidden = hide;
    }
    // Mirror Element.classList.toggle, with IE compatibility for "force" argument
    function toggleClass(element, className, force) {
        if (is.nodeList(element)) return Array.from(element).map((e)=>toggleClass(e, className, force));
        if (is.element(element)) {
            let method = 'toggle';
            if (typeof force !== 'undefined') method = force ? 'add' : 'remove';
            element.classList[method](className);
            return element.classList.contains(className);
        }
        return false;
    }
    // Has class name
    function hasClass(element, className) {
        return is.element(element) && element.classList.contains(className);
    }
    // Element matches selector
    function matches(element, selector) {
        const { prototype: prototype } = Element;
        function match() {
            return Array.from(document.querySelectorAll(selector)).includes(this);
        }
        const method = prototype.matches || prototype.webkitMatchesSelector || prototype.mozMatchesSelector || prototype.msMatchesSelector || match;
        return method.call(element, selector);
    }
    // Closest ancestor element matching selector (also tests element itself)
    function closest$1(element, selector) {
        const { prototype: prototype } = Element;
        // https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
        function closestElement() {
            let el = this;
            do {
                if (matches.matches(el, selector)) return el;
                el = el.parentElement || el.parentNode;
            }while (el !== null && el.nodeType === 1);
            return null;
        }
        const method = prototype.closest || closestElement;
        return method.call(element, selector);
    }
    // Find all elements
    function getElements(selector) {
        return this.elements.container.querySelectorAll(selector);
    }
    // Find a single element
    function getElement(selector) {
        return this.elements.container.querySelector(selector);
    }
    // Set focus and tab focus class
    function setFocus(element = null, tabFocus = false) {
        if (!is.element(element)) return;
        // Set regular focus
        element.focus({
            preventScroll: true
        });
        // If we want to mimic keyboard focus via tab
        if (tabFocus) toggleClass(element, this.config.classNames.tabFocus);
    }
    // ==========================================================================
    // Default codecs for checking mimetype support
    const defaultCodecs = {
        'audio/ogg': 'vorbis',
        'audio/wav': '1',
        'video/webm': 'vp8, vorbis',
        'video/mp4': 'avc1.42E01E, mp4a.40.2',
        'video/ogg': 'theora'
    };
    // Check for feature support
    const support = {
        // Basic support
        audio: 'canPlayType' in document.createElement('audio'),
        video: 'canPlayType' in document.createElement('video'),
        // Check for support
        // Basic functionality vs full UI
        check (type, provider, playsinline) {
            const canPlayInline = browser.isIPhone && playsinline && support.playsinline;
            const api = support[type] || provider !== 'html5';
            const ui = api && support.rangeInput && (type !== 'video' || !browser.isIPhone || canPlayInline);
            return {
                api: api,
                ui: ui
            };
        },
        // Picture-in-picture support
        // Safari & Chrome only currently
        pip: (()=>{
            // While iPhone's support picture-in-picture for some apps, seemingly Safari isn't one of them
            // It will throw the following error when trying to enter picture-in-picture
            // `NotSupportedError: The Picture-in-Picture mode is not supported.`
            if (browser.isIPhone) return false;
            // Safari
            // https://developer.apple.com/documentation/webkitjs/adding_picture_in_picture_to_your_safari_media_controls
            if (is.function(createElement('video').webkitSetPresentationMode)) return true;
            // Chrome
            // https://developers.google.com/web/updates/2018/10/watch-video-using-picture-in-picture
            if (document.pictureInPictureEnabled && !createElement('video').disablePictureInPicture) return true;
            return false;
        })(),
        // Airplay support
        // Safari only currently
        airplay: is.function(window.WebKitPlaybackTargetAvailabilityEvent),
        // Inline playback support
        // https://webkit.org/blog/6784/new-video-policies-for-ios/
        playsinline: 'playsInline' in document.createElement('video'),
        // Check for mime type support against a player instance
        // Credits: http://diveintohtml5.info/everything.html
        // Related: http://www.leanbackplayer.com/test/h5mt.html
        mime (input) {
            if (is.empty(input)) return false;
            const [mediaType] = input.split('/');
            let type = input;
            // Verify we're using HTML5 and there's no media type mismatch
            if (!this.isHTML5 || mediaType !== this.type) return false;
            // Add codec if required
            if (Object.keys(defaultCodecs).includes(type)) type += `; codecs="${defaultCodecs[input]}"`;
            try {
                return Boolean(type && this.media.canPlayType(type).replace(/no/, ''));
            } catch (_) {
                return false;
            }
        },
        // Check for textTracks support
        textTracks: 'textTracks' in document.createElement('video'),
        // <input type="range"> Sliders
        rangeInput: (()=>{
            const range = document.createElement('input');
            range.type = 'range';
            return range.type === 'range';
        })(),
        // Touch
        // NOTE: Remember a device can be mouse + touch enabled so we check on first touch event
        touch: 'ontouchstart' in document.documentElement,
        // Detect transitions support
        transitions: transitionEndEvent !== false,
        // Reduced motion iOS & MacOS setting
        // https://webkit.org/blog/7551/responsive-design-for-motion/
        reducedMotion: 'matchMedia' in window && window.matchMedia('(prefers-reduced-motion)').matches
    };
    // ==========================================================================
    // Check for passive event listener support
    // https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
    // https://www.youtube.com/watch?v=NPM6172J22g
    const supportsPassiveListeners = (()=>{
        // Test via a getter in the options object to see if the passive property is accessed
        let supported = false;
        try {
            const options = Object.defineProperty({}, 'passive', {
                get () {
                    supported = true;
                    return null;
                }
            });
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        } catch (_) {
        // Do nothing
        }
        return supported;
    })();
    // Toggle event listener
    function toggleListener(element, event, callback, toggle = false, passive = true, capture = false) {
        // Bail if no element, event, or callback
        if (!element || !('addEventListener' in element) || is.empty(event) || !is.function(callback)) return;
        // Allow multiple events
        const events = event.split(' ');
        // Build options
        // Default to just the capture boolean for browsers with no passive listener support
        let options = capture;
        // If passive events listeners are supported
        if (supportsPassiveListeners) options = {
            passive: // Whether the listener can be passive (i.e. default never prevented)
            passive,
            capture: // Whether the listener is a capturing listener or not
            capture
        };
        // If a single node is passed, bind the event listener
        events.forEach((type)=>{
            if (this && this.eventListeners && toggle) // Cache event listener
            this.eventListeners.push({
                element: element,
                type: type,
                callback: callback,
                options: options
            });
            element[toggle ? 'addEventListener' : 'removeEventListener'](type, callback, options);
        });
    }
    // Bind event handler
    function on(element, events = '', callback, passive = true, capture = false) {
        toggleListener.call(this, element, events, callback, true, passive, capture);
    }
    // Unbind event handler
    function off(element, events = '', callback, passive = true, capture = false) {
        toggleListener.call(this, element, events, callback, false, passive, capture);
    }
    // Bind once-only event handler
    function once(element, events = '', callback, passive = true, capture = false) {
        const onceCallback = (...args)=>{
            off(element, events, onceCallback, passive, capture);
            callback.apply(this, args);
        };
        toggleListener.call(this, element, events, onceCallback, true, passive, capture);
    }
    // Trigger event
    function triggerEvent(element, type = '', bubbles = false, detail = {}) {
        // Bail if no element
        if (!is.element(element) || is.empty(type)) return;
        // Create and dispatch the event
        const event = new CustomEvent(type, {
            bubbles: bubbles,
            detail: {
                ...detail,
                plyr: this
            }
        });
        // Dispatch the event
        element.dispatchEvent(event);
    }
    // Unbind all cached event listeners
    function unbindListeners() {
        if (this && this.eventListeners) {
            this.eventListeners.forEach((item)=>{
                const { element: element, type: type, callback: callback, options: options } = item;
                element.removeEventListener(type, callback, options);
            });
            this.eventListeners = [];
        }
    }
    // Run method when / if player is ready
    function ready() {
        return new Promise((resolve)=>this.ready ? setTimeout(resolve, 0) : on.call(this, this.elements.container, 'ready', resolve)).then(()=>{});
    }
    /**
   * Silence a Promise-like object.
   * This is useful for avoiding non-harmful, but potentially confusing "uncaught
   * play promise" rejection error messages.
   * @param  {Object} value An object that may or may not be `Promise`-like.
   */ function silencePromise(value) {
        if (is.promise(value)) value.then(null, ()=>{});
    }
    // ==========================================================================
    // Remove duplicates in an array
    function dedupe(array) {
        if (!is.array(array)) return array;
        return array.filter((item, index)=>array.indexOf(item) === index);
    }
    // Get the closest value in an array
    function closest(array, value) {
        if (!is.array(array) || !array.length) return null;
        return array.reduce((prev, curr)=>Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev);
    }
    // ==========================================================================
    // Check support for a CSS declaration
    function supportsCSS(declaration) {
        if (!window || !window.CSS) return false;
        return window.CSS.supports(declaration);
    }
    // Standard/common aspect ratios
    const standardRatios = [
        [
            1,
            1
        ],
        [
            4,
            3
        ],
        [
            3,
            4
        ],
        [
            5,
            4
        ],
        [
            4,
            5
        ],
        [
            3,
            2
        ],
        [
            2,
            3
        ],
        [
            16,
            10
        ],
        [
            10,
            16
        ],
        [
            16,
            9
        ],
        [
            9,
            16
        ],
        [
            21,
            9
        ],
        [
            9,
            21
        ],
        [
            32,
            9
        ],
        [
            9,
            32
        ]
    ].reduce((out, [x, y])=>({
            ...out,
            [x / y]: [
                x,
                y
            ]
        }), {});
    // Validate an aspect ratio
    function validateAspectRatio(input) {
        if (!is.array(input) && (!is.string(input) || !input.includes(':'))) return false;
        const ratio = is.array(input) ? input : input.split(':');
        return ratio.map(Number).every(is.number);
    }
    // Reduce an aspect ratio to it's lowest form
    function reduceAspectRatio(ratio) {
        if (!is.array(ratio) || !ratio.every(is.number)) return null;
        const [width, height] = ratio;
        const getDivider = (w, h)=>h === 0 ? w : getDivider(h, w % h);
        const divider = getDivider(width, height);
        return [
            width / divider,
            height / divider
        ];
    }
    // Calculate an aspect ratio
    function getAspectRatio(input) {
        const parse = (ratio)=>validateAspectRatio(ratio) ? ratio.split(':').map(Number) : null;
        // Try provided ratio
        let ratio = parse(input);
        // Get from config
        if (ratio === null) ratio = parse(this.config.ratio);
        // Get from embed
        if (ratio === null && !is.empty(this.embed) && is.array(this.embed.ratio)) ({ ratio: ratio } = this.embed);
        // Get from HTML5 video
        if (ratio === null && this.isHTML5) {
            const { videoWidth: videoWidth, videoHeight: videoHeight } = this.media;
            ratio = [
                videoWidth,
                videoHeight
            ];
        }
        return reduceAspectRatio(ratio);
    }
    // Set aspect ratio for responsive container
    function setAspectRatio(input) {
        if (!this.isVideo) return {};
        const { wrapper: wrapper } = this.elements;
        const ratio = getAspectRatio.call(this, input);
        if (!is.array(ratio)) return {};
        const [x, y] = reduceAspectRatio(ratio);
        const useNative = supportsCSS(`aspect-ratio: ${x}/${y}`);
        const padding = 100 / x * y;
        if (useNative) wrapper.style.aspectRatio = `${x}/${y}`;
        else wrapper.style.paddingBottom = `${padding}%`;
        // For Vimeo we have an extra <div> to hide the standard controls and UI
        if (this.isVimeo && !this.config.vimeo.premium && this.supported.ui) {
            const height = 100 / this.media.offsetWidth * parseInt(window.getComputedStyle(this.media).paddingBottom, 10);
            const offset = (height - padding) / (height / 50);
            if (this.fullscreen.active) wrapper.style.paddingBottom = null;
            else this.media.style.transform = `translateY(-${offset}%)`;
        } else if (this.isHTML5) wrapper.classList.add(this.config.classNames.videoFixedRatio);
        return {
            padding: padding,
            ratio: ratio
        };
    }
    // Round an aspect ratio to closest standard ratio
    function roundAspectRatio(x, y, tolerance = 0.05) {
        const ratio = x / y;
        const closestRatio = closest(Object.keys(standardRatios), ratio);
        // Check match is within tolerance
        if (Math.abs(closestRatio - ratio) <= tolerance) return standardRatios[closestRatio];
        // No match
        return [
            x,
            y
        ];
    }
    // Get the size of the viewport
    // https://stackoverflow.com/questions/1248081/how-to-get-the-browser-viewport-dimensions
    function getViewportSize() {
        const width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        const height = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        return [
            width,
            height
        ];
    }
    // ==========================================================================
    const html5 = {
        getSources () {
            if (!this.isHTML5) return [];
            const sources = Array.from(this.media.querySelectorAll('source'));
            // Filter out unsupported sources (if type is specified)
            return sources.filter((source)=>{
                const type = source.getAttribute('type');
                if (is.empty(type)) return true;
                return support.mime.call(this, type);
            });
        },
        // Get quality levels
        getQualityOptions () {
            // Whether we're forcing all options (e.g. for streaming)
            if (this.config.quality.forced) return this.config.quality.options;
            // Get sizes from <source> elements
            return html5.getSources.call(this).map((source)=>Number(source.getAttribute('size'))).filter(Boolean);
        },
        setup () {
            if (!this.isHTML5) return;
            const player = this;
            // Set speed options from config
            player.options.speed = player.config.speed.options;
            // Set aspect ratio if fixed
            if (!is.empty(this.config.ratio)) setAspectRatio.call(player);
            // Quality
            Object.defineProperty(player.media, 'quality', {
                get () {
                    // Get sources
                    const sources = html5.getSources.call(player);
                    const source = sources.find((s)=>s.getAttribute('src') === player.source);
                    // Return size, if match is found
                    return source && Number(source.getAttribute('size'));
                },
                set (input) {
                    if (player.quality === input) return;
                    // If we're using an external handler...
                    if (player.config.quality.forced && is.function(player.config.quality.onChange)) player.config.quality.onChange(input);
                    else {
                        // Get sources
                        const sources = html5.getSources.call(player);
                        // Get first match for requested size
                        const source = sources.find((s)=>Number(s.getAttribute('size')) === input);
                        // No matching source found
                        if (!source) return;
                        // Get current state
                        const { currentTime: currentTime, paused: paused, preload: preload, readyState: readyState, playbackRate: playbackRate } = player.media;
                        // Set new source
                        player.media.src = source.getAttribute('src');
                        // Prevent loading if preload="none" and the current source isn't loaded (#1044)
                        if (preload !== 'none' || readyState) {
                            // Restore time
                            player.once('loadedmetadata', ()=>{
                                player.speed = playbackRate;
                                player.currentTime = currentTime;
                                // Resume playing
                                if (!paused) silencePromise(player.play());
                            });
                            // Load new source
                            player.media.load();
                        }
                    }
                    // Trigger change event
                    triggerEvent.call(player, player.media, 'qualitychange', false, {
                        quality: input
                    });
                }
            });
        },
        // Cancel current network requests
        // See https://github.com/sampotts/plyr/issues/174
        cancelRequests () {
            if (!this.isHTML5) return;
            // Remove child sources
            removeElement(html5.getSources.call(this));
            // Set blank video src attribute
            // This is to prevent a MEDIA_ERR_SRC_NOT_SUPPORTED error
            // Info: http://stackoverflow.com/questions/32231579/how-to-properly-dispose-of-an-html5-video-and-close-socket-or-connection
            this.media.setAttribute('src', this.config.blankVideo);
            // Load the new empty source
            // This will cancel existing requests
            // See https://github.com/sampotts/plyr/issues/174
            this.media.load();
            // Debugging
            this.debug.log('Cancelled network requests');
        }
    };
    // ==========================================================================
    // Generate a random ID
    function generateId(prefix) {
        return `${prefix}-${Math.floor(Math.random() * 10000)}`;
    }
    // Format string
    function format(input, ...args) {
        if (is.empty(input)) return input;
        return input.toString().replace(/{(\d+)}/g, (match, i)=>args[i].toString());
    }
    // Get percentage
    function getPercentage(current, max) {
        if (current === 0 || max === 0 || Number.isNaN(current) || Number.isNaN(max)) return 0;
        return (current / max * 100).toFixed(2);
    }
    // Replace all occurrences of a string in a string
    const replaceAll = (input = '', find = '', replace = '')=>input.replace(new RegExp(find.toString().replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1'), 'g'), replace.toString());
    // Convert to title case
    const toTitleCase = (input = '')=>input.toString().replace(/\w\S*/g, (text)=>text.charAt(0).toUpperCase() + text.slice(1).toLowerCase());
    // Convert string to pascalCase
    function toPascalCase(input = '') {
        let string = input.toString();
        // Convert kebab case
        string = replaceAll(string, '-', ' ');
        // Convert snake case
        string = replaceAll(string, '_', ' ');
        // Convert to title case
        string = toTitleCase(string);
        // Convert to pascal case
        return replaceAll(string, ' ', '');
    }
    // Convert string to pascalCase
    function toCamelCase(input = '') {
        let string = input.toString();
        // Convert to pascal case
        string = toPascalCase(string);
        // Convert first character to lowercase
        return string.charAt(0).toLowerCase() + string.slice(1);
    }
    // Remove HTML from a string
    function stripHTML(source) {
        const fragment = document.createDocumentFragment();
        const element = document.createElement('div');
        fragment.appendChild(element);
        element.innerHTML = source;
        return fragment.firstChild.innerText;
    }
    // Like outerHTML, but also works for DocumentFragment
    function getHTML(element) {
        const wrapper = document.createElement('div');
        wrapper.appendChild(element);
        return wrapper.innerHTML;
    }
    // ==========================================================================
    // Skip i18n for abbreviations and brand names
    const resources = {
        pip: 'PIP',
        airplay: 'AirPlay',
        html5: 'HTML5',
        vimeo: 'Vimeo',
        youtube: 'YouTube'
    };
    const i18n = {
        get (key = '', config = {}) {
            if (is.empty(key) || is.empty(config)) return '';
            let string = getDeep(config.i18n, key);
            if (is.empty(string)) {
                if (Object.keys(resources).includes(key)) return resources[key];
                return '';
            }
            const replace = {
                '{seektime}': config.seekTime,
                '{title}': config.title
            };
            Object.entries(replace).forEach(([k, v])=>{
                string = replaceAll(string, k, v);
            });
            return string;
        }
    };
    class Storage {
        constructor(player){
            _defineProperty$1(this, "get", (key)=>{
                if (!Storage.supported || !this.enabled) return null;
                const store = window.localStorage.getItem(this.key);
                if (is.empty(store)) return null;
                const json = JSON.parse(store);
                return is.string(key) && key.length ? json[key] : json;
            });
            _defineProperty$1(this, "set", (object)=>{
                // Bail if we don't have localStorage support or it's disabled
                if (!Storage.supported || !this.enabled) return;
                // Can only store objectst
                if (!is.object(object)) return;
                // Get current storage
                let storage = this.get();
                // Default to empty object
                if (is.empty(storage)) storage = {};
                // Update the working copy of the values
                extend(storage, object);
                // Update storage
                try {
                    window.localStorage.setItem(this.key, JSON.stringify(storage));
                } catch (_) {
                // Do nothing
                }
            });
            this.enabled = player.config.storage.enabled;
            this.key = player.config.storage.key;
        }
        // Check for actual support (see if we can use it)
        static get supported() {
            try {
                if (!('localStorage' in window)) return false;
                const test = '___test';
                // Try to use it (it might be disabled, e.g. user is in private mode)
                // see: https://github.com/sampotts/plyr/issues/131
                window.localStorage.setItem(test, test);
                window.localStorage.removeItem(test);
                return true;
            } catch (_) {
                return false;
            }
        }
    }
    // ==========================================================================
    // Fetch wrapper
    // Using XHR to avoid issues with older browsers
    // ==========================================================================
    function fetch(url, responseType = 'text') {
        return new Promise((resolve, reject)=>{
            try {
                const request = new XMLHttpRequest();
                // Check for CORS support
                if (!('withCredentials' in request)) return;
                request.addEventListener('load', ()=>{
                    if (responseType === 'text') try {
                        resolve(JSON.parse(request.responseText));
                    } catch (_) {
                        resolve(request.responseText);
                    }
                    else resolve(request.response);
                });
                request.addEventListener('error', ()=>{
                    throw new Error(request.status);
                });
                request.open('GET', url, true);
                // Set the required response type
                request.responseType = responseType;
                request.send();
            } catch (error) {
                reject(error);
            }
        });
    }
    // ==========================================================================
    // Load an external SVG sprite
    function loadSprite(url, id) {
        if (!is.string(url)) return;
        const prefix = 'cache';
        const hasId = is.string(id);
        let isCached = false;
        const exists = ()=>document.getElementById(id) !== null;
        const update = (container, data)=>{
            // eslint-disable-next-line no-param-reassign
            container.innerHTML = data;
            // Check again incase of race condition
            if (hasId && exists()) return;
            // Inject the SVG to the body
            document.body.insertAdjacentElement('afterbegin', container);
        };
        // Only load once if ID set
        if (!hasId || !exists()) {
            const useStorage = Storage.supported;
            // Create container
            const container = document.createElement('div');
            container.setAttribute('hidden', '');
            if (hasId) container.setAttribute('id', id);
            // Check in cache
            if (useStorage) {
                const cached = window.localStorage.getItem(`${prefix}-${id}`);
                isCached = cached !== null;
                if (isCached) {
                    const data = JSON.parse(cached);
                    update(container, data.content);
                }
            }
            // Get the sprite
            fetch(url).then((result)=>{
                if (is.empty(result)) return;
                if (useStorage) try {
                    window.localStorage.setItem(`${prefix}-${id}`, JSON.stringify({
                        content: result
                    }));
                } catch (_) {
                // Do nothing
                }
                update(container, result);
            }).catch(()=>{});
        }
    }
    // ==========================================================================
    // Time helpers
    const getHours = (value)=>Math.trunc(value / 60 / 60 % 60, 10);
    const getMinutes = (value)=>Math.trunc(value / 60 % 60, 10);
    const getSeconds = (value)=>Math.trunc(value % 60, 10);
    // Format time to UI friendly string
    function formatTime(time = 0, displayHours = false, inverted = false) {
        // Bail if the value isn't a number
        if (!is.number(time)) return formatTime(undefined, displayHours, inverted);
        // Format time component to add leading zero
        const format = (value)=>`0${value}`.slice(-2);
        // Breakdown to hours, mins, secs
        let hours = getHours(time);
        const mins = getMinutes(time);
        const secs = getSeconds(time);
        // Do we need to display hours?
        if (displayHours || hours > 0) hours = `${hours}:`;
        else hours = '';
        // Render
        return `${inverted && time > 0 ? '-' : ''}${hours}${format(mins)}:${format(secs)}`;
    }
    // ==========================================================================
    // TODO: Don't export a massive object - break down and create class
    const controls = {
        // Get icon URL
        getIconUrl () {
            const url = new URL(this.config.iconUrl, window.location);
            const host = window.location.host ? window.location.host : window.top.location.host;
            const cors = url.host !== host || browser.isIE && !window.svg4everybody;
            return {
                url: this.config.iconUrl,
                cors: cors
            };
        },
        // Find the UI controls
        findElements () {
            try {
                this.elements.controls = getElement.call(this, this.config.selectors.controls.wrapper);
                // Buttons
                this.elements.buttons = {
                    play: getElements.call(this, this.config.selectors.buttons.play),
                    pause: getElement.call(this, this.config.selectors.buttons.pause),
                    restart: getElement.call(this, this.config.selectors.buttons.restart),
                    rewind: getElement.call(this, this.config.selectors.buttons.rewind),
                    fastForward: getElement.call(this, this.config.selectors.buttons.fastForward),
                    mute: getElement.call(this, this.config.selectors.buttons.mute),
                    pip: getElement.call(this, this.config.selectors.buttons.pip),
                    airplay: getElement.call(this, this.config.selectors.buttons.airplay),
                    settings: getElement.call(this, this.config.selectors.buttons.settings),
                    captions: getElement.call(this, this.config.selectors.buttons.captions),
                    fullscreen: getElement.call(this, this.config.selectors.buttons.fullscreen)
                };
                // Progress
                this.elements.progress = getElement.call(this, this.config.selectors.progress);
                // Inputs
                this.elements.inputs = {
                    seek: getElement.call(this, this.config.selectors.inputs.seek),
                    volume: getElement.call(this, this.config.selectors.inputs.volume)
                };
                // Display
                this.elements.display = {
                    buffer: getElement.call(this, this.config.selectors.display.buffer),
                    currentTime: getElement.call(this, this.config.selectors.display.currentTime),
                    duration: getElement.call(this, this.config.selectors.display.duration)
                };
                // Seek tooltip
                if (is.element(this.elements.progress)) this.elements.display.seekTooltip = this.elements.progress.querySelector(`.${this.config.classNames.tooltip}`);
                return true;
            } catch (error) {
                // Log it
                this.debug.warn('It looks like there is a problem with your custom controls HTML', error);
                // Restore native video controls
                this.toggleNativeControls(true);
                return false;
            }
        },
        // Create <svg> icon
        createIcon (type, attributes) {
            const namespace = 'http://www.w3.org/2000/svg';
            const iconUrl = controls.getIconUrl.call(this);
            const iconPath = `${!iconUrl.cors ? iconUrl.url : ''}#${this.config.iconPrefix}`;
            // Create <svg>
            const icon = document.createElementNS(namespace, 'svg');
            setAttributes(icon, extend(attributes, {
                'aria-hidden': 'true',
                focusable: 'false'
            }));
            // Create the <use> to reference sprite
            const use = document.createElementNS(namespace, 'use');
            const path = `${iconPath}-${type}`;
            // Set `href` attributes
            // https://github.com/sampotts/plyr/issues/460
            // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/xlink:href
            if ('href' in use) use.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);
            // Always set the older attribute even though it's "deprecated" (it'll be around for ages)
            use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', path);
            // Add <use> to <svg>
            icon.appendChild(use);
            return icon;
        },
        // Create hidden text label
        createLabel (key, attr = {}) {
            const text = i18n.get(key, this.config);
            const attributes = {
                ...attr,
                class: [
                    attr.class,
                    this.config.classNames.hidden
                ].filter(Boolean).join(' ')
            };
            return createElement('span', attributes, text);
        },
        // Create a badge
        createBadge (text) {
            if (is.empty(text)) return null;
            const badge = createElement('span', {
                class: this.config.classNames.menu.value
            });
            badge.appendChild(createElement('span', {
                class: this.config.classNames.menu.badge
            }, text));
            return badge;
        },
        // Create a <button>
        createButton (buttonType, attr) {
            const attributes = extend({}, attr);
            let type = toCamelCase(buttonType);
            const props = {
                element: 'button',
                toggle: false,
                label: null,
                icon: null,
                labelPressed: null,
                iconPressed: null
            };
            [
                'element',
                'icon',
                'label'
            ].forEach((key)=>{
                if (Object.keys(attributes).includes(key)) {
                    props[key] = attributes[key];
                    delete attributes[key];
                }
            });
            // Default to 'button' type to prevent form submission
            if (props.element === 'button' && !Object.keys(attributes).includes('type')) attributes.type = 'button';
            // Set class name
            if (Object.keys(attributes).includes('class')) {
                if (!attributes.class.split(' ').some((c)=>c === this.config.classNames.control)) extend(attributes, {
                    class: `${attributes.class} ${this.config.classNames.control}`
                });
            } else attributes.class = this.config.classNames.control;
            // Large play button
            switch(buttonType){
                case 'play':
                    props.toggle = true;
                    props.label = 'play';
                    props.labelPressed = 'pause';
                    props.icon = 'play';
                    props.iconPressed = 'pause';
                    break;
                case 'mute':
                    props.toggle = true;
                    props.label = 'mute';
                    props.labelPressed = 'unmute';
                    props.icon = 'volume';
                    props.iconPressed = 'muted';
                    break;
                case 'captions':
                    props.toggle = true;
                    props.label = 'enableCaptions';
                    props.labelPressed = 'disableCaptions';
                    props.icon = 'captions-off';
                    props.iconPressed = 'captions-on';
                    break;
                case 'fullscreen':
                    props.toggle = true;
                    props.label = 'enterFullscreen';
                    props.labelPressed = 'exitFullscreen';
                    props.icon = 'enter-fullscreen';
                    props.iconPressed = 'exit-fullscreen';
                    break;
                case 'play-large':
                    attributes.class += ` ${this.config.classNames.control}--overlaid`;
                    type = 'play';
                    props.label = 'play';
                    props.icon = 'play';
                    break;
                default:
                    if (is.empty(props.label)) props.label = type;
                    if (is.empty(props.icon)) props.icon = buttonType;
            }
            const button = createElement(props.element);
            // Setup toggle icon and labels
            if (props.toggle) {
                // Icon
                button.appendChild(controls.createIcon.call(this, props.iconPressed, {
                    class: 'icon--pressed'
                }));
                button.appendChild(controls.createIcon.call(this, props.icon, {
                    class: 'icon--not-pressed'
                }));
                // Label/Tooltip
                button.appendChild(controls.createLabel.call(this, props.labelPressed, {
                    class: 'label--pressed'
                }));
                button.appendChild(controls.createLabel.call(this, props.label, {
                    class: 'label--not-pressed'
                }));
            } else {
                button.appendChild(controls.createIcon.call(this, props.icon));
                button.appendChild(controls.createLabel.call(this, props.label));
            }
            // Merge and set attributes
            extend(attributes, getAttributesFromSelector(this.config.selectors.buttons[type], attributes));
            setAttributes(button, attributes);
            // We have multiple play buttons
            if (type === 'play') {
                if (!is.array(this.elements.buttons[type])) this.elements.buttons[type] = [];
                this.elements.buttons[type].push(button);
            } else this.elements.buttons[type] = button;
            return button;
        },
        // Create an <input type='range'>
        createRange (type, attributes) {
            // Seek input
            const input = createElement('input', extend(getAttributesFromSelector(this.config.selectors.inputs[type]), {
                type: 'range',
                min: 0,
                max: 100,
                step: 0.01,
                value: 0,
                autocomplete: 'off',
                // A11y fixes for https://github.com/sampotts/plyr/issues/905
                role: 'slider',
                'aria-label': i18n.get(type, this.config),
                'aria-valuemin': 0,
                'aria-valuemax': 100,
                'aria-valuenow': 0
            }, attributes));
            this.elements.inputs[type] = input;
            // Set the fill for webkit now
            controls.updateRangeFill.call(this, input);
            // Improve support on touch devices
            RangeTouch.setup(input);
            return input;
        },
        // Create a <progress>
        createProgress (type, attributes) {
            const progress = createElement('progress', extend(getAttributesFromSelector(this.config.selectors.display[type]), {
                min: 0,
                max: 100,
                value: 0,
                role: 'progressbar',
                'aria-hidden': true
            }, attributes));
            // Create the label inside
            if (type !== 'volume') {
                progress.appendChild(createElement('span', null, '0'));
                const suffixKey = {
                    played: 'played',
                    buffer: 'buffered'
                }[type];
                const suffix = suffixKey ? i18n.get(suffixKey, this.config) : '';
                progress.innerText = `% ${suffix.toLowerCase()}`;
            }
            this.elements.display[type] = progress;
            return progress;
        },
        // Create time display
        createTime (type, attrs) {
            const attributes = getAttributesFromSelector(this.config.selectors.display[type], attrs);
            const container = createElement('div', extend(attributes, {
                class: `${attributes.class ? attributes.class : ''} ${this.config.classNames.display.time} `.trim(),
                'aria-label': i18n.get(type, this.config)
            }), '00:00');
            // Reference for updates
            this.elements.display[type] = container;
            return container;
        },
        // Bind keyboard shortcuts for a menu item
        // We have to bind to keyup otherwise Firefox triggers a click when a keydown event handler shifts focus
        // https://bugzilla.mozilla.org/show_bug.cgi?id=1220143
        bindMenuItemShortcuts (menuItem, type) {
            // Navigate through menus via arrow keys and space
            on.call(this, menuItem, 'keydown keyup', (event)=>{
                // We only care about space and ⬆️ ⬇️️ ➡️
                if (![
                    'Space',
                    'ArrowUp',
                    'ArrowDown',
                    'ArrowRight'
                ].includes(event.key)) return;
                // Prevent play / seek
                event.preventDefault();
                event.stopPropagation();
                // We're just here to prevent the keydown bubbling
                if (event.type === 'keydown') return;
                const isRadioButton = matches(menuItem, '[role="menuitemradio"]');
                // Show the respective menu
                if (!isRadioButton && [
                    'Space',
                    'ArrowRight'
                ].includes(event.key)) controls.showMenuPanel.call(this, type, true);
                else {
                    let target;
                    if (event.key !== 'Space') {
                        if (event.key === 'ArrowDown' || isRadioButton && event.key === 'ArrowRight') {
                            target = menuItem.nextElementSibling;
                            if (!is.element(target)) target = menuItem.parentNode.firstElementChild;
                        } else {
                            target = menuItem.previousElementSibling;
                            if (!is.element(target)) target = menuItem.parentNode.lastElementChild;
                        }
                        setFocus.call(this, target, true);
                    }
                }
            }, false);
            // Enter will fire a `click` event but we still need to manage focus
            // So we bind to keyup which fires after and set focus here
            on.call(this, menuItem, 'keyup', (event)=>{
                if (event.key !== 'Return') return;
                controls.focusFirstMenuItem.call(this, null, true);
            });
        },
        // Create a settings menu item
        createMenuItem ({ value: value, list: list, type: type, title: title, badge: badge = null, checked: checked = false }) {
            const attributes = getAttributesFromSelector(this.config.selectors.inputs[type]);
            const menuItem = createElement('button', extend(attributes, {
                type: 'button',
                role: 'menuitemradio',
                class: `${this.config.classNames.control} ${attributes.class ? attributes.class : ''}`.trim(),
                'aria-checked': checked,
                value: value
            }));
            const flex = createElement('span');
            // We have to set as HTML incase of special characters
            flex.innerHTML = title;
            if (is.element(badge)) flex.appendChild(badge);
            menuItem.appendChild(flex);
            // Replicate radio button behavior
            Object.defineProperty(menuItem, 'checked', {
                enumerable: true,
                get () {
                    return menuItem.getAttribute('aria-checked') === 'true';
                },
                set (check) {
                    // Ensure exclusivity
                    if (check) Array.from(menuItem.parentNode.children).filter((node)=>matches(node, '[role="menuitemradio"]')).forEach((node)=>node.setAttribute('aria-checked', 'false'));
                    menuItem.setAttribute('aria-checked', check ? 'true' : 'false');
                }
            });
            this.listeners.bind(menuItem, 'click keyup', (event)=>{
                if (is.keyboardEvent(event) && event.key !== 'Space') return;
                event.preventDefault();
                event.stopPropagation();
                menuItem.checked = true;
                switch(type){
                    case 'language':
                        this.currentTrack = Number(value);
                        break;
                    case 'quality':
                        this.quality = value;
                        break;
                    case 'speed':
                        this.speed = parseFloat(value);
                        break;
                }
                controls.showMenuPanel.call(this, 'home', is.keyboardEvent(event));
            }, type, false);
            controls.bindMenuItemShortcuts.call(this, menuItem, type);
            list.appendChild(menuItem);
        },
        // Format a time for display
        formatTime (time = 0, inverted = false) {
            // Bail if the value isn't a number
            if (!is.number(time)) return time;
            // Always display hours if duration is over an hour
            const forceHours = getHours(this.duration) > 0;
            return formatTime(time, forceHours, inverted);
        },
        // Update the displayed time
        updateTimeDisplay (target = null, time = 0, inverted = false) {
            // Bail if there's no element to display or the value isn't a number
            if (!is.element(target) || !is.number(time)) return;
            // eslint-disable-next-line no-param-reassign
            target.innerText = controls.formatTime(time, inverted);
        },
        // Update volume UI and storage
        updateVolume () {
            if (!this.supported.ui) return;
            // Update range
            if (is.element(this.elements.inputs.volume)) controls.setRange.call(this, this.elements.inputs.volume, this.muted ? 0 : this.volume);
            // Update mute state
            if (is.element(this.elements.buttons.mute)) this.elements.buttons.mute.pressed = this.muted || this.volume === 0;
        },
        // Update seek value and lower fill
        setRange (target, value = 0) {
            if (!is.element(target)) return;
            // eslint-disable-next-line
            target.value = value;
            // Webkit range fill
            controls.updateRangeFill.call(this, target);
        },
        // Update <progress> elements
        updateProgress (event) {
            if (!this.supported.ui || !is.event(event)) return;
            let value = 0;
            const setProgress = (target, input)=>{
                const val = is.number(input) ? input : 0;
                const progress = is.element(target) ? target : this.elements.display.buffer;
                // Update value and label
                if (is.element(progress)) {
                    progress.value = val;
                    // Update text label inside
                    const label = progress.getElementsByTagName('span')[0];
                    if (is.element(label)) label.childNodes[0].nodeValue = val;
                }
            };
            if (event) switch(event.type){
                // Video playing
                case 'timeupdate':
                case 'seeking':
                case 'seeked':
                    value = getPercentage(this.currentTime, this.duration);
                    // Set seek range value only if it's a 'natural' time event
                    if (event.type === 'timeupdate') controls.setRange.call(this, this.elements.inputs.seek, value);
                    break;
                // Check buffer status
                case 'playing':
                case 'progress':
                    setProgress(this.elements.display.buffer, this.buffered * 100);
                    break;
            }
        },
        // Webkit polyfill for lower fill range
        updateRangeFill (target) {
            // Get range from event if event passed
            const range = is.event(target) ? target.target : target;
            // Needs to be a valid <input type='range'>
            if (!is.element(range) || range.getAttribute('type') !== 'range') return;
            // Set aria values for https://github.com/sampotts/plyr/issues/905
            if (matches(range, this.config.selectors.inputs.seek)) {
                range.setAttribute('aria-valuenow', this.currentTime);
                const currentTime = controls.formatTime(this.currentTime);
                const duration = controls.formatTime(this.duration);
                const format = i18n.get('seekLabel', this.config);
                range.setAttribute('aria-valuetext', format.replace('{currentTime}', currentTime).replace('{duration}', duration));
            } else if (matches(range, this.config.selectors.inputs.volume)) {
                const percent = range.value * 100;
                range.setAttribute('aria-valuenow', percent);
                range.setAttribute('aria-valuetext', `${percent.toFixed(1)}%`);
            } else range.setAttribute('aria-valuenow', range.value);
            // WebKit only
            if (!browser.isWebkit) return;
            // Set CSS custom property
            range.style.setProperty('--value', `${range.value / range.max * 100}%`);
        },
        // Update hover tooltip for seeking
        updateSeekTooltip (event) {
            var _this$config$markers, _this$config$markers$;
            // Bail if setting not true
            if (!this.config.tooltips.seek || !is.element(this.elements.inputs.seek) || !is.element(this.elements.display.seekTooltip) || this.duration === 0) return;
            const tipElement = this.elements.display.seekTooltip;
            const visible = `${this.config.classNames.tooltip}--visible`;
            const toggle = (show)=>toggleClass(tipElement, visible, show);
            // Hide on touch
            if (this.touch) {
                toggle(false);
                return;
            }
            // Determine percentage, if already visible
            let percent = 0;
            const clientRect = this.elements.progress.getBoundingClientRect();
            if (is.event(event)) percent = 100 / clientRect.width * (event.pageX - clientRect.left);
            else if (hasClass(tipElement, visible)) percent = parseFloat(tipElement.style.left, 10);
            else return;
            // Set bounds
            if (percent < 0) percent = 0;
            else if (percent > 100) percent = 100;
            const time = this.duration / 100 * percent;
            // Display the time a click would seek to
            tipElement.innerText = controls.formatTime(time);
            // Get marker point for time
            const point = (_this$config$markers = this.config.markers) === null || _this$config$markers === void 0 ? void 0 : (_this$config$markers$ = _this$config$markers.points) === null || _this$config$markers$ === void 0 ? void 0 : _this$config$markers$.find(({ time: t })=>t === Math.round(time));
            // Append the point label to the tooltip
            if (point) tipElement.insertAdjacentHTML('afterbegin', `${point.label}<br>`);
            // Set position
            tipElement.style.left = `${percent}%`;
            // Show/hide the tooltip
            // If the event is a moues in/out and percentage is inside bounds
            if (is.event(event) && [
                'mouseenter',
                'mouseleave'
            ].includes(event.type)) toggle(event.type === 'mouseenter');
        },
        // Handle time change event
        timeUpdate (event) {
            // Only invert if only one time element is displayed and used for both duration and currentTime
            const invert = !is.element(this.elements.display.duration) && this.config.invertTime;
            // Duration
            controls.updateTimeDisplay.call(this, this.elements.display.currentTime, invert ? this.duration - this.currentTime : this.currentTime, invert);
            // Ignore updates while seeking
            if (event && event.type === 'timeupdate' && this.media.seeking) return;
            // Playing progress
            controls.updateProgress.call(this, event);
        },
        // Show the duration on metadataloaded or durationchange events
        durationUpdate () {
            // Bail if no UI or durationchange event triggered after playing/seek when invertTime is false
            if (!this.supported.ui || !this.config.invertTime && this.currentTime) return;
            // If duration is the 2**32 (shaka), Infinity (HLS), DASH-IF (Number.MAX_SAFE_INTEGER || Number.MAX_VALUE) indicating live we hide the currentTime and progressbar.
            // https://github.com/video-dev/hls.js/blob/5820d29d3c4c8a46e8b75f1e3afa3e68c1a9a2db/src/controller/buffer-controller.js#L415
            // https://github.com/google/shaka-player/blob/4d889054631f4e1cf0fbd80ddd2b71887c02e232/lib/media/streaming_engine.js#L1062
            // https://github.com/Dash-Industry-Forum/dash.js/blob/69859f51b969645b234666800d4cb596d89c602d/src/dash/models/DashManifestModel.js#L338
            if (this.duration >= 2 ** 32) {
                toggleHidden(this.elements.display.currentTime, true);
                toggleHidden(this.elements.progress, true);
                return;
            }
            // Update ARIA values
            if (is.element(this.elements.inputs.seek)) this.elements.inputs.seek.setAttribute('aria-valuemax', this.duration);
            // If there's a spot to display duration
            const hasDuration = is.element(this.elements.display.duration);
            // If there's only one time display, display duration there
            if (!hasDuration && this.config.displayDuration && this.paused) controls.updateTimeDisplay.call(this, this.elements.display.currentTime, this.duration);
            // If there's a duration element, update content
            if (hasDuration) controls.updateTimeDisplay.call(this, this.elements.display.duration, this.duration);
            if (this.config.markers.enabled) controls.setMarkers.call(this);
            // Update the tooltip (if visible)
            controls.updateSeekTooltip.call(this);
        },
        // Hide/show a tab
        toggleMenuButton (setting, toggle) {
            toggleHidden(this.elements.settings.buttons[setting], !toggle);
        },
        // Update the selected setting
        updateSetting (setting, container, input) {
            const pane = this.elements.settings.panels[setting];
            let value = null;
            let list = container;
            if (setting === 'captions') value = this.currentTrack;
            else {
                value = !is.empty(input) ? input : this[setting];
                // Get default
                if (is.empty(value)) value = this.config[setting].default;
                // Unsupported value
                if (!is.empty(this.options[setting]) && !this.options[setting].includes(value)) {
                    this.debug.warn(`Unsupported value of '${value}' for ${setting}`);
                    return;
                }
                // Disabled value
                if (!this.config[setting].options.includes(value)) {
                    this.debug.warn(`Disabled value of '${value}' for ${setting}`);
                    return;
                }
            }
            // Get the list if we need to
            if (!is.element(list)) list = pane && pane.querySelector('[role="menu"]');
            // If there's no list it means it's not been rendered...
            if (!is.element(list)) return;
            // Update the label
            const label = this.elements.settings.buttons[setting].querySelector(`.${this.config.classNames.menu.value}`);
            label.innerHTML = controls.getLabel.call(this, setting, value);
            // Find the radio option and check it
            const target = list && list.querySelector(`[value="${value}"]`);
            if (is.element(target)) target.checked = true;
        },
        // Translate a value into a nice label
        getLabel (setting, value) {
            switch(setting){
                case 'speed':
                    return value === 1 ? i18n.get('normal', this.config) : `${value}&times;`;
                case 'quality':
                    if (is.number(value)) {
                        const label = i18n.get(`qualityLabel.${value}`, this.config);
                        if (!label.length) return `${value}p`;
                        return label;
                    }
                    return toTitleCase(value);
                case 'captions':
                    return captions.getLabel.call(this);
                default:
                    return null;
            }
        },
        // Set the quality menu
        setQualityMenu (options) {
            // Menu required
            if (!is.element(this.elements.settings.panels.quality)) return;
            const type = 'quality';
            const list = this.elements.settings.panels.quality.querySelector('[role="menu"]');
            // Set options if passed and filter based on uniqueness and config
            if (is.array(options)) this.options.quality = dedupe(options).filter((quality)=>this.config.quality.options.includes(quality));
            // Toggle the pane and tab
            const toggle = !is.empty(this.options.quality) && this.options.quality.length > 1;
            controls.toggleMenuButton.call(this, type, toggle);
            // Empty the menu
            emptyElement(list);
            // Check if we need to toggle the parent
            controls.checkMenu.call(this);
            // If we're hiding, nothing more to do
            if (!toggle) return;
            // Get the badge HTML for HD, 4K etc
            const getBadge = (quality)=>{
                const label = i18n.get(`qualityBadge.${quality}`, this.config);
                if (!label.length) return null;
                return controls.createBadge.call(this, label);
            };
            // Sort options by the config and then render options
            this.options.quality.sort((a, b)=>{
                const sorting = this.config.quality.options;
                return sorting.indexOf(a) > sorting.indexOf(b) ? 1 : -1;
            }).forEach((quality)=>{
                controls.createMenuItem.call(this, {
                    value: quality,
                    list: list,
                    type: type,
                    title: controls.getLabel.call(this, 'quality', quality),
                    badge: getBadge(quality)
                });
            });
            controls.updateSetting.call(this, type, list);
        },
        // Set the looping options
        /* setLoopMenu() {
          // Menu required
          if (!is.element(this.elements.settings.panels.loop)) {
              return;
          }
           const options = ['start', 'end', 'all', 'reset'];
          const list = this.elements.settings.panels.loop.querySelector('[role="menu"]');
           // Show the pane and tab
          toggleHidden(this.elements.settings.buttons.loop, false);
          toggleHidden(this.elements.settings.panels.loop, false);
           // Toggle the pane and tab
          const toggle = !is.empty(this.loop.options);
          controls.toggleMenuButton.call(this, 'loop', toggle);
           // Empty the menu
          emptyElement(list);
           options.forEach(option => {
              const item = createElement('li');
               const button = createElement(
                  'button',
                  extend(getAttributesFromSelector(this.config.selectors.buttons.loop), {
                      type: 'button',
                      class: this.config.classNames.control,
                      'data-plyr-loop-action': option,
                  }),
                  i18n.get(option, this.config)
              );
               if (['start', 'end'].includes(option)) {
                  const badge = controls.createBadge.call(this, '00:00');
                  button.appendChild(badge);
              }
               item.appendChild(button);
              list.appendChild(item);
          });
      }, */ // Get current selected caption language
        // TODO: rework this to user the getter in the API?
        // Set a list of available captions languages
        setCaptionsMenu () {
            // Menu required
            if (!is.element(this.elements.settings.panels.captions)) return;
            // TODO: Captions or language? Currently it's mixed
            const type = 'captions';
            const list = this.elements.settings.panels.captions.querySelector('[role="menu"]');
            const tracks = captions.getTracks.call(this);
            const toggle = Boolean(tracks.length);
            // Toggle the pane and tab
            controls.toggleMenuButton.call(this, type, toggle);
            // Empty the menu
            emptyElement(list);
            // Check if we need to toggle the parent
            controls.checkMenu.call(this);
            // If there's no captions, bail
            if (!toggle) return;
            // Generate options data
            const options = tracks.map((track, value)=>({
                    value: value,
                    checked: this.captions.toggled && this.currentTrack === value,
                    title: captions.getLabel.call(this, track),
                    badge: track.language && controls.createBadge.call(this, track.language.toUpperCase()),
                    list: list,
                    type: 'language'
                }));
            // Add the "Disabled" option to turn off captions
            options.unshift({
                value: -1,
                checked: !this.captions.toggled,
                title: i18n.get('disabled', this.config),
                list: list,
                type: 'language'
            });
            // Generate options
            options.forEach(controls.createMenuItem.bind(this));
            controls.updateSetting.call(this, type, list);
        },
        // Set a list of available captions languages
        setSpeedMenu () {
            // Menu required
            if (!is.element(this.elements.settings.panels.speed)) return;
            const type = 'speed';
            const list = this.elements.settings.panels.speed.querySelector('[role="menu"]');
            // Filter out invalid speeds
            this.options.speed = this.options.speed.filter((o)=>o >= this.minimumSpeed && o <= this.maximumSpeed);
            // Toggle the pane and tab
            const toggle = !is.empty(this.options.speed) && this.options.speed.length > 1;
            controls.toggleMenuButton.call(this, type, toggle);
            // Empty the menu
            emptyElement(list);
            // Check if we need to toggle the parent
            controls.checkMenu.call(this);
            // If we're hiding, nothing more to do
            if (!toggle) return;
            // Create items
            this.options.speed.forEach((speed)=>{
                controls.createMenuItem.call(this, {
                    value: speed,
                    list: list,
                    type: type,
                    title: controls.getLabel.call(this, 'speed', speed)
                });
            });
            controls.updateSetting.call(this, type, list);
        },
        // Check if we need to hide/show the settings menu
        checkMenu () {
            const { buttons: buttons } = this.elements.settings;
            const visible = !is.empty(buttons) && Object.values(buttons).some((button)=>!button.hidden);
            toggleHidden(this.elements.settings.menu, !visible);
        },
        // Focus the first menu item in a given (or visible) menu
        focusFirstMenuItem (pane, tabFocus = false) {
            if (this.elements.settings.popup.hidden) return;
            let target = pane;
            if (!is.element(target)) target = Object.values(this.elements.settings.panels).find((p)=>!p.hidden);
            const firstItem = target.querySelector('[role^="menuitem"]');
            setFocus.call(this, firstItem, tabFocus);
        },
        // Show/hide menu
        toggleMenu (input) {
            const { popup: popup } = this.elements.settings;
            const button = this.elements.buttons.settings;
            // Menu and button are required
            if (!is.element(popup) || !is.element(button)) return;
            // True toggle by default
            const { hidden: hidden } = popup;
            let show = hidden;
            if (is.boolean(input)) show = input;
            else if (is.keyboardEvent(input) && input.key === 'Escape') show = false;
            else if (is.event(input)) {
                // If Plyr is in a shadowDOM, the event target is set to the component, instead of the
                // Element in the shadowDOM. The path, if available, is complete.
                const target = is.function(input.composedPath) ? input.composedPath()[0] : input.target;
                const isMenuItem = popup.contains(target);
                // If the click was inside the menu or if the click
                // wasn't the button or menu item and we're trying to
                // show the menu (a doc click shouldn't show the menu)
                if (isMenuItem || !isMenuItem && input.target !== button && show) return;
            }
            // Set button attributes
            button.setAttribute('aria-expanded', show);
            // Show the actual popup
            toggleHidden(popup, !show);
            // Add class hook
            toggleClass(this.elements.container, this.config.classNames.menu.open, show);
            // Focus the first item if key interaction
            if (show && is.keyboardEvent(input)) controls.focusFirstMenuItem.call(this, null, true);
            else if (!show && !hidden) // If closing, re-focus the button
            setFocus.call(this, button, is.keyboardEvent(input));
        },
        // Get the natural size of a menu panel
        getMenuSize (tab) {
            const clone = tab.cloneNode(true);
            clone.style.position = 'absolute';
            clone.style.opacity = 0;
            clone.removeAttribute('hidden');
            // Append to parent so we get the "real" size
            tab.parentNode.appendChild(clone);
            // Get the sizes before we remove
            const width = clone.scrollWidth;
            const height = clone.scrollHeight;
            // Remove from the DOM
            removeElement(clone);
            return {
                width: width,
                height: height
            };
        },
        // Show a panel in the menu
        showMenuPanel (type = '', tabFocus = false) {
            const target = this.elements.container.querySelector(`#plyr-settings-${this.id}-${type}`);
            // Nothing to show, bail
            if (!is.element(target)) return;
            // Hide all other panels
            const container = target.parentNode;
            const current = Array.from(container.children).find((node)=>!node.hidden);
            // If we can do fancy animations, we'll animate the height/width
            if (support.transitions && !support.reducedMotion) {
                // Set the current width as a base
                container.style.width = `${current.scrollWidth}px`;
                container.style.height = `${current.scrollHeight}px`;
                // Get potential sizes
                const size = controls.getMenuSize.call(this, target);
                // Restore auto height/width
                const restore = (event)=>{
                    // We're only bothered about height and width on the container
                    if (event.target !== container || ![
                        'width',
                        'height'
                    ].includes(event.propertyName)) return;
                    // Revert back to auto
                    container.style.width = '';
                    container.style.height = '';
                    // Only listen once
                    off.call(this, container, transitionEndEvent, restore);
                };
                // Listen for the transition finishing and restore auto height/width
                on.call(this, container, transitionEndEvent, restore);
                // Set dimensions to target
                container.style.width = `${size.width}px`;
                container.style.height = `${size.height}px`;
            }
            // Set attributes on current tab
            toggleHidden(current, true);
            // Set attributes on target
            toggleHidden(target, false);
            // Focus the first item
            controls.focusFirstMenuItem.call(this, target, tabFocus);
        },
        // Set the download URL
        setDownloadUrl () {
            const button = this.elements.buttons.download;
            // Bail if no button
            if (!is.element(button)) return;
            // Set attribute
            button.setAttribute('href', this.download);
        },
        // Build the default HTML
        create (data) {
            const { bindMenuItemShortcuts: bindMenuItemShortcuts, createButton: createButton, createProgress: createProgress, createRange: createRange, createTime: createTime, setQualityMenu: setQualityMenu, setSpeedMenu: setSpeedMenu, showMenuPanel: showMenuPanel } = controls;
            this.elements.controls = null;
            // Larger overlaid play button
            if (is.array(this.config.controls) && this.config.controls.includes('play-large')) this.elements.container.appendChild(createButton.call(this, 'play-large'));
            // Create the container
            const container = createElement('div', getAttributesFromSelector(this.config.selectors.controls.wrapper));
            this.elements.controls = container;
            // Default item attributes
            const defaultAttributes = {
                class: 'plyr__controls__item'
            };
            // Loop through controls in order
            dedupe(is.array(this.config.controls) ? this.config.controls : []).forEach((control)=>{
                // Restart button
                if (control === 'restart') container.appendChild(createButton.call(this, 'restart', defaultAttributes));
                // Rewind button
                if (control === 'rewind') container.appendChild(createButton.call(this, 'rewind', defaultAttributes));
                // Play/Pause button
                if (control === 'play') container.appendChild(createButton.call(this, 'play', defaultAttributes));
                // Fast forward button
                if (control === 'fast-forward') container.appendChild(createButton.call(this, 'fast-forward', defaultAttributes));
                // Progress
                if (control === 'progress') {
                    const progressContainer = createElement('div', {
                        class: `${defaultAttributes.class} plyr__progress__container`
                    });
                    const progress = createElement('div', getAttributesFromSelector(this.config.selectors.progress));
                    // Seek range slider
                    progress.appendChild(createRange.call(this, 'seek', {
                        id: `plyr-seek-${data.id}`
                    }));
                    // Buffer progress
                    progress.appendChild(createProgress.call(this, 'buffer'));
                    // TODO: Add loop display indicator
                    // Seek tooltip
                    if (this.config.tooltips.seek) {
                        const tooltip = createElement('span', {
                            class: this.config.classNames.tooltip
                        }, '00:00');
                        progress.appendChild(tooltip);
                        this.elements.display.seekTooltip = tooltip;
                    }
                    this.elements.progress = progress;
                    progressContainer.appendChild(this.elements.progress);
                    container.appendChild(progressContainer);
                }
                // Media current time display
                if (control === 'current-time') container.appendChild(createTime.call(this, 'currentTime', defaultAttributes));
                // Media duration display
                if (control === 'duration') container.appendChild(createTime.call(this, 'duration', defaultAttributes));
                // Volume controls
                if (control === 'mute' || control === 'volume') {
                    let { volume: volume } = this.elements;
                    // Create the volume container if needed
                    if (!is.element(volume) || !container.contains(volume)) {
                        volume = createElement('div', extend({}, defaultAttributes, {
                            class: `${defaultAttributes.class} plyr__volume`.trim()
                        }));
                        this.elements.volume = volume;
                        container.appendChild(volume);
                    }
                    // Toggle mute button
                    if (control === 'mute') volume.appendChild(createButton.call(this, 'mute'));
                    // Volume range control
                    // Ignored on iOS as it's handled globally
                    // https://developer.apple.com/library/safari/documentation/AudioVideo/Conceptual/Using_HTML5_Audio_Video/Device-SpecificConsiderations/Device-SpecificConsiderations.html
                    if (control === 'volume' && !browser.isIos) {
                        // Set the attributes
                        const attributes = {
                            max: 1,
                            step: 0.05,
                            value: this.config.volume
                        };
                        // Create the volume range slider
                        volume.appendChild(createRange.call(this, 'volume', extend(attributes, {
                            id: `plyr-volume-${data.id}`
                        })));
                    }
                }
                // Toggle captions button
                if (control === 'captions') container.appendChild(createButton.call(this, 'captions', defaultAttributes));
                // Settings button / menu
                if (control === 'settings' && !is.empty(this.config.settings)) {
                    const wrapper = createElement('div', extend({}, defaultAttributes, {
                        class: `${defaultAttributes.class} plyr__menu`.trim(),
                        hidden: ''
                    }));
                    wrapper.appendChild(createButton.call(this, 'settings', {
                        'aria-haspopup': true,
                        'aria-controls': `plyr-settings-${data.id}`,
                        'aria-expanded': false
                    }));
                    const popup = createElement('div', {
                        class: 'plyr__menu__container',
                        id: `plyr-settings-${data.id}`,
                        hidden: ''
                    });
                    const inner = createElement('div');
                    const home = createElement('div', {
                        id: `plyr-settings-${data.id}-home`
                    });
                    // Create the menu
                    const menu = createElement('div', {
                        role: 'menu'
                    });
                    home.appendChild(menu);
                    inner.appendChild(home);
                    this.elements.settings.panels.home = home;
                    // Build the menu items
                    this.config.settings.forEach((type)=>{
                        // TODO: bundle this with the createMenuItem helper and bindings
                        const menuItem = createElement('button', extend(getAttributesFromSelector(this.config.selectors.buttons.settings), {
                            type: 'button',
                            class: `${this.config.classNames.control} ${this.config.classNames.control}--forward`,
                            role: 'menuitem',
                            'aria-haspopup': true,
                            hidden: ''
                        }));
                        // Bind menu shortcuts for keyboard users
                        bindMenuItemShortcuts.call(this, menuItem, type);
                        // Show menu on click
                        on.call(this, menuItem, 'click', ()=>{
                            showMenuPanel.call(this, type, false);
                        });
                        const flex = createElement('span', null, i18n.get(type, this.config));
                        const value = createElement('span', {
                            class: this.config.classNames.menu.value
                        });
                        // Speed contains HTML entities
                        value.innerHTML = data[type];
                        flex.appendChild(value);
                        menuItem.appendChild(flex);
                        menu.appendChild(menuItem);
                        // Build the panes
                        const pane = createElement('div', {
                            id: `plyr-settings-${data.id}-${type}`,
                            hidden: ''
                        });
                        // Back button
                        const backButton = createElement('button', {
                            type: 'button',
                            class: `${this.config.classNames.control} ${this.config.classNames.control}--back`
                        });
                        // Visible label
                        backButton.appendChild(createElement('span', {
                            'aria-hidden': true
                        }, i18n.get(type, this.config)));
                        // Screen reader label
                        backButton.appendChild(createElement('span', {
                            class: this.config.classNames.hidden
                        }, i18n.get('menuBack', this.config)));
                        // Go back via keyboard
                        on.call(this, pane, 'keydown', (event)=>{
                            if (event.key !== 'ArrowLeft') return;
                            // Prevent seek
                            event.preventDefault();
                            event.stopPropagation();
                            // Show the respective menu
                            showMenuPanel.call(this, 'home', true);
                        }, false);
                        // Go back via button click
                        on.call(this, backButton, 'click', ()=>{
                            showMenuPanel.call(this, 'home', false);
                        });
                        // Add to pane
                        pane.appendChild(backButton);
                        // Menu
                        pane.appendChild(createElement('div', {
                            role: 'menu'
                        }));
                        inner.appendChild(pane);
                        this.elements.settings.buttons[type] = menuItem;
                        this.elements.settings.panels[type] = pane;
                    });
                    popup.appendChild(inner);
                    wrapper.appendChild(popup);
                    container.appendChild(wrapper);
                    this.elements.settings.popup = popup;
                    this.elements.settings.menu = wrapper;
                }
                // Picture in picture button
                if (control === 'pip' && support.pip) container.appendChild(createButton.call(this, 'pip', defaultAttributes));
                // Airplay button
                if (control === 'airplay' && support.airplay) container.appendChild(createButton.call(this, 'airplay', defaultAttributes));
                // Download button
                if (control === 'download') {
                    const attributes = extend({}, defaultAttributes, {
                        element: 'a',
                        href: this.download,
                        target: '_blank'
                    });
                    // Set download attribute for HTML5 only
                    if (this.isHTML5) attributes.download = '';
                    const { download: download } = this.config.urls;
                    if (!is.url(download) && this.isEmbed) extend(attributes, {
                        icon: `logo-${this.provider}`,
                        label: this.provider
                    });
                    container.appendChild(createButton.call(this, 'download', attributes));
                }
                // Toggle fullscreen button
                if (control === 'fullscreen') container.appendChild(createButton.call(this, 'fullscreen', defaultAttributes));
            });
            // Set available quality levels
            if (this.isHTML5) setQualityMenu.call(this, html5.getQualityOptions.call(this));
            setSpeedMenu.call(this);
            return container;
        },
        // Insert controls
        inject () {
            // Sprite
            if (this.config.loadSprite) {
                const icon = controls.getIconUrl.call(this);
                // Only load external sprite using AJAX
                if (icon.cors) loadSprite(icon.url, 'sprite-plyr');
            }
            // Create a unique ID
            this.id = Math.floor(Math.random() * 10000);
            // Null by default
            let container = null;
            this.elements.controls = null;
            // Set template properties
            const props = {
                id: this.id,
                seektime: this.config.seekTime,
                title: this.config.title
            };
            let update = true;
            // If function, run it and use output
            if (is.function(this.config.controls)) this.config.controls = this.config.controls.call(this, props);
            // Convert falsy controls to empty array (primarily for empty strings)
            if (!this.config.controls) this.config.controls = [];
            if (is.element(this.config.controls) || is.string(this.config.controls)) // HTMLElement or Non-empty string passed as the option
            container = this.config.controls;
            else {
                // Create controls
                container = controls.create.call(this, {
                    id: this.id,
                    seektime: this.config.seekTime,
                    speed: this.speed,
                    quality: this.quality,
                    captions: captions.getLabel.call(this)
                });
                update = false;
            }
            // Replace props with their value
            const replace = (input)=>{
                let result = input;
                Object.entries(props).forEach(([key, value])=>{
                    result = replaceAll(result, `{${key}}`, value);
                });
                return result;
            };
            // Update markup
            if (update) {
                if (is.string(this.config.controls)) container = replace(container);
            }
            // Controls container
            let target;
            // Inject to custom location
            if (is.string(this.config.selectors.controls.container)) target = document.querySelector(this.config.selectors.controls.container);
            // Inject into the container by default
            if (!is.element(target)) target = this.elements.container;
            // Inject controls HTML (needs to be before captions, hence "afterbegin")
            const insertMethod = is.element(container) ? 'insertAdjacentElement' : 'insertAdjacentHTML';
            target[insertMethod]('afterbegin', container);
            // Find the elements if need be
            if (!is.element(this.elements.controls)) controls.findElements.call(this);
            // Add pressed property to buttons
            if (!is.empty(this.elements.buttons)) {
                const addProperty = (button)=>{
                    const className = this.config.classNames.controlPressed;
                    button.setAttribute('aria-pressed', 'false');
                    Object.defineProperty(button, 'pressed', {
                        configurable: true,
                        enumerable: true,
                        get () {
                            return hasClass(button, className);
                        },
                        set (pressed = false) {
                            toggleClass(button, className, pressed);
                            button.setAttribute('aria-pressed', pressed ? 'true' : 'false');
                        }
                    });
                };
                // Toggle classname when pressed property is set
                Object.values(this.elements.buttons).filter(Boolean).forEach((button)=>{
                    if (is.array(button) || is.nodeList(button)) Array.from(button).filter(Boolean).forEach(addProperty);
                    else addProperty(button);
                });
            }
            // Edge sometimes doesn't finish the paint so force a repaint
            if (browser.isEdge) repaint(target);
            // Setup tooltips
            if (this.config.tooltips.controls) {
                const { classNames: classNames, selectors: selectors } = this.config;
                const selector = `${selectors.controls.wrapper} ${selectors.labels} .${classNames.hidden}`;
                const labels = getElements.call(this, selector);
                Array.from(labels).forEach((label)=>{
                    toggleClass(label, this.config.classNames.hidden, false);
                    toggleClass(label, this.config.classNames.tooltip, true);
                });
            }
        },
        // Set media metadata
        setMediaMetadata () {
            try {
                if ('mediaSession' in navigator) navigator.mediaSession.metadata = new window.MediaMetadata({
                    title: this.config.mediaMetadata.title,
                    artist: this.config.mediaMetadata.artist,
                    album: this.config.mediaMetadata.album,
                    artwork: this.config.mediaMetadata.artwork
                });
            } catch (_) {
            // Do nothing
            }
        },
        // Add markers
        setMarkers () {
            var _this$config$markers2, _this$config$markers3;
            if (!this.duration || this.elements.markers) return;
            // Get valid points
            const points = (_this$config$markers2 = this.config.markers) === null || _this$config$markers2 === void 0 ? void 0 : (_this$config$markers3 = _this$config$markers2.points) === null || _this$config$markers3 === void 0 ? void 0 : _this$config$markers3.filter(({ time: time })=>time > 0 && time < this.duration);
            if (!(points !== null && points !== void 0 && points.length)) return;
            const containerFragment = document.createDocumentFragment();
            const pointsFragment = document.createDocumentFragment();
            let tipElement = null;
            const tipVisible = `${this.config.classNames.tooltip}--visible`;
            const toggleTip = (show)=>toggleClass(tipElement, tipVisible, show);
            // Inject markers to progress container
            points.forEach((point)=>{
                const markerElement = createElement('span', {
                    class: this.config.classNames.marker
                }, '');
                const left = `${point.time / this.duration * 100}%`;
                if (tipElement) {
                    // Show on hover
                    markerElement.addEventListener('mouseenter', ()=>{
                        if (point.label) return;
                        tipElement.style.left = left;
                        tipElement.innerHTML = point.label;
                        toggleTip(true);
                    });
                    // Hide on leave
                    markerElement.addEventListener('mouseleave', ()=>{
                        toggleTip(false);
                    });
                }
                markerElement.addEventListener('click', ()=>{
                    this.currentTime = point.time;
                });
                markerElement.style.left = left;
                pointsFragment.appendChild(markerElement);
            });
            containerFragment.appendChild(pointsFragment);
            // Inject a tooltip if needed
            if (!this.config.tooltips.seek) {
                tipElement = createElement('span', {
                    class: this.config.classNames.tooltip
                }, '');
                containerFragment.appendChild(tipElement);
            }
            this.elements.markers = {
                points: pointsFragment,
                tip: tipElement
            };
            this.elements.progress.appendChild(containerFragment);
        }
    };
    // ==========================================================================
    /**
   * Parse a string to a URL object
   * @param {String} input - the URL to be parsed
   * @param {Boolean} safe - failsafe parsing
   */ function parseUrl(input, safe = true) {
        let url = input;
        if (safe) {
            const parser = document.createElement('a');
            parser.href = url;
            url = parser.href;
        }
        try {
            return new URL(url);
        } catch (_) {
            return null;
        }
    }
    // Convert object to URLSearchParams
    function buildUrlParams(input) {
        const params = new URLSearchParams();
        if (is.object(input)) Object.entries(input).forEach(([key, value])=>{
            params.set(key, value);
        });
        return params;
    }
    // ==========================================================================
    const captions = {
        // Setup captions
        setup () {
            // Requires UI support
            if (!this.supported.ui) return;
            // Only Vimeo and HTML5 video supported at this point
            if (!this.isVideo || this.isYouTube || this.isHTML5 && !support.textTracks) {
                // Clear menu and hide
                if (is.array(this.config.controls) && this.config.controls.includes('settings') && this.config.settings.includes('captions')) controls.setCaptionsMenu.call(this);
                return;
            }
            // Inject the container
            if (!is.element(this.elements.captions)) {
                this.elements.captions = createElement('div', getAttributesFromSelector(this.config.selectors.captions));
                this.elements.captions.setAttribute('dir', 'auto');
                insertAfter(this.elements.captions, this.elements.wrapper);
            }
            // Fix IE captions if CORS is used
            // Fetch captions and inject as blobs instead (data URIs not supported!)
            if (browser.isIE && window.URL) {
                const elements = this.media.querySelectorAll('track');
                Array.from(elements).forEach((track)=>{
                    const src = track.getAttribute('src');
                    const url = parseUrl(src);
                    if (url !== null && url.hostname !== window.location.href.hostname && [
                        'http:',
                        'https:'
                    ].includes(url.protocol)) fetch(src, 'blob').then((blob)=>{
                        track.setAttribute('src', window.URL.createObjectURL(blob));
                    }).catch(()=>{
                        removeElement(track);
                    });
                });
            }
            // Get and set initial data
            // The "preferred" options are not realized unless / until the wanted language has a match
            // * languages: Array of user's browser languages.
            // * language:  The language preferred by user settings or config
            // * active:    The state preferred by user settings or config
            // * toggled:   The real captions state
            const browserLanguages = navigator.languages || [
                navigator.language || navigator.userLanguage || 'en'
            ];
            const languages = dedupe(browserLanguages.map((language)=>language.split('-')[0]));
            let language = (this.storage.get('language') || this.config.captions.language || 'auto').toLowerCase();
            // Use first browser language when language is 'auto'
            if (language === 'auto') [language] = languages;
            let active = this.storage.get('captions');
            if (!is.boolean(active)) ({ active: active } = this.config.captions);
            Object.assign(this.captions, {
                toggled: false,
                active: active,
                language: language,
                languages: languages
            });
            // Watch changes to textTracks and update captions menu
            if (this.isHTML5) {
                const trackEvents = this.config.captions.update ? 'addtrack removetrack' : 'removetrack';
                on.call(this, this.media.textTracks, trackEvents, captions.update.bind(this));
            }
            // Update available languages in list next tick (the event must not be triggered before the listeners)
            setTimeout(captions.update.bind(this), 0);
        },
        // Update available language options in settings based on tracks
        update () {
            const tracks = captions.getTracks.call(this, true);
            // Get the wanted language
            const { active: active, language: language, meta: meta, currentTrackNode: currentTrackNode } = this.captions;
            const languageExists = Boolean(tracks.find((track)=>track.language === language));
            // Handle tracks (add event listener and "pseudo"-default)
            if (this.isHTML5 && this.isVideo) tracks.filter((track)=>!meta.get(track)).forEach((track)=>{
                this.debug.log('Track added', track);
                // Attempt to store if the original dom element was "default"
                meta.set(track, {
                    default: track.mode === 'showing'
                });
                // Turn off native caption rendering to avoid double captions
                // Note: mode='hidden' forces a track to download. To ensure every track
                // isn't downloaded at once, only 'showing' tracks should be reassigned
                // eslint-disable-next-line no-param-reassign
                if (track.mode === 'showing') // eslint-disable-next-line no-param-reassign
                track.mode = 'hidden';
                // Add event listener for cue changes
                on.call(this, track, 'cuechange', ()=>captions.updateCues.call(this));
            });
            // Update language first time it matches, or if the previous matching track was removed
            if (languageExists && this.language !== language || !tracks.includes(currentTrackNode)) {
                captions.setLanguage.call(this, language);
                captions.toggle.call(this, active && languageExists);
            }
            // Enable or disable captions based on track length
            if (this.elements) toggleClass(this.elements.container, this.config.classNames.captions.enabled, !is.empty(tracks));
            // Update available languages in list
            if (is.array(this.config.controls) && this.config.controls.includes('settings') && this.config.settings.includes('captions')) controls.setCaptionsMenu.call(this);
        },
        // Toggle captions display
        // Used internally for the toggleCaptions method, with the passive option forced to false
        toggle (input, passive = true) {
            // If there's no full support
            if (!this.supported.ui) return;
            const { toggled: toggled } = this.captions; // Current state
            const activeClass = this.config.classNames.captions.active;
            // Get the next state
            // If the method is called without parameter, toggle based on current value
            const active = is.nullOrUndefined(input) ? !toggled : input;
            // Update state and trigger event
            if (active !== toggled) {
                // When passive, don't override user preferences
                if (!passive) {
                    this.captions.active = active;
                    this.storage.set({
                        captions: active
                    });
                }
                // Force language if the call isn't passive and there is no matching language to toggle to
                if (!this.language && active && !passive) {
                    const tracks = captions.getTracks.call(this);
                    const track = captions.findTrack.call(this, [
                        this.captions.language,
                        ...this.captions.languages
                    ], true);
                    // Override user preferences to avoid switching languages if a matching track is added
                    this.captions.language = track.language;
                    // Set caption, but don't store in localStorage as user preference
                    captions.set.call(this, tracks.indexOf(track));
                    return;
                }
                // Toggle button if it's enabled
                if (this.elements.buttons.captions) this.elements.buttons.captions.pressed = active;
                // Add class hook
                toggleClass(this.elements.container, activeClass, active);
                this.captions.toggled = active;
                // Update settings menu
                controls.updateSetting.call(this, 'captions');
                // Trigger event (not used internally)
                triggerEvent.call(this, this.media, active ? 'captionsenabled' : 'captionsdisabled');
            }
            // Wait for the call stack to clear before setting mode='hidden'
            // on the active track - forcing the browser to download it
            setTimeout(()=>{
                if (active && this.captions.toggled) this.captions.currentTrackNode.mode = 'hidden';
            });
        },
        // Set captions by track index
        // Used internally for the currentTrack setter with the passive option forced to false
        set (index, passive = true) {
            const tracks = captions.getTracks.call(this);
            // Disable captions if setting to -1
            if (index === -1) {
                captions.toggle.call(this, false, passive);
                return;
            }
            if (!is.number(index)) {
                this.debug.warn('Invalid caption argument', index);
                return;
            }
            if (!(index in tracks)) {
                this.debug.warn('Track not found', index);
                return;
            }
            if (this.captions.currentTrack !== index) {
                this.captions.currentTrack = index;
                const track = tracks[index];
                const { language: language } = track || {};
                // Store reference to node for invalidation on remove
                this.captions.currentTrackNode = track;
                // Update settings menu
                controls.updateSetting.call(this, 'captions');
                // When passive, don't override user preferences
                if (!passive) {
                    this.captions.language = language;
                    this.storage.set({
                        language: language
                    });
                }
                // Handle Vimeo captions
                if (this.isVimeo) this.embed.enableTextTrack(language);
                // Trigger event
                triggerEvent.call(this, this.media, 'languagechange');
            }
            // Show captions
            captions.toggle.call(this, true, passive);
            if (this.isHTML5 && this.isVideo) // If we change the active track while a cue is already displayed we need to update it
            captions.updateCues.call(this);
        },
        // Set captions by language
        // Used internally for the language setter with the passive option forced to false
        setLanguage (input, passive = true) {
            if (!is.string(input)) {
                this.debug.warn('Invalid language argument', input);
                return;
            }
            // Normalize
            const language = input.toLowerCase();
            this.captions.language = language;
            // Set currentTrack
            const tracks = captions.getTracks.call(this);
            const track = captions.findTrack.call(this, [
                language
            ]);
            captions.set.call(this, tracks.indexOf(track), passive);
        },
        // Get current valid caption tracks
        // If update is false it will also ignore tracks without metadata
        // This is used to "freeze" the language options when captions.update is false
        getTracks (update = false) {
            // Handle media or textTracks missing or null
            const tracks = Array.from((this.media || {}).textTracks || []);
            // For HTML5, use cache instead of current tracks when it exists (if captions.update is false)
            // Filter out removed tracks and tracks that aren't captions/subtitles (for example metadata)
            return tracks.filter((track)=>!this.isHTML5 || update || this.captions.meta.has(track)).filter((track)=>[
                    'captions',
                    'subtitles'
                ].includes(track.kind));
        },
        // Match tracks based on languages and get the first
        findTrack (languages, force = false) {
            const tracks = captions.getTracks.call(this);
            const sortIsDefault = (track)=>Number((this.captions.meta.get(track) || {}).default);
            const sorted = Array.from(tracks).sort((a, b)=>sortIsDefault(b) - sortIsDefault(a));
            let track;
            languages.every((language)=>{
                track = sorted.find((t)=>t.language === language);
                return !track; // Break iteration if there is a match
            });
            // If no match is found but is required, get first
            return track || (force ? sorted[0] : undefined);
        },
        // Get the current track
        getCurrentTrack () {
            return captions.getTracks.call(this)[this.currentTrack];
        },
        // Get UI label for track
        getLabel (track) {
            let currentTrack = track;
            if (!is.track(currentTrack) && support.textTracks && this.captions.toggled) currentTrack = captions.getCurrentTrack.call(this);
            if (is.track(currentTrack)) {
                if (!is.empty(currentTrack.label)) return currentTrack.label;
                if (!is.empty(currentTrack.language)) return track.language.toUpperCase();
                return i18n.get('enabled', this.config);
            }
            return i18n.get('disabled', this.config);
        },
        // Update captions using current track's active cues
        // Also optional array argument in case there isn't any track (ex: vimeo)
        updateCues (input) {
            // Requires UI
            if (!this.supported.ui) return;
            if (!is.element(this.elements.captions)) {
                this.debug.warn('No captions element to render to');
                return;
            }
            // Only accept array or empty input
            if (!is.nullOrUndefined(input) && !Array.isArray(input)) {
                this.debug.warn('updateCues: Invalid input', input);
                return;
            }
            let cues = input;
            // Get cues from track
            if (!cues) {
                const track = captions.getCurrentTrack.call(this);
                cues = Array.from((track || {}).activeCues || []).map((cue)=>cue.getCueAsHTML()).map(getHTML);
            }
            // Set new caption text
            const content = cues.map((cueText)=>cueText.trim()).join('\n');
            const changed = content !== this.elements.captions.innerHTML;
            if (changed) {
                // Empty the container and create a new child element
                emptyElement(this.elements.captions);
                const caption = createElement('span', getAttributesFromSelector(this.config.selectors.caption));
                caption.innerHTML = content;
                this.elements.captions.appendChild(caption);
                // Trigger event
                triggerEvent.call(this, this.media, 'cuechange');
            }
        }
    };
    // ==========================================================================
    // Plyr default config
    // ==========================================================================
    const defaults = {
        // Disable
        enabled: true,
        // Custom media title
        title: '',
        // Logging to console
        debug: false,
        // Auto play (if supported)
        autoplay: false,
        // Only allow one media playing at once (vimeo only)
        autopause: true,
        // Allow inline playback on iOS (this effects YouTube/Vimeo - HTML5 requires the attribute present)
        // TODO: Remove iosNative fullscreen option in favour of this (logic needs work)
        playsinline: true,
        // Default time to skip when rewind/fast forward
        seekTime: 10,
        // Default volume
        volume: 1,
        muted: false,
        // Pass a custom duration
        duration: null,
        // Display the media duration on load in the current time position
        // If you have opted to display both duration and currentTime, this is ignored
        displayDuration: true,
        // Invert the current time to be a countdown
        invertTime: true,
        // Clicking the currentTime inverts it's value to show time left rather than elapsed
        toggleInvert: true,
        // Force an aspect ratio
        // The format must be `'w:h'` (e.g. `'16:9'`)
        ratio: null,
        // Click video container to play/pause
        clickToPlay: true,
        // Auto hide the controls
        hideControls: true,
        // Reset to start when playback ended
        resetOnEnd: false,
        // Disable the standard context menu
        disableContextMenu: true,
        // Sprite (for icons)
        loadSprite: true,
        iconPrefix: 'plyr',
        iconUrl: 'https://cdn.plyr.io/3.7.3/plyr.svg',
        // Blank video (used to prevent errors on source change)
        blankVideo: 'https://cdn.plyr.io/static/blank.mp4',
        // Quality default
        quality: {
            default: 576,
            // The options to display in the UI, if available for the source media
            options: [
                4320,
                2880,
                2160,
                1440,
                1080,
                720,
                576,
                480,
                360,
                240
            ],
            forced: false,
            onChange: null
        },
        // Set loops
        loop: {
            active: false
        },
        // Speed default and options to display
        speed: {
            selected: 1,
            // The options to display in the UI, if available for the source media (e.g. Vimeo and YouTube only support 0.5x-4x)
            options: [
                0.5,
                0.75,
                1,
                1.25,
                1.5,
                1.75,
                2,
                4
            ]
        },
        // Keyboard shortcut settings
        keyboard: {
            focused: true,
            global: false
        },
        // Display tooltips
        tooltips: {
            controls: false,
            seek: true
        },
        // Captions settings
        captions: {
            active: false,
            language: 'auto',
            // Listen to new tracks added after Plyr is initialized.
            // This is needed for streaming captions, but may result in unselectable options
            update: false
        },
        // Fullscreen settings
        fullscreen: {
            enabled: true,
            // Allow fullscreen?
            fallback: true,
            // Fallback using full viewport/window
            iosNative: false // Use the native fullscreen in iOS (disables custom controls)
        },
        // Local storage
        storage: {
            enabled: true,
            key: 'plyr'
        },
        // Default controls
        controls: [
            'play-large',
            // 'restart',
            // 'rewind',
            'play',
            // 'fast-forward',
            'progress',
            'current-time',
            // 'duration',
            'mute',
            'volume',
            'captions',
            'settings',
            'pip',
            'airplay',
            // 'download',
            'fullscreen'
        ],
        settings: [
            'captions',
            'quality',
            'speed'
        ],
        // Localisation
        i18n: {
            restart: 'Restart',
            rewind: 'Rewind {seektime}s',
            play: 'Play',
            pause: 'Pause',
            fastForward: 'Forward {seektime}s',
            seek: 'Seek',
            seekLabel: '{currentTime} of {duration}',
            played: 'Played',
            buffered: 'Buffered',
            currentTime: 'Current time',
            duration: 'Duration',
            volume: 'Volume',
            mute: 'Mute',
            unmute: 'Unmute',
            enableCaptions: 'Enable captions',
            disableCaptions: 'Disable captions',
            download: 'Download',
            enterFullscreen: 'Enter fullscreen',
            exitFullscreen: 'Exit fullscreen',
            frameTitle: 'Player for {title}',
            captions: 'Captions',
            settings: 'Settings',
            pip: 'PIP',
            menuBack: 'Go back to previous menu',
            speed: 'Speed',
            normal: 'Normal',
            quality: 'Quality',
            loop: 'Loop',
            start: 'Start',
            end: 'End',
            all: 'All',
            reset: 'Reset',
            disabled: 'Disabled',
            enabled: 'Enabled',
            advertisement: 'Ad',
            qualityBadge: {
                2160: '4K',
                1440: 'HD',
                1080: 'HD',
                720: 'HD',
                576: 'SD',
                480: 'SD'
            }
        },
        // URLs
        urls: {
            download: null,
            vimeo: {
                sdk: 'https://player.vimeo.com/api/player.js',
                iframe: 'https://player.vimeo.com/video/{0}?{1}',
                api: 'https://vimeo.com/api/oembed.json?url={0}'
            },
            youtube: {
                sdk: 'https://www.youtube.com/iframe_api',
                api: 'https://noembed.com/embed?url=https://www.youtube.com/watch?v={0}'
            },
            googleIMA: {
                sdk: 'https://imasdk.googleapis.com/js/sdkloader/ima3.js'
            }
        },
        // Custom control listeners
        listeners: {
            seek: null,
            play: null,
            pause: null,
            restart: null,
            rewind: null,
            fastForward: null,
            mute: null,
            volume: null,
            captions: null,
            download: null,
            fullscreen: null,
            pip: null,
            airplay: null,
            speed: null,
            quality: null,
            loop: null,
            language: null
        },
        // Events to watch and bubble
        events: [
            // Events to watch on HTML5 media elements and bubble
            // https://developer.mozilla.org/en/docs/Web/Guide/Events/Media_events
            'ended',
            'progress',
            'stalled',
            'playing',
            'waiting',
            'canplay',
            'canplaythrough',
            'loadstart',
            'loadeddata',
            'loadedmetadata',
            'timeupdate',
            'volumechange',
            'play',
            'pause',
            'error',
            'seeking',
            'seeked',
            'emptied',
            'ratechange',
            'cuechange',
            // Custom events
            'download',
            'enterfullscreen',
            'exitfullscreen',
            'captionsenabled',
            'captionsdisabled',
            'languagechange',
            'controlshidden',
            'controlsshown',
            'ready',
            // YouTube
            'statechange',
            // Quality
            'qualitychange',
            // Ads
            'adsloaded',
            'adscontentpause',
            'adscontentresume',
            'adstarted',
            'adsmidpoint',
            'adscomplete',
            'adsallcomplete',
            'adsimpression',
            'adsclick'
        ],
        // Selectors
        // Change these to match your template if using custom HTML
        selectors: {
            editable: 'input, textarea, select, [contenteditable]',
            container: '.plyr',
            controls: {
                container: null,
                wrapper: '.plyr__controls'
            },
            labels: '[data-plyr]',
            buttons: {
                play: '[data-plyr="play"]',
                pause: '[data-plyr="pause"]',
                restart: '[data-plyr="restart"]',
                rewind: '[data-plyr="rewind"]',
                fastForward: '[data-plyr="fast-forward"]',
                mute: '[data-plyr="mute"]',
                captions: '[data-plyr="captions"]',
                download: '[data-plyr="download"]',
                fullscreen: '[data-plyr="fullscreen"]',
                pip: '[data-plyr="pip"]',
                airplay: '[data-plyr="airplay"]',
                settings: '[data-plyr="settings"]',
                loop: '[data-plyr="loop"]'
            },
            inputs: {
                seek: '[data-plyr="seek"]',
                volume: '[data-plyr="volume"]',
                speed: '[data-plyr="speed"]',
                language: '[data-plyr="language"]',
                quality: '[data-plyr="quality"]'
            },
            display: {
                currentTime: '.plyr__time--current',
                duration: '.plyr__time--duration',
                buffer: '.plyr__progress__buffer',
                loop: '.plyr__progress__loop',
                // Used later
                volume: '.plyr__volume--display'
            },
            progress: '.plyr__progress',
            captions: '.plyr__captions',
            caption: '.plyr__caption'
        },
        // Class hooks added to the player in different states
        classNames: {
            type: 'plyr--{0}',
            provider: 'plyr--{0}',
            video: 'plyr__video-wrapper',
            embed: 'plyr__video-embed',
            videoFixedRatio: 'plyr__video-wrapper--fixed-ratio',
            embedContainer: 'plyr__video-embed__container',
            poster: 'plyr__poster',
            posterEnabled: 'plyr__poster-enabled',
            ads: 'plyr__ads',
            control: 'plyr__control',
            controlPressed: 'plyr__control--pressed',
            playing: 'plyr--playing',
            paused: 'plyr--paused',
            stopped: 'plyr--stopped',
            loading: 'plyr--loading',
            hover: 'plyr--hover',
            tooltip: 'plyr__tooltip',
            cues: 'plyr__cues',
            marker: 'plyr__progress__marker',
            hidden: 'plyr__sr-only',
            hideControls: 'plyr--hide-controls',
            isIos: 'plyr--is-ios',
            isTouch: 'plyr--is-touch',
            uiSupported: 'plyr--full-ui',
            noTransition: 'plyr--no-transition',
            display: {
                time: 'plyr__time'
            },
            menu: {
                value: 'plyr__menu__value',
                badge: 'plyr__badge',
                open: 'plyr--menu-open'
            },
            captions: {
                enabled: 'plyr--captions-enabled',
                active: 'plyr--captions-active'
            },
            fullscreen: {
                enabled: 'plyr--fullscreen-enabled',
                fallback: 'plyr--fullscreen-fallback'
            },
            pip: {
                supported: 'plyr--pip-supported',
                active: 'plyr--pip-active'
            },
            airplay: {
                supported: 'plyr--airplay-supported',
                active: 'plyr--airplay-active'
            },
            tabFocus: 'plyr__tab-focus',
            previewThumbnails: {
                // Tooltip thumbs
                thumbContainer: 'plyr__preview-thumb',
                thumbContainerShown: 'plyr__preview-thumb--is-shown',
                imageContainer: 'plyr__preview-thumb__image-container',
                timeContainer: 'plyr__preview-thumb__time-container',
                // Scrubbing
                scrubbingContainer: 'plyr__preview-scrubbing',
                scrubbingContainerShown: 'plyr__preview-scrubbing--is-shown'
            }
        },
        // Embed attributes
        attributes: {
            embed: {
                provider: 'data-plyr-provider',
                id: 'data-plyr-embed-id',
                hash: 'data-plyr-embed-hash'
            }
        },
        // Advertisements plugin
        // Register for an account here: http://vi.ai/publisher-video-monetization/?aid=plyrio
        ads: {
            enabled: false,
            publisherId: '',
            tagUrl: ''
        },
        // Preview Thumbnails plugin
        previewThumbnails: {
            enabled: false,
            src: ''
        },
        // Vimeo plugin
        vimeo: {
            byline: false,
            portrait: false,
            title: false,
            speed: true,
            transparent: false,
            // Custom settings from Plyr
            customControls: true,
            referrerPolicy: null,
            // https://developer.mozilla.org/en-US/docs/Web/API/HTMLIFrameElement/referrerPolicy
            // Whether the owner of the video has a Pro or Business account
            // (which allows us to properly hide controls without CSS hacks, etc)
            premium: false
        },
        // YouTube plugin
        youtube: {
            rel: 0,
            // No related vids
            showinfo: 0,
            // Hide info
            iv_load_policy: 3,
            // Hide annotations
            modestbranding: 1,
            // Hide logos as much as possible (they still show one in the corner when paused)
            // Custom settings from Plyr
            customControls: true,
            noCookie: false // Whether to use an alternative version of YouTube without cookies
        },
        // Media Metadata
        mediaMetadata: {
            title: '',
            artist: '',
            album: '',
            artwork: []
        },
        // Markers
        markers: {
            enabled: false,
            points: []
        }
    };
    // ==========================================================================
    // Plyr states
    // ==========================================================================
    const pip = {
        active: 'picture-in-picture',
        inactive: 'inline'
    };
    // ==========================================================================
    // Plyr supported types and providers
    // ==========================================================================
    const providers = {
        html5: 'html5',
        youtube: 'youtube',
        vimeo: 'vimeo'
    };
    const types = {
        audio: 'audio',
        video: 'video'
    };
    /**
   * Get provider by URL
   * @param {String} url
   */ function getProviderByUrl(url) {
        // YouTube
        if (/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(url)) return providers.youtube;
        // Vimeo
        if (/^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(url)) return providers.vimeo;
        return null;
    }
    // ==========================================================================
    // Console wrapper
    // ==========================================================================
    const noop = ()=>{};
    class Console {
        constructor(enabled = false){
            this.enabled = window.console && enabled;
            if (this.enabled) this.log('Debugging enabled');
        }
        get log() {
            // eslint-disable-next-line no-console
            return this.enabled ? Function.prototype.bind.call(console.log, console) : noop;
        }
        get warn() {
            // eslint-disable-next-line no-console
            return this.enabled ? Function.prototype.bind.call(console.warn, console) : noop;
        }
        get error() {
            // eslint-disable-next-line no-console
            return this.enabled ? Function.prototype.bind.call(console.error, console) : noop;
        }
    }
    class Fullscreen {
        constructor(player){
            _defineProperty$1(this, "onChange", ()=>{
                if (!this.enabled) return;
                // Update toggle button
                const button = this.player.elements.buttons.fullscreen;
                if (is.element(button)) button.pressed = this.active;
                // Always trigger events on the plyr / media element (not a fullscreen container) and let them bubble up
                const target = this.target === this.player.media ? this.target : this.player.elements.container;
                // Trigger an event
                triggerEvent.call(this.player, target, this.active ? 'enterfullscreen' : 'exitfullscreen', true);
            });
            _defineProperty$1(this, "toggleFallback", (toggle = false)=>{
                // Store or restore scroll position
                if (toggle) this.scrollPosition = {
                    x: window.scrollX || 0,
                    y: window.scrollY || 0
                };
                else window.scrollTo(this.scrollPosition.x, this.scrollPosition.y);
                // Toggle scroll
                document.body.style.overflow = toggle ? 'hidden' : '';
                // Toggle class hook
                toggleClass(this.target, this.player.config.classNames.fullscreen.fallback, toggle);
                // Force full viewport on iPhone X+
                if (browser.isIos) {
                    let viewport = document.head.querySelector('meta[name="viewport"]');
                    const property = 'viewport-fit=cover';
                    // Inject the viewport meta if required
                    if (!viewport) {
                        viewport = document.createElement('meta');
                        viewport.setAttribute('name', 'viewport');
                    }
                    // Check if the property already exists
                    const hasProperty = is.string(viewport.content) && viewport.content.includes(property);
                    if (toggle) {
                        this.cleanupViewport = !hasProperty;
                        if (!hasProperty) viewport.content += `,${property}`;
                    } else if (this.cleanupViewport) viewport.content = viewport.content.split(',').filter((part)=>part.trim() !== property).join(',');
                }
                // Toggle button and fire events
                this.onChange();
            });
            _defineProperty$1(this, "trapFocus", (event)=>{
                // Bail if iOS, not active, not the tab key
                if (browser.isIos || !this.active || event.key !== 'Tab') return;
                // Get the current focused element
                const focused = document.activeElement;
                const focusable = getElements.call(this.player, 'a[href], button:not(:disabled), input:not(:disabled), [tabindex]');
                const [first] = focusable;
                const last = focusable[focusable.length - 1];
                if (focused === last && !event.shiftKey) {
                    // Move focus to first element that can be tabbed if Shift isn't used
                    first.focus();
                    event.preventDefault();
                } else if (focused === first && event.shiftKey) {
                    // Move focus to last element that can be tabbed if Shift is used
                    last.focus();
                    event.preventDefault();
                }
            });
            _defineProperty$1(this, "update", ()=>{
                if (this.enabled) {
                    let mode;
                    if (this.forceFallback) mode = 'Fallback (forced)';
                    else if (Fullscreen.native) mode = 'Native';
                    else mode = 'Fallback';
                    this.player.debug.log(`${mode} fullscreen enabled`);
                } else this.player.debug.log('Fullscreen not supported and fallback disabled');
                // Add styling hook to show button
                toggleClass(this.player.elements.container, this.player.config.classNames.fullscreen.enabled, this.enabled);
            });
            _defineProperty$1(this, "enter", ()=>{
                if (!this.enabled) return;
                // iOS native fullscreen doesn't need the request step
                if (browser.isIos && this.player.config.fullscreen.iosNative) {
                    if (this.player.isVimeo) this.player.embed.requestFullscreen();
                    else this.target.webkitEnterFullscreen();
                } else if (!Fullscreen.native || this.forceFallback) this.toggleFallback(true);
                else if (!this.prefix) this.target.requestFullscreen({
                    navigationUI: 'hide'
                });
                else if (!is.empty(this.prefix)) this.target[`${this.prefix}Request${this.property}`]();
            });
            _defineProperty$1(this, "exit", ()=>{
                if (!this.enabled) return;
                // iOS native fullscreen
                if (browser.isIos && this.player.config.fullscreen.iosNative) {
                    this.target.webkitExitFullscreen();
                    silencePromise(this.player.play());
                } else if (!Fullscreen.native || this.forceFallback) this.toggleFallback(false);
                else if (!this.prefix) (document.cancelFullScreen || document.exitFullscreen).call(document);
                else if (!is.empty(this.prefix)) {
                    const action = this.prefix === 'moz' ? 'Cancel' : 'Exit';
                    document[`${this.prefix}${action}${this.property}`]();
                }
            });
            _defineProperty$1(this, "toggle", ()=>{
                if (!this.active) this.enter();
                else this.exit();
            });
            // Keep reference to parent
            this.player = player;
            // Get prefix
            this.prefix = Fullscreen.prefix;
            this.property = Fullscreen.property;
            // Scroll position
            this.scrollPosition = {
                x: 0,
                y: 0
            };
            // Force the use of 'full window/browser' rather than fullscreen
            this.forceFallback = player.config.fullscreen.fallback === 'force';
            // Get the fullscreen element
            // Checks container is an ancestor, defaults to null
            this.player.elements.fullscreen = player.config.fullscreen.container && closest$1(this.player.elements.container, player.config.fullscreen.container);
            // Register event listeners
            // Handle event (incase user presses escape etc)
            on.call(this.player, document, this.prefix === 'ms' ? 'MSFullscreenChange' : `${this.prefix}fullscreenchange`, ()=>{
                // TODO: Filter for target??
                this.onChange();
            });
            // Fullscreen toggle on double click
            on.call(this.player, this.player.elements.container, 'dblclick', (event)=>{
                // Ignore double click in controls
                if (is.element(this.player.elements.controls) && this.player.elements.controls.contains(event.target)) return;
                this.player.listeners.proxy(event, this.toggle, 'fullscreen');
            });
            // Tap focus when in fullscreen
            on.call(this, this.player.elements.container, 'keydown', (event)=>this.trapFocus(event));
            // Update the UI
            this.update();
        // this.toggle = this.toggle.bind(this);
        }
        // Determine if native supported
        static get native() {
            return !!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled);
        }
        // If we're actually using native
        get usingNative() {
            return Fullscreen.native && !this.forceFallback;
        }
        // Get the prefix for handlers
        static get prefix() {
            // No prefix
            if (is.function(document.exitFullscreen)) return '';
            // Check for fullscreen support by vendor prefix
            let value = '';
            const prefixes = [
                'webkit',
                'moz',
                'ms'
            ];
            prefixes.some((pre)=>{
                if (is.function(document[`${pre}ExitFullscreen`]) || is.function(document[`${pre}CancelFullScreen`])) {
                    value = pre;
                    return true;
                }
                return false;
            });
            return value;
        }
        static get property() {
            return this.prefix === 'moz' ? 'FullScreen' : 'Fullscreen';
        }
        // Determine if fullscreen is enabled
        get enabled() {
            return (Fullscreen.native || this.player.config.fullscreen.fallback) && this.player.config.fullscreen.enabled && this.player.supported.ui && this.player.isVideo;
        }
        // Get active state
        get active() {
            if (!this.enabled) return false;
            // Fallback using classname
            if (!Fullscreen.native || this.forceFallback) return hasClass(this.target, this.player.config.classNames.fullscreen.fallback);
            const element = !this.prefix ? this.target.getRootNode().fullscreenElement : this.target.getRootNode()[`${this.prefix}${this.property}Element`];
            return element && element.shadowRoot ? element === this.target.getRootNode().host : element === this.target;
        }
        // Get target element
        get target() {
            return browser.isIos && this.player.config.fullscreen.iosNative ? this.player.media : this.player.elements.fullscreen || this.player.elements.container;
        }
    }
    // ==========================================================================
    // Load image avoiding xhr/fetch CORS issues
    // Server status can't be obtained this way unfortunately, so this uses "naturalWidth" to determine if the image has loaded
    // By default it checks if it is at least 1px, but you can add a second argument to change this
    // ==========================================================================
    function loadImage(src, minWidth = 1) {
        return new Promise((resolve, reject)=>{
            const image = new Image();
            const handler = ()=>{
                delete image.onload;
                delete image.onerror;
                (image.naturalWidth >= minWidth ? resolve : reject)(image);
            };
            Object.assign(image, {
                onload: handler,
                onerror: handler,
                src: src
            });
        });
    }
    // ==========================================================================
    const ui = {
        addStyleHook () {
            toggleClass(this.elements.container, this.config.selectors.container.replace('.', ''), true);
            toggleClass(this.elements.container, this.config.classNames.uiSupported, this.supported.ui);
        },
        // Toggle native HTML5 media controls
        toggleNativeControls (toggle = false) {
            if (toggle && this.isHTML5) this.media.setAttribute('controls', '');
            else this.media.removeAttribute('controls');
        },
        // Setup the UI
        build () {
            // Re-attach media element listeners
            // TODO: Use event bubbling?
            this.listeners.media();
            // Don't setup interface if no support
            if (!this.supported.ui) {
                this.debug.warn(`Basic support only for ${this.provider} ${this.type}`);
                // Restore native controls
                ui.toggleNativeControls.call(this, true);
                // Bail
                return;
            }
            // Inject custom controls if not present
            if (!is.element(this.elements.controls)) {
                // Inject custom controls
                controls.inject.call(this);
                // Re-attach control listeners
                this.listeners.controls();
            }
            // Remove native controls
            ui.toggleNativeControls.call(this);
            // Setup captions for HTML5
            if (this.isHTML5) captions.setup.call(this);
            // Reset volume
            this.volume = null;
            // Reset mute state
            this.muted = null;
            // Reset loop state
            this.loop = null;
            // Reset quality setting
            this.quality = null;
            // Reset speed
            this.speed = null;
            // Reset volume display
            controls.updateVolume.call(this);
            // Reset time display
            controls.timeUpdate.call(this);
            // Reset duration display
            controls.durationUpdate.call(this);
            // Update the UI
            ui.checkPlaying.call(this);
            // Check for picture-in-picture support
            toggleClass(this.elements.container, this.config.classNames.pip.supported, support.pip && this.isHTML5 && this.isVideo);
            // Check for airplay support
            toggleClass(this.elements.container, this.config.classNames.airplay.supported, support.airplay && this.isHTML5);
            // Add iOS class
            toggleClass(this.elements.container, this.config.classNames.isIos, browser.isIos);
            // Add touch class
            toggleClass(this.elements.container, this.config.classNames.isTouch, this.touch);
            // Ready for API calls
            this.ready = true;
            // Ready event at end of execution stack
            setTimeout(()=>{
                triggerEvent.call(this, this.media, 'ready');
            }, 0);
            // Set the title
            ui.setTitle.call(this);
            // Assure the poster image is set, if the property was added before the element was created
            if (this.poster) ui.setPoster.call(this, this.poster, false).catch(()=>{});
            // Manually set the duration if user has overridden it.
            // The event listeners for it doesn't get called if preload is disabled (#701)
            if (this.config.duration) controls.durationUpdate.call(this);
            // Media metadata
            if (this.config.mediaMetadata) controls.setMediaMetadata.call(this);
        },
        // Setup aria attribute for play and iframe title
        setTitle () {
            // Find the current text
            let label = i18n.get('play', this.config);
            // If there's a media title set, use that for the label
            if (is.string(this.config.title) && !is.empty(this.config.title)) label += `, ${this.config.title}`;
            // If there's a play button, set label
            Array.from(this.elements.buttons.play || []).forEach((button)=>{
                button.setAttribute('aria-label', label);
            });
            // Set iframe title
            // https://github.com/sampotts/plyr/issues/124
            if (this.isEmbed) {
                const iframe = getElement.call(this, 'iframe');
                if (!is.element(iframe)) return;
                // Default to media type
                const title = !is.empty(this.config.title) ? this.config.title : 'video';
                const format = i18n.get('frameTitle', this.config);
                iframe.setAttribute('title', format.replace('{title}', title));
            }
        },
        // Toggle poster
        togglePoster (enable) {
            toggleClass(this.elements.container, this.config.classNames.posterEnabled, enable);
        },
        // Set the poster image (async)
        // Used internally for the poster setter, with the passive option forced to false
        setPoster (poster, passive = true) {
            // Don't override if call is passive
            if (passive && this.poster) return Promise.reject(new Error('Poster already set'));
            // Set property synchronously to respect the call order
            this.media.setAttribute('data-poster', poster);
            // Show the poster
            this.elements.poster.removeAttribute('hidden');
            // Wait until ui is ready
            return ready.call(this)// Load image
            .then(()=>loadImage(poster)).catch((error)=>{
                // Hide poster on error unless it's been set by another call
                if (poster === this.poster) ui.togglePoster.call(this, false);
                // Rethrow
                throw error;
            }).then(()=>{
                // Prevent race conditions
                if (poster !== this.poster) throw new Error('setPoster cancelled by later call to setPoster');
            }).then(()=>{
                Object.assign(this.elements.poster.style, {
                    backgroundImage: `url('${poster}')`,
                    // Reset backgroundSize as well (since it can be set to "cover" for padded thumbnails for youtube)
                    backgroundSize: ''
                });
                ui.togglePoster.call(this, true);
                return poster;
            });
        },
        // Check playing state
        checkPlaying (event) {
            // Class hooks
            toggleClass(this.elements.container, this.config.classNames.playing, this.playing);
            toggleClass(this.elements.container, this.config.classNames.paused, this.paused);
            toggleClass(this.elements.container, this.config.classNames.stopped, this.stopped);
            // Set state
            Array.from(this.elements.buttons.play || []).forEach((target)=>{
                Object.assign(target, {
                    pressed: this.playing
                });
                target.setAttribute('aria-label', i18n.get(this.playing ? 'pause' : 'play', this.config));
            });
            // Only update controls on non timeupdate events
            if (is.event(event) && event.type === 'timeupdate') return;
            // Toggle controls
            ui.toggleControls.call(this);
        },
        // Check if media is loading
        checkLoading (event) {
            this.loading = [
                'stalled',
                'waiting'
            ].includes(event.type);
            // Clear timer
            clearTimeout(this.timers.loading);
            // Timer to prevent flicker when seeking
            this.timers.loading = setTimeout(()=>{
                // Update progress bar loading class state
                toggleClass(this.elements.container, this.config.classNames.loading, this.loading);
                // Update controls visibility
                ui.toggleControls.call(this);
            }, this.loading ? 250 : 0);
        },
        // Toggle controls based on state and `force` argument
        toggleControls (force) {
            const { controls: controlsElement } = this.elements;
            if (controlsElement && this.config.hideControls) {
                // Don't hide controls if a touch-device user recently seeked. (Must be limited to touch devices, or it occasionally prevents desktop controls from hiding.)
                const recentTouchSeek = this.touch && this.lastSeekTime + 2000 > Date.now();
                // Show controls if force, loading, paused, button interaction, or recent seek, otherwise hide
                this.toggleControls(Boolean(force || this.loading || this.paused || controlsElement.pressed || controlsElement.hover || recentTouchSeek));
            }
        },
        // Migrate any custom properties from the media to the parent
        migrateStyles () {
            // Loop through values (as they are the keys when the object is spread 🤔)
            Object.values({
                ...this.media.style
            })// We're only fussed about Plyr specific properties
            .filter((key)=>!is.empty(key) && is.string(key) && key.startsWith('--plyr')).forEach((key)=>{
                // Set on the container
                this.elements.container.style.setProperty(key, this.media.style.getPropertyValue(key));
                // Clean up from media element
                this.media.style.removeProperty(key);
            });
            // Remove attribute if empty
            if (is.empty(this.media.style)) this.media.removeAttribute('style');
        }
    };
    class Listeners {
        constructor(_player){
            _defineProperty$1(this, "firstTouch", ()=>{
                const { player: player } = this;
                const { elements: elements } = player;
                player.touch = true;
                // Add touch class
                toggleClass(elements.container, player.config.classNames.isTouch, true);
            });
            _defineProperty$1(this, "setTabFocus", (event)=>{
                const { player: player } = this;
                const { elements: elements } = player;
                const { key: key, type: type, timeStamp: timeStamp } = event;
                clearTimeout(this.focusTimer);
                // Ignore any key other than tab
                if (type === 'keydown' && key !== 'Tab') return;
                // Store reference to event timeStamp
                if (type === 'keydown') this.lastKeyDown = timeStamp;
                // Remove current classes
                const removeCurrent = ()=>{
                    const className = player.config.classNames.tabFocus;
                    const current = getElements.call(player, `.${className}`);
                    toggleClass(current, className, false);
                };
                // Determine if a key was pressed to trigger this event
                const wasKeyDown = timeStamp - this.lastKeyDown <= 20;
                // Ignore focus events if a key was pressed prior
                if (type === 'focus' && !wasKeyDown) return;
                // Remove all current
                removeCurrent();
                // Delay the adding of classname until the focus has changed
                // This event fires before the focusin event
                if (type !== 'focusout') this.focusTimer = setTimeout(()=>{
                    const focused = document.activeElement;
                    // Ignore if current focus element isn't inside the player
                    if (!elements.container.contains(focused)) return;
                    toggleClass(document.activeElement, player.config.classNames.tabFocus, true);
                }, 10);
            });
            _defineProperty$1(this, "global", (toggle = true)=>{
                const { player: player } = this;
                // Keyboard shortcuts
                if (player.config.keyboard.global) toggleListener.call(player, window, 'keydown keyup', this.handleKey, toggle, false);
                // Click anywhere closes menu
                toggleListener.call(player, document.body, 'click', this.toggleMenu, toggle);
                // Detect touch by events
                once.call(player, document.body, 'touchstart', this.firstTouch);
                // Tab focus detection
                toggleListener.call(player, document.body, 'keydown focus blur focusout', this.setTabFocus, toggle, false, true);
            });
            _defineProperty$1(this, "container", ()=>{
                const { player: player } = this;
                const { config: config, elements: elements, timers: timers } = player;
                // Keyboard shortcuts
                if (!config.keyboard.global && config.keyboard.focused) on.call(player, elements.container, 'keydown keyup', this.handleKey, false);
                // Toggle controls on mouse events and entering fullscreen
                on.call(player, elements.container, 'mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen', (event)=>{
                    const { controls: controlsElement } = elements;
                    // Remove button states for fullscreen
                    if (controlsElement && event.type === 'enterfullscreen') {
                        controlsElement.pressed = false;
                        controlsElement.hover = false;
                    }
                    // Show, then hide after a timeout unless another control event occurs
                    const show = [
                        'touchstart',
                        'touchmove',
                        'mousemove'
                    ].includes(event.type);
                    let delay = 0;
                    if (show) {
                        ui.toggleControls.call(player, true);
                        // Use longer timeout for touch devices
                        delay = player.touch ? 3000 : 2000;
                    }
                    // Clear timer
                    clearTimeout(timers.controls);
                    // Set new timer to prevent flicker when seeking
                    timers.controls = setTimeout(()=>ui.toggleControls.call(player, false), delay);
                });
                // Set a gutter for Vimeo
                const setGutter = ()=>{
                    if (!player.isVimeo || player.config.vimeo.premium) return;
                    const target = elements.wrapper;
                    const { active: active } = player.fullscreen;
                    const [videoWidth, videoHeight] = getAspectRatio.call(player);
                    const useNativeAspectRatio = supportsCSS(`aspect-ratio: ${videoWidth} / ${videoHeight}`);
                    // If not active, remove styles
                    if (!active) {
                        if (useNativeAspectRatio) {
                            target.style.width = null;
                            target.style.height = null;
                        } else {
                            target.style.maxWidth = null;
                            target.style.margin = null;
                        }
                        return;
                    }
                    // Determine which dimension will overflow and constrain view
                    const [viewportWidth, viewportHeight] = getViewportSize();
                    const overflow = viewportWidth / viewportHeight > videoWidth / videoHeight;
                    if (useNativeAspectRatio) {
                        target.style.width = overflow ? 'auto' : '100%';
                        target.style.height = overflow ? '100%' : 'auto';
                    } else {
                        target.style.maxWidth = overflow ? `${viewportHeight / videoHeight * videoWidth}px` : null;
                        target.style.margin = overflow ? '0 auto' : null;
                    }
                };
                // Handle resizing
                const resized = ()=>{
                    clearTimeout(timers.resized);
                    timers.resized = setTimeout(setGutter, 50);
                };
                on.call(player, elements.container, 'enterfullscreen exitfullscreen', (event)=>{
                    const { target: target } = player.fullscreen;
                    // Ignore events not from target
                    if (target !== elements.container) return;
                    // If it's not an embed and no ratio specified
                    if (!player.isEmbed && is.empty(player.config.ratio)) return;
                    // Set Vimeo gutter
                    setGutter();
                    // Watch for resizes
                    const method = event.type === 'enterfullscreen' ? on : off;
                    method.call(player, window, 'resize', resized);
                });
            });
            _defineProperty$1(this, "media", ()=>{
                const { player: player } = this;
                const { elements: elements } = player;
                // Time change on media
                on.call(player, player.media, 'timeupdate seeking seeked', (event)=>controls.timeUpdate.call(player, event));
                // Display duration
                on.call(player, player.media, 'durationchange loadeddata loadedmetadata', (event)=>controls.durationUpdate.call(player, event));
                // Handle the media finishing
                on.call(player, player.media, 'ended', ()=>{
                    // Show poster on end
                    if (player.isHTML5 && player.isVideo && player.config.resetOnEnd) {
                        // Restart
                        player.restart();
                        // Call pause otherwise IE11 will start playing the video again
                        player.pause();
                    }
                });
                // Check for buffer progress
                on.call(player, player.media, 'progress playing seeking seeked', (event)=>controls.updateProgress.call(player, event));
                // Handle volume changes
                on.call(player, player.media, 'volumechange', (event)=>controls.updateVolume.call(player, event));
                // Handle play/pause
                on.call(player, player.media, 'playing play pause ended emptied timeupdate', (event)=>ui.checkPlaying.call(player, event));
                // Loading state
                on.call(player, player.media, 'waiting canplay seeked playing', (event)=>ui.checkLoading.call(player, event));
                // Click video
                if (player.supported.ui && player.config.clickToPlay && !player.isAudio) {
                    // Re-fetch the wrapper
                    const wrapper = getElement.call(player, `.${player.config.classNames.video}`);
                    // Bail if there's no wrapper (this should never happen)
                    if (!is.element(wrapper)) return;
                    // On click play, pause or restart
                    on.call(player, elements.container, 'click', (event)=>{
                        const targets = [
                            elements.container,
                            wrapper
                        ];
                        // Ignore if click if not container or in video wrapper
                        if (!targets.includes(event.target) && !wrapper.contains(event.target)) return;
                        // Touch devices will just show controls (if hidden)
                        if (player.touch && player.config.hideControls) return;
                        if (player.ended) {
                            this.proxy(event, player.restart, 'restart');
                            this.proxy(event, ()=>{
                                silencePromise(player.play());
                            }, 'play');
                        } else this.proxy(event, ()=>{
                            silencePromise(player.togglePlay());
                        }, 'play');
                    });
                }
                // Disable right click
                if (player.supported.ui && player.config.disableContextMenu) on.call(player, elements.wrapper, 'contextmenu', (event)=>{
                    event.preventDefault();
                }, false);
                // Volume change
                on.call(player, player.media, 'volumechange', ()=>{
                    // Save to storage
                    player.storage.set({
                        volume: player.volume,
                        muted: player.muted
                    });
                });
                // Speed change
                on.call(player, player.media, 'ratechange', ()=>{
                    // Update UI
                    controls.updateSetting.call(player, 'speed');
                    // Save to storage
                    player.storage.set({
                        speed: player.speed
                    });
                });
                // Quality change
                on.call(player, player.media, 'qualitychange', (event)=>{
                    // Update UI
                    controls.updateSetting.call(player, 'quality', null, event.detail.quality);
                });
                // Update download link when ready and if quality changes
                on.call(player, player.media, 'ready qualitychange', ()=>{
                    controls.setDownloadUrl.call(player);
                });
                // Proxy events to container
                // Bubble up key events for Edge
                const proxyEvents = player.config.events.concat([
                    'keyup',
                    'keydown'
                ]).join(' ');
                on.call(player, player.media, proxyEvents, (event)=>{
                    let { detail: detail = {} } = event;
                    // Get error details from media
                    if (event.type === 'error') detail = player.media.error;
                    triggerEvent.call(player, elements.container, event.type, true, detail);
                });
            });
            _defineProperty$1(this, "proxy", (event, defaultHandler, customHandlerKey)=>{
                const { player: player } = this;
                const customHandler = player.config.listeners[customHandlerKey];
                const hasCustomHandler = is.function(customHandler);
                let returned = true;
                // Execute custom handler
                if (hasCustomHandler) returned = customHandler.call(player, event);
                // Only call default handler if not prevented in custom handler
                if (returned !== false && is.function(defaultHandler)) defaultHandler.call(player, event);
            });
            _defineProperty$1(this, "bind", (element, type, defaultHandler, customHandlerKey, passive = true)=>{
                const { player: player } = this;
                const customHandler = player.config.listeners[customHandlerKey];
                const hasCustomHandler = is.function(customHandler);
                on.call(player, element, type, (event)=>this.proxy(event, defaultHandler, customHandlerKey), passive && !hasCustomHandler);
            });
            _defineProperty$1(this, "controls", ()=>{
                const { player: player } = this;
                const { elements: elements } = player;
                // IE doesn't support input event, so we fallback to change
                const inputEvent = browser.isIE ? 'change' : 'input';
                // Play/pause toggle
                if (elements.buttons.play) Array.from(elements.buttons.play).forEach((button)=>{
                    this.bind(button, 'click', ()=>{
                        silencePromise(player.togglePlay());
                    }, 'play');
                });
                // Pause
                this.bind(elements.buttons.restart, 'click', player.restart, 'restart');
                // Rewind
                this.bind(elements.buttons.rewind, 'click', ()=>{
                    // Record seek time so we can prevent hiding controls for a few seconds after rewind
                    player.lastSeekTime = Date.now();
                    player.rewind();
                }, 'rewind');
                // Rewind
                this.bind(elements.buttons.fastForward, 'click', ()=>{
                    // Record seek time so we can prevent hiding controls for a few seconds after fast forward
                    player.lastSeekTime = Date.now();
                    player.forward();
                }, 'fastForward');
                // Mute toggle
                this.bind(elements.buttons.mute, 'click', ()=>{
                    player.muted = !player.muted;
                }, 'mute');
                // Captions toggle
                this.bind(elements.buttons.captions, 'click', ()=>player.toggleCaptions());
                // Download
                this.bind(elements.buttons.download, 'click', ()=>{
                    triggerEvent.call(player, player.media, 'download');
                }, 'download');
                // Fullscreen toggle
                this.bind(elements.buttons.fullscreen, 'click', ()=>{
                    player.fullscreen.toggle();
                }, 'fullscreen');
                // Picture-in-Picture
                this.bind(elements.buttons.pip, 'click', ()=>{
                    player.pip = 'toggle';
                }, 'pip');
                // Airplay
                this.bind(elements.buttons.airplay, 'click', player.airplay, 'airplay');
                // Settings menu - click toggle
                this.bind(elements.buttons.settings, 'click', (event)=>{
                    // Prevent the document click listener closing the menu
                    event.stopPropagation();
                    event.preventDefault();
                    controls.toggleMenu.call(player, event);
                }, null, false); // Can't be passive as we're preventing default
                // Settings menu - keyboard toggle
                // We have to bind to keyup otherwise Firefox triggers a click when a keydown event handler shifts focus
                // https://bugzilla.mozilla.org/show_bug.cgi?id=1220143
                this.bind(elements.buttons.settings, 'keyup', (event)=>{
                    if (![
                        'Space',
                        'Enter'
                    ].includes(event.key)) return;
                    // Because return triggers a click anyway, all we need to do is set focus
                    if (event.key === 'Enter') {
                        controls.focusFirstMenuItem.call(player, null, true);
                        return;
                    }
                    // Prevent scroll
                    event.preventDefault();
                    // Prevent playing video (Firefox)
                    event.stopPropagation();
                    // Toggle menu
                    controls.toggleMenu.call(player, event);
                }, null, false // Can't be passive as we're preventing default
                );
                // Escape closes menu
                this.bind(elements.settings.menu, 'keydown', (event)=>{
                    if (event.key === 'Escape') controls.toggleMenu.call(player, event);
                });
                // Set range input alternative "value", which matches the tooltip time (#954)
                this.bind(elements.inputs.seek, 'mousedown mousemove', (event)=>{
                    const rect = elements.progress.getBoundingClientRect();
                    const percent = 100 / rect.width * (event.pageX - rect.left);
                    event.currentTarget.setAttribute('seek-value', percent);
                });
                // Pause while seeking
                this.bind(elements.inputs.seek, 'mousedown mouseup keydown keyup touchstart touchend', (event)=>{
                    const seek = event.currentTarget;
                    const attribute = 'play-on-seeked';
                    if (is.keyboardEvent(event) && ![
                        'ArrowLeft',
                        'ArrowRight'
                    ].includes(event.key)) return;
                    // Record seek time so we can prevent hiding controls for a few seconds after seek
                    player.lastSeekTime = Date.now();
                    // Was playing before?
                    const play = seek.hasAttribute(attribute);
                    // Done seeking
                    const done = [
                        'mouseup',
                        'touchend',
                        'keyup'
                    ].includes(event.type);
                    // If we're done seeking and it was playing, resume playback
                    if (play && done) {
                        seek.removeAttribute(attribute);
                        silencePromise(player.play());
                    } else if (!done && player.playing) {
                        seek.setAttribute(attribute, '');
                        player.pause();
                    }
                });
                // Fix range inputs on iOS
                // Super weird iOS bug where after you interact with an <input type="range">,
                // it takes over further interactions on the page. This is a hack
                if (browser.isIos) {
                    const inputs = getElements.call(player, 'input[type="range"]');
                    Array.from(inputs).forEach((input)=>this.bind(input, inputEvent, (event)=>repaint(event.target)));
                }
                // Seek
                this.bind(elements.inputs.seek, inputEvent, (event)=>{
                    const seek = event.currentTarget;
                    // If it exists, use seek-value instead of "value" for consistency with tooltip time (#954)
                    let seekTo = seek.getAttribute('seek-value');
                    if (is.empty(seekTo)) seekTo = seek.value;
                    seek.removeAttribute('seek-value');
                    player.currentTime = seekTo / seek.max * player.duration;
                }, 'seek');
                // Seek tooltip
                this.bind(elements.progress, 'mouseenter mouseleave mousemove', (event)=>controls.updateSeekTooltip.call(player, event));
                // Preview thumbnails plugin
                // TODO: Really need to work on some sort of plug-in wide event bus or pub-sub for this
                this.bind(elements.progress, 'mousemove touchmove', (event)=>{
                    const { previewThumbnails: previewThumbnails } = player;
                    if (previewThumbnails && previewThumbnails.loaded) previewThumbnails.startMove(event);
                });
                // Hide thumbnail preview - on mouse click, mouse leave, and video play/seek. All four are required, e.g., for buffering
                this.bind(elements.progress, 'mouseleave touchend click', ()=>{
                    const { previewThumbnails: previewThumbnails } = player;
                    if (previewThumbnails && previewThumbnails.loaded) previewThumbnails.endMove(false, true);
                });
                // Show scrubbing preview
                this.bind(elements.progress, 'mousedown touchstart', (event)=>{
                    const { previewThumbnails: previewThumbnails } = player;
                    if (previewThumbnails && previewThumbnails.loaded) previewThumbnails.startScrubbing(event);
                });
                this.bind(elements.progress, 'mouseup touchend', (event)=>{
                    const { previewThumbnails: previewThumbnails } = player;
                    if (previewThumbnails && previewThumbnails.loaded) previewThumbnails.endScrubbing(event);
                });
                // Polyfill for lower fill in <input type="range"> for webkit
                if (browser.isWebkit) Array.from(getElements.call(player, 'input[type="range"]')).forEach((element)=>{
                    this.bind(element, 'input', (event)=>controls.updateRangeFill.call(player, event.target));
                });
                // Current time invert
                // Only if one time element is used for both currentTime and duration
                if (player.config.toggleInvert && !is.element(elements.display.duration)) this.bind(elements.display.currentTime, 'click', ()=>{
                    // Do nothing if we're at the start
                    if (player.currentTime === 0) return;
                    player.config.invertTime = !player.config.invertTime;
                    controls.timeUpdate.call(player);
                });
                // Volume
                this.bind(elements.inputs.volume, inputEvent, (event)=>{
                    player.volume = event.target.value;
                }, 'volume');
                // Update controls.hover state (used for ui.toggleControls to avoid hiding when interacting)
                this.bind(elements.controls, 'mouseenter mouseleave', (event)=>{
                    elements.controls.hover = !player.touch && event.type === 'mouseenter';
                });
                // Also update controls.hover state for any non-player children of fullscreen element (as above)
                if (elements.fullscreen) Array.from(elements.fullscreen.children).filter((c)=>!c.contains(elements.container)).forEach((child)=>{
                    this.bind(child, 'mouseenter mouseleave', (event)=>{
                        if (elements.controls) elements.controls.hover = !player.touch && event.type === 'mouseenter';
                    });
                });
                // Update controls.pressed state (used for ui.toggleControls to avoid hiding when interacting)
                this.bind(elements.controls, 'mousedown mouseup touchstart touchend touchcancel', (event)=>{
                    elements.controls.pressed = [
                        'mousedown',
                        'touchstart'
                    ].includes(event.type);
                });
                // Show controls when they receive focus (e.g., when using keyboard tab key)
                this.bind(elements.controls, 'focusin', ()=>{
                    const { config: config, timers: timers } = player;
                    // Skip transition to prevent focus from scrolling the parent element
                    toggleClass(elements.controls, config.classNames.noTransition, true);
                    // Toggle
                    ui.toggleControls.call(player, true);
                    // Restore transition
                    setTimeout(()=>{
                        toggleClass(elements.controls, config.classNames.noTransition, false);
                    }, 0);
                    // Delay a little more for mouse users
                    const delay = this.touch ? 3000 : 4000;
                    // Clear timer
                    clearTimeout(timers.controls);
                    // Hide again after delay
                    timers.controls = setTimeout(()=>ui.toggleControls.call(player, false), delay);
                });
                // Mouse wheel for volume
                this.bind(elements.inputs.volume, 'wheel', (event)=>{
                    // Detect "natural" scroll - supported on OS X Safari only
                    // Other browsers on OS X will be inverted until support improves
                    const inverted = event.webkitDirectionInvertedFromDevice;
                    // Get delta from event. Invert if `inverted` is true
                    const [x, y] = [
                        event.deltaX,
                        -event.deltaY
                    ].map((value)=>inverted ? -value : value);
                    // Using the biggest delta, normalize to 1 or -1 (or 0 if no delta)
                    const direction = Math.sign(Math.abs(x) > Math.abs(y) ? x : y);
                    // Change the volume by 2%
                    player.increaseVolume(direction / 50);
                    // Don't break page scrolling at max and min
                    const { volume: volume } = player.media;
                    if (direction === 1 && volume < 1 || direction === -1 && volume > 0) event.preventDefault();
                }, 'volume', false);
            });
            this.player = _player;
            this.lastKey = null;
            this.focusTimer = null;
            this.lastKeyDown = null;
            this.handleKey = this.handleKey.bind(this);
            this.toggleMenu = this.toggleMenu.bind(this);
            this.setTabFocus = this.setTabFocus.bind(this);
            this.firstTouch = this.firstTouch.bind(this);
        }
        // Handle key presses
        handleKey(event) {
            const { player: player } = this;
            const { elements: elements } = player;
            const { key: key, type: type, altKey: altKey, ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey } = event;
            const pressed = type === 'keydown';
            const repeat = pressed && key === this.lastKey;
            // Bail if a modifier key is set
            if (altKey || ctrlKey || metaKey || shiftKey) return;
            // If the event is bubbled from the media element
            // Firefox doesn't get the key for whatever reason
            if (!key) return;
            // Seek by increment
            const seekByIncrement = (increment)=>{
                // Divide the max duration into 10th's and times by the number value
                player.currentTime = player.duration / 10 * increment;
            };
            // Handle the key on keydown
            // Reset on keyup
            if (pressed) {
                // Check focused element
                // and if the focused element is not editable (e.g. text input)
                // and any that accept key input http://webaim.org/techniques/keyboard/
                const focused = document.activeElement;
                if (is.element(focused)) {
                    const { editable: editable } = player.config.selectors;
                    const { seek: seek } = elements.inputs;
                    if (focused !== seek && matches(focused, editable)) return;
                    if (event.key === 'Space' && matches(focused, 'button, [role^="menuitem"]')) return;
                }
                // Which keys should we prevent default
                const preventDefault = [
                    'Space',
                    'ArrowLeft',
                    'ArrowUp',
                    'ArrowRight',
                    'ArrowDown',
                    '0',
                    '1',
                    '2',
                    '3',
                    '4',
                    '5',
                    '6',
                    '7',
                    '8',
                    '9',
                    'c',
                    'f',
                    'k',
                    'l',
                    'm'
                ];
                // If the key is found prevent default (e.g. prevent scrolling for arrows)
                if (preventDefault.includes(key)) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                switch(key){
                    case '0':
                    case '1':
                    case '2':
                    case '3':
                    case '4':
                    case '5':
                    case '6':
                    case '7':
                    case '8':
                    case '9':
                        if (!repeat) seekByIncrement(parseInt(key, 10));
                        break;
                    case 'Space':
                    case 'k':
                        if (!repeat) silencePromise(player.togglePlay());
                        break;
                    case 'ArrowUp':
                        player.increaseVolume(0.1);
                        break;
                    case 'ArrowDown':
                        player.decreaseVolume(0.1);
                        break;
                    case 'm':
                        if (!repeat) player.muted = !player.muted;
                        break;
                    case 'ArrowRight':
                        player.forward();
                        break;
                    case 'ArrowLeft':
                        player.rewind();
                        break;
                    case 'f':
                        player.fullscreen.toggle();
                        break;
                    case 'c':
                        if (!repeat) player.toggleCaptions();
                        break;
                    case 'l':
                        player.loop = !player.loop;
                        break;
                }
                // Escape is handle natively when in full screen
                // So we only need to worry about non native
                if (key === 'Escape' && !player.fullscreen.usingNative && player.fullscreen.active) player.fullscreen.toggle();
                // Store last key for next cycle
                this.lastKey = key;
            } else this.lastKey = null;
        }
        // Toggle menu
        toggleMenu(event) {
            controls.toggleMenu.call(this.player, event);
        }
    }
    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
    function createCommonjsModule(fn, module1) {
        return module1 = {
            exports: {}
        }, fn(module1, module1.exports), module1.exports;
    }
    var loadjs_umd = createCommonjsModule(function(module1, exports) {
        (function(root, factory) {
            module1.exports = factory();
        })(commonjsGlobal, function() {
            /**
       * Global dependencies.
       * @global {Object} document - DOM
       */ var devnull = function() {}, bundleIdCache = {}, bundleResultCache = {}, bundleCallbackQueue = {};
            /**
       * Subscribe to bundle load event.
       * @param {string[]} bundleIds - Bundle ids
       * @param {Function} callbackFn - The callback function
       */ function subscribe(bundleIds, callbackFn) {
                // listify
                bundleIds = bundleIds.push ? bundleIds : [
                    bundleIds
                ];
                var depsNotFound = [], i = bundleIds.length, numWaiting = i, fn, bundleId, r, q;
                // define callback function
                fn = function(bundleId, pathsNotFound) {
                    if (pathsNotFound.length) depsNotFound.push(bundleId);
                    numWaiting--;
                    if (!numWaiting) callbackFn(depsNotFound);
                };
                // register callback
                while(i--){
                    bundleId = bundleIds[i];
                    // execute callback if in result cache
                    r = bundleResultCache[bundleId];
                    if (r) {
                        fn(bundleId, r);
                        continue;
                    }
                    // add to callback queue
                    q = bundleCallbackQueue[bundleId] = bundleCallbackQueue[bundleId] || [];
                    q.push(fn);
                }
            }
            /**
       * Publish bundle load event.
       * @param {string} bundleId - Bundle id
       * @param {string[]} pathsNotFound - List of files not found
       */ function publish(bundleId, pathsNotFound) {
                // exit if id isn't defined
                if (!bundleId) return;
                var q = bundleCallbackQueue[bundleId];
                // cache result
                bundleResultCache[bundleId] = pathsNotFound;
                // exit if queue is empty
                if (!q) return;
                // empty callback queue
                while(q.length){
                    q[0](bundleId, pathsNotFound);
                    q.splice(0, 1);
                }
            }
            /**
       * Execute callbacks.
       * @param {Object or Function} args - The callback args
       * @param {string[]} depsNotFound - List of dependencies not found
       */ function executeCallbacks(args, depsNotFound) {
                // accept function as argument
                if (args.call) args = {
                    success: args
                };
                // success and error callbacks
                if (depsNotFound.length) (args.error || devnull)(depsNotFound);
                else (args.success || devnull)(args);
            }
            /**
       * Load individual file.
       * @param {string} path - The file path
       * @param {Function} callbackFn - The callback function
       */ function loadFile(path, callbackFn, args, numTries) {
                var doc = document, async = args.async, maxTries = (args.numRetries || 0) + 1, beforeCallbackFn = args.before || devnull, pathname = path.replace(/[\?|#].*$/, ''), pathStripped = path.replace(/^(css|img)!/, ''), isLegacyIECss, e;
                numTries = numTries || 0;
                if (/(^css!|\.css$)/.test(pathname)) {
                    // css
                    e = doc.createElement('link');
                    e.rel = 'stylesheet';
                    e.href = pathStripped;
                    // tag IE9+
                    isLegacyIECss = 'hideFocus' in e;
                    // use preload in IE Edge (to detect load errors)
                    if (isLegacyIECss && e.relList) {
                        isLegacyIECss = 0;
                        e.rel = 'preload';
                        e.as = 'style';
                    }
                } else if (/(^img!|\.(png|gif|jpg|svg|webp)$)/.test(pathname)) {
                    // image
                    e = doc.createElement('img');
                    e.src = pathStripped;
                } else {
                    // javascript
                    e = doc.createElement('script');
                    e.src = path;
                    e.async = async === undefined ? true : async;
                }
                e.onload = e.onerror = e.onbeforeload = function(ev) {
                    var result = ev.type[0];
                    // treat empty stylesheets as failures to get around lack of onerror
                    // support in IE9-11
                    if (isLegacyIECss) try {
                        if (!e.sheet.cssText.length) result = 'e';
                    } catch (x) {
                        // sheets objects created from load errors don't allow access to
                        // `cssText` (unless error is Code:18 SecurityError)
                        if (x.code != 18) result = 'e';
                    }
                    // handle retries in case of load failure
                    if (result == 'e') {
                        // increment counter
                        numTries += 1;
                        // exit function and try again
                        if (numTries < maxTries) return loadFile(path, callbackFn, args, numTries);
                    } else if (e.rel == 'preload' && e.as == 'style') // activate preloaded stylesheets
                    return e.rel = 'stylesheet'; // jshint ignore:line
                    // execute callback
                    callbackFn(path, result, ev.defaultPrevented);
                };
                // add to document (unless callback returns `false`)
                if (beforeCallbackFn(path, e) !== false) doc.head.appendChild(e);
            }
            /**
       * Load multiple files.
       * @param {string[]} paths - The file paths
       * @param {Function} callbackFn - The callback function
       */ function loadFiles(paths, callbackFn, args) {
                // listify paths
                paths = paths.push ? paths : [
                    paths
                ];
                var numWaiting = paths.length, x = numWaiting, pathsNotFound = [], fn, i;
                // define callback function
                fn = function(path, result, defaultPrevented) {
                    // handle error
                    if (result == 'e') pathsNotFound.push(path);
                    // handle beforeload event. If defaultPrevented then that means the load
                    // will be blocked (ex. Ghostery/ABP on Safari)
                    if (result == 'b') {
                        if (defaultPrevented) pathsNotFound.push(path);
                        else return;
                    }
                    numWaiting--;
                    if (!numWaiting) callbackFn(pathsNotFound);
                };
                // load scripts
                for(i = 0; i < x; i++)loadFile(paths[i], fn, args);
            }
            /**
       * Initiate script load and register bundle.
       * @param {(string|string[])} paths - The file paths
       * @param {(string|Function|Object)} [arg1] - The (1) bundleId or (2) success
       *   callback or (3) object literal with success/error arguments, numRetries,
       *   etc.
       * @param {(Function|Object)} [arg2] - The (1) success callback or (2) object
       *   literal with success/error arguments, numRetries, etc.
       */ function loadjs(paths, arg1, arg2) {
                var bundleId, args;
                // bundleId (if string)
                if (arg1 && arg1.trim) bundleId = arg1;
                // args (default is {})
                args = (bundleId ? arg2 : arg1) || {};
                // throw error if bundle is already defined
                if (bundleId) {
                    if (bundleId in bundleIdCache) throw "LoadJS";
                    else bundleIdCache[bundleId] = true;
                }
                function loadFn(resolve, reject) {
                    loadFiles(paths, function(pathsNotFound) {
                        // execute callbacks
                        executeCallbacks(args, pathsNotFound);
                        // resolve Promise
                        if (resolve) executeCallbacks({
                            success: resolve,
                            error: reject
                        }, pathsNotFound);
                        // publish bundle load event
                        publish(bundleId, pathsNotFound);
                    }, args);
                }
                if (args.returnPromise) return new Promise(loadFn);
                else loadFn();
            }
            /**
       * Execute callbacks when dependencies have been satisfied.
       * @param {(string|string[])} deps - List of bundle ids
       * @param {Object} args - success/error arguments
       */ loadjs.ready = function ready(deps, args) {
                // subscribe to bundle load event
                subscribe(deps, function(depsNotFound) {
                    // execute callbacks
                    executeCallbacks(args, depsNotFound);
                });
                return loadjs;
            };
            /**
       * Manually satisfy bundle dependencies.
       * @param {string} bundleId - The bundle id
       */ loadjs.done = function done(bundleId) {
                publish(bundleId, []);
            };
            /**
       * Reset loadjs dependencies statuses
       */ loadjs.reset = function reset() {
                bundleIdCache = {};
                bundleResultCache = {};
                bundleCallbackQueue = {};
            };
            /**
       * Determine if bundle has already been defined
       * @param String} bundleId - The bundle id
       */ loadjs.isDefined = function isDefined(bundleId) {
                return bundleId in bundleIdCache;
            };
            // export
            return loadjs;
        });
    });
    // ==========================================================================
    function loadScript(url) {
        return new Promise((resolve, reject)=>{
            loadjs_umd(url, {
                success: resolve,
                error: reject
            });
        });
    }
    // ==========================================================================
    // Parse Vimeo ID from URL
    function parseId$1(url) {
        if (is.empty(url)) return null;
        if (is.number(Number(url))) return url;
        const regex = /^.*(vimeo.com\/|video\/)(\d+).*/;
        return url.match(regex) ? RegExp.$2 : url;
    }
    // Try to extract a hash for private videos from the URL
    function parseHash(url) {
        /* This regex matches a hexadecimal hash if given in any of these forms:
     *  - [https://player.]vimeo.com/video/{id}/{hash}[?params]
     *  - [https://player.]vimeo.com/video/{id}?h={hash}[&params]
     *  - [https://player.]vimeo.com/video/{id}?[params]&h={hash}
     *  - video/{id}/{hash}
     * If matched, the hash is available in capture group 4
     */ const regex = /^.*(vimeo.com\/|video\/)(\d+)(\?.*&*h=|\/)+([\d,a-f]+)/;
        const found = url.match(regex);
        return found && found.length === 5 ? found[4] : null;
    }
    // Set playback state and trigger change (only on actual change)
    function assurePlaybackState$1(play) {
        if (play && !this.embed.hasPlayed) this.embed.hasPlayed = true;
        if (this.media.paused === play) {
            this.media.paused = !play;
            triggerEvent.call(this, this.media, play ? 'play' : 'pause');
        }
    }
    const vimeo = {
        setup () {
            const player = this;
            // Add embed class for responsive
            toggleClass(player.elements.wrapper, player.config.classNames.embed, true);
            // Set speed options from config
            player.options.speed = player.config.speed.options;
            // Set intial ratio
            setAspectRatio.call(player);
            // Load the SDK if not already
            if (!is.object(window.Vimeo)) loadScript(player.config.urls.vimeo.sdk).then(()=>{
                vimeo.ready.call(player);
            }).catch((error)=>{
                player.debug.warn('Vimeo SDK (player.js) failed to load', error);
            });
            else vimeo.ready.call(player);
        },
        // API Ready
        ready () {
            const player = this;
            const config = player.config.vimeo;
            const { premium: premium, referrerPolicy: referrerPolicy, ...frameParams } = config;
            // Get the source URL or ID
            let source = player.media.getAttribute('src');
            let hash = '';
            // Get from <div> if needed
            if (is.empty(source)) {
                source = player.media.getAttribute(player.config.attributes.embed.id);
                // hash can also be set as attribute on the <div>
                hash = player.media.getAttribute(player.config.attributes.embed.hash);
            } else hash = parseHash(source);
            const hashParam = hash ? {
                h: hash
            } : {};
            // If the owner has a pro or premium account then we can hide controls etc
            if (premium) Object.assign(frameParams, {
                controls: false,
                sidedock: false
            });
            // Get Vimeo params for the iframe
            const params = buildUrlParams({
                loop: player.config.loop.active,
                autoplay: player.autoplay,
                muted: player.muted,
                gesture: 'media',
                playsinline: !this.config.fullscreen.iosNative,
                // hash has to be added to iframe-URL
                ...hashParam,
                ...frameParams
            });
            const id = parseId$1(source);
            // Build an iframe
            const iframe = createElement('iframe');
            const src = format(player.config.urls.vimeo.iframe, id, params);
            iframe.setAttribute('src', src);
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('allow', [
                'autoplay',
                'fullscreen',
                'picture-in-picture',
                'encrypted-media',
                'accelerometer',
                'gyroscope'
            ].join('; '));
            // Set the referrer policy if required
            if (!is.empty(referrerPolicy)) iframe.setAttribute('referrerPolicy', referrerPolicy);
            // Inject the package
            if (premium || !config.customControls) {
                iframe.setAttribute('data-poster', player.poster);
                player.media = replaceElement(iframe, player.media);
            } else {
                const wrapper = createElement('div', {
                    class: player.config.classNames.embedContainer,
                    'data-poster': player.poster
                });
                wrapper.appendChild(iframe);
                player.media = replaceElement(wrapper, player.media);
            }
            // Get poster image
            if (!config.customControls) fetch(format(player.config.urls.vimeo.api, src)).then((response)=>{
                if (is.empty(response) || !response.thumbnail_url) return;
                // Set and show poster
                ui.setPoster.call(player, response.thumbnail_url).catch(()=>{});
            });
            // Setup instance
            // https://github.com/vimeo/player.js
            player.embed = new window.Vimeo.Player(iframe, {
                autopause: player.config.autopause,
                muted: player.muted
            });
            player.media.paused = true;
            player.media.currentTime = 0;
            // Disable native text track rendering
            if (player.supported.ui) player.embed.disableTextTrack();
            // Create a faux HTML5 API using the Vimeo API
            player.media.play = ()=>{
                assurePlaybackState$1.call(player, true);
                return player.embed.play();
            };
            player.media.pause = ()=>{
                assurePlaybackState$1.call(player, false);
                return player.embed.pause();
            };
            player.media.stop = ()=>{
                player.pause();
                player.currentTime = 0;
            };
            // Seeking
            let { currentTime: currentTime } = player.media;
            Object.defineProperty(player.media, 'currentTime', {
                get () {
                    return currentTime;
                },
                set (time) {
                    // Vimeo will automatically play on seek if the video hasn't been played before
                    // Get current paused state and volume etc
                    const { embed: embed, media: media, paused: paused, volume: volume } = player;
                    const restorePause = paused && !embed.hasPlayed;
                    // Set seeking state and trigger event
                    media.seeking = true;
                    triggerEvent.call(player, media, 'seeking');
                    // If paused, mute until seek is complete
                    Promise.resolve(restorePause && embed.setVolume(0))// Seek
                    .then(()=>embed.setCurrentTime(time))// Restore paused
                    .then(()=>restorePause && embed.pause())// Restore volume
                    .then(()=>restorePause && embed.setVolume(volume)).catch(()=>{
                    // Do nothing
                    });
                }
            });
            // Playback speed
            let speed = player.config.speed.selected;
            Object.defineProperty(player.media, 'playbackRate', {
                get () {
                    return speed;
                },
                set (input) {
                    player.embed.setPlaybackRate(input).then(()=>{
                        speed = input;
                        triggerEvent.call(player, player.media, 'ratechange');
                    }).catch(()=>{
                        // Cannot set Playback Rate, Video is probably not on Pro account
                        player.options.speed = [
                            1
                        ];
                    });
                }
            });
            // Volume
            let { volume: volume } = player.config;
            Object.defineProperty(player.media, 'volume', {
                get () {
                    return volume;
                },
                set (input) {
                    player.embed.setVolume(input).then(()=>{
                        volume = input;
                        triggerEvent.call(player, player.media, 'volumechange');
                    });
                }
            });
            // Muted
            let { muted: muted } = player.config;
            Object.defineProperty(player.media, 'muted', {
                get () {
                    return muted;
                },
                set (input) {
                    const toggle = is.boolean(input) ? input : false;
                    player.embed.setVolume(toggle ? 0 : player.config.volume).then(()=>{
                        muted = toggle;
                        triggerEvent.call(player, player.media, 'volumechange');
                    });
                }
            });
            // Loop
            let { loop: loop } = player.config;
            Object.defineProperty(player.media, 'loop', {
                get () {
                    return loop;
                },
                set (input) {
                    const toggle = is.boolean(input) ? input : player.config.loop.active;
                    player.embed.setLoop(toggle).then(()=>{
                        loop = toggle;
                    });
                }
            });
            // Source
            let currentSrc;
            player.embed.getVideoUrl().then((value)=>{
                currentSrc = value;
                controls.setDownloadUrl.call(player);
            }).catch((error)=>{
                this.debug.warn(error);
            });
            Object.defineProperty(player.media, 'currentSrc', {
                get () {
                    return currentSrc;
                }
            });
            // Ended
            Object.defineProperty(player.media, 'ended', {
                get () {
                    return player.currentTime === player.duration;
                }
            });
            // Set aspect ratio based on video size
            Promise.all([
                player.embed.getVideoWidth(),
                player.embed.getVideoHeight()
            ]).then((dimensions)=>{
                const [width, height] = dimensions;
                player.embed.ratio = roundAspectRatio(width, height);
                setAspectRatio.call(this);
            });
            // Set autopause
            player.embed.setAutopause(player.config.autopause).then((state)=>{
                player.config.autopause = state;
            });
            // Get title
            player.embed.getVideoTitle().then((title)=>{
                player.config.title = title;
                ui.setTitle.call(this);
            });
            // Get current time
            player.embed.getCurrentTime().then((value)=>{
                currentTime = value;
                triggerEvent.call(player, player.media, 'timeupdate');
            });
            // Get duration
            player.embed.getDuration().then((value)=>{
                player.media.duration = value;
                triggerEvent.call(player, player.media, 'durationchange');
            });
            // Get captions
            player.embed.getTextTracks().then((tracks)=>{
                player.media.textTracks = tracks;
                captions.setup.call(player);
            });
            player.embed.on('cuechange', ({ cues: cues = [] })=>{
                const strippedCues = cues.map((cue)=>stripHTML(cue.text));
                captions.updateCues.call(player, strippedCues);
            });
            player.embed.on('loaded', ()=>{
                // Assure state and events are updated on autoplay
                player.embed.getPaused().then((paused)=>{
                    assurePlaybackState$1.call(player, !paused);
                    if (!paused) triggerEvent.call(player, player.media, 'playing');
                });
                if (is.element(player.embed.element) && player.supported.ui) {
                    const frame = player.embed.element;
                    // Fix keyboard focus issues
                    // https://github.com/sampotts/plyr/issues/317
                    frame.setAttribute('tabindex', -1);
                }
            });
            player.embed.on('bufferstart', ()=>{
                triggerEvent.call(player, player.media, 'waiting');
            });
            player.embed.on('bufferend', ()=>{
                triggerEvent.call(player, player.media, 'playing');
            });
            player.embed.on('play', ()=>{
                assurePlaybackState$1.call(player, true);
                triggerEvent.call(player, player.media, 'playing');
            });
            player.embed.on('pause', ()=>{
                assurePlaybackState$1.call(player, false);
            });
            player.embed.on('timeupdate', (data)=>{
                player.media.seeking = false;
                currentTime = data.seconds;
                triggerEvent.call(player, player.media, 'timeupdate');
            });
            player.embed.on('progress', (data)=>{
                player.media.buffered = data.percent;
                triggerEvent.call(player, player.media, 'progress');
                // Check all loaded
                if (parseInt(data.percent, 10) === 1) triggerEvent.call(player, player.media, 'canplaythrough');
                // Get duration as if we do it before load, it gives an incorrect value
                // https://github.com/sampotts/plyr/issues/891
                player.embed.getDuration().then((value)=>{
                    if (value !== player.media.duration) {
                        player.media.duration = value;
                        triggerEvent.call(player, player.media, 'durationchange');
                    }
                });
            });
            player.embed.on('seeked', ()=>{
                player.media.seeking = false;
                triggerEvent.call(player, player.media, 'seeked');
            });
            player.embed.on('ended', ()=>{
                player.media.paused = true;
                triggerEvent.call(player, player.media, 'ended');
            });
            player.embed.on('error', (detail)=>{
                player.media.error = detail;
                triggerEvent.call(player, player.media, 'error');
            });
            // Rebuild UI
            if (config.customControls) setTimeout(()=>ui.build.call(player), 0);
        }
    };
    // ==========================================================================
    // Parse YouTube ID from URL
    function parseId(url) {
        if (is.empty(url)) return null;
        const regex = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        return url.match(regex) ? RegExp.$2 : url;
    }
    // Set playback state and trigger change (only on actual change)
    function assurePlaybackState(play) {
        if (play && !this.embed.hasPlayed) this.embed.hasPlayed = true;
        if (this.media.paused === play) {
            this.media.paused = !play;
            triggerEvent.call(this, this.media, play ? 'play' : 'pause');
        }
    }
    function getHost(config) {
        if (config.noCookie) return 'https://www.youtube-nocookie.com';
        if (window.location.protocol === 'http:') return 'http://www.youtube.com';
        // Use YouTube's default
        return undefined;
    }
    const youtube = {
        setup () {
            // Add embed class for responsive
            toggleClass(this.elements.wrapper, this.config.classNames.embed, true);
            // Setup API
            if (is.object(window.YT) && is.function(window.YT.Player)) youtube.ready.call(this);
            else {
                // Reference current global callback
                const callback = window.onYouTubeIframeAPIReady;
                // Set callback to process queue
                window.onYouTubeIframeAPIReady = ()=>{
                    // Call global callback if set
                    if (is.function(callback)) callback();
                    youtube.ready.call(this);
                };
                // Load the SDK
                loadScript(this.config.urls.youtube.sdk).catch((error)=>{
                    this.debug.warn('YouTube API failed to load', error);
                });
            }
        },
        // Get the media title
        getTitle (videoId) {
            const url = format(this.config.urls.youtube.api, videoId);
            fetch(url).then((data)=>{
                if (is.object(data)) {
                    const { title: title, height: height, width: width } = data;
                    // Set title
                    this.config.title = title;
                    ui.setTitle.call(this);
                    // Set aspect ratio
                    this.embed.ratio = roundAspectRatio(width, height);
                }
                setAspectRatio.call(this);
            }).catch(()=>{
                // Set aspect ratio
                setAspectRatio.call(this);
            });
        },
        // API ready
        ready () {
            const player = this;
            const config = player.config.youtube;
            // Ignore already setup (race condition)
            const currentId = player.media && player.media.getAttribute('id');
            if (!is.empty(currentId) && currentId.startsWith('youtube-')) return;
            // Get the source URL or ID
            let source = player.media.getAttribute('src');
            // Get from <div> if needed
            if (is.empty(source)) source = player.media.getAttribute(this.config.attributes.embed.id);
            // Replace the <iframe> with a <div> due to YouTube API issues
            const videoId = parseId(source);
            const id = generateId(player.provider);
            // Replace media element
            const container = createElement('div', {
                id: id,
                'data-poster': config.customControls ? player.poster : undefined
            });
            player.media = replaceElement(container, player.media);
            // Only load the poster when using custom controls
            if (config.customControls) {
                const posterSrc = (s)=>`https://i.ytimg.com/vi/${videoId}/${s}default.jpg`;
                // Check thumbnail images in order of quality, but reject fallback thumbnails (120px wide)
                loadImage(posterSrc('maxres'), 121) // Higest quality and unpadded
                .catch(()=>loadImage(posterSrc('sd'), 121)) // 480p padded 4:3
                .catch(()=>loadImage(posterSrc('hq'))) // 360p padded 4:3. Always exists
                .then((image)=>ui.setPoster.call(player, image.src)).then((src)=>{
                    // If the image is padded, use background-size "cover" instead (like youtube does too with their posters)
                    if (!src.includes('maxres')) player.elements.poster.style.backgroundSize = 'cover';
                }).catch(()=>{});
            }
            // Setup instance
            // https://developers.google.com/youtube/iframe_api_reference
            player.embed = new window.YT.Player(player.media, {
                videoId: videoId,
                host: getHost(config),
                playerVars: extend({}, {
                    // Autoplay
                    autoplay: player.config.autoplay ? 1 : 0,
                    // iframe interface language
                    hl: player.config.hl,
                    // Only show controls if not fully supported or opted out
                    controls: player.supported.ui && config.customControls ? 0 : 1,
                    // Disable keyboard as we handle it
                    disablekb: 1,
                    // Allow iOS inline playback
                    playsinline: !player.config.fullscreen.iosNative ? 1 : 0,
                    // Captions are flaky on YouTube
                    cc_load_policy: player.captions.active ? 1 : 0,
                    cc_lang_pref: player.config.captions.language,
                    // Tracking for stats
                    widget_referrer: window ? window.location.href : null
                }, config),
                events: {
                    onError (event) {
                        // YouTube may fire onError twice, so only handle it once
                        if (!player.media.error) {
                            const code = event.data;
                            // Messages copied from https://developers.google.com/youtube/iframe_api_reference#onError
                            const message = {
                                2: 'The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.',
                                5: 'The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.',
                                100: 'The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.',
                                101: 'The owner of the requested video does not allow it to be played in embedded players.',
                                150: 'The owner of the requested video does not allow it to be played in embedded players.'
                            }[code] || 'An unknown error occured';
                            player.media.error = {
                                code: code,
                                message: message
                            };
                            triggerEvent.call(player, player.media, 'error');
                        }
                    },
                    onPlaybackRateChange (event) {
                        // Get the instance
                        const instance = event.target;
                        // Get current speed
                        player.media.playbackRate = instance.getPlaybackRate();
                        triggerEvent.call(player, player.media, 'ratechange');
                    },
                    onReady (event) {
                        // Bail if onReady has already been called. See issue #1108
                        if (is.function(player.media.play)) return;
                        // Get the instance
                        const instance = event.target;
                        // Get the title
                        youtube.getTitle.call(player, videoId);
                        // Create a faux HTML5 API using the YouTube API
                        player.media.play = ()=>{
                            assurePlaybackState.call(player, true);
                            instance.playVideo();
                        };
                        player.media.pause = ()=>{
                            assurePlaybackState.call(player, false);
                            instance.pauseVideo();
                        };
                        player.media.stop = ()=>{
                            instance.stopVideo();
                        };
                        player.media.duration = instance.getDuration();
                        player.media.paused = true;
                        // Seeking
                        player.media.currentTime = 0;
                        Object.defineProperty(player.media, 'currentTime', {
                            get () {
                                return Number(instance.getCurrentTime());
                            },
                            set (time) {
                                // If paused and never played, mute audio preventively (YouTube starts playing on seek if the video hasn't been played yet).
                                if (player.paused && !player.embed.hasPlayed) player.embed.mute();
                                // Set seeking state and trigger event
                                player.media.seeking = true;
                                triggerEvent.call(player, player.media, 'seeking');
                                // Seek after events sent
                                instance.seekTo(time);
                            }
                        });
                        // Playback speed
                        Object.defineProperty(player.media, 'playbackRate', {
                            get () {
                                return instance.getPlaybackRate();
                            },
                            set (input) {
                                instance.setPlaybackRate(input);
                            }
                        });
                        // Volume
                        let { volume: volume } = player.config;
                        Object.defineProperty(player.media, 'volume', {
                            get () {
                                return volume;
                            },
                            set (input) {
                                volume = input;
                                instance.setVolume(volume * 100);
                                triggerEvent.call(player, player.media, 'volumechange');
                            }
                        });
                        // Muted
                        let { muted: muted } = player.config;
                        Object.defineProperty(player.media, 'muted', {
                            get () {
                                return muted;
                            },
                            set (input) {
                                const toggle = is.boolean(input) ? input : muted;
                                muted = toggle;
                                instance[toggle ? 'mute' : 'unMute']();
                                instance.setVolume(volume * 100);
                                triggerEvent.call(player, player.media, 'volumechange');
                            }
                        });
                        // Source
                        Object.defineProperty(player.media, 'currentSrc', {
                            get () {
                                return instance.getVideoUrl();
                            }
                        });
                        // Ended
                        Object.defineProperty(player.media, 'ended', {
                            get () {
                                return player.currentTime === player.duration;
                            }
                        });
                        // Get available speeds
                        const speeds = instance.getAvailablePlaybackRates();
                        // Filter based on config
                        player.options.speed = speeds.filter((s)=>player.config.speed.options.includes(s));
                        // Set the tabindex to avoid focus entering iframe
                        if (player.supported.ui && config.customControls) player.media.setAttribute('tabindex', -1);
                        triggerEvent.call(player, player.media, 'timeupdate');
                        triggerEvent.call(player, player.media, 'durationchange');
                        // Reset timer
                        clearInterval(player.timers.buffering);
                        // Setup buffering
                        player.timers.buffering = setInterval(()=>{
                            // Get loaded % from YouTube
                            player.media.buffered = instance.getVideoLoadedFraction();
                            // Trigger progress only when we actually buffer something
                            if (player.media.lastBuffered === null || player.media.lastBuffered < player.media.buffered) triggerEvent.call(player, player.media, 'progress');
                            // Set last buffer point
                            player.media.lastBuffered = player.media.buffered;
                            // Bail if we're at 100%
                            if (player.media.buffered === 1) {
                                clearInterval(player.timers.buffering);
                                // Trigger event
                                triggerEvent.call(player, player.media, 'canplaythrough');
                            }
                        }, 200);
                        // Rebuild UI
                        if (config.customControls) setTimeout(()=>ui.build.call(player), 50);
                    },
                    onStateChange (event) {
                        // Get the instance
                        const instance = event.target;
                        // Reset timer
                        clearInterval(player.timers.playing);
                        const seeked = player.media.seeking && [
                            1,
                            2
                        ].includes(event.data);
                        if (seeked) {
                            // Unset seeking and fire seeked event
                            player.media.seeking = false;
                            triggerEvent.call(player, player.media, 'seeked');
                        }
                        // Handle events
                        // -1   Unstarted
                        // 0    Ended
                        // 1    Playing
                        // 2    Paused
                        // 3    Buffering
                        // 5    Video cued
                        switch(event.data){
                            case -1:
                                // Update scrubber
                                triggerEvent.call(player, player.media, 'timeupdate');
                                // Get loaded % from YouTube
                                player.media.buffered = instance.getVideoLoadedFraction();
                                triggerEvent.call(player, player.media, 'progress');
                                break;
                            case 0:
                                assurePlaybackState.call(player, false);
                                // YouTube doesn't support loop for a single video, so mimick it.
                                if (player.media.loop) {
                                    // YouTube needs a call to `stopVideo` before playing again
                                    instance.stopVideo();
                                    instance.playVideo();
                                } else triggerEvent.call(player, player.media, 'ended');
                                break;
                            case 1:
                                // Restore paused state (YouTube starts playing on seek if the video hasn't been played yet)
                                if (config.customControls && !player.config.autoplay && player.media.paused && !player.embed.hasPlayed) player.media.pause();
                                else {
                                    assurePlaybackState.call(player, true);
                                    triggerEvent.call(player, player.media, 'playing');
                                    // Poll to get playback progress
                                    player.timers.playing = setInterval(()=>{
                                        triggerEvent.call(player, player.media, 'timeupdate');
                                    }, 50);
                                    // Check duration again due to YouTube bug
                                    // https://github.com/sampotts/plyr/issues/374
                                    // https://code.google.com/p/gdata-issues/issues/detail?id=8690
                                    if (player.media.duration !== instance.getDuration()) {
                                        player.media.duration = instance.getDuration();
                                        triggerEvent.call(player, player.media, 'durationchange');
                                    }
                                }
                                break;
                            case 2:
                                // Restore audio (YouTube starts playing on seek if the video hasn't been played yet)
                                if (!player.muted) player.embed.unMute();
                                assurePlaybackState.call(player, false);
                                break;
                            case 3:
                                // Trigger waiting event to add loading classes to container as the video buffers.
                                triggerEvent.call(player, player.media, 'waiting');
                                break;
                        }
                        triggerEvent.call(player, player.elements.container, 'statechange', false, {
                            code: event.data
                        });
                    }
                }
            });
        }
    };
    // ==========================================================================
    const media = {
        // Setup media
        setup () {
            // If there's no media, bail
            if (!this.media) {
                this.debug.warn('No media element found!');
                return;
            }
            // Add type class
            toggleClass(this.elements.container, this.config.classNames.type.replace('{0}', this.type), true);
            // Add provider class
            toggleClass(this.elements.container, this.config.classNames.provider.replace('{0}', this.provider), true);
            // Add video class for embeds
            // This will require changes if audio embeds are added
            if (this.isEmbed) toggleClass(this.elements.container, this.config.classNames.type.replace('{0}', 'video'), true);
            // Inject the player wrapper
            if (this.isVideo) {
                // Create the wrapper div
                this.elements.wrapper = createElement('div', {
                    class: this.config.classNames.video
                });
                // Wrap the video in a container
                wrap(this.media, this.elements.wrapper);
                // Poster image container
                this.elements.poster = createElement('div', {
                    class: this.config.classNames.poster
                });
                this.elements.wrapper.appendChild(this.elements.poster);
            }
            if (this.isHTML5) html5.setup.call(this);
            else if (this.isYouTube) youtube.setup.call(this);
            else if (this.isVimeo) vimeo.setup.call(this);
        }
    };
    const destroy = (instance)=>{
        // Destroy our adsManager
        if (instance.manager) instance.manager.destroy();
        // Destroy our adsManager
        if (instance.elements.displayContainer) instance.elements.displayContainer.destroy();
        instance.elements.container.remove();
    };
    class Ads {
        /**
     * Ads constructor.
     * @param {Object} player
     * @return {Ads}
     */ constructor(player){
            _defineProperty$1(this, "load", ()=>{
                if (!this.enabled) return;
                // Check if the Google IMA3 SDK is loaded or load it ourselves
                if (!is.object(window.google) || !is.object(window.google.ima)) loadScript(this.player.config.urls.googleIMA.sdk).then(()=>{
                    this.ready();
                }).catch(()=>{
                    // Script failed to load or is blocked
                    this.trigger('error', new Error('Google IMA SDK failed to load'));
                });
                else this.ready();
            });
            _defineProperty$1(this, "ready", ()=>{
                // Double check we're enabled
                if (!this.enabled) destroy(this);
                // Start ticking our safety timer. If the whole advertisement
                // thing doesn't resolve within our set time; we bail
                this.startSafetyTimer(12000, 'ready()');
                // Clear the safety timer
                this.managerPromise.then(()=>{
                    this.clearSafetyTimer('onAdsManagerLoaded()');
                });
                // Set listeners on the Plyr instance
                this.listeners();
                // Setup the IMA SDK
                this.setupIMA();
            });
            _defineProperty$1(this, "setupIMA", ()=>{
                // Create the container for our advertisements
                this.elements.container = createElement('div', {
                    class: this.player.config.classNames.ads
                });
                this.player.elements.container.appendChild(this.elements.container);
                // So we can run VPAID2
                google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED);
                // Set language
                google.ima.settings.setLocale(this.player.config.ads.language);
                // Set playback for iOS10+
                google.ima.settings.setDisableCustomPlaybackForIOS10Plus(this.player.config.playsinline);
                // We assume the adContainer is the video container of the plyr element that will house the ads
                this.elements.displayContainer = new google.ima.AdDisplayContainer(this.elements.container, this.player.media);
                // Create ads loader
                this.loader = new google.ima.AdsLoader(this.elements.displayContainer);
                // Listen and respond to ads loaded and error events
                this.loader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, (event)=>this.onAdsManagerLoaded(event), false);
                this.loader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (error)=>this.onAdError(error), false);
                // Request video ads to be pre-loaded
                this.requestAds();
            });
            _defineProperty$1(this, "requestAds", ()=>{
                const { container: container } = this.player.elements;
                try {
                    // Request video ads
                    const request = new google.ima.AdsRequest();
                    request.adTagUrl = this.tagUrl;
                    // Specify the linear and nonlinear slot sizes. This helps the SDK
                    // to select the correct creative if multiple are returned
                    request.linearAdSlotWidth = container.offsetWidth;
                    request.linearAdSlotHeight = container.offsetHeight;
                    request.nonLinearAdSlotWidth = container.offsetWidth;
                    request.nonLinearAdSlotHeight = container.offsetHeight;
                    // We only overlay ads as we only support video.
                    request.forceNonLinearFullSlot = false;
                    // Mute based on current state
                    request.setAdWillPlayMuted(!this.player.muted);
                    this.loader.requestAds(request);
                } catch (error) {
                    this.onAdError(error);
                }
            });
            _defineProperty$1(this, "pollCountdown", (start = false)=>{
                if (!start) {
                    clearInterval(this.countdownTimer);
                    this.elements.container.removeAttribute('data-badge-text');
                    return;
                }
                const update = ()=>{
                    const time = formatTime(Math.max(this.manager.getRemainingTime(), 0));
                    const label = `${i18n.get('advertisement', this.player.config)} - ${time}`;
                    this.elements.container.setAttribute('data-badge-text', label);
                };
                this.countdownTimer = setInterval(update, 100);
            });
            _defineProperty$1(this, "onAdsManagerLoaded", (event)=>{
                // Load could occur after a source change (race condition)
                if (!this.enabled) return;
                // Get the ads manager
                const settings = new google.ima.AdsRenderingSettings();
                // Tell the SDK to save and restore content video state on our behalf
                settings.restoreCustomPlaybackStateOnAdBreakComplete = true;
                settings.enablePreloading = true;
                // The SDK is polling currentTime on the contentPlayback. And needs a duration
                // so it can determine when to start the mid- and post-roll
                this.manager = event.getAdsManager(this.player, settings);
                // Get the cue points for any mid-rolls by filtering out the pre- and post-roll
                this.cuePoints = this.manager.getCuePoints();
                // Add listeners to the required events
                // Advertisement error events
                this.manager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (error)=>this.onAdError(error));
                // Advertisement regular events
                Object.keys(google.ima.AdEvent.Type).forEach((type)=>{
                    this.manager.addEventListener(google.ima.AdEvent.Type[type], (e)=>this.onAdEvent(e));
                });
                // Resolve our adsManager
                this.trigger('loaded');
            });
            _defineProperty$1(this, "addCuePoints", ()=>{
                // Add advertisement cue's within the time line if available
                if (!is.empty(this.cuePoints)) this.cuePoints.forEach((cuePoint)=>{
                    if (cuePoint !== 0 && cuePoint !== -1 && cuePoint < this.player.duration) {
                        const seekElement = this.player.elements.progress;
                        if (is.element(seekElement)) {
                            const cuePercentage = 100 / this.player.duration * cuePoint;
                            const cue = createElement('span', {
                                class: this.player.config.classNames.cues
                            });
                            cue.style.left = `${cuePercentage.toString()}%`;
                            seekElement.appendChild(cue);
                        }
                    }
                });
            });
            _defineProperty$1(this, "onAdEvent", (event)=>{
                const { container: container } = this.player.elements;
                // Retrieve the ad from the event. Some events (e.g. ALL_ADS_COMPLETED)
                // don't have ad object associated
                const ad = event.getAd();
                const adData = event.getAdData();
                // Proxy event
                const dispatchEvent = (type)=>{
                    triggerEvent.call(this.player, this.player.media, `ads${type.replace(/_/g, '').toLowerCase()}`);
                };
                // Bubble the event
                dispatchEvent(event.type);
                switch(event.type){
                    case google.ima.AdEvent.Type.LOADED:
                        // This is the first event sent for an ad - it is possible to determine whether the
                        // ad is a video ad or an overlay
                        this.trigger('loaded');
                        // Start countdown
                        this.pollCountdown(true);
                        if (!ad.isLinear()) {
                            // Position AdDisplayContainer correctly for overlay
                            ad.width = container.offsetWidth;
                            ad.height = container.offsetHeight;
                        }
                        break;
                    case google.ima.AdEvent.Type.STARTED:
                        // Set volume to match player
                        this.manager.setVolume(this.player.volume);
                        break;
                    case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
                        // All ads for the current videos are done. We can now request new advertisements
                        // in case the video is re-played
                        // TODO: Example for what happens when a next video in a playlist would be loaded.
                        // So here we load a new video when all ads are done.
                        // Then we load new ads within a new adsManager. When the video
                        // Is started - after - the ads are loaded, then we get ads.
                        // You can also easily test cancelling and reloading by running
                        // player.ads.cancel() and player.ads.play from the console I guess.
                        // this.player.source = {
                        //     type: 'video',
                        //     title: 'View From A Blue Moon',
                        //     sources: [{
                        //         src:
                        // 'https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-HD.mp4', type:
                        // 'video/mp4', }], poster:
                        // 'https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-HD.jpg', tracks:
                        // [ { kind: 'captions', label: 'English', srclang: 'en', src:
                        // 'https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-HD.en.vtt',
                        // default: true, }, { kind: 'captions', label: 'French', srclang: 'fr', src:
                        // 'https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-HD.fr.vtt', }, ],
                        // };
                        // TODO: So there is still this thing where a video should only be allowed to start
                        // playing when the IMA SDK is ready or has failed
                        if (this.player.ended) this.loadAds();
                        else // The SDK won't allow new ads to be called without receiving a contentComplete()
                        this.loader.contentComplete();
                        break;
                    case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:
                        // This event indicates the ad has started - the video player can adjust the UI,
                        // for example display a pause button and remaining time. Fired when content should
                        // be paused. This usually happens right before an ad is about to cover the content
                        this.pauseContent();
                        break;
                    case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:
                        // This event indicates the ad has finished - the video player can perform
                        // appropriate UI actions, such as removing the timer for remaining time detection.
                        // Fired when content should be resumed. This usually happens when an ad finishes
                        // or collapses
                        this.pollCountdown();
                        this.resumeContent();
                        break;
                    case google.ima.AdEvent.Type.LOG:
                        if (adData.adError) this.player.debug.warn(`Non-fatal ad error: ${adData.adError.getMessage()}`);
                        break;
                }
            });
            _defineProperty$1(this, "onAdError", (event)=>{
                this.cancel();
                this.player.debug.warn('Ads error', event);
            });
            _defineProperty$1(this, "listeners", ()=>{
                const { container: container } = this.player.elements;
                let time;
                this.player.on('canplay', ()=>{
                    this.addCuePoints();
                });
                this.player.on('ended', ()=>{
                    this.loader.contentComplete();
                });
                this.player.on('timeupdate', ()=>{
                    time = this.player.currentTime;
                });
                this.player.on('seeked', ()=>{
                    const seekedTime = this.player.currentTime;
                    if (is.empty(this.cuePoints)) return;
                    this.cuePoints.forEach((cuePoint, index)=>{
                        if (time < cuePoint && cuePoint < seekedTime) {
                            this.manager.discardAdBreak();
                            this.cuePoints.splice(index, 1);
                        }
                    });
                });
                // Listen to the resizing of the window. And resize ad accordingly
                // TODO: eventually implement ResizeObserver
                window.addEventListener('resize', ()=>{
                    if (this.manager) this.manager.resize(container.offsetWidth, container.offsetHeight, google.ima.ViewMode.NORMAL);
                });
            });
            _defineProperty$1(this, "play", ()=>{
                const { container: container } = this.player.elements;
                if (!this.managerPromise) this.resumeContent();
                // Play the requested advertisement whenever the adsManager is ready
                this.managerPromise.then(()=>{
                    // Set volume to match player
                    this.manager.setVolume(this.player.volume);
                    // Initialize the container. Must be done via a user action on mobile devices
                    this.elements.displayContainer.initialize();
                    try {
                        if (!this.initialized) {
                            // Initialize the ads manager. Ad rules playlist will start at this time
                            this.manager.init(container.offsetWidth, container.offsetHeight, google.ima.ViewMode.NORMAL);
                            // Call play to start showing the ad. Single video and overlay ads will
                            // start at this time; the call will be ignored for ad rules
                            this.manager.start();
                        }
                        this.initialized = true;
                    } catch (adError) {
                        // An error may be thrown if there was a problem with the
                        // VAST response
                        this.onAdError(adError);
                    }
                }).catch(()=>{});
            });
            _defineProperty$1(this, "resumeContent", ()=>{
                // Hide the advertisement container
                this.elements.container.style.zIndex = '';
                // Ad is stopped
                this.playing = false;
                // Play video
                silencePromise(this.player.media.play());
            });
            _defineProperty$1(this, "pauseContent", ()=>{
                // Show the advertisement container
                this.elements.container.style.zIndex = 3;
                // Ad is playing
                this.playing = true;
                // Pause our video.
                this.player.media.pause();
            });
            _defineProperty$1(this, "cancel", ()=>{
                // Pause our video
                if (this.initialized) this.resumeContent();
                // Tell our instance that we're done for now
                this.trigger('error');
                // Re-create our adsManager
                this.loadAds();
            });
            _defineProperty$1(this, "loadAds", ()=>{
                // Tell our adsManager to go bye bye
                this.managerPromise.then(()=>{
                    // Destroy our adsManager
                    if (this.manager) this.manager.destroy();
                    // Re-set our adsManager promises
                    this.managerPromise = new Promise((resolve)=>{
                        this.on('loaded', resolve);
                        this.player.debug.log(this.manager);
                    });
                    // Now that the manager has been destroyed set it to also be un-initialized
                    this.initialized = false;
                    // Now request some new advertisements
                    this.requestAds();
                }).catch(()=>{});
            });
            _defineProperty$1(this, "trigger", (event, ...args)=>{
                const handlers = this.events[event];
                if (is.array(handlers)) handlers.forEach((handler)=>{
                    if (is.function(handler)) handler.apply(this, args);
                });
            });
            _defineProperty$1(this, "on", (event, callback)=>{
                if (!is.array(this.events[event])) this.events[event] = [];
                this.events[event].push(callback);
                return this;
            });
            _defineProperty$1(this, "startSafetyTimer", (time, from)=>{
                this.player.debug.log(`Safety timer invoked from: ${from}`);
                this.safetyTimer = setTimeout(()=>{
                    this.cancel();
                    this.clearSafetyTimer('startSafetyTimer()');
                }, time);
            });
            _defineProperty$1(this, "clearSafetyTimer", (from)=>{
                if (!is.nullOrUndefined(this.safetyTimer)) {
                    this.player.debug.log(`Safety timer cleared from: ${from}`);
                    clearTimeout(this.safetyTimer);
                    this.safetyTimer = null;
                }
            });
            this.player = player;
            this.config = player.config.ads;
            this.playing = false;
            this.initialized = false;
            this.elements = {
                container: null,
                displayContainer: null
            };
            this.manager = null;
            this.loader = null;
            this.cuePoints = null;
            this.events = {};
            this.safetyTimer = null;
            this.countdownTimer = null;
            // Setup a promise to resolve when the IMA manager is ready
            this.managerPromise = new Promise((resolve, reject)=>{
                // The ad is loaded and ready
                this.on('loaded', resolve);
                // Ads failed
                this.on('error', reject);
            });
            this.load();
        }
        get enabled() {
            const { config: config } = this;
            return this.player.isHTML5 && this.player.isVideo && config.enabled && (!is.empty(config.publisherId) || is.url(config.tagUrl));
        }
        /**
     * Load the IMA SDK
     */ // Build the tag URL
        get tagUrl() {
            const { config: config } = this;
            if (is.url(config.tagUrl)) return config.tagUrl;
            const params = {
                AV_PUBLISHERID: '58c25bb0073ef448b1087ad6',
                AV_CHANNELID: '5a0458dc28a06145e4519d21',
                AV_URL: window.location.hostname,
                cb: Date.now(),
                AV_WIDTH: 640,
                AV_HEIGHT: 480,
                AV_CDIM2: config.publisherId
            };
            const base = 'https://go.aniview.com/api/adserver6/vast/';
            return `${base}?${buildUrlParams(params)}`;
        }
    }
    /**
   * Returns a number whose value is limited to the given range.
   *
   * Example: limit the output of this computation to between 0 and 255
   * (x * 255).clamp(0, 255)
   *
   * @param {Number} input
   * @param {Number} min The lower boundary of the output range
   * @param {Number} max The upper boundary of the output range
   * @returns A number within the bounds of min and max
   * @type Number
   */ function clamp(input = 0, min = 0, max = 255) {
        return Math.min(Math.max(input, min), max);
    }
    // Arg: vttDataString example: "WEBVTT\n\n1\n00:00:05.000 --> 00:00:10.000\n1080p-00001.jpg"
    const parseVtt = (vttDataString)=>{
        const processedList = [];
        const frames = vttDataString.split(/\r\n\r\n|\n\n|\r\r/);
        frames.forEach((frame)=>{
            const result = {};
            const lines = frame.split(/\r\n|\n|\r/);
            lines.forEach((line)=>{
                if (!is.number(result.startTime)) {
                    // The line with start and end times on it is the first line of interest
                    const matchTimes = line.match(/([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})( ?--> ?)([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})/); // Note that this currently ignores caption formatting directives that are optionally on the end of this line - fine for non-captions VTT
                    if (matchTimes) {
                        result.startTime = Number(matchTimes[1] || 0) * 3600 + Number(matchTimes[2]) * 60 + Number(matchTimes[3]) + Number(`0.${matchTimes[4]}`);
                        result.endTime = Number(matchTimes[6] || 0) * 3600 + Number(matchTimes[7]) * 60 + Number(matchTimes[8]) + Number(`0.${matchTimes[9]}`);
                    }
                } else if (!is.empty(line.trim()) && is.empty(result.text)) {
                    // If we already have the startTime, then we're definitely up to the text line(s)
                    const lineSplit = line.trim().split('#xywh=');
                    [result.text] = lineSplit;
                    // If there's content in lineSplit[1], then we have sprites. If not, then it's just one frame per image
                    if (lineSplit[1]) [result.x, result.y, result.w, result.h] = lineSplit[1].split(',');
                }
            });
            if (result.text) processedList.push(result);
        });
        return processedList;
    };
    /**
   * Preview thumbnails for seek hover and scrubbing
   * Seeking: Hover over the seek bar (desktop only): shows a small preview container above the seek bar
   * Scrubbing: Click and drag the seek bar (desktop and mobile): shows the preview image over the entire video, as if the video is scrubbing at very high speed
   *
   * Notes:
   * - Thumbs are set via JS settings on Plyr init, not HTML5 'track' property. Using the track property would be a bit gross, because it doesn't support custom 'kinds'. kind=metadata might be used for something else, and we want to allow multiple thumbnails tracks. Tracks must have a unique combination of 'kind' and 'label'. We would have to do something like kind=metadata,label=thumbnails1 / kind=metadata,label=thumbnails2. Square peg, round hole
   * - VTT info: the image URL is relative to the VTT, not the current document. But if the url starts with a slash, it will naturally be relative to the current domain. https://support.jwplayer.com/articles/how-to-add-preview-thumbnails
   * - This implementation uses multiple separate img elements. Other implementations use background-image on one element. This would be nice and simple, but Firefox and Safari have flickering issues with replacing backgrounds of larger images. It seems that YouTube perhaps only avoids this because they don't have the option for high-res previews (even the fullscreen ones, when mousedown/seeking). Images appear over the top of each other, and previous ones are discarded once the new ones have been rendered
   */ const fitRatio = (ratio, outer)=>{
        const targetRatio = outer.width / outer.height;
        const result = {};
        if (ratio > targetRatio) {
            result.width = outer.width;
            result.height = 1 / ratio * outer.width;
        } else {
            result.height = outer.height;
            result.width = ratio * outer.height;
        }
        return result;
    };
    class PreviewThumbnails {
        /**
     * PreviewThumbnails constructor.
     * @param {Plyr} player
     * @return {PreviewThumbnails}
     */ constructor(player){
            _defineProperty$1(this, "load", ()=>{
                // Toggle the regular seek tooltip
                if (this.player.elements.display.seekTooltip) this.player.elements.display.seekTooltip.hidden = this.enabled;
                if (!this.enabled) return;
                this.getThumbnails().then(()=>{
                    if (!this.enabled) return;
                    // Render DOM elements
                    this.render();
                    // Check to see if thumb container size was specified manually in CSS
                    this.determineContainerAutoSizing();
                    this.loaded = true;
                });
            });
            _defineProperty$1(this, "getThumbnails", ()=>{
                return new Promise((resolve)=>{
                    const { src: src } = this.player.config.previewThumbnails;
                    if (is.empty(src)) throw new Error('Missing previewThumbnails.src config attribute');
                    // Resolve promise
                    const sortAndResolve = ()=>{
                        // Sort smallest to biggest (e.g., [120p, 480p, 1080p])
                        this.thumbnails.sort((x, y)=>x.height - y.height);
                        this.player.debug.log('Preview thumbnails', this.thumbnails);
                        resolve();
                    };
                    // Via callback()
                    if (is.function(src)) src((thumbnails)=>{
                        this.thumbnails = thumbnails;
                        sortAndResolve();
                    });
                    else {
                        // If string, convert into single-element list
                        const urls = is.string(src) ? [
                            src
                        ] : src;
                        // Loop through each src URL. Download and process the VTT file, storing the resulting data in this.thumbnails
                        const promises = urls.map((u)=>this.getThumbnail(u));
                        // Resolve
                        Promise.all(promises).then(sortAndResolve);
                    }
                });
            });
            _defineProperty$1(this, "getThumbnail", (url)=>{
                return new Promise((resolve)=>{
                    fetch(url).then((response)=>{
                        const thumbnail = {
                            frames: parseVtt(response),
                            height: null,
                            urlPrefix: ''
                        };
                        // If the URLs don't start with '/', then we need to set their relative path to be the location of the VTT file
                        // If the URLs do start with '/', then they obviously don't need a prefix, so it will remain blank
                        // If the thumbnail URLs start with with none of '/', 'http://' or 'https://', then we need to set their relative path to be the location of the VTT file
                        if (!thumbnail.frames[0].text.startsWith('/') && !thumbnail.frames[0].text.startsWith('http://') && !thumbnail.frames[0].text.startsWith('https://')) thumbnail.urlPrefix = url.substring(0, url.lastIndexOf('/') + 1);
                        // Download the first frame, so that we can determine/set the height of this thumbnailsDef
                        const tempImage = new Image();
                        tempImage.onload = ()=>{
                            thumbnail.height = tempImage.naturalHeight;
                            thumbnail.width = tempImage.naturalWidth;
                            this.thumbnails.push(thumbnail);
                            resolve();
                        };
                        tempImage.src = thumbnail.urlPrefix + thumbnail.frames[0].text;
                    });
                });
            });
            _defineProperty$1(this, "startMove", (event)=>{
                if (!this.loaded) return;
                if (!is.event(event) || ![
                    'touchmove',
                    'mousemove'
                ].includes(event.type)) return;
                // Wait until media has a duration
                if (!this.player.media.duration) return;
                if (event.type === 'touchmove') // Calculate seek hover position as approx video seconds
                this.seekTime = this.player.media.duration * (this.player.elements.inputs.seek.value / 100);
                else {
                    var _this$player$config$m, _this$player$config$m2;
                    // Calculate seek hover position as approx video seconds
                    const clientRect = this.player.elements.progress.getBoundingClientRect();
                    const percentage = 100 / clientRect.width * (event.pageX - clientRect.left);
                    this.seekTime = this.player.media.duration * (percentage / 100);
                    if (this.seekTime < 0) // The mousemove fires for 10+px out to the left
                    this.seekTime = 0;
                    if (this.seekTime > this.player.media.duration - 1) // Took 1 second off the duration for safety, because different players can disagree on the real duration of a video
                    this.seekTime = this.player.media.duration - 1;
                    this.mousePosX = event.pageX;
                    // Set time text inside image container
                    this.elements.thumb.time.innerText = formatTime(this.seekTime);
                    // Get marker point for time
                    const point = (_this$player$config$m = this.player.config.markers) === null || _this$player$config$m === void 0 ? void 0 : (_this$player$config$m2 = _this$player$config$m.points) === null || _this$player$config$m2 === void 0 ? void 0 : _this$player$config$m2.find(({ time: t })=>t === Math.round(this.seekTime));
                    // Append the point label to the tooltip
                    if (point) // this.elements.thumb.time.innerText.concat('\n');
                    this.elements.thumb.time.insertAdjacentHTML('afterbegin', `${point.label}<br>`);
                }
                // Download and show image
                this.showImageAtCurrentTime();
            });
            _defineProperty$1(this, "endMove", ()=>{
                this.toggleThumbContainer(false, true);
            });
            _defineProperty$1(this, "startScrubbing", (event)=>{
                // Only act on left mouse button (0), or touch device (event.button does not exist or is false)
                if (is.nullOrUndefined(event.button) || event.button === false || event.button === 0) {
                    this.mouseDown = true;
                    // Wait until media has a duration
                    if (this.player.media.duration) {
                        this.toggleScrubbingContainer(true);
                        this.toggleThumbContainer(false, true);
                        // Download and show image
                        this.showImageAtCurrentTime();
                    }
                }
            });
            _defineProperty$1(this, "endScrubbing", ()=>{
                this.mouseDown = false;
                // Hide scrubbing preview. But wait until the video has successfully seeked before hiding the scrubbing preview
                if (Math.ceil(this.lastTime) === Math.ceil(this.player.media.currentTime)) // The video was already seeked/loaded at the chosen time - hide immediately
                this.toggleScrubbingContainer(false);
                else // The video hasn't seeked yet. Wait for that
                once.call(this.player, this.player.media, 'timeupdate', ()=>{
                    // Re-check mousedown - we might have already started scrubbing again
                    if (!this.mouseDown) this.toggleScrubbingContainer(false);
                });
            });
            _defineProperty$1(this, "listeners", ()=>{
                // Hide thumbnail preview - on mouse click, mouse leave (in listeners.js for now), and video play/seek. All four are required, e.g., for buffering
                this.player.on('play', ()=>{
                    this.toggleThumbContainer(false, true);
                });
                this.player.on('seeked', ()=>{
                    this.toggleThumbContainer(false);
                });
                this.player.on('timeupdate', ()=>{
                    this.lastTime = this.player.media.currentTime;
                });
            });
            _defineProperty$1(this, "render", ()=>{
                // Create HTML element: plyr__preview-thumbnail-container
                this.elements.thumb.container = createElement('div', {
                    class: this.player.config.classNames.previewThumbnails.thumbContainer
                });
                // Wrapper for the image for styling
                this.elements.thumb.imageContainer = createElement('div', {
                    class: this.player.config.classNames.previewThumbnails.imageContainer
                });
                this.elements.thumb.container.appendChild(this.elements.thumb.imageContainer);
                // Create HTML element, parent+span: time text (e.g., 01:32:00)
                const timeContainer = createElement('div', {
                    class: this.player.config.classNames.previewThumbnails.timeContainer
                });
                this.elements.thumb.time = createElement('span', {}, '00:00');
                timeContainer.appendChild(this.elements.thumb.time);
                this.elements.thumb.imageContainer.appendChild(timeContainer);
                // Inject the whole thumb
                if (is.element(this.player.elements.progress)) this.player.elements.progress.appendChild(this.elements.thumb.container);
                // Create HTML element: plyr__preview-scrubbing-container
                this.elements.scrubbing.container = createElement('div', {
                    class: this.player.config.classNames.previewThumbnails.scrubbingContainer
                });
                this.player.elements.wrapper.appendChild(this.elements.scrubbing.container);
            });
            _defineProperty$1(this, "destroy", ()=>{
                if (this.elements.thumb.container) this.elements.thumb.container.remove();
                if (this.elements.scrubbing.container) this.elements.scrubbing.container.remove();
            });
            _defineProperty$1(this, "showImageAtCurrentTime", ()=>{
                if (this.mouseDown) this.setScrubbingContainerSize();
                else this.setThumbContainerSizeAndPos();
                // Find the desired thumbnail index
                // TODO: Handle a video longer than the thumbs where thumbNum is null
                const thumbNum = this.thumbnails[0].frames.findIndex((frame)=>this.seekTime >= frame.startTime && this.seekTime <= frame.endTime);
                const hasThumb = thumbNum >= 0;
                let qualityIndex = 0;
                // Show the thumb container if we're not scrubbing
                if (!this.mouseDown) this.toggleThumbContainer(hasThumb);
                // No matching thumb found
                if (!hasThumb) return;
                // Check to see if we've already downloaded higher quality versions of this image
                this.thumbnails.forEach((thumbnail, index)=>{
                    if (this.loadedImages.includes(thumbnail.frames[thumbNum].text)) qualityIndex = index;
                });
                // Only proceed if either thumb num or thumbfilename has changed
                if (thumbNum !== this.showingThumb) {
                    this.showingThumb = thumbNum;
                    this.loadImage(qualityIndex);
                }
            });
            _defineProperty$1(this, "loadImage", (qualityIndex = 0)=>{
                const thumbNum = this.showingThumb;
                const thumbnail = this.thumbnails[qualityIndex];
                const { urlPrefix: urlPrefix } = thumbnail;
                const frame = thumbnail.frames[thumbNum];
                const thumbFilename = thumbnail.frames[thumbNum].text;
                const thumbUrl = urlPrefix + thumbFilename;
                if (!this.currentImageElement || this.currentImageElement.dataset.filename !== thumbFilename) {
                    // If we're already loading a previous image, remove its onload handler - we don't want it to load after this one
                    // Only do this if not using sprites. Without sprites we really want to show as many images as possible, as a best-effort
                    if (this.loadingImage && this.usingSprites) this.loadingImage.onload = null;
                    // We're building and adding a new image. In other implementations of similar functionality (YouTube), background image
                    // is instead used. But this causes issues with larger images in Firefox and Safari - switching between background
                    // images causes a flicker. Putting a new image over the top does not
                    const previewImage = new Image();
                    previewImage.src = thumbUrl;
                    previewImage.dataset.index = thumbNum;
                    previewImage.dataset.filename = thumbFilename;
                    this.showingThumbFilename = thumbFilename;
                    this.player.debug.log(`Loading image: ${thumbUrl}`);
                    // For some reason, passing the named function directly causes it to execute immediately. So I've wrapped it in an anonymous function...
                    previewImage.onload = ()=>this.showImage(previewImage, frame, qualityIndex, thumbNum, thumbFilename, true);
                    this.loadingImage = previewImage;
                    this.removeOldImages(previewImage);
                } else {
                    // Update the existing image
                    this.showImage(this.currentImageElement, frame, qualityIndex, thumbNum, thumbFilename, false);
                    this.currentImageElement.dataset.index = thumbNum;
                    this.removeOldImages(this.currentImageElement);
                }
            });
            _defineProperty$1(this, "showImage", (previewImage, frame, qualityIndex, thumbNum, thumbFilename, newImage = true)=>{
                this.player.debug.log(`Showing thumb: ${thumbFilename}. num: ${thumbNum}. qual: ${qualityIndex}. newimg: ${newImage}`);
                this.setImageSizeAndOffset(previewImage, frame);
                if (newImage) {
                    this.currentImageContainer.appendChild(previewImage);
                    this.currentImageElement = previewImage;
                    if (!this.loadedImages.includes(thumbFilename)) this.loadedImages.push(thumbFilename);
                }
                // Preload images before and after the current one
                // Show higher quality of the same frame
                // Each step here has a short time delay, and only continues if still hovering/seeking the same spot. This is to protect slow connections from overloading
                this.preloadNearby(thumbNum, true).then(this.preloadNearby(thumbNum, false)).then(this.getHigherQuality(qualityIndex, previewImage, frame, thumbFilename));
            });
            _defineProperty$1(this, "removeOldImages", (currentImage)=>{
                // Get a list of all images, convert it from a DOM list to an array
                Array.from(this.currentImageContainer.children).forEach((image)=>{
                    if (image.tagName.toLowerCase() !== 'img') return;
                    const removeDelay = this.usingSprites ? 500 : 1000;
                    if (image.dataset.index !== currentImage.dataset.index && !image.dataset.deleting) {
                        // Wait 200ms, as the new image can take some time to show on certain browsers (even though it was downloaded before showing). This will prevent flicker, and show some generosity towards slower clients
                        // First set attribute 'deleting' to prevent multi-handling of this on repeat firing of this function
                        // eslint-disable-next-line no-param-reassign
                        image.dataset.deleting = true;
                        // This has to be set before the timeout - to prevent issues switching between hover and scrub
                        const { currentImageContainer: currentImageContainer } = this;
                        setTimeout(()=>{
                            currentImageContainer.removeChild(image);
                            this.player.debug.log(`Removing thumb: ${image.dataset.filename}`);
                        }, removeDelay);
                    }
                });
            });
            _defineProperty$1(this, "preloadNearby", (thumbNum, forward = true)=>{
                return new Promise((resolve)=>{
                    setTimeout(()=>{
                        const oldThumbFilename = this.thumbnails[0].frames[thumbNum].text;
                        if (this.showingThumbFilename === oldThumbFilename) {
                            // Find the nearest thumbs with different filenames. Sometimes it'll be the next index, but in the case of sprites, it might be 100+ away
                            let thumbnailsClone;
                            if (forward) thumbnailsClone = this.thumbnails[0].frames.slice(thumbNum);
                            else thumbnailsClone = this.thumbnails[0].frames.slice(0, thumbNum).reverse();
                            let foundOne = false;
                            thumbnailsClone.forEach((frame)=>{
                                const newThumbFilename = frame.text;
                                if (newThumbFilename !== oldThumbFilename) // Found one with a different filename. Make sure it hasn't already been loaded on this page visit
                                {
                                    if (!this.loadedImages.includes(newThumbFilename)) {
                                        foundOne = true;
                                        this.player.debug.log(`Preloading thumb filename: ${newThumbFilename}`);
                                        const { urlPrefix: urlPrefix } = this.thumbnails[0];
                                        const thumbURL = urlPrefix + newThumbFilename;
                                        const previewImage = new Image();
                                        previewImage.src = thumbURL;
                                        previewImage.onload = ()=>{
                                            this.player.debug.log(`Preloaded thumb filename: ${newThumbFilename}`);
                                            if (!this.loadedImages.includes(newThumbFilename)) this.loadedImages.push(newThumbFilename);
                                            // We don't resolve until the thumb is loaded
                                            resolve();
                                        };
                                    }
                                }
                            });
                            // If there are none to preload then we want to resolve immediately
                            if (!foundOne) resolve();
                        }
                    }, 300);
                });
            });
            _defineProperty$1(this, "getHigherQuality", (currentQualityIndex, previewImage, frame, thumbFilename)=>{
                if (currentQualityIndex < this.thumbnails.length - 1) {
                    // Only use the higher quality version if it's going to look any better - if the current thumb is of a lower pixel density than the thumbnail container
                    let previewImageHeight = previewImage.naturalHeight;
                    if (this.usingSprites) previewImageHeight = frame.h;
                    if (previewImageHeight < this.thumbContainerHeight) // Recurse back to the loadImage function - show a higher quality one, but only if the viewer is on this frame for a while
                    setTimeout(()=>{
                        // Make sure the mouse hasn't already moved on and started hovering at another image
                        if (this.showingThumbFilename === thumbFilename) {
                            this.player.debug.log(`Showing higher quality thumb for: ${thumbFilename}`);
                            this.loadImage(currentQualityIndex + 1);
                        }
                    }, 300);
                }
            });
            _defineProperty$1(this, "toggleThumbContainer", (toggle = false, clearShowing = false)=>{
                const className = this.player.config.classNames.previewThumbnails.thumbContainerShown;
                this.elements.thumb.container.classList.toggle(className, toggle);
                if (!toggle && clearShowing) {
                    this.showingThumb = null;
                    this.showingThumbFilename = null;
                }
            });
            _defineProperty$1(this, "toggleScrubbingContainer", (toggle = false)=>{
                const className = this.player.config.classNames.previewThumbnails.scrubbingContainerShown;
                this.elements.scrubbing.container.classList.toggle(className, toggle);
                if (!toggle) {
                    this.showingThumb = null;
                    this.showingThumbFilename = null;
                }
            });
            _defineProperty$1(this, "determineContainerAutoSizing", ()=>{
                if (this.elements.thumb.imageContainer.clientHeight > 20 || this.elements.thumb.imageContainer.clientWidth > 20) // This will prevent auto sizing in this.setThumbContainerSizeAndPos()
                this.sizeSpecifiedInCSS = true;
            });
            _defineProperty$1(this, "setThumbContainerSizeAndPos", ()=>{
                const { imageContainer: imageContainer } = this.elements.thumb;
                if (!this.sizeSpecifiedInCSS) {
                    const thumbWidth = Math.floor(this.thumbContainerHeight * this.thumbAspectRatio);
                    imageContainer.style.height = `${this.thumbContainerHeight}px`;
                    imageContainer.style.width = `${thumbWidth}px`;
                } else if (imageContainer.clientHeight > 20 && imageContainer.clientWidth < 20) {
                    const thumbWidth = Math.floor(imageContainer.clientHeight * this.thumbAspectRatio);
                    imageContainer.style.width = `${thumbWidth}px`;
                } else if (imageContainer.clientHeight < 20 && imageContainer.clientWidth > 20) {
                    const thumbHeight = Math.floor(imageContainer.clientWidth / this.thumbAspectRatio);
                    imageContainer.style.height = `${thumbHeight}px`;
                }
                this.setThumbContainerPos();
            });
            _defineProperty$1(this, "setThumbContainerPos", ()=>{
                const scrubberRect = this.player.elements.progress.getBoundingClientRect();
                const containerRect = this.player.elements.container.getBoundingClientRect();
                const { container: container } = this.elements.thumb;
                // Find the lowest and highest desired left-position, so we don't slide out the side of the video container
                const min = containerRect.left - scrubberRect.left + 10;
                const max = containerRect.right - scrubberRect.left - container.clientWidth - 10;
                // Set preview container position to: mousepos, minus seekbar.left, minus half of previewContainer.clientWidth
                const position = this.mousePosX - scrubberRect.left - container.clientWidth / 2;
                const clamped = clamp(position, min, max);
                // Move the popover position
                container.style.left = `${clamped}px`;
                // The arrow can follow the cursor
                container.style.setProperty('--preview-arrow-offset', `${position - clamped}px`);
            });
            _defineProperty$1(this, "setScrubbingContainerSize", ()=>{
                const { width: width, height: height } = fitRatio(this.thumbAspectRatio, {
                    width: this.player.media.clientWidth,
                    height: this.player.media.clientHeight
                });
                this.elements.scrubbing.container.style.width = `${width}px`;
                this.elements.scrubbing.container.style.height = `${height}px`;
            });
            _defineProperty$1(this, "setImageSizeAndOffset", (previewImage, frame)=>{
                if (!this.usingSprites) return;
                // Find difference between height and preview container height
                const multiplier = this.thumbContainerHeight / frame.h;
                // eslint-disable-next-line no-param-reassign
                previewImage.style.height = `${previewImage.naturalHeight * multiplier}px`;
                // eslint-disable-next-line no-param-reassign
                previewImage.style.width = `${previewImage.naturalWidth * multiplier}px`;
                // eslint-disable-next-line no-param-reassign
                previewImage.style.left = `-${frame.x * multiplier}px`;
                // eslint-disable-next-line no-param-reassign
                previewImage.style.top = `-${frame.y * multiplier}px`;
            });
            this.player = player;
            this.thumbnails = [];
            this.loaded = false;
            this.lastMouseMoveTime = Date.now();
            this.mouseDown = false;
            this.loadedImages = [];
            this.elements = {
                thumb: {},
                scrubbing: {}
            };
            this.load();
        }
        get enabled() {
            return this.player.isHTML5 && this.player.isVideo && this.player.config.previewThumbnails.enabled;
        }
        get currentImageContainer() {
            return this.mouseDown ? this.elements.scrubbing.container : this.elements.thumb.imageContainer;
        }
        get usingSprites() {
            return Object.keys(this.thumbnails[0].frames[0]).includes('w');
        }
        get thumbAspectRatio() {
            if (this.usingSprites) return this.thumbnails[0].frames[0].w / this.thumbnails[0].frames[0].h;
            return this.thumbnails[0].width / this.thumbnails[0].height;
        }
        get thumbContainerHeight() {
            if (this.mouseDown) {
                const { height: height } = fitRatio(this.thumbAspectRatio, {
                    width: this.player.media.clientWidth,
                    height: this.player.media.clientHeight
                });
                return height;
            }
            // If css is used this needs to return the css height for sprites to work (see setImageSizeAndOffset)
            if (this.sizeSpecifiedInCSS) return this.elements.thumb.imageContainer.clientHeight;
            return Math.floor(this.player.media.clientWidth / this.thumbAspectRatio / 4);
        }
        get currentImageElement() {
            return this.mouseDown ? this.currentScrubbingImageElement : this.currentThumbnailImageElement;
        }
        set currentImageElement(element) {
            if (this.mouseDown) this.currentScrubbingImageElement = element;
            else this.currentThumbnailImageElement = element;
        }
    }
    // ==========================================================================
    const source = {
        // Add elements to HTML5 media (source, tracks, etc)
        insertElements (type, attributes) {
            if (is.string(attributes)) insertElement(type, this.media, {
                src: attributes
            });
            else if (is.array(attributes)) attributes.forEach((attribute)=>{
                insertElement(type, this.media, attribute);
            });
        },
        // Update source
        // Sources are not checked for support so be careful
        change (input) {
            if (!getDeep(input, 'sources.length')) {
                this.debug.warn('Invalid source format');
                return;
            }
            // Cancel current network requests
            html5.cancelRequests.call(this);
            // Destroy instance and re-setup
            this.destroy.call(this, ()=>{
                // Reset quality options
                this.options.quality = [];
                // Remove elements
                removeElement(this.media);
                this.media = null;
                // Reset class name
                if (is.element(this.elements.container)) this.elements.container.removeAttribute('class');
                // Set the type and provider
                const { sources: sources, type: type } = input;
                const [{ provider: provider = providers.html5, src: src }] = sources;
                const tagName = provider === 'html5' ? type : 'div';
                const attributes = provider === 'html5' ? {} : {
                    src: src
                };
                Object.assign(this, {
                    provider: provider,
                    type: type,
                    // Check for support
                    supported: support.check(type, provider, this.config.playsinline),
                    // Create new element
                    media: createElement(tagName, attributes)
                });
                // Inject the new element
                this.elements.container.appendChild(this.media);
                // Autoplay the new source?
                if (is.boolean(input.autoplay)) this.config.autoplay = input.autoplay;
                // Set attributes for audio and video
                if (this.isHTML5) {
                    if (this.config.crossorigin) this.media.setAttribute('crossorigin', '');
                    if (this.config.autoplay) this.media.setAttribute('autoplay', '');
                    if (!is.empty(input.poster)) this.poster = input.poster;
                    if (this.config.loop.active) this.media.setAttribute('loop', '');
                    if (this.config.muted) this.media.setAttribute('muted', '');
                    if (this.config.playsinline) this.media.setAttribute('playsinline', '');
                }
                // Restore class hook
                ui.addStyleHook.call(this);
                // Set new sources for html5
                if (this.isHTML5) source.insertElements.call(this, 'source', sources);
                // Set video title
                this.config.title = input.title;
                // Set up from scratch
                media.setup.call(this);
                // HTML5 stuff
                if (this.isHTML5) // Setup captions
                {
                    if (Object.keys(input).includes('tracks')) source.insertElements.call(this, 'track', input.tracks);
                }
                // If HTML5 or embed but not fully supported, setupInterface and call ready now
                if (this.isHTML5 || this.isEmbed && !this.supported.ui) // Setup interface
                ui.build.call(this);
                // Load HTML5 sources
                if (this.isHTML5) this.media.load();
                // Update previewThumbnails config & reload plugin
                if (!is.empty(input.previewThumbnails)) {
                    Object.assign(this.config.previewThumbnails, input.previewThumbnails);
                    // Cleanup previewThumbnails plugin if it was loaded
                    if (this.previewThumbnails && this.previewThumbnails.loaded) {
                        this.previewThumbnails.destroy();
                        this.previewThumbnails = null;
                    }
                    // Create new instance if it is still enabled
                    if (this.config.previewThumbnails.enabled) this.previewThumbnails = new PreviewThumbnails(this);
                }
                // Update the fullscreen support
                this.fullscreen.update();
            }, true);
        }
    };
    // Private properties
    // TODO: Use a WeakMap for private globals
    // const globals = new WeakMap();
    // Plyr instance
    class Plyr {
        constructor(target, options){
            _defineProperty$1(this, "play", ()=>{
                if (!is.function(this.media.play)) return null;
                // Intecept play with ads
                if (this.ads && this.ads.enabled) this.ads.managerPromise.then(()=>this.ads.play()).catch(()=>silencePromise(this.media.play()));
                // Return the promise (for HTML5)
                return this.media.play();
            });
            _defineProperty$1(this, "pause", ()=>{
                if (!this.playing || !is.function(this.media.pause)) return null;
                return this.media.pause();
            });
            _defineProperty$1(this, "togglePlay", (input)=>{
                // Toggle based on current state if nothing passed
                const toggle = is.boolean(input) ? input : !this.playing;
                if (toggle) return this.play();
                return this.pause();
            });
            _defineProperty$1(this, "stop", ()=>{
                if (this.isHTML5) {
                    this.pause();
                    this.restart();
                } else if (is.function(this.media.stop)) this.media.stop();
            });
            _defineProperty$1(this, "restart", ()=>{
                this.currentTime = 0;
            });
            _defineProperty$1(this, "rewind", (seekTime)=>{
                this.currentTime -= is.number(seekTime) ? seekTime : this.config.seekTime;
            });
            _defineProperty$1(this, "forward", (seekTime)=>{
                this.currentTime += is.number(seekTime) ? seekTime : this.config.seekTime;
            });
            _defineProperty$1(this, "increaseVolume", (step)=>{
                const volume = this.media.muted ? 0 : this.volume;
                this.volume = volume + (is.number(step) ? step : 0);
            });
            _defineProperty$1(this, "decreaseVolume", (step)=>{
                this.increaseVolume(-step);
            });
            _defineProperty$1(this, "airplay", ()=>{
                // Show dialog if supported
                if (support.airplay) this.media.webkitShowPlaybackTargetPicker();
            });
            _defineProperty$1(this, "toggleControls", (toggle)=>{
                // Don't toggle if missing UI support or if it's audio
                if (this.supported.ui && !this.isAudio) {
                    // Get state before change
                    const isHidden = hasClass(this.elements.container, this.config.classNames.hideControls);
                    // Negate the argument if not undefined since adding the class to hides the controls
                    const force = typeof toggle === 'undefined' ? undefined : !toggle;
                    // Apply and get updated state
                    const hiding = toggleClass(this.elements.container, this.config.classNames.hideControls, force);
                    // Close menu
                    if (hiding && is.array(this.config.controls) && this.config.controls.includes('settings') && !is.empty(this.config.settings)) controls.toggleMenu.call(this, false);
                    // Trigger event on change
                    if (hiding !== isHidden) {
                        const eventName = hiding ? 'controlshidden' : 'controlsshown';
                        triggerEvent.call(this, this.media, eventName);
                    }
                    return !hiding;
                }
                return false;
            });
            _defineProperty$1(this, "on", (event, callback)=>{
                on.call(this, this.elements.container, event, callback);
            });
            _defineProperty$1(this, "once", (event, callback)=>{
                once.call(this, this.elements.container, event, callback);
            });
            _defineProperty$1(this, "off", (event, callback)=>{
                off(this.elements.container, event, callback);
            });
            _defineProperty$1(this, "destroy", (callback, soft = false)=>{
                if (!this.ready) return;
                const done = ()=>{
                    // Reset overflow (incase destroyed while in fullscreen)
                    document.body.style.overflow = '';
                    // GC for embed
                    this.embed = null;
                    // If it's a soft destroy, make minimal changes
                    if (soft) {
                        if (Object.keys(this.elements).length) {
                            // Remove elements
                            removeElement(this.elements.buttons.play);
                            removeElement(this.elements.captions);
                            removeElement(this.elements.controls);
                            removeElement(this.elements.wrapper);
                            // Clear for GC
                            this.elements.buttons.play = null;
                            this.elements.captions = null;
                            this.elements.controls = null;
                            this.elements.wrapper = null;
                        }
                        // Callback
                        if (is.function(callback)) callback();
                    } else {
                        // Unbind listeners
                        unbindListeners.call(this);
                        // Cancel current network requests
                        html5.cancelRequests.call(this);
                        // Replace the container with the original element provided
                        replaceElement(this.elements.original, this.elements.container);
                        // Event
                        triggerEvent.call(this, this.elements.original, 'destroyed', true);
                        // Callback
                        if (is.function(callback)) callback.call(this.elements.original);
                        // Reset state
                        this.ready = false;
                        // Clear for garbage collection
                        setTimeout(()=>{
                            this.elements = null;
                            this.media = null;
                        }, 200);
                    }
                };
                // Stop playback
                this.stop();
                // Clear timeouts
                clearTimeout(this.timers.loading);
                clearTimeout(this.timers.controls);
                clearTimeout(this.timers.resized);
                // Provider specific stuff
                if (this.isHTML5) {
                    // Restore native video controls
                    ui.toggleNativeControls.call(this, true);
                    // Clean up
                    done();
                } else if (this.isYouTube) {
                    // Clear timers
                    clearInterval(this.timers.buffering);
                    clearInterval(this.timers.playing);
                    // Destroy YouTube API
                    if (this.embed !== null && is.function(this.embed.destroy)) this.embed.destroy();
                    // Clean up
                    done();
                } else if (this.isVimeo) {
                    // Destroy Vimeo API
                    // then clean up (wait, to prevent postmessage errors)
                    if (this.embed !== null) this.embed.unload().then(done);
                    // Vimeo does not always return
                    setTimeout(done, 200);
                }
            });
            _defineProperty$1(this, "supports", (type)=>support.mime.call(this, type));
            this.timers = {};
            // State
            this.ready = false;
            this.loading = false;
            this.failed = false;
            // Touch device
            this.touch = support.touch;
            // Set the media element
            this.media = target;
            // String selector passed
            if (is.string(this.media)) this.media = document.querySelectorAll(this.media);
            // jQuery, NodeList or Array passed, use first element
            if (window.jQuery && this.media instanceof jQuery || is.nodeList(this.media) || is.array(this.media)) // eslint-disable-next-line
            this.media = this.media[0];
            // Set config
            this.config = extend({}, defaults, Plyr.defaults, options || {}, (()=>{
                try {
                    return JSON.parse(this.media.getAttribute('data-plyr-config'));
                } catch (_) {
                    return {};
                }
            })());
            // Elements cache
            this.elements = {
                container: null,
                fullscreen: null,
                captions: null,
                buttons: {},
                display: {},
                progress: {},
                inputs: {},
                settings: {
                    popup: null,
                    menu: null,
                    panels: {},
                    buttons: {}
                }
            };
            // Captions
            this.captions = {
                active: null,
                currentTrack: -1,
                meta: new WeakMap()
            };
            // Fullscreen
            this.fullscreen = {
                active: false
            };
            // Options
            this.options = {
                speed: [],
                quality: []
            };
            // Debugging
            // TODO: move to globals
            this.debug = new Console(this.config.debug);
            // Log config options and support
            this.debug.log('Config', this.config);
            this.debug.log('Support', support);
            // We need an element to setup
            if (is.nullOrUndefined(this.media) || !is.element(this.media)) {
                this.debug.error('Setup failed: no suitable element passed');
                return;
            }
            // Bail if the element is initialized
            if (this.media.plyr) {
                this.debug.warn('Target already setup');
                return;
            }
            // Bail if not enabled
            if (!this.config.enabled) {
                this.debug.error('Setup failed: disabled by config');
                return;
            }
            // Bail if disabled or no basic support
            // You may want to disable certain UAs etc
            if (!support.check().api) {
                this.debug.error('Setup failed: no support');
                return;
            }
            // Cache original element state for .destroy()
            const clone = this.media.cloneNode(true);
            clone.autoplay = false;
            this.elements.original = clone;
            // Set media type based on tag or data attribute
            // Supported: video, audio, vimeo, youtube
            const _type = this.media.tagName.toLowerCase();
            // Embed properties
            let iframe = null;
            let url = null;
            // Different setup based on type
            switch(_type){
                case 'div':
                    // Find the frame
                    iframe = this.media.querySelector('iframe');
                    // <iframe> type
                    if (is.element(iframe)) {
                        // Detect provider
                        url = parseUrl(iframe.getAttribute('src'));
                        this.provider = getProviderByUrl(url.toString());
                        // Rework elements
                        this.elements.container = this.media;
                        this.media = iframe;
                        // Reset classname
                        this.elements.container.className = '';
                        // Get attributes from URL and set config
                        if (url.search.length) {
                            const truthy = [
                                '1',
                                'true'
                            ];
                            if (truthy.includes(url.searchParams.get('autoplay'))) this.config.autoplay = true;
                            if (truthy.includes(url.searchParams.get('loop'))) this.config.loop.active = true;
                            // TODO: replace fullscreen.iosNative with this playsinline config option
                            // YouTube requires the playsinline in the URL
                            if (this.isYouTube) {
                                this.config.playsinline = truthy.includes(url.searchParams.get('playsinline'));
                                this.config.youtube.hl = url.searchParams.get('hl'); // TODO: Should this be setting language?
                            } else this.config.playsinline = true;
                        }
                    } else {
                        // <div> with attributes
                        this.provider = this.media.getAttribute(this.config.attributes.embed.provider);
                        // Remove attribute
                        this.media.removeAttribute(this.config.attributes.embed.provider);
                    }
                    // Unsupported or missing provider
                    if (is.empty(this.provider) || !Object.values(providers).includes(this.provider)) {
                        this.debug.error('Setup failed: Invalid provider');
                        return;
                    }
                    // Audio will come later for external providers
                    this.type = types.video;
                    break;
                case 'video':
                case 'audio':
                    this.type = _type;
                    this.provider = providers.html5;
                    // Get config from attributes
                    if (this.media.hasAttribute('crossorigin')) this.config.crossorigin = true;
                    if (this.media.hasAttribute('autoplay')) this.config.autoplay = true;
                    if (this.media.hasAttribute('playsinline') || this.media.hasAttribute('webkit-playsinline')) this.config.playsinline = true;
                    if (this.media.hasAttribute('muted')) this.config.muted = true;
                    if (this.media.hasAttribute('loop')) this.config.loop.active = true;
                    break;
                default:
                    this.debug.error('Setup failed: unsupported type');
                    return;
            }
            // Check for support again but with type
            this.supported = support.check(this.type, this.provider, this.config.playsinline);
            // If no support for even API, bail
            if (!this.supported.api) {
                this.debug.error('Setup failed: no support');
                return;
            }
            this.eventListeners = [];
            // Create listeners
            this.listeners = new Listeners(this);
            // Setup local storage for user settings
            this.storage = new Storage(this);
            // Store reference
            this.media.plyr = this;
            // Wrap media
            if (!is.element(this.elements.container)) {
                this.elements.container = createElement('div', {
                    tabindex: 0
                });
                wrap(this.media, this.elements.container);
            }
            // Migrate custom properties from media to container (so they work 😉)
            ui.migrateStyles.call(this);
            // Add style hook
            ui.addStyleHook.call(this);
            // Setup media
            media.setup.call(this);
            // Listen for events if debugging
            if (this.config.debug) on.call(this, this.elements.container, this.config.events.join(' '), (event)=>{
                this.debug.log(`event: ${event.type}`);
            });
            // Setup fullscreen
            this.fullscreen = new Fullscreen(this);
            // Setup interface
            // If embed but not fully supported, build interface now to avoid flash of controls
            if (this.isHTML5 || this.isEmbed && !this.supported.ui) ui.build.call(this);
            // Container listeners
            this.listeners.container();
            // Global listeners
            this.listeners.global();
            // Setup ads if provided
            if (this.config.ads.enabled) this.ads = new Ads(this);
            // Autoplay if required
            if (this.isHTML5 && this.config.autoplay) this.once('canplay', ()=>silencePromise(this.play()));
            // Seek time will be recorded (in listeners.js) so we can prevent hiding controls for a few seconds after seek
            this.lastSeekTime = 0;
            // Setup preview thumbnails if enabled
            if (this.config.previewThumbnails.enabled) this.previewThumbnails = new PreviewThumbnails(this);
        }
        // ---------------------------------------
        // API
        // ---------------------------------------
        /**
     * Types and provider helpers
     */ get isHTML5() {
            return this.provider === providers.html5;
        }
        get isEmbed() {
            return this.isYouTube || this.isVimeo;
        }
        get isYouTube() {
            return this.provider === providers.youtube;
        }
        get isVimeo() {
            return this.provider === providers.vimeo;
        }
        get isVideo() {
            return this.type === types.video;
        }
        get isAudio() {
            return this.type === types.audio;
        }
        /**
     * Play the media, or play the advertisement (if they are not blocked)
     */ /**
     * Get playing state
     */ get playing() {
            return Boolean(this.ready && !this.paused && !this.ended);
        }
        /**
     * Get paused state
     */ get paused() {
            return Boolean(this.media.paused);
        }
        /**
     * Get stopped state
     */ get stopped() {
            return Boolean(this.paused && this.currentTime === 0);
        }
        /**
     * Get ended state
     */ get ended() {
            return Boolean(this.media.ended);
        }
        /**
     * Toggle playback based on current status
     * @param {Boolean} input
     */ /**
     * Seek to a time
     * @param {Number} input - where to seek to in seconds. Defaults to 0 (the start)
     */ set currentTime(input) {
            // Bail if media duration isn't available yet
            if (!this.duration) return;
            // Validate input
            const inputIsValid = is.number(input) && input > 0;
            // Set
            this.media.currentTime = inputIsValid ? Math.min(input, this.duration) : 0;
            // Logging
            this.debug.log(`Seeking to ${this.currentTime} seconds`);
        }
        /**
     * Get current time
     */ get currentTime() {
            return Number(this.media.currentTime);
        }
        /**
     * Get buffered
     */ get buffered() {
            const { buffered: buffered } = this.media;
            // YouTube / Vimeo return a float between 0-1
            if (is.number(buffered)) return buffered;
            // HTML5
            // TODO: Handle buffered chunks of the media
            // (i.e. seek to another section buffers only that section)
            if (buffered && buffered.length && this.duration > 0) return buffered.end(0) / this.duration;
            return 0;
        }
        /**
     * Get seeking status
     */ get seeking() {
            return Boolean(this.media.seeking);
        }
        /**
     * Get the duration of the current media
     */ get duration() {
            // Faux duration set via config
            const fauxDuration = parseFloat(this.config.duration);
            // Media duration can be NaN or Infinity before the media has loaded
            const realDuration = (this.media || {}).duration;
            const duration = !is.number(realDuration) || realDuration === Infinity ? 0 : realDuration;
            // If config duration is funky, use regular duration
            return fauxDuration || duration;
        }
        /**
     * Set the player volume
     * @param {Number} value - must be between 0 and 1. Defaults to the value from local storage and config.volume if not set in storage
     */ set volume(value) {
            let volume = value;
            const max = 1;
            const min = 0;
            if (is.string(volume)) volume = Number(volume);
            // Load volume from storage if no value specified
            if (!is.number(volume)) volume = this.storage.get('volume');
            // Use config if all else fails
            if (!is.number(volume)) ({ volume: volume } = this.config);
            // Maximum is volumeMax
            if (volume > max) volume = max;
            // Minimum is volumeMin
            if (volume < min) volume = min;
            // Update config
            this.config.volume = volume;
            // Set the player volume
            this.media.volume = volume;
            // If muted, and we're increasing volume manually, reset muted state
            if (!is.empty(value) && this.muted && volume > 0) this.muted = false;
        }
        /**
     * Get the current player volume
     */ get volume() {
            return Number(this.media.volume);
        }
        /**
     * Increase volume
     * @param {Boolean} step - How much to decrease by (between 0 and 1)
     */ /**
     * Set muted state
     * @param {Boolean} mute
     */ set muted(mute) {
            let toggle = mute;
            // Load muted state from storage
            if (!is.boolean(toggle)) toggle = this.storage.get('muted');
            // Use config if all else fails
            if (!is.boolean(toggle)) toggle = this.config.muted;
            // Update config
            this.config.muted = toggle;
            // Set mute on the player
            this.media.muted = toggle;
        }
        /**
     * Get current muted state
     */ get muted() {
            return Boolean(this.media.muted);
        }
        /**
     * Check if the media has audio
     */ get hasAudio() {
            // Assume yes for all non HTML5 (as we can't tell...)
            if (!this.isHTML5) return true;
            if (this.isAudio) return true;
            // Get audio tracks
            return Boolean(this.media.mozHasAudio) || Boolean(this.media.webkitAudioDecodedByteCount) || Boolean(this.media.audioTracks && this.media.audioTracks.length);
        }
        /**
     * Set playback speed
     * @param {Number} input - the speed of playback (0.5-2.0)
     */ set speed(input) {
            let speed = null;
            if (is.number(input)) speed = input;
            if (!is.number(speed)) speed = this.storage.get('speed');
            if (!is.number(speed)) speed = this.config.speed.selected;
            // Clamp to min/max
            const { minimumSpeed: min, maximumSpeed: max } = this;
            speed = clamp(speed, min, max);
            // Update config
            this.config.speed.selected = speed;
            // Set media speed
            setTimeout(()=>{
                if (this.media) this.media.playbackRate = speed;
            }, 0);
        }
        /**
     * Get current playback speed
     */ get speed() {
            return Number(this.media.playbackRate);
        }
        /**
     * Get the minimum allowed speed
     */ get minimumSpeed() {
            if (this.isYouTube) // https://developers.google.com/youtube/iframe_api_reference#setPlaybackRate
            return Math.min(...this.options.speed);
            if (this.isVimeo) // https://github.com/vimeo/player.js/#setplaybackrateplaybackrate-number-promisenumber-rangeerrorerror
            return 0.5;
            // https://stackoverflow.com/a/32320020/1191319
            return 0.0625;
        }
        /**
     * Get the maximum allowed speed
     */ get maximumSpeed() {
            if (this.isYouTube) // https://developers.google.com/youtube/iframe_api_reference#setPlaybackRate
            return Math.max(...this.options.speed);
            if (this.isVimeo) // https://github.com/vimeo/player.js/#setplaybackrateplaybackrate-number-promisenumber-rangeerrorerror
            return 2;
            // https://stackoverflow.com/a/32320020/1191319
            return 16;
        }
        /**
     * Set playback quality
     * Currently HTML5 & YouTube only
     * @param {Number} input - Quality level
     */ set quality(input) {
            const config = this.config.quality;
            const options = this.options.quality;
            if (!options.length) return;
            let quality = [
                !is.empty(input) && Number(input),
                this.storage.get('quality'),
                config.selected,
                config.default
            ].find(is.number);
            let updateStorage = true;
            if (!options.includes(quality)) {
                const value = closest(options, quality);
                this.debug.warn(`Unsupported quality option: ${quality}, using ${value} instead`);
                quality = value;
                // Don't update storage if quality is not supported
                updateStorage = false;
            }
            // Update config
            config.selected = quality;
            // Set quality
            this.media.quality = quality;
            // Save to storage
            if (updateStorage) this.storage.set({
                quality: quality
            });
        }
        /**
     * Get current quality level
     */ get quality() {
            return this.media.quality;
        }
        /**
     * Toggle loop
     * TODO: Finish fancy new logic. Set the indicator on load as user may pass loop as config
     * @param {Boolean} input - Whether to loop or not
     */ set loop(input) {
            const toggle = is.boolean(input) ? input : this.config.loop.active;
            this.config.loop.active = toggle;
            this.media.loop = toggle;
        // Set default to be a true toggle
        /* const type = ['start', 'end', 'all', 'none', 'toggle'].includes(input) ? input : 'toggle';
           switch (type) {
              case 'start':
                  if (this.config.loop.end && this.config.loop.end <= this.currentTime) {
                      this.config.loop.end = null;
                  }
                  this.config.loop.start = this.currentTime;
                  // this.config.loop.indicator.start = this.elements.display.played.value;
                  break;
               case 'end':
                  if (this.config.loop.start >= this.currentTime) {
                      return this;
                  }
                  this.config.loop.end = this.currentTime;
                  // this.config.loop.indicator.end = this.elements.display.played.value;
                  break;
               case 'all':
                  this.config.loop.start = 0;
                  this.config.loop.end = this.duration - 2;
                  this.config.loop.indicator.start = 0;
                  this.config.loop.indicator.end = 100;
                  break;
               case 'toggle':
                  if (this.config.loop.active) {
                      this.config.loop.start = 0;
                      this.config.loop.end = null;
                  } else {
                      this.config.loop.start = 0;
                      this.config.loop.end = this.duration - 2;
                  }
                  break;
               default:
                  this.config.loop.start = 0;
                  this.config.loop.end = null;
                  break;
          } */ }
        /**
     * Get current loop state
     */ get loop() {
            return Boolean(this.media.loop);
        }
        /**
     * Set new media source
     * @param {Object} input - The new source object (see docs)
     */ set source(input) {
            source.change.call(this, input);
        }
        /**
     * Get current source
     */ get source() {
            return this.media.currentSrc;
        }
        /**
     * Get a download URL (either source or custom)
     */ get download() {
            const { download: download } = this.config.urls;
            return is.url(download) ? download : this.source;
        }
        /**
     * Set the download URL
     */ set download(input) {
            if (!is.url(input)) return;
            this.config.urls.download = input;
            controls.setDownloadUrl.call(this);
        }
        /**
     * Set the poster image for a video
     * @param {String} input - the URL for the new poster image
     */ set poster(input) {
            if (!this.isVideo) {
                this.debug.warn('Poster can only be set for video');
                return;
            }
            ui.setPoster.call(this, input, false).catch(()=>{});
        }
        /**
     * Get the current poster image
     */ get poster() {
            if (!this.isVideo) return null;
            return this.media.getAttribute('poster') || this.media.getAttribute('data-poster');
        }
        /**
     * Get the current aspect ratio in use
     */ get ratio() {
            if (!this.isVideo) return null;
            const ratio = reduceAspectRatio(getAspectRatio.call(this));
            return is.array(ratio) ? ratio.join(':') : ratio;
        }
        /**
     * Set video aspect ratio
     */ set ratio(input) {
            if (!this.isVideo) {
                this.debug.warn('Aspect ratio can only be set for video');
                return;
            }
            if (!is.string(input) || !validateAspectRatio(input)) {
                this.debug.error(`Invalid aspect ratio specified (${input})`);
                return;
            }
            this.config.ratio = reduceAspectRatio(input);
            setAspectRatio.call(this);
        }
        /**
     * Set the autoplay state
     * @param {Boolean} input - Whether to autoplay or not
     */ set autoplay(input) {
            this.config.autoplay = is.boolean(input) ? input : this.config.autoplay;
        }
        /**
     * Get the current autoplay state
     */ get autoplay() {
            return Boolean(this.config.autoplay);
        }
        /**
     * Toggle captions
     * @param {Boolean} input - Whether to enable captions
     */ toggleCaptions(input) {
            captions.toggle.call(this, input, false);
        }
        /**
     * Set the caption track by index
     * @param {Number} input - Caption index
     */ set currentTrack(input) {
            captions.set.call(this, input, false);
            captions.setup.call(this);
        }
        /**
     * Get the current caption track index (-1 if disabled)
     */ get currentTrack() {
            const { toggled: toggled, currentTrack: currentTrack } = this.captions;
            return toggled ? currentTrack : -1;
        }
        /**
     * Set the wanted language for captions
     * Since tracks can be added later it won't update the actual caption track until there is a matching track
     * @param {String} input - Two character ISO language code (e.g. EN, FR, PT, etc)
     */ set language(input) {
            captions.setLanguage.call(this, input, false);
        }
        /**
     * Get the current track's language
     */ get language() {
            return (captions.getCurrentTrack.call(this) || {}).language;
        }
        /**
     * Toggle picture-in-picture playback on WebKit/MacOS
     * TODO: update player with state, support, enabled
     * TODO: detect outside changes
     */ set pip(input) {
            // Bail if no support
            if (!support.pip) return;
            // Toggle based on current state if not passed
            const toggle = is.boolean(input) ? input : !this.pip;
            // Toggle based on current state
            // Safari
            if (is.function(this.media.webkitSetPresentationMode)) this.media.webkitSetPresentationMode(toggle ? pip.active : pip.inactive);
            // Chrome
            if (is.function(this.media.requestPictureInPicture)) {
                if (!this.pip && toggle) this.media.requestPictureInPicture();
                else if (this.pip && !toggle) document.exitPictureInPicture();
            }
        }
        /**
     * Get the current picture-in-picture state
     */ get pip() {
            if (!support.pip) return null;
            // Safari
            if (!is.empty(this.media.webkitPresentationMode)) return this.media.webkitPresentationMode === pip.active;
            // Chrome
            return this.media === document.pictureInPictureElement;
        }
        /**
     * Sets the preview thubmnails for the current source
     */ setPreviewThumbnails(thumbnailSource) {
            if (this.previewThumbnails && this.previewThumbnails.loaded) {
                this.previewThumbnails.destroy();
                this.previewThumbnails = null;
            }
            Object.assign(this.config.previewThumbnails, thumbnailSource);
            // Create new instance if it is still enabled
            if (this.config.previewThumbnails.enabled) this.previewThumbnails = new PreviewThumbnails(this);
        }
        /**
     * Trigger the airplay dialog
     * TODO: update player with state, support, enabled
     */ /**
     * Check for support
     * @param {String} type - Player type (audio/video)
     * @param {String} provider - Provider (html5/youtube/vimeo)
     * @param {Boolean} inline - Where player has `playsinline` sttribute
     */ static supported(type, provider, inline) {
            return support.check(type, provider, inline);
        }
        /**
     * Load an SVG sprite into the page
     * @param {String} url - URL for the SVG sprite
     * @param {String} [id] - Unique ID
     */ static loadSprite(url, id) {
            return loadSprite(url, id);
        }
        /**
     * Setup multiple instances
     * @param {*} selector
     * @param {Object} options
     */ static setup(selector, options = {}) {
            let targets = null;
            if (is.string(selector)) targets = Array.from(document.querySelectorAll(selector));
            else if (is.nodeList(selector)) targets = Array.from(selector);
            else if (is.array(selector)) targets = selector.filter(is.element);
            if (is.empty(targets)) return null;
            return targets.map((t)=>new Plyr(t, options));
        }
    }
    Plyr.defaults = cloneDeep(defaults);
    return Plyr;
}); //# sourceMappingURL=plyr.js.map



var $5FkrB = parcelRequire("5FkrB");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $f188eff9b59fb855$var$extendStatics = function(d, b) {
    $f188eff9b59fb855$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $f188eff9b59fb855$var$extendStatics(d, b);
};
function $f188eff9b59fb855$var$__extends(d, b) {
    $f188eff9b59fb855$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f188eff9b59fb855$var$__assign = function() {
    $f188eff9b59fb855$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f188eff9b59fb855$var$__assign.apply(this, arguments);
};
function $f188eff9b59fb855$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }
    return t;
}
var $f188eff9b59fb855$var$VIEWBOX_WIDTH = 100;
var $f188eff9b59fb855$var$VIEWBOX_HEIGHT = 100;
var $f188eff9b59fb855$var$VIEWBOX_HEIGHT_HALF = 50;
var $f188eff9b59fb855$var$VIEWBOX_CENTER_X = 50;
var $f188eff9b59fb855$var$VIEWBOX_CENTER_Y = 50;
function $f188eff9b59fb855$var$Path(_a) {
    var className = _a.className, counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius, strokeWidth = _a.strokeWidth, style = _a.style;
    return (0, $5FkrB.createElement)("path", {
        className: className,
        style: Object.assign({}, style, $f188eff9b59fb855$var$getDashStyle({
            pathRadius: pathRadius,
            dashRatio: dashRatio,
            counterClockwise: counterClockwise
        })),
        d: $f188eff9b59fb855$var$getPathDescription({
            pathRadius: pathRadius,
            counterClockwise: counterClockwise
        }),
        strokeWidth: strokeWidth,
        fillOpacity: 0
    });
}
function $f188eff9b59fb855$var$getPathDescription(_a) {
    var pathRadius = _a.pathRadius, counterClockwise = _a.counterClockwise;
    var radius = pathRadius;
    var rotation = counterClockwise ? 1 : 0;
    return "\n      M " + $f188eff9b59fb855$var$VIEWBOX_CENTER_X + "," + $f188eff9b59fb855$var$VIEWBOX_CENTER_Y + "\n      m 0,-" + radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0," + 2 * radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0,-" + 2 * radius + "\n    ";
}
function $f188eff9b59fb855$var$getDashStyle(_a) {
    var counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius;
    var diameter = Math.PI * 2 * pathRadius;
    var gapLength = (1 - dashRatio) * diameter;
    return {
        strokeDasharray: diameter + "px " + diameter + "px",
        strokeDashoffset: (counterClockwise ? -gapLength : gapLength) + "px"
    };
}
var $f188eff9b59fb855$export$14082143029b37c8 = function(_super) {
    $f188eff9b59fb855$var$__extends(CircularProgressbar, _super);
    function CircularProgressbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CircularProgressbar.prototype.getBackgroundPadding = function() {
        if (!this.props.background) return 0;
        return this.props.backgroundPadding;
    };
    CircularProgressbar.prototype.getPathRadius = function() {
        return $f188eff9b59fb855$var$VIEWBOX_HEIGHT_HALF - this.props.strokeWidth / 2 - this.getBackgroundPadding();
    };
    CircularProgressbar.prototype.getPathRatio = function() {
        var _a = this.props, value = _a.value, minValue = _a.minValue, maxValue = _a.maxValue;
        var boundedValue = Math.min(Math.max(value, minValue), maxValue);
        return (boundedValue - minValue) / (maxValue - minValue);
    };
    CircularProgressbar.prototype.render = function() {
        var _a = this.props, circleRatio = _a.circleRatio, className = _a.className, classes = _a.classes, counterClockwise = _a.counterClockwise, styles = _a.styles, strokeWidth = _a.strokeWidth, text = _a.text;
        var pathRadius = this.getPathRadius();
        var pathRatio = this.getPathRatio();
        return (0, $5FkrB.createElement)("svg", {
            className: classes.root + " " + className,
            style: styles.root,
            viewBox: "0 0 " + $f188eff9b59fb855$var$VIEWBOX_WIDTH + " " + $f188eff9b59fb855$var$VIEWBOX_HEIGHT,
            "data-test-id": "CircularProgressbar"
        }, this.props.background ? (0, $5FkrB.createElement)("circle", {
            className: classes.background,
            style: styles.background,
            cx: $f188eff9b59fb855$var$VIEWBOX_CENTER_X,
            cy: $f188eff9b59fb855$var$VIEWBOX_CENTER_Y,
            r: $f188eff9b59fb855$var$VIEWBOX_HEIGHT_HALF
        }) : null, (0, $5FkrB.createElement)($f188eff9b59fb855$var$Path, {
            className: classes.trail,
            counterClockwise: counterClockwise,
            dashRatio: circleRatio,
            pathRadius: pathRadius,
            strokeWidth: strokeWidth,
            style: styles.trail
        }), (0, $5FkrB.createElement)($f188eff9b59fb855$var$Path, {
            className: classes.path,
            counterClockwise: counterClockwise,
            dashRatio: pathRatio * circleRatio,
            pathRadius: pathRadius,
            strokeWidth: strokeWidth,
            style: styles.path
        }), text ? (0, $5FkrB.createElement)("text", {
            className: classes.text,
            style: styles.text,
            x: $f188eff9b59fb855$var$VIEWBOX_CENTER_X,
            y: $f188eff9b59fb855$var$VIEWBOX_CENTER_Y
        }, text) : null);
    };
    CircularProgressbar.defaultProps = {
        background: false,
        backgroundPadding: 0,
        circleRatio: 1,
        classes: {
            root: 'CircularProgressbar',
            trail: 'CircularProgressbar-trail',
            path: 'CircularProgressbar-path',
            text: 'CircularProgressbar-text',
            background: 'CircularProgressbar-background'
        },
        counterClockwise: false,
        className: '',
        maxValue: 100,
        minValue: 0,
        strokeWidth: 8,
        styles: {
            root: {},
            trail: {},
            path: {},
            text: {},
            background: {}
        },
        text: ''
    };
    return CircularProgressbar;
}((0, $5FkrB.Component));
function $f188eff9b59fb855$export$5ab97151efedb8c6(props) {
    var children = props.children, circularProgressbarProps = $f188eff9b59fb855$var$__rest(props, [
        "children"
    ]);
    return (0, $5FkrB.createElement)("div", {
        "data-test-id": "CircularProgressbarWithChildren"
    }, (0, $5FkrB.createElement)("div", {
        style: {
            position: 'relative',
            width: '100%',
            height: '100%'
        }
    }, (0, $5FkrB.createElement)($f188eff9b59fb855$export$14082143029b37c8, $f188eff9b59fb855$var$__assign({}, circularProgressbarProps)), props.children ? (0, $5FkrB.createElement)("div", {
        "data-test-id": "CircularProgressbarWithChildren__children",
        style: {
            position: 'absolute',
            width: '100%',
            height: '100%',
            marginTop: '-100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        }
    }, props.children) : null));
}
function $f188eff9b59fb855$export$5115a192ad9bf57f(_a) {
    var rotation = _a.rotation, strokeLinecap = _a.strokeLinecap, textColor = _a.textColor, textSize = _a.textSize, pathColor = _a.pathColor, pathTransition = _a.pathTransition, pathTransitionDuration = _a.pathTransitionDuration, trailColor = _a.trailColor, backgroundColor = _a.backgroundColor;
    var rotationTransform = rotation == null ? undefined : "rotate(" + rotation + "turn)";
    var rotationTransformOrigin = rotation == null ? undefined : 'center center';
    return {
        root: {},
        path: $f188eff9b59fb855$var$removeUndefinedValues({
            stroke: pathColor,
            strokeLinecap: strokeLinecap,
            transform: rotationTransform,
            transformOrigin: rotationTransformOrigin,
            transition: pathTransition,
            transitionDuration: pathTransitionDuration == null ? undefined : pathTransitionDuration + "s"
        }),
        trail: $f188eff9b59fb855$var$removeUndefinedValues({
            stroke: trailColor,
            strokeLinecap: strokeLinecap,
            transform: rotationTransform,
            transformOrigin: rotationTransformOrigin
        }),
        text: $f188eff9b59fb855$var$removeUndefinedValues({
            fill: textColor,
            fontSize: textSize
        }),
        background: $f188eff9b59fb855$var$removeUndefinedValues({
            fill: backgroundColor
        })
    };
}
function $f188eff9b59fb855$var$removeUndefinedValues(obj) {
    Object.keys(obj).forEach(function(key) {
        if (obj[key] == null) delete obj[key];
    });
    return obj;
}



var $kqp0i = parcelRequire("kqp0i");

var $ekGgq = parcelRequire("ekGgq");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $1d0cfadcde059b60$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1d0cfadcde059b60$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1d0cfadcde059b60$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1d0cfadcde059b60$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1d0cfadcde059b60$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $1d0cfadcde059b60$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $1d0cfadcde059b60$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $1d0cfadcde059b60$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $1d0cfadcde059b60$var$_objectSpread($1d0cfadcde059b60$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $b95068fc516c9108$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $b95068fc516c9108$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $b95068fc516c9108$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b95068fc516c9108$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $b95068fc516c9108$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $b95068fc516c9108$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $b95068fc516c9108$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $b95068fc516c9108$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $b95068fc516c9108$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $b95068fc516c9108$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $1d0cfadcde059b60$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $047d9f4294939461$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $adf0005bf2c65956$export$5bf35293e545f20c() {
    var analyticsContext = (0, $047d9f4294939461$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $b95068fc516c9108$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $4618b43f5fc4f6c5$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $a918673efb06b613$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a918673efb06b613$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a918673efb06b613$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a918673efb06b613$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a918673efb06b613$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $adf0005bf2c65956$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $4618b43f5fc4f6c5$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $4618b43f5fc4f6c5$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $a918673efb06b613$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $9dOvm = parcelRequire("9dOvm");
var $472462b83b962a12$var$_process, $472462b83b962a12$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $472462b83b962a12$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($472462b83b962a12$var$_process = globalThis.process) === null || $472462b83b962a12$var$_process === void 0 || ($472462b83b962a12$var$_process = $472462b83b962a12$var$_process.env) === null || $472462b83b962a12$var$_process === void 0 ? void 0 : $472462b83b962a12$var$_process.JEST_WORKER_ID) !== undefined;
var $472462b83b962a12$var$DEBUG_MODE = !$472462b83b962a12$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($472462b83b962a12$var$_process2 = globalThis.process) === null || $472462b83b962a12$var$_process2 === void 0 || ($472462b83b962a12$var$_process2 = $472462b83b962a12$var$_process2.env) === null || $472462b83b962a12$var$_process2 === void 0 ? void 0 : $472462b83b962a12$var$_process2.NODE_ENV) !== 'production';
var $472462b83b962a12$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$472462b83b962a12$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $84d96ec79ead29f5$var$pkgName = '@atlaskit/platform-feature-flags';
var $84d96ec79ead29f5$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $84d96ec79ead29f5$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $84d96ec79ead29f5$var$ENV_ENABLE_PLATFORM_FF = $84d96ec79ead29f5$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $84d96ec79ead29f5$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $84d96ec79ead29f5$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $84d96ec79ead29f5$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $84d96ec79ead29f5$var$ENV_ENABLE_PLATFORM_FF || $84d96ec79ead29f5$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $84d96ec79ead29f5$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $84d96ec79ead29f5$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$84d96ec79ead29f5$var$globalVar[$84d96ec79ead29f5$export$7e41b1b2bdee3f98] = $84d96ec79ead29f5$var$globalVar[$84d96ec79ead29f5$export$7e41b1b2bdee3f98] || $84d96ec79ead29f5$var$DEFAULT_PFF_GLOBAL;
function $84d96ec79ead29f5$export$f2b591175b3e424c(resolver) {
    $84d96ec79ead29f5$var$globalVar[$84d96ec79ead29f5$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $84d96ec79ead29f5$export$6333b6aff9fc6275(flagKey) {
    if ($84d96ec79ead29f5$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $472462b83b962a12$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $84d96ec79ead29f5$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $84d96ec79ead29f5$var$globalVar[$84d96ec79ead29f5$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $84d96ec79ead29f5$var$globalVar[$84d96ec79ead29f5$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $9dOvm.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $84d96ec79ead29f5$var$globalVar[$84d96ec79ead29f5$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $190479c355802156$export$ba05d765b8392e5e(flagResolver) {
    (0, $84d96ec79ead29f5$export$f2b591175b3e424c)(flagResolver);
}
function $190479c355802156$export$470e5c2be1411c89(name) {
    return (0, $84d96ec79ead29f5$export$6333b6aff9fc6275)(name);
}
function $190479c355802156$export$b40ec24ac8275656(name) {
    return (0, $84d96ec79ead29f5$export$6333b6aff9fc6275)(name);
}


/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $8922b7a46dc064ca$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
var $8922b7a46dc064ca$export$c881183ca713c214 = $8922b7a46dc064ca$export$987d49ffe1b0900f;


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $8e3a4a009d721f1c$export$4b84fd0e2c617bd = '#FFEBE6';
var $8e3a4a009d721f1c$export$b34b069eff244586 = '#FFBDAD';
var $8e3a4a009d721f1c$export$be802dd0d8b57f35 = '#FF8F73';
var $8e3a4a009d721f1c$export$60847d42f9da92a6 = '#FF7452';
var $8e3a4a009d721f1c$export$4a7404f376229999 = '#FF5630';
var $8e3a4a009d721f1c$export$2010d0fb4295b346 = '#DE350B';
var $8e3a4a009d721f1c$export$2837b5a1a71d5c02 = '#BF2600';
var $8e3a4a009d721f1c$export$8d9596b529bbb9cf = '#FFFAE6';
var $8e3a4a009d721f1c$export$41060a744ab0b7ae = '#FFF0B3';
var $8e3a4a009d721f1c$export$1cc05bbbf340e559 = '#FFE380';
var $8e3a4a009d721f1c$export$5aae31392d72caaa = '#FFC400';
var $8e3a4a009d721f1c$export$c6930421db9fa514 = '#FFAB00';
var $8e3a4a009d721f1c$export$59619663aa6500fb = '#FF991F';
var $8e3a4a009d721f1c$export$874739ea9e379ab6 = '#FF8B00';
var $8e3a4a009d721f1c$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $8e3a4a009d721f1c$export$69a3bf21b9686c2b = '#ABF5D1';
var $8e3a4a009d721f1c$export$afbce1382ec95f73 = '#79F2C0';
var $8e3a4a009d721f1c$export$747d86715d4175de = '#57D9A3';
var $8e3a4a009d721f1c$export$940e1f69e873f202 = '#36B37E';
var $8e3a4a009d721f1c$export$a49394138f7b8e85 = '#00875A';
var $8e3a4a009d721f1c$export$6fa04827ac68a4fb = '#006644';
var $8e3a4a009d721f1c$export$226de0355ed012f8 = '#DEEBFF';
var $8e3a4a009d721f1c$export$8c13c2ee36917869 = '#B3D4FF';
var $8e3a4a009d721f1c$export$ecfc1dff386a3e7a = '#4C9AFF';
var $8e3a4a009d721f1c$export$215b7063051591f1 = '#2684FF';
var $8e3a4a009d721f1c$export$e62e8919cca44969 = '#0065FF';
var $8e3a4a009d721f1c$export$b3de0ae08da2ce64 = '#0052CC';
var $8e3a4a009d721f1c$export$a6ee3d71bc067634 = '#0747A6';
var $8e3a4a009d721f1c$export$67f15409e87642a1 = '#669DF1';
var $8e3a4a009d721f1c$export$f0539dbc42dbb067 = '#8FB8F6';
var $8e3a4a009d721f1c$export$363e4475840015bb = '#EAE6FF';
var $8e3a4a009d721f1c$export$4b0a4417ed59760f = '#C0B6F2';
var $8e3a4a009d721f1c$export$6011520a64d9a187 = '#998DD9';
var $8e3a4a009d721f1c$export$a7175d4e9206bc80 = '#8777D9';
var $8e3a4a009d721f1c$export$b48405b95304b5a1 = '#6554C0';
var $8e3a4a009d721f1c$export$c71e4279dd54a18d = '#5243AA';
var $8e3a4a009d721f1c$export$147899de772240ec = '#403294';
var $8e3a4a009d721f1c$export$2cf711fe14c66f06 = '#E6FCFF';
var $8e3a4a009d721f1c$export$7a8f4d33f6f9772c = '#B3F5FF';
var $8e3a4a009d721f1c$export$776c9c497ef08533 = '#79E2F2';
var $8e3a4a009d721f1c$export$69cb3ca10c1e330e = '#00C7E6';
var $8e3a4a009d721f1c$export$9dc1ef0f3f48059b = '#00B8D9';
var $8e3a4a009d721f1c$export$7c835c78b6fcdef8 = '#00A3BF';
var $8e3a4a009d721f1c$export$6036577f95c3877e = '#008DA6';
var $8e3a4a009d721f1c$export$29a4f05edc054374 = '#FFFFFF';
var $8e3a4a009d721f1c$export$e655ef011c4aa1a2 = '#FAFBFC';
var $8e3a4a009d721f1c$export$9fdfb749e33cdf97 = '#F4F5F7';
var $8e3a4a009d721f1c$export$3e51e8f1440314ba = '#EBECF0';
var $8e3a4a009d721f1c$export$1ce2d1575d444ceb = '#DFE1E6';
var $8e3a4a009d721f1c$export$8754fc7e6d8b3000 = '#C1C7D0';
var $8e3a4a009d721f1c$export$c2e91cbeada39b8b = '#B3BAC5';
var $8e3a4a009d721f1c$export$5f71e19f3a7ad9de = '#A5ADBA';
var $8e3a4a009d721f1c$export$eaa8c8a70ac22806 = '#97A0AF';
var $8e3a4a009d721f1c$export$7c87d337fb91a97d = '#8993A4';
var $8e3a4a009d721f1c$export$d6447c357493214f = '#7A869A';
var $8e3a4a009d721f1c$export$f563ee71e9ee74cd = '#6B778C';
var $8e3a4a009d721f1c$export$e2ef2124cf4024b1 = '#5E6C84';
var $8e3a4a009d721f1c$export$eece5f492e429f08 = '#505F79';
var $8e3a4a009d721f1c$export$c39c0fe0f26207ae = '#42526E';
var $8e3a4a009d721f1c$export$7090862dc3038a9f = '#344563';
var $8e3a4a009d721f1c$export$ad0bacf983b7ddaa = '#253858';
var $8e3a4a009d721f1c$export$7d61b15e0da132af = '#172B4D';
var $8e3a4a009d721f1c$export$fbda843f0a27fe96 = '#091E42';
var $8e3a4a009d721f1c$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $8e3a4a009d721f1c$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $8e3a4a009d721f1c$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $8e3a4a009d721f1c$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $8e3a4a009d721f1c$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $8e3a4a009d721f1c$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $8e3a4a009d721f1c$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $8e3a4a009d721f1c$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $8e3a4a009d721f1c$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $8e3a4a009d721f1c$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $8e3a4a009d721f1c$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $8e3a4a009d721f1c$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $8e3a4a009d721f1c$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $8e3a4a009d721f1c$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $8e3a4a009d721f1c$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $8e3a4a009d721f1c$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $8e3a4a009d721f1c$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $8e3a4a009d721f1c$export$2f6319cf7d736c2a = '#E6EDFA';
var $8e3a4a009d721f1c$export$95126bc8884d6634 = '#DCE5F5';
var $8e3a4a009d721f1c$export$8338d8c35d44ff1 = '#CED9EB';
var $8e3a4a009d721f1c$export$5368d76ae4fbbda7 = '#B8C7E0';
var $8e3a4a009d721f1c$export$9f0a771d16ec8d36 = '#ABBBD6';
var $8e3a4a009d721f1c$export$abcf8c38338b4aa5 = '#9FB0CC';
var $8e3a4a009d721f1c$export$97e81faa16a182c7 = '#8C9CB8';
var $8e3a4a009d721f1c$export$bfe21c59123ecf33 = '#7988A3';
var $8e3a4a009d721f1c$export$ee82aa2ea6a1558 = '#67758F';
var $8e3a4a009d721f1c$export$682927c6ed76be02 = '#56637A';
var $8e3a4a009d721f1c$export$91fd9994c5be9757 = '#455166';
var $8e3a4a009d721f1c$export$d281fbfe3cff2df6 = '#3B475C';
var $8e3a4a009d721f1c$export$3902c91d8b98a753 = '#313D52';
var $8e3a4a009d721f1c$export$8e8133c1ba5845b5 = '#283447';
var $8e3a4a009d721f1c$export$33ff357f6620b39 = '#202B3D';
var $8e3a4a009d721f1c$export$633847cf062b69e0 = '#1B2638';
var $8e3a4a009d721f1c$export$9776a6e503bdbf76 = '#121A29';
var $8e3a4a009d721f1c$export$6c813d5160dff5db = '#0E1624';
var $8e3a4a009d721f1c$export$3d4f271a500072a = '#0D1424';
var $8e3a4a009d721f1c$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $8e3a4a009d721f1c$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $8e3a4a009d721f1c$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $8e3a4a009d721f1c$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $8e3a4a009d721f1c$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $8e3a4a009d721f1c$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $8e3a4a009d721f1c$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $8e3a4a009d721f1c$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $8e3a4a009d721f1c$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $8e3a4a009d721f1c$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $8e3a4a009d721f1c$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $8e3a4a009d721f1c$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $8e3a4a009d721f1c$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $8e3a4a009d721f1c$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $8e3a4a009d721f1c$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $8e3a4a009d721f1c$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $8e3a4a009d721f1c$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $8e3a4a009d721f1c$export$d2adc5dedf09fced = '#292A2E';
var $8e3a4a009d721f1c$export$f51762073d2bb381 = '#94C748';
var $8e3a4a009d721f1c$export$95e26d54def96891 = '#B3DF72';


var $e42caaa3067aa593$export$ae3cba7672df0890 = "var(--ds-background-disabled, ".concat((0, $8e3a4a009d721f1c$export$9fdfb749e33cdf97), ")");
var $e42caaa3067aa593$export$fe505fe3c5edbdf6 = "var(--ds-border-disabled, ".concat((0, $8e3a4a009d721f1c$export$1ce2d1575d444ceb), ")");
var $e42caaa3067aa593$export$7f333bbf7ddab792 = "var(--ds-border-danger, ".concat((0, $8e3a4a009d721f1c$export$2010d0fb4295b346), ")");
var $e42caaa3067aa593$export$dafd83031c202ca8 = "var(--ds-border-input, ".concat((0, $8e3a4a009d721f1c$export$d6447c357493214f), ")");
var $e42caaa3067aa593$export$e8320c09dc1e4012 = "var(--ds-border-focused, ".concat((0, $8e3a4a009d721f1c$export$215b7063051591f1), ")");
var $e42caaa3067aa593$export$b13414ee9ac9cae6 = "var(--ds-background-input, ".concat((0, $8e3a4a009d721f1c$export$e655ef011c4aa1a2), ")");
var $e42caaa3067aa593$export$bca15982c103d57b = "var(--ds-background-input-hovered, ".concat((0, $8e3a4a009d721f1c$export$3e51e8f1440314ba), ")");
var $e42caaa3067aa593$export$21287e4b7f134f09 = "var(--ds-background-input-pressed, ".concat((0, $8e3a4a009d721f1c$export$29a4f05edc054374), ")");
var $e42caaa3067aa593$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
var $e42caaa3067aa593$export$5e076b2557ef7bbb = "var(--ds-text-subtlest, ".concat((0, $8e3a4a009d721f1c$export$f563ee71e9ee74cd), ")");
var $e42caaa3067aa593$export$32f78bffcd82ff28 = "var(--ds-text, ".concat((0, $8e3a4a009d721f1c$export$fbda843f0a27fe96), ")");
var $e42caaa3067aa593$export$eb4a7d363eec53c8 = "var(--ds-text-disabled, ".concat((0, $8e3a4a009d721f1c$export$5f71e19f3a7ad9de), ")");
var $e42caaa3067aa593$export$f4d082c200a4b4b8 = 'transparent';


function $b22ea6c50e1a7cea$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b22ea6c50e1a7cea$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b22ea6c50e1a7cea$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b22ea6c50e1a7cea$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b22ea6c50e1a7cea$var$disabledRules = {
    backgroundColor: $e42caaa3067aa593$export$ae3cba7672df0890,
    backgroundColorFocus: $e42caaa3067aa593$export$ae3cba7672df0890,
    backgroundColorHover: $e42caaa3067aa593$export$ae3cba7672df0890,
    borderColor: $e42caaa3067aa593$export$fe505fe3c5edbdf6,
    borderColorFocus: $e42caaa3067aa593$export$e8320c09dc1e4012,
    textColor: $e42caaa3067aa593$export$eb4a7d363eec53c8
};
var $b22ea6c50e1a7cea$var$invalidRules = {
    borderColor: $e42caaa3067aa593$export$7f333bbf7ddab792,
    borderColorFocus: $e42caaa3067aa593$export$e8320c09dc1e4012,
    backgroundColor: $e42caaa3067aa593$export$b13414ee9ac9cae6,
    backgroundColorFocus: $e42caaa3067aa593$export$21287e4b7f134f09,
    backgroundColorHover: $e42caaa3067aa593$export$bca15982c103d57b
};
var $b22ea6c50e1a7cea$var$backgroundColor = {
    standard: $e42caaa3067aa593$export$b13414ee9ac9cae6,
    subtle: $e42caaa3067aa593$export$f4d082c200a4b4b8,
    none: $e42caaa3067aa593$export$f4d082c200a4b4b8
};
var $b22ea6c50e1a7cea$var$backgroundColorFocus = {
    standard: $e42caaa3067aa593$export$21287e4b7f134f09,
    subtle: $e42caaa3067aa593$export$21287e4b7f134f09,
    none: $e42caaa3067aa593$export$f4d082c200a4b4b8
};
var $b22ea6c50e1a7cea$var$backgroundColorHover = {
    standard: $e42caaa3067aa593$export$bca15982c103d57b,
    subtle: $e42caaa3067aa593$export$bca15982c103d57b,
    none: $e42caaa3067aa593$export$f4d082c200a4b4b8
};
var $b22ea6c50e1a7cea$var$borderColor = {
    standard: $e42caaa3067aa593$export$dafd83031c202ca8,
    subtle: $e42caaa3067aa593$export$f4d082c200a4b4b8,
    none: $e42caaa3067aa593$export$f4d082c200a4b4b8
};
var $b22ea6c50e1a7cea$var$borderColorFocus = {
    standard: $e42caaa3067aa593$export$e8320c09dc1e4012,
    subtle: $e42caaa3067aa593$export$e8320c09dc1e4012,
    none: $e42caaa3067aa593$export$f4d082c200a4b4b8
};
var $b22ea6c50e1a7cea$var$borderColorHover = {
    standard: $e42caaa3067aa593$export$dafd83031c202ca8,
    subtle: $e42caaa3067aa593$export$a87538d56ee366ec,
    none: $e42caaa3067aa593$export$f4d082c200a4b4b8
};
var $b22ea6c50e1a7cea$var$lineHeightBase = 20;
var $b22ea6c50e1a7cea$var$lineHeightCompact = 16;
var $b22ea6c50e1a7cea$var$compactVerticalPadding = 2;
var $b22ea6c50e1a7cea$var$verticalPadding = 6;
var $b22ea6c50e1a7cea$var$horizontalPadding = 8;
var $b22ea6c50e1a7cea$var$transitionDuration = '0.2s';
var $b22ea6c50e1a7cea$export$12879c7697ed953d = 2;
// Safari puts on some difficult to remove styles, mainly for disabled inputs
// but we want full control so need to override them in all cases
var $b22ea6c50e1a7cea$var$overrideSafariDisabledStyles = {
    WebkitTextFillColor: 'unset',
    WebkitOpacity: '1'
};
var $b22ea6c50e1a7cea$var$borderBoxMinHeight = function borderBoxMinHeight(minimumRows, borderHeight) {
    var contentHeight = $b22ea6c50e1a7cea$var$lineHeightBase * minimumRows;
    return contentHeight + $b22ea6c50e1a7cea$var$verticalPadding * 2 + borderHeight * 2;
};
var $b22ea6c50e1a7cea$var$borderBoxMinHeightCompact = function borderBoxMinHeightCompact(minimumRows, borderHeight) {
    var contentHeightCompact = $b22ea6c50e1a7cea$var$lineHeightCompact * minimumRows;
    return contentHeightCompact + $b22ea6c50e1a7cea$var$compactVerticalPadding * 2 + borderHeight * 2;
};
var $b22ea6c50e1a7cea$var$bgAndBorderColorStyles = function bgAndBorderColorStyles(appearance) {
    return appearance && (0, $74Zh5.css)($b22ea6c50e1a7cea$var$_objectSpread({
        '&:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $b22ea6c50e1a7cea$var$backgroundColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $b22ea6c50e1a7cea$var$borderColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", $b22ea6c50e1a7cea$var$borderColorFocus[appearance])
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $b22ea6c50e1a7cea$var$backgroundColor[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $b22ea6c50e1a7cea$var$borderColor[appearance]
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $b22ea6c50e1a7cea$var$invalidRules.backgroundColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $b22ea6c50e1a7cea$var$invalidRules.borderColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", $b22ea6c50e1a7cea$var$invalidRules.borderColorFocus)
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $b22ea6c50e1a7cea$var$invalidRules.backgroundColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $b22ea6c50e1a7cea$var$invalidRules.borderColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", $b22ea6c50e1a7cea$var$invalidRules.borderColor)
        }
    }, appearance === 'standard' ? {
        '&:disabled:focus': {
            backgroundColor: $b22ea6c50e1a7cea$var$disabledRules.backgroundColorFocus,
            borderColor: $b22ea6c50e1a7cea$var$disabledRules.borderColorFocus
        },
        '&:disabled:not(:focus)': {
            backgroundColor: $b22ea6c50e1a7cea$var$disabledRules.backgroundColor,
            borderColor: $b22ea6c50e1a7cea$var$disabledRules.borderColor
        }
    } : {}));
};
var $b22ea6c50e1a7cea$var$placeholderStyles = (0, $74Zh5.css)({
    '&::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $e42caaa3067aa593$export$5e076b2557ef7bbb
    },
    '&:disabled::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $b22ea6c50e1a7cea$var$disabledRules.textColor
    }
});
var $b22ea6c50e1a7cea$var$hoverBackgroundAndBorderStyles = function hoverBackgroundAndBorderStyles(appearance) {
    return appearance && (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:hover:not(:read-only):not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $b22ea6c50e1a7cea$var$backgroundColorHover[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $b22ea6c50e1a7cea$var$borderColorHover[appearance],
            '&:disabled': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $b22ea6c50e1a7cea$var$disabledRules.backgroundColorHover
            },
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[data-invalid]': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $b22ea6c50e1a7cea$var$invalidRules.backgroundColorHover,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderColor: $b22ea6c50e1a7cea$var$invalidRules.borderColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", $b22ea6c50e1a7cea$var$invalidRules.borderColor)
            }
        }
    });
};
var $b22ea6c50e1a7cea$var$resizeStyle = function resizeStyle(resize) {
    if (resize === 'horizontal' || resize === 'vertical') // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return (0, $74Zh5.css)({
        resize: resize
    });
    if (resize === 'auto') return (0, $74Zh5.css)({
        resize: 'both'
    });
    return (0, $74Zh5.css)({
        resize: 'none'
    });
};
var $b22ea6c50e1a7cea$var$borderStyle = function borderStyle(appearance) {
    return (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderStyle: appearance === 'none' ? 'none' : 'solid'
    });
};
var $b22ea6c50e1a7cea$var$fontFamilyStyle = function fontFamilyStyle(isMonospaced) {
    return (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        fontFamily: isMonospaced ? "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)" : "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
};
var $b22ea6c50e1a7cea$var$borderPaddingAndHeightStyles = function borderPaddingAndHeightStyles() {
    var minimumRows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var appearance = arguments.length > 1 ? arguments[1] : undefined;
    var borderWidth = appearance !== 'none' ? 1 : 2;
    var horizontalPaddingWithoutBorderWidth = $b22ea6c50e1a7cea$var$horizontalPadding - borderWidth;
    var borderHeight = borderWidth;
    return (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-compact]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $b22ea6c50e1a7cea$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: "".concat($b22ea6c50e1a7cea$var$compactVerticalPadding, "px ").concat(horizontalPaddingWithoutBorderWidth, "px"),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography
            lineHeight: $b22ea6c50e1a7cea$var$lineHeightCompact / 14
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-compact])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $b22ea6c50e1a7cea$var$borderBoxMinHeight(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: "".concat($b22ea6c50e1a7cea$var$verticalPadding, "px ").concat(horizontalPaddingWithoutBorderWidth, "px"),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography
            lineHeight: $b22ea6c50e1a7cea$var$lineHeightBase / 14
        }
    });
};
var $b22ea6c50e1a7cea$var$staticStyles = (0, $74Zh5.css)({
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    margin: 0,
    position: 'relative',
    flex: '1 1 100%',
    borderRadius: "var(--ds-border-radius, 3px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    borderWidth: 1,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    outline: 'none',
    overflow: 'auto',
    transition: "background-color ".concat($b22ea6c50e1a7cea$var$transitionDuration, " ease-in-out,\n               border-color ").concat($b22ea6c50e1a7cea$var$transitionDuration, " ease-in-out"),
    wordWrap: 'break-word',
    '&:disabled': $b22ea6c50e1a7cea$var$_objectSpread({
        cursor: 'not-allowed'
    }, $b22ea6c50e1a7cea$var$overrideSafariDisabledStyles),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-ms-clear': {
        display: 'none'
    },
    '&:invalid': {
        boxShadow: 'none'
    }
});
// suggestion: these two could be merged into cssMap during @compiled rewrite
var $b22ea6c50e1a7cea$var$newFontStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
}, (0, $8922b7a46dc064ca$export$987d49ffe1b0900f).above.xs, {
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
}));
var $b22ea6c50e1a7cea$var$monospacedFontFamilyStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
}, (0, $8922b7a46dc064ca$export$987d49ffe1b0900f).above.xs, {
    // Reapply the monospaced font family as the font declaration used in the breakpoint in newFontStyles overrides it otherwise
    fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
}));
var $b22ea6c50e1a7cea$export$bff8031d86bb089 = function getBaseStyles(_ref) {
    var minimumRows = _ref.minimumRows, resize = _ref.resize, appearance = _ref.appearance, isMonospaced = _ref.isMonospaced, maxHeight = _ref.maxHeight;
    return(// eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $74Zh5.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $b22ea6c50e1a7cea$var$staticStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $b22ea6c50e1a7cea$var$borderPaddingAndHeightStyles(minimumRows, appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $b22ea6c50e1a7cea$var$resizeStyle(resize), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $b22ea6c50e1a7cea$var$borderStyle(appearance), // @todo: remove in `platform_design_system_team_safari_input_fix` cleanup
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $b22ea6c50e1a7cea$var$fontFamilyStyle(isMonospaced), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    (0, $190479c355802156$export$b40ec24ac8275656)('platform_design_system_team_safari_input_fix') ? $b22ea6c50e1a7cea$var$newFontStyles : undefined, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    isMonospaced && (0, $190479c355802156$export$b40ec24ac8275656)('platform_design_system_team_safari_input_fix') ? $b22ea6c50e1a7cea$var$monospacedFontFamilyStyles : undefined, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    {
        maxHeight: maxHeight
    }));
};
var $b22ea6c50e1a7cea$export$98856a888ef36079 = function dynamicStyles(appearance) {
    return(// eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $74Zh5.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $b22ea6c50e1a7cea$var$bgAndBorderColorStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $b22ea6c50e1a7cea$var$hoverBackgroundAndBorderStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $b22ea6c50e1a7cea$var$placeholderStyles, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $e42caaa3067aa593$export$32f78bffcd82ff28,
        '&:disabled': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: $b22ea6c50e1a7cea$var$disabledRules.textColor
        }
    }));
};


var $68e53f06a5d0057b$var$_excluded = [
    "resize",
    "appearance",
    "isCompact",
    "isRequired",
    "isReadOnly",
    "isDisabled",
    "isInvalid",
    "isMonospaced",
    "minimumRows",
    "testId",
    "maxHeight",
    "onBlur",
    "onFocus",
    "onChange",
    "value"
];
function $68e53f06a5d0057b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68e53f06a5d0057b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68e53f06a5d0057b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68e53f06a5d0057b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $68e53f06a5d0057b$var$packageName = "@atlaskit/textarea";
var $68e53f06a5d0057b$var$packageVersion = "5.8.2";
var $68e53f06a5d0057b$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $68e53f06a5d0057b$var$packageName,
    packageVersion: $68e53f06a5d0057b$var$packageVersion
};
var $68e53f06a5d0057b$var$setSmartHeight = function setSmartHeight(el) {
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    var borderHeight = (0, $b22ea6c50e1a7cea$export$12879c7697ed953d);
    var paddingBoxHeight = el.scrollHeight;
    var borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = "".concat(borderBoxHeight, "px");
};
var $68e53f06a5d0057b$var$InnerTextArea = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var ourRef = (0, $5FkrB.useRef)(null);
    var _props$resize = props.resize, resize = _props$resize === void 0 ? 'smart' : _props$resize, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'standard' : _props$appearance, _props$isCompact = props.isCompact, isCompact = _props$isCompact === void 0 ? false : _props$isCompact, _props$isRequired = props.isRequired, isRequired = _props$isRequired === void 0 ? false : _props$isRequired, _props$isReadOnly = props.isReadOnly, isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isMonospaced = props.isMonospaced, isMonospaced = _props$isMonospaced === void 0 ? false : _props$isMonospaced, _props$minimumRows = props.minimumRows, minimumRows = _props$minimumRows === void 0 ? 2 : _props$minimumRows, testId = props.testId, _props$maxHeight = props.maxHeight, maxHeight = _props$maxHeight === void 0 ? '50vh' : _props$maxHeight, onBlur = props.onBlur, onFocus = props.onFocus, onChange = props.onChange, value = props.value, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $68e53f06a5d0057b$var$_excluded);
    (0, $5FkrB.useEffect)(function() {
        var el = ourRef.current;
        if (resize === 'smart' && el) $68e53f06a5d0057b$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    var onBlurWithAnalytics = (0, $a918673efb06b613$export$a4687b0234b40e28)($68e53f06a5d0057b$var$_objectSpread({
        fn: function fn(event) {
            onBlur && onBlur(event);
        },
        action: 'blurred'
    }, $68e53f06a5d0057b$var$analyticsParams));
    var onFocusWithAnalytics = (0, $a918673efb06b613$export$a4687b0234b40e28)($68e53f06a5d0057b$var$_objectSpread({
        fn: function fn(event) {
            onFocus && onFocus(event);
        },
        action: 'focused'
    }, $68e53f06a5d0057b$var$analyticsParams));
    var getTextAreaRef = function getTextAreaRef(elementRef) {
        ourRef.current = elementRef;
        if (ref && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref) === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    var handleOnChange = (0, $5FkrB.useCallback)(function(e) {
        var el = ourRef.current;
        if (resize === 'smart' && el) $68e53f06a5d0057b$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    var controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    var baseStyles = (0, $5FkrB.useMemo)(function() {
        return (0, $b22ea6c50e1a7cea$export$bff8031d86bb089)({
            minimumRows: minimumRows,
            resize: resize,
            appearance: appearance,
            isMonospaced: isMonospaced,
            maxHeight: maxHeight
        });
    }, [
        minimumRows,
        resize,
        appearance,
        isMonospaced,
        maxHeight
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-array-arguments, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    var textAreaStyles = (0, $74Zh5.css)([
        baseStyles,
        (0, $b22ea6c50e1a7cea$export$98856a888ef36079)(appearance)
    ]);
    return (0, $74Zh5.jsx)("textarea", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, controlProps, {
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        css: textAreaStyles
    }, rest));
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ var $68e53f06a5d0057b$var$TextArea = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function TextArea(props, ref) {
    return (0, $74Zh5.jsx)($68e53f06a5d0057b$var$InnerTextArea, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: ref
    }, props));
}));
$68e53f06a5d0057b$var$TextArea.displayName = 'TextArea';
var $68e53f06a5d0057b$export$2e2bcd8739ae039 = $68e53f06a5d0057b$var$TextArea;


var $336d3dfe62d84a74$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $336d3dfe62d84a74$var$INFINITY = 1 / 0, $336d3dfe62d84a74$var$MAX_SAFE_INTEGER = 9007199254740991, $336d3dfe62d84a74$var$MAX_INTEGER = 1.7976931348623157e+308, $336d3dfe62d84a74$var$NAN = 0 / 0;
/** Used as references for the maximum length and index of an array. */ var $336d3dfe62d84a74$var$MAX_ARRAY_LENGTH = 4294967295;
/** `Object#toString` result references. */ var $336d3dfe62d84a74$var$argsTag = '[object Arguments]', $336d3dfe62d84a74$var$funcTag = '[object Function]', $336d3dfe62d84a74$var$genTag = '[object GeneratorFunction]', $336d3dfe62d84a74$var$mapTag = '[object Map]', $336d3dfe62d84a74$var$objectTag = '[object Object]', $336d3dfe62d84a74$var$promiseTag = '[object Promise]', $336d3dfe62d84a74$var$setTag = '[object Set]', $336d3dfe62d84a74$var$stringTag = '[object String]', $336d3dfe62d84a74$var$symbolTag = '[object Symbol]', $336d3dfe62d84a74$var$weakMapTag = '[object WeakMap]';
var $336d3dfe62d84a74$var$dataViewTag = '[object DataView]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $336d3dfe62d84a74$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match leading and trailing whitespace. */ var $336d3dfe62d84a74$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $336d3dfe62d84a74$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $336d3dfe62d84a74$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect host constructors (Safari). */ var $336d3dfe62d84a74$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect octal string values. */ var $336d3dfe62d84a74$var$reIsOctal = /^0o[0-7]+$/i;
/** Used to detect unsigned integer values. */ var $336d3dfe62d84a74$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to compose unicode character classes. */ var $336d3dfe62d84a74$var$rsAstralRange = '\\ud800-\\udfff', $336d3dfe62d84a74$var$rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23', $336d3dfe62d84a74$var$rsComboSymbolsRange = '\\u20d0-\\u20f0', $336d3dfe62d84a74$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $336d3dfe62d84a74$var$rsAstral = '[' + $336d3dfe62d84a74$var$rsAstralRange + ']', $336d3dfe62d84a74$var$rsCombo = '[' + $336d3dfe62d84a74$var$rsComboMarksRange + $336d3dfe62d84a74$var$rsComboSymbolsRange + ']', $336d3dfe62d84a74$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $336d3dfe62d84a74$var$rsModifier = '(?:' + $336d3dfe62d84a74$var$rsCombo + '|' + $336d3dfe62d84a74$var$rsFitz + ')', $336d3dfe62d84a74$var$rsNonAstral = '[^' + $336d3dfe62d84a74$var$rsAstralRange + ']', $336d3dfe62d84a74$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $336d3dfe62d84a74$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $336d3dfe62d84a74$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $336d3dfe62d84a74$var$reOptMod = $336d3dfe62d84a74$var$rsModifier + '?', $336d3dfe62d84a74$var$rsOptVar = '[' + $336d3dfe62d84a74$var$rsVarRange + ']?', $336d3dfe62d84a74$var$rsOptJoin = '(?:' + $336d3dfe62d84a74$var$rsZWJ + '(?:' + [
    $336d3dfe62d84a74$var$rsNonAstral,
    $336d3dfe62d84a74$var$rsRegional,
    $336d3dfe62d84a74$var$rsSurrPair
].join('|') + ')' + $336d3dfe62d84a74$var$rsOptVar + $336d3dfe62d84a74$var$reOptMod + ')*', $336d3dfe62d84a74$var$rsSeq = $336d3dfe62d84a74$var$rsOptVar + $336d3dfe62d84a74$var$reOptMod + $336d3dfe62d84a74$var$rsOptJoin, $336d3dfe62d84a74$var$rsSymbol = '(?:' + [
    $336d3dfe62d84a74$var$rsNonAstral + $336d3dfe62d84a74$var$rsCombo + '?',
    $336d3dfe62d84a74$var$rsCombo,
    $336d3dfe62d84a74$var$rsRegional,
    $336d3dfe62d84a74$var$rsSurrPair,
    $336d3dfe62d84a74$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $336d3dfe62d84a74$var$reUnicode = RegExp($336d3dfe62d84a74$var$rsFitz + '(?=' + $336d3dfe62d84a74$var$rsFitz + ')|' + $336d3dfe62d84a74$var$rsSymbol + $336d3dfe62d84a74$var$rsSeq, 'g');
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $336d3dfe62d84a74$var$reHasUnicode = RegExp('[' + $336d3dfe62d84a74$var$rsZWJ + $336d3dfe62d84a74$var$rsAstralRange + $336d3dfe62d84a74$var$rsComboMarksRange + $336d3dfe62d84a74$var$rsComboSymbolsRange + $336d3dfe62d84a74$var$rsVarRange + ']');
/** Built-in method references without a dependency on `root`. */ var $336d3dfe62d84a74$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $336d3dfe62d84a74$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $336d3dfe62d84a74$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $336d3dfe62d84a74$var$root = $336d3dfe62d84a74$var$freeGlobal || $336d3dfe62d84a74$var$freeSelf || Function('return this')();
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $336d3dfe62d84a74$var$arrayMap(array, iteratee) {
    var index = -1, length = array ? array.length : 0, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $336d3dfe62d84a74$var$asciiToArray(string) {
    return string.split('');
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $336d3dfe62d84a74$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $336d3dfe62d84a74$var$baseValues(object, props) {
    return $336d3dfe62d84a74$var$arrayMap(props, function(key) {
        return object[key];
    });
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $336d3dfe62d84a74$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $336d3dfe62d84a74$var$hasUnicode(string) {
    return $336d3dfe62d84a74$var$reHasUnicode.test(string);
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $336d3dfe62d84a74$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */ function $336d3dfe62d84a74$var$iteratorToArray(iterator) {
    var data, result = [];
    while(!(data = iterator.next()).done)result.push(data.value);
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $336d3dfe62d84a74$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $336d3dfe62d84a74$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $336d3dfe62d84a74$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $336d3dfe62d84a74$var$stringToArray(string) {
    return $336d3dfe62d84a74$var$hasUnicode(string) ? $336d3dfe62d84a74$var$unicodeToArray(string) : $336d3dfe62d84a74$var$asciiToArray(string);
}
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $336d3dfe62d84a74$var$unicodeToArray(string) {
    return string.match($336d3dfe62d84a74$var$reUnicode) || [];
}
/** Used for built-in method references. */ var $336d3dfe62d84a74$var$funcProto = Function.prototype, $336d3dfe62d84a74$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $336d3dfe62d84a74$var$coreJsData = $336d3dfe62d84a74$var$root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var $336d3dfe62d84a74$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($336d3dfe62d84a74$var$coreJsData && $336d3dfe62d84a74$var$coreJsData.keys && $336d3dfe62d84a74$var$coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var $336d3dfe62d84a74$var$funcToString = $336d3dfe62d84a74$var$funcProto.toString;
/** Used to check objects for own properties. */ var $336d3dfe62d84a74$var$hasOwnProperty = $336d3dfe62d84a74$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $336d3dfe62d84a74$var$objectToString = $336d3dfe62d84a74$var$objectProto.toString;
/** Used to detect if a method is native. */ var $336d3dfe62d84a74$var$reIsNative = RegExp('^' + $336d3dfe62d84a74$var$funcToString.call($336d3dfe62d84a74$var$hasOwnProperty).replace($336d3dfe62d84a74$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var $336d3dfe62d84a74$var$Symbol = $336d3dfe62d84a74$var$root.Symbol, $336d3dfe62d84a74$var$iteratorSymbol = $336d3dfe62d84a74$var$Symbol ? $336d3dfe62d84a74$var$Symbol.iterator : undefined, $336d3dfe62d84a74$var$propertyIsEnumerable = $336d3dfe62d84a74$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $336d3dfe62d84a74$var$nativeFloor = Math.floor, $336d3dfe62d84a74$var$nativeKeys = $336d3dfe62d84a74$var$overArg(Object.keys, Object), $336d3dfe62d84a74$var$nativeRandom = Math.random;
/* Built-in method references that are verified to be native. */ var $336d3dfe62d84a74$var$DataView = $336d3dfe62d84a74$var$getNative($336d3dfe62d84a74$var$root, 'DataView'), $336d3dfe62d84a74$var$Map = $336d3dfe62d84a74$var$getNative($336d3dfe62d84a74$var$root, 'Map'), $336d3dfe62d84a74$var$Promise = $336d3dfe62d84a74$var$getNative($336d3dfe62d84a74$var$root, 'Promise'), $336d3dfe62d84a74$var$Set = $336d3dfe62d84a74$var$getNative($336d3dfe62d84a74$var$root, 'Set'), $336d3dfe62d84a74$var$WeakMap = $336d3dfe62d84a74$var$getNative($336d3dfe62d84a74$var$root, 'WeakMap');
/** Used to detect maps, sets, and weakmaps. */ var $336d3dfe62d84a74$var$dataViewCtorString = $336d3dfe62d84a74$var$toSource($336d3dfe62d84a74$var$DataView), $336d3dfe62d84a74$var$mapCtorString = $336d3dfe62d84a74$var$toSource($336d3dfe62d84a74$var$Map), $336d3dfe62d84a74$var$promiseCtorString = $336d3dfe62d84a74$var$toSource($336d3dfe62d84a74$var$Promise), $336d3dfe62d84a74$var$setCtorString = $336d3dfe62d84a74$var$toSource($336d3dfe62d84a74$var$Set), $336d3dfe62d84a74$var$weakMapCtorString = $336d3dfe62d84a74$var$toSource($336d3dfe62d84a74$var$WeakMap);
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $336d3dfe62d84a74$var$arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = $336d3dfe62d84a74$var$isArray(value) || $336d3dfe62d84a74$var$isArguments(value) ? $336d3dfe62d84a74$var$baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || $336d3dfe62d84a74$var$hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || $336d3dfe62d84a74$var$isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $336d3dfe62d84a74$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $336d3dfe62d84a74$var$baseGetTag(value) {
    return $336d3dfe62d84a74$var$objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $336d3dfe62d84a74$var$baseIsNative(value) {
    if (!$336d3dfe62d84a74$var$isObject(value) || $336d3dfe62d84a74$var$isMasked(value)) return false;
    var pattern = $336d3dfe62d84a74$var$isFunction(value) || $336d3dfe62d84a74$var$isHostObject(value) ? $336d3dfe62d84a74$var$reIsNative : $336d3dfe62d84a74$var$reIsHostCtor;
    return pattern.test($336d3dfe62d84a74$var$toSource(value));
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $336d3dfe62d84a74$var$baseKeys(object) {
    if (!$336d3dfe62d84a74$var$isPrototype(object)) return $336d3dfe62d84a74$var$nativeKeys(object);
    var result = [];
    for(var key in Object(object))if ($336d3dfe62d84a74$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */ function $336d3dfe62d84a74$var$baseRandom(lower, upper) {
    return lower + $336d3dfe62d84a74$var$nativeFloor($336d3dfe62d84a74$var$nativeRandom() * (upper - lower + 1));
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $336d3dfe62d84a74$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $336d3dfe62d84a74$var$getNative(object, key) {
    var value = $336d3dfe62d84a74$var$getValue(object, key);
    return $336d3dfe62d84a74$var$baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $336d3dfe62d84a74$var$getTag = $336d3dfe62d84a74$var$baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ($336d3dfe62d84a74$var$DataView && $336d3dfe62d84a74$var$getTag(new $336d3dfe62d84a74$var$DataView(new ArrayBuffer(1))) != $336d3dfe62d84a74$var$dataViewTag || $336d3dfe62d84a74$var$Map && $336d3dfe62d84a74$var$getTag(new $336d3dfe62d84a74$var$Map) != $336d3dfe62d84a74$var$mapTag || $336d3dfe62d84a74$var$Promise && $336d3dfe62d84a74$var$getTag($336d3dfe62d84a74$var$Promise.resolve()) != $336d3dfe62d84a74$var$promiseTag || $336d3dfe62d84a74$var$Set && $336d3dfe62d84a74$var$getTag(new $336d3dfe62d84a74$var$Set) != $336d3dfe62d84a74$var$setTag || $336d3dfe62d84a74$var$WeakMap && $336d3dfe62d84a74$var$getTag(new $336d3dfe62d84a74$var$WeakMap) != $336d3dfe62d84a74$var$weakMapTag) $336d3dfe62d84a74$var$getTag = function(value) {
    var result = $336d3dfe62d84a74$var$objectToString.call(value), Ctor = result == $336d3dfe62d84a74$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $336d3dfe62d84a74$var$toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case $336d3dfe62d84a74$var$dataViewCtorString:
            return $336d3dfe62d84a74$var$dataViewTag;
        case $336d3dfe62d84a74$var$mapCtorString:
            return $336d3dfe62d84a74$var$mapTag;
        case $336d3dfe62d84a74$var$promiseCtorString:
            return $336d3dfe62d84a74$var$promiseTag;
        case $336d3dfe62d84a74$var$setCtorString:
            return $336d3dfe62d84a74$var$setTag;
        case $336d3dfe62d84a74$var$weakMapCtorString:
            return $336d3dfe62d84a74$var$weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $336d3dfe62d84a74$var$isIndex(value, length) {
    length = length == null ? $336d3dfe62d84a74$var$MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || $336d3dfe62d84a74$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $336d3dfe62d84a74$var$isIterateeCall(value, index, object) {
    if (!$336d3dfe62d84a74$var$isObject(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $336d3dfe62d84a74$var$isArrayLike(object) && $336d3dfe62d84a74$var$isIndex(index, object.length) : type == 'string' && index in object) return $336d3dfe62d84a74$var$eq(object[index], value);
    return false;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $336d3dfe62d84a74$var$isMasked(func) {
    return !!$336d3dfe62d84a74$var$maskSrcKey && $336d3dfe62d84a74$var$maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $336d3dfe62d84a74$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $336d3dfe62d84a74$var$objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $336d3dfe62d84a74$var$toSource(func) {
    if (func != null) {
        try {
            return $336d3dfe62d84a74$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Gets `n` random elements at unique keys from `collection` up to the
 * size of `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @param {number} [n=1] The number of elements to sample.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the random elements.
 * @example
 *
 * _.sampleSize([1, 2, 3], 2);
 * // => [3, 1]
 *
 * _.sampleSize([1, 2, 3], 4);
 * // => [2, 3, 1]
 */ function $336d3dfe62d84a74$var$sampleSize(collection, n, guard) {
    var index = -1, result = $336d3dfe62d84a74$var$toArray(collection), length = result.length, lastIndex = length - 1;
    if (guard ? $336d3dfe62d84a74$var$isIterateeCall(collection, n, guard) : n === undefined) n = 1;
    else n = $336d3dfe62d84a74$var$baseClamp($336d3dfe62d84a74$var$toInteger(n), 0, length);
    while(++index < n){
        var rand = $336d3dfe62d84a74$var$baseRandom(index, lastIndex), value = result[rand];
        result[rand] = result[index];
        result[index] = value;
    }
    result.length = n;
    return result;
}
/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */ function $336d3dfe62d84a74$var$shuffle(collection) {
    return $336d3dfe62d84a74$var$sampleSize(collection, $336d3dfe62d84a74$var$MAX_ARRAY_LENGTH);
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $336d3dfe62d84a74$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function $336d3dfe62d84a74$var$isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return $336d3dfe62d84a74$var$isArrayLikeObject(value) && $336d3dfe62d84a74$var$hasOwnProperty.call(value, 'callee') && (!$336d3dfe62d84a74$var$propertyIsEnumerable.call(value, 'callee') || $336d3dfe62d84a74$var$objectToString.call(value) == $336d3dfe62d84a74$var$argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $336d3dfe62d84a74$var$isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $336d3dfe62d84a74$var$isArrayLike(value) {
    return value != null && $336d3dfe62d84a74$var$isLength(value.length) && !$336d3dfe62d84a74$var$isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $336d3dfe62d84a74$var$isArrayLikeObject(value) {
    return $336d3dfe62d84a74$var$isObjectLike(value) && $336d3dfe62d84a74$var$isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $336d3dfe62d84a74$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $336d3dfe62d84a74$var$isObject(value) ? $336d3dfe62d84a74$var$objectToString.call(value) : '';
    return tag == $336d3dfe62d84a74$var$funcTag || tag == $336d3dfe62d84a74$var$genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $336d3dfe62d84a74$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $336d3dfe62d84a74$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $336d3dfe62d84a74$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $336d3dfe62d84a74$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $336d3dfe62d84a74$var$isString(value) {
    return typeof value == 'string' || !$336d3dfe62d84a74$var$isArray(value) && $336d3dfe62d84a74$var$isObjectLike(value) && $336d3dfe62d84a74$var$objectToString.call(value) == $336d3dfe62d84a74$var$stringTag;
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $336d3dfe62d84a74$var$isSymbol(value) {
    return typeof value == 'symbol' || $336d3dfe62d84a74$var$isObjectLike(value) && $336d3dfe62d84a74$var$objectToString.call(value) == $336d3dfe62d84a74$var$symbolTag;
}
/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */ function $336d3dfe62d84a74$var$toArray(value) {
    if (!value) return [];
    if ($336d3dfe62d84a74$var$isArrayLike(value)) return $336d3dfe62d84a74$var$isString(value) ? $336d3dfe62d84a74$var$stringToArray(value) : $336d3dfe62d84a74$var$copyArray(value);
    if ($336d3dfe62d84a74$var$iteratorSymbol && value[$336d3dfe62d84a74$var$iteratorSymbol]) return $336d3dfe62d84a74$var$iteratorToArray(value[$336d3dfe62d84a74$var$iteratorSymbol]());
    var tag = $336d3dfe62d84a74$var$getTag(value), func = tag == $336d3dfe62d84a74$var$mapTag ? $336d3dfe62d84a74$var$mapToArray : tag == $336d3dfe62d84a74$var$setTag ? $336d3dfe62d84a74$var$setToArray : $336d3dfe62d84a74$var$values;
    return func(value);
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $336d3dfe62d84a74$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $336d3dfe62d84a74$var$toNumber(value);
    if (value === $336d3dfe62d84a74$var$INFINITY || value === -$336d3dfe62d84a74$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $336d3dfe62d84a74$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $336d3dfe62d84a74$var$toInteger(value) {
    var result = $336d3dfe62d84a74$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $336d3dfe62d84a74$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($336d3dfe62d84a74$var$isSymbol(value)) return $336d3dfe62d84a74$var$NAN;
    if ($336d3dfe62d84a74$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $336d3dfe62d84a74$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($336d3dfe62d84a74$var$reTrim, '');
    var isBinary = $336d3dfe62d84a74$var$reIsBinary.test(value);
    return isBinary || $336d3dfe62d84a74$var$reIsOctal.test(value) ? $336d3dfe62d84a74$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $336d3dfe62d84a74$var$reIsBadHex.test(value) ? $336d3dfe62d84a74$var$NAN : +value;
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $336d3dfe62d84a74$var$keys(object) {
    return $336d3dfe62d84a74$var$isArrayLike(object) ? $336d3dfe62d84a74$var$arrayLikeKeys(object) : $336d3dfe62d84a74$var$baseKeys(object);
}
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $336d3dfe62d84a74$var$values(object) {
    return object ? $336d3dfe62d84a74$var$baseValues(object, $336d3dfe62d84a74$var$keys(object)) : [];
}
$336d3dfe62d84a74$exports = $336d3dfe62d84a74$var$shuffle;


/* eslint-disable @repo/internal/react/require-jsdoc */ var $66bbf3a923e23145$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};


var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");

var $9dOvm = parcelRequire("9dOvm");
var $6540c7204bb86f70$var$_process, $6540c7204bb86f70$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $6540c7204bb86f70$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($6540c7204bb86f70$var$_process = globalThis.process) === null || $6540c7204bb86f70$var$_process === void 0 || ($6540c7204bb86f70$var$_process = $6540c7204bb86f70$var$_process.env) === null || $6540c7204bb86f70$var$_process === void 0 ? void 0 : $6540c7204bb86f70$var$_process.JEST_WORKER_ID) !== undefined;
var $6540c7204bb86f70$var$DEBUG_MODE = !$6540c7204bb86f70$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($6540c7204bb86f70$var$_process2 = globalThis.process) === null || $6540c7204bb86f70$var$_process2 === void 0 || ($6540c7204bb86f70$var$_process2 = $6540c7204bb86f70$var$_process2.env) === null || $6540c7204bb86f70$var$_process2 === void 0 ? void 0 : $6540c7204bb86f70$var$_process2.NODE_ENV) !== 'production';
var $6540c7204bb86f70$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$6540c7204bb86f70$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $8ca1301ce5ac43fe$var$pkgName = '@atlaskit/platform-feature-flags';
var $8ca1301ce5ac43fe$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $8ca1301ce5ac43fe$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $8ca1301ce5ac43fe$var$ENV_ENABLE_PLATFORM_FF = $8ca1301ce5ac43fe$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $8ca1301ce5ac43fe$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $8ca1301ce5ac43fe$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $8ca1301ce5ac43fe$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $8ca1301ce5ac43fe$var$ENV_ENABLE_PLATFORM_FF || $8ca1301ce5ac43fe$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $8ca1301ce5ac43fe$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $8ca1301ce5ac43fe$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$8ca1301ce5ac43fe$var$globalVar[$8ca1301ce5ac43fe$export$7e41b1b2bdee3f98] = $8ca1301ce5ac43fe$var$globalVar[$8ca1301ce5ac43fe$export$7e41b1b2bdee3f98] || $8ca1301ce5ac43fe$var$DEFAULT_PFF_GLOBAL;
function $8ca1301ce5ac43fe$export$f2b591175b3e424c(resolver) {
    $8ca1301ce5ac43fe$var$globalVar[$8ca1301ce5ac43fe$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $8ca1301ce5ac43fe$export$6333b6aff9fc6275(flagKey) {
    if ($8ca1301ce5ac43fe$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $6540c7204bb86f70$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $8ca1301ce5ac43fe$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $8ca1301ce5ac43fe$var$globalVar[$8ca1301ce5ac43fe$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $8ca1301ce5ac43fe$var$globalVar[$8ca1301ce5ac43fe$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $9dOvm.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $8ca1301ce5ac43fe$var$globalVar[$8ca1301ce5ac43fe$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $77b9d880a5d24b37$export$ba05d765b8392e5e(flagResolver) {
    (0, $8ca1301ce5ac43fe$export$f2b591175b3e424c)(flagResolver);
}
function $77b9d880a5d24b37$export$470e5c2be1411c89(name) {
    return (0, $8ca1301ce5ac43fe$export$6333b6aff9fc6275)(name);
}
function $77b9d880a5d24b37$export$b40ec24ac8275656(name) {
    return (0, $8ca1301ce5ac43fe$export$6333b6aff9fc6275)(name);
}



var $3ZMUU = parcelRequire("3ZMUU");
var $41e10ad6d9a491e4$var$_process$env;
/// <reference types="node" />
var $41e10ad6d9a491e4$var$_default_1 = typeof $3ZMUU !== 'undefined' && $3ZMUU !== null && (($41e10ad6d9a491e4$var$_process$env = {}, $41e10ad6d9a491e4$var$_process$env === void 0) ? void 0 : $41e10ad6d9a491e4$var$_process$env['ANALYTICS_NEXT_MODERN_CONTEXT']);
var $41e10ad6d9a491e4$export$2e2bcd8739ae039 = $41e10ad6d9a491e4$var$_default_1;



var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $8vJ0V = parcelRequire("8vJ0V");

var $iyyOp = parcelRequire("iyyOp");
function $2680bc82fb97f20a$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $2680bc82fb97f20a$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $2680bc82fb97f20a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2680bc82fb97f20a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $2680bc82fb97f20a$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).func
};
var $2680bc82fb97f20a$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $2680bc82fb97f20a$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsContext);
        _this = $2680bc82fb97f20a$var$_callSuper(this, AnalyticsContext, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $2680bc82fb97f20a$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $2680bc82fb97f20a$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(AnalyticsContext, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iyyOp.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
}((0, $5FkrB.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2680bc82fb97f20a$var$AnalyticsContext, "contextTypes", $2680bc82fb97f20a$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($2680bc82fb97f20a$var$AnalyticsContext, "childContextTypes", $2680bc82fb97f20a$var$ContextTypes);
var $2680bc82fb97f20a$export$2e2bcd8739ae039 = $2680bc82fb97f20a$var$AnalyticsContext;



var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $bc1ff720bb91204a$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};



var $5FkrB = parcelRequire("5FkrB");
var $de4744f6e056f3b6$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


var $3e78c8693dc0b7d8$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $de4744f6e056f3b6$export$1d27a74659855e44)(data);
    var _useAnalyticsContext = (0, $bc1ff720bb91204a$export$d1f587f82ad51c4)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $5FkrB.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $5FkrB.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iyyOp.default).Provider, {
        value: value
    }, children);
};
var $3e78c8693dc0b7d8$export$2e2bcd8739ae039 = $3e78c8693dc0b7d8$var$AnalyticsContext;


var $61f72de07f015ffa$var$AnalyticsContext = function AnalyticsContext(props) {
    var isModernContext = (0, $41e10ad6d9a491e4$export$2e2bcd8739ae039) || (0, $77b9d880a5d24b37$export$b40ec24ac8275656)('analytics-next-use-legacy-context') === false;
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3e78c8693dc0b7d8$export$2e2bcd8739ae039), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $2680bc82fb97f20a$export$2e2bcd8739ae039), props);
};
var $61f72de07f015ffa$export$2e2bcd8739ae039 = $61f72de07f015ffa$var$AnalyticsContext;


var $2b64717bfa6e5a5b$var$_excluded = [
    "analyticsContext"
];
function $2b64717bfa6e5a5b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2b64717bfa6e5a5b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2b64717bfa6e5a5b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2b64717bfa6e5a5b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2b64717bfa6e5a5b$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $2b64717bfa6e5a5b$var$_excluded);
            var analyticsData = (0, $5FkrB.useMemo)(function() {
                return $2b64717bfa6e5a5b$var$_objectSpread($2b64717bfa6e5a5b$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $61f72de07f015ffa$export$2e2bcd8739ae039), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
                ref: ref
            })));
        });
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $2b64717bfa6e5a5b$export$2e2bcd8739ae039 = $2b64717bfa6e5a5b$var$withAnalyticsContext;


var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $f62ba9f613eab87a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f62ba9f613eab87a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f62ba9f613eab87a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f62ba9f613eab87a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f62ba9f613eab87a$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $f62ba9f613eab87a$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $f62ba9f613eab87a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $f62ba9f613eab87a$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $f62ba9f613eab87a$var$_objectSpread($f62ba9f613eab87a$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $83c4218f3207afbf$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $83c4218f3207afbf$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $83c4218f3207afbf$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($83c4218f3207afbf$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $83c4218f3207afbf$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $83c4218f3207afbf$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $83c4218f3207afbf$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $83c4218f3207afbf$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $83c4218f3207afbf$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $83c4218f3207afbf$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $f62ba9f613eab87a$export$2e2bcd8739ae039));



function $42c62ab2cf3781ce$export$5bf35293e545f20c() {
    var analyticsContext = (0, $bc1ff720bb91204a$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $83c4218f3207afbf$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

function $d4608622a6f13739$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d4608622a6f13739$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d4608622a6f13739$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d4608622a6f13739$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d4608622a6f13739$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $42c62ab2cf3781ce$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $5FkrB.useRef)({});
    var patchedProps = (0, $5FkrB.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $d4608622a6f13739$var$_objectSpread($d4608622a6f13739$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $d4608622a6f13739$var$_objectSpread($d4608622a6f13739$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}


var $ca50b4d958b734a9$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
            var _usePatchedProps = (0, $d4608622a6f13739$export$9ebb5a84d17e5d18)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $42c62ab2cf3781ce$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $ca50b4d958b734a9$export$2e2bcd8739ae039 = $ca50b4d958b734a9$var$withAnalyticsEvents;



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");
/* select.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");
parcelRequire("dujqE");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $fC8ib = parcelRequire("fC8ib");

var $kplgf = parcelRequire("kplgf");

var $5FkrB = parcelRequire("5FkrB");
function $a05a369e5fc6d009$var$testPlatform(re) {
    var _userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_userAgentData = window.navigator['userAgentData']) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || window.navigator.platform) : false;
}
function $a05a369e5fc6d009$var$isIPhone() {
    return $a05a369e5fc6d009$var$testPlatform(/^iPhone/i);
}
function $a05a369e5fc6d009$var$isIPad() {
    return $a05a369e5fc6d009$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $a05a369e5fc6d009$var$isMac() && navigator.maxTouchPoints > 1;
}
function $a05a369e5fc6d009$var$isMac() {
    return $a05a369e5fc6d009$var$testPlatform(/^Mac/i);
}
function $a05a369e5fc6d009$var$isIOS() {
    return $a05a369e5fc6d009$var$isIPhone() || $a05a369e5fc6d009$var$isIPad();
}
function $a05a369e5fc6d009$export$e1865c3bedcd822b() {
    return $a05a369e5fc6d009$var$isMac() || $a05a369e5fc6d009$var$isIOS();
}


function $56c8837ddb74a576$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use;
        var ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}


/**
 * An empty function which does nothing.
 */ function $f9d235c635a41ace$export$2e2bcd8739ae039() {}



var $9dOvm = parcelRequire("9dOvm");
var $efbf2a7c278db428$var$_process, $efbf2a7c278db428$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $efbf2a7c278db428$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($efbf2a7c278db428$var$_process = globalThis.process) === null || $efbf2a7c278db428$var$_process === void 0 || ($efbf2a7c278db428$var$_process = $efbf2a7c278db428$var$_process.env) === null || $efbf2a7c278db428$var$_process === void 0 ? void 0 : $efbf2a7c278db428$var$_process.JEST_WORKER_ID) !== undefined;
var $efbf2a7c278db428$var$DEBUG_MODE = !$efbf2a7c278db428$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($efbf2a7c278db428$var$_process2 = globalThis.process) === null || $efbf2a7c278db428$var$_process2 === void 0 || ($efbf2a7c278db428$var$_process2 = $efbf2a7c278db428$var$_process2.env) === null || $efbf2a7c278db428$var$_process2 === void 0 ? void 0 : $efbf2a7c278db428$var$_process2.NODE_ENV) !== 'production';
var $efbf2a7c278db428$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$efbf2a7c278db428$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $01990eb1bade285f$var$pkgName = '@atlaskit/platform-feature-flags';
var $01990eb1bade285f$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $01990eb1bade285f$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $01990eb1bade285f$var$ENV_ENABLE_PLATFORM_FF = $01990eb1bade285f$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $01990eb1bade285f$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $01990eb1bade285f$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $01990eb1bade285f$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $01990eb1bade285f$var$ENV_ENABLE_PLATFORM_FF || $01990eb1bade285f$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $01990eb1bade285f$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $01990eb1bade285f$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$01990eb1bade285f$var$globalVar[$01990eb1bade285f$export$7e41b1b2bdee3f98] = $01990eb1bade285f$var$globalVar[$01990eb1bade285f$export$7e41b1b2bdee3f98] || $01990eb1bade285f$var$DEFAULT_PFF_GLOBAL;
function $01990eb1bade285f$export$f2b591175b3e424c(resolver) {
    $01990eb1bade285f$var$globalVar[$01990eb1bade285f$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $01990eb1bade285f$export$6333b6aff9fc6275(flagKey) {
    if ($01990eb1bade285f$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $efbf2a7c278db428$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $01990eb1bade285f$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $01990eb1bade285f$var$globalVar[$01990eb1bade285f$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $01990eb1bade285f$var$globalVar[$01990eb1bade285f$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $9dOvm.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $01990eb1bade285f$var$globalVar[$01990eb1bade285f$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $f366b43c8bc426de$export$ba05d765b8392e5e(flagResolver) {
    (0, $01990eb1bade285f$export$f2b591175b3e424c)(flagResolver);
}
function $f366b43c8bc426de$export$470e5c2be1411c89(name) {
    return (0, $01990eb1bade285f$export$6333b6aff9fc6275)(name);
}
function $f366b43c8bc426de$export$b40ec24ac8275656(name) {
    return (0, $01990eb1bade285f$export$6333b6aff9fc6275)(name);
}


/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $7c03f6656844599b$export$f4da216a6ca54656 = function formatGroupLabel(group) {
    return group.label;
};

/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $40a615bc6e150de0$export$dac6ace3020563ca = function getOptionLabel(option) {
    return option.label;
};

/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $3aa0d68e1ea1ddc1$export$40be908210c5a79c = function getOptionValue(option) {
    return option.value;
};

/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $f80ef9501f701871$export$56bd0c8d90db075 = function isOptionDisabled(option) {
    return !!option.isDisabled;
};



var $25nEq = parcelRequire("25nEq");
/* indicators-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");

var $kplgf = parcelRequire("kplgf");
const $865d2b574ca8ba08$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $kplgf.default)(actualStyles);
};


var $ac9e6827c3316393$export$26417cabd806a658 = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};


var $bc12c8b5d0aba571$var$indicatorContainerStyles = null;
var $bc12c8b5d0aba571$export$d0ffd7e649cab6f = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $ac9e6827c3316393$export$26417cabd806a658)(props, 'indicatorsContainer', {
        indicators: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $kplgf.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $865d2b574ca8ba08$export$a274e22fb40f762e)(className, xcss, '-IndicatorsContainer')
        ])
    }, innerProps), children);
};


/* multi-value-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");

var $498272d93eb16769$var$multiValueStyles = {
    root: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _1e0c1txw _1ul9ze3t _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _bfhk1j9a _p12f1osq _syazi7uo _3yq3glyw",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk15s3 _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
var $498272d93eb16769$export$cf9cf2a30a59265c = function MultiValueContainer(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isFocused = _ref.isFocused, isDisabled = _ref.isDisabled, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $kplgf.default)([
            $498272d93eb16769$var$multiValueStyles.root,
            isDisabled && $498272d93eb16769$var$multiValueStyles.disabled,
            isFocused && $498272d93eb16769$var$multiValueStyles.focused,
            (0, $865d2b574ca8ba08$export$a274e22fb40f762e)(className, xcss, '-multiValue')
        ])
    }), children);
};


/* select-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");


var $9ddf52c777f4b036$var$containerStyles = {
    default: "_11c81d4k _kqswh2mm _lcxv1rj4 _1tn2fhey",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf"
};
var $9ddf52c777f4b036$export$446eebadefe1123b = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl, xcss = props.xcss;
    var _getStyleProps = (0, $ac9e6827c3316393$export$26417cabd806a658)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), className = _getStyleProps.className, css = _getStyleProps.css;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $kplgf.default)([
            $9ddf52c777f4b036$var$containerStyles.default,
            isRtl && $9ddf52c777f4b036$var$containerStyles.rtl,
            isDisabled && $9ddf52c777f4b036$var$containerStyles.disabled,
            (0, $865d2b574ca8ba08$export$a274e22fb40f762e)(className, xcss, '-container')
        ]),
        style: css
    }, innerProps), children);
};


/* value-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");



var $89d4f4b87f906dc6$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _y4ti12x7 _bozg12x7",
    verticalPaddingStandard: "_1q51v77o _85i5v77o",
    verticalPaddingTagUpliftMulti: "_1q511b66 _85i51b66",
    verticalPaddingTagUpliftCompactMulti: "_1q51v77o _85i5v77o",
    verticalPaddingCompactNonUplift: "_1q51ze3t _85i5ze3t",
    flex: "_1e0c1txw",
    flexWithGap: "_zulp1b66 _1e0c1txw _1n261g80"
};
var $89d4f4b87f906dc6$export$4dc9f58ad9a1a000 = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue, isCompact = props.isCompact, xcss = props.xcss, controlShouldRenderValue = props.selectProps.controlShouldRenderValue;
    var _getStyleProps = (0, $ac9e6827c3316393$export$26417cabd806a658)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    var ffTagUplifts = (0, $f366b43c8bc426de$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts');
    var tagUpliftMultiVertical = ffTagUplifts && isMulti;
    var tagUpliftChipRow = ffTagUplifts && isMulti && hasValue && controlShouldRenderValue;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $kplgf.default)([
            $89d4f4b87f906dc6$var$valueContainerStyles.default,
            tagUpliftMultiVertical && isCompact && $89d4f4b87f906dc6$var$valueContainerStyles.verticalPaddingTagUpliftCompactMulti,
            tagUpliftMultiVertical && !isCompact && $89d4f4b87f906dc6$var$valueContainerStyles.verticalPaddingTagUpliftMulti,
            !tagUpliftMultiVertical && !isCompact && $89d4f4b87f906dc6$var$valueContainerStyles.verticalPaddingStandard,
            !tagUpliftMultiVertical && isCompact && $89d4f4b87f906dc6$var$valueContainerStyles.verticalPaddingCompactNonUplift,
            isMulti && hasValue && controlShouldRenderValue && $89d4f4b87f906dc6$var$valueContainerStyles.flex,
            tagUpliftChipRow && $89d4f4b87f906dc6$var$valueContainerStyles.flexWithGap,
            (0, $865d2b574ca8ba08$export$a274e22fb40f762e)(className, xcss, '-ValueContainer')
        ]),
        style: css
    }, innerProps), children);
};


/* control.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");



var $c40f4e2f8ec9aafa$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkofajl _v564r5cv _1h6drsbi _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _15peftgi _1ke8ftgi _jaboglyw _1u6luvb6 _4cvxrsbi _123byq51 _d0altlke _irr3l4ek _1ogl1caj",
    defaultT26Shape: "_2rko1qi0",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsvyy1",
    disabled: "_1h6dby5v _lcxvglyw _bfhkby5v _1u6l1s3b",
    focused: "_1h6d1v1w _bfhkr01l _16qsvyy1 _1u6lvyy1 _4cvx1v1w _irr3r01l",
    subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
var $c40f4e2f8ec9aafa$var$Control = function Control(props) {
    var children = props.children, appearance = props.appearance, isCompact = props.isCompact, isDisabled = props.isDisabled, isFocused = props.isFocused, isInvalid = props.isInvalid, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen, xcss = props.xcss;
    var _getStyleProps = (0, $ac9e6827c3316393$export$26417cabd806a658)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: innerRef,
        className: (0, $kplgf.default)([
            $c40f4e2f8ec9aafa$var$styles.default,
            (0, $f366b43c8bc426de$export$b40ec24ac8275656)('platform-dst-shape-theme-default') && $c40f4e2f8ec9aafa$var$styles.defaultT26Shape,
            isDisabled && $c40f4e2f8ec9aafa$var$styles.disabled,
            isInvalid && $c40f4e2f8ec9aafa$var$styles.invalid,
            isCompact && $c40f4e2f8ec9aafa$var$styles.compact,
            appearance === 'subtle' && $c40f4e2f8ec9aafa$var$styles.subtle,
            appearance === 'subtle' && isFocused && $c40f4e2f8ec9aafa$var$styles.subtleFocused,
            isFocused && $c40f4e2f8ec9aafa$var$styles.focused,
            appearance === 'none' && $c40f4e2f8ec9aafa$var$styles.none,
            (0, $865d2b574ca8ba08$export$a274e22fb40f762e)(className, xcss, '-control')
        ]),
        style: css
    }, innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c40f4e2f8ec9aafa$export$2e2bcd8739ae039 = $c40f4e2f8ec9aafa$var$Control;


/* group.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");


var $53cf7edb74ae36f8$var$styles = {
    root: "_85i5u2gc _1q51u2gc"
};
var $53cf7edb74ae36f8$var$Group = function Group(props) {
    var children = props.children, builtinCX = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, selectProps = props.selectProps, xcss = props.xcss;
    var _getStyleProps = (0, $ac9e6827c3316393$export$26417cabd806a658)(props, 'group', {
        group: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $kplgf.default)([
            $53cf7edb74ae36f8$var$styles.root,
            (0, $865d2b574ca8ba08$export$a274e22fb40f762e)(className, xcss, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className, '-Group')
        ])
    }), label && /*#__PURE__*/ $5FkrB.createElement(Heading, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, headingProps, {
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: builtinCX
    }), label), /*#__PURE__*/ $5FkrB.createElement("div", null, children));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$53cf7edb74ae36f8$export$2e2bcd8739ae039 = $53cf7edb74ae36f8$var$Group;


/* group-heading.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");



var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");
var $12e456506e32e8b1$var$_excluded = [
    "className",
    "clearValue",
    "cx",
    "xcss",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue"
];
function $12e456506e32e8b1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $12e456506e32e8b1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $12e456506e32e8b1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $12e456506e32e8b1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $12e456506e32e8b1$export$8e9fd4287627890c = function cleanCommonProps(props) {
    //className
    var className = props.className, clearValue = props.clearValue, cx = props.cx, xcss = props.xcss, getStyles = props.getStyles, getClassNames = props.getClassNames, getValue = props.getValue, hasValue = props.hasValue, isMulti = props.isMulti, isRtl = props.isRtl, options = props.options, selectOption = props.selectOption, selectProps = props.selectProps, setValue = props.setValue, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $12e456506e32e8b1$var$_excluded);
    return $12e456506e32e8b1$var$_objectSpread({}, innerProps);
};


var $c385c892c3112915$var$_excluded = [
    "data"
];
var $c385c892c3112915$var$headingStyles = null;
var $c385c892c3112915$export$85c8b41a3cd87edc = function GroupHeading(props) {
    var xcss = props.xcss;
    var _cleanCommonProps = (0, $12e456506e32e8b1$export$8e9fd4287627890c)(props), data = _cleanCommonProps.data, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_cleanCommonProps, $c385c892c3112915$var$_excluded);
    var _getStyleProps = (0, $ac9e6827c3316393$export$26417cabd806a658)(props, 'groupHeading', {
        'group-heading': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $kplgf.default)([
            "_11c8wadc _1e0c1ule _syazazsu _80om73ad _k48pwu06 _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $865d2b574ca8ba08$export$a274e22fb40f762e)(className, xcss, '-group')
        ]),
        style: css
    }, innerProps));
};


/* clear-indicator.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");

var $22ee7b357a49397a$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3eb90e0e095210547df6d71f04e27a56>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($22ee7b357a49397a$exports, "__esModule", {
    value: true
});
$22ee7b357a49397a$exports.default = void 0;

var $22ee7b357a49397a$var$_react = $22ee7b357a49397a$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $22ee7b357a49397a$var$_baseNew = $22ee7b357a49397a$var$_interopRequireDefault((parcelRequire("k8BjC")));
function $22ee7b357a49397a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $22ee7b357a49397a$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $22ee7b357a49397a$var$_react.default.createElement($22ee7b357a49397a$var$_baseNew.default, Object.assign({
        name: "CrossCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$22ee7b357a49397a$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $22ee7b357a49397a$var$_default = $22ee7b357a49397a$exports.default = $22ee7b357a49397a$var$CrossCircleIcon;


/* pressable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");



var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $a1a0ad6d982c7338$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a1a0ad6d982c7338$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a1a0ad6d982c7338$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a1a0ad6d982c7338$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a1a0ad6d982c7338$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $a1a0ad6d982c7338$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $a1a0ad6d982c7338$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $a1a0ad6d982c7338$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $a1a0ad6d982c7338$var$_objectSpread($a1a0ad6d982c7338$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $f05b1007c2253420$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $f05b1007c2253420$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $f05b1007c2253420$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f05b1007c2253420$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $f05b1007c2253420$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $f05b1007c2253420$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $f05b1007c2253420$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $f05b1007c2253420$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $f05b1007c2253420$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $f05b1007c2253420$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $a1a0ad6d982c7338$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $2f6eb26ebbee4a9d$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $5938dadee29faf4e$export$5bf35293e545f20c() {
    var analyticsContext = (0, $2f6eb26ebbee4a9d$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $f05b1007c2253420$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $eb81cce7d400b79f$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $175352406893ebec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $175352406893ebec$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $175352406893ebec$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $175352406893ebec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $175352406893ebec$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $5938dadee29faf4e$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $eb81cce7d400b79f$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $eb81cce7d400b79f$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $175352406893ebec$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}





/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");
var $3963eec8dec07451$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $3963eec8dec07451$var$_excluded2 = [
    "className"
];
var $3963eec8dec07451$var$focusRingStyles = null;
var $3963eec8dec07451$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $3963eec8dec07451$var$Focusable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $3963eec8dec07451$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $3963eec8dec07451$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $kplgf.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $3963eec8dec07451$export$2e2bcd8739ae039 = $3963eec8dec07451$var$Focusable;


var $21ae1b99be8c2c1c$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $21ae1b99be8c2c1c$var$_excluded2 = [
    "className"
];
var $21ae1b99be8c2c1c$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $21ae1b99be8c2c1c$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $f9d235c635a41ace$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $21ae1b99be8c2c1c$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $4b5a5d40339b6fdb$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $175352406893ebec$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "19.0.1",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $21ae1b99be8c2c1c$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement((0, $3963eec8dec07451$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $56c8837ddb74a576$export$95df08bae54cb4df)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $865d2b574ca8ba08$export$a274e22fb40f762e)($21ae1b99be8c2c1c$var$styles.root, isDisabled && $21ae1b99be8c2c1c$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $21ae1b99be8c2c1c$export$2e2bcd8739ae039 = $21ae1b99be8c2c1c$var$Pressable;



var $23da9f503fee4d68$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _1q51v77o _y4tiv77o _85i5v77o _bozgv77o"
};
var $23da9f503fee4d68$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1rpy _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf"
};
var $23da9f503fee4d68$export$ecf9cf59142dd54a = function ClearIndicator(props) {
    var innerProps = props.innerProps, _props$clearControlLa = props.clearControlLabel, clearControlLabel = _props$clearControlLa === void 0 ? 'clear' : _props$clearControlLa, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $ac9e6827c3316393$export$26417cabd806a658)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $kplgf.default)([
            $23da9f503fee4d68$var$clearIndicatorStyles.default,
            isCompact && $23da9f503fee4d68$var$clearIndicatorStyles.compact,
            (0, $865d2b574ca8ba08$export$a274e22fb40f762e)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $21ae1b99be8c2c1c$export$2e2bcd8739ae039), {
        xcss: $23da9f503fee4d68$var$iconContainerStyles.root,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($22ee7b357a49397a$exports))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
};


/* dropdown-indicator.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");

var $c150c6015359071d$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($c150c6015359071d$exports, "__esModule", {
    value: true
});
$c150c6015359071d$exports.default = void 0;

var $c150c6015359071d$var$_react = $c150c6015359071d$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $c150c6015359071d$var$_baseNew = $c150c6015359071d$var$_interopRequireDefault((parcelRequire("k8BjC")));
function $c150c6015359071d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c150c6015359071d$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $c150c6015359071d$var$_react.default.createElement($c150c6015359071d$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$c150c6015359071d$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $c150c6015359071d$var$_default = $c150c6015359071d$exports.default = $c150c6015359071d$var$ChevronDownIcon;


/* inline.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");

/* flex.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");
var $2695cedaa453587e$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $2695cedaa453587e$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $2695cedaa453587e$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $2695cedaa453587e$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $2695cedaa453587e$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $2695cedaa453587e$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $2695cedaa453587e$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $2695cedaa453587e$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $2695cedaa453587e$var$Flex = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $2695cedaa453587e$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, ariaAttributes, {
        role: role,
        className: (0, $kplgf.default)([
            $2695cedaa453587e$var$styles.root,
            gap && $2695cedaa453587e$var$columnGapMap[gap],
            columnGap && $2695cedaa453587e$var$columnGapMap[columnGap],
            gap && $2695cedaa453587e$var$rowGapMap[gap],
            rowGap && $2695cedaa453587e$var$rowGapMap[rowGap],
            alignItems && $2695cedaa453587e$var$alignItemsMap[alignItems],
            direction && $2695cedaa453587e$var$flexDirectionMap[direction],
            justifyContent && $2695cedaa453587e$var$justifyContentMap[justifyContent],
            wrap && $2695cedaa453587e$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$2695cedaa453587e$var$Flex.displayName = 'Flex';
var $2695cedaa453587e$export$2e2bcd8739ae039 = $2695cedaa453587e$var$Flex;


var $bcf51d45413e6fcb$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $bcf51d45413e6fcb$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $bcf51d45413e6fcb$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $kplgf.default)([
            $bcf51d45413e6fcb$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $bcf51d45413e6fcb$var$Inline = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $bcf51d45413e6fcb$var$_excluded);
    var separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $5FkrB.createElement($bcf51d45413e6fcb$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $5FkrB.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $5FkrB.createElement((0, $2695cedaa453587e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $51c2ad1cc5d37be6$export$a274e22fb40f762e)(grow === 'hug' && $bcf51d45413e6fcb$var$styles.hug, grow === 'fill' && $bcf51d45413e6fcb$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$bcf51d45413e6fcb$var$Inline.displayName = 'Inline';
var $bcf51d45413e6fcb$export$2e2bcd8739ae039 = $bcf51d45413e6fcb$var$Inline;



var $e420c52a445c8c12$var$dropdownWrapperStyles = {
    root: "_1q5112x7 _y4ti12x7 _85i512x7 _bozg12x7"
};
var $e420c52a445c8c12$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syazazsu _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf",
    disabled: "_syaz1gmx"
};
var $e420c52a445c8c12$export$ec98719d3db7f2e4 = function DropdownIndicator(props) {
    var innerProps = props.innerProps, children = props.children, isDisabled = props.isDisabled, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $ac9e6827c3316393$export$26417cabd806a658)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $kplgf.default)([
            $e420c52a445c8c12$var$dropdownStyles.default,
            isDisabled && $e420c52a445c8c12$var$dropdownStyles.disabled,
            isCompact && $e420c52a445c8c12$var$dropdownStyles.compact,
            (0, $865d2b574ca8ba08$export$a274e22fb40f762e)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), children ? children : /*#__PURE__*/ $5FkrB.createElement((0, $bcf51d45413e6fcb$export$2e2bcd8739ae039), {
        as: "span",
        xcss: $e420c52a445c8c12$var$dropdownWrapperStyles.root
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($c150c6015359071d$exports))), {
        color: "currentColor",
        label: "open",
        size: "small"
    })));
};


/* loading-indicator.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");

/* spinner.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kplgf = parcelRequire("kplgf");

var $5FkrB = parcelRequire("5FkrB");

var $91619096e141467f$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $bc6b39f2ac546666$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
var $bc6b39f2ac546666$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $bc6b39f2ac546666$var$loadIn = null;
var $bc6b39f2ac546666$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $bc6b39f2ac546666$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $bc6b39f2ac546666$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $91619096e141467f$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $bc6b39f2ac546666$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $4b5a5d40339b6fdb$export$2e2bcd8739ae039));
    $bc6b39f2ac546666$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $kplgf.default)([
            $bc6b39f2ac546666$var$styles.wrapperStyles,
            $bc6b39f2ac546666$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $kplgf.default)([
            $bc6b39f2ac546666$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $kplgf.default)([
            $bc6b39f2ac546666$var$styles.circleStyles
        ])
    })));
}));
var $bc6b39f2ac546666$export$2e2bcd8739ae039 = $bc6b39f2ac546666$var$Spinner;



var $8426adcf6875d21c$var$_excluded = [
    "innerProps",
    "isRtl",
    "size",
    "isCompact",
    "xcss"
];
function $8426adcf6875d21c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8426adcf6875d21c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8426adcf6875d21c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8426adcf6875d21c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8426adcf6875d21c$var$loadingIndicatorStyles = {
    default: "_1q5112x7 _y4tiu2gc _85i512x7 _bozgu2gc",
    compact: "_1q51idpf _85i5idpf"
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $8426adcf6875d21c$export$7c20be4c1d342248 = function LoadingIndicator(_ref) {
    var innerProps = _ref.innerProps, isRtl = _ref.isRtl, _ref$size = _ref.size, size = _ref$size === void 0 ? 4 : _ref$size, isCompact = _ref.isCompact, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $8426adcf6875d21c$var$_excluded);
    var _getStyleProps = (0, $ac9e6827c3316393$export$26417cabd806a658)($8426adcf6875d21c$var$_objectSpread($8426adcf6875d21c$var$_objectSpread({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $kplgf.default)([
            $8426adcf6875d21c$var$loadingIndicatorStyles.default,
            isCompact && $8426adcf6875d21c$var$loadingIndicatorStyles.compact,
            (0, $865d2b574ca8ba08$export$a274e22fb40f762e)(className, xcss, '-loadingIndicator')
        ])
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $bc6b39f2ac546666$export$2e2bcd8739ae039), {
        size: "small"
    }));
};


/* input.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");




var $6464be408c5bbddb$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName",
    "testId"
];
var $6464be408c5bbddb$var$inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
var $6464be408c5bbddb$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
var $6464be408c5bbddb$var$nativeInputStylesOld = null;
var $6464be408c5bbddb$var$nativeInputStyles = null;
var $6464be408c5bbddb$var$hidden = null;
var $6464be408c5bbddb$var$Input = function Input(props) {
    var builtinCX = props.cx, value = props.value, xcss = props.xcss, isMulti = props.isMulti;
    var _cleanCommonProps = (0, $12e456506e32e8b1$export$8e9fd4287627890c)(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, testId = _cleanCommonProps.testId, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_cleanCommonProps, $6464be408c5bbddb$var$_excluded);
    var dataId = testId ? "".concat(testId, "-select--input") : null;
    var _getStyleProps = (0, $ac9e6827c3316393$export$26417cabd806a658)(props, 'input', {
        'input-container': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    var ffTagUplifts = (0, $f366b43c8bc426de$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts');
    if ((0, $f366b43c8bc426de$export$b40ec24ac8275656)('platform_fix_input_component_styling')) return /*#__PURE__*/ $5FkrB.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $kplgf.default)([
            $6464be408c5bbddb$var$inputStyles.root,
            isMulti && ffTagUplifts && $6464be408c5bbddb$var$inputStyles.labellingFFStyles,
            isDisabled && $6464be408c5bbddb$var$inputStyles.disabled,
            (0, $865d2b574ca8ba08$export$a274e22fb40f762e)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $kplgf.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $kplgf.default)([
            $6464be408c5bbddb$var$inputStylesOld.root,
            isMulti && ffTagUplifts && $6464be408c5bbddb$var$inputStylesOld.labellingFFStyles,
            isDisabled && $6464be408c5bbddb$var$inputStylesOld.disabled,
            (0, $865d2b574ca8ba08$export$a274e22fb40f762e)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $kplgf.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6464be408c5bbddb$export$2e2bcd8739ae039 = $6464be408c5bbddb$var$Input;


/* menu.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");



var $195c12e5177a207f$var$menuStyles = {
    root: "_2rko12b0 _kqswstnw _1bsb1osq _1pbykb7n _6rthu2gc _1pfhu2gc _bfhk1bhr _16qs130s",
    rootT26Shape: "_2rko1mok",
    bottom: "_152t1osq",
    top: "_u7co1osq"
};
var $195c12e5177a207f$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottom' : _props$placement, xcss = props.xcss;
    var _getStyleProps = (0, $ac9e6827c3316393$export$26417cabd806a658)(props, 'menu', {
        menu: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $kplgf.default)([
            $195c12e5177a207f$var$menuStyles.root,
            $195c12e5177a207f$var$menuStyles[placement],
            (0, $f366b43c8bc426de$export$b40ec24ac8275656)('platform-dst-shape-theme-default') && $195c12e5177a207f$var$menuStyles.rootT26Shape,
            (0, $865d2b574ca8ba08$export$a274e22fb40f762e)(xcss, className, '-menu')
        ]),
        style: css,
        ref: innerRef
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$195c12e5177a207f$export$2e2bcd8739ae039 = $195c12e5177a207f$var$Menu;


/* menu-list.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");


function $6e7391b418742df6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6e7391b418742df6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6e7391b418742df6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6e7391b418742df6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6e7391b418742df6$var$menuListStyles = null;
var $6e7391b418742df6$export$d4c4e98c5044dc8 = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti, maxHeight = props.maxHeight, xcss = props.xcss;
    var _getStyleProps = (0, $ac9e6827c3316393$export$26417cabd806a658)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $kplgf.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $865d2b574ca8ba08$export$a274e22fb40f762e)(className, xcss, '-MenuList')
        ]),
        style: $6e7391b418742df6$var$_objectSpread($6e7391b418742df6$var$_objectSpread({}, css), {}, {
            maxHeight: maxHeight
        }),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};


/* menu-loading-message.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");

/* text.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");

var $afMOk = parcelRequire("afMOk");

var $5FkrB = parcelRequire("5FkrB");
var $1f8dbd7d91f9c6c2$var$HasTextAncestorContext = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $1f8dbd7d91f9c6c2$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $5FkrB.useContext)($1f8dbd7d91f9c6c2$var$HasTextAncestorContext);
};
var $1f8dbd7d91f9c6c2$export$ae933c6cbe5643ad = $1f8dbd7d91f9c6c2$var$HasTextAncestorContext.Provider;



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $33950a43c5bfd2f0$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');


var $8407c88bdc456fbd$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)((0, $33950a43c5bfd2f0$export$1ca2a26fecb070ae));
};
(0, $33950a43c5bfd2f0$export$1ca2a26fecb070ae).displayName = 'SurfaceProvider';


var $3e631f986b84a440$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $3e631f986b84a440$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $8407c88bdc456fbd$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($3e631f986b84a440$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $3e631f986b84a440$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $3e631f986b84a440$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $3e631f986b84a440$var$fontSizeMap = {
    medium: "_11c8fhey",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $3e631f986b84a440$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $3e631f986b84a440$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
var $3e631f986b84a440$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $3e631f986b84a440$var$Text = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $afMOk.default)($3e631f986b84a440$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $1f8dbd7d91f9c6c2$export$9322276ec105d055)();
    var color = $3e631f986b84a440$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        className: (0, $kplgf.default)([
            $3e631f986b84a440$var$styles.root,
            size && $3e631f986b84a440$var$fontSizeMap[size],
            color && $3e631f986b84a440$var$textColorMap[color],
            maxLines && $3e631f986b84a440$var$styles.truncation,
            maxLines === 1 && $3e631f986b84a440$var$styles.breakAll,
            align && $3e631f986b84a440$var$styles["textAlign.".concat(align)],
            weight && $3e631f986b84a440$var$fontWeightMap[weight],
            Component === 'em' && $3e631f986b84a440$var$styles['as.em'],
            Component === 'strong' && $3e631f986b84a440$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $5FkrB.createElement((0, $1f8dbd7d91f9c6c2$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$3e631f986b84a440$export$2e2bcd8739ae039 = $3e631f986b84a440$var$Text;



var $3c26ff6e56099c2b$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
];
function $3c26ff6e56099c2b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3c26ff6e56099c2b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3c26ff6e56099c2b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3c26ff6e56099c2b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3c26ff6e56099c2b$var$noticeStyles = null;
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $3c26ff6e56099c2b$export$e928a71d039d3102 = function LoadingMessage(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? 'Loading...' : _ref$children, innerProps = _ref.innerProps, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $3c26ff6e56099c2b$var$_excluded);
    var _getStyleProps = (0, $ac9e6827c3316393$export$26417cabd806a658)($3c26ff6e56099c2b$var$_objectSpread($3c26ff6e56099c2b$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $kplgf.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $865d2b574ca8ba08$export$a274e22fb40f762e)(className, xcss, '-LoadingMessage')
        ]),
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option"
    }), /*#__PURE__*/ $5FkrB.createElement((0, $3e631f986b84a440$export$2e2bcd8739ae039), {
        color: "color.text.subtle"
    }, children));
};


/* menu-no-options-message.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");



var $30ea6eca843fb406$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
];
function $30ea6eca843fb406$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $30ea6eca843fb406$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $30ea6eca843fb406$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $30ea6eca843fb406$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $30ea6eca843fb406$var$noticeStyles = null;
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $30ea6eca843fb406$export$d58b72b7d3c4072c = function NoOptionsMessage(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? 'No options' : _ref$children, innerProps = _ref.innerProps, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $30ea6eca843fb406$var$_excluded);
    var _getStyleProps = (0, $ac9e6827c3316393$export$26417cabd806a658)($30ea6eca843fb406$var$_objectSpread($30ea6eca843fb406$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $kplgf.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $865d2b574ca8ba08$export$a274e22fb40f762e)(className, xcss, '-NoOptionsMessage')
        ]),
        style: css,
        role: "option"
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $3e631f986b84a440$export$2e2bcd8739ae039), {
        color: "color.text.subtle"
    }, children));
};


/* menu-portal.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");


var $6I9SI = parcelRequire("6I9SI");

var $aLeHs = parcelRequire("aLeHs");


var $5FkrB = parcelRequire("5FkrB");
var $54783dc573eaff35$export$e001f626511a0ead = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $3752472734d435ca$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3752472734d435ca$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3752472734d435ca$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3752472734d435ca$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3752472734d435ca$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
var $3752472734d435ca$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $3752472734d435ca$var$menuPortalStyles = {
    root: "_1pbykb7n _1e02a1vk _kqswcp1v _152t1nmo _1bsb1qxj"
};
var $3752472734d435ca$export$793392f970497feb = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, xcss = props.xcss;
    var menuPortalRef = (0, $5FkrB.useRef)(null);
    var cleanupRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)($3752472734d435ca$var$coercePlacement(menuPlacement)), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), placement = _useState2[0], setPortalPlacement = _useState2[1];
    var portalPlacementContext = (0, $5FkrB.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState3 = (0, $5FkrB.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), computedPosition = _useState4[0], setComputedPosition = _useState4[1];
    var updateComputedPosition = (0, $5FkrB.useCallback)(function() {
        if (!controlElement) return;
        var rect = $3752472734d435ca$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $5FkrB.useLayoutEffect)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $5FkrB.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $6I9SI.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $5FkrB.useLayoutEffect)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $5FkrB.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    var _getStyleProps = (0, $ac9e6827c3316393$export$26417cabd806a658)($3752472734d435ca$var$_objectSpread($3752472734d435ca$var$_objectSpread({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    // same wrapper element whether fixed or portalled
    var menuWrapper = /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $kplgf.default)([
            $3752472734d435ca$var$menuPortalStyles.root,
            (0, $865d2b574ca8ba08$export$a274e22fb40f762e)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: $3752472734d435ca$var$_objectSpread({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': "".concat(computedPosition.rect.left, "px"),
            '--menu-position': menuPosition,
            '--menu-top': "".concat(computedPosition.offset, "px"),
            '--menu-width': "".concat(computedPosition.rect.width, "px")
        }, css)
    }, innerProps), children);
    return /*#__PURE__*/ $5FkrB.createElement((0, $54783dc573eaff35$export$e001f626511a0ead).Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $aLeHs.createPortal)(menuWrapper, appendTo) : menuWrapper);
};


/* multi-value.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $25nEq = parcelRequire("25nEq");

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");


/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $25nEq = parcelRequire("25nEq");

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $7NBLq = parcelRequire("7NBLq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $5f510ed1119260df$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5f510ed1119260df$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5f510ed1119260df$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5f510ed1119260df$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5f510ed1119260df$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $5f510ed1119260df$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $5f510ed1119260df$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $5f510ed1119260df$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $5f510ed1119260df$var$_objectSpread($5f510ed1119260df$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $066f0f689b0ee353$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $066f0f689b0ee353$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $066f0f689b0ee353$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($066f0f689b0ee353$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $066f0f689b0ee353$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $066f0f689b0ee353$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $066f0f689b0ee353$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $066f0f689b0ee353$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $066f0f689b0ee353$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $066f0f689b0ee353$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $5f510ed1119260df$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $471322728b8df9ad$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $b36a9016275e3e9c$export$5bf35293e545f20c() {
    var analyticsContext = (0, $471322728b8df9ad$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $066f0f689b0ee353$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $f7b395006a91e5c4$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


var $ae38a13ac3cadf40$export$53c2b9c37c40e0d8 = function useCallbackWithAnalytics(method, payload, channel) {
    var _useAnalyticsEvents = (0, $b36a9016275e3e9c$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var methodRef = (0, $f7b395006a91e5c4$export$1d27a74659855e44)(method);
    var payloadRef = (0, $f7b395006a91e5c4$export$1d27a74659855e44)(payload);
    return (0, $5FkrB.useCallback)(function() {
        var pload = typeof payloadRef.current === 'function' ? payloadRef.current.apply(payloadRef, arguments) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current.apply(methodRef, arguments);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};



var $ekGgq = parcelRequire("ekGgq");
function $68b8a88b732414bf$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref) === 'object') ref.current = value;
        });
    };
}


/**
 * An empty function which does nothing.
 */ function $784ecc28b84f92e1$export$2e2bcd8739ae039() {}


/* lozenge.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $7NBLq = parcelRequire("7NBLq");

var $9dOvm = parcelRequire("9dOvm");
var $a401c7f286a1cae1$var$_process, $a401c7f286a1cae1$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $a401c7f286a1cae1$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($a401c7f286a1cae1$var$_process = globalThis.process) === null || $a401c7f286a1cae1$var$_process === void 0 || ($a401c7f286a1cae1$var$_process = $a401c7f286a1cae1$var$_process.env) === null || $a401c7f286a1cae1$var$_process === void 0 ? void 0 : $a401c7f286a1cae1$var$_process.JEST_WORKER_ID) !== undefined;
var $a401c7f286a1cae1$var$DEBUG_MODE = !$a401c7f286a1cae1$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($a401c7f286a1cae1$var$_process2 = globalThis.process) === null || $a401c7f286a1cae1$var$_process2 === void 0 || ($a401c7f286a1cae1$var$_process2 = $a401c7f286a1cae1$var$_process2.env) === null || $a401c7f286a1cae1$var$_process2 === void 0 ? void 0 : $a401c7f286a1cae1$var$_process2.NODE_ENV) !== 'production';
var $a401c7f286a1cae1$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$a401c7f286a1cae1$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $22ee1ad5c39041df$var$pkgName = '@atlaskit/platform-feature-flags';
var $22ee1ad5c39041df$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $22ee1ad5c39041df$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $22ee1ad5c39041df$var$ENV_ENABLE_PLATFORM_FF = $22ee1ad5c39041df$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $22ee1ad5c39041df$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $22ee1ad5c39041df$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $22ee1ad5c39041df$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $22ee1ad5c39041df$var$ENV_ENABLE_PLATFORM_FF || $22ee1ad5c39041df$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $22ee1ad5c39041df$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $22ee1ad5c39041df$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$22ee1ad5c39041df$var$globalVar[$22ee1ad5c39041df$export$7e41b1b2bdee3f98] = $22ee1ad5c39041df$var$globalVar[$22ee1ad5c39041df$export$7e41b1b2bdee3f98] || $22ee1ad5c39041df$var$DEFAULT_PFF_GLOBAL;
function $22ee1ad5c39041df$export$f2b591175b3e424c(resolver) {
    $22ee1ad5c39041df$var$globalVar[$22ee1ad5c39041df$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $22ee1ad5c39041df$export$6333b6aff9fc6275(flagKey) {
    if ($22ee1ad5c39041df$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $a401c7f286a1cae1$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $22ee1ad5c39041df$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $22ee1ad5c39041df$var$globalVar[$22ee1ad5c39041df$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $22ee1ad5c39041df$var$globalVar[$22ee1ad5c39041df$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $9dOvm.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $22ee1ad5c39041df$var$globalVar[$22ee1ad5c39041df$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $4dee22873f13f74d$export$ba05d765b8392e5e(flagResolver) {
    (0, $22ee1ad5c39041df$export$f2b591175b3e424c)(flagResolver);
}
function $4dee22873f13f74d$export$470e5c2be1411c89(name) {
    return (0, $22ee1ad5c39041df$export$6333b6aff9fc6275)(name);
}
function $4dee22873f13f74d$export$b40ec24ac8275656(name) {
    return (0, $22ee1ad5c39041df$export$6333b6aff9fc6275)(name);
}


/* lozenge.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

/* lozenge-base.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $25nEq = parcelRequire("25nEq");

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7NBLq = parcelRequire("7NBLq");
/* badge-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $afe8d2493aac17be$var$ATOMIC_GROUP_LENGTH = 5;
function $afe8d2493aac17be$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $afe8d2493aac17be$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


/* text.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");


var $afMOk = parcelRequire("afMOk");

var $5FkrB = parcelRequire("5FkrB");
var $b17c63bc868ede63$var$HasTextAncestorContext = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $b17c63bc868ede63$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $5FkrB.useContext)($b17c63bc868ede63$var$HasTextAncestorContext);
};
var $b17c63bc868ede63$export$ae933c6cbe5643ad = $b17c63bc868ede63$var$HasTextAncestorContext.Provider;



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $ddaa5e78be1a4705$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');


var $7ffc2204370f652b$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)((0, $ddaa5e78be1a4705$export$1ca2a26fecb070ae));
};
(0, $ddaa5e78be1a4705$export$1ca2a26fecb070ae).displayName = 'SurfaceProvider';


var $5774451cc1763ff6$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $5774451cc1763ff6$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $7ffc2204370f652b$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($5774451cc1763ff6$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $5774451cc1763ff6$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $5774451cc1763ff6$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $5774451cc1763ff6$var$fontSizeMap = {
    medium: "_11c8fhey",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $5774451cc1763ff6$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $5774451cc1763ff6$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
var $5774451cc1763ff6$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $5774451cc1763ff6$var$Text = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $afMOk.default)($5774451cc1763ff6$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $b17c63bc868ede63$export$9322276ec105d055)();
    var color = $5774451cc1763ff6$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        className: (0, $afe8d2493aac17be$export$2e2bcd8739ae039)([
            $5774451cc1763ff6$var$styles.root,
            size && $5774451cc1763ff6$var$fontSizeMap[size],
            color && $5774451cc1763ff6$var$textColorMap[color],
            maxLines && $5774451cc1763ff6$var$styles.truncation,
            maxLines === 1 && $5774451cc1763ff6$var$styles.breakAll,
            align && $5774451cc1763ff6$var$styles["textAlign.".concat(align)],
            weight && $5774451cc1763ff6$var$fontWeightMap[weight],
            Component === 'em' && $5774451cc1763ff6$var$styles['as.em'],
            Component === 'strong' && $5774451cc1763ff6$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $5FkrB.createElement((0, $b17c63bc868ede63$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$5774451cc1763ff6$export$2e2bcd8739ae039 = $5774451cc1763ff6$var$Text;



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $25nEq = parcelRequire("25nEq");
var $ebc74021cd1e7f0f$export$4ef52930e33717cd = 'data-theme';
var $ebc74021cd1e7f0f$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $ebc74021cd1e7f0f$export$a00eac3f8684bcd0 = 'data-color-mode';
var $ebc74021cd1e7f0f$export$2112803007239c61 = 'data-contrast-mode';
var $ebc74021cd1e7f0f$export$352e418ed5b6193a = 'data-custom-theme';
var $ebc74021cd1e7f0f$export$6f0c6fb8c80fcc92 = 'ds';
var $ebc74021cd1e7f0f$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $ebc74021cd1e7f0f$export$dddac1532e822863 = "--".concat($ebc74021cd1e7f0f$export$6f0c6fb8c80fcc92, "-token-not-found");
var $ebc74021cd1e7f0f$export$9d7b58831ae93caa = "--".concat($ebc74021cd1e7f0f$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $d93b2a470532b657$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];



var $iYJcE = parcelRequire("iYJcE");
var $db15aabd782424a1$export$4a14e169b1de4ee7 = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};


/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */ var $11c331917b9bbade$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];


var $2adc7de39e883e70$export$ea35b8958c39dd07 = function isThemeIds(themeId) {
    return (0, $11c331917b9bbade$export$7d43e72a58e3283f).find(function(id) {
        return id === themeId;
    }) !== undefined;
};


var $dfa4f26467b4f5e1$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $dfa4f26467b4f5e1$export$958fa026be3a263e = function isThemeKind(themeKind) {
    return $dfa4f26467b4f5e1$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};


var $989eb83d24ad11ea$var$customThemeOptions = 'UNSAFE_themeOptions';
var $989eb83d24ad11ea$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && (0, $db15aabd782424a1$export$4a14e169b1de4ee7)(id)) themeObject[kind] = id;
        if ((0, $dfa4f26467b4f5e1$export$958fa026be3a263e)(kind) && (0, $2adc7de39e883e70$export$ea35b8958c39dd07)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $989eb83d24ad11ea$var$customThemeOptions) try {
            themeObject[$989eb83d24ad11ea$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};


function $88cbf4ebd45e33d7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $88cbf4ebd45e33d7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $88cbf4ebd45e33d7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $88cbf4ebd45e33d7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $88cbf4ebd45e33d7$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $d93b2a470532b657$export$83993de8eb66733).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $88cbf4ebd45e33d7$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $ebc74021cd1e7f0f$export$a00eac3f8684bcd0)) || '';
    var theme = element.getAttribute((0, $ebc74021cd1e7f0f$export$4ef52930e33717cd)) || '';
    return $88cbf4ebd45e33d7$var$_objectSpread($88cbf4ebd45e33d7$var$_objectSpread({}, (0, $989eb83d24ad11ea$export$f19b488f7c0547ee)(theme)), $88cbf4ebd45e33d7$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $88cbf4ebd45e33d7$export$2e2bcd8739ae039 = $88cbf4ebd45e33d7$var$getGlobalTheme;



var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");


/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $6f336cca73132934$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $88cbf4ebd45e33d7$export$2e2bcd8739ae039)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $ebc74021cd1e7f0f$export$4ef52930e33717cd),
                            (0, $ebc74021cd1e7f0f$export$a00eac3f8684bcd0)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6f336cca73132934$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6f336cca73132934$export$2e2bcd8739ae039, "callbacks", new Set());


/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $b8c1271fd22f9950$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $5FkrB.useState)((0, $88cbf4ebd45e33d7$export$2e2bcd8739ae039)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        var observer = new (0, $6f336cca73132934$export$2e2bcd8739ae039)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $b8c1271fd22f9950$export$2e2bcd8739ae039 = $b8c1271fd22f9950$var$useThemeObserver;


function $027a82c92e88315f$var$getSafeValue() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $027a82c92e88315f$export$7c4d25c0c3217d8c(value, max) {
    var safeValue = $027a82c92e88315f$var$getSafeValue(value);
    var safeMax = $027a82c92e88315f$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}


/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ // Nested selectors with data attributes are required for theme switching
var $603b587025821f08$var$stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk14j0",
    danger: "_syaz1blx _bfhk18wg",
    warning: "_syazmgs1 _bfhk10f4",
    information: "_syaz1qd9 _bfhk8lbg",
    discovery: "_syaz1g72 _bfhke670",
    neutral: "_syazi7uo _bfhk7qp0",
    inverse: "_bfhkvuon _syazi7uo",
    informationBold: "_syaz1qd9 _bfhk9pm7",
    successBold: "_syaz1p1e _bfhk16ib",
    dangerBold: "_syaz1blx _bfhkud63",
    warningBold: "_syazmgs1 _bfhk1kmu",
    warningBoldDark: "_syazmgs1 _bfhkgj02",
    discoveryBold: "_syaz1g72 _bfhk5ly7"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ var $603b587025821f08$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === 'number' && max ? (0, $027a82c92e88315f$export$7c4d25c0c3217d8c)(children, max) : children;
};
/**
 * __BadgeNew__
 *
 * New visual refresh implementation of Badge component for the labelling system.
 * This component is used when the 'platform-dst-lozenge-tag-badge-visual-uplifts' feature flag is enabled.
 *
 * Uses new appearance naming convention:
 * - success (green)
 * - danger (red)
 * - neutral (gray)
 * - information (blue)
 * - inverse (inverted colors)
 * - warning (orange/yellow)
 * - discovery (purple)
 * - informationBold (bold blue, color.background.information.subtle)
 * - successBold (bold green, color.background.success.subtle)
 * - dangerBold (bold red, color.background.danger.subtle)
 * - warningBold (bold warning, color.background.warning.bold)
 * - discoveryBold (bold purple, color.background.discovery.subtle)
 */ var $603b587025821f08$var$BadgeNew = /*#__PURE__*/ (0, $5FkrB.memo)(function BadgeNew(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    var _useThemeObserver = (0, $b8c1271fd22f9950$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    // In dark theme, warningBold needs to swap to a lighter background
    // (color.background.warning.subtle / Orange800) for better contrast against
    // the typical dark surface colors.
    var resolvedAppearance = appearance === 'warningBold' && colorMode === 'dark' ? 'warningBoldDark' : appearance;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $afe8d2493aac17be$export$2e2bcd8739ae039)([
            $603b587025821f08$var$stylesNew.root,
            $603b587025821f08$var$stylesNew[resolvedAppearance]
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $5774451cc1763ff6$export$2e2bcd8739ae039), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $603b587025821f08$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $603b587025821f08$export$2e2bcd8739ae039 = $603b587025821f08$var$BadgeNew;



var $7d87ab0548ede72e$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($7d87ab0548ede72e$exports, "__esModule", {
    value: true
});
$7d87ab0548ede72e$exports.default = void 0;

var $7d87ab0548ede72e$var$_react = $7d87ab0548ede72e$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $7d87ab0548ede72e$var$_baseNew = $7d87ab0548ede72e$var$_interopRequireDefault((parcelRequire("lhDQM")));
function $7d87ab0548ede72e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7d87ab0548ede72e$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $7d87ab0548ede72e$var$_react.default.createElement($7d87ab0548ede72e$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$7d87ab0548ede72e$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $7d87ab0548ede72e$var$_default = $7d87ab0548ede72e$exports.default = $7d87ab0548ede72e$var$ChevronDownIcon;



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
var $6f5ca52080a8acd8$export$ff879f35a69d56b7 = function useElementRef() {
    var elementRef = (0, $5FkrB.useRef)(null);
    var setRef = (0, $5FkrB.useCallback)(function(ref) {
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};




var $5FkrB = parcelRequire("5FkrB");
var $b07db2e560a4c968$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $b07db2e560a4c968$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $b07db2e560a4c968$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};




var $5FkrB = parcelRequire("5FkrB");

var $b661c0f26656b472$export$9e95200239cd148b = function useSnapshotBeforeUpdate(cb) {
    var isFirstRender = (0, $5FkrB.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $ddf5c8c411f7d786$export$e5c5a5f917a5871c)(function() {
        isFirstRender.current = false;
    }, []);
};


/**
 * Which dimension(s) of the element to animate.
 *
 * - `'width'` animates only width changes.
 * - `'height'` animates only height changes.
 * - `'both'` animates width and height changes simultaneously.
 */ /**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $cb7903d00c12ea64$var$parseCSSTimeToMs(value) {
    var parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $cb7903d00c12ea64$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $cb7903d00c12ea64$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
var $cb7903d00c12ea64$export$a300664a1a230956 = function useResizing(_ref) {
    var dimension = _ref.dimension, duration = _ref.duration, easing = _ref.easing, onFinishMotion = _ref.onFinishMotion;
    var prevDimensions = (0, $5FkrB.useRef)();
    var _useElementRef = (0, $6f5ca52080a8acd8$export$ff879f35a69d56b7)(), _useElementRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useElementRef, 2), element = _useElementRef2[0], setElementRef = _useElementRef2[1];
    var setTimeout = (0, $8f57e60563dd1d02$export$4f34107a2b00f39c)({
        cleanup: 'next-effect'
    });
    var requestAnimationFrame = (0, $b07db2e560a4c968$export$1775f27e7c8051ca)();
    (0, $b661c0f26656b472$export$9e95200239cd148b)(function() {
        if ((0, $1e16768a721836bc$export$b7baf7667a68d87c)() || !element) return;
        var rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $ddf5c8c411f7d786$export$e5c5a5f917a5871c)(function() {
        if ((0, $1e16768a721836bc$export$b7baf7667a68d87c)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        var rect = element.getBoundingClientRect();
        var nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!$cb7903d00c12ea64$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
            return;
        }
        var propertyList = $cb7903d00c12ea64$var$getDimensionPropertyList(dimension);
        var newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = "".concat(prevDimensions.current.width, "px");
        if (dimension === 'height' || dimension === 'both') newStyles.height = "".concat(prevDimensions.current.height, "px");
        Object.assign(element.style, newStyles);
        var resolvedDuration = $cb7903d00c12ea64$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = "".concat(nextDimensions.width, "px");
                if (dimension === 'height' || dimension === 'both') element.style.height = "".concat(nextDimensions.height, "px");
                setTimeout(function() {
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};




var $kqp0i = parcelRequire("kqp0i");

var $fC8ib = parcelRequire("fC8ib");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");


function $9b78cd112fbe38b9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9b78cd112fbe38b9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9b78cd112fbe38b9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9b78cd112fbe38b9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9b78cd112fbe38b9$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $b36a9016275e3e9c$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $f7b395006a91e5c4$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $f7b395006a91e5c4$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $9b78cd112fbe38b9$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}





var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");
var $28103444f1c7f5ac$export$4ef52930e33717cd = 'data-theme';
var $28103444f1c7f5ac$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $28103444f1c7f5ac$export$a00eac3f8684bcd0 = 'data-color-mode';
var $28103444f1c7f5ac$export$2112803007239c61 = 'data-contrast-mode';
var $28103444f1c7f5ac$export$352e418ed5b6193a = 'data-custom-theme';
var $28103444f1c7f5ac$export$6f0c6fb8c80fcc92 = 'ds';
var $28103444f1c7f5ac$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $28103444f1c7f5ac$export$dddac1532e822863 = "--".concat($28103444f1c7f5ac$export$6f0c6fb8c80fcc92, "-token-not-found");
var $28103444f1c7f5ac$export$9d7b58831ae93caa = "--".concat($28103444f1c7f5ac$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $62fa7d53866b6c61$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $62fa7d53866b6c61$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $62fa7d53866b6c61$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $62fa7d53866b6c61$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $62fa7d53866b6c61$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $62fa7d53866b6c61$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $62fa7d53866b6c61$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $62fa7d53866b6c61$export$632685d741f3dbbf = $62fa7d53866b6c61$var$_objectSpread($62fa7d53866b6c61$var$_objectSpread({}, $62fa7d53866b6c61$export$958d0ae7f2977ae4), $62fa7d53866b6c61$export$d2dc61f58390201c);
var $62fa7d53866b6c61$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $62fa7d53866b6c61$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $62fa7d53866b6c61$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};
var $62fa7d53866b6c61$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};
var $62fa7d53866b6c61$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.lime.subtle': "var(--ds-border-accent-lime-subtle, #B3DF72)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.red.subtle': "var(--ds-border-accent-red-subtle, #FD9891)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.orange.subtle': "var(--ds-border-accent-orange-subtle, #FBC828)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.yellow.subtle': "var(--ds-border-accent-yellow-subtle, #EED12B)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.green.subtle': "var(--ds-border-accent-green-subtle, #7EE2B8)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.teal.subtle': "var(--ds-border-accent-teal-subtle, #9DD9EE)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.blue.subtle': "var(--ds-border-accent-blue-subtle, #8FB8F6)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.purple.subtle': "var(--ds-border-accent-purple-subtle, #D8A0F7)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.magenta.subtle': "var(--ds-border-accent-magenta-subtle, #F797D2)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.accent.gray.subtle': "var(--ds-border-accent-gray-subtle, #DDDEE1)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.danger.subtle': "var(--ds-border-danger-subtle, #FD9891)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.warning.subtle': "var(--ds-border-warning-subtle, #FBC828)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.success.subtle': "var(--ds-border-success-subtle, #B3DF72)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.discovery.subtle': "var(--ds-border-discovery-subtle, #D8A0F7)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.information.subtle': "var(--ds-border-information-subtle, #8FB8F6)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};
var $62fa7d53866b6c61$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.disabled': "var(--ds-background-disabled, #0515240F)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.subtle': "var(--ds-background-danger-subtle, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.subtle': "var(--ds-background-warning-subtle, #FBD779)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.subtle': "var(--ds-background-success-subtle, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.subtle': "var(--ds-background-discovery-subtle, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.subtle': "var(--ds-background-information-subtle, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $62fa7d53866b6c61$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};
var $62fa7d53866b6c61$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #292A2E)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #C9372C)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #E06C00)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #B38600)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #22A06B)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #2898BD)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #357DE8)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #AF59E1)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #7D818A)",
    'color.icon.disabled': "var(--ds-icon-disabled, #080F214A)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #1868DB)",
    'color.icon.brand': "var(--ds-icon-brand, #1868DB)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.warning': "var(--ds-icon-warning, #E06C00)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #292A2E)",
    'color.icon.success': "var(--ds-icon-success, #6A9A23)",
    'color.icon.discovery': "var(--ds-icon-discovery, #AF59E1)",
    'color.icon.information': "var(--ds-icon-information, #357DE8)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B6E76)",
    'color.icon.subtle': "var(--ds-icon-subtle, #505258)"
};
var $62fa7d53866b6c61$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $62fa7d53866b6c61$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $62fa7d53866b6c61$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
var $62fa7d53866b6c61$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $62fa7d53866b6c61$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $62fa7d53866b6c61$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $62fa7d53866b6c61$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $62fa7d53866b6c61$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $62fa7d53866b6c61$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
/**
 * Token functions are currently allowed for borderRadius in xcss to ease migration.
 * Because 'radius.small' defaults to 3px, we need a mechanism to allow for 4px values to be provided:
 * This is done by calling the token function - token('radius.small')
 *
 * TODO: Remove once shape them is rolled out and fg platform-dst-shape-theme-default removed
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $62fa7d53866b6c61$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $62fa7d53866b6c61$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $62fa7d53866b6c61$export$e615f061ca585a6c = $62fa7d53866b6c61$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $62fa7d53866b6c61$export$ca0f9c2de39ffed7(spacingProperty, $62fa7d53866b6c61$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $62fa7d53866b6c61$export$bf46c3f9eeafc71f = $62fa7d53866b6c61$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $62fa7d53866b6c61$export$ca0f9c2de39ffed7(spacingProperty, $62fa7d53866b6c61$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $62fa7d53866b6c61$export$e7af83bafe7f9e63 = $62fa7d53866b6c61$export$ca0f9c2de39ffed7('backgroundColor', $62fa7d53866b6c61$export$d1d79bf68ac056bd);
var $62fa7d53866b6c61$export$3a1bcba60b23d7f0 = $62fa7d53866b6c61$export$ca0f9c2de39ffed7('color', $62fa7d53866b6c61$export$8473307aa00d6ea1);
var $62fa7d53866b6c61$export$45f3f4fe16f9f7d5 = $62fa7d53866b6c61$export$ca0f9c2de39ffed7('fontWeight', $62fa7d53866b6c61$export$303e322c6b1ed114);
var $62fa7d53866b6c61$export$68cc305da27dbaa4 = $62fa7d53866b6c61$export$ca0f9c2de39ffed7('fontFamily', $62fa7d53866b6c61$export$3c7e9587132614b4);
var $62fa7d53866b6c61$export$128f10c238242f83 = $62fa7d53866b6c61$export$ca0f9c2de39ffed7('font', $62fa7d53866b6c61$export$6ffa317d5e70375);
var $62fa7d53866b6c61$export$219d364c0da35ae4 = $62fa7d53866b6c61$export$ca0f9c2de39ffed7('font', $62fa7d53866b6c61$export$236bfe3a33ef1292);
var $62fa7d53866b6c61$export$38845ca010b93505 = $62fa7d53866b6c61$export$ca0f9c2de39ffed7('fontWeight', $62fa7d53866b6c61$export$855cfd311192d666);
var $62fa7d53866b6c61$export$ff257d957d48c421 = $62fa7d53866b6c61$export$ca0f9c2de39ffed7((0, $28103444f1c7f5ac$export$9d7b58831ae93caa), $62fa7d53866b6c61$export$41a358c9c2356760);
var $62fa7d53866b6c61$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $62fa7d53866b6c61$export$41a358c9c2356760[color] !== undefined;
};
var $62fa7d53866b6c61$export$7001ce64d9ff7c7f = $62fa7d53866b6c61$export$ca0f9c2de39ffed7('font', $62fa7d53866b6c61$export$b805719bc8cb376);



var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $74Zh5 = parcelRequire("74Zh5");


var $3ZMUU = parcelRequire("3ZMUU");
function $0298940b6412b0cb$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $0298940b6412b0cb$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $0298940b6412b0cb$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $0298940b6412b0cb$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $0298940b6412b0cb$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $0298940b6412b0cb$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $0298940b6412b0cb$export$9a199fbafee0014e = {
    backgroundColor: (0, $62fa7d53866b6c61$export$d1d79bf68ac056bd),
    blockSize: (0, $62fa7d53866b6c61$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $62fa7d53866b6c61$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $62fa7d53866b6c61$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $62fa7d53866b6c61$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $62fa7d53866b6c61$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $62fa7d53866b6c61$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $62fa7d53866b6c61$export$e1b83c5210c471b8),
    borderBottomColor: (0, $62fa7d53866b6c61$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $62fa7d53866b6c61$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $62fa7d53866b6c61$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $62fa7d53866b6c61$export$e1b83c5210c471b8),
    borderColor: (0, $62fa7d53866b6c61$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $62fa7d53866b6c61$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $62fa7d53866b6c61$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $62fa7d53866b6c61$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $62fa7d53866b6c61$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $62fa7d53866b6c61$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $62fa7d53866b6c61$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $62fa7d53866b6c61$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $62fa7d53866b6c61$export$e1b83c5210c471b8),
    borderLeftColor: (0, $62fa7d53866b6c61$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $62fa7d53866b6c61$export$e1b83c5210c471b8),
    borderRadius: (0, $62fa7d53866b6c61$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $62fa7d53866b6c61$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $62fa7d53866b6c61$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $62fa7d53866b6c61$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $62fa7d53866b6c61$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $62fa7d53866b6c61$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $62fa7d53866b6c61$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $62fa7d53866b6c61$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $62fa7d53866b6c61$export$e1b83c5210c471b8),
    borderWidth: (0, $62fa7d53866b6c61$export$e1b83c5210c471b8),
    bottom: (0, $62fa7d53866b6c61$export$632685d741f3dbbf),
    boxShadow: (0, $62fa7d53866b6c61$export$7aff6e7ba39bb774),
    color: (0, $62fa7d53866b6c61$export$8473307aa00d6ea1),
    columnGap: (0, $62fa7d53866b6c61$export$958d0ae7f2977ae4),
    font: (0, $62fa7d53866b6c61$export$6ffa317d5e70375),
    fontFamily: (0, $62fa7d53866b6c61$export$3c7e9587132614b4),
    fontWeight: (0, $62fa7d53866b6c61$export$303e322c6b1ed114),
    gap: (0, $62fa7d53866b6c61$export$958d0ae7f2977ae4),
    height: (0, $62fa7d53866b6c61$export$6ccdbebca2ee545f),
    inlineSize: (0, $62fa7d53866b6c61$export$6ccdbebca2ee545f),
    inset: (0, $62fa7d53866b6c61$export$632685d741f3dbbf),
    insetBlock: (0, $62fa7d53866b6c61$export$632685d741f3dbbf),
    insetBlockEnd: (0, $62fa7d53866b6c61$export$632685d741f3dbbf),
    insetBlockStart: (0, $62fa7d53866b6c61$export$632685d741f3dbbf),
    insetInline: (0, $62fa7d53866b6c61$export$632685d741f3dbbf),
    insetInlineEnd: (0, $62fa7d53866b6c61$export$632685d741f3dbbf),
    insetInlineStart: (0, $62fa7d53866b6c61$export$632685d741f3dbbf),
    left: (0, $62fa7d53866b6c61$export$632685d741f3dbbf),
    margin: (0, $62fa7d53866b6c61$export$632685d741f3dbbf),
    marginBlock: (0, $62fa7d53866b6c61$export$632685d741f3dbbf),
    marginBlockEnd: (0, $62fa7d53866b6c61$export$632685d741f3dbbf),
    marginBlockStart: (0, $62fa7d53866b6c61$export$632685d741f3dbbf),
    marginBottom: (0, $62fa7d53866b6c61$export$632685d741f3dbbf),
    marginInline: (0, $62fa7d53866b6c61$export$632685d741f3dbbf),
    marginInlineEnd: (0, $62fa7d53866b6c61$export$632685d741f3dbbf),
    marginInlineStart: (0, $62fa7d53866b6c61$export$632685d741f3dbbf),
    marginLeft: (0, $62fa7d53866b6c61$export$632685d741f3dbbf),
    marginRight: (0, $62fa7d53866b6c61$export$632685d741f3dbbf),
    marginTop: (0, $62fa7d53866b6c61$export$632685d741f3dbbf),
    maxBlockSize: (0, $62fa7d53866b6c61$export$6ccdbebca2ee545f),
    maxHeight: (0, $62fa7d53866b6c61$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $62fa7d53866b6c61$export$6ccdbebca2ee545f),
    maxWidth: (0, $62fa7d53866b6c61$export$6ccdbebca2ee545f),
    minBlockSize: (0, $62fa7d53866b6c61$export$6ccdbebca2ee545f),
    minHeight: (0, $62fa7d53866b6c61$export$6ccdbebca2ee545f),
    minInlineSize: (0, $62fa7d53866b6c61$export$6ccdbebca2ee545f),
    minWidth: (0, $62fa7d53866b6c61$export$6ccdbebca2ee545f),
    opacity: (0, $62fa7d53866b6c61$export$daf94a976c798b4f),
    outlineColor: (0, $62fa7d53866b6c61$export$1531ad5bb3fbedac),
    outlineOffset: (0, $62fa7d53866b6c61$export$632685d741f3dbbf),
    outlineWidth: (0, $62fa7d53866b6c61$export$e1b83c5210c471b8),
    padding: (0, $62fa7d53866b6c61$export$958d0ae7f2977ae4),
    paddingBlock: (0, $62fa7d53866b6c61$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $62fa7d53866b6c61$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $62fa7d53866b6c61$export$958d0ae7f2977ae4),
    paddingBottom: (0, $62fa7d53866b6c61$export$958d0ae7f2977ae4),
    paddingInline: (0, $62fa7d53866b6c61$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $62fa7d53866b6c61$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $62fa7d53866b6c61$export$958d0ae7f2977ae4),
    paddingLeft: (0, $62fa7d53866b6c61$export$958d0ae7f2977ae4),
    paddingRight: (0, $62fa7d53866b6c61$export$958d0ae7f2977ae4),
    paddingTop: (0, $62fa7d53866b6c61$export$958d0ae7f2977ae4),
    right: (0, $62fa7d53866b6c61$export$632685d741f3dbbf),
    rowGap: (0, $62fa7d53866b6c61$export$958d0ae7f2977ae4),
    top: (0, $62fa7d53866b6c61$export$632685d741f3dbbf),
    width: (0, $62fa7d53866b6c61$export$6ccdbebca2ee545f),
    zIndex: (0, $62fa7d53866b6c61$export$b5f31a7e431d2eab)
};
var $0298940b6412b0cb$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $0298940b6412b0cb$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU.env) === 'object' && false;
};
var $0298940b6412b0cb$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $0298940b6412b0cb$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $0298940b6412b0cb$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($0298940b6412b0cb$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && $0298940b6412b0cb$var$safeSelectors.test(key)) {
            styleObj[key] = $0298940b6412b0cb$var$_transformStyles(value);
            return;
        }
        if ($0298940b6412b0cb$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($0298940b6412b0cb$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $0298940b6412b0cb$export$9a199fbafee0014e)) return;
        var tokenValue = $0298940b6412b0cb$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $0298940b6412b0cb$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $0298940b6412b0cb$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $0298940b6412b0cb$var$uniqueSymbol, (0, $74Zh5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $0298940b6412b0cb$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $0298940b6412b0cb$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $0298940b6412b0cb$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$0298940b6412b0cb$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $0298940b6412b0cb$export$f6c783d06584602c(style) {
    return $0298940b6412b0cb$var$baseXcss(style);
}


var $714e262e46e4ecb4$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $714e262e46e4ecb4$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $714e262e46e4ecb4$var$focusRingStyles = (0, $74Zh5.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $62fa7d53866b6c61$export$1531ad5bb3fbedac)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $62fa7d53866b6c61$export$958d0ae7f2977ae4)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $62fa7d53866b6c61$export$e1b83c5210c471b8)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: "".concat((0, $62fa7d53866b6c61$export$e1b83c5210c471b8)['border.width'], " solid")
        }
    }
});
var $714e262e46e4ecb4$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
var $714e262e46e4ecb4$var$enabledStyles = (0, $74Zh5.css)({
    cursor: 'pointer'
});
var $714e262e46e4ecb4$var$disabledStyles = (0, $74Zh5.css)({
    cursor: 'not-allowed'
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $714e262e46e4ecb4$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $784ecc28b84f92e1$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $714e262e46e4ecb4$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $4b5a5d40339b6fdb$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $9b78cd112fbe38b9$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "19.0.1",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $714e262e46e4ecb4$var$_excluded2);
    var resolvedStyles = (0, $0298940b6412b0cb$export$a9c84988c8f81f2d)(xcss);
    return (0, $74Zh5.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $714e262e46e4ecb4$var$baseStyles,
            $714e262e46e4ecb4$var$focusRingStyles,
            isDisabled ? $714e262e46e4ecb4$var$disabledStyles : $714e262e46e4ecb4$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $62fa7d53866b6c61$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $62fa7d53866b6c61$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $62fa7d53866b6c61$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $62fa7d53866b6c61$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $62fa7d53866b6c61$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $62fa7d53866b6c61$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $62fa7d53866b6c61$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $62fa7d53866b6c61$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(resolvedStyles.emotion || [])),
        "data-testid": testId
    }), children);
});
var $714e262e46e4ecb4$export$2e2bcd8739ae039 = $714e262e46e4ecb4$var$Pressable;


/* spinner.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $7NBLq = parcelRequire("7NBLq");

var $5FkrB = parcelRequire("5FkrB");

var $6cc517c1e490744b$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $d101d811be8b645e$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
var $d101d811be8b645e$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $d101d811be8b645e$var$loadIn = null;
var $d101d811be8b645e$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $d101d811be8b645e$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $d101d811be8b645e$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $6cc517c1e490744b$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $d101d811be8b645e$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $4b5a5d40339b6fdb$export$2e2bcd8739ae039));
    $d101d811be8b645e$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $7NBLq.default)([
            $d101d811be8b645e$var$styles.wrapperStyles,
            $d101d811be8b645e$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $7NBLq.default)([
            $d101d811be8b645e$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $7NBLq.default)([
            $d101d811be8b645e$var$styles.circleStyles
        ])
    })));
}));
var $d101d811be8b645e$export$2e2bcd8739ae039 = $d101d811be8b645e$var$Spinner;


// extract the category and key from the resolved color
var $65f2b30ecdcfed7c$export$a3fc04b8551e006a = function getThemeStyles(resolvedColor) {
    var isAccent = resolvedColor.startsWith('accent-');
    var category = isAccent ? 'accent' : 'semantic';
    var key = isAccent ? resolvedColor.replace('accent-', '') : resolvedColor;
    return {
        category: category,
        key: key
    };
};


/* icon-renderer.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $5FkrB = parcelRequire("5FkrB");

/* box.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $7NBLq = parcelRequire("7NBLq");

var $5FkrB = parcelRequire("5FkrB");
var $c09de90d1c2ebc9d$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');


var $da6b8b520c8e7caa$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $da6b8b520c8e7caa$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $da6b8b520c8e7caa$var$baseStyles = null;
var $da6b8b520c8e7caa$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhk187o",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $da6b8b520c8e7caa$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $da6b8b520c8e7caa$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $da6b8b520c8e7caa$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $da6b8b520c8e7caa$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $da6b8b520c8e7caa$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $da6b8b520c8e7caa$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $da6b8b520c8e7caa$var$Box = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $da6b8b520c8e7caa$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $da6b8b520c8e7caa$var$_excluded2);
    var node = /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: (0, $7NBLq.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $da6b8b520c8e7caa$var$backgroundColorMap[backgroundColor],
            backgroundColor && $da6b8b520c8e7caa$var$isSurfaceToken(backgroundColor) && $da6b8b520c8e7caa$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $da6b8b520c8e7caa$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $da6b8b520c8e7caa$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $da6b8b520c8e7caa$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $da6b8b520c8e7caa$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $5FkrB.createElement((0, $c09de90d1c2ebc9d$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $da6b8b520c8e7caa$export$2e2bcd8739ae039 = $da6b8b520c8e7caa$var$Box;
function $da6b8b520c8e7caa$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $da6b8b520c8e7caa$var$setSurfaceTokenMap;
}


// Map lozenge colors to appropriate icon colors.
//
// We intentionally use `color.text.*.bolder` tokens for icons across all
// colored lozenges (semantic + accent). Text tokens use higher-stop palette
// values (Color700+) which pass 3:1 contrast against subtler backgrounds in
// every interactive state — including pressed where icon Color600 fails for
// most hues. Using text tokens uniformly:
//   - avoids global changes to the `color.icon.*` token ramps
//   - keeps icon and text visually aligned in the lozenge
//   - guarantees ≥3:1 contrast across default/hover/pressed states
//
// Neutral lozenges use `color.text.subtle` to match the neutral text styling
// and remain consistent with their alpha-based backgrounds.
var $206355ab779def4c$var$getIconColor = function getIconColor(color) {
    switch(color){
        // Semantic
        case 'success':
            return "var(--ds-text-success, #4C6B1F)";
        case 'warning':
            return "var(--ds-text-warning, #9E4C00)";
        case 'danger':
            return "var(--ds-text-danger, #AE2E24)";
        case 'information':
            return "var(--ds-text-information, #1558BC)";
        case 'discovery':
            return "var(--ds-text-discovery, #803FA5)";
        case 'neutral':
            return "var(--ds-text-subtle, #505258)";
        // Accent
        case 'accent-red':
            return "var(--ds-text-accent-red, #AE2E24)";
        case 'accent-orange':
            return "var(--ds-text-accent-orange, #9E4C00)";
        case 'accent-yellow':
            return "var(--ds-text-accent-yellow, #7F5F01)";
        case 'accent-lime':
            return "var(--ds-text-accent-lime, #4C6B1F)";
        case 'accent-green':
            return "var(--ds-text-accent-green, #216E4E)";
        case 'accent-teal':
            return "var(--ds-text-accent-teal, #206A83)";
        case 'accent-blue':
            return "var(--ds-text-accent-blue, #1558BC)";
        case 'accent-purple':
            return "var(--ds-text-accent-purple, #803FA5)";
        case 'accent-magenta':
            return "var(--ds-text-accent-magenta, #943D73)";
        case 'accent-gray':
            return "var(--ds-text-subtle, #505258)";
        default:
            return "var(--ds-text-subtle, #505258)";
    }
};
var $206355ab779def4c$var$styles = {
    motion: "_k8m01ylx _1oeci9qs _6fl41d08"
};
/**
 * Icon renderer for lozenge components
 * Handles proper sizing and color theming for icons
 */ var $206355ab779def4c$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon, color = _ref.color, testId = _ref.testId, size = _ref.size;
    var iconColor = $206355ab779def4c$var$getIconColor(color);
    return (0, $4dee22873f13f74d$export$b40ec24ac8275656)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $da6b8b520c8e7caa$export$2e2bcd8739ae039), {
        xcss: $206355ab779def4c$var$styles.motion,
        style: {
            color: iconColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, {
        label: "",
        size: size,
        testId: testId
    })) : /*#__PURE__*/ // Cast required because the lozenge intentionally uses some
    // `color.text.*.bolder` tokens for icons that don't pass 3:1 contrast
    // at their default `color.icon.*` stop. The Icon component types only
    // accept `IconColor`, but text tokens are valid CSS color values and
    // render correctly at runtime.
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, {
        color: iconColor,
        label: "",
        size: size,
        testId: testId
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$206355ab779def4c$export$2e2bcd8739ae039 = $206355ab779def4c$var$IconRenderer;


// Map legacy appearance to new color values

var $d750c56368b9a5b0$var$legacyAppearanceMap = {
    default: 'neutral',
    removed: 'danger',
    inprogress: 'information',
    new: 'discovery',
    moved: 'warning'
};
var $d750c56368b9a5b0$export$acf5d2b7dc999bda = function resolveLozengeColor() {
    var _legacyAppearanceMap$;
    var appearance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'neutral';
    if (appearance.startsWith('accent-')) return appearance;
    return (_legacyAppearanceMap$ = $d750c56368b9a5b0$var$legacyAppearanceMap[appearance]) !== null && _legacyAppearanceMap$ !== void 0 ? _legacyAppearanceMap$ : appearance;
};


function $4775a4a0c5a2c4bc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4775a4a0c5a2c4bc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4775a4a0c5a2c4bc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4775a4a0c5a2c4bc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Get the pressed background color for the selected lozenge dropdown trigger
var $4775a4a0c5a2c4bc$var$pressedBackgroundMapping = {
    success: "var(--ds-background-success-subtler-pressed, #B3DF72)",
    warning: "var(--ds-background-warning-subtler-pressed, #FBC828)",
    danger: "var(--ds-background-danger-subtler-pressed, #FD9891)",
    information: "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    neutral: "var(--ds-background-neutral-pressed, #080F214A)",
    discovery: "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'accent-red': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'accent-orange': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'accent-yellow': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'accent-lime': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'accent-green': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'accent-teal': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'accent-blue': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'accent-purple': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'accent-magenta': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'accent-gray': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
};
var $4775a4a0c5a2c4bc$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1j28 _kqswh2mm _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k92 _1q51v77o _85i5v77o _bozg1b66 _y4ti1b66",
    motionContainer: "_k8m01rje _1oeci9qs _6fl41d08",
    containerSpacious: "_2rko1qi0 _1tkeviql _1q511b66 _85i51b66 _bozgutpp _y4tiutpp",
    containerBadgePadding: "_y4ti303w",
    text: "_11c8wadc _1reo15vq _18m915vq _o5721q9c",
    textEllipsis: "_1bto1l2s",
    textClip: "_1btozryt",
    textSpacious: "_11c8fhey _k48p1wq8",
    textSelected: "_syaz6x5g",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw",
    metricBadgeWrapper: "_1e0c1txw",
    'semantic.success': "_3wu02gvx _bfhk14j0 _syaz1p1e",
    'semantic.warning': "_3wu01wfx _bfhk10f4 _syazmgs1",
    'semantic.danger': "_3wu01mzp _bfhk18wg _syaz1blx",
    'semantic.information': "_3wu0wn4u _bfhk8lbg _syaz1qd9",
    'semantic.neutral': "_3wu01l7x _bfhki8nm _syazi7uo",
    'semantic.discovery': "_3wu019v3 _bfhke670 _syaz1g72",
    'accent.red': "_3wu0n9dc _bfhk1rtt _syazhwvp",
    'accent.orange': "_3wu01ip5 _bfhk165s _syaz7i1p",
    'accent.yellow': "_3wu01s7j _bfhk1773 _syazekll",
    'accent.lime': "_3wu01m7d _bfhkz2ec _syaz1ik3",
    'accent.green': "_3wu05d2u _bfhk1wnw _syaz1y78",
    'accent.teal': "_3wu0131p _bfhk1a17 _syaz12v7",
    'accent.blue': "_3wu018hp _bfhk1dy8 _syaz1kyx",
    'accent.purple': "_3wu0luwt _bfhk1nm4 _syaz1mn1",
    'accent.magenta': "_3wu0132u _bfhkv9ra _syaz1qur",
    'accent.gray': "_3wu01l7x _bfhkysee _syaz1tmo",
    'interactive.semantic.success': "_irr31r82 _1di6d6jc",
    'interactive.semantic.warning': "_irr31yx4 _1di6bkku",
    'interactive.semantic.danger': "_irr370oi _1di6jkmi",
    'interactive.semantic.information': "_irr315aw _1di6ar1y",
    'interactive.semantic.neutral': "_irr3plhp _1di61gdz",
    'interactive.semantic.discovery': "_irr3rumk _1di65usi",
    'interactive.accent.red': "_irr3affd _1di61j5a",
    'interactive.accent.orange': "_irr31ei0 _1di6dpo3",
    'interactive.accent.yellow': "_irr31uw7 _1di61r9w",
    'interactive.accent.lime': "_irr31gf0 _1di62kxc",
    'interactive.accent.green': "_irr31e2h _1di6ybhx",
    'interactive.accent.teal': "_irr3kwwr _1di61jb0",
    'interactive.accent.blue': "_irr3815t _1di6rwxf",
    'interactive.accent.purple': "_irr3attl _1di63nfk",
    'interactive.accent.magenta': "_irr31axx _1di642ri",
    'interactive.accent.gray': "_irr3wejn _1di618ut",
    iconBorderFilter: "_1h6d74of",
    content: "_zulp1b66 _1e0c116y _4cvr1h6o",
    maxWidth: "_p12f1osq",
    contentSpacious: "_zulp12x7",
    loadingContent: "_tzy4idpf",
    containerBadgePressed: "_1axmtoke _17i7toke",
    containerBadgeNeutralAppearance: "_1ftrnkaw _1axmnkaw _17i7nkaw"
};
/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */ var $4775a4a0c5a2c4bc$var$LozengeBase = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, appearance = _ref.appearance, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, onClick = _ref.onClick, style = _ref.style, analyticsContext = _ref.analyticsContext, interactionName = _ref.interactionName, ariaControls = _ref['aria-controls'], ariaExpanded = _ref['aria-expanded'], ariaHaspopup = _ref['aria-haspopup'], ariaLabel = _ref['aria-label'];
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), resizing = _useState2[0], setResizing = _useState2[1];
    var onFinishMotion = function onFinishMotion() {
        return setResizing(false);
    };
    var resizingWidth = (0, $cb7903d00c12ea64$export$a300664a1a230956)({
        dimension: 'width',
        duration: "var(--ds-duration-medium, 200ms)",
        easing: "var(--ds-easing-inout-bold, cubic-bezier(0.4, 0, 0, 1))",
        onFinishMotion: onFinishMotion
    });
    var isInitialRender = (0, $5FkrB.useRef)(true);
    var isInteractive = typeof onClick === 'function';
    // Determine the effective color, with fallback logic for legacy appearances
    var resolvedColor = (0, $d750c56368b9a5b0$export$acf5d2b7dc999bda)(appearance) || 'neutral';
    var _getThemeStyles = (0, $65f2b30ecdcfed7c$export$a3fc04b8551e006a)(resolvedColor), category = _getThemeStyles.category, key = _getThemeStyles.key;
    var colorStyleKey = "".concat(category, ".").concat(key);
    var interactiveStyleKey = "interactive.".concat(category, ".").concat(key);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && maxWidth.endsWith('%');
    var resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === 'inverse' ? 'inverse' : (0, $d750c56368b9a5b0$export$acf5d2b7dc999bda)(trailingMetricAppearance) : resolvedColor;
    // Map the resolved trailing metric appearance to a Badge appearance.
    // Semantic colors map to their new bold variants (e.g. successBold),
    // which provide sufficient color emphasis on top of the subtler
    // lozenge background. Accent colors and unknown values fall back to
    // the neutral appearance.
    var metricBadgeAppearance = function() {
        if (resolvedTrailingMetricAppearance === 'inverse') return 'inverse';
        if (resolvedTrailingMetricAppearance == null) return 'neutral';
        if (resolvedTrailingMetricAppearance.startsWith('accent-')) return 'neutral';
        switch(resolvedTrailingMetricAppearance){
            case 'success':
                return 'successBold';
            case 'warning':
                return 'warningBold';
            case 'danger':
                return 'dangerBold';
            case 'information':
                return 'informationBold';
            case 'discovery':
                return 'discoveryBold';
            case 'neutral':
            default:
                return 'neutral';
        }
    }();
    var commonStyleOverrides = {
        backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
        // Constrain the container to the smaller of the explicit maxWidth and 100% of
        // the parent. Using min(...) means the lozenge never overflows its parent,
        // while still honouring the explicit maxWidth prop when the parent is wider.
        maxWidth: maxWidthIsPc ? maxWidth : "min(".concat(maxWidthValue, ", 100%)")
    };
    var hasTrailingMetric = trailingMetric != null && trailingMetric !== '';
    var childrenKey = typeof children === 'string' ? children : undefined;
    (0, $5FkrB.useLayoutEffect)(function() {
        // Ignore initial render
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        setResizing(true);
    }, [
        childrenKey
    ]);
    var enableMotionFG = (0, $4dee22873f13f74d$export$b40ec24ac8275656)('platform-dst-motion-uplift');
    var innerContent = /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, enableMotionFG ? resizingWidth : undefined, {
        className: (0, $7NBLq.default)([
            $4775a4a0c5a2c4bc$var$styles.content,
            spacing === 'spacious' && $4775a4a0c5a2c4bc$var$styles.contentSpacious,
            isLoading && $4775a4a0c5a2c4bc$var$styles.loadingContent,
            // Constrain the content wrapper to its container so text truncation
            // works correctly within the flex layout, regardless of whether maxWidth
            // is a percentage, fixed value, or the parent container is narrower than
            // the explicit maxWidth.
            $4775a4a0c5a2c4bc$var$styles.maxWidth
        ])
    }), iconBefore && /*#__PURE__*/ $5FkrB.createElement((0, $206355ab779def4c$export$2e2bcd8739ae039), {
        size: spacing === 'spacious' ? 'medium' : 'small',
        icon: iconBefore,
        color: resolvedColor,
        testId: testId && "".concat(testId, "--icon")
    }), /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            // The text fills 100% of the inner content wrapper. The container's
            // own max-width (set on the container via commonStyleOverrides) handles
            // the actual size constraint, so the text just needs to fill the available
            // space and truncate when it overflows.
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")"),
            color: style === null || style === void 0 ? void 0 : style.color
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $7NBLq.default)([
            $4775a4a0c5a2c4bc$var$styles.text,
            enableMotionFG && resizing && !maxWidth ? $4775a4a0c5a2c4bc$var$styles.textClip : $4775a4a0c5a2c4bc$var$styles.textEllipsis,
            spacing === 'spacious' && $4775a4a0c5a2c4bc$var$styles.textSpacious
        ])
    }, children), hasTrailingMetric && !resolvedColor.startsWith('accent-') && /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-lozenge-metric-wrapper": true,
        "data-testid": testId && "".concat(testId, "--metric"),
        className: (0, $7NBLq.default)([
            $4775a4a0c5a2c4bc$var$styles.metricBadgeWrapper
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $603b587025821f08$export$2e2bcd8739ae039), {
        appearance: metricBadgeAppearance
    }, trailingMetric)), isInteractive && /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7d87ab0548ede72e$exports))), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && "".concat(testId, "--chevron")
    }));
    if (isInteractive) return /*#__PURE__*/ $5FkrB.createElement((0, $714e262e46e4ecb4$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: ref,
        xcss: (0, $51c2ad1cc5d37be6$export$a274e22fb40f762e)($4775a4a0c5a2c4bc$var$styles.container, (0, $4dee22873f13f74d$export$b40ec24ac8275656)('platform-dst-motion-uplift') && $4775a4a0c5a2c4bc$var$styles.motionContainer, spacing === 'spacious' && $4775a4a0c5a2c4bc$var$styles.containerSpacious, !isSelected && $4775a4a0c5a2c4bc$var$styles.iconBorderFilter, $4775a4a0c5a2c4bc$var$styles[colorStyleKey], !isLoading && $4775a4a0c5a2c4bc$var$styles[interactiveStyleKey], hasTrailingMetric && $4775a4a0c5a2c4bc$var$styles.containerBadgePressed, hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $4775a4a0c5a2c4bc$var$styles.containerBadgeNeutralAppearance)
    }, isLoading && {
        'aria-busy': true,
        'aria-disabled': true,
        isDisabled: true
    }, {
        "aria-label": isLoading ? 'Loading' : ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        onClick: isLoading ? undefined : onClick,
        style: $4775a4a0c5a2c4bc$var$_objectSpread($4775a4a0c5a2c4bc$var$_objectSpread({}, commonStyleOverrides), {}, {
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: "solid ".concat("var(--ds-border-width, 1px)", " ", isSelected ? 'var(--border-color) !important' : 'transparent'),
            backgroundColor: isSelected ? $4775a4a0c5a2c4bc$var$pressedBackgroundMapping[resolvedColor] : undefined,
            cursor: isLoading ? 'progress' : 'pointer'
        }),
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger"
    }, isSelected && {
        'data-selected': 'true'
    }), innerContent, isLoading && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $7NBLq.default)([
            $4775a4a0c5a2c4bc$var$styles.loadingOverlay
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $d101d811be8b645e$export$2e2bcd8739ae039), {
        size: spacing === 'spacious' ? 'small' : 'xsmall',
        label: ", Loading",
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    })));
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, $7NBLq.default)([
            $4775a4a0c5a2c4bc$var$styles.container,
            spacing === 'spacious' && $4775a4a0c5a2c4bc$var$styles.containerSpacious,
            spacing !== 'spacious' && hasTrailingMetric && $4775a4a0c5a2c4bc$var$styles.containerBadgePadding,
            $4775a4a0c5a2c4bc$var$styles[colorStyleKey],
            $4775a4a0c5a2c4bc$var$styles.iconBorderFilter,
            hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $4775a4a0c5a2c4bc$var$styles.containerBadgeNeutralAppearance
        ])
    }, innerContent);
}));
var $4775a4a0c5a2c4bc$export$2e2bcd8739ae039 = $4775a4a0c5a2c4bc$var$LozengeBase;


/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $5d99b848cdf04750$var$Lozenge = function Lozenge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style, testId = _ref.testId, children = _ref.children, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance;
    var baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        children: children
    };
    return /*#__PURE__*/ $5FkrB.createElement((0, $4775a4a0c5a2c4bc$export$2e2bcd8739ae039), baseProps, children);
};
$5d99b848cdf04750$var$Lozenge.displayName = 'Lozenge';
var $5d99b848cdf04750$export$2e2bcd8739ae039 = $5d99b848cdf04750$var$Lozenge;


/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ var $abe7eb499db4bfa4$var$styles = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect4ttxp _1wyb1skh _zg8l4jg8 _k48pwu06 _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhksm61",
    'bg.subtle.inprogress': "_bfhksm61",
    'bg.subtle.moved': "_bfhksm61",
    'bg.subtle.new': "_bfhksm61",
    'bg.subtle.removed': "_bfhksm61",
    'bg.subtle.success': "_bfhksm61",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syazi7uo",
    'text.bold': "_syazwwip"
};
var $abe7eb499db4bfa4$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed'
];
var $abe7eb499db4bfa4$var$newSemanticColors = [
    'success',
    'discovery',
    'warning',
    'danger',
    'information',
    'neutral'
];
var $abe7eb499db4bfa4$var$appearanceMapping = {
    neutral: 'default',
    default: 'default',
    information: 'inprogress',
    inprogress: 'inprogress',
    warning: 'moved',
    moved: 'moved',
    removed: 'removed',
    danger: 'removed',
    success: 'success',
    discovery: 'new',
    new: 'new'
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $abe7eb499db4bfa4$var$LegacyLozenge = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? 'bold' : 'subtle';
    var appearanceType = (0, $5FkrB.useMemo)(function() {
        return $abe7eb499db4bfa4$var$appearanceTypes.includes(appearance) || $abe7eb499db4bfa4$var$newSemanticColors.includes(appearance) ? $abe7eb499db4bfa4$var$appearanceMapping[appearance] : 'default';
    }, [
        appearance
    ]);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $7NBLq.default)([
            $abe7eb499db4bfa4$var$styles.container,
            $abe7eb499db4bfa4$var$styles["bg.".concat(appearanceStyle, ".").concat(appearanceType)],
            appearanceStyle === 'subtle' && $abe7eb499db4bfa4$var$styles["outline.subtle.".concat(appearanceType)],
            appearanceStyle === 'subtle' && $abe7eb499db4bfa4$var$styles.containerSubtle
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $7NBLq.default)([
            $abe7eb499db4bfa4$var$styles.text,
            (0, $4dee22873f13f74d$export$b40ec24ac8275656)('platform-lozenge-custom-letterspacing') && $abe7eb499db4bfa4$var$styles.customLetterspacing,
            $abe7eb499db4bfa4$var$styles["text.".concat(appearanceStyle)]
        ])
    }, children));
});
$abe7eb499db4bfa4$var$LegacyLozenge.displayName = 'Lozenge';
/**
 * Wrapper component that switches between old and new Lozenge based on feature flag
 */ var $abe7eb499db4bfa4$var$LozengeWrapper = /*#__PURE__*/ (0, $5FkrB.memo)(function(props) {
    if ((0, $4dee22873f13f74d$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts')) return /*#__PURE__*/ $5FkrB.createElement((0, $5d99b848cdf04750$export$2e2bcd8739ae039), props);
    return /*#__PURE__*/ $5FkrB.createElement($abe7eb499db4bfa4$var$LegacyLozenge, props);
});
$abe7eb499db4bfa4$var$LozengeWrapper.displayName = 'Lozenge';
var $abe7eb499db4bfa4$export$2e2bcd8739ae039 = $abe7eb499db4bfa4$var$LozengeWrapper;



var $iYJcE = parcelRequire("iYJcE");







/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $1457c78a8b8e5d17$var$ShrinkOut = function ShrinkOut(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'small' : _ref$duration, onFinish = _ref.onFinish;
    var _useElementRef = (0, $6f5ca52080a8acd8$export$ff879f35a69d56b7)(), _useElementRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useElementRef, 2), element = _useElementRef2[0], setElementRef = _useElementRef2[1];
    var exiting = (0, $0fe6287c12490552$export$3b6f38abbdcbd000)();
    var requestAnimationFrame = (0, $b07db2e560a4c968$export$1775f27e7c8051ca)();
    var setTimeout = (0, $8f57e60563dd1d02$export$4f34107a2b00f39c)();
    var direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $ddf5c8c411f7d786$export$e5c5a5f917a5871c)(function() {
        if (exiting.isExiting && element) {
            if ((0, $1e16768a721836bc$export$b7baf7667a68d87c)()) {
                exiting.onFinish && exiting.onFinish();
                onFinish && onFinish('exiting');
                return;
            }
            var newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: "".concat(element.offsetWidth, "px"),
                height: "".concat(element.offsetHeight, "px"),
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    var newStyles = {
                        width: '0px',
                        margin: '0px',
                        // We animate margin down to zero so it doesn't take any space.
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $3f46f842626a6ed4$export$38b928a7167ce124)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(function() {
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $3f46f842626a6ed4$export$38b928a7167ce124)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $1457c78a8b8e5d17$export$2e2bcd8739ae039 = $1457c78a8b8e5d17$var$ShrinkOut;



/* tag-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $7NBLq = parcelRequire("7NBLq");

var $7NBLq = parcelRequire("7NBLq");
const $2d3c35f771a6028a$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $7NBLq.default)(actualStyles);
};



/* pressable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");



function $7d097c8054de1296$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use;
        var ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}




/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $7NBLq = parcelRequire("7NBLq");
var $ce3b3fda6579bde8$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $ce3b3fda6579bde8$var$_excluded2 = [
    "className"
];
var $ce3b3fda6579bde8$var$focusRingStyles = null;
var $ce3b3fda6579bde8$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $ce3b3fda6579bde8$var$Focusable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $ce3b3fda6579bde8$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $ce3b3fda6579bde8$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $7NBLq.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $ce3b3fda6579bde8$export$2e2bcd8739ae039 = $ce3b3fda6579bde8$var$Focusable;


var $b0e39caa41d1b0a6$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $b0e39caa41d1b0a6$var$_excluded2 = [
    "className"
];
var $b0e39caa41d1b0a6$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $b0e39caa41d1b0a6$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $784ecc28b84f92e1$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $b0e39caa41d1b0a6$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $4b5a5d40339b6fdb$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $9b78cd112fbe38b9$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "19.0.1",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $b0e39caa41d1b0a6$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement((0, $ce3b3fda6579bde8$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $7d097c8054de1296$export$95df08bae54cb4df)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $2d3c35f771a6028a$export$a274e22fb40f762e)($b0e39caa41d1b0a6$var$styles.root, isDisabled && $b0e39caa41d1b0a6$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $b0e39caa41d1b0a6$export$2e2bcd8739ae039 = $b0e39caa41d1b0a6$var$Pressable;



/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // Color mapping from old color names to new color names
var $a37d528f66b9020f$export$3351a8d90bcc13aa = {
    standard: 'gray',
    grey: 'gray',
    blue: 'blue',
    green: 'green',
    red: 'red',
    yellow: 'yellow',
    purple: 'purple',
    lime: 'lime',
    magenta: 'magenta',
    orange: 'orange',
    teal: 'teal',
    // Light variants map to same as their non-light counterparts
    greyLight: 'gray',
    blueLight: 'blue',
    greenLight: 'green',
    redLight: 'red',
    yellowLight: 'yellow',
    purpleLight: 'purple',
    limeLight: 'lime',
    magentaLight: 'magenta',
    orangeLight: 'orange',
    tealLight: 'teal'
};


// Intentionally scoped to the UI-uplifted TagNew implementation.
var $b7002e514c670cae$export$7d100de1166870f6 = function getTagText(text) {
    return Array.isArray(text) ? text.join('') : text;
};



var $5FkrB = parcelRequire("5FkrB");
function $76b77f1e120be454$export$ce4b6a469c26f53f(_ref) {
    var isLink = _ref.isLink, href = _ref.href, LinkComponent = _ref.LinkComponent, testId = _ref.testId, children = _ref.children, onClick = _ref.onClick, linkHandlers = _ref.linkHandlers;
    if (isLink && href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LinkComponent, {
        href: href,
        testId: testId ? "".concat(testId, "--link") : undefined,
        onClick: onClick,
        onMouseEnter: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseEnter,
        onMouseLeave: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseLeave,
        onMouseDown: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseDown,
        onFocus: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onFocus,
        onBlur: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onBlur
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, children);
}


/* removable-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ /**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $7NBLq = parcelRequire("7NBLq");

// Tag status enum
var $afbd375195ac61bc$export$74452314b63acabc = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}({});


/**
 * Stable key so ExitingPersistence can match this child across the remove transition
 * (see ShrinkOut + ExitingPersistence docs in @atlaskit/motion).
 */ var $1de29c1ed3c716a8$var$removableShrinkOutChildKey = 'atlaskit-tag-removable-shrink-out';
var $1de29c1ed3c716a8$var$motionWrapperStyles = null;
function $1de29c1ed3c716a8$export$898a500849bb5cf4(_ref) {
    var isRemovable = _ref.isRemovable, status = _ref.status, onShrinkOutExitComplete = _ref.onShrinkOutExitComplete, children = _ref.children;
    if (isRemovable) return /*#__PURE__*/ $5FkrB.createElement((0, $0fe6287c12490552$export$2e2bcd8739ae039), null, !(status === (0, $afbd375195ac61bc$export$74452314b63acabc).Removed) && /*#__PURE__*/ $5FkrB.createElement((0, $1457c78a8b8e5d17$export$2e2bcd8739ae039), {
        key: $1de29c1ed3c716a8$var$removableShrinkOutChildKey,
        onFinish: onShrinkOutExitComplete ? function(phase) {
            if (phase === 'exiting') onShrinkOutExitComplete();
        } : undefined
    }, function(motion) {
        return /*#__PURE__*/ $5FkrB.createElement("span", {
            ref: motion.ref,
            className: (0, $7NBLq.default)([
                "_1e0c116y"
            ])
        }, children);
    }));
    return children;
}


/* swatch-before.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $7NBLq = parcelRequire("7NBLq");
var $aba74707decee077$var$tagSwatchBeforeStyles = {
    swatch: "_2rkolb4i _1bsboqnp _4t3ioqnp _1o9zidpf"
};
var $aba74707decee077$var$tagSwatchBeforeColorStyles = {
    gray: "_bfhk18j9",
    blue: "_bfhk115i",
    green: "_bfhk1rsu",
    red: "_bfhkkrt9",
    yellow: "_bfhk8y3s",
    purple: "_bfhk18ah",
    lime: "_bfhkbq5w",
    magenta: "_bfhk1mi6",
    orange: "_bfhk1kkj",
    teal: "_bfhktdv8"
};
function $aba74707decee077$export$2e2bcd8739ae039(_ref) {
    var colorKey = _ref.colorKey, swatchBefore = _ref.swatchBefore;
    if (swatchBefore === undefined || swatchBefore === false) return null;
    if (swatchBefore === true) return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $7NBLq.default)([
            $aba74707decee077$var$tagSwatchBeforeStyles.swatch,
            $aba74707decee077$var$tagSwatchBeforeColorStyles[colorKey]
        ])
    });
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            backgroundColor: swatchBefore
        },
        className: (0, $7NBLq.default)([
            $aba74707decee077$var$tagSwatchBeforeStyles.swatch
        ])
    });
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $14b060b9066053e0$export$84acd183858d8235() {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isLinkHovered = _useState2[0], setIsLinkHovered = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), isOverButton = _useState4[0], setIsOverButton = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), isButtonFocused = _useState6[0], setIsButtonFocused = _useState6[1];
    var _useState7 = (0, $5FkrB.useState)(false), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState7, 2), isLinkFocused = _useState8[0], setIsLinkFocused = _useState8[1];
    // Track if last interaction was via mouse (to determine keyboard vs mouse focus)
    var hadMouseDownRef = (0, $5FkrB.useRef)(false);
    // Button handlers
    var buttonHandlers = (0, $5FkrB.useMemo)(function() {
        return {
            onMouseEnter: function onMouseEnter() {
                return setIsOverButton(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setIsOverButton(false);
            },
            onMouseDown: function onMouseDown(e) {
                // Prevent the browser from moving focus to the remove button on mousedown.
                // Without this, parent composite widgets (e.g. Select) lose input focus when
                // the user clicks remove, triggering unwanted blur side-effects.
                e === null || e === void 0 || e.preventDefault();
                hadMouseDownRef.current = true;
            },
            onFocus: function onFocus() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsButtonFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function onBlur() {
                return setIsButtonFocused(false);
            }
        };
    }, []);
    // Link handlers - includes hover tracking
    var linkHandlers = (0, $5FkrB.useMemo)(function() {
        return {
            onMouseEnter: function onMouseEnter() {
                return setIsLinkHovered(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setIsLinkHovered(false);
            },
            onMouseDown: function onMouseDown() {
                hadMouseDownRef.current = true;
            },
            onFocus: function onFocus() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsLinkFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function onBlur() {
                return setIsLinkFocused(false);
            }
        };
    }, []);
    return {
        isLinkHovered: isLinkHovered,
        isOverButton: isOverButton,
        isButtonFocused: isButtonFocused,
        isLinkFocused: isLinkFocused,
        buttonHandlers: buttonHandlers,
        linkHandlers: linkHandlers
    };
}


/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $9f5e95bf7cec163b$var$ATOMIC_GROUP_LENGTH = 5;
function $9f5e95bf7cec163b$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $9f5e95bf7cec163b$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}




var $9dOvm = parcelRequire("9dOvm");
var $827d87e6cea4a030$var$_process, $827d87e6cea4a030$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $827d87e6cea4a030$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($827d87e6cea4a030$var$_process = globalThis.process) === null || $827d87e6cea4a030$var$_process === void 0 || ($827d87e6cea4a030$var$_process = $827d87e6cea4a030$var$_process.env) === null || $827d87e6cea4a030$var$_process === void 0 ? void 0 : $827d87e6cea4a030$var$_process.JEST_WORKER_ID) !== undefined;
var $827d87e6cea4a030$var$DEBUG_MODE = !$827d87e6cea4a030$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($827d87e6cea4a030$var$_process2 = globalThis.process) === null || $827d87e6cea4a030$var$_process2 === void 0 || ($827d87e6cea4a030$var$_process2 = $827d87e6cea4a030$var$_process2.env) === null || $827d87e6cea4a030$var$_process2 === void 0 ? void 0 : $827d87e6cea4a030$var$_process2.NODE_ENV) !== 'production';
var $827d87e6cea4a030$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$827d87e6cea4a030$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $5968470e247196e1$var$pkgName = '@atlaskit/platform-feature-flags';
var $5968470e247196e1$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $5968470e247196e1$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $5968470e247196e1$var$ENV_ENABLE_PLATFORM_FF = $5968470e247196e1$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $5968470e247196e1$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $5968470e247196e1$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $5968470e247196e1$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $5968470e247196e1$var$ENV_ENABLE_PLATFORM_FF || $5968470e247196e1$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $5968470e247196e1$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $5968470e247196e1$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$5968470e247196e1$var$globalVar[$5968470e247196e1$export$7e41b1b2bdee3f98] = $5968470e247196e1$var$globalVar[$5968470e247196e1$export$7e41b1b2bdee3f98] || $5968470e247196e1$var$DEFAULT_PFF_GLOBAL;
function $5968470e247196e1$export$f2b591175b3e424c(resolver) {
    $5968470e247196e1$var$globalVar[$5968470e247196e1$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $5968470e247196e1$export$6333b6aff9fc6275(flagKey) {
    if ($5968470e247196e1$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $827d87e6cea4a030$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $5968470e247196e1$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $5968470e247196e1$var$globalVar[$5968470e247196e1$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $5968470e247196e1$var$globalVar[$5968470e247196e1$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $9dOvm.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $5968470e247196e1$var$globalVar[$5968470e247196e1$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $2f7a050164f5fe9d$export$ba05d765b8392e5e(flagResolver) {
    (0, $5968470e247196e1$export$f2b591175b3e424c)(flagResolver);
}
function $2f7a050164f5fe9d$export$470e5c2be1411c89(name) {
    return (0, $5968470e247196e1$export$6333b6aff9fc6275)(name);
}
function $2f7a050164f5fe9d$export$b40ec24ac8275656(name) {
    return (0, $5968470e247196e1$export$6333b6aff9fc6275)(name);
}


/* anchor.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $ekGgq = parcelRequire("ekGgq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


const $ad8defbde93368b8$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $9f5e95bf7cec163b$export$2e2bcd8739ae039)(actualStyles);
};



var $afMOk = parcelRequire("afMOk");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $b740093a2189db93$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b740093a2189db93$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b740093a2189db93$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b740093a2189db93$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b740093a2189db93$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $b740093a2189db93$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $b740093a2189db93$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $b740093a2189db93$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $b740093a2189db93$var$_objectSpread($b740093a2189db93$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $1ade0e8e74b19ca6$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $1ade0e8e74b19ca6$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $1ade0e8e74b19ca6$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1ade0e8e74b19ca6$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1ade0e8e74b19ca6$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $1ade0e8e74b19ca6$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $1ade0e8e74b19ca6$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $1ade0e8e74b19ca6$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $1ade0e8e74b19ca6$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $1ade0e8e74b19ca6$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $b740093a2189db93$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $d149e119cbe17af6$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $d541cb4de8a8fd90$export$5bf35293e545f20c() {
    var analyticsContext = (0, $d149e119cbe17af6$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $1ade0e8e74b19ca6$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $ea324d478d069aa3$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $d327f5950a18ccec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d327f5950a18ccec$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d327f5950a18ccec$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d327f5950a18ccec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d327f5950a18ccec$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $d541cb4de8a8fd90$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $ea324d478d069aa3$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $ea324d478d069aa3$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $d327f5950a18ccec$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $dafd7b0d00589961$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $5FkrB.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $dafd7b0d00589961$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($dafd7b0d00589961$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $dafd7b0d00589961$export$2e2bcd8739ae039 = $dafd7b0d00589961$var$RouterLinkProvider;


/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $7d84243441393339$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $5FkrB.useContext)((0, $dafd7b0d00589961$export$2931e0ee690eee88)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $7d84243441393339$export$2e2bcd8739ae039 = $7d84243441393339$var$useRouterLink;


/**
 * An empty function which does nothing.
 */ function $19baa82873b2e813$export$2e2bcd8739ae039() {}



var $5FkrB = parcelRequire("5FkrB");
function $3e91fe3af3bdf322$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId().replace(/[:«»]/g, '_');
}



/* visually-hidden.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $0e76c406aee5adbd$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $0e76c406aee5adbd$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $9f5e95bf7cec163b$export$2e2bcd8739ae039)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
$0e76c406aee5adbd$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $0e76c406aee5adbd$export$2e2bcd8739ae039 = $0e76c406aee5adbd$var$VisuallyHidden;


/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $18622cb73317b55e$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $18622cb73317b55e$var$_excluded2 = [
    "className"
];
var $18622cb73317b55e$var$focusRingStyles = null;
var $18622cb73317b55e$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $18622cb73317b55e$var$Focusable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $18622cb73317b55e$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $18622cb73317b55e$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $9f5e95bf7cec163b$export$2e2bcd8739ae039)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $18622cb73317b55e$export$2e2bcd8739ae039 = $18622cb73317b55e$var$Focusable;


var $5983675045b23df5$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $5983675045b23df5$var$_excluded2 = [
    "className"
];
var $5983675045b23df5$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
var $5983675045b23df5$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $5983675045b23df5$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $5983675045b23df5$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $19baa82873b2e813$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? '(opens new window)' : _ref$newWindowLabel, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $5983675045b23df5$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $4b5a5d40339b6fdb$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $3e91fe3af3bdf322$export$f680877a34711e37)();
    var onClick = (0, $d327f5950a18ccec$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@atlaskit/primitives",
        packageVersion: "19.0.1",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $5983675045b23df5$var$_excluded2);
    var RouterLink = (0, $7d84243441393339$export$2e2bcd8739ae039)();
    var isExternal = typeof href === 'string' && $5983675045b23df5$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $5983675045b23df5$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(href) === 'object';
    (0, $afMOk.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $5FkrB.createElement((0, $18622cb73317b55e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $ad8defbde93368b8$export$a274e22fb40f762e)($5983675045b23df5$var$styles.root, $5983675045b23df5$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $5FkrB.createElement((0, $0e76c406aee5adbd$export$2e2bcd8739ae039), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $5983675045b23df5$var$Anchor = /*#__PURE__*/ (0, $5FkrB.forwardRef)($5983675045b23df5$var$AnchorNoRef);
var $5983675045b23df5$export$2e2bcd8739ae039 = $5983675045b23df5$var$Anchor;

/* box.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
var $e0a79e92a1e531ec$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');


var $458167a97d876788$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $458167a97d876788$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $458167a97d876788$var$baseStyles = null;
var $458167a97d876788$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhk187o",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $458167a97d876788$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $458167a97d876788$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $458167a97d876788$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $458167a97d876788$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $458167a97d876788$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $458167a97d876788$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $458167a97d876788$var$Box = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $458167a97d876788$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $458167a97d876788$var$_excluded2);
    var node = /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: (0, $9f5e95bf7cec163b$export$2e2bcd8739ae039)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $458167a97d876788$var$backgroundColorMap[backgroundColor],
            backgroundColor && $458167a97d876788$var$isSurfaceToken(backgroundColor) && $458167a97d876788$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $458167a97d876788$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $458167a97d876788$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $458167a97d876788$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $458167a97d876788$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $5FkrB.createElement((0, $e0a79e92a1e531ec$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $458167a97d876788$export$2e2bcd8739ae039 = $458167a97d876788$var$Box;
function $458167a97d876788$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $458167a97d876788$var$setSurfaceTokenMap;
}


var $f3148367fe5261c5$var$_excluded = [
    "children",
    "testId",
    "appearance",
    "newWindowLabel",
    "target",
    "className",
    "style"
];
var $f3148367fe5261c5$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
var $f3148367fe5261c5$var$iconStyles = null;
var $f3148367fe5261c5$var$LinkWithoutRef = function LinkWithoutRef(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, newWindowLabel = _ref.newWindowLabel, target = _ref.target, _preventedClassName = _ref.className, _preventedStyle = _ref.style, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $f3148367fe5261c5$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement((0, $5983675045b23df5$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, htmlAttributes, {
        target: target,
        ref: ref,
        xcss: (0, $51c2ad1cc5d37be6$export$a274e22fb40f762e)($f3148367fe5261c5$var$styles.base, (0, $2f7a050164f5fe9d$export$b40ec24ac8275656)('platform-dst-shape-theme-default') && $f3148367fe5261c5$var$styles.baseT26Shape, appearance === 'default' && $f3148367fe5261c5$var$styles.defaultAppearance, appearance === 'subtle' && $f3148367fe5261c5$var$styles.subtleAppearance, appearance === 'inverse' && $f3148367fe5261c5$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $f3148367fe5261c5$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }), children, target === '_blank' && /*#__PURE__*/ $5FkrB.createElement((0, $458167a97d876788$export$2e2bcd8739ae039), {
        as: "span",
        xcss: $f3148367fe5261c5$var$styles.iconWrapper,
        testId: testId && "".concat(testId, "__icon")
    }, "\uFEFF", /*#__PURE__*/ $5FkrB.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $9f5e95bf7cec163b$export$2e2bcd8739ae039)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ var $f3148367fe5261c5$var$Link = /*#__PURE__*/ (0, $5FkrB.forwardRef)($f3148367fe5261c5$var$LinkWithoutRef);
var $f3148367fe5261c5$export$2e2bcd8739ae039 = $f3148367fe5261c5$var$Link;


function $07f4a2d4e320d534$export$dcf14c9974fe2767(href, linkComponent) {
    var isLink = Boolean(href);
    var LinkComponent = linkComponent !== null && linkComponent !== void 0 ? linkComponent : (0, $f3148367fe5261c5$export$2e2bcd8739ae039);
    return {
        isLink: isLink,
        LinkComponent: LinkComponent
    };
}


/**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $5FkrB = parcelRequire("5FkrB");
/* remove-button.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");


var $d838284193657b59$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a6e34d167858ba514f74d5881b8440fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($d838284193657b59$exports, "__esModule", {
    value: true
});
$d838284193657b59$exports.default = void 0;

var $d838284193657b59$var$_react = $d838284193657b59$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $d838284193657b59$var$_baseNew = $d838284193657b59$var$_interopRequireDefault((parcelRequire("lhDQM")));
function $d838284193657b59$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d838284193657b59$var$CrossIcon = (props)=>/*#__PURE__*/ $d838284193657b59$var$_react.default.createElement($d838284193657b59$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.53 3.53 9.06 8l4.47 4.47-1.06 1.06L8 9.06l-4.47 4.47-1.06-1.06L6.94 8 2.47 3.53l1.06-1.06L8 6.94l4.47-4.47z"/>`
    }, props));
$d838284193657b59$var$CrossIcon.displayName = 'CrossIcon';
var $d838284193657b59$var$_default = $d838284193657b59$exports.default = $d838284193657b59$var$CrossIcon;



var $500725d60421dda6$var$removeButtonStyles = {
    root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i1j6v _1bsb1j6v _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah3idpf _irr31dpa _1di6fcek",
    circle: "_2rko1rr0 _1ah3idpf"
};
var $500725d60421dda6$var$removeButtonStylesNewIcon = {
    root: "_rjxpv77o"
};
var $500725d60421dda6$var$RemoveButton = function RemoveButton(_ref) {
    var ariaLabel = _ref['aria-label'], onClick = _ref.onClick, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onKeyPress = _ref.onKeyPress, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onMouseDown = _ref.onMouseDown, onMouseUp = _ref.onMouseUp, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, testId = _ref.testId, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? 'default' : _ref$shape;
    return /*#__PURE__*/ $5FkrB.createElement((0, $b0e39caa41d1b0a6$export$2e2bcd8739ae039), {
        xcss: (0, $51c2ad1cc5d37be6$export$a274e22fb40f762e)($500725d60421dda6$var$removeButtonStyles.root, shape === 'circle' && $500725d60421dda6$var$removeButtonStyles.circle, $500725d60421dda6$var$removeButtonStylesNewIcon.root),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: testId
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($d838284193657b59$exports))), {
        color: "currentColor",
        label: "",
        size: "small"
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$500725d60421dda6$export$2e2bcd8739ae039 = $500725d60421dda6$var$RemoveButton;


function $57714b2490f0f365$export$97d8be09cd53869b(_ref) {
    var isRemovable = _ref.isRemovable, tagText = _ref.tagText, removeButtonLabel = _ref.removeButtonLabel, testId = _ref.testId, handleRemoveRequest = _ref.handleRemoveRequest, removingTag = _ref.removingTag, showingTag = _ref.showingTag, onKeyPress = _ref.onKeyPress, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? 'default' : _ref$shape, buttonHandlers = _ref.buttonHandlers;
    var handleFocus = (0, $5FkrB.useCallback)(function() {
        removingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onFocus();
    }, [
        removingTag,
        buttonHandlers
    ]);
    var handleBlur = (0, $5FkrB.useCallback)(function() {
        showingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onBlur();
    }, [
        showingTag,
        buttonHandlers
    ]);
    return (0, $5FkrB.useMemo)(function() {
        if (!isRemovable) return undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $500725d60421dda6$export$2e2bcd8739ae039), {
            "aria-label": "".concat(removeButtonLabel || 'Remove', " ").concat(tagText),
            onClick: handleRemoveRequest,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyPress: onKeyPress,
            onMouseEnter: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseEnter,
            onMouseLeave: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseLeave,
            onMouseDown: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseDown,
            testId: testId ? "close-button-".concat(testId) : undefined,
            shape: shape
        });
    }, [
        isRemovable,
        removeButtonLabel,
        tagText,
        handleRemoveRequest,
        handleFocus,
        handleBlur,
        onKeyPress,
        buttonHandlers,
        testId,
        shape
    ]);
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
var $d987394a0281e26f$export$279e7025ed114474 = function defaultBeforeRemoveAction() {
    return true;
};



function $00bc8903c7c5f7be$export$f26019543e9f862f(onBeforeRemoveAction) {
    var _useState = (0, $5FkrB.useState)((0, $afbd375195ac61bc$export$74452314b63acabc).Showing), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var handleRemoveRequest = (0, $5FkrB.useCallback)(function() {
        var beforeAction = onBeforeRemoveAction !== null && onBeforeRemoveAction !== void 0 ? onBeforeRemoveAction : (0, $d987394a0281e26f$export$279e7025ed114474);
        if (beforeAction()) // Defer onAfterRemoveAction until ShrinkOut's onFinish so ExitingPersistence can run
        // the exit animation (e.g. in multi-select and user pickers).
        setStatus((0, $afbd375195ac61bc$export$74452314b63acabc).Removed);
    }, [
        onBeforeRemoveAction
    ]);
    var onKeyPress = (0, $5FkrB.useCallback)(function(e) {
        var spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    var removingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus((0, $afbd375195ac61bc$export$74452314b63acabc).Removing);
    }, []);
    var showingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus((0, $afbd375195ac61bc$export$74452314b63acabc).Showing);
    }, []);
    return {
        status: status,
        handleRemoveRequest: handleRemoveRequest,
        onKeyPress: onKeyPress,
        removingTag: removingTag,
        showingTag: showingTag
    };
}


var $00f43ed5c0571333$var$_excluded = [
    "color",
    "text",
    "elemBefore",
    "href",
    "linkComponent",
    "isRemovable",
    "removeButtonLabel",
    "onBeforeRemoveAction",
    "onAfterRemoveAction",
    "testId",
    "maxWidth",
    "hasMargin",
    "onClick",
    "swatchBefore",
    "trailingMetric"
], $00f43ed5c0571333$var$_excluded2 = [
    "color",
    "text",
    "elemBefore",
    "testId",
    "maxWidth",
    "hasMargin",
    "onClick",
    "isSelected",
    "isLoading",
    "analyticsContext",
    "hasChevron",
    "swatchBefore",
    "trailingMetric"
];
var $00f43ed5c0571333$var$styles = {
    baseStyles: "_zulp1b66 _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1rjcv77o _18zr1mie _1mou1b66 _195g1b66 _1e0c116y _vchhusvi _1ul9idpf _p12ff6dh _4t3i1k92 _kqswh2mm _4cvr1h6o _80om73ad _bfhksm61",
    noMarginStyles: "_1mouze3t _195gze3t",
    removableStyles: "_zulp1b66",
    beforeStyles: "_4bfu1snc _1hmsagmp _ajmmvv82 _1e0c116y _4cvr1h6o _1o9zidpf _syaz125o",
    beforeStylesSelected: "_syazxl6c",
    textStyles: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n _1ul9idpf _syazi7uo",
    textStylesSelected: "_syaz6x5g",
    afterStyles: "_1e0c1txw _4cvr1h6o _1o9zidpf _lcxv1wug _kqswh2mm",
    trailingMetric: "_2rkolb4i _11c8wadc _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _4cvr1h6o _1o9zidpf _1kz6184x _bfhk1w9g _syazi7uo",
    trailingMetricEndPadding: "_y4ti303w",
    focusRingStyles: "_1ygbdfik _1ah3v77o",
    childFocusRingStyles: "_1a37dfik _1cwgv77o",
    interactiveBaseStyles: "_80omtlke _1all1b66 _qsdj1r31 _17ncglyw _15hpnqa1 _1rg815vq _1yoo15vq _j8j91snc _1afaagmp _gdbt10yn _h5vp116y _1qxz1h6o _8zx0idpf _1km4jdj5 _wc1fagmp _9408jdj5 _usew1snc _ebtnagmp _uvk910yn _10nj1r31 _1xq0glyw _18x1nqa1 _2mpsagmp",
    interactiveHoverStyles: "_17501r31 _qrsc8stv _1wodnqa1 _irr31dpa _rlyhjdj5 _1di6fcek"
};
// For accent borders, we use the new color.border.accent.*.subtle tokens (Color300
// light / Color800 dark) which provide proper decorative-border colours
//
// Icons keep color.icon.accent.* in the default state (vibrant on the plain page
// background) and swap to color.text.accent.* in hovered/pressed states (where the
// Tag picks up a coloured background and needs guaranteed 3:1 icon contrast).
var $00f43ed5c0571333$var$colorStyles = {
    gray: "_119bmsup _1ib21diz _egnk1sqi _17x31sqi _ih6z7qp0",
    blue: "_119b18hp _1ib26txe _egnk16jw _17x316jw _ih6z1dy8",
    green: "_119b5d2u _1ib217hp _egnkh55r _17x3h55r _ih6z1wnw",
    red: "_119bn9dc _1ib2nbxb _egnk9lu1 _17x39lu1 _ih6z1rtt",
    yellow: "_119b1s7j _1ib21oqg _egnkfb2s _17x3fb2s _ih6z1773",
    purple: "_119bluwt _1ib2uq3u _egnkqmo9 _17x3qmo9 _ih6z1nm4",
    lime: "_119b1m7d _1ib28645 _egnk1tco _17x31tco _ih6zz2ec",
    magenta: "_119b132u _1ib2v8hk _egnk1s8m _17x31s8m _ih6zv9ra",
    orange: "_119b1ip5 _1ib21j6y _egnkp1lv _17x3p1lv _ih6z165s",
    teal: "_119b131p _1ib28uof _egnk17qg _17x317qg _ih6z1a17"
};
// Border + icon filter styles - base state.
// Borders use the new color.border.accent.*.subtle tokens directly.
// Icons use the color.icon.accent.* tokens directly in the default state.
var $00f43ed5c0571333$var$borderIconFilterStyles = {
    root: "_1h6dip4g _wi6h9ea2"
};
// Border + icon filter styles - interactive states (hover/pressed).
// Icons swap to the color.text.accent.* tokens for guaranteed 3:1 contrast
// against the coloured interactive backgrounds. Borders stay constant.
var $00f43ed5c0571333$var$borderIconInteractiveFilterStyles = {
    root: "_4cvxip4g _zqoiipvw _q4ztip4g _ba35u0j8"
};
var $00f43ed5c0571333$var$dropdownStyles = {
    interactive: "_irr31dpa _1di6fcek",
    selected: "_1h6dq98m _syaz6x5g _bfhk15s3 _irr3ufnl _1di6nozp",
    content: "_zulp1b66 _1reo15vq _18m915vq _1e0c116y _4cvr1h6o _16jlkb7n _1o9zkb7n _1ul9idpf",
    loadingContent: "_tzy4idpf",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw"
};
/**
 * __TagNew__
 *
 * TagNew is the visual uplift implementation of Tag
 */ var $00f43ed5c0571333$var$TagNewComponent = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TagNew(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'gray' : _ref$color, text = _ref.text, elemBefore = _ref.elemBefore, href = _ref.href, linkComponent = _ref.linkComponent, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, removeButtonLabel = _ref.removeButtonLabel, onBeforeRemoveAction = _ref.onBeforeRemoveAction, onAfterRemoveAction = _ref.onAfterRemoveAction, testId = _ref.testId, maxWidth = _ref.maxWidth, _ref$hasMargin = _ref.hasMargin, hasMargin = _ref$hasMargin === void 0 ? true : _ref$hasMargin, onClick = _ref.onClick, swatchBefore = _ref.swatchBefore, trailingMetric = _ref.trailingMetric, other = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $00f43ed5c0571333$var$_excluded);
    var normalizedText = (0, $b7002e514c670cae$export$7d100de1166870f6)(text);
    var _useTagRemoval = (0, $00bc8903c7c5f7be$export$f26019543e9f862f)(onBeforeRemoveAction), status = _useTagRemoval.status, handleRemoveRequest = _useTagRemoval.handleRemoveRequest, onKeyPress = _useTagRemoval.onKeyPress, removingTag = _useTagRemoval.removingTag, showingTag = _useTagRemoval.showingTag;
    var onShrinkOutExitComplete = (0, $5FkrB.useCallback)(function() {
        onAfterRemoveAction === null || onAfterRemoveAction === void 0 || onAfterRemoveAction(normalizedText);
    }, [
        normalizedText,
        onAfterRemoveAction
    ]);
    var _useLink = (0, $07f4a2d4e320d534$export$dcf14c9974fe2767)(href, linkComponent), isLink = _useLink.isLink, LinkComponent = _useLink.LinkComponent;
    var _useButtonInteraction = (0, $14b060b9066053e0$export$84acd183858d8235)(), isLinkHovered = _useButtonInteraction.isLinkHovered, isOverButton = _useButtonInteraction.isOverButton, isButtonFocused = _useButtonInteraction.isButtonFocused, isLinkFocused = _useButtonInteraction.isLinkFocused, buttonHandlers = _useButtonInteraction.buttonHandlers, linkHandlers = _useButtonInteraction.linkHandlers;
    var removeButton = (0, $57714b2490f0f365$export$97d8be09cd53869b)({
        isRemovable: isRemovable,
        tagText: normalizedText,
        removeButtonLabel: removeButtonLabel,
        testId: testId,
        handleRemoveRequest: handleRemoveRequest,
        removingTag: removingTag,
        showingTag: showingTag,
        onKeyPress: onKeyPress,
        buttonHandlers: buttonHandlers
    });
    var tagContent = /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, other, {
        ref: ref,
        "data-testid": testId,
        style: maxWidth !== undefined ? {
            maxWidth: maxWidth
        } : undefined,
        className: (0, $7NBLq.default)([
            $00f43ed5c0571333$var$styles.baseStyles,
            !hasMargin && $00f43ed5c0571333$var$styles.noMarginStyles,
            $00f43ed5c0571333$var$colorStyles[color],
            $00f43ed5c0571333$var$borderIconFilterStyles.root,
            isLink && $00f43ed5c0571333$var$styles.interactiveBaseStyles,
            isLink && $00f43ed5c0571333$var$styles.focusRingStyles,
            isLink && isLinkHovered && !isOverButton && $00f43ed5c0571333$var$borderIconInteractiveFilterStyles.root,
            isLink && isLinkHovered && !isOverButton && $00f43ed5c0571333$var$styles.interactiveHoverStyles,
            isRemovable && $00f43ed5c0571333$var$styles.removableStyles,
            isLinkFocused && !isButtonFocused && $00f43ed5c0571333$var$styles.childFocusRingStyles,
            !isRemovable && trailingMetric != null && trailingMetric !== '' && $00f43ed5c0571333$var$styles.trailingMetricEndPadding
        ])
    }), /*#__PURE__*/ $5FkrB.createElement((0, $76b77f1e120be454$export$ce4b6a469c26f53f), {
        isLink: isLink,
        href: href,
        LinkComponent: LinkComponent,
        testId: testId,
        linkHandlers: linkHandlers,
        onClick: onClick
    }, /*#__PURE__*/ $5FkrB.createElement((0, $aba74707decee077$export$2e2bcd8739ae039), {
        colorKey: color,
        swatchBefore: swatchBefore
    }), elemBefore && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $7NBLq.default)([
            $00f43ed5c0571333$var$styles.beforeStyles
        ])
    }, elemBefore), /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-tag-text": true,
        className: (0, $7NBLq.default)([
            $00f43ed5c0571333$var$styles.textStyles
        ])
    }, normalizedText), trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId && "".concat(testId, "--metric"),
        className: (0, $7NBLq.default)([
            $00f43ed5c0571333$var$styles.trailingMetric
        ])
    }, trailingMetric)), removeButton && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $7NBLq.default)([
            $00f43ed5c0571333$var$styles.afterStyles
        ])
    }, removeButton));
    return /*#__PURE__*/ $5FkrB.createElement((0, $1de29c1ed3c716a8$export$898a500849bb5cf4), {
        isRemovable: isRemovable,
        status: status,
        onShrinkOutExitComplete: isRemovable ? onShrinkOutExitComplete : undefined
    }, tagContent);
});
var $00f43ed5c0571333$export$aba6bd1190e79361 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TagDropdownTrigger(_ref2, ref) {
    var _ref2$color = _ref2.color, color = _ref2$color === void 0 ? 'gray' : _ref2$color, text = _ref2.text, elemBefore = _ref2.elemBefore, testId = _ref2.testId, maxWidth = _ref2.maxWidth, _ref2$hasMargin = _ref2.hasMargin, hasMargin = _ref2$hasMargin === void 0 ? true : _ref2$hasMargin, onClick = _ref2.onClick, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, _analyticsContext = _ref2.analyticsContext, _ref2$hasChevron = _ref2.hasChevron, hasChevron = _ref2$hasChevron === void 0 ? true : _ref2$hasChevron, swatchBefore = _ref2.swatchBefore, trailingMetric = _ref2.trailingMetric, other = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $00f43ed5c0571333$var$_excluded2);
    var resolvedColor = (0, $a37d528f66b9020f$export$3351a8d90bcc13aa)[color] || 'gray';
    return /*#__PURE__*/ $5FkrB.createElement((0, $b0e39caa41d1b0a6$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: ref,
        xcss: (0, $2d3c35f771a6028a$export$a274e22fb40f762e)($00f43ed5c0571333$var$styles.baseStyles, !hasMargin && $00f43ed5c0571333$var$styles.noMarginStyles, $00f43ed5c0571333$var$colorStyles[resolvedColor], $00f43ed5c0571333$var$borderIconFilterStyles.root, $00f43ed5c0571333$var$dropdownStyles.interactive, $00f43ed5c0571333$var$styles.focusRingStyles, $00f43ed5c0571333$var$borderIconInteractiveFilterStyles.root, isSelected && $00f43ed5c0571333$var$dropdownStyles.selected, // Reduce end padding when trailing metric is the last element (no chevron)
        !hasChevron && trailingMetric != null && trailingMetric !== '' && $00f43ed5c0571333$var$styles.trailingMetricEndPadding),
        onClick: isLoading ? undefined : onClick,
        style: {
            borderColor: isSelected ? "var(--ds-border-selected, #1868DB)" : undefined,
            cursor: isLoading ? 'progress' : 'pointer',
            maxWidth: maxWidth !== undefined ? maxWidth : undefined
        }
    }, isLoading && {
        'aria-busy': true,
        'aria-disabled': true,
        isDisabled: true
    }, {
        testId: testId
    }, other), /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $7NBLq.default)([
            $00f43ed5c0571333$var$dropdownStyles.content,
            isLoading && $00f43ed5c0571333$var$dropdownStyles.loadingContent
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $aba74707decee077$export$2e2bcd8739ae039), {
        colorKey: resolvedColor,
        swatchBefore: swatchBefore
    }), elemBefore && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $7NBLq.default)([
            $00f43ed5c0571333$var$styles.beforeStyles,
            isSelected && $00f43ed5c0571333$var$styles.beforeStylesSelected
        ])
    }, elemBefore), /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-tag-text": true,
        className: (0, $7NBLq.default)([
            $00f43ed5c0571333$var$styles.textStyles,
            isSelected && $00f43ed5c0571333$var$styles.textStylesSelected
        ])
    }, (0, $b7002e514c670cae$export$7d100de1166870f6)(text)), trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId && "".concat(testId, "--metric"),
        className: (0, $7NBLq.default)([
            $00f43ed5c0571333$var$styles.trailingMetric
        ])
    }, trailingMetric), hasChevron && /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7d87ab0548ede72e$exports))), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && "".concat(testId, "--chevron")
    })), isLoading && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $7NBLq.default)([
            $00f43ed5c0571333$var$dropdownStyles.loadingOverlay
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $d101d811be8b645e$export$2e2bcd8739ae039), {
        size: 'xsmall',
        label: ", Loading",
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    })));
});
/**
 * __Tag new__
 */ var $00f43ed5c0571333$var$TagNew = /*#__PURE__*/ (0, $5FkrB.memo)($00f43ed5c0571333$var$TagNewComponent);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$00f43ed5c0571333$export$2e2bcd8739ae039 = $00f43ed5c0571333$var$TagNew;



/* base.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $7NBLq = parcelRequire("7NBLq");

var $5FkrB = parcelRequire("5FkrB");
var $0d2dc90083d161de$var$_excluded = [
    "before",
    "contentElement",
    "after",
    "testId",
    "style",
    "color",
    "href",
    "className"
];
function $0d2dc90083d161de$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0d2dc90083d161de$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0d2dc90083d161de$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0d2dc90083d161de$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Border colors - Hardcoded for Visual Refresh - to be removed with labelling system work
var $0d2dc90083d161de$var$borderColors = {
    standard: "_1h6d14je",
    blue: "_1h6duisw",
    red: "_1h6da2c0",
    yellow: "_1h6deh2r",
    green: "_1h6d18uw",
    teal: "_1h6d1ug6",
    purple: "_1h6d157s",
    lime: "_1h6dn0nx",
    magenta: "_1h6d1lf6",
    orange: "_1h6dh727",
    grey: "_1h6d14je",
    standardLink: "_1h6d14je",
    blueLight: "_1h6duisw",
    redLight: "_1h6da2c0",
    yellowLight: "_1h6deh2r",
    greenLight: "_1h6d18uw",
    tealLight: "_1h6d1ug6",
    purpleLight: "_1h6d157s",
    limeLight: "_1h6dn0nx",
    magentaLight: "_1h6d1lf6",
    orangeLight: "_1h6dh727",
    greyLight: "_1h6d14je"
};
var $0d2dc90083d161de$var$baseStyles = null;
var $0d2dc90083d161de$var$interactiveStyles = null;
var $0d2dc90083d161de$var$focusRingStyles = null;
var $0d2dc90083d161de$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function BaseTag(_ref, ref) {
    var before = _ref.before, contentElement = _ref.contentElement, after = _ref.after, testId = _ref.testId, style = _ref.style, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, className = _ref.className, other = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $0d2dc90083d161de$var$_excluded);
    var isLink = Boolean(href);
    var isRemovable = Boolean(after);
    var isInteractive = isLink || isRemovable;
    if (color === 'gray') // internally we use 'grey' for gray color so that we can make migration easier behind the ff (gray will work with and without ff now)
    color = 'grey';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, other, {
        ref: ref,
        style: $0d2dc90083d161de$var$_objectSpread({}, style),
        className: (0, $7NBLq.default)([
            "_zulp1b66 _2rko12b0 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3i1k92 _kqswh2mm _4cvr1h6o _bfhksm61 _syazi7uo _80om73ad",
            isInteractive && "_1e38dfik _7glxv77o",
            isLink && "_irr31dpa _1di6fcek",
            $0d2dc90083d161de$var$borderColors[color],
            className
        ]),
        "data-testid": testId
    }), before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0d2dc90083d161de$export$2e2bcd8739ae039 = $0d2dc90083d161de$var$BaseTag;


/* before.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $7NBLq = parcelRequire("7NBLq");
var $b1ff56f4e9087f7c$var$beforeElementStyles = null;
var $b1ff56f4e9087f7c$var$Before = function Before(_ref) {
    var elemBefore = _ref.elemBefore;
    return elemBefore ? /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $7NBLq.default)([
            "_1e0c1txw _4t3i1j6v _4cvr1h6o _1bah1h6o _152tze3t"
        ])
    }, elemBefore) : null;
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b1ff56f4e9087f7c$export$2e2bcd8739ae039 = $b1ff56f4e9087f7c$var$Before;


/**
 * Maps Tag color values to Lozenge appearance values.
 * Used for migration_fallback rendering when feature flag is off.
 */ var $19e3797c67b539db$var$colorToLozengeAppearanceMap = {
    gray: 'default',
    grey: 'default',
    lime: 'success',
    green: 'success',
    blue: 'inprogress',
    red: 'removed',
    purple: 'new',
    yellow: 'moved',
    orange: 'moved',
    magenta: 'new',
    teal: 'inprogress',
    grayLight: 'default',
    greyLight: 'default',
    limeLight: 'success',
    greenLight: 'success',
    blueLight: 'inprogress',
    redLight: 'removed',
    purpleLight: 'new',
    yellowLight: 'moved',
    orangeLight: 'moved',
    magentaLight: 'new',
    tealLight: 'inprogress'
};
function $19e3797c67b539db$export$4d9e331cafeacb9d(color) {
    return $19e3797c67b539db$var$colorToLozengeAppearanceMap[color || 'gray'] || 'default';
}


/* content.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $7NBLq = parcelRequire("7NBLq");

var $5a4cca70d492c64f$var$baseStyles = null;
var $5a4cca70d492c64f$var$linkStyles = null;
var $5a4cca70d492c64f$var$hasAfterStyles = null;
var $5a4cca70d492c64f$var$Content = function Content(_ref) {
    var _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? '' : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, linkComponent = _ref.linkComponent, testId = _ref.testId;
    var Link = linkComponent !== null && linkComponent !== void 0 ? linkComponent : 'a';
    var normalizedText = (0, $b7002e514c670cae$export$7d100de1166870f6)(text);
    if (href) return /*#__PURE__*/ $5FkrB.createElement(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? "".concat(testId, "--link") : undefined,
        className: (0, $7NBLq.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazi7uo _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3i7uo _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
            isRemovable && "_p12f1lit"
        ])
    }, normalizedText);
    else return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $7NBLq.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            isRemovable && "_p12f1lit"
        ])
    }, normalizedText);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5a4cca70d492c64f$export$2e2bcd8739ae039 = $5a4cca70d492c64f$var$Content;



var $84f27cc5ac764e5d$var$_excluded = [
    "appearance",
    "elemBefore",
    "isRemovable",
    "text",
    "color",
    "href",
    "removeButtonLabel",
    "testId",
    "onBeforeRemoveAction",
    "onAfterRemoveAction",
    "linkComponent",
    "migration_fallback",
    "maxWidth",
    "hasMargin",
    "swatchBefore"
];
var $84f27cc5ac764e5d$var$textLinkCssVar = '--ds-ctl';
var $84f27cc5ac764e5d$var$textDefaultCssVar = '--ds-ct';
var $84f27cc5ac764e5d$var$textActiveCssVar = '--ds-ctp';
var $84f27cc5ac764e5d$var$backgroundHoverCssVar = '--ds-cbh';
var $84f27cc5ac764e5d$var$backgroundActiveCssVar = '--ds-cba';
var $84f27cc5ac764e5d$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($84f27cc5ac764e5d$var$TagStatus || {});
var $84f27cc5ac764e5d$var$packageName = "@atlaskit/tag";
var $84f27cc5ac764e5d$var$packageVersion = "14.15.0";
var $84f27cc5ac764e5d$var$defaultBeforeRemoveAction = function defaultBeforeRemoveAction() {
    return true;
};
/**
 * These hide the focus ring for the tag when its remove button is focused,
 * preventing a double focus ring.
 */ var $84f27cc5ac764e5d$var$removingStyles = null;
var $84f27cc5ac764e5d$var$RemovableTagComponent = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var appearance = _ref.appearance, _ref$elemBefore = _ref.elemBefore, elemBefore = _ref$elemBefore === void 0 ? null : _ref$elemBefore, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? '' : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, removeButtonLabel = _ref.removeButtonLabel, testId = _ref.testId, _ref$onBeforeRemoveAc = _ref.onBeforeRemoveAction, onBeforeRemoveAction = _ref$onBeforeRemoveAc === void 0 ? $84f27cc5ac764e5d$var$defaultBeforeRemoveAction : _ref$onBeforeRemoveAc, _ref$onAfterRemoveAct = _ref.onAfterRemoveAction, onAfterRemoveAction = _ref$onAfterRemoveAct === void 0 ? (0, $784ecc28b84f92e1$export$2e2bcd8739ae039) : _ref$onAfterRemoveAct, linkComponent = _ref.linkComponent, migration_fallback = _ref.migration_fallback, maxWidth = _ref.maxWidth, _ref$hasMargin = _ref.hasMargin, hasMargin = _ref$hasMargin === void 0 ? true : _ref$hasMargin, swatchBefore = _ref.swatchBefore, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $84f27cc5ac764e5d$var$_excluded);
    var _useState = (0, $5FkrB.useState)($84f27cc5ac764e5d$var$TagStatus.Showing), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), isHoverCloseButton = _useState4[0], setIsHoverCloseButton = _useState4[1];
    var normalizedText = (0, $b7002e514c670cae$export$7d100de1166870f6)(text);
    var onAfterRemoveActionWithAnalytics = (0, $ae38a13ac3cadf40$export$53c2b9c37c40e0d8)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $84f27cc5ac764e5d$var$packageName,
            packageVersion: $84f27cc5ac764e5d$var$packageVersion
        }
    }, 'atlaskit');
    var handleRemoveComplete = (0, $5FkrB.useCallback)(function() {
        setStatus($84f27cc5ac764e5d$var$TagStatus.Removed);
    }, []);
    var handleRemoveRequest = (0, $5FkrB.useCallback)(function() {
        if (onBeforeRemoveAction && onBeforeRemoveAction()) {
            onAfterRemoveActionWithAnalytics(normalizedText);
            handleRemoveComplete();
        }
    }, [
        handleRemoveComplete,
        normalizedText,
        onBeforeRemoveAction,
        onAfterRemoveActionWithAnalytics
    ]);
    var onKeyPress = (0, $5FkrB.useCallback)(function(e) {
        var spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    var removingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus($84f27cc5ac764e5d$var$TagStatus.Removing);
    }, []);
    var showingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus($84f27cc5ac764e5d$var$TagStatus.Showing);
    }, []);
    var handleMouseOver = (0, $5FkrB.useCallback)(function() {
        return setIsHoverCloseButton(true);
    }, []);
    var handleMouseOut = (0, $5FkrB.useCallback)(function() {
        return setIsHoverCloseButton(false);
    }, []);
    var removeButton = isRemovable ? /*#__PURE__*/ $5FkrB.createElement((0, $500725d60421dda6$export$2e2bcd8739ae039), {
        "aria-label": "".concat(removeButtonLabel || 'Remove', " ").concat(normalizedText),
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: "close-button-".concat(testId)
    }) : undefined;
    // Handle migration_fallback: render Lozenge when flag is off and migration_fallback is 'lozenge'
    if (migration_fallback === 'lozenge' && !(0, $4dee22873f13f74d$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        var lozengeAppearance = (0, $19e3797c67b539db$export$4d9e331cafeacb9d)(color);
        return /*#__PURE__*/ $5FkrB.createElement((0, $abe7eb499db4bfa4$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            appearance: lozengeAppearance,
            isBold: false,
            testId: testId
        }, rest), normalizedText);
    }
    // Use new TagNew component behind feature flag
    // TagNew handles its own animation internally via RemovableWrapper
    if ((0, $4dee22873f13f74d$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        var newColor = (0, $a37d528f66b9020f$export$3351a8d90bcc13aa)[color || 'standard'];
        return /*#__PURE__*/ $5FkrB.createElement((0, $00f43ed5c0571333$export$2e2bcd8739ae039), {
            ref: ref,
            color: newColor,
            text: normalizedText,
            elemBefore: elemBefore,
            href: href,
            testId: testId,
            isRemovable: isRemovable,
            removeButtonLabel: removeButtonLabel,
            onBeforeRemoveAction: onBeforeRemoveAction,
            onAfterRemoveAction: onAfterRemoveActionWithAnalytics,
            maxWidth: maxWidth,
            hasMargin: hasMargin,
            swatchBefore: swatchBefore
        });
    }
    // Original implementation
    var content = /*#__PURE__*/ $5FkrB.createElement((0, $5a4cca70d492c64f$export$2e2bcd8739ae039), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: normalizedText,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    var hoverCloseButtonColors = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
    }, $84f27cc5ac764e5d$var$backgroundHoverCssVar, undefined), $84f27cc5ac764e5d$var$backgroundActiveCssVar, undefined), $84f27cc5ac764e5d$var$textDefaultCssVar, undefined), $84f27cc5ac764e5d$var$textActiveCssVar, undefined), $84f27cc5ac764e5d$var$textLinkCssVar, undefined);
    return /*#__PURE__*/ $5FkrB.createElement((0, $0fe6287c12490552$export$2e2bcd8739ae039), null, !(status === $84f27cc5ac764e5d$var$TagStatus.Removed) && /*#__PURE__*/ $5FkrB.createElement((0, $1457c78a8b8e5d17$export$2e2bcd8739ae039), {
        key: "atlaskit-removable-tag-legacy-shrink-out",
        onFinish: handleRemoveComplete
    }, function(motion) {
        return /*#__PURE__*/ $5FkrB.createElement((0, $0d2dc90083d161de$export$2e2bcd8739ae039), {
            ref: (0, $68b8a88b732414bf$export$2e2bcd8739ae039)([
                motion.ref,
                ref
            ]),
            appearance: appearance,
            color: color,
            testId: testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
            "data-removable": true,
            "data-removing": status === $84f27cc5ac764e5d$var$TagStatus.Removing,
            "data-ishoverclosebutton": isHoverCloseButton,
            href: href,
            before: /*#__PURE__*/ $5FkrB.createElement((0, $b1ff56f4e9087f7c$export$2e2bcd8739ae039), {
                elemBefore: elemBefore
            }),
            contentElement: content,
            after: removeButton,
            className: (0, $7NBLq.default)([
                status === $84f27cc5ac764e5d$var$TagStatus.Removing && "_z30c1r31 _twwiglyw _1pka1o36 _bqhtfiwo"
            ])
        });
    }));
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ var $84f27cc5ac764e5d$var$RemovableTag = /*#__PURE__*/ (0, $5FkrB.memo)($84f27cc5ac764e5d$var$RemovableTagComponent);
var $84f27cc5ac764e5d$export$2e2bcd8739ae039 = $84f27cc5ac764e5d$var$RemovableTag;



/**
 * Hook to consume the SelectGetStylesContext.
 *
 * @internal — not part of the public API
 */ 
var $5FkrB = parcelRequire("5FkrB");
/**
 * Internal context used to pass the original Select instance's getStyles function
 * down to components like MultiValue, without polluting the public CommonProps API.
 *
 * This allows MultiValue to detect whether getStyles has been overridden on a
 * component instance (e.g. via a custom component wrapper passing a different
 * getStyles prop), by comparing props.getStyles against the original.
 *
 * @internal — not part of the public API
 */ 
var $5FkrB = parcelRequire("5FkrB");
var $925affe3a83b0ba8$export$50727c0a52da4015 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);


var $e55cb7b5e3e57661$export$2a533455c10aa11f = function useSelectGetStyles() {
    return (0, $5FkrB.useContext)((0, $925affe3a83b0ba8$export$50727c0a52da4015));
};


/* multi-value-label.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");

var $ea9cd31ae81cb092$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c8fhey _o5721q9c _y4tiv77o _bozg1b66 _syaz1kw7",
    disabled: "_syaz1gmx",
    ellipsis: "_1bto1l2s"
};
var $ea9cd31ae81cb092$export$544aeea2a5ce08ee = function MultiValueLabel(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isDisabled = _ref.isDisabled, hasEllipsis = _ref.hasEllipsis, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $kplgf.default)([
            $ea9cd31ae81cb092$var$multiValueLabelStyles.root,
            isDisabled && $ea9cd31ae81cb092$var$multiValueLabelStyles.disabled,
            hasEllipsis && $ea9cd31ae81cb092$var$multiValueLabelStyles.ellipsis,
            (0, $865d2b574ca8ba08$export$a274e22fb40f762e)(className, xcss, '-MultiValueLabel')
        ])
    }), children);
};


function $dbc085bfcaa2309b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dbc085bfcaa2309b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dbc085bfcaa2309b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dbc085bfcaa2309b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dbc085bfcaa2309b$var$multiValueTagWrapperStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1mouze3t _195gze3t _4cvr1h6o _1e0c1txw _1ul9ze3t _zdxokb7n _v5ynkb7n _13lsf1ug _3pxh1h6o _d0dz1txw _1ouwze3t"
};
// Tag-like color styles
var $dbc085bfcaa2309b$var$tagLikeColorStyles = {
    gray: "_119b8yml",
    blue: "_119b1w55",
    green: "_119b1crs",
    red: "_119b16y8",
    yellow: "_119bfeiv",
    purple: "_119b1hqq",
    lime: "_119bnf89",
    magenta: "_119buwd0",
    orange: "_119b1b2s",
    teal: "_119b1h3o"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- match TagNew border color logic
var $dbc085bfcaa2309b$var$tagLikeBorderFilterStyles = null;
// Tag-like styles for custom content values (not plain text) when FF is on.
// Mirrors the TagNew component's visual appearance (padding, margins, sizing, colors).
// The container uses tag-like styling while Label/Remove sub-components are preserved
// so custom overrides (e.g. custom aria-labels, rendering objects as data) continue to work.
var $dbc085bfcaa2309b$var$multiValueTagLikeStyles = {
    root: "_1reo15vq _18m915vq _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1mouze3t _195gze3t _1e0c116y _vchhusvi _kqswh2mm _4cvr1h6o _1wpz1h6o _1ul9ze3t _1o9zkb7n _p12ff6dh _4t3i1k92 _bfhksm61 _syazi7uo _80om73ad _3yq3glyw",
    labelWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _11c8wadc _1e0c1txw _4cvr1h6o _1ul9ze3t _1tkeidpf _2a9v1kw7",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk1dpa _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
var $dbc085bfcaa2309b$var$getMultiValueLabelText = function getMultiValueLabelText(children, data) {
    if (typeof children === 'string') return children;
    var label = data === null || data === void 0 ? void 0 : data.label;
    return typeof label === 'string' ? label : '';
};
var $dbc085bfcaa2309b$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, isFocused = props.isFocused, removeProps = props.removeProps, selectProps = props.selectProps, cropWithEllipsis = props.cropWithEllipsis;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    var labelText = $dbc085bfcaa2309b$var$getMultiValueLabelText(children, data);
    var isPlainLabel = typeof children === 'string';
    var ffTagUplifts = (0, $f366b43c8bc426de$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts');
    var _getStyleProps = (0, $ac9e6827c3316393$export$26417cabd806a658)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    }), containerCss = _getStyleProps.css, containerClassName = _getStyleProps.className;
    var _getStyleProps2 = (0, $ac9e6827c3316393$export$26417cabd806a658)(props, 'multiValueLabel', {
        'multi-value__label': true
    }), labelCss = _getStyleProps2.css, labelClassName = _getStyleProps2.className;
    var _getStyleProps3 = (0, $ac9e6827c3316393$export$26417cabd806a658)(props, 'multiValueRemove', {
        'multi-value__remove': true
    }), removeCss = _getStyleProps3.css, removeClassName = _getStyleProps3.className;
    var hasCustomLabel = Label !== (0, $ea9cd31ae81cb092$export$544aeea2a5ce08ee);
    var selectStyles = selectProps.styles;
    var hasCustomMultiValueStyles = Boolean((selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValue) || (selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValueLabel) || (selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValueRemove));
    var selectClassNames = selectProps.classNames;
    var hasCustomMultiValueClassNames = Boolean((selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValue) || (selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValueLabel) || (selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValueRemove));
    // Detect if getStyles was overridden directly on this component instance (e.g. via the
    // components prop wrapper passing a custom getStyles). The context holds the original
    // Select instance's getStyles — a reference inequality means a custom override was passed.
    // When context is absent (e.g. in mocked/test contexts), assume no override.
    var selectGetStyles = (0, $e55cb7b5e3e57661$export$2a533455c10aa11f)();
    var hasOverriddenGetStyles = selectGetStyles !== undefined && props.getStyles !== selectGetStyles;
    var hasCustomContainerStyles = hasCustomMultiValueStyles || hasCustomMultiValueClassNames || hasOverriddenGetStyles;
    if (ffTagUplifts && isPlainLabel && !hasCustomLabel && !hasCustomContainerStyles) {
        var _ref = data !== null && data !== void 0 ? data : {}, elemBefore = _ref.elemBefore, tagColor = _ref.color;
        return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
            className: (0, $kplgf.default)([
                $dbc085bfcaa2309b$var$multiValueTagWrapperStyles.root,
                (0, $865d2b574ca8ba08$export$a274e22fb40f762e)(props.className, containerClassName, props.xcss, '-multiValue')
            ])
        }), /*#__PURE__*/ $5FkrB.createElement((0, $84f27cc5ac764e5d$export$2e2bcd8739ae039), {
            text: labelText,
            isRemovable: !isDisabled,
            removeButtonLabel: "".concat(labelText, ", remove"),
            onBeforeRemoveAction: function onBeforeRemoveAction() {
                var _removeProps$onClick;
                (_removeProps$onClick = removeProps.onClick) === null || _removeProps$onClick === void 0 || _removeProps$onClick.call(removeProps, {});
                return false;
            },
            color: tagColor !== null && tagColor !== void 0 ? tagColor : 'gray',
            elemBefore: elemBefore,
            hasMargin: false
        }));
    }
    // FF on + custom content → tag-like path
    if (ffTagUplifts) {
        var colorKey = data === null || data === void 0 ? void 0 : data.color;
        return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            "data-multi-value-tag-like": "true"
        }, innerProps, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- custom styles.multiValue overrides (e.g. colored borders) must be preserved
            style: containerCss,
            className: (0, $kplgf.default)([
                $dbc085bfcaa2309b$var$multiValueTagLikeStyles.root,
                $dbc085bfcaa2309b$var$tagLikeColorStyles.gray,
                colorKey === 'blue' && $dbc085bfcaa2309b$var$tagLikeColorStyles.blue,
                colorKey === 'green' && $dbc085bfcaa2309b$var$tagLikeColorStyles.green,
                colorKey === 'red' && $dbc085bfcaa2309b$var$tagLikeColorStyles.red,
                colorKey === 'yellow' && $dbc085bfcaa2309b$var$tagLikeColorStyles.yellow,
                colorKey === 'purple' && $dbc085bfcaa2309b$var$tagLikeColorStyles.purple,
                colorKey === 'lime' && $dbc085bfcaa2309b$var$tagLikeColorStyles.lime,
                colorKey === 'magenta' && $dbc085bfcaa2309b$var$tagLikeColorStyles.magenta,
                colorKey === 'orange' && $dbc085bfcaa2309b$var$tagLikeColorStyles.orange,
                colorKey === 'teal' && $dbc085bfcaa2309b$var$tagLikeColorStyles.teal,
                "_1h6dpryq _1k671038 _13muu67f _oe6mmko7 _u8p61h4e _hg5mr3uz _1easrqqc",
                isDisabled && $dbc085bfcaa2309b$var$multiValueTagLikeStyles.disabled,
                isFocused && $dbc085bfcaa2309b$var$multiValueTagLikeStyles.focused,
                (0, $865d2b574ca8ba08$export$a274e22fb40f762e)(props.className, containerClassName, props.xcss, '-multiValue')
            ])
        }), /*#__PURE__*/ $5FkrB.createElement("div", {
            className: (0, $kplgf.default)([
                $dbc085bfcaa2309b$var$multiValueTagLikeStyles.labelWrapper
            ])
        }, /*#__PURE__*/ $5FkrB.createElement(Label, {
            data: data,
            innerProps: {
                style: labelCss,
                className: labelClassName
            },
            className: labelClassName,
            hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
            selectProps: selectProps
        }, children)), /*#__PURE__*/ $5FkrB.createElement(Remove, {
            data: data,
            innerProps: $dbc085bfcaa2309b$var$_objectSpread({
                style: removeCss,
                className: removeClassName,
                role: 'button',
                tabIndex: -1,
                'aria-label': "".concat(labelText || 'option', ", remove")
            }, removeProps),
            className: removeClassName,
            isDisabled: isDisabled,
            selectProps: selectProps
        }));
    }
    // FF off → default styles
    return /*#__PURE__*/ $5FkrB.createElement(Container, {
        data: data,
        innerProps: $dbc085bfcaa2309b$var$_objectSpread({
            style: containerCss,
            className: containerClassName
        }, innerProps),
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps
    }, /*#__PURE__*/ $5FkrB.createElement(Label, {
        data: data,
        innerProps: {
            style: labelCss,
            className: labelClassName
        },
        className: labelClassName,
        hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
        selectProps: selectProps
    }, children), /*#__PURE__*/ $5FkrB.createElement(Remove, {
        data: data,
        innerProps: $dbc085bfcaa2309b$var$_objectSpread({
            style: removeCss,
            className: removeClassName,
            role: 'button',
            tabIndex: -1,
            'aria-label': "".concat(labelText || 'option', ", remove")
        }, removeProps),
        className: removeClassName,
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dbc085bfcaa2309b$export$2e2bcd8739ae039 = $dbc085bfcaa2309b$var$MultiValue;



/* multi-value-remove.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");

var $fdf9ed0b0605978a$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a6e34d167858ba514f74d5881b8440fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($fdf9ed0b0605978a$exports, "__esModule", {
    value: true
});
$fdf9ed0b0605978a$exports.default = void 0;

var $fdf9ed0b0605978a$var$_react = $fdf9ed0b0605978a$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $fdf9ed0b0605978a$var$_baseNew = $fdf9ed0b0605978a$var$_interopRequireDefault((parcelRequire("k8BjC")));
function $fdf9ed0b0605978a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fdf9ed0b0605978a$var$CrossIcon = (props)=>/*#__PURE__*/ $fdf9ed0b0605978a$var$_react.default.createElement($fdf9ed0b0605978a$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.53 3.53 9.06 8l4.47 4.47-1.06 1.06L8 9.06l-4.47 4.47-1.06-1.06L6.94 8 2.47 3.53l1.06-1.06L8 6.94l4.47-4.47z"/>`
    }, props));
$fdf9ed0b0605978a$var$CrossIcon.displayName = 'CrossIcon';
var $fdf9ed0b0605978a$var$_default = $fdf9ed0b0605978a$exports.default = $fdf9ed0b0605978a$var$CrossIcon;


var $eb58837bc15495c1$var$disabledStyles = null;
var $eb58837bc15495c1$var$enabledStyles = null;
var $eb58837bc15495c1$var$multiValueRemoveStyles = {
    focused: "_bfhkb1q9 _lswu6x5g",
    root: "_19itglyw _2rko12b0 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _1e0c1txw _lswui7uo _1q51v77o _y4tiv77o _85i5v77o _bozgv77o _12l2v77o _1ah312gs _irr31dpa _13br1tmw _1di6fcek _i5f81tmw"
};
function $eb58837bc15495c1$export$8e1fd1a40e7a2f4a(_ref) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, innerProps = _ref.innerProps, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $kplgf.default)([
            $eb58837bc15495c1$var$multiValueRemoveStyles.root,
            isFocused && $eb58837bc15495c1$var$multiValueRemoveStyles.focused,
            (0, $865d2b574ca8ba08$export$a274e22fb40f762e)(className, xcss, '-MultiValueRemove')
        ])
    }), /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
        className: (0, $kplgf.default)([
            isDisabled && "_1e0cglyw",
            !isDisabled && "_1e0c1kw7"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fdf9ed0b0605978a$exports))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
}


/* option.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");


var $451efba6d73717a4$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syazi7uo _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di6fcek",
    disabled: "_syaz1gmx _80om13gf _bfhk1j28 _16qsglyw _1di61j28 _112eglyw",
    focused: "_bfhk1dpa _16qs1x9r _112e5u6v",
    selected: "_syaz6x5g _bfhk15s3 _16qs1x9r _1di6nozp _112e5u6v",
    focusedSelected: "_bfhkufnl"
};
var $451efba6d73717a4$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $ac9e6827c3316393$export$26417cabd806a658)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $kplgf.default)([
            $451efba6d73717a4$var$optionStyles.root,
            isFocused && $451efba6d73717a4$var$optionStyles.focused,
            isSelected && $451efba6d73717a4$var$optionStyles.selected,
            isFocused && isSelected && $451efba6d73717a4$var$optionStyles.focusedSelected,
            isDisabled && $451efba6d73717a4$var$optionStyles.disabled,
            (0, $865d2b574ca8ba08$export$a274e22fb40f762e)(className, xcss, '-option')
        ]),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$451efba6d73717a4$export$2e2bcd8739ae039 = $451efba6d73717a4$var$Option;


/* placeholder.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");


var $9f233418c7cb4308$var$placeholderStyles = {
    root: "_nd5l1sux _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syaz1rpy",
    disabled: "_syaz1gmx"
};
var $9f233418c7cb4308$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, xcss = props.xcss;
    var _getStyleProps = (0, $ac9e6827c3316393$export$26417cabd806a658)(props, 'placeholder', {
        placeholder: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $kplgf.default)([
            $9f233418c7cb4308$var$placeholderStyles.root,
            isDisabled && $9f233418c7cb4308$var$placeholderStyles.disabled,
            (0, $865d2b574ca8ba08$export$a274e22fb40f762e)(className, xcss, '-placeholder')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9f233418c7cb4308$export$2e2bcd8739ae039 = $9f233418c7cb4308$var$Placeholder;


/* single-value.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");


var $6fd83c0b3c7ff0a6$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syazi7uo",
    disalbed: "_syaz1gmx"
};
var $6fd83c0b3c7ff0a6$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $ac9e6827c3316393$export$26417cabd806a658)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $kplgf.default)([
            $6fd83c0b3c7ff0a6$var$styles.root,
            isDisabled && $6fd83c0b3c7ff0a6$var$styles.disalbed,
            (0, $865d2b574ca8ba08$export$a274e22fb40f762e)(className, xcss, '-singleValue')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6fd83c0b3c7ff0a6$export$2e2bcd8739ae039 = $6fd83c0b3c7ff0a6$var$SingleValue;


function $de5e6bb37d0375f4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $de5e6bb37d0375f4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $de5e6bb37d0375f4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $de5e6bb37d0375f4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $de5e6bb37d0375f4$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $23da9f503fee4d68$export$ecf9cf59142dd54a),
    Control: (0, $c40f4e2f8ec9aafa$export$2e2bcd8739ae039),
    DropdownIndicator: (0, $e420c52a445c8c12$export$ec98719d3db7f2e4),
    Group: (0, $53cf7edb74ae36f8$export$2e2bcd8739ae039),
    GroupHeading: (0, $c385c892c3112915$export$85c8b41a3cd87edc),
    IndicatorsContainer: (0, $bc12c8b5d0aba571$export$d0ffd7e649cab6f),
    Input: (0, $6464be408c5bbddb$export$2e2bcd8739ae039),
    LoadingIndicator: (0, $8426adcf6875d21c$export$7c20be4c1d342248),
    Menu: (0, $195c12e5177a207f$export$2e2bcd8739ae039),
    MenuList: (0, $6e7391b418742df6$export$d4c4e98c5044dc8),
    MenuPortal: (0, $3752472734d435ca$export$793392f970497feb),
    LoadingMessage: (0, $3c26ff6e56099c2b$export$e928a71d039d3102),
    NoOptionsMessage: (0, $30ea6eca843fb406$export$d58b72b7d3c4072c),
    MultiValue: (0, $dbc085bfcaa2309b$export$2e2bcd8739ae039),
    MultiValueContainer: (0, $498272d93eb16769$export$cf9cf2a30a59265c),
    MultiValueLabel: (0, $ea9cd31ae81cb092$export$544aeea2a5ce08ee),
    MultiValueRemove: (0, $eb58837bc15495c1$export$8e1fd1a40e7a2f4a),
    Option: (0, $451efba6d73717a4$export$2e2bcd8739ae039),
    Placeholder: (0, $9f233418c7cb4308$export$2e2bcd8739ae039),
    SelectContainer: (0, $9ddf52c777f4b036$export$446eebadefe1123b),
    SingleValue: (0, $6fd83c0b3c7ff0a6$export$2e2bcd8739ae039),
    ValueContainer: (0, $89d4f4b87f906dc6$export$4dc9f58ad9a1a000)
};
var $de5e6bb37d0375f4$export$71abc632aa29e6fe = function defaultComponents(props) {
    return $de5e6bb37d0375f4$var$_objectSpread($de5e6bb37d0375f4$var$_objectSpread({}, $de5e6bb37d0375f4$export$9b5ac10f59f76296), props.components);
};


/* dummy-input.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");
var $2a5dfe1a3424c47d$var$_excluded = [
    "innerRef"
];
var $2a5dfe1a3424c47d$var$removeProps = function removeProps(propsObj) {
    for(var _len = arguments.length, properties = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)properties[_key - 1] = arguments[_key];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $2a5dfe1a3424c47d$var$dummyInputStyles = null;
function $2a5dfe1a3424c47d$export$2e2bcd8739ae039(_ref5) {
    var innerRef = _ref5.innerRef, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref5, $2a5dfe1a3424c47d$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = $2a5dfe1a3424c47d$var$removeProps(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: innerRef,
        className: (0, $kplgf.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d1j28 _syaz1j28 _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ])
    }, filteredProps));
}



var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");
var $b057f6c02ca907ff$export$a7265767c78f9bae = {
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? "option ".concat(label, ", deselected") : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? "option ".concat(label, ", selected.") : '';
            default:
                return '';
        }
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return inputValue ? "".concat(resultsMessage, " for search term ").concat(inputValue, ".") : '';
    }
};


/* a11y-text.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");
// Assistive text to describe visual elements. Hidden for sighted users.
var $57a911262f4e6886$var$styles = null;
var $57a911262f4e6886$var$A11yText = function A11yText(props) {
    return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $kplgf.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _uiztglyw _o5721q9c",
            "-a11yText"
        ])
    }, props));
};
var $57a911262f4e6886$export$2e2bcd8739ae039 = $57a911262f4e6886$var$A11yText;


function $509727e7da2e808a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $509727e7da2e808a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $509727e7da2e808a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $509727e7da2e808a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Root Container
// ==============================
var $509727e7da2e808a$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isOptionDisabled = selectProps.isOptionDisabled, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, isLoading = selectProps.isLoading;
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $5FkrB.useMemo)(function() {
        return $509727e7da2e808a$var$_objectSpread($509727e7da2e808a$var$_objectSpread({}, (0, $b057f6c02ca907ff$export$a7265767c78f9bae)), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $5FkrB.useMemo)(function() {
        var message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            var onChangeProps = $509727e7da2e808a$var$_objectSpread({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    var ariaResults = (0, $5FkrB.useMemo)(function() {
        var resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ScreenReaderText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        id: "aria-results"
    }, ariaResults));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $57a911262f4e6886$export$2e2bcd8739ae039), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $57a911262f4e6886$export$2e2bcd8739ae039), {
        "aria-live": ariaLive // Should be undefined by default unless a specific use case requires it
        ,
        role: "status"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$509727e7da2e808a$export$2e2bcd8739ae039 = $509727e7da2e808a$var$LiveRegion;



var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");


function $b9b814ad33a9873a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b9b814ad33a9873a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b9b814ad33a9873a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b9b814ad33a9873a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b9b814ad33a9873a$var$noop = (0, $f9d235c635a41ace$export$2e2bcd8739ae039);
function $b9b814ad33a9873a$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
function $b9b814ad33a9873a$var$isDocumentElement(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $b9b814ad33a9873a$var$normalizedHeight(el) {
    if ($b9b814ad33a9873a$var$isDocumentElement(el)) return window.innerHeight;
    return el.clientHeight;
}
function $b9b814ad33a9873a$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($b9b814ad33a9873a$var$isDocumentElement(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $b9b814ad33a9873a$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $b9b814ad33a9873a$var$getScrollTop(el) {
    if ($b9b814ad33a9873a$var$isDocumentElement(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $b9b814ad33a9873a$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $b9b814ad33a9873a$var$noop;
    var start = $b9b814ad33a9873a$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $b9b814ad33a9873a$var$easeOutCubic(currentTime, start, change, duration);
        $b9b814ad33a9873a$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $b9b814ad33a9873a$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $b9b814ad33a9873a$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $b9b814ad33a9873a$var$normalizedHeight(scrollParent);
    var scrollTop = $b9b814ad33a9873a$var$getScrollTop(scrollParent);
    var menuTopFromParent = menuTop;
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTopFromParent;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $b9b814ad33a9873a$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $b9b814ad33a9873a$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $b9b814ad33a9873a$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $b9b814ad33a9873a$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $b9b814ad33a9873a$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
var $b9b814ad33a9873a$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
// NOTE: internal only
// eslint-disable-next-line @repo/internal/react/require-jsdoc
// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Menu placer__
 *
 * A menu placer {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ var $b9b814ad33a9873a$var$MenuPlacer = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView;
    var _ref2 = (0, $5FkrB.useContext)((0, $54783dc573eaff35$export$e001f626511a0ead)) || {}, setPortalPlacement = _ref2.setPortalPlacement;
    var ref = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)(maxMenuHeight), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    // The minimum height of the control
    var controlHeight = 38;
    (0, $5FkrB.useLayoutEffect)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $b9b814ad33a9873a$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: $b9b814ad33a9873a$var$_objectSpread($b9b814ad33a9873a$var$_objectSpread({}, props), {}, {
            placement: placement || $b9b814ad33a9873a$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $b9b814ad33a9873a$export$2e2bcd8739ae039 = $b9b814ad33a9873a$var$MenuPlacer;



var $25nEq = parcelRequire("25nEq");

var $cvlyC = parcelRequire("cvlyC");
var $114557f07b4d8bb7$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $114557f07b4d8bb7$var$anyDiacritic = new RegExp('[' + $114557f07b4d8bb7$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $114557f07b4d8bb7$var$diacriticToBase = {};
for(var $114557f07b4d8bb7$var$i = 0; $114557f07b4d8bb7$var$i < $114557f07b4d8bb7$var$diacritics.length; $114557f07b4d8bb7$var$i++){
    var $114557f07b4d8bb7$var$diacritic = $114557f07b4d8bb7$var$diacritics[$114557f07b4d8bb7$var$i];
    for(var $114557f07b4d8bb7$var$j = 0; $114557f07b4d8bb7$var$j < $114557f07b4d8bb7$var$diacritic.letters.length; $114557f07b4d8bb7$var$j++)$114557f07b4d8bb7$var$diacriticToBase[$114557f07b4d8bb7$var$diacritic.letters[$114557f07b4d8bb7$var$j]] = $114557f07b4d8bb7$var$diacritic.base;
}
var $114557f07b4d8bb7$export$b5bee4b27048330b = function stripDiacritics(str) {
    return str.replace($114557f07b4d8bb7$var$anyDiacritic, function(match) {
        return $114557f07b4d8bb7$var$diacriticToBase[match];
    });
};


function $d998080e8bc09b8a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d998080e8bc09b8a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d998080e8bc09b8a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d998080e8bc09b8a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d998080e8bc09b8a$var$memoizedStripDiacriticsForInput = (0, $cvlyC.default)((0, $114557f07b4d8bb7$export$b5bee4b27048330b));
var $d998080e8bc09b8a$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $d998080e8bc09b8a$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $d998080e8bc09b8a$export$5d81789ff4aeccdf = function createFilter(config) {
    return function(option, rawInput) {
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = $d998080e8bc09b8a$var$_objectSpread({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $d998080e8bc09b8a$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $d998080e8bc09b8a$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $d998080e8bc09b8a$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $d998080e8bc09b8a$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $114557f07b4d8bb7$export$b5bee4b27048330b)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};


/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $555afa5e7bb77172$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $555afa5e7bb77172$export$ce4ab0c55987d1ff(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($555afa5e7bb77172$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}



var $ekGgq = parcelRequire("ekGgq");
var $8162cb3f617e161f$export$33f062f47f21a01 = function cleanValue(value) {
    if (Array.isArray(value)) return value.filter(Boolean);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};


function $fe6f4de01b5477b7$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}


function $c2ccd4bd6c20d8e9$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $f3303db4f0f290a8$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $8b0a637238906099$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $b3f11431917f9aef$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $8b0a637238906099$export$644a49f3b8c50fcd));
    return namespace;
}


function $47fc0daed1656475$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $f3303db4f0f290a8$export$5fbf4d7fae6cdc00));
    var namespace = (0, $b3f11431917f9aef$export$1d57e79091cc3046)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}


function $f432a850848ad829$export$17baa7c95b6ba1b8(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose;
    // @ts-ignore - hot-116676
    (0, $47fc0daed1656475$export$469bb693f11edc7f)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}


/* required-input.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $kplgf = parcelRequire("kplgf");

var $f08221d75ac04f18$var$styles = null;
var $f08221d75ac04f18$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return /*#__PURE__*/ $5FkrB.createElement("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        className: (0, $kplgf.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $f9d235c635a41ace$export$2e2bcd8739ae039)
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f08221d75ac04f18$export$2e2bcd8739ae039 = $f08221d75ac04f18$var$RequiredInput;



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
// ==============================
// Passive Event Detector
// ==============================

var $8ba1438c52eb387d$var$noop = (0, $f9d235c635a41ace$export$2e2bcd8739ae039);
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $8ba1438c52eb387d$var$passiveOptionAccessed = false;
var $8ba1438c52eb387d$var$options = {
    get passive () {
        return $8ba1438c52eb387d$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $8ba1438c52eb387d$var$w = typeof window !== 'undefined' ? window : {};
if ($8ba1438c52eb387d$var$w.addEventListener && $8ba1438c52eb387d$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $8ba1438c52eb387d$var$w.addEventListener('p', $8ba1438c52eb387d$var$noop, $8ba1438c52eb387d$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $8ba1438c52eb387d$var$w.removeEventListener('p', $8ba1438c52eb387d$var$noop, false);
}
var $8ba1438c52eb387d$export$b0622a6911dbeaf5 = $8ba1438c52eb387d$var$passiveOptionAccessed;


var $4cbae2ca05881984$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $4cbae2ca05881984$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $5FkrB.useRef)(false);
    var isTop = (0, $5FkrB.useRef)(false);
    var touchStart = (0, $5FkrB.useRef)(0);
    var scrollTarget = (0, $5FkrB.useRef)(null);
    var handleEventDelta = (0, $5FkrB.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $4cbae2ca05881984$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $5FkrB.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $5FkrB.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $5FkrB.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $5FkrB.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $8ba1438c52eb387d$export$b0622a6911dbeaf5) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $5FkrB.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $ff73f0f89e2fb3a7$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $ff73f0f89e2fb3a7$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $ff73f0f89e2fb3a7$var$preventTouchMove(e) {
    e.preventDefault();
}
function $ff73f0f89e2fb3a7$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $ff73f0f89e2fb3a7$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $ff73f0f89e2fb3a7$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $ff73f0f89e2fb3a7$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $ff73f0f89e2fb3a7$var$activeScrollLocks = 0;
var $ff73f0f89e2fb3a7$var$listenerOptions = {
    capture: false,
    passive: false
};
function $ff73f0f89e2fb3a7$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $5FkrB.useRef)({});
    var scrollTarget = (0, $5FkrB.useRef)(null);
    var addScrollLock = (0, $5FkrB.useCallback)(function(touchScrollTarget) {
        if (!$ff73f0f89e2fb3a7$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $ff73f0f89e2fb3a7$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $ff73f0f89e2fb3a7$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($ff73f0f89e2fb3a7$var$LOCK_STYLES).forEach(function(key) {
                var val = $ff73f0f89e2fb3a7$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $ff73f0f89e2fb3a7$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $ff73f0f89e2fb3a7$var$preventTouchMove, $ff73f0f89e2fb3a7$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $ff73f0f89e2fb3a7$var$preventInertiaScroll, $ff73f0f89e2fb3a7$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $ff73f0f89e2fb3a7$var$allowTouchMove, $ff73f0f89e2fb3a7$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $ff73f0f89e2fb3a7$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $5FkrB.useCallback)(function(touchScrollTarget) {
        if (!$ff73f0f89e2fb3a7$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $ff73f0f89e2fb3a7$var$activeScrollLocks = Math.max($ff73f0f89e2fb3a7$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $ff73f0f89e2fb3a7$var$activeScrollLocks < 1) $ff73f0f89e2fb3a7$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $ff73f0f89e2fb3a7$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $ff73f0f89e2fb3a7$var$preventTouchMove, $ff73f0f89e2fb3a7$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $ff73f0f89e2fb3a7$var$preventInertiaScroll, $ff73f0f89e2fb3a7$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $ff73f0f89e2fb3a7$var$allowTouchMove, $ff73f0f89e2fb3a7$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}


var $dc28e183e7decdd3$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $dc28e183e7decdd3$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = (0, $4cbae2ca05881984$export$2e2bcd8739ae039)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = (0, $ff73f0f89e2fb3a7$export$2e2bcd8739ae039)({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, lockEnabled && /*#__PURE__*/ // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        onClick: $dc28e183e7decdd3$var$blurSelectInput,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            position: 'fixed',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockStart: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineStart: 0
        }
    }), children(targetRef));
}



function $5ee57e72cf234a71$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ((0, $fe6f4de01b5477b7$export$d8a62a489b442872)(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}



function $61782cccc1e3c000$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}


function $0804185e76505745$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}


function $688ea211cffbe405$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $688ea211cffbe405$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $688ea211cffbe405$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $688ea211cffbe405$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $688ea211cffbe405$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $688ea211cffbe405$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $688ea211cffbe405$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($688ea211cffbe405$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $688ea211cffbe405$var$noop = (0, $f9d235c635a41ace$export$2e2bcd8739ae039);
function $688ea211cffbe405$var$notNullish(item) {
    return item != null;
}
function $688ea211cffbe405$var$scrollIntoView(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) (0, $5ee57e72cf234a71$export$3f99968195accfaf)(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) (0, $5ee57e72cf234a71$export$3f99968195accfaf)(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $688ea211cffbe405$var$isMobileDevice() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (_unused) {
        return false;
    }
}
function $688ea211cffbe405$var$isTouchCapable() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (_unused2) {
        return false;
    }
}
/**
 * Filters out unsupported selectors (e.g., pseudo-classes, complex selectors) from a styles object.
 * @param styles - The styles object to filter.
 * @returns A new object containing only supported styles.
 */ var $688ea211cffbe405$var$filterUnsupportedSelectors = function filterUnsupportedSelectors(styles) {
    var unsupportedSelectors = [
        ':',
        // pseudo-classes/elements
        '[',
        // attribute selectors
        '>',
        // child combinator
        '+',
        // adjacent sibling combinator
        '~',
        // general sibling combinator
        ' ',
        // descendant combinator
        '*',
        // universal selector
        '#',
        // ID selector
        '.',
        // class selector
        '@',
        // at-rules
        '&',
        // parent selector
        '|',
        // namespace separator
        '^',
        // starts with
        '$',
        // ends with
        '=' // equals
    ];
    return Object.keys(styles).reduce(function(filteredStyles, key) {
        if (!unsupportedSelectors.some(function(selector) {
            return key.includes(selector);
        })) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};
var $688ea211cffbe405$var$elemBeforeCSS = null;
var $688ea211cffbe405$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: $688ea211cffbe405$var$isTouchCapable(),
    captureMenuScroll: !$688ea211cffbe405$var$isTouchCapable(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $d998080e8bc09b8a$export$5d81789ff4aeccdf)(),
    formatGroupLabel: (0, $7c03f6656844599b$export$f4da216a6ca54656),
    getOptionLabel: (0, $40a615bc6e150de0$export$dac6ace3020563ca),
    getOptionValue: (0, $3aa0d68e1ea1ddc1$export$40be908210c5a79c),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $f80ef9501f701871$export$56bd0c8d90db075),
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !$688ea211cffbe405$var$isMobileDevice(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false
};
function $688ea211cffbe405$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $688ea211cffbe405$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $688ea211cffbe405$var$_isOptionSelected(props, option, selectValue);
    var label = $688ea211cffbe405$var$getOptionLabel(props, option);
    var value = $688ea211cffbe405$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $688ea211cffbe405$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        //@ts-ignore
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $688ea211cffbe405$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $688ea211cffbe405$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $688ea211cffbe405$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $688ea211cffbe405$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter($688ea211cffbe405$var$notNullish);
}
function $688ea211cffbe405$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $688ea211cffbe405$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $688ea211cffbe405$var$buildFocusableOptions(props, selectValue) {
    return $688ea211cffbe405$var$buildFocusableOptionsFromCategorizedOptions($688ea211cffbe405$var$buildCategorizedOptions(props, selectValue));
}
function $688ea211cffbe405$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$688ea211cffbe405$var$shouldHideSelectedOptions(props) || !isSelected) && $688ea211cffbe405$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $688ea211cffbe405$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $688ea211cffbe405$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $688ea211cffbe405$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $688ea211cffbe405$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $688ea211cffbe405$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $688ea211cffbe405$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $688ea211cffbe405$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $688ea211cffbe405$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $688ea211cffbe405$var$getOptionValue(props, i) === candidate;
    });
}
function $688ea211cffbe405$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $688ea211cffbe405$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $688ea211cffbe405$var$instanceId = 1;
// eslint-disable-next-line @repo/internal/react/no-class-components, @atlaskit/volt-strict-mode/no-multiple-exports
var $688ea211cffbe405$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Select);
        _this = $688ea211cffbe405$var$_callSuper(this, Select, [
            _props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "state", {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        });
        // Misc. Instance Properties
        // ------------------------------
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "blockOptionHover", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "isComposing", false);
        // TODO
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "initialTouchX", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "initialTouchY", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "openAfterFocus", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "scrollToFocusedOptionOnUpdate", false);
        // Refs
        // ------------------------------
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "controlRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getControlRef", function(ref) {
            _this.controlRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "focusedOptionRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getFocusedOptionRef", function(ref) {
            _this.focusedOptionRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "menuListRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getMenuListRef", function(ref) {
            _this.menuListRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "inputRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getInputRef", function(ref) {
            _this.inputRef = ref;
        });
        // aliased for consumers
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "focus", _this.focusInput);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "blur", _this.blurInput);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onChange", function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "setValue", function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "selectOption", function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $c2ccd4bd6c20d8e9$export$d1ca752ec761b95b)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $c2ccd4bd6c20d8e9$export$d1ca752ec761b95b)([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $61782cccc1e3c000$export$dea4763e29237f4c)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $61782cccc1e3c000$export$dea4763e29237f4c)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "removeValue", function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $0804185e76505745$export$40fb9515c784cc3b)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clearValue", function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $0804185e76505745$export$40fb9515c784cc3b)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "popValue", function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $0804185e76505745$export$40fb9515c784cc3b)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        });
        // ==============================
        // Getters
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getFocusedOptionId", function(focusedOption) {
            return $688ea211cffbe405$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getFocusableOptionsWithIds", function() {
            return $688ea211cffbe405$var$buildFocusableOptionsWithIds($688ea211cffbe405$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getValue", function() {
            return _this.state.selectValue;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "cx", function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $555afa5e7bb77172$export$ce4ab0c55987d1ff).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getOptionLabel", function(data) {
            return $688ea211cffbe405$var$getOptionLabel(_this.props, data);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getOptionValue", function(data) {
            return $688ea211cffbe405$var$getOptionValue(_this.props, data);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getStyles", function(key, props) {
            var base = {
                boxSizing: 'border-box'
            };
            var custom = _this.props.styles[key];
            if (custom) return $688ea211cffbe405$var$filterUnsupportedSelectors(custom(base, props));
            return base;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getClassNames", function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getElementId", function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getComponents", function() {
            return (0, $de5e6bb37d0375f4$export$71abc632aa29e6fe)(_this.props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "buildCategorizedOptions", function() {
            return $688ea211cffbe405$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getCategorizedOptions", function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "buildFocusableOptions", function() {
            return $688ea211cffbe405$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getFocusableOptions", function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        });
        // ==============================
        // Helpers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "ariaOnChange", function(value, actionMeta) {
            _this.setState({
                ariaSelection: $688ea211cffbe405$var$_objectSpread({
                    value: value
                }, actionMeta)
            });
        });
        // ==============================
        // Mouse Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onMenuMouseDown", function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onMenuMouseMove", function(_) {
            _this.blockOptionHover = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onControlMouseDown", function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                var _this$controlRef;
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!((_this$controlRef = _this.controlRef) !== null && _this$controlRef !== void 0 && _this$controlRef.closest('[data-rbd-draggable-context-id]'))) return;
            }
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onDropdownIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onClearIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onScroll", function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $fe6f4de01b5477b7$export$d8a62a489b442872)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onCompositionStart", function() {
            _this.isComposing = true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onCompositionEnd", function() {
            _this.isComposing = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onTouchStart", function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onTouchMove", function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onControlTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onClearIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onDropdownIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        });
        // ==============================
        // Focus Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "handleInputChange", function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onInputFocus", function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onInputBlur", function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            if ((0, $f366b43c8bc426de$export$b40ec24ac8275656)('platform_dst_select_menu_close_on_blur')) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            _this.props.menuIsOpen && _this.onMenuClose();
            else _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onOptionHover", function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "shouldHideSelectedOptions", function() {
            return $688ea211cffbe405$var$shouldHideSelectedOptions(_this.props);
        });
        // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onValueInputFocus", function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        });
        // ==============================
        // Keyboard Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onKeyDown", function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus, shouldPreventEscapePropagation = _this$props5.shouldPreventEscapePropagation;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) _this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                        if (shouldPreventEscapePropagation && event.target instanceof HTMLElement) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "handleOpenLayerObserverCloseSignal", function() {
            _this.onMenuClose();
        });
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$688ea211cffbe405$var$instanceId);
        _this.state.selectValue = (0, $8162cb3f617e161f$export$33f062f47f21a01)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $688ea211cffbe405$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(Select, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) $688ea211cffbe405$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    $688ea211cffbe405$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                var focusedOption = focusableOptions[openAtIndex];
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusedOption,
                    focusedOptionId: this.getFocusedOptionId(focusedOption)
                }, function() {
                    return _this2.onMenuOpen();
                });
                (0, $56c8837ddb74a576$export$95df08bae54cb4df)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
            }
        },
        {
            key: "updateInputLabel",
            value: function updateInputLabel(inputLabel) {
                var _this3 = this;
                if (inputLabel) {
                    var _this$inputRef;
                    (_this$inputRef = this.inputRef) === null || _this$inputRef === void 0 || _this$inputRef.setAttribute('aria-label', inputLabel);
                    setTimeout(function() {
                        var normalizedLabel = _this3.props['aria-label'] || _this3.props.label;
                        if (normalizedLabel) {
                            var _this3$inputRef;
                            (_this3$inputRef = _this3.inputRef) === null || _this3$inputRef === void 0 || _this3$inputRef.setAttribute('aria-label', normalizedLabel);
                        } else {
                            var _this3$inputRef2;
                            (_this3$inputRef2 = _this3.inputRef) === null || _this3$inputRef2 === void 0 || _this3$inputRef2.removeAttribute('aria-label');
                        }
                    }, 500);
                }
            }
        },
        {
            key: "calculateInputLabel",
            value: function calculateInputLabel(focusedOption, optionIndex) {
                var _this4 = this;
                var options = this.props.options;
                var isOptionsGrouped = options === null || options === void 0 ? void 0 : options.every(function(obj) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(obj) === 'object' && obj !== null && 'options' in obj;
                });
                var inputLabel = this.getOptionLabel(focusedOption);
                var isOptionFocused = function isOptionFocused(option) {
                    return _this4.getOptionLabel(option) === inputLabel;
                };
                var groupData = options === null || options === void 0 ? void 0 : options.find(function(option) {
                    var _groupCandidate$optio, _groupCandidate$optio2;
                    var groupCandidate = option;
                    return (_groupCandidate$optio = (_groupCandidate$optio2 = groupCandidate.options) === null || _groupCandidate$optio2 === void 0 ? void 0 : _groupCandidate$optio2.some(isOptionFocused)) !== null && _groupCandidate$optio !== void 0 ? _groupCandidate$optio : false;
                });
                if (isOptionsGrouped) {
                    var _groupData$options$fi;
                    var groupOptionIndex = (_groupData$options$fi = groupData === null || groupData === void 0 ? void 0 : groupData.options.findIndex(isOptionFocused)) !== null && _groupData$options$fi !== void 0 ? _groupData$options$fi : 0;
                    var totalLength = options === null || options === void 0 ? void 0 : options.reduce(function(acc, currentGroup) {
                        var _group$options;
                        var group = currentGroup;
                        acc += group === null || group === void 0 || (_group$options = group.options) === null || _group$options === void 0 ? void 0 : _group$options.length;
                        return acc;
                    }, 0);
                    inputLabel = "".concat(inputLabel, ", ").concat(groupData === null || groupData === void 0 ? void 0 : groupData.label, " (").concat(groupOptionIndex + 1, " of ").concat(totalLength, ")");
                } else inputLabel = "".concat(inputLabel, " (").concat(optionIndex + 1, " of ").concat(options === null || options === void 0 ? void 0 : options.length, ")");
                return inputLabel;
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus],
                    focusedValueId: "".concat(this.getElementId('selected-value'), "-").concat(nextFocus, "-remove"),
                    focusedOption: null,
                    focusedOptionId: null
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedValueId: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $688ea211cffbe405$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $688ea211cffbe405$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $688ea211cffbe405$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                var _this$props$component;
                if (typeof this.props.formatOptionLabel === 'function') {
                    var inputValue = this.props.inputValue;
                    var selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: inputValue,
                        selectValue: selectValue
                    });
                }
                // Auto-render elemBefore in dropdown menu only if formatOptionLabel is not provided
                // and no custom Option component is provided (custom Option components may already
                // render elemBefore themselves, causing it to appear twice)
                if (context === 'menu' && !this.props.formatOptionLabel && !((_this$props$component = this.props.components) !== null && _this$props$component !== void 0 && _this$props$component.Option) && (0, $f366b43c8bc426de$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
                    var elemBefore = data.elemBefore;
                    if (elemBefore) {
                        var label = this.getOptionLabel(data);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                            className: (0, $kplgf.default)([
                                "_zulpu2gc _1e0c1txw _4cvr1h6o"
                            ])
                        }, elemBefore, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", null, label));
                    }
                }
                return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "calculateDescription",
            value: function calculateDescription() {
                var descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
                var isMulti = this.props.isMulti;
                var hasValue = this.state.selectValue.length > 0;
                // Determine base description based on selection state
                var baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
                // Fast path for single select with no description prop
                if (!isMulti && !descriptionProp) return {
                    'aria-describedby': baseDescriptionId
                };
                // Build the describedby string efficiently
                var describedBy = baseDescriptionId;
                // Add description prop if it exists
                if (descriptionProp) describedBy = describedBy ? "".concat(descriptionProp, " ").concat(describedBy) : descriptionProp;
                // For multi-select, always add multi-message ID
                if (isMulti) {
                    var multiMessage = this.getElementId('multi-message');
                    describedBy = describedBy ? "".concat(describedBy, " ").concat(multiMessage) : multiMessage;
                }
                return {
                    'aria-describedby': describedBy
                };
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchstart', this.onTouchStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchmove', this.onTouchMove);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, form = _this$props8.form, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, isDisabled = _this$props8.isDisabled, isInvalid = _this$props8.isInvalid, isRequired = _this$props8.isRequired, isSearchable = _this$props8.isSearchable, label = _this$props8.label, labelId = _this$props8.labelId, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required, _this$props8$tabIndex = _this$props8.tabIndex, tabIndex = _this$props8$tabIndex === void 0 ? 0 : _this$props8$tabIndex, testId = _this$props8.testId;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var inputIsHidden = this.state.inputIsHidden;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = $688ea211cffbe405$var$_objectSpread($688ea211cffbe405$var$_objectSpread($688ea211cffbe405$var$_objectSpread($688ea211cffbe405$var$_objectSpread({}, !this.props.isSearchable && (0, $f366b43c8bc426de$export$b40ec24ac8275656)('platform_fix_autocomplete_aria_for_select') ? {} : {
                    'aria-autocomplete': 'both'
                }), {}, {
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-expanded': menuIsOpen,
                    // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
                    'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                    'aria-invalid': this.props['aria-invalid'] || isInvalid,
                    'aria-label': this.props['aria-label'] || label,
                    'aria-labelledby': this.props['aria-labelledby'] || labelId,
                    'aria-required': required || isRequired,
                    role: 'combobox',
                    'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && !(0, $f366b43c8bc426de$export$b40ec24ac8275656)('select_issearchable_aria-readonly_fix') && {
                    'aria-readonly': true
                }), this.calculateDescription());
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $2a5dfe1a3424c47d$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: $688ea211cffbe405$var$noop,
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: "",
                    "data-testid": testId && "".concat(testId, "-select--input")
                }, ariaAttributes));
                // NOTE: Don't add the `name` prop to this Input, `name` is already a prop on the hidden input element that has the value of the select.
                // Adding `name` to this Input will cause unexpected behavior.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Input, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    testId: testId,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this5 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder, testId = _this$props9.testId;
                var _this$state4 = this.state, selectValue = _this$state4.selectValue, focusedValue = _this$state4.focusedValue, isFocused = _this$state4.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Placeholder, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: $688ea211cffbe405$var$_objectSpread({
                        id: this.getElementId('placeholder')
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--placeholder")
                    })
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this5.getOptionLabel(opt), "-").concat(_this5.getOptionValue(opt));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(MultiValue, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: $688ea211cffbe405$var$_objectSpread($688ea211cffbe405$var$_objectSpread({
                            onClick: function onClick() {
                                return _this5.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this5.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        }, testId && {
                            'data-testid': "".concat(testId, "-select--multivalue-").concat(index, "-remove")
                        }), {}, {
                            id: "".concat(_this5.getElementId('selected-value'), "-").concat(index, "-remove")
                        }),
                        data: opt,
                        innerProps: $688ea211cffbe405$var$_objectSpread($688ea211cffbe405$var$_objectSpread({}, testId && {
                            'data-testid': "".concat(testId, "-select--multivalue-").concat(index)
                        }), {}, {
                            id: "".concat(_this5.getElementId('selected-value'), "-").concat(index)
                        })
                    }), _this5.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(SingleValue, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled,
                    innerProps: {
                        id: this.getElementId('single-value')
                    }
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props0 = this.props, clearControlLabel = _this$props0.clearControlLabel, isDisabled = _this$props0.isDisabled, isLoading = _this$props0.isLoading, spacing = _this$props0.spacing, testId = _this$props0.testId;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = $688ea211cffbe405$var$_objectSpread({
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd
                }, testId && {
                    'data-testid': "".concat(testId, "-select--clear-indicator")
                });
                var isCompact = spacing === 'compact';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(ClearIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                    clearControlLabel: clearControlLabel
                }, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props1 = this.props, isDisabled = _this$props1.isDisabled, isLoading = _this$props1.isLoading, spacing = _this$props1.spacing, testId = _this$props1.testId;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var isCompact = spacing === 'compact';
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LoadingIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                    "data-testid": testId && "".concat(testId, "-select--loading-indicator")
                }, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, spacing = _this$props10.spacing, testId = _this$props10.testId;
                var isFocused = this.state.isFocused;
                var isCompact = spacing === 'compact';
                var innerProps = $688ea211cffbe405$var$_objectSpread({
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                }, testId && {
                    'data-testid': "".concat(testId, "-select--dropdown-indicator")
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(DropdownIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this6 = this;
                var _this$getComponents6 = this.getComponents(), Group = _this$getComponents6.Group, GroupHeading = _this$getComponents6.GroupHeading, Menu = _this$getComponents6.Menu, MenuList = _this$getComponents6.MenuList, MenuPortal = _this$getComponents6.MenuPortal, LoadingMessage = _this$getComponents6.LoadingMessage, NoOptionsMessage = _this$getComponents6.NoOptionsMessage, Option = _this$getComponents6.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props11 = this.props, captureMenuScroll = _this$props11.captureMenuScroll, inputValue = _this$props11.inputValue, isLoading = _this$props11.isLoading, loadingMessage = _this$props11.loadingMessage, minMenuHeight = _this$props11.minMenuHeight, maxMenuHeight = _this$props11.maxMenuHeight, menuIsOpen = _this$props11.menuIsOpen, menuPlacement = _this$props11.menuPlacement, menuPosition = _this$props11.menuPosition, menuPortalTarget = _this$props11.menuPortalTarget, menuShouldBlockScroll = _this$props11.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props11.menuShouldScrollIntoView, noOptionsMessage = _this$props11.noOptionsMessage, onMenuScrollToTop = _this$props11.onMenuScrollToTop, onMenuScrollToBottom = _this$props11.onMenuScrollToBottom, testId = _this$props11.testId;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id, headingId) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this6.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this6.selectOption(data);
                    };
                    var optionId = "".concat(_this6.getElementId('option'), "-").concat(id);
                    var innerProps = $688ea211cffbe405$var$_objectSpread({
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        role: _this6.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                        'aria-selected': _this6.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                        // We don't want aria-disabled if it's false. It's just noisy.
                        'aria-disabled': !isDisabled ? undefined : isDisabled,
                        'aria-describedby': headingId
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--option-").concat(id)
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Option, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this6.getFocusedOptionRef : undefined
                    }), _this6.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) {
                    var items = this.getCategorizedOptions();
                    menuUI = items.map(function(item) {
                        if (item.type === 'group') {
                            var data = item.data, options = item.options, groupIndex = item.index;
                            var groupId = "".concat(_this6.getElementId('group'), "-").concat(groupIndex);
                            var headingId = "".concat(groupId, "-heading");
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Group, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                                key: groupId,
                                data: data,
                                options: options,
                                Heading: GroupHeading,
                                headingProps: $688ea211cffbe405$var$_objectSpread({
                                    id: headingId,
                                    data: item.data
                                }, testId && {
                                    'data-testid': "".concat(testId, "-select--group-").concat(groupIndex, "-heading")
                                }),
                                label: _this6.formatGroupLabel(item.data)
                            }), item.options.map(function(option) {
                                return render(option, "".concat(groupIndex, "-").concat(option.index), headingId);
                            }));
                        } else if (item.type === 'option') return render(item, "".concat(item.index));
                        return undefined;
                    });
                } else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NoOptionsMessage, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                        innerProps: $688ea211cffbe405$var$_objectSpread($688ea211cffbe405$var$_objectSpread({}, this.props['UNSAFE_is_experimental_generic'] && {
                            role: 'listitem'
                        }), testId && {
                            'data-testid': "".concat(testId, "-select--no-options")
                        })
                    }), _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b9b814ad33a9873a$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Menu, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: $688ea211cffbe405$var$_objectSpread({
                            onMouseDown: _this6.onMenuMouseDown,
                            onMouseMove: _this6.onMenuMouseMove,
                            id: _this6.props.components.Menu ? _this6.getElementId('listbox') : undefined
                        }, testId && {
                            'data-testid': "".concat(testId, "-select--listbox-container")
                        }),
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dc28e183e7decdd3$export$2e2bcd8739ae039), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        var _this6$inputRef, _this6$inputRef2;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(MenuList, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this6.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: $688ea211cffbe405$var$_objectSpread($688ea211cffbe405$var$_objectSpread($688ea211cffbe405$var$_objectSpread({
                                role: _this6.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox'
                            }, _this6.props['UNSAFE_is_experimental_generic'] && {
                                'aria-labelledby': ((_this6$inputRef = _this6.inputRef) === null || _this6$inputRef === void 0 ? void 0 : _this6$inputRef.id) || _this6.getElementId('input')
                            }), {}, {
                                'aria-multiselectable': !commonProps.isMulti || _this6.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                id: _this6.getElementId('listbox')
                            }, testId && {
                                'data-testid': "".concat(testId, "-select--listbox")
                            }), (0, $56c8837ddb74a576$export$95df08bae54cb4df)() && !_this6.props['UNSAFE_is_experimental_generic'] && {
                                'aria-describedby': ((_this6$inputRef2 = _this6.inputRef) === null || _this6$inputRef2 === void 0 ? void 0 : _this6$inputRef2.id) || _this6.getElementId('input')
                            }),
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), _this6.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                            role: "list"
                        }, menuUI) : menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(MenuPortal, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this7 = this;
                var _this$props12 = this.props, delimiter = _this$props12.delimiter, isDisabled = _this$props12.isDisabled, isMulti = _this$props12.isMulti, required = _this$props12.required, name = _this$props12.name;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f08221d75ac04f18$export$2e2bcd8739ae039), {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this7.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this7.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state5 = this.state, ariaSelection = _this$state5.ariaSelection, isFocused = _this$state5.isFocused, selectValue = _this$state5.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $509727e7da2e808a$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "renderMultiselectMessage",
            value: function renderMultiselectMessage() {
                // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
                // Also, since this is rendered onscreen, it should be transtlated automatically.
                var msg = ", multiple selections available, ".concat(this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : '');
                return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
                (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
                    id: this.getElementId('multi-message'),
                    hidden: true
                }, msg));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents7 = this.getComponents(), Control = _this$getComponents7.Control, IndicatorsContainer = _this$getComponents7.IndicatorsContainer, SelectContainer = _this$getComponents7.SelectContainer, ValueContainer = _this$getComponents7.ValueContainer;
                var _this$props13 = this.props, className = _this$props13.className, id = _this$props13.id, isDisabled = _this$props13.isDisabled, menuIsOpen = _this$props13.menuIsOpen, isInvalid = _this$props13.isInvalid, testId = _this$props13.testId, _this$props13$appeara = _this$props13.appearance, appearance = _this$props13$appeara === void 0 ? 'default' : _this$props13$appeara, _this$props13$spacing = _this$props13.spacing, spacing = _this$props13$spacing === void 0 ? 'default' : _this$props13$spacing;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                var isCompact = spacing === 'compact';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $925affe3a83b0ba8$export$50727c0a52da4015).Provider, {
                    value: this.getStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(SelectContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                    className: className,
                    innerProps: $688ea211cffbe405$var$_objectSpread({
                        id: id,
                        onKeyDown: this.onKeyDown
                    }, testId && {
                        'data-testid': testId && "".concat(testId, "-select--container")
                    }),
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), commonProps.isMulti && this.renderMultiselectMessage(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Control, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: $688ea211cffbe405$var$_objectSpread({
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--control")
                    }),
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(ValueContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    isDisabled: isDisabled,
                    isCompact: isCompact,
                    innerProps: $688ea211cffbe405$var$_objectSpread($688ea211cffbe405$var$_objectSpread({}, testId && {
                        'data-testid': "".concat(testId, "-select--value-container")
                    }), commonProps.isMulti && commonProps.hasValue && !(0, $a05a369e5fc6d009$export$e1865c3bedcd822b)() && {
                        // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                        // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                        // DST Accessibility.
                        role: 'application'
                    })
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(IndicatorsContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    isDisabled: isDisabled,
                    innerProps: $688ea211cffbe405$var$_objectSpread({}, testId && {
                        'data-testid': "".concat(testId, "-select--indicators-container")
                    })
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f432a850848ad829$export$17baa7c95b6ba1b8), {
                    isOpen: this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $8162cb3f617e161f$export$33f062f47f21a01)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $688ea211cffbe405$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $688ea211cffbe405$var$buildFocusableOptionsWithIds($688ea211cffbe405$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $688ea211cffbe405$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $688ea211cffbe405$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $688ea211cffbe405$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $0804185e76505745$export$40fb9515c784cc3b)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return $688ea211cffbe405$var$_objectSpread($688ea211cffbe405$var$_objectSpread($688ea211cffbe405$var$_objectSpread({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
}((0, $5FkrB.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($688ea211cffbe405$export$2e2bcd8739ae039, "defaultProps", $688ea211cffbe405$export$9c21a3269931e1e6);



var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
var $e4185ab08309eab6$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $e4185ab08309eab6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e4185ab08309eab6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e4185ab08309eab6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e4185ab08309eab6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e4185ab08309eab6$var$handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $e4185ab08309eab6$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions, propsOptions = _ref.options, _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $e4185ab08309eab6$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $5FkrB.useRef)(undefined);
    var mounted = (0, $5FkrB.useRef)(false);
    var _useState = (0, $5FkrB.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : ''), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(propsDefaultOptions === true), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $5FkrB.useState)(undefined), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $5FkrB.useState)([]), _useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState9, 2), loadedOptions = _useState0[0], setLoadedOptions = _useState0[1];
    var _useState1 = (0, $5FkrB.useState)(false), _useState10 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState1, 2), passEmptyOptions = _useState10[0], setPassEmptyOptions = _useState10[1];
    var _useState11 = (0, $5FkrB.useState)({}), _useState12 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState11, 2), optionsCache = _useState12[0], setOptionsCache = _useState12[1];
    var _useState13 = (0, $5FkrB.useState)(undefined), _useState14 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState13, 2), prevDefaultOptions = _useState14[0], setPrevDefaultOptions = _useState14[1];
    var _useState15 = (0, $5FkrB.useState)(undefined), _useState16 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState15, 2), prevCacheOptions = _useState16[0], setPrevCacheOptions = _useState16[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $5FkrB.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $5FkrB.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $5FkrB.useCallback)(function(newValue, actionMeta) {
        var inputValue = $e4185ab08309eab6$var$handleInputChange(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? $e4185ab08309eab6$var$_objectSpread($e4185ab08309eab6$var$_objectSpread({}, optionsCache), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return $e4185ab08309eab6$var$_objectSpread($e4185ab08309eab6$var$_objectSpread({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}



var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
var $3ca1752e6d757d7e$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $3ca1752e6d757d7e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3ca1752e6d757d7e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3ca1752e6d757d7e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3ca1752e6d757d7e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3ca1752e6d757d7e$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $3ca1752e6d757d7e$var$_excluded);
    var _useState = (0, $5FkrB.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $5FkrB.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $5FkrB.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $5FkrB.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $5FkrB.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return $3ca1752e6d757d7e$var$_objectSpread($3ca1752e6d757d7e$var$_objectSpread({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}


var $a1ba8d6c870895b8$var$AsyncSelect = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    // when isAsync is true, options are not provided and async props are used, we will enable async
    var isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    var stateManagedProps = (0, $e4185ab08309eab6$export$2e2bcd8739ae039)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    var selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    var selectProps = (0, $3ca1752e6d757d7e$export$2e2bcd8739ae039)(selectAsyncProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $688ea211cffbe405$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: ref
    }, selectProps));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a1ba8d6c870895b8$export$2e2bcd8739ae039 = $a1ba8d6c870895b8$var$AsyncSelect;



var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
var $1592b8d0711f5d6e$var$_excluded = [
    "ariaLiveMessages",
    "isInvalid",
    "onClickPreventDefault",
    "tabSelectsValue",
    "validationState"
];
function $1592b8d0711f5d6e$export$2e2bcd8739ae039(WrappedComponent) {
    var AtlaskitSelect = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        var ariaLiveMessages = props.ariaLiveMessages, isInvalid = props.isInvalid, _props$onClickPrevent = props.onClickPreventDefault, onClickPreventDefault = _props$onClickPrevent === void 0 ? true : _props$onClickPrevent, _props$tabSelectsValu = props.tabSelectsValue, tabSelectsValue = _props$tabSelectsValu === void 0 ? false : _props$tabSelectsValu, _props$validationStat = props.validationState, validationState = _props$validationStat === void 0 ? 'default' : _props$validationStat, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $1592b8d0711f5d6e$var$_excluded);
        var internalSelectRef = (0, $5FkrB.useRef)(null);
        /**
     * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
     * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
     * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
     * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
     * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
     */ (0, $5FkrB.useImperativeHandle)(forwardedRef, function() {
            return {
                select: internalSelectRef.current,
                focus: function focus() {
                    var _internalSelectRef$cu;
                    return (_internalSelectRef$cu = internalSelectRef.current) === null || _internalSelectRef$cu === void 0 ? void 0 : _internalSelectRef$cu.focus();
                },
                blur: function blur() {
                    var _internalSelectRef$cu2;
                    return (_internalSelectRef$cu2 = internalSelectRef.current) === null || _internalSelectRef$cu2 === void 0 ? void 0 : _internalSelectRef$cu2.blur();
                }
            };
        }, []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error'
        }, restProps, {
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        }));
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}


var $1b9277a0356f88e4$export$d1de3b251ccaa8a3 = (0, $1592b8d0711f5d6e$export$2e2bcd8739ae039)((0, $a1ba8d6c870895b8$export$2e2bcd8739ae039));


var $6b35e1e8c8ac06e7$var$packageName = "@atlaskit/select";
var $6b35e1e8c8ac06e7$var$packageVersion = "21.12.14";
var $6b35e1e8c8ac06e7$var$createAndFireEventOnAtlaskit = (0, $66bbf3a923e23145$export$2e2bcd8739ae039)('atlaskit');
var $6b35e1e8c8ac06e7$var$Select = (0, $2b64717bfa6e5a5b$export$2e2bcd8739ae039)({
    componentName: 'select',
    packageName: $6b35e1e8c8ac06e7$var$packageName,
    packageVersion: $6b35e1e8c8ac06e7$var$packageVersion
})((0, $ca50b4d958b734a9$export$2e2bcd8739ae039)({
    onChange: $6b35e1e8c8ac06e7$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $6b35e1e8c8ac06e7$var$packageName,
            packageVersion: $6b35e1e8c8ac06e7$var$packageVersion
        }
    })
})((0, $1b9277a0356f88e4$export$d1de3b251ccaa8a3)));
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$6b35e1e8c8ac06e7$export$2e2bcd8739ae039 = $6b35e1e8c8ac06e7$var$Select;



var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $5FkrB = parcelRequire("5FkrB");
var $de50da79535ed886$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $de50da79535ed886$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($de50da79535ed886$export$1ca2a26fecb070ae);
};
$de50da79535ed886$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';



var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");
var $da02f9ea28dda37a$export$4ef52930e33717cd = 'data-theme';
var $da02f9ea28dda37a$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $da02f9ea28dda37a$export$a00eac3f8684bcd0 = 'data-color-mode';
var $da02f9ea28dda37a$export$2112803007239c61 = 'data-contrast-mode';
var $da02f9ea28dda37a$export$352e418ed5b6193a = 'data-custom-theme';
var $da02f9ea28dda37a$export$6f0c6fb8c80fcc92 = 'ds';
var $da02f9ea28dda37a$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $da02f9ea28dda37a$export$dddac1532e822863 = "--".concat($da02f9ea28dda37a$export$6f0c6fb8c80fcc92, "-token-not-found");
var $da02f9ea28dda37a$export$9d7b58831ae93caa = "--".concat($da02f9ea28dda37a$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $8cd2f451c5ad80c5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8cd2f451c5ad80c5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8cd2f451c5ad80c5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8cd2f451c5ad80c5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8cd2f451c5ad80c5$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $8cd2f451c5ad80c5$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $8cd2f451c5ad80c5$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $8cd2f451c5ad80c5$export$632685d741f3dbbf = $8cd2f451c5ad80c5$var$_objectSpread($8cd2f451c5ad80c5$var$_objectSpread({}, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4), $8cd2f451c5ad80c5$export$d2dc61f58390201c);
var $8cd2f451c5ad80c5$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $8cd2f451c5ad80c5$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $8cd2f451c5ad80c5$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $8cd2f451c5ad80c5$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $8cd2f451c5ad80c5$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $8cd2f451c5ad80c5$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFBDAD)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FF8F73)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FF7452)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FFF0B3)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FFE380)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FFC400)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #ABF5D1)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #79F2C0)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #57D9A3)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #C0B6F2)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #998DD9)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #8777D9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #B3D4FF)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #4C9AFF)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #2684FF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $8cd2f451c5ad80c5$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #BF2600)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #974F0C)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #0747A6)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $8cd2f451c5ad80c5$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B778C)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $8cd2f451c5ad80c5$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $8cd2f451c5ad80c5$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $8cd2f451c5ad80c5$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
var $8cd2f451c5ad80c5$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $8cd2f451c5ad80c5$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $8cd2f451c5ad80c5$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $8cd2f451c5ad80c5$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $8cd2f451c5ad80c5$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $8cd2f451c5ad80c5$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
/**
 * Token functions are currently allowed for borderRadius in xcss to ease migration.
 * Because 'radius.small' defaults to 3px, we need a mechanism to allow for 4px values to be provided:
 * This is done by calling the token function - token('radius.small')
 *
 * TODO: Remove once shape them is rolled out and fg platform-dst-shape-theme-default removed
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $8cd2f451c5ad80c5$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $8cd2f451c5ad80c5$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $8cd2f451c5ad80c5$export$e615f061ca585a6c = $8cd2f451c5ad80c5$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $8cd2f451c5ad80c5$export$ca0f9c2de39ffed7(spacingProperty, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $8cd2f451c5ad80c5$export$bf46c3f9eeafc71f = $8cd2f451c5ad80c5$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $8cd2f451c5ad80c5$export$ca0f9c2de39ffed7(spacingProperty, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $8cd2f451c5ad80c5$export$e7af83bafe7f9e63 = $8cd2f451c5ad80c5$export$ca0f9c2de39ffed7('backgroundColor', $8cd2f451c5ad80c5$export$d1d79bf68ac056bd);
var $8cd2f451c5ad80c5$export$3a1bcba60b23d7f0 = $8cd2f451c5ad80c5$export$ca0f9c2de39ffed7('color', $8cd2f451c5ad80c5$export$8473307aa00d6ea1);
var $8cd2f451c5ad80c5$export$45f3f4fe16f9f7d5 = $8cd2f451c5ad80c5$export$ca0f9c2de39ffed7('fontWeight', $8cd2f451c5ad80c5$export$303e322c6b1ed114);
var $8cd2f451c5ad80c5$export$68cc305da27dbaa4 = $8cd2f451c5ad80c5$export$ca0f9c2de39ffed7('fontFamily', $8cd2f451c5ad80c5$export$3c7e9587132614b4);
var $8cd2f451c5ad80c5$export$128f10c238242f83 = $8cd2f451c5ad80c5$export$ca0f9c2de39ffed7('font', $8cd2f451c5ad80c5$export$6ffa317d5e70375);
var $8cd2f451c5ad80c5$export$219d364c0da35ae4 = $8cd2f451c5ad80c5$export$ca0f9c2de39ffed7('font', $8cd2f451c5ad80c5$export$236bfe3a33ef1292);
var $8cd2f451c5ad80c5$export$38845ca010b93505 = $8cd2f451c5ad80c5$export$ca0f9c2de39ffed7('fontWeight', $8cd2f451c5ad80c5$export$855cfd311192d666);
var $8cd2f451c5ad80c5$export$ff257d957d48c421 = $8cd2f451c5ad80c5$export$ca0f9c2de39ffed7((0, $da02f9ea28dda37a$export$9d7b58831ae93caa), $8cd2f451c5ad80c5$export$41a358c9c2356760);
var $8cd2f451c5ad80c5$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $8cd2f451c5ad80c5$export$41a358c9c2356760[color] !== undefined;
};
var $8cd2f451c5ad80c5$export$7001ce64d9ff7c7f = $8cd2f451c5ad80c5$export$ca0f9c2de39ffed7('font', $8cd2f451c5ad80c5$export$b805719bc8cb376);



var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $74Zh5 = parcelRequire("74Zh5");


var $3ZMUU = parcelRequire("3ZMUU");
function $e4d6a42270c0fa86$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $e4d6a42270c0fa86$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $e4d6a42270c0fa86$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e4d6a42270c0fa86$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e4d6a42270c0fa86$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $e4d6a42270c0fa86$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $e4d6a42270c0fa86$export$9a199fbafee0014e = {
    backgroundColor: (0, $8cd2f451c5ad80c5$export$d1d79bf68ac056bd),
    blockSize: (0, $8cd2f451c5ad80c5$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $8cd2f451c5ad80c5$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $8cd2f451c5ad80c5$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $8cd2f451c5ad80c5$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $8cd2f451c5ad80c5$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $8cd2f451c5ad80c5$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $8cd2f451c5ad80c5$export$e1b83c5210c471b8),
    borderBottomColor: (0, $8cd2f451c5ad80c5$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $8cd2f451c5ad80c5$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $8cd2f451c5ad80c5$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $8cd2f451c5ad80c5$export$e1b83c5210c471b8),
    borderColor: (0, $8cd2f451c5ad80c5$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $8cd2f451c5ad80c5$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $8cd2f451c5ad80c5$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $8cd2f451c5ad80c5$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $8cd2f451c5ad80c5$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $8cd2f451c5ad80c5$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $8cd2f451c5ad80c5$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $8cd2f451c5ad80c5$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $8cd2f451c5ad80c5$export$e1b83c5210c471b8),
    borderLeftColor: (0, $8cd2f451c5ad80c5$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $8cd2f451c5ad80c5$export$e1b83c5210c471b8),
    borderRadius: (0, $8cd2f451c5ad80c5$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $8cd2f451c5ad80c5$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $8cd2f451c5ad80c5$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $8cd2f451c5ad80c5$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $8cd2f451c5ad80c5$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $8cd2f451c5ad80c5$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $8cd2f451c5ad80c5$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $8cd2f451c5ad80c5$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $8cd2f451c5ad80c5$export$e1b83c5210c471b8),
    borderWidth: (0, $8cd2f451c5ad80c5$export$e1b83c5210c471b8),
    bottom: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    boxShadow: (0, $8cd2f451c5ad80c5$export$7aff6e7ba39bb774),
    color: (0, $8cd2f451c5ad80c5$export$8473307aa00d6ea1),
    columnGap: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    font: (0, $8cd2f451c5ad80c5$export$6ffa317d5e70375),
    fontFamily: (0, $8cd2f451c5ad80c5$export$3c7e9587132614b4),
    fontWeight: (0, $8cd2f451c5ad80c5$export$303e322c6b1ed114),
    gap: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    height: (0, $8cd2f451c5ad80c5$export$6ccdbebca2ee545f),
    inlineSize: (0, $8cd2f451c5ad80c5$export$6ccdbebca2ee545f),
    inset: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    insetBlock: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    insetBlockEnd: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    insetBlockStart: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    insetInline: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    insetInlineEnd: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    insetInlineStart: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    left: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    margin: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    marginBlock: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    marginBlockEnd: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    marginBlockStart: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    marginBottom: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    marginInline: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    marginInlineEnd: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    marginInlineStart: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    marginLeft: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    marginRight: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    marginTop: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    maxBlockSize: (0, $8cd2f451c5ad80c5$export$6ccdbebca2ee545f),
    maxHeight: (0, $8cd2f451c5ad80c5$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $8cd2f451c5ad80c5$export$6ccdbebca2ee545f),
    maxWidth: (0, $8cd2f451c5ad80c5$export$6ccdbebca2ee545f),
    minBlockSize: (0, $8cd2f451c5ad80c5$export$6ccdbebca2ee545f),
    minHeight: (0, $8cd2f451c5ad80c5$export$6ccdbebca2ee545f),
    minInlineSize: (0, $8cd2f451c5ad80c5$export$6ccdbebca2ee545f),
    minWidth: (0, $8cd2f451c5ad80c5$export$6ccdbebca2ee545f),
    opacity: (0, $8cd2f451c5ad80c5$export$daf94a976c798b4f),
    outlineColor: (0, $8cd2f451c5ad80c5$export$1531ad5bb3fbedac),
    outlineOffset: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    outlineWidth: (0, $8cd2f451c5ad80c5$export$e1b83c5210c471b8),
    padding: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    paddingBlock: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    paddingBottom: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    paddingInline: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    paddingLeft: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    paddingRight: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    paddingTop: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    right: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    rowGap: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    top: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    width: (0, $8cd2f451c5ad80c5$export$6ccdbebca2ee545f),
    zIndex: (0, $8cd2f451c5ad80c5$export$b5f31a7e431d2eab)
};
var $e4d6a42270c0fa86$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $e4d6a42270c0fa86$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU.env) === 'object' && false;
};
var $e4d6a42270c0fa86$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $e4d6a42270c0fa86$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $e4d6a42270c0fa86$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($e4d6a42270c0fa86$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && $e4d6a42270c0fa86$var$safeSelectors.test(key)) {
            styleObj[key] = $e4d6a42270c0fa86$var$_transformStyles(value);
            return;
        }
        if ($e4d6a42270c0fa86$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($e4d6a42270c0fa86$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $e4d6a42270c0fa86$export$9a199fbafee0014e)) return;
        var tokenValue = $e4d6a42270c0fa86$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $e4d6a42270c0fa86$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $e4d6a42270c0fa86$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $e4d6a42270c0fa86$var$uniqueSymbol, (0, $74Zh5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $e4d6a42270c0fa86$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $e4d6a42270c0fa86$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $e4d6a42270c0fa86$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$e4d6a42270c0fa86$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $e4d6a42270c0fa86$export$f6c783d06584602c(style) {
    return $e4d6a42270c0fa86$var$baseXcss(style);
}


var $a18eb272727512e1$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $a18eb272727512e1$var$_excluded2 = [
    "className"
];
var $a18eb272727512e1$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $a18eb272727512e1$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $a18eb272727512e1$var$_excluded2);
    var resolvedStyles = (0, $e4d6a42270c0fa86$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $a18eb272727512e1$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $8cd2f451c5ad80c5$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $8cd2f451c5ad80c5$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $8cd2f451c5ad80c5$export$ff257d957d48c421)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $8cd2f451c5ad80c5$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $8cd2f451c5ad80c5$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $8cd2f451c5ad80c5$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $8cd2f451c5ad80c5$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $8cd2f451c5ad80c5$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $8cd2f451c5ad80c5$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $8cd2f451c5ad80c5$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $74Zh5.jsx)((0, $de50da79535ed886$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $a18eb272727512e1$export$2e2bcd8739ae039 = $a18eb272727512e1$export$e71c4d32a2263218;
var $a18eb272727512e1$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});


/**
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-sort
 */ var $48eaba2dc4ec4d09$var$baseResetStyles = (0, $e4d6a42270c0fa86$export$f6c783d06584602c)({
    display: 'table-cell',
    verticalAlign: 'middle',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':first-of-type': {
        paddingInlineStart: 'space.100'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        paddingInlineEnd: 'space.100'
    }
});
var $48eaba2dc4ec4d09$var$alignMapStyles = {
    text: (0, $e4d6a42270c0fa86$export$f6c783d06584602c)({
        textAlign: 'left'
    }),
    icon: (0, $e4d6a42270c0fa86$export$f6c783d06584602c)({
        textAlign: 'center'
    }),
    number: (0, $e4d6a42270c0fa86$export$f6c783d06584602c)({
        textAlign: 'right'
    })
};
var $48eaba2dc4ec4d09$export$41ad0bbfa4755cac = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, as = _ref.as, children = _ref.children, _ref$align = _ref.align, align = _ref$align === void 0 ? 'text' : _ref$align, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? 'space.100' : _ref$paddingBlock, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? 'space.100' : _ref$paddingInline, backgroundColor = _ref.backgroundColor, scope = _ref.scope, width = _ref.width, xcss = _ref.xcss, sortDirection = _ref.sortDirection, colSpan = _ref.colSpan, rowSpan = _ref.rowSpan;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = Array.isArray(xcss) ? xcss : [
        xcss
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a18eb272727512e1$export$2e2bcd8739ae039), {
        xcss: [
            $48eaba2dc4ec4d09$var$baseResetStyles,
            $48eaba2dc4ec4d09$var$alignMapStyles[align]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(styles)),
        ref: ref,
        scope: scope,
        backgroundColor: backgroundColor,
        paddingBlock: paddingBlock,
        paddingInline: paddingInline,
        as: as,
        testId: testId,
        style: width ? {
            width: width
        } : undefined,
        "aria-sort": sortDirection,
        colSpan: colSpan,
        rowSpan: rowSpan
    }, children);
});


var $db2ca91e0d53ac06$var$_excluded = [
    "testId"
];
var $db2ca91e0d53ac06$export$9cf5b401f969f5e3 = function TD(_ref) {
    var testId = _ref.testId, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $db2ca91e0d53ac06$var$_excluded);
    return(/*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $48eaba2dc4ec4d09$export$41ad0bbfa4755cac), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "td",
        testId: testId
    }, props)));
};


var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
var $b1da8f3ca8bdaac0$export$2a909d4c080cb420 = {
    checked: [],
    allChecked: false,
    anyChecked: false,
    maxChecked: 0,
    selectionStart: -1,
    previousSelection: []
};
var $b1da8f3ca8bdaac0$var$arrayFromRange = function arrayFromRange(from, to) {
    var startIdx = from;
    var stopIdx = to;
    var increment = 1;
    if (from > to) {
        startIdx = to;
        stopIdx = from;
        increment = 0;
    }
    // Create an array with values between `from` and `to` - either ascending or descending
    return Array.from({
        length: stopIdx - startIdx
    }, function(_, i) {
        return startIdx + i + increment;
    });
};
function $b1da8f3ca8bdaac0$var$reducer(_ref, action) {
    var checked = _ref.checked, anyChecked = _ref.anyChecked, maxChecked = _ref.maxChecked, selectionStart = _ref.selectionStart, previousSelection = _ref.previousSelection;
    switch(action.type){
        case 'toggle_selection':
            var _action$value = action.value, id = _action$value.id, shiftHeld = _action$value.shiftHeld;
            var updated = checked.slice();
            var newSelectionStart = selectionStart;
            var newPreviousSelection = previousSelection.slice();
            if (shiftHeld) {
                if (checked.length > 0) {
                    var newIds = $b1da8f3ca8bdaac0$var$arrayFromRange(selectionStart, id); // create an array of the new ids
                    // Uncheck ids from the previous selection.
                    // This is done to maintain consistency with Shift-select behaviour elsewhere (e.g. macOS)
                    // TODO: Code could be improved to only remove ids that are not included in the new range, avoiding needing to re-add them below
                    updated = updated.filter(function(id) {
                        return !previousSelection.includes(id);
                    });
                    newIds.forEach(function(id) {
                        return updated.indexOf(id) === -1 && updated.push(id);
                    } // If the new id is not already checked, check it
                    );
                    newPreviousSelection = newIds; // Maintain an array of the previous selection to allow for consistent Shift-select behaviour
                }
            } else {
                var checkedIndex = checked.indexOf(id); // is index already checked
                if (checkedIndex !== -1) updated.splice(checkedIndex, 1); // if index is already checked, uncheck
                else updated.push(id); // if index is not checked, check
                newSelectionStart = id; // Reset selection start id to this non-shift-selected id
                newPreviousSelection = []; // Reset previous selection as it is no longer relevant once a new non-shift-selected id is added
            }
            var _anyChecked = updated.length > 0;
            return {
                checked: updated,
                allChecked: updated.length === maxChecked,
                anyChecked: _anyChecked || Boolean(updated[id]),
                maxChecked: maxChecked,
                selectionStart: newSelectionStart,
                previousSelection: newPreviousSelection
            };
        case 'set_root':
            return {
                checked: action.value ? Array.from(Array(maxChecked).keys()) : [],
                allChecked: action.value,
                anyChecked: Boolean(action.value),
                maxChecked: maxChecked,
                selectionStart: selectionStart,
                previousSelection: previousSelection
            };
        case 'set_max':
            var max = action.value;
            return {
                maxChecked: max,
                allChecked: checked.length === max,
                anyChecked: anyChecked,
                checked: checked,
                selectionStart: selectionStart,
                previousSelection: previousSelection
            };
        default:
            throw new Error();
    }
}
function $b1da8f3ca8bdaac0$var$useSelectable() {
    var _useReducer = (0, $5FkrB.useReducer)($b1da8f3ca8bdaac0$var$reducer, $b1da8f3ca8bdaac0$export$2a909d4c080cb420), _useReducer2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var toggleSelection = (0, $5FkrB.useCallback)(function(id, shiftHeld) {
        dispatch({
            type: 'toggle_selection',
            value: {
                id: id,
                shiftHeld: shiftHeld
            }
        });
    }, []);
    var setAll = (0, $5FkrB.useCallback)(function() {
        dispatch({
            type: 'set_root',
            value: true
        });
    }, []);
    var removeAll = (0, $5FkrB.useCallback)(function() {
        dispatch({
            type: 'set_root',
            value: false
        });
    }, []);
    var setMax = (0, $5FkrB.useCallback)(function(max) {
        dispatch({
            type: 'set_max',
            value: max
        });
    }, []);
    return [
        state,
        {
            setAll: setAll,
            removeAll: removeAll,
            toggleSelection: toggleSelection,
            setMax: setMax
        }
    ];
}
var $b1da8f3ca8bdaac0$export$2e2bcd8739ae039 = $b1da8f3ca8bdaac0$var$useSelectable;


var $777bb5c8a69aeae5$var$SelectionContext = /*#__PURE__*/ (0, $5FkrB.createContext)([
    (0, $b1da8f3ca8bdaac0$export$2a909d4c080cb420),
    {}
]);
/**
 * __Selection provider__
 *
 * A selection provider injects selection specific state into the table.
 */ var $777bb5c8a69aeae5$var$SelectionProvider = function SelectionProvider(_ref) {
    var children = _ref.children;
    var reducer = (0, $b1da8f3ca8bdaac0$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($777bb5c8a69aeae5$var$SelectionContext.Provider, {
        value: reducer
    }, children);
};
var $777bb5c8a69aeae5$export$a97c3cc4bf1da1ca = function useSelection() {
    return (0, $5FkrB.useContext)($777bb5c8a69aeae5$var$SelectionContext);
};
var $777bb5c8a69aeae5$export$2e2bcd8739ae039 = $777bb5c8a69aeae5$var$SelectionProvider;



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
var $4e506b1e6559e97a$export$21ebc1ba2b2bee67 = function useSorting(sortKey) {
    var _useState = (0, $5FkrB.useState)(sortKey), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), localSortKey = _useState2[0], setLocalSortKey = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), localSortDirection = _useState4[0], setLocalSortDirection = _useState4[1];
    var toggleSortDirection = (0, $5FkrB.useCallback)(function() {
        setLocalSortDirection(function(oldLocalSortDirection) {
            switch(oldLocalSortDirection){
                case undefined:
                    return 'ascending';
                case 'ascending':
                    return 'descending';
                case 'descending':
                    return 'ascending';
            }
        });
    }, []);
    var setSortState = (0, $5FkrB.useCallback)(function(key) {
        setLocalSortKey(function(localSortKey) {
            if (key !== localSortKey) {
                // sorting by different column
                setLocalSortDirection('ascending');
                return key;
            } else toggleSortDirection();
            return localSortKey;
        });
    }, [
        toggleSortDirection
    ]);
    var sortFn = (0, $5FkrB.useCallback)(function(rowA, rowB) {
        if (localSortKey === 'unset') return 0;
        var ascendingComparator = rowA[localSortKey] < rowB[localSortKey] ? -1 : 1;
        return localSortDirection === 'ascending' ? ascendingComparator : -ascendingComparator;
    }, [
        localSortDirection,
        localSortKey
    ]);
    return {
        sortKey: localSortKey,
        sortDirection: localSortDirection,
        setSortState: setSortState,
        sortFn: sortFn
    };
};



var $5FkrB = parcelRequire("5FkrB");
/**
 * An empty function which does nothing.
 */ function $c11d8866dd12c49b$export$2e2bcd8739ae039() {}


function $c410d2d48027d6af$var$generateContext() {
    return /*#__PURE__*/ (0, $5FkrB.createContext)({
        isSelectable: false,
        sortKey: 'unset',
        setSortState: (0, $c11d8866dd12c49b$export$2e2bcd8739ae039),
        sortFn: function sortFn() {
            return 0;
        }
    });
}
var $c410d2d48027d6af$var$TableContext = $c410d2d48027d6af$var$generateContext();
function $c410d2d48027d6af$export$d542ac353845c9cf(_ref) {
    var children = _ref.children, state = _ref.state;
    return(/*#__PURE__*/ // @ts-expect-error
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($c410d2d48027d6af$var$TableContext.Provider, {
        value: state
    }, children));
}
var $c410d2d48027d6af$export$25bceaac3c7e4dc7 = function useTable() {
    return(// @ts-expect-error
    (0, $5FkrB.useContext)($c410d2d48027d6af$var$TableContext));
};



var $5FkrB = parcelRequire("5FkrB");
var $252502c30937ddc7$export$54ec01a60f47d33d = function Table(_ref) {
    var children = _ref.children, testId = _ref.testId, summary = _ref.summary;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("table", {
        "data-testid": testId
    }, summary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("caption", null, summary), children);
};


/**
 * __Table__
 *
 * A data table is used to display dynamic data.
 *
 * - [Examples](https://atlassian.design/components/table/examples)
 */ function $1c9849e9ca2bf87c$var$Table(_ref) {
    var children = _ref.children, isSelectable = _ref.isSelectable, _ref$sortKey = _ref.sortKey, sortKey = _ref$sortKey === void 0 ? 'unset' : _ref$sortKey, testId = _ref.testId;
    var _useSorting = (0, $4e506b1e6559e97a$export$21ebc1ba2b2bee67)(sortKey), localSortKey = _useSorting.sortKey, sortDirection = _useSorting.sortDirection, setSortState = _useSorting.setSortState, sortFn = _useSorting.sortFn;
    var tableProviderState = (0, $5FkrB.useMemo)(function() {
        return {
            isSelectable: isSelectable,
            sortKey: localSortKey,
            sortDirection: sortDirection,
            setSortState: setSortState,
            sortFn: sortFn
        };
    }, [
        isSelectable,
        localSortKey,
        setSortState,
        sortDirection,
        sortFn
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c410d2d48027d6af$export$d542ac353845c9cf), {
        state: tableProviderState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $252502c30937ddc7$export$54ec01a60f47d33d), {
        testId: testId
    }, isSelectable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $777bb5c8a69aeae5$export$2e2bcd8739ae039), null, children) : children));
}
var $1c9849e9ca2bf87c$export$2e2bcd8739ae039 = $1c9849e9ca2bf87c$var$Table;


var $5FkrB = parcelRequire("5FkrB");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $afMOk = parcelRequire("afMOk");

var $5FkrB = parcelRequire("5FkrB");
var $27ab4881942cfff6$var$HasTextAncestorContext = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $27ab4881942cfff6$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $5FkrB.useContext)($27ab4881942cfff6$var$HasTextAncestorContext);
};
var $27ab4881942cfff6$export$ae933c6cbe5643ad = $27ab4881942cfff6$var$HasTextAncestorContext.Provider;




var $f1e6ff9ef5ff2e1b$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $f1e6ff9ef5ff2e1b$var$resetStyles = (0, $74Zh5.css)({
    margin: 0,
    overflowWrap: 'anywhere'
});
var $f1e6ff9ef5ff2e1b$var$strongStyles = (0, $74Zh5.css)({
    fontWeight: "var(--ds-font-weight-bold, 653)"
});
var $f1e6ff9ef5ff2e1b$var$emStyles = (0, $74Zh5.css)({
    fontStyle: 'italic'
});
var $f1e6ff9ef5ff2e1b$var$textAlignMap = {
    center: (0, $74Zh5.css)({
        textAlign: 'center'
    }),
    end: (0, $74Zh5.css)({
        textAlign: 'end'
    }),
    start: (0, $74Zh5.css)({
        textAlign: 'start'
    })
};
var $f1e6ff9ef5ff2e1b$var$truncationStyles = (0, $74Zh5.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
var $f1e6ff9ef5ff2e1b$var$wordBreakMap = {
    breakAll: (0, $74Zh5.css)({
        wordBreak: 'break-all'
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $f1e6ff9ef5ff2e1b$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $de50da79535ed886$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $8cd2f451c5ad80c5$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $8cd2f451c5ad80c5$export$2185ce37f9bdd963)[surface];
    return 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $f1e6ff9ef5ff2e1b$var$Text = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $afMOk.default)($f1e6ff9ef5ff2e1b$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $27ab4881942cfff6$export$9322276ec105d055)();
    var color = $f1e6ff9ef5ff2e1b$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = (0, $74Zh5.jsx)(Component, {
        ref: ref,
        css: [
            $f1e6ff9ef5ff2e1b$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $8cd2f451c5ad80c5$export$219d364c0da35ae4)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $8cd2f451c5ad80c5$export$3a1bcba60b23d7f0)[color],
            maxLines && $f1e6ff9ef5ff2e1b$var$truncationStyles,
            maxLines === 1 && $f1e6ff9ef5ff2e1b$var$wordBreakMap.breakAll,
            align && $f1e6ff9ef5ff2e1b$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $8cd2f451c5ad80c5$export$38845ca010b93505)[weight],
            Component === 'em' && $f1e6ff9ef5ff2e1b$var$emStyles,
            Component === 'strong' && $f1e6ff9ef5ff2e1b$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $74Zh5.jsx)((0, $27ab4881942cfff6$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var $f1e6ff9ef5ff2e1b$export$2e2bcd8739ae039 = $f1e6ff9ef5ff2e1b$var$Text;



var $5FkrB = parcelRequire("5FkrB");

var $b58322d0be7716da$export$2b39a3648955dd09 = function TH(_ref) {
    var children = _ref.children, testId = _ref.testId, align = _ref.align, scope = _ref.scope, backgroundColor = _ref.backgroundColor, width = _ref.width, sortDirection = _ref.sortDirection, colSpan = _ref.colSpan;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $48eaba2dc4ec4d09$export$41ad0bbfa4755cac), {
        as: "th",
        testId: testId,
        align: align,
        scope: scope,
        width: width,
        backgroundColor: backgroundColor,
        sortDirection: sortDirection,
        colSpan: colSpan
    }, children);
};


/**
 * __HeadCell__
 *
 * HeadCell element
 */ var $017ea8a39e3f2896$var$HeadCell = function HeadCell(_ref) {
    var children = _ref.children, align = _ref.align, testId = _ref.testId, backgroundColor = _ref.backgroundColor, _ref$scope = _ref.scope, scope = _ref$scope === void 0 ? 'col' : _ref$scope;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b58322d0be7716da$export$2b39a3648955dd09), {
        scope: scope,
        align: align,
        testId: testId,
        backgroundColor: backgroundColor
    }, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f1e6ff9ef5ff2e1b$export$2e2bcd8739ae039), {
        weight: "medium"
    }, children));
};
var $017ea8a39e3f2896$export$2e2bcd8739ae039 = $017ea8a39e3f2896$var$HeadCell;


var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");


var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $6a2e067d7f178d02$var$ExpandContext = /*#__PURE__*/ (0, $5FkrB.createContext)({
    isExpanded: false,
    toggleExpanded: (0, $c11d8866dd12c49b$export$2e2bcd8739ae039)
});
var $6a2e067d7f178d02$export$2994164b482c6fe4 = function ExpandContextProvider(_ref) {
    var children = _ref.children, isExpandedProp = _ref.isExpanded, _ref$isDefaultExpande = _ref.isDefaultExpanded, isDefaultExpanded = _ref$isDefaultExpande === void 0 ? false : _ref$isDefaultExpande;
    var _useState = (0, $5FkrB.useState)(isDefaultExpanded), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isExpanded = _useState2[0], setIsExpanded = _useState2[1];
    var toggleExpanded = (0, $5FkrB.useCallback)(function() {
        setIsExpanded(function(v) {
            return !v;
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($6a2e067d7f178d02$var$ExpandContext.Provider, {
        value: {
            isExpanded: isExpandedProp || isExpanded,
            toggleExpanded: toggleExpanded
        }
    }, children);
};
var $6a2e067d7f178d02$var$useExpand = function useExpand() {
    return (0, $5FkrB.useContext)($6a2e067d7f178d02$var$ExpandContext);
};
var $6a2e067d7f178d02$export$2e2bcd8739ae039 = $6a2e067d7f178d02$var$useExpand;



var $5FkrB = parcelRequire("5FkrB");
var $043408dc1c1a3669$var$ExpandContentContext = /*#__PURE__*/ (0, $5FkrB.createContext)({
    isExpandableContent: false
});
var $043408dc1c1a3669$export$bc52fac1a043e39f = function ExpandContentContextProvider(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($043408dc1c1a3669$var$ExpandContentContext.Provider, {
        value: {
            isExpandableContent: true
        }
    }, children);
};
var $043408dc1c1a3669$var$useExpandContent = function useExpandContent() {
    return (0, $5FkrB.useContext)($043408dc1c1a3669$var$ExpandContentContext);
};
var $043408dc1c1a3669$export$2e2bcd8739ae039 = $043408dc1c1a3669$var$useExpandContent;



var $5FkrB = parcelRequire("5FkrB");
var $1f65586892545a6c$var$RowContext = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $1f65586892545a6c$export$81981d840a2ece5 = function useRowId() {
    return (0, $5FkrB.useContext)($1f65586892545a6c$var$RowContext);
};
var $1f65586892545a6c$export$329ef9142f16ee64 = $1f65586892545a6c$var$RowContext.Provider;




var $5FkrB = parcelRequire("5FkrB");

var $afMOk = parcelRequire("afMOk");
var $3ec5c5d14d7bc945$var$TableBodyContext = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $3ec5c5d14d7bc945$export$c0d7aba0938441d = $3ec5c5d14d7bc945$var$TableBodyContext.Provider;
var $3ec5c5d14d7bc945$export$e4e48199ad91605c = function useTableBody() {
    var hasTableBody = (0, $5FkrB.useContext)($3ec5c5d14d7bc945$var$TableBodyContext);
    (0, $afMOk.default)(hasTableBody, '<Row /> must be nested inside a <TableBody>');
};



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
/* checkbox.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $b35f73781ccc1019$var$ATOMIC_GROUP_LENGTH = 5;
function $b35f73781ccc1019$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $b35f73781ccc1019$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $f150d5461c467163$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f150d5461c467163$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f150d5461c467163$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f150d5461c467163$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f150d5461c467163$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $f150d5461c467163$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $f150d5461c467163$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $f150d5461c467163$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $f150d5461c467163$var$_objectSpread($f150d5461c467163$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $5f1e708ec415b60e$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $5f1e708ec415b60e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $5f1e708ec415b60e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5f1e708ec415b60e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $5f1e708ec415b60e$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $5f1e708ec415b60e$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $5f1e708ec415b60e$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $5f1e708ec415b60e$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $5f1e708ec415b60e$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $5f1e708ec415b60e$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $f150d5461c467163$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $f041e46c3826fc87$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $c09c67dbf32a3827$export$5bf35293e545f20c() {
    var analyticsContext = (0, $f041e46c3826fc87$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $5f1e708ec415b60e$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $521ab623aa630431$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $e18af02ff64c1d51$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e18af02ff64c1d51$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e18af02ff64c1d51$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e18af02ff64c1d51$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e18af02ff64c1d51$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $c09c67dbf32a3827$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $521ab623aa630431$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $521ab623aa630431$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $e18af02ff64c1d51$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $ekGgq = parcelRequire("ekGgq");
function $a0f238ac02a0d36e$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref) === 'object') ref.current = value;
        });
    };
}


/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

/**
 * Styles for the checkbox icon.
 * CSS custom properties for colors are set by the parent Label element
 * and consumed directly in these styles.
 */ var $c30cf9142c2d249a$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function $c30cf9142c2d249a$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ $5FkrB.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ $5FkrB.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ var $c30cf9142c2d249a$var$CheckboxIcon = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var isIndeterminate = _ref.isIndeterminate, isChecked = _ref.isChecked;
    var icon = (0, $5FkrB.useMemo)(function() {
        return $c30cf9142c2d249a$var$getIcon(isIndeterminate, isChecked);
    }, [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ $5FkrB.createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $b35f73781ccc1019$export$2e2bcd8739ae039)([
            $c30cf9142c2d249a$var$svgStyles.root
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $5FkrB.createElement("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        className: (0, $b35f73781ccc1019$export$2e2bcd8739ae039)([
            $c30cf9142c2d249a$var$svgStyles.rect
        ])
    }), icon));
});
var $c30cf9142c2d249a$export$2e2bcd8739ae039 = $c30cf9142c2d249a$var$CheckboxIcon;

/* label.tsx generated by @compiled/babel-plugin v0.38.1 */ /**
 * Base state styles with CSS custom properties.
 * Pseudo-selectors (:hover, :focus-within, :active) on the label element
 * update CSS variables that cascade to the CheckboxIcon.
 * This avoids nested sibling selectors.
 *
 * Uses `css` over `cssMap` to work around a bug in Compiled types when
 * using CSS variables in pseudo-selectors.
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $3b03ac2b87f5e244$var$baseStyles = null;
var $3b03ac2b87f5e244$var$textLabelLayoutStyles = null;
// Checked/Indeterminate state
var $3b03ac2b87f5e244$var$checkedStyles = null;
// Invalid state - must override hover/active to maintain red border
var $3b03ac2b87f5e244$var$invalidStyles = null;
// Disabled state - must override hover/active to maintain disabled appearance
var $3b03ac2b87f5e244$var$disabledStyles = null;
// Disabled + Checked/Indeterminate
var $3b03ac2b87f5e244$var$disabledCheckedStyles = null;
function $3b03ac2b87f5e244$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, isChecked = _ref.isChecked, isIndeterminate = _ref.isIndeterminate, isInvalid = _ref.isInvalid, testId = _ref.testId, label = _ref.label, id = _ref.id, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("label", {
        className: (0, $b35f73781ccc1019$export$2e2bcd8739ae039)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwnby5v _f0grby5v _syaz1tvo _80om13gf _1vj5by5v _q29qby5v _dh4gby5v _cz1uby5v _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

/* label-text.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $354cf3d9c52a9cc1$var$labelTextStyles = null;
function $354cf3d9c52a9cc1$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $b35f73781ccc1019$export$2e2bcd8739ae039)([
            "_nd5l11ig _1wpz1h6o"
        ])
    }, children);
}

/* required-indicator.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $efa73eb840607fbf$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}


// Reds
var $11d0f24a4ddb8d4f$export$4b84fd0e2c617bd = '#FFEBE6';
var $11d0f24a4ddb8d4f$export$b34b069eff244586 = '#FFBDAD';
var $11d0f24a4ddb8d4f$export$be802dd0d8b57f35 = '#FF8F73';
var $11d0f24a4ddb8d4f$export$60847d42f9da92a6 = '#FF7452';
var $11d0f24a4ddb8d4f$export$4a7404f376229999 = '#FF5630';
var $11d0f24a4ddb8d4f$export$2010d0fb4295b346 = '#DE350B';
var $11d0f24a4ddb8d4f$export$2837b5a1a71d5c02 = '#BF2600';
var $11d0f24a4ddb8d4f$export$8d9596b529bbb9cf = '#FFFAE6';
var $11d0f24a4ddb8d4f$export$41060a744ab0b7ae = '#FFF0B3';
var $11d0f24a4ddb8d4f$export$1cc05bbbf340e559 = '#FFE380';
var $11d0f24a4ddb8d4f$export$5aae31392d72caaa = '#FFC400';
var $11d0f24a4ddb8d4f$export$c6930421db9fa514 = '#FFAB00';
var $11d0f24a4ddb8d4f$export$59619663aa6500fb = '#FF991F';
var $11d0f24a4ddb8d4f$export$874739ea9e379ab6 = '#FF8B00';
var $11d0f24a4ddb8d4f$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $11d0f24a4ddb8d4f$export$69a3bf21b9686c2b = '#ABF5D1';
var $11d0f24a4ddb8d4f$export$afbce1382ec95f73 = '#79F2C0';
var $11d0f24a4ddb8d4f$export$747d86715d4175de = '#57D9A3';
var $11d0f24a4ddb8d4f$export$940e1f69e873f202 = '#36B37E';
var $11d0f24a4ddb8d4f$export$a49394138f7b8e85 = '#00875A';
var $11d0f24a4ddb8d4f$export$6fa04827ac68a4fb = '#006644';
var $11d0f24a4ddb8d4f$export$226de0355ed012f8 = '#DEEBFF';
var $11d0f24a4ddb8d4f$export$8c13c2ee36917869 = '#B3D4FF';
var $11d0f24a4ddb8d4f$export$ecfc1dff386a3e7a = '#4C9AFF';
var $11d0f24a4ddb8d4f$export$215b7063051591f1 = '#2684FF';
var $11d0f24a4ddb8d4f$export$e62e8919cca44969 = '#0065FF';
var $11d0f24a4ddb8d4f$export$b3de0ae08da2ce64 = '#0052CC';
var $11d0f24a4ddb8d4f$export$a6ee3d71bc067634 = '#0747A6';
var $11d0f24a4ddb8d4f$export$67f15409e87642a1 = '#669DF1';
var $11d0f24a4ddb8d4f$export$f0539dbc42dbb067 = '#8FB8F6';
var $11d0f24a4ddb8d4f$export$363e4475840015bb = '#EAE6FF';
var $11d0f24a4ddb8d4f$export$4b0a4417ed59760f = '#C0B6F2';
var $11d0f24a4ddb8d4f$export$6011520a64d9a187 = '#998DD9';
var $11d0f24a4ddb8d4f$export$a7175d4e9206bc80 = '#8777D9';
var $11d0f24a4ddb8d4f$export$b48405b95304b5a1 = '#6554C0';
var $11d0f24a4ddb8d4f$export$c71e4279dd54a18d = '#5243AA';
var $11d0f24a4ddb8d4f$export$147899de772240ec = '#403294';
var $11d0f24a4ddb8d4f$export$2cf711fe14c66f06 = '#E6FCFF';
var $11d0f24a4ddb8d4f$export$7a8f4d33f6f9772c = '#B3F5FF';
var $11d0f24a4ddb8d4f$export$776c9c497ef08533 = '#79E2F2';
var $11d0f24a4ddb8d4f$export$69cb3ca10c1e330e = '#00C7E6';
var $11d0f24a4ddb8d4f$export$9dc1ef0f3f48059b = '#00B8D9';
var $11d0f24a4ddb8d4f$export$7c835c78b6fcdef8 = '#00A3BF';
var $11d0f24a4ddb8d4f$export$6036577f95c3877e = '#008DA6';
var $11d0f24a4ddb8d4f$export$29a4f05edc054374 = '#FFFFFF';
var $11d0f24a4ddb8d4f$export$e655ef011c4aa1a2 = '#FAFBFC';
var $11d0f24a4ddb8d4f$export$9fdfb749e33cdf97 = '#F4F5F7';
var $11d0f24a4ddb8d4f$export$3e51e8f1440314ba = '#EBECF0';
var $11d0f24a4ddb8d4f$export$1ce2d1575d444ceb = '#DFE1E6';
var $11d0f24a4ddb8d4f$export$8754fc7e6d8b3000 = '#C1C7D0';
var $11d0f24a4ddb8d4f$export$c2e91cbeada39b8b = '#B3BAC5';
var $11d0f24a4ddb8d4f$export$5f71e19f3a7ad9de = '#A5ADBA';
var $11d0f24a4ddb8d4f$export$eaa8c8a70ac22806 = '#97A0AF';
var $11d0f24a4ddb8d4f$export$7c87d337fb91a97d = '#8993A4';
var $11d0f24a4ddb8d4f$export$d6447c357493214f = '#7A869A';
var $11d0f24a4ddb8d4f$export$f563ee71e9ee74cd = '#6B778C';
var $11d0f24a4ddb8d4f$export$e2ef2124cf4024b1 = '#5E6C84';
var $11d0f24a4ddb8d4f$export$eece5f492e429f08 = '#505F79';
var $11d0f24a4ddb8d4f$export$c39c0fe0f26207ae = '#42526E';
var $11d0f24a4ddb8d4f$export$7090862dc3038a9f = '#344563';
var $11d0f24a4ddb8d4f$export$ad0bacf983b7ddaa = '#253858';
var $11d0f24a4ddb8d4f$export$7d61b15e0da132af = '#172B4D';
var $11d0f24a4ddb8d4f$export$fbda843f0a27fe96 = '#091E42';
var $11d0f24a4ddb8d4f$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $11d0f24a4ddb8d4f$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $11d0f24a4ddb8d4f$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $11d0f24a4ddb8d4f$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $11d0f24a4ddb8d4f$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $11d0f24a4ddb8d4f$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $11d0f24a4ddb8d4f$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $11d0f24a4ddb8d4f$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $11d0f24a4ddb8d4f$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $11d0f24a4ddb8d4f$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $11d0f24a4ddb8d4f$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $11d0f24a4ddb8d4f$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $11d0f24a4ddb8d4f$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $11d0f24a4ddb8d4f$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $11d0f24a4ddb8d4f$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $11d0f24a4ddb8d4f$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $11d0f24a4ddb8d4f$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $11d0f24a4ddb8d4f$export$2f6319cf7d736c2a = '#E6EDFA';
var $11d0f24a4ddb8d4f$export$95126bc8884d6634 = '#DCE5F5';
var $11d0f24a4ddb8d4f$export$8338d8c35d44ff1 = '#CED9EB';
var $11d0f24a4ddb8d4f$export$5368d76ae4fbbda7 = '#B8C7E0';
var $11d0f24a4ddb8d4f$export$9f0a771d16ec8d36 = '#ABBBD6';
var $11d0f24a4ddb8d4f$export$abcf8c38338b4aa5 = '#9FB0CC';
var $11d0f24a4ddb8d4f$export$97e81faa16a182c7 = '#8C9CB8';
var $11d0f24a4ddb8d4f$export$bfe21c59123ecf33 = '#7988A3';
var $11d0f24a4ddb8d4f$export$ee82aa2ea6a1558 = '#67758F';
var $11d0f24a4ddb8d4f$export$682927c6ed76be02 = '#56637A';
var $11d0f24a4ddb8d4f$export$91fd9994c5be9757 = '#455166';
var $11d0f24a4ddb8d4f$export$d281fbfe3cff2df6 = '#3B475C';
var $11d0f24a4ddb8d4f$export$3902c91d8b98a753 = '#313D52';
var $11d0f24a4ddb8d4f$export$8e8133c1ba5845b5 = '#283447';
var $11d0f24a4ddb8d4f$export$33ff357f6620b39 = '#202B3D';
var $11d0f24a4ddb8d4f$export$633847cf062b69e0 = '#1B2638';
var $11d0f24a4ddb8d4f$export$9776a6e503bdbf76 = '#121A29';
var $11d0f24a4ddb8d4f$export$6c813d5160dff5db = '#0E1624';
var $11d0f24a4ddb8d4f$export$3d4f271a500072a = '#0D1424';
var $11d0f24a4ddb8d4f$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $11d0f24a4ddb8d4f$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $11d0f24a4ddb8d4f$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $11d0f24a4ddb8d4f$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $11d0f24a4ddb8d4f$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $11d0f24a4ddb8d4f$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $11d0f24a4ddb8d4f$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $11d0f24a4ddb8d4f$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $11d0f24a4ddb8d4f$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $11d0f24a4ddb8d4f$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $11d0f24a4ddb8d4f$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $11d0f24a4ddb8d4f$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $11d0f24a4ddb8d4f$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $11d0f24a4ddb8d4f$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $11d0f24a4ddb8d4f$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $11d0f24a4ddb8d4f$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $11d0f24a4ddb8d4f$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $11d0f24a4ddb8d4f$export$d2adc5dedf09fced = '#292A2E';
var $11d0f24a4ddb8d4f$export$f51762073d2bb381 = '#94C748';
var $11d0f24a4ddb8d4f$export$95e26d54def96891 = '#B3DF72';


var $2cf8b476b3bb79f9$var$requiredIndicatorStyles = null;
function $2cf8b476b3bb79f9$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "aria-hidden": true,
        className: (0, $b35f73781ccc1019$export$2e2bcd8739ae039)([
            "_syaz1ml5 _bozgv77o"
        ]),
        style: {
            "--_1xw92dq": (0, $efa73eb840607fbf$export$2e2bcd8739ae039)("var(--ds-text-danger, ".concat((0, $11d0f24a4ddb8d4f$export$2837b5a1a71d5c02), ")"))
        }
    }, "*");
}


var $9530357121cd5f70$var$_excluded = [
    "isChecked",
    "isDisabled",
    "isInvalid",
    "defaultChecked",
    "isIndeterminate",
    "onChange",
    "analyticsContext",
    "label",
    "name",
    "value",
    "isRequired",
    "testId",
    "xcss",
    "className"
];
/**
 * The input is visually hidden but remains in the DOM for accessibility.
 * State-based styling is handled by the Label component using CSS custom properties
 * that cascade to the CheckboxIcon, avoiding nested sibling selectors.
 */ var $9530357121cd5f70$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
};
/**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ var $9530357121cd5f70$var$Checkbox = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function Checkbox(_ref, ref) {
    var isCheckedProp = _ref.isChecked, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isInvalid = _ref.isInvalid, isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid, _ref$defaultChecked = _ref.defaultChecked, defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked, _ref$isIndeterminate = _ref.isIndeterminate, isIndeterminate = _ref$isIndeterminate === void 0 ? false : _ref$isIndeterminate, onChangeProps = _ref.onChange, analyticsContext = _ref.analyticsContext, label = _ref.label, name = _ref.name, value = _ref.value, isRequired = _ref.isRequired, testId = _ref.testId, xcss = _ref.xcss, className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $9530357121cd5f70$var$_excluded);
    var _useState = (0, $5FkrB.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isCheckedState = _useState2[0], setIsCheckedState = _useState2[1];
    var onChange = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    var onChangeAnalytics = (0, $e18af02ff64c1d51$export$a4687b0234b40e28)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "@atlaskit/checkbox",
        packageVersion: "17.3.4"
    });
    var internalRef = (0, $5FkrB.useRef)(null);
    var mergedRefs = (0, $a0f238ac02a0d36e$export$2e2bcd8739ae039)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    var isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5FkrB.useEffect)(function() {
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ $5FkrB.createElement((0, $3b03ac2b87f5e244$export$2e2bcd8739ae039), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? "".concat(rest.id, "-label") : undefined,
        testId: testId && "".concat(testId, "--checkbox-label"),
        xcss: xcss
    }, /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0
    }, rest, {
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $b35f73781ccc1019$export$2e2bcd8739ae039)([
            $9530357121cd5f70$var$checkboxStyles.root,
            className
        ]),
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && "".concat(testId, "--hidden-checkbox"),
        "data-invalid": isInvalid ? 'true' : undefined
    })), /*#__PURE__*/ $5FkrB.createElement((0, $c30cf9142c2d249a$export$2e2bcd8739ae039), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ $5FkrB.createElement((0, $354cf3d9c52a9cc1$export$2e2bcd8739ae039), null, label, isRequired && /*#__PURE__*/ $5FkrB.createElement((0, $2cf8b476b3bb79f9$export$2e2bcd8739ae039), null)));
}));
$9530357121cd5f70$var$Checkbox.displayName = 'Checkbox';
var $9530357121cd5f70$export$2e2bcd8739ae039 = $9530357121cd5f70$var$Checkbox;


/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $1f5c8ad4e714c1d8$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $1f5c8ad4e714c1d8$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $b35f73781ccc1019$export$2e2bcd8739ae039)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
var $1f5c8ad4e714c1d8$export$2e2bcd8739ae039 = $1f5c8ad4e714c1d8$var$VisuallyHidden;





var $5FkrB = parcelRequire("5FkrB");


var $fc0dd2f534f6c2e1$var$spacingStyles = (0, $e4d6a42270c0fa86$export$f6c783d06584602c)({
    width: '2rem',
    padding: 'space.0'
});
var $fc0dd2f534f6c2e1$export$1049d18762739f1d = function SelectableCell(_ref) {
    var children = _ref.children, as = _ref.as;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $48eaba2dc4ec4d09$export$41ad0bbfa4755cac), {
        as: as,
        xcss: $fc0dd2f534f6c2e1$var$spacingStyles
    }, children);
};


var $1784c866f06db016$var$SelectableCellComponent = function SelectableCellComponent() {
    var _useSelection = (0, $777bb5c8a69aeae5$export$a97c3cc4bf1da1ca)(), _useSelection2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useSelection, 2), _useSelection2$ = _useSelection2[0], allChecked = _useSelection2$.allChecked, checked = _useSelection2$.checked, toggleSelection = _useSelection2[1].toggleSelection;
    var idx = (0, $1f65586892545a6c$export$81981d840a2ece5)();
    var isChecked = (0, $5FkrB.useMemo)(function() {
        return allChecked || checked.includes(idx);
    }, [
        allChecked,
        checked,
        idx
    ]);
    var onChange = (0, $5FkrB.useCallback)(function(e) {
        return toggleSelection === null || toggleSelection === void 0 ? void 0 : toggleSelection(idx, e.nativeEvent.shiftKey);
    }, [
        idx,
        toggleSelection
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fc0dd2f534f6c2e1$export$1049d18762739f1d), {
        as: "td"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9530357121cd5f70$export$2e2bcd8739ae039), {
        isChecked: isChecked,
        onChange: onChange,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1f5c8ad4e714c1d8$export$2e2bcd8739ae039), null, "Select row ", idx + 1)
    }));
};
var $1784c866f06db016$var$SelectableCell = /*#__PURE__*/ (0, $5FkrB.memo)($1784c866f06db016$var$SelectableCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1784c866f06db016$export$2e2bcd8739ae039 = $1784c866f06db016$var$SelectableCell;



/* tr.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ parcelRequire("5FkrB");

const $5d71a2e069938e3b$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $5d71a2e069938e3b$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};


/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $875042696bafe16b$var$ATOMIC_GROUP_LENGTH = 5;
function $875042696bafe16b$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $875042696bafe16b$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


const $51dbabc3892ea9be$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $875042696bafe16b$export$2e2bcd8739ae039)(actualStyles);
};


function $e646d88de37ab34b$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $5d71a2e069938e3b$export$c4df1cb0c2b4d77c)();
        },
        cssMap () {
            throw (0, $5d71a2e069938e3b$export$c4df1cb0c2b4d77c)();
        },
        cx: $51dbabc3892ea9be$export$a274e22fb40f762e,
        XCSSProp () {
            throw (0, $5d71a2e069938e3b$export$c4df1cb0c2b4d77c)();
        }
    };
}


var $da9b4678c76c32cc$var$strictApi = (0, $e646d88de37ab34b$export$39716b4af53f4ad)();
var $da9b4678c76c32cc$export$dbf350e5966cf602 = $da9b4678c76c32cc$var$strictApi.css;
var $da9b4678c76c32cc$export$eb1ecd84a24ee424 = $da9b4678c76c32cc$var$strictApi.cssMap;
$da9b4678c76c32cc$var$strictApi.cssMap;
var $da9b4678c76c32cc$export$a274e22fb40f762e = $da9b4678c76c32cc$var$strictApi.cx;
var $da9b4678c76c32cc$var$XCSSProp = $da9b4678c76c32cc$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 


/* focusable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $eebd42600c0b8c3d$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $eebd42600c0b8c3d$var$_excluded2 = [
    "className"
];
var $eebd42600c0b8c3d$var$focusRingStyles = null;
var $eebd42600c0b8c3d$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $eebd42600c0b8c3d$var$Focusable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $eebd42600c0b8c3d$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $eebd42600c0b8c3d$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $b35f73781ccc1019$export$2e2bcd8739ae039)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $eebd42600c0b8c3d$export$2e2bcd8739ae039 = $eebd42600c0b8c3d$var$Focusable;


var $d34538b46070ed67$var$styles = {
    base: "_19itglyw _4t3i1wto _kqswh2mm _hpylidpf _btyzidpf",
    selected: "_bfhkcslv _irr3quvt",
    subitem: "_bfhkm7j4",
    bodyRow: "_1r62e4h9 _12ornqa1 _1ezz1tr0 _irr3134o"
};
var $d34538b46070ed67$export$5582bd7183a5e873 = function TR(_ref) {
    var children = _ref.children, testId = _ref.testId, isSelected = _ref.isSelected, _ref$isBodyRow = _ref.isBodyRow, isBodyRow = _ref$isBodyRow === void 0 ? true : _ref$isBodyRow, isSubitem = _ref.isSubitem;
    return /*#__PURE__*/ $5FkrB.createElement((0, $eebd42600c0b8c3d$export$2e2bcd8739ae039), {
        as: "tr",
        isInset: true,
        tabIndex: -1,
        "aria-selected": isSelected,
        testId: testId,
        xcss: (0, $da9b4678c76c32cc$export$a274e22fb40f762e)($d34538b46070ed67$var$styles.base, isBodyRow && $d34538b46070ed67$var$styles.bodyRow, isSelected && $d34538b46070ed67$var$styles.selected, isSubitem && $d34538b46070ed67$var$styles.subitem)
    }, children);
};


/**
 * __Row__
 *
 * A table row.
 *
 * - [Examples](https://atlassian.design/components/table/examples)
 */ var $1df2a8a5055de686$var$Row = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId;
    // To ensure valid nesting
    (0, $3ec5c5d14d7bc945$export$e4e48199ad91605c)();
    // to access table state
    var _useTable = (0, $c410d2d48027d6af$export$25bceaac3c7e4dc7)(), isSelectable = _useTable.isSelectable;
    var _useSelection = (0, $777bb5c8a69aeae5$export$a97c3cc4bf1da1ca)(), _useSelection2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useSelection, 1), _useSelection2$ = _useSelection2[0], allChecked = _useSelection2$.allChecked, checked = _useSelection2$.checked;
    var _useExpand = (0, $6a2e067d7f178d02$export$2e2bcd8739ae039)(), isExpanded = _useExpand.isExpanded;
    var _useExpandContent = (0, $043408dc1c1a3669$export$2e2bcd8739ae039)(), isExpandableContent = _useExpandContent.isExpandableContent;
    var rowId = (0, $1f65586892545a6c$export$81981d840a2ece5)();
    var isSelected = (0, $5FkrB.useMemo)(function() {
        if (!isSelectable || rowId === undefined) return undefined;
        return allChecked || checked.includes(rowId);
    }, [
        allChecked,
        checked,
        isSelectable,
        rowId
    ]);
    if (isExpanded === false && isExpandableContent) return null;
    var selectableCell = isSelectable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1784c866f06db016$export$2e2bcd8739ae039), null);
    if (isSelectable && isExpandableContent) selectableCell = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fc0dd2f534f6c2e1$export$1049d18762739f1d), {
        as: "td"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d34538b46070ed67$export$5582bd7183a5e873), {
        isSelected: isSelected,
        testId: testId,
        isSubitem: isExpandableContent
    }, selectableCell, children);
});
var $1df2a8a5055de686$export$2e2bcd8739ae039 = $1df2a8a5055de686$var$Row;


var $1Vcia = parcelRequire("1Vcia");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");




/* tbody.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $5e0a6a316d56daa1$var$bodyStyles = null;
var $5e0a6a316d56daa1$export$7005b8a93a167348 = function TBody(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("tbody", {
        className: (0, $b35f73781ccc1019$export$2e2bcd8739ae039)([
            "_19itglyw _kqswh2mm _9v7aidpf _18postnw _8x3u8fd9 _aetrb3bt _11fnglyw"
        ])
    }, children);
};


var $722a9df093eb8cc5$var$_excluded = [
    "idx"
];
function $722a9df093eb8cc5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $722a9df093eb8cc5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $722a9df093eb8cc5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $722a9df093eb8cc5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * __Table body__
 */ function $722a9df093eb8cc5$var$TBody(_ref) {
    var rows = _ref.rows, children = _ref.children;
    var _useTable = (0, $c410d2d48027d6af$export$25bceaac3c7e4dc7)(), sortFn = _useTable.sortFn;
    var _useSelection = (0, $777bb5c8a69aeae5$export$a97c3cc4bf1da1ca)(), _useSelection2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useSelection, 2), _state = _useSelection2[0], _useSelection2$ = _useSelection2[1], removeAll = _useSelection2$.removeAll, setMax = _useSelection2$.setMax;
    // TODO: this seems like something the user should control or opt into.
    (0, $5FkrB.useEffect)(function() {
        removeAll === null || removeAll === void 0 || removeAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- When the rows change, we [currently] want to call removeAll.
    }, [
        rows
    ]);
    var childrenCount = (0, $5FkrB.Children).count(children);
    var rowsLength = rows === null || rows === void 0 ? void 0 : rows.length;
    // Set data length (via setMax) whenever data changes
    (0, $5FkrB.useEffect)(function() {
        var numRows = rowsLength !== null && rowsLength !== void 0 ? rowsLength : childrenCount;
        setMax === null || setMax === void 0 || setMax(numRows);
    }, [
        rowsLength,
        childrenCount,
        setMax
    ]);
    var sortedRows = (0, $5FkrB.useMemo)(function() {
        return rows === null || rows === void 0 ? void 0 : rows.map(function(row, idx) {
            return $722a9df093eb8cc5$var$_objectSpread($722a9df093eb8cc5$var$_objectSpread({}, row), {}, {
                idx: idx
            });
        }).sort(sortFn);
    }, [
        rows,
        sortFn
    ]);
    var renderedChildren = function() {
        if (typeof children === 'function') return sortedRows === null || sortedRows === void 0 ? void 0 : sortedRows.map(function(_ref2) {
            var idx = _ref2.idx, row = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $722a9df093eb8cc5$var$_excluded);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1f65586892545a6c$export$329ef9142f16ee64), {
                key: idx,
                value: idx
            }, // @ts-expect-error
            children(row));
        });
        var childrenArray = Array.isArray(children) ? children : [
            children
        ];
        return childrenArray.map(function(row, idx) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1f65586892545a6c$export$329ef9142f16ee64), {
                key: idx,
                value: idx
            }, row);
        });
    }();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3ec5c5d14d7bc945$export$c0d7aba0938441d), {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5e0a6a316d56daa1$export$7005b8a93a167348), null, renderedChildren));
}
var $722a9df093eb8cc5$export$2e2bcd8739ae039 = $722a9df093eb8cc5$var$TBody;


var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");


var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");


var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");


var $c26cb8c597cf5d6f$var$justifyContentMap = {
    start: (0, $74Zh5.css)({
        justifyContent: 'start'
    }),
    center: (0, $74Zh5.css)({
        justifyContent: 'center'
    }),
    end: (0, $74Zh5.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $74Zh5.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $74Zh5.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $74Zh5.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $74Zh5.css)({
        justifyContent: 'stretch'
    })
};
var $c26cb8c597cf5d6f$var$flexDirectionMap = {
    column: (0, $74Zh5.css)({
        flexDirection: 'column'
    }),
    row: (0, $74Zh5.css)({
        flexDirection: 'row'
    })
};
var $c26cb8c597cf5d6f$var$flexWrapMap = {
    wrap: (0, $74Zh5.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $74Zh5.css)({
        flexWrap: 'nowrap'
    })
};
var $c26cb8c597cf5d6f$var$alignItemsMap = {
    start: (0, $74Zh5.css)({
        alignItems: 'start'
    }),
    center: (0, $74Zh5.css)({
        alignItems: 'center'
    }),
    baseline: (0, $74Zh5.css)({
        alignItems: 'baseline'
    }),
    end: (0, $74Zh5.css)({
        alignItems: 'end'
    }),
    stretch: (0, $74Zh5.css)({
        alignItems: 'stretch'
    })
};
var $c26cb8c597cf5d6f$var$baseStyles = (0, $74Zh5.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $c26cb8c597cf5d6f$var$Flex = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, id = _ref.id;
    var resolvedStyles = (0, $e4d6a42270c0fa86$export$a9c84988c8f81f2d)(xcss);
    return (0, $74Zh5.jsx)(Component, {
        id: id,
        role: role,
        className: resolvedStyles.static,
        css: [
            $c26cb8c597cf5d6f$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $8cd2f451c5ad80c5$export$bf46c3f9eeafc71f).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $8cd2f451c5ad80c5$export$bf46c3f9eeafc71f).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $8cd2f451c5ad80c5$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $c26cb8c597cf5d6f$var$alignItemsMap[alignItems],
            direction && $c26cb8c597cf5d6f$var$flexDirectionMap[direction],
            justifyContent && $c26cb8c597cf5d6f$var$justifyContentMap[justifyContent],
            wrap && $c26cb8c597cf5d6f$var$flexWrapMap[wrap]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(resolvedStyles.emotion || [])),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$c26cb8c597cf5d6f$var$Flex.displayName = 'Flex';
var $c26cb8c597cf5d6f$export$2e2bcd8739ae039 = $c26cb8c597cf5d6f$var$Flex;


var $c03a9f36412c08af$var$flexGrowMap = {
    hug: (0, $e4d6a42270c0fa86$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $e4d6a42270c0fa86$export$f6c783d06584602c)({
        width: '100%',
        flexGrow: 1
    })
};
var $c03a9f36412c08af$var$separatorStyles = (0, $74Zh5.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $c03a9f36412c08af$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $74Zh5.jsx)("span", {
        css: $c03a9f36412c08af$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $c03a9f36412c08af$var$Inline = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, id = _ref2.id, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $74Zh5.jsx)($c03a9f36412c08af$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $5FkrB.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $74Zh5.jsx)((0, $5FkrB.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $c03a9f36412c08af$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $74Zh5.jsx)((0, $c26cb8c597cf5d6f$export$2e2bcd8739ae039), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$c03a9f36412c08af$var$Inline.displayName = 'Inline';
var $c03a9f36412c08af$export$2e2bcd8739ae039 = $c03a9f36412c08af$var$Inline;






var $5FkrB = parcelRequire("5FkrB");

var $c2c88a7f46957c03$var$overlayStyles = (0, $e4d6a42270c0fa86$export$f6c783d06584602c)({
    display: 'flex',
    position: 'absolute',
    inset: 'space.0',
    insetInlineStart: 'space.400'
});
var $c2c88a7f46957c03$export$7e782ae264b7f61c = function BulkActionOverlay(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a18eb272727512e1$export$2e2bcd8739ae039), {
        as: "th",
        paddingInline: "space.100",
        backgroundColor: "elevation.surface",
        xcss: $c2c88a7f46957c03$var$overlayStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c03a9f36412c08af$export$2e2bcd8739ae039), {
        space: "space.300",
        alignBlock: "center"
    }, children));
};



/* thead.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $b1f2c46434dde5bf$var$baseStyles = null;
var $b1f2c46434dde5bf$export$c4c2bc57f2e82919 = function THead(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("thead", {
        className: (0, $b35f73781ccc1019$export$2e2bcd8739ae039)([
            "_1r04idpf _19itglyw _179rhf6m _mqm25u6v _kqsw1if8 _1pbykb7n _bfhkvuon"
        ])
    }, children);
};



var $46ca8edaccb96b62$var$THead = function THead(_ref) {
    var actions = _ref.actions, children = _ref.children;
    var _useTable = (0, $c410d2d48027d6af$export$25bceaac3c7e4dc7)(), isSelectable = _useTable.isSelectable;
    var _useSelection = (0, $777bb5c8a69aeae5$export$a97c3cc4bf1da1ca)(), _useSelection2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useSelection, 2), state = _useSelection2[0], _useSelection2$ = _useSelection2[1], setAll = _useSelection2$.setAll, removeAll = _useSelection2$.removeAll;
    var isChecked = state.allChecked || state.anyChecked;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b1f2c46434dde5bf$export$c4c2bc57f2e82919), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d34538b46070ed67$export$5582bd7183a5e873), {
        isBodyRow: false
    }, isSelectable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fc0dd2f534f6c2e1$export$1049d18762739f1d), {
        as: "th"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9530357121cd5f70$export$2e2bcd8739ae039), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1f5c8ad4e714c1d8$export$2e2bcd8739ae039), {
            id: "select-all"
        }, "Select all rows"),
        onChange: isChecked ? removeAll : setAll,
        isChecked: isChecked,
        isIndeterminate: state.anyChecked && !state.allChecked
    })), children, isSelectable && isChecked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c2c88a7f46957c03$export$7e782ae264b7f61c), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text, #172B4D)",
            /* @ts-ignore migrate to Text */ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            fontWeight: "var(--ds-font-weight-medium, 500)"
        }
    }, state.checked.length, " selected"), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c03a9f36412c08af$export$2e2bcd8739ae039), {
        alignBlock: "stretch",
        space: "space.100"
    }, actions(state.checked)))));
};
var $46ca8edaccb96b62$export$2e2bcd8739ae039 = $46ca8edaccb96b62$var$THead;


var $0e561d53dcc9f631$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::36758847330c30e3d31c155e38099f5e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($0e561d53dcc9f631$exports, "__esModule", {
    value: true
});
$0e561d53dcc9f631$exports.default = void 0;

var $0e561d53dcc9f631$var$_react = $0e561d53dcc9f631$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $0e561d53dcc9f631$var$_UNSAFE_baseNew = $0e561d53dcc9f631$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $0e561d53dcc9f631$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e561d53dcc9f631$var$CommentIcon = (props)=>/*#__PURE__*/ $0e561d53dcc9f631$var$_react.default.createElement($0e561d53dcc9f631$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M4.25 13.25v-.75h-.2l-.172.099zm-3.5 2H0a.75.75 0 0 0 1.122.651zM2.625 2h10.75V.5H2.625zM14.5 3.125v8.25H16v-8.25zM13.375 12.5H4.25V14h9.125zm-9.497.099-3.5 2 .744 1.302 3.5-2zM1.5 15.25V3.125H0V15.25zM4 6.5h8V5H4zm0 3h5V8H4zm10.5 1.875c0 .621-.504 1.125-1.125 1.125V14A2.625 2.625 0 0 0 16 11.375zM13.375 2c.621 0 1.125.504 1.125 1.125H16A2.625 2.625 0 0 0 13.375.5zM2.625.5A2.625 2.625 0 0 0 0 3.125h1.5C1.5 2.504 2.004 2 2.625 2z"/>`
    }, props));
$0e561d53dcc9f631$var$CommentIcon.displayName = 'CommentIcon';
var $0e561d53dcc9f631$var$_default = $0e561d53dcc9f631$exports.default = $0e561d53dcc9f631$var$CommentIcon;


var $59c4a893ce5f1bf5$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e445612cfd22a19ca6ff947247db0ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($59c4a893ce5f1bf5$exports, "__esModule", {
    value: true
});
$59c4a893ce5f1bf5$exports.default = void 0;

var $59c4a893ce5f1bf5$var$_react = $59c4a893ce5f1bf5$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $59c4a893ce5f1bf5$var$_UNSAFE_baseNew = $59c4a893ce5f1bf5$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $59c4a893ce5f1bf5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $59c4a893ce5f1bf5$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $59c4a893ce5f1bf5$var$_react.default.createElement($59c4a893ce5f1bf5$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 2.75c-3.255 0-6.086 2.039-7.13 4.888a1.06 1.06 0 0 0 0 .724C1.914 11.212 4.745 13.25 8 13.25s6.086-2.039 7.129-4.888a1.06 1.06 0 0 0 0-.724c-1.043-2.85-3.874-4.888-7.13-4.888Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.25 8a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"/>`
    }, props));
$59c4a893ce5f1bf5$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $59c4a893ce5f1bf5$var$_default = $59c4a893ce5f1bf5$exports.default = $59c4a893ce5f1bf5$var$EyeOpenIcon;


var $0dd7a84998b77bec$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1b7d311e04eceb9781b3930a729d8836>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($0dd7a84998b77bec$exports, "__esModule", {
    value: true
});
$0dd7a84998b77bec$exports.default = void 0;

var $0dd7a84998b77bec$var$_react = $0dd7a84998b77bec$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $0dd7a84998b77bec$var$_UNSAFE_baseNew = $0dd7a84998b77bec$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $0dd7a84998b77bec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PersonAdded".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for a user added to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0dd7a84998b77bec$var$PersonAddedIcon = (props)=>/*#__PURE__*/ $0dd7a84998b77bec$var$_react.default.createElement($0dd7a84998b77bec$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 15v-2.25a3 3 0 0 1 3-3h2.5a3 3 0 0 1 3 3V15m.25-7.278L11.346 9.5l4-4M8.25 4a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
    }, props));
$0dd7a84998b77bec$var$PersonAddedIcon.displayName = 'PersonAddedIcon';
var $0dd7a84998b77bec$var$_default = $0dd7a84998b77bec$exports.default = $0dd7a84998b77bec$var$PersonAddedIcon;


function $24c02ea0e14dbe4f$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $24c02ea0e14dbe4f$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $24c02ea0e14dbe4f$var$$parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
/// <reference types="./types/custom.d.ts" />
var $24c02ea0e14dbe4f$var$$a69491ea5a126553$exports = {};
var $24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports = {};
var $24c02ea0e14dbe4f$var$$660bd1c6cb41002a$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$660bd1c6cb41002a$exports, "Blockquote", ()=>$24c02ea0e14dbe4f$export$29a7a275fe11687);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$660bd1c6cb41002a$exports, "blockquoteStyles", ()=>$24c02ea0e14dbe4f$export$7a77f8e9665fa6b2);
const $24c02ea0e14dbe4f$export$29a7a275fe11687 = ({ children: children })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("blockquote", {
        css: (0, $74Zh5.css)($24c02ea0e14dbe4f$export$7a77f8e9665fa6b2),
        children: children
    });
};
const $24c02ea0e14dbe4f$var$$660bd1c6cb41002a$var$fontSizeStyles = {
    fontSize: "1.5rem",
    lineHeight: "2.25rem",
    fontWeight: 600
};
const $24c02ea0e14dbe4f$export$7a77f8e9665fa6b2 = {
    paddingLeft: 0,
    fontFamily: "Inter, sans-serif",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    ...$24c02ea0e14dbe4f$var$$660bd1c6cb41002a$var$fontSizeStyles,
    span: $24c02ea0e14dbe4f$var$$660bd1c6cb41002a$var$fontSizeStyles,
    "&:before, &:after": {
        content: "''"
    }
};
var $24c02ea0e14dbe4f$var$$fec02fc26c7e145d$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fec02fc26c7e145d$exports, "ButtonSize", ()=>$24c02ea0e14dbe4f$export$5dd2748b7940a2a0);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fec02fc26c7e145d$exports, "ButtonAppearance", ()=>$24c02ea0e14dbe4f$export$261c9483fc4a455a);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fec02fc26c7e145d$exports, "Button", ()=>$24c02ea0e14dbe4f$export$353f5b6fc5456de1);
const $24c02ea0e14dbe4f$var$$ecfd5f2b18d4854e$export$b7c3a2f69225ecf = ({ label: label, type: type, clickHandler: clickHandler, iconBefore: iconBefore, iconAfter: iconAfter, appearance: appearance, testId: testId, href: href, target: target, fullWidth: fullWidth = false, disabled: disabled = false, isLoading: isLoading = false, selected: selected = false })=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $e015d36248b70172$export$2e2bcd8739ae039), {
        "aria-label": label.replaceAll("-", " "),
        type: type,
        onClick: clickHandler,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        appearance: appearance,
        testId: testId,
        href: href,
        target: target,
        shouldFitContainer: fullWidth,
        isDisabled: disabled || isLoading,
        isSelected: selected,
        css: [
            isLoading && !label && (0, $74Zh5.css)({
                padding: "21px 49px",
                alignItems: "center"
            }),
            fullWidth && (0, $74Zh5.css)({
                width: "100%",
                justifyContent: "center"
            })
        ],
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    isLoading && label && (0, $74Zh5.css)({
                        marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
                    })
                ],
                children: label
            }),
            isLoading && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e9bb9e7afd1cf629$export$2e2bcd8739ae039), {
                testId: "spinner",
                size: "small"
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$384448a6ffd0907f$export$5be053290bf6cd4c = (appearance, selected, disabled)=>{
    let testId = `button-${appearance}`;
    if (selected) testId += "-selected";
    if (disabled) testId += "-disabled";
    return testId;
};
const $24c02ea0e14dbe4f$var$$384448a6ffd0907f$export$99c79d2ae299b19a = (iconType)=>iconType ? iconType.replaceAll("-", " ") : "button icon";
const $24c02ea0e14dbe4f$var$$f0f55be381b0aa07$export$c25acd513dcc8062 = ({ clickHandler: clickHandler, testId: testId, disabled: disabled = false, selected: selected = false, isLoading: isLoading = false, tooltip: tooltip, iconType: iconType, showBeforeIcon: showBeforeIcon, href: href, target: target, iconColor: iconColor, size: size })=>{
    const commonProps = {
        tabIndex: 0,
        "aria-label": $24c02ea0e14dbe4f$var$$384448a6ffd0907f$export$99c79d2ae299b19a(iconType),
        "data-testid": testId,
        css: [
            $24c02ea0e14dbe4f$var$$f0f55be381b0aa07$var$learningButtonIconStyles["base"],
            size === $24c02ea0e14dbe4f$export$5dd2748b7940a2a0.MEDIUM && $24c02ea0e14dbe4f$var$$f0f55be381b0aa07$var$learningButtonIconStyles["medium"],
            selected && $24c02ea0e14dbe4f$var$$f0f55be381b0aa07$var$learningButtonIconStyles["selected"],
            iconColor && (0, $74Zh5.css)({
                color: iconColor
            })
        ],
        onClick: clickHandler
    };
    const content = (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            isLoading && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e9bb9e7afd1cf629$export$2e2bcd8739ae039), {
                testId: "spinner",
                size: "small"
            }),
            showBeforeIcon
        ]
    });
    let element;
    if (href && !disabled) element = (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        ...commonProps,
        href: href,
        target: target,
        rel: target === "_blank" ? "noreferrer" : "",
        children: content
    });
    else element = (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
        id: "icon-button",
        ...commonProps,
        disabled: disabled,
        children: content
    });
    return tooltip ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $1ee6819d2d8fb6a1$export$2e2bcd8739ae039), {
        content: tooltip,
        testId: "tooltip",
        children: element
    }) : element;
};
const $24c02ea0e14dbe4f$var$$f0f55be381b0aa07$var$learningButtonIconStyles = {
    base: (0, $74Zh5.css)({
        width: "24px",
        height: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "4px",
        border: "none",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon"),
        backgroundColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")
        },
        "&:active": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.pressed")
        },
        "&:disabled": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.disabled"),
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.disabled"),
            cursor: "not-allowed"
        }
    }),
    medium: (0, $74Zh5.css)({
        width: "38px",
        height: "38px",
        minWidth: "38px",
        minHeight: "38px"
    }),
    selected: (0, $74Zh5.css)({
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected"),
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.selected"),
        "&:hover": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected.hovered"),
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.selected")
        }
    })
};
const $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$8f9833f38f34a075 = {
    basic: (0, $74Zh5.css)({
        fontFamily: "Charlie Text, sans-serif",
        display: "flex",
        alignItems: "center",
        borderRadius: "4px",
        borderStyle: "solid",
        borderWidth: "1px",
        cursor: "pointer",
        textDecoration: "none",
        justifyContent: "center",
        maxWidth: "max-content",
        width: "100%",
        whiteSpace: "nowrap",
        boxSizing: "border-box",
        height: "40px",
        "&:hover": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected.bold.hovered"),
            borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected"),
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"),
            textDecoration: "none"
        },
        "&:active": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected.bold.pressed"),
            borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected"),
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse")
        },
        "&:disabled": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.disabled"),
            borderColor: "transparent",
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle"),
            cursor: "not-allowed"
        }
    }),
    primary: (0, $74Zh5.css)({
        padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.brand.bold"),
        borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.brand"),
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"),
        "&:focus-visible": {
            outline: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.focused")}`
        }
    }),
    secondary: (0, $74Zh5.css)({
        padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: "transparent",
        borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.brand"),
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand")
    }),
    danger: (0, $74Zh5.css)({
        padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.danger.bold"),
        borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.danger"),
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse")
    }),
    warning: (0, $74Zh5.css)({
        padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.warning.bold"),
        borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.warning"),
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.warning.inverse")
    }),
    subtle: (0, $74Zh5.css)({
        padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: "transparent",
        borderColor: "transparent",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
    }),
    success: (0, $74Zh5.css)({
        padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.success.bold"),
        borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.success"),
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse")
    }),
    selected: (0, $74Zh5.css)({
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected"),
        borderColor: "transparent",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
        "&:hover": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected"),
            borderColor: "transparent",
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand")
        }
    })
};
const $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$b2e4e24d9c5d7463 = {
    medium: (0, $74Zh5.css)({
        fontSize: "16px",
        lineHeight: "20px",
        fontWeight: 600,
        height: "40px"
    }),
    large: (0, $74Zh5.css)({
        fontSize: "20px",
        lineHeight: "24px",
        fontWeight: 600,
        height: "48px"
    })
};
const $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$84379743ac6ff850 = {
    medium: (0, $74Zh5.css)({
        padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`
    }),
    "medium-icon-before": (0, $74Zh5.css)({
        padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} 10px 10px`
    }),
    "medium-icon-after": (0, $74Zh5.css)({
        padding: `10px 10px 10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`
    }),
    large: (0, $74Zh5.css)({
        maxWidth: "max-content",
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")}`
    }),
    "large-icon-before": (0, $74Zh5.css)({
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`
    }),
    "large-icon-after": (0, $74Zh5.css)({
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")}`
    })
};
const $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$6398dd78520de6de = {
    large: (0, $74Zh5.css)({
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
            padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`
        }
    }),
    "large-icon-before": (0, $74Zh5.css)({
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
            padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} 10px 10px`
        }
    }),
    "large-icon-after": (0, $74Zh5.css)({
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
            padding: `10px 10px 10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`
        }
    })
};
const $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$9d41b2b2e9b27135 = (0, $74Zh5.css)({
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        fontSize: "16px",
        lineHeight: "20px"
    }
});
const $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$1870a7443335e00d = (0, $74Zh5.css)({
    width: "20px",
    height: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    "& > span": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    "& svg": {
        maxWidth: "20px",
        maxHeight: "20px"
    }
});
const $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$46d009ded5eecf4e = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon"),
    cursor: "not-allowed"
});
const $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$d0e85600c25cfb6 = (0, $74Zh5.css)({
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.disabled"),
    borderColor: "transparent",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle"),
    "&:hover": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.disabled"),
        borderColor: "transparent",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle"),
        cursor: "not-allowed"
    }
});
const $24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$8c0322faba831be3 = (appearance, size)=>[
        $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$8f9833f38f34a075["basic"],
        $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$8f9833f38f34a075[appearance],
        $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$b2e4e24d9c5d7463[size]
    ];
const $24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$18739f551ab326b6 = (size, isButtonWithoutIcon, showBeforeIcon, showAfterIcon)=>{
    const styles = [];
    if (isButtonWithoutIcon) styles.push($24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$84379743ac6ff850[size]);
    if (showBeforeIcon) styles.push($24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$84379743ac6ff850[`${size}-icon-before`]);
    if (showAfterIcon) styles.push($24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$84379743ac6ff850[`${size}-icon-after`]);
    return styles;
};
const $24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$10dac92f1edafe3b = (isResponsiveSpacing, size, showBeforeIcon, showAfterIcon)=>{
    const styles = [
        $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$6398dd78520de6de[size],
        $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$9d41b2b2e9b27135
    ];
    if (!isResponsiveSpacing) return [];
    if (showBeforeIcon) styles.push($24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$6398dd78520de6de[`${size}-icon-before`]);
    if (showAfterIcon) styles.push($24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$6398dd78520de6de[`${size}-icon-after`]);
    return styles;
};
const $24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$1bff1bc920069ec8 = (appearance)=>{
    if (appearance === $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY) return (0, $74Zh5.css)({
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse")
    });
    if (appearance === $24c02ea0e14dbe4f$export$261c9483fc4a455a.SECONDARY) return (0, $74Zh5.css)({
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand")
    });
    return null;
};
const $24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$3f4ba612f3306fd2 = (selected, isLoading, disabled, fullWidth)=>{
    const styles = [];
    if (selected) styles.push($24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$8f9833f38f34a075["selected"]);
    if (isLoading || disabled) styles.push((0, $74Zh5.css)({
        ...$24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$d0e85600c25cfb6,
        pointerEvents: "none",
        cursor: "not-allowed"
    }));
    if (fullWidth) styles.push((0, $74Zh5.css)({
        width: "100%",
        maxWidth: "none",
        justifyContent: "center"
    }));
    return styles;
};
const $24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$a803e3773f881664 = (size, isButtonWithoutIcon, showBeforeIcon, showAfterIcon, withPadding = true)=>{
    const linkButtonSpacingStyles = {
        medium: (0, $74Zh5.css)({
            padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`
        }),
        "medium-icon-before": (0, $74Zh5.css)({
            padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} 10px 10px`
        }),
        "medium-icon-after": (0, $74Zh5.css)({
            padding: `10px 10px 10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`
        }),
        large: (0, $74Zh5.css)({
            maxWidth: "max-content",
            padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")}`
        }),
        "large-icon-before": (0, $74Zh5.css)({
            padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`
        }),
        "large-icon-after": (0, $74Zh5.css)({
            padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")}`
        })
    };
    const styles = [];
    if (isButtonWithoutIcon) styles.push(linkButtonSpacingStyles[size]);
    if (showBeforeIcon) styles.push(linkButtonSpacingStyles[`${size}-icon-before`]);
    if (showAfterIcon) styles.push(linkButtonSpacingStyles[`${size}-icon-after`]);
    if (!withPadding) styles.push((0, $74Zh5.css)({
        padding: 0
    }));
    return styles;
};
const $24c02ea0e14dbe4f$var$$9a690c81e99c8d02$var$getLinkButtonStyles = (disabled)=>[
        $24c02ea0e14dbe4f$var$$9a690c81e99c8d02$var$learningButtonLinkStyles["basic"],
        disabled && $24c02ea0e14dbe4f$var$$9a690c81e99c8d02$var$learningButtonLinkStyles["disabled"]
    ];
const $24c02ea0e14dbe4f$var$$9a690c81e99c8d02$export$29d11c0fe2fc51d8 = ({ label: label, disabled: disabled = false, clickHandler: clickHandler, testId: testId, size: size = $24c02ea0e14dbe4f$export$5dd2748b7940a2a0.MEDIUM, href: href, target: target, withPadding: withPadding = true, showBeforeIcon: showBeforeIcon, showAfterIcon: showAfterIcon, isButtonWithoutIcon: isButtonWithoutIcon })=>{
    const commonProps = {
        "aria-label": label.replaceAll("-", " "),
        "data-testid": testId,
        css: [
            ...$24c02ea0e14dbe4f$var$$9a690c81e99c8d02$var$getLinkButtonStyles(disabled),
            ...$24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$a803e3773f881664(size, isButtonWithoutIcon, showBeforeIcon, showAfterIcon, withPadding)
        ]
    };
    const content = (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            showBeforeIcon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $24c02ea0e14dbe4f$var$$9a690c81e99c8d02$var$buttonIconContainerStyles,
                    (0, $74Zh5.css)({
                        marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
                    })
                ],
                children: showBeforeIcon
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                children: label
            }),
            showAfterIcon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $24c02ea0e14dbe4f$var$$9a690c81e99c8d02$var$buttonIconContainerStyles,
                    (0, $74Zh5.css)({
                        marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
                    }),
                    disabled && $24c02ea0e14dbe4f$var$$9a690c81e99c8d02$var$disabledIconStyles
                ],
                children: showAfterIcon
            })
        ]
    });
    if (href && !disabled) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        ...commonProps,
        href: href,
        target: target,
        rel: target === "_blank" ? "noreferrer" : "",
        onClick: clickHandler,
        children: content
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
        ...commonProps,
        disabled: disabled,
        onClick: clickHandler,
        children: content
    });
};
const $24c02ea0e14dbe4f$var$$9a690c81e99c8d02$var$learningButtonLinkStyles = {
    basic: (0, $74Zh5.css)({
        display: "flex",
        width: "fit-content",
        padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`,
        border: "none",
        alignItems: "center",
        fontFamily: "Charlie Text, sans-serif",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "20px",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
        background: "transparent",
        outline: "none",
        cursor: "pointer",
        "&:hover": {
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
            textDecoration: "underline",
            textUnderlineOffset: "4px"
        },
        "&:active": {
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
            textDecoration: "underline"
        }
    }),
    disabled: (0, $74Zh5.css)({
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.disabled"),
        "&:hover": {
            textDecoration: "none"
        },
        "&:active": {
            textDecoration: "none"
        }
    })
};
const $24c02ea0e14dbe4f$var$$9a690c81e99c8d02$var$buttonIconContainerStyles = (0, $74Zh5.css)({
    width: "24px",
    height: "24px"
});
const $24c02ea0e14dbe4f$var$$9a690c81e99c8d02$var$disabledIconStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.disabled"),
    cursor: "not-allowed"
});
const $24c02ea0e14dbe4f$var$$73286ba8e7c0bafe$export$9508e056e78f90ef = ({ label: label, appearance: appearance, disabled: disabled = false, isLoading: isLoading = false, clickHandler: clickHandler, testId: testId, href: href, target: target, fullWidth: fullWidth = false, selected: selected = false, size: size = $24c02ea0e14dbe4f$export$5dd2748b7940a2a0.MEDIUM, showBeforeIcon: showBeforeIcon, showAfterIcon: showAfterIcon, isButtonWithoutIcon: isButtonWithoutIcon, isResponsiveSpacing: isResponsiveSpacing, as: as = "a", type: type })=>{
    const commonProps = {
        "aria-label": label.replaceAll("-", " "),
        onClick: disabled || isLoading ? undefined : clickHandler,
        role: as === "button" ? undefined : href ? undefined : "button",
        tabIndex: disabled || isLoading ? -1 : 0,
        "data-testid": testId,
        css: [
            ...$24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$8c0322faba831be3(appearance, size),
            ...$24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$18739f551ab326b6(size, isButtonWithoutIcon, showBeforeIcon, showAfterIcon),
            ...$24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$10dac92f1edafe3b(isResponsiveSpacing, size, showBeforeIcon, showAfterIcon),
            $24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$1bff1bc920069ec8(appearance),
            ...$24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$3f4ba612f3306fd2(selected, isLoading, disabled, fullWidth)
        ]
    };
    const children = (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            isLoading && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e9bb9e7afd1cf629$export$2e2bcd8739ae039), {
                testId: "spinner",
                size: "small"
            }),
            showBeforeIcon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$1870a7443335e00d,
                    label && (0, $74Zh5.css)({
                        marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
                        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
                            marginRight: 0
                        }
                    })
                ],
                children: showBeforeIcon
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: isLoading && (0, $74Zh5.css)({
                    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
                }),
                children: label
            }),
            showAfterIcon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$1870a7443335e00d,
                    (0, $74Zh5.css)({
                        marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
                    }),
                    disabled && $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$46d009ded5eecf4e
                ],
                children: showAfterIcon
            })
        ]
    });
    if (as === "button") return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
        ...commonProps,
        type: type,
        disabled: disabled || isLoading,
        children: children
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        ...commonProps,
        href: !disabled && !isLoading ? href : undefined,
        target: target,
        rel: target === "_blank" ? "noreferrer" : "",
        children: children
    });
};
const $24c02ea0e14dbe4f$var$$ea4b236bf0573f71$export$69c6dd121e96df9e = ({ label: label, type: type = "button", appearance: appearance, disabled: disabled = false, isLoading: isLoading = false, clickHandler: clickHandler, testId: testId, fullWidth: fullWidth = false, selected: selected = false, size: size = $24c02ea0e14dbe4f$export$5dd2748b7940a2a0.MEDIUM, showBeforeIcon: showBeforeIcon, showAfterIcon: showAfterIcon, isButtonWithoutIcon: isButtonWithoutIcon, isResponsiveSpacing: isResponsiveSpacing, href: href, target: target })=>{
    const commonProps = {
        "aria-label": label.replaceAll("-", " "),
        "data-testid": testId,
        css: [
            ...$24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$8c0322faba831be3(appearance, size),
            ...$24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$18739f551ab326b6(size, isButtonWithoutIcon, showBeforeIcon, showAfterIcon),
            ...$24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$10dac92f1edafe3b(isResponsiveSpacing, size, showBeforeIcon, showAfterIcon),
            ...$24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$3f4ba612f3306fd2(selected, isLoading, disabled, fullWidth)
        ],
        onClick: clickHandler
    };
    const content = (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            isLoading && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e9bb9e7afd1cf629$export$2e2bcd8739ae039), {
                testId: "spinner",
                size: "small"
            }),
            showBeforeIcon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$1870a7443335e00d,
                    (0, $74Zh5.css)({
                        marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
                    })
                ],
                children: showBeforeIcon
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    isLoading && (0, $74Zh5.css)({
                        marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
                    })
                ],
                children: label
            }),
            showAfterIcon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$1870a7443335e00d,
                    (0, $74Zh5.css)({
                        marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
                    })
                ],
                children: showAfterIcon
            })
        ]
    });
    if (href && !disabled) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        ...commonProps,
        href: href,
        target: target,
        rel: target === "_blank" ? "noreferrer" : "",
        children: content
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
        ...commonProps,
        type: type,
        disabled: disabled || isLoading,
        children: content
    });
};
let $24c02ea0e14dbe4f$export$5dd2748b7940a2a0;
(function(ButtonSize) {
    ButtonSize["MEDIUM"] = "medium";
    ButtonSize["LARGE"] = "large";
})($24c02ea0e14dbe4f$export$5dd2748b7940a2a0 || ($24c02ea0e14dbe4f$export$5dd2748b7940a2a0 = {}));
let $24c02ea0e14dbe4f$export$261c9483fc4a455a;
(function(ButtonAppearance) {
    ButtonAppearance["DEFAULT"] = "default";
    ButtonAppearance["DANGER"] = "danger";
    ButtonAppearance["LINK"] = "link";
    ButtonAppearance["PRIMARY"] = "primary";
    ButtonAppearance["SECONDARY"] = "secondary";
    ButtonAppearance["SUBTLE"] = "subtle";
    ButtonAppearance["WARNING"] = "warning";
    ButtonAppearance["ICON"] = "icon";
    ButtonAppearance["SUCCESS"] = "success";
})($24c02ea0e14dbe4f$export$261c9483fc4a455a || ($24c02ea0e14dbe4f$export$261c9483fc4a455a = {}));
const $24c02ea0e14dbe4f$export$353f5b6fc5456de1 = (props)=>{
    const { appearance: appearance = $24c02ea0e14dbe4f$export$261c9483fc4a455a.DEFAULT, selected: selected = false, disabled: disabled = false, size: size = $24c02ea0e14dbe4f$export$5dd2748b7940a2a0.MEDIUM, onClick: onClick, iconBefore: iconBefore, iconAfter: iconAfter, isLoading: isLoading = false, isResponsive: isResponsive = false } = props;
    const clickHandler = (0, $5FkrB.useCallback)((e)=>{
        if (onClick) onClick(e);
    }, [
        onClick
    ]);
    const isButtonWithoutIcon = !iconBefore && !iconAfter;
    const showBeforeIcon = !isLoading && iconBefore || false;
    const showAfterIcon = !isLoading && iconAfter || false;
    const isResponsiveSpacing = isResponsive && [
        $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
        $24c02ea0e14dbe4f$export$261c9483fc4a455a.SECONDARY
    ].includes(appearance) && size === $24c02ea0e14dbe4f$export$5dd2748b7940a2a0.LARGE;
    const testId = $24c02ea0e14dbe4f$var$$384448a6ffd0907f$export$5be053290bf6cd4c(appearance, selected, disabled);
    const commonProps = {
        ...props,
        size: size,
        clickHandler: clickHandler,
        isButtonWithoutIcon: isButtonWithoutIcon,
        showBeforeIcon: showBeforeIcon,
        showAfterIcon: showAfterIcon,
        isResponsiveSpacing: isResponsiveSpacing,
        testId: testId
    };
    const componentMap = {
        [$24c02ea0e14dbe4f$export$261c9483fc4a455a.DEFAULT]: $24c02ea0e14dbe4f$var$$ecfd5f2b18d4854e$export$b7c3a2f69225ecf,
        [$24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON]: $24c02ea0e14dbe4f$var$$f0f55be381b0aa07$export$c25acd513dcc8062,
        [$24c02ea0e14dbe4f$export$261c9483fc4a455a.LINK]: $24c02ea0e14dbe4f$var$$9a690c81e99c8d02$export$29d11c0fe2fc51d8,
        [$24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY]: $24c02ea0e14dbe4f$var$$73286ba8e7c0bafe$export$9508e056e78f90ef,
        [$24c02ea0e14dbe4f$export$261c9483fc4a455a.SECONDARY]: $24c02ea0e14dbe4f$var$$73286ba8e7c0bafe$export$9508e056e78f90ef
    };
    const Component = componentMap[appearance] ?? $24c02ea0e14dbe4f$var$$ea4b236bf0573f71$export$69c6dd121e96df9e;
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)(Component, {
        ...commonProps
    });
};
var $24c02ea0e14dbe4f$var$$d501466973a9f0a6$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$d501466973a9f0a6$exports, "CheckboxType", ()=>$24c02ea0e14dbe4f$export$138e17770a0a93a6);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$d501466973a9f0a6$exports, "CheckboxSize", ()=>$24c02ea0e14dbe4f$export$5e435bc8b081a399);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$d501466973a9f0a6$exports, "Checkbox", ()=>$24c02ea0e14dbe4f$export$48513f6b9f8ce62d);
var $24c02ea0e14dbe4f$var$$633811e9cd66d921$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$633811e9cd66d921$exports, "useKeyboardInteraction", ()=>$24c02ea0e14dbe4f$export$2a0b6757d41dacb2);
const $24c02ea0e14dbe4f$export$2a0b6757d41dacb2 = (handler)=>{
    return (0, $5FkrB.useCallback)((e)=>{
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            e.stopPropagation();
            handler();
        }
    }, [
        handler
    ]);
};
let $24c02ea0e14dbe4f$export$138e17770a0a93a6;
(function(CheckboxType) {
    CheckboxType["DEFAULT"] = "DEFAULT";
    CheckboxType[/** TODO: remove success styles in scope of the QUIZ component update */ "SUCCESS"] = "SUCCESS";
    CheckboxType["DANGER"] = "DANGER";
    CheckboxType["DISABLED"] = "DISABLED";
})($24c02ea0e14dbe4f$export$138e17770a0a93a6 || ($24c02ea0e14dbe4f$export$138e17770a0a93a6 = {}));
let $24c02ea0e14dbe4f$export$5e435bc8b081a399;
(function(CheckboxSize) {
    CheckboxSize["DEFAULT"] = "DEFAULT";
    CheckboxSize["LARGE"] = "LARGE";
})($24c02ea0e14dbe4f$export$5e435bc8b081a399 || ($24c02ea0e14dbe4f$export$5e435bc8b081a399 = {}));
const $24c02ea0e14dbe4f$export$48513f6b9f8ce62d = ({ label: label, isChecked: isChecked, onChange: onChange, type: type = $24c02ea0e14dbe4f$export$138e17770a0a93a6.DEFAULT, size: size = $24c02ea0e14dbe4f$export$5e435bc8b081a399.DEFAULT, isIndeterminate: isIndeterminate = false, isRequired: isRequired = false, isBold: isBold, tabIndex: tabIndex = 0 })=>{
    const [userHasInteracted, setUserHasInteracted] = (0, $5FkrB.useState)(false);
    const checkboxRef = (0, $5FkrB.useRef)(null);
    const handleChange = (0, $5FkrB.useCallback)(()=>{
        setUserHasInteracted(true);
        if (onChange) onChange();
    }, [
        onChange
    ]);
    const handleKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleChange);
    (0, $5FkrB.useEffect)(()=>{
        if (checkboxRef.current) checkboxRef.current.indeterminate = isIndeterminate && !userHasInteracted;
    }, [
        isIndeterminate,
        userHasInteracted
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("label", {
        onKeyDown: handleKeyDown,
        css: [
            $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$labelStyles,
            size === $24c02ea0e14dbe4f$export$5e435bc8b081a399.LARGE && $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$labelLargeStyles,
            type === $24c02ea0e14dbe4f$export$138e17770a0a93a6.DISABLED && $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$variants.label.DISABLED,
            isBold && (0, $74Zh5.css)({
                fontWeight: 700
            }),
            !isBold && (0, $74Zh5.css)({
                fontWeight: 400
            })
        ],
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("input", {
                ref: checkboxRef,
                tabIndex: -1,
                type: "checkbox",
                checked: isChecked,
                onChange: handleChange,
                css: $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$inputCheckboxStyles
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e61786c4aee8d415, {
                children: label
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                tabIndex: tabIndex,
                onKeyDown: handleKeyDown,
                css: [
                    $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$variants.checkbox[type],
                    $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$checkmarkStyles,
                    size === $24c02ea0e14dbe4f$export$5e435bc8b081a399.LARGE && $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$checkmarkLargeStyles,
                    isIndeterminate && !userHasInteracted && $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$indeterminateCheckmarkStyles,
                    isChecked && $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$checkedCheckmarkStyles,
                    isChecked && type === $24c02ea0e14dbe4f$export$138e17770a0a93a6.DANGER && (0, $74Zh5.css)({
                        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.danger")
                    })
                ]
            }),
            isRequired && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$requiredMarkStyles,
                    size === $24c02ea0e14dbe4f$export$5e435bc8b081a399.LARGE && (0, $74Zh5.css)({
                        marginLeft: "2px"
                    })
                ],
                children: "*"
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$requiredMarkStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle"),
    marginLeft: "6px"
});
const $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$labelStyles = (0, $74Zh5.css)({
    display: "flex",
    position: "relative",
    paddingLeft: "22px",
    marginBottom: 0,
    userSelect: "none",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    lineHeight: "22px",
    "&:hover": {
        cursor: "pointer"
    }
});
const $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$labelLargeStyles = (0, $74Zh5.css)({
    paddingLeft: "28px",
    fontSize: "20px",
    lineHeight: "32px"
});
const $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$inputCheckboxStyles = (0, $74Zh5.css)({
    position: "absolute",
    opacity: 0,
    cursor: "pointer",
    height: 0,
    width: 0
});
const $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$checkmarkStyles = (0, $74Zh5.css)({
    position: "absolute",
    top: 0,
    left: 0,
    width: "16px",
    height: "16px",
    marginTop: "3px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.input")}`,
    borderRadius: "2px",
    cursor: "pointer",
    "&:after": {
        content: '""',
        position: "absolute",
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$checkedCheckmarkStyles = (0, $74Zh5.css)({
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected.bold"),
    borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected"),
    "&:after": {
        display: "block",
        left: "4px",
        top: "1px",
        width: "4px",
        height: "7px",
        border: `solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse")}`,
        borderWidth: "0 2px 2px 0",
        transform: "rotate(45deg)"
    }
});
const $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$checkmarkLargeStyles = (0, $74Zh5.css)({
    width: "20px",
    height: "20px",
    marginRight: "8px",
    marginTop: "6px",
    "&:after": {
        left: "5px !important",
        top: "1px",
        width: "6px !important",
        height: "10px !important",
        border: `solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse")}`,
        borderWidth: "0 2px 2px 0",
        transform: "rotate(45deg)"
    }
});
const $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$indeterminateCheckmarkStyles = (0, $74Zh5.css)({
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected.bold"),
    borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected"),
    "&:after": {
        display: "block",
        left: "2.5px",
        top: "-1px",
        width: "9px",
        height: "7px",
        borderBottom: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse")}`
    }
});
const $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$variants = {
    label: {
        DISABLED: (0, $74Zh5.css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    },
    checkbox: {
        DEFAULT: (0, $74Zh5.css)({
            "&:hover": {
                borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")
            }
        }),
        SUCCESS: (0, $74Zh5.css)({
            "&, &:hover": {
                borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")
            }
        }),
        DANGER: (0, $74Zh5.css)({
            "&, &:hover": {
                borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.danger")
            }
        }),
        DISABLED: (0, $74Zh5.css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    }
};
var $24c02ea0e14dbe4f$var$$c4979bfceee73878$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$c4979bfceee73878$exports, "CommonModal", ()=>$24c02ea0e14dbe4f$export$8577c1390d697bac);
const $24c02ea0e14dbe4f$export$8577c1390d697bac = ({ isOpen: isOpen, toggleModal: toggleModal, modalDescriptionLabel: modalDescription, children: children, styles: styles })=>{
    const closeModal = (0, $5FkrB.useCallback)((e)=>{
        e?.stopPropagation();
        toggleModal(false);
    }, [
        toggleModal
    ]);
    const modalRef = (0, $5FkrB.useRef)(null);
    const focusOnOpen = (0, $5FkrB.useCallback)(()=>{
        if (isOpen) modalRef?.current?.focus();
    }, [
        isOpen
    ]);
    (0, $5FkrB.useEffect)(()=>{
        focusOnOpen();
        const handleEsc = (event)=>{
            if (event.key === "Escape") toggleModal(false);
        };
        document.addEventListener("keyup", handleEsc, false);
        return ()=>{
            document.removeEventListener("keyup", handleEsc, false);
        };
    // focusOnOpen and toggleModal intentionally excluded to avoid re-creating listener
    /* eslint-disable react-hooks/exhaustive-deps */ }, []);
    (0, $5FkrB.useEffect)(()=>{
        focusOnOpen();
    }, [
        isOpen
    ]);
    if (!isOpen) return null;
    return isOpen && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$c4979bfceee73878$var$backdropStyles,
            styles && styles
        ],
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            "aria-modal": true,
            role: "dialog",
            ref: modalRef,
            "aria-label": modalDescription,
            tabIndex: -1,
            css: $24c02ea0e14dbe4f$var$$c4979bfceee73878$var$modalStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                    type: "button",
                    css: $24c02ea0e14dbe4f$var$$c4979bfceee73878$var$closeButtonStyles,
                    onClick: closeModal,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($fec45b36b8fde091$exports))), {
                        label: "Close Modal",
                        size: "medium",
                        primaryColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                    })
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$c4979bfceee73878$var$modalSlotStyles,
                    children: children
                })
            ]
        })
    });
};
const $24c02ea0e14dbe4f$var$$c4979bfceee73878$var$backdropStyles = (0, $74Zh5.css)({
    "&, *": {
        boxSizing: "border-box"
    },
    backgroundColor: "gray",
    position: "fixed",
    padding: "16px",
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    left: 0,
    top: 0,
    zIndex: 100000000
});
const $24c02ea0e14dbe4f$var$$c4979bfceee73878$var$modalStyles = (0, $74Zh5.css)({
    position: "relative",
    padding: "16px",
    paddingTop: "48px",
    maxWidth: "100%",
    maxHeight: "100%",
    borderRadius: "8px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    boxShadow: "0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 1px 1px 0px rgba(9, 30, 66, 0.25)",
    zIndex: 200000000
});
const $24c02ea0e14dbe4f$var$$c4979bfceee73878$var$closeButtonStyles = (0, $74Zh5.css)({
    position: "absolute",
    top: "16px",
    right: "16px",
    border: "none",
    outline: "none",
    background: "transparent",
    padding: 0,
    cursor: "pointer",
    borderRadius: "4px",
    "&:hover": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral.subtle.hovered")
    },
    "&:focus svg": {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.selected")
    },
    "&:active": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral.subtle.pressed")
    },
    "&:disabled": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtle.hovered")
    }
});
const $24c02ea0e14dbe4f$var$$c4979bfceee73878$var$modalSlotStyles = (0, $74Zh5.css)({
    minWidth: "100px",
    minHeight: "25px",
    fontSize: "16px"
});
var $24c02ea0e14dbe4f$var$$0903e93de01b205a$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$0903e93de01b205a$exports, "Divider", ()=>$24c02ea0e14dbe4f$export$2e0a83ec2e27ecbb);
/**
 * Horizontal line acting as divider with custom color and height
 * @param {DividerProps} DividerProps
 * @returns {React.ReactElement} React.ReactElement
 *
 * @example
 * <Divider color={token('color.border')} />
 */ const $24c02ea0e14dbe4f$export$2e0a83ec2e27ecbb = ({ color: color, height: height = 1 })=>{
    const styles = {
        height: height + "px",
        border: `0 solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
        margin: 0,
        backgroundColor: color
    };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("hr", {
        "data-testid": "divider",
        style: styles
    });
};
var $24c02ea0e14dbe4f$var$$a950778dc3003c4a$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a950778dc3003c4a$exports, "Eyebrow", ()=>$24c02ea0e14dbe4f$export$71f050e2efa708bb);
const $24c02ea0e14dbe4f$export$71f050e2efa708bb = ({ fontWeight: fontWeight = "regular", size: size = "small", color: color = (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"), children: children })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("h4", {
        css: [
            $24c02ea0e14dbe4f$var$$a950778dc3003c4a$var$eyebrowSmallStyles,
            size === "medium" && $24c02ea0e14dbe4f$var$$a950778dc3003c4a$var$eyebrowMediumStyles,
            fontWeight === "semibold" && (0, $74Zh5.css)({
                fontWeight: 600
            }),
            color && (0, $74Zh5.css)({
                color: color
            })
        ],
        children: children
    });
};
const $24c02ea0e14dbe4f$var$$a950778dc3003c4a$var$eyebrowSmallStyles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Text", sans-serif',
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    textTransform: "uppercase"
});
const $24c02ea0e14dbe4f$var$$a950778dc3003c4a$var$eyebrowMediumStyles = (0, $74Zh5.css)({
    fontSize: "14px",
    lineHeight: "18px"
});
var $24c02ea0e14dbe4f$var$$582583ec420fce57$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$582583ec420fce57$exports, "Heading", ()=>$24c02ea0e14dbe4f$export$a8a3e93435678ff9);
var $24c02ea0e14dbe4f$var$$fde9406d76ec24a9$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fde9406d76ec24a9$exports, "objectValuesToControls", ()=>$24c02ea0e14dbe4f$export$8a8918d045227e35);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fde9406d76ec24a9$exports, "inspectorProps", ()=>$24c02ea0e14dbe4f$export$1784ac302bd8ebad);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fde9406d76ec24a9$exports, "formatMinutes", ()=>$24c02ea0e14dbe4f$export$30c35cbf580cab77);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fde9406d76ec24a9$exports, "getRedirectUrl", ()=>$24c02ea0e14dbe4f$export$93832c3affb240d3);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fde9406d76ec24a9$exports, "calculateLearningProgress", ()=>$24c02ea0e14dbe4f$export$6e67b290ed5690f6);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fde9406d76ec24a9$exports, "SEARCHBAR_HISTORY_STORAGE_KEY", ()=>$24c02ea0e14dbe4f$export$1059c3e9f228d9b);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fde9406d76ec24a9$exports, "getLocalStorageHistory", ()=>$24c02ea0e14dbe4f$export$7765f5b61937bda1);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fde9406d76ec24a9$exports, "setLocalStorageItems", ()=>$24c02ea0e14dbe4f$export$cec0922aa1b64670);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fde9406d76ec24a9$exports, "generateHashFromLabel", ()=>$24c02ea0e14dbe4f$export$1bdcd43c8c2377cf);
const $24c02ea0e14dbe4f$var$$3dba2111a1a6d39b$var$buildAuthQueryParams = ({ email: email, redirectUrl: redirectUrl, prompt: prompt = "none", experience: experience = "entry-auth" })=>{
    const queryParams = [];
    if (email) queryParams.push(`login_hint=${email}`);
    if (experience) queryParams.push(`application=community--${experience}`);
    if (redirectUrl) queryParams.push(`referer=${redirectUrl}`);
    if (prompt) queryParams.push(`prompt=${prompt}`);
    return queryParams;
};
const $24c02ea0e14dbe4f$var$$3dba2111a1a6d39b$export$1db7da00354b15ed = (queryParamValues)=>{
    const queryParams = $24c02ea0e14dbe4f$var$$3dba2111a1a6d39b$var$buildAuthQueryParams(queryParamValues);
    return `/forums/s/plugins/common/feature/oauth2sso_v2/sso_login_redirect?${queryParams.join("&")}`;
};
let $24c02ea0e14dbe4f$export$7dc6752a22ab011a;
(function(Environment) {
    Environment["LOCAL"] = "local";
    Environment["DEVELOPMENT"] = "development";
    Environment["STAGING"] = "staging";
    Environment["PRODUCTION"] = "production";
})($24c02ea0e14dbe4f$export$7dc6752a22ab011a || ($24c02ea0e14dbe4f$export$7dc6752a22ab011a = {}));
const $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$1b5aa7388a6c5e6f = {
    [$24c02ea0e14dbe4f$export$7dc6752a22ab011a.LOCAL]: {
        loggedIn: "https://id.stg.internal.atlassian.com",
        loggedOut: "https://id.stg.internal.atlassian.com"
    },
    [$24c02ea0e14dbe4f$export$7dc6752a22ab011a.DEVELOPMENT]: {
        loggedIn: "https://id.stg.internal.atlassian.com",
        loggedOut: "https://id.stg.internal.atlassian.com"
    },
    [$24c02ea0e14dbe4f$export$7dc6752a22ab011a.STAGING]: {
        loggedIn: "https://id.stg.internal.atlassian.com",
        loggedOut: "https://id.stg.internal.atlassian.com"
    },
    [$24c02ea0e14dbe4f$export$7dc6752a22ab011a.PRODUCTION]: {
        loggedIn: "https://id.atlassian.com",
        loggedOut: "https://id.atlassian.com"
    }
};
const $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$d349399b473d7299 = {
    loggedIn: "/",
    loggedOut: "/"
};
let $24c02ea0e14dbe4f$export$93d048dc21eb282a;
(function(CommunityApp) {
    CommunityApp["HOME"] = "home";
    CommunityApp["LEARNING"] = "learning";
    CommunityApp["FORUMS"] = "forums";
    CommunityApp["EVENTS"] = "events";
    CommunityApp["PROFILE"] = "unified-portable-profile";
    CommunityApp["CHAMPIONS"] = "champions";
    CommunityApp["APP_UPDATES"] = "release-notes";
})($24c02ea0e14dbe4f$export$93d048dc21eb282a || ($24c02ea0e14dbe4f$export$93d048dc21eb282a = {}));
const $24c02ea0e14dbe4f$export$67e61a6fa639f224 = (email)=>[
        {
            app: $24c02ea0e14dbe4f$export$93d048dc21eb282a.FORUMS,
            label: "Forums",
            target: "_self",
            href: {
                loggedIn: $24c02ea0e14dbe4f$var$$3dba2111a1a6d39b$export$1db7da00354b15ed({
                    email: email,
                    redirectUrl: "/forums"
                }),
                loggedOut: "/forums"
            }
        },
        {
            app: $24c02ea0e14dbe4f$export$93d048dc21eb282a.LEARNING,
            label: "Learning",
            href: {
                loggedIn: "/learning",
                loggedOut: "/learning"
            }
        },
        {
            app: $24c02ea0e14dbe4f$export$93d048dc21eb282a.EVENTS,
            label: "Events",
            target: "_self",
            href: {
                loggedIn: "/events",
                loggedOut: "/events"
            }
        },
        {
            app: $24c02ea0e14dbe4f$export$93d048dc21eb282a.CHAMPIONS,
            label: "Champions",
            target: "_self",
            href: {
                loggedIn: "/champions",
                loggedOut: "/champions"
            }
        },
        {
            app: $24c02ea0e14dbe4f$export$93d048dc21eb282a.APP_UPDATES,
            label: "Release Notes",
            target: "_self",
            href: {
                loggedIn: "/release-notes",
                loggedOut: "/release-notes"
            }
        }
    ];
const $24c02ea0e14dbe4f$export$208c68d48dfc9a12 = $24c02ea0e14dbe4f$export$67e61a6fa639f224();
const $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$fe0105b4860d6e11 = {
    [$24c02ea0e14dbe4f$export$93d048dc21eb282a.FORUMS]: "/forums",
    [$24c02ea0e14dbe4f$export$93d048dc21eb282a.LEARNING]: "/learning",
    [$24c02ea0e14dbe4f$export$93d048dc21eb282a.EVENTS]: "/events",
    [$24c02ea0e14dbe4f$export$93d048dc21eb282a.PROFILE]: "/user",
    [$24c02ea0e14dbe4f$export$93d048dc21eb282a.CHAMPIONS]: "/champions",
    [$24c02ea0e14dbe4f$export$93d048dc21eb282a.APP_UPDATES]: "/release-notes"
};
const $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$132b2bf91782e62b = "/user";
const $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$b9cc8022ec117e91 = "/user/settings";
const $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$46dbfbdf99745111 = "Log in";
const $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$4fe37309c24221ae = "Sign up";
const $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$668d072b293d5f38 = {
    PROFILE: {
        text: "Profile",
        id: "profile"
    },
    SETTINGS: {
        text: "Settings",
        id: "settings"
    },
    SWITCH_ACCOUNT: {
        text: "Switch accounts",
        id: "switch-account"
    },
    LOG_OUT: {
        text: "Log out",
        id: "logout"
    }
};
let $24c02ea0e14dbe4f$export$3d7865934588d77e;
(function(EventType) {
    EventType["TRACK"] = "track";
    EventType["UI"] = "ui";
    EventType["OPERATIONAL"] = "operational";
    EventType["SCREEN"] = "screen";
    EventType["IDENTIFY"] = "identify";
})($24c02ea0e14dbe4f$export$3d7865934588d77e || ($24c02ea0e14dbe4f$export$3d7865934588d77e = {}));
let $24c02ea0e14dbe4f$export$d778a884eb401313;
(function(AnalyticsActivityType) {
    AnalyticsActivityType["NAV_LOGO_CLICK"] = "NAV_LOGO_CLICK";
    AnalyticsActivityType["NAV_ITEM_CLICK"] = "NAV_ITEM_CLICK";
    AnalyticsActivityType["LOG_IN_CLICK"] = "LOG_IN_CLICK";
    AnalyticsActivityType["SIGN_UP_CLICK"] = "SIGN_UP_CLICK";
    AnalyticsActivityType["LOG_OUT_CLICK"] = "LOG_OUT_CLICK";
    AnalyticsActivityType["PROFILE_MENU_OPEN"] = "PROFILE_MENU_OPEN";
    AnalyticsActivityType["PROFILE_MENU_CLOSE"] = "PROFILE_MENU_CLOSE";
    AnalyticsActivityType["PROFILE_MENU_ITEM_CLICK"] = "PROFILE_MENU_ITEM_CLICK";
    AnalyticsActivityType["MOBILE_MENU_OPEN"] = "MOBILE_MENU_OPEN";
    AnalyticsActivityType["MOBILE_MENU_CLOSE"] = "MOBILE_MENU_CLOSE";
})($24c02ea0e14dbe4f$export$d778a884eb401313 || ($24c02ea0e14dbe4f$export$d778a884eb401313 = {}));
const $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$bc6e44c7f1ae99f6 = "https://www.atlassian.com/legal/community-platform-terms-of-use";
const $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$30786e8ac20c09d8 = "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers";
const $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$6aafbda8e90312f0 = "#";
const $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$10bc455dcefd3f1f = "https://www.atlassian.com/trust/data-protection";
var $24c02ea0e14dbe4f$var$$ff456f198febe2ae$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$ff456f198febe2ae$exports, "formatUserTimestamp", ()=>$24c02ea0e14dbe4f$export$a547c17dcfa0a6bc);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$ff456f198febe2ae$exports, "formatRelativeTimestamp", ()=>$24c02ea0e14dbe4f$export$880acc1b13aaa28b);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$ff456f198febe2ae$exports, "formatFullDateTime", ()=>$24c02ea0e14dbe4f$export$a31e25c49c78e203);
const $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$getOrdinalSuffix = (day)=>{
    if (day >= 11 && day <= 13) return "th";
    switch(day % 10){
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
        default:
            return "th";
    }
};
const $24c02ea0e14dbe4f$export$a547c17dcfa0a6bc = (value, { locale: locale, timeZone: timeZone } = {})=>{
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    const resolvedLocale = locale || (typeof navigator !== "undefined" ? navigator.language : "en-US");
    const resolvedTimeZone = timeZone || (typeof Intl !== "undefined" ? Intl.DateTimeFormat().resolvedOptions().timeZone : "UTC");
    const parts = new Intl.DateTimeFormat(resolvedLocale, {
        timeZone: resolvedTimeZone,
        year: "numeric",
        month: "long",
        day: "numeric"
    }).formatToParts(date);
    const month = parts.find((p)=>p.type === "month")?.value;
    const dayString = parts.find((p)=>p.type === "day")?.value;
    const year = parts.find((p)=>p.type === "year")?.value;
    if (!month || !dayString || !year) return "";
    const day = Number(dayString);
    if (Number.isNaN(day)) return "";
    return `${month} ${day}${$24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$getOrdinalSuffix(day)}, ${year}`;
};
const $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$SECONDS_IN_MINUTE = 60;
const $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$SECONDS_IN_HOUR = 3600;
const $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$getUserTimeZone = ()=>{
    try {
        if (typeof Intl !== "undefined") return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch  {
        return "UTC";
    }
    return "UTC";
};
const $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$generateDateString = (d)=>{
    return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}-${String(d.getUTCDate()).padStart(2, "0")}`;
};
const $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$getCalendarDate = (ms, timeZone)=>{
    const d = new Date(ms);
    try {
        const parts = new Intl.DateTimeFormat("en-CA", {
            timeZone: timeZone,
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        }).formatToParts(new Date(ms));
        const year = parts.find((p)=>p.type === "year")?.value;
        const month = parts.find((p)=>p.type === "month")?.value;
        const day = parts.find((p)=>p.type === "day")?.value;
        if (year && month && day) return `${year}-${month}-${day}`;
    } catch  {
        return $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$generateDateString(d);
    }
    return $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$generateDateString(d);
};
const $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$getCalendarDaysDiff = (nowMs, thenMs, timeZone)=>{
    const nowDate = $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$getCalendarDate(nowMs, timeZone);
    const thenDate = $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$getCalendarDate(thenMs, timeZone);
    const nowEpochDay = Math.floor(new Date(nowDate).getTime() / 86400000);
    const thenEpochDay = Math.floor(new Date(thenDate).getTime() / 86400000);
    return nowEpochDay - thenEpochDay;
};
const $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$formatTruncatedDate = (date, timeZone)=>{
    try {
        return new Intl.DateTimeFormat("en-US", {
            timeZone: timeZone,
            month: "short",
            day: "numeric"
        }).format(date);
    } catch  {
        const months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ];
        return `${months[date.getMonth()]} ${date.getDate()}`;
    }
};
const $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$formatTime = (date, timeZone)=>{
    try {
        return new Intl.DateTimeFormat("en-US", {
            timeZone: timeZone,
            hour: "numeric",
            minute: "2-digit",
            hour12: true
        }).format(date).toLowerCase().replace("am", "a.m.").replace("pm", "p.m.");
    } catch  {
        const hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const period = hours >= 12 ? "p.m." : "a.m.";
        const displayHour = hours % 12 || 12;
        return `${displayHour}:${minutes} ${period}`;
    }
};
const $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$getFullLabel = (date, timeZone, diff)=>{
    if (diff.seconds < 0) return $24c02ea0e14dbe4f$export$a547c17dcfa0a6bc(date, {
        timeZone: timeZone
    });
    if (diff.seconds < $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$SECONDS_IN_MINUTE) return "Just now";
    if (diff.minutes < 60) return diff.minutes === 1 ? "A minute ago" : `${diff.minutes} minutes ago`;
    if (diff.calendarDays === 1) return "Yesterday";
    if (diff.calendarDays === 0 && diff.hours < 24) return diff.hours === 1 ? "1 hour ago" : `${diff.hours} hours ago`;
    if (diff.calendarDays > 1 && diff.calendarDays < 7) return `${diff.calendarDays} days ago`;
    if (diff.calendarDays === 7) return "1 week ago";
    return $24c02ea0e14dbe4f$export$a547c17dcfa0a6bc(date, {
        timeZone: timeZone
    });
};
const $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$getTruncatedLabel = (date, timeZone, diff)=>{
    if (diff.seconds < 0) return $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$formatTruncatedDate(date, timeZone);
    if (diff.seconds < $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$SECONDS_IN_MINUTE) return "now";
    if (diff.minutes < 60) return `${diff.minutes}m`;
    if (diff.calendarDays === 1) return "1d";
    if (diff.calendarDays === 0 && diff.hours < 24) return `${diff.hours}h`;
    return $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$formatTruncatedDate(date, timeZone);
};
const $24c02ea0e14dbe4f$export$880acc1b13aaa28b = (value, format = "full")=>{
    try {
        const date = value instanceof Date ? value : new Date(value);
        if (Number.isNaN(date.getTime())) return "";
        const timeZone = $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$getUserTimeZone();
        const nowMs = Date.now();
        const seconds = Math.floor((nowMs - date.getTime()) / 1000);
        const diff = {
            seconds: seconds,
            minutes: Math.floor(seconds / $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$SECONDS_IN_MINUTE),
            hours: Math.floor(seconds / $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$SECONDS_IN_HOUR),
            calendarDays: $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$getCalendarDaysDiff(nowMs, date.getTime(), timeZone)
        };
        return format === "truncated" ? $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$getTruncatedLabel(date, timeZone, diff) : $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$getFullLabel(date, timeZone, diff);
    } catch  {
        return "";
    }
};
const $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$getTimeZoneAbbreviation = (date, timeZone)=>{
    try {
        const shortParts = new Intl.DateTimeFormat("en-US", {
            timeZone: timeZone,
            timeZoneName: "short"
        }).formatToParts(date);
        const shortResult = shortParts.find((p)=>p.type === "timeZoneName")?.value ?? "";
        if (shortResult && !shortResult.startsWith("GMT+") && !shortResult.startsWith("GMT-")) return shortResult;
        const longParts = new Intl.DateTimeFormat("en-US", {
            timeZone: timeZone,
            timeZoneName: "long"
        }).formatToParts(date);
        const longName = longParts.find((p)=>p.type === "timeZoneName")?.value ?? "";
        if (longName) return longName.split(" ").map((word)=>word.charAt(0).toUpperCase()).join("");
        return shortResult || timeZone;
    } catch  {
        return timeZone;
    }
};
const $24c02ea0e14dbe4f$export$a31e25c49c78e203 = (value)=>{
    try {
        const date = value instanceof Date ? value : new Date(value);
        if (Number.isNaN(date.getTime())) return "";
        const timeZone = $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$getUserTimeZone();
        const dateString = $24c02ea0e14dbe4f$export$a547c17dcfa0a6bc(date, {
            timeZone: timeZone
        });
        const timeString = $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$formatTime(date, timeZone);
        const tzAbbr = $24c02ea0e14dbe4f$var$$ff456f198febe2ae$var$getTimeZoneAbbreviation(date, timeZone);
        return `${dateString} at ${timeString} ${tzAbbr}`;
    } catch  {
        const date = value instanceof Date ? value : new Date(value);
        if (Number.isNaN(date.getTime())) return "";
        return date.toLocaleString();
    }
};
const $24c02ea0e14dbe4f$export$8a8918d045227e35 = (obj, control = "select")=>({
        control: control,
        options: Object.values(obj)
    });
const $24c02ea0e14dbe4f$export$1784ac302bd8ebad = (key, inspectMode)=>{
    if (inspectMode && inspectMode[key]) {
        const { entryId: entryId, fieldId: fieldId } = inspectMode[key];
        return {
            "data-contentful-entry-id": entryId,
            "data-contentful-field-id": fieldId
        };
    }
};
const $24c02ea0e14dbe4f$export$30c35cbf580cab77 = (minutes)=>{
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    let output = "";
    if (hours > 0) {
        output += `${hours} hour`;
        if (hours > 1) output += "s";
    }
    if (remainingMinutes > 0) {
        if (hours > 0) output += " and ";
        output += `${remainingMinutes} minute`;
        if (remainingMinutes > 1) output += "s";
    }
    return output;
};
const $24c02ea0e14dbe4f$export$93832c3affb240d3 = (url, environment)=>{
    const idUrl = $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$1b5aa7388a6c5e6f[environment] || $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$1b5aa7388a6c5e6f[$24c02ea0e14dbe4f$export$7dc6752a22ab011a.STAGING];
    return `${idUrl}/login?continue=${encodeURIComponent(url)}`;
};
const $24c02ea0e14dbe4f$export$6e67b290ed5690f6 = (completed, total)=>{
    if (total === 0) return 0;
    return completed / total * 100;
};
const $24c02ea0e14dbe4f$export$1059c3e9f228d9b = "searchbar_history";
const $24c02ea0e14dbe4f$export$7765f5b61937bda1 = ()=>{
    if (typeof window === "undefined") return [];
    const storedHistory = localStorage.getItem($24c02ea0e14dbe4f$export$1059c3e9f228d9b);
    return storedHistory ? JSON.parse(storedHistory) : [];
};
const $24c02ea0e14dbe4f$export$cec0922aa1b64670 = (items)=>{
    if (typeof window === "undefined") return;
    localStorage.setItem($24c02ea0e14dbe4f$export$1059c3e9f228d9b, JSON.stringify(items));
};
const $24c02ea0e14dbe4f$export$1bdcd43c8c2377cf = (label)=>{
    return `#${label.toLowerCase().replace(/ /g, "-")}`;
};
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$fde9406d76ec24a9$exports, $24c02ea0e14dbe4f$var$$ff456f198febe2ae$exports);
const $24c02ea0e14dbe4f$export$a8a3e93435678ff9 = ({ children: children, level: level, inspectMode: inspectMode, id: id, color: color = (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"), fontWeight: fontWeight })=>{
    const HeadingElement = $24c02ea0e14dbe4f$var$$582583ec420fce57$var$levelToHeadingElementsMap[level];
    const headingStyles = $24c02ea0e14dbe4f$var$$582583ec420fce57$var$levelToHeadingStylesMap[level];
    const additionalProps = inspectMode ? $24c02ea0e14dbe4f$export$1784ac302bd8ebad(Object.keys(inspectMode)[0], inspectMode) : {};
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)(HeadingElement, {
        id: id,
        css: [
            headingStyles,
            fontWeight && (0, $74Zh5.css)({
                fontWeight: fontWeight
            })
        ],
        ...additionalProps,
        style: {
            color: color
        },
        children: children
    });
};
const $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h0Styles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "48px",
    lineHeight: "52px",
    letterSpacing: "-0.144px",
    margin: 0,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "56px",
        lineHeight: "64px",
        letterSpacing: "-0.168px"
    }
});
const $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h1Styles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "2.5rem",
    lineHeight: "3rem",
    margin: 0,
    letterSpacing: "-0.144px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "3rem",
        lineHeight: "3.5rem",
        letterSpacing: "-0.168px"
    }
});
const $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h2Styles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "2rem",
    lineHeight: "2.5rem",
    margin: 0,
    letterSpacing: "-0.096px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "2.5rem",
        lineHeight: "3rem",
        letterSpacing: "-0.12px"
    }
});
const $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h3Styles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "1.5rem",
    lineHeight: "2rem",
    margin: 0,
    letterSpacing: "normal",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "2rem",
        lineHeight: "2.5rem",
        letterSpacing: "normal"
    }
});
const $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h4Styles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 600,
    fontSize: "1.25rem",
    lineHeight: "1.75rem",
    margin: 0,
    letterSpacing: "normal",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "1.5rem",
        lineHeight: "2rem",
        letterSpacing: "normal"
    }
});
const $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h5Styles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 600,
    fontSize: "1rem",
    lineHeight: "1.5rem",
    margin: 0,
    letterSpacing: "normal",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "1.25rem",
        lineHeight: "1.75rem",
        letterSpacing: "normal"
    }
});
const $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h6Styles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 600,
    fontSize: "0.875rem",
    lineHeight: "1.375rem",
    textTransform: "unset",
    margin: 0,
    letterSpacing: "normal",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "1rem",
        lineHeight: "1.5rem",
        letterSpacing: "normal"
    }
});
const $24c02ea0e14dbe4f$var$$582583ec420fce57$var$levelToHeadingElementsMap = {
    0: "h1",
    1: "h1",
    2: "h2",
    3: "h3",
    4: "h4",
    5: "h5",
    6: "h6"
};
const $24c02ea0e14dbe4f$var$$582583ec420fce57$var$levelToHeadingStylesMap = {
    0: $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h0Styles,
    1: $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h1Styles,
    2: $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h2Styles,
    3: $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h3Styles,
    4: $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h4Styles,
    5: $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h5Styles,
    6: $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h6Styles
};
var $24c02ea0e14dbe4f$var$$a02a6f7de308273b$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a02a6f7de308273b$exports, "icons", ()=>$24c02ea0e14dbe4f$export$df03f54e09e486fa);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a02a6f7de308273b$exports, "IconSize", ()=>$24c02ea0e14dbe4f$export$ff775019b5b6e7df);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a02a6f7de308273b$exports, "IconRotation", ()=>$24c02ea0e14dbe4f$export$b3241a99d3e47e02);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a02a6f7de308273b$exports, "Icon", ()=>$24c02ea0e14dbe4f$export$f04a61298a47a40f);
// Core icons use 'color' prop and default to 'currentColor' for CSS inheritance
// Glyph icons use 'primaryColor' prop
const $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$CORE_ICONS = [
    "arrow-up-right",
    "atlassian-intelligence",
    "calendar",
    "compass",
    "download-core",
    "link-external",
    "location-outline",
    "megaphone",
    "people-group",
    "person",
    "project",
    "sidebar-collapse",
    "sidebar-expand",
    "thumb-down",
    "thumb-up",
    "roadmaps-plan",
    "generative-indicator"
];
const $24c02ea0e14dbe4f$export$df03f54e09e486fa = {
    filter: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($fb968510c42de8af$exports))), {
            ...props
        }),
    "chevron-down": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($9486f8503a3e67e2$exports))), {
            ...props
        }),
    "chevron-up": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($30203922e34ab8aa$exports))), {
            ...props
        }),
    "chevron-left": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($385bb13f555ba5b8$exports))), {
            ...props
        }),
    "chevron-right": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($dffd612a245a9817$exports))), {
            ...props
        }),
    "chevron-down-circle": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($e572ec8845a02646$exports))), {
            ...props
        }),
    "arrow-up-circle": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($e48f677aac887358$exports))), {
            ...props
        }),
    "arrow-up": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($9cd1998a3c9cfc99$exports))), {
            ...props
        }),
    "arrow-up-right": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($aBp15))), {
            ...props
        }),
    "check-circle": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d5a84db960eef864$exports))), {
            ...props
        }),
    "check-circle-outline": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($ade8daf0e7d9a0c6$exports))), {
            ...props
        }),
    "arrow-right": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($c98a967905aaff91$exports))), {
            ...props
        }),
    "arrow-left-circle": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($6d9883dd8b1794e3$exports))), {
            ...props
        }),
    "arrow-right-circle": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($7ef4b2cc5f25a288$exports))), {
            ...props
        }),
    "arrow-right-small": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.908 8L12.8283 9.2021L14.5785 11.1497H7.26318C6.84191 11.1497 6.5 11.5304 6.5 11.9994C6.5 12.4685 6.84191 12.8492 7.26318 12.8492H14.5785L12.8283 14.7979L13.908 16L17.5 11.9994L13.908 8Z",
                fill: props.primaryColor ?? "#1868DB"
            })
        }),
    "atlassian-intelligence": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($1595a2df2d5c9f61$exports))), {
            ...props
        }),
    "atlassian-logo": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($207a5ee071608021$exports))), {
            ...props
        }),
    cross: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($fec45b36b8fde091$exports))), {
            ...props
        }),
    "dropdown-cross": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($79f04fcc1fc38f5b$exports))), {
            ...props
        }),
    "menu-icon": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($3388360884a36db4$exports))), {
            ...props
        }),
    "emoji-frequent": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($2bb56a67b3ef2d16$exports))), {
            ...props
        }),
    "star-filled": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($7f3db16b7d369d9b$exports))), {
            ...props
        }),
    star: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($de0848e68fcb9d68$exports))), {
            ...props
        }),
    "bitbucket-builds": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($8e55f27140ce88eb$exports))), {
            ...props
        }),
    "editor-media-wrap-right": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($34e5d1c6c1f4125d$exports))), {
            ...props
        }),
    "editor-table": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($3ac3f969cbb47b8f$exports))), {
            ...props
        }),
    "editor-open": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($3f5daf0b07171f08$exports))), {
            ...props
        }),
    calendar: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($5ec615fd02e164a6$exports))), {
            ...props
        }),
    copy: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($590d7c6a980c3249$exports))), {
            ...props
        }),
    warning: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($fcdbc1d2bc40f8ba$exports))), {
            ...props
        }),
    image: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($a68fb0b0d8dbf79c$exports))), {
            ...props
        }),
    download: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($be4a353bf96cd982$exports))), {
            ...props
        }),
    "download-core": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($exnso))), {
            ...props
        }),
    "zoom-in": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($1fb024143896ae8b$exports))), {
            ...props
        }),
    "zoom-out": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($f84ee0cde97a62c2$exports))), {
            ...props
        }),
    search: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($47b625f21d7ae4a6$exports))), {
            ...props
        }),
    overview: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($c7b70d3a2f678352$exports))), {
            ...props
        }),
    add: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($1a8d9f6b66868ddc$exports))), {
            ...props
        }),
    refresh: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($7f6dfc6f29e99698$exports))), {
            ...props
        }),
    "add-circle": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($98bc205bd71a8c29$exports))), {
            ...props
        }),
    edit: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($8710dfec56d91aa3$exports))), {
            ...props
        }),
    "edit-filled": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d565c3bdf418c732$exports))), {
            ...props
        }),
    error: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($ff31d8fb1771b8a0$exports))), {
            ...props
        }),
    settings: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d93733cd60a2ee2e$exports))), {
            ...props
        }),
    info: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($03d4c1818fb39364$exports))), {
            ...props
        }),
    question: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($4d9bc1cb23b5f81c$exports))), {
            ...props
        }),
    check: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($873ac5cd1764ee99$exports))), {
            ...props
        }),
    "check-circle-filled": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d5a84db960eef864$exports))), {
            ...props
        }),
    "emoji-symbols": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($88999ebaf76df20a$exports))), {
            ...props
        }),
    compass: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($c76c9acbab193ca4$exports))), {
            ...props
        }),
    megaphone: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($742fae155a6bbd32$exports))), {
            ...props
        }),
    location: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($0035a91c863e72cf$exports))), {
            ...props
        }),
    "location-outline": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($ln0Ih))), {
            ...props
        }),
    "chevron-left-large": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($464fbc8de2c8545a$exports))), {
            ...props
        }),
    "chevron-right-large": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($464fbc8de2c8545a$exports))), {
            ...props
        }),
    "hipchat-chevron-up": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($56277a34572e0602$exports))), {
            ...props
        }),
    "hipchat-chevron-down": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($5d26562b02511d06$exports))), {
            ...props
        }),
    export: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($34d04bfb84685d13$exports))), {
            ...props
        }),
    link: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($0be4bc1b8cb1f6f1$exports))), {
            ...props
        }),
    "roadmaps-plan": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($25e8a161b396b80d$exports))), {
            ...props
        }),
    "generative-indicator": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d99a39b11f2828b9$exports))), {
            ...props
        }),
    share: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($eb718c580db4626b$exports))), {
            ...props
        }),
    "sidebar-collapse": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($75ab11f9a6d4b351$exports))), {
            ...props
        }),
    "sidebar-expand": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($e8ed8fa21860117a$exports))), {
            ...props
        }),
    "people-group": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($be2e2d4d6fde7b33$exports))), {
            ...props
        }),
    project: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($2a5cc7bed34af7d5$exports))), {
            ...props
        }),
    "link-external": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d670f5d7c7940d5f$exports))), {
            ...props
        }),
    person: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d0d6b2a53e44f9e1$exports))), {
            ...props
        }),
    "bookmark-narrow": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M16.5745 5.49575C16.5745 5.13673 16.2832 4.84567 15.9242 4.84554H8.07595C7.71685 4.84554 7.42574 5.13665 7.42574 5.49575V18.2473L12.0001 15.0318L12.5601 15.4268L16.5745 18.2473V5.49575ZM18.5251 20.0633C18.5248 20.8281 17.717 21.2956 17.0659 20.965L16.9377 20.8875L11.9988 17.4155L7.06253 20.8875C6.39483 21.3569 5.47538 20.8794 5.4751 20.0633V5.49575C5.4751 4.05934 6.63954 2.8949 8.07595 2.8949H15.9242C17.3605 2.89503 18.5251 4.05942 18.5251 5.49575V20.0633Z",
                fill: props.primaryColor ?? "white"
            })
        }),
    "bookmark-narrow-filled": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M18.525 20.0632C18.5247 20.828 17.7168 21.2955 17.0658 20.9649L16.9375 20.8874L11.9987 17.4154L7.06241 20.8874C6.39471 21.3568 5.47525 20.8792 5.47498 20.0632V5.49563C5.47498 4.05922 6.63942 2.89478 8.07583 2.89478H15.9241C17.3604 2.8949 18.525 4.0593 18.525 5.49563V20.0632Z",
                fill: props.primaryColor ?? "white"
            })
        }),
    bookmark: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            "aria-label": "bookmark",
            "data-testid": "bookmark",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("g", {
                id: "Icons/bookmark_24px",
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                    id: "bookmark",
                    d: "M12 18L7.8 19.8C7.13333 20.0833 6.5 20.0292 5.9 19.6375C5.3 19.2458 5 18.6917 5 17.975V5C5 4.45 5.19583 3.97917 5.5875 3.5875C5.97917 3.19583 6.45 3 7 3H17C17.55 3 18.0208 3.19583 18.4125 3.5875C18.8042 3.97917 19 4.45 19 5V17.975C19 18.6917 18.7 19.2458 18.1 19.6375C17.5 20.0292 16.8667 20.0833 16.2 19.8L12 18Z",
                    fill: "transparent",
                    stroke: "#626F86",
                    strokeWidth: "2"
                })
            })
        }),
    "bookmark-filled": ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            "aria-label": "bookmark filled",
            "data-testid": "bookmark-filled",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("g", {
                id: "Icons/bookmark_24px",
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                    id: "bookmark",
                    d: "M12 18L7.8 19.8C7.13333 20.0833 6.5 20.0292 5.9 19.6375C5.3 19.2458 5 18.6917 5 17.975V5C5 4.45 5.19583 3.97917 5.5875 3.5875C5.97917 3.19583 6.45 3 7 3H17C17.55 3 18.0208 3.19583 18.4125 3.5875C18.8042 3.97917 19 4.45 19 5V17.975C19 18.6917 18.7 19.2458 18.1 19.6375C17.5 20.0292 16.8667 20.0833 16.2 19.8L12 18Z",
                    fill: "#626F86",
                    stroke: "#626F86",
                    strokeWidth: "2"
                })
            })
        }),
    "gap-completed": ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            "data-testid": "gap-completed",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("g", {
                id: "Icon / <CheckCircleIcon>",
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                    id: "gap",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM9.3824 11.0689C9.50441 11.1213 9.61475 11.1975 9.707 11.293L11 12.586L14.293 9.29302C14.3852 9.19751 14.4956 9.12133 14.6176 9.06892C14.7396 9.01651 14.8708 8.98892 15.0036 8.98777C15.1364 8.98662 15.2681 9.01192 15.391 9.0622C15.5138 9.11248 15.6255 9.18673 15.7194 9.28063C15.8133 9.37452 15.8875 9.48617 15.9378 9.60907C15.9881 9.73196 16.0134 9.86364 16.0122 9.99642C16.0111 10.1292 15.9835 10.2604 15.9311 10.3824C15.8787 10.5044 15.8025 10.6148 15.707 10.707L11.707 14.707C11.5195 14.8945 11.2652 14.9998 11 14.9998C10.7348 14.9998 10.4805 14.8945 10.293 14.707L8.293 12.707C8.19749 12.6148 8.1213 12.5044 8.0689 12.3824C8.01649 12.2604 7.9889 12.1292 7.98775 11.9964C7.98659 11.8636 8.0119 11.732 8.06218 11.6091C8.11246 11.4862 8.18671 11.3745 8.2806 11.2806C8.3745 11.1867 8.48615 11.1125 8.60904 11.0622C8.73194 11.0119 8.86362 10.9866 8.9964 10.9878C9.12918 10.9889 9.2604 11.0165 9.3824 11.0689Z",
                    fill: "#22A06B"
                })
            })
        }),
    "thumb-down": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($9bde3da3ddd3925b$exports))), {
            ...props
        }),
    "thumb-up": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d613dcd7cfbb1e58$exports))), {
            ...props
        }),
    "dot-default": ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "8",
            height: "8",
            viewBox: "0 0 8 8",
            fill: "none",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("rect", {
                x: "0.5",
                y: "0.5",
                width: "7",
                height: "7",
                rx: "3.5",
                stroke: "#091E42",
                strokeOpacity: "0.14"
            })
        }),
    "dot-selected": ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "8",
            height: "8",
            viewBox: "0 0 8 8",
            fill: "none",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("rect", {
                x: "0.5",
                y: "0.5",
                width: "7",
                height: "7",
                rx: "3.5",
                stroke: "#0C66E4"
            })
        }),
    "dot-completed": ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "8",
            height: "8",
            viewBox: "0 0 8 8",
            fill: "none",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("rect", {
                width: "8",
                height: "8",
                rx: "4",
                fill: "#22A06B"
            })
        }),
    "mosaic_map-pin": (props)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15.8088 12.9426L19.8045 18.7363L23.8003 12.9426C23.8715 12.8394 23.938 12.735 24 12.6296C25.8712 9.44592 23.5904 5.33325 19.8045 5.33325C15.8931 5.33325 13.5882 9.72274 15.8088 12.9426ZM19.9234 12.494C21.1444 12.4321 22.1153 11.4225 22.1153 10.1861C22.1153 8.90983 21.0807 7.87521 19.8045 7.87521C18.5909 7.87521 17.5958 8.81071 17.501 9.99992C17.4961 10.0613 17.4938 10.1234 17.4938 10.1861C17.4938 11.4623 18.5284 12.4969 19.8046 12.497M19.8046 12.497C19.8444 12.497 19.8841 12.496 19.9234 12.494L19.8046 12.497Z",
                    fill: props.primaryColor ?? "#172b4d"
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                    d: "M21.3333 22.6666V20.0426L24 16.1759V25.3333H8V9.99992H12.9424C12.9149 10.8857 13.0615 11.7906 13.4072 12.6666H10.6667V22.6666H21.3333Z",
                    fill: props.primaryColor ?? "#172b4d"
                })
            ]
        }),
    mosaic_compass: (props)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("mask", {
                    id: "mask0_64467_13333",
                    style: {
                        maskType: "luminance"
                    },
                    maskUnits: "userSpaceOnUse",
                    x: "0",
                    y: "0",
                    width: "32",
                    height: "32",
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M32 0H0V32H32V0Z",
                        fill: "white"
                    })
                }),
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                    mask: "url(#mask0_64467_13333)",
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                            d: "M14.6665 16.0001C14.6665 15.2667 15.2665 14.6667 15.9998 14.6667C16.7332 14.6667 17.3332 15.2667 17.3332 16.0001C17.3332 16.7334 16.7332 17.3334 15.9998 17.3334C15.2665 17.3334 14.6665 16.7334 14.6665 16.0001Z",
                            fill: props.primaryColor || "#172b4d"
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M16.0002 26.6666C21.8935 26.6666 26.6668 21.8933 26.6668 15.9999C26.6668 10.1066 21.8935 5.33325 16.0002 5.33325C10.1068 5.33325 5.3335 10.1066 5.3335 15.9999C5.3335 21.8933 10.1068 26.6666 16.0002 26.6666ZM21.3335 10.6666L13.3335 13.3333L10.6668 21.3333L18.6668 18.6666L21.3335 10.6666Z",
                            fill: props.primaryColor || "#172b4d"
                        })
                    ]
                })
            ]
        }),
    mosaic_megaphone: (props)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("mask", {
                    id: "mask0_64493_847",
                    style: {
                        maskType: "luminance"
                    },
                    maskUnits: "userSpaceOnUse",
                    x: "0",
                    y: "0",
                    width: "32",
                    height: "32",
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M32 0H0V32H32V0Z",
                        fill: "white"
                    })
                }),
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                    mask: "url(#mask0_64493_847)",
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                            d: "M26 5.33325L16 9.33325V19.9999L26 23.9999V5.33325Z",
                            fill: props.primaryColor || "#172b4d"
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                            d: "M13.3335 10H5.3335V19.3333H9.3335V25.3333H13.3335V10Z",
                            fill: props.primaryColor || "#172b4d"
                        })
                    ]
                })
            ]
        }),
    "more-vertical": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($89ede3cf48e6c473$exports))), {
            ...props
        }),
    "editor-panel": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($533ab672e6b1443b$exports))), {
            ...props
        }),
    one: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "one",
            children: "1"
        }),
    two: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "two",
            children: "2"
        }),
    three: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "three",
            children: "3"
        }),
    four: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "four",
            children: "4"
        }),
    five: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "five",
            children: "5"
        }),
    six: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "six",
            children: "6"
        }),
    seven: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "seven",
            children: "7"
        }),
    eight: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "eight",
            children: "8"
        }),
    nine: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "nine",
            children: "9"
        }),
    zero: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "zero",
            children: "0"
        })
};
let $24c02ea0e14dbe4f$export$ff775019b5b6e7df;
(function(IconSize) {
    IconSize["SMALL"] = "small";
    IconSize["MEDIUM"] = "medium";
    IconSize["LARGE"] = "large";
    IconSize["XLARGE"] = "xlarge";
})($24c02ea0e14dbe4f$export$ff775019b5b6e7df || ($24c02ea0e14dbe4f$export$ff775019b5b6e7df = {}));
let $24c02ea0e14dbe4f$export$b3241a99d3e47e02;
(function(IconRotation) {
    IconRotation["ZERO"] = "0deg";
    IconRotation["NINETY"] = "90deg";
    IconRotation["ONE_EIGHTY"] = "180deg";
    IconRotation["TWO_SEVENTY"] = "270deg";
})($24c02ea0e14dbe4f$export$b3241a99d3e47e02 || ($24c02ea0e14dbe4f$export$b3241a99d3e47e02 = {}));
const $24c02ea0e14dbe4f$export$f04a61298a47a40f = ({ type: type, size: size = $24c02ea0e14dbe4f$export$ff775019b5b6e7df.MEDIUM, rotation: rotation = $24c02ea0e14dbe4f$export$b3241a99d3e47e02.ZERO, alt: alt = "", color: color, hoverColor: hoverColor, activeColor: activeColor })=>{
    const icon = (0, $5FkrB.useMemo)(()=>$24c02ea0e14dbe4f$export$df03f54e09e486fa[type], [
        type
    ]);
    const isCoreIcon = $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$CORE_ICONS.includes(type);
    // Core icons use 'color' prop and default to 'currentColor' for CSS inheritance
    // Glyph icons use 'primaryColor' prop
    const iconProps = isCoreIcon ? {
        size: size,
        label: alt,
        color: color || "currentColor",
        testId: type
    } : {
        size: size,
        label: alt,
        primaryColor: color || undefined,
        testId: type
    };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
        css: [
            $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$baseStyles,
            $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$rotationStyles[rotation],
            hoverColor && {
                "&:hover": {
                    color: hoverColor
                }
            },
            activeColor && {
                "&:active": {
                    color: activeColor
                }
            }
        ],
        "data-testid": `icon-${type}`,
        children: icon ? icon(iconProps) : null
    });
};
const $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$baseStyles = (0, $74Zh5.css)({
    width: "fit-content",
    height: "fit-content",
    display: "inline-flex"
});
const $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$rotationStyles = {
    "0deg": (0, $74Zh5.css)({
        transform: "rotate(0deg)"
    }),
    "90deg": (0, $74Zh5.css)({
        transform: "rotate(90deg)"
    }),
    "180deg": (0, $74Zh5.css)({
        transform: "rotate(180deg)"
    }),
    "270deg": (0, $74Zh5.css)({
        transform: "rotate(270deg)"
    })
};
const $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$iconNumberStyles = (0, $74Zh5.css)({
    fontSize: "16px"
});
var $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$exports, "Image", ()=>$24c02ea0e14dbe4f$export$3e431a229df88919);
/**
 * It takes a url and returns the last part of the url which is the name of the image.
 * @param {string} url - The URL of the image you want to get the name.
 * @returns name of the image file.
 */ const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$getImageName = (url)=>{
    const urlSplitted = url.split("/");
    return urlSplitted[urlSplitted.length - 1];
};
/**
 * Convert bytes into KB or MB
 * @param {number} [bytes] - The number of bytes to format.
 * @returns a string with the KB o MB converted
 */ const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$formatBytes = (bytes)=>{
    const marker = 1024;
    const decimal = 0;
    const kiloBytes = marker;
    const megaBytes = marker * marker;
    return bytes ? bytes < kiloBytes ? bytes + " Bytes" : bytes < megaBytes ? (bytes / kiloBytes).toFixed(decimal) + " KB" : (bytes / megaBytes).toFixed(decimal) + " MB" : undefined;
};
/**
 * Download image
 * @param {string} src - The URL of the image you want to download.
 * @param {string} name - The name of the file you want to save the image as.
 */ const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$downloadImage = async (src, name)=>{
    const image = await fetch(src);
    const imageBlog = await image.blob();
    const imageURL = URL.createObjectURL(imageBlog);
    const link = document.createElement("a");
    link.href = imageURL;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $24c02ea0e14dbe4f$export$3e431a229df88919 = ({ inspectMode: inspectMode, src: src, alt: alt, width: width, height: height, caption: caption = "", size: size, center: center = true, preventModal: preventModal = false, onClick: onClick, ...props })=>{
    const rightToolsRef = (0, $5FkrB.useRef)(null);
    const downloadButtonRef = (0, $5FkrB.useRef)(null);
    const modalImgRef = (0, $5FkrB.useRef)(null);
    const originalImgRef = (0, $5FkrB.useRef)(null);
    const [showModal, setShowModal] = (0, $5FkrB.useState)(false);
    const [showControls, setShowControls] = (0, $5FkrB.useState)(false);
    const [totalZoom, setTotalZoom] = (0, $5FkrB.useState)(100);
    const [initialWidthModalImage, setInitialWidthModalImage] = (0, $5FkrB.useState)(0);
    const [initialHeightImage, setInitialHeightImage] = (0, $5FkrB.useState)(0);
    const [initialWidthOriginalImage, setInitialWidthOriginalImage] = (0, $5FkrB.useState)(0);
    (0, $5FkrB.useEffect)(()=>{
        if (showModal) {
            setShowControls(true);
            setTotalZoom(100);
            if (rightToolsRef.current) rightToolsRef.current.focus();
        }
    }, [
        showModal
    ]);
    (0, $5FkrB.useEffect)(()=>{
        let timer = null;
        if (showControls) timer = setTimeout(()=>setShowControls(false), 5000);
        return ()=>clearTimeout(timer ?? undefined);
    }, [
        showControls
    ]);
    (0, $5FkrB.useEffect)(()=>{
        const close = (e)=>{
            if (e.key === "Escape") setShowModal(false);
        };
        window.addEventListener("keydown", close);
        return ()=>window.removeEventListener("keydown", close);
    }, []);
    const onHoverModal = ()=>{
        setShowControls(true);
    };
    const onZoomOut = ()=>{
        if (totalZoom > 20) {
            setTotalZoom(totalZoom - 20);
            if (modalImgRef.current) {
                const widthImageModal = Math.round(modalImgRef.current?.offsetWidth - initialWidthModalImage * 0.2);
                const heightImageModal = Math.round(modalImgRef.current?.offsetHeight - initialHeightImage * 0.2);
                modalImgRef.current.style.width = `${widthImageModal}px`;
                modalImgRef.current.style.height = `${heightImageModal}px`;
            }
        }
    };
    const onZoomIn = ()=>{
        if (totalZoom < 320) {
            setTotalZoom(totalZoom + 20);
            if (modalImgRef.current) {
                const widthImageModal = Math.round(modalImgRef.current?.offsetWidth + initialWidthModalImage * 0.2);
                const heightImageModal = Math.round(modalImgRef.current?.offsetHeight + initialHeightImage * 0.2);
                modalImgRef.current.style.width = `${widthImageModal}px`;
                modalImgRef.current.style.height = `${heightImageModal}px`;
            }
        }
    };
    const onBlur = ()=>{
        if (rightToolsRef.current && downloadButtonRef.current) {
            rightToolsRef.current.setAttribute("tabIndex", "-1");
            downloadButtonRef.current.focus();
        }
    };
    const onClickImage = (0, $5FkrB.useCallback)(()=>{
        if (onClick) onClick();
        if (!preventModal) setShowModal(true);
    }, [
        onClick,
        preventModal
    ]);
    const onLoadImageModal = ()=>{
        setInitialWidthModalImage(modalImgRef.current?.offsetWidth ?? 0);
        setInitialHeightImage(modalImgRef.current?.offsetHeight ?? 0);
    };
    (0, $5FkrB.useEffect)(()=>{
        if (originalImgRef.current?.offsetWidth) setInitialWidthOriginalImage(originalImgRef.current.offsetWidth);
    }, [
        originalImgRef.current?.offsetWidth
    ]);
    const handleKeyDown = (0, $5FkrB.useCallback)((e)=>{
        if (e.code === "Space") onClickImage();
    }, [
        onClickImage
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            showModal && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                "data-testid": "modal",
                id: "myModal",
                css: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$modalStyles,
                onMouseMove: onHoverModal,
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$modalContentStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: [
                                $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$modalControlsStyles,
                                showControls && (0, $74Zh5.css)({
                                    opacity: 1
                                }),
                                !showControls && (0, $74Zh5.css)({
                                    opacity: 0
                                })
                            ],
                            children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$containerStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        css: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$textContainerStyles,
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$iconContainerStyles,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                                    type: "image",
                                                    size: "large",
                                                    color: (0, $54ca2d3948378259$export$c6930421db9fa514)
                                                })
                                            }),
                                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                                css: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$imageContainerStyles,
                                                children: [
                                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                                        css: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$badgeContentStyles,
                                                        children: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$getImageName(src)
                                                    }),
                                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
                                                        css: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$badgeContentStyles,
                                                        children: [
                                                            "image \xb7 ",
                                                            $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$formatBytes(size)
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        className: "right",
                                        ref: rightToolsRef,
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                                                "data-testid": "download-button",
                                                ref: downloadButtonRef,
                                                tabIndex: 0,
                                                css: (0, $74Zh5.css)({
                                                    marginRight: "1rem",
                                                    border: "none",
                                                    cursor: "pointer"
                                                }),
                                                "aria-label": "download image",
                                                onClick: ()=>{
                                                    $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$downloadImage(src, $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$getImageName(src));
                                                },
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                                    type: "download",
                                                    size: "medium"
                                                })
                                            }),
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                                                css: {
                                                    border: "none",
                                                    cursor: "pointer"
                                                },
                                                tabIndex: 0,
                                                "data-testid": "close-modal-button",
                                                "aria-label": "close modal",
                                                onClick: ()=>{
                                                    setShowModal(false);
                                                },
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                                    type: "cross",
                                                    size: "medium"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f9ff4343296b19bf$export$2e2bcd8739ae039), {
                            css: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$scrollContainerStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                                src: src,
                                alt: alt,
                                ref: modalImgRef,
                                onLoad: onLoadImageModal,
                                css: (0, $74Zh5.css)({
                                    margin: "auto"
                                })
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: [
                                $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$modalToolsStyles,
                                (0, $74Zh5.css)({
                                    opacity: showControls ? 1 : 0
                                })
                            ],
                            children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$buttonContainerStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                                                "data-testid": "zoom-out-button",
                                                onClick: ()=>onZoomOut(),
                                                css: (0, $74Zh5.css)({
                                                    marginRight: "0.625rem",
                                                    border: "none",
                                                    cursor: "pointer"
                                                }),
                                                "aria-label": "zoom out",
                                                tabIndex: 0,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                                    type: "zoom-out"
                                                })
                                            }),
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                                                css: {
                                                    border: "none",
                                                    cursor: "pointer"
                                                },
                                                "data-testid": "zoom-in-button",
                                                onClick: ()=>onZoomIn(),
                                                onBlur: onBlur,
                                                "aria-label": "zoom in",
                                                tabIndex: 0,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                                    type: "zoom-in"
                                                })
                                            })
                                        ]
                                    }),
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        css: (0, $74Zh5.css)({
                                            color: (0, $54ca2d3948378259$export$5368d76ae4fbbda7)
                                        }),
                                        children: [
                                            totalZoom,
                                            "%"
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("image", inspectMode),
                css: (0, $74Zh5.css)({
                    width: "100%",
                    overflow: "hidden"
                }),
                "data-testid": "image",
                onClick: onClickImage,
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("figure", {
                    css: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$figureStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                            tabIndex: 0,
                            width: width,
                            height: height,
                            ref: originalImgRef,
                            alt: alt,
                            src: src,
                            onKeyDown: handleKeyDown,
                            css: [
                                (0, $74Zh5.css)({
                                    transform: "scale(1)",
                                    objectFit: "contain",
                                    height: "auto"
                                }),
                                center && (0, $74Zh5.css)({
                                    margin: "auto"
                                }),
                                !preventModal && (0, $74Zh5.css)({
                                    cursor: "pointer"
                                }),
                                !width && (0, $74Zh5.css)({
                                    width: "100%"
                                })
                            ],
                            ...props
                        }),
                        !!initialWidthOriginalImage && !!caption && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("figcaption", {
                            style: {
                                width: `${initialWidthOriginalImage}px`,
                                maxWidth: "100vw"
                            },
                            css: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$captionContainerStyles,
                            children: caption
                        })
                    ]
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$modalStyles = (0, $74Zh5.css)({
    position: "fixed",
    zIndex: 100000,
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    overflow: "auto",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    "& button": {
        background: "transparent",
        borderRadius: "3px",
        verticalAlign: "middle",
        display: "inline-flex",
        padding: "0.125rem !important",
        height: "fit-content",
        "&:hover": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.bolder.hovered"),
            borderRadius: "3px"
        }
    }
});
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$modalContentStyles = (0, $74Zh5.css)({
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    padding: 0,
    position: "relative",
    overflow: "hidden",
    "& img": {
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",
        width: "auto",
        height: "auto"
    }
});
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$modalControlsStyles = (0, $74Zh5.css)({
    backgroundImage: "linear-gradient(rgb(14, 22, 36), rgba(14, 22, 36, 0))",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "6.125rem",
    zIndex: 1,
    fontWeight: 500,
    padding: "1.5rem",
    transition: "opacity 0.3s ease 0s",
    "& .right:focus": {
        outline: "none"
    },
    "& .right svg": {
        color: `${(0, $54ca2d3948378259$export$5368d76ae4fbbda7)} !important`
    }
});
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between"
});
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$textContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    color: (0, $54ca2d3948378259$export$5368d76ae4fbbda7)
});
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$iconContainerStyles = (0, $74Zh5.css)({
    marginRight: "0.75rem",
    display: "flex",
    alignItems: "center"
});
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$imageContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    color: "filter",
    fontSize: ".875rem",
    lineHeight: "1.25rem"
});
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$badgeContentStyles = (0, $74Zh5.css)({
    margin: 0
});
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$scrollContainerStyles = (0, $74Zh5.css)({
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    overflow: "auto",
    WebkitOverflowScrolling: "touch"
});
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$modalToolsStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    position: "fixed",
    bottom: 0,
    width: "100%",
    height: "6.125rem",
    padding: "0.625rem",
    backgroundImage: "linear-gradient(rgba(14, 22, 36, 0), rgb(14, 22, 36))",
    "& svg": {
        color: `${(0, $54ca2d3948378259$export$5368d76ae4fbbda7)} !important`
    }
});
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$buttonContainerStyles = (0, $74Zh5.css)({
    width: "50%",
    display: "flex",
    justifyContent: "space-between"
});
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$figureStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    margin: 0,
    textAlign: "center"
});
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$captionContainerStyles = (0, $74Zh5.css)({
    margin: "16px auto",
    textAlign: "center",
    fontStyle: "italic",
    fontSize: ".875rem",
    lineHeight: "1.25rem",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest")
});
var $24c02ea0e14dbe4f$var$$c0c01354ab9765ae$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$c0c01354ab9765ae$exports, "InvertedIconButton", ()=>$24c02ea0e14dbe4f$export$dd09d7da2da4d16f);
const $24c02ea0e14dbe4f$export$dd09d7da2da4d16f = ({ icon: icon, onClick: onClick, ariaLabel: ariaLabel, disabled: disabled = false, selected: selected = false, tooltip: tooltip, testId: testId = "inverted-icon-button" })=>{
    const button = (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
        css: [
            $24c02ea0e14dbe4f$var$$c0c01354ab9765ae$var$baseStyles,
            selected && $24c02ea0e14dbe4f$var$$c0c01354ab9765ae$var$selectedStyles,
            disabled && $24c02ea0e14dbe4f$var$$c0c01354ab9765ae$var$disabledStyles
        ],
        onClick: onClick,
        "aria-label": ariaLabel,
        disabled: disabled,
        "data-testid": testId,
        type: "button",
        children: icon
    });
    return tooltip && !disabled ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $1ee6819d2d8fb6a1$export$2e2bcd8739ae039), {
        content: tooltip,
        testId: `${testId}-tooltip`,
        children: button
    }) : button;
};
const $24c02ea0e14dbe4f$var$$c0c01354ab9765ae$var$baseStyles = (0, $74Zh5.css)({
    background: "transparent",
    border: "none",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    transition: "background-color 0.2s ease",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"),
    width: "32px",
    height: "32px",
    "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.16)"
    },
    "&:active": {
        backgroundColor: "rgba(255, 255, 255, 0.24)"
    },
    "&:focus": {
        outline: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`,
        outlineOffset: "2px"
    },
    // Ensure icon inherits the white color
    "& > span": {
        color: "inherit"
    }
});
const $24c02ea0e14dbe4f$var$$c0c01354ab9765ae$var$selectedStyles = (0, $74Zh5.css)({
    "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.32)"
    },
    "&:active": {
        backgroundColor: "rgba(255, 255, 255, 0.40)"
    }
});
const $24c02ea0e14dbe4f$var$$c0c01354ab9765ae$var$disabledStyles = (0, $74Zh5.css)({
    cursor: "not-allowed",
    opacity: 0.4,
    "&:hover": {
        backgroundColor: "transparent"
    },
    "&:active": {
        backgroundColor: "transparent"
    }
});
var $24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$exports, "LinkStyle", ()=>$24c02ea0e14dbe4f$export$2b77966d73aefa77);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$exports, "LinkSize", ()=>$24c02ea0e14dbe4f$export$be4c932f76c19adf);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$exports, "Link", ()=>$24c02ea0e14dbe4f$export$a6c7ac8248d6e38a);
let $24c02ea0e14dbe4f$export$2b77966d73aefa77;
(function(LinkStyle) {
    LinkStyle["REGULAR"] = "regular";
    LinkStyle["SEMIBOLD"] = "semibold";
})($24c02ea0e14dbe4f$export$2b77966d73aefa77 || ($24c02ea0e14dbe4f$export$2b77966d73aefa77 = {}));
let $24c02ea0e14dbe4f$export$be4c932f76c19adf;
(function(LinkSize) {
    LinkSize["EXTRA_LARGE"] = "extraLarge";
    LinkSize["LARGE"] = "large";
    LinkSize["MEDIUM"] = "medium";
})($24c02ea0e14dbe4f$export$be4c932f76c19adf || ($24c02ea0e14dbe4f$export$be4c932f76c19adf = {}));
const $24c02ea0e14dbe4f$export$a6c7ac8248d6e38a = ({ label: label, fontColor: fontColor = (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.accent.blue"), target: target = "_self", link: link, style: style = $24c02ea0e14dbe4f$export$2b77966d73aefa77.REGULAR, icon: icon, onClick: onClick, size: size = $24c02ea0e14dbe4f$export$be4c932f76c19adf.MEDIUM, ...props })=>{
    const clickHandler = (0, $5FkrB.useCallback)((e)=>{
        e.stopPropagation();
        e.preventDefault();
        if (onClick) onClick(e);
    }, [
        onClick
    ]);
    const onKeyDown = (e)=>(handler)=>{
            if (e.key === "Enter" || e.key === " ") handler(e);
        };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("a", {
        target: target,
        href: link,
        rel: target === "_blank" ? "noopener noreferrer" : "",
        tabIndex: 0,
        css: [
            $24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$var$sizeStyles[size],
            $24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$var$variantStyles[style].base,
            $24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$var$baseStyles,
            $24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$var$variantStyles[style].hover,
            (0, $74Zh5.css)({
                color: fontColor
            })
        ],
        style: {
            wordBreak: "break-word",
            overflowWrap: "break-word"
        },
        onClick: clickHandler,
        /** @ts-expect-error - onKeyDown is not typed correctly */ onKeyDown: (e)=>onKeyDown(e)(clickHandler),
        ...props,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                children: label
            }),
            icon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: $24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$var$iconContainerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: icon,
                    size: "medium"
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$var$baseStyles = (0, $74Zh5.css)({
    display: "inline",
    alignItems: "center",
    justifyContent: "center",
    columnGap: "2px",
    textDecoration: "none",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        fontSize: "16px !important",
        lineHeight: "20px !important"
    }
});
const $24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$var$sizeStyles = {
    medium: {
        fontSize: "16px",
        lineHeight: "24px"
    },
    large: {
        fontSize: "20px",
        lineHeight: "24px"
    },
    extraLarge: {
        fontSize: "24px",
        lineHeight: "32px"
    }
};
const $24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$var$variantStyles = {
    regular: {
        base: (0, $74Zh5.css)({
            fontWeight: "normal"
        }),
        hover: (0, $74Zh5.css)({
            "&:hover": {
                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.link"),
                textDecoration: "underline",
                cursor: "pointer",
                textUnderlineOffset: "4px",
                textDecorationThickness: "2px",
                textDecorationColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.link")
            }
        })
    },
    semibold: {
        base: (0, $74Zh5.css)({
            fontWeight: 600
        }),
        hover: (0, $74Zh5.css)({
            "&:hover": {
                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.link"),
                textDecoration: "underline",
                cursor: "pointer",
                textUnderlineOffset: "4px",
                textDecorationThickness: "2px",
                textDecorationColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.link")
            }
        })
    }
};
const $24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$var$iconContainerStyles = {
    display: "inline",
    verticalAlign: "middle"
};
var $24c02ea0e14dbe4f$var$$800df40a54823a3f$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$800df40a54823a3f$exports, "List", ()=>$24c02ea0e14dbe4f$export$54c2e3dc7acea9f5);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$800df40a54823a3f$exports, "variantsListStyles", ()=>$24c02ea0e14dbe4f$export$6427468642e6e9fe);
const $24c02ea0e14dbe4f$export$54c2e3dc7acea9f5 = ({ type: type = "unordered", textStyleType: textStyleType = "regular", children: children })=>{
    if (type === "ordered") return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ol", {
        "aria-label": "ordered",
        css: [
            $24c02ea0e14dbe4f$var$$800df40a54823a3f$var$listStyles,
            (0, $74Zh5.css)($24c02ea0e14dbe4f$export$6427468642e6e9fe.list[type]),
            $24c02ea0e14dbe4f$export$6427468642e6e9fe.textStyle[textStyleType]
        ],
        children: children
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
        "aria-label": "unordered",
        css: [
            $24c02ea0e14dbe4f$var$$800df40a54823a3f$var$listStyles,
            (0, $74Zh5.css)($24c02ea0e14dbe4f$export$6427468642e6e9fe.list[type]),
            $24c02ea0e14dbe4f$export$6427468642e6e9fe.textStyle[textStyleType]
        ],
        children: children
    });
};
const $24c02ea0e14dbe4f$var$$800df40a54823a3f$var$fontSizeStyles = {
    fontSize: "1.25rem",
    lineHeight: "2rem",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        fontSize: "1rem",
        lineHeight: "1.5rem"
    }
};
const $24c02ea0e14dbe4f$var$$800df40a54823a3f$var$listStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    letterSpacing: "0.3%",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    ...$24c02ea0e14dbe4f$var$$800df40a54823a3f$var$fontSizeStyles,
    span: $24c02ea0e14dbe4f$var$$800df40a54823a3f$var$fontSizeStyles
});
const $24c02ea0e14dbe4f$export$6427468642e6e9fe = {
    list: {
        unordered: {
            listStyleType: "disc",
            paddingLeft: "1.25rem",
            ul: {
                listStyleType: "circle",
                paddingLeft: "1.25rem"
            },
            "ul ul": {
                listStyleType: "square",
                paddingLeft: "1.25rem"
            },
            "ul:not(:first-of-type), ul li, li + li": {
                marginTop: 0
            }
        },
        ordered: {
            listStyleType: "decimal",
            paddingLeft: "1.25rem",
            ol: {
                listStyleType: "lower-alpha",
                paddingLeft: "1.25rem"
            },
            "ol ol": {
                listStyleType: "lower-roman",
                paddingLeft: "1.25rem"
            },
            "ol:not(:first-of-type), ol li, li + li": {
                marginTop: 0
            }
        }
    },
    textStyle: {
        regular: (0, $74Zh5.css)({
            fontWeight: 400
        }),
        italic: (0, $74Zh5.css)({
            fontStyle: "italic"
        }),
        bold: (0, $74Zh5.css)({
            fontWeight: 700
        }),
        boldItalic: (0, $74Zh5.css)({
            fontWeight: 700,
            fontStyle: "italic"
        })
    }
};
var $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$exports, "NavigationBar", ()=>$24c02ea0e14dbe4f$export$214ae410b202e65a);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$exports, "NavBarLinkItem", ()=>$24c02ea0e14dbe4f$export$e76239e22e3abad);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$exports, "NavBarProfileItem", ()=>$24c02ea0e14dbe4f$export$1cba3806e1f1b01d);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$exports, "AtlassianNavLogo", ()=>$24c02ea0e14dbe4f$export$6ce3be5638d8e2a);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$exports, "MenuItem", ()=>$24c02ea0e14dbe4f$export$2ce376c2cc3355c8);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$exports, "NavBarExpandableItem", ()=>$24c02ea0e14dbe4f$export$1229978ae51a03a8);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$exports, "NavbarSlideMenuItem", ()=>$24c02ea0e14dbe4f$export$c7fcbaf97c146aec);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$exports, "NavBarItemWithMenu", ()=>$24c02ea0e14dbe4f$export$2771c1f4a09ce668);
const $24c02ea0e14dbe4f$var$$6a34d18c8d59b475$var$CloseIcon = ()=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M7 7L23.9706 23.9706",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M7 24L23.9706 7.02944",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            })
        ]
    });
var $24c02ea0e14dbe4f$var$$6a34d18c8d59b475$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$var$$6a34d18c8d59b475$var$CloseIcon;
const $24c02ea0e14dbe4f$var$$5ba5f450ff826a14$var$HamburgerMenuIcon = ()=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M4 8H28",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M4 16H28",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M4 24H28",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            })
        ]
    });
var $24c02ea0e14dbe4f$var$$5ba5f450ff826a14$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$var$$5ba5f450ff826a14$var$HamburgerMenuIcon;
const $24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d = {
    MOBILE: {
        MAX_WIDTH: 767,
        MEDIA_QUERY: "@media (max-width: 767px)"
    },
    TABLET: {
        MIN_WIDTH: 768,
        MAX_WIDTH: 1279,
        MEDIA_QUERY: "@media (min-width: 768px) and (max-width: 1279px)"
    },
    DESKTOP: {
        MIN_WIDTH: 1280,
        MEDIA_QUERY: "@media (min-width: 1280px)"
    }
};
var $24c02ea0e14dbe4f$var$$965a3cfbe886b380$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$965a3cfbe886b380$exports, "useOutsideClickHandler", ()=>$24c02ea0e14dbe4f$export$aa79b0abe3dfeaba);
const $24c02ea0e14dbe4f$export$aa79b0abe3dfeaba = (refs, onOutsideClick)=>{
    (0, $5FkrB.useEffect)(()=>{
        const handleOutsideClick = (event)=>{
            // if click has occurred outside of all refs, then call onOutsideClick
            if (refs.every((ref)=>ref.current && !ref.current.contains(event.target))) onOutsideClick();
        };
        // bind the event listener
        document.addEventListener("mousedown", handleOutsideClick);
        return ()=>{
            // unbind the event listener on clean up
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [
        refs,
        onOutsideClick
    ]);
};
const $24c02ea0e14dbe4f$export$6ce3be5638d8e2a = ({ subtitleHref: subtitleHref, label: label, logoSubtitle: logoSubtitle })=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
        css: $24c02ea0e14dbe4f$var$$90d3cbebafca1fdb$var$containerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("a", {
                href: "https://www.atlassian.com",
                target: "_blank",
                rel: "noopener noreferrer",
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                        css: $24c02ea0e14dbe4f$var$$90d3cbebafca1fdb$var$smallAtlassianLogoStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $37844134dd17fb96$export$8a485e2e7ed91e8f), {
                            testId: "mobile"
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                        css: $24c02ea0e14dbe4f$var$$90d3cbebafca1fdb$var$bigAtlassianLogoStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $fefa5e0a15da0ac0$export$765cacec8b0843f3), {
                            testId: "desktop"
                        })
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: $24c02ea0e14dbe4f$var$$90d3cbebafca1fdb$var$dividerStyles
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                href: subtitleHref,
                css: $24c02ea0e14dbe4f$var$$90d3cbebafca1fdb$var$subtitleStyles,
                "data-testid": "logoSubtitle",
                "aria-label": label,
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
                    children: [
                        " ",
                        logoSubtitle,
                        " "
                    ]
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$90d3cbebafca1fdb$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    background: "none",
    fontFamily: "Charlie Display"
});
const $24c02ea0e14dbe4f$var$$90d3cbebafca1fdb$var$smallAtlassianLogoStyles = (0, $74Zh5.css)({
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        display: "flex",
        alignItems: "center",
        svg: {
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.brand"),
            transform: "scale(0.74)"
        }
    },
    [`@media (min-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$90d3cbebafca1fdb$var$bigAtlassianLogoStyles = (0, $74Zh5.css)({
    [`@media (min-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        display: "flex",
        alignItems: "center",
        span: {
            width: "148px",
            height: "24px"
        },
        svg: {
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.brand")
        }
    },
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$90d3cbebafca1fdb$var$dividerStyles = (0, $74Zh5.css)({
    width: "1px",
    height: "32px",
    backgroundColor: "#DDDEE1",
    marginLeft: "24px",
    marginRight: "16px",
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        marginLeft: "8px",
        marginRight: "16px"
    }
});
const $24c02ea0e14dbe4f$var$$90d3cbebafca1fdb$var$subtitleStyles = (0, $74Zh5.css)({
    fontSize: "22px",
    fontWeight: 600,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    textDecoration: "none",
    padding: "6px 8px",
    "&:hover": {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.brand"),
        textDecoration: "none"
    }
});
const $24c02ea0e14dbe4f$var$$ff532043ef39c56f$var$SlideMenuContext = (0, $5FkrB.createContext)(undefined);
const $24c02ea0e14dbe4f$var$$ff532043ef39c56f$export$74d704c90f90362c = ()=>{
    const context = (0, $5FkrB.useContext)($24c02ea0e14dbe4f$var$$ff532043ef39c56f$var$SlideMenuContext);
    if (!context) throw new Error("useSlideMenuContext must be used within a SlideMenuContextProvider");
    return context;
};
const $24c02ea0e14dbe4f$var$$ff532043ef39c56f$export$f5c7f2da77f7e7fd = ({ children: children })=>{
    const [slideMenuContent, setSlideMenuContent] = (0, $5FkrB.useState)(null);
    const [isSlideMenuOpen, setIsSlideMenuOpen] = (0, $5FkrB.useState)(false);
    const [containerHeight, setContainerHeight] = (0, $5FkrB.useState)("initial");
    const openSlideMenu = (content)=>{
        setSlideMenuContent(content);
        setIsSlideMenuOpen(true);
    };
    const closeSlideMenu = ()=>{
        setIsSlideMenuOpen(false);
    };
    const contextValue = (0, $5FkrB.useMemo)(()=>({
            slideMenuContent: slideMenuContent,
            isSlideMenuOpen: isSlideMenuOpen,
            openSlideMenu: openSlideMenu,
            closeSlideMenu: closeSlideMenu,
            containerHeight: containerHeight,
            setContainerHeight: setContainerHeight
        }), [
        slideMenuContent,
        isSlideMenuOpen,
        containerHeight
    ]);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$ff532043ef39c56f$var$SlideMenuContext.Provider, {
        value: contextValue,
        children: children
    });
};
const $24c02ea0e14dbe4f$export$2771c1f4a09ce668 = ({ headerContent: headerContent, bodyContent: bodyContent, isNested: isNested = false, isActive: isActive = false })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$6295d3d31ca2a786$var$containerStyles,
        role: "group",
        "data-testid": "navbar-menu-item",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$6295d3d31ca2a786$var$headerStyles,
                    isActive && $24c02ea0e14dbe4f$var$$6295d3d31ca2a786$var$headerSelectedStyles,
                    isNested && $24c02ea0e14dbe4f$var$$6295d3d31ca2a786$var$nestedHeaderStyles
                ],
                role: "treeitem",
                "aria-selected": isActive,
                children: headerContent
            }),
            isActive && bodyContent && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
                css: [
                    $24c02ea0e14dbe4f$var$$6295d3d31ca2a786$var$bodyContentContainerStyles,
                    isNested && $24c02ea0e14dbe4f$var$$6295d3d31ca2a786$var$nestedBodyContentContainerStyles
                ],
                children: bodyContent
            })
        ]
    });
const $24c02ea0e14dbe4f$var$$6295d3d31ca2a786$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    fontSize: "16px",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$6295d3d31ca2a786$var$headerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    height: "32px",
    width: "100%",
    padding: `0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")}`
});
const $24c02ea0e14dbe4f$var$$6295d3d31ca2a786$var$headerSelectedStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected"),
    "a, span": {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")
    }
});
const $24c02ea0e14dbe4f$var$$6295d3d31ca2a786$var$nestedHeaderStyles = (0, $74Zh5.css)({
    padding: `0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.500")}`
});
const $24c02ea0e14dbe4f$var$$6295d3d31ca2a786$var$bodyContentContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    paddingLeft: 0,
    margin: 0,
    marginTop: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} !important`,
    listStyle: "none"
});
const $24c02ea0e14dbe4f$var$$6295d3d31ca2a786$var$nestedBodyContentContainerStyles = (0, $74Zh5.css)({
    li: {
        paddingLeft: "56px"
    }
});
var $24c02ea0e14dbe4f$var$$6e8a4d5d78071ed7$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$6e8a4d5d78071ed7$exports, "useMediaQuery", ()=>$24c02ea0e14dbe4f$export$32d5543ab307c01);
const $24c02ea0e14dbe4f$export$32d5543ab307c01 = (mediaQuery)=>{
    const [targetReached, setTargetReached] = (0, $5FkrB.useState)(false);
    const updateTarget = (0, $5FkrB.useCallback)((e)=>{
        if (e.matches) setTargetReached(true);
        else setTargetReached(false);
    }, []);
    (0, $5FkrB.useEffect)(()=>{
        const media = window.matchMedia(mediaQuery);
        media.addEventListener("change", updateTarget);
        // Check on mount (callback is not called until a change occurs)
        if (media.matches) setTargetReached(true);
        return ()=>media.removeEventListener("change", updateTarget);
    // mediaQuery and updateTarget intentionally excluded to avoid re-creating listener
    /* eslint-disable react-hooks/exhaustive-deps */ }, []);
    /* eslint-enable react-hooks/exhaustive-deps */ return targetReached;
};
const $24c02ea0e14dbe4f$var$$3e3d20b49785004a$export$29d11c0fe2fc51d8 = ({ link: link, shouldRedirect: shouldRedirect, isSelected: isSelected })=>{
    const { text: text, href: href, onClick: onClick, target: target } = link;
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        css: [
            $24c02ea0e14dbe4f$var$$3e3d20b49785004a$var$linkStyles.default,
            isSelected && $24c02ea0e14dbe4f$var$$3e3d20b49785004a$var$linkStyles.selected
        ],
        href: shouldRedirect ? href : undefined,
        onClick: onClick,
        target: target || "_self",
        children: text
    });
};
const $24c02ea0e14dbe4f$export$e76239e22e3abad = ({ isSelected: isSelected = false, link: link, expandableBodyContent: expandableBodyContent, isNested: isNested = false, showNewMenu: showNewMenu = false })=>{
    const isBreakpoint = $24c02ea0e14dbe4f$export$32d5543ab307c01(`(max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`);
    if (isBreakpoint) return showNewMenu ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2771c1f4a09ce668, {
        headerContent: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$3e3d20b49785004a$export$29d11c0fe2fc51d8, {
            link: link,
            isSelected: isSelected,
            shouldRedirect: !expandableBodyContent
        }),
        bodyContent: expandableBodyContent,
        isNested: isNested,
        isActive: isSelected
    }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$1229978ae51a03a8, {
        headerContent: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$3e3d20b49785004a$export$29d11c0fe2fc51d8, {
            link: link,
            isSelected: isSelected,
            shouldRedirect: !expandableBodyContent
        }),
        bodyContent: expandableBodyContent,
        isNested: isNested
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$3e3d20b49785004a$var$buttonDivStyles,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$3e3d20b49785004a$export$29d11c0fe2fc51d8, {
            link: link,
            isSelected: isSelected,
            shouldRedirect: true
        })
    });
};
const $24c02ea0e14dbe4f$var$$3e3d20b49785004a$var$buttonDivStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px 12px"
});
const $24c02ea0e14dbe4f$var$$3e3d20b49785004a$var$linkStyles = {
    default: (0, $74Zh5.css)({
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
        fontSize: "1rem",
        fontWeight: 400,
        lineHeight: "20px",
        "&:hover": {
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected"),
            textDecoration: "none"
        },
        "&:active": {
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.information")
        },
        [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
            "&:hover, &:active": {
                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
                textDecoration: "none"
            }
        }
    }),
    selected: (0, $74Zh5.css)({
        [`@media (min-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")
        }
    })
};
const $24c02ea0e14dbe4f$export$1229978ae51a03a8 = ({ headerContent: headerContent, expandedHeaderContent: expandedHeaderContent, bodyContent: bodyContent, onExpandClick: onExpandClick, isNested: isNested = false })=>{
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const onExpandClickHandler = ()=>{
        setIsOpen(!isOpen);
        if (onExpandClick) onExpandClick(isOpen);
    };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$containerStyles,
        role: "group",
        children: bodyContent ? (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
            children: [
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: [
                        $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$headerStyles,
                        isOpen && $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$headerSelectedStyles,
                        isNested && $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$nestedHeaderStyles
                    ],
                    role: "treeitem",
                    tabIndex: 0,
                    "aria-selected": isOpen,
                    onClick: onExpandClickHandler,
                    onKeyDown: (e)=>{
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            onExpandClickHandler();
                        }
                    },
                    children: [
                        isOpen && expandedHeaderContent ? expandedHeaderContent : headerContent,
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: isOpen && $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$chevronSelectedStyles,
                            children: isOpen ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($cS1ic))), {
                                label: "Collapse item"
                            }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($5Y5FQ))), {
                                label: "Expand item"
                            })
                        })
                    ]
                }),
                isOpen && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
                    css: [
                        $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$bodyContentContainerStyles,
                        isNested && $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$nestedBodyContentContainerStyles
                    ],
                    children: bodyContent
                })
            ]
        }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$headerStyles,
            role: "treeitem",
            tabIndex: 0,
            "aria-selected": false,
            children: headerContent
        })
    });
};
const $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    fontSize: "1rem",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$headerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    height: "32px",
    width: "100%",
    padding: "0 24px"
});
// when selected, header text color should appear as selected color (apply to different elements, since headerContent can vary)
const $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$headerSelectedStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected"),
    a: {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")
    },
    span: {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")
    }
});
const $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$nestedHeaderStyles = (0, $74Zh5.css)({
    padding: "0 40px"
});
const $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$bodyContentContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "8px",
    paddingTop: "8px",
    paddingLeft: "0",
    margin: 0,
    listStyle: "none"
});
const $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$nestedBodyContentContainerStyles = (0, $74Zh5.css)({
    li: {
        paddingLeft: "56px"
    }
});
const $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$chevronSelectedStyles = (0, $74Zh5.css)({
    svg: {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")
    }
});
const $24c02ea0e14dbe4f$export$c7fcbaf97c146aec = ({ title: title, menuHeader: menuHeader, menuContent: menuContent, type: type = "menuItem" })=>{
    const { openSlideMenu: openSlideMenu } = $24c02ea0e14dbe4f$var$$ff532043ef39c56f$export$74d704c90f90362c();
    const handleOpenMenu = (0, $5FkrB.useCallback)(()=>{
        openSlideMenu({
            header: menuHeader || title,
            content: menuContent
        });
    }, [
        openSlideMenu,
        menuHeader,
        title,
        menuContent
    ]);
    const onKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleOpenMenu);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
        "data-testid": "navbar-slide-menu-item",
        css: [
            $24c02ea0e14dbe4f$var$$67abd1c503eb8615$var$listItemStyles,
            type === "subMenuItem" && $24c02ea0e14dbe4f$var$$67abd1c503eb8615$var$subMenuItemStyles
        ],
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            role: "button",
            tabIndex: 0,
            css: $24c02ea0e14dbe4f$var$$67abd1c503eb8615$var$interactiveContentStyles,
            onClick: handleOpenMenu,
            onKeyDown: onKeyDown,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    css: $24c02ea0e14dbe4f$var$$67abd1c503eb8615$var$titleStyles,
                    children: title
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: "chevron-right",
                    size: "medium"
                })
            ]
        })
    });
};
const $24c02ea0e14dbe4f$var$$67abd1c503eb8615$var$titleStyles = (0, $74Zh5.css)({
    fontSize: "16px",
    fontWeight: 400
});
const $24c02ea0e14dbe4f$var$$67abd1c503eb8615$var$listItemStyles = (0, $74Zh5.css)({});
const $24c02ea0e14dbe4f$var$$67abd1c503eb8615$var$interactiveContentStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    padding: `0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")}`,
    paddingRight: "18px",
    height: "32px",
    "&:hover": {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.link")
    }
});
const $24c02ea0e14dbe4f$var$$67abd1c503eb8615$var$subMenuItemStyles = (0, $74Zh5.css)({
    "& > div": {
        padding: `0 18px 0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.500")}`
    }
});
const $24c02ea0e14dbe4f$var$$397a78fff494027c$var$getAvatarUserHeaderForMobile = (user, isExpanded)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$397a78fff494027c$var$headerContentStyles,
            isExpanded && $24c02ea0e14dbe4f$var$$397a78fff494027c$var$avatarUserSelectedStyles
        ],
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f31efb9f24b21b67$export$2e2bcd8739ae039), {
                appearance: "circle",
                src: user.avatar,
                size: "small",
                name: user.publicName
            }, user.publicName),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$397a78fff494027c$var$nameStyles,
                children: user.publicName
            })
        ]
    });
const $24c02ea0e14dbe4f$export$1cba3806e1f1b01d = ({ user: user, expandableMenuContent: expandableMenuContent, profileMenuContent: profileMenuContent, onProfileMenuClick: onProfileMenuClick, showNewMenu: showNewMenu = false })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $5FkrB.useState)(false);
    const isBreakpoint = $24c02ea0e14dbe4f$export$32d5543ab307c01(`(max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`);
    const avatarMenuRef = (0, $5FkrB.useRef)(null);
    $24c02ea0e14dbe4f$export$aa79b0abe3dfeaba([
        avatarMenuRef
    ], ()=>setIsMenuOpen(false));
    const onProfileMenuClickHandler = ()=>{
        setIsMenuOpen(!isMenuOpen);
        if (onProfileMenuClick) onProfileMenuClick(isMenuOpen);
    };
    if (isBreakpoint) return showNewMenu ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$c7fcbaf97c146aec, {
        title: $24c02ea0e14dbe4f$var$$397a78fff494027c$var$getAvatarUserHeaderForMobile(user, false),
        menuHeader: $24c02ea0e14dbe4f$var$$397a78fff494027c$var$getAvatarUserHeaderForMobile(user, true),
        menuContent: expandableMenuContent
    }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$1229978ae51a03a8, {
        headerContent: $24c02ea0e14dbe4f$var$$397a78fff494027c$var$getAvatarUserHeaderForMobile(user, false),
        expandedHeaderContent: $24c02ea0e14dbe4f$var$$397a78fff494027c$var$getAvatarUserHeaderForMobile(user, true),
        bodyContent: expandableMenuContent,
        onExpandClick: onProfileMenuClick
    });
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
        ref: avatarMenuRef,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                css: [
                    $24c02ea0e14dbe4f$var$$397a78fff494027c$var$avatarStyles,
                    isMenuOpen && $24c02ea0e14dbe4f$var$$397a78fff494027c$var$avatarUserSelectedStyles
                ],
                onClick: onProfileMenuClickHandler,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f31efb9f24b21b67$export$2e2bcd8739ae039), {
                    appearance: "circle",
                    src: user.avatar,
                    size: "medium",
                    name: user.publicName
                }, user.publicName)
            }),
            isMenuOpen && profileMenuContent ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
                css: $24c02ea0e14dbe4f$var$$397a78fff494027c$var$openMenuStyles,
                "aria-label": "Profile menu",
                role: "menu",
                children: profileMenuContent
            }) : null
        ]
    });
};
const $24c02ea0e14dbe4f$var$$397a78fff494027c$var$headerContentStyles = (0, $74Zh5.css)({
    display: "flex",
    gap: "8px",
    fontSize: "1rem",
    lineHeight: "20px"
});
const $24c02ea0e14dbe4f$var$$397a78fff494027c$var$nameStyles = (0, $74Zh5.css)({
    alignSelf: "center"
});
const $24c02ea0e14dbe4f$var$$397a78fff494027c$var$avatarStyles = (0, $74Zh5.css)({
    all: "unset",
    cursor: "pointer",
    marginTop: "3px",
    "&:focus-visible": {
        outline: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $24c02ea0e14dbe4f$var$$397a78fff494027c$var$avatarUserSelectedStyles = (0, $74Zh5.css)({
    "& > * > span": {
        outline: `2px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")} solid`
    }
});
const $24c02ea0e14dbe4f$var$$397a78fff494027c$var$openMenuStyles = (0, $74Zh5.css)({
    backgroundColor: "#FFFFFF",
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    right: 0,
    zIndex: 10,
    borderRadius: "4px",
    boxShadow: "0 0 1px 0 #ccc,0 5px 20px -5px rgba(0,0,0,.1)",
    listStyle: "none",
    margin: 0,
    padding: 0
});
const $24c02ea0e14dbe4f$export$2ce376c2cc3355c8 = ({ link: link, type: type, contentBefore: contentBefore, contentAfter: contentAfter })=>{
    const { href: href, onClick: onClick, text: text, icon: icon } = link;
    const isActive = (0, $5FkrB.useMemo)(()=>href && globalThis ? globalThis.location.pathname === href : false, [
        href
    ]);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        css: $24c02ea0e14dbe4f$var$$3539883ac1727dfc$var$menuLinkStyles,
        href: href,
        onClick: onClick,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("li", {
            css: [
                $24c02ea0e14dbe4f$var$$3539883ac1727dfc$var$menuItemContainerBaseStyles,
                $24c02ea0e14dbe4f$var$$3539883ac1727dfc$var$menuItemContainerStyles[type],
                isActive && $24c02ea0e14dbe4f$var$$3539883ac1727dfc$var$activeStyles
            ],
            role: "treeitem",
            "aria-selected": isActive,
            children: [
                contentBefore,
                text,
                icon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    css: $24c02ea0e14dbe4f$var$$3539883ac1727dfc$var$iconStyles,
                    children: icon
                }),
                contentAfter
            ]
        })
    });
};
const $24c02ea0e14dbe4f$var$$3539883ac1727dfc$var$menuItemContainerBaseStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$3539883ac1727dfc$var$menuItemContainerStyles = {
    subMenu: (0, $74Zh5.css)({
        height: "32px",
        padding: "0 40px"
    }),
    profile: (0, $74Zh5.css)({
        height: "48px",
        padding: "0 24px"
    }),
    menuItem: (0, $74Zh5.css)({
        fontFamily: "Inter, sans-serif",
        fontSize: "14px",
        lineHeight: "22px",
        fontWeight: 400,
        height: "32px",
        padding: `0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`
    })
};
const $24c02ea0e14dbe4f$var$$3539883ac1727dfc$var$menuLinkStyles = (0, $74Zh5.css)({
    fontSize: "16px",
    lineHeight: "16px",
    fontWeight: 400,
    color: "#172B4D",
    cursor: "pointer",
    "&:hover": {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected"),
        textDecoration: "none"
    },
    "&:active": {
        color: "#0055CC",
        li: {
            background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.blue.subtlest")
        }
    }
});
const $24c02ea0e14dbe4f$var$$3539883ac1727dfc$var$activeStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")
});
const $24c02ea0e14dbe4f$var$$3539883ac1727dfc$var$iconStyles = (0, $74Zh5.css)({
    display: "inline-flex",
    alignItems: "center",
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
});
const $24c02ea0e14dbe4f$var$$e2bb601faa5fb56f$export$a24e9349d70a402 = ({ navRef: navRef })=>{
    const navWrapperTopPosition = (0, $5FkrB.useMemo)(()=>navRef.current?.getBoundingClientRect()?.y || 56, [
        navRef
    ]);
    const ref = (0, $5FkrB.useRef)(null);
    const { closeSlideMenu: closeSlideMenu, slideMenuContent: slideMenuContent, isSlideMenuOpen: isSlideMenuOpen, setContainerHeight: setContainerHeight } = $24c02ea0e14dbe4f$var$$ff532043ef39c56f$export$74d704c90f90362c();
    const { header: header, content: content } = slideMenuContent || {};
    const isTitleString = typeof header === "string";
    (0, $5FkrB.useEffect)(()=>{
        const element = ref.current;
        if (!element) return;
        const preventScroll = (e)=>{
            if (element.contains(e.target)) return;
            e.preventDefault();
        };
        element.addEventListener("wheel", preventScroll);
        element.addEventListener("touchmove", preventScroll);
        return ()=>{
            element.removeEventListener("wheel", preventScroll);
            element.removeEventListener("touchmove", preventScroll);
        };
    }, []);
    (0, $5FkrB.useEffect)(()=>{
        if (isSlideMenuOpen) setContainerHeight(ref.current?.getBoundingClientRect().height || "initial");
    // setContainerHeight intentionally excluded (stable setState function)
    /* eslint-disable react-hooks/exhaustive-deps */ }, [
        isSlideMenuOpen
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        ref: ref,
        "data-testid": "slide-menu",
        css: [
            $24c02ea0e14dbe4f$var$$e2bb601faa5fb56f$var$menuStyles,
            (0, $74Zh5.css)({
                maxHeight: `calc(100vh - ${navWrapperTopPosition}px)`
            })
        ],
        "aria-hidden": !isSlideMenuOpen,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$e2bb601faa5fb56f$var$backButtonContainerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.LINK,
                    onClick: closeSlideMenu,
                    iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                        type: "chevron-left",
                        size: "medium"
                    }),
                    label: "Back"
                })
            }),
            header && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    !isTitleString && $24c02ea0e14dbe4f$var$$e2bb601faa5fb56f$var$headerStyles,
                    isTitleString && $24c02ea0e14dbe4f$var$$e2bb601faa5fb56f$var$titleStyles
                ],
                children: header
            }),
            content && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$e2bb601faa5fb56f$var$contentStyles,
                children: content
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$e2bb601faa5fb56f$var$menuStyles = (0, $74Zh5.css)({
    position: "fixed",
    width: "375px",
    overflow: "auto",
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    zIndex: 1000,
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    top: 0,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        transition: "transform 0.3s cubic-bezier(.4,1,.5,1), opacity 0.3s",
        transform: "translateX(-100%)",
        left: 0,
        width: "100vw"
    }
});
const $24c02ea0e14dbe4f$var$$e2bb601faa5fb56f$var$backButtonContainerStyles = (0, $74Zh5.css)({
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250"),
    "& button": {
        padding: 0,
        marginLeft: "-9px",
        fontWeight: 400
    }
});
const $24c02ea0e14dbe4f$var$$e2bb601faa5fb56f$var$headerStyles = (0, $74Zh5.css)({
    textTransform: "uppercase",
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    "& > div": {
        fontSize: "12px",
        lineHeight: "16px",
        fontWeight: 600,
        fontFamily: "Charlie Text, sans-serif"
    }
});
const $24c02ea0e14dbe4f$var$$e2bb601faa5fb56f$var$titleStyles = (0, $74Zh5.css)({
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 600,
    fontFamily: "Charlie Text, sans-serif",
    textTransform: "uppercase",
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400")
});
const $24c02ea0e14dbe4f$var$$e2bb601faa5fb56f$var$contentStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$DRAWER_WIDTH = 375;
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$ToggleButton = ({ isOpen: isOpen, toggleMenu: toggleMenu })=>{
    const { closeSlideMenu: closeSlideMenu } = $24c02ea0e14dbe4f$var$$ff532043ef39c56f$export$74d704c90f90362c();
    const handleToggle = ()=>{
        toggleMenu();
        if (isOpen) closeSlideMenu();
    };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $0c4c08ddec83e35f$export$2e2bcd8739ae039), {
        appearance: "subtle",
        onClick: handleToggle,
        icon: isOpen ? $24c02ea0e14dbe4f$var$$6a34d18c8d59b475$export$2e2bcd8739ae039 : $24c02ea0e14dbe4f$var$$5ba5f450ff826a14$export$2e2bcd8739ae039,
        label: isOpen ? "Close menu" : "Open menu"
    });
};
const $24c02ea0e14dbe4f$export$214ae410b202e65a = ({ leftItems: leftItems, rightItems: rightItems, logoItem: logoItem, isSticky: isSticky = true, onMenuToggleClick: onMenuToggleClick, onMenuOutsideClick: onMenuOutsideClick })=>{
    // open state of mobile/tablet menu
    const [isMenuOpen, setIsMenuOpen] = (0, $5FkrB.useState)(false);
    // ref for the toggle button - necessary for the useOutsideClickHandler
    // useOutsideClickHandler will close menu IF the user clicks outside of the menu or toggle button (necessary to include toggle button prevent double-click)
    // separately, toggle button (close button) should also close the menu
    const toggleRef = (0, $5FkrB.useRef)(null);
    const handleToggle = ()=>{
        setIsMenuOpen(!isMenuOpen);
        if (onMenuToggleClick) onMenuToggleClick(isMenuOpen);
    };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("nav", {
        css: [
            $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$containerStyles,
            !isSticky && $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$stickyStyles
        ],
        "data-testid": "navbar",
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$innerContainerStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$logoWrapperStyles,
                    children: logoItem
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$navContentWrapperStyles,
                    children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)($24c02ea0e14dbe4f$var$$ff532043ef39c56f$export$f5c7f2da77f7e7fd, {
                        children: [
                            leftItems || rightItems ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$navMenuToggleButtonStyles,
                                ref: toggleRef,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$ToggleButton, {
                                    isOpen: isMenuOpen,
                                    toggleMenu: handleToggle
                                })
                            }) : null,
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$DesktopNavItems, {
                                leftItems: leftItems,
                                rightItems: rightItems
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$SmallNavItems, {
                                isMenuOpen: isMenuOpen,
                                setIsMenuOpen: setIsMenuOpen,
                                onMenuOutsideClick: onMenuOutsideClick,
                                leftItems: leftItems,
                                rightItems: rightItems,
                                toggleRef: toggleRef
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$MenuItems = ({ leftItems: leftItems, rightItems: rightItems })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            leftItems?.map((item, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                    css: [
                        $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$navItemWrapperStyles,
                        $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$leftItemStyles
                    ],
                    role: "menuitem",
                    children: item
                }, `left-${index}`)),
            rightItems?.map((item, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                    css: [
                        $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$navItemWrapperStyles,
                        $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$rightItemStyles
                    ],
                    role: "menuitem",
                    children: item
                }, `right-${index}`))
        ]
    });
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$DesktopNavItems = ({ leftItems: leftItems, rightItems: rightItems })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
        css: $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$desktopNavWrapperStyles,
        role: "menubar",
        "aria-orientation": "horizontal",
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$MenuItems, {
            leftItems: leftItems,
            rightItems: rightItems
        })
    });
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$SmallNavItems = ({ isMenuOpen: isMenuOpen, setIsMenuOpen: setIsMenuOpen, onMenuOutsideClick: onMenuOutsideClick, leftItems: leftItems, rightItems: rightItems, toggleRef: toggleRef })=>{
    const navRef = (0, $5FkrB.useRef)(null);
    const menuRef = (0, $5FkrB.useRef)(null);
    const slideMenuWrapperRef = (0, $5FkrB.useRef)(null);
    const { isSlideMenuOpen: isSlideMenuOpen, containerHeight: containerHeight, closeSlideMenu: closeSlideMenu } = $24c02ea0e14dbe4f$var$$ff532043ef39c56f$export$74d704c90f90362c();
    $24c02ea0e14dbe4f$export$aa79b0abe3dfeaba([
        menuRef,
        slideMenuWrapperRef,
        toggleRef
    ], ()=>{
        if (isMenuOpen) {
            setIsMenuOpen(false);
            closeSlideMenu();
            if (onMenuOutsideClick) onMenuOutsideClick();
        }
    });
    return isMenuOpen ? (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        ref: navRef,
        css: [
            $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$smallNavWrapperStyles,
            isSlideMenuOpen && (0, $74Zh5.css)({
                height: containerHeight
            })
        ],
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                ref: slideMenuWrapperRef,
                css: [
                    $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$slideMenuStyles,
                    isSlideMenuOpen && $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$slideMenuOpenStyles,
                    !isSlideMenuOpen && $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$slideMenuClosedStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$e2bb601faa5fb56f$export$a24e9349d70a402, {
                    navRef: navRef
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$smallNavContentWrapperStyles,
                    isSlideMenuOpen && $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$smallNavContentShiftedStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
                    css: $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$smallNavUlStyles,
                    ref: menuRef,
                    role: "menubar",
                    "aria-orientation": "vertical",
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$MenuItems, {
                        leftItems: leftItems,
                        rightItems: rightItems
                    })
                })
            })
        ]
    }) : null;
};
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$navItemWrapperStyles = (0, $74Zh5.css)({
    height: "100%",
    alignSelf: "center",
    margin: "0 auto",
    padding: 0,
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        "& > button": {
            width: "100%",
            justifyContent: "center"
        }
    }
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$smallNavContentWrapperStyles = (0, $74Zh5.css)({
    position: "relative",
    transition: "transform 0.4s cubic-bezier(.5,1,.5,1)",
    zIndex: 1,
    borderRadius: "8px"
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$slideMenuOpenStyles = (0, $74Zh5.css)({
    transform: "translateX(0)",
    opacity: 1,
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MAX_WIDTH}px)`]: {
        transform: "translateX(100vw)",
        top: "56px"
    }
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$slideMenuClosedStyles = (0, $74Zh5.css)({
    transform: "translateX(-100%)",
    opacity: 0,
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MAX_WIDTH}px)`]: {
        transform: "translateX(-100vw)",
        top: "56px"
    }
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$smallNavContentShiftedStyles = (0, $74Zh5.css)({
    transform: `translateX(${$24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$DRAWER_WIDTH}px)`,
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MAX_WIDTH}px)`]: {
        transform: "translateX(100vw)"
    }
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$slideMenuStyles = (0, $74Zh5.css)({
    position: "absolute",
    left: 0,
    top: 0,
    width: `${$24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$DRAWER_WIDTH}px`,
    height: "100%",
    zIndex: 2,
    transition: "height 0.7s cubic-bezier(0.22, 1, 0.36, 1), transform 0.4s cubic-bezier(.5,1,.5,1), opacity 0.2s",
    transform: "translateX(-100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MAX_WIDTH}px)`]: {
        width: "100vw",
        position: "fixed",
        borderRadius: 0,
        height: "100%"
    }
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$containerStyles = (0, $74Zh5.css)({
    backgroundColor: "#FFFFFF",
    position: "sticky",
    width: "100%",
    height: "68px",
    left: 0,
    top: 0,
    padding: "0 16px",
    zIndex: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        height: "56px",
        justifyContent: "space-between"
    }
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$stickyStyles = (0, $74Zh5.css)({
    position: "fixed"
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$innerContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    width: "100%",
    maxWidth: "1232px",
    [`@media (min-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        width: "1232px"
    }
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$navContentWrapperStyles = (0, $74Zh5.css)({
    flex: 1,
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        display: "flex",
        flexDirection: "column"
    }
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$navMenuToggleButtonStyles = (0, $74Zh5.css)({
    flex: 0,
    alignSelf: "flex-end",
    [`@media (min-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        display: "none"
    },
    button: {
        "&:hover, &:active": {
            backgroundColor: "transparent",
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.brand")
        }
    }
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$desktopNavWrapperStyles = (0, $74Zh5.css)({
    backgroundColor: "#FFFFFF",
    listStyle: "none",
    display: "none",
    flexDirection: "column",
    width: "100%",
    padding: "16px 12px",
    margin: 0,
    [`@media (min-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        display: "block",
        position: "relative",
        gap: "8px",
        padding: 0,
        boxShadow: "none",
        height: "42px"
    }
});
// mobile/tablet open menu
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$smallNavWrapperStyles = (0, $74Zh5.css)({
    backgroundColor: "#FFFFFF",
    position: "absolute",
    right: 0,
    margin: 0,
    width: "100%",
    zIndex: 1000,
    overflow: "hidden",
    transition: "height 0.4s cubic-bezier(.5,1,.5,1)",
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MAX_WIDTH}px)`]: {
        // full screen menu in mobile view
        height: "100%",
        position: "fixed",
        right: 0,
        top: 0,
        marginTop: "56px"
    },
    [`@media ((min-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MIN_WIDTH}px) and (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px))`]: {
        // appearance of floating fixed-width menu in tablet view
        width: `${$24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$DRAWER_WIDTH}px`,
        top: "100%",
        marginTop: "-9px",
        marginRight: "20px",
        borderRadius: "8px",
        boxShadow: "0 0 1px 0 #ccc,0 5px 20px -5px rgba(0,0,0,.1)"
    },
    [`@media (min-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$smallNavUlStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    listStyle: "none",
    padding: "16px 0"
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$logoWrapperStyles = (0, $74Zh5.css)({
    margin: 0,
    padding: 0,
    paddingRight: "32px",
    flexShrink: 0,
    flexGrow: 0
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$leftItemStyles = (0, $74Zh5.css)({
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        alignSelf: "flex-start",
        width: "100%"
    },
    [`@media (min-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        float: "left",
        marginRight: "8px"
    }
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$rightItemStyles = (0, $74Zh5.css)({
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        width: "100%"
    },
    [`@media (min-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        float: "right"
    }
});
var $24c02ea0e14dbe4f$var$$9efbb38deb40219f$exports = {};
$24c02ea0e14dbe4f$var$$parcel$defineInteropFlag($24c02ea0e14dbe4f$var$$9efbb38deb40219f$exports);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$9efbb38deb40219f$exports, "NavigationBarWithProfile", ()=>$24c02ea0e14dbe4f$export$fddd19fbf4d591d8);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$9efbb38deb40219f$exports, "default", ()=>$24c02ea0e14dbe4f$var$$9efbb38deb40219f$export$2e2bcd8739ae039);
/**
 * This file contains the sub-components that are wrapped with the OnClickWrapper component to send analytics events
 * with the relevant payload attributes.
 */ const $24c02ea0e14dbe4f$var$$d97d6cd9a58d7e95$export$bb065923b9250b7b = ({ ...rest })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e76239e22e3abad, {
        ...rest
    });
};
/**
 * This is a wrapper component that allows passing in an onClick handler to a div. It can be used to wrap components
 * that are meant to be clicked (e.g. buttons and links), for additional click handling.
 */ const $24c02ea0e14dbe4f$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a = ({ children: children, onClick: onClick })=>{
    const noOp = ()=>{};
    const handleKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(onClick || noOp);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
        role: "button",
        tabIndex: 0,
        onClick: onClick,
        onKeyDown: onClick ? handleKeyDown : undefined,
        children: children
    });
};
const $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$68280dacbbcb94bd = (payload, analyticsInfo)=>{
    return {
        ...payload,
        source: "communityNavigation",
        attributes: {
            ...payload.attributes || {},
            currentApp: analyticsInfo.currentApp,
            isLoggedIn: analyticsInfo.isLoggedIn,
            isNavMobileOrTablet: analyticsInfo.isMobileOrTablet
        }
    };
};
const $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$5aa64ab1f07d6e00 = ({ analyticsInfo: analyticsInfo, subtitleHref: subtitleHref, ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($24c02ea0e14dbe4f$export$3d7865934588d77e.UI, $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "logo",
                actionSubjectId: "communityNavigationHome",
                attributes: {
                    href: subtitleHref,
                    destinationApp: $24c02ea0e14dbe4f$export$93d048dc21eb282a.HOME
                }
            }, analyticsInfo), $24c02ea0e14dbe4f$export$d778a884eb401313.NAV_LOGO_CLICK);
        };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a, {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$6ce3be5638d8e2a, {
            subtitleHref: subtitleHref,
            ...rest
        })
    });
};
const $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$b18dbc162161ec9c = ({ analyticsInfo: analyticsInfo, destinationApp: destinationApp, link: link, ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($24c02ea0e14dbe4f$export$3d7865934588d77e.UI, $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "link",
                actionSubjectId: "communityNavigationLink",
                attributes: {
                    href: link.href,
                    label: link.text,
                    destinationApp: destinationApp
                }
            }, analyticsInfo), $24c02ea0e14dbe4f$export$d778a884eb401313.NAV_ITEM_CLICK);
        };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a, {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$d97d6cd9a58d7e95$export$bb065923b9250b7b, {
            link: link,
            destinationApp: destinationApp,
            ...rest
        })
    });
};
const $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$var$loginSignupWrapperStyles = (isMobile)=>isMobile ? (0, $74Zh5.css)({
        padding: "0 24px"
    }) : undefined;
const $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$var$loginButtonStyles = (isMobile)=>isMobile ? (0, $74Zh5.css)({
        button: {
            width: "100%",
            borderRadius: "0.25rem",
            borderStyle: "solid",
            borderWidth: "1px",
            fontSize: "1rem",
            fontWeight: 600,
            fontFamily: "Charlie Text",
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
            borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.brand"),
            "&:active": {
                backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected.bold.pressed"),
                borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected"),
                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse")
            },
            "&:hover": {
                backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected.bold.hovered"),
                borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected"),
                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"),
                textDecoration: "none"
            }
        }
    }) : (0, $74Zh5.css)({
        button: {
            fontWeight: 650,
            fontFamily: "Charlie Text",
            fontSize: "1rem",
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
            width: "auto",
            "&:hover": {
                backgroundColor: "transparent",
                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
                textDecoration: "none"
            }
        }
    });
const $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$var$signupButtonStyles = (isMobile)=>(0, $74Zh5.css)({
        button: {
            fontWeight: 550,
            fontFamily: "Charlie Text",
            fontSize: "1rem",
            width: isMobile ? "100%" : "auto"
        }
    });
const $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$c421b2a9819014e7 = ({ href: href, analyticsInfo: analyticsInfo, isMobile: isMobile = false })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($24c02ea0e14dbe4f$export$3d7865934588d77e.UI, $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "communityNavigationLogin",
                attributes: {
                    href: href
                }
            }, analyticsInfo), $24c02ea0e14dbe4f$export$d778a884eb401313.LOG_IN_CLICK);
        };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a, {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$var$loginSignupWrapperStyles(isMobile),
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                css: $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$var$loginButtonStyles(isMobile),
                href: href,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $123ba5aab151a241$export$2e2bcd8739ae039), {
                    appearance: "subtle",
                    children: $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$46dbfbdf99745111
                })
            })
        })
    });
};
const $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$5f193ccad31822c4 = ({ href: href, analyticsInfo: analyticsInfo, isMobile: isMobile = false })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($24c02ea0e14dbe4f$export$3d7865934588d77e.UI, $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "communityNavigationSignup",
                attributes: {
                    href: href
                }
            }, analyticsInfo), $24c02ea0e14dbe4f$export$d778a884eb401313.SIGN_UP_CLICK);
        };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a, {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$var$loginSignupWrapperStyles(isMobile),
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                css: $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$var$signupButtonStyles(isMobile),
                href: href,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $123ba5aab151a241$export$2e2bcd8739ae039), {
                    appearance: "primary",
                    children: $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$4fe37309c24221ae
                })
            })
        })
    });
};
const $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$55b351f575b2f75b = ({ analyticsInfo: analyticsInfo, ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>(isMenuOpen)=>{
            analyticsInfo.onAnalyticsSendEvent($24c02ea0e14dbe4f$export$3d7865934588d77e.UI, $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: !isMenuOpen ? "communityNavigationProfileMenuOpen" : "communityNavigationProfileMenuClose"
            }, analyticsInfo), !isMenuOpen ? $24c02ea0e14dbe4f$export$d778a884eb401313.PROFILE_MENU_OPEN : $24c02ea0e14dbe4f$export$d778a884eb401313.PROFILE_MENU_CLOSE);
        };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$1cba3806e1f1b01d, {
        onProfileMenuClick: analyticsInfo && getSendEventFn(analyticsInfo),
        ...rest
    });
};
const $24c02ea0e14dbe4f$export$92905cc84b82619c = ({ analyticsInfo: analyticsInfo, link: link, type: type, ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($24c02ea0e14dbe4f$export$3d7865934588d77e.UI, $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "communityNavigationMenuItem",
                attributes: {
                    href: link.href,
                    label: link.text,
                    menuItemId: link.id
                }
            }, analyticsInfo), $24c02ea0e14dbe4f$export$d778a884eb401313.PROFILE_MENU_ITEM_CLICK);
        };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a, {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2ce376c2cc3355c8, {
            type: type,
            link: link,
            ...rest
        })
    });
};
const $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$86a131c9ca6f534a = ({ analyticsInfo: analyticsInfo, ...rest })=>{
    // event when clicking on the menu toggle button in mobile/tablet view
    const getSendEventMenuToggleFn = (analyticsInfo)=>(isMenuOpen)=>{
            analyticsInfo.onAnalyticsSendEvent($24c02ea0e14dbe4f$export$3d7865934588d77e.UI, $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: !isMenuOpen ? "communityNavigationMobileMenuOpen" : "communityNavigationMobileMenuClose"
            }, analyticsInfo), !isMenuOpen ? $24c02ea0e14dbe4f$export$d778a884eb401313.MOBILE_MENU_OPEN : $24c02ea0e14dbe4f$export$d778a884eb401313.MOBILE_MENU_CLOSE);
        };
    // event when clicking outside of the menu in mobile/tablet view, which closes the menu
    const getSendEventOutsideClickFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($24c02ea0e14dbe4f$export$3d7865934588d77e.UI, $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "component",
                actionSubjectId: "communityNavigationMobileMenuClose"
            }, analyticsInfo), $24c02ea0e14dbe4f$export$d778a884eb401313.MOBILE_MENU_CLOSE);
        };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$214ae410b202e65a, {
        onMenuToggleClick: analyticsInfo && getSendEventMenuToggleFn(analyticsInfo),
        onMenuOutsideClick: analyticsInfo && getSendEventOutsideClickFn(analyticsInfo),
        ...rest
    });
};
const $24c02ea0e14dbe4f$var$$9efbb38deb40219f$var$getUserDisplayMenuContent = (logoutHref, type, profileHref, settingsHref, switchHref, analyticsInfo)=>{
    const subMenuItems = [];
    if (profileHref) subMenuItems.push({
        ...$24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$668d072b293d5f38.PROFILE,
        href: profileHref
    });
    if (settingsHref) subMenuItems.push({
        ...$24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$668d072b293d5f38.SETTINGS,
        href: settingsHref
    });
    if (switchHref) subMenuItems.push({
        ...$24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$668d072b293d5f38.SWITCH_ACCOUNT,
        href: switchHref
    });
    if (logoutHref) subMenuItems.push({
        ...$24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$668d072b293d5f38.LOG_OUT,
        href: logoutHref
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: subMenuItems.map((item, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$92905cc84b82619c, {
                link: item,
                type: type,
                analyticsInfo: analyticsInfo
            }, `${item.text}-${index}`))
    });
};
const $24c02ea0e14dbe4f$export$fddd19fbf4d591d8 = ({ logoItem: logoItem, leftItems: leftItems, isLoggedIn: isLoggedIn, user: user, loginHref: loginHref, signupHref: signupHref, logoutHref: logoutHref, switchHref: switchHref, profileHref: profileHref, settingsHref: settingsHref, onAnalyticsSendEvent: onAnalyticsSendEvent, isSticky: isSticky = true, showNewMenu: showNewMenu = false, currentApp: currentApp = "unknown" })=>{
    const isMobileOrTablet = $24c02ea0e14dbe4f$export$32d5543ab307c01(`(max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`);
    // Set up analytics info
    const analyticsInfo = onAnalyticsSendEvent ? {
        currentApp: currentApp,
        isLoggedIn: isLoggedIn,
        isMobileOrTablet: isMobileOrTablet,
        onAnalyticsSendEvent: onAnalyticsSendEvent
    } : undefined;
    // Render right items based on login state
    const rightItems = [];
    if (isLoggedIn && user) rightItems.push((0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$55b351f575b2f75b, {
        user: user,
        expandableMenuContent: $24c02ea0e14dbe4f$var$$9efbb38deb40219f$var$getUserDisplayMenuContent(logoutHref, showNewMenu ? "menuItem" : "subMenu", profileHref, settingsHref, switchHref, analyticsInfo),
        profileMenuContent: $24c02ea0e14dbe4f$var$$9efbb38deb40219f$var$getUserDisplayMenuContent(logoutHref, "profile", profileHref, settingsHref, switchHref, analyticsInfo),
        analyticsInfo: analyticsInfo,
        showNewMenu: showNewMenu
    }));
    else if (isMobileOrTablet) rightItems.push((0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $bdfb9b3a36dcb2bb$export$2e2bcd8739ae039), {
        space: "space.100",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$c421b2a9819014e7, {
                href: loginHref,
                analyticsInfo: analyticsInfo,
                isMobile: isMobileOrTablet
            }),
            signupHref && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$5f193ccad31822c4, {
                href: signupHref,
                analyticsInfo: analyticsInfo,
                isMobile: isMobileOrTablet
            })
        ]
    }));
    else rightItems.push((0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0c22dfc1af284338$export$2e2bcd8739ae039), {
        space: "space.100",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$c421b2a9819014e7, {
                href: loginHref,
                analyticsInfo: analyticsInfo
            }),
            signupHref && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$5f193ccad31822c4, {
                href: signupHref,
                analyticsInfo: analyticsInfo
            })
        ]
    }));
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$86a131c9ca6f534a, {
        logoItem: logoItem,
        leftItems: leftItems,
        rightItems: rightItems,
        analyticsInfo: analyticsInfo,
        isSticky: isSticky
    });
};
var $24c02ea0e14dbe4f$var$$9efbb38deb40219f$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$export$fddd19fbf4d591d8;
var $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3fbcb32390ca7008$exports, "RadioType", ()=>$24c02ea0e14dbe4f$export$f5eff9f4cffe1e46);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3fbcb32390ca7008$exports, "RadioSize", ()=>$24c02ea0e14dbe4f$export$4da24539a3bb7d98);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3fbcb32390ca7008$exports, "Radio", ()=>$24c02ea0e14dbe4f$export$d7b12c4107be0d61);
let $24c02ea0e14dbe4f$export$f5eff9f4cffe1e46;
(function(RadioType) {
    RadioType["DEFAULT"] = "DEFAULT";
    RadioType[/** TODO: remove success styles in scope of the QUIZ component update */ "SUCCESS"] = "SUCCESS";
    RadioType["DANGER"] = "DANGER";
    RadioType["DISABLED"] = "DISABLED";
})($24c02ea0e14dbe4f$export$f5eff9f4cffe1e46 || ($24c02ea0e14dbe4f$export$f5eff9f4cffe1e46 = {}));
let $24c02ea0e14dbe4f$export$4da24539a3bb7d98;
(function(RadioSize) {
    RadioSize["DEFAULT"] = "DEFAULT";
    RadioSize["LARGE"] = "LARGE";
})($24c02ea0e14dbe4f$export$4da24539a3bb7d98 || ($24c02ea0e14dbe4f$export$4da24539a3bb7d98 = {}));
const $24c02ea0e14dbe4f$export$d7b12c4107be0d61 = ({ label: label = "", name: name, isChecked: isChecked, setIsChecked: setIsChecked, type: type = $24c02ea0e14dbe4f$export$f5eff9f4cffe1e46.DEFAULT, size: size = $24c02ea0e14dbe4f$export$4da24539a3bb7d98.DEFAULT, isRequired: isRequired = false, isBold: isBold, tabIndex: tabIndex = 0 })=>{
    const handleChange = (0, $5FkrB.useCallback)(()=>{
        setIsChecked(!isChecked);
    }, [
        isChecked,
        setIsChecked
    ]);
    const handleKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleChange);
    const labelAndInputConnection = name ? `${name}-${label?.toLowerCase().replace(/\s+/g, "-")}` + "-radio-input" : label?.toLowerCase().replace(/\s+/g, "-") + "-radio-input";
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$radioContainerStyles,
            size === $24c02ea0e14dbe4f$export$4da24539a3bb7d98.LARGE && (0, $74Zh5.css)({
                columnGap: "8px"
            })
        ],
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("label", {
            htmlFor: labelAndInputConnection,
            css: [
                $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$labelStyles,
                size === $24c02ea0e14dbe4f$export$4da24539a3bb7d98.LARGE && $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$labelLargeStyles,
                type === $24c02ea0e14dbe4f$export$f5eff9f4cffe1e46.DISABLED && $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$variantClasses.label.DISABLED,
                isBold && (0, $74Zh5.css)({
                    fontWeight: 700
                }),
                !isBold && (0, $74Zh5.css)({
                    fontWeight: 400
                })
            ],
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("input", {
                    "data-testid": "radio-input",
                    name: name,
                    tabIndex: -1,
                    id: labelAndInputConnection,
                    type: "radio",
                    css: $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$inputStyles,
                    checked: isChecked,
                    onChange: (e)=>setIsChecked(e.currentTarget.checked),
                    "aria-checked": isChecked
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e61786c4aee8d415, {
                    children: label
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    role: "radio",
                    "aria-checked": isChecked,
                    "aria-label": label,
                    tabIndex: tabIndex,
                    onKeyDown: handleKeyDown,
                    css: [
                        $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$variantClasses.checkbox[type],
                        $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$checkmarkStyles,
                        size === $24c02ea0e14dbe4f$export$4da24539a3bb7d98.LARGE && $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$checkmarkLargeStyles,
                        isChecked && $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$checkedCheckmarkStyles,
                        isChecked && type === $24c02ea0e14dbe4f$export$f5eff9f4cffe1e46.DANGER && (0, $74Zh5.css)({
                            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.danger")
                        })
                    ]
                }),
                isRequired && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    css: [
                        $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$requiredMarkStyles,
                        size === $24c02ea0e14dbe4f$export$4da24539a3bb7d98.LARGE && (0, $74Zh5.css)({
                            marginLeft: "4px"
                        })
                    ],
                    children: "*"
                })
            ]
        })
    });
};
const $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$radioContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    columnGap: "6px"
});
const $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$requiredMarkStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle"),
    marginLeft: "2px"
});
const $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$inputStyles = (0, $74Zh5.css)({
    position: "absolute",
    height: 0,
    width: 0,
    opacity: 0,
    cursor: "pointer"
});
const $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$checkmarkStyles = (0, $74Zh5.css)({
    position: "absolute",
    top: 0,
    left: 0,
    width: "16px",
    height: "16px",
    marginTop: "2px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "50%",
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.input")}`,
    cursor: "pointer",
    "&:after": {
        content: '""',
        position: "absolute",
        display: "none"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        marginTop: "4px"
    }
});
const $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$checkmarkLargeStyles = (0, $74Zh5.css)({
    width: "20px",
    height: "20px",
    marginRight: "8px",
    marginTop: "6px",
    "&:after": {
        left: "5px !important",
        top: "5px !important",
        width: "8px !important",
        height: "8px !important"
    }
});
const $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$checkedCheckmarkStyles = (0, $74Zh5.css)({
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected.bold"),
    borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected"),
    "&:after": {
        display: "block",
        left: "4px",
        top: "4px",
        width: "6px",
        height: "6px",
        borderRadius: "50%",
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input")
    }
});
const $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$labelStyles = (0, $74Zh5.css)({
    display: "flex",
    position: "relative",
    paddingLeft: "22px",
    userSelect: "none",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "22px"
});
const $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$labelLargeStyles = (0, $74Zh5.css)({
    paddingLeft: "28px",
    fontSize: "20px",
    lineHeight: "32px"
});
const $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$variantClasses = {
    label: {
        DISABLED: (0, $74Zh5.css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    },
    checkbox: {
        DEFAULT: (0, $74Zh5.css)({
            ":hover": {
                borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")
            }
        }),
        SUCCESS: (0, $74Zh5.css)({
            ":hover": {
                borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")
            }
        }),
        DANGER: (0, $74Zh5.css)({
            "&, &:hover": {
                borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.danger")
            }
        }),
        DISABLED: (0, $74Zh5.css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    }
};
var $24c02ea0e14dbe4f$var$$731a4fd527bab680$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$731a4fd527bab680$exports, "TabsSize", ()=>$24c02ea0e14dbe4f$export$ddadc1228c8dcfa);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$731a4fd527bab680$exports, "Tab", ()=>$24c02ea0e14dbe4f$export$3e41faf802a29e71);
let $24c02ea0e14dbe4f$export$ddadc1228c8dcfa;
(function(TabsSize) {
    TabsSize["SMALL"] = "small";
    TabsSize["MEDIUM"] = "medium";
    TabsSize["LARGE"] = "large";
})($24c02ea0e14dbe4f$export$ddadc1228c8dcfa || ($24c02ea0e14dbe4f$export$ddadc1228c8dcfa = {}));
const $24c02ea0e14dbe4f$export$3e41faf802a29e71 = ({ label: label, labelColor: labelColor = (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"), labelColorSelected: labelColorSelected = (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"), labelColorSelectedHover: labelColorSelectedHover = (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"), onClick: onClick, iconBefore: iconBefore, iconAfter: iconAfter, size: size = $24c02ea0e14dbe4f$export$ddadc1228c8dcfa.MEDIUM, selected: selected = false, selectedColor: selectedColor, selectedHoverColor: selectedHoverColor, isLoading: isLoading })=>{
    const clickHandler = (0, $5FkrB.useCallback)((e)=>{
        if (onClick) onClick(e);
    }, [
        onClick
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
        tabIndex: 0,
        onClick: clickHandler,
        "data-testid": `tab${selected ? "-selected" : ""}`,
        css: [
            $24c02ea0e14dbe4f$var$$731a4fd527bab680$var$tabStyles["basic"],
            selected && $24c02ea0e14dbe4f$var$$731a4fd527bab680$var$tabStyles["selected"],
            !iconBefore && !iconAfter && $24c02ea0e14dbe4f$var$$731a4fd527bab680$var$tabSpacingStyles[size],
            iconBefore && $24c02ea0e14dbe4f$var$$731a4fd527bab680$var$tabSpacingStyles[`${size}-icon-before`],
            iconAfter && $24c02ea0e14dbe4f$var$$731a4fd527bab680$var$tabSpacingStyles[`${size}-icon-after`],
            labelColor && !selected && (0, $74Zh5.css)({
                color: labelColor
            }),
            labelColorSelected && selected && (0, $74Zh5.css)({
                color: labelColorSelected
            }),
            labelColorSelectedHover && selected && (0, $74Zh5.css)({
                "&:hover": {
                    color: labelColorSelectedHover
                }
            }),
            selected && selectedColor && (0, $74Zh5.css)({
                backgroundColor: selectedColor,
                borderColor: selectedColor
            }),
            selected && selectedHoverColor && (0, $74Zh5.css)({
                "&:hover": {
                    backgroundColor: selectedHoverColor,
                    borderColor: selectedHoverColor
                }
            })
        ],
        children: [
            iconBefore && !isLoading && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $24c02ea0e14dbe4f$var$$731a4fd527bab680$var$tabIconContainerStyles,
                    (0, $74Zh5.css)({
                        marginRight: "0.25rem"
                    })
                ],
                children: iconBefore
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    isLoading && (0, $74Zh5.css)({
                        marginRight: "0.5rem"
                    })
                ],
                children: label
            }),
            iconAfter && !isLoading && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $24c02ea0e14dbe4f$var$$731a4fd527bab680$var$tabIconContainerStyles,
                    (0, $74Zh5.css)({
                        marginLeft: "0.25rem"
                    })
                ],
                children: iconAfter
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$731a4fd527bab680$var$tabStyles = {
    basic: (0, $74Zh5.css)({
        display: "flex",
        alignItems: "center",
        whiteSpace: "nowrap",
        borderRadius: "3.125rem",
        fontFamily: "Charlie Display, sans-serif",
        fontSize: "1.25rem",
        fontWeight: 600,
        lineHeight: "1.75rem",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
        border: `0.125rem solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
        cursor: "pointer",
        outline: "none",
        background: "transparent",
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
            fontSize: "1rem",
            lineHeight: "1.5rem",
            padding: "0.5rem 1rem"
        },
        "&:hover": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest"),
            borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border"),
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
        },
        "&:focus-visible": {
            border: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")}`
        }
    }),
    selected: (0, $74Zh5.css)({
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral.bold.pressed"),
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"),
        border: "0.125rem solid",
        "&:hover": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.brand.boldest"),
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"),
            border: "0.125rem solid"
        }
    })
};
const $24c02ea0e14dbe4f$var$$731a4fd527bab680$var$tabSpacingStyles = {
    small: (0, $74Zh5.css)({
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")}`,
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
            padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")}`
        }
    }),
    "small-icon-before": (0, $74Zh5.css)({
        padding: "0.375rem 1rem 0.375rem 0.5rem"
    }),
    "small-icon-after": (0, $74Zh5.css)({
        padding: "0.375rem 0.5rem 0.375rem 1rem"
    }),
    medium: (0, $74Zh5.css)({
        padding: "0.375rem 1.5rem"
    }),
    "medium-icon-before": (0, $74Zh5.css)({
        padding: "0.375rem 1.5rem 0.375rem 1rem"
    }),
    "medium-icon-after": (0, $74Zh5.css)({
        padding: "0.375rem 1rem 0.375rem 1.5rem"
    }),
    large: (0, $74Zh5.css)({
        padding: "0.625rem 1.5rem"
    }),
    "large-icon-before": (0, $74Zh5.css)({
        padding: "0.625rem 1.5rem 0.625rem 1rem"
    }),
    "large-icon-after": (0, $74Zh5.css)({
        padding: "0.625rem 1rem 0.625rem 1.5rem"
    })
};
const $24c02ea0e14dbe4f$var$$731a4fd527bab680$var$tabIconContainerStyles = (0, $74Zh5.css)({
    width: "2rem",
    height: "2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
var $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$exports, "Tag", ()=>$24c02ea0e14dbe4f$export$3288d34c523a1192);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$exports, "tagListStyles", ()=>$24c02ea0e14dbe4f$export$f40d73b6f7f951e9);
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$buildCustomStyles = (labelColor, borderColor, backgroundColor, textTransform, fontWeight, fontFamily, padding)=>(0, $74Zh5.css)({
        ...labelColor && {
            color: labelColor
        },
        ...borderColor && {
            borderColor: borderColor
        },
        ...backgroundColor && {
            backgroundColor: backgroundColor
        },
        ...textTransform && {
            textTransform: textTransform
        },
        ...fontWeight && {
            fontWeight: fontWeight
        },
        ...padding && {
            padding: padding
        },
        ...fontFamily && {
            fontFamily: fontFamily
        }
    });
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$buildCustomTextStyles = (labelColor, fontWeight, textTransform, fontFamily, maxSize)=>(0, $74Zh5.css)({
        ...labelColor && {
            color: labelColor
        },
        ...fontWeight && {
            fontWeight: fontWeight
        },
        ...textTransform && {
            textTransform: textTransform
        },
        ...fontFamily && {
            fontFamily: fontFamily
        },
        ...maxSize && {
            maxWidth: maxSize,
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap"
        }
    });
const $24c02ea0e14dbe4f$export$3288d34c523a1192 = ({ inspectMode: inspectMode, label: label, onClick: onClick, selected: selected, iconAfter: iconAfter, iconBefore: iconBefore, isLarge: isLarge, isTall: isTall, labelColor: labelColor, borderColor: borderColor, backgroundColor: backgroundColor, textTransform: textTransform, fontWeight: fontWeight, fontFamily: fontFamily, maxSize: maxSize, padding: padding })=>{
    const customStyles = $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$buildCustomStyles(labelColor, borderColor, backgroundColor, textTransform, fontWeight, fontFamily, padding);
    const customTextStyles = $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$buildCustomTextStyles(labelColor, fontWeight, textTransform, fontFamily, maxSize);
    const noOp = ()=>{};
    const onKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(onClick || noOp);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("tag", inspectMode),
        role: onClick ? "button" : undefined,
        tabIndex: onClick ? 0 : -1,
        css: [
            $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$tagStyles,
            selected && $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$selectedTagStyles,
            onClick && $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$hoverableTagStyles,
            iconBefore && $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$beforeIconTagStyles,
            iconAfter && $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$afterIconTagStyles,
            isLarge && $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$largeTagStyles,
            isTall && $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$tallTagStyles,
            customStyles
        ],
        onClick: onClick,
        onKeyDown: onClick ? onKeyDown : undefined,
        children: [
            iconBefore && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$iconStyles,
                    $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$beforeIconStyles
                ],
                children: iconBefore
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    isLarge && $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$largeTagTextStyles,
                    customTextStyles
                ],
                children: label
            }),
            iconAfter && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$iconStyles,
                    $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$afterIconStyles
                ],
                children: iconAfter
            })
        ]
    });
};
const $24c02ea0e14dbe4f$export$f40d73b6f7f951e9 = (0, $74Zh5.css)({
    display: "flex",
    flexWrap: "wrap",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$tagStyles = (0, $74Zh5.css)({
    display: "flex",
    height: "24px",
    padding: `4px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")}`,
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "4px",
    alignItems: "center",
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px",
    textTransform: "uppercase",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    boxSizing: "border-box",
    whiteSpace: "nowrap"
});
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$hoverableTagStyles = (0, $74Zh5.css)({
    "&:hover": {
        borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.accent.gray"),
        cursor: "pointer"
    }
});
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$selectedTagStyles = (0, $74Zh5.css)({
    borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")
});
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$iconStyles = (0, $74Zh5.css)({
    span: {
        width: "14px",
        height: "14px",
        marginBottom: "2px"
    }
});
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$beforeIconStyles = (0, $74Zh5.css)({
    marginRight: "0.125rem"
});
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$afterIconStyles = (0, $74Zh5.css)({
    marginLeft: "0.125rem"
});
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$beforeIconTagStyles = (0, $74Zh5.css)({
    paddingLeft: "0.375rem"
});
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$afterIconTagStyles = (0, $74Zh5.css)({
    paddingRight: "0.375rem"
});
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$largeTagStyles = (0, $74Zh5.css)({
    display: "flex",
    height: "32px",
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.075")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")}`,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "4px",
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    textTransform: "uppercase",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    boxSizing: "border-box",
    whiteSpace: "nowrap"
});
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$largeTagTextStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    textAlign: "center",
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: 'var(--Font-Family-Eyebrow, "Charlie Text")',
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "16px",
    textTransform: "uppercase"
});
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$tallTagStyles = (0, $74Zh5.css)({
    paddingTop: "6px",
    paddingBottom: "6px",
    paddingLeft: "6px",
    paddingRight: "6px",
    height: "auto"
});
var $24c02ea0e14dbe4f$var$$8b54d37779d052e8$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$8b54d37779d052e8$exports, "Text", ()=>$24c02ea0e14dbe4f$export$5f1af8db9871e1d6);
const $24c02ea0e14dbe4f$export$5f1af8db9871e1d6 = ({ fontWeight: fontWeight = "regular", size: size = "regular", color: color = (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.accent.gray.bolder"), children: children, backgroundColor: backgroundColor })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
        css: [
            $24c02ea0e14dbe4f$var$$8b54d37779d052e8$var$textDefaultStyles,
            backgroundColor && (0, $74Zh5.css)({
                backgroundColor: backgroundColor,
                padding: "4px"
            }),
            color && (0, $74Zh5.css)({
                color: color
            }),
            $24c02ea0e14dbe4f$var$$8b54d37779d052e8$var$variantsStyles.fontWeight[fontWeight],
            $24c02ea0e14dbe4f$var$$8b54d37779d052e8$var$variantsStyles.size[size]
        ],
        children: children
    });
const $24c02ea0e14dbe4f$var$$8b54d37779d052e8$var$textDefaultStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    blockquote: $24c02ea0e14dbe4f$export$7a77f8e9665fa6b2,
    ul: $24c02ea0e14dbe4f$export$6427468642e6e9fe.list.unordered,
    ol: $24c02ea0e14dbe4f$export$6427468642e6e9fe.list.ordered
});
const $24c02ea0e14dbe4f$var$$8b54d37779d052e8$var$variantsStyles = {
    size: {
        small: (0, $74Zh5.css)({
            fontSize: "14px",
            lineHeight: "20px",
            [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
                fontSize: "14px",
                lineHeight: "20px"
            }
        }),
        regular: (0, $74Zh5.css)({
            fontSize: "14px",
            lineHeight: "22px",
            [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
                fontSize: "16px",
                lineHeight: "24px"
            }
        }),
        large: (0, $74Zh5.css)({
            fontSize: "16px",
            lineHeight: "24px",
            [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
                fontSize: "20px",
                lineHeight: "32px"
            }
        })
    },
    fontWeight: {
        regular: (0, $74Zh5.css)({
            fontWeight: 400
        }),
        semibold: (0, $74Zh5.css)({
            fontWeight: 600
        }),
        bold: (0, $74Zh5.css)({
            fontWeight: 700
        })
    }
};
var $24c02ea0e14dbe4f$var$$9cfa05d02afa3952$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$9cfa05d02afa3952$exports, "AccordionSize", ()=>$24c02ea0e14dbe4f$export$8f89d78db9c8c41f);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$9cfa05d02afa3952$exports, "Accordion", ()=>$24c02ea0e14dbe4f$export$a766cd26d0d69044);
const $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$NAVBAR_HEIGHT = 124;
const $24c02ea0e14dbe4f$var$$51f57eef4d47f918$export$10e5e64ea66c812f = ({ title: title, index: index, children: children, isFirstTab: isFirstTab, isExpanded: isExpanded, shouldSingleTabBeOpen: shouldSingleTabBeOpen, setTabState: setTabState, setExpansionMap: setExpansionMap })=>{
    const tabRef = (0, $5FkrB.useRef)(null);
    const handleExpand = (0, $5FkrB.useCallback)(()=>{
        if (!setExpansionMap) return;
        setExpansionMap((prevState)=>prevState.map((tab, i)=>{
                if (setTabState && index !== undefined && i === index) setTabState({
                    [index + 1]: !tab.isExpanded ? "expand" : "collapse"
                });
                return {
                    ...tab,
                    isExpanded: i === index ? !tab.isExpanded : shouldSingleTabBeOpen ? false : tab.isExpanded
                };
            }));
    }, [
        index,
        setExpansionMap,
        setTabState,
        shouldSingleTabBeOpen
    ]);
    const disableClickEventBubbling = (event)=>event.stopPropagation();
    const handleKeyDown = (0, $5FkrB.useCallback)((event)=>{
        if (event.code === "Space") {
            // to handle cases when there are clickable items within accordion
            if (event.target !== event.currentTarget) {
                event.preventDefault();
                event.stopPropagation();
            } else {
                event.preventDefault();
                handleExpand();
            }
        }
    }, [
        handleExpand
    ]);
    (0, $5FkrB.useEffect)(()=>{
        if (isExpanded && tabRef.current) {
            const topPosition = tabRef.current.getBoundingClientRect().top + window.scrollY - $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$NAVBAR_HEIGHT;
            window.scrollTo({
                top: topPosition,
                behavior: "smooth"
            });
        }
    }, [
        isExpanded
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        ref: tabRef,
        onKeyDown: handleKeyDown,
        css: [
            $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$accordionTabStyles,
            isFirstTab && $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$firstTabStyles,
            isExpanded && $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$expandedTabStyles
        ],
        onClick: handleExpand,
        "data-testid": `accordion-tab-${title}`,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    isExpanded && $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$expandedTabContentStyles
                ],
                children: isExpanded ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: "chevron-down",
                    alt: "Chevron down"
                }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: "chevron-right",
                    alt: "Chevron right"
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$contentContainer,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$titleStyles,
                        children: title
                    }),
                    isExpanded && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        role: "button",
                        tabIndex: 0,
                        onClick: disableClickEventBubbling,
                        onKeyDown: (e)=>{
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },
                        css: $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$contentStyles,
                        "data-testid": "accordion-tab-content",
                        children: children
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$accordionTabStyles = (0, $74Zh5.css)({
    display: "flex",
    width: "100%",
    alignContent: "center",
    alignItems: "flex-start",
    padding: "24px",
    cursor: "pointer",
    borderBottom: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`
});
const $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$firstTabStyles = (0, $74Zh5.css)({
    borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`
});
const $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$expandedTabStyles = (0, $74Zh5.css)({
    borderLeft: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.accent.blue")}`
});
const $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$expandedTabContentStyles = (0, $74Zh5.css)({
    marginLeft: "-0.5rem"
});
const $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$contentContainer = (0, $74Zh5.css)({
    marginLeft: "0.75rem"
});
const $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$titleStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    marginTop: 0,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
});
const $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$contentStyles = (0, $74Zh5.css)({
    marginTop: "16px",
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "30px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    ol: {
        margin: 0
    },
    ul: {
        margin: 0
    },
    a: {
        fontSize: "20px !important",
        lineHeight: "28px !important"
    }
});
let $24c02ea0e14dbe4f$export$8f89d78db9c8c41f;
(function(AccordionSize) {
    AccordionSize["DEFAULT"] = "default";
    AccordionSize["WIDE"] = "wide";
    AccordionSize["FULL_WIDTH"] = "full-width";
})($24c02ea0e14dbe4f$export$8f89d78db9c8c41f || ($24c02ea0e14dbe4f$export$8f89d78db9c8c41f = {}));
const $24c02ea0e14dbe4f$export$a766cd26d0d69044 = ({ tabsContent: tabsContent, size: size, shouldSingleTabBeOpen: shouldSingleTabBeOpen, onChange: onChange })=>{
    const [expansionMap, setExpansionMap] = (0, $5FkrB.useState)([]);
    const [tabState, setTabState] = (0, $5FkrB.useState)();
    (0, $5FkrB.useEffect)(()=>{
        const initialExpansionMap = tabsContent.map((tabContent)=>({
                ...tabContent,
                isExpanded: false
            }));
        setExpansionMap(initialExpansionMap);
    // tabsContent intentionally excluded to avoid re-initializing on content changes
    /* eslint-disable react-hooks/exhaustive-deps */ }, []);
    (0, $5FkrB.useEffect)(()=>{
        if (!tabState) return;
        onChange(tabState);
    }, [
        expansionMap,
        setExpansionMap
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$9cfa05d02afa3952$var$baseAccordionStyles,
            $24c02ea0e14dbe4f$export$8f89d78db9c8c41f.DEFAULT === size && $24c02ea0e14dbe4f$var$$9cfa05d02afa3952$var$accordionDefaultStyles,
            $24c02ea0e14dbe4f$export$8f89d78db9c8c41f.WIDE === size && $24c02ea0e14dbe4f$var$$9cfa05d02afa3952$var$accordionWideStyles
        ],
        "data-testid": "lesson-accordion",
        children: expansionMap.map(({ title: title, children: children, isExpanded: isExpanded }, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$51f57eef4d47f918$export$10e5e64ea66c812f, {
                title: title,
                isFirstTab: index === 0,
                index: index,
                isExpanded: isExpanded,
                shouldSingleTabBeOpen: shouldSingleTabBeOpen,
                setTabState: setTabState,
                setExpansionMap: setExpansionMap,
                children: children
            }, title))
    });
};
const $24c02ea0e14dbe4f$var$$9cfa05d02afa3952$var$baseAccordionStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column"
});
const $24c02ea0e14dbe4f$var$$9cfa05d02afa3952$var$accordionDefaultStyles = (0, $74Zh5.css)({
    maxWidth: "720px"
});
const $24c02ea0e14dbe4f$var$$9cfa05d02afa3952$var$accordionWideStyles = (0, $74Zh5.css)({
    maxWidth: "1020px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        maxWidth: "720px"
    }
});
var $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$exports, "InlineCode", ()=>$24c02ea0e14dbe4f$export$7f1bf47c7f50a6aa);
const $24c02ea0e14dbe4f$export$7f1bf47c7f50a6aa = ({ code: code = "" })=>{
    const lines = code ? code.split(/\r\n|\r|\n/) : null;
    const [isCopied, setIsCopied] = (0, $5FkrB.useState)(false);
    const copy = (code)=>{
        navigator.clipboard.writeText(code);
        setIsCopied(true);
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("code", {
        "data-testid": "code-block",
        css: $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$var$inlineCodeStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                css: [
                    $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$var$inlineCodeButtonStyles,
                    isCopied ? (0, $74Zh5.css)({
                        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected.bold.pressed"),
                        border: "2px solid"
                    }) : (0, $74Zh5.css)({
                        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest"),
                        border: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`,
                        "&:hover": {
                            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered"),
                            border: "2px solid transparent"
                        }
                    })
                ],
                "aria-label": "Copy",
                "aria-haspopup": "true",
                type: "button",
                tabIndex: 0,
                onClick: ()=>copy(code),
                onMouseOut: ()=>setIsCopied(false),
                onBlur: ()=>setIsCopied(false),
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                        className: "tooltipText",
                        css: $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$var$tooltipTextStyles,
                        children: isCopied ? "Copied!" : "Copy"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                        type: "copy",
                        color: isCopied ? (0, $54ca2d3948378259$export$29a4f05edc054374) : (0, $54ca2d3948378259$export$7d61b15e0da132af)
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                children: lines?.map((line, index)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
                        css: $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$var$codeLinesStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                css: $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$var$lineNumberStyles,
                                children: index + 1
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                css: $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$var$lineTextStyles,
                                children: line
                            })
                        ]
                    }, index))
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$var$inlineCodeStyles = (0, $74Zh5.css)({
    position: "relative",
    display: "flex",
    maxWidth: "100%",
    margin: "20px 0",
    flexDirection: "column",
    borderRadius: "3px",
    overflowWrap: "normal",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
});
const $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$var$inlineCodeButtonStyles = (0, $74Zh5.css)({
    position: "absolute",
    right: "8px",
    top: "6px",
    display: "flex",
    padding: "2px",
    borderRadius: "4px",
    transition: "opacity 0.2s ease 0s",
    opacity: 0,
    zIndex: 1,
    cursor: "pointer",
    "&:hover .tooltipText": {
        opacity: 1
    },
    "&:hover": {
        opacity: 1
    }
});
const $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$var$tooltipTextStyles = (0, $74Zh5.css)({
    position: "absolute",
    top: "-30px",
    padding: "2px 6px",
    marginLeft: "-5px",
    borderRadius: "6px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected.bold.pressed"),
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"),
    textAlign: "center",
    fontSize: "11px",
    opacity: 0,
    zIndex: 1,
    transition: "opacity 0.4s ease 0s",
    "&:hover": {
        opacity: 1
    }
});
const $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$var$codeLinesStyles = (0, $74Zh5.css)({
    display: "flex",
    lineHeight: "20px",
    whiteSpace: "pre",
    fontSize: "12px"
});
const $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$var$lineNumberStyles = (0, $74Zh5.css)({
    padding: "4px 8px",
    marginRight: "8px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtler")
});
const $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$var$lineTextStyles = (0, $74Zh5.css)({
    padding: "4px 8px 4px 0"
});
var $24c02ea0e14dbe4f$var$$a467abe0c2c1750b$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a467abe0c2c1750b$exports, "Lozenge", ()=>$24c02ea0e14dbe4f$export$a31cbe1bf5463979);
const $24c02ea0e14dbe4f$export$a31cbe1bf5463979 = ({ appearance: appearance = "default", text: text, isBold: isBold })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $31a965b6dd4a0db8$export$2e2bcd8739ae039), {
        isBold: isBold,
        appearance: appearance,
        testId: "lozenge",
        children: text?.toUpperCase()
    });
var $24c02ea0e14dbe4f$var$$52124b9ae1d78e04$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$52124b9ae1d78e04$exports, "SectionMessageAppearance", ()=>$24c02ea0e14dbe4f$export$710836885d72543c);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$52124b9ae1d78e04$exports, "SectionMessage", ()=>$24c02ea0e14dbe4f$export$a36903bd214cec06);
let $24c02ea0e14dbe4f$export$710836885d72543c;
(function(SectionMessageAppearance) {
    SectionMessageAppearance["INFORMATION"] = "information";
    SectionMessageAppearance["INFORMATION_WHITE"] = "information_white";
})($24c02ea0e14dbe4f$export$710836885d72543c || ($24c02ea0e14dbe4f$export$710836885d72543c = {}));
const $24c02ea0e14dbe4f$export$a36903bd214cec06 = ({ children: children, appearance: appearance, fullWidth: fullWidth = false, padding: padding, title: title })=>{
    const isInfoWhite = appearance === $24c02ea0e14dbe4f$export$710836885d72543c.INFORMATION_WHITE;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$52124b9ae1d78e04$var$sectionMessageContainerStyles({
                padding: padding
            }),
            isInfoWhite && $24c02ea0e14dbe4f$var$$52124b9ae1d78e04$var$informationWhiteStyles,
            !isInfoWhite && $24c02ea0e14dbe4f$var$$52124b9ae1d78e04$var$informationStyles,
            !fullWidth && (0, $74Zh5.css)({
                maxWidth: "720px"
            })
        ],
        "data-testid": `section-message${isInfoWhite ? "-white" : ""}`,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$52124b9ae1d78e04$var$iconContainerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: "info",
                    alt: "info icon",
                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.accent.blue")
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$52124b9ae1d78e04$var$descriptionStyles,
                children: [
                    title && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                        level: 5,
                        children: title
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                        children: children
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$52124b9ae1d78e04$var$sectionMessageContainerStyles = ({ padding: padding = (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200") })=>(0, $74Zh5.css)({
        display: "flex",
        width: "100%",
        borderRadius: "3px",
        padding: padding,
        columnGap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
    });
const $24c02ea0e14dbe4f$var$$52124b9ae1d78e04$var$informationStyles = (0, $74Zh5.css)({
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.information")
});
const $24c02ea0e14dbe4f$var$$52124b9ae1d78e04$var$informationWhiteStyles = (0, $74Zh5.css)({
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface")
});
const $24c02ea0e14dbe4f$var$$52124b9ae1d78e04$var$iconContainerStyles = (0, $74Zh5.css)({
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
});
const $24c02ea0e14dbe4f$var$$52124b9ae1d78e04$var$descriptionStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    "& *": {
        fontSize: "16px !important"
    }
});
var $24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$exports = {};
$24c02ea0e14dbe4f$var$$parcel$defineInteropFlag($24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$exports);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$exports, "SharedFooter", ()=>$24c02ea0e14dbe4f$export$7a92b4adf6bd95bb);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$exports, "MinimalSharedFooter", ()=>$24c02ea0e14dbe4f$export$8dce6dbf8ef18fcb);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$exports, "default", ()=>$24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$export$2e2bcd8739ae039);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$exports, "columnStyle", ()=>$24c02ea0e14dbe4f$export$c5f2190049e47f52);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$exports, "columnsContainerStyle", ()=>$24c02ea0e14dbe4f$export$220191dc35b80c46);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$exports, "headerStyle", ()=>$24c02ea0e14dbe4f$export$5939e41228734fb7);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$exports, "linkStyle", ()=>$24c02ea0e14dbe4f$export$a4c1071d1005664f);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$exports, "FooterLink", ()=>$24c02ea0e14dbe4f$export$e0513c91be1318ca);
var $24c02ea0e14dbe4f$var$$a0eced43682c2d75$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a0eced43682c2d75$exports, "LicenseModal", ()=>$24c02ea0e14dbe4f$export$bd0c6e28f5d6b66e);
const $24c02ea0e14dbe4f$export$bd0c6e28f5d6b66e = ({ modalTitle: modalTitle, bodyTitle: bodyTitle, bodyDescription: bodyDescription, closeModal: closeModal, licenses: licenses })=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $73c4314b1cf0d4b0$export$2e2bcd8739ae039), {
        onClose: closeModal,
        shouldScrollInViewport: false,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e63db9e78b9f7f9d$export$2e2bcd8739ae039), {
                children: modalTitle && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                    level: 3,
                    fontWeight: 600,
                    children: modalTitle
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $883c6fe3d36b669f$export$2e2bcd8739ae039), {
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                        css: (0, $74Zh5.css)({
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.brand")
                        }),
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $fefa5e0a15da0ac0$export$765cacec8b0843f3), {
                            testId: "desktop"
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$a0eced43682c2d75$var$spacingContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                            level: 4,
                            fontWeight: 500,
                            children: bodyTitle
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$a0eced43682c2d75$var$spacingContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                            children: bodyDescription
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$a0eced43682c2d75$var$spacingContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                            level: 4,
                            fontWeight: 500,
                            children: "Attributions for Open Source Libraries"
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$a0eced43682c2d75$var$spacingContainerStyles,
                        children: licenses?.length && licenses.map((license, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: (0, $74Zh5.css)({
                                    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} 0`
                                }),
                                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                            css: $24c02ea0e14dbe4f$var$$a0eced43682c2d75$var$licenseTitleStyles,
                                            href: license.link,
                                            children: `${license.packageName} ${license.version}`
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                            css: (0, $74Zh5.css)({
                                                margin: 0
                                            }),
                                            children: license.description
                                        })
                                    ]
                                }, license.packageName)
                            }, license.packageName + index))
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $812d3a996ab3db86$export$2e2bcd8739ae039), {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $123ba5aab151a241$export$2e2bcd8739ae039), {
                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                    onClick: closeModal,
                    children: "Close"
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$a0eced43682c2d75$var$spacingContainerStyles = (0, $74Zh5.css)({
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} 0`
});
const $24c02ea0e14dbe4f$var$$a0eced43682c2d75$var$licenseTitleStyles = (0, $74Zh5.css)({
    fontWeight: 600
});
var $24c02ea0e14dbe4f$var$$795b38850428b3a7$require$Buffer = (0, $7KfP5.Buffer);
const $24c02ea0e14dbe4f$var$$795b38850428b3a7$var$svgStringDesktopFooterWider = `<svg width="3597" height="220" viewBox="0 0 3597 220" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_1461_26831)">
<path d="M2132.54 314.529C2146.63 313.033 2161.59 314.218 2177.19 318.272C2192.78 322.325 2207.65 328.995 2219.68 337.581L2245.71 236.527C2232.41 230.415 2218.06 225.333 2202.74 221.351C2187.42 217.369 2172.81 214.822 2158.49 213.604L2132.48 314.564L2132.54 314.529Z" fill="#BF63F3"/>
<path d="M1905.63 13.0095L1932.77 57.7351C1902.11 76.8306 1895.31 95.1589 1908.88 117.522C1922.45 139.884 1942.19 142.885 1973.45 124.776L2000.59 169.502C1939.18 206.46 1898.36 193.057 1867.63 142.412C1836.9 91.7667 1844.25 50.0145 1905.66 13.0565L1905.63 13.0095Z" fill="#BF63F3"/>
<path d="M2653.64 67.1608C2651.12 70.158 2648.74 73.5509 2646.59 77.2837C2644.43 81.0165 2642.62 84.8928 2641.3 88.6374C2633.3 110.896 2640.22 131.445 2658.16 146.049C2661.21 148.541 2664.61 150.872 2668.29 152.996C2671.97 155.121 2675.99 157.022 2679.83 158.505C2701.49 166.665 2722.75 162.381 2737.96 144.444C2740.54 141.43 2742.94 137.998 2745.14 134.187C2747.35 130.375 2749.05 126.695 2750.38 123.013C2758.29 100.911 2751.37 80.3628 2733.5 65.6405C2730.31 63.0181 2726.79 60.6186 2722.96 58.4028C2719.12 56.187 2715.6 54.5204 2711.88 53.1059C2690.25 44.8669 2668.94 49.1675 2653.72 67.2065L2653.64 67.1608Z" fill="#FCA700"/>
<path d="M1895.14 242.555C1892.93 245.176 1890.84 248.144 1888.96 251.41C1887.07 254.676 1885.48 258.069 1884.33 261.347C1877.35 280.834 1883.48 298.855 1899.28 311.691C1901.96 313.881 1904.95 315.93 1908.19 317.8C1911.43 319.669 1914.97 321.344 1918.34 322.652C1937.4 329.85 1956.07 326.142 1969.39 310.457C1971.66 307.822 1973.76 304.819 1975.69 301.484C1977.61 298.149 1979.1 294.929 1980.27 291.705C1987.17 272.356 1981.05 254.335 1965.3 241.396C1962.5 239.091 1959.4 236.981 1956.03 235.031C1952.65 233.081 1949.55 231.613 1946.28 230.365C1927.26 223.099 1908.54 226.821 1895.21 242.595L1895.14 242.555Z" fill="#1868DB"/>
<path d="M2377.56 187.36C2332.41 205.776 2303.33 188.768 2293.49 181.225L2286.73 268.152C2295.75 275.232 2321.35 289.599 2365.56 271.568C2407.5 254.47 2435.57 267.92 2447.25 275.96L2454 189.016C2443.32 181.668 2418.37 170.713 2377.56 187.36Z" fill="#1868DB"/>
<path d="M1956.63 392.322L2067.8 363.764L2103.25 229.834L2021.88 185.761L1956.63 392.322Z" fill="#82B536"/>
<path d="M1814.81 214.821C1777.79 204.861 1754.37 195.571 1741.02 184.518L1735.75 299.502C1749.51 304.079 1764.42 308.373 1780.76 312.342C1816.54 322.129 1838.14 331.724 1849.86 343.657L1855.25 225.91C1842.76 221.962 1829.36 218.25 1814.81 214.821Z" fill="#FCA700"/>
<path d="M1717.71 131.43L1767.34 121.105L1788.77 77.5333L1765.89 33.5097L1715.9 22.1945L1676.46 52.1123L1677.27 100.718L1717.71 131.43Z" fill="#82B536"/>
<path d="M2287.3 0.329368C2292.26 17.6796 2294.03 36.6867 2292.33 57.0839C2290.62 77.481 2285.46 97.5178 2277.28 114.391L2410.19 125.941C2414.99 107.988 2418.26 88.9353 2419.94 68.8981C2421.61 48.8609 2421.63 30.0094 2420.04 11.8036L2287.25 0.264012L2287.3 0.329368Z" fill="#82B536"/>
<path d="M2732.21 188.352C2731.07 192.109 2730.22 196.176 2729.74 200.467C2729.26 204.759 2729.16 209.049 2729.49 213.022C2731.28 236.704 2746.68 252.942 2770.15 259.359C2774.14 260.46 2778.41 261.273 2782.85 261.786C2787.29 262.299 2791.96 262.473 2796.29 262.331C2820.59 261.339 2839.19 249.028 2846.17 226.497C2847.37 222.7 2848.22 218.588 2848.72 214.207C2849.21 209.825 2849.28 205.76 2848.99 201.838C2847.18 178.337 2831.78 162.098 2808.32 155.546C2804.15 154.377 2799.74 153.548 2795.11 153.013C2790.48 152.478 2786.38 152.326 2782.2 152.484C2757.91 153.385 2739.25 165.736 2732.31 188.363L2732.21 188.352Z" fill="#82B536"/>
<path d="M2889.07 147.28C2915.86 136.154 2934.18 130.899 2947.27 131.344L2897.58 60.2224C2887.23 63.8352 2876.31 68.1465 2864.68 73.3134C2838.72 83.9714 2821.36 88.1994 2808.84 86.4762L2859.72 159.306C2869.02 155.908 2878.77 151.943 2889.07 147.28Z" fill="#BF63F3"/>
<path d="M1500.61 92.78C1499.48 96.4691 1498.65 100.462 1498.18 104.676C1497.71 108.89 1497.62 113.103 1497.94 117.004C1499.7 140.257 1514.82 156.202 1537.86 162.503C1541.78 163.584 1545.97 164.382 1550.33 164.886C1554.69 165.39 1559.28 165.56 1563.52 165.421C1587.38 164.447 1605.65 152.359 1612.51 130.235C1613.69 126.507 1614.52 122.47 1615 118.167C1615.49 113.864 1615.56 109.873 1615.27 106.022C1613.5 82.9459 1598.37 67.0012 1575.34 60.5673C1571.24 59.4199 1566.92 58.6058 1562.37 58.0804C1557.82 57.5551 1553.8 57.4053 1549.7 57.5605C1525.84 58.4455 1507.52 70.573 1500.7 92.7908L1500.61 92.78Z" fill="#FCA700"/>
<path d="M2476.23 171.901L2512.57 187.615L2580.4 132.718L2540.7 72.2981L2469.59 84.8102L2476.23 171.901Z" fill="#FCA700"/>
<path d="M1590.18 276.392C1581.18 284.413 1582.82 297.295 1599.18 315.611C1600.94 317.584 1603.22 319.181 1604.98 321.154L1565.44 356.405C1561.81 353.394 1557.79 348.885 1552.5 342.967C1511.68 297.27 1513.72 256.222 1543.27 229.879C1565.29 210.248 1585.75 208.965 1606.41 210.958C1621.55 211.808 1632.33 212.828 1640.38 205.651C1649.37 197.63 1647.78 184.796 1631.38 166.432L1625.63 159.998L1664.69 125.169C1668.74 128.65 1672.77 133.158 1677.63 138.606C1718.87 184.774 1717.35 225.357 1687.28 252.165C1665.26 271.796 1644.39 272.609 1624.1 271.038C1609.01 270.236 1598.18 269.168 1590.13 276.345L1590.18 276.392Z" fill="#BF63F3"/>
<path d="M2627.7 309.01L2674.17 285.958L2684.11 237.19L2650.04 199.408L2597.6 201.079L2566.29 240.945L2579.68 288.97L2627.7 309.01Z" fill="#1868DB"/>
<path d="M2872.12 290.73C2867.27 321.394 2860.18 348.844 2852.92 371.879L2952.23 418.074C2962.37 387.895 2972.61 350.569 2979.35 307.997C2986.08 265.424 2987.84 226.732 2987.52 194.869L2878.89 207.578C2878.69 231.751 2876.97 260.066 2872.12 290.73Z" fill="#1868DB"/>
<path d="M2029.07 76.709L2081.8 60.3305C2094.17 97.6481 2111.48 109.727 2137.85 101.538C2164.21 93.3484 2172.04 73.4588 2160.83 35.7799L2213.56 19.4014C2237.02 93.7899 2213.37 132.978 2153.67 151.525C2093.96 170.071 2052.58 151.08 2029.12 76.6918L2029.07 76.709Z" fill="#1868DB"/>
<path d="M3183.71 263.373L3218.75 257.454C3262.92 249.994 3285.29 225.656 3295.17 194.436C3275.45 168.157 3246.29 152.584 3202.18 160.035L3140.03 170.531L3156.62 268.008L3183.67 263.44L3183.71 263.373Z" fill="#82B536"/>
<path d="M3507.45 240.161L3557.25 236.478L3583.87 196.676L3567.29 150.712L3519.96 133.206L3477.54 157.345L3471.98 204.936L3507.45 240.161Z" fill="#FCA700"/>
<path d="M3409.05 183.497L3432.31 152.723L3395.5 75.4747L3328.88 98.91L3324.57 169.298L3409.05 183.497Z" fill="#BF63F3"/>
<path d="M3096.28 193.6L3071.36 147.313L2999.69 124.541L3013.98 207.767L3075.67 265.657L3096.28 193.6Z" fill="#FCA700"/>
<path d="M3604.18 274.336L3620.24 305.08C3640.49 343.822 3667.68 358.475 3696.55 359.996C3711.89 335.532 3715.4 304.987 3695.17 266.29L3666.68 211.774L3591.71 250.587L3604.11 274.315L3604.18 274.336Z" fill="#1868DB"/>
<path d="M3419.15 246.402C3387.51 238.086 3359.1 229.101 3335.23 220.826L3290.48 267.987C3321.77 279.173 3360.41 291.729 3404.34 303.274C3448.28 314.818 3488.09 322.876 3520.82 328.514L3504.79 265.379C3479.94 260.853 3450.8 254.717 3419.15 246.402Z" fill="#1868DB"/>
<path d="M3194.92 119.479C3224.2 117.038 3243.38 117.413 3255.57 121.325L3234.28 46.2045C3223.2 46.5499 3211.35 47.3509 3198.52 48.703C3170.19 50.9595 3152.29 49.9514 3141.1 45.084L3162.9 122.009C3172.9 121.566 3183.52 120.75 3194.92 119.479Z" fill="#1868DB"/>
<path d="M1080.67 276.053C1089.16 285.428 1102.4 283.893 1120.89 267.24C1122.88 265.447 1124.47 263.118 1126.46 261.324L1163.76 302.525C1160.75 306.228 1156.2 310.327 1150.22 315.707C1104.1 357.253 1061.73 354.658 1033.86 323.868C1013.08 300.924 1011.27 279.808 1012.82 258.521C1013.33 242.923 1014.12 231.819 1006.53 223.431C998.038 214.056 984.845 215.548 966.31 232.244L959.816 238.093L922.961 197.386C926.452 193.256 931.003 189.157 936.501 184.204C983.099 142.231 1024.98 144.284 1053.34 175.616C1074.12 198.56 1075.46 220.103 1074.33 241.006C1073.87 256.561 1073.03 267.708 1080.63 276.096L1080.67 276.053Z" fill="#82B536"/>
<path d="M625.543 193.797C639.63 192.301 654.593 193.486 670.188 197.54C685.782 201.593 700.654 208.263 712.683 216.849L738.712 115.795C725.409 109.683 711.058 104.601 695.739 100.619C680.42 96.6367 665.808 94.0903 651.489 92.8723L625.485 193.832L625.543 193.797Z" fill="#BF63F3"/>
<path d="M1266.86 164.218L1230.53 158.808L1182.68 226.256L1232.61 271.992L1293.45 242.75L1266.86 164.218Z" fill="#FCA700"/>
<path d="M399.069 336.98L422.334 306.205L385.52 228.958L318.902 252.393L314.592 322.781L399.069 336.98Z" fill="#BF63F3"/>
<path d="M388.137 121.823C385.928 124.444 383.843 127.412 381.957 130.678C380.072 133.944 378.484 137.337 377.334 140.615C370.355 160.102 376.477 178.123 392.278 190.959C394.96 193.149 397.955 195.199 401.193 197.068C404.431 198.938 407.967 200.612 411.344 201.92C430.4 209.118 449.068 205.41 462.395 189.725C464.659 187.09 466.763 184.087 468.689 180.752C470.614 177.418 472.102 174.197 473.267 170.973C480.168 151.624 474.045 133.603 458.303 120.664C455.502 118.359 452.403 116.249 449.026 114.299C445.649 112.349 442.55 110.881 439.278 109.634C420.261 102.367 401.539 106.09 388.207 121.863L388.137 121.823Z" fill="#1868DB"/>
<path d="M870.565 66.6285C825.409 85.0438 796.327 68.0356 786.485 60.4931L779.735 147.42C788.749 154.5 814.346 168.867 858.558 150.836C900.496 133.738 928.568 147.188 940.25 155.228L947.002 68.2839C936.315 60.9356 911.368 49.9809 870.565 66.6285Z" fill="#1868DB"/>
<path d="M743.463 217.247C740.532 228.564 734.449 235.337 724.723 239.407C714.173 243.821 704.241 242.98 695.082 237.49L605.16 275.114C646.399 339.254 703.508 358.315 762.522 333.623C817.497 310.622 843.195 267.293 832.726 179.9L743.381 217.282L743.463 217.247Z" fill="#1868DB"/>
<path d="M449.631 271.59L560.8 243.032L596.253 109.102L514.879 65.0287L449.631 271.59Z" fill="#82B536"/>
<path d="M307.812 94.0893C270.79 84.1287 247.365 74.8387 234.016 63.7859L228.75 178.77C242.51 183.347 257.418 187.641 273.761 191.61C309.542 201.397 331.135 210.992 342.854 222.925L348.246 105.178C335.764 101.23 322.362 97.5184 307.812 94.0893Z" fill="#FCA700"/>
<path d="M1225.21 67.6199C1224.07 71.377 1223.22 75.4437 1222.74 79.7352C1222.26 84.0267 1222.16 88.3172 1222.49 92.2903C1224.28 115.972 1239.68 132.21 1263.15 138.627C1267.14 139.728 1271.41 140.541 1275.85 141.054C1280.29 141.567 1284.96 141.741 1289.29 141.599C1313.59 140.607 1332.19 128.296 1339.17 105.765C1340.37 101.968 1341.22 97.8564 1341.72 93.4746C1342.21 89.0927 1342.28 85.0281 1341.99 81.1056C1340.18 57.6047 1324.78 41.3663 1301.32 34.8139C1297.15 33.6454 1292.74 32.8162 1288.11 32.2812C1283.48 31.7462 1279.38 31.5936 1275.2 31.7517C1250.91 32.653 1232.25 45.0039 1225.31 67.631L1225.21 67.6199Z" fill="#82B536"/>
<path d="M83.1762 155.66C74.1789 163.681 75.8177 176.563 92.1789 194.879C93.9408 196.852 96.2182 198.449 97.9802 200.422L58.4398 235.673C54.8145 232.662 50.7872 228.153 45.5013 222.235C4.68234 176.538 6.72077 135.49 36.2695 109.147C58.289 89.5158 78.7491 88.2328 99.414 90.2263C114.549 91.0758 125.328 92.0964 133.378 84.9196C142.375 76.8983 140.778 64.064 124.375 45.7004L118.628 39.2661L157.695 4.43712C161.739 7.91785 165.767 12.4265 170.633 17.8745C211.872 64.0418 210.354 104.625 180.284 131.433C158.265 151.064 137.385 151.877 117.098 150.306C102.005 149.504 91.1843 148.436 83.1342 155.613L83.1762 155.66Z" fill="#BF63F3"/>
<path d="M1120.7 188.278L1167.17 165.226L1177.11 116.458L1143.04 78.6759L1090.6 80.3475L1059.29 120.213L1072.68 168.238L1120.7 188.278Z" fill="#1868DB"/>
<path d="M1365.12 169.998C1360.27 200.662 1353.18 228.112 1345.92 251.147L1445.23 297.342C1455.37 267.164 1465.61 229.838 1472.35 187.265C1479.08 144.692 1480.84 106 1480.52 74.1372L1371.89 86.8457C1371.69 111.019 1369.97 139.334 1365.12 169.998Z" fill="#1868DB"/>
<path d="M184.943 272.962C214.22 270.521 233.398 270.896 245.587 274.808L224.294 199.687C213.221 200.033 201.37 200.834 188.539 202.186C160.208 204.442 142.304 203.434 131.116 198.567L152.92 275.492C162.921 275.048 173.542 274.233 184.943 272.962Z" fill="#1868DB"/>
</g>
<defs>
<clipPath id="clip0_1461_26831">
<rect width="3597" height="220" fill="white"/>
</clipPath>
</defs>
</svg>
`;
const $24c02ea0e14dbe4f$var$$795b38850428b3a7$export$f3cfc44c4eba4576 = `data:image/svg+xml;base64,${$24c02ea0e14dbe4f$var$$795b38850428b3a7$require$Buffer.from($24c02ea0e14dbe4f$var$$795b38850428b3a7$var$svgStringDesktopFooterWider).toString("base64")}`;
const $24c02ea0e14dbe4f$var$$795b38850428b3a7$var$svgStringDesktopFooterWide = `<svg width="3305" height="220" viewBox="0 0 3305 220" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_1461_26940)">
<path d="M2132.54 314.529C2146.63 313.033 2161.59 314.218 2177.19 318.272C2192.78 322.325 2207.65 328.995 2219.68 337.581L2245.71 236.527C2232.41 230.415 2218.06 225.333 2202.74 221.351C2187.42 217.369 2172.81 214.822 2158.49 213.604L2132.48 314.564L2132.54 314.529Z" fill="#BF63F3"/>
<path d="M1905.63 13.0095L1932.77 57.7351C1902.11 76.8306 1895.31 95.1589 1908.88 117.522C1922.45 139.884 1942.19 142.885 1973.45 124.776L2000.59 169.502C1939.18 206.46 1898.36 193.057 1867.63 142.412C1836.9 91.7667 1844.25 50.0145 1905.66 13.0565L1905.63 13.0095Z" fill="#BF63F3"/>
<path d="M2653.64 67.1608C2651.12 70.158 2648.74 73.5509 2646.59 77.2837C2644.43 81.0165 2642.62 84.8928 2641.3 88.6374C2633.3 110.896 2640.22 131.445 2658.16 146.049C2661.21 148.541 2664.61 150.872 2668.29 152.996C2671.97 155.121 2675.99 157.022 2679.83 158.505C2701.49 166.665 2722.75 162.381 2737.96 144.444C2740.54 141.43 2742.94 137.998 2745.14 134.187C2747.35 130.375 2749.05 126.695 2750.38 123.013C2758.29 100.911 2751.37 80.3628 2733.5 65.6405C2730.31 63.0181 2726.79 60.6186 2722.96 58.4028C2719.12 56.187 2715.6 54.5204 2711.88 53.1059C2690.25 44.8669 2668.94 49.1675 2653.72 67.2065L2653.64 67.1608Z" fill="#FCA700"/>
<path d="M1895.14 242.555C1892.93 245.176 1890.84 248.144 1888.96 251.41C1887.07 254.676 1885.48 258.069 1884.33 261.347C1877.35 280.834 1883.48 298.855 1899.28 311.691C1901.96 313.881 1904.95 315.93 1908.19 317.8C1911.43 319.669 1914.97 321.344 1918.34 322.652C1937.4 329.85 1956.07 326.142 1969.39 310.457C1971.66 307.822 1973.76 304.819 1975.69 301.484C1977.61 298.149 1979.1 294.929 1980.27 291.705C1987.17 272.356 1981.05 254.335 1965.3 241.396C1962.5 239.091 1959.4 236.981 1956.03 235.031C1952.65 233.081 1949.55 231.613 1946.28 230.365C1927.26 223.099 1908.54 226.821 1895.21 242.595L1895.14 242.555Z" fill="#1868DB"/>
<path d="M2377.56 187.36C2332.41 205.776 2303.33 188.768 2293.49 181.225L2286.73 268.152C2295.75 275.232 2321.35 289.599 2365.56 271.568C2407.5 254.47 2435.57 267.92 2447.25 275.96L2454 189.016C2443.32 181.668 2418.37 170.713 2377.56 187.36Z" fill="#1868DB"/>
<path d="M1956.63 392.322L2067.8 363.764L2103.25 229.834L2021.88 185.761L1956.63 392.322Z" fill="#82B536"/>
<path d="M1814.81 214.821C1777.79 204.861 1754.37 195.571 1741.02 184.518L1735.75 299.502C1749.51 304.079 1764.42 308.373 1780.76 312.342C1816.54 322.129 1838.14 331.724 1849.86 343.657L1855.25 225.91C1842.76 221.962 1829.36 218.25 1814.81 214.821Z" fill="#FCA700"/>
<path d="M1717.71 131.43L1767.34 121.105L1788.77 77.5333L1765.89 33.5097L1715.9 22.1945L1676.46 52.1123L1677.27 100.718L1717.71 131.43Z" fill="#82B536"/>
<path d="M2287.3 0.329368C2292.26 17.6796 2294.03 36.6867 2292.33 57.0839C2290.62 77.481 2285.46 97.5178 2277.28 114.391L2410.19 125.941C2414.99 107.988 2418.26 88.9353 2419.94 68.8981C2421.61 48.8609 2421.63 30.0094 2420.04 11.8036L2287.25 0.264012L2287.3 0.329368Z" fill="#82B536"/>
<path d="M2732.21 188.352C2731.07 192.109 2730.22 196.176 2729.74 200.467C2729.26 204.759 2729.16 209.049 2729.49 213.022C2731.28 236.704 2746.68 252.942 2770.15 259.359C2774.14 260.46 2778.41 261.273 2782.85 261.786C2787.29 262.299 2791.96 262.473 2796.29 262.331C2820.59 261.339 2839.19 249.028 2846.17 226.497C2847.37 222.7 2848.22 218.588 2848.72 214.207C2849.21 209.825 2849.28 205.76 2848.99 201.838C2847.18 178.337 2831.78 162.098 2808.32 155.546C2804.15 154.377 2799.74 153.548 2795.11 153.013C2790.48 152.478 2786.38 152.326 2782.2 152.484C2757.91 153.385 2739.25 165.736 2732.31 188.363L2732.21 188.352Z" fill="#82B536"/>
<path d="M2889.07 147.28C2915.86 136.154 2934.18 130.899 2947.27 131.344L2897.58 60.2224C2887.23 63.8352 2876.31 68.1465 2864.68 73.3134C2838.72 83.9714 2821.36 88.1994 2808.84 86.4762L2859.72 159.306C2869.02 155.908 2878.77 151.943 2889.07 147.28Z" fill="#BF63F3"/>
<path d="M1500.61 92.78C1499.48 96.4691 1498.65 100.462 1498.18 104.676C1497.71 108.89 1497.62 113.103 1497.94 117.004C1499.7 140.257 1514.82 156.202 1537.86 162.503C1541.78 163.584 1545.97 164.382 1550.33 164.886C1554.69 165.39 1559.28 165.56 1563.52 165.421C1587.38 164.447 1605.65 152.359 1612.51 130.235C1613.69 126.507 1614.52 122.47 1615 118.167C1615.49 113.864 1615.56 109.873 1615.27 106.022C1613.5 82.9459 1598.37 67.0012 1575.34 60.5673C1571.24 59.4199 1566.92 58.6058 1562.37 58.0804C1557.82 57.5551 1553.8 57.4053 1549.7 57.5605C1525.84 58.4455 1507.52 70.573 1500.7 92.7908L1500.61 92.78Z" fill="#FCA700"/>
<path d="M2476.23 171.901L2512.57 187.615L2580.4 132.718L2540.7 72.2981L2469.59 84.8102L2476.23 171.901Z" fill="#FCA700"/>
<path d="M1590.18 276.392C1581.18 284.413 1582.82 297.295 1599.18 315.611C1600.94 317.584 1603.22 319.181 1604.98 321.154L1565.44 356.405C1561.81 353.394 1557.79 348.885 1552.5 342.967C1511.68 297.27 1513.72 256.222 1543.27 229.879C1565.29 210.248 1585.75 208.965 1606.41 210.958C1621.55 211.808 1632.33 212.828 1640.38 205.651C1649.37 197.63 1647.78 184.796 1631.38 166.432L1625.63 159.998L1664.69 125.169C1668.74 128.65 1672.77 133.158 1677.63 138.606C1718.87 184.774 1717.35 225.357 1687.28 252.165C1665.26 271.796 1644.39 272.609 1624.1 271.038C1609.01 270.236 1598.18 269.168 1590.13 276.345L1590.18 276.392Z" fill="#BF63F3"/>
<path d="M2627.7 309.01L2674.17 285.958L2684.11 237.19L2650.04 199.408L2597.6 201.079L2566.29 240.945L2579.68 288.97L2627.7 309.01Z" fill="#1868DB"/>
<path d="M2872.12 290.73C2867.27 321.394 2860.18 348.844 2852.92 371.879L2952.23 418.074C2962.37 387.895 2972.61 350.569 2979.35 307.997C2986.08 265.424 2987.84 226.732 2987.52 194.869L2878.89 207.578C2878.69 231.751 2876.97 260.066 2872.12 290.73Z" fill="#1868DB"/>
<path d="M2029.07 76.709L2081.8 60.3305C2094.17 97.6481 2111.48 109.727 2137.85 101.538C2164.21 93.3484 2172.04 73.4588 2160.83 35.7799L2213.56 19.4014C2237.02 93.7899 2213.37 132.978 2153.67 151.525C2093.96 170.071 2052.58 151.08 2029.12 76.6918L2029.07 76.709Z" fill="#1868DB"/>
<path d="M3183.71 263.373L3218.75 257.454C3262.92 249.994 3285.29 225.656 3295.17 194.436C3275.45 168.157 3246.29 152.584 3202.18 160.035L3140.03 170.531L3156.62 268.008L3183.67 263.44L3183.71 263.373Z" fill="#82B536"/>
<path d="M3409.05 183.497L3432.31 152.723L3395.5 75.4747L3328.88 98.91L3324.57 169.298L3409.05 183.497Z" fill="#BF63F3"/>
<path d="M3096.28 193.6L3071.36 147.313L2999.69 124.541L3013.98 207.767L3075.67 265.657L3096.28 193.6Z" fill="#FCA700"/>
<path d="M3419.15 246.402C3387.51 238.086 3359.1 229.101 3335.23 220.826L3290.48 267.987C3321.77 279.173 3360.41 291.729 3404.34 303.274C3448.28 314.818 3488.09 322.876 3520.82 328.514L3504.79 265.379C3479.94 260.853 3450.8 254.717 3419.15 246.402Z" fill="#1868DB"/>
<path d="M3194.92 119.479C3224.2 117.038 3243.38 117.413 3255.57 121.325L3234.28 46.2045C3223.2 46.5499 3211.35 47.3509 3198.52 48.703C3170.19 50.9595 3152.29 49.9514 3141.1 45.084L3162.9 122.009C3172.9 121.566 3183.52 120.75 3194.92 119.479Z" fill="#1868DB"/>
<path d="M1080.67 276.053C1089.16 285.428 1102.4 283.893 1120.89 267.24C1122.88 265.447 1124.47 263.118 1126.46 261.324L1163.76 302.525C1160.75 306.228 1156.2 310.327 1150.22 315.707C1104.1 357.253 1061.73 354.658 1033.86 323.868C1013.08 300.924 1011.27 279.808 1012.82 258.521C1013.33 242.923 1014.12 231.819 1006.53 223.431C998.038 214.056 984.845 215.548 966.31 232.244L959.816 238.093L922.961 197.386C926.452 193.256 931.003 189.157 936.501 184.204C983.099 142.231 1024.98 144.284 1053.34 175.616C1074.12 198.56 1075.46 220.103 1074.33 241.006C1073.87 256.561 1073.03 267.708 1080.63 276.096L1080.67 276.053Z" fill="#82B536"/>
<path d="M625.543 193.797C639.63 192.301 654.593 193.486 670.188 197.54C685.782 201.593 700.654 208.263 712.683 216.849L738.712 115.795C725.409 109.683 711.058 104.601 695.739 100.619C680.42 96.6367 665.808 94.0903 651.489 92.8723L625.485 193.832L625.543 193.797Z" fill="#BF63F3"/>
<path d="M1266.86 164.218L1230.53 158.808L1182.68 226.256L1232.61 271.992L1293.45 242.75L1266.86 164.218Z" fill="#FCA700"/>
<path d="M399.069 336.98L422.334 306.205L385.52 228.958L318.902 252.393L314.592 322.781L399.069 336.98Z" fill="#BF63F3"/>
<path d="M388.137 121.823C385.928 124.444 383.843 127.412 381.957 130.678C380.072 133.944 378.484 137.337 377.334 140.615C370.355 160.102 376.477 178.123 392.278 190.959C394.96 193.149 397.955 195.199 401.193 197.068C404.431 198.938 407.967 200.612 411.344 201.92C430.4 209.118 449.068 205.41 462.395 189.725C464.659 187.09 466.763 184.087 468.689 180.752C470.614 177.418 472.102 174.197 473.267 170.973C480.168 151.624 474.045 133.603 458.303 120.664C455.502 118.359 452.403 116.249 449.026 114.299C445.649 112.349 442.55 110.881 439.278 109.634C420.261 102.367 401.539 106.09 388.207 121.863L388.137 121.823Z" fill="#1868DB"/>
<path d="M870.565 66.6285C825.409 85.0438 796.327 68.0356 786.485 60.4931L779.735 147.42C788.749 154.5 814.346 168.867 858.558 150.836C900.496 133.738 928.568 147.188 940.25 155.228L947.002 68.2839C936.315 60.9356 911.368 49.9809 870.565 66.6285Z" fill="#1868DB"/>
<path d="M743.463 217.247C740.532 228.564 734.449 235.337 724.723 239.407C714.173 243.821 704.241 242.98 695.082 237.49L605.16 275.114C646.399 339.254 703.508 358.315 762.522 333.623C817.497 310.622 843.195 267.293 832.726 179.9L743.381 217.282L743.463 217.247Z" fill="#1868DB"/>
<path d="M449.631 271.59L560.8 243.032L596.253 109.102L514.879 65.0287L449.631 271.59Z" fill="#82B536"/>
<path d="M307.812 94.0893C270.79 84.1287 247.365 74.8387 234.016 63.7859L228.75 178.77C242.51 183.347 257.418 187.641 273.761 191.61C309.542 201.397 331.135 210.992 342.854 222.925L348.246 105.178C335.764 101.23 322.362 97.5184 307.812 94.0893Z" fill="#FCA700"/>
<path d="M1225.21 67.6199C1224.07 71.377 1223.22 75.4437 1222.74 79.7352C1222.26 84.0267 1222.16 88.3172 1222.49 92.2903C1224.28 115.972 1239.68 132.21 1263.15 138.627C1267.14 139.728 1271.41 140.541 1275.85 141.054C1280.29 141.567 1284.96 141.741 1289.29 141.599C1313.59 140.607 1332.19 128.296 1339.17 105.765C1340.37 101.968 1341.22 97.8564 1341.72 93.4746C1342.21 89.0927 1342.28 85.0281 1341.99 81.1056C1340.18 57.6047 1324.78 41.3663 1301.32 34.8139C1297.15 33.6454 1292.74 32.8162 1288.11 32.2812C1283.48 31.7462 1279.38 31.5936 1275.2 31.7517C1250.91 32.653 1232.25 45.0039 1225.31 67.631L1225.21 67.6199Z" fill="#82B536"/>
<path d="M83.1762 155.66C74.1789 163.681 75.8177 176.563 92.1789 194.879C93.9408 196.852 96.2182 198.449 97.9802 200.422L58.4398 235.673C54.8145 232.662 50.7872 228.153 45.5013 222.235C4.68234 176.538 6.72077 135.49 36.2695 109.147C58.289 89.5158 78.7491 88.2328 99.414 90.2263C114.549 91.0758 125.328 92.0964 133.378 84.9196C142.375 76.8983 140.778 64.064 124.375 45.7004L118.628 39.2661L157.695 4.43712C161.739 7.91785 165.767 12.4265 170.633 17.8745C211.872 64.0418 210.354 104.625 180.284 131.433C158.265 151.064 137.385 151.877 117.098 150.306C102.005 149.504 91.1843 148.436 83.1342 155.613L83.1762 155.66Z" fill="#BF63F3"/>
<path d="M1120.7 188.278L1167.17 165.226L1177.11 116.458L1143.04 78.6759L1090.6 80.3475L1059.29 120.213L1072.68 168.238L1120.7 188.278Z" fill="#1868DB"/>
<path d="M1365.12 169.998C1360.27 200.662 1353.18 228.112 1345.92 251.147L1445.23 297.342C1455.37 267.164 1465.61 229.838 1472.35 187.265C1479.08 144.692 1480.84 106 1480.52 74.1372L1371.89 86.8457C1371.69 111.019 1369.97 139.334 1365.12 169.998Z" fill="#1868DB"/>
<path d="M184.943 272.962C214.22 270.521 233.398 270.896 245.587 274.808L224.294 199.687C213.221 200.033 201.37 200.834 188.539 202.186C160.208 204.442 142.304 203.434 131.116 198.567L152.92 275.492C162.921 275.048 173.542 274.233 184.943 272.962Z" fill="#1868DB"/>
</g>
<defs>
<clipPath id="clip0_1461_26940">
<rect width="3305" height="220" fill="white"/>
</clipPath>
</defs>
</svg>
`;
const $24c02ea0e14dbe4f$var$$795b38850428b3a7$export$7d22dc8c5b0cc81c = `data:image/svg+xml;base64,${$24c02ea0e14dbe4f$var$$795b38850428b3a7$require$Buffer.from($24c02ea0e14dbe4f$var$$795b38850428b3a7$var$svgStringDesktopFooterWide).toString("base64")}`;
const $24c02ea0e14dbe4f$var$$795b38850428b3a7$var$svgStringMobileFooter = `<svg width="907" height="139" viewBox="0 0 907 139" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_1421_26676" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="907" height="139">
<rect width="907" height="138.569" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_1421_26676)">
<path d="M395.637 190.948C403.967 189.968 412.814 190.744 422.035 193.4C431.255 196.056 440.048 200.427 447.161 206.052L462.551 139.842C454.685 135.837 446.2 132.507 437.142 129.898C428.085 127.289 419.445 125.62 410.979 124.822L395.603 190.971L395.637 190.948Z" fill="#BF63F3"/>
<path d="M261.469 -6.60718L277.516 22.697C259.386 35.2084 255.368 47.2171 263.392 61.8691C271.415 76.5212 283.086 78.4874 301.57 66.6224L317.617 95.9265C281.308 120.141 257.173 111.36 239.002 78.1771C220.831 44.9945 225.177 17.6384 261.486 -6.57639L261.469 -6.60718Z" fill="#BF63F3"/>
<path d="M703.749 28.8725C702.258 30.8363 700.85 33.0593 699.576 35.505C698.302 37.9507 697.228 40.4904 696.449 42.9439C691.72 57.5278 695.81 70.9912 706.42 80.56C708.221 82.1926 710.233 83.7199 712.408 85.1118C714.584 86.5037 716.96 87.7495 719.23 88.7212C732.041 94.0679 744.608 91.2609 753.601 79.5082C755.128 77.5337 756.55 75.2849 757.851 72.7877C759.152 70.2905 760.158 67.8795 760.948 65.4667C765.623 50.9859 761.533 37.5224 750.963 27.8764C749.082 26.1581 747 24.586 744.731 23.1342C742.462 21.6824 740.379 20.5905 738.179 19.6637C725.396 14.2655 712.792 17.0833 703.796 28.9024L703.749 28.8725Z" fill="#FCA700"/>
<path d="M255.266 143.791C253.96 145.508 252.727 147.453 251.612 149.593C250.497 151.733 249.559 153.956 248.879 156.104C244.752 168.871 248.372 180.679 257.715 189.089C259.3 190.524 261.071 191.867 262.985 193.092C264.9 194.316 266.991 195.414 268.987 196.271C280.255 200.986 291.293 198.557 299.172 188.28C300.511 186.554 301.755 184.587 302.894 182.402C304.032 180.217 304.912 178.106 305.601 175.994C309.681 163.316 306.061 151.509 296.753 143.031C295.097 141.521 293.265 140.139 291.268 138.861C289.271 137.584 287.439 136.622 285.504 135.804C274.26 131.044 263.19 133.482 255.307 143.817L255.266 143.791Z" fill="#1868DB"/>
<path d="M540.511 107.628C513.812 119.693 496.617 108.55 490.798 103.608L486.806 160.563C492.136 165.201 507.271 174.615 533.412 162.8C558.209 151.598 574.807 160.41 581.715 165.678L585.707 108.712C579.388 103.898 564.637 96.7202 540.511 107.628Z" fill="#1868DB"/>
<path d="M291.626 241.918L357.357 223.207L378.319 135.456L330.205 106.579L291.626 241.918Z" fill="#82B536"/>
<path d="M207.772 125.619C185.882 119.093 172.032 113.006 164.139 105.765L161.026 181.102C169.161 184.101 177.976 186.914 187.639 189.515C208.795 195.927 221.563 202.214 228.492 210.032L231.68 132.885C224.3 130.298 216.376 127.866 207.772 125.619Z" fill="#FCA700"/>
<path d="M150.358 70.9821L179.701 64.217L192.375 35.669L178.846 6.8247L149.287 -0.588974L125.967 19.0132L126.445 50.8598L150.358 70.9821Z" fill="#82B536"/>
<path d="M487.144 -14.9153C490.073 -3.54747 491.12 8.90597 490.112 22.2702C489.104 35.6344 486.055 48.7625 481.214 59.8175L559.804 67.3853C562.64 55.6224 564.574 43.1392 565.564 30.0109C566.554 16.8825 566.566 4.53097 565.627 -7.39742L487.11 -14.9582L487.144 -14.9153Z" fill="#82B536"/>
<path d="M750.205 108.277C749.527 110.739 749.028 113.403 748.743 116.215C748.458 119.027 748.402 121.838 748.596 124.441C749.655 139.957 758.761 150.597 772.638 154.801C774.997 155.523 777.517 156.055 780.143 156.391C782.77 156.727 785.533 156.841 788.088 156.748C802.457 156.099 813.458 148.032 817.586 133.27C818.296 130.782 818.798 128.088 819.089 125.217C819.38 122.346 819.421 119.683 819.252 117.113C818.181 101.715 809.075 91.0758 795.207 86.7827C792.738 86.0171 790.133 85.4738 787.394 85.1233C784.655 84.7727 782.233 84.6728 779.762 84.7763C765.4 85.3669 754.367 93.4592 750.262 108.284L750.205 108.277Z" fill="#82B536"/>
<path d="M842.951 81.367C858.788 74.077 869.621 70.6339 877.359 70.9258L847.983 24.3268C841.859 26.6939 835.405 29.5186 828.529 32.904C813.18 39.8871 802.914 42.6573 795.515 41.5283L825.596 89.2466C831.096 87.0197 836.858 84.4222 842.951 81.367Z" fill="#BF63F3"/>
<path d="M21.9939 45.6584C21.3276 48.0755 20.8378 50.6918 20.558 53.4527C20.2782 56.2137 20.2233 58.9739 20.4137 61.5301C21.454 76.7656 30.395 87.2126 44.021 91.3409C46.3368 92.0494 48.8118 92.5722 51.3906 92.9022C53.9694 93.2322 56.6827 93.3439 59.1918 93.2528C73.3009 92.6149 84.1031 84.6944 88.1561 70.199C88.853 67.7564 89.3458 65.111 89.6315 62.292C89.9171 59.4729 89.9574 56.8579 89.7918 54.3344C88.7397 39.2151 79.7987 28.7681 66.1814 24.5527C63.7577 23.8009 61.1995 23.2675 58.5098 22.9233C55.8201 22.5791 53.4424 22.4809 51.0165 22.5826C36.9134 23.1624 26.0805 31.1084 22.0493 45.6655L21.9939 45.6584Z" fill="#FCA700"/>
<path d="M598.85 97.498L620.339 107.794L660.44 71.8259L636.967 32.2385L594.924 40.4365L598.85 97.498Z" fill="#FCA700"/>
<path d="M74.9517 165.961C69.6319 171.216 70.6008 179.656 80.2747 191.657C81.3165 192.95 82.6631 193.996 83.7049 195.289L60.3258 218.385C58.1823 216.412 55.801 213.458 52.6756 209.581C28.5406 179.64 29.7458 152.746 47.2172 135.485C60.2366 122.623 72.3341 121.783 84.5526 123.089C93.5012 123.645 99.8746 124.314 104.634 119.612C109.954 114.356 109.01 105.947 99.3113 93.9154L95.9131 89.6996L119.012 66.8797C121.404 69.1603 123.785 72.1144 126.662 75.6839C151.045 105.933 150.148 132.523 132.369 150.087C119.349 162.95 107.004 163.482 95.0086 162.453C86.0848 161.927 79.6867 161.228 74.9268 165.93L74.9517 165.961Z" fill="#BF63F3"/>
<path d="M688.409 187.332L715.888 172.229L721.763 140.276L701.619 115.521L670.609 116.616L652.097 142.736L660.019 174.202L688.409 187.332Z" fill="#1868DB"/>
<path d="M832.929 175.355C830.063 195.446 825.869 213.432 821.573 228.524L880.295 258.791C886.287 239.018 892.347 214.562 896.327 186.668C900.306 158.775 901.351 133.424 901.158 112.547L836.93 120.874C836.813 136.712 835.795 155.264 832.929 175.355Z" fill="#1868DB"/>
<path d="M334.456 35.1284L365.632 24.3972C372.95 48.8477 383.184 56.7618 398.772 51.3962C414.36 46.0306 418.993 32.9989 412.363 8.3117L443.539 -2.41947C457.409 46.3198 443.431 71.9961 408.128 84.1476C372.826 96.2991 348.359 83.8565 334.489 35.1171L334.456 35.1284Z" fill="#1868DB"/>
</g>
</svg>
`;
const $24c02ea0e14dbe4f$var$$795b38850428b3a7$export$eca0cf64e1927e60 = `data:image/svg+xml;base64,${$24c02ea0e14dbe4f$var$$795b38850428b3a7$require$Buffer.from($24c02ea0e14dbe4f$var$$795b38850428b3a7$var$svgStringMobileFooter).toString("base64")}`;
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$aa27a9003cb13d3 = "@media (min-width: 768px) and (max-width: 1279px)";
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8 = "@media (max-width: 767px)";
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$77261562b77476b8 = "@media (min-width: 1280px)";
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$9f513872ee8f6246 = (0, $74Zh5.css)({
    width: "100%",
    backgroundImage: `url(${$24c02ea0e14dbe4f$var$$795b38850428b3a7$export$f3cfc44c4eba4576})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    paddingTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    paddingBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    boxSizing: "border-box",
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        backgroundImage: `url(${$24c02ea0e14dbe4f$var$$795b38850428b3a7$export$7d22dc8c5b0cc81c})`
    },
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        backgroundImage: `url(${$24c02ea0e14dbe4f$var$$795b38850428b3a7$export$eca0cf64e1927e60})`
    }
});
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$12bbd02e39f3a749 = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    justifyContent: "center",
    margin: "0 auto",
    maxWidth: "100%",
    fontFamily: "Inter, sans-serif",
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$77261562b77476b8]: {
        maxWidth: "1234px"
    },
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        maxWidth: "720px"
    },
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        paddingLeft: "20px",
        paddingRight: "20px"
    }
});
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$b3dee97a51489da1 = (0, $74Zh5.css)({
    borderRadius: "0px 0px 24px 24px",
    width: "100%",
    margin: "0 auto",
    backgroundColor: "#F8F8F8",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        padding: "0 16px"
    },
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        paddingLeft: "16px",
        paddingRight: "16px",
        paddingTop: "24px",
        textAlign: "left"
    }
});
const $24c02ea0e14dbe4f$export$a4c1071d1005664f = (0, $74Zh5.css)({
    display: "inline",
    fontSize: "12px",
    fontWeight: 400,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    textDecoration: "none",
    "&:hover": {
        textDecoration: "underline",
        textDecorationColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
        cursor: "pointer"
    }
});
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$76b9e543844e8a5 = (0, $74Zh5.css)({
    padding: "24px 24px",
    boxSizing: "border-box",
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        flexDirection: "column",
        alignItems: "flex-start"
    },
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        flexDirection: "column",
        alignItems: "flex-start",
        paddingTop: "0px",
        paddingBottom: "8px"
    }
});
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$313ce10a9f9c4472 = (0, $74Zh5.css)({
    width: "420px",
    display: "flex",
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        justifyContent: "flex-start",
        width: "120px"
    },
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        marginBottom: "16px",
        width: "120px"
    }
});
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$2bc3a170ad333299 = (0, $74Zh5.css)({
    svg: {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.brand"),
        transform: `scale(0.9)`
    },
    marginLeft: "24px",
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        marginLeft: "0",
        marginBottom: "8px"
    },
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        marginLeft: "0",
        paddingLeft: "0"
    }
});
const $24c02ea0e14dbe4f$export$220191dc35b80c46 = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    gap: "24px",
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        gap: "16px"
    },
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        width: "100%",
        flexDirection: "column",
        gap: "0"
    }
});
const $24c02ea0e14dbe4f$export$c5f2190049e47f52 = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "120px",
    textAlign: "left",
    gap: "12px",
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        width: "100%",
        marginBottom: "16px"
    }
});
const $24c02ea0e14dbe4f$export$5939e41228734fb7 = (0, $74Zh5.css)({
    marginBottom: "4px"
});
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$17633131d02ad451 = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    justifyContent: "center",
    boxSizing: "border-box",
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        padding: "0 0px"
    },
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        justifyContent: "flex-start",
        width: "100%",
        paddingLeft: "0",
        paddingRight: "0"
    }
});
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$140449594731c4c9 = (0, $74Zh5.css)({
    marginLeft: "0px",
    fontSize: "12px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle")
});
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$55e15b718251f123 = (0, $74Zh5.css)({
    width: "100%",
    maxWidth: "calc(100% - 48px)",
    paddingTop: "16px",
    paddingBottom: "24px",
    paddingLeft: "24px",
    paddingRight: "24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxSizing: "border-box",
    borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        paddingLeft: "0",
        paddingRight: "0"
    },
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        maxWidth: "100%",
        justifyContent: "flex-start",
        flexDirection: "column-reverse",
        alignItems: "flex-start",
        paddingLeft: "24px",
        paddingRight: "0"
    }
});
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$e635e766db488209 = (0, $74Zh5.css)({
    display: "inline",
    marginLeft: "32px",
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        marginLeft: "0"
    }
});
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$b814e32be8f9cc9e = (0, $74Zh5.css)({
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        width: "100%",
        textAlign: "left",
        marginTop: "0",
        marginBottom: "32px",
        gap: "12px"
    }
});
const $24c02ea0e14dbe4f$var$$5a3292f3bef31812$var$YEAR = new Date().getFullYear();
const $24c02ea0e14dbe4f$var$$5a3292f3bef31812$var$COPYRIGHT = `Copyright \xa9 ${$24c02ea0e14dbe4f$var$$5a3292f3bef31812$var$YEAR} Atlassian`;
const $24c02ea0e14dbe4f$export$e0513c91be1318ca = ({ href: href, onClick: onClick, text: text, styles: styles = [] })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        href: href,
        onClick: onClick,
        css: [
            $24c02ea0e14dbe4f$export$a4c1071d1005664f,
            ...styles
        ],
        children: text
    });
const $24c02ea0e14dbe4f$var$$5a3292f3bef31812$export$f769621e3a03739f = ({ termsUrl: termsUrl, nav: nav, reportAProblemCallback: reportAProblemCallback, licenseData: licenseData, policyLinkText: policyLinkText = "Notice at Collection", policyLinkHref: policyLinkHref = $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$6aafbda8e90312f0 })=>{
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const openModal = (0, $5FkrB.useCallback)(()=>setIsOpen(true), []);
    const closeModal = (0, $5FkrB.useCallback)(()=>setIsOpen(false), []);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$9f513872ee8f6246,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$12bbd02e39f3a749,
            children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$b3dee97a51489da1,
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$76b9e543844e8a5,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$313ce10a9f9c4472,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$2bc3a170ad333299,
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $37844134dd17fb96$export$8a485e2e7ed91e8f), {})
                                })
                            }),
                            nav
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$17633131d02ad451,
                        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$55e15b718251f123,
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                    css: $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$140449594731c4c9,
                                    children: $24c02ea0e14dbe4f$var$$5a3292f3bef31812$var$COPYRIGHT
                                }),
                                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                    css: $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$b814e32be8f9cc9e,
                                    children: [
                                        reportAProblemCallback && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e0513c91be1318ca, {
                                            onClick: reportAProblemCallback,
                                            text: "Report a problem",
                                            styles: [
                                                $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$e635e766db488209
                                            ]
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e0513c91be1318ca, {
                                            href: $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$30786e8ac20c09d8,
                                            text: "Privacy Policy",
                                            styles: [
                                                $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$e635e766db488209
                                            ]
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                            href: policyLinkHref,
                                            className: "atl-policy-link",
                                            css: $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$e635e766db488209,
                                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                                css: $24c02ea0e14dbe4f$export$a4c1071d1005664f,
                                                className: "atl-policy-link-text",
                                                children: policyLinkText
                                            })
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e0513c91be1318ca, {
                                            href: termsUrl,
                                            text: "Terms",
                                            styles: [
                                                $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$e635e766db488209
                                            ]
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e0513c91be1318ca, {
                                            href: $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$10bc455dcefd3f1f,
                                            text: "Security",
                                            styles: [
                                                $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$e635e766db488209
                                            ]
                                        }),
                                        licenseData && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                                            children: [
                                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e0513c91be1318ca, {
                                                    onClick: openModal,
                                                    text: "About",
                                                    styles: [
                                                        $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$e635e766db488209
                                                    ]
                                                }),
                                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $58963c306889e449$export$2e2bcd8739ae039), {
                                                    children: isOpen && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$bd0c6e28f5d6b66e, {
                                                        ...licenseData,
                                                        closeModal: closeModal
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const $24c02ea0e14dbe4f$var$$224bc56423ffe231$var$FORUMS_URL = $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$fe0105b4860d6e11[$24c02ea0e14dbe4f$export$93d048dc21eb282a.FORUMS];
const $24c02ea0e14dbe4f$var$$224bc56423ffe231$var$getForumsUrl = (url, isLoggedIn, email)=>isLoggedIn ? $24c02ea0e14dbe4f$var$$3dba2111a1a6d39b$export$1db7da00354b15ed({
        email: email,
        redirectUrl: url
    }) : url;
const $24c02ea0e14dbe4f$var$$224bc56423ffe231$var$ABOUT_LEARNING_URL = "https://community.atlassian.com/learning/hub/resources-and-support/about-atlassian-learning";
const $24c02ea0e14dbe4f$var$$224bc56423ffe231$var$RESOURCES_LEARNING_URL = "https://community.atlassian.com/learning/hub/resources-and-support";
const $24c02ea0e14dbe4f$var$$224bc56423ffe231$export$2680595b358b488a = ({ isLoggedIn: isLoggedIn = false, email: email })=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$export$220191dc35b80c46,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$export$c5f2190049e47f52,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$export$5939e41228734fb7,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                        href: "/",
                        css: $24c02ea0e14dbe4f$export$a4c1071d1005664f,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$71f050e2efa708bb, {
                            size: "medium",
                            fontWeight: "semibold",
                            children: "Community"
                        })
                    })
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$export$c5f2190049e47f52,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$export$5939e41228734fb7,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                            href: $24c02ea0e14dbe4f$var$$224bc56423ffe231$var$getForumsUrl($24c02ea0e14dbe4f$var$$224bc56423ffe231$var$FORUMS_URL, isLoggedIn, email),
                            css: $24c02ea0e14dbe4f$export$a4c1071d1005664f,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$71f050e2efa708bb, {
                                size: "medium",
                                fontWeight: "semibold",
                                children: "Forums"
                            })
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e0513c91be1318ca, {
                        href: $24c02ea0e14dbe4f$var$$224bc56423ffe231$var$getForumsUrl(`${$24c02ea0e14dbe4f$var$$224bc56423ffe231$var$FORUMS_URL}/help/faqpage`, isLoggedIn, email),
                        text: "FAQs"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e0513c91be1318ca, {
                        href: $24c02ea0e14dbe4f$var$$224bc56423ffe231$var$getForumsUrl(`${$24c02ea0e14dbe4f$var$$224bc56423ffe231$var$FORUMS_URL}/custom/page/page-id/rules-of-engagement`, isLoggedIn, email),
                        text: "Forums guidelines"
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$export$c5f2190049e47f52,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$export$5939e41228734fb7,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                            href: $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$fe0105b4860d6e11[$24c02ea0e14dbe4f$export$93d048dc21eb282a.LEARNING],
                            css: $24c02ea0e14dbe4f$export$a4c1071d1005664f,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$71f050e2efa708bb, {
                                size: "medium",
                                fontWeight: "semibold",
                                children: "Learning"
                            })
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e0513c91be1318ca, {
                        href: $24c02ea0e14dbe4f$var$$224bc56423ffe231$var$ABOUT_LEARNING_URL,
                        text: "About learning"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e0513c91be1318ca, {
                        href: $24c02ea0e14dbe4f$var$$224bc56423ffe231$var$RESOURCES_LEARNING_URL,
                        text: "Resources"
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$export$c5f2190049e47f52,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$export$5939e41228734fb7,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                        href: $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$fe0105b4860d6e11[$24c02ea0e14dbe4f$export$93d048dc21eb282a.EVENTS],
                        css: $24c02ea0e14dbe4f$export$a4c1071d1005664f,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$71f050e2efa708bb, {
                            size: "medium",
                            fontWeight: "semibold",
                            children: "Events"
                        })
                    })
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$export$c5f2190049e47f52,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$export$5939e41228734fb7,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                        href: $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$fe0105b4860d6e11[$24c02ea0e14dbe4f$export$93d048dc21eb282a.CHAMPIONS],
                        css: $24c02ea0e14dbe4f$export$a4c1071d1005664f,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$71f050e2efa708bb, {
                            size: "medium",
                            fontWeight: "semibold",
                            children: "Champions"
                        })
                    })
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$export$c5f2190049e47f52,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$export$5939e41228734fb7,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                        href: $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$fe0105b4860d6e11[$24c02ea0e14dbe4f$export$93d048dc21eb282a.APP_UPDATES],
                        css: $24c02ea0e14dbe4f$export$a4c1071d1005664f,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$71f050e2efa708bb, {
                            size: "medium",
                            fontWeight: "semibold",
                            children: "Release Notes"
                        })
                    })
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$export$7a92b4adf6bd95bb = ({ reportAProblemCallback: reportAProblemCallback, isLoggedIn: isLoggedIn = false, email: email, licenseData: licenseData, policyLinkText: policyLinkText, policyLinkHref: policyLinkHref })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$5a3292f3bef31812$export$f769621e3a03739f, {
        termsUrl: $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$bc6e44c7f1ae99f6,
        reportAProblemCallback: reportAProblemCallback,
        licenseData: licenseData,
        policyLinkText: policyLinkText,
        policyLinkHref: policyLinkHref,
        nav: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$224bc56423ffe231$export$2680595b358b488a, {
            isLoggedIn: isLoggedIn,
            email: email
        })
    });
const $24c02ea0e14dbe4f$export$8dce6dbf8ef18fcb = ({ termsUrl: termsUrl, nav: nav, reportAProblemCallback: reportAProblemCallback, licenseData: licenseData, policyLinkText: policyLinkText, policyLinkHref: policyLinkHref })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$5a3292f3bef31812$export$f769621e3a03739f, {
        termsUrl: termsUrl,
        nav: nav,
        reportAProblemCallback: reportAProblemCallback,
        licenseData: licenseData,
        policyLinkText: policyLinkText,
        policyLinkHref: policyLinkHref
    });
var $24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$export$7a92b4adf6bd95bb;
var $24c02ea0e14dbe4f$var$$77696804880d7cdc$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$77696804880d7cdc$exports, "DropdownMenu", ()=>$24c02ea0e14dbe4f$export$e44a253a59704894);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$77696804880d7cdc$exports, "DropdownMenuCheckbox", ()=>$24c02ea0e14dbe4f$export$2393c31da95977ae);
// Main DropdownMenu component (config-based with items object or custom items array)
const $24c02ea0e14dbe4f$var$$0199732cf5257721$export$e960b0f5cc4a2826 = ({ items: items, onItemClick: onItemClick })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $4efa9b4942c769d7$export$2e2bcd8739ae039), {
        id: "actions",
        children: Object.entries(items).map(([label, value])=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $9717609675842cd9$export$2e2bcd8739ae039), {
                testId: `dropdown-item-checkbox-${label}`,
                isDisabled: value.isDisabled,
                id: label,
                onClick: ()=>onItemClick(label),
                isSelected: value.isSelected,
                children: label
            }, label))
    });
};
const $24c02ea0e14dbe4f$var$$77e170ce1d4ab374$export$a6155c53cd00116c = ({ items: items, onItemClick: onItemClick })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $d7f1a7874207c75a$export$2e2bcd8739ae039), {
        id: "actions",
        children: Object.entries(items).map(([label, value])=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2f6caa8af3b1a588$export$2e2bcd8739ae039), {
                testId: `dropdown-item-checkbox-${label}`,
                isDisabled: value.isDisabled,
                id: label,
                onClick: ()=>onItemClick(label),
                isSelected: value.isSelected,
                children: label
            }, label))
    });
};
const $24c02ea0e14dbe4f$var$$0633f0dbed99c656$var$selectedItemStyles = (0, $74Zh5.css)({
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected.hovered"),
    fontWeight: 600
});
const $24c02ea0e14dbe4f$var$$0633f0dbed99c656$var$iconMenuStyles = (0, $74Zh5.css)({
    "& button > span": {
        gap: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} !important`
    },
    // Ensure icon and text are vertically aligned
    '& button [role="img"]': {
        display: "flex !important"
    }
});
const $24c02ea0e14dbe4f$var$$0633f0dbed99c656$export$efefb5b75235a614 = ({ items: items, onItemClick: onItemClick })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        id: "actions",
        css: $24c02ea0e14dbe4f$var$$0633f0dbed99c656$var$iconMenuStyles,
        children: Object.entries(items).map(([label, value])=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: value.isSelected && $24c02ea0e14dbe4f$var$$0633f0dbed99c656$var$selectedItemStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $896b4f3af893fddb$export$2e2bcd8739ae039), {
                    testId: `dropdown-item-${label}`,
                    isDisabled: value.isDisabled,
                    onClick: ()=>onItemClick(label),
                    elemBefore: value.icon,
                    children: label
                })
            }, label))
    });
};
const $24c02ea0e14dbe4f$var$$69215f50d6c9f1e0$export$2165c09f364cf0ee = (0, $74Zh5.css)({
    "& > button": {
        border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.brand")}`,
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`,
        background: "#fff",
        alignItems: "center",
        height: "40px",
        fontSize: "16px",
        lineHeight: "20px",
        fontWeight: 600,
        fontFamily: "Charlie Text, sans-serif",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
        borderRadius: "4px",
        ":hover": {
            background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected"),
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")
        }
    },
    svg: {
        width: "30px",
        height: "30px"
    }
});
const $24c02ea0e14dbe4f$var$$69215f50d6c9f1e0$export$a6df230d684a2658 = (0, $74Zh5.css)({
    "#actions": {
        "button[disabled]": {
            background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.disabled"),
            span: {
                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.disabled"),
                ":hover": {
                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.disabled")
                }
            },
            rect: {
                stroke: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.disabled")
            }
        },
        ":before, :after": {
            display: "none"
        },
        button: {
            padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} 24px`,
            width: "220px",
            height: "48px",
            '[aria-checked="true"]:before': {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: "2px",
                height: "100%",
                background: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")}`
            },
            span: {
                gap: 0,
                span: {
                    fontFamily: "Inter, sans-serif",
                    fontSize: "16px",
                    lineHeight: "20px"
                }
            }
        }
    }
});
const $24c02ea0e14dbe4f$var$$69215f50d6c9f1e0$export$e42df41f371072da = (0, $74Zh5.css)({
    "& > button": {
        border: 0,
        background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected")
    }
});
const $24c02ea0e14dbe4f$var$$69215f50d6c9f1e0$export$9ee5d5d0a4499fc5 = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    paddingRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$export$e44a253a59704894 = ({ items: items, placement: placement, onItemClick: onItemClick, customItems: customItems, isCheckboxMenu: isCheckboxMenu = false, triggerText: triggerText, customTriggerStyles: customTriggerStyles, customTriggerActiveStyles: customTriggerActiveStyles, customTriggerComponent: customTriggerComponent, isOptionMenu: isOptionMenu = false })=>{
    const [isDropdownOpen, setIsDropdownOpen] = (0, $5FkrB.useState)(false);
    const [itemsList, setItemList] = (0, $5FkrB.useState)(items ?? {});
    const isControlled = (0, $5FkrB.useRef)(false);
    const prevItemsRef = (0, $5FkrB.useRef)(items);
    // Check if we're using custom items mode
    const isCustomItemsMode = customItems && customItems.length > 0;
    (0, $5FkrB.useEffect)(()=>{
        if (!isCustomItemsMode && prevItemsRef.current !== items && items) {
            isControlled.current = true;
            setItemList(items);
            prevItemsRef.current = items;
        }
    }, [
        items,
        isCustomItemsMode
    ]);
    const handleItemClick = (label)=>{
        // Only update internal state if not controlled
        if (!isControlled.current) setItemList((prev)=>{
            const updatedState = {
                ...prev
            };
            if (isCheckboxMenu) updatedState[label].isSelected = !updatedState[label].isSelected;
            else Object.keys(updatedState).forEach((key)=>{
                updatedState[key].isSelected = key === label;
            });
            return updatedState;
        });
        if (onItemClick) onItemClick(label);
    };
    const getTriggerText = (itemsChecked)=>{
        const selectedItems = Object.keys(itemsChecked).filter((key)=>itemsChecked[key].isSelected);
        if (isCheckboxMenu) {
            if (triggerText) return triggerText;
            // For checkbox mode, show count of selected items or first item name
            if (selectedItems.length === 0) return Object.keys(itemsChecked)[0] || "Select items";
            else if (selectedItems.length === 1) return selectedItems[0];
            return `${selectedItems.length} selected`;
        }
        if (triggerText) return triggerText;
        // For radio mode, show the selected item or first item
        return selectedItems[0] || Object.keys(itemsChecked)[0];
    };
    const renderTrigger = ()=>{
        const selectedItems = Object.keys(itemsList).filter((key)=>itemsList[key]?.isSelected);
        // If custom trigger component is provided, use it
        if (customTriggerComponent) return customTriggerComponent;
        // For custom items mode, just use the triggerText
        if (isCustomItemsMode) return triggerText || "Menu";
        // If checkbox mode with custom trigger text and selections, render custom trigger with badge
        if (isCheckboxMenu && triggerText && selectedItems.length > 0) return ({ triggerRef: triggerRef, ...triggerButtonProps })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                ...triggerButtonProps,
                ref: triggerRef,
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
                    css: $24c02ea0e14dbe4f$var$$69215f50d6c9f1e0$export$9ee5d5d0a4499fc5,
                    children: [
                        triggerText,
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $31a965b6dd4a0db8$export$2e2bcd8739ae039), {
                            isBold: true,
                            appearance: "inprogress",
                            children: selectedItems.length
                        })
                    ]
                })
            });
        // Otherwise return the text trigger
        return getTriggerText(itemsList);
    };
    const hasAnyIcons = Object.values(itemsList).some((item)=>item?.icon);
    const isAnyItemSelected = isCustomItemsMode ? false : Object.values(itemsList).some(({ isSelected: isSelected })=>isSelected);
    const renderMenuContent = ()=>{
        // Custom items mode - render custom DropdownItems
        if (isCustomItemsMode && customItems) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
            children: customItems.map((item, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $896b4f3af893fddb$export$2e2bcd8739ae039), {
                    onClick: item.onClick,
                    isDisabled: item.isDisabled,
                    description: item.description,
                    elemBefore: item.elemBefore,
                    elemAfter: item.elemAfter,
                    testId: item.testId,
                    children: item.children
                }, item.testId ?? index))
        });
        if (isCheckboxMenu) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$0199732cf5257721$export$e960b0f5cc4a2826, {
            items: itemsList,
            onItemClick: handleItemClick
        });
        if (isOptionMenu || hasAnyIcons) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$0633f0dbed99c656$export$efefb5b75235a614, {
            items: itemsList,
            onItemClick: handleItemClick
        });
        return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$77e170ce1d4ab374$export$a6155c53cd00116c, {
            items: itemsList,
            onItemClick: handleItemClick
        });
    };
    // Combine base styles with actions styles for full DropdownMenu styling
    const combinedTriggerStyles = (0, $74Zh5.css)([
        $24c02ea0e14dbe4f$var$$69215f50d6c9f1e0$export$2165c09f364cf0ee,
        $24c02ea0e14dbe4f$var$$69215f50d6c9f1e0$export$a6df230d684a2658
    ]);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: [
            combinedTriggerStyles,
            customTriggerStyles,
            isAnyItemSelected && isDropdownOpen && $24c02ea0e14dbe4f$var$$69215f50d6c9f1e0$export$e42df41f371072da,
            isAnyItemSelected && isDropdownOpen && customTriggerActiveStyles
        ],
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $9e29898158274f39$export$2e2bcd8739ae039), {
            onOpenChange: ({ isOpen: isOpen })=>setIsDropdownOpen(isOpen),
            trigger: renderTrigger(),
            shouldRenderToParent: true,
            placement: placement,
            children: renderMenuContent()
        })
    });
};
const $24c02ea0e14dbe4f$export$2393c31da95977ae = (props)=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e44a253a59704894, {
        ...props,
        isCheckboxMenu: false
    });
};
var $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$exports, "GreetingCard", ()=>$24c02ea0e14dbe4f$export$e52b3c28ffecde23);
const $24c02ea0e14dbe4f$var$$7a335ab395aac0f5$export$6b53fc34987132a8 = ()=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
        viewBox: "0 0 406 37",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                clipPath: "url(#clip0_511_7308)",
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M396.155 27.8221H394.244L388.065 11.4229H391.206L396.667 26.4205L402.129 11.4229H405.269L398.818 28.3828C396.906 33.3937 395.814 35.9867 391.479 35.9867C390.011 35.9867 389.192 35.8465 388.338 35.4961V32.9031C389.328 33.2185 390.455 33.3236 391.308 33.3236C393.697 33.3236 394.756 31.6416 396.155 27.8221Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M382.705 23.5062C382.705 25.048 383.593 26.0992 385.402 26.0992C386.085 26.0992 386.733 25.9591 387.245 25.854V28.7624C386.733 28.9025 386.153 29.0427 385.265 29.0427C381.613 29.0427 379.838 26.8351 379.838 23.5763V14.2203H377.073V11.417H379.838V7.70264H382.705V11.417H387.245V14.2203H382.705V23.5062Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M370.731 6.79681C370.731 5.46524 371.585 4.69434 372.779 4.69434C373.974 4.69434 374.827 5.46524 374.827 6.79681C374.827 8.12837 373.974 8.89928 372.779 8.89928C371.585 8.89928 370.731 8.12837 370.731 6.79681ZM371.278 28.9428V11.4222H374.213V28.9428H371.278Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M367.184 18.6738V28.9408H364.248V18.3584C364.248 15.2047 363.019 13.803 360.22 13.803C357.49 13.803 355.612 15.6602 355.612 19.1994V28.9408H352.677V11.4202H355.612V14.2936C356.705 12.2262 358.718 11.0698 361.005 11.0698C364.931 11.0698 367.184 13.8381 367.184 18.6738Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M333.733 21.6899V11.4229H336.669V22.0053C336.669 25.159 337.898 26.5606 340.697 26.5606C343.427 26.5606 345.305 24.7035 345.305 21.1643V11.4229H348.24V28.9434H345.305V26.0701C344.212 28.1375 342.199 29.2938 339.912 29.2938C335.986 29.2938 333.733 26.5256 333.733 21.6899Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M318.416 19.1994V28.9408H315.48V18.3584C315.48 15.2047 314.252 13.803 311.453 13.803C308.722 13.803 306.845 15.6602 306.845 19.1994V28.9408H303.909V11.4202H306.845V14.2936C307.937 12.2262 309.951 11.0698 312.238 11.0698C315.139 11.0698 317.119 12.5766 317.972 15.3448C318.928 12.6467 321.215 11.0698 324.048 11.0698C327.871 11.0698 329.987 13.733 329.987 18.6738V28.9408H327.052V19.1994C327.052 15.5901 325.823 13.803 323.024 13.803C320.293 13.803 318.416 15.6602 318.416 19.1994Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M288.249 19.1994V28.9408H285.314V18.3584C285.314 15.2047 284.085 13.803 281.286 13.803C278.555 13.803 276.678 15.6602 276.678 19.1994V28.9408H273.742V11.4202H276.678V14.2936C277.77 12.2262 279.784 11.0698 282.071 11.0698C284.972 11.0698 286.952 12.5766 287.805 15.3448C288.761 12.6467 291.048 11.0698 293.881 11.0698C297.704 11.0698 299.82 13.733 299.82 18.6738V28.9408H296.885V19.1994C296.885 15.5901 295.656 13.803 292.857 13.803C290.126 13.803 288.249 15.6602 288.249 19.1994Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M262.275 29.2912C257.155 29.2912 254.151 25.4017 254.151 20.1455C254.151 14.8893 257.155 11.0698 262.275 11.0698C267.361 11.0698 270.331 14.8893 270.331 20.1455C270.331 25.4017 267.361 29.2912 262.275 29.2912ZM262.275 13.8731C258.623 13.8731 257.019 16.8166 257.019 20.1455C257.019 23.4744 258.623 26.4879 262.275 26.4879C265.893 26.4879 267.464 23.4744 267.464 20.1455C267.464 16.8166 265.893 13.8731 262.275 13.8731Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M251.998 24.88V27.9285C250.598 28.8746 248.38 29.2951 246.059 29.2951C238.686 29.2951 234.521 24.7398 234.521 17.4863C234.521 10.478 238.686 5.57227 245.99 5.57227C248.175 5.57227 250.36 5.99276 251.964 7.18416V10.2327C250.36 9.18151 248.585 8.62085 245.99 8.62085C240.734 8.62085 237.594 12.195 237.594 17.4863C237.594 22.7775 240.836 26.2816 246.161 26.2816C248.516 26.2816 250.36 25.7209 251.998 24.88Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M119.605 12.4499C119.605 15.8465 121.102 18.5153 127.168 19.7284C130.713 20.5371 131.501 21.1032 131.501 22.3163C131.501 23.5294 130.713 24.2572 128.192 24.2572C125.277 24.2572 121.811 23.2059 119.526 21.8311V27.3304C121.338 28.22 123.702 29.2713 128.192 29.2713C134.494 29.2713 136.936 26.3599 136.936 22.1546M136.936 22.2354C136.936 18.1918 134.888 16.3318 128.98 15.0378C125.75 14.3099 124.962 13.5821 124.962 12.5308C124.962 11.2368 126.144 10.6707 128.271 10.6707C130.87 10.6707 133.391 11.4794 135.833 12.6116V7.35493C134.1 6.46534 131.501 5.81836 128.428 5.81836C122.599 5.81836 119.605 8.40627 119.605 12.6116",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M200.274 5.979V29.0276H205.08V11.4783L207.049 16.088L213.824 29.0276H219.811V5.979H215.085V20.8595L213.273 16.4924L207.837 5.979H200.274Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M169.865 5.979H164.666V29.0276H169.865V5.979Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M158.679 22.1554C158.679 18.1117 156.631 16.2517 150.723 14.9577C147.493 14.2299 146.705 13.502 146.705 12.4507C146.705 11.1567 147.887 10.5906 150.014 10.5906C152.614 10.5906 155.134 11.3993 157.577 12.5316V7.27485C155.843 6.38526 153.244 5.73828 150.171 5.73828C144.342 5.73828 141.348 8.32619 141.348 12.5316C141.348 15.9282 142.845 18.597 148.911 19.8101C152.456 20.6188 153.244 21.1849 153.244 22.398C153.244 23.6111 152.456 24.3389 149.935 24.3389C147.02 24.3389 143.554 23.2876 141.27 21.9127V27.412C143.081 28.3016 145.445 29.353 149.935 29.353C156.159 29.353 158.679 26.4416 158.679 22.1554Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M79.1143 5.979V29.0276H89.828L91.4824 24.0135H84.3136V5.979H79.1143Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M57.9219 5.979V10.9122H63.6727V29.0276H68.9508V10.9122H75.1742V5.979H57.9219Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M50.2806 5.97412H43.4269L35.6279 29.0227H41.615L42.7179 25.1408C44.0572 25.5452 45.4752 25.7878 46.8932 25.7878C48.3112 25.7878 49.7292 25.5452 51.0684 25.1408L52.1713 29.0227H58.1584C58.0796 29.0227 50.2806 5.97412 50.2806 5.97412ZM46.8144 20.9355C45.7903 20.9355 44.8449 20.7737 43.9784 20.5311L46.8144 10.503L49.6504 20.5311C48.7838 20.7737 47.8385 20.9355 46.8144 20.9355Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M108.339 5.97363H101.485L93.6074 29.0222H99.5945L100.697 25.1404C102.037 25.5447 103.455 25.7873 104.873 25.7873C106.291 25.7873 107.709 25.5447 109.048 25.1404L110.151 29.0222H116.138L108.339 5.97363ZM104.873 20.935C103.849 20.935 102.903 20.7733 102.037 20.5306L104.873 10.5025L107.709 20.5306C106.842 20.7733 105.897 20.935 104.873 20.935Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M188.694 5.97363H181.84L174.041 29.0222H180.028L181.131 25.1404C182.47 25.5447 183.888 25.7873 185.306 25.7873C186.724 25.7873 188.142 25.5447 189.481 25.1404L190.584 29.0222H196.571L188.694 5.97363ZM185.306 20.935C184.282 20.935 183.337 20.7733 182.47 20.5306L185.306 10.5025L188.142 20.5306C187.276 20.7733 186.252 20.935 185.306 20.935Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("g", {
                        clipPath: "url(#clip1_511_7308)",
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                            d: "M25.4715 28.1859L13.6868 3.70842C13.4549 3.1784 13.2229 3.08203 12.9445 3.08203C12.7125 3.08203 12.4342 3.1784 12.1558 3.66024C10.4855 6.40673 9.74318 9.58688 9.74318 12.9116C9.74318 17.5372 12.0166 21.8738 15.3571 28.8605C15.7283 29.6314 16.0067 29.776 16.6562 29.776H24.8219C25.4251 29.776 25.7498 29.5351 25.7498 29.0532C25.7498 28.8123 25.7034 28.6678 25.4715 28.1859ZM8.3513 16.6217C7.42338 15.1762 7.145 15.0799 6.91302 15.0799C6.68104 15.0799 6.54185 15.1762 6.12429 16.0435L0.231981 28.2823C0.0463961 28.6678 0 28.8123 0 29.005C0 29.3905 0.324773 29.776 1.02071 29.776H9.32562C9.88237 29.776 10.2999 29.2941 10.5319 28.3786C10.8103 27.2222 10.9031 26.2104 10.9031 25.0058C10.9031 21.6329 9.4648 18.3564 8.3513 16.6217Z",
                            fill: "#1868DB"
                        })
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("defs", {
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("clipPath", {
                        id: "clip0_511_7308",
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("rect", {
                            width: "406",
                            height: "37",
                            fill: "white"
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("clipPath", {
                        id: "clip1_511_7308",
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("rect", {
                            width: "25.7498",
                            height: "26.694",
                            fill: "white",
                            transform: "translate(0 3.08154)"
                        })
                    })
                ]
            })
        ]
    });
const $24c02ea0e14dbe4f$var$$0467da094044eefe$export$590b8cc7d4f1d823 = ()=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
        viewBox: "0 0 112 113",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("g", {
                id: "icon-launched-new",
                clipPath: "url(#clip0_608_7795)",
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                    id: "Clip path group",
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("mask", {
                            id: "mask0_608_7795",
                            "mask-type": "luminance",
                            maskUnits: "userSpaceOnUse",
                            x: "0",
                            y: "0",
                            width: "112",
                            height: "113",
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("g", {
                                id: "clip0_10_2524",
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                    id: "Vector",
                                    d: "M112 0.5H0V112.5H112V0.5Z",
                                    fill: "white"
                                })
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("g", {
                            mask: "url(#mask0_608_7795)",
                            children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                                id: "Group",
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        id: "Vector_2",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M69.4245 80.4295C67.168 95.2604 53.3169 105.459 38.486 103.203C23.6551 100.946 13.456 87.0952 15.7126 72.2643C17.9691 57.4334 31.8202 47.2344 46.6512 49.4909C61.4821 51.7475 71.6811 65.5986 69.4245 80.4295ZM39.5994 70.0078C39.926 67.8848 38.4711 65.9103 36.3482 65.5837C34.2253 65.2571 32.2508 66.712 31.9242 68.8349C31.5976 70.9579 33.0524 72.9324 35.1754 73.259C37.2983 73.5856 39.2728 72.1307 39.5994 70.0078ZM54.9499 72.3385C55.2765 70.2156 53.8217 68.2411 51.6987 67.9145C49.5758 67.5879 47.6013 69.0428 47.2747 71.1657C46.9481 73.2887 48.403 75.2632 50.5259 75.5898C52.6488 75.9164 54.6233 74.4615 54.9499 72.3385ZM33.8541 82.7454L32.132 80.3998L27.4407 83.844L29.1628 86.1896C34.6112 93.5828 45.0181 95.1713 52.4262 89.7229L54.7718 88.0008L51.3276 83.3096L48.9819 85.0317C44.1719 88.565 37.4022 87.5406 33.869 82.7306L33.8541 82.7454Z",
                                        fill: "#1868DB"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        id: "Vector_3",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M67.8214 26.5393C53.0795 29.3006 43.3555 43.4932 46.1169 58.2499C48.8782 72.9917 63.0707 82.7157 77.8125 79.9544C92.5544 77.1931 102.293 63.0005 99.5319 48.2587C96.7706 33.5168 82.5632 23.7929 67.8214 26.5393ZM78.6588 42.2758C80.7669 41.875 82.7859 43.2705 83.1867 45.3786C83.5875 47.4867 82.1921 49.5057 80.084 49.9066C77.9759 50.3074 75.9568 48.9119 75.556 46.8038C75.1552 44.6957 76.5507 42.6767 78.6588 42.2758ZM63.3973 45.1262C65.5054 44.7254 67.5244 46.1209 67.9253 48.229C68.3261 50.3371 66.9306 52.3561 64.8225 52.7569C62.7144 53.1578 60.6954 51.7623 60.2946 49.6542C59.8937 47.5461 61.2892 45.5271 63.3973 45.1262ZM76.3428 72.0713C68.9496 73.4519 61.8534 68.5974 60.4727 61.2339L87.1802 56.2308C88.5609 63.6092 83.6915 70.6906 76.328 72.0713H76.3428Z",
                                        fill: "#82B536"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        id: "Vector_4",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M69.3206 71.522C64.8966 69.9781 61.4079 66.1776 60.4874 61.2339L64.6145 60.4619C60.5023 54.7463 54.178 50.6341 46.666 49.4909C46.4285 49.4612 46.1761 49.4167 45.9386 49.4019C45.508 52.2671 45.5526 55.2511 46.1167 58.2499C46.7996 61.8575 48.1506 65.1532 50.036 68.0481C50.5556 67.8848 51.1346 67.8403 51.7136 67.9294C53.8217 68.256 55.2914 70.2305 54.9648 72.3534C54.9054 72.7394 54.7866 73.1105 54.6382 73.4371C58.7208 77.1189 63.8871 79.5387 69.4691 80.2217C69.8996 77.2525 69.8254 74.3279 69.3206 71.522Z",
                                        fill: "#09326C"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        id: "Vector_5",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M69.3206 71.522C64.8966 69.9781 61.4079 66.1776 60.4874 61.2339L64.6145 60.4619C60.5023 54.7463 54.178 50.6341 46.666 49.4909C46.4285 49.4612 46.1761 49.4167 45.9386 49.4019C45.508 52.2671 45.5526 55.2511 46.1167 58.2499C46.7996 61.8575 48.1506 65.1532 50.036 68.0481C50.5556 67.8848 51.1346 67.8403 51.7136 67.9294C53.8217 68.256 55.2914 70.2305 54.9648 72.3534C54.9054 72.7394 54.7866 73.1105 54.6382 73.4371C58.7208 77.1189 63.8871 79.5387 69.4691 80.2217C69.8996 77.2525 69.8254 74.3279 69.3206 71.522Z",
                                        fill: "#09326C"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        id: "Vector_6",
                                        d: "M37.1105 18.5589C35.4939 18.8626 33.943 19.3745 32.443 19.9453C32.443 19.9453 31.9357 20.0403 31.129 20.2877C30.3129 20.4878 29.2409 20.8857 28.0837 21.3496C25.7784 22.3248 23.3235 23.9635 22.2601 25.3038C18.8575 27.6207 15.8953 30.6524 13.728 34.2501C13.728 34.2501 13.6005 34.5506 13.3796 35.0267C13.172 35.4954 12.8711 36.1395 12.6779 36.8806C12.4487 37.5894 12.2232 38.3664 12.138 39.0812C12.0319 39.7904 11.9544 40.3955 12.0307 40.8082C12.1735 41.8321 12.4667 42.4724 12.8105 42.6457C13.1619 42.8321 13.577 42.5438 13.99 41.6956C14.1653 41.2628 14.3883 40.6978 14.6648 39.9797C14.8788 39.2444 15.2371 38.3922 15.6052 37.3413C15.6582 37.3111 15.7874 37.1677 15.863 37.1775C16.5848 34.9263 18.0622 33.0179 19.7393 31.3996C21.4298 29.7737 23.3598 28.4153 25.3445 27.0607C25.1727 26.9127 25.2076 26.665 25.3929 26.6826L25.5019 26.9363C26.7066 25.8143 27.936 25.2919 29.1048 24.7864C30.2944 24.2867 31.425 23.8377 32.7028 22.9372C32.7028 22.9372 32.4877 23.3925 32.4745 23.4001C34.8719 22.6182 37.6167 22.0775 40.4373 22.1955C43.2427 22.2869 46.1201 22.9688 48.4691 24.5119C50.8752 25.97 52.5652 28.3606 53.6246 30.9689C53.8516 31.6469 54.0785 32.3249 54.2715 33.0045C54.3962 33.6879 54.6001 34.449 54.6797 35.0528C54.8203 36.1657 54.6543 37.2947 54.118 38.2656L54.1709 38.2354L54.2011 38.2884C54.5424 38.0246 55.2229 36.9369 55.3721 35.7473C55.4646 35.1686 55.434 34.5896 55.3732 34.0806C55.3273 33.5979 55.2903 33.2857 55.2903 33.2857C55.5313 33.7102 55.7664 34.1555 55.9486 34.6309C56.0816 35.0815 56.188 35.5472 56.1791 36.0258C56.182 36.9888 55.8574 37.9623 55.2989 38.7703C54.191 40.4338 52.3157 41.2704 50.6424 41.536L50.6095 41.1688C52.0421 41.0046 52.9986 39.9706 53.223 39.5627C52.2579 40.3033 50.7995 40.8856 49.2811 40.5898C48.5361 40.4515 47.7197 40.1255 47.3784 39.7405C47.0447 39.3686 46.8665 38.8385 46.8708 38.0117C46.8985 36.3298 47.86 34.2232 48.8355 32.512C49.8283 30.7383 50.9433 29.211 51.8152 27.9971C51.4767 27.9261 50.7999 29.7309 49.8072 29.5578C50.7472 28.3402 51.6439 27.0771 52.6818 26.0321C53.0988 26.4268 52.386 26.9015 52.3552 27.0943C52.8898 26.7383 55.478 24.1295 59.4933 21.2541C63.5031 18.3996 69.0286 15.4039 74.4857 13.8324C79.9467 12.2062 85.1646 12.1912 88.1909 12.4555C91.1868 12.7897 92.2788 12.6434 89.3823 11.3409L89.7669 11.1225C86.5833 10.3337 83.8919 10.0724 80.3945 9.8125C79.908 9.91315 79.8439 9.86194 79.8865 10.1534C79.7671 10.2212 79.5682 10.334 79.6283 10.4402C79.7549 11.1575 78.6865 10.9748 78.2284 11.0944C78.351 9.91998 75.6295 10.2545 72.8735 11.3625C71.487 11.8865 70.1322 12.6203 69.0219 13.1979C67.9359 13.8492 67.1077 14.3369 66.7535 14.4854C66.0124 13.6432 64.1295 15.7642 63.1568 15.8426C63.1872 15.7728 63.4117 15.3647 63.4497 15.3081C62.9108 15.193 60.0007 17.2655 57.7814 19.2266C55.5546 21.1746 53.9377 22.899 54.9247 21.1462C53.2247 22.1988 51.4934 23.5672 49.7915 25.2347C48.1027 26.8946 46.436 28.8403 45.0442 31.2087C44.369 32.3987 43.6976 33.6567 43.277 35.1406C42.8754 36.5962 42.5394 38.2601 43.0769 40.165C43.2648 40.6195 43.4204 41.11 43.6821 41.5403C43.9836 41.9478 44.2736 42.397 44.6529 42.7255C45.038 43.0331 45.4249 43.3748 45.846 43.5916C46.2598 43.7953 46.6793 43.9782 47.1119 44.1534C48.7601 44.7088 50.6331 44.7333 52.3051 44.1876C55.7004 43.155 58.0935 39.9553 58.4079 36.5849C58.4804 35.7544 58.4471 34.8615 58.3055 34.1175C58.1656 33.4076 58.0184 32.6845 57.8785 31.9745C57.6573 31.2759 57.4569 30.5828 57.2433 29.8973C56.9823 29.2211 56.6814 28.5676 56.4072 27.8989C55.1699 25.2864 53.2694 23.0503 51.087 21.43C48.9049 19.8099 46.507 18.7681 44.2577 18.0804L44.3555 18.2528C44.2347 18.1635 43.7768 18.1603 43.679 17.9879C42.7253 18.0381 41.0604 18.071 39.6751 18.2259C38.2821 18.3675 37.1464 18.5912 37.1464 18.5912L37.1105 18.5589ZM50.547 43.0983C50.547 43.0983 50.5297 43.1608 50.5507 43.1665C50.5355 43.14 49.968 43.1289 49.3872 43.1252C48.7971 43.0743 48.2184 42.9818 48.1883 42.9288L48.2858 42.5753C48.8516 42.5523 49.5324 42.6394 50.2474 42.7248C50.6105 42.7466 50.968 42.7894 51.2971 42.813C51.6319 42.8158 51.9534 42.8262 52.2278 42.8459C52.7538 42.8456 53.1037 42.875 52.9613 43.026C52.8247 43.1561 52.1654 43.4778 50.8016 43.3924C50.6366 43.5035 50.594 43.212 50.547 43.0983ZM48.7248 28.3305C48.9904 28.0569 49.2619 27.7627 49.5787 27.4249C48.4351 29.7051 46.7257 32.0082 45.4672 34.7042C44.9032 36.0592 44.4354 37.5524 44.6239 39.0589C44.6303 39.4411 44.7788 39.7953 44.9272 40.1495C45.0283 40.5131 45.2962 40.7995 45.5166 41.0953C46.0031 41.6434 46.6452 42.0331 47.3106 42.2168C47.0285 42.3067 46.6746 42.3321 46.3172 42.2895C45.9844 42.1978 45.6066 42.0263 45.2194 41.8076C44.8968 41.5172 44.5439 41.1739 44.2898 40.7569C44.1094 40.3155 43.8119 39.853 43.8 39.3686C43.4767 37.3774 44.2801 35.6412 44.7204 34.5319C45.2518 32.0379 47.2732 29.8209 48.738 28.3229L48.7248 28.3305ZM75.3293 11.3017L75.292 11.1124L75.4605 11.0693C75.4605 11.0693 75.4734 11.1848 75.4336 11.2074C75.4222 11.249 75.3634 11.2999 75.3218 11.2885L75.3293 11.3017ZM39.9067 19.252C40.2934 18.9447 41.7287 19.2176 40.7452 19.7406C40.5072 19.6301 39.8026 19.8723 39.9067 19.252ZM52.7887 24.428C52.3491 23.9935 53.6243 22.6559 54.1751 23.2553C53.7406 23.6949 53.2325 24.0358 52.7887 24.428ZM26.807 23.1792C26.6704 23.9581 26.4775 23.2785 26.1416 22.9955C26.2853 23.0016 26.7001 22.8364 26.7504 23.1412L26.807 23.1792ZM20.0624 28.3223C20.1883 28.6368 19.9807 29.1055 19.8459 29.2696C19.2644 29.5119 19.686 28.3081 20.0624 28.3223ZM12.8127 39.961C13.1396 40.0737 13.1576 40.4142 12.8019 40.4056C12.5581 40.3159 12.4933 39.8617 12.8923 39.9158C12.8923 39.9158 12.845 39.9252 12.826 39.9535L12.8127 39.961ZM59.9658 20.1089C60.1746 21.2182 58.4067 21.5025 57.8937 22.2673C57.4082 21.3502 59.1026 20.9673 59.526 20.4464C59.7175 20.3202 59.8616 20.2033 59.9658 20.1089ZM51.5342 25.7714C51.2097 26.0959 50.8889 25.8395 50.5815 25.4527C50.2554 25.0941 49.8839 24.656 49.6192 24.5607L49.8434 24.2757C50.2098 24.4886 50.5195 24.6636 50.8161 24.8461C51.0936 25.0569 51.3198 25.3318 51.5191 25.7448L51.5342 25.7714ZM48.7068 31.8834C48.8548 32.3607 48.2335 32.6255 48.0926 32.9336C47.6072 32.6655 48.3318 31.3773 48.7068 31.8834ZM49.8278 41.2441C49.8866 41.8421 49.2689 41.5263 49.0854 41.5428C49.237 41.4392 49.4801 41.1258 49.6106 41.1394C49.6996 41.1415 49.7239 41.2154 49.8278 41.2441ZM52.2354 25.9873C52.6331 26.5333 53.1404 27.0872 53.4601 27.7125L53.1417 27.8932C52.8087 27.2754 52.3316 26.7745 51.9396 26.2077L52.2221 25.9948L52.2354 25.9873ZM54.8127 32.2588L54.4625 32.3525C53.8595 31.5372 54.7063 31.1442 54.7977 32.2324L54.8127 32.2588ZM44.6137 21.8595C44.7044 21.8958 44.8517 21.97 44.9482 21.9854C46.2715 22.3392 44.0824 23.0555 44.6137 21.8595ZM37.2998 21.7663C37.1672 21.8416 36.9889 21.9602 36.8452 21.9541C35.8442 22.0136 36.8308 21.0328 37.2998 21.7663Z",
                                        fill: "#09326C"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("defs", {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("clipPath", {
                    id: "clip0_608_7795",
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("rect", {
                        width: "112",
                        height: "112",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
const $24c02ea0e14dbe4f$export$e52b3c28ffecde23 = ({ onClickLogIn: onClickLogIn, onClickContinue: onClickContinue })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$overlayStyles,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$containerStyles,
            children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $bdfb9b3a36dcb2bb$export$2e2bcd8739ae039), {
                alignInline: "center",
                alignBlock: "center",
                grow: "fill",
                xcss: $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$containerStackStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$logoStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$0467da094044eefe$export$590b8cc7d4f1d823, {})
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $bdfb9b3a36dcb2bb$export$2e2bcd8739ae039), {
                        alignInline: "center",
                        alignBlock: "center",
                        space: "space.200",
                        xcss: $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$middleStackStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$communityLogoStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$7a335ab395aac0f5$export$6b53fc34987132a8, {})
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                                level: 3,
                                children: "We've launched something new"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                children: "We've logged you out. Log back in to see what's changed"
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0c22dfc1af284338$export$2e2bcd8739ae039), {
                        space: "space.200",
                        shouldWrap: true,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$buttonContainerStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.SECONDARY,
                                    label: "Continue without logging in",
                                    fullWidth: true,
                                    onClick: onClickContinue
                                })
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$buttonContainerStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                                    label: "Log back in",
                                    fullWidth: true,
                                    onClick: onClickLogIn
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$overlayStyles = (0, $74Zh5.css)({
    position: "fixed",
    zIndex: (0, $0ce0c6f54e6e45da$export$7be255094ccdc533).blanket(),
    inset: 0,
    backgroundColor: "white",
    overflowY: "auto",
    pointerEvents: "initial",
    fontFamily: "Charlie Display, sans-serif"
});
const $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$containerStackStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    height: "100%"
});
const $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$middleStackStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    marginBottom: "space.500"
});
const $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$containerStyles = (0, $74Zh5.css)({
    position: "absolute",
    width: "100%",
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    "@media(min-width: 1280px)": {
        width: "720px",
        height: "480px"
    },
    "@media (min-width: 768px) and (max-width: 1279px)": {
        width: "656px"
    }
});
const $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$communityLogoStyles = (0, $74Zh5.css)({
    width: "406px",
    "@media(max-width: 767px)": {
        width: "90%"
    }
});
const $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$logoStyles = (0, $74Zh5.css)({
    width: "112px",
    height: "112px",
    borderRadius: "50%",
    border: "1px solid black",
    marginBottom: "24px"
});
const $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$buttonContainerStyles = (0, $74Zh5.css)({
    "@media(max-width: 767px)": {
        width: "100%"
    }
});
var $24c02ea0e14dbe4f$var$$be203e745bcefb12$exports = {};
$24c02ea0e14dbe4f$var$$parcel$defineInteropFlag($24c02ea0e14dbe4f$var$$be203e745bcefb12$exports);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$be203e745bcefb12$exports, "Error", ()=>$24c02ea0e14dbe4f$export$edf27be85e5f6da0);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$be203e745bcefb12$exports, "default", ()=>$24c02ea0e14dbe4f$var$$be203e745bcefb12$export$2e2bcd8739ae039);
const $24c02ea0e14dbe4f$var$$72560d06a87aac8e$export$87321d307719eaf2 = (props)=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
        width: "96",
        height: "89",
        viewBox: "0 0 96 89",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M0.576172 88.4576L0.628536 88.5623H95.366L95.4242 88.4576L48.0002 0.8125L0.576172 88.4576Z",
                fill: "#DDDEE1"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M48.1641 32.2012V64.207",
                stroke: "white",
                strokeWidth: "7.33",
                strokeMiterlimit: "10"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M50.4025 74.1797C50.4316 74.0284 50.4433 73.8655 50.4433 73.6968C50.4433 73.528 50.4316 73.3593 50.4025 73.208C50.2396 72.2946 49.6054 71.736 48.7153 71.5906C48.564 71.5673 48.4069 71.5557 48.2382 71.5557C48.0694 71.5557 47.9007 71.5673 47.7436 71.5964C46.8534 71.7418 46.2251 72.3062 46.0564 73.2138C46.0273 73.3651 46.0156 73.528 46.0156 73.7026C46.0156 73.8771 46.0273 74.0342 46.0564 74.1855C46.2193 75.0931 46.8534 75.6517 47.7436 75.8029C47.9007 75.832 48.0694 75.8437 48.2382 75.8437C48.4069 75.8437 48.564 75.832 48.7153 75.8088C49.6054 75.6633 50.2396 75.0989 50.4025 74.1913V74.1797Z",
                stroke: "white",
                strokeWidth: "7.33",
                strokeMiterlimit: "10"
            })
        ]
    });
};
const $24c02ea0e14dbe4f$export$edf27be85e5f6da0 = ({ onClickLogout: onClickLogout, errorMessage: errorMessage })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$be203e745bcefb12$var$pageStyles,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: $24c02ea0e14dbe4f$var$$be203e745bcefb12$var$containerStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$72560d06a87aac8e$export$87321d307719eaf2, {}),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("h1", {
                    css: $24c02ea0e14dbe4f$var$$be203e745bcefb12$var$headingStyles,
                    children: "Error"
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                    css: $24c02ea0e14dbe4f$var$$be203e745bcefb12$var$descriptionStyles,
                    children: errorMessage
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                    label: "Log out",
                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.LINK,
                    onClick: onClickLogout
                })
            ]
        })
    });
};
var $24c02ea0e14dbe4f$var$$be203e745bcefb12$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$export$edf27be85e5f6da0;
const $24c02ea0e14dbe4f$var$$be203e745bcefb12$var$pageStyles = (0, $74Zh5.css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
});
const $24c02ea0e14dbe4f$var$$be203e745bcefb12$var$containerStyles = (0, $74Zh5.css)({
    maxWidth: "800px",
    minWidth: "375px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.600")
});
const $24c02ea0e14dbe4f$var$$be203e745bcefb12$var$headingStyles = (0, $74Zh5.css)({
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    fontFamily: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("font.family.brand.heading"),
    fontSize: "24px",
    fontWeight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("font.weight.semibold"),
    lineHeight: "32px",
    textAlign: "center"
});
const $24c02ea0e14dbe4f$var$$be203e745bcefb12$var$descriptionStyles = (0, $74Zh5.css)({
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Inter",
    fontWeight: "400",
    lineHeight: "20px",
    textAlign: "center",
    fontSize: "16px"
});
var $24c02ea0e14dbe4f$var$$1db60c687807de63$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$1db60c687807de63$exports, "SUCCESS_MESSAGE", ()=>$24c02ea0e14dbe4f$export$5620dbefc1cb6f80);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$1db60c687807de63$exports, "ERROR_MESSAGE", ()=>$24c02ea0e14dbe4f$export$3f27bc10068ef877);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$1db60c687807de63$exports, "NewsletterSignup", ()=>$24c02ea0e14dbe4f$export$21041608e6399292);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$1db60c687807de63$exports, "Environment", ()=>$24c02ea0e14dbe4f$export$7dc6752a22ab011a);
var $24c02ea0e14dbe4f$var$$ca43fe01b6155439$exports = {};
var $24c02ea0e14dbe4f$var$$3ced3ef7e9864bf1$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3ced3ef7e9864bf1$exports, "DESKTOP_SCREEN_WIDTH", ()=>$24c02ea0e14dbe4f$export$27ed77542911fb0e);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3ced3ef7e9864bf1$exports, "TABLET_SCREEN_WIDTH", ()=>$24c02ea0e14dbe4f$export$62d1d6124a8e4649);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3ced3ef7e9864bf1$exports, "useDeviceSize", ()=>$24c02ea0e14dbe4f$export$4616d33c54ae5baf);
// Default to a common desktop device width (is used to handle window object not being available during SSR)
const $24c02ea0e14dbe4f$var$$3ced3ef7e9864bf1$var$DEFAULT_WIDTH = 1440;
const $24c02ea0e14dbe4f$export$27ed77542911fb0e = 1024;
const $24c02ea0e14dbe4f$export$62d1d6124a8e4649 = 900;
const $24c02ea0e14dbe4f$export$4616d33c54ae5baf = ()=>{
    const [width, setWidth] = (0, $5FkrB.useState)(typeof window !== "undefined" ? window.innerWidth : $24c02ea0e14dbe4f$var$$3ced3ef7e9864bf1$var$DEFAULT_WIDTH);
    const handleWindowResize = ()=>{
        setWidth(window.innerWidth);
    };
    (0, $5FkrB.useEffect)(()=>{
        if (typeof window === "undefined") return;
        if (width === $24c02ea0e14dbe4f$var$$3ced3ef7e9864bf1$var$DEFAULT_WIDTH && width !== window.innerWidth) handleWindowResize();
        window.addEventListener("resize", handleWindowResize);
        return ()=>window.removeEventListener("resize", handleWindowResize);
    // width intentionally excluded (stable state setter)
    /* eslint-disable react-hooks/exhaustive-deps */ }, []);
    /* eslint-enable react-hooks/exhaustive-deps */ return width;
};
var $24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$exports, "usePostNewsletterSignup", ()=>$24c02ea0e14dbe4f$export$ea96d97e8873ca7f);
const $24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$var$NEWSLETTER_FORM_TYPE = "community_learning_signup";
const $24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$var$NEWSLETTER_FORM_DEF = "pointALead";
const $24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$var$WAC_BASE_URL = {
    [$24c02ea0e14dbe4f$export$7dc6752a22ab011a.LOCAL]: "/api/wac",
    [$24c02ea0e14dbe4f$export$7dc6752a22ab011a.DEVELOPMENT]: "https://wac.stg.internal.atlassian.com",
    [$24c02ea0e14dbe4f$export$7dc6752a22ab011a.STAGING]: "https://wac.stg.internal.atlassian.com",
    [$24c02ea0e14dbe4f$export$7dc6752a22ab011a.PRODUCTION]: "https://www.atlassian.com"
};
const $24c02ea0e14dbe4f$export$ea96d97e8873ca7f = ({ environment: environment = $24c02ea0e14dbe4f$export$7dc6752a22ab011a.DEVELOPMENT, onError: onError = ()=>null, onSuccess: onSuccess = ()=>null })=>{
    const [loading, setLoading] = (0, $5FkrB.useState)(false);
    const [error, setError] = (0, $5FkrB.useState)(null);
    const [success, setSuccess] = (0, $5FkrB.useState)(false);
    const handleNewsletterSignup = async (formValues, formUrl)=>{
        setLoading(true);
        setError(null);
        setSuccess(false);
        try {
            const preferencesResponse = await $24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$var$postPreferencesUpdate(formValues, environment, formUrl);
            if (!preferencesResponse.ok || preferencesResponse.status !== 202) throw new Error(`Error in postPreferencesUpdate with status: ${preferencesResponse.status}`);
            const wacResponse = await $24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$var$postWacFormLead(formValues, environment);
            if (!wacResponse.ok || wacResponse.status !== 200) throw new Error(`Error in postWacFormLead with status: ${wacResponse.status}`);
            onSuccess();
            setSuccess(true);
        } catch (error) {
            if (error instanceof Error) setError(error.message);
            onError(error);
        } finally{
            setLoading(false);
        }
    };
    return {
        handleNewsletterSignup: handleNewsletterSignup,
        loading: loading,
        error: error,
        success: success
    };
};
const $24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$var$postPreferencesUpdate = async (formValues, environment, formUrl)=>{
    const locale = navigator.language || Intl.DateTimeFormat().resolvedOptions().locale;
    const region = locale.split("-")[1];
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            consentCheckboxValue: true,
            consentLabelText: "By signing up, you agree to receive promotional emails including product news, events, and more from Atlassian and its affiliates, and acknowledge and accept the Atlassian Privacy Policy.",
            email: formValues.email,
            formUrl: formUrl || "https://community.atlassian.com/",
            formId: "655e8a50-2d1f-4c1c-a782-fb5333e272a8",
            locale: region,
            paramsLocale: region,
            privacyPolicyText: '<p>By signing up, you agree to receive promotional emails including product news, events, and more from Atlassian and its affiliates, and acknowledge and accept the Atlassian Privacy Policy. <a href=\\"https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers\\">Atlassian Privacy Policy</a>.</p>\n',
            site: "atlassian"
        })
    };
    return fetch($24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$var$WAC_BASE_URL[environment] + "/gateway/api/preferencesV2/update", requestOptions);
};
// Initiates POST to /streamhub/wacformlead
// Endpoint in: https://bitbucket.org/atlassian/bxp-express/src/routes/streamhubSubmission.ts
const $24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$var$postWacFormLead = async (formValues, environment)=>{
    const now = new Date();
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            ...formValues,
            formType: $24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$var$NEWSLETTER_FORM_TYPE,
            formDef: $24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$var$NEWSLETTER_FORM_DEF,
            created_at: now.toISOString(),
            submitted: now.toString()
        })
    };
    return fetch($24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$var$WAC_BASE_URL[environment] + "/endpoint/streamhub/wacformlead", requestOptions);
};
var $24c02ea0e14dbe4f$var$$18cdd3872ade1318$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$18cdd3872ade1318$exports, "useScrollActiveSection", ()=>$24c02ea0e14dbe4f$export$c0e9cacf89df0750);
const $24c02ea0e14dbe4f$export$c0e9cacf89df0750 = ({ links: links, containerRef: containerRef, options: options = {} })=>{
    const [activeHref, setActiveHref] = (0, $5FkrB.useState)("");
    const { triggerPoint: triggerPoint = 0.3, topThreshold: topThreshold = 100 } = options;
    (0, $5FkrB.useEffect)(()=>{
        // Derive section IDs from links
        const linkHrefs = links.map((link)=>link.href ? link.href : $24c02ea0e14dbe4f$export$1bdcd43c8c2377cf(link.label));
        const sectionIds = linkHrefs.map((href)=>href.replace("#", ""));
        // Find sections by the IDs we derived from links
        const sections = sectionIds.map((id)=>document.getElementById(id)).filter(Boolean);
        if (sections.length === 0) return;
        const container = containerRef?.current;
        const isWindowScroll = !container;
        let ticking = false;
        const updateActiveSection = ()=>{
            // Get scroll position and dimensions
            const scrollY = isWindowScroll ? window.scrollY : container.scrollTop;
            const viewportHeight = isWindowScroll ? window.innerHeight : container.clientHeight;
            const triggerPointPx = viewportHeight * triggerPoint;
            // If we're at the very top, always select the first section
            if (scrollY < topThreshold) {
                setActiveHref(linkHrefs[0]);
                return;
            }
            // Find which section is currently at the trigger point
            let currentSectionIndex = 0;
            sections.forEach((section, index)=>{
                const rect = section.getBoundingClientRect();
                if (isWindowScroll) {
                    if (rect.top <= triggerPointPx) currentSectionIndex = index;
                } else {
                    // For container scroll, calculate relative position
                    const containerRect = container.getBoundingClientRect();
                    const relativeTop = rect.top - containerRect.top;
                    if (relativeTop <= triggerPointPx) currentSectionIndex = index;
                }
            });
            setActiveHref(linkHrefs[currentSectionIndex]);
        };
        const handleScroll = ()=>{
            if (!ticking) {
                window.requestAnimationFrame(()=>{
                    updateActiveSection();
                    ticking = false;
                });
                ticking = true;
            }
        };
        // Set initial active section
        updateActiveSection();
        // Attach scroll listener to container or window
        if (isWindowScroll) window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        else container.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return ()=>{
            if (isWindowScroll) window.removeEventListener("scroll", handleScroll);
            else container.removeEventListener("scroll", handleScroll);
        };
    }, [
        links,
        containerRef,
        triggerPoint,
        topThreshold
    ]);
    return activeHref;
};
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$ca43fe01b6155439$exports, $24c02ea0e14dbe4f$var$$3ced3ef7e9864bf1$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$ca43fe01b6155439$exports, $24c02ea0e14dbe4f$var$$633811e9cd66d921$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$ca43fe01b6155439$exports, $24c02ea0e14dbe4f$var$$6e8a4d5d78071ed7$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$ca43fe01b6155439$exports, $24c02ea0e14dbe4f$var$$965a3cfbe886b380$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$ca43fe01b6155439$exports, $24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$ca43fe01b6155439$exports, $24c02ea0e14dbe4f$var$$18cdd3872ade1318$exports);
var $24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports = {};
var $24c02ea0e14dbe4f$var$$1ca64a7075ab6eae$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$1ca64a7075ab6eae$exports, "TextField", ()=>$24c02ea0e14dbe4f$export$2c73285ae9390cec);
const $24c02ea0e14dbe4f$export$2c73285ae9390cec = ({ isInvalid: isInvalid = false, onChange: onChange = ()=>{
    return null;
}, value: value, isDisabled: isDisabled = false, isRequired: isRequired = false, ...rest })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("input", {
        css: [
            $24c02ea0e14dbe4f$var$$1ca64a7075ab6eae$var$inputStyles,
            isInvalid && $24c02ea0e14dbe4f$var$$1ca64a7075ab6eae$var$invalidStyles,
            isDisabled && $24c02ea0e14dbe4f$var$$1ca64a7075ab6eae$var$disabledStyles
        ],
        onChange: onChange,
        disabled: isDisabled,
        value: value,
        required: isRequired,
        ...rest
    });
const $24c02ea0e14dbe4f$var$$1ca64a7075ab6eae$var$inputStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "42px",
    fontWeight: 400,
    display: "flex",
    padding: "8px 12px",
    alignItems: "center",
    gap: "6px",
    alignSelf: "stretch",
    borderRadius: "4px",
    border: "1px solid #8590A2",
    background: "#FFFFFF",
    fontFamily: "inter",
    fontSize: "16px",
    "&:hover": {
        background: "#F7F8F9"
    },
    "&:focus": {
        borderColor: "inherit",
        boxShadow: "none",
        border: "1px solid #388BFF",
        outline: "1px solid #388BFF"
    }
});
const $24c02ea0e14dbe4f$var$$1ca64a7075ab6eae$var$invalidStyles = (0, $74Zh5.css)({
    border: "1px solid #C9372C",
    outline: "1px solid #C9372C"
});
const $24c02ea0e14dbe4f$var$$1ca64a7075ab6eae$var$disabledStyles = (0, $74Zh5.css)({
    color: "#091E424F",
    border: "1px solid #091E420F",
    background: "#091E4208"
});
var $24c02ea0e14dbe4f$var$$60ab015507144a2b$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$60ab015507144a2b$exports, "TextFieldMessage", ()=>$24c02ea0e14dbe4f$export$9144c5f9beecc4b7);
const $24c02ea0e14dbe4f$export$9144c5f9beecc4b7 = ({ message: message = "Example text here", type: type = "valid" })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$60ab015507144a2b$var$spacing,
        children: [
            type === "helper" && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $3433a9f6c8d902bf$export$8fbe3c7d0ed2c683), {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                    css: $24c02ea0e14dbe4f$var$$60ab015507144a2b$var$helperMessageStyle,
                    children: message
                })
            }),
            type === "error" && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $3433a9f6c8d902bf$export$915e9e7bd4f0f96d), {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                    css: $24c02ea0e14dbe4f$var$$60ab015507144a2b$var$errorMessageStyle,
                    children: message
                })
            }),
            type === "valid" && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $3433a9f6c8d902bf$export$5505afb209a532c8), {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                    css: $24c02ea0e14dbe4f$var$$60ab015507144a2b$var$validMessageStyles,
                    children: message
                })
            })
        ]
    });
const $24c02ea0e14dbe4f$var$$60ab015507144a2b$var$spacing = (0, $74Zh5.css)({
    marginTop: "2px"
});
const $24c02ea0e14dbe4f$var$$60ab015507144a2b$var$helperMessageStyle = (0, $74Zh5.css)({
    fontFamily: "Inter",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px"
});
const $24c02ea0e14dbe4f$var$$60ab015507144a2b$var$errorMessageStyle = (0, $74Zh5.css)({
    paddingLeft: "6px",
    fontFamily: "Inter",
    marginTop: "0.5px",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px"
});
const $24c02ea0e14dbe4f$var$$60ab015507144a2b$var$validMessageStyles = (0, $74Zh5.css)({
    paddingLeft: "6px",
    fontFamily: "Inter",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px"
});
var $24c02ea0e14dbe4f$var$$57b1d5df6b5425d4$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$57b1d5df6b5425d4$exports, "TextFieldLabel", ()=>$24c02ea0e14dbe4f$export$76375b2580d1f8ac);
const $24c02ea0e14dbe4f$export$76375b2580d1f8ac = ({ labelText: labelText = "Example label", isRequired: isRequired = true })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
        htmlFor: "basic-textfield",
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
            css: $24c02ea0e14dbe4f$var$$57b1d5df6b5425d4$var$labelStyles,
            children: [
                labelText,
                isRequired && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $83f0848311ef2185$export$2e2bcd8739ae039), {})
            ]
        })
    });
const $24c02ea0e14dbe4f$var$$57b1d5df6b5425d4$var$labelStyles = (0, $74Zh5.css)({
    fontFamily: "Inter",
    color: "#44546F",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px"
});
var $24c02ea0e14dbe4f$var$$4be7278e65b71184$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$4be7278e65b71184$exports, "UnifiedAccountCardContent", ()=>$24c02ea0e14dbe4f$export$c031b829a2452999);
var $24c02ea0e14dbe4f$var$$fc6addd2061b87dd$exports = {};
$24c02ea0e14dbe4f$var$$parcel$defineInteropFlag($24c02ea0e14dbe4f$var$$fc6addd2061b87dd$exports);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fc6addd2061b87dd$exports, "default", ()=>$24c02ea0e14dbe4f$var$$fc6addd2061b87dd$export$2e2bcd8739ae039);
const $24c02ea0e14dbe4f$var$$fc6addd2061b87dd$var$UnifiedMoreDropdownMenu = ({ actions: actions, isDisabled: isDisabled })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $9e29898158274f39$export$2e2bcd8739ae039), {
        trigger: ({ triggerRef: triggerRef, ...props })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$fc6addd2061b87dd$var$buttonWrapperStyle,
                "data-testid": "dropdown-trigger",
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $0c4c08ddec83e35f$export$2e2bcd8739ae039), {
                    ...props,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($68426ff7d9d92e39$exports))),
                    label: "more",
                    ref: triggerRef,
                    appearance: "default",
                    isDisabled: isDisabled
                })
            }),
        placement: "bottom-end",
        shouldRenderToParent: true,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c45aef576c3a1b33$export$2e2bcd8739ae039), {
            children: actions.map((action, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $896b4f3af893fddb$export$2e2bcd8739ae039), {
                    onClick: action.onClick,
                    children: action.text
                }, index))
        })
    });
var $24c02ea0e14dbe4f$var$$fc6addd2061b87dd$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$var$$fc6addd2061b87dd$var$UnifiedMoreDropdownMenu;
const $24c02ea0e14dbe4f$var$$fc6addd2061b87dd$var$buttonWrapperStyle = (0, $74Zh5.css)({
    backgroundColor: "#FFFFFF",
    borderRadius: "3px"
});
const $24c02ea0e14dbe4f$export$c031b829a2452999 = ({ email: email, tags: tags, actions: actions, disableMenu: disableMenu })=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$contentWrapperStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$dropdownWrapperStyles,
                children: disableMenu ? null : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$fc6addd2061b87dd$export$2e2bcd8739ae039, {
                    actions: actions,
                    isDisabled: disableMenu
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$coverImageWrapperStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$coverImageStyles,
                    children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
                        width: "350",
                        height: "82",
                        viewBox: "0 0 350 82",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                                clipPath: "url(#clip0_985_48434)",
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        d: "M167.322 38.821C177.93 34.78 184.789 30.2722 188.858 25.4255C193.11 20.3612 194.263 14.9878 193.538 9.5957C192.822 4.25652 190.271 -1.06544 187.204 -6.12471C185.194 -9.43933 182.915 -12.7134 180.746 -15.8286C179.821 -17.1581 178.915 -18.4586 178.059 -19.7211L221.313 -48.8693C222.054 -47.7618 222.787 -46.6694 223.511 -45.5908C241.665 -18.5315 254.013 -0.126895 247.42 31.5817C243.994 48.0569 230.739 60.1325 218.142 68.1357C211.864 72.1242 205.799 75.0696 201.302 77.0177C199.054 77.9913 197.201 78.7147 195.913 79.1939C195.383 79.3909 194.949 79.5465 194.622 79.6613L167.322 38.821Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        d: "M72.3053 -15.1135C82.328 -17.928 92.5012 -22.9961 101.629 -29.5552C110.755 -36.1128 118.158 -43.5947 123.819 -51.8086L166.607 8.14819C159.501 15.3002 151.561 22.0298 142.555 28.5017C133.545 34.9761 124.385 40.4509 115.146 44.9177L72.3053 -15.1135Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        d: "M145.593 48.2832L177.327 107.164L160.851 130.97L94.7005 121.821L95.1645 67.6983L145.593 48.2832Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        d: "M315.34 72.2206L315.355 72.2331L315.372 72.2449C315.778 72.5416 316.18 72.8355 316.577 73.1258C320.114 75.7149 323.269 78.0239 326.324 79.6083C329.758 81.3894 333.158 82.3068 336.975 81.7093C341.291 81.0335 344.5 78.5429 346.241 74.1008C347.949 69.7418 348.232 63.5491 346.967 55.3884L346.241 50.7055L378.755 45.6149C379.596 48.7568 380.163 52.4046 380.848 56.8254C383.982 77.0371 381.669 92.493 375.423 103.369C369.195 114.213 358.984 120.632 346.012 122.663C327.026 125.636 315.363 118.74 304.711 110.615L304.701 110.608L304.691 110.601C304.22 110.259 303.755 109.92 303.296 109.586C299.84 107.069 296.744 104.815 293.745 103.255C290.311 101.469 286.909 100.54 283.091 101.138L282.103 101.293L282.115 101.369C278.291 102.255 275.438 104.702 273.833 108.804C272.126 113.168 271.843 119.36 273.105 127.5C273.249 128.428 273.503 129.339 273.738 130.185L273.746 130.211C273.89 130.731 274.028 131.226 274.142 131.711L241.242 136.862C240.465 134.058 239.898 130.414 239.159 125.649C236.059 105.652 238.499 90.2821 244.81 79.446C251.105 68.6378 261.321 62.2203 274.06 60.2258C283.596 58.7327 291.242 59.6302 297.818 61.9301C304.407 64.2347 309.975 67.9653 315.34 72.2206Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        d: "M292.179 -56.9295L292.37 -57.2966L292.352 -57.3526L301.854 -75.6471L361.496 -44.2691L338.629 -0.241775C322.356 31.0905 300.658 42.9482 277.565 44.2706C265.48 24.4864 262.733 -0.232558 279.024 -31.6005L292.179 -56.9295Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("defs", {
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("clipPath", {
                                    id: "clip0_985_48434",
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        d: "M0 8C0 3.58172 3.58172 0 8 0H386C390.418 0 394 3.58172 394 8V96H0V8Z",
                                        fill: "white"
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$textWrapperStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$emailStyles,
                        children: email
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$tagsWrapperStyles,
                        children: tags.map((tag, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$tagItemStyles,
                                children: tag
                            }, index))
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$contentWrapperStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: 0,
    margin: 0,
    height: "100%",
    borderRadius: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$coverImageWrapperStyles = (0, $74Zh5.css)({
    width: "100%",
    overflow: "hidden",
    borderTopLeftRadius: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    borderTopRightRadius: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$coverImageStyles = (0, $74Zh5.css)({
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface.sunken"),
    width: "100%",
    height: "82px",
    objectFit: "cover",
    margin: 0,
    padding: 0,
    display: "block"
});
const $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$textWrapperStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "24px",
    boxSizing: "border-box",
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$emailStyles = (0, $74Zh5.css)({
    fontFamily: "Inter",
    marginBottom: "12px",
    fontSize: "16px",
    color: "#44546F",
    lineHeight: "24px"
});
const $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$tagsWrapperStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    gap: "8px"
});
const $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$tagItemStyles = (0, $74Zh5.css)({
    display: "inline-block"
});
const $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$dropdownWrapperStyles = (0, $74Zh5.css)({
    position: "absolute",
    top: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    right: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
});
var $24c02ea0e14dbe4f$var$$db9d361cdef36cb6$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$db9d361cdef36cb6$exports, "UnifiedAccountContainerCard", ()=>$24c02ea0e14dbe4f$export$c9d2f1697787ae74);
const $24c02ea0e14dbe4f$export$c9d2f1697787ae74 = ({ children: children, testId: testId, onClick: onClick, isAddAccount: isAddAccount = false })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
        "data-testid": testId,
        css: [
            $24c02ea0e14dbe4f$var$$db9d361cdef36cb6$var$unstyledButtonStyles,
            $24c02ea0e14dbe4f$var$$db9d361cdef36cb6$var$cardContainerStyles,
            isAddAccount && $24c02ea0e14dbe4f$var$$db9d361cdef36cb6$var$addAccountStyles,
            isAddAccount ? $24c02ea0e14dbe4f$var$$db9d361cdef36cb6$var$hoverEffectStyles : $24c02ea0e14dbe4f$var$$db9d361cdef36cb6$var$noPointerCursorStyles
        ],
        onClick: isAddAccount ? onClick : undefined,
        children: children
    });
};
const $24c02ea0e14dbe4f$var$$db9d361cdef36cb6$var$unstyledButtonStyles = (0, $74Zh5.css)({
    display: "flex",
    textAlign: "inherit",
    textDecoration: "none",
    background: "none",
    color: "inherit",
    border: "none",
    padding: 0,
    fontFamily: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("font.family.brand.body")
});
const $24c02ea0e14dbe4f$var$$db9d361cdef36cb6$var$cardContainerStyles = (0, $74Zh5.css)({
    position: "relative",
    textDecoration: "none",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    borderRadius: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface"),
    alignItems: "center",
    zIndex: 1,
    justifyContent: "center",
    height: "194px",
    transition: "box-shadow 0.2s ease",
    width: "300px",
    "@media (min-width: 768px) and (max-width: 1279px)": {
        width: "290px"
    },
    "@media (min-width: 1280px)": {
        width: "290px"
    }
});
const $24c02ea0e14dbe4f$var$$db9d361cdef36cb6$var$hoverEffectStyles = (0, $74Zh5.css)({
    cursor: "pointer",
    "&:hover": {
        boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    },
    "&:active": {
        outline: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $24c02ea0e14dbe4f$var$$db9d361cdef36cb6$var$noPointerCursorStyles = (0, $74Zh5.css)({
    cursor: "default"
});
const $24c02ea0e14dbe4f$var$$db9d361cdef36cb6$var$addAccountStyles = (0, $74Zh5.css)({
    border: `1px dashed ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    boxShadow: "none"
});
var $24c02ea0e14dbe4f$var$$e6da040d2ca2c72a$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$e6da040d2ca2c72a$exports, "UnifiedAccountLinkAccountCard", ()=>$24c02ea0e14dbe4f$export$fc13faf098015d3a);
const $24c02ea0e14dbe4f$var$$5089616a215e9052$var$ellipseStyles = (0, $74Zh5.css)({
    width: "72px",
    height: "72px",
    backgroundColor: "#D3F1A7",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $24c02ea0e14dbe4f$var$$5089616a215e9052$export$f21ab0717a89c77f = ()=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$5089616a215e9052$var$ellipseStyles,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($1a8d9f6b66868ddc$exports))), {
            label: "Add",
            size: "large",
            primaryColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
        })
    });
};
const $24c02ea0e14dbe4f$var$$e6da040d2ca2c72a$var$contentStyles = (0, $74Zh5.css)({
    textAlign: "center",
    padding: "17px 48px",
    fontFamily: "Inter, sans-serif",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%"
});
const $24c02ea0e14dbe4f$var$$e6da040d2ca2c72a$var$textStyles = (0, $74Zh5.css)({
    marginTop: "16px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon"),
    fontSize: "16px",
    lineHeight: "24px"
});
const $24c02ea0e14dbe4f$export$fc13faf098015d3a = ()=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$e6da040d2ca2c72a$var$contentStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$5089616a215e9052$export$f21ab0717a89c77f, {}),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$e6da040d2ca2c72a$var$textStyles,
                children: "Link account"
            })
        ]
    });
};
var $24c02ea0e14dbe4f$var$$9c7edcd33b2e220b$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$9c7edcd33b2e220b$exports, "UnifiedAccountTagContainer", ()=>$24c02ea0e14dbe4f$export$b27c6704e245f018);
const $24c02ea0e14dbe4f$export$b27c6704e245f018 = ({ children: children })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$9c7edcd33b2e220b$var$containerStyles,
        children: children
    });
};
const $24c02ea0e14dbe4f$var$$9c7edcd33b2e220b$var$containerStyles = (0, $74Zh5.css)({
    maxWidth: "84px",
    height: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    boxSizing: "border-box",
    borderRadius: "4px"
});
var $24c02ea0e14dbe4f$var$$3ec1f71319ba0295$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3ec1f71319ba0295$exports, "UnifiedAccountTagLoggedIn", ()=>$24c02ea0e14dbe4f$export$8bee5cfdbbc2fc0c);
const $24c02ea0e14dbe4f$var$$3ec1f71319ba0295$var$loggedInContentStyles = (0, $74Zh5.css)({
    backgroundColor: "#626F86",
    color: "#FFFFFF"
});
const $24c02ea0e14dbe4f$export$8bee5cfdbbc2fc0c = ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$b27c6704e245f018, {
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: [
                $24c02ea0e14dbe4f$var$$3ec1f71319ba0295$var$loggedInContentStyles,
                $24c02ea0e14dbe4f$var$$3ec1f71319ba0295$var$baseContentStyles
            ],
            children: "LOGGED IN"
        })
    });
const $24c02ea0e14dbe4f$var$$3ec1f71319ba0295$var$baseContentStyles = (0, $74Zh5.css)({
    width: "84px",
    height: "28px",
    fontFamily: "Charlie Text",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 8px",
    boxSizing: "border-box",
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "4px"
});
var $24c02ea0e14dbe4f$var$$7cbc56ac0bc2e1de$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$7cbc56ac0bc2e1de$exports, "UnifiedAccountTagPrimary", ()=>$24c02ea0e14dbe4f$export$be7f7dedc3a0e1ad);
const $24c02ea0e14dbe4f$var$$5f6e50d159d7e8e1$var$StarFilledIcon = ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
            id: "Icon / <StarFilledIcon>",
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("rect", {
                    width: "12",
                    height: "12",
                    rx: "6",
                    fill: "#44546F"
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                    id: "Vector",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6.0357 8.64198L4.0832 9.66848C4.00063 9.7119 3.90755 9.73135 3.8145 9.72463C3.72146 9.71791 3.63214 9.68529 3.55666 9.63046C3.48118 9.57563 3.42255 9.50078 3.38739 9.41437C3.35223 9.32796 3.34194 9.23344 3.3577 9.14149L3.7302 6.96698L2.1507 5.42698C2.08399 5.36186 2.03683 5.27937 2.01452 5.18886C1.99222 5.09834 1.99566 5.00338 2.02447 4.91472C2.05328 4.82605 2.10631 4.74721 2.17756 4.68709C2.24881 4.62697 2.33545 4.58797 2.4277 4.57448L4.6107 4.25698L5.5872 2.27898C5.62846 2.19525 5.69234 2.12474 5.7716 2.07544C5.85087 2.02613 5.94235 2 6.0357 2C6.12905 2 6.22053 2.02613 6.29979 2.07544C6.37906 2.12474 6.44294 2.19525 6.4842 2.27898L7.4602 4.25698L9.6432 4.57448C9.73549 4.58789 9.82219 4.62684 9.89351 4.68693C9.96482 4.74701 10.0179 4.82585 10.0468 4.91453C10.0756 5.00321 10.0791 5.09819 10.0569 5.18875C10.0346 5.2793 9.98741 5.36182 9.9207 5.42698L8.3407 6.96698L8.7137 9.14149C8.72939 9.23337 8.71908 9.32781 8.68394 9.41414C8.64879 9.50048 8.59022 9.57527 8.51482 9.63008C8.43942 9.68488 8.3502 9.71752 8.25724 9.72431C8.16427 9.7311 8.07126 9.71176 7.9887 9.66848L6.0357 8.64198Z",
                    fill: "white"
                })
            ]
        })
    });
var $24c02ea0e14dbe4f$var$$5f6e50d159d7e8e1$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$var$$5f6e50d159d7e8e1$var$StarFilledIcon;
const $24c02ea0e14dbe4f$var$$7cbc56ac0bc2e1de$var$primaryContentStyles = (0, $74Zh5.css)({
    backgroundColor: "#FFFFFF",
    color: "#172B4D",
    border: "1px solid #091E4224"
});
const $24c02ea0e14dbe4f$var$$7cbc56ac0bc2e1de$var$iconWrapperStyles = (0, $74Zh5.css)({
    marginRight: "2px",
    display: "flex",
    alignItems: "center"
});
const $24c02ea0e14dbe4f$export$be7f7dedc3a0e1ad = ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$b27c6704e245f018, {
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: [
                $24c02ea0e14dbe4f$var$$7cbc56ac0bc2e1de$var$primaryContentStyles,
                $24c02ea0e14dbe4f$var$$7cbc56ac0bc2e1de$var$baseContentStyles
            ],
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$7cbc56ac0bc2e1de$var$iconWrapperStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$5f6e50d159d7e8e1$export$2e2bcd8739ae039, {})
                }),
                "PRIMARY"
            ]
        })
    });
const $24c02ea0e14dbe4f$var$$7cbc56ac0bc2e1de$var$baseContentStyles = (0, $74Zh5.css)({
    width: "84px",
    height: "28px",
    fontFamily: "Charlie Text",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 8px",
    boxSizing: "border-box",
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "4px"
});
var $24c02ea0e14dbe4f$var$$01ef21c48d795edb$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$01ef21c48d795edb$exports, "UnifiedAccountTagLinked", ()=>$24c02ea0e14dbe4f$export$446c53c437a3d14a);
const $24c02ea0e14dbe4f$var$$01ef21c48d795edb$var$primaryContentStyles = (0, $74Zh5.css)({
    backgroundColor: "#FFFFFF",
    color: "#172B4D",
    border: "1px solid #091E4224"
});
const $24c02ea0e14dbe4f$export$446c53c437a3d14a = ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$b27c6704e245f018, {
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: [
                $24c02ea0e14dbe4f$var$$01ef21c48d795edb$var$primaryContentStyles,
                $24c02ea0e14dbe4f$var$$01ef21c48d795edb$var$baseContentStyles
            ],
            children: "LINKED"
        })
    });
const $24c02ea0e14dbe4f$var$$01ef21c48d795edb$var$baseContentStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Text",
    height: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 8px",
    boxSizing: "border-box",
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "4px"
});
var $24c02ea0e14dbe4f$var$$fff41b96fcd62262$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fff41b96fcd62262$exports, "WelcomeModal", ()=>$24c02ea0e14dbe4f$export$9d12d42929c3fcf);
const $24c02ea0e14dbe4f$export$9d12d42929c3fcf = ({ onAccept: onAccept, onCancel: onCancel, coverImageSrc: coverImageSrc })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $73c4314b1cf0d4b0$export$2e2bcd8739ae039), {
        onClose: onCancel,
        width: "auto",
        shouldCloseOnEscapePress: false,
        shouldCloseOnOverlayClick: false,
        shouldScrollInViewport: true,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalContainerStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalImageContainerStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                        src: coverImageSrc,
                        alt: "cover",
                        css: $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$coverImageStyles
                    })
                }),
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalBodyStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("h1", {
                            css: $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalHeadingContainerStyles,
                            children: "Welcome to the new Atlassian Community"
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                            css: $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalSubheadingContainerStyles,
                            children: "Online forums and learning are now in one easy-to-use experience."
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
                            css: $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalSubheadingContainerStyles,
                            children: [
                                "By continuing, you accept the updated",
                                " ",
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                    href: $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$bc6e44c7f1ae99f6,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "Community Terms of Use"
                                }),
                                " ",
                                "and acknowledge the",
                                " ",
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                    href: $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$30786e8ac20c09d8,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "Privacy Policy"
                                }),
                                ". Your public name, photo, and achievements may be publicly visible and available in search engines."
                            ]
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalButtonContainerStyles,
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$buttonStyle,
                                    children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $123ba5aab151a241$export$2e2bcd8739ae039), {
                                        appearance: "subtle",
                                        onClick: onCancel,
                                        children: [
                                            " ",
                                            "Cancel and logout"
                                        ]
                                    })
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$buttonStyle,
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $123ba5aab151a241$export$2e2bcd8739ae039), {
                                        appearance: "primary",
                                        onClick: onAccept,
                                        children: "Accept and continue"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
const $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$buttonStyle = (0, $74Zh5.css)({
    fontSize: "16px",
    "& span": {
        fontWeight: "600"
    }
});
const $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$coverImageStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "auto",
    display: "block"
});
const $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalContainerStyles = (0, $74Zh5.css)({
    maxWidth: "600px",
    margin: "0 auto"
});
const $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalImageContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    overflow: "hidden"
});
const $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalBodyStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "24px"
});
const $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalHeadingContainerStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "32px",
    paddingTop: "24px",
    fontWeight: 700,
    textAlign: "center"
});
const $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalSubheadingContainerStyles = (0, $74Zh5.css)({
    fontSize: "16px",
    marginTop: "16px",
    fontFamily: "Inter",
    textAlign: "center",
    marginBottom: "24px"
});
const $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalButtonContainerStyles = (0, $74Zh5.css)({
    paddingTop: "16px",
    display: "flex",
    justifyContent: "center",
    gap: "8px"
});
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports, $24c02ea0e14dbe4f$var$$1ca64a7075ab6eae$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports, $24c02ea0e14dbe4f$var$$60ab015507144a2b$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports, $24c02ea0e14dbe4f$var$$57b1d5df6b5425d4$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports, $24c02ea0e14dbe4f$var$$4be7278e65b71184$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports, $24c02ea0e14dbe4f$var$$db9d361cdef36cb6$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports, $24c02ea0e14dbe4f$var$$e6da040d2ca2c72a$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports, $24c02ea0e14dbe4f$var$$9c7edcd33b2e220b$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports, $24c02ea0e14dbe4f$var$$3ec1f71319ba0295$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports, $24c02ea0e14dbe4f$var$$7cbc56ac0bc2e1de$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports, $24c02ea0e14dbe4f$var$$fc6addd2061b87dd$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports, $24c02ea0e14dbe4f$var$$01ef21c48d795edb$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports, $24c02ea0e14dbe4f$var$$fff41b96fcd62262$exports);
const $24c02ea0e14dbe4f$var$$2db63308c0b2527b$export$b56677d67e73c7be = ({ response: response, isLoading: isLoading })=>{
    const { message: message, isError: responseError } = response;
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$2db63308c0b2527b$var$inputStyles,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
            name: "email",
            label: "Email address",
            defaultValue: "",
            children: ({ fieldProps: fieldProps, error: error, meta: meta })=>{
                const validationErrorMessage = meta.dirtySinceLastSubmit ? undefined : error;
                const displayMessage = validationErrorMessage || message;
                const displayType = error || responseError ? "error" : "valid";
                return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                    children: [
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $24c02ea0e14dbe4f$var$$2db63308c0b2527b$var$inputButtonFlex,
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2c73285ae9390cec, {
                                    ...fieldProps,
                                    required: true,
                                    type: "email",
                                    autoComplete: "off",
                                    placeholder: "yourname@email.com"
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $24c02ea0e14dbe4f$var$$2db63308c0b2527b$export$a3b9b213fa74e4fd,
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                        as: "button",
                                        label: "Sign up",
                                        type: "submit",
                                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                                        isLoading: isLoading
                                    })
                                })
                            ]
                        }),
                        displayMessage ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$9144c5f9beecc4b7, {
                            type: displayType,
                            message: displayMessage
                        }) : null
                    ]
                });
            }
        })
    });
};
const $24c02ea0e14dbe4f$var$$2db63308c0b2527b$var$inputStyles = (0, $74Zh5.css)({
    "& label": {
        fontWeight: 400
    }
});
const $24c02ea0e14dbe4f$var$$2db63308c0b2527b$var$inputButtonFlex = (0, $74Zh5.css)({
    display: "flex",
    alignContent: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$2db63308c0b2527b$export$a3b9b213fa74e4fd = ({ isMobile: isMobile })=>(0, $74Zh5.css)({
        minWidth: "fit-content",
        display: isMobile ? "none" : "block",
        marginTop: isMobile ? (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200") : 0,
        [$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
            minWidth: "100%",
            display: isMobile ? "block" : "none"
        }
    });
const $24c02ea0e14dbe4f$var$$d51a9a1c56c91a16$export$eefa3b352a86957 = "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers";
const $24c02ea0e14dbe4f$var$$d51a9a1c56c91a16$export$ecf6508459835aaf = "By signing up, you agree to receive promotional emails including product news, events, and more from Atlassian and its affiliates, and acknowledge and accept the ";
const $24c02ea0e14dbe4f$var$$d51a9a1c56c91a16$export$ec00f1754868e2a2 = ({ response: response, onSubmit: onSubmit, onPrivacyPolicyClick: onPrivacyPolicyClick })=>{
    const handleSubmit = async (data, form)=>{
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const errors = {
            email: !emailPattern.test(data.email) ? "Enter a valid email address." : undefined
        };
        if (!errors.email) {
            await onSubmit(data);
            form.reset();
        }
        return errors;
    };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $916dd591feb93e13$export$2e2bcd8739ae039), {
        onSubmit: handleSubmit,
        children: ({ formProps: formProps, submitting: submitting })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("form", {
                ...formProps,
                css: $24c02ea0e14dbe4f$var$$d51a9a1c56c91a16$var$formWrapperStyles,
                "data-testid": "signup-form",
                noValidate: true,
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$d51a9a1c56c91a16$var$formActionStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$2db63308c0b2527b$export$b56677d67e73c7be, {
                                response: response,
                                isLoading: submitting
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$2db63308c0b2527b$export$a3b9b213fa74e4fd({
                                    isMobile: true
                                }),
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                    as: "button",
                                    label: "Sign up",
                                    type: "submit",
                                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                                    isLoading: submitting,
                                    fullWidth: true
                                })
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
                        css: $24c02ea0e14dbe4f$var$$d51a9a1c56c91a16$var$acknowledgeStyle,
                        children: [
                            $24c02ea0e14dbe4f$var$$d51a9a1c56c91a16$export$ecf6508459835aaf,
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                href: $24c02ea0e14dbe4f$var$$d51a9a1c56c91a16$export$eefa3b352a86957,
                                target: "_blank",
                                onClick: onPrivacyPolicyClick,
                                rel: "noreferrer",
                                children: "Atlassian Privacy Policy"
                            }),
                            "."
                        ]
                    })
                ]
            })
    });
};
const $24c02ea0e14dbe4f$var$$d51a9a1c56c91a16$var$formWrapperStyles = (0, $74Zh5.css)({
    width: "100%",
    paddingLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.800"),
    paddingRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.800"),
    [$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
        padding: 0
    },
    [$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MEDIA_QUERY]: {
        marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
    },
    [$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MEDIA_QUERY]: {
        marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400")
    }
});
const $24c02ea0e14dbe4f$var$$d51a9a1c56c91a16$var$formActionStyles = (0, $74Zh5.css)({
    [$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
        flexDirection: "column",
        gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
    }
});
const $24c02ea0e14dbe4f$var$$d51a9a1c56c91a16$var$acknowledgeStyle = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    maxWidth: "405px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontWeight: "400",
    fontSize: "12px",
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    "& a": {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")
    },
    [$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
        maxWidth: "unset"
    }
});
const $24c02ea0e14dbe4f$var$$eb8aa702a3355ad4$export$260d8f4a67dc36b0 = ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
        "data-testid": "open-letter",
        width: "124",
        height: "118",
        viewBox: "0 0 124 118",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("g", {
            id: "Spot/Basics/Letter open",
            children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                id: "Vector",
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_2",
                        d: "M61.8877 12.0239L11 54.5804V105.981H112.775V54.5804L61.8877 12.0239Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_3",
                        d: "M100.759 28.2393H23.0166V105.981H100.759V28.2393Z",
                        fill: "#FCA700"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_4",
                        d: "M81.2754 28.2393H42.4938L23.0166 44.5319V105.981H100.759V44.5319L81.2754 28.2393Z",
                        fill: "#164B35"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_5",
                        d: "M94.3773 34.6199H29.3916V99.6056H94.3773V34.6199Z",
                        fill: "#DDDEE1"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_6",
                        d: "M88.2168 41.562H36.7148V43.9475H88.2168V41.562Z",
                        fill: "#FCA700"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_7",
                        d: "M88.2168 51.1689H36.7148V53.5544H88.2168V51.1689Z",
                        fill: "#FCA700"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_8",
                        d: "M88.2168 60.7825H36.7148V63.1679H88.2168V60.7825Z",
                        fill: "#FCA700"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_9",
                        d: "M88.2168 70.3901H36.7148V72.7756H88.2168V70.3901Z",
                        fill: "#FCA700"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_10",
                        d: "M88.2168 80.0034H36.7148V82.3889H88.2168V80.0034Z",
                        fill: "#FCA700"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_11",
                        d: "M88.2168 89.6106H36.7148V91.9961H88.2168V89.6106Z",
                        fill: "#FCA700"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_12",
                        d: "M72.2824 105.981L11.1074 54.5923L11.2088 105.981H72.2824Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_13",
                        d: "M51.4873 105.981L112.662 54.5923L112.567 105.981H51.4873Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_14",
                        d: "M51.4873 105.981H72.2825L61.8879 97.2446L51.4873 105.981Z",
                        fill: "#09326C"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_15",
                        d: "M61.8877 12.0239L11 54.5804V105.981H112.775V54.5804L61.8877 12.0239Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_16",
                        d: "M100.759 28.2393H23.0166V105.981H100.759V28.2393Z",
                        fill: "#FCA700"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_17",
                        d: "M81.2754 28.2393H42.4938L23.0166 44.5319V105.981H100.759V44.5319L81.2754 28.2393Z",
                        fill: "#164B35"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_18",
                        d: "M94.3773 34.6199H29.3916V99.6056H94.3773V34.6199Z",
                        fill: "#DDDEE1"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_19",
                        d: "M51.0637 80.5821L49.6444 80.767C49.6444 80.767 47.1873 80.5642 46.2033 80.9041L42.5059 80.7491C42.5059 80.7491 40.9613 80.8385 40.4961 81.0532C40.2039 81.1844 40.0191 81.3454 39.9773 81.4945C39.8938 81.7927 40.4127 82.0432 41.9036 81.9478C41.9215 81.9656 41.9811 81.9835 41.9871 82.0074C43.5615 81.7987 45.0762 82.1863 46.6804 82.1446C46.6626 82.0551 46.7162 81.9895 46.7639 82.0312L46.746 82.1386C47.8135 81.9239 48.4815 82.2817 49.4595 81.912C49.4595 81.912 49.3402 82.0551 49.3462 82.0551C52.6918 82.0014 57.2241 82.1744 60.85 82.0193L60.8321 82.0014V81.9835C60.5041 81.8702 58.8999 81.7032 58.8999 81.7032C60.1106 81.1784 61.4762 81.739 62.7584 81.7211L62.7465 81.8643C62.1919 81.8583 61.6969 81.9179 61.5001 81.9776C63.4919 82.1803 67.4876 82.234 69.3959 82.0253C69.3482 81.9179 68.7578 82.1505 68.6087 81.7987C69.0978 81.7987 69.5868 81.7509 70.046 81.7569C70.046 81.9835 69.7776 81.906 69.7239 81.9478C70.5171 82.1982 86.7322 82.5441 82.8618 81.5542L82.9632 81.4349C81.9613 81.3812 81.1324 81.3335 80.0947 81.1009C79.9456 81.1188 79.9277 81.1009 79.9277 81.2142C79.886 81.2321 79.8204 81.2679 79.8383 81.3156C79.8502 81.6019 79.5281 81.4886 79.385 81.4945C79.5639 80.6059 76.1527 81.3872 75.6995 81.3514C75.616 80.928 74.8109 81.3335 74.5366 81.1486C74.5545 81.1307 74.6797 81.0413 74.6916 81.0234C74.4471 80.7491 70.4217 81.4826 71.5727 80.9638C66.8196 80.0454 58.1962 81.0771 53.0615 80.272L53.0973 80.3256C53.0556 80.3078 52.9303 80.3316 52.9005 80.272C52.3936 80.439 51.0577 80.5582 51.0577 80.5582L51.0637 80.5821ZM62.8419 81.1486C62.8419 81.1486 62.8479 81.1248 62.8419 81.1188C62.8419 81.1606 63.5039 81.1367 63.5277 81.1486V81.2917C62.8538 81.5601 61.3212 80.588 62.7763 81.0174C62.824 80.9816 62.824 81.1009 62.8359 81.1486H62.8419ZM68.7101 81.1963C68.8234 81.2083 68.9487 81.2202 69.0858 81.2321C67.5651 81.6675 65.5136 81.1069 63.8438 81.3037C64.4163 80.6775 65.77 81.0174 66.4916 81.0592C67.2132 80.922 68.072 81.095 68.7101 81.1963ZM78.5143 81.3514V81.2798H78.574C78.574 81.2977 78.568 81.3216 78.5561 81.3335C78.5501 81.3454 78.5263 81.3633 78.5143 81.3573V81.3514ZM51.8688 80.922C51.9821 80.8087 52.4055 80.8743 52.1252 81.1009C52.0537 81.0651 51.8449 81.1665 51.8688 80.922ZM70.4276 81.3752C70.4276 81.1427 70.9882 81.1009 70.9882 81.417C70.7974 81.417 70.6125 81.3991 70.4276 81.3752ZM47.7121 81.1427C47.5631 81.3872 47.6048 81.1128 47.5571 80.9578C47.5929 80.9936 47.73 81.0055 47.7002 81.1188L47.7121 81.1427ZM45.1001 81.2739C45.0643 81.3931 44.9152 81.4707 44.8436 81.4766C44.6647 81.3812 45.0166 81.1665 45.1001 81.2739ZM40.8003 81.2739C40.7943 81.411 40.6929 81.4587 40.6631 81.3216C40.6751 81.2202 40.8003 81.1427 40.8182 81.2977C40.8182 81.2918 40.8182 81.2798 40.8003 81.2739ZM73.0039 81.8881C72.8489 82.2936 72.342 81.9597 72.0676 82.067C72.1332 81.6615 72.6223 81.9656 72.831 81.8941C72.9025 81.8941 72.9622 81.8941 73.0039 81.8881ZM56.0851 81.6973C56.0851 82.0551 55.5186 81.7688 55.3277 81.8464V81.7032C55.614 81.6675 55.7869 81.578 56.0732 81.6973H56.0851ZM67.7977 81.9776C67.6903 82.1207 67.5114 81.9835 67.3981 81.9835C67.3981 81.7808 67.8692 81.751 67.7977 81.9776ZM63.0447 81.8941C63.0208 81.6734 63.2534 81.7808 63.325 81.7629C63.2772 81.8106 63.1878 81.9478 63.1341 81.9418C63.0983 81.9418 63.0864 81.912 63.0447 81.8941ZM56.2938 81.5601C56.5145 81.5601 56.753 81.5601 56.9796 81.572V81.7152C56.7411 81.7152 56.5145 81.7092 56.2879 81.7032V81.5601H56.2938ZM58.5183 81.7927V81.9358C58.1962 82.067 58.1604 81.7032 58.5123 81.7927H58.5183ZM53.4193 81.7092C53.4551 81.7152 53.5028 81.7271 53.5386 81.7271C53.9978 81.7152 53.3478 82.228 53.4193 81.7092ZM51.01 81.8344C50.9623 81.8523 50.9027 81.8941 50.855 81.8941C50.533 81.8762 50.8908 81.5363 51.01 81.8344Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_20",
                        d: "M72.2824 105.981L11.1074 54.5923L11.2088 105.981H72.2824Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_21",
                        d: "M51.4873 105.981L112.662 54.5923L112.567 105.981H51.4873Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_22",
                        d: "M51.4873 105.981H72.2825L61.8879 97.2446L51.4873 105.981Z",
                        fill: "#09326C"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_23",
                        d: "M51.0637 44.3943L49.6444 44.5792C49.6444 44.5792 47.1873 44.3764 46.2033 44.7164L42.5059 44.5613C42.5059 44.5613 40.9613 44.6508 40.4961 44.8655C40.2039 45.0026 40.0191 45.1577 39.9773 45.3068C39.8938 45.605 40.4127 45.8554 41.9036 45.76C41.9215 45.7779 41.9811 45.7958 41.9871 45.8196C43.5615 45.6109 45.0762 45.9986 46.6804 45.9568C46.6626 45.8674 46.7162 45.8018 46.7639 45.8435L46.746 45.9508C47.8135 45.7362 48.4815 46.094 49.4595 45.7242C49.4595 45.7242 49.3402 45.8674 49.3462 45.8674C52.6918 45.8137 57.2241 45.9866 60.85 45.8316L60.8321 45.8137V45.7958C60.5041 45.6825 58.8999 45.5155 58.8999 45.5155C60.1106 44.9907 61.4762 45.5513 62.7584 45.5334L62.7465 45.6765C62.1919 45.6706 61.6969 45.7302 61.5001 45.7898C63.4919 45.9926 67.4876 46.0463 69.3959 45.8375C69.3482 45.7302 68.7578 45.9628 68.6087 45.6109C69.0978 45.6109 69.5868 45.5632 70.046 45.5692C70.046 45.7958 69.7776 45.7183 69.7239 45.76C70.5171 46.0105 86.7322 46.3564 82.8618 45.3664L82.9632 45.2471C81.9613 45.1935 81.1324 45.1458 80.0947 44.9132C79.9456 44.9311 79.9277 44.9132 79.9277 45.0265C79.886 45.0444 79.8204 45.0802 79.8383 45.1279C79.8502 45.4141 79.5281 45.3008 79.385 45.3068C79.5639 44.4182 76.1527 45.1994 75.6995 45.1636C75.616 44.7402 74.8109 45.1458 74.5366 44.9609C74.5545 44.943 74.6797 44.8535 74.6916 44.8356C74.4471 44.5613 70.4217 45.2948 71.5727 44.776C66.8196 43.8576 58.1962 44.8893 53.0615 44.0842L53.0973 44.1379C53.0556 44.12 52.9303 44.1439 52.9005 44.0842C52.3936 44.2512 51.0577 44.3705 51.0577 44.3705L51.0637 44.3943ZM62.8419 44.9549C62.8419 44.9549 62.8479 44.9311 62.8419 44.9251C62.8419 44.9668 63.5039 44.943 63.5277 44.9549V45.098C62.8538 45.3664 61.3212 44.4003 62.7763 44.8237C62.824 44.7879 62.824 44.9072 62.8359 44.9549H62.8419ZM68.7101 45.0026C68.8234 45.0146 68.9487 45.0265 69.0858 45.0384C67.5651 45.4738 65.5136 44.9132 63.8438 45.11C64.4163 44.4838 65.77 44.8237 66.4916 44.8655C67.2132 44.7283 68.072 44.9012 68.7101 45.0026ZM78.5143 45.1577V45.0861H78.574C78.574 45.104 78.568 45.1279 78.5561 45.1398C78.5501 45.1517 78.5263 45.1696 78.5143 45.1636V45.1577ZM51.8688 44.7283C51.9821 44.615 52.4055 44.6806 52.1252 44.9072C52.0537 44.8714 51.8449 44.9728 51.8688 44.7283ZM70.4276 45.1815C70.4276 44.949 70.9882 44.9012 70.9882 45.2233C70.7974 45.2233 70.6125 45.2054 70.4276 45.1815ZM47.7121 44.949C47.5631 45.1935 47.6048 44.9191 47.5571 44.7641C47.5929 44.7999 47.73 44.8118 47.7002 44.9251L47.7121 44.949ZM45.1001 45.0802C45.0643 45.1994 44.9152 45.277 44.8436 45.2829C44.6647 45.1875 45.0166 44.9728 45.1001 45.0802ZM40.8003 45.0802C40.7943 45.2173 40.6929 45.265 40.6631 45.1279C40.6751 45.0265 40.8003 44.949 40.8182 45.104C40.8182 45.098 40.8182 45.0861 40.8003 45.0802ZM73.0039 45.6944C72.8489 46.0999 72.342 45.766 72.0676 45.8733C72.1332 45.4678 72.6223 45.7719 72.831 45.7004C72.9025 45.7004 72.9622 45.7004 73.0039 45.6944ZM56.0851 45.5036C56.0851 45.8614 55.5186 45.5751 55.3277 45.6527V45.5095C55.614 45.4738 55.7869 45.3843 56.0732 45.5036H56.0851ZM67.7977 45.7839C67.6903 45.927 67.5114 45.7898 67.3981 45.7898C67.3981 45.5871 67.8692 45.5572 67.7977 45.7839ZM63.0447 45.7004C63.0208 45.4797 63.2534 45.5871 63.325 45.5692C63.2772 45.6169 63.1878 45.754 63.1341 45.7481C63.0983 45.7481 63.0864 45.7183 63.0447 45.7004ZM56.2938 45.3664C56.5145 45.3664 56.753 45.3664 56.9796 45.3783V45.5215C56.7411 45.5215 56.5145 45.5155 56.2879 45.5095V45.3664H56.2938ZM58.5183 45.599V45.7421C58.1962 45.8733 58.1604 45.5095 58.5123 45.599H58.5183ZM53.4193 45.5155C53.4551 45.5215 53.5028 45.5334 53.5386 45.5334C53.9978 45.5215 53.3478 46.0343 53.4193 45.5155ZM51.01 45.6407C50.9623 45.6586 50.9027 45.7004 50.855 45.6944C50.533 45.6765 50.8908 45.3366 51.01 45.6407Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_24",
                        d: "M51.0637 56.4532L49.6444 56.638C49.6444 56.638 47.1873 56.4353 46.2033 56.7752L42.5059 56.6202C42.5059 56.6202 40.9613 56.7096 40.4961 56.9243C40.2039 57.0615 40.0191 57.2165 39.9773 57.3656C39.8938 57.6638 40.4127 57.9143 41.9036 57.8188C41.9215 57.8367 41.9811 57.8546 41.9871 57.8785C43.5615 57.6698 45.0762 58.0574 46.6804 58.0156C46.6626 57.9262 46.7162 57.8606 46.7639 57.9023L46.746 58.0097C47.8135 57.795 48.4815 58.1528 49.4595 57.7831C49.4595 57.7831 49.3402 57.9262 49.3462 57.9262C52.6918 57.8725 57.2241 58.0455 60.85 57.8904L60.8321 57.8725V57.8546C60.5041 57.7413 58.8999 57.5743 58.8999 57.5743C60.1106 57.0495 61.4762 57.6101 62.7584 57.5922L62.7465 57.7354C62.1919 57.7294 61.6969 57.789 61.5001 57.8487C63.4919 58.0514 67.4876 58.1051 69.3959 57.8964C69.3482 57.789 68.7578 58.0216 68.6087 57.6698C69.0978 57.6698 69.5868 57.6221 70.046 57.628C70.046 57.8546 69.7776 57.7771 69.7239 57.8188C70.5171 58.0693 86.7322 58.4152 82.8618 57.4253L82.9632 57.306C81.9613 57.2523 81.1324 57.2046 80.0947 56.972C79.9456 56.9899 79.9277 56.972 79.9277 57.0853C79.886 57.1032 79.8204 57.139 79.8383 57.1867C79.8502 57.473 79.5281 57.3597 79.385 57.3656C79.5639 56.477 76.1527 57.2583 75.6995 57.2225C75.616 56.7991 74.8109 57.2046 74.5366 57.0197C74.5545 57.0018 74.6797 56.9124 74.6916 56.8945C74.4471 56.6202 70.4217 57.3537 71.5727 56.8349C66.8196 55.9165 58.1962 56.9482 53.0615 56.1431L53.0973 56.1967C53.0556 56.1789 52.9303 56.2027 52.9005 56.1431C52.3936 56.31 51.0577 56.4293 51.0577 56.4293L51.0637 56.4532ZM62.8419 57.0197C62.8419 57.0197 62.8479 56.9959 62.8419 56.9899C62.8419 57.0316 63.5039 57.0078 63.5277 57.0197V57.1629C62.8538 57.4312 61.3212 56.4591 62.7763 56.8885C62.824 56.8527 62.824 56.972 62.8359 57.0197H62.8419ZM68.7101 57.0674C68.8234 57.0794 68.9487 57.0913 69.0858 57.1032C67.5651 57.5386 65.5136 56.978 63.8438 57.1748C64.4163 56.5486 65.77 56.8885 66.4916 56.9303C67.2132 56.7931 68.072 56.9661 68.7101 57.0674ZM78.5143 57.2225V57.1509H78.574C78.574 57.1688 78.568 57.1927 78.5561 57.2046C78.5501 57.2225 78.5263 57.2344 78.5143 57.2285V57.2225ZM51.8688 56.7931C51.9821 56.6798 52.4055 56.7454 52.1252 56.972C52.0537 56.9362 51.8449 57.0376 51.8688 56.7931ZM70.4276 57.2463C70.4276 57.0138 70.9882 56.972 70.9882 57.2941C70.7974 57.2941 70.6125 57.2762 70.4276 57.2463ZM47.7121 57.0138C47.5631 57.2583 47.6048 56.9839 47.5571 56.8289C47.5929 56.8647 47.73 56.8766 47.7002 56.9899L47.7121 57.0138ZM45.1001 57.145C45.0643 57.2642 44.9152 57.3418 44.8436 57.3477C44.6647 57.2523 45.0166 57.0376 45.1001 57.145ZM40.8003 57.145C40.7943 57.2821 40.6929 57.3298 40.6631 57.1927C40.6751 57.0913 40.8003 57.0138 40.8182 57.1688C40.8182 57.1628 40.8182 57.1509 40.8003 57.145ZM73.0039 57.7592C72.8489 58.1647 72.342 57.8308 72.0676 57.9381C72.1332 57.5326 72.6223 57.8367 72.831 57.7652C72.9025 57.7652 72.9622 57.7652 73.0039 57.7592ZM56.0851 57.5684C56.0851 57.9262 55.5186 57.6399 55.3277 57.7175V57.5743C55.614 57.5386 55.7869 57.4491 56.0732 57.5684H56.0851ZM67.7977 57.8487C67.6903 57.9918 67.5114 57.8487 67.3981 57.8546C67.3981 57.6519 67.8692 57.622 67.7977 57.8487ZM63.0447 57.7652C63.0208 57.5445 63.2534 57.6519 63.325 57.634C63.2772 57.6817 63.1878 57.8189 63.1341 57.8129C63.0983 57.8129 63.0864 57.7831 63.0447 57.7652ZM56.2938 57.4312C56.5145 57.4312 56.753 57.4312 56.9796 57.4431V57.5863C56.7411 57.5863 56.5145 57.5803 56.2879 57.5743V57.4312H56.2938ZM58.5183 57.6638V57.8069C58.1962 57.9381 58.1604 57.5743 58.5123 57.6638H58.5183ZM53.4193 57.5803C53.4551 57.5863 53.5028 57.5982 53.5386 57.5982C53.9978 57.5863 53.3478 58.0991 53.4193 57.5803ZM51.01 57.7055C50.9623 57.7234 50.9027 57.7652 50.855 57.7592C50.533 57.7413 50.8908 57.4014 51.01 57.7055Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_25",
                        d: "M51.0637 68.5174L49.6444 68.7022C49.6444 68.7022 47.1873 68.4995 46.2033 68.8394L42.5059 68.6844C42.5059 68.6844 40.9613 68.7738 40.4961 68.9885C40.2039 69.1257 40.0191 69.2807 39.9773 69.4298C39.8938 69.728 40.4127 69.9785 41.9036 69.8831C41.9215 69.9009 41.9811 69.9188 41.9871 69.9427C43.5615 69.734 45.0762 70.1216 46.6804 70.0799C46.6626 69.9904 46.7162 69.9248 46.7639 69.9665L46.746 70.0739C47.8135 69.8592 48.4815 70.217 49.4595 69.8473C49.4595 69.8473 49.3402 69.9904 49.3462 69.9904C52.6918 69.9367 57.2241 70.1097 60.85 69.9546L60.8321 69.9367V69.9188C60.5041 69.8055 58.8999 69.6385 58.8999 69.6385C60.1106 69.1137 61.4762 69.6743 62.7584 69.6564L62.7465 69.7996C62.1919 69.7936 61.6969 69.8532 61.5001 69.9129C63.4919 70.1156 67.4876 70.1693 69.3959 69.9606C69.3482 69.8532 68.7578 70.0858 68.6087 69.734C69.0978 69.734 69.5868 69.6863 70.046 69.6922C70.046 69.9188 69.7776 69.8413 69.7239 69.8831C70.5171 70.1335 86.7322 70.4794 82.8618 69.4895L82.9632 69.3702C81.9613 69.3165 81.1324 69.2688 80.0947 69.0362C79.9456 69.0541 79.9277 69.0362 79.9277 69.1495C79.886 69.1674 79.8204 69.2032 79.8383 69.2509C79.8502 69.5372 79.5281 69.4238 79.385 69.4298C79.5639 68.5412 76.1527 69.3225 75.6995 69.2867C75.616 68.8633 74.8109 69.2688 74.5366 69.0839C74.5545 69.066 74.6797 68.9766 74.6916 68.9587C74.4471 68.6844 70.4217 69.4179 71.5727 68.8991C66.8196 67.9807 58.1962 69.0124 53.0615 68.2073L53.0973 68.2609C53.0556 68.2431 52.9303 68.2669 52.9005 68.2073C52.3936 68.3743 51.0577 68.4935 51.0577 68.4935L51.0637 68.5174ZM62.8419 69.0839C62.8419 69.0839 62.8479 69.0601 62.8419 69.0541C62.8419 69.0959 63.5039 69.072 63.5277 69.0839V69.2271C62.8538 69.4954 61.3212 68.5233 62.7763 68.9527C62.824 68.9169 62.824 69.0362 62.8359 69.0839H62.8419ZM68.7101 69.1316C68.8234 69.1436 68.9487 69.1555 69.0858 69.1674C67.5651 69.6028 65.5136 69.0422 63.8438 69.239C64.4163 68.6128 65.77 68.9527 66.4916 68.9945C67.2132 68.8573 68.072 69.0302 68.7101 69.1316ZM78.5143 69.2867V69.2151H78.574C78.574 69.233 78.568 69.2569 78.5561 69.2688C78.5501 69.2807 78.5263 69.2986 78.5143 69.2927V69.2867ZM51.8688 68.8573C51.9821 68.744 52.4055 68.8096 52.1252 69.0362C52.0537 69.0004 51.8449 69.1018 51.8688 68.8573ZM70.4276 69.3105C70.4276 69.078 70.9882 69.0362 70.9882 69.3583C70.7974 69.3583 70.6125 69.3404 70.4276 69.3105ZM47.7121 69.078C47.5631 69.3225 47.6048 69.0481 47.5571 68.8931C47.5929 68.9289 47.73 68.9408 47.7002 69.0541L47.7121 69.078ZM45.1001 69.2092C45.0643 69.3284 44.9152 69.406 44.8436 69.4119C44.6647 69.3165 45.0166 69.1018 45.1001 69.2092ZM40.8003 69.2092C40.7943 69.3463 40.6929 69.394 40.6631 69.2569C40.6751 69.1555 40.8003 69.078 40.8182 69.233C40.8182 69.227 40.8182 69.2151 40.8003 69.2092ZM73.0039 69.8234C72.8489 70.2289 72.342 69.895 72.0676 70.0023C72.1332 69.5968 72.6223 69.9009 72.831 69.8294C72.9025 69.8294 72.9622 69.8294 73.0039 69.8234ZM56.0851 69.6326C56.0851 69.9904 55.5186 69.7041 55.3277 69.7817V69.6385C55.614 69.6028 55.7869 69.5133 56.0732 69.6326H56.0851ZM67.7977 69.9129C67.6903 70.056 67.5114 69.9129 67.3981 69.9188C67.3981 69.7161 67.8692 69.6863 67.7977 69.9129ZM63.0447 69.8294C63.0208 69.6087 63.2534 69.7161 63.325 69.6982C63.2772 69.7459 63.1878 69.883 63.1341 69.8771C63.0983 69.8771 63.0864 69.8473 63.0447 69.8294ZM56.2938 69.4954C56.5145 69.4954 56.753 69.4954 56.9796 69.5073V69.6505C56.7411 69.6505 56.5145 69.6445 56.2879 69.6385V69.4954H56.2938ZM58.5183 69.728V69.8711C58.1962 70.0023 58.1604 69.6385 58.5123 69.728H58.5183ZM53.4193 69.6445C53.4551 69.6505 53.5028 69.6624 53.5386 69.6624C53.9978 69.6505 53.3478 70.1633 53.4193 69.6445ZM51.01 69.7697C50.9623 69.7876 50.9027 69.8294 50.855 69.8234C50.533 69.8055 50.8908 69.4656 51.01 69.7697Z",
                        fill: "#101214"
                    })
                ]
            })
        })
    });
const $24c02ea0e14dbe4f$export$5620dbefc1cb6f80 = "You\u2019re on the list! Thanks for signing up.";
const $24c02ea0e14dbe4f$export$3f27bc10068ef877 = "Something went wrong. Try again.";
const $24c02ea0e14dbe4f$export$21041608e6399292 = ({ environment: environment, formUrl: formUrl, atlassianId: atlassianId, anonymousId: anonymousId, eventHandlers: eventHandlers = {} })=>{
    const { handleNewsletterSignup: handleNewsletterSignup, error: error, success: success } = $24c02ea0e14dbe4f$export$ea96d97e8873ca7f({
        environment: environment,
        ...eventHandlers
    });
    const { onSubmit: onSubmit = ()=>null, onPrivacyPolicyClick: onPrivacyPolicyClick } = eventHandlers;
    const handleSubmit = async ({ email: email })=>{
        onSubmit();
        await handleNewsletterSignup({
            email: email,
            anonymousId: anonymousId,
            atlassianId: atlassianId
        }, formUrl);
    };
    const successMessage = success ? $24c02ea0e14dbe4f$export$5620dbefc1cb6f80 : undefined;
    const responseMessage = error ? $24c02ea0e14dbe4f$export$3f27bc10068ef877 : successMessage;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$1db60c687807de63$var$signUpWrapper,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$1db60c687807de63$var$stack,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$eb8aa702a3355ad4$export$260d8f4a67dc36b0, {}),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("h2", {
                        css: $24c02ea0e14dbe4f$var$$1db60c687807de63$var$headingStyles,
                        children: [
                            "Sign up for the community ",
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                children: "newsletter"
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: $24c02ea0e14dbe4f$var$$1db60c687807de63$var$descriptionStyles,
                        children: "Get the latest resources, tips, and trends to help you grow."
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$d51a9a1c56c91a16$export$ec00f1754868e2a2, {
                response: {
                    message: responseMessage,
                    isError: Boolean(error)
                },
                onSubmit: handleSubmit,
                onPrivacyPolicyClick: onPrivacyPolicyClick
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$1db60c687807de63$var$signUpWrapper = (0, $74Zh5.css)({
    margin: "0 auto",
    maxWidth: "624px"
});
const $24c02ea0e14dbe4f$var$$1db60c687807de63$var$stack = (0, $74Zh5.css)({
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$1db60c687807de63$var$headingStyles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontSize: "40px",
    fontWeight: 700,
    lineHeight: "48px",
    letterSpacing: "-0.12px",
    marginTop: 0,
    "& span": {
        display: "block",
        [$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
            display: "inline-block"
        }
    },
    [$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MEDIA_QUERY]: {
        fontSize: "32px"
    },
    [$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
        width: "340px",
        fontSize: "32px"
    }
});
const $24c02ea0e14dbe4f$var$$1db60c687807de63$var$descriptionStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontSize: "20px",
    fontWeight: "400",
    lineHeight: "32px",
    marginTop: 0,
    [$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MEDIA_QUERY]: {
        fontSize: "20px"
    },
    [$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
        fontSize: "16px",
        lineHeight: "24px"
    }
});
var $24c02ea0e14dbe4f$var$$2f0c862779035c26$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$2f0c862779035c26$exports, "MarkdownWrapper", ()=>$24c02ea0e14dbe4f$export$e61786c4aee8d415);
const $24c02ea0e14dbe4f$export$e61786c4aee8d415 = ({ children: children, overrides: overrides })=>{
    if (!children) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).isValidElement(children) || typeof children !== "string" ? children : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $igbF4.default), {
        css: $24c02ea0e14dbe4f$var$$2f0c862779035c26$var$defaultStyles,
        options: {
            overrides: overrides
        },
        children: children
    });
};
const $24c02ea0e14dbe4f$var$$2f0c862779035c26$var$defaultStyles = (0, $74Zh5.css)({
    "& > p:first-of-type": {
        margin: 0
    }
});
var $24c02ea0e14dbe4f$var$$6937e97bac512574$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$6937e97bac512574$exports, "TabbedAccordion", ()=>$24c02ea0e14dbe4f$export$187009fd9803261e);
const $24c02ea0e14dbe4f$var$$76fc9668239269ce$var$ResourceCard = ({ description: description, link: link, type: type })=>{
    const handleClick = ()=>{
        window.open(link.link, link.target);
    };
    const hasType = type && type.length > 0;
    const hasDescription = description && description.length > 0;
    const accessibilityLabel = `${link.label}; ${hasType ? `type: ${type}; ` : ""}${hasDescription ? description : ""}`;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$76fc9668239269ce$var$containerStyles,
        onClick: handleClick,
        onKeyDown: (e)=>{
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleClick();
            }
        },
        tabIndex: 0,
        role: "button",
        "aria-label": accessibilityLabel,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$76fc9668239269ce$var$contentStyles,
                children: [
                    hasType && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                        label: type
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a6c7ac8248d6e38a, {
                        ...link,
                        style: $24c02ea0e14dbe4f$export$2b77966d73aefa77.SEMIBOLD,
                        onClick: handleClick,
                        tabIndex: -1
                    }),
                    hasDescription && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: $24c02ea0e14dbe4f$var$$76fc9668239269ce$var$descriptionStyles,
                        children: description
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: "arrow-right",
                    alt: "Arrow right",
                    size: $24c02ea0e14dbe4f$export$ff775019b5b6e7df.MEDIUM
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$76fc9668239269ce$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250")}`,
    alignItems: "center",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface"),
    justifyContent: "space-between",
    "& a": {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.link")
    },
    "& a:hover": {
        textDecoration: "none"
    },
    "&:hover": {
        cursor: "pointer",
        boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
        transition: "box-shadow 0.3s ease-in-out"
    },
    "&:hover svg": {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.link"),
        transform: "translateX(2px)"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
    }
});
const $24c02ea0e14dbe4f$var$$76fc9668239269ce$var$contentStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    alignItems: "flex-start",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
    }
});
const $24c02ea0e14dbe4f$var$$76fc9668239269ce$var$descriptionStyles = (0, $74Zh5.css)({
    margin: 0,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle"),
    fontFamily: "Atlassian Sans",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        fontSize: "12px",
        lineHeight: "16px"
    }
});
var $24c02ea0e14dbe4f$var$$76fc9668239269ce$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$var$$76fc9668239269ce$var$ResourceCard;
const $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$Expander = ({ title: title, description: description, resources: resources, color: color, expandedByDefault: expandedByDefault = false, onExpandToggle: onExpandToggle, iconType: iconType, expandedContent: expandedContent })=>{
    const [isExpanded, setIsExpanded] = (0, $5FkrB.useState)(expandedByDefault);
    const iconProps = isExpanded ? {
        type: "chevron-down",
        alt: "Chevron down"
    } : {
        type: "chevron-right",
        alt: "Chevron right"
    };
    const toggleExpanded = (0, $5FkrB.useCallback)(()=>{
        setIsExpanded(!isExpanded);
        onExpandToggle?.();
    }, [
        isExpanded,
        onExpandToggle
    ]);
    const handleKeyDown = (0, $5FkrB.useCallback)((event)=>{
        if (event.code === "Space") {
            // to handle cases when there are clickable items within accordion
            if (event.target !== event.currentTarget) {
                event.preventDefault();
                event.stopPropagation();
            } else {
                event.preventDefault();
                toggleExpanded();
            }
        }
    }, [
        toggleExpanded
    ]);
    const accessibilityLabel = `${title}; ${typeof description === "string" ? description : ""}`;
    const hasResources = resources.length > 0;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$iconAndExpanderContainerStyles,
        role: "button",
        "aria-label": accessibilityLabel,
        "aria-expanded": isExpanded,
        tabIndex: 0,
        onKeyDown: handleKeyDown,
        children: [
            iconType && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$outerIconStyles,
                    (0, $74Zh5.css)({
                        opacity: isExpanded ? 1 : 0.6,
                        "& svg": {
                            color: color
                        }
                    })
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: iconType,
                    color: color,
                    size: $24c02ea0e14dbe4f$export$ff775019b5b6e7df.LARGE
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$expanderCardStyles,
                style: {
                    borderLeft: `8px solid ${color && isExpanded ? color : "transparent"}`
                },
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$containerStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            role: "button",
                            tabIndex: 0,
                            css: $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$expanderHeaderStyles,
                            onClick: toggleExpanded,
                            onKeyDown: (e)=>{
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    toggleExpanded();
                                }
                            },
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                    ...iconProps,
                                    size: $24c02ea0e14dbe4f$export$ff775019b5b6e7df.LARGE
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                                    level: 5,
                                    children: title
                                })
                            ]
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$contentStyles,
                            children: [
                                typeof description === "string" ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                        css: $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$descriptionStyles,
                                        children: description
                                    })
                                }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$descriptionStyles,
                                    children: description
                                }),
                                isExpanded && expandedContent && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$expandedContentStyles,
                                    children: expandedContent
                                }),
                                isExpanded && hasResources && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                    css: $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$resourcesStyles,
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$71f050e2efa708bb, {
                                            fontWeight: "semibold",
                                            children: "Resources"
                                        }),
                                        resources.map((resource)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$76fc9668239269ce$export$2e2bcd8739ae039, {
                                                description: resource.description,
                                                link: resource.link,
                                                type: resource.type
                                            }, resource.link.link))
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$iconAndExpanderContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
});
const $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$expanderCardStyles = (0, $74Zh5.css)({
    display: "flex",
    flex: "auto",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400"),
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    alignSelf: "stretch",
    alignItems: "stretch",
    borderRadius: "8px",
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface"),
    boxShadow: "0 0 1px 0 rgba(9, 30, 66, 0.31), 0 1px 1px 0 rgba(9, 30, 66, 0.25)",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")}`
    }
});
const $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
    }
});
const $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$expanderHeaderStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    cursor: "pointer",
    userSelect: "none",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
    }
});
const $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$contentStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400"),
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.600"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.500")
    }
});
const $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$resourcesStyles = (0, $74Zh5.css)({
    display: "flex",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    flexDirection: "column",
    alignItems: "stretch",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    alignSelf: "stretch",
    borderRadius: "8px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface.sunken"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
        gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
    }
});
const $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$outerIconStyles = (0, $74Zh5.css)({
    "& svg": {
        width: "32px !important",
        height: "32px !important"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$descriptionStyles = (0, $74Zh5.css)({
    whiteSpace: "pre-wrap"
});
const $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$expandedContentStyles = (0, $74Zh5.css)({
    width: "100%"
});
var $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$Expander;
const $24c02ea0e14dbe4f$var$$737c57f1a347e52a$var$TabContent = ({ tabExpanders: tabExpanders, color: color, iconType: iconType })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$737c57f1a347e52a$var$tabContentContainerStyles,
        children: tabExpanders.map((tabItem, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$export$2e2bcd8739ae039, {
                title: tabItem.title,
                description: tabItem.description,
                resources: tabItem.resources,
                color: color,
                expandedByDefault: index === 0,
                iconType: iconType,
                expandedContent: tabItem.expandedContent
            }, tabItem.title))
    });
};
const $24c02ea0e14dbe4f$var$$737c57f1a347e52a$var$tabContentContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
    }
});
var $24c02ea0e14dbe4f$var$$737c57f1a347e52a$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$var$$737c57f1a347e52a$var$TabContent;
const $24c02ea0e14dbe4f$export$187009fd9803261e = ({ tabs: tabs, containerStyles: containerStyles, defaultSelectedIndex: defaultSelectedIndex = 0, onTabChange: onTabChange })=>{
    const [selectedTabIndex, setSelectedTabIndex] = (0, $5FkrB.useState)(defaultSelectedIndex);
    const tabRefs = (0, $5FkrB.useRef)([]);
    const contentRef = (0, $5FkrB.useRef)(null);
    const handleSelectTab = (0, $5FkrB.useCallback)((index)=>{
        setSelectedTabIndex(index);
        onTabChange?.(index);
    }, [
        onTabChange
    ]);
    const handleKeyDown = (0, $5FkrB.useCallback)((event)=>{
        let newIndex = selectedTabIndex;
        switch(event.key){
            case "ArrowLeft":
                event.preventDefault();
                newIndex = selectedTabIndex > 0 ? selectedTabIndex - 1 : tabs.length - 1;
                break;
            case "ArrowRight":
                event.preventDefault();
                newIndex = selectedTabIndex < tabs.length - 1 ? selectedTabIndex + 1 : 0;
                break;
            case "Home":
                event.preventDefault();
                newIndex = 0;
                break;
            case "End":
                event.preventDefault();
                newIndex = tabs.length - 1;
                break;
            default:
                return;
        }
        if (newIndex !== selectedTabIndex) {
            contentRef.current?.focus?.();
            handleSelectTab(newIndex);
        }
    }, [
        selectedTabIndex,
        tabs.length,
        handleSelectTab
    ]);
    const selectedTabContent = (0, $5FkrB.useMemo)(()=>{
        const selected = tabs[selectedTabIndex];
        if (!selected) return null;
        return selected;
    }, [
        tabs,
        selectedTabIndex
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$6937e97bac512574$var$defaultContainerStyles,
            containerStyles
        ],
        "data-testid": "tabbed-accordion",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$6937e97bac512574$var$tabsHeaderStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$6937e97bac512574$var$tabsRowStyles,
                    role: "tablist",
                    "aria-label": "Tabbed accordion tabs",
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    children: tabs.map((tab, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$6937e97bac512574$var$tabWrapperStyles,
                            ref: (el)=>tabRefs.current[index] = el,
                            tabIndex: -1,
                            role: "tab",
                            "aria-selected": index === selectedTabIndex,
                            "aria-controls": `tabpanel-${index}`,
                            "aria-setsize": tabs.length,
                            "aria-posinset": index + 1,
                            id: `tab-${index}`,
                            onClick: ()=>handleSelectTab(index),
                            onKeyDown: (e)=>{
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    handleSelectTab(index);
                                }
                            },
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3e41faf802a29e71, {
                                label: tab.label,
                                labelColor: tab.labelColor || (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
                                labelColorSelected: tab.labelColorSelected || (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
                                labelColorSelectedHover: tab.labelColorSelectedHover || (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
                                selectedColor: tab.color,
                                selectedHoverColor: tab.color,
                                size: $24c02ea0e14dbe4f$export$ddadc1228c8dcfa.SMALL,
                                selected: index === selectedTabIndex
                            })
                        }, tab.label))
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("hr", {
                css: $24c02ea0e14dbe4f$var$$6937e97bac512574$var$dividerStyles
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$6937e97bac512574$var$accordionContainerStyles,
                ref: contentRef,
                tabIndex: -1,
                role: "tabpanel",
                id: `tabpanel-${selectedTabIndex}`,
                "aria-labelledby": `tab-${selectedTabIndex}`,
                "aria-label": `${tabs[selectedTabIndex]?.label} content`,
                children: selectedTabContent && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$737c57f1a347e52a$export$2e2bcd8739ae039, {
                    tabExpanders: selectedTabContent.tabExpanders,
                    color: selectedTabContent.color,
                    iconType: selectedTabContent.iconType
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$6937e97bac512574$var$defaultContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.600"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
    }
});
const $24c02ea0e14dbe4f$var$$6937e97bac512574$var$tabsHeaderStyles = (0, $74Zh5.css)({
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$6937e97bac512574$var$tabsRowStyles = (0, $74Zh5.css)({
    display: "flex",
    flexWrap: "wrap",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$6937e97bac512574$var$dividerStyles = (0, $74Zh5.css)({
    border: `0.5px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    width: "100%",
    margin: 0,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.md]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$6937e97bac512574$var$tabWrapperStyles = (0, $74Zh5.css)({
    display: "flex",
    // override default pressed style
    '& [data-testid="tab"]:active': {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")
    }
});
const $24c02ea0e14dbe4f$var$$6937e97bac512574$var$accordionContainerStyles = (0, $74Zh5.css)({
    width: "100%"
});
var $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$8aff256b69bb18bd$exports, "TabbedCards", ()=>$24c02ea0e14dbe4f$export$f0f045459b5b92);
const $24c02ea0e14dbe4f$export$f0f045459b5b92 = ({ cards: cards, containerStyles: containerStyles, defaultSelectedIndex: defaultSelectedIndex = 0, onTabChange: onTabChange, ctaText: ctaText = "Learn more" })=>{
    const safeDefaultSelectedIndex = Math.min(Math.max(0, defaultSelectedIndex), Math.max(0, cards.length - 1));
    const [selectedCardIndex, setSelectedCardIndex] = (0, $5FkrB.useState)(safeDefaultSelectedIndex);
    const tabRefs = (0, $5FkrB.useRef)([]);
    const handleSelectTab = (0, $5FkrB.useCallback)((index)=>{
        setSelectedCardIndex(index);
        onTabChange?.(index);
    }, [
        onTabChange
    ]);
    const selectedCard = (0, $5FkrB.useMemo)(()=>{
        const selected = cards[selectedCardIndex];
        return selected ?? null;
    }, [
        cards,
        selectedCardIndex
    ]);
    if (!cards.length) return null;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$containerBaseStyles,
            containerStyles
        ],
        "data-testid": "tabbed-cards",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$tabsHeaderStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$tabsRowStyles,
                    role: "tablist",
                    "aria-label": "Tabbed cards tabs",
                    children: cards.map((card, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$tabWrapperStyles,
                            ref: (el)=>tabRefs.current[index] = el,
                            tabIndex: -1,
                            role: "tab",
                            "aria-selected": index === selectedCardIndex,
                            "aria-controls": `tabpanel-${index}`,
                            "aria-setsize": cards.length,
                            "aria-posinset": index + 1,
                            id: `tab-${index}`,
                            onClick: ()=>handleSelectTab(index),
                            onKeyDown: (e)=>{
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    handleSelectTab(index);
                                }
                            },
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3e41faf802a29e71, {
                                label: card.title,
                                labelColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
                                labelColorSelected: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"),
                                labelColorSelectedHover: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"),
                                selectedColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.discovery"),
                                selectedHoverColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.discovery"),
                                size: $24c02ea0e14dbe4f$export$ddadc1228c8dcfa.MEDIUM,
                                selected: index === selectedCardIndex
                            })
                        }, card.title))
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$panelContainerStyles,
                tabIndex: -1,
                role: "tabpanel",
                id: `tabpanel-${selectedCardIndex}`,
                "aria-labelledby": `tab-${selectedCardIndex}`,
                "aria-label": `${cards[selectedCardIndex]?.title} content`,
                children: selectedCard && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$cardContainerStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$cardLeftStyles,
                            children: [
                                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                    css: $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$textBlockStyles,
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                                            level: 3,
                                            children: selectedCard.title
                                        }),
                                        selectedCard.subtitle && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                            size: "regular",
                                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
                                            children: selectedCard.subtitle
                                        })
                                    ]
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$ctaContainerStyles,
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.LINK,
                                        label: ctaText,
                                        href: selectedCard.href,
                                        target: selectedCard.target,
                                        iconAfter: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                            type: "arrow-right",
                                            alt: "Arrow right",
                                            size: $24c02ea0e14dbe4f$export$ff775019b5b6e7df.MEDIUM
                                        })
                                    })
                                })
                            ]
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$imageWellStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                                src: selectedCard.img.src,
                                alt: selectedCard.img.alt,
                                width: selectedCard.img.width,
                                height: selectedCard.img.height,
                                css: $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$cardImageStyles,
                                loading: selectedCard.img.loading,
                                decoding: selectedCard.img.decoding
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$containerBaseStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.600"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
    }
});
const $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$tabsHeaderStyles = (0, $74Zh5.css)({
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$tabsRowStyles = (0, $74Zh5.css)({
    display: "flex",
    flexWrap: "nowrap",
    justifyContent: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    overflowX: "auto",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        flexWrap: "wrap",
        justifyContent: "flex-start"
    }
});
const $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$tabWrapperStyles = (0, $74Zh5.css)({
    display: "flex",
    // override default pressed style
    '& [data-testid="tab-selected"]:active': {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.discovery")
    },
    '& [data-testid="tab"]:active': {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")
    }
});
const $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$panelContainerStyles = (0, $74Zh5.css)({
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$cardContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface"),
    borderRadius: "8px",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: "266px",
    gap: "80px",
    paddingLeft: "62px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        flexDirection: "column",
        alignItems: "stretch",
        gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400"),
        padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400")
    }
});
const $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$cardLeftStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    flex: "1 1 auto",
    minWidth: 0,
    paddingTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400"),
    paddingBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        padding: 0
    }
});
const $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$textBlockStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    minWidth: 0
});
const $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$ctaContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    alignSelf: "flex-start",
    // Align button label with heading/subtitle by removing left padding.
    '& [data-testid="button-link"]': {
        paddingLeft: 0
    }
});
const $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$imageWellStyles = (0, $74Zh5.css)({
    width: "416px",
    height: "266px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface.sunken"),
    borderTopRightRadius: "20px",
    borderBottomRightRadius: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        width: "100%",
        height: "200px",
        borderTopRightRadius: "8px",
        borderBottomRightRadius: "8px",
        borderTopLeftRadius: "8px",
        borderBottomLeftRadius: "8px"
    }
});
const $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$cardImageStyles = (0, $74Zh5.css)({
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain"
});
var $24c02ea0e14dbe4f$var$$271716b3dbf43c41$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$271716b3dbf43c41$exports, "MeatballMenu", ()=>$24c02ea0e14dbe4f$export$ef4a0fdddd7eccb7);
const $24c02ea0e14dbe4f$export$ef4a0fdddd7eccb7 = ({ items: items, placement: placement = "bottom-end", testId: testId = "meatball-menu", ariaLabel: ariaLabel = "More options", isInverted: isInverted = false })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$271716b3dbf43c41$var$menuContainerStyles,
        "data-testid": testId,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $9e29898158274f39$export$2e2bcd8739ae039), {
            trigger: ({ triggerRef: triggerRef, ...props })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                    ...props,
                    ref: triggerRef,
                    css: [
                        $24c02ea0e14dbe4f$var$$271716b3dbf43c41$var$triggerButtonStyles,
                        isInverted && $24c02ea0e14dbe4f$var$$271716b3dbf43c41$var$invertedTriggerButtonStyles
                    ],
                    "aria-label": ariaLabel,
                    "data-testid": `${testId}-trigger`,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                        type: "more-vertical",
                        rotation: $24c02ea0e14dbe4f$export$b3241a99d3e47e02.NINETY,
                        alt: ariaLabel,
                        color: isInverted ? "#FFFFFF" : undefined
                    })
                }),
            placement: placement,
            children: items.map((item, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $896b4f3af893fddb$export$2e2bcd8739ae039), {
                    onClick: item.onClick,
                    isDisabled: item.isDisabled,
                    testId: item.testId || `${testId}-item-${index}`,
                    children: item.label
                }, `${item.label}-${index}`))
        })
    });
};
const $24c02ea0e14dbe4f$var$$271716b3dbf43c41$var$menuContainerStyles = (0, $74Zh5.css)({
    display: "inline-flex",
    alignItems: "center"
});
const $24c02ea0e14dbe4f$var$$271716b3dbf43c41$var$triggerButtonStyles = (0, $74Zh5.css)({
    background: "transparent",
    border: "none",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    transition: "background-color 0.2s ease",
    "&:hover": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral.hovered")
    },
    "&:active": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral.pressed")
    },
    "&:focus": {
        outline: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.focused")}`,
        outlineOffset: "2px"
    }
});
const $24c02ea0e14dbe4f$var$$271716b3dbf43c41$var$invertedTriggerButtonStyles = (0, $74Zh5.css)({
    "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.16)"
    },
    "&:active": {
        backgroundColor: "rgba(255, 255, 255, 0.24)"
    },
    "&:focus": {
        outline: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`,
        outlineOffset: "2px"
    }
});
var $24c02ea0e14dbe4f$var$$fd4e65895774e705$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fd4e65895774e705$exports, "ProfileAvatarSize", ()=>$24c02ea0e14dbe4f$export$902867f9afe4e0c1);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fd4e65895774e705$exports, "ProfileAvatar", ()=>$24c02ea0e14dbe4f$export$3778be82376b06d7);
let $24c02ea0e14dbe4f$export$902867f9afe4e0c1;
(function(ProfileAvatarSize) {
    ProfileAvatarSize["XS"] = "xs";
    ProfileAvatarSize["S"] = "s";
    ProfileAvatarSize["M"] = "m";
    ProfileAvatarSize["L"] = "l";
    ProfileAvatarSize["XL"] = "xl";
    ProfileAvatarSize["XXL"] = "xxl";
    ProfileAvatarSize["XXXL"] = "xxxl";
})($24c02ea0e14dbe4f$export$902867f9afe4e0c1 || ($24c02ea0e14dbe4f$export$902867f9afe4e0c1 = {}));
const $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$sizeMap = {
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.XS]: 16,
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.S]: 24,
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.M]: 32,
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.L]: 40,
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.XL]: 96,
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.XXL]: 128,
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.XXXL]: 248
};
const $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$atlaskitSizeMap = {
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.XS]: "xsmall",
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.S]: "small",
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.M]: "medium",
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.L]: "large",
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.XL]: "xlarge",
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.XXL]: "xxlarge",
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.XXXL]: "xxlarge"
};
// Pixel sizes used internally by @atlaskit/avatar for each `size` value.
const $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$atlaskitSizePx = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $24c02ea0e14dbe4f$export$3778be82376b06d7 = ({ size: size, label: label, src: src, showCameraIconOnXXXL: showCameraIconOnXXXL = false, onCameraClick: onCameraClick })=>{
    const avatarSize = $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$sizeMap[size] ?? $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$sizeMap[$24c02ea0e14dbe4f$export$902867f9afe4e0c1.M];
    const borderWidth = size === $24c02ea0e14dbe4f$export$902867f9afe4e0c1.XXXL ? 8 : 2;
    const scale = avatarSize / $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$atlaskitSizePx[$24c02ea0e14dbe4f$var$$fd4e65895774e705$var$atlaskitSizeMap[size]];
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
        xcss: $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$wrapperBaseStyles,
        style: {
            width: avatarSize + 2 * borderWidth,
            height: avatarSize + 2 * borderWidth
        },
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                xcss: $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$avatarFrameStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                        xcss: $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$avatarBorderRingStyles,
                        style: {
                            border: `${borderWidth}px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface.overlay")}`
                        }
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                        xcss: $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$avatarScaleWrapperStyles,
                        style: {
                            transform: `scale(${scale})`
                        },
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f31efb9f24b21b67$export$2e2bcd8739ae039), {
                            size: $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$atlaskitSizeMap[size],
                            src: src,
                            name: label,
                            borderColor: "transparent"
                        })
                    })
                ]
            }),
            showCameraIconOnXXXL ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                as: "span",
                xcss: $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$cameraWrapperStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                    as: "button",
                    type: "button",
                    xcss: $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$cameraButtonStyles,
                    "aria-label": "Change profile picture",
                    onClick: onCameraClick,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($af69d9e57c55d6b7$exports))), {
                        label: "Change profile picture",
                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.subtle")
                    })
                })
            }) : null
        ]
    });
};
const $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$wrapperBaseStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box"
});
const $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$avatarFrameStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    width: "100%",
    height: "100%",
    borderRadius: "border.radius.circle",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "color.background.neutral",
    boxSizing: "border-box",
    position: "relative"
});
const $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$avatarBorderRingStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    position: "absolute",
    inset: "space.0",
    borderRadius: "border.radius.circle",
    pointerEvents: "none",
    boxSizing: "border-box"
});
const $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$avatarScaleWrapperStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    transformOrigin: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$cameraWrapperStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    position: "absolute",
    width: "55px",
    height: "55px",
    borderRadius: "border.radius.circle",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    right: "16px",
    bottom: "14px",
    backgroundColor: "color.background.input",
    boxShadow: "elevation.shadow.overlay"
});
const $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$cameraButtonStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    width: "100%",
    height: "100%",
    borderRadius: "border.radius.circle",
    borderWidth: "border.width.0",
    padding: "space.0",
    margin: "space.0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
    cursor: "pointer"
});
var $24c02ea0e14dbe4f$var$$54253e316d7b853e$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$54253e316d7b853e$exports, "IconSizeWrapper", ()=>$24c02ea0e14dbe4f$export$a98b567077af326b);
const $24c02ea0e14dbe4f$var$$54253e316d7b853e$var$sizeMap = {
    xsmall: 12,
    small: 14,
    medium: 16,
    large: 24,
    xlarge: 32
};
function $24c02ea0e14dbe4f$var$$54253e316d7b853e$var$resolveSize(value) {
    return typeof value === "number" ? `${value}px` : value;
}
const $24c02ea0e14dbe4f$var$$54253e316d7b853e$var$wrapperStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center"
});
function $24c02ea0e14dbe4f$export$a98b567077af326b({ children: children, size: size, width: width, height: height }) {
    const resolvedWidth = width != null ? $24c02ea0e14dbe4f$var$$54253e316d7b853e$var$resolveSize(width) : `${$24c02ea0e14dbe4f$var$$54253e316d7b853e$var$sizeMap[size ?? "large"]}px`;
    const resolvedHeight = height != null ? $24c02ea0e14dbe4f$var$$54253e316d7b853e$var$resolveSize(height) : `${$24c02ea0e14dbe4f$var$$54253e316d7b853e$var$sizeMap[size ?? "large"]}px`;
    const refCallback = (0, $5FkrB.useCallback)((el)=>{
        if (el) {
            const svg = el.querySelector("svg");
            if (svg) {
                svg.style.width = resolvedWidth;
                svg.style.height = resolvedHeight;
            }
        }
    }, [
        resolvedWidth,
        resolvedHeight
    ]);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $0c22dfc1af284338$export$2e2bcd8739ae039), {
        xcss: $24c02ea0e14dbe4f$var$$54253e316d7b853e$var$wrapperStyles,
        ref: refCallback,
        children: children
    });
}
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$660bd1c6cb41002a$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$fec02fc26c7e145d$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$d501466973a9f0a6$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$c4979bfceee73878$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$0903e93de01b205a$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$a950778dc3003c4a$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$582583ec420fce57$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$a02a6f7de308273b$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$c0c01354ab9765ae$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$800df40a54823a3f$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$9efbb38deb40219f$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$731a4fd527bab680$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$8b54d37779d052e8$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$9cfa05d02afa3952$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$a467abe0c2c1750b$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$52124b9ae1d78e04$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$77696804880d7cdc$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$be203e745bcefb12$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$a0eced43682c2d75$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$1db60c687807de63$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$2f0c862779035c26$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$6937e97bac512574$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$271716b3dbf43c41$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$fd4e65895774e705$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$54253e316d7b853e$exports);
var $24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports = {};
var $24c02ea0e14dbe4f$var$$83fc18f8199a12ff$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$83fc18f8199a12ff$exports, "AudioPlayer", ()=>$24c02ea0e14dbe4f$export$832cc5475f11d8b4);
// using 'plyr' instead of 'plyr/dist/plyr'
// will start executing DOM APIs right away
// and it breaks SSR
const $24c02ea0e14dbe4f$export$832cc5475f11d8b4 = ({ source: source, isOpened: isOpened, onClose: onClose, onControlClick: onControlClick, onProgressUpdate: onProgressUpdate, onError: onError })=>{
    const audioRef = (0, $5FkrB.useRef)(null);
    const focusRef = (0, $5FkrB.useRef)(null);
    const playerSource = {
        type: "audio",
        sources: [
            {
                src: source
            }
        ]
    };
    const playerOptions = {
        hideControls: true,
        controls: [
            "play",
            "progress",
            "current-time"
        ]
    };
    const addEvent = (0, $5FkrB.useCallback)((instance, event)=>{
        instance.on(event, ()=>onControlClick && onControlClick(event));
        instance.on("timeupdate", ()=>{
            const currentTime = instance.currentTime;
            const duration = instance.duration;
            const percentage = currentTime / duration * 100;
            onProgressUpdate && onProgressUpdate(+percentage.toFixed(2));
        });
    }, [
        onControlClick,
        onProgressUpdate
    ]);
    const addEvents = (0, $5FkrB.useCallback)((instance)=>{
        addEvent(instance, "play");
        addEvent(instance, "pause");
        if (onError) instance.on("error", onError);
    }, [
        addEvent,
        onError
    ]);
    (0, $5FkrB.useEffect)(()=>{
        const player = new (0, (/*@__PURE__*/$parcel$interopDefault($1c94bc9aa532188d$exports)))(audioRef.current, playerOptions);
        player.source = playerSource;
        addEvents(player);
        //To avoid: aria-label attribute is not well supported on a div with no valid role attribute.
        const plyrTimer = document.getElementsByClassName("plyr__time")[0];
        if (plyrTimer) plyrTimer.removeAttribute("aria-label");
        if (isOpened) focusRef.current?.focus();
        const plyrAudioContainer = document.getElementsByClassName("plyr--audio")[0];
        if (plyrAudioContainer) plyrAudioContainer.role = "presentation";
    }, [
        isOpened
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ const handleKeyDown = (0, $5FkrB.useCallback)((event)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onClose();
        }
    }, [
        onClose
    ]);
    return isOpened && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        role: "dialog",
        "aria-label": "Audio player",
        ref: focusRef,
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- Dialog needs tabIndex for focus management
        tabIndex: 0,
        css: $24c02ea0e14dbe4f$var$$83fc18f8199a12ff$var$audioPlayerStyles,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("figure", {
            "data-testid": "audio-player",
            css: $24c02ea0e14dbe4f$var$$83fc18f8199a12ff$var$figureStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("audio", {
                    ref: audioRef
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    role: "button",
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    onClick: onClose,
                    css: $24c02ea0e14dbe4f$var$$83fc18f8199a12ff$var$closeIconStyles,
                    "data-testid": "close-audio",
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                        type: "cross",
                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.subtle"),
                        alt: "close-audio"
                    })
                })
            ]
        })
    });
};
const $24c02ea0e14dbe4f$var$$83fc18f8199a12ff$var$audioPlayerStyles = (0, $74Zh5.css)({
    borderRadius: "8px",
    maxWidth: "340px",
    padding: "24px",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    ".plyr--audio": {
        width: "100%",
        "--plyr-color-main": (0, $54ca2d3948378259$export$e62e8919cca44969),
        "--plyr-audio-control-color": (0, $54ca2d3948378259$export$29a4f05edc054374),
        "--plyr-control-icon-size": "16px",
        "--plyr-range-thumb-height": "8px",
        "--plyr-range-track-height": "8px",
        "--plyr-range-thumb-shadow": "none",
        "--plyr-audio-progress-buffered-background": (0, $54ca2d3948378259$export$c2e91cbeada39b8b),
        "--plyr-font-family": "Charlie Text",
        "--plyr-tooltip-background": (0, $54ca2d3948378259$export$c39c0fe0f26207ae),
        "--plyr-tooltip-color": (0, $54ca2d3948378259$export$29a4f05edc054374),
        "--plyr-tooltip-radius": "8px",
        "--plyr-control-spacing": "16px",
        "--plyr-range-thumb-background": (0, $54ca2d3948378259$export$e62e8919cca44969)
    },
    ".plyr--audio > .plyr__controls": {
        padding: 0
    },
    ".plyr--audio > .plyr__controls > .plyr__control": {
        width: "40px",
        height: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: "16px",
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.information.bold"),
        borderRadius: "50%"
    },
    ".plyr__progress": {
        marginRight: "16px"
    },
    ".icon--not-pressed": {
        marginRight: "-3px"
    },
    ".plyr__time": {
        fontFamily: "Inter, sans-serif",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
        fontSize: "14px",
        fontWeight: 600
    },
    ".plyr--audio:focus, .plyr--audio:focus-visible": {
        border: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $24c02ea0e14dbe4f$var$$83fc18f8199a12ff$var$figureStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: 0
});
const $24c02ea0e14dbe4f$var$$83fc18f8199a12ff$var$closeIconStyles = (0, $74Zh5.css)({
    display: "flex",
    cursor: "pointer",
    marginLeft: "4px"
});
var $24c02ea0e14dbe4f$var$$438c82700c218044$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$438c82700c218044$exports, "ArticleJumpLinks", ()=>$24c02ea0e14dbe4f$export$e11be3ad528d3c05);
const $24c02ea0e14dbe4f$var$$7af640a6c4cb35c7$export$5972a68b6e54f38f = (0, $74Zh5.css)({
    display: "flex",
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")}`,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    borderRadius: "8px",
    backgroundColor: "white",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    // desktop
    "@media (min-width: 1000px)": {
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")}`,
        maxWidth: "290px"
    }
});
const $24c02ea0e14dbe4f$var$$7af640a6c4cb35c7$export$2dc6a66a41038997 = (0, $74Zh5.css)({
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
});
const $24c02ea0e14dbe4f$var$$7af640a6c4cb35c7$export$4ea5976125a01ffa = (0, $74Zh5.css)({
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")} 0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")}`,
    position: "relative",
    "&:hover": {
        borderRadius: "4px",
        backgroundColor: "rgba(220, 223, 228, 0.50)"
    },
    "& a": {
        // limit to 2 lines
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: "2",
        wordBreak: "break-word",
        overflow: "hidden",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle"),
        textOverflow: "ellipsis",
        textDecoration: "none",
        fontFamily: "Inter, sans-serif",
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px"
    }
});
const $24c02ea0e14dbe4f$var$$7af640a6c4cb35c7$export$976a5bac7cff1dce = (0, $74Zh5.css)({
    // desktop
    "@media (min-width: 1000px)": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.blue.subtlest"),
        borderRadius: "4px",
        "& a": {
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand")
        },
        "&:hover": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.blue.subtlest")
        },
        ":before": {
            content: '""',
            display: "block",
            width: "2px",
            height: "16px",
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
            position: "absolute",
            left: "0",
            top: "50%",
            transform: "translateY(-50%)"
        }
    }
});
const $24c02ea0e14dbe4f$var$$7af640a6c4cb35c7$export$405b853093cc10c7 = (0, $74Zh5.css)({
    padding: `0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")}`,
    "& h6": {
        textOverflow: "ellipsis",
        fontSize: "16px !important",
        lineHeight: "24px !important"
    },
    // desktop
    "@media (min-width: 1000px)": {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$438c82700c218044$var$DEFAULT_TITLE = "On this page";
const $24c02ea0e14dbe4f$export$e11be3ad528d3c05 = ({ links: links, className: className, style: style, onClick: onClick, title: title = $24c02ea0e14dbe4f$var$$438c82700c218044$var$DEFAULT_TITLE, activeHref: activeHref })=>{
    const [internalActiveLink, setInternalActiveLink] = (0, $5FkrB.useState)(null);
    const handleScroll = (0, $5FkrB.useCallback)(()=>{
        internalActiveLink && setInternalActiveLink(null);
    }, [
        internalActiveLink
    ]);
    const handleClick = (0, $5FkrB.useCallback)((link)=>{
        requestAnimationFrame(()=>{
            setInternalActiveLink(link);
        });
        onClick?.(link);
    }, [
        onClick,
        setInternalActiveLink
    ]);
    (0, $5FkrB.useEffect)(()=>{
        // Only add scroll listener if activeHref is not provided (internal state mode)
        if (!activeHref) {
            window.addEventListener("scroll", handleScroll);
            return ()=>{
                window.removeEventListener("scroll", handleScroll);
            };
        }
    }, [
        handleScroll,
        activeHref
    ]);
    const linksWithHref = (0, $5FkrB.useMemo)(()=>{
        return links.map((link)=>{
            const linkHref = link.href ? link.href : $24c02ea0e14dbe4f$export$1bdcd43c8c2377cf(link.label);
            // Use activeHref prop if provided, otherwise fall back to internal state
            const isActive = activeHref ? linkHref === activeHref : internalActiveLink?.label === link.label;
            const onLinkClick = ()=>handleClick?.(link);
            return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                css: [
                    $24c02ea0e14dbe4f$var$$7af640a6c4cb35c7$export$4ea5976125a01ffa,
                    isActive && $24c02ea0e14dbe4f$var$$7af640a6c4cb35c7$export$976a5bac7cff1dce
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                    href: linkHref,
                    onClick: onLinkClick,
                    children: link.label
                })
            }, linkHref);
        });
    }, [
        links,
        internalActiveLink,
        activeHref,
        handleClick
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$7af640a6c4cb35c7$export$5972a68b6e54f38f,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$7af640a6c4cb35c7$export$405b853093cc10c7,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                    level: 6,
                    children: title
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
                css: $24c02ea0e14dbe4f$var$$7af640a6c4cb35c7$export$2dc6a66a41038997,
                className: className,
                style: style,
                children: linksWithHref
            })
        ]
    });
};
var $24c02ea0e14dbe4f$var$$389dbaf1c04dd698$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$389dbaf1c04dd698$exports, "BadgeCard", ()=>$24c02ea0e14dbe4f$export$22da447a4012011);
const $24c02ea0e14dbe4f$export$22da447a4012011 = ({ image: image, badgeTitle: badgeTitle, earnedDate: earnedDate, link: link, onClick: onClick })=>{
    const clickHandler = (0, $5FkrB.useCallback)(()=>{
        if (onClick) onClick(link, "_self");
    }, [
        onClick,
        link
    ]);
    const handleKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(clickHandler);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        role: "button",
        css: $24c02ea0e14dbe4f$var$$389dbaf1c04dd698$var$containerStyles,
        tabIndex: 0,
        onClick: clickHandler,
        onKeyDown: handleKeyDown,
        "data-testid": "badge-card",
        children: [
            image && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3e431a229df88919, {
                    ...image,
                    width: 64,
                    height: 64,
                    preventModal: true,
                    style: {
                        height: "64px",
                        objectFit: "contain"
                    }
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$389dbaf1c04dd698$var$contentContainerStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: $24c02ea0e14dbe4f$var$$389dbaf1c04dd698$var$badgeTitleStyles,
                        children: badgeTitle
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
                        css: $24c02ea0e14dbe4f$var$$389dbaf1c04dd698$var$earnedDateStyles,
                        children: [
                            "Earned: ",
                            earnedDate
                        ]
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$389dbaf1c04dd698$var$containerStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    alignItems: "center",
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    border: `0 solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "4px",
    padding: "16px 12px",
    transition: "all 0.2s ease-in-out",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    "&:hover": {
        cursor: "pointer",
        boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    }
});
const $24c02ea0e14dbe4f$var$$389dbaf1c04dd698$var$contentContainerStyles = (0, $74Zh5.css)({
    marginLeft: "16px"
});
const $24c02ea0e14dbe4f$var$$389dbaf1c04dd698$var$badgeTitleStyles = (0, $74Zh5.css)({
    paddingBottom: "4px",
    fontSize: "16px",
    fontFamily: "system-ui",
    fontWeight: 600,
    lineHeight: "20px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    wordBreak: "break-word",
    margin: 0
});
const $24c02ea0e14dbe4f$var$$389dbaf1c04dd698$var$earnedDateStyles = (0, $74Zh5.css)({
    fontSize: "14px",
    lineHeight: "20px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "system-ui",
    fontWeight: "normal",
    wordBreak: "break-word",
    margin: 0
});
var $24c02ea0e14dbe4f$var$$c18917e553fd2737$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$c18917e553fd2737$exports, "CertificateCard", ()=>$24c02ea0e14dbe4f$export$c572aa3e2aa38d2);
const $24c02ea0e14dbe4f$export$c572aa3e2aa38d2 = ({ image: image, backgroundColor: backgroundColor, title: title, link: link, onClick: onClick })=>{
    const clickHandler = (0, $5FkrB.useCallback)(()=>{
        if (onClick) onClick(link, "_self");
    }, [
        onClick,
        link
    ]);
    const handleKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(clickHandler);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        css: $24c02ea0e14dbe4f$var$$c18917e553fd2737$var$containerStyles,
        onClick: clickHandler,
        onKeyDown: handleKeyDown,
        "data-testid": "certificate-card",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$c18917e553fd2737$var$cardHeaderStyles,
                    (0, $74Zh5.css)({
                        backgroundColor: backgroundColor
                    })
                ],
                "data-testid": "certificate-card-background",
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$c18917e553fd2737$var$imageContainerStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3e431a229df88919, {
                        ...image,
                        width: 112,
                        height: 112,
                        preventModal: true,
                        style: {
                            objectFit: "contain"
                        }
                    })
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$c18917e553fd2737$var$cardTitleStyles,
                children: title
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$c18917e553fd2737$var$containerStyles = (0, $74Zh5.css)({
    maxWidth: "280px",
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "5px",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    transition: "box-shadow 0.2s ease",
    "&:hover": {
        cursor: "pointer",
        boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    }
});
const $24c02ea0e14dbe4f$var$$c18917e553fd2737$var$cardHeaderStyles = (0, $74Zh5.css)({
    height: "66px",
    padding: "14px 16px 0",
    borderTopLeftRadius: "5px",
    borderTopRightRadius: "5px"
});
const $24c02ea0e14dbe4f$var$$c18917e553fd2737$var$imageContainerStyles = (0, $74Zh5.css)({
    height: "112px",
    width: "112px"
});
const $24c02ea0e14dbe4f$var$$c18917e553fd2737$var$cardTitleStyles = (0, $74Zh5.css)({
    padding: "0 16px 24px",
    marginTop: "76px",
    color: "N800",
    lineHeight: "20px",
    fontSize: "16px",
    fontFamily: "system-ui",
    fontWeight: 600,
    wordBreak: "break-word"
});
var $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3ca3d702a74367ba$exports, "ContentOverviewCardState", ()=>$24c02ea0e14dbe4f$export$84c408eab3fc01b3);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3ca3d702a74367ba$exports, "ContentOverviewCard", ()=>$24c02ea0e14dbe4f$export$cb86f63bb5e77777);
var $24c02ea0e14dbe4f$var$$ed20910b93d89c3f$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$ed20910b93d89c3f$exports, "ContentType", ()=>$24c02ea0e14dbe4f$export$e2e108cbe2e4f865);
let $24c02ea0e14dbe4f$export$e2e108cbe2e4f865;
(function(ContentType) {
    ContentType["LEARNING_PATH"] = "LEARNING_PATH";
    ContentType["COURSE"] = "COURSE";
    ContentType["LESSON"] = "LESSON";
})($24c02ea0e14dbe4f$export$e2e108cbe2e4f865 || ($24c02ea0e14dbe4f$export$e2e108cbe2e4f865 = {}));
let $24c02ea0e14dbe4f$export$84c408eab3fc01b3;
(function(ContentOverviewCardState) {
    ContentOverviewCardState["LOADING"] = "loading";
    ContentOverviewCardState["DEFAULT"] = "default";
    ContentOverviewCardState["IN_PROGRESS"] = "in_progress";
    ContentOverviewCardState["FINISHED"] = "finished";
})($24c02ea0e14dbe4f$export$84c408eab3fc01b3 || ($24c02ea0e14dbe4f$export$84c408eab3fc01b3 = {}));
const $24c02ea0e14dbe4f$export$cb86f63bb5e77777 = ({ inspectMode: inspectMode, state: state = $24c02ea0e14dbe4f$export$84c408eab3fc01b3.DEFAULT, heading: heading, subheading: subheading, tags: tags = [], collapsedSectionItems: itemsSectionCollapsed = [], collapsedSectionContent: infoSectionCollapsed = "", collapsedSectionTitle: titleSectionCollapsed, contentType: contentType, onClickButton: onClickButton, href: href })=>{
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const handleClickButton = (0, $5FkrB.useCallback)((event)=>{
        if (onClickButton) {
            event?.preventDefault();
            onClickButton();
        }
    }, [
        onClickButton
    ]);
    const handleToggleVisibility = (0, $5FkrB.useCallback)(()=>{
        setIsOpen((prevIsOpen)=>!prevIsOpen);
    }, []);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("article", {
        "aria-label": heading,
        css: [
            $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$articleContainerStyles,
            state === $24c02ea0e14dbe4f$export$84c408eab3fc01b3.FINISHED && (0, $74Zh5.css)({
                borderLeftColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.success")
            })
        ],
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$containerStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                        "data-testid": "toggle-visibility",
                        "aria-label": isOpen ? "collapse" : "expand",
                        onClick: handleToggleVisibility,
                        css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$buttonStyles,
                        children: isOpen ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$buttonIconSpanStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                type: "chevron-down"
                            })
                        }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$buttonIconSpanStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                type: "chevron-right"
                            })
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$gridContainerStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$gridItemStyles,
                                children: [
                                    tags.length > 0 && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$tagContainerStyles,
                                        children: tags?.map((tag, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$tagStyles,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                                                    inspectMode: tag.inspectMode && {
                                                        tag: tag.inspectMode.duration
                                                    },
                                                    label: tag.label
                                                })
                                            }, `tag-${index}`))
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("title", inspectMode),
                                        css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$titleContainerStyles,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                                            level: 5,
                                            children: heading
                                        })
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                        ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("description", inspectMode),
                                        css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$descriptionStyles,
                                        children: subheading
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$gridSideItemStyles,
                                children: [
                                    state === $24c02ea0e14dbe4f$export$84c408eab3fc01b3.LOADING && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                        label: "",
                                        isLoading: true
                                    }),
                                    state === $24c02ea0e14dbe4f$export$84c408eab3fc01b3.DEFAULT && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                        label: "Get started",
                                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                                        onClick: handleClickButton,
                                        href: href,
                                        target: "_blank"
                                    }),
                                    state === $24c02ea0e14dbe4f$export$84c408eab3fc01b3.IN_PROGRESS && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                        label: "Continue",
                                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.SECONDARY,
                                        onClick: handleClickButton,
                                        href: href,
                                        target: "_blank"
                                    }),
                                    state === $24c02ea0e14dbe4f$export$84c408eab3fc01b3.FINISHED && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$finishedStateContainerStyles,
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: (0, $74Zh5.css)({
                                                    marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
                                                }),
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a6c7ac8248d6e38a, {
                                                    link: href || "#",
                                                    label: `Review ${$24c02ea0e14dbe4f$export$e2e108cbe2e4f865.COURSE === contentType ? "lesson" : "course"}`,
                                                    onClick: (event)=>handleClickButton(event),
                                                    target: "_blank"
                                                })
                                            }),
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                                type: "check-circle",
                                                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.success")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": "section-expanded",
                css: [
                    $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$sectionExpandedStyles,
                    (0, $74Zh5.css)({
                        display: isOpen ? "block" : "none"
                    })
                ],
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$sectionContentStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2e0a83ec2e27ecbb, {
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border"),
                            height: 1
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("sectionList", inspectMode),
                        css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$sectionListStyles,
                        children: [
                            titleSectionCollapsed && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$sectionTitleStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                                    level: 6,
                                    children: titleSectionCollapsed
                                })
                            }),
                            itemsSectionCollapsed.length > 0 && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
                                css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$listStyles,
                                "aria-label": "collapsed section items",
                                children: itemsSectionCollapsed?.map((item, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                                        css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$itemStyles,
                                        children: item
                                    }, `item-${index}`))
                            }),
                            infoSectionCollapsed && infoSectionCollapsed
                        ]
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$articleContainerStyles = (0, $74Zh5.css)({
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    borderLeft: `8px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.brand")}`,
    borderRadius: "8px",
    padding: "16px 24px",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised")
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$containerStyles = (0, $74Zh5.css)({
    padding: "16px 0",
    display: "flex",
    alignItems: "flex-start"
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$buttonStyles = (0, $74Zh5.css)({
    padding: 0,
    border: "none",
    backgroundColor: "transparent",
    cursor: "pointer"
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$buttonIconSpanStyles = (0, $74Zh5.css)({
    marginRight: "16px"
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$gridContainerStyles = (0, $74Zh5.css)({
    flex: 1,
    display: "grid",
    gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        columnGap: "16px",
        alignItems: "center"
    }
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$gridItemStyles = (0, $74Zh5.css)({
    gridColumn: "span 12",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        gridColumn: "span 9",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
    }
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$tagContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexWrap: "wrap"
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$tagStyles = (0, $74Zh5.css)({
    marginRight: "12px",
    "&:last-of-type": {
        marginRight: 0
    }
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$titleContainerStyles = (0, $74Zh5.css)({
    margin: "16px auto",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        marginRight: "1px"
    }
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$descriptionStyles = (0, $74Zh5.css)({
    display: "none",
    fontSize: "16px",
    margin: 0,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Inter, sans-serif",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: "100%",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        lineHeight: "1.5",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
    }
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$gridSideItemStyles = (0, $74Zh5.css)({
    gridColumn: "span 12",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        gridColumn: "span 3",
        justifySelf: "end"
    }
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$finishedStateContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    marginRight: "4px"
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$sectionExpandedStyles = (0, $74Zh5.css)({
    overflow: "hidden",
    transition: "ease-in-out 1000ms",
    paddingLeft: "40px"
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$sectionContentStyles = (0, $74Zh5.css)({
    margin: "8px 0"
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$sectionListStyles = (0, $74Zh5.css)({
    padding: "24px 0"
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$sectionTitleStyles = (0, $74Zh5.css)({
    marginBottom: "8px",
    textTransform: "uppercase"
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$listStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontSize: "14px",
    lineHeight: "20px",
    listStyleType: "disc",
    listStylePosition: "inside",
    paddingLeft: "4px",
    marginTop: 0,
    fontFamily: "Inter, sans-serif",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "16px",
        lineHeight: "1.714"
    }
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$itemStyles = (0, $74Zh5.css)({
    marginTop: 0,
    marginLeft: "20px",
    textIndent: "-20px"
});
var $24c02ea0e14dbe4f$var$$e018ab7ed2648ae8$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$e018ab7ed2648ae8$exports, "EmptyState", ()=>$24c02ea0e14dbe4f$export$fddf379e22a74b00);
const $24c02ea0e14dbe4f$export$fddf379e22a74b00 = ({ image: image, description: description, redirectLink: redirectLink })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$e018ab7ed2648ae8$var$containerStyles,
        "data-testid": "empty-state",
        children: [
            image && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$e018ab7ed2648ae8$var$imageContainerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3e431a229df88919, {
                    src: image.src,
                    alt: image.alt,
                    preventModal: true,
                    height: 96
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$e018ab7ed2648ae8$var$descriptionContainerStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: $24c02ea0e14dbe4f$var$$e018ab7ed2648ae8$var$descriptionStyles,
                        tabIndex: 0,
                        children: description
                    }),
                    redirectLink && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a6c7ac8248d6e38a, {
                        label: redirectLink.label,
                        link: redirectLink.link,
                        style: $24c02ea0e14dbe4f$export$2b77966d73aefa77.SEMIBOLD,
                        fontColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.link"),
                        css: (0, $74Zh5.css)({
                            fontFamily: "system-ui"
                        })
                    })
                ]
            })
        ]
    });
const $24c02ea0e14dbe4f$var$$e018ab7ed2648ae8$var$containerStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    padding: "24px",
    border: "1px dashed",
    borderColor: (0, $54ca2d3948378259$export$5f71e19f3a7ad9de),
    borderRadius: "4px",
    alignItems: "center"
});
const $24c02ea0e14dbe4f$var$$e018ab7ed2648ae8$var$imageContainerStyles = (0, $74Zh5.css)({
    width: "64px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        width: "96px"
    }
});
const $24c02ea0e14dbe4f$var$$e018ab7ed2648ae8$var$descriptionContainerStyles = (0, $74Zh5.css)({
    marginLeft: "16px",
    lineHeight: "23px"
});
const $24c02ea0e14dbe4f$var$$e018ab7ed2648ae8$var$descriptionStyles = (0, $74Zh5.css)({
    paddingBottom: "2px",
    margin: 0,
    fontFamily: "system-ui",
    fontSize: "16px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontWeight: "normal",
    wordBreak: "break-word",
    lineHeight: 1.714
});
var $24c02ea0e14dbe4f$var$$81dd635d83decaee$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$81dd635d83decaee$exports, "InlineFeedbackMessageAppearance", ()=>$24c02ea0e14dbe4f$export$f9292ef28b7b429a);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$81dd635d83decaee$exports, "InlineFeedbackMessage", ()=>$24c02ea0e14dbe4f$export$f23c56ac9ab316f);
let $24c02ea0e14dbe4f$export$f9292ef28b7b429a;
(function(InlineFeedbackMessageAppearance) {
    InlineFeedbackMessageAppearance["INCORRECT"] = "INCORRECT";
    InlineFeedbackMessageAppearance["CORRECT"] = "CORRECT";
})($24c02ea0e14dbe4f$export$f9292ef28b7b429a || ($24c02ea0e14dbe4f$export$f9292ef28b7b429a = {}));
const $24c02ea0e14dbe4f$export$f23c56ac9ab316f = ({ title: title, description: description, appearance: appearance = $24c02ea0e14dbe4f$export$f9292ef28b7b429a.CORRECT })=>{
    const isIncorrectAppearance = appearance === $24c02ea0e14dbe4f$export$f9292ef28b7b429a.INCORRECT;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$81dd635d83decaee$var$feedbackMessageContainerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$81dd635d83decaee$var$feedbackMessageLeftBorderStyles,
                    (0, $74Zh5.css)({
                        backgroundColor: `${isIncorrectAppearance ? (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.danger") : (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.success")}`
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": `feedback-message-${appearance}`,
                css: $24c02ea0e14dbe4f$var$$81dd635d83decaee$var$feedbackMessageContentContainerStyles,
                children: [
                    isIncorrectAppearance ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                        type: "error",
                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.danger")
                    }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                        type: "check-circle",
                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.success")
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$81dd635d83decaee$var$feedbackMessageContentStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                css: $24c02ea0e14dbe4f$var$$81dd635d83decaee$var$feedbackMessageTitleStyles,
                                children: title
                            }),
                            description && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                css: $24c02ea0e14dbe4f$var$$81dd635d83decaee$var$feedbackMessageDescriptionStyles,
                                children: description
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$81dd635d83decaee$var$feedbackMessageContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input")
});
const $24c02ea0e14dbe4f$var$$81dd635d83decaee$var$feedbackMessageContentContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    padding: "24px 24px 24px 16px",
    display: "flex",
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "0 3px 3px 0",
    borderLeft: "none",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        padding: "16px 16px 16px 8px"
    }
});
const $24c02ea0e14dbe4f$var$$81dd635d83decaee$var$feedbackMessageLeftBorderStyles = (0, $74Zh5.css)({
    maxHeight: "100%",
    width: "8px",
    borderRadius: "3px 0 0 3px"
});
const $24c02ea0e14dbe4f$var$$81dd635d83decaee$var$feedbackMessageContentStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginLeft: "16px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        marginLeft: "8px"
    }
});
const $24c02ea0e14dbe4f$var$$81dd635d83decaee$var$feedbackMessageTitleStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "24px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    margin: 0,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        fontSize: "16px"
    }
});
const $24c02ea0e14dbe4f$var$$81dd635d83decaee$var$feedbackMessageDescriptionStyles = (0, $74Zh5.css)({
    marginTop: "16px",
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    lineHeight: "32px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    marginBottom: 0,
    p: {
        margin: 0
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        marginTop: "8px",
        fontSize: "16px",
        lineHeight: "24px"
    }
});
var $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$8d99d7c025746ac9$exports, "LearningContentCard", ()=>$24c02ea0e14dbe4f$export$c01be50dd5c433fe);
const $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$export$64ef9b8c11710c47 = ({ title: title, description: description, isLearningProgress: isLearningProgress, inspectMode: inspectMode, disableDescriptionClamp: disableDescriptionClamp })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "card-content",
        css: $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$titleAndDetailsContainerStyles,
        children: [
            isLearningProgress ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("h4", {
                ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("title", inspectMode),
                css: $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$withProgressTitleStyles,
                children: title
            }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("h5", {
                ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("title", inspectMode),
                css: $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$catalogTitleStyles,
                children: title
            }),
            description && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                "data-testid": "description",
                ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("description", inspectMode),
                css: [
                    $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$descriptionStyles,
                    disableDescriptionClamp && $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$descriptionNoClampStyles
                ],
                children: description
            })
        ]
    });
const $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$titleAndDetailsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: `0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")}`,
    marginBottom: "-2px"
});
const $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$baseTitleStyles = (0, $74Zh5.css)({
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    marginBottom: 0,
    fontFamily: "Charlie Display, sans-serif",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
});
const $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$learningProgressTitleStyles = (0, $74Zh5.css)({
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    marginTop: "20px !important",
    marginBottom: 0,
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "32px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    height: "64px"
});
const $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$withProgressTitleStyles = (0, $74Zh5.css)([
    $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$learningProgressTitleStyles,
    {
        fontSize: "24px",
        lineHeight: "32px",
        marginTop: "0 !important"
    }
]);
const $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$catalogTitleStyles = (0, $74Zh5.css)([
    $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$baseTitleStyles,
    {
        fontSize: "20px",
        lineHeight: "28px",
        marginTop: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} !important`
    }
]);
const $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$descriptionStyles = (0, $74Zh5.css)({
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250"),
    marginBottom: 0,
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle")
});
const $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$descriptionNoClampStyles = (0, $74Zh5.css)({
    display: "block",
    WebkitLineClamp: "none",
    overflow: "visible"
});
const $24c02ea0e14dbe4f$var$$f73a4551a9d8a3b1$export$8a8c015277a3d77a = ({ imageUrl: imageUrl, backgroundColor: backgroundColor, productIcon: productIcon, isLearningProgress: isLearningProgress, imageHeight: imageHeight })=>{
    let height = isLearningProgress ? "96px" : "80px";
    if (imageHeight) height = `${imageHeight}px`;
    const backgroundSize = imageHeight ? "contain" : "cover";
    const backgroundPosition = imageHeight ? "center" : undefined; // if imageHeight is provided, the image will be displayed at the center of the container
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$f73a4551a9d8a3b1$var$imageBaseStyles,
            !imageUrl && $24c02ea0e14dbe4f$var$$f73a4551a9d8a3b1$var$noImageStyles,
            (0, $74Zh5.css)({
                backgroundColor: backgroundColor,
                height: height,
                backgroundSize: backgroundSize,
                ...backgroundPosition && {
                    backgroundPosition: backgroundPosition
                }
            })
        ],
        style: {
            backgroundImage: `url(${imageUrl})`
        },
        "data-testid": "card-image",
        children: productIcon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
            css: (0, $74Zh5.css)({
                marginLeft: "26px"
            }),
            src: productIcon,
            alt: "product icon"
        })
    });
};
const $24c02ea0e14dbe4f$var$$f73a4551a9d8a3b1$var$imageBaseStyles = (0, $74Zh5.css)({
    width: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    borderRadius: "7px 7px 0 0",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center"
});
const $24c02ea0e14dbe4f$var$$f73a4551a9d8a3b1$var$noImageStyles = (0, $74Zh5.css)({
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
});
const $24c02ea0e14dbe4f$var$$70542fe329d53412$export$ce572121d239fe86 = 4;
const $24c02ea0e14dbe4f$var$$70542fe329d53412$export$3b38c99bd0870716 = 290;
const $24c02ea0e14dbe4f$var$$70542fe329d53412$export$bb4069a5b1582edc = 24;
const $24c02ea0e14dbe4f$var$$70542fe329d53412$export$9c6eb1f46b993412 = 3;
const $24c02ea0e14dbe4f$var$$fb345954107134f9$export$331084b24da1eef5 = ({ tags: tags, lastLabelWidth: lastLabelWidth })=>tags.length > 0 && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$fb345954107134f9$var$labelContainerStyles,
        id: "tabs-container",
        children: tags.slice(0, $24c02ea0e14dbe4f$var$$70542fe329d53412$export$9c6eb1f46b993412).map((tag, index, arr)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: index === arr.length - 1 && (0, $74Zh5.css)([
                    {
                        "& > div": {
                            width: lastLabelWidth
                        }
                    },
                    $24c02ea0e14dbe4f$var$$fb345954107134f9$var$truncatedLabelStyles
                ]),
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                    ...tag
                })
            }, tag.label + index))
    });
const $24c02ea0e14dbe4f$var$$fb345954107134f9$var$labelContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: `${$24c02ea0e14dbe4f$var$$70542fe329d53412$export$ce572121d239fe86}px`,
    padding: `0 ${$24c02ea0e14dbe4f$var$$70542fe329d53412$export$bb4069a5b1582edc}px`,
    overflow: "hidden"
});
const $24c02ea0e14dbe4f$var$$fb345954107134f9$var$truncatedLabelStyles = (0, $74Zh5.css)({
    "& > div": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "block"
    }
});
var $24c02ea0e14dbe4f$var$$d8ee29df49af8811$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$d8ee29df49af8811$exports, "LearningProgressBar", ()=>$24c02ea0e14dbe4f$export$184a993f673fc83f);
const $24c02ea0e14dbe4f$export$184a993f673fc83f = ({ wasPreviouslyCompleted: wasPreviouslyCompleted = false, completedResources: completedResources, resourceCount: resourceCount, completionDate: completionDate, contentType: contentType })=>{
    const getProgressText = ()=>{
        switch(contentType){
            case $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.COURSE:
                return `${completedResources} of ${resourceCount} lessons`;
            case $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.LEARNING_PATH:
                return `${completedResources} of ${resourceCount} courses`;
            default:
                return `${Math.round($24c02ea0e14dbe4f$export$6e67b290ed5690f6(completedResources, resourceCount))}%`;
        }
    };
    if (completedResources === resourceCount || wasPreviouslyCompleted) return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "learning-progress-bar-container",
        css: $24c02ea0e14dbe4f$var$$d8ee29df49af8811$var$progressBarContainerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$d8ee29df49af8811$var$progressBarStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: "gap-completed"
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
                css: [
                    $24c02ea0e14dbe4f$var$$d8ee29df49af8811$var$progressTitleStyles,
                    (0, $74Zh5.css)({
                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.success")
                    })
                ],
                children: [
                    "Completed ",
                    completionDate
                ]
            })
        ]
    });
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "learning-progress-bar-container",
        css: $24c02ea0e14dbe4f$var$$d8ee29df49af8811$var$progressBarContainerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$d8ee29df49af8811$var$progressBarStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f188eff9b59fb855$export$5ab97151efedb8c6), {
                    strokeWidth: 10,
                    value: $24c02ea0e14dbe4f$export$6e67b290ed5690f6(completedResources, resourceCount),
                    styles: (0, $f188eff9b59fb855$export$5115a192ad9bf57f)({
                        pathColor: completedResources === 0 ? (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border") : (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.success")
                    })
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                css: $24c02ea0e14dbe4f$var$$d8ee29df49af8811$var$progressTitleStyles,
                children: getProgressText()
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$d8ee29df49af8811$var$progressBarContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$d8ee29df49af8811$var$progressBarStyles = (0, $74Zh5.css)({
    display: "flex",
    maxWidth: "20px",
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$d8ee29df49af8811$var$progressTitleStyles = (0, $74Zh5.css)({
    marginTop: 0,
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    fontFamily: "Inter, sans-serif",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle")
});
let $24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061;
(function(LearningProgressStatus) {
    LearningProgressStatus["NOT_STARTED"] = "NOT_STARTED";
    LearningProgressStatus["IN_PROGRESS"] = "IN_PROGRESS";
    LearningProgressStatus["COMPLETED"] = "COMPLETED";
})($24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061 || ($24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061 = {}));
let $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8;
(function(CardStatus) {
    CardStatus["COMPLETED"] = "completed";
    CardStatus["DEFAULT"] = "default";
})($24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8 || ($24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8 = {}));
const $24c02ea0e14dbe4f$var$$035f8a623e403361$export$780035d9fe48eb32 = 420;
var $24c02ea0e14dbe4f$var$$ec9b8ebbd21bd316$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$ec9b8ebbd21bd316$exports, "ShowMore", ()=>$24c02ea0e14dbe4f$export$ca7697601dcd7803);
const $24c02ea0e14dbe4f$export$ca7697601dcd7803 = ({ cardRef: cardRef, shareOnPdf: shareOnPdf, onGeneratePdf: onGeneratePdf, areHistoricalNotifications: areHistoricalNotifications, onViewUpdates: onViewUpdates, alignToRight: alignToRight })=>{
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const dropdownRef = (0, $5FkrB.useRef)(null);
    const handleButtonClick = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        setIsOpen(!isOpen);
    };
    const handleOnGeneratePDF = (event)=>{
        if (onGeneratePdf) {
            event.stopPropagation();
            event.preventDefault();
            onGeneratePdf();
            setIsOpen(!isOpen);
        }
    };
    const handleOnViewUpdates = (event)=>{
        if (onViewUpdates) {
            event.stopPropagation();
            event.preventDefault();
            onViewUpdates();
            setIsOpen(!isOpen);
        }
    };
    const handleGeneratePdf = (0, $5FkrB.useCallback)(()=>{
        if (onGeneratePdf) onGeneratePdf();
    }, [
        onGeneratePdf
    ]);
    const handleViewUpdates = (0, $5FkrB.useCallback)(()=>{
        if (onViewUpdates) onViewUpdates();
    }, [
        onViewUpdates
    ]);
    const onKeyDownGeneratePdf = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleGeneratePdf);
    const onKeyDownViewUpdates = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleViewUpdates);
    (0, $5FkrB.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            const isClickOnThisCard = (cardRef?.current || dropdownRef.current)?.contains(event.target);
            if (!isClickOnThisCard) setIsOpen(false);
        };
        if (isOpen) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isOpen,
        cardRef
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: (0, $74Zh5.css)({
            width: "fit-content",
            position: "relative"
        }),
        "data-testid": "show-more",
        ref: dropdownRef,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                label: "",
                appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON,
                onClick: handleButtonClick,
                selected: isOpen,
                iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: "more-vertical"
                }),
                iconType: "more-vertical"
            }),
            isOpen && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": "show-more-dropdown",
                css: [
                    $24c02ea0e14dbe4f$var$$ec9b8ebbd21bd316$var$showMoreDropdownStyles,
                    alignToRight && (0, $74Zh5.css)({
                        right: "unset",
                        textAlign: "left"
                    })
                ],
                children: [
                    shareOnPdf && onGeneratePdf && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        role: "button",
                        tabIndex: 0,
                        css: $24c02ea0e14dbe4f$var$$ec9b8ebbd21bd316$var$optionStyles,
                        onClick: handleOnGeneratePDF,
                        onKeyDown: onKeyDownGeneratePdf,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $24c02ea0e14dbe4f$var$$ec9b8ebbd21bd316$var$optionTextStyles,
                            children: "Export to PDF"
                        })
                    }),
                    areHistoricalNotifications && onViewUpdates && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        role: "button",
                        tabIndex: 0,
                        css: $24c02ea0e14dbe4f$var$$ec9b8ebbd21bd316$var$optionStyles,
                        onClick: handleOnViewUpdates,
                        onKeyDown: onKeyDownViewUpdates,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $24c02ea0e14dbe4f$var$$ec9b8ebbd21bd316$var$optionTextStyles,
                            children: "View updates"
                        })
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$ec9b8ebbd21bd316$var$showMoreDropdownStyles = (0, $74Zh5.css)({
    position: "absolute",
    right: 0,
    display: "flex",
    flexDirection: "column",
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "4px",
    padding: "7px 0",
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
    zIndex: 2,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay")
});
const $24c02ea0e14dbe4f$var$$ec9b8ebbd21bd316$var$optionStyles = (0, $74Zh5.css)({
    width: "220px",
    padding: "7px 24px",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    backgroundColor: "transparent",
    boxSizing: "border-box",
    cursor: "pointer",
    ":hover": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral.subtle.hovered")
    }
});
const $24c02ea0e14dbe4f$var$$ec9b8ebbd21bd316$var$optionTextStyles = (0, $74Zh5.css)({
    fontSize: "16px",
    lineHeight: "20px",
    fontFamily: "Inter, sans-serif",
    fontWeight: "400"
});
const $24c02ea0e14dbe4f$export$c01be50dd5c433fe = ({ inspectMode: inspectMode, title: title, description: description, onClick: onClick, target: target, link: link, tags: tags, disableDescriptionClamp: disableDescriptionClamp, minHeight: minHeight = 248, isLoading: isLoading = false, learningProgress: learningProgress, onGeneratePdf: onGeneratePdf, shouldDisplayShowMoreButton: shouldDisplayShowMoreButton, shouldDisplayBookmark: shouldDisplayBookmark, isUpdated: isUpdated, areHistoricalNotifications: areHistoricalNotifications, onViewUpdates: onViewUpdates, onUpdatedButtonClick: onUpdatedButtonClick, productIcon: productIcon, imageUrl: imageUrl, imageHeight: imageHeight, backgroundColor: backgroundColor })=>{
    const cardRef = (0, $5FkrB.useRef)(null);
    const [lastLabelWidth, setLastLabelWidth] = (0, $5FkrB.useState)("auto");
    const clickHandler = (0, $5FkrB.useCallback)(()=>{
        onClick && onClick();
    }, [
        onClick
    ]);
    const handleKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(clickHandler);
    const handleOnSave = (event)=>{
        if (learningProgress) {
            event.stopPropagation();
            event.preventDefault();
            learningProgress.onSave(!learningProgress.isSaved);
        }
    };
    const handleUpdatedButtonClick = (0, $5FkrB.useCallback)((event)=>{
        event.stopPropagation();
        event.preventDefault();
        onUpdatedButtonClick && onUpdatedButtonClick();
    }, [
        onUpdatedButtonClick
    ]);
    (0, $5FkrB.useEffect)(()=>{
        // truncating the last label if it doesn't fit in the card
        if (tags.length && cardRef.current) {
            const card = cardRef.current;
            const tagsContainer = card.querySelector("#tabs-container");
            const maxTagsContainerWidth = (card?.offsetWidth || $24c02ea0e14dbe4f$var$$70542fe329d53412$export$3b38c99bd0870716) - $24c02ea0e14dbe4f$var$$70542fe329d53412$export$bb4069a5b1582edc * 2;
            let firstTagsWidth = 0;
            let totalTagsWidth = 0;
            if (tagsContainer) {
                Array.from(tagsContainer.children).slice(0, $24c02ea0e14dbe4f$var$$70542fe329d53412$export$9c6eb1f46b993412).forEach((tag, i, arr)=>{
                    if (i < arr.length - 1) firstTagsWidth += tag.clientWidth + $24c02ea0e14dbe4f$var$$70542fe329d53412$export$ce572121d239fe86;
                    totalTagsWidth += tag.clientWidth;
                });
                const shouldTruncate = totalTagsWidth + ($24c02ea0e14dbe4f$var$$70542fe329d53412$export$ce572121d239fe86 * tagsContainer.children.length - 1) + $24c02ea0e14dbe4f$var$$70542fe329d53412$export$bb4069a5b1582edc * 2 > card?.offsetWidth;
                if (shouldTruncate) setLastLabelWidth(maxTagsContainerWidth - firstTagsWidth - 2);
            }
        }
    }, [
        cardRef.current
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ if (isLoading) return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$learningContentCardContainerStyles,
            $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$loadingLearningContentCardContainerStyles
        ],
        "data-testid": "loading-learning-content-card",
        style: {
            minHeight: `${minHeight}px`
        },
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$imageBaseStyles,
                    $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$noImageStyles
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$bodyContainerStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$labelContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$smallPillStyles
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: [
                                        $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$smallPillStyles,
                                        (0, $74Zh5.css)({
                                            marginLeft: "24px"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$titleAndDetailsContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: (0, $74Zh5.css)({
                                marginTop: "12px"
                            }),
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: [
                                        $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$bigPillStyles,
                                        (0, $74Zh5.css)({
                                            width: "212px"
                                        })
                                    ]
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$bigPillStyles
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        href: link,
        target: target,
        rel: "noopener noreferrer",
        css: $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$linkContainerStyles,
        onClick: (e)=>e.preventDefault(),
        tabIndex: -1,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            ref: cardRef,
            role: "link",
            css: $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$learningContentCardContainerStyles,
            onClick: clickHandler,
            onKeyDown: handleKeyDown,
            tabIndex: 0,
            "data-testid": "learning-content-card",
            style: {
                minHeight: `${minHeight}px`
            },
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$f73a4551a9d8a3b1$export$8a8c015277a3d77a, {
                    imageUrl: imageUrl,
                    backgroundColor: backgroundColor,
                    productIcon: productIcon,
                    isLearningProgress: !!learningProgress,
                    imageHeight: imageHeight
                }),
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: [
                        $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$bodyContainerStyles,
                        learningProgress && $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$progressBodyContainerStyles
                    ],
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$fb345954107134f9$export$331084b24da1eef5, {
                            tags: tags,
                            lastLabelWidth: lastLabelWidth
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$94fa590b0c9d9421$export$64ef9b8c11710c47, {
                            title: title,
                            description: description,
                            inspectMode: inspectMode,
                            isLearningProgress: !!learningProgress,
                            disableDescriptionClamp: disableDescriptionClamp
                        }),
                        learningProgress && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$learningContentCardProgressContainerStyles,
                            "data-testid": "learning-progress-content",
                            children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$learningContentCardProgressItemsContainerStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$184a993f673fc83f, {
                                        wasPreviouslyCompleted: learningProgress.status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED,
                                        completedResources: learningProgress.completedResources,
                                        resourceCount: learningProgress.resourceCount,
                                        completionDate: learningProgress.completionDate,
                                        contentType: $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.LEARNING_PATH
                                    }),
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        css: $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$learningContentCardIconsContainerStyles,
                                        children: [
                                            isUpdated && learningProgress.status !== $24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                "data-testid": "updated-icon",
                                                css: $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$updatedIconContainerStyles,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                                    label: "Updated",
                                                    iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                                        type: "editor-panel"
                                                    }),
                                                    onClick: handleUpdatedButtonClick
                                                })
                                            }),
                                            shouldDisplayShowMoreButton && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$ca7697601dcd7803, {
                                                cardRef: cardRef,
                                                shareOnPdf: true,
                                                onGeneratePdf: onGeneratePdf,
                                                areHistoricalNotifications: areHistoricalNotifications,
                                                onViewUpdates: onViewUpdates
                                            }),
                                            shouldDisplayBookmark && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                                                "data-testid": "save-content",
                                                css: $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$learningContentCardBookmarkContainerStyles,
                                                onClick: handleOnSave,
                                                children: learningProgress.isSaved ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                                    type: "bookmark-filled"
                                                }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                                    type: "bookmark"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$imageBaseStyles = (0, $74Zh5.css)({
    width: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    borderRadius: "7px 7px 0px 0px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    height: "80px"
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$noImageStyles = (0, $74Zh5.css)({
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$bodyContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: `${$24c02ea0e14dbe4f$var$$70542fe329d53412$export$bb4069a5b1582edc}px 0 0`
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$progressBodyContainerStyles = (0, $74Zh5.css)({
    padding: `21px 0 0`
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$labelContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: `${$24c02ea0e14dbe4f$var$$70542fe329d53412$export$ce572121d239fe86}px`,
    padding: `0 ${$24c02ea0e14dbe4f$var$$70542fe329d53412$export$bb4069a5b1582edc}px`,
    overflow: "hidden"
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$linkContainerStyles = (0, $74Zh5.css)({
    textDecoration: "none",
    "&:hover": {
        textDecoration: "none"
    }
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$titleAndDetailsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: `0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")}`
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$learningContentCardProgressContainerStyles = (0, $74Zh5.css)({
    borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$learningContentCardProgressItemsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    padding: `18px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")}`
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$learningContentCardIconsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: "5px"
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$updatedIconContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: "5px",
    button: {
        backgroundColor: "transparent",
        height: "auto",
        minHeight: "auto",
        alignItems: "center",
        ":hover": {
            backgroundColor: "transparent"
        }
    },
    span: {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected"),
        fontFamily: "SF Pro, sans-serif",
        fontSize: "14px",
        lineHeight: "20px"
    }
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$learningContentCardBookmarkContainerStyles = (0, $74Zh5.css)({
    height: "24px",
    border: "none",
    background: "none",
    cursor: "pointer",
    outline: "none",
    "&:focus-visible": {
        outline: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$learningContentCardContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "8px",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    transition: "box-shadow 0.3s ease-in-out",
    cursor: "pointer",
    minWidth: `${$24c02ea0e14dbe4f$var$$70542fe329d53412$export$3b38c99bd0870716}px`,
    "&:hover": {
        boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    },
    "&:active": {
        outline: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.focused")}`,
        border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.focused")}`
    },
    '&:has([data-testid="show-more"]:active)': {
        outline: "none",
        border: "none"
    }
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$loadingLearningContentCardContainerStyles = (0, $74Zh5.css)({
    boxShadow: "none",
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.disabled")}`,
    cursor: "initial",
    "&:hover": {
        boxShadow: "none"
    },
    "&:active": {
        outline: "none",
        border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.disabled")}`
    }
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$smallPillStyles = (0, $74Zh5.css)({
    width: "52px",
    height: "10.5px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral"),
    borderRadius: "15px",
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    display: "inline-block"
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$bigPillStyles = (0, $74Zh5.css)({
    maxWidth: "227px",
    height: "17.5px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral"),
    borderRadius: "25px",
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
var $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$1f7c4876f10b107b$exports, "Modal", ()=>$24c02ea0e14dbe4f$export$2b77a92f1a5ad772);
let $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$DialogWidth;
(function(DialogWidth) {
    DialogWidth["SMALL"] = "small";
    DialogWidth["MEDIUM"] = "medium";
    DialogWidth["LARGE"] = "large";
    DialogWidth["XLARGE"] = "x-large";
})($24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$DialogWidth || ($24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$DialogWidth = {}));
const $24c02ea0e14dbe4f$export$2b77a92f1a5ad772 = ({ closeModal: closeModal, width: width = $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$DialogWidth.LARGE, imageLink: imageLink, actionButton: actionButton, heading: heading, subheading: subheading, surveyText: surveyText })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $73c4314b1cf0d4b0$export$2e2bcd8739ae039), {
        onClose: closeModal,
        width: width,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalContainerStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    css: $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalCloseButtonStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                        label: "close modal button",
                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON,
                        iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: "cross"
                        }),
                        onClick: closeModal
                    })
                }),
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalBodyStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalImageContainerStyles,
                            children: imageLink && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                                src: imageLink,
                                alt: "modal-image",
                                width: 120,
                                height: 120,
                                css: $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$imageStyles
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                            "data-testid": "modal-heading",
                            css: $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalHeadingContainerStyles,
                            children: heading
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            "data-testid": "modal-subheading",
                            css: $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalSubheadingContainerStyles,
                            children: subheading
                        }),
                        surveyText && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            "data-testid": "modal-survey-text",
                            css: [
                                $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalSubheadingContainerStyles,
                                $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$surveyTextStyles
                            ],
                            children: surveyText
                        }),
                        actionButton && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalActionButtonContainerStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                                size: $24c02ea0e14dbe4f$export$5dd2748b7940a2a0.LARGE,
                                onClick: actionButton.onClick,
                                label: actionButton.label,
                                iconBefore: actionButton.iconBefore,
                                iconAfter: actionButton.iconAfter
                            })
                        })
                    ]
                })
            ]
        })
    });
const $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$imageStyles = (0, $74Zh5.css)({
    borderRadius: "50%"
});
const $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalContainerStyles = (0, $74Zh5.css)({
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.500")}`,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        padding: "16px"
    }
});
const $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalCloseButtonStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        padding: "8px"
    }
});
const $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalImageContainerStyles = (0, $74Zh5.css)({
    marginBottom: "24px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        marginBottom: "16px"
    }
});
const $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalBodyStyles = (0, $74Zh5.css)({
    maxWidth: "640px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} auto 0`,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        marginTop: 0
    }
});
const $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalHeadingContainerStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "32px",
    fontWeight: 600,
    lineHeight: "40px",
    marginTop: 0,
    marginBottom: "24px",
    textAlign: "center",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        marginTop: 0,
        marginBottom: "16px",
        fontSize: "24px",
        lineHeight: "32px"
    }
});
const $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalSubheadingContainerStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "32px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    textAlign: "center",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        marginBottom: "32px",
        fontSize: "16px",
        lineHeight: "24px"
    }
});
const $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$surveyTextStyles = (0, $74Zh5.css)({
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    a: {
        fontSize: "20px"
    }
});
const $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalActionButtonContainerStyles = (0, $74Zh5.css)({
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        margin: 0
    }
});
var $24c02ea0e14dbe4f$var$$c5616d3f1657fc84$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$c5616d3f1657fc84$exports, "LessonsTabContentSize", ()=>$24c02ea0e14dbe4f$export$415b2bdf1346d2d4);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$c5616d3f1657fc84$exports, "LessonsTabContent", ()=>$24c02ea0e14dbe4f$export$ce96f190f5d3ee14);
let $24c02ea0e14dbe4f$export$415b2bdf1346d2d4;
(function(LessonsTabContentSize) {
    LessonsTabContentSize["DEFAULT"] = "default";
    LessonsTabContentSize["WIDE"] = "wide";
})($24c02ea0e14dbe4f$export$415b2bdf1346d2d4 || ($24c02ea0e14dbe4f$export$415b2bdf1346d2d4 = {}));
const $24c02ea0e14dbe4f$export$ce96f190f5d3ee14 = ({ tabLinks: tabLinks, activeTab: activeTab = 0, onClickTab: onClickTab, children: children, size: size = $24c02ea0e14dbe4f$export$415b2bdf1346d2d4.DEFAULT })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$c5616d3f1657fc84$var$tabsContainerStyles["base"],
            $24c02ea0e14dbe4f$var$$c5616d3f1657fc84$var$tabsContainerStyles[`${size}-size`]
        ],
        "data-testid": "navtab",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
                css: $24c02ea0e14dbe4f$var$$c5616d3f1657fc84$var$tabsButtonGroupContainerStyles,
                children: tabLinks.map((tab, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                        "data-testid": `button-${tab}${index === activeTab ? "-selected" : ""}`,
                        css: $24c02ea0e14dbe4f$var$$c5616d3f1657fc84$var$tabsButtonContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3e41faf802a29e71, {
                            size: $24c02ea0e14dbe4f$export$ddadc1228c8dcfa.LARGE,
                            label: tab,
                            onClick: ()=>onClickTab(index),
                            selected: index === activeTab
                        })
                    }, `li-navtab-${tab}-${index}`))
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$c5616d3f1657fc84$var$tabsContentContainerStyles,
                children: children
            })
        ]
    });
const $24c02ea0e14dbe4f$var$$c5616d3f1657fc84$var$tabsContainerStyles = {
    base: (0, $74Zh5.css)({
        width: "100%",
        borderRadius: "8px",
        boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised"),
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
            maxWidth: "720px"
        }
    }),
    "default-size": (0, $74Zh5.css)({
        maxWidth: "720px"
    }),
    "wide-size": (0, $74Zh5.css)({
        maxWidth: "1020px"
    })
};
const $24c02ea0e14dbe4f$var$$c5616d3f1657fc84$var$tabsButtonGroupContainerStyles = (0, $74Zh5.css)({
    padding: "18px",
    overflowX: "auto",
    listStyleType: "none",
    borderBottom: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    margin: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        padding: "12px"
    }
});
const $24c02ea0e14dbe4f$var$$c5616d3f1657fc84$var$tabsButtonContainerStyles = (0, $74Zh5.css)({
    margin: "6px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        margin: "4px"
    }
});
const $24c02ea0e14dbe4f$var$$c5616d3f1657fc84$var$tabsContentContainerStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "32px",
    letterSpacing: "-0.06px",
    padding: "24px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    a: {
        fontSize: "20px",
        lineHeight: "32px"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        padding: "16px",
        fontSize: "16px",
        lineHeight: "24px"
    }
});
var $24c02ea0e14dbe4f$var$$eb6f767c51421421$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$eb6f767c51421421$exports, "Metadata", ()=>$24c02ea0e14dbe4f$export$e7adebdc1ebd2fed);
const $24c02ea0e14dbe4f$export$e7adebdc1ebd2fed = ({ fields: fields })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$eb6f767c51421421$var$metadataContainerStyles,
        "data-testid": "metadata",
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: $24c02ea0e14dbe4f$var$$eb6f767c51421421$var$metadataListStyles,
            children: fields.map((field)=>field.value && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $24c02ea0e14dbe4f$var$$eb6f767c51421421$var$metadataItemsStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                            css: $24c02ea0e14dbe4f$var$$eb6f767c51421421$var$metadataTitleStyles,
                            children: field.name
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$eb6f767c51421421$var$metadataValueStyles,
                            children: field.value
                        })
                    ]
                }, field.name))
        })
    });
const $24c02ea0e14dbe4f$var$$eb6f767c51421421$var$metadataContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400"),
    alignItems: "flex-start",
    flexDirection: "column",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "8px",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised")
});
const $24c02ea0e14dbe4f$var$$eb6f767c51421421$var$metadataListStyles = (0, $74Zh5.css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
});
const $24c02ea0e14dbe4f$var$$eb6f767c51421421$var$metadataItemsStyles = (0, $74Zh5.css)({
    display: "flex",
    minHeight: "24px",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    alignItems: "center"
});
const $24c02ea0e14dbe4f$var$$eb6f767c51421421$var$metadataTitleStyles = (0, $74Zh5.css)({
    margin: 0,
    minWidth: "88px",
    color: "#000",
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "18px",
    textTransform: "uppercase"
});
const $24c02ea0e14dbe4f$var$$eb6f767c51421421$var$metadataValueStyles = (0, $74Zh5.css)({
    margin: 0,
    color: "#000",
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px"
});
var $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$exports, "ArrowPosition", ()=>$24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$exports, "Popup", ()=>$24c02ea0e14dbe4f$export$129a32eedafa97c5);
let $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9;
(function(ArrowPosition) {
    ArrowPosition["LEFT_START"] = "leftStart";
    ArrowPosition["LEFT_CENTER"] = "leftCenter";
    ArrowPosition["LEFT_END"] = "leftEnd";
    ArrowPosition["TOP_START"] = "topStart";
    ArrowPosition["TOP_CENTER"] = "topCenter";
    ArrowPosition["TOP_END"] = "topEnd";
    ArrowPosition["RIGHT_START"] = "rightStart";
    ArrowPosition["RIGHT_CENTER"] = "rightCenter";
    ArrowPosition["RIGHT_END"] = "rightEnd";
    ArrowPosition["BOTTOM_START"] = "bottomStart";
    ArrowPosition["BOTTOM_CENTER"] = "bottomCenter";
    ArrowPosition["BOTTOM_END"] = "bottomEnd";
})($24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9 || ($24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9 = {}));
const $24c02ea0e14dbe4f$export$129a32eedafa97c5 = (0, $5FkrB.forwardRef)(({ popupHeight: popupHeight, title: title, children: children, step: step, totalSteps: totalSteps, arrowPosition: arrowPosition, onClose: onClose, onPrevious: onPrevious, onNext: onNext, popupStyle: popupStyle }, popoverRef)=>{
    const CONTAINER_SIZE_PX = 88;
    const handlePrevious = ()=>{
        if (onPrevious) onPrevious();
    };
    const handleNext = ()=>{
        if (onNext) onNext();
    };
    const handleClose = ()=>{
        if (onClose) onClose();
    };
    (0, $5FkrB.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (popoverRef && !popoverRef.current.contains(event.target)) handleClose();
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    // handleClose and popoverRef intentionally excluded to avoid re-creating listener
    /* eslint-disable react-hooks/exhaustive-deps */ }, [
        onClose
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        role: "dialog",
        "aria-label": title,
        "data-testid": `popup-${arrowPosition}`,
        css: $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$popupContainerStyles,
        style: popupStyle,
        ref: popoverRef,
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- Dialog needs tabIndex for focus management
        tabIndex: 0,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: [
                $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$popupContentStyles["base"],
                $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$popupContentStyles[arrowPosition]
            ],
            children: [
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$contentHeaderStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
                            css: $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$counterContainerStyles,
                            children: [
                                step,
                                "/",
                                totalSteps
                            ]
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$buttonsContainerStyles,
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                    disabled: step === 1,
                                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON,
                                    label: "Previous",
                                    iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                        type: "chevron-left",
                                        alt: "next icon"
                                    }),
                                    onClick: handlePrevious
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                    disabled: step === totalSteps,
                                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON,
                                    label: "Next",
                                    iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                        type: "chevron-right",
                                        alt: "previous icon"
                                    }),
                                    onClick: handleNext
                                })
                            ]
                        })
                    ]
                }),
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: (0, $74Zh5.css)({
                        overflow: "auto",
                        maxHeight: `calc(${popupHeight}px - ${CONTAINER_SIZE_PX}px)`,
                        minHeight: "80px",
                        padding: "0 16px"
                    }),
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                            css: $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$titleContainerStyles,
                            children: title
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
                            css: $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$descriptionContainerStyles,
                            children: [
                                " ",
                                children
                            ]
                        })
                    ]
                })
            ]
        })
    });
});
const $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$popupContainerStyles = (0, $74Zh5.css)({
    width: "340px",
    position: "absolute",
    zIndex: 10,
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "8px",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        top: "0 !important",
        left: "0 !important"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        height: "100%",
        width: "100%",
        border: "1px solid",
        borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border"),
        borderRadius: 0
    }
});
const $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$popupContentStyles = {
    base: (0, $74Zh5.css)({
        position: "relative",
        padding: "24px 8px",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
        display: "flex",
        flexDirection: "column",
        "&:after": {
            content: '""',
            display: "block",
            position: "absolute",
            border: "16px solid transparent",
            width: 0,
            height: 0,
            marginTop: "-10px"
        },
        [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
            "&:after": {
                display: "none"
            }
        }
    }),
    leftStart: (0, $74Zh5.css)({
        "&::after": {
            top: "35px",
            left: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: 0,
            borderRightColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse"),
            marginLeft: "-10px",
            filter: "drop-shadow(-2px 1px 1px rgb(178, 176, 176))"
        }
    }),
    leftCenter: (0, $74Zh5.css)({
        "&::after": {
            top: "calc(50%)",
            left: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: 0,
            borderRightColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse"),
            marginLeft: "-10px",
            filter: "drop-shadow(-2px 1px 1px rgb(178, 176, 176))"
        }
    }),
    leftEnd: (0, $74Zh5.css)({
        "&::after": {
            left: "-5px",
            bottom: "35px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: 0,
            borderRightColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse"),
            marginLeft: "-10px",
            filter: "drop-shadow(-2px 1px 1px rgb(178, 176, 176))"
        }
    }),
    topStart: (0, $74Zh5.css)({
        "&::after": {
            top: "-21px",
            left: "35px",
            borderRight: "12px solid transparent",
            borderLeft: "12px solid transparent",
            borderBottom: `16px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`,
            marginRight: "-10px",
            filter: "drop-shadow(0 -1px 0.4px rgb(178, 176, 176))"
        }
    }),
    topCenter: (0, $74Zh5.css)({
        "&::after": {
            top: "-5px",
            left: "calc(50% - 16px)",
            borderRight: "12px solid transparent",
            borderLeft: "12px solid transparent",
            borderBottom: `16px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderTop: 0,
            marginRight: "-10px",
            filter: "drop-shadow(0 -1px 0.4px rgb(178, 176, 176))"
        }
    }),
    topEnd: (0, $74Zh5.css)({
        "&::after": {
            top: "-5px",
            right: "35px",
            borderRight: "12px solid transparent",
            borderLeft: "12px solid transparent",
            borderBottom: `16px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderTop: 0,
            marginRight: "-10px",
            filter: "drop-shadow(0 -1px 0.4px rgb(178, 176, 176))"
        }
    }),
    rightStart: (0, $74Zh5.css)({
        "&::after": {
            top: "35px",
            right: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: `16px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderRight: 0,
            marginRight: "-10px",
            filter: "drop-shadow(2px 0 1px #939393)"
        }
    }),
    rightCenter: (0, $74Zh5.css)({
        "&::after": {
            top: "calc(50% - 10px)",
            right: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: `16px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderRight: 0,
            marginRight: "-10px",
            filter: "drop-shadow(2px 0 1px #939393)"
        }
    }),
    rightEnd: (0, $74Zh5.css)({
        "&::after": {
            bottom: "35px",
            right: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: `16px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderRight: 0,
            marginRight: "-10px",
            filter: "drop-shadow(2px 0 1px #939393)"
        }
    }),
    bottomStart: (0, $74Zh5.css)({
        "&::after": {
            left: "35px",
            bottom: "-14px",
            borderLeft: "12px solid transparent",
            borderRight: "12px solid transparent",
            borderTop: `16px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderBottom: 0,
            filter: "drop-shadow(0 4px 2px #939393)"
        }
    }),
    bottomCenter: (0, $74Zh5.css)({
        "&::after": {
            left: "calc(50% - 16px)",
            bottom: "-14px",
            borderLeft: "12px solid transparent",
            borderRight: "12px solid transparent",
            borderTop: `16px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderBottom: 0,
            filter: "drop-shadow(0 4px 2px #939393)"
        }
    }),
    bottomEnd: (0, $74Zh5.css)({
        "&::after": {
            right: "35px",
            bottom: "-14px",
            borderLeft: "12px solid transparent",
            borderRight: "12px solid transparent",
            borderTop: `16px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderBottom: 0,
            filter: "drop-shadow(0 4px 2px #939393)"
        }
    })
};
const $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$contentHeaderStyles = (0, $74Zh5.css)({
    padding: "0 16px",
    marginBottom: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$titleContainerStyles = (0, $74Zh5.css)({
    marginBottom: "16px",
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px"
});
const $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$descriptionContainerStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px"
});
const $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$counterContainerStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "18px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest")
});
const $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$buttonsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center"
});
var $24c02ea0e14dbe4f$var$$915f5687b3b07750$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$915f5687b3b07750$exports, "ProgressBar", ()=>$24c02ea0e14dbe4f$export$c17561cb55d4db30);
const $24c02ea0e14dbe4f$export$c17561cb55d4db30 = ({ progress: progress, color: color })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        "data-testid": "progress-bar",
        css: $24c02ea0e14dbe4f$var$$915f5687b3b07750$var$progressBarContainerStyles,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            "data-testid": `progress-${progress}`,
            css: [
                $24c02ea0e14dbe4f$var$$915f5687b3b07750$var$progressBarContentStyles,
                color && (0, $74Zh5.css)({
                    backgroundColor: color
                }),
                (0, $74Zh5.css)({
                    width: `${progress}%`
                })
            ]
        })
    });
const $24c02ea0e14dbe4f$var$$915f5687b3b07750$var$progressBarContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "8px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtler"),
    borderRadius: "100px",
    overflow: "hidden"
});
const $24c02ea0e14dbe4f$var$$915f5687b3b07750$var$progressBarContentStyles = (0, $74Zh5.css)({
    height: "8px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.success"),
    borderRadius: "100px"
});
var $24c02ea0e14dbe4f$var$$579f9ef2424e0bd8$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$579f9ef2424e0bd8$exports, "ProgressStatus", ()=>$24c02ea0e14dbe4f$export$fad76899145ca0c7);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$579f9ef2424e0bd8$exports, "defineProgressStatus", ()=>$24c02ea0e14dbe4f$export$aa03ab7e1a208875);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$579f9ef2424e0bd8$exports, "LearningHeader", ()=>$24c02ea0e14dbe4f$export$86f07cccb119409d);
var $24c02ea0e14dbe4f$var$$2cfa64583f556289$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$2cfa64583f556289$exports, "PopupShare", ()=>$24c02ea0e14dbe4f$export$477c64ffaba52edf);
const $24c02ea0e14dbe4f$export$477c64ffaba52edf = ({ cardRef: cardRef, buttonText: buttonText, showCopyLink: showCopyLink = true, shareOnFb: shareOnFb = true, shareOnLinkedin: shareOnLinkedin = true, backgroundColor: backgroundColor = "#FFFFFF", urlToShare: urlToShare, alignToLeft: alignToLeft = false, alignToTop: alignToTop = false, fullWidth: fullWidth = false, color: color = "default", fullHeight: fullHeight = false })=>{
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const [isCopied, setIsCopied] = (0, $5FkrB.useState)(false);
    const dropdownRef = (0, $5FkrB.useRef)(null);
    const handleButtonClick = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        setIsOpen(!isOpen);
    };
    const handleShare = (url)=>{
        window.open(url, "_blank");
    };
    const shareOnFacebook = (0, $5FkrB.useCallback)(()=>{
        const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(urlToShare)}`;
        handleShare(facebookUrl);
    }, [
        urlToShare
    ]);
    const shareOnLinkedIn = (0, $5FkrB.useCallback)(()=>{
        const shareText = "Check out this training from Atlassian!";
        const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(urlToShare)}&text=${encodeURIComponent(shareText)}`;
        handleShare(linkedinUrl);
    }, [
        urlToShare
    ]);
    const copyToClipboard = (0, $5FkrB.useCallback)(()=>{
        navigator.clipboard.writeText(urlToShare).then(()=>{
            setIsCopied(true);
            setTimeout(()=>{
                setIsCopied(false);
            }, 2000);
        });
    }, [
        urlToShare
    ]);
    const onKeyDownLinkedIn = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(shareOnLinkedIn);
    const onKeyDownFacebook = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(shareOnFacebook);
    (0, $5FkrB.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            const isClickOnThisCard = (cardRef?.current || dropdownRef.current)?.contains(event.target);
            if (!isClickOnThisCard) setIsOpen(false);
        };
        if (isOpen) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isOpen,
        cardRef
    ]);
    const primaryColor = (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand");
    const primaryColorStyles = color === "primary" ? (0, $74Zh5.css)({
        color: primaryColor,
        "& span": {
            color: primaryColor
        },
        "& svg": {
            fill: primaryColor
        }
    }) : undefined;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$shareButtonStyles,
            fullHeight && $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$fullHeightStyles,
            $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$fitContentButtonStyles
        ],
        "data-testid": "popup-share",
        ref: dropdownRef,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                label: buttonText ?? "Share",
                appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON,
                onClick: handleButtonClick,
                selected: isOpen,
                size: $24c02ea0e14dbe4f$export$5dd2748b7940a2a0.MEDIUM,
                iconBefore: buttonText ? (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: [
                        $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$buttonWithTextStyles,
                        primaryColorStyles
                    ],
                    "data-testid": "button-with-text",
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$buttonTextStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                children: buttonText
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: "share"
                        })
                    ]
                }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    css: primaryColorStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                        type: "share"
                    })
                }),
                iconType: "share"
            }),
            isOpen && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": "popup-share-dropdown",
                css: [
                    $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$popupShareDropdownStyles,
                    alignToLeft && (0, $74Zh5.css)({
                        width: "176px",
                        right: 0
                    }),
                    alignToTop && (0, $74Zh5.css)({
                        bottom: "50px"
                    })
                ],
                style: {
                    backgroundColor: backgroundColor
                },
                children: [
                    showCopyLink && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                        onClick: copyToClipboard,
                        css: [
                            $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$copyToClipboardOptionStyles,
                            fullWidth && $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$fullWidthOptionsStyles
                        ],
                        "aria-label": "copy to clipboard",
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                type: "link",
                                size: "small"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                css: (0, $74Zh5.css)({
                                    marginLeft: "0.5rem",
                                    fontSize: "0.875rem",
                                    lineHeight: "1.25rem",
                                    fontFamily: "Charlie Text, sans-serif",
                                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
                                }),
                                children: "Copy link"
                            }),
                            isCopied && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                css: $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$isCopiedStyles,
                                children: "Copied!"
                            })
                        ]
                    }),
                    shareOnLinkedin && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        role: "button",
                        tabIndex: 0,
                        css: [
                            $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$shareOnLinkedInOptionStyles,
                            fullWidth && $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$fullWidthOptionsStyles
                        ],
                        onClick: shareOnLinkedIn,
                        onKeyDown: onKeyDownLinkedIn,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                xmlnsXlink: "http://www.w3.org/1999/xlink",
                                version: "1.1",
                                viewBox: "0 0 512 512",
                                style: {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    strokeLinejoin: "round",
                                    strokeMiterlimit: "2",
                                    width: "1rem",
                                    height: "1rem"
                                },
                                xmlSpace: "preserve",
                                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                                    id: "g5891",
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                            d: "M512,64c0,-35.323 -28.677,-64 -64,-64l-384,0c-35.323,0 -64,28.677 -64,64l0,384c0,35.323 28.677,64 64,64l384,0c35.323,0 64,-28.677 64,-64l0,-384Z",
                                            id: "background",
                                            style: {
                                                fill: "#2867b2"
                                            }
                                        }),
                                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                                            id: "shapes",
                                            children: [
                                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("rect", {
                                                    height: "257.962",
                                                    id: "rect11",
                                                    style: {
                                                        fill: "#fff"
                                                    },
                                                    width: "85.76",
                                                    x: "61.053",
                                                    y: "178.667"
                                                }),
                                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                                    d: "M104.512,54.28c-29.341,0 -48.512,19.29 -48.512,44.573c0,24.752 18.588,44.574 47.377,44.574l0.554,0c29.903,0 48.516,-19.822 48.516,-44.574c-0.555,-25.283 -18.611,-44.573 -47.935,-44.573Z",
                                                    id: "path13-0",
                                                    style: {
                                                        fill: "#fff",
                                                        fillRule: "nonzero"
                                                    }
                                                }),
                                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                                    d: "M357.278,172.601c-45.49,0 -65.866,25.017 -77.276,42.589l0,-36.523l-85.738,0c1.137,24.197 0,257.961 0,257.961l85.737,0l0,-144.064c0,-7.711 0.554,-15.42 2.827,-20.931c6.188,-15.4 20.305,-31.352 43.993,-31.352c31.012,0 43.436,23.664 43.436,58.327l0,138.02l85.741,0l0,-147.93c0,-79.237 -42.305,-116.097 -98.72,-116.097Z",
                                                    id: "path15",
                                                    style: {
                                                        fill: "#fff",
                                                        fillRule: "nonzero"
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            " ",
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                css: (0, $74Zh5.css)({
                                    marginLeft: "0.5rem",
                                    fontSize: "0.875rem",
                                    lineHeight: "1.25rem"
                                }),
                                children: "Share on LinkedIn"
                            })
                        ]
                    }),
                    shareOnFb && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        role: "button",
                        tabIndex: 0,
                        css: [
                            $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$shareOnFacebookOptionStyles,
                            fullWidth && $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$fullWidthOptionsStyles
                        ],
                        onClick: shareOnFacebook,
                        onKeyDown: onKeyDownFacebook,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                xmlnsXlink: "http://www.w3.org/1999/xlink",
                                version: "1.1",
                                viewBox: "0 0 512 512",
                                style: {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    strokeLinejoin: "round",
                                    strokeMiterlimit: "2",
                                    width: "1rem",
                                    height: "1rem"
                                },
                                xmlSpace: "preserve",
                                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                            d: "M512,256c0,-141.385 -114.615,-256 -256,-256c-141.385,0 -256,114.615 -256,256c0,127.777 93.616,233.685 216,252.89l0,-178.89l-65,0l0,-74l65,0l0,-56.4c0,-64.16 38.219,-99.6 96.695,-99.6c28.009,0 57.305,5 57.305,5l0,63l-32.281,0c-31.801,0 -41.719,19.733 -41.719,39.978l0,48.022l71,0l-11.35,74l-59.65,0l0,178.89c122.385,-19.205 216,-125.113 216,-252.89Z",
                                            fill: "#1877f2",
                                            fillRule: "nonzero"
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                            d: "M355.65,330l11.35,-74l-71,0l0,-48.022c0,-20.245 9.917,-39.978 41.719,-39.978l32.281,0l0,-63c0,0 -29.297,-5 -57.305,-5c-58.476,0 -96.695,35.44 -96.695,99.6l0,56.4l-65,0l0,74l65,0l0,178.89c13.033,2.045 26.392,3.11 40,3.11c13.608,0 26.966,-1.065 40,-3.11l0,-178.89l59.65,0Z",
                                            fill: "#fff",
                                            fillRule: "nonzero"
                                        })
                                    ]
                                })
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                css: (0, $74Zh5.css)({
                                    marginLeft: "0.5rem",
                                    fontSize: "0.875rem",
                                    lineHeight: "1.25rem"
                                }),
                                children: "Share on Facebook"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$buttonWithTextStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$buttonTextStyles = (0, $74Zh5.css)({
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$shareButtonStyles = (0, $74Zh5.css)({
    width: "fit-content",
    position: "relative",
    "& span": {
        fontFamily: "Charlie Text, sans-serif"
    }
});
const $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$fitContentButtonStyles = (0, $74Zh5.css)({
    '& button[id*="icon-button"]': {
        width: "fit-content !important",
        height: "fit-content !important"
    }
});
const $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$fullHeightStyles = (0, $74Zh5.css)({
    height: "100%",
    '& button[id*="icon-button"]': {
        height: "100% !important"
    }
});
const $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$popupShareDropdownStyles = (0, $74Zh5.css)({
    position: "absolute",
    marginTop: "0.5rem",
    display: "flex",
    flexDirection: "column",
    borderRadius: "0.25rem",
    zIndex: 2,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay")
});
const $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$fullWidthOptionsStyles = (0, $74Zh5.css)({
    whiteSpace: "nowrap"
});
const $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$copyToClipboardOptionStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    whiteSpace: "nowrap",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingLeft: "0.75rem",
    paddingRight: "1rem",
    border: "none",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    cursor: "pointer",
    backgroundColor: "transparent",
    ":hover": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral.subtle.hovered")
    }
});
const $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$isCopiedStyles = (0, $74Zh5.css)({
    position: "absolute",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtle.pressed"),
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontSize: "0.688rem",
    lineHeight: "0.875rem",
    padding: "0.25rem",
    borderRadius: "0.25rem",
    marginTop: "0.25rem",
    right: "1rem"
});
const $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$shareOnLinkedInOptionStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    whiteSpace: "nowrap",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingLeft: "0.75rem",
    paddingRight: "1rem",
    border: "none",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    cursor: "pointer",
    backgroundColor: "transparent",
    ":hover": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral.subtle.hovered")
    }
});
const $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$shareOnFacebookOptionStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    whiteSpace: "nowrap",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingLeft: "0.75rem",
    paddingRight: "1rem",
    border: "none",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    cursor: "pointer",
    backgroundColor: "transparent",
    ":hover": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral.subtle.hovered")
    }
});
let $24c02ea0e14dbe4f$export$fad76899145ca0c7;
(function(ProgressStatus) {
    ProgressStatus["NOT_STARTED"] = "not_started";
    ProgressStatus["IN_PROGRESS"] = "in_progress";
    ProgressStatus["FINISHED"] = "finished";
})($24c02ea0e14dbe4f$export$fad76899145ca0c7 || ($24c02ea0e14dbe4f$export$fad76899145ca0c7 = {}));
const $24c02ea0e14dbe4f$export$aa03ab7e1a208875 = (progressStatus, contentTypeLabel)=>{
    switch(progressStatus){
        case $24c02ea0e14dbe4f$export$fad76899145ca0c7.NOT_STARTED:
            return `Start ${contentTypeLabel}`;
        case $24c02ea0e14dbe4f$export$fad76899145ca0c7.IN_PROGRESS:
            return `Continue ${contentTypeLabel}`;
        case $24c02ea0e14dbe4f$export$fad76899145ca0c7.FINISHED:
            return `Review ${contentTypeLabel}`;
        default:
            return `Start ${contentTypeLabel}`;
    }
};
const $24c02ea0e14dbe4f$export$86f07cccb119409d = ({ inspectMode: inspectMode, heading: heading, anonymousView: anonymousView = true, urlToShare: urlToShare, onSignIn: onSignIn, onStartCourse: onStartCourse, isLoading: isLoading, contentType: contentType, progressStatus: progressStatus, tagLine: tagLine, isSaved: isSaved, onSave: onSave, shouldShowFeedback: shouldShowFeedback, onStartFeedback: onStartFeedback, href: href })=>{
    const handleSignIn = ()=>{
        if (onSignIn) onSignIn();
    };
    const handleStartCourse = (event)=>{
        if (onStartCourse) {
            event?.preventDefault();
            onStartCourse();
        }
    };
    const handleOnSave = ()=>{
        if (onSave) onSave();
    };
    const contentTypeLabel = contentType === $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.COURSE ? "course" : "learning path";
    const status = $24c02ea0e14dbe4f$export$aa03ab7e1a208875(progressStatus, contentTypeLabel);
    const renderActionButtons = ()=>{
        if (isLoading) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
            label: "",
            isLoading: isLoading
        });
        if (anonymousView) return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: (0, $74Zh5.css)({
                display: "flex"
            }),
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                    label: "Sign in",
                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                    onClick: handleSignIn,
                    isLoading: isLoading
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: (0, $74Zh5.css)({
                        marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
                    }),
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                        label: status,
                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.SECONDARY,
                        onClick: handleStartCourse,
                        isLoading: isLoading,
                        href: href,
                        target: "_blank"
                    })
                })
            ]
        });
        return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: (0, $74Zh5.css)({
                display: "flex"
            }),
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                    label: status,
                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                    onClick: handleStartCourse,
                    isLoading: isLoading,
                    href: href,
                    target: "_blank"
                }),
                shouldShowFeedback && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: (0, $74Zh5.css)({
                        marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
                    }),
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                        label: "Take survey",
                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.SECONDARY,
                        onClick: onStartFeedback,
                        isLoading: isLoading
                    })
                })
            ]
        });
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("section", {
        "data-testid": "learning-header",
        css: $24c02ea0e14dbe4f$var$$579f9ef2424e0bd8$var$learningHeaderContainerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$export$f40d73b6f7f951e9
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                    label: contentTypeLabel
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: (0, $74Zh5.css)({
                    margin: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} 0`
                }),
                ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("title", inspectMode),
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                    level: 1,
                    children: heading
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                    css: $24c02ea0e14dbe4f$var$$579f9ef2424e0bd8$var$tagLineStyles,
                    children: tagLine
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: (0, $74Zh5.css)({
                    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
                    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400")
                }),
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2e0a83ec2e27ecbb, {
                    color: (0, $54ca2d3948378259$export$8754fc7e6d8b3000)
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: (0, $74Zh5.css)({
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }),
                children: [
                    renderActionButtons(),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: (0, $74Zh5.css)({
                            display: "flex"
                        }),
                        children: [
                            !anonymousView && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                                tabIndex: 0,
                                css: $24c02ea0e14dbe4f$var$$579f9ef2424e0bd8$var$learningCourseCardBookmarkContainerStyles,
                                onClick: handleOnSave,
                                "aria-label": isSaved ? "unsave" : "save",
                                children: isSaved ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                    type: "bookmark-filled"
                                }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                    type: "bookmark"
                                })
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$477c64ffaba52edf, {
                                urlToShare: urlToShare,
                                alignToLeft: true
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$579f9ef2424e0bd8$var$learningHeaderContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    paddingTop: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.600")}`,
    paddingBottom: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400")}`,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.lg]: {
        paddingTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.1000"),
        paddingBottom: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400")}`
    }
});
const $24c02ea0e14dbe4f$var$$579f9ef2424e0bd8$var$tagLineStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "32px"
});
const $24c02ea0e14dbe4f$var$$579f9ef2424e0bd8$var$learningCourseCardBookmarkContainerStyles = (0, $74Zh5.css)({
    height: "24px",
    border: "none",
    padding: 0,
    marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    background: "none",
    cursor: "pointer",
    outline: "none",
    "&:focus-visible": {
        outline: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")}`,
        borderRadius: "2px"
    }
});
var $24c02ea0e14dbe4f$var$$d559b1cc82536c49$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$d559b1cc82536c49$exports, "Footer", ()=>$24c02ea0e14dbe4f$export$a06f1c675e846f6f);
const $24c02ea0e14dbe4f$export$a06f1c675e846f6f = ({ onOpenReportProblemModal: onOpenReportProblemModal })=>{
    const noOp = ()=>{};
    const onKeyDownReport = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(onOpenReportProblemModal || noOp);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("footer", {
        "data-testid": "footer",
        css: $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$footerContainerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                href: "https://www.atlassian.com",
                css: [
                    $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$paddingRightStyles,
                    $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$logoLinkStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $fefa5e0a15da0ac0$export$765cacec8b0843f3), {
                    appearance: "neutral",
                    size: "small"
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("ul", {
                    css: $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listStyles,
                    "aria-label": "footer navigation",
                    children: [
                        onOpenReportProblemModal && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                            css: [
                                $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listItemStyles,
                                $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                role: "button",
                                tabIndex: 0,
                                css: [
                                    $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listItemLinkStyles,
                                    (0, $74Zh5.css)({
                                        cursor: "pointer"
                                    })
                                ],
                                onClick: onOpenReportProblemModal,
                                onKeyDown: onKeyDownReport,
                                children: "Report problem"
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                            css: [
                                $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listItemStyles,
                                $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                css: $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listItemLinkStyles,
                                href: "https://www.atlassian.com/legal/privacy-policy",
                                children: "Privacy Policy"
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                            css: [
                                $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listItemStyles,
                                $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                css: $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listItemLinkStyles,
                                href: "https://community.atlassian.com/t5/user/termsofservicepage",
                                children: "Terms of Use"
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                            css: [
                                $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listItemStyles,
                                $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                css: $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listItemLinkStyles,
                                href: "https://www.atlassian.com/security",
                                children: "Security"
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("li", {
                            css: $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listItemStyles,
                            children: [
                                "\xa9 ",
                                new Date().getUTCFullYear(),
                                " Atlassian"
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$footerContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center",
    maxWidth: "1440px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    zIndex: 4,
    padding: "48px 104px",
    boxSizing: "border-box",
    margin: "0 auto",
    width: "100%",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        padding: "48px 60px"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        padding: "72px 32px",
        flexDirection: "column",
        alignItems: "flex-start"
    }
});
const $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listStyles = (0, $74Zh5.css)({
    display: "flex",
    paddingLeft: 0,
    margin: 0,
    flexDirection: "row",
    justifyContent: "flex-end",
    listStyle: "none",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        flexDirection: "column"
    }
});
const $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listItemStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    marginTop: 0,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        paddingTop: "24px"
    }
});
const $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$paddingRightStyles = (0, $74Zh5.css)({
    paddingRight: "24px"
});
const $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$logoLinkStyles = (0, $74Zh5.css)({
    lineHeight: "24px"
});
const $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listItemLinkStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
    textDecoration: "none",
    "&:hover": {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
        textDecoration: "none"
    }
});
var $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fa53e9c0a1746730$exports, "LabelledGraphic", ()=>$24c02ea0e14dbe4f$export$12b5e3eab33f219b);
const $24c02ea0e14dbe4f$export$12b5e3eab33f219b = ({ image: image, markers: markers, onClickMarker: onClickMarker, onClickNext: onClickNext, onClickPrevious: onClickPrevious, onClickDismiss: onClickDismiss, pulseAnimationColor: pulseAnimationColor = (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input") })=>{
    const [activeId, setActiveId] = (0, $5FkrB.useState)(null);
    const [popoverPosX, setPopoverPosX] = (0, $5FkrB.useState)(null);
    const [popoverPosY, setPopoverPosY] = (0, $5FkrB.useState)(null);
    const [clickedMarkers, setClickedMarkers] = (0, $5FkrB.useState)([]);
    const containerDivRef = (0, $5FkrB.useRef)(null);
    const popupRef = (0, $5FkrB.useRef)(null);
    const imageContainerRef = (0, $5FkrB.useRef)(null);
    const maxPopupHeight = 540;
    const maxPopupWidth = 340;
    const defaultDesktopWidth = 1040;
    const normalizedPulseColor = pulseAnimationColor.replace(/\s/g, "").toUpperCase();
    const isWhitePulseVariant = normalizedPulseColor === "#FFFFFF" || normalizedPulseColor === "#FFF" || normalizedPulseColor.includes("#FFFFFF") || normalizedPulseColor === "VAR(--DS-BORDER-INVERSE)";
    const markerStrokeColor = isWhitePulseVariant ? "#FFFFFF" : "#BF63F3";
    const iconNumbers = [
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "zero"
    ];
    const handleNextStep = (idx)=>{
        if (onClickNext) onClickNext();
        setClickedMarkers((prevState)=>[
                ...prevState,
                idx + 1
            ]);
        setActiveId((prevId)=>{
            return prevId !== null ? prevId + 1 : null;
        });
    };
    const handlePreviousStep = (idx)=>{
        if (onClickPrevious) onClickPrevious();
        setClickedMarkers((prevState)=>[
                ...prevState,
                idx - 1
            ]);
        setActiveId((prevId)=>{
            return prevId !== null ? prevId - 1 : null;
        });
    };
    const handleDismiss = (0, $5FkrB.useCallback)(()=>{
        if (onClickDismiss) onClickDismiss();
        setActiveId(null);
    }, [
        onClickDismiss
    ]);
    const handleClickMarker = (0, $5FkrB.useCallback)((idx)=>{
        if (onClickMarker) onClickMarker(idx + 1);
        setClickedMarkers((prevState)=>[
                ...prevState,
                idx
            ]);
        setActiveId(idx);
    }, [
        onClickMarker
    ]);
    (0, $5FkrB.useEffect)(()=>{
        if (containerDivRef.current && activeId != null) {
            const parentWidth = containerDivRef.current.clientWidth;
            const parentHeight = containerDivRef.current.clientHeight;
            const popoverHeight = popupRef?.current?.clientHeight ?? 0;
            let posX = parentWidth * markers[activeId].posX / 100;
            let posY = parentHeight * markers[activeId].posY / 100;
            switch(markers[activeId].arrowPosition){
                case $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9.LEFT_START:
                    posX = posX + 70;
                    posY = posY - 15;
                    break;
                case $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9.LEFT_CENTER:
                    posX = posX + 70;
                    posY = posY - Math.ceil(popoverHeight / 2.5) - 15;
                    break;
                case $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9.LEFT_END:
                    posX = posX + 70;
                    posY = posY - popoverHeight + 70;
                    break;
                case $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9.TOP_START:
                    posX = posX - 24;
                    posY = posY + 70;
                    break;
                case $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9.TOP_CENTER:
                    posX = posX - Math.ceil(maxPopupWidth / 2) + 27;
                    posY = posY + 70;
                    break;
                case $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9.TOP_END:
                    posX = posX - maxPopupWidth + 60;
                    posY = posY + 70;
                    break;
                case $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9.RIGHT_START:
                    posX = posX - maxPopupWidth - 24;
                    posY = posY - 13;
                    break;
                case $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9.RIGHT_CENTER:
                    posX = posX - maxPopupWidth - 24;
                    posY = posY - Math.ceil(popoverHeight / 2) + 32;
                    break;
                case $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9.RIGHT_END:
                    posX = posX - maxPopupWidth - 24;
                    posY = posY - popoverHeight + 70;
                    break;
                case $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9.BOTTOM_START:
                    posX = posX - 25;
                    posY = posY - popoverHeight - 20;
                    break;
                case $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9.BOTTOM_CENTER:
                    posX = posX - Math.ceil(maxPopupWidth / 2) + 25;
                    posY = posY - popoverHeight - 20;
                    break;
                case $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9.BOTTOM_END:
                    posX = posX - maxPopupWidth + 70;
                    posY = posY - popoverHeight - 18;
                    break;
                default:
                    break;
            }
            setPopoverPosX(posX / parentWidth * 100);
            setPopoverPosY(posY / parentHeight * 100);
            // Focus the popup when it is opened
            popupRef.current?.focus();
        }
    }, [
        activeId,
        markers,
        imageContainerRef.current?.clientHeight
    ]);
    const handleKeyDown = (0, $5FkrB.useCallback)((event)=>{
        if (event.code === "Space") {
            event.preventDefault();
            handleClickMarker(Number(event.currentTarget.getAttribute("data-marker-index")));
        }
    }, [
        handleClickMarker
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$labelledGraphicContainerStyles,
        ref: containerDivRef,
        children: [
            markers?.map((marker, idx)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    role: "button",
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    "data-testid": "graphic-marker",
                    css: [
                        $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$markerPulseStyles,
                        clickedMarkers.includes(idx) && "none",
                        !clickedMarkers.includes(idx) && isWhitePulseVariant && (0, $74Zh5.css)({
                            animation: `${$24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$pulseWhiteAnimationStyles} 1200ms linear infinite`
                        }),
                        !clickedMarkers.includes(idx) && !isWhitePulseVariant && (0, $74Zh5.css)({
                            animation: `${$24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$pulsePurpleAnimationStyles} 1200ms linear infinite`
                        })
                    ],
                    style: {
                        left: marker.posX + "%",
                        top: marker.posY + "%"
                    },
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        role: "button",
                        tabIndex: 0,
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            handleClickMarker(idx);
                        },
                        onKeyDown: (e)=>{
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                e.stopPropagation();
                                handleClickMarker(idx);
                            }
                        },
                        draggable: true,
                        css: [
                            $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$graphicMarkerContainerStyles["base"],
                            activeId === idx && $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$graphicMarkerContainerStyles["selected"],
                            (0, $74Zh5.css)({
                                border: `2px solid ${markerStrokeColor}`
                            })
                        ],
                        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                            children: [
                                marker.icon && iconNumbers.includes(marker.icon) && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                    css: [
                                        activeId === idx && (0, $74Zh5.css)({
                                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse")
                                        }),
                                        activeId !== idx && (0, $74Zh5.css)({
                                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
                                        })
                                    ],
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                        type: marker.icon
                                    })
                                }),
                                marker.icon && !iconNumbers.includes(marker.icon) && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                    css: (0, $74Zh5.css)({
                                        display: "flex",
                                        alignItems: "center"
                                    }),
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                        size: "small",
                                        color: `${activeId === idx ? (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.inverse") : (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.warning.inverse")}`,
                                        type: marker.icon
                                    })
                                })
                            ]
                        })
                    })
                }, `marker-${idx}`)),
            activeId != null && imageContainerRef.current && containerDivRef.current && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$129a32eedafa97c5, {
                popupHeight: imageContainerRef.current.clientHeight > 540 ? 540 : imageContainerRef.current.clientHeight,
                title: markers[activeId].title,
                totalSteps: markers.length,
                step: activeId + 1,
                popupStyle: {
                    position: "absolute",
                    left: popoverPosX + "%",
                    top: popoverPosY + "%",
                    maxHeight: `${maxPopupHeight}px`,
                    maxWidth: `${maxPopupWidth}px`,
                    minHeight: "fit-content"
                },
                arrowPosition: markers[activeId].arrowPosition,
                onNext: ()=>handleNextStep(activeId),
                onPrevious: ()=>handlePreviousStep(activeId),
                onClose: handleDismiss,
                ref: popupRef,
                children: markers[activeId].children
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                ref: imageContainerRef,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3e431a229df88919, {
                    ...image,
                    css: [
                        $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$imageStyles,
                        (0, $74Zh5.css)({
                            maxWidth: `${defaultDesktopWidth}px`
                        })
                    ],
                    preventModal: true
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$labelledGraphicContainerStyles = (0, $74Zh5.css)({
    position: "relative",
    cursor: "default"
});
const $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$createPulseAnimationStyles = (pulseColor)=>(0, $74Zh5.keyframes)({
        "0%": {
            boxShadow: `0 0 0 2px ${pulseColor}, 0 0 0 2px ${pulseColor}`
        },
        "35%": {
            boxShadow: `0 0 0 2px ${pulseColor}, 0 0 0 8px ${pulseColor}99`
        },
        "65%": {
            boxShadow: `0 0 0 2px ${pulseColor}, 0 0 0 14px ${pulseColor}00`
        },
        "100%": {
            boxShadow: `0 0 0 2px ${pulseColor}, 0 0 0 14px ${pulseColor}00`
        }
    });
const $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$pulseWhiteAnimationStyles = $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$createPulseAnimationStyles("#FFFFFF");
const $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$pulsePurpleAnimationStyles = $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$createPulseAnimationStyles("#BF63F3");
const $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$markerPulseStyles = (0, $74Zh5.css)({
    height: "46px",
    width: "46px",
    padding: "6px 12px",
    backgroundColor: "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    borderRadius: "50%",
    zIndex: 2,
    cursor: "pointer"
});
const $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$graphicMarkerContainerStyles = {
    base: (0, $74Zh5.css)({
        height: "40px",
        width: "40px",
        padding: "6px 12px",
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        backgroundColor: "#FFBA00",
        fontFamily: "Charlie Display, sans-serif",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "24px",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
        boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
        "&:hover": {
            backgroundColor: "#FCA700"
        },
        "&:active": {
            backgroundColor: "#FDCC09"
        }
    }),
    selected: (0, $74Zh5.css)({
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
        "&:hover": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
        },
        "&:active": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
        }
    })
};
const $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$imageStyles = (0, $74Zh5.css)({
    height: "auto",
    width: "100%"
});
var $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$9225344cd5d1f99b$exports, "LessonHeader", ()=>$24c02ea0e14dbe4f$export$7bee7638d150bc04);
const $24c02ea0e14dbe4f$export$7bee7638d150bc04 = ({ heading: heading, tags: tags, description: description, urlToShare: urlToShare, onListenClick: onListenClick, showListenButton: showListenButton = true })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$headingWrapperStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                    level: 1,
                    children: heading
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$metadataStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$flexContainerStyles,
                        children: tags.map((tag, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$tagStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                                    ...tag
                                })
                            }, index))
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$flexContainerStyles,
                        children: [
                            showListenButton && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                                css: $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$listenButtonStyles,
                                onClick: ()=>onListenClick && onListenClick(),
                                "data-testid": "listen-button",
                                children: [
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M8.5 17.3333V13.5C8.5 12.9477 8.05228 12.5 7.5 12.5C6.94772 12.5 6.5 12.9477 6.5 13.5V15.6667C6.5 16.6792 7.32081 17.5 8.33333 17.5C8.42538 17.5 8.5 17.4254 8.5 17.3333ZM7.5 11C6.11929 11 5 12.1193 5 13.5V15.6667C5 17.5076 6.49238 19 8.33333 19C9.25381 19 10 18.2538 10 17.3333V13.5C10 12.1193 8.88071 11 7.5 11Z",
                                                fill: "#44546F"
                                            }),
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M15.5 17.3333V13.5C15.5 12.9477 15.9477 12.5 16.5 12.5C17.0523 12.5 17.5 12.9477 17.5 13.5V15.6667C17.5 16.6792 16.6792 17.5 15.6667 17.5C15.5746 17.5 15.5 17.4254 15.5 17.3333ZM16.5 11C17.8807 11 19 12.1193 19 13.5V15.6667C19 17.5076 17.5076 19 15.6667 19C14.7462 19 14 18.2538 14 17.3333V13.5C14 12.1193 15.1193 11 16.5 11Z",
                                                fill: "#44546F"
                                            }),
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M12 5.5C8.96243 5.5 6.5 7.96243 6.5 11V14.25H5V11C5 7.13401 8.13401 4 12 4C15.866 4 19 7.13401 19 11V14.25H17.5V11C17.5 7.96243 15.0376 5.5 12 5.5Z",
                                                fill: "#44546F"
                                            })
                                        ]
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                        css: $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$listenTextWrapperStyles,
                                        children: "Listen"
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$477c64ffaba52edf, {
                                urlToShare: urlToShare,
                                alignToLeft: true
                            })
                        ]
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$lineWrapperStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2e0a83ec2e27ecbb, {
                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$descriptionStyles,
                children: description
            })
        ]
    });
const $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$metadataStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$flexContainerStyles = (0, $74Zh5.css)({
    display: "flex"
});
const $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$listenButtonStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    marginRight: "1.5rem",
    cursor: "pointer",
    padding: 0,
    border: "none",
    background: "transparent"
});
const $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$listenTextWrapperStyles = (0, $74Zh5.css)({
    marginLeft: "0.25rem",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle"),
    fontSize: "16px",
    fontFamily: "Charlie Text, sans-serif"
});
const $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$tagStyles = (0, $74Zh5.css)({
    marginRight: "0.5rem"
});
const $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$lineWrapperStyles = (0, $74Zh5.css)({
    padding: "1.5rem 0 2.5rem 0"
});
const $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$headingWrapperStyles = (0, $74Zh5.css)({
    padding: "5rem 0 1.5rem 0"
});
const $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$descriptionStyles = (0, $74Zh5.css)({
    paddingBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.1000"),
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    lineHeight: "32px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    p: {
        margin: 0
    },
    a: {
        fontSize: "20px",
        lineHeight: "32px"
    },
    ul: {
        paddingLeft: "20px",
        marginTop: 0,
        marginBottom: 0,
        li: {
            marginTop: "16px"
        },
        "li + li": {
            marginTop: "16px !important"
        }
    }
});
var $24c02ea0e14dbe4f$var$$3b9afd8fe4435353$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3b9afd8fe4435353$exports, "LessonList", ()=>$24c02ea0e14dbe4f$export$962a95c44e73eb25);
const $24c02ea0e14dbe4f$var$$057799a99c9f255f$export$b7cafc9b9fbb48b2 = ({ isCompleted: isCompleted, size: size })=>isCompleted ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
        type: "check-circle-filled",
        size: size,
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.success")
    }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
        type: "check-circle-outline",
        size: size,
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtler.pressed")
    });
const $24c02ea0e14dbe4f$var$$7e5a668c3a5a9ea8$export$2c301aad86da9f9a = ({ sectionTitle: sectionTitle, slug: slug, lessonSlug: lessonSlug, isCompleted: isCompleted, onNavigation: onNavigation })=>{
    const handleKeyDown = (0, $5FkrB.useCallback)((event, onNavigation, slug, lessonSlug)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onNavigation({
                sectionSlug: slug,
                lessonSlug: lessonSlug
            });
        }
    }, []);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$7e5a668c3a5a9ea8$var$sectionStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$057799a99c9f255f$export$b7cafc9b9fbb48b2, {
                isCompleted: isCompleted,
                size: $24c02ea0e14dbe4f$export$ff775019b5b6e7df.SMALL
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$7e5a668c3a5a9ea8$var$sectionLinkStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    role: "link",
                    tabIndex: 0,
                    onKeyDown: (event)=>handleKeyDown(event, onNavigation, slug, lessonSlug),
                    onClick: ()=>onNavigation({
                            sectionSlug: slug,
                            lessonSlug: lessonSlug
                        }),
                    children: sectionTitle
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$7e5a668c3a5a9ea8$var$sectionStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    marginBottom: "0.75rem"
});
const $24c02ea0e14dbe4f$var$$7e5a668c3a5a9ea8$var$sectionLinkStyles = (0, $74Zh5.css)({
    marginLeft: "11px",
    span: {
        fontFamily: "Inter, sans-serif",
        fontSize: "14px",
        lineHeight: "1.5rem",
        fontWeight: 400,
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
    },
    ":hover": {
        span: {
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected"),
            textDecoration: "none"
        }
    }
});
const $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$export$e4e5e6361d1b89e2 = ({ lessonTitle: lessonTitle, slug: slug, duration: duration, isCompleted: isCompleted, isCurrentLesson: isCurrentLesson, hasDivider: hasDivider, sections: sections, onNavigation: onNavigation })=>{
    const [isExpanded, setIsExpanded] = (0, $5FkrB.useState)(isCurrentLesson);
    const expandByCard = (event)=>{
        if (event.target === event.currentTarget) setIsExpanded(!isExpanded);
    };
    const expandByButton = ()=>{
        setIsExpanded(!isExpanded);
    };
    (0, $5FkrB.useEffect)(()=>{
        setIsExpanded(isCurrentLesson);
    }, [
        isCurrentLesson
    ]);
    const handleKeyDown = (0, $5FkrB.useCallback)((event, onNavigation, slug)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onNavigation({
                lessonSlug: slug
            });
        }
    }, []);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("section", {
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- Section needs tabIndex for keyboard navigation
        tabIndex: 0,
        "aria-label": `Lesson overview for ${lessonTitle}`,
        css: [
            $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$lessonCardContainerStyles,
            !hasDivider && (0, $74Zh5.css)({
                marginBottom: "16px"
            })
        ],
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                role: "button",
                tabIndex: 0,
                css: [
                    $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$lessonCardStyles,
                    isCurrentLesson && $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$currentLessonStyles,
                    !isCurrentLesson && $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$hoverLessonStyles
                ],
                onClick: expandByCard,
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        expandByCard(e);
                    }
                },
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                        tabIndex: 0,
                        "aria-label": "expand lesson button",
                        css: [
                            $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$expandButtonStyles,
                            !isCurrentLesson && (0, $74Zh5.css)({
                                borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")
                            })
                        ],
                        "data-testid": "expand-button",
                        onClick: expandByButton,
                        children: isExpanded ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: "chevron-down",
                            size: $24c02ea0e14dbe4f$export$ff775019b5b6e7df.MEDIUM,
                            color: isCurrentLesson ? (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.selected") : (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.subtle")
                        }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: "chevron-right",
                            size: $24c02ea0e14dbe4f$export$ff775019b5b6e7df.MEDIUM,
                            color: isCurrentLesson ? (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.selected") : (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.subtle")
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$mainContentColumnStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                css: [
                                    $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$durationStyles,
                                    !isCurrentLesson && (0, $74Zh5.css)({
                                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest")
                                    })
                                ],
                                children: duration.toUpperCase()
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$lessonContainer,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        css: $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$lessonTitleStyles,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                            role: "button",
                                            tabIndex: 0,
                                            onKeyDown: (event)=>handleKeyDown(event, onNavigation, slug),
                                            onClick: ()=>onNavigation({
                                                    lessonSlug: slug
                                                }),
                                            children: lessonTitle
                                        })
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        css: (0, $74Zh5.css)({
                                            marginLeft: "1.5rem",
                                            display: "flex"
                                        }),
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$057799a99c9f255f$export$b7cafc9b9fbb48b2, {
                                            isCompleted: isCompleted,
                                            size: $24c02ea0e14dbe4f$export$ff775019b5b6e7df.MEDIUM
                                        })
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: (0, $74Zh5.css)({
                                    marginTop: "0.75rem"
                                }),
                                children: isExpanded && sections.map((section)=>(0, $5FkrB.createElement)($24c02ea0e14dbe4f$var$$7e5a668c3a5a9ea8$export$2c301aad86da9f9a, {
                                        ...section,
                                        lessonSlug: slug,
                                        onNavigation: onNavigation,
                                        key: `section-${section.slug}`
                                    }))
                            })
                        ]
                    })
                ]
            }),
            hasDivider && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: (0, $74Zh5.css)({
                    marginTop: "16px",
                    marginBottom: "16px"
                }),
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2e0a83ec2e27ecbb, {
                    height: 2,
                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")
                })
            })
        ]
    }, slug);
};
const $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$lessonCardContainerStyles = (0, $74Zh5.css)({
    maxWidth: "25.25rem",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        maxWidth: "100%",
        paddingRight: "16px"
    }
});
const $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$lessonCardStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    padding: "16px",
    borderRadius: "0.25rem",
    cursor: "pointer"
});
const $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$currentLessonStyles = (0, $74Zh5.css)({
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected"),
    borderLeft: `4px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand")}`
});
const $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$hoverLessonStyles = (0, $74Zh5.css)({
    ":hover": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
    },
    ":hover button": {
        borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.pressed")
    }
});
const $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$mainContentColumnStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    marginLeft: "0.75rem"
});
const $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$expandButtonStyles = (0, $74Zh5.css)({
    width: "1.5rem",
    height: "1.5rem",
    padding: 0,
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.blue.subtlest.pressed")}`,
    borderRadius: "0.25rem",
    boxSizing: "content-box",
    background: "transparent",
    outline: "none",
    cursor: "pointer",
    ":focus-visible": {
        border: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$durationStyles = (0, $74Zh5.css)({
    width: "100%",
    fontSize: "0.75rem",
    fontWeight: 400,
    lineHeight: "1.125rem",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected"),
    marginTop: 0,
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.075")
});
const $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$lessonContainer = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center"
});
const $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$lessonTitleStyles = (0, $74Zh5.css)({
    width: "100%",
    fontFamily: "Charlie Display",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "1.5rem",
    span: {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
    },
    ":hover": {
        span: {
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected"),
            textDecoration: "none"
        }
    }
});
const $24c02ea0e14dbe4f$export$962a95c44e73eb25 = ({ lessons: lessons })=>{
    const currentLessonIndx = lessons.findIndex((lesson)=>lesson.isCurrentLesson);
    const updatedLessons = lessons.map((lesson, indx)=>({
            ...lesson,
            hasDivider: !(indx === currentLessonIndx || indx === currentLessonIndx - 1)
        }));
    return updatedLessons.map((lesson)=>(0, $5FkrB.createElement)($24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$export$e4e5e6361d1b89e2, {
            ...lesson,
            key: `lesson-${lesson.slug}`
        }));
};
var $24c02ea0e14dbe4f$var$$050a30fc95775cfd$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$050a30fc95775cfd$exports, "LessonsList", ()=>$24c02ea0e14dbe4f$export$c3b0ae23c563b692);
const $24c02ea0e14dbe4f$export$c3b0ae23c563b692 = ({ lessons: lessons, onLessonClick: onLessonClick, isStandalone: isStandalone = false, isTablet: isTablet = false })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$lessonsListStyles,
            isStandalone && $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$lessonsListStandaloneStyles,
            isTablet && !isStandalone && (0, $74Zh5.css)({
                borderRadius: "0"
            })
        ],
        children: lessons?.map(({ slug: slug, isCompleted: isCompleted, title: title, duration: duration }, index)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                role: "button",
                "data-testid": `lesson-list-item-${index}`,
                tabIndex: 0,
                css: [
                    $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$lessonItemStyles,
                    !isStandalone && !isTablet && index === lessons.length - 1 && $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$lastLessonItemStyles,
                    isTablet && !isStandalone && index === 0 && $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$firstLessonItemTabletStyles,
                    isTablet && !isStandalone && index === lessons.length - 1 && $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$lastLessonItemTabletStyles
                ],
                onClick: ()=>onLessonClick(slug),
                onKeyDown: (event)=>{
                    if (event.key === "Enter") onLessonClick(slug);
                },
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$circleContainerStyles,
                        children: isCompleted ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            size: "small",
                            type: "check-circle",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.success")
                        }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$emptyCircleStyles
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                        css: [
                            $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$textStyles,
                            isCompleted && {
                                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.success")
                            }
                        ],
                        children: title
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$durationBadgeStyles,
                        children: duration
                    }),
                    isStandalone && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$chevronContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            size: "medium",
                            type: "chevron-right",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
                        })
                    })
                ]
            }, slug))
    });
};
const $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$lessonsListStyles = (0, $74Zh5.css)({
    backgroundColor: "#FFFFFF",
    maxWidth: "100%",
    borderRadius: "0 0 8px 8px",
    overflow: "hidden"
});
const $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$lessonsListStandaloneStyles = (0, $74Zh5.css)({
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "8px"
});
const $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$lessonItemStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")}`,
    cursor: "pointer",
    "&:hover": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
    },
    "&:active": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")
    },
    ":first-of-type": {
        borderTop: "none"
    }
});
const $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$circleContainerStyles = (0, $74Zh5.css)({
    marginTop: "3px"
});
const $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$emptyCircleStyles = (0, $74Zh5.css)({
    width: "14px",
    height: "14px",
    borderRadius: "50%",
    border: `1.4px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.075"),
    margin: "1px",
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.025")
});
const $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$textStyles = (0, $74Zh5.css)({
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
    fontFamily: "Inter",
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.025")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")}`,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
});
const $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$durationBadgeStyles = (0, $74Zh5.css)({
    marginTop: "1px",
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.025")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.075")}`,
    borderRadius: "8px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.disabled"),
    textTransform: "uppercase",
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "18px",
    marginLeft: "auto",
    whiteSpace: "nowrap",
    height: "fit-content"
});
const $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$lastLessonItemStyles = (0, $74Zh5.css)({
    borderRadius: "0 0 8px 8px"
});
const $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$firstLessonItemTabletStyles = (0, $74Zh5.css)({
    borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")} !important`
});
const $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$lastLessonItemTabletStyles = (0, $74Zh5.css)({
    borderRadius: "0 !important"
});
const $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$chevronContainerStyles = (0, $74Zh5.css)({
    display: "none",
    "@media (max-width: 965px)": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "24px",
        marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
        marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.negative.100")
    }
});
var $24c02ea0e14dbe4f$var$$65703ff0bcd12648$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$65703ff0bcd12648$exports, "LessonSidebar", ()=>$24c02ea0e14dbe4f$export$c2bf8d11366d1eb0);
const $24c02ea0e14dbe4f$var$$bae5a7f2c1ae6bce$export$7ded8628b71ba75 = ({ progress: progress, pathColor: pathColor, trailColor: trailColor = (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border"), image: image, title: title, onCourseNavigation: onCourseNavigation })=>{
    const handleClick = (0, $5FkrB.useCallback)(()=>{
        onCourseNavigation && onCourseNavigation();
    }, [
        onCourseNavigation
    ]);
    const handleKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleClick);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$bae5a7f2c1ae6bce$var$progressBadgeContainerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: (0, $74Zh5.css)({
                    maxWidth: "64px",
                    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
                        maxWidth: "85px"
                    }
                }),
                "data-testid": "progress-circle",
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f188eff9b59fb855$export$5ab97151efedb8c6), {
                    strokeWidth: 4,
                    value: progress,
                    styles: (0, $f188eff9b59fb855$export$5115a192ad9bf57f)({
                        pathColor: pathColor,
                        trailColor: trailColor
                    }),
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$bae5a7f2c1ae6bce$var$imageBadgeContainerStyles,
                        children: image ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                            css: $24c02ea0e14dbe4f$var$$bae5a7f2c1ae6bce$var$imageStyles,
                            "data-testid": "badge-image",
                            src: image.src,
                            alt: image.alt
                        }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: [
                                (0, $74Zh5.css)({
                                    backgroundColor: trailColor
                                }),
                                $24c02ea0e14dbe4f$var$$bae5a7f2c1ae6bce$var$innerCircleBackgroundStyles
                            ]
                        })
                    })
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    role: "button",
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    css: $24c02ea0e14dbe4f$var$$bae5a7f2c1ae6bce$var$titleStyles,
                    onClick: onCourseNavigation,
                    children: title
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$bae5a7f2c1ae6bce$var$progressBadgeContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: "16px"
});
const $24c02ea0e14dbe4f$var$$bae5a7f2c1ae6bce$var$imageBadgeContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    padding: "8px"
});
const $24c02ea0e14dbe4f$var$$bae5a7f2c1ae6bce$var$imageStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "50%"
});
const $24c02ea0e14dbe4f$var$$bae5a7f2c1ae6bce$var$innerCircleBackgroundStyles = (0, $74Zh5.css)({
    borderRadius: "9999px",
    width: "100%",
    height: "100%"
});
const $24c02ea0e14dbe4f$var$$bae5a7f2c1ae6bce$var$titleStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "28px",
    fontFamily: "Charlie Display, sans-serif",
    paddingRight: "16px",
    margin: 0,
    "&:hover": {
        cursor: "pointer",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")
    }
});
const $24c02ea0e14dbe4f$export$c2bf8d11366d1eb0 = ({ lessons: lessons, progress: progress, pathColor: pathColor, title: title, image: image, isVisible: isVisible, onChangeMenuVisibility: onChangeMenuVisibility, onCourseNavigation: onCourseNavigation })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)($24c02ea0e14dbe4f$export$1ba59dacbcbf90fe, {
        isVisible: isVisible,
        onChangeMenuVisibility: onChangeMenuVisibility,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: (0, $74Zh5.css)({
                    marginLeft: "16px"
                }),
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: (0, $74Zh5.css)({
                            marginBottom: "16px",
                            lineHeight: "24px"
                        }),
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: [
                                $24c02ea0e14dbe4f$var$$65703ff0bcd12648$var$subheadingStyles,
                                (0, $74Zh5.css)({
                                    marginBottom: "24px",
                                    marginTop: "24px"
                                })
                            ],
                            children: "Current course"
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$bae5a7f2c1ae6bce$export$7ded8628b71ba75, {
                        progress: progress,
                        pathColor: pathColor,
                        title: title,
                        image: image,
                        onCourseNavigation: onCourseNavigation
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: (0, $74Zh5.css)({
                            marginBottom: "24px",
                            marginTop: "24px",
                            lineHeight: "24px"
                        }),
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $24c02ea0e14dbe4f$var$$65703ff0bcd12648$var$subheadingStyles,
                            children: "Lessons in this course"
                        })
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$962a95c44e73eb25, {
                lessons: lessons
            })
        ]
    });
const $24c02ea0e14dbe4f$var$$65703ff0bcd12648$var$subheadingStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Text, sens-serif",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px",
    textTransform: "uppercase",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
});
var $24c02ea0e14dbe4f$var$$8340d81aba797956$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$8340d81aba797956$exports, "LearningOverviewCard", ()=>$24c02ea0e14dbe4f$export$60e8035fadc9b8fc);
var $24c02ea0e14dbe4f$var$$8f97e278a4a2a6b3$require$Buffer = (0, $7KfP5.Buffer);
const $24c02ea0e14dbe4f$var$$8f97e278a4a2a6b3$var$svgStringLearningOverviewCardBackground = `<svg width="1003" height="48" viewBox="0 0 1003 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3622_1083)">
      <g clip-path="url(#clip1_3622_1083)">
        <path
          d="M929.87 -106.601C934.923 -113.047 932.654 -115.022 927.128 -108.989C923.208 -104.711 919.232 -100.29 914.973 -95.4457C910.706 -90.547 906.173 -84.8713 902.441 -77.642C901.929 -76.6053 901.438 -75.6223 900.973 -74.6736C900.581 -73.6929 900.196 -72.7546 899.839 -71.8631C899.493 -70.958 899.113 -70.1306 898.849 -69.2729C898.586 -68.4274 898.343 -67.6109 898.101 -66.8314C897.872 -66.0506 897.619 -65.3092 897.435 -64.5795C897.275 -63.835 897.116 -63.1274 896.97 -62.4309C896.673 -61.0446 896.374 -59.7637 896.241 -58.4844C896.079 -57.2144 895.893 -55.9961 895.769 -54.7717C895.695 -53.5422 895.62 -52.3126 895.538 -51.053C895.481 -50.4216 895.48 -49.7785 895.49 -49.1218C895.494 -48.4596 895.492 -47.7918 895.495 -47.0926C895.45 -45.6992 895.57 -44.2212 895.672 -42.6212C895.734 -40.8087 896.046 -38.9029 896.305 -36.9035C896.407 -35.8974 896.663 -34.8941 896.85 -33.8669C897.074 -32.836 897.222 -31.7755 897.514 -30.7316C897.793 -29.6765 898.071 -28.6091 898.36 -27.5159C898.619 -26.4196 899.039 -25.3563 899.372 -24.2525C899.729 -23.1586 900.067 -22.0357 900.524 -20.944C901.095 -19.4758 901.672 -18.0008 902.248 -16.5135C903.686 -16.151 905.125 -15.7886 906.563 -15.4261L908.148 -15.024L909.749 -14.7069C910.816 -14.4996 911.884 -14.2923 912.945 -14.0795C914.015 -13.9338 915.072 -13.7893 916.13 -13.6449C916.659 -13.5788 917.181 -13.4949 917.698 -13.4424C918.222 -13.4077 918.74 -13.3676 919.258 -13.3274C920.294 -13.2594 921.317 -13.1803 922.328 -13.1147C923.342 -13.1108 924.331 -13.1094 925.302 -13.1037C925.79 -13.0974 926.272 -13.098 926.748 -13.093C927.225 -13.1003 927.69 -13.1458 928.161 -13.1722C930.021 -13.305 931.798 -13.3659 933.424 -13.6525C935.06 -13.8885 936.594 -14.073 937.944 -14.4185C939.298 -14.7325 940.538 -14.9593 941.583 -15.2676C942.622 -15.5827 943.499 -15.8526 944.2 -16.0659C944.814 -16.2634 945.445 -16.4282 946.042 -16.6706L947.817 -17.4307C948.868 -17.8993 950.401 -18.4983 952.174 -19.5183C953.072 -20.0086 954.081 -20.5123 955.126 -21.1299C956.149 -21.7869 957.247 -22.4858 958.427 -23.2319C963.03 -26.3399 968.353 -30.7603 973.46 -36.3963C976.055 -39.2319 978.501 -42.2247 981.093 -45.2956C983.684 -48.3664 986.348 -51.5351 989.05 -54.737C994.763 -61.4435 1000.62 -68.3333 1006.26 -74.9487L1008.09 -77.1133L970.879 -109.453C966.364 -113.375 962.194 -116.953 958.273 -120.283C953.7 -124.143 949.449 -127.723 945.42 -131.125C944.678 -130.223 943.943 -129.327 943.214 -128.436C942.856 -127.996 942.499 -127.568 942.141 -127.128C941.939 -126.87 941.731 -126.619 941.535 -126.367C940.74 -125.372 939.959 -124.387 939.189 -123.414C937.664 -121.465 936.17 -119.557 934.69 -117.66C932.576 -114.943 931.934 -113.128 932.4 -112.592L932.334 -112.332C932.406 -112.276 932.468 -112.282 932.515 -112.357L932.544 -112.466C933.134 -112.084 934.804 -113.003 937.144 -115.524C938.768 -117.296 940.405 -119.078 942.08 -120.893C942.908 -121.811 943.75 -122.74 944.611 -123.686C944.824 -123.918 945.032 -124.157 945.245 -124.389L945.523 -124.676C945.697 -124.85 945.871 -125.036 946.051 -125.216C946.212 -125.057 946.378 -124.892 946.551 -124.732L946.789 -124.498C946.872 -124.415 946.884 -124.389 947.164 -124.144C948.023 -123.364 948.906 -122.57 949.794 -121.768C951.584 -120.164 953.428 -118.511 955.343 -116.801C959.18 -113.387 963.311 -109.751 967.813 -105.818C970.585 -103.409 974.75 -99.5537 980.247 -94.53C983.002 -92.0237 986.097 -89.2169 989.489 -86.1324C991.196 -84.5985 992.985 -82.9942 994.853 -81.3264C996.512 -79.8591 998.231 -78.3239 1000.02 -76.7443C1000.02 -76.7443 1000.02 -76.7443 1000.03 -76.7375C1000.03 -76.7375 1000.03 -76.7375 1000.03 -76.7307L999.428 -75.9942C998.608 -74.9765 997.794 -73.9643 996.986 -72.9576C992.58 -67.3803 987.764 -61.4487 983.029 -55.6945C980.656 -52.8241 978.303 -49.9826 976.04 -47.2557C974.903 -45.8928 973.785 -44.5589 972.7 -43.2526C971.603 -41.9845 970.523 -40.8015 969.48 -39.627C968.467 -38.4309 967.35 -37.4185 966.338 -36.4017C965.308 -35.3929 964.34 -34.4148 963.33 -33.6019C962.344 -32.7618 961.416 -31.9716 960.551 -31.2367C959.658 -30.548 958.798 -29.9486 958.034 -29.383C957.263 -28.8364 956.598 -28.2977 955.964 -27.9044C955.336 -27.5166 954.797 -27.1817 954.347 -26.9119C953.472 -26.3698 952.996 -26.0778 952.996 -26.0778C952.138 -25.5031 951.199 -25.0603 950.283 -24.5781C949.361 -24.1149 948.469 -23.5932 947.518 -23.1762C945.607 -22.393 943.74 -21.4938 941.744 -20.9109C937.842 -19.5255 933.722 -18.7251 929.573 -18.2555L926.433 -17.9804L923.272 -17.9363C922.219 -17.8947 921.159 -17.9652 920.098 -18.0234C919.038 -18.1063 917.98 -18.0961 916.922 -18.2406L913.741 -18.6191C912.682 -18.7389 911.629 -18.9819 910.566 -19.1578C909.51 -19.3392 908.455 -19.5329 907.408 -19.8061L905.406 -20.2877L904.553 -22.4154C904.095 -23.4824 903.763 -24.5862 903.387 -25.6759C902.591 -27.8535 902.063 -30.0843 901.455 -32.3048C900.43 -36.7694 899.847 -41.2944 899.708 -45.799C899.617 -54.5172 901.176 -60.7732 902.66 -65.3605C902.844 -65.9356 903.027 -66.4861 903.204 -67.0187C903.288 -67.2822 903.373 -67.5458 903.458 -67.797C903.56 -68.0402 903.663 -68.2833 903.759 -68.521C904.156 -69.4703 904.519 -70.3427 904.855 -71.156C905.02 -71.5599 905.184 -71.9515 905.335 -72.3196C905.517 -72.6785 905.692 -73.0195 905.86 -73.355C906.196 -74.0137 906.505 -74.6256 906.787 -75.1907C907.6 -76.9267 908.616 -78.4937 909.532 -80.0583C910.413 -81.6513 911.478 -83.0586 912.439 -84.4951C912.938 -85.1991 913.381 -85.9272 913.903 -86.5918C914.425 -87.2563 914.927 -87.9166 915.436 -88.5701C916.442 -89.8783 917.421 -91.1521 918.467 -92.4005C922.553 -97.4041 926.266 -102.05 929.852 -106.622L929.87 -106.601Z"
          fill="#ffffff7d"
        />
        <path
          d="M485.107 17.5435C485.157 17.2393 485.206 16.9473 485.261 16.6622C485.278 16.3733 485.284 16.0955 485.3 15.8312C485.322 15.2892 485.33 14.7951 485.324 14.3368C485.343 13.4171 485.158 12.6498 485.022 12.0299C484.719 10.8054 484.323 10.2085 483.928 10.1932C483.526 10.1834 483.114 10.7415 482.773 11.8449C482.59 12.3954 482.499 13.0914 482.264 13.8777C482.161 14.2755 482.069 14.7115 481.982 15.179C481.941 15.4161 481.901 15.6532 481.853 15.9082C481.782 16.1483 481.716 16.3953 481.65 16.6545C480.974 19.6043 479.725 22.3352 477.739 24.515C475.77 26.7027 473.101 28.343 469.989 29.4622C466.875 30.606 463.32 31.2162 459.494 31.4897C458.544 31.5974 457.566 31.6219 456.576 31.6451C455.585 31.6806 454.581 31.7272 453.55 31.6906C452.518 31.6786 451.48 31.6599 450.417 31.6509C449.33 31.6149 448.225 31.5831 447.114 31.5445C442.635 31.4549 438.7 31.3709 437.402 31.3506C437.461 33.0947 437.517 34.758 437.575 36.3721C437.617 37.335 437.653 38.2665 437.691 39.1611C437.768 40.7708 437.837 42.2685 437.903 43.6732C438.049 46.4837 438.178 48.94 438.299 51.2842C438.542 55.9725 438.747 60.2179 438.871 65.9952C438.989 71.3019 439.109 77.3447 439.271 84.7774C442.605 84.9054 446.043 85.0502 449.524 85.1809C452.302 85.302 455.11 85.42 457.906 85.5368C463.561 85.752 469.165 85.7145 474.329 85.3789C479.492 85.0555 484.21 84.4395 488.08 83.7004C491.949 82.9612 494.97 82.1111 496.811 81.5433C498.187 81.1511 499.514 80.6115 500.851 80.0978C502.029 79.5802 503.702 78.8717 505.73 77.7972C506.747 77.2757 507.825 76.6181 509.009 75.928C510.159 75.1726 511.403 74.3834 512.642 73.4081C515.149 71.5039 517.788 69.0935 520.199 66.06C522.609 63.0388 524.767 59.3919 526.368 55.2742C528 51.1658 529.033 46.5883 529.51 41.8369C530 37.0745 529.928 32.156 529.432 27.1513C528.49 17.1591 524.835 6.82357 518.805 -1.52006C514.549 -7.40132 509.649 -11.8944 504.902 -15.2832C503.698 -16.0981 502.525 -16.8914 501.381 -17.6631C500.204 -18.3579 499.057 -19.0433 497.946 -19.7004C496.828 -20.3396 495.706 -20.8803 494.635 -21.4406C494.295 -21.6111 493.962 -21.7871 493.629 -21.9632C493.405 -22.0664 493.158 -22.2337 492.914 -22.3079L492.13 -22.3319C491.5 -22.3463 490.882 -22.3719 490.271 -22.3906C481.737 -22.6506 475.456 -22.8365 471.146 -22.9647C466.13 -23.0903 461.424 -23.2092 457.699 -23.3088L457.377 -18.1211C464.071 -16.6871 469.734 -13.9351 473.851 -9.95455C477.937 -5.97092 480.524 -1.00134 481.726 4.27301C482.155 6.19688 482.534 7.6642 482.859 8.65586C483.208 9.65003 483.595 10.1718 483.947 10.1889C484.305 10.2005 484.622 9.70074 484.85 8.64766C485.091 7.59583 485.137 5.9862 484.816 3.85057C483.934 -1.98513 481.344 -7.93852 476.726 -12.8297C472.089 -17.7166 465.53 -21.0977 458.111 -22.7969L457.845 -18.5252C461.574 -18.3941 466.279 -18.2259 471.299 -18.0566C475.257 -17.9332 481.351 -17.5745 489.372 -17.144C489.878 -17.1174 490.384 -17.0907 490.902 -17.0629L491.679 -17.0211C491.864 -17.0147 491.79 -17.0099 491.827 -17.0061L491.876 -17.0011C491.876 -17.0011 491.906 -16.9672 492.051 -16.8906C492.287 -16.7615 492.523 -16.6324 492.759 -16.5033C493.23 -16.2451 493.715 -15.9857 494.198 -15.7139C495.186 -15.2117 496.131 -14.5776 497.12 -13.97C497.614 -13.6601 498.115 -13.3556 498.622 -13.0444C499.109 -12.7043 499.602 -12.3574 500.095 -12.0104C504.076 -9.24363 508.128 -5.80154 511.761 -1.4742C512.991 -0.0999016 514.024 1.40902 515.133 2.87617L516.629 5.17427C517.149 5.92597 517.586 6.72498 518.024 7.52399C519.044 9.21093 519.835 11.0478 520.681 12.8965C521.038 13.8482 521.389 14.8054 521.745 15.7694C521.936 16.2465 522.095 16.7389 522.224 17.2344L522.652 18.7191C523.758 22.6971 524.486 26.8472 524.689 30.9872C525.268 39.2601 524.188 47.3027 521.595 53.596C520.323 56.7513 518.723 59.4651 517.055 61.7143C515.399 63.977 513.604 65.6937 512.1 67.0998C511.301 67.7547 510.62 68.3784 509.964 68.8499C509.314 69.3283 508.747 69.7347 508.295 70.066C507.343 70.6745 506.828 71.012 506.828 71.012C504.563 72.4459 502.168 73.7183 499.652 74.7619C498.417 75.3293 497.12 75.7605 495.839 76.249C494.529 76.6666 493.237 77.1292 491.9 77.476C486.584 78.9529 481.067 79.9146 475.469 80.435C469.87 80.9678 464.194 81.1277 458.498 81.0197C455.668 80.9799 452.748 80.8629 449.876 80.7879L443.466 80.595L443.003 62.5921L442.312 36.3457L447.253 36.4884C448.371 36.5214 449.476 36.5532 450.557 36.5825C451.664 36.5896 452.764 36.6023 453.845 36.607C454.926 36.6362 455.999 36.5657 457.058 36.5186C458.117 36.4714 459.157 36.4409 460.183 36.3038C464.297 35.9358 468.223 35.1838 471.806 33.7413C475.381 32.329 478.615 30.1893 480.927 27.3127C483.263 24.4509 484.572 20.9901 485.113 17.5626L485.107 17.5435Z"
          fill="#ffffff7d"
        />
        <path
          d="M628.636 -23.6993C627.184 -18.8428 627.285 -16.1605 628.042 -15.9228C628.842 -15.6623 630.281 -17.7738 631.962 -22.3165C632.638 -23.887 633.321 -25.4753 634.004 -27.076C634.766 -28.6378 635.601 -30.1674 636.401 -31.7501C636.774 -32.5596 637.297 -33.2735 637.749 -34.0441C638.219 -34.8067 638.689 -35.5693 639.159 -36.3442C640.136 -37.8656 641.277 -39.3024 642.347 -40.8329C646.985 -46.6464 652.943 -52.2209 660.978 -56.2732C662.164 -56.858 663.294 -57.4299 664.388 -57.8632C664.934 -58.086 665.445 -58.3372 665.959 -58.5077C666.505 -58.7059 667.026 -58.8943 667.522 -59.0729C671.346 -60.2248 674.355 -60.9339 676.118 -61.4106C673.934 -63.5064 671.794 -65.474 669.883 -67.2824C669.186 -67.9284 668.512 -68.5472 667.857 -69.158C667.344 -69.6307 666.85 -70.0829 666.361 -70.5284C664.423 -72.3023 662.67 -73.9028 660.971 -75.4546C657.579 -78.5637 654.391 -81.516 650.316 -85.4491C645.637 -89.9197 640.194 -95.1915 634.538 -100.708C631.719 -103.468 628.828 -106.285 625.968 -109.08C625.255 -109.784 624.535 -110.481 623.827 -111.178L622.162 -112.794L621.685 -113.251L621.448 -113.485L621.329 -113.596C621.329 -113.596 621.229 -113.582 621.179 -113.574L619.975 -113.307L618.771 -113.039L618.209 -112.911L617.847 -112.812L616.408 -112.413C615.469 -112.125 614.541 -111.799 613.625 -111.483C609.996 -110.12 606.696 -108.327 603.832 -106.317C603.47 -106.075 603.114 -105.827 602.751 -105.585C602.413 -105.316 602.075 -105.06 601.742 -104.797C601.078 -104.271 600.433 -103.761 599.794 -103.257C598.6 -102.165 597.433 -101.133 596.389 -100.089C592.2 -95.9121 589.715 -91.9583 588.256 -89.8302C587.419 -88.5482 586.726 -87.1773 585.979 -85.8305C585.374 -84.7971 584.726 -83.2857 583.896 -81.44C583.006 -79.6129 582.202 -77.3255 581.25 -74.7439C580.735 -73.4664 580.356 -72.0451 579.906 -70.5753C579.47 -69.1166 579.012 -67.5796 578.533 -65.9768C578.075 -64.4398 577.589 -62.8438 577.095 -61.1806C576.51 -59.5576 575.868 -57.8971 575.223 -56.175C572.497 -49.3508 568.288 -42.2319 562.402 -35.9698C559.408 -32.8965 555.985 -30.0708 552.167 -27.712C550.27 -26.5128 548.238 -25.4944 546.165 -24.5358L544.574 -23.8869L543.682 -23.5322L542.028 -22.9949C539.834 -22.265 537.606 -21.6005 535.378 -20.9482C537.479 -18.9228 542.769 -13.8396 547.946 -8.84843C558.695 1.42159 567.391 9.73274 574.278 16.3139C577.724 19.6017 580.706 22.4589 583.266 24.8959C584.545 26.1206 585.724 27.2423 586.789 28.2596C587.504 28.9383 588.182 29.5886 588.831 30.2049C589.29 30.6411 589.73 31.0693 590.165 31.4784C590.225 31.5092 590.263 31.6306 590.333 31.5821L590.528 31.5214L590.916 31.4C591.173 31.3209 591.423 31.2473 591.68 31.1682C592.268 30.9929 592.863 30.812 593.445 30.6299C593.795 30.5294 593.902 30.4845 594.078 30.4158L594.574 30.2373C595.233 29.9887 595.903 29.7784 596.534 29.4836C597.169 29.2079 597.793 28.931 598.422 28.6609C599.028 28.3513 599.628 28.0472 600.221 27.7487C600.826 27.4637 601.379 27.1053 601.948 26.7797C602.506 26.4404 603.075 26.1271 603.615 25.7675C604.143 25.4066 604.671 25.0458 605.193 24.6782C605.714 24.3228 606.23 23.9608 606.71 23.558C610.661 20.5014 613.893 17.0563 616.604 13.478C621.912 6.22945 625.281 -1.35211 627.641 -9.08543C629.982 -17.7176 627.486 -18.3668 624.653 -10.2731C621.847 -2.97477 618.23 4.03719 613.054 10.6126C610.418 13.8522 607.349 16.9427 603.702 19.6652C603.261 20.0225 602.791 20.3458 602.302 20.6612C601.825 20.9777 601.342 21.2998 600.853 21.6275C600.364 21.9428 599.84 22.2174 599.332 22.5247C598.814 22.8184 598.312 23.1325 597.77 23.3867C597.228 23.6533 596.691 23.9266 596.149 24.1932C595.582 24.4326 595.022 24.6789 594.456 24.9183C593.895 25.1768 593.294 25.3632 592.71 25.5823L591.926 25.8676L591.619 25.9541C591.538 25.9767 591.456 26.0117 591.375 26.0221C591.322 25.961 591.262 25.9055 591.197 25.8431C591.138 25.7753 591.072 25.713 591.001 25.6439C590.763 25.4095 590.525 25.175 590.269 24.9326C589.277 23.9473 588.177 22.8646 586.976 21.6788C584.593 19.3031 581.8 16.5207 578.639 13.367C572.304 7.05828 564.428 -0.749007 555.093 -9.75596C553.569 -11.2219 552.04 -12.6822 550.497 -14.1192C549.722 -14.8411 548.954 -15.5562 548.185 -16.2713L547.023 -17.3356L546.438 -17.865L546.152 -18.1291L546.093 -18.1969L546.08 -18.1858C545.995 -18.2192 545.856 -18.289 545.699 -18.4038C545.738 -18.4371 545.802 -18.4924 545.891 -18.5453L545.967 -18.587L545.999 -18.6147C546.055 -18.6276 545.923 -18.5853 546.124 -18.6638L547.66 -19.3245C549.706 -20.224 551.69 -21.272 553.622 -22.4058C557.474 -24.6993 561.024 -27.4687 564.189 -30.5123C570.569 -36.582 575.119 -43.8643 578.252 -50.5296C578.645 -51.368 579.024 -52.1831 579.397 -52.9927C579.782 -53.7886 580.044 -54.6218 580.367 -55.4117C580.671 -56.2096 580.968 -56.9774 581.259 -57.7396C581.549 -58.4895 581.839 -59.2271 582.048 -59.9666C582.944 -62.857 583.728 -65.4 584.382 -67.5108C584.702 -68.5361 584.98 -69.4542 585.229 -70.2516C585.472 -71.0558 585.691 -71.7325 585.911 -72.2669C586.326 -73.3505 586.553 -73.9274 586.553 -73.9274C586.553 -73.9274 586.913 -74.8805 587.564 -76.5958C587.883 -77.4541 588.4 -78.447 588.93 -79.6302C589.472 -80.7999 590.059 -82.1629 590.87 -83.5528C591.663 -84.9629 592.457 -86.5524 593.54 -88.094C594.06 -88.8762 594.582 -89.7077 595.141 -90.5355C595.755 -91.3268 596.369 -92.1428 597.015 -92.9741C599.646 -96.2451 602.871 -99.5547 606.768 -102.326C607.258 -102.666 607.748 -103.018 608.238 -103.358C608.746 -103.69 609.277 -103.983 609.791 -104.296C610.813 -104.953 611.929 -105.476 613.021 -106.04C613.565 -106.331 614.148 -106.538 614.715 -106.789C615.281 -107.041 615.854 -107.274 616.443 -107.474C617.032 -107.674 617.605 -107.919 618.211 -108.074L619.106 -108.335L619.556 -108.463L619.693 -108.499L619.768 -108.516L620.049 -108.58C620.049 -108.58 620.15 -108.619 620.186 -108.591L620.287 -108.5L621.186 -107.636C622.186 -106.681 623.185 -105.726 624.185 -104.771C626.179 -102.867 628.149 -100.979 630.09 -99.1241C637.845 -91.7125 645.023 -84.8481 650.362 -79.7354L660.058 -70.4692L664.909 -65.8388L666.201 -64.6006L666.528 -64.289L666.688 -64.1304L666.765 -64.0422C666.765 -64.0422 666.868 -63.9885 666.806 -63.9824C666.538 -63.9169 666.275 -63.8569 666.012 -63.7723C665.881 -63.73 665.75 -63.7 665.624 -63.6509L664.364 -63.2159C662.387 -62.495 660.461 -61.6636 658.599 -60.7207C649.837 -56.2783 643.471 -50.1019 638.705 -43.7384C637.605 -42.0749 636.447 -40.4915 635.471 -38.8401C634.998 -38.0036 634.537 -37.1659 634.071 -36.3472C633.629 -35.5137 633.115 -34.7247 632.758 -33.8579C631.991 -32.1606 631.199 -30.4904 630.488 -28.8183C629.869 -27.1061 629.256 -25.4116 628.649 -23.7227L628.636 -23.6993Z"
          fill="#ffffff7d"
        />
        <path
          d="M802.514 -15.3488C802.255 -15.1958 802.007 -15.0415 801.766 -14.8928C801.549 -14.7169 801.338 -14.5466 801.127 -14.3886C800.718 -14.059 800.353 -13.7435 800.025 -13.4366C799.347 -12.8622 798.925 -12.2246 798.577 -11.7341C797.906 -10.726 797.767 -10.0473 798.052 -9.74631C798.336 -9.44528 799.049 -9.50277 800.095 -9.96575C801.122 -10.4491 802.552 -11.2442 804.398 -12.2444C807.021 -13.6544 809.918 -14.5046 812.946 -14.4571C815.968 -14.4287 819.104 -13.5352 822.187 -11.9667C825.284 -10.4215 828.323 -8.208 831.307 -5.57939C832.074 -4.95732 832.799 -4.24042 833.549 -3.53337C834.3 -2.82631 835.056 -2.12481 835.791 -1.34509C836.533 -0.583212 837.281 0.197792 838.04 0.980018C838.811 1.80046 839.581 2.63321 840.369 3.474C843.542 6.79592 846.33 9.71378 847.249 10.6669C848.471 9.50436 849.642 8.37379 850.774 7.30107C851.45 6.64598 852.094 6.01856 852.712 5.41328C853.832 4.31467 854.857 3.29906 855.829 2.34008C857.762 0.420855 859.456 -1.25662 861.061 -2.85659C864.282 -6.05529 867.225 -8.94207 871.324 -12.7568C875.09 -16.259 879.375 -20.2465 884.651 -25.148C882.323 -27.679 879.919 -30.2858 877.485 -32.9266C875.549 -35.0343 873.595 -37.1748 871.641 -39.3029C867.678 -43.5833 863.565 -47.6625 859.562 -51.2419C855.558 -54.8213 851.676 -57.875 848.315 -60.2386C844.955 -62.6023 842.135 -64.2555 840.376 -65.2443C839.082 -65.9817 837.73 -66.6323 836.371 -67.2651C833.928 -68.3171 829.349 -70.353 822.893 -71.5648C819.678 -72.1633 815.995 -72.5248 812.042 -72.3075C808.089 -72.1025 803.883 -71.3108 799.735 -69.8205C795.57 -68.3505 791.529 -66.1318 787.746 -63.4108C783.945 -60.6977 780.444 -57.4717 777.195 -53.88C770.655 -46.7565 765.856 -37.4398 764.192 -27.6812C763.028 -20.7913 763.322 -14.3287 764.311 -8.68015C764.594 -7.27211 764.866 -5.90225 765.14 -4.56938C765.488 -3.25365 765.832 -1.98167 766.159 -0.742359C766.511 0.487134 766.934 1.65575 767.302 2.80025C767.423 3.15895 767.539 3.51087 767.654 3.87511C767.737 4.10009 767.806 4.38541 767.92 4.61967L768.477 5.20816C768.928 5.68685 769.367 6.15197 769.793 6.61584C775.826 13.0424 780.259 17.7725 783.306 21.0136C786.845 24.7562 790.171 28.2668 792.804 31.0452L796.812 27.9635C792.968 22.1179 790.866 16.1831 790.764 10.6122C790.693 5.05057 792.433 -0.0427144 795.383 -4.31432C796.459 -5.86269 797.251 -7.08128 797.725 -7.95475C798.188 -8.84177 798.288 -9.47491 798.039 -9.73523C797.797 -10.0134 797.199 -9.92557 796.276 -9.41314C795.334 -8.90874 794.131 -7.90512 792.817 -6.30657C789.226 -1.90838 786.78 3.80608 786.583 10.3363C786.404 16.8746 788.698 23.8804 792.878 30.4219L796.178 27.8806C793.571 25.0801 790.284 21.5362 786.776 17.7659C783.985 14.792 779.805 10.0814 774.28 3.91675C773.937 3.52322 773.582 3.14077 773.227 2.74599C773.05 2.54245 772.878 2.34568 772.695 2.14767L772.63 2.07304L772.618 2.05946L772.6 2.03911L772.571 1.99286C772.56 1.95465 772.567 1.94911 772.518 1.78949C772.441 1.53434 772.365 1.2792 772.289 1.02406C772.137 0.513761 771.972 -0.0101045 771.808 -0.533968C771.455 -1.5842 771.234 -2.67674 770.945 -3.79464C770.807 -4.35297 770.663 -4.91808 770.525 -5.48873C770.419 -6.06241 770.313 -6.64842 770.207 -7.23442C769.321 -11.9262 768.883 -17.1107 769.375 -22.5409C769.472 -24.3248 769.82 -26.0523 770.071 -27.802C770.242 -28.663 770.468 -29.5122 770.651 -30.3719C770.755 -30.7943 770.822 -31.2329 770.95 -31.6528L771.335 -32.9003C771.471 -33.3504 771.606 -33.8006 771.749 -34.2562L771.962 -34.9397L772.224 -35.6059C772.582 -36.4974 772.933 -37.3957 773.292 -38.2995C774.16 -40.036 774.986 -41.8201 776.062 -43.4861C778.128 -46.8639 780.613 -50.0569 783.448 -52.8742C789.006 -58.6378 795.609 -63.0458 802.047 -65.2314C805.252 -66.3473 808.392 -66.944 811.234 -67.1876C814.082 -67.4243 816.641 -67.2573 818.754 -67.0615C819.804 -66.8992 820.758 -66.7838 821.581 -66.6385C822.402 -66.4685 823.107 -66.3166 823.677 -66.203C824.816 -65.9266 825.433 -65.7464 825.433 -65.7464C828.131 -65.0335 830.795 -64.0889 833.388 -62.9289C835.995 -61.8046 838.531 -60.4647 841.007 -59.0135C845.958 -56.074 850.673 -52.6574 855.132 -48.8895C859.598 -45.1271 863.848 -41.0711 867.917 -36.8233C869.947 -34.7246 871.99 -32.507 874.023 -30.3522L878.557 -25.5191L865.83 -13.5742L847.266 3.86467L843.846 0.220832C840.742 -3.12502 837.56 -6.39212 834.303 -9.15357C831.04 -11.9341 827.625 -14.3342 823.966 -16.0355C820.332 -17.7465 816.415 -18.7378 812.637 -18.577C808.86 -18.4407 805.395 -17.1595 802.52 -15.342L802.514 -15.3488Z"
          fill="#ffffff7d"
        />
        <path
          d="M896.677 56.1783C892.472 50.562 890.102 52.1214 893.806 58.0641C895.803 61.2605 897.854 64.5057 900.088 67.9488C901.212 69.6648 902.371 71.4339 903.575 73.2819C904.187 74.2037 904.811 75.1392 905.446 76.1005C906.384 77.5009 907.347 78.9283 908.332 80.3953C911.16 80.1752 914.652 79.9049 918.331 79.6164C932.903 78.2748 936.445 77.3663 946.338 76.6075C950.283 76.2781 954.866 75.9453 959.665 75.6159C965.171 75.2469 970.917 74.8714 976.416 74.5079C976.371 72.4312 976.331 70.3736 976.289 68.3653C976.274 67.0586 976.264 65.7834 976.24 64.5439C976.211 62.0606 976.188 59.7265 976.168 57.6153C976.136 53.3874 976.104 50.0627 976.097 48.2497C976.089 47.2344 976.062 46.2112 976.011 45.1854C975.941 43.7247 975.824 41.2696 975.624 37.068C975.434 32.4407 975.156 25.8808 974.762 16.5443C973.11 15.8322 970.49 14.7066 967.178 13.2881C964.633 12.1823 961.564 10.8503 958.168 9.37371C951.382 6.40262 943.322 2.83217 935.648 -0.631174L920.59 -7.28702L908.681 15.5899C902.014 28.4344 897.278 38.1719 892.865 47.868C890.442 53.195 892.708 54.4827 895.67 49.4639C901.067 40.3317 906.334 30.8955 913.044 18.0739C914.017 16.1995 915.482 13.6143 917.4 10.2338C918.352 8.54299 919.419 6.64715 920.598 4.55866C921.185 3.50486 921.798 2.40427 922.445 1.25138C922.605 0.958381 922.771 0.672173 922.931 0.379174L923.158 -0.0307828L923.19 -0.0584499C923.229 -0.0916589 923.261 -0.119349 923.287 -0.141488C923.328 -0.0939942 923.37 -0.0588179 923.393 -0.031678C923.411 -0.011323 923.369 -0.0341659 923.447 0.00475372C923.636 0.0918888 923.83 0.185811 924.036 0.280978C924.431 0.463279 924.843 0.653604 925.268 0.857508C926.961 1.62938 928.843 2.48842 930.798 3.37956C933.366 4.53711 935.962 5.63551 938.548 6.65879C943.946 8.79622 949.698 11.1738 955.309 13.5432C960.426 15.7326 965.434 17.8738 969.858 19.7702C969.896 20.677 969.934 21.5592 969.968 22.3977C970.02 23.708 970.068 24.9623 970.113 26.1483C970.196 28.5133 970.271 30.6117 970.325 32.349C970.431 35.8235 970.496 37.8836 970.496 37.8836L971.644 70.2257L943.162 72.5864C928.788 73.781 921.87 74.3593 917.621 74.7136C916.076 74.8475 914.562 74.9783 913.141 75.1001C912.433 75.1644 911.745 75.2244 911.087 75.2813C910.882 75.3038 910.689 75.3275 910.509 75.3525C908 71.8258 905.724 68.6321 903.589 65.6259C901.183 62.2952 898.91 59.1945 896.652 56.1758L896.677 56.1783Z"
          fill="#ffffff7d"
        />
        <path
          d="M597.353 122.644C597.321 122.504 597.289 122.377 597.257 122.251C597.244 122.119 597.225 121.994 597.217 121.869C597.19 121.619 597.145 121.373 597.13 121.137C597.142 120.674 597.08 120.228 597.152 119.834C597.166 119.631 597.174 119.434 597.188 119.244C597.226 119.056 597.252 118.879 597.284 118.709C597.309 118.532 597.335 118.368 597.36 118.203C597.403 118.047 597.44 117.896 597.477 117.758C597.581 117.168 597.711 116.711 597.738 116.355C597.759 115.992 597.695 115.726 597.534 115.592C597.372 115.458 597.126 115.446 596.773 115.595C596.421 115.745 595.946 116.025 595.478 116.584C595.361 116.72 595.232 116.868 595.101 117.028C594.983 117.201 594.877 117.388 594.763 117.593C594.65 117.798 594.536 118.016 594.409 118.244C594.325 118.495 594.234 118.752 594.142 119.021C593.929 119.562 593.872 120.194 593.777 120.871C593.751 121.214 593.773 121.563 593.777 121.928C593.782 122.114 593.793 122.295 593.804 122.488C593.833 122.676 593.863 122.865 593.892 123.053C594.23 125.234 595.114 127.216 596.16 129.023C597.211 130.85 598.507 132.441 599.847 134.006C600.54 134.763 601.226 135.537 601.969 136.25C602.694 136.991 603.45 137.693 604.214 138.389C606.437 140.427 606.357 139.961 606.372 140.365L606.178 140.568L606.075 140.656L606.036 140.714L605.816 140.964C605.166 141.727 604.511 142.495 603.849 143.269C602.53 144.824 601.174 146.412 599.79 148.047C597.036 151.318 594.151 154.761 591.092 158.39C591.039 158.459 590.987 158.528 590.935 158.597C590.893 158.704 590.821 158.647 590.749 158.603L590.647 158.537L590.593 158.501L590.436 158.386C589.963 158.022 589.507 157.667 589.058 157.318C587.267 155.881 585.586 154.492 584.085 153.232C581.089 150.744 578.706 148.523 576.579 146.378C574.459 144.226 572.571 142.148 570.769 139.794C568.966 137.44 567.199 134.818 565.521 131.524C562.672 126.008 560.589 118.832 561.413 111.629C561.8 108.05 562.864 104.515 564.515 101.318C566.136 98.0866 568.312 95.2209 570.74 92.6593C573.15 90.1019 575.761 87.9422 578.437 86.2963C581.107 84.6437 583.83 83.5037 586.402 82.7565C591.556 81.2879 595.987 81.181 598.452 81.0971L600.716 81.0547C601.478 81.0269 602.303 80.9683 603.053 80.9146C604.356 80.8117 606.189 80.7257 608.761 80.4177C610.041 80.2631 611.534 80.0435 613.228 79.603C614.909 79.149 616.873 78.4514 618.766 77.0539C619.721 76.3715 620.591 75.5134 621.386 74.5055C622.193 73.4988 622.881 72.2388 623.361 70.7906C623.792 69.3127 623.914 67.6613 623.715 66.0144C623.472 64.3815 622.937 62.7994 622.218 61.3039C620.749 58.3528 618.641 55.7513 616.232 53.2677C615.021 52.0314 613.715 50.8289 612.342 49.6379C611.762 49.14 611.17 48.6408 610.573 48.1224L610.369 47.9657C610.369 47.9657 610.416 47.89 610.436 47.8487L610.482 47.773L610.521 47.7398C610.599 47.6241 610.684 47.5152 610.775 47.4007C611.634 46.3621 612.616 45.1567 613.715 43.8271C615.919 41.1622 618.572 37.9553 621.498 34.4174C622.727 32.9401 624.007 31.3938 625.333 29.8089C625.422 29.5891 625.576 29.7655 625.738 29.8748C626.158 30.2019 626.583 30.5357 627.002 30.8752C627.517 31.2985 628.032 31.7218 628.546 32.1452C629.586 33.0301 630.626 33.915 631.678 34.8134C632.686 35.726 633.732 36.5931 634.714 37.5401C636.729 39.3775 638.622 41.3325 640.459 43.3003C645.38 48.6552 649.092 54.0792 651.459 59.2862C653.851 64.4957 654.862 69.4353 654.88 73.7235C654.892 75.8649 654.675 77.847 654.323 79.6607C653.941 81.4651 653.442 83.0968 652.881 84.5677C651.724 87.4934 650.34 89.759 649.124 91.5222C647.674 93.5955 646.045 95.5022 644.343 97.1975C642.666 98.92 640.881 100.39 639.03 101.668C635.34 104.226 631.36 105.869 627.289 106.841C625.265 107.354 623.199 107.676 621.149 107.925C619.098 108.187 617.04 108.3 614.925 108.475C612.828 108.658 610.774 108.827 608.673 109.096C606.585 109.367 604.46 109.764 602.383 110.511C600.137 111.335 598.693 112.617 597.997 113.623C597.631 114.118 597.458 114.564 597.377 114.896C597.301 115.235 597.335 115.455 597.46 115.585L597.512 115.98C597.512 115.98 597.581 115.956 597.564 115.911L597.502 115.62L597.525 115.647C597.676 115.743 597.911 115.754 598.223 115.675C598.529 115.588 598.908 115.404 599.386 115.193C600.338 114.739 601.633 114.085 603.535 113.523C607.106 112.519 611.21 112.552 615.366 112.373C619.512 112.287 623.989 112.141 628.498 111.183C633.018 110.262 637.627 108.515 641.847 105.69C643.957 104.284 645.989 102.659 647.859 100.771C649.752 98.9093 651.542 96.8519 653.182 94.5195C654.443 92.7053 655.981 90.3192 657.364 87.1505C658.723 83.9916 659.911 80.0051 660.141 75.2657C660.376 70.5454 659.595 65.1096 657.494 59.5894C655.399 54.0636 652.045 48.509 647.728 43.203C644.913 39.7504 641.795 36.5825 638.53 33.709C637.82 33.0617 637.079 32.4421 636.337 31.8226C635.59 31.1962 634.849 30.5643 634.106 29.9694C632.622 28.7549 631.102 27.512 629.495 26.285L627.85 25.0666C627.117 24.5468 626.382 24.064 625.654 23.5757L624.552 22.8515L624.414 22.7571C624.414 22.7571 624.372 22.7096 624.347 22.7194L624.289 22.7692L624.088 23.0147L623.679 23.4866C623.134 24.1117 622.583 24.7423 622.055 25.4124C620.76 27.0067 619.471 28.6077 618.182 30.1965C615.865 33.054 613.555 35.8936 611.31 38.6533C608.565 41.9869 605.898 45.2419 603.342 48.3411C604.974 49.7252 606.582 51.0945 608.154 52.4355C609.17 53.2932 610.065 54.0892 610.977 54.9178C612.759 56.5646 614.335 58.2585 615.621 59.9415C616.907 61.6245 617.87 63.3243 618.363 64.8836C618.862 66.4497 618.875 67.8302 618.525 68.9884C618.181 70.1412 617.474 71.0962 616.739 71.8504C616.004 72.5923 615.273 73.0933 614.621 73.4539C614.292 73.6309 613.978 73.7598 613.725 73.895C613.449 74.003 613.21 74.0901 613.022 74.1576C612.639 74.2981 612.427 74.3508 612.427 74.3508C612.427 74.3508 611.579 74.6668 609.824 74.9587C608.074 75.2574 605.4 75.4871 601.98 75.6718C600.33 75.8013 598.451 75.7838 596.367 75.9311C594.302 76.0864 592.087 76.276 589.776 76.7156C587.47 77.1496 585.078 77.7542 582.68 78.6366C580.293 79.5449 577.933 80.7279 575.674 82.1563C573.397 83.5767 571.322 85.333 569.336 87.2035C568.858 87.687 568.369 88.1693 567.892 88.6528C567.408 89.1418 566.979 89.6673 566.519 90.1835C565.606 91.198 564.733 92.2847 563.915 93.4077C560.623 97.892 558.255 103.218 557.363 108.744C556.428 114.259 557.006 119.823 558.369 124.637C559.73 129.476 561.814 133.597 563.8 136.922C566.849 141.92 570.097 145.843 573.095 149.055C576.105 152.267 578.87 154.824 581.332 156.942C583.751 159.025 585.795 160.778 587.707 162.253C588.445 162.816 589.25 163.405 589.984 163.888C590.358 164.136 590.719 164.371 591.08 164.605C591.261 164.723 591.442 164.84 591.617 164.951L591.882 165.126C591.935 165.187 591.957 165.096 591.989 165.069L592.086 164.961C592.604 164.383 593.102 163.846 593.576 163.294C594.044 162.735 594.492 162.193 594.921 161.68C597.951 158.016 600.812 154.559 603.531 151.259C604.884 149.603 606.205 147.986 607.499 146.405C608.144 145.61 608.781 144.834 609.413 144.05C609.894 143.456 610.375 142.874 610.856 142.292C611.408 141.649 611.811 141.028 612.269 140.406L612.603 139.939L612.773 139.709L612.812 139.651C612.812 139.651 612.777 139.611 612.759 139.603L612.639 139.504L611.681 138.726C611.053 138.223 610.43 137.715 609.72 137.247C609.045 136.795 608.197 136.22 607.987 136.057C607.807 135.927 607.663 135.813 607.49 135.666L606.94 135.19C606.199 134.558 605.47 133.939 604.786 133.282C604.076 132.647 603.423 131.975 602.77 131.315C600.231 128.657 598.02 125.705 597.34 122.642L597.353 122.644Z"
          fill="#ffffff7d"
        />
        <path
          d="M905.025 104.617C908.268 104.859 910.596 104.322 912.04 103.776C913.485 103.218 914.096 102.63 913.988 102.248C913.875 101.834 913.048 101.633 911.568 101.532C910.088 101.432 907.949 101.437 905.199 101.09C901.301 100.546 897.6 98.8219 894.302 96.1306C890.979 93.4615 888.092 90.1067 886.444 86.0736C885.591 84.0759 885.092 81.9036 884.855 79.659C884.811 79.3762 884.81 79.0916 884.791 78.8113L884.765 78.3819C884.753 78.2137 884.742 78.1755 884.744 77.8293L884.721 76.1259L884.719 75.699L884.715 75.4883L884.714 75.383C884.714 75.383 884.66 75.3342 884.63 75.3126L883.93 74.7405C882.703 73.7315 881.458 72.7146 880.202 71.684C876.043 68.2867 871.686 64.7148 867.066 60.9429C856.534 52.4702 849.863 47.284 844.067 42.7681C841.173 40.5013 838.494 38.4047 835.636 36.1662C834.216 35.0387 832.755 33.8637 831.198 32.6293C829.498 31.2445 827.702 29.7881 825.745 28.1977C825.123 27.6892 824.488 27.1794 823.86 26.6641C823.543 26.4031 823.219 26.1476 822.902 25.8866L822.417 25.4971C822.26 25.3947 822.069 25.0968 822.006 25.4122C821.299 26.8311 820.573 28.2789 819.833 29.7502C819.557 30.3098 819.268 30.8681 818.986 31.4332C818.751 31.8856 818.534 32.3461 818.317 32.8189C817.877 33.7577 817.437 34.7089 816.996 35.6723C816.089 37.5967 815.284 39.6241 814.409 41.6632C813.632 43.7491 812.757 45.8252 812.043 48.0104C809.022 56.6477 806.809 66.0723 806.012 75.2136C805.771 77.4901 805.691 79.7582 805.607 81.9703C805.61 84.1911 805.553 86.3687 805.702 88.4868C805.864 92.7217 806.395 96.6971 807.016 100.273C808.309 107.431 810.225 112.92 811.332 115.958C812.064 117.727 812.733 119.527 813.615 121.25C815.072 124.354 818.013 130.052 823.031 136.821C827.985 143.621 835.198 151.311 844.23 158.5C848.74 162.081 853.705 165.603 859.117 168.75C864.529 171.885 870.381 174.712 876.587 176.734C882.775 178.759 889.26 180.148 895.734 180.582C902.208 181.041 908.645 180.711 914.787 179.757C923.446 178.304 930.974 175.938 937.461 173.318C943.967 170.694 949.526 167.937 954.295 165.291C959.059 162.639 963.103 160.191 966.488 157.981C968.177 156.878 969.745 155.88 971.126 154.913C972.385 154.051 973.587 153.227 974.726 152.446C975.311 152.047 975.883 151.648 976.443 151.272C976.723 151.077 976.99 150.894 977.263 150.705L977.365 150.641L977.41 150.603C977.41 150.603 977.386 150.576 977.374 150.562L977.177 150.4L976.782 150.075C970.586 145.073 964.791 140.39 959.289 135.941C954.569 132.184 950.114 128.627 945.831 125.217C937.241 118.42 929.312 112.24 921.415 106.175C917.23 102.954 914.707 101.746 914.2 102.195L913.841 102.66C913.927 102.669 913.953 102.634 913.926 102.551L914.115 102.304C913.794 102.902 915.515 105.137 919.53 108.588C927.094 115.083 934.763 121.583 943.177 128.603C947.401 132.1 951.791 135.737 956.439 139.592C960.436 142.868 964.655 146.321 969.155 150.006C969.179 150.033 969.252 150.065 969.232 150.094L969.118 150.169C969.041 150.223 968.959 150.271 968.882 150.325C968.724 150.426 968.559 150.533 968.375 150.644C967.752 151.051 967.091 151.492 966.405 151.941C965.67 152.399 964.908 152.878 964.109 153.378C963.31 153.879 962.473 154.388 961.61 154.931C960.73 155.442 959.817 155.98 958.867 156.539C956.991 157.672 954.913 158.766 952.724 159.979C948.308 162.308 943.298 164.781 937.627 167.1C931.95 169.413 925.605 171.565 918.574 173.109C913.99 174.085 909.349 174.789 904.705 175.128C899.688 175.491 894.42 175.333 889.129 174.53C883.844 173.734 878.535 172.305 873.465 170.324C863.295 166.354 854.154 160.317 846.718 154.33C843.019 151.319 839.715 148.337 836.93 145.512C836.209 144.826 835.584 144.095 834.931 143.422C834.297 142.733 833.655 142.099 833.101 141.437C831.986 140.105 830.883 138.942 830.009 137.783C828.172 135.531 826.851 133.64 825.932 132.353C825.464 131.712 825.157 131.192 824.924 130.846C824.703 130.502 824.58 130.323 824.58 130.323C824.58 130.323 824.406 130.058 824.074 129.548C823.736 129.043 823.247 128.301 822.669 127.302C822.097 126.31 821.329 125.131 820.59 123.677C820.205 122.964 819.797 122.199 819.366 121.382C818.973 120.556 818.557 119.679 818.113 118.756C816.414 115.064 814.643 110.554 813.269 105.417C811.882 100.291 810.891 94.537 810.529 88.5129C810.162 82.482 810.418 76.1866 811.288 69.9782C812.158 63.7699 813.624 57.653 815.434 51.9049C817.238 46.1501 819.429 40.7747 821.671 35.9489C821.95 35.34 822.221 34.749 822.492 34.158C822.755 33.6342 823.011 33.1159 823.267 32.5975C823.341 32.4504 823.415 32.3033 823.489 32.1562L823.597 31.9321L823.65 31.8262C823.65 31.8262 823.717 31.8639 823.741 31.8787C825.04 32.9321 826.255 33.9276 827.38 34.8335C848.06 51.6349 858.015 59.715 864.132 64.678C868.772 68.4209 873.16 71.9652 877.333 75.339C878.195 76.0327 879.058 76.714 879.896 77.3929L880.01 77.4849C880.039 77.5188 880.024 77.5914 880.028 77.6352L880.046 77.9648L880.114 78.8809C880.149 79.2186 880.154 79.5592 880.209 79.8926C880.539 82.5796 881.21 85.2332 882.305 87.6638C883.393 90.0999 884.804 92.34 886.476 94.2724C888.134 96.2159 889.983 97.8881 891.927 99.3472C893.878 100.801 895.972 102.059 898.199 102.953C900.419 103.852 902.739 104.416 905.025 104.617Z"
          fill="#ffffff7d"
        />
        <path
          d="M750.918 46.3522C758.573 45.1128 758.048 42.2019 750.288 42.8307C744.785 43.2804 739.151 43.7848 733.048 44.4087C730.025 44.6895 726.768 45.1259 723.389 45.6428C721.713 45.9736 719.993 46.3063 718.229 46.653C716.491 47.1076 714.704 47.5695 712.867 48.051C704.656 50.6382 699.911 53.2864 696.03 55.8305C695.542 56.1458 695.048 56.4297 694.589 56.7666C694.13 57.1036 693.684 57.4294 693.232 57.7608C692.779 58.0922 692.333 58.418 691.881 58.7494C691.422 59.074 690.976 59.4122 690.546 59.7953C689.669 60.529 688.754 61.2836 687.788 62.0824C686.875 62.9423 685.905 63.852 684.851 64.846C681.414 68.3136 677.817 72.8473 674.903 78.0873C674.182 79.3997 673.527 80.762 672.822 82.1193L671.901 84.2464L671.143 86.0189L670.767 86.9146L670.671 87.14C670.637 87.2169 670.752 87.2719 670.787 87.3373L671.117 87.7172C673.189 90.148 673.774 90.9743 674.941 92.2247C675.48 92.8052 676.025 93.3924 676.558 93.9661L677.364 94.8272L678.215 95.6373C682.663 100.01 687.456 103.478 691.623 105.93C693.74 107.085 695.626 108.154 697.297 108.862C698.123 109.243 698.869 109.585 699.537 109.887C700.213 110.148 700.803 110.375 701.296 110.567C702.473 110.989 703.633 111.485 704.839 111.786C705.916 112.056 707.431 112.507 709.355 112.95C711.288 113.301 713.602 113.869 716.25 114.138C721.545 114.843 728.159 115.205 735.372 114.644C738.976 114.348 742.752 113.939 746.495 113.441C750.273 112.971 754.175 112.489 758.128 111.999C766.026 111.025 774.134 110.061 781.929 109.176L790.783 108.101L783.832 68.3848C782.917 63.2076 782.054 58.4253 781.215 53.9548C780.206 48.6567 779.256 43.7234 778.358 39.0427C777.183 39.2018 776.013 39.3677 774.857 39.5225C774.285 39.6005 773.725 39.6798 773.16 39.7522L772.158 39.9042C770.883 40.1025 769.638 40.2979 768.4 40.4877C765.929 40.8864 763.533 41.2802 761.131 41.6673C757.912 42.2004 756.344 43.068 756.371 43.7574L756.162 43.8785C756.178 43.9604 756.232 43.9968 756.313 43.9865L756.401 43.9336C756.615 44.6048 758.421 45.054 761.689 44.8105C764.121 44.612 766.559 44.4202 769.065 44.2168C770.318 44.109 771.578 43.9956 772.862 43.8848L773.799 43.8005L774.196 43.7789C774.444 43.7669 774.692 43.755 774.946 43.7375C774.986 44.1188 775.032 44.507 775.072 44.9007C775.222 45.9118 775.385 46.9365 775.54 47.9791C775.876 50.079 776.214 52.2473 776.568 54.4852C777.295 58.9692 778.096 63.7575 778.999 68.9335C779.54 72.0563 780.214 76.7884 781.124 83.0166C781.591 86.1319 782.111 89.6175 782.684 93.4612C782.99 95.3849 783.297 97.4016 783.627 99.4947C783.8 100.545 783.967 101.614 784.139 102.714L784.174 102.921L784.194 103.022C784.194 103.022 784.194 103.022 784.2 103.029L784.188 103.04L784.175 103.051C784.156 103.043 784.138 103.035 784.145 103.03L781.976 103.286L779.639 103.593C778.085 103.806 776.53 104.032 774.993 104.278C768.347 105.323 761.182 106.353 754.181 107.312C747.181 108.247 740.314 109.257 734.418 109.667C732.925 109.732 731.488 109.796 730.119 109.861C728.746 109.883 727.424 109.835 726.182 109.827C725.558 109.819 724.952 109.807 724.371 109.798C723.792 109.751 723.225 109.706 722.683 109.663C721.598 109.578 720.593 109.507 719.687 109.434C717.878 109.225 716.441 108.98 715.451 108.849C714.467 108.724 713.94 108.597 713.94 108.597C713.94 108.597 713.149 108.436 711.726 108.143C711.016 107.972 710.136 107.864 709.147 107.566C708.156 107.292 707.019 106.979 705.772 106.63C704.533 106.238 703.205 105.732 701.766 105.24C700.341 104.699 698.861 104.005 697.293 103.338C696.53 102.939 695.755 102.539 694.955 102.124C694.562 101.917 694.156 101.709 693.75 101.5C693.345 101.28 692.966 101.025 692.561 100.792C691.765 100.303 690.956 99.8127 690.129 99.3144C689.342 98.7582 688.542 98.2008 687.731 97.6298C684.548 95.2904 681.374 92.6116 678.556 89.5299C677.819 88.7994 677.14 88.0068 676.468 87.2087L676.019 86.6931C675.99 86.6345 675.9 86.582 675.902 86.5204L675.984 86.3308C676.272 85.6425 676.553 84.9597 676.834 84.2769C677.253 83.404 677.677 82.5379 678.096 81.6773C681.496 74.8288 686.134 69.4791 689.985 66.0103C690.674 65.3195 691.439 64.7539 692.155 64.1709C692.877 63.607 693.538 63.0123 694.25 62.5279C694.956 62.0367 695.643 61.5744 696.305 61.1097C696.635 60.8835 696.96 60.6628 697.278 60.4353C697.602 60.2269 697.937 60.0445 698.266 59.8552C698.912 59.4754 699.539 59.1123 700.141 58.7589C700.736 58.3988 701.319 58.062 701.917 57.7949C703.091 57.2213 704.169 56.6937 705.173 56.1955C706.216 55.7695 707.166 55.3772 708.059 55.0101C708.945 54.6486 709.751 54.2974 710.546 54.0626C712.1 53.5523 713.403 53.1156 714.525 52.7408C716.263 52.2739 717.957 51.8211 719.607 51.3824C721.285 51.0269 722.919 50.6855 724.521 50.3472C727.753 49.7907 730.809 49.2906 733.861 48.889C739.924 48.0384 745.498 47.1939 750.919 46.3153L750.918 46.3522Z"
          fill="#ffffff7d"
        />
        <path
          d="M737.982 -30.5396C732.593 -21.759 735.084 -20.0835 740.952 -28.4568C749.352 -40.2903 758.232 -52.6566 770.032 -68.2584C772.641 -71.7481 774.923 -74.8132 775.687 -75.8304C774.881 -77.2978 774.104 -78.7065 773.355 -80.069C772.865 -80.9414 772.399 -81.7866 771.937 -82.6005C771.02 -84.2213 770.178 -85.7294 769.382 -87.1339C767.784 -89.9496 766.388 -92.417 765.049 -94.7672C762.377 -99.4733 759.978 -103.75 756.841 -109.622C754.559 -113.881 752.054 -118.576 748.766 -124.711C746.283 -121.568 743.683 -118.287 741.024 -114.933C739.035 -112.394 737 -109.793 734.96 -107.198C730.902 -101.981 726.88 -96.7112 723.186 -91.7852C715.782 -81.9413 709.725 -73.4883 707.149 -69.8716C706.263 -68.6192 705.384 -67.3601 704.534 -66.0671C701.497 -61.4703 693.327 -49.0876 683.61 -33.1569C673.857 -17.2423 662.64 2.27826 652.745 20.6217L648.111 29.3675L703.445 35.6948L705.577 31.7609C716.267 12.1249 724.631 -2.31629 732.934 -16.4668C737.533 -24.208 735.393 -25.7118 730.256 -18.2788C720.982 -4.71547 712.04 9.48774 701.254 29.2067C701.107 29.4763 700.947 29.7693 700.574 30.4365C696.645 29.8955 690.711 29.0892 683.012 28.0357C678.849 27.4833 674.212 26.8642 669.126 26.1934C666.586 25.8675 663.935 25.5304 661.173 25.182C659.899 25.0219 658.595 24.8647 657.266 24.6928C657.254 24.6792 657.249 24.6724 657.249 24.6601C657.249 24.6601 657.268 24.6435 657.281 24.6324C657.3 24.6158 657.307 24.598 657.314 24.5801L658.634 22.0606C659.587 20.2151 660.54 18.3697 661.48 16.5352C669.558 0.629919 679.733 -17.1593 688.132 -30.7743C692.323 -37.592 696.033 -43.3885 698.697 -47.4849C701.385 -51.5665 702.973 -53.9723 702.973 -53.9723C710.404 -65.23 718.082 -76.3204 725.964 -87.254C729.908 -92.7174 733.912 -98.1376 737.97 -103.509L744.095 -111.547L748.245 -116.89L755.104 -104.151L769.991 -76.5323L766.066 -71.3824C754.237 -55.6723 745.682 -42.9328 737.982 -30.5396Z"
          fill="#ffffff7d"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3622_1083">
        <rect width="1003" height="48" fill="white" />
      </clipPath>
      <clipPath id="clip1_3622_1083">
        <rect
          width="3757.37"
          height="4501.65"
          fill="white"
          transform="matrix(0.17533 -0.151453 0.135277 0.155367 247.785 7.06543)"
        />
      </clipPath>
    </defs>
  </svg>`;
const $24c02ea0e14dbe4f$var$$8f97e278a4a2a6b3$export$cdb81064101cb20c = `data:image/svg+xml;base64,${$24c02ea0e14dbe4f$var$$8f97e278a4a2a6b3$require$Buffer.from($24c02ea0e14dbe4f$var$$8f97e278a4a2a6b3$var$svgStringLearningOverviewCardBackground).toString("base64")}`;
const $24c02ea0e14dbe4f$var$$0fd79bc510e2fa30$export$b7c3a2f69225ecf = ({ ...props })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$0fd79bc510e2fa30$var$defaultButtonStyles,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $123ba5aab151a241$export$2e2bcd8739ae039), {
            appearance: "default",
            ...props
        })
    });
};
const $24c02ea0e14dbe4f$var$$0fd79bc510e2fa30$var$defaultButtonStyles = (0, $74Zh5.css)({
    "& button": {
        borderRadius: "4px",
        border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
        backgroundColor: `transparent`
    }
});
const $24c02ea0e14dbe4f$var$$7586a58445419b5a$export$2c3faa04d4773275 = ({ lessons: lessons, onLessonClick: onLessonClick, expandButtonText: expandButtonText = "Show lessons", collapseButtonText: collapseButtonText = "Hide lessons", containerStyles: customContainerStyles, buttonContainerStyles: customButtonContainerStyles })=>{
    const [isOpened, setIsOpened] = (0, $5FkrB.useState)(false);
    const deviceSize = $24c02ea0e14dbe4f$export$4616d33c54ae5baf();
    const isTablet = deviceSize <= $24c02ea0e14dbe4f$export$62d1d6124a8e4649;
    const toggleLessons = ()=>{
        setIsOpened(!isOpened);
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$wrapperStyles,
            customContainerStyles
        ],
        children: [
            !isTablet && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$buttonContainerStyles,
                    isOpened && $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$buttonContainerOpenStyles,
                    !isOpened && $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$buttonContainerClosedStyles,
                    customButtonContainerStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                    css: $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$toggleButtonStyles,
                    onClick: toggleLessons,
                    "data-testid": "toggle-lessons-button",
                    children: [
                        isOpened ? collapseButtonText : expandButtonText,
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            size: "large",
                            type: isOpened ? "chevron-up" : "chevron-down",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand")
                        })
                    ]
                })
            }),
            isOpened && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$lessonsContentWrapperStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$c3b0ae23c563b692, {
                    lessons: lessons,
                    onLessonClick: onLessonClick,
                    isStandalone: false,
                    isTablet: isTablet
                })
            }),
            isTablet && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$buttonContainerStyles,
                    isOpened && $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$buttonContainerOpenStyles,
                    !isOpened && $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$buttonContainerClosedStyles,
                    $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$buttonContainerMobileStyles,
                    customButtonContainerStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                    css: [
                        $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$toggleButtonStyles,
                        $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$toggleButtonMobileStyles
                    ],
                    onClick: toggleLessons,
                    "data-testid": "toggle-lessons-button-mobile",
                    children: [
                        isOpened ? collapseButtonText : expandButtonText,
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            size: "large",
                            type: isOpened ? "chevron-up" : "chevron-down",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand")
                        })
                    ]
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$wrapperStyles = (0, $74Zh5.css)({
    overflow: "hidden",
    maxWidth: "100%"
});
const $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$buttonContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    alignSelf: "stretch",
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")}`,
    borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`
});
const $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$toggleButtonStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
    fontFamily: "Charlie Text",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.0"),
    display: "flex",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
    "&:hover": {
        textDecoration: "underline",
        textUnderlineOffset: "4px"
    }
});
const $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$toggleButtonMobileStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
    textAlign: "center",
    fontFamily: "Charlie Text",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px"
});
const $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$buttonContainerOpenStyles = (0, $74Zh5.css)({
    borderBottom: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`
});
const $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$lessonsContentWrapperStyles = (0, $74Zh5.css)({
    overflow: "hidden",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral")
});
const $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$buttonContainerClosedStyles = (0, $74Zh5.css)({
    justifyContent: "space-between"
});
const $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$buttonContainerMobileStyles = (0, $74Zh5.css)({
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    justifyContent: "space-between",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`
    }
});
const $24c02ea0e14dbe4f$var$$bde17c0708419ffe$var$CompletedIcon = ()=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M15.8203 7.04186L15.8028 7.03662L6.61914 16.5773L6.62525 16.5939L21.6161 21.8224L15.8203 7.04186Z",
                fill: "#1868DB"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.31618 3.19751L10.3213 7.04536L5.25684 6.23896L5.28564 4.75358L5.31618 3.19751Z",
                fill: "#FCA700"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M14.6344 9.49606H12.8924L11.1836 4.41504H12.9256L14.6344 9.49606Z",
                fill: "#BF63F3"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M9.40688 15.4488L9.37982 15.3764C9.22448 14.9662 8.95742 14.6153 8.60659 14.3631C8.24877 14.1057 7.82811 13.9695 7.39001 13.9695C6.9519 13.9695 6.53211 14.1057 6.17342 14.3631C5.82259 14.6153 5.55553 14.9662 5.40019 15.3764L5.37313 15.4488H3.82666L3.85808 15.3118C4.04397 14.5054 4.49255 13.774 5.12179 13.253C5.43684 12.9921 5.78855 12.7896 6.16644 12.6491C6.5583 12.5042 6.96935 12.4309 7.38913 12.4309C7.80891 12.4309 8.21997 12.5042 8.61182 12.6491C8.99059 12.7887 9.34142 12.9921 9.65648 13.253C10.2857 13.774 10.7352 14.5054 10.9202 15.3118L10.9516 15.4488H9.40513H9.40688Z",
                fill: "#1868DB"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M6.51602 10.2929C6.56926 10.2475 6.62075 10.1943 6.66962 10.1349C6.71849 10.0756 6.76126 10.0127 6.79617 9.94989C7.00126 9.58073 6.94017 9.19935 6.66787 8.89215C6.62162 8.83978 6.56926 8.78916 6.51078 8.74204C6.45231 8.69491 6.38773 8.64953 6.32402 8.61287C5.96707 8.40866 5.5822 8.42436 5.26278 8.69666C5.20867 8.74291 5.15631 8.79615 5.10657 8.85724C5.05769 8.91746 5.0158 8.97855 4.98177 9.03964C4.77755 9.40618 4.83951 9.78669 5.11093 10.0965C5.15893 10.1515 5.21304 10.2039 5.27413 10.2536C5.33522 10.3033 5.39195 10.3426 5.45304 10.3775C5.80911 10.5835 6.19486 10.5678 6.51515 10.2929H6.51602Z",
                fill: "#BF63F3"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M13.6186 12.9931C13.6718 12.9477 13.7233 12.8945 13.7722 12.8351C13.821 12.7758 13.8638 12.7129 13.8987 12.6501C14.1038 12.2809 14.0427 11.8995 13.7704 11.5923C13.7242 11.54 13.6718 11.4894 13.6133 11.4422C13.5548 11.3951 13.4903 11.3497 13.4266 11.3131C13.0696 11.1089 12.6847 11.1246 12.3653 11.3969C12.3112 11.4431 12.2589 11.4963 12.2091 11.5574C12.1594 11.6185 12.1183 11.6787 12.0843 11.7398C11.8801 12.1064 11.942 12.4869 12.2135 12.7967C12.2615 12.8517 12.3156 12.9041 12.3767 12.9538C12.4378 13.0035 12.4945 13.0428 12.5556 13.0777C12.9117 13.2837 13.2974 13.268 13.6177 12.9931H13.6186Z",
                fill: "#292A2E"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M9.3788 15.3765L9.40586 15.449H10.9523L10.9209 15.3119C10.7446 14.5439 10.3283 13.844 9.74535 13.3291L8.68848 14.4279C8.99829 14.674 9.23655 14.9995 9.3788 15.3765Z",
                fill: "#292A2E"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M14.6342 9.4961L14.3235 8.57275L13.4351 9.4961H14.6342Z",
                fill: "#292A2E"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M9.68084 8.91065L8.87305 10.5713L10.5337 11.3791L11.3415 9.71844L9.68084 8.91065Z",
                fill: "#FCA700"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M2.55684 10.4918C2.52717 10.4718 2.49924 10.4726 2.48004 10.4752C2.46084 10.4787 2.45037 10.4883 2.44601 10.5014C2.43728 10.5285 2.45561 10.5599 2.49051 10.5896C2.54113 10.6323 2.57255 10.6934 2.59786 10.7763C2.62491 10.8592 2.63888 10.9605 2.69648 11.0818C2.72964 11.1499 2.77764 11.2014 2.8239 11.2345C2.8719 11.2686 2.91641 11.2834 2.95742 11.2947C3.03946 11.3148 3.12062 11.3104 3.2175 11.2764C3.37982 11.2153 3.52557 11.0539 3.66346 11.0259C3.72804 11.0111 3.79001 11.0294 3.83277 11.0565C3.87291 11.0835 3.89648 11.1115 3.90608 11.1324C3.91306 11.1438 3.92004 11.1542 3.92702 11.1673C3.94011 11.1883 3.96106 11.2336 3.98462 11.3052C4.00993 11.3759 4.03088 11.4763 4.09982 11.5897C4.13473 11.6464 4.19059 11.6997 4.25691 11.7355C4.32324 11.7686 4.3983 11.787 4.47771 11.7843C4.55713 11.7782 4.62957 11.7486 4.68979 11.7136C4.75088 11.6787 4.80062 11.6395 4.8495 11.6046C4.9839 11.4998 5.07815 11.4675 5.15582 11.492C5.23611 11.512 5.27539 11.5548 5.29808 11.5897C5.35393 11.6744 5.3775 11.7878 5.41851 11.8908C5.45517 11.9938 5.52324 12.1029 5.6271 12.1552C5.6847 12.1823 5.72048 12.1666 5.72746 12.1456C5.73531 12.1221 5.71873 12.0924 5.68295 12.0662C5.61924 12.0147 5.58433 11.9406 5.55815 11.8437C5.52848 11.7494 5.51626 11.6307 5.43335 11.499C5.40281 11.4501 5.33561 11.3646 5.21255 11.3253C5.15321 11.3035 5.07466 11.2965 4.99524 11.3139C4.91495 11.3314 4.84426 11.3742 4.77968 11.4178C4.73691 11.4475 4.70026 11.478 4.66535 11.5077C4.62782 11.54 4.58942 11.567 4.55015 11.588C4.51088 11.6054 4.47161 11.6176 4.43146 11.6142C4.41139 11.6142 4.39044 11.608 4.37037 11.6037C4.35204 11.5941 4.33022 11.5915 4.31539 11.5784C4.28048 11.56 4.25779 11.5286 4.2351 11.4981C4.19495 11.4318 4.17575 11.355 4.15917 11.3017C4.14346 11.2467 4.13299 11.2127 4.13299 11.2127C4.13299 11.2127 4.12862 11.2005 4.12164 11.1778C4.11204 11.1542 4.1007 11.1211 4.07801 11.08C4.05706 11.039 4.02215 10.9902 3.97066 10.9491C3.9183 10.9072 3.85197 10.8802 3.77953 10.8671C3.70448 10.8566 3.62331 10.8697 3.55611 10.9003C3.48717 10.9299 3.43306 10.971 3.38157 11.0076C3.28208 11.0844 3.19655 11.1411 3.13197 11.156C3.03684 11.176 2.95917 11.1411 2.91902 11.1088C2.87801 11.0739 2.85706 11.0382 2.84222 11.0094C2.79859 10.9212 2.77677 10.8191 2.74011 10.7266C2.70433 10.6341 2.64499 10.5416 2.55684 10.4927V10.4918Z",
                fill: "#292A2E"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M8.03289 2.23406C8.01543 2.20352 7.99012 2.19043 7.97267 2.18432C7.95434 2.17908 7.9395 2.18257 7.93078 2.19217C7.9107 2.21224 7.91245 2.2489 7.93078 2.29079C7.95609 2.35188 7.95609 2.42083 7.94125 2.50635C7.92729 2.59275 7.89412 2.68875 7.88976 2.82315C7.88801 2.89821 7.90721 2.96715 7.93339 3.01777C7.96045 3.07014 7.99361 3.1033 8.02503 3.1321C8.08961 3.18708 8.16292 3.22112 8.26416 3.23421C8.43609 3.25341 8.63943 3.17574 8.77558 3.21414C8.84016 3.23072 8.88641 3.27523 8.9126 3.31886C8.93616 3.36163 8.94401 3.39654 8.94314 3.4201C8.94401 3.43319 8.94576 3.44628 8.94576 3.46024C8.94838 3.48468 8.94576 3.5353 8.93354 3.60948C8.92394 3.68454 8.89601 3.78315 8.90649 3.91494C8.91172 3.98126 8.9379 4.0537 8.97979 4.11566C9.0243 4.17588 9.0819 4.22563 9.15434 4.25966C9.22852 4.29021 9.3062 4.29719 9.37514 4.2937C9.44583 4.29021 9.5078 4.27799 9.56714 4.27014C9.73383 4.23872 9.83332 4.25268 9.89092 4.31028C9.95376 4.36439 9.9686 4.42024 9.97296 4.46214C9.9843 4.5625 9.95376 4.67421 9.94329 4.78504C9.92932 4.89326 9.9398 5.02155 10.0087 5.11581C10.0471 5.16555 10.0873 5.16904 10.1021 5.15246C10.1196 5.13501 10.1187 5.10097 10.0986 5.0617C10.0646 4.98664 10.0681 4.90461 10.089 4.80686C10.1056 4.70912 10.1493 4.59828 10.1353 4.44294C10.1309 4.38621 10.11 4.27886 10.0183 4.1881C9.97558 4.14184 9.90838 4.09995 9.82983 4.07901C9.75041 4.05806 9.66838 4.0633 9.58983 4.07377C9.53834 4.08075 9.49121 4.09123 9.4467 4.1017C9.3987 4.11304 9.35245 4.12003 9.30794 4.1209C9.26518 4.11828 9.22503 4.1113 9.19012 4.09035C9.17267 4.08075 9.15696 4.06592 9.14125 4.05283C9.1299 4.03624 9.1107 4.02315 9.10372 4.00483C9.08103 3.97254 9.07492 3.93414 9.06881 3.89661C9.06358 3.81894 9.08016 3.74214 9.09063 3.68715C9.10198 3.6313 9.10809 3.59552 9.10809 3.59552C9.10809 3.59552 9.10983 3.58243 9.11332 3.55886C9.11507 3.53355 9.12118 3.49952 9.11943 3.45239C9.11943 3.40614 9.1107 3.34679 9.08365 3.28657C9.0566 3.22548 9.00947 3.17137 8.951 3.12599C8.88903 3.08235 8.81049 3.05704 8.7363 3.05355C8.66125 3.04832 8.59405 3.06054 8.53209 3.07014C8.40816 3.09283 8.30692 3.10504 8.24234 3.08934C8.14896 3.06403 8.09572 2.9977 8.0739 2.9497C8.05296 2.89908 8.05034 2.85894 8.05121 2.82577C8.05209 2.72715 8.08001 2.62679 8.08874 2.5273C8.09921 2.42868 8.08874 2.31872 8.03201 2.23581L8.03289 2.23406Z",
                fill: "#292A2E"
            })
        ]
    });
};
var $24c02ea0e14dbe4f$var$$bde17c0708419ffe$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$var$$bde17c0708419ffe$var$CompletedIcon;
const $24c02ea0e14dbe4f$var$$b16d92af3081158f$var$QuestionIcon = ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM14.8284 7.15997C15.3505 7.67945 15.7181 8.3338 15.89 9.04999C16.1223 10.008 15.9918 11.0181 15.5235 11.8856C15.0552 12.7531 14.2824 13.4165 13.354 13.748C13.149 13.821 13.004 14.003 13.004 14.22V15.002C13.004 15.2677 12.8984 15.5226 12.7105 15.7105C12.5226 15.8984 12.2677 16.004 12.002 16.004C11.7363 16.004 11.4814 15.8984 11.2935 15.7105C11.1056 15.5226 11 15.2677 11 15.002V12.988C11.0034 12.725 11.1103 12.474 11.2975 12.2893C11.4846 12.1046 11.7369 12.001 11.9998 12.001H11.993C13.098 12.001 13.996 11.103 13.996 10.001C13.984 9.47739 13.7676 8.97927 13.3929 8.61327C13.0183 8.24727 12.5153 8.04248 11.9915 8.04275C11.4678 8.04301 10.9649 8.2483 10.5907 8.61467C10.2164 8.98104 10.0004 9.47937 9.989 10.003C9.987 10.554 9.539 11.001 8.987 11.001C8.74019 10.9995 8.50281 10.906 8.32123 10.7388C8.13964 10.5717 8.02689 10.3428 8.005 10.097L8 9.94999C8.017 7.44599 10.321 5.51399 12.933 6.10799C13.6501 6.27628 14.3063 6.64048 14.8284 7.15997ZM13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18Z",
            fill: "#44546F"
        })
    });
var $24c02ea0e14dbe4f$var$$b16d92af3081158f$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$var$$b16d92af3081158f$var$QuestionIcon;
const $24c02ea0e14dbe4f$var$$c68bccd399b510db$var$STATUS_LABELS = {
    [$24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED]: "Not started",
    [$24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED]: "Complete!"
};
const $24c02ea0e14dbe4f$var$$c68bccd399b510db$export$cee724c49a9ffe54 = ({ isRetired: isRetired, progress: progress, status: status })=>{
    if (isRetired) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$71f050e2efa708bb, {
        size: "medium",
        fontWeight: "semibold",
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
            css: $24c02ea0e14dbe4f$var$$c68bccd399b510db$var$progressStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    children: "Retired content"
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$b16d92af3081158f$export$2e2bcd8739ae039, {})
            ]
        })
    });
    if (status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED) return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$71f050e2efa708bb, {
                size: "medium",
                fontWeight: "semibold",
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    css: (0, $74Zh5.css)({
                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle")
                    }),
                    children: $24c02ea0e14dbe4f$var$$c68bccd399b510db$var$STATUS_LABELS[$24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED]
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$c17561cb55d4db30, {
                progress: 0
            })
        ]
    });
    if (status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$71f050e2efa708bb, {
        size: "medium",
        fontWeight: "semibold",
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
            css: $24c02ea0e14dbe4f$var$$c68bccd399b510db$var$progressStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    children: "Progress"
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    css: (0, $74Zh5.css)({
                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.accent.lime")
                    }),
                    children: $24c02ea0e14dbe4f$var$$c68bccd399b510db$var$STATUS_LABELS[$24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED]
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$bde17c0708419ffe$export$2e2bcd8739ae039, {})
            ]
        })
    });
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$71f050e2efa708bb, {
                size: "medium",
                fontWeight: "semibold",
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
                    css: $24c02ea0e14dbe4f$var$$c68bccd399b510db$var$progressStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            children: "Progress"
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
                            css: (0, $74Zh5.css)({
                                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle")
                            }),
                            children: [
                                progress,
                                "%"
                            ]
                        })
                    ]
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$c17561cb55d4db30, {
                progress: progress,
                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.accent.lime")
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$c68bccd399b510db$var$progressStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$e9cd1e314d8acc99$export$aa140c19feb5d492 = ({ title: title, href: href, isRetired: isRetired = false, onTitleClick: onTitleClick })=>{
    const handleClick = (e)=>{
        if (onTitleClick) {
            e.preventDefault();
            onTitleClick();
        }
    };
    const handleKeyboardClick = (0, $5FkrB.useCallback)(()=>{
        if (onTitleClick) onTitleClick();
    }, [
        onTitleClick
    ]);
    const onKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleKeyboardClick);
    if (isRetired) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        role: "button",
        tabIndex: 0,
        css: $24c02ea0e14dbe4f$var$$e9cd1e314d8acc99$var$titleContainerStyles,
        onClick: handleClick,
        onKeyDown: onKeyDown,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
            level: 4,
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
            children: title
        })
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$e9cd1e314d8acc99$var$titleContainerStyles,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a6c7ac8248d6e38a, {
            label: title,
            link: href || "#",
            size: $24c02ea0e14dbe4f$export$be4c932f76c19adf.EXTRA_LARGE,
            style: $24c02ea0e14dbe4f$export$2b77966d73aefa77.SEMIBOLD,
            icon: "arrow-right-small",
            onClick: handleClick
        })
    });
};
const $24c02ea0e14dbe4f$var$$e9cd1e314d8acc99$var$titleContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    "& *": {
        fontFamily: "Charlie Display, sans-serif"
    },
    "& a:hover": {
        textDecoration: "none"
    },
    "& a span:last-of-type": {
        verticalAlign: "text-bottom"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        "& a span:last-of-type": {
            verticalAlign: "bottom"
        }
    }
});
const $24c02ea0e14dbe4f$export$60e8035fadc9b8fc = ({ course: course, lessons: lessons, onLessonClick: onLessonClick, progress: progress, type: type, isSaved: isSaved, isRetired: isRetired, onSave: onSave, tags: tags, status: status, onDownloadPdf: onDownloadPdf, additionalActions: additionalActions, completionBadgeUrl: completionBadgeUrl, dropdownItems: dropdownItems, onTitleClick: onTitleClick, showSaveButton: showSaveButton = true })=>{
    const typeText = (0, $5FkrB.useMemo)(()=>{
        switch(type){
            case $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.COURSE:
                return "Course";
            case $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.LESSON:
                return "Lesson";
            default:
                return "Learning Path";
        }
    }, [
        type
    ]);
    const getBackgroundColor = (0, $5FkrB.useMemo)(()=>{
        if (isRetired) return "#8C8F97"; // neutral 500
        switch(type){
            case $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.COURSE:
                return "#357DE8"; // blue 600
            case $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.LESSON:
                return "#FCA700"; // yellow 400
            default:
                return "#6A9A23"; // lime 600
        }
    }, [
        isRetired,
        type
    ]);
    const expandableTextLabels = (0, $5FkrB.useMemo)(()=>{
        switch(type){
            case $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.COURSE:
                return {
                    expandButtonText: "Show lessons",
                    collapseButtonText: "Hide lessons"
                };
            default:
                return {
                    expandButtonText: "Show courses",
                    collapseButtonText: "Hide courses"
                };
        }
    }, [
        type
    ]);
    const handleSave = ()=>{
        onSave?.(!isSaved);
    };
    const showCourseList = !isRetired && lessons.length > 0;
    const isCompleted = progress === 100;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$8340d81aba797956$var$containerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$8340d81aba797956$var$topControlsStyles,
                style: {
                    backgroundColor: getBackgroundColor
                },
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: (0, $74Zh5.css)({
                            flexShrink: 0
                        }),
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$71f050e2efa708bb, {
                            size: "medium",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"),
                            fontWeight: "semibold",
                            children: typeText
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$8340d81aba797956$var$headerImageStyles,
                        style: {
                            backgroundImage: `url(${$24c02ea0e14dbe4f$var$$8f97e278a4a2a6b3$export$cdb81064101cb20c})`
                        }
                    }),
                    isCompleted && completionBadgeUrl && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$8340d81aba797956$var$badgeOuterContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$8340d81aba797956$var$badgeInnerContainerStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3e431a229df88919, {
                                src: completionBadgeUrl,
                                alt: "Completion Badge",
                                width: 48,
                                height: 48
                            })
                        })
                    }),
                    showSaveButton && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$dd09d7da2da4d16f, {
                        icon: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: isSaved ? "bookmark-narrow-filled" : "bookmark-narrow",
                            color: "#FFFFFF"
                        }),
                        ariaLabel: isSaved ? "Saved" : "Save",
                        onClick: handleSave,
                        selected: isSaved
                    }),
                    Boolean(dropdownItems?.length) && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$ef4a0fdddd7eccb7, {
                        items: dropdownItems,
                        isInverted: true
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$8340d81aba797956$var$contentStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$8340d81aba797956$var$leftColumnStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$8340d81aba797956$var$tagsContainerStyles,
                                children: tags.map((tag)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                                        label: tag.label
                                    }, tag.label))
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$e9cd1e314d8acc99$export$aa140c19feb5d492, {
                                title: course.title,
                                href: course.href,
                                isRetired: isRetired,
                                onTitleClick: onTitleClick
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$8340d81aba797956$var$rightColumnStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$c68bccd399b510db$export$cee724c49a9ffe54, {
                            isRetired: isRetired,
                            progress: progress,
                            status: status
                        })
                    })
                ]
            }),
            (onDownloadPdf || additionalActions) && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$8340d81aba797956$var$completionActionsStyles,
                children: [
                    onDownloadPdf && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$0fd79bc510e2fa30$export$b7c3a2f69225ecf, {
                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.DEFAULT,
                        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($exnso))),
                        onClick: onDownloadPdf,
                        children: "Download completion pdf"
                    }),
                    additionalActions
                ]
            }),
            showCourseList && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$7586a58445419b5a$export$2c3faa04d4773275, {
                lessons: lessons,
                onLessonClick: onLessonClick,
                expandButtonText: expandableTextLabels.expandButtonText,
                collapseButtonText: expandableTextLabels.collapseButtonText,
                containerStyles: $24c02ea0e14dbe4f$var$$8340d81aba797956$var$expandableLessonsListContainerStyles,
                buttonContainerStyles: $24c02ea0e14dbe4f$var$$8340d81aba797956$var$expandableLessonsListButtonContainerStyles
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$8340d81aba797956$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    borderRadius: "8px",
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    overflow: "hidden"
});
const $24c02ea0e14dbe4f$var$$8340d81aba797956$var$topControlsStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: `0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250")}`
});
const $24c02ea0e14dbe4f$var$$8340d81aba797956$var$contentStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250"),
    flexWrap: "wrap",
    rowGap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400")
});
const $24c02ea0e14dbe4f$var$$8340d81aba797956$var$leftColumnStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
});
const $24c02ea0e14dbe4f$var$$8340d81aba797956$var$rightColumnStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    minWidth: "234px",
    alignSelf: "flex-end"
});
const $24c02ea0e14dbe4f$var$$8340d81aba797956$var$tagsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$8340d81aba797956$var$expandableLessonsListContainerStyles = (0, $74Zh5.css)({
    border: "none",
    borderRadius: "0"
});
const $24c02ea0e14dbe4f$var$$8340d81aba797956$var$expandableLessonsListButtonContainerStyles = (0, $74Zh5.css)({
    paddingLeft: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250")} !important`
});
const $24c02ea0e14dbe4f$var$$8340d81aba797956$var$headerImageStyles = (0, $74Zh5.css)({
    display: "flex",
    flexGrow: 1,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right",
    backgroundSize: "cover",
    minHeight: "48px",
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$8340d81aba797956$var$completionActionsStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} 0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250")}`
});
const $24c02ea0e14dbe4f$var$$8340d81aba797956$var$badgeOuterContainerStyles = (0, $74Zh5.css)({
    position: "relative",
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    width: "72px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$8340d81aba797956$var$badgeInnerContainerStyles = (0, $74Zh5.css)({
    position: "absolute",
    top: 0,
    right: 0,
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "50%",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    transform: "translateY(-25%)"
});
var $24c02ea0e14dbe4f$var$$dbb9d5792c296a49$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$dbb9d5792c296a49$exports, "SubmitFeedback", ()=>$24c02ea0e14dbe4f$export$f6dc54b55657f29f);
const $24c02ea0e14dbe4f$export$f6dc54b55657f29f = ({ onSubmit: onSubmit, onChange: onChange, isLoading: isLoading, isSubmitted: isSubmitted, hasError: hasError, opinion: opinion })=>{
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const [isYesSelected, setIsYesSelected] = (0, $5FkrB.useState)(false);
    const [isNoSelected, setIsNoSelected] = (0, $5FkrB.useState)(false);
    const handleChange = (0, $5FkrB.useCallback)((e)=>{
        e.preventDefault();
        if (onChange) onChange(e);
    }, [
        onChange
    ]);
    const handleYes = (0, $5FkrB.useCallback)(()=>{
        setIsOpen(true);
        setIsYesSelected(true);
        setIsNoSelected(false);
    }, []);
    const handleNo = (0, $5FkrB.useCallback)(()=>{
        setIsOpen(true);
        setIsNoSelected(true);
        setIsYesSelected(false);
    }, []);
    const handleCancel = (0, $5FkrB.useCallback)(()=>{
        setIsOpen(false);
        setIsYesSelected(false);
        setIsNoSelected(false);
    }, []);
    const renderButtons = ()=>{
        if (isLoading && !isSubmitted) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $a60eb1e63addc72a$export$2e2bcd8739ae039), {
            appearance: "primary",
            isLoading: true,
            children: "Submit"
        });
        if (isSubmitted) return null;
        return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                    type: "submit",
                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                    label: "Submit",
                    onClick: onSubmit
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.LINK,
                    label: "Cancel",
                    onClick: handleCancel
                })
            ]
        });
    };
    const renderFeedbackBox = ()=>{
        if (!isOpen) return null;
        if (!isSubmitted) return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: {
                label: {
                    fontSize: "13.7143px",
                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest")
                },
                textArea: {
                    borderColor: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")} !important`,
                    "&:focus": {
                        borderColor: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.focused")} !important`
                    }
                }
            },
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                    htmlFor: "area",
                    children: "Send us your opinion"
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $68e53f06a5d0057b$export$2e2bcd8739ae039), {
                    placeholder: "Begin typing in here...",
                    defaultValue: opinion,
                    onChange: handleChange
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $ab642ec49327e475$export$2e2bcd8739ae039), {
                    children: renderButtons()
                })
            ]
        });
        if (!hasError) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
            css: $24c02ea0e14dbe4f$var$$dbb9d5792c296a49$var$feedbackStyles,
            children: "Thanks for your feedback!"
        });
        return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
            css: $24c02ea0e14dbe4f$var$$dbb9d5792c296a49$var$feedbackStyles,
            children: "Error submitting feedback. Try again later."
        });
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            !isSubmitted && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: (0, $74Zh5.css)({
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "10px"
                    }),
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                            css: $24c02ea0e14dbe4f$var$$dbb9d5792c296a49$var$labelStyles,
                            children: "Was this content helpful?"
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: (0, $74Zh5.css)({
                                marginLeft: "1rem",
                                display: "flex"
                            }),
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                    css: (0, $74Zh5.css)({
                                        marginRight: "0.5rem"
                                    }),
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                        label: "Yes",
                                        onClick: handleYes,
                                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                                        disabled: isYesSelected
                                    })
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                    label: "No",
                                    onClick: handleNo,
                                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                                    disabled: isNoSelected
                                })
                            ]
                        })
                    ]
                })
            }),
            renderFeedbackBox()
        ]
    });
};
const $24c02ea0e14dbe4f$var$$dbb9d5792c296a49$var$labelStyles = (0, $74Zh5.css)({
    marginTop: 0,
    marginBottom: 0,
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "1.25rem",
    fontWeight: 600,
    lineHeight: "1.75rem",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
});
const $24c02ea0e14dbe4f$var$$dbb9d5792c296a49$var$feedbackStyles = (0, $74Zh5.css)({
    fontWeight: 600,
    fontSize: "1.125rem",
    lineHeight: "1.5rem",
    width: "13.813rem",
    height: "1.563rem"
});
var $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$44303f6c3c81eeac$exports, "QuestionType", ()=>$24c02ea0e14dbe4f$export$51940fbbacba35d4);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$44303f6c3c81eeac$exports, "QuizStatus", ()=>$24c02ea0e14dbe4f$export$bf1c1ed72daa392b);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$44303f6c3c81eeac$exports, "QuestionStatus", ()=>$24c02ea0e14dbe4f$export$602daccbd963b20);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$44303f6c3c81eeac$exports, "MatchingAnswerStatus", ()=>$24c02ea0e14dbe4f$export$85e3e62cc743c830);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$44303f6c3c81eeac$exports, "ActionDescription", ()=>$24c02ea0e14dbe4f$export$cb9c858407602327);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$44303f6c3c81eeac$exports, "Quiz", ()=>$24c02ea0e14dbe4f$export$76709845c4fea6cd);
let $24c02ea0e14dbe4f$var$$b55544cdfa85935b$export$1bd2035254432789;
(function(InputStatus) {
    InputStatus["CORRECT"] = "CORRECT";
    InputStatus["INCORRECT"] = "INCORRECT";
    InputStatus["SELECTED"] = "SELECTED";
    InputStatus["DEFAULT"] = "DEFAULT";
    InputStatus["DISABLED"] = "DISABLED";
})($24c02ea0e14dbe4f$var$$b55544cdfa85935b$export$1bd2035254432789 || ($24c02ea0e14dbe4f$var$$b55544cdfa85935b$export$1bd2035254432789 = {}));
const $24c02ea0e14dbe4f$var$$b55544cdfa85935b$export$56e6c05354470c53 = ({ inspectMode: inspectMode, text: text, elementId: elementId, inputStatus: inputStatus = $24c02ea0e14dbe4f$var$$b55544cdfa85935b$export$1bd2035254432789.DEFAULT, onClick: onClick })=>{
    // Keep original Space-only handler for outer div (used by tests)
    const handleKeyDown = (0, $5FkrB.useCallback)((event)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onClick && onClick();
        }
    }, [
        onClick
    ]);
    // Use keyboard interaction hook for inner div
    const handleClick = (0, $5FkrB.useCallback)(()=>onClick?.(), [
        onClick
    ]);
    const onKeyDownInner = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleClick);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        onKeyDown: handleKeyDown,
        css: [
            $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputsContainerStyles,
            $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputsVariantStyles[inputStatus]
        ],
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputBorderStyles["DEFAULT"],
                    $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputBorderStyles[inputStatus],
                    $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputsVariantStyles[inputStatus]
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                role: "button",
                tabIndex: 0,
                ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("title", inspectMode),
                id: elementId ? elementId + "-quiz-input" : "",
                css: [
                    $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputsContentStyles,
                    $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputsVariantStyles[inputStatus]
                ],
                onClick: onClick,
                onKeyDown: onKeyDownInner,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputsTextStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e61786c4aee8d415, {
                        children: text
                    })
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputsContainerStyles = (0, $74Zh5.css)({
    width: "50%",
    display: "flex",
    cursor: "pointer",
    borderRadius: "8px",
    boxShadow: "0px 1px 1px 0px rgba(9, 30, 66, 0.25), 0px 0px 1px 0px rgba(9, 30, 66, 0.31)",
    justifyContent: "center"
});
const $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputsContentStyles = (0, $74Zh5.css)({
    maxWidth: "300px",
    width: "100%",
    padding: "16px",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    border: "1px solid rgba(9, 30, 66, 0.14)",
    borderLeft: "none",
    borderRadius: "0 8px 8px 0"
});
const $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputsTextStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    lineHeight: "24px",
    width: "100%",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        fontSize: "14px",
        lineHeight: "20px"
    }
});
const $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputBorderStyles = {
    DEFAULT: (0, $74Zh5.css)({
        maxHeight: "100%",
        width: "8px",
        borderRadius: "8px 0 0 8px",
        border: "1px solid rgba(9, 30, 66, 0.14)",
        borderRight: "none",
        backgroundColor: (0, $54ca2d3948378259$export$29a4f05edc054374),
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
            width: "4px"
        }
    }),
    CORRECT: (0, $74Zh5.css)({
        backgroundColor: "#22A06B",
        border: "1px solid #22A06B"
    }),
    INCORRECT: (0, $74Zh5.css)({
        backgroundColor: "#E2483D",
        border: "1px solid #E2483D"
    }),
    SELECTED: (0, $74Zh5.css)({
        backgroundColor: "#0C66E4",
        border: "1px solid #0C66E4"
    })
};
const $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputsVariantStyles = {
    DEFAULT: (0, $74Zh5.css)({
        color: "#000000",
        backgroundColor: (0, $54ca2d3948378259$export$29a4f05edc054374),
        fontWeight: 400
    }),
    CORRECT: (0, $74Zh5.css)({
        fontWeight: 700
    }),
    INCORRECT: (0, $74Zh5.css)({
        fontWeight: 700
    }),
    SELECTED: (0, $74Zh5.css)({
        fontWeight: 700
    }),
    DISABLED: (0, $74Zh5.css)({
        color: "#626F86",
        fontWeight: 400,
        backgroundColor: "#F7F8F9",
        border: "1px solid #F7F8F9",
        boxShadow: "none",
        transition: "all",
        transitionDuration: "500ms",
        transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
        pointerEvents: "none"
    })
};
let $24c02ea0e14dbe4f$export$51940fbbacba35d4;
(function(QuestionType) {
    QuestionType["SINGLE_SELECT"] = "SINGLE_SELECT";
    QuestionType["MULTI_SELECT"] = "MULTI_SELECT";
    QuestionType["MATCHING"] = "MATCHING";
})($24c02ea0e14dbe4f$export$51940fbbacba35d4 || ($24c02ea0e14dbe4f$export$51940fbbacba35d4 = {}));
let $24c02ea0e14dbe4f$export$bf1c1ed72daa392b;
(function(QuizStatus) {
    QuizStatus["DEFAULT"] = "DEFAULT";
    QuizStatus["ERROR"] = "ERROR";
    QuizStatus["PARTLY_CORRECT"] = "PARTLY_CORRECT";
    QuizStatus["SUCCESS"] = "SUCCESS";
})($24c02ea0e14dbe4f$export$bf1c1ed72daa392b || ($24c02ea0e14dbe4f$export$bf1c1ed72daa392b = {}));
let $24c02ea0e14dbe4f$export$602daccbd963b20;
(function(QuestionStatus) {
    QuestionStatus["INCORRECT"] = "INCORRECT";
    QuestionStatus["PARTLY_CORRECT"] = "PARTLY_CORRECT";
    QuestionStatus["CORRECT"] = "CORRECT";
})($24c02ea0e14dbe4f$export$602daccbd963b20 || ($24c02ea0e14dbe4f$export$602daccbd963b20 = {}));
let $24c02ea0e14dbe4f$export$85e3e62cc743c830;
(function(MatchingAnswerStatus) {
    MatchingAnswerStatus["DEFAULT"] = "DEFAULT";
    MatchingAnswerStatus["INCORRECT"] = "INCORRECT";
    MatchingAnswerStatus["CORRECT"] = "CORRECT";
})($24c02ea0e14dbe4f$export$85e3e62cc743c830 || ($24c02ea0e14dbe4f$export$85e3e62cc743c830 = {}));
let $24c02ea0e14dbe4f$export$cb9c858407602327;
(function(ActionDescription) {
    ActionDescription["SINGLE_SELECT"] = "Select the correct answer.";
    ActionDescription["MULTI_SELECT"] = "Select all correct responses.";
    ActionDescription["MATCHING"] = "Select the matching pairs.";
})($24c02ea0e14dbe4f$export$cb9c858407602327 || ($24c02ea0e14dbe4f$export$cb9c858407602327 = {}));
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$QuizStatusToCheckboxType = {
    [$24c02ea0e14dbe4f$export$bf1c1ed72daa392b.DEFAULT]: "DEFAULT",
    [$24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS]: "SUCCESS",
    [$24c02ea0e14dbe4f$export$bf1c1ed72daa392b.ERROR]: "DANGER",
    [$24c02ea0e14dbe4f$export$bf1c1ed72daa392b.PARTLY_CORRECT]: "DANGER"
};
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$QuizStatusToRadioType = {
    [$24c02ea0e14dbe4f$export$bf1c1ed72daa392b.DEFAULT]: "DEFAULT",
    [$24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS]: "SUCCESS",
    [$24c02ea0e14dbe4f$export$bf1c1ed72daa392b.ERROR]: "DANGER",
    [$24c02ea0e14dbe4f$export$bf1c1ed72daa392b.PARTLY_CORRECT]: "DANGER"
};
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$MOBILE_SCREEN_WIDTH = 480;
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$NAVBAR_HEIGHT = 136;
const $24c02ea0e14dbe4f$export$76709845c4fea6cd = ({ inspectMode: inspectMode, title: title, questions: questions = [], onCompletion: onCompletion, step: step = 0, setStep: setStep, onInteraction: onInteraction, isCompleted: isCompleted = false, setIsCompleted: setIsCompleted, isLoggedInUser: isLoggedInUser, handleUserLogin: handleUserLogin, lessonId: lessonId, onAnswerSubmit: onAnswerSubmit })=>{
    const [questionAnswers, setQuestionAnswers] = (0, $5FkrB.useState)([]);
    const [selectedAnswers, setSelectedAnswers] = (0, $5FkrB.useState)([]);
    const [status, setStatus] = (0, $5FkrB.useState)($24c02ea0e14dbe4f$export$bf1c1ed72daa392b.DEFAULT);
    const [answersStatus, setAnswersStatus] = (0, $5FkrB.useState)({});
    const [matchingAnswersStatus, setMatchingAnswersStatus] = (0, $5FkrB.useState)($24c02ea0e14dbe4f$export$85e3e62cc743c830.DEFAULT);
    const [correctAnswersArray, setCorrectAnswersArray] = (0, $5FkrB.useState)([]);
    const [incorrectAnswersArray, setIncorrectAnswersArray] = (0, $5FkrB.useState)([]);
    const [lastSubmittedQuestion, setLastSubmittedQuestion] = (0, $5FkrB.useState)({
        lessonId: "",
        step: 0
    });
    const width = $24c02ea0e14dbe4f$export$4616d33c54ae5baf();
    const isNextButtonDisabled = step + 1 !== questions.length ? !isCompleted && status !== $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS : true;
    const isMatchingFeedbackVisible = questions[step]?.type === $24c02ea0e14dbe4f$export$51940fbbacba35d4.MATCHING && matchingAnswersStatus === $24c02ea0e14dbe4f$export$85e3e62cc743c830.CORRECT && !isCompleted;
    (0, $5FkrB.useEffect)(()=>{
        if (lastSubmittedQuestion.lessonId !== lessonId) setLastSubmittedQuestion({
            lessonId: lessonId,
            step: 0
        });
        if (isCompleted && lessonId && questions.length) {
            setStatus($24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS);
            onSubmittedQuestionsRecheck(questions.length - 1);
        } else {
            setStatus($24c02ea0e14dbe4f$export$bf1c1ed72daa392b.DEFAULT);
            setSelectedAnswers([]);
        }
    // lastSubmittedQuestion.lessonId, onSubmittedQuestionsRecheck, questions.length intentionally excluded
    /* eslint-disable react-hooks/exhaustive-deps */ }, [
        lessonId,
        isCompleted
    ]);
    (0, $5FkrB.useEffect)(()=>{
        setLastSubmittedQuestion((prevState)=>{
            if (prevState.lessonId === lessonId && !prevState.step) return {
                ...prevState,
                step: step
            };
            return {
                ...prevState
            };
        });
    }, [
        step,
        lastSubmittedQuestion.lessonId
    ]);
    (0, $5FkrB.useEffect)(()=>{
        checkMatchingQuestionCompleted();
    }, [
        correctAnswersArray
    ]);
    (0, $5FkrB.useEffect)(()=>{
        const isLastCompletedQuestion = status === $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS && lastSubmittedQuestion.step === questions.length;
        if (questions.length && !isLastCompletedQuestion) setQuestionAnswers(questions[step]?.answers);
    }, [
        step,
        questions
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ const handleOnAnswerSubmit = (type, status)=>{
        if (onAnswerSubmit) onAnswerSubmit(type, status);
    };
    const toggleAnswer = (answer)=>{
        onInteraction();
        if (status !== $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.DEFAULT) return;
        if (questions[step]?.type === $24c02ea0e14dbe4f$export$51940fbbacba35d4.SINGLE_SELECT) setSelectedAnswers([
            answer
        ]);
        if (questions[step]?.type === $24c02ea0e14dbe4f$export$51940fbbacba35d4.MULTI_SELECT) {
            if (selectedAnswers.includes(answer)) setSelectedAnswers((a)=>a.filter((ans)=>ans !== answer));
            else setSelectedAnswers((a)=>[
                    ...a,
                    answer
                ]);
        }
        if (questions[step]?.type === $24c02ea0e14dbe4f$export$51940fbbacba35d4.MATCHING) {
            if (isLoggedInUser) toggleMatchingQuestion(answer);
            else handleUserLogin();
        }
    };
    const toggleMatchingQuestion = (answer)=>{
        if (selectedAnswers.length && selectedAnswers[0].title !== answer.title && selectedAnswers[0].isLeftMatchingAnswer !== answer.isLeftMatchingAnswer) {
            if (selectedAnswers[0].matchingAnswer?.title === answer.title && !correctAnswersArray.includes(answer)) {
                const correctAnswers = [
                    ...selectedAnswers,
                    answer
                ];
                handleOnAnswerSubmit($24c02ea0e14dbe4f$export$51940fbbacba35d4.MATCHING, $24c02ea0e14dbe4f$export$602daccbd963b20.CORRECT);
                setMatchingAnswersStatus($24c02ea0e14dbe4f$export$85e3e62cc743c830.CORRECT);
                setSelectedAnswers([
                    ...correctAnswers
                ]);
                setCorrectAnswersArray((a)=>[
                        ...a,
                        ...correctAnswers
                    ]);
                setTimeout(()=>{
                    setSelectedAnswers([]);
                    setMatchingAnswersStatus($24c02ea0e14dbe4f$export$85e3e62cc743c830.DEFAULT);
                }, 500);
            } else {
                const incorrectAnswers = [
                    ...selectedAnswers,
                    answer
                ];
                handleOnAnswerSubmit($24c02ea0e14dbe4f$export$51940fbbacba35d4.MATCHING, $24c02ea0e14dbe4f$export$602daccbd963b20.INCORRECT);
                setMatchingAnswersStatus($24c02ea0e14dbe4f$export$85e3e62cc743c830.INCORRECT);
                setSelectedAnswers([
                    ...incorrectAnswers
                ]);
                setIncorrectAnswersArray((a)=>[
                        ...a,
                        ...incorrectAnswers
                    ]);
                setTimeout(()=>{
                    setSelectedAnswers([]);
                    setMatchingAnswersStatus($24c02ea0e14dbe4f$export$85e3e62cc743c830.DEFAULT);
                }, 500);
            }
        } else {
            setSelectedAnswers([
                answer
            ]);
            setIncorrectAnswersArray([]);
        }
    };
    const checkMatchingQuestionCompleted = ()=>{
        const currentQuestion = questions[step];
        if (!currentQuestion?.leftAnswers || !currentQuestion?.rightAnswers) return;
        const leftAnswers = currentQuestion.leftAnswers;
        const rightAnswers = currentQuestion.rightAnswers;
        if (correctAnswersArray.length === leftAnswers.length + rightAnswers.length) {
            setStatus($24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS);
            setLastSubmittedQuestion((prevState)=>{
                return {
                    ...prevState,
                    step: step + 1
                };
            });
            const questionOnCompletion = questions[step]?.onCompletion;
            if (questionOnCompletion) questionOnCompletion();
            if (onCompletion && step + 1 === questions.length) {
                onCompletion();
                setIsCompleted(true);
            }
        }
    };
    const handleAnswerSubmit = ()=>{
        if (isLoggedInUser) onSubmit();
        else handleUserLogin();
    };
    const onSubmit = ()=>{
        const answers = questions[step]?.answers;
        const correctAnswers = answers.filter((ans)=>ans.correct);
        const totalSteps = questions.length;
        const questionOnCompletion = questions[step]?.onCompletion;
        const atLeastOneCorrectAnswer = !!correctAnswers.filter((ans)=>selectedAnswers.includes(ans)).length;
        if (correctAnswers.length === selectedAnswers.length && correctAnswers.every((ans)=>selectedAnswers.includes(ans))) {
            if (step + 1 === totalSteps) {
                /** completed quiz */ setIsCompleted(true);
                if (questionOnCompletion) questionOnCompletion();
                if (onCompletion) onCompletion();
            } else /** unfinished quiz */ if (questionOnCompletion) questionOnCompletion();
            setStatus($24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS);
            handleOnAnswerSubmit(questions[step]?.type, $24c02ea0e14dbe4f$export$602daccbd963b20.CORRECT);
            setLastSubmittedQuestion((prevState)=>{
                return {
                    ...prevState,
                    step: step + 1
                };
            });
        } else if (atLeastOneCorrectAnswer) {
            setStatus($24c02ea0e14dbe4f$export$bf1c1ed72daa392b.PARTLY_CORRECT);
            handleOnAnswerSubmit(questions[step]?.type, $24c02ea0e14dbe4f$export$602daccbd963b20.PARTLY_CORRECT);
        } else {
            setStatus($24c02ea0e14dbe4f$export$bf1c1ed72daa392b.ERROR);
            handleOnAnswerSubmit(questions[step]?.type, $24c02ea0e14dbe4f$export$602daccbd963b20.INCORRECT);
        }
        setAnswersStatus(selectedAnswers.reduce((prev, curr)=>({
                ...prev,
                [curr.title]: answers.find((a)=>a.title === curr.title)?.correct ? $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS : $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.ERROR
            }), {}));
    };
    const onTryAgain = ()=>{
        const element = document.getElementById("quiz");
        if (element) {
            const topPosition = element.getBoundingClientRect().top + window.scrollY - $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$NAVBAR_HEIGHT;
            window.scrollTo({
                top: topPosition,
                behavior: "smooth"
            });
        }
        setStatus($24c02ea0e14dbe4f$export$bf1c1ed72daa392b.DEFAULT);
        setSelectedAnswers([]);
        setAnswersStatus({});
        setQuestionAnswers((prevState)=>(0, (/*@__PURE__*/$parcel$interopDefault($336d3dfe62d84a74$exports)))(prevState));
    };
    const onSubmittedQuestionsRecheck = (step)=>{
        const prevQuestionAnswers = questions[step].answers;
        const correctAnswers = prevQuestionAnswers.filter((answer)=>answer.correct);
        setStep(step);
        setStatus($24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS);
        setSelectedAnswers(correctAnswers);
        setAnswersStatus(correctAnswers.reduce((prev, curr)=>({
                ...prev,
                [curr.title]: questions[step].answers.find((a)=>a.title === curr.title)?.correct ? $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS : $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.ERROR
            }), {}));
    };
    const onNextQuestionClick = ()=>{
        const nextQuestionStep = step + 1;
        const element = document.getElementById("quiz");
        if (element) {
            const topPosition = element.getBoundingClientRect().top + window.scrollY - $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$NAVBAR_HEIGHT;
            window.scrollTo({
                top: topPosition,
                behavior: "smooth"
            });
        }
        if (nextQuestionStep < lastSubmittedQuestion.step || isCompleted) onSubmittedQuestionsRecheck(step + 1);
        else {
            setStatus($24c02ea0e14dbe4f$export$bf1c1ed72daa392b.DEFAULT);
            setSelectedAnswers([]);
            setCorrectAnswersArray([]);
            setStep(step + 1);
            setAnswersStatus({});
        }
    };
    const onPrevQuestionClick = ()=>{
        onInteraction();
        onSubmittedQuestionsRecheck(step - 1);
    };
    const getQuizProgress = ()=>{
        const progress = isCompleted ? questions.length : lastSubmittedQuestion.step;
        return progress / questions.length * 100;
    };
    const getInputStatus = (answer)=>{
        if (correctAnswersArray.includes(answer) && selectedAnswers.includes(answer)) return $24c02ea0e14dbe4f$var$$b55544cdfa85935b$export$1bd2035254432789.CORRECT;
        if (incorrectAnswersArray.includes(answer) && selectedAnswers.includes(answer)) return $24c02ea0e14dbe4f$var$$b55544cdfa85935b$export$1bd2035254432789.INCORRECT;
        if (correctAnswersArray.includes(answer) || status === $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS) return $24c02ea0e14dbe4f$var$$b55544cdfa85935b$export$1bd2035254432789.DISABLED;
        if (selectedAnswers.includes(answer)) return $24c02ea0e14dbe4f$var$$b55544cdfa85935b$export$1bd2035254432789.SELECTED;
        return $24c02ea0e14dbe4f$var$$b55544cdfa85935b$export$1bd2035254432789.DEFAULT;
    };
    const getAnswerStatus = (answer)=>!!selectedAnswers.find((a)=>a.title === answer.title);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$quizContainerStyles,
        id: "quiz",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("title", inspectMode),
                css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$quizTitleStyles,
                children: title
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$quizContentContainerStyles,
                id: "quiz-question-container",
                "data-testid": "quiz-question-container",
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$quizHeaderContainerStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$quizActionPanelContainerStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                        label: "back-button",
                                        disabled: !step,
                                        iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                            type: "arrow-left-circle"
                                        }),
                                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON,
                                        onClick: onPrevQuestionClick,
                                        iconType: "arrow-left-circle"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
                                        css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$questionsStepStyles,
                                        children: [
                                            "QUESTION ",
                                            step + 1,
                                            " 0F ",
                                            questions.length
                                        ]
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                        css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$desktopScreenProgressContainerStyles,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$c17561cb55d4db30, {
                                            progress: getQuizProgress()
                                        })
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                        label: "next-button",
                                        disabled: isNextButtonDisabled,
                                        iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                            type: "arrow-right-circle"
                                        }),
                                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON,
                                        onClick: onNextQuestionClick,
                                        iconType: "arrow-right-circle"
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$mobileScreenProgressContainerStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$c17561cb55d4db30, {
                                    progress: getQuizProgress()
                                })
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("title", questions[step]?.inspectMode),
                        css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$questionTitleStyles,
                        children: questions[step]?.title
                    }),
                    questions[step] && questions[step].imageUrl && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$questionImageStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3e431a229df88919, {
                            src: questions[step].imageUrl,
                            alt: questions[step]?.title.props.children
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$chooseCorrectAnswerStyles,
                        children: $24c02ea0e14dbe4f$export$cb9c858407602327[questions[step]?.type]
                    }),
                    questions[step]?.type === $24c02ea0e14dbe4f$export$51940fbbacba35d4.MATCHING && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        children: questions[step]?.leftAnswers?.map((leftAnswer, index)=>{
                            const rightAnswer = questions[step]?.rightAnswers?.[index];
                            if (!rightAnswer) return null;
                            return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$quizInputsContainerStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$b55544cdfa85935b$export$56e6c05354470c53, {
                                        inspectMode: leftAnswer?.inspectMode,
                                        elementId: leftAnswer.title,
                                        text: leftAnswer.title,
                                        onClick: ()=>toggleAnswer(leftAnswer),
                                        inputStatus: getInputStatus(leftAnswer)
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$b55544cdfa85935b$export$56e6c05354470c53, {
                                        inspectMode: rightAnswer.inspectMode,
                                        elementId: rightAnswer.title,
                                        text: rightAnswer.title,
                                        onClick: ()=>toggleAnswer(rightAnswer),
                                        inputStatus: getInputStatus(rightAnswer)
                                    })
                                ]
                            }, leftAnswer.title + rightAnswer.title);
                        })
                    }),
                    (questions[step]?.type === $24c02ea0e14dbe4f$export$51940fbbacba35d4.SINGLE_SELECT || questions[step]?.type === $24c02ea0e14dbe4f$export$51940fbbacba35d4.MULTI_SELECT) && questionAnswers?.map((answer)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$answerContainerStyles,
                            ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("title", answer?.inspectMode),
                            children: questions[step]?.type === $24c02ea0e14dbe4f$export$51940fbbacba35d4.SINGLE_SELECT ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$d7b12c4107be0d61, {
                                size: width >= $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$MOBILE_SCREEN_WIDTH ? $24c02ea0e14dbe4f$export$4da24539a3bb7d98.LARGE : $24c02ea0e14dbe4f$export$4da24539a3bb7d98.DEFAULT,
                                label: answer.title,
                                isChecked: getAnswerStatus(answer),
                                setIsChecked: ()=>toggleAnswer(answer),
                                type: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$QuizStatusToRadioType[answersStatus[answer.title]],
                                isBold: getAnswerStatus(answer)
                            }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$48513f6b9f8ce62d, {
                                size: width >= $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$MOBILE_SCREEN_WIDTH ? $24c02ea0e14dbe4f$export$5e435bc8b081a399.LARGE : $24c02ea0e14dbe4f$export$5e435bc8b081a399.DEFAULT,
                                label: answer.title,
                                onChange: ()=>toggleAnswer(answer),
                                isChecked: getAnswerStatus(answer),
                                type: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$QuizStatusToCheckboxType[answersStatus[answer.title]],
                                isBold: getAnswerStatus(answer)
                            })
                        }, answer.title)),
                    !isCompleted && status === $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.DEFAULT && questions[step]?.type !== $24c02ea0e14dbe4f$export$51940fbbacba35d4.MATCHING && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: [
                            $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$buttonContainerStyles,
                            (0, $74Zh5.css)({
                                borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
                                paddingTop: "32px"
                            })
                        ],
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                            label: "Submit answer",
                            appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                            onClick: handleAnswerSubmit,
                            disabled: selectedAnswers.length === 0
                        })
                    }),
                    (status === $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS || questions[step]?.type === $24c02ea0e14dbe4f$export$51940fbbacba35d4.MATCHING) && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$buttonContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: [
                                $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$feedbackContainerStyles,
                                status !== $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS && (0, $74Zh5.css)({
                                    borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`
                                })
                            ],
                            children: [
                                status === $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f23c56ac9ab316f, {
                                    title: questions[step]?.type === $24c02ea0e14dbe4f$export$51940fbbacba35d4.MATCHING ? "Correct" : "That\u2019s correct",
                                    appearance: $24c02ea0e14dbe4f$export$f9292ef28b7b429a.CORRECT,
                                    description: questions[step]?.feedbackMessage
                                }),
                                (!isCompleted || questions[step]?.type === $24c02ea0e14dbe4f$export$51940fbbacba35d4.MATCHING && !isCompleted) && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                    css: (0, $74Zh5.css)({
                                        marginTop: "32px"
                                    }),
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                        disabled: status !== $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS,
                                        label: "Next question",
                                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                                        onClick: onNextQuestionClick,
                                        iconAfter: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                            type: "arrow-right"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    (status === $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.ERROR || status === $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.PARTLY_CORRECT) && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$buttonContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$feedbackContainerStyles,
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f23c56ac9ab316f, {
                                    title: status === $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.PARTLY_CORRECT ? "That\u2019s partly correct" : "That\u2019s not correct",
                                    appearance: $24c02ea0e14dbe4f$export$f9292ef28b7b429a.INCORRECT,
                                    description: questions[step]?.feedbackMessage
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                    css: (0, $74Zh5.css)({
                                        marginTop: "32px"
                                    }),
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                        label: "Try again",
                                        iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                            type: "refresh"
                                        }),
                                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                                        onClick: onTryAgain
                                    })
                                })
                            ]
                        })
                    }),
                    isCompleted && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$completionMessageStyles,
                        children: "\uD83C\uDF89 Quiz complete! Great work."
                    })
                ]
            }),
            isMatchingFeedbackVisible && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$matchingFeedbackContainerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f23c56ac9ab316f, {
                    title: "That\u2019s correct",
                    appearance: $24c02ea0e14dbe4f$export$f9292ef28b7b429a.CORRECT
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$quizContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$quizContentContainerStyles = (0, $74Zh5.css)({
    padding: "32px 48px",
    borderRadius: "8px",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    maxWidth: "720px",
    width: "100%",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        maxWidth: "720px",
        width: "100%"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        padding: "24px 16px"
    }
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$quizHeaderContainerStyles = (0, $74Zh5.css)({
    marginBottom: "32px",
    paddingBottom: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    flexDirection: "row",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        flexDirection: "column"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        marginBottom: "24px",
        paddingBottom: "24px"
    }
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$quizActionPanelContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$quizTitleStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "40px",
    fontWeight: 700,
    lineHeight: "48px",
    letterSpacing: "-0.12px",
    marginTop: 0,
    marginBottom: "32px",
    textAlign: "center",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$questionTitleStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    marginTop: 0,
    marginBottom: "32px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        fontSize: "16px",
        lineHeight: "24px",
        marginBottom: "24px"
    }
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$questionImageStyles = (0, $74Zh5.css)({
    padding: "24px 0"
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$desktopScreenProgressContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    margin: "0 24px 0 13px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$mobileScreenProgressContainerStyles = (0, $74Zh5.css)({
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        width: "100%",
        margin: 0,
        marginTop: "12px"
    }
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$chooseCorrectAnswerStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
    marginTop: 0,
    marginBottom: "24px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        fontSize: "14px",
        lineHeight: "22px",
        marginBottom: "16px"
    }
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$answerContainerStyles = (0, $74Zh5.css)({
    marginBottom: "24px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        marginBottom: "20px"
    }
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$quizInputsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    gap: "24px",
    marginTop: "24px"
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$buttonContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    marginTop: "32px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        marginTop: "24px"
    }
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$feedbackContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$questionsStepStyles = (0, $74Zh5.css)({
    minWidth: "115px",
    marginLeft: "24px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "18px"
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$completionMessageStyles = (0, $74Zh5.css)({
    marginTop: "40px",
    marginBottom: 0,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    textAlign: "center"
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$matchingFeedbackContainerStyles = (0, $74Zh5.css)({
    marginTop: "40px",
    maxWidth: "624px",
    width: "100%",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        display: "none"
    }
});
var $24c02ea0e14dbe4f$var$$9c3f769544bb2079$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$9c3f769544bb2079$exports, "Sidebar", ()=>$24c02ea0e14dbe4f$export$1ba59dacbcbf90fe);
const $24c02ea0e14dbe4f$export$1ba59dacbcbf90fe = ({ onChangeMenuVisibility: onChangeMenuVisibility, isVisible: isVisible = true, children: children })=>{
    const toggleMenu = ()=>{
        if (onChangeMenuVisibility) onChangeMenuVisibility(!isVisible);
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$sidebarNavContainerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                "data-testid": "button-toggle-menu-toggle",
                css: [
                    $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$buttonToggleMenuStyles,
                    !isVisible && $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$buttonToggleMenuClosedStyles,
                    isVisible && $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$buttonToggleMenuOpenStyles
                ],
                onClick: toggleMenu,
                "aria-label": "toggle menu",
                children: isVisible ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: "chevron-left",
                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: "chevron-right",
                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$mobileButtonToggleMenuContainerStyles,
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                    "data-testid": "button-toggle-menu-show",
                    css: $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$mobileButtonToggleMenuStyles,
                    onClick: toggleMenu,
                    "aria-label": "show menu",
                    children: [
                        isVisible ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: "dropdown-cross",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                        }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: "menu-icon",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                        }),
                        isVisible ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: (0, $74Zh5.css)({
                                span: {
                                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                                }
                            }),
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                children: "Close"
                            })
                        }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: (0, $74Zh5.css)({
                                span: {
                                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                                }
                            }),
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                children: "Menu"
                            })
                        })
                    ]
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    isVisible && $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$sidebarOpenStyles,
                    !isVisible && $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$sidebarClosedStyles,
                    $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$sidebarStyles
                ],
                "data-testid": "sidebar",
                children: isVisible && children
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$sidebarNavContainerStyles = (0, $74Zh5.css)({
    position: "absolute",
    height: "100%",
    opacity: 1,
    display: "block",
    transform: "translateX(0px)",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        width: "100%",
        position: "absolute"
    }
});
const $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$sidebarStyles = (0, $74Zh5.css)({
    transition: "all",
    transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
    transitionDuration: "300ms",
    height: "100%",
    paddingTop: "1.75rem",
    paddingRight: "7px",
    paddingLeft: "0.5rem",
    top: 0,
    bottom: 0,
    left: 0,
    borderRightWidth: "1px",
    borderStyle: "solid",
    borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border"),
    borderTop: "none",
    borderLeft: "none",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface.sunken"),
    overflowY: "auto",
    overflowX: "hidden"
});
const $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$sidebarClosedStyles = (0, $74Zh5.css)({
    width: "1.25rem",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        top: 0,
        borderRightWidth: 0,
        paddingTop: 0,
        height: 0,
        width: "100%",
        position: "absolute"
    }
});
const $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$sidebarOpenStyles = (0, $74Zh5.css)({
    display: "block",
    transform: "translateX(0px)",
    paddingTop: "1.75rem",
    position: "fixed",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        width: "100vw",
        marginTop: "3rem",
        position: "absolute"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        width: "26.25rem",
        position: "absolute"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        boxShadow: `0 0 0 10000px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.blanket")}`
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.lg]: {
        position: "relative",
        boxShadow: "none"
    }
});
const $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$mobileButtonToggleMenuContainerStyles = (0, $74Zh5.css)({
    display: "none",
    alignItems: "center",
    justifyContent: "align-start",
    width: "100vw",
    paddingLeft: "1rem",
    height: "3rem",
    borderBottom: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    borderLeft: "none",
    borderRight: "none",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    position: "relative",
    zIndex: 200,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        display: "flex"
    }
});
const $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$mobileButtonToggleMenuStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    border: "none",
    background: "transparent",
    outline: "none"
});
const $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$buttonToggleMenuStyles = (0, $74Zh5.css)({
    transition: "all",
    transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
    transitionDuration: "300ms",
    border: "none",
    borderRadius: "9999px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    width: "1.5rem",
    height: "1.5rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    position: "absolute",
    top: "1.75rem",
    zIndex: 200,
    cursor: "pointer",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$buttonToggleMenuOpenStyles = (0, $74Zh5.css)({
    marginLeft: "25.5rem"
});
const $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$buttonToggleMenuClosedStyles = (0, $74Zh5.css)({
    marginLeft: "0.5rem"
});
var $24c02ea0e14dbe4f$var$$3d76652bb6362040$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3d76652bb6362040$exports, "LearningSidebar", ()=>$24c02ea0e14dbe4f$export$4ff69a78d3a65d6f);
var $24c02ea0e14dbe4f$var$$ef44b01e6346ac17$require$Buffer = (0, $7KfP5.Buffer);
const $24c02ea0e14dbe4f$var$$ef44b01e6346ac17$var$badge = `<svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_2407_668" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="120" height="120">
<path d="M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z" fill="#FCA700"/>
</mask>
<g mask="url(#mask0_2407_668)">
<path d="M59.9919 120.001C93.129 120.001 119.992 93.1381 119.992 60.001C119.992 26.8639 93.129 0.00100708 59.9919 0.00100708C26.8549 0.00100708 -0.00805664 26.8639 -0.00805664 60.001C-0.00805664 93.1381 26.8549 120.001 59.9919 120.001Z" fill="#F0F1F2"/>
<path d="M114.195 48.5778C139.041 82.736 131.616 130.479 97.5729 155.447L75.6838 125.554C93.1971 112.63 97.0229 88.0317 84.2648 70.3823L114.195 48.5778Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M61.381 -11.1668L61.381 -11.1667L61.3875 -11.1713C66.9496 -15.1726 72.2687 -18.6935 77.3965 -21.8258L116.987 15.9668C109.215 16.5818 99.355 21.2346 85.3825 30.54L85.3825 30.5399L85.3765 30.5441C79.0802 35.0076 73.098 38.8783 67.3602 42.2665L28.6585 5.32281C36.6192 3.90769 46.9288 -1.45355 61.381 -11.1668Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M-4.01227 93.1467L46.5982 80.1918L59.4265 130.835L8.81594 143.79L-4.01227 93.1467Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M3.67239 23.827L3.68518 23.7211L3.66478 23.6962C4.43632 16.9412 1.0124 10.0403 -2.57376 4.84886C-4.3803 2.23367 -6.23694 0.0395466 -7.64175 -1.5007C-8.34432 -2.27099 -8.93428 -2.8782 -9.34902 -3.29322C-9.39083 -3.33506 -9.43086 -3.37495 -9.46905 -3.41285L13.9267 -0.587166C22.5213 4.49206 28.577 10.8772 32.2178 18.2212C35.8649 25.5781 37.096 33.9122 36.0121 42.8863C34.4107 56.146 27.9882 65.8687 18.1125 72.3709C8.28951 78.8384 -4.96514 82.1287 -20.3194 82.5128L-15.6409 43.7758C-9.8996 42.5993 -5.41093 40.3431 -2.18767 37.026C1.06994 33.6736 3.01663 29.2565 3.67239 23.827Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M98.1255 59.8467C98.1255 81.1403 81.101 98.3963 60.1074 98.3963C39.1139 98.3963 22.0894 81.1403 22.0894 59.8467C22.0894 38.5531 39.1139 21.2971 60.1074 21.2971C81.101 21.2971 98.1255 38.5531 98.1255 59.8467Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M35.4794 65.1887C35.2675 65.5337 35.0269 65.9381 34.84 66.2562C34.66 66.5631 34.7569 66.9575 35.06 67.1444L39.3062 69.765C39.6175 69.9569 40.025 69.8581 40.2106 69.5431C40.3794 69.2575 40.5981 68.89 40.8369 68.495C42.52 65.7175 44.2125 66.0562 47.2619 67.5056L51.4731 69.5075C51.805 69.6656 52.2019 69.5181 52.3512 69.1819L54.3737 64.6156C54.5175 64.2906 54.3762 63.9112 54.055 63.76C53.1656 63.3419 51.3981 62.5075 49.8156 61.7412C44.0656 58.9569 39.2 59.1406 35.48 65.1887H35.4794Z" fill="url(#paint0_linear_2407_668)"/>
<path d="M54.5206 54.8113C54.7325 54.4663 54.9731 54.0619 55.16 53.7438C55.34 53.4369 55.2431 53.0425 54.94 52.8556L50.6938 50.235C50.3825 50.0431 49.975 50.1419 49.7894 50.4569C49.6206 50.7425 49.4019 51.11 49.1631 51.505C47.48 54.2825 45.7875 53.9438 42.7381 52.4944L38.5269 50.4925C38.195 50.3344 37.7981 50.4819 37.6488 50.8181L35.6263 55.3844C35.4825 55.7094 35.6238 56.0888 35.945 56.24C36.8344 56.6581 38.6019 57.4925 40.1844 58.2588C45.9344 61.0431 50.8 60.8594 54.52 54.8113H54.5206Z" fill="url(#paint1_linear_2407_668)"/>
<path d="M85.1263 49.5188H73.8275C73.8275 52.335 76.1106 54.6175 78.9263 54.6175H81.0069V56.6256C81.0069 59.4419 83.29 61.7244 86.1056 61.7244V50.4988C86.1056 49.9575 85.6669 49.5188 85.1256 49.5188H85.1263Z" fill="#1D7AFC"/>
<path d="M79.5345 55.1475H68.2357C68.2357 57.9638 70.5188 60.2463 73.3345 60.2463H75.4151V62.2544C75.4151 65.0706 77.6982 67.3531 80.5138 67.3531V56.1275C80.5138 55.5863 80.0751 55.1475 79.5338 55.1475H79.5345Z" fill="url(#paint2_linear_2407_668)"/>
<path d="M73.9425 60.7756H62.6438C62.6438 63.5919 64.9269 65.8744 67.7425 65.8744H69.8232V67.8825C69.8232 70.6988 72.1063 72.9813 74.9219 72.9813V61.7556C74.9219 61.2144 74.4832 60.7756 73.9419 60.7756H73.9425Z" fill="url(#paint3_linear_2407_668)"/>
</g>
<defs>
<linearGradient id="paint0_linear_2407_668" x1="54.2475" y1="71.11" x2="41.3981" y2="63.7263" gradientUnits="userSpaceOnUse">
<stop stop-color="#0055CC"/>
<stop offset="0.972" stop-color="#1C78FA"/>
<stop offset="1" stop-color="#1D7AFC"/>
</linearGradient>
<linearGradient id="paint1_linear_2407_668" x1="35.7519" y1="48.89" x2="48.6019" y2="56.2738" gradientUnits="userSpaceOnUse">
<stop stop-color="#0055CC"/>
<stop offset="0.972" stop-color="#1C78FA"/>
<stop offset="1" stop-color="#1D7AFC"/>
</linearGradient>
<linearGradient id="paint2_linear_2407_668" x1="80.2745" y1="55.1663" x2="75.4682" y2="60.1225" gradientUnits="userSpaceOnUse">
<stop offset="0.176" stop-color="#0055CC"/>
<stop offset="1" stop-color="#1D7AFC"/>
</linearGradient>
<linearGradient id="paint3_linear_2407_668" x1="75.0019" y1="60.8281" x2="69.445" y2="66.2344" gradientUnits="userSpaceOnUse">
<stop offset="0.176" stop-color="#0055CC"/>
<stop offset="1" stop-color="#1D7AFC"/>
</linearGradient>
</defs>
</svg>`;
const $24c02ea0e14dbe4f$var$$ef44b01e6346ac17$export$44f5f766f3f98994 = `data:image/svg+xml;base64,${$24c02ea0e14dbe4f$var$$ef44b01e6346ac17$require$Buffer.from($24c02ea0e14dbe4f$var$$ef44b01e6346ac17$var$badge).toString("base64")}`;
const $24c02ea0e14dbe4f$var$$32c02b5652036d7a$var$SidebarContext = (0, $5FkrB.createContext)(undefined);
const $24c02ea0e14dbe4f$var$$32c02b5652036d7a$export$861cd542ff836f0d = ()=>{
    const context = (0, $5FkrB.useContext)($24c02ea0e14dbe4f$var$$32c02b5652036d7a$var$SidebarContext);
    if (!context) throw new Error("useSidebarContext must be used within a SidebarContextProvider");
    return context;
};
const $24c02ea0e14dbe4f$var$$32c02b5652036d7a$export$d8355e8edbcacbe8 = ({ children: children })=>{
    const [hoverInfo, setHoverInfo] = (0, $5FkrB.useState)(null);
    const popupRef = (0, $5FkrB.useRef)(null);
    const lastIdRef = (0, $5FkrB.useRef)(null);
    const timeoutRef = (0, $5FkrB.useRef)(null);
    const clear = (0, $5FkrB.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);
    const handleMouseEnter = (0, $5FkrB.useCallback)((data)=>{
        clear();
        if (lastIdRef.current !== data.courseId) setHoverInfo(null);
        lastIdRef.current = data.courseId;
        timeoutRef.current = setTimeout(()=>{
            if (lastIdRef.current === data.courseId) setHoverInfo(data);
        }, 1000);
    }, [
        clear
    ]);
    const handleMouseLeave = (0, $5FkrB.useCallback)((id)=>{
        clear();
        if (!id || lastIdRef.current === id) {
            lastIdRef.current = null;
            setHoverInfo(null);
        }
    }, [
        clear
    ]);
    const contextValue = (0, $5FkrB.useMemo)(()=>({
            hoverInfo: hoverInfo,
            handleMouseEnter: handleMouseEnter,
            handleMouseLeave: handleMouseLeave,
            popupRef: popupRef
        }), [
        hoverInfo,
        handleMouseEnter,
        handleMouseLeave
    ]);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$32c02b5652036d7a$var$SidebarContext.Provider, {
        value: contextValue,
        children: children
    });
};
const $24c02ea0e14dbe4f$var$$48630d5962798e4a$export$272e7ef3ea22070d = (status)=>{
    switch(status){
        case $24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED:
            return $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED;
        case $24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.IN_PROGRESS:
        case $24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED:
        default:
            return $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT;
    }
};
const $24c02ea0e14dbe4f$var$$48630d5962798e4a$export$15379570ba48f04d = (courseSlug, lessonSlug, sectionSlug)=>{
    const currentPath = globalThis.location.pathname;
    const currentHash = globalThis.location.hash;
    if (courseSlug) return currentPath.includes(`/course/${courseSlug}`);
    if (sectionSlug === "quiz") return currentPath.includes(`lesson/${lessonSlug}`) && currentHash === "#quiz";
    if (sectionSlug) return currentPath.includes(`/lesson/${lessonSlug}`) && currentHash === `#${sectionSlug}`;
    if (lessonSlug) {
        const lessonPath = `/lesson/${lessonSlug}`;
        return currentPath.endsWith(lessonPath) || currentPath.includes(lessonPath + "/");
    }
    return currentHash === `#${sectionSlug}`;
};
const $24c02ea0e14dbe4f$var$$48630d5962798e4a$export$1308f255697e8777 = (lessonsCollection, progressForLessons)=>{
    const numberOfCompletedLessons = lessonsCollection.items.filter(({ sys: { id: id } })=>$24c02ea0e14dbe4f$var$$48630d5962798e4a$export$272e7ef3ea22070d(progressForLessons?.lessons.find((lesson)=>lesson.lessonId === id)?.status) === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED).length;
    const numberOfTotalLessons = lessonsCollection.items.length;
    const progress = numberOfTotalLessons === 0 ? 0 : numberOfCompletedLessons / numberOfTotalLessons * 100;
    const isStatusCompleted = progress === 100;
    return {
        progress: progress,
        isStatusCompleted: isStatusCompleted
    };
};
const $24c02ea0e14dbe4f$var$$6cca9b298ff547cb$export$a9a23386c3e0c05f = ({ lessonsCollection: lessonsCollection, progressForLessons: progressForLessons, reward: reward, title: title })=>{
    const { progress: progress, isStatusCompleted: isStatusCompleted } = (0, $5FkrB.useMemo)(()=>$24c02ea0e14dbe4f$var$$48630d5962798e4a$export$1308f255697e8777(lessonsCollection, progressForLessons), [
        lessonsCollection,
        progressForLessons
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$6cca9b298ff547cb$var$progressCircleContainerStyles,
        "data-testid": "course-progress-circle",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f188eff9b59fb855$export$5ab97151efedb8c6), {
                strokeWidth: 8,
                value: progress,
                styles: (0, $f188eff9b59fb855$export$5115a192ad9bf57f)({
                    pathColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.success"),
                    trailColor: "rgba(9, 30, 66, 0.14)"
                }),
                css: [
                    isStatusCompleted && $24c02ea0e14dbe4f$var$$6cca9b298ff547cb$var$completedCourseProgressStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: [
                        $24c02ea0e14dbe4f$var$$6cca9b298ff547cb$var$imageBadgeContainerStyles,
                        isStatusCompleted && $24c02ea0e14dbe4f$var$$6cca9b298ff547cb$var$completedCourseProgressStyles
                    ],
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                        css: $24c02ea0e14dbe4f$var$$6cca9b298ff547cb$var$imageStyles,
                        "data-testid": "course-badge-image",
                        src: reward?.badgeCdnUrl || $24c02ea0e14dbe4f$var$$ef44b01e6346ac17$export$44f5f766f3f98994,
                        alt: title
                    })
                })
            }),
            isStatusCompleted && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                type: "check",
                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.success")
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$6cca9b298ff547cb$var$completedCourseProgressStyles = (0, $74Zh5.css)({
    opacity: "0.2"
});
const $24c02ea0e14dbe4f$var$$6cca9b298ff547cb$var$progressCircleContainerStyles = (0, $74Zh5.css)({
    position: "relative",
    maxWidth: "32px",
    span: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    }
});
const $24c02ea0e14dbe4f$var$$6cca9b298ff547cb$var$imageBadgeContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$6cca9b298ff547cb$var$imageStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "50%"
});
let $24c02ea0e14dbe4f$var$$47b694880a211b2b$export$40bdb27f2137fcf;
(function(Appearance) {
    Appearance["COURSE"] = "course";
    Appearance["LESSON"] = "lesson";
    Appearance["SECTION"] = "section";
})($24c02ea0e14dbe4f$var$$47b694880a211b2b$export$40bdb27f2137fcf || ($24c02ea0e14dbe4f$var$$47b694880a211b2b$export$40bdb27f2137fcf = {}));
/**
 * Props for the TextTooltip component
 * @param {string} text - Text to display in the tooltip
 * @param {CardStatus} status - Current status of the item (completed, or default)
 * @param {Appearance} appearance - Whether the item is a course card or lesson card
 * @param {boolean} isSelected - Whether the item is selected
 */ const $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$MOBILE_SCREEN_WIDTH = 650;
const $24c02ea0e14dbe4f$var$$47b694880a211b2b$export$c0d3d8bfa41e2e2a = ({ text: text, status: status, appearance: appearance, isSelected: isSelected })=>{
    const [isTruncated, setIsTruncated] = (0, $5FkrB.useState)(false);
    const textRef = (0, $5FkrB.useRef)(null);
    const deviceSize = $24c02ea0e14dbe4f$export$4616d33c54ae5baf();
    const isMobile = deviceSize <= $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$MOBILE_SCREEN_WIDTH;
    (0, $5FkrB.useEffect)(()=>{
        const checkTruncation = ()=>{
            if (textRef.current) setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
        };
        checkTruncation();
        window.addEventListener("resize", checkTruncation);
        return ()=>{
            window.removeEventListener("resize", checkTruncation);
        };
    }, [
        text
    ]);
    const isLesson = appearance === $24c02ea0e14dbe4f$var$$47b694880a211b2b$export$40bdb27f2137fcf.LESSON;
    const isCourse = appearance === $24c02ea0e14dbe4f$var$$47b694880a211b2b$export$40bdb27f2137fcf.COURSE;
    const isSection = appearance === $24c02ea0e14dbe4f$var$$47b694880a211b2b$export$40bdb27f2137fcf.SECTION;
    const textElement = (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
        "data-testid": "sidebar-text-tooltip",
        ref: textRef,
        css: [
            isCourse && $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$courseTitleStyles,
            isCourse && isSelected && $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$titleSelectedStyles,
            isLesson && $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$lessonTitleStyles,
            isMobile && isLesson && $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$regularDecorationStyles,
            isLesson && isSelected && $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$titleSelectedStyles,
            $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$sectionTitleStyles,
            isCourse && $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$courseMaxWidth,
            isLesson && $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$lessonMaxWidth,
            status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED && $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$sectionTitleCompletedStyles,
            status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT && $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$sectionTitleDefaultStyles,
            isSection && isSelected && $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$sectionTitleSelectedStyles
        ],
        children: text
    });
    return isTruncated ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $1ee6819d2d8fb6a1$export$2e2bcd8739ae039), {
        content: text,
        position: isMobile ? "bottom" : "right",
        children: textElement
    }) : textElement;
};
const $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$sectionTitleStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    lineHeight: "24px",
    fontSize: "16px",
    marginTop: 0,
    marginLeft: "10px",
    maxWidth: "330px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        maxWidth: "290px"
    }
});
const $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$sectionTitleSelectedStyles = (0, $74Zh5.css)({
    fontWeight: 600,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")
});
const $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$sectionTitleCompletedStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest")
});
const $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$sectionTitleDefaultStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle")
});
const $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$lessonTitleStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    lineHeight: "24px",
    fontSize: "16px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle"),
    marginTop: 0,
    marginRight: "auto",
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.025"),
    "&:hover": {
        textDecoration: "underline"
    }
});
const $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$regularDecorationStyles = (0, $74Zh5.css)({
    "&:hover": {
        textDecoration: "none"
    }
});
const $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$titleSelectedStyles = (0, $74Zh5.css)({
    fontWeight: "500 !important",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
});
const $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$courseTitleStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "24px",
    marginTop: 0
});
const $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$courseMaxWidth = (0, $74Zh5.css)({
    marginLeft: 0,
    maxWidth: "320px"
});
const $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$lessonMaxWidth = (0, $74Zh5.css)({
    marginLeft: 0,
    marginRight: "auto",
    maxWidth: "290px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        maxWidth: "270px"
    }
});
const $24c02ea0e14dbe4f$var$$0efd93166e145c77$export$a3b47b9708ebe4f0 = {
    [$24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT]: "dot-default",
    [$24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED]: "dot-completed"
};
const $24c02ea0e14dbe4f$var$$0efd93166e145c77$export$411533295806dc51 = (sectionContentfulId, seenSectionObserver)=>{
    const element = document.getElementById(`${sectionContentfulId}`);
    if (element) seenSectionObserver.unobserve(element);
};
const $24c02ea0e14dbe4f$var$$0efd93166e145c77$export$a1fd357e7aacc4df = (0, $5FkrB.memo)(({ section: { title: title, id: id }, status: status, courseSlug: courseSlug, lessonSlug: lessonSlug, onSelect: onSelect, isSelected: isSelected })=>{
    const handleSectionClick = (e)=>{
        e.stopPropagation();
        onSelect(courseSlug || "", lessonSlug, id);
    };
    const handleKeyboardClick = (0, $5FkrB.useCallback)(()=>{
        onSelect(courseSlug || "", lessonSlug, id);
    }, [
        onSelect,
        courseSlug,
        lessonSlug,
        id
    ]);
    const onKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleKeyboardClick);
    const getIconType = ()=>{
        if (isSelected && status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED) return $24c02ea0e14dbe4f$var$$0efd93166e145c77$export$a3b47b9708ebe4f0[status];
        if (isSelected) return "dot-selected";
        return $24c02ea0e14dbe4f$var$$0efd93166e145c77$export$a3b47b9708ebe4f0[status];
    };
    const type = getIconType();
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        "data-testid": "sidebar-section-item",
        css: [
            $24c02ea0e14dbe4f$var$$0efd93166e145c77$var$sectionBarStyles,
            isSelected && $24c02ea0e14dbe4f$var$$0efd93166e145c77$var$sectionBarSelectedStyles
        ],
        onClick: handleSectionClick,
        onKeyDown: onKeyDown,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                type: type,
                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$47b694880a211b2b$export$c0d3d8bfa41e2e2a, {
                text: title,
                status: status,
                isSelected: isSelected,
                appearance: $24c02ea0e14dbe4f$var$$47b694880a211b2b$export$40bdb27f2137fcf.SECTION
            })
        ]
    });
});
const $24c02ea0e14dbe4f$var$$0efd93166e145c77$var$sectionBarStyles = (0, $74Zh5.css)({
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "4px 0 4px 10px",
    borderRadius: "4px",
    cursor: "pointer",
    "&:active": {
        background: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")} !important`
    },
    "&:hover": {
        background: "rgba(220, 223, 228, 0.50)",
        "&::before": {
            content: '""',
            display: "block",
            width: "2px",
            height: "12px",
            position: "absolute",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral")
        }
    }
});
const $24c02ea0e14dbe4f$var$$0efd93166e145c77$var$sectionBarSelectedStyles = (0, $74Zh5.css)({
    "&::before": {
        content: '""',
        display: "block",
        width: "2px",
        height: "12px",
        position: "absolute",
        left: 0,
        top: "50%",
        transform: "translateY(-50%)",
        background: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")} !important`
    }
});
const $24c02ea0e14dbe4f$var$$4baed82dabfd5555$var$loadingFlash = (0, $74Zh5.keyframes)`
  0% {
    background-position: -10px;
  }
  100% {
    background-position: calc(100% + 250px);
  }
`;
const $24c02ea0e14dbe4f$var$$4baed82dabfd5555$var$skeletonStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(241, 242, 244, 1)",
    borderRadius: "4px",
    position: "relative",
    "&::before": {
        content: '""',
        display: "block",
        width: "100%",
        height: "100%",
        borderRadius: "4px",
        background: `linear-gradient(
      90deg,
      rgba(241, 242, 244, 1) 0,
      #f9f9f9 calc(50% - 25px),
      #f9f9f9 calc(50% + 25px),
      rgba(241, 242, 244, 1) 100%
    )`,
        backgroundSize: "35%",
        backgroundPosition: 0,
        backgroundRepeat: "no-repeat",
        animation: `${$24c02ea0e14dbe4f$var$$4baed82dabfd5555$var$loadingFlash} 2.5s infinite linear`
    }
});
const $24c02ea0e14dbe4f$var$$4baed82dabfd5555$export$27a22c945b52f415 = ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$4baed82dabfd5555$var$skeletonStyles,
        "data-testid": "skeleton-loader"
    });
const $24c02ea0e14dbe4f$var$$193bb26965d10640$export$9794789a1567361c = (0, $5FkrB.memo)(()=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$193bb26965d10640$var$loaderContainerStyles,
        children: [
            [
                ...Array(4)
            ].map((_, index)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $24c02ea0e14dbe4f$var$$193bb26965d10640$var$sectionBarStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$export$a3b47b9708ebe4f0[$24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT],
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$193bb26965d10640$var$skeletonLoaderBarStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$4baed82dabfd5555$export$27a22c945b52f415, {})
                        })
                    ]
                }, index)),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$193bb26965d10640$var$sectionBarStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                        type: $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$export$a3b47b9708ebe4f0[$24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT],
                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$47b694880a211b2b$export$c0d3d8bfa41e2e2a, {
                        text: "Quiz",
                        status: $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT,
                        isSelected: false
                    })
                ]
            })
        ]
    }));
const $24c02ea0e14dbe4f$var$$193bb26965d10640$var$loaderContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$193bb26965d10640$var$skeletonLoaderBarStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "20px",
    marginLeft: "10px"
});
const $24c02ea0e14dbe4f$var$$193bb26965d10640$var$sectionBarStyles = (0, $74Zh5.css)({
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "4px 0 4px 10px",
    borderRadius: "4px",
    cursor: "pointer",
    "&:hover": {
        background: "rgba(220, 223, 228, 0.50)",
        "&::before": {
            content: '""',
            display: "block",
            width: "2px",
            height: "12px",
            position: "absolute",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral")
        }
    }
});
const $24c02ea0e14dbe4f$var$$fd3fa057a77982d6$export$1f81c5947c983f13 = (0, $5FkrB.memo)((props)=>{
    const { lesson: { slug: slug, sectionListCollection: sectionListCollection }, progressForLesson: progressForLesson, isLoading: isLoading, courseSlug: courseSlug, selectedSectionId: selectedSectionId, currentLessonSlug: currentLessonSlug, onSelect: onSelect, isLessonCardExpanded: isLessonCardExpanded, isMobile: isMobile } = props;
    if (isLoading && isLessonCardExpanded) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$193bb26965d10640$export$9794789a1567361c, {});
    if (!isLessonCardExpanded || isMobile) return null;
    const status = $24c02ea0e14dbe4f$var$$48630d5962798e4a$export$272e7ef3ea22070d(progressForLesson?.status);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$fd3fa057a77982d6$var$sectionContainerStyles,
        children: sectionListCollection.items.map((section)=>{
            const sectionStatus = section.id === "quiz" && status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED ? $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED : $24c02ea0e14dbe4f$var$$48630d5962798e4a$export$272e7ef3ea22070d(progressForLesson?.section.find((sectionProgress)=>sectionProgress.sectionId === section.sys.id)?.status);
            return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$0efd93166e145c77$export$a1fd357e7aacc4df, {
                section: section,
                status: sectionStatus,
                onSelect: onSelect,
                lessonSlug: slug,
                courseSlug: courseSlug,
                isSelected: currentLessonSlug === slug && section.sys.id === selectedSectionId
            }, section.id);
        })
    });
});
const $24c02ea0e14dbe4f$var$$fd3fa057a77982d6$var$sectionContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$d1d0f9af78cf2050$export$5496f515fa03c54e = (totalMinutes)=>{
    if (totalMinutes > 59) {
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        if (minutes === 0) return `${hours} h`;
        return `${hours} h ${minutes} min`;
    }
    return `${totalMinutes} min`;
};
const $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$export$db6f237c151666ee = 480;
const $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$export$a3b47b9708ebe4f0 = {
    [$24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT]: "dot-default",
    [$24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED]: "dot-completed"
};
const $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$export$951debaed2d5c034 = (0, $5FkrB.memo)((props)=>{
    const { lesson: { sys: sys, slug: slug, title: title, duration: duration }, courseSlug: courseSlug, isLoading: isLoading, progressForLesson: progressForLesson, onSelect: onSelect, expandedLessonIds: expandedLessonIds, selectedSectionId: selectedSectionId, currentLessonSlug: currentLessonSlug, isCourse: isCourse } = props;
    const deviceSize = $24c02ea0e14dbe4f$export$4616d33c54ae5baf();
    const isMobile = deviceSize <= $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$export$db6f237c151666ee;
    const isSelected = $24c02ea0e14dbe4f$var$$48630d5962798e4a$export$15379570ba48f04d("", slug);
    const status = $24c02ea0e14dbe4f$var$$48630d5962798e4a$export$272e7ef3ea22070d(progressForLesson?.status);
    const [isLessonCardExpanded, setIsLessonCardExpanded] = (0, $5FkrB.useState)(false);
    (0, $5FkrB.useEffect)(()=>{
        const isExpanded = expandedLessonIds?.includes(sys.id);
        setIsLessonCardExpanded(isExpanded || false);
    }, [
        expandedLessonIds
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ const handleExpandClick = (e)=>{
        e.stopPropagation();
        setIsLessonCardExpanded(!isLessonCardExpanded);
    };
    const handleCardClick = (0, $5FkrB.useCallback)(()=>{
        setIsLessonCardExpanded(true);
        onSelect(courseSlug || "", slug);
    }, [
        courseSlug,
        slug,
        onSelect
    ]);
    const handleExpandKeyboard = (0, $5FkrB.useCallback)(()=>{
        setIsLessonCardExpanded(!isLessonCardExpanded);
    }, [
        isLessonCardExpanded
    ]);
    const onKeyDownCard = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleCardClick);
    const onKeyDownExpand = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleExpandKeyboard);
    const renderStatusIndicator = ()=>{
        if (status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
            type: "check-circle-outline",
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.success")
        });
        return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: [
                $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeStyles,
                isSelected && $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeSelectedStyles
            ],
            children: $24c02ea0e14dbe4f$var$$d1d0f9af78cf2050$export$5496f515fa03c54e(duration)
        });
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "sidebar-lesson-card",
        css: [
            $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonCardStyles,
            isSelected && $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonCardSelectedStyles
        ],
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                role: "button",
                tabIndex: 0,
                css: [
                    $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonCardHeaderStyles,
                    isMobile && $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonCardHeaderMobileStyles,
                    isCourse && isMobile && $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonCardHeaderCourseStyles
                ],
                onClick: handleCardClick,
                onKeyDown: onKeyDownCard,
                children: [
                    !isMobile && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        role: "button",
                        tabIndex: 0,
                        css: $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonExpanderStyles,
                        onClick: handleExpandClick,
                        onKeyDown: onKeyDownExpand,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: isLessonCardExpanded ? "chevron-down" : "chevron-right",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$47b694880a211b2b$export$c0d3d8bfa41e2e2a, {
                        text: title,
                        isSelected: isSelected,
                        appearance: $24c02ea0e14dbe4f$var$$47b694880a211b2b$export$40bdb27f2137fcf.LESSON
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeContainerStyles,
                        children: renderStatusIndicator()
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$fd3fa057a77982d6$export$1f81c5947c983f13, {
                lesson: props.lesson,
                progressForLesson: progressForLesson,
                isLoading: isLoading,
                courseSlug: courseSlug,
                selectedSectionId: selectedSectionId,
                currentLessonSlug: currentLessonSlug,
                onSelect: onSelect,
                isLessonCardExpanded: isLessonCardExpanded,
                isMobile: isMobile
            })
        ]
    });
});
const $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonCardStyles = (0, $74Zh5.css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    paddingTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    paddingBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    paddingLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250"),
    paddingRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    "&:active": {
        background: "#F1F2F4 !important"
    },
    "&:hover": {
        background: "#F7F8F9"
    }
});
const $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonCardSelectedStyles = (0, $74Zh5.css)({
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input.hovered"),
    "&:active": {
        background: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input.hovered")} !important`
    }
});
const $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonCardHeaderStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    cursor: "pointer"
});
const $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonCardHeaderMobileStyles = (0, $74Zh5.css)({
    marginLeft: `calc(${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} + ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.025")})`
});
const $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonCardHeaderCourseStyles = (0, $74Zh5.css)({
    marginLeft: 0
});
const $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonExpanderStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    borderRadius: "4px",
    cursor: "pointer",
    marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.025"),
    "&:hover": {
        background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface.pressed")
    }
});
const $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: 400,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.025")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.075")}`,
    borderRadius: "8px",
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral"),
    marginLeft: "auto"
});
const $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeSelectedStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.brand.subtlest")
});
const $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeContainerStyles = (0, $74Zh5.css)({
    marginLeft: "auto"
});
const $24c02ea0e14dbe4f$var$$11732cc088354996$export$748c6b3a71d1e268 = (0, $5FkrB.memo)(()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            ...Array(4)
        ].map((_, index)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$11732cc088354996$var$lessonCardHeaderStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$11732cc088354996$var$lessonExpanderStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: "chevron-right",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$11732cc088354996$var$skeletonLoaderBarStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$4baed82dabfd5555$export$27a22c945b52f415, {}),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$11732cc088354996$var$skeletonTimeLoaderBarStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$4baed82dabfd5555$export$27a22c945b52f415, {})
                            })
                        ]
                    })
                ]
            }, index))
    }));
const $24c02ea0e14dbe4f$var$$11732cc088354996$var$lessonCardHeaderStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    paddingBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    paddingLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250"),
    paddingRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$11732cc088354996$var$lessonExpanderStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    borderRadius: "4px"
});
const $24c02ea0e14dbe4f$var$$11732cc088354996$var$skeletonTimeLoaderBarStyles = (0, $74Zh5.css)({
    width: "50px",
    height: "20px",
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
});
const $24c02ea0e14dbe4f$var$$11732cc088354996$var$skeletonLoaderBarStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "20px",
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.025")
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$COURSE_CARD_TITLE = {
    [$24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED]: "Completed",
    [$24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT]: "Course"
};
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$CourseCardHeaderContent = ({ isCourseExpanded: isCourseExpanded, isSelected: isSelected, status: status, title: title })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseExpanderStyles,
                    isCourseExpanded && $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseExpanderSelectedStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: isCourseExpanded ? "chevron-down" : "chevron-right",
                    color: isCourseExpanded ? (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.selected") : (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseTitleContainerStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: [
                            $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardTitleStyles,
                            status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED && $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardTitleCompletedStyles,
                            status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT && $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardTitleDefaultStyles,
                            isSelected && $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardTitleSelectedStyles
                        ],
                        children: isSelected ? "Current course".toUpperCase() : $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$COURSE_CARD_TITLE[status].toUpperCase()
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$47b694880a211b2b$export$c0d3d8bfa41e2e2a, {
                        text: title,
                        isSelected: isSelected,
                        appearance: $24c02ea0e14dbe4f$var$$47b694880a211b2b$export$40bdb27f2137fcf.COURSE
                    })
                ]
            })
        ]
    });
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$export$bb61bd2f4f2a772c = (props)=>{
    const { handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, popupRef: popupRef } = $24c02ea0e14dbe4f$var$$32c02b5652036d7a$export$861cd542ff836f0d();
    const mouseLeaveHandler = (0, $5FkrB.useCallback)((e, id, courseCardRef)=>{
        const lessonPage = document.getElementById("lesson-page-body");
        const isMovedToSidebar = e.relatedTarget?.tagName === "ASIDE";
        if (!e.relatedTarget || !e.relatedTarget.nodeType || isMovedToSidebar || e.relatedTarget === props.scrollContainerRef.current || lessonPage?.contains(e.relatedTarget)) {
            handleMouseLeave();
            return;
        }
        if (e.currentTarget === courseCardRef.current || e.relatedTarget === popupRef.current) return;
        handleMouseLeave(id);
    }, [
        handleMouseLeave,
        popupRef,
        props.scrollContainerRef
    ]);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$aefb4e9d0a694068$export$7b8f328152f30a2c, {
        ...props,
        onHover: handleMouseEnter,
        onMouseLeave: mouseLeaveHandler,
        popupRef: popupRef
    });
};
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$export$7b8f328152f30a2c = (0, $5FkrB.memo)(({ course: { sys: sys, title: title, reward: reward, slug: slug, lessonsCollection: lessonsCollection }, status: status, isLoading: isLoading, selectedLessonRef: selectedLessonRef, progressForLessons: progressForLessons, onHover: onHover, onMouseLeave: onMouseLeave, onSelect: onSelect, expandedLessonIds: expandedLessonIds = [], expandedCourseIds: expandedCourseIds = [], selectedSectionId: selectedSectionId, currentLessonSlug: currentLessonSlug })=>{
    const courseCardRef = (0, $5FkrB.useRef)(null);
    const isSelected = $24c02ea0e14dbe4f$var$$48630d5962798e4a$export$15379570ba48f04d(slug);
    const [isCourseExpanded, setIsCourseExpanded] = (0, $5FkrB.useState)(false);
    (0, $5FkrB.useEffect)(()=>{
        const isExpanded = expandedCourseIds.includes(sys.id);
        setIsCourseExpanded(isExpanded || false);
    }, [
        expandedCourseIds
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ const handleCourseCardExpand = (0, $5FkrB.useCallback)(()=>{
        setIsCourseExpanded(!isCourseExpanded);
        onSelect(slug);
    }, [
        isCourseExpanded,
        onSelect,
        slug
    ]);
    const showCoursePopup = (0, $5FkrB.useCallback)(()=>{
        if (courseCardRef.current) onHover({
            courseId: sys.id,
            courseCardPosition: courseCardRef.current.getBoundingClientRect()
        });
    }, [
        sys.id,
        onHover
    ]);
    const hideCoursePopup = (0, $5FkrB.useCallback)((e)=>{
        onMouseLeave(e, sys.id, courseCardRef);
    }, [
        onMouseLeave,
        sys.id,
        courseCardRef
    ]);
    const onKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleCourseCardExpand);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "sidebar-course-card",
        css: [
            $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardStyles,
            isCourseExpanded && $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardOpenedStyles
        ],
        ref: courseCardRef,
        onMouseEnter: showCoursePopup,
        onMouseLeave: hideCoursePopup,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                role: "button",
                tabIndex: 0,
                css: [
                    $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardHeaderStyles,
                    isCourseExpanded && $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardHeaderOpenedStyles
                ],
                onClick: handleCourseCardExpand,
                onKeyDown: onKeyDown,
                onMouseEnter: showCoursePopup,
                "data-testid": "course-card-header",
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$CourseCardHeaderContent, {
                        isCourseExpanded: isCourseExpanded,
                        isSelected: isSelected,
                        status: status,
                        title: title
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$6cca9b298ff547cb$export$a9a23386c3e0c05f, {
                        lessonsCollection: lessonsCollection,
                        progressForLessons: progressForLessons,
                        reward: reward,
                        title: title
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$lessonContainerStyles,
                onMouseEnter: hideCoursePopup,
                children: isLoading && isCourseExpanded ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$11732cc088354996$export$748c6b3a71d1e268, {}) : isCourseExpanded && lessonsCollection.items.map((lesson)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        ref: $24c02ea0e14dbe4f$var$$48630d5962798e4a$export$15379570ba48f04d("", lesson.slug) ? selectedLessonRef : null,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$export$951debaed2d5c034, {
                            lesson: lesson,
                            courseSlug: slug,
                            progressForLesson: progressForLessons?.lessons.find((lessonProgress)=>lessonProgress.lessonId === lesson.sys.id),
                            onSelect: onSelect,
                            isLoading: isLoading,
                            expandedLessonIds: expandedLessonIds,
                            selectedSectionId: selectedSectionId,
                            currentLessonSlug: currentLessonSlug
                        })
                    }, lesson.sys.id))
            })
        ]
    });
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardStyles = (0, $74Zh5.css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    paddingTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    paddingBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    borderBottom: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    "&:hover": {
        background: "#F7F8F9"
    }
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardOpenedStyles = (0, $74Zh5.css)({
    paddingBottom: 0,
    "&:hover": {
        background: "none"
    }
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardHeaderStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    paddingLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    paddingRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardHeaderOpenedStyles = (0, $74Zh5.css)({
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseExpanderStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    borderRadius: "4px",
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")}`,
    cursor: "pointer"
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseExpanderSelectedStyles = (0, $74Zh5.css)({
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.blue.subtler")}`
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseTitleContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    marginRight: "auto"
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardTitleStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px"
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardTitleSelectedStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardTitleCompletedStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.success")
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardTitleDefaultStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest")
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$lessonContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
var $24c02ea0e14dbe4f$var$$e48fba9cf5395297$require$Buffer = (0, $7KfP5.Buffer);
const $24c02ea0e14dbe4f$var$$e48fba9cf5395297$var$courseBg = `<svg width="419" height="16" viewBox="0 0 419 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_550_14457)">
<rect width="419" height="16" fill="#CCE0FF"/>
<g clipPath="url(#clip1_550_14457)">
<path d="M419.987 -18.5349C419.996 -18.6007 420.003 -18.6684 420.014 -18.7323C420.032 -18.7947 420.048 -18.8548 420.064 -18.915C420.099 -19.0356 420.114 -19.1585 420.159 -19.2632C420.248 -19.4786 420.309 -19.6895 420.416 -19.8625C420.463 -19.9546 420.508 -20.0404 420.551 -20.1238C420.603 -20.2039 420.653 -20.2775 420.702 -20.3488C420.75 -20.4201 420.79 -20.4949 420.836 -20.5598C420.888 -20.6209 420.931 -20.6813 420.974 -20.7375C421.14 -20.9764 421.288 -21.1424 421.37 -21.2817C421.452 -21.421 421.479 -21.522 421.443 -21.5797C421.407 -21.6374 421.307 -21.6518 421.142 -21.6124C420.978 -21.5729 420.733 -21.4929 420.458 -21.2992C420.387 -21.251 420.313 -21.2006 420.234 -21.1476C420.159 -21.0907 420.086 -21.0172 420.006 -20.9452C419.928 -20.8714 419.847 -20.793 419.762 -20.7101C419.686 -20.6195 419.613 -20.5188 419.533 -20.4154C419.364 -20.214 419.244 -19.956 419.102 -19.6814C419.032 -19.5431 418.992 -19.3907 418.936 -19.2369C418.91 -19.159 418.885 -19.0793 418.86 -18.9995C418.838 -18.9178 418.826 -18.835 418.809 -18.7495C418.615 -17.7843 418.69 -16.8131 418.876 -15.8955C419.059 -14.9692 419.392 -14.1022 419.756 -13.244C419.947 -12.82 420.142 -12.3941 420.364 -11.9832C420.574 -11.563 420.81 -11.1596 421.049 -10.7501L421.231 -10.4386C421.302 -10.321 421.379 -10.2101 421.453 -10.1053C421.527 -10.0006 421.606 -9.89614 421.681 -9.80195L421.834 -9.60333C421.861 -9.56574 421.887 -9.52816 421.909 -9.49438C421.917 -9.47618 421.939 -9.45715 421.93 -9.44167L421.87 -9.4071L421.756 -9.34475C421.555 -9.2203 421.349 -9.09548 421.146 -8.96877C420.732 -8.71463 420.314 -8.45596 419.889 -8.19466C419.043 -7.67017 418.178 -7.13781 417.292 -6.58888C415.522 -5.48495 413.666 -4.32951 411.701 -3.10375C411.569 -3.02103 411.438 -2.9383 411.311 -2.85594L411.263 -2.82245C411.247 -2.81267 411.23 -2.79231 411.213 -2.79503L411.176 -2.83796L411.129 -2.89683C411.053 -2.99935 410.979 -3.09997 410.908 -3.19868C410.748 -3.42193 410.595 -3.64364 410.445 -3.8657C409.853 -4.75016 409.317 -5.59122 408.833 -6.35712C407.867 -7.87642 407.139 -9.19183 406.523 -10.4477C405.911 -11.704 405.395 -12.8909 404.961 -14.1983C404.532 -15.5018 404.156 -16.9191 403.941 -18.6294C403.764 -20.0724 403.734 -21.6582 403.948 -23.2902C404.067 -24.102 404.224 -24.9319 404.485 -25.7435C404.596 -26.156 404.761 -26.5543 404.909 -26.9594C405.08 -27.3562 405.245 -27.7586 405.453 -28.1438C405.847 -28.925 406.311 -29.6786 406.85 -30.3841C407.385 -31.0935 407.973 -31.7656 408.624 -32.3738C408.936 -32.6905 409.287 -32.9706 409.619 -33.2637C409.969 -33.5374 410.311 -33.821 410.678 -34.0689C411.033 -34.3347 411.41 -34.5667 411.777 -34.8021C412.152 -35.0318 412.539 -35.2437 412.914 -35.465C414.436 -36.3062 415.99 -36.9507 417.497 -37.3604C419.003 -37.7742 420.458 -37.9529 421.776 -37.9727C423.096 -37.9948 424.276 -37.8642 425.269 -37.709C426.262 -37.5579 427.07 -37.3657 427.646 -37.233L428.69 -36.9731C429.045 -36.8906 429.419 -36.816 429.771 -36.7438C430.378 -36.6242 431.227 -36.4356 432.428 -36.2523C433.028 -36.1615 433.721 -36.0769 434.532 -36.0632C435.339 -36.0534 436.29 -36.1149 437.298 -36.4729C437.804 -36.6385 438.302 -36.8957 438.794 -37.2048C439.033 -37.3787 439.288 -37.5351 439.516 -37.7605C439.63 -37.869 439.756 -37.968 439.863 -38.0906C439.969 -38.2173 440.076 -38.3441 440.183 -38.4708C440.585 -39.0093 440.922 -39.6533 441.087 -40.36C441.245 -41.0619 441.295 -41.8006 441.211 -42.5236C441.061 -43.9793 440.534 -45.3835 439.853 -46.7869C439.509 -47.4894 439.114 -48.1853 438.684 -48.8866C438.47 -49.2437 438.255 -49.5754 438.036 -49.9299C437.987 -50.0054 437.941 -50.0791 437.892 -50.1546L437.861 -50.2043C437.876 -50.2183 437.894 -50.2303 437.914 -50.2446C437.836 -50.198 438.202 -50.4311 438.461 -50.5962C439.016 -50.9486 439.658 -51.3547 440.372 -51.809C441.803 -52.7114 443.524 -53.7985 445.425 -54.9977C446.336 -55.5719 447.291 -56.1709 448.275 -56.789L448.326 -56.8229C448.342 -56.8285 448.363 -56.8575 448.374 -56.8291L448.412 -56.782L448.504 -56.6579C448.854 -56.1741 449.194 -55.6643 449.531 -55.1417C449.866 -54.6085 450.202 -54.0711 450.54 -53.5318C450.86 -52.9887 451.204 -52.4562 451.506 -51.9012C452.14 -50.8042 452.697 -49.6712 453.218 -48.5372C454.609 -45.4748 455.414 -42.5189 455.622 -39.8407C455.835 -37.1587 455.451 -34.7733 454.708 -32.833C453.969 -30.8848 452.931 -29.3702 451.906 -28.2006C450.869 -27.0365 449.854 -26.1974 448.994 -25.5647C448.74 -25.3769 448.489 -25.1936 448.225 -25.0259C447.964 -24.8543 447.711 -24.6813 447.441 -24.5299C447.177 -24.3728 446.912 -24.2175 446.652 -24.0608C446.391 -23.9059 446.118 -23.7795 445.858 -23.6394C445.335 -23.3486 444.792 -23.1336 444.267 -22.8909C444.001 -22.7819 443.73 -22.6891 443.467 -22.5865L443.07 -22.4368L442.67 -22.3139C441.607 -21.9637 440.54 -21.7558 439.49 -21.6187C438.439 -21.4751 437.397 -21.4582 436.377 -21.4936C435.354 -21.5266 434.349 -21.6452 433.361 -21.7966C432.866 -21.869 432.377 -21.9631 431.889 -22.0529C431.396 -22.1508 430.914 -22.258 430.418 -22.3472C429.434 -22.5326 428.468 -22.7237 427.477 -22.8686C426.491 -23.014 425.476 -23.1064 424.439 -23.0396C423.318 -22.955 422.489 -22.6083 422.02 -22.2885C421.775 -22.1351 421.62 -21.979 421.526 -21.8617C421.431 -21.7444 421.396 -21.6575 421.422 -21.6051L421.393 -21.4788C421.408 -21.4697 421.421 -21.4749 421.419 -21.4957L421.417 -21.6089L421.441 -21.5816C421.478 -21.5345 421.572 -21.5216 421.717 -21.5384C421.86 -21.5571 422.053 -21.6116 422.306 -21.665C422.804 -21.7878 423.52 -21.9506 424.501 -21.9791C426.333 -22.0036 428.217 -21.4933 430.151 -21.0651C432.069 -20.5956 434.122 -20.121 436.309 -19.9979C437.401 -19.9331 438.53 -19.9303 439.679 -20.0655C440.824 -20.1921 441.997 -20.4071 443.155 -20.7739L443.593 -20.9042L444.026 -21.0614C444.313 -21.168 444.608 -21.2671 444.896 -21.3844C445.464 -21.6371 446.054 -21.8709 446.616 -22.1755C446.899 -22.3238 447.191 -22.4604 447.471 -22.6231C447.751 -22.7858 448.03 -22.9527 448.316 -23.1181C448.602 -23.2793 448.877 -23.4647 449.157 -23.6505C449.44 -23.8303 449.714 -24.0282 449.988 -24.2304C450.841 -24.8582 451.905 -25.7016 453.021 -26.8957C453.309 -27.1871 453.571 -27.5225 453.863 -27.8605C454.004 -28.0321 454.137 -28.2178 454.276 -28.4019C454.418 -28.5841 454.554 -28.7744 454.686 -28.9767C455.233 -29.7648 455.74 -30.6669 456.174 -31.6739C457.054 -33.6806 457.614 -36.1379 457.566 -38.8279C457.534 -41.5171 456.936 -44.407 455.846 -47.313C455.131 -49.2086 454.232 -51.0191 453.22 -52.7275C453 -53.1092 452.768 -53.4857 452.531 -53.8595C452.294 -54.2398 452.058 -54.6159 451.817 -54.9852C451.333 -55.728 450.844 -56.4872 450.306 -57.24C450.171 -57.4276 450.035 -57.6151 449.893 -57.8043C449.653 -58.1255 449.383 -58.4567 449.123 -58.7678L448.927 -59.0067L448.828 -59.1241L448.779 -59.1849L448.713 -59.1435L448.187 -58.821L447.222 -58.2106C446.463 -57.721 445.702 -57.2332 444.944 -56.7458C443.425 -55.7748 441.918 -54.8133 440.448 -53.8739C438.753 -52.7996 437.104 -51.7523 435.527 -50.7531C435.991 -50.0108 436.451 -49.2806 436.903 -48.5602C437.066 -48.3037 437.217 -48.0566 437.362 -47.8111C437.505 -47.5633 437.664 -47.3253 437.793 -47.0784C438.349 -46.1047 438.792 -45.1297 439.105 -44.1938C439.417 -43.2556 439.58 -42.3464 439.535 -41.5453C439.493 -40.7422 439.25 -40.0623 438.851 -39.5598C438.46 -39.0496 437.954 -38.691 437.475 -38.4375C436.995 -38.1882 436.554 -38.0451 436.181 -37.9645C435.996 -37.9233 435.825 -37.9043 435.679 -37.8769C435.529 -37.8639 435.404 -37.8531 435.302 -37.8421C435.2 -37.8312 435.122 -37.8308 435.068 -37.8302C435.013 -37.8297 434.988 -37.8275 434.988 -37.8275C434.988 -37.8275 434.871 -37.8258 434.651 -37.8214C434.54 -37.8264 434.399 -37.8289 434.237 -37.8337C434.073 -37.8405 433.88 -37.8594 433.667 -37.8766C432.801 -37.959 431.531 -38.193 429.936 -38.5373C429.151 -38.6875 428.292 -38.9299 427.33 -39.1213C426.369 -39.3108 425.335 -39.5003 424.228 -39.5889C423.123 -39.684 421.952 -39.7105 420.741 -39.6161C419.533 -39.5114 418.291 -39.2883 417.058 -38.9422C415.82 -38.5999 414.613 -38.0966 413.43 -37.5304C412.848 -37.2281 412.256 -36.9335 411.697 -36.5849C411.125 -36.2584 410.565 -35.8951 410.019 -35.512C407.837 -33.9779 405.925 -31.9888 404.62 -29.7209C403.3 -27.462 402.621 -24.9776 402.422 -22.6921C402.327 -21.5467 402.342 -20.4485 402.416 -19.4205C402.469 -18.9089 402.508 -18.4129 402.588 -17.9394C402.625 -17.7034 402.656 -17.469 402.697 -17.2417C402.742 -17.0148 402.786 -16.792 402.83 -16.5776C403.106 -15.2754 403.444 -14.0752 403.836 -12.9845C404.024 -12.4364 404.237 -11.9177 404.431 -11.4142C404.65 -10.9212 404.839 -10.434 405.058 -9.98298C405.906 -8.16173 406.754 -6.6679 407.532 -5.40717C408.303 -4.16047 408.956 -3.11338 409.589 -2.21778C409.677 -2.09742 409.763 -1.97896 409.846 -1.8624C409.972 -1.69494 410.097 -1.53165 410.231 -1.36908C410.364 -1.21067 410.493 -1.0519 410.619 -0.899205C410.683 -0.822855 410.748 -0.748768 410.811 -0.672419C410.838 -0.607579 410.885 -0.664166 410.925 -0.684437L411.049 -0.758101C411.375 -0.947891 411.688 -1.14077 411.994 -1.33518C412.199 -1.46416 412.396 -1.58825 412.583 -1.70518C414.541 -2.94081 416.392 -4.10837 418.154 -5.22217C419.034 -5.78098 419.891 -6.32738 420.73 -6.86175C421.15 -7.13101 421.563 -7.39348 421.975 -7.65786C422.182 -7.7891 422.388 -7.9245 422.593 -8.05348L423.1 -8.37651L423.351 -8.53671L423.58 -8.69928L424.035 -9.02403L424.063 -9.04323L424.074 -9.05681C424.074 -9.05681 424.071 -9.06287 424.069 -9.06894L424.03 -9.12852L423.95 -9.24961L423.794 -9.48571C423.591 -9.79544 423.369 -10.1056 423.118 -10.405L422.846 -10.7381L422.646 -10.9914C422.584 -11.0742 422.525 -11.1592 422.472 -11.2385L422.296 -11.5213C422.062 -11.9038 421.823 -12.2818 421.616 -12.6688C421.392 -13.0502 421.203 -13.4408 421.015 -13.8274C420.658 -14.6063 420.324 -15.3894 420.137 -16.1874C419.943 -16.9804 419.861 -17.7833 419.977 -18.536L419.987 -18.5349Z" fill="#0055CC"/>
<path d="M375.063 24.9613C374.963 24.9469 374.87 24.934 374.776 24.9211C374.684 24.9207 374.594 24.9181 374.507 24.9151C374.335 24.9132 374.174 24.9167 374.025 24.9233C373.73 24.9258 373.486 24.9952 373.295 25.0474C372.911 25.1605 372.732 25.2998 372.737 25.4357C372.745 25.5735 372.937 25.7079 373.298 25.8109C373.477 25.8688 373.704 25.8932 373.964 25.9651C374.095 25.9937 374.236 26.0234 374.387 26.046C374.461 26.0584 374.54 26.0705 374.623 26.0822C374.702 26.1026 374.783 26.1207 374.867 26.1407C375.825 26.3325 376.729 26.7137 377.473 27.3312C378.22 27.9441 378.807 28.785 379.24 29.7755C379.678 30.7657 379.967 31.901 380.15 33.1252C380.208 33.4286 380.237 33.7429 380.273 34.0629C380.311 34.3807 380.35 34.7026 380.365 35.0327C380.388 35.3644 380.408 35.6983 380.431 36.0384C380.447 36.3874 380.465 36.7426 380.481 37.1C380.568 38.5486 380.642 39.8241 380.666 40.2417C381.225 40.2059 381.762 40.1741 382.279 40.1418C382.607 40.1197 382.919 40.0968 383.222 40.0768C383.739 40.0362 384.218 39.9989 384.668 39.964C385.568 39.8902 386.356 39.8262 387.106 39.7653C388.606 39.6437 389.965 39.5385 391.821 39.449C393.519 39.3668 395.452 39.2727 397.832 39.1566C397.789 38.0735 397.747 36.9566 397.702 35.8254C397.669 34.9323 397.636 34.0245 397.605 33.125C397.53 31.3039 397.376 29.4981 397.138 27.8338C396.902 26.1715 396.583 24.6549 396.247 23.4104C395.91 22.1659 395.554 21.1981 395.327 20.6092C395.161 20.1725 394.959 19.7431 394.754 19.3202C394.367 18.5733 393.65 17.1667 392.278 15.5734C391.593 14.7809 390.741 13.9525 389.693 13.2062C388.648 12.4595 387.41 11.801 386.039 11.3281C384.669 10.8447 383.165 10.5723 381.624 10.4666C380.079 10.3572 378.499 10.4312 376.908 10.6467C373.722 11.0467 370.51 12.3407 368.007 14.3579C366.235 15.781 364.937 17.3979 363.976 18.95C363.746 19.3434 363.514 19.7244 363.305 20.1013C363.11 20.4854 362.924 20.8582 362.739 21.2205C362.569 21.5877 362.42 21.9489 362.268 22.3C362.215 22.422 362.163 22.544 362.112 22.6638C362.01 22.8133 362.067 22.9888 362.062 23.1549C362.073 23.3492 362.081 23.5415 362.091 23.7274C362.225 26.4708 362.325 28.491 362.392 29.8763C362.478 31.4741 362.561 32.9734 362.623 34.1577L364.386 34.2336C364.674 32.0726 365.411 30.2357 366.575 28.8843C367.741 27.5432 369.26 26.6687 370.916 26.2336C371.517 26.0786 371.977 25.9401 372.284 25.8233C372.59 25.6982 372.75 25.5626 372.742 25.4437C372.74 25.3221 372.569 25.2173 372.224 25.1508C371.88 25.0778 371.359 25.0726 370.681 25.1943C368.823 25.5253 366.976 26.4093 365.521 27.937C364.067 29.4689 363.142 31.6116 362.786 34.0198L364.239 34.0827C364.187 32.8954 364.122 31.3966 364.054 29.7974C363.992 28.5249 363.955 26.5621 363.894 23.9844C363.891 23.8231 363.885 23.66 363.883 23.4923L363.878 23.2409L363.877 23.1781L363.878 23.1675L363.881 23.1505C363.881 23.1505 363.892 23.1327 363.903 23.1108C363.934 23.0409 363.966 22.971 364 22.903C364.071 22.75 364.141 22.5928 364.214 22.4376C364.35 22.1194 364.523 21.8086 364.694 21.4895C364.779 21.329 364.866 21.1662 364.953 21.0034C365.043 20.8403 365.147 20.6844 365.242 20.5209C366.022 19.2216 367.014 17.8998 368.295 16.6977C368.509 16.507 368.703 16.2951 368.929 16.1223L369.589 15.5804C369.811 15.3996 370.05 15.2488 370.278 15.0779L370.624 14.8277L370.986 14.6032C371.25 14.4461 371.505 14.2666 371.785 14.127C372.062 13.9854 372.345 13.8413 372.625 13.6975C373.21 13.4516 373.797 13.1846 374.426 13.0021C374.736 12.8997 375.044 12.7954 375.367 12.7275C375.686 12.6516 376.006 12.5651 376.327 12.4994C376.979 12.3905 377.629 12.2649 378.288 12.2204C380.921 11.946 383.526 12.209 385.614 12.968C386.66 13.3411 387.579 13.8238 388.345 14.3365C389.111 14.8534 389.716 15.401 390.206 15.8705C390.437 16.1191 390.649 16.3399 390.826 16.5386C390.997 16.7441 391.142 16.9203 391.259 17.0654C391.379 17.2083 391.454 17.3297 391.516 17.4083C391.573 17.4873 391.601 17.5268 391.601 17.5268C391.873 17.8747 392.103 18.2575 392.347 18.6288C392.569 19.0166 392.801 19.393 392.997 19.7977C393.412 20.5906 393.761 21.4207 394.07 22.2646C394.683 23.9614 395.133 25.7269 395.443 27.5254C395.758 29.3236 395.953 31.1448 396.065 32.9773C396.125 33.8891 396.162 34.828 396.208 35.7514L396.305 37.7845L390.608 38.0895L382.223 38.5415L382.147 37.0331C382.088 35.6115 381.988 34.1912 381.763 32.8742C381.542 31.5526 381.199 30.294 380.646 29.1459C380.101 28.0035 379.328 26.971 378.338 26.2428C377.353 25.5077 376.197 25.1148 375.079 24.9746L375.063 24.9613Z" fill="#0055CC"/>
<path d="M402.801 24.9656C402.203 22.6548 401.239 22.8832 401.63 25.2097C401.897 26.8631 402.16 28.5525 402.386 30.3878C402.496 31.3035 402.599 32.2556 402.664 33.2487C402.731 34.2438 402.77 35.2853 402.721 36.368C402.716 36.4986 402.712 36.6269 402.706 36.7533C402.692 36.9308 402.68 37.106 402.667 37.2728C402.649 37.501 402.616 37.7284 402.587 37.947C402.549 38.1706 402.513 38.3836 402.478 38.5859C402.35 39.3629 402.251 39.9632 402.194 40.3059C402.264 40.2831 402.36 40.2328 402.447 40.1938C402.536 40.1525 402.622 40.1093 402.707 40.0684C402.88 39.9863 403.049 39.9045 403.212 39.8253C403.541 39.6688 403.857 39.5134 404.161 39.3675C404.461 39.2218 404.753 39.0811 405.035 38.9434C405.166 38.8796 405.295 38.8181 405.42 38.7569C405.494 38.719 405.569 38.681 405.641 38.6454C406.222 38.3495 406.739 38.0886 407.235 37.8379C408.23 37.334 409.152 36.8765 410.402 36.3086C413.075 35.0677 416.694 33.4635 419.925 32.0504C420.732 31.6972 421.514 31.3587 422.252 31.0366C422.623 30.8766 422.982 30.7195 423.328 30.5699C423.651 30.4244 423.969 30.2815 424.278 30.1435L424.51 30.0373L424.627 29.9852C424.643 29.9754 424.67 29.971 424.679 29.9555L424.669 29.8934C424.645 29.7298 424.621 29.5703 424.596 29.4109C424.469 28.5658 424.357 27.8075 424.263 27.1716C424.181 26.6584 424.115 26.2443 424.066 25.9443C424.009 25.5906 423.941 25.2398 423.864 24.8897C423.747 24.3627 423.548 23.4609 423.258 22.267C423.115 21.6751 422.945 20.9912 422.762 20.281C422.599 19.5649 422.429 18.7845 422.257 17.937C421.919 16.25 421.588 14.3419 421.404 12.3017C421.312 11.2815 421.271 10.2275 421.314 9.17048C421.331 8.90671 421.348 8.64295 421.367 8.37693L421.413 7.98269L421.436 7.78557L421.445 7.71975C421.453 7.66451 421.46 7.64713 421.465 7.60892L421.506 7.4081C421.68 6.38378 422.084 5.13595 422.384 4.06711C422.287 4.10077 422.129 4.17316 421.956 4.25533C421.78 4.3356 421.585 4.42601 421.371 4.52428C420.941 4.7231 420.436 4.95568 419.886 5.21114C419.131 5.55774 418.245 5.96396 417.367 6.3653C411.226 9.21824 407.424 10.9851 405.438 11.9042C404.269 12.4546 403.174 12.9712 402.136 13.462C401.618 13.7104 401.117 13.9532 400.623 14.1911C400.196 14.396 399.771 14.5986 399.352 14.7986C399.183 14.8195 399.29 14.9823 399.295 15.091L399.363 15.446C399.409 15.6812 399.454 15.9123 399.497 16.1457C399.555 16.4219 399.614 16.6958 399.671 16.9678C399.726 17.219 399.783 17.4679 399.838 17.715C399.952 18.2087 400.069 18.6937 400.19 19.17C400.43 20.1249 400.684 21.0492 400.954 21.9637C401.557 23.9739 402.388 23.7488 401.992 21.7122C401.823 20.7825 401.653 19.851 401.478 18.8926C401.397 18.415 401.313 17.9312 401.226 17.4373C401.149 16.9592 401.07 16.4752 400.989 15.9786L400.974 15.8456L400.966 15.7812C400.966 15.7623 400.949 15.7324 400.982 15.7295L401.11 15.6785L401.173 15.6542L401.28 15.6092C401.78 15.3876 402.289 15.1588 402.814 14.9244C403.86 14.4477 404.962 13.9451 406.136 13.4069C407.958 12.5628 411.855 11.0143 417.234 8.56739C417.672 8.36786 418.107 8.16225 418.54 7.95474L419.186 7.63645L419.508 7.47429C419.526 7.46225 419.52 7.46071 419.527 7.45166C419.541 7.43581 419.56 7.41318 419.589 7.38756L419.638 7.34764L419.667 7.32619C419.667 7.32619 419.691 7.30737 419.688 7.31606C419.694 7.34069 419.694 7.39103 419.696 7.4622L419.696 7.51671L419.663 7.87844C419.633 8.14329 419.62 8.40669 419.607 8.67009C419.56 9.72334 419.595 10.7652 419.667 11.7724C419.824 13.7898 420.128 15.6834 420.427 17.3172C420.573 18.1354 420.726 18.8859 420.861 19.5603C421 20.2365 421.126 20.8298 421.25 21.3122C421.469 22.2689 421.597 22.8286 421.597 22.8286C421.597 22.8286 421.823 23.7951 422.142 25.3537C422.301 26.133 422.48 27.0597 422.663 28.0908C422.702 28.3203 422.743 28.5559 422.785 28.7957L422.803 28.9075L422.812 28.9654C422.818 28.9859 422.785 28.9846 422.771 28.9963C422.384 29.1767 421.984 29.3624 421.575 29.5511C417.19 31.5824 412.042 33.9717 408.986 35.3886L405.982 36.7841L404.671 37.3929L404.467 37.4882L404.366 37.5347L404.316 37.558L404.289 37.5708C404.289 37.5708 404.28 37.5779 404.277 37.576L404.28 37.5631C404.303 37.4584 404.319 37.3521 404.328 37.2442L404.345 37.0687C404.365 36.8613 404.372 36.6551 404.381 36.4465C404.431 35.2672 404.374 34.1685 404.284 33.1272C404.194 32.0859 404.057 31.1094 403.903 30.1765C403.593 28.3087 403.216 26.6124 402.802 24.9739L402.801 24.9656Z" fill="#0055CC"/>
<path d="M384.78 4.00317C387.938 3.20902 387.727 2.24328 384.526 2.8355C382.254 3.25484 379.932 3.70159 377.414 4.2115C376.157 4.47157 374.85 4.74014 373.477 5.02282C372.791 5.16832 372.086 5.31754 371.367 5.47009L371.218 5.49975C371.197 5.50156 371.166 5.52111 371.163 5.48779C371.092 5.3198 371.022 5.14955 370.951 4.97739C369.623 1.76683 368.946 -0.312608 368.381 -2.12056C367.842 -3.9371 367.411 -5.50071 367.051 -7.83206C366.893 -8.815 366.773 -9.88939 366.688 -11.0193C366.622 -12.1487 366.576 -13.3344 366.64 -14.536C366.704 -15.7375 366.819 -16.9582 367.064 -18.1397C367.308 -19.3212 367.637 -20.4743 368.076 -21.5384C368.18 -21.8056 368.312 -22.0583 368.428 -22.3159C368.488 -22.4429 368.547 -22.5717 368.605 -22.6964C368.676 -22.8221 368.743 -22.9475 368.812 -23.071C369.086 -23.5669 369.355 -24.0518 369.614 -24.5212C369.889 -24.9814 370.184 -25.4057 370.452 -25.8255C370.59 -26.0304 370.716 -26.2407 370.855 -26.4332C371 -26.62 371.14 -26.8041 371.278 -26.9818C371.556 -27.3353 371.803 -27.6799 372.06 -27.9813C372.327 -28.2708 372.576 -28.5442 372.802 -28.7905C373.238 -29.3046 373.671 -29.64 373.952 -29.9099L374.459 -30.3798L375.001 -30.8128C375.161 -30.9442 375.356 -31.1016 375.579 -31.2847C375.688 -31.3822 375.817 -31.471 375.954 -31.5606C376.091 -31.6542 376.237 -31.7509 376.39 -31.8543C376.986 -32.2879 377.767 -32.7207 378.666 -33.1973C380.483 -34.1269 382.926 -34.9702 385.749 -35.687C386.452 -35.8718 387.182 -36.0463 387.929 -36.2181C388.673 -36.3959 389.442 -36.5611 390.222 -36.7357C390.745 -36.8524 391.276 -36.9698 391.811 -37.0875C391.827 -37.0973 391.829 -37.0806 391.834 -37.0685L391.843 -37.0295L391.877 -36.8813C391.965 -36.4755 392.052 -36.0698 392.138 -35.6618C392.826 -32.3978 393.535 -29.0517 394.215 -25.8333C394.699 -23.5608 395.138 -21.507 395.533 -19.657C395.709 -18.833 395.874 -18.0563 396.03 -17.3228L396.047 -17.2508C396.046 -17.2319 396.008 -17.237 395.99 -17.2291C395.759 -17.1839 395.532 -17.139 395.315 -17.0972C393.858 -16.8198 392.563 -16.5564 391.456 -16.2549C390.349 -15.9574 389.427 -15.6237 388.695 -15.2811C387.829 -14.8809 387.014 -14.3843 386.312 -13.7653C385.606 -13.1501 385.025 -12.4137 384.602 -11.6258C384.182 -10.8319 383.945 -10.0036 383.788 -9.19684C383.737 -8.79165 383.662 -8.39072 383.656 -7.99783C383.648 -7.79989 383.64 -7.60612 383.631 -7.41235C383.631 -7.2193 383.643 -7.02734 383.649 -6.83691C383.805 -3.79328 384.714 -1.22835 385.709 1.20748C386.262 2.50247 386.762 3.06972 386.983 3.0044L386.993 2.90906C386.995 2.92988 387.006 2.93939 387.029 2.93532L387.023 2.9883C387.233 2.86729 387.157 2.12695 386.709 0.831265C385.907 -1.60452 385.185 -4.13535 385.149 -6.8662C385.149 -7.03616 385.145 -7.20576 385.149 -7.37608C385.164 -7.54521 385.174 -7.71399 385.187 -7.88504C385.199 -8.2302 385.278 -8.56223 385.326 -8.90422C385.476 -9.57396 385.682 -10.2423 386.022 -10.8571C386.365 -11.4682 386.82 -12.0321 387.389 -12.52C387.957 -13.0078 388.635 -13.4232 389.39 -13.7698C389.972 -14.0448 390.76 -14.3208 391.748 -14.5722C392.735 -14.8236 393.919 -15.0374 395.292 -15.2697C395.66 -15.3352 396.039 -15.3995 396.429 -15.469C396.772 -15.5364 397.118 -15.6043 397.469 -15.6724C397.646 -15.7088 397.826 -15.7432 398.003 -15.7796L398.137 -15.8059L398.206 -15.8181C398.206 -15.8181 398.218 -15.8192 398.222 -15.8237L398.22 -15.8404L398.213 -15.8733L398.161 -16.1416C397.961 -17.1481 397.754 -18.2066 397.532 -19.3163C397.2 -21.0059 396.833 -22.8478 396.421 -24.8327C396.152 -26.1249 395.86 -27.4132 395.553 -28.6874C394.886 -31.4349 394.198 -34.3926 393.546 -37.2862L393.341 -38.2231L393.235 -38.7028L393.183 -38.9396L393.156 -39.0589C393.152 -39.0775 393.15 -39.1025 393.141 -39.1143L393.079 -39.1005C392.467 -38.9657 391.858 -38.8289 391.251 -38.6944C390.541 -38.5343 389.839 -38.3748 389.149 -38.2206C387.771 -37.9081 386.435 -37.6014 385.194 -37.2777C382.705 -36.6507 380.584 -35.9233 379.116 -35.303C378.753 -35.1373 378.426 -34.9872 378.141 -34.8597C377.997 -34.7948 377.866 -34.7352 377.745 -34.6785C377.627 -34.6158 377.521 -34.5583 377.422 -34.5058C377.038 -34.2962 376.829 -34.1816 376.829 -34.1816C376.829 -34.1816 376.751 -34.1391 376.605 -34.0572C376.459 -33.9712 376.233 -33.8676 375.972 -33.6855C375.704 -33.5091 375.379 -33.2921 374.999 -33.0431C374.904 -32.9803 374.807 -32.9152 374.705 -32.8498C374.611 -32.7744 374.511 -32.6965 374.413 -32.6167C374.213 -32.4566 373.998 -32.2891 373.775 -32.1102C373.313 -31.7722 372.875 -31.3252 372.39 -30.8677C371.887 -30.4254 371.447 -29.8606 370.947 -29.3074C370.689 -29.0333 370.468 -28.7245 370.238 -28.4087C370.006 -28.097 369.77 -27.7743 369.529 -27.4513C369.295 -27.1226 369.093 -26.7673 368.869 -26.4185C368.652 -26.0639 368.416 -25.714 368.211 -25.3458C368.012 -24.9719 367.81 -24.5935 367.61 -24.2131C367.412 -23.8267 367.19 -23.4612 367.018 -23.0414C366.838 -22.6334 366.644 -22.2242 366.501 -21.7963L366.27 -21.1595C366.194 -20.9452 366.142 -20.7266 366.076 -20.5111C365.569 -18.7781 365.306 -16.9907 365.209 -15.2722C365.017 -11.8291 365.44 -8.6765 365.857 -6.37103C366.505 -2.89797 367.285 -0.399449 367.899 1.48819C368.53 3.37439 369.032 4.64646 369.43 5.61072C369.519 5.81702 369.604 6.02368 369.693 6.2258C369.821 6.52311 369.954 6.82006 370.092 7.11438L370.193 7.33434L370.219 7.39085C370.227 7.40905 370.255 7.38986 370.274 7.39032L370.391 7.36545L370.861 7.27014C371.154 7.20702 371.444 7.142 371.732 7.07923C372.451 6.91835 373.155 6.76081 373.838 6.60923C375.206 6.2955 376.507 5.99813 377.757 5.70926C380.258 5.1232 382.558 4.56506 384.799 4.00364L384.78 4.00317Z" fill="#0055CC"/>
<path d="M289.604 -5.95927C289.825 -7.16812 289.658 -7.81042 289.394 -7.85468C289.12 -7.90012 288.748 -7.36645 288.444 -6.25107C287.978 -4.67267 287.331 -3.1185 286.404 -1.58822C285.451 -0.0788647 284.202 1.41638 282.444 2.63884C282.187 2.81642 281.946 2.9884 281.706 3.1267C281.648 3.16317 281.588 3.19774 281.53 3.23421L281.447 3.28762C281.447 3.28762 281.409 3.30978 281.377 3.32517L281.29 3.36835C281.059 3.48283 280.835 3.59242 280.626 3.69867C280.424 3.80645 280.211 3.89829 280.009 3.98299C279.81 4.06733 279.626 4.14832 279.454 4.2199C279.131 4.36125 278.862 4.47897 278.656 4.5682C278.704 4.61647 278.78 4.66864 278.853 4.71892C278.925 4.77146 278.996 4.81983 279.068 4.87237C279.209 4.97138 279.347 5.07265 279.484 5.16786C279.754 5.36053 280.016 5.54559 280.268 5.72304C280.518 5.89859 280.76 6.0707 280.994 6.2371C281.17 6.35821 281.342 6.47968 281.508 6.59544C282.011 6.93785 282.46 7.2452 282.899 7.54495C283.773 8.1448 284.593 8.71793 285.64 9.49792C286.838 10.3781 288.231 11.4219 289.677 12.5177C290.398 13.0658 291.134 13.6272 291.868 14.1826C292.068 14.3352 292.27 14.4898 292.47 14.6424L292.955 15.0033L293.076 15.0935L293.136 15.1365L293.166 15.1612C293.166 15.1612 293.19 15.1507 293.202 15.1455L293.482 15.0373L294.04 14.8189L294.428 14.6468C294.65 14.5436 294.865 14.4306 295.078 14.3198C295.921 13.8585 296.673 13.3087 297.317 12.722C297.483 12.5796 297.641 12.4338 297.785 12.2807C297.933 12.1314 298.078 11.9825 298.221 11.84C298.484 11.5361 298.742 11.243 298.969 10.9548C299.883 9.79918 300.394 8.76454 300.697 8.20105C300.87 7.86299 301.007 7.51115 301.151 7.16086C301.27 6.89033 301.388 6.50663 301.543 6.03374C301.71 5.56394 301.847 4.99179 302.013 4.33953C302.105 4.01476 302.163 3.66562 302.234 3.29648C302.303 2.93376 302.376 2.55402 302.45 2.15726C302.521 1.78395 302.597 1.39552 302.673 0.992327C302.769 0.593762 302.883 0.187326 302.989 -0.237315C303.46 -1.91903 304.268 -3.72008 305.478 -5.37976C306.096 -6.19706 306.82 -6.9753 307.642 -7.65926C308.05 -8.00731 308.494 -8.31432 308.949 -8.61183L309.48 -8.92643C309.722 -9.05865 309.971 -9.18934 310.24 -9.31123C310.758 -9.55548 311.278 -9.80199 311.8 -10.0466C311.202 -10.492 309.695 -11.6078 308.218 -12.703C305.465 -14.7241 303.236 -16.3585 301.476 -17.6495C300.595 -18.2971 299.83 -18.8559 299.173 -19.3383C298.846 -19.5785 298.546 -19.8001 298.271 -20.0007C298.038 -20.1694 297.818 -20.3308 297.61 -20.4827C297.494 -20.565 297.378 -20.6472 297.27 -20.726C297.244 -20.7594 297.213 -20.7357 297.182 -20.7226L297.092 -20.6791C297.033 -20.6509 296.971 -20.6224 296.914 -20.5965C296.644 -20.4641 296.349 -20.3377 296.113 -20.204C295.961 -20.1194 295.804 -20.0429 295.661 -19.9466C295.516 -19.8563 295.37 -19.7661 295.229 -19.6762C295.09 -19.5803 294.954 -19.4824 294.82 -19.3869C294.549 -19.1934 294.3 -18.9851 294.054 -18.7791C293.819 -18.5594 293.574 -18.3598 293.365 -18.1298C292.493 -17.2443 291.803 -16.2907 291.244 -15.3315C290.158 -13.3931 289.552 -11.4542 289.197 -9.52671C288.87 -7.38335 289.73 -7.29835 290.238 -9.28538C290.758 -11.0888 291.464 -12.8475 292.528 -14.5574C293.072 -15.4019 293.716 -16.2236 294.498 -16.9838C294.687 -17.1806 294.905 -17.3485 295.111 -17.5384C295.329 -17.7105 295.547 -17.8909 295.782 -18.0519C295.901 -18.1335 296.018 -18.2129 296.139 -18.2968C296.263 -18.3705 296.386 -18.4483 296.512 -18.5243C296.637 -18.6044 296.768 -18.6682 296.898 -18.7403C296.958 -18.7749 296.982 -18.7854 297.027 -18.806C297.043 -18.8116 297.059 -18.8214 297.075 -18.827C297.089 -18.8156 297.105 -18.8023 297.118 -18.7909C297.157 -18.7585 297.195 -18.7262 297.236 -18.692C297.49 -18.4937 297.769 -18.2786 298.075 -18.0408C298.684 -17.5628 299.393 -17.0053 300.204 -16.3705C301.821 -15.1028 303.83 -13.5417 306.218 -11.7617C306.608 -11.4723 307 -11.1853 307.395 -10.9069L307.991 -10.4907L308.141 -10.3882C308.141 -10.3882 308.145 -10.3886 308.149 -10.389C308.156 -10.3874 308.164 -10.3881 308.172 -10.3889C308.198 -10.3869 308.247 -10.3723 308.287 -10.3505C308.274 -10.3264 308.253 -10.3015 308.185 -10.2431L308.026 -10.1412L307.856 -10.0215L307.515 -9.7822C307.288 -9.6219 307.077 -9.44412 306.856 -9.27395C305.994 -8.57388 305.217 -7.77012 304.539 -6.92241C303.169 -5.22782 302.263 -3.31968 301.676 -1.61952C301.604 -1.40558 301.532 -1.1958 301.461 -0.992448C301.389 -0.786833 301.346 -0.579579 301.287 -0.381476C301.185 0.0197139 301.063 0.395451 300.994 0.762334C300.848 1.4779 300.721 2.10572 300.615 2.62689C300.509 3.12497 300.445 3.52707 300.363 3.79018C300.29 4.05674 300.25 4.20078 300.25 4.20078C300.25 4.20078 300.188 4.43483 300.074 4.86019C300.018 5.07269 299.922 5.32023 299.824 5.6162C299.724 5.91027 299.618 6.24672 299.46 6.60036C299.308 6.95554 299.158 7.35463 298.943 7.75307C298.84 7.95289 298.734 8.1614 298.625 8.37859C298.502 8.58437 298.376 8.79468 298.248 9.01141C297.713 9.8635 297.042 10.7483 296.207 11.5257C296.102 11.623 295.997 11.7202 295.892 11.8174C295.785 11.9127 295.666 11.9985 295.555 12.09C295.334 12.2791 295.092 12.4386 294.853 12.6083C294.734 12.6941 294.604 12.7621 294.482 12.8418C294.359 12.9197 294.233 12.9956 294.101 13.0617C293.97 13.1296 293.844 13.2056 293.709 13.2614L293.533 13.3417C293.509 13.3522 293.493 13.3619 293.472 13.3679C293.433 13.3734 293.389 13.4255 293.358 13.3799L293.237 13.2897C292.982 13.102 292.724 12.9124 292.469 12.7247C291.958 12.3494 291.452 11.9778 290.954 11.6139C288.967 10.1558 287.13 8.80428 285.762 7.80036L283.266 5.96879L282.16 5.15826L281.992 5.03643L281.909 4.97438L281.868 4.94015C281.868 4.94015 281.82 4.91912 281.851 4.91433C281.973 4.86601 282.09 4.80973 282.204 4.74737L282.226 4.73497L282.264 4.71279L282.428 4.61469L282.757 4.42037C282.977 4.29221 283.184 4.13788 283.397 3.99986C285.383 2.6065 286.754 0.888816 287.729 -0.813492C288.682 -2.53899 289.266 -4.26186 289.612 -5.96416L289.604 -5.95927Z" fill="#0055CC"/>
<path d="M335.18 -24.8556C335.367 -27.0896 334.385 -27.2164 333.994 -25.0108C333.717 -23.4468 333.449 -21.8414 333.182 -20.0956C333.054 -19.2221 332.92 -18.3146 332.78 -17.3583C332.644 -16.3603 332.501 -15.3135 332.351 -14.2073C332.315 -13.902 332.279 -13.6073 332.272 -13.5479C332.586 -13.2373 332.882 -12.942 333.169 -12.6584C333.357 -12.4774 333.536 -12.2999 333.707 -12.1364C334.053 -11.8034 334.368 -11.5034 334.661 -11.2224C335.252 -10.6673 335.75 -10.1985 336.218 -9.76272C337.155 -8.88931 337.961 -8.13454 339.071 -6.99696C339.768 -6.28315 340.543 -5.4922 341.538 -4.47471C342.213 -4.57105 342.912 -4.67145 343.62 -4.77484C344.209 -4.85527 344.811 -4.93678 345.41 -5.02019C346.613 -5.17905 347.818 -5.34016 348.949 -5.49061C351.408 -5.80659 353.549 -6.08036 354.718 -6.22989C354.939 -6.58062 355.125 -6.88001 355.282 -7.13069C355.375 -7.27301 355.451 -7.3908 355.515 -7.49084C355.643 -7.68865 355.727 -7.81548 355.797 -7.92231C355.981 -8.20051 356.158 -8.48443 356.33 -8.77214C356.622 -9.26111 357.152 -10.1443 358.014 -11.5787C358.936 -13.098 360.217 -15.2044 361.956 -18.0724C361.796 -18.5474 361.552 -19.2816 361.244 -20.2012C360.997 -20.9457 360.704 -21.8414 360.38 -22.8288C359.735 -24.8082 358.978 -27.1597 358.266 -29.4229L357.826 -30.7822L346.487 -34.4322C346.071 -34.566 345.657 -34.698 345.367 -34.7904C344.773 -34.3822 344.196 -33.9902 343.636 -33.6038C343.197 -33.2972 342.767 -33.0018 342.351 -32.7098C341.523 -32.1239 340.738 -31.567 339.98 -31.0334C338.475 -29.9545 337.106 -28.942 335.757 -27.9207C334.187 -26.7334 334.67 -26.0221 336.355 -27.0389C337.803 -27.9114 339.251 -28.8111 340.81 -29.8065C341.585 -30.3101 342.392 -30.8333 343.246 -31.3858C343.996 -31.883 344.784 -32.4066 345.626 -32.9622C345.717 -32.9323 345.846 -32.889 345.978 -32.8479C346.88 -32.5568 348.252 -32.0525 350.06 -31.4015C350.964 -31.0812 351.977 -30.72 353.094 -30.3258C354.069 -29.9928 355.133 -29.6276 356.281 -29.234L356.327 -29.0953L356.539 -28.457C356.685 -28.0332 356.834 -27.6097 356.99 -27.1931C357.543 -25.6967 358.111 -24.0988 358.656 -22.52C359.156 -21.0526 359.648 -19.6076 360.1 -18.2892L360.045 -18.1921C359.979 -18.0815 359.913 -17.975 359.847 -17.8644C359.702 -17.6273 359.56 -17.3947 359.422 -17.1666C359.143 -16.7102 358.876 -16.2737 358.625 -15.8595C358.115 -15.0327 357.658 -14.2923 357.279 -13.6761C356.512 -12.4473 356.05 -11.7043 356.05 -11.7043L353.657 -7.82492L342.05 -6.02149L339.492 -8.60924L334.019 -14.1379L334.03 -14.2332C334.157 -15.2577 334.277 -16.227 334.393 -17.1498C334.503 -18.1077 334.607 -19.0211 334.706 -19.8962C334.896 -21.6521 335.05 -23.2727 335.182 -24.8537L335.18 -24.8556Z" fill="#0055CC"/>
<path d="M334.463 4.55043C336.378 5.19855 337.423 5.25896 337.511 5.00382C337.601 4.73999 336.74 4.16631 334.878 3.42756C332.352 2.4169 329.793 1.33152 327.049 0.0860085C325.677 -0.537881 324.262 -1.20208 322.786 -1.9218C322.048 -2.27958 321.294 -2.65483 320.524 -3.0434C320.14 -3.23882 319.751 -3.43804 319.356 -3.63881C318.73 -3.96432 318.098 -4.29136 317.454 -4.62376C317.2 -4.26182 316.851 -3.76363 316.498 -3.26091C311.509 3.94463 310.444 5.82257 307.026 10.6636C306.168 11.8815 305.22 13.2247 304.201 14.6706C303.026 16.3251 301.771 18.0936 300.448 19.9519C301.609 20.5878 302.784 21.2287 303.958 21.8718C304.893 22.372 305.832 22.8676 306.756 23.3477C308.612 24.3052 310.431 25.205 312.103 26.0043C315.451 27.6025 318.222 28.8038 319.543 29.3586C320.099 29.5979 320.659 29.8221 321.228 30.0372C323.093 30.7483 327.879 32.5744 334.242 34.4547C337.42 35.4003 340.99 36.3582 344.761 37.2378C346.647 37.6765 348.582 38.0984 350.545 38.4927C351.525 38.691 352.513 38.8802 353.502 39.0631L354.99 39.3328L357.469 39.7599C357.512 39.07 357.618 37.3781 357.721 35.7073C358.398 24.2427 358.818 17.1478 359.038 13.4422C359.115 12.0821 359.191 10.7663 359.248 9.79823C358.525 9.66157 357.813 9.53027 357.113 9.39788C356.669 9.31047 356.23 9.22686 355.799 9.14253C354.934 8.97197 354.095 8.79926 353.278 8.62663C351.643 8.27947 350.096 7.92473 348.607 7.5691C345.63 6.85142 342.892 6.12149 340.191 5.33379C338.504 4.8422 337.595 4.76987 337.515 5.00346C337.437 5.2242 338.192 5.75466 339.861 6.35065C342.533 7.3025 345.259 8.16562 348.242 8.98554C349.733 9.39341 351.289 9.78944 352.935 10.1692C353.757 10.3623 354.602 10.5471 355.474 10.7317C356.136 10.8674 356.819 11.0054 357.52 11.1503C357.485 11.7346 357.434 12.53 357.383 13.3486C357.181 16.7484 356.524 23.8218 355.888 33.8225C355.843 34.6301 355.797 35.4335 355.753 36.2389L355.697 37.4438C355.695 37.5154 355.695 37.4881 355.696 37.4965L355.7 37.5003L355.703 37.5147L355.713 37.5495C355.713 37.5495 355.699 37.557 355.686 37.5581C355.653 37.5568 355.753 37.5796 355.443 37.531C355.007 37.4618 354.566 37.3929 354.124 37.3222C353.241 37.1784 352.344 37.0274 351.449 36.8616C349.654 36.5388 347.844 36.1754 346.062 35.7822C342.497 35.0064 339.05 34.105 336.046 33.2324C333.043 32.3575 330.487 31.5175 328.681 30.8914C327.778 30.573 327.064 30.3202 326.573 30.1467C326.083 29.9667 325.818 29.8679 325.818 29.8679C321.699 28.3744 317.646 26.7051 313.653 24.9006C311.657 23.9951 309.679 23.0545 307.719 22.0746C306.741 21.5844 305.762 21.086 304.793 20.5804L303.34 19.8146L302.638 19.4369L309.085 10.2354C314.014 3.19241 316.386 -0.198335 317.845 -2.28244C317.896 -2.35604 317.946 -2.42965 317.981 -2.48098C318.602 -2.1676 319.205 -1.86528 319.791 -1.56985C320.573 -1.18236 321.337 -0.814252 322.09 -0.459821C323.592 0.247136 325.035 0.892152 326.437 1.484C329.24 2.67411 331.869 3.66742 334.463 4.55459L334.463 4.55043Z" fill="#0055CC"/>
<path d="M266.148 11.4376C265.904 11.2409 261.607 11.6971 262.767 12.4216C263.152 12.7387 263.531 12.7338 263.685 12.3129C263.756 13.1539 264.635 12.0998 265.004 12.398C264.83 12.9693 266.069 11.8381 265.807 12.4269C270.358 13.3708 279.961 8.37317 268.469 10.984C269.573 11.3221 268.502 11.4792 268.006 11.3161C268.775 10.623 266.63 11.1225 266.225 11.3523C266.878 11.3825 265.768 11.8563 266.15 11.4397L266.148 11.4376Z" fill="#101214"/>
<path d="M272.605 3.22316C273.458 2.36056 274.245 3.76267 275.035 3.06913C276.28 1.68993 267.453 -0.414982 267.475 1.23096C267.685 2.6437 272.067 2.52666 272.605 3.22316Z" fill="#101214"/>
<path d="M353.904 0.605135C351.888 -0.0406305 348.015 0.187959 346.143 -0.686571C344.414 -0.564747 342.931 -1.0713 341.224 -1.48882C341.674 -1.91768 342.883 -2.42509 342.976 -2.90903C346.063 -5.01434 340.805 -2.8555 339.877 -1.40738L339.89 -1.40739C339.89 -1.40739 339.691 -1.15637 339.673 -1.19408C339.802 -0.692643 340.458 -0.0652969 340.454 0.283156C343.482 2.73881 344.616 3.1592 341.381 -0.567943C342.528 -0.296267 343.241 0.288849 344.364 0.147743C344.642 0.54692 350.562 1.43902 348.42 0.717936C348.941 0.404403 350.793 1.07698 349.514 1.05847C350.098 1.25533 359.729 2.18758 358.787 0.832591C358.387 0.926263 357.763 0.58519 357.477 0.747534C357.422 0.905176 357.407 1.02061 357.253 0.965295C357.28 0.632353 356.933 0.630529 356.556 0.701981C356.088 0.866753 355.08 0.903412 355.236 0.665757C355.306 0.46149 353.472 0.982932 353.904 0.607357L353.904 0.605135Z" fill="#101214"/>
</g>
<g clipPath="url(#clip2_550_14457)">
<path d="M13.0459 7.94648C13.2244 7.80301 13.375 7.65148 13.5135 7.50519C13.6519 7.3589 13.7767 7.22429 13.8912 7.09266C14.1165 6.83394 14.2962 6.60644 14.4242 6.41279C14.6826 6.0274 14.7534 5.77787 14.657 5.68132C14.5605 5.58477 14.2987 5.63893 13.898 5.85831C13.6977 5.968 13.4612 6.12069 13.1927 6.31602C13.0586 6.41577 12.9146 6.52266 12.7657 6.64468C12.6168 6.7667 12.4583 6.90004 12.2783 7.02685C11.7797 7.3995 11.2791 7.7744 10.7705 8.1542C10.2398 8.49606 9.70493 8.83827 9.16244 9.18954C8.60947 9.51654 8.02636 9.81049 7.44957 10.1291C7.15404 10.2785 6.84575 10.4017 6.5389 10.5416C6.23133 10.6732 5.92782 10.8275 5.60858 10.9454C5.28898 11.0591 4.96332 11.1755 4.63765 11.2918C4.47464 11.3479 4.31044 11.4146 4.1448 11.4646C3.97464 11.5109 3.80449 11.5571 3.63433 11.6033C3.29175 11.6939 2.94835 11.7992 2.59636 11.8779C2.24139 11.9465 1.88225 12.0154 1.51931 12.0888C0.0606176 12.3264 -1.49813 12.4259 -3.12925 12.2945C-3.56103 12.2753 -3.97141 12.2123 -4.35537 12.1637C-4.54794 12.1447 -4.73171 12.1061 -4.90643 12.0751C-4.9938 12.0596 -5.08116 12.0441 -5.16436 12.0282C-5.22411 12.0166 -5.28576 12.0072 -5.34551 11.9956C-5.43287 11.9801 -5.5081 11.9594 -5.58713 11.9432C-6.21656 11.7732 -6.77491 11.6244 -7.25162 11.4978C-7.70977 11.3676 -8.08591 11.2638 -8.36563 11.1831C-8.05452 12.2599 -7.73595 13.2771 -7.45896 14.2015C-7.28585 14.7489 -7.12621 15.2617 -6.97515 15.748C-6.68674 16.6588 -6.42815 17.4673 -6.18005 18.2515C-5.68384 19.8199 -5.22994 21.2871 -4.66961 23.2339C-4.04204 25.3764 -3.32537 27.8951 -2.58721 30.5168C-2.22004 31.83 -1.84428 33.1696 -1.4715 34.4991C-1.25363 35.2733 -1.04029 36.0438 -0.825398 36.8078C-0.802628 36.8772 -0.789367 36.9578 -0.758627 37.0223L-0.551516 37.0883L-0.137285 37.2202L0.276945 37.3522L0.53893 37.4218C0.71283 37.4676 0.884474 37.5114 1.05837 37.5572C1.23346 37.5924 1.40628 37.6257 1.57946 37.6631C4.36235 38.2066 7.04848 37.8962 9.14027 37.3602C9.66062 37.2144 10.1485 37.0567 10.6086 36.9182C11.0609 36.7615 11.4697 36.5876 11.8496 36.4434C12.2341 36.3031 12.5622 36.1425 12.8562 35.9995C13.1502 35.8565 13.4062 35.7357 13.6198 35.6332C13.8785 35.5185 14.1157 35.3742 14.3552 35.2317L15.0752 34.7979C15.254 34.6817 15.4828 34.5611 15.7156 34.3899C15.9507 34.2205 16.2176 34.0316 16.5119 33.8194C16.8017 33.6033 17.1399 33.3894 17.4667 33.1155C17.7957 32.8436 18.1502 32.5506 18.5283 32.2388C18.716 32.0798 18.9169 31.9281 19.1073 31.7521C19.2955 31.5743 19.4897 31.3938 19.6897 31.2065C20.0835 30.8345 20.499 30.446 20.9358 30.0368C21.3513 29.6482 21.7823 29.2458 22.2305 28.8229C22.6881 28.4119 23.1922 28.0283 23.6952 27.6091C23.943 27.3925 24.219 27.2112 24.4958 27.0152C24.7708 26.8214 25.0517 26.625 25.3346 26.4263C25.4725 26.322 25.6221 26.2314 25.772 26.145C25.9215 26.0544 26.0733 25.9657 26.2248 25.8728C26.5303 25.6932 26.8325 25.4991 27.1493 25.329C28.4302 24.6598 29.8119 24.0406 31.3018 23.6052C32.7947 23.1799 34.3762 22.9064 36.0024 22.8599C36.8156 22.8251 37.6359 22.8736 38.4607 22.9489L39.0913 23.0348L39.4056 23.0789L40.0042 23.2075C40.8225 23.3779 41.6365 23.5717 42.4509 23.7697C42.1544 22.74 41.401 20.1363 40.667 17.5876C37.7264 7.53183 35.9053 1.30688 34.9535 -1.94261C34.9552 -2.23861 34.6651 -2.19668 34.4682 -2.26564C34.2584 -2.3146 34.0485 -2.36355 33.8387 -2.41251L33.6803 -2.44913C33.6311 -2.45956 33.6141 -2.46227 33.5778 -2.46961L33.3902 -2.50372L33.0173 -2.57001C32.7696 -2.61988 32.5206 -2.63607 32.2744 -2.66928L31.9055 -2.71284L31.5408 -2.73367C30.5668 -2.81081 29.6218 -2.74779 28.7074 -2.67062C26.8858 -2.45607 25.2051 -1.99564 23.6927 -1.35886C23.3041 -1.21817 22.9496 -1.02168 22.5817 -0.859698C22.4004 -0.772642 22.2187 -0.689742 22.0393 -0.604949C21.8648 -0.512183 21.6929 -0.413354 21.5206 -0.318686C21.1787 -0.123287 20.8406 0.0675779 20.5024 0.258452C20.1809 0.47097 19.8612 0.681234 19.5415 0.89149C19.3828 0.99757 19.226 1.10138 19.0692 1.20519C18.9128 1.31317 18.7677 1.43066 18.618 1.54435C18.321 1.77363 18.0236 1.99874 17.7304 2.22349C17.4281 2.44063 17.165 2.69844 16.8834 2.93687C16.6064 3.1791 16.3335 3.42097 16.0565 3.6632C14.9003 4.78106 14.4954 5.51069 14.6627 5.67453C14.8371 5.84825 15.5686 5.4743 16.7575 4.469C17.0367 4.25176 17.3182 4.03643 17.6015 3.81883C17.8853 3.60539 18.1547 3.37221 18.455 3.18042C18.7503 2.98066 19.0435 2.77901 19.3427 2.57472C19.4915 2.47579 19.6354 2.36889 19.7888 2.27377C19.9425 2.18281 20.0981 2.08959 20.256 1.99827C20.5672 1.81183 20.8807 1.62728 21.1938 1.43857C21.5194 1.27187 21.8468 1.10292 22.1765 0.935855C22.3434 0.852145 22.5062 0.768783 22.675 0.682808C22.8449 0.60933 23.0189 0.535501 23.193 0.461662C23.5419 0.322314 23.8814 0.148096 24.2446 0.0284898C25.6722 -0.5212 27.2231 -0.905332 28.8787 -1.07402C29.7068 -1.13111 30.5609 -1.17788 31.436 -1.10266L31.7652 -1.08084L32.0939 -1.04009C32.3148 -1.00888 32.5385 -0.994695 32.7585 -0.948727C32.959 -0.911546 33.1636 -0.874721 33.3663 -0.835639L33.4906 -0.804459C33.5296 -0.791045 33.5901 -0.794202 33.5831 -0.753728C33.7626 -0.108343 33.9886 0.711361 34.2604 1.69705C34.563 2.82065 34.9173 4.13071 35.3166 5.62151C36.1212 8.60049 37.1258 12.2923 38.3635 16.5934C38.7677 17.9957 39.1924 19.3919 39.6324 20.7701L39.7103 21.0172L39.7503 21.1397C39.7503 21.1397 39.7548 21.1435 39.757 21.1454C39.7661 21.153 39.7713 21.1651 39.7789 21.1792C39.7935 21.2031 39.816 21.2452 39.8321 21.2858C39.8094 21.2898 39.7776 21.2863 39.7337 21.288L39.7 21.2867L39.6811 21.2863L39.5858 21.2756L39.0005 21.2047C38.6159 21.1478 38.1999 21.1419 37.8004 21.1073C37.3951 21.0795 36.9912 21.0914 36.5855 21.0825C34.9651 21.0992 33.3478 21.3233 31.8071 21.7044C28.7091 22.4451 25.9889 23.9167 23.8329 25.4108C23.5617 25.6001 23.2986 25.7845 23.0374 25.9666C22.7852 26.1563 22.5484 26.3552 22.3129 26.5434C22.0774 26.7317 21.8479 26.9174 21.6222 27.0985C21.5105 27.19 21.3985 27.2773 21.2906 27.3643C21.1876 27.4593 21.0865 27.552 20.9873 27.6424C20.2001 28.3674 19.5102 29.0042 18.937 29.5344C18.6591 29.7914 18.4082 30.0209 18.1904 30.2202C18.0817 30.3219 17.9806 30.4146 17.8871 30.4983C17.7891 30.5781 17.6987 30.6489 17.6204 30.7144C17.3005 30.9709 17.13 31.1094 17.13 31.1094C17.13 31.1094 16.8416 31.3422 16.3261 31.7624C16.0647 31.9676 15.7272 32.1899 15.3418 32.4646C15.15 32.6009 14.9442 32.7446 14.7266 32.8977C14.509 33.0509 14.2624 33.1835 14.0092 33.3376C13.758 33.4895 13.4926 33.6489 13.2175 33.8154C12.9446 33.9838 12.637 34.1154 12.3319 34.2761C12.0216 34.4247 11.7142 34.6066 11.3733 34.7411C11.037 34.8794 10.6885 35.0229 10.3339 35.169C8.89465 35.705 7.25528 36.1346 5.51244 36.2647C4.64192 36.3402 3.74838 36.319 2.85551 36.2327L2.18746 36.1501L1.52224 36.0273C1.30062 35.9877 1.08518 35.9225 0.864745 35.8723L0.70406 35.8338L0.64585 35.8158L0.529429 35.7797C0.476824 35.778 0.495606 35.7281 0.478692 35.7023L0.439583 35.5651L0.23949 34.8753C0.105343 34.4149 -0.0284482 33.9585 -0.162235 33.5022C-0.429811 32.5896 -0.692493 31.685 -0.951844 30.7947C-1.99079 27.2401 -2.95224 23.9516 -3.66507 21.5018L-5.03013 16.8425L-5.71171 14.5117L-5.92228 13.7977L-5.96736 13.64L-5.99086 13.5623L-6.00278 13.5214C-6.00278 13.5214 -6.02077 13.4831 -6.00077 13.496C-5.91685 13.5202 -5.83258 13.5486 -5.74485 13.5683L-5.6163 13.5991L-5.29637 13.6595C-5.12807 13.689 -4.95906 13.7268 -4.78886 13.754L-4.27933 13.8231L-3.7698 13.8922L-3.25864 13.9319C-1.47352 14.073 0.223859 13.951 1.8069 13.6711C2.20054 13.5887 2.59002 13.5067 2.97117 13.4254C3.3535 13.3335 3.71855 13.2116 4.08731 13.1083C4.27151 13.0546 4.45344 12.999 4.63347 12.9456C4.81315 12.8881 4.98721 12.8142 5.162 12.7487C5.51122 12.6135 5.85438 12.481 6.19753 12.3484C6.53616 12.212 6.85488 12.0396 7.17958 11.8877C7.49939 11.7278 7.82481 11.5842 8.13331 11.4148C8.73565 11.052 9.34051 10.7184 9.90882 10.3502C10.4625 9.95811 11.0127 9.57471 11.5478 9.18631C12.0546 8.7626 12.5558 8.34566 13.0547 7.92683L13.0459 7.94648Z" fill="#0055CC"/>
<path d="M114.495 32.3233C112.222 31.5594 111.865 32.4842 114.065 33.4412C115.623 34.1181 117.228 34.7952 118.977 35.5123C119.855 35.8642 120.766 36.2322 121.724 36.617C122.269 36.8321 122.83 37.0521 123.405 37.2771C123.642 37.3719 123.882 37.4581 124.118 37.5446L124.298 37.6109L124.387 37.6431L124.432 37.658C124.448 37.6672 124.451 37.6354 124.461 37.6282L124.677 37.3074C124.82 37.0915 124.962 36.8714 125.107 36.6532C125.214 36.4803 125.323 36.3051 125.431 36.1299C126.78 33.8413 127.434 32.3201 127.986 30.9923C128.522 29.6576 128.956 28.5121 129.531 26.8088C130.002 25.3663 130.481 23.6442 130.752 21.7826C131.029 19.9289 131.072 17.9297 130.72 16.0614C130.685 15.8273 130.618 15.6003 130.566 15.3718L130.485 15.0327C130.452 14.9243 130.42 14.8201 130.388 14.7117C130.257 14.2887 130.129 13.8759 130.004 13.4734C129.871 13.0758 129.708 12.6954 129.569 12.3277C129.497 12.143 129.427 11.9644 129.357 11.79C129.273 11.619 129.194 11.4517 129.115 11.2886C128.956 10.9624 128.812 10.6518 128.666 10.3665C128.501 10.0891 128.349 9.82956 128.209 9.59201C127.945 9.10715 127.656 8.75656 127.474 8.4912L127.134 8.0276L126.744 7.59974C126.627 7.47357 126.483 7.32232 126.319 7.14562C126.159 6.96439 125.94 6.79237 125.717 6.58514C125.273 6.16197 124.688 5.71968 124.013 5.24104C122.649 4.29127 120.829 3.37894 118.787 2.5467C117.766 2.12111 116.69 1.71915 115.586 1.30078C115.27 1.18135 114.951 1.06003 114.628 0.93906C114.367 0.83993 114.105 0.738895 113.84 0.640126L113.446 0.4897L113.246 0.41467L113.146 0.37717L113.096 0.35841C113.096 0.35841 113.082 0.389005 113.075 0.406389C112.755 1.2378 112.429 2.08018 112.103 2.92671C111.218 5.21915 110.304 7.56446 109.412 9.8156C108.794 11.4093 108.234 12.851 107.732 14.1514C107.421 14.9526 107.128 15.7103 106.85 16.4268C106.745 16.6982 106.644 16.965 106.543 17.2276L106.506 17.3274C106.489 17.3478 106.52 17.3471 106.533 17.3544L106.583 17.3731L106.78 17.4463C106.91 17.4938 107.038 17.5435 107.168 17.591C107.634 17.7625 108.085 17.9291 108.525 18.0903C109.559 18.458 110.424 18.7754 111.129 19.0899C111.836 19.4021 112.382 19.7072 112.788 19.9826C113.763 20.6283 114.417 21.4256 114.721 22.3225C115.031 23.2209 115.01 24.211 114.85 25.1627C114.514 27.0782 113.723 28.8274 112.888 30.5008C112.427 31.3926 112.339 31.952 112.53 32.0971L112.524 32.1921C112.543 32.1967 112.555 32.1914 112.562 32.174L112.566 32.1192C112.77 32.2253 113.25 31.9025 113.813 31.0312C114.839 29.3874 115.819 27.6386 116.32 25.4445C116.554 24.3541 116.654 23.1054 116.251 21.8205C116.047 21.1856 115.719 20.5657 115.278 20.0207C114.838 19.4734 114.298 19.004 113.712 18.6079C113.257 18.2948 112.658 17.946 111.931 17.5894C111.201 17.2309 110.34 16.8775 109.378 16.5014C109.259 16.4551 109.137 16.4069 109.015 16.3587L108.972 16.3415L108.965 16.3358L108.952 16.3285L108.932 16.3114L108.894 16.2874C108.885 16.2798 108.864 16.2774 108.883 16.2548C108.905 16.2235 108.922 16.1989 108.937 16.1767C109.05 15.9046 109.164 15.6303 109.285 15.345C109.769 14.1721 110.29 12.891 110.842 11.5045C111.2 10.6006 111.535 9.68824 111.85 8.77542C112.189 7.78926 112.548 6.77404 112.917 5.74334C113.278 4.74895 113.644 3.73943 114.005 2.74504L114.061 2.56814C114.061 2.56814 114.066 2.54885 114.07 2.54849L114.092 2.555L114.135 2.56806L114.223 2.59607L114.268 2.61102L114.292 2.61945L114.381 2.65161L114.756 2.78908C115.003 2.88097 115.248 2.97094 115.491 3.06319C115.976 3.24351 116.451 3.42266 116.91 3.60324C117.372 3.77931 117.813 3.96134 118.238 4.13648C119.943 4.84051 121.328 5.56817 122.259 6.15047C122.71 6.45973 123.088 6.68503 123.314 6.87524C123.546 7.05866 123.675 7.15875 123.675 7.15875C123.675 7.15875 123.72 7.1968 123.812 7.26645C123.898 7.33873 124.044 7.43095 124.196 7.58148C124.355 7.72712 124.549 7.90546 124.772 8.1127C124.829 8.16442 124.886 8.21615 124.948 8.27167C125.001 8.33208 125.059 8.39212 125.117 8.45634C125.233 8.58477 125.355 8.7189 125.483 8.861C126.504 9.99784 127.669 11.8 128.462 14.0309C128.555 14.3103 128.651 14.5957 128.747 14.8812C128.839 15.167 128.95 15.4574 129.012 15.7415C129.087 16.0288 129.164 16.3138 129.211 16.6119L129.291 17.0539C129.312 17.2032 129.325 17.3531 129.347 17.5023C129.488 18.7029 129.464 19.9345 129.335 21.1165C129.074 23.485 128.427 25.6372 127.869 27.2046C127.024 29.5691 126.192 31.2486 125.546 32.5173C124.889 33.7808 124.393 34.6273 124.007 35.2609C123.939 35.3738 123.871 35.4825 123.805 35.589L123.775 35.6377C123.775 35.6377 123.741 35.6281 123.724 35.6254L123.618 35.5863C123.167 35.4156 122.729 35.2521 122.3 35.0921C121.329 34.7356 120.408 34.3979 119.52 34.072C117.742 33.4309 116.096 32.8581 114.486 32.3157L114.495 32.3233Z" fill="#0055CC"/>
<path d="M63.2213 -4.91981C64.3036 -4.55832 64.931 -4.50988 65.0627 -4.7584C65.1871 -4.9937 64.7809 -5.5439 63.6473 -6.03733C62.8457 -6.3791 62.0109 -6.66763 61.1289 -6.89542C60.2473 -7.11905 59.3135 -7.2899 58.3289 -7.34513C57.8413 -7.40358 57.3321 -7.37202 56.8151 -7.38176C56.558 -7.36997 56.296 -7.34306 56.0313 -7.32222C55.898 -7.31066 55.7647 -7.29911 55.6314 -7.28755C55.497 -7.2654 55.3648 -7.24136 55.2303 -7.21921C54.1508 -7.06059 53.0339 -6.72876 51.9327 -6.21366C51.7776 -6.13937 51.624 -6.0715 51.4775 -5.99376C51.3356 -5.91221 51.1978 -5.83104 51.0597 -5.75402C50.7857 -5.59808 50.528 -5.44774 50.2994 -5.27685C50.0662 -5.10976 49.8377 -4.96196 49.6378 -4.79776C49.4383 -4.6294 49.2487 -4.46819 49.0667 -4.31603C48.7053 -4.00564 48.4124 -3.68019 48.1181 -3.3945C47.8555 -3.08218 47.5991 -2.79557 47.3722 -2.50733C46.4759 -1.34485 45.8317 -0.275565 45.0325 1.33172C44.3767 2.70416 43.7657 4.37696 43.3437 6.17395C42.9124 7.95917 42.6876 9.9258 42.8109 11.7679C42.9178 13.6155 43.3565 15.3442 43.9484 16.684C44.5304 18.031 45.2423 18.9618 45.621 19.485C45.8706 19.776 46.1183 20.0692 46.3915 20.3414C46.8871 20.8083 47.8267 21.6795 49.2654 22.4989C49.6286 22.6962 50.0023 22.9177 50.4196 23.1102C50.8332 23.3072 51.2794 23.4931 51.7434 23.6669C52.6774 24.0119 53.698 24.3137 54.8094 24.5258C57.0183 24.9575 59.6288 24.962 62.1114 24.1404C63.3524 23.7391 64.5396 23.1263 65.6002 22.3608C66.6654 21.5991 67.6064 20.6867 68.4118 19.7104C69.54 18.318 70.3115 16.8999 70.9125 15.5972C71.4954 14.2794 71.8779 13.0712 72.1641 11.9868C72.4458 10.8986 72.6224 9.93065 72.7077 9.09447C72.8141 8.26064 72.8305 7.55211 72.8419 6.97831C72.8528 4.26015 72.1712 1.85591 71.051 -0.0633815C70.4777 -1.01665 69.8234 -1.86426 69.0796 -2.58242C68.3284 -3.28736 67.5418 -3.9179 66.6795 -4.40338C66.2508 -4.67885 65.8679 -4.78834 65.5987 -4.84473C65.3256 -4.8966 65.1518 -4.86894 65.0821 -4.77687L65.145 -4.63126C65.1232 -4.66504 65.0952 -4.67311 65.0588 -4.65736L65.0431 -4.69376C65.0108 -4.58185 65.0816 -4.41803 65.2604 -4.21742C65.4355 -4.01228 65.7286 -3.80058 66.0982 -3.50529C66.8482 -2.98281 67.5077 -2.34335 68.1348 -1.66543C68.7505 -0.973925 69.282 -0.187015 69.7486 0.672685C70.2113 1.53691 70.5551 2.50588 70.8114 3.55585C71.0594 4.60655 71.2063 5.74994 71.1886 6.97894C71.1966 7.21745 71.1654 7.48872 71.1497 7.79223C71.1381 8.09539 71.0911 8.42678 71.0364 8.79032C70.948 9.51559 70.767 10.3601 70.5057 11.2954C69.9645 13.1699 69.1073 15.4663 67.5012 17.7163L67.3088 17.9911L67.1005 18.2525L66.6908 18.7811C66.3873 19.1054 66.1203 19.4642 65.8002 19.7668C65.6299 19.9327 65.4716 20.1164 65.2858 20.273C65.1023 20.4316 64.9187 20.5902 64.7333 20.7511C64.3409 21.0432 63.9478 21.35 63.5114 21.5935C62.6552 22.102 61.7221 22.5228 60.7441 22.7629C58.7947 23.2718 56.7658 23.2231 55.0396 22.865C53.3077 22.5136 51.8735 21.9413 50.9288 21.4483C50.4595 21.1889 50.0869 20.9799 49.8427 20.8249C49.602 20.6611 49.4726 20.5716 49.4726 20.5716C49.4726 20.5716 49.4235 20.5381 49.3322 20.4768C49.2405 20.4113 49.0971 20.3293 48.9364 20.1942C48.772 20.0637 48.5714 19.9027 48.3372 19.7174C48.1201 19.5117 47.8736 19.2813 47.5996 19.0239C47.0988 18.4714 46.5061 17.8031 46.0168 16.9475C45.52 16.1009 45.0877 15.1039 44.7938 14.0068C44.1804 11.8107 44.2512 9.25102 44.7058 6.95602C45.1626 4.63984 45.9616 2.59194 46.736 1.18404C47.8904 -0.951311 49.1258 -2.26907 50.1581 -3.12021C51.1942 -3.97588 52.0123 -4.41609 52.6484 -4.70413C53.6061 -5.15434 54.5704 -5.45614 55.5178 -5.6138C55.6356 -5.6345 55.753 -5.65937 55.8686 -5.68198C55.9871 -5.69435 56.1034 -5.70862 56.2219 -5.72099C56.4548 -5.74538 56.6851 -5.77583 56.9142 -5.79569C57.3752 -5.80208 57.8243 -5.8494 58.2681 -5.81234C60.0484 -5.77572 61.691 -5.41453 63.2383 -4.91709L63.2213 -4.91981Z" fill="#0055CC"/>
<path d="M149.643 41.1462C149.707 41.1386 149.772 41.135 149.834 41.1296C149.897 41.1284 149.958 41.1335 150.017 41.1368C150.136 41.1434 150.255 41.1393 150.367 41.1485C150.584 41.1884 150.799 41.195 150.983 41.2609C151.077 41.2863 151.167 41.3078 151.257 41.3294C151.342 41.3619 151.422 41.3948 151.5 41.4216C151.58 41.4504 151.654 41.4776 151.725 41.5028C151.793 41.5368 151.859 41.5689 151.92 41.5972C152.179 41.7027 152.367 41.8102 152.516 41.8582C152.665 41.9103 152.768 41.9119 152.818 41.8655C152.869 41.8192 152.863 41.7211 152.795 41.5675C152.727 41.4139 152.604 41.2022 152.364 40.9733C152.304 40.9155 152.242 40.8517 152.176 40.7882C152.104 40.7315 152.021 40.6736 151.936 40.6138C151.851 40.554 151.758 40.4908 151.66 40.4279C151.555 40.3783 151.444 40.3271 151.328 40.2721C151.099 40.1534 150.826 40.0974 150.536 40.0197C150.391 39.9903 150.237 39.9806 150.078 39.9629C149.999 39.955 149.919 39.9452 149.837 39.9418C149.757 39.9445 149.674 39.9476 149.59 39.9506C148.636 39.9788 147.736 40.254 146.905 40.6177C146.068 40.9798 145.315 41.471 144.572 41.9823C144.209 42.2488 143.842 42.5115 143.498 42.8057C143.142 43.0862 142.801 43.3864 142.46 43.695L142.203 43.9229C142.117 43.9975 142.015 44.1008 141.928 44.1902C141.84 44.2818 141.755 44.373 141.675 44.4639L141.463 44.7068L141.37 44.8029C141.341 44.8285 141.308 44.8776 141.28 44.8192L141.196 44.7216L141.177 44.698L141.059 44.5718L140.819 44.3157C140.497 43.9722 140.173 43.6226 139.843 43.2714C139.187 42.5688 138.512 41.8509 137.823 41.1133C136.438 39.6471 134.985 38.105 133.447 36.4758C133.366 36.3925 133.286 36.3093 133.205 36.2261L133.16 36.188C133.113 36.1606 133.152 36.1278 133.173 36.0987L133.224 36.0376C133.316 35.9373 133.407 35.8393 133.497 35.7413C133.679 35.5471 133.86 35.3593 134.04 35.1738C134.763 34.4418 135.456 33.7649 136.09 33.1581C137.34 31.9418 138.448 30.9918 139.511 30.1548C140.576 29.3197 141.597 28.587 142.741 27.9067C143.884 27.2263 145.144 26.5737 146.712 25.9993C147.041 25.8701 147.387 25.775 147.733 25.6568C148.083 25.5489 148.444 25.4588 148.809 25.36C149.549 25.1973 150.314 25.0408 151.105 24.9722C152.687 24.8036 154.367 24.8909 156.008 25.2858C157.649 25.6806 159.244 26.388 160.67 27.3471C162.105 28.2991 163.355 29.4853 164.442 30.7697C165.532 32.0453 166.437 33.3937 167.101 34.744C167.769 36.094 168.2 37.4415 168.453 38.689C168.707 39.9385 168.791 41.0831 168.821 42.0542C168.854 43.0248 168.81 43.826 168.784 44.399L168.72 45.4389C168.704 45.7886 168.699 46.1626 168.693 46.5093C168.686 47.1141 168.656 47.9581 168.694 49.1446C168.711 49.7348 168.755 50.4171 168.886 51.1989C169.02 51.9762 169.253 52.8834 169.791 53.7915C170.053 54.2472 170.391 54.6816 170.799 55.0868C171.204 55.5007 171.727 55.8667 172.326 56.1546C172.941 56.4245 173.637 56.5655 174.345 56.5693C175.051 56.5605 175.743 56.4082 176.418 56.1881C177.747 55.7099 178.979 54.9338 180.172 53.9974C180.767 53.5283 181.354 53.0136 181.936 52.4638C182.23 52.1929 182.508 51.9211 182.801 51.6419C182.857 51.5887 182.911 51.5337 182.968 51.4805L183.01 51.4391C183.026 51.4524 183.042 51.4657 183.06 51.481L183.076 51.4943L183.085 51.5019L183.154 51.5756C183.256 51.6801 183.36 51.7907 183.472 51.9047C183.91 52.3619 184.42 52.8906 184.982 53.4797C186.108 54.6578 187.46 56.0766 188.952 57.6405C189.633 58.3557 190.346 59.1059 191.082 59.8793C191.101 59.907 191.162 59.9353 191.113 59.9669L191.075 60.0121L190.913 60.1856C190.524 60.6075 190.105 61.0278 189.673 61.445C189.235 61.8649 188.793 62.2851 188.349 62.7117C187.9 63.1179 187.462 63.5461 186.997 63.9389C186.087 64.7501 185.126 65.5027 184.164 66.2239C181.541 68.1593 178.922 69.5424 176.438 70.3284C173.956 71.1228 171.629 71.2992 169.639 71.0479C168.643 70.9245 167.728 70.7079 166.902 70.427C166.08 70.1373 165.338 69.8072 164.678 69.449C163.359 68.7303 162.368 67.9392 161.596 67.2591C160.691 66.4521 159.878 65.572 159.161 64.6753C158.43 63.7861 157.823 62.8547 157.303 61.9115C156.265 60.0228 155.669 58.0497 155.387 56.0934C155.235 55.1162 155.172 54.1397 155.141 53.1751C155.104 52.2089 155.139 51.2533 155.147 50.279C155.152 49.3092 155.16 48.358 155.127 47.3873C155.092 46.4231 155.005 45.4381 154.757 44.4609C154.485 43.4059 153.996 42.6741 153.603 42.2822C153.412 42.0785 153.232 41.9619 153.1 41.8936C152.968 41.8253 152.879 41.812 152.832 41.8497L152.701 41.8442C152.697 41.8635 152.703 41.8692 152.722 41.8655L152.829 41.8436L152.808 41.8685C152.77 41.9138 152.772 42.008 152.817 42.1426C152.86 42.2752 152.946 42.4482 153.042 42.6791C153.244 43.1316 153.527 43.7785 153.718 44.7041C153.889 45.5705 153.936 46.4792 153.926 47.4054C153.92 48.3312 153.872 49.2838 153.833 50.2398C153.722 52.1482 153.636 54.1889 153.902 56.2935C154.151 58.3995 154.77 60.593 155.881 62.6747C156.437 63.7134 157.093 64.7371 157.873 65.7018C158.641 66.6759 159.501 67.6149 160.49 68.5006C161.26 69.1829 162.28 70.0177 163.649 70.8244C165.02 71.6183 166.762 72.3758 168.863 72.7476C170.959 73.1156 173.393 73.0683 175.922 72.44C178.453 71.8219 181.043 70.6301 183.565 69.0036C185.208 67.94 186.742 66.7265 188.162 65.4284C188.478 65.1492 188.784 64.8541 189.092 64.5567C189.402 64.2613 189.714 63.9636 190.011 63.665C190.619 63.0668 191.235 62.4573 191.845 61.8107L192.299 61.316C192.345 61.2617 192.523 61.0679 192.639 60.9257L193.021 60.4708L193.391 60.0086L193.486 59.8955C193.48 59.8561 193.425 59.821 193.399 59.7834L193.195 59.566C192.933 59.2761 192.65 58.988 192.374 58.7014C191.761 58.0705 191.146 57.4377 190.534 56.8068C189.331 55.5598 188.135 54.3226 186.969 53.1144C185.625 51.7139 184.318 50.348 183.066 49.0444C182.442 49.6398 181.829 50.2259 181.227 50.8048C181.016 51.0098 180.808 51.2062 180.602 51.3919C180.393 51.5799 180.196 51.7733 179.987 51.9488C179.164 52.6706 178.326 53.2951 177.498 53.7927C176.67 54.2863 175.836 54.6439 175.066 54.7841C174.293 54.9266 173.6 54.8461 173.042 54.5966C172.477 54.3497 172.045 53.936 171.712 53.5326C171.383 53.1289 171.169 52.7362 171.022 52.3965C170.949 52.2266 170.901 52.067 170.85 51.9351C170.811 51.7937 170.778 51.677 170.753 51.5826C170.724 51.4886 170.713 51.4098 170.7 51.3606C170.689 51.309 170.683 51.2844 170.683 51.2844C170.683 51.2844 170.655 51.1757 170.62 50.9647C170.602 50.8571 170.582 50.7245 170.558 50.5692C170.542 50.409 170.522 50.2261 170.5 50.0182C170.428 49.181 170.429 47.9304 170.475 46.3506C170.48 45.578 170.559 44.7172 170.575 43.7653C170.586 42.816 170.584 41.7985 170.473 40.7275C170.366 39.6562 170.183 38.5328 169.879 37.3967C169.563 36.2616 169.12 35.1208 168.563 34.0109C168.013 32.8919 167.297 31.8419 166.532 30.8276C166.332 30.5785 166.135 30.3312 165.933 30.0802C165.729 29.8356 165.508 29.603 165.296 29.3632C165.082 29.1258 164.871 28.886 164.637 28.6587C164.41 28.4287 164.184 28.1965 163.941 27.9846C162.045 26.2207 159.744 24.834 157.312 24.1068C154.881 23.3649 152.383 23.3003 150.19 23.631C147.983 23.9545 146.071 24.6532 144.51 25.353C142.165 26.4333 140.292 27.6636 138.737 28.8286C137.183 29.9978 135.935 31.0964 134.891 32.0807C133.859 33.0556 132.992 33.8798 132.263 34.6501C132.173 34.7481 132.085 34.8439 131.996 34.9355C131.87 35.0807 131.724 35.2361 131.601 35.3915C131.474 35.5473 131.351 35.6986 131.228 35.8498C131.165 35.9245 131.108 36.0008 131.048 36.0732C131.006 36.1461 130.87 36.225 130.986 36.2883C131.232 36.5607 131.465 36.8217 131.709 37.0734C131.889 37.2634 132.062 37.4477 132.23 37.624C133.778 39.2461 135.238 40.775 136.632 42.2363C137.33 42.9626 138.015 43.6733 138.681 44.3688C139.015 44.7154 139.345 45.0583 139.674 45.3969C139.865 45.5964 140.056 45.7918 140.245 45.9894L140.649 46.4098C140.784 46.5428 140.916 46.6615 141.049 46.7885L141.247 46.9748L141.299 47.0185L141.32 47.044C141.325 47.0478 141.329 47.0516 141.332 47.0535L141.343 47.0399L141.444 46.943L141.83 46.5529C142.085 46.3 142.335 46.0077 142.564 45.7213C142.888 45.3177 143.089 45.0967 143.437 44.779C143.751 44.4791 144.068 44.1851 144.395 43.9113C144.712 43.6257 145.047 43.3701 145.374 43.1088C146.043 42.6165 146.72 42.1424 147.435 41.8013C148.146 41.4564 148.886 41.2055 149.62 41.1503L149.643 41.1462Z" fill="#0055CC"/>
<path d="M80.321 9.381C80.4416 7.10655 79.4571 7.02823 79.1312 9.25752C78.8942 10.8392 78.6434 12.4555 78.3341 14.1966C78.018 15.932 77.6635 17.8049 77.0533 19.8029C76.9621 20.1318 76.8558 20.4327 76.7629 20.7177C76.7418 20.7888 76.7161 20.8561 76.6904 20.9233C76.6579 21.008 76.6295 21.0923 76.5966 21.1728C76.5069 21.4218 76.4055 21.6573 76.3015 21.8866C75.8871 22.7744 75.5595 23.4763 75.3454 23.9376C76.5743 23.808 77.6597 23.6698 78.5962 23.5572C79.1374 23.483 79.6268 23.4154 80.1059 23.3508C81.0599 23.2219 81.9734 23.1092 83.1533 22.9964C85.9529 22.7118 89.7215 22.3998 93.0728 22.1386C93.9107 22.0744 94.7237 22.0123 95.4885 21.9523C95.6782 21.938 95.8679 21.9236 96.0534 21.9097C96.3908 21.8804 96.7199 21.8519 97.0447 21.8237C97.2132 21.807 97.3821 21.7945 97.5465 21.7781L97.6089 21.7727C97.6204 21.7591 97.6182 21.7341 97.6228 21.7148L97.6419 21.5957L97.6801 21.3574C97.73 21.0362 97.7788 20.7257 97.826 20.4215C97.9332 19.7429 98.0279 19.1388 98.1097 18.6281C98.1809 18.1394 98.241 17.7418 98.2835 17.4569C98.332 17.1191 98.3699 16.7801 98.4014 16.4396C98.4496 15.9045 98.5308 14.9722 98.6212 13.7348C98.6626 13.1206 98.7101 12.4304 98.7605 11.6769C98.8248 10.9391 98.9042 10.1327 98.9956 9.27083C99.1893 7.55237 99.4495 5.63093 99.8761 3.6447C100.088 2.65271 100.35 1.64389 100.688 0.657733C100.777 0.415087 100.869 0.172091 100.959 -0.0728197L101.111 -0.432169L101.185 -0.612789C101.19 -0.632072 101.226 -0.698169 101.255 -0.755205L101.343 -0.924419L101.695 -1.60959C101.746 -1.72103 101.822 -1.84298 101.901 -1.96529L102.126 -2.32887C102.421 -2.80344 102.713 -3.27991 103.01 -3.75675C102.93 -3.75822 102.807 -3.74549 102.664 -3.73095C102.522 -3.71867 102.364 -3.70079 102.189 -3.68563C101.84 -3.65113 101.434 -3.60967 100.989 -3.56688C100.271 -3.49835 99.4285 -3.41482 98.594 -3.33619C92.1629 -2.6822 88.1819 -2.27836 86.104 -2.06678C84.8775 -1.93528 83.7301 -1.81063 82.6387 -1.69294C81.9634 -1.61553 81.3068 -1.54182 80.6649 -1.4673L80.3138 -1.42637L80.1393 -1.40705L80.054 -1.39756C80.054 -1.39756 80.0158 -1.40264 80.0195 -1.38408L80.0129 -1.33944C79.9849 -1.10411 79.9566 -0.872952 79.9306 -0.639888C79.9042 -0.410991 79.8778 -0.182091 79.8514 0.046808C79.8379 0.182264 79.824 0.313557 79.8105 0.449013C79.6178 2.44645 79.5162 4.28491 79.4719 6.10582C79.4328 8.10883 80.2926 8.15179 80.5363 6.1856C80.7678 4.39463 81.0108 2.59008 81.2991 0.630513C81.3163 0.51362 81.3335 0.396721 81.3507 0.279829L81.3736 0.156149L81.3968 0.0366324C81.4245 0.0174448 81.4801 0.0294168 81.5173 0.0220026L81.6426 0.0153272C81.7592 0.00521753 81.8758 -0.00488413 81.9924 -0.0149939C82.259 -0.0381019 82.5275 -0.0634723 82.8005 -0.0850388C83.891 -0.187965 85.0441 -0.296311 86.2698 -0.413054C88.1772 -0.605671 92.1765 -0.77399 97.792 -1.29854C98.2499 -1.34242 98.7073 -1.39046 99.1621 -1.44458L99.459 -1.4808C99.459 -1.4808 99.4628 -1.48532 99.4666 -1.48985C99.4723 -1.49664 99.4841 -1.50606 99.5061 -1.51846C99.5282 -1.53086 99.5786 -1.55412 99.6074 -1.56081C99.6134 -1.54035 99.619 -1.52404 99.5928 -1.43784L99.5732 -1.37321L99.4323 -1.01267C99.3335 -0.771204 99.2457 -0.524399 99.1662 -0.278311C98.8317 0.707485 98.5712 1.70154 98.3498 2.68592C97.9192 4.64943 97.6406 6.5515 97.4316 8.21463C97.2283 9.87097 97.0684 11.3011 96.9964 12.3145C96.9101 13.3082 96.8578 13.8939 96.8578 13.8939C96.8578 13.8939 96.7819 14.8384 96.6206 16.3484C96.541 17.1044 96.4359 18.0011 96.3094 18.9919C96.2578 19.3657 96.2075 19.7561 96.1523 20.1616C96.1696 20.265 96.0622 20.2366 95.9922 20.2511C95.7737 20.2721 95.5533 20.2954 95.3287 20.3191C90.738 20.782 85.3487 21.3268 82.1496 21.6503L79.3959 21.931L78.3394 22.0393L78.1542 22.0575L78.0607 22.0677L78.0148 22.0717C78.0148 22.0717 77.9678 22.0862 77.9869 22.0636C78.0476 21.9408 78.1061 21.8162 78.1578 21.6858L78.2605 21.4167C78.3084 21.2909 78.3479 21.1657 78.3917 21.0402C78.4791 20.7893 78.5624 20.5387 78.637 20.2846C79.2812 18.1452 79.6012 16.2123 79.8478 14.4263C80.088 12.6388 80.2266 10.9859 80.3206 9.37683L80.321 9.381Z" fill="#0055CC"/>
</g>
</g>
<defs>
<clipPath id="clip0_550_14457">
<rect width="419" height="16" fill="white"/>
</clipPath>
<clipPath id="clip1_550_14457">
<rect width="304" height="304.679" fill="white" transform="translate(268.681 74.498) rotate(-105)"/>
</clipPath>
<clipPath id="clip2_550_14457">
<rect width="304" height="304.679" fill="white" transform="translate(-42.3188 330) rotate(-105)"/>
</clipPath>
</defs>
</svg>
`;
const $24c02ea0e14dbe4f$var$$e48fba9cf5395297$export$d3a66d29d3f047ac = `data:image/svg+xml;base64,${$24c02ea0e14dbe4f$var$$e48fba9cf5395297$require$Buffer.from($24c02ea0e14dbe4f$var$$e48fba9cf5395297$var$courseBg).toString("base64")}`;
var $24c02ea0e14dbe4f$var$$ea8e736e4eb06883$require$Buffer = (0, $7KfP5.Buffer);
const $24c02ea0e14dbe4f$var$$ea8e736e4eb06883$var$learningPathBg = `<svg width="420" height="32" viewBox="0 0 420 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_783_5660)">
<rect width="421" height="32" fill="#D3F1A7"/>
<g clipPath="url(#clip1_783_5660)">
<path d="M419.987 -18.535C419.996 -18.6008 420.003 -18.6685 420.014 -18.7325C420.032 -18.7948 420.048 -18.855 420.064 -18.9151C420.099 -19.0357 420.114 -19.1586 420.159 -19.2633C420.248 -19.4787 420.309 -19.6897 420.416 -19.8626C420.463 -19.9547 420.508 -20.0405 420.551 -20.1239C420.603 -20.204 420.653 -20.2776 420.702 -20.3489C420.75 -20.4203 420.79 -20.495 420.836 -20.56C420.888 -20.6211 420.931 -20.6814 420.974 -20.7377C421.14 -20.9766 421.288 -21.1425 421.37 -21.2818C421.452 -21.4212 421.479 -21.5221 421.443 -21.5798C421.407 -21.6375 421.307 -21.6519 421.142 -21.6125C420.978 -21.5731 420.733 -21.4931 420.458 -21.2993C420.387 -21.2511 420.313 -21.2007 420.234 -21.1477C420.159 -21.0908 420.086 -21.0173 420.006 -20.9454C419.928 -20.8715 419.847 -20.7931 419.762 -20.7102C419.686 -20.6197 419.613 -20.5189 419.533 -20.4155C419.364 -20.2141 419.244 -19.9561 419.102 -19.6815C419.032 -19.5432 418.992 -19.3908 418.936 -19.237C418.91 -19.1592 418.885 -19.0794 418.86 -18.9996C418.838 -18.918 418.826 -18.8351 418.809 -18.7496C418.615 -17.7845 418.69 -16.8132 418.876 -15.8956C419.059 -14.9694 419.392 -14.1023 419.756 -13.2441C419.947 -12.8201 420.142 -12.3942 420.364 -11.9834C420.574 -11.5631 420.81 -11.1597 421.049 -10.7503L421.231 -10.4387C421.302 -10.3211 421.379 -10.2102 421.453 -10.1055C421.527 -10.0007 421.606 -9.89626 421.681 -9.80207L421.834 -9.60345C421.861 -9.56587 421.887 -9.52828 421.909 -9.4945C421.917 -9.4763 421.939 -9.45727 421.93 -9.44179L421.87 -9.40722L421.756 -9.34487C421.555 -9.22042 421.349 -9.0956 421.146 -8.96889C420.732 -8.71475 420.314 -8.45608 419.889 -8.19478C419.043 -7.67029 418.178 -7.13793 417.292 -6.589C415.522 -5.48507 413.666 -4.32963 411.701 -3.10388C411.569 -3.02115 411.438 -2.93843 411.311 -2.85606L411.263 -2.82257C411.247 -2.8128 411.23 -2.79243 411.213 -2.79515L411.176 -2.83808L411.129 -2.89695C411.053 -2.99948 410.979 -3.10009 410.908 -3.19881C410.748 -3.42205 410.595 -3.64376 410.445 -3.86582C409.853 -4.75028 409.317 -5.59134 408.833 -6.35724C407.867 -7.87654 407.139 -9.19195 406.523 -10.4478C405.911 -11.7041 405.395 -12.8911 404.961 -14.1984C404.532 -15.502 404.156 -16.9192 403.941 -18.6296C403.764 -20.0725 403.734 -21.6583 403.948 -23.2903C404.067 -24.1022 404.224 -24.932 404.485 -25.7436C404.596 -26.1561 404.761 -26.5544 404.909 -26.9595C405.08 -27.3563 405.245 -27.7587 405.453 -28.1439C405.847 -28.9251 406.311 -29.6787 406.85 -30.3843C407.385 -31.0937 407.973 -31.7657 408.624 -32.3739C408.936 -32.6906 409.287 -32.9707 409.619 -33.2638C409.969 -33.5376 410.311 -33.8212 410.678 -34.0691C411.033 -34.3348 411.41 -34.5668 411.777 -34.8022C412.152 -35.0319 412.539 -35.2438 412.914 -35.4652C414.436 -36.3063 415.99 -36.9508 417.497 -37.3605C419.003 -37.7744 420.458 -37.953 421.776 -37.9728C423.096 -37.9949 424.276 -37.8643 425.269 -37.7091C426.262 -37.5581 427.07 -37.3658 427.646 -37.2332L428.69 -36.9733C429.045 -36.8908 429.419 -36.8161 429.771 -36.7439C430.378 -36.6244 431.227 -36.4357 432.428 -36.2524C433.028 -36.1617 433.721 -36.077 434.532 -36.0634C435.339 -36.0536 436.29 -36.115 437.298 -36.4731C437.804 -36.6386 438.302 -36.8958 438.794 -37.2049C439.033 -37.3788 439.288 -37.5352 439.516 -37.7606C439.63 -37.8691 439.756 -37.9682 439.863 -38.0907C439.969 -38.2175 440.076 -38.3442 440.183 -38.4709C440.585 -39.0094 440.922 -39.6534 441.087 -40.3602C441.245 -41.0621 441.295 -41.8007 441.211 -42.5237C441.061 -43.9794 440.534 -45.3837 439.853 -46.7871C439.509 -47.4895 439.114 -48.1854 438.684 -48.8867C438.47 -49.2438 438.255 -49.5756 438.036 -49.93C437.987 -50.0056 437.941 -50.0792 437.892 -50.1547L437.861 -50.2044C437.876 -50.2184 437.894 -50.2304 437.914 -50.2447C437.836 -50.1981 438.202 -50.4313 438.461 -50.5964C439.016 -50.9487 439.658 -51.3548 440.372 -51.8091C441.803 -52.7116 443.524 -53.7987 445.425 -54.9978C446.336 -55.572 447.291 -56.171 448.275 -56.7892L448.326 -56.823C448.342 -56.8286 448.363 -56.8577 448.374 -56.8292L448.412 -56.7821L448.504 -56.658C448.854 -56.1743 449.194 -55.6645 449.531 -55.1418C449.866 -54.6086 450.202 -54.0712 450.54 -53.5319C450.86 -52.9889 451.204 -52.4564 451.506 -51.9013C452.14 -50.8043 452.697 -49.6713 453.218 -48.5373C454.609 -45.4749 455.414 -42.519 455.622 -39.8408C455.835 -37.1588 455.451 -34.7734 454.708 -32.8332C453.969 -30.885 452.931 -29.3703 451.906 -28.2008C450.869 -27.0366 449.854 -26.1975 448.994 -25.5648C448.74 -25.377 448.489 -25.1937 448.225 -25.026C447.964 -24.8545 447.711 -24.6814 447.441 -24.53C447.177 -24.3729 446.912 -24.2176 446.652 -24.0609C446.391 -23.906 446.118 -23.7796 445.858 -23.6395C445.335 -23.3487 444.792 -23.1337 444.267 -22.891C444.001 -22.782 443.73 -22.6893 443.467 -22.5866L443.07 -22.4369L442.67 -22.314C441.607 -21.9638 440.54 -21.7559 439.49 -21.6188C438.439 -21.4752 437.397 -21.4584 436.377 -21.4937C435.354 -21.5267 434.349 -21.6453 433.361 -21.7967C432.866 -21.8692 432.377 -21.9632 431.889 -22.0531C431.396 -22.1509 430.914 -22.2581 430.418 -22.3473C429.434 -22.5327 428.468 -22.7238 427.477 -22.8687C426.491 -23.0141 425.476 -23.1065 424.439 -23.0397C423.318 -22.9551 422.489 -22.6084 422.02 -22.2886C421.775 -22.1352 421.62 -21.9792 421.526 -21.8618C421.431 -21.7445 421.396 -21.6576 421.422 -21.6053L421.393 -21.479C421.408 -21.4698 421.421 -21.475 421.419 -21.4959L421.417 -21.6091L421.441 -21.5817C421.478 -21.5346 421.572 -21.5217 421.717 -21.5385C421.86 -21.5572 422.053 -21.6117 422.306 -21.6651C422.804 -21.788 423.52 -21.9508 424.501 -21.9792C426.333 -22.0037 428.217 -21.4935 430.151 -21.0652C432.069 -20.5957 434.122 -20.1211 436.309 -19.998C437.401 -19.9333 438.53 -19.9304 439.679 -20.0657C440.824 -20.1922 441.997 -20.4072 443.155 -20.774L443.593 -20.9043L444.026 -21.0615C444.313 -21.1682 444.608 -21.2672 444.896 -21.3845C445.464 -21.6372 446.054 -21.871 446.616 -22.1756C446.899 -22.3239 447.191 -22.4605 447.471 -22.6232C447.751 -22.7859 448.03 -22.9528 448.316 -23.1182C448.602 -23.2794 448.877 -23.4648 449.157 -23.6507C449.44 -23.8304 449.714 -24.0284 449.988 -24.2305C450.841 -24.8583 451.905 -25.7017 453.021 -26.8958C453.309 -27.1872 453.571 -27.5226 453.863 -27.8606C454.004 -28.0322 454.137 -28.2179 454.276 -28.402C454.418 -28.5843 454.554 -28.7745 454.686 -28.9768C455.233 -29.7649 455.74 -30.6671 456.174 -31.674C457.054 -33.6807 457.614 -36.138 457.566 -38.828C457.534 -41.5172 456.936 -44.4071 455.846 -47.3131C455.131 -49.2087 454.232 -51.0192 453.22 -52.7276C453 -53.1093 452.768 -53.4858 452.531 -53.8597C452.294 -54.2399 452.058 -54.616 451.817 -54.9854C451.333 -55.7282 450.844 -56.4873 450.306 -57.2401C450.171 -57.4277 450.035 -57.6153 449.893 -57.8044C449.653 -58.1256 449.383 -58.4568 449.123 -58.7679L448.927 -59.0068L448.828 -59.1242L448.779 -59.185L448.713 -59.1436L448.187 -58.8211L447.222 -58.2108C446.463 -57.7211 445.702 -57.2334 444.944 -56.746C443.425 -55.775 441.918 -54.8134 440.448 -53.874C438.753 -52.7997 437.104 -51.7524 435.527 -50.7533C435.991 -50.0109 436.451 -49.2807 436.903 -48.5604C437.066 -48.3038 437.217 -48.0567 437.362 -47.8112C437.505 -47.5634 437.664 -47.3254 437.793 -47.0785C438.349 -46.1048 438.792 -45.1298 439.105 -44.1939C439.417 -43.2557 439.58 -42.3466 439.535 -41.5454C439.493 -40.7424 439.25 -40.0624 438.851 -39.5599C438.46 -39.0497 437.954 -38.6911 437.475 -38.4376C436.995 -38.1883 436.554 -38.0452 436.181 -37.9646C435.996 -37.9234 435.825 -37.9044 435.679 -37.877C435.529 -37.864 435.404 -37.8532 435.302 -37.8423C435.2 -37.8313 435.122 -37.8309 435.068 -37.8304C435.013 -37.8298 434.988 -37.8277 434.988 -37.8277C434.988 -37.8277 434.871 -37.8259 434.651 -37.8215C434.54 -37.8265 434.399 -37.829 434.237 -37.8338C434.073 -37.8406 433.88 -37.8596 433.667 -37.8767C432.801 -37.9591 431.531 -38.1931 429.936 -38.5374C429.151 -38.6876 428.292 -38.93 427.33 -39.1214C426.369 -39.3109 425.335 -39.5004 424.228 -39.5891C423.123 -39.6842 421.952 -39.7107 420.741 -39.6162C419.533 -39.5115 418.291 -39.2884 417.058 -38.9423C415.82 -38.6 414.613 -38.0967 413.43 -37.5305C412.848 -37.2282 412.256 -36.9336 411.697 -36.585C411.125 -36.2585 410.565 -35.8952 410.019 -35.5121C407.837 -33.978 405.925 -31.9889 404.62 -29.721C403.3 -27.4622 402.621 -24.9777 402.422 -22.6922C402.327 -21.5468 402.342 -20.4487 402.416 -19.4206C402.469 -18.909 402.508 -18.413 402.588 -17.9395C402.625 -17.7035 402.656 -17.4691 402.697 -17.2418C402.742 -17.0149 402.786 -16.7921 402.83 -16.5777C403.106 -15.2755 403.444 -14.0753 403.836 -12.9846C404.024 -12.4365 404.237 -11.9178 404.431 -11.4143C404.65 -10.9213 404.839 -10.4341 405.058 -9.9831C405.906 -8.16185 406.754 -6.66802 407.532 -5.40729C408.303 -4.16059 408.956 -3.11351 409.589 -2.2179C409.677 -2.09754 409.763 -1.97908 409.846 -1.86252C409.972 -1.69507 410.097 -1.53177 410.231 -1.3692C410.364 -1.2108 410.493 -1.05203 410.619 -0.899327C410.683 -0.822977 410.748 -0.74889 410.811 -0.672541C410.838 -0.607701 410.885 -0.664288 410.925 -0.684559L411.049 -0.758224C411.375 -0.948013 411.688 -1.14089 411.994 -1.3353C412.199 -1.46428 412.396 -1.58837 412.583 -1.70531C414.541 -2.94093 416.392 -4.10849 418.154 -5.2223C419.034 -5.7811 419.891 -6.3275 420.73 -6.86187C421.15 -7.13113 421.563 -7.39361 421.975 -7.65798C422.182 -7.78922 422.388 -7.92463 422.593 -8.0536L423.1 -8.37663L423.351 -8.53683L423.58 -8.6994L424.035 -9.02415L424.063 -9.04335L424.074 -9.05693C424.074 -9.05693 424.071 -9.06299 424.069 -9.06906L424.03 -9.12865L423.95 -9.24973L423.794 -9.48584C423.591 -9.79557 423.369 -10.1058 423.118 -10.4051L422.846 -10.7382L422.646 -10.9915C422.584 -11.0743 422.525 -11.1593 422.472 -11.2387L422.296 -11.5214C422.062 -11.9039 421.823 -12.282 421.616 -12.6689C421.392 -13.0503 421.203 -13.441 421.015 -13.8275C420.658 -14.6065 420.324 -15.3895 420.137 -16.1875C419.943 -16.9806 419.861 -17.7834 419.977 -18.5362L419.987 -18.535Z" fill="#6A9A23"/>
<path d="M375.063 24.9613C374.963 24.9469 374.87 24.934 374.776 24.9211C374.684 24.9207 374.594 24.9181 374.507 24.9151C374.335 24.9132 374.174 24.9167 374.025 24.9233C373.73 24.9258 373.486 24.9952 373.295 25.0474C372.911 25.1605 372.732 25.2998 372.737 25.4357C372.745 25.5735 372.937 25.7079 373.298 25.8109C373.477 25.8688 373.704 25.8932 373.964 25.9651C374.095 25.9937 374.236 26.0234 374.387 26.046C374.461 26.0584 374.54 26.0705 374.623 26.0822C374.702 26.1026 374.783 26.1207 374.867 26.1407C375.825 26.3325 376.729 26.7137 377.473 27.3312C378.22 27.9441 378.807 28.785 379.24 29.7755C379.678 30.7657 379.967 31.901 380.15 33.1252C380.208 33.4286 380.237 33.7429 380.273 34.0629C380.311 34.3807 380.35 34.7026 380.365 35.0327C380.388 35.3644 380.408 35.6983 380.431 36.0384C380.447 36.3874 380.465 36.7426 380.481 37.1C380.568 38.5486 380.642 39.8241 380.666 40.2417C381.225 40.2059 381.762 40.1741 382.279 40.1418C382.607 40.1197 382.919 40.0968 383.222 40.0768C383.739 40.0362 384.218 39.9989 384.668 39.964C385.568 39.8902 386.356 39.8262 387.106 39.7653C388.606 39.6437 389.965 39.5385 391.821 39.449C393.519 39.3668 395.452 39.2727 397.832 39.1566C397.789 38.0735 397.747 36.9566 397.702 35.8254C397.669 34.9323 397.636 34.0245 397.605 33.125C397.53 31.3039 397.376 29.4981 397.138 27.8338C396.902 26.1715 396.583 24.6549 396.247 23.4104C395.91 22.1659 395.554 21.1981 395.327 20.6092C395.161 20.1725 394.959 19.7431 394.754 19.3202C394.367 18.5733 393.65 17.1667 392.278 15.5734C391.593 14.7809 390.741 13.9525 389.693 13.2062C388.648 12.4595 387.41 11.801 386.039 11.3281C384.669 10.8447 383.165 10.5723 381.624 10.4666C380.079 10.3572 378.499 10.4312 376.908 10.6467C373.722 11.0467 370.51 12.3407 368.007 14.3579C366.235 15.781 364.937 17.3979 363.976 18.95C363.746 19.3434 363.514 19.7244 363.305 20.1013C363.11 20.4854 362.924 20.8582 362.739 21.2205C362.569 21.5877 362.42 21.9489 362.268 22.3C362.215 22.422 362.163 22.544 362.112 22.6638C362.01 22.8133 362.067 22.9888 362.062 23.1549C362.073 23.3492 362.081 23.5415 362.091 23.7274C362.225 26.4708 362.325 28.491 362.392 29.8763C362.478 31.4741 362.561 32.9734 362.623 34.1577L364.386 34.2336C364.674 32.0726 365.411 30.2357 366.575 28.8843C367.741 27.5432 369.26 26.6687 370.916 26.2336C371.517 26.0786 371.977 25.9401 372.284 25.8233C372.59 25.6982 372.75 25.5626 372.742 25.4437C372.74 25.3221 372.569 25.2173 372.224 25.1508C371.88 25.0778 371.359 25.0726 370.681 25.1943C368.823 25.5253 366.976 26.4093 365.521 27.937C364.067 29.4689 363.142 31.6116 362.786 34.0198L364.239 34.0827C364.187 32.8954 364.122 31.3966 364.054 29.7974C363.992 28.5249 363.955 26.5621 363.894 23.9844C363.891 23.8231 363.885 23.66 363.883 23.4923L363.878 23.2409L363.877 23.1781L363.878 23.1675L363.881 23.1505C363.881 23.1505 363.892 23.1327 363.903 23.1108C363.934 23.0409 363.966 22.971 364 22.903C364.071 22.75 364.141 22.5928 364.214 22.4376C364.35 22.1194 364.523 21.8086 364.694 21.4895C364.779 21.329 364.866 21.1662 364.953 21.0034C365.043 20.8403 365.147 20.6844 365.242 20.5209C366.022 19.2216 367.014 17.8998 368.295 16.6977C368.509 16.507 368.703 16.2951 368.929 16.1223L369.589 15.5804C369.811 15.3996 370.05 15.2488 370.278 15.0779L370.624 14.8277L370.986 14.6032C371.25 14.4461 371.505 14.2666 371.785 14.127C372.062 13.9854 372.345 13.8413 372.625 13.6975C373.21 13.4516 373.797 13.1846 374.426 13.0021C374.736 12.8997 375.044 12.7954 375.367 12.7275C375.686 12.6516 376.006 12.5651 376.327 12.4994C376.979 12.3905 377.629 12.2649 378.288 12.2204C380.921 11.946 383.526 12.209 385.614 12.968C386.66 13.3411 387.579 13.8238 388.345 14.3365C389.111 14.8534 389.716 15.401 390.206 15.8705C390.437 16.1191 390.649 16.3399 390.826 16.5386C390.997 16.7441 391.142 16.9203 391.259 17.0654C391.379 17.2083 391.454 17.3297 391.516 17.4083C391.573 17.4873 391.601 17.5268 391.601 17.5268C391.873 17.8747 392.103 18.2575 392.347 18.6288C392.569 19.0166 392.801 19.393 392.997 19.7977C393.412 20.5906 393.761 21.4207 394.07 22.2646C394.683 23.9614 395.133 25.7269 395.443 27.5254C395.758 29.3236 395.953 31.1448 396.065 32.9773C396.125 33.8891 396.162 34.828 396.208 35.7514L396.305 37.7845L390.608 38.0895L382.223 38.5415L382.147 37.0331C382.088 35.6115 381.988 34.1912 381.763 32.8742C381.542 31.5526 381.199 30.294 380.646 29.1459C380.101 28.0035 379.328 26.971 378.338 26.2428C377.353 25.5077 376.197 25.1148 375.079 24.9746L375.063 24.9613Z" fill="#6A9A23"/>
<path d="M402.801 24.9656C402.203 22.6548 401.239 22.8832 401.63 25.2097C401.897 26.8631 402.16 28.5525 402.386 30.3878C402.496 31.3035 402.599 32.2556 402.664 33.2487C402.731 34.2438 402.77 35.2853 402.721 36.368C402.716 36.4986 402.712 36.6269 402.706 36.7533C402.692 36.9308 402.68 37.106 402.667 37.2728C402.649 37.501 402.616 37.7284 402.587 37.947C402.549 38.1706 402.513 38.3836 402.478 38.5859C402.35 39.3629 402.251 39.9632 402.194 40.3059C402.264 40.2831 402.36 40.2328 402.447 40.1938C402.536 40.1525 402.622 40.1093 402.707 40.0684C402.88 39.9863 403.049 39.9045 403.212 39.8253C403.541 39.6688 403.857 39.5134 404.161 39.3675C404.461 39.2218 404.753 39.0811 405.035 38.9434C405.166 38.8796 405.295 38.8181 405.42 38.7569C405.494 38.719 405.569 38.681 405.641 38.6454C406.222 38.3495 406.739 38.0886 407.235 37.8379C408.23 37.334 409.152 36.8765 410.402 36.3086C413.075 35.0677 416.694 33.4635 419.925 32.0504C420.732 31.6972 421.514 31.3587 422.252 31.0366C422.623 30.8766 422.982 30.7195 423.328 30.5699C423.651 30.4244 423.969 30.2815 424.278 30.1435L424.51 30.0373L424.627 29.9852C424.643 29.9754 424.67 29.971 424.679 29.9555L424.669 29.8934C424.645 29.7298 424.621 29.5703 424.596 29.4109C424.469 28.5658 424.357 27.8075 424.263 27.1716C424.181 26.6584 424.115 26.2443 424.066 25.9443C424.009 25.5906 423.941 25.2398 423.864 24.8897C423.747 24.3627 423.548 23.4609 423.258 22.267C423.115 21.6751 422.945 20.9912 422.762 20.281C422.599 19.5649 422.429 18.7845 422.257 17.937C421.919 16.25 421.588 14.3419 421.404 12.3017C421.312 11.2815 421.271 10.2275 421.314 9.17048C421.331 8.90671 421.348 8.64295 421.367 8.37693L421.413 7.98269L421.436 7.78557L421.445 7.71975C421.453 7.66451 421.46 7.64713 421.465 7.60892L421.506 7.4081C421.68 6.38378 422.084 5.13595 422.384 4.06711C422.287 4.10077 422.129 4.17316 421.956 4.25533C421.78 4.3356 421.585 4.42601 421.371 4.52428C420.941 4.7231 420.436 4.95568 419.886 5.21114C419.131 5.55774 418.245 5.96396 417.367 6.3653C411.226 9.21824 407.424 10.9851 405.438 11.9042C404.269 12.4546 403.174 12.9712 402.136 13.462C401.618 13.7104 401.117 13.9532 400.623 14.1911C400.196 14.396 399.771 14.5986 399.352 14.7986C399.183 14.8195 399.29 14.9823 399.295 15.091L399.363 15.446C399.409 15.6812 399.454 15.9123 399.497 16.1457C399.555 16.4219 399.614 16.6958 399.671 16.9678C399.726 17.219 399.783 17.4679 399.838 17.715C399.952 18.2087 400.069 18.6937 400.19 19.17C400.43 20.1249 400.684 21.0492 400.954 21.9637C401.557 23.9739 402.388 23.7488 401.992 21.7122C401.823 20.7825 401.653 19.851 401.478 18.8926C401.397 18.415 401.313 17.9312 401.226 17.4373C401.149 16.9592 401.07 16.4752 400.989 15.9786L400.974 15.8456L400.966 15.7812C400.966 15.7623 400.949 15.7324 400.982 15.7295L401.11 15.6785L401.173 15.6542L401.28 15.6092C401.78 15.3876 402.289 15.1588 402.814 14.9244C403.86 14.4477 404.962 13.9451 406.136 13.4069C407.958 12.5628 411.855 11.0143 417.234 8.56739C417.672 8.36786 418.107 8.16225 418.54 7.95474L419.186 7.63645L419.508 7.47429C419.526 7.46225 419.52 7.46071 419.527 7.45166C419.541 7.43581 419.56 7.41318 419.589 7.38756L419.638 7.34764L419.667 7.32619C419.667 7.32619 419.691 7.30737 419.688 7.31606C419.694 7.34069 419.694 7.39103 419.696 7.4622L419.696 7.51671L419.663 7.87844C419.633 8.14329 419.62 8.40669 419.607 8.67009C419.56 9.72334 419.595 10.7652 419.667 11.7724C419.824 13.7898 420.128 15.6834 420.427 17.3172C420.573 18.1354 420.726 18.8859 420.861 19.5603C421 20.2365 421.126 20.8298 421.25 21.3122C421.469 22.2689 421.597 22.8286 421.597 22.8286C421.597 22.8286 421.823 23.7951 422.142 25.3537C422.301 26.133 422.48 27.0597 422.663 28.0908C422.702 28.3203 422.743 28.5559 422.785 28.7957L422.803 28.9075L422.812 28.9654C422.818 28.9859 422.785 28.9846 422.771 28.9963C422.384 29.1767 421.984 29.3624 421.575 29.5511C417.19 31.5824 412.042 33.9717 408.986 35.3886L405.982 36.7841L404.671 37.3929L404.467 37.4882L404.366 37.5347L404.316 37.558L404.289 37.5708C404.289 37.5708 404.28 37.5779 404.277 37.576L404.28 37.5631C404.303 37.4584 404.319 37.3521 404.328 37.2442L404.345 37.0687C404.365 36.8613 404.372 36.6551 404.381 36.4465C404.431 35.2672 404.374 34.1685 404.284 33.1272C404.194 32.0859 404.057 31.1094 403.903 30.1765C403.593 28.3087 403.216 26.6124 402.802 24.9739L402.801 24.9656Z" fill="#6A9A23"/>
<path d="M384.78 4.00329C387.938 3.20915 387.727 2.24341 384.526 2.83562C382.254 3.25496 379.932 3.70171 377.414 4.21162C376.157 4.47169 374.85 4.74026 373.477 5.02294C372.791 5.16845 372.086 5.31766 371.367 5.47022L371.218 5.49987C371.197 5.50168 371.166 5.52123 371.163 5.48791C371.092 5.31992 371.022 5.14967 370.951 4.97752C369.623 1.76695 368.946 -0.312486 368.381 -2.12043C367.842 -3.93698 367.411 -5.50059 367.051 -7.83194C366.893 -8.81488 366.773 -9.88927 366.688 -11.0192C366.622 -12.1486 366.576 -13.3343 366.64 -14.5359C366.704 -15.7374 366.819 -16.9581 367.064 -18.1396C367.308 -19.3211 367.637 -20.4742 368.076 -21.5383C368.18 -21.8055 368.312 -22.0581 368.428 -22.3158C368.488 -22.4427 368.547 -22.5716 368.605 -22.6962C368.676 -22.822 368.743 -22.9474 368.812 -23.0709C369.086 -23.5667 369.355 -24.0516 369.614 -24.5211C369.889 -24.9813 370.184 -25.4056 370.452 -25.8254C370.59 -26.0303 370.716 -26.2406 370.855 -26.4331C371 -26.6199 371.14 -26.804 371.278 -26.9817C371.556 -27.3352 371.803 -27.6798 372.06 -27.9811C372.327 -28.2707 372.576 -28.5441 372.802 -28.7903C373.238 -29.3044 373.671 -29.6399 373.952 -29.9097L374.459 -30.3796L375.001 -30.8127C375.161 -30.9441 375.356 -31.1015 375.579 -31.2845C375.688 -31.3821 375.817 -31.4709 375.954 -31.5604C376.091 -31.6541 376.237 -31.7508 376.39 -31.8542C376.986 -32.2878 377.767 -32.7206 378.666 -33.1972C380.483 -34.1268 382.926 -34.9701 385.749 -35.6869C386.452 -35.8717 387.182 -36.0462 387.929 -36.2179C388.673 -36.3957 389.442 -36.561 390.222 -36.7356C390.745 -36.8523 391.276 -36.9696 391.811 -37.0874C391.827 -37.0972 391.829 -37.0805 391.834 -37.0684L391.843 -37.0293L391.877 -36.8812C391.965 -36.4754 392.052 -36.0697 392.138 -35.6616C392.826 -32.3977 393.535 -29.0516 394.215 -25.8332C394.699 -23.5607 395.138 -21.5069 395.533 -19.6569C395.709 -18.8328 395.874 -18.0562 396.03 -17.3227L396.047 -17.2507C396.046 -17.2318 396.008 -17.2368 395.99 -17.229C395.759 -17.1838 395.532 -17.1389 395.315 -17.097C393.858 -16.8196 392.563 -16.5563 391.456 -16.2547C390.349 -15.9573 389.427 -15.6235 388.695 -15.281C387.829 -14.8808 387.014 -14.3841 386.312 -13.7652C385.606 -13.15 385.025 -12.4135 384.602 -11.6257C384.182 -10.8318 383.945 -10.0035 383.788 -9.19671C383.737 -8.79153 383.662 -8.39059 383.656 -7.99771C383.648 -7.79977 383.64 -7.606 383.631 -7.41223C383.631 -7.21918 383.643 -7.02722 383.649 -6.83679C383.805 -3.79316 384.714 -1.22823 385.709 1.20761C386.262 2.50259 386.762 3.06984 386.983 3.00452L386.993 2.90918C386.995 2.93001 387.006 2.93951 387.029 2.93545L387.023 2.98842C387.233 2.86741 387.157 2.12707 386.709 0.831387C385.907 -1.6044 385.185 -4.13523 385.149 -6.86608C385.149 -7.03604 385.145 -7.20563 385.149 -7.37595C385.164 -7.54509 385.174 -7.71387 385.187 -7.88491C385.199 -8.23008 385.278 -8.56211 385.326 -8.9041C385.476 -9.57384 385.682 -10.2422 386.022 -10.857C386.365 -11.468 386.82 -12.032 387.389 -12.5198C387.957 -13.0076 388.635 -13.4231 389.39 -13.7697C389.972 -14.0447 390.76 -14.3207 391.748 -14.5721C392.735 -14.8234 393.919 -15.0373 395.292 -15.2696C395.66 -15.3351 396.039 -15.3993 396.429 -15.4689C396.772 -15.5363 397.118 -15.6041 397.469 -15.6723C397.646 -15.7087 397.826 -15.7431 398.003 -15.7795L398.137 -15.8058L398.206 -15.818C398.206 -15.818 398.218 -15.8191 398.222 -15.8236L398.22 -15.8403L398.213 -15.8732L398.161 -16.1414C397.961 -17.148 397.754 -18.2065 397.532 -19.3161C397.2 -21.0058 396.833 -22.8477 396.421 -24.8325C396.152 -26.1248 395.86 -27.413 395.553 -28.6873C394.886 -31.4348 394.198 -34.3925 393.546 -37.286L393.341 -38.223L393.235 -38.7027L393.183 -38.9395L393.156 -39.0588C393.152 -39.0774 393.15 -39.1024 393.141 -39.1141L393.079 -39.1004C392.467 -38.9655 391.858 -38.8288 391.251 -38.6943C390.541 -38.5342 389.839 -38.3747 389.149 -38.2205C387.771 -37.908 386.435 -37.6013 385.194 -37.2776C382.705 -36.6506 380.584 -35.9232 379.116 -35.3029C378.753 -35.1371 378.426 -34.9871 378.141 -34.8596C377.997 -34.7947 377.866 -34.7351 377.745 -34.6784C377.627 -34.6157 377.521 -34.5582 377.422 -34.5056C377.038 -34.296 376.829 -34.1815 376.829 -34.1815C376.829 -34.1815 376.751 -34.139 376.605 -34.0571C376.459 -33.971 376.233 -33.8675 375.972 -33.6854C375.704 -33.509 375.379 -33.292 374.999 -33.043C374.904 -32.9802 374.807 -32.9151 374.705 -32.8496C374.611 -32.7743 374.511 -32.6964 374.413 -32.6165C374.213 -32.4565 373.998 -32.289 373.775 -32.1101C373.313 -31.7721 372.875 -31.325 372.39 -30.8675C371.887 -30.4253 371.447 -29.8604 370.947 -29.3072C370.689 -29.0331 370.468 -28.7244 370.238 -28.4086C370.006 -28.0969 369.77 -27.7742 369.529 -27.4512C369.295 -27.1225 369.093 -26.7672 368.869 -26.4183C368.652 -26.0638 368.416 -25.7139 368.211 -25.3457C368.012 -24.9718 367.81 -24.5934 367.61 -24.213C367.412 -23.8266 367.19 -23.4611 367.018 -23.0413C366.838 -22.6332 366.644 -22.2241 366.501 -21.7962L366.27 -21.1594C366.194 -20.9451 366.142 -20.7265 366.076 -20.511C365.569 -18.778 365.306 -16.9905 365.209 -15.272C365.017 -11.829 365.44 -8.67637 365.857 -6.37091C366.505 -2.89785 367.285 -0.399327 367.899 1.48832C368.53 3.37452 369.032 4.64658 369.43 5.61085C369.519 5.81714 369.604 6.0238 369.693 6.22593C369.821 6.52323 369.954 6.82018 370.092 7.1145L370.193 7.33446L370.219 7.39097C370.227 7.40918 370.255 7.38998 370.274 7.39044L370.391 7.36557L370.861 7.27026C371.154 7.20714 371.444 7.14212 371.732 7.07936C372.451 6.91847 373.155 6.76093 373.838 6.60936C375.206 6.29562 376.507 5.99825 377.757 5.70939C380.258 5.12332 382.558 4.56518 384.799 4.00376L384.78 4.00329Z" fill="#6A9A23"/>
<path d="M289.604 -5.95927C289.825 -7.16812 289.658 -7.81042 289.394 -7.85468C289.12 -7.90012 288.748 -7.36645 288.444 -6.25107C287.978 -4.67267 287.331 -3.1185 286.404 -1.58822C285.451 -0.0788647 284.202 1.41638 282.444 2.63884C282.187 2.81642 281.946 2.9884 281.706 3.1267C281.648 3.16317 281.588 3.19774 281.53 3.23421L281.447 3.28762C281.447 3.28762 281.409 3.30978 281.377 3.32517L281.29 3.36835C281.059 3.48283 280.835 3.59242 280.626 3.69867C280.424 3.80645 280.211 3.89829 280.009 3.98299C279.81 4.06733 279.626 4.14832 279.454 4.2199C279.131 4.36125 278.862 4.47897 278.656 4.5682C278.704 4.61647 278.78 4.66864 278.853 4.71892C278.925 4.77146 278.996 4.81983 279.068 4.87237C279.209 4.97138 279.347 5.07265 279.484 5.16786C279.754 5.36053 280.016 5.54559 280.268 5.72304C280.518 5.89859 280.76 6.0707 280.994 6.2371C281.17 6.35821 281.342 6.47968 281.508 6.59544C282.011 6.93785 282.46 7.2452 282.899 7.54495C283.773 8.1448 284.593 8.71793 285.64 9.49792C286.838 10.3781 288.231 11.4219 289.677 12.5177C290.398 13.0658 291.134 13.6272 291.868 14.1826C292.068 14.3352 292.27 14.4898 292.47 14.6424L292.955 15.0033L293.076 15.0935L293.136 15.1365L293.166 15.1612C293.166 15.1612 293.19 15.1507 293.202 15.1455L293.482 15.0373L294.04 14.8189L294.428 14.6468C294.65 14.5436 294.865 14.4306 295.078 14.3198C295.921 13.8585 296.673 13.3087 297.317 12.722C297.483 12.5796 297.641 12.4338 297.785 12.2807C297.933 12.1314 298.078 11.9825 298.221 11.84C298.484 11.5361 298.742 11.243 298.969 10.9548C299.883 9.79918 300.394 8.76454 300.697 8.20105C300.87 7.86299 301.007 7.51115 301.151 7.16086C301.27 6.89033 301.388 6.50663 301.543 6.03374C301.71 5.56394 301.847 4.99179 302.013 4.33953C302.105 4.01476 302.163 3.66562 302.234 3.29648C302.303 2.93376 302.376 2.55402 302.45 2.15726C302.521 1.78395 302.597 1.39552 302.673 0.992327C302.769 0.593762 302.883 0.187326 302.989 -0.237315C303.46 -1.91903 304.268 -3.72008 305.478 -5.37976C306.096 -6.19706 306.82 -6.9753 307.642 -7.65926C308.05 -8.00731 308.494 -8.31432 308.949 -8.61183L309.48 -8.92643C309.722 -9.05865 309.971 -9.18934 310.24 -9.31123C310.758 -9.55548 311.278 -9.80199 311.8 -10.0466C311.202 -10.492 309.695 -11.6078 308.218 -12.703C305.465 -14.7241 303.236 -16.3585 301.476 -17.6495C300.595 -18.2971 299.83 -18.8559 299.173 -19.3383C298.846 -19.5785 298.546 -19.8001 298.271 -20.0007C298.038 -20.1694 297.818 -20.3308 297.61 -20.4827C297.494 -20.565 297.378 -20.6472 297.27 -20.726C297.244 -20.7594 297.213 -20.7357 297.182 -20.7226L297.092 -20.6791C297.033 -20.6509 296.971 -20.6224 296.914 -20.5965C296.644 -20.4641 296.349 -20.3377 296.113 -20.204C295.961 -20.1194 295.804 -20.0429 295.661 -19.9466C295.516 -19.8563 295.37 -19.7661 295.229 -19.6762C295.09 -19.5803 294.954 -19.4824 294.82 -19.3869C294.549 -19.1934 294.3 -18.9851 294.054 -18.7791C293.819 -18.5594 293.574 -18.3598 293.365 -18.1298C292.493 -17.2443 291.803 -16.2907 291.244 -15.3315C290.158 -13.3931 289.552 -11.4542 289.197 -9.52671C288.87 -7.38335 289.73 -7.29835 290.238 -9.28538C290.758 -11.0888 291.464 -12.8475 292.528 -14.5574C293.072 -15.4019 293.716 -16.2236 294.498 -16.9838C294.687 -17.1806 294.905 -17.3485 295.111 -17.5384C295.329 -17.7105 295.547 -17.8909 295.782 -18.0519C295.901 -18.1335 296.018 -18.2129 296.139 -18.2968C296.263 -18.3705 296.386 -18.4483 296.512 -18.5243C296.637 -18.6044 296.768 -18.6682 296.898 -18.7403C296.958 -18.7749 296.982 -18.7854 297.027 -18.806C297.043 -18.8116 297.059 -18.8214 297.075 -18.827C297.089 -18.8156 297.105 -18.8023 297.118 -18.7909C297.157 -18.7585 297.195 -18.7262 297.236 -18.692C297.49 -18.4937 297.769 -18.2786 298.075 -18.0408C298.684 -17.5628 299.393 -17.0053 300.204 -16.3705C301.821 -15.1028 303.83 -13.5417 306.218 -11.7617C306.608 -11.4723 307 -11.1853 307.395 -10.9069L307.991 -10.4907L308.141 -10.3882C308.141 -10.3882 308.145 -10.3886 308.149 -10.389C308.156 -10.3874 308.164 -10.3881 308.172 -10.3889C308.198 -10.3869 308.247 -10.3723 308.287 -10.3505C308.274 -10.3264 308.253 -10.3015 308.185 -10.2431L308.026 -10.1412L307.856 -10.0215L307.515 -9.7822C307.288 -9.6219 307.077 -9.44412 306.856 -9.27395C305.994 -8.57388 305.217 -7.77012 304.539 -6.92241C303.169 -5.22782 302.263 -3.31968 301.676 -1.61952C301.604 -1.40558 301.532 -1.1958 301.461 -0.992448C301.389 -0.786833 301.346 -0.579579 301.287 -0.381476C301.185 0.0197139 301.063 0.395451 300.994 0.762334C300.848 1.4779 300.721 2.10572 300.615 2.62689C300.509 3.12497 300.445 3.52707 300.363 3.79018C300.29 4.05674 300.25 4.20078 300.25 4.20078C300.25 4.20078 300.188 4.43483 300.074 4.86019C300.018 5.07269 299.922 5.32023 299.824 5.6162C299.724 5.91027 299.618 6.24672 299.46 6.60036C299.308 6.95554 299.158 7.35463 298.943 7.75307C298.84 7.95289 298.734 8.1614 298.625 8.37859C298.502 8.58437 298.376 8.79468 298.248 9.01141C297.713 9.8635 297.042 10.7483 296.207 11.5257C296.102 11.623 295.997 11.7202 295.892 11.8174C295.785 11.9127 295.666 11.9985 295.555 12.09C295.334 12.2791 295.092 12.4386 294.853 12.6083C294.734 12.6941 294.604 12.7621 294.482 12.8418C294.359 12.9197 294.233 12.9956 294.101 13.0617C293.97 13.1296 293.844 13.2056 293.709 13.2614L293.533 13.3417C293.509 13.3522 293.493 13.3619 293.472 13.3679C293.433 13.3734 293.389 13.4255 293.358 13.3799L293.237 13.2897C292.982 13.102 292.724 12.9124 292.469 12.7247C291.958 12.3494 291.452 11.9778 290.954 11.6139C288.967 10.1558 287.13 8.80428 285.762 7.80036L283.266 5.96879L282.16 5.15826L281.992 5.03643L281.909 4.97438L281.868 4.94015C281.868 4.94015 281.82 4.91912 281.851 4.91433C281.973 4.86601 282.09 4.80973 282.204 4.74737L282.226 4.73497L282.264 4.71279L282.428 4.61469L282.757 4.42037C282.977 4.29221 283.184 4.13788 283.397 3.99986C285.383 2.6065 286.754 0.888816 287.729 -0.813492C288.682 -2.53899 289.266 -4.26186 289.612 -5.96416L289.604 -5.95927Z" fill="#6A9A23"/>
<path d="M335.18 -24.8556C335.367 -27.0896 334.385 -27.2164 333.994 -25.0108C333.717 -23.4468 333.449 -21.8414 333.182 -20.0956C333.054 -19.2221 332.92 -18.3146 332.78 -17.3583C332.644 -16.3603 332.501 -15.3135 332.351 -14.2073C332.315 -13.902 332.279 -13.6073 332.272 -13.5479C332.586 -13.2373 332.882 -12.942 333.169 -12.6584C333.357 -12.4774 333.536 -12.2999 333.707 -12.1364C334.053 -11.8034 334.368 -11.5034 334.661 -11.2224C335.252 -10.6673 335.75 -10.1985 336.218 -9.76272C337.155 -8.88931 337.961 -8.13454 339.071 -6.99696C339.768 -6.28315 340.543 -5.4922 341.538 -4.47471C342.213 -4.57105 342.912 -4.67145 343.62 -4.77484C344.209 -4.85527 344.811 -4.93678 345.41 -5.02019C346.613 -5.17905 347.818 -5.34016 348.949 -5.49061C351.408 -5.80659 353.549 -6.08036 354.718 -6.22989C354.939 -6.58062 355.125 -6.88001 355.282 -7.13069C355.375 -7.27301 355.451 -7.3908 355.515 -7.49084C355.643 -7.68865 355.727 -7.81548 355.797 -7.92231C355.981 -8.20051 356.158 -8.48443 356.33 -8.77214C356.622 -9.26111 357.152 -10.1443 358.014 -11.5787C358.936 -13.098 360.217 -15.2044 361.956 -18.0724C361.796 -18.5474 361.552 -19.2816 361.244 -20.2012C360.997 -20.9457 360.704 -21.8414 360.38 -22.8288C359.735 -24.8082 358.978 -27.1597 358.266 -29.4229L357.826 -30.7822L346.487 -34.4322C346.071 -34.566 345.657 -34.698 345.367 -34.7904C344.773 -34.3822 344.196 -33.9902 343.636 -33.6038C343.197 -33.2972 342.767 -33.0018 342.351 -32.7098C341.523 -32.1239 340.738 -31.567 339.98 -31.0334C338.475 -29.9545 337.106 -28.942 335.757 -27.9207C334.187 -26.7334 334.67 -26.0221 336.355 -27.0389C337.803 -27.9114 339.251 -28.8111 340.81 -29.8065C341.585 -30.3101 342.392 -30.8333 343.246 -31.3858C343.996 -31.883 344.784 -32.4066 345.626 -32.9622C345.717 -32.9323 345.846 -32.889 345.978 -32.8479C346.88 -32.5568 348.252 -32.0525 350.06 -31.4015C350.964 -31.0812 351.977 -30.72 353.094 -30.3258C354.069 -29.9928 355.133 -29.6276 356.281 -29.234L356.327 -29.0953L356.539 -28.457C356.685 -28.0332 356.834 -27.6097 356.99 -27.1931C357.543 -25.6967 358.111 -24.0988 358.656 -22.52C359.156 -21.0526 359.648 -19.6076 360.1 -18.2892L360.045 -18.1921C359.979 -18.0815 359.913 -17.975 359.847 -17.8644C359.702 -17.6273 359.56 -17.3947 359.422 -17.1666C359.143 -16.7102 358.876 -16.2737 358.625 -15.8595C358.115 -15.0327 357.658 -14.2923 357.279 -13.6761C356.512 -12.4473 356.05 -11.7043 356.05 -11.7043L353.657 -7.82492L342.05 -6.02149L339.492 -8.60924L334.019 -14.1379L334.03 -14.2332C334.157 -15.2577 334.277 -16.227 334.393 -17.1498C334.503 -18.1077 334.607 -19.0211 334.706 -19.8962C334.896 -21.6521 335.05 -23.2727 335.182 -24.8537L335.18 -24.8556Z" fill="#6A9A23"/>
<path d="M334.463 4.5503C336.378 5.19843 337.423 5.25884 337.511 5.0037C337.601 4.73987 336.74 4.16619 334.878 3.42744C332.352 2.41678 329.793 1.3314 327.049 0.0858865C325.677 -0.538004 324.262 -1.20221 322.786 -1.92192C322.048 -2.2797 321.294 -2.65496 320.524 -3.04353C320.14 -3.23894 319.751 -3.43817 319.356 -3.63893C318.73 -3.96444 318.098 -4.29148 317.454 -4.62388C317.2 -4.26194 316.851 -3.76375 316.498 -3.26103C311.509 3.94451 310.444 5.82245 307.026 10.6635C306.168 11.8814 305.22 13.2246 304.201 14.6705C303.026 16.325 301.771 18.0935 300.448 19.9518C301.609 20.5877 302.784 21.2286 303.958 21.8717C304.893 22.3719 305.832 22.8675 306.756 23.3476C308.612 24.3051 310.431 25.2049 312.103 26.0042C315.451 27.6024 318.222 28.8037 319.543 29.3585C320.099 29.5978 320.659 29.8219 321.228 30.0371C323.093 30.7482 327.879 32.5742 334.242 34.4546C337.42 35.4002 340.99 36.3581 344.761 37.2377C346.647 37.6764 348.582 38.0983 350.545 38.4926C351.525 38.6909 352.513 38.8801 353.502 39.0629L354.99 39.3326L357.469 39.7598C357.512 39.0699 357.618 37.378 357.721 35.7072C358.398 24.2426 358.818 17.1477 359.038 13.4421C359.115 12.082 359.191 10.7661 359.248 9.7981C358.525 9.66145 357.813 9.53015 357.113 9.39776C356.669 9.31034 356.23 9.22673 355.799 9.14241C354.934 8.97185 354.095 8.79914 353.278 8.62651C351.643 8.27935 350.096 7.92461 348.607 7.56898C345.63 6.8513 342.892 6.12137 340.191 5.33367C338.504 4.84208 337.595 4.76975 337.515 5.00334C337.437 5.22408 338.192 5.75453 339.861 6.35052C342.533 7.30237 345.259 8.1655 348.242 8.98542C349.733 9.39329 351.289 9.78932 352.935 10.1691C353.757 10.3622 354.602 10.547 355.474 10.7316C356.136 10.8673 356.819 11.0053 357.52 11.1501C357.485 11.7344 357.434 12.5299 357.383 13.3484C357.181 16.7483 356.524 23.8217 355.888 33.8224C355.843 34.63 355.797 35.4334 355.753 36.2387L355.697 37.4437C355.695 37.5153 355.695 37.488 355.696 37.4963L355.7 37.5001L355.703 37.5145L355.713 37.5494C355.713 37.5494 355.699 37.5569 355.686 37.558C355.653 37.5567 355.753 37.5795 355.443 37.5309C355.007 37.4616 354.566 37.3928 354.124 37.3221C353.241 37.1783 352.344 37.0273 351.449 36.8615C349.654 36.5387 347.844 36.1753 346.062 35.7821C342.497 35.0063 339.05 34.1049 336.046 33.2323C333.043 32.3574 330.487 31.5173 328.681 30.8912C327.778 30.5729 327.064 30.3201 326.573 30.1465C326.083 29.9666 325.818 29.8678 325.818 29.8678C321.699 28.3743 317.646 26.705 313.653 24.9004C311.657 23.995 309.679 23.0544 307.719 22.0745C306.741 21.5843 305.762 21.0859 304.793 20.5802L303.34 19.8144L302.638 19.4367L309.085 10.2353C314.014 3.19229 316.386 -0.198457 317.845 -2.28256C317.896 -2.35617 317.946 -2.42977 317.981 -2.4811C318.602 -2.16773 319.205 -1.86541 319.791 -1.56997C320.573 -1.18248 321.337 -0.814374 322.09 -0.459944C323.592 0.247014 325.035 0.89203 326.437 1.48387C329.24 2.67399 331.869 3.6673 334.463 4.55447L334.463 4.5503Z" fill="#6A9A23"/>
<path d="M266.148 11.4377C265.904 11.241 261.607 11.6973 262.767 12.4218C263.152 12.7388 263.531 12.734 263.685 12.313C263.756 13.154 264.635 12.1 265.004 12.3981C264.83 12.9694 266.069 11.8383 265.807 12.4271C270.358 13.3709 279.961 8.3733 268.469 10.9842C269.573 11.3222 268.502 11.4793 268.006 11.3163C268.775 10.6232 266.63 11.1226 266.225 11.3524C266.878 11.3826 265.768 11.8565 266.15 11.4398L266.148 11.4377Z" fill="#101214"/>
<path d="M273.986 19.0467C273.385 19.0418 270.602 22.9468 270.26 23.3131C269.677 24.2322 271.049 24.4039 271.328 23.6053C271.45 23.4739 271.918 22.3416 272.164 22.8577C273.353 22.6833 273.656 20.6225 274.654 20.5627C274.514 20.2788 274.886 19.9778 274.819 19.7896C275.111 19.8418 275.301 19.4589 275.233 19.4186C276.559 18.4848 275.082 17.1701 274.308 18.5903C274.261 18.5239 273.902 18.7589 273.986 19.0428L273.986 19.0467Z" fill="#101214"/>
<path d="M288.709 27.7641C289.293 27.125 289.207 27.8367 288.919 28.1456C288.477 27.5052 288.381 28.9221 288.518 29.2965C288.558 29.1514 288.815 29.1459 288.75 29.4489C288.158 29.1232 287.385 32.9628 288.995 31.3767C289.003 31.3103 288.513 31.1909 288.68 31.1416C289.409 31.4079 288.987 30.7058 288.958 30.5243C289.347 30.5991 289.013 30.3704 289.181 30.3567C289.67 30.6613 288.959 29.5148 289.438 29.8463C290.383 29.1065 289.625 27.1642 290.464 26.62C289.666 25.994 291.452 23.4009 289.594 24.1887C289.01 25.3404 288.629 26.3014 288.709 27.7641Z" fill="#101214"/>
<path d="M278.52 33.4874C279.672 34.0122 279.857 31.3062 280.471 30.6733C281.323 29.9268 285.341 20.9746 282.563 22.9852C281.37 25.7048 279.916 27.7259 278.886 31.2063C278.677 31.7594 277.666 33.4114 278.52 33.4874Z" fill="#101214"/>
<path d="M272.605 3.22304C273.458 2.36044 274.245 3.76255 275.035 3.06901C276.28 1.6898 267.453 -0.415104 267.475 1.23084C267.685 2.64358 272.067 2.52653 272.605 3.22304Z" fill="#101214"/>
<path d="M353.904 0.605135C351.888 -0.0406305 348.015 0.187959 346.143 -0.686571C344.414 -0.564747 342.931 -1.0713 341.224 -1.48882C341.674 -1.91768 342.883 -2.42509 342.976 -2.90903C346.063 -5.01434 340.805 -2.8555 339.877 -1.40738L339.89 -1.40739C339.89 -1.40739 339.691 -1.15637 339.673 -1.19408C339.802 -0.692643 340.458 -0.0652969 340.454 0.283156C343.482 2.73881 344.616 3.1592 341.381 -0.567943C342.528 -0.296267 343.241 0.288849 344.364 0.147743C344.642 0.54692 350.562 1.43902 348.42 0.717936C348.941 0.404403 350.793 1.07698 349.514 1.05847C350.098 1.25533 359.729 2.18758 358.787 0.832591C358.387 0.926263 357.763 0.58519 357.477 0.747534C357.422 0.905176 357.407 1.02061 357.253 0.965295C357.28 0.632353 356.933 0.630529 356.556 0.701981C356.088 0.866753 355.08 0.903412 355.236 0.665757C355.306 0.46149 353.472 0.982932 353.904 0.607357L353.904 0.605135Z" fill="#101214"/>
</g>
<g clipPath="url(#clip2_783_5660)">
<path d="M13.0459 23.9464C13.2244 23.8029 13.375 23.6514 13.5135 23.5051C13.6519 23.3588 13.7767 23.2242 13.8912 23.0925C14.1165 22.8338 14.2962 22.6063 14.4242 22.4127C14.6826 22.0273 14.7534 21.7777 14.657 21.6812C14.5605 21.5846 14.2987 21.6388 13.898 21.8582C13.6977 21.9679 13.4612 22.1206 13.1927 22.3159C13.0586 22.4156 12.9146 22.5225 12.7657 22.6446C12.6168 22.7666 12.4583 22.8999 12.2783 23.0267C11.7797 23.3994 11.2791 23.7743 10.7705 24.1541C10.2398 24.4959 9.70493 24.8382 9.16244 25.1894C8.60947 25.5164 8.02636 25.8104 7.44957 26.1289C7.15404 26.2784 6.84575 26.4016 6.5389 26.5415C6.23133 26.6731 5.92782 26.8274 5.60858 26.9453C5.28898 27.059 4.96332 27.1754 4.63765 27.2917C4.47464 27.3478 4.31044 27.4145 4.1448 27.4645C3.97464 27.5108 3.80449 27.557 3.63433 27.6032C3.29175 27.6937 2.94835 27.799 2.59636 27.8778C2.24139 27.9463 1.88225 28.0152 1.51931 28.0887C0.0606176 28.3263 -1.49813 28.4258 -3.12925 28.2944C-3.56103 28.2752 -3.97141 28.2121 -4.35537 28.1636C-4.54794 28.1446 -4.73171 28.106 -4.90643 28.075C-4.9938 28.0595 -5.08116 28.0439 -5.16436 28.0281C-5.22411 28.0165 -5.28576 28.0071 -5.34551 27.9955C-5.43287 27.98 -5.5081 27.9593 -5.58713 27.943C-6.21656 27.7731 -6.77491 27.6242 -7.25162 27.4977C-7.70977 27.3675 -8.08591 27.2637 -8.36563 27.183C-8.05452 28.2597 -7.73595 29.277 -7.45896 30.2014C-7.28585 30.7487 -7.12621 31.2616 -6.97515 31.7478C-6.68674 32.6587 -6.42815 33.4671 -6.18005 34.2514C-5.68384 35.8198 -5.22994 37.287 -4.66961 39.2338C-4.04204 41.3763 -3.32537 43.895 -2.58721 46.5167C-2.22004 47.8299 -1.84428 49.1695 -1.4715 50.499C-1.25363 51.2732 -1.04029 52.0436 -0.825398 52.8077C-0.802628 52.877 -0.789367 52.9577 -0.758627 53.0222L-0.551516 53.0882L-0.137285 53.2201L0.276945 53.3521L0.53893 53.4217C0.71283 53.4675 0.884474 53.5113 1.05837 53.5571C1.23346 53.5923 1.40628 53.6256 1.57946 53.663C4.36235 54.2065 7.04848 53.896 9.14027 53.3601C9.66062 53.2143 10.1485 53.0566 10.6086 52.9181C11.0609 52.7614 11.4697 52.5875 11.8496 52.4433C12.2341 52.303 12.5622 52.1424 12.8562 51.9994C13.1502 51.8564 13.4062 51.7356 13.6198 51.6331C13.8785 51.5184 14.1157 51.374 14.3552 51.2316L15.0752 50.7978C15.254 50.6816 15.4828 50.561 15.7156 50.3898C15.9507 50.2204 16.2176 50.0315 16.5119 49.8192C16.8017 49.6032 17.1399 49.3892 17.4667 49.1154C17.7957 48.8435 18.1502 48.5505 18.5283 48.2387C18.716 48.0797 18.9169 47.928 19.1073 47.752C19.2955 47.5741 19.4897 47.3936 19.6897 47.2064C20.0835 46.8344 20.499 46.4459 20.9358 46.0366C21.3513 45.6481 21.7823 45.2457 22.2305 44.8228C22.6881 44.4118 23.1922 44.0282 23.6952 43.609C23.943 43.3924 24.219 43.2111 24.4958 43.015C24.7708 42.8212 25.0517 42.6248 25.3346 42.4262C25.4725 42.3219 25.6221 42.2313 25.772 42.1449C25.9215 42.0543 26.0733 41.9656 26.2248 41.8727C26.5303 41.693 26.8325 41.499 27.1493 41.3288C28.4302 40.6597 29.8119 40.0405 31.3018 39.605C32.7947 39.1798 34.3762 38.9063 36.0024 38.8598C36.8156 38.8249 37.6359 38.8734 38.4607 38.9488L39.0913 39.0347L39.4056 39.0788L40.0042 39.2074C40.8225 39.3777 41.6365 39.5716 42.4509 39.7695C42.1544 38.7398 41.401 36.1362 40.667 33.5875C37.7264 23.5317 35.9053 17.3068 34.9535 14.0573C34.9552 13.7613 34.6651 13.8032 34.4682 13.7342C34.2584 13.6853 34.0485 13.6363 33.8387 13.5874L33.6803 13.5507C33.6311 13.5403 33.6141 13.5376 33.5778 13.5303L33.3902 13.4962L33.0173 13.4299C32.7696 13.38 32.5206 13.3638 32.2744 13.3306L31.9055 13.287L31.5408 13.2662C30.5668 13.1891 29.6218 13.2521 28.7074 13.3293C26.8858 13.5438 25.2051 14.0042 23.6927 14.641C23.3041 14.7817 22.9496 14.9782 22.5817 15.1402C22.4004 15.2272 22.2187 15.3101 22.0393 15.3949C21.8648 15.4877 21.6929 15.5865 21.5206 15.6812C21.1787 15.8766 20.8406 16.0675 20.5024 16.2583C20.1809 16.4708 19.8612 16.6811 19.5415 16.8914C19.3828 16.9974 19.226 17.1013 19.0692 17.2051C18.9128 17.3131 18.7677 17.4305 18.618 17.5442C18.321 17.7735 18.0236 17.9986 17.7304 18.2234C17.4281 18.4405 17.165 18.6983 16.8834 18.9367C16.6064 19.179 16.3335 19.4208 16.0565 19.6631C14.9003 20.7809 14.4954 21.5106 14.6627 21.6744C14.8371 21.8481 15.5686 21.4742 16.7575 20.4689C17.0367 20.2516 17.3182 20.0363 17.6015 19.8187C17.8853 19.6053 18.1547 19.3721 18.455 19.1803C18.7503 18.9805 19.0435 18.7789 19.3427 18.5746C19.4915 18.4757 19.6354 18.3688 19.7888 18.2736C19.9425 18.1827 20.0981 18.0895 20.256 17.9982C20.5672 17.8117 20.8807 17.6272 21.1938 17.4384C21.5194 17.2717 21.8468 17.1028 22.1765 16.9357C22.3434 16.852 22.5062 16.7687 22.675 16.6827C22.8449 16.6092 23.0189 16.5354 23.193 16.4615C23.5419 16.3222 23.8814 16.148 24.2446 16.0284C25.6722 15.4787 27.2231 15.0945 28.8787 14.9259C29.7068 14.8688 30.5609 14.822 31.436 14.8972L31.7652 14.919L32.0939 14.9598C32.3148 14.991 32.5385 15.0052 32.7585 15.0512C32.959 15.0883 33.1636 15.1252 33.3663 15.1642L33.4906 15.1954C33.5296 15.2088 33.5901 15.2057 33.5831 15.2462C33.7626 15.8915 33.9886 16.7112 34.2604 17.6969C34.563 18.8205 34.9173 20.1306 35.3166 21.6214C36.1212 24.6004 37.1258 28.2922 38.3635 32.5933C38.7677 33.9956 39.1924 35.3918 39.6324 36.77L39.7103 37.0171L39.7503 37.1396C39.7503 37.1396 39.7548 37.1434 39.757 37.1453C39.7661 37.1529 39.7713 37.165 39.7789 37.179C39.7935 37.203 39.816 37.2451 39.8321 37.2856C39.8094 37.2897 39.7776 37.2862 39.7337 37.2879L39.7 37.2866L39.6811 37.2861L39.5858 37.2755L39.0005 37.2045C38.6159 37.1477 38.1999 37.1418 37.8004 37.1071C37.3951 37.0793 36.9912 37.0913 36.5855 37.0824C34.9651 37.099 33.3478 37.3232 31.8071 37.7043C28.7091 38.445 25.9889 39.9166 23.8329 41.4107C23.5617 41.6 23.2986 41.7843 23.0374 41.9664C22.7852 42.1562 22.5484 42.355 22.3129 42.5433C22.0774 42.7316 21.8479 42.9172 21.6222 43.0984C21.5105 43.1899 21.3985 43.2772 21.2906 43.3642C21.1876 43.4592 21.0865 43.5519 20.9873 43.6423C20.2001 44.3673 19.5102 45.0041 18.937 45.5343C18.6591 45.7913 18.4082 46.0207 18.1904 46.2201C18.0817 46.3218 17.9806 46.4145 17.8871 46.4981C17.7891 46.578 17.6987 46.6488 17.6204 46.7143C17.3005 46.9707 17.13 47.1093 17.13 47.1093C17.13 47.1093 16.8416 47.342 16.3261 47.7623C16.0647 47.9675 15.7272 48.1898 15.3418 48.4645C15.15 48.6007 14.9442 48.7445 14.7266 48.8976C14.509 49.0508 14.2624 49.1833 14.0092 49.3375C13.758 49.4894 13.4926 49.6487 13.2175 49.8153C12.9446 49.9837 12.637 50.1153 12.3319 50.276C12.0216 50.4246 11.7142 50.6065 11.3733 50.741C11.037 50.8792 10.6885 51.0228 10.3339 51.1689C8.89465 51.7049 7.25528 52.1345 5.51244 52.2646C4.64192 52.34 3.74838 52.3189 2.85551 52.2326L2.18746 52.1499L1.52224 52.0271C1.30062 51.9876 1.08518 51.9223 0.864745 51.8722L0.70406 51.8337L0.64585 51.8157L0.529429 51.7796C0.476824 51.7779 0.495606 51.728 0.478692 51.7022L0.439583 51.565L0.23949 50.8752C0.105343 50.4147 -0.0284482 49.9584 -0.162235 49.5021C-0.429811 48.5895 -0.692493 47.6848 -0.951844 46.7946C-1.99079 43.24 -2.95224 39.9515 -3.66507 37.5017L-5.03013 32.8424L-5.71171 30.5116L-5.92228 29.7975L-5.96736 29.6399L-5.99086 29.5622L-6.00278 29.5213C-6.00278 29.5213 -6.02077 29.4829 -6.00077 29.4959C-5.91685 29.5201 -5.83258 29.5485 -5.74485 29.5681L-5.6163 29.599L-5.29637 29.6594C-5.12807 29.6888 -4.95906 29.7266 -4.78886 29.7539L-4.27933 29.823L-3.7698 29.8921L-3.25864 29.9317C-1.47352 30.0729 0.223859 29.9509 1.8069 29.671C2.20054 29.5886 2.59002 29.5066 2.97117 29.4253C3.3535 29.3334 3.71855 29.2115 4.08731 29.1082C4.27151 29.0545 4.45344 28.9988 4.63347 28.9455C4.81315 28.8879 4.98721 28.8141 5.162 28.7486C5.51122 28.6134 5.85438 28.4808 6.19753 28.3483C6.53616 28.2119 6.85488 28.0395 7.17958 27.8876C7.49939 27.7277 7.82481 27.584 8.13331 27.4146C8.73565 27.0519 9.34051 26.7183 9.90882 26.3501C10.4625 25.958 11.0127 25.5746 11.5478 25.1862C12.0546 24.7625 12.5558 24.3455 13.0547 23.9267L13.0459 23.9464Z" fill="#6A9A23"/>
<path d="M114.495 48.3233C112.222 47.5594 111.865 48.4842 114.065 49.4412C115.623 50.1181 117.228 50.7952 118.977 51.5123C119.855 51.8642 120.766 52.2322 121.724 52.617C122.269 52.8321 122.83 53.0521 123.405 53.2771C123.642 53.3719 123.882 53.4581 124.118 53.5446L124.298 53.6109L124.387 53.6431L124.432 53.658C124.448 53.6672 124.451 53.6354 124.461 53.6282L124.677 53.3074C124.82 53.0915 124.962 52.8714 125.107 52.6532C125.214 52.4803 125.323 52.3051 125.431 52.1299C126.78 49.8413 127.434 48.3201 127.986 46.9923C128.522 45.6576 128.956 44.5121 129.531 42.8088C130.002 41.3663 130.481 39.6442 130.752 37.7826C131.029 35.9289 131.072 33.9297 130.72 32.0614C130.685 31.8273 130.618 31.6003 130.566 31.3718L130.485 31.0327C130.452 30.9243 130.42 30.8201 130.388 30.7117C130.257 30.2887 130.129 29.8759 130.004 29.4734C129.871 29.0758 129.708 28.6954 129.569 28.3277C129.497 28.143 129.427 27.9644 129.357 27.79C129.273 27.619 129.194 27.4517 129.115 27.2886C128.956 26.9624 128.812 26.6518 128.666 26.3665C128.501 26.0891 128.349 25.8296 128.209 25.592C127.945 25.1071 127.656 24.7566 127.474 24.4912L127.134 24.0276L126.744 23.5997C126.627 23.4736 126.483 23.3223 126.319 23.1456C126.159 22.9644 125.94 22.7924 125.717 22.5851C125.273 22.162 124.688 21.7197 124.013 21.241C122.649 20.2913 120.829 19.3789 118.787 18.5467C117.766 18.1211 116.69 17.7191 115.586 17.3008C115.27 17.1814 114.951 17.06 114.628 16.9391C114.367 16.8399 114.105 16.7389 113.84 16.6401L113.446 16.4897L113.246 16.4147L113.146 16.3772L113.096 16.3584C113.096 16.3584 113.082 16.389 113.075 16.4064C112.755 17.2378 112.429 18.0802 112.103 18.9267C111.218 21.2191 110.304 23.5645 109.412 25.8156C108.794 27.4093 108.234 28.851 107.732 30.1514C107.421 30.9526 107.128 31.7103 106.85 32.4268C106.745 32.6982 106.644 32.965 106.543 33.2276L106.506 33.3274C106.489 33.3478 106.52 33.3471 106.533 33.3544L106.583 33.3731L106.78 33.4463C106.91 33.4938 107.038 33.5435 107.168 33.591C107.634 33.7625 108.085 33.9291 108.525 34.0903C109.559 34.458 110.424 34.7754 111.129 35.0899C111.836 35.4021 112.382 35.7072 112.788 35.9826C113.763 36.6283 114.417 37.4256 114.721 38.3225C115.031 39.2209 115.01 40.211 114.85 41.1627C114.514 43.0782 113.723 44.8274 112.888 46.5008C112.427 47.3926 112.339 47.952 112.53 48.0971L112.524 48.1921C112.543 48.1967 112.555 48.1914 112.562 48.174L112.566 48.1192C112.77 48.2253 113.25 47.9025 113.813 47.0312C114.839 45.3874 115.819 43.6386 116.32 41.4445C116.554 40.3541 116.654 39.1054 116.251 37.8205C116.047 37.1856 115.719 36.5657 115.278 36.0207C114.838 35.4734 114.298 35.004 113.712 34.6079C113.257 34.2948 112.658 33.946 111.931 33.5894C111.201 33.2309 110.34 32.8775 109.378 32.5014C109.259 32.4551 109.137 32.4069 109.015 32.3587L108.972 32.3415L108.965 32.3358L108.952 32.3285L108.932 32.3114L108.894 32.2874C108.885 32.2798 108.864 32.2774 108.883 32.2548C108.905 32.2235 108.922 32.1989 108.937 32.1767C109.05 31.9046 109.164 31.6303 109.285 31.345C109.769 30.1721 110.29 28.891 110.842 27.5045C111.2 26.6006 111.535 25.6882 111.85 24.7754C112.189 23.7893 112.548 22.774 112.917 21.7433C113.278 20.7489 113.644 19.7394 114.005 18.745L114.061 18.5681C114.061 18.5681 114.066 18.5489 114.07 18.5485L114.092 18.555L114.135 18.5681L114.223 18.5961L114.268 18.611L114.292 18.6194L114.381 18.6516L114.756 18.7891C115.003 18.881 115.248 18.9709 115.491 19.0632C115.976 19.2435 116.451 19.4227 116.91 19.6032C117.372 19.7793 117.813 19.9613 118.238 20.1365C119.943 20.8405 121.328 21.5682 122.259 22.1505C122.71 22.4597 123.088 22.685 123.314 22.8752C123.546 23.0587 123.675 23.1587 123.675 23.1587C123.675 23.1587 123.72 23.1968 123.812 23.2665C123.898 23.3387 124.044 23.4309 124.196 23.5815C124.355 23.7271 124.549 23.9055 124.772 24.1127C124.829 24.1644 124.886 24.2161 124.948 24.2717C125.001 24.3321 125.059 24.3921 125.117 24.4563C125.233 24.5848 125.355 24.7189 125.483 24.861C126.504 25.9978 127.669 27.8 128.462 30.0309C128.555 30.3103 128.651 30.5957 128.747 30.8812C128.839 31.167 128.95 31.4574 129.012 31.7415C129.087 32.0288 129.164 32.3138 129.211 32.6119L129.291 33.0539C129.312 33.2032 129.325 33.3531 129.347 33.5023C129.488 34.7029 129.464 35.9345 129.335 37.1165C129.074 39.485 128.427 41.6372 127.869 43.2046C127.024 45.5691 126.192 47.2486 125.546 48.5173C124.889 49.7808 124.393 50.6273 124.007 51.2609C123.939 51.3738 123.871 51.4825 123.805 51.589L123.775 51.6377C123.775 51.6377 123.741 51.6281 123.724 51.6254L123.618 51.5863C123.167 51.4156 122.729 51.2521 122.3 51.0921C121.329 50.7356 120.408 50.3979 119.52 50.072C117.742 49.4309 116.096 48.8581 114.486 48.3157L114.495 48.3233Z" fill="#6A9A23"/>
<path d="M63.2213 11.0802C64.3036 11.4417 64.931 11.4901 65.0627 11.2416C65.1871 11.0063 64.7809 10.4561 63.6473 9.96267C62.8457 9.6209 62.0109 9.33237 61.1289 9.10458C60.2473 8.88095 59.3135 8.7101 58.3289 8.65487C57.8413 8.59642 57.3321 8.62798 56.8151 8.61824C56.558 8.63003 56.296 8.65694 56.0313 8.67778C55.898 8.68934 55.7647 8.70089 55.6314 8.71245C55.497 8.7346 55.3648 8.75864 55.2303 8.78079C54.1508 8.93941 53.0339 9.27124 51.9327 9.78634C51.7776 9.86063 51.624 9.9285 51.4775 10.0062C51.3356 10.0878 51.1978 10.169 51.0597 10.246C50.7857 10.4019 50.528 10.5523 50.2994 10.7231C50.0662 10.8902 49.8377 11.038 49.6378 11.2022C49.4383 11.3706 49.2487 11.5318 49.0667 11.684C48.7053 11.9944 48.4124 12.3198 48.1181 12.6055C47.8555 12.9178 47.5991 13.2044 47.3722 13.4927C46.4759 14.6552 45.8317 15.7244 45.0325 17.3317C44.3767 18.7042 43.7657 20.377 43.3437 22.174C42.9124 23.9592 42.6876 25.9258 42.8109 27.7679C42.9178 29.6155 43.3565 31.3442 43.9484 32.684C44.5304 34.031 45.2423 34.9618 45.621 35.485C45.8706 35.776 46.1183 36.0692 46.3915 36.3414C46.8871 36.8083 47.8267 37.6795 49.2654 38.4989C49.6286 38.6962 50.0023 38.9177 50.4196 39.1102C50.8332 39.3072 51.2794 39.4931 51.7434 39.6669C52.6774 40.0119 53.698 40.3137 54.8094 40.5258C57.0183 40.9575 59.6288 40.962 62.1114 40.1404C63.3524 39.7391 64.5396 39.1263 65.6002 38.3608C66.6654 37.5991 67.6064 36.6867 68.4118 35.7104C69.54 34.318 70.3115 32.8999 70.9125 31.5972C71.4954 30.2794 71.8779 29.0712 72.1641 27.9868C72.4458 26.8986 72.6224 25.9307 72.7077 25.0945C72.8141 24.2606 72.8305 23.5521 72.8419 22.9783C72.8528 20.2602 72.1712 17.8559 71.051 15.9366C70.4777 14.9834 69.8234 14.1357 69.0796 13.4176C68.3284 12.7126 67.5418 12.0821 66.6795 11.5966C66.2508 11.3211 65.8679 11.2117 65.5987 11.1553C65.3256 11.1034 65.1518 11.1311 65.0821 11.2231L65.145 11.3687C65.1232 11.335 65.0952 11.3269 65.0588 11.3426L65.0431 11.3062C65.0108 11.4181 65.0816 11.582 65.2604 11.7826C65.4355 11.9877 65.7286 12.1994 66.0982 12.4947C66.8482 13.0172 67.5077 13.6566 68.1348 14.3346C68.7505 15.0261 69.282 15.813 69.7486 16.6727C70.2113 17.5369 70.5551 18.5059 70.8114 19.5559C71.0594 20.6065 71.2063 21.7499 71.1886 22.9789C71.1966 23.2174 71.1654 23.4887 71.1497 23.7922C71.1381 24.0954 71.0911 24.4268 71.0364 24.7903C70.948 25.5156 70.767 26.3601 70.5057 27.2954C69.9645 29.1699 69.1073 31.4663 67.5012 33.7163L67.3088 33.9911L67.1005 34.2525L66.6908 34.7811C66.3873 35.1054 66.1203 35.4642 65.8002 35.7668C65.6299 35.9327 65.4716 36.1164 65.2858 36.273C65.1023 36.4316 64.9187 36.5902 64.7333 36.7511C64.3409 37.0432 63.9478 37.35 63.5114 37.5935C62.6552 38.102 61.7221 38.5228 60.7441 38.7629C58.7947 39.2718 56.7658 39.2231 55.0396 38.865C53.3077 38.5136 51.8735 37.9413 50.9288 37.4483C50.4595 37.1889 50.0869 36.9799 49.8427 36.8249C49.602 36.6611 49.4726 36.5716 49.4726 36.5716C49.4726 36.5716 49.4235 36.5381 49.3322 36.4768C49.2405 36.4113 49.0971 36.3293 48.9364 36.1942C48.772 36.0637 48.5714 35.9027 48.3372 35.7174C48.1201 35.5117 47.8736 35.2813 47.5996 35.0239C47.0988 34.4714 46.5061 33.8031 46.0168 32.9475C45.52 32.1009 45.0877 31.1039 44.7938 30.0068C44.1804 27.8107 44.2512 25.251 44.7058 22.956C45.1626 20.6398 45.9616 18.5919 46.736 17.184C47.8904 15.0487 49.1258 13.7309 50.1581 12.8798C51.1942 12.0241 52.0123 11.5839 52.6484 11.2959C53.6061 10.8457 54.5704 10.5439 55.5178 10.3862C55.6356 10.3655 55.753 10.3406 55.8686 10.318C55.9871 10.3057 56.1034 10.2914 56.2219 10.279C56.4548 10.2546 56.6851 10.2242 56.9142 10.2043C57.3752 10.1979 57.8243 10.1506 58.2681 10.1877C60.0484 10.2243 61.691 10.5855 63.2383 11.0829L63.2213 11.0802Z" fill="#6A9A23"/>
<path d="M149.643 57.1462C149.707 57.1386 149.772 57.135 149.834 57.1296C149.897 57.1284 149.958 57.1335 150.017 57.1368C150.136 57.1434 150.255 57.1393 150.367 57.1485C150.584 57.1884 150.799 57.195 150.983 57.2609C151.077 57.2863 151.167 57.3078 151.257 57.3294C151.342 57.3619 151.422 57.3948 151.5 57.4216C151.58 57.4504 151.654 57.4776 151.725 57.5028C151.793 57.5368 151.859 57.5689 151.92 57.5972C152.179 57.7027 152.367 57.8102 152.516 57.8582C152.665 57.9103 152.768 57.9119 152.818 57.8655C152.869 57.8192 152.863 57.7211 152.795 57.5675C152.727 57.4139 152.604 57.2022 152.364 56.9733C152.304 56.9155 152.242 56.8517 152.176 56.7882C152.104 56.7315 152.021 56.6736 151.936 56.6138C151.851 56.554 151.758 56.4908 151.66 56.4279C151.555 56.3783 151.444 56.3271 151.328 56.2721C151.099 56.1534 150.826 56.0974 150.536 56.0197C150.391 55.9903 150.237 55.9806 150.078 55.9629C149.999 55.955 149.919 55.9452 149.837 55.9418C149.757 55.9445 149.674 55.9476 149.59 55.9506C148.636 55.9788 147.736 56.254 146.905 56.6177C146.068 56.9798 145.315 57.471 144.572 57.9823C144.209 58.2488 143.842 58.5115 143.498 58.8057C143.142 59.0862 142.801 59.3864 142.46 59.695L142.203 59.9229C142.117 59.9975 142.015 60.1008 141.928 60.1902C141.84 60.2818 141.755 60.373 141.675 60.4639L141.463 60.7068L141.37 60.8029C141.341 60.8285 141.308 60.8776 141.28 60.8192L141.196 60.7216L141.177 60.698L141.059 60.5718L140.819 60.3157C140.497 59.9722 140.173 59.6226 139.843 59.2714C139.187 58.5688 138.512 57.8509 137.823 57.1133C136.438 55.6471 134.985 54.105 133.447 52.4758C133.366 52.3925 133.286 52.3093 133.205 52.2261L133.16 52.188C133.113 52.1606 133.152 52.1278 133.173 52.0987L133.224 52.0376C133.316 51.9373 133.407 51.8393 133.497 51.7413C133.679 51.5471 133.86 51.3593 134.04 51.1738C134.763 50.4418 135.456 49.7649 136.09 49.1581C137.34 47.9418 138.448 46.9918 139.511 46.1548C140.576 45.3197 141.597 44.587 142.741 43.9067C143.884 43.2263 145.144 42.5737 146.712 41.9993C147.041 41.8701 147.387 41.775 147.733 41.6568C148.083 41.5489 148.444 41.4588 148.809 41.36C149.549 41.1973 150.314 41.0408 151.105 40.9722C152.687 40.8036 154.367 40.8909 156.008 41.2858C157.649 41.6806 159.244 42.388 160.67 43.3471C162.105 44.2991 163.355 45.4853 164.442 46.7697C165.532 48.0453 166.437 49.3937 167.101 50.744C167.769 52.094 168.2 53.4415 168.453 54.689C168.707 55.9385 168.791 57.0831 168.821 58.0542C168.854 59.0248 168.81 59.826 168.784 60.399L168.72 61.4389C168.704 61.7886 168.699 62.1626 168.693 62.5093C168.686 63.1141 168.656 63.9581 168.694 65.1446C168.711 65.7348 168.755 66.4171 168.886 67.1989C169.02 67.9762 169.253 68.8834 169.791 69.7915C170.053 70.2472 170.391 70.6816 170.799 71.0868C171.204 71.5007 171.727 71.8667 172.326 72.1546C172.941 72.4245 173.637 72.5655 174.345 72.5693C175.051 72.5605 175.743 72.4082 176.418 72.1881C177.747 71.7099 178.979 70.9338 180.172 69.9974C180.767 69.5283 181.354 69.0136 181.936 68.4638C182.23 68.1929 182.508 67.9211 182.801 67.6419C182.857 67.5887 182.911 67.5337 182.968 67.4805L183.01 67.4391C183.026 67.4524 183.042 67.4657 183.06 67.481L183.076 67.4943L183.085 67.5019L183.154 67.5756C183.256 67.6801 183.36 67.7907 183.472 67.9047C183.91 68.3619 184.42 68.8906 184.982 69.4797C186.108 70.6578 187.46 72.0766 188.952 73.6405C189.633 74.3557 190.346 75.1059 191.082 75.8793C191.101 75.907 191.162 75.9353 191.113 75.9669L191.075 76.0121L190.913 76.1856C190.524 76.6075 190.105 77.0278 189.673 77.445C189.235 77.8649 188.793 78.2851 188.349 78.7117C187.9 79.1179 187.462 79.5461 186.997 79.9389C186.087 80.7501 185.126 81.5027 184.164 82.2239C181.541 84.1593 178.922 85.5424 176.438 86.3284C173.956 87.1228 171.629 87.2992 169.639 87.0479C168.643 86.9245 167.728 86.7079 166.902 86.427C166.08 86.1373 165.338 85.8072 164.678 85.449C163.359 84.7303 162.368 83.9392 161.596 83.2591C160.691 82.4521 159.878 81.572 159.161 80.6753C158.43 79.7861 157.823 78.8547 157.303 77.9115C156.265 76.0228 155.669 74.0497 155.387 72.0934C155.235 71.1162 155.172 70.1397 155.141 69.1751C155.104 68.2089 155.139 67.2533 155.147 66.279C155.152 65.3092 155.16 64.358 155.127 63.3873C155.092 62.4231 155.005 61.4381 154.757 60.4609C154.485 59.4059 153.996 58.6741 153.603 58.2822C153.412 58.0785 153.232 57.9619 153.1 57.8936C152.968 57.8253 152.879 57.812 152.832 57.8497L152.701 57.8442C152.697 57.8635 152.703 57.8692 152.722 57.8655L152.829 57.8436L152.808 57.8685C152.77 57.9138 152.772 58.008 152.817 58.1426C152.86 58.2752 152.946 58.4482 153.042 58.6791C153.244 59.1316 153.527 59.7785 153.718 60.7041C153.889 61.5705 153.936 62.4792 153.926 63.4054C153.92 64.3312 153.872 65.2838 153.833 66.2398C153.722 68.1482 153.636 70.1889 153.902 72.2935C154.151 74.3995 154.77 76.593 155.881 78.6747C156.437 79.7134 157.093 80.7371 157.873 81.7018C158.641 82.6759 159.501 83.6149 160.49 84.5006C161.26 85.1829 162.28 86.0177 163.649 86.8244C165.02 87.6183 166.762 88.3758 168.863 88.7476C170.959 89.1156 173.393 89.0683 175.922 88.44C178.453 87.8219 181.043 86.6301 183.565 85.0036C185.208 83.94 186.742 82.7265 188.162 81.4284C188.478 81.1492 188.784 80.8541 189.092 80.5567C189.402 80.2613 189.714 79.9636 190.011 79.665C190.619 79.0668 191.235 78.4573 191.845 77.8107L192.299 77.316C192.345 77.2617 192.523 77.0679 192.639 76.9257L193.021 76.4708L193.391 76.0086L193.486 75.8955C193.48 75.8561 193.425 75.821 193.399 75.7834L193.195 75.566C192.933 75.2761 192.65 74.988 192.374 74.7014C191.761 74.0705 191.146 73.4377 190.534 72.8068C189.331 71.5598 188.135 70.3226 186.969 69.1144C185.625 67.7139 184.318 66.348 183.066 65.0444C182.442 65.6398 181.829 66.2259 181.227 66.8048C181.016 67.0098 180.808 67.2062 180.602 67.3919C180.393 67.5799 180.196 67.7733 179.987 67.9488C179.164 68.6706 178.326 69.2951 177.498 69.7927C176.67 70.2863 175.836 70.6439 175.066 70.7841C174.293 70.9266 173.6 70.8461 173.042 70.5966C172.477 70.3497 172.045 69.936 171.712 69.5326C171.383 69.1289 171.169 68.7362 171.022 68.3965C170.949 68.2266 170.901 68.067 170.85 67.9351C170.811 67.7937 170.778 67.677 170.753 67.5826C170.724 67.4886 170.713 67.4098 170.7 67.3606C170.689 67.309 170.683 67.2844 170.683 67.2844C170.683 67.2844 170.655 67.1757 170.62 66.9647C170.602 66.8571 170.582 66.7245 170.558 66.5692C170.542 66.409 170.522 66.2261 170.5 66.0182C170.428 65.181 170.429 63.9304 170.475 62.3506C170.48 61.578 170.559 60.7172 170.575 59.7653C170.586 58.816 170.584 57.7985 170.473 56.7275C170.366 55.6562 170.183 54.5328 169.879 53.3967C169.563 52.2616 169.12 51.1208 168.563 50.0109C168.013 48.8919 167.297 47.8419 166.532 46.8276C166.332 46.5785 166.135 46.3312 165.933 46.0802C165.729 45.8356 165.508 45.603 165.296 45.3632C165.082 45.1258 164.871 44.886 164.637 44.6587C164.41 44.4287 164.184 44.1965 163.941 43.9846C162.045 42.2207 159.744 40.834 157.312 40.1068C154.881 39.3649 152.383 39.3003 150.19 39.631C147.983 39.9545 146.071 40.6532 144.51 41.353C142.165 42.4333 140.292 43.6636 138.737 44.8286C137.183 45.9978 135.935 47.0964 134.891 48.0807C133.859 49.0556 132.992 49.8798 132.263 50.6501C132.173 50.7481 132.085 50.8439 131.996 50.9355C131.87 51.0807 131.724 51.2361 131.601 51.3915C131.474 51.5473 131.351 51.6986 131.228 51.8498C131.165 51.9245 131.108 52.0008 131.048 52.0732C131.006 52.1461 130.87 52.225 130.986 52.2883C131.232 52.5607 131.465 52.8217 131.709 53.0734C131.889 53.2634 132.062 53.4477 132.23 53.624C133.778 55.2461 135.238 56.775 136.632 58.2363C137.33 58.9626 138.015 59.6733 138.681 60.3688C139.015 60.7154 139.345 61.0583 139.674 61.3969C139.865 61.5964 140.056 61.7918 140.245 61.9894L140.649 62.4098C140.784 62.5428 140.916 62.6615 141.049 62.7885L141.247 62.9748L141.299 63.0185L141.32 63.044C141.325 63.0478 141.329 63.0516 141.332 63.0535L141.343 63.0399L141.444 62.943L141.83 62.5529C142.085 62.3 142.335 62.0077 142.564 61.7213C142.888 61.3177 143.089 61.0967 143.437 60.779C143.751 60.4791 144.068 60.1851 144.395 59.9113C144.712 59.6257 145.047 59.3701 145.374 59.1088C146.043 58.6165 146.72 58.1424 147.435 57.8013C148.146 57.4564 148.886 57.2055 149.62 57.1503L149.643 57.1462Z" fill="#6A9A23"/>
<path d="M80.321 25.3809C80.4416 23.1064 79.4571 23.0281 79.1312 25.2574C78.8942 26.839 78.6434 28.4554 78.3341 30.1965C78.018 31.9318 77.6635 33.8048 77.0533 35.8028C76.9621 36.1317 76.8558 36.4326 76.7629 36.7176C76.7418 36.7887 76.7161 36.8559 76.6904 36.9232C76.6579 37.0079 76.6295 37.0922 76.5966 37.1726C76.5069 37.4217 76.4055 37.6571 76.3015 37.8865C75.8871 38.7743 75.5595 39.4762 75.3454 39.9375C76.5743 39.8079 77.6597 39.6697 78.5962 39.5571C79.1374 39.4829 79.6268 39.4153 80.1059 39.3507C81.0599 39.2218 81.9734 39.109 83.1533 38.9963C85.9529 38.7116 89.7215 38.3996 93.0728 38.1385C93.9107 38.0743 94.7237 38.0122 95.4885 37.9522C95.6782 37.9379 95.8679 37.9235 96.0534 37.9095C96.3908 37.8803 96.7199 37.8518 97.0447 37.8236C97.2132 37.8069 97.3821 37.7943 97.5465 37.778L97.6089 37.7726C97.6204 37.759 97.6182 37.734 97.6228 37.7147L97.6419 37.5956L97.6801 37.3573C97.73 37.0361 97.7788 36.7255 97.826 36.4214C97.9332 35.7428 98.0279 35.1387 98.1097 34.628C98.1809 34.1392 98.241 33.7417 98.2835 33.4568C98.332 33.119 98.3699 32.78 98.4014 32.4394C98.4496 31.9044 98.5308 30.972 98.6212 29.7346C98.6626 29.1205 98.7101 28.4302 98.7605 27.6768C98.8248 26.9389 98.9042 26.1326 98.9956 25.2707C99.1893 23.5523 99.4495 21.6308 99.8761 19.6446C100.088 18.6526 100.35 17.6438 100.688 16.6576C100.777 16.415 100.869 16.172 100.959 15.9271L101.111 15.5677L101.185 15.3871C101.19 15.3678 101.226 15.3017 101.255 15.2447L101.343 15.0755L101.695 14.3903C101.746 14.2788 101.822 14.1569 101.901 14.0346L102.126 13.671C102.421 13.1964 102.713 12.72 103.01 12.2431C102.93 12.2417 102.807 12.2544 102.664 12.2689C102.522 12.2812 102.364 12.2991 102.189 12.3143C101.84 12.3487 101.434 12.3902 100.989 12.433C100.271 12.5015 99.4285 12.5851 98.594 12.6637C92.1629 13.3177 88.1819 13.7215 86.104 13.9331C84.8775 14.0646 83.7301 14.1892 82.6387 14.3069C81.9634 14.3843 81.3068 14.4581 80.6649 14.5326L80.3138 14.5735L80.1393 14.5928L80.054 14.6023C80.054 14.6023 80.0158 14.5972 80.0195 14.6158L80.0129 14.6604C79.9849 14.8958 79.9566 15.1269 79.9306 15.36C79.9042 15.5889 79.8778 15.8178 79.8514 16.0467C79.8379 16.1821 79.824 16.3134 79.8105 16.4489C79.6178 18.4463 79.5162 20.2848 79.4719 22.1057C79.4328 24.1087 80.2926 24.1517 80.5363 22.1855C80.7678 20.3945 81.0108 18.59 81.2991 16.6304C81.3163 16.5135 81.3335 16.3966 81.3507 16.2797L81.3736 16.156L81.3968 16.0365C81.4245 16.0173 81.4801 16.0293 81.5173 16.0219L81.6426 16.0152C81.7592 16.0051 81.8758 15.995 81.9924 15.9849C82.259 15.9618 82.5275 15.9364 82.8005 15.9148C83.891 15.8119 85.0441 15.7036 86.2698 15.5868C88.1772 15.3942 92.1765 15.2259 97.792 14.7013C98.2499 14.6575 98.7073 14.6094 99.1621 14.5553L99.459 14.5191C99.459 14.5191 99.4628 14.5146 99.4666 14.51C99.4723 14.5032 99.4841 14.4938 99.5061 14.4814C99.5282 14.469 99.5786 14.4458 99.6074 14.4391C99.6134 14.4595 99.619 14.4758 99.5928 14.562L99.5732 14.6267L99.4323 14.9872C99.3335 15.2287 99.2457 15.4755 99.1662 15.7216C98.8317 16.7074 98.5712 17.7014 98.3498 18.6858C97.9192 20.6493 97.6406 22.5514 97.4316 24.2145C97.2283 25.8708 97.0684 27.301 96.9964 28.3144C96.9101 29.3081 96.8578 29.8938 96.8578 29.8938C96.8578 29.8938 96.7819 30.8383 96.6206 32.3483C96.541 33.1043 96.4359 34.0009 96.3094 34.9918C96.2578 35.3655 96.2075 35.756 96.1523 36.1615C96.1696 36.2649 96.0622 36.2365 95.9922 36.2509C95.7737 36.272 95.5533 36.2953 95.3287 36.3189C90.738 36.7819 85.3487 37.3267 82.1496 37.6502L79.3959 37.9309L78.3394 38.0392L78.1542 38.0574L78.0607 38.0676L78.0148 38.0716C78.0148 38.0716 77.9678 38.0861 77.9869 38.0635C78.0476 37.9407 78.1061 37.8161 78.1578 37.6857L78.2605 37.4166C78.3084 37.2907 78.3479 37.1656 78.3917 37.0401C78.4791 36.7891 78.5624 36.5385 78.637 36.2845C79.2812 34.1451 79.6012 32.2122 79.8478 30.4262C80.088 28.6386 80.2266 26.9858 80.3206 25.3767L80.321 25.3809Z" fill="#6A9A23"/>
</g>
</g>
<defs>
<clipPath id="clip0_783_5660">
<rect width="421" height="32" fill="white"/>
</clipPath>
<clipPath id="clip1_783_5660">
<rect width="304" height="304.679" fill="white" transform="translate(268.681 74.498) rotate(-105)"/>
</clipPath>
<clipPath id="clip2_783_5660">
<rect width="304" height="304.679" fill="white" transform="translate(-42.3188 346) rotate(-105)"/>
</clipPath>
</defs>
</svg>
`;
const $24c02ea0e14dbe4f$var$$ea8e736e4eb06883$export$3c6f6c6a4ab84ea6 = `data:image/svg+xml;base64,${$24c02ea0e14dbe4f$var$$ea8e736e4eb06883$require$Buffer.from($24c02ea0e14dbe4f$var$$ea8e736e4eb06883$var$learningPathBg).toString("base64")}`;
const $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$export$8b251419efc915eb = ({ isCourse: isCourse, courseImgUrl: courseImgUrl, title: title, completedItems: completedItems, progress: progress, learningPathSlug: learningPathSlug, courseSlug: courseSlug, navigate: navigate })=>{
    const handleNavigation = (0, $5FkrB.useCallback)(()=>{
        learningPathSlug ? navigate(`/path/${learningPathSlug}`) : navigate(`/course/${courseSlug}`);
    }, [
        learningPathSlug,
        courseSlug,
        navigate
    ]);
    const onKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleNavigation);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "sidebar-header",
        css: $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$headerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                css: $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$headerImageStyles,
                src: isCourse ? $24c02ea0e14dbe4f$var$$e48fba9cf5395297$export$d3a66d29d3f047ac : $24c02ea0e14dbe4f$var$$ea8e736e4eb06883$export$3c6f6c6a4ab84ea6,
                alt: title
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$headerContentStyles,
                    isCourse && $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$courseHeaderContentStyles
                ],
                children: [
                    isCourse && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$courseImageContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                            css: $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$courseImageStyles,
                            src: courseImgUrl,
                            alt: title,
                            "data-testid": "course-image"
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: [
                            $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$containerStyles,
                            isCourse && (0, $74Zh5.css)({
                                marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
                            })
                        ],
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                css: $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$typeStyles,
                                children: isCourse ? "Course" : "Learning Path"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                role: "button",
                                tabIndex: 0,
                                css: $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$titleStyles,
                                "data-testid": "sidebar-title",
                                onClick: handleNavigation,
                                onKeyDown: onKeyDown,
                                children: title
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        "data-testid": "course-progress-circle",
                        css: $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$progressCircleContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f188eff9b59fb855$export$5ab97151efedb8c6), {
                            strokeWidth: 8,
                            value: progress,
                            styles: (0, $f188eff9b59fb855$export$5115a192ad9bf57f)({
                                pathColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.success"),
                                trailColor: "rgba(9, 30, 66, 0.14)"
                            }),
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                css: [
                                    $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$progressStyles,
                                    isCourse && (0, $74Zh5.css)({
                                        fontSize: "14px"
                                    })
                                ],
                                "data-testid": "progress-text",
                                children: completedItems
                            })
                        })
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$headerStyles = (0, $74Zh5.css)({
    width: "100%",
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
});
const $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$headerImageStyles = (0, $74Zh5.css)({
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        width: "100%"
    }
});
const $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$headerContentStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250"),
    paddingLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    paddingRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$courseHeaderContentStyles = (0, $74Zh5.css)({
    paddingLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    paddingRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
});
const $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$progressCircleContainerStyles = (0, $74Zh5.css)({
    maxWidth: "48px",
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
});
const $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$progressStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px"
});
const $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$courseImageContainerStyles = (0, $74Zh5.css)({
    width: "32px",
    minWidth: "32px",
    minHeight: "32px"
});
const $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$courseImageStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    objectFit: "cover"
});
const $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    marginRight: "auto"
});
const $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$typeStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle"),
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 600,
    textTransform: "uppercase",
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
});
const $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$titleStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    marginTop: 0,
    transition: "color 0.5s ease",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        fontSize: "16px",
        lineHeight: "24px"
    },
    "&:hover": {
        cursor: "pointer",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")
    }
});
const $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$792ece11a7230884 = 89;
const $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$1239cfcb7eeed80e = 8;
const $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$686a18f490557de2 = 16;
const $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$6a021f56d50c6f44 = 250;
const $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$789f21e35b72f907 = 68;
const $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$4ac0ef1183ae81e8 = (positionData)=>{
    const height = positionData.height > $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$792ece11a7230884 ? $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$792ece11a7230884 : positionData.height;
    const subnavbarPosition = document.getElementById("subnavbar")?.getBoundingClientRect();
    const offset = subnavbarPosition && subnavbarPosition.y < $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$789f21e35b72f907 ? $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$789f21e35b72f907 - subnavbarPosition.y : 0;
    return {
        top: positionData.top - ($24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$6a021f56d50c6f44 / 2 - height / 2) + offset - $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$686a18f490557de2,
        left: $24c02ea0e14dbe4f$var$$035f8a623e403361$export$780035d9fe48eb32 - $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$686a18f490557de2
    };
};
const $24c02ea0e14dbe4f$var$$f50e6e435b887166$export$1671b398b5e36be4 = ({ courses: courses, renderPopup: renderPopup })=>{
    const { hoverInfo: hoverInfo, popupRef: popupRef, handleMouseLeave: handleMouseLeave } = $24c02ea0e14dbe4f$var$$32c02b5652036d7a$export$861cd542ff836f0d();
    const courseToShowInPopup = (0, $5FkrB.useMemo)(()=>courses.find(({ sys: sys })=>sys.id === hoverInfo?.courseId), [
        hoverInfo?.courseId,
        courses
    ]);
    const handlePopupLeave = (e)=>{
        const popupId = popupRef.current?.children[0].id;
        const isMovedToOutside = e.target.closest(`#${popupId}`);
        if (isMovedToOutside) handleMouseLeave();
    };
    if (!hoverInfo) return null;
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        "data-testid": "sidebar-hover-popup",
        ref: popupRef,
        onMouseLeave: handlePopupLeave,
        css: [
            $24c02ea0e14dbe4f$var$$f50e6e435b887166$var$popupStyles,
            (0, $74Zh5.css)($24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$4ac0ef1183ae81e8(hoverInfo.courseCardPosition))
        ],
        children: renderPopup(courseToShowInPopup)
    });
};
const $24c02ea0e14dbe4f$var$$f50e6e435b887166$var$popupStyles = (0, $74Zh5.css)({
    position: "absolute",
    zIndex: 100,
    transform: "translateY(-50%)",
    paddingLeft: `${$24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$686a18f490557de2 + $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$1239cfcb7eeed80e}px`,
    marginLeft: "-1px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$export$4ff69a78d3a65d6f = ({ isVisible: isVisible = true, isLoading: isLoading, learningPath: learningPath, progressForLessons: progressForLessons, progressForCourses: progressForCourses, expandedCourseIds: expandedCourseIds = [], expandedLessonIds: expandedLessonIds = [], selectedSectionId: selectedSectionId, currentLessonSlug: currentLessonSlug, onSelect: onSelect, navigate: navigate = ()=>{}, renderPopup: renderPopup, onToggleVisibility: onToggleVisibility })=>{
    const [showCurrentLessonButton, setShowCurrentLessonButton] = (0, $5FkrB.useState)(false);
    const scrollContainerRef = (0, $5FkrB.useRef)(null);
    const selectedLessonRef = (0, $5FkrB.useRef)(null);
    const courses = (0, $5FkrB.useMemo)(()=>learningPath?.coursesCollection.items || [], [
        learningPath?.coursesCollection.items
    ]);
    const lessons = (0, $5FkrB.useMemo)(()=>courses.flatMap((course)=>course.lessonsCollection.items), [
        courses
    ]);
    const numberOfCompletedLessons = lessons.filter(({ sys: { id: id } })=>progressForLessons?.lessons.find((lesson)=>lesson.lessonId === id)?.status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED).length;
    const numberOfCompletedCourses = courses.filter(({ sys: { id: id } })=>progressForCourses?.courses.find((course)=>course.courseId === id)?.status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED).length;
    const selectedCourse = courses.find(({ slug: slug })=>$24c02ea0e14dbe4f$var$$48630d5962798e4a$export$15379570ba48f04d(slug));
    const isCourse = !learningPath?.title;
    const courseImage = (courses[0]?.reward?.orangeLogicAsset?.imageUrl ?? courses[0]?.reward?.badgeCdnUrl) || $24c02ea0e14dbe4f$var$$ef44b01e6346ac17$export$44f5f766f3f98994;
    const calculateProgress = ()=>isCourse ? numberOfCompletedLessons / lessons.length * 100 : numberOfCompletedCourses / courses.length * 100;
    const completedEntities = isCourse ? numberOfCompletedLessons : numberOfCompletedCourses;
    const totalEntities = isCourse ? lessons.length : courses.length;
    // Find the selected lesson in either the main lessons array or inside course cards
    const selectedLessonId = (0, $5FkrB.useMemo)(()=>isCourse ? lessons.find(({ slug: slug })=>$24c02ea0e14dbe4f$var$$48630d5962798e4a$export$15379570ba48f04d("", slug)) : courses.reduce((found, course)=>{
            if (found) return found;
            const selectedLesson = course.lessonsCollection.items.find(({ slug: slug })=>$24c02ea0e14dbe4f$var$$48630d5962798e4a$export$15379570ba48f04d("", slug));
            return selectedLesson ? selectedLesson.sys.id : undefined;
        }, undefined), [
        isCourse,
        lessons,
        courses
    ]);
    // Handle scroll event to check if selected lesson is visible
    const handleScroll = (0, $5FkrB.useCallback)(()=>{
        if (!scrollContainerRef.current || !selectedLessonRef.current || !selectedLessonId) return;
        const container = scrollContainerRef.current;
        const selectedLessonElement = selectedLessonRef.current;
        const containerRect = container.getBoundingClientRect();
        const lessonRect = selectedLessonElement.getBoundingClientRect();
        // Check if the selected lesson is above the visible area
        const isLessonAboveViewport = lessonRect.top < containerRect.top;
        setShowCurrentLessonButton(isLessonAboveViewport);
    }, [
        selectedLessonId
    ]);
    const scrollToSelectedLesson = (0, $5FkrB.useCallback)(()=>{
        if (selectedLessonRef.current && scrollContainerRef.current) selectedLessonRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    }, []);
    (0, $5FkrB.useEffect)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (scrollContainer) {
            scrollContainer.addEventListener("scroll", handleScroll);
            handleScroll();
            return ()=>{
                scrollContainer.removeEventListener("scroll", handleScroll);
            };
        }
    }, [
        selectedLessonId
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("aside", {
        "data-testid": "sidebar",
        css: [
            $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$sidebarStyles,
            !isVisible && $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$sidebarClosedStyles
        ],
        children: [
            isVisible && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                role: "button",
                tabIndex: 0,
                css: $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$closeButtonContainerStyles,
                onClick: onToggleVisibility,
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        onToggleVisibility?.();
                    }
                },
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                    "data-testid": "sidebar-mobile-close-button",
                    css: $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$closeButtonStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: "cross",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$closeButtonTextStyles,
                            children: "Close"
                        })
                    ]
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                "data-testid": "sidebar-toggle-button",
                css: [
                    $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$sidebarButton,
                    isCourse && $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$sidebarButtonForCourseStyles
                ],
                onClick: onToggleVisibility,
                "aria-label": isVisible ? "Collapse sidebar" : "Expand sidebar",
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: isVisible ? "sidebar-collapse" : "sidebar-expand"
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$export$8b251419efc915eb, {
                isCourse: isCourse,
                learningPathSlug: learningPath?.slug,
                courseSlug: courses[0]?.slug,
                title: isCourse ? selectedCourse?.title || "" : learningPath?.title || "",
                completedItems: `${completedEntities}/${totalEntities}`,
                progress: calculateProgress(),
                courseImgUrl: courseImage,
                navigate: navigate
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)($24c02ea0e14dbe4f$var$$32c02b5652036d7a$export$d8355e8edbcacbe8, {
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        "data-testid": "sidebar-cards-container",
                        css: [
                            $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$cardsContainerStyles,
                            isCourse && $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$cardsContainerForCourseStyles
                        ],
                        children: [
                            showCurrentLessonButton && selectedLessonId && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                                css: $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$currentLessonStyles,
                                onClick: scrollToSelectedLesson,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                        type: "arrow-up",
                                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                        css: $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$buttonTextStyles,
                                        children: "Current lesson"
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$cardsScrollableContainerStyles,
                                ref: scrollContainerRef,
                                children: isCourse ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    "data-testid": "sidebar-lesson-container",
                                    css: $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$lessonContainerStyles,
                                    children: lessons.map((lesson)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                            ref: $24c02ea0e14dbe4f$var$$48630d5962798e4a$export$15379570ba48f04d("", lesson.slug) ? selectedLessonRef : null,
                                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$export$951debaed2d5c034, {
                                                isCourse: isCourse,
                                                courseSlug: selectedCourse?.slug,
                                                lesson: lesson,
                                                progressForLesson: progressForLessons?.lessons.find((lessonProgress)=>lessonProgress.lessonId === lesson.sys.id),
                                                onSelect: onSelect,
                                                expandedLessonIds: expandedLessonIds,
                                                isLoading: isLoading,
                                                selectedSectionId: selectedSectionId,
                                                currentLessonSlug: currentLessonSlug
                                            })
                                        }, lesson.sys.id))
                                }) : courses.map((course)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$aefb4e9d0a694068$export$bb61bd2f4f2a772c, {
                                        course: course,
                                        progressForLessons: progressForLessons,
                                        status: $24c02ea0e14dbe4f$var$$48630d5962798e4a$export$272e7ef3ea22070d(progressForCourses?.courses.find((courseProgress)=>courseProgress.courseId === course.sys.id)?.status),
                                        onSelect: onSelect,
                                        isLoading: isLoading,
                                        selectedLessonRef: selectedLessonRef,
                                        expandedLessonIds: expandedLessonIds,
                                        expandedCourseIds: expandedCourseIds,
                                        selectedSectionId: selectedSectionId,
                                        currentLessonSlug: currentLessonSlug,
                                        scrollContainerRef: scrollContainerRef
                                    }, course.sys.id))
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$f50e6e435b887166$export$1671b398b5e36be4, {
                        courses: courses,
                        renderPopup: renderPopup
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$sidebarStyles = (0, $74Zh5.css)({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    height: "100%",
    width: `${$24c02ea0e14dbe4f$var$$035f8a623e403361$export$780035d9fe48eb32}px`,
    borderRight: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    transition: "transform 0.3s ease",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        width: "100%"
    }
});
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$sidebarClosedStyles = (0, $74Zh5.css)({
    transform: "translateX(-412px)",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        transform: "translateX(-100%)"
    }
});
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$closeButtonContainerStyles = (0, $74Zh5.css)({
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")}`,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.xs]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$closeButtonStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FFFFFF",
    border: "none",
    cursor: "pointer"
});
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$closeButtonTextStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 400,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$sidebarButton = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    width: "32px",
    height: "32px",
    top: "84px",
    right: "calc(-32px - 16px)",
    backgroundColor: "#FFFFFF",
    borderRadius: "3px",
    boxShadow: "0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 1px 1px 0px rgba(9, 30, 66, 0.25)",
    padding: 0,
    border: "none",
    cursor: "pointer",
    zIndex: 100,
    "&:hover": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface.hovered")
    },
    "&:active": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface.pressed")
    },
    svg: {
        width: "24px",
        height: "24px"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$sidebarButtonForCourseStyles = (0, $74Zh5.css)({
    top: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
});
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$cardsContainerStyles = (0, $74Zh5.css)({
    position: "relative",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    minHeight: 0
});
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$cardsContainerForCourseStyles = (0, $74Zh5.css)({
    paddingTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$currentLessonStyles = (0, $74Zh5.css)({
    position: "absolute",
    zIndex: 100,
    top: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")}`,
    cursor: "pointer",
    width: "fit-content",
    borderRadius: "100px",
    boxShadow: "0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 8px 12px 0px rgba(9, 30, 66, 0.15), 0px 0px 0px 1px rgba(188, 214, 240, 0.00) inset"
});
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$buttonTextStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 400,
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
});
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$lessonContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$cardsScrollableContainerStyles = (0, $74Zh5.css)({
    flex: 1,
    overflowY: "auto",
    minHeight: 0
});
var $24c02ea0e14dbe4f$var$$764442aba3de2fce$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$764442aba3de2fce$exports, "VIDEO_CONTROL_TYPES", ()=>$24c02ea0e14dbe4f$export$2ffae0f952561172);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$764442aba3de2fce$exports, "Video", ()=>$24c02ea0e14dbe4f$export$ae01dedf5c052bb);
// using 'plyr' instead of 'plyr/dist/plyr'
// will start executing DOM APIs right away
// and it breaks SSR
const $24c02ea0e14dbe4f$export$2ffae0f952561172 = [
    "play-small",
    "play",
    "progress",
    "current-time",
    "rewind",
    "fast-forward",
    "mute",
    "volume",
    "settings",
    "fullscreen",
    "seektime"
];
const $24c02ea0e14dbe4f$var$$764442aba3de2fce$var$MOBILE_SCREEN_WIDTH = 480;
const $24c02ea0e14dbe4f$var$$764442aba3de2fce$var$LEARNING_PAGE_CUSTOM_PLAYER_WIDTH = 920;
const $24c02ea0e14dbe4f$var$$764442aba3de2fce$var$ORANGE_LOGIC_CDN_LINK_PATH = "/CDNLink/";
const $24c02ea0e14dbe4f$var$$764442aba3de2fce$var$isOrangeLogicCdnLinkUrl = (videoUrl)=>videoUrl?.includes($24c02ea0e14dbe4f$var$$764442aba3de2fce$var$ORANGE_LOGIC_CDN_LINK_PATH) ?? false;
const $24c02ea0e14dbe4f$export$ae01dedf5c052bb = ({ orangeUrl: orangeUrl, vimeoUrl: vimeoUrl, youtubeUrl: youtubeUrl, captions: captions, chapters: chapters, controls: controls, width: width, height: height, videoId: videoId, name: name, poster: poster = "", onControlClick: onControlClick, onProgressUpdate: onProgressUpdate, onError: onError, customControls: customControls, hasResponsiveControls: hasResponsiveControls, preload: preload = "metadata" })=>{
    const videoRef = (0, $5FkrB.useRef)(null);
    const playerRef = (0, $5FkrB.useRef)(null);
    const mobileControls = (0, $5FkrB.useMemo)(()=>customControls?.customMobileControls ?? [
            ...$24c02ea0e14dbe4f$export$2ffae0f952561172
        ], [
        customControls?.customMobileControls
    ]);
    const desktopControls = (0, $5FkrB.useMemo)(()=>customControls?.customDesktopControls ?? [
            ...$24c02ea0e14dbe4f$export$2ffae0f952561172
        ], [
        customControls?.customDesktopControls
    ]);
    const hasCustomDesktopControls = Boolean(customControls?.customDesktopControls?.length);
    const videoSrc = (0, $5FkrB.useMemo)(()=>orangeUrl || vimeoUrl || youtubeUrl, [
        orangeUrl,
        vimeoUrl,
        youtubeUrl
    ]);
    const playerSource = (0, $5FkrB.useMemo)(()=>({
            type: "video",
            sources: [
                {
                    src: videoSrc
                }
            ],
            tracks: [
                {
                    kind: "captions",
                    label: "English",
                    srcLang: "en",
                    src: captions,
                    default: true
                }
            ]
        }), [
        videoSrc,
        captions
    ]);
    const playerOptions = (0, $5FkrB.useMemo)(()=>({
            invertTime: false,
            tooltips: {
                controls: true,
                seek: true
            },
            controls: desktopControls,
            quality: {
                default: 1080,
                options: [
                    1080,
                    720,
                    576,
                    480,
                    360,
                    240
                ]
            },
            markers: {
                enabled: true,
                points: chapters
            },
            preload: preload
        }), [
        desktopControls,
        chapters,
        preload
    ]);
    const playerOptionsMobile = (0, $5FkrB.useMemo)(()=>({
            invertTime: false,
            tooltips: {
                controls: controls,
                seek: true
            },
            controls: controls ? mobileControls : [],
            quality: {
                default: 1080,
                options: [
                    1080,
                    720,
                    576,
                    480,
                    360,
                    240
                ]
            },
            markers: {
                enabled: true,
                points: chapters
            },
            preload: preload
        }), [
        controls,
        mobileControls,
        chapters,
        preload
    ]);
    const addEvents = (0, $5FkrB.useCallback)((instance)=>{
        instance.once("loadeddata", ()=>{
            const addEvent = (event)=>instance.on(event, ()=>onControlClick && onControlClick(event));
            addEvent("play");
            addEvent("pause");
            addEvent("captionsenabled");
            addEvent("captionsdisabled");
        });
        instance.on("timeupdate", ()=>{
            const currentTime = instance.currentTime;
            const duration = instance.duration;
            const percentage = currentTime / duration * 100;
            onProgressUpdate && onProgressUpdate(+percentage.toFixed(2), name, videoId);
        });
        if (onError) instance.on("error", onError);
    }, [
        onControlClick,
        onProgressUpdate,
        onError,
        name,
        videoId
    ]);
    (0, $5FkrB.useEffect)(()=>{
        // ✅ Destroy old player before creating new one
        const destroyPlayer = ()=>{
            if (playerRef.current) {
                playerRef.current.destroy();
                playerRef.current = null;
            }
        };
        const initializePlayer = ()=>{
            if (!videoRef.current) return;
            destroyPlayer(); // ✅ Clean up first
            const isMobileSize = hasResponsiveControls ? window.innerWidth >= $24c02ea0e14dbe4f$var$$764442aba3de2fce$var$LEARNING_PAGE_CUSTOM_PLAYER_WIDTH : window.innerWidth <= $24c02ea0e14dbe4f$var$$764442aba3de2fce$var$MOBILE_SCREEN_WIDTH;
            const player = new (0, (/*@__PURE__*/$parcel$interopDefault($1c94bc9aa532188d$exports)))(videoRef.current, isMobileSize ? playerOptionsMobile : playerOptions);
            player.source = playerSource;
            player.poster = poster;
            addEvents(player);
            if ($24c02ea0e14dbe4f$var$$764442aba3de2fce$var$isOrangeLogicCdnLinkUrl(orangeUrl) && videoRef.current?.hasAttribute("crossorigin")) {
                // Orange Logic CDNLink URLs can fail CORS checks with crossorigin="anonymous".
                // Removing it restores playback for the original asset.
                videoRef.current.removeAttribute("crossorigin");
                videoRef.current.load();
            }
            playerRef.current = player; // ✅ Store reference
            const plyrVideoContainers = document.getElementsByClassName("plyr--video");
            if (plyrVideoContainers.length) Array.from(plyrVideoContainers).forEach((el)=>el.role = "presentation");
        };
        const handleResize = ()=>{
            initializePlayer();
        };
        window.addEventListener("resize", handleResize);
        initializePlayer();
        return ()=>{
            window.removeEventListener("resize", handleResize);
            destroyPlayer();
        };
    }, [
        hasResponsiveControls,
        playerOptions,
        playerOptionsMobile,
        playerSource,
        poster,
        orangeUrl,
        addEvents
    ]);
    if (videoSrc === vimeoUrl) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("iframe", {
        role: "region",
        "aria-label": "Video player",
        title: "video",
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- iframe needs tabIndex for keyboard access
        tabIndex: 0,
        css: (0, $74Zh5.css)({
            backgroundColor: "transparent",
            width: "100%",
            aspectRatio: "16 / 9",
            ":focus-visible": {
                border: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")}`
            }
        }),
        src: vimeoUrl,
        allowFullScreen: true,
        allow: "autoplay"
    });
    else if (videoSrc === youtubeUrl) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("iframe", {
        role: "region",
        "aria-label": "Video player",
        title: "video",
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- iframe needs tabIndex for keyboard access
        tabIndex: 0,
        css: (0, $74Zh5.css)({
            backgroundColor: "transparent",
            width: "100%",
            aspectRatio: "16 / 9",
            ":focus-visible": {
                border: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")}`
            }
        }),
        src: youtubeUrl,
        allowFullScreen: true,
        allow: "autoplay"
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$764442aba3de2fce$var$videoPlayerStyles,
            hasCustomDesktopControls && $24c02ea0e14dbe4f$var$$764442aba3de2fce$var$unsetVolumeWidthStyles
        ],
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("video", {
            tabIndex: 0,
            ref: videoRef,
            width: width,
            height: height,
            controls: controls,
            crossOrigin: "anonymous",
            title: "video",
            preload: preload,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("source", {
                    src: videoSrc,
                    type: "video/mp4"
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("track", {
                    src: captions,
                    kind: "captions",
                    label: "captions",
                    srcLang: "en",
                    default: true
                })
            ]
        })
    });
};
const $24c02ea0e14dbe4f$var$$764442aba3de2fce$var$videoPlayerStyles = (0, $74Zh5.css)({
    ".plyr__time": {
        fontSize: "12px !important",
        fontWeight: "600 !important"
    },
    "--plyr-color-main": "#1D7AFC",
    "--plyr-badge-background": (0, $54ca2d3948378259$export$7d61b15e0da132af),
    "--plyr-audio-control-color": (0, $54ca2d3948378259$export$7d61b15e0da132af),
    "--plyr-menu-color": (0, $54ca2d3948378259$export$7d61b15e0da132af),
    "--plyr-menu-item-arrow-color": "#758195",
    "--plyr-menu-border-color": "#DCDFE4",
    "--plyr-tooltip-color": (0, $54ca2d3948378259$export$7d61b15e0da132af),
    ":focus-visible": {
        border: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $24c02ea0e14dbe4f$var$$764442aba3de2fce$var$unsetVolumeWidthStyles = (0, $74Zh5.css)({
    ".plyr__controls__item.plyr__volume": {
        minWidth: "unset !important",
        width: "unset !important"
    }
});
var $24c02ea0e14dbe4f$var$$77282b3961d82199$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$77282b3961d82199$exports, "Columns", ()=>$24c02ea0e14dbe4f$export$f02cc02ad0e0bba3);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$77282b3961d82199$exports, "LessonColumns", ()=>$24c02ea0e14dbe4f$export$2dde675552f76fc5);
let $24c02ea0e14dbe4f$export$f02cc02ad0e0bba3;
(function(Columns) {
    Columns["TWO"] = "two";
    Columns["THREE"] = "three";
    Columns["FOUR"] = "four";
})($24c02ea0e14dbe4f$export$f02cc02ad0e0bba3 || ($24c02ea0e14dbe4f$export$f02cc02ad0e0bba3 = {}));
const $24c02ea0e14dbe4f$export$2dde675552f76fc5 = ({ columns: columns = $24c02ea0e14dbe4f$export$f02cc02ad0e0bba3.TWO, children: children })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("section", {
        css: $24c02ea0e14dbe4f$var$$77282b3961d82199$var$sectionStyles,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            "data-testid": "lesson-columns",
            css: [
                $24c02ea0e14dbe4f$var$$77282b3961d82199$var$lessonColumnsStyles,
                $24c02ea0e14dbe4f$var$$77282b3961d82199$var$lessonColumnsMDStyles[columns]
            ],
            children: children
        })
    });
const $24c02ea0e14dbe4f$var$$77282b3961d82199$var$sectionStyles = (0, $74Zh5.css)({
    textOverflow: "ellipsis",
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400"),
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.lg]: {
        textOverflow: "clip"
    }
});
const $24c02ea0e14dbe4f$var$$77282b3961d82199$var$lessonColumnsStyles = (0, $74Zh5.css)({
    display: "grid",
    columnGap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
    fontSize: "16px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.xs]: {
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
    }
});
const $24c02ea0e14dbe4f$var$$77282b3961d82199$var$lessonColumnsMDStyles = {
    [$24c02ea0e14dbe4f$export$f02cc02ad0e0bba3.TWO]: (0, $74Zh5.css)({
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
        }
    }),
    [$24c02ea0e14dbe4f$export$f02cc02ad0e0bba3.THREE]: (0, $74Zh5.css)({
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
            gridTemplateColumns: "repeat(3, minmax(0, 1fr))"
        }
    }),
    [$24c02ea0e14dbe4f$export$f02cc02ad0e0bba3.FOUR]: (0, $74Zh5.css)({
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
            gridTemplateColumns: "repeat(4, minmax(0, 1fr))"
        }
    })
};
var $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$exports, "LearningCourseCard", ()=>$24c02ea0e14dbe4f$export$5ae3342de8088f07);
const $24c02ea0e14dbe4f$export$5ae3342de8088f07 = ({ inspectMode: inspectMode, title: title, imageUrl: imageUrl, onClick: onClick, link: link, minHeight: minHeight = 153, learningProgress: learningProgress, onGeneratePdf: onGeneratePdf, shouldDisplayShowMoreButton: shouldDisplayShowMoreButton, shouldDisplayBookmark: shouldDisplayBookmark, onViewUpdates: onViewUpdates, onUpdatedButtonClick: onUpdatedButtonClick, isUpdated: isUpdated, areHistoricalNotifications: areHistoricalNotifications })=>{
    const cardRef = (0, $5FkrB.useRef)(null);
    const onClickHandler = (0, $5FkrB.useCallback)(()=>{
        onClick && onClick();
    }, [
        onClick
    ]);
    const handleUpdatedButtonClick = (0, $5FkrB.useCallback)((event)=>{
        event.stopPropagation();
        event.preventDefault();
        onUpdatedButtonClick && onUpdatedButtonClick();
    }, [
        onUpdatedButtonClick
    ]);
    const onKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(onClickHandler);
    const handleSave = (event)=>{
        if (learningProgress) {
            event.stopPropagation();
            event.preventDefault();
            learningProgress.onSave(!learningProgress.isSaved);
        }
    };
    const isSaved = learningProgress?.completedResources === learningProgress?.resourceCount || learningProgress?.isSaved;
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        href: link,
        css: $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$linkContainerStyles,
        rel: "noopener noreferrer",
        onClick: (e)=>e.preventDefault(),
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            role: "button",
            ref: cardRef,
            css: $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$learningCourseCardContainerStyles,
            onClick: onClickHandler,
            onKeyDown: onKeyDown,
            tabIndex: 0,
            "data-testid": "learning-course-card",
            style: {
                minHeight: `${minHeight}px`
            },
            children: [
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$bodyContainerStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$imageContainerStyles,
                            children: imageUrl ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                                css: [
                                    $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$imageStyles
                                ],
                                "data-testid": "learning-course-card-image",
                                src: imageUrl,
                                alt: "course-img"
                            }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                "data-testid": "learning-course-card-no-image",
                                css: $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$noImageStyles
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$titleAndDetailsContainerStyles,
                            children: title && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                "data-testid": "title",
                                ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("title", inspectMode),
                                css: $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$titleStyles,
                                children: title
                            })
                        })
                    ]
                }),
                learningProgress && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$learningCourseCardProgressContainerStyles,
                    "data-testid": "learning-course-card-progress-content",
                    children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$learningCourseCardProgressItemsContainerStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$184a993f673fc83f, {
                                wasPreviouslyCompleted: learningProgress.status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED,
                                completedResources: learningProgress.completedResources,
                                resourceCount: learningProgress.resourceCount,
                                completionDate: learningProgress.completionDate,
                                contentType: $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.COURSE
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$learningCourseCardIconsContainerStyles,
                                children: [
                                    isUpdated && learningProgress.status !== $24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        "data-testid": "updated-icon",
                                        css: $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$updatedIconContainerStyles,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                            label: "Updated",
                                            iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                                type: "editor-panel"
                                            }),
                                            onClick: handleUpdatedButtonClick
                                        })
                                    }),
                                    shouldDisplayShowMoreButton && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$ca7697601dcd7803, {
                                        cardRef: cardRef,
                                        shareOnPdf: true,
                                        onGeneratePdf: onGeneratePdf,
                                        areHistoricalNotifications: areHistoricalNotifications,
                                        onViewUpdates: onViewUpdates
                                    }),
                                    shouldDisplayBookmark && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                                        "data-testid": "save-content",
                                        css: $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$learningCourseCardBookmarkContainerStyles,
                                        onClick: handleSave,
                                        children: isSaved ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                            type: "bookmark-filled"
                                        }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                            type: "bookmark"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$learningCourseCardContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "8px",
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    transition: "box-shadow 0.3s ease-in-out",
    cursor: "pointer",
    width: "100%",
    height: "153px",
    "&:hover": {
        boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    },
    "&:active": {
        outline: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.focused")}`,
        border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.focused")}`
    }
});
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$bodyContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.075")}`,
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    minHeight: "96px",
    justifyContent: "flex-end",
    "@media (max-width: 1279px)": {
        justifyContent: "flex-start",
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")}`
    }
});
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$linkContainerStyles = (0, $74Zh5.css)({
    textDecoration: "none",
    "&:hover": {
        textDecoration: "none"
    }
});
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$imageContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    width: "64px",
    height: "64px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0
});
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$imageStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "50%"
});
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$noImageStyles = (0, $74Zh5.css)({
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest"),
    width: "64px",
    height: "64px",
    borderRadius: "50%"
});
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$titleAndDetailsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "275px",
    "@media (max-width: 1279px)": {
        width: "232px",
        flexGrow: 1,
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.0")}`
    }
});
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$learningCourseCardProgressContainerStyles = (0, $74Zh5.css)({
    borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`
});
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$learningCourseCardProgressItemsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")}`
});
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$learningCourseCardIconsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: "5px"
});
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$learningCourseCardBookmarkContainerStyles = (0, $74Zh5.css)({
    height: "24px",
    border: "none",
    background: "none",
    cursor: "pointer",
    outline: "none",
    "&:focus-visible": {
        outline: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$titleStyles = (0, $74Zh5.css)({
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginTop: "20px",
    marginBottom: 0,
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 400,
    fontStyle: "normal",
    lineHeight: "24px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
});
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$updatedIconContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: "5px",
    button: {
        backgroundColor: "transparent",
        height: "auto",
        minHeight: "auto",
        alignItems: "center",
        ":hover": {
            backgroundColor: "transparent"
        }
    },
    span: {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected"),
        fontFamily: "SF Pro, sans-serif",
        fontSize: "14px",
        lineHeight: "20px"
    }
});
var $24c02ea0e14dbe4f$var$$27d686e47ff412fd$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$27d686e47ff412fd$exports, "FeedbackHeader", ()=>$24c02ea0e14dbe4f$export$41cd510048068b0c);
const $24c02ea0e14dbe4f$export$41cd510048068b0c = ({ heading: heading, duration: duration, description: description })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("section", {
        "aria-labelledby": "feedback-header",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$headingWrapperStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("h1", {
                    css: $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$headingStyles,
                    id: "feedback-header",
                    children: heading
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$metadataStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$flexContainerStyles,
                    children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: (0, $74Zh5.css)({
                            display: "flex"
                        }),
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$tagStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                                    label: duration
                                })
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$tagStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                                    label: "survey"
                                })
                            })
                        ]
                    })
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$lineWrapperStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2e0a83ec2e27ecbb, {
                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$descriptionStyles,
                children: description
            })
        ]
    });
const $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$metadataStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$flexContainerStyles = (0, $74Zh5.css)({
    display: "flex"
});
const $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$tagStyles = (0, $74Zh5.css)({
    marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$lineWrapperStyles = (0, $74Zh5.css)({
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} 0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.500")} 0`
});
const $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$headingWrapperStyles = (0, $74Zh5.css)({
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.1000")} 0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} 0`
});
const $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$headingStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "61.333px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "81.778px"
});
const $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$descriptionStyles = (0, $74Zh5.css)({
    paddingBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.1000"),
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    lineHeight: "32px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    p: {
        margin: 0
    }
});
var $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$exports, "ReportIssueModal", ()=>$24c02ea0e14dbe4f$export$448811829c5d1992);
let $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$DialogWidth;
(function(DialogWidth) {
    DialogWidth["SMALL"] = "small";
    DialogWidth["MEDIUM"] = "medium";
    DialogWidth["LARGE"] = "large";
    DialogWidth["XLARGE"] = "x-large";
})($24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$DialogWidth || ($24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$DialogWidth = {}));
const $24c02ea0e14dbe4f$export$448811829c5d1992 = ({ isParticipatingInResearch: isParticipatingInResearch, consentToContact: consentToContact, selectValue: selectValue, textAreaValues: textAreaValues, heading: heading, width: width = $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$DialogWidth.LARGE, options: options, isDisabled: isDisabled, closeModal: closeModal, submit: submit, onSelectChange: onSelectChange, onTextChange: onTextChange, onParticipatingInResearch: onParticipatingInResearch, onConsentToContact: onConsentToContact })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $73c4314b1cf0d4b0$export$2e2bcd8739ae039), {
        onClose: closeModal,
        width: width,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$modalContainerStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$modalBodyStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                            "data-testid": "modal-heading",
                            css: $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$modalHeadingContainerStyles,
                            children: heading
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
                            css: $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$requiredFieldsStyles,
                            children: [
                                "Required fields are marked with an asterisk",
                                " ",
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                    css: [
                                        $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$requiredFieldsStyles,
                                        (0, $74Zh5.css)({
                                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.accent.red")
                                        })
                                    ],
                                    children: "*"
                                })
                            ]
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: (0, $74Zh5.css)({
                                marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
                            }),
                            children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                htmlFor: "problem-to-report",
                                children: [
                                    "What problem would you like to report? ",
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                        css: (0, $74Zh5.css)({
                                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.accent.red")
                                        }),
                                        children: "*"
                                    })
                                ]
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$selectContainerStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $6b35e1e8c8ac06e7$export$2e2bcd8739ae039), {
                                inputId: "problem-to-report",
                                options: options,
                                value: selectValue,
                                onChange: (e)=>onSelectChange(e),
                                placeholder: "Select problem"
                            })
                        }),
                        selectValue && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: (0, $74Zh5.css)({
                                        marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
                                    }),
                                    children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                        htmlFor: "problem-to-report",
                                        children: [
                                            "Provide any other details ",
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                                css: (0, $74Zh5.css)({
                                                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.accent.red")
                                                }),
                                                children: "*"
                                            })
                                        ]
                                    })
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$detailsStyles,
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $68e53f06a5d0057b$export$2e2bcd8739ae039), {
                                        maxHeight: "156px",
                                        placeholder: "Start typing...",
                                        onChange: onTextChange,
                                        value: textAreaValues
                                    })
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: (0, $74Zh5.css)({
                                        marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
                                    }),
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$48513f6b9f8ce62d, {
                                        label: "I'd like to participate in product research",
                                        onChange: onParticipatingInResearch,
                                        isChecked: isParticipatingInResearch
                                    })
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$policyContainerStyles,
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$48513f6b9f8ce62d, {
                                        label: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
                                            children: [
                                                "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the Atlassian Privacy Policy",
                                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a6c7ac8248d6e38a, {
                                                    label: "Atlassian Privacy Policy.",
                                                    target: "_blank",
                                                    link: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
                                                    onClick: ()=>{
                                                        window.open("https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers", "_blank", "noopener");
                                                    }
                                                })
                                            ]
                                        }),
                                        onChange: onConsentToContact,
                                        isChecked: consentToContact
                                    })
                                })
                            ]
                        })
                    ]
                }),
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
                    css: $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$modalCloseButtonStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$customButtonWrapperStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $123ba5aab151a241$export$2e2bcd8739ae039), {
                                appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.SUBTLE,
                                onClick: closeModal,
                                children: "Cancel"
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                            label: "Submit",
                            appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                            disabled: isDisabled,
                            onClick: submit
                        })
                    ]
                })
            ]
        })
    });
const $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$modalContainerStyles = (0, $74Zh5.css)({
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
    }
});
const $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$modalHeadingContainerStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "32px"
});
const $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$requiredFieldsStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
});
const $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$selectContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    maxWidth: "420px",
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
});
const $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$detailsStyles = (0, $74Zh5.css)({
    width: "100%",
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
});
const $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$modalCloseButtonStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "flex-end",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
    }
});
const $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$modalBodyStyles = (0, $74Zh5.css)({
    maxWidth: "640px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    margin: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} auto 0`,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        marginTop: 0
    }
});
const $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$customButtonWrapperStyles = (0, $74Zh5.css)({
    marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    button: {
        height: "100%",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
        fontSize: "16px",
        lineHeight: "20px",
        padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`,
        fontWeight: 600
    }
});
const $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$policyContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    a: {
        marginLeft: "5px"
    }
});
var $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$exports, "FlatContentCardStyle", ()=>$24c02ea0e14dbe4f$export$f2adaabc3a0295ef);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$exports, "FlatContentCardType", ()=>$24c02ea0e14dbe4f$export$8023ea0baf29b8db);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$exports, "FlatContentCard", ()=>$24c02ea0e14dbe4f$export$bc8a9d98c2eabbb7);
let $24c02ea0e14dbe4f$export$f2adaabc3a0295ef;
(function(FlatContentCardStyle) {
    FlatContentCardStyle["TALL"] = "tall";
    FlatContentCardStyle["FULL"] = "full";
})($24c02ea0e14dbe4f$export$f2adaabc3a0295ef || ($24c02ea0e14dbe4f$export$f2adaabc3a0295ef = {}));
let $24c02ea0e14dbe4f$export$8023ea0baf29b8db;
(function(FlatContentCardType) {
    FlatContentCardType["ROUND"] = "round";
    FlatContentCardType["SQUARE"] = "square";
    FlatContentCardType["RECTANGLE"] = "rectangle";
    FlatContentCardType["FLEXIBLE"] = "flexible";
})($24c02ea0e14dbe4f$export$8023ea0baf29b8db || ($24c02ea0e14dbe4f$export$8023ea0baf29b8db = {}));
const $24c02ea0e14dbe4f$export$bc8a9d98c2eabbb7 = ({ image: image, title: title, text: text, link: link, linkLabel: linkLabel = "Learn more", style: style = $24c02ea0e14dbe4f$export$f2adaabc3a0295ef.TALL, type: type = $24c02ea0e14dbe4f$export$8023ea0baf29b8db.ROUND, headingLevel: headingLevel, bgColor: bgColor = "initial", onClick: onClick, target: target = "_self", maxWidth: maxWidth, minHeight: minHeight, withElevationBorder: withElevationBorder = false })=>{
    const isSquareOrRectangle = type === $24c02ea0e14dbe4f$export$8023ea0baf29b8db.SQUARE || type === $24c02ea0e14dbe4f$export$8023ea0baf29b8db.RECTANGLE;
    const isFlexible = type === $24c02ea0e14dbe4f$export$8023ea0baf29b8db.FLEXIBLE;
    const roundStyles = image ? $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$variantStyles[style].container.withImage : $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$variantStyles[style].container.withoutImage;
    const additionalContainerStyles = isSquareOrRectangle ? $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$squareTypeStyles.container : isFlexible ? $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$flexibleContainerStyles : roundStyles;
    const defaultHeadingLevel = isSquareOrRectangle ? 3 : 4;
    const rectangleStyles = type === $24c02ea0e14dbe4f$export$8023ea0baf29b8db.RECTANGLE && $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$variantStyles[$24c02ea0e14dbe4f$export$f2adaabc3a0295ef.TALL].container.withImage;
    const handleClick = (title)=>{
        onClick && onClick(title);
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$containerStyles,
            additionalContainerStyles,
            rectangleStyles,
            (0, $74Zh5.css)({
                backgroundColor: bgColor
            }),
            maxWidth && (0, $74Zh5.css)({
                maxWidth: maxWidth
            }),
            isFlexible && minHeight && (0, $74Zh5.css)({
                minHeight: minHeight
            }),
            withElevationBorder && $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$elevationBorderStyles
        ],
        "data-testid": "learn-more-card",
        children: [
            image && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                src: image.src,
                alt: image.alt,
                width: isFlexible && image.width ? image.width : undefined,
                height: isFlexible && image.height ? image.height : undefined,
                css: [
                    $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$imageBaseStyles,
                    (isSquareOrRectangle || isFlexible) && $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$imageSquareStyles,
                    isFlexible && $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$imageFlexibleStyles,
                    isFlexible && image.width && image.height && (0, $74Zh5.css)({
                        width: `${image.width}px`,
                        height: `${image.height}px`
                    }),
                    style === $24c02ea0e14dbe4f$export$f2adaabc3a0295ef.FULL && $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$fullStyleImageStyles
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$contentContainerStyles,
                    isSquareOrRectangle && $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$contentContainerSquareStyles
                ],
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: (0, $74Zh5.css)([
                            $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$textStyles,
                            type === $24c02ea0e14dbe4f$export$8023ea0baf29b8db.ROUND && $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$variantStyles[style].heading,
                            isSquareOrRectangle && $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$squareTypeStyles.heading,
                            isFlexible && $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$variantStyles[style].heading
                        ]),
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                            level: headingLevel || defaultHeadingLevel,
                            fontWeight: 600,
                            children: title
                        })
                    }),
                    (type === $24c02ea0e14dbe4f$export$8023ea0baf29b8db.ROUND || type === $24c02ea0e14dbe4f$export$8023ea0baf29b8db.RECTANGLE || isFlexible) && text && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: [
                            (0, $74Zh5.css)([
                                $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$textStyles,
                                $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$variantStyles[style].text,
                                $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$textContainerStyles
                            ])
                        ],
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                            children: text
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a6c7ac8248d6e38a, {
                        label: linkLabel,
                        link: link,
                        onClick: ()=>handleClick(title),
                        icon: "arrow-right",
                        fontColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
                        style: $24c02ea0e14dbe4f$export$2b77966d73aefa77.SEMIBOLD,
                        size: $24c02ea0e14dbe4f$export$be4c932f76c19adf.LARGE,
                        target: target
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$containerStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400")} 0`,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} 0`
    }
});
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$elevationBorderStyles = (0, $74Zh5.css)({
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "8px",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    transition: "box-shadow 0.3s ease-in-out",
    "&:hover": {
        boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    }
});
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$textStyles = (0, $74Zh5.css)({
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.md]: {
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis"
    }
});
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$imageBaseStyles = (0, $74Zh5.css)({
    height: "80px",
    width: "80px",
    objectFit: "contain",
    borderRadius: "50%",
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    maxWidth: "100%"
});
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$imageSquareStyles = (0, $74Zh5.css)({
    borderRadius: 0,
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
});
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$imageFlexibleStyles = (0, $74Zh5.css)({
    maxWidth: "100%",
    objectFit: "contain"
});
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$fullStyleImageStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "auto",
    maxHeight: "260px",
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.500"),
    borderRadius: "initial"
});
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$variantStyles = {
    [$24c02ea0e14dbe4f$export$f2adaabc3a0295ef.TALL]: {
        container: {
            withImage: (0, $74Zh5.css)({
                [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.md]: {
                    height: "352px !important"
                }
            }),
            withoutImage: (0, $74Zh5.css)({
                [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.md]: {
                    height: "264px !important"
                }
            })
        },
        heading: (0, $74Zh5.css)({
            [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.md]: {
                WebkitLineClamp: "2"
            }
        }),
        text: (0, $74Zh5.css)({
            [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.md]: {
                WebkitLineClamp: "3"
            }
        })
    },
    [$24c02ea0e14dbe4f$export$f2adaabc3a0295ef.FULL]: {
        container: {
            withImage: (0, $74Zh5.css)({
                [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.md]: {
                    height: "auto !important"
                }
            }),
            withoutImage: (0, $74Zh5.css)({
                [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.md]: {
                    height: "auto !important"
                }
            })
        },
        heading: (0, $74Zh5.css)({
            [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.md]: {
                WebkitLineClamp: "none"
            }
        }),
        text: (0, $74Zh5.css)({
            [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.md]: {
                WebkitLineClamp: "none"
            }
        })
    }
};
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$squareTypeStyles = {
    container: (0, $74Zh5.css)({
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
        padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
        height: "320px",
        width: "324px",
        borderRadius: "8px",
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
            minHeight: "360px",
            maxWidth: "unset",
            height: "100%"
        },
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
            minHeight: "264px",
            padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
        }
    }),
    heading: (0, $74Zh5.css)({
        marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
    })
};
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$flexibleContainerStyles = (0, $74Zh5.css)({
    height: "auto",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    borderRadius: "8px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400")
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
    }
});
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$contentContainerStyles = (0, $74Zh5.css)({
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.025"),
    flex: 1,
    display: "flex",
    flexDirection: "column"
});
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$contentContainerSquareStyles = (0, $74Zh5.css)({
    justifyContent: "space-between",
    a: {
        fontSize: "20px",
        lineHeight: "24px"
    }
});
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$textContainerStyles = (0, $74Zh5.css)({
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
    }
});
var $24c02ea0e14dbe4f$var$$205ed41b47d90e33$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$205ed41b47d90e33$exports, "RelatedResourcesPanel", ()=>$24c02ea0e14dbe4f$export$3775cdf183cb8274);
const $24c02ea0e14dbe4f$var$$205ed41b47d90e33$var$ResourceItem = ({ title: title, slug: slug, onResourceClick: onResourceClick })=>{
    const handleClick = (0, $5FkrB.useCallback)(()=>onResourceClick(slug), [
        slug,
        onResourceClick
    ]);
    const onKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleClick);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        role: "button",
        tabIndex: 0,
        css: $24c02ea0e14dbe4f$var$$205ed41b47d90e33$var$resourceStyles,
        onClick: handleClick,
        onKeyDown: onKeyDown,
        children: title
    });
};
const $24c02ea0e14dbe4f$export$3775cdf183cb8274 = ({ title: title, resources: resources, onResourceClick: onResourceClick, onButtonClick: onButtonClick })=>{
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const handleButtonClick = (0, $5FkrB.useCallback)(()=>{
        setIsOpen(!isOpen);
        onButtonClick && onButtonClick();
    }, [
        isOpen,
        onButtonClick
    ]);
    const onKeyDownPanel = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleButtonClick);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        "data-testid": "related-resources-panel",
        css: $24c02ea0e14dbe4f$var$$205ed41b47d90e33$var$relatedResourcesPanelStyles,
        onClick: handleButtonClick,
        onKeyDown: onKeyDownPanel,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": "related-resources-header",
                css: $24c02ea0e14dbe4f$var$$205ed41b47d90e33$var$headerStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                        level: 6,
                        children: title
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $0c4c08ddec83e35f$export$2e2bcd8739ae039), {
                        appearance: "subtle",
                        icon: isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($30203922e34ab8aa$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($9486f8503a3e67e2$exports))),
                        label: isOpen ? "Collapse" : "Expand"
                    })
                ]
            }),
            isOpen && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
                "data-testid": "related-resources-list",
                css: $24c02ea0e14dbe4f$var$$205ed41b47d90e33$var$resourcesListStyles,
                children: resources.map(({ title: title, slug: slug })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                        "data-testid": `related-resource-item-${slug}`,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$205ed41b47d90e33$var$ResourceItem, {
                            title: title,
                            slug: slug,
                            onResourceClick: onResourceClick
                        })
                    }, slug))
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$205ed41b47d90e33$var$relatedResourcesPanelStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    borderRadius: "8px",
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")}`,
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    cursor: "pointer",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input.pressed")
});
const $24c02ea0e14dbe4f$var$$205ed41b47d90e33$var$headerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
});
const $24c02ea0e14dbe4f$var$$205ed41b47d90e33$var$resourcesListStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    margin: 0,
    paddingLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250"),
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
});
const $24c02ea0e14dbe4f$var$$205ed41b47d90e33$var$resourceStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.link"),
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    cursor: "pointer",
    "&:hover": {
        textDecoration: "underline"
    }
});
var $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3c691af970e2b3d8$exports, "ThumbType", ()=>$24c02ea0e14dbe4f$export$e1c6e381de15460b);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3c691af970e2b3d8$exports, "FeedbackButtonType", ()=>$24c02ea0e14dbe4f$export$8eec558e14651de4);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3c691af970e2b3d8$exports, "THUMBS_UP_FEEDBACK_OPTIONS", ()=>$24c02ea0e14dbe4f$export$3e6d4d99e8c08756);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3c691af970e2b3d8$exports, "THUMBS_DOWN_FEEDBACK_OPTIONS", ()=>$24c02ea0e14dbe4f$export$592a942fdddb4b1a);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3c691af970e2b3d8$exports, "QuickFeedback", ()=>$24c02ea0e14dbe4f$export$c6f2bf448101d429);
let $24c02ea0e14dbe4f$export$e1c6e381de15460b;
(function(ThumbType) {
    ThumbType["THUMB_UP"] = "thumb-up";
    ThumbType["THUMB_DOWN"] = "thumb-down";
})($24c02ea0e14dbe4f$export$e1c6e381de15460b || ($24c02ea0e14dbe4f$export$e1c6e381de15460b = {}));
let $24c02ea0e14dbe4f$export$8eec558e14651de4;
(function(FeedbackButtonType) {
    FeedbackButtonType["DISMISS"] = "dismiss";
    FeedbackButtonType["SUBMIT"] = "submit";
})($24c02ea0e14dbe4f$export$8eec558e14651de4 || ($24c02ea0e14dbe4f$export$8eec558e14651de4 = {}));
const $24c02ea0e14dbe4f$export$3e6d4d99e8c08756 = [
    "It was easy to understand",
    "I learned something useful",
    "It was engaging",
    "It improved my confidence in the subject",
    "Other"
];
const $24c02ea0e14dbe4f$export$592a942fdddb4b1a = [
    "It wasn\u2019t clear",
    "It wasn\u2019t accurate",
    "I didn\u2019t learn what I wanted to know",
    "Other"
];
const $24c02ea0e14dbe4f$export$c6f2bf448101d429 = ({ onSubmitFeedback: onSubmitFeedback, onChangeThoughts: onChangeThoughts, onChangeOption: onChangeOption, onThumbClick: onThumbClick, shouldShowDivider: shouldShowDivider = true, buttonText: buttonText = "How was this lesson?" })=>{
    const [isPopupOpened, setIsPopupOpened] = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState({
        isOpen: false,
        thumbType: null
    });
    const [selectedOption, setSelectedOption] = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState("");
    const [selectedThumb, setSelectedThumb] = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(null);
    const handleThumbClick = (thumbType)=>{
        if (selectedThumb !== thumbType) {
            setSelectedOption("");
            onChangeOption("");
            onChangeThoughts({
                target: {
                    value: ""
                }
            });
        }
        setIsPopupOpened({
            isOpen: true,
            thumbType: thumbType
        });
        setSelectedThumb(thumbType);
        onThumbClick(thumbType);
    };
    const toggleAnswer = (option)=>{
        setSelectedOption(option);
        onChangeOption(option);
    };
    const getOptionStatus = (option)=>selectedOption === option;
    const handleChangeThoughts = (0, $5FkrB.useCallback)((e)=>{
        e.preventDefault();
        if (onChangeThoughts) onChangeThoughts(e);
    }, [
        onChangeThoughts
    ]);
    const handleSubmitFeedback = ()=>{
        setIsPopupOpened({
            isOpen: false,
            thumbType: null
        });
        onSubmitFeedback($24c02ea0e14dbe4f$export$8eec558e14651de4.SUBMIT);
    };
    const handleDismissFeedback = ()=>{
        setIsPopupOpened({
            isOpen: false,
            thumbType: null
        });
        setSelectedOption("");
        onChangeThoughts({
            target: {
                value: ""
            }
        });
        onChangeOption("");
        onSubmitFeedback($24c02ea0e14dbe4f$export$8eec558e14651de4.DISMISS);
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "quick-feedback-component",
        css: $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$quickFeedbackStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$feedbackContainerStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$thumbsContainerStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                "data-testid": "thumb-down-container",
                                css: [
                                    $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$thumbButtonContainerStyles,
                                    selectedThumb === $24c02ea0e14dbe4f$export$e1c6e381de15460b.THUMB_DOWN && {
                                        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected")
                                    }
                                ],
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                    tooltip: "Needs improvement",
                                    iconType: "thumb-down",
                                    label: "",
                                    iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                        type: "thumb-down"
                                    }),
                                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON,
                                    onClick: ()=>handleThumbClick($24c02ea0e14dbe4f$export$e1c6e381de15460b.THUMB_DOWN)
                                })
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: [
                                    $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$thumbButtonContainerStyles,
                                    selectedThumb === $24c02ea0e14dbe4f$export$e1c6e381de15460b.THUMB_UP && {
                                        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected")
                                    }
                                ],
                                "data-testid": "thumb-up-container",
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                    tooltip: "Good",
                                    iconType: "thumb-up",
                                    label: "",
                                    iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                        type: "thumb-up"
                                    }),
                                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON,
                                    onClick: ()=>handleThumbClick($24c02ea0e14dbe4f$export$e1c6e381de15460b.THUMB_UP)
                                })
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        "data-testid": "quick-feedback-text",
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                            level: 6,
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle"),
                            children: selectedThumb ? "Thanks for your feedback!" : buttonText
                        })
                    })
                ]
            }),
            shouldShowDivider && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$dividerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2e0a83ec2e27ecbb, {
                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border"),
                    height: 2
                })
            }),
            isPopupOpened.isOpen && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": "popup",
                css: $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$popupStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                size: "small",
                                fontWeight: "semibold",
                                children: "Why did you choose this response?"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$optionsContentStyles,
                                children: isPopupOpened.thumbType === $24c02ea0e14dbe4f$export$e1c6e381de15460b.THUMB_UP ? $24c02ea0e14dbe4f$export$3e6d4d99e8c08756.map((option)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        css: $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$radioContainerStyles,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$d7b12c4107be0d61, {
                                            setIsChecked: ()=>toggleAnswer(option),
                                            isChecked: getOptionStatus(option),
                                            label: option,
                                            name: "thumb-up"
                                        })
                                    }, option)) : $24c02ea0e14dbe4f$export$592a942fdddb4b1a.map((option)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        css: $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$radioContainerStyles,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$d7b12c4107be0d61, {
                                            setIsChecked: ()=>toggleAnswer(option),
                                            isChecked: getOptionStatus(option),
                                            label: option,
                                            name: "thumb-down"
                                        })
                                    }, option))
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$feedbackFormStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$inputContainerStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                        size: "small",
                                        fontWeight: "semibold",
                                        children: "Share your thoughts"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2c73285ae9390cec, {
                                        id: "quick-feedback-input",
                                        placeholder: "Start typing...",
                                        onChange: handleChangeThoughts
                                    }, selectedThumb)
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$buttonsContainerStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                        label: "Dismiss",
                                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.LINK,
                                        onClick: handleDismissFeedback
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                        label: "Submit",
                                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                                        onClick: handleSubmitFeedback
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$quickFeedbackStyles = (0, $74Zh5.css)({
    position: "relative",
    maxWidth: "720px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center"
});
const $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$feedbackContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    alignItems: "center"
});
const $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$thumbsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$thumbButtonContainerStyles = (0, $74Zh5.css)({
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.disabled"),
    borderRadius: "3px"
});
const $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$dividerStyles = (0, $74Zh5.css)({
    width: "100%",
    margin: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400")} 0`
});
const $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$popupStyles = (0, $74Zh5.css)({
    position: "absolute",
    bottom: "100px",
    maxWidth: "476px",
    width: "100%",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    borderRadius: "8px",
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    boxShadow: `0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 1px 1px 0px rgba(9, 30, 66, 0.25)`,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        position: "relative",
        bottom: "60px"
    }
});
const $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$optionsContentStyles = (0, $74Zh5.css)({
    margin: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} 0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`
});
const $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$radioContainerStyles = (0, $74Zh5.css)({
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
});
const $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$feedbackFormStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
});
const $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$inputContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
});
const $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$buttonsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "flex-end",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
var $24c02ea0e14dbe4f$var$$5f9280667c666470$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$5f9280667c666470$exports, "Searchbar", ()=>$24c02ea0e14dbe4f$export$b9f6e7a4c54af1f6);
const $24c02ea0e14dbe4f$var$$9c9ed7a3b666cf11$export$b36c0aa7a63a3911 = ({ item: item, onRemove: onRemove, onSelect: onSelect })=>{
    const deviceSize = $24c02ea0e14dbe4f$export$4616d33c54ae5baf();
    const handleRemoveButton = (e)=>{
        e.stopPropagation();
        onRemove(item);
    };
    const handleItemClick = (0, $5FkrB.useCallback)(()=>{
        onSelect(item);
    }, [
        onSelect,
        item
    ]);
    const handleRemoveKeyboard = (0, $5FkrB.useCallback)(()=>{
        onRemove(item);
    }, [
        onRemove,
        item
    ]);
    const onKeyDownItem = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleItemClick);
    const onKeyDownRemove = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleRemoveKeyboard);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        css: $24c02ea0e14dbe4f$var$$9c9ed7a3b666cf11$var$historyItemContainerStyles,
        onClick: handleItemClick,
        onKeyDown: onKeyDownItem,
        "data-testid": "history-item",
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$9c9ed7a3b666cf11$var$historyItemStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                        type: "emoji-frequent",
                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.subtle")
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                        css: $24c02ea0e14dbe4f$var$$9c9ed7a3b666cf11$var$itemTextStyles,
                        children: item
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$9c9ed7a3b666cf11$var$removeContainerStyles,
                    deviceSize < $24c02ea0e14dbe4f$export$27ed77542911fb0e && (0, $74Zh5.css)({
                        opacity: 1
                    })
                ],
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                        onClick: handleRemoveButton,
                        label: "",
                        iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: "dropdown-cross",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                        })
                    }),
                    deviceSize < $24c02ea0e14dbe4f$export$27ed77542911fb0e && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                        role: "button",
                        tabIndex: 0,
                        css: $24c02ea0e14dbe4f$var$$9c9ed7a3b666cf11$var$clearButtonStyles,
                        onClick: handleRemoveButton,
                        onKeyDown: onKeyDownRemove,
                        children: "Clear"
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$9c9ed7a3b666cf11$var$removeContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    opacity: 0,
    button: {
        span: {
            margin: "0px !important"
        }
    }
});
const $24c02ea0e14dbe4f$var$$9c9ed7a3b666cf11$var$historyItemContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
    cursor: "pointer",
    button: {
        backgroundColor: "transparent",
        border: "none",
        padding: 0,
        margin: 0,
        outline: "none",
        "&:hover": {
            backgroundColor: "transparent"
        }
    },
    "&:hover": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
    },
    "&:hover > div:last-child": {
        opacity: 1
    }
});
const $24c02ea0e14dbe4f$var$$9c9ed7a3b666cf11$var$historyItemStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: "4px"
});
const $24c02ea0e14dbe4f$var$$9c9ed7a3b666cf11$var$itemTextStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    color: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")}`
});
const $24c02ea0e14dbe4f$var$$9c9ed7a3b666cf11$var$clearButtonStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "Inter, sans-serif",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px"
});
const $24c02ea0e14dbe4f$var$$2f046e897b352baf$export$ed4de3239e2fb964 = ({ items: items, onRemove: onRemove, onSelect: onSelect })=>{
    if (!items.length) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {});
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$2f046e897b352baf$var$historyStyles,
        "data-testid": "history-container",
        children: items.slice(-5).reverse().map((item)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$9c9ed7a3b666cf11$export$b36c0aa7a63a3911, {
                item: item,
                onRemove: onRemove,
                onSelect: onSelect
            }, item))
    });
};
const $24c02ea0e14dbe4f$var$$2f046e897b352baf$var$historyStyles = (0, $74Zh5.css)({
    position: "absolute",
    display: "flex",
    width: "279px",
    borderRadius: "3px",
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.075")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")}`,
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.075"),
    flexDirection: "column",
    alignItems: "flex-start",
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface.overlay"),
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    zIndex: 1,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        width: "327px"
    }
});
const $24c02ea0e14dbe4f$export$b9f6e7a4c54af1f6 = ({ value: value, onChange: onChange, isLoading: isLoading, label: label, isTall: isTall = false })=>{
    const [isHistoryVisible, setIsHistoryVisible] = (0, $5FkrB.useState)(false);
    const [history, setHistory] = (0, $5FkrB.useState)($24c02ea0e14dbe4f$export$7765f5b61937bda1());
    const searchRef = (0, $5FkrB.useRef)(null);
    const deviceSize = $24c02ea0e14dbe4f$export$4616d33c54ae5baf();
    const isRemoveIconVisible = !!value.length && (deviceSize >= $24c02ea0e14dbe4f$export$27ed77542911fb0e || !isLoading);
    (0, $5FkrB.useEffect)(()=>{
        const searchElement = searchRef.current;
        if (!searchElement) return;
        const inputElement = searchElement.querySelector("input");
        if (!inputElement) return;
        const handleFocus = ()=>{
            setIsHistoryVisible(true);
        };
        const handleClickOutside = (event)=>{
            if (searchRef.current && !searchRef.current.contains(event.target)) setIsHistoryVisible(false);
        };
        inputElement.addEventListener("focus", handleFocus);
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            inputElement.removeEventListener("focus", handleFocus);
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const handleRemoveItem = (itemToRemove)=>{
        const newHistory = history.filter((item)=>item !== itemToRemove);
        setHistory(newHistory);
        $24c02ea0e14dbe4f$export$cec0922aa1b64670(newHistory);
    };
    const handleSelectItem = (selectedItem)=>{
        onChange(selectedItem);
        setIsHistoryVisible(false);
    };
    const onKeyDown = (event)=>{
        if (event.key === "Enter" && value.trim()) {
            if (!history.includes(value.trim()) && searchRef.current) {
                const newHistory = [
                    ...history,
                    value.trim()
                ];
                $24c02ea0e14dbe4f$export$cec0922aa1b64670(newHistory);
                const inputElement = searchRef.current.querySelector("input");
                if (inputElement) inputElement.blur();
                setIsHistoryVisible(false);
                setHistory(newHistory);
            }
        }
    };
    const filteredItems = history.filter((item)=>item.toLowerCase().includes(value.toLowerCase()));
    const handleOnChange = (event)=>{
        if (event.target instanceof HTMLInputElement) onChange(event.target.value);
    };
    const onClearSearchClick = ()=>{
        onChange("");
        setIsHistoryVisible(false);
    };
    const onKeyDownClear = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(onClearSearchClick);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        role: "search",
        css: $24c02ea0e14dbe4f$var$$5f9280667c666470$var$searchStyles,
        onKeyDown: onKeyDown,
        tabIndex: 0,
        ref: searchRef,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: $24c02ea0e14dbe4f$var$$5f9280667c666470$var$searchBeforeIconStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($47b625f21d7ae4a6$exports))), {
                    primaryColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
                    size: "medium",
                    label: "search icon"
                })
            }),
            !!value.length && isLoading && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                "data-testid": "search-loader",
                css: [
                    $24c02ea0e14dbe4f$var$$5f9280667c666470$var$searchAfterIconStyles,
                    $24c02ea0e14dbe4f$var$$5f9280667c666470$var$searchLoaderIconStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e9bb9e7afd1cf629$export$2e2bcd8739ae039), {
                    size: "small"
                })
            }),
            isRemoveIconVisible && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                role: "button",
                tabIndex: 0,
                css: $24c02ea0e14dbe4f$var$$5f9280667c666470$var$searchAfterIconStyles,
                onClick: onClearSearchClick,
                onKeyDown: onKeyDownClear,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                    label: "",
                    size: $24c02ea0e14dbe4f$export$5dd2748b7940a2a0.LARGE,
                    iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                        type: "cross",
                        alt: "cross icon"
                    }),
                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("input", {
                placeholder: label ?? (deviceSize < $24c02ea0e14dbe4f$export$27ed77542911fb0e ? "Search" : "Search catalog"),
                value: value,
                onChange: handleOnChange,
                style: isTall ? {
                    paddingTop: "10px",
                    paddingBottom: "10px"
                } : {}
            }),
            isHistoryVisible && history.length > 0 && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$2f046e897b352baf$export$ed4de3239e2fb964, {
                items: filteredItems,
                onRemove: handleRemoveItem,
                onSelect: handleSelectItem
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$5f9280667c666470$var$searchStyles = (0, $74Zh5.css)({
    position: "relative",
    width: "100%",
    maxWidth: "240px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        maxWidth: "275px"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        maxWidth: "100%"
    },
    input: {
        width: "100%",
        minHeight: "32px",
        border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.input")}`,
        borderRadius: "5px !important",
        padding: `0 30px 0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.500")}`,
        color: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")} !important`,
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "20px",
        outline: "none",
        "&::placeholder": {
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
            fontFamily: "SF Pro, sans-serif"
        },
        "&:focus": {
            border: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.focused")} !important`
        },
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
            height: "40px",
            padding: `10px 30px 10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.500")}`
        }
    }
});
const $24c02ea0e14dbe4f$var$$5f9280667c666470$var$searchBeforeIconStyles = (0, $74Zh5.css)({
    position: "absolute",
    left: "10px",
    top: 0,
    height: "100%",
    display: "flex",
    alignItems: "center",
    "[role='img']": {
        width: "20px !important",
        height: "20px !important"
    }
});
const $24c02ea0e14dbe4f$var$$5f9280667c666470$var$searchAfterIconStyles = (0, $74Zh5.css)({
    position: "absolute",
    right: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    top: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
    cursor: "pointer",
    "[role='img']": {
        width: "20px !important",
        height: "20px !important"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        top: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
    }
});
const $24c02ea0e14dbe4f$var$$5f9280667c666470$var$searchLoaderIconStyles = (0, $74Zh5.css)({
    cursor: "default",
    right: "-24px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        top: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
        right: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
    }
});
var $24c02ea0e14dbe4f$var$$ffad026de847a971$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$ffad026de847a971$exports, "CourseStatus", ()=>$24c02ea0e14dbe4f$export$686d6bd87c227b43);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$ffad026de847a971$exports, "CourseList", ()=>$24c02ea0e14dbe4f$export$96ebd64c4b8b0cf9);
var $24c02ea0e14dbe4f$var$$45c6e177b24a84f5$require$Buffer = (0, $7KfP5.Buffer);
const $24c02ea0e14dbe4f$var$$45c6e177b24a84f5$var$completedGap = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.735 12.322C6.55446 12.13 6.30541 12.0171 6.04201 12.0077C5.77861 11.9983 5.52217 12.0933 5.32844 12.272C5.13471 12.4507 5.01937 12.6987 5.00749 12.962C4.99561 13.2253 5.08815 13.4826 5.265 13.678L8.877 17.597C9.414 18.123 10.214 18.123 10.711 17.627L11.075 17.268C12.3895 15.9753 13.7025 14.6809 15.014 13.385L15.054 13.345C16.2797 12.1371 17.499 10.9228 18.712 9.70205C18.8933 9.51225 18.9927 9.25878 18.9887 8.99634C18.9848 8.73391 18.8778 8.48354 18.6909 8.29926C18.504 8.11499 18.2522 8.01158 17.9897 8.01135C17.7273 8.01113 17.4752 8.1141 17.288 8.29805C16.0807 9.51239 14.8673 10.7207 13.648 11.923L13.608 11.963C12.3513 13.2053 11.0929 14.446 9.833 15.685L6.735 12.322Z" fill="#22A06B"/>
</svg>
`;
const $24c02ea0e14dbe4f$var$$45c6e177b24a84f5$export$29aa8664c658caa9 = `data:image/svg+xml;base64,${$24c02ea0e14dbe4f$var$$45c6e177b24a84f5$require$Buffer.from($24c02ea0e14dbe4f$var$$45c6e177b24a84f5$var$completedGap).toString("base64")}`;
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$TABLET_SCREEN_WIDTH = 900;
let $24c02ea0e14dbe4f$export$686d6bd87c227b43;
(function(CourseStatus) {
    CourseStatus[/** The course is not started */ "DEFAULT"] = "default";
    CourseStatus[/** The course is in progress */ "IN_PROGRESS"] = "in_progress";
    CourseStatus[/** The course is finished */ "FINISHED"] = "finished";
})($24c02ea0e14dbe4f$export$686d6bd87c227b43 || ($24c02ea0e14dbe4f$export$686d6bd87c227b43 = {}));
const $24c02ea0e14dbe4f$export$96ebd64c4b8b0cf9 = ({ course: course, lessons: lessons, onLessonClick: onLessonClick, onCourseTitleClick: onCourseTitleClick, onCourseButtonClick: onCourseButtonClick })=>{
    const [isOpened, setIsOpened] = (0, $5FkrB.useState)(false);
    const deviceSize = $24c02ea0e14dbe4f$export$4616d33c54ae5baf();
    const numberOfCompletedLessons = lessons.filter((lesson)=>lesson.isCompleted).length;
    const calculateProgress = ()=>{
        if (course.courseStatus === $24c02ea0e14dbe4f$export$686d6bd87c227b43.FINISHED) return 100;
        return numberOfCompletedLessons / lessons.length * 100;
    };
    const isCompleted = calculateProgress() === 100;
    const isTablet = deviceSize <= $24c02ea0e14dbe4f$var$$ffad026de847a971$var$TABLET_SCREEN_WIDTH;
    const toggleLessons = ()=>{
        setIsOpened(!isOpened);
    };
    const getButtonText = (status)=>{
        switch(status){
            case $24c02ea0e14dbe4f$export$686d6bd87c227b43.DEFAULT:
                return "Get started";
            case $24c02ea0e14dbe4f$export$686d6bd87c227b43.IN_PROGRESS:
                return "Continue";
            case $24c02ea0e14dbe4f$export$686d6bd87c227b43.FINISHED:
                return "Review course";
            default:
                return "Get started";
        }
    };
    const handleTitleClick = (0, $5FkrB.useCallback)((event)=>{
        if (onCourseTitleClick) {
            event?.preventDefault();
            onCourseTitleClick();
        }
    }, [
        onCourseTitleClick
    ]);
    const handleButtonClick = (0, $5FkrB.useCallback)((event)=>{
        if (onCourseButtonClick) {
            event?.preventDefault();
            onCourseButtonClick();
        }
    }, [
        onCourseButtonClick
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$ffad026de847a971$var$wrapperStyles,
            isOpened ? $24c02ea0e14dbe4f$var$$ffad026de847a971$var$wrapperOpenStyles : $24c02ea0e14dbe4f$var$$ffad026de847a971$var$wrapperClosedStyles,
            isCompleted && $24c02ea0e14dbe4f$var$$ffad026de847a971$var$completedCourseStyles
        ],
        "data-testid": "course-list-container",
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": `course-card-${course?.slug}`,
                css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$containerStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$progressBadgeContainerStyles,
                        "data-testid": "course-progress-badge",
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$customProgressBadgeStyles,
                            children: !isCompleted ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f188eff9b59fb855$export$5ab97151efedb8c6), {
                                strokeWidth: 6,
                                value: calculateProgress(),
                                styles: (0, $f188eff9b59fb855$export$5115a192ad9bf57f)({
                                    pathColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.success"),
                                    trailColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")
                                }),
                                "data-testid": "course-progress-circle",
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$imageBadgeContainerStyles,
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                                        src: course.imageUrl,
                                        alt: "Course badge",
                                        css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$imageStyles,
                                        "data-testid": "course-badge-image"
                                    })
                                })
                            }) : (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$completedBadgeContainerStyles,
                                "data-testid": "course-completed-badge",
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$imageBadgeContainerStyles,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                                            src: course.imageUrl,
                                            alt: "Course badge",
                                            css: [
                                                $24c02ea0e14dbe4f$var$$ffad026de847a971$var$imageStyles,
                                                $24c02ea0e14dbe4f$var$$ffad026de847a971$var$completedImageStyles
                                            ],
                                            "data-testid": "course-completed-image"
                                        })
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$checkmarkOverlayStyles,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                                            src: $24c02ea0e14dbe4f$var$$45c6e177b24a84f5$export$29aa8664c658caa9,
                                            alt: "Completed",
                                            css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$checkmarkIconStyles,
                                            "data-testid": "course-completed-checkmark"
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$contentContainerStyles,
                        "data-testid": "course-content",
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$topContentStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$durationTitleContainerStyles,
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$durationTextStyles,
                                                "data-testid": "course-duration",
                                                children: course.duration
                                            }),
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                                                level: 5,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                                    css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$titleStyles,
                                                    href: course.href,
                                                    onClick: handleTitleClick,
                                                    "data-testid": "course-title-link",
                                                    children: course.title
                                                })
                                            })
                                        ]
                                    }),
                                    !isTablet && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                        css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$startCourseButtonStyles,
                                        href: course.href,
                                        onClick: handleButtonClick,
                                        "data-testid": "desktop-course-button",
                                        children: getButtonText(course.courseStatus)
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$durationTitleContainerStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                    css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$subTitleStyles,
                                    "data-testid": "course-subtitle",
                                    children: course.subTitle
                                })
                            })
                        ]
                    })
                ]
            }),
            !isTablet && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$ffad026de847a971$var$buttonContainerStyles,
                    isOpened && $24c02ea0e14dbe4f$var$$ffad026de847a971$var$buttonContainerOpenStyles,
                    !isOpened && $24c02ea0e14dbe4f$var$$ffad026de847a971$var$buttonContainerClosedStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                    css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$toggleButtonStyles,
                    onClick: toggleLessons,
                    "data-testid": "toggle-lessons-button",
                    children: [
                        isOpened ? "Hide lessons" : "Show lessons",
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            size: "small",
                            type: isOpened ? "chevron-up" : "chevron-down",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand")
                        })
                    ]
                })
            }),
            isOpened && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$ffad026de847a971$var$lessonsContentWrapperStyles,
                    isTablet && $24c02ea0e14dbe4f$var$$ffad026de847a971$var$lessonContentWrapperMobileStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$c3b0ae23c563b692, {
                    lessons: lessons,
                    onLessonClick: onLessonClick,
                    isStandalone: false,
                    isTablet: isTablet
                })
            }),
            isTablet && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$ffad026de847a971$var$buttonContainerStyles,
                    isOpened && $24c02ea0e14dbe4f$var$$ffad026de847a971$var$buttonContainerOpenStyles,
                    !isOpened && $24c02ea0e14dbe4f$var$$ffad026de847a971$var$buttonContainerClosedStyles,
                    $24c02ea0e14dbe4f$var$$ffad026de847a971$var$buttonContainerMobileStyles
                ],
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                        css: [
                            $24c02ea0e14dbe4f$var$$ffad026de847a971$var$toggleButtonStyles,
                            $24c02ea0e14dbe4f$var$$ffad026de847a971$var$toggleButtonMobileStyles
                        ],
                        onClick: toggleLessons,
                        "data-testid": "toggle-lessons-button-mobile",
                        children: [
                            isOpened ? "Hide lessons" : "Show lessons",
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                size: "small",
                                type: isOpened ? "chevron-up" : "chevron-down",
                                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand")
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                        css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$continueButtonStyles,
                        href: course.href,
                        onClick: handleButtonClick,
                        "data-testid": "tablet-course-button",
                        children: getButtonText(course.courseStatus)
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    alignItems: "flex-start",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    alignSelf: "stretch",
    minHeight: "120px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    "&:hover a": {
        opacity: 1
    },
    "@media (max-width: 343px)": {
        minHeight: "148px",
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")}`,
        gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
    }
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$progressBadgeContainerStyles = (0, $74Zh5.css)({
    width: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.500"),
    height: "41px",
    flexShrink: 0
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$customProgressBadgeStyles = (0, $74Zh5.css)({
    width: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.500"),
    height: "41px"
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$imageBadgeContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$imageStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "50%"
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$completedBadgeContainerStyles = (0, $74Zh5.css)({
    position: "relative",
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$completedImageStyles = (0, $74Zh5.css)({
    opacity: 0.5,
    filter: "grayscale(100%)"
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$checkmarkOverlayStyles = (0, $74Zh5.css)({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$checkmarkIconStyles = (0, $74Zh5.css)({
    width: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    height: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$contentContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    marginRight: "auto",
    flex: 1,
    overflow: "hidden",
    minWidth: 0,
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$topContentStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
    minWidth: 0,
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$durationTitleContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    flex: 1,
    overflow: "hidden",
    minWidth: 0,
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$titleStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Charlie Display",
    fontSize: "20px",
    fontStyle: "normal",
    margin: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    textDecoration: "none",
    cursor: "pointer",
    lineHeight: "28px",
    fontWeight: 600,
    width: "100%",
    minWidth: 0,
    display: "block",
    maxHeight: "56px",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    "&:hover": {
        textDecoration: "underline",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
    },
    "@media (max-width: 343px)": {
        fontSize: "16px",
        lineHeight: "24px",
        whiteSpace: "normal",
        overflow: "hidden",
        textOverflow: "ellipsis",
        wordBreak: "break-word",
        overflowWrap: "break-word",
        maxHeight: "48px"
    }
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$startCourseButtonStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
    fontFamily: "Charlie Text",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`,
    display: "flex",
    alignItems: "center",
    opacity: 0,
    transition: "opacity 0.2s ease",
    textDecoration: "none",
    "&:hover": {
        textDecoration: "underline",
        textUnderlineOffset: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand")
    },
    "&:visited": {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand")
    }
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$subTitleStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    margin: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    width: "100%",
    minWidth: 0,
    maxHeight: "40px",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    "@media (max-width: 343px)": {
        lineHeight: "22px",
        whiteSpace: "normal",
        overflow: "hidden",
        textOverflow: "ellipsis",
        wordBreak: "break-word",
        overflowWrap: "break-word",
        maxHeight: "44px"
    }
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$durationTextStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "Charlie Text",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px",
    textTransform: "uppercase",
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$buttonContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    alignSelf: "stretch",
    borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")}`,
    "@media (max-width: 343px)": {
        gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")}`
    }
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$toggleButtonStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
    fontFamily: "Charlie Text",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.0"),
    display: "flex",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
    "&:hover": {
        textDecoration: "underline",
        textUnderlineOffset: "4px"
    }
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$toggleButtonMobileStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
    textAlign: "center",
    fontFamily: "Charlie Text",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px"
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$buttonContainerOpenStyles = (0, $74Zh5.css)({
    borderBottom: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$wrapperStyles = (0, $74Zh5.css)({
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    overflow: "hidden",
    maxWidth: "100%",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input")
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$wrapperClosedStyles = (0, $74Zh5.css)({
    borderRadius: "8px"
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$wrapperOpenStyles = (0, $74Zh5.css)({
    borderRadius: "8px",
    "& > div:last-child": {
        borderRadius: "0 0 8px 8px"
    }
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$lessonsContentWrapperStyles = (0, $74Zh5.css)({
    overflow: "hidden",
    borderRadius: "0 0 8px 8px !important",
    backgroundColor: "#FFFFFF",
    "& > div": {
        borderRadius: "0 0 8px 8px !important"
    },
    "& > div > div:last-child": {
        borderRadius: "0 0 8px 8px !important"
    }
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$lessonContentWrapperMobileStyles = (0, $74Zh5.css)({
    borderRadius: "0 !important",
    "& > div": {
        borderRadius: "0 !important"
    },
    "& > div > div:last-child": {
        borderRadius: "0 !important"
    }
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$completedCourseStyles = (0, $74Zh5.css)({
    borderLeft: `4px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.success")}`
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$buttonContainerClosedStyles = (0, $74Zh5.css)({
    justifyContent: "space-between"
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$buttonContainerMobileStyles = (0, $74Zh5.css)({
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    justifyContent: "space-between"
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$continueButtonStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"),
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.brand.bold"),
    fontFamily: "Charlie Text",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    height: "32px",
    borderRadius: "4px",
    border: "none",
    cursor: "pointer",
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.brand.bold.hovered"),
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"),
        textDecoration: "none"
    },
    "&:active": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.brand.bold.pressed")
    }
});
var $24c02ea0e14dbe4f$var$$0f989458047e435a$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$0f989458047e435a$exports, "InformationCardState", ()=>$24c02ea0e14dbe4f$export$cbadcd18ba5a3835);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$0f989458047e435a$exports, "InformationCard", ()=>$24c02ea0e14dbe4f$export$5a1fe75c0326c1f3);
var $24c02ea0e14dbe4f$var$$a7b3e1c0391fddac$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a7b3e1c0391fddac$exports, "LearningControlPanel", ()=>$24c02ea0e14dbe4f$export$b0db8dac2b423604);
const $24c02ea0e14dbe4f$export$b0db8dac2b423604 = ({ state: state = $24c02ea0e14dbe4f$export$cbadcd18ba5a3835.DEFAULT, isSaved: isSaved, onSave: onSave, urlToShare: urlToShare, contentType: contentType, onClick: onClick, ctaSlot: ctaSlot })=>{
    const isCourse = contentType === $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.COURSE;
    const buttonLabel = isCourse ? "course" : "learning path";
    const width = $24c02ea0e14dbe4f$export$4616d33c54ae5baf();
    const TABLET_WIDTH = 920;
    const handleOnClick = (event)=>{
        if (onClick) {
            event?.preventDefault();
            onClick();
        }
    };
    const ButtonStateProps = {
        [$24c02ea0e14dbe4f$export$cbadcd18ba5a3835.LOADING]: {
            label: "",
            isLoading: true,
            fullWidth: true
        },
        [$24c02ea0e14dbe4f$export$cbadcd18ba5a3835.DEFAULT]: {
            label: `Start ${buttonLabel}`,
            appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
            fullWidth: true
        },
        [$24c02ea0e14dbe4f$export$cbadcd18ba5a3835.IN_PROGRESS]: {
            label: `Continue ${buttonLabel}`,
            appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
            fullWidth: true
        },
        [$24c02ea0e14dbe4f$export$cbadcd18ba5a3835.FINISHED]: {
            label: `Review ${buttonLabel}`,
            appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.SECONDARY,
            fullWidth: true
        }
    };
    const handleOnSave = ()=>{
        if (onSave) onSave();
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "control-panel-card",
        css: $24c02ea0e14dbe4f$var$$a7b3e1c0391fddac$var$learningControlPanelStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$a7b3e1c0391fddac$var$iconButtonsContainerStyles,
                children: [
                    onSave && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                        iconColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.subtle"),
                        label: "",
                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON,
                        size: $24c02ea0e14dbe4f$export$5dd2748b7940a2a0.MEDIUM,
                        iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: isSaved ? "bookmark-filled" : "bookmark"
                        }),
                        onClick: handleOnSave
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$477c64ffaba52edf, {
                        urlToShare: urlToShare,
                        alignToTop: width <= TABLET_WIDTH,
                        fullWidth: true
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": "control-panel-cta-button",
                css: $24c02ea0e14dbe4f$var$$a7b3e1c0391fddac$var$statusButtonContainerStyles,
                children: [
                    state === $24c02ea0e14dbe4f$export$cbadcd18ba5a3835.LOADING && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                        ...ButtonStateProps[$24c02ea0e14dbe4f$export$cbadcd18ba5a3835.LOADING]
                    }),
                    state === $24c02ea0e14dbe4f$export$cbadcd18ba5a3835.DEFAULT && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                        onClick: handleOnClick,
                        ...ButtonStateProps[$24c02ea0e14dbe4f$export$cbadcd18ba5a3835.DEFAULT]
                    }),
                    state === $24c02ea0e14dbe4f$export$cbadcd18ba5a3835.IN_PROGRESS && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                        onClick: handleOnClick,
                        ...ButtonStateProps[$24c02ea0e14dbe4f$export$cbadcd18ba5a3835.IN_PROGRESS]
                    }),
                    state === $24c02ea0e14dbe4f$export$cbadcd18ba5a3835.FINISHED && (ctaSlot ?? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                        onClick: handleOnClick,
                        ...ButtonStateProps[$24c02ea0e14dbe4f$export$cbadcd18ba5a3835.FINISHED]
                    }))
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$a7b3e1c0391fddac$var$learningControlPanelStyles = (0, $74Zh5.css)({
    position: "relative",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "8px",
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    zIndex: 2,
    borderLeft: "none",
    borderRight: "none",
    "@media (max-width: 920px)": {
        borderBottom: "none"
    }
});
const $24c02ea0e14dbe4f$var$$a7b3e1c0391fddac$var$iconButtonsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    '[id*="icon-button"]': {
        width: "38px",
        height: "38px",
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral"),
        ":hover": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral.hovered")
        }
    }
});
const $24c02ea0e14dbe4f$var$$a7b3e1c0391fddac$var$statusButtonContainerStyles = (0, $74Zh5.css)({
    flex: 1,
    width: "100%",
    a: {
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`
    },
    button: {
        width: "100%",
        height: "38px"
    }
});
let $24c02ea0e14dbe4f$export$cbadcd18ba5a3835;
(function(InformationCardState) {
    InformationCardState["LOADING"] = "loading";
    InformationCardState["DEFAULT"] = "default";
    InformationCardState["IN_PROGRESS"] = "in_progress";
    InformationCardState["FINISHED"] = "finished";
})($24c02ea0e14dbe4f$export$cbadcd18ba5a3835 || ($24c02ea0e14dbe4f$export$cbadcd18ba5a3835 = {}));
const $24c02ea0e14dbe4f$export$5a1fe75c0326c1f3 = ({ contentType: contentType, video: video, badge: badge, progress: progress, duration: duration, description: description, title: title, urlToShare: urlToShare, cardState: cardState, isSaved: isSaved, onSave: onSave, onClick: onClick, ctaSlot: ctaSlot })=>{
    const isCourse = contentType === $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.COURSE;
    const defaultTitle = isCourse ? "After this course, you'll be able to:" : "This learning path is for:";
    const displayTitle = title ?? defaultTitle;
    const titleColor = isCourse ? (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.accent.blue") : (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.accent.lime");
    const isCompleted = progress === 100;
    const shouldShowBadge = isCourse && badge && !video;
    const shouldShowVideo = contentType === $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.LEARNING_PATH && video && !badge;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "information-card",
        css: [
            $24c02ea0e14dbe4f$var$$0f989458047e435a$var$informationCardStyles,
            isCourse ? $24c02ea0e14dbe4f$var$$0f989458047e435a$var$courseBorderStyles : $24c02ea0e14dbe4f$var$$0f989458047e435a$var$learningPathBorderStyles,
            shouldShowVideo && (0, $74Zh5.css)({
                borderTop: "none"
            })
        ],
        children: [
            shouldShowBadge && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$0f989458047e435a$var$badgeContainerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$0f989458047e435a$var$badgeStyles,
                    style: {
                        backgroundImage: `url(${badge})`
                    }
                })
            }),
            shouldShowVideo && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$0f989458047e435a$var$videoContainerStyles,
                children: video
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": "information-card-top",
                css: [
                    $24c02ea0e14dbe4f$var$$0f989458047e435a$var$informationCardContainerStyles,
                    (0, $74Zh5.css)({
                        marginTop: shouldShowBadge ? (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250") : "0px"
                    })
                ],
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                        level: 5,
                        color: titleColor,
                        children: displayTitle
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$0f989458047e435a$var$descriptionStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                            size: "small",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
                            children: description
                        })
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": "duration-progress-container",
                css: [
                    $24c02ea0e14dbe4f$var$$0f989458047e435a$var$informationCardContainerStyles,
                    $24c02ea0e14dbe4f$var$$0f989458047e435a$var$durationProgressContainerStyles
                ],
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        "data-testid": "duration-info",
                        css: $24c02ea0e14dbe4f$var$$0f989458047e435a$var$durationContainerStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                css: $24c02ea0e14dbe4f$var$$0f989458047e435a$var$spanStyles,
                                children: "Duration"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                                label: duration
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        "data-testid": "progress-info",
                        css: $24c02ea0e14dbe4f$var$$0f989458047e435a$var$progressContainerStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$0f989458047e435a$var$progressPercentageStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                        css: $24c02ea0e14dbe4f$var$$0f989458047e435a$var$spanStyles,
                                        children: "Progress "
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                        css: [
                                            $24c02ea0e14dbe4f$var$$0f989458047e435a$var$percentageStyles,
                                            isCompleted && (0, $74Zh5.css)({
                                                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.success")
                                            })
                                        ],
                                        children: isCompleted ? "Completed" : `${progress}%`
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$c17561cb55d4db30, {
                                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.success"),
                                progress: progress
                            })
                        ]
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$0f989458047e435a$var$controlPanelContainerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$b0db8dac2b423604, {
                    onClick: onClick,
                    isSaved: isSaved,
                    onSave: onSave,
                    state: cardState,
                    urlToShare: urlToShare,
                    contentType: contentType,
                    ctaSlot: ctaSlot
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$informationCardStyles = (0, $74Zh5.css)({
    position: "relative",
    width: "100%",
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    borderBottom: "unset",
    borderRadius: "8px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    "@media (max-width: 965px)": {
        borderBottom: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
        boxShadow: "unset"
    }
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$courseBorderStyles = (0, $74Zh5.css)({
    borderTop: `8px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.accent.blue")}`
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$learningPathBorderStyles = (0, $74Zh5.css)({
    borderTop: "8px solid #6A9A23"
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$badgeContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    border: `4px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.accent.blue")}`,
    left: "50%",
    top: "0%",
    transform: "translate(-50%, -60%)",
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    zIndex: 1
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$videoContainerStyles = (0, $74Zh5.css)({
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    ".plyr": {
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px"
    }
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$badgeStyles = (0, $74Zh5.css)({
    width: "35px",
    height: "35px",
    borderRadius: "50%",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat"
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$informationCardContainerStyles = (0, $74Zh5.css)({
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$descriptionStyles = (0, $74Zh5.css)({
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    color: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")} !important`,
    fontFamily: "Inter !important",
    fontSize: "14px !important",
    fontWeight: "400 !important",
    lineHeight: "22px !important",
    div: {
        paddingBottom: "0 !important",
        display: "flex !important",
        "@media (max-width: 920px)": {
            display: "flex !important"
        }
    },
    "span, p, li": {
        color: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")} !important`,
        fontFamily: "Inter !important",
        fontSize: "14px !important",
        fontWeight: "400 !important",
        lineHeight: "22px !important"
    },
    li: {
        marginBottom: "6px !important"
    },
    "li:last-child": {
        marginBottom: "0 !important"
    }
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$durationProgressContainerStyles = (0, $74Zh5.css)({
    borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$durationContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$spanStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    fontWeight: "700",
    lineHeight: "20px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    textTransform: "uppercase"
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$percentageStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$progressContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$progressPercentageStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$controlPanelContainerStyles = (0, $74Zh5.css)({
    "@media (max-width: 965px)": {
        display: "none"
    }
});
var $24c02ea0e14dbe4f$var$$ffc638203e092686$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$ffc638203e092686$exports, "ContentVersioningDialog", ()=>$24c02ea0e14dbe4f$export$3a7bdc050aa55c54);
const $24c02ea0e14dbe4f$export$3a7bdc050aa55c54 = ({ resourceTitle: resourceTitle, subtitle: subtitle, notifications: notifications, onResourceLinkClick: onResourceLinkClick, closeModal: closeModal })=>{
    const handleDismiss = (e)=>{
        e.preventDefault();
        closeModal();
    };
    const handleResourceClick = (e, resourceLink)=>{
        e.preventDefault();
        onResourceLinkClick(resourceLink);
    };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $73c4314b1cf0d4b0$export$2e2bcd8739ae039), {
        onClose: closeModal,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            "data-testid": "content-versioning-dialog",
            css: $24c02ea0e14dbe4f$var$$ffc638203e092686$var$containerStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$ffc638203e092686$var$crossIconContainerStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                        label: "",
                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON,
                        iconType: "cross",
                        iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: "cross",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                        }),
                        onClick: handleDismiss
                    })
                }),
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    children: [
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            "data-testid": "dialog-title",
                            css: $24c02ea0e14dbe4f$var$$ffc638203e092686$var$dialogTitleStyles,
                            children: [
                                "Update to ",
                                resourceTitle
                            ]
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            "data-testid": "dialog-subtitle",
                            css: $24c02ea0e14dbe4f$var$$ffc638203e092686$var$dialogSubtitleStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                size: "small",
                                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
                                children: subtitle
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
                                    children: "Summary of changes:"
                                }),
                                !!notifications.length && notifications.map((notification)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        css: $24c02ea0e14dbe4f$var$$ffc638203e092686$var$notificationContainerStyles,
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                                children: [
                                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                        "data-testid": "notification-title",
                                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                                            children: notification.title
                                                        })
                                                    }),
                                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                                        css: $24c02ea0e14dbe4f$var$$ffc638203e092686$var$notificationDateStyles,
                                                        children: notification.date
                                                    })
                                                ]
                                            }),
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: $24c02ea0e14dbe4f$var$$ffc638203e092686$var$notificationDescriptionContainerStyles,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                                    size: "small",
                                                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle"),
                                                    children: notification.description
                                                })
                                            }),
                                            notification.contentType === $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.LESSON && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: $24c02ea0e14dbe4f$var$$ffc638203e092686$var$linkContainerStyles,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a6c7ac8248d6e38a, {
                                                    target: "_blank",
                                                    label: "View changes",
                                                    link: notification.resourceLink,
                                                    icon: "arrow-right",
                                                    onClick: (e)=>handleResourceClick(e, notification.resourceLink)
                                                })
                                            })
                                        ]
                                    }, notification.id))
                            ]
                        })
                    ]
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$ffc638203e092686$var$buttonContainerStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                        label: "Dismiss",
                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                        onClick: handleDismiss
                    })
                })
            ]
        })
    });
};
const $24c02ea0e14dbe4f$var$$ffc638203e092686$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    borderRadius: "8px"
});
const $24c02ea0e14dbe4f$var$$ffc638203e092686$var$crossIconContainerStyles = (0, $74Zh5.css)({
    alignSelf: "flex-end",
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
});
const $24c02ea0e14dbe4f$var$$ffc638203e092686$var$dialogTitleStyles = (0, $74Zh5.css)({
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "32px",
    textAlign: "left"
});
const $24c02ea0e14dbe4f$var$$ffc638203e092686$var$dialogSubtitleStyles = (0, $74Zh5.css)({
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
});
const $24c02ea0e14dbe4f$var$$ffc638203e092686$var$notificationContainerStyles = (0, $74Zh5.css)({
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")}`,
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    borderRadius: "4px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    borderLeft: `4px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.blue.subtlest.pressed")}`
});
const $24c02ea0e14dbe4f$var$$ffc638203e092686$var$buttonContainerStyles = (0, $74Zh5.css)({
    alignSelf: "flex-end",
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400"),
    a: {
        fontFamily: "SF Pro, sans-serif",
        fontSize: "14px",
        fontWeight: 500,
        paddingTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.075"),
        paddingBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.075")
    }
});
const $24c02ea0e14dbe4f$var$$ffc638203e092686$var$notificationDateStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    lineHeight: "18px"
});
const $24c02ea0e14dbe4f$var$$ffc638203e092686$var$notificationDescriptionContainerStyles = (0, $74Zh5.css)({
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
});
const $24c02ea0e14dbe4f$var$$ffc638203e092686$var$linkContainerStyles = (0, $74Zh5.css)({
    a: {
        "&:hover": {
            textDecoration: "none"
        }
    }
});
var $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$4dfe37aba1865d88$exports, "CustomerInfoForm", ()=>$24c02ea0e14dbe4f$export$6415ce2f4ef17e20);
const $24c02ea0e14dbe4f$var$$292473fda2395210$export$1d1c4391ecac81e8 = async ()=>{
    const result = await fetch(`https://www.atlassian.com/hamlet/1.0/public/country/taas/all`);
    if (!result.ok) throw Error("Unable to fetch countries");
    return (await result.json()).countryList;
};
const $24c02ea0e14dbe4f$var$$292473fda2395210$export$2bc3cba6f94d7400 = async (isoCountryCode)=>{
    const result = await fetch(`https://www.atlassian.com/hamlet/1.0/public/country/taas/findByIso/${isoCountryCode}`);
    if (!result.ok) throw Error("Unable to fetch states");
    return result.json();
};
const $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$rowStyles = (0, $74Zh5.css)({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
});
const $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$fieldBlock = (0, $74Zh5.css)({
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
});
const $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$selectContainer = (0, $74Zh5.css)({
    maxWidth: "420px"
});
const $24c02ea0e14dbe4f$export$6415ce2f4ef17e20 = ({ onSubmit: onSubmit })=>{
    const [countries, setCountries] = (0, $5FkrB.useState)([]);
    const [selectedCountry, setSelectedCountry] = (0, $5FkrB.useState)(null);
    const [states, setStates] = (0, $5FkrB.useState)([]);
    (0, $5FkrB.useEffect)(()=>{
        let mounted = true;
        (async ()=>{
            try {
                const list = await $24c02ea0e14dbe4f$var$$292473fda2395210$export$1d1c4391ecac81e8();
                if (!mounted) return;
                setCountries(list);
                const us = list.find((c)=>c.isoCountryCode === "US" || c.countryIsoCode === "US" || c.displayName === "United States");
                if (us) setSelectedCountry(us);
            } catch  {
            // ignore network errors in Storybook/local environments
            }
        })();
        return ()=>{
            mounted = false;
        };
    }, []);
    (0, $5FkrB.useEffect)(()=>{
        let mounted = true;
        (async ()=>{
            if (!selectedCountry) {
                setStates([]);
                return;
            }
            if (selectedCountry.states && selectedCountry.states.length) {
                setStates(selectedCountry.states);
                return;
            }
            try {
                const detailed = await $24c02ea0e14dbe4f$var$$292473fda2395210$export$2bc3cba6f94d7400(selectedCountry.isoCountryCode || selectedCountry.countryIsoCode);
                if (!mounted) return;
                setStates(detailed.states || []);
            } catch  {
                setStates([]);
            }
        })();
        return ()=>{
            mounted = false;
        };
    }, [
        selectedCountry
    ]);
    const countryOptions = (0, $5FkrB.useMemo)(()=>countries.map((c)=>({
                label: c.displayName || c.countryIsoCode,
                value: c.isoCountryCode || c.countryIsoCode,
                data: c
            })), [
        countries
    ]);
    const stateOptions = (0, $5FkrB.useMemo)(()=>states.map((s)=>({
                label: s.name,
                value: s.code
            })), [
        states
    ]);
    const selectedCountryOption = (0, $5FkrB.useMemo)(()=>{
        if (!selectedCountry) return null;
        return {
            label: selectedCountry.displayName || selectedCountry.countryIsoCode,
            value: selectedCountry.isoCountryCode || selectedCountry.countryIsoCode,
            data: selectedCountry
        };
    }, [
        selectedCountry
    ]);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $916dd591feb93e13$export$2e2bcd8739ae039), {
        onSubmit: onSubmit,
        children: ({ formProps: formProps })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("form", {
                ...formProps,
                noValidate: true,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: (0, $74Zh5.css)({
                            marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250")
                        }),
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                            level: 4,
                            children: "Customer Information"
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: [
                            $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$rowStyles,
                            $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$fieldBlock
                        ],
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                        htmlFor: "first-name",
                                        children: "First Name"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                        name: "firstName",
                                        defaultValue: "",
                                        children: ({ fieldProps: fieldProps })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2c73285ae9390cec, {
                                                ...fieldProps,
                                                id: "first-name",
                                                placeholder: "First Name",
                                                required: true
                                            })
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                        htmlFor: "last-name",
                                        children: "Last Name"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                        name: "lastName",
                                        defaultValue: "",
                                        children: ({ fieldProps: fieldProps })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2c73285ae9390cec, {
                                                ...fieldProps,
                                                id: "last-name",
                                                placeholder: "Last Name",
                                                required: true
                                            })
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$fieldBlock,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                htmlFor: "address1",
                                children: "Address"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                name: "address1",
                                defaultValue: "",
                                children: ({ fieldProps: fieldProps })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2c73285ae9390cec, {
                                        ...fieldProps,
                                        id: "address1",
                                        placeholder: "Address",
                                        required: true
                                    })
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$fieldBlock,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                htmlFor: "address2",
                                children: "Address Line 2 (Optional)"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                name: "address2",
                                defaultValue: "",
                                children: ({ fieldProps: fieldProps })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2c73285ae9390cec, {
                                        ...fieldProps,
                                        id: "address2",
                                        placeholder: "Address Line 2"
                                    })
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$fieldBlock,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                htmlFor: "city",
                                children: "City"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                name: "city",
                                defaultValue: "",
                                children: ({ fieldProps: fieldProps })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2c73285ae9390cec, {
                                        ...fieldProps,
                                        id: "city",
                                        placeholder: "City",
                                        required: true
                                    })
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: [
                            $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$rowStyles,
                            $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$fieldBlock
                        ],
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                        htmlFor: "country",
                                        children: "Country"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                        name: "country",
                                        defaultValue: selectedCountryOption,
                                        children: ({ fieldProps: { value: value, onChange: onChange } })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$selectContainer,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $6b35e1e8c8ac06e7$export$2e2bcd8739ae039), {
                                                    inputId: "country",
                                                    options: countryOptions,
                                                    value: value || selectedCountryOption,
                                                    placeholder: "Select country",
                                                    onChange: (opt)=>{
                                                        onChange(opt);
                                                        const countryData = opt?.data;
                                                        setSelectedCountry(countryData || null);
                                                    }
                                                })
                                            })
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                        htmlFor: "state",
                                        children: "State"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                        name: "state",
                                        defaultValue: null,
                                        children: ({ fieldProps: { value: value, onChange: onChange } })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$selectContainer,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $6b35e1e8c8ac06e7$export$2e2bcd8739ae039), {
                                                    inputId: "state",
                                                    options: stateOptions,
                                                    value: value,
                                                    placeholder: "Select state",
                                                    isDisabled: !selectedCountry,
                                                    onChange: (opt)=>onChange(opt)
                                                })
                                            })
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: [
                            $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$rowStyles,
                            $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$fieldBlock
                        ],
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                        htmlFor: "postcode",
                                        children: "Zip Code"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                        name: "postcode",
                                        defaultValue: "",
                                        children: ({ fieldProps: fieldProps })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2c73285ae9390cec, {
                                                ...fieldProps,
                                                id: "postcode",
                                                placeholder: "Zip Code",
                                                required: true
                                            })
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                        htmlFor: "phone",
                                        children: "Phone Number"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                        name: "phone",
                                        defaultValue: "",
                                        children: ({ fieldProps: fieldProps })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2c73285ae9390cec, {
                                                ...fieldProps,
                                                id: "phone",
                                                placeholder: "Phone Number",
                                                type: "tel",
                                                required: true
                                            })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
    });
};
var $24c02ea0e14dbe4f$var$$556680ce820612ab$exports = {};
$24c02ea0e14dbe4f$var$$parcel$defineInteropFlag($24c02ea0e14dbe4f$var$$556680ce820612ab$exports);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$556680ce820612ab$exports, "PaymentInfoForm", ()=>$24c02ea0e14dbe4f$export$f950880927ff03db);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$556680ce820612ab$exports, "default", ()=>$24c02ea0e14dbe4f$var$$556680ce820612ab$export$2e2bcd8739ae039);
const $24c02ea0e14dbe4f$var$$556680ce820612ab$var$rowStyles = (0, $74Zh5.css)({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
});
const $24c02ea0e14dbe4f$var$$556680ce820612ab$var$fieldBlock = (0, $74Zh5.css)({
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
});
const $24c02ea0e14dbe4f$var$$556680ce820612ab$var$selectContainer = (0, $74Zh5.css)({
    maxWidth: "220px"
});
const $24c02ea0e14dbe4f$var$$556680ce820612ab$var$onlyDigits = (s)=>s.replace(/\D+/g, "");
const $24c02ea0e14dbe4f$var$$556680ce820612ab$var$formatCardNumber = (value)=>{
    const digits = $24c02ea0e14dbe4f$var$$556680ce820612ab$var$onlyDigits(value).slice(0, 19); // support up to 19 digits
    // group into 4s: 4-4-4-4-3
    const groups = [];
    for(let i = 0; i < digits.length; i += 4)groups.push(digits.slice(i, i + 4));
    return groups.join(" ").trim();
};
const $24c02ea0e14dbe4f$var$$556680ce820612ab$var$luhnCheck = (value)=>{
    const digits = $24c02ea0e14dbe4f$var$$556680ce820612ab$var$onlyDigits(value);
    if (digits.length < 12) return false;
    // basic length gate
    let sum = 0;
    let shouldDouble = false;
    for(let i = digits.length - 1; i >= 0; i--){
        let digit = parseInt(digits.charAt(i), 10);
        if (shouldDouble) {
            digit *= 2;
            if (digit > 9) digit -= 9;
        }
        sum += digit;
        shouldDouble = !shouldDouble;
    }
    return sum % 10 === 0;
};
const $24c02ea0e14dbe4f$var$$556680ce820612ab$var$isExpiryInPast = (month, year)=>{
    if (!month || !year) return false;
    // incomplete fields handled elsewhere
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1; // 1-12
    if (year < currentYear) return true;
    if (year === currentYear && month < currentMonth) return true;
    return false;
};
const $24c02ea0e14dbe4f$export$f950880927ff03db = ({ onSubmit: onSubmit })=>{
    const monthOptions = (0, $5FkrB.useMemo)(()=>Array.from({
            length: 12
        }, (_, i)=>{
            const m = i + 1;
            const label = m < 10 ? `0${m}` : `${m}`;
            return {
                label: label,
                value: m
            };
        }), []);
    const yearOptions = (0, $5FkrB.useMemo)(()=>{
        const now = new Date();
        const start = now.getFullYear();
        const end = start + 20;
        const arr = [];
        for(let y = start; y <= end; y++)arr.push({
            label: `${y}`,
            value: y
        });
        return arr;
    }, []);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $916dd591feb93e13$export$2e2bcd8739ae039), {
        onSubmit: (values)=>{
            // normalize values before submit
            const normalized = {
                ...values,
                cardNumber: $24c02ea0e14dbe4f$var$$556680ce820612ab$var$onlyDigits(values.cardNumber || "")
            };
            return onSubmit(normalized);
        },
        children: ({ formProps: formProps })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("form", {
                ...formProps,
                noValidate: true,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: (0, $74Zh5.css)({
                            marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250")
                        }),
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                            level: 4,
                            children: "Payment Information"
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$556680ce820612ab$var$fieldBlock,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                htmlFor: "cardholder-name",
                                children: "Name on card"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                name: "cardholderName",
                                defaultValue: "",
                                validate: (v)=>!v ? "Required" : undefined,
                                children: ({ fieldProps: fieldProps, error: error })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2c73285ae9390cec, {
                                                ...fieldProps,
                                                id: "cardholder-name",
                                                placeholder: "Name on card",
                                                required: true
                                            }),
                                            error && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                role: "alert",
                                                style: {
                                                    color: "#C9372C",
                                                    fontSize: 12
                                                },
                                                children: error
                                            })
                                        ]
                                    })
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$556680ce820612ab$var$fieldBlock,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                htmlFor: "card-number",
                                children: "Card number"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                name: "cardNumber",
                                defaultValue: "",
                                validate: (v)=>{
                                    if (!v) return "Required";
                                    const digits = $24c02ea0e14dbe4f$var$$556680ce820612ab$var$onlyDigits(v);
                                    if (digits.length < 12) return "Enter a valid card number";
                                    if (!$24c02ea0e14dbe4f$var$$556680ce820612ab$var$luhnCheck(v)) return "Enter a valid card number";
                                    return undefined;
                                },
                                children: ({ fieldProps: fieldProps, error: error })=>{
                                    const { onChange: onChange, value: value, ...rest } = fieldProps;
                                    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2c73285ae9390cec, {
                                                ...rest,
                                                id: "card-number",
                                                placeholder: "1234 5678 9012 3456",
                                                inputMode: "numeric",
                                                autoComplete: "cc-number",
                                                value: $24c02ea0e14dbe4f$var$$556680ce820612ab$var$formatCardNumber(String(value ?? "")),
                                                onChange: (e)=>onChange($24c02ea0e14dbe4f$var$$556680ce820612ab$var$formatCardNumber(e.target.value)),
                                                required: true
                                            }),
                                            error && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                role: "alert",
                                                style: {
                                                    color: "#C9372C",
                                                    fontSize: 12
                                                },
                                                children: error
                                            })
                                        ]
                                    });
                                }
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: [
                            $24c02ea0e14dbe4f$var$$556680ce820612ab$var$rowStyles,
                            $24c02ea0e14dbe4f$var$$556680ce820612ab$var$fieldBlock
                        ],
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                        htmlFor: "expiry-month",
                                        children: "Expiry month"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                        name: "expiryMonth",
                                        defaultValue: null,
                                        // @ts-expect-error - @atlaskit/form validate signature doesn't expose proper types for cross-field validation
                                        validate: (v, _, values)=>{
                                            if (!v) return "Required";
                                            const monthVal = v?.value;
                                            const yearVal = values?.expiryYear?.value;
                                            if (monthVal && yearVal && $24c02ea0e14dbe4f$var$$556680ce820612ab$var$isExpiryInPast(monthVal, yearVal)) return "Card has expired";
                                            return undefined;
                                        },
                                        children: ({ fieldProps: { value: value, onChange: onChange }, error: error })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                                                children: [
                                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                        css: $24c02ea0e14dbe4f$var$$556680ce820612ab$var$selectContainer,
                                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $6b35e1e8c8ac06e7$export$2e2bcd8739ae039), {
                                                            inputId: "expiry-month",
                                                            options: monthOptions,
                                                            value: value,
                                                            placeholder: "MM",
                                                            onChange: (opt)=>onChange(opt)
                                                        })
                                                    }),
                                                    error && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                        role: "alert",
                                                        style: {
                                                            color: "#C9372C",
                                                            fontSize: 12
                                                        },
                                                        children: error
                                                    })
                                                ]
                                            })
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                        htmlFor: "expiry-year",
                                        children: "Expiry year"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                        name: "expiryYear",
                                        defaultValue: null,
                                        // @ts-expect-error - @atlaskit/form validate signature doesn't expose proper types for cross-field validation
                                        validate: (v, _, values)=>{
                                            // cross validate month/year when both exist
                                            const monthVal = values?.expiryMonth?.value;
                                            const yearVal = v?.value;
                                            if (!v) return "Required";
                                            if (monthVal && yearVal && $24c02ea0e14dbe4f$var$$556680ce820612ab$var$isExpiryInPast(monthVal, yearVal)) return "Card has expired";
                                            return undefined;
                                        },
                                        children: ({ fieldProps: { value: value, onChange: onChange }, error: error })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                                                children: [
                                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                        css: $24c02ea0e14dbe4f$var$$556680ce820612ab$var$selectContainer,
                                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $6b35e1e8c8ac06e7$export$2e2bcd8739ae039), {
                                                            inputId: "expiry-year",
                                                            options: yearOptions,
                                                            value: value,
                                                            placeholder: "YYYY",
                                                            onChange: (opt)=>onChange(opt)
                                                        })
                                                    }),
                                                    error && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                        role: "alert",
                                                        style: {
                                                            color: "#C9372C",
                                                            fontSize: 12
                                                        },
                                                        children: error
                                                    })
                                                ]
                                            })
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$556680ce820612ab$var$fieldBlock,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                htmlFor: "cvc",
                                children: "Security code (CVC)"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                name: "cvc",
                                defaultValue: "",
                                validate: (v)=>{
                                    if (!v) return "Required";
                                    const digits = $24c02ea0e14dbe4f$var$$556680ce820612ab$var$onlyDigits(v);
                                    if (digits.length < 3 || digits.length > 4) return "Enter a valid CVC";
                                    return undefined;
                                },
                                children: ({ fieldProps: fieldProps, error: error })=>{
                                    const { onChange: onChange, value: value, ...rest } = fieldProps;
                                    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2c73285ae9390cec, {
                                                ...rest,
                                                id: "cvc",
                                                placeholder: "CVC",
                                                type: "password",
                                                inputMode: "numeric",
                                                autoComplete: "cc-csc",
                                                value: $24c02ea0e14dbe4f$var$$556680ce820612ab$var$onlyDigits(String(value ?? "")).slice(0, 4),
                                                onChange: (e)=>onChange($24c02ea0e14dbe4f$var$$556680ce820612ab$var$onlyDigits(e.target.value).slice(0, 4)),
                                                required: true
                                            }),
                                            error && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                role: "alert",
                                                style: {
                                                    color: "#C9372C",
                                                    fontSize: 12
                                                },
                                                children: error
                                            })
                                        ]
                                    });
                                }
                            })
                        ]
                    })
                ]
            })
    });
};
var $24c02ea0e14dbe4f$var$$556680ce820612ab$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$export$f950880927ff03db;
var $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$exports = {};
$24c02ea0e14dbe4f$var$$parcel$defineInteropFlag($24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$exports);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$exports, "CheckoutSummary", ()=>$24c02ea0e14dbe4f$export$fde280adb8350d09);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$exports, "default", ()=>$24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$export$2e2bcd8739ae039);
const $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$asCurrency = (amountInCents, currency = "USD")=>{
    try {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currency
        }).format(amountInCents / 100);
    } catch  {
        return `$${(amountInCents / 100).toFixed(2)}`;
    }
};
const $24c02ea0e14dbe4f$export$fde280adb8350d09 = ({ subtotal: subtotal, salesTax: salesTax, total: total, items: items, paymentMethod: paymentMethod, currency: currency = "USD" })=>{
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const itemCountText = (0, $5FkrB.useMemo)(()=>`${items.length} item${items.length === 1 ? "" : "s"}`, [
        items.length
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$containerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                level: 4,
                children: "Summary"
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$rowStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                        children: "Subtotal"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                        children: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$asCurrency(subtotal, currency)
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$rowStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                        children: "Sales Tax"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                        children: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$asCurrency(salesTax, currency)
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$dividerStyles
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$rowStyles,
                    (0, $74Zh5.css)({
                        marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
                    })
                ],
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                        level: 6,
                        children: "Total"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                        level: 6,
                        children: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$asCurrency(total, currency)
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$paymentMethodRowStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                        size: "small",
                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
                        children: [
                            "Payment Method: ",
                            paymentMethod
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                        size: "small",
                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
                        children: itemCountText
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$buttonRowStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                    label: "Review Purchase",
                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                    fullWidth: true,
                    size: $24c02ea0e14dbe4f$export$5dd2748b7940a2a0.LARGE,
                    onClick: ()=>setIsOpen(true)
                })
            }),
            isOpen && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $73c4314b1cf0d4b0$export$2e2bcd8739ae039), {
                onClose: ()=>setIsOpen(false),
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$modalContainerStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$modalHeaderStyles,
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                                    level: 3,
                                    children: "Review and Confirm"
                                }),
                                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
                                    children: [
                                        currency,
                                        " \u2022 ",
                                        paymentMethod
                                    ]
                                })
                            ]
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$modalSectionStyles,
                            children: items.map((item, idx)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                    css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$itemRowStyles,
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                            children: item.name
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                            children: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$asCurrency(item.price, currency)
                                        })
                                    ]
                                }, `${item.name}-${idx}`))
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$dividerStyles
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$modalTotalsStyles,
                            children: [
                                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                    css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$itemRowStyles,
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                            children: "Subtotal"
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                            children: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$asCurrency(subtotal, currency)
                                        })
                                    ]
                                }),
                                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                    css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$itemRowStyles,
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                            children: "Sales Tax"
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                            children: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$asCurrency(salesTax, currency)
                                        })
                                    ]
                                }),
                                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                    css: [
                                        $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$itemRowStyles,
                                        (0, $74Zh5.css)({
                                            marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
                                        })
                                    ],
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                                            level: 6,
                                            children: "Total"
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                                            level: 6,
                                            children: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$asCurrency(total, currency)
                                        })
                                    ]
                                })
                            ]
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$modalButtonRowStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                label: "Confirm Purchase",
                                appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                                onClick: ()=>setIsOpen(false)
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$containerStyles = (0, $74Zh5.css)({
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "8px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input")
});
const $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$rowStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$dividerStyles = (0, $74Zh5.css)({
    height: 1,
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border"),
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250")
});
const $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$paymentMethodRowStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$buttonRowStyles = (0, $74Zh5.css)({
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
});
const $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$modalContainerStyles = (0, $74Zh5.css)({
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "8px",
    minWidth: "560px"
});
const $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$modalHeaderStyles = (0, $74Zh5.css)({
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
});
const $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$modalSectionStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$itemRowStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$modalTotalsStyles = (0, $74Zh5.css)({
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250")
});
const $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$modalButtonRowStyles = (0, $74Zh5.css)({
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400"),
    display: "flex",
    justifyContent: "center"
});
var $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$export$fde280adb8350d09;
var $24c02ea0e14dbe4f$var$$2397677ef2f4ee69$exports = {};
$24c02ea0e14dbe4f$var$$parcel$defineInteropFlag($24c02ea0e14dbe4f$var$$2397677ef2f4ee69$exports);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$2397677ef2f4ee69$exports, "Orders", ()=>$24c02ea0e14dbe4f$export$ed0df17bf864fd7b);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$2397677ef2f4ee69$exports, "default", ()=>$24c02ea0e14dbe4f$var$$2397677ef2f4ee69$export$2e2bcd8739ae039);
const $24c02ea0e14dbe4f$var$$2397677ef2f4ee69$var$containerStyles = (0, $74Zh5.css)({
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "8px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input")
});
const $24c02ea0e14dbe4f$var$$2397677ef2f4ee69$var$headerStyles = (0, $74Zh5.css)({
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
});
const $24c02ea0e14dbe4f$var$$2397677ef2f4ee69$var$amountToUsd = (amount)=>{
    const dollars = (amount / 100).toFixed(2);
    return `USD $${dollars}`;
};
const $24c02ea0e14dbe4f$export$ed0df17bf864fd7b = ({ orders: orders })=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$2397677ef2f4ee69$var$containerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$2397677ef2f4ee69$var$headerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                    level: 4,
                    children: "Transactions"
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $1c9849e9ca2bf87c$export$2e2bcd8739ae039), {
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $46ca8edaccb96b62$export$2e2bcd8739ae039), {
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $017ea8a39e3f2896$export$2e2bcd8739ae039), {
                                width: "20%",
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
                                    children: "Date"
                                })
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $017ea8a39e3f2896$export$2e2bcd8739ae039), {
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
                                    children: "Purchase Info"
                                })
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $017ea8a39e3f2896$export$2e2bcd8739ae039), {
                                width: "20%",
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
                                    children: "Payment Method"
                                })
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $017ea8a39e3f2896$export$2e2bcd8739ae039), {
                                width: "20%",
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
                                    children: "Price"
                                })
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $722a9df093eb8cc5$export$2e2bcd8739ae039), {
                        children: orders.map((o)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $1df2a8a5055de686$export$2e2bcd8739ae039), {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $db2ca91e0d53ac06$export$9cf5b401f969f5e3), {
                                        children: o.date
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $db2ca91e0d53ac06$export$9cf5b401f969f5e3), {
                                        children: o.summary
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $db2ca91e0d53ac06$export$9cf5b401f969f5e3), {
                                        children: o.paymentMethod
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $db2ca91e0d53ac06$export$9cf5b401f969f5e3), {
                                        children: $24c02ea0e14dbe4f$var$$2397677ef2f4ee69$var$amountToUsd(o.totalAmount)
                                    })
                                ]
                            }, o.id))
                    })
                ]
            })
        ]
    });
};
var $24c02ea0e14dbe4f$var$$2397677ef2f4ee69$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$export$ed0df17bf864fd7b;
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$83fc18f8199a12ff$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$438c82700c218044$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$389dbaf1c04dd698$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$c18917e553fd2737$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$e018ab7ed2648ae8$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$81dd635d83decaee$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$c5616d3f1657fc84$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$eb6f767c51421421$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$915f5687b3b07750$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$579f9ef2424e0bd8$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$d559b1cc82536c49$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$3b9afd8fe4435353$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$050a30fc95775cfd$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$65703ff0bcd12648$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$8340d81aba797956$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$dbb9d5792c296a49$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$2cfa64583f556289$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$9c3f769544bb2079$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$3d76652bb6362040$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$764442aba3de2fce$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$77282b3961d82199$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$d8ee29df49af8811$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$27d686e47ff412fd$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$205ed41b47d90e33$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$5f9280667c666470$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$ec9b8ebbd21bd316$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$ffad026de847a971$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$0f989458047e435a$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$a7b3e1c0391fddac$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$ffc638203e092686$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$ed20910b93d89c3f$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$556680ce820612ab$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$2397677ef2f4ee69$exports);
var $24c02ea0e14dbe4f$var$$0cf4554ad00467b5$exports = {};
var $24c02ea0e14dbe4f$var$$a3d28c94a229f94e$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a3d28c94a229f94e$exports, "CommunityLogo", ()=>$24c02ea0e14dbe4f$export$311e5e9ca09eea69);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a3d28c94a229f94e$exports, "CommunityNavigation", ()=>$24c02ea0e14dbe4f$export$901cb8c9de2be2aa);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a3d28c94a229f94e$exports, "AnalyticsActivityType", ()=>$24c02ea0e14dbe4f$export$d778a884eb401313);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a3d28c94a229f94e$exports, "EventType", ()=>$24c02ea0e14dbe4f$export$3d7865934588d77e);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a3d28c94a229f94e$exports, "CommunityApp", ()=>$24c02ea0e14dbe4f$export$93d048dc21eb282a);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a3d28c94a229f94e$exports, "MenuItemWithAnalytics", ()=>$24c02ea0e14dbe4f$export$92905cc84b82619c);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a3d28c94a229f94e$exports, "APP_BUTTONS", ()=>$24c02ea0e14dbe4f$export$208c68d48dfc9a12);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a3d28c94a229f94e$exports, "getAppButtons", ()=>$24c02ea0e14dbe4f$export$67e61a6fa639f224);
const $24c02ea0e14dbe4f$export$311e5e9ca09eea69 = ({ subtitleHref: subtitleHref, analyticsInfo: analyticsInfo })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$5aa64ab1f07d6e00, {
        subtitleHref: subtitleHref,
        label: "Community homepage",
        logoSubtitle: "Community",
        analyticsInfo: analyticsInfo
    });
};
const $24c02ea0e14dbe4f$var$$a3d28c94a229f94e$var$renderAppButtons = (currentApp, subMenuContentByApp, isLoggedIn, analyticsInfo, forumsLoggedInRedirectHref, email, showNewMenu, appButtonHrefOverrides)=>{
    const loginState = isLoggedIn ? "loggedIn" : "loggedOut";
    return $24c02ea0e14dbe4f$export$67e61a6fa639f224(email).map((button)=>{
        const defaultHref = button.app === $24c02ea0e14dbe4f$export$93d048dc21eb282a.FORUMS && isLoggedIn && forumsLoggedInRedirectHref ? `${button.href[loginState]}${forumsLoggedInRedirectHref}` : button.href[loginState];
        const overriddenHref = appButtonHrefOverrides?.[button.app]?.[loginState];
        return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$b18dbc162161ec9c, {
            isSelected: button.app === currentApp,
            link: {
                text: button.label,
                href: overriddenHref ?? defaultHref,
                target: button.target
            },
            expandableBodyContent: subMenuContentByApp?.[button.app],
            destinationApp: button.app,
            analyticsInfo: analyticsInfo,
            showNewMenu: showNewMenu
        }, button.app);
    });
};
const $24c02ea0e14dbe4f$export$901cb8c9de2be2aa = ({ currentApp: currentApp, isLoggedIn: isLoggedIn, user: user, loginHref: loginHref, signupHref: signupHref, logoutHref: logoutHref, switchHref: switchHref, profileHref: profileHref, settingsHref: settingsHref, subMenuContentByApp: subMenuContentByApp, onAnalyticsSendEvent: onAnalyticsSendEvent, forumsLoggedInRedirectHref: forumsLoggedInRedirectHref, appButtonHrefOverrides: appButtonHrefOverrides, isSticky: isSticky = true, email: email, showNewMenu: showNewMenu = false })=>{
    const loginState = isLoggedIn ? "loggedIn" : "loggedOut";
    const homeHref = (0, $5FkrB.useMemo)(()=>$24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$d349399b473d7299[loginState], [
        loginState
    ]);
    const isMobileOrTablet = $24c02ea0e14dbe4f$export$32d5543ab307c01(`(max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`);
    const analyticsInfo = onAnalyticsSendEvent ? {
        currentApp: currentApp,
        isLoggedIn: isLoggedIn,
        isMobileOrTablet: isMobileOrTablet,
        onAnalyticsSendEvent: onAnalyticsSendEvent
    } : undefined;
    const leftItems = [
        ...$24c02ea0e14dbe4f$var$$a3d28c94a229f94e$var$renderAppButtons(currentApp, subMenuContentByApp, isLoggedIn, analyticsInfo, forumsLoggedInRedirectHref, email, showNewMenu, appButtonHrefOverrides)
    ];
    // Create logo item
    const logoItem = (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$311e5e9ca09eea69, {
        subtitleHref: homeHref,
        analyticsInfo: analyticsInfo
    }, "community-logo");
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$fddd19fbf4d591d8, {
        logoItem: logoItem,
        leftItems: leftItems,
        isLoggedIn: isLoggedIn,
        user: user,
        loginHref: loginHref,
        signupHref: signupHref,
        logoutHref: logoutHref,
        switchHref: switchHref,
        profileHref: profileHref ?? $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$132b2bf91782e62b,
        settingsHref: settingsHref ?? $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$b9cc8022ec117e91,
        onAnalyticsSendEvent: onAnalyticsSendEvent,
        isSticky: isSticky,
        showNewMenu: showNewMenu,
        currentApp: currentApp
    });
};
var $24c02ea0e14dbe4f$var$$976a3c76bc9fa9bc$exports = {};
var $24c02ea0e14dbe4f$var$$b0e23f9f192d2ea7$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$b0e23f9f192d2ea7$exports, "ForumFeedItem", ()=>$24c02ea0e14dbe4f$export$1074985837f1b2a5);
const $24c02ea0e14dbe4f$var$$c13069d48b7dab65$export$bbef7a8f2307e1f9 = ()=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.6668 8.00004C14.6668 11.6819 11.6821 14.6667 8.00016 14.6667C4.31826 14.6667 1.3335 11.6819 1.3335 8.00004C1.3335 4.31814 4.31826 1.33337 8.00016 1.33337C11.6821 1.33337 14.6668 4.31814 14.6668 8.00004ZM6.2551 7.37932C6.33643 7.41426 6.41 7.46505 6.47149 7.52872L7.33349 8.39072L9.52883 6.19539C9.59033 6.13171 9.66389 6.08093 9.74522 6.04599C9.82656 6.01105 9.91404 5.99266 10.0026 5.99189C10.0911 5.99112 10.1789 6.00799 10.2608 6.04151C10.3427 6.07503 10.4172 6.12453 10.4798 6.18712C10.5424 6.24972 10.5919 6.32415 10.6254 6.40608C10.6589 6.48802 10.6758 6.5758 10.675 6.66432C10.6742 6.75284 10.6558 6.84032 10.6209 6.92166C10.586 7.00299 10.5352 7.07656 10.4715 7.13805L7.80483 9.80472C7.67981 9.9297 7.51027 9.99991 7.33349 9.99991C7.15672 9.99991 6.98718 9.9297 6.86216 9.80472L5.52883 8.47139C5.46515 8.40989 5.41437 8.33633 5.37943 8.25499C5.34449 8.17365 5.3261 8.08617 5.32533 7.99765C5.32456 7.90913 5.34143 7.82135 5.37495 7.73942C5.40847 7.65749 5.45797 7.58305 5.52056 7.52046C5.58316 7.45786 5.65759 7.40836 5.73952 7.37484C5.82146 7.34132 5.90924 7.32445 5.99776 7.32522C6.08628 7.32599 6.17376 7.34438 6.2551 7.37932Z",
            fill: "#22A06B"
        })
    });
};
var $24c02ea0e14dbe4f$var$$fa9d4c58bb661680$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fa9d4c58bb661680$exports, "ForumFeedItemContentType", ()=>$24c02ea0e14dbe4f$export$96b2e747ae3de284);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fa9d4c58bb661680$exports, "ForumFeedItemCategoryType", ()=>$24c02ea0e14dbe4f$export$c6c284c40052569e);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fa9d4c58bb661680$exports, "ForumFeedItemStatus", ()=>$24c02ea0e14dbe4f$export$88a22e3eec02cfbe);
let $24c02ea0e14dbe4f$export$96b2e747ae3de284;
(function(ForumFeedItemContentType) {
    ForumFeedItemContentType["Question"] = "Question";
    ForumFeedItemContentType["Discussion"] = "Discussion";
    ForumFeedItemContentType["Article"] = "Article";
})($24c02ea0e14dbe4f$export$96b2e747ae3de284 || ($24c02ea0e14dbe4f$export$96b2e747ae3de284 = {}));
let $24c02ea0e14dbe4f$export$c6c284c40052569e;
(function(ForumFeedItemCategoryType) {
    ForumFeedItemCategoryType["Subject"] = "subject";
    ForumFeedItemCategoryType["App"] = "app";
    ForumFeedItemCategoryType["Group"] = "group";
})($24c02ea0e14dbe4f$export$c6c284c40052569e || ($24c02ea0e14dbe4f$export$c6c284c40052569e = {}));
let $24c02ea0e14dbe4f$export$88a22e3eec02cfbe;
(function(ForumFeedItemStatus) {
    ForumFeedItemStatus["AnswerNotAccepted"] = "Answered Not Accepted";
    ForumFeedItemStatus["UnAnswered"] = "Unanswered";
    ForumFeedItemStatus["AnsweredAccepted"] = "Answered Accepted";
})($24c02ea0e14dbe4f$export$88a22e3eec02cfbe || ($24c02ea0e14dbe4f$export$88a22e3eec02cfbe = {}));
const $24c02ea0e14dbe4f$var$$2248ded33c1cc26f$var$getMetricLabel = (value, singular, plural)=>value === 1 ? singular : plural;
const $24c02ea0e14dbe4f$var$$2248ded33c1cc26f$export$9e55f86bc7a20cd4 = ({ likes: likes, responses: responses, views: views, status: status, contentType: contentType })=>{
    const showAnswerText = ()=>{
        switch(status){
            case $24c02ea0e14dbe4f$export$88a22e3eec02cfbe.AnsweredAccepted:
                return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                    xcss: $24c02ea0e14dbe4f$var$$2248ded33c1cc26f$var$answerContainerStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$c13069d48b7dab65$export$bbef7a8f2307e1f9, {}),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                            size: "small",
                            weight: "semibold",
                            children: "ANSWER ACCEPTED"
                        })
                    ]
                });
            case $24c02ea0e14dbe4f$export$88a22e3eec02cfbe.AnswerNotAccepted:
                return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                    xcss: $24c02ea0e14dbe4f$var$$2248ded33c1cc26f$var$answerContainerStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                        size: "small",
                        weight: "semibold",
                        children: "ANSWERED"
                    })
                });
            default:
                return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                    xcss: $24c02ea0e14dbe4f$var$$2248ded33c1cc26f$var$answerContainerStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                        size: "small",
                        weight: "semibold",
                        children: "UNANSWERED"
                    })
                });
        }
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
        alignItems: "center",
        justifyContent: "space-between",
        gap: "space.200",
        wrap: "wrap",
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                alignItems: "center",
                gap: "space.150",
                wrap: "wrap",
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                        alignItems: "center",
                        gap: "space.075",
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d613dcd7cfbb1e58$exports))), {
                                label: "Likes"
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                                size: "medium",
                                children: [
                                    likes,
                                    " ",
                                    $24c02ea0e14dbe4f$var$$2248ded33c1cc26f$var$getMetricLabel(likes, "like", "likes")
                                ]
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                        alignItems: "center",
                        gap: "space.075",
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($0e561d53dcc9f631$exports))), {
                                label: "Responses"
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                                size: "medium",
                                children: [
                                    responses,
                                    " ",
                                    $24c02ea0e14dbe4f$var$$2248ded33c1cc26f$var$getMetricLabel(responses, "response", "responses")
                                ]
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                        alignItems: "center",
                        gap: "space.075",
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($59c4a893ce5f1bf5$exports))), {
                                label: "Views"
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                                size: "medium",
                                children: [
                                    views,
                                    " ",
                                    $24c02ea0e14dbe4f$var$$2248ded33c1cc26f$var$getMetricLabel(views, "view", "views")
                                ]
                            })
                        ]
                    })
                ]
            }),
            contentType === $24c02ea0e14dbe4f$export$96b2e747ae3de284.Question ? showAnswerText() : null
        ]
    });
};
const $24c02ea0e14dbe4f$var$$2248ded33c1cc26f$var$answerContainerStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    display: "inline-flex",
    alignItems: "center",
    gap: "space.075"
});
const $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$export$a6e7f421a5dba78a = (appName)=>{
    return appName.trim().replace(/[-_]+/g, " ").replace(/\s+/g, " ").split(" ").filter(Boolean).map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
};
const $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$var$normalizeProductKey = (product)=>{
    return product.trim().toLowerCase().replace(/[\s_]+/g, "-");
};
const $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$var$productLogoMap = {
    // Company
    atlassian: (0, $37844134dd17fb96$export$8a485e2e7ed91e8f),
    "atlassian-analytics": (0, $e5c28807f044a60a$export$c42ad8a0b925c762),
    analytics: (0, $e5c28807f044a60a$export$c42ad8a0b925c762),
    access: (0, $90b44dd97a49007a$export$a825993f361832f7),
    "atlassian-access": (0, $90b44dd97a49007a$export$a825993f361832f7),
    community: (0, $37844134dd17fb96$export$8a485e2e7ed91e8f),
    // Products
    atlas: (0, $e5c28807f044a60a$export$92c8767b874048d),
    focus: (0, $e5c28807f044a60a$export$1e02e7298035a77c),
    crowd: (0, $e5c28807f044a60a$export$eaf73f391f7103bd),
    bitbucket: (0, $e5c28807f044a60a$export$5fc1066e677788d4),
    compass: (0, $e5c28807f044a60a$export$f7857fe64d7161d9),
    confluence: (0, $e5c28807f044a60a$export$68f3db7f6af48bcb),
    guard: (0, $e5c28807f044a60a$export$3f95fcfdc25a741d),
    "atlassian-guard": (0, $e5c28807f044a60a$export$3f95fcfdc25a741d),
    jira: (0, $e5c28807f044a60a$export$c4b5b1f965d8b3eb),
    "jira-software": (0, $e5c28807f044a60a$export$c4b5b1f965d8b3eb),
    "jira-service-management": (0, $e5c28807f044a60a$export$3c6158790f5e01c4),
    "jira-service-desk": (0, $e5c28807f044a60a$export$3c6158790f5e01c4),
    jsm: (0, $e5c28807f044a60a$export$3c6158790f5e01c4),
    "jira-product-discovery": (0, $e5c28807f044a60a$export$21bfbeb62fdcce8d),
    jpd: (0, $e5c28807f044a60a$export$21bfbeb62fdcce8d),
    "jira-align": (0, $e5c28807f044a60a$export$407687b2dd89cc68),
    align: (0, $e5c28807f044a60a$export$407687b2dd89cc68),
    "jira-work-management": (0, $e5c28807f044a60a$export$c4b5b1f965d8b3eb),
    jwm: (0, $e5c28807f044a60a$export$c4b5b1f965d8b3eb),
    bamboo: (0, $e5c28807f044a60a$export$e812398311cab9a3),
    marketplace: (0, $722ae65b25b74a2f$export$94c87d39a54a1894),
    "atlassian-marketplace": (0, $722ae65b25b74a2f$export$94c87d39a54a1894),
    talent: (0, $e5c28807f044a60a$export$4b05688514531169),
    teams: (0, $e5c28807f044a60a$export$1bcbc9c337da86da),
    studio: (0, $e5c28807f044a60a$export$290a0f24614cde9f),
    projects: (0, $e5c28807f044a60a$export$5ed3e1bb3b04fc02),
    goals: (0, $e5c28807f044a60a$export$9eb74917ea768ed4),
    "atlassian-administration": (0, $e5c28807f044a60a$export$ef8e5f836dd989d3),
    "atlassian-admin": (0, $e5c28807f044a60a$export$ef8e5f836dd989d3),
    admin: (0, $e5c28807f044a60a$export$ef8e5f836dd989d3),
    assets: (0, $e5c28807f044a60a$export$d89497e7f33ca6f5),
    "rovo-dev": (0, $e5c28807f044a60a$export$8b784b3227531b3e),
    dx: (0, $e5c28807f044a60a$export$9951d02c2d848122),
    hub: (0, $e5c28807f044a60a$export$80b8b269d8b5014e),
    home: (0, $e5c28807f044a60a$export$92c8767b874048d),
    loom: (0, $e5c28807f044a60a$export$8d789f76fde3e05),
    opsgenie: (0, $e5c28807f044a60a$export$eeccc49dc7a12d9f),
    rovo: (0, $e5c28807f044a60a$export$e23ae35269442b4f),
    "rovo-atlassian-intelligence": (0, $e5c28807f044a60a$export$e23ae35269442b4f),
    statuspage: (0, $e5c28807f044a60a$export$f3f5aa321d88adf9),
    trello: (0, $e5c28807f044a60a$export$4384da9b8b140bf4),
    "customer-service-management": (0, $e5c28807f044a60a$export$6da5aa77c402ba0f)
};
const $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$var$dataCenterProductLogoMap = {
    "jira-service-management": (0, $e5c28807f044a60a$export$65fae0eaf343f2ca),
    jira: (0, $e5c28807f044a60a$export$f8455b5667a3ee0c),
    confluence: (0, $e5c28807f044a60a$export$53305f1f2855d3be),
    bitbucket: (0, $e5c28807f044a60a$export$d3ab16bbf4f954ee)
};
const $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$export$39846976078a8f0d = (product, props, hostingType)=>{
    const key = $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$var$normalizeProductKey(product);
    let Logo;
    if (hostingType === "data-center" && key in $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$var$dataCenterProductLogoMap) Logo = $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$var$dataCenterProductLogoMap[key];
    else Logo = $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$var$productLogoMap[key];
    if (!Logo) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $37844134dd17fb96$export$8a485e2e7ed91e8f), {
        size: "xsmall",
        ...props,
        shouldUseNewLogoDesign: true,
        appearance: "brand"
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)(Logo, {
        size: "xsmall",
        ...props,
        shouldUseNewLogoDesign: true,
        appearance: "brand"
    });
};
const $24c02ea0e14dbe4f$var$$eb5a017dbcef9100$export$b8c4492f94f00c1c = {
    color: "color.text",
    cursor: "pointer",
    position: "relative",
    textDecoration: "none",
    fontSize: "14px"
};
const $24c02ea0e14dbe4f$var$$eb5a017dbcef9100$export$37cc822878118153 = {
    textDecoration: "none",
    ":hover": {
        textDecoration: "none",
        color: "color.text"
    }
};
const $24c02ea0e14dbe4f$var$$eb5a017dbcef9100$export$ef0b806eff7008c6 = {
    textDecoration: "none",
    color: "color.text",
    ":hover": {
        color: "color.text",
        textDecoration: "none"
    },
    ":visited": {
        color: "color.text",
        textDecoration: "none"
    }
};
const $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$anchorResetStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)($24c02ea0e14dbe4f$var$$eb5a017dbcef9100$export$ef0b806eff7008c6);
const $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$anchorDetailStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)($24c02ea0e14dbe4f$var$$eb5a017dbcef9100$export$b8c4492f94f00c1c);
const $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$hoverUnderlineStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)($24c02ea0e14dbe4f$var$$eb5a017dbcef9100$export$37cc822878118153);
const $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$getContentTypeBackground = (contentType)=>{
    switch(contentType){
        case $24c02ea0e14dbe4f$export$96b2e747ae3de284.Question:
            return (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.warning.pressed");
        case $24c02ea0e14dbe4f$export$96b2e747ae3de284.Discussion:
            return (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.discovery.pressed");
        case $24c02ea0e14dbe4f$export$96b2e747ae3de284.Article:
            return (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.information.pressed");
    }
};
const $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$renderProductLogo = (name, hostingType)=>$24c02ea0e14dbe4f$var$$027dbfbbc85481a9$export$39846976078a8f0d(name, {
        size: "xsmall"
    }, hostingType);
const $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$export$7d7346e428084a7e = ({ contentType: contentType, isFeatured: isFeatured, categoryName: categoryName, categoryType: categoryType, categoryHref: categoryHref, menuComponent: menuComponent, hostingType: hostingType, isNew: isNew })=>{
    const categoryShown = ()=>{
        switch(categoryType){
            case $24c02ea0e14dbe4f$export$c6c284c40052569e.App:
                return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                    gap: "space.075",
                    alignItems: "center",
                    children: [
                        $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$renderProductLogo(categoryName, hostingType),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                            color: "color.text",
                            size: "medium",
                            children: $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$export$a6e7f421a5dba78a(categoryName)
                        })
                    ]
                });
            case $24c02ea0e14dbe4f$export$c6c284c40052569e.Group:
                return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                    gap: "space.075",
                    alignItems: "center",
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($be2e2d4d6fde7b33$exports))), {
                            label: "group"
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                            color: "color.text",
                            size: "medium",
                            children: $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$export$a6e7f421a5dba78a(categoryName)
                        })
                    ]
                });
            case $24c02ea0e14dbe4f$export$c6c284c40052569e.Subject:
                return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                    color: "color.text",
                    size: "medium",
                    children: $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$export$a6e7f421a5dba78a(categoryName)
                });
        }
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
        justifyContent: "space-between",
        alignItems: "stretch",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                label: contentType,
                isTall: true,
                backgroundColor: $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$getContentTypeBackground(contentType),
                borderColor: "transparent"
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                gap: "space.150",
                alignItems: "center",
                children: [
                    isNew && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                        label: "New",
                        isTall: true,
                        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
                        borderColor: "#C97CF4"
                    }),
                    isFeatured && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                        label: "Featured",
                        isTall: true,
                        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
                        borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.accent.blue")
                    }),
                    categoryHref ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                        as: "a",
                        href: categoryHref,
                        xcss: [
                            $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$anchorDetailStyles,
                            $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$anchorResetStyles,
                            $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$hoverUnderlineStyles,
                            $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$categoryLinkStyles
                        ],
                        children: categoryShown()
                    }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                        xcss: $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$categoryLinkStyles,
                        children: categoryShown()
                    }),
                    menuComponent
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$categoryLinkStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    display: "inline-flex",
    alignItems: "center"
});
const $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$var$anchorResetStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)($24c02ea0e14dbe4f$var$$eb5a017dbcef9100$export$ef0b806eff7008c6);
const $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$var$anchorDetailStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)($24c02ea0e14dbe4f$var$$eb5a017dbcef9100$export$b8c4492f94f00c1c);
const $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$var$hoverUnderlineStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)($24c02ea0e14dbe4f$var$$eb5a017dbcef9100$export$37cc822878118153);
const $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$var$noWrapText = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    whiteSpace: "nowrap"
});
const $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$export$1e30305c33fd8c57 = ({ tags: tags, timestamp: timestamp, authorDetails: authorDetails, authorHref: authorHref, authorHoverContent: authorHoverContent, rankComponent: rankComponent })=>{
    const [isAuthorHoverOpen, setIsAuthorHoverOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(false);
    const authorHoverRef = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(null);
    const tagsShown = tags.slice(0, 2);
    const extraTagCount = tags.length - tagsShown.length;
    const handleAuthorHoverOpen = ()=>setIsAuthorHoverOpen(true);
    const handleAuthorHoverClose = (event)=>{
        const relatedTarget = event?.relatedTarget;
        if (relatedTarget instanceof Node && authorHoverRef.current?.contains(relatedTarget)) return;
        setIsAuthorHoverOpen(false);
    };
    const authorContent = (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
        alignItems: "center",
        gap: "space.025",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3778be82376b06d7, {
                size: $24c02ea0e14dbe4f$export$902867f9afe4e0c1.S,
                src: authorDetails.avatarUrl,
                label: authorDetails.name
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                size: "medium",
                children: authorDetails.name
            })
        ]
    });
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
        wrap: "wrap",
        gap: "space.300",
        justifyContent: "space-between",
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                wrap: "wrap",
                alignItems: "center",
                gap: "space.050",
                children: [
                    tagsShown.map((tag)=>{
                        return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                            as: "a",
                            href: tag.hyperlink,
                            xcss: [
                                $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$var$pillInteractiveStyles,
                                $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$var$anchorResetStyles
                            ],
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                                label: `# ${tag.tag}`,
                                backgroundColor: "transparent",
                                borderColor: "color.border",
                                textTransform: "none",
                                fontWeight: "normal",
                                fontFamily: "Atlassian Sans, sans-serif",
                                maxSize: "250px",
                                padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.025")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")}`
                            })
                        }, tag.tag);
                    }),
                    extraTagCount > 0 ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                        label: `+${extraTagCount} more`,
                        textTransform: "none",
                        isTall: true,
                        borderColor: "transparent",
                        fontWeight: "400",
                        fontFamily: "Inter"
                    }) : null
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                wrap: "wrap",
                gap: "space.150",
                alignItems: "center",
                justifyContent: "end",
                xcss: (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
                    flex: "1"
                }),
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $1ee6819d2d8fb6a1$export$2e2bcd8739ae039), {
                        content: $24c02ea0e14dbe4f$export$a31e25c49c78e203(timestamp),
                        children: (tooltipProps)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                                as: "span",
                                ...tooltipProps,
                                xcss: $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$var$noWrapText,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                                    size: "medium",
                                    children: $24c02ea0e14dbe4f$export$880acc1b13aaa28b(timestamp, "full")
                                })
                            })
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                        columnGap: "space.100",
                        wrap: "wrap",
                        justifyContent: "end",
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                                xcss: $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$var$authorHoverTargetStyles,
                                onMouseEnter: handleAuthorHoverOpen,
                                onMouseLeave: handleAuthorHoverClose,
                                onFocusCapture: handleAuthorHoverOpen,
                                onBlurCapture: handleAuthorHoverClose,
                                ref: authorHoverRef,
                                children: [
                                    authorHref ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                                        as: "a",
                                        href: authorHref,
                                        xcss: [
                                            $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$var$anchorDetailStyles,
                                            $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$var$hoverUnderlineStyles,
                                            $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$var$noWrapText
                                        ],
                                        children: authorContent
                                    }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                                        xcss: $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$var$anchorDetailStyles,
                                        children: authorContent
                                    }),
                                    authorHoverContent && isAuthorHoverOpen ? authorHoverContent : null
                                ]
                            }),
                            rankComponent
                        ]
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$var$pillInteractiveStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    cursor: "pointer",
    ":hover": {
        textTransform: "none",
        borderColor: "color.border",
        backgroundColor: "color.background.neutral.subtle.hovered"
    }
});
const $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$var$authorHoverTargetStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    position: "relative"
});
const $24c02ea0e14dbe4f$var$$3ec02f67788713f1$export$f438dff3491d77ab = ({ title: title, titleHref: titleHref })=>{
    const content = (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
        justifyContent: "space-between",
        alignItems: "center",
        gap: "space.100",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                as: "span",
                style: {
                    fontSize: "24px",
                    fontFamily: "Charlie Display, sans-serif",
                    fontWeight: "600"
                },
                children: title
            }),
            titleHref && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($c98a967905aaff91$exports))), {
                label: "Navigate",
                size: "small"
            })
        ]
    });
    return titleHref ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
        as: "a",
        xcss: $24c02ea0e14dbe4f$var$$3ec02f67788713f1$var$titleLinkStyles,
        href: titleHref,
        children: content
    }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
        xcss: $24c02ea0e14dbe4f$var$$3ec02f67788713f1$var$titleTextStyles,
        children: content
    });
};
const $24c02ea0e14dbe4f$var$$3ec02f67788713f1$var$titleLinkStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    color: "color.text",
    padding: "space.0",
    textAlign: "left",
    cursor: "pointer",
    textDecoration: "none",
    ":hover": {
        color: "color.link",
        textDecoration: "none"
    }
});
const $24c02ea0e14dbe4f$var$$3ec02f67788713f1$var$titleTextStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    color: "color.text",
    padding: "space.0",
    textAlign: "left"
});
const $24c02ea0e14dbe4f$var$$11271ea5e6da2c5e$export$c806476cb62098c9 = ()=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M12.5 2C12.5 1.72386 12.2761 1.5 12 1.5H2C1.72386 1.5 1.5 1.72386 1.5 2V12C1.5 12.2761 1.72386 12.5 2 12.5H12C12.2761 12.5 12.5 12.2761 12.5 12V2ZM7.75 3V8H6.25V3H7.75ZM14 12C14 13.1046 13.1046 14 12 14H2C0.895431 14 1.00665e-08 13.1046 0 12V2C1.61066e-07 0.895431 0.89543 1.00665e-08 2 0H12C13.1046 1.61066e-07 14 0.89543 14 2V12Z",
                fill: "#6C6F77"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M8 10.25C8 10.8023 7.55228 11.25 7 11.25C6.44772 11.25 6 10.8023 6 10.25C6 9.69771 6.44772 9.25 7 9.25C7.55228 9.25 8 9.69771 8 10.25Z",
                fill: "#6C6F77"
            })
        ]
    });
const $24c02ea0e14dbe4f$var$$ae14dd6ecf20d4c3$export$6d2e2d5b3f4f86b8 = ({ showModerationDetails: showModerationDetails, isModerationReviewed: isModerationReviewed })=>{
    if (!showModerationDetails) return null;
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
        padding: "space.075",
        children: isModerationReviewed ? (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
            gap: "space.075",
            alignItems: "center",
            justifyContent: "end",
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($0dd7a84998b77bec$exports))), {
                    label: "Approved by admin",
                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.success")
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                    color: "color.text.success",
                    children: "Approved by admin"
                })
            ]
        }) : (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
            gap: "space.075",
            alignItems: "center",
            justifyContent: "end",
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$11271ea5e6da2c5e$export$c806476cb62098c9, {}),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                    color: "color.text.subtlest",
                    children: "Not yet reviewed"
                })
            ]
        })
    });
};
const $24c02ea0e14dbe4f$export$1074985837f1b2a5 = ({ contentType: contentType = $24c02ea0e14dbe4f$export$96b2e747ae3de284.Question, categoryType: categoryType, isFeatured: isFeatured = false, title: title, id: id, description: description, categoryName: categoryName, tags: tags = [], timestamp: timestamp, showModerationDetails: showModerationDetails = false, isModerationReviewed: isModerationReviewed = false, authorDetails: authorDetails, authorHoverContent: authorHoverContent, likes: likes, responses: responses, views: views, status: status, hostingType: hostingType = "data-center", titleHref: titleHref, authorHref: authorHref = "", categoryHref: categoryHref = "", menuComponent: menuComponent, isNew: isNew, rankComponent: rankComponent })=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
        direction: "column",
        gap: "space.100",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$ae14dd6ecf20d4c3$export$6d2e2d5b3f4f86b8, {
                showModerationDetails: showModerationDetails,
                isModerationReviewed: isModerationReviewed
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                xcss: $24c02ea0e14dbe4f$var$$b0e23f9f192d2ea7$var$cardStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                        gap: "space.200",
                        direction: "column",
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$06e8096ff5ff1247$export$7d7346e428084a7e, {
                                menuComponent: menuComponent,
                                categoryHref: categoryHref,
                                contentType: contentType,
                                categoryName: categoryName,
                                isFeatured: isFeatured,
                                categoryType: categoryType,
                                hostingType: hostingType,
                                isNew: isNew
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$3ec02f67788713f1$export$f438dff3491d77ab, {
                                title: title,
                                titleHref: titleHref
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                                size: "large",
                                maxLines: 2,
                                children: description
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$65d6e13fe84e408e$export$1e30305c33fd8c57, {
                                authorHref: authorHref,
                                tags: tags,
                                timestamp: timestamp,
                                authorDetails: authorDetails,
                                authorHoverContent: authorHoverContent,
                                id: id,
                                rankComponent: rankComponent
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                        xcss: $24c02ea0e14dbe4f$var$$b0e23f9f192d2ea7$var$dividerStyles
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$2248ded33c1cc26f$export$9e55f86bc7a20cd4, {
                        contentType: contentType,
                        likes: likes,
                        responses: responses,
                        views: views,
                        status: status
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$b0e23f9f192d2ea7$var$cardStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    display: "flex",
    flexDirection: "column",
    gap: "space.200",
    padding: "space.200",
    backgroundColor: "elevation.surface",
    borderRadius: "border.radius.200",
    boxShadow: "elevation.shadow.raised",
    width: "100%",
    boxSizing: "border-box"
});
const $24c02ea0e14dbe4f$var$$b0e23f9f192d2ea7$var$dividerStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    width: "100%",
    borderTopWidth: "border.width",
    borderTopStyle: "solid",
    borderTopColor: "color.border",
    borderRadius: "border.radius.circle"
});
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$976a3c76bc9fa9bc$exports, $24c02ea0e14dbe4f$var$$b0e23f9f192d2ea7$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$976a3c76bc9fa9bc$exports, $24c02ea0e14dbe4f$var$$fa9d4c58bb661680$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$0cf4554ad00467b5$exports, $24c02ea0e14dbe4f$var$$a3d28c94a229f94e$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$0cf4554ad00467b5$exports, $24c02ea0e14dbe4f$var$$976a3c76bc9fa9bc$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a69491ea5a126553$exports, $24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a69491ea5a126553$exports, $24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a69491ea5a126553$exports, $24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a69491ea5a126553$exports, $24c02ea0e14dbe4f$var$$0cf4554ad00467b5$exports);


const $6cf738ba21080f36$export$a06f1c675e846f6f = ({ isLoggedIn: isLoggedIn, loggedInUser: loggedInUser })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $faf30355a80342e4$exports.Fragment), {
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $24c02ea0e14dbe4f$export$7a92b4adf6bd95bb), {
            isLoggedIn: isLoggedIn,
            email: loggedInUser?.email || 'test@atlassian.com'
        })
    });



var $a73be79b54a68660$exports = {};
"use strict";
Object.defineProperty($a73be79b54a68660$exports, "__esModule", {
    value: true
});
var $d9a56230c565b38a$exports = {};
"use strict";
Object.defineProperty($d9a56230c565b38a$exports, "__esModule", {
    value: true
});
var $e70db4c19b26a7d8$exports = {};
"use strict";
Object.defineProperty($e70db4c19b26a7d8$exports, "__esModule", {
    value: true
});
$e70db4c19b26a7d8$exports.TestComponent = void 0;

var $e70db4c19b26a7d8$var$_react = $e70db4c19b26a7d8$var$_interopRequireDefault((parcelRequire("5FkrB")));
function $e70db4c19b26a7d8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $e70db4c19b26a7d8$var$TestComponent = $e70db4c19b26a7d8$exports.TestComponent = function TestComponent(_ref) {
    var text = _ref.text, subtext = _ref.subtext;
    return /*#__PURE__*/ $e70db4c19b26a7d8$var$_react["default"].createElement("div", null, /*#__PURE__*/ $e70db4c19b26a7d8$var$_react["default"].createElement("h1", null, text), subtext ? /*#__PURE__*/ $e70db4c19b26a7d8$var$_react["default"].createElement("div", null, subtext) : null);
};


Object.keys($e70db4c19b26a7d8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $d9a56230c565b38a$exports && $d9a56230c565b38a$exports[key] === $e70db4c19b26a7d8$exports[key]) return;
    Object.defineProperty($d9a56230c565b38a$exports, key, {
        enumerable: true,
        get: function get() {
            return $e70db4c19b26a7d8$exports[key];
        }
    });
});
var $5533df6f33d2f6e3$exports = {};
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ "use strict";
Object.defineProperty($5533df6f33d2f6e3$exports, "__esModule", {
    value: true
});
$5533df6f33d2f6e3$exports.ConsentModal = void 0;

var $jY1dw = parcelRequire("jY1dw");

var $5533df6f33d2f6e3$var$_react = $5533df6f33d2f6e3$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $5533df6f33d2f6e3$var$_modalDialog = $5533df6f33d2f6e3$var$_interopRequireDefault((parcelRequire("lnqhJ")));

var $5533df6f33d2f6e3$var$_new = $5533df6f33d2f6e3$var$_interopRequireDefault((parcelRequire("427nl")));
function $5533df6f33d2f6e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
// import './ConsentModal.module.css';
/**
 * Component that renders a inline code in topic body
 * @param {ConsentModalProps} ConsentModalProps
 * @returns {React.ReactElement} React.ReactElement
 *
 * @example
 * <ConsentModal onClick={ () => setConsent() } />
 */ var $5533df6f33d2f6e3$var$ConsentModal = $5533df6f33d2f6e3$exports.ConsentModal = function ConsentModal(_ref) {
    var onClick = _ref.onClick;
    return /*#__PURE__*/ $5533df6f33d2f6e3$var$_react["default"].createElement($5533df6f33d2f6e3$var$_modalDialog["default"], {
        shouldScrollInViewport: true
    }, /*#__PURE__*/ $5533df6f33d2f6e3$var$_react["default"].createElement("div", {
        className: (0, $jY1dw.default)([
            "_1e0c1txw _4cvr1h6o _2lx21bp4 _19pk7vkz _ca0q1ylp _u5f31ylp _n3td1ylp _19bv1ylp"
        ])
    }, /*#__PURE__*/ $5533df6f33d2f6e3$var$_react["default"].createElement("h1", {
        className: (0, $jY1dw.default)([
            "_ect46nat _1wybzwfg _k48pni7l _vwz41ylp _19pkidpf _otyr7vkz _y3gn1h6o"
        ])
    }, "Welcome to Early Access"), /*#__PURE__*/ $5533df6f33d2f6e3$var$_react["default"].createElement("p", {
        className: (0, $jY1dw.default)([
            "_ect4oyw7 _1wybgktf _k48p1nn1 _vwz41tcg _y3gn1h6o _otyrzwfg"
        ])
    }, "By signing up for the Early Access Program (\u201CEAP\u201D), you acknowledge the", ' ', /*#__PURE__*/ $5533df6f33d2f6e3$var$_react["default"].createElement("a", {
        href: "http://atlassian.com/legal/privacy-policy",
        className: (0, $jY1dw.default)([
            "_syaz7g9i"
        ])
    }, "Atlassian Privacy Policy"), ' ', "and that use of the EAP products is governed by the", ' ', /*#__PURE__*/ $5533df6f33d2f6e3$var$_react["default"].createElement("a", {
        href: "https://www.atlassian.com/legal/community-platform-terms-of-use",
        className: (0, $jY1dw.default)([
            "_syaz7g9i"
        ])
    }, "Online Community Platform Terms of Use"), "."), /*#__PURE__*/ $5533df6f33d2f6e3$var$_react["default"].createElement("div", {
        className: (0, $jY1dw.default)([
            "_ect4zeyy"
        ])
    }, /*#__PURE__*/ $5533df6f33d2f6e3$var$_react["default"].createElement($5533df6f33d2f6e3$var$_new["default"], {
        appearance: "primary",
        onClick: onClick
    }, "Agree and sign up"))));
};
var $5533df6f33d2f6e3$var$contentStyles = null;
var $5533df6f33d2f6e3$var$headerStyles = null;
var $5533df6f33d2f6e3$var$bodyStyles = null;
var $5533df6f33d2f6e3$var$linkStyles = null;
var $5533df6f33d2f6e3$var$buttonContainerStyles = null;


Object.keys($5533df6f33d2f6e3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $d9a56230c565b38a$exports && $d9a56230c565b38a$exports[key] === $5533df6f33d2f6e3$exports[key]) return;
    Object.defineProperty($d9a56230c565b38a$exports, key, {
        enumerable: true,
        get: function get() {
            return $5533df6f33d2f6e3$exports[key];
        }
    });
});
var $3506c2b8472f3d94$exports = {};
"use strict";
function $3506c2b8472f3d94$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3506c2b8472f3d94$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3506c2b8472f3d94$var$_typeof(o);
}
Object.defineProperty($3506c2b8472f3d94$exports, "__esModule", {
    value: true
});
$3506c2b8472f3d94$exports.ConsentValidator = void 0;

var $3506c2b8472f3d94$var$_react = $3506c2b8472f3d94$var$_interopRequireDefault((parcelRequire("5FkrB")));
var $9274af858143a4bd$exports = {};
"use strict";
function $9274af858143a4bd$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9274af858143a4bd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9274af858143a4bd$var$_typeof(o);
}
Object.defineProperty($9274af858143a4bd$exports, "__esModule", {
    value: true
});
$9274af858143a4bd$exports.userConsentStatuses = $9274af858143a4bd$exports.setUserConsent = $9274af858143a4bd$exports.isUserConsented = void 0;
var $6601efa3d6ce5781$exports = {};
"use strict";
Object.defineProperty($6601efa3d6ce5781$exports, "__esModule", {
    value: true
});
$6601efa3d6ce5781$exports.getUserIsConsentedQuery = $6601efa3d6ce5781$exports.getUserIsAllowedQuery = $6601efa3d6ce5781$exports.getUserAccountQuery = $6601efa3d6ce5781$exports.USER_INFO_QUERY = void 0;
var $6601efa3d6ce5781$var$getUserIsAllowedQuery = $6601efa3d6ce5781$exports.getUserIsAllowedQuery = function getUserIsAllowedQuery(emailId) {
    return "\n  query USER_ALLOWED_QUERY {\n    unified {\n      gating {\n        isEmailIdAllowed(emailId: \"".concat(emailId, "\") {\n          ... on UnifiedQueryError {\n            identifier\n            message\n            extensions {\n              errorType\n              statusCode\n            }\n          }\n          ... on UnifiedAccessStatus {\n            id\n            status\n          }\n        }\n      }\n    }\n  }\n");
};
var $6601efa3d6ce5781$var$USER_INFO_QUERY = $6601efa3d6ce5781$exports.USER_INFO_QUERY = "query USER_INFO_QUERY {\n  me {\n    user {\n      ... on AtlassianAccountUser {\n        email\n        accountId\n        orgId\n        picture\n      }\n    }\n  }\n}";
var $6601efa3d6ce5781$var$getUserIsConsentedQuery = $6601efa3d6ce5781$exports.getUserIsConsentedQuery = function getUserIsConsentedQuery(aaid) {
    return "\n  query USER_CONSENTED_QUERY {\n    unified {\n      consent {\n      getConsent(value: \"".concat(aaid, "\", type: \"AAID\") {\n        ... on UnifiedConsentStatus {\n          id\n          createdAt\n          type\n          updatedAt\n          value\n          consentObj {\n            consentKey\n            consentStatus\n            consenthubStatus\n            createdAt\n            updatedAt\n            uppConsentStatus\n          }\n        }\n        ... on UnifiedQueryError {\n          identifier\n          message\n          code\n        }\n      }\n    }\n  }\n}");
};
var $6601efa3d6ce5781$var$getUserAccountQuery = $6601efa3d6ce5781$exports.getUserAccountQuery = function getUserAccountQuery(aaid) {
    return "\n  query USER_ACCOUNT_QUERY {\n    unified {\n      account(aaid: \"".concat(aaid, "\") {\n        ... on UnifiedAccount {\n          aaid\n          atlassianOneUserId\n          emailId\n          id\n          internalId\n          isLinked\n          isManaged\n          isPrimary\n          isProfileOwnerConsented\n          khorosUserId\n        }\n        ... on UnifiedQueryError {\n          code\n          identifier\n          message\n        }\n      }\n    }\n  }\n");
};


var $6eda9e6c03494bd2$exports = {};
"use strict";
Object.defineProperty($6eda9e6c03494bd2$exports, "__esModule", {
    value: true
});
$6eda9e6c03494bd2$exports.setUserIsConsentedMutation = $6eda9e6c03494bd2$exports.initializeCommunityMutationbyAaid = $6eda9e6c03494bd2$exports.initializeCommunityMutation = $6eda9e6c03494bd2$exports.SUBMIT_CHAMPION_SIGNUP_MUTATION = void 0;
var $6eda9e6c03494bd2$var$setUserIsConsentedMutation = $6eda9e6c03494bd2$exports.setUserIsConsentedMutation = function setUserIsConsentedMutation(aaid, consentKey) {
    return "\n  mutation SET_USER_CONSENTED_MUTATION {\n    unified {\n      consent {\n        setConsent(\n          consentObj: {consentKey: \"".concat(consentKey, "\", consentStatus: \"true\"}\n          type: \"AAID\"\n          value: \"").concat(aaid, "\"\n        ) {\n          errors {\n            message\n          }\n          message\n          success\n      }\n    }\n  }\n}");
};
var $6eda9e6c03494bd2$var$initializeCommunityMutation = $6eda9e6c03494bd2$exports.initializeCommunityMutation = function initializeCommunityMutation(emailId) {
    return "\nmutation INITIALIZE_COMMUNITY_MUTATION {\n  unified {\n    community {\n      initializeCommunity(emailId: \"".concat(emailId, "\") {\n        success\n        errors {\n          code\n          message\n          extensions {\n            errorType\n            statusCode\n          }\n        }\n        forumsProfile {\n          id\n          login\n        }\n        gamificationProfile {\n          firstName\n          userId\n        }\n        unifiedProfile {\n          accountInternalId\n        }\n        isNewForumsProfile\n        isNewGamificationProfile\n        isNewProfile\n      }\n    }\n  }\n}");
};
var $6eda9e6c03494bd2$var$initializeCommunityMutationbyAaid = $6eda9e6c03494bd2$exports.initializeCommunityMutationbyAaid = function initializeCommunityMutationbyAaid(aaid) {
    return "\nmutation INITIALIZE_COMMUNITY_MUTATION {\n  unified {\n    community {\n      initializeCommunity(aaid: \"".concat(aaid, "\") {\n        success\n        errors {\n          code\n          message\n          extensions {\n            errorType\n            statusCode\n          }\n        }\n        forumsProfile {\n          id\n          login\n        }\n        gamificationProfile {\n          firstName\n          userId\n        }\n        unifiedProfile {\n          accountInternalId\n        }\n        isNewForumsProfile\n        isNewGamificationProfile\n        isNewProfile\n      }\n    }\n  }\n}");
};
var $6eda9e6c03494bd2$var$SUBMIT_CHAMPION_SIGNUP_MUTATION = $6eda9e6c03494bd2$exports.SUBMIT_CHAMPION_SIGNUP_MUTATION = "\n  mutation SUBMIT_CHAMPION_SIGNUP_MUTATION($input: UnifiedChampionSignupInput) {\n    champion {\n      championSignup {\n        submitChampionSignup(input: $input) {\n          success\n          message\n        }\n      }\n    }\n  }\n";


var $9b8dc532c3c3f9ae$exports = {};
"use strict";
Object.defineProperty($9b8dc532c3c3f9ae$exports, "__esModule", {
    value: true
});
$9b8dc532c3c3f9ae$exports.shouldUseStargate = $9b8dc532c3c3f9ae$exports.getXidEnvironment = $9b8dc532c3c3f9ae$exports.getUppApiPathFromEnvironment = $9b8dc532c3c3f9ae$exports.getGASv3Environment = $9b8dc532c3c3f9ae$exports.getEnvironment = $9b8dc532c3c3f9ae$exports.getAnalyticsWriteKey = $9b8dc532c3c3f9ae$exports.ENVIRONMENT_CONFIGS = void 0;

var $dpXUu = parcelRequire("dpXUu");
var $a576733921801e90$exports = {};
"use strict";
Object.defineProperty($a576733921801e90$exports, "__esModule", {
    value: true
});

var $l2Z7B = parcelRequire("l2Z7B");

$l2Z7B.__exportStar((parcelRequire("4qBHc")), $a576733921801e90$exports);
var $5cdc7272fdf5cc1c$exports = {};
"use strict";
Object.defineProperty($5cdc7272fdf5cc1c$exports, "__esModule", {
    value: true
});

var $l2Z7B = parcelRequire("l2Z7B");

var $5cdc7272fdf5cc1c$var$promise_polyfill_1 = $l2Z7B.__importDefault((parcelRequire("7UOcZ")));
var $43113123be356ccf$exports = {};
"use strict";
Object.defineProperty($43113123be356ccf$exports, "__esModule", {
    value: true
});

var $l2Z7B = parcelRequire("l2Z7B");
var $0b6506b711105af1$exports = {};
"use strict";
Object.defineProperty($0b6506b711105af1$exports, "__esModule", {
    value: true
});

var $l2Z7B = parcelRequire("l2Z7B");
var $0b6506b711105af1$var$set = function(name, value, options) {
    var str = $0b6506b711105af1$var$encode(name) + '=' + $0b6506b711105af1$var$encode((value || '').toString());
    if (value == null) options.maxage = -1;
    var expiry;
    if (options.maxage) expiry = new Date(+new Date() + options.maxage);
    if (options.path) str += '; path=' + options.path;
    if (options.domain) str += '; domain=' + options.domain;
    if (expiry) str += '; expires=' + expiry.toUTCString();
    if (options.secure) str += '; secure';
    if (options.sameSite) str += '; samesite=' + options.sameSite;
    document.cookie = str;
    return str;
};
var $0b6506b711105af1$var$all = function() {
    try {
        return $0b6506b711105af1$var$parse(document.cookie);
    } catch (err) {
        if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(err.stack || err);
        return {};
    }
};
function $0b6506b711105af1$var$get(name) {
    return $0b6506b711105af1$var$all()[name];
}
function $0b6506b711105af1$var$parse(str) {
    var obj = {};
    var pairs = str.split(/ *; */);
    if (pairs[0] === '') return obj;
    pairs.forEach(function(item) {
        var pair = item.split('=');
        var key = $0b6506b711105af1$var$decode(pair[0]);
        var value = $0b6506b711105af1$var$decode(pair[1]);
        if (key && value) obj[key] = value;
    });
    return obj;
}
function $0b6506b711105af1$var$encode(value) {
    try {
        return encodeURIComponent(value);
    } catch (e) {
        console.log('error `encode(%o)` - %o', value, e);
        return "";
    }
}
function $0b6506b711105af1$var$decode(value) {
    try {
        return decodeURIComponent(value);
    } catch (e) {
        console.log('error `decode(%o)` - %o', value, e);
        return "";
    }
}
function $0b6506b711105af1$var$getCookie(name) {
    return $0b6506b711105af1$var$get(name);
}
$0b6506b711105af1$exports.getCookie = $0b6506b711105af1$var$getCookie;
function $0b6506b711105af1$var$getAllCookies() {
    return $0b6506b711105af1$var$all();
}
$0b6506b711105af1$exports.getAllCookies = $0b6506b711105af1$var$getAllCookies;
function $0b6506b711105af1$var$setCookie(name, value, options) {
    var finalOption = $l2Z7B.__assign({
        maxage: 31536000000,
        secure: true,
        path: '/',
        expires: null,
        domain: null,
        sameSite: 'lax'
    }, options);
    return $0b6506b711105af1$var$set(name, value, finalOption);
}
$0b6506b711105af1$exports.setCookie = $0b6506b711105af1$var$setCookie;
function $0b6506b711105af1$var$getCrossDomainCookieOption() {
    var domain = window.location.hostname.split('.').slice(-2).join('.');
    return {
        sameSite: 'None',
        domain: domain
    };
}
$0b6506b711105af1$exports.getCrossDomainCookieOption = $0b6506b711105af1$var$getCrossDomainCookieOption;



var $4qBHc = parcelRequire("4qBHc");
var $2c0cc5aa0127ff82$exports = {};
"use strict";
Object.defineProperty($2c0cc5aa0127ff82$exports, "__esModule", {
    value: true
});

var $a28e63c01fe9e2bf$exports = {};
"use strict";
Object.defineProperty($a28e63c01fe9e2bf$exports, "__esModule", {
    value: true
});

var $4qBHc = parcelRequire("4qBHc");
$a28e63c01fe9e2bf$exports.checkXidValid = function(xid) {
    return (xid.type === $4qBHc.XIDItemType.UID || xid.type === $4qBHc.XIDItemType.XC) && !!xid.value && !!Date.parse(xid.createdAt);
};


var $2c0cc5aa0127ff82$var$parseCachedXidItem = function(value) {
    try {
        var xid = JSON.parse(value);
        if (xid instanceof Array) {
            var valid = true;
            for(var _i = 0, xid_1 = xid; _i < xid_1.length; _i++){
                var entry = xid_1[_i];
                valid = valid && $a28e63c01fe9e2bf$exports.checkXidValid(entry);
            }
            return valid ? xid : undefined;
        } else return $a28e63c01fe9e2bf$exports.checkXidValid(xid) ? xid : undefined;
    } catch (err) {
        return;
    }
};
function $2c0cc5aa0127ff82$var$getFromLocalStorage(name) {
    try {
        return localStorage.getItem(name) || '';
    } catch (err) {}
}
function $2c0cc5aa0127ff82$var$getXidFromCookie(name) {
    var cookieValue = $0b6506b711105af1$exports.getCookie(name);
    return $2c0cc5aa0127ff82$var$parseCachedXidItem(cookieValue);
}
$2c0cc5aa0127ff82$exports.getXidFromCookie = $2c0cc5aa0127ff82$var$getXidFromCookie;
function $2c0cc5aa0127ff82$var$getXidFromLocalStorage(name) {
    var lsValue = '';
    try {
        lsValue = localStorage.getItem(name) || '';
    } catch (err) {}
    return $2c0cc5aa0127ff82$var$parseCachedXidItem(lsValue);
}
$2c0cc5aa0127ff82$exports.getXidFromLocalStorage = $2c0cc5aa0127ff82$var$getXidFromLocalStorage;
function $2c0cc5aa0127ff82$var$setLocalstorage(name, value) {
    try {
        localStorage.setItem(name, value);
    } catch (err) {}
}
$2c0cc5aa0127ff82$exports.setLocalstorage = $2c0cc5aa0127ff82$var$setLocalstorage;
function $2c0cc5aa0127ff82$var$getCache(name) {
    return $0b6506b711105af1$exports.getCookie(name) || $2c0cc5aa0127ff82$var$getFromLocalStorage(name);
}
$2c0cc5aa0127ff82$exports.getCache = $2c0cc5aa0127ff82$var$getCache;
function $2c0cc5aa0127ff82$var$getXidItemFromCache(name) {
    return $2c0cc5aa0127ff82$var$getXidFromCookie(name) || $2c0cc5aa0127ff82$var$getXidFromLocalStorage(name);
}
$2c0cc5aa0127ff82$exports.getXidItemFromCache = $2c0cc5aa0127ff82$var$getXidItemFromCache;


var $e226362dd6674ff5$exports = {};
"use strict";
Object.defineProperty($e226362dd6674ff5$exports, "__esModule", {
    value: true
});

var $25cd23fdd1b43e03$exports = {};
"use strict";
Object.defineProperty($25cd23fdd1b43e03$exports, "__esModule", {
    value: true
});
$25cd23fdd1b43e03$exports.parse = function(url) {
    var a = document.createElement('a');
    a.href = url;
    return {
        href: a.href,
        host: a.host || location.host,
        port: '0' === a.port || '' === a.port ? $25cd23fdd1b43e03$exports.port(a.protocol) : a.port,
        hash: a.hash,
        hostname: a.hostname || location.hostname,
        pathname: a.pathname.charAt(0) !== '/' ? '/' + a.pathname : a.pathname,
        protocol: !a.protocol || ':' === a.protocol ? location.protocol : a.protocol,
        search: a.search,
        query: a.search.slice(1)
    };
};
$25cd23fdd1b43e03$exports.isAbsolute = function(url) {
    return 0 === url.indexOf('//') || !!~url.indexOf('://');
};
$25cd23fdd1b43e03$exports.isRelative = function(url) {
    return !$25cd23fdd1b43e03$exports.isAbsolute(url);
};
$25cd23fdd1b43e03$exports.isCrossDomain = function(url) {
    var finalUrl = $25cd23fdd1b43e03$exports.parse(url);
    var location1 = $25cd23fdd1b43e03$exports.parse(window.location.href);
    return finalUrl.hostname !== location1.hostname || finalUrl.port !== location1.port || finalUrl.protocol !== location1.protocol;
};
$25cd23fdd1b43e03$exports.port = function(protocol) {
    switch(protocol){
        case 'http:':
            return 80;
        case 'https:':
            return 443;
        default:
            return location.port;
    }
};
$25cd23fdd1b43e03$exports.getParam = function(name) {
    var b = window.location.href.match('[?&]' + name + '=([^&#]+)');
    return b ? b.pop() : '';
};


var $e226362dd6674ff5$var$getLevels = function(url) {
    var host = $25cd23fdd1b43e03$exports.parse(url).hostname;
    var parts = host.split('.');
    var last = parts[parts.length - 1];
    var levels = [];
    if (parts.length === 4 && !isNaN(parseInt(last, 10))) return levels;
    if (parts.length <= 1) return levels;
    for(var i = parts.length - 2; i >= 0; --i)levels.push(parts.slice(i).join('.'));
    return levels;
};
$e226362dd6674ff5$exports.domain = function(url) {
    var domainLevels = $e226362dd6674ff5$var$getLevels(url);
    for(var _i = 0, domainLevels_1 = domainLevels; _i < domainLevels_1.length; _i++){
        var domainLevel = domainLevels_1[_i];
        var cname = '__tld__';
        var opts = {
            domain: '.' + domainLevel
        };
        $0b6506b711105af1$exports.setCookie(cname, 1, opts);
        if ($0b6506b711105af1$exports.getCookie(cname)) {
            $0b6506b711105af1$exports.setCookie(cname, null, opts);
            return domainLevel;
        }
    }
    return '';
};
$e226362dd6674ff5$exports.inIframe = function() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};
$e226362dd6674ff5$exports.isAtlassianComDomain = function() {
    return /atlassian\.com$/.test(window.location.hostname);
};


var $0efdf1f5ff90e2ff$exports = {};
"use strict";
Object.defineProperty($0efdf1f5ff90e2ff$exports, "__esModule", {
    value: true
});
$0efdf1f5ff90e2ff$exports.uuidv4 = function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(char) {
        var random = Math.random() * 16 | 0;
        var uuid = char === 'x' ? random : random & 0x3 | 0x8;
        return uuid.toString(16);
    });
};


var $43113123be356ccf$var$UID_REFRESH_PERIOD = 604800000;
var $43113123be356ccf$var$XC_REFRESH_PERIOD = 2592000000;
$43113123be356ccf$exports.XC_CURRENT = 'atl_xid.xc';
var $43113123be356ccf$var$XID_REFRESHED_AT = 'atl_xid.ts';
var $43113123be356ccf$var$XID_CURRENT = 'atl_xid.current';
var $43113123be356ccf$var$UIDS_ALL = 'atl_xid.uid';
var $43113123be356ccf$var$UIDS_STORE_LIMIT = 20;
var $43113123be356ccf$var$Storage = function() {
    function Storage() {}
    Storage.getCachedXID = function() {
        try {
            var currentXID = $2c0cc5aa0127ff82$exports.getXidItemFromCache($43113123be356ccf$var$XID_CURRENT);
            var refreshedAt = $2c0cc5aa0127ff82$exports.getCache($43113123be356ccf$var$XID_REFRESHED_AT);
            var isFresh = false;
            if (currentXID.length > 0 && currentXID[0].type === $4qBHc.XIDItemType.UID) isFresh = parseInt(refreshedAt || '', 10) >= new Date().getTime() - $43113123be356ccf$var$UID_REFRESH_PERIOD;
            else if (currentXID.length > 0 && currentXID[0].type === $4qBHc.XIDItemType.XC) isFresh = parseInt(refreshedAt || '', 10) >= new Date().getTime() - $43113123be356ccf$var$XC_REFRESH_PERIOD;
            if (isFresh) {
                for(var _i = 0, currentXID_1 = currentXID; _i < currentXID_1.length; _i++){
                    var entry = currentXID_1[_i];
                    entry.state = $4qBHc.XIDState.EXISTING;
                }
                return currentXID;
            } else return [];
        } catch (err) {
            return [];
        }
    };
    Storage.saveXid = function(xid) {
        try {
            $0b6506b711105af1$exports.setCookie($43113123be356ccf$var$XID_REFRESHED_AT, new Date().getTime());
            $2c0cc5aa0127ff82$exports.setLocalstorage($43113123be356ccf$var$XID_REFRESHED_AT, new Date().getTime().toString());
            var xidCache = [];
            for(var _i = 0, xid_1 = xid; _i < xid_1.length; _i++){
                var entry = xid_1[_i];
                if (entry.value && entry.createdAt) {
                    xidCache.push({
                        type: entry.type,
                        value: entry.value,
                        createdAt: entry.createdAt
                    });
                    break;
                }
            }
            $0b6506b711105af1$exports.setCookie($43113123be356ccf$var$XID_CURRENT, JSON.stringify(xidCache));
            $2c0cc5aa0127ff82$exports.setLocalstorage($43113123be356ccf$var$XID_CURRENT, JSON.stringify(xidCache));
        } catch (err) {
            console.error('Error setting xid cookie.');
        }
    };
    Storage.updateXc = function(env, xc) {
        try {
            if (env === $4qBHc.Environment.PROD && $e226362dd6674ff5$exports.isAtlassianComDomain()) return Storage.processAtlassianComDomainXc(xc);
            else Storage.saveXcLocalstorage(xc);
        } catch (err) {
            console.error('Error setting xc cookie.');
        }
        return xc;
    };
    Storage.getUids = function() {
        var uid = $2c0cc5aa0127ff82$exports.getXidItemFromCache($43113123be356ccf$var$UIDS_ALL) || [];
        for(var _i = 0, uid_1 = uid; _i < uid_1.length; _i++){
            var entry = uid_1[_i];
            entry.state = $4qBHc.XIDState.EXISTING;
        }
        return uid;
    };
    Storage.saveUids = function(uid) {
        try {
            var uidCache = [];
            for(var _i = 0, uid_2 = uid; _i < uid_2.length; _i++){
                var entry = uid_2[_i];
                if (entry.value && entry.createdAt) uidCache.push({
                    type: entry.type,
                    value: entry.value,
                    createdAt: entry.createdAt
                });
            }
            uidCache.slice(0, $43113123be356ccf$var$UIDS_STORE_LIMIT);
            $2c0cc5aa0127ff82$exports.setLocalstorage($43113123be356ccf$var$UIDS_ALL, JSON.stringify(uidCache));
        } catch (err) {
            console.error('Error setting uid cookie.');
        }
    };
    Storage.saveXcLocalstorage = function(xc) {
        if (xc.value && xc.createdAt) {
            var currentXcCache = $2c0cc5aa0127ff82$exports.getXidFromLocalStorage($43113123be356ccf$exports.XC_CURRENT);
            if (currentXcCache && currentXcCache.value === xc.value) return;
            else if (currentXcCache && currentXcCache.value !== xc.value) xc.state = $4qBHc.XIDState.CHANGED;
            var xidCache = {
                type: xc.type,
                value: xc.value,
                createdAt: xc.createdAt
            };
            $2c0cc5aa0127ff82$exports.setLocalstorage($43113123be356ccf$exports.XC_CURRENT, JSON.stringify(xidCache));
        }
    };
    Storage.processAtlassianComDomainXc = function(xc) {
        if (xc.value && xc.createdAt) {
            var currentXcCache = $2c0cc5aa0127ff82$exports.getXidFromCookie($43113123be356ccf$exports.XC_CURRENT);
            if (currentXcCache) {
                $0b6506b711105af1$exports.setCookie($43113123be356ccf$exports.XC_CURRENT, JSON.stringify(currentXcCache), $0b6506b711105af1$exports.getCrossDomainCookieOption());
                var currentXc = $l2Z7B.__assign({
                    state: $4qBHc.XIDState.EXISTING
                }, currentXcCache);
                Storage.saveXcLocalstorage(currentXc);
                return currentXc;
            } else {
                var newXcCache = {
                    value: $0efdf1f5ff90e2ff$exports.uuidv4(),
                    createdAt: new Date().toISOString(),
                    type: $4qBHc.XIDItemType.XC
                };
                $0b6506b711105af1$exports.setCookie($43113123be356ccf$exports.XC_CURRENT, JSON.stringify(newXcCache), $0b6506b711105af1$exports.getCrossDomainCookieOption());
                var newXc = $l2Z7B.__assign({
                    state: $4qBHc.XIDState.NEW
                }, newXcCache);
                Storage.saveXcLocalstorage(newXc);
                return newXc;
            }
        } else return xc;
    };
    return Storage;
}();
$43113123be356ccf$exports.Storage = $43113123be356ccf$var$Storage;


var $80509bb111a91081$exports = {};
"use strict";
Object.defineProperty($80509bb111a91081$exports, "__esModule", {
    value: true
});

var $l2Z7B = parcelRequire("l2Z7B");
var $3d8c7377a85fa527$exports = {};
"use strict";
Object.defineProperty($3d8c7377a85fa527$exports, "__esModule", {
    value: true
});
var $2f54eebc6872cda3$exports = {};
"use strict";
Object.defineProperty($2f54eebc6872cda3$exports, "__esModule", {
    value: true
});
var $96e78a72aef15085$exports = {};
"use strict";
Object.defineProperty($96e78a72aef15085$exports, "__esModule", {
    value: true
});
$96e78a72aef15085$exports.UNAVAILABLE = "UNAVAILABLE";
$96e78a72aef15085$exports.ERROR = "ERROR";
$96e78a72aef15085$exports.YES = "YES";
$96e78a72aef15085$exports.NO = "NO";


function $2f54eebc6872cda3$var$browserDefaultEvalLength() {
    try {
        return eval.toString().length || 0;
    } catch (err) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$2f54eebc6872cda3$exports.browserDefaultEvalLength = $2f54eebc6872cda3$var$browserDefaultEvalLength;


$3d8c7377a85fa527$exports.browserDefaultEvalLength = $2f54eebc6872cda3$exports.browserDefaultEvalLength;
var $9603535221c4e017$exports = {};
"use strict";
Object.defineProperty($9603535221c4e017$exports, "__esModule", {
    value: true
});

function $9603535221c4e017$var$canWriteCookie() {
    try {
        document.cookie = "cookietest=1";
        if (document.cookie.indexOf("cookietest=") !== -1) {
            document.cookie = "cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT";
            return $96e78a72aef15085$exports.YES;
        }
        return $96e78a72aef15085$exports.NO;
    } catch (t) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$9603535221c4e017$exports.canWriteCookie = $9603535221c4e017$var$canWriteCookie;


$3d8c7377a85fa527$exports.canWriteCookie = $9603535221c4e017$exports.canWriteCookie;
var $019da8f0475acef5$exports = {};
"use strict";
Object.defineProperty($019da8f0475acef5$exports, "__esModule", {
    value: true
});

function $019da8f0475acef5$var$getBrowserVendor() {
    try {
        return navigator.vendor || $96e78a72aef15085$exports.UNAVAILABLE;
    } catch (error) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$019da8f0475acef5$exports.getBrowserVendor = $019da8f0475acef5$var$getBrowserVendor;


$3d8c7377a85fa527$exports.getBrowserVendor = $019da8f0475acef5$exports.getBrowserVendor;
var $2aee7602ca42bd00$exports = {};
"use strict";
Object.defineProperty($2aee7602ca42bd00$exports, "__esModule", {
    value: true
});
function $2aee7602ca42bd00$var$getHardwareConcurrency() {
    try {
        var result = parseInt(navigator.hardwareConcurrency.toString(), 10);
        return isNaN(result) ? 1 : result;
    } catch (t) {
        return 1;
    }
}
$2aee7602ca42bd00$exports.getHardwareConcurrency = $2aee7602ca42bd00$var$getHardwareConcurrency;


$3d8c7377a85fa527$exports.getHardwareConcurrency = $2aee7602ca42bd00$exports.getHardwareConcurrency;
var $2acfbbd4af651a16$exports = {};
"use strict";
Object.defineProperty($2acfbbd4af651a16$exports, "__esModule", {
    value: true
});

function $2acfbbd4af651a16$var$getLanguage() {
    try {
        return navigator.language || $96e78a72aef15085$exports.UNAVAILABLE;
    } catch (error) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$2acfbbd4af651a16$exports.getLanguage = $2acfbbd4af651a16$var$getLanguage;


$3d8c7377a85fa527$exports.getLanguage = $2acfbbd4af651a16$exports.getLanguage;
var $e6e568cc867e7678$exports = {};
"use strict";
Object.defineProperty($e6e568cc867e7678$exports, "__esModule", {
    value: true
});

function $e6e568cc867e7678$var$getPlatform() {
    try {
        return navigator.platform || $96e78a72aef15085$exports.UNAVAILABLE;
    } catch (error) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$e6e568cc867e7678$exports.getPlatform = $e6e568cc867e7678$var$getPlatform;


$3d8c7377a85fa527$exports.getPlatform = $e6e568cc867e7678$exports.getPlatform;
var $dd71e8e2a1788002$exports = {};
"use strict";
Object.defineProperty($dd71e8e2a1788002$exports, "__esModule", {
    value: true
});

function $dd71e8e2a1788002$var$getPlugins() {
    try {
        var MSIE = "Microsoft Internet Explorer";
        var NETSCAPE = "Netscape";
        var isIE = navigator.appName === MSIE;
        var isNetscape = navigator.appName === NETSCAPE;
        var isTrident = /Trident/.test(navigator.userAgent);
        if (isIE || isNetscape && isTrident) return $96e78a72aef15085$exports.UNAVAILABLE;
        var navigatorPlugins = navigator.plugins;
        var s = "";
        for(var i = 0; i < navigatorPlugins.length; i++){
            var plugin = navigator.plugins[i];
            var name_1 = plugin.name;
            var fileName = plugin.filename;
            var pluginMimeTypes = plugin.length;
            for(var j = 0; j < pluginMimeTypes; j++){
                var o = plugin[j];
                if (o) s = s + name_1 + "," + fileName + "," + o.type + "|";
            }
        }
        return s;
    } catch (error) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$dd71e8e2a1788002$exports.getPlugins = $dd71e8e2a1788002$var$getPlugins;


$3d8c7377a85fa527$exports.getPlugins = $dd71e8e2a1788002$exports.getPlugins;
var $7297dc5435e34b8a$exports = {};
"use strict";
Object.defineProperty($7297dc5435e34b8a$exports, "__esModule", {
    value: true
});

function $7297dc5435e34b8a$var$getProductSub() {
    try {
        return navigator.productSub || $96e78a72aef15085$exports.UNAVAILABLE;
    } catch (error) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$7297dc5435e34b8a$exports.getProductSub = $7297dc5435e34b8a$var$getProductSub;


$3d8c7377a85fa527$exports.getProductSub = $7297dc5435e34b8a$exports.getProductSub;
var $b01884a4f4ec014e$exports = {};
"use strict";
Object.defineProperty($b01884a4f4ec014e$exports, "__esModule", {
    value: true
});

function $b01884a4f4ec014e$var$getTimeZone() {
    try {
        if (window.Intl && window.Intl.DateTimeFormat) return new window.Intl.DateTimeFormat().resolvedOptions().timeZone;
        return $96e78a72aef15085$exports.UNAVAILABLE;
    } catch (error) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$b01884a4f4ec014e$exports.getTimeZone = $b01884a4f4ec014e$var$getTimeZone;


$3d8c7377a85fa527$exports.getTimeZone = $b01884a4f4ec014e$exports.getTimeZone;
var $01488803c7ffc2e3$exports = {};
"use strict";
Object.defineProperty($01488803c7ffc2e3$exports, "__esModule", {
    value: true
});

function $01488803c7ffc2e3$var$getTimeZoneOffset() {
    try {
        return new Date().getTimezoneOffset() || $96e78a72aef15085$exports.UNAVAILABLE;
    } catch (error) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$01488803c7ffc2e3$exports.getTimeZoneOffset = $01488803c7ffc2e3$var$getTimeZoneOffset;


$3d8c7377a85fa527$exports.getTimeZoneOffset = $01488803c7ffc2e3$exports.getTimeZoneOffset;
var $c672d82b9e341cab$exports = {};
"use strict";
Object.defineProperty($c672d82b9e341cab$exports, "__esModule", {
    value: true
});

function $c672d82b9e341cab$var$getUserAgent() {
    try {
        return navigator.userAgent || $96e78a72aef15085$exports.UNAVAILABLE;
    } catch (d) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$c672d82b9e341cab$exports.getUserAgent = $c672d82b9e341cab$var$getUserAgent;


$3d8c7377a85fa527$exports.getUserAgent = $c672d82b9e341cab$exports.getUserAgent;
var $8d01ee7a76e3c9b6$exports = {};
"use strict";
Object.defineProperty($8d01ee7a76e3c9b6$exports, "__esModule", {
    value: true
});

function $8d01ee7a76e3c9b6$var$isIndexedDBAvailable() {
    try {
        return window.indexedDB ? $96e78a72aef15085$exports.YES : $96e78a72aef15085$exports.NO;
    } catch (e) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$8d01ee7a76e3c9b6$exports.isIndexedDBAvailable = $8d01ee7a76e3c9b6$var$isIndexedDBAvailable;


$3d8c7377a85fa527$exports.isIndexedDBAvailable = $8d01ee7a76e3c9b6$exports.isIndexedDBAvailable;
var $b8d0b1c831619e80$exports = {};
"use strict";
Object.defineProperty($b8d0b1c831619e80$exports, "__esModule", {
    value: true
});

function $b8d0b1c831619e80$var$isLocalStorageAvailable() {
    try {
        return window.localStorage ? $96e78a72aef15085$exports.YES : $96e78a72aef15085$exports.NO;
    } catch (e) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$b8d0b1c831619e80$exports.isLocalStorageAvailable = $b8d0b1c831619e80$var$isLocalStorageAvailable;


$3d8c7377a85fa527$exports.isLocalStorageAvailable = $b8d0b1c831619e80$exports.isLocalStorageAvailable;
var $486f3558e2350d8b$exports = {};
"use strict";
Object.defineProperty($486f3558e2350d8b$exports, "__esModule", {
    value: true
});

function $486f3558e2350d8b$var$isSessionStorageAvailable() {
    try {
        return window.sessionStorage ? $96e78a72aef15085$exports.YES : $96e78a72aef15085$exports.NO;
    } catch (e) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$486f3558e2350d8b$exports.isSessionStorageAvailable = $486f3558e2350d8b$var$isSessionStorageAvailable;


$3d8c7377a85fa527$exports.isSessionStorageAvailable = $486f3558e2350d8b$exports.isSessionStorageAvailable;
var $7e69c4765b7c492e$exports = {};
"use strict";
Object.defineProperty($7e69c4765b7c492e$exports, "__esModule", {
    value: true
});

function $7e69c4765b7c492e$var$isTestingBot() {
    try {
        var t = [
            "webdriver" in window,
            "_Selenium_IDE_Recorder" in window,
            "callSelenium" in window,
            "_selenium" in window,
            "__webdriver_script_fn" in document,
            "__driver_evaluate" in document,
            "__webdriver_evaluate" in document,
            "__selenium_evaluate" in document,
            "__fxdriver_evaluate" in document,
            "__driver_unwrapped" in document,
            "__webdriver_unwrapped" in document,
            "__selenium_unwrapped" in document,
            "__fxdriver_unwrapped" in document,
            "__webdriver_script_func" in document,
            null !== document.documentElement.getAttribute("selenium"),
            null !== document.documentElement.getAttribute("webdriver"),
            null !== document.documentElement.getAttribute("driver")
        ];
        return t.some(function(e) {
            return e === true;
        }) ? $96e78a72aef15085$exports.YES : $96e78a72aef15085$exports.NO;
    } catch (error) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$7e69c4765b7c492e$exports.isTestingBot = $7e69c4765b7c492e$var$isTestingBot;


$3d8c7377a85fa527$exports.isTestingBot = $7e69c4765b7c492e$exports.isTestingBot;
var $5a6afa0234012711$exports = {};
"use strict";
Object.defineProperty($5a6afa0234012711$exports, "__esModule", {
    value: true
});

function $5a6afa0234012711$var$isWebDriver() {
    try {
        return navigator.webdriver ? $96e78a72aef15085$exports.YES : $96e78a72aef15085$exports.NO;
    } catch (error) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$5a6afa0234012711$exports.isWebDriver = $5a6afa0234012711$var$isWebDriver;


$3d8c7377a85fa527$exports.isWebDriver = $5a6afa0234012711$exports.isWebDriver;


var $b2289a3a1290497e$exports = {};
"use strict";
Object.defineProperty($b2289a3a1290497e$exports, "__esModule", {
    value: true
});
var $f9ea33537480d7a8$exports = {};
"use strict";
Object.defineProperty($f9ea33537480d7a8$exports, "__esModule", {
    value: true
});

function $f9ea33537480d7a8$var$studyPrint() {
    try {
        var canvasElement = document.createElement("canvas");
        canvasElement.width = 240;
        canvasElement.height = 140;
        canvasElement.style.display = "inline";
        var canvasContext = canvasElement.getContext("2d");
        if (canvasContext) {
            canvasContext.rect(0, 0, 10, 10);
            canvasContext.rect(2, 2, 6, 6);
            canvasContext.isPointInPath(5, 5, "evenodd");
            canvasContext.textBaseline = "alphabetic";
            canvasContext.fillStyle = "#f60";
            canvasContext.fillRect(125, 1, 62, 20);
            canvasContext.fillStyle = "#069";
            canvasContext.font = "11pt no-real-font-123";
            canvasContext.fillText("Cwm fjordbank \uD83D\uDE03 gly", 2, 15);
            canvasContext.fillStyle = "rgba(102, 204, 0, 0.2)";
            canvasContext.font = "18pt Arial";
            canvasContext.fillText("Cwm fjordbank \uD83D\uDE03 gly", 4, 45);
            canvasContext.globalCompositeOperation = "multiply";
            canvasContext.fillStyle = "rgb(255,0,255)";
            canvasContext.beginPath();
            canvasContext.arc(50, 50, 50, 0, 2 * Math.PI, !0);
            canvasContext.closePath();
            canvasContext.fill();
            canvasContext.fillStyle = "rgb(0,255,255)";
            canvasContext.beginPath();
            canvasContext.arc(100, 50, 50, 0, 2 * Math.PI, !0);
            canvasContext.closePath();
            canvasContext.fill();
            canvasContext.fillStyle = "rgb(255,255,0)";
            canvasContext.beginPath();
            canvasContext.arc(75, 100, 50, 0, 2 * Math.PI, !0);
            canvasContext.closePath();
            canvasContext.fill();
            canvasContext.fillStyle = "rgb(255,0,255)";
            canvasContext.arc(75, 75, 75, 0, 2 * Math.PI, !0);
            canvasContext.arc(75, 75, 25, 0, 2 * Math.PI, !0);
            canvasContext.fill("evenodd");
            return canvasElement.toDataURL();
        }
        return $96e78a72aef15085$exports.UNAVAILABLE;
    } catch (error) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$f9ea33537480d7a8$exports.studyPrint = $f9ea33537480d7a8$var$studyPrint;


$b2289a3a1290497e$exports.studyPrint = $f9ea33537480d7a8$exports.studyPrint;



var $d58e2d37ce0b81a6$exports = {};
"use strict";
Object.defineProperty($d58e2d37ce0b81a6$exports, "__esModule", {
    value: true
});
var $351c551dac2f8c7e$exports = {};
"use strict";
Object.defineProperty($351c551dac2f8c7e$exports, "__esModule", {
    value: true
});

var $fdd4c4e3d2a2af74$exports = {};
"use strict";
Object.defineProperty($fdd4c4e3d2a2af74$exports, "__esModule", {
    value: true
});
$fdd4c4e3d2a2af74$exports.fontsToCheck = [
    "Adobe Garamond",
    "Adobe Hebrew",
    "Agency FB",
    "Airstream",
    "Andale Mono",
    "Aparajita",
    "Arial",
    "BN Manson Nights",
    "Baskerville",
    "BlackChancery",
    "Book Antiqua",
    "Bookman Old Style",
    "CG Times",
    "Calibri",
    "Cambria",
    "Cambria Math",
    "Century",
    "Century Gothic",
    "Century Schoolbook",
    "Chalkboard",
    "Comic Sans",
    "Comic Sans MS",
    "Consolas",
    "Cooper Black",
    "Corbel",
    "Courier",
    "Courier New",
    "Curlz MT",
    "DS Sans Serif",
    "Degrassi",
    "Didot",
    "Ebrima",
    "GOST Common",
    "Geneva",
    "Georgia",
    "Gulim",
    "Heiti TC",
    "Helvetica",
    "Helvetica Neue",
    "Hoefler Text",
    "Impact",
    "Kalinga",
    "Letter Gothic",
    "Lithos Pro",
    "Lucida Bright",
    "Lucida Calligraphy",
    "Lucida Console",
    "Lucida Fax",
    "Lucida Handwriting",
    "Lucida Sans",
    "MS Gothic",
    "MS Outlook",
    "MS PGothic",
    "MYRIAD",
    "Malgun Gothic",
    "Mangal",
    "MapInfo Miscellaneous",
    "Meiryo UI",
    "Monaco",
    "Monotype Corsiva",
    "NSimSun",
    "OSAKA",
    "Palatino",
    "Pickwick",
    "Playbill",
    "Pristina",
    "Segoe Print",
    "Segoe Script",
    "Segoe UI",
    "Shonar Bangla",
    "Snell Roundhand",
    "Styllo",
    "Tahoma",
    "Times",
    "Times New Roman",
    "Trebuchet MS",
    "Verdana",
    "Wingdings"
];


var $351c551dac2f8c7e$var$DetectFonts = function() {
    function DetectFonts() {
        var _this = this;
        this.baseFonts = [
            'monospace',
            'sans-serif',
            'serif'
        ];
        this.testString = 'mmmmmmmmmmlli';
        this.testSize = '72px';
        this.defaultWidth = {};
        this.defaultHeight = {};
        this.createSpan = function() {
            var s = document.createElement('span');
            s.style.position = 'absolute';
            s.style.left = '-9999px';
            s.style.fontSize = _this.testSize;
            s.style.fontStyle = 'normal';
            s.style.fontWeight = 'normal';
            s.style.letterSpacing = 'normal';
            s.style.lineBreak = 'auto';
            s.style.lineHeight = 'normal';
            s.style.textTransform = 'none';
            s.style.textAlign = 'left';
            s.style.textDecoration = 'none';
            s.style.textShadow = 'none';
            s.style.whiteSpace = 'normal';
            s.style.wordBreak = 'normal';
            s.style.wordSpacing = 'normal';
            s.innerHTML = _this.testString;
            return s;
        };
        this.createSpanWithFonts = function(fontToDetect, baseFont) {
            var s = _this.createSpan();
            s.style.fontFamily = "'" + fontToDetect + "'," + baseFont;
            return s;
        };
        this.initializeBaseFontsSpans = function() {
            var spans = [];
            for(var _i = 0, _a = _this.baseFonts; _i < _a.length; _i++){
                var font = _a[_i];
                var s = _this.createSpan();
                s.style.fontFamily = font;
                _this.baseFontsDiv.appendChild(s);
                spans.push(s);
            }
            return spans;
        };
        this.initializeFontsSpans = function() {
            var spans = {};
            for(var _i = 0, fontsToCheck_2 = $fdd4c4e3d2a2af74$exports.fontsToCheck; _i < fontsToCheck_2.length; _i++){
                var fontToDetect = fontsToCheck_2[_i];
                var fontSpans = [];
                for(var _a = 0, _b = _this.baseFonts; _a < _b.length; _a++){
                    var baseFont = _b[_a];
                    var s = _this.createSpanWithFonts(fontToDetect, baseFont);
                    _this.fontsDiv.appendChild(s);
                    fontSpans.push(s);
                }
                var key = fontToDetect;
                spans[key] = fontSpans;
            }
            return spans;
        };
        this.isFontAvailable = function(fontSpans) {
            var detected = false;
            for(var i = 0; i < _this.baseFonts.length; i++){
                var fontWidth = fontSpans[i].offsetWidth;
                var fontDefaultWidth = _this.defaultWidth[_this.baseFonts[i]];
                var fontHeight = fontSpans[i].offsetHeight;
                var fontDefaultHeight = _this.defaultHeight[_this.baseFonts[i]];
                detected = fontWidth !== fontDefaultWidth || fontHeight !== fontDefaultHeight;
                if (detected) return detected;
            }
            return detected;
        };
        this.bodyElement = document.getElementsByTagName('body')[0];
        this.baseFontsDiv = document.createElement('div');
        this.fontsDiv = document.createElement('div');
    }
    DetectFonts.prototype.detect = function() {
        var baseFontsSpans = this.initializeBaseFontsSpans();
        this.bodyElement.appendChild(this.baseFontsDiv);
        for(var index = 0; index < this.baseFonts.length; index++){
            this.defaultWidth[this.baseFonts[index]] = baseFontsSpans[index].offsetWidth;
            this.defaultHeight[this.baseFonts[index]] = baseFontsSpans[index].offsetHeight;
        }
        var fontsSpans = this.initializeFontsSpans();
        this.bodyElement.appendChild(this.fontsDiv);
        var available = [];
        for(var _i = 0, fontsToCheck_3 = $fdd4c4e3d2a2af74$exports.fontsToCheck; _i < fontsToCheck_3.length; _i++){
            var fontToCheck = fontsToCheck_3[_i];
            var result = 0;
            if (this.isFontAvailable(fontsSpans[fontToCheck])) result = 1;
            available.push(result);
        }
        this.bodyElement.removeChild(this.fontsDiv);
        this.bodyElement.removeChild(this.baseFontsDiv);
        return available.join("|");
    };
    DetectFonts.prototype.result = function() {
        try {
            return this.detect();
        } catch (error) {
            return $96e78a72aef15085$exports.ERROR;
        }
    };
    return DetectFonts;
}();
$351c551dac2f8c7e$exports.DetectFonts = $351c551dac2f8c7e$var$DetectFonts;


$d58e2d37ce0b81a6$exports.DetectFonts = $351c551dac2f8c7e$exports.DetectFonts;


var $f54acdfa91569540$exports = {};
"use strict";
Object.defineProperty($f54acdfa91569540$exports, "__esModule", {
    value: true
});
var $52b3787dc019b4f3$exports = {};
"use strict";
Object.defineProperty($52b3787dc019b4f3$exports, "__esModule", {
    value: true
});

var $ef24a61a0a1de451$exports = {};
"use strict";
Object.defineProperty($ef24a61a0a1de451$exports, "__esModule", {
    value: true
});

function $ef24a61a0a1de451$var$getContext() {
    if (window.WebGLRenderingContext) {
        var canvasElement = document.createElement("canvas");
        var webGLcontexts = [
            "webgl",
            "experimental-webgl",
            "moz-webgl",
            "webkit-3d"
        ];
        for(var _i = 0, webGLcontexts_1 = webGLcontexts; _i < webGLcontexts_1.length; _i++){
            var contextName = webGLcontexts_1[_i];
            try {
                var canvasRenderingContext = canvasElement.getContext(contextName);
                if (canvasRenderingContext && canvasRenderingContext instanceof WebGLRenderingContext && typeof canvasRenderingContext.getParameter === "function") return {
                    name: contextName,
                    context: canvasRenderingContext
                };
            } catch (p) {
                return $96e78a72aef15085$exports.ERROR;
            }
        }
    }
    return $96e78a72aef15085$exports.UNAVAILABLE;
}
$ef24a61a0a1de451$exports.getContext = $ef24a61a0a1de451$var$getContext;


function $52b3787dc019b4f3$var$getWebGL() {
    try {
        var gl = $ef24a61a0a1de451$exports.getContext();
        if (typeof gl === "undefined") return $96e78a72aef15085$exports.UNAVAILABLE;
        if (gl && typeof gl === "object" && gl.context) {
            var glContext = gl.context;
            var rendererInfo = glContext.getExtension("WEBGL_debug_renderer_info");
            if (rendererInfo !== null) return [
                glContext.getParameter(rendererInfo.UNMASKED_RENDERER_WEBGL),
                glContext.getParameter(glContext.MAX_COMBINED_TEXTURE_IMAGE_UNITS),
                glContext.getParameter(glContext.MAX_CUBE_MAP_TEXTURE_SIZE)
            ].join("|");
            return $96e78a72aef15085$exports.UNAVAILABLE;
        }
    } catch (p) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$52b3787dc019b4f3$exports.getWebGL = $52b3787dc019b4f3$var$getWebGL;


$f54acdfa91569540$exports.getWebGL = $52b3787dc019b4f3$exports.getWebGL;



var $458d8d5b9f9f3033$exports = {};
"use strict";
Object.defineProperty($458d8d5b9f9f3033$exports, "__esModule", {
    value: true
});
var $458d8d5b9f9f3033$var$x64Add = function(m, n) {
    m = [
        m[0] >>> 16,
        m[0] & 0xffff,
        m[1] >>> 16,
        m[1] & 0xffff
    ];
    n = [
        n[0] >>> 16,
        n[0] & 0xffff,
        n[1] >>> 16,
        n[1] & 0xffff
    ];
    var o = [
        0,
        0,
        0,
        0
    ];
    o[3] += m[3] + n[3];
    o[2] += o[3] >>> 16;
    o[3] &= 0xffff;
    o[2] += m[2] + n[2];
    o[1] += o[2] >>> 16;
    o[2] &= 0xffff;
    o[1] += m[1] + n[1];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[0] += m[0] + n[0];
    o[0] &= 0xffff;
    return [
        o[0] << 16 | o[1],
        o[2] << 16 | o[3]
    ];
};
var $458d8d5b9f9f3033$var$x64Multiply = function(m, n) {
    m = [
        m[0] >>> 16,
        m[0] & 0xffff,
        m[1] >>> 16,
        m[1] & 0xffff
    ];
    n = [
        n[0] >>> 16,
        n[0] & 0xffff,
        n[1] >>> 16,
        n[1] & 0xffff
    ];
    var o = [
        0,
        0,
        0,
        0
    ];
    o[3] += m[3] * n[3];
    o[2] += o[3] >>> 16;
    o[3] &= 0xffff;
    o[2] += m[2] * n[3];
    o[1] += o[2] >>> 16;
    o[2] &= 0xffff;
    o[2] += m[3] * n[2];
    o[1] += o[2] >>> 16;
    o[2] &= 0xffff;
    o[1] += m[1] * n[3];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[1] += m[2] * n[2];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[1] += m[3] * n[1];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[0] += m[0] * n[3] + m[1] * n[2] + m[2] * n[1] + m[3] * n[0];
    o[0] &= 0xffff;
    return [
        o[0] << 16 | o[1],
        o[2] << 16 | o[3]
    ];
};
var $458d8d5b9f9f3033$var$x64Rotl = function(m, n) {
    n %= 64;
    if (n === 32) return [
        m[1],
        m[0]
    ];
    else if (n < 32) return [
        m[0] << n | m[1] >>> 32 - n,
        m[1] << n | m[0] >>> 32 - n
    ];
    else {
        n -= 32;
        return [
            m[1] << n | m[0] >>> 32 - n,
            m[0] << n | m[1] >>> 32 - n
        ];
    }
};
var $458d8d5b9f9f3033$var$x64LeftShift = function(m, n) {
    n %= 64;
    if (n === 0) return m;
    else if (n < 32) return [
        m[0] << n | m[1] >>> 32 - n,
        m[1] << n
    ];
    else return [
        m[1] << n - 32,
        0
    ];
};
var $458d8d5b9f9f3033$var$x64Xor = function(m, n) {
    return [
        m[0] ^ n[0],
        m[1] ^ n[1]
    ];
};
var $458d8d5b9f9f3033$var$x64Fmix = function(h) {
    h = $458d8d5b9f9f3033$var$x64Xor(h, [
        0,
        h[0] >>> 1
    ]);
    h = $458d8d5b9f9f3033$var$x64Multiply(h, [
        0xff51afd7,
        0xed558ccd
    ]);
    h = $458d8d5b9f9f3033$var$x64Xor(h, [
        0,
        h[0] >>> 1
    ]);
    h = $458d8d5b9f9f3033$var$x64Multiply(h, [
        0xc4ceb9fe,
        0x1a85ec53
    ]);
    h = $458d8d5b9f9f3033$var$x64Xor(h, [
        0,
        h[0] >>> 1
    ]);
    return h;
};
$458d8d5b9f9f3033$exports.x64hash128 = function(key, seed) {
    key = key || '';
    seed = seed || 0;
    var remainder = key.length % 16;
    var bytes = key.length - remainder;
    var h1 = [
        0,
        seed
    ];
    var h2 = [
        0,
        seed
    ];
    var k1 = [
        0,
        0
    ];
    var k2 = [
        0,
        0
    ];
    var c1 = [
        0x87c37b91,
        0x114253d5
    ];
    var c2 = [
        0x4cf5ad43,
        0x2745937f
    ];
    for(var i = 0; i < bytes; i = i + 16){
        k1 = [
            key.charCodeAt(i + 4) & 0xff | (key.charCodeAt(i + 5) & 0xff) << 8 | (key.charCodeAt(i + 6) & 0xff) << 16 | (key.charCodeAt(i + 7) & 0xff) << 24,
            key.charCodeAt(i) & 0xff | (key.charCodeAt(i + 1) & 0xff) << 8 | (key.charCodeAt(i + 2) & 0xff) << 16 | (key.charCodeAt(i + 3) & 0xff) << 24
        ];
        k2 = [
            key.charCodeAt(i + 12) & 0xff | (key.charCodeAt(i + 13) & 0xff) << 8 | (key.charCodeAt(i + 14) & 0xff) << 16 | (key.charCodeAt(i + 15) & 0xff) << 24,
            key.charCodeAt(i + 8) & 0xff | (key.charCodeAt(i + 9) & 0xff) << 8 | (key.charCodeAt(i + 10) & 0xff) << 16 | (key.charCodeAt(i + 11) & 0xff) << 24
        ];
        k1 = $458d8d5b9f9f3033$var$x64Multiply(k1, c1);
        k1 = $458d8d5b9f9f3033$var$x64Rotl(k1, 31);
        k1 = $458d8d5b9f9f3033$var$x64Multiply(k1, c2);
        h1 = $458d8d5b9f9f3033$var$x64Xor(h1, k1);
        h1 = $458d8d5b9f9f3033$var$x64Rotl(h1, 27);
        h1 = $458d8d5b9f9f3033$var$x64Add(h1, h2);
        h1 = $458d8d5b9f9f3033$var$x64Add($458d8d5b9f9f3033$var$x64Multiply(h1, [
            0,
            5
        ]), [
            0,
            0x52dce729
        ]);
        k2 = $458d8d5b9f9f3033$var$x64Multiply(k2, c2);
        k2 = $458d8d5b9f9f3033$var$x64Rotl(k2, 33);
        k2 = $458d8d5b9f9f3033$var$x64Multiply(k2, c1);
        h2 = $458d8d5b9f9f3033$var$x64Xor(h2, k2);
        h2 = $458d8d5b9f9f3033$var$x64Rotl(h2, 31);
        h2 = $458d8d5b9f9f3033$var$x64Add(h2, h1);
        h2 = $458d8d5b9f9f3033$var$x64Add($458d8d5b9f9f3033$var$x64Multiply(h2, [
            0,
            5
        ]), [
            0,
            0x38495ab5
        ]);
    }
    k1 = [
        0,
        0
    ];
    k2 = [
        0,
        0
    ];
    var iX = bytes;
    switch(remainder){
        case 15:
            k2 = $458d8d5b9f9f3033$var$x64Xor(k2, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 14)
            ], 48));
        case 14:
            k2 = $458d8d5b9f9f3033$var$x64Xor(k2, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 13)
            ], 40));
        case 13:
            k2 = $458d8d5b9f9f3033$var$x64Xor(k2, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 12)
            ], 32));
        case 12:
            k2 = $458d8d5b9f9f3033$var$x64Xor(k2, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 11)
            ], 24));
        case 11:
            k2 = $458d8d5b9f9f3033$var$x64Xor(k2, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 10)
            ], 16));
        case 10:
            k2 = $458d8d5b9f9f3033$var$x64Xor(k2, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 9)
            ], 8));
        case 9:
            k2 = $458d8d5b9f9f3033$var$x64Xor(k2, [
                0,
                key.charCodeAt(iX + 8)
            ]);
            k2 = $458d8d5b9f9f3033$var$x64Multiply(k2, c2);
            k2 = $458d8d5b9f9f3033$var$x64Rotl(k2, 33);
            k2 = $458d8d5b9f9f3033$var$x64Multiply(k2, c1);
            h2 = $458d8d5b9f9f3033$var$x64Xor(h2, k2);
        case 8:
            k1 = $458d8d5b9f9f3033$var$x64Xor(k1, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 7)
            ], 56));
        case 7:
            k1 = $458d8d5b9f9f3033$var$x64Xor(k1, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 6)
            ], 48));
        case 6:
            k1 = $458d8d5b9f9f3033$var$x64Xor(k1, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 5)
            ], 40));
        case 5:
            k1 = $458d8d5b9f9f3033$var$x64Xor(k1, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 4)
            ], 32));
        case 4:
            k1 = $458d8d5b9f9f3033$var$x64Xor(k1, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 3)
            ], 24));
        case 3:
            k1 = $458d8d5b9f9f3033$var$x64Xor(k1, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 2)
            ], 16));
        case 2:
            k1 = $458d8d5b9f9f3033$var$x64Xor(k1, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 1)
            ], 8));
        case 1:
            k1 = $458d8d5b9f9f3033$var$x64Xor(k1, [
                0,
                key.charCodeAt(iX)
            ]);
            k1 = $458d8d5b9f9f3033$var$x64Multiply(k1, c1);
            k1 = $458d8d5b9f9f3033$var$x64Rotl(k1, 31);
            k1 = $458d8d5b9f9f3033$var$x64Multiply(k1, c2);
            h1 = $458d8d5b9f9f3033$var$x64Xor(h1, k1);
    }
    h1 = $458d8d5b9f9f3033$var$x64Xor(h1, [
        0,
        key.length
    ]);
    h2 = $458d8d5b9f9f3033$var$x64Xor(h2, [
        0,
        key.length
    ]);
    h1 = $458d8d5b9f9f3033$var$x64Add(h1, h2);
    h2 = $458d8d5b9f9f3033$var$x64Add(h2, h1);
    h1 = $458d8d5b9f9f3033$var$x64Fmix(h1);
    h2 = $458d8d5b9f9f3033$var$x64Fmix(h2);
    h1 = $458d8d5b9f9f3033$var$x64Add(h1, h2);
    h2 = $458d8d5b9f9f3033$var$x64Add(h2, h1);
    return ('00000000' + (h1[0] >>> 0).toString(16)).slice(-8) + ('00000000' + (h1[1] >>> 0).toString(16)).slice(-8) + ('00000000' + (h2[0] >>> 0).toString(16)).slice(-8) + ('00000000' + (h2[1] >>> 0).toString(16)).slice(-8);
};


var $80509bb111a91081$var$UIDGenerator = function() {
    function UIDGenerator() {}
    UIDGenerator.getDetails = function() {
        try {
            return {
                browser: {
                    browserDefaultEvalLength: $3d8c7377a85fa527$exports.browserDefaultEvalLength(),
                    canWriteCookie: $3d8c7377a85fa527$exports.canWriteCookie(),
                    getBrowserVendor: $3d8c7377a85fa527$exports.getBrowserVendor(),
                    getHardwareConcurrency: $3d8c7377a85fa527$exports.getHardwareConcurrency(),
                    getLanguage: $3d8c7377a85fa527$exports.getLanguage(),
                    getPlatform: $3d8c7377a85fa527$exports.getPlatform(),
                    getPlugins: $3d8c7377a85fa527$exports.getPlugins(),
                    getProductSub: $3d8c7377a85fa527$exports.getProductSub(),
                    getTimeZone: $3d8c7377a85fa527$exports.getTimeZone(),
                    getTimeZoneOffset: $3d8c7377a85fa527$exports.getTimeZoneOffset(),
                    getUserAgent: $3d8c7377a85fa527$exports.getUserAgent(),
                    isIndexedDBAvailable: $3d8c7377a85fa527$exports.isIndexedDBAvailable(),
                    isLocalStorageAvailable: $3d8c7377a85fa527$exports.isLocalStorageAvailable(),
                    isSessionStorageAvailable: $3d8c7377a85fa527$exports.isSessionStorageAvailable(),
                    isTestingBot: $3d8c7377a85fa527$exports.isTestingBot(),
                    isWebDriver: $3d8c7377a85fa527$exports.isWebDriver()
                },
                canvas: {
                    studyPrint: $b2289a3a1290497e$exports.studyPrint()
                },
                font: {
                    jsFonts: new $d58e2d37ce0b81a6$exports.DetectFonts().detect()
                },
                webGL: {
                    getWebGL: $f54acdfa91569540$exports.getWebGL()
                }
            };
        } catch (err) {
            return $96e78a72aef15085$exports.ERROR;
        }
    };
    UIDGenerator.getValue = function(cachedUids) {
        try {
            var values = [
                $3d8c7377a85fa527$exports.browserDefaultEvalLength(),
                $3d8c7377a85fa527$exports.canWriteCookie(),
                $3d8c7377a85fa527$exports.getBrowserVendor(),
                $3d8c7377a85fa527$exports.getHardwareConcurrency(),
                $3d8c7377a85fa527$exports.getLanguage(),
                $3d8c7377a85fa527$exports.getPlatform(),
                $3d8c7377a85fa527$exports.getPlugins(),
                $3d8c7377a85fa527$exports.getProductSub(),
                $3d8c7377a85fa527$exports.getTimeZone(),
                $3d8c7377a85fa527$exports.getTimeZoneOffset(),
                $3d8c7377a85fa527$exports.getUserAgent(),
                $3d8c7377a85fa527$exports.isIndexedDBAvailable(),
                $3d8c7377a85fa527$exports.isLocalStorageAvailable(),
                $3d8c7377a85fa527$exports.isSessionStorageAvailable(),
                $3d8c7377a85fa527$exports.isTestingBot(),
                $3d8c7377a85fa527$exports.isWebDriver(),
                $b2289a3a1290497e$exports.studyPrint(),
                new $d58e2d37ce0b81a6$exports.DetectFonts().result(),
                $f54acdfa91569540$exports.getWebGL()
            ];
            var value = $458d8d5b9f9f3033$exports.x64hash128(values.join("|"), 64);
            var state = void 0;
            if (!cachedUids.length) state = $a576733921801e90$exports.XIDState.NEW;
            else if (cachedUids[0].value === value) state = $a576733921801e90$exports.XIDState.EXISTING;
            else state = $a576733921801e90$exports.XIDState.CHANGED;
            return state === $a576733921801e90$exports.XIDState.EXISTING ? cachedUids : $l2Z7B.__spreadArrays([
                {
                    type: $a576733921801e90$exports.XIDItemType.UID,
                    createdAt: new Date().toISOString(),
                    state: state,
                    value: value
                }
            ], cachedUids);
        } catch (err) {
            return [
                {
                    type: $a576733921801e90$exports.XIDItemType.UID,
                    state: $a576733921801e90$exports.XIDState.ERROR
                }
            ];
        }
    };
    return UIDGenerator;
}();
$80509bb111a91081$exports.UIDGenerator = $80509bb111a91081$var$UIDGenerator;


var $5b77bf485bccaea8$exports = {};
"use strict";
Object.defineProperty($5b77bf485bccaea8$exports, "__esModule", {
    value: true
});

var $l2Z7B = parcelRequire("l2Z7B");

var $5b77bf485bccaea8$var$promise_polyfill_1 = $l2Z7B.__importDefault((parcelRequire("7UOcZ")));



var $5b77bf485bccaea8$var$TEST_HOST = '';
var $5b77bf485bccaea8$var$DEV_HOST = 'xxid.dev.atl-paas.net';
var $5b77bf485bccaea8$var$STG_HOST = 'xxid.staging.atl-paas.net';
var $5b77bf485bccaea8$var$PROD_FALLBACK_HOST = 'xxid.atl-paas.net';
var $5b77bf485bccaea8$var$PROD_HOST = 'xxid.atlassian.com';
var $5b77bf485bccaea8$var$defaultTimeout = 3000;
var $5b77bf485bccaea8$var$XCGenerator = function() {
    function XCGenerator() {}
    XCGenerator.getValue = function(env, timeout, isStorageEnabled) {
        if (timeout === void 0) timeout = $5b77bf485bccaea8$var$defaultTimeout;
        if (isStorageEnabled === void 0) isStorageEnabled = true;
        var xxidHost = XCGenerator.getHost(env);
        var xxidOrigin = xxidHost ? "https://" + xxidHost : '';
        var iframeUrl = xxidOrigin ? xxidOrigin + "?t=" + new Date().getTime() : '';
        var frame = XCGenerator.addFrame(iframeUrl);
        return new $5b77bf485bccaea8$var$promise_polyfill_1.default(function(resolve) {
            var listen = function(event) {
                if (event.data.type === "xcReady" && event.origin === xxidOrigin) {
                    var xc = XCGenerator.messageToXc(event);
                    if (isStorageEnabled) xc = $43113123be356ccf$exports.Storage.updateXc(env, xc);
                    resolve(xc);
                    XCGenerator.removeFrame(frame, listen);
                }
            };
            window.addEventListener('message', listen);
            setTimeout(function() {
                resolve({
                    type: $a576733921801e90$exports.XIDItemType.XC,
                    state: $a576733921801e90$exports.XIDState.TIMEOUT
                });
                XCGenerator.removeFrame(frame, listen);
            }, timeout);
        });
    };
    XCGenerator.messageToXc = function(event) {
        var _a = event.data, xc = _a.xc, ts = _a.ts, state = _a.state;
        if (xc && !!Date.parse(ts) && state) return {
            type: $a576733921801e90$exports.XIDItemType.XC,
            value: xc,
            createdAt: ts,
            state: state
        };
        else return {
            type: $a576733921801e90$exports.XIDItemType.XC,
            state: state ? state : $a576733921801e90$exports.XIDState.MALFORMED
        };
    };
    XCGenerator.addFrame = function(url) {
        var frame = document.createElement('iframe');
        frame.id = "xc-" + new Date().getTime();
        frame.src = url;
        frame.style.display = 'none';
        frame.style.position = 'fixed';
        document.body.appendChild(frame);
        return frame;
    };
    XCGenerator.removeFrame = function(frame, listen) {
        if (document.body.contains(frame)) {
            document.body.removeChild(frame);
            window.removeEventListener('message', listen);
        }
    };
    XCGenerator.getHost = function(env) {
        switch(env){
            case $a576733921801e90$exports.Environment.STAGE:
                return $5b77bf485bccaea8$var$STG_HOST;
            case $a576733921801e90$exports.Environment.PROD:
                return $e226362dd6674ff5$exports.isAtlassianComDomain() ? $5b77bf485bccaea8$var$PROD_FALLBACK_HOST : $5b77bf485bccaea8$var$PROD_HOST;
            case $a576733921801e90$exports.Environment.TEST:
                return $5b77bf485bccaea8$var$TEST_HOST;
            case $a576733921801e90$exports.Environment.LOCAL:
            case $a576733921801e90$exports.Environment.DEV:
            default:
                return $5b77bf485bccaea8$var$DEV_HOST;
        }
    };
    return XCGenerator;
}();
$5b77bf485bccaea8$exports.XCGenerator = $5b77bf485bccaea8$var$XCGenerator;


var $15f92bf84d5e00ff$exports = {};
"use strict";
Object.defineProperty($15f92bf84d5e00ff$exports, "__esModule", {
    value: true
});

var $4qBHc = parcelRequire("4qBHc");
var $15f92bf84d5e00ff$var$maptoNewXidCandidate = function(item, promiseStartTime) {
    var state = item.state, type = item.type, value = item.value, createdAt = item.createdAt;
    if (item && state && type && value && createdAt && (state === $4qBHc.XIDState.NEW || state === $4qBHc.XIDState.CHANGED)) return {
        state: state,
        type: type,
        value: value,
        createdAt: createdAt,
        timeTaken: $15f92bf84d5e00ff$var$getCurrentTime() - promiseStartTime
    };
    return null;
};
var $15f92bf84d5e00ff$var$maptoExistingXid = function(item) {
    var state = item.state, type = item.type, value = item.value, createdAt = item.createdAt;
    if (item && state && type && value && createdAt && state === $4qBHc.XIDState.EXISTING) return {
        state: state,
        type: type,
        value: value,
        createdAt: createdAt
    };
    return null;
};
var $15f92bf84d5e00ff$var$mapToAmbiguousXid = function(item) {
    var state = item.state, type = item.type;
    if (item && state && type) switch(state){
        case $4qBHc.XIDState.TIMEOUT:
        case $4qBHc.XIDState.ERROR:
        case $4qBHc.XIDState.UNAVAILABLE:
        case $4qBHc.XIDState.UNKNOWN:
        case $4qBHc.XIDState.MALFORMED:
            return {
                type: type,
                state: state
            };
    }
    return null;
};
var $15f92bf84d5e00ff$var$mapToMalformedXid = function(item) {
    var type = item.type;
    if (item && type) return {
        type: type,
        state: $4qBHc.XIDState.MALFORMED
    };
    return null;
};
function $15f92bf84d5e00ff$var$promiseWithTimer(fn) {
    var addTimeTaken = function(item) {
        var fallbackXid = {
            type: $4qBHc.XIDItemType.UID,
            state: $4qBHc.XIDState.MALFORMED
        };
        return $15f92bf84d5e00ff$var$maptoNewXidCandidate(item, start) || $15f92bf84d5e00ff$var$maptoExistingXid(item) || $15f92bf84d5e00ff$var$mapToAmbiguousXid(item) || $15f92bf84d5e00ff$var$mapToMalformedXid(item) || fallbackXid;
    };
    var onPromiseDone = function(data) {
        return data.map(function(item) {
            return addTimeTaken(item);
        });
    };
    var start = $15f92bf84d5e00ff$var$getCurrentTime();
    return fn().then(onPromiseDone);
}
$15f92bf84d5e00ff$exports.promiseWithTimer = $15f92bf84d5e00ff$var$promiseWithTimer;
var $15f92bf84d5e00ff$var$getCurrentTime = function() {
    if (performance && performance.now) return performance.now();
    return new Date().getTime();
};



var $4qBHc = parcelRequire("4qBHc");
$5cdc7272fdf5cc1c$exports.defaultTimeout = 5000;
var $5cdc7272fdf5cc1c$var$delayUidGenerate = 1e3;
var $5cdc7272fdf5cc1c$var$nonProdMaxTimeout = 30000;
var $5cdc7272fdf5cc1c$var$prodMaxTimeout = 10000;
var $5cdc7272fdf5cc1c$var$minTimeout = 2000;
var $5cdc7272fdf5cc1c$var$XID = function() {
    function XID(env, timeout) {
        if (env === void 0) env = $4qBHc.Environment.LOCAL;
        if (timeout === void 0) timeout = $5cdc7272fdf5cc1c$exports.defaultTimeout;
        this.storageEnabled = true;
        this.timeoutUid = {
            type: $4qBHc.XIDItemType.UID,
            state: $4qBHc.XIDState.TIMEOUT
        };
        if (!env) throw new Error('Missing env configuration');
        this.env = env;
        var maxTimeout = this.env === $4qBHc.Environment.PROD ? $5cdc7272fdf5cc1c$var$prodMaxTimeout : $5cdc7272fdf5cc1c$var$nonProdMaxTimeout;
        if (timeout >= $5cdc7272fdf5cc1c$var$minTimeout && timeout <= maxTimeout) this.timeout = timeout;
        else {
            if (this.env !== $4qBHc.Environment.PROD) console.log("timeout configuration must be in the range of [" + $5cdc7272fdf5cc1c$var$minTimeout + ", " + maxTimeout + "] seconds");
            this.timeout = $5cdc7272fdf5cc1c$exports.defaultTimeout;
        }
    }
    XID.prototype.getTimeoutPromise = function(timeoutXid) {
        var _this = this;
        return new $5cdc7272fdf5cc1c$var$promise_polyfill_1.default(function(resolve) {
            setTimeout(function() {
                resolve([
                    timeoutXid
                ]);
            }, (_this.timeout - $5cdc7272fdf5cc1c$var$delayUidGenerate) / 2);
        });
    };
    XID.prototype.getXcPromiseAndSave = function() {
        var _this = this;
        return new $5cdc7272fdf5cc1c$var$promise_polyfill_1.default(function(resolve) {
            _this.getXc().then(function(xc) {
                if (_this.storageEnabled) $43113123be356ccf$exports.Storage.saveXid([
                    xc
                ]);
                resolve([
                    xc
                ]);
            });
        });
    };
    XID.prototype.getUidPromiseAndSave = function() {
        var _this = this;
        return new $5cdc7272fdf5cc1c$var$promise_polyfill_1.default(function(resolve) {
            var handleUid = function() {
                var cachedUids = [];
                if (_this.storageEnabled) cachedUids = $43113123be356ccf$exports.Storage.getUids();
                var uids = $80509bb111a91081$exports.UIDGenerator.getValue(cachedUids);
                if (_this.storageEnabled) {
                    $43113123be356ccf$exports.Storage.saveUids(uids);
                    $43113123be356ccf$exports.Storage.saveXid(uids);
                }
                resolve(uids);
            };
            var requestIdleCallback = window.requestIdleCallback;
            requestIdleCallback ? requestIdleCallback(handleUid) : setTimeout(handleUid, $5cdc7272fdf5cc1c$var$delayUidGenerate);
        });
    };
    XID.prototype.getXidPromiseInXcUidOnly = function() {
        var _this = this;
        return this.getXcPromiseAndSave().then(function(xc) {
            if (xc && xc.length > 0 && xc[0].createdAt && xc[0].value) return xc;
            else return _this.getTimeoutPromise(_this.timeoutUid), _this.getUidPromiseAndSave().then(function(uid) {
                return $l2Z7B.__spreadArrays(uid, xc);
            });
        });
    };
    XID.prototype.getXidCallbackForPromise = function(mode, storageEnabled) {
        if (mode === void 0) mode = $4qBHc.XIDGenerateMode.CACHE_XC_UID;
        if (storageEnabled === void 0) storageEnabled = true;
        var transformedXids;
        var transform = function(xids) {
            if (transformedXids) return transformedXids;
            transformedXids = xids.map(function(xid) {
                if (xid.state === $4qBHc.XIDState.NEW || xid.state === $4qBHc.XIDState.CHANGED) return {
                    state: $4qBHc.XIDState.EXISTING,
                    type: xid.type,
                    createdAt: xid.createdAt,
                    value: xid.value
                };
                return xid;
            });
            return xids;
        };
        return this.getXidPromise(mode, storageEnabled).then(function(xid) {
            return function() {
                return transform(xid);
            };
        });
    };
    XID.prototype.getXidPromise = function(mode, storageEnabled) {
        var _this = this;
        if (mode === void 0) mode = $4qBHc.XIDGenerateMode.CACHE_XC_UID;
        if (storageEnabled === void 0) storageEnabled = true;
        this.storageEnabled = storageEnabled;
        var cachedXidValue = mode === $4qBHc.XIDGenerateMode.CACHE_ONLY || mode === $4qBHc.XIDGenerateMode.CACHE_XC_UID ? $43113123be356ccf$exports.Storage.getCachedXID() : [];
        switch(mode){
            case $4qBHc.XIDGenerateMode.XC_ONLY:
                return $15f92bf84d5e00ff$exports.promiseWithTimer(function() {
                    return _this.getXcPromiseAndSave();
                });
            case $4qBHc.XIDGenerateMode.UID_ONLY:
                return $15f92bf84d5e00ff$exports.promiseWithTimer(function() {
                    return $5cdc7272fdf5cc1c$var$promise_polyfill_1.default.race([
                        _this.getTimeoutPromise(_this.timeoutUid),
                        _this.getUidPromiseAndSave()
                    ]);
                });
            case $4qBHc.XIDGenerateMode.XC_UID:
                return $15f92bf84d5e00ff$exports.promiseWithTimer(function() {
                    return _this.getXidPromiseInXcUidOnly();
                });
            case $4qBHc.XIDGenerateMode.CACHE_ONLY:
                return $5cdc7272fdf5cc1c$var$promise_polyfill_1.default.resolve(cachedXidValue);
            case $4qBHc.XIDGenerateMode.CACHE_XC_UID:
            default:
                return cachedXidValue.length > 0 ? $5cdc7272fdf5cc1c$var$promise_polyfill_1.default.resolve(cachedXidValue) : $15f92bf84d5e00ff$exports.promiseWithTimer(function() {
                    return _this.getXidPromiseInXcUidOnly();
                });
        }
    };
    XID.prototype.getXc = function() {
        return $5b77bf485bccaea8$exports.XCGenerator.getValue(this.env, (this.timeout - $5cdc7272fdf5cc1c$var$delayUidGenerate) / 2, this.storageEnabled);
    };
    XID.prototype.getUidDetails = function() {
        return $80509bb111a91081$exports.UIDGenerator.getDetails();
    };
    return XID;
}();
$5cdc7272fdf5cc1c$exports.XID = $5cdc7272fdf5cc1c$var$XID;


$a576733921801e90$exports.XID = $5cdc7272fdf5cc1c$exports.XID;


var $000760bdf95e0c2b$exports = {};
"use strict";
Object.defineProperty($000760bdf95e0c2b$exports, "__esModule", {
    value: true
});
$000760bdf95e0c2b$exports.ENVIRONMENT = $000760bdf95e0c2b$exports.CONSENT_KEY = void 0;
var $000760bdf95e0c2b$var$ENVIRONMENT = $000760bdf95e0c2b$exports.ENVIRONMENT = /*#__PURE__*/ function(ENVIRONMENT) {
    ENVIRONMENT["LOCAL"] = "local";
    ENVIRONMENT["DEV"] = "development";
    ENVIRONMENT["STAGING"] = "staging";
    ENVIRONMENT["PROD"] = "production";
    return ENVIRONMENT;
}({});
var $000760bdf95e0c2b$var$CONSENT_KEY = $000760bdf95e0c2b$exports.CONSENT_KEY = {
    COMMUNITY: 'communityTermsOfService',
    PRIVACY: 'privacyPolicy'
};


function $9b8dc532c3c3f9ae$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9b8dc532c3c3f9ae$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9b8dc532c3c3f9ae$var$_typeof(o);
}
function $9b8dc532c3c3f9ae$var$_defineProperty(e, r, t) {
    return (r = $9b8dc532c3c3f9ae$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $9b8dc532c3c3f9ae$var$_toPropertyKey(t) {
    var i = $9b8dc532c3c3f9ae$var$_toPrimitive(t, "string");
    return "symbol" == $9b8dc532c3c3f9ae$var$_typeof(i) ? i : i + "";
}
function $9b8dc532c3c3f9ae$var$_toPrimitive(t, r) {
    if ("object" != $9b8dc532c3c3f9ae$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9b8dc532c3c3f9ae$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $9b8dc532c3c3f9ae$var$ENV_TO_ANALYTICS_ENV_TYPE = $9b8dc532c3c3f9ae$var$_defineProperty($9b8dc532c3c3f9ae$var$_defineProperty($9b8dc532c3c3f9ae$var$_defineProperty($9b8dc532c3c3f9ae$var$_defineProperty({}, $000760bdf95e0c2b$exports.ENVIRONMENT.LOCAL, $dpXUu.envType.LOCAL), $000760bdf95e0c2b$exports.ENVIRONMENT.DEV, $dpXUu.envType.DEV), $000760bdf95e0c2b$exports.ENVIRONMENT.STAGING, $dpXUu.envType.STAGING), $000760bdf95e0c2b$exports.ENVIRONMENT.PROD, $dpXUu.envType.PROD);
var $9b8dc532c3c3f9ae$var$ENV_TO_XID_ENV = $9b8dc532c3c3f9ae$var$_defineProperty($9b8dc532c3c3f9ae$var$_defineProperty($9b8dc532c3c3f9ae$var$_defineProperty($9b8dc532c3c3f9ae$var$_defineProperty({}, $000760bdf95e0c2b$exports.ENVIRONMENT.LOCAL, $a576733921801e90$exports.Environment.LOCAL), $000760bdf95e0c2b$exports.ENVIRONMENT.DEV, $a576733921801e90$exports.Environment.DEV), $000760bdf95e0c2b$exports.ENVIRONMENT.STAGING, $a576733921801e90$exports.Environment.STAGE), $000760bdf95e0c2b$exports.ENVIRONMENT.PROD, $a576733921801e90$exports.Environment.PROD);
var $9b8dc532c3c3f9ae$var$ENV_TO_ANALYTICS_WRITE_KEY = $9b8dc532c3c3f9ae$var$_defineProperty($9b8dc532c3c3f9ae$var$_defineProperty($9b8dc532c3c3f9ae$var$_defineProperty($9b8dc532c3c3f9ae$var$_defineProperty({}, $000760bdf95e0c2b$exports.ENVIRONMENT.LOCAL, 'SBLZG3ZYcSBcUMeLKLalrtyW8w1Caold'), $000760bdf95e0c2b$exports.ENVIRONMENT.DEV, 'SBLZG3ZYcSBcUMeLKLalrtyW8w1Caold'), $000760bdf95e0c2b$exports.ENVIRONMENT.STAGING, '4J6H7c3XTcpm1dbenkOILSyOachvf9It'), $000760bdf95e0c2b$exports.ENVIRONMENT.PROD, 'TNnhg0QuQfHEpBTzp27kJXNWZoMqSvkw');
var $9b8dc532c3c3f9ae$var$getEnvironment = $9b8dc532c3c3f9ae$exports.getEnvironment = function getEnvironment(env) {
    var _process$env$CLIENT_L, _ref;
    if (env) return env;
    var processEnv = (_process$env$CLIENT_L = undefined, _process$env$CLIENT_L !== void 0) ? _process$env$CLIENT_L : "production";
    return (_ref = processEnv) !== null && _ref !== void 0 ? _ref : $000760bdf95e0c2b$exports.ENVIRONMENT.LOCAL;
};
var $9b8dc532c3c3f9ae$var$getGASv3Environment = $9b8dc532c3c3f9ae$exports.getGASv3Environment = function getGASv3Environment(environment) {
    return $9b8dc532c3c3f9ae$var$ENV_TO_ANALYTICS_ENV_TYPE[environment !== null && environment !== void 0 ? environment : $9b8dc532c3c3f9ae$var$getEnvironment()];
};
var $9b8dc532c3c3f9ae$var$getXidEnvironment = $9b8dc532c3c3f9ae$exports.getXidEnvironment = function getXidEnvironment(environment) {
    return $9b8dc532c3c3f9ae$var$ENV_TO_XID_ENV[environment !== null && environment !== void 0 ? environment : $9b8dc532c3c3f9ae$var$getEnvironment()];
};
var $9b8dc532c3c3f9ae$var$getAnalyticsWriteKey = $9b8dc532c3c3f9ae$exports.getAnalyticsWriteKey = function getAnalyticsWriteKey(environment) {
    return $9b8dc532c3c3f9ae$var$ENV_TO_ANALYTICS_WRITE_KEY[environment !== null && environment !== void 0 ? environment : $9b8dc532c3c3f9ae$var$getEnvironment()];
};
var $9b8dc532c3c3f9ae$var$shouldUseStargate = $9b8dc532c3c3f9ae$exports.shouldUseStargate = function shouldUseStargate(environment) {
    switch(environment !== null && environment !== void 0 ? environment : $9b8dc532c3c3f9ae$var$getEnvironment()){
        case $000760bdf95e0c2b$exports.ENVIRONMENT.PROD:
        case $000760bdf95e0c2b$exports.ENVIRONMENT.STAGING:
            return true;
        case $000760bdf95e0c2b$exports.ENVIRONMENT.DEV:
        default:
            return false;
    }
};
var $9b8dc532c3c3f9ae$var$getUppApiPathFromEnvironment = $9b8dc532c3c3f9ae$exports.getUppApiPathFromEnvironment = function getUppApiPathFromEnvironment(env) {
    var environment = $9b8dc532c3c3f9ae$var$getEnvironment(env);
    switch(environment){
        case $000760bdf95e0c2b$exports.ENVIRONMENT.DEV:
            return '/gateway/api/graphql?serviceOverride=upp_service_api=https://upp-service-api.ap-southeast-2.dev.atl-paas.net/api/graphql';
        default:
            return '/gateway/api/graphql';
    }
};
var $9b8dc532c3c3f9ae$var$ENVIRONMENT_CONFIGS = $9b8dc532c3c3f9ae$exports.ENVIRONMENT_CONFIGS = $9b8dc532c3c3f9ae$var$_defineProperty($9b8dc532c3c3f9ae$var$_defineProperty($9b8dc532c3c3f9ae$var$_defineProperty($9b8dc532c3c3f9ae$var$_defineProperty({}, $000760bdf95e0c2b$exports.ENVIRONMENT.LOCAL, {
    HOME_BASE_URL: 'https://community.dev.atlassian.com',
    KHOROS_ENDPOINT_PATH: 'atlassiandev3',
    IDENTITY_BASE_URL: 'https://id.stg.internal.atlassian.com'
}), $000760bdf95e0c2b$exports.ENVIRONMENT.DEV, {
    HOME_BASE_URL: 'https://community.dev.atlassian.com',
    KHOROS_ENDPOINT_PATH: 'atlassiandev3',
    IDENTITY_BASE_URL: 'https://id.stg.internal.atlassian.com'
}), $000760bdf95e0c2b$exports.ENVIRONMENT.STAGING, {
    HOME_BASE_URL: 'https://community.stg.atlassian.com',
    KHOROS_ENDPOINT_PATH: 'atlassiandev',
    IDENTITY_BASE_URL: 'https://id.stg.internal.atlassian.com'
}), $000760bdf95e0c2b$exports.ENVIRONMENT.PROD, {
    HOME_BASE_URL: 'https://community.atlassian.com',
    KHOROS_ENDPOINT_PATH: 'atlassian',
    IDENTITY_BASE_URL: 'https://id.atlassian.com'
});


var $5af8fa5f3021d79b$exports = {};
"use strict";
Object.defineProperty($5af8fa5f3021d79b$exports, "__esModule", {
    value: true
});
$5af8fa5f3021d79b$exports.hasConsentMutationError = $5af8fa5f3021d79b$var$hasConsentMutationError;
$5af8fa5f3021d79b$exports.isUnifiedAccountQueryError = $5af8fa5f3021d79b$var$isUnifiedAccountQueryError;
$5af8fa5f3021d79b$exports.isUnifiedQueryError = $5af8fa5f3021d79b$var$isUnifiedQueryError;
function $5af8fa5f3021d79b$var$isUnifiedQueryError(response) {
    return 'identifier' in response;
}
function $5af8fa5f3021d79b$var$hasConsentMutationError(response) {
    return response.errors != null && Array.isArray(response.errors) && response.errors.length > 0;
}
function $5af8fa5f3021d79b$var$isUnifiedAccountQueryError(response) {
    return 'identifier' in response;
}


function $9274af858143a4bd$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $9274af858143a4bd$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $9274af858143a4bd$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($9274af858143a4bd$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $9274af858143a4bd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9274af858143a4bd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9274af858143a4bd$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9274af858143a4bd$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9274af858143a4bd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9274af858143a4bd$var$_defineProperty(e, r, t) {
    return (r = $9274af858143a4bd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $9274af858143a4bd$var$_toPropertyKey(t) {
    var i = $9274af858143a4bd$var$_toPrimitive(t, "string");
    return "symbol" == $9274af858143a4bd$var$_typeof(i) ? i : i + "";
}
function $9274af858143a4bd$var$_toPrimitive(t, r) {
    if ("object" != $9274af858143a4bd$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9274af858143a4bd$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9274af858143a4bd$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $9274af858143a4bd$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $9274af858143a4bd$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $9274af858143a4bd$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
var $9274af858143a4bd$var$userConsentStatuses = $9274af858143a4bd$exports.userConsentStatuses = /*#__PURE__*/ function() {
    var _ref = $9274af858143a4bd$var$_asyncToGenerator(/*#__PURE__*/ $9274af858143a4bd$var$_regeneratorRuntime().mark(function _callee(aaid) {
        var baseUrl, Origin, env, apiPath, rawConsentResponse, consentResponse, _args = arguments;
        return $9274af858143a4bd$var$_regeneratorRuntime().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    baseUrl = _args.length > 1 && _args[1] !== undefined ? _args[1] : '';
                    Origin = _args.length > 2 ? _args[2] : undefined;
                    env = _args.length > 3 ? _args[3] : undefined;
                    apiPath = (0, $9b8dc532c3c3f9ae$exports.getUppApiPathFromEnvironment)(env);
                    _context.next = 6;
                    return fetch("".concat(baseUrl).concat(apiPath), {
                        method: 'POST',
                        headers: $9274af858143a4bd$var$_objectSpread({
                            'Content-Type': 'application/json'
                        }, Origin ? {
                            Origin: Origin
                        } : {}),
                        body: JSON.stringify({
                            query: (0, $6601efa3d6ce5781$exports.getUserIsConsentedQuery)(aaid),
                            operationName: 'USER_CONSENTED_QUERY'
                        })
                    });
                case 6:
                    rawConsentResponse = _context.sent;
                    _context.next = 9;
                    return rawConsentResponse.json();
                case 9:
                    consentResponse = _context.sent;
                    return _context.abrupt("return", consentResponse);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function userConsentStatuses(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $9274af858143a4bd$var$isUserConsented = $9274af858143a4bd$exports.isUserConsented = /*#__PURE__*/ function() {
    var _ref2 = $9274af858143a4bd$var$_asyncToGenerator(/*#__PURE__*/ $9274af858143a4bd$var$_regeneratorRuntime().mark(function _callee2(consentKeys, aaid) {
        var baseUrl, Origin, _consentStatuses$data, consentStatuses, consentObj, _args2 = arguments;
        return $9274af858143a4bd$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    baseUrl = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : '';
                    Origin = _args2.length > 3 ? _args2[3] : undefined;
                    _context2.prev = 2;
                    _context2.next = 5;
                    return $9274af858143a4bd$var$userConsentStatuses(aaid, baseUrl, Origin);
                case 5:
                    consentStatuses = _context2.sent;
                    if (!(0, $5af8fa5f3021d79b$exports.isUnifiedQueryError)(consentStatuses.data.unified.consent.getConsent)) {
                        _context2.next = 8;
                        break;
                    }
                    return _context2.abrupt("return", false);
                case 8:
                    consentObj = consentStatuses === null || consentStatuses === void 0 || (_consentStatuses$data = consentStatuses.data) === null || _consentStatuses$data === void 0 || (_consentStatuses$data = _consentStatuses$data.unified) === null || _consentStatuses$data === void 0 || (_consentStatuses$data = _consentStatuses$data.consent) === null || _consentStatuses$data === void 0 || (_consentStatuses$data = _consentStatuses$data.getConsent) === null || _consentStatuses$data === void 0 ? void 0 : _consentStatuses$data.consentObj;
                    return _context2.abrupt("return", consentKeys.every(function(key) {
                        var consentStatus = consentObj === null || consentObj === void 0 ? void 0 : consentObj.find(function(consent) {
                            return consent.consentKey === key;
                        });
                        if ((consentStatus === null || consentStatus === void 0 ? void 0 : consentStatus.consentStatus) === 'true') return true;
                    }));
                case 12:
                    _context2.prev = 12;
                    _context2.t0 = _context2["catch"](2);
                    console.error(_context2.t0);
                    return _context2.abrupt("return", false);
                case 16:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                2,
                12
            ]
        ]);
    }));
    return function isUserConsented(_x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();
// Set consent on UPP
var $9274af858143a4bd$var$setUserConsent = $9274af858143a4bd$exports.setUserConsent = /*#__PURE__*/ function() {
    var _ref3 = $9274af858143a4bd$var$_asyncToGenerator(/*#__PURE__*/ $9274af858143a4bd$var$_regeneratorRuntime().mark(function _callee3(consentKeys, aaid, env) {
        var baseUrl, cookie, Origin, apiPath, consentPromises, consentResponses, consentValues, _args3 = arguments;
        return $9274af858143a4bd$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    baseUrl = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : '';
                    cookie = _args3.length > 4 ? _args3[4] : undefined;
                    Origin = _args3.length > 5 ? _args3[5] : undefined;
                    _context3.prev = 3;
                    apiPath = (0, $9b8dc532c3c3f9ae$exports.getUppApiPathFromEnvironment)(env);
                    consentPromises = [];
                    consentKeys.forEach(function(key) {
                        var consentPromise = fetch("".concat(baseUrl).concat(apiPath), {
                            method: 'POST',
                            credentials: 'include',
                            headers: $9274af858143a4bd$var$_objectSpread($9274af858143a4bd$var$_objectSpread({}, Origin ? {
                                Origin: Origin
                            } : {}), {}, {
                                'Content-Type': 'application/json'
                            }, cookie ? {
                                cookie: cookie
                            } : {}),
                            body: JSON.stringify({
                                query: (0, $6eda9e6c03494bd2$exports.setUserIsConsentedMutation)(aaid, key),
                                operationName: 'SET_USER_CONSENTED_MUTATION'
                            })
                        }).then(function(response) {
                            return response.json();
                        });
                        consentPromises.push(consentPromise);
                    });
                    _context3.next = 9;
                    return Promise.all(consentPromises);
                case 9:
                    consentResponses = _context3.sent;
                    consentValues = consentResponses.map(function(response) {
                        return response.data.unified.consent.setConsent;
                    });
                    consentValues.forEach(function(values) {
                        if ((0, $5af8fa5f3021d79b$exports.hasConsentMutationError)(values)) {
                            if (values.errors && values.errors.length > 0) throw new Error("Error setting consent: ".concat(values.errors[0].message));
                        }
                    });
                    return _context3.abrupt("return", consentValues.every(function(value) {
                        return value.success;
                    }));
                case 15:
                    _context3.prev = 15;
                    _context3.t0 = _context3["catch"](3);
                    console.error('Error setting consent on UPP: ', _context3.t0);
                    return _context3.abrupt("return", false);
                case 19:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                3,
                15
            ]
        ]);
    }));
    return function setUserConsent(_x4, _x5, _x6) {
        return _ref3.apply(this, arguments);
    };
}();





var $3506c2b8472f3d94$var$_loadingSpinner = $3506c2b8472f3d94$var$_interopRequireDefault((parcelRequire("bAhZ8")));
function $3506c2b8472f3d94$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $3506c2b8472f3d94$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $3506c2b8472f3d94$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $3506c2b8472f3d94$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($3506c2b8472f3d94$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $3506c2b8472f3d94$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $3506c2b8472f3d94$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $3506c2b8472f3d94$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $3506c2b8472f3d94$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function $3506c2b8472f3d94$var$_slicedToArray(r, e) {
    return $3506c2b8472f3d94$var$_arrayWithHoles(r) || $3506c2b8472f3d94$var$_iterableToArrayLimit(r, e) || $3506c2b8472f3d94$var$_unsupportedIterableToArray(r, e) || $3506c2b8472f3d94$var$_nonIterableRest();
}
function $3506c2b8472f3d94$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3506c2b8472f3d94$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3506c2b8472f3d94$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3506c2b8472f3d94$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $3506c2b8472f3d94$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $3506c2b8472f3d94$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $3506c2b8472f3d94$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
var $3506c2b8472f3d94$var$ConsentValidator = $3506c2b8472f3d94$exports.ConsentValidator = function ConsentValidator(_ref) {
    var coverImageSrc = _ref.coverImageSrc, children = _ref.children, onLogout = _ref.onLogout, aaid = _ref.aaid, isUserConsented = _ref.isUserConsented, onConsentError = _ref.onConsentError, onConsentSuccess = _ref.onConsentSuccess, env = _ref.env;
    var _React$useState = $3506c2b8472f3d94$var$_react["default"].useState(false), _React$useState2 = $3506c2b8472f3d94$var$_slicedToArray(_React$useState, 2), handledConsent = _React$useState2[0], setHandledConsent = _React$useState2[1];
    var _React$useState3 = $3506c2b8472f3d94$var$_react["default"].useState(false), _React$useState4 = $3506c2b8472f3d94$var$_slicedToArray(_React$useState3, 2), isLoading = _React$useState4[0], setIsLoading = _React$useState4[1];
    var _React$useState5 = $3506c2b8472f3d94$var$_react["default"].useState(false), _React$useState6 = $3506c2b8472f3d94$var$_slicedToArray(_React$useState5, 2), consentError = _React$useState6[0], setConsentError = _React$useState6[1];
    var handleConsentError = function handleConsentError() {
        onConsentError();
        setConsentError(true);
    };
    var handleUserConsent = function handleUserConsent() {
        $3506c2b8472f3d94$var$_asyncToGenerator(/*#__PURE__*/ $3506c2b8472f3d94$var$_regeneratorRuntime().mark(function _callee() {
            var consentResponse;
            return $3506c2b8472f3d94$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.prev = 0;
                        if (!(aaid && !consentError)) {
                            _context.next = 7;
                            break;
                        }
                        setIsLoading(true);
                        _context.next = 5;
                        return (0, $9274af858143a4bd$exports.setUserConsent)([
                            $000760bdf95e0c2b$exports.CONSENT_KEY.COMMUNITY,
                            $000760bdf95e0c2b$exports.CONSENT_KEY.PRIVACY
                        ], aaid, env);
                    case 5:
                        consentResponse = _context.sent;
                        // Tried to set consent but still false
                        if (!consentResponse) handleConsentError();
                        else if (onConsentSuccess) onConsentSuccess();
                    case 7:
                        _context.next = 12;
                        break;
                    case 9:
                        _context.prev = 9;
                        _context.t0 = _context["catch"](0);
                        handleConsentError();
                    case 12:
                        _context.prev = 12;
                        setIsLoading(false);
                        // We have either handled the error or succesfully consented
                        setHandledConsent(true);
                        return _context.finish(12);
                    case 16:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9,
                    12,
                    16
                ]
            ]);
        }))();
    };
    if (isLoading) return /*#__PURE__*/ $3506c2b8472f3d94$var$_react["default"].createElement($3506c2b8472f3d94$var$_loadingSpinner["default"], null);
    // If not logged in, consent is true, or there is an error
    return !aaid || isUserConsented || handledConsent ? children : /*#__PURE__*/ $3506c2b8472f3d94$var$_react["default"].createElement($24c02ea0e14dbe4f$export$9d12d42929c3fcf, {
        coverImageSrc: coverImageSrc,
        onAccept: handleUserConsent,
        onCancel: onLogout
    });
};


Object.keys($3506c2b8472f3d94$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $d9a56230c565b38a$exports && $d9a56230c565b38a$exports[key] === $3506c2b8472f3d94$exports[key]) return;
    Object.defineProperty($d9a56230c565b38a$exports, key, {
        enumerable: true,
        get: function get() {
            return $3506c2b8472f3d94$exports[key];
        }
    });
});
var $b50c793e04f4978b$exports = {};
"use strict";
function $b50c793e04f4978b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b50c793e04f4978b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b50c793e04f4978b$var$_typeof(o);
}
Object.defineProperty($b50c793e04f4978b$exports, "__esModule", {
    value: true
});
$b50c793e04f4978b$exports.ConsentValidator2 = void 0;

var $b50c793e04f4978b$var$_react = $b50c793e04f4978b$var$_interopRequireDefault((parcelRequire("5FkrB")));




var $b50c793e04f4978b$var$_loadingSpinner = $b50c793e04f4978b$var$_interopRequireDefault((parcelRequire("bAhZ8")));
function $b50c793e04f4978b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $b50c793e04f4978b$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $b50c793e04f4978b$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $b50c793e04f4978b$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($b50c793e04f4978b$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $b50c793e04f4978b$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $b50c793e04f4978b$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $b50c793e04f4978b$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $b50c793e04f4978b$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function $b50c793e04f4978b$var$_slicedToArray(r, e) {
    return $b50c793e04f4978b$var$_arrayWithHoles(r) || $b50c793e04f4978b$var$_iterableToArrayLimit(r, e) || $b50c793e04f4978b$var$_unsupportedIterableToArray(r, e) || $b50c793e04f4978b$var$_nonIterableRest();
}
function $b50c793e04f4978b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b50c793e04f4978b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b50c793e04f4978b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b50c793e04f4978b$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b50c793e04f4978b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $b50c793e04f4978b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $b50c793e04f4978b$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
var $b50c793e04f4978b$var$ConsentValidator2 = $b50c793e04f4978b$exports.ConsentValidator2 = function ConsentValidator2(_ref) {
    var coverImageSrc = _ref.coverImageSrc, children = _ref.children, onLogout = _ref.onLogout, aaid = _ref.aaid, isUserConsented = _ref.isUserConsented, onConsentError = _ref.onConsentError, onConsentSuccess = _ref.onConsentSuccess, onConsentComplete = _ref.onConsentComplete, env = _ref.env;
    var _React$useState = $b50c793e04f4978b$var$_react["default"].useState(false), _React$useState2 = $b50c793e04f4978b$var$_slicedToArray(_React$useState, 2), isLoading = _React$useState2[0], setIsLoading = _React$useState2[1];
    var handleUserConsent = function handleUserConsent() {
        $b50c793e04f4978b$var$_asyncToGenerator(/*#__PURE__*/ $b50c793e04f4978b$var$_regeneratorRuntime().mark(function _callee() {
            var consentResponse;
            return $b50c793e04f4978b$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.prev = 0;
                        if (aaid) {
                            _context.next = 5;
                            break;
                        }
                        onConsentError('missing_aaid', 'AAID is required');
                        _context.next = 10;
                        break;
                    case 5:
                        setIsLoading(true);
                        _context.next = 8;
                        return (0, $9274af858143a4bd$exports.setUserConsent)([
                            $000760bdf95e0c2b$exports.CONSENT_KEY.COMMUNITY,
                            $000760bdf95e0c2b$exports.CONSENT_KEY.PRIVACY
                        ], aaid, env);
                    case 8:
                        consentResponse = _context.sent;
                        // Tried to set consent but still false
                        if (!consentResponse) onConsentError('consent_failed', 'Failed to set consent');
                        else onConsentSuccess();
                    case 10:
                        _context.next = 15;
                        break;
                    case 12:
                        _context.prev = 12;
                        _context.t0 = _context["catch"](0);
                        onConsentError('consent_failed', 'Failed to set consent' + _context.t0.message);
                    case 15:
                        _context.prev = 15;
                        setIsLoading(false);
                        if (onConsentComplete) onConsentComplete();
                        return _context.finish(15);
                    case 19:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12,
                    15,
                    19
                ]
            ]);
        }))();
    };
    if (isLoading) return /*#__PURE__*/ $b50c793e04f4978b$var$_react["default"].createElement($b50c793e04f4978b$var$_loadingSpinner["default"], null);
    // If not logged in, consent is true, or there is an error
    return isUserConsented ? children : /*#__PURE__*/ $b50c793e04f4978b$var$_react["default"].createElement($24c02ea0e14dbe4f$export$9d12d42929c3fcf, {
        coverImageSrc: coverImageSrc,
        onAccept: handleUserConsent,
        onCancel: onLogout
    });
};


Object.keys($b50c793e04f4978b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $d9a56230c565b38a$exports && $d9a56230c565b38a$exports[key] === $b50c793e04f4978b$exports[key]) return;
    Object.defineProperty($d9a56230c565b38a$exports, key, {
        enumerable: true,
        get: function get() {
            return $b50c793e04f4978b$exports[key];
        }
    });
});
var $5901c0f352881320$exports = {};
"use strict";
function $5901c0f352881320$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5901c0f352881320$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5901c0f352881320$var$_typeof(o);
}
Object.defineProperty($5901c0f352881320$exports, "__esModule", {
    value: true
});
$5901c0f352881320$exports.SuspenseExtender = void 0;

var $5901c0f352881320$var$_react = $5901c0f352881320$var$_interopRequireWildcard((parcelRequire("5FkrB")));
function $5901c0f352881320$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5901c0f352881320$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5901c0f352881320$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $5901c0f352881320$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $5901c0f352881320$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
var $5901c0f352881320$var$SuspenseExtender = $5901c0f352881320$exports.SuspenseExtender = function SuspenseExtender(_ref) {
    var children = _ref.children, fallback = _ref.fallback, isReady = _ref.isReady;
    return /*#__PURE__*/ $5901c0f352881320$var$_react["default"].createElement($5901c0f352881320$var$_react.Suspense, {
        fallback: fallback
    }, isReady === null || isReady === undefined || isReady ? children : fallback);
};


Object.keys($5901c0f352881320$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $d9a56230c565b38a$exports && $d9a56230c565b38a$exports[key] === $5901c0f352881320$exports[key]) return;
    Object.defineProperty($d9a56230c565b38a$exports, key, {
        enumerable: true,
        get: function get() {
            return $5901c0f352881320$exports[key];
        }
    });
});

var $bAhZ8 = parcelRequire("bAhZ8");
Object.keys($bAhZ8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $d9a56230c565b38a$exports && $d9a56230c565b38a$exports[key] === $bAhZ8[key]) return;
    Object.defineProperty($d9a56230c565b38a$exports, key, {
        enumerable: true,
        get: function get() {
            return $bAhZ8[key];
        }
    });
});
var $1964ee7f51f79709$exports = {};
"use strict";
function $1964ee7f51f79709$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1964ee7f51f79709$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1964ee7f51f79709$var$_typeof(o);
}
Object.defineProperty($1964ee7f51f79709$exports, "__esModule", {
    value: true
});
$1964ee7f51f79709$exports.Initializer = void 0;

var $1964ee7f51f79709$var$_react = $1964ee7f51f79709$var$_interopRequireWildcard((parcelRequire("5FkrB")));

var $1964ee7f51f79709$var$_loadingSpinner = $1964ee7f51f79709$var$_interopRequireDefault((parcelRequire("bAhZ8")));
var $bd858cf878484440$exports = {};
"use strict";
Object.defineProperty($bd858cf878484440$exports, "__esModule", {
    value: true
});
var $b39c9956eebb23a1$exports = {};
"use strict";
Object.defineProperty($b39c9956eebb23a1$exports, "__esModule", {
    value: true
});
var $eeec4b79607b6553$exports = {};
"use strict";
Object.defineProperty($eeec4b79607b6553$exports, "__esModule", {
    value: true
});
Object.defineProperty($eeec4b79607b6553$exports, "CookieCompliance", {
    enumerable: true,
    get: function get() {
        return $f1d158ad5148ce30$exports.CookieCompliance;
    }
});
Object.defineProperty($eeec4b79607b6553$exports, "InitializeAutoAtlAnalytics", {
    enumerable: true,
    get: function get() {
        return $edca2caa766c402a$exports.InitializeAutoAtlAnalytics;
    }
});
var $edca2caa766c402a$exports = {};
"use strict";
Object.defineProperty($edca2caa766c402a$exports, "__esModule", {
    value: true
});
$edca2caa766c402a$exports.InitializeAutoAtlAnalytics = void 0;

var $5FkrB = parcelRequire("5FkrB");

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $hQ6Uq = parcelRequire("hQ6Uq");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $hQ6Uq = parcelRequire("hQ6Uq");
function $64381d03c394a173$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $64381d03c394a173$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $64381d03c394a173$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $64381d03c394a173$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $64381d03c394a173$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $hQ6Uq.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $5FkrB.useRef)({});
    var patchedProps = (0, $5FkrB.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $64381d03c394a173$var$_objectSpread($64381d03c394a173$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $64381d03c394a173$var$_objectSpread($64381d03c394a173$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}


var $d5f32e7562891e94$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
            var _usePatchedProps = (0, $64381d03c394a173$export$9ebb5a84d17e5d18)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $hQ6Uq.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $d5f32e7562891e94$export$2e2bcd8739ae039 = $d5f32e7562891e94$var$withAnalyticsEvents;


var $611eba94e0709501$exports = {};
"use strict";
Object.defineProperty($611eba94e0709501$exports, "__esModule", {
    value: true
});
$611eba94e0709501$exports.useAnalyticsClient = $611eba94e0709501$exports.CommunityAnalyticsListener = $611eba94e0709501$exports.CommunityAnalyticsClientProvider = $611eba94e0709501$exports.AnalyticsWebClientContext = void 0;

var $611eba94e0709501$var$_react = $611eba94e0709501$var$_interopRequireWildcard((parcelRequire("5FkrB")));

var $5FkrB = parcelRequire("5FkrB");

var $jZlo3 = parcelRequire("jZlo3");
var $7cebc1a497019d4b$var$_process, $7cebc1a497019d4b$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $7cebc1a497019d4b$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($7cebc1a497019d4b$var$_process = globalThis.process) === null || $7cebc1a497019d4b$var$_process === void 0 || ($7cebc1a497019d4b$var$_process = $7cebc1a497019d4b$var$_process.env) === null || $7cebc1a497019d4b$var$_process === void 0 ? void 0 : $7cebc1a497019d4b$var$_process.JEST_WORKER_ID) !== undefined;
var $7cebc1a497019d4b$var$DEBUG_MODE = !$7cebc1a497019d4b$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($7cebc1a497019d4b$var$_process2 = globalThis.process) === null || $7cebc1a497019d4b$var$_process2 === void 0 || ($7cebc1a497019d4b$var$_process2 = $7cebc1a497019d4b$var$_process2.env) === null || $7cebc1a497019d4b$var$_process2 === void 0 ? void 0 : $7cebc1a497019d4b$var$_process2.NODE_ENV) !== 'production';
var $7cebc1a497019d4b$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$7cebc1a497019d4b$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $4b063ea43d2750ec$var$pkgName = '@atlaskit/platform-feature-flags';
var $4b063ea43d2750ec$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $4b063ea43d2750ec$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $4b063ea43d2750ec$var$ENV_ENABLE_PLATFORM_FF = $4b063ea43d2750ec$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $4b063ea43d2750ec$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $4b063ea43d2750ec$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $4b063ea43d2750ec$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $4b063ea43d2750ec$var$ENV_ENABLE_PLATFORM_FF || $4b063ea43d2750ec$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $4b063ea43d2750ec$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $4b063ea43d2750ec$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$4b063ea43d2750ec$var$globalVar[$4b063ea43d2750ec$export$7e41b1b2bdee3f98] = $4b063ea43d2750ec$var$globalVar[$4b063ea43d2750ec$export$7e41b1b2bdee3f98] || $4b063ea43d2750ec$var$DEFAULT_PFF_GLOBAL;
function $4b063ea43d2750ec$export$f2b591175b3e424c(resolver) {
    $4b063ea43d2750ec$var$globalVar[$4b063ea43d2750ec$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $4b063ea43d2750ec$export$6333b6aff9fc6275(flagKey) {
    if ($4b063ea43d2750ec$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $7cebc1a497019d4b$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $4b063ea43d2750ec$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $4b063ea43d2750ec$var$globalVar[$4b063ea43d2750ec$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $4b063ea43d2750ec$var$globalVar[$4b063ea43d2750ec$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $jZlo3.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $4b063ea43d2750ec$var$globalVar[$4b063ea43d2750ec$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $becc7ed5e3e052cc$export$ba05d765b8392e5e(flagResolver) {
    (0, $4b063ea43d2750ec$export$f2b591175b3e424c)(flagResolver);
}
function $becc7ed5e3e052cc$export$470e5c2be1411c89(name) {
    return (0, $4b063ea43d2750ec$export$6333b6aff9fc6275)(name);
}
function $becc7ed5e3e052cc$export$b40ec24ac8275656(name) {
    return (0, $4b063ea43d2750ec$export$6333b6aff9fc6275)(name);
}



var $3ZMUU = parcelRequire("3ZMUU");
var $ca9d768b23f35126$var$_process$env;
var /// <reference types="node" />
$ca9d768b23f35126$export$2e2bcd8739ae039 = typeof $3ZMUU !== 'undefined' && $3ZMUU !== null && (($ca9d768b23f35126$var$_process$env = {}, $ca9d768b23f35126$var$_process$env === void 0) ? void 0 : $ca9d768b23f35126$var$_process$env['ANALYTICS_NEXT_MODERN_CONTEXT']);



var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $8vJ0V = parcelRequire("8vJ0V");

var $iyyOp = parcelRequire("iyyOp");
function $f436cf4b258cc0fb$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $f436cf4b258cc0fb$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $f436cf4b258cc0fb$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f436cf4b258cc0fb$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $f436cf4b258cc0fb$var$ContextTypes = {
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).func,
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).func
};
var $f436cf4b258cc0fb$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $f436cf4b258cc0fb$var$AnalyticsListener = /*#__PURE__*/ function(_Component) {
    function AnalyticsListener(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsListener);
        _this = $f436cf4b258cc0fb$var$_callSuper(this, AnalyticsListener, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getChildContext", function() {
            return {
                getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers,
                getAtlaskitAnalyticsContext: _this.getAtlaskitAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getAnalyticsEventHandlers", function() {
            var _this$props = _this.props, channel = _this$props.channel, onEvent = _this$props.onEvent;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla === void 0 ? $f436cf4b258cc0fb$var$noop : _this$context$getAtla;
            var handler = function handler(event, eventChannel) {
                if (channel === '*' || channel === eventChannel) onEvent(event, eventChannel);
            };
            return [
                handler
            ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(getAtlaskitAnalyticsEventHandlers()));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getAtlaskitAnalyticsContext", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla2 === void 0 ? $f436cf4b258cc0fb$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsContext();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(AnalyticsListener, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsListener, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iyyOp.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
}((0, $5FkrB.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($f436cf4b258cc0fb$var$AnalyticsListener, "contextTypes", $f436cf4b258cc0fb$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($f436cf4b258cc0fb$var$AnalyticsListener, "childContextTypes", $f436cf4b258cc0fb$var$ContextTypes);
var $f436cf4b258cc0fb$export$2e2bcd8739ae039 = $f436cf4b258cc0fb$var$AnalyticsListener;



var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");

var $ePFpc = parcelRequire("ePFpc");

var $aFyjd = parcelRequire("aFyjd");
var $aef46461767049c5$var$AnalyticsListener = function AnalyticsListener(_ref) {
    var children = _ref.children, channel = _ref.channel, onEvent = _ref.onEvent;
    var _useAnalyticsContext = (0, $ePFpc.useAnalyticsContext)(), _useAnalyticsContext$ = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext$ === void 0 ? function() {
        return [];
    } : _useAnalyticsContext$, getAtlaskitAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var onEventRef = (0, $aFyjd.useTrackedRef)(onEvent);
    var channelRef = (0, $aFyjd.useTrackedRef)(channel);
    var getAnalyticsEventHandlers = (0, $5FkrB.useCallback)(function() {
        var thisHandler = function thisHandler(event, eventChannel) {
            if (channelRef.current === '*' || channelRef.current === eventChannel) onEventRef.current(event, eventChannel);
        };
        return [
            thisHandler
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(getAtlaskitAnalyticsEventHandlers()));
    }, [
        channelRef,
        onEventRef,
        getAtlaskitAnalyticsEventHandlers
    ]);
    var value = (0, $5FkrB.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iyyOp.default).Provider, {
        value: value
    }, children);
};
var $aef46461767049c5$export$2e2bcd8739ae039 = $aef46461767049c5$var$AnalyticsListener;


var $01b5b1a5740294b4$var$ExportedAnalyticsListener = function ExportedAnalyticsListener(props) {
    var isModernContext = (0, $ca9d768b23f35126$export$2e2bcd8739ae039) || (0, $becc7ed5e3e052cc$export$b40ec24ac8275656)('analytics-next-use-modern-context_jira');
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aef46461767049c5$export$2e2bcd8739ae039), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f436cf4b258cc0fb$export$2e2bcd8739ae039), props);
};
var $01b5b1a5740294b4$export$2e2bcd8739ae039 = $01b5b1a5740294b4$var$ExportedAnalyticsListener;



var $dpXUu = parcelRequire("dpXUu");
var $35247c7511184ad3$exports = {};
"use strict";
Object.defineProperty($35247c7511184ad3$exports, "__esModule", {
    value: true
});
$35247c7511184ad3$exports.Identity = void 0;
var $767eab9fde59e2ab$exports = {};
"use strict";
Object.defineProperty($767eab9fde59e2ab$exports, "__esModule", {
    value: true
});
$767eab9fde59e2ab$exports.Cookie = void 0;
function $767eab9fde59e2ab$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $767eab9fde59e2ab$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $767eab9fde59e2ab$var$_typeof(o);
}
function $767eab9fde59e2ab$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $767eab9fde59e2ab$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $767eab9fde59e2ab$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $767eab9fde59e2ab$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $767eab9fde59e2ab$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $767eab9fde59e2ab$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $767eab9fde59e2ab$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $767eab9fde59e2ab$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $767eab9fde59e2ab$var$_toPropertyKey(o.key), o);
    }
}
function $767eab9fde59e2ab$var$_createClass(e, r, t) {
    return r && $767eab9fde59e2ab$var$_defineProperties(e.prototype, r), t && $767eab9fde59e2ab$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $767eab9fde59e2ab$var$_toPropertyKey(t) {
    var i = $767eab9fde59e2ab$var$_toPrimitive(t, "string");
    return "symbol" == $767eab9fde59e2ab$var$_typeof(i) ? i : i + "";
}
function $767eab9fde59e2ab$var$_toPrimitive(t, r) {
    if ("object" != $767eab9fde59e2ab$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $767eab9fde59e2ab$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $767eab9fde59e2ab$var$Cookie = $767eab9fde59e2ab$exports.Cookie = /*#__PURE__*/ function() {
    function Cookie() {
        $767eab9fde59e2ab$var$_classCallCheck(this, Cookie);
    }
    return $767eab9fde59e2ab$var$_createClass(Cookie, null, [
        {
            key: "getCookieUrl",
            value: function getCookieUrl(cookieName, defaultUrl) {
                var cookieUrl = Cookie.readCookie(cookieName);
                if (cookieUrl !== null) return cookieUrl;
                return defaultUrl;
            }
        },
        {
            key: "readCookie",
            value: function readCookie(name) {
                try {
                    var nameEQ = name + '=';
                    var ca = document.cookie.split(';');
                    var _iterator = $767eab9fde59e2ab$var$_createForOfIteratorHelper(ca), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var c = _step.value;
                            while(c.startsWith(' '))c = c.substring(1, c.length);
                            if (c.startsWith(nameEQ)) return c.substring(nameEQ.length, c.length);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                } catch (e) {
                    // Helpers.sendWrapperLoadError uses this method to get some context
                    // for the reported error, so we don't want to call that here, otherwise
                    // we would get stuck in an infinite loop
                    // Missing login_user_detected cookie is expected for logged out users, so no need to log it.
                    if (name !== 'login_user_detected') console.warn("Error reading cookie - ".concat(name), e);
                }
                return null;
            }
        },
        {
            key: "writeCookie",
            value: function writeCookie(name, value, days, topLevelDomain) {
                var seconds = days ? days * 86400 : null;
                Cookie.writeCookieInSeconds(name, value, seconds, topLevelDomain);
            }
        },
        {
            key: "writeCookieInSeconds",
            value: function writeCookieInSeconds(name, value, seconds, topLevelDomain) {
                try {
                    var expires = '';
                    if (seconds) {
                        var date = new Date();
                        date.setTime(date.getTime() + seconds * 1000);
                        expires = '; expires=' + date.toUTCString();
                    }
                    var cookie = name + '=' + value + expires + '; path=/;';
                    var domain = window.location.hostname;
                    if (domain !== 'localhost' && topLevelDomain) {
                        var domainTokens = domain.split('.');
                        if (domainTokens.length > 1) {
                            var lastToken = domainTokens[domainTokens.length - 1];
                            var secondLastToken = domainTokens[domainTokens.length - 2];
                            if (isNaN(Number(lastToken)) || isNaN(Number(secondLastToken))) domain = '.' + secondLastToken + '.' + lastToken;
                        }
                        cookie += ' domain=' + domain + ';';
                    }
                    document.cookie = cookie;
                } catch (e) {
                    console.warn("Error writing cookie - ".concat(name), e);
                }
            }
        }
    ]);
}();


var $adbd9ab2eaa40909$exports = {};
"use strict";
Object.defineProperty($adbd9ab2eaa40909$exports, "__esModule", {
    value: true
});
$adbd9ab2eaa40909$exports.AnalyticsState = void 0;
function $adbd9ab2eaa40909$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $adbd9ab2eaa40909$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $adbd9ab2eaa40909$var$_typeof(o);
}
function $adbd9ab2eaa40909$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $adbd9ab2eaa40909$var$_toPropertyKey(o.key), o);
    }
}
function $adbd9ab2eaa40909$var$_createClass(e, r, t) {
    return r && $adbd9ab2eaa40909$var$_defineProperties(e.prototype, r), t && $adbd9ab2eaa40909$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $adbd9ab2eaa40909$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $adbd9ab2eaa40909$var$_defineProperty(e, r, t) {
    return (r = $adbd9ab2eaa40909$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $adbd9ab2eaa40909$var$_toPropertyKey(t) {
    var i = $adbd9ab2eaa40909$var$_toPrimitive(t, "string");
    return "symbol" == $adbd9ab2eaa40909$var$_typeof(i) ? i : i + "";
}
function $adbd9ab2eaa40909$var$_toPrimitive(t, r) {
    if ("object" != $adbd9ab2eaa40909$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $adbd9ab2eaa40909$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $adbd9ab2eaa40909$var$AnalyticsState = $adbd9ab2eaa40909$exports.AnalyticsState = /*#__PURE__*/ $adbd9ab2eaa40909$var$_createClass(function AnalyticsState() {
    $adbd9ab2eaa40909$var$_classCallCheck(this, AnalyticsState);
});
$adbd9ab2eaa40909$var$_defineProperty($adbd9ab2eaa40909$var$AnalyticsState, "pageViewOptions", {});


var $062e0101ba16ec7d$exports = {};
"use strict";
Object.defineProperty($062e0101ba16ec7d$exports, "__esModule", {
    value: true
});
$062e0101ba16ec7d$exports.requiredBucketAttributeKeys = $062e0101ba16ec7d$exports.Cohort = $062e0101ba16ec7d$exports.COHORT_VERSION = $062e0101ba16ec7d$exports.ATL_COHORT = void 0;

var $d568c1b4cd0cc27f$exports = {};
"use strict";
Object.defineProperty($d568c1b4cd0cc27f$exports, "__esModule", {
    value: true
});
$d568c1b4cd0cc27f$exports.Guid = void 0;

var $6JfQX = parcelRequire("6JfQX");
var $4fb91a309ed42af5$exports = {};
"use strict";
Object.defineProperty($4fb91a309ed42af5$exports, "__esModule", {
    value: true
});
$4fb91a309ed42af5$exports.Helpers = void 0;

var $4fb91a309ed42af5$var$_queryString = $4fb91a309ed42af5$var$_interopRequireDefault((parcelRequire("lSdkB")));
function $4fb91a309ed42af5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $4fb91a309ed42af5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4fb91a309ed42af5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4fb91a309ed42af5$var$_typeof(o);
}
function $4fb91a309ed42af5$var$_slicedToArray(r, e) {
    return $4fb91a309ed42af5$var$_arrayWithHoles(r) || $4fb91a309ed42af5$var$_iterableToArrayLimit(r, e) || $4fb91a309ed42af5$var$_unsupportedIterableToArray(r, e) || $4fb91a309ed42af5$var$_nonIterableRest();
}
function $4fb91a309ed42af5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4fb91a309ed42af5$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $4fb91a309ed42af5$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $4fb91a309ed42af5$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $4fb91a309ed42af5$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $4fb91a309ed42af5$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $4fb91a309ed42af5$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $4fb91a309ed42af5$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $4fb91a309ed42af5$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $4fb91a309ed42af5$var$_toPropertyKey(o.key), o);
    }
}
function $4fb91a309ed42af5$var$_createClass(e, r, t) {
    return r && $4fb91a309ed42af5$var$_defineProperties(e.prototype, r), t && $4fb91a309ed42af5$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $4fb91a309ed42af5$var$_defineProperty(e, r, t) {
    return (r = $4fb91a309ed42af5$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4fb91a309ed42af5$var$_toPropertyKey(t) {
    var i = $4fb91a309ed42af5$var$_toPrimitive(t, "string");
    return "symbol" == $4fb91a309ed42af5$var$_typeof(i) ? i : i + "";
}
function $4fb91a309ed42af5$var$_toPrimitive(t, r) {
    if ("object" != $4fb91a309ed42af5$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4fb91a309ed42af5$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// This regex is the simplified RFC 5322 expression from http://www.regular-expressions.info/email.html
var $4fb91a309ed42af5$var$EMAIL_REGEX = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;
var $4fb91a309ed42af5$var$PATH_OVERRIDE = '/path-contained-email-address';
// Cap on identical wrapper-load error reports per page lifecycle, so a
// recurring failure can't flood downstream telemetry.
var $4fb91a309ed42af5$var$MAX_REPORTS_PER_KEY = 3;
var $4fb91a309ed42af5$var$Helpers = $4fb91a309ed42af5$exports.Helpers = /*#__PURE__*/ function() {
    function Helpers() {
        $4fb91a309ed42af5$var$_classCallCheck(this, Helpers);
    }
    return $4fb91a309ed42af5$var$_createClass(Helpers, null, [
        {
            key: "sendWrapperLoadError",
            value: /** Report a wrapper-load failure. Throttled per `message` key. */ function sendWrapperLoadError(message, data) {
                var _Helpers$wrapperLoadE;
                var count = (_Helpers$wrapperLoadE = Helpers.wrapperLoadErrorCounts.get(message)) !== null && _Helpers$wrapperLoadE !== void 0 ? _Helpers$wrapperLoadE : 0;
                if (count >= $4fb91a309ed42af5$var$MAX_REPORTS_PER_KEY) return;
                Helpers.wrapperLoadErrorCounts.set(message, count + 1);
                // TODO: Handle sending error somewhere, reference atl-analytics if needed
                console.warn("Error loading wrapper: ".concat(message), data);
            }
        },
        {
            key: "_resetWrapperLoadErrorThrottle",
            value: function _resetWrapperLoadErrorThrottle() {
                Helpers.wrapperLoadErrorCounts.clear();
            }
        },
        {
            key: "getParameterByName",
            value: function getParameterByName(name) {
                //eslint-disable-next-line
                name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
                var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
                var results = regex.exec(window.location.search);
                var value = results && results.length >= 2 ? results[1] : null;
                return !value ? '' : decodeURIComponent(value.replace(/\+/g, ' '));
            }
        },
        {
            key: "getUtms",
            value: function getUtms(utms) {
                if (window.location.search.includes('utm_')) {
                    for(var utmKey in utms)//eslint-disable-next-line
                    if (utms.hasOwnProperty(utmKey)) utms[utmKey] = Helpers.getParameterByName(utmKey);
                    return utms;
                }
                return null;
            }
        },
        {
            key: "canonical",
            value: function canonical() {
                var tags = Array.from(document.getElementsByTagName('link'));
                for(var _i = 0, _tags = tags; _i < _tags.length; _i++){
                    var tag = _tags[_i];
                    if (tag && tag.getAttribute('rel') === 'canonical') return tag.getAttribute('href');
                }
                return null;
            }
        },
        {
            key: "getCanonicalUrl",
            value: function getCanonicalUrl() {
                var canon = Helpers.canonical();
                if (canon) return canon;
                var url = window.location.href;
                var i = url.indexOf('#');
                return i === -1 ? url : url.slice(0, i);
            }
        },
        {
            key: "getUrlFragment",
            value: function getUrlFragment() {
                var url = window.location.href;
                var i = url.indexOf('#');
                if (i === -1) return '';
                var fragment = url.slice(i + 1); // fragment after '#'
                var _fragment$split = fragment.split('?'), _fragment$split2 = $4fb91a309ed42af5$var$_slicedToArray(_fragment$split, 1), path = _fragment$split2[0]; // discard query string
                return "#".concat(path);
            }
        },
        {
            key: "addActualUrl",
            value: function addActualUrl(obj) {
                if (window.location.href !== Helpers.getCanonicalUrl()) {
                    // respect cleaned url
                    if (obj['url']) obj['actualUrl'] = obj['url'];
                    else obj['actualUrl'] = Helpers.maskURL(window.location.href);
                }
            }
        },
        {
            key: "isObject",
            value: function isObject(o) {
                return o !== null && $4fb91a309ed42af5$var$_typeof(o) === 'object' && Array.isArray(o) === false;
            }
        },
        {
            key: "urlContainsEmail",
            value: function urlContainsEmail(url) {
                return Boolean($4fb91a309ed42af5$var$EMAIL_REGEX.exec(decodeURIComponent(url)));
            }
        },
        {
            key: "dropEmailQueryParams",
            value: function dropEmailQueryParams(obj) {
                var sanitizedObj = {};
                Object.entries(obj).forEach(function(_ref) {
                    var _ref2 = $4fb91a309ed42af5$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                    if (!Helpers.urlContainsEmail(value)) sanitizedObj[key] = value;
                });
                return sanitizedObj;
            }
        },
        {
            key: "maskSearchTerms",
            value: function maskSearchTerms(obj) {
                var sanitizedObj = {};
                Object.entries(obj).forEach(function(_ref3) {
                    var _ref4 = $4fb91a309ed42af5$var$_slicedToArray(_ref3, 2), key = _ref4[0], value = _ref4[1];
                    if (key === 'term' || key === 'q') sanitizedObj[key] = '[REDACTED]';
                    else sanitizedObj[key] = value;
                });
                return sanitizedObj;
            }
        },
        {
            key: "dropEmailFromPath",
            value: function dropEmailFromPath(path) {
                var newPath = '';
                if (Helpers.urlContainsEmail(path)) {
                    var pathArray = path.split('/');
                    pathArray.forEach(function(value) {
                        if (value !== '' && !Helpers.urlContainsEmail(value)) newPath = newPath + '/' + value;
                    });
                }
                return newPath === '' ? path : newPath;
            }
        },
        {
            key: "convertQueryObjToString",
            value: function convertQueryObjToString(obj) {
                var queryString = new URLSearchParams(obj).toString();
                if (queryString !== '') queryString = '?' + queryString;
                return queryString;
            }
        },
        {
            key: "emailAddressIsDetected",
            value: function emailAddressIsDetected() {
                return Helpers.urlContainsEmail(window.location.href) || Helpers.urlContainsEmail(document.referrer);
            }
        },
        {
            key: "hostnameFromUrl",
            value: function hostnameFromUrl(url) {
                return url.replace(/http(s|):\/\//g, '').split(/(\/|:)/g)[0];
            }
        },
        {
            key: "addCleanedUrlAndPaths",
            value: function addCleanedUrlAndPaths(obj) {
                obj['url'] = window.location.origin + $4fb91a309ed42af5$var$PATH_OVERRIDE;
                obj['path'] = $4fb91a309ed42af5$var$PATH_OVERRIDE;
                obj['search'] = '';
                return obj;
            }
        },
        {
            key: "addCleanedReferrer",
            value: function addCleanedReferrer(obj) {
                obj['referrer'] = Helpers.urlWithoutPath(document.referrer) + $4fb91a309ed42af5$var$PATH_OVERRIDE;
                return obj;
            }
        },
        {
            key: "urlWithoutPath",
            value: function urlWithoutPath(url) {
                var fakeTag = document.createElement('a');
                fakeTag.href = url;
                return fakeTag.protocol + '//' + fakeTag.host;
            }
        },
        {
            key: "maskURL",
            value: function maskURL(input) {
                if (input === '' || input === undefined) return input;
                var url = new URL(input);
                var obj = $4fb91a309ed42af5$var$_queryString["default"].parse(url.search);
                obj = Helpers.dropEmailQueryParams(obj);
                if (url.pathname.includes('/search')) obj = Helpers.maskSearchTerms(obj);
                return url.origin + Helpers.dropEmailFromPath(url.pathname) + Helpers.convertQueryObjToString(obj);
            }
        }
    ]);
}();
$4fb91a309ed42af5$var$_defineProperty($4fb91a309ed42af5$var$Helpers, "wrapperLoadErrorCounts", new Map());


var $06626edace7f812b$exports = {};
"use strict";
Object.defineProperty($06626edace7f812b$exports, "__esModule", {
    value: true
});
$06626edace7f812b$exports.mathGuid = void 0;
function $06626edace7f812b$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $06626edace7f812b$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $06626edace7f812b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $06626edace7f812b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $06626edace7f812b$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $06626edace7f812b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
/**
 * See:
 *  - http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/24891600#24891600
 * for more context around the issue of psuedo-randomness used by browsers and the solution used below.
 *
 * and:
 *  - http://web.archive.org/web/20120503063359/http://baagoe.com/en/RandomMusings/javascript/
 * for info regarding the Alea code used below.
 */ var $06626edace7f812b$var$trueRandom = function() {
    function Mash() {
        var n = 0xefc8249d;
        var mash = function mash(data) {
            for(var i = 0; i < data.length; i++){
                n += data.charCodeAt(i);
                var h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }
            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
        return mash;
    }
    function Alea() {
        return function(args) {
            // Johannes BaagÃ¸e <baagoe@baagoe.com>, 2010
            var s0 = 0;
            var s1 = 0;
            var s2 = 0;
            var c = 1;
            if (args.length == 0) args = [
                +new Date()
            ];
            var mash = Mash();
            s0 = mash(' ');
            s1 = mash(' ');
            s2 = mash(' ');
            var _iterator = $06626edace7f812b$var$_createForOfIteratorHelper(args), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var item = _step.value;
                    s0 -= mash(item);
                    if (s0 < 0) s0 += 1;
                    s1 -= mash(item);
                    if (s1 < 0) s1 += 1;
                    s2 -= mash(item);
                    if (s2 < 0) s2 += 1;
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
            var random = function random() {
                var t = 2091639 * s0 + c * 2.3283064365386963e-10; // 2^-32
                s0 = s1;
                s1 = s2;
                return s2 = t - (c = t | 0);
            };
            random.uint32 = function() {
                return random() * 0x100000000; // 2^32
            };
            random.fract53 = function() {
                return random() + (random() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
            };
            random.version = 'Alea 0.9';
            random.args = args;
            return random;
        }(Array.prototype.slice.call(arguments));
    }
    return Alea();
}();
var $06626edace7f812b$var$mathGuid = $06626edace7f812b$exports.mathGuid = function mathGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = $06626edace7f812b$var$trueRandom() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};


function $d568c1b4cd0cc27f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d568c1b4cd0cc27f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d568c1b4cd0cc27f$var$_typeof(o);
}
function $d568c1b4cd0cc27f$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $d568c1b4cd0cc27f$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $d568c1b4cd0cc27f$var$_toPropertyKey(o.key), o);
    }
}
function $d568c1b4cd0cc27f$var$_createClass(e, r, t) {
    return r && $d568c1b4cd0cc27f$var$_defineProperties(e.prototype, r), t && $d568c1b4cd0cc27f$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $d568c1b4cd0cc27f$var$_toPropertyKey(t) {
    var i = $d568c1b4cd0cc27f$var$_toPrimitive(t, "string");
    return "symbol" == $d568c1b4cd0cc27f$var$_typeof(i) ? i : i + "";
}
function $d568c1b4cd0cc27f$var$_toPrimitive(t, r) {
    if ("object" != $d568c1b4cd0cc27f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d568c1b4cd0cc27f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $d568c1b4cd0cc27f$var$Guid = $d568c1b4cd0cc27f$exports.Guid = /*#__PURE__*/ function() {
    function Guid() {
        $d568c1b4cd0cc27f$var$_classCallCheck(this, Guid);
    }
    return $d568c1b4cd0cc27f$var$_createClass(Guid, null, [
        {
            key: "guid",
            value: function guid() {
                try {
                    return (0, $6JfQX.default)();
                } catch (e) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error getting uuidV4');
                    return (0, $06626edace7f812b$exports.mathGuid)();
                }
            }
        },
        {
            key: "guidNoDashes",
            value: function guidNoDashes() {
                return (0, $6JfQX.default)().replace(/-/g, '');
            }
        },
        {
            key: "addNumberToGUID",
            value: function addNumberToGUID(guid, number) {
                // take the last 4 digits and convert to a hex string representation
                var hex = guid.slice(-4);
                var value = parseInt(hex, 16);
                if (isNaN(value)) return guid;
                var valLength = value.toString(16).length;
                value += number;
                // clamp to 2 bytes
                if (value > 65535) value -= 65536;
                else if (value < 0) value += 65536;
                // convert back to hex and make sure its as long as many digits as the initial value
                // This is needed for subtraction
                hex = value.toString(16);
                if (hex.length < valLength) hex = ('00000' + hex).slice(-valLength);
                // replace the last 4 digits of the guid with the last 4 digits of the converted value
                return guid.slice(0, guid.length - hex.length) + hex;
            }
        },
        {
            key: "guidHashCode",
            value: function guidHashCode(guid) {
                var hash = 0;
                for(var i = 0; i < guid.length; i++){
                    hash += Math.pow(guid.charCodeAt(i) * 31, guid.length - i);
                    hash = hash & hash; // Convert to 32bit integer
                }
                return Math.abs(hash);
            }
        }
    ]);
}();



function $062e0101ba16ec7d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $062e0101ba16ec7d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $062e0101ba16ec7d$var$_typeof(o);
}
function $062e0101ba16ec7d$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $062e0101ba16ec7d$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $062e0101ba16ec7d$var$_toPropertyKey(o.key), o);
    }
}
function $062e0101ba16ec7d$var$_createClass(e, r, t) {
    return r && $062e0101ba16ec7d$var$_defineProperties(e.prototype, r), t && $062e0101ba16ec7d$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $062e0101ba16ec7d$var$_toPropertyKey(t) {
    var i = $062e0101ba16ec7d$var$_toPrimitive(t, "string");
    return "symbol" == $062e0101ba16ec7d$var$_typeof(i) ? i : i + "";
}
function $062e0101ba16ec7d$var$_toPrimitive(t, r) {
    if ("object" != $062e0101ba16ec7d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $062e0101ba16ec7d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /**
 * @typedef {object} Cohort
 * @property {string} ATL_COHORT The cookie name
 * @property {object | null} readWriteAtlCohort The cohort object or null
 * @property {object | null} readAtlCohort The cohort object or null
 */ 
var $062e0101ba16ec7d$var$ATL_COHORT = $062e0101ba16ec7d$exports.ATL_COHORT = 'atlCohort';
var $062e0101ba16ec7d$var$COHORT_VERSION = $062e0101ba16ec7d$exports.COHORT_VERSION = '2';
var $062e0101ba16ec7d$var$requiredBucketAttributeKeys = $062e0101ba16ec7d$exports.requiredBucketAttributeKeys = [
    'index',
    'bucketedAtUTC',
    'version',
    'bucketId'
];
var $062e0101ba16ec7d$var$cohortBuckets = {
    bucketAll: {
        bucketId: 0
    }
};
/**
 * Provides public access to cohort cookie name and methods for reading and writing that cookie
 * @module Cohort
 */ var $062e0101ba16ec7d$var$Cohort = $062e0101ba16ec7d$exports.Cohort = /*#__PURE__*/ function() {
    function Cohort() {
        $062e0101ba16ec7d$var$_classCallCheck(this, Cohort);
    }
    return $062e0101ba16ec7d$var$_createClass(Cohort, null, [
        {
            key: "readAtlCohort",
            value: /*
       Hypothetical way to add other buckets (adding their name to the types above):
           if (isMobileDevice()) {
              cohortBuckets.bucket_mobile = {
                  bucketId: 1
              };
          }
           if (isEnglishSpeaking()) {
              cohortBuckets.bucket_english = {};
          }
           function isMobileDevice() {
              // some logic here...
              return true;
          }
           function isEnglishSpeaking() {
              // some logic here...
              return false;
          }
      */ /**
     * Tries to read the ATL_COHORT cookie and return it
     * @function readAtlCohort
     * @return {object | null} the cohort object or null
     */ function readAtlCohort() {
                var atlCohort;
                var atlCohortCookie = $767eab9fde59e2ab$exports.Cookie.readCookie($062e0101ba16ec7d$var$ATL_COHORT);
                try {
                    atlCohort = atlCohortCookie ? JSON.parse(atlCohortCookie) : null;
                    return $4fb91a309ed42af5$exports.Helpers.isObject(atlCohort) ? atlCohort : null;
                } catch (e) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error reading ALT_COHORT Cookie');
                    return null;
                }
            }
        },
        {
            key: "writeAtlCohort",
            value: function writeAtlCohort(atlCohort) {
                if ($4fb91a309ed42af5$exports.Helpers.isObject(atlCohort)) $767eab9fde59e2ab$exports.Cookie.writeCookie($062e0101ba16ec7d$var$ATL_COHORT, JSON.stringify(atlCohort), 3650, true);
            }
        },
        {
            key: "bucketExists",
            value: function bucketExists(key, atlCohort) {
                if ($4fb91a309ed42af5$exports.Helpers.isObject(atlCohort)) {
                    var bucket = atlCohort[key];
                    if (bucket && $4fb91a309ed42af5$exports.Helpers.isObject(bucket)) return $062e0101ba16ec7d$var$requiredBucketAttributeKeys.every(function(bucketAttribute) {
                        return typeof bucket[bucketAttribute] !== 'undefined';
                    });
                }
                return false;
            }
        },
        {
            key: "createBucket",
            value: function createBucket(bucketKey) {
                var bucketAttributes = $062e0101ba16ec7d$var$cohortBuckets[bucketKey];
                var anonymousId = $767eab9fde59e2ab$exports.Cookie.readCookie('ajs_anonymous_id');
                var bucket = {
                    bucketedAtUTC: new Date().toISOString(),
                    version: $062e0101ba16ec7d$var$COHORT_VERSION,
                    index: anonymousId ? $d568c1b4cd0cc27f$exports.Guid.guidHashCode($d568c1b4cd0cc27f$exports.Guid.addNumberToGUID(anonymousId, bucketAttributes.bucketId)) % 100 : Math.ceil(Math.random() * 100),
                    bucketId: bucketAttributes.bucketId
                };
                return bucket;
            }
        },
        {
            key: "readWriteAtlCohort",
            value: function readWriteAtlCohort(writeOverride) {
                // if overriding the cohort, do not read the existing cohort; set to empty to force a write
                var atlCohort = writeOverride ? {} : Cohort.readAtlCohort() || {};
                var missingBuckets = Object.keys($062e0101ba16ec7d$var$cohortBuckets)// Find missing buckets
                .filter(function(bucket) {
                    return !Cohort.bucketExists(bucket, atlCohort);
                });
                if (missingBuckets.length) {
                    missingBuckets.forEach(function(missingBucket) {
                        return atlCohort[missingBucket] = Cohort.createBucket(missingBucket);
                    });
                    Cohort.writeAtlCohort(atlCohort);
                }
                return atlCohort;
            }
        }
    ]);
}();



var $3f4554f5dd6755f8$exports = {};
"use strict";
Object.defineProperty($3f4554f5dd6755f8$exports, "__esModule", {
    value: true
});
$3f4554f5dd6755f8$exports.Tracking = void 0;


var $f1d158ad5148ce30$exports = {};
"use strict";
Object.defineProperty($f1d158ad5148ce30$exports, "__esModule", {
    value: true
});
$f1d158ad5148ce30$exports.CookieCompliance = void 0;



function $f1d158ad5148ce30$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f1d158ad5148ce30$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f1d158ad5148ce30$var$_typeof(o);
}
function $f1d158ad5148ce30$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $f1d158ad5148ce30$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $f1d158ad5148ce30$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($f1d158ad5148ce30$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $f1d158ad5148ce30$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $f1d158ad5148ce30$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $f1d158ad5148ce30$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $f1d158ad5148ce30$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function $f1d158ad5148ce30$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $f1d158ad5148ce30$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $f1d158ad5148ce30$var$_toPropertyKey(o.key), o);
    }
}
function $f1d158ad5148ce30$var$_createClass(e, r, t) {
    return r && $f1d158ad5148ce30$var$_defineProperties(e.prototype, r), t && $f1d158ad5148ce30$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $f1d158ad5148ce30$var$_defineProperty(e, r, t) {
    return (r = $f1d158ad5148ce30$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f1d158ad5148ce30$var$_toPropertyKey(t) {
    var i = $f1d158ad5148ce30$var$_toPrimitive(t, "string");
    return "symbol" == $f1d158ad5148ce30$var$_typeof(i) ? i : i + "";
}
function $f1d158ad5148ce30$var$_toPrimitive(t, r) {
    if ("object" != $f1d158ad5148ce30$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f1d158ad5148ce30$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /**
 * Cookie compliance module.
 *
 * Two-tier consent model:
 *   - operational events  -> always fire (error/perf/page-load telemetry)
 *   - non-operational     -> fire only if the user consented to OneTrust C0002 (Performance) cookies
 *
 * Suppression is purely a function of OneTrust consent state — must not depend on
 * FeatureGates / async init.
 *
 * @module CookieCompliance
 */ 
// 24h, mirrors upstream PR #256
var $f1d158ad5148ce30$var$SN_ID_COOKIE_DAYS = 1;
var $f1d158ad5148ce30$var$ATL_FIRST_VISIT_TTL_MS = 86400000;
var $f1d158ad5148ce30$var$SN_ID_COOKIE_NAME = 'sn_id';
var $f1d158ad5148ce30$var$ATL_FIRST_VISIT_KEY = 'atl_first_visit';
var $f1d158ad5148ce30$var$CookieCompliance = $f1d158ad5148ce30$exports.CookieCompliance = /*#__PURE__*/ function() {
    function CookieCompliance() {
        $f1d158ad5148ce30$var$_classCallCheck(this, CookieCompliance);
    }
    return $f1d158ad5148ce30$var$_createClass(CookieCompliance, null, [
        {
            key: "optOutPerfTracking",
            value: /**
     * @returns true when the user has NOT consented to OneTrust C0002 (Performance) cookies.
     *          When true, the wrapper suppresses all non-operational events and only fires the
     *          strictly-necessary `requested_page` operational event. Side-effect: refreshes
     *          the `optedOut` cache used by `GASv3.sendOperationalEvent` to strip identifiers.
     */ function optOutPerfTracking() {
                var result = CookieCompliance._noPerformanceCookieConsent();
                CookieCompliance.optedOut = result;
                return result;
            }
        },
        {
            key: "_noPerformanceCookieConsent",
            value: function _noPerformanceCookieConsent() {
                if (typeof window === 'undefined') return false;
                if (typeof window.OnetrustActiveGroups === 'string' && window.OnetrustActiveGroups.length > 0) return !window.OnetrustActiveGroups.includes('2');
                // OptanonConsent cookie fallback — value contains "groups=...,C0002:1,..."
                var optanon = $767eab9fde59e2ab$exports.Cookie.readCookie('OptanonConsent');
                if (optanon) try {
                    var decoded = decodeURIComponent(optanon);
                    var groupsMatch = /groups=([^&]+)/.exec(decoded);
                    if (groupsMatch && groupsMatch[1]) return !/C0002:1|,2:1|,2,/.test(groupsMatch[1]);
                } catch (_unused) {
                // ignore — fall through to default
                }
                // No signal at all → treat as opted out so we don't accidentally over-collect
                return true;
            }
        },
        {
            key: "_isLocalStorageAvailable",
            value: function _isLocalStorageAvailable() {
                if (CookieCompliance.localStorageAvailable !== undefined) return CookieCompliance.localStorageAvailable;
                if (typeof window === 'undefined') {
                    CookieCompliance.localStorageAvailable = false;
                    return false;
                }
                try {
                    var probeKey = '__atl_storage_probe__';
                    window.localStorage.setItem(probeKey, '1');
                    window.localStorage.removeItem(probeKey);
                    CookieCompliance.localStorageAvailable = true;
                } catch (_unused2) {
                    CookieCompliance.localStorageAvailable = false;
                }
                return CookieCompliance.localStorageAvailable;
            }
        },
        {
            key: "_resetMemoisedState",
            value: function _resetMemoisedState() {
                CookieCompliance.localStorageAvailable = undefined;
                CookieCompliance.atlFirstVisitCache = undefined;
                CookieCompliance.activeGroupsListenerInstalled = false;
            }
        },
        {
            key: "setSnIdAndAtlFirstVisit",
            value: function setSnIdAndAtlFirstVisit(pageViewProperties) {
                var snId = $767eab9fde59e2ab$exports.Cookie.readCookie($f1d158ad5148ce30$var$SN_ID_COOKIE_NAME);
                if (!snId) {
                    snId = $d568c1b4cd0cc27f$exports.Guid.guid();
                    $767eab9fde59e2ab$exports.Cookie.writeCookie($f1d158ad5148ce30$var$SN_ID_COOKIE_NAME, encodeURIComponent('"' + snId + '"'), $f1d158ad5148ce30$var$SN_ID_COOKIE_DAYS, true);
                    // Invalidate cache before seeding so the post-seed read sees the new payload.
                    CookieCompliance.atlFirstVisitCache = undefined;
                    CookieCompliance._setAtlFirstVisit(pageViewProperties);
                }
                CookieCompliance.snId = decodeURIComponent(snId).replace(/['"]+/g, '');
                // Fast path: serve from memoised cache to skip storage on SPA route changes.
                if (CookieCompliance.atlFirstVisitCache !== undefined) {
                    CookieCompliance.atlFirstVisit = CookieCompliance.atlFirstVisitCache;
                    return;
                }
                if (!CookieCompliance._isLocalStorageAvailable()) {
                    CookieCompliance.atlFirstVisit = {};
                    CookieCompliance.atlFirstVisitCache = {};
                    return;
                }
                try {
                    var stored = window.localStorage.getItem($f1d158ad5148ce30$var$ATL_FIRST_VISIT_KEY);
                    var parsed = stored ? JSON.parse(stored) : {};
                    CookieCompliance.atlFirstVisit = parsed;
                    CookieCompliance.atlFirstVisitCache = parsed;
                } catch (_unused3) {
                    CookieCompliance.atlFirstVisit = {};
                    CookieCompliance.atlFirstVisitCache = {};
                }
            }
        },
        {
            key: "_listenForActiveGroupsChange",
            value: function _listenForActiveGroupsChange() {
                if (typeof window === 'undefined') return;
                // Idempotent: only install the accessor once per page lifecycle.
                if (CookieCompliance.activeGroupsListenerInstalled) return;
                var activeGroups = window.OnetrustActiveGroups;
                try {
                    Object.defineProperty(window, 'OnetrustActiveGroups', {
                        get: function get() {
                            return activeGroups;
                        },
                        set: function set(newGroups) {
                            if (newGroups !== activeGroups) {
                                activeGroups = newGroups;
                                // Prefer the in-memory cache so we don't trigger an extra
                                // storage read on every group change. Only fall back to
                                // `localStorage.getItem` if the cache hasn't been populated
                                // yet AND storage is available.
                                var payload = CookieCompliance.atlFirstVisitCache;
                                if (payload === undefined && CookieCompliance._isLocalStorageAvailable()) try {
                                    var data = window.localStorage.getItem($f1d158ad5148ce30$var$ATL_FIRST_VISIT_KEY);
                                    payload = data ? JSON.parse(data) : undefined;
                                } catch (_unused4) {
                                    // swallow — the property setter must not throw
                                    return;
                                }
                                if (!payload || Object.keys(payload).length === 0) return;
                                payload.activeGroups = newGroups;
                                // Keep the cache + public field in sync.
                                CookieCompliance.atlFirstVisitCache = payload;
                                CookieCompliance.atlFirstVisit = payload;
                                // Persist to storage when available; skip silently otherwise.
                                if (CookieCompliance._isLocalStorageAvailable()) try {
                                    window.localStorage.setItem($f1d158ad5148ce30$var$ATL_FIRST_VISIT_KEY, JSON.stringify(payload));
                                } catch (_unused5) {
                                // swallow — the property setter must not throw
                                }
                            }
                        },
                        configurable: true
                    });
                    CookieCompliance.activeGroupsListenerInstalled = true;
                } catch (e) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('atl_first_visit activeGroups listener install failed', e instanceof Error ? e.message : String(e));
                }
            }
        },
        {
            key: "_setAtlFirstVisit",
            value: function _setAtlFirstVisit(pageViewProperties) {
                var refUrl = null;
                try {
                    refUrl = document.referrer ? new URL(document.referrer) : null;
                } catch (_unused6) {
                    refUrl = null;
                }
                var data = {
                    originProduct: CookieCompliance._try(function() {
                        return pageViewProperties === null || pageViewProperties === void 0 ? void 0 : pageViewProperties['originProduct'];
                    }),
                    campaign: CookieCompliance._try(function() {
                        return $4fb91a309ed42af5$exports.Helpers.getUtms({
                            utm_campaign: '',
                            utm_medium: '',
                            utm_source: '',
                            utm_content: '',
                            utm_term: ''
                        });
                    }),
                    page_url_params_json: CookieCompliance._try(function() {
                        return JSON.stringify(CookieCompliance._parseQuery(window.location.search));
                    }),
                    page_url: CookieCompliance._try(function() {
                        return window.location.href;
                    }),
                    page_path: CookieCompliance._try(function() {
                        return window.location.pathname;
                    }),
                    page_domain: CookieCompliance._try(function() {
                        return window.location.hostname;
                    }),
                    page_subdomain: CookieCompliance._try(function() {
                        return window.location.hostname;
                    }),
                    page_referrer_url: CookieCompliance._try(function() {
                        return document.referrer;
                    }),
                    page_referrer_domain: CookieCompliance._try(function() {
                        var _refUrl;
                        return (_refUrl = refUrl) === null || _refUrl === void 0 ? void 0 : _refUrl.hostname;
                    }),
                    page_referrer_subdomain: CookieCompliance._try(function() {
                        var _refUrl2;
                        return (_refUrl2 = refUrl) === null || _refUrl2 === void 0 ? void 0 : _refUrl2.hostname;
                    }),
                    page_url_parameters: CookieCompliance._try(function() {
                        return window.location.search;
                    }),
                    page_referrer_url_parameters: CookieCompliance._try(function() {
                        var _refUrl3;
                        return (_refUrl3 = refUrl) === null || _refUrl3 === void 0 ? void 0 : _refUrl3.search;
                    }),
                    cookiesEnabled: CookieCompliance._try(function() {
                        var _window$navigator;
                        return (_window$navigator = window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.cookieEnabled;
                    }, 'unknown'),
                    activeGroups: CookieCompliance._try(function() {
                        return window.OnetrustActiveGroups;
                    }),
                    'bxp-gateway-id': CookieCompliance._try(function() {
                        return $767eab9fde59e2ab$exports.Cookie.readCookie('bxp_gateway_request_id');
                    }),
                    'user-agent': CookieCompliance._try(function() {
                        var _window$navigator2;
                        return (_window$navigator2 = window.navigator) === null || _window$navigator2 === void 0 ? void 0 : _window$navigator2.userAgent;
                    }),
                    expiresAt: Date.now() + $f1d158ad5148ce30$var$ATL_FIRST_VISIT_TTL_MS
                };
                // Skip the write when storage is known-broken; cache the payload in memory.
                if (!CookieCompliance._isLocalStorageAvailable()) {
                    CookieCompliance.atlFirstVisitCache = data;
                    return;
                }
                try {
                    window.localStorage.setItem($f1d158ad5148ce30$var$ATL_FIRST_VISIT_KEY, JSON.stringify(data));
                    CookieCompliance.atlFirstVisitCache = data;
                } catch (e) {
                    // Mark storage unavailable so subsequent ops short-circuit.
                    CookieCompliance.localStorageAvailable = false;
                    CookieCompliance.atlFirstVisitCache = data;
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('atl_first_visit localStorage update failed', e instanceof Error ? e.message : String(e));
                }
            }
        },
        {
            key: "_try",
            value: function _try(fn) {
                var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                try {
                    var value = fn();
                    return value === null || value === undefined ? fallback : value;
                } catch (_unused7) {
                    return fallback;
                }
            }
        },
        {
            key: "_parseQuery",
            value: function _parseQuery(search) {
                var out = {};
                if (!search) return out;
                var params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
                params.forEach(function(value, key) {
                    out[key] = value;
                });
                return out;
            }
        },
        {
            key: "waitForOneTrustToInit",
            value: function() {
                var _waitForOneTrustToInit = $f1d158ad5148ce30$var$_asyncToGenerator(/*#__PURE__*/ $f1d158ad5148ce30$var$_regeneratorRuntime().mark(function _callee() {
                    var maxWaitMs, _args = arguments;
                    return $f1d158ad5148ce30$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                maxWaitMs = _args.length > 0 && _args[0] !== undefined ? _args[0] : 3000;
                                if (!(typeof window === 'undefined')) {
                                    _context.next = 3;
                                    break;
                                }
                                return _context.abrupt("return");
                            case 3:
                                if (!(typeof window.OnetrustActiveGroups === 'string')) {
                                    _context.next = 5;
                                    break;
                                }
                                return _context.abrupt("return");
                            case 5:
                                return _context.abrupt("return", new Promise(function(resolve) {
                                    var POLL_MS = 250;
                                    var timers = {};
                                    timers.interval = setInterval(function() {
                                        if (typeof window.OnetrustActiveGroups === 'string') {
                                            if (timers.interval) clearInterval(timers.interval);
                                            if (timers.timeout) clearTimeout(timers.timeout);
                                            resolve();
                                        }
                                    }, POLL_MS);
                                    timers.timeout = setTimeout(function() {
                                        if (timers.interval) clearInterval(timers.interval);
                                        resolve();
                                    }, maxWaitMs);
                                }));
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function waitForOneTrustToInit() {
                    return _waitForOneTrustToInit.apply(this, arguments);
                }
                return waitForOneTrustToInit;
            }()
        }
    ]);
}();
/**
 * Resolved sn_id (after `setSnIdAndAtlFirstVisit` runs). Attached to the `requested_page`
 * operational event in `Tracking.pageView` (mirrors upstream PR #269).
 */ $f1d158ad5148ce30$var$_defineProperty($f1d158ad5148ce30$var$CookieCompliance, "snId", '');
/**
 * Resolved atl_first_visit payload (after `setSnIdAndAtlFirstVisit` runs). Attached to the
 * `requested_page` operational event.
 */ $f1d158ad5148ce30$var$_defineProperty($f1d158ad5148ce30$var$CookieCompliance, "atlFirstVisit", {});
/**
 * Memoised result of the most recent `optOutPerfTracking()` call. Used so the rest of the
 * wrapper can branch off a stable boolean within a single init pass without re-reading the
 * gate / cookie on every event. Refreshed on each `optOutPerfTracking()` call.
 */ $f1d158ad5148ce30$var$_defineProperty($f1d158ad5148ce30$var$CookieCompliance, "optedOut", false);
/**
 * Idempotency flag for `_listenForActiveGroupsChange()`. The
 * `Object.defineProperty` accessor on `window.OnetrustActiveGroups` can only
 * be installed once per page lifecycle (re-installing throws), so callers
 * can safely invoke from every SPA route change.
 */ $f1d158ad5148ce30$var$_defineProperty($f1d158ad5148ce30$var$CookieCompliance, "activeGroupsListenerInstalled", false);
/**
 * Memoised feature-detect for `window.localStorage`. Tri-state: `undefined`
 * = not probed, `true` = available, `false` = unavailable (Safari private
 * mode, sandboxed iframe, ITP, disabled). Once `false`, callers MUST skip
 * storage ops — repeating them on every event amplifies upstream operational
 * error volume.
 */ $f1d158ad5148ce30$var$_defineProperty($f1d158ad5148ce30$var$CookieCompliance, "localStorageAvailable", undefined);
/**
 * Memoised parsed `atl_first_visit` payload for this page lifecycle. Set on
 * first read so SPA route changes don't re-hit storage.
 */ $f1d158ad5148ce30$var$_defineProperty($f1d158ad5148ce30$var$CookieCompliance, "atlFirstVisitCache", undefined);



var $077fd9c14d82a85a$exports = {};
"use strict";
Object.defineProperty($077fd9c14d82a85a$exports, "__esModule", {
    value: true
});
$077fd9c14d82a85a$exports.GASv3 = void 0;
var $3bef5a1e67ea5779$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};



var $dpXUu = parcelRequire("dpXUu");







var $a49bd8faafbfa6f8$exports = {};
"use strict";
Object.defineProperty($a49bd8faafbfa6f8$exports, "__esModule", {
    value: true
});
$a49bd8faafbfa6f8$exports.TrelloUrlScrubber = void 0;
function $a49bd8faafbfa6f8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a49bd8faafbfa6f8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a49bd8faafbfa6f8$var$_typeof(o);
}
function $a49bd8faafbfa6f8$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $a49bd8faafbfa6f8$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $a49bd8faafbfa6f8$var$_toPropertyKey(o.key), o);
    }
}
function $a49bd8faafbfa6f8$var$_createClass(e, r, t) {
    return r && $a49bd8faafbfa6f8$var$_defineProperties(e.prototype, r), t && $a49bd8faafbfa6f8$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $a49bd8faafbfa6f8$var$_toPropertyKey(t) {
    var i = $a49bd8faafbfa6f8$var$_toPrimitive(t, "string");
    return "symbol" == $a49bd8faafbfa6f8$var$_typeof(i) ? i : i + "";
}
function $a49bd8faafbfa6f8$var$_toPrimitive(t, r) {
    if ("object" != $a49bd8faafbfa6f8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a49bd8faafbfa6f8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $a49bd8faafbfa6f8$var$routeTypes = {
    BOARD: 'board',
    BOARD_BUTLER: 'board-butler',
    BOARD_BUTLER_PAGE: 'board-butler-page',
    BOARD_RECOMMEND: 'board-recommend',
    CARD: 'card',
    ENTERPRISE_ADMIN: 'enterprise-admin',
    ENTERPRISE_ADMIN_TAB: 'enterprise-admin-tab',
    ENTERPRISE_ADMIN_TAB_SUBSECTION: 'enterprise-admin-tab-subsection',
    HOME: 'home',
    TEMPLATES: 'templates',
    TEMPLATES_CATEGORIES: 'templates-categories',
    TEMPLATES_STORY: 'templates-story',
    TEMPLATES_RECOMMEND: 'templates-recommend',
    TEMPLATES_SUBMIT: 'templates-submit',
    TEMPLATE: 'template',
    USER: 'user',
    USER_TABS: 'user-tabs',
    USER_CARDS_WORKSPACE: 'user-cards-workspace',
    VIEW: 'view',
    WORKSPACE: 'workspace',
    WORKSPACE_SECTION: 'workspace-section',
    WORKSPACE_MEMBERS_SUBSECTION: 'workspace-members-subsection',
    WORKSPACE_VIEWS_SUBSECTION: 'workspace-views-subsection',
    POWER_UPS_HOME: 'power-ups-home',
    POWER_UPS_ALL: 'power-ups-all',
    POWER_UPS_TRELLO: 'power-ups-trello',
    POWER_UPS_CATEGORIES: 'power-ups-categories',
    UPGRADE_TEAM: 'select-team-to-upgrade',
    SHORTCUTS: 'shortcuts'
};
// Trello indices of non UGC/PII in the pathname depending on their route type
var $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES = {
    ROUTE_IDENTIFIER: 0,
    ROUTE_SHORTLINK: 1,
    B_ROUTE_BUTLER: 3,
    B_ROUTE_BUTLER_PAGE: 4,
    B_ROUTE_RECOMMEND: 4,
    E_ROUTE_ADMIN: 2,
    E_ROUTE_ADMIN_TAB_NAME: 3,
    E_ROUTE_ADMIN_TAB_SUBSECTION_NAME: 4,
    POWER_UPS_ROUTE_PAGE: 1,
    POWER_UPS_ROUTE_CATEGORY: 1,
    POWER_UPS_ROUTE_CATEGORY_NAME: 2,
    TEMPLATES_ROUTE_PAGE: 1,
    TEMPLATES_ROUTE_CATEGORY: 1,
    TEMPLATES_ROUTE_TEMPLATE_NAME: 2,
    TEMPLATES_ROUTE_RECOMMEND: 4,
    U_ROUTE_TAB_NAME: 2,
    W_ROUTE_PAGE: 2,
    W_ROUTE_PAGE_SUBSECTION: 3
};
var $a49bd8faafbfa6f8$var$routePatternMap = new Map([
    [
        $a49bd8faafbfa6f8$var$routeTypes.BOARD_RECOMMEND,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.BOARD_RECOMMEND,
            regExp: new RegExp('^/b/([^/]+)/([^/]+)/([^/]+)/recommend$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.B_ROUTE_RECOMMEND
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.BOARD_BUTLER_PAGE,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.BOARD_BUTLER_PAGE,
            regExp: new RegExp('^/b/([^/]+)/([^/]+)/butler/(rules|card-buttons|board-buttons|schedule|on-dates|connected-apps)$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.B_ROUTE_BUTLER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.B_ROUTE_BUTLER_PAGE
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.BOARD_BUTLER,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.BOARD_BUTLER,
            regExp: new RegExp('^/b/([^/]+)/([^/]+)/butler/$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.B_ROUTE_BUTLER
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.BOARD,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.BOARD,
            regExp: new RegExp('^/b/([^/]+)(?:/(.*?))?$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.CARD,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.CARD,
            regExp: new RegExp('^/c/'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.ENTERPRISE_ADMIN_TAB_SUBSECTION,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.ENTERPRISE_ADMIN_TAB_SUBSECTION,
            regExp: new RegExp('^/e/([^/]+)/admin/(members|workspaces|boards)/(managed|boardguests|deactivated|non-enterprise|pending|public)$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN_TAB_NAME,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN_TAB_SUBSECTION_NAME
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.ENTERPRISE_ADMIN_TAB,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.ENTERPRISE_ADMIN_TAB,
            regExp: new RegExp('^/e/([^/]+)/admin/(members|workspaces|settings|attachment-restrictions|boards|power-ups|auditlog|account-administration|sso|api-tokens)$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN_TAB_NAME
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.ENTERPRISE_ADMIN,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.ENTERPRISE_ADMIN,
            regExp: new RegExp('^/e/([^/]+)/admin$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.POWER_UPS_HOME,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.POWER_UPS_HOME,
            regExp: new RegExp('^/power-ups$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.POWER_UPS_ALL,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.POWER_UPS_ALL,
            regExp: new RegExp('^/power-ups/all$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.POWER_UPS_ROUTE_PAGE
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.POWER_UPS_TRELLO,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.POWER_UPS_TRELLO,
            regExp: new RegExp('^/power-ups/made-by-trello$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.POWER_UPS_ROUTE_PAGE
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.POWER_UPS_CATEGORIES,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.POWER_UPS_CATEGORIES,
            regExp: new RegExp('^/power-ups/category/(automation|analytics-reporting|board-utilities|communication-collaboration|developer-tools|file-management|hr-operations|it-project-management|marketing-social-media|product-design|sales-support)$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.POWER_UPS_ROUTE_CATEGORY,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.POWER_UPS_ROUTE_CATEGORY_NAME
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.HOME,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.HOME,
            regExp: new RegExp('^/$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.UPGRADE_TEAM,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.UPGRADE_TEAM,
            regExp: new RegExp('^/select-team-to-upgrade$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.SHORTCUTS,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.SHORTCUTS,
            regExp: new RegExp('^/shortcuts$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.TEMPLATES_SUBMIT,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.TEMPLATES_SUBMIT,
            regExp: new RegExp('^/templates/submit$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_PAGE
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.TEMPLATES_RECOMMEND,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.TEMPLATES_RECOMMEND,
            regExp: new RegExp('^/templates/([^/]+)/([^/]+)/([^/]+)/recommend$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_CATEGORY,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_TEMPLATE_NAME,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_RECOMMEND
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.TEMPLATES_CATEGORIES,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.TEMPLATES_CATEGORIES,
            regExp: new RegExp('^/templates/(business|design|education|engineering|marketing|operations-hr|personal|productivity|product-management|project-management|remote-work|sales|support|team-management)$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_CATEGORY
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.TEMPLATES_STORY,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.TEMPLATES_STORY,
            regExp: new RegExp('^/templates/([^/]+)/([^/]+)$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_CATEGORY,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_TEMPLATE_NAME
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.TEMPLATES,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.TEMPLATES,
            regExp: new RegExp('^/templates$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.USER_CARDS_WORKSPACE,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.USER_CARDS_WORKSPACE,
            regExp: new RegExp('^/u/([^/]+)/cards/([^/]+)$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.U_ROUTE_TAB_NAME
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.USER_TABS,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.USER_TABS,
            regExp: new RegExp('^/u/([^/]+)/(profile|activity|boards|cards|labs|tasks)$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.U_ROUTE_TAB_NAME
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.USER,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.USER,
            regExp: new RegExp('^/u/'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.VIEW,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.VIEW,
            regExp: new RegExp('^/v/'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.WORKSPACE_SECTION,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.WORKSPACE_SECTION,
            regExp: new RegExp('^/w/([^/]+)/(account|billing|home|export|free-trial|members|tables|getting-started|highlights|reports)$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.W_ROUTE_PAGE
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.WORKSPACE_MEMBERS_SUBSECTION,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.WORKSPACE_MEMBERS_SUBSECTION,
            regExp: new RegExp('^/w/([^/]+)/members/(guests|requests)$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.W_ROUTE_PAGE,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.W_ROUTE_PAGE_SUBSECTION
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.WORKSPACE_VIEWS_SUBSECTION,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.WORKSPACE_VIEWS_SUBSECTION,
            regExp: new RegExp('^/w/([^/]+)/views/(table|calendar|)$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.W_ROUTE_PAGE,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.W_ROUTE_PAGE_SUBSECTION
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.WORKSPACE,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.WORKSPACE,
            regExp: new RegExp('^/w/'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ]
]);
var $a49bd8faafbfa6f8$var$TrelloUrlScrubber = $a49bd8faafbfa6f8$exports.TrelloUrlScrubber = /*#__PURE__*/ function() {
    function TrelloUrlScrubber() {
        $a49bd8faafbfa6f8$var$_classCallCheck(this, TrelloUrlScrubber);
    }
    return $a49bd8faafbfa6f8$var$_createClass(TrelloUrlScrubber, null, [
        {
            key: "_determineRoute",
            value: function _determineRoute(urlPathname) {
                var routePatternArray = Array.from($a49bd8faafbfa6f8$var$routePatternMap.values());
                for(var _i = 0, _routePatternArray = routePatternArray; _i < _routePatternArray.length; _i++){
                    var routeDefinition = _routePatternArray[_i];
                    if (routeDefinition.regExp.exec(urlPathname)) return routeDefinition;
                }
                return null;
            }
        },
        {
            key: "_reconstructPathname",
            value: function _reconstructPathname(pathnameSections, sectionsToKeep) {
                var reconstructedUrl = '';
                for(var i = 0; i < pathnameSections.length; i++)if (sectionsToKeep.includes(i)) reconstructedUrl += '/' + pathnameSections[i];
                return reconstructedUrl;
            }
        },
        {
            key: "scrubUrl",
            value: function scrubUrl(urlPathname, defaultPathname) {
                var matchingRoute = TrelloUrlScrubber._determineRoute(urlPathname);
                // remove starting slash to allow matchers to use ^ properly
                var partialUrl = urlPathname.substring(1, urlPathname.length);
                var pathnameSections = partialUrl.split('/');
                // to avoid UGC/PII related HOTs, we should be extra cautious & return a
                // generic path for URLs that don't follow a known pattern
                return matchingRoute ? TrelloUrlScrubber._reconstructPathname(pathnameSections, matchingRoute.allowlist) : defaultPathname;
            }
        }
    ]);
}();


function $077fd9c14d82a85a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $077fd9c14d82a85a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $077fd9c14d82a85a$var$_typeof(o);
}
function $077fd9c14d82a85a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $077fd9c14d82a85a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $077fd9c14d82a85a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $077fd9c14d82a85a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $077fd9c14d82a85a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $077fd9c14d82a85a$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $077fd9c14d82a85a$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $077fd9c14d82a85a$var$_toPropertyKey(o.key), o);
    }
}
function $077fd9c14d82a85a$var$_createClass(e, r, t) {
    return r && $077fd9c14d82a85a$var$_defineProperties(e.prototype, r), t && $077fd9c14d82a85a$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $077fd9c14d82a85a$var$_defineProperty(e, r, t) {
    return (r = $077fd9c14d82a85a$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $077fd9c14d82a85a$var$_toPropertyKey(t) {
    var i = $077fd9c14d82a85a$var$_toPrimitive(t, "string");
    return "symbol" == $077fd9c14d82a85a$var$_typeof(i) ? i : i + "";
}
function $077fd9c14d82a85a$var$_toPrimitive(t, r) {
    if ("object" != $077fd9c14d82a85a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $077fd9c14d82a85a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

var $lSdkB = parcelRequire("lSdkB");
var $077fd9c14d82a85a$var$attributeWhiteList = [
    'atlCohort',
    'featureFlags'
];
var $077fd9c14d82a85a$var$ATL_USER_HASH = 'atlUserHash';
/**
 * Module for GASv3 tracking events.
 * @module GASv3
 */ var $077fd9c14d82a85a$var$GASv3 = $077fd9c14d82a85a$exports.GASv3 = /*#__PURE__*/ function() {
    function GASv3() {
        $077fd9c14d82a85a$var$_classCallCheck(this, GASv3);
    }
    return $077fd9c14d82a85a$var$_createClass(GASv3, null, [
        {
            key: "sendUIEvent",
            value: /**
     * Sends a UI event to GASv3
     * @function sendUIEvent
     * @param {string} name
     * @param {object} data
     * @param {object} skipEnrichment - whether to add additional data
     */ function sendUIEvent(name, data, skipEnrichment) {
                if ($f1d158ad5148ce30$exports.CookieCompliance.optOutPerfTracking()) return;
                var attributes = data.attributes || {};
                if (!skipEnrichment) attributes = GASv3.enrichEventData(data.attributes);
                attributes['trackEventName'] = name;
                var source = GASv3.setSource(data);
                var uiEvent = {
                    action: data.action || 'clicked',
                    actionSubject: data.actionSubject || 'component',
                    actionSubjectId: data.actionSubjectId || undefined,
                    source: source,
                    attributes: attributes
                };
                this._createAndFireEvent($dpXUu.eventType.UI, uiEvent);
            }
        },
        {
            key: "sendScreenEvent",
            value: function sendScreenEvent(name, data, skipEnrichment) {
                if ($f1d158ad5148ce30$exports.CookieCompliance.optOutPerfTracking()) return;
                var attributes = data.attributes || {};
                if (!skipEnrichment) attributes = GASv3.enrichEventData(data.attributes);
                attributes['name'] = name || data['name'];
                var screenName = data['name'] || attributes['screenNameOverride'] || 'page';
                delete attributes['screenNameOverride'];
                this._createAndFireEvent($dpXUu.eventType.SCREEN, {
                    name: screenName,
                    attributes: attributes
                });
                GASv3.sendIdentityEvent();
            }
        },
        {
            key: "sendTrackEvent",
            value: function sendTrackEvent(name, data, skipEnrichment) {
                if ($f1d158ad5148ce30$exports.CookieCompliance.optOutPerfTracking()) return;
                var attributes = data.attributes || {};
                if (!skipEnrichment) attributes = GASv3.enrichEventData(data.attributes);
                attributes['trackEventName'] = name;
                data.source = GASv3.setSource(data);
                data.attributes = attributes;
                this._createAndFireEvent($dpXUu.eventType.TRACK, data);
            }
        },
        {
            key: "sendOperationalEvent",
            value: function sendOperationalEvent(name, data, skipEnrichment) {
                var attributes = data.attributes || {};
                if (!skipEnrichment) attributes = GASv3.enrichEventData(data.attributes);
                attributes['trackEventName'] = name;
                data.source = GASv3.setSource(data);
                data.attributes = attributes;
                // When opted out of performance cookies, exclude cross-product
                // identifiers from operational events so the strictly-necessary sn_id is the only
                // session linker. Uses the analytics-web-client native `excludedProperties` option
                // (requires @atlassiansox/analytics-web-client >= 5.24.0) per upstream atl-analytics.
                if ($f1d158ad5148ce30$exports.CookieCompliance.optedOut) data.excludedProperties = {
                    anonymousId: true,
                    authenticatedUserId: true,
                    userId: true,
                    xid: true
                };
                this._createAndFireEvent($dpXUu.eventType.OPERATIONAL, data);
            }
        },
        {
            key: "sendIdentityEvent",
            value: function sendIdentityEvent() {
                if ($f1d158ad5148ce30$exports.CookieCompliance.optOutPerfTracking()) return;
                // load the identity hash cookie
                var atlUserHash = $767eab9fde59e2ab$exports.Cookie.readCookie($077fd9c14d82a85a$var$ATL_USER_HASH);
                // get the user identifiers
                var identifiers = GASv3.getUserIdentifiers();
                // calculate the data hash of the known identifiers
                var calculatedHash = $d568c1b4cd0cc27f$exports.Guid.guidHashCode(JSON.stringify(identifiers)).toString();
                if (!atlUserHash || atlUserHash !== calculatedHash) {
                    // save new hash and send UI event
                    $767eab9fde59e2ab$exports.Cookie.writeCookie($077fd9c14d82a85a$var$ATL_USER_HASH, calculatedHash, 3650, true);
                    var data = {
                        action: 'identified',
                        actionSubject: 'user',
                        identifiers: identifiers,
                        writeKey: $adbd9ab2eaa40909$exports.AnalyticsState.writeKey
                    };
                    GASv3.sendUIEvent('', data, true);
                }
            }
        },
        {
            key: "getUserIdentifiers",
            value: function getUserIdentifiers() {
                return {
                    anonymousId: $adbd9ab2eaa40909$exports.AnalyticsState.anonymousId,
                    atlassianAccountId: $35247c7511184ad3$exports.Identity.getAtlassianUserId(),
                    crossDomainId: $3f4554f5dd6755f8$exports.Tracking.xid,
                    optimizelyEndUserId: null,
                    trelloUserId: $35247c7511184ad3$exports.Identity.getTrelloUserId()
                };
            }
        },
        {
            key: "setSource",
            value: function setSource(data) {
                var set = false;
                var source = data.source || '';
                if (source) set = true;
                if (data['eventContainer']) {
                    source += data['eventContainer'].split(' ')[0];
                    set = true;
                }
                if (data['eventColumn']) {
                    source += data['eventColumn'].split(' ')[0];
                    set = true;
                }
                if (!set) source = 'none';
                return source;
            }
        },
        {
            key: "getReferrerURL",
            value: function getReferrerURL(ref) {
                if ($35247c7511184ad3$exports.Identity.isReferrerTrello()) {
                    var referrer = new URL(ref);
                    return referrer.hostname + $a49bd8faafbfa6f8$exports.TrelloUrlScrubber.scrubUrl(referrer.pathname, '');
                }
                return ref;
            }
        },
        {
            key: "_createAndFireEvent",
            value: function _createAndFireEvent(eventType, payload) {
                // using analytics-next createAndFireEvent to send event
                if ($adbd9ab2eaa40909$exports.AnalyticsState.createAnalyticsEvent) (0, $3bef5a1e67ea5779$export$2e2bcd8739ae039)('atl-global')($077fd9c14d82a85a$var$_objectSpread($077fd9c14d82a85a$var$_objectSpread({}, payload), {}, {
                    eventType: eventType
                }))($adbd9ab2eaa40909$exports.AnalyticsState.createAnalyticsEvent);
                // using analytics-web-client to send event
                if (GASv3.client) switch(eventType){
                    case 'ui':
                        GASv3.client.sendUIEvent(payload, null);
                        break;
                    case 'screen':
                        GASv3.client.sendScreenEvent(payload, null);
                        break;
                    case 'operational':
                        GASv3.client.sendOperationalEvent(payload, null);
                        break;
                    case 'track':
                        GASv3.client.sendTrackEvent(payload, null);
                        break;
                }
            }
        },
        {
            key: "enrichEventData",
            value: function enrichEventData(inputData) {
                var data = {};
                if ($077fd9c14d82a85a$var$_typeof(inputData) !== 'object' || inputData === null) {
                    var dataValue = inputData;
                    if (typeof dataValue !== 'undefined') data.data = dataValue;
                } else data = inputData;
                var newData = JSON.parse(JSON.stringify(data));
                newData.writeKey = $adbd9ab2eaa40909$exports.AnalyticsState.writeKey;
                newData.isMarketingEvent = GASv3.isMarketingEvent;
                var page;
                var ref;
                var page_canonical_url;
                try {
                    var _page;
                    // convert all passed in values to string if they are currently objects
                    Object.keys(newData).forEach(function(inputKey) {
                        var key = inputKey;
                        if (newData[key] && $077fd9c14d82a85a$var$_typeof(newData[key]) === 'object' && !Array.isArray(newData[key]) && !$077fd9c14d82a85a$var$attributeWhiteList.includes(key)) // @ts-ignore
                        newData[key] = JSON.stringify(newData[key]);
                    });
                    var href = GASv3.getLocation();
                    page = href ? new URL($4fb91a309ed42af5$exports.Helpers.maskURL(href)) : null;
                    var referredByJiraDotCom = ((_page = page) === null || _page === void 0 ? void 0 : _page.searchParams.get('referer')) === 'jira.com';
                    ref = referredByJiraDotCom ? new URL('https://www.jira.com') : document.referrer ? new URL($4fb91a309ed42af5$exports.Helpers.maskURL(document.referrer)) : null;
                    var canonical_url = $4fb91a309ed42af5$exports.Helpers.getCanonicalUrl();
                    page_canonical_url = canonical_url ? $4fb91a309ed42af5$exports.Helpers.maskURL($4fb91a309ed42af5$exports.Helpers.getCanonicalUrl()) : undefined;
                    newData.page_title = newData.page_title || document.title || '';
                    newData.page_domain = page ? page.hostname || '' : '';
                    newData.page_subdomain = page ? page.hostname || '' : '';
                    // referrer attributes
                    newData.page_referrer_domain = ref ? ref.hostname || '' : '';
                    newData.page_referrer_subdomain = ref ? ref.hostname || '' : '';
                    if ($35247c7511184ad3$exports.Identity.isReferrerTrello()) {
                        // fix for hot-99118
                        newData.page_canonical_url = page ? $a49bd8faafbfa6f8$exports.TrelloUrlScrubber.scrubUrl(page.href, page.origin) || '' : '';
                        newData.page_url = page ? $a49bd8faafbfa6f8$exports.TrelloUrlScrubber.scrubUrl(page.href, page.origin) || '' : '';
                        newData.page_path = page ? $a49bd8faafbfa6f8$exports.TrelloUrlScrubber.scrubUrl(page.pathname, new URL(page.href).pathname) || '' : '';
                        newData.page_url_parameters = page ? $a49bd8faafbfa6f8$exports.TrelloUrlScrubber.scrubUrl(page.search, '') : '';
                        newData.page_url_params_json = page ? JSON.stringify($lSdkB.parse($a49bd8faafbfa6f8$exports.TrelloUrlScrubber.scrubUrl(page.search, new URL(page.origin).pathname))) : '';
                        newData.page_referrer_url_params_json = ref ? JSON.stringify($lSdkB.parse($a49bd8faafbfa6f8$exports.TrelloUrlScrubber.scrubUrl(ref.search, new URL(ref.origin).pathname))) : '';
                        newData.page_referrer_path = ref ? $a49bd8faafbfa6f8$exports.TrelloUrlScrubber.scrubUrl(ref.pathname, new URL(ref.origin).pathname) || '' : '';
                        newData.page_referrer_url = ref ? ref.origin + $a49bd8faafbfa6f8$exports.TrelloUrlScrubber.scrubUrl(ref.pathname, new URL(ref.origin).pathname) || '' : '';
                    } else {
                        newData.page_canonical_url = page_canonical_url;
                        newData.page_url = page ? page.href || '' : '';
                        newData.page_path = page ? page.pathname || '' : '';
                        newData.page_url_parameters = page ? page.search || '' : '';
                        newData.page_url_params_json = page ? JSON.stringify($lSdkB.parse(page.search)) : '';
                        newData.page_url_fragment = page ? $4fb91a309ed42af5$exports.Helpers.getUrlFragment() : ''; // added for community client
                        newData.page_referrer_url_params_json = ref ? JSON.stringify($lSdkB.parse(ref.search)) : '';
                        newData.page_referrer_path = ref ? ref.pathname || '' : '';
                        newData.page_referrer_url = ref ? ref.href || '' : '';
                    }
                    newData.cookiesEnabled = window.navigator ? window.navigator.cookieEnabled : 'unknown';
                    newData.activeGroups = window.OnetrustActiveGroups ? window.OnetrustActiveGroups : '';
                    // add additionalEventData
                    for(var _key in GASv3.additionalEventData)// eslint-disable-next-line no-prototype-builtins
                    if (GASv3.additionalEventData.hasOwnProperty(_key)) newData[_key] = GASv3.additionalEventData[_key];
                } catch (e) {
                    // fix for hot-99118
                    var additionalData = {
                        error: e instanceof Error ? e.message : JSON.stringify(e),
                        href: location ? location.href : 'no location',
                        referrer: document ? document.referrer ? GASv3.getReferrerURL(document.referrer) : 'no referrer' : 'no document'
                    };
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('GASv3 enrichEventData error', JSON.stringify(additionalData));
                }
                return newData;
            }
        },
        {
            key: "getLocation",
            value: function getLocation() {
                return location.href;
            }
        }
    ]);
}();
// set this value with attributes that should be sent on every event, set during event enrichment
$077fd9c14d82a85a$var$_defineProperty($077fd9c14d82a85a$var$GASv3, "additionalEventData", {});


var $6428f42409a4abae$exports = {};
"use strict";
Object.defineProperty($6428f42409a4abae$exports, "__esModule", {
    value: true
});
$6428f42409a4abae$exports.Gtm = void 0;


function $6428f42409a4abae$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6428f42409a4abae$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6428f42409a4abae$var$_typeof(o);
}
function $6428f42409a4abae$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $6428f42409a4abae$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $6428f42409a4abae$var$_toPropertyKey(o.key), o);
    }
}
function $6428f42409a4abae$var$_createClass(e, r, t) {
    return r && $6428f42409a4abae$var$_defineProperties(e.prototype, r), t && $6428f42409a4abae$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $6428f42409a4abae$var$_toPropertyKey(t) {
    var i = $6428f42409a4abae$var$_toPrimitive(t, "string");
    return "symbol" == $6428f42409a4abae$var$_typeof(i) ? i : i + "";
}
function $6428f42409a4abae$var$_toPrimitive(t, r) {
    if ("object" != $6428f42409a4abae$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6428f42409a4abae$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /**
 * Internal module for initializing Snowplow and making Snowplow-specific event calls. Public init functions can be found in Initializer module
 * @module Gtm
 */ 
var $6428f42409a4abae$var$Gtm = $6428f42409a4abae$exports.Gtm = /*#__PURE__*/ function() {
    function Gtm() {
        $6428f42409a4abae$var$_classCallCheck(this, Gtm);
    }
    return $6428f42409a4abae$var$_createClass(Gtm, null, [
        {
            key: "initialize",
            value: /**
     * Initializes Google Tag Manager
     * @function initialize
     */ function initialize(writeKey) {
                if ($f1d158ad5148ce30$exports.CookieCompliance.optOutPerfTracking()) return;
                var containerId = Gtm.getContainerId(writeKey);
                if (containerId) {
                    var _firstScript$parentNo;
                    window['dataLayer'] = window['dataLayer'] || [];
                    window['dataLayer'].push({
                        'gtm.start': new Date().getTime(),
                        event: 'gtm.js'
                    });
                    var firstScript = document.getElementsByTagName('script')[0];
                    var gtmScript = document.createElement('script');
                    gtmScript.defer = true;
                    gtmScript.src = 'https://www.googletagmanager.com/gtm.js?id=' + containerId;
                    firstScript === null || firstScript === void 0 || (_firstScript$parentNo = firstScript.parentNode) === null || _firstScript$parentNo === void 0 || _firstScript$parentNo.appendChild(gtmScript);
                }
            }
        },
        {
            key: "page",
            value: function page(name, category, data) {
                if ($f1d158ad5148ce30$exports.CookieCompliance.optOutPerfTracking()) return;
                var event = 'Loaded a Page';
                Gtm.track(data, event);
                if (category) {
                    event = 'Viewed ' + name + ' ' + category + ' Page';
                    Gtm.track(data, event);
                }
                if (name) {
                    event = 'Viewed ' + name + ' Page';
                    Gtm.track(data, event);
                }
            }
        },
        {
            key: "track",
            value: function track(data, event) {
                if ($f1d158ad5148ce30$exports.CookieCompliance.optOutPerfTracking()) return;
                var props = typeof data !== 'undefined' ? JSON.parse(JSON.stringify(data)) : {};
                var anonId = $adbd9ab2eaa40909$exports.AnalyticsState.anonymousId;
                if (anonId) props.gasv3AnonymousId = anonId;
                if (event) props.event = event;
                var dataLayer = 'dataLayer';
                window[dataLayer] = window[dataLayer] || [];
                window[dataLayer].push(props);
            }
        },
        {
            key: "getContainerId",
            value: function getContainerId(writeKey) {
                var containerIds = Gtm.getContainerIdMapping();
                return containerIds[writeKey];
            }
        },
        {
            key: "getContainerIdMapping",
            value: function getContainerIdMapping() {
                return {
                    // Production
                    ycih1ygfsk: 'GTM-MR6PJQR',
                    // support.atlassian.com
                    '9nfqb81km3': 'GTM-TSGXFNC',
                    // confluence.atlassian.com
                    kFTUHPhH9Q: 'GTM-TRS3MV',
                    // bitbucket
                    u7y09b0olq: 'GTM-5VS67RK',
                    // developer.atlassian.com
                    eNVsl3NOQquS5E0YXjD4prfiNVqVP3mr: 'GTM-KZLJPX4',
                    // opsgenie
                    bvsetm1g1y: 'GTM-5RJSBR',
                    // atlassian.com-cart
                    kiv6wyh2nw: 'GTM-5RJSBR',
                    // atlassian.com
                    r4n974s99s: 'GTM-5RJSBR',
                    // blogs.atlassian.com
                    swoogo: 'GTM-5RJSBR',
                    // events.atlassian.com
                    '8oi64no': 'GTM-K7MDT22',
                    // statuspage.io
                    xjtlog1hqa: 'GTM-KQ6R2C3',
                    // marketplace.atlassian.com
                    bNSPpYAL9OiAkamBRvfRJoRu9YANW14I: 'GTM-MGV77B',
                    // docs.atlassian.com-aui
                    TNnhg0QuQfHEpBTzp27kJXNWZoMqSvkw: 'GTM-TQZMFCL',
                    // community.atlassian.com
                    trello: 'GTM-PJ8M5SK',
                    // trello
                    // Test
                    '4J6H7c3XTcpm1dbenkOILSyOachvf9It': 'GTM-TQZMFCL',
                    // community.stg.atlassian.com
                    SBLZG3ZYcSBcUMeLKLalrtyW8w1Caold: 'GTM-TQZMFCL',
                    // community.dev1.dev.atlassian.com
                    QVFu18jjHlCNaBXizZ3mtiqlBXVRkg1M: 'GTM-TQZMFCL',
                    // community.dev2.dev.atlassian.com
                    QmWM6iw7auEJw5gDQi6910Xk1wqyZ6bE: 'GTM-TQZMFCL',
                    // community.dev3.dev.atlassian.com
                    hWTszOAQMuItRdv8J30A3mNpCWd891bx: 'GTM-TQZMFCL',
                    // community.dev4.dev.atlassian.com
                    EWfeqJKJ0rPNOe3fcXrh2dg7bVXZNi2I: 'GTM-5RJSBR',
                    // qa-wac.internal.atlassian.com
                    Z2S07IGcRYkPJ7XHy3OIXcjpYoy9E6bs: 'GTM-5RJSBR' // CXP Local Dev
                };
            }
        }
    ]);
}();





var $55a1880d3758202a$exports = {};
"use strict";
Object.defineProperty($55a1880d3758202a$exports, "__esModule", {
    value: true
});
$55a1880d3758202a$exports.eventType = void 0;
// this is a 'const enum' copy of eventType from '@atlassiansox/analytics-web-client'
// exporting it here allows importing the enum directly from this package - it cannot be directly exported, as
// enums have issues being accessed during runtime from *.d.ts files
// https://stackoverflow.com/a/50511773
// https://stackoverflow.com/a/66939542
var $55a1880d3758202a$var$eventType = $55a1880d3758202a$exports.eventType = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});


function $3f4554f5dd6755f8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3f4554f5dd6755f8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3f4554f5dd6755f8$var$_typeof(o);
}
function $3f4554f5dd6755f8$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $3f4554f5dd6755f8$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $3f4554f5dd6755f8$var$_toPropertyKey(o.key), o);
    }
}
function $3f4554f5dd6755f8$var$_createClass(e, r, t) {
    return r && $3f4554f5dd6755f8$var$_defineProperties(e.prototype, r), t && $3f4554f5dd6755f8$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $3f4554f5dd6755f8$var$_toPropertyKey(t) {
    var i = $3f4554f5dd6755f8$var$_toPrimitive(t, "string");
    return "symbol" == $3f4554f5dd6755f8$var$_typeof(i) ? i : i + "";
}
function $3f4554f5dd6755f8$var$_toPrimitive(t, r) {
    if ("object" != $3f4554f5dd6755f8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3f4554f5dd6755f8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $3f4554f5dd6755f8$var$Tracking = $3f4554f5dd6755f8$exports.Tracking = /*#__PURE__*/ function() {
    function Tracking() {
        $3f4554f5dd6755f8$var$_classCallCheck(this, Tracking);
    }
    return $3f4554f5dd6755f8$var$_createClass(Tracking, null, [
        {
            key: "_getEventDomain",
            value: function _getEventDomain() {
                return location && location.href ? new URL(location.href).hostname : '';
            }
        },
        {
            key: "trackEvent",
            value: function trackEvent(event, data) {
                var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $55a1880d3758202a$exports.eventType.UI;
                // Drop non-operational events when the user is opted out of performance cookies.
                // Operational events still fire so we can observe page lifecycle compliantly.
                if (type !== $55a1880d3758202a$exports.eventType.OPERATIONAL && $f1d158ad5148ce30$exports.CookieCompliance.optOutPerfTracking()) return;
                // Upstream-aligned: prefer the async enrichment path when available.
                if (Tracking._shouldUsePromise()) {
                    Tracking.enrichEventDataPromise(data).then(function(enriched) {
                        try {
                            Tracking._trackEvent(event, enriched, type);
                        } catch (e) {
                            console.warn('enrich Event + tracking._trackEvent invocation failed', e);
                        }
                    }, function(e) {
                        console.warn('enrich Event + tracking._trackEvent invocation failed', e);
                    });
                    return;
                }
                try {
                    data = Tracking.enrichEventData(data);
                    Tracking._trackEvent(event, data, type);
                } catch (e) {
                    console.warn('enrich Event + tracking._trackEvent invocation failed', e);
                }
            }
        },
        {
            key: "_trackEvent",
            value: function _trackEvent(event, enrichedData, type) {
                switch(type){
                    case $55a1880d3758202a$exports.eventType.SCREEN:
                        $077fd9c14d82a85a$exports.GASv3.sendScreenEvent(event, enrichedData);
                        break;
                    case $55a1880d3758202a$exports.eventType.TRACK:
                        $077fd9c14d82a85a$exports.GASv3.sendTrackEvent(event, enrichedData);
                        break;
                    case $55a1880d3758202a$exports.eventType.OPERATIONAL:
                        $077fd9c14d82a85a$exports.GASv3.sendOperationalEvent(event, enrichedData);
                        break;
                    case $55a1880d3758202a$exports.eventType.UI:
                    default:
                        $077fd9c14d82a85a$exports.GASv3.sendUIEvent(event, enrichedData);
                        break;
                }
            }
        },
        {
            key: "_shouldUsePromise",
            value: function _shouldUsePromise() {
                return Tracking._browserSupportsPromises() && Tracking._userOptedOutOfTrackingCookies();
            }
        },
        {
            key: "_browserSupportsPromises",
            value: function _browserSupportsPromises() {
                return typeof Promise !== 'undefined';
            }
        },
        {
            key: "_userOptedOutOfTrackingCookies",
            value: function _userOptedOutOfTrackingCookies() {
                return false;
            }
        },
        {
            key: "enrichEventDataPromise",
            value: function enrichEventDataPromise(data) {
                return Promise.resolve(Tracking.enrichEventData(data));
            }
        },
        {
            key: "pageView",
            value: function pageView(pageViewProperties) {
                // Upstream-aligned: prefer the async enrichment path when available so we
                // can wait on identity hydration (marketo id) before firing. Falls back to
                // the synchronous path. Both paths converge on `_pageView()` for the
                // cookie-compliance / requested_page logic. Mirrors atl-analytics
                // _pageView at:
                // https://bitbucket.org/atlassian/atl-analytics/src/master/src/analytics/js/atl-events.js#lines-158
                if (Tracking._shouldUsePromise()) {
                    Tracking.enrichEventDataPromise(pageViewProperties).then(function(enriched) {
                        try {
                            Tracking._pageView(enriched);
                        } catch (e) {
                            console.warn('enrich Event + tracking._pageView invocation failed', e);
                        }
                    }, function(e) {
                        console.warn('enrich Event + tracking._pageView invocation failed', e);
                    });
                    return;
                }
                try {
                    pageViewProperties = Tracking.enrichEventData(pageViewProperties);
                    Tracking._pageView(pageViewProperties);
                } catch (e) {
                    console.warn('enrich Event + tracking._pageView invocation failed', e);
                }
            }
        },
        {
            key: "_pageView",
            value: function _pageView(enrichedPageViewProperties) {
                enrichedPageViewProperties.wrapperName = 'atl-global';
                enrichedPageViewProperties.destinationFlag = 'gasv3';
                if (window.cmsPageVariant) enrichedPageViewProperties.cmsPageVariant = window.cmsPageVariant;
                // ALWAYS fire the `requested_page` operational event regardless of consent
                // state. Operational events are strictly-necessary for page-lifecycle
                // observability and are exempt from C0002 (Performance) consent. The event
                // carries `sn_id` (24h cookie) and `atl_first_visit` (localStorage) as
                // strictly-necessary identifiers. Mirrors upstream atl-analytics _pageView():
                // https://bitbucket.org/atlassian/atl-analytics/src/master/src/analytics/js/atl-events.js#lines-169
                //
                // Note: `gasv3.sendOperationalEvent()` automatically sets
                // `data.excludedProperties` (anonymousId, authenticatedUserId, userId, xid)
                // when `CookieCompliance.optedOut === true` so the operational event does
                // not leak cross-product identifiers when the user has not consented.
                enrichedPageViewProperties.sn_id = $f1d158ad5148ce30$exports.CookieCompliance.snId;
                enrichedPageViewProperties.atl_first_visit = $f1d158ad5148ce30$exports.CookieCompliance.atlFirstVisit;
                // analytics-web-client requires `action` + `actionSubject` on operational
                // events (it throws "Missing event.actionSubject" otherwise). The page-view
                // operational event describes "a page was requested", so use the standard
                // page/requested subject+action pair.
                enrichedPageViewProperties.actionSubject = 'page';
                enrichedPageViewProperties.action = 'requested';
                $077fd9c14d82a85a$exports.GASv3.sendOperationalEvent('requested_page', enrichedPageViewProperties, true);
                // When the user HAS consented to performance cookies, also fire the
                // non-operational screen + GTM page events on top of the operational one.
                // When opted out, these are suppressed (gasv3.sendScreenEvent has its own
                // optOutPerfTracking gate, but we short-circuit explicitly here for clarity).
                if ($f1d158ad5148ce30$exports.CookieCompliance.optOutPerfTracking()) return;
                $6428f42409a4abae$exports.Gtm.page(null, null, enrichedPageViewProperties);
                $077fd9c14d82a85a$exports.GASv3.sendScreenEvent(null, enrichedPageViewProperties);
            }
        },
        {
            key: "getPageViewId",
            value: function getPageViewId() {
                if (!Tracking.pageViewId) Tracking.pageViewId = $d568c1b4cd0cc27f$exports.Guid.guid();
                return Tracking.pageViewId;
            }
        },
        {
            key: "enrichEventData",
            value: function enrichEventData(data) {
                return Tracking._enrichEventData(data, $35247c7511184ad3$exports.Identity.getMarketoId());
            }
        },
        {
            key: "_enrichEventData",
            value: function _enrichEventData(inputData, marketoId) {
                var data = {};
                if ($3f4554f5dd6755f8$var$_typeof(inputData) !== 'object' || inputData === null) {
                    var dataValue = inputData;
                    if (typeof dataValue !== 'undefined') data['data'] = dataValue;
                } else data = inputData;
                // if not already done, read the request Id cookie set by bxp-gateway
                if (!Tracking.bxpGatewayRequestId) Tracking.bxpGatewayRequestId = $767eab9fde59e2ab$exports.Cookie.readCookie('bxp_gateway_request_id');
                // Only set the property if the cookie was there and readCookie didn't return null
                if (Tracking.bxpGatewayRequestId) data['bxpGatewayRequestId'] = Tracking.bxpGatewayRequestId;
                data['pageViewId'] = Tracking.getPageViewId();
                // add identity data, if not present
                data['atlEventId'] = $d568c1b4cd0cc27f$exports.Guid.guid();
                data['atlJSVersion'] = $adbd9ab2eaa40909$exports.AnalyticsState.version || '1.0.0';
                data['browserLanguages'] = navigator.languages;
                // add category, if not present
                data['category'] = data['category'] || (document.title !== 'undefined' ? document.title.trim().replace(/\W+/g, '_') : '');
                // add the cohort to the object
                data[$062e0101ba16ec7d$exports.ATL_COHORT] = $062e0101ba16ec7d$exports.Cohort.readWriteAtlCohort();
                var utms = $adbd9ab2eaa40909$exports.AnalyticsState.utms;
                if (utms) data['campaign'] = {
                    name: utms['utm_campaign'],
                    medium: utms['utm_medium'],
                    source: utms['utm_source'],
                    content: utms['utm_content'],
                    term: utms['utm_term']
                };
                data['clientSessionId'] = Tracking.readWriteSessionCookie();
                if (Tracking.xid) data['atlXid'] = Tracking.xid;
                data['marketoId'] = marketoId ? marketoId : '';
                return data;
            }
        },
        {
            key: "buildTrackEventProperties",
            value: function buildTrackEventProperties(el, dataset, label, href) {
                if (!dataset) return;
                var trackEventProperties = {
                    label: label,
                    href: href
                };
                if (el && el.nodeName === 'BUTTON') {
                    var form = el.getAttribute('form');
                    if (form) trackEventProperties.form = form;
                }
                var expectedProperties = [
                    'actionSubjectId',
                    'eventContainer',
                    'eventColumn',
                    'eventComponent',
                    'uuid',
                    'event',
                    'inputValue',
                    'parentLabel',
                    'label',
                    'labelEnglish',
                    'productKey',
                    'productVersion',
                    'productEdition',
                    'productPlatform',
                    'schemaVersion',
                    'name'
                ];
                var isExpectedProperty = function isExpectedProperty(value) {
                    return expectedProperties.includes(value);
                };
                var dataSetEntries = [];
                for(var dataProperty in dataset)// eslint-disable-next-line no-prototype-builtins
                if (dataProperty !== 'track-event' && dataset.hasOwnProperty(dataProperty)) {
                    var dataPropertyValue = dataset[dataProperty];
                    if (dataPropertyValue) {
                        if (isExpectedProperty(dataProperty)) trackEventProperties[dataProperty] = dataPropertyValue;
                        else {
                            var dataEntry = {};
                            dataEntry[dataProperty] = dataPropertyValue;
                            dataSetEntries.push(dataEntry);
                        }
                    }
                }
                trackEventProperties.dataSet = dataSetEntries;
                return trackEventProperties;
            }
        },
        {
            key: "_autoTrackClickEvent",
            value: function _autoTrackClickEvent(event) {
                try {
                    var currentTargetElem = event.currentTarget;
                    var targetElem = event.target;
                    var rawText = targetElem.textContent;
                    var isInput = function isInput(elem) {
                        return elem.tagName === 'INPUT';
                    };
                    var isAnchor = function isAnchor(elem) {
                        return elem.hasAttribute('href');
                    };
                    var isSelect = function isSelect(elem) {
                        return elem.tagName === 'SELECT';
                    };
                    // handle form buttons differently
                    if (isInput(targetElem)) // targetElem.value of an input text field is considered UGC and should not be tracked
                    rawText = targetElem.type === 'text' ? '[REDACTED]' : targetElem.value !== '' ? targetElem.value : targetElem.textContent;
                    else if (isSelect(targetElem)) {
                        targetElem = targetElem.options[targetElem.selectedIndex] || targetElem;
                        rawText = targetElem.getAttribute('data-label') || targetElem.textContent || targetElem.ariaLabel || targetElem.className;
                    } else if (rawText === '') {
                        var _targetElem$parentNod;
                        rawText = ((_targetElem$parentNod = targetElem.parentNode) === null || _targetElem$parentNod === void 0 ? void 0 : _targetElem$parentNod.textContent) || targetElem.title || targetElem.ariaLabel || targetElem.className;
                    }
                    var href = isAnchor(targetElem) ? targetElem.href : isAnchor(currentTargetElem) ? currentTargetElem.href : '';
                    var trackEventName = targetElem.getAttribute('data-track-event') || currentTargetElem.getAttribute('data-track-event') || 'Clicked-Auto-CTA';
                    var eventLabel = rawText ? rawText.toLowerCase().trim().replace(/ /g, '-') : '';
                    var trackEventProperties = Tracking.buildTrackEventProperties(currentTargetElem, currentTargetElem.dataset, eventLabel, href);
                    //@ts-ignore
                    Tracking.trackEvent(trackEventName, trackEventProperties);
                } catch (err) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error auto-tracking click event');
                }
            }
        },
        {
            key: "autoTrackSelects",
            value: function autoTrackSelects() {
                try {
                    var selects = Array.from(document.querySelectorAll('select'));
                    for(var _i = 0, _selects = selects; _i < _selects.length; _i++){
                        var select = _selects[_i];
                        if (!Tracking.isAutoTrackingDisabled(select)) {
                            select.removeEventListener('change', Tracking._autoTrackClickEvent);
                            select.addEventListener('change', Tracking._autoTrackClickEvent);
                        }
                    }
                } catch (e) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error auto-tracking select event');
                }
            }
        },
        {
            key: "autoTrackButtons",
            value: function autoTrackButtons(trackAll) {
                try {
                    var selector = trackAll ? "button, input[type='submit'], input[type='button']" : "button, input[type='submit']";
                    var btns = Array.from(document.querySelectorAll(selector));
                    for(var _i2 = 0, _btns = btns; _i2 < _btns.length; _i2++){
                        var btn = _btns[_i2];
                        if (!Tracking.isAutoTrackingDisabled(btn)) {
                            // remove existing event listener (to prevent redundant listeners from useEffect hooks)
                            btn.removeEventListener('click', Tracking._autoTrackClickEvent);
                            // add an event listener
                            btn.addEventListener('click', Tracking._autoTrackClickEvent);
                        }
                    }
                } catch (e) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error auto-tracking button event');
                }
            }
        },
        {
            key: "autoTrackLinks",
            value: function autoTrackLinks(trackAll) {
                try {
                    var links = [], selector = trackAll ? 'a, .external-link' : "a[class*='button'], a[class*='btn'], .external-link", btnyLinks = Array.from(document.querySelectorAll(selector));
                    for(var _i3 = 0, _btnyLinks = btnyLinks; _i3 < _btnyLinks.length; _i3++){
                        var el = _btnyLinks[_i3];
                        var htmlEl = el;
                        if (trackAll || htmlEl.offsetWidth >= 50 || el.className.includes('cta') || el.className.includes('external-link')) links.push(el);
                    }
                    for(var _i4 = 0, _links = links; _i4 < _links.length; _i4++){
                        var link = _links[_i4];
                        if (!Tracking.isAutoTrackingDisabled(link)) {
                            link.removeEventListener('click', Tracking._autoTrackClickEvent);
                            link.addEventListener('click', Tracking._autoTrackClickEvent);
                        }
                    }
                } catch (e) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error auto-tracking link event');
                }
            }
        },
        {
            key: "_autoTrackVideoEvent",
            value: function _autoTrackVideoEvent(element, eventName) {
                try {
                    var _element$parentElemen;
                    var className = typeof element.className !== 'undefined' ? element.className : (_element$parentElemen = element.parentElement) === null || _element$parentElemen === void 0 ? void 0 : _element$parentElemen.className, eventLabel = typeof element.textContent !== 'undefined' ? element.textContent : '', eventCategory = typeof document.title !== 'undefined' ? document.title.replace(/\W+/g, '_').trim() : '';
                    Tracking.trackEvent(eventName, {
                        className: className,
                        category: eventCategory,
                        label: eventLabel,
                        _sio: $767eab9fde59e2ab$exports.Cookie.readCookie('_sio') || '',
                        _atl_path: $767eab9fde59e2ab$exports.Cookie.readCookie('__atl_path') || ''
                    });
                } catch (e) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error auto-tracking video event');
                }
            }
        },
        {
            key: "autoTrackVideos",
            value: function autoTrackVideos() {
                try {
                    var videoOpenLinks = Array.from(document.querySelectorAll("div[class*='videoPlayButton'], .video-link, .video_link, .customer-story-video-link"));
                    var videoCloseLinks = Array.from(document.querySelectorAll("div[class='overlay'], .modal.video .close"));
                    var trackVideoOpenEvent = function trackVideoOpenEvent(ev) {
                        var currentTargetElem = ev.currentTarget;
                        Tracking._autoTrackVideoEvent(currentTargetElem, 'Opened Video');
                    };
                    var trackVideoCloseEvent = function trackVideoCloseEvent(ev) {
                        var currentTargetElem = ev.currentTarget;
                        Tracking._autoTrackVideoEvent(currentTargetElem, 'Closed Video');
                    };
                    for(var _i5 = 0, _videoOpenLinks = videoOpenLinks; _i5 < _videoOpenLinks.length; _i5++){
                        var videoOpenLink = _videoOpenLinks[_i5];
                        videoOpenLink.removeEventListener('click', trackVideoOpenEvent);
                        videoOpenLink.addEventListener('click', trackVideoOpenEvent);
                    }
                    for(var _i6 = 0, _videoCloseLinks = videoCloseLinks; _i6 < _videoCloseLinks.length; _i6++){
                        var videoCloseLink = _videoCloseLinks[_i6];
                        videoCloseLink.removeEventListener('click', trackVideoCloseEvent);
                        videoCloseLink.addEventListener('click', trackVideoCloseEvent);
                    }
                } catch (e) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error auto-tracking video event');
                }
            }
        },
        {
            key: "autoTrackTabs",
            value: function autoTrackTabs() {
                try {
                    var selector = "[role='tab']";
                    var tabs = Array.from(document.querySelectorAll(selector));
                    for(var _i7 = 0, _tabs = tabs; _i7 < _tabs.length; _i7++){
                        var tab = _tabs[_i7];
                        if (!Tracking.isAutoTrackingDisabled(tab)) {
                            // remove existing event listener (to prevent redundant listeners from useEffect hooks)
                            tab.removeEventListener('select', Tracking._autoTrackClickEvent);
                            // add an event listener
                            tab.addEventListener('select', Tracking._autoTrackClickEvent);
                        }
                    }
                } catch (e) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error auto-tracking tab event');
                }
            }
        },
        {
            key: "isAutoTrackingDisabled",
            value: function isAutoTrackingDisabled(element) {
                return element.classList.contains('doNotAutoTrack');
            }
        },
        {
            key: "readWriteSessionCookie",
            value: function readWriteSessionCookie() {
                var cookie = $767eab9fde59e2ab$exports.Cookie.readCookie('atl_session');
                var name = 'atl_session';
                var value = cookie || $d568c1b4cd0cc27f$exports.Guid.guid();
                var seconds = 1800;
                if ($767eab9fde59e2ab$exports.Cookie.writeCookieInSeconds) $767eab9fde59e2ab$exports.Cookie.writeCookieInSeconds(name, value, seconds);
                return value;
            }
        }
    ]);
}();


function $35247c7511184ad3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $35247c7511184ad3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $35247c7511184ad3$var$_typeof(o);
}
function $35247c7511184ad3$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $35247c7511184ad3$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $35247c7511184ad3$var$_toPropertyKey(o.key), o);
    }
}
function $35247c7511184ad3$var$_createClass(e, r, t) {
    return r && $35247c7511184ad3$var$_defineProperties(e.prototype, r), t && $35247c7511184ad3$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $35247c7511184ad3$var$_toPropertyKey(t) {
    var i = $35247c7511184ad3$var$_toPrimitive(t, "string");
    return "symbol" == $35247c7511184ad3$var$_typeof(i) ? i : i + "";
}
function $35247c7511184ad3$var$_toPrimitive(t, r) {
    if ("object" != $35247c7511184ad3$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $35247c7511184ad3$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $35247c7511184ad3$var$TRELLO_USER_ID = 'token';
var $35247c7511184ad3$var$XID = 'seg_xid';
var $35247c7511184ad3$var$pageViewProperties = {};
// cookie used by Marketo to track interactions, allows a website to link visitor behavior across sites and campaigns
var $35247c7511184ad3$var$MARKETO_ID = '_mkto_trk';
var $35247c7511184ad3$var$REFERRER_TRELLO_DOMAINS = [
    'trello.com',
    'trellis.coffee'
];
var $35247c7511184ad3$var$Identity = $35247c7511184ad3$exports.Identity = /*#__PURE__*/ function() {
    function Identity() {
        $35247c7511184ad3$var$_classCallCheck(this, Identity);
    }
    return $35247c7511184ad3$var$_createClass(Identity, null, [
        {
            key: "identify",
            value: /**
     * Sends a track event with known identifiers
     * @function identify
     * @param {string} userId - required
     * @param {object} traits - optional, dictionary of custom traits to send
     */ function identify(userId, traits) {
                traits = !!traits && $35247c7511184ad3$var$_typeof(traits) === 'object' ? traits : {};
                var data = traits;
                data['atlassian_id'] = userId;
                data['atlJSVersion'] = $adbd9ab2eaa40909$exports.AnalyticsState.version || '1.0.0';
                try {
                    data['ga_clientid'] = $767eab9fde59e2ab$exports.Cookie.readCookie('_ga');
                } catch (e) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error reading _ga cookie');
                }
                $3f4554f5dd6755f8$exports.Tracking.trackEvent('known_identifiers', data);
            }
        },
        {
            key: "autoIdentify",
            value: function autoIdentify() {
                var emailDetected = $4fb91a309ed42af5$exports.Helpers.emailAddressIsDetected();
                var userId = Identity.getAtlassianUserId();
                var xid = $767eab9fde59e2ab$exports.Cookie.readCookie($35247c7511184ad3$var$XID);
                if (emailDetected) {
                    var integrations = {
                        All: false,
                        'Google Analytics': true
                    };
                    if (!$adbd9ab2eaa40909$exports.AnalyticsState.pageViewOptions) $adbd9ab2eaa40909$exports.AnalyticsState.pageViewOptions = {
                        integrations: integrations
                    };
                    else $adbd9ab2eaa40909$exports.AnalyticsState.pageViewOptions['integrations'] = integrations;
                    if ($4fb91a309ed42af5$exports.Helpers.urlContainsEmail(window.location.href)) $4fb91a309ed42af5$exports.Helpers.addCleanedUrlAndPaths($35247c7511184ad3$var$pageViewProperties);
                    if ($4fb91a309ed42af5$exports.Helpers.urlContainsEmail(document.referrer)) $4fb91a309ed42af5$exports.Helpers.addCleanedReferrer($35247c7511184ad3$var$pageViewProperties);
                }
                try {
                    $35247c7511184ad3$var$pageViewProperties['anonymous_id'] = $adbd9ab2eaa40909$exports.AnalyticsState.anonymousId;
                } catch (e) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error reading segment anonymousId');
                }
                try {
                    $35247c7511184ad3$var$pageViewProperties[$062e0101ba16ec7d$exports.ATL_COHORT] = $062e0101ba16ec7d$exports.Cohort.readWriteAtlCohort();
                } catch (e) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error read / writing atlCohort cookie');
                }
                if (userId || xid) Identity.identify(userId, $35247c7511184ad3$var$pageViewProperties);
            }
        },
        {
            key: "getAtlassianUserId",
            value: function getAtlassianUserId() {
                var userId = $767eab9fde59e2ab$exports.Cookie.readCookie('__aid_user_id');
                if (userId) return decodeURIComponent(userId);
                return null;
            }
        },
        {
            key: "getTrelloUserId",
            value: function getTrelloUserId() {
                try {
                    var page = location.href ? new URL(location.href) : null;
                    // since the trello cookie is such a common name. check to make sure we're actually on a trello page
                    if (page && (page.hostname.includes('trello.com') || page.hostname.includes('trellis.coffee'))) {
                        var token = $767eab9fde59e2ab$exports.Cookie.readCookie($35247c7511184ad3$var$TRELLO_USER_ID);
                        if (token) return decodeURIComponent(token).split('/')[0];
                    }
                } catch (e) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error reading Trello userId');
                }
                return null;
            }
        },
        {
            key: "getMarketoId",
            value: function getMarketoId() {
                var marketoId = $767eab9fde59e2ab$exports.Cookie.readCookie($35247c7511184ad3$var$MARKETO_ID);
                if (marketoId) return decodeURIComponent(marketoId);
                return null;
            }
        },
        {
            key: "getMarketoIdPromise",
            value: function getMarketoIdPromise() {
                var enableRetry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                var waitCount = 0;
                var maxWait = enableRetry ? 5000 : 0;
                return new Promise(function(resolve) {
                    Identity._internalMarketoPromise(waitCount, maxWait, resolve);
                });
            }
        },
        {
            key: "_internalMarketoPromise",
            value: function _internalMarketoPromise(waitCount, maxWait, resolve) {
                var delay = 500;
                var marketoId = $767eab9fde59e2ab$exports.Cookie.readCookie($35247c7511184ad3$var$MARKETO_ID);
                // wait for up to 5 seconds for the marketo cookie to show up
                if (marketoId) resolve(decodeURIComponent(marketoId));
                else {
                    waitCount += delay;
                    if (waitCount >= maxWait) {
                        $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('getMarketoIdPromise error');
                        resolve('');
                    } else if (typeof setTimeout === 'function') setTimeout(function() {
                        Identity._internalMarketoPromise(waitCount, maxWait, resolve);
                    }, delay);
                    else {
                        // handle the case where setTimeout is not a function
                        $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('getMarketoIdPromise error - setTimeout is not a function');
                        resolve('');
                    }
                }
            }
        },
        {
            key: "isReferrerTrello",
            value: function isReferrerTrello() {
                if (!document.referrer) return false;
                var ref = new URL(document.referrer);
                return $35247c7511184ad3$var$REFERRER_TRELLO_DOMAINS.includes(ref.hostname);
            }
        }
    ]);
}();



var $77649b04a9131230$exports = {};
"use strict";
Object.defineProperty($77649b04a9131230$exports, "__esModule", {
    value: true
});
Object.defineProperty($77649b04a9131230$exports, "AnalyticsWebClient", {
    enumerable: true,
    get: function get() {
        return $77649b04a9131230$var$_analyticsWebClient["default"];
    }
});
$77649b04a9131230$exports.CommunityAnalyticsClient = void 0;

var $77649b04a9131230$var$_analyticsWebClient = $77649b04a9131230$var$_interopRequireWildcard((parcelRequire("c40db")));


var $a16418a003617505$exports = {};
"use strict";
Object.defineProperty($a16418a003617505$exports, "__esModule", {
    value: true
});
$a16418a003617505$exports.Initializer = void 0;





var $648460a2ac9885d9$exports = {};
"use strict";
Object.defineProperty($648460a2ac9885d9$exports, "__esModule", {
    value: true
});
$648460a2ac9885d9$exports.Metrics = $648460a2ac9885d9$exports.MetricKey = void 0;





function $648460a2ac9885d9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $648460a2ac9885d9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $648460a2ac9885d9$var$_typeof(o);
}
function $648460a2ac9885d9$var$_slicedToArray(r, e) {
    return $648460a2ac9885d9$var$_arrayWithHoles(r) || $648460a2ac9885d9$var$_iterableToArrayLimit(r, e) || $648460a2ac9885d9$var$_unsupportedIterableToArray(r, e) || $648460a2ac9885d9$var$_nonIterableRest();
}
function $648460a2ac9885d9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $648460a2ac9885d9$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $648460a2ac9885d9$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $648460a2ac9885d9$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $648460a2ac9885d9$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $648460a2ac9885d9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $648460a2ac9885d9$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $648460a2ac9885d9$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $648460a2ac9885d9$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $648460a2ac9885d9$var$_toPropertyKey(o.key), o);
    }
}
function $648460a2ac9885d9$var$_createClass(e, r, t) {
    return r && $648460a2ac9885d9$var$_defineProperties(e.prototype, r), t && $648460a2ac9885d9$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $648460a2ac9885d9$var$_defineProperty(e, r, t) {
    return (r = $648460a2ac9885d9$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $648460a2ac9885d9$var$_toPropertyKey(t) {
    var i = $648460a2ac9885d9$var$_toPrimitive(t, "string");
    return "symbol" == $648460a2ac9885d9$var$_typeof(i) ? i : i + "";
}
function $648460a2ac9885d9$var$_toPrimitive(t, r) {
    if ("object" != $648460a2ac9885d9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $648460a2ac9885d9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /**
 * Module for segment metrics tracking events.
 * @module Metrics
 */ 
var $648460a2ac9885d9$var$MetricKey = $648460a2ac9885d9$exports.MetricKey = /*#__PURE__*/ function(MetricKey) {
    MetricKey["TIME_TO_LOAD"] = "timeToLoad";
    MetricKey["TIME_TO_SEGMENT_LOAD"] = "timeToSegmentLoad";
    MetricKey["TIME_TO_AVAILABLE"] = "timeToAvailable";
    MetricKey["TIME_TO_READY"] = "timeToReady";
    MetricKey["TIME_TO_START_LOAD_XID"] = "timeToStartLoadXID";
    MetricKey["TIME_TO_START_GET_XID"] = "timeToStartGetXID";
    MetricKey["TIME_TO_LOAD_XID"] = "timeToLoadXID";
    return MetricKey;
}({});
var $648460a2ac9885d9$var$Metrics = $648460a2ac9885d9$exports.Metrics = /*#__PURE__*/ function() {
    function Metrics() {
        $648460a2ac9885d9$var$_classCallCheck(this, Metrics);
    }
    return $648460a2ac9885d9$var$_createClass(Metrics, null, [
        {
            key: "logMetric",
            value: /**
     * Store the value of a single performance metric
     * @function logMetrics
     * @param {MetricKey} metricKey - the metric to log
     * @param {number} mockDate - a mock timestamp
     */ function logMetric(metricKey, mockDate) {
                Metrics.metricsData[metricKey] = mockDate || Date.now();
            }
        },
        {
            key: "setLoadTimestamp",
            value: function setLoadTimestamp(loadTimestamp) {
                Metrics.loadTimestamp = loadTimestamp;
            }
        },
        {
            key: "sendMetrics",
            value: function sendMetrics(mockReq) {
                if ($f1d158ad5148ce30$exports.CookieCompliance.optOutPerfTracking()) return;
                var loadTimestamp = Metrics.loadTimestamp;
                if (!loadTimestamp) return;
                // calculate all of the times
                Object.entries(Metrics.metricsData).forEach(function(_ref) {
                    var _ref2 = $648460a2ac9885d9$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                    if (value > 0) // Todo .. should this be > loadTimestamp ??
                    Metrics.metricsData[key] = value - loadTimestamp;
                });
                var cohort = $062e0101ba16ec7d$exports.Cohort.readAtlCohort();
                var properties = {
                    action: 'metrics',
                    actionSubject: 'atlGlobal',
                    metrics: Metrics.metricsData,
                    atlJSVersion: $adbd9ab2eaa40909$exports.AnalyticsState.version,
                    cohort: cohort ? cohort.bucketAll.index : null,
                    host: mockReq ? mockReq.hostFake : window.location.host,
                    path: mockReq ? mockReq.pathFake : window.location.pathname,
                    pageViewId: $3f4554f5dd6755f8$exports.Tracking.getPageViewId() // used to tie to other events
                };
                $077fd9c14d82a85a$exports.GASv3.sendUIEvent('', properties, true);
                Metrics.resetMetrics();
            }
        },
        {
            key: "resetMetrics",
            value: function resetMetrics() {
                Metrics.metricsData = {};
            }
        }
    ]);
}();
$648460a2ac9885d9$var$_defineProperty($648460a2ac9885d9$var$Metrics, "metricsData", {});



function $a16418a003617505$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a16418a003617505$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a16418a003617505$var$_typeof(o);
}
function $a16418a003617505$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $a16418a003617505$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $a16418a003617505$var$_toPropertyKey(o.key), o);
    }
}
function $a16418a003617505$var$_createClass(e, r, t) {
    return r && $a16418a003617505$var$_defineProperties(e.prototype, r), t && $a16418a003617505$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $a16418a003617505$var$_toPropertyKey(t) {
    var i = $a16418a003617505$var$_toPrimitive(t, "string");
    return "symbol" == $a16418a003617505$var$_typeof(i) ? i : i + "";
}
function $a16418a003617505$var$_toPrimitive(t, r) {
    if ("object" != $a16418a003617505$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a16418a003617505$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * Module for initializing the wrapper.
 * @module Initializer
 */ var $a16418a003617505$var$Initializer = $a16418a003617505$exports.Initializer = /*#__PURE__*/ function() {
    function Initializer() {
        $a16418a003617505$var$_classCallCheck(this, Initializer);
    }
    return $a16418a003617505$var$_createClass(Initializer, null, [
        {
            key: "initWithPageAnalytics",
            value: /**
     * Initializes auto-tracking and page view tracking.
     * @function initWithPageAnalytics
     * @param {string} writeKey - required, historically used as Segment.io key, now just sent as a property (not sure if used, but keep sending it)
     * @param {object} pageViewProperties - optional, dictionary of properties of the page
     * @param {number} loadTimestamp - optional, the timestamp at which the initializing site loaded this script
     * @param {string} anonymousId - GASv3 analytics client anonymous id
     * @param {function} createAnalyticsEvent - analytics-next CreateUIAnalyticsEvent
     */ function initWithPageAnalytics(writeKey) {
                var pageViewProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var loadTimestamp = arguments.length > 2 ? arguments[2] : undefined;
                var anonymousId = arguments.length > 3 ? arguments[3] : undefined;
                var createAnalyticsEvent = arguments.length > 4 ? arguments[4] : undefined;
                $adbd9ab2eaa40909$exports.AnalyticsState.anonymousId = anonymousId;
                $adbd9ab2eaa40909$exports.AnalyticsState.createAnalyticsEvent = createAnalyticsEvent;
                // set load timestamp for calculating metrics
                $648460a2ac9885d9$exports.Metrics.setLoadTimestamp(loadTimestamp);
                Initializer.captureUTMs();
                // adding marketing boolean if current product comes under marketing domain
                Initializer.setIsMarketingEvent(pageViewProperties);
                // store params for later reporting if necessary.
                $adbd9ab2eaa40909$exports.AnalyticsState.writeKey = writeKey;
                $4fb91a309ed42af5$exports.Helpers.addActualUrl(pageViewProperties);
                // When the user has not consented to performance cookies and
                // the kill-switch FeatureGate is on, fire only the strictly-necessary operational path.
                // Skips GTM, Segment (already absent in this fork), Snowplow (idem), auto-tracking, and
                // GA integration. The library still fires the `requested_page` operational event with
                // the strictly-necessary `sn_id` + `atl_first_visit` payload via Tracking.pageView.
                if ($f1d158ad5148ce30$exports.CookieCompliance.optOutPerfTracking()) {
                    $f1d158ad5148ce30$exports.CookieCompliance.setSnIdAndAtlFirstVisit(pageViewProperties);
                    $f1d158ad5148ce30$exports.CookieCompliance._listenForActiveGroupsChange();
                    $3f4554f5dd6755f8$exports.Tracking.pageView(pageViewProperties);
                    Initializer.globalCallReady();
                    return;
                }
                // Full (consented) init path — load GTM, fire normal page view, set up auto-tracking.
                // TODO: Switch these params to dynamically config based on writeKey
                $6428f42409a4abae$exports.Gtm.initialize(writeKey);
                $3f4554f5dd6755f8$exports.Tracking.pageView(pageViewProperties);
                Initializer.autoTrack();
                Initializer.gaIntegration();
                Initializer.globalCallReady();
            }
        },
        {
            key: "globalCallReady",
            value: function globalCallReady() {
                if (typeof window.analyticsPageReady === 'function') window.analyticsPageReady();
                $648460a2ac9885d9$exports.Metrics.logMetric($648460a2ac9885d9$exports.MetricKey.TIME_TO_READY);
                $648460a2ac9885d9$exports.Metrics.sendMetrics();
            }
        },
        {
            key: "captureUTMs",
            value: function captureUTMs() {
                var utmKeys = {
                    utm_campaign: '',
                    utm_medium: '',
                    utm_source: '',
                    utm_content: '',
                    utm_term: ''
                };
                $adbd9ab2eaa40909$exports.AnalyticsState.utms = $4fb91a309ed42af5$exports.Helpers.getUtms(utmKeys);
            }
        },
        {
            key: "autoTrack",
            value: function autoTrack() {
                $3f4554f5dd6755f8$exports.Tracking.autoTrackButtons(true);
                $3f4554f5dd6755f8$exports.Tracking.autoTrackLinks(true);
                $3f4554f5dd6755f8$exports.Tracking.autoTrackVideos();
                $3f4554f5dd6755f8$exports.Tracking.autoTrackSelects();
                $3f4554f5dd6755f8$exports.Tracking.autoTrackTabs();
            }
        },
        {
            key: "gaIntegration",
            value: function gaIntegration() {
                var emailDetected = $4fb91a309ed42af5$exports.Helpers.emailAddressIsDetected();
                var pathOverride = '/path-contained-email-address';
                if (typeof window.ga !== 'undefined') {
                    window.ga('require', 'linker');
                    window.ga('linker:autoLink', [
                        'atlassian.com',
                        'bitbucket.org',
                        'hipchat.com',
                        'attendease.com',
                        'get.atlassian.com',
                        'eegeventsite.secure.force.com',
                        'atlassian.swoogo.com'
                    ]);
                    if (emailDetected) {
                        // only override what is needed
                        if ($4fb91a309ed42af5$exports.Helpers.urlContainsEmail(window.location.href)) {
                            window.ga('set', 'location', window.location.origin + pathOverride);
                            window.ga('set', 'path', pathOverride);
                        }
                        if ($4fb91a309ed42af5$exports.Helpers.urlContainsEmail(document.referrer)) window.ga('set', 'referrer', $4fb91a309ed42af5$exports.Helpers.hostnameFromUrl(document.referrer) + pathOverride);
                    }
                }
            }
        },
        {
            key: "setIsMarketingEvent",
            value: function setIsMarketingEvent(pageViewProperties) {
                if (typeof pageViewProperties['isMarketingEvent'] !== 'boolean') $077fd9c14d82a85a$exports.GASv3.isMarketingEvent = true;
                else $077fd9c14d82a85a$exports.GASv3.isMarketingEvent = pageViewProperties['isMarketingEvent'];
            }
        },
        {
            key: "setXID",
            value: function setXID(xid) {
                $3f4554f5dd6755f8$exports.Tracking.xid = xid;
            }
        }
    ]);
}();






function $77649b04a9131230$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($77649b04a9131230$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $77649b04a9131230$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $77649b04a9131230$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $77649b04a9131230$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $77649b04a9131230$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $77649b04a9131230$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $77649b04a9131230$var$_typeof(o);
}
function $77649b04a9131230$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $77649b04a9131230$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $77649b04a9131230$var$ownKeys(Object(t), !0).forEach(function(r) {
            $77649b04a9131230$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $77649b04a9131230$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $77649b04a9131230$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $77649b04a9131230$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $77649b04a9131230$var$_toPropertyKey(o.key), o);
    }
}
function $77649b04a9131230$var$_createClass(e, r, t) {
    return r && $77649b04a9131230$var$_defineProperties(e.prototype, r), t && $77649b04a9131230$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $77649b04a9131230$var$_defineProperty(e, r, t) {
    return (r = $77649b04a9131230$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $77649b04a9131230$var$_toPropertyKey(t) {
    var i = $77649b04a9131230$var$_toPrimitive(t, "string");
    return "symbol" == $77649b04a9131230$var$_typeof(i) ? i : i + "";
}
function $77649b04a9131230$var$_toPrimitive(t, r) {
    if ("object" != $77649b04a9131230$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $77649b04a9131230$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /**
 * Service to interact with analytics client, send GASv3 events
 */ 
var $77649b04a9131230$var$CommunityAnalyticsClient = $77649b04a9131230$exports.CommunityAnalyticsClient = /*#__PURE__*/ function() {
    function CommunityAnalyticsClient() {
        $77649b04a9131230$var$_classCallCheck(this, CommunityAnalyticsClient);
    }
    return $77649b04a9131230$var$_createClass(CommunityAnalyticsClient, null, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                if (typeof window !== 'undefined') {
                    var settings = $77649b04a9131230$var$_objectSpread({
                        useStargate: (0, $9b8dc532c3c3f9ae$exports.shouldUseStargate)(this.clientEnvironment),
                        xidConsent: true,
                        xidPromiseFn: function xidPromiseFn() {
                            return new $a576733921801e90$exports.XID((0, $9b8dc532c3c3f9ae$exports.getXidEnvironment)(_this.clientEnvironment)).getXidCallbackForPromise();
                        }
                    }, this.clientSettings);
                    return new $77649b04a9131230$var$_analyticsWebClient["default"]({
                        env: (0, $9b8dc532c3c3f9ae$exports.getGASv3Environment)(this.clientEnvironment),
                        product: this.PRODUCT,
                        version: '1.0.0',
                        locale: 'en-us'
                    }, settings);
                }
                throw new Error('window is not defined');
            }
        },
        {
            key: "initializeClient",
            value: function initializeClient(communitySubApp, settings, environment) {
                var userId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var writeKey = (0, $9b8dc532c3c3f9ae$exports.getAnalyticsWriteKey)(this.clientEnvironment);
                this.writeKey = writeKey;
                this.clientSettings = settings;
                this.clientEnvironment = environment;
                this.analyticsClient = this.init();
                // set static analytics client instance on GASv3 class
                $077fd9c14d82a85a$exports.GASv3.client = this.analyticsClient;
                // If the consumer explicitly passes `null`, treat the session as anonymous and
                // skip the legacy identity-cookie hydration so a stale AAID can't leak into events.
                // Only fall back to Identity.getAtlassianUserId() when `userId` is omitted entirely.
                var clientUserId = userId === null ? null : userId !== null && userId !== void 0 ? userId : $35247c7511184ad3$exports.Identity.getAtlassianUserId();
                if (clientUserId) this.setAnalyticsUserInfo(clientUserId);
                else if (this.analyticsClient.clearUserInfo) // Defensive: ensure no stale userId persists on the underlying analytics-web-client instance.
                this.analyticsClient.clearUserInfo();
                // set global community attributes to be sent on each event
                $077fd9c14d82a85a$exports.GASv3.additionalEventData = this.getGlobalAttributes(communitySubApp);
                return this.analyticsClient;
            }
        },
        {
            key: "initWithPageAnalytics",
            value: function initWithPageAnalytics(communitySubApp, settings, environment) {
                var pageViewProperties = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var userId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                if (!this.analyticsClient) this.analyticsClient = this.initializeClient(communitySubApp, settings, environment, userId);
                this.setUpPageAnalytics(pageViewProperties);
                return this.analyticsClient;
            }
        },
        {
            key: "setUpPageAnalytics",
            value: function setUpPageAnalytics() {
                var pageViewProperties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!this.analyticsClient) throw new Error('Initialize the analytics client before calling setUpPageAnalytics()');
                // set up auto-tracking for page views and other activity
                $a16418a003617505$exports.Initializer.initWithPageAnalytics((0, $9b8dc532c3c3f9ae$exports.getAnalyticsWriteKey)(this.clientEnvironment), $77649b04a9131230$var$deepClone(pageViewProperties), Date.now(), this.analyticsClient.getAnonymousId(), null // createAnalyticsEvent only needed for analytics-next
                );
            }
        },
        {
            key: "sendPageView",
            value: function sendPageView() {
                var pageViewProperties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!this.analyticsClient) // No client yet (init in flight / SSR) — nothing to fire. Callers fire the
                // entry page view via init; route-change calls before init are no-ops.
                return;
                $3f4554f5dd6755f8$exports.Tracking.pageView(pageViewProperties);
            }
        },
        {
            key: "hasAnalyticsClient",
            value: function hasAnalyticsClient() {
                return !!this.analyticsClient;
            }
        },
        {
            key: "getAnalyticsClient",
            value: function getAnalyticsClient() {
                return this.analyticsClient;
            }
        },
        {
            key: "setAnalyticsUserInfo",
            value: function setAnalyticsUserInfo(userId) {
                if (userId && this.hasAnalyticsClient()) this.getAnalyticsClient().setUserInfo($77649b04a9131230$var$_analyticsWebClient.userType.ATLASSIAN_ACCOUNT, userId);
            }
        },
        {
            key: "sendEvent",
            value: function sendEvent() {
                var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $55a1880d3758202a$exports.eventType.UI;
                var payload = arguments.length > 1 ? arguments[1] : undefined;
                if (this.isAnalyticsEnabled()) $3f4554f5dd6755f8$exports.Tracking.trackEvent('', payload, type);
            }
        },
        {
            key: "getGlobalAttributes",
            value: function getGlobalAttributes(subApp) {
                return {
                    app: this.APP,
                    subApp: subApp
                };
            }
        }
    ]);
}();
/** Payload for eventType.UI and TRACK events
 * @property {string} action - action being performed
 * @property {string} actionSubject - subject of the action
 * @property {string} [actionSubjectId] - (optional) action subject id
 * @property {Record<string, string>} [attributes] - (optional) additional attributes
 * @property {string} [source] - source of the event, where (e.g. a screen) in the product
 */ $77649b04a9131230$var$_defineProperty($77649b04a9131230$var$CommunityAnalyticsClient, "PRODUCT", 'marketing');
$77649b04a9131230$var$_defineProperty($77649b04a9131230$var$CommunityAnalyticsClient, "APP", 'community');
$77649b04a9131230$var$_defineProperty($77649b04a9131230$var$CommunityAnalyticsClient, "SUB_APP", {
    HOME: 'home',
    FORUMS: 'forums',
    LEARNING: 'learning',
    EVENTS: 'events',
    UNIFIED_PORTABLE_PROFILE: 'unified-portable-profile'
});
$77649b04a9131230$var$_defineProperty($77649b04a9131230$var$CommunityAnalyticsClient, "writeKey", null);
$77649b04a9131230$var$_defineProperty($77649b04a9131230$var$CommunityAnalyticsClient, "analyticsClient", null);
$77649b04a9131230$var$_defineProperty($77649b04a9131230$var$CommunityAnalyticsClient, "clientSettings", null);
$77649b04a9131230$var$_defineProperty($77649b04a9131230$var$CommunityAnalyticsClient, "clientEnvironment", null);
$77649b04a9131230$var$_defineProperty($77649b04a9131230$var$CommunityAnalyticsClient, "isAnalyticsEnabled", function() {
    return true;
});
/**
 * Payload for eventType.SCREEN events
 * @property {string} name - name of the screen being viewed
 * @property {Record<string, string>} [attributes] - additional attributes
 */ // type constrained to community sub-app string values (as defined by CommunityAnalyticsClient.SUB_APP)
var $77649b04a9131230$var$deepClone = function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
};


function $611eba94e0709501$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($611eba94e0709501$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $611eba94e0709501$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $611eba94e0709501$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $611eba94e0709501$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $611eba94e0709501$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $611eba94e0709501$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $611eba94e0709501$var$_typeof(o);
}
function $611eba94e0709501$var$_slicedToArray(r, e) {
    return $611eba94e0709501$var$_arrayWithHoles(r) || $611eba94e0709501$var$_iterableToArrayLimit(r, e) || $611eba94e0709501$var$_unsupportedIterableToArray(r, e) || $611eba94e0709501$var$_nonIterableRest();
}
function $611eba94e0709501$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $611eba94e0709501$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $611eba94e0709501$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $611eba94e0709501$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $611eba94e0709501$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $611eba94e0709501$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $611eba94e0709501$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $611eba94e0709501$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $611eba94e0709501$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $611eba94e0709501$var$ownKeys(Object(t), !0).forEach(function(r) {
            $611eba94e0709501$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $611eba94e0709501$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $611eba94e0709501$var$_defineProperty(e, r, t) {
    return (r = $611eba94e0709501$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $611eba94e0709501$var$_toPropertyKey(t) {
    var i = $611eba94e0709501$var$_toPrimitive(t, "string");
    return "symbol" == $611eba94e0709501$var$_typeof(i) ? i : i + "";
}
function $611eba94e0709501$var$_toPrimitive(t, r) {
    if ("object" != $611eba94e0709501$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $611eba94e0709501$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /**
 * WARNING: Not yet ready for use, do not use - use the CommunityAnalyticsClient in analytics-client instead.
 *
 * This file contains the context and provider for the analytics client (@atlaskit/analytics-next pattern) - these React
 * components can be wrapped around the app to provide the analytics client to the rest of the application.
 */ 
var $611eba94e0709501$var$AnalyticsWebClientContext = $611eba94e0709501$exports.AnalyticsWebClientContext = /*#__PURE__*/ (0, $611eba94e0709501$var$_react.createContext)({
    analyticsWebClientInstance: null
});
/**
 * This listener component listens for analytics events and sends them to the analytics client (analytics-next pattern).
 */ var $611eba94e0709501$var$CommunityAnalyticsListener = $611eba94e0709501$exports.CommunityAnalyticsListener = function CommunityAnalyticsListener(_ref) {
    var children = _ref.children;
    var analyticsClient = $611eba94e0709501$var$useAnalyticsClient();
    var onEvent = (0, $611eba94e0709501$var$_react.useCallback)(function(event) {
        if (!analyticsClient) return;
        // Gate: suppress non-operational (UI/screen) events when the user has not
        // consented to OneTrust C0002 (Performance) cookies. Only operational events
        // are strictly-necessary and exempt from consent.
        if ($f1d158ad5148ce30$exports.CookieCompliance.optOutPerfTracking()) return;
        // TODO: modify this?
        var processedEventPayload = $611eba94e0709501$var$_objectSpread($611eba94e0709501$var$_objectSpread({
            actionSubject: 'component',
            eventType: 'ui',
            source: 'default'
        }, event.payload), {}, {
            attributes: $611eba94e0709501$var$_objectSpread({}, event.payload['attributes'] || {})
        });
        var ANALYTICS_TYPE = 'console';
        if (ANALYTICS_TYPE === 'console') {
            // eslint-disable-next-line
            console.log({
                event: processedEventPayload
            });
            analyticsClient.onEvent(null, processedEventPayload);
        } else analyticsClient.onEvent(null, processedEventPayload);
    }, [
        analyticsClient
    ]);
    return /*#__PURE__*/ $611eba94e0709501$var$_react["default"].createElement($01b5b1a5740294b4$export$2e2bcd8739ae039, {
        channel: '*',
        onEvent: onEvent
    }, children);
};
/**
 * This provider component initializes the analytics client and provides it to the rest of the application (analytics-next
 * pattern).
 * @param settings
 * @param environment
 * @param children
 * @constructor
 */ var $611eba94e0709501$var$CommunityAnalyticsClientProvider = $611eba94e0709501$exports.CommunityAnalyticsClientProvider = function CommunityAnalyticsClientProvider(_ref2) {
    var settings = _ref2.settings, environment = _ref2.environment, children = _ref2.children;
    var _useState = (0, $611eba94e0709501$var$_react.useState)(null), _useState2 = $611eba94e0709501$var$_slicedToArray(_useState, 2), analyticsWebClientInstance = _useState2[0], setAnalyticsWebClientInstance = _useState2[1];
    (0, $611eba94e0709501$var$_react.useEffect)(function() {
        if (typeof window !== 'undefined') {
            // eslint-disable-next-line
            console.log('Initializing analytics client');
            $77649b04a9131230$exports.CommunityAnalyticsClient.clientSettings = settings;
            $77649b04a9131230$exports.CommunityAnalyticsClient.clientEnvironment = environment;
            var client = $77649b04a9131230$exports.CommunityAnalyticsClient.init();
            var aaid = $35247c7511184ad3$exports.Identity.getAtlassianUserId();
            if (aaid) client.setUserInfo($dpXUu.userType.ATLASSIAN_ACCOUNT, aaid);
            setAnalyticsWebClientInstance(client);
        }
    }, []);
    return /*#__PURE__*/ $611eba94e0709501$var$_react["default"].createElement($611eba94e0709501$var$AnalyticsWebClientContext.Provider, {
        value: {
            analyticsWebClientInstance: analyticsWebClientInstance
        }
    }, children);
};
var $611eba94e0709501$var$useAnalyticsClient = $611eba94e0709501$exports.useAnalyticsClient = function useAnalyticsClient() {
    var context = (0, $611eba94e0709501$var$_react.useContext)($611eba94e0709501$var$AnalyticsWebClientContext);
    if (!context) throw new Error('calls to useAnalyticsClient must be wrapped in <WacAnalyticsClientProvider>!');
    return context.analyticsWebClientInstance;
};



var $edca2caa766c402a$var$deepClone = function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
};
var $edca2caa766c402a$var$InitializeAutoAtlAnalyticsImpl = function InitializeAutoAtlAnalyticsImpl(_ref) {
    var _ref$pageViewProperti = _ref.pageViewProperties, pageViewProperties = _ref$pageViewProperti === void 0 ? {} : _ref$pageViewProperti, createAnalyticsEvent = _ref.createAnalyticsEvent;
    var analyticsClient = (0, $611eba94e0709501$exports.useAnalyticsClient)();
    var ANALYTICS_WRITE_KEY = '';
    (0, $5FkrB.useEffect)(function() {
        if (!analyticsClient) return;
        $a16418a003617505$exports.Initializer.initWithPageAnalytics(ANALYTICS_WRITE_KEY, $edca2caa766c402a$var$deepClone(pageViewProperties), Date.now(), analyticsClient.getAnonymousId(), createAnalyticsEvent || null);
    }, [
        analyticsClient,
        ANALYTICS_WRITE_KEY,
        createAnalyticsEvent,
        pageViewProperties
    ]);
    return null;
};
var $edca2caa766c402a$var$InitializeAutoAtlAnalytics = $edca2caa766c402a$exports.InitializeAutoAtlAnalytics = (0, $d5f32e7562891e94$export$2e2bcd8739ae039)()($edca2caa766c402a$var$InitializeAutoAtlAnalyticsImpl);





Object.keys($eeec4b79607b6553$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $b39c9956eebb23a1$exports && $b39c9956eebb23a1$exports[key] === $eeec4b79607b6553$exports[key]) return;
    Object.defineProperty($b39c9956eebb23a1$exports, key, {
        enumerable: true,
        get: function get() {
            return $eeec4b79607b6553$exports[key];
        }
    });
});
var $c9a10b8dc262d1c2$exports = {};
"use strict";
Object.defineProperty($c9a10b8dc262d1c2$exports, "__esModule", {
    value: true
});

Object.keys($611eba94e0709501$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $c9a10b8dc262d1c2$exports && $c9a10b8dc262d1c2$exports[key] === $611eba94e0709501$exports[key]) return;
    Object.defineProperty($c9a10b8dc262d1c2$exports, key, {
        enumerable: true,
        get: function get() {
            return $611eba94e0709501$exports[key];
        }
    });
});

Object.keys($77649b04a9131230$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $c9a10b8dc262d1c2$exports && $c9a10b8dc262d1c2$exports[key] === $77649b04a9131230$exports[key]) return;
    Object.defineProperty($c9a10b8dc262d1c2$exports, key, {
        enumerable: true,
        get: function get() {
            return $77649b04a9131230$exports[key];
        }
    });
});

Object.keys($55a1880d3758202a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $c9a10b8dc262d1c2$exports && $c9a10b8dc262d1c2$exports[key] === $55a1880d3758202a$exports[key]) return;
    Object.defineProperty($c9a10b8dc262d1c2$exports, key, {
        enumerable: true,
        get: function get() {
            return $55a1880d3758202a$exports[key];
        }
    });
});


Object.keys($c9a10b8dc262d1c2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $b39c9956eebb23a1$exports && $b39c9956eebb23a1$exports[key] === $c9a10b8dc262d1c2$exports[key]) return;
    Object.defineProperty($b39c9956eebb23a1$exports, key, {
        enumerable: true,
        get: function get() {
            return $c9a10b8dc262d1c2$exports[key];
        }
    });
});


Object.keys($b39c9956eebb23a1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $bd858cf878484440$exports && $bd858cf878484440$exports[key] === $b39c9956eebb23a1$exports[key]) return;
    Object.defineProperty($bd858cf878484440$exports, key, {
        enumerable: true,
        get: function get() {
            return $b39c9956eebb23a1$exports[key];
        }
    });
});
var $209e8d31241d8aca$exports = {};
"use strict";
function $209e8d31241d8aca$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $209e8d31241d8aca$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $209e8d31241d8aca$var$_typeof(o);
}
Object.defineProperty($209e8d31241d8aca$exports, "__esModule", {
    value: true
});
$209e8d31241d8aca$exports.isUserInAllowList = $209e8d31241d8aca$exports.isUserAllowedForEaExperience = $209e8d31241d8aca$exports.getUserInfo = void 0;


function $209e8d31241d8aca$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $209e8d31241d8aca$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $209e8d31241d8aca$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($209e8d31241d8aca$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $209e8d31241d8aca$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $209e8d31241d8aca$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $209e8d31241d8aca$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $209e8d31241d8aca$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
var $209e8d31241d8aca$var$getUserInfo = $209e8d31241d8aca$exports.getUserInfo = /*#__PURE__*/ function() {
    var _ref = $209e8d31241d8aca$var$_asyncToGenerator(/*#__PURE__*/ $209e8d31241d8aca$var$_regeneratorRuntime().mark(function _callee() {
        var baseUrl, _responseBody$data, apiPath, response, responseBody, _args = arguments;
        return $209e8d31241d8aca$var$_regeneratorRuntime().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    baseUrl = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
                    _context.prev = 1;
                    apiPath = (0, $9b8dc532c3c3f9ae$exports.getUppApiPathFromEnvironment)();
                    _context.next = 5;
                    return fetch("".concat(baseUrl).concat(apiPath), {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            query: $6601efa3d6ce5781$exports.USER_INFO_QUERY,
                            operationName: 'USER_INFO_QUERY'
                        })
                    });
                case 5:
                    response = _context.sent;
                    _context.next = 8;
                    return response.json();
                case 8:
                    responseBody = _context.sent;
                    return _context.abrupt("return", ((_responseBody$data = responseBody.data) === null || _responseBody$data === void 0 || (_responseBody$data = _responseBody$data.me) === null || _responseBody$data === void 0 ? void 0 : _responseBody$data.user) || null);
                case 12:
                    _context.prev = 12;
                    _context.t0 = _context["catch"](1);
                    return _context.abrupt("return", null);
                case 15:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                1,
                12
            ]
        ]);
    }));
    return function getUserInfo() {
        return _ref.apply(this, arguments);
    };
}();
var $209e8d31241d8aca$var$isUserInAllowList = $209e8d31241d8aca$exports.isUserInAllowList = /*#__PURE__*/ function() {
    var _ref2 = $209e8d31241d8aca$var$_asyncToGenerator(/*#__PURE__*/ $209e8d31241d8aca$var$_regeneratorRuntime().mark(function _callee2(emailId) {
        var baseUrl, _responseBody$data2, apiPath, response, responseBody, _args2 = arguments;
        return $209e8d31241d8aca$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    baseUrl = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : '';
                    if (emailId) {
                        _context2.next = 3;
                        break;
                    }
                    return _context2.abrupt("return", false);
                case 3:
                    _context2.prev = 3;
                    apiPath = (0, $9b8dc532c3c3f9ae$exports.getUppApiPathFromEnvironment)();
                    _context2.next = 7;
                    return fetch("".concat(baseUrl).concat(apiPath), {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            query: (0, $6601efa3d6ce5781$exports.getUserIsAllowedQuery)(emailId),
                            operationName: 'USER_ALLOWED_QUERY'
                        })
                    });
                case 7:
                    response = _context2.sent;
                    _context2.next = 10;
                    return response.json();
                case 10:
                    responseBody = _context2.sent;
                    return _context2.abrupt("return", !!((_responseBody$data2 = responseBody.data) !== null && _responseBody$data2 !== void 0 && (_responseBody$data2 = _responseBody$data2.unified) !== null && _responseBody$data2 !== void 0 && (_responseBody$data2 = _responseBody$data2.gating) !== null && _responseBody$data2 !== void 0 && (_responseBody$data2 = _responseBody$data2.isEmailIdAllowed) !== null && _responseBody$data2 !== void 0 && _responseBody$data2.status));
                case 14:
                    _context2.prev = 14;
                    _context2.t0 = _context2["catch"](3);
                    return _context2.abrupt("return", false);
                case 17:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                3,
                14
            ]
        ]);
    }));
    return function isUserInAllowList(_x) {
        return _ref2.apply(this, arguments);
    };
}();
var $209e8d31241d8aca$var$isUserAllowedForEaExperience = $209e8d31241d8aca$exports.isUserAllowedForEaExperience = /*#__PURE__*/ function() {
    var _ref3 = $209e8d31241d8aca$var$_asyncToGenerator(/*#__PURE__*/ $209e8d31241d8aca$var$_regeneratorRuntime().mark(function _callee3() {
        var baseUrl, userInfo, _args3 = arguments;
        return $209e8d31241d8aca$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    baseUrl = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : '';
                    _context3.next = 3;
                    return $209e8d31241d8aca$var$getUserInfo(baseUrl);
                case 3:
                    userInfo = _context3.sent;
                    if (userInfo) {
                        _context3.next = 6;
                        break;
                    }
                    return _context3.abrupt("return", false);
                case 6:
                    _context3.next = 8;
                    return $209e8d31241d8aca$var$isUserInAllowList(userInfo.email);
                case 8:
                    return _context3.abrupt("return", _context3.sent);
                case 9:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function isUserAllowedForEaExperience() {
        return _ref3.apply(this, arguments);
    };
}();


Object.keys($209e8d31241d8aca$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $bd858cf878484440$exports && $bd858cf878484440$exports[key] === $209e8d31241d8aca$exports[key]) return;
    Object.defineProperty($bd858cf878484440$exports, key, {
        enumerable: true,
        get: function get() {
            return $209e8d31241d8aca$exports[key];
        }
    });
});

Object.keys($9274af858143a4bd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $bd858cf878484440$exports && $bd858cf878484440$exports[key] === $9274af858143a4bd$exports[key]) return;
    Object.defineProperty($bd858cf878484440$exports, key, {
        enumerable: true,
        get: function get() {
            return $9274af858143a4bd$exports[key];
        }
    });
});
var $6476a8cf69414f97$exports = {};
"use strict";
function $6476a8cf69414f97$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6476a8cf69414f97$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6476a8cf69414f97$var$_typeof(o);
}
Object.defineProperty($6476a8cf69414f97$exports, "__esModule", {
    value: true
});
$6476a8cf69414f97$exports.initializeCommunitybyAaid = $6476a8cf69414f97$exports.initializeCommunity = $6476a8cf69414f97$exports.getCommunityLogoutUrl = $6476a8cf69414f97$exports.getCommunityLoginUrl = void 0;


var $62fb03ede952ca54$exports = {};
"use strict";
Object.defineProperty($62fb03ede952ca54$exports, "__esModule", {
    value: true
});
$62fb03ede952ca54$exports.getLogoutUrl = $62fb03ede952ca54$exports.getLoginUrl = $62fb03ede952ca54$exports.getForumsSignOutUrl = $62fb03ede952ca54$exports.getForumsSignInUrl = $62fb03ede952ca54$exports.getAuthUrl = void 0;

function $62fb03ede952ca54$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $62fb03ede952ca54$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $62fb03ede952ca54$var$_typeof(o);
}
function $62fb03ede952ca54$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $62fb03ede952ca54$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $62fb03ede952ca54$var$ownKeys(Object(t), !0).forEach(function(r) {
            $62fb03ede952ca54$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $62fb03ede952ca54$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $62fb03ede952ca54$var$_defineProperty(e, r, t) {
    return (r = $62fb03ede952ca54$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $62fb03ede952ca54$var$_toPropertyKey(t) {
    var i = $62fb03ede952ca54$var$_toPrimitive(t, "string");
    return "symbol" == $62fb03ede952ca54$var$_typeof(i) ? i : i + "";
}
function $62fb03ede952ca54$var$_toPrimitive(t, r) {
    if ("object" != $62fb03ede952ca54$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $62fb03ede952ca54$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $62fb03ede952ca54$var$buildAuthQueryParams = function buildAuthQueryParams(urlType, _ref) {
    var email = _ref.email, redirectUrl = _ref.redirectUrl, prompt = _ref.prompt, _ref$experience = _ref.experience, experience = _ref$experience === void 0 ? 'entry-auth' : _ref$experience;
    var queryParams = [];
    if (email) queryParams.push("login_hint=".concat(email));
    if (experience) queryParams.push("application=community--".concat(experience));
    if (redirectUrl) {
        // Encode the redirectUrl to handle special characters in paths (e.g. nested article paths)
        var encodedRedirectUrl = encodeURIComponent(redirectUrl);
        queryParams.push(urlType === 'identity' ? "continue=".concat(encodedRedirectUrl) : "referer=".concat(encodedRedirectUrl));
    }
    if (prompt) queryParams.push("prompt=".concat(prompt));
    return queryParams;
};
var $62fb03ede952ca54$var$getAuthUrl = $62fb03ede952ca54$exports.getAuthUrl = function getAuthUrl(type, queryParamValues, env) {
    var environment = (0, $9b8dc532c3c3f9ae$exports.getEnvironment)(env);
    var config = $9b8dc532c3c3f9ae$exports.ENVIRONMENT_CONFIGS[environment];
    var queryParams = $62fb03ede952ca54$var$buildAuthQueryParams('identity', queryParamValues);
    return "".concat(config.IDENTITY_BASE_URL, "/").concat(type, "?").concat(queryParams.join('&'));
};
var $62fb03ede952ca54$var$getForumsSignInUrl = $62fb03ede952ca54$exports.getForumsSignInUrl = function getForumsSignInUrl(queryParamValues, env) {
    var environment = (0, $9b8dc532c3c3f9ae$exports.getEnvironment)(env);
    var config = $9b8dc532c3c3f9ae$exports.ENVIRONMENT_CONFIGS[environment];
    // Only include referer parameter for OAuth2 SSO redirect
    var queryParams = [];
    if (queryParamValues.redirectUrl) // Encode the redirectUrl to handle special characters in paths (e.g. nested article paths)
    queryParams.push("referer=".concat(encodeURIComponent(queryParamValues.redirectUrl)));
    var queryString = queryParams.length > 0 ? "?".concat(queryParams.join('&')) : '';
    return "".concat(config.HOME_BASE_URL, "/forums/s/plugins/common/feature/oauth2sso_v2/sso_login_redirect").concat(queryString);
};
var $62fb03ede952ca54$var$getForumsSignOutUrl = $62fb03ede952ca54$exports.getForumsSignOutUrl = function getForumsSignOutUrl(redirectUrl, env) {
    var environment = (0, $9b8dc532c3c3f9ae$exports.getEnvironment)(env);
    var config = $9b8dc532c3c3f9ae$exports.ENVIRONMENT_CONFIGS[environment];
    // Encode the redirectUrl to handle special characters in paths (e.g. nested article paths)
    var encodedRedirectUrl = redirectUrl ? encodeURIComponent(redirectUrl) : '';
    return "".concat(config.HOME_BASE_URL, "/forums/s/plugins/custom/atlassian/").concat(config.KHOROS_ENDPOINT_PATH, "/khoros_logout?referer=").concat(encodedRedirectUrl);
};
var $62fb03ede952ca54$var$getLoginUrl = $62fb03ede952ca54$exports.getLoginUrl = function getLoginUrl(queryParamValues, env) {
    // Build the forums signin URL with the redirect URL
    var forumsSignInUrl = $62fb03ede952ca54$var$getForumsSignInUrl(queryParamValues);
    // redirect the identity login to the forums signin url
    var identityLoginUrl = $62fb03ede952ca54$var$getAuthUrl('login', $62fb03ede952ca54$var$_objectSpread($62fb03ede952ca54$var$_objectSpread({}, queryParamValues), {}, {
        redirectUrl: "".concat(forumsSignInUrl)
    }), env);
    return identityLoginUrl;
};
var $62fb03ede952ca54$var$getLogoutUrl = $62fb03ede952ca54$exports.getLogoutUrl = function getLogoutUrl(queryParamValues, env) {
    // Build the forums signout URL with the redirect URL
    var forumsSignOutUrl = $62fb03ede952ca54$var$getForumsSignOutUrl(queryParamValues.redirectUrl, env);
    // redirect the identity logout to the forums signout url
    var identityLogoutUrl = $62fb03ede952ca54$var$getAuthUrl('logout', $62fb03ede952ca54$var$_objectSpread($62fb03ede952ca54$var$_objectSpread({}, queryParamValues), {}, {
        redirectUrl: "".concat(forumsSignOutUrl)
    }), env);
    return identityLogoutUrl;
};


function $6476a8cf69414f97$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $6476a8cf69414f97$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $6476a8cf69414f97$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($6476a8cf69414f97$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $6476a8cf69414f97$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6476a8cf69414f97$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6476a8cf69414f97$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6476a8cf69414f97$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6476a8cf69414f97$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6476a8cf69414f97$var$_defineProperty(e, r, t) {
    return (r = $6476a8cf69414f97$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $6476a8cf69414f97$var$_toPropertyKey(t) {
    var i = $6476a8cf69414f97$var$_toPrimitive(t, "string");
    return "symbol" == $6476a8cf69414f97$var$_typeof(i) ? i : i + "";
}
function $6476a8cf69414f97$var$_toPrimitive(t, r) {
    if ("object" != $6476a8cf69414f97$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6476a8cf69414f97$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $6476a8cf69414f97$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $6476a8cf69414f97$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $6476a8cf69414f97$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $6476a8cf69414f97$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
var $6476a8cf69414f97$var$getCommunityLoginUrl = $6476a8cf69414f97$exports.getCommunityLoginUrl = function getCommunityLoginUrl(queryParamValues, env) {
    return (0, $62fb03ede952ca54$exports.getLoginUrl)(queryParamValues, env);
};
var $6476a8cf69414f97$var$getCommunityLogoutUrl = $6476a8cf69414f97$exports.getCommunityLogoutUrl = function getCommunityLogoutUrl(queryParamValues, env) {
    return (0, $62fb03ede952ca54$exports.getLogoutUrl)(queryParamValues, env);
};
// Initialize Community on UPP
var $6476a8cf69414f97$var$initializeCommunity = $6476a8cf69414f97$exports.initializeCommunity = /*#__PURE__*/ function() {
    var _ref = $6476a8cf69414f97$var$_asyncToGenerator(/*#__PURE__*/ $6476a8cf69414f97$var$_regeneratorRuntime().mark(function _callee(emailId) {
        var baseUrl, Origin, env, _graphqlResponseBody$, apiPath, graphqlResponse, graphqlResponseBody, _args = arguments;
        return $6476a8cf69414f97$var$_regeneratorRuntime().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    baseUrl = _args.length > 1 && _args[1] !== undefined ? _args[1] : '';
                    Origin = _args.length > 2 ? _args[2] : undefined;
                    env = _args.length > 3 ? _args[3] : undefined;
                    _context.prev = 3;
                    apiPath = (0, $9b8dc532c3c3f9ae$exports.getUppApiPathFromEnvironment)(env);
                    _context.next = 7;
                    return fetch("".concat(baseUrl).concat(apiPath), {
                        method: 'POST',
                        headers: $6476a8cf69414f97$var$_objectSpread({
                            'Content-Type': 'application/json'
                        }, Origin ? {
                            Origin: Origin
                        } : {}),
                        body: JSON.stringify({
                            query: (0, $6eda9e6c03494bd2$exports.initializeCommunityMutation)(emailId),
                            operationName: 'INITIALIZE_COMMUNITY_MUTATION'
                        })
                    });
                case 7:
                    graphqlResponse = _context.sent;
                    _context.next = 10;
                    return graphqlResponse.json();
                case 10:
                    graphqlResponseBody = _context.sent;
                    return _context.abrupt("return", graphqlResponseBody === null || graphqlResponseBody === void 0 || (_graphqlResponseBody$ = graphqlResponseBody.data) === null || _graphqlResponseBody$ === void 0 || (_graphqlResponseBody$ = _graphqlResponseBody$.unified) === null || _graphqlResponseBody$ === void 0 || (_graphqlResponseBody$ = _graphqlResponseBody$.community) === null || _graphqlResponseBody$ === void 0 ? void 0 : _graphqlResponseBody$.initializeCommunity);
                case 14:
                    _context.prev = 14;
                    _context.t0 = _context["catch"](3);
                    console.error('Error setting consent on UPP: ', _context.t0);
                    return _context.abrupt("return", false);
                case 18:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                3,
                14
            ]
        ]);
    }));
    return function initializeCommunity(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $6476a8cf69414f97$var$initializeCommunitybyAaid = $6476a8cf69414f97$exports.initializeCommunitybyAaid = /*#__PURE__*/ function() {
    var _ref2 = $6476a8cf69414f97$var$_asyncToGenerator(/*#__PURE__*/ $6476a8cf69414f97$var$_regeneratorRuntime().mark(function _callee2(aaid) {
        var baseUrl, Origin, env, _graphqlResponseBody$2, apiPath, graphqlResponse, graphqlResponseBody, _args2 = arguments;
        return $6476a8cf69414f97$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    baseUrl = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : '';
                    Origin = _args2.length > 2 ? _args2[2] : undefined;
                    env = _args2.length > 3 ? _args2[3] : undefined;
                    _context2.prev = 3;
                    apiPath = (0, $9b8dc532c3c3f9ae$exports.getUppApiPathFromEnvironment)(env);
                    _context2.next = 7;
                    return fetch("".concat(baseUrl).concat(apiPath), {
                        method: 'POST',
                        headers: $6476a8cf69414f97$var$_objectSpread({
                            'Content-Type': 'application/json'
                        }, Origin ? {
                            Origin: Origin
                        } : {}),
                        body: JSON.stringify({
                            query: (0, $6eda9e6c03494bd2$exports.initializeCommunityMutationbyAaid)(aaid),
                            operationName: 'INITIALIZE_COMMUNITY_MUTATION'
                        })
                    });
                case 7:
                    graphqlResponse = _context2.sent;
                    _context2.next = 10;
                    return graphqlResponse.json();
                case 10:
                    graphqlResponseBody = _context2.sent;
                    return _context2.abrupt("return", graphqlResponseBody === null || graphqlResponseBody === void 0 || (_graphqlResponseBody$2 = graphqlResponseBody.data) === null || _graphqlResponseBody$2 === void 0 || (_graphqlResponseBody$2 = _graphqlResponseBody$2.unified) === null || _graphqlResponseBody$2 === void 0 || (_graphqlResponseBody$2 = _graphqlResponseBody$2.community) === null || _graphqlResponseBody$2 === void 0 ? void 0 : _graphqlResponseBody$2.initializeCommunity);
                case 14:
                    _context2.prev = 14;
                    _context2.t0 = _context2["catch"](3);
                    console.error('Error setting consent on UPP: ', _context2.t0);
                    return _context2.abrupt("return", false);
                case 18:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                3,
                14
            ]
        ]);
    }));
    return function initializeCommunitybyAaid(_x2) {
        return _ref2.apply(this, arguments);
    };
}();


Object.keys($6476a8cf69414f97$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $bd858cf878484440$exports && $bd858cf878484440$exports[key] === $6476a8cf69414f97$exports[key]) return;
    Object.defineProperty($bd858cf878484440$exports, key, {
        enumerable: true,
        get: function get() {
            return $6476a8cf69414f97$exports[key];
        }
    });
});
var $0fb329e9144e036b$exports = {};
"use strict";
function $0fb329e9144e036b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0fb329e9144e036b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0fb329e9144e036b$var$_typeof(o);
}
Object.defineProperty($0fb329e9144e036b$exports, "__esModule", {
    value: true
});
$0fb329e9144e036b$exports.isUserManaged = $0fb329e9144e036b$exports.getUserAccountStatuses = void 0;



function $0fb329e9144e036b$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $0fb329e9144e036b$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $0fb329e9144e036b$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($0fb329e9144e036b$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $0fb329e9144e036b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0fb329e9144e036b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0fb329e9144e036b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0fb329e9144e036b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0fb329e9144e036b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0fb329e9144e036b$var$_defineProperty(e, r, t) {
    return (r = $0fb329e9144e036b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0fb329e9144e036b$var$_toPropertyKey(t) {
    var i = $0fb329e9144e036b$var$_toPrimitive(t, "string");
    return "symbol" == $0fb329e9144e036b$var$_typeof(i) ? i : i + "";
}
function $0fb329e9144e036b$var$_toPrimitive(t, r) {
    if ("object" != $0fb329e9144e036b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0fb329e9144e036b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0fb329e9144e036b$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $0fb329e9144e036b$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $0fb329e9144e036b$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $0fb329e9144e036b$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
var $0fb329e9144e036b$var$getUserAccountStatuses = $0fb329e9144e036b$exports.getUserAccountStatuses = /*#__PURE__*/ function() {
    var _ref = $0fb329e9144e036b$var$_asyncToGenerator(/*#__PURE__*/ $0fb329e9144e036b$var$_regeneratorRuntime().mark(function _callee(aaid) {
        var baseUrl, Origin, env, apiPath, rawResponse, json, _args = arguments;
        return $0fb329e9144e036b$var$_regeneratorRuntime().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    baseUrl = _args.length > 1 && _args[1] !== undefined ? _args[1] : '';
                    Origin = _args.length > 2 ? _args[2] : undefined;
                    env = _args.length > 3 ? _args[3] : undefined;
                    apiPath = (0, $9b8dc532c3c3f9ae$exports.getUppApiPathFromEnvironment)(env);
                    _context.next = 6;
                    return fetch("".concat(baseUrl).concat(apiPath), {
                        method: 'POST',
                        headers: $0fb329e9144e036b$var$_objectSpread({
                            'Content-Type': 'application/json'
                        }, Origin ? {
                            Origin: Origin
                        } : {}),
                        body: JSON.stringify({
                            query: (0, $6601efa3d6ce5781$exports.getUserAccountQuery)(aaid),
                            operationName: 'USER_ACCOUNT_QUERY'
                        })
                    });
                case 6:
                    rawResponse = _context.sent;
                    _context.next = 9;
                    return rawResponse.json();
                case 9:
                    json = _context.sent;
                    return _context.abrupt("return", json);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function getUserAccountStatuses(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $0fb329e9144e036b$var$isUserManaged = $0fb329e9144e036b$exports.isUserManaged = /*#__PURE__*/ function() {
    var _ref2 = $0fb329e9144e036b$var$_asyncToGenerator(/*#__PURE__*/ $0fb329e9144e036b$var$_regeneratorRuntime().mark(function _callee2(aaid) {
        var baseUrl, Origin, env, _response$data, response, account, _args2 = arguments;
        return $0fb329e9144e036b$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    baseUrl = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : '';
                    Origin = _args2.length > 2 ? _args2[2] : undefined;
                    env = _args2.length > 3 ? _args2[3] : undefined;
                    _context2.prev = 3;
                    _context2.next = 6;
                    return $0fb329e9144e036b$var$getUserAccountStatuses(aaid, baseUrl, Origin, env);
                case 6:
                    response = _context2.sent;
                    account = response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 || (_response$data = _response$data.unified) === null || _response$data === void 0 ? void 0 : _response$data.account;
                    if (!(!account || (0, $5af8fa5f3021d79b$exports.isUnifiedAccountQueryError)(account))) {
                        _context2.next = 10;
                        break;
                    }
                    return _context2.abrupt("return", null);
                case 10:
                    if (!(typeof account.isManaged !== 'boolean')) {
                        _context2.next = 12;
                        break;
                    }
                    return _context2.abrupt("return", null);
                case 12:
                    return _context2.abrupt("return", account.isManaged);
                case 15:
                    _context2.prev = 15;
                    _context2.t0 = _context2["catch"](3);
                    console.error('[isUserManaged] Error fetching unified account:', _context2.t0);
                    return _context2.abrupt("return", null);
                case 19:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                3,
                15
            ]
        ]);
    }));
    return function isUserManaged(_x2) {
        return _ref2.apply(this, arguments);
    };
}();


Object.keys($0fb329e9144e036b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $bd858cf878484440$exports && $bd858cf878484440$exports[key] === $0fb329e9144e036b$exports[key]) return;
    Object.defineProperty($bd858cf878484440$exports, key, {
        enumerable: true,
        get: function get() {
            return $0fb329e9144e036b$exports[key];
        }
    });
});
var $39032f18861f088c$exports = {};
"use strict";
function $39032f18861f088c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $39032f18861f088c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $39032f18861f088c$var$_typeof(o);
}
Object.defineProperty($39032f18861f088c$exports, "__esModule", {
    value: true
});
$39032f18861f088c$exports.submitChampionSignup = void 0;


function $39032f18861f088c$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $39032f18861f088c$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $39032f18861f088c$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($39032f18861f088c$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $39032f18861f088c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $39032f18861f088c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $39032f18861f088c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $39032f18861f088c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $39032f18861f088c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $39032f18861f088c$var$_defineProperty(e, r, t) {
    return (r = $39032f18861f088c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $39032f18861f088c$var$_toPropertyKey(t) {
    var i = $39032f18861f088c$var$_toPrimitive(t, "string");
    return "symbol" == $39032f18861f088c$var$_typeof(i) ? i : i + "";
}
function $39032f18861f088c$var$_toPrimitive(t, r) {
    if ("object" != $39032f18861f088c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $39032f18861f088c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $39032f18861f088c$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $39032f18861f088c$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $39032f18861f088c$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $39032f18861f088c$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
var $39032f18861f088c$var$submitChampionSignup = $39032f18861f088c$exports.submitChampionSignup = /*#__PURE__*/ function() {
    var _ref = $39032f18861f088c$var$_asyncToGenerator(/*#__PURE__*/ $39032f18861f088c$var$_regeneratorRuntime().mark(function _callee(input) {
        var baseUrl, Origin, env, _json$data$champion$c, _json$data, apiPath, rawResponse, json, _args = arguments;
        return $39032f18861f088c$var$_regeneratorRuntime().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    baseUrl = _args.length > 1 && _args[1] !== undefined ? _args[1] : '';
                    Origin = _args.length > 2 ? _args[2] : undefined;
                    env = _args.length > 3 ? _args[3] : undefined;
                    _context.prev = 3;
                    apiPath = (0, $9b8dc532c3c3f9ae$exports.getUppApiPathFromEnvironment)(env);
                    _context.next = 7;
                    return fetch("".concat(baseUrl).concat(apiPath), {
                        method: 'POST',
                        credentials: 'include',
                        headers: $39032f18861f088c$var$_objectSpread({
                            'Content-Type': 'application/json'
                        }, Origin ? {
                            Origin: Origin
                        } : {}),
                        body: JSON.stringify({
                            query: $6eda9e6c03494bd2$exports.SUBMIT_CHAMPION_SIGNUP_MUTATION,
                            operationName: 'SUBMIT_CHAMPION_SIGNUP_MUTATION',
                            variables: {
                                input: input
                            }
                        })
                    });
                case 7:
                    rawResponse = _context.sent;
                    _context.next = 10;
                    return rawResponse.json();
                case 10:
                    json = _context.sent;
                    return _context.abrupt("return", (_json$data$champion$c = json === null || json === void 0 || (_json$data = json.data) === null || _json$data === void 0 || (_json$data = _json$data.champion) === null || _json$data === void 0 || (_json$data = _json$data.championSignup) === null || _json$data === void 0 ? void 0 : _json$data.submitChampionSignup) !== null && _json$data$champion$c !== void 0 ? _json$data$champion$c : null);
                case 14:
                    _context.prev = 14;
                    _context.t0 = _context["catch"](3);
                    console.error('Error submitting champion signup: ', _context.t0);
                    return _context.abrupt("return", null);
                case 18:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                3,
                14
            ]
        ]);
    }));
    return function submitChampionSignup(_x) {
        return _ref.apply(this, arguments);
    };
}();


Object.keys($39032f18861f088c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $bd858cf878484440$exports && $bd858cf878484440$exports[key] === $39032f18861f088c$exports[key]) return;
    Object.defineProperty($bd858cf878484440$exports, key, {
        enumerable: true,
        get: function get() {
            return $39032f18861f088c$exports[key];
        }
    });
});


function $1964ee7f51f79709$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $1964ee7f51f79709$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1964ee7f51f79709$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1964ee7f51f79709$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $1964ee7f51f79709$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $1964ee7f51f79709$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1964ee7f51f79709$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $1964ee7f51f79709$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $1964ee7f51f79709$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($1964ee7f51f79709$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $1964ee7f51f79709$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $1964ee7f51f79709$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $1964ee7f51f79709$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $1964ee7f51f79709$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function $1964ee7f51f79709$var$_slicedToArray(r, e) {
    return $1964ee7f51f79709$var$_arrayWithHoles(r) || $1964ee7f51f79709$var$_iterableToArrayLimit(r, e) || $1964ee7f51f79709$var$_unsupportedIterableToArray(r, e) || $1964ee7f51f79709$var$_nonIterableRest();
}
function $1964ee7f51f79709$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1964ee7f51f79709$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $1964ee7f51f79709$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1964ee7f51f79709$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $1964ee7f51f79709$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $1964ee7f51f79709$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $1964ee7f51f79709$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
var $1964ee7f51f79709$var$Initializer = $1964ee7f51f79709$exports.Initializer = function Initializer(_ref) {
    var emailId = _ref.emailId, aaid = _ref.aaid, onError = _ref.onError, onSuccess = _ref.onSuccess, onComplete = _ref.onComplete, isInitialized = _ref.isInitialized, children = _ref.children;
    var _React$useState = $1964ee7f51f79709$var$_react["default"].useState(false), _React$useState2 = $1964ee7f51f79709$var$_slicedToArray(_React$useState, 2), isLoading = _React$useState2[0], setIsLoading = _React$useState2[1];
    var initializeCommunityAccounts = /*#__PURE__*/ function() {
        var _ref2 = $1964ee7f51f79709$var$_asyncToGenerator(/*#__PURE__*/ $1964ee7f51f79709$var$_regeneratorRuntime().mark(function _callee() {
            var response;
            return $1964ee7f51f79709$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.prev = 0;
                        setIsLoading(true);
                        if (!aaid) {
                            _context.next = 8;
                            break;
                        }
                        _context.next = 5;
                        return (0, $bd858cf878484440$exports.initializeCommunitybyAaid)(aaid);
                    case 5:
                        response = _context.sent;
                        _context.next = 15;
                        break;
                    case 8:
                        if (!emailId) {
                            _context.next = 14;
                            break;
                        }
                        _context.next = 11;
                        return (0, $bd858cf878484440$exports.initializeCommunity)(emailId);
                    case 11:
                        response = _context.sent;
                        _context.next = 15;
                        break;
                    case 14:
                        onError('missing_aaid_emailid', 'AAID or emailId is required');
                    case 15:
                        if (!response) onError('consent_failed', 'Failed to initialize');
                        else onSuccess();
                        _context.next = 21;
                        break;
                    case 18:
                        _context.prev = 18;
                        _context.t0 = _context["catch"](0);
                        onError('initialization_failed', 'Failed to initialize' + _context.t0.message);
                    case 21:
                        _context.prev = 21;
                        setIsLoading(false);
                        if (onComplete) onComplete();
                        return _context.finish(21);
                    case 25:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    0,
                    18,
                    21,
                    25
                ]
            ]);
        }));
        return function initializeCommunityAccounts() {
            return _ref2.apply(this, arguments);
        };
    }();
    (0, $1964ee7f51f79709$var$_react.useEffect)(function() {
        $1964ee7f51f79709$var$_asyncToGenerator(/*#__PURE__*/ $1964ee7f51f79709$var$_regeneratorRuntime().mark(function _callee2() {
            return $1964ee7f51f79709$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        _context2.next = 2;
                        return initializeCommunityAccounts();
                    case 2:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2);
        }))();
    }, [
        aaid,
        emailId
    ]);
    if (isLoading) return /*#__PURE__*/ $1964ee7f51f79709$var$_react["default"].createElement($1964ee7f51f79709$var$_loadingSpinner["default"], null);
    // If not logged in, consent is true, or there is an error
    return isInitialized ? children : null;
};


Object.keys($1964ee7f51f79709$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $d9a56230c565b38a$exports && $d9a56230c565b38a$exports[key] === $1964ee7f51f79709$exports[key]) return;
    Object.defineProperty($d9a56230c565b38a$exports, key, {
        enumerable: true,
        get: function get() {
            return $1964ee7f51f79709$exports[key];
        }
    });
});


Object.keys($d9a56230c565b38a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $a73be79b54a68660$exports && $a73be79b54a68660$exports[key] === $d9a56230c565b38a$exports[key]) return;
    Object.defineProperty($a73be79b54a68660$exports, key, {
        enumerable: true,
        get: function get() {
            return $d9a56230c565b38a$exports[key];
        }
    });
});

Object.keys($bd858cf878484440$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $a73be79b54a68660$exports && $a73be79b54a68660$exports[key] === $bd858cf878484440$exports[key]) return;
    Object.defineProperty($a73be79b54a68660$exports, key, {
        enumerable: true,
        get: function get() {
            return $bd858cf878484440$exports[key];
        }
    });
});



/**
 * Returns the current page URL.
 * Extracted into its own module so it can be mocked in unit tests,
 * since window.location.href is non-configurable in jsdom.
 */ const $dbdd82f2c97f07d1$export$e28ecc88271c1c41 = ()=>window.location.href;


const $b512f1dc2d07f0c5$var$SSO_REDIRECT_PATH = '/forums/s/plugins/common/feature/oauth2sso_v2/sso_login_redirect';
const $b512f1dc2d07f0c5$var$COMMUNITY_PARAM = 'application=community--entry-auth';
const $b512f1dc2d07f0c5$export$c539662d478decb = ()=>{
    const env = (0, $09e3b90497c94454$export$e6ab37cc923d2afa)();
    const khorosEndpoint = env === 'production' ? 'atlassian' : 'atlassiandev';
    return `/forums/s/plugins/custom/atlassian/${khorosEndpoint}/khoros_logout`;
};
const $b512f1dc2d07f0c5$export$1db7da00354b15ed = ()=>{
    const homeBaseUrl = "https://community.atlassian.com";
    const referer = encodeURIComponent((0, $dbdd82f2c97f07d1$export$e28ecc88271c1c41)());
    const forumsUrl = `${homeBaseUrl}${$b512f1dc2d07f0c5$var$SSO_REDIRECT_PATH}?referer=${referer}`;
    return encodeURIComponent(forumsUrl);
};
const $b512f1dc2d07f0c5$export$f6a03fcc87267edf = ()=>{
    const homeBaseUrl = "https://community.atlassian.com";
    const referer = encodeURIComponent((0, $dbdd82f2c97f07d1$export$e28ecc88271c1c41)());
    const forumsUrl = `${homeBaseUrl}${$b512f1dc2d07f0c5$export$c539662d478decb()}?referer=${referer}`;
    return encodeURIComponent(forumsUrl);
};
const $b512f1dc2d07f0c5$export$f1dab1a322d2e5c = (email)=>{
    const identityBaseUrl = "https://id.atlassian.com";
    const params = [
        $b512f1dc2d07f0c5$var$COMMUNITY_PARAM
    ];
    if (email) params.push(`login_hint=${email}`);
    // getForumsSignInUrl already returns an encoded URL — use it directly as continue= value
    params.push(`continue=${$b512f1dc2d07f0c5$export$1db7da00354b15ed()}`);
    return `${identityBaseUrl}/login?${params.join('&')}`;
};
const $b512f1dc2d07f0c5$export$35bc0a4a03944143 = (email)=>{
    const identityBaseUrl = "https://id.atlassian.com";
    const params = [
        $b512f1dc2d07f0c5$var$COMMUNITY_PARAM
    ];
    if (email) params.push(`login_hint=${email}`);
    // getForumsSignOutUrl already returns an encoded URL — use it directly as continue= value
    params.push(`continue=${$b512f1dc2d07f0c5$export$f6a03fcc87267edf()}`);
    return `${identityBaseUrl}/logout?${params.join('&')}`;
};
const $b512f1dc2d07f0c5$export$82e6520baed18150 = (email)=>{
    const identityBaseUrl = "https://id.atlassian.com";
    const params = [
        $b512f1dc2d07f0c5$var$COMMUNITY_PARAM
    ];
    if (email) params.push(`login_hint=${email}`);
    // Signup goes directly back to the page, so encode the raw URL once
    params.push(`continue=${encodeURIComponent((0, $dbdd82f2c97f07d1$export$e28ecc88271c1c41)())}`);
    return `${identityBaseUrl}/signup?${params.join('&')}`;
};
const $b512f1dc2d07f0c5$export$e43e4e187350fb69 = ()=>{
    const identityBaseUrl = "https://id.atlassian.com";
    const params = [
        $b512f1dc2d07f0c5$var$COMMUNITY_PARAM
    ];
    params.push(`continue=${$b512f1dc2d07f0c5$export$1db7da00354b15ed()}`);
    params.push(`prompt=select_account`);
    return `${identityBaseUrl}/login?${params.join('&')}`;
};


const $12fc361ebcaf5b04$export$3151da8f6716d1a2 = ({ isLoggedIn: isLoggedIn, loggedInUser: loggedInUser })=>{
    // Auth href utils read window.location.href internally at call time, ensuring the correct
    // page URL is used even on the details page (/release-notes/:id)
    const email = loggedInUser?.email || '';
    const loginHref = (0, $b512f1dc2d07f0c5$export$f1dab1a322d2e5c)(email);
    const logoutHref = (0, $b512f1dc2d07f0c5$export$35bc0a4a03944143)(email);
    const signupHref = (0, $b512f1dc2d07f0c5$export$82e6520baed18150)(email);
    const switchHref = (0, $b512f1dc2d07f0c5$export$e43e4e187350fb69)();
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $24c02ea0e14dbe4f$export$901cb8c9de2be2aa), {
        currentApp: (0, $24c02ea0e14dbe4f$export$93d048dc21eb282a).APP_UPDATES,
        isLoggedIn: isLoggedIn,
        user: loggedInUser,
        loginHref: loginHref,
        logoutHref: logoutHref,
        signupHref: signupHref,
        switchHref: switchHref,
        onAnalyticsSendEvent: (type, payload)=>(0, $a73be79b54a68660$exports.CommunityAnalyticsClient).sendEvent(type, payload),
        email: loggedInUser?.email,
        showNewMenu: true
    });
};



var $5FkrB = parcelRequire("5FkrB");



var $l2Z7B = parcelRequire("l2Z7B");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");


function $50e1cdc87cad912e$export$2e2bcd8739ae039() {
    var intl = $5FkrB.useContext((0, $2b44d392c4a4ed5c$export$841858b892ce1f4c));
    (0, $ee8cd37431c4074b$export$45c4bbf6e55bba1f)(intl);
    return intl;
}


var $96dfa288cab30b1c$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($96dfa288cab30b1c$var$DisplayName || ($96dfa288cab30b1c$var$DisplayName = {}));
var $96dfa288cab30b1c$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($96dfa288cab30b1c$var$DisplayNameParts || ($96dfa288cab30b1c$var$DisplayNameParts = {}));
var $96dfa288cab30b1c$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    var value = props.value, children = props.children, formatProps = (0, $l2Z7B.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$96dfa288cab30b1c$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $96dfa288cab30b1c$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    var value = props.value, children = props.children, formatProps = (0, $l2Z7B.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$96dfa288cab30b1c$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $96dfa288cab30b1c$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
        var value = props.value, children = props.children, formatProps = (0, $l2Z7B.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $96dfa288cab30b1c$var$DisplayNameParts[name];
    return ComponentParts;
}
function $96dfa288cab30b1c$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
        var value = props.value, children = props.children, formatProps = (0, $l2Z7B.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $5FkrB.Fragment;
        return $5FkrB.createElement(Text, null, formattedValue);
    };
    Component.displayName = $96dfa288cab30b1c$var$DisplayName[name];
    return Component;
}







/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $l2Z7B = parcelRequire("l2Z7B");

var $5FkrB = parcelRequire("5FkrB");


function $d8c258b384a9ab14$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $l2Z7B.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $l2Z7B.__rest)(nextProps, [
        "values"
    ]);
    return (0, $ee8cd37431c4074b$export$d36bdfa510afb180)(nextValues, values) && (0, $ee8cd37431c4074b$export$d36bdfa510afb180)(otherProps, nextOtherProps);
}
function $d8c258b384a9ab14$var$FormattedMessage(props) {
    var intl = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $5FkrB.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $5FkrB.createElement(Component, null, $5FkrB.Children.toArray(nodes));
    return $5FkrB.createElement($5FkrB.Fragment, null, nodes);
}
$d8c258b384a9ab14$var$FormattedMessage.displayName = 'FormattedMessage';
var $d8c258b384a9ab14$var$MemoizedFormattedMessage = $5FkrB.memo($d8c258b384a9ab14$var$FormattedMessage, $d8c258b384a9ab14$var$areEqual);
$d8c258b384a9ab14$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $d8c258b384a9ab14$export$2e2bcd8739ae039 = $d8c258b384a9ab14$var$MemoizedFormattedMessage;




function $7e94896e68874ec2$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $7e94896e68874ec2$export$747d244ee58120dd(msg) {
    return msg;
}
var $7e94896e68874ec2$export$40ae3194919d16b = (0, $96dfa288cab30b1c$export$b37e14176d001dec)('formatDate');
var $7e94896e68874ec2$export$5b390a54f8a846f7 = (0, $96dfa288cab30b1c$export$b37e14176d001dec)('formatTime');
var $7e94896e68874ec2$export$db80edc1e6b2f63d = (0, $96dfa288cab30b1c$export$b37e14176d001dec)('formatNumber');
var $7e94896e68874ec2$export$f52b44e459e6e71d = (0, $96dfa288cab30b1c$export$b37e14176d001dec)('formatList');
var $7e94896e68874ec2$export$c2336ea5aaab92fa = (0, $96dfa288cab30b1c$export$b37e14176d001dec)('formatDisplayName');
var $7e94896e68874ec2$export$7fdc7d2c91ce149b = (0, $96dfa288cab30b1c$export$7448277f6036d2ab)('formatDate');
var $7e94896e68874ec2$export$ec35873761676c2a = (0, $96dfa288cab30b1c$export$7448277f6036d2ab)('formatTime');


// src/index.tsx

var $5FkrB = parcelRequire("5FkrB");

var $dcrmD = parcelRequire("dcrmD");

var $jSI6G = parcelRequire("jSI6G");
var $12b11248680fdff3$exports = {};
//
$12b11248680fdff3$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


// src/constants.ts
var $448e9b7b3295f6e4$var$TAG_NAMES = /* @__PURE__ */ ((TAG_NAMES2)=>{
    TAG_NAMES2["BASE"] = "base";
    TAG_NAMES2["BODY"] = "body";
    TAG_NAMES2["HEAD"] = "head";
    TAG_NAMES2["HTML"] = "html";
    TAG_NAMES2["LINK"] = "link";
    TAG_NAMES2["META"] = "meta";
    TAG_NAMES2["NOSCRIPT"] = "noscript";
    TAG_NAMES2["SCRIPT"] = "script";
    TAG_NAMES2["STYLE"] = "style";
    TAG_NAMES2["TITLE"] = "title";
    TAG_NAMES2["FRAGMENT"] = "Symbol(react.fragment)";
    return TAG_NAMES2;
})($448e9b7b3295f6e4$var$TAG_NAMES || {});
var $448e9b7b3295f6e4$var$SEO_PRIORITY_TAGS = {
    link: {
        rel: [
            "amphtml",
            "canonical",
            "alternate"
        ]
    },
    script: {
        type: [
            "application/ld+json"
        ]
    },
    meta: {
        charset: "",
        name: [
            "generator",
            "robots",
            "description"
        ],
        property: [
            "og:type",
            "og:title",
            "og:url",
            "og:image",
            "og:image:alt",
            "og:description",
            "twitter:url",
            "twitter:title",
            "twitter:description",
            "twitter:image",
            "twitter:image:alt",
            "twitter:card",
            "twitter:site"
        ]
    }
};
var $448e9b7b3295f6e4$var$VALID_TAG_NAMES = Object.values($448e9b7b3295f6e4$var$TAG_NAMES);
var $448e9b7b3295f6e4$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $448e9b7b3295f6e4$var$HTML_TAG_MAP = Object.entries($448e9b7b3295f6e4$var$REACT_TAG_MAP).reduce((carry, [key, value])=>{
    carry[value] = key;
    return carry;
}, {});
var $448e9b7b3295f6e4$var$HELMET_ATTRIBUTE = "data-rh";
// src/utils.ts
var $448e9b7b3295f6e4$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate",
    PRIORITIZE_SEO_TAGS: "prioritizeSeoTags"
};
var $448e9b7b3295f6e4$var$getInnermostProperty = (propsList, property)=>{
    for(let i = propsList.length - 1; i >= 0; i -= 1){
        const props = propsList[i];
        if (Object.prototype.hasOwnProperty.call(props, property)) return props[property];
    }
    return null;
};
var $448e9b7b3295f6e4$var$getTitleFromPropsList = (propsList)=>{
    let innermostTitle = $448e9b7b3295f6e4$var$getInnermostProperty(propsList, "title" /* TITLE */ );
    const innermostTemplate = $448e9b7b3295f6e4$var$getInnermostProperty(propsList, $448e9b7b3295f6e4$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (Array.isArray(innermostTitle)) innermostTitle = innermostTitle.join("");
    if (innermostTemplate && innermostTitle) return innermostTemplate.replace(/%s/g, ()=>innermostTitle);
    const innermostDefaultTitle = $448e9b7b3295f6e4$var$getInnermostProperty(propsList, $448e9b7b3295f6e4$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || void 0;
};
var $448e9b7b3295f6e4$var$getOnChangeClientState = (propsList)=>$448e9b7b3295f6e4$var$getInnermostProperty(propsList, $448e9b7b3295f6e4$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || (()=>{});
var $448e9b7b3295f6e4$var$getAttributesFromPropsList = (tagType, propsList)=>propsList.filter((props)=>typeof props[tagType] !== "undefined").map((props)=>props[tagType]).reduce((tagAttrs, current)=>({
            ...tagAttrs,
            ...current
        }), {});
var $448e9b7b3295f6e4$var$getBaseTagFromPropsList = (primaryAttributes, propsList)=>propsList.filter((props)=>typeof props["base" /* BASE */ ] !== "undefined").map((props)=>props["base" /* BASE */ ]).reverse().reduce((innermostBaseTag, tag)=>{
        if (!innermostBaseTag.length) {
            const keys = Object.keys(tag);
            for(let i = 0; i < keys.length; i += 1){
                const attributeKey = keys[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
var $448e9b7b3295f6e4$var$warn = (msg)=>console && typeof console.warn === "function" && console.warn(msg);
var $448e9b7b3295f6e4$var$getTagsFromPropsList = (tagName, primaryAttributes, propsList)=>{
    const approvedSeenTags = {};
    return propsList.filter((props)=>{
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $448e9b7b3295f6e4$var$warn(`Helmet: ${tagName} should be of type "Array". Instead found type "${typeof props[tagName]}"`);
        return false;
    }).map((props)=>props[tagName]).reverse().reduce((approvedTags, instanceTags)=>{
        const instanceSeenTags = {};
        instanceTags.filter((tag)=>{
            let primaryAttributeKey;
            const keys2 = Object.keys(tag);
            for(let i = 0; i < keys2.length; i += 1){
                const attributeKey = keys2[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === "rel" /* REL */  && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === "rel" /* REL */  && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === "innerHTML" /* INNER_HTML */  || attributeKey === "cssText" /* CSS_TEXT */  || attributeKey === "itemprop" /* ITEM_PROP */ )) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            const value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach((tag)=>approvedTags.push(tag));
        const keys = Object.keys(instanceSeenTags);
        for(let i = 0; i < keys.length; i += 1){
            const attributeKey = keys[i];
            const tagUnion = {
                ...approvedSeenTags[attributeKey],
                ...instanceSeenTags[attributeKey]
            };
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $448e9b7b3295f6e4$var$getAnyTrueFromPropsList = (propsList, checkedTag)=>{
    if (Array.isArray(propsList) && propsList.length) for(let index = 0; index < propsList.length; index += 1){
        const prop = propsList[index];
        if (prop[checkedTag]) return true;
    }
    return false;
};
var $448e9b7b3295f6e4$var$reducePropsToState = (propsList)=>({
        baseTag: $448e9b7b3295f6e4$var$getBaseTagFromPropsList([
            "href" /* HREF */ 
        ], propsList),
        bodyAttributes: $448e9b7b3295f6e4$var$getAttributesFromPropsList("bodyAttributes" /* BODY */ , propsList),
        defer: $448e9b7b3295f6e4$var$getInnermostProperty(propsList, $448e9b7b3295f6e4$var$HELMET_PROPS.DEFER),
        encode: $448e9b7b3295f6e4$var$getInnermostProperty(propsList, $448e9b7b3295f6e4$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $448e9b7b3295f6e4$var$getAttributesFromPropsList("htmlAttributes" /* HTML */ , propsList),
        linkTags: $448e9b7b3295f6e4$var$getTagsFromPropsList("link" /* LINK */ , [
            "rel" /* REL */ ,
            "href" /* HREF */ 
        ], propsList),
        metaTags: $448e9b7b3295f6e4$var$getTagsFromPropsList("meta" /* META */ , [
            "name" /* NAME */ ,
            "charset" /* CHARSET */ ,
            "http-equiv" /* HTTPEQUIV */ ,
            "property" /* PROPERTY */ ,
            "itemprop" /* ITEM_PROP */ 
        ], propsList),
        noscriptTags: $448e9b7b3295f6e4$var$getTagsFromPropsList("noscript" /* NOSCRIPT */ , [
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        onChangeClientState: $448e9b7b3295f6e4$var$getOnChangeClientState(propsList),
        scriptTags: $448e9b7b3295f6e4$var$getTagsFromPropsList("script" /* SCRIPT */ , [
            "src" /* SRC */ ,
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        styleTags: $448e9b7b3295f6e4$var$getTagsFromPropsList("style" /* STYLE */ , [
            "cssText" /* CSS_TEXT */ 
        ], propsList),
        title: $448e9b7b3295f6e4$var$getTitleFromPropsList(propsList),
        titleAttributes: $448e9b7b3295f6e4$var$getAttributesFromPropsList("titleAttributes" /* TITLE */ , propsList),
        prioritizeSeoTags: $448e9b7b3295f6e4$var$getAnyTrueFromPropsList(propsList, $448e9b7b3295f6e4$var$HELMET_PROPS.PRIORITIZE_SEO_TAGS)
    });
var $448e9b7b3295f6e4$var$flattenArray = (possibleArray)=>Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
var $448e9b7b3295f6e4$var$checkIfPropsMatch = (props, toMatch)=>{
    const keys = Object.keys(props);
    for(let i = 0; i < keys.length; i += 1){
        if (toMatch[keys[i]] && toMatch[keys[i]].includes(props[keys[i]])) return true;
    }
    return false;
};
var $448e9b7b3295f6e4$var$prioritizer = (elementsList, propsToMatch)=>{
    if (Array.isArray(elementsList)) return elementsList.reduce((acc, elementAttrs)=>{
        if ($448e9b7b3295f6e4$var$checkIfPropsMatch(elementAttrs, propsToMatch)) acc.priority.push(elementAttrs);
        else acc.default.push(elementAttrs);
        return acc;
    }, {
        priority: [],
        default: []
    });
    return {
        default: elementsList,
        priority: []
    };
};
var $448e9b7b3295f6e4$var$without = (obj, key)=>{
    return {
        ...obj,
        [key]: void 0
    };
};
// src/server.ts
var $448e9b7b3295f6e4$var$SELF_CLOSING_TAGS = [
    "noscript" /* NOSCRIPT */ ,
    "script" /* SCRIPT */ ,
    "style" /* STYLE */ 
];
var $448e9b7b3295f6e4$var$encodeSpecialCharacters = (str, encode = true)=>{
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $448e9b7b3295f6e4$var$generateElementAttributesAsString = (attributes)=>Object.keys(attributes).reduce((str, key)=>{
        const attr = typeof attributes[key] !== "undefined" ? `${key}="${attributes[key]}"` : `${key}`;
        return str ? `${str} ${attr}` : attr;
    }, "");
var $448e9b7b3295f6e4$var$generateTitleAsString = (type, title, attributes, encode)=>{
    const attributeString = $448e9b7b3295f6e4$var$generateElementAttributesAsString(attributes);
    const flattenedTitle = $448e9b7b3295f6e4$var$flattenArray(title);
    return attributeString ? `<${type} ${$448e9b7b3295f6e4$var$HELMET_ATTRIBUTE}="true" ${attributeString}>${$448e9b7b3295f6e4$var$encodeSpecialCharacters(flattenedTitle, encode)}</${type}>` : `<${type} ${$448e9b7b3295f6e4$var$HELMET_ATTRIBUTE}="true">${$448e9b7b3295f6e4$var$encodeSpecialCharacters(flattenedTitle, encode)}</${type}>`;
};
var $448e9b7b3295f6e4$var$generateTagsAsString = (type, tags, encode = true)=>tags.reduce((str, t)=>{
        const tag = t;
        const attributeHtml = Object.keys(tag).filter((attribute)=>!(attribute === "innerHTML" /* INNER_HTML */  || attribute === "cssText" /* CSS_TEXT */ )).reduce((string, attribute)=>{
            const attr = typeof tag[attribute] === "undefined" ? attribute : `${attribute}="${$448e9b7b3295f6e4$var$encodeSpecialCharacters(tag[attribute], encode)}"`;
            return string ? `${string} ${attr}` : attr;
        }, "");
        const tagContent = tag.innerHTML || tag.cssText || "";
        const isSelfClosing = $448e9b7b3295f6e4$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return `${str}<${type} ${$448e9b7b3295f6e4$var$HELMET_ATTRIBUTE}="true" ${attributeHtml}${isSelfClosing ? `/>` : `>${tagContent}</${type}>`}`;
    }, "");
var $448e9b7b3295f6e4$var$convertElementAttributesToReactProps = (attributes, initProps = {})=>Object.keys(attributes).reduce((obj, key)=>{
        const mapped = $448e9b7b3295f6e4$var$REACT_TAG_MAP[key];
        obj[mapped || key] = attributes[key];
        return obj;
    }, initProps);
var $448e9b7b3295f6e4$var$generateTitleAsReactComponent = (_type, title, attributes)=>{
    const initProps = {
        key: title,
        [$448e9b7b3295f6e4$var$HELMET_ATTRIBUTE]: true
    };
    const props = $448e9b7b3295f6e4$var$convertElementAttributesToReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("title" /* TITLE */ , props, title)
    ];
};
var $448e9b7b3295f6e4$var$generateTagsAsReactComponent = (type, tags)=>tags.map((tag, i)=>{
        const mappedTag = {
            key: i,
            [$448e9b7b3295f6e4$var$HELMET_ATTRIBUTE]: true
        };
        Object.keys(tag).forEach((attribute)=>{
            const mapped = $448e9b7b3295f6e4$var$REACT_TAG_MAP[attribute];
            const mappedAttribute = mapped || attribute;
            if (mappedAttribute === "innerHTML" /* INNER_HTML */  || mappedAttribute === "cssText" /* CSS_TEXT */ ) {
                const content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(type, mappedTag);
    });
var $448e9b7b3295f6e4$var$getMethodsForTag = (type, tags, encode = true)=>{
    switch(type){
        case "title" /* TITLE */ :
            return {
                toComponent: ()=>$448e9b7b3295f6e4$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes),
                toString: ()=>$448e9b7b3295f6e4$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode)
            };
        case "bodyAttributes" /* BODY */ :
        case "htmlAttributes" /* HTML */ :
            return {
                toComponent: ()=>$448e9b7b3295f6e4$var$convertElementAttributesToReactProps(tags),
                toString: ()=>$448e9b7b3295f6e4$var$generateElementAttributesAsString(tags)
            };
        default:
            return {
                toComponent: ()=>$448e9b7b3295f6e4$var$generateTagsAsReactComponent(type, tags),
                toString: ()=>$448e9b7b3295f6e4$var$generateTagsAsString(type, tags, encode)
            };
    }
};
var $448e9b7b3295f6e4$var$getPriorityMethods = ({ metaTags: metaTags, linkTags: linkTags, scriptTags: scriptTags, encode: encode })=>{
    const meta = $448e9b7b3295f6e4$var$prioritizer(metaTags, $448e9b7b3295f6e4$var$SEO_PRIORITY_TAGS.meta);
    const link = $448e9b7b3295f6e4$var$prioritizer(linkTags, $448e9b7b3295f6e4$var$SEO_PRIORITY_TAGS.link);
    const script = $448e9b7b3295f6e4$var$prioritizer(scriptTags, $448e9b7b3295f6e4$var$SEO_PRIORITY_TAGS.script);
    const priorityMethods = {
        toComponent: ()=>[
                ...$448e9b7b3295f6e4$var$generateTagsAsReactComponent("meta" /* META */ , meta.priority),
                ...$448e9b7b3295f6e4$var$generateTagsAsReactComponent("link" /* LINK */ , link.priority),
                ...$448e9b7b3295f6e4$var$generateTagsAsReactComponent("script" /* SCRIPT */ , script.priority)
            ],
        toString: ()=>// generate all the tags as strings and concatenate them
            `${$448e9b7b3295f6e4$var$getMethodsForTag("meta" /* META */ , meta.priority, encode)} ${$448e9b7b3295f6e4$var$getMethodsForTag("link" /* LINK */ , link.priority, encode)} ${$448e9b7b3295f6e4$var$getMethodsForTag("script" /* SCRIPT */ , script.priority, encode)}`
    };
    return {
        priorityMethods: priorityMethods,
        metaTags: meta.default,
        linkTags: link.default,
        scriptTags: script.default
    };
};
var $448e9b7b3295f6e4$var$mapStateOnServer = (props)=>{
    const { baseTag: baseTag, bodyAttributes: bodyAttributes, encode: encode = true, htmlAttributes: htmlAttributes, noscriptTags: noscriptTags, styleTags: styleTags, title: title = "", titleAttributes: titleAttributes, prioritizeSeoTags: prioritizeSeoTags } = props;
    let { linkTags: linkTags, metaTags: metaTags, scriptTags: scriptTags } = props;
    let priorityMethods = {
        toComponent: ()=>[],
        toString: ()=>""
    };
    if (prioritizeSeoTags) ({ priorityMethods: priorityMethods, linkTags: linkTags, metaTags: metaTags, scriptTags: scriptTags } = $448e9b7b3295f6e4$var$getPriorityMethods(props));
    return {
        priority: priorityMethods,
        base: $448e9b7b3295f6e4$var$getMethodsForTag("base" /* BASE */ , baseTag, encode),
        bodyAttributes: $448e9b7b3295f6e4$var$getMethodsForTag("bodyAttributes" /* BODY */ , bodyAttributes, encode),
        htmlAttributes: $448e9b7b3295f6e4$var$getMethodsForTag("htmlAttributes" /* HTML */ , htmlAttributes, encode),
        link: $448e9b7b3295f6e4$var$getMethodsForTag("link" /* LINK */ , linkTags, encode),
        meta: $448e9b7b3295f6e4$var$getMethodsForTag("meta" /* META */ , metaTags, encode),
        noscript: $448e9b7b3295f6e4$var$getMethodsForTag("noscript" /* NOSCRIPT */ , noscriptTags, encode),
        script: $448e9b7b3295f6e4$var$getMethodsForTag("script" /* SCRIPT */ , scriptTags, encode),
        style: $448e9b7b3295f6e4$var$getMethodsForTag("style" /* STYLE */ , styleTags, encode),
        title: $448e9b7b3295f6e4$var$getMethodsForTag("title" /* TITLE */ , {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $448e9b7b3295f6e4$var$server_default = $448e9b7b3295f6e4$var$mapStateOnServer;
// src/HelmetData.ts
var $448e9b7b3295f6e4$var$instances = [];
var $448e9b7b3295f6e4$var$isDocument = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $448e9b7b3295f6e4$export$a9cf6990c9c7feb9 = class {
    instances = [];
    canUseDOM = $448e9b7b3295f6e4$var$isDocument;
    context;
    value = {
        setHelmet: (serverState)=>{
            this.context.helmet = serverState;
        },
        helmetInstances: {
            get: ()=>this.canUseDOM ? $448e9b7b3295f6e4$var$instances : this.instances,
            add: (instance)=>{
                (this.canUseDOM ? $448e9b7b3295f6e4$var$instances : this.instances).push(instance);
            },
            remove: (instance)=>{
                const index = (this.canUseDOM ? $448e9b7b3295f6e4$var$instances : this.instances).indexOf(instance);
                (this.canUseDOM ? $448e9b7b3295f6e4$var$instances : this.instances).splice(index, 1);
            }
        }
    };
    constructor(context, canUseDOM){
        this.context = context;
        this.canUseDOM = canUseDOM || false;
        if (!canUseDOM) context.helmet = $448e9b7b3295f6e4$var$server_default({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
    }
};
var $448e9b7b3295f6e4$var$major = parseInt((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).version.split(".")[0], 10);
var $448e9b7b3295f6e4$var$isReact19 = $448e9b7b3295f6e4$var$major >= 19;
// src/Provider.tsx
var $448e9b7b3295f6e4$var$defaultValue = {};
var $448e9b7b3295f6e4$var$Context = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext($448e9b7b3295f6e4$var$defaultValue);
var $448e9b7b3295f6e4$export$4719288a8f5f7e71 = class _HelmetProvider extends (0, $5FkrB.Component) {
    static canUseDOM = $448e9b7b3295f6e4$var$isDocument;
    helmetData;
    constructor(props){
        super(props);
        if ($448e9b7b3295f6e4$var$isReact19) this.helmetData = null;
        else this.helmetData = new $448e9b7b3295f6e4$export$a9cf6990c9c7feb9(this.props.context || {}, _HelmetProvider.canUseDOM);
    }
    render() {
        if ($448e9b7b3295f6e4$var$isReact19) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, this.props.children);
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($448e9b7b3295f6e4$var$Context.Provider, {
            value: this.helmetData.value
        }, this.props.children);
    }
};
// src/client.ts
var $448e9b7b3295f6e4$var$updateTags = (type, tags)=>{
    const headElement = document.head || document.querySelector("head" /* HEAD */ );
    const tagNodes = headElement.querySelectorAll(`${type}[${$448e9b7b3295f6e4$var$HELMET_ATTRIBUTE}]`);
    const oldTags = [].slice.call(tagNodes);
    const newTags = [];
    let indexToDelete;
    if (tags && tags.length) tags.forEach((tag)=>{
        const newElement = document.createElement(type);
        for(const attribute in tag)if (Object.prototype.hasOwnProperty.call(tag, attribute)) {
            if (attribute === "innerHTML" /* INNER_HTML */ ) newElement.innerHTML = tag.innerHTML;
            else if (attribute === "cssText" /* CSS_TEXT */ ) {
                const cssText = tag.cssText;
                newElement.appendChild(document.createTextNode(cssText));
            } else {
                const attr = attribute;
                const value = typeof tag[attr] === "undefined" ? "" : tag[attr];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($448e9b7b3295f6e4$var$HELMET_ATTRIBUTE, "true");
        if (oldTags.some((existingTag, index)=>{
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach((tag)=>tag.parentNode?.removeChild(tag));
    newTags.forEach((tag)=>headElement.appendChild(tag));
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $448e9b7b3295f6e4$var$updateAttributes = (tagName, attributes)=>{
    const elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    const helmetAttributeString = elementTag.getAttribute($448e9b7b3295f6e4$var$HELMET_ATTRIBUTE);
    const helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    const attributesToRemove = [
        ...helmetAttributes
    ];
    const attributeKeys = Object.keys(attributes);
    for (const attribute of attributeKeys){
        const value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        const indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(let i = attributesToRemove.length - 1; i >= 0; i -= 1)elementTag.removeAttribute(attributesToRemove[i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($448e9b7b3295f6e4$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($448e9b7b3295f6e4$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($448e9b7b3295f6e4$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $448e9b7b3295f6e4$var$updateTitle = (title, attributes)=>{
    if (typeof title !== "undefined" && document.title !== title) document.title = $448e9b7b3295f6e4$var$flattenArray(title);
    $448e9b7b3295f6e4$var$updateAttributes("title" /* TITLE */ , attributes);
};
var $448e9b7b3295f6e4$var$commitTagChanges = (newState, cb)=>{
    const { baseTag: baseTag, bodyAttributes: bodyAttributes, htmlAttributes: htmlAttributes, linkTags: linkTags, metaTags: metaTags, noscriptTags: noscriptTags, onChangeClientState: onChangeClientState, scriptTags: scriptTags, styleTags: styleTags, title: title, titleAttributes: titleAttributes } = newState;
    $448e9b7b3295f6e4$var$updateAttributes("body" /* BODY */ , bodyAttributes);
    $448e9b7b3295f6e4$var$updateAttributes("html" /* HTML */ , htmlAttributes);
    $448e9b7b3295f6e4$var$updateTitle(title, titleAttributes);
    const tagUpdates = {
        baseTag: $448e9b7b3295f6e4$var$updateTags("base" /* BASE */ , baseTag),
        linkTags: $448e9b7b3295f6e4$var$updateTags("link" /* LINK */ , linkTags),
        metaTags: $448e9b7b3295f6e4$var$updateTags("meta" /* META */ , metaTags),
        noscriptTags: $448e9b7b3295f6e4$var$updateTags("noscript" /* NOSCRIPT */ , noscriptTags),
        scriptTags: $448e9b7b3295f6e4$var$updateTags("script" /* SCRIPT */ , scriptTags),
        styleTags: $448e9b7b3295f6e4$var$updateTags("style" /* STYLE */ , styleTags)
    };
    const addedTags = {};
    const removedTags = {};
    Object.keys(tagUpdates).forEach((tagType)=>{
        const { newTags: newTags, oldTags: oldTags } = tagUpdates[tagType];
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    if (cb) cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $448e9b7b3295f6e4$var$_helmetCallback = null;
var $448e9b7b3295f6e4$var$handleStateChangeOnClient = (newState)=>{
    if ($448e9b7b3295f6e4$var$_helmetCallback) cancelAnimationFrame($448e9b7b3295f6e4$var$_helmetCallback);
    if (newState.defer) $448e9b7b3295f6e4$var$_helmetCallback = requestAnimationFrame(()=>{
        $448e9b7b3295f6e4$var$commitTagChanges(newState, ()=>{
            $448e9b7b3295f6e4$var$_helmetCallback = null;
        });
    });
    else {
        $448e9b7b3295f6e4$var$commitTagChanges(newState);
        $448e9b7b3295f6e4$var$_helmetCallback = null;
    }
};
var $448e9b7b3295f6e4$var$client_default = $448e9b7b3295f6e4$var$handleStateChangeOnClient;
// src/Dispatcher.tsx
var $448e9b7b3295f6e4$var$HelmetDispatcher = class extends (0, $5FkrB.Component) {
    rendered = false;
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($12b11248680fdff3$exports)))(nextProps, this.props);
    }
    componentDidUpdate() {
        this.emitChange();
    }
    componentWillUnmount() {
        const { helmetInstances: helmetInstances } = this.props.context;
        helmetInstances.remove(this);
        this.emitChange();
    }
    emitChange() {
        const { helmetInstances: helmetInstances, setHelmet: setHelmet } = this.props.context;
        let serverState = null;
        const state = $448e9b7b3295f6e4$var$reducePropsToState(helmetInstances.get().map((instance)=>{
            const { context: _context, ...props } = instance.props;
            return props;
        }));
        if ($448e9b7b3295f6e4$export$4719288a8f5f7e71.canUseDOM) $448e9b7b3295f6e4$var$client_default(state);
        else if ($448e9b7b3295f6e4$var$server_default) serverState = $448e9b7b3295f6e4$var$server_default(state);
        setHelmet(serverState);
    }
    // componentWillMount will be deprecated
    // for SSR, initialize on first render
    // constructor is also unsafe in StrictMode
    init() {
        if (this.rendered) return;
        this.rendered = true;
        const { helmetInstances: helmetInstances } = this.props.context;
        helmetInstances.add(this);
        this.emitChange();
    }
    render() {
        this.init();
        return null;
    }
};
var $448e9b7b3295f6e4$var$react19Instances = [];
var $448e9b7b3295f6e4$var$toHtmlAttributes = (props)=>{
    const result = {};
    for (const key of Object.keys(props))result[$448e9b7b3295f6e4$var$HTML_TAG_MAP[key] || key] = props[key];
    return result;
};
var $448e9b7b3295f6e4$var$toReactProps = (attrs)=>{
    const result = {};
    for (const key of Object.keys(attrs)){
        const mapped = $448e9b7b3295f6e4$var$REACT_TAG_MAP[key];
        result[mapped || key] = attrs[key];
    }
    return result;
};
var $448e9b7b3295f6e4$var$applyAttributes = (tagName, attributes)=>{
    if (!$448e9b7b3295f6e4$var$isDocument) return;
    const el = document.getElementsByTagName(tagName)[0];
    if (!el) return;
    const managedAttr = "data-rh-managed";
    const prev = el.getAttribute(managedAttr);
    const prevKeys = prev ? prev.split(",") : [];
    const nextKeys = Object.keys(attributes);
    for (const key of prevKeys)if (!nextKeys.includes(key)) el.removeAttribute(key);
    for (const key of nextKeys){
        const value = attributes[key];
        if (value === void 0 || value === null || value === false) el.removeAttribute(key);
        else if (value === true) el.setAttribute(key, "");
        else el.setAttribute(key, String(value));
    }
    if (nextKeys.length > 0) el.setAttribute(managedAttr, nextKeys.join(","));
    else el.removeAttribute(managedAttr);
};
var $448e9b7b3295f6e4$var$syncAllAttributes = ()=>{
    const htmlAttrs = {};
    const bodyAttrs = {};
    for (const instance of $448e9b7b3295f6e4$var$react19Instances){
        const { htmlAttributes: htmlAttributes, bodyAttributes: bodyAttributes } = instance.props;
        if (htmlAttributes) Object.assign(htmlAttrs, $448e9b7b3295f6e4$var$toHtmlAttributes(htmlAttributes));
        if (bodyAttributes) Object.assign(bodyAttrs, $448e9b7b3295f6e4$var$toHtmlAttributes(bodyAttributes));
    }
    $448e9b7b3295f6e4$var$applyAttributes("html" /* HTML */ , htmlAttrs);
    $448e9b7b3295f6e4$var$applyAttributes("body" /* BODY */ , bodyAttrs);
};
var $448e9b7b3295f6e4$var$React19Dispatcher = class extends (0, $5FkrB.Component) {
    componentDidMount() {
        $448e9b7b3295f6e4$var$react19Instances.push(this);
        $448e9b7b3295f6e4$var$syncAllAttributes();
    }
    componentDidUpdate() {
        $448e9b7b3295f6e4$var$syncAllAttributes();
    }
    componentWillUnmount() {
        const index = $448e9b7b3295f6e4$var$react19Instances.indexOf(this);
        if (index !== -1) $448e9b7b3295f6e4$var$react19Instances.splice(index, 1);
        $448e9b7b3295f6e4$var$syncAllAttributes();
    }
    resolveTitle() {
        const { title: title, titleTemplate: titleTemplate, defaultTitle: defaultTitle } = this.props;
        if (title && titleTemplate) return titleTemplate.replace(/%s/g, ()=>Array.isArray(title) ? title.join("") : title);
        return title || defaultTitle || void 0;
    }
    renderTitle() {
        const title = this.resolveTitle();
        if (title === void 0) return null;
        const titleAttributes = this.props.titleAttributes || {};
        return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("title" /* TITLE */ , $448e9b7b3295f6e4$var$toReactProps(titleAttributes), title);
    }
    renderBase() {
        const { base: base } = this.props;
        if (!base) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("base" /* BASE */ , $448e9b7b3295f6e4$var$toReactProps(base));
    }
    renderMeta() {
        const { meta: meta } = this.props;
        if (!meta || !Array.isArray(meta)) return null;
        return meta.map((attrs, i)=>(0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("meta" /* META */ , {
                key: i,
                ...$448e9b7b3295f6e4$var$toReactProps(attrs)
            }));
    }
    renderLink() {
        const { link: link } = this.props;
        if (!link || !Array.isArray(link)) return null;
        return link.map((attrs, i)=>(0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("link" /* LINK */ , {
                key: i,
                ...$448e9b7b3295f6e4$var$toReactProps(attrs)
            }));
    }
    renderScript() {
        const { script: script } = this.props;
        if (!script || !Array.isArray(script)) return null;
        return script.map((attrs, i)=>{
            const { innerHTML: innerHTML, ...rest } = attrs;
            const props = $448e9b7b3295f6e4$var$toReactProps(rest);
            if (innerHTML) props.dangerouslySetInnerHTML = {
                __html: innerHTML
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("script" /* SCRIPT */ , {
                key: i,
                ...props
            });
        });
    }
    renderStyle() {
        const { style: style } = this.props;
        if (!style || !Array.isArray(style)) return null;
        return style.map((attrs, i)=>{
            const { cssText: cssText, ...rest } = attrs;
            const props = $448e9b7b3295f6e4$var$toReactProps(rest);
            if (cssText) props.dangerouslySetInnerHTML = {
                __html: cssText
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("style" /* STYLE */ , {
                key: i,
                ...props
            });
        });
    }
    renderNoscript() {
        const { noscript: noscript } = this.props;
        if (!noscript || !Array.isArray(noscript)) return null;
        return noscript.map((attrs, i)=>{
            const { innerHTML: innerHTML, ...rest } = attrs;
            const props = $448e9b7b3295f6e4$var$toReactProps(rest);
            if (innerHTML) props.dangerouslySetInnerHTML = {
                __html: innerHTML
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("noscript" /* NOSCRIPT */ , {
                key: i,
                ...props
            });
        });
    }
    render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, this.renderTitle(), this.renderBase(), this.renderMeta(), this.renderLink(), this.renderScript(), this.renderStyle(), this.renderNoscript());
    }
};
// src/index.tsx
var $448e9b7b3295f6e4$export$dcef8f9bb9a41431 = class extends (0, $5FkrB.Component) {
    static defaultProps = {
        defer: true,
        encodeSpecialCharacters: true,
        prioritizeSeoTags: false
    };
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($dcrmD)))($448e9b7b3295f6e4$var$without(this.props, "helmetData"), $448e9b7b3295f6e4$var$without(nextProps, "helmetData"));
    }
    mapNestedChildrenToProps(child, nestedChildren) {
        if (!nestedChildren) return null;
        switch(child.type){
            case "script" /* SCRIPT */ :
            case "noscript" /* NOSCRIPT */ :
                return {
                    innerHTML: nestedChildren
                };
            case "style" /* STYLE */ :
                return {
                    cssText: nestedChildren
                };
            default:
                throw new Error(`<${child.type} /> elements are self-closing and can not contain children. Refer to our API for more information.`);
        }
    }
    flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren) {
        return {
            ...arrayTypeChildren,
            [child.type]: [
                ...arrayTypeChildren[child.type] || [],
                {
                    ...newChildProps,
                    ...this.mapNestedChildrenToProps(child, nestedChildren)
                }
            ]
        };
    }
    mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren) {
        switch(child.type){
            case "title" /* TITLE */ :
                return {
                    ...newProps,
                    [child.type]: nestedChildren,
                    titleAttributes: {
                        ...newChildProps
                    }
                };
            case "body" /* BODY */ :
                return {
                    ...newProps,
                    bodyAttributes: {
                        ...newChildProps
                    }
                };
            case "html" /* HTML */ :
                return {
                    ...newProps,
                    htmlAttributes: {
                        ...newChildProps
                    }
                };
            default:
                return {
                    ...newProps,
                    [child.type]: {
                        ...newChildProps
                    }
                };
        }
    }
    mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
        let newFlattenedProps = {
            ...newProps
        };
        Object.keys(arrayTypeChildren).forEach((arrayChildName)=>{
            newFlattenedProps = {
                ...newFlattenedProps,
                [arrayChildName]: arrayTypeChildren[arrayChildName]
            };
        });
        return newFlattenedProps;
    }
    warnOnInvalidChildren(child, nestedChildren) {
        (0, (/*@__PURE__*/$parcel$interopDefault($jSI6G)))($448e9b7b3295f6e4$var$VALID_TAG_NAMES.some((name)=>child.type === name), typeof child.type === "function" ? `You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.` : `Only elements types ${$448e9b7b3295f6e4$var$VALID_TAG_NAMES.join(", ")} are allowed. Helmet does not support rendering <${child.type}> elements. Refer to our API for more information.`);
        (0, (/*@__PURE__*/$parcel$interopDefault($jSI6G)))(!nestedChildren || typeof nestedChildren === "string" || Array.isArray(nestedChildren) && !nestedChildren.some((nestedChild)=>typeof nestedChild !== "string"), `Helmet expects a string as a child of <${child.type}>. Did you forget to wrap your children in braces? ( <${child.type}>{\`\`}</${child.type}> ) Refer to our API for more information.`);
        return true;
    }
    mapChildrenToProps(children, newProps) {
        let arrayTypeChildren = {};
        (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.forEach(children, (child)=>{
            if (!child || !child.props) return;
            const { children: nestedChildren, ...childProps } = child.props;
            const newChildProps = Object.keys(childProps).reduce((obj, key)=>{
                obj[$448e9b7b3295f6e4$var$HTML_TAG_MAP[key] || key] = childProps[key];
                return obj;
            }, {});
            let { type: type } = child;
            if (typeof type === "symbol") type = type.toString();
            else this.warnOnInvalidChildren(child, nestedChildren);
            switch(type){
                case "Symbol(react.fragment)" /* FRAGMENT */ :
                    newProps = this.mapChildrenToProps(nestedChildren, newProps);
                    break;
                case "link" /* LINK */ :
                case "meta" /* META */ :
                case "noscript" /* NOSCRIPT */ :
                case "script" /* SCRIPT */ :
                case "style" /* STYLE */ :
                    arrayTypeChildren = this.flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren);
                    break;
                default:
                    newProps = this.mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren);
                    break;
            }
        });
        return this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
    }
    render() {
        const { children: children, ...props } = this.props;
        let newProps = {
            ...props
        };
        let { helmetData: helmetData } = props;
        if (children) newProps = this.mapChildrenToProps(children, newProps);
        if (helmetData && !(helmetData instanceof $448e9b7b3295f6e4$export$a9cf6990c9c7feb9)) {
            const data = helmetData;
            helmetData = new $448e9b7b3295f6e4$export$a9cf6990c9c7feb9(data.context, true);
            delete newProps.helmetData;
        }
        if ($448e9b7b3295f6e4$var$isReact19) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($448e9b7b3295f6e4$var$React19Dispatcher, {
            ...newProps
        });
        return helmetData ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($448e9b7b3295f6e4$var$HelmetDispatcher, {
            ...newProps,
            context: helmetData.value
        }) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($448e9b7b3295f6e4$var$Context.Consumer, null, (context)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($448e9b7b3295f6e4$var$HelmetDispatcher, {
                ...newProps,
                context: context
            }));
    }
};




var $4Pn6z = parcelRequire("4Pn6z");
var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $gDiFE = parcelRequire("gDiFE");

var $2kuK2 = parcelRequire("2kuK2");
var $c8dbef6c41cfa689$var$flexGrowMap = {
    hug: (0, $gDiFE.xcss)({
        flexGrow: 0
    }),
    fill: (0, $gDiFE.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
var $c8dbef6c41cfa689$export$694e0d28c7ffc90c = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role, id = _ref.id;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $c8dbef6c41cfa689$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $74Zh5.jsx)((0, $2kuK2.Flex), {
        id: id,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$c8dbef6c41cfa689$export$694e0d28c7ffc90c.displayName = 'Stack';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$c8dbef6c41cfa689$export$2e2bcd8739ae039 = $c8dbef6c41cfa689$export$694e0d28c7ffc90c;


var $ifpPH = parcelRequire("ifpPH");
var $gDiFE = parcelRequire("gDiFE");

var $bb0Oq = parcelRequire("bb0Oq");
/* tabs.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $25nEq = parcelRequire("25nEq");

var $2BL4q = parcelRequire("2BL4q");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $aLEtb = parcelRequire("aLEtb");
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5FkrB = parcelRequire("5FkrB");
var $1b23a6d8f9b96f86$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5FkrB = parcelRequire("5FkrB");
var $105b2b73664cf5fe$export$2054129d247c3102 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $f4929bb9d46c4aaa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f4929bb9d46c4aaa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f4929bb9d46c4aaa$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f4929bb9d46c4aaa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f4929bb9d46c4aaa$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $f4929bb9d46c4aaa$var$baseStyles = null;
var $f4929bb9d46c4aaa$var$tabsStyles = null;
var $f4929bb9d46c4aaa$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "@atlaskit/tabs",
    packageVersion: "21.2.1"
};
var $f4929bb9d46c4aaa$var$getTabPanelWithContext = function getTabPanelWithContext(_ref) {
    var tabPanel = _ref.tabPanel, index = _ref.index, isSelected = _ref.isSelected, tabsId = _ref.tabsId;
    return(// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ $5FkrB.createElement((0, $105b2b73664cf5fe$export$2054129d247c3102).Provider, {
        value: {
            role: 'tabpanel',
            id: "".concat(tabsId, "-").concat(index, "-tab"),
            hidden: isSelected ? undefined : true,
            'aria-labelledby': "".concat(tabsId, "-").concat(index),
            tabIndex: isSelected ? 0 : -1
        },
        key: index
    }, tabPanel));
};
/**
 * __Tabs__
 *
 * Tabs acts as a container for all Tab components.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $f4929bb9d46c4aaa$var$Tabs = function Tabs(props) {
    var _props$shouldUnmountT = props.shouldUnmountTabPanelOnChange, shouldUnmountTabPanelOnChange = _props$shouldUnmountT === void 0 ? false : _props$shouldUnmountT, SelectedType = props.selected, defaultSelected = props.defaultSelected, onChangeProp = props.onChange, id = props.id, analyticsContext = props.analyticsContext, children = props.children, testId = props.testId;
    var _useState = (0, $5FkrB.useState)(SelectedType || defaultSelected || 0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), selectedState = _useState2[0], setSelected = _useState2[1];
    var selected = SelectedType === undefined ? selectedState : SelectedType;
    var childrenArray = (0, $5FkrB.Children).toArray(children)// Don't include any conditional children
    .filter(function(child) {
        return Boolean(child);
    });
    // First child should be a tabList followed by tab panels
    var _childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($2BL4q)))(childrenArray), tabList = _childrenArray[0], tabPanels = $f4929bb9d46c4aaa$var$_arrayLikeToArray(_childrenArray).slice(1);
    // Keep track of visited and add to a set
    var visited = (0, $5FkrB.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    var onChange = (0, $5FkrB.useCallback)(function(index, analyticsEvent) {
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    var onChangeAnalytics = (0, $aLEtb.usePlatformLeafEventHandler)($f4929bb9d46c4aaa$var$_objectSpread({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext
    }, $f4929bb9d46c4aaa$var$analyticsAttributes));
    var tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $f4929bb9d46c4aaa$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map(function(tabIndex) {
        return $f4929bb9d46c4aaa$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        });
    });
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": testId,
        className: (0, $970q7.default)([
            "_1e0c1txw _p12f1osq _1tkeidpf _i0dl1osq _2lx21bp4 _16jlkb7n",
            "_1c3y1txw _ftfaidpf _18i0kb7n _185bglyw"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $1b23a6d8f9b96f86$export$aa6907f9fd69e93b).Provider, {
        value: {
            selected: selected,
            onChange: onChangeAnalytics,
            tabsId: id
        }
    }, tabList), /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, tabPanelsWithContext));
};
var $f4929bb9d46c4aaa$export$2e2bcd8739ae039 = $f4929bb9d46c4aaa$var$Tabs;


var $5FkrB = parcelRequire("5FkrB");

var $5yoeA = parcelRequire("5yoeA");
var $72GAO = parcelRequire("72GAO");

var $5FkrB = parcelRequire("5FkrB");
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5FkrB = parcelRequire("5FkrB");
var $72410aac6635c6c0$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $62881b5e01ed5a8e$export$2e2bcd8739ae039() {
    var tabData = (0, $5FkrB.useContext)((0, $72410aac6635c6c0$export$5a5d356ca5f10a0a));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
}


/**
 * __Tab__
 *
 * Tab represents an individual Tab displayed in a TabList.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $e23e17c0c75104db$var$Tab = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function Tab(_ref, ref) {
    var children = _ref.children, testId = _ref.testId;
    var _useTab = (0, $62881b5e01ed5a8e$export$2e2bcd8739ae039)(), onClick = _useTab.onClick, id = _useTab.id, ariaControls = _useTab['aria-controls'], ariaPosinset = _useTab['aria-posinset'], ariaSelected = _useTab['aria-selected'], ariaSetsize = _useTab['aria-setsize'], onKeyDown = _useTab.onKeyDown, role = _useTab.role, tabIndex = _useTab.tabIndex;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5yoeA.Focusable), {
        as: "div",
        isInset: true,
        testId: testId,
        onClick: onClick,
        id: id,
        "aria-controls": ariaControls,
        "aria-posinset": ariaPosinset,
        "aria-selected": ariaSelected,
        "aria-setsize": ariaSetsize,
        onKeyDown: onKeyDown,
        role: role,
        tabIndex: tabIndex,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $72GAO.Text), {
        weight: "medium",
        color: "inherit",
        maxLines: 1
    }, children));
});
var $e23e17c0c75104db$export$2e2bcd8739ae039 = $e23e17c0c75104db$var$Tab;

/* tab-list.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");


var $5FkrB = parcelRequire("5FkrB");

function $6c8e7e396623eae7$export$2e2bcd8739ae039() {
    var tabListData = (0, $5FkrB.useContext)((0, $1b23a6d8f9b96f86$export$aa6907f9fd69e93b));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
}


var $62b7beffa12a0bc3$var$baseStyles = null;
var $62b7beffa12a0bc3$var$tabListStyles = null;
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $62b7beffa12a0bc3$var$TabList = function TabList(_ref) {
    var children = _ref.children;
    var _useTabList = (0, $6c8e7e396623eae7$export$2e2bcd8739ae039)(), tabsId = _useTabList.tabsId, selected = _useTabList.selected, onChange = _useTabList.onChange;
    var ref = /*#__PURE__*/ (0, $5FkrB.createRef)();
    // Don't include any conditional children
    var childrenArray = (0, $5FkrB.Children).toArray(children).filter(Boolean);
    var length = childrenArray.length;
    var selectTabByIndex = (0, $5FkrB.useCallback)(function(index) {
        var _ref$current;
        var newSelectedNode = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.querySelector("[id='".concat(tabsId, "-").concat(index, "']"));
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        var lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            var _newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(_newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        var selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        var modifier = e.key === 'ArrowRight' ? 1 : -1;
        var newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    var getTabWithContext = (0, $5FkrB.useCallback)(function(_ref2) {
        var tab = _ref2.tab, isSelected = _ref2.isSelected, index = _ref2.index;
        return /*#__PURE__*/ $5FkrB.createElement((0, $72410aac6635c6c0$export$5a5d356ca5f10a0a).Provider, {
            value: {
                onClick: function onClick() {
                    return onChange(index);
                },
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: "".concat(tabsId, "-").concat(index),
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': "".concat(tabsId, "-").concat(index, "-tab"),
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tab);
    }, [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        role: "tablist",
        ref: ref,
        className: (0, $970q7.default)([
            "_1e0c1txw _kqswh2mm _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _qwyt1qi0 _7hip15vq _1fud15vq _bb0mh2mm _1quzazsu _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _1lzu1uh4 _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazazsu _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1b8d1uh4 _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i20i7uo _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _rsmzz0c1 _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem6x5g _ipw1z0c1 _gmk66x5g _pascidpf _eid3idpf _zr3eidpf _fntnidpf _1mp41kw7 _kfgte4h9 _1cs8stnw _1rus1l7x _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc"
        ])
    }, childrenArray.map(function(child, index) {
        return getTabWithContext({
            tab: child,
            index: index,
            isSelected: index === selected
        });
    }));
};
var $62b7beffa12a0bc3$export$2e2bcd8739ae039 = $62b7beffa12a0bc3$var$TabList;


var $5FkrB = parcelRequire("5FkrB");

var $5yoeA = parcelRequire("5yoeA");

var $5FkrB = parcelRequire("5FkrB");

function $33cc981e165181ff$export$2e2bcd8739ae039() {
    var tabPanelData = (0, $5FkrB.useContext)((0, $105b2b73664cf5fe$export$2054129d247c3102));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
}


// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $9620d31b6d3b6773$var$TabPanel = function TabPanel(_ref) {
    var children = _ref.children, testId = _ref.testId;
    var _useTabPanel = (0, $33cc981e165181ff$export$2e2bcd8739ae039)(), role = _useTabPanel.role, id = _useTabPanel.id, hidden = _useTabPanel.hidden, ariaLabelledBy = _useTabPanel['aria-labelledby'], tabIndex = _useTabPanel.tabIndex;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5yoeA.Focusable), {
        as: "div",
        isInset: true,
        testId: testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        tabIndex: tabIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, children));
};
var $9620d31b6d3b6773$export$2e2bcd8739ae039 = $9620d31b6d3b6773$var$TabPanel;


/**
 * URL route constants for the App Updates application
 */ const $749a6437bd4ec017$export$cd891b82501bb412 = {
    /**
   * Base route for the app updates list page (the "All changes" tab)
   */ RELEASE_NOTES: '/release-notes',
    /**
   * Route for the app updates list page with the "Release tracks changes" tab active
   */ RELEASE_TRACKS_CHANGES: '/release-notes/release-tracks-changes',
    /**
   * Legacy route for the Release tracks changes tab. Keep this redirect path
   * working for existing customer links.
   */ LEGACY_BUNDLED_CHANGES: '/release-notes/bundled-changes',
    /**
   * Route for app update details page
   * @param id - The update ID
   * @returns The complete route path
   */ RELEASE_NOTE_DETAILS: (id)=>`/release-notes/${id}`
};





var $ifpPH = parcelRequire("ifpPH");
/* section-message.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $5yfDB = parcelRequire("5yfDB");
/* heading.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $a3VXv = parcelRequire("a3VXv");

var $99N5z = parcelRequire("99N5z");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $d5feb91794df3429$export$d1fa8a19e192bc63 = /*#__PURE__*/ (0, $5FkrB.createContext)(0);


var $2576bf3f3605e1db$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $5FkrB.useContext)((0, $d5feb91794df3429$export$d1fa8a19e192bc63));
};


var $e36faaa305cb62b6$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = (0, $2576bf3f3605e1db$export$6a64a1e2d0bbbf75)();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : "h".concat(hLevel)) || fallback
    ];
};



var $3ZMUU = parcelRequire("3ZMUU");
var $3125392203c599f4$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $3125392203c599f4$var$styles = {
    reset: "_dxsyidpf _1i144jg8 _nmk4glyw"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $3125392203c599f4$var$headingColorStyles = {
    'color.text': "_1w90i7uo",
    'color.text.inverse': "_1w9015cr",
    'color.text.warning.inverse': "_1w901yd3"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $3125392203c599f4$var$headingSizeStyles = {
    xxlarge: "_fqox1iff",
    xlarge: "_fqox12ln",
    large: "_fqox10sd",
    medium: "_fqox1af2",
    small: "_fqox1e3o",
    xsmall: "_fqox1qyo",
    xxsmall: "_fqoxi4vh"
};
/**
 * @codegenEnd
 */ var $3125392203c599f4$var$useColor = function useColor(colorProp) {
    var surface = (0, $99N5z.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $a3VXv.inverseColorMap).hasOwnProperty(surface)) return (0, $a3VXv.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $3125392203c599f4$var$Heading = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    typeof $3ZMUU;
    var _useHeading = (0, $e36faaa305cb62b6$export$97a37b1befbbf9b1)($3125392203c599f4$var$sizeTagMap[size]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === 'div' && hLevel;
    var color = $3125392203c599f4$var$useColor(colorProp);
    return /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $970q7.default)([
            $3125392203c599f4$var$styles.reset,
            $3125392203c599f4$var$headingSizeStyles[size],
            $3125392203c599f4$var$headingColorStyles[color]
        ])
    }, children);
});
var $3125392203c599f4$export$2e2bcd8739ae039 = $3125392203c599f4$var$Heading;



var $ac8VW = parcelRequire("ac8VW");

var $m5IEn = parcelRequire("m5IEn");
var $9FlpM = parcelRequire("9FlpM");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");
var $98c07db38382dc18$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9aea886ae883664b6f933ff09352e51d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($98c07db38382dc18$exports, "__esModule", {
    value: true
});
$98c07db38382dc18$exports.default = void 0;

var $98c07db38382dc18$var$_react = $98c07db38382dc18$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $98c07db38382dc18$var$_iconNew = $98c07db38382dc18$var$_interopRequireDefault((parcelRequire("gDzom")));
function $98c07db38382dc18$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusDiscovery".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-discovery
 * Usage guidance:
 * Reserved for discovery statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $98c07db38382dc18$var$StatusDiscoveryIcon = (props)=>/*#__PURE__*/ $98c07db38382dc18$var$_react.default.createElement($98c07db38382dc18$var$_iconNew.default, Object.assign({
        name: "StatusDiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10.5 15.06v-3.81a.75.75 0 0 1 .75-.75h3.81z"/><path fill="currentcolor" fill-rule="evenodd" d="M13 1a2 2 0 0 1 2 2v6h-4.75C9.56 9 9 9.56 9 10.25V15H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM4 9h3V7.5H4zm0-5v1.5h7V4z" clip-rule="evenodd"/>`
    }, props));
$98c07db38382dc18$var$StatusDiscoveryIcon.displayName = 'StatusDiscoveryIcon';
var $98c07db38382dc18$var$_default = $98c07db38382dc18$exports.default = $98c07db38382dc18$var$StatusDiscoveryIcon;



var $cMVCI = parcelRequire("cMVCI");

var $7bxOu = parcelRequire("7bxOu");

var $lcW9s = parcelRequire("lcW9s");

var $lNKbd = parcelRequire("lNKbd");
function $321e0bf4d8386b43$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $321e0bf4d8386b43$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $321e0bf4d8386b43$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $321e0bf4d8386b43$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $321e0bf4d8386b43$var$appearanceIconSchema = {
    information: {
        backgroundColor: "var(--ds-background-information, #E9F2FE)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7bxOu))),
        primaryIconColor: "var(--ds-icon-information, #357DE8)"
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, #FFF5DB)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lNKbd))),
        primaryIconColor: "var(--ds-icon-warning, #E06C00)"
    },
    error: {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($cMVCI))),
        primaryIconColor: "var(--ds-icon-danger, #C9372C)"
    },
    success: {
        backgroundColor: "var(--ds-background-success, #EFFFD6)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lcW9s))),
        primaryIconColor: "var(--ds-icon-success, #6A9A23)"
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, #F8EEFE)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($98c07db38382dc18$exports))),
        primaryIconColor: "var(--ds-icon-discovery, #AF59E1)"
    }
};
function $321e0bf4d8386b43$export$e9b82d2e21ac0c1f(appearance, icon) {
    var appearanceIconStyles = $321e0bf4d8386b43$var$appearanceIconSchema[appearance] || $321e0bf4d8386b43$var$appearanceIconSchema.information;
    var AppearanceIcon = function AppearanceIcon(_ref) {
        var primaryColor = _ref.primaryColor;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(appearanceIconStyles.Icon, {
            color: primaryColor,
            spacing: "spacious",
            label: appearance
        });
    };
    var Icon = icon || AppearanceIcon;
    return $321e0bf4d8386b43$var$_objectSpread($321e0bf4d8386b43$var$_objectSpread({}, appearanceIconStyles), {}, {
        Icon: Icon
    });
}


var $ac2404b057b8688e$var$sectionMessageStyles = {
    container: "_2rko1mok _1rjcpxbi _18zrpxbi _1nmz1hna",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c8fhey _syazi7uo",
    actionsContainer: "_11c8fhey",
    dismissButtonContainer: "_1pfh1i6y"
};
var $ac2404b057b8688e$var$appearanceStyles = {
    information: "_bfhk19ip",
    warning: "_bfhk1917",
    error: "_bfhk1gly",
    success: "_bfhk1y9u",
    discovery: "_bfhk6vm6"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ var $ac2404b057b8688e$var$SectionMessage = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'information' : _ref$appearance, actions = _ref.actions, title = _ref.title, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 'h2' : _ref$headingLevel, icon = _ref.icon, isDismissible = _ref.isDismissible, onDismiss = _ref.onDismiss, testId = _ref.testId;
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), dismissed = _useState2[0], setDismissed = _useState2[1];
    var handleDismiss = (0, $5FkrB.useCallback)(function() {
        onDismiss === null || onDismiss === void 0 || onDismiss();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    var _getAppearanceIconSty = (0, $321e0bf4d8386b43$export$e9b82d2e21ac0c1f)(appearance, icon), primaryColor = _getAppearanceIconSty.primaryIconColor, secondaryColor = _getAppearanceIconSty.backgroundColor, Icon = _getAppearanceIconSty.Icon;
    var actionElements = actions && actions.type === (0, $5FkrB.Fragment) ? actions.props.children : actions;
    var actionsArray = (0, $5FkrB.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ $5FkrB.createElement("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $970q7.default)([
            $ac2404b057b8688e$var$sectionMessageStyles.container,
            $ac2404b057b8688e$var$appearanceStyles[appearance]
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $m5IEn.Inline), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            $ac2404b057b8688e$var$sectionMessageStyles.iconContainer
        ])
    }, /*#__PURE__*/ $5FkrB.createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        color: primaryColor,
        spacing: "spacious"
    })), /*#__PURE__*/ $5FkrB.createElement((0, $9FlpM.Stack), {
        space: "space.100",
        testId: testId && "".concat(testId, "--content"),
        xcss: $ac2404b057b8688e$var$sectionMessageStyles.contentContainer
    }, !!title && /*#__PURE__*/ $5FkrB.createElement((0, $3125392203c599f4$export$2e2bcd8739ae039), {
        as: headingLevel,
        size: "small"
    }, title), /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            $ac2404b057b8688e$var$sectionMessageStyles.content
        ])
    }, children), actionsArray.length > 0 && /*#__PURE__*/ $5FkrB.createElement((0, $m5IEn.Inline), {
        shouldWrap: true,
        testId: testId && "".concat(testId, "--actions"),
        separator: "\xB7",
        space: "space.100",
        rowSpace: "space.0",
        role: actionsArray.length > 1 ? 'list' : undefined,
        xcss: $ac2404b057b8688e$var$sectionMessageStyles.actionsContainer
    }, actionsArray.map(function(action, id) {
        return(/*#__PURE__*/ // Only use a listitem role if more than one action is present
        $5FkrB.createElement((0, $m5IEn.Inline), {
            role: actionsArray.length > 1 ? 'listitem' : undefined,
            key: id
        }, action));
    }))), isDismissible && /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            $ac2404b057b8688e$var$sectionMessageStyles.dismissButtonContainer
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $5yfDB.default), {
        testId: testId && "".concat(testId, "--dismiss-button"),
        label: "Dismiss",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ac8VW))),
        appearance: "subtle",
        onClick: handleDismiss,
        spacing: "compact"
    }))));
});
$ac2404b057b8688e$var$SectionMessage.displayName = 'SectionMessage';
var $ac2404b057b8688e$export$2e2bcd8739ae039 = $ac2404b057b8688e$var$SectionMessage;

/* section-message-action.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $jgNUw = parcelRequire("jgNUw");

var $hRJ5R = parcelRequire("hRJ5R");

var $8F9hT = parcelRequire("8F9hT");

var $auVZV = parcelRequire("auVZV");
var $btdNC = parcelRequire("btdNC");
var $3fe662b077bc761a$var$styles = {
    common: "_11c8fhey",
    anchor: "_k48pi7a9",
    pressable: "_2rkolb4i _syaz13af _k48p1wq8 _bfhk1j28 _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ var $3fe662b077bc761a$var$SectionMessageAction = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, onClick = _ref.onClick, href = _ref.href, testId = _ref.testId, linkComponent = _ref.linkComponent, target = _ref.target;
    if (!linkComponent) {
        if (href) return /*#__PURE__*/ $5FkrB.createElement("span", {
            className: (0, $970q7.default)([
                $3fe662b077bc761a$var$styles.common,
                $3fe662b077bc761a$var$styles.anchor
            ])
        }, /*#__PURE__*/ $5FkrB.createElement((0, $8F9hT.default), {
            testId: testId,
            onClick: onClick,
            href: href,
            target: target,
            ref: ref
        }, children));
        if (onClick) return /*#__PURE__*/ $5FkrB.createElement((0, $btdNC.Pressable), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $hRJ5R.cx)($3fe662b077bc761a$var$styles.common, $3fe662b077bc761a$var$styles.pressable),
            ref: ref
        }, children);
        return /*#__PURE__*/ $5FkrB.createElement((0, $auVZV.Box), {
            as: "span",
            testId: testId,
            xcss: $3fe662b077bc761a$var$styles.common,
            ref: ref
        }, children);
    }
    // TODO: Remove this once the deprecated `linkComponent` prop is removed.
    return onClick || href ? /*#__PURE__*/ $5FkrB.createElement((0, $jgNUw.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined,
        ref: ref
    }, children) : /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, children);
}));
$3fe662b077bc761a$var$SectionMessageAction.displayName = 'SectionMessageAction';
var $3fe662b077bc761a$export$2e2bcd8739ae039 = $3fe662b077bc761a$var$SectionMessageAction;


const $010bee42faeab737$var$impactMessages = (0, $7e94896e68874ec2$export$1adfeb024f5185b)({
    impactTitle: {
        id: 'app.updates.impact.banner.title',
        defaultMessage: 'Understand change impact at a glance',
        description: 'Title for the impact rating banner on the app updates list page'
    },
    impactBody: {
        id: 'app.updates.impact.banner.body',
        defaultMessage: 'Use the new <strong>Impact</strong> rating to quickly identify how much attention a change may need. Filter release notes by Low, Medium, or High impact to focus on the changes that matter most to your organization.',
        description: 'Introductory text for the impact rating banner on the app updates list page'
    },
    betaDisclaimer: {
        id: 'app.updates.impact.banner.beta.disclaimer',
        defaultMessage: "<strong>Impact ratings are currently in beta.</strong> We\u2019re continuing to improve their accuracy and would love your feedback to help us fine-tune the experience.",
        description: 'Beta disclaimer for impact ratings on the app updates list page'
    },
    impactLink: {
        id: 'app.updates.impact.banner.link',
        defaultMessage: 'Learn more and share feedback',
        description: 'Link text for the impact rating banner on the app updates list page'
    }
});
const $010bee42faeab737$var$IMPACT_RATING_COMMUNITY_POST_URL = 'https://community.atlassian.com/forums/Community-Announcements-articles/A-smarter-way-to-understand-which-Atlassian-Cloud-changes-need/ba-p/3274946';
const $010bee42faeab737$export$92843d20b8ec0118 = ()=>{
    const { formatMessage: formatMessage } = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ac2404b057b8688e$export$2e2bcd8739ae039), {
        appearance: "discovery",
        title: formatMessage($010bee42faeab737$var$impactMessages.impactTitle),
        actions: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $3fe662b077bc761a$export$2e2bcd8739ae039), {
                href: $010bee42faeab737$var$IMPACT_RATING_COMMUNITY_POST_URL,
                target: "_blank",
                children: formatMessage($010bee42faeab737$var$impactMessages.impactLink)
            })
        ],
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
                    children: formatMessage($010bee42faeab737$var$impactMessages.impactBody, {
                        strong: (chunks)=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
                                as: "span",
                                weight: "bold",
                                children: chunks
                            })
                    })
                }),
                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
                    children: formatMessage($010bee42faeab737$var$impactMessages.betaDisclaimer, {
                        strong: (chunks)=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
                                as: "span",
                                weight: "bold",
                                children: chunks
                            })
                    })
                })
            ]
        })
    });
};
var $010bee42faeab737$export$2e2bcd8739ae039 = $010bee42faeab737$export$92843d20b8ec0118;




var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
"use client";
//#region src/IsRestoringProvider.ts
const $fc8ae81a69ed1932$var$IsRestoringContext = $5FkrB.createContext(false);
/**
* If you are using `PersistQueryClientProvider`, you can also use the `useIsRestoring` hook alongside it to
* check if a restore is currently in progress. `useQuery` and friends also check this internally to avoid
* race conditions between the restore and mounting queries.
*
* @returns `true` while a persisted client is being restored, `false` otherwise.
*/ const $fc8ae81a69ed1932$export$4da0178d6b5f553 = ()=>$5FkrB.useContext($fc8ae81a69ed1932$var$IsRestoringContext);
/**
* The Provider that `PersistQueryClientProvider` uses to signal whether a persisted client is currently
* being restored, read by `useIsRestoring`.
*/ const $fc8ae81a69ed1932$export$593807d4e94f9621 = $fc8ae81a69ed1932$var$IsRestoringContext.Provider;



var $5FkrB = parcelRequire("5FkrB");

"use client";
//#region src/QueryErrorResetBoundary.tsx
/**
* Resets any query errors within the boundary, so queries know they can try again.
*/ function $68e16a09567a1394$var$createValue() {
    let isReset = false;
    return {
        /**
		* Clears the reset state, so queries know not to try again until the boundary is reset again.
		*/ clearReset: ()=>{
            isReset = false;
        },
        /**
		* Resets any query errors within the boundary, so queries know they can try again.
		*/ reset: ()=>{
            isReset = true;
        },
        /**
		* Returns whether the boundary has been reset and not yet cleared.
		*/ isReset: ()=>{
            return isReset;
        }
    };
}
const $68e16a09567a1394$var$QueryErrorResetBoundaryContext = $5FkrB.createContext($68e16a09567a1394$var$createValue());
/**
* This hook will reset any query errors within the closest `QueryErrorResetBoundary`. If there is no boundary
* defined it will reset them globally.
*
* @returns The boundary's {@link QueryErrorResetBoundaryValue}.
*
* @example
* ```tsx
* import { ErrorBoundary } from 'react-error-boundary'
* import { useQueryErrorResetBoundary } from '@tanstack/react-query'
*
* function App({ children }: { children: React.ReactNode }) {
*   const { reset } = useQueryErrorResetBoundary()
*
*   return (
*     <ErrorBoundary
*       onReset={reset}
*       fallbackRender={({ resetErrorBoundary }) => (
*         <div>
*           There was an error!
*           <button onClick={() => resetErrorBoundary()}>Try again</button>
*         </div>
*       )}
*     >
*       {children}
*     </ErrorBoundary>
*   )
* }
* ```
*/ const $68e16a09567a1394$export$50dfac555130cafd = ()=>$5FkrB.useContext($68e16a09567a1394$var$QueryErrorResetBoundaryContext);
/**
* When using `suspense` or `throwOnError` in your queries, you need a way to let queries know that you want to
* try again when re-rendering after some error occurred. With the `QueryErrorResetBoundary` component you can
* reset any query errors within the boundaries of the component.
*
* @returns The `children`, rendered as-is, or called with the boundary's {@link QueryErrorResetBoundaryValue}
* if `children` is a function.
*
* @example
* ```tsx
* import { ErrorBoundary } from 'react-error-boundary'
* import { QueryErrorResetBoundary } from '@tanstack/react-query'
*
* function App() {
*   return (
*     <QueryErrorResetBoundary>
*       {({ reset }) => (
*         <ErrorBoundary
*           onReset={reset}
*           fallbackRender={({ resetErrorBoundary }) => (
*             <div>
*               There was an error!
*               <button onClick={() => resetErrorBoundary()}>Try again</button>
*             </div>
*           )}
*         >
*           <Page />
*         </ErrorBoundary>
*       )}
*     </QueryErrorResetBoundary>
*   )
* }
* ```
*/ const $68e16a09567a1394$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $5FkrB.useState(()=>$68e16a09567a1394$var$createValue());
    return /* @__PURE__ */ (0, $faf30355a80342e4$exports.jsx)($68e16a09567a1394$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};



var $5FkrB = parcelRequire("5FkrB");
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/checkPrivateRedeclaration.js
function $2a8ed1c9c5679810$export$407448d2b89b1813(e, t) {
    if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/classPrivateFieldInitSpec.js
function $2a8ed1c9c5679810$export$23f2a1d2818174ef(e, t, a) {
    $2a8ed1c9c5679810$export$407448d2b89b1813(e, t), t.set(e, a);
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/assertClassBrand.js
function $2a8ed1c9c5679810$export$43caf9889c228507(e, t, n) {
    if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
    throw new TypeError("Private element is not present on this object");
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/classPrivateFieldGet2.js
function $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5(s, a) {
    return s.get($2a8ed1c9c5679810$export$43caf9889c228507(s, a));
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/classPrivateFieldSet2.js
function $2a8ed1c9c5679810$export$625550452a3fa3ec(s, a, r) {
    return s.set($2a8ed1c9c5679810$export$43caf9889c228507(s, a), r), r;
}


//#region src/timeoutManager.ts
const $c256c6d36f9f33f6$export$d235812f9125bf47 = {
    setTimeout: (callback, delay)=>setTimeout(callback, delay),
    clearTimeout: (timeoutId)=>clearTimeout(timeoutId),
    setInterval: (callback, delay)=>setInterval(callback, delay),
    clearInterval: (intervalId)=>clearInterval(intervalId)
};
var $c256c6d36f9f33f6$var$_provider = /* @__PURE__ */ new WeakMap();
var $c256c6d36f9f33f6$var$_providerCalled = /* @__PURE__ */ new WeakMap();
/**
* Allows customization of how timeouts are created.
*
* @tanstack/query-core makes liberal use of timeouts to implement `staleTime`
* and `gcTime`. The default TimeoutManager provider uses the platform's global
* `setTimeout` implementation, which is known to have scalability issues with
* thousands of timeouts on the event loop.
*
* If you hit this limitation, consider providing a custom TimeoutProvider that
* coalesces timeouts.
*/ var $c256c6d36f9f33f6$export$6336d90323f0ab52 = class {
    constructor(){
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $c256c6d36f9f33f6$var$_provider, $c256c6d36f9f33f6$export$d235812f9125bf47);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $c256c6d36f9f33f6$var$_providerCalled, false);
    }
    /**
	* `setTimeoutProvider` can be used to set a custom implementation of the
	* `setTimeout`, `clearTimeout`, `setInterval`, `clearInterval` functions,
	* called a `TimeoutProvider`.
	*
	* This may be useful if you notice event loop performance issues with
	* thousands of queries. A custom TimeoutProvider could also support timer
	* delays longer than the global `setTimeout` maximum delay value of about
	* 24 days.
	*
	* It is important to call `setTimeoutProvider` before creating a
	* QueryClient or queries, so that the same provider is used consistently
	* for all timers in the application, since different TimeoutProviders
	* cannot cancel each others' timers.
	*
	* @example
	* ```ts
	* import { timeoutManager, QueryClient } from '@tanstack/query-core'
	* import { CustomTimeoutProvider } from './CustomTimeoutProvider'
	*
	* timeoutManager.setTimeoutProvider(new CustomTimeoutProvider())
	*
	* export const queryClient = new QueryClient()
	* ```
	*/ setTimeoutProvider(provider) {
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($c256c6d36f9f33f6$var$_provider, this, provider);
    }
    /**
	* `setTimeout` schedules a callback to run after approximately `delay`
	* milliseconds, like the global `setTimeout` function. The callback can be
	* canceled with `clearTimeout`.
	*
	* It returns a timer ID, which may be a number or an object that can be
	* coerced to a number via `Symbol.toPrimitive`.
	*
	* @example
	* ```ts
	* import { timeoutManager } from '@tanstack/query-core'
	*
	* const timeoutId = timeoutManager.setTimeout(
	*   () => console.log('ran at:', new Date()),
	*   1000,
	* )
	*
	* const timeoutIdNumber: number = Number(timeoutId)
	* ```
	*/ setTimeout(callback, delay) {
        return (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c256c6d36f9f33f6$var$_provider, this).setTimeout(callback, delay);
    }
    /**
	* `clearTimeout` cancels a timeout callback scheduled with `setTimeout`,
	* like the global `clearTimeout` function. It should be called with a
	* timer ID returned by `setTimeout`.
	*
	* @example
	* ```ts
	* import { timeoutManager } from '@tanstack/query-core'
	*
	* const timeoutId = timeoutManager.setTimeout(
	*   () => console.log('ran at:', new Date()),
	*   1000,
	* )
	*
	* timeoutManager.clearTimeout(timeoutId)
	* ```
	*/ clearTimeout(timeoutId) {
        (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c256c6d36f9f33f6$var$_provider, this).clearTimeout(timeoutId);
    }
    /**
	* `setInterval` schedules a callback to be called approximately every
	* `delay` milliseconds, like the global `setInterval` function.
	*
	* Like `setTimeout`, it returns a timer ID, which may be a number or an
	* object that can be coerced to a number via `Symbol.toPrimitive`.
	*
	* @example
	* ```ts
	* import { timeoutManager } from '@tanstack/query-core'
	*
	* const intervalId = timeoutManager.setInterval(
	*   () => console.log('ran at:', new Date()),
	*   1000,
	* )
	* ```
	*/ setInterval(callback, delay) {
        return (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c256c6d36f9f33f6$var$_provider, this).setInterval(callback, delay);
    }
    /**
	* `clearInterval` can be used to cancel an interval, like the global
	* `clearInterval` function. It should be called with an interval ID
	* returned by `setInterval`.
	*
	* @example
	* ```ts
	* import { timeoutManager } from '@tanstack/query-core'
	*
	* const intervalId = timeoutManager.setInterval(
	*   () => console.log('ran at:', new Date()),
	*   1000,
	* )
	*
	* timeoutManager.clearInterval(intervalId)
	* ```
	*/ clearInterval(intervalId) {
        (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c256c6d36f9f33f6$var$_provider, this).clearInterval(intervalId);
    }
};
/**
* Singleton instance of {@link TimeoutManager}, used throughout TanStack Query to schedule and cancel timers.
*/ const $c256c6d36f9f33f6$export$94a2700736e69372 = new $c256c6d36f9f33f6$export$6336d90323f0ab52();
/**
* In many cases code wants to delay to the next event loop tick; this is not
* mediated by {@link timeoutManager}.
*
* This function is provided to make auditing the `tanstack/query-core` for
* incorrect use of system `setTimeout` easier.
*/ function $c256c6d36f9f33f6$export$5086591e51e32a18(callback) {
    setTimeout(callback, 0);
}


//#region src/utils.ts
/** @deprecated
* use `environmentManager.isServer()` instead.
*/ const $e9d6dc959f196f70$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $e9d6dc959f196f70$export$8793edee2d425525() {}
function $e9d6dc959f196f70$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $e9d6dc959f196f70$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $e9d6dc959f196f70$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $e9d6dc959f196f70$export$e36731f6aa6a4362(value, query) {
    return typeof value === "function" ? value(query) : value;
}
/**
* Checks whether a query matches the given {@link QueryFilters}.
* Every filter that is specified must match; filters that are left unspecified are ignored.
*
* @example
* ```ts
* const queryCache = queryClient.getQueryCache()
*
* const matchingQueries = queryCache
*   .getAll()
*   .filter((query) => matchQuery({ queryKey: ['posts'] }, query))
* ```
*/ function $e9d6dc959f196f70$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $e9d6dc959f196f70$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$e9d6dc959f196f70$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
/**
* Checks whether a mutation matches the given {@link MutationFilters}.
* Every filter that is specified must match; filters that are left unspecified are ignored.
* If a `mutationKey` filter is provided but the mutation has no `mutationKey` of its own, it does not match.
*
* @example
* ```ts
* const mutationCache = queryClient.getMutationCache()
*
* const matchingMutations = mutationCache
*   .getAll()
*   .filter((mutation) => matchMutation({ mutationKey: ['addPost'] }, mutation))
* ```
*/ function $e9d6dc959f196f70$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($e9d6dc959f196f70$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $e9d6dc959f196f70$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$e9d6dc959f196f70$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $e9d6dc959f196f70$export$cc90ca97bc0d73fd(queryKey, options) {
    return ((options === null || options === void 0 ? void 0 : options.queryKeyHashFn) || $e9d6dc959f196f70$export$1e87d19d4aab5805)(queryKey);
}
/**
* Default query & mutation keys hash function.
* Hashes the value into a stable hash.
*
* @example
* ```ts
* // Object keys are sorted, so key order doesn't affect the hash:
* hashKey(['todos', { page: 1, filter: 'done' }]) // === '["todos",{"filter":"done","page":1}]'
* ```
*/ function $e9d6dc959f196f70$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$e9d6dc959f196f70$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $e9d6dc959f196f70$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") {
        if (Array.isArray(a) && Array.isArray(b)) {
            if (b.length > a.length) return false;
            for(let i = 0; i < b.length; i++)if (!$e9d6dc959f196f70$export$2f07189bb9fa26a7(a[i], b[i])) return false;
            return true;
        }
        const bKeys = Object.keys(b);
        for (const key of bKeys)if (!$e9d6dc959f196f70$export$2f07189bb9fa26a7(a[key], b[key])) return false;
        return true;
    }
    return false;
}
const $e9d6dc959f196f70$var$hasOwn = Object.prototype.hasOwnProperty;
function $e9d6dc959f196f70$export$77a71fc411098696(a, b, depth = 0) {
    if (a === b) return a;
    if (depth > 500) return b;
    const array = $e9d6dc959f196f70$export$7a8558113332b71e(a) && $e9d6dc959f196f70$export$7a8558113332b71e(b);
    if (!array && !($e9d6dc959f196f70$export$53b83ca8eaab0383(a) && $e9d6dc959f196f70$export$53b83ca8eaab0383(b))) return b;
    const aSize = (array ? a : Object.keys(a)).length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? new Array(bSize) : {};
    let equalItems = 0;
    for(let i = 0; i < bSize; i++){
        const key = array ? i : bItems[i];
        const aItem = a[key];
        const bItem = b[key];
        if (aItem === bItem) {
            copy[key] = aItem;
            if (array ? i < aSize : $e9d6dc959f196f70$var$hasOwn.call(a, key)) equalItems++;
            continue;
        }
        if (aItem === null || bItem === null || typeof aItem !== "object" || typeof bItem !== "object") {
            copy[key] = bItem;
            continue;
        }
        const v = $e9d6dc959f196f70$export$77a71fc411098696(aItem, bItem, depth + 1);
        copy[key] = v;
        if (v === aItem) equalItems++;
    }
    return aSize === bSize && equalItems === aSize ? a : copy;
}
/**
* Shallow compare objects.
*/ function $e9d6dc959f196f70$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a)if (a[key] !== b[key]) return false;
    return true;
}
function $e9d6dc959f196f70$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $e9d6dc959f196f70$export$53b83ca8eaab0383(o) {
    if (!$e9d6dc959f196f70$var$hasObjectPrototype(o)) return false;
    const objectPrototype = Object.getPrototypeOf(o);
    const ctor = objectPrototype === null || objectPrototype === void 0 ? void 0 : objectPrototype.constructor;
    if (ctor === void 0) return true;
    if (typeof ctor !== "function") return false;
    const prot = ctor.prototype;
    if (!$e9d6dc959f196f70$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (objectPrototype !== Object.prototype) return false;
    return true;
}
function $e9d6dc959f196f70$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $e9d6dc959f196f70$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        (0, $c256c6d36f9f33f6$export$94a2700736e69372).setTimeout(resolve, timeout);
    });
}
function $e9d6dc959f196f70$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $e9d6dc959f196f70$export$77a71fc411098696(prevData, data);
    }
    return data;
}
/**
* Intended to be passed as a query's `placeholderData` option, for example
* `placeholderData: keepPreviousData`. Instead of resetting the query's data to `undefined` while a new
* query key is fetching, it keeps displaying the previously fetched data until the new data arrives.
*
* @example
* ```ts
* new QueryObserver(queryClient, {
*   queryKey: ['posts', page],
*   queryFn: () => fetchPosts(page),
*   placeholderData: keepPreviousData,
* })
* ```
*/ function $e9d6dc959f196f70$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $e9d6dc959f196f70$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $e9d6dc959f196f70$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
/**
* Sentinel value that can be passed as a query's `queryFn` to conditionally disable the query (equivalent
* to `enabled: false`) while preserving full type inference for the query's data. Unlike `enabled: false`,
* a query disabled via `skipToken` cannot be triggered with `refetch`.
*
* @example
* ```ts
* new QueryObserver(queryClient, {
*   queryKey: ['post', postId],
*   queryFn: postId != null ? () => fetchPost(postId) : skipToken,
* })
* ```
*/ const $e9d6dc959f196f70$export$1aa5a89531b7670d = Symbol();
function $e9d6dc959f196f70$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && (fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.initialPromise)) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $e9d6dc959f196f70$export$1aa5a89531b7670d) return ()=>Promise.reject(/* @__PURE__ */ new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}
/**
* Resolves a `throwOnError` option to a boolean.
* If `throwOnError` is a function, it is called with `params` (e.g. the error and, depending on the caller,
* additional context such as the query or mutation) and its result is returned, allowing the throwing
* behavior to be decided per error. Otherwise, `throwOnError` itself is coerced to a boolean (`undefined`
* resolves to `false`).
*
* @example
* ```ts
* const throwOnError =
*   query.state.error && typeof options.throwOnError === 'function'
*     ? shouldThrowError(options.throwOnError, [query.state.error, query])
*     : options.throwOnError
* ```
*/ function $e9d6dc959f196f70$export$2072f68e6c3507cf(throwOnError, params) {
    if (typeof throwOnError === "function") return throwOnError(...params);
    return !!throwOnError;
}
function $e9d6dc959f196f70$export$83f813cd1f8a4973(object, getSignal, onCancelled) {
    let consumed = false;
    let signal;
    Object.defineProperty(object, "signal", {
        enumerable: true,
        get: ()=>{
            signal ?? (signal = getSignal());
            if (consumed) return signal;
            consumed = true;
            if (signal.aborted) onCancelled();
            else signal.addEventListener("abort", onCancelled, {
                once: true
            });
            return signal;
        }
    });
    return object;
}


"use client";
//#region src/errorBoundaryUtils.ts
const $b95e72c01d14ad05$export$ae8adb3de3d77633 = (options, errorResetBoundary, query)=>{
    const throwOnError = (query === null || query === void 0 ? void 0 : query.state.error) && typeof options.throwOnError === "function" ? (0, $e9d6dc959f196f70$export$2072f68e6c3507cf)(options.throwOnError, [
        query.state.error,
        query
    ]) : options.throwOnError;
    if (options.suspense || throwOnError) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const $b95e72c01d14ad05$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $5FkrB.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const $b95e72c01d14ad05$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query, suspense: suspense })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (suspense && result.data === void 0 || (0, $e9d6dc959f196f70$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]));
};


//#region src/suspense.ts
const $ffbdf52ffadc6ec6$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
const $ffbdf52ffadc6ec6$export$274d2a1db5a20c09 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        const MIN_SUSPENSE_TIME_MS = 1e3;
        const clamp = (value)=>value === "static" ? value : Math.max(value ?? MIN_SUSPENSE_TIME_MS, MIN_SUSPENSE_TIME_MS);
        const originalStaleTime = defaultedOptions.staleTime;
        defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args)=>clamp(originalStaleTime(...args)) : clamp(originalStaleTime);
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, MIN_SUSPENSE_TIME_MS);
    }
};
const $ffbdf52ffadc6ec6$export$88d3586dfed64df9 = (defaultedOptions, result)=>(defaultedOptions === null || defaultedOptions === void 0 ? void 0 : defaultedOptions.suspense) && result.isPending;
const $ffbdf52ffadc6ec6$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });



var $5FkrB = parcelRequire("5FkrB");

//#region src/notifyManager.ts
/**
* Default scheduling function used by the notify manager.
* Schedules the callback with the system's `setTimeout(callback, 0)`.
*/ const $a37b31dc4086690f$export$7c76da44185e6090 = (0, $c256c6d36f9f33f6$export$5086591e51e32a18);
function $a37b31dc4086690f$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = $a37b31dc4086690f$export$7c76da44185e6090;
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        /**
		* Batches all updates scheduled inside the passed callback.
		* This is mainly used internally to optimize query client updating.
		* Batches can be nested; the queue is only flushed once the outermost `batch` call finishes.
		* The return value of `callback` is passed through.
		*/ batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
		* All calls to the wrapped function will be batched.
		*/ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: /**
		* Schedules a function to be run on the next batch.
		* By default, the batch is run with a `setTimeout`, but this can be configured via `setScheduler`.
		*/ schedule,
        /**
		* Use this method to set a custom notify function.
		* This can be used to for example wrap notifications with `React.act` while running tests.
		*/ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
		* Use this method to set a custom function to batch notifications together into a single tick.
		* Framework adapters use this to plug in their own batching primitive, so that a single query
		* update only triggers one re-render instead of one per subscriber.
		*
		* @example
		* ```ts
		* import { notifyManager } from '@tanstack/query-core'
		* import { batch } from 'solid-js'
		*
		* notifyManager.setBatchNotifyFunction(batch)
		* ```
		*/ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        /**
		* Configures a custom callback that schedules when the next batch runs.
		* The default behavior is `setTimeout(callback, 0)`.
		*
		* @example
		* ```ts
		* import { notifyManager } from '@tanstack/query-core'
		*
		* // Schedule batches in the next microtask
		* notifyManager.setScheduler(queueMicrotask)
		*
		* // Schedule batches before the next frame is rendered
		* notifyManager.setScheduler(requestAnimationFrame)
		*
		* // Schedule batches some time in the future
		* notifyManager.setScheduler((cb) => setTimeout(cb, 10))
		* ```
		*/ setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
/**
* Handles scheduling and batching callbacks in TanStack Query.
*/ const $a37b31dc4086690f$export$520687f44db6e1ab = $a37b31dc4086690f$export$316a8efd03cd1458();


"use client";
//#region src/useBaseQuery.ts
function $bccea28e74b4fdc0$export$fff0865807e996c5(options, Observer, queryClient) {
    const isRestoring = (0, $fc8ae81a69ed1932$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $68e16a09567a1394$export$50dfac555130cafd)();
    const client = (0, $a0fe68b284b4365c$export$22e77b9572c4fded)(queryClient);
    const defaultedOptions = client.defaultQueryOptions(options);
    const query = client.getQueryCache().get(defaultedOptions.queryHash);
    const subscribed = options.subscribed !== false;
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : subscribed ? "optimistic" : void 0;
    (0, $ffbdf52ffadc6ec6$export$274d2a1db5a20c09)(defaultedOptions);
    (0, $b95e72c01d14ad05$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary, query);
    (0, $b95e72c01d14ad05$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $5FkrB.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    const shouldSubscribe = !isRestoring && subscribed;
    $5FkrB.useSyncExternalStore($5FkrB.useCallback((onStoreChange)=>{
        const unsubscribe = shouldSubscribe ? observer.subscribe((0, $a37b31dc4086690f$export$520687f44db6e1ab).batchCalls(onStoreChange)) : (0, $e9d6dc959f196f70$export$8793edee2d425525);
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $5FkrB.useEffect(()=>{
        observer.setOptions(defaultedOptions);
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $ffbdf52ffadc6ec6$export$88d3586dfed64df9)(defaultedOptions, result)) throw (0, $ffbdf52ffadc6ec6$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $b95e72c01d14ad05$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: query,
        suspense: defaultedOptions.suspense
    })) throw result.error;
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}






//#region src/environmentManager.ts
let $fc249fd5f601b92a$var$isServerFn = ()=>(0, $e9d6dc959f196f70$export$6acf61af03e62db);
/**
* Returns whether the current runtime should be treated as a server environment.
*/ const $fc249fd5f601b92a$export$6acf61af03e62db = ()=>$fc249fd5f601b92a$var$isServerFn();
/**
* Manages how TanStack Query detects whether the current runtime should be treated as
* server-side, which disables scheduling refetch timers and changes the default `retry` count
* and `gcTime`. By default, the detection treats a missing `window` (or the presence of a
* `Deno` global) as server.
*
* Override this for runtimes where that default detection would give the wrong answer — for
* example, a Service Worker, where `window` is undefined even though the environment should
* behave like a client.
*
* @example
* ```ts
* import { environmentManager } from '@tanstack/query-core'
*
* environmentManager.setIsServer(() => false)
* ```
*/ const $fc249fd5f601b92a$export$2d935f1a9c9d3f3e = {
    isServer: $fc249fd5f601b92a$export$6acf61af03e62db,
    /**
	* Overrides the server check globally.
	*/ setIsServer (isServerValue) {
        $fc249fd5f601b92a$var$isServerFn = isServerValue;
    }
};


//#region src/subscribable.ts
var $78d76f0c1d823036$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};




//#region src/focusManager.ts
var $780e8903dcf2df97$var$_focused = /* @__PURE__ */ new WeakMap();
var $780e8903dcf2df97$var$_cleanup = /* @__PURE__ */ new WeakMap();
var $780e8903dcf2df97$var$_setup = /* @__PURE__ */ new WeakMap();
/**
* The `FocusManager` manages the focus state within TanStack Query.
*
* It can be used to change the default event listeners or to manually change the focus state.
*/ var $780e8903dcf2df97$export$86f1af424b2ca4de = class extends (0, $78d76f0c1d823036$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $780e8903dcf2df97$var$_focused, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $780e8903dcf2df97$var$_cleanup, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $780e8903dcf2df97$var$_setup, void 0);
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($780e8903dcf2df97$var$_setup, this, (onFocus)=>{
            if (typeof window !== "undefined" && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
        });
    }
    onSubscribe() {
        if (!(0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($780e8903dcf2df97$var$_cleanup, this)) this.setEventListener((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($780e8903dcf2df97$var$_setup, this));
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _classPrivateFieldGet2$1;
            (_classPrivateFieldGet2$1 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($780e8903dcf2df97$var$_cleanup, this)) === null || _classPrivateFieldGet2$1 === void 0 || _classPrivateFieldGet2$1.call(this);
            (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($780e8903dcf2df97$var$_cleanup, this, void 0);
        }
    }
    /**
	* `setEventListener` can be used to set a custom event listener that will
	* be used to determine the focus state. The provided `setup` function
	* receives a `setFocused` callback: call it with a `boolean` to manually
	* set the focus state, or with no arguments to re-evaluate the current
	* focus state and notify subscribers.
	*
	* @example
	* ```ts
	* import { focusManager } from '@tanstack/query-core'
	*
	* focusManager.setEventListener((handleFocus) => {
	*   const listener = () => handleFocus()
	*   // Listen to visibilitychange
	*   if (typeof window !== 'undefined' && window.addEventListener) {
	*     window.addEventListener('visibilitychange', listener, false)
	*   }
	*
	*   return () => {
	*     // Be sure to unsubscribe if a new handler is set
	*     window.removeEventListener('visibilitychange', listener)
	*   }
	* })
	* ```
	*/ setEventListener(setup) {
        var _classPrivateFieldGet3;
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($780e8903dcf2df97$var$_setup, this, setup);
        (_classPrivateFieldGet3 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($780e8903dcf2df97$var$_cleanup, this)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.call(this);
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($780e8903dcf2df97$var$_cleanup, this, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    /**
	* `setFocused` can be used to manually set the focus state. Set `undefined`
	* to fall back to the default focus check.
	*
	* @example
	* ```ts
	* import { focusManager } from '@tanstack/query-core'
	*
	* // Set focused
	* focusManager.setFocused(true)
	*
	* // Set unfocused
	* focusManager.setFocused(false)
	*
	* // Fallback to the default focus check
	* focusManager.setFocused(undefined)
	* ```
	*/ setFocused(focused) {
        if ((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($780e8903dcf2df97$var$_focused, this) !== focused) {
            (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($780e8903dcf2df97$var$_focused, this, focused);
            this.onFocus();
        }
    }
    /**
	* `onFocus` notifies all subscribed listeners with the current focus state.
	*/ onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    /**
	* `isFocused` can be used to get the current focus state.
	*/ isFocused() {
        var _globalThis$document;
        if (typeof (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($780e8903dcf2df97$var$_focused, this) === "boolean") return (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($780e8903dcf2df97$var$_focused, this);
        return ((_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.visibilityState) !== "hidden";
    }
};
/**
* Singleton instance of {@link FocusManager}, used to manage and observe the focus state within TanStack Query.
*/ const $780e8903dcf2df97$export$6bf54661be5b02cf = new $780e8903dcf2df97$export$86f1af424b2ca4de();




//#region \0@oxc-project+runtime@0.144.0/helpers/esm/classPrivateMethodInitSpec.js
function $319cb07e0a96d91d$export$625550452a3fa3ec(e, a) {
    (0, $2a8ed1c9c5679810$export$407448d2b89b1813)(e, a), a.add(e);
}










//#region src/onlineManager.ts
var $3b7c5eeebfe845db$var$_online = /* @__PURE__ */ new WeakMap();
var $3b7c5eeebfe845db$var$_cleanup = /* @__PURE__ */ new WeakMap();
var $3b7c5eeebfe845db$var$_setup = /* @__PURE__ */ new WeakMap();
/**
* The `OnlineManager` manages the online state within TanStack Query. It can
* be used to change the default event listeners or to manually change the
* online state.
*
* By default, the `onlineManager` assumes an active network connection, and
* listens to the `online` and `offline` events on the `window` object to
* detect changes.
*/ var $3b7c5eeebfe845db$export$58774fb55d5ff7fc = class extends (0, $78d76f0c1d823036$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $3b7c5eeebfe845db$var$_online, true);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $3b7c5eeebfe845db$var$_cleanup, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $3b7c5eeebfe845db$var$_setup, void 0);
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($3b7c5eeebfe845db$var$_setup, this, (onOnline)=>{
            if (typeof window !== "undefined" && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
        });
    }
    onSubscribe() {
        if (!(0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($3b7c5eeebfe845db$var$_cleanup, this)) this.setEventListener((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($3b7c5eeebfe845db$var$_setup, this));
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _classPrivateFieldGet2$1;
            (_classPrivateFieldGet2$1 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($3b7c5eeebfe845db$var$_cleanup, this)) === null || _classPrivateFieldGet2$1 === void 0 || _classPrivateFieldGet2$1.call(this);
            (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($3b7c5eeebfe845db$var$_cleanup, this, void 0);
        }
    }
    /**
	* `setEventListener` can be used to set a custom event listener that will
	* be used to determine the online state. The provided `setup` function
	* receives a `setOnline` callback that should be called with a `boolean`
	* whenever the online state changes.
	*
	* @example
	* ```ts
	* import NetInfo from '@react-native-community/netinfo'
	* import { onlineManager } from '@tanstack/query-core'
	*
	* onlineManager.setEventListener((setOnline) => {
	*   return NetInfo.addEventListener((state) => {
	*     setOnline(!!state.isConnected)
	*   })
	* })
	* ```
	*/ setEventListener(setup) {
        var _classPrivateFieldGet3;
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($3b7c5eeebfe845db$var$_setup, this, setup);
        (_classPrivateFieldGet3 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($3b7c5eeebfe845db$var$_cleanup, this)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.call(this);
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($3b7c5eeebfe845db$var$_cleanup, this, setup(this.setOnline.bind(this)));
    }
    /**
	* `setOnline` can be used to manually set the online state.
	*
	* @example
	* ```ts
	* import { onlineManager } from '@tanstack/query-core'
	*
	* // Set to online
	* onlineManager.setOnline(true)
	*
	* // Set to offline
	* onlineManager.setOnline(false)
	* ```
	*/ setOnline(online) {
        if ((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($3b7c5eeebfe845db$var$_online, this) !== online) {
            (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($3b7c5eeebfe845db$var$_online, this, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    /**
	* `isOnline` can be used to get the current online state.
	*/ isOnline() {
        return (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($3b7c5eeebfe845db$var$_online, this);
    }
};
/**
* Singleton instance of {@link OnlineManager}, used to manage and observe the online state within TanStack Query.
*/ const $3b7c5eeebfe845db$export$b113e788b2dd3fdc = new $3b7c5eeebfe845db$export$58774fb55d5ff7fc();


//#region src/retryer.ts
function $c0d8ccc060892ed3$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $c0d8ccc060892ed3$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $3b7c5eeebfe845db$export$b113e788b2dd3fdc).isOnline() : true;
}
/**
* The error thrown by a `Retryer` (and surfaced to `query.promise`/`mutation`) when a fetch is cancelled, e.g. via
* `query.cancel()`. `revert`, if `true`, tells the caller to restore the state the query was in before the fetch
* started instead of surfacing the error. `silent`, if `true`, tells the caller to suppress this error and instead
* resolve with the promise of the fetch that triggered the cancellation.
* @example
* ```ts
* query.cancel()
*
* try {
*   await query.promise
* } catch (error) {
*   if (error instanceof CancelledError) {
*     // the fetch was cancelled, e.g. via `query.cancel()`
*   }
* }
* ```
*/ var $c0d8ccc060892ed3$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options === null || options === void 0 ? void 0 : options.revert;
        this.silent = options === null || options === void 0 ? void 0 : options.silent;
    }
};
/**
* @deprecated Use instanceof `CancelledError` instead.
*/ function $c0d8ccc060892ed3$export$986cc6445c1d323(value) {
    return value instanceof $c0d8ccc060892ed3$export$a8430ed4188f35a9;
}
function $c0d8ccc060892ed3$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let continueFn;
    let status = "pending";
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((resolve, reject)=>{
        promiseResolve = resolve;
        promiseReject = reject;
    });
    promise.catch((0, $e9d6dc959f196f70$export$8793edee2d425525));
    const isResolved = ()=>status !== "pending";
    const cancel = (cancelOptions)=>{
        if (!isResolved()) {
            var _config$onCancel;
            const error = new $c0d8ccc060892ed3$export$a8430ed4188f35a9(cancelOptions);
            reject(error);
            (_config$onCancel = config.onCancel) === null || _config$onCancel === void 0 || _config$onCancel.call(config, error);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $780e8903dcf2df97$export$6bf54661be5b02cf).isFocused() && (config.networkMode === "always" || (0, $3b7c5eeebfe845db$export$b113e788b2dd3fdc).isOnline()) && config.canRun();
    const canStart = ()=>$c0d8ccc060892ed3$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved()) {
            continueFn === null || continueFn === void 0 || continueFn();
            status = "resolved";
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved()) {
            continueFn === null || continueFn === void 0 || continueFn();
            status = "rejected";
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _config$onPause;
            continueFn = (value)=>{
                if (isResolved() || canContinue()) continueResolve(value);
            };
            (_config$onPause = config.onPause) === null || _config$onPause === void 0 || _config$onPause.call(config);
        }).then(()=>{
            continueFn = void 0;
            if (!isResolved()) {
                var _config$onContinue;
                (_config$onContinue = config.onContinue) === null || _config$onContinue === void 0 || _config$onContinue.call(config);
            }
        });
    };
    const run = ()=>{
        if (isResolved()) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$onFail;
            if (isResolved()) return;
            const retry = config.retry ?? ((0, $fc249fd5f601b92a$export$6acf61af03e62db)() ? 0 : 3);
            const retryDelay = config.retryDelay ?? $c0d8ccc060892ed3$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_config$onFail = config.onFail) === null || _config$onFail === void 0 || _config$onFail.call(config, failureCount, error);
            (0, $e9d6dc959f196f70$export$e772c8ff12451969)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: promise,
        status: ()=>status,
        cancel: cancel,
        continue: ()=>{
            continueFn === null || continueFn === void 0 || continueFn();
            return promise;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return promise;
        }
    };
}






//#region src/removable.ts
var $b5f33a596cb9c395$var$_gcTimeout = /* @__PURE__ */ new WeakMap();
var $b5f33a596cb9c395$export$e09608847fcc8c59 = class {
    constructor(){
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $b5f33a596cb9c395$var$_gcTimeout, void 0);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $e9d6dc959f196f70$export$e539f754e934e270)(this.gcTime)) (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($b5f33a596cb9c395$var$_gcTimeout, this, (0, $c256c6d36f9f33f6$export$94a2700736e69372).setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $fc249fd5f601b92a$export$6acf61af03e62db)() ? Infinity : 3e5));
    }
    clearGcTimeout() {
        if ((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($b5f33a596cb9c395$var$_gcTimeout, this) !== void 0) {
            (0, $c256c6d36f9f33f6$export$94a2700736e69372).clearTimeout((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($b5f33a596cb9c395$var$_gcTimeout, this));
            (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($b5f33a596cb9c395$var$_gcTimeout, this, void 0);
        }
    }
};



//#region src/infiniteQueryBehavior.ts
function $0297628cdc6ea7c0$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            var _context$fetchOptions, _context$state$data, _context$state$data2;
            const options = context.options;
            const direction = (_context$fetchOptions = context.fetchOptions) === null || _context$fetchOptions === void 0 || (_context$fetchOptions = _context$fetchOptions.meta) === null || _context$fetchOptions === void 0 || (_context$fetchOptions = _context$fetchOptions.fetchMore) === null || _context$fetchOptions === void 0 ? void 0 : _context$fetchOptions.direction;
            const oldPages = ((_context$state$data = context.state.data) === null || _context$state$data === void 0 ? void 0 : _context$state$data.pages) || [];
            const oldPageParams = ((_context$state$data2 = context.state.data) === null || _context$state$data2 === void 0 ? void 0 : _context$state$data2.pageParams) || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    (0, $e9d6dc959f196f70$export$83f813cd1f8a4973)(object, ()=>context.signal, ()=>cancelled = true);
                };
                const queryFn = (0, $e9d6dc959f196f70$export$c71c44209368a3bc)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject(context.signal.reason);
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const createQueryFnContext = ()=>{
                        const queryFnContext = {
                            client: context.client,
                            queryKey: context.queryKey,
                            pageParam: param,
                            direction: previous ? "backward" : "forward",
                            meta: context.options.meta
                        };
                        addSignalProperty(queryFnContext);
                        return queryFnContext;
                    };
                    const queryFnContext = createQueryFnContext();
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $e9d6dc959f196f70$export$8c6246b73dd61f4a) : (0, $e9d6dc959f196f70$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $0297628cdc6ea7c0$var$getPreviousPageParam : $0297628cdc6ea7c0$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    result = await fetchPage(oldData, pageParamFn(options, oldData), previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : $0297628cdc6ea7c0$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _context$options$pers, _context$options;
                return (_context$options$pers = (_context$options = context.options).persister) === null || _context$options$pers === void 0 ? void 0 : _context$options$pers.call(_context$options, fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $0297628cdc6ea7c0$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $0297628cdc6ea7c0$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _options$getPreviousP;
    return pages.length > 0 ? (_options$getPreviousP = options.getPreviousPageParam) === null || _options$getPreviousP === void 0 ? void 0 : _options$getPreviousP.call(options, pages[0], pages, pageParams[0], pageParams) : void 0;
}
/**
* Checks if there is a next page.
*/ function $0297628cdc6ea7c0$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $0297628cdc6ea7c0$var$getNextPageParam(options, data) != null;
}
/**
* Checks if there is a previous page.
*/ function $0297628cdc6ea7c0$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $0297628cdc6ea7c0$var$getPreviousPageParam(options, data) != null;
}



//#region src/query.ts
var $d3cc80c94d2af732$var$_queryType = /* @__PURE__ */ new WeakMap();
var $d3cc80c94d2af732$var$_initialState = /* @__PURE__ */ new WeakMap();
var $d3cc80c94d2af732$var$_revertState = /* @__PURE__ */ new WeakMap();
var $d3cc80c94d2af732$var$_cache = /* @__PURE__ */ new WeakMap();
var $d3cc80c94d2af732$var$_client = /* @__PURE__ */ new WeakMap();
var $d3cc80c94d2af732$var$_retryer = /* @__PURE__ */ new WeakMap();
var $d3cc80c94d2af732$var$_defaultOptions = /* @__PURE__ */ new WeakMap();
var $d3cc80c94d2af732$var$_abortSignalConsumed = /* @__PURE__ */ new WeakMap();
var $d3cc80c94d2af732$var$_Query_brand = /* @__PURE__ */ new WeakSet();
/**
* Represents a single cached query. A `Query` holds the query's key, options,
* state (data/error/status), and the observers currently subscribed to it.
*
* Instances are created and managed internally by `QueryCache`; application
* code typically interacts with queries indirectly through `QueryClient` or
* a framework hook like `useQuery`. Direct access to a `Query` instance is
* possible via `queryCache.find()`/`findAll()` for inspecting cache state.
*
* @example
* ```ts
* const queryCache = queryClient.getQueryCache()
* const query = queryCache.find({ queryKey: ['posts'] })
*
* if (query) {
*   console.log(query.state.dataUpdatedAt)
* }
* ```
*/ var $d3cc80c94d2af732$export$62297b13309008b2 = class extends (0, $b5f33a596cb9c395$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $319cb07e0a96d91d$export$625550452a3fa3ec)(this, $d3cc80c94d2af732$var$_Query_brand);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $d3cc80c94d2af732$var$_queryType, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $d3cc80c94d2af732$var$_initialState, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $d3cc80c94d2af732$var$_revertState, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $d3cc80c94d2af732$var$_cache, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $d3cc80c94d2af732$var$_client, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $d3cc80c94d2af732$var$_retryer, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $d3cc80c94d2af732$var$_defaultOptions, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $d3cc80c94d2af732$var$_abortSignalConsumed, void 0);
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($d3cc80c94d2af732$var$_abortSignalConsumed, this, false);
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($d3cc80c94d2af732$var$_defaultOptions, this, config.defaultOptions);
        this.setOptions(config.options);
        this.observers = [];
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($d3cc80c94d2af732$var$_client, this, config.client);
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($d3cc80c94d2af732$var$_cache, this, (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_client, this).getQueryCache());
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($d3cc80c94d2af732$var$_initialState, this, $d3cc80c94d2af732$var$getDefaultState(this.options));
        this.state = config.state ?? (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_initialState, this);
        this.scheduleGc();
    }
    /**
	* The `meta` object passed in the query's options, if any.
	*/ get meta() {
        return this.options.meta;
    }
    /** @internal */ get queryType() {
        return (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_queryType, this);
    }
    /**
	* The promise for the currently in-flight fetch, if the query is fetching.
	* `undefined` when the query is not fetching.
	*/ get promise() {
        var _classPrivateFieldGet2$1;
        return (_classPrivateFieldGet2$1 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_retryer, this)) === null || _classPrivateFieldGet2$1 === void 0 ? void 0 : _classPrivateFieldGet2$1.promise;
    }
    /** @internal */ setOptions(options) {
        this.options = {
            ...(0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_defaultOptions, this),
            ...options
        };
        if (options === null || options === void 0 ? void 0 : options._type) (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($d3cc80c94d2af732$var$_queryType, this, options._type);
        this.updateGcTime(this.options.gcTime);
        if (this.state && this.state.data === void 0) {
            const defaultState = $d3cc80c94d2af732$var$getDefaultState(this.options);
            if (defaultState.data !== void 0) {
                this.setState($d3cc80c94d2af732$var$successState(defaultState.data, defaultState.dataUpdatedAt));
                (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($d3cc80c94d2af732$var$_initialState, this, defaultState);
            }
        }
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_cache, this).remove(this);
    }
    /** @internal */ setData(newData, options) {
        const data = (0, $e9d6dc959f196f70$export$17619bac5b909b23)(this.state.data, newData, this.options);
        (0, $2a8ed1c9c5679810$export$43caf9889c228507)($d3cc80c94d2af732$var$_Query_brand, this, $d3cc80c94d2af732$var$_dispatch).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options === null || options === void 0 ? void 0 : options.updatedAt,
            manual: options === null || options === void 0 ? void 0 : options.manual
        });
        return data;
    }
    /**
	* Merges the given partial state directly into this query's state, notifying observers. Used
	* by persistence and broadcast plugins to restore a state snapshot, and by devtools to let a
	* user manually trigger a loading/error state or edit the cached data.
	*/ setState(state) {
        (0, $2a8ed1c9c5679810$export$43caf9889c228507)($d3cc80c94d2af732$var$_Query_brand, this, $d3cc80c94d2af732$var$_dispatch).call(this, {
            type: "setState",
            state: state
        });
    }
    /**
	* Cancels the query's currently in-flight fetch, if any.
	* - Returns a promise that resolves once the cancellation has settled.
	* - If no fetch is in progress, resolves immediately.
	*
	* @example
	* ```ts
	* await query.cancel()
	* ```
	*/ cancel(options) {
        var _classPrivateFieldGet3, _classPrivateFieldGet4;
        const promise = (_classPrivateFieldGet3 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_retryer, this)) === null || _classPrivateFieldGet3 === void 0 ? void 0 : _classPrivateFieldGet3.promise;
        (_classPrivateFieldGet4 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_retryer, this)) === null || _classPrivateFieldGet4 === void 0 || _classPrivateFieldGet4.cancel(options);
        return promise ? promise.then((0, $e9d6dc959f196f70$export$8793edee2d425525)).catch((0, $e9d6dc959f196f70$export$8793edee2d425525)) : Promise.resolve();
    }
    /**
	* Clears the query's garbage collection timeout and silently cancels any
	* in-flight fetch. Called by `QueryCache` when the query is removed from
	* the cache.
	*
	* @see {@link Query#cancel}
	*/ destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    /** @internal */ get resetState() {
        return (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_initialState, this);
    }
    /**
	* Resets the query back to its initial state (the state it had when it was
	* first created, e.g. any `initialData`), destroying it first to cancel any
	* in-flight fetch.
	*/ reset() {
        this.destroy();
        this.setState(this.resetState);
    }
    /**
	* Returns `true` if the query has at least one observer for which `enabled`
	* does not resolve to `false`.
	*/ isActive() {
        return this.observers.some((observer)=>(0, $e9d6dc959f196f70$export$e36731f6aa6a4362)(observer.options.enabled, this) !== false);
    }
    /**
	* Returns `true` if the query is disabled, meaning it will not fetch
	* automatically.
	* - If the query has observers, it is disabled when none of them are active
	*   (see `isActive`).
	* - If the query has no observers, it is disabled when its `queryFn` is
	*   `skipToken` or it has never been fetched.
	*/ isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $e9d6dc959f196f70$export$1aa5a89531b7670d) || !this.isFetched();
    }
    /**
	* Returns `true` if the query has been fetched, i.e. it has resolved with
	* either data or an error at least once.
	*/ isFetched() {
        return this.state.dataUpdateCount + this.state.errorUpdateCount > 0;
    }
    /**
	* Returns `true` if the query has at least one observer configured with
	* `staleTime: 'static'`, meaning it is treated as never stale.
	*/ isStatic() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>(0, $e9d6dc959f196f70$export$e36731f6aa6a4362)(observer.options.staleTime, this) === "static");
        return false;
    }
    /**
	* Returns `true` if the query is stale.
	* - If the query has observers, defers to whether any observer's current
	*   result reports `isStale` (which accounts for each observer's own
	*   `staleTime` and `enabled` state).
	* - If the query has no observers, it is considered stale when it has no
	*   data or has been invalidated.
	*
	* @see {@link Query#isStaleByTime}
	* @example
	* ```ts
	* if (query.isStale()) {
	*   // refetch or otherwise treat the cached data as outdated
	* }
	* ```
	*/ isStale() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0 || this.state.isInvalidated;
    }
    /**
	* Returns `true` if the query's data is stale relative to the given
	* `staleTime` (defaults to `0`).
	* - A query with no data is always stale.
	* - `staleTime: 'static'` is never stale.
	* - An invalidated query is always stale.
	* - Otherwise, staleness is based on elapsed time since `dataUpdatedAt`.
	*
	* @see {@link Query#isStale}
	* @example
	* ```ts
	* const isStale = query.isStaleByTime(1000 * 60)
	* ```
	*/ isStaleByTime(staleTime = 0) {
        if (this.state.data === void 0) return true;
        if (staleTime === "static") return false;
        if (this.state.isInvalidated) return true;
        return !(0, $e9d6dc959f196f70$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    /** @internal */ onFocus() {
        var _classPrivateFieldGet5;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer === null || observer === void 0 || observer.refetch({
            cancelRefetch: false
        });
        (_classPrivateFieldGet5 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_retryer, this)) === null || _classPrivateFieldGet5 === void 0 || _classPrivateFieldGet5.continue();
    }
    /** @internal */ onOnline() {
        var _classPrivateFieldGet6;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer === null || observer === void 0 || observer.refetch({
            cancelRefetch: false
        });
        (_classPrivateFieldGet6 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_retryer, this)) === null || _classPrivateFieldGet6 === void 0 || _classPrivateFieldGet6.continue();
    }
    /** @internal */ addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_cache, this).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    /** @internal */ removeObserver(observer) {
        const index = this.observers.indexOf(observer);
        if (index !== -1) {
            this.observers.splice(index, 1);
            if (!this.observers.length) {
                if ((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_retryer, this)) {
                    if ((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_abortSignalConsumed, this) || this.state.fetchStatus === "paused" && this.state.status === "pending") (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_retryer, this).cancel({
                        revert: true
                    });
                    else (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_retryer, this).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_cache, this).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    /**
	* Returns the number of observers currently subscribed to this query.
	*
	* @example
	* ```ts
	* if (query.getObserversCount() === 0) {
	*   // no component is currently watching this query
	* }
	* ```
	*/ getObserversCount() {
        return this.observers.length;
    }
    /**
	* Marks the query as invalidated, unless it is already invalidated. This
	* updates `state.isInvalidated` and notifies observers, but does not by
	* itself trigger a refetch.
	*
	* @example
	* ```ts
	* query.invalidate()
	* ```
	*/ invalidate() {
        if (!this.state.isInvalidated) (0, $2a8ed1c9c5679810$export$43caf9889c228507)($d3cc80c94d2af732$var$_Query_brand, this, $d3cc80c94d2af732$var$_dispatch).call(this, {
            type: "invalidate"
        });
    }
    /**
	* Fetches the query, i.e. runs its `queryFn` (through any configured
	* retryer/behavior) and updates the query's state with the result.
	* - If a fetch is already in flight, returns its promise instead of
	*   starting a new one, unless `fetchOptions.cancelRefetch` is set and the
	*   query already has data, in which case the current fetch is silently
	*   cancelled first.
	* - If `options` is passed, it replaces the query's current options
	*   before fetching.
	*/ async fetch(options, fetchOptions) {
        var _classPrivateFieldGet7, _context$fetchOptions;
        if (this.state.fetchStatus !== "idle" && ((_classPrivateFieldGet7 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_retryer, this)) === null || _classPrivateFieldGet7 === void 0 ? void 0 : _classPrivateFieldGet7.status()) !== "rejected") {
            if (this.state.data !== void 0 && (fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_retryer, this)) {
                (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_retryer, this).continueRetry();
                return (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_retryer, this).promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($d3cc80c94d2af732$var$_abortSignalConsumed, this, true);
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $e9d6dc959f196f70$export$c71c44209368a3bc)(this.options, fetchOptions);
            const createQueryFnContext = ()=>{
                const queryFnContext = {
                    client: (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_client, this),
                    queryKey: this.queryKey,
                    meta: this.meta
                };
                addSignalProperty(queryFnContext);
                return queryFnContext;
            };
            const queryFnContext = createQueryFnContext();
            (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($d3cc80c94d2af732$var$_abortSignalConsumed, this, false);
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const createFetchContext = ()=>{
            const context = {
                fetchOptions: fetchOptions,
                options: this.options,
                queryKey: this.queryKey,
                client: (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_client, this),
                state: this.state,
                fetchFn: fetchFn
            };
            addSignalProperty(context);
            return context;
        };
        const context = createFetchContext();
        const behavior = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_queryType, this) === "infinite" ? (0, $0297628cdc6ea7c0$export$84470d1367601e8d)(this.options.pages) : this.options.behavior;
        behavior === null || behavior === void 0 || behavior.onFetch(context, this);
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($d3cc80c94d2af732$var$_revertState, this, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) === null || _context$fetchOptions === void 0 ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            (0, $2a8ed1c9c5679810$export$43caf9889c228507)($d3cc80c94d2af732$var$_Query_brand, this, $d3cc80c94d2af732$var$_dispatch).call(this, {
                type: "fetch",
                meta: (_context$fetchOptions2 = context.fetchOptions) === null || _context$fetchOptions2 === void 0 ? void 0 : _context$fetchOptions2.meta
            });
        }
        const retryer = (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($d3cc80c94d2af732$var$_retryer, this, (0, $c0d8ccc060892ed3$export$2cbd00fe8a2c8d85)({
            initialPromise: fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.initialPromise,
            fn: context.fetchFn,
            onCancel: (error)=>{
                if (error instanceof (0, $c0d8ccc060892ed3$export$a8430ed4188f35a9) && error.revert) this.setState({
                    ...(0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_revertState, this),
                    fetchStatus: "idle"
                });
                abortController.abort();
            },
            onFail: (failureCount, error)=>{
                (0, $2a8ed1c9c5679810$export$43caf9889c228507)($d3cc80c94d2af732$var$_Query_brand, this, $d3cc80c94d2af732$var$_dispatch).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $2a8ed1c9c5679810$export$43caf9889c228507)($d3cc80c94d2af732$var$_Query_brand, this, $d3cc80c94d2af732$var$_dispatch).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $2a8ed1c9c5679810$export$43caf9889c228507)($d3cc80c94d2af732$var$_Query_brand, this, $d3cc80c94d2af732$var$_dispatch).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        }));
        try {
            var _classPrivateFieldGet8, _classPrivateFieldGet9, _classPrivateFieldGet10, _classPrivateFieldGet11;
            const data = await retryer.start();
            if (data === void 0) throw new Error(`${this.queryHash} data is undefined`);
            this.setData(data);
            (_classPrivateFieldGet8 = (_classPrivateFieldGet9 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_cache, this).config).onSuccess) === null || _classPrivateFieldGet8 === void 0 || _classPrivateFieldGet8.call(_classPrivateFieldGet9, data, this);
            (_classPrivateFieldGet10 = (_classPrivateFieldGet11 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_cache, this).config).onSettled) === null || _classPrivateFieldGet10 === void 0 || _classPrivateFieldGet10.call(_classPrivateFieldGet11, data, this.state.error, this);
            return data;
        } catch (error) {
            var _classPrivateFieldGet12, _classPrivateFieldGet13, _classPrivateFieldGet14, _classPrivateFieldGet15;
            if (error instanceof (0, $c0d8ccc060892ed3$export$a8430ed4188f35a9)) {
                if (error.silent) return (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_retryer, this).promise;
                else if (error.revert) {
                    if (this.state.data === void 0) throw error;
                    return this.state.data;
                }
            }
            (0, $2a8ed1c9c5679810$export$43caf9889c228507)($d3cc80c94d2af732$var$_Query_brand, this, $d3cc80c94d2af732$var$_dispatch).call(this, {
                type: "error",
                error: error
            });
            (_classPrivateFieldGet12 = (_classPrivateFieldGet13 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_cache, this).config).onError) === null || _classPrivateFieldGet12 === void 0 || _classPrivateFieldGet12.call(_classPrivateFieldGet13, error, this);
            (_classPrivateFieldGet14 = (_classPrivateFieldGet15 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_cache, this).config).onSettled) === null || _classPrivateFieldGet14 === void 0 || _classPrivateFieldGet14.call(_classPrivateFieldGet15, this.state.data, error, this);
            throw error;
        } finally{
            if ((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_retryer, this) === retryer) (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($d3cc80c94d2af732$var$_retryer, this, void 0);
            this.scheduleGc();
        }
    }
};
function $d3cc80c94d2af732$var$_dispatch(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    ...$d3cc80c94d2af732$export$f3df9013f2b58bce(state.data, this.options),
                    fetchMeta: action.meta ?? null
                };
            case "success":
                const newState = {
                    ...state,
                    ...$d3cc80c94d2af732$var$successState(action.data, action.dataUpdatedAt),
                    dataUpdateCount: state.dataUpdateCount + 1,
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
                (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($d3cc80c94d2af732$var$_revertState, this, action.manual ? newState : void 0);
                return newState;
            case "error":
                const error = action.error;
                return {
                    ...state,
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error",
                    isInvalidated: true
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>{
        this.observers.slice().forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($d3cc80c94d2af732$var$_cache, this).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
}
function $d3cc80c94d2af732$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $c0d8ccc060892ed3$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $d3cc80c94d2af732$var$successState(data, dataUpdatedAt) {
    return {
        data: data,
        dataUpdatedAt: dataUpdatedAt ?? Date.now(),
        error: null,
        isInvalidated: false,
        status: "success"
    };
}
function $d3cc80c94d2af732$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}


//#region src/queryObserver.ts
var $f34a2001660d7650$var$_client = /* @__PURE__ */ new WeakMap();
var $f34a2001660d7650$var$_currentQuery = /* @__PURE__ */ new WeakMap();
var $f34a2001660d7650$var$_currentQueryInitialState = /* @__PURE__ */ new WeakMap();
var $f34a2001660d7650$var$_currentResult = /* @__PURE__ */ new WeakMap();
var $f34a2001660d7650$var$_currentResultState = /* @__PURE__ */ new WeakMap();
var $f34a2001660d7650$var$_currentResultOptions = /* @__PURE__ */ new WeakMap();
var $f34a2001660d7650$var$_selectError = /* @__PURE__ */ new WeakMap();
var $f34a2001660d7650$var$_selectFn = /* @__PURE__ */ new WeakMap();
var $f34a2001660d7650$var$_selectResult = /* @__PURE__ */ new WeakMap();
var $f34a2001660d7650$var$_lastQueryWithDefinedData = /* @__PURE__ */ new WeakMap();
var $f34a2001660d7650$var$_staleTimeoutId = /* @__PURE__ */ new WeakMap();
var $f34a2001660d7650$var$_refetchIntervalId = /* @__PURE__ */ new WeakMap();
var $f34a2001660d7650$var$_currentRefetchInterval = /* @__PURE__ */ new WeakMap();
var $f34a2001660d7650$var$_trackedProps = /* @__PURE__ */ new WeakMap();
var $f34a2001660d7650$var$_QueryObserver_brand = /* @__PURE__ */ new WeakSet();
/**
* A `QueryObserver` watches a single query in the `QueryCache` and computes a
* `QueryObserverResult` from its state, recomputing and notifying subscribers
* whenever the underlying query (or the observer's options) changes. It is
* the primitive that framework adapters (e.g. `useQuery`) build their hooks
* on top of, but it can also be used directly to observe and switch between
* queries outside of any framework.
*
* @example
* ```ts
* const observer = new QueryObserver(queryClient, {
*   queryKey: ['posts'],
*   queryFn: fetchPosts,
* })
*
* const unsubscribe = observer.subscribe((result) => {
*   console.log(result.data)
* })
* ```
*/ var $f34a2001660d7650$export$a06cf8c0066f0d4c = class extends (0, $78d76f0c1d823036$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.options = options;
        (0, $319cb07e0a96d91d$export$625550452a3fa3ec)(this, $f34a2001660d7650$var$_QueryObserver_brand);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $f34a2001660d7650$var$_client, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $f34a2001660d7650$var$_currentQuery, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $f34a2001660d7650$var$_currentQueryInitialState, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $f34a2001660d7650$var$_currentResult, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $f34a2001660d7650$var$_currentResultState, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $f34a2001660d7650$var$_currentResultOptions, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $f34a2001660d7650$var$_selectError, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $f34a2001660d7650$var$_selectFn, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $f34a2001660d7650$var$_selectResult, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $f34a2001660d7650$var$_lastQueryWithDefinedData, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $f34a2001660d7650$var$_staleTimeoutId, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $f34a2001660d7650$var$_refetchIntervalId, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $f34a2001660d7650$var$_currentRefetchInterval, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $f34a2001660d7650$var$_trackedProps, /* @__PURE__ */ new Set());
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($f34a2001660d7650$var$_client, this, client);
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($f34a2001660d7650$var$_selectError, this, null);
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this).addObserver(this);
            if ($f34a2001660d7650$var$shouldFetchOnMount((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this), this.options)) (0, $2a8ed1c9c5679810$export$43caf9889c228507)($f34a2001660d7650$var$_QueryObserver_brand, this, $f34a2001660d7650$var$_executeFetch).call(this);
            else this.updateResult();
            (0, $2a8ed1c9c5679810$export$43caf9889c228507)($f34a2001660d7650$var$_QueryObserver_brand, this, $f34a2001660d7650$var$_updateTimers).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    /**
	* Returns whether the observed query is currently stale and configured
	* (via the `refetchOnReconnect` option) to refetch when the network
	* reconnects.
	*/ shouldFetchOnReconnect() {
        return $f34a2001660d7650$var$shouldFetchOn((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this), this.options, this.options.refetchOnReconnect);
    }
    /**
	* Returns whether the observed query is currently stale and configured
	* (via the `refetchOnWindowFocus` option) to refetch when the window
	* regains focus.
	*/ shouldFetchOnWindowFocus() {
        return $f34a2001660d7650$var$shouldFetchOn((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this), this.options, this.options.refetchOnWindowFocus);
    }
    /**
	* Stops observing the current query: clears all listeners, cancels the
	* stale and refetch-interval timers, and removes this observer from the
	* query it was observing.
	*/ destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $2a8ed1c9c5679810$export$43caf9889c228507)($f34a2001660d7650$var$_QueryObserver_brand, this, $f34a2001660d7650$var$_clearStaleTimeout).call(this);
        (0, $2a8ed1c9c5679810$export$43caf9889c228507)($f34a2001660d7650$var$_QueryObserver_brand, this, $f34a2001660d7650$var$_clearRefetchInterval).call(this);
        (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this).removeObserver(this);
    }
    /**
	* Updates the observer's options. This will re-resolve the query being
	* observed (switching to a different query if the `queryKey` changed),
	* trigger a fetch if the new options require one and the observer has
	* subscribers, recompute the current result, and reschedule the stale and
	* refetch-interval timers as needed.
	*
	* @example
	* ```ts
	* observer.setOptions({ queryKey: ['posts', 1], queryFn: () => fetchPost(1) })
	* // later: switch to a different query, reusing the same observer
	* observer.setOptions({ queryKey: ['posts', 2], queryFn: () => fetchPost(2) })
	* ```
	*/ setOptions(options) {
        const prevOptions = this.options;
        const prevQuery = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this);
        this.options = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_client, this).defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, $e9d6dc959f196f70$export$e36731f6aa6a4362)(this.options.enabled, (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this)) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        (0, $2a8ed1c9c5679810$export$43caf9889c228507)($f34a2001660d7650$var$_QueryObserver_brand, this, $f34a2001660d7650$var$_updateQuery).call(this);
        (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this).setOptions(this.options);
        if (prevOptions._defaulted && !(0, $e9d6dc959f196f70$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_client, this).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this),
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $f34a2001660d7650$var$shouldFetchOptionally((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this), prevQuery, this.options, prevOptions)) (0, $2a8ed1c9c5679810$export$43caf9889c228507)($f34a2001660d7650$var$_QueryObserver_brand, this, $f34a2001660d7650$var$_executeFetch).call(this);
        this.updateResult();
        if (mounted && ((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this) !== prevQuery || (0, $e9d6dc959f196f70$export$e36731f6aa6a4362)(this.options.enabled, (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this)) !== (0, $e9d6dc959f196f70$export$e36731f6aa6a4362)(prevOptions.enabled, (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this)) || (0, $e9d6dc959f196f70$export$e36731f6aa6a4362)(this.options.staleTime, (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this)) !== (0, $e9d6dc959f196f70$export$e36731f6aa6a4362)(prevOptions.staleTime, (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this)))) (0, $2a8ed1c9c5679810$export$43caf9889c228507)($f34a2001660d7650$var$_QueryObserver_brand, this, $f34a2001660d7650$var$_updateStaleTimeout).call(this);
        const nextRefetchInterval = (0, $2a8ed1c9c5679810$export$43caf9889c228507)($f34a2001660d7650$var$_QueryObserver_brand, this, $f34a2001660d7650$var$_computeRefetchInterval).call(this);
        if (mounted && ((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this) !== prevQuery || (0, $e9d6dc959f196f70$export$e36731f6aa6a4362)(this.options.enabled, (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this)) !== (0, $e9d6dc959f196f70$export$e36731f6aa6a4362)(prevOptions.enabled, (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this)) || nextRefetchInterval !== (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentRefetchInterval, this))) (0, $2a8ed1c9c5679810$export$43caf9889c228507)($f34a2001660d7650$var$_QueryObserver_brand, this, $f34a2001660d7650$var$_updateRefetchInterval).call(this, nextRefetchInterval);
    }
    /**
	* Computes the result the observer would produce for the given (already-defaulted) options
	* right now, building the underlying `Query` if it doesn't exist yet, without waiting for a
	* subscription callback. Called by framework adapters on every render (e.g. `useQuery`) so the
	* returned value is available synchronously, ahead of `setOptions` triggering an actual fetch.
	*/ getOptimisticResult(options) {
        const query = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_client, this).getQueryCache().build((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_client, this), options);
        const result = this.createResult(query, options);
        if (!(0, $e9d6dc959f196f70$export$3e67810a3f0e9f1c)(this.getCurrentResult(), result)) {
            (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($f34a2001660d7650$var$_currentResult, this, result);
            (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($f34a2001660d7650$var$_currentResultOptions, this, this.options);
            (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($f34a2001660d7650$var$_currentResultState, this, (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this).state);
        }
        return result;
    }
    /**
	* Returns the most recently computed `QueryObserverResult` for the
	* observed query. This is a point-in-time read; to be notified of updates
	* as they happen, subscribe to the observer instead (its inherited
	* `subscribe` method).
	*
	* @example
	* ```ts
	* const result = observer.getCurrentResult()
	* console.log(result.status, result.data)
	* ```
	*/ getCurrentResult() {
        return (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentResult, this);
    }
    /**
	* Wraps a `QueryObserverResult` in a `Proxy` that records which properties are read, via
	* {@link QueryObserver#trackProp} (and an optional `onPropTracked` callback). Used by framework
	* adapters when `notifyOnChangeProps` is not set, to implement its default "only re-render on
	* properties you actually read" behavior.
	*/ trackResult(result, onPropTracked) {
        return new Proxy(result, {
            get: (target, key)=>{
                this.trackProp(key);
                onPropTracked === null || onPropTracked === void 0 || onPropTracked(key);
                return Reflect.get(target, key);
            }
        });
    }
    /**
	* Records that the given `QueryObserverResult` property was read, so a subsequent update only
	* notifies this observer if a tracked property actually changed. Normally called indirectly via
	* {@link QueryObserver#trackResult}'s proxy; exposed directly for adapters that track property
	* access themselves (e.g. through their own reactivity system) instead of via the proxy.
	*/ trackProp(key) {
        (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_trackedProps, this).add(key);
    }
    /**
	* Returns the `Query` instance this observer is currently observing.
	*/ getCurrentQuery() {
        return (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this);
    }
    /**
	* Refetches the observed query and returns a promise that resolves with
	* the resulting `QueryObserverResult`.
	*
	* @example
	* ```ts
	* const result = await observer.refetch({ cancelRefetch: false })
	* console.log(result.data)
	* ```
	*/ refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    /**
	* Fetches a query defined by the given options without affecting this
	* observer's own tracked query or result, and returns a promise that
	* resolves with the `QueryObserverResult` for that fetch. This is useful
	* for prefetching data that another observer (e.g. a query about to be
	* navigated to) will need, ahead of time.
	*
	* @example
	* ```ts
	* const result = await observer.fetchOptimistic({
	*   queryKey: ['posts', 2],
	*   queryFn: () => fetchPost(2),
	* })
	* console.log(result.data)
	* ```
	*/ fetchOptimistic(options) {
        const defaultedOptions = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_client, this).defaultQueryOptions(options);
        const query = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_client, this).getQueryCache().build((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_client, this), defaultedOptions);
        let unsubscribe = ()=>{};
        let resolveEarly;
        const cachePromise = new Promise((resolve)=>{
            resolveEarly = resolve;
            unsubscribe = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_client, this).getQueryCache().subscribe((event)=>{
                if (event.type === "updated" && event.query.queryHash === query.queryHash && query.state.data !== void 0) {
                    unsubscribe();
                    resolve(this.createResult(query, defaultedOptions));
                }
            });
        });
        return Promise.race([
            query.fetch().then(()=>{
                const result = this.createResult(query, defaultedOptions);
                resolveEarly === null || resolveEarly === void 0 || resolveEarly(result);
                return result;
            }).finally(()=>{
                unsubscribe();
            }),
            cachePromise
        ]);
    }
    fetch(fetchOptions) {
        return (0, $2a8ed1c9c5679810$export$43caf9889c228507)($f34a2001660d7650$var$_QueryObserver_brand, this, $f34a2001660d7650$var$_executeFetch).call(this, {
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentResult, this);
        });
    }
    createResult(query, options) {
        const prevQuery = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this);
        const prevOptions = this.options;
        const prevResult = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentResult, this);
        const prevResultState = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentResultState, this);
        const prevResultOptions = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentResultOptions, this);
        const queryInitialState = query !== prevQuery ? query.state : (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQueryInitialState, this);
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $f34a2001660d7650$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $f34a2001660d7650$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $d3cc80c94d2af732$export$f3df9013f2b58bce)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        data = newState.data;
        let skipSelect = false;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if ((prevResult === null || prevResult === void 0 ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions === null || prevResultOptions === void 0 ? void 0 : prevResultOptions.placeholderData)) {
                placeholderData = prevResult.data;
                skipSelect = true;
            } else {
                var _classPrivateFieldGet2$1;
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_classPrivateFieldGet2$1 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_lastQueryWithDefinedData, this)) === null || _classPrivateFieldGet2$1 === void 0 ? void 0 : _classPrivateFieldGet2$1.state.data, (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_lastQueryWithDefinedData, this)) : options.placeholderData;
            }
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $e9d6dc959f196f70$export$17619bac5b909b23)(prevResult === null || prevResult === void 0 ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (options.select && data !== void 0 && !skipSelect) {
            if (prevResult && data === (prevResultState === null || prevResultState === void 0 ? void 0 : prevResultState.data) && options.select === (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_selectFn, this)) data = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_selectResult, this);
            else try {
                (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($f34a2001660d7650$var$_selectFn, this, options.select);
                data = options.select(data);
                data = (0, $e9d6dc959f196f70$export$17619bac5b909b23)(prevResult === null || prevResult === void 0 ? void 0 : prevResult.data, data, options);
                (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($f34a2001660d7650$var$_selectResult, this, data);
                (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($f34a2001660d7650$var$_selectError, this, null);
            } catch (selectError) {
                (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($f34a2001660d7650$var$_selectError, this, selectError);
            }
        } else if (data === void 0) (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($f34a2001660d7650$var$_selectError, this, null);
        if ((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_selectError, this)) {
            error = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_selectError, this);
            data = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_selectResult, this);
            errorUpdatedAt = Date.now();
            status = "error";
            isPlaceholderData = false;
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        return {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: query.isFetched(),
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $f34a2001660d7650$var$isStale(query, options),
            refetch: this.refetch,
            isEnabled: (0, $e9d6dc959f196f70$export$e36731f6aa6a4362)(options.enabled, query) !== false
        };
    }
    /**
	* Recomputes and stores the current result from the current query/options, notifying listeners
	* if it changed. Framework adapters call this right after subscribing to make sure no query
	* update was missed in the gap between creating the observer and subscribing to it.
	*/ updateResult() {
        const prevResult = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentResult, this);
        const nextResult = this.createResult((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this), this.options);
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($f34a2001660d7650$var$_currentResultState, this, (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this).state);
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($f34a2001660d7650$var$_currentResultOptions, this, this.options);
        if ((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentResultState, this).data !== void 0) (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($f34a2001660d7650$var$_lastQueryWithDefinedData, this, (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this));
        if ((0, $e9d6dc959f196f70$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($f34a2001660d7650$var$_currentResult, this, nextResult);
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_trackedProps, this).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_trackedProps, this));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentResult, this)).some((key)=>{
                const typedKey = key;
                return (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentResult, this)[typedKey] !== prevResult[typedKey] && includedProps.has(typedKey);
            });
        };
        const notifyListeners = shouldNotifyListeners();
        (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>{
            if (notifyListeners) this.listeners.forEach((listener)=>{
                listener((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentResult, this));
            });
            (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_client, this).getQueryCache().notify({
                query: (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this),
                type: "observerResultsUpdated"
            });
        });
    }
    /** @internal */ onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, $2a8ed1c9c5679810$export$43caf9889c228507)($f34a2001660d7650$var$_QueryObserver_brand, this, $f34a2001660d7650$var$_updateTimers).call(this);
    }
};
function $f34a2001660d7650$var$_executeFetch(fetchOptions) {
    (0, $2a8ed1c9c5679810$export$43caf9889c228507)($f34a2001660d7650$var$_QueryObserver_brand, this, $f34a2001660d7650$var$_updateQuery).call(this);
    let promise = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this).fetch(this.options, fetchOptions);
    if (!(fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $e9d6dc959f196f70$export$8793edee2d425525));
    return promise;
}
function $f34a2001660d7650$var$_shouldScheduleTimer(timeout) {
    return !(0, $fc249fd5f601b92a$export$6acf61af03e62db)() && (0, $e9d6dc959f196f70$export$e36731f6aa6a4362)(this.options.enabled, (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this)) !== false && (0, $e9d6dc959f196f70$export$e539f754e934e270)(timeout);
}
function $f34a2001660d7650$var$_updateStaleTimeout() {
    (0, $2a8ed1c9c5679810$export$43caf9889c228507)($f34a2001660d7650$var$_QueryObserver_brand, this, $f34a2001660d7650$var$_clearStaleTimeout).call(this);
    const staleTime = (0, $e9d6dc959f196f70$export$e36731f6aa6a4362)(this.options.staleTime, (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this));
    if ((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentResult, this).isStale || !(0, $2a8ed1c9c5679810$export$43caf9889c228507)($f34a2001660d7650$var$_QueryObserver_brand, this, $f34a2001660d7650$var$_shouldScheduleTimer).call(this, staleTime)) return;
    const timeout = (0, $e9d6dc959f196f70$export$811b83d62bcf47f0)((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentResult, this).dataUpdatedAt, staleTime) + 1;
    (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($f34a2001660d7650$var$_staleTimeoutId, this, (0, $c256c6d36f9f33f6$export$94a2700736e69372).setTimeout(()=>{
        if (!(0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentResult, this).isStale) this.updateResult();
    }, timeout));
}
function $f34a2001660d7650$var$_computeRefetchInterval() {
    return (0, $e9d6dc959f196f70$export$e36731f6aa6a4362)(this.options.refetchInterval, (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this)) ?? false;
}
function $f34a2001660d7650$var$_updateRefetchInterval(nextInterval) {
    (0, $2a8ed1c9c5679810$export$43caf9889c228507)($f34a2001660d7650$var$_QueryObserver_brand, this, $f34a2001660d7650$var$_clearRefetchInterval).call(this);
    (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($f34a2001660d7650$var$_currentRefetchInterval, this, nextInterval);
    if ((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentRefetchInterval, this) === 0 || !(0, $2a8ed1c9c5679810$export$43caf9889c228507)($f34a2001660d7650$var$_QueryObserver_brand, this, $f34a2001660d7650$var$_shouldScheduleTimer).call(this, (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentRefetchInterval, this))) return;
    (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($f34a2001660d7650$var$_refetchIntervalId, this, (0, $c256c6d36f9f33f6$export$94a2700736e69372).setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, $780e8903dcf2df97$export$6bf54661be5b02cf).isFocused()) (0, $2a8ed1c9c5679810$export$43caf9889c228507)($f34a2001660d7650$var$_QueryObserver_brand, this, $f34a2001660d7650$var$_executeFetch).call(this);
    }, (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentRefetchInterval, this)));
}
function $f34a2001660d7650$var$_updateTimers() {
    (0, $2a8ed1c9c5679810$export$43caf9889c228507)($f34a2001660d7650$var$_QueryObserver_brand, this, $f34a2001660d7650$var$_updateStaleTimeout).call(this);
    (0, $2a8ed1c9c5679810$export$43caf9889c228507)($f34a2001660d7650$var$_QueryObserver_brand, this, $f34a2001660d7650$var$_updateRefetchInterval).call(this, (0, $2a8ed1c9c5679810$export$43caf9889c228507)($f34a2001660d7650$var$_QueryObserver_brand, this, $f34a2001660d7650$var$_computeRefetchInterval).call(this));
}
function $f34a2001660d7650$var$_clearStaleTimeout() {
    if ((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_staleTimeoutId, this) !== void 0) {
        (0, $c256c6d36f9f33f6$export$94a2700736e69372).clearTimeout((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_staleTimeoutId, this));
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($f34a2001660d7650$var$_staleTimeoutId, this, void 0);
    }
}
function $f34a2001660d7650$var$_clearRefetchInterval() {
    if ((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_refetchIntervalId, this) !== void 0) {
        (0, $c256c6d36f9f33f6$export$94a2700736e69372).clearInterval((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_refetchIntervalId, this));
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($f34a2001660d7650$var$_refetchIntervalId, this, void 0);
    }
}
function $f34a2001660d7650$var$_updateQuery() {
    const query = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_client, this).getQueryCache().build((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_client, this), this.options);
    if (query === (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this)) return;
    const prevQuery = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($f34a2001660d7650$var$_currentQuery, this);
    (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($f34a2001660d7650$var$_currentQuery, this, query);
    (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($f34a2001660d7650$var$_currentQueryInitialState, this, query.state);
    if (this.hasListeners()) {
        prevQuery === null || prevQuery === void 0 || prevQuery.removeObserver(this);
        query.addObserver(this);
    }
}
function $f34a2001660d7650$var$shouldLoadOnMount(query, options) {
    return (0, $e9d6dc959f196f70$export$e36731f6aa6a4362)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && (0, $e9d6dc959f196f70$export$e36731f6aa6a4362)(options.retryOnMount, query) === false);
}
function $f34a2001660d7650$var$shouldFetchOnMount(query, options) {
    return $f34a2001660d7650$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $f34a2001660d7650$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $f34a2001660d7650$var$shouldFetchOn(query, options, field) {
    if ((0, $e9d6dc959f196f70$export$e36731f6aa6a4362)(options.enabled, query) !== false && (0, $e9d6dc959f196f70$export$e36731f6aa6a4362)(options.staleTime, query) !== "static") {
        const value = (0, $e9d6dc959f196f70$export$e36731f6aa6a4362)(field, query);
        return value === "always" || value !== false && $f34a2001660d7650$var$isStale(query, options);
    }
    return false;
}
function $f34a2001660d7650$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, $e9d6dc959f196f70$export$e36731f6aa6a4362)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && $f34a2001660d7650$var$isStale(query, options);
}
function $f34a2001660d7650$var$isStale(query, options) {
    return (0, $e9d6dc959f196f70$export$e36731f6aa6a4362)(options.enabled, query) !== false && query.isStaleByTime((0, $e9d6dc959f196f70$export$e36731f6aa6a4362)(options.staleTime, query));
}


"use client";
//#region src/useQuery.ts
function $4b398c1589a0f1e2$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $bccea28e74b4fdc0$export$fff0865807e996c5)(options, (0, $f34a2001660d7650$export$a06cf8c0066f0d4c), queryClient);
}





var $5FkrB = parcelRequire("5FkrB");
const $ff8369db971fa1a8$export$237dc0bae177ad41 = {
    user: null,
    isLoggedIn: false,
    loggedInUser: undefined
};
function $ff8369db971fa1a8$export$299abcbcbe81ab38(user) {
    if (!user) return {
        isLoggedIn: false,
        loggedInUser: undefined
    };
    return {
        isLoggedIn: true,
        loggedInUser: {
            id: user.account_id,
            publicName: user.name || user.nickname || user.email || '',
            avatar: user.picture || '',
            email: user.email
        }
    };
}
const $ff8369db971fa1a8$export$b3aa4dbb59e7857d = (state, action)=>{
    switch(action.type){
        case 'AUTHENTICATE':
            {
                const user = action.payload.user;
                return {
                    user: user,
                    ...$ff8369db971fa1a8$export$299abcbcbe81ab38(user)
                };
            }
        default:
            return state;
    }
};


parcelRequire("5FkrB");

var $2d94d3bb9b62d159$exports = {};
$parcel$export($2d94d3bb9b62d159$exports, "AdminIcon", () => $2d94d3bb9b62d159$export$ef8e5f836dd989d3);
$parcel$export($2d94d3bb9b62d159$exports, "AdminLogo", () => $2d94d3bb9b62d159$export$ebcd30672e67406);
$parcel$export($2d94d3bb9b62d159$exports, "AnalyticsIcon", () => $2d94d3bb9b62d159$export$af3460f51ce3602a);
$parcel$export($2d94d3bb9b62d159$exports, "AnalyticsLogo", () => $2d94d3bb9b62d159$export$c8415b6abe4a8587);
$parcel$export($2d94d3bb9b62d159$exports, "AssetsIcon", () => $2d94d3bb9b62d159$export$d89497e7f33ca6f5);
$parcel$export($2d94d3bb9b62d159$exports, "AssetsLogo", () => $2d94d3bb9b62d159$export$48ca930f3071e3e4);
$parcel$export($2d94d3bb9b62d159$exports, "ChatIcon", () => $2d94d3bb9b62d159$export$52cd484a7ef4f2b9);
$parcel$export($2d94d3bb9b62d159$exports, "ChatLogo", () => $2d94d3bb9b62d159$export$9ca9881809919df8);
$parcel$export($2d94d3bb9b62d159$exports, "CustomerServiceManagementIcon", () => $2d94d3bb9b62d159$export$6da5aa77c402ba0f);
$parcel$export($2d94d3bb9b62d159$exports, "CustomerServiceManagementLogo", () => $2d94d3bb9b62d159$export$abc95e6180bb1d88);
$parcel$export($2d94d3bb9b62d159$exports, "FeedbackIcon", () => $2d94d3bb9b62d159$export$34420f0520b19b1d);
$parcel$export($2d94d3bb9b62d159$exports, "FeedbackLogo", () => $2d94d3bb9b62d159$export$c9696eb3c34c5a96);
$parcel$export($2d94d3bb9b62d159$exports, "GoalsIcon", () => $2d94d3bb9b62d159$export$9eb74917ea768ed4);
$parcel$export($2d94d3bb9b62d159$exports, "GoalsLogo", () => $2d94d3bb9b62d159$export$d2577aa28451395f);
$parcel$export($2d94d3bb9b62d159$exports, "HomeIcon", () => $2d94d3bb9b62d159$export$92c8767b874048d);
$parcel$export($2d94d3bb9b62d159$exports, "HomeLogo", () => $2d94d3bb9b62d159$export$d5648119d5b68e90);
$parcel$export($2d94d3bb9b62d159$exports, "HubIcon", () => $2d94d3bb9b62d159$export$80b8b269d8b5014e);
$parcel$export($2d94d3bb9b62d159$exports, "HubLogo", () => $2d94d3bb9b62d159$export$fc9bd6687b80fe3b);
$parcel$export($2d94d3bb9b62d159$exports, "ProjectsIcon", () => $2d94d3bb9b62d159$export$5ed3e1bb3b04fc02);
$parcel$export($2d94d3bb9b62d159$exports, "ProjectsLogo", () => $2d94d3bb9b62d159$export$aeefab651bcf2338);
$parcel$export($2d94d3bb9b62d159$exports, "RovoDevIcon", () => $2d94d3bb9b62d159$export$8b784b3227531b3e);
$parcel$export($2d94d3bb9b62d159$exports, "RovoDevLogo", () => $2d94d3bb9b62d159$export$f0750468d67c6902);
$parcel$export($2d94d3bb9b62d159$exports, "RovoDevAgentIcon", () => $2d94d3bb9b62d159$export$813cff80931d9dbf);
$parcel$export($2d94d3bb9b62d159$exports, "RovoDevAgentLogo", () => $2d94d3bb9b62d159$export$409b7a5b7f180eba);
$parcel$export($2d94d3bb9b62d159$exports, "JiraCodingAgentIcon", () => $2d94d3bb9b62d159$export$b12fec207e8537a8);
$parcel$export($2d94d3bb9b62d159$exports, "SearchIcon", () => $2d94d3bb9b62d159$export$82eafebb825fc23f);
$parcel$export($2d94d3bb9b62d159$exports, "SearchLogo", () => $2d94d3bb9b62d159$export$e4c5487c9a8ae3b1);
$parcel$export($2d94d3bb9b62d159$exports, "StudioIcon", () => $2d94d3bb9b62d159$export$290a0f24614cde9f);
$parcel$export($2d94d3bb9b62d159$exports, "StudioLogo", () => $2d94d3bb9b62d159$export$8aceb78c659789b6);
$parcel$export($2d94d3bb9b62d159$exports, "TalentIcon", () => $2d94d3bb9b62d159$export$4b05688514531169);
$parcel$export($2d94d3bb9b62d159$exports, "TalentLogo", () => $2d94d3bb9b62d159$export$4f6453e012279f89);
$parcel$export($2d94d3bb9b62d159$exports, "TeamsIcon", () => $2d94d3bb9b62d159$export$1bcbc9c337da86da);
$parcel$export($2d94d3bb9b62d159$exports, "TeamsLogo", () => $2d94d3bb9b62d159$export$9b1a0a0c574cec2a);
$parcel$export($2d94d3bb9b62d159$exports, "BambooIcon", () => $2d94d3bb9b62d159$export$e812398311cab9a3);
$parcel$export($2d94d3bb9b62d159$exports, "BambooLogo", () => $2d94d3bb9b62d159$export$765f5afcc1a5a7e3);
$parcel$export($2d94d3bb9b62d159$exports, "BitbucketDataCenterIcon", () => $2d94d3bb9b62d159$export$d3ab16bbf4f954ee);
$parcel$export($2d94d3bb9b62d159$exports, "BitbucketDataCenterLogo", () => $2d94d3bb9b62d159$export$36044946916e84a0);
$parcel$export($2d94d3bb9b62d159$exports, "ConfluenceDataCenterIcon", () => $2d94d3bb9b62d159$export$53305f1f2855d3be);
$parcel$export($2d94d3bb9b62d159$exports, "ConfluenceDataCenterLogo", () => $2d94d3bb9b62d159$export$5e06396bce773a3);
$parcel$export($2d94d3bb9b62d159$exports, "CrowdIcon", () => $2d94d3bb9b62d159$export$eaf73f391f7103bd);
$parcel$export($2d94d3bb9b62d159$exports, "CrowdLogo", () => $2d94d3bb9b62d159$export$6128b385660fd3c6);
$parcel$export($2d94d3bb9b62d159$exports, "JiraDataCenterIcon", () => $2d94d3bb9b62d159$export$f8455b5667a3ee0c);
$parcel$export($2d94d3bb9b62d159$exports, "JiraDataCenterLogo", () => $2d94d3bb9b62d159$export$eb152ab3801b2ae3);
$parcel$export($2d94d3bb9b62d159$exports, "JiraServiceManagementDataCenterIcon", () => $2d94d3bb9b62d159$export$65fae0eaf343f2ca);
$parcel$export($2d94d3bb9b62d159$exports, "JiraServiceManagementDataCenterLogo", () => $2d94d3bb9b62d159$export$fffc0d480fb1ebf1);
$parcel$export($2d94d3bb9b62d159$exports, "AtlassianAdministrationIcon", () => $2d94d3bb9b62d159$export$74517ed253186308);
$parcel$export($2d94d3bb9b62d159$exports, "AtlassianAdministrationLogo", () => $2d94d3bb9b62d159$export$833abe6c2ce5ebfd);
$parcel$export($2d94d3bb9b62d159$exports, "AtlassianAdminIcon", () => $2d94d3bb9b62d159$export$84109e099492cb5f);
$parcel$export($2d94d3bb9b62d159$exports, "AtlassianAdminLogo", () => $2d94d3bb9b62d159$export$f845d9b9254f0541);
$parcel$export($2d94d3bb9b62d159$exports, "AtlassianAnalyticsIcon", () => $2d94d3bb9b62d159$export$c42ad8a0b925c762);
$parcel$export($2d94d3bb9b62d159$exports, "AtlassianAnalyticsLogo", () => $2d94d3bb9b62d159$export$e6470bfc39010cc4);
$parcel$export($2d94d3bb9b62d159$exports, "BitbucketIcon", () => $2d94d3bb9b62d159$export$5fc1066e677788d4);
$parcel$export($2d94d3bb9b62d159$exports, "BitbucketLogo", () => $2d94d3bb9b62d159$export$bd40525f5333524b);
$parcel$export($2d94d3bb9b62d159$exports, "CompassIcon", () => $2d94d3bb9b62d159$export$f7857fe64d7161d9);
$parcel$export($2d94d3bb9b62d159$exports, "CompassLogo", () => $2d94d3bb9b62d159$export$eb7d748e4f9c9676);
$parcel$export($2d94d3bb9b62d159$exports, "DxIcon", () => $2d94d3bb9b62d159$export$9951d02c2d848122);
$parcel$export($2d94d3bb9b62d159$exports, "ConfluenceIcon", () => $2d94d3bb9b62d159$export$68f3db7f6af48bcb);
$parcel$export($2d94d3bb9b62d159$exports, "ConfluenceLogo", () => $2d94d3bb9b62d159$export$1b2e4fe6ef471556);
$parcel$export($2d94d3bb9b62d159$exports, "AlignIcon", () => $2d94d3bb9b62d159$export$70a0c2f5862937b6);
$parcel$export($2d94d3bb9b62d159$exports, "AlignLogo", () => $2d94d3bb9b62d159$export$1b8596b4b0ef673b);
$parcel$export($2d94d3bb9b62d159$exports, "JiraAlignIcon", () => $2d94d3bb9b62d159$export$407687b2dd89cc68);
$parcel$export($2d94d3bb9b62d159$exports, "JiraAlignLogo", () => $2d94d3bb9b62d159$export$ee11e928d3d045fd);
$parcel$export($2d94d3bb9b62d159$exports, "JiraIcon", () => $2d94d3bb9b62d159$export$c4b5b1f965d8b3eb);
$parcel$export($2d94d3bb9b62d159$exports, "JiraLogo", () => $2d94d3bb9b62d159$export$17d3acb0b4379d02);
$parcel$export($2d94d3bb9b62d159$exports, "JiraProductDiscoveryIcon", () => $2d94d3bb9b62d159$export$21bfbeb62fdcce8d);
$parcel$export($2d94d3bb9b62d159$exports, "JiraProductDiscoveryLogo", () => $2d94d3bb9b62d159$export$c49a2b642fe9eef4);
$parcel$export($2d94d3bb9b62d159$exports, "JiraServiceManagementIcon", () => $2d94d3bb9b62d159$export$3c6158790f5e01c4);
$parcel$export($2d94d3bb9b62d159$exports, "JiraServiceManagementLogo", () => $2d94d3bb9b62d159$export$dabef2be6cd28c20);
$parcel$export($2d94d3bb9b62d159$exports, "LoomIcon", () => $2d94d3bb9b62d159$export$8d789f76fde3e05);
$parcel$export($2d94d3bb9b62d159$exports, "LoomLogo", () => $2d94d3bb9b62d159$export$94e206806e36c2ec);
$parcel$export($2d94d3bb9b62d159$exports, "LoomAttributionIcon", () => $2d94d3bb9b62d159$export$1bf47cdade1a9fcb);
$parcel$export($2d94d3bb9b62d159$exports, "LoomAttributionLogo", () => $2d94d3bb9b62d159$export$6e87ce8d41eda665);
$parcel$export($2d94d3bb9b62d159$exports, "LoomBlurpleLogo", () => $2d94d3bb9b62d159$export$e84e925618e0e5bc);
$parcel$export($2d94d3bb9b62d159$exports, "LoomBlurpleIcon", () => $2d94d3bb9b62d159$export$1940ba72c868b663);
$parcel$export($2d94d3bb9b62d159$exports, "OpsgenieIcon", () => $2d94d3bb9b62d159$export$eeccc49dc7a12d9f);
$parcel$export($2d94d3bb9b62d159$exports, "OpsgenieLogo", () => $2d94d3bb9b62d159$export$a1c6484cdecc2c4b);
$parcel$export($2d94d3bb9b62d159$exports, "StatuspageIcon", () => $2d94d3bb9b62d159$export$f3f5aa321d88adf9);
$parcel$export($2d94d3bb9b62d159$exports, "StatuspageLogo", () => $2d94d3bb9b62d159$export$bb4ae5b41b43be04);
$parcel$export($2d94d3bb9b62d159$exports, "TrelloIcon", () => $2d94d3bb9b62d159$export$4384da9b8b140bf4);
$parcel$export($2d94d3bb9b62d159$exports, "TrelloLogo", () => $2d94d3bb9b62d159$export$60e26212f3b61a28);
$parcel$export($2d94d3bb9b62d159$exports, "RovoIcon", () => $2d94d3bb9b62d159$export$e23ae35269442b4f);
$parcel$export($2d94d3bb9b62d159$exports, "RovoLogo", () => $2d94d3bb9b62d159$export$a0f6cb8061290bbb);
$parcel$export($2d94d3bb9b62d159$exports, "GuardIcon", () => $2d94d3bb9b62d159$export$3f95fcfdc25a741d);
$parcel$export($2d94d3bb9b62d159$exports, "GuardLogo", () => $2d94d3bb9b62d159$export$a4a891d202775deb);
$parcel$export($2d94d3bb9b62d159$exports, "FocusIcon", () => $2d94d3bb9b62d159$export$1e02e7298035a77c);
$parcel$export($2d94d3bb9b62d159$exports, "FocusLogo", () => $2d94d3bb9b62d159$export$33908560ea1b226d);
$parcel$export($2d94d3bb9b62d159$exports, "CompanyHubIcon", () => $2d94d3bb9b62d159$export$5ef3f25e16249826);
$parcel$export($2d94d3bb9b62d159$exports, "CompanyHubLogo", () => $2d94d3bb9b62d159$export$1ab0976b9ea166ae);
$parcel$export($2d94d3bb9b62d159$exports, "CustomLinkIcon", () => $2d94d3bb9b62d159$export$5efe8561ca252843);
$parcel$export($2d94d3bb9b62d159$exports, "GuardDetectIcon", () => $2d94d3bb9b62d159$export$e26e48d31d71c1e1);
$parcel$export($2d94d3bb9b62d159$exports, "GuardDetectLogo", () => $2d94d3bb9b62d159$export$bf5ca9fb70f56bb5);
$parcel$export($2d94d3bb9b62d159$exports, "MoreAtlassianAppsIcon", () => $2d94d3bb9b62d159$export$518f48548316ec87);
$parcel$export($2d94d3bb9b62d159$exports, "AtlasIcon", () => $4174445314181c05$export$9d0b19639662f94b);
$parcel$export($2d94d3bb9b62d159$exports, "AtlasLogo", () => $98e32ec83d30e263$export$e388b783bff06f6c);
$parcel$export($2d94d3bb9b62d159$exports, "AtlassianMarketplaceLogo", () => $0f47431498944ba2$export$32e7eace0c9d6a57);
$parcel$export($2d94d3bb9b62d159$exports, "AtlassianMarketplaceIcon", () => $4d13fd8db0387c2f$export$94c87d39a54a1894);
$parcel$export($2d94d3bb9b62d159$exports, "AtlassianAccessIcon", () => $0f9005534e6d00b4$export$a825993f361832f7);
$parcel$export($2d94d3bb9b62d159$exports, "AtlassianAccessLogo", () => $df5a6323ac020c2a$export$5aa23cd4d8596f56);
$parcel$export($2d94d3bb9b62d159$exports, "JiraWorkManagementLogo", () => $1945384bec13664b$export$56cadce97cc7cc);
$parcel$export($2d94d3bb9b62d159$exports, "JiraWorkManagementIcon", () => $67babfef1c42b04b$export$7330b9fc5718fd30);
$parcel$export($2d94d3bb9b62d159$exports, "AtlassianIcon", () => $50101e7733a6b1d7$export$8a485e2e7ed91e8f);
$parcel$export($2d94d3bb9b62d159$exports, "AtlassianLogo", () => $47d58fd2ef4b1aac$export$765cacec8b0843f3);
$parcel$export($2d94d3bb9b62d159$exports, "JiraSoftwareIcon", () => $0d3d329829351edb$export$c3835feba2a66e67);
$parcel$export($2d94d3bb9b62d159$exports, "JiraSoftwareLogo", () => $b6cb5eaa962c21c0$export$8869c52f95591fed);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ee8292a79b161f2b692708d346bda7d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $fdd60fb407482c20$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $fdd60fb407482c20$export$ef8e5f836dd989d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $fdd60fb407482c20$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb1b5c1084ec5af5d6446030d431f52c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");
/* logo-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $50U6m = parcelRequire("50U6m");

var $fDucD = parcelRequire("fDucD");
var $9b7a1b046861a04a$var$styles = {
    root: "_1e0c1o8l _vwz4idpf",
    TEMP_assets: "_9aea1fkg"
};
// These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
var $9b7a1b046861a04a$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
var $9b7a1b046861a04a$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b7a1b046861a04a$var$textLightAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1e01",
    inverse: "_1wycu67f",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b7a1b046861a04a$var$textDarkAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1gvk",
    inverse: "_1wyc5a6q",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b7a1b046861a04a$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b7a1b046861a04a$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b7a1b046861a04a$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b7a1b046861a04a$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $9b7a1b046861a04a$var$rovoDarkAppearanceMap = {
    brand: "_1703lrxy _1evoh727 _epb51yy8 _1osdxeun",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $9b7a1b046861a04a$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
function $9b7a1b046861a04a$export$f827d3c5a9c3f644(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$size = _ref.size, size = _ref$size === void 0 ? 'small' : _ref$size, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, label = _ref.label, userDefinedTestId = _ref.testId, customIconColor = _ref.iconColor, customTextColor = _ref.textColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? 'tile' : _ref$type;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-text-color': customTextColor || 'inherit'
        },
        "data-testid": testId,
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $970q7.default)([
            $9b7a1b046861a04a$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $9b7a1b046861a04a$var$logoTextColorMap[colorMode !== null && colorMode !== void 0 ? colorMode : 'light'],
            $9b7a1b046861a04a$var$sizeMap[size],
            colorMode === 'dark' ? $9b7a1b046861a04a$var$textDarkAppearanceMap[appearance] : $9b7a1b046861a04a$var$textLightAppearanceMap[appearance],
            colorMode === 'dark' ? $9b7a1b046861a04a$var$dataCenterDarkAppearanceMap[appearance] : $9b7a1b046861a04a$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $9b7a1b046861a04a$var$rovoDarkAppearanceMap[appearance] : $9b7a1b046861a04a$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $9b7a1b046861a04a$var$cloudDarkAppearanceMap[appearance] : $9b7a1b046861a04a$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $50U6m.fg)('assets-platform-branding') || (0, $50U6m.fg)('assets-platform-branding-v2')) && $9b7a1b046861a04a$var$styles.TEMP_assets
        ])
    });
}


// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $82e1f1c7094b4744$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M124.84 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-20.15-10.4c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-14.07-8.52v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.85c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-22.02-4.01c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M13.826 6.4h4.255l1.338 3.569 3.76-.626 2.128 3.684-2.422 2.945 2.421 2.943L23.18 22.6l-3.76-.626-1.338 3.57h-4.255l-1.338-3.57-3.76.625L6.6 18.915l2.421-2.943L6.6 13.028l2.127-3.685 3.76.626zm2.128 13.16a3.59 3.59 0 1 0 0-7.178 3.59 3.59 0 0 0 0 7.179\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $82e1f1c7094b4744$export$61afcb38c001e19(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $82e1f1c7094b4744$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8dc880eda57906914bb7837c5a5c673>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $d7c936ff53cc5c33$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z\"/>\n</svg>\n";
function $d7c936ff53cc5c33$export$70a0c2f5862937b6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $d7c936ff53cc5c33$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b50cb2ad76b4dba28f22d4bb555219f7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e8c987d7492ee286$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M105.76 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-19.6 7.75v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52M68.73 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-2.54-.03c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM49.6 21.32c-1.53 0-3.1-.18-4.82-.52l-1.69 4.54H40l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.68 7.43 45.6 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M23.735 23.735c0-2.928-2.396-5.295-5.295-5.295h-4.88v-4.466H8.265v8.785c0 .68.296.976.976.976zM8.265 8.265c0 2.928 2.337 5.295 5.265 5.295h4.91v4.466h5.295V9.241q0-.976-.976-.976z\"/>\n</svg>\n";
function $e8c987d7492ee286$export$8b5103382c06639c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $e8c987d7492ee286$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::93b4dea5ca940a35aa6da4a3e32efaba>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $e1043fa2303698cc$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z\"/>\n</svg>\n";
function $e1043fa2303698cc$export$af3460f51ce3602a(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $e1043fa2303698cc$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19cf5335c393da35608b01fe889f5c46>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $0be36fd552dc1c99$var$svg = "<svg height=\"100%\" viewBox=\"0 0 161 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M160.66 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.6 1.41v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M129.13 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-7.46-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-14.12 3.77h-1.72L100.77 10h2.82l4.91 13.13L113.41 10h2.82l-5.8 14.84c-1.72 4.39-2.7 6.66-6.59 6.66-1.32 0-2.05-.12-2.82-.43V28.8c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.81m-7.8.94c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM79.5 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM74.1 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-24.66 4.97c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.5 7.83v12.25h4.08V7.83zM7.83 24.17h15.75v-2.33H7.83zm0-4.09v-6.42h4.08v6.42zm5.84-8.75v8.75h4.08v-8.75z\"/>\n</svg>\n";
function $0be36fd552dc1c99$export$f0bac2b7ac3e3504(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $0be36fd552dc1c99$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::70585722d0ca9257d878eccc1885f195>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $07c282adbd4b5243$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z\"/>\n</svg>\n";
var $07c282adbd4b5243$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729\"/>\n</svg>\n";
function $07c282adbd4b5243$export$d89497e7f33ca6f5(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $07c282adbd4b5243$var$svg,
        customThemeSvg: $07c282adbd4b5243$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e69fa4e6ed45c9755193e19593b57593>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $67e6f3ace9444edb$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M125.8 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.77-.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.5c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.13-3.56c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63-.01c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-22.22.15c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M11.667 15.425a4.335 4.335 0 0 0 3.758-3.758h2.742V9.5h-3.023A4.335 4.335 0 1 0 9.5 15.144v3.023h2.167zm-.542-2.675a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M24.67 10.58a2.71 2.71 0 1 1-5.42 0 2.71 2.71 0 0 1 5.42 0M10.58 24.67a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m11.38 0a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m-3.79-3.79h-3.79v2.17h3.79zm2.71-6.5v3.79h2.17v-3.79z\"/>\n</svg>\n";
function $67e6f3ace9444edb$export$81c47abe19675c4c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $67e6f3ace9444edb$var$svg,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4355cde32d77e58b21f0c95828a80152>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $29a53ab50e0d6e2c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z\"/>\n</svg>\n";
function $29a53ab50e0d6e2c$export$e812398311cab9a3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $29a53ab50e0d6e2c$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a8b53caccfaf8935cadc28439cd96493>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $eb65bc71ea217c46$var$svg = "<svg height=\"100%\" viewBox=\"0 0 154 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M146 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-16.68 13.49c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-12.07 5.52c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-21.58-8.82v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.23-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M12.287 16.869a3.665 3.665 0 0 0 3.665 3.656v5.607c-4.71 0-8.602-3.52-9.196-8.06zm12.347 0a.584.584 0 0 1 .581.624c-.295 4.415-3.71 7.986-8.057 8.554l-1.206-5.521a3.67 3.67 0 0 0 3.63-3.161.59.59 0 0 1 .589-.496zm-8.683-3.656a3.664 3.664 0 0 0-3.665 3.656h-5.62v-.088c.044-4.66 3.557-8.498 8.078-9.088zm0-7.964a.58.58 0 0 1 .96-.44l6.432 5.518c.27.232.27.65 0 .883l-6.431 5.517a.581.581 0 0 1-.96-.44z\"/>\n</svg>\n";
function $eb65bc71ea217c46$export$7c51958462d750e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $eb65bc71ea217c46$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0a55e042f17bf853ed858530ff13b240>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $7d99f03edbd4b9cf$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m17.843 11.763-.986 6.024c-.065.365-.322.58-.686.58H7.81c-.365 0-.622-.215-.686-.58L5.387 7.047c-.064-.364.129-.6.472-.6h12.262c.343 0 .536.236.472.6l-.472 2.83c-.064.407-.3.579-.686.579h-7.374c-.107 0-.172.064-.15.193l.579 3.558c.021.086.085.15.171.15h2.658c.086 0 .15-.064.172-.15l.407-2.572c.043-.322.257-.45.558-.45h2.894c.428 0 .557.214.493.578\"/>\n</svg>\n";
function $7d99f03edbd4b9cf$export$d3ab16bbf4f954ee(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $7d99f03edbd4b9cf$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a6cf1e00141abbc39f2d3b5098a9d63a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $9517141151b4abf9$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.85-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.39-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.028.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.571 0 .743.285.657.771\"/>\n</svg>\n";
function $9517141151b4abf9$export$cc55e2a4c4b40552(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $9517141151b4abf9$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83bd991a11895fc697ec86ba4d2d82c2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $53bbed640c6e6632$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582\"/>\n</svg>\n";
var $53bbed640c6e6632$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z\"/>\n</svg>\n";
function $53bbed640c6e6632$export$5fc1066e677788d4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $53bbed640c6e6632$var$svg,
        customThemeSvg: $53bbed640c6e6632$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7131ffd6f745f530e9a82fe4842b6a8c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $20e6a750a55a1c4a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.4-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.17-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.27 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.69 5.43z\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.029.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.572 0 .743.285.657.771\"/>\n</svg>\n";
function $20e6a750a55a1c4a$export$f7ef5e5488e4b430(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $20e6a750a55a1c4a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a54a6a33fcca799b58ea8f543b85188b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $ad00fac377c9e40f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M18.563 16.688h-8.438L5.438 19.5V5.438h13.125zm-6.83-9.375-.255.647c-.362.92-.543 1.38-.878 1.727-.334.346-.787.543-1.694.938l-.388.17v.535l.388.17c.907.394 1.36.592 1.694.938.335.346.516.807.878 1.727l.255.648h.535l.255-.648c.362-.92.543-1.38.877-1.727.335-.346.788-.544 1.694-.939l.388-.169v-.535l-.388-.17c-.906-.395-1.36-.592-1.694-.938-.334-.347-.515-.807-.877-1.727l-.255-.647z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $ad00fac377c9e40f$export$52cd484a7ef4f2b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $ad00fac377c9e40f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e9242b17d268ccb8686f65219c6ac465>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $d3bc400e03f0c58c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.95c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M24.75 22.25H13.5L7.25 26V7.25h17.5zm-9.107-12.5-.34.864c-.482 1.226-.724 1.84-1.17 2.302s-1.05.725-2.258 1.251l-.518.226v.714l.518.226c1.209.526 1.813.79 2.259 1.251.445.462.687 1.076 1.17 2.303l.34.863h.714l.34-.864c.482-1.227.724-1.84 1.17-2.302s1.049-.725 2.258-1.251l.517-.226v-.714l-.517-.226c-1.21-.526-1.813-.79-2.259-1.251-.445-.462-.687-1.075-1.17-2.302l-.34-.864z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $d3bc400e03f0c58c$export$a529e78951cd6709(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $d3bc400e03f0c58c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ac62e14826e8b3e1f38977284672c29>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $7d2e0cc3e3a950d6$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M6.75 19V5h10.5v14h-3.937v-3.062h-2.625V19zM9.375 8.063h1.75V6.75h-1.75zm3.5 0h1.75V6.75h-1.75zm-1.75 3.062h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75zm5.25-3.063h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $7d2e0cc3e3a950d6$export$5ef3f25e16249826(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Company Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $7d2e0cc3e3a950d6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf3d9eaf1759437b869f9901adcacb2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $1408f1e2ddb10b25$var$svg = "<svg height=\"100%\" viewBox=\"0 0 129 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M6.75 19V5h10.5v14h-3.937v-3.062h-2.625V19zM9.375 8.063h1.75V6.75h-1.75zm3.5 0h1.75V6.75h-1.75zm-1.75 3.062h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75zm5.25-3.063h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--text-color, #292a2e)\" d=\"M124.53 17.13q-.64 0-1.07-.21a2.3 2.3 0 0 1-.7-.53 3 3 0 0 1-.4-.61h-.1V17h-1.89V6.81h1.93v3.82h.07a3 3 0 0 1 .4-.61q.26-.32.69-.54t1.09-.22q.87 0 1.57.44.71.44 1.13 1.32.42.87.42 2.17 0 1.26-.41 2.15-.41.87-1.12 1.33a2.87 2.87 0 0 1-1.6.46m-.56-1.55q.57 0 .95-.31a1.9 1.9 0 0 0 .57-.85q.2-.54.2-1.23t-.2-1.22a1.8 1.8 0 0 0-.57-.83q-.38-.31-.95-.31-.55 0-.94.29-.38.29-.58.83-.2.53-.2 1.24t.2 1.25q.21.54.59.84.39.3.94.3m-9.65 1.52q-.79 0-1.39-.34a2.34 2.34 0 0 1-.92-.98q-.33-.65-.33-1.55V9.37h1.93v4.54q0 .75.38 1.16t1.05.42q.46 0 .81-.19a1.4 1.4 0 0 0 .55-.57q.2-.38.2-.9V9.38h1.93V17h-1.82l-.02-1.9h.12q-.31.98-.93 1.49t-1.56.51m-13.01-.1V6.81h1.96v4.16h4.58V6.81h1.97V17h-1.97v-4.39h-4.58V17zm-11.89 2.71.45-1.47.23.06q.41.11.73.06a.83.83 0 0 0 .52-.27q.2-.22.27-.62l.08-.44-2.88-7.67h2.04l1.34 4.05q.24.75.39 1.49.16.75.34 1.54h-.47l.37-1.54q.18-.75.43-1.49l1.4-4.05h2.02l-3.26 8.58q-.23.62-.59 1.06-.35.44-.88.68-.52.24-1.25.24-.4 0-.74-.06a2.5 2.5 0 0 1-.53-.14m-6.44-7.17V17h-1.93V9.36h1.82l.04 1.9h-.13q.31-.97.92-1.48.62-.51 1.57-.51.79 0 1.37.34.59.34.92.98t.33 1.55V17H86v-4.54q0-.74-.38-1.16t-1.05-.42q-.45 0-.81.2a1.34 1.34 0 0 0-.55.57q-.2.37-.2.9m-7.92 4.58a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.13-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M63.5 19.86V9.36h1.89v1.28h.1q.14-.29.4-.61t.69-.54 1.09-.22q.87 0 1.57.44.71.44 1.13 1.32.42.87.42 2.17 0 1.26-.41 2.15-.41.87-1.12 1.33a2.87 2.87 0 0 1-1.6.46q-.64 0-1.07-.21a2.3 2.3 0 0 1-.7-.53 3 3 0 0 1-.4-.61h-.07v4.07zm3.61-4.28q.57 0 .95-.31t.57-.85q.2-.54.2-1.23t-.2-1.22a1.8 1.8 0 0 0-.57-.83q-.38-.31-.95-.31-.56 0-.94.29t-.58.83q-.2.53-.2 1.24t.2 1.25q.21.54.59.84.39.3.94.3M50.8 17V9.36h1.8l.08 1.87h-.14q.17-.7.51-1.13.35-.44.81-.64.47-.21.97-.21.83 0 1.33.52.51.52.73 1.57h-.22q.16-.71.55-1.18.39-.46.91-.69.53-.23 1.12-.23.69 0 1.24.3.56.3.87.88.32.58.32 1.42V17h-1.92v-4.82q0-.67-.37-1a1.32 1.32 0 0 0-.89-.32q-.4 0-.7.18a1.2 1.2 0 0 0-.46.49q-.16.32-.16.73V17h-1.87v-4.89q0-.57-.35-.91-.34-.34-.89-.34-.37 0-.68.17a1.2 1.2 0 0 0-.49.51q-.18.33-.18.81V17zm-5.18.15q-1.13 0-1.97-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07.45-.9 1.28-1.39t1.97-.49 1.96.49q.83.49 1.29 1.39.45.89.45 2.07t-.45 2.07-1.29 1.38q-.83.49-1.96.49m0-1.53q.58 0 .97-.31.39-.32.58-.87a3.7 3.7 0 0 0 .19-1.23 3.7 3.7 0 0 0-.19-1.23 1.87 1.87 0 0 0-.58-.86q-.39-.32-.97-.32t-.97.32q-.38.32-.58.86-.19.54-.19 1.23 0 .68.19 1.23.2.55.58.87.39.31.97.31m-9.25 1.51q-1.35 0-2.41-.62t-1.67-1.79-.61-2.82.62-2.82q.62-1.18 1.68-1.79 1.07-.62 2.4-.62.85 0 1.59.24.75.24 1.32.7t.94 1.12.49 1.51h-1.98a2.2 2.2 0 0 0-.28-.77 2 2 0 0 0-.51-.57q-.3-.24-.69-.36a2.8 2.8 0 0 0-.83-.12q-.81 0-1.43.41-.62.4-.97 1.18-.34.78-.34 1.89 0 1.13.35 1.91.35.77.96 1.17a2.6 2.6 0 0 0 1.43.4q.45 0 .83-.12.39-.12.7-.36.32-.24.52-.57.21-.34.29-.77h1.98q-.09.72-.43 1.36a4.2 4.2 0 0 1-.9 1.15 4.2 4.2 0 0 1-1.32.79q-.76.28-1.69.28\"/>\n</svg>\n";
function $1408f1e2ddb10b25$export$1ab0976b9ea166ae(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Company Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $1408f1e2ddb10b25$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5ce5248a23a237688e2341559569305>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $4baee89efb80cd04$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z\"/>\n</svg>\n";
function $4baee89efb80cd04$export$f7857fe64d7161d9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $4baee89efb80cd04$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbcc7f43e0a51fb6caa253b27359fb22>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $6cbfa5dee2ec240d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 162 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.79 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63 0c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-25.9-3.49c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01v-2.7h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97M89.5 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.83c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.69 15.16v4.24h-4.25v-4.24zv-4.24H8.93a.74.74 0 0 0-.74.74v11.25a.74.74 0 0 0 .74.75h11.26a.74.74 0 0 0 .75-.74v-7.76zm0-8.48v4.24h4.26v4.24h4.24V7.42a.74.74 0 0 0-.73-.75h-.01z\"/>\n</svg>\n";
function $6cbfa5dee2ec240d$export$a16f50a81d183ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $6cbfa5dee2ec240d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79151986eefb0d79ff7389ad5707c136>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $1261df2be6b304e0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617\"/>\n</svg>\n";
function $1261df2be6b304e0$export$53305f1f2855d3be(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $1261df2be6b304e0$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0ac4de94f42b3a4050a935e411c6789>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $16ff1b53fcc3594d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.5-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.23 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.2-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.441 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.084.302.389.494l3.134 1.948c.167.11.306.165.444.165.167 0 .278-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.693.22 2.83.768l3.273 1.537c.333.165.694.083.86-.302l1.554-3.403c.166-.384.055-.63-.333-.823M8.762 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.306-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.69 8.29c-.167-.11-.305-.165-.444-.165-.166 0-.277.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.692-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302L8.43 12.187c-.167.384-.056.63.332.823\"/>\n</svg>\n";
function $16ff1b53fcc3594d$export$b3e508cb103e1f93(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $16ff1b53fcc3594d$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}



var $gpCpU = parcelRequire("gpCpU");
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90f8012e577da50adfff14718da1e4b3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e6985fb29d7e75d7$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.51-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.24 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.442 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.083.302.388.494l3.135 1.948c.167.11.305.165.444.165.166 0 .277-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.692.22 2.83.768l3.273 1.537c.333.165.693.083.86-.302l1.553-3.403c.167-.384.056-.63-.333-.823M8.761 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.305-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.691 8.29c-.167-.11-.306-.165-.444-.165-.167 0-.278.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.693-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302l-1.554 3.403c-.166.384-.055.63.333.823\"/>\n</svg>\n";
function $e6985fb29d7e75d7$export$a88b0b0da9ef63ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $e6985fb29d7e75d7$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d471014cf3c5b11585548418a230239b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $9f0bbf9ab4b2a1c5$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.71 7.463 12 4.993l-6.71 2.47a.44.44 0 0 0-.29.433l.14 3.807c.103 3.148 1.684 5.489 4.163 7.018a.446.446 0 0 0 .646-.204l1.445-3.412a.22.22 0 0 0-.14-.298 2.585 2.585 0 1 1 1.492 0 .22.22 0 0 0-.14.298l1.446 3.412a.446.446 0 0 0 .645.204c2.48-1.529 4.06-3.87 4.163-7.018L19 7.896a.44.44 0 0 0-.29-.433\"/>\n</svg>\n";
function $9f0bbf9ab4b2a1c5$export$eaf73f391f7103bd(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $9f0bbf9ab4b2a1c5$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13d7df881302adff1c5de7157bb4b9bb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $74bdda6b0a46426e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.97 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.72 0h-3.37l-2.64-7.42-1.41-4.72-1.41 4.72-2.64 7.42h-3.37L84.45 10h2.91l4.42 13 4.48-13h2.51l4.48 13 4.41-13h2.91zm-28.47.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.77 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-5.76 5.48v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M24.946 9.951 16 6.657 7.054 9.95a.59.59 0 0 0-.387.577l.187 5.076c.137 4.197 2.245 7.319 5.55 9.357.31.19.719.063.86-.272l1.928-4.55a.294.294 0 0 0-.185-.396 3.447 3.447 0 1 1 1.987 0 .294.294 0 0 0-.185.397l1.927 4.549c.142.335.55.463.86.272 3.305-2.038 5.413-5.16 5.55-9.357l.187-5.076a.59.59 0 0 0-.387-.577\"/>\n</svg>\n";
function $74bdda6b0a46426e$export$3c371bdbcdfcdce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $74bdda6b0a46426e$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a1acdf5e3aacf1ac91c03f0f8d3dcf4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $f5be1548d97162b0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M19 12a7 7 0 1 0-14 0 7 7 0 0 0 14 0m-9.37 4.625.026.074a5.26 5.26 0 0 1-2.833-3.824h2.136c.069 1.426.306 2.73.67 3.75m1.08-3.75c.068 1.255.278 2.353.567 3.162.179.5.37.841.54 1.042a.6.6 0 0 0 .183.165.7.7 0 0 0 .183-.165c.17-.2.361-.543.54-1.042.288-.809.498-1.907.566-3.162zm2.58-1.75h-2.58c.068-1.255.278-2.353.567-3.162.179-.5.37-.841.54-1.042A.7.7 0 0 1 12 6.756a.6.6 0 0 1 .183.165c.17.2.361.543.54 1.042.288.809.498 1.907.566 3.162m1.751 1.75c-.069 1.426-.306 2.73-.67 3.75l-.027.074a5.26 5.26 0 0 0 2.833-3.824zm2.136-1.75H15.04c-.069-1.426-.306-2.73-.67-3.75l-.027-.074a5.26 5.26 0 0 1 2.833 3.824m-8.218 0H6.823a5.26 5.26 0 0 1 2.833-3.824l-.027.074c-.364 1.02-.601 2.324-.67 3.75\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $f5be1548d97162b0$export$5efe8561ca252843(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Custom Link' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $f5be1548d97162b0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::adde776e49635255fd9de5c803442f95>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $c1154bc2e76da5bc$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z\"/>\n</svg>\n";
var $c1154bc2e76da5bc$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5\"/>\n</svg>\n";
function $c1154bc2e76da5bc$export$6da5aa77c402ba0f(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $c1154bc2e76da5bc$var$svg,
        customThemeSvg: $c1154bc2e76da5bc$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e95354b27dc93f4ad2578de274aa63f2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $08a10d77ef70bbc8$var$svg = "<svg height=\"100%\" viewBox=\"0 0 456 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M451.86 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.08-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.51-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M234.91 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.24 0h-3.53L217.69 10h2.76l4.97 13.09L230.36 10h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.65 2.45 6.65 6.07m-26.4-3.5v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H146.5c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.15-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M94.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45H94.1zm-6.7.58c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.89 2.79v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M21.91 23.23a9.3 9.3 0 0 1-5.91 2.1H8.53v-.62l5.12-5.04a4.34 4.34 0 0 0 2.35.69c.86 0 1.67-.25 2.35-.69zm1.32-1.32a9.3 9.3 0 0 0 2.1-5.91c0-2.24-.79-4.3-2.11-5.91l-3.56 3.56c.43.68.69 1.48.69 2.35s-.25 1.67-.69 2.35zM21.91 8.77l-3.56 3.56a4.34 4.34 0 0 0-2.35-.69c-.86 0-1.67.25-2.35.69l-3.56-3.56A9.3 9.3 0 0 1 16 6.67c2.24 0 4.3.79 5.91 2.11M8.77 10.09A9.3 9.3 0 0 0 6.67 16c0 2.24.79 4.3 2.11 5.91l3.56-3.56a4.34 4.34 0 0 1-.69-2.35c0-.86.25-1.67.69-2.35z\"/>\n</svg>\n";
function $08a10d77ef70bbc8$export$f597f0f7fadce0b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $08a10d77ef70bbc8$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::772abda1b80977ea1535de7e3f60e0fa>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $645e97300d058240$var$svg = "<svg height=\"100%\" viewBox=\"0 0 48 48\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m36.22 26.75 4.9 7.25h-4.78c-.52-.6-1.02-1.31-1.47-1.98-.68-1.02-.68-2.41.03-3.41zm-7.3-5.5L24.02 14h4.78c.52.6 1.02 1.31 1.47 1.98.68 1.02.68 2.41-.02 3.41zm6.98-6.02c.5-.84 1.07-1.16 1.95-1.16l3.9-.07-12.68 19.27a1.46 1.46 0 0 1-1.22.67H23.6c4.07-6.25 8.37-12.37 12.31-18.7M8 33.94h6.89c6.16 0 9.92-3.88 9.92-9.94s-3.76-9.94-9.92-9.94H8l4.28 3.9h-1.76C9.13 17.96 8 19.12 8 20.55v13.38m4.41-3.9V17.96h2.46c3.52 0 5.49 2.38 5.49 6.04 0 3.65-1.97 6.04-5.46 6.04z\"/>\n</svg>\n";
function $645e97300d058240$export$9951d02c2d848122(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Dx' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $645e97300d058240$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b7db25f7017f6ec5d21f0ae31065359>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $7a1b18946ccbad19$var$svg = "<svg height=\"100%\" viewBox=\"0 0 48 48\">\n    <rect width=\"48\" height=\"48\" fill=\"var(--tile-color,#c97cf4)\" rx=\"12\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M20 19h5v11h-5zm7-9h5v28h-5zm7 6h5v16h-5zm-21 0h5v16h-5zm-7 5h5v7H6z\"/>\n</svg>\n";
function $7a1b18946ccbad19$export$34420f0520b19b1d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Feedback' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $7a1b18946ccbad19$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe7d010e7776c61d1ffb49fef9c7dd61>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $c1e8533d1c9e7c7d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 169 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M157.894 25.334h-2.638V3.59h2.638v13.585L164.487 10h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.177zm-5.648-2.761v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.489s1.656 5.49 5.674 5.49c1.564 0 2.545-.215 3.496-.553m-26.118-4.906c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.638v15.333zm-16.09-7.666c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.502-4.478 4.906v1.227c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.698H107.4V3.592h2.637v9.17c.982-2.025 2.822-3.068 5.183-3.068 4.079 0 6.133 3.466 6.133 7.974 0 4.324-2.146 7.973-6.44 7.973m-22.806-7.974c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.963-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.08 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.013 4.876 3.006V3.59h2.638v21.743zM80.502 12.085c-2.79 0-4.201 1.81-4.477 4.478h8.555c-.153-2.852-1.44-4.478-4.078-4.478M86.39 24.72c-1.258.675-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.625 3.282 6.625 7.943v1.196H76.055c.368 2.607 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zM64.42 12.085c-2.79 0-4.202 1.81-4.477 4.478h8.556c-.154-2.852-1.442-4.478-4.08-4.478m5.888 12.635c-1.258.675-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.238-7.943 4.722 0 6.623 3.282 6.623 7.943v1.196H59.974c.368 2.607 2.055 4.293 5.674 4.293 1.778 0 3.28-.337 4.66-.828zm-15.679-6.9H45.49v7.514h-2.76V5.186h12.94v2.637H45.49v7.36h9.138z\"/>\n    <rect width=\"32\" height=\"32\" fill=\"var(--tile-color,#c97cf4)\" rx=\"8\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.333 12.667h3.334V20h-3.334zm4.667-6h3.333v18.666H18zm4.667 4H26v10.666h-3.333zm-14 0H12v10.666H8.667zM4 14h3.333v4.666H4z\"/>\n</svg>\n";
function $c1e8533d1c9e7c7d$export$bbccafb125ebd50c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Feedback' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $c1e8533d1c9e7c7d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86bc4a90f7eb35fd36ae7c99f20011b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $0c16e5609534a2b0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z\"/>\n</svg>\n";
function $0c16e5609534a2b0$export$1e02e7298035a77c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $0c16e5609534a2b0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7aca4717e5f7edbaa74141430c7d1f8d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $4de141105e2ca493$var$svg = "<svg height=\"100%\" viewBox=\"0 0 117 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.03 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.71 3.58v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M64.6 25.64c-4.6 0-7.3-3.4-7.3-8S60 9.7 64.6 9.7c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.97 5.67h-9.14v7.51h-2.76V5.19h12.94v2.64H45.49v7.36h9.14z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M27.607 16.272c-2.176-2.176-5.712-2.152-7.865 0l-1.812 1.812c-1 1-2.625 1-3.625 0L12.8 16.578l-3.933 3.934 1.505 1.505a8.126 8.126 0 0 0 11.49 0zm-22.982-.541c2.176 2.175 5.668 2.196 7.844.02l1.834-1.834c1-1 2.625-1 3.625 0l1.505 1.505 3.934-3.933-1.505-1.505a8.126 8.126 0 0 0-11.49 0l-5.745 5.745z\"/>\n</svg>\n";
function $4de141105e2ca493$export$3a6e8b37e069a69d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $4de141105e2ca493$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::02833d9738a6774113f222b59b2a94ce>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $a91c75e095c80598$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $a91c75e095c80598$export$9eb74917ea768ed4(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $a91c75e095c80598$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::56bcd62ca7ac54601202de0d95c6f0a6>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $7d59ddb7b829c48b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 116 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M115.55 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.12 4.13c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M58.71 24.2c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.36 16a3.36 3.36 0 1 1-6.72 0 3.36 3.36 0 0 1 6.72 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M16 25.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75M21.86 16a5.86 5.86 0 1 1-11.72 0 5.86 5.86 0 0 1 11.72 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $7d59ddb7b829c48b$export$c527a545aa426db3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $7d59ddb7b829c48b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0276df52cce3ff4af21c51ddcfcd1999>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $89e8a96e1e6f33d4$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649\"/>\n</svg>\n";
function $89e8a96e1e6f33d4$export$e26e48d31d71c1e1(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard Detect' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $89e8a96e1e6f33d4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ffc02f6eb51ba8d719155b3e3ac4a088>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $f5375db4b0eca8fb$var$svg = "<svg height=\"100%\" viewBox=\"0 0 121 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649\"/>\n    <path fill=\"var(--text-color, #292a2e)\" d=\"M120.03 9.36v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19a3 3 0 0 0 .32-.03 5 5 0 0 0 .32-.06l.29 1.46a3.4 3.4 0 0 1-.63.13 5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-5.13 9.61q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.96-.49.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86q-.2.54-.2 1.24t.2 1.24.59.86q.39.31.97.31.32 0 .57-.09.26-.09.46-.27a1.6 1.6 0 0 0 .34-.42q.14-.25.2-.56l1.79.35q-.12.6-.4 1.06t-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17m-8.29-.02q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.73 0 1.36.23.64.23 1.13.71.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.54 1.54 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-4.67-7.8v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19q.12 0 .32-.03.21-.03.32-.06l.29 1.46q-.31.1-.64.13a5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-5.19 9.61q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06A3.4 3.4 0 0 1 88 9.77q.82-.5 1.93-.5.72 0 1.36.23t1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31a1.4 1.4 0 0 0 .34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25M80.08 17h-2.6v-1.69H80q1.02 0 1.71-.37t1.03-1.12q.35-.76.35-1.91t-.35-1.9a2.32 2.32 0 0 0-1.02-1.12q-.68-.37-1.69-.37h-2.61v-1.7h2.71q1.52 0 2.62.61a4.1 4.1 0 0 1 1.69 1.75q.6 1.14.6 2.73t-.59 2.74a4.1 4.1 0 0 1-1.7 1.76q-1.12.59-2.67.59M78.53 6.81V17h-1.96V6.81zM67.1 17.13a2.9 2.9 0 0 1-1.6-.46q-.71-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.13-1.32a2.9 2.9 0 0 1 1.57-.44q.66 0 1.09.23.43.22.69.54.27.32.4.61h.07V6.81h1.92V17h-1.89v-1.22h-.1a2.8 2.8 0 0 1-.4.61q-.27.31-.7.53-.43.21-1.07.21m.56-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.59-.83q-.38-.29-.94-.29-.57 0-.95.31a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.22q0 .69.19 1.23.2.54.58.85.39.31.95.31M58.98 17V9.36h1.87v1.31h.08q.2-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-5.98.13a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.56 0 .94-.3t.58-.84q.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83-.94-.29q-.57 0-.96.3a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31m-9.43 1.53q-.79 0-1.39-.34a2.34 2.34 0 0 1-.92-.98q-.33-.65-.33-1.55V9.37h1.93v4.54q0 .75.38 1.16t1.05.42q.46 0 .81-.19.35-.2.55-.57t.2-.9V9.38h1.93V17h-1.82l-.02-1.9h.12q-.31.98-.93 1.49t-1.56.51m-8.95.04q-1.29 0-2.32-.64-1.02-.63-1.63-1.8-.6-1.17-.6-2.77 0-1.65.62-2.82t1.68-1.8q1.07-.63 2.41-.63.85 0 1.58.25.74.25 1.31.7.57.46.94 1.09a3.8 3.8 0 0 1 .49 1.37h-2.01a2.3 2.3 0 0 0-.32-.69 2 2 0 0 0-.5-.52 2 2 0 0 0-.66-.33 2.6 2.6 0 0 0-.81-.12q-.81 0-1.43.4T33 10.01q-.35.77-.35 1.89 0 1.11.35 1.89t.98 1.19q.64.4 1.48.4.76 0 1.3-.29a2 2 0 0 0 .83-.83q.29-.55.29-1.29h.42v.85q0 .66-.16 1.26t-.53 1.06q-.35.47-.95.73-.59.27-1.45.27m3.24-.14-.26-2.43v-1.43H35.6v-1.52h4.19V17z\"/>\n</svg>\n";
function $f5375db4b0eca8fb$export$bf5ca9fb70f56bb5(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard Detect' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $f5375db4b0eca8fb$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9271fe2e99ed03180fc112676167f42e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $3fde30457b2fb8db$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649\"/>\n</svg>\n";
function $3fde30457b2fb8db$export$3f95fcfdc25a741d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $3fde30457b2fb8db$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db6984f13fa8a1f65e3a27814935822a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5e873dad6b32a772$var$svg = "<svg height=\"100%\" viewBox=\"0 0 120 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M108.4 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.8-9.04v9.05H96.7V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.86 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-27.42-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-3.98 5.21c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.188 14.644h15.623c.449 0 .688-.24.688-.688V8.688c0-.449-.24-.688-.688-.688h-3.292c-.45 0-.689.24-.689.688v2.664h-1.496V8.688c0-.449-.24-.688-.688-.688h-3.293c-.448 0-.688.24-.688.688v2.664H12.17V8.688c0-.449-.24-.688-.689-.688H8.188c-.449 0-.688.24-.688.688v5.268c0 .449.24.688.688.688m.27 4.609a10.4 10.4 0 0 1-.599-2.993c-.03-.389.15-.598.569-.598H23.57c.42 0 .599.18.599.538q-.09 1.662-.629 3.053c-.18.479-.448.688-.957.688H9.415c-.508 0-.778-.21-.957-.688m13.856 2.484c-1.436 1.766-3.8 2.903-6.314 2.903s-4.939-1.137-6.345-2.903c-.36-.479-.18-.778.18-.778h12.33c.359 0 .538.3.15.778\"/>\n</svg>\n";
function $5e873dad6b32a772$export$2b896c4d595a4331(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $5e873dad6b32a772$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::978838b36f6aa3744f039bfb1c56d79c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $dfcee9eb5660984d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z\"/>\n</svg>\n";
function $dfcee9eb5660984d$export$92c8767b874048d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $dfcee9eb5660984d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5bd026d27282a90cddcd834d02167bda>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $6d94cf131d4d8744$var$svg = "<svg height=\"100%\" viewBox=\"0 0 121 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.57 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM93.3 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.33 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M56.41 5.19h2.76v20.15h-2.76v-8.71H45.8v8.71h-2.76V5.19h2.76v8.8h10.61z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M7.25 14.125V24.75h6.25V18.5h5v6.25h6.25V14.125L16 6z\"/>\n</svg>\n";
function $6d94cf131d4d8744$export$8b6b7f1b1b2367d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $6d94cf131d4d8744$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::983ad8fa518509adc011dda491e7edb4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $21530e0c9bf76790$var$svg = "<svg height=\"100%\" viewBox=\"0 0 32 32\">\n    <g clip-path=\"url(#clip0_95164_16219)\">\n        <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n        <g clip-path=\"url(#clip1_95164_16219)\">\n            <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n        </g>\n    </g>\n    <defs>\n        <clipPath id=\"clip0_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M0 0h32v32H0z\"/>\n        </clipPath>\n        <clipPath id=\"clip1_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M2 2h28v28H2z\"/>\n        </clipPath>\n    </defs>\n</svg>\n";
function $21530e0c9bf76790$export$80b8b269d8b5014e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $21530e0c9bf76790$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::525e888921a2eb67ac3477c558f06bd0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $25e04bc358978974$var$svg = "<svg height=\"100%\" viewBox=\"0 0 95 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M91.61 17.67c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-24.52-6.64V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65M56.4 5.19h2.76v20.15H56.4v-8.71H45.79v8.71h-2.76V5.19h2.76v8.8H56.4z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $25e04bc358978974$export$7a38180641471460(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $25e04bc358978974$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238f469c20433ab8ed5a1e4abeae5fe>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $0016866d85e6e365$var$svg = "<svg height=\"100%\" viewBox=\"0 0 55 55\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M24.519.844a6.3 6.3 0 0 1 6.3 0l18.37 10.601a6.3 6.3 0 0 1 3.15 5.454V38.1c0 2.25-1.2 4.33-3.15 5.454l-18.37 10.601a6.3 6.3 0 0 1-6.3 0l-18.37-10.6a6.3 6.3 0 0 1-3.15-5.454V16.9c0-2.25 1.2-4.33 3.15-5.454z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M20.71 34.657h-2.705C13.926 34.657 11 32.16 11 28.5h14.543c.754 0 1.241.536 1.241 1.294v14.634c-3.635 0-6.074-2.944-6.074-7.05zm7.183-7.272h-2.705c-4.079 0-7.005-2.454-7.005-6.113h14.542c.754 0 1.286.491 1.286 1.25v14.634c-3.635 0-6.118-2.945-6.118-7.05zm7.227-7.228h-2.705c-4.079 0-7.005-2.498-7.005-6.157h14.543c.753 0 1.241.535 1.241 1.25v14.633c-3.636 0-6.074-2.944-6.074-7.049z\"/>\n</svg>\n";
function $0016866d85e6e365$export$b12fec207e8537a8(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Coding Agent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $0016866d85e6e365$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::491a8713d140a4025bae404f0574bce7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $63d5863d2ed13516$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z\"/>\n</svg>\n";
function $63d5863d2ed13516$export$f8455b5667a3ee0c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $63d5863d2ed13516$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97902fae9a5e66613a7ad8ae8ea2e75d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $ba7c91ea510df47c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M11.965 20.699h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.424 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.502 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.699zm4.818-4.819h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $ba7c91ea510df47c$export$3224b07bc93ef23e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $ba7c91ea510df47c$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b3ec3c590ed89c431e0f979daa3e25e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $2d211468a13d2fb7$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z\"/>\n</svg>\n";
var $2d211468a13d2fb7$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228\"/>\n</svg>\n";
function $2d211468a13d2fb7$export$21bfbeb62fdcce8d(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $2d211468a13d2fb7$var$svg,
        customThemeSvg: $2d211468a13d2fb7$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8e2d27dec964efc37c6ed5782c3fe57>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $d84bc94694df07a6$var$svg = "<svg height=\"100%\" viewBox=\"0 0 327 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M317.88 24.35h-1.72L310.62 10h2.82l4.91 13.13 4.9-13.13h2.82l-5.8 14.84c-1.72 4.39-2.7 6.65-6.59 6.65-1.32 0-2.06-.12-2.82-.43v-2.27c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.82m-13.25-8.05v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.72.6h-3.53L268.87 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.39 10.42v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-13.88-1.42c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.7-15.22c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zM207.68 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-13.41-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-14.99-1.32c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.78 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84h-4.02v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14h-3.71v8.28zm-27.87 1.56c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M17.448 6.967c2.544.746 5.113.746 7.656 0 .225-.05.375.1.325.323-.724 2.612-.724 5.025 0 7.637.05.199-.1.373-.325.298a14.3 14.3 0 0 0-7.656 0c-.2.075-.374-.1-.3-.298.674-2.612.674-5.025 0-7.637-.074-.223.1-.373.3-.323m1.023 9.253v.423c0 1.965-1.372 3.408-3.068 3.408a3.04 3.04 0 0 1-3.043-3.06c0-1.691 1.372-3.034 3.292-3.034h.5V8.012c-.25-.025-.5-.025-.749-.025a9.02 9.02 0 0 0-9.028 9.03c0 4.999 4.04 9.004 9.028 9.004s9.053-4.03 9.053-9.005v-.796z\"/>\n</svg>\n";
function $d84bc94694df07a6$export$602140a6a10b02bf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $d84bc94694df07a6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e66626867983712448eb161ec2993046>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $7a89adb1474ccf1d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 25 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M14.117 10.203h4.464c.67 0 .899.637.49 1.144l-6.98 8.616c-2.257-1.798-2.044-4.643-.393-6.72zm-3.45 3.433H6.205c-.67 0-.899-.638-.49-1.144l6.981-8.617c2.256 1.799 2.011 4.61.376 6.704z\"/>\n</svg>\n";
function $7a89adb1474ccf1d$export$65fae0eaf343f2ca(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $7a89adb1474ccf1d$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90317e51e9a9185b7a39157502e3ebed>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $3e1ff0d7c502f7bb$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.17-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.268 13.604h5.95c.895 0 1.2.85.655 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.524-8.959zm-4.6 4.577h-5.95c-.895 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $3e1ff0d7c502f7bb$export$f64bc7a7f04428d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $3e1ff0d7c502f7bb$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cedb5d68059644a06a093aa74d8e3cc5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $e2db2120f58c7778$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z\"/>\n</svg>\n";
var $e2db2120f58c7778$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z\"/>\n</svg>\n";
function $e2db2120f58c7778$export$3c6158790f5e01c4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $e2db2120f58c7778$var$svg,
        customThemeSvg: $e2db2120f58c7778$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf1b6bc0c0712320d6fbdb868500ebb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $105e244f4782482d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.268 13.604h5.951c.894 0 1.199.85.654 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.523-8.959zm-4.6 4.577h-5.95c-.894 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $105e244f4782482d$export$de148263c75d2bc1(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $105e244f4782482d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}



var $aEDe1 = parcelRequire("aEDe1");
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ed7d2f84cfdfe8bfef2a295bafed6da>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $6e34b13172a5b29b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.965 20.698h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.423 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.503 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.7zm4.818-4.82h-1.803c-2.72 0-4.67-1.665-4.67-4.104h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $6e34b13172a5b29b$export$bf4c5f97b468e8d6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $6e34b13172a5b29b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f5d94b0d7bf822b6ab4c2ad26c21970>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $dbb0fc9f5c20d708$var$svg = "<svg height=\"100%\" viewBox=\"0 0 100 32\">\n    <path fill=\"var(--icon-color, #101214)\" d=\"M66.71 5.11c0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82 0 .39-.26.62-1.08.62-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.06 0 2.85-.92 2.85-2.26m0 .03c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.5c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16m26.29-2.11v7.32h1.57V4.81l.64 1.46 2.21 4.11h1.95V3.06h-1.54v4.73l-.59-1.39-1.77-3.34zm-9.91 0h-1.7v7.32h1.7zM79.45 8.2c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.47c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16 0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82s-.26.62-1.08.62c-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.03 0 2.85-.92 2.85-2.29M53.5 3.06v7.32h3.49l.54-1.59h-2.34V3.06zm-6.91 0v1.57h1.88v5.75h1.72V4.63h2.03V3.06zm-2.49 0h-2.24l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95c-.03 0-2.57-7.32-2.57-7.32m-1.13 4.75c-.33 0-.64-.05-.93-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m20.06-4.75H60.8l-2.57 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zM61.9 7.81c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m27.32-4.75h-2.23l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zm-1.11 4.75c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19a3.7 3.7 0 0 1-.92.13\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.664-1.775-1.025-2.692 4.664V7.125h-2.048v5.385l-2.694-4.664-1.774 1.025 2.693 4.663-4.664-2.692-1.024 1.774 4.664 2.693H6.958v2.048h5.385L7.68 20.05l1.024 1.775 4.663-2.693-2.692 4.664 1.774 1.024 2.693-4.664v5.386h2.049v-5.385l2.692 4.663 1.774-1.024-2.692-4.664 4.663 2.693 1.025-1.775-4.664-2.692h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.594 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M39.32 27.74v-13.7h2.52v13.7zm24.13-9.31h2.4v1.14c.51-.91 1.7-1.4 2.72-1.4 1.27 0 2.29.55 2.76 1.55.74-1.14 1.72-1.55 2.95-1.55 1.72 0 3.37 1.04 3.37 3.54v6.04h-2.44v-5.53c0-1-.49-1.76-1.65-1.76-1.08 0-1.72.83-1.72 1.84v5.45h-2.49v-5.53c0-1-.51-1.76-1.65-1.76-1.1 0-1.74.81-1.74 1.84v5.45h-2.52zm-15.93 9.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.05 4.93-4.89 4.93m0-7.58a2.65 2.65 0 0 0-2.65 2.65 2.65 2.65 0 0 0 2.65 2.65c1.46 0 2.65-1.19 2.65-2.65a2.65 2.65 0 0 0-2.65-2.65m10.26 7.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.06 4.93-4.89 4.93m0-7.61a2.69 2.69 0 0 0-2.68 2.68 2.69 2.69 0 0 0 2.68 2.68 2.69 2.69 0 0 0 2.68-2.68 2.69 2.69 0 0 0-2.68-2.68\"/>\n</svg>\n";
function $dbb0fc9f5c20d708$export$68d7391318cdef11(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $dbb0fc9f5c20d708$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::26f3036375895bf30dc2c16f910588fe>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $da79d6616879e497$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $da79d6616879e497$export$38c7b37a3e5e8d70(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $da79d6616879e497$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf5c00a6af1a30f7d2914e27e51f1aff>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $fc01f80024a1e9f7$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $fc01f80024a1e9f7$export$71743a944cb62e48(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $fc01f80024a1e9f7$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::568f663154fd35333110385dd0c22e41>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $7277bf1ab856c9fb$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $7277bf1ab856c9fb$export$8d789f76fde3e05(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $7277bf1ab856c9fb$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d69248f39a87c063a78e83a58b63bd7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a9d66750d87e778d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $a9d66750d87e778d$export$78c0b4d8be34c9b2(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $a9d66750d87e778d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c11df6f0c8182479108e0649acaca190>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $ddf42b4cd5986168$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M11.13 5.88H5.88v5.25h5.25zm0 7H5.88v5.25h5.25zm1.75-7h5.25v5.25h-5.25zm5.25 7h-5.25v5.25h5.25z\"/>\n</svg>\n";
function $ddf42b4cd5986168$export$518f48548316ec87(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'More Atlassian Apps' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $ddf42b4cd5986168$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bf4732a418598faff0fcffc57f4a7b7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $6f107b5a3cdc7c24$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848\"/>\n</svg>\n";
function $6f107b5a3cdc7c24$export$eeccc49dc7a12d9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $6f107b5a3cdc7c24$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::032f8fa95ed51413adb506dd076fd343>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $208acfc57f03835f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 164 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M156.69 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM143.39 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-3.68-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.47-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.06 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-4.72 3.52c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-16.29-3.49c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3.01v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-20.11.01c-6.22 0-9.72-4.29-9.72-10.43 0-6.07 3.5-10.33 9.72-10.33 6.2 0 9.69 4.26 9.69 10.34 0 6.13-3.5 10.43-9.69 10.43m0-18.12c-4.97 0-6.96 3.53-6.96 7.7 0 4.26 1.99 7.79 6.96 7.79 4.94 0 6.93-3.53 6.93-7.79 0-4.17-1.99-7.7-6.93-7.7\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.905 25.684c-.638.47-.974.437-1.612-.033-3.088-2.216-5.942-4.734-7.855-7.352-.202-.269-.1-.638.201-.806l3.491-2.182q.454-.302.806.1c1.343 1.545 2.652 3.056 4.163 4.13 1.51-1.074 2.82-2.585 4.163-4.13q.352-.402.805-.1l3.491 2.182c.303.168.403.537.202.806-1.914 2.618-4.767 5.136-7.855 7.385m-.806-9.635c2.753 0 5.035-2.249 5.035-5.001s-2.282-5.07-5.035-5.07-5.036 2.283-5.036 5.07c0 2.786 2.216 5.001 5.036 5.001\"/>\n</svg>\n";
function $208acfc57f03835f$export$a5b9122e89b32ad3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $208acfc57f03835f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c3a56195279b145c83aee2d39dd6918>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $41cbf4a689ed8f4f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $41cbf4a689ed8f4f$export$5ed3e1bb3b04fc02(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $41cbf4a689ed8f4f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2700d019c02f76a45bbbdb7e71fedfcb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5f3418d4a157010d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 145 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M144.54 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.75-.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M99.43 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM83.8 31.25v-2.36c.31.03.49.03.77.03 1.13 0 2.05-.49 2.05-1.87V10h2.64v17.36c0 2.82-1.59 4.02-4.11 4.02-.67 0-1.13-.06-1.35-.12m2.3-25.3c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84M76.07 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M62.3 16.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84H45.8v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14H45.8v8.28z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m6.152 19.486 2.651-2.652-2.651-2.651 2.21-2.21h5.303l3.977-3.977h6.187v6.187l-3.977 3.977v5.304l-2.21 2.21-2.652-2.652-2.651 2.651-2.429-2.428 3.978-3.978-1.326-1.325-3.978 3.977zM20.736 13.3a1.562 1.562 0 1 1-2.21-2.21 1.562 1.562 0 0 1 2.21 2.21\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $5f3418d4a157010d$export$e3d1678155aaab99(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $5f3418d4a157010d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::694cf9c8d8336e73333c711f4777239b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $4f24c8abb3bfcd10$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M10.7.368a2.75 2.75 0 0 1 2.748 0l8.016 4.626a2.75 2.75 0 0 1 1.375 2.38v9.252c0 .982-.524 1.889-1.375 2.38l-8.016 4.626a2.75 2.75 0 0 1-2.749 0l-8.016-4.626a2.75 2.75 0 0 1-1.374-2.38V7.374c0-.982.524-1.889 1.374-2.38z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.181 6.096 6.777 8.06a1.53 1.53 0 0 0-.768 1.327v5.229c0 .547.294 1.054.768 1.327l.807.466 3.722 2.149a1.54 1.54 0 0 0 1.508.014l.027-.018a1.54 1.54 0 0 0 .766-1.323v-2.026l-1.97-1.137-.568-.327a2 2 0 0 1-1.006-1.74V6.775a2 2 0 0 1 .118-.678\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M12.842 5.441a1.54 1.54 0 0 0-1.508-.014l-.028.019a1.54 1.54 0 0 0-.765 1.323v2.025l1.91 1.102.628.362a2 2 0 0 1 1.006 1.74v5.228a2 2 0 0 1-.118.678l3.404-1.965c.476-.273.767-.778.767-1.327V9.383c0-.546-.293-1.054-.767-1.327l-.868-.501z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $4f24c8abb3bfcd10$export$813cff80931d9dbf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev Agent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $4f24c8abb3bfcd10$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e07b5682123be769fa70cfe7a8367bf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $f7ab768ff134333e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 160 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M153.94 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zM136.3 12.42c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-25.13-16.9h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.52h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.25.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M45 8.16h-4.05v7.36H45c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M12.52.49a3.67 3.67 0 0 1 3.666 0l10.688 6.17a3.66 3.66 0 0 1 1.833 3.173v12.336a3.66 3.66 0 0 1-1.833 3.173L16.186 31.51a3.67 3.67 0 0 1-3.665 0L1.833 25.341A3.66 3.66 0 0 1 0 22.168V9.832c0-1.309.7-2.519 1.833-3.173z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m11.83 8.128-4.54 2.62a2.04 2.04 0 0 0-1.022 1.77v6.972c0 .728.39 1.405 1.023 1.77l1.076.62 4.963 2.865a2.05 2.05 0 0 0 2.01.02l.037-.025c.445-.257.771-.67.925-1.146q.094-.297.095-.619v-2.7l-2.627-1.516-.757-.436a2.67 2.67 0 0 1-1.34-2.32v-6.97a2.7 2.7 0 0 1 .157-.904\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M15.377 7.255a2.05 2.05 0 0 0-2.01-.019l-.038.026c-.445.257-.77.67-.924 1.145a2 2 0 0 0-.095.618v2.7l2.545 1.47.839.483a2.67 2.67 0 0 1 1.34 2.319v6.972a2.7 2.7 0 0 1-.157.903l4.54-2.62a2.04 2.04 0 0 0 1.022-1.77v-6.971c0-.729-.39-1.405-1.023-1.77l-1.157-.668z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $f7ab768ff134333e$export$58747af448450872(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev Agent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $f7ab768ff134333e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1131b9b9b6248ab2f320c07042466bf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $197063d63daf10dc$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M11.26 4.71a1.7 1.7 0 0 1 1.666.017l5.006 2.89c.524.302.848.863.848 1.467v5.78a1.69 1.69 0 0 1-.848 1.467l-3.763 2.172.024-.07c.07-.216.107-.445.107-.679v-5.78c0-.794-.423-1.526-1.112-1.922l-2.805-1.62V6.195q.001-.267.08-.512c.126-.395.396-.737.765-.95l.002-.001z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M9.986 5.45 6.223 7.623a1.69 1.69 0 0 0-.848 1.466v5.78c0 .605.324 1.166.848 1.468l5.006 2.89a1.7 1.7 0 0 0 1.666.016l.03-.02c.37-.214.64-.556.768-.95q.078-.247.079-.513v-2.24l-2.805-1.618a2.22 2.22 0 0 1-1.112-1.922V6.2a2.2 2.2 0 0 1 .13-.75\"/>\n</svg>\n";
function $197063d63daf10dc$export$8b784b3227531b3e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $197063d63daf10dc$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8e3612ac67ced6c8ac8b271a1aa6aa8b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $52144500e207f1b9$var$svg = "<svg height=\"100%\" viewBox=\"0 0 165 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M158.79 25.33h-3.53L149.32 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.64-13.24c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM121.91 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.26.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.86 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682a2.26 2.26 0 0 1 1.021-1.267h.002z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1\"/>\n</svg>\n";
function $52144500e207f1b9$export$4145bd793c9ed1d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $52144500e207f1b9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7bd8774a1a483ce4ec625e53d5f111c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $43ecd9ad182aa785$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--rovo-blue-color, #1868db)\" fill-rule=\"evenodd\" d=\"m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-green-color, #6a9a23)\" fill-rule=\"evenodd\" d=\"m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-purple-color, #af59e1)\" fill-rule=\"evenodd\" d=\"m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-yellow-color, #fca700)\" fill-rule=\"evenodd\" d=\"M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $43ecd9ad182aa785$export$9e62346a60cfb459(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $43ecd9ad182aa785$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::81d74fa5dbe2e1ea12f9e61d6b58e6d8>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $57fe7bba8f3a8d6a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M93.5 25.97c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.3c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M44.99 8.16h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--rovo-blue-color, #1868db)\" fill-rule=\"evenodd\" d=\"m15.892 22.385-9.538 5.559-4.538-2.613A3.63 3.63 0 0 1 0 22.19V9.821C0 8.524.69 7.33 1.816 6.682l8.058-4.649-.052.152a4.7 4.7 0 0 0-.228 1.452v12.37a4.74 4.74 0 0 0 2.38 4.113z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-green-color, #6a9a23)\" fill-rule=\"evenodd\" d=\"m13.318 20.895-9.591 5.538 8.809 5.082a3.64 3.64 0 0 0 3.568.034l.065-.043a3.63 3.63 0 0 0 1.642-2.034c.11-.35.17-.718.17-1.096v-4.792z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-purple-color, #af59e1)\" fill-rule=\"evenodd\" d=\"M26.893 6.67 21.02 3.285l-7.873 6.52 3.587 2.075a4.74 4.74 0 0 1 2.38 4.115v12.369a4.7 4.7 0 0 1-.28 1.603l8.058-4.649a3.62 3.62 0 0 0 1.816-3.139V9.81a3.63 3.63 0 0 0-1.816-3.139\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-yellow-color, #fca700)\" fill-rule=\"evenodd\" d=\"m15.244 11.022-4.519-2.606V3.625c0-.378.059-.747.17-1.096a3.63 3.63 0 0 1 1.64-2.033l.002-.001.064-.044a3.64 3.64 0 0 1 3.569.034l8.665 5z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $57fe7bba8f3a8d6a$export$5e38d02efdb45577(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $57fe7bba8f3a8d6a$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fdd9cdb3dfb222b9beb33bde63bcd67>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $c0e81f450057cf06$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691\"/>\n</svg>\n";
function $c0e81f450057cf06$export$e23ae35269442b4f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $c0e81f450057cf06$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::078cc586ef0207819d6635adebbccf14>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $bd5d466aedec2939$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M98.36 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.87 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896q.017-.046.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682.17-.527.529-.983 1.021-1.267h.002z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1\"/>\n</svg>\n";
function $bd5d466aedec2939$export$b0e15f0a1c9f4c55(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $bd5d466aedec2939$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8449a5cf6c2f473179dfe4bd9893163>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $0f8b4aaeed3bfd5f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6.625a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.76 17.176a5.791 5.791 0 1 1 5.038-2.935l3.403 3.403-2.205 2.204-3.409-3.408a5.77 5.77 0 0 1-2.827.736m-.274-9.37-.242.615c-.344.874-.516 1.312-.833 1.64-.318.33-.749.518-1.61.893l-.37.16v.51l.37.16c.861.376 1.292.563 1.61.893.317.329.49.766.833 1.64l.242.616h.51l.242-.616c.344-.874.516-1.311.834-1.64.317-.33.748-.517 1.61-.893l.368-.16v-.51l-.369-.16c-.861-.375-1.292-.563-1.61-.892-.317-.33-.489-.766-.833-1.64l-.242-.616z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $0f8b4aaeed3bfd5f$export$82eafebb825fc23f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $0f8b4aaeed3bfd5f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17e42f012731a68dbb72bc00bc08f838>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $b4bd8937bad3fd8c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 130 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M128.82 16.35v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.05 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M14.346 22.068a7.721 7.721 0 1 1 6.718-3.913l4.537 4.536-2.94 2.94-4.545-4.545a7.7 7.7 0 0 1-3.77.982m-.364-12.494-.323.82c-.459 1.167-.688 1.75-1.112 2.188-.423.44-.997.69-2.146 1.19l-.492.214v.68l.492.213c1.149.5 1.723.75 2.146 1.19.424.439.653 1.022 1.112 2.188l.323.82h.679l.323-.82c.459-1.166.688-1.75 1.111-2.188.424-.44.998-.69 2.147-1.19l.491-.214v-.679l-.491-.214c-1.149-.5-1.723-.75-2.147-1.19-.423-.438-.652-1.021-1.111-2.187l-.323-.82z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $b4bd8937bad3fd8c$export$fa08cbfe393f2a68(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $b4bd8937bad3fd8c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37c59c3ee979ff8acaf7525e576da094>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $29dc00d3e852c298$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68\"/>\n</svg>\n";
function $29dc00d3e852c298$export$f3f5aa321d88adf9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $29dc00d3e852c298$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4e31a509778b74933bf91345a74560c5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $498a5dc059f68f6e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 192 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M184.96 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-10.55-4.47c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.61-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19H85V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.95-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.26-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M15.896 13.196c-2.464 0-4.86 1.114-6.817 2.835q-.303.304-.607.304c-.169 0-.338-.102-.473-.27l-2.463-2.902c-.135-.17-.202-.338-.202-.473 0-.202.1-.371.303-.573C8.607 9.484 12.217 8 15.896 8c3.678 0 7.29 1.484 10.259 4.117.202.202.303.37.303.573 0 .135-.067.304-.202.473l-2.463 2.902c-.135.168-.304.27-.473.27q-.303 0-.607-.304c-1.958-1.721-4.353-2.835-6.817-2.835m0 10.867c-2.733 0-4.96-2.228-4.96-4.927 0-2.7 2.227-4.927 4.96-4.927s4.96 2.193 4.96 4.927-2.227 4.927-4.96 4.927\"/>\n</svg>\n";
function $498a5dc059f68f6e$export$2bc88a281410ffa7(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $498a5dc059f68f6e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::547909cc6b5dd84f765ef41fd848647b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $d4a2fbda144b1191$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.594 18.563v-7.97h7.969v7.97zm3.808-6.488-.163.429c-.235.615-.352.922-.572 1.155s-.52.368-1.12.638l-.222.1v.357l.222.099c.6.27.9.405 1.12.638s.337.54.572 1.156l.163.428h.347l.163-.429c.235-.615.352-.922.572-1.155s.52-.368 1.12-.638l.221-.1v-.357l-.22-.1c-.601-.269-.901-.404-1.121-.637s-.337-.54-.572-1.155l-.164-.429z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.813 7.195 10.125 4.5 5.438 7.195v5.39l3.75 2.157V9.187h5.625z\"/>\n</svg>\n";
function $d4a2fbda144b1191$export$290a0f24614cde9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $d4a2fbda144b1191$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f55f424cde2b5fe1f1eee28320c6ad8>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $c66fc654b038e593$var$svg = "<svg height=\"100%\" viewBox=\"0 0 124 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M14.125 24.75V14.125H24.75V24.75zm5.078-8.65-.218.571c-.312.82-.469 1.23-.762 1.541s-.694.49-1.494.85l-.295.133v.476l.295.133c.8.36 1.2.54 1.494.85.293.311.45.721.762 1.541l.218.572h.462l.218-.572c.313-.82.469-1.23.762-1.54s.694-.491 1.494-.851l.295-.133v-.476l-.295-.132c-.8-.36-1.2-.54-1.494-.85-.293-.312-.45-.722-.762-1.542l-.218-.571z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z\"/>\n</svg>\n";
function $c66fc654b038e593$export$273fd56580e523ae(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $c66fc654b038e593$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::548aca21494c6e3d39de8ad380612aed>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $7f7edb4e357e2b13$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $7f7edb4e357e2b13$export$4b05688514531169(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $7f7edb4e357e2b13$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5789a2ba9d9ad5ee943d0005b148e594>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $1f1b8db51b42626f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 122 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M117.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H82.4c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-14.47.57c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m16.577 4.907 3.035 6.763 7.372.797.354 1.09-5.495 4.977 1.52 7.257-.927.672-6.431-3.687-6.433 3.687-.926-.672 1.52-7.257-5.495-4.978.353-1.089 7.372-.797 3.035-6.763zm-.668 11.936a2.476 2.476 0 0 0-2.476 2.477v.904a4.8 4.8 0 0 0 2.369.644h.07a4.8 4.8 0 0 0 2.514-.73v-.818a2.477 2.477 0 0 0-2.477-2.477m0-4.511a1.857 1.857 0 1 0 0 3.714 1.857 1.857 0 0 0 0-3.714\"/>\n</svg>\n";
function $1f1b8db51b42626f$export$1b3979d995ebbc6e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $1f1b8db51b42626f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2a7617bb15f45b06b307ddb34a89ff24>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $a04a36d44116debe$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63\"/>\n</svg>\n";
function $a04a36d44116debe$export$1bcbc9c337da86da(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $a04a36d44116debe$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::767fa2606cdc14e785d5959f2e07c247>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a982aa43c10022ed$var$svg = "<svg height=\"100%\" viewBox=\"0 0 127 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M126.58 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-24.66-4.36v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.33.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM61.99 12.08c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H57.55c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M10.75 14.83a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m10.5 0a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.23 1.75a3.86 3.86 0 0 1 3.86 3.86v3.72h-9.62l2.21-5.23a3.86 3.86 0 0 1 3.55-2.35M6.67 20.67v3.5h6.42l1.75-4.08a3.5 3.5 0 0 0-3.5-3.5h-.58a4.08 4.08 0 0 0-4.08 4.08\"/>\n</svg>\n";
function $a982aa43c10022ed$export$bfd8d1c4da84ce71(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $a982aa43c10022ed$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fc7b25031952cd94704eefaa85d7de4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $846cd6bc1530edeb$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z\"/>\n</svg>\n";
var $846cd6bc1530edeb$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z\"/>\n</svg>\n";
function $846cd6bc1530edeb$export$4384da9b8b140bf4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $846cd6bc1530edeb$var$svg,
        customThemeSvg: $846cd6bc1530edeb$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b73a20da143650f747e32cb182c99798>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $d346c3580de5e974$var$svg = "<svg height=\"100%\" viewBox=\"0 0 113 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M104.97 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M96.21 25.3c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-8 0c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM72.86 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H68.42c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.48-8.44v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M12.9 24c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H8.13C7.51 8 7 8.49 7 9.1v13.8c0 .61.5 1.1 1.13 1.1zm10.97-6.34c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H19.1c-.62 0-1.13.49-1.13 1.1v7.47c0 .61.5 1.1 1.13 1.1z\"/>\n</svg>\n";
function $d346c3580de5e974$export$1b13139dfc0336af(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $d346c3580de5e974$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}



var $af9o7 = parcelRequire("af9o7");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
var $8d9471b61f79a2a7$var$_excluded = [
    "size",
    "shouldUseNewLogoDesign"
];
/**
 * Creates a component that renders the new logo design.
 *
 * @param LegacyComponent - The legacy logo component (no longer used).
 * @param NewComponent - The new logo component.
 * @returns A component that renders the new logo.
 */ var $8d9471b61f79a2a7$export$436fcf6e31fbacea = function createFeatureFlaggedServiceCollectionComponent(_LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref) {
        var size = _ref.size, _shouldUseNewLogoDesign = _ref.shouldUseNewLogoDesign, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $8d9471b61f79a2a7$var$_excluded);
        // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            size: size || 'medium'
        }, props));
    };
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $1c67e9a6f1bb1a6f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $1c67e9a6f1bb1a6f$export$84109e099492cb5f = function AtlassianAdminIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        svg: $1c67e9a6f1bb1a6f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $02204c990345b447$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 295 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M294.31 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $02204c990345b447$export$f845d9b9254f0541 = function AtlassianAdminLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $02204c990345b447$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $97a4280f75f7a22e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $97a4280f75f7a22e$export$74517ed253186308 = function AtlassianAdministrationIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        svg: $97a4280f75f7a22e$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $412bfa0d5894b3c6$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 404 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M403.77 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-23.336 9.292c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.57 0 7.237 3.343 7.237 7.943s-2.667 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.489s1.442 5.55 4.723 5.55c3.251 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49zm-13.488-6.195c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-7.461-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.078v2.453h-4.078zm-18.943-2.913c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.637v15.333zm-17.793-9.046v9.046h-2.576V10h2.576v2.699c.89-1.81 2.423-3.098 5.428-2.914v2.576c-3.373-.337-5.428.675-5.428 3.926m-10.037 4.293c0 1.35.797 2.27 2.423 2.27.613 0 1.196-.123 1.656-.215v2.545c-.46.123-.982.245-1.779.245-3.281 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.079v2.453h-4.079zm-6.696.583c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.675-2.974 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.121 2.086 5.121 4.754M297.497 5.952c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-3.678-8.985v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $412bfa0d5894b3c6$export$833abe6c2ce5ebfd = function AtlassianAdministrationLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $412bfa0d5894b3c6$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $h8qvJ = parcelRequire("h8qvJ");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");
// TODO: This is where we need to add tokens for all appearance color values
var $8ea89a764ffd4a31$export$362a25f017e2bc8a = function getColorsFromAppearanceOldLogos(appearance, colorMode) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = '#0052CC';
            iconGradientStop = '#2684FF';
            iconColor = '#2684FF';
            textColor = "var(--ds-text, #292A2E)";
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = '#0052CC';
            break;
        case 'neutral':
            iconGradientStart = '#344563';
            iconGradientStop = '#7A869A';
            iconColor = '#7A869A';
            textColor = '#505F79';
            atlassianLogoTextColor = '#505F79';
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};


var $34224b7af8484c42$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8ea89a764ffd4a31$export$362a25f017e2bc8a)(appearance, colorMode);
    return "<svg height=\"32\" viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"12.595\" x2=\"12.595\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient id=\"").concat(id, "-b\" x1=\"28.595\" x2=\"28.595\" y1=\"40\" y2=\"27\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-c\" x1=\"20.595\" x2=\"20.595\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-d\" x1=\"36.595\" x2=\"36.595\" y2=\"20\"/>\n  </defs>\n  <path d=\"M10.595 30h4v10h-4z\" fill=\"url(#").concat(id, "-a)\"/>\n  <path d=\"M26.595 27h4v13h-4z\" fill=\"url(#").concat(id, "-b)\"/>\n  <path d=\"M18.595 22h4v18h-4z\" fill=\"url(#").concat(id, "-c)\"/>\n  <path d=\"M34.595 20h4v20h-4z\" fill=\"url(#").concat(id, "-d)\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m9.009 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\" />\n</svg>");
};
var $34224b7af8484c42$export$c42ad8a0b925c762 = function AtlassianAnalyticsIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $h8qvJ.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $34224b7af8484c42$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $h8qvJ = parcelRequire("h8qvJ");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $7a3a6eb3b1e795cf$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        textColor: textColor,
        iconColor: iconColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $8ea89a764ffd4a31$export$362a25f017e2bc8a)(appearance, colorMode);
    return "\n  <svg height=\"32\" viewBox=\"0 0 477 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"447.285\" x2=\"447.285\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-b\" x1=\"463.285\" x2=\"463.285\" y2=\"27\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-c\" x1=\"455.285\" x2=\"455.285\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-d\" x1=\"471.285\" x2=\"471.285\" y2=\"20\"/>\n  </defs>\n  <g fill=\"").concat(colors.atlassianLogoTextColor, "\">\n    <path d=\"M106.72 18.359c0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835m0 0c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445M209.1 10.346v28.455h6.063V17.103l2.556 5.76 8.575 15.938h7.623V10.346h-6.064V28.71l-2.295-5.327-6.886-13.037H209.1zM163.909 10.346h6.626v28.455h-6.626zM156.263 30.399c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445 0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835M55.243 10.346v28.455h13.62l2.145-6.15h-9.095V10.346h-6.67zM28.334 10.346v6.15h7.363v22.305h6.67V16.496h7.882v-6.15H28.334zM18.663 10.346h-8.74L0 38.801h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM92.344 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM194.414 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524Z\"/>\n  </g>\n  <g fill=\"").concat(colors.textColor, "\">\n    <path d=\"m254.776 31.987-2.53 6.809H247.6l11.916-30.225h5.244l11.916 30.225h-4.646l-2.53-6.855c-2.714.552-5.061.828-7.499.828-2.3 0-4.646-.276-7.223-.782Zm13.479-3.496-6.119-16.562-6.119 16.608c2.254.368 4.141.552 5.98.552 1.933 0 3.911-.23 6.257-.598ZM298.984 38.796h-3.957V24.902c0-4.141-1.656-5.981-5.428-5.981-3.681 0-6.211 2.438-6.211 7.085v12.79h-3.957V15.794h3.957v3.772c1.472-2.715 4.187-4.232 7.269-4.232 5.291 0 8.327 3.634 8.327 9.983v13.479ZM320.097 34.656c-1.472 3.036-4.232 4.6-7.775 4.6-6.119 0-9.201-5.199-9.201-11.961 0-6.486 3.22-11.961 9.661-11.961 3.358 0 5.935 1.518 7.314 4.508v-4.048h3.957v23.002h-3.957v-4.14Zm-6.717.92c3.542 0 6.717-2.254 6.717-7.361v-1.84c0-5.106-2.898-7.361-6.256-7.361-4.463 0-6.763 2.944-6.763 8.281 0 5.521 2.208 8.281 6.303 8.281ZM336.196 38.935c-3.772 0-6.165-1.794-6.165-6.027V6.179h3.957v26.269c0 2.07 1.38 2.806 3.083 2.806.414 0 .69 0 1.15-.046v3.542c-.322.092-1.012.184-2.024.184ZM347.328 37.324l-8.327-21.53h4.232l7.361 19.69 7.361-19.69h4.232l-8.695 22.267c-2.576 6.579-4.048 9.983-9.891 9.983-1.979 0-3.083-.184-4.232-.644v-3.404c1.334.414 2.852.552 4.002.552 3.22 0 4.646-2.208 6.533-7.223h-2.576ZM374.698 35.07c.92 0 1.794-.185 2.484-.322v3.818c-.69.184-1.472.368-2.668.368-4.923 0-7.315-2.898-7.315-7.177V19.473h-3.727v-3.68h3.727v-4.877h3.864v4.877h6.119v3.68h-6.119v12.191c0 2.024 1.196 3.405 3.635 3.405ZM384.265 6.961c1.61 0 2.76 1.012 2.76 2.76s-1.15 2.76-2.76 2.76-2.76-1.012-2.76-2.76 1.15-2.76 2.76-2.76Zm-2.024 8.833h3.957v23.002h-3.957V15.794ZM408.416 38.198c-1.38.736-3.496 1.058-5.612 1.058-8.189 0-12.007-4.968-12.007-12.007 0-6.947 3.818-11.915 12.007-11.915 2.07 0 3.68.276 5.475 1.104v3.681c-1.472-.69-3.037-1.104-5.199-1.104-5.98 0-8.419 3.772-8.419 8.235s2.484 8.235 8.511 8.235c2.346 0 3.818-.322 5.244-.828v3.542ZM420.144 39.256c-3.451 0-6.257-.782-8.005-1.702v-4.187c1.978 1.15 5.291 2.254 8.188 2.254 3.037 0 4.601-1.242 4.601-3.036 0-1.749-1.334-2.761-5.705-3.818-5.106-1.242-7.269-3.221-7.269-6.993 0-4.002 3.082-6.44 8.327-6.44 2.99 0 5.705.736 7.407 1.656v4.094c-2.76-1.38-5.014-2.117-7.453-2.117-2.898 0-4.462 1.013-4.462 2.807 0 1.61 1.104 2.622 5.336 3.635 5.106 1.242 7.683 3.128 7.683 7.13 0 3.819-2.484 6.717-8.649 6.717Z\"/>\n  </g>\n  <path fill=\"url(#").concat(id, "-a)\" d=\"M445.285 30h4v10h-4z\"/>\n  <path fill=\"url(#").concat(id, "-b)\" d=\"M461.285 27h4v13h-4z\"/>\n  <path fill=\"url(#").concat(id, "-c)\" d=\"M453.285 22h4v18h-4z\"/>\n  <path fill=\"url(#").concat(id, "-d)\" d=\"M469.285 20h4v20h-4z\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m443.699 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\"/>\n</svg>");
};
var $7a3a6eb3b1e795cf$export$e6470bfc39010cc4 = function AtlassianAnalyticsLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $h8qvJ.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        size: size,
        iconColor: iconColor,
        svg: $7a3a6eb3b1e795cf$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $4dbba68b0e2d177f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95\"/>\n    </svg>");
};
var $4dbba68b0e2d177f$export$5fc1066e677788d4 = function BitbucketIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $4dbba68b0e2d177f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $d9b1388a5ad29f00$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 158 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill=".concat(colors.iconColor, " d=\"m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95\"/>\n        <path fill=").concat(colors.textColor, " d=\"M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z\"/>\n      </svg>");
};
var $d9b1388a5ad29f00$export$bd40525f5333524b = function BitbucketLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $d9b1388a5ad29f00$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $82ec3faa3f0368a6$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z\"/>\n      </svg>\n    ");
};
var $82ec3faa3f0368a6$export$f7857fe64d7161d9 = function CompassIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $82ec3faa3f0368a6$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $ec654b9e2387dfd0$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 155 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path fill=".concat(colors.iconColor, " d=\"M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z\"/>\n    <path fill=\"").concat(colors.textColor, "\" d=\"M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n  </svg>");
};
var $ec654b9e2387dfd0$export$eb7d748e4f9c9676 = function CompassLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $ec654b9e2387dfd0$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $1VIl7 = parcelRequire("1VIl7");

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $939c0243cabcce21$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 180 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n    </svg>\n    ");
};
var $939c0243cabcce21$export$1b2e4fe6ef471556 = function ConfluenceLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $939c0243cabcce21$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $3e24df8349650905$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 48 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M45.4277 24.5018C41.4108 20.4849 34.8821 20.5276 30.908 24.5018L27.5636 27.8462C25.717 29.6927 22.7177 29.6927 20.8712 27.8462L18.0925 25.0675L10.8309 32.3291L13.6096 35.1078C19.4658 40.9641 28.9654 40.9641 34.8216 35.1078L45.4277 24.5018ZM3 23.5018C7.01684 27.5186 13.4637 27.5578 17.4805 23.5409L20.8676 20.1538C22.7142 18.3073 25.7135 18.3073 27.56 20.1538L30.3387 22.9325L37.6003 15.6709L34.8216 12.8922C28.9654 7.03593 19.4658 7.03593 13.6096 12.8922L3.00356 23.4982L3 23.5018Z\"/>\n\t\t</svg>\n\t\t");
};
var $3e24df8349650905$export$1e02e7298035a77c = function FocusIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $3e24df8349650905$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $c938f2c9202f2b9d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 168 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M42.4277 24.5018C38.4108 20.4849 31.8821 20.5276 27.908 24.5018L24.5636 27.8462C22.717 29.6927 19.7177 29.6927 17.8712 27.8462L15.0925 25.0675L7.83088 32.3291L10.6096 35.1078C16.4658 40.9641 25.9654 40.9641 31.8216 35.1078L42.4277 24.5018ZM0 23.5018C4.01684 27.5186 10.4637 27.5578 14.4805 23.5409L17.8676 20.1538C19.7142 18.3073 22.7135 18.3073 24.56 20.1538L27.3387 22.9325L34.6003 15.6709L31.8216 12.8922C25.9654 7.03593 16.4658 7.03593 10.6096 12.8922L0.00355592 23.4982L0 23.5018Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M167.405 31.746C167.405 35.564 164.921 38.462 158.757 38.462C155.307 38.462 152.501 37.68 150.753 36.76V32.574C152.731 33.724 156.043 34.828 158.941 34.828C161.977 34.828 163.541 33.586 163.541 31.792C163.541 30.044 162.207 29.032 157.837 27.974C152.731 26.732 150.569 24.754 150.569 20.982C150.569 16.98 153.651 14.542 158.895 14.542C161.885 14.542 164.599 15.278 166.301 16.198V20.292C163.541 18.912 161.287 18.176 158.849 18.176C155.951 18.176 154.387 19.188 154.387 20.982C154.387 22.592 155.491 23.604 159.723 24.616C164.829 25.858 167.405 27.744 167.405 31.746Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M126.009 28.48V15.002H129.965V28.894C129.965 33.034 131.621 34.874 135.393 34.874C139.073 34.874 141.603 32.436 141.603 27.79V15.002H145.559V38.002H141.603V34.23C140.131 36.944 137.417 38.462 134.335 38.462C129.045 38.462 126.009 34.828 126.009 28.48Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M121.953 33.862V37.404C120.573 38.14 118.457 38.462 116.341 38.462C108.153 38.462 104.335 33.494 104.335 26.456C104.335 19.51 108.153 14.542 116.341 14.542C118.411 14.542 120.021 14.818 121.815 15.646V19.326C120.343 18.636 118.779 18.222 116.617 18.222C110.637 18.222 108.199 21.994 108.199 26.456C108.199 30.918 110.683 34.69 116.709 34.69C119.055 34.69 120.527 34.368 121.953 33.862Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M90.2616 38.462C83.3616 38.462 79.3136 33.356 79.3136 26.456C79.3136 19.556 83.3616 14.542 90.2616 14.542C97.1156 14.542 101.118 19.556 101.118 26.456C101.118 33.356 97.1156 38.462 90.2616 38.462ZM90.2616 18.222C85.3396 18.222 83.1776 22.086 83.1776 26.456C83.1776 30.826 85.3396 34.782 90.2616 34.782C95.1376 34.782 97.2536 30.826 97.2536 26.456C97.2536 22.086 95.1376 18.222 90.2616 18.222Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M75.298 26.732H61.59V38.002H57.45V7.78003H76.862V11.736H61.59V22.776H75.298V26.732Z\"/>\n\t\t</svg>\n\t\t");
};
var $c938f2c9202f2b9d$export$33908560ea1b226d = function FocusLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $c938f2c9202f2b9d$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $f9d366510db8d846$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M5.584 14.4h20.83c.599 0 .918-.32.918-.918V6.459c0-.599-.319-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v7.023c0 .599.319.918.917.918zm.36 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.199-.799.758-.799h20.191c.559 0 .798.24.798.719q-.12 2.214-.838 4.07c-.24.638-.598.918-1.277.918H7.221c-.679 0-1.038-.28-1.277-.918m18.475 3.312c-1.915 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.478-.638-.239-1.038.24-1.038h16.44c.48 0 .719.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $f9d366510db8d846$export$3f95fcfdc25a741d = function GuardIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        svg: $f9d366510db8d846$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $4aaa416bcb06d11e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 114 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $4aaa416bcb06d11e$export$a4a891d202775deb = function GuardLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $4aaa416bcb06d11e$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $a086e675d50d99f5$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path\n      fill=\"".concat(colors.iconColor, "\"\n      d=\"M25.52 25.727c0-3.604-2.949-6.517-6.517-6.517h-6.007v-5.497H6.48v10.813c0 .837.364 1.201 1.201 1.201zM6.48 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\"\n    />\n  </svg>");
};
var $a086e675d50d99f5$export$407687b2dd89cc68 = function JiraAlignIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $a086e675d50d99f5$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $0384e43546c82587$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg viewBox=\"0 0 146 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M19.04 25.727c0-3.604-2.949-6.517-6.517-6.517H6.517v-5.497H0v10.813c0 .837.364 1.201 1.201 1.201zM0 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\" fill=\"".concat(colors.iconColor, "\"/>\n      <path d=\"M144.993 16.555v8.985h-2.638v-9.26c0-2.76-1.104-3.988-3.618-3.988-2.454 0-4.14 1.626-4.14 4.723v8.525h-2.638V10.207h2.638v2.515c.981-1.81 2.79-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-19.589 7.759V22.78c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.465-6.072-7.973 0-4.324 2.116-7.974 6.379-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.054 5.152-4.906m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.975 0-4.508 1.962-4.508 5.52M107.96 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S110.873 8 109.8 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.638Zm-2.537-.03c-.215.061-.675.122-1.349.122-2.515 0-4.11-1.196-4.11-4.017V3.798h2.638v17.51c0 1.38.92 1.871 2.054 1.871.276 0 .46 0 .767-.03v2.36ZM88.83 21.523c-1.534 0-3.098-.184-4.815-.521l-1.687 4.539h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.57c-1.81.368-3.373.552-4.999.552Zm0-2.453c1.287 0 2.606-.153 4.17-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369Zm-27.807-1.196c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925ZM42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.637Zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" fill=\"").concat(colors.textColor, "\"/>\n    </svg>\n  ");
};
var $0384e43546c82587$export$ee11e928d3d045fd = function JiraAlignLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $0384e43546c82587$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $539f53a33632dfac$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z\"/>\n    </svg>");
};
var $539f53a33632dfac$export$21bfbeb62fdcce8d = function JiraProductDiscoveryIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $539f53a33632dfac$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $3a5dc488d65304f9$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 318 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $3a5dc488d65304f9$export$c49a2b642fe9eef4 = function JiraProductDiscoveryLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $3a5dc488d65304f9$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $ab3633d671879ebc$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z\"/>\n    </svg>");
};
var $ab3633d671879ebc$export$3c6158790f5e01c4 = function JiraServiceManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $ab3633d671879ebc$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $44f664ec6684700a$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 362 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z\" />\n      <path fill=").concat(colors.textColor, " d=\"M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $44f664ec6684700a$export$dabef2be6cd28c20 = function JiraServiceManagementLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $44f664ec6684700a$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $Y36zi = parcelRequire("Y36zi");

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $5f3c0cc4476ee39f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 77 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404\"/>\n    </svg>");
};
var $5f3c0cc4476ee39f$export$17d3acb0b4379d02 = function JiraLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $5f3c0cc4476ee39f$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $8onqJ = parcelRequire("8onqJ");

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $61d4fcd56468b2fe$export$7818df200941dbbf = function getColorsForLoom(appearance, colorMode) {
    var iconColor = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode).iconColor;
    var textColor = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};


var $d3bf053d58aecb39$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $61d4fcd56468b2fe$export$7818df200941dbbf)(appearance, colorMode);
    return "<svg\n    fill=\"none\"\n    height=\"32\"\n    viewBox=\"0 0 32 32\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    focusable=\"false\"\n    aria-hidden=\"true\"\n  >\n    <path\n      d=\"M27.333 15.508h-6.628l5.74-3.315-1.26-2.184-5.74 3.314 3.313-5.74-2.184-1.26-3.313 5.74V5.434h-2.522v6.628l-3.314-5.74-2.184 1.26 3.314 5.74-5.74-3.314-1.26 2.184 5.74 3.314H4.667v2.521h6.627l-5.74 3.314 1.261 2.184 5.74-3.313-3.314 5.74 2.184 1.26 3.314-5.74V28.1h2.521v-6.627l3.313 5.74 2.184-1.261-3.314-5.74 5.74 3.313 1.261-2.184-5.74-3.313h6.628zM16 20.198a3.442 3.442 0 1 1 0-6.885 3.442 3.442 0 0 1 0 6.884\"\n      fill=\"".concat(colors.iconColor, "\"\n    />\n  </svg>");
};
var $d3bf053d58aecb39$export$8d789f76fde3e05 = function LoomIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $d3bf053d58aecb39$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $24fc4a6d140006a0$export$1bf47cdade1a9fcb = function LoomAttributionIcon(_ref) {
    var appearance = _ref.appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, _ref$size = _ref.size, size = _ref$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref$size, testId = _ref.testId, _ref$iconColor = _ref.iconColor, iconColor = _ref$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref$iconColor, _ref$textColor = _ref.textColor, textColor = _ref$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d3bf053d58aecb39$export$8d789f76fde3e05), {
        appearance: appearance,
        label: label,
        size: size,
        testId: testId,
        iconColor: iconColor,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $550dd97c2a7853ef$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $61d4fcd56468b2fe$export$7818df200941dbbf)(appearance, colorMode);
    return "<svg\n\t\tfill=\"none\"\n\t\theight=\"32\"\n\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\tfocusable=\"false\"\n\t\taria-hidden=\"true\"\n\t\tviewBox=\"0 0 88 32\"\n\t>\n\t\t<path\n\t\t\td=\"M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058\"\n\t\t\tfill=\"".concat(colors.iconColor, "\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z\"\n\t\t\tfill=\"").concat(colors.textColor, "\"\n\t\t/>\n\t</svg>");
};
var $550dd97c2a7853ef$export$6e87ce8d41eda665 = function LoomAttributionLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom Attribution' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $550dd97c2a7853ef$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};




var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $df29a5258322e53f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $61d4fcd56468b2fe$export$7818df200941dbbf)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 98 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M29.657 13.659h-8.672l7.51-4.337-1.649-2.857-7.51 4.336 4.335-7.51-2.857-1.65-4.336 7.51V.479H13.18v8.672l-4.337-7.51-2.856 1.65 4.336 7.51-7.51-4.336-1.65 2.857 7.51 4.336H0v3.299h8.671l-7.51 4.336 1.65 2.858 7.51-4.336-4.336 7.51 2.857 1.65 4.336-7.511v8.672h3.3v-8.671l4.335 7.51 2.857-1.65-4.336-7.51 7.51 4.336 1.65-2.858-7.51-4.335h8.672v-3.3zM14.83 19.794a4.503 4.503 0 1 1 0-9.006 4.503 4.503 0 0 1 0 9.006\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M37.303 26.155V4.459h3.983v21.696zm38.204-14.743h3.803v1.798c.808-1.438 2.696-2.218 4.313-2.218 2.007 0 3.624.87 4.373 2.457 1.167-1.798 2.726-2.457 4.673-2.457 2.725 0 5.33 1.648 5.33 5.604v9.559h-3.862v-8.75c0-1.588-.78-2.786-2.607-2.786-1.707 0-2.726 1.318-2.726 2.907v8.63H84.85v-8.75c0-1.59-.808-2.787-2.606-2.787-1.738 0-2.757 1.288-2.757 2.907v8.63h-3.981zm-25.219 15.17c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.251 7.798-7.737 7.798m0-11.996a4.2 4.2 0 0 0-4.197 4.199c0 2.315 1.883 4.199 4.197 4.199s4.196-1.884 4.196-4.2a4.2 4.2 0 0 0-4.196-4.198m16.245 11.996c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.253 7.798-7.737 7.798m0-12.046c-2.34 0-4.245 1.906-4.245 4.247s1.904 4.247 4.245 4.247a4.25 4.25 0 0 0 4.245-4.247 4.25 4.25 0 0 0-4.245-4.247\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $df29a5258322e53f$export$94e206806e36c2ec = function LoomLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $df29a5258322e53f$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $133343937fec1563$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.114 28.127c-.785.578-1.199.537-1.984-.041-3.8-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.992.124c1.652 1.9 3.264 3.76 5.123 5.082 1.86-1.322 3.47-3.181 5.123-5.082q.434-.495.992-.124l4.297 2.686c.372.206.496.66.248.991-2.355 3.223-5.867 6.322-9.668 9.09m-.992-11.858c3.388 0 6.198-2.768 6.198-6.156s-2.81-6.239-6.198-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n    </svg>");
};
var $133343937fec1563$export$eeccc49dc7a12d9f = function OpsgenieIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        svg: $133343937fec1563$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $7012d37ccd20defe$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 154 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.78 28.127c-.785.578-1.198.537-1.983-.041-3.801-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.991.124c1.653 1.9 3.264 3.76 5.124 5.082 1.859-1.322 3.47-3.181 5.123-5.082q.435-.495.992-.124l4.297 2.686c.371.206.495.66.247.991-2.355 3.223-5.867 6.322-9.668 9.09m-.99-11.857c3.388 0 6.197-2.768 6.197-6.156s-2.81-6.239-6.197-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M146.689 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zM133.385 6.16c0-1.166.767-1.84 1.841-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84c-1.074 0-1.841-.675-1.841-1.84m.491 19.38V10.208h2.638v15.334zm-3.677-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-18.639-.614v-1.533c-.981 2.024-2.821 3.067-5.182 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.378-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.834 0 5.152-2.055 5.152-4.907m-8.678-6.44c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m-4.703 3.497c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.17-.52-5.336-1.134v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.89-1.84-3.802-2.545-3.404-.829-4.846-2.147-4.846-4.662 0-2.668 2.055-4.293 5.55-4.293 1.994 0 3.804.49 4.938 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.121 2.085 5.121 4.753m-16.274-3.496c0-3.68-1.472-5.52-4.202-5.52-2.36 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.509-1.962 4.509-5.52m-3.803 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.637V10.207h2.637v2.76c.981-2.024 2.821-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.147 7.973-6.44 7.973m-20.121 0c-6.225 0-9.721-4.293-9.721-10.426 0-6.072 3.496-10.335 9.721-10.335 6.195 0 9.69 4.263 9.69 10.335 0 6.133-3.495 10.426-9.69 10.426m0-18.124c-4.968 0-6.961 3.527-6.961 7.698 0 4.262 1.993 7.789 6.961 7.789 4.937 0 6.93-3.527 6.93-7.79 0-4.17-1.993-7.697-6.93-7.697\" />\n    </svg>");
};
var $7012d37ccd20defe$export$a1c6484cdecc2c4b = function OpsgenieLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $7012d37ccd20defe$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $96f99918f881107b$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n    <g fill=\"".concat(colors.iconColor, "\" fill-rule=\"evenodd\">\n      <path d=\"M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z\"/>\n      <path d=\"m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z\"/>\n    </g>\n  </svg>");
};
var $96f99918f881107b$export$e23ae35269442b4f = function RovoIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        svg: $96f99918f881107b$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $93173c7c8bd4c45d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 100 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path\n        d=\"M12.393 4.246a2.79 2.79 0 0 0-2.735-.026.4.4 0 0 1-.05.033l-.001.001c-.606.35-1.048.91-1.257 1.558q-.129.404-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566A2.77 2.77 0 0 0 22 20.884v-9.487c0-.991-.532-1.912-1.392-2.408z\"\n        fill=\"".concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"m1.391 9 6.176-3.566a3.6 3.6 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155h.001l4.603 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.85.47-1.89.461-2.734-.026l-8.216-4.743A2.78 2.78 0 0 1 0 20.893v-9.486c0-.996.529-1.912 1.391-2.408z\"\n        fill=\"").concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"M91.688 25.848c-4.6 0-7.298-3.404-7.298-8.004S87.088 9.9 91.688 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004zm0-13.494c-3.28 0-4.722 2.576-4.722 5.49 0 2.913 1.441 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.41-5.49-4.662-5.49M77.675 25.54H74.15L68.2 10.208h2.76l4.968 13.094 4.938-13.095h2.76zm-17.462.308c-4.6 0-7.299-3.404-7.299-8.004s2.7-7.943 7.3-7.943c4.568 0 7.236 3.342 7.236 7.942s-2.668 8.004-7.237 8.004zm0-13.494c-3.281 0-4.723 2.576-4.723 5.49 0 2.913 1.442 5.55 4.723 5.55 3.25 0 4.661-2.637 4.661-5.55 0-2.914-1.41-5.49-4.66-5.49zM43.177 8.03H39.13v7.36h4.048c3.588 0 4.692-1.38 4.692-3.68 0-2.177-1.134-3.68-4.692-3.68zm7.452 3.619c0 3.036-1.288 5.09-3.956 5.949l4.938 7.943H48.36l-4.447-7.514H39.13v7.514h-2.76V5.393h7.115c4.815 0 7.145 2.392 7.145 6.256z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $93173c7c8bd4c45d$export$a0f6cb8061290bbb = function RovoLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $93173c7c8bd4c45d$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $e5090466625d94f8$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M16 12.604c-3.033 0-5.981 1.37-8.39 3.489q-.375.373-.748.373c-.208 0-.415-.124-.581-.332l-3.032-3.572c-.166-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706 3.655-3.24 8.1-5.067 12.627-5.067s8.97 1.827 12.626 5.067c.249.249.374.457.374.706 0 .166-.084.374-.25.581l-3.032 3.572c-.166.208-.373.332-.581.332q-.374 0-.748-.374c-2.409-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.365 0-6.106-2.742-6.106-6.064S12.635 13.85 16 13.85s6.106 2.7 6.106 6.064-2.741 6.063-6.105 6.063\"/>\n    </svg>");
};
var $e5090466625d94f8$export$f3f5aa321d88adf9 = function StatuspageIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $e5090466625d94f8$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $a0b9b85073824ba8$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 188 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M13 12.604c-3.032 0-5.98 1.37-8.39 3.489q-.373.373-.747.373c-.208 0-.416-.124-.582-.332L.25 12.562c-.167-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706C4.029 8.035 8.473 6.208 13 6.208s8.971 1.827 12.626 5.067c.25.249.374.457.374.706 0 .166-.083.374-.25.581l-3.031 3.572c-.166.208-.374.332-.582.332q-.373 0-.747-.374c-2.41-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.364 0-6.105-2.742-6.105-6.064S9.635 13.85 13 13.85c3.364 0 6.105 2.7 6.105 6.064s-2.74 6.063-6.105 6.063\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M180.293 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.981 2.024-2.821 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.982 2.024-2.822 3.066-5.183 3.066-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-16.091-7.666c0-3.68-1.472-5.52-4.201-5.52-2.361 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.508-1.962 4.508-5.52m-3.802 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.638V10.207h2.638v2.76c.981-2.024 2.821-3.066 5.182-3.066 4.079 0 6.134 3.465 6.134 7.973 0 4.324-2.147 7.973-6.44 7.973m-10.56-4.477c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.52-5.336-1.134v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.829-4.845-2.147-4.845-4.662 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-27.598-2.177v-8.985h2.638v9.26c0 2.76 1.104 3.988 3.618 3.988 2.454 0 4.14-1.626 4.14-4.723v-8.525h2.638V25.54h-2.638v-2.515c-.981 1.81-2.79 2.821-4.845 2.821-3.527 0-5.55-2.422-5.55-6.654m-7.155 1.596c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454H85.39zm-18.943-2.914c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-17.258-4.752c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454h-4.078zm-6.894-.798c0 3.496-2.085 5.858-7.084 5.858-3.894 0-5.704-.767-7.268-1.564v-2.822c1.871.982 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975 0-1.778-1.104-2.729-4.937-3.649-4.539-1.104-6.563-2.668-6.563-5.98 0-3.128 2.392-5.459 7.084-5.459 2.914 0 4.784.706 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.846 3.373 4.262 1.074 6.654 2.454 6.654 6.072\" />\n    </svg>");
};
var $a0b9b85073824ba8$export$bb4ae5b41b43be04 = function StatuspageLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $a0b9b85073824ba8$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $72b24621895b039d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " clip-rule=\"evenodd\" d=\"M24.286 5.337H7.714a2.585 2.585 0 0 0-2.585 2.585v16.572a2.585 2.585 0 0 0 2.585 2.584h16.572a2.585 2.585 0 0 0 2.585-2.584V7.922a2.585 2.585 0 0 0-2.585-2.585m-9.791 15.66a.86.86 0 0 1-.859.858h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86zm8.362-4.953a.86.86 0 0 1-.859.859h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86z\" fill-rule=\"evenodd\"/>\n    </svg>");
};
var $72b24621895b039d$export$4384da9b8b140bf4 = function TrelloIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $72b24621895b039d$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $77f83b2a64e78b50$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 106 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" clip-rule=\"evenodd\" d=\"M19.157 4.67H2.585A2.585 2.585 0 0 0 0 7.255v16.572a2.585 2.585 0 0 0 2.585 2.585h16.572a2.585 2.585 0 0 0 2.584-2.585V7.255a2.585 2.585 0 0 0-2.584-2.585M9.365 20.33a.86.86 0 0 1-.858.858H4.873a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86zm8.362-4.952a.86.86 0 0 1-.858.858h-3.634a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86z\" fill-rule=\"evenodd\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M97.64 25.848c-4.6 0-7.298-3.404-7.298-8.004S93.04 9.9 97.64 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.494c-3.281 0-4.722 2.576-4.722 5.49 0 2.913 1.44 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.411-5.49-4.662-5.49M88.874 25.51c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-7.996 0c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zM65.532 12.293c-2.79 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.44-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196H61.085c.368 2.606 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zm-19.48-8.434v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M32.943 5.393H48.03V8.03h-6.164v17.511h-2.76V8.031h-6.164z\"/>\n    </svg>");
};
var $77f83b2a64e78b50$export$60e26212f3b61a28 = function TrelloLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $77f83b2a64e78b50$var$svg({
            appearance: appearance,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $4174445314181c05$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance;
    var colors = (0, $hyx75.getColorsFromAppearance)(appearance ? appearance : 'brand', colorMode);
    return "<svg viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g fill=\"".concat(colors.iconColor, "\">\n      <path d=\"M16 28.532c-6.656 0-12.068-5.412-12.068-12.068S9.344 4.396 16 4.396v1.921c-5.597 0-10.146 4.549-10.146 10.146S10.403 26.609 16 26.609zm0 0v-1.921c5.597 0 10.146-4.549 10.146-10.146h1.921c0 6.656-5.412 12.068-12.068 12.068zm12.068-12.068h-1.921c0-5.597-4.549-10.146-10.146-10.146V4.397c6.656 0 12.068 5.412 12.068 12.068zm-6.928 3.695c-1.28-.251-2.292-.706-3.973-1.467-.464-.204-.974-.436-1.559-.696a59 59 0 0 0-1.003-.436c-2.534-1.123-3.926-1.736-5.634-1.736-1.198 0-2.098.325-2.6.937a1.72 1.72 0 0 0-.38 1.448l-1.885.362a3.67 3.67 0 0 1 .78-3.035c.613-.743 1.82-1.634 4.085-1.634 2.116 0 3.824.761 6.414 1.903.316.14.641.288.994.436.594.26 1.114.492 1.578.706 1.606.724 2.488 1.123 3.555 1.327l-.371 1.885Zm1.877.185c-.64 0-1.253-.056-1.875-.185l.371-1.885c.502.102.994.149 1.504.149 1.188 0 2.089-.298 2.609-.864s.539-1.253.51-1.615l1.913-.167c.102 1.169-.251 2.265-1.003 3.082-.622.677-1.82 1.485-4.029 1.485M16 28.532v-1.921c2.757 0 4.4-2.813 4.4-7.52s-1.67-8.652-5.096-12.3l1.402-1.318c3.778 4.02 5.616 8.476 5.616 13.618 0 5.821-2.423 9.441-6.322 9.441m-.001 0c-4.15 0-6.526-3.379-6.526-9.273 0-6.879 3.008-10.722 5.82-13.776l1.412 1.299c-3.277 3.565-5.31 6.888-5.31 12.476 0 6.08 2.506 7.352 4.604 7.352z\"/>\n      <path d=\"M10.857 17.467a2.247 2.247 0 1 0 0-4.494 2.247 2.247 0 0 0 0 4.494m10.385 3.871a2.247 2.247 0 1 0 0-4.494 2.247 2.247 0 0 0 0 4.494M15.998 7.96a2.247 2.247 0 1 0 0-4.493 2.247 2.247 0 0 0 0 4.494Z\"/>\n    </g>\n  </svg>");
};
var $4174445314181c05$export$9d0b19639662f94b = function AtlasIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlas' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $4174445314181c05$var$svg({
            appearance: appearance
        }, colorMode),
        size: size,
        testId: testId
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $98e32ec83d30e263$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance;
    var colors = (0, $hyx75.getColorsFromAppearance)(appearance ? appearance : 'brand', colorMode);
    return "<svg viewBox=\"0 0 102 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path d=\"M12.068 27.865C5.412 27.865 0 22.453 0 15.797S5.412 3.73 12.068 3.73v1.922c-5.597 0-10.146 4.548-10.146 10.146 0 5.597 4.549 10.145 10.146 10.145z M12.068 27.865v-1.92c5.597 0 10.146-4.55 10.146-10.147h1.921c0 6.656-5.412 12.068-12.068 12.068h.001Zm12.068-12.068h-1.921c0-5.597-4.549-10.146-10.146-10.146V3.73c6.656 0 12.068 5.412 12.068 12.068zm-6.927 3.695c-1.282-.25-2.293-.705-3.974-1.466-.464-.204-.974-.436-1.559-.696a58 58 0 0 0-1.003-.436C8.14 15.77 6.747 15.158 5.04 15.158c-1.198 0-2.098.324-2.6.937a1.72 1.72 0 0 0-.38 1.448l-1.885.362a3.67 3.67 0 0 1 .78-3.035c.613-.743 1.82-1.634 4.085-1.634 2.116 0 3.824.761 6.414 1.903.316.14.641.288.994.436.594.26 1.114.492 1.578.705 1.606.724 2.488 1.124 3.555 1.328l-.371 1.884Z M19.085 19.677c-.64 0-1.253-.056-1.875-.185l.371-1.885c.502.102.994.15 1.504.15 1.188 0 2.089-.298 2.609-.864s.539-1.254.51-1.616l1.913-.167c.102 1.17-.251 2.265-1.003 3.082-.622.677-1.82 1.485-4.029 1.485 M12.068 27.865v-1.92c2.757 0 4.4-2.814 4.4-7.52 0-4.707-1.67-8.652-5.096-12.3l1.402-1.318c3.778 4.02 5.616 8.475 5.616 13.618 0 5.82-2.423 9.44-6.322 9.44 M12.067 27.866c-4.15 0-6.526-3.379-6.526-9.274 0-6.878 3.008-10.722 5.82-13.776l1.412 1.3c-3.277 3.564-5.31 6.888-5.31 12.476 0 6.08 2.506 7.352 4.604 7.352v1.921Z\" fill=\"".concat(colors.iconColor, "\"/>\n    <path d=\"M6.925 16.8a2.247 2.247 0 1 0 0-4.494 2.247 2.247 0 0 0 0 4.494m10.385 3.872a2.247 2.247 0 1 0 0-4.494 2.247 2.247 0 0 0 0 4.494M12.066 7.294a2.247 2.247 0 1 0 0-4.494 2.247 2.247 0 0 0 0 4.494\" fill=\"").concat(colors.iconColor, "\"/>\n    <path d=\"M101.019 21.163c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.89-1.84-3.803-2.545-3.404-.828-4.845-2.147-4.845-4.661 0-2.668 2.054-4.294 5.55-4.294 1.994 0 3.803.491 4.938 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.675-2.975 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.122 2.086 5.122 4.754m-25.873-3.496c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.08 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.638v15.333zm-12.784-.03c-.214.061-.674.122-1.349.122-2.514 0-4.11-1.196-4.11-4.017V3.591h2.638V21.1c0 1.38.92 1.871 2.055 1.871.276 0 .46 0 .767-.03v2.36ZM58.12 20.58c0 1.35.798 2.27 2.423 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.779.245c-3.28 0-4.876-1.932-4.876-4.784v-8.188h-2.483V10h2.483V6.75h2.577V10h4.078v2.453h-4.078v8.127Zm-14.675.736c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.81.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\" fill=\"").concat(colors.textColor, "\"/>\n  </svg>");
};
var $98e32ec83d30e263$export$e388b783bff06f6c = function AtlasLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlas' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        size: size,
        svg: $98e32ec83d30e263$var$svg({
            appearance: appearance
        }, colorMode),
        testId: testId
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $0f47431498944ba2$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 377 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M369.828 12.524c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.943 8.004-7.943 1.38 0 2.453.184 3.649.736v2.454c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.514-5.612 5.489s1.656 5.49 5.673 5.49c1.564 0 2.545-.215 3.496-.553m-26.118-4.906c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.638v15.333zm-12.783-.031c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V4.03h2.637v17.51c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-11.153-7.635c0-3.68-1.472-5.52-4.202-5.52-2.361 0-4.477 1.502-4.477 4.906v1.227c0 3.404 1.932 4.907 4.171 4.907 2.974 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.239 0-3.956-1.012-4.876-3.005v8.678h-2.637V10.44h2.637v2.76c.981-2.024 2.821-3.067 5.183-3.067 4.078 0 6.133 3.466 6.133 7.974 0 4.324-2.147 7.973-6.44 7.973zm-14.975-5.06c0 1.35.798 2.27 2.423 2.27.613 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.779.245c-3.281 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10.44h2.484V7.19h2.576v3.25h4.079v2.453h-4.079zm-13.537-8.495c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-23.82.613h-2.637V4.03H269v13.585l6.593-7.176h3.435l-7.207 7.544 7.514 7.79h-3.588L269 18.595zm-10.333-9.046v9.046h-2.576V10.44h2.576v2.699c.889-1.81 2.422-3.098 5.428-2.914V12.8c-3.374-.337-5.428.675-5.428 3.926m-17.869 1.38c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.638v15.333zm-31.445-11.009-2.76-7.483v18.492h-2.76V5.624h4.784l4.569 11.562 1.871 5.55 1.871-5.55 4.6-11.562h4.446v20.148h-2.76V7.495l-2.361 7.268-4.447 11.01h-2.668z\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 11.267c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.807c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V10.417l1.769 4.034 6.087 11.325h5.379V5.604h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.156c0-3.54-1.841-5.167-7.149-6.3-2.902-.636-3.609-1.273-3.609-2.194 0-1.132 1.061-1.627 2.972-1.627 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.308 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3zM71.069 5.604v20.172h9.625l1.486-4.389h-6.44V5.604zm-19.039 0v4.318h5.167v15.854h4.741V9.922h5.592V5.604zm-6.866 0h-6.157L32 25.776h5.379l.99-3.398c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.698c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.604H91.17l-7.08 20.172h5.38l.99-3.398c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.114 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.094h-6.157l-7.007 20.172h5.379l.991-3.398c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.817 12.293 3.647c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.126-2.167 8 0 4.002 2.042 7.752 5.043 13.795.333.666.583.791 1.166.791h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.816c-.833-1.25-1.083-1.334-1.292-1.334s-.333.084-.708.834L.208 24.9c-.166.334-.208.459-.208.626 0 .333.292.666.917.666h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.875.333-2.917 0-2.917-1.292-5.751-2.292-7.251\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $0f47431498944ba2$export$32e7eace0c9d6a57 = function AtlassianMarketplaceLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Marketplace' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $0f47431498944ba2$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $4d13fd8db0387c2f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n    <path fill=\"".concat(colors.iconColor, "\" d=\"M27.545 24.817 16.96 3.647c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.126-2.167 8 0 4.002 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.816c-.834-1.25-1.084-1.334-1.292-1.334s-.333.084-.708.834L4.875 24.9c-.167.334-.208.459-.208.626 0 .333.291.666.916.666h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.875.334-2.917 0-2.917-1.292-5.751-2.292-7.251\"/>\n  </svg>\n  ");
};
var $4d13fd8db0387c2f$export$94c87d39a54a1894 = function AtlassianMarketplaceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Marketplace' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        svg: $4d13fd8db0387c2f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $0f9005534e6d00b4$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 32 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.126-2.167 8.001 0 4 2.042 7.751 5.042 13.794.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.084-.708.834L4.875 24.462c-.167.333-.208.458-.208.625 0 .333.291.666.916.666h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.875.334-2.917 0-2.917-1.292-5.751-2.292-7.251\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $0f9005534e6d00b4$export$a825993f361832f7 = function AtlassianAccessIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Access' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        svg: $0f9005534e6d00b4$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $df5a6323ac020c2a$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 299 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M298.505 21.163c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.675-2.974 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.121 2.086 5.121 4.754m-13.626 0c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.828-4.845-2.147-4.845-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.802.491 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.675-2.975 1.87 0 1.074.736 1.749 3.558 2.423 3.404.828 5.121 2.086 5.121 4.754m-20.467-9.078c-2.791 0-4.202 1.81-4.478 4.478h8.556c-.153-2.852-1.441-4.478-4.078-4.478M270.3 24.72c-1.258.675-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.147v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.943 8.004-7.943 1.38 0 2.453.184 3.649.736v2.454c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.514-5.612 5.489s1.656 5.49 5.673 5.49c1.564 0 2.546-.215 3.496-.553m-13.836 0v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.943 8.004-7.943 1.38 0 2.453.184 3.649.736v2.454c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.514-5.612 5.489s1.656 5.49 5.673 5.49c1.564 0 2.546-.215 3.496-.553m-22.45-1.257c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.337h5.379l.99-3.398c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.172h5.38l.99-3.398c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.172h5.379l.991-3.398c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.126-2.167 8.001 0 4 2.042 7.751 5.043 13.794.333.666.583.791 1.166.791h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.084-.708.834L.208 24.462c-.166.333-.208.458-.208.625 0 .333.292.666.917.666h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.875.333-2.917 0-2.917-1.292-5.751-2.292-7.251\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $df5a6323ac020c2a$export$5aa23cd4d8596f56 = function AtlassianAccessLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Access' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $df5a6323ac020c2a$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $h8qvJ = parcelRequire("h8qvJ");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $1945384bec13664b$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: (0, $8onqJ.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $8onqJ.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $8ea89a764ffd4a31$export$362a25f017e2bc8a)(appearance, colorMode);
    return "\n  <svg\n  fill=\"none\"\n  height=\"32\"\n  viewBox=\"0 0 303 32\"\n  xmlns=\"http://www.w3.org/2000/svg\"\n>\n  <linearGradient\n    id=\"".concat(id, "\"\n    gradientUnits=\"userSpaceOnUse\"\n    x1=\"7.94848\"\n    x2=\"14.7792\"\n    y1=\"19.536\"\n    y2=\"11.1249\"\n  >\n    <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " />\n    <stop offset=\"100%\" stop-color=\"").concat(colors.iconGradientStop, "\" />\n  </linearGradient>\n  <path\n    d=\"m12.3893 6.29721-3.42568 13.18669c4.35918 1.2052 7.83828-.3558 9.17088-5.4802l1.9988-7.69729z\"\n    fill=\"url(#").concat(id, ")\"\n  />\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m7.75657 24.1237 3.42573-13.1866c-4.3623-1.19602-7.8383.3649-9.17087 5.4985l-2.01143 7.6881z\" />\n  <g fill=\"").concat(colors.textColor, "\">\n    <path\n      clip-rule=\"evenodd\"\n      d=\"m122.757 5v19.1237h2.379v-6.305l6.085 6.305h3.234l-6.776-6.8448 6.499-6.6485h-3.095l-5.947 6.3296v-11.96zm-84.0053.55058c-.2088-.0757-.4319-.1066-.654-.09058-.222-.0155-.4448.01575-.6533.09164-.2086.07589-.398.19465-.5553.34821-.1574.15356-.2791.33835-.3569.54183s-.1098.4209-.0939.63752c0 .42944.1748.84129.486 1.14495s.7333.47425 1.1734.47425.8622-.17059 1.1734-.47425.4861-.71551.4861-1.14495c.0164-.21674-.0153-.43438-.0929-.6381s-.1993-.38872-.3568-.5424c-.1574-.15367-.347-.27241-.5558-.34812zm.5089 5.07982h-2.3792v13.4933h2.3792zm-5.6979-4.22587h-2.4891l.0094 12.49357c0 1.7695-.726 2.9962-2.8286 2.9962-.88.0065-1.7534-.1496-2.574-.46v2.349c.9621.3182 1.9731.4727 2.9889.457 3.4288 0 4.8934-2.2387 4.8934-5.5047zm11.6158 17.71917h-2.3225v-13.4933h2.3225v2.3736c.8015-1.5916 2.1843-2.7232 4.8966-2.5637v2.2693c-3.0423-.3067-4.8966.5919-4.8966 3.4531zm11.3678.2791c2.1309 0 3.7903-.9169 4.6734-2.6987l.0032 2.4196h2.3791v-13.4933h-2.3791v2.3828c-.8329-1.7541-2.3823-2.6435-4.4-2.6435-3.872 0-5.808 3.2108-5.808 7.0166 0 3.9682 1.8543 7.0165 5.5314 7.0165zm4.6734-6.4768c0 2.9961-1.9077 4.3179-4.0385 4.3179-2.4609 0-3.7872-1.6192-3.7966-4.8576 0-3.1311 1.3829-4.8576 4.0637-4.8576 2.0303 0 3.7714 1.3217 3.7714 4.3178zm8.6023-11.52147h2.5709l4.7143 15.43457 5.1731-15.43457h2.9291l5.1732 15.43457 4.73-15.43457h2.4891l-5.7105 17.71917h-3.1806l-5.0286-15.1401-5.0285 15.1401h-3.0989zm34.376 3.96517c-4.148 0-6.5808 2.941-6.5808 6.989s2.4608 7.0533 6.5808 7.0533c4.121 0 6.528-3.0053 6.528-7.0533s-2.379-6.989-6.528-6.989zm0 11.8742c-2.957 0-4.2582-2.3215-4.2582-4.8852h.0031c0-2.5638 1.3231-4.83 4.2551-4.83 2.933 0 4.205 2.2662 4.205 4.83 0 2.5637-1.247 4.8852-4.205 4.8852zm11.617 1.8798h-2.323v-13.4933h2.323v2.3736c.801-1.5916 2.184-2.7232 4.896-2.5637v2.2693c-3.042-.3067-4.896.5919-4.896 3.4531zm28.734-16.2533v16.2533h-2.492v-17.71917h4.315l4.121 10.17217 1.687 4.8852 1.688-4.8852 4.149-10.17217h4.01v17.71917h-2.489v-16.07543l-2.131 6.39703-4.007 9.6784h-2.408l-3.953-9.6784zm26.165 16.5324c2.131 0 3.79-.9169 4.673-2.6987l.003 2.4196h2.38v-13.4933h-2.38v2.3828c-.833-1.7541-2.382-2.6435-4.4-2.6435-3.872 0-5.808 3.2108-5.808 7.0166 0 3.9682 1.855 7.0165 5.532 7.0165zm4.673-6.4768c0 2.9961-1.907 4.3179-4.038 4.3179-2.461 0-3.787-1.6192-3.797-4.8576 0-3.1311 1.383-4.8576 4.064-4.8576 2.03 0 3.771 1.3217 3.771 4.3178zm17.729 6.1977h-2.379v-8.142c0-2.4288-.996-3.5082-3.262-3.5082-2.2 0-3.734 1.4321-3.734 4.1584v7.4918h-2.379v-13.4933h2.379v2.2141c.423-.7665 1.055-1.4041 1.826-1.8424s1.651-.6603 2.543-.6416c3.18 0 5.006 2.1467 5.006 5.8574zm8.021.2791c2.131 0 3.79-.9169 4.673-2.6987l.003 2.4196h2.379v-13.4933h-2.379v2.3828c-.833-1.7541-2.382-2.6435-4.4-2.6435-3.872 0-5.808 3.2108-5.808 7.0166 0 3.9682 1.855 7.0165 5.532 7.0165zm4.673-6.4768c0 2.9961-1.908 4.3179-4.038 4.3179-2.461 0-3.772-1.6192-3.772-4.8668 0-3.1219 1.367-4.8484 4.039-4.8484 2.03 0 3.771 1.3217 3.771 4.3178zm15.293 3.7781c-.883 1.7818-2.542 2.6987-4.673 2.6987-3.658 0-5.475-3.0391-5.475-7.0257 0-3.8058 1.908-7.0166 5.752-7.0166 2.02 0 3.567.8894 4.4 2.6435v-2.3736h2.325v12.2667c0 3.9682-1.911 6.6393-6.861 6.6393-1.672.0477-3.339-.1995-4.921-.7299v-2.2294c1.549.5193 3.173.7927 4.811.8096 3.458 0 4.646-1.8094 4.646-4.3179zm-4.035.5398c2.128 0 4.035-1.3218 4.035-4.3179v-1.0795c0-2.9961-1.741-4.3178-3.771-4.3178-2.684 0-4.067 1.7265-4.067 4.8576.013 3.2384 1.339 4.8576 3.803 4.8576zm9.127-4.8944c0 4.14 2.266 7.0533 7.439 7.0533 1.411 0 3.152-.2147 4.281-.7943v-2.1466c-1.346.477-2.767.7199-4.199.7176-3.263 0-4.784-1.4843-5.117-3.7782h10.092v-1.0518c0-4.1002-1.71-6.989-5.972-6.989-4.202 0-6.524 2.9134-6.524 6.989zm10.095-.92h-7.719v-.0154c.251-2.346 1.521-3.9437 4.038-3.9437 2.38 0 3.542 1.4352 3.681 3.9591zm16.98 7.6942h-2.379v-8.142c0-2.4288-.996-3.5082-3.265-3.5082-2.2 0-3.731 1.4321-3.731 4.1584v7.4918h-2.379v-13.4933h2.37v2.2141c.423-.7667 1.054-1.4045 1.825-1.8428.771-.4384 1.651-.6603 2.543-.6412 2.351 0 3.954 1.1592 4.646 3.2936.776-2.0792 2.627-3.2936 4.924-3.2936 3.096 0 4.812 2.0516 4.812 5.8574v7.9058h-2.379v-7.4918c.009-2.7815-.971-4.1615-3.253-4.1615-2.2 0-3.734 1.4321-3.734 4.1584zm11.865-6.7742c0 4.14 2.266 7.0533 7.439 7.0533 1.411 0 3.152-.2147 4.287-.8035v-2.1466c-1.347.4808-2.771.7269-4.205.7268-3.263 0-4.784-1.4843-5.117-3.7782h10.095v-1.0518c0-4.1002-1.713-6.989-5.972-6.989-4.205 0-6.527 2.9134-6.527 6.989zm10.095-.92h-7.716v-.0154c.258-2.346 1.515-3.9437 4.029-3.9437 2.385 0 3.548 1.4352 3.687 3.9591zm16.98 7.6942h-2.379v-8.142c0-2.4288-1.002-3.5113-3.262-3.5113-2.2 0-3.734 1.4321-3.734 4.1584v7.4949h-2.379v-13.4933h2.379v2.2141c.423-.7667 1.055-1.4045 1.826-1.8428.771-.4384 1.651-.6603 2.543-.6412 3.18 0 5.006 2.1467 5.006 5.8574zm10.287-2.3644c-.49.1102-.99.1728-1.493.1871-1.464 0-2.184-.8096-2.187-1.9964v-7.1729h3.677v-2.1467h-3.677v-2.852h-2.323v2.852h-2.241v2.1681h2.241v7.2067c0 2.5085 1.44 4.2075 4.4 4.2075.542.0028 1.082-.0695 1.603-.2147z\"\n      fill-rule=\"evenodd\"\n    />\n  </g>\n</svg>");
};
var $1945384bec13664b$export$56cadce97cc7cc = function JiraWorkManagementLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Work Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $h8qvJ.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $1945384bec13664b$var$svg({
            appearance: appearance,
            size: size,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $h8qvJ = parcelRequire("h8qvJ");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $67babfef1c42b04b$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: (0, $8onqJ.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $8onqJ.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8ea89a764ffd4a31$export$362a25f017e2bc8a)(appearance, colorMode);
    return "\n    <svg\n      fill=\"none\"\n      height=\"32\"\n      viewBox=\"0 0 32 32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n    >\n      <linearGradient\n        id=\"".concat(id, "\"\n        gradientUnits=\"userSpaceOnUse\"\n        x1=\"13.9485\"\n        x2=\"20.7792\"\n        y1=\"20.2388\"\n        y2=\"11.8277\"\n      >\n        <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " />\n        <stop offset=\"100%\" stop-color=\"").concat(colors.iconGradientStop, "\" />\n      </linearGradient>\n      <path\n        d=\"m18.3893 7-3.4257 13.1867c4.3592 1.2052 7.8383-.3558 9.1709-5.4802l1.9988-7.6973z\"\n        fill=\"url(#").concat(id, ")\"\n      />\n      <path\n      fill=\"").concat(colors.iconColor, "\"\n      d=\"m13.7566 24.8265 3.4257-13.1866c-4.3623-1.196-7.8383.3649-9.17087 5.4985l-2.01143 7.6881z\"\n      />\n    </svg>");
};
var $67babfef1c42b04b$export$7330b9fc5718fd30 = function JiraWorkManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Work Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $h8qvJ.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $67babfef1c42b04b$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $50101e7733a6b1d7$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251\"/>\n    </svg>");
};
var $50101e7733a6b1d7$export$8a485e2e7ed91e8f = function AtlassianIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $50101e7733a6b1d7$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $hyx75 = parcelRequire("hyx75");
var $47d58fd2ef4b1aac$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $hyx75.getColorsFromAppearance)(appearance, colorMode);
    return "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 198 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\">\n      <path fill=".concat(colors.iconColor, " d=\"M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"/>\n      <path fill=").concat(colors.atlassianLogoTextColor, " d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.265 0 1.061-.708 1.698-2.973 1.698-2.619 0-5.733-.92-7.785-2.123v4.813c1.627.778 3.751 1.698 7.785 1.698 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.298-2.902-.637-3.61-1.274-3.61-2.194 0-1.133 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.698v-4.6c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.17h4.318V9.979l1.769 4.035 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.821-4.883-9.201zm-27.319 0h-4.671v20.17h4.671zm-10.05 14.154c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.708 6.795 1.699v-4.6c-1.557-.78-3.893-1.346-6.653-1.346-5.238 0-7.927 2.265-7.927 5.946 0 2.972 1.344 5.308 6.794 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.618 0-5.733-.92-7.785-2.123v4.812c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.166v20.17h9.625l1.486-4.387h-6.44V5.166zm-19.039 0v4.317h5.167v15.854h4.741V9.483h5.592V5.166zm-6.866 0h-6.157L32 25.336h5.379l.99-3.396c1.204.353 2.478.566 3.752.566s2.548-.213 3.751-.567l.991 3.398h5.379c-.07 0-7.078-20.171-7.078-20.171M42.05 18.259c-.92 0-1.77-.141-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354zM97.326 5.166H91.17l-7.078 20.17h5.38l.99-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.114 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.093h-6.157l-7.007 20.17h5.379l.991-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.043 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354\"/>\n    </svg>");
};
var $47d58fd2ef4b1aac$export$765cacec8b0843f3 = function AtlassianLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $47d58fd2ef4b1aac$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $h8qvJ = parcelRequire("h8qvJ");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $0d3d329829351edb$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: (0, $8onqJ.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $8onqJ.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8ea89a764ffd4a31$export$362a25f017e2bc8a)(appearance, colorMode);
    return "\n  <svg viewBox=\"0 0 32 32\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"108.695%\" x2=\"12.439%\" y1=\"-14.936%\" y2=\"45.215%\" id=\"".concat(id, "-1\">\n        <stop stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(colors.iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n      <linearGradient x1=\"0%\" x2=\"91.029%\" y1=\"118.55%\" y2=\"63.971%\" id=\"").concat(id, "-2\">\n        <stop stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(colors.iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n      <path fill=\"").concat(colors.iconColor, "\" d=\"M15.9669691 29.3616152C17.2195568 28.1097726 17.9233158 26.4114623 17.9233158 24.6405626 17.9233158 22.8696629 17.2195568 21.1713527 15.9669691 19.91951L7.26805808 11.2489111 3.31143376 15.2055354C2.89743442 15.6200502 2.89743442 16.291565 3.31143376 16.7060799L15.9669691 29.3616152zM28.6225045 15.2055354L15.9669691 2.55 15.9280399 2.58892922C13.3485687 5.19994003 13.3612164 9.40374108 15.9563521 11.9991833L24.6623412 20.6662432 28.6225045 16.7060799C29.0365039 16.291565 29.0365039 15.6200502 28.6225045 15.2055354z\" />\n      <path fill=\"url(#").concat(id, "-1\" d=\"M15.9669691,11.9921053 C13.3718335,9.39666304 13.3591857,5.19286199 15.938657,2.58185118 L6.91061706,11.6063521 L11.6316697,16.3274047 L15.9669691,11.9921053 Z\" />\n      <path fill=\"url(#").concat(id, "-2\" d=\"M20.2951906,15.5912886 L15.9669691,19.91951 C17.2195568,21.1713527 17.9233158,22.8696629 17.9233158,24.6405626 C17.9233158,26.4114623 17.2195568,28.1097726 15.9669691,29.3616152 L25.0162432,20.3123412 L20.2951906,15.5912886 Z\" />\n    </g>\n  </svg>");
};
var $0d3d329829351edb$export$c3835feba2a66e67 = function JiraSoftwareIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Software' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $h8qvJ.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $0d3d329829351edb$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $h8qvJ = parcelRequire("h8qvJ");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $b6cb5eaa962c21c0$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: (0, $8onqJ.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $8onqJ.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $8ea89a764ffd4a31$export$362a25f017e2bc8a)(appearance, colorMode);
    return "\n  <svg viewBox=\"0 0 179 32\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"97.6553341%\" y1=\"35.6591143%\" x2=\"37.202032%\" y2=\"75.4891864%\" id=\"".concat(id, "-1\">\n        <stop stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"7%\"></stop>\n        <stop stop-color=\"").concat(colors.iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n      <linearGradient x1=\"8.43371138%\" y1=\"60.1495759%\" x2=\"64.1161517%\" y2=\"23.5790285%\" id=\"").concat(id, "-2\">\n        <stop stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(colors.iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n      <path fill=\"").concat(colors.iconColor, "\" d=\"M11.3881081,27.9242105 C12.4881804,26.8071817 13.1062496,25.2917664 13.1062496,23.7115789 C13.1062496,22.1313915 12.4881804,20.6159762 11.3881081,19.4989474 L11.3881081,19.4989474 L3.74837838,11.7621053 L0.273513514,15.2926316 C-0.0900771727,15.6625064 -0.0900771727,16.2617042 0.273513514,16.6315789 L11.3881081,27.9242105 L11.3881081,27.9242105 Z\" fill-rule=\"nonzero\"></path>\n      <path fill=\"").concat(colors.iconColor, "\" d=\"M22.5027027,15.2926316 L11.3881081,4 L11.3881081,4 L11.3539189,4.03473684 L11.3539189,4.03473684 C9.08852466,6.36456187 9.09963243,10.1156459 11.3787838,12.4315789 L19.0247297,20.1652632 L22.5027027,16.6315789 C22.8662934,16.2617042 22.8662934,15.6625064 22.5027027,15.2926316 Z\" fill-rule=\"nonzero\"></path>\n      <path d=\"M11.3881081,12.4252632 C9.10895676,10.1093301 9.09784899,6.35824608 11.3632432,4.02842105 L3.43445946,12.0810526 L7.58067568,16.2936842 L11.3881081,12.4252632 Z\" fill=\"url(#").concat(id, "-1)\" fill-rule=\"nonzero\"></path>\n      <path fill=\"url(#").concat(id, "-2)\" d=\"M15.1893243,15.6368421 L11.3881081,19.4989474 C12.4881804,20.6159762 13.1062496,22.1313915 13.1062496,23.7115789 C13.1062496,25.2917664 12.4881804,26.8071817 11.3881081,27.9242105 L19.3355405,19.8494737 L15.1893243,15.6368421 Z\" fill-rule=\"nonzero\"></path>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M36.07,18.956 C36.07,20.646 35.394,21.842 33.418,21.842 C32.56,21.842 31.702,21.686 31,21.4 L31,23.662 C31.65,23.896 32.586,24.104 33.808,24.104 C37.032,24.104 38.41,21.946 38.41,18.8 L38.41,6.918 L36.07,6.918 L36.07,18.956 Z M41.894,7.568 C41.894,8.556 42.544,9.128 43.454,9.128 C44.364,9.128 45.014,8.556 45.014,7.568 C45.014,6.58 44.364,6.008 43.454,6.008 C42.544,6.008 41.894,6.58 41.894,7.568 Z M42.31,24 L44.546,24 L44.546,11 L42.31,11 L42.31,24 Z M47.926,24 L50.11,24 L50.11,16.33 C50.11,13.574 51.852,12.716 54.712,13.002 L54.712,10.818 C52.164,10.662 50.864,11.754 50.11,13.288 L50.11,11 L47.926,11 L47.926,24 Z M65.45,24 L65.45,21.66 C64.618,23.376 63.058,24.26 61.056,24.26 C57.598,24.26 55.856,21.322 55.856,17.5 C55.856,13.834 57.676,10.74 61.316,10.74 C63.214,10.74 64.67,11.598 65.45,13.288 L65.45,11 L67.686,11 L67.686,24 L65.45,24 Z M58.092,17.5 C58.092,20.62 59.34,22.18 61.654,22.18 C63.656,22.18 65.45,20.906 65.45,18.02 L65.45,16.98 C65.45,14.094 63.812,12.82 61.914,12.82 C59.392,12.82 58.092,14.484 58.092,17.5 Z M86.926,19.294 C86.926,16.226 84.898,15.056 81.284,14.146 C78.268,13.392 77.176,12.69 77.176,11.286 C77.176,9.726 78.502,8.946 80.738,8.946 C82.506,8.946 84.352,9.258 86.068,10.246 L86.068,7.906 C84.898,7.256 83.312,6.658 80.842,6.658 C76.864,6.658 74.836,8.634 74.836,11.286 C74.836,14.094 76.552,15.42 80.4,16.356 C83.65,17.136 84.586,17.942 84.586,19.45 C84.586,20.958 83.624,21.972 81.05,21.972 C78.788,21.972 76.344,21.374 74.758,20.542 L74.758,22.934 C76.084,23.61 77.618,24.26 80.92,24.26 C85.158,24.26 86.926,22.258 86.926,19.294 Z M95.09,24.26 C91.19,24.26 88.902,21.374 88.902,17.474 C88.902,13.574 91.19,10.74 95.09,10.74 C98.964,10.74 101.226,13.574 101.226,17.474 C101.226,21.374 98.964,24.26 95.09,24.26 Z M95.09,12.82 C92.308,12.82 91.086,15.004 91.086,17.474 C91.086,19.944 92.308,22.18 95.09,22.18 C97.846,22.18 99.042,19.944 99.042,17.474 C99.042,15.004 97.846,12.82 95.09,12.82 Z M106.92,9.622 C106.92,8.452 107.596,7.646 108.974,7.646 C109.494,7.646 109.988,7.698 110.378,7.776 L110.378,5.722 C109.988,5.618 109.546,5.514 108.87,5.514 C106.088,5.514 104.736,7.152 104.736,9.57 L104.736,11 L102.63,11 L102.63,13.08 L104.736,13.08 L104.736,24 L106.92,24 L106.92,13.08 L110.274,13.08 L110.274,11 L106.92,11 L106.92,9.622 Z M115.786,19.892 L115.786,13.08 L119.244,13.08 L119.244,11 L115.786,11 L115.786,8.244 L113.602,8.244 L113.602,11 L111.496,11 L111.496,13.08 L113.602,13.08 L113.602,19.944 C113.602,22.362 114.954,24 117.736,24 C118.412,24 118.854,23.896 119.244,23.792 L119.244,21.634 C118.854,21.712 118.36,21.816 117.84,21.816 C116.462,21.816 115.786,21.036 115.786,19.892 Z M125.432,24 L128.292,24 L130.528,17.708 L131.724,13.704 L132.92,17.708 L135.156,24 L138.016,24 L142.8,11 L140.33,11 L136.586,22.024 L132.79,11 L130.658,11 L126.862,22.024 L123.118,11 L120.648,11 L125.432,24 Z M153.538,24 L153.538,21.66 C152.706,23.376 151.146,24.26 149.144,24.26 C145.686,24.26 143.944,21.322 143.944,17.5 C143.944,13.834 145.764,10.74 149.404,10.74 C151.302,10.74 152.758,11.598 153.538,13.288 L153.538,11 L155.774,11 L155.774,24 L153.538,24 Z M146.18,17.5 C146.18,20.62 147.428,22.18 149.742,22.18 C151.744,22.18 153.538,20.906 153.538,18.02 L153.538,16.98 C153.538,14.094 151.9,12.82 150.002,12.82 C147.48,12.82 146.18,14.484 146.18,17.5 Z M159.154,24 L161.338,24 L161.338,16.33 C161.338,13.574 163.08,12.716 165.94,13.002 L165.94,10.818 C163.392,10.662 162.092,11.754 161.338,13.288 L161.338,11 L159.154,11 L159.154,24 Z M178.108,23.48 C177.042,24.052 175.404,24.26 174.078,24.26 C169.216,24.26 167.084,21.452 167.084,17.474 C167.084,13.548 169.268,10.74 173.22,10.74 C177.224,10.74 178.836,13.522 178.836,17.474 L178.836,18.488 L169.346,18.488 C169.658,20.698 171.088,22.128 174.156,22.128 C175.664,22.128 176.938,21.842 178.108,21.426 L178.108,23.48 Z M173.116,12.768 C170.75,12.768 169.554,14.302 169.32,16.564 L176.574,16.564 C176.444,14.146 175.352,12.768 173.116,12.768 Z\" fill-rule=\"evenodd\"></path>\n    </g>\n  </svg>");
};
var $b6cb5eaa962c21c0$export$8869c52f95591fed = function JiraSoftwareLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Software' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $h8qvJ.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $b6cb5eaa962c21c0$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};



var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
var $1de484d679ff13a5$var$_excluded = [
    "size"
];
/**
 * Creates a wrapper around the new logo or icon component to ensure it receives the correct default (medium) size prop.
 *
 * @param NewComponent - The new logo or icon component.
 */ var $1de484d679ff13a5$export$667425256e2e7296 = function tempSizeWrapper(NewComponent) {
    return function(_ref) {
        var size = _ref.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $1de484d679ff13a5$var$_excluded);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var Component = NewComponent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            size: size || 'medium'
        }, props));
    };
};


var $1cf61e15150efda7$var$_excluded = [
    "shouldUseHexLogo"
];
var $1cf61e15150efda7$export$2469203854060337 = function createFeatureFlaggedRovoComponent(_LegacyComponent, _NewComponent, NewHexComponent) {
    var RovoHexWrapped = (0, $1de484d679ff13a5$export$667425256e2e7296)(NewHexComponent);
    return function(_ref) {
        var _shouldUseHexLogo = _ref.shouldUseHexLogo, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $1cf61e15150efda7$var$_excluded);
        // Hex logo is now always used (platform-logo-rebrand-rovo-hex fully launched)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(RovoHexWrapped, props);
    };
};



/**
 * __Admin icon__
 *
 * The Admin icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $2d94d3bb9b62d159$export$ef8e5f836dd989d3 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $fdd60fb407482c20$export$ef8e5f836dd989d3));
var $2d94d3bb9b62d159$export$ebcd30672e67406 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $82e1f1c7094b4744$export$61afcb38c001e19));
var $2d94d3bb9b62d159$export$af3460f51ce3602a = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $e1043fa2303698cc$export$af3460f51ce3602a));
var $2d94d3bb9b62d159$export$c8415b6abe4a8587 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $0be36fd552dc1c99$export$f0bac2b7ac3e3504));
var $2d94d3bb9b62d159$export$d89497e7f33ca6f5 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $07c282adbd4b5243$export$d89497e7f33ca6f5));
var $2d94d3bb9b62d159$export$48ca930f3071e3e4 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $67e6f3ace9444edb$export$81c47abe19675c4c));
var $2d94d3bb9b62d159$export$52cd484a7ef4f2b9 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $ad00fac377c9e40f$export$52cd484a7ef4f2b9));
var $2d94d3bb9b62d159$export$9ca9881809919df8 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $d3bc400e03f0c58c$export$a529e78951cd6709));
var $2d94d3bb9b62d159$export$6da5aa77c402ba0f = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $c1154bc2e76da5bc$export$6da5aa77c402ba0f));
var $2d94d3bb9b62d159$export$abc95e6180bb1d88 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $08a10d77ef70bbc8$export$f597f0f7fadce0b9));
var $2d94d3bb9b62d159$export$34420f0520b19b1d = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $7a1b18946ccbad19$export$34420f0520b19b1d));
var $2d94d3bb9b62d159$export$c9696eb3c34c5a96 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $c1e8533d1c9e7c7d$export$bbccafb125ebd50c));
var $2d94d3bb9b62d159$export$9eb74917ea768ed4 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $a91c75e095c80598$export$9eb74917ea768ed4));
var $2d94d3bb9b62d159$export$d2577aa28451395f = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $7d59ddb7b829c48b$export$c527a545aa426db3));
var $2d94d3bb9b62d159$export$92c8767b874048d = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $dfcee9eb5660984d$export$92c8767b874048d));
var $2d94d3bb9b62d159$export$d5648119d5b68e90 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $6d94cf131d4d8744$export$8b6b7f1b1b2367d3));
var $2d94d3bb9b62d159$export$80b8b269d8b5014e = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $21530e0c9bf76790$export$80b8b269d8b5014e));
var $2d94d3bb9b62d159$export$fc9bd6687b80fe3b = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $25e04bc358978974$export$7a38180641471460));
var $2d94d3bb9b62d159$export$5ed3e1bb3b04fc02 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $41cbf4a689ed8f4f$export$5ed3e1bb3b04fc02));
var $2d94d3bb9b62d159$export$aeefab651bcf2338 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $5f3418d4a157010d$export$e3d1678155aaab99));
var $2d94d3bb9b62d159$export$8b784b3227531b3e = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $197063d63daf10dc$export$8b784b3227531b3e));
var $2d94d3bb9b62d159$export$f0750468d67c6902 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $52144500e207f1b9$export$4145bd793c9ed1d0));
var $2d94d3bb9b62d159$export$813cff80931d9dbf = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $4f24c8abb3bfcd10$export$813cff80931d9dbf));
var $2d94d3bb9b62d159$export$409b7a5b7f180eba = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $f7ab768ff134333e$export$58747af448450872));
var $2d94d3bb9b62d159$export$b12fec207e8537a8 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $0016866d85e6e365$export$b12fec207e8537a8));
var $2d94d3bb9b62d159$export$82eafebb825fc23f = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $0f8b4aaeed3bfd5f$export$82eafebb825fc23f));
var $2d94d3bb9b62d159$export$e4c5487c9a8ae3b1 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $b4bd8937bad3fd8c$export$fa08cbfe393f2a68));
var $2d94d3bb9b62d159$export$290a0f24614cde9f = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $d4a2fbda144b1191$export$290a0f24614cde9f));
var $2d94d3bb9b62d159$export$8aceb78c659789b6 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $c66fc654b038e593$export$273fd56580e523ae));
var $2d94d3bb9b62d159$export$4b05688514531169 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $7f7edb4e357e2b13$export$4b05688514531169));
var $2d94d3bb9b62d159$export$4f6453e012279f89 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $1f1b8db51b42626f$export$1b3979d995ebbc6e));
var $2d94d3bb9b62d159$export$1bcbc9c337da86da = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $a04a36d44116debe$export$1bcbc9c337da86da));
var $2d94d3bb9b62d159$export$9b1a0a0c574cec2a = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $a982aa43c10022ed$export$bfd8d1c4da84ce71));
var $2d94d3bb9b62d159$export$e812398311cab9a3 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $29a53ab50e0d6e2c$export$e812398311cab9a3));
var $2d94d3bb9b62d159$export$765f5afcc1a5a7e3 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $eb65bc71ea217c46$export$7c51958462d750e));
var $2d94d3bb9b62d159$export$d3ab16bbf4f954ee = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $7d99f03edbd4b9cf$export$d3ab16bbf4f954ee));
var $2d94d3bb9b62d159$export$36044946916e84a0 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $9517141151b4abf9$export$cc55e2a4c4b40552));
var $2d94d3bb9b62d159$export$53305f1f2855d3be = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $1261df2be6b304e0$export$53305f1f2855d3be));
var $2d94d3bb9b62d159$export$5e06396bce773a3 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $16ff1b53fcc3594d$export$b3e508cb103e1f93));
var $2d94d3bb9b62d159$export$eaf73f391f7103bd = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $9f0bbf9ab4b2a1c5$export$eaf73f391f7103bd));
var $2d94d3bb9b62d159$export$6128b385660fd3c6 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $74bdda6b0a46426e$export$3c371bdbcdfcdce));
var $2d94d3bb9b62d159$export$f8455b5667a3ee0c = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $63d5863d2ed13516$export$f8455b5667a3ee0c));
var $2d94d3bb9b62d159$export$eb152ab3801b2ae3 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $ba7c91ea510df47c$export$3224b07bc93ef23e));
var $2d94d3bb9b62d159$export$65fae0eaf343f2ca = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $7a89adb1474ccf1d$export$65fae0eaf343f2ca));
var $2d94d3bb9b62d159$export$fffc0d480fb1ebf1 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $3e1ff0d7c502f7bb$export$f64bc7a7f04428d0));
var $2d94d3bb9b62d159$export$74517ed253186308 = (0, $af9o7.createFeatureFlaggedComponent)((0, $97a4280f75f7a22e$export$74517ed253186308), (0, $fdd60fb407482c20$export$ef8e5f836dd989d3));
var $2d94d3bb9b62d159$export$833abe6c2ce5ebfd = (0, $af9o7.createFeatureFlaggedComponent)((0, $412bfa0d5894b3c6$export$833abe6c2ce5ebfd), (0, $82e1f1c7094b4744$export$61afcb38c001e19));
var $2d94d3bb9b62d159$export$84109e099492cb5f = (0, $af9o7.createFeatureFlaggedComponent)((0, $1c67e9a6f1bb1a6f$export$84109e099492cb5f), (0, $fdd60fb407482c20$export$ef8e5f836dd989d3));
var $2d94d3bb9b62d159$export$f845d9b9254f0541 = (0, $af9o7.createFeatureFlaggedComponent)((0, $02204c990345b447$export$f845d9b9254f0541), (0, $82e1f1c7094b4744$export$61afcb38c001e19));
var $2d94d3bb9b62d159$export$c42ad8a0b925c762 = (0, $af9o7.createFeatureFlaggedComponent)((0, $34224b7af8484c42$export$c42ad8a0b925c762), (0, $e1043fa2303698cc$export$af3460f51ce3602a));
var $2d94d3bb9b62d159$export$e6470bfc39010cc4 = (0, $af9o7.createFeatureFlaggedComponent)((0, $7a3a6eb3b1e795cf$export$e6470bfc39010cc4), (0, $0be36fd552dc1c99$export$f0bac2b7ac3e3504));
var $2d94d3bb9b62d159$export$5fc1066e677788d4 = (0, $af9o7.createFeatureFlaggedComponent)((0, $4dbba68b0e2d177f$export$5fc1066e677788d4), (0, $53bbed640c6e6632$export$5fc1066e677788d4));
var $2d94d3bb9b62d159$export$bd40525f5333524b = (0, $af9o7.createFeatureFlaggedComponent)((0, $d9b1388a5ad29f00$export$bd40525f5333524b), (0, $20e6a750a55a1c4a$export$f7ef5e5488e4b430));
var $2d94d3bb9b62d159$export$f7857fe64d7161d9 = (0, $af9o7.createFeatureFlaggedComponent)((0, $82ec3faa3f0368a6$export$f7857fe64d7161d9), (0, $4baee89efb80cd04$export$f7857fe64d7161d9));
var $2d94d3bb9b62d159$export$eb7d748e4f9c9676 = (0, $af9o7.createFeatureFlaggedComponent)((0, $ec654b9e2387dfd0$export$eb7d748e4f9c9676), (0, $6cbfa5dee2ec240d$export$a16f50a81d183ce));
var $2d94d3bb9b62d159$export$9951d02c2d848122 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $645e97300d058240$export$9951d02c2d848122));
var $2d94d3bb9b62d159$export$68f3db7f6af48bcb = (0, $af9o7.createFeatureFlaggedComponent)((0, $1VIl7.ConfluenceIcon), (0, $gpCpU.ConfluenceIcon));
var $2d94d3bb9b62d159$export$1b2e4fe6ef471556 = (0, $af9o7.createFeatureFlaggedComponent)((0, $939c0243cabcce21$export$1b2e4fe6ef471556), (0, $e6985fb29d7e75d7$export$a88b0b0da9ef63ce));
var $2d94d3bb9b62d159$export$70a0c2f5862937b6 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $d7c936ff53cc5c33$export$70a0c2f5862937b6));
var $2d94d3bb9b62d159$export$1b8596b4b0ef673b = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $e8c987d7492ee286$export$8b5103382c06639c));
var $2d94d3bb9b62d159$export$407687b2dd89cc68 = (0, $af9o7.createFeatureFlaggedComponent)((0, $a086e675d50d99f5$export$407687b2dd89cc68), (0, $d7c936ff53cc5c33$export$70a0c2f5862937b6));
var $2d94d3bb9b62d159$export$ee11e928d3d045fd = (0, $af9o7.createFeatureFlaggedComponent)((0, $0384e43546c82587$export$ee11e928d3d045fd), (0, $e8c987d7492ee286$export$8b5103382c06639c));
var $2d94d3bb9b62d159$export$c4b5b1f965d8b3eb = (0, $af9o7.createFeatureFlaggedComponent)((0, $Y36zi.JiraIcon), (0, $aEDe1.JiraIcon));
var $2d94d3bb9b62d159$export$17d3acb0b4379d02 = (0, $af9o7.createFeatureFlaggedComponent)((0, $5f3c0cc4476ee39f$export$17d3acb0b4379d02), (0, $6e34b13172a5b29b$export$bf4c5f97b468e8d6));
var $2d94d3bb9b62d159$export$21bfbeb62fdcce8d = (0, $af9o7.createFeatureFlaggedComponent)((0, $539f53a33632dfac$export$21bfbeb62fdcce8d), (0, $2d211468a13d2fb7$export$21bfbeb62fdcce8d));
var $2d94d3bb9b62d159$export$c49a2b642fe9eef4 = (0, $af9o7.createFeatureFlaggedComponent)((0, $3a5dc488d65304f9$export$c49a2b642fe9eef4), (0, $d84bc94694df07a6$export$602140a6a10b02bf));
var $2d94d3bb9b62d159$export$3c6158790f5e01c4 = (0, $8d9471b61f79a2a7$export$436fcf6e31fbacea)((0, $ab3633d671879ebc$export$3c6158790f5e01c4), (0, $e2db2120f58c7778$export$3c6158790f5e01c4));
var $2d94d3bb9b62d159$export$dabef2be6cd28c20 = (0, $8d9471b61f79a2a7$export$436fcf6e31fbacea)((0, $44f664ec6684700a$export$dabef2be6cd28c20), (0, $105e244f4782482d$export$de148263c75d2bc1));
var $2d94d3bb9b62d159$export$8d789f76fde3e05 = (0, $af9o7.createFeatureFlaggedComponent)((0, $d3bf053d58aecb39$export$8d789f76fde3e05), (0, $7277bf1ab856c9fb$export$8d789f76fde3e05));
var $2d94d3bb9b62d159$export$94e206806e36c2ec = (0, $af9o7.createFeatureFlaggedComponent)((0, $df29a5258322e53f$export$94e206806e36c2ec), (0, $a9d66750d87e778d$export$78c0b4d8be34c9b2));
var $2d94d3bb9b62d159$export$1bf47cdade1a9fcb = (0, $af9o7.createFeatureFlaggedComponent)((0, $24fc4a6d140006a0$export$1bf47cdade1a9fcb), (0, $7277bf1ab856c9fb$export$8d789f76fde3e05));
var $2d94d3bb9b62d159$export$6e87ce8d41eda665 = (0, $af9o7.createFeatureFlaggedComponent)((0, $550dd97c2a7853ef$export$6e87ce8d41eda665), (0, $dbb0fc9f5c20d708$export$68d7391318cdef11));
var $2d94d3bb9b62d159$export$e84e925618e0e5bc = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $fc01f80024a1e9f7$export$71743a944cb62e48));
var $2d94d3bb9b62d159$export$1940ba72c868b663 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $da79d6616879e497$export$38c7b37a3e5e8d70));
var $2d94d3bb9b62d159$export$eeccc49dc7a12d9f = (0, $8d9471b61f79a2a7$export$436fcf6e31fbacea)((0, $133343937fec1563$export$eeccc49dc7a12d9f), (0, $6f107b5a3cdc7c24$export$eeccc49dc7a12d9f));
var $2d94d3bb9b62d159$export$a1c6484cdecc2c4b = (0, $8d9471b61f79a2a7$export$436fcf6e31fbacea)((0, $7012d37ccd20defe$export$a1c6484cdecc2c4b), (0, $208acfc57f03835f$export$a5b9122e89b32ad3));
var $2d94d3bb9b62d159$export$f3f5aa321d88adf9 = (0, $8d9471b61f79a2a7$export$436fcf6e31fbacea)((0, $e5090466625d94f8$export$f3f5aa321d88adf9), (0, $29dc00d3e852c298$export$f3f5aa321d88adf9));
var $2d94d3bb9b62d159$export$bb4ae5b41b43be04 = (0, $8d9471b61f79a2a7$export$436fcf6e31fbacea)((0, $a0b9b85073824ba8$export$bb4ae5b41b43be04), (0, $498a5dc059f68f6e$export$2bc88a281410ffa7));
var $2d94d3bb9b62d159$export$4384da9b8b140bf4 = (0, $af9o7.createFeatureFlaggedComponent)((0, $72b24621895b039d$export$4384da9b8b140bf4), (0, $846cd6bc1530edeb$export$4384da9b8b140bf4));
var $2d94d3bb9b62d159$export$60e26212f3b61a28 = (0, $af9o7.createFeatureFlaggedComponent)((0, $77f83b2a64e78b50$export$60e26212f3b61a28), (0, $d346c3580de5e974$export$1b13139dfc0336af));
var $2d94d3bb9b62d159$export$e23ae35269442b4f = (0, $1cf61e15150efda7$export$2469203854060337)((0, $96f99918f881107b$export$e23ae35269442b4f), (0, $c0e81f450057cf06$export$e23ae35269442b4f), (0, $43ecd9ad182aa785$export$9e62346a60cfb459));
var $2d94d3bb9b62d159$export$a0f6cb8061290bbb = (0, $1cf61e15150efda7$export$2469203854060337)((0, $93173c7c8bd4c45d$export$a0f6cb8061290bbb), (0, $bd5d466aedec2939$export$b0e15f0a1c9f4c55), (0, $57fe7bba8f3a8d6a$export$5e38d02efdb45577));
var $2d94d3bb9b62d159$export$3f95fcfdc25a741d = (0, $af9o7.createFeatureFlaggedComponent)((0, $f9d366510db8d846$export$3f95fcfdc25a741d), (0, $3fde30457b2fb8db$export$3f95fcfdc25a741d));
var $2d94d3bb9b62d159$export$a4a891d202775deb = (0, $af9o7.createFeatureFlaggedComponent)((0, $4aaa416bcb06d11e$export$a4a891d202775deb), (0, $5e873dad6b32a772$export$2b896c4d595a4331));
var $2d94d3bb9b62d159$export$1e02e7298035a77c = (0, $af9o7.createFeatureFlaggedComponent)((0, $3e24df8349650905$export$1e02e7298035a77c), (0, $0c16e5609534a2b0$export$1e02e7298035a77c));
var $2d94d3bb9b62d159$export$33908560ea1b226d = (0, $af9o7.createFeatureFlaggedComponent)((0, $c938f2c9202f2b9d$export$33908560ea1b226d), (0, $4de141105e2ca493$export$3a6e8b37e069a69d));
var $2d94d3bb9b62d159$export$5ef3f25e16249826 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $7d2e0cc3e3a950d6$export$5ef3f25e16249826));
var $2d94d3bb9b62d159$export$1ab0976b9ea166ae = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $1408f1e2ddb10b25$export$1ab0976b9ea166ae));
var $2d94d3bb9b62d159$export$5efe8561ca252843 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $f5be1548d97162b0$export$5efe8561ca252843));
var $2d94d3bb9b62d159$export$e26e48d31d71c1e1 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $89e8a96e1e6f33d4$export$e26e48d31d71c1e1));
var $2d94d3bb9b62d159$export$bf5ca9fb70f56bb5 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $f5375db4b0eca8fb$export$bf5ca9fb70f56bb5));
var $2d94d3bb9b62d159$export$518f48548316ec87 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $ddf42b4cd5986168$export$518f48548316ec87));


const $d3185276e14a4c2b$export$b8c7f5b0854d3581 = {
    // All UiProductType values mapped to logo configurations
    access: {
        icon: 'AdminIcon',
        displayName: 'Atlassian Administration',
        productKey: 'access'
    },
    analytics: {
        icon: 'AtlassianAnalyticsIcon',
        displayName: 'Analytics',
        productKey: 'avp'
    },
    automation: {
        icon: 'AtlassianIcon',
        displayName: 'Automation',
        productKey: 'automation'
    },
    cmdb: {
        icon: 'AssetsIcon',
        displayName: 'Assets',
        productKey: 'cmdb'
    },
    atlassian_together: {
        icon: 'AtlassianIcon',
        displayName: 'Atlassian Together',
        productKey: 'atlassian-together'
    },
    avocado: {
        icon: 'AtlassianIcon',
        displayName: 'Avocado',
        productKey: 'avocado'
    },
    beacon: {
        icon: 'GuardIcon',
        displayName: 'Guard Detect',
        productKey: 'beacon'
    },
    bitbucket: {
        logo: 'BitbucketLogo',
        icon: 'BitbucketIcon',
        displayName: 'Bitbucket',
        productKey: 'bitbucket'
    },
    cloud_admin: {
        logo: 'AtlassianAdministrationLogo',
        icon: 'AtlassianAdministrationIcon',
        displayName: 'Atlassian Administration',
        productKey: 'cloud-admin'
    },
    compass: {
        logo: 'CompassLogo',
        icon: 'CompassIcon',
        displayName: 'Compass',
        productKey: 'compass'
    },
    confluence: {
        logo: 'ConfluenceLogo',
        icon: 'ConfluenceIcon',
        displayName: 'Confluence',
        productKey: 'confluence'
    },
    devai: {
        icon: 'RovoDevIcon',
        displayName: 'Rovo Dev',
        productKey: 'devai'
    },
    fabric: {
        icon: 'AtlassianIcon',
        displayName: 'Fabric',
        productKey: 'canvas'
    },
    feedback: {
        icon: 'AtlassianIcon',
        displayName: 'Feedback',
        productKey: 'feedback'
    },
    goal: {
        icon: 'GoalsIcon',
        displayName: 'Goals',
        productKey: 'goal'
    },
    jira_admin: {
        logo: 'JiraLogo',
        icon: 'JiraIcon',
        displayName: 'Jira Administration',
        productKey: 'jira-admin'
    },
    jira_align: {
        logo: 'JiraAlignLogo',
        icon: 'JiraAlignIcon',
        displayName: 'Jira Align',
        productKey: 'jira-align'
    },
    jira_core: {
        logo: 'JiraLogo',
        icon: 'JiraIcon',
        displayName: 'Jira',
        productKey: 'jira-core'
    },
    jira_customer_service: {
        logo: 'JiraServiceManagementLogo',
        icon: 'JiraServiceManagementIcon',
        displayName: 'Jira Customer Service',
        productKey: 'jira-customer-service'
    },
    jira_family: {
        logo: 'JiraLogo',
        icon: 'JiraIcon',
        displayName: 'Jira',
        productKey: 'jira-family'
    },
    jira_incident_manager: {
        logo: 'JiraServiceManagementLogo',
        icon: 'JiraServiceManagementIcon',
        displayName: 'Jira Incident Manager',
        productKey: 'jira-incident-manager'
    },
    jira_product_discovery: {
        logo: 'JiraProductDiscoveryLogo',
        icon: 'JiraProductDiscoveryIcon',
        displayName: 'Jira Product Discovery',
        productKey: 'jira-product-discovery'
    },
    jira_service_management: {
        logo: 'JiraServiceManagementLogo',
        icon: 'JiraServiceManagementIcon',
        displayName: 'Jira Service Management',
        productKey: 'jira-servicedesk'
    },
    jira_software: {
        logo: 'JiraLogo',
        icon: 'JiraIcon',
        displayName: 'Jira',
        productKey: 'jira-software'
    },
    jira_work_management: {
        logo: 'JiraWorkManagementLogo',
        icon: 'JiraWorkManagementIcon',
        displayName: 'Jira Work Management',
        productKey: 'jira-work-management'
    },
    loom: {
        logo: 'LoomLogo',
        icon: 'LoomIcon',
        displayName: 'Loom',
        productKey: 'loom'
    },
    loom_attribution: {
        logo: 'LoomLogo',
        icon: 'LoomIcon',
        displayName: 'Loom Attribution',
        productKey: 'loom-attribution'
    },
    mercury: {
        icon: 'FocusIcon',
        displayName: 'Focus',
        productKey: 'mercury'
    },
    opsgenie: {
        logo: 'OpsgenieLogo',
        icon: 'OpsgenieIcon',
        displayName: 'Opsgenie',
        productKey: 'opsgenie'
    },
    passionfruit: {
        icon: 'AtlassianIcon',
        displayName: 'Passionfruit',
        productKey: 'passionfruit'
    },
    project: {
        icon: 'ProjectsIcon',
        displayName: 'Projects',
        productKey: 'project'
    },
    radar: {
        icon: 'TalentIcon',
        displayName: 'Talent',
        productKey: 'radar'
    },
    rovo: {
        logo: 'RovoLogo',
        icon: 'RovoIcon',
        displayName: 'Rovo',
        productKey: 'rovo'
    },
    statuspage: {
        logo: 'StatuspageLogo',
        icon: 'StatuspageIcon',
        displayName: 'Statuspage',
        productKey: 'statuspage'
    },
    stride: {
        icon: 'AtlassianIcon',
        displayName: 'Stride',
        productKey: 'hipchat.cloud'
    },
    studio: {
        icon: 'StudioIcon',
        displayName: 'Studio',
        productKey: 'studio'
    },
    teamcentral: {
        icon: 'AtlassianIcon',
        displayName: 'Team Central',
        productKey: 'townsquare'
    },
    teams: {
        icon: 'TeamsIcon',
        displayName: 'Teams',
        productKey: 'teams'
    },
    trello: {
        logo: 'TrelloLogo',
        icon: 'TrelloIcon',
        displayName: 'Trello',
        productKey: 'trello'
    },
    unified_help: {
        icon: 'AtlassianIcon',
        displayName: 'Unified Help',
        productKey: 'unified-help'
    },
    unknown_atlassian: {
        icon: 'AtlassianIcon',
        displayName: 'Unknown Atlassian',
        productKey: 'unknown-atlassian'
    }
};
function $d3185276e14a4c2b$export$7524c8b3bd6ccb7f(productType) {
    const config = $d3185276e14a4c2b$export$b8c7f5b0854d3581[productType.toLowerCase()];
    return config || null;
}
function $d3185276e14a4c2b$export$4f572bfb89b8eab9() {
    return Object.values($d3185276e14a4c2b$export$b8c7f5b0854d3581);
}
const $d3185276e14a4c2b$export$44fea6589b7ddc92 = (productType)=>{
    const config = $d3185276e14a4c2b$export$7524c8b3bd6ccb7f(productType);
    return config?.displayName || productType;
};
const $d3185276e14a4c2b$export$27e53caf66bae1d = (productKey)=>{
    // Find the UiProductType key that matches the productKey
    const productTypeEntry = Object.entries($d3185276e14a4c2b$export$b8c7f5b0854d3581).find(([, value])=>value.productKey === productKey);
    return productTypeEntry ? productTypeEntry[0] : null;
};
const $d3185276e14a4c2b$export$a3ce53670861b599 = (productKey)=>{
    const config = Object.values($d3185276e14a4c2b$export$b8c7f5b0854d3581).find((config)=>config.productKey === productKey);
    return config || null;
};


const $7397f708924e0bda$var$messages = (0, $7e94896e68874ec2$export$1adfeb024f5185b)({
    productIconAlt: {
        id: 'appUpdates.productIcon.alt',
        defaultMessage: '{productName} icon',
        description: 'Alt text for app icon'
    },
    unknownProductIcon: {
        id: 'appUpdates.productIcon.unknown',
        defaultMessage: 'App icon',
        description: 'Alt text for unknown app icon'
    }
});
const $7397f708924e0bda$export$1a199e029d5e93d6 = ({ productType: productType, size: size = 'small', useIcon: useIcon = true, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    const productConfig = productType ? (0, $d3185276e14a4c2b$export$7524c8b3bd6ccb7f)(productType) : null;
    // If no product config found, fallback to AtlassianIcon
    if (!productConfig) return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($2d94d3bb9b62d159$exports.AtlassianIcon, {
        size: size,
        appearance: "brand",
        shouldUseNewLogoDesign: true,
        testId: testId || 'product-icon-fallback',
        label: formatMessage($7397f708924e0bda$var$messages.unknownProductIcon)
    });
    // Determine which component to use (icon or logo)
    const componentName = useIcon ? productConfig.icon : productConfig.logo || productConfig.icon;
    // Get the component from AtlasKit logo library with type assertion
    const LogoComponent = $2d94d3bb9b62d159$exports[componentName];
    if (!LogoComponent || typeof LogoComponent !== 'function') // Fallback to AtlassianIcon if component not found
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($2d94d3bb9b62d159$exports.AtlassianIcon, {
        size: size,
        appearance: "brand",
        shouldUseNewLogoDesign: true,
        testId: testId || 'product-icon-fallback',
        label: formatMessage($7397f708924e0bda$var$messages.unknownProductIcon)
    });
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)(LogoComponent, {
        size: size,
        appearance: "brand",
        shouldUseNewLogoDesign: true,
        testId: testId || `product-icon-${componentName}`,
        label: formatMessage($7397f708924e0bda$var$messages.productIconAlt, {
            productName: productConfig.displayName
        })
    });
};




/**
 * Product keys of apps that are supported by the backend and should be visible in the UI.
 * Derived from the backend's supported apps enum (context IDs).
 */ const $50e94d71524dc43e$var$VISIBLE_PRODUCT_KEYS = new Set([
    'cmdb',
    'avp',
    'automation',
    'bitbucket',
    'cloud-admin',
    'compass',
    'confluence',
    'jira-customer-service',
    'mercury',
    'goal',
    'jira-software',
    'jira-align',
    'jira-product-discovery',
    'jira-servicedesk',
    'loom',
    'opsgenie',
    'project',
    'radar',
    'rovo',
    'devai',
    'statuspage',
    'studio',
    'teams',
    'trello'
]);
const $50e94d71524dc43e$export$c6f09e1afd88c25a = ()=>{
    return Object.fromEntries(Object.entries((0, $d3185276e14a4c2b$export$b8c7f5b0854d3581)).filter(([, config])=>$50e94d71524dc43e$var$VISIBLE_PRODUCT_KEYS.has(config.productKey))// PRODUCT_LOGO_MAP keys are Lowercase<UiProductType>, so toUpperCase() gives UiProductType
    .map(([key, config])=>[
            key.toUpperCase(),
            config
        ]));
};
const $50e94d71524dc43e$export$fd35fa3fda96a6c2 = (productKey)=>{
    return $50e94d71524dc43e$var$VISIBLE_PRODUCT_KEYS.has(productKey);
};



/**
 * Priority order for displaying impacted products.
 * Key products like Jira and Confluence are shown first.
 * Products not in this list will appear at the end in their original order.
 */ const $ace4c485fd808422$var$PRODUCT_PRIORITY_ORDER = [
    'JIRA_SOFTWARE',
    'JIRA_CORE',
    'CONFLUENCE',
    'CLOUD_ADMIN',
    'ROVO',
    'JIRA_SERVICE_MANAGEMENT',
    'JIRA_WORK_MANAGEMENT',
    'JIRA_PRODUCT_DISCOVERY',
    'LOOM',
    'TRELLO',
    'BITBUCKET',
    'COMPASS',
    'OPSGENIE',
    'STATUSPAGE',
    'JIRA_ALIGN',
    'JIRA_ADMIN',
    'JIRA_CUSTOMER_SERVICE',
    'JIRA_INCIDENT_MANAGER'
];
/**
 * Normalizes a product type to uppercase for comparison.
 * Handles both uppercase (JIRA_SOFTWARE) and lowercase (jira_software) inputs.
 */ const $ace4c485fd808422$var$normalizeProductType = (product)=>product.toUpperCase();
const $ace4c485fd808422$export$e3760658a711f2d3 = (products)=>{
    if (products.length === 0) return [];
    const productsCopy = [
        ...products
    ];
    const normalizedPriorityOrder = $ace4c485fd808422$var$PRODUCT_PRIORITY_ORDER.map($ace4c485fd808422$var$normalizeProductType);
    const sorted = productsCopy.sort((a, b)=>{
        const weightA = normalizedPriorityOrder.indexOf($ace4c485fd808422$var$normalizeProductType(a));
        const weightB = normalizedPriorityOrder.indexOf($ace4c485fd808422$var$normalizeProductType(b));
        return (weightA === -1 ? Infinity : weightA) - (weightB === -1 ? Infinity : weightB);
    });
    // Deduplicate by display name — keep the first (highest priority) occurrence
    const seenDisplayNames = new Set();
    return sorted.filter((product)=>{
        const displayName = (0, $d3185276e14a4c2b$export$44fea6589b7ddc92)(product);
        if (seenDisplayNames.has(displayName)) return false;
        seenDisplayNames.add(displayName);
        return true;
    });
};




const $51e43113ed6c9475$export$c2352a34eb11a9e9 = [
    'COMING_SOON',
    'PLANNED',
    'ROLLING_OUT',
    'GENERALLY_AVAILABLE',
    'ROLLED_BACK'
];
const $51e43113ed6c9475$export$94a5323e67ff7814 = [
    'IMPROVEMENT',
    'FIX',
    'EXPERIMENT',
    'REMOVED',
    'ANNOUNCEMENT'
];
const $51e43113ed6c9475$export$aafe24a01710fa9a = [
    'HIGH',
    'MEDIUM',
    'LOW'
];
const $51e43113ed6c9475$export$5926fcb263ea10c4 = {
    HIGH: 'High',
    MEDIUM: 'Medium',
    LOW: 'Low'
};
const $51e43113ed6c9475$export$f3e6ae23d6c89755 = [
    'EXPERIMENT',
    'SEASONAL_RELEASE',
    'UI_RELATED',
    'BUG_FIX',
    'PERFORMANCE_IMPROVEMENT',
    'NEW_FEATURE',
    'DEPRECATION_REMOVAL',
    'INTEGRATION_API_CHANGE',
    'PERMISSIONS_ACCESS_CONTROL',
    'AI_RELATED'
];
const $51e43113ed6c9475$export$d9b81c96441d0617 = {
    EXPERIMENT: '#Experiment',
    SEASONAL_RELEASE: '#Seasonal-release',
    UI_RELATED: '#UI',
    BUG_FIX: '#Bug-fix',
    PERFORMANCE_IMPROVEMENT: '#Performance',
    NEW_FEATURE: '#New-feature',
    DEPRECATION_REMOVAL: '#Deprecation',
    INTEGRATION_API_CHANGE: '#API-change',
    PERMISSIONS_ACCESS_CONTROL: '#Permissions',
    AI_RELATED: '#AI'
};
const $51e43113ed6c9475$export$4bbe71e8edfbf0cd = (tagId)=>$51e43113ed6c9475$export$d9b81c96441d0617[tagId] ?? tagId;


const $ea567f1e5717897c$export$e582c11b604ddc57 = (filters)=>{
    const params = {};
    if (filters.searchQuery) params.search = filters.searchQuery;
    if (filters.selectedProducts && filters.selectedProducts.length > 0) params.products = filters.selectedProducts.map((p)=>p.id).join(',');
    if (filters.selectedStatuses && filters.selectedStatuses.length > 0) params.statuses = filters.selectedStatuses.map((p)=>p.id).join(',');
    if (filters.selectedChangeTypes && filters.selectedChangeTypes.length > 0) params.changeTypes = filters.selectedChangeTypes.map((p)=>p.id).join(',');
    if (filters.selectedImpactRatings && filters.selectedImpactRatings.length > 0) params.impactRatings = filters.selectedImpactRatings.map((p)=>p.id).join(',');
    if (filters.selectedTags && filters.selectedTags.length > 0) params.tags = filters.selectedTags.map((p)=>p.id).join(',');
    if (filters.effectiveFrom) params.effectiveFrom = filters.effectiveFrom;
    if (filters.selectedBundleDate) params.bundleDate = filters.selectedBundleDate;
    if (filters.cursor) params.cursor = filters.cursor;
    if (typeof filters.limit === 'number' && Number.isFinite(filters.limit)) params.limit = String(filters.limit);
    return params;
};
const $ea567f1e5717897c$export$e0663cb7e2aca336 = Object.entries((0, $50e94d71524dc43e$export$c6f09e1afd88c25a)()).map(([key, config])=>({
        id: key,
        name: config.displayName,
        icon: config.icon
    }));
const $ea567f1e5717897c$var$availableStatuses = (0, $51e43113ed6c9475$export$c2352a34eb11a9e9).map((statusId)=>({
        id: statusId,
        name: statusId
    }));
const $ea567f1e5717897c$var$availableChangeTypes = (0, $51e43113ed6c9475$export$94a5323e67ff7814).map((changeTypeId)=>({
        id: changeTypeId,
        name: changeTypeId
    }));
const $ea567f1e5717897c$var$availableImpactRatings = (0, $51e43113ed6c9475$export$aafe24a01710fa9a).map((ratingId)=>({
        id: ratingId,
        name: (0, $51e43113ed6c9475$export$5926fcb263ea10c4)[ratingId]
    }));
const $ea567f1e5717897c$var$availableTags = (0, $51e43113ed6c9475$export$f3e6ae23d6c89755).map((tagId)=>({
        id: tagId,
        name: tagId
    }));
const $ea567f1e5717897c$export$227523e113d14c22 = ()=>{
    if (typeof window === 'undefined') return {};
    const params = new URLSearchParams(window.location.search);
    const filters = {};
    const search = params.get('search');
    if (search) filters.searchQuery = search;
    const products = params.get('products');
    if (products) {
        const productKeys = products.split(',').filter(Boolean);
        filters.selectedProducts = $ea567f1e5717897c$export$e0663cb7e2aca336.filter((p)=>productKeys.includes(p.id));
    }
    const statuses = params.get('statuses');
    if (statuses) {
        const statusIds = statuses.split(',').filter(Boolean);
        filters.selectedStatuses = $ea567f1e5717897c$var$availableStatuses.filter((s)=>statusIds.includes(s.id));
    }
    const changeTypes = params.get('changeTypes');
    if (changeTypes) {
        const changeTypeIds = changeTypes.split(',').filter(Boolean);
        filters.selectedChangeTypes = $ea567f1e5717897c$var$availableChangeTypes.filter((c)=>changeTypeIds.includes(c.id));
    }
    const impactRatings = params.get('impactRatings');
    if (impactRatings) {
        const ratingIds = impactRatings.split(',').filter(Boolean);
        filters.selectedImpactRatings = $ea567f1e5717897c$var$availableImpactRatings.filter((r)=>ratingIds.includes(r.id));
    }
    const tags = params.get('tags');
    if (tags) {
        const tagIds = tags.split(',').filter(Boolean);
        filters.selectedTags = $ea567f1e5717897c$var$availableTags.filter((t)=>tagIds.includes(t.id));
    }
    const effectiveFrom = params.get('effectiveFrom');
    if (effectiveFrom) filters.effectiveFrom = effectiveFrom;
    const bundleDate = params.get('bundleDate');
    if (bundleDate) filters.selectedBundleDate = bundleDate;
    const cursor = params.get('cursor');
    if (cursor) filters.cursor = cursor;
    const limit = params.get('limit');
    if (limit) {
        const parsedLimit = Number(limit);
        if (Number.isFinite(parsedLimit) && parsedLimit > 0) filters.limit = parsedLimit;
    }
    return filters;
};
const $ea567f1e5717897c$export$de85dd96eb599379 = (params)=>{
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value])=>{
        if (value) searchParams.set(key, value);
    });
    const searchString = searchParams.toString();
    return searchString ? `?${searchString}` : '';
};


const $cb707c631f92bf69$var$urlFilters = (0, $ea567f1e5717897c$export$227523e113d14c22)();
const $cb707c631f92bf69$var$initialFiltersState = {
    selectedProducts: $cb707c631f92bf69$var$urlFilters.selectedProducts ?? null,
    selectedBundleDate: $cb707c631f92bf69$var$urlFilters.selectedBundleDate ?? null,
    searchQuery: $cb707c631f92bf69$var$urlFilters.searchQuery ?? null
};
const $cb707c631f92bf69$var$emptyFiltersState = {
    selectedProducts: null,
    selectedBundleDate: null,
    searchQuery: null
};
const $cb707c631f92bf69$export$4ea9a80dc2aa2583 = {
    data: [],
    isLoading: false,
    error: null,
    links: {
        prev: null,
        self: '',
        next: null
    },
    pagination: {
        cursor: $cb707c631f92bf69$var$urlFilters.cursor,
        limit: $cb707c631f92bf69$var$urlFilters.limit ?? 100
    },
    draftFilters: {
        ...$cb707c631f92bf69$var$initialFiltersState
    },
    committedFilters: {
        ...$cb707c631f92bf69$var$initialFiltersState,
        committedFiltersVersion: 0
    }
};
const $cb707c631f92bf69$export$fb2ad06510f736b4 = (state, action)=>{
    switch(action.type){
        case 'BUNDLE_FILTER_APP_SELECT':
            return {
                ...state,
                draftFilters: {
                    ...state.draftFilters,
                    selectedProducts: action.payload.selectedProducts
                }
            };
        case 'BUNDLE_FILTER_DATE_SELECT':
            return {
                ...state,
                draftFilters: {
                    ...state.draftFilters,
                    selectedBundleDate: action.payload.selectedBundleDate
                }
            };
        case 'BUNDLE_FILTER_SEARCH_SELECT':
            return {
                ...state,
                draftFilters: {
                    ...state.draftFilters,
                    searchQuery: action.payload.searchQuery
                }
            };
        case 'BUNDLES_FILTERS_APPLY':
            return {
                ...state,
                committedFilters: {
                    ...state.draftFilters,
                    committedFiltersVersion: state.committedFilters.committedFiltersVersion + 1
                },
                pagination: {
                    ...state.pagination,
                    cursor: undefined
                }
            };
        case 'BUNDLES_FILTERS_RESET':
            return {
                ...state,
                draftFilters: {
                    ...$cb707c631f92bf69$var$emptyFiltersState,
                    selectedBundleDate: action.payload.selectedBundleDate
                },
                committedFilters: {
                    ...$cb707c631f92bf69$var$emptyFiltersState,
                    selectedBundleDate: action.payload.selectedBundleDate,
                    committedFiltersVersion: state.committedFilters.committedFiltersVersion + 1
                },
                pagination: {
                    ...state.pagination,
                    cursor: undefined
                }
            };
        case 'BUNDLES_DATA_LINKS_SET':
            return {
                ...state,
                data: action.payload.data,
                links: action.payload.links
            };
        case 'BUNDLES_LOADING_SET':
            return {
                ...state,
                isLoading: action.payload.isLoading
            };
        case 'BUNDLES_ERROR_SET':
            return {
                ...state,
                error: action.payload.error
            };
        case 'BUNDLES_CURSOR_SET':
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    cursor: action.payload.cursor
                }
            };
        case 'BUNDLES_LIMIT_SET':
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    limit: action.payload.limit,
                    cursor: undefined
                }
            };
        default:
            return state;
    }
};


const $add35b76dd84c7d0$var$urlFilters = (0, $ea567f1e5717897c$export$227523e113d14c22)();
const $add35b76dd84c7d0$var$initialFiltersState = {
    selectedProducts: $add35b76dd84c7d0$var$urlFilters.selectedProducts ?? null,
    selectedStatuses: $add35b76dd84c7d0$var$urlFilters.selectedStatuses ?? null,
    selectedChangeTypes: $add35b76dd84c7d0$var$urlFilters.selectedChangeTypes ?? null,
    selectedImpactRatings: $add35b76dd84c7d0$var$urlFilters.selectedImpactRatings ?? null,
    selectedTags: $add35b76dd84c7d0$var$urlFilters.selectedTags ?? null,
    searchQuery: $add35b76dd84c7d0$var$urlFilters.searchQuery ?? null,
    effectiveFrom: null
};
const $add35b76dd84c7d0$export$fc84e809bad5f75a = {
    data: [],
    isLoading: false,
    error: null,
    links: {
        self: '',
        next: null,
        prev: null
    },
    pagination: {
        cursor: $add35b76dd84c7d0$var$urlFilters.cursor,
        limit: $add35b76dd84c7d0$var$urlFilters.limit ?? 20
    },
    draftFilters: {
        ...$add35b76dd84c7d0$var$initialFiltersState
    },
    committedFilters: {
        ...$add35b76dd84c7d0$var$initialFiltersState,
        committedFiltersVersion: 0
    }
};
const $add35b76dd84c7d0$export$ad0c6bbc0e9460d8 = (state, action)=>{
    switch(action.type){
        case 'UPDATES_DATA_LINKS_SET':
            return {
                ...state,
                data: action.payload.updates,
                links: action.payload.links
            };
        case 'UPDATES_CURSOR_SET':
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    cursor: action.payload.cursor
                }
            };
        case 'UPDATES_LIMIT_SET':
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    limit: action.payload.limit,
                    cursor: undefined
                }
            };
        case 'UPDATES_LOADING_SET':
            return {
                ...state,
                isLoading: action.payload.isLoading
            };
        case 'UPDATES_ERROR_SET':
            return {
                ...state,
                error: action.payload.error
            };
        case 'FILTER_APP_SELECT':
            return {
                ...state,
                draftFilters: {
                    ...state.draftFilters,
                    selectedProducts: action.payload.selectedProducts
                }
            };
        case 'FILTER_STATUS_SELECT':
            return {
                ...state,
                draftFilters: {
                    ...state.draftFilters,
                    selectedStatuses: action.payload.selectedStatuses
                }
            };
        case 'FILTER_CHANGE_TYPE_SELECT':
            return {
                ...state,
                draftFilters: {
                    ...state.draftFilters,
                    selectedChangeTypes: action.payload.selectedChangeTypes
                }
            };
        case 'FILTER_IMPACT_RATING_SELECT':
            return {
                ...state,
                draftFilters: {
                    ...state.draftFilters,
                    selectedImpactRatings: action.payload.selectedImpactRatings
                }
            };
        case 'FILTER_TAG_SELECT':
            return {
                ...state,
                draftFilters: {
                    ...state.draftFilters,
                    selectedTags: action.payload.selectedTags
                }
            };
        case 'FILTER_SEARCH_SELECT':
            return {
                ...state,
                draftFilters: {
                    ...state.draftFilters,
                    searchQuery: action.payload.searchQuery
                }
            };
        case 'UPDATES_FILTERS_APPLY':
            return {
                ...state,
                committedFilters: {
                    ...state.draftFilters,
                    committedFiltersVersion: state.committedFilters.committedFiltersVersion + 1
                },
                pagination: {
                    ...state.pagination,
                    cursor: undefined
                }
            };
        case 'FILTER_EFFECTIVE_FROM_TOGGLE':
            return {
                ...state,
                draftFilters: {
                    ...state.draftFilters,
                    effectiveFrom: action.payload.effectiveFrom
                }
            };
        case 'UPDATES_FILTERS_RESET':
            return {
                ...state,
                draftFilters: {
                    selectedProducts: null,
                    selectedStatuses: null,
                    selectedChangeTypes: null,
                    selectedImpactRatings: null,
                    selectedTags: null,
                    searchQuery: null,
                    effectiveFrom: null
                },
                committedFilters: {
                    selectedProducts: null,
                    selectedStatuses: null,
                    selectedChangeTypes: null,
                    selectedImpactRatings: null,
                    selectedTags: null,
                    searchQuery: null,
                    effectiveFrom: null,
                    committedFiltersVersion: state.committedFilters.committedFiltersVersion + 1
                },
                pagination: {
                    ...state.pagination,
                    cursor: undefined
                }
            };
        default:
            return state;
    }
};


const $4933e76bd0ca959e$var$INITIAL_STATE = {
    ...(0, $ff8369db971fa1a8$export$237dc0bae177ad41),
    updates: (0, $add35b76dd84c7d0$export$fc84e809bad5f75a),
    bundles: (0, $cb707c631f92bf69$export$4ea9a80dc2aa2583)
};
function $4933e76bd0ca959e$var$reducer(state, action) {
    switch(action.type){
        case 'AUTHENTICATE':
            {
                const authState = (0, $ff8369db971fa1a8$export$b3aa4dbb59e7857d)({
                    user: state.user,
                    isLoggedIn: state.isLoggedIn,
                    loggedInUser: state.loggedInUser
                }, action);
                return {
                    ...state,
                    ...authState
                };
            }
        case 'UPDATES_CURSOR_SET':
        case 'UPDATES_LIMIT_SET':
        case 'UPDATES_DATA_LINKS_SET':
        case 'UPDATES_LOADING_SET':
        case 'UPDATES_ERROR_SET':
        case 'FILTER_APP_SELECT':
        case 'FILTER_STATUS_SELECT':
        case 'FILTER_CHANGE_TYPE_SELECT':
        case 'FILTER_IMPACT_RATING_SELECT':
        case 'FILTER_TAG_SELECT':
        case 'FILTER_SEARCH_SELECT':
        case 'UPDATES_FILTERS_APPLY':
        case 'UPDATES_FILTERS_RESET':
        case 'FILTER_EFFECTIVE_FROM_TOGGLE':
            return {
                ...state,
                updates: (0, $add35b76dd84c7d0$export$ad0c6bbc0e9460d8)(state.updates, action)
            };
        case 'BUNDLE_FILTER_APP_SELECT':
        case 'BUNDLE_FILTER_DATE_SELECT':
        case 'BUNDLE_FILTER_SEARCH_SELECT':
        case 'BUNDLES_FILTERS_APPLY':
        case 'BUNDLES_FILTERS_RESET':
        case 'BUNDLES_DATA_LINKS_SET':
        case 'BUNDLES_LOADING_SET':
        case 'BUNDLES_ERROR_SET':
        case 'BUNDLES_CURSOR_SET':
        case 'BUNDLES_LIMIT_SET':
            return {
                ...state,
                bundles: (0, $cb707c631f92bf69$export$fb2ad06510f736b4)(state.bundles, action)
            };
        default:
            return state;
    }
}
const $4933e76bd0ca959e$var$AppUpdatesContext = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
const $4933e76bd0ca959e$export$7653fec709d1e7bb = ()=>{
    const ctx = (0, $5FkrB.useContext)($4933e76bd0ca959e$var$AppUpdatesContext);
    if (!ctx) throw new Error('useAppUpdatesContext must be used within <AppUpdatesContextProvider>');
    return ctx;
};
const $4933e76bd0ca959e$export$5d107a7783183624 = ({ children: children, api: api, initialState: initialState })=>{
    const initialUser = initialState?.user ?? $4933e76bd0ca959e$var$INITIAL_STATE.user;
    const initialStateMerged = {
        user: initialUser,
        ...(0, $ff8369db971fa1a8$export$299abcbcbe81ab38)(initialUser),
        updates: {
            ...$4933e76bd0ca959e$var$INITIAL_STATE.updates,
            ...initialState?.updates,
            pagination: {
                ...$4933e76bd0ca959e$var$INITIAL_STATE.updates.pagination,
                ...initialState?.updates?.pagination
            },
            draftFilters: {
                ...$4933e76bd0ca959e$var$INITIAL_STATE.updates.draftFilters,
                ...initialState?.updates?.draftFilters
            },
            committedFilters: {
                ...$4933e76bd0ca959e$var$INITIAL_STATE.updates.committedFilters,
                ...initialState?.updates?.committedFilters
            }
        },
        bundles: {
            ...$4933e76bd0ca959e$var$INITIAL_STATE.bundles,
            ...initialState?.bundles,
            pagination: {
                ...$4933e76bd0ca959e$var$INITIAL_STATE.bundles.pagination,
                ...initialState?.bundles?.pagination
            },
            draftFilters: {
                ...$4933e76bd0ca959e$var$INITIAL_STATE.bundles.draftFilters,
                ...initialState?.bundles?.draftFilters
            },
            committedFilters: {
                ...$4933e76bd0ca959e$var$INITIAL_STATE.bundles.committedFilters,
                ...initialState?.bundles?.committedFilters
            }
        }
    };
    const [state, dispatch] = (0, $5FkrB.useReducer)($4933e76bd0ca959e$var$reducer, initialStateMerged);
    const value = (0, $5FkrB.useMemo)(()=>({
            state: state,
            dispatch: dispatch,
            api: api
        }), [
        state,
        dispatch,
        api
    ]);
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($4933e76bd0ca959e$var$AppUpdatesContext.Provider, {
        value: value,
        children: children
    });
};






var $8F9hT = parcelRequire("8F9hT");



var $9TAkY = parcelRequire("9TAkY");

var $4Pn6z = parcelRequire("4Pn6z");
var $2kuK2 = parcelRequire("2kuK2");
var $ifpPH = parcelRequire("ifpPH");
var $gDiFE = parcelRequire("gDiFE");

var $5FkrB = parcelRequire("5FkrB");

var $eCCay = parcelRequire("eCCay");
/* heading.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $a3VXv = parcelRequire("a3VXv");

var $99N5z = parcelRequire("99N5z");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $9e1402c6a82b1460$export$d1fa8a19e192bc63 = /*#__PURE__*/ (0, $5FkrB.createContext)(0);


var $7983d3034ceacae2$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $5FkrB.useContext)((0, $9e1402c6a82b1460$export$d1fa8a19e192bc63));
};


var $b11a642b52a5818c$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = (0, $7983d3034ceacae2$export$6a64a1e2d0bbbf75)();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : "h".concat(hLevel)) || fallback
    ];
};



var $3ZMUU = parcelRequire("3ZMUU");
var $9203416ce7d4106b$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $9203416ce7d4106b$var$styles = {
    reset: "_dxsyidpf _1i144jg8 _nmk4glyw"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $9203416ce7d4106b$var$headingColorStyles = {
    'color.text': "_1w90i7uo",
    'color.text.inverse': "_1w9015cr",
    'color.text.warning.inverse': "_1w901yd3"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $9203416ce7d4106b$var$headingSizeStyles = {
    xxlarge: "_fqox1iff",
    xlarge: "_fqox12ln",
    large: "_fqox10sd",
    medium: "_fqox1af2",
    small: "_fqox1e3o",
    xsmall: "_fqox1qyo",
    xxsmall: "_fqoxi4vh"
};
/**
 * @codegenEnd
 */ var $9203416ce7d4106b$var$useColor = function useColor(colorProp) {
    var surface = (0, $99N5z.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $a3VXv.inverseColorMap).hasOwnProperty(surface)) return (0, $a3VXv.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $9203416ce7d4106b$var$Heading = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    typeof $3ZMUU;
    var _useHeading = (0, $b11a642b52a5818c$export$97a37b1befbbf9b1)($9203416ce7d4106b$var$sizeTagMap[size]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === 'div' && hLevel;
    var color = $9203416ce7d4106b$var$useColor(colorProp);
    return /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $970q7.default)([
            $9203416ce7d4106b$var$styles.reset,
            $9203416ce7d4106b$var$headingSizeStyles[size],
            $9203416ce7d4106b$var$headingColorStyles[color]
        ])
    }, children);
});
var $9203416ce7d4106b$export$2e2bcd8739ae039 = $9203416ce7d4106b$var$Heading;



var $auVZV = parcelRequire("auVZV");
var $72GAO = parcelRequire("72GAO");

var $9ztDu = parcelRequire("9ztDu");
/* actions-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $44124a981e9227cb$var$actionsStyles = null;
/**
 * __Actions container__
 *
 * A container for actions: primary action, secondary action, and tertiary action.
 *
 * @internal
 */ var $44124a981e9227cb$var$ActionsContainer = function ActionsContainer(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _6rthu2gc _bozg1jfw"
        ])
    }, children);
};
var $44124a981e9227cb$export$2e2bcd8739ae039 = $44124a981e9227cb$var$ActionsContainer;


/* container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $3a73f390fa3336aa$var$containerStyles = null;
/* Use max-width so the component can shrink on smaller viewports. */ var $3a73f390fa3336aa$var$wideContainerStyles = null;
var $3a73f390fa3336aa$var$narrowContainerStyles = null;
/**
 * __Container__
 *
 * Upper level container for Empty State.
 *
 * @internal
 */ var $3a73f390fa3336aa$var$Container = function Container(_ref) {
    var children = _ref.children, width = _ref.width, testId = _ref.testId;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": testId,
        className: (0, $970q7.default)([
            "_6rthoahv _1pfhoahv _12l21wug _ahbq1wug _y3gn1h6o",
            width === 'narrow' ? "_p12fko4j" : "_p12f1pl1"
        ])
    }, children);
};
var $3a73f390fa3336aa$export$2e2bcd8739ae039 = $3a73f390fa3336aa$var$Container;


/* image.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $cAVP0 = parcelRequire("cAVP0");
function $3cc2c4b28ad7dbd4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3cc2c4b28ad7dbd4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3cc2c4b28ad7dbd4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3cc2c4b28ad7dbd4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3cc2c4b28ad7dbd4$var$CSS_VAR_MAX_WIDTH = '--max-width';
var $3cc2c4b28ad7dbd4$var$CSS_VAR_MAX_HEIGHT = '--max-height';
var $3cc2c4b28ad7dbd4$var$imageStyles = null;
/**
 * __Image__
 *
 * Image in Empty State.
 *
 * @internal
 */ var $3cc2c4b28ad7dbd4$var$Image = function Image(_ref) {
    var maxHeight = _ref.maxHeight, maxWidth = _ref.maxWidth, _ref$height = _ref.height, height = _ref$height === void 0 ? 'auto' : _ref$height, _ref$width = _ref.width, width = _ref$width === void 0 ? 'auto' : _ref$width, src = _ref.src;
    return /*#__PURE__*/ $5FkrB.createElement("img", {
        width: width,
        height: height,
        alt: "",
        role: "presentation",
        src: src,
        className: (0, $970q7.default)([
            "_1e0c1ule _p12f163m _c71l649k _6rth1ejb _1pfhidpf _12l21wug _ahbq1wug"
        ]),
        style: $3cc2c4b28ad7dbd4$var$_objectSpread($3cc2c4b28ad7dbd4$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $3cc2c4b28ad7dbd4$var$CSS_VAR_MAX_WIDTH, "".concat(maxWidth, "px")), $3cc2c4b28ad7dbd4$var$CSS_VAR_MAX_HEIGHT, "".concat(maxHeight, "px"))), {}, {
            "--_11x3y0": (0, $cAVP0.default)("var(".concat($3cc2c4b28ad7dbd4$var$CSS_VAR_MAX_WIDTH, ")")),
            "--_zsxb2b": (0, $cAVP0.default)("var(".concat($3cc2c4b28ad7dbd4$var$CSS_VAR_MAX_HEIGHT, ")"))
        })
    });
};
var $3cc2c4b28ad7dbd4$export$2e2bcd8739ae039 = $3cc2c4b28ad7dbd4$var$Image;


/* spinner-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $a934e1bd7cb5d22f$var$spinnerContainerStyles = null;
/**
 * __Spinner container__
 *
 * A spinner container for loading state of Empty State.
 *
 * @internal
 */ var $a934e1bd7cb5d22f$var$SpinnerContainer = function SpinnerContainer(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            "_1bsb1ejb _ahbqpxbi"
        ])
    }, children);
};
var $a934e1bd7cb5d22f$export$2e2bcd8739ae039 = $a934e1bd7cb5d22f$var$SpinnerContainer;


/**
 * __Empty state__
 *
 * A component used for presenting various empty states.
 * e.g. (no items, empty search, broken link, welcome screen etc.)
 *
 * @example
 * ```tsx
 * import EmptyState from '@atlaskit/empty-state';
 *
 * // An example of a 404 state
 * export default () => {
 *  <EmptyState
 *   header="Page not found"
 *   imageUrl="https://cdn.io/images/404"
 *   description="Looks like you've stumbled off track. Sorry about that! This page either doesn't exist or has been removed."
 *   primaryAction={<Button appearance="primary">Home Page</Button>}
 *   secondaryAction={<Button>Report a problem</Button>}
 *  />;
 * };
 * ```
 */ var $9a28bb334efe6ee5$var$EmptyState = function EmptyState(_ref) {
    var buttonGroupLabel = _ref.buttonGroupLabel, description = _ref.description, header = _ref.header, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 4 : _ref$headingLevel, _ref$headingSize = _ref.headingSize, headingSize = _ref$headingSize === void 0 ? 'medium' : _ref$headingSize, imageHeight = _ref.imageHeight, imageUrl = _ref.imageUrl, imageWidth = _ref.imageWidth, isLoading = _ref.isLoading, _ref$maxImageHeight = _ref.maxImageHeight, maxImageHeight = _ref$maxImageHeight === void 0 ? 160 : _ref$maxImageHeight, _ref$maxImageWidth = _ref.maxImageWidth, maxImageWidth = _ref$maxImageWidth === void 0 ? 160 : _ref$maxImageWidth, primaryAction = _ref.primaryAction, renderImage = _ref.renderImage, secondaryAction = _ref.secondaryAction, width = _ref.width, tertiaryAction = _ref.tertiaryAction, testId = _ref.testId;
    var actionsContainer = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $44124a981e9227cb$export$2e2bcd8739ae039), null, primaryAction && secondaryAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $eCCay.default), {
        label: buttonGroupLabel || 'Button group',
        testId: testId && "".concat(testId, "-button-group")
    }, secondaryAction, primaryAction) : primaryAction || secondaryAction, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a934e1bd7cb5d22f$export$2e2bcd8739ae039), null, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9ztDu.default), {
        testId: "empty-state-spinner"
    }))) : null;
    var tag = "h".concat(headingLevel > 0 && headingLevel < 7 ? headingLevel : headingLevel > 6 ? 6 : 4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3a73f390fa3336aa$export$2e2bcd8739ae039), {
        testId: testId,
        width: width || 'wide'
    }, imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3cc2c4b28ad7dbd4$export$2e2bcd8739ae039), {
        src: imageUrl,
        maxWidth: maxImageWidth,
        maxHeight: maxImageHeight,
        width: imageWidth,
        height: imageHeight
    }) : renderImage && renderImage({
        maxImageWidth: maxImageWidth,
        maxImageHeight: maxImageHeight,
        imageWidth: imageWidth,
        imageHeight: imageHeight
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $auVZV.Box), {
        paddingBlockEnd: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9203416ce7d4106b$export$2e2bcd8739ae039), {
        size: headingSize,
        as: tag
    }, header)), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $auVZV.Box), {
        paddingBlockEnd: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $72GAO.Text), {
        as: "p"
    }, description)), actionsContainer, tertiaryAction);
};
var $9a28bb334efe6ee5$export$2e2bcd8739ae039 = $9a28bb334efe6ee5$var$EmptyState;



/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $bgNpv = parcelRequire("bgNpv");
var $hrVKU = parcelRequire("hrVKU");

var $dUWEU = parcelRequire("dUWEU");

var $kzB9W = parcelRequire("kzB9W");

var $b1mKd = parcelRequire("b1mKd");

var $eaEPs = parcelRequire("eaEPs");

var $h19KG = parcelRequire("h19KG");

var $4r3Kr = parcelRequire("4r3Kr");

var $aMiKe = parcelRequire("aMiKe");

var $50U6m = parcelRequire("50U6m");

var $72GAO = parcelRequire("72GAO");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $5FkrB = parcelRequire("5FkrB");

var $5tQm9 = parcelRequire("5tQm9");

var $i2C5U = parcelRequire("i2C5U");
// https://parceljs.org/features/dependency-resolution/#glob-specifiers

























var $1937f0450e0b52d4$export$3770c7a7737d463c = {
    cs: function cs() {
        return (parcelRequire("7BOim"));
    },
    da: function da() {
        return (parcelRequire("lBZGT"));
    },
    de: function de() {
        return (parcelRequire("bGn3J"));
    },
    'en-GB': function enGB() {
        return (parcelRequire("kbs14"));
    },
    'en-ZZ': function enZZ() {
        return (parcelRequire("he924"));
    },
    en: function en() {
        return Promise.resolve((parcelRequire("i2C5U")));
    },
    es: function es() {
        return (parcelRequire("6n0tt"));
    },
    fi: function fi() {
        return (parcelRequire("jpANc"));
    },
    fr: function fr() {
        return (parcelRequire("a0R1n"));
    },
    hu: function hu() {
        return (parcelRequire("8oykS"));
    },
    it: function it() {
        return (parcelRequire("4GjoG"));
    },
    ja: function ja() {
        return (parcelRequire("inXrq"));
    },
    ko: function ko() {
        return (parcelRequire("ix375"));
    },
    nb: function nb() {
        return (parcelRequire("8NjuC"));
    },
    nl: function nl() {
        return (parcelRequire("5kzPX"));
    },
    pl: function pl() {
        return (parcelRequire("7jwnm"));
    },
    'pt-BR': function ptBR() {
        return (parcelRequire("73JLl"));
    },
    ru: function ru() {
        return (parcelRequire("01W4K"));
    },
    sv: function sv() {
        return (parcelRequire("hGuAk"));
    },
    th: function th() {
        return (parcelRequire("e2uAj"));
    },
    tr: function tr() {
        return (parcelRequire("b9qm9"));
    },
    uk: function uk() {
        return (parcelRequire("hk4dg"));
    },
    vi: function vi() {
        return (parcelRequire("Jx3pr"));
    },
    zh_TW: function zh_TW() {
        return (parcelRequire("cFvPh"));
    },
    zh: function zh() {
        return (parcelRequire("hwI6q"));
    }
};


var $c58a4616776b6c56$var$fetchMessagesForLocale = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(locale) {
        var _asyncLanguages$langu, _localeMessages$defau, languageLocale, localeMessages, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.prev = 0;
                    // Fallback to the generic locale if specified one is not found
                    languageLocale = locale in (0, $1937f0450e0b52d4$export$3770c7a7737d463c) ? locale : locale.split(/[-_]/)[0] || ''; // Dynamic import of the locale file
                    _context.next = 1;
                    return (_asyncLanguages$langu = (0, $1937f0450e0b52d4$export$3770c7a7737d463c)[languageLocale]) === null || _asyncLanguages$langu === void 0 ? void 0 : _asyncLanguages$langu.call((0, $1937f0450e0b52d4$export$3770c7a7737d463c));
                case 1:
                    localeMessages = _context.sent;
                    return _context.abrupt("return", (_localeMessages$defau = localeMessages === null || localeMessages === void 0 ? void 0 : localeMessages.default) !== null && _localeMessages$defau !== void 0 ? _localeMessages$defau : (0, $i2C5U.default));
                case 2:
                    _context.prev = 2;
                    _t = _context["catch"](0);
                    return _context.abrupt("return", (0, $i2C5U.default));
                case 3:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                0,
                2
            ]
        ]);
    }));
    return function fetchMessagesForLocale(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $c58a4616776b6c56$export$460e64eacd3ef998 = function AdminhubIntlProvider(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5tQm9.default), {
        defaultMessages: (0, $i2C5U.default),
        loaderFn: $c58a4616776b6c56$var$fetchMessagesForLocale
    }, children);
};



var $6bnW7 = parcelRequire("6bnW7");
var $97c8fa4180da01bc$export$defe85febe8b728c = (0, $6bnW7.defineMessages)({
    pagination: {
        id: 'admin-hub-pagination.pagination',
        defaultMessage: 'Pagination',
        description: 'Aria-label for the pagination navigation component used in admin hub tables to identify the landmark region for screen readers.'
    },
    nextPageButton: {
        id: 'admin-hub-pagination.next.page.button',
        defaultMessage: 'Next',
        description: 'Button to go the next page on a paginated table or list'
    },
    previousPageButton: {
        id: 'admin-hub-pagination.previous.page.button',
        defaultMessage: 'Previous',
        description: 'Button to go the previous page on a paginated table or list'
    },
    pageRange: {
        id: 'admin-hub-pagination.page.range',
        defaultMessage: '{itemsStart} to {itemsEnd} results',
        description: 'Indicates which items are currently being shown in the paginated table. example of full sentence "21 to 40 of many results"'
    },
    pageRangeWithTotal: {
        id: 'admin-hub-pagination.page.range.with.total',
        defaultMessage: '{itemsStart} to {itemsEnd} of {totalCount, plural, one {# result} other {# results}}',
        description: 'Indicates which items are currently being shown in the paginated table, total included. example of full sentence "1 to 20 of 678 result."'
    },
    resultsPerPage: {
        id: 'admin-hub-pagination.result.per.page',
        defaultMessage: 'Results per page:',
        description: 'Label shown before a drop-down selector in the admin hub pagination bar that lets the user choose how many results to display per page.'
    },
    count: {
        id: 'admin-hub-pagination.refresh.count.total',
        defaultMessage: 'Showing {totalCount} {label}',
        description: 'Table count. This will display count of total number of items in the table.'
    },
    currentCount: {
        id: 'admin-hub-pagination.refresh.count.current',
        defaultMessage: 'Showing {currentCount, plural, one {# result} other {# results}} out of {totalCount} {label}',
        description: 'Table count. This will display filtered count of items in the table.'
    },
    loading: {
        id: 'admin-hub-pagination.refresh.loading',
        defaultMessage: 'Checking for updates',
        description: 'Message to show next to table count while product results are loading'
    },
    defaultItemLabel: {
        id: 'admin-hub-pagination.refresh.item.default.label',
        defaultMessage: '{totalCount, plural, one {Item} other {Items}}',
        description: 'Default item type label used in the admin hub pagination count when no specific item name is provided. The placeholder {totalCount} controls the plural form (one vs. other).'
    },
    refreshLabel: {
        id: 'admin-hub-pagination.refresh.label',
        defaultMessage: 'Refresh',
        description: 'Accessible label for refresh icon button'
    }
});


var $de3e24ee9809fb70$var$_excluded = [
    "triggerRef"
];
var $de3e24ee9809fb70$var$mediaStyles = {
    paginationBar: "_zulpu2gc _1e0c1txw _1n261g80",
    paginationButtons: "_zulp1b66 _1e0c1txw _4cvr1h6o _2mzuglyw _19pkidpf _19bvze3t",
    paginationSizeSelector: "_zulpu2gc _1e0c1txw _4cvr1h6o _1bahesu3",
    dropdownWrapper: "_1e0c1txw _4cvr1h6o _1bahesu3 _c71l1ejb",
    paginationContainer: "_zulpu2gc _1e0c1txw _1bah1yb4 _1n261g80",
    paginationList: "_19pkidpf _1g5lu2gc",
    results: "_1wpz1h6o _2vqh4jg8 _1r8nze3t"
};
var $de3e24ee9809fb70$export$7a33151a69952680 = 'large';
var $de3e24ee9809fb70$export$e256cdbfdb42e93c = {
    small: [
        10,
        20
    ],
    large: [
        20,
        40
    ]
};
var $de3e24ee9809fb70$export$5716e8bcb003888d = $de3e24ee9809fb70$export$e256cdbfdb42e93c[$de3e24ee9809fb70$export$7a33151a69952680][0];
var $de3e24ee9809fb70$export$b4f25c536698a4fa = function PaginationImpl(_ref) {
    var onNextPageClicked = _ref.onNextPageClicked, onPreviousPageClicked = _ref.onPreviousPageClicked, onPageSizeChange = _ref.onPageSizeChange, currentPageStart = _ref.currentPageStart, currentPageEnd = _ref.currentPageEnd, totalItems = _ref.totalItems, hasPreviousPage = _ref.hasPreviousPage, hasNextPage = _ref.hasNextPage, pageSize = _ref.pageSize, pageSizeOptions = _ref.pageSizeOptions, pageSizeOption = _ref.pageSizeOption, defaultPageSizeOption = _ref.defaultPageSizeOption, menuPlacement = _ref.menuPlacement, nextButtonTestId = _ref.nextButtonTestId, previousButtonTestId = _ref.previousButtonTestId, ariaPreviousLabel = _ref.ariaPreviousLabel, ariaNextLabel = _ref.ariaNextLabel;
    var intl = (0, $hrVKU.default)();
    var labelId = (0, $5FkrB.useId)();
    var triggerButtonId = (0, $5FkrB.useId)();
    var options = pageSizeOptions || $de3e24ee9809fb70$export$e256cdbfdb42e93c[pageSize !== null && pageSize !== void 0 ? pageSize : $de3e24ee9809fb70$export$7a33151a69952680].map(function(value) {
        return {
            label: intl.formatNumber(value),
            value: value
        };
    });
    var defaultValue = defaultPageSizeOption || options[0];
    var _useState = (0, $5FkrB.useState)(defaultValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), internalOption = _useState2[0], setInternalOption = _useState2[1];
    var selectedOption = (0, $50U6m.fg)('adminhub_table_pagination_controlled_page_size') && pageSizeOption ? pageSizeOption : internalOption;
    var shouldShowPagination = hasPreviousPage || hasNextPage || selectedOption.value !== defaultValue.value;
    if (!shouldShowPagination) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        "data-testid": "pagination",
        className: (0, $970q7.default)([
            $de3e24ee9809fb70$var$mediaStyles.paginationContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        className: (0, $970q7.default)([
            $de3e24ee9809fb70$var$mediaStyles.paginationSizeSelector
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $72GAO.Text), {
        id: labelId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, $97c8fa4180da01bc$export$defe85febe8b728c).resultsPerPage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        className: (0, $970q7.default)([
            $de3e24ee9809fb70$var$mediaStyles.dropdownWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kzB9W.default), {
        trigger: function trigger(_ref2) {
            var triggerRef = _ref2.triggerRef, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $de3e24ee9809fb70$var$_excluded);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dUWEU.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                ref: triggerRef
            }, props, {
                "aria-labelledby": "".concat(labelId, " ").concat(triggerButtonId),
                id: triggerButtonId,
                iconAfter: function iconAfter(iconProps) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h19KG))), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, iconProps, {
                        size: "small"
                    }));
                },
                spacing: "compact"
            }), selectedOption.label);
        },
        spacing: "compact",
        testId: "pagination-dropdown",
        placement: menuPlacement !== null && menuPlacement !== void 0 ? menuPlacement : 'bottom-start',
        shouldFitContainer: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $eaEPs.default), null, options.map(function(option) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b1mKd.default), {
            key: "".concat(option.label, "-").concat(option.value),
            isSelected: selectedOption.value === option.value,
            onClick: function onClick() {
                setInternalOption(option);
                onPageSizeChange(option, {
                    action: 'select-option'
                });
            }
        }, option.label);
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("nav", {
        "data-testid": "pagination-nav",
        "aria-label": intl.formatMessage((0, $97c8fa4180da01bc$export$defe85febe8b728c).pagination),
        className: (0, $970q7.default)([
            $de3e24ee9809fb70$var$mediaStyles.paginationBar
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        className: (0, $970q7.default)([
            $de3e24ee9809fb70$var$mediaStyles.results
        ])
    }, currentPageStart && currentPageStart > 0 && currentPageEnd && currentPageEnd > 0 && currentPageEnd <= Number(totalItems || currentPageEnd) ? totalItems && totalItems > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, (0, $97c8fa4180da01bc$export$defe85febe8b728c).pageRangeWithTotal, {
        values: {
            itemsStart: currentPageStart,
            itemsEnd: currentPageEnd,
            totalCount: totalItems
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, (0, $97c8fa4180da01bc$export$defe85febe8b728c).pageRange, {
        values: {
            itemsStart: currentPageStart,
            itemsEnd: currentPageEnd
        }
    })) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("ul", {
        className: (0, $970q7.default)([
            $de3e24ee9809fb70$var$mediaStyles.paginationButtons
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("li", {
        className: (0, $970q7.default)([
            $de3e24ee9809fb70$var$mediaStyles.paginationList
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dUWEU.default), {
        "aria-label": ariaPreviousLabel ? ariaPreviousLabel : intl.formatMessage((0, $97c8fa4180da01bc$export$defe85febe8b728c).previousPageButton),
        isDisabled: !hasPreviousPage,
        iconBefore: function iconBefore(iconProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4r3Kr))), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, iconProps, {
                size: "small"
            }));
        },
        spacing: "compact",
        testId: nextButtonTestId || 'pagination-previous-button',
        onClick: onPreviousPageClicked
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, $97c8fa4180da01bc$export$defe85febe8b728c).previousPageButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("li", {
        className: (0, $970q7.default)([
            $de3e24ee9809fb70$var$mediaStyles.paginationList
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dUWEU.default), {
        "aria-label": ariaNextLabel ? ariaNextLabel : intl.formatMessage((0, $97c8fa4180da01bc$export$defe85febe8b728c).nextPageButton),
        isDisabled: !hasNextPage,
        iconAfter: function iconAfter(iconProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aMiKe))), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, iconProps, {
                size: "small"
            }));
        },
        spacing: "compact",
        testId: previousButtonTestId || 'pagination-next-button',
        onClick: onNextPageClicked
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, $97c8fa4180da01bc$export$defe85febe8b728c).nextPageButton))))));
};
var $de3e24ee9809fb70$export$68f5e1453c188a82 = function Pagination(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c58a4616776b6c56$export$460e64eacd3ef998), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($de3e24ee9809fb70$export$b4f25c536698a4fa, props));
};
var $de3e24ee9809fb70$export$2e2bcd8739ae039 = $de3e24ee9809fb70$export$68f5e1453c188a82;



var $5FkrB = parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");

/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $fc9e4eeab8790eaa$export$dfd9b671c89acc8e = 7;
const $fc9e4eeab8790eaa$export$3913210603d8e9ae = 365.2425;
const $fc9e4eeab8790eaa$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $fc9e4eeab8790eaa$export$4dec998e48f9c246 = -$fc9e4eeab8790eaa$export$81caae6e1cc7a622;
const $fc9e4eeab8790eaa$export$4fad13613e88edc8 = 604800000;
const $fc9e4eeab8790eaa$export$b76b1809a2898f9a = 86400000;
const $fc9e4eeab8790eaa$export$91246f0b9bd9beff = 60000;
const $fc9e4eeab8790eaa$export$7f72910d6dfd237a = 3600000;
const $fc9e4eeab8790eaa$export$397c2d5776aa9055 = 1000;
const $fc9e4eeab8790eaa$export$3633035e63cee86a = 525600;
const $fc9e4eeab8790eaa$export$ab7da2ccd1075c38 = 43200;
const $fc9e4eeab8790eaa$export$2423174df8cd3cd2 = 1440;
const $fc9e4eeab8790eaa$export$f2f5ae5a8e2d8f9f = 60;
const $fc9e4eeab8790eaa$export$3c58128db900d44e = 3;
const $fc9e4eeab8790eaa$export$80d7e435f744f319 = 12;
const $fc9e4eeab8790eaa$export$4db7641526e3241f = 4;
const $fc9e4eeab8790eaa$export$698aec755e92c695 = 3600;
const $fc9e4eeab8790eaa$export$a77c1a7ebebe2a5a = 60;
const $fc9e4eeab8790eaa$export$815a9362476d2fe3 = $fc9e4eeab8790eaa$export$698aec755e92c695 * 24;
const $fc9e4eeab8790eaa$export$34804a017b31e2fe = $fc9e4eeab8790eaa$export$815a9362476d2fe3 * 7;
const $fc9e4eeab8790eaa$export$7271e9e3478110d1 = $fc9e4eeab8790eaa$export$815a9362476d2fe3 * $fc9e4eeab8790eaa$export$3913210603d8e9ae;
const $fc9e4eeab8790eaa$export$8e6600bbdee7dabb = $fc9e4eeab8790eaa$export$7271e9e3478110d1 / 12;
const $fc9e4eeab8790eaa$export$be1dccf2de902d31 = $fc9e4eeab8790eaa$export$8e6600bbdee7dabb * 3;
const $fc9e4eeab8790eaa$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");


function $0cb18d37664e0c78$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $fc9e4eeab8790eaa$export$2a7b97929c48d47d) in date) return date[0, $fc9e4eeab8790eaa$export$2a7b97929c48d47d](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$0cb18d37664e0c78$export$2e2bcd8739ae039 = $0cb18d37664e0c78$export$ead8a1812b171991;



function $1c71cd1e0e1aa409$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $0cb18d37664e0c78$export$ead8a1812b171991)(context || argument, argument);
}
var // Fallback for modularized imports:
$1c71cd1e0e1aa409$export$2e2bcd8739ae039 = $1c71cd1e0e1aa409$export$e67a095c620b86fe;


function $c94dceb2d15e7bee$export$dd412b56f1e4d8aa(date, amount, options) {
    const _date = (0, $1c71cd1e0e1aa409$export$e67a095c620b86fe)(date, options?.in);
    if (isNaN(amount)) return (0, $0cb18d37664e0c78$export$ead8a1812b171991)(options?.in || date, NaN);
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    if (!amount) return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
var // Fallback for modularized imports:
$c94dceb2d15e7bee$export$2e2bcd8739ae039 = $c94dceb2d15e7bee$export$dd412b56f1e4d8aa;


function $c560af1483547aa3$export$70823084e2deb1ea(date, amount, options) {
    return (0, $c94dceb2d15e7bee$export$dd412b56f1e4d8aa)(date, -amount, options);
}
var // Fallback for modularized imports:
$c560af1483547aa3$export$2e2bcd8739ae039 = $c560af1483547aa3$export$70823084e2deb1ea;



var $kqp0i = parcelRequire("kqp0i");

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $eSyoe = parcelRequire("eSyoe");

var $kuWWJ = parcelRequire("kuWWJ");

var $dcrmD = parcelRequire("dcrmD");

var $bgNpv = parcelRequire("bgNpv");

var $gAHKi = parcelRequire("gAHKi");

var $5tQm9 = parcelRequire("5tQm9");

var $6fyuV = parcelRequire("6fyuV");
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");


var $kuWWJ = parcelRequire("kuWWJ");

var $bgNpv = parcelRequire("bgNpv");
var $hrVKU = parcelRequire("hrVKU");

var $dUWEU = parcelRequire("dUWEU");

var $h19KG = parcelRequire("h19KG");

var $cMVCI = parcelRequire("cMVCI");

var $5tQm9 = parcelRequire("5tQm9");

var $dY97G = parcelRequire("dY97G");

var $4Pn6z = parcelRequire("4Pn6z");
var $gDiFE = parcelRequire("gDiFE");
var $86b286ad5c089076$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};


/* radio.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $aLEtb = parcelRequire("aLEtb");

var $eVb4V = parcelRequire("eVb4V");
var $b59c286b12779831$var$_excluded = [
    "ariaLabel",
    "aria-labelledby",
    "isDisabled",
    "isRequired",
    "isInvalid",
    "isChecked",
    "label",
    "labelId",
    "name",
    "onChange",
    "value",
    "testId",
    "analyticsContext"
];
var $b59c286b12779831$var$packageName = "@atlaskit/radio";
var $b59c286b12779831$var$packageVersion = "10.1.1";
var $b59c286b12779831$var$noop = (0, $eVb4V.default);
var $b59c286b12779831$var$labelPaddingStyles = null;
var $b59c286b12779831$var$labelStyles = null;
var $b59c286b12779831$var$labelDisabledStyles = null;
var $b59c286b12779831$var$radioBaseStyles = null;
var $b59c286b12779831$var$radioInteractiveStyles = null;
var $b59c286b12779831$var$radioDisabledStyles = null;
var $b59c286b12779831$var$radioDisabledCheckedStyles = null;
var $b59c286b12779831$var$radioInvalidStyles = null;
var $b59c286b12779831$var$InnerRadio = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function Radio(props, ref) {
    var ariaLabel = props.ariaLabel, ariaLabelledBy = props['aria-labelledby'], _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, isRequired = props.isRequired, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isChecked = props.isChecked, isChecked = _props$isChecked === void 0 ? false : _props$isChecked, label = props.label, labelId = props.labelId, name = props.name, _props$onChange = props.onChange, onChange = _props$onChange === void 0 ? $b59c286b12779831$var$noop : _props$onChange, value = props.value, testId = props.testId, analyticsContext = props.analyticsContext, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $b59c286b12779831$var$_excluded);
    var onChangeAnalytics = (0, $aLEtb.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $b59c286b12779831$var$packageName,
        packageVersion: $b59c286b12779831$var$packageVersion
    });
    return /*#__PURE__*/ $5FkrB.createElement("label", {
        "data-testid": testId && "".concat(testId, "--radio-label"),
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $970q7.default)([
            "_11c8fhey _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazi7uo",
            isDisabled && "_syaz1gmx _80om13gf"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        "aria-label": ariaLabel,
        "aria-labelledby": labelId || ariaLabelledBy,
        checked: isChecked,
        disabled: isDisabled,
        name: name,
        onChange: onChangeAnalytics,
        required: isRequired,
        type: "radio",
        value: value,
        "data-testid": testId && "".concat(testId, "--radio-input"),
        "data-invalid": isInvalid ? 'true' : undefined,
        ref: ref,
        className: (0, $970q7.default)([
            "_18s8ze3t _19it3vzd _2rko1qll _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6q1j9a _1151rsbi _1s6w5w2r _tqbwidpf _t9ec1soj _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1qll _qc5orqeg _z0ai120g _1qdg120g _18postnw _aetrb3bt _1peq1xmd",
            !isDisabled && "_iosijmqp _11jyjmqp _f3ett94y _y2mvdfik _1bg41l7b _6tjkdfik _awqn1l7b _1rvql4ek _1p9jrsbi _x2tz1q28 _1iwz1q28 _sj8yr01l _jcko12kk _1dvdrsbi _60ak5w2r",
            isDisabled && "_80om13gf _1q6q187o _1151bk0g _1s6w2sac",
            isDisabled && isChecked && "_tqbwt94y",
            isInvalid && !isDisabled && "_1151s4qr _11jys4qr"
        ])
    })), label ? /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
        ])
    }, label) : null);
});
/**
 * __Radio__
 *
 * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
 *
 * - [Examples](https://atlassian.design/components/radio/examples)
 * - [Code](https://atlassian.design/components/radio/code)
 * - [Usage](https://atlassian.design/components/radio/usage)
 */ var $b59c286b12779831$var$Radio = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ $5FkrB.createElement($b59c286b12779831$var$InnerRadio, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        ref: ref
    }));
}));
var $b59c286b12779831$export$2e2bcd8739ae039 = $b59c286b12779831$var$Radio;


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $78c9c9e25929b7eb$export$2e2bcd8739ae039 = {
    'admin-hub-filter.between-dates.and': 'and',
    'admin-hub-filter.between-dates.open-end-date-label': 'End date',
    'admin-hub-filter.between-dates.open-start-date-label': 'Start date',
    'admin-hub-filter.more-than.days': 'days ago',
    'admin-hub-filter.more-than.hours': 'hours ago',
    'admin-hub-filter.more-than.minutes': 'minutes ago',
    'admin-hub-filter.more-than.weeks': 'weeks ago',
    'admin-hub-filter.option.between-dates': 'Between',
    'admin-hub-filter.option.clear-selection': 'Clear selection',
    'admin-hub-filter.option.in-time-range': 'In the range',
    'admin-hub-filter.option.more-than': 'More than',
    'admin-hub-filter.option.update': 'Update',
    'admin-hub-filter.option.within-the-last': 'Within the last',
    'admin-hub-filter.popup.aria-label': 'Popup for date time filter',
    'admin-hub-filter.popup.label': 'Popup for date time filter"',
    'admin-hub-filter.time-input.timeunit-duration-value.non-final': 'Enter duration value',
    'admin-hub-filter.time-input.timeunit.label.non-final': 'Select time unit',
    'admin-hub-filter.trigger.label.inTimeRange.afterNowToAfterNow.non-final': 'From {start} from now to {end} from now',
    'admin-hub-filter.trigger.label.inTimeRange.afterNowtoBlank.non-final': 'From {start} from now',
    'admin-hub-filter.trigger.label.inTimeRange.beforeNowToAfterNow.non-final': 'From {start} ago to {end} from now',
    'admin-hub-filter.trigger.label.inTimeRange.beforeNowToBeforeNow.non-final': 'From {start} ago to {end} ago',
    'admin-hub-filter.trigger.label.inTimeRange.beforeToBlank.non-final': 'From {start} ago',
    'admin-hub-filter.trigger.label.inTimeRange.blankToAfterNow.non-final': 'Up to {end} from now',
    'admin-hub-filter.trigger.label.inTimeRange.blankToBefore.non-final': 'Up to {end} ago',
    'admin-hub-filter.trigger.label.inTimeRange.unknown.non-final': 'From {start} to {end}',
    'admin-hub-filter.trigger.label.moreThan.day.non-final': 'More than {value, plural, one {# day} other {# days}} ago',
    'admin-hub-filter.trigger.label.moreThan.hour.non-final': 'More than {value, plural, one {# hour} other {# hours}} ago',
    'admin-hub-filter.trigger.label.moreThan.min.non-final': 'More than {value, plural, one {# minute} other {# minutes}} ago',
    'admin-hub-filter.trigger.label.moreThan.unknown.non-final': 'More than {value} ago',
    'admin-hub-filter.trigger.label.moreThan.week.non-final': 'More than {value, plural, one {# week} other {# weeks}} ago',
    'admin-hub-filter.trigger.label.timeInDays.non-final': '{value, plural, one {# day} other {# days}}',
    'admin-hub-filter.trigger.label.timeInHours.non-final': '{value, plural, one {# hour} other {# hours}}',
    'admin-hub-filter.trigger.label.timeInMinutes.non-final': '{value, plural, one {# minute} other {# minutes}}',
    'admin-hub-filter.trigger.label.timeInWeeks.non-final': '{value, plural, one {# week} other {# weeks}}',
    'admin-hub-filter.trigger.label.withinLast.day': 'Within the last {value, plural, one {day} other {# days}}',
    'admin-hub-filter.trigger.label.withinLast.hour': 'Within the last {value, plural, one {hour} other {# hours}}',
    'admin-hub-filter.trigger.label.withinLast.min': 'Within the last {value, plural, one {minute} other {# minutes}}',
    'admin-hub-filter.trigger.label.withinLast.unknown': 'Within the last {value}',
    'admin-hub-filter.trigger.label.withinLast.week': 'Within the last {value, plural, one {week} other {# weeks}}',
    'admin-hub-filter.utils.validation-message-before-greater-than-after': "'Before' field cannot be later than 'After' field.",
    'admin-hub-filter.utils.validation-message-date-out-of-range': 'Date is outside the allowed range.',
    'admin-hub-filter.utils.validation-message-invalid-period-format': 'Enter a valid number',
    'admin-hub-filter.within-the-last.days': 'days',
    'admin-hub-filter.within-the-last.hours': 'hours',
    'admin-hub-filter.within-the-last.minutes': 'minutes',
    'admin-hub-filter.within-the-last.weeks': 'weeks',
    'filter.in-time-range.end-label': 'Enter end period time range value',
    'filter.in-time-range.start-label': 'Enter start period time range value',
    'filter.in-time-range.to': 'to',
    'filter.utils.validation-message-invalid-period-range-format': 'Invalid period format. Please enter the period in the format "3w 4d 5h 6m".',
    'filter.utils.validation-message-time-range-cannot-include-future-date-nonfinal': 'Time range cannot include a future date.'
};


var $f71e7f1cc9464e0b$export$2e2bcd8739ae039 = (0, $78c9c9e25929b7eb$export$2e2bcd8739ae039);



var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");
function $fd4467ba0d8a5a4a$var$_tsRewriteRelativeImportExtensions(t, e) {
    return "string" == typeof t && /^\.\.?\//.test(t) ? t.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+)?)\.([cm]?)ts$/i, function(t, s, r, n, o) {
        return s ? e ? ".jsx" : ".js" : !r || n && o ? r + n + "." + o.toLowerCase() + "js" : t;
    }) : t;
}
var $fd4467ba0d8a5a4a$export$2b153a2030b0feb2 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(locale) {
        var messages, parentLocale, _messages, _t, _t2;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.prev = 0;
                    _context.next = 1;
                    return import(/* webpackChunkName: "@atlaskit-internal_@atlassian/filter-controller-i18n-[request]" */ $fd4467ba0d8a5a4a$var$_tsRewriteRelativeImportExtensions($fd4467ba0d8a5a4a$var$_tsRewriteRelativeImportExtensions("../../i18n/".concat(locale))));
                case 1:
                    messages = _context.sent;
                    return _context.abrupt("return", messages.default);
                case 2:
                    _context.prev = 2;
                    _t = _context["catch"](0);
                    _context.prev = 3;
                    parentLocale = locale.split(/[-_]/)[0];
                    _context.next = 4;
                    return import(/* webpackChunkName: "@atlaskit-internal_@atlassian/filter-controller-i18n-[request]" */ $fd4467ba0d8a5a4a$var$_tsRewriteRelativeImportExtensions($fd4467ba0d8a5a4a$var$_tsRewriteRelativeImportExtensions("../../i18n/".concat(parentLocale))));
                case 4:
                    _messages = _context.sent;
                    return _context.abrupt("return", _messages.default);
                case 5:
                    _context.prev = 5;
                    _t2 = _context["catch"](3);
                case 6:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                0,
                2
            ],
            [
                3,
                5
            ]
        ]);
    }));
    return function fetchMessagesForLocale(_x) {
        return _ref.apply(this, arguments);
    };
}();



var $5FkrB = parcelRequire("5FkrB");

var $bgNpv = parcelRequire("bgNpv");

var $ifX9g = parcelRequire("ifX9g");
var $gDiFE = parcelRequire("gDiFE");

var $6bnW7 = parcelRequire("6bnW7");
var $3de5fbb892f27244$export$defe85febe8b728c = (0, $6bnW7.defineMessages)({
    clearSelection: {
        id: 'admin-hub-filter.option.clear-selection',
        defaultMessage: 'Clear selection',
        description: 'Text shown on a button in the datetime filter panel that clears all currently selected filter options when clicked.'
    }
});


var $5900b3c7c8a85aa0$var$pressableStyles = (0, $gDiFE.xcss)({
    color: 'color.text.subtle',
    fontWeight: 'font.weight.medium',
    ':hover': {
        textDecoration: 'underline'
    },
    ':active': {
        color: 'color.text'
    }
});
function $5900b3c7c8a85aa0$export$2e2bcd8739ae039(_ref) {
    var id = _ref.id, testId = _ref.testId, handleClearSelection = _ref.handleClearSelection;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ifX9g.Pressable), {
        id: "".concat(id, "-datetime-clear"),
        testId: "".concat(testId, "-datetime-clear"),
        onClick: handleClearSelection,
        padding: "space.0",
        backgroundColor: "color.background.neutral.subtle",
        xcss: $5900b3c7c8a85aa0$var$pressableStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, $3de5fbb892f27244$export$defe85febe8b728c).clearSelection));
}


var $380570a298df429f$export$23a3939f30e96d0d = 'BETWEEN_DATES';
var $380570a298df429f$export$7fdef674d2870515 = {
    startDate: '',
    endDate: ''
};

var $4d293f787d49bb57$export$e54cb950486aac3c = 'IN_TIME_RANGE';
var $4d293f787d49bb57$export$b6e2d38d788f819d = {
    startPeriod: '',
    endPeriod: ''
};

var $289eb4eab502a333$export$d9e59215631231e3 = /*#__PURE__*/ function(TimeUnit) {
    /**
   * Minutes
   */ TimeUnit["m"] = "m";
    /**
   * Hours
   */ TimeUnit["h"] = "h";
    /**
   * Days
   */ TimeUnit["d"] = "d";
    /**
   * Weeks
   */ TimeUnit["w"] = "w";
    return TimeUnit;
}({});
var $289eb4eab502a333$export$3eb32c07c48a482 = 'WITHIN_THE_LAST';
var $289eb4eab502a333$export$1d6ceeecb2c7a18d = 'MORE_THAN';
var $289eb4eab502a333$export$82fa23ae93bbb468 = {
    m: 60000,
    h: 3600000,
    d: 86400000,
    w: 604800000
};
var $289eb4eab502a333$export$83c81c9b7b7a0a1f = {
    unitValue: '',
    timeUnit: $289eb4eab502a333$export$d9e59215631231e3.m
};


var $c013b3b4ee68e75f$export$18932e8706af151c = [
    (0, $380570a298df429f$export$23a3939f30e96d0d),
    (0, $289eb4eab502a333$export$3eb32c07c48a482),
    (0, $289eb4eab502a333$export$1d6ceeecb2c7a18d),
    (0, $4d293f787d49bb57$export$e54cb950486aac3c)
];
var $c013b3b4ee68e75f$export$b272f341752cc375 = 510;



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");
var $hrVKU = parcelRequire("hrVKU");


var $ekGgq = parcelRequire("ekGgq");

var $eyuDe = parcelRequire("eyuDe");

var $aMsoM = parcelRequire("aMsoM");

var $iYJcE = parcelRequire("iYJcE");

var $kuWWJ = parcelRequire("kuWWJ");

function $9159a798162ada16$var$_wrapRegExp() {
    $9159a798162ada16$var$_wrapRegExp = function _wrapRegExp(e, r) {
        return new BabelRegExp(e, void 0, r);
    };
    var e = RegExp.prototype, r = new WeakMap();
    function BabelRegExp(e, t, p) {
        var o = RegExp(e, t);
        return r.set(o, p || r.get(e)), (0, (/*@__PURE__*/$parcel$interopDefault($aMsoM)))(o, BabelRegExp.prototype);
    }
    function buildGroups(e, t) {
        var p = r.get(t);
        return Object.keys(p).reduce(function(r, t) {
            var o = p[t];
            if ("number" == typeof o) r[t] = e[o];
            else {
                for(var i = 0; void 0 === e[o[i]] && i + 1 < o.length;)i++;
                r[t] = e[o[i]];
            }
            return r;
        }, Object.create(null));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(r) {
        var t = e.exec.call(this, r);
        if (t) {
            t.groups = buildGroups(t, this);
            var p = t.indices;
            p && (p.groups = buildGroups(p, this));
        }
        return t;
    }, BabelRegExp.prototype[Symbol.replace] = function(t, p) {
        if ("string" == typeof p) {
            var o = r.get(this);
            return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)(>|$)/g, function(e, r, t) {
                if ("" === t) return e;
                var p = o[r];
                return Array.isArray(p) ? "$" + p.join("$") : "number" == typeof p ? "$" + p : "";
            }));
        }
        if ("function" == typeof p) {
            var i = this;
            return e[Symbol.replace].call(this, t, function() {
                var e = arguments;
                return "object" != (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(e[e.length - 1]) && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e);
            });
        }
        return e[Symbol.replace].call(this, t, p);
    }, $9159a798162ada16$var$_wrapRegExp.apply(this, arguments);
}
function $9159a798162ada16$export$9798fe0e3b26bbe6(val, unit) {
    var endBase = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date().getTime();
    var end = new Date(endBase);
    var unixTimestamp = end.getTime();
    var offset = val * (0, $289eb4eab502a333$export$82fa23ae93bbb468)[unit];
    var start = new Date(unixTimestamp - offset);
    return [
        start.getTime(),
        end.getTime()
    ];
}
var $9159a798162ada16$export$8cf53058824d30eb = function convertUnixMsTimestampToDate(date) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($kuWWJ))).unix(parseInt(date) / 1000).toDate();
};
var $9159a798162ada16$export$f1f2862ec6f674f7 = function convertToBetweenDates(_ref) {
    var unitValue = _ref.unitValue, timeUnit = _ref.timeUnit;
    // Set an error message if the parsed string is not a positive integer.
    var parsedVal = Number(unitValue);
    var isDecimal = parsedVal % 1 !== 0 || unitValue.includes('.');
    if (unitValue === '' || isNaN(parsedVal) || parsedVal < 0 || isDecimal) return null;
    // If we did not exit from errors, proceed to compute and store the date range.
    // At this point we can guarantee that unitValue is a number.
    var _getPastDate = $9159a798162ada16$export$9798fe0e3b26bbe6(Number(unitValue), timeUnit), _getPastDate2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_getPastDate, 2), start = _getPastDate2[0], end = _getPastDate2[1];
    return {
        startDate: String(start),
        endDate: String(end)
    };
};
var $9159a798162ada16$export$e94bddb708e1b5b7 = function convertStringToTimePeriod(timePeriodString) {
    var _matches$groups$minut, _matches$groups, _matches$groups$hours, _matches$groups2, _matches$groups$days, _matches$groups3, _matches$groups$weeks, _matches$groups4, _matches$groups5;
    var timePeriodRegEx = /*#__PURE__*/ $9159a798162ada16$var$_wrapRegExp(/^(?!$)(^-)?((\d+)w)? ?((\d+)d)? ?((\d+)h)? ?((\d+)m)?$/, {
        sign: 1,
        weeks: 3,
        days: 5,
        hours: 7,
        minutes: 9
    });
    var cleanTimePeriodString = timePeriodString !== null && timePeriodString !== void 0 ? timePeriodString : '';
    var matches = cleanTimePeriodString.match(timePeriodRegEx);
    var isIncompleteString = cleanTimePeriodString === '-';
    var isInvalidString = matches === null && cleanTimePeriodString !== '';
    if (isIncompleteString || isInvalidString) return null;
    var minutes = parseInt((_matches$groups$minut = matches === null || matches === void 0 || (_matches$groups = matches.groups) === null || _matches$groups === void 0 ? void 0 : _matches$groups.minutes) !== null && _matches$groups$minut !== void 0 ? _matches$groups$minut : '', 10);
    var hours = parseInt((_matches$groups$hours = matches === null || matches === void 0 || (_matches$groups2 = matches.groups) === null || _matches$groups2 === void 0 ? void 0 : _matches$groups2.hours) !== null && _matches$groups$hours !== void 0 ? _matches$groups$hours : '', 10);
    var days = parseInt((_matches$groups$days = matches === null || matches === void 0 || (_matches$groups3 = matches.groups) === null || _matches$groups3 === void 0 ? void 0 : _matches$groups3.days) !== null && _matches$groups$days !== void 0 ? _matches$groups$days : '', 10);
    var weeks = parseInt((_matches$groups$weeks = matches === null || matches === void 0 || (_matches$groups4 = matches.groups) === null || _matches$groups4 === void 0 ? void 0 : _matches$groups4.weeks) !== null && _matches$groups$weeks !== void 0 ? _matches$groups$weeks : '', 10);
    return {
        timePeriodString: cleanTimePeriodString,
        isBeforeNow: (matches === null || matches === void 0 || (_matches$groups5 = matches.groups) === null || _matches$groups5 === void 0 ? void 0 : _matches$groups5.sign) === '-',
        minutes: Number.isNaN(minutes) ? undefined : minutes,
        hours: Number.isNaN(hours) ? undefined : hours,
        days: Number.isNaN(days) ? undefined : days,
        weeks: Number.isNaN(weeks) ? undefined : weeks
    };
};
var $9159a798162ada16$export$60de5adecd09a061 = function convertTimePeriodToUnixMsTimeStamp(timePeriod) {
    var _timePeriod$minutes, _timePeriod$hours, _timePeriod$days, _timePeriod$weeks;
    var todayUnixTimestamp = new Date().getTime();
    var minutesOffset = ((_timePeriod$minutes = timePeriod.minutes) !== null && _timePeriod$minutes !== void 0 ? _timePeriod$minutes : 0) * (0, $289eb4eab502a333$export$82fa23ae93bbb468).m;
    var hoursOffset = ((_timePeriod$hours = timePeriod.hours) !== null && _timePeriod$hours !== void 0 ? _timePeriod$hours : 0) * (0, $289eb4eab502a333$export$82fa23ae93bbb468).h;
    var daysOffset = ((_timePeriod$days = timePeriod.days) !== null && _timePeriod$days !== void 0 ? _timePeriod$days : 0) * (0, $289eb4eab502a333$export$82fa23ae93bbb468).d;
    var weeksOffset = ((_timePeriod$weeks = timePeriod.weeks) !== null && _timePeriod$weeks !== void 0 ? _timePeriod$weeks : 0) * (0, $289eb4eab502a333$export$82fa23ae93bbb468).w;
    var offset = minutesOffset + hoursOffset + daysOffset + weeksOffset;
    var date = timePeriod.isBeforeNow ? new Date(todayUnixTimestamp - offset) : new Date(todayUnixTimestamp + offset);
    return date.getTime();
};
var $9159a798162ada16$export$27cc17b63a5387e5 = function convertRangeToBetweenDates(_ref2) {
    var startPeriod = _ref2.startPeriod, endPeriod = _ref2.endPeriod;
    var startTimePeriod = $9159a798162ada16$export$e94bddb708e1b5b7(startPeriod);
    var endTimePeriod = $9159a798162ada16$export$e94bddb708e1b5b7(endPeriod);
    var isBlankStart = (startTimePeriod === null || startTimePeriod === void 0 ? void 0 : startTimePeriod.timePeriodString) === '';
    var isBlankEnd = (endTimePeriod === null || endTimePeriod === void 0 ? void 0 : endTimePeriod.timePeriodString) === '';
    var isBlank = isBlankStart && isBlankEnd;
    var isInvalidFormat = startTimePeriod === null || endTimePeriod === null;
    if (isInvalidFormat || isBlank) return null;
    if (!startTimePeriod.isBeforeNow && !isBlankStart && isBlankEnd) return {
        startDate: String($9159a798162ada16$export$60de5adecd09a061(startTimePeriod)),
        endDate: undefined
    };
    return {
        startDate: startTimePeriod.timePeriodString === '' ? String(0) : String($9159a798162ada16$export$60de5adecd09a061(startTimePeriod)),
        endDate: String($9159a798162ada16$export$60de5adecd09a061(endTimePeriod))
    };
};



var $6bnW7 = parcelRequire("6bnW7");
var $3c506956d6b6235c$export$defe85febe8b728c = {
    WITHIN_THE_LAST: (0, $6bnW7.defineMessages)({
        minute: {
            id: 'admin-hub-filter.trigger.label.withinLast.min',
            defaultMessage: 'Within the last {value, plural, one {minute} other {# minutes}}',
            description: 'Label on the datetime filter trigger button when the filter is set to "within the last N minutes". The placeholder {value} is the number of minutes and controls the plural form.'
        },
        week: {
            id: 'admin-hub-filter.trigger.label.withinLast.week',
            defaultMessage: 'Within the last {value, plural, one {week} other {# weeks}}',
            description: 'Label on the datetime filter trigger button when the filter is set to "within the last N weeks". The placeholder {value} is the number of weeks and controls the plural form.'
        },
        day: {
            id: 'admin-hub-filter.trigger.label.withinLast.day',
            defaultMessage: 'Within the last {value, plural, one {day} other {# days}}',
            description: 'Label on the datetime filter trigger button when the filter is set to "within the last N days". The placeholder {value} is the number of days and controls the plural form.'
        },
        hour: {
            id: 'admin-hub-filter.trigger.label.withinLast.hour',
            defaultMessage: 'Within the last {value, plural, one {hour} other {# hours}}',
            description: 'Label on the datetime filter trigger button when the filter is set to "within the last N hours". The placeholder {value} is the number of hours and controls the plural form.'
        },
        unknown: {
            id: 'admin-hub-filter.trigger.label.withinLast.unknown',
            defaultMessage: 'Within the last {value}',
            description: 'default quantifier for within last. Should never be used.'
        }
    }),
    MORE_THAN: (0, $6bnW7.defineMessages)({
        minute: {
            id: 'admin-hub-filter.trigger.label.moreThan.min.non-final',
            defaultMessage: 'More than {value, plural, one {# minute} other {# minutes}} ago',
            description: 'quantifier for more than some minutes ago'
        },
        week: {
            id: 'admin-hub-filter.trigger.label.moreThan.week.non-final',
            defaultMessage: 'More than {value, plural, one {# week} other {# weeks}} ago',
            description: 'Label on the datetime filter trigger button when "more than N weeks ago" is selected. The placeholder {value} is the number of weeks and controls the plural form.'
        },
        day: {
            id: 'admin-hub-filter.trigger.label.moreThan.day.non-final',
            defaultMessage: 'More than {value, plural, one {# day} other {# days}} ago',
            description: 'Label on the datetime filter trigger button when "more than N days ago" is selected. The placeholder {value} is the number of days and controls the plural form.'
        },
        hour: {
            id: 'admin-hub-filter.trigger.label.moreThan.hour.non-final',
            defaultMessage: 'More than {value, plural, one {# hour} other {# hours}} ago',
            description: 'Label on the datetime filter trigger button when "more than N hours ago" is selected. The placeholder {value} is the number of hours and controls the plural form.'
        },
        unknown: {
            id: 'admin-hub-filter.trigger.label.moreThan.unknown.non-final',
            defaultMessage: 'More than {value} ago',
            description: 'default quantifier for more than. Should never be used.'
        }
    }),
    IN_TIME_RANGE: (0, $6bnW7.defineMessages)({
        beforeToBefore: {
            id: 'admin-hub-filter.trigger.label.inTimeRange.beforeNowToBeforeNow.non-final',
            defaultMessage: 'From {start} ago to {end} ago',
            description: 'Label on the datetime filter trigger button for a past-to-past time range. The placeholders {start} and {end} are the resolved time offsets (e.g. "3 days").'
        },
        beforeToAfter: {
            id: 'admin-hub-filter.trigger.label.inTimeRange.beforeNowToAfterNow.non-final',
            defaultMessage: 'From {start} ago to {end} from now',
            description: 'quantifier for past time to future time range'
        },
        beforeToBlank: {
            id: 'admin-hub-filter.trigger.label.inTimeRange.beforeToBlank.non-final',
            defaultMessage: 'From {start} ago',
            description: 'quantifier for past time to future time range'
        },
        afterToAfter: {
            id: 'admin-hub-filter.trigger.label.inTimeRange.afterNowToAfterNow.non-final',
            defaultMessage: 'From {start} from now to {end} from now',
            description: 'Label on the datetime filter trigger button for a future-to-future time range. The placeholders {start} and {end} are the resolved time offsets from now (e.g. "2 weeks").'
        },
        afterToBlank: {
            id: 'admin-hub-filter.trigger.label.inTimeRange.afterNowtoBlank.non-final',
            defaultMessage: 'From {start} from now',
            description: 'Label on the datetime filter trigger button for a future-to-future time range. The placeholders {start} and {end} are the resolved time offsets from now (e.g. "2 weeks").'
        },
        blankToAfter: {
            id: 'admin-hub-filter.trigger.label.inTimeRange.blankToAfterNow.non-final',
            defaultMessage: 'Up to {end} from now',
            description: 'Label on the datetime filter trigger button for a future-only upper-bound range. The placeholder {end} is the resolved time offset from now (e.g. "2 weeks").'
        },
        blankToBefore: {
            id: 'admin-hub-filter.trigger.label.inTimeRange.blankToBefore.non-final',
            defaultMessage: 'Up to {end} ago',
            description: 'Label on the datetime filter trigger button for a past-only upper-bound range. The placeholder {end} is the resolved time offset in the past (e.g. "5 days").'
        },
        unknown: {
            id: 'admin-hub-filter.trigger.label.inTimeRange.unknown.non-final',
            defaultMessage: 'From {start} to {end}',
            description: 'default quantifier for in time range. Should never be used.'
        },
        timeInMinutes: {
            id: 'admin-hub-filter.trigger.label.timeInMinutes.non-final',
            defaultMessage: '{value, plural, one {# minute} other {# minutes}}',
            description: 'Formatted time duration in minutes used as an interpolated value in other datetime filter labels. The placeholder {value} controls the plural form (one vs. other).'
        },
        timeInWeeks: {
            id: 'admin-hub-filter.trigger.label.timeInWeeks.non-final',
            defaultMessage: '{value, plural, one {# week} other {# weeks}}',
            description: 'Formatted time duration in weeks used as an interpolated value in other datetime filter labels. The placeholder {value} controls the plural form (one vs. other).'
        },
        timeInHours: {
            id: 'admin-hub-filter.trigger.label.timeInHours.non-final',
            defaultMessage: '{value, plural, one {# hour} other {# hours}}',
            description: 'Formatted time duration in hours used as an interpolated value in other datetime filter labels. The placeholder {value} controls the plural form (one vs. other).'
        },
        timeInDays: {
            id: 'admin-hub-filter.trigger.label.timeInDays.non-final',
            defaultMessage: '{value, plural, one {# day} other {# days}}',
            description: 'Formatted time duration in days used as an interpolated value in other datetime filter labels. The placeholder {value} controls the plural form (one vs. other).'
        }
    })
};


var $8e9a488dd3812b69$var$timeUnitToMessage = function timeUnitToMessage(unit, filterType) {
    switch(unit){
        case 'h':
            return (0, $3c506956d6b6235c$export$defe85febe8b728c)[filterType].hour;
        case 'm':
            return (0, $3c506956d6b6235c$export$defe85febe8b728c)[filterType].minute;
        case 'w':
            return (0, $3c506956d6b6235c$export$defe85febe8b728c)[filterType].week;
        case 'd':
            return (0, $3c506956d6b6235c$export$defe85febe8b728c)[filterType].day;
        default:
            return (0, $3c506956d6b6235c$export$defe85febe8b728c)[filterType].unknown;
    }
};
var $8e9a488dd3812b69$var$timeRangeToMessage = function timeRangeToMessage(start, end) {
    if (start.timePeriodString === '' && end.isBeforeNow) return (0, $3c506956d6b6235c$export$defe85febe8b728c).IN_TIME_RANGE.blankToBefore;
    if (start.timePeriodString === '' && !end.isBeforeNow) return (0, $3c506956d6b6235c$export$defe85febe8b728c).IN_TIME_RANGE.blankToAfter;
    if (start.isBeforeNow && end.timePeriodString === '') return (0, $3c506956d6b6235c$export$defe85febe8b728c).IN_TIME_RANGE.beforeToBlank;
    if (!start.isBeforeNow && end.timePeriodString === '') return (0, $3c506956d6b6235c$export$defe85febe8b728c).IN_TIME_RANGE.afterToBlank;
    if (start.isBeforeNow && end.isBeforeNow) return (0, $3c506956d6b6235c$export$defe85febe8b728c).IN_TIME_RANGE.beforeToBefore;
    if (start.isBeforeNow && !end.isBeforeNow) return (0, $3c506956d6b6235c$export$defe85febe8b728c).IN_TIME_RANGE.beforeToAfter;
    if (!start.isBeforeNow && !end.isBeforeNow) return (0, $3c506956d6b6235c$export$defe85febe8b728c).IN_TIME_RANGE.afterToAfter;
    return (0, $3c506956d6b6235c$export$defe85febe8b728c).IN_TIME_RANGE.unknown;
};
var $8e9a488dd3812b69$export$a0b4e36f606aa66f = function DynamicLabel(_ref) {
    var triggerLabel = _ref.triggerLabel, selectedDates = _ref.selectedDates, isPickerOpen = _ref.isPickerOpen;
    var _useIntl = (0, $hrVKU.default)(), formatMessage = _useIntl.formatMessage;
    var styledTriggerLabel = isPickerOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("b", null, triggerLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, triggerLabel);
    var getTimeString = function getTimeString(timePeriod) {
        return [
            timePeriod.weeks !== undefined ? formatMessage((0, $3c506956d6b6235c$export$defe85febe8b728c).IN_TIME_RANGE.timeInWeeks, {
                value: timePeriod.weeks
            }) : false,
            timePeriod.days !== undefined ? formatMessage((0, $3c506956d6b6235c$export$defe85febe8b728c).IN_TIME_RANGE.timeInDays, {
                value: timePeriod.days
            }) : false,
            timePeriod.hours !== undefined ? formatMessage((0, $3c506956d6b6235c$export$defe85febe8b728c).IN_TIME_RANGE.timeInHours, {
                value: timePeriod.hours
            }) : false,
            timePeriod.minutes !== undefined ? formatMessage((0, $3c506956d6b6235c$export$defe85febe8b728c).IN_TIME_RANGE.timeInMinutes, {
                value: timePeriod.minutes
            }) : false
        ].filter(Boolean).join(', ');
    };
    if (!selectedDates) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, triggerLabel);
    switch(selectedDates.filterType){
        case 0, $289eb4eab502a333$export$3eb32c07c48a482:
            var _selectedDates$within, _selectedDates$within2;
            var withinTheLastUnitValue = (_selectedDates$within = selectedDates.withinTheLast) === null || _selectedDates$within === void 0 ? void 0 : _selectedDates$within.unitValue;
            var withinTheLastTimeUnit = (_selectedDates$within2 = selectedDates.withinTheLast) === null || _selectedDates$within2 === void 0 ? void 0 : _selectedDates$within2.timeUnit;
            if (!withinTheLastUnitValue || !withinTheLastTimeUnit) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, triggerLabel);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, styledTriggerLabel, ":", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, $8e9a488dd3812b69$var$timeUnitToMessage(withinTheLastTimeUnit, (0, $289eb4eab502a333$export$3eb32c07c48a482)), {
                values: {
                    value: withinTheLastUnitValue
                }
            })));
        case 0, $289eb4eab502a333$export$1d6ceeecb2c7a18d:
            var _selectedDates$moreTh, _selectedDates$moreTh2;
            var moreThanUnitValue = (_selectedDates$moreTh = selectedDates.moreThan) === null || _selectedDates$moreTh === void 0 ? void 0 : _selectedDates$moreTh.unitValue;
            var moreThanTimeUnit = (_selectedDates$moreTh2 = selectedDates.moreThan) === null || _selectedDates$moreTh2 === void 0 ? void 0 : _selectedDates$moreTh2.timeUnit;
            if (!moreThanUnitValue || !moreThanTimeUnit) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, triggerLabel);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, styledTriggerLabel, ":", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, $8e9a488dd3812b69$var$timeUnitToMessage(moreThanTimeUnit, (0, $289eb4eab502a333$export$1d6ceeecb2c7a18d)), {
                values: {
                    value: moreThanUnitValue
                }
            })));
        case 0, $4d293f787d49bb57$export$e54cb950486aac3c:
            var _selectedDates$inTime, _selectedDates$inTime2;
            var startPeriod = (0, $9159a798162ada16$export$e94bddb708e1b5b7)((_selectedDates$inTime = selectedDates.inTimeRange) === null || _selectedDates$inTime === void 0 ? void 0 : _selectedDates$inTime.startPeriod);
            var endPeriod = (0, $9159a798162ada16$export$e94bddb708e1b5b7)((_selectedDates$inTime2 = selectedDates.inTimeRange) === null || _selectedDates$inTime2 === void 0 ? void 0 : _selectedDates$inTime2.endPeriod);
            var isBlank = (startPeriod === null || startPeriod === void 0 ? void 0 : startPeriod.timePeriodString) === '' && (endPeriod === null || endPeriod === void 0 ? void 0 : endPeriod.timePeriodString) === '';
            var isInvalid = startPeriod === null || endPeriod === null;
            if (isInvalid || isBlank) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, triggerLabel);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, styledTriggerLabel, ":", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, $8e9a488dd3812b69$var$timeRangeToMessage(startPeriod, endPeriod), {
                values: {
                    start: getTimeString(startPeriod),
                    end: getTimeString(endPeriod)
                }
            })));
        case 0, $380570a298df429f$export$23a3939f30e96d0d:
            var _selectedDates$betwee, _selectedDates$betwee2;
            var startDate = (_selectedDates$betwee = selectedDates.betweenDates) === null || _selectedDates$betwee === void 0 ? void 0 : _selectedDates$betwee.startDate;
            var endDate = (_selectedDates$betwee2 = selectedDates.betweenDates) === null || _selectedDates$betwee2 === void 0 ? void 0 : _selectedDates$betwee2.endDate;
            if (!startDate && !endDate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, triggerLabel);
            var start = startDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6bnW7.FormattedDate), {
                value: (0, $9159a798162ada16$export$8cf53058824d30eb)(startDate)
            }) : null;
            var end = endDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6bnW7.FormattedDate), {
                value: (0, $9159a798162ada16$export$8cf53058824d30eb)(endDate)
            }) : null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, styledTriggerLabel, ": ", start, start && end && ' - ', end);
        default:
            return styledTriggerLabel;
    }
};


/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $25nEq = parcelRequire("25nEq");


var $5FkrB = parcelRequire("5FkrB");

var $kuWWJ = parcelRequire("kuWWJ");

var $bgNpv = parcelRequire("bgNpv");
var $hrVKU = parcelRequire("hrVKU");
/* date-picker.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $4bFFZ = parcelRequire("4bFFZ");
function $70a4b20ef6a52e56$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}


function $b04852a58acb2d74$export$2e2bcd8739ae039(value) {
    (0, $70a4b20ef6a52e56$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $4bFFZ.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}



var $4bFFZ = parcelRequire("4bFFZ");

function $a03aa00843c0bb6b$export$2e2bcd8739ae039(argument) {
    (0, $70a4b20ef6a52e56$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $4bFFZ.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $4ddee9e0d8965130$export$2e2bcd8739ae039(dirtyDate) {
    (0, $70a4b20ef6a52e56$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $b04852a58acb2d74$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $a03aa00843c0bb6b$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}

/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $cd16919d0b40c529$export$dfd9b671c89acc8e = 7;
var $cd16919d0b40c529$export$3913210603d8e9ae = 365.2425;
var $cd16919d0b40c529$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $cd16919d0b40c529$export$91246f0b9bd9beff = 60000;
var $cd16919d0b40c529$export$7f72910d6dfd237a = 3600000;
var $cd16919d0b40c529$export$397c2d5776aa9055 = 1000;
var $cd16919d0b40c529$export$4dec998e48f9c246 = -$cd16919d0b40c529$export$81caae6e1cc7a622;
var $cd16919d0b40c529$export$f2f5ae5a8e2d8f9f = 60;
var $cd16919d0b40c529$export$3c58128db900d44e = 3;
var $cd16919d0b40c529$export$80d7e435f744f319 = 12;
var $cd16919d0b40c529$export$4db7641526e3241f = 4;
var $cd16919d0b40c529$export$698aec755e92c695 = 3600;
var $cd16919d0b40c529$export$a77c1a7ebebe2a5a = 60;
var $cd16919d0b40c529$export$815a9362476d2fe3 = $cd16919d0b40c529$export$698aec755e92c695 * 24;
var $cd16919d0b40c529$export$34804a017b31e2fe = $cd16919d0b40c529$export$815a9362476d2fe3 * 7;
var $cd16919d0b40c529$export$7271e9e3478110d1 = $cd16919d0b40c529$export$815a9362476d2fe3 * $cd16919d0b40c529$export$3913210603d8e9ae;
var $cd16919d0b40c529$export$8e6600bbdee7dabb = $cd16919d0b40c529$export$7271e9e3478110d1 / 12;
var $cd16919d0b40c529$export$be1dccf2de902d31 = $cd16919d0b40c529$export$8e6600bbdee7dabb * 3;



function $acbf5f73d02defdc$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}


function $af26a0dfda6128df$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $70a4b20ef6a52e56$export$2e2bcd8739ae039)(1, arguments);
    var additionalDigits = (0, $acbf5f73d02defdc$export$2e2bcd8739ae039)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $af26a0dfda6128df$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $af26a0dfda6128df$var$parseYear(dateStrings.date, additionalDigits);
        date = $af26a0dfda6128df$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $af26a0dfda6128df$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $af26a0dfda6128df$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $af26a0dfda6128df$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $af26a0dfda6128df$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $af26a0dfda6128df$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $af26a0dfda6128df$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $af26a0dfda6128df$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($af26a0dfda6128df$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($af26a0dfda6128df$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($af26a0dfda6128df$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $af26a0dfda6128df$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $af26a0dfda6128df$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $af26a0dfda6128df$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($af26a0dfda6128df$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $af26a0dfda6128df$var$parseDateUnit(captures[1]);
    var month = $af26a0dfda6128df$var$parseDateUnit(captures[2]) - 1;
    var day = $af26a0dfda6128df$var$parseDateUnit(captures[3]);
    var week = $af26a0dfda6128df$var$parseDateUnit(captures[4]);
    var dayOfWeek = $af26a0dfda6128df$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$af26a0dfda6128df$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $af26a0dfda6128df$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$af26a0dfda6128df$var$validateDate(year, month, day) || !$af26a0dfda6128df$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $af26a0dfda6128df$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $af26a0dfda6128df$var$parseTime(timeString) {
    var captures = timeString.match($af26a0dfda6128df$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $af26a0dfda6128df$var$parseTimeUnit(captures[1]);
    var minutes = $af26a0dfda6128df$var$parseTimeUnit(captures[2]);
    var seconds = $af26a0dfda6128df$var$parseTimeUnit(captures[3]);
    if (!$af26a0dfda6128df$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $cd16919d0b40c529$export$7f72910d6dfd237a) + minutes * (0, $cd16919d0b40c529$export$91246f0b9bd9beff) + seconds * 1000;
}
function $af26a0dfda6128df$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $af26a0dfda6128df$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($af26a0dfda6128df$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$af26a0dfda6128df$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $cd16919d0b40c529$export$7f72910d6dfd237a) + minutes * (0, $cd16919d0b40c529$export$91246f0b9bd9beff));
}
function $af26a0dfda6128df$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $af26a0dfda6128df$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $af26a0dfda6128df$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $af26a0dfda6128df$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($af26a0dfda6128df$var$daysInMonths[month] || ($af26a0dfda6128df$var$isLeapYearIndex(year) ? 29 : 28));
}
function $af26a0dfda6128df$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($af26a0dfda6128df$var$isLeapYearIndex(year) ? 366 : 365);
}
function $af26a0dfda6128df$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $af26a0dfda6128df$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $af26a0dfda6128df$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}



var $aLEtb = parcelRequire("aLEtb");

var $5yfDB = parcelRequire("5yfDB");

var $hRJ5R = parcelRequire("hRJ5R");

var $h8qvJ = parcelRequire("h8qvJ");

var $j5dho = parcelRequire("j5dho");

var $bCpKE = parcelRequire("bCpKE");

var $50U6m = parcelRequire("50U6m");

var $auVZV = parcelRequire("auVZV");

var $78ORw = parcelRequire("78ORw");

var $25nEq = parcelRequire("25nEq");
function $b3efbabdf341a1f6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b3efbabdf341a1f6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b3efbabdf341a1f6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b3efbabdf341a1f6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b3efbabdf341a1f6$export$e618dc39ac9ad607(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = $b3efbabdf341a1f6$var$_objectSpread({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}


/**
 * This component is used to hide portions of Select component.
 */ var $b3ed50813e899a91$export$5e30e9a24d6c1203 = function EmptyComponent() {
    return null;
};


/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ // oxlint-disable-next-line @atlassian/no-restricted-imports




function $61a88fefdf8b3556$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $70a4b20ef6a52e56$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $a03aa00843c0bb6b$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $acbf5f73d02defdc$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $2c442fbfac0d69a4$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $70a4b20ef6a52e56$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $acbf5f73d02defdc$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $61a88fefdf8b3556$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $4233119b2b7d93e0$var$MILLISECONDS_IN_DAY = 86400000;
function $4233119b2b7d93e0$export$2e2bcd8739ae039(dirtyDate) {
    (0, $70a4b20ef6a52e56$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $a03aa00843c0bb6b$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $4233119b2b7d93e0$var$MILLISECONDS_IN_DAY) + 1;
}





function $f0279c201272a024$export$2e2bcd8739ae039(dirtyDate) {
    (0, $70a4b20ef6a52e56$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $a03aa00843c0bb6b$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $2c2d96ffb95257c5$export$2e2bcd8739ae039(dirtyDate) {
    (0, $70a4b20ef6a52e56$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $a03aa00843c0bb6b$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $f0279c201272a024$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $f0279c201272a024$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $876b4323e327f6ba$export$2e2bcd8739ae039(dirtyDate) {
    (0, $70a4b20ef6a52e56$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $2c2d96ffb95257c5$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $f0279c201272a024$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $f0a3f4796becbced$var$MILLISECONDS_IN_WEEK = 604800000;
function $f0a3f4796becbced$export$2e2bcd8739ae039(dirtyDate) {
    (0, $70a4b20ef6a52e56$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $a03aa00843c0bb6b$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $f0279c201272a024$export$2e2bcd8739ae039)(date).getTime() - (0, $876b4323e327f6ba$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $f0a3f4796becbced$var$MILLISECONDS_IN_WEEK) + 1;
}







var $9bf015016e4f3310$var$defaultOptions = {};
function $9bf015016e4f3310$export$430a3269e24b912e() {
    return $9bf015016e4f3310$var$defaultOptions;
}
function $9bf015016e4f3310$export$95365be1b0704abc(newOptions) {
    $9bf015016e4f3310$var$defaultOptions = newOptions;
}


function $e264ca9759b9f33f$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $70a4b20ef6a52e56$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $9bf015016e4f3310$export$430a3269e24b912e)();
    var weekStartsOn = (0, $acbf5f73d02defdc$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $a03aa00843c0bb6b$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $1561aad59e6b2871$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $70a4b20ef6a52e56$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $a03aa00843c0bb6b$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $9bf015016e4f3310$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $acbf5f73d02defdc$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $e264ca9759b9f33f$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $e264ca9759b9f33f$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $3ee11ef17f604ca8$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $70a4b20ef6a52e56$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $9bf015016e4f3310$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $acbf5f73d02defdc$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $1561aad59e6b2871$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $e264ca9759b9f33f$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $97b9cb523b787a79$var$MILLISECONDS_IN_WEEK = 604800000;
function $97b9cb523b787a79$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $70a4b20ef6a52e56$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $a03aa00843c0bb6b$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $e264ca9759b9f33f$export$2e2bcd8739ae039)(date, options).getTime() - (0, $3ee11ef17f604ca8$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $97b9cb523b787a79$var$MILLISECONDS_IN_WEEK) + 1;
}



function $f23e87a014807ce1$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $48173cd750a2feb6$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $48173cd750a2feb6$export$2e2bcd8739ae039 = $48173cd750a2feb6$var$formatters;


var $4cef721e48860bf2$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $4cef721e48860bf2$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $48173cd750a2feb6$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $1561aad59e6b2871$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $2c2d96ffb95257c5$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $48173cd750a2feb6$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $97b9cb523b787a79$export$2e2bcd8739ae039)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $f0a3f4796becbced$export$2e2bcd8739ae039)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $48173cd750a2feb6$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $4233119b2b7d93e0$export$2e2bcd8739ae039)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $4cef721e48860bf2$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $4cef721e48860bf2$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $4cef721e48860bf2$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $4cef721e48860bf2$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $4cef721e48860bf2$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $4cef721e48860bf2$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $48173cd750a2feb6$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $48173cd750a2feb6$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $48173cd750a2feb6$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $48173cd750a2feb6$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $48173cd750a2feb6$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $4cef721e48860bf2$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $4cef721e48860bf2$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $4cef721e48860bf2$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $4cef721e48860bf2$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $4cef721e48860bf2$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $4cef721e48860bf2$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $4cef721e48860bf2$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $4cef721e48860bf2$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $4cef721e48860bf2$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $4cef721e48860bf2$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $4cef721e48860bf2$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(minutes, 2);
}
function $4cef721e48860bf2$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $4cef721e48860bf2$var$formatTimezone(offset, dirtyDelimiter);
}
function $4cef721e48860bf2$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $f23e87a014807ce1$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $4cef721e48860bf2$export$2e2bcd8739ae039 = $4cef721e48860bf2$var$formatters;


var $7ea57f69439f3f00$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $7ea57f69439f3f00$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $7ea57f69439f3f00$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $7ea57f69439f3f00$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $7ea57f69439f3f00$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $7ea57f69439f3f00$var$timeLongFormatter(timePattern, formatLong));
};
var $7ea57f69439f3f00$var$longFormatters = {
    p: $7ea57f69439f3f00$var$timeLongFormatter,
    P: $7ea57f69439f3f00$var$dateTimeLongFormatter
};
var $7ea57f69439f3f00$export$2e2bcd8739ae039 = $7ea57f69439f3f00$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $1e958f34c1568341$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $f3b1738d8c44b5fe$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $f3b1738d8c44b5fe$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $f3b1738d8c44b5fe$export$c6cc36aa33304772(token) {
    return $f3b1738d8c44b5fe$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $f3b1738d8c44b5fe$export$c6b49d6dceb604a1(token) {
    return $f3b1738d8c44b5fe$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $f3b1738d8c44b5fe$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $d409e3eae2fd1b29$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $d409e3eae2fd1b29$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $d409e3eae2fd1b29$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $d409e3eae2fd1b29$export$2e2bcd8739ae039 = $d409e3eae2fd1b29$var$formatDistance;


function $bb1fa658d7fb084b$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $e0f53f86aa6eacd4$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $e0f53f86aa6eacd4$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $e0f53f86aa6eacd4$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $e0f53f86aa6eacd4$var$formatLong = {
    date: (0, $bb1fa658d7fb084b$export$2e2bcd8739ae039)({
        formats: $e0f53f86aa6eacd4$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $bb1fa658d7fb084b$export$2e2bcd8739ae039)({
        formats: $e0f53f86aa6eacd4$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $bb1fa658d7fb084b$export$2e2bcd8739ae039)({
        formats: $e0f53f86aa6eacd4$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $e0f53f86aa6eacd4$export$2e2bcd8739ae039 = $e0f53f86aa6eacd4$var$formatLong;


var $40a76f53870f418e$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $40a76f53870f418e$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $40a76f53870f418e$var$formatRelativeLocale[token];
};
var $40a76f53870f418e$export$2e2bcd8739ae039 = $40a76f53870f418e$var$formatRelative;


function $63da4b80b7ed24e3$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $0e50096a4a57d25c$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $0e50096a4a57d25c$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $0e50096a4a57d25c$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $0e50096a4a57d25c$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $0e50096a4a57d25c$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $0e50096a4a57d25c$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $0e50096a4a57d25c$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $0e50096a4a57d25c$var$localize = {
    ordinalNumber: $0e50096a4a57d25c$var$ordinalNumber,
    era: (0, $63da4b80b7ed24e3$export$2e2bcd8739ae039)({
        values: $0e50096a4a57d25c$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $63da4b80b7ed24e3$export$2e2bcd8739ae039)({
        values: $0e50096a4a57d25c$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $63da4b80b7ed24e3$export$2e2bcd8739ae039)({
        values: $0e50096a4a57d25c$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $63da4b80b7ed24e3$export$2e2bcd8739ae039)({
        values: $0e50096a4a57d25c$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $63da4b80b7ed24e3$export$2e2bcd8739ae039)({
        values: $0e50096a4a57d25c$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $0e50096a4a57d25c$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $0e50096a4a57d25c$export$2e2bcd8739ae039 = $0e50096a4a57d25c$var$localize;


function $64a9f2e39edce4a6$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $64a9f2e39edce4a6$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $64a9f2e39edce4a6$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $64a9f2e39edce4a6$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $64a9f2e39edce4a6$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $bc1011b9a68e32cf$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $b49e3ac28c0d0d46$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $b49e3ac28c0d0d46$var$parseOrdinalNumberPattern = /\d+/i;
var $b49e3ac28c0d0d46$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $b49e3ac28c0d0d46$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $b49e3ac28c0d0d46$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $b49e3ac28c0d0d46$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $b49e3ac28c0d0d46$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $b49e3ac28c0d0d46$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $b49e3ac28c0d0d46$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $b49e3ac28c0d0d46$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $b49e3ac28c0d0d46$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $b49e3ac28c0d0d46$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $b49e3ac28c0d0d46$var$match = {
    ordinalNumber: (0, $bc1011b9a68e32cf$export$2e2bcd8739ae039)({
        matchPattern: $b49e3ac28c0d0d46$var$matchOrdinalNumberPattern,
        parsePattern: $b49e3ac28c0d0d46$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $64a9f2e39edce4a6$export$2e2bcd8739ae039)({
        matchPatterns: $b49e3ac28c0d0d46$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b49e3ac28c0d0d46$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $64a9f2e39edce4a6$export$2e2bcd8739ae039)({
        matchPatterns: $b49e3ac28c0d0d46$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b49e3ac28c0d0d46$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $64a9f2e39edce4a6$export$2e2bcd8739ae039)({
        matchPatterns: $b49e3ac28c0d0d46$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b49e3ac28c0d0d46$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $64a9f2e39edce4a6$export$2e2bcd8739ae039)({
        matchPatterns: $b49e3ac28c0d0d46$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b49e3ac28c0d0d46$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $64a9f2e39edce4a6$export$2e2bcd8739ae039)({
        matchPatterns: $b49e3ac28c0d0d46$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $b49e3ac28c0d0d46$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $b49e3ac28c0d0d46$export$2e2bcd8739ae039 = $b49e3ac28c0d0d46$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $909a70def1cfb091$var$locale = {
    code: 'en-US',
    formatDistance: (0, $d409e3eae2fd1b29$export$2e2bcd8739ae039),
    formatLong: (0, $e0f53f86aa6eacd4$export$2e2bcd8739ae039),
    formatRelative: (0, $40a76f53870f418e$export$2e2bcd8739ae039),
    localize: (0, $0e50096a4a57d25c$export$2e2bcd8739ae039),
    match: (0, $b49e3ac28c0d0d46$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $909a70def1cfb091$export$2e2bcd8739ae039 = $909a70def1cfb091$var$locale;


var $4347dc865c1a8f6a$export$2e2bcd8739ae039 = (0, $909a70def1cfb091$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $ba980e91c8661518$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $ba980e91c8661518$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $ba980e91c8661518$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $ba980e91c8661518$var$doubleQuoteRegExp = /''/g;
var $ba980e91c8661518$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $ba980e91c8661518$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $70a4b20ef6a52e56$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $9bf015016e4f3310$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $4347dc865c1a8f6a$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $acbf5f73d02defdc$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $acbf5f73d02defdc$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $a03aa00843c0bb6b$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $4ddee9e0d8965130$export$2e2bcd8739ae039)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $1e958f34c1568341$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $2c442fbfac0d69a4$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($ba980e91c8661518$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $7ea57f69439f3f00$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($ba980e91c8661518$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $ba980e91c8661518$var$cleanEscapedString(substring);
        var formatter = (0, $4cef721e48860bf2$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $f3b1738d8c44b5fe$export$c6b49d6dceb604a1)(substring)) (0, $f3b1738d8c44b5fe$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $f3b1738d8c44b5fe$export$c6cc36aa33304772)(substring)) (0, $f3b1738d8c44b5fe$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($ba980e91c8661518$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $ba980e91c8661518$var$cleanEscapedString(input) {
    var matched = input.match($ba980e91c8661518$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($ba980e91c8661518$var$doubleQuoteRegExp, "'");
}


var $d197ac6d992b01c0$export$75032c84f56650eb = 'YYYY/MM/DD';


// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
var $9ef3ef18e75888d6$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
var $9ef3ef18e75888d6$var$v1tokens = Object.keys($9ef3ef18e75888d6$var$tokensMap).sort().reverse();
var $9ef3ef18e75888d6$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$9ef3ef18e75888d6$var$v1tokens.join('|') + '|.)', 'g');
function $9ef3ef18e75888d6$export$4d5430175be73d45(format) {
    var tokensCaptures = format.match($9ef3ef18e75888d6$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce(function(parsed, tokenString, index) {
        var v2token = $9ef3ef18e75888d6$var$tokensMap[tokenString];
        if (!v2token) {
            var escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        var endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            var filteredEscapedTextBuffer = parsed.escapedTextBuffer.map(function(token) {
                return token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token;
            }).filter(function(token) {
                return token !== "'";
            }).join('');
            parsed.formatBuffer.push("'".concat(filteredEscapedTextBuffer, "'"));
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}


var $351584cf12c08523$export$3ae94a2503e890a1 = function formatDate(value, di) {
    var formatDisplayLabel = di.formatDisplayLabel, dateFormat = di.dateFormat, l10n = di.l10n;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $d197ac6d992b01c0$export$75032c84f56650eb));
    var date = (0, $af26a0dfda6128df$export$2e2bcd8739ae039)(value);
    return dateFormat ? (0, $ba980e91c8661518$export$2e2bcd8739ae039)(date, (0, $9ef3ef18e75888d6$export$4d5430175be73d45)(dateFormat)) : l10n.formatDate(date);
};



var $iYJcE = parcelRequire("iYJcE");


function $1463e351df530bb7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $70a4b20ef6a52e56$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $a03aa00843c0bb6b$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(0, 0, 0, 0);
    return date;
}


function $a9b2cb21a0f63106$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? "0".concat(number).slice(-2) : "".concat(number);
}


var $74f7710237c74b20$export$38db26406d1a1ee2 = function getParsedISO(di) {
    var iso = di.iso;
    var _iso$split = iso.split('-'), _iso$split2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_iso$split, 3), year = _iso$split2[0], month = _iso$split2[1], date = _iso$split2[2];
    var newIso = iso;
    var parsedDate = parseInt(date, 10);
    var parsedMonth = parseInt(month, 10);
    var parsedYear = parseInt(year, 10);
    var lastDayInMonth = (0, $1463e351df530bb7$export$2e2bcd8739ae039)(new Date(parsedYear, parsedMonth - 1 // This needs to be -1, because the Date constructor expects an index of the given month
    )).getDate();
    if (lastDayInMonth < parsedDate) newIso = "".concat(parsedYear, "-").concat((0, $a9b2cb21a0f63106$export$a7de57e5b672ccdb)(parsedMonth), "-").concat((0, $a9b2cb21a0f63106$export$a7de57e5b672ccdb)(lastDayInMonth));
    else newIso = "".concat(parsedYear, "-").concat((0, $a9b2cb21a0f63106$export$a7de57e5b672ccdb)(parsedMonth), "-").concat((0, $a9b2cb21a0f63106$export$a7de57e5b672ccdb)(parsedDate));
    return newIso;
};


/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ // oxlint-disable-next-line @atlassian/no-restricted-imports
// This date was chosen to clearly show date and time formats (day > 12)
// e.g. 18/02/1993 vs. 2/18/1993 and 1:00 PM vs 13:00
var $316c9947d6a7b94c$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);


var $6199335cb0c628c1$export$d3f5c5e0a5023fa0 = function getPlaceholder(di) {
    var placeholder = di.placeholder, l10n = di.l10n;
    return placeholder || l10n.formatDate((0, $316c9947d6a7b94c$export$fff8babee5abe3e2));
};


// oxlint-disable-next-line @atlassian/no-restricted-imports
// oxlint-disable-next-line @atlassian/no-restricted-imports


function $7733e0da4d409b5f$export$77d5bc49fed7ef14(date) {
    return (0, $ba980e91c8661518$export$2e2bcd8739ae039)(date, (0, $9ef3ef18e75888d6$export$4d5430175be73d45)('YYYY-MM-DD'));
}


function $3e132d6967265931$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    var yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return (0, $7733e0da4d409b5f$export$77d5bc49fed7ef14)(new Date());
    return calendarValue;
}



/* indicators-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $25nEq = parcelRequire("25nEq");
/* indicators-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");
var $2601addfebe56e71$export$26417cabd806a658 = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};


var $bf49b07163a4a854$var$indicatorContainerStyles = null;
var $bf49b07163a4a854$export$d0ffd7e649cab6f = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $2601addfebe56e71$export$26417cabd806a658)(props, 'indicatorsContainer', {
        indicators: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $hUFig.cx)(className, xcss, '-IndicatorsContainer')
        ])
    }, innerProps), children);
};


/* multi-value-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");
var $cd801d0089070243$var$multiValueStyles = {
    root: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _1e0c1txw _1ul9ze3t _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _bfhk1j9a _p12f1osq _syazi7uo _3yq3glyw",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk15s3 _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
var $cd801d0089070243$export$cf9cf2a30a59265c = function MultiValueContainer(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isFocused = _ref.isFocused, isDisabled = _ref.isDisabled, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $cd801d0089070243$var$multiValueStyles.root,
            isDisabled && $cd801d0089070243$var$multiValueStyles.disabled,
            isFocused && $cd801d0089070243$var$multiValueStyles.focused,
            (0, $hUFig.cx)(className, xcss, '-multiValue')
        ])
    }), children);
};


/* select-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $d4c88289b5b8ffe4$var$containerStyles = {
    default: "_11c81d4k _kqswh2mm _lcxv1rj4 _1tn2fhey",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf"
};
var $d4c88289b5b8ffe4$export$446eebadefe1123b = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl, xcss = props.xcss;
    var _getStyleProps = (0, $2601addfebe56e71$export$26417cabd806a658)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), className = _getStyleProps.className, css = _getStyleProps.css;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $d4c88289b5b8ffe4$var$containerStyles.default,
            isRtl && $d4c88289b5b8ffe4$var$containerStyles.rtl,
            isDisabled && $d4c88289b5b8ffe4$var$containerStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-container')
        ]),
        style: css
    }, innerProps), children);
};


/* value-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $ISKn7 = parcelRequire("ISKn7");
var $dbd87443ed7c2f80$var$_process, $dbd87443ed7c2f80$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $dbd87443ed7c2f80$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($dbd87443ed7c2f80$var$_process = globalThis.process) === null || $dbd87443ed7c2f80$var$_process === void 0 || ($dbd87443ed7c2f80$var$_process = $dbd87443ed7c2f80$var$_process.env) === null || $dbd87443ed7c2f80$var$_process === void 0 ? void 0 : $dbd87443ed7c2f80$var$_process.JEST_WORKER_ID) !== undefined;
var $dbd87443ed7c2f80$var$DEBUG_MODE = !$dbd87443ed7c2f80$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($dbd87443ed7c2f80$var$_process2 = globalThis.process) === null || $dbd87443ed7c2f80$var$_process2 === void 0 || ($dbd87443ed7c2f80$var$_process2 = $dbd87443ed7c2f80$var$_process2.env) === null || $dbd87443ed7c2f80$var$_process2 === void 0 ? void 0 : $dbd87443ed7c2f80$var$_process2.NODE_ENV) !== 'production';
var $dbd87443ed7c2f80$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$dbd87443ed7c2f80$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $090c88ed1cc12d15$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $090c88ed1cc12d15$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
var $090c88ed1cc12d15$export$75f4a1454eff2805 = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';


var $54ac7888c04d14aa$export$b574c24e1e6490f5 = (0, $090c88ed1cc12d15$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $1697a3f341ef0bb4$export$92f8b531feaeb23d = (0, $090c88ed1cc12d15$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $3afc6fd7e01d4156$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $3afc6fd7e01d4156$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$3afc6fd7e01d4156$export$54ea85357b4e0159[0, $090c88ed1cc12d15$export$7e41b1b2bdee3f98] = $3afc6fd7e01d4156$export$54ea85357b4e0159[0, $090c88ed1cc12d15$export$7e41b1b2bdee3f98] || $3afc6fd7e01d4156$var$DEFAULT_PFF_GLOBAL;



var $0ee5c45d425e24d7$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $54ac7888c04d14aa$export$b574c24e1e6490f5) || (0, $1697a3f341ef0bb4$export$92f8b531feaeb23d);
function $0ee5c45d425e24d7$export$6333b6aff9fc6275(flagKey) {
    if ($0ee5c45d425e24d7$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $dbd87443ed7c2f80$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $090c88ed1cc12d15$export$407f05df8e3ce9f3), flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = (0, $3afc6fd7e01d4156$export$54ea85357b4e0159)[0, $090c88ed1cc12d15$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = (0, $3afc6fd7e01d4156$export$54ea85357b4e0159)[0, $090c88ed1cc12d15$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $ISKn7.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = (0, $3afc6fd7e01d4156$export$54ea85357b4e0159)[0, $090c88ed1cc12d15$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $9a15a8b9047bb706$export$b40ec24ac8275656(name) {
    return (0, $0ee5c45d425e24d7$export$6333b6aff9fc6275)(name);
}



var $e0549d3c091396af$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _y4ti12x7 _bozg12x7",
    verticalPaddingStandard: "_1q51v77o _85i5v77o",
    verticalPaddingTagUpliftMulti: "_1q511b66 _85i51b66",
    verticalPaddingTagUpliftCompactMulti: "_1q51v77o _85i5v77o",
    verticalPaddingCompactNonUplift: "_1q51ze3t _85i5ze3t",
    flex: "_1e0c1txw",
    flexWithGap: "_zulp1b66 _1e0c1txw _1n261g80"
};
var $e0549d3c091396af$export$4dc9f58ad9a1a000 = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue, isCompact = props.isCompact, xcss = props.xcss, controlShouldRenderValue = props.selectProps.controlShouldRenderValue;
    var _getStyleProps = (0, $2601addfebe56e71$export$26417cabd806a658)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    var ffTagUplifts = (0, $9a15a8b9047bb706$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts');
    var tagUpliftMultiVertical = ffTagUplifts && isMulti;
    var tagUpliftChipRow = ffTagUplifts && isMulti && hasValue && controlShouldRenderValue;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $e0549d3c091396af$var$valueContainerStyles.default,
            tagUpliftMultiVertical && isCompact && $e0549d3c091396af$var$valueContainerStyles.verticalPaddingTagUpliftCompactMulti,
            tagUpliftMultiVertical && !isCompact && $e0549d3c091396af$var$valueContainerStyles.verticalPaddingTagUpliftMulti,
            !tagUpliftMultiVertical && !isCompact && $e0549d3c091396af$var$valueContainerStyles.verticalPaddingStandard,
            !tagUpliftMultiVertical && isCompact && $e0549d3c091396af$var$valueContainerStyles.verticalPaddingCompactNonUplift,
            isMulti && hasValue && controlShouldRenderValue && $e0549d3c091396af$var$valueContainerStyles.flex,
            tagUpliftChipRow && $e0549d3c091396af$var$valueContainerStyles.flexWithGap,
            (0, $hUFig.cx)(className, xcss, '-ValueContainer')
        ]),
        style: css
    }, innerProps), children);
};


/* control.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");


var $a2f37cab13b48253$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkofajl _v564r5cv _1h6drsbi _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _15peftgi _1ke8ftgi _jaboglyw _1u6luvb6 _4cvxrsbi _123byq51 _d0altlke _irr3l4ek _1ogl1caj",
    defaultT26Shape: "_2rko1qi0",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsvyy1",
    disabled: "_1h6d187o _lcxvglyw _bfhk187o _1u6lfrlt",
    focused: "_1h6d1v1w _bfhkr01l _16qsvyy1 _1u6lvyy1 _4cvx1v1w _irr3r01l",
    subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
var $a2f37cab13b48253$var$Control = function Control(props) {
    var children = props.children, appearance = props.appearance, isCompact = props.isCompact, isDisabled = props.isDisabled, isFocused = props.isFocused, isInvalid = props.isInvalid, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen, xcss = props.xcss;
    var _getStyleProps = (0, $2601addfebe56e71$export$26417cabd806a658)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: innerRef,
        className: (0, $970q7.default)([
            $a2f37cab13b48253$var$styles.default,
            (0, $9a15a8b9047bb706$export$b40ec24ac8275656)('platform-dst-shape-theme-default') && $a2f37cab13b48253$var$styles.defaultT26Shape,
            isDisabled && $a2f37cab13b48253$var$styles.disabled,
            isInvalid && $a2f37cab13b48253$var$styles.invalid,
            isCompact && $a2f37cab13b48253$var$styles.compact,
            appearance === 'subtle' && $a2f37cab13b48253$var$styles.subtle,
            appearance === 'subtle' && isFocused && $a2f37cab13b48253$var$styles.subtleFocused,
            isFocused && $a2f37cab13b48253$var$styles.focused,
            appearance === 'none' && $a2f37cab13b48253$var$styles.none,
            (0, $hUFig.cx)(className, xcss, '-control')
        ]),
        style: css
    }, innerProps, {
        "aria-disabled": (0, $9a15a8b9047bb706$export$b40ec24ac8275656)('platform_dst_select_disabled_a11y_fix') ? undefined : isDisabled || undefined
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a2f37cab13b48253$export$2e2bcd8739ae039 = $a2f37cab13b48253$var$Control;


/* group.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $eed7c4dabefdcdc0$var$styles = {
    root: "_85i5u2gc _1q51u2gc"
};
var $eed7c4dabefdcdc0$var$Group = function Group(props) {
    var children = props.children, builtinCX = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, selectProps = props.selectProps, xcss = props.xcss;
    var _getStyleProps = (0, $2601addfebe56e71$export$26417cabd806a658)(props, 'group', {
        group: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $eed7c4dabefdcdc0$var$styles.root,
            (0, $hUFig.cx)(className, xcss, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className, '-Group')
        ])
    }), label && /*#__PURE__*/ $5FkrB.createElement(Heading, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, headingProps, {
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: builtinCX
    }), label), /*#__PURE__*/ $5FkrB.createElement("div", null, children));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$eed7c4dabefdcdc0$export$2e2bcd8739ae039 = $eed7c4dabefdcdc0$var$Group;


/* group-heading.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");


var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");
var $74ac0a27140dbd56$var$_excluded = [
    "className",
    "clearValue",
    "cx",
    "xcss",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue"
];
function $74ac0a27140dbd56$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $74ac0a27140dbd56$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $74ac0a27140dbd56$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $74ac0a27140dbd56$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $74ac0a27140dbd56$export$8e9fd4287627890c = function cleanCommonProps(props) {
    //className
    var className = props.className, clearValue = props.clearValue, cx = props.cx, xcss = props.xcss, getStyles = props.getStyles, getClassNames = props.getClassNames, getValue = props.getValue, hasValue = props.hasValue, isMulti = props.isMulti, isRtl = props.isRtl, options = props.options, selectOption = props.selectOption, selectProps = props.selectProps, setValue = props.setValue, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $74ac0a27140dbd56$var$_excluded);
    return $74ac0a27140dbd56$var$_objectSpread({}, innerProps);
};


var $090b4c9959dd11fa$var$_excluded = [
    "data"
];
var $090b4c9959dd11fa$var$headingStyles = null;
var $090b4c9959dd11fa$export$85c8b41a3cd87edc = function GroupHeading(props) {
    var xcss = props.xcss;
    var _cleanCommonProps = (0, $74ac0a27140dbd56$export$8e9fd4287627890c)(props), data = _cleanCommonProps.data, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_cleanCommonProps, $090b4c9959dd11fa$var$_excluded);
    var _getStyleProps = (0, $2601addfebe56e71$export$26417cabd806a658)(props, 'groupHeading', {
        'group-heading': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_11c8wadc _1e0c1ule _syazazsu _80om73ad _k48pwu06 _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $hUFig.cx)(className, xcss, '-group')
        ]),
        style: css
    }, innerProps));
};


/* clear-indicator.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $eNN4d = parcelRequire("eNN4d");

var $btdNC = parcelRequire("btdNC");

var $9f79b3d10303de95$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _1q51v77o _y4tiv77o _85i5v77o _bozgv77o"
};
var $9f79b3d10303de95$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1rpy _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf"
};
var $9f79b3d10303de95$export$ecf9cf59142dd54a = function ClearIndicator(props) {
    var innerProps = props.innerProps, _props$clearControlLa = props.clearControlLabel, clearControlLabel = _props$clearControlLa === void 0 ? 'clear' : _props$clearControlLa, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $2601addfebe56e71$export$26417cabd806a658)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $9f79b3d10303de95$var$clearIndicatorStyles.default,
            isCompact && $9f79b3d10303de95$var$clearIndicatorStyles.compact,
            (0, $hUFig.cx)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $btdNC.Pressable), {
        xcss: $9f79b3d10303de95$var$iconContainerStyles.root,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eNN4d))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
};


/* dropdown-indicator.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $h19KG = parcelRequire("h19KG");


var $m5IEn = parcelRequire("m5IEn");
var $btdNC = parcelRequire("btdNC");

var $cec302d41ffd5f8b$var$_excluded = [
    "aria-hidden"
];
var $cec302d41ffd5f8b$var$dropdownWrapperStyles = {
    root: "_1q5112x7 _y4ti12x7 _85i512x7 _bozg12x7"
};
// Reset styles for the voice-control <Pressable> so the chevron renders
// pixel-identical to the gate-off icon-in-a-div. Uses @atlaskit/css cssMap
// (aliased as strictCssMap) because Pressable's xcss prop requires that type.
var $cec302d41ffd5f8b$var$voiceControlPressableStyles = {
    root: "_1rjcidpf _18zridpf _1mouidpf _195gidpf _bfhk1j28 _1e0c1txw _4cvr1h6o"
};
// Inline size reset applied as a last resort (see the `style` prop docs on
// @atlaskit/primitives). Consumers ship global element selectors such as
// `& button { min-width: 149px }` (e.g. Jira Plans' hierarchy filter — see
// https://hello.jira.atlassian.cloud/jira/browse/JPO-42328) whose (class +
// element) specificity outranks the atomic single-class styles above, stretching
// this button and pushing the chevron toward the middle of the control. Inline
// styles outrank any selector, so the button always hugs the chevron and stays
// right-aligned like the gate-off icon-in-a-div.
var $cec302d41ffd5f8b$var$voiceControlPressableSizeReset = {
    minWidth: 0,
    width: 'auto'
};
var $cec302d41ffd5f8b$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syazazsu _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf",
    disabled: "_syaz1gmx"
};
var $cec302d41ffd5f8b$export$ec98719d3db7f2e4 = function DropdownIndicator(props) {
    var _props$innerProps = props.innerProps, innerProps = _props$innerProps === void 0 ? {} : _props$innerProps, children = props.children, isDisabled = props.isDisabled, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $2601addfebe56e71$export$26417cabd806a658)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    var ariaHidden = innerProps['aria-hidden'], restInnerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(innerProps, $cec302d41ffd5f8b$var$_excluded);
    var isVoiceControlAccessible = (0, $9a15a8b9047bb706$export$b40ec24ac8275656)('platform_dst_select_dropdown_voice_control');
    // Stable testid for the hoisted aria-hidden children wrapper (avoids parentElement in tests).
    var wrapperTestId = restInnerProps['data-testid'] ? "".concat(restInnerProps['data-testid'], "-children") : undefined;
    var voiceControlAccessibleIndicator = children ? /*#__PURE__*/ $5FkrB.createElement("div", {
        "aria-hidden": ariaHidden,
        "data-testid": wrapperTestId
    }, children) : /*#__PURE__*/ $5FkrB.createElement((0, $btdNC.Pressable), {
        tabIndex: -1,
        "aria-label": "toggle select menu",
        isDisabled: isDisabled,
        componentName: "DropdownIndicatorVoiceControl",
        xcss: $cec302d41ffd5f8b$var$voiceControlPressableStyles.root,
        style: $cec302d41ffd5f8b$var$voiceControlPressableSizeReset
    }, /*#__PURE__*/ $5FkrB.createElement((0, $m5IEn.Inline), {
        as: "span",
        xcss: $cec302d41ffd5f8b$var$dropdownWrapperStyles.root
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($h19KG))), {
        color: "currentColor",
        label: "open",
        size: "small"
    })));
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $cec302d41ffd5f8b$var$dropdownStyles.default,
            isDisabled && $cec302d41ffd5f8b$var$dropdownStyles.disabled,
            isCompact && $cec302d41ffd5f8b$var$dropdownStyles.compact,
            (0, $hUFig.cx)(className, xcss, '-indicatorContainer')
        ])
    }, restInnerProps, {
        "aria-hidden": isVoiceControlAccessible ? undefined : ariaHidden
    }), isVoiceControlAccessible ? voiceControlAccessibleIndicator : children !== null && children !== void 0 ? children : /*#__PURE__*/ $5FkrB.createElement((0, $m5IEn.Inline), {
        as: "span",
        xcss: $cec302d41ffd5f8b$var$dropdownWrapperStyles.root
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($h19KG))), {
        color: "currentColor",
        label: "open",
        size: "small"
    })));
};


/* loading-indicator.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $9ztDu = parcelRequire("9ztDu");

var $99e05c35d7ce9815$var$_excluded = [
    "innerProps",
    "isRtl",
    "size",
    "isCompact",
    "xcss"
];
function $99e05c35d7ce9815$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $99e05c35d7ce9815$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $99e05c35d7ce9815$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $99e05c35d7ce9815$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $99e05c35d7ce9815$var$loadingIndicatorStyles = {
    default: "_1q5112x7 _y4tiu2gc _85i512x7 _bozgu2gc",
    compact: "_1q51idpf _85i5idpf"
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $99e05c35d7ce9815$export$7c20be4c1d342248 = function LoadingIndicator(_ref) {
    var innerProps = _ref.innerProps, isRtl = _ref.isRtl, _ref$size = _ref.size, size = _ref$size === void 0 ? 4 : _ref$size, isCompact = _ref.isCompact, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $99e05c35d7ce9815$var$_excluded);
    var _getStyleProps = (0, $2601addfebe56e71$export$26417cabd806a658)($99e05c35d7ce9815$var$_objectSpread($99e05c35d7ce9815$var$_objectSpread({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $99e05c35d7ce9815$var$loadingIndicatorStyles.default,
            isCompact && $99e05c35d7ce9815$var$loadingIndicatorStyles.compact,
            (0, $hUFig.cx)(className, xcss, '-loadingIndicator')
        ])
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $9ztDu.default), {
        size: "small"
    }));
};


/* input.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");



var $4ec1d49e28fd0e6f$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName",
    "testId"
];
var $4ec1d49e28fd0e6f$var$inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
var $4ec1d49e28fd0e6f$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
var $4ec1d49e28fd0e6f$var$nativeInputStylesOld = null;
var $4ec1d49e28fd0e6f$var$nativeInputStyles = null;
var $4ec1d49e28fd0e6f$var$hidden = null;
var $4ec1d49e28fd0e6f$var$Input = function Input(props) {
    var builtinCX = props.cx, value = props.value, xcss = props.xcss, isMulti = props.isMulti;
    var _cleanCommonProps = (0, $74ac0a27140dbd56$export$8e9fd4287627890c)(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, testId = _cleanCommonProps.testId, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_cleanCommonProps, $4ec1d49e28fd0e6f$var$_excluded);
    var dataId = testId ? "".concat(testId, "-select--input") : null;
    var _getStyleProps = (0, $2601addfebe56e71$export$26417cabd806a658)(props, 'input', {
        'input-container': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    var ffTagUplifts = (0, $9a15a8b9047bb706$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts');
    if ((0, $9a15a8b9047bb706$export$b40ec24ac8275656)('platform_fix_input_component_styling')) return /*#__PURE__*/ $5FkrB.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $4ec1d49e28fd0e6f$var$inputStyles.root,
            isMulti && ffTagUplifts && $4ec1d49e28fd0e6f$var$inputStyles.labellingFFStyles,
            isDisabled && $4ec1d49e28fd0e6f$var$inputStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $4ec1d49e28fd0e6f$var$inputStylesOld.root,
            isMulti && ffTagUplifts && $4ec1d49e28fd0e6f$var$inputStylesOld.labellingFFStyles,
            isDisabled && $4ec1d49e28fd0e6f$var$inputStylesOld.disabled,
            (0, $hUFig.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4ec1d49e28fd0e6f$export$2e2bcd8739ae039 = $4ec1d49e28fd0e6f$var$Input;


/* menu.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");


var $edbf2144ff2d3eea$var$menuStyles = {
    root: "_2rko12b0 _kqswstnw _1bsb1osq _1pbykb7n _6rthu2gc _1pfhu2gc _bfhk1bhr _16qs130s",
    rootT26Shape: "_2rko1mok",
    bottom: "_152t1osq",
    top: "_u7co1osq"
};
var $edbf2144ff2d3eea$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottom' : _props$placement, xcss = props.xcss;
    var _getStyleProps = (0, $2601addfebe56e71$export$26417cabd806a658)(props, 'menu', {
        menu: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $edbf2144ff2d3eea$var$menuStyles.root,
            $edbf2144ff2d3eea$var$menuStyles[placement],
            (0, $9a15a8b9047bb706$export$b40ec24ac8275656)('platform-dst-shape-theme-default') && $edbf2144ff2d3eea$var$menuStyles.rootT26Shape,
            (0, $hUFig.cx)(xcss, className, '-menu')
        ]),
        style: css,
        ref: innerRef
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$edbf2144ff2d3eea$export$2e2bcd8739ae039 = $edbf2144ff2d3eea$var$Menu;


/* menu-list.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

function $eeecfc93b2054c92$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eeecfc93b2054c92$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eeecfc93b2054c92$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eeecfc93b2054c92$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $eeecfc93b2054c92$var$menuListStyles = null;
var $eeecfc93b2054c92$export$d4c4e98c5044dc8 = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti, maxHeight = props.maxHeight, xcss = props.xcss;
    var _getStyleProps = (0, $2601addfebe56e71$export$26417cabd806a658)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $hUFig.cx)(className, xcss, '-MenuList')
        ]),
        style: $eeecfc93b2054c92$var$_objectSpread($eeecfc93b2054c92$var$_objectSpread({}, css), {}, {
            maxHeight: maxHeight
        }),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};


/* menu-loading-message.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $72GAO = parcelRequire("72GAO");

var $56ff478e70f33c0d$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
];
function $56ff478e70f33c0d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $56ff478e70f33c0d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $56ff478e70f33c0d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $56ff478e70f33c0d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $56ff478e70f33c0d$var$noticeStyles = null;
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $56ff478e70f33c0d$export$e928a71d039d3102 = function LoadingMessage(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? 'Loading...' : _ref$children, innerProps = _ref.innerProps, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $56ff478e70f33c0d$var$_excluded);
    var _getStyleProps = (0, $2601addfebe56e71$export$26417cabd806a658)($56ff478e70f33c0d$var$_objectSpread($56ff478e70f33c0d$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $hUFig.cx)(className, xcss, '-LoadingMessage')
        ]),
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option"
    }), /*#__PURE__*/ $5FkrB.createElement((0, $72GAO.Text), {
        color: "color.text.subtle"
    }, children));
};


/* menu-no-options-message.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $72GAO = parcelRequire("72GAO");

var $70bca3ca2ec9fe2c$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
];
function $70bca3ca2ec9fe2c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $70bca3ca2ec9fe2c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $70bca3ca2ec9fe2c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $70bca3ca2ec9fe2c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $70bca3ca2ec9fe2c$var$noticeStyles = null;
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $70bca3ca2ec9fe2c$export$d58b72b7d3c4072c = function NoOptionsMessage(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? 'No options' : _ref$children, innerProps = _ref.innerProps, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $70bca3ca2ec9fe2c$var$_excluded);
    var _getStyleProps = (0, $2601addfebe56e71$export$26417cabd806a658)($70bca3ca2ec9fe2c$var$_objectSpread($70bca3ca2ec9fe2c$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $hUFig.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        style: css,
        role: "option"
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $72GAO.Text), {
        color: "color.text.subtle"
    }, children));
};


/* menu-portal.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $6I9SI = parcelRequire("6I9SI");

var $aLeHs = parcelRequire("aLeHs");



var $5FkrB = parcelRequire("5FkrB");
var $0fc0d1783c68fd27$export$e001f626511a0ead = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


/* menu-portal-top-layer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $309548f12679ffcf$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $c80d5176da1c23f7$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $464b356bcb4d53fd$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $c80d5176da1c23f7$export$644a49f3b8c50fcd));
    return namespace;
}


function $fb3d2710fcacd626$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $309548f12679ffcf$export$5fbf4d7fae6cdc00));
    var namespace = (0, $464b356bcb4d53fd$export$1d57e79091cc3046)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}


/* popover.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $hUFig = parcelRequire("hUFig");

var $7QpUe = parcelRequire("7QpUe");

var $iO8GM = parcelRequire("iO8GM");

var $bvsoE = parcelRequire("bvsoE");

/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $b90facb98b434df5$export$63b6b0ff65d84d47(_ref) {
    var value = _ref.value;
    if (typeof value === 'number') return "".concat(value, "px");
    return value;
}


/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ var $82926ccb1b7b6251$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $82926ccb1b7b6251$export$63044d21bc3d3fa2(_ref) {
    var _placement$offset, _placement$axis, _placement$edge, _placement$align, _placement$offset$cro, _placement$offset2, _placement$offset$cro2, _placement$offset3;
    var placement = _ref.placement;
    var consumerGap = (_placement$offset = placement.offset) === null || _placement$offset === void 0 ? void 0 : _placement$offset.gap;
    return {
        axis: (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block',
        edge: (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end',
        align: (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center',
        offset: {
            gap: consumerGap === undefined ? $82926ccb1b7b6251$var$DEFAULT_GAP : (0, $b90facb98b434df5$export$63b6b0ff65d84d47)({
                value: consumerGap
            }),
            crossAxisShift: {
                value: (0, $b90facb98b434df5$export$63b6b0ff65d84d47)({
                    value: (_placement$offset$cro = (_placement$offset2 = placement.offset) === null || _placement$offset2 === void 0 || (_placement$offset2 = _placement$offset2.crossAxisShift) === null || _placement$offset2 === void 0 ? void 0 : _placement$offset2.value) !== null && _placement$offset$cro !== void 0 ? _placement$offset$cro : 0
                }),
                direction: (_placement$offset$cro2 = (_placement$offset3 = placement.offset) === null || _placement$offset3 === void 0 || (_placement$offset3 = _placement$offset3.crossAxisShift) === null || _placement$offset3 === void 0 ? void 0 : _placement$offset3.direction) !== null && _placement$offset$cro2 !== void 0 ? _placement$offset$cro2 : 'forwards'
            }
        }
    };
}


var $6f5b9ff04d2efd44$var$rolesThatMoveFocus = new Set([
    'dialog',
    'alertdialog',
    'menu',
    'listbox',
    'tree',
    'grid'
]);
function $6f5b9ff04d2efd44$export$b12adccf56228c71(_ref) {
    var role = _ref.role;
    if (!role) return false;
    return $6f5b9ff04d2efd44$var$rolesThatMoveFocus.has(role);
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $bvsoE = parcelRequire("bvsoE");
var $21306724f2f85faa$export$ff7706047246b98b = (0, $bvsoE.default)(function() {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});


function $620e767e58d5f797$var$runCancellableSettlement(_ref) {
    var schedule = _ref.schedule, onSettled = _ref.onSettled;
    var isCancelled = false;
    schedule(function() {
        if (isCancelled) return;
        onSettled();
    });
    return function() {
        isCancelled = true;
    };
}
/**
 * Fires `onSettled` once all animations currently applied to `element`
 * finish or are cancelled. Returns a cleanup that prevents stale settlement.
 */ function $620e767e58d5f797$var$runOnAnimationsSettled(_ref2) {
    var element = _ref2.element, onSettled = _ref2.onSettled;
    return $620e767e58d5f797$var$runCancellableSettlement({
        onSettled: onSettled,
        schedule: function schedule(settle) {
            var _element$getAnimation, _element$getAnimation2;
            var animations = (_element$getAnimation = (_element$getAnimation2 = element.getAnimations) === null || _element$getAnimation2 === void 0 ? void 0 : _element$getAnimation2.call(element)) !== null && _element$getAnimation !== void 0 ? _element$getAnimation : [];
            Promise.allSettled(animations.map(function(animation) {
                return animation.finished;
            })).then(settle);
        }
    });
}
function $620e767e58d5f797$export$1bccb45daf07907f(_ref3) {
    var isOpen = _ref3.isOpen, shouldAnimate = _ref3.shouldAnimate, elementRef = _ref3.elementRef, onEnterFinish = _ref3.onEnterFinish, onExitFinish = _ref3.onExitFinish;
    var willAnimate = shouldAnimate && !(0, $21306724f2f85faa$export$ff7706047246b98b)();
    var isNativeClosedRef = (0, $5FkrB.useRef)(false);
    // Promote `closed → entering`/`closed → open` synchronously during
    // render so the host element mounts in the same commit as the open
    // intent. All other transitions are driven by phase-specific effects.
    var _useState = (0, $5FkrB.useState)(function() {
        if (!isOpen) return 'closed';
        return willAnimate ? 'entering' : 'open';
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), phase = _useState2[0], setPhase = _useState2[1];
    // Rearm only after controlled state and the native lifecycle have both
    // reached closed. Resetting as soon as `isOpen` becomes false can erase a
    // closing toggle that was handled in the same React batch.
    if (!isOpen && phase === 'closed') isNativeClosedRef.current = false;
    if (isOpen && phase === 'closed' && !isNativeClosedRef.current) setPhase(willAnimate ? 'entering' : 'open');
    if (!isOpen && (phase === 'open' || phase === 'entering')) // Close intent. Move to `exiting` to gate the unmount on either
    // the exit transition (animated) or the closing toggle event
    // (non-animated). Includes interrupted entry (`entering → exiting`).
    setPhase('exiting');
    if (isOpen && phase === 'exiting' && !isNativeClosedRef.current) // Reopen mid-exit. With animation, jump back to `entering` and let
    // the entry transition restart from current visual state. Without
    // animation, jump straight to `open` (the handshake we were waiting
    // for is no longer relevant; the consumer wants the host visible
    // again synchronously).
    setPhase(willAnimate ? 'entering' : 'open');
    // Keep stable refs to the latest callbacks so effects and promise callbacks
    // always call the current callback without needing them in dependency arrays.
    var onEnterFinishRef = (0, $5FkrB.useRef)(onEnterFinish);
    onEnterFinishRef.current = onEnterFinish;
    var onExitFinishRef = (0, $5FkrB.useRef)(onExitFinish);
    onExitFinishRef.current = onExitFinish;
    // Animated entry: wait for all active animations and move to `open`.
    (0, $5FkrB.useEffect)(function() {
        if (phase !== 'entering') return;
        var element = elementRef.current;
        if (!element) return;
        return $620e767e58d5f797$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                var _onEnterFinishRef$cur;
                // Fire the consumer callback before transitioning phase so any
                // state the consumer reads (refs, DOM nodes) is still attached
                // in the same synchronous tick, regardless of React batching
                // semantics.
                (_onEnterFinishRef$cur = onEnterFinishRef.current) === null || _onEnterFinishRef$cur === void 0 || _onEnterFinishRef$cur.call(onEnterFinishRef);
                setPhase(function(current) {
                    return current === 'entering' ? 'open' : current;
                });
            }
        });
    }, [
        phase,
        elementRef
    ]);
    // Non-animated entry callback. The lifecycle goes `closed → open`
    // directly with no `entering` phase; fire `onEnterFinish` on that jump.
    // A previous-phase ref avoids double-firing on the animated path.
    var prevPhaseForEntryRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForEntryRef.current;
        prevPhaseForEntryRef.current = phase;
        // Animated entry settle goes through `entering` and already fired
        // onEnterFinish above; only handle the non-animated direct jumps.
        if (prevPhase !== 'open' && phase === 'open' && prevPhase !== 'entering') {
            var _onEnterFinishRef$cur2;
            (_onEnterFinishRef$cur2 = onEnterFinishRef.current) === null || _onEnterFinishRef$cur2 === void 0 || _onEnterFinishRef$cur2.call(onEnterFinishRef);
        }
    }, [
        phase
    ]);
    // Animated exit: wait for all active animations, fire `onExitFinish`,
    // then move to `closed` to unmount the host.
    (0, $5FkrB.useEffect)(function() {
        if (phase !== 'exiting' || !willAnimate) return;
        var element = elementRef.current;
        if (!element) return;
        return $620e767e58d5f797$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                var _onExitFinishRef$curr;
                // Fire the consumer callback before transitioning phase to
                // `closed`. The phase change drives the host element unmount,
                // and consumers expect to be able to read the element (or a
                // forwarded ref to it) inside `onExitFinish`. Doing this in
                // the safe order avoids relying on React's automatic batching
                // to keep the element attached across the callback.
                (_onExitFinishRef$curr = onExitFinishRef.current) === null || _onExitFinishRef$curr === void 0 || _onExitFinishRef$curr.call(onExitFinishRef);
                setPhase(function(current) {
                    return current === 'exiting' ? 'closed' : current;
                });
            }
        });
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    // Native dismissal is authoritative. Its toggle can arrive while controlled
    // state still says open, so remember that native state and do not
    // reopen until `isOpen` has first moved to false.
    (0, $5FkrB.useLayoutEffect)(function() {
        if (phase === 'exiting' && !willAnimate && isNativeClosedRef.current) setPhase('closed');
    }, [
        phase,
        willAnimate
    ]);
    var onToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState === 'open') {
            isNativeClosedRef.current = false;
            return;
        }
        if (event.newState !== 'closed') return;
        isNativeClosedRef.current = true;
        setPhase(function(current) {
            if (current === 'open' || current === 'entering') return 'exiting';
            if (current === 'exiting' && !willAnimate) return 'closed';
            return current;
        });
    }, [
        willAnimate
    ]);
    // Non-animated exit callback. There are no animations to wait for, so fire
    // `onExitFinish` on the transition into `exiting` (the unmount itself
    // is gated by the closing toggle handshake above).
    var prevPhaseForExitRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForExitRef.current;
        prevPhaseForExitRef.current = phase;
        // Only fire on the non-animated transition into `exiting`. The
        // animated path's `exiting → closed` settle already fires
        // `onExitFinish` from `runOnAnimationsSettled`.
        if (prevPhase !== 'exiting' && phase === 'exiting' && !willAnimate) {
            var _onExitFinishRef$curr2;
            (_onExitFinishRef$curr2 = onExitFinishRef.current) === null || _onExitFinishRef$curr2 === void 0 || _onExitFinishRef$curr2.call(onExitFinishRef);
        }
    }, [
        phase,
        willAnimate
    ]);
    return {
        phase: phase,
        onToggle: onToggle
    };
}



var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
var $4bf3ccb43411f5b2$var$topLayerSelector = '[popover], dialog, [role="dialog"], [role="alertdialog"]';
function $4bf3ccb43411f5b2$export$df8c72c64edc7260(_ref) {
    var element = _ref.element, container = _ref.container;
    return element.closest($4bf3ccb43411f5b2$var$topLayerSelector) === container.closest($4bf3ccb43411f5b2$var$topLayerSelector);
}


var $4eb24b94c08791e5$export$e1252723db1c541 = function() {
    // Common exclusion filter applied to every selector.
    var not = ':not([tabindex="-1"]):not([aria-disabled="true"]):not([aria-hidden="true"])';
    var notDisabled = ":not([disabled])".concat(not);
    var focusable = [
        "a[href]".concat(not),
        "area[href]".concat(not),
        "input".concat(notDisabled, ":not([type=\"hidden\"])"),
        "select".concat(notDisabled),
        "textarea".concat(notDisabled),
        "button".concat(notDisabled),
        "iframe".concat(not),
        "audio[controls]".concat(not),
        "video[controls]".concat(not),
        "[contenteditable]:not([contenteditable=\"false\"])".concat(not),
        "[tabindex]".concat(notDisabled)
    ];
    return {
        focusable: focusable.join(','),
        // Build the `:focus` selector
        focused: focusable.map(function(selector) {
            return "".concat(selector, ":focus");
        }).join(',')
    };
}();


function $294fdc987b393fdb$export$f6768025e418420e(_ref) {
    var container = _ref.container, filter = _ref.filter;
    return Array.from(container.querySelectorAll((0, $4eb24b94c08791e5$export$e1252723db1c541).focusable)).filter(function(element) {
        return element instanceof HTMLElement;
    }).filter(function(element) {
        return (0, $4bf3ccb43411f5b2$export$df8c72c64edc7260)({
            element: element,
            container: container
        });
    }).filter(function(element) {
        return !filter || filter(element, container);
    });
}


function $11d3fc76319d7811$export$748138f04a69bf21(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $294fdc987b393fdb$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}



function $75f8c1fedeaabf5c$export$73e81fa65335a75b(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $294fdc987b393fdb$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}


/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * Returns `null` if there is no focused element within the container or if
 * the focused element is not in the list of focusable elements.
 */ 

function $ec576d04ad289e44$export$a7db88e6d491b450(_ref) {
    var _all$nextIndex;
    var container = _ref.container, direction = _ref.direction, filter = _ref.filter;
    var all = (0, $294fdc987b393fdb$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    var current = container.querySelector((0, $4eb24b94c08791e5$export$e1252723db1c541).focused);
    if (!(current instanceof HTMLElement)) return null;
    var index = all.indexOf(current);
    if (index === -1) return null;
    var nextIndex = function() {
        if (direction === 'forwards') return (index + 1) % all.length;
        var proposed = index - 1;
        // if going into negative numbers, loop back to the last item
        return proposed < 0 ? all.length - 1 : proposed;
    }();
    return (_all$nextIndex = all[nextIndex]) !== null && _all$nextIndex !== void 0 ? _all$nextIndex : null;
}



var $lFhdZ = parcelRequire("lFhdZ");

function $6fe1a1d07cf32a95$export$b9590fdfeb5f722f(_ref) {
    var _getDocument;
    var container = _ref.container;
    var focused = (_getDocument = (0, $lFhdZ.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return !(0, $4bf3ccb43411f5b2$export$df8c72c64edc7260)({
        element: focused,
        container: container
    });
}


/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/outputs/menu-keyboard-decision.md
 */ function $16fde60aa22a13c1$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $16fde60aa22a13c1$export$4f6462e86a70abe5(_ref) {
    var elementRef = _ref.elementRef, role = _ref.role, phase = _ref.phase;
    var isVisible = phase !== 'closed';
    (0, $5FkrB.useEffect)(function() {
        var element = elementRef.current;
        if (!element || !$16fde60aa22a13c1$var$roleRequiresFocusWrap(role) || !isVisible) return;
        var unbind = (0, $7QpUe.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $6fe1a1d07cf32a95$export$b9590fdfeb5f722f)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                var direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                var next = (0, $ec576d04ad289e44$export$a7db88e6d491b450)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                var fallback = direction === 'forwards' ? (0, $11d3fc76319d7811$export$748138f04a69bf21)({
                    container: element
                }) : (0, $75f8c1fedeaabf5c$export$73e81fa65335a75b)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}



var $5FkrB = parcelRequire("5FkrB");

/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox regardless of role. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, or menu), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
var $9184d5e5333cd646$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $9184d5e5333cd646$var$isTextboxLikeElement(element) {
    var role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    var tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        var _element$getAttribute;
        var type = ((_element$getAttribute = element.getAttribute('type')) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : 'text').toLowerCase();
        return $9184d5e5333cd646$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $9184d5e5333cd646$var$isComboboxControllingPopup(_ref) {
    var _active$getAttribute;
    var container = _ref.container;
    var ownerDocument = container.ownerDocument;
    var active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$9184d5e5333cd646$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    var idRefs = (_active$getAttribute = active.getAttribute('aria-controls')) !== null && _active$getAttribute !== void 0 ? _active$getAttribute : active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    var referencedIds = idRefs.split(/\s+/).filter(function(id) {
        return id !== '';
    });
    return referencedIds.some(function(id) {
        var referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function $9184d5e5333cd646$var$getInitialFocusTarget(_ref2) {
    var container = _ref2.container, role = _ref2.role;
    if (role === 'dialog' || role === 'alertdialog') {
        // Prefer element with the native HTML autofocus attribute.
        var autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $11d3fc76319d7811$export$748138f04a69bf21)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific (menu / listbox) rather
    // than hoisted. Hoisting it over-matched on dialog popups that contain
    // a nested combobox (e.g. datetime-picker's dialog hosts a react-select),
    // where the active combobox's `aria-controls` falsely matched the
    // container and suppressed the dialog's own focus contract.
    if (role === 'menu') {
        if ($9184d5e5333cd646$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/outputs/menu-keyboard-decision.md
        return (0, $11d3fc76319d7811$export$748138f04a69bf21)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($9184d5e5333cd646$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        var selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        var firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $11d3fc76319d7811$export$748138f04a69bf21)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $9184d5e5333cd646$export$e992c40175757a22(_ref3) {
    var elementRef = _ref3.elementRef, phase = _ref3.phase, role = _ref3.role;
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    var prevPhaseRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var _getInitialFocusTarge;
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        var element = elementRef.current;
        if (!element) return;
        (_getInitialFocusTarge = $9184d5e5333cd646$var$getInitialFocusTarget({
            container: element,
            role: role
        })) === null || _getInitialFocusTarge === void 0 || _getInitialFocusTarge.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}


/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ var $1e0f40384beefae2$var$supportsPopoverHint = (0, $bvsoE.default)(function() {
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    var element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
// Surface reset — neutralises inherited interaction and text-layout properties
// (e.g. `pointer-events: none` from an overlaid controls container and
// `white-space: nowrap` from an `@atlaskit/select` option) that leak into a
// top-layer element because, for CSS inheritance, it is still a DOM child of its
// trigger (top-layer promotion is paint/stacking only; the legacy portal path
// avoided this by rendering at `<body>`). Excludes `color`/`font` (theming) and
// `direction`/`unicode-bidi` (RTL must inherit).
//
// KEEP IN SYNC with the identical `surfaceResetStyles` in `dialog/dialog-content.tsx`.
// ADS forbids sharing styles across files (`no-exported-styles` /
// `no-imported-style-values` — Compiled styles are null at runtime), so the reset is
// co-located and duplicated deliberately.
var $1e0f40384beefae2$var$surfaceResetStyles = {
    root: "_lcxv1wug _o5724jg8 _1nmz4jg8 _1i4q4jg8 _y3gnv2br _azhwidpf _1p1dglyw"
};
var $1e0f40384beefae2$var$styles = {
    root: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r041wug _1reoewfl _18m9ewfl _bfhk1j28 _4t3i1wug",
    motion: "_k8m011k7 _1oecdn4k _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v179n",
    exit: "_y44vof1f"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
var $1e0f40384beefae2$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ var $1e0f40384beefae2$var$POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
var $1e0f40384beefae2$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function Popover(_ref, ref) {
    var children = _ref.children, _ref$mode = _ref.mode, modeProp = _ref$mode === void 0 ? 'auto' : _ref$mode, onClose = _ref.onClose, onEnterFinish = _ref.onEnterFinish, onExitFinish = _ref.onExitFinish, _ref$shouldAnimate = _ref.shouldAnimate, shouldAnimate = _ref$shouldAnimate === void 0 ? false : _ref$shouldAnimate, placement = _ref.placement, testId = _ref.testId, isOpen = _ref.isOpen, enteringAnimationXcss = _ref.enteringAnimationXcss, exitingAnimationXcss = _ref.exitingAnimationXcss, role = _ref.role, label = _ref.label, labelledBy = _ref.labelledBy, idProp = _ref.id;
    var autoId = (0, $5FkrB.useId)();
    var ownRef = (0, $5FkrB.useRef)(null);
    var combinedRef = (0, $iO8GM.default)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    var popoverId = idProp !== null && idProp !== void 0 ? idProp : "popover-".concat(autoId.replace(/:/g, ''));
    var _useAnimatedVisibilit = (0, $620e767e58d5f797$export$1bccb45daf07907f)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    }), phase = _useAnimatedVisibilit.phase, onToggle = _useAnimatedVisibilit.onToggle;
    // True while the host element is mounted (any phase except `closed`).
    // Used as a dep so listener-rebind effects re-attach after a remount.
    var isVisible = phase !== 'closed';
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // focus-capturing roles are handled below via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus-restoration.md.
    (0, $16fde60aa22a13c1$export$4f6462e86a70abe5)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    (0, $9184d5e5333cd646$export$e992c40175757a22)({
        elementRef: ownRef,
        phase: phase,
        role: role
    });
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined.
    var handleObserverClose = (0, $5FkrB.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose({
            reason: 'programmatic'
        });
    }, [
        onClose
    ]);
    (0, $fb3d2710fcacd626$export$469bb693f11edc7f)({
        type: role && $1e0f40384beefae2$var$POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen: isOpen,
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    var mode = modeProp === 'hint' && !$1e0f40384beefae2$var$supportsPopoverHint() ? 'auto' : modeProp;
    var popupMotionStyle = (0, $5FkrB.useMemo)(function() {
        if (!placement || !shouldAnimate) return undefined;
        var _resolvePlacement = (0, $82926ccb1b7b6251$export$63044d21bc3d3fa2)({
            placement: placement
        }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge;
        return $1e0f40384beefae2$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]);
    // Prevents toggle handler from calling onClose for our own hidePopover() calls.
    var programmaticCloseRef = (0, $5FkrB.useRef)(false);
    // Set in capture-phase keydown so the toggle handler knows close reason.
    var closeReasonRef = (0, $5FkrB.useRef)('light-dismiss');
    // Snapshot of pre-open focus, used to restore focus for nested popovers
    // with focus-capturing roles (browser only restores the outermost).
    var previouslyFocusedElementRef = (0, $5FkrB.useRef)(null);
    var handleBeforeToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState !== 'open') return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- need active element snapshot
        var active = document.activeElement;
        previouslyFocusedElementRef.current = active instanceof HTMLElement ? active : null;
    }, []);
    var handleToggle = (0, $5FkrB.useCallback)(function(event) {
        var element = ownRef.current;
        if (event.newState === 'open') {
            onToggle(event);
            return;
        }
        if (event.newState === 'closed') {
            if (element) {
                // Nested-popover focus restoration fallback (browser only
                // restores outermost; Firefox skips nested entirely).
                // Restore only when the role moved focus in on open AND the
                // close was Escape/programmatic. For light dismiss, the
                // click target keeps focus per HTML spec
                // (`focusPreviousElement=false`).
                var previouslyFocused = previouslyFocusedElementRef.current;
                var reason = closeReasonRef.current;
                var isProgrammatic = programmaticCloseRef.current;
                var shouldRestore = previouslyFocused !== null && previouslyFocused.isConnected && (0, $6f5b9ff04d2efd44$export$b12adccf56228c71)({
                    role: role
                }) && (reason === 'escape' || isProgrammatic);
                if (shouldRestore && previouslyFocused) previouslyFocused.focus({
                    preventScroll: true
                });
                previouslyFocusedElementRef.current = null;
            }
            // Programmatic close: consumer already knows.
            if (programmaticCloseRef.current) // Reset reason so a stale 'escape' from a race with Escape keydown
            // does not corrupt the next browser-dismiss cycle.
            closeReasonRef.current = 'light-dismiss';
            else {
                // Browser dismiss (Escape/click-outside).
                var _reason = closeReasonRef.current;
                closeReasonRef.current = 'light-dismiss';
                // Optional: `manual` mode has no `onClose` in the forwarded type.
                onClose === null || onClose === void 0 || onClose({
                    reason: _reason
                });
            }
        }
        onToggle(event);
    }, [
        onClose,
        onToggle,
        role
    ]);
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `previouslyFocusedElementRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        var unbindEscape = (0, $7QpUe.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key === 'Escape') closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        var unbindToggle = (0, $7QpUe.bind)(element, {
            type: 'toggle',
            listener: handleToggle
        });
        // Snapshot `document.activeElement` before `useInitialFocus` moves it.
        var unbindBeforeToggle = (0, $7QpUe.bind)(element, {
            type: 'beforetoggle',
            listener: handleBeforeToggle
        });
        return function() {
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleToggle,
        handleBeforeToggle,
        isVisible
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            programmaticCloseRef.current = false;
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and the no-animation path unmounts before
            // `handleToggle` can reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch (_unused) {}
            return function() {
                programmaticCloseRef.current = true;
                try {
                    element.hidePopover();
                } catch (_unused2) {}
            };
        }
        programmaticCloseRef.current = true;
        try {
            element.hidePopover();
        } catch (_unused3) {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        ref: combinedRef,
        id: popoverId,
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        style: popupMotionStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $1e0f40384beefae2$var$styles.root,
            $1e0f40384beefae2$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $1e0f40384beefae2$var$styles.enter,
            shouldAnimate && phase === 'exiting' && $1e0f40384beefae2$var$styles.exit,
            shouldAnimate && $1e0f40384beefae2$var$styles.motion,
            (0, $hUFig.cx)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ])
    }, children);
});



var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $45Zis = parcelRequire("45Zis");

var $bvsoE = parcelRequire("bvsoE");

var $25nEq = parcelRequire("25nEq");
function $07e20599bb880728$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $07e20599bb880728$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $07e20599bb880728$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $07e20599bb880728$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * JS fallback positioning math. Used only when the browser does not
 * support CSS Anchor Positioning (less than 6% of users).
 *
 * Consumer-supplied `offset.gap` and `offset.crossAxisShift` are
 * honored: the caller (`useAnchorPosition`) resolves CSS length strings
 * (tokens, calc, var, etc) to pixels via a DOM probe before passing them
 * in. The caller also keeps the popover hidden (`opacity: 0`) until the
 * first measurement completes, so the popover never paints at the wrong
 * position.
 */ /**
 * A viewport-relative position, in pixels. Physical rather than logical
 * because it is written straight to `top` / `left`.
 */ /**
 * The cross-axis shift with its length already resolved to pixels.
 *
 * Mirrors `TCrossAxisShiftOffset`, whose `value` is an unresolved CSS length
 * string. Only this module needs the pixel form, because only this module does
 * the arithmetic itself.
 */ /**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function $07e20599bb880728$var$computeEdgePosition(_ref) {
    var axis = _ref.axis, edge = _ref.edge, triggerRect = _ref.triggerRect, popoverWidth = _ref.popoverWidth, popoverHeight = _ref.popoverHeight, viewport = _ref.viewport, gap = _ref.gap;
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        var spaceBelow = viewport.height - triggerRect.bottom;
        var spaceAbove = triggerRect.top;
        var fitsBelow = spaceBelow >= popoverHeight + gap;
        var useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        var _spaceAbove = triggerRect.top;
        var _spaceBelow = viewport.height - triggerRect.bottom;
        var fitsAbove = _spaceAbove >= popoverHeight + gap;
        var useAbove = fitsAbove || _spaceAbove >= _spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        var spaceRight = viewport.width - triggerRect.right;
        var spaceLeft = triggerRect.left;
        var fitsRight = spaceRight >= popoverWidth + gap;
        var useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        var _spaceLeft = triggerRect.left;
        var _spaceRight = viewport.width - triggerRect.right;
        var fitsLeft = _spaceLeft >= popoverWidth + gap;
        var useLeft = fitsLeft || _spaceLeft >= _spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function $07e20599bb880728$var$applyAlignment(_ref2) {
    var position = _ref2.position, axis = _ref2.axis, align = _ref2.align, triggerRect = _ref2.triggerRect, popoverWidth = _ref2.popoverWidth, popoverHeight = _ref2.popoverHeight;
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return $07e20599bb880728$var$_objectSpread($07e20599bb880728$var$_objectSpread({}, position), {}, {
            left: triggerRect.left
        });
        // align === 'end'
        return $07e20599bb880728$var$_objectSpread($07e20599bb880728$var$_objectSpread({}, position), {}, {
            left: triggerRect.right - popoverWidth
        });
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return $07e20599bb880728$var$_objectSpread($07e20599bb880728$var$_objectSpread({}, position), {}, {
        top: triggerRect.top
    });
    // align === 'end'
    return $07e20599bb880728$var$_objectSpread($07e20599bb880728$var$_objectSpread({}, position), {}, {
        top: triggerRect.bottom - popoverHeight
    });
}
/**
 * Applies the cross-axis shift offset.
 *
 * `forwards` always moves the popover toward the cross-axis END and
 * `backwards` toward the START, for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 *
 * This is a coordinate, so the direction is the sign and nothing else. There
 * is deliberately no per-`align` sign inversion here: the CSS path inverts the
 * sign only because a margin on the END side pushes a box the opposite way to
 * a margin on the START side, which is a property of margins rather than of
 * the shift. Applying that inversion to a coordinate moved `align: 'end'`
 * popovers the wrong way.
 */ function $07e20599bb880728$var$applyCrossAxisShift(_ref3) {
    var position = _ref3.position, axis = _ref3.axis, crossAxisShift = _ref3.crossAxisShift;
    if (crossAxisShift.value === 0) return position;
    var directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    var delta = crossAxisShift.value * directionSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return $07e20599bb880728$var$_objectSpread($07e20599bb880728$var$_objectSpread({}, position), {}, {
        left: position.left + delta
    });
    return $07e20599bb880728$var$_objectSpread($07e20599bb880728$var$_objectSpread({}, position), {}, {
        top: position.top + delta
    });
}
function $07e20599bb880728$export$d5ef1dac02135664(_ref4) {
    var triggerRect = _ref4.triggerRect, popoverEl = _ref4.popoverEl, placement = _ref4.placement, viewport = _ref4.viewport, gap = _ref4.gap, crossAxisShift = _ref4.crossAxisShift;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    var popoverWidth = popoverEl.offsetWidth;
    var popoverHeight = popoverEl.offsetHeight;
    var basePosition = $07e20599bb880728$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    var alignedPosition = $07e20599bb880728$var$applyAlignment({
        position: basePosition,
        axis: axis,
        align: align,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    var shiftedPosition = $07e20599bb880728$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        crossAxisShift: crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}


/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $ea1121e23bd98a9e$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, cleanupFns = new Array(_len), _key = 0; _key < _len; _key++)cleanupFns[_key] = arguments[_key];
    return function cleanup() {
        cleanupFns.forEach(function(callback) {
            return callback === null || callback === void 0 ? void 0 : callback();
        });
    };
}



function $36900f09c7f6373a$export$de49b61f233ddeb9(_ref) {
    var placement = _ref.placement;
    var _resolvePlacement = (0, $82926ccb1b7b6251$export$63044d21bc3d3fa2)({
        placement: placement
    }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge, align = _resolvePlacement.align;
    var edgeValue = "".concat(axis, "-").concat(edge);
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    var spanDir = align === 'start' ? 'end' : 'start';
    return "".concat(edgeValue, " span-").concat(crossAxis, "-").concat(spanDir);
}



/**
 * A `position-area` primary edge — the placement axis joined to its edge, e.g.
 * `block-end` or `inline-start`. These are the four edges a popover can sit on.
 */ function $24454af70e90db4a$var$slideOnEdge(_ref) {
    var align = _ref.align, edgeKey = _ref.edgeKey, crossAxis = _ref.crossAxis;
    if (align === 'center') return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-end"),
        "".concat(edgeKey, " span-").concat(crossAxis, "-start")
    ];
    // For `align: 'start'` the popover expands toward `end`, so the "near"
    // span is `end` and the "far" span is `start`; `align: 'end'` mirrors
    // this. The bare `edgeKey` (re-centered) sits between them.
    var near = align === 'start' ? 'end' : 'start';
    var far = align === 'start' ? 'start' : 'end';
    return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(near),
        edgeKey,
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(far)
    ];
}
function $24454af70e90db4a$var$flipDiagonally(_ref2) {
    var axis = _ref2.axis;
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    var flipToCrossAxis = axis === 'block' ? 'flip-inline' : 'flip-block';
    return "".concat(flipOnMainAxis, " ").concat(flipToCrossAxis);
}
function $24454af70e90db4a$export$c4e16947a95d61f1(_ref3) {
    var placement = _ref3.placement;
    /**
   * **Build the fallback list**
   *
   * Each entry is a complete alternative position.
   * The browser tries them _in order_ and uses the _first_ one that fits.
   */ var resolved = (0, $82926ccb1b7b6251$export$63044d21bc3d3fa2)({
        placement: placement
    });
    var axis = resolved.axis, edge = resolved.edge, align = resolved.align;
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    var flippedEdge = edge === 'start' ? 'end' : 'start';
    var sameEdgeArea = "".concat(axis, "-").concat(edge);
    var oppositeEdgeArea = "".concat(axis, "-").concat(flippedEdge);
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    /**
   * **Fallback algorithm**
   *
   * We have two things we can do to keep something visible:
   *
   * 1. _Slide_ along edges
   * 2. _Flip_ to another edge
   *
   * _Centered popover_
   *
   * Desired: Sits in middle of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge (centered)
   *  3: _Slide_ along opposite edge on the cross axis
   *
   * _Start or end aligned popover_
   *
   * Desired: Sits at start / end of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge
   *  3: _Flip_ on the diagonal (flip main axis + flip cross axis) into the
   *     opposite corner. For start / end alignment, this is the clean escape
   *     when the popover would otherwise land offscreen on both axes (ie in a
   *     corner). Rule 4 gets the job done, but a slide drops the gap
   *     as named position-area values don't carry margins).
   *     The diagonal flip keeps the gap and the alignment.
   *  4: _Slide_ along opposite edge on the cross axis
   */ return [
        $24454af70e90db4a$var$slideOnEdge({
            align: align,
            edgeKey: sameEdgeArea,
            crossAxis: crossAxis
        }),
        flipOnMainAxis,
        align !== 'center' ? $24454af70e90db4a$var$flipDiagonally({
            axis: axis
        }) : null,
        $24454af70e90db4a$var$slideOnEdge({
            align: align,
            edgeKey: oppositeEdgeArea,
            crossAxis: crossAxis
        })
    ].filter(Boolean).flat().join(', ');
}


var $d015903fee099275$var$elementCaches = new WeakMap();
function $d015903fee099275$var$canCacheResolvedLength(value) {
    // Custom-property values can be retargeted by inline overrides on the
    // consumer's wrapper, so we cannot prove a cached pixel value is still valid.
    return !value.includes('var(');
}
function $d015903fee099275$var$getCachedResolvedLength(_ref) {
    var _cacheForElement$get;
    var element = _ref.element, value = _ref.value;
    if (!$d015903fee099275$var$canCacheResolvedLength(value)) return null;
    var cacheForElement = $d015903fee099275$var$elementCaches.get(element);
    return (_cacheForElement$get = cacheForElement === null || cacheForElement === void 0 ? void 0 : cacheForElement.get(value)) !== null && _cacheForElement$get !== void 0 ? _cacheForElement$get : null;
}
function $d015903fee099275$var$cacheResolvedLength(_ref2) {
    var _elementCaches$get;
    var element = _ref2.element, value = _ref2.value, result = _ref2.result;
    if (!$d015903fee099275$var$canCacheResolvedLength(value)) return;
    var cacheForElement = (_elementCaches$get = $d015903fee099275$var$elementCaches.get(element)) !== null && _elementCaches$get !== void 0 ? _elementCaches$get : new Map();
    cacheForElement.set(value, result);
    $d015903fee099275$var$elementCaches.set(element, cacheForElement);
}
function $d015903fee099275$export$98721546d2816d9e(_ref3) {
    var value = _ref3.value, container = _ref3.container;
    if (typeof value === 'number') return value;
    // Fast path: unitless zero is universally zero pixels - accept `'0'` and
    // `'-0'` without a probe. (Consumers occasionally pass `'0'` instead of
    // the number `0`.)
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from the consumer normalisation
    // in `resolvePlacement`. Avoid a reflow when we can.
    var pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    var cached = $d015903fee099275$var$getCachedResolvedLength({
        element: container,
        value: value
    });
    if (cached !== null) return cached;
    var probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hide the probe from assistive tech and event targeting; defensive
    // against `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    container.appendChild(probe);
    var resolved = parseFloat(getComputedStyle(probe).marginLeft);
    container.removeChild(probe);
    var result = Number.isFinite(resolved) ? resolved : 0;
    $d015903fee099275$var$cacheResolvedLength({
        element: container,
        value: value,
        result: result
    });
    return result;
}



/**
 * A single inline style declaration.
 *
 * `TProperty` narrows the property name for callers that write a known, closed
 * set of properties. Narrowing it lets a record keyed on those same names be
 * checked for exhaustiveness at compile time, rather than silently resolving to
 * `undefined` for a name that was never mapped.
 */ /**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 */ function $1098787332e5e936$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}


// `resolvePlacement` is intentionally NOT re-exported here - import it directly
// from `./resolve-placement` so search-and-jump lands at the source of truth.
/**
 * Module-scope no-op `ResizeObserver` used in non-DOM jest environments where
 * `ResizeObserver` is `undefined`. Hoisted out of the effect to avoid
 * allocating a new class declaration on every run.
 */ var $fd88366a8c6ce2ed$var$NoopResizeObserver = /*#__PURE__*/ function() {
    function NoopResizeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoopResizeObserver);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoopResizeObserver, [
        {
            key: "observe",
            value: function observe() {}
        },
        {
            key: "unobserve",
            value: function unobserve() {}
        },
        {
            key: "disconnect",
            value: function disconnect() {}
        }
    ]);
}();
/**
 * Returns true when the popover is currently open. Wrapped because the
 * `:popover-open` pseudo-class is not implemented in some test environments
 * (e.g. jsdom), where `matches` throws on unknown selectors.
 */ function $fd88366a8c6ce2ed$var$isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch (_unused) {
        return false;
    }
}
/**
 * Detects whether the browser supports CSS Anchor Positioning.
 * Uses `once()` for lazy evaluation: safe for SSR and avoids hydration mismatches.
 */ var $fd88366a8c6ce2ed$var$supportsAnchorPositioning = (0, $bvsoE.default)(function() {
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('anchor-name', '--a');
});
/**
 * Every logical margin property this module can write: one per axis, per side.
 *
 * Deriving the union from `TPlacementAxis` and `TPlacementEdge` rather than
 * writing the four names out keeps it in step with the placement model, and
 * makes `CROSS_AXIS_SHIFT_CUSTOM_PROPERTY` below exhaustive by construction.
 */ /**
 * The custom property mirroring each cross-axis shift margin.
 *
 * These are written for the planned named arrow `@position-try` rules. Nothing
 * reads them yet, and the shift no longer depends on them: the antisymmetric
 * margins written by `crossAxisShiftMargins` survive a cross-axis slide on
 * their own.
 *
 * Keyed on `TLogicalMarginProperty` and not on `string`, so a margin property
 * that has no custom property (or a custom property whose margin no longer
 * exists) is a compile error rather than an `undefined` lookup that reaches
 * `setStyle` as `{ property: undefined, value }`.
 */ var $fd88366a8c6ce2ed$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY = {
    'margin-inline-start': '--ds-cross-axis-shift-margin-start',
    'margin-inline-end': '--ds-cross-axis-shift-margin-end',
    'margin-block-start': '--ds-cross-axis-shift-margin-block-start',
    'margin-block-end': '--ds-cross-axis-shift-margin-block-end'
};
var $fd88366a8c6ce2ed$var$ZEROED_CROSS_AXIS_SHIFT_CUSTOM_PROPERTIES = Object.values($fd88366a8c6ce2ed$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY).map(function(property) {
    return {
        property: property,
        value: '0px'
    };
});
/**
 * Returns the CSS margin declaration that creates a gap between the
 * popover and its trigger on the side facing the anchor.
 *
 * For example, a `block-end` placement (popover below) gets
 * `margin-block-start: 8px` to push it away from the trigger's bottom edge.
 */ function $fd88366a8c6ce2ed$var$edgeMargin(_ref) {
    var placement = _ref.placement, offset = _ref.offset;
    var axis = placement.axis, edge = placement.edge;
    // The gap sits on the side FACING the anchor, which is always the side
    // opposite the placement edge.
    var anchorFacingEdge = edge === 'end' ? 'start' : 'end';
    return {
        property: "margin-".concat(axis, "-").concat(anchorFacingEdge),
        value: offset
    };
}
/**
 * **The cross-axis shift margins.**
 *
 * The shift is written antisymmetrically on BOTH cross-axis sides
 * (`start: +value`, `end: -value`) rather than as a single margin on the side
 * picked from `align`. Two separate behaviours require it:
 *
 * 1. **`align: 'center'` is centered with `anchor-center`, which centers the
 *    popover's MARGIN box on the anchor.** A single-sided margin widens the
 *    margin box, so it displaces the border box by only half its value. An
 *    antisymmetric pair leaves the margin box width unchanged (`+value` and
 *    `-value` sum to zero) while moving its center by the full value.
 * 2. **`position-try-fallbacks` can slide the popover onto the opposite
 *    cross-axis side.** A `<position-area>` fallback keeps the base style's
 *    margins, and margin on the un-anchored side has no effect, so a
 *    single-sided margin is silently dropped once the browser slides across the
 *    cross axis. With both sides written, whichever side ends up anchored moves
 *    the popover the same physical direction.
 *
 * Leaving the margin box width unchanged also means the shift does not move
 * the point at which `position-try-fallbacks` decides the popover overflows.
 *
 * A `<try-tactic>` fallback (`flip-block`, `flip-inline`) behaves differently to
 * a `<position-area>` one: it SWAPS the start and end margins rather than
 * keeping them, which is what preserves the gap through a flip. So a flip across
 * the cross axis mirrors the shift along with the rest of the placement, rather
 * than preserving its physical direction. Only the diagonal fallback does that,
 * and only for `align: 'start' | 'end'`. See `placementToTryFallbacks`.
 *
 * A positive value always moves the popover toward the cross-axis END, so
 * `direction: 'forwards'` means the same thing for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 */ function $fd88366a8c6ce2ed$var$crossAxisShiftMargins(_ref2) {
    var placement = _ref2.placement, crossAxisShiftCssValue = _ref2.crossAxisShiftCssValue, direction = _ref2.direction;
    var crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    // Wrap any string in calc() with the sign factor. CSS handles the math,
    // so opaque values such as design tokens negate correctly.
    var negated = "calc(-1 * ".concat(crossAxisShiftCssValue, ")");
    var isForwards = direction === 'forwards';
    return [
        {
            property: "margin-".concat(crossAxis, "-start"),
            value: isForwards ? crossAxisShiftCssValue : negated
        },
        {
            property: "margin-".concat(crossAxis, "-end"),
            value: isForwards ? negated : crossAxisShiftCssValue
        }
    ];
}
/**
 * Returns a referentially-stable, fully-resolved `TPlacement`. The memo is
 * keyed on the resolved primitive fields so a fresh inline `placement` object
 * (or undefined fields vs explicit defaults) does not produce a fresh result.
 */ function $fd88366a8c6ce2ed$var$useStablePlacement(placement) {
    var resolved = (0, $82926ccb1b7b6251$export$63044d21bc3d3fa2)({
        placement: placement
    });
    var axis = resolved.axis;
    var edge = resolved.edge;
    var align = resolved.align;
    var gap = resolved.offset.gap;
    var shiftValue = resolved.offset.crossAxisShift.value;
    var shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuild inside the memo from primitive deps so the factory does not
    // close over the outer `resolved` reference and exhaustive-deps can verify.
    return (0, $5FkrB.useMemo)(function() {
        return {
            axis: axis,
            edge: edge,
            align: align,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        };
    }, [
        axis,
        edge,
        align,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $fd88366a8c6ce2ed$export$56b02a1e583f953c(_ref3) {
    var anchorRef = _ref3.anchorRef, popoverRef = _ref3.popoverRef, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? {} : _ref3$placement, _ref3$forceFallbackPo = _ref3.forceFallbackPositioning, forceFallbackPositioning = _ref3$forceFallbackPo === void 0 ? false : _ref3$forceFallbackPo, _ref3$isEnabled = _ref3.isEnabled, isEnabled = _ref3$isEnabled === void 0 ? true : _ref3$isEnabled, isOpen = _ref3.isOpen;
    var id = (0, $5FkrB.useId)();
    var stablePlacement = $fd88366a8c6ce2ed$var$useStablePlacement(placement);
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!isEnabled) return;
        var trigger = anchorRef.current;
        var popover = popoverRef.current;
        if (!trigger || !popover) return;
        var gapCssValue = stablePlacement.offset.gap;
        var crossAxisShiftCssValue = stablePlacement.offset.crossAxisShift.value;
        var shouldForceFallback = Boolean(forceFallbackPositioning);
        if ($fd88366a8c6ce2ed$var$supportsAnchorPositioning() && !shouldForceFallback) {
            // Reuse an existing `anchor-name` if the element already has one.
            // Another popover might already be anchored to the old name.
            var anchorName = trigger.style.getPropertyValue('anchor-name') || "--anchor-".concat(id.replace(/:/g, ''));
            var gap = $fd88366a8c6ce2ed$var$edgeMargin({
                placement: stablePlacement,
                offset: gapCssValue
            });
            // Computed once; also mirrored into the
            // `--ds-cross-axis-shift-margin-*` custom properties below.
            var crossAxisShift = $fd88366a8c6ce2ed$var$crossAxisShiftMargins({
                placement: stablePlacement,
                crossAxisShiftCssValue: crossAxisShiftCssValue,
                direction: stablePlacement.offset.crossAxisShift.direction
            });
            var popoverStyles = [
                {
                    property: 'position-anchor',
                    value: anchorName
                },
                {
                    property: 'position-area',
                    value: (0, $36900f09c7f6373a$export$de49b61f233ddeb9)({
                        placement: stablePlacement
                    })
                },
                {
                    property: 'position-try-fallbacks',
                    value: (0, $24454af70e90db4a$export$c4e16947a95d61f1)({
                        placement: stablePlacement
                    })
                },
                // Reset browser default popover positioning that conflicts
                // with anchor positioning (UA: `inset: 0; margin: auto;`)
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                },
                gap
            ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(crossAxisShift), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))($fd88366a8c6ce2ed$var$ZEROED_CROSS_AXIS_SHIFT_CUSTOM_PROPERTIES), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(crossAxisShift.map(function(_ref4) {
                var property = _ref4.property, value = _ref4.value;
                return {
                    property: $fd88366a8c6ce2ed$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY[property],
                    value: value
                };
            })));
            /**
       * **We are never cleaning up anchor names**
       *
       * _Rationale_
       *
       * - Multiple popovers can share the same anchor element.
       * - Sometimes the `useAnchorPosition` hook and `Popover`
       *   are not in the same component.
       * - There can be times when, even with reference counting, we
       *   could remove the anchor-name while it is still being used
       *   by something else - especially with async react updates
       *   which can cause tearing
       *
       * _More_
       *
       * See `notes/decisions/anchor-name-lifetime.md`
       */ trigger.style.setProperty('anchor-name', anchorName);
            return (0, $1098787332e5e936$export$37a5fde709c1db82)({
                element: popover,
                styles: popoverStyles
            });
        }
        // JS fallback. The popover is already in the top layer via
        // popover="auto", so we only reset UA defaults and set top/left
        // based on measurements.
        var cleanupBaseStyles = (0, $1098787332e5e936$export$37a5fde709c1db82)({
            element: popover,
            styles: [
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                }
            ]
        });
        // The popover can be consumer-owned (`@atlaskit/popper`'s `createPopper`),
        // so restore prior inline values rather than removing ours.
        var undoPosition;
        var undoHide;
        // `opacity: 0` not `visibility: hidden`: Firefox skips visibility-hidden
        // elements during `<dialog>` initial-focus traversal.
        function hideUntilPositioned() {
            // Keep the first snapshot, else we capture our own `opacity: 0`.
            // (`!popover` is for TS: narrowing does not reach nested functions.)
            if (!popover || undoHide) return;
            undoHide = (0, $1098787332e5e936$export$37a5fde709c1db82)({
                element: popover,
                styles: [
                    {
                        property: 'opacity',
                        value: '0'
                    }
                ]
            });
        }
        function reveal() {
            var _undoHide;
            (_undoHide = undoHide) === null || _undoHide === void 0 || _undoHide();
            undoHide = undefined;
        }
        function restorePosition() {
            var _undoPosition;
            (_undoPosition = undoPosition) === null || _undoPosition === void 0 || _undoPosition();
            undoPosition = undefined;
        }
        function update() {
            if (!trigger || !popover) return;
            var triggerRect = trigger.getBoundingClientRect();
            var viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            // Resolve consumer-supplied CSS length strings (tokens, calc, var,
            // px, rem, etc) to pixels. The probe is mounted INSIDE the popover
            // itself so the resolved length matches the scope a token would
            // resolve against from inside the popover content. (The popover
            // lives in the top layer, not the trigger's DOM tree, so probing
            // at `popover.parentElement` would resolve in a different scope
            // than the consumer's token authoring expects.)
            var gapPx = (0, $d015903fee099275$export$98721546d2816d9e)({
                value: gapCssValue,
                container: popover
            });
            var crossAxisShiftPx = (0, $d015903fee099275$export$98721546d2816d9e)({
                value: crossAxisShiftCssValue,
                container: popover
            });
            var _computeFallbackPosit = (0, $07e20599bb880728$export$d5ef1dac02135664)({
                triggerRect: triggerRect,
                popoverEl: popover,
                placement: stablePlacement,
                viewport: viewport,
                gap: gapPx,
                crossAxisShift: {
                    value: crossAxisShiftPx,
                    direction: stablePlacement.offset.crossAxisShift.direction
                }
            }), top = _computeFallbackPosit.top, left = _computeFallbackPosit.left;
            // Restore first so the snapshot stays the consumer's value.
            restorePosition();
            undoPosition = (0, $1098787332e5e936$export$37a5fde709c1db82)({
                element: popover,
                styles: [
                    {
                        property: 'top',
                        value: "".concat(top, "px")
                    },
                    {
                        property: 'left',
                        value: "".concat(left, "px")
                    }
                ]
            });
            reveal();
        }
        // Throttle scroll/resize updates to one per animation frame
        var scheduledUpdate = (0, $45Zis.default)(update);
        // Wait for the FIRST valid layout before measuring: the popover
        // is `display: none` until `showPopover()`, and some browsers
        // fire `toggle` before layout, so RAF-after-toggle is unreliable.
        // ResizeObserver fires once the browser has real dimensions.
        // Self-disconnects after one valid measurement; ongoing
        // scroll/resize is handled by the window listeners below.
        // `ResizeObserver` is missing in some non-DOM jest environments
        // (e.g. post-office's `node` environment). Fall back to a no-op
        // observer there. The scroll/resize listeners below still keep
        // the popover positioned in the rare case the consumer also
        // polyfilled `showPopover` but not `ResizeObserver`. Real
        // browsers always have it. The `NoopResizeObserver` class is
        // hoisted to module scope (see top of file) so we do not allocate
        // a new constructor on every effect run.
        var ResizeObserverImpl = typeof ResizeObserver !== 'undefined' ? ResizeObserver : $fd88366a8c6ce2ed$var$NoopResizeObserver;
        var resizeObserver = new ResizeObserverImpl(function() {
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                update();
                resizeObserver.disconnect();
            }
        });
        // If the popover is already open by the time this effect runs (for
        // example, the parent `useAnchorPosition` effect runs after the child
        // `Popover` effect that called `showPopover()`), the initial `toggle`
        // event has already fired and our listener below would miss it. Start
        // observing immediately so the first measurement still happens.
        if ($fd88366a8c6ce2ed$var$isPopoverOpen(popover)) {
            hideUntilPositioned();
            resizeObserver.observe(popover);
        }
        var undoPositioning = (0, $ea1121e23bd98a9e$export$1be1fc439b849fdf)(cleanupBaseStyles, // Each open needs a fresh measurement, so hide and re-observe.
        (0, $7QpUe.bind)(popover, {
            type: 'toggle',
            listener: function listener(event) {
                var toggleEvent = event;
                if (toggleEvent.newState === 'open') {
                    hideUntilPositioned();
                    resizeObserver.observe(popover);
                }
            }
        }), function() {
            return resizeObserver.disconnect();
        }, (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: scheduledUpdate,
            options: {
                capture: true,
                passive: true
            }
        }), (0, $7QpUe.bind)(window, {
            type: 'resize',
            listener: scheduledUpdate,
            options: {
                passive: true
            }
        }), function() {
            scheduledUpdate.cancel();
            restorePosition();
            reveal();
        });
        return undoPositioning;
    }, [
        anchorRef,
        popoverRef,
        stablePlacement,
        forceFallbackPositioning,
        isEnabled,
        id,
        isOpen
    ]);
}



var $5FkrB = parcelRequire("5FkrB");

var $bvsoE = parcelRequire("bvsoE");

/**
 * Probes anchor SIZING, separately from `anchor-name` (see
 * `supportsAnchorPositioning`): some browsers have positioning but not sizing.
 * `once()` for SSR safety.
 */ var $86bdecde31a22a3e$var$supportsAnchorSize = (0, $bvsoE.default)(function() {
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('min-inline-size', 'anchor-size(self-inline)');
});
/**
 * The JS fallback's stand-in for `anchor-size(self-inline)`. `offsetWidth` / `offsetHeight` are
 * physical, so the axis is picked from the popover's `writing-mode`. Anything not horizontal is
 * treated as vertical, and an unknown or empty value falls back to `offsetWidth`.
 */ function $86bdecde31a22a3e$var$getFallbackAnchorInlineSize(_ref) {
    var anchor = _ref.anchor, popover = _ref.popover;
    // `String()` because not every test environment implements `writing-mode`.
    var writingMode = String(getComputedStyle(popover).writingMode);
    var isVertical = writingMode.startsWith('vertical') || writingMode.startsWith('sideways');
    return isVertical ? anchor.offsetHeight : anchor.offsetWidth;
}
function $86bdecde31a22a3e$export$7071d791a7b131ed(_ref2) {
    var mode = _ref2.mode, popoverRef = _ref2.popoverRef, anchorRef = _ref2.anchorRef, isOpen = _ref2.isOpen;
    (0, $5FkrB.useLayoutEffect)(function() {
        var node = popoverRef.current;
        if (!node) return;
        if (mode === 'match-anchor') {
            // No floor here: it would let the popover grow past the anchor.
            if ($86bdecde31a22a3e$var$supportsAnchorSize()) return (0, $1098787332e5e936$export$37a5fde709c1db82)({
                element: node,
                styles: [
                    {
                        property: 'inline-size',
                        value: 'anchor-size(self-inline)'
                    }
                ]
            });
            var anchor = anchorRef.current;
            if (anchor) return (0, $1098787332e5e936$export$37a5fde709c1db82)({
                element: node,
                styles: [
                    {
                        property: 'inline-size',
                        value: "".concat($86bdecde31a22a3e$var$getFallbackAnchorInlineSize({
                            anchor: anchor,
                            popover: node
                        }), "px")
                    }
                ]
            });
            return;
        }
        if (mode === 'min-anchor') {
            // One floor only. The content floor from mode 'none' deliberately does not also apply
            // here, and cannot: it would need this same property. See the decision note.
            if ($86bdecde31a22a3e$var$supportsAnchorSize()) return (0, $1098787332e5e936$export$37a5fde709c1db82)({
                element: node,
                styles: [
                    {
                        property: 'min-inline-size',
                        value: 'anchor-size(self-inline)'
                    }
                ]
            });
            var _anchor = anchorRef.current;
            if (_anchor) return (0, $1098787332e5e936$export$37a5fde709c1db82)({
                element: node,
                styles: [
                    {
                        property: 'min-inline-size',
                        value: "".concat($86bdecde31a22a3e$var$getFallbackAnchorInlineSize({
                            anchor: _anchor,
                            popover: node
                        }), "px")
                    }
                ]
            });
            // Nothing to measure, so no floor.
            return;
        }
        // Makes a too-narrow span overflow and drive `position-try-fallbacks` instead of wrapping.
        // `@atlaskit/popper` resets this exact property to `0` for its fit-to-viewport mode.
        return (0, $1098787332e5e936$export$37a5fde709c1db82)({
            element: node,
            styles: [
                {
                    property: 'min-inline-size',
                    value: 'max-content'
                }
            ]
        });
    }, [
        mode,
        popoverRef,
        anchorRef,
        isOpen
    ]);
}




var $5FkrB = parcelRequire("5FkrB");
var $5cdd9d5ff120039b$export$a0d5b29fa9affc38 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);


function $6b74680df9e76de2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6b74680df9e76de2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6b74680df9e76de2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6b74680df9e76de2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// `'auto'` falls through to `'end'`; top-layer's `position-try-fallbacks` flips it if needed.
function $6b74680df9e76de2$var$reactSelectEdgeToTopLayerEdge(menuPlacement) {
    return menuPlacement === 'top' ? 'start' : 'end';
}
var $6b74680df9e76de2$var$menuPortalStyles = {
    root: "_ofie1496"
};
function $6b74680df9e76de2$export$1f5427c7f5364d0b(props) {
    var children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, xcss = props.xcss;
    // Select's "close the menu" callback, distinct from `Popover.onClose`.
    var closeSelect = (0, $5FkrB.useContext)((0, $5cdd9d5ff120039b$export$a0d5b29fa9affc38));
    var popoverRef = (0, $5FkrB.useRef)(null);
    // Top-layer hooks need a RefObject; in-render mutation keeps it in sync
    // with the prop without an effect. The hooks re-read `.current` from
    // `isOpen`-keyed layout effects, so a stable ref identity is fine.
    var anchorRef = (0, $5FkrB.useRef)(null);
    anchorRef.current = controlElement;
    // `controlElement` is null on initial mount / SSR until `Select` mirrors
    // its ref into state. While null, every hook below no-ops to avoid DOM
    // reads or registering an unpositioned popover.
    var isAnchored = controlElement !== null;
    // `gap: 0` matches the legacy MenuPortal (no trigger-to-menu gap; the
    // menu root already declares its own `marginBlockStart`). Without this
    // override `useAnchorPosition`'s default 8px gap would diverge visually
    // from the legacy path.
    (0, $fd88366a8c6ce2ed$export$56b02a1e583f953c)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        placement: {
            axis: 'block',
            edge: $6b74680df9e76de2$var$reactSelectEdgeToTopLayerEdge(menuPlacement),
            offset: {
                gap: 0
            }
        },
        isOpen: isAnchored
    });
    (0, $86bdecde31a22a3e$export$7071d791a7b131ed)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        mode: 'match-anchor',
        isOpen: isAnchored
    });
    var handlePopoverClose = (0, $5FkrB.useCallback)(function() {
        if (closeSelect) closeSelect();
    }, [
        closeSelect
    ]);
    // Explicit observer registration: the outer Popover is intentionally
    // roleless (see Popover comment below), so Popover cannot auto-register
    // from its role. This lets `closeLayers()` (Modal / Drawer) dismiss us.
    (0, $fb3d2710fcacd626$export$469bb693f11edc7f)({
        type: 'popup',
        isOpen: isAnchored,
        onClose: handlePopoverClose
    });
    // Top-layer owns positioning; zero offset/rect preserves the consumer
    // styles call shape.
    var _getStyleProps = (0, $2601addfebe56e71$export$26417cabd806a658)($6b74680df9e76de2$var$_objectSpread($6b74680df9e76de2$var$_objectSpread({}, props), {}, {
        offset: 0,
        position: menuPosition,
        rect: {
            left: 0,
            width: 0
        }
    }), 'menuPortal', {
        'menu-portal': true
    }), className = _getStyleProps.className;
    // Popover stays mounted and is driven by `isOpen` so its layout-effect
    // teardown (`hidePopover`, observer cleanup, position-hook style reset)
    // runs against a live element. Conditional render would skip that path.
    //
    // `mode="auto"` delegates light-dismiss and Escape to the browser. The
    // `onClose` bridge then synchronizes react-select's `menuIsOpen` state after
    // native dismissal, keeping this popover available to consume the request.
    //
    // The Popover host is intentionally roleless: the inner `MenuList`
    // keeps `role="listbox"` and the id referenced by `aria-controls`.
    // Putting the role on the outer host caused Playwright `toBeVisible`
    // and some SR hit-testing to treat it as hidden (zero bounding rect
    // while `styles.root` opts out of UA `[popover]` positioning).
    //
    // TODO: add open / close animation. Select unmounts MenuPortalTopLayer
    // the moment `menuIsOpen` flips false, so Popover's `animate` exit
    // transition never gets a frame. Needs keeping the portal mounted
    // through the exit (`onExitFinish`) on the Select side.
    return /*#__PURE__*/ $5FkrB.createElement((0, $1e0f40384beefae2$export$5b6b19405a83ff9d), {
        ref: popoverRef,
        mode: "auto",
        isOpen: isAnchored,
        onClose: handlePopoverClose
    }, /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // `className` carries consumer `styles.menuPortal({...})` output,
        // `xcss` carries caller compiled atomic classes, and `-MenuPortal`
        // is a legacy selector hook kept for parity with MenuPortalLegacy.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss, @typescript-eslint/no-explicit-any
        className: (0, $970q7.default)([
            $6b74680df9e76de2$var$menuPortalStyles.root,
            (0, $hUFig.cx)(className, xcss, '-MenuPortal')
        ])
    }, innerProps), children));
}


function $deb76f8a97da38a0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $deb76f8a97da38a0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $deb76f8a97da38a0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $deb76f8a97da38a0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $deb76f8a97da38a0$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
var $deb76f8a97da38a0$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $deb76f8a97da38a0$var$menuPortalStyles = {
    root: "_1pbykb7n _1e02a1vk _kqswcp1v _152t1nmo _1bsb1qxj"
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
function $deb76f8a97da38a0$var$MenuPortalLegacy(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, xcss = props.xcss;
    var menuPortalRef = (0, $5FkrB.useRef)(null);
    var cleanupRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)($deb76f8a97da38a0$var$coercePlacement(menuPlacement)), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), placement = _useState2[0], setPortalPlacement = _useState2[1];
    var portalPlacementContext = (0, $5FkrB.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState3 = (0, $5FkrB.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), computedPosition = _useState4[0], setComputedPosition = _useState4[1];
    var updateComputedPosition = (0, $5FkrB.useCallback)(function() {
        if (!controlElement) return;
        var rect = $deb76f8a97da38a0$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $5FkrB.useLayoutEffect)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $5FkrB.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $6I9SI.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $5FkrB.useLayoutEffect)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $5FkrB.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // Legacy quirk: `computedPosition` is null until the layout effect runs,
    // so the first render returns null even with `defaultMenuIsOpen` set.
    // Synchronous observers (VR snapshots) see a one-frame "closed" state.
    // Left as-is; the top-layer path supersedes this and positions declaratively.
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    var _getStyleProps = (0, $2601addfebe56e71$export$26417cabd806a658)($deb76f8a97da38a0$var$_objectSpread($deb76f8a97da38a0$var$_objectSpread({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    // same wrapper element whether fixed or portalled
    var menuWrapper = /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $deb76f8a97da38a0$var$menuPortalStyles.root,
            (0, $hUFig.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: $deb76f8a97da38a0$var$_objectSpread({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': "".concat(computedPosition.rect.left, "px"),
            '--menu-position': menuPosition,
            '--menu-top': "".concat(computedPosition.offset, "px"),
            '--menu-width': "".concat(computedPosition.rect.width, "px")
        }, css)
    }, innerProps), children);
    return /*#__PURE__*/ $5FkrB.createElement((0, $0fc0d1783c68fd27$export$e001f626511a0ead).Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $aLeHs.createPortal)(menuWrapper, appendTo) : menuWrapper);
}
var $deb76f8a97da38a0$export$793392f970497feb = function MenuPortal(props) {
    if ((0, $9a15a8b9047bb706$export$b40ec24ac8275656)('platform-dst-top-layer')) // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ $5FkrB.createElement((0, $6b74680df9e76de2$export$1f5427c7f5364d0b), props);
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ $5FkrB.createElement($deb76f8a97da38a0$var$MenuPortalLegacy, props);
};


/* multi-value.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $25nEq = parcelRequire("25nEq");

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $iO8GM = parcelRequire("iO8GM");
var $17249b49585bd341$export$75eee42ff540d8ae = function convertToMs(duration) {
    // Use regex to separate the number and the unit
    var matches = duration.match(/^(-?(?:\d+\.?\d*|\.\d+))(s|ms)$/);
    if (!matches) return 0; // Or return for invalid format
    var value = parseFloat(matches[1]);
    var unit = matches[2];
    if (unit === 's') return value * 1000; // Convert seconds to milliseconds
    else return value; // Already in milliseconds
};


var $36f1cd4f42e18a2d$var$cssTimePattern = /^-?(?:\d+\.?\d*|\.\d+)(?:ms|s)$/;
var $36f1cd4f42e18a2d$var$toCssList = function toCssList(value) {
    return value.split(',').map(function(item) {
        return item.trim();
    }).filter(Boolean);
};
var $36f1cd4f42e18a2d$var$toTimeList = function toTimeList(value) {
    return $36f1cd4f42e18a2d$var$toCssList(value).filter(function(time) {
        return $36f1cd4f42e18a2d$var$cssTimePattern.test(time);
    }).map((0, $17249b49585bd341$export$75eee42ff540d8ae));
};
var $36f1cd4f42e18a2d$export$dd9b73a7482d05b6 = function getComputedAnimationDurationMs(animationName, animationDuration, animationDelay) {
    var names = $36f1cd4f42e18a2d$var$toCssList(animationName);
    var durations = $36f1cd4f42e18a2d$var$toTimeList(animationDuration);
    var delays = $36f1cd4f42e18a2d$var$toTimeList(animationDelay);
    if (names.length === 0 || durations.length === 0) return 0;
    var longestDuration = 0;
    for(var index = 0; index < names.length; index++){
        if (names[index] === 'none') continue;
        var duration = durations[index % durations.length];
        var delay = delays.length > 0 ? delays[index % delays.length] : 0;
        longestDuration = Math.max(longestDuration, duration + delay);
    }
    return longestDuration;
};



var $fC8ib = parcelRequire("fC8ib");
var $a8165367ac79073e$export$d0038b6e47881463 = function getDurationMs(animation) {
    var animations = animation.split(/,(?![^()]*\))/).map(function(value) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(value.trim().matchAll(/(-?\d*\.?\d+)(ms|s)\b/g));
    }).filter(function(matches) {
        return matches.length > 0;
    });
    if (animations.length === 0) return {
        duration: 0,
        delay: 0
    };
    return animations.reduce(function(longest, matches) {
        var toMilliseconds = function toMilliseconds(match) {
            var value = parseFloat(match[1]);
            return match[2] === 's' ? value * 1000 : value;
        };
        var timing = {
            duration: toMilliseconds(matches[0]),
            delay: matches[1] ? toMilliseconds(matches[1]) : 0
        };
        return timing.duration + timing.delay > longest.duration + longest.delay ? timing : longest;
    }, {
        duration: 0,
        delay: 0
    });
};


var $60059c8f9c6e854d$export$c5406bd59b374abd = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};


var $f3900a8d038b1536$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!(0, $60059c8f9c6e854d$export$c5406bd59b374abd)()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};



var $lFhdZ = parcelRequire("lFhdZ");
var $a77a93149d2dd612$export$82b92541889a035d = function resolveMotionToken(token) {
    var cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    var cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        var _getDocument;
        var documentElement = (_getDocument = (0, $lFhdZ.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};


/**
 * Supported reanimate values.
 * 'enter' will re-enter the animation.
 * 'exit-then-enter' will exit the animation and then enter it again.
 */ var $8e0021cb6fcac814$export$569340a66b14e0dc = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    Reanimate["exit"] = "exit";
    return Reanimate;
}({});



var $5FkrB = parcelRequire("5FkrB");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $ISKn7 = parcelRequire("ISKn7");
var $12ca1103b6710af8$var$_process, $12ca1103b6710af8$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $12ca1103b6710af8$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($12ca1103b6710af8$var$_process = globalThis.process) === null || $12ca1103b6710af8$var$_process === void 0 || ($12ca1103b6710af8$var$_process = $12ca1103b6710af8$var$_process.env) === null || $12ca1103b6710af8$var$_process === void 0 ? void 0 : $12ca1103b6710af8$var$_process.JEST_WORKER_ID) !== undefined;
var $12ca1103b6710af8$var$DEBUG_MODE = !$12ca1103b6710af8$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($12ca1103b6710af8$var$_process2 = globalThis.process) === null || $12ca1103b6710af8$var$_process2 === void 0 || ($12ca1103b6710af8$var$_process2 = $12ca1103b6710af8$var$_process2.env) === null || $12ca1103b6710af8$var$_process2 === void 0 ? void 0 : $12ca1103b6710af8$var$_process2.NODE_ENV) !== 'production';
var $12ca1103b6710af8$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$12ca1103b6710af8$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $f7cf28701ce80d1d$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $f7cf28701ce80d1d$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
var $f7cf28701ce80d1d$export$75f4a1454eff2805 = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';


var $53c05a563fe93b7b$export$b574c24e1e6490f5 = (0, $f7cf28701ce80d1d$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $9cb075343a19c72f$export$92f8b531feaeb23d = (0, $f7cf28701ce80d1d$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $0b5280b6b32113dc$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $0b5280b6b32113dc$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$0b5280b6b32113dc$export$54ea85357b4e0159[0, $f7cf28701ce80d1d$export$7e41b1b2bdee3f98] = $0b5280b6b32113dc$export$54ea85357b4e0159[0, $f7cf28701ce80d1d$export$7e41b1b2bdee3f98] || $0b5280b6b32113dc$var$DEFAULT_PFF_GLOBAL;



var $dd4ec35222a8e3b1$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $53c05a563fe93b7b$export$b574c24e1e6490f5) || (0, $9cb075343a19c72f$export$92f8b531feaeb23d);
function $dd4ec35222a8e3b1$export$6333b6aff9fc6275(flagKey) {
    if ($dd4ec35222a8e3b1$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $12ca1103b6710af8$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $f7cf28701ce80d1d$export$407f05df8e3ce9f3), flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = (0, $0b5280b6b32113dc$export$54ea85357b4e0159)[0, $f7cf28701ce80d1d$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = (0, $0b5280b6b32113dc$export$54ea85357b4e0159)[0, $f7cf28701ce80d1d$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $ISKn7.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = (0, $0b5280b6b32113dc$export$54ea85357b4e0159)[0, $f7cf28701ce80d1d$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $debc7175c79c9ae5$export$b40ec24ac8275656(name) {
    return (0, $dd4ec35222a8e3b1$export$6333b6aff9fc6275)(name);
}


/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $44bece14de74cdc3$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isInsideExitingPersistence: false,
    isExiting: false
};
var $44bece14de74cdc3$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $5FkrB.createContext)($44bece14de74cdc3$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $44bece14de74cdc3$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $44bece14de74cdc3$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($44bece14de74cdc3$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $44bece14de74cdc3$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $44bece14de74cdc3$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $44bece14de74cdc3$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $44bece14de74cdc3$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $44bece14de74cdc3$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $44bece14de74cdc3$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false,
            isInsideExitingPersistence: true
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false,
            isInsideExitingPersistence: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $44bece14de74cdc3$var$childrenToArray(previousChildren);
    var current = $44bece14de74cdc3$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var nextChildren = currentChildren !== children ? $44bece14de74cdc3$var$childrenToArray(children) : current;
    var missingKeys = $44bece14de74cdc3$var$getMissingKeys(nextChildren, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $44bece14de74cdc3$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $debc7175c79c9ae5$export$b40ec24ac8275656)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $44bece14de74cdc3$var$wrapChildWithContextProvider(child, {
            appear: true,
            isInsideExitingPersistence: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $44bece14de74cdc3$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$44bece14de74cdc3$export$2e2bcd8739ae039 = $44bece14de74cdc3$var$ExitingPersistence;
$44bece14de74cdc3$var$ExitingPersistence.displayName = 'ExitingPersistence';


var $f729f6f87eeda37a$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)((0, $44bece14de74cdc3$export$b9c4904d7a6929e6));
};



var $5FkrB = parcelRequire("5FkrB");
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $cba68290716696a7$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");

var $5FkrB = parcelRequire("5FkrB");
var $7ec860281298f964$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);


var $9932ab0d535106b9$export$5e65d7d58ae96ad8 = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $eVb4V.default)
    };
});
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $9932ab0d535106b9$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $7ec860281298f964$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($9932ab0d535106b9$export$5e65d7d58ae96ad8.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$9932ab0d535106b9$export$2e2bcd8739ae039 = $9932ab0d535106b9$var$StaggeredEntrance;


var $efde60a21ac66d1c$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var identifier = (0, $cba68290716696a7$export$c485849f2e393253)();
    var context = (0, $5FkrB.useContext)((0, $9932ab0d535106b9$export$5e65d7d58ae96ad8));
    return context(identifier);
};


function $ae09c2b1e5b3d62e$export$2a51cfe9390d36ef() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, onFinishMotion = _ref.onFinish, initialState = _ref.initialState;
    var reducedMotion = (0, $f3900a8d038b1536$export$b7baf7667a68d87c)();
    var staggered = (0, $efde60a21ac66d1c$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $f729f6f87eeda37a$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var staggeredDelay = isExiting ? 0 : staggered.delay;
    var staggeredIsReady = staggered.isReady;
    var _useState = (0, $5FkrB.useState)(initialState !== null && initialState !== void 0 ? initialState : appear ? staggeredIsReady && !staggeredDelay ? 'entering' : 'init' : 'visible'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var elementRef = (0, $5FkrB.useRef)(null);
    var reanimateRef = (0, $5FkrB.useRef)();
    var animationRef = (0, $5FkrB.useRef)();
    var staggeredEntryRef = (0, $5FkrB.useRef)();
    (0, $5FkrB.useEffect)(function() {
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ var onAnimationEnd = (0, $5FkrB.useCallback)(function(currentState, cancelled) {
        // We are done animating, so we set the state to visible
        var newState = 'visible';
        if (currentState === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('exiting');
        }
        if (currentState === 'entering') onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('entering');
        if (reanimateRef.current === (0, $8e0021cb6fcac814$export$569340a66b14e0dc).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $8e0021cb6fcac814$export$569340a66b14e0dc).enter;
            newState = 'entering';
        } else if (reanimateRef.current === (0, $8e0021cb6fcac814$export$569340a66b14e0dc).enter) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        else if (reanimateRef.current === (0, $8e0021cb6fcac814$export$569340a66b14e0dc).exit) {
            // We are done reanimating, so we clear the reanimate state
            reanimateRef.current = undefined;
            newState = 'hidden';
        }
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    // Handles staggered entry
    (0, $5FkrB.useEffect)(function() {
        if (state !== 'init') return;
        if (reducedMotion) {
            onAnimationEnd('entering', false);
            return;
        }
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(function() {
            setState('entering');
        }, staggeredDelay);
        return function() {
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        onAnimationEnd,
        state,
        staggeredIsReady,
        staggeredDelay,
        reducedMotion
    ]);
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (!staggeredIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is visible, hidden or init, we don't need to do anything
        if (state === 'visible' || state === 'init' || state === 'hidden') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if (reducedMotion) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        var animationDuration = 0;
        if (state === 'entering' || state === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    var animationTimings = (0, $a8165367ac79073e$export$d0038b6e47881463)((0, $a77a93149d2dd612$export$82b92541889a035d)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    var computedStyles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $36f1cd4f42e18a2d$export$dd9b73a7482d05b6)(computedStyles.animationName, computedStyles.animationDuration, computedStyles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting') animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration);
        else if (state === 'entering') animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration);
        return function() {
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        appear,
        staggeredDelay,
        staggeredIsReady,
        reducedMotion
    ]);
    var reanimate = (0, $5FkrB.useCallback)(function(value) {
        animationRef.current && clearTimeout(animationRef.current);
        reanimateRef.current = value;
        if (value === (0, $8e0021cb6fcac814$export$569340a66b14e0dc).exit_then_enter) setState('exiting');
        else if (value === (0, $8e0021cb6fcac814$export$569340a66b14e0dc).enter) setState('entering');
        else if (value === (0, $8e0021cb6fcac814$export$569340a66b14e0dc).exit) setState('exiting');
    }, []);
    var ref = (0, $iO8GM.default)([
        staggered.ref,
        elementRef
    ]);
    return {
        ref: ref,
        reanimate: reanimate,
        state: state
    };
}



/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $25nEq = parcelRequire("25nEq");

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ISKn7 = parcelRequire("ISKn7");
var $6712f6e3528d3d0e$var$_process, $6712f6e3528d3d0e$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $6712f6e3528d3d0e$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($6712f6e3528d3d0e$var$_process = globalThis.process) === null || $6712f6e3528d3d0e$var$_process === void 0 || ($6712f6e3528d3d0e$var$_process = $6712f6e3528d3d0e$var$_process.env) === null || $6712f6e3528d3d0e$var$_process === void 0 ? void 0 : $6712f6e3528d3d0e$var$_process.JEST_WORKER_ID) !== undefined;
var $6712f6e3528d3d0e$var$DEBUG_MODE = !$6712f6e3528d3d0e$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($6712f6e3528d3d0e$var$_process2 = globalThis.process) === null || $6712f6e3528d3d0e$var$_process2 === void 0 || ($6712f6e3528d3d0e$var$_process2 = $6712f6e3528d3d0e$var$_process2.env) === null || $6712f6e3528d3d0e$var$_process2 === void 0 ? void 0 : $6712f6e3528d3d0e$var$_process2.NODE_ENV) !== 'production';
var $6712f6e3528d3d0e$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$6712f6e3528d3d0e$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $e0803be8bd26e1e8$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $e0803be8bd26e1e8$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
var $e0803be8bd26e1e8$export$75f4a1454eff2805 = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';


var $01a22f40b6050cb1$export$b574c24e1e6490f5 = (0, $e0803be8bd26e1e8$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $7bc41d901ff7fadb$export$92f8b531feaeb23d = (0, $e0803be8bd26e1e8$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $59cdd34eda791302$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $59cdd34eda791302$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$59cdd34eda791302$export$54ea85357b4e0159[0, $e0803be8bd26e1e8$export$7e41b1b2bdee3f98] = $59cdd34eda791302$export$54ea85357b4e0159[0, $e0803be8bd26e1e8$export$7e41b1b2bdee3f98] || $59cdd34eda791302$var$DEFAULT_PFF_GLOBAL;



var $9b1ff4a53ecb3cb8$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $01a22f40b6050cb1$export$b574c24e1e6490f5) || (0, $7bc41d901ff7fadb$export$92f8b531feaeb23d);
function $9b1ff4a53ecb3cb8$export$6333b6aff9fc6275(flagKey) {
    if ($9b1ff4a53ecb3cb8$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $6712f6e3528d3d0e$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $e0803be8bd26e1e8$export$407f05df8e3ce9f3), flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = (0, $59cdd34eda791302$export$54ea85357b4e0159)[0, $e0803be8bd26e1e8$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = (0, $59cdd34eda791302$export$54ea85357b4e0159)[0, $e0803be8bd26e1e8$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $ISKn7.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = (0, $59cdd34eda791302$export$54ea85357b4e0159)[0, $e0803be8bd26e1e8$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $68452a212463a8b0$export$b40ec24ac8275656(name) {
    return (0, $9b1ff4a53ecb3cb8$export$6333b6aff9fc6275)(name);
}



var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $9ade55a9ad00e544$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9ade55a9ad00e544$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9ade55a9ad00e544$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9ade55a9ad00e544$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9ade55a9ad00e544$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $9ade55a9ad00e544$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $9ade55a9ad00e544$var$_objectSpread($9ade55a9ad00e544$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $1bfe29a751e3a37a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1bfe29a751e3a37a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1bfe29a751e3a37a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1bfe29a751e3a37a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1bfe29a751e3a37a$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $1bfe29a751e3a37a$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $1bfe29a751e3a37a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1bfe29a751e3a37a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1bfe29a751e3a37a$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $1bfe29a751e3a37a$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $1bfe29a751e3a37a$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            var payload = $1bfe29a751e3a37a$var$clonePayload(_this.payload);
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $1bfe29a751e3a37a$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $9ade55a9ad00e544$export$2e2bcd8739ae039));
var $1bfe29a751e3a37a$var$clonePayload = function clonePayload(payload) {
    if ((0, $68452a212463a8b0$export$b40ec24ac8275656)('platform-analytics-next-safe-clone')) try {
        return JSON.parse(JSON.stringify(payload));
    } catch (e) {
        // Shallow clone keeps the event usable without crashing the UI.
        return $1bfe29a751e3a37a$var$_objectSpread({}, payload);
    }
    /**
   * A hacky "deep clone" of the object. This is limited in that it wont
   * support functions, regexs, Maps, Sets, etc, but none of those need to
   * be represented in our payload.
   */ return JSON.parse(JSON.stringify(payload));
};



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $ddcb73dbdcec42cc$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $1b5ac968fc71b5b8$export$5bf35293e545f20c() {
    var analyticsContext = (0, $ddcb73dbdcec42cc$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $1bfe29a751e3a37a$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $027d153723847d71$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


var $5597405245131e6e$export$53c2b9c37c40e0d8 = function useCallbackWithAnalytics(method, payload, channel) {
    var _useAnalyticsEvents = (0, $1b5ac968fc71b5b8$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var methodRef = (0, $027d153723847d71$export$1d27a74659855e44)(method);
    var payloadRef = (0, $027d153723847d71$export$1d27a74659855e44)(payload);
    return (0, $5FkrB.useCallback)(function() {
        var pload = typeof payloadRef.current === 'function' ? payloadRef.current.apply(payloadRef, arguments) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current.apply(methodRef, arguments);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};



var $iO8GM = parcelRequire("iO8GM");

var $eVb4V = parcelRequire("eVb4V");

var $5supy = parcelRequire("5supy");

var $iYJcE = parcelRequire("iYJcE");
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $14d0b14f9c47982f$export$368bacef0dacbe05 = 25;
var $14d0b14f9c47982f$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};




var $5FkrB = parcelRequire("5FkrB");
var $abc3a461c99ee76b$export$ff879f35a69d56b7 = function useElementRef() {
    var elementRef = (0, $5FkrB.useRef)(null);
    var setRef = (0, $5FkrB.useCallback)(function(ref) {
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};




var $5FkrB = parcelRequire("5FkrB");
var $2ad7e310fd0eb213$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $2ad7e310fd0eb213$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $2ad7e310fd0eb213$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};



var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $b759ab62b3ea53ba$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $b759ab62b3ea53ba$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $b759ab62b3ea53ba$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};



/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $75016b43cbaa745a$var$ShrinkOut = function ShrinkOut(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'small' : _ref$duration, onFinish = _ref.onFinish;
    var _useElementRef = (0, $abc3a461c99ee76b$export$ff879f35a69d56b7)(), _useElementRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useElementRef, 2), element = _useElementRef2[0], setElementRef = _useElementRef2[1];
    var exiting = (0, $f729f6f87eeda37a$export$3b6f38abbdcbd000)();
    var requestAnimationFrame = (0, $2ad7e310fd0eb213$export$1775f27e7c8051ca)();
    var setTimeout = (0, $b759ab62b3ea53ba$export$4f34107a2b00f39c)();
    var direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $7ec860281298f964$export$e5c5a5f917a5871c)(function() {
        if (exiting.isExiting && element) {
            if ((0, $f3900a8d038b1536$export$b7baf7667a68d87c)()) {
                exiting.onFinish && exiting.onFinish();
                onFinish && onFinish('exiting');
                return;
            }
            var newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: "".concat(element.offsetWidth, "px"),
                height: "".concat(element.offsetHeight, "px"),
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    var newStyles = {
                        width: '0px',
                        margin: '0px',
                        // We animate margin down to zero so it doesn't take any space.
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $14d0b14f9c47982f$export$38b928a7167ce124)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(function() {
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $14d0b14f9c47982f$export$38b928a7167ce124)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $75016b43cbaa745a$export$2e2bcd8739ae039 = $75016b43cbaa745a$var$ShrinkOut;



/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // Color mapping from old color names to new color names
var $bb4829ea0d0f6c29$export$3351a8d90bcc13aa = {
    standard: 'gray',
    grey: 'gray',
    blue: 'blue',
    green: 'green',
    red: 'red',
    yellow: 'yellow',
    purple: 'purple',
    lime: 'lime',
    magenta: 'magenta',
    orange: 'orange',
    teal: 'teal',
    // Light variants map to same as their non-light counterparts
    greyLight: 'gray',
    blueLight: 'blue',
    greenLight: 'green',
    redLight: 'red',
    yellowLight: 'yellow',
    purpleLight: 'purple',
    limeLight: 'lime',
    magentaLight: 'magenta',
    orangeLight: 'orange',
    tealLight: 'teal'
};


// Intentionally scoped to the UI-uplifted TagNew implementation.
var $ca23aee08bc5176e$export$7d100de1166870f6 = function getTagText(text) {
    return Array.isArray(text) ? text.join('') : text;
};


/* tag-new.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $h19KG = parcelRequire("h19KG");


var $btdNC = parcelRequire("btdNC");

var $9ztDu = parcelRequire("9ztDu");



var $5FkrB = parcelRequire("5FkrB");
function $55584633f11267eb$export$ce4b6a469c26f53f(_ref) {
    var isLink = _ref.isLink, href = _ref.href, LinkComponent = _ref.LinkComponent, testId = _ref.testId, children = _ref.children, onClick = _ref.onClick, linkHandlers = _ref.linkHandlers;
    if (isLink && href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LinkComponent, {
        href: href,
        testId: testId ? "".concat(testId, "--link") : undefined,
        onClick: onClick,
        onMouseEnter: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseEnter,
        onMouseLeave: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseLeave,
        onMouseDown: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseDown,
        onFocus: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onFocus,
        onBlur: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onBlur
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, children);
}


/* removable-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ /**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

// Tag status enum
var $70a8f76075a95e27$export$74452314b63acabc = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}({});


/**
 * Stable key so ExitingPersistence can match this child across the remove transition
 * (see ShrinkOut + ExitingPersistence docs in @atlaskit/motion).
 */ var $cfb8785e053c0b07$var$removableShrinkOutChildKey = 'atlaskit-tag-removable-shrink-out';
var $cfb8785e053c0b07$var$motionWrapperStyles = null;
function $cfb8785e053c0b07$export$898a500849bb5cf4(_ref) {
    var isRemovable = _ref.isRemovable, status = _ref.status, onShrinkOutExitComplete = _ref.onShrinkOutExitComplete, children = _ref.children;
    if (isRemovable) return /*#__PURE__*/ $5FkrB.createElement((0, $44bece14de74cdc3$export$2e2bcd8739ae039), null, !(status === (0, $70a8f76075a95e27$export$74452314b63acabc).Removed) && /*#__PURE__*/ $5FkrB.createElement((0, $75016b43cbaa745a$export$2e2bcd8739ae039), {
        key: $cfb8785e053c0b07$var$removableShrinkOutChildKey,
        onFinish: onShrinkOutExitComplete ? function(phase) {
            if (phase === 'exiting') onShrinkOutExitComplete();
        } : undefined
    }, function(motion) {
        return /*#__PURE__*/ $5FkrB.createElement("span", {
            ref: motion.ref,
            className: (0, $970q7.default)([
                "_1e0c116y"
            ])
        }, children);
    }));
    return children;
}


var $9da3c9802f885960$var$tagMotionCapability = Symbol.for('@atlaskit/tag/motion-capable');
function $9da3c9802f885960$export$88b132e52a65ec37(component) {
    Object.defineProperty(component, $9da3c9802f885960$var$tagMotionCapability, {
        value: true
    });
    return component;
}


/* swatch-before.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $661ea088daf7f589$var$tagSwatchBeforeStyles = {
    swatch: "_2rkolb4i _1bsboqnp _4t3ioqnp _1o9zidpf"
};
var $661ea088daf7f589$var$tagSwatchBeforeColorStyles = {
    gray: "_bfhk18j9",
    blue: "_bfhk115i",
    green: "_bfhk1rsu",
    red: "_bfhkkrt9",
    yellow: "_bfhk8y3s",
    purple: "_bfhk18ah",
    lime: "_bfhkbq5w",
    magenta: "_bfhk1mi6",
    orange: "_bfhk1kkj",
    teal: "_bfhktdv8"
};
function $661ea088daf7f589$export$2e2bcd8739ae039(_ref) {
    var colorKey = _ref.colorKey, swatchBefore = _ref.swatchBefore, swatchBeforeLabel = _ref.swatchBeforeLabel, swatchBeforeRole = _ref.swatchBeforeRole;
    if (swatchBefore === undefined || swatchBefore === false) return null;
    if (swatchBefore === true) return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, swatchBeforeLabel && swatchBeforeRole ? {
        'aria-label': swatchBeforeLabel,
        role: swatchBeforeRole
    } : {}, {
        className: (0, $970q7.default)([
            $661ea088daf7f589$var$tagSwatchBeforeStyles.swatch,
            $661ea088daf7f589$var$tagSwatchBeforeColorStyles[colorKey]
        ])
    }));
    return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, swatchBeforeLabel && swatchBeforeRole ? {
        'aria-label': swatchBeforeLabel,
        role: swatchBeforeRole
    } : {}, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            backgroundColor: swatchBefore
        },
        className: (0, $970q7.default)([
            $661ea088daf7f589$var$tagSwatchBeforeStyles.swatch
        ])
    }));
}


/* tag-motion.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");


var $iO8GM = parcelRequire("iO8GM");





var $e873e61352e9253a$var$tagMotionKey = 'atlaskit-tag-motion';
function $e873e61352e9253a$var$TagMotionContent(_ref) {
    var children = _ref.children, forwardedRef = _ref.forwardedRef, onExitComplete = _ref.onExitComplete;
    var _useMotion = (0, $ae09c2b1e5b3d62e$export$2a51cfe9390d36ef)({
        onFinish: function onFinish(phase) {
            if (phase === 'exiting') onExitComplete === null || onExitComplete === void 0 || onExitComplete();
        }
    }), motionRef = _useMotion.ref, state = _useMotion.state;
    var mergedRef = (0, $5FkrB.useMemo)(function() {
        return (0, $iO8GM.default)([
            forwardedRef,
            motionRef
        ]);
    }, [
        forwardedRef,
        motionRef
    ]);
    return children({
        isEntering: state === 'entering',
        isExiting: state === 'exiting',
        ref: mergedRef
    });
}
function $e873e61352e9253a$export$6adae1772ccf137c(_ref2) {
    var children = _ref2.children, forwardedRef = _ref2.forwardedRef, onExitComplete = _ref2.onExitComplete, status = _ref2.status;
    var hasCompletedReducedMotionExit = (0, $5FkrB.useRef)(false);
    var outerPresence = (0, $f729f6f87eeda37a$export$3b6f38abbdcbd000)();
    var isRemoved = status === (0, $70a8f76075a95e27$export$74452314b63acabc).Removed || outerPresence.isExiting;
    var shouldAppear = outerPresence.isInsideExitingPersistence && outerPresence.appear && !outerPresence.isExiting;
    var latestExitState = (0, $5FkrB.useRef)({
        onExitComplete: onExitComplete,
        outerPresence: outerPresence,
        status: status
    });
    latestExitState.current = {
        onExitComplete: onExitComplete,
        outerPresence: outerPresence,
        status: status
    };
    var onMotionExitComplete = (0, $5FkrB.useCallback)(function() {
        var latest = latestExitState.current;
        if (latest.outerPresence.isExiting) {
            var _latest$outerPresence, _latest$outerPresence2;
            (_latest$outerPresence = (_latest$outerPresence2 = latest.outerPresence).onFinish) === null || _latest$outerPresence === void 0 || _latest$outerPresence.call(_latest$outerPresence2);
        }
        if (latest.status === (0, $70a8f76075a95e27$export$74452314b63acabc).Removed) {
            var _latest$onExitComplet;
            (_latest$onExitComplet = latest.onExitComplete) === null || _latest$onExitComplet === void 0 || _latest$onExitComplet.call(latest);
        }
    }, []);
    (0, $5FkrB.useEffect)(function() {
        if (isRemoved && (0, $f3900a8d038b1536$export$b7baf7667a68d87c)() && !hasCompletedReducedMotionExit.current) {
            hasCompletedReducedMotionExit.current = true;
            onMotionExitComplete();
        }
    }, [
        isRemoved,
        onMotionExitComplete
    ]);
    return /*#__PURE__*/ $5FkrB.createElement((0, $44bece14de74cdc3$export$2e2bcd8739ae039), {
        appear: shouldAppear
    }, !isRemoved && /*#__PURE__*/ $5FkrB.createElement($e873e61352e9253a$var$TagMotionContent, {
        key: $e873e61352e9253a$var$tagMotionKey,
        forwardedRef: forwardedRef,
        onExitComplete: onMotionExitComplete
    }, children));
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $9b6ff4ababde8cfc$export$84acd183858d8235() {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isLinkHovered = _useState2[0], setIsLinkHovered = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), isOverButton = _useState4[0], setIsOverButton = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), isButtonFocused = _useState6[0], setIsButtonFocused = _useState6[1];
    var _useState7 = (0, $5FkrB.useState)(false), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState7, 2), isLinkFocused = _useState8[0], setIsLinkFocused = _useState8[1];
    // Track if last interaction was via mouse (to determine keyboard vs mouse focus)
    var hadMouseDownRef = (0, $5FkrB.useRef)(false);
    // Button handlers
    var buttonHandlers = (0, $5FkrB.useMemo)(function() {
        return {
            onMouseEnter: function onMouseEnter() {
                return setIsOverButton(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setIsOverButton(false);
            },
            onMouseDown: function onMouseDown(e) {
                // Prevent the browser from moving focus to the remove button on mousedown.
                // Without this, parent composite widgets (e.g. Select) lose input focus when
                // the user clicks remove, triggering unwanted blur side-effects.
                e === null || e === void 0 || e.preventDefault();
                hadMouseDownRef.current = true;
            },
            onFocus: function onFocus() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsButtonFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function onBlur() {
                return setIsButtonFocused(false);
            }
        };
    }, []);
    // Link handlers - includes hover tracking
    var linkHandlers = (0, $5FkrB.useMemo)(function() {
        return {
            onMouseEnter: function onMouseEnter() {
                return setIsLinkHovered(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setIsLinkHovered(false);
            },
            onMouseDown: function onMouseDown() {
                hadMouseDownRef.current = true;
            },
            onFocus: function onFocus() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsLinkFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function onBlur() {
                return setIsLinkFocused(false);
            }
        };
    }, []);
    return {
        isLinkHovered: isLinkHovered,
        isOverButton: isOverButton,
        isButtonFocused: isButtonFocused,
        isLinkFocused: isLinkFocused,
        buttonHandlers: buttonHandlers,
        linkHandlers: linkHandlers
    };
}



var $8F9hT = parcelRequire("8F9hT");
function $3f6f04e70ee9aa2f$export$dcf14c9974fe2767(href, linkComponent) {
    var isLink = Boolean(href);
    var LinkComponent = linkComponent !== null && linkComponent !== void 0 ? linkComponent : (0, $8F9hT.default);
    return {
        isLink: isLink,
        LinkComponent: LinkComponent
    };
}


/**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $5FkrB = parcelRequire("5FkrB");
/* remove-button.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");


var $hRJ5R = parcelRequire("hRJ5R");

var $ac8VW = parcelRequire("ac8VW");


var $btdNC = parcelRequire("btdNC");
var $895b521df4e93c7f$var$removeButtonStyles = {
    root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i1j6v _1bsb1j6v _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah3idpf _irr31dpa _1di6fcek",
    circle: "_2rko1rr0 _1ah3idpf",
    focusRing: "_1ah3v77o",
    newIcon: "_rjxpv77o"
};
var $895b521df4e93c7f$var$RemoveButton = function RemoveButton(_ref) {
    var ariaLabel = _ref['aria-label'], onClick = _ref.onClick, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onKeyPress = _ref.onKeyPress, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onMouseDown = _ref.onMouseDown, onMouseUp = _ref.onMouseUp, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, testId = _ref.testId, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? 'default' : _ref$shape;
    return /*#__PURE__*/ $5FkrB.createElement((0, $btdNC.Pressable), {
        xcss: (0, $hRJ5R.cx)($895b521df4e93c7f$var$removeButtonStyles.root, shape === 'circle' && $895b521df4e93c7f$var$removeButtonStyles.circle, $895b521df4e93c7f$var$removeButtonStyles.newIcon, (0, $68452a212463a8b0$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts') && $895b521df4e93c7f$var$removeButtonStyles.focusRing),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: testId
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ac8VW))), {
        color: "currentColor",
        label: "",
        size: "small"
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$895b521df4e93c7f$export$2e2bcd8739ae039 = $895b521df4e93c7f$var$RemoveButton;


function $c1ad5dceaed0665b$export$97d8be09cd53869b(_ref) {
    var isRemovable = _ref.isRemovable, tagText = _ref.tagText, removeButtonLabel = _ref.removeButtonLabel, testId = _ref.testId, handleRemoveRequest = _ref.handleRemoveRequest, removingTag = _ref.removingTag, showingTag = _ref.showingTag, onKeyPress = _ref.onKeyPress, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? 'default' : _ref$shape, buttonHandlers = _ref.buttonHandlers;
    var handleFocus = (0, $5FkrB.useCallback)(function() {
        removingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onFocus();
    }, [
        removingTag,
        buttonHandlers
    ]);
    var handleBlur = (0, $5FkrB.useCallback)(function() {
        showingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onBlur();
    }, [
        showingTag,
        buttonHandlers
    ]);
    return (0, $5FkrB.useMemo)(function() {
        if (!isRemovable) return undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $895b521df4e93c7f$export$2e2bcd8739ae039), {
            "aria-label": "".concat(removeButtonLabel || 'Remove', " ").concat(tagText),
            onClick: handleRemoveRequest,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyPress: onKeyPress,
            onMouseEnter: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseEnter,
            onMouseLeave: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseLeave,
            onMouseDown: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseDown,
            testId: testId ? "close-button-".concat(testId) : undefined,
            shape: shape
        });
    }, [
        isRemovable,
        removeButtonLabel,
        tagText,
        handleRemoveRequest,
        handleFocus,
        handleBlur,
        onKeyPress,
        buttonHandlers,
        testId,
        shape
    ]);
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
var $9c6282511621ab31$export$279e7025ed114474 = function defaultBeforeRemoveAction() {
    return true;
};



function $f80fd095f865d480$export$f26019543e9f862f(onBeforeRemoveAction) {
    var _useState = (0, $5FkrB.useState)((0, $70a8f76075a95e27$export$74452314b63acabc).Showing), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var handleRemoveRequest = (0, $5FkrB.useCallback)(function() {
        var beforeAction = onBeforeRemoveAction !== null && onBeforeRemoveAction !== void 0 ? onBeforeRemoveAction : (0, $9c6282511621ab31$export$279e7025ed114474);
        if (beforeAction()) // Defer onAfterRemoveAction until ShrinkOut's onFinish so ExitingPersistence can run
        // the exit animation (e.g. in multi-select and user pickers).
        setStatus((0, $70a8f76075a95e27$export$74452314b63acabc).Removed);
    }, [
        onBeforeRemoveAction
    ]);
    var onKeyPress = (0, $5FkrB.useCallback)(function(e) {
        var spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    var removingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus((0, $70a8f76075a95e27$export$74452314b63acabc).Removing);
    }, []);
    var showingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus((0, $70a8f76075a95e27$export$74452314b63acabc).Showing);
    }, []);
    return {
        status: status,
        handleRemoveRequest: handleRemoveRequest,
        onKeyPress: onKeyPress,
        removingTag: removingTag,
        showingTag: showingTag
    };
}


var $6ac7b3a4d246614d$var$_excluded = [
    "color",
    "text",
    "elemBefore",
    "href",
    "linkComponent",
    "isRemovable",
    "removeButtonLabel",
    "onBeforeRemoveAction",
    "onAfterRemoveAction",
    "testId",
    "maxWidth",
    "hasMargin",
    "onClick",
    "swatchBefore",
    "swatchBeforeLabel",
    "swatchBeforeRole",
    "trailingMetric"
], $6ac7b3a4d246614d$var$_excluded2 = [
    "color",
    "text",
    "elemBefore",
    "testId",
    "maxWidth",
    "hasMargin",
    "onClick",
    "isSelected",
    "isLoading",
    "analyticsContext",
    "hasChevron",
    "swatchBefore",
    "swatchBeforeLabel",
    "swatchBeforeRole",
    "trailingMetric"
];
var $6ac7b3a4d246614d$var$styles = {
    baseStyles: "_zulp1b66 _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1rjcv77o _18zr1mie _1mou1b66 _195g1b66 _1e0c116y _vchhusvi _1ul9idpf _p12ff6dh _4t3i1k92 _kqswh2mm _4cvr1h6o _80om73ad _bfhksm61",
    noMarginStyles: "_1mouze3t _195gze3t",
    removableStyles: "_zulp1b66",
    beforeStyles: "_4bfu1snc _1hmsagmp _ajmmvv82 _1e0c116y _4cvr1h6o _1o9zidpf _syaz125o",
    beforeStylesSelected: "_syazxl6c",
    textStyles: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n _1ul9idpf _syazi7uo",
    textStylesSelected: "_syaz6x5g",
    afterStyles: "_1e0c1txw _4cvr1h6o _1o9zidpf _lcxv1wug _kqswh2mm",
    afterMotionStyles: "_1ul9utpp",
    trailingMetric: "_2rkolb4i _11c8wadc _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _4cvr1h6o _1o9zidpf _1kz6184x _bfhk1w9g _syazi7uo",
    trailingMetricEndPadding: "_y4ti303w",
    focusRingStyles: "_1ygbdfik _1ah3v77o",
    childFocusRingStyles: "_1a37dfik _1cwgv77o",
    interactiveBaseStyles: "_80omtlke _1all1b66 _qsdj1r31 _17ncglyw _15hpnqa1 _1rg815vq _1yoo15vq _j8j91snc _1afaagmp _gdbt10yn _h5vp116y _1qxz1h6o _8zx0idpf _1km4jdj5 _wc1fagmp _9408jdj5 _usew1snc _ebtnagmp _uvk910yn _10nj1r31 _1xq0glyw _18x1nqa1 _2mpsagmp",
    interactiveHoverStyles: "_17501r31 _qrsc8stv _1wodnqa1 _irr31dpa _rlyhjdj5 _1di6fcek",
    interactiveMotionStyles: "_v564k6bl _1ggl5xtf",
    activeMotionStyles: "_1reo15vq _18m915vq _8hrz1e5h",
    enteringMotionStyles: "_y44v1ukz _1bumglyw",
    exitingMotionStyles: "_y44v12ef _1bumglyw"
};
// For accent borders, we use the new color.border.accent.*.subtle tokens (Color300
// light / Color800 dark) which provide proper decorative-border colours
//
// Icons keep color.icon.accent.* in the default state (vibrant on the plain page
// background) and swap to color.text.accent.* in hovered/pressed states (where the
// Tag picks up a coloured background and needs guaranteed 3:1 icon contrast).
var $6ac7b3a4d246614d$var$colorStyles = {
    gray: "_119bmsup _1ib21diz _egnk1sqi _17x31sqi _ih6z7qp0",
    blue: "_119b18hp _1ib26txe _egnk16jw _17x316jw _ih6z1dy8",
    green: "_119b5d2u _1ib217hp _egnkh55r _17x3h55r _ih6z1wnw",
    red: "_119bn9dc _1ib2nbxb _egnk9lu1 _17x39lu1 _ih6z1rtt",
    yellow: "_119b1s7j _1ib21oqg _egnkfb2s _17x3fb2s _ih6z1773",
    purple: "_119bluwt _1ib2uq3u _egnkqmo9 _17x3qmo9 _ih6z1nm4",
    lime: "_119b1m7d _1ib28645 _egnk1tco _17x31tco _ih6zz2ec",
    magenta: "_119b132u _1ib2v8hk _egnk1s8m _17x31s8m _ih6zv9ra",
    orange: "_119b1ip5 _1ib21j6y _egnkp1lv _17x3p1lv _ih6z165s",
    teal: "_119b131p _1ib28uof _egnk17qg _17x317qg _ih6z1a17"
};
// Border + icon filter styles - base state.
// Borders use the new color.border.accent.*.subtle tokens directly.
// Icons use the color.icon.accent.* tokens directly in the default state.
var $6ac7b3a4d246614d$var$borderIconFilterStyles = {
    root: "_1h6dip4g _wi6h9ea2"
};
// Border + icon filter styles - interactive states (hover/pressed).
// Icons swap to the color.text.accent.* tokens for guaranteed 3:1 contrast
// against the coloured interactive backgrounds. Borders stay constant.
var $6ac7b3a4d246614d$var$borderIconInteractiveFilterStyles = {
    root: "_4cvxip4g _zqoiipvw _q4ztip4g _ba35u0j8"
};
var $6ac7b3a4d246614d$var$dropdownStyles = {
    interactive: "_irr31dpa _1di6fcek",
    selected: "_1h6dq98m _syaz6x5g _bfhk15s3 _irr3ufnl _1di6nozp",
    content: "_zulp1b66 _1reo15vq _18m915vq _1e0c116y _4cvr1h6o _16jlkb7n _1o9zkb7n _1ul9idpf",
    loadingMotion: "_k8m0brmi _1oec1ign _6fl4indk _sedtglyw",
    loadingOverlayMotion: "_j7hq1bym _5sag1ign _1pglindk _1bumglyw",
    loadingContent: "_tzy4idpf",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw"
};
/**
 * __TagNew__
 *
 * TagNew is the visual uplift implementation of Tag
 */ var $6ac7b3a4d246614d$var$TagNewComponent = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TagNew(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'gray' : _ref$color, text = _ref.text, elemBefore = _ref.elemBefore, href = _ref.href, linkComponent = _ref.linkComponent, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, removeButtonLabel = _ref.removeButtonLabel, onBeforeRemoveAction = _ref.onBeforeRemoveAction, onAfterRemoveAction = _ref.onAfterRemoveAction, testId = _ref.testId, maxWidth = _ref.maxWidth, _ref$hasMargin = _ref.hasMargin, hasMargin = _ref$hasMargin === void 0 ? true : _ref$hasMargin, onClick = _ref.onClick, swatchBefore = _ref.swatchBefore, swatchBeforeLabel = _ref.swatchBeforeLabel, swatchBeforeRole = _ref.swatchBeforeRole, trailingMetric = _ref.trailingMetric, other = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $6ac7b3a4d246614d$var$_excluded);
    var normalizedText = (0, $ca23aee08bc5176e$export$7d100de1166870f6)(text);
    var _useTagRemoval = (0, $f80fd095f865d480$export$f26019543e9f862f)(onBeforeRemoveAction), status = _useTagRemoval.status, handleRemoveRequest = _useTagRemoval.handleRemoveRequest, onKeyPress = _useTagRemoval.onKeyPress, removingTag = _useTagRemoval.removingTag, showingTag = _useTagRemoval.showingTag;
    var onShrinkOutExitComplete = (0, $5FkrB.useCallback)(function() {
        onAfterRemoveAction === null || onAfterRemoveAction === void 0 || onAfterRemoveAction(normalizedText);
    }, [
        normalizedText,
        onAfterRemoveAction
    ]);
    var _useLink = (0, $3f6f04e70ee9aa2f$export$dcf14c9974fe2767)(href, linkComponent), isLink = _useLink.isLink, LinkComponent = _useLink.LinkComponent;
    var _useButtonInteraction = (0, $9b6ff4ababde8cfc$export$84acd183858d8235)(), isLinkHovered = _useButtonInteraction.isLinkHovered, isOverButton = _useButtonInteraction.isOverButton, isButtonFocused = _useButtonInteraction.isButtonFocused, isLinkFocused = _useButtonInteraction.isLinkFocused, buttonHandlers = _useButtonInteraction.buttonHandlers, linkHandlers = _useButtonInteraction.linkHandlers;
    var removeButton = (0, $c1ad5dceaed0665b$export$97d8be09cd53869b)({
        isRemovable: isRemovable,
        tagText: normalizedText,
        removeButtonLabel: removeButtonLabel,
        testId: testId,
        handleRemoveRequest: handleRemoveRequest,
        removingTag: removingTag,
        showingTag: showingTag,
        onKeyPress: onKeyPress,
        buttonHandlers: buttonHandlers
    });
    var isMotionEnabled = (0, $68452a212463a8b0$export$b40ec24ac8275656)('platform-dst-motion-uplift-labels');
    var renderTagContent = function renderTagContent(tagRef) {
        var isEntering = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var isExiting = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, other, {
            ref: tagRef,
            "data-testid": testId,
            style: maxWidth !== undefined ? {
                maxWidth: maxWidth
            } : undefined,
            className: (0, $970q7.default)([
                $6ac7b3a4d246614d$var$styles.baseStyles,
                !hasMargin && $6ac7b3a4d246614d$var$styles.noMarginStyles,
                $6ac7b3a4d246614d$var$colorStyles[color],
                $6ac7b3a4d246614d$var$borderIconFilterStyles.root,
                isLink && $6ac7b3a4d246614d$var$styles.interactiveBaseStyles,
                isLink && $6ac7b3a4d246614d$var$styles.focusRingStyles,
                isLink && isMotionEnabled && $6ac7b3a4d246614d$var$styles.interactiveMotionStyles,
                (isEntering || isExiting) && $6ac7b3a4d246614d$var$styles.activeMotionStyles,
                isEntering && $6ac7b3a4d246614d$var$styles.enteringMotionStyles,
                isExiting && $6ac7b3a4d246614d$var$styles.exitingMotionStyles,
                isLink && isLinkHovered && !isOverButton && $6ac7b3a4d246614d$var$borderIconInteractiveFilterStyles.root,
                isLink && isLinkHovered && !isOverButton && $6ac7b3a4d246614d$var$styles.interactiveHoverStyles,
                isRemovable && $6ac7b3a4d246614d$var$styles.removableStyles,
                isLinkFocused && !isButtonFocused && $6ac7b3a4d246614d$var$styles.childFocusRingStyles,
                !isRemovable && trailingMetric != null && trailingMetric !== '' && $6ac7b3a4d246614d$var$styles.trailingMetricEndPadding
            ])
        }), /*#__PURE__*/ $5FkrB.createElement((0, $55584633f11267eb$export$ce4b6a469c26f53f), {
            isLink: isLink,
            href: href,
            LinkComponent: LinkComponent,
            testId: testId,
            linkHandlers: linkHandlers,
            onClick: onClick
        }, /*#__PURE__*/ $5FkrB.createElement((0, $661ea088daf7f589$export$2e2bcd8739ae039), {
            colorKey: color,
            swatchBefore: swatchBefore,
            swatchBeforeLabel: swatchBeforeLabel,
            swatchBeforeRole: swatchBeforeRole
        }), elemBefore && /*#__PURE__*/ $5FkrB.createElement("span", {
            className: (0, $970q7.default)([
                $6ac7b3a4d246614d$var$styles.beforeStyles
            ])
        }, elemBefore), /*#__PURE__*/ $5FkrB.createElement("span", {
            "data-tag-text": true,
            className: (0, $970q7.default)([
                $6ac7b3a4d246614d$var$styles.textStyles
            ])
        }, normalizedText), trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ $5FkrB.createElement("span", {
            "data-testid": testId && "".concat(testId, "--metric"),
            className: (0, $970q7.default)([
                $6ac7b3a4d246614d$var$styles.trailingMetric
            ])
        }, trailingMetric)), removeButton && /*#__PURE__*/ $5FkrB.createElement("span", {
            className: (0, $970q7.default)([
                $6ac7b3a4d246614d$var$styles.afterStyles,
                isMotionEnabled && $6ac7b3a4d246614d$var$styles.afterMotionStyles
            ])
        }, !isExiting && removeButton));
    };
    if (isMotionEnabled) return /*#__PURE__*/ $5FkrB.createElement((0, $e873e61352e9253a$export$6adae1772ccf137c), {
        forwardedRef: ref,
        onExitComplete: isRemovable ? onShrinkOutExitComplete : undefined,
        status: status
    }, function(_ref2) {
        var isEntering = _ref2.isEntering, isExiting = _ref2.isExiting, motionRef = _ref2.ref;
        return renderTagContent(motionRef, isEntering, isExiting);
    });
    return /*#__PURE__*/ $5FkrB.createElement((0, $cfb8785e053c0b07$export$898a500849bb5cf4), {
        isRemovable: isRemovable,
        status: status,
        onShrinkOutExitComplete: isRemovable ? onShrinkOutExitComplete : undefined
    }, renderTagContent(ref));
});
var $6ac7b3a4d246614d$export$aba6bd1190e79361 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TagDropdownTrigger(_ref3, ref) {
    var _ref3$color = _ref3.color, color = _ref3$color === void 0 ? 'gray' : _ref3$color, text = _ref3.text, elemBefore = _ref3.elemBefore, testId = _ref3.testId, maxWidth = _ref3.maxWidth, _ref3$hasMargin = _ref3.hasMargin, hasMargin = _ref3$hasMargin === void 0 ? true : _ref3$hasMargin, onClick = _ref3.onClick, _ref3$isSelected = _ref3.isSelected, isSelected = _ref3$isSelected === void 0 ? false : _ref3$isSelected, _ref3$isLoading = _ref3.isLoading, isLoading = _ref3$isLoading === void 0 ? false : _ref3$isLoading, _analyticsContext = _ref3.analyticsContext, _ref3$hasChevron = _ref3.hasChevron, hasChevron = _ref3$hasChevron === void 0 ? true : _ref3$hasChevron, swatchBefore = _ref3.swatchBefore, swatchBeforeLabel = _ref3.swatchBeforeLabel, swatchBeforeRole = _ref3.swatchBeforeRole, trailingMetric = _ref3.trailingMetric, other = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref3, $6ac7b3a4d246614d$var$_excluded2);
    var resolvedColor = (0, $bb4829ea0d0f6c29$export$3351a8d90bcc13aa)[color] || 'gray';
    var isMotionEnabled = (0, $68452a212463a8b0$export$b40ec24ac8275656)('platform-dst-motion-uplift-labels');
    return /*#__PURE__*/ $5FkrB.createElement((0, $btdNC.Pressable), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: ref,
        xcss: (0, $hUFig.cx)($6ac7b3a4d246614d$var$styles.baseStyles, !hasMargin && $6ac7b3a4d246614d$var$styles.noMarginStyles, $6ac7b3a4d246614d$var$colorStyles[resolvedColor], $6ac7b3a4d246614d$var$borderIconFilterStyles.root, $6ac7b3a4d246614d$var$dropdownStyles.interactive, $6ac7b3a4d246614d$var$styles.focusRingStyles, $6ac7b3a4d246614d$var$borderIconInteractiveFilterStyles.root, isSelected && $6ac7b3a4d246614d$var$dropdownStyles.selected, isMotionEnabled && $6ac7b3a4d246614d$var$styles.interactiveMotionStyles, // Reduce end padding when trailing metric is the last element (no chevron)
        !hasChevron && trailingMetric != null && trailingMetric !== '' && $6ac7b3a4d246614d$var$styles.trailingMetricEndPadding),
        onClick: isLoading ? undefined : onClick,
        style: {
            borderColor: isSelected ? "var(--ds-border-selected, #1868DB)" : undefined,
            cursor: isLoading ? 'progress' : 'pointer',
            maxWidth: maxWidth !== undefined ? maxWidth : undefined
        }
    }, isLoading && {
        'aria-busy': true,
        'aria-disabled': true,
        isDisabled: true
    }, {
        testId: testId
    }, other), /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            $6ac7b3a4d246614d$var$dropdownStyles.content,
            isMotionEnabled && $6ac7b3a4d246614d$var$dropdownStyles.loadingMotion,
            isLoading && $6ac7b3a4d246614d$var$dropdownStyles.loadingContent
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $661ea088daf7f589$export$2e2bcd8739ae039), {
        colorKey: resolvedColor,
        swatchBefore: swatchBefore,
        swatchBeforeLabel: swatchBeforeLabel,
        swatchBeforeRole: swatchBeforeRole
    }), elemBefore && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            $6ac7b3a4d246614d$var$styles.beforeStyles,
            isSelected && $6ac7b3a4d246614d$var$styles.beforeStylesSelected
        ])
    }, elemBefore), /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-tag-text": true,
        className: (0, $970q7.default)([
            $6ac7b3a4d246614d$var$styles.textStyles,
            isSelected && $6ac7b3a4d246614d$var$styles.textStylesSelected
        ])
    }, (0, $ca23aee08bc5176e$export$7d100de1166870f6)(text)), trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId && "".concat(testId, "--metric"),
        className: (0, $970q7.default)([
            $6ac7b3a4d246614d$var$styles.trailingMetric
        ])
    }, trailingMetric), hasChevron && /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($h19KG))), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && "".concat(testId, "--chevron")
    })), isLoading && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            $6ac7b3a4d246614d$var$dropdownStyles.loadingOverlay,
            isMotionEnabled && $6ac7b3a4d246614d$var$dropdownStyles.loadingOverlayMotion
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $9ztDu.default), {
        size: 'xsmall',
        label: ", Loading",
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    })));
});
/**
 * __Tag new__
 */ var $6ac7b3a4d246614d$var$TagNew = (0, $9da3c9802f885960$export$88b132e52a65ec37)(/*#__PURE__*/ (0, $5FkrB.memo)($6ac7b3a4d246614d$var$TagNewComponent));
var $6ac7b3a4d246614d$export$2e2bcd8739ae039 = $6ac7b3a4d246614d$var$TagNew;



/* base.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $e7f26cc9fecfa6a9$var$_excluded = [
    "before",
    "contentElement",
    "after",
    "testId",
    "style",
    "color",
    "href",
    "className"
];
function $e7f26cc9fecfa6a9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e7f26cc9fecfa6a9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e7f26cc9fecfa6a9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e7f26cc9fecfa6a9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Border colors - Hardcoded for Visual Refresh - to be removed with labelling system work
var $e7f26cc9fecfa6a9$var$borderColors = {
    standard: "_1h6d14je",
    blue: "_1h6duisw",
    red: "_1h6da2c0",
    yellow: "_1h6deh2r",
    green: "_1h6d18uw",
    teal: "_1h6d1ug6",
    purple: "_1h6d157s",
    lime: "_1h6dn0nx",
    magenta: "_1h6d1lf6",
    orange: "_1h6dh727",
    grey: "_1h6d14je",
    standardLink: "_1h6d14je",
    blueLight: "_1h6duisw",
    redLight: "_1h6da2c0",
    yellowLight: "_1h6deh2r",
    greenLight: "_1h6d18uw",
    tealLight: "_1h6d1ug6",
    purpleLight: "_1h6d157s",
    limeLight: "_1h6dn0nx",
    magentaLight: "_1h6d1lf6",
    orangeLight: "_1h6dh727",
    greyLight: "_1h6d14je"
};
var $e7f26cc9fecfa6a9$var$baseStyles = null;
var $e7f26cc9fecfa6a9$var$interactiveStyles = null;
var $e7f26cc9fecfa6a9$var$focusRingStyles = null;
var $e7f26cc9fecfa6a9$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function BaseTag(_ref, ref) {
    var before = _ref.before, contentElement = _ref.contentElement, after = _ref.after, testId = _ref.testId, style = _ref.style, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, className = _ref.className, other = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $e7f26cc9fecfa6a9$var$_excluded);
    var isLink = Boolean(href);
    var isRemovable = Boolean(after);
    var isInteractive = isLink || isRemovable;
    if (color === 'gray') // internally we use 'grey' for gray color so that we can make migration easier behind the ff (gray will work with and without ff now)
    color = 'grey';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, other, {
        ref: ref,
        style: $e7f26cc9fecfa6a9$var$_objectSpread({}, style),
        className: (0, $970q7.default)([
            "_zulp1b66 _2rko12b0 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3i1k92 _kqswh2mm _4cvr1h6o _bfhksm61 _syazi7uo _80om73ad",
            isInteractive && "_1e38dfik _7glxv77o",
            isLink && "_irr31dpa _1di6fcek",
            $e7f26cc9fecfa6a9$var$borderColors[color],
            className
        ]),
        "data-testid": testId
    }), before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e7f26cc9fecfa6a9$export$2e2bcd8739ae039 = $e7f26cc9fecfa6a9$var$BaseTag;


/* before.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $afaa8a7ef96fe4da$var$beforeElementStyles = null;
var $afaa8a7ef96fe4da$var$Before = function Before(_ref) {
    var elemBefore = _ref.elemBefore;
    return elemBefore ? /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            "_1e0c1txw _4t3i1j6v _4cvr1h6o _1bah1h6o _152tze3t"
        ])
    }, elemBefore) : null;
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$afaa8a7ef96fe4da$export$2e2bcd8739ae039 = $afaa8a7ef96fe4da$var$Before;


/**
 * Maps Tag color values to Lozenge appearance values.
 * Used for migration_fallback rendering when feature flag is off.
 */ var $702b896b869a8501$var$colorToLozengeAppearanceMap = {
    gray: 'default',
    grey: 'default',
    lime: 'success',
    green: 'success',
    blue: 'inprogress',
    red: 'removed',
    purple: 'new',
    yellow: 'moved',
    orange: 'moved',
    magenta: 'new',
    teal: 'inprogress',
    grayLight: 'default',
    greyLight: 'default',
    limeLight: 'success',
    greenLight: 'success',
    blueLight: 'inprogress',
    redLight: 'removed',
    purpleLight: 'new',
    yellowLight: 'moved',
    orangeLight: 'moved',
    magentaLight: 'new',
    tealLight: 'inprogress'
};
function $702b896b869a8501$export$4d9e331cafeacb9d(color) {
    return $702b896b869a8501$var$colorToLozengeAppearanceMap[color || 'gray'] || 'default';
}


/* content.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $d7c7a4280869cb92$var$baseStyles = null;
var $d7c7a4280869cb92$var$linkStyles = null;
var $d7c7a4280869cb92$var$hasAfterStyles = null;
var $d7c7a4280869cb92$var$Content = function Content(_ref) {
    var _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? '' : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, linkComponent = _ref.linkComponent, testId = _ref.testId;
    var Link = linkComponent !== null && linkComponent !== void 0 ? linkComponent : 'a';
    var normalizedText = (0, $ca23aee08bc5176e$export$7d100de1166870f6)(text);
    if (href) return /*#__PURE__*/ $5FkrB.createElement(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? "".concat(testId, "--link") : undefined,
        className: (0, $970q7.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazi7uo _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3i7uo _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
            isRemovable && "_p12f1lit"
        ])
    }, normalizedText);
    else return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            isRemovable && "_p12f1lit"
        ])
    }, normalizedText);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d7c7a4280869cb92$export$2e2bcd8739ae039 = $d7c7a4280869cb92$var$Content;



var $193eabfa81e05e00$var$_excluded = [
    "appearance",
    "elemBefore",
    "isRemovable",
    "text",
    "color",
    "href",
    "removeButtonLabel",
    "testId",
    "onBeforeRemoveAction",
    "onAfterRemoveAction",
    "linkComponent",
    "migration_fallback",
    "maxWidth",
    "hasMargin",
    "swatchBefore",
    "swatchBeforeLabel",
    "swatchBeforeRole"
];
var $193eabfa81e05e00$var$textLinkCssVar = '--ds-ctl';
var $193eabfa81e05e00$var$textDefaultCssVar = '--ds-ct';
var $193eabfa81e05e00$var$textActiveCssVar = '--ds-ctp';
var $193eabfa81e05e00$var$backgroundHoverCssVar = '--ds-cbh';
var $193eabfa81e05e00$var$backgroundActiveCssVar = '--ds-cba';
var $193eabfa81e05e00$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($193eabfa81e05e00$var$TagStatus || {});
var $193eabfa81e05e00$var$packageName = "@atlaskit/tag";
var $193eabfa81e05e00$var$packageVersion = "15.7.2";
var $193eabfa81e05e00$var$defaultBeforeRemoveAction = function defaultBeforeRemoveAction() {
    return true;
};
/**
 * These hide the focus ring for the tag when its remove button is focused,
 * preventing a double focus ring.
 */ var $193eabfa81e05e00$var$removingStyles = null;
var $193eabfa81e05e00$var$RemovableTagComponent = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var appearance = _ref.appearance, _ref$elemBefore = _ref.elemBefore, elemBefore = _ref$elemBefore === void 0 ? null : _ref$elemBefore, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? '' : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, removeButtonLabel = _ref.removeButtonLabel, testId = _ref.testId, _ref$onBeforeRemoveAc = _ref.onBeforeRemoveAction, onBeforeRemoveAction = _ref$onBeforeRemoveAc === void 0 ? $193eabfa81e05e00$var$defaultBeforeRemoveAction : _ref$onBeforeRemoveAc, _ref$onAfterRemoveAct = _ref.onAfterRemoveAction, onAfterRemoveAction = _ref$onAfterRemoveAct === void 0 ? (0, $eVb4V.default) : _ref$onAfterRemoveAct, linkComponent = _ref.linkComponent, migration_fallback = _ref.migration_fallback, maxWidth = _ref.maxWidth, _ref$hasMargin = _ref.hasMargin, hasMargin = _ref$hasMargin === void 0 ? true : _ref$hasMargin, swatchBefore = _ref.swatchBefore, swatchBeforeLabel = _ref.swatchBeforeLabel, swatchBeforeRole = _ref.swatchBeforeRole, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $193eabfa81e05e00$var$_excluded);
    var _useState = (0, $5FkrB.useState)($193eabfa81e05e00$var$TagStatus.Showing), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), isHoverCloseButton = _useState4[0], setIsHoverCloseButton = _useState4[1];
    var normalizedText = (0, $ca23aee08bc5176e$export$7d100de1166870f6)(text);
    var onAfterRemoveActionWithAnalytics = (0, $5597405245131e6e$export$53c2b9c37c40e0d8)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $193eabfa81e05e00$var$packageName,
            packageVersion: $193eabfa81e05e00$var$packageVersion
        }
    }, 'atlaskit');
    var handleRemoveComplete = (0, $5FkrB.useCallback)(function() {
        setStatus($193eabfa81e05e00$var$TagStatus.Removed);
    }, []);
    var handleRemoveRequest = (0, $5FkrB.useCallback)(function() {
        if (onBeforeRemoveAction && onBeforeRemoveAction()) {
            onAfterRemoveActionWithAnalytics(normalizedText);
            handleRemoveComplete();
        }
    }, [
        handleRemoveComplete,
        normalizedText,
        onBeforeRemoveAction,
        onAfterRemoveActionWithAnalytics
    ]);
    var onKeyPress = (0, $5FkrB.useCallback)(function(e) {
        var spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    var removingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus($193eabfa81e05e00$var$TagStatus.Removing);
    }, []);
    var showingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus($193eabfa81e05e00$var$TagStatus.Showing);
    }, []);
    var handleMouseOver = (0, $5FkrB.useCallback)(function() {
        return setIsHoverCloseButton(true);
    }, []);
    var handleMouseOut = (0, $5FkrB.useCallback)(function() {
        return setIsHoverCloseButton(false);
    }, []);
    var removeButton = isRemovable ? /*#__PURE__*/ $5FkrB.createElement((0, $895b521df4e93c7f$export$2e2bcd8739ae039), {
        "aria-label": "".concat(removeButtonLabel || 'Remove', " ").concat(normalizedText),
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: "close-button-".concat(testId)
    }) : undefined;
    // Handle migration_fallback: render Lozenge when flag is off and migration_fallback is 'lozenge'
    if (migration_fallback === 'lozenge' && !(0, $68452a212463a8b0$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        var lozengeAppearance = (0, $702b896b869a8501$export$4d9e331cafeacb9d)(color);
        return /*#__PURE__*/ $5FkrB.createElement((0, $5supy.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            appearance: lozengeAppearance,
            isBold: false,
            testId: testId
        }, rest), normalizedText);
    }
    // Use new TagNew component behind feature flag
    // TagNew handles its own animation internally via RemovableWrapper
    if ((0, $68452a212463a8b0$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        var newColor = (0, $bb4829ea0d0f6c29$export$3351a8d90bcc13aa)[color || 'standard'];
        return /*#__PURE__*/ $5FkrB.createElement((0, $6ac7b3a4d246614d$export$2e2bcd8739ae039), {
            ref: ref,
            color: newColor,
            text: normalizedText,
            elemBefore: elemBefore,
            href: href,
            testId: testId,
            isRemovable: isRemovable,
            removeButtonLabel: removeButtonLabel,
            onBeforeRemoveAction: onBeforeRemoveAction,
            onAfterRemoveAction: onAfterRemoveActionWithAnalytics,
            maxWidth: maxWidth,
            hasMargin: hasMargin,
            swatchBefore: swatchBefore,
            swatchBeforeLabel: swatchBeforeLabel,
            swatchBeforeRole: swatchBeforeRole
        });
    }
    // Original implementation
    var content = /*#__PURE__*/ $5FkrB.createElement((0, $d7c7a4280869cb92$export$2e2bcd8739ae039), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: normalizedText,
        color: color,
        href: href,
        linkComponent: linkComponent,
        testId: testId
    });
    var hoverCloseButtonColors = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
    }, $193eabfa81e05e00$var$backgroundHoverCssVar, undefined), $193eabfa81e05e00$var$backgroundActiveCssVar, undefined), $193eabfa81e05e00$var$textDefaultCssVar, undefined), $193eabfa81e05e00$var$textActiveCssVar, undefined), $193eabfa81e05e00$var$textLinkCssVar, undefined);
    return /*#__PURE__*/ $5FkrB.createElement((0, $44bece14de74cdc3$export$2e2bcd8739ae039), null, !(status === $193eabfa81e05e00$var$TagStatus.Removed) && /*#__PURE__*/ $5FkrB.createElement((0, $75016b43cbaa745a$export$2e2bcd8739ae039), {
        key: "atlaskit-removable-tag-legacy-shrink-out",
        onFinish: handleRemoveComplete
    }, function(motion) {
        return /*#__PURE__*/ $5FkrB.createElement((0, $e7f26cc9fecfa6a9$export$2e2bcd8739ae039), {
            ref: (0, $iO8GM.default)([
                motion.ref,
                ref
            ]),
            appearance: appearance,
            color: color,
            testId: testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
            "data-removable": true,
            "data-removing": status === $193eabfa81e05e00$var$TagStatus.Removing,
            "data-ishoverclosebutton": isHoverCloseButton,
            href: href,
            before: /*#__PURE__*/ $5FkrB.createElement((0, $afaa8a7ef96fe4da$export$2e2bcd8739ae039), {
                elemBefore: elemBefore
            }),
            contentElement: content,
            after: removeButton,
            className: (0, $970q7.default)([
                status === $193eabfa81e05e00$var$TagStatus.Removing && "_z30c1r31 _twwiglyw _1pka1o36 _bqhtfiwo"
            ])
        });
    }));
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ var $193eabfa81e05e00$var$RemovableTag = (0, $9da3c9802f885960$export$88b132e52a65ec37)(/*#__PURE__*/ (0, $5FkrB.memo)($193eabfa81e05e00$var$RemovableTagComponent));
var $193eabfa81e05e00$export$2e2bcd8739ae039 = $193eabfa81e05e00$var$RemovableTag;



/**
 * Hook to consume the SelectGetStylesContext.
 *
 * @internal — not part of the public API
 */ 
var $5FkrB = parcelRequire("5FkrB");
/**
 * Internal context used to pass the original Select instance's getStyles function
 * down to components like MultiValue, without polluting the public CommonProps API.
 *
 * This allows MultiValue to detect whether getStyles has been overridden on a
 * component instance (e.g. via a custom component wrapper passing a different
 * getStyles prop), by comparing props.getStyles against the original.
 *
 * @internal — not part of the public API
 */ 
var $5FkrB = parcelRequire("5FkrB");
var $7c7340f9e05f4af0$export$50727c0a52da4015 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);


var $d39f250c37413494$export$2a533455c10aa11f = function useSelectGetStyles() {
    return (0, $5FkrB.useContext)((0, $7c7340f9e05f4af0$export$50727c0a52da4015));
};



/* multi-value-label.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");
var $96a0b865fb98edab$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c8fhey _o5721q9c _y4tiv77o _bozg1b66 _syaz1kw7",
    disabled: "_syaz1gmx",
    ellipsis: "_1bto1l2s"
};
var $96a0b865fb98edab$export$544aeea2a5ce08ee = function MultiValueLabel(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isDisabled = _ref.isDisabled, hasEllipsis = _ref.hasEllipsis, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $96a0b865fb98edab$var$multiValueLabelStyles.root,
            isDisabled && $96a0b865fb98edab$var$multiValueLabelStyles.disabled,
            hasEllipsis && $96a0b865fb98edab$var$multiValueLabelStyles.ellipsis,
            (0, $hUFig.cx)(className, xcss, '-MultiValueLabel')
        ])
    }), children);
};


function $89cb846ac02cf9b6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $89cb846ac02cf9b6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $89cb846ac02cf9b6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $89cb846ac02cf9b6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $89cb846ac02cf9b6$var$multiValueTagWrapperStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1mouze3t _195gze3t _4cvr1h6o _1e0c1txw _1ul9ze3t _zdxokb7n _v5ynkb7n _13lsf1ug _3pxh1h6o _d0dz1txw _1ouwze3t"
};
var $89cb846ac02cf9b6$var$multiValueMotionStyles = {
    active: "_1reo15vq _18m915vq _8hrz1e5h",
    entering: "_y44v1ukz _1bumglyw",
    exiting: "_y44v12ef _1bumglyw"
};
// Tag-like color styles
var $89cb846ac02cf9b6$var$tagLikeColorStyles = {
    gray: "_119bmsup",
    blue: "_119b18hp",
    green: "_119b5d2u",
    red: "_119bn9dc",
    yellow: "_119b1s7j",
    purple: "_119bluwt",
    lime: "_119b1m7d",
    magenta: "_119b132u",
    orange: "_119b1ip5",
    teal: "_119b131p"
};
var $89cb846ac02cf9b6$var$tagLikeBorderFilterStyles = null;
// Tag-like styles for custom content values (not plain text) when FF is on.
// Mirrors the TagNew component's visual appearance (padding, margins, sizing, colors).
// The container uses tag-like styling while Label/Remove sub-components are preserved
// so custom overrides (e.g. custom aria-labels, rendering objects as data) continue to work.
var $89cb846ac02cf9b6$var$multiValueTagLikeStyles = {
    root: "_1reo15vq _18m915vq _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1mouze3t _195gze3t _1e0c116y _vchhusvi _kqswh2mm _4cvr1h6o _1wpz1h6o _1ul9ze3t _1o9zkb7n _p12ff6dh _4t3i1k92 _bfhksm61 _syazi7uo _80om73ad _3yq3glyw",
    labelWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _11c8wadc _1e0c1txw _4cvr1h6o _1ul9ze3t _1tkeidpf _2a9v1kw7",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk1dpa _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
var $89cb846ac02cf9b6$var$getMultiValueLabelText = function getMultiValueLabelText(children, data) {
    if (typeof children === 'string') return children;
    var label = data === null || data === void 0 ? void 0 : data.label;
    return typeof label === 'string' ? label : '';
};
var $89cb846ac02cf9b6$var$MultiValueContent = function MultiValueContent(contentProps) {
    var props = contentProps.multiValueProps, motionRef = contentProps.motionRef, motionState = contentProps.motionState;
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, isFocused = props.isFocused, removeProps = props.removeProps, selectProps = props.selectProps, cropWithEllipsis = props.cropWithEllipsis;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    var labelText = $89cb846ac02cf9b6$var$getMultiValueLabelText(children, data);
    var isPlainLabel = typeof children === 'string';
    var ffTagUplifts = (0, $9a15a8b9047bb706$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts');
    var isEnteringWithMotion = motionState === 'entering';
    var isExitingWithMotion = motionState === 'exiting';
    var _getStyleProps = (0, $2601addfebe56e71$export$26417cabd806a658)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    }), containerCss = _getStyleProps.css, containerClassName = _getStyleProps.className;
    var _getStyleProps2 = (0, $2601addfebe56e71$export$26417cabd806a658)(props, 'multiValueLabel', {
        'multi-value__label': true
    }), labelCss = _getStyleProps2.css, labelClassName = _getStyleProps2.className;
    var _getStyleProps3 = (0, $2601addfebe56e71$export$26417cabd806a658)(props, 'multiValueRemove', {
        'multi-value__remove': true
    }), removeCss = _getStyleProps3.css, removeClassName = _getStyleProps3.className;
    var hasCustomLabel = Label !== (0, $96a0b865fb98edab$export$544aeea2a5ce08ee);
    var hasCustomContainer = Container !== (0, $cd801d0089070243$export$cf9cf2a30a59265c);
    var selectStyles = selectProps.styles;
    var hasCustomMultiValueStyles = Boolean((selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValue) || (selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValueLabel) || (selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValueRemove));
    var selectClassNames = selectProps.classNames;
    var hasCustomMultiValueClassNames = Boolean((selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValue) || (selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValueLabel) || (selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValueRemove));
    // Detect if getStyles was overridden directly on this component instance (e.g. via the
    // components prop wrapper passing a custom getStyles). The context holds the original
    // Select instance's getStyles — a reference inequality means a custom override was passed.
    // When context is absent (e.g. in mocked/test contexts), assume no override.
    var selectGetStyles = (0, $d39f250c37413494$export$2a533455c10aa11f)();
    var hasOverriddenGetStyles = selectGetStyles !== undefined && props.getStyles !== selectGetStyles;
    var hasCustomContainerStyles = hasCustomMultiValueStyles || hasCustomMultiValueClassNames || hasOverriddenGetStyles;
    if (ffTagUplifts && isPlainLabel && !hasCustomLabel && !hasCustomContainer && !hasCustomContainerStyles) {
        var _ref = data !== null && data !== void 0 ? data : {}, elemBefore = _ref.elemBefore, tagColor = _ref.color;
        return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
            ref: motionRef,
            className: (0, $970q7.default)([
                $89cb846ac02cf9b6$var$multiValueTagWrapperStyles.root,
                isExitingWithMotion && $89cb846ac02cf9b6$var$multiValueMotionStyles.active,
                isExitingWithMotion && $89cb846ac02cf9b6$var$multiValueMotionStyles.exiting,
                (0, $hUFig.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ])
        }), /*#__PURE__*/ $5FkrB.createElement((0, $193eabfa81e05e00$export$2e2bcd8739ae039), {
            text: labelText,
            isRemovable: !isDisabled,
            removeButtonLabel: "".concat(labelText, ", remove"),
            onBeforeRemoveAction: function onBeforeRemoveAction() {
                var _removeProps$onClick;
                (_removeProps$onClick = removeProps.onClick) === null || _removeProps$onClick === void 0 || _removeProps$onClick.call(removeProps, {});
                return false;
            },
            color: tagColor !== null && tagColor !== void 0 ? tagColor : 'gray',
            elemBefore: elemBefore,
            hasMargin: false
        }));
    }
    // FF on + custom content → tag-like path
    if (ffTagUplifts && !hasCustomContainer) {
        var colorKey = data === null || data === void 0 ? void 0 : data.color;
        return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            "data-multi-value-tag-like": "true"
        }, innerProps, {
            ref: motionRef,
            style: containerCss,
            className: (0, $970q7.default)([
                $89cb846ac02cf9b6$var$multiValueTagLikeStyles.root,
                $89cb846ac02cf9b6$var$tagLikeColorStyles.gray,
                colorKey === 'blue' && $89cb846ac02cf9b6$var$tagLikeColorStyles.blue,
                colorKey === 'green' && $89cb846ac02cf9b6$var$tagLikeColorStyles.green,
                colorKey === 'red' && $89cb846ac02cf9b6$var$tagLikeColorStyles.red,
                colorKey === 'yellow' && $89cb846ac02cf9b6$var$tagLikeColorStyles.yellow,
                colorKey === 'purple' && $89cb846ac02cf9b6$var$tagLikeColorStyles.purple,
                colorKey === 'lime' && $89cb846ac02cf9b6$var$tagLikeColorStyles.lime,
                colorKey === 'magenta' && $89cb846ac02cf9b6$var$tagLikeColorStyles.magenta,
                colorKey === 'orange' && $89cb846ac02cf9b6$var$tagLikeColorStyles.orange,
                colorKey === 'teal' && $89cb846ac02cf9b6$var$tagLikeColorStyles.teal,
                "_1h6dip4g",
                isDisabled && $89cb846ac02cf9b6$var$multiValueTagLikeStyles.disabled,
                isFocused && $89cb846ac02cf9b6$var$multiValueTagLikeStyles.focused,
                (isEnteringWithMotion || isExitingWithMotion) && $89cb846ac02cf9b6$var$multiValueMotionStyles.active,
                isEnteringWithMotion && $89cb846ac02cf9b6$var$multiValueMotionStyles.entering,
                isExitingWithMotion && $89cb846ac02cf9b6$var$multiValueMotionStyles.exiting,
                (0, $hUFig.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ])
        }), /*#__PURE__*/ $5FkrB.createElement("div", {
            className: (0, $970q7.default)([
                $89cb846ac02cf9b6$var$multiValueTagLikeStyles.labelWrapper
            ])
        }, /*#__PURE__*/ $5FkrB.createElement(Label, {
            data: data,
            innerProps: {
                style: labelCss,
                className: labelClassName
            },
            className: labelClassName,
            hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
            selectProps: selectProps
        }, children)), /*#__PURE__*/ $5FkrB.createElement(Remove, {
            data: data,
            innerProps: $89cb846ac02cf9b6$var$_objectSpread({
                style: removeCss,
                className: removeClassName,
                role: 'button',
                tabIndex: -1,
                'aria-label': "".concat(labelText || 'option', ", remove")
            }, removeProps),
            className: removeClassName,
            isDisabled: isDisabled,
            selectProps: selectProps
        }));
    }
    // FF off → default styles
    return /*#__PURE__*/ $5FkrB.createElement(Container, {
        data: data,
        innerProps: $89cb846ac02cf9b6$var$_objectSpread({
            style: containerCss,
            className: containerClassName
        }, innerProps),
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps
    }, /*#__PURE__*/ $5FkrB.createElement(Label, {
        data: data,
        innerProps: {
            style: labelCss,
            className: labelClassName
        },
        className: labelClassName,
        hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
        selectProps: selectProps
    }, children), /*#__PURE__*/ $5FkrB.createElement(Remove, {
        data: data,
        innerProps: $89cb846ac02cf9b6$var$_objectSpread({
            style: removeCss,
            className: removeClassName,
            role: 'button',
            tabIndex: -1,
            'aria-label': "".concat(labelText || 'option', ", remove")
        }, removeProps),
        className: removeClassName,
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var $89cb846ac02cf9b6$var$MotionMultiValue = function MotionMultiValue(props) {
    var multiValueProps = props.multiValueProps;
    var _useMotion = (0, $ae09c2b1e5b3d62e$export$2a51cfe9390d36ef)({
        onFinish: function onFinish(motionState) {
            if (motionState === 'exiting') {
                var _multiValueProps$onMo;
                (_multiValueProps$onMo = multiValueProps.onMotionFinish) === null || _multiValueProps$onMo === void 0 || _multiValueProps$onMo.call(multiValueProps);
            }
        }
    }), ref = _useMotion.ref, state = _useMotion.state;
    return /*#__PURE__*/ $5FkrB.createElement($89cb846ac02cf9b6$var$MultiValueContent, {
        multiValueProps: multiValueProps,
        motionRef: ref,
        motionState: state
    });
};
var $89cb846ac02cf9b6$var$MultiValue = function MultiValue(props) {
    if (props.isMotionEnabled) return /*#__PURE__*/ $5FkrB.createElement($89cb846ac02cf9b6$var$MotionMultiValue, {
        multiValueProps: props
    });
    return /*#__PURE__*/ $5FkrB.createElement($89cb846ac02cf9b6$var$MultiValueContent, {
        multiValueProps: props
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$89cb846ac02cf9b6$export$2e2bcd8739ae039 = $89cb846ac02cf9b6$var$MultiValue;



/* multi-value-remove.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $ac8VW = parcelRequire("ac8VW");
var $d41fb44411b62bc0$var$disabledStyles = null;
var $d41fb44411b62bc0$var$enabledStyles = null;
var $d41fb44411b62bc0$var$multiValueRemoveStyles = {
    focused: "_bfhkb1q9 _lswu6x5g",
    root: "_19itglyw _2rko12b0 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _1e0c1txw _lswui7uo _1q51v77o _y4tiv77o _85i5v77o _bozgv77o _12l2v77o _1ah312gs _irr31dpa _13br1tmw _1di6fcek _i5f81tmw"
};
function $d41fb44411b62bc0$export$8e1fd1a40e7a2f4a(_ref) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, innerProps = _ref.innerProps, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $d41fb44411b62bc0$var$multiValueRemoveStyles.root,
            isFocused && $d41fb44411b62bc0$var$multiValueRemoveStyles.focused,
            (0, $hUFig.cx)(className, xcss, '-MultiValueRemove')
        ])
    }), /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
        className: (0, $970q7.default)([
            isDisabled && "_1e0cglyw",
            !isDisabled && "_1e0c1kw7"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ac8VW))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
}


/* option.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");


var $204703ed812bebb3$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syazi7uo _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di6fcek",
    disabled: "_syaz1gmx _80om13gf _bfhk1j28 _16qsglyw _1di61j28 _112eglyw",
    focused: "_bfhk1dpa _16qs1x9r _112e5u6v",
    selected: "_syaz6x5g _bfhk15s3 _16qs1x9r _1di6nozp _112e5u6v",
    focusedSelected: "_bfhkufnl",
    motion: "_v564hxmd _o7kshxmd _1ggl87vo",
    motionSelected: "_v5641rrn _o7kshxmd"
};
var $204703ed812bebb3$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $2601addfebe56e71$export$26417cabd806a658)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $204703ed812bebb3$var$optionStyles.root,
            !isDisabled && !isSelected && (0, $9a15a8b9047bb706$export$b40ec24ac8275656)('platform-dst-motion-uplift-list-item') && $204703ed812bebb3$var$optionStyles.motion,
            isFocused && $204703ed812bebb3$var$optionStyles.focused,
            isSelected && $204703ed812bebb3$var$optionStyles.selected,
            isFocused && isSelected && $204703ed812bebb3$var$optionStyles.focusedSelected,
            !isDisabled && isSelected && (0, $9a15a8b9047bb706$export$b40ec24ac8275656)('platform-dst-motion-uplift-list-item') && $204703ed812bebb3$var$optionStyles.motionSelected,
            isDisabled && $204703ed812bebb3$var$optionStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-option')
        ]),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$204703ed812bebb3$export$2e2bcd8739ae039 = $204703ed812bebb3$var$Option;


/* placeholder.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $c8dd7d6567de36ab$var$placeholderStyles = {
    root: "_nd5l1sux _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syaz1rpy",
    disabled: "_syaz1gmx"
};
var $c8dd7d6567de36ab$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, xcss = props.xcss;
    var _getStyleProps = (0, $2601addfebe56e71$export$26417cabd806a658)(props, 'placeholder', {
        placeholder: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $c8dd7d6567de36ab$var$placeholderStyles.root,
            isDisabled && $c8dd7d6567de36ab$var$placeholderStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-placeholder')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c8dd7d6567de36ab$export$2e2bcd8739ae039 = $c8dd7d6567de36ab$var$Placeholder;


/* single-value.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $196bf38ba8e23074$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syazi7uo",
    disalbed: "_syaz1gmx"
};
var $196bf38ba8e23074$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $2601addfebe56e71$export$26417cabd806a658)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $196bf38ba8e23074$var$styles.root,
            isDisabled && $196bf38ba8e23074$var$styles.disalbed,
            (0, $hUFig.cx)(className, xcss, '-singleValue')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$196bf38ba8e23074$export$2e2bcd8739ae039 = $196bf38ba8e23074$var$SingleValue;


function $5363260948404c2f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5363260948404c2f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5363260948404c2f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5363260948404c2f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5363260948404c2f$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $9f79b3d10303de95$export$ecf9cf59142dd54a),
    Control: (0, $a2f37cab13b48253$export$2e2bcd8739ae039),
    DropdownIndicator: (0, $cec302d41ffd5f8b$export$ec98719d3db7f2e4),
    Group: (0, $eed7c4dabefdcdc0$export$2e2bcd8739ae039),
    GroupHeading: (0, $090b4c9959dd11fa$export$85c8b41a3cd87edc),
    IndicatorsContainer: (0, $bf49b07163a4a854$export$d0ffd7e649cab6f),
    Input: (0, $4ec1d49e28fd0e6f$export$2e2bcd8739ae039),
    LoadingIndicator: (0, $99e05c35d7ce9815$export$7c20be4c1d342248),
    Menu: (0, $edbf2144ff2d3eea$export$2e2bcd8739ae039),
    MenuList: (0, $eeecfc93b2054c92$export$d4c4e98c5044dc8),
    MenuPortal: (0, $deb76f8a97da38a0$export$793392f970497feb),
    LoadingMessage: (0, $56ff478e70f33c0d$export$e928a71d039d3102),
    NoOptionsMessage: (0, $70bca3ca2ec9fe2c$export$d58b72b7d3c4072c),
    MultiValue: (0, $89cb846ac02cf9b6$export$2e2bcd8739ae039),
    MultiValueContainer: (0, $cd801d0089070243$export$cf9cf2a30a59265c),
    MultiValueLabel: (0, $96a0b865fb98edab$export$544aeea2a5ce08ee),
    MultiValueRemove: (0, $d41fb44411b62bc0$export$8e1fd1a40e7a2f4a),
    Option: (0, $204703ed812bebb3$export$2e2bcd8739ae039),
    Placeholder: (0, $c8dd7d6567de36ab$export$2e2bcd8739ae039),
    SelectContainer: (0, $d4c88289b5b8ffe4$export$446eebadefe1123b),
    SingleValue: (0, $196bf38ba8e23074$export$2e2bcd8739ae039),
    ValueContainer: (0, $e0549d3c091396af$export$4dc9f58ad9a1a000)
};
var $5363260948404c2f$export$71abc632aa29e6fe = function defaultComponents(props) {
    return $5363260948404c2f$var$_objectSpread($5363260948404c2f$var$_objectSpread({}, $5363260948404c2f$export$9b5ac10f59f76296), props.components);
};


var $25d3d98af03b26d0$var$_excluded = [
    "showClearIndicator"
];
var $25d3d98af03b26d0$var$styles = {
    calendarButtonInclusionStyles: "_ahbqxy5q",
    calendarButtonOnlyInclusionStyles: "_ahbq1ejb"
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $25d3d98af03b26d0$export$d0ffd7e649cab6f = function IndicatorsContainer(_ref) {
    var showClearIndicator = _ref.showClearIndicator, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $25d3d98af03b26d0$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            showClearIndicator ? $25d3d98af03b26d0$var$styles.calendarButtonInclusionStyles : $25d3d98af03b26d0$var$styles.calendarButtonOnlyInclusionStyles
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $5363260948404c2f$export$9b5ac10f59f76296).IndicatorsContainer, rest));
};


/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ // oxlint-disable-next-line @atlassian/no-restricted-imports
var $e480236bb44c6c0d$export$d38e7e283938128c = function isDateDisabled(date, di) {
    var disabled = di.disabled;
    return disabled.indexOf(date) > -1;
};


/* menu.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");


var $jyEcA = parcelRequire("jyEcA");

var $ezd8U = parcelRequire("ezd8U");
/* fixed-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");
var $bd8f31a1f7f76490$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
var $bd8f31a1f7f76490$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
var $bd8f31a1f7f76490$export$62ad7b0c781000e9 = {
    small: {
        width: $bd8f31a1f7f76490$export$c647cb0ee6e282fe.small,
        height: $bd8f31a1f7f76490$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $bd8f31a1f7f76490$export$c647cb0ee6e282fe.medium,
        height: $bd8f31a1f7f76490$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $bd8f31a1f7f76490$export$c647cb0ee6e282fe.large,
        height: $bd8f31a1f7f76490$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $bd8f31a1f7f76490$export$c647cb0ee6e282fe.xlarge,
        height: $bd8f31a1f7f76490$export$c647cb0ee6e282fe.xlarge
    }
};



var $4yHJ4 = parcelRequire("4yHJ4");

var $5K5L9 = parcelRequire("5K5L9");

var $hFSRt = parcelRequire("hFSRt");
function $eda9ddd4ca3bb53c$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $eda9ddd4ca3bb53c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $eda9ddd4ca3bb53c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($eda9ddd4ca3bb53c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $eda9ddd4ca3bb53c$var$styles = {
    root: "_bfhk1j28 _kqswstnw _152tze3t",
    popperStyles: "_1pbyowjs"
};
/**
 * This component renders layered content with fixed positioning.
 * Scroll is locked outside the layer to prevent the layered content from detaching from the
 * container ref.
 */ // eslint-disable-next-line @repo/internal/react/no-class-components
var $eda9ddd4ca3bb53c$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    function FixedLayer() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FixedLayer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $eda9ddd4ca3bb53c$var$_callSuper(this, FixedLayer, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "update", (0, $eVb4V.default));
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(FixedLayer, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FixedLayer, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (prevProps.inputValue !== this.props.inputValue) this.update();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, containerRef = _this$props.containerRef, content = _this$props.content, testId = _this$props.testId;
                // Wait for containerRef callback to cause a re-render
                if (!containerRef) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", null);
                var divStyles = {
                    height: containerRef.getBoundingClientRect().height,
                    // Don't block the clear button
                    width: containerRef.getBoundingClientRect().width - parseInt((0, $bd8f31a1f7f76490$export$c647cb0ee6e282fe).small.slice(0, -2)) - 8
                };
                return(/*#__PURE__*/ /* Need to wrap layer in a fixed position div so that it will render its content as fixed
         * We need to set the intial top value to where the container is and zIndex so that it still
         * applies since we're creating a new stacking context. */ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4yHJ4.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $hFSRt.Reference), null, function(_ref) {
                    var ref = _ref.ref;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                        ref: ref,
                        "data-layer-child": true,
                        style: divStyles,
                        className: (0, $970q7.default)([
                            $eda9ddd4ca3bb53c$var$styles.root
                        ])
                    });
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5K5L9.Popper), null, function(_ref2) {
                    var ref = _ref2.ref, style = _ref2.style, update = _ref2.update;
                    _this2.update = update;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                        ref: ref,
                        style: style,
                        "data-testid": testId && "".concat(testId, "--popper--container"),
                        className: (0, $970q7.default)([
                            $eda9ddd4ca3bb53c$var$styles.popperStyles
                        ])
                    }, content);
                })));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component);


/**
 * @param isos A series of ISO dates.
 * @returns The last valid date within the array of ISO strings.
 */ function $716374d333a5033e$var$getValidDate(isos) {
    return isos.reduce(function(acc, iso) {
        var date = (0, $af26a0dfda6128df$export$2e2bcd8739ae039)(iso);
        return (0, $4ddee9e0d8965130$export$2e2bcd8739ae039)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
var $716374d333a5033e$var$menuStyles = null;
var $716374d333a5033e$export$d9b273488cd8ce6f = function Menu(_ref) {
    var selectProps = _ref.selectProps, innerProps = _ref.innerProps;
    var calendarValue = selectProps.calendarValue, calendarView = selectProps.calendarView, MenuInnerWrapper = selectProps.menuInnerWrapper;
    var _getValidDate = $716374d333a5033e$var$getValidDate([
        calendarValue,
        calendarView
    ]), day = _getValidDate.day, month = _getValidDate.month, year = _getValidDate.year;
    var onMenuMouseDown = function onMenuMouseDown(event) {
        if (event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();
    };
    var Wrapper = typeof MenuInnerWrapper === 'function' ? MenuInnerWrapper : (0, $5FkrB.Fragment);
    return /*#__PURE__*/ $5FkrB.createElement((0, $ezd8U.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ $5FkrB.createElement((0, $eda9ddd4ca3bb53c$export$2e2bcd8739ae039), {
        inputValue: selectProps.inputValue,
        containerRef: selectProps.calendarContainerRef,
        content: /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
            onMouseDown: onMenuMouseDown,
            className: (0, $970q7.default)([
                "_2rko1mok _1reo15vq _18m915vq _1pbyowjs _bfhk1bhr _16qs130s"
            ])
        }), /*#__PURE__*/ $5FkrB.createElement(Wrapper, null, /*#__PURE__*/ $5FkrB.createElement((0, $jyEcA.default), {
            day: day,
            month: month,
            year: year,
            disabled: selectProps.calendarDisabled,
            disabledDateFilter: selectProps.calendarDisabledDateFilter,
            minDate: selectProps.calendarMinDate,
            maxDate: selectProps.calendarMaxDate,
            nextMonthLabel: selectProps.nextMonthLabel,
            onChange: selectProps.onCalendarChange,
            onSelect: selectProps.onCalendarSelect,
            previousMonthLabel: selectProps.previousMonthLabel,
            ref: selectProps.calendarRef,
            selected: [
                selectProps.calendarValue
            ],
            shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
            locale: selectProps.calendarLocale,
            testId: selectProps.testId && "".concat(selectProps.testId, "--calendar"),
            weekStartDay: selectProps.calendarWeekStartDay
        }))),
        testId: selectProps.testId
    }));
};


/* menu-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");


var $jyEcA = parcelRequire("jyEcA");
/**
 * @param isos A series of ISO dates.
 * @returns The last valid date within the array of ISO strings.
 */ function $a4f8a13db48a5dd1$var$getValidDate(isos) {
    return isos.reduce(function(acc, iso) {
        var date = (0, $af26a0dfda6128df$export$2e2bcd8739ae039)(iso);
        return (0, $4ddee9e0d8965130$export$2e2bcd8739ae039)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
var $a4f8a13db48a5dd1$var$styles = {
    root: "_2rko1mok _1bsb1ris _bfhk1bhr _16qs130s _1pfhu2gc _6rthu2gc"
};
var $a4f8a13db48a5dd1$export$11ed8c2ae184f5b3 = function MenuTopLayer(_ref) {
    var selectProps = _ref.selectProps, innerProps = _ref.innerProps;
    var calendarValue = selectProps.calendarValue, calendarView = selectProps.calendarView, MenuInnerWrapper = selectProps.menuInnerWrapper;
    var _getValidDate = $a4f8a13db48a5dd1$var$getValidDate([
        calendarValue,
        calendarView
    ]), day = _getValidDate.day, month = _getValidDate.month, year = _getValidDate.year;
    var onMenuMouseDown = function onMenuMouseDown(event) {
        if (event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();
    };
    var Wrapper = typeof MenuInnerWrapper === 'function' ? MenuInnerWrapper : (0, $5FkrB.Fragment);
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        onMouseDown: onMenuMouseDown,
        role: "presentation",
        className: (0, $970q7.default)([
            $a4f8a13db48a5dd1$var$styles.root
        ])
    }), /*#__PURE__*/ $5FkrB.createElement(Wrapper, null, /*#__PURE__*/ $5FkrB.createElement((0, $jyEcA.default), {
        day: day,
        month: month,
        year: year,
        disabled: selectProps.calendarDisabled,
        disabledDateFilter: selectProps.calendarDisabledDateFilter,
        minDate: selectProps.calendarMinDate,
        maxDate: selectProps.calendarMaxDate,
        nextMonthLabel: selectProps.nextMonthLabel,
        onChange: selectProps.onCalendarChange,
        onSelect: selectProps.onCalendarSelect,
        previousMonthLabel: selectProps.previousMonthLabel,
        ref: selectProps.calendarRef,
        selected: [
            selectProps.calendarValue
        ],
        shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
        locale: selectProps.calendarLocale,
        testId: selectProps.testId && "".concat(selectProps.testId, "--calendar"),
        weekStartDay: selectProps.calendarWeekStartDay
    })));
};


/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ // oxlint-disable-next-line @atlassian/no-restricted-imports

var $4bFFZ = parcelRequire("4bFFZ");

var $eOG0P = parcelRequire("eOG0P");



function $334f3142be8322c7$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}








var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $jpOKD = parcelRequire("jpOKD");
var $57907c86dd2b6f65$var$TIMEZONE_UNIT_PRIORITY = 10;
var $57907c86dd2b6f65$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $aWDq9.default)(this, Setter);
        (0, $jpOKD.default)(this, "priority", void 0);
        (0, $jpOKD.default)(this, "subPriority", 0);
    }
    (0, $kU8z5.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $57907c86dd2b6f65$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $fnxbN.default)(ValueSetter, _Setter);
    var _super = (0, $llIiI.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $aWDq9.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $kU8z5.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($57907c86dd2b6f65$export$81d53e3678089a6);
var $57907c86dd2b6f65$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $fnxbN.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $llIiI.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $aWDq9.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this2), "priority", $57907c86dd2b6f65$var$TIMEZONE_UNIT_PRIORITY);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $kU8z5.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($57907c86dd2b6f65$export$81d53e3678089a6);



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");

var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $jpOKD = parcelRequire("jpOKD");

var $249d7d2d37885fc2$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $aWDq9.default)(this, Parser);
        (0, $jpOKD.default)(this, "incompatibleTokens", void 0);
        (0, $jpOKD.default)(this, "priority", void 0);
        (0, $jpOKD.default)(this, "subPriority", void 0);
    }
    (0, $kU8z5.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $57907c86dd2b6f65$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();


var $799542e0ddc22cad$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(EraParser, _Parser);
    var _super = (0, $llIiI.default)(EraParser);
    function EraParser() {
        var _this;
        (0, $aWDq9.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 140);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");


var $ab58007d9ba30e95$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $ab58007d9ba30e95$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $aca45ab97199f65b$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $aca45ab97199f65b$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $aca45ab97199f65b$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $cd16919d0b40c529$export$7f72910d6dfd237a) + minutes * (0, $cd16919d0b40c529$export$91246f0b9bd9beff) + seconds * (0, $cd16919d0b40c529$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $aca45ab97199f65b$export$d931c43c4608a164(dateString) {
    return $aca45ab97199f65b$export$cc7cc9e2a3ff9388((0, $ab58007d9ba30e95$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $aca45ab97199f65b$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $aca45ab97199f65b$export$cc7cc9e2a3ff9388((0, $ab58007d9ba30e95$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $aca45ab97199f65b$export$cc7cc9e2a3ff9388((0, $ab58007d9ba30e95$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $aca45ab97199f65b$export$cc7cc9e2a3ff9388((0, $ab58007d9ba30e95$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $aca45ab97199f65b$export$cc7cc9e2a3ff9388((0, $ab58007d9ba30e95$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $aca45ab97199f65b$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $aca45ab97199f65b$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $aca45ab97199f65b$export$cc7cc9e2a3ff9388((0, $ab58007d9ba30e95$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $aca45ab97199f65b$export$cc7cc9e2a3ff9388((0, $ab58007d9ba30e95$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $aca45ab97199f65b$export$cc7cc9e2a3ff9388((0, $ab58007d9ba30e95$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $aca45ab97199f65b$export$cc7cc9e2a3ff9388((0, $ab58007d9ba30e95$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $aca45ab97199f65b$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $aca45ab97199f65b$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $aca45ab97199f65b$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $aca45ab97199f65b$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


var $bcbf830fe3e94198$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(YearParser, _Parser);
    var _super = (0, $llIiI.default)(YearParser);
    function YearParser() {
        var _this;
        (0, $aWDq9.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 130);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $aca45ab97199f65b$export$4f84e3a82c7b538)((0, $aca45ab97199f65b$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $aca45ab97199f65b$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $aca45ab97199f65b$export$4f84e3a82c7b538)((0, $aca45ab97199f65b$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $aca45ab97199f65b$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");




var $898512a2098f26af$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(LocalWeekYearParser, _Parser);
    var _super = (0, $llIiI.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $aWDq9.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 130);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $aca45ab97199f65b$export$4f84e3a82c7b538)((0, $aca45ab97199f65b$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $aca45ab97199f65b$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $aca45ab97199f65b$export$4f84e3a82c7b538)((0, $aca45ab97199f65b$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $1561aad59e6b2871$export$2e2bcd8739ae039)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $aca45ab97199f65b$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $e264ca9759b9f33f$export$2e2bcd8739ae039)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $e264ca9759b9f33f$export$2e2bcd8739ae039)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");



var $99159133c4c75869$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(ISOWeekYearParser, _Parser);
    var _super = (0, $llIiI.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $aWDq9.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 130);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $aca45ab97199f65b$export$2c9307b2e29c533c)(4, dateString);
                return (0, $aca45ab97199f65b$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $f0279c201272a024$export$2e2bcd8739ae039)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");


var $938a073dfa4e4c96$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(ExtendedYearParser, _Parser);
    var _super = (0, $llIiI.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $aWDq9.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 130);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $aca45ab97199f65b$export$2c9307b2e29c533c)(4, dateString);
                return (0, $aca45ab97199f65b$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");


var $c0da65150313aee4$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(QuarterParser, _Parser);
    var _super = (0, $llIiI.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $aWDq9.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 120);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $aca45ab97199f65b$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");


var $9b0b7bcbb4123f78$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, $llIiI.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $aWDq9.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 120);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $aca45ab97199f65b$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");



var $25ee56bebd6f040f$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(MonthParser, _Parser);
    var _super = (0, $llIiI.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $aWDq9.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 110);
        return _this;
    }
    (0, $kU8z5.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $aca45ab97199f65b$export$4f84e3a82c7b538)((0, $aca45ab97199f65b$export$cc7cc9e2a3ff9388)((0, $ab58007d9ba30e95$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $aca45ab97199f65b$export$4f84e3a82c7b538)((0, $aca45ab97199f65b$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $aca45ab97199f65b$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");



var $4902ef51d2eff503$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(StandAloneMonthParser, _Parser);
    var _super = (0, $llIiI.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $aWDq9.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 110);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $aca45ab97199f65b$export$4f84e3a82c7b538)((0, $aca45ab97199f65b$export$cc7cc9e2a3ff9388)((0, $ab58007d9ba30e95$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $aca45ab97199f65b$export$4f84e3a82c7b538)((0, $aca45ab97199f65b$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $aca45ab97199f65b$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");







function $ee46799725a19b63$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $70a4b20ef6a52e56$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $a03aa00843c0bb6b$export$2e2bcd8739ae039)(dirtyDate);
    var week = (0, $acbf5f73d02defdc$export$2e2bcd8739ae039)(dirtyWeek);
    var diff = (0, $97b9cb523b787a79$export$2e2bcd8739ae039)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $e687501df00f1f6f$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(LocalWeekParser, _Parser);
    var _super = (0, $llIiI.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $aWDq9.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 100);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $aca45ab97199f65b$export$cc7cc9e2a3ff9388)((0, $ab58007d9ba30e95$export$c123ee06d9da8480).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $aca45ab97199f65b$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $e264ca9759b9f33f$export$2e2bcd8739ae039)((0, $ee46799725a19b63$export$2e2bcd8739ae039)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");







function $8f0c8a68233893a5$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $70a4b20ef6a52e56$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $a03aa00843c0bb6b$export$2e2bcd8739ae039)(dirtyDate);
    var isoWeek = (0, $acbf5f73d02defdc$export$2e2bcd8739ae039)(dirtyISOWeek);
    var diff = (0, $f0a3f4796becbced$export$2e2bcd8739ae039)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $9eb26fee959eae4e$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(ISOWeekParser, _Parser);
    var _super = (0, $llIiI.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $aWDq9.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 100);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $aca45ab97199f65b$export$cc7cc9e2a3ff9388)((0, $ab58007d9ba30e95$export$c123ee06d9da8480).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $aca45ab97199f65b$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $f0279c201272a024$export$2e2bcd8739ae039)((0, $8f0c8a68233893a5$export$2e2bcd8739ae039)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");



var $558771df39cd39ce$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $558771df39cd39ce$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $558771df39cd39ce$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(DateParser, _Parser);
    var _super = (0, $llIiI.default)(DateParser);
    function DateParser() {
        var _this;
        (0, $aWDq9.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 90);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "subPriority", 1);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $aca45ab97199f65b$export$cc7cc9e2a3ff9388)((0, $ab58007d9ba30e95$export$c123ee06d9da8480).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $aca45ab97199f65b$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $aca45ab97199f65b$export$3d50627710b84d75)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $558771df39cd39ce$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $558771df39cd39ce$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");



var $d0c75b862a599317$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(DayOfYearParser, _Parser);
    var _super = (0, $llIiI.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $aWDq9.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 90);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "subpriority", 1);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $aca45ab97199f65b$export$cc7cc9e2a3ff9388)((0, $ab58007d9ba30e95$export$c123ee06d9da8480).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $aca45ab97199f65b$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $aca45ab97199f65b$export$3d50627710b84d75)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");





function $05080c593d5fc1f8$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $70a4b20ef6a52e56$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $9bf015016e4f3310$export$430a3269e24b912e)();
    var weekStartsOn = (0, $acbf5f73d02defdc$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $a03aa00843c0bb6b$export$2e2bcd8739ae039)(dirtyDate);
    var day = (0, $acbf5f73d02defdc$export$2e2bcd8739ae039)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $b322dc87b8f71cc9$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(DayParser, _Parser);
    var _super = (0, $llIiI.default)(DayParser);
    function DayParser() {
        var _this;
        (0, $aWDq9.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 90);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $05080c593d5fc1f8$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");



var $6dbae9d73c37955b$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(LocalDayParser, _Parser);
    var _super = (0, $llIiI.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $aWDq9.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 90);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $aca45ab97199f65b$export$4f84e3a82c7b538)((0, $aca45ab97199f65b$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $aca45ab97199f65b$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $05080c593d5fc1f8$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");



var $55194de10b541dc1$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $llIiI.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $aWDq9.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 90);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $aca45ab97199f65b$export$4f84e3a82c7b538)((0, $aca45ab97199f65b$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $aca45ab97199f65b$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $05080c593d5fc1f8$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");





function $530f4cc7b29e0a81$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $70a4b20ef6a52e56$export$2e2bcd8739ae039)(2, arguments);
    var day = (0, $acbf5f73d02defdc$export$2e2bcd8739ae039)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $a03aa00843c0bb6b$export$2e2bcd8739ae039)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $5a73225966a57967$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(ISODayParser, _Parser);
    var _super = (0, $llIiI.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $aWDq9.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 90);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $aca45ab97199f65b$export$513bb01536146ab6)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $aca45ab97199f65b$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $aca45ab97199f65b$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $aca45ab97199f65b$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $aca45ab97199f65b$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $530f4cc7b29e0a81$export$2e2bcd8739ae039)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");


var $5f4551faaac458c0$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(AMPMParser, _Parser);
    var _super = (0, $llIiI.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $aWDq9.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 80);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $aca45ab97199f65b$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");


var $067a781d708c529c$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(AMPMMidnightParser, _Parser);
    var _super = (0, $llIiI.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $aWDq9.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 80);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $aca45ab97199f65b$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");


var $f9a80d8b2996ff93$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(DayPeriodParser, _Parser);
    var _super = (0, $llIiI.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $aWDq9.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 80);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $aca45ab97199f65b$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");



var $cd88082311d36778$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(Hour1to12Parser, _Parser);
    var _super = (0, $llIiI.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $aWDq9.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 70);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $aca45ab97199f65b$export$cc7cc9e2a3ff9388)((0, $ab58007d9ba30e95$export$c123ee06d9da8480).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $aca45ab97199f65b$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");



var $5473d5c606bcef8a$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(Hour0to23Parser, _Parser);
    var _super = (0, $llIiI.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $aWDq9.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 70);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $aca45ab97199f65b$export$cc7cc9e2a3ff9388)((0, $ab58007d9ba30e95$export$c123ee06d9da8480).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $aca45ab97199f65b$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");



var $89f4528a2f1c3fb3$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(Hour0To11Parser, _Parser);
    var _super = (0, $llIiI.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $aWDq9.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 70);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $aca45ab97199f65b$export$cc7cc9e2a3ff9388)((0, $ab58007d9ba30e95$export$c123ee06d9da8480).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $aca45ab97199f65b$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");



var $e80671aae793d17c$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(Hour1To24Parser, _Parser);
    var _super = (0, $llIiI.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $aWDq9.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 70);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $aca45ab97199f65b$export$cc7cc9e2a3ff9388)((0, $ab58007d9ba30e95$export$c123ee06d9da8480).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $aca45ab97199f65b$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");



var $083d11a21def76f1$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(MinuteParser, _Parser);
    var _super = (0, $llIiI.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $aWDq9.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 60);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $aca45ab97199f65b$export$cc7cc9e2a3ff9388)((0, $ab58007d9ba30e95$export$c123ee06d9da8480).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $aca45ab97199f65b$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");



var $bf44d7c2a14f7fdf$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(SecondParser, _Parser);
    var _super = (0, $llIiI.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $aWDq9.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 50);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $aca45ab97199f65b$export$cc7cc9e2a3ff9388)((0, $ab58007d9ba30e95$export$c123ee06d9da8480).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $aca45ab97199f65b$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");


var $0ec62e4c99ca1723$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(FractionOfSecondParser, _Parser);
    var _super = (0, $llIiI.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $aWDq9.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 30);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $aca45ab97199f65b$export$4f84e3a82c7b538)((0, $aca45ab97199f65b$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");



var $be88c9eb5ad63932$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $llIiI.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $aWDq9.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 10);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $aca45ab97199f65b$export$6497f4c0ecdfba8e)((0, $ab58007d9ba30e95$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $aca45ab97199f65b$export$6497f4c0ecdfba8e)((0, $ab58007d9ba30e95$export$a7ee192b982af9c1).basic, dateString);
                    case 'XXXX':
                        return (0, $aca45ab97199f65b$export$6497f4c0ecdfba8e)((0, $ab58007d9ba30e95$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $aca45ab97199f65b$export$6497f4c0ecdfba8e)((0, $ab58007d9ba30e95$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $aca45ab97199f65b$export$6497f4c0ecdfba8e)((0, $ab58007d9ba30e95$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");



var $b8885ae89307c3ec$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(ISOTimezoneParser, _Parser);
    var _super = (0, $llIiI.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $aWDq9.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 10);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, $kU8z5.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $aca45ab97199f65b$export$6497f4c0ecdfba8e)((0, $ab58007d9ba30e95$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $aca45ab97199f65b$export$6497f4c0ecdfba8e)((0, $ab58007d9ba30e95$export$a7ee192b982af9c1).basic, dateString);
                    case 'xxxx':
                        return (0, $aca45ab97199f65b$export$6497f4c0ecdfba8e)((0, $ab58007d9ba30e95$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $aca45ab97199f65b$export$6497f4c0ecdfba8e)((0, $ab58007d9ba30e95$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $aca45ab97199f65b$export$6497f4c0ecdfba8e)((0, $ab58007d9ba30e95$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");


var $072ce829c20c8fec$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(TimestampSecondsParser, _Parser);
    var _super = (0, $llIiI.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $aWDq9.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 40);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $kU8z5.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $aca45ab97199f65b$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));



var $aWDq9 = parcelRequire("aWDq9");

var $kU8z5 = parcelRequire("kU8z5");

var $4AHqC = parcelRequire("4AHqC");

var $fnxbN = parcelRequire("fnxbN");

var $llIiI = parcelRequire("llIiI");

var $jpOKD = parcelRequire("jpOKD");


var $82bd459fe95fca01$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $fnxbN.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $llIiI.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $aWDq9.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "priority", 20);
        (0, $jpOKD.default)((0, $4AHqC.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $kU8z5.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $aca45ab97199f65b$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $249d7d2d37885fc2$export$7acfa6ed01010e37));


var $12ba4de35f731bf6$export$19131010e7fd8373 = {
    G: new (0, $799542e0ddc22cad$export$8e5a1d3f85a9688)(),
    y: new (0, $bcbf830fe3e94198$export$48d352de7cd4a988)(),
    Y: new (0, $898512a2098f26af$export$b8ef38dfcf05d5db)(),
    R: new (0, $99159133c4c75869$export$951d1df011fde06f)(),
    u: new (0, $938a073dfa4e4c96$export$bad9d2ea38e8f1a)(),
    Q: new (0, $c0da65150313aee4$export$5cb0f701186dde1d)(),
    q: new (0, $9b0b7bcbb4123f78$export$300c0c2990e20e6d)(),
    M: new (0, $25ee56bebd6f040f$export$400dd8b40ef138a3)(),
    L: new (0, $4902ef51d2eff503$export$1d7eaa53eaa5deba)(),
    w: new (0, $e687501df00f1f6f$export$c4005ffc174e07c0)(),
    I: new (0, $9eb26fee959eae4e$export$6fc8dbedd560a6af)(),
    d: new (0, $558771df39cd39ce$export$e8d4b28a20981dd2)(),
    D: new (0, $d0c75b862a599317$export$6cfe0d613455f615)(),
    E: new (0, $b322dc87b8f71cc9$export$1b03c8b76262f7bd)(),
    e: new (0, $6dbae9d73c37955b$export$44d1c127ab42c480)(),
    c: new (0, $55194de10b541dc1$export$e447a647caaaec1d)(),
    i: new (0, $5a73225966a57967$export$693fb1e525095b2a)(),
    a: new (0, $5f4551faaac458c0$export$8d1e08492351df91)(),
    b: new (0, $067a781d708c529c$export$73ca2bd0a17d273)(),
    B: new (0, $f9a80d8b2996ff93$export$bb9212adf05373db)(),
    h: new (0, $cd88082311d36778$export$8a04050a727a1756)(),
    H: new (0, $5473d5c606bcef8a$export$e56f4dea2c3e56dd)(),
    K: new (0, $89f4528a2f1c3fb3$export$cbbe855312f87d77)(),
    k: new (0, $e80671aae793d17c$export$6008046d2b34b6a5)(),
    m: new (0, $083d11a21def76f1$export$2b52670d9e2be53)(),
    s: new (0, $bf44d7c2a14f7fdf$export$94d46d540cf1366a)(),
    S: new (0, $0ec62e4c99ca1723$export$b8e6f8b2d70893b1)(),
    X: new (0, $be88c9eb5ad63932$export$104d901d49fea29b)(),
    x: new (0, $b8885ae89307c3ec$export$12910e5204b52b9)(),
    t: new (0, $072ce829c20c8fec$export$2cd8bf877a05e96)(),
    T: new (0, $82bd459fe95fca01$export$6d8f69c6906d6368)()
};



// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $2cbd5973bdba93a0$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $2cbd5973bdba93a0$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $2cbd5973bdba93a0$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $2cbd5973bdba93a0$var$doubleQuoteRegExp = /''/g;
var $2cbd5973bdba93a0$var$notWhitespaceRegExp = /\S/;
var $2cbd5973bdba93a0$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $2cbd5973bdba93a0$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $70a4b20ef6a52e56$export$2e2bcd8739ae039)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $9bf015016e4f3310$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $4347dc865c1a8f6a$export$2e2bcd8739ae039);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $acbf5f73d02defdc$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $acbf5f73d02defdc$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $a03aa00843c0bb6b$export$2e2bcd8739ae039)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $57907c86dd2b6f65$export$5aaf7ff7f09ea4ee)()
    ];
    var tokens = formatString.match($2cbd5973bdba93a0$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $7ea57f69439f3f00$export$2e2bcd8739ae039)) {
            var longFormatter = (0, $7ea57f69439f3f00$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($2cbd5973bdba93a0$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $eOG0P.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $f3b1738d8c44b5fe$export$c6b49d6dceb604a1)(token)) (0, $f3b1738d8c44b5fe$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $f3b1738d8c44b5fe$export$c6cc36aa33304772)(token)) (0, $f3b1738d8c44b5fe$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $12ba4de35f731bf6$export$19131010e7fd8373)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($2cbd5973bdba93a0$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $2cbd5973bdba93a0$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $4bFFZ.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $2cbd5973bdba93a0$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $a03aa00843c0bb6b$export$2e2bcd8739ae039)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $2c442fbfac0d69a4$export$2e2bcd8739ae039)(date, (0, $1e958f34c1568341$export$2e2bcd8739ae039)(date));
    var flags = {};
    var _iterator2 = (0, $eOG0P.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $334f3142be8322c7$export$2e2bcd8739ae039)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $2cbd5973bdba93a0$var$cleanEscapedString(input) {
    return input.match($2cbd5973bdba93a0$var$escapedStringRegExp)[1].replace($2cbd5973bdba93a0$var$doubleQuoteRegExp, "'");
}



var $50U6m = parcelRequire("50U6m");


var $c20435e8d34fc793$export$6b862160d295c8e = function parseDate(date, di) {
    var parseInputValue = di.parseInputValue, dateFormat = di.dateFormat, l10n = di.l10n;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $d197ac6d992b01c0$export$75032c84f56650eb));
    if (dateFormat && (0, $50U6m.fg)('platform-dst-dp-parse-date-format')) {
        // date-fns uses the reference year to resolve two-digit years and fill
        // omitted years. Use the current local date rather than the Unix epoch.
        var referenceDate = (0, $50U6m.fg)('platform-dst-dp-current-reference-date') ? new Date() : new Date(0);
        var parsed = (0, $2cbd5973bdba93a0$export$2e2bcd8739ae039)(date, (0, $9ef3ef18e75888d6$export$4d5430175be73d45)(dateFormat), referenceDate);
        // `dateFormat` is a display format, so typed input does not always match
        // it. Locale parsing stays as the fallback so those entries still work.
        if ((0, $4ddee9e0d8965130$export$2e2bcd8739ae039)(parsed)) return parsed;
    }
    return l10n.parseDate(date);
};



var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $0d2548309078df04$var$_excluded = [
    "children",
    "className",
    "clearValue",
    "cx",
    "data",
    "getStyles",
    "getValue",
    "hasValue",
    "isDisabled",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue"
];
var $0d2548309078df04$export$6e30bf8cb1347b56 = // TODO: Make ID required
function makeSingleValue(_ref) {
    var id = _ref.id, lang = _ref.lang;
    return function(_ref2) {
        var children = _ref2.children, className = _ref2.className, clearValue = _ref2.clearValue, cx = _ref2.cx, data = _ref2.data, getStyles = _ref2.getStyles, getValue = _ref2.getValue, hasValue = _ref2.hasValue, isDisabled = _ref2.isDisabled, isMulti = _ref2.isMulti, isRtl = _ref2.isRtl, options = _ref2.options, selectOption = _ref2.selectOption, selectProps = _ref2.selectProps, setValue = _ref2.setValue, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $0d2548309078df04$var$_excluded);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5363260948404c2f$export$9b5ac10f59f76296).SingleValue, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                id: id,
                lang: lang.replace('_', '-')
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue
        }), children);
    };
};


var $e765debe27d2174e$var$_excluded = [
    "appearance",
    "autoFocus",
    "clearControlLabel",
    "hideIcon",
    "openCalendarLabel",
    "defaultIsOpen",
    "defaultValue",
    "disabled",
    "disabledDateFilter",
    "icon",
    "id",
    "innerProps",
    "inputLabel",
    "inputLabelId",
    "isDisabled",
    "isInvalid",
    "isRequired",
    "label",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "selectProps",
    "shouldShowCalendarButton",
    "spacing",
    "locale",
    "value",
    "isOpen",
    "maxDate",
    "minDate",
    "weekStartDay",
    "formatDisplayLabel",
    "testId",
    "aria-describedby",
    "placeholder",
    "nextMonthLabel",
    "previousMonthLabel"
];
function $e765debe27d2174e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e765debe27d2174e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e765debe27d2174e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e765debe27d2174e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e765debe27d2174e$var$packageName = "@atlaskit/datetime-picker";
var $e765debe27d2174e$var$packageVersion = "18.7.2";
var $e765debe27d2174e$var$styles = {
    pickerContainerStyle: "_kqswh2mm",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz1rpy _152tze3t _rjxpze3t _30l3azsu",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66"
};
var $e765debe27d2174e$var$analyticsAttributes = {
    componentName: 'datePicker',
    packageName: $e765debe27d2174e$var$packageName,
    packageVersion: $e765debe27d2174e$var$packageVersion
};
/**
 * __Date picker__
 *
 * A date picker allows the user to select a particular date.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
 */ var $e765debe27d2174e$var$DatePicker = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, _forwardedRef) {
    var containerRef = (0, $5FkrB.useRef)(null);
    var calendarRef = (0, $5FkrB.useRef)(null);
    var calendarButtonRef = (0, $5FkrB.useRef)(null);
    // Track whether focus was caused by an active pointer gesture. Pointer-driven focus must defer
    // opening a top-layer popover until click, while keyboard and programmatic focus can open it now.
    var isPointerInteractionRef = (0, $5FkrB.useRef)(false);
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'default' : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, _props$clearControlLa = props.clearControlLabel, clearControlLabel = _props$clearControlLa === void 0 ? 'Clear' : _props$clearControlLa, _props$hideIcon = props.hideIcon, hideIcon = _props$hideIcon === void 0 ? false : _props$hideIcon, _props$openCalendarLa = props.openCalendarLabel, openCalendarLabel = _props$openCalendarLa === void 0 ? 'Open calendar' : _props$openCalendarLa, _props$defaultIsOpen = props.defaultIsOpen, defaultIsOpen = _props$defaultIsOpen === void 0 ? false : _props$defaultIsOpen, _props$defaultValue = props.defaultValue, defaultValue = _props$defaultValue === void 0 ? '' : _props$defaultValue, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? [] : _props$disabled, _props$disabledDateFi = props.disabledDateFilter, disabledDateFilter = _props$disabledDateFi === void 0 ? function(_) {
        return false;
    } : _props$disabledDateFi, _props$icon = props.icon, Icon = _props$icon === void 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($j5dho))) : _props$icon, _props$id = props.id, id = _props$id === void 0 ? '' : _props$id, _props$innerProps = props.innerProps, innerProps = _props$innerProps === void 0 ? {} : _props$innerProps, _props$inputLabel = props.inputLabel, inputLabel = _props$inputLabel === void 0 ? 'Date picker' : _props$inputLabel, inputLabelId = props.inputLabelId, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isRequired = props.isRequired, isRequired = _props$isRequired === void 0 ? false : _props$isRequired, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, _props$name = props.name, name = _props$name === void 0 ? '' : _props$name, _props$onBlur = props.onBlur, onBlur = _props$onBlur === void 0 ? function(_event) {} : _props$onBlur, _props$onChange = props.onChange, onChangeProp = _props$onChange === void 0 ? function(_value) {} : _props$onChange, _props$onFocus = props.onFocus, onFocus = _props$onFocus === void 0 ? function(_event) {} : _props$onFocus, _props$selectProps = props.selectProps, selectProps = _props$selectProps === void 0 ? {} : _props$selectProps, shouldShowCalendarButton = props.shouldShowCalendarButton, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 'default' : _props$spacing, _props$locale = props.locale, propLocale = _props$locale === void 0 ? 'en-US' : _props$locale, propValue = props.value, isOpenProp = props.isOpen, maxDate = props.maxDate, minDate = props.minDate, weekStartDay = props.weekStartDay, formatDisplayLabel = props.formatDisplayLabel, testId = props.testId, ariaDescribedBy = props['aria-describedby'], placeholder = props.placeholder, nextMonthLabel = props.nextMonthLabel, previousMonthLabel = props.previousMonthLabel, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $e765debe27d2174e$var$_excluded);
    var _useState = (0, $5FkrB.useState)(defaultIsOpen), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), _ = _useState4[0], setIsFocused = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), clearingFromIcon = _useState6[0], setClearingFromIcon = _useState6[1];
    var _useState7 = (0, $5FkrB.useState)(selectProps.inputValue), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState7, 2), selectInputValue = _useState8[0], setSelectInputValue = _useState8[1];
    var _useState9 = (0, $5FkrB.useState)(propValue || defaultValue), _useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState9, 2), value = _useState0[0], setValue = _useState0[1];
    var _useState1 = (0, $5FkrB.useState)(propValue || defaultValue || (0, $7733e0da4d409b5f$export$77d5bc49fed7ef14)(new Date())), _useState10 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState1, 2), calendarValue = _useState10[0], setCalendarValue = _useState10[1];
    var _useState11 = (0, $5FkrB.useState)((0, $bCpKE.createLocalizationProvider)(propLocale)), _useState12 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState11, 2), l10n = _useState12[0], setL10n = _useState12[1];
    var _useState13 = (0, $5FkrB.useState)(propLocale), _useState14 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState13, 2), locale = _useState14[0], setLocale = _useState14[1];
    var _useState15 = (0, $5FkrB.useState)(false), _useState16 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState15, 2), shouldSetFocusOnCurrentDay = _useState16[0], setShouldSetFocusOnCurrentDay = _useState16[1];
    var _useState17 = (0, $5FkrB.useState)(false), _useState18 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState17, 2), isKeyDown = _useState18[0], setIsKeyDown = _useState18[1];
    var _useState19 = (0, $5FkrB.useState)(false), _useState20 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState19, 2), wasOpenedFromCalendarButton = _useState20[0], setWasOpenedFromCalendarButton = _useState20[1];
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    var _useReducer = (0, $5FkrB.useReducer)(function(x) {
        return !x;
    }, true), _useReducer2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useReducer, 2), forceUpdate = _useReducer2[1];
    var onChangePropWithAnalytics = (0, $aLEtb.usePlatformLeafEventHandler)($e765debe27d2174e$var$_objectSpread({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker'
    }, $e765debe27d2174e$var$analyticsAttributes));
    if (propLocale !== locale) {
        setL10n((0, $bCpKE.createLocalizationProvider)(propLocale));
        setLocale(propLocale);
    }
    (0, $5FkrB.useEffect)(function() {
        // Only move focus when the dedicated calendar button opened the menu.
        if (!isKeyDown) return;
        if (isOpen && wasOpenedFromCalendarButton) {
            var _calendarRef$current;
            setIsKeyDown(false);
            // Focus on the first button within the calendar
            calendarRef === null || calendarRef === void 0 || (_calendarRef$current = calendarRef.current) === null || _calendarRef$current === void 0 || (_calendarRef$current = _calendarRef$current.querySelector('button')) === null || _calendarRef$current === void 0 || _calendarRef$current.focus();
        }
    }, [
        isKeyDown,
        calendarRef,
        isOpen,
        wasOpenedFromCalendarButton
    ]);
    var getValue = function getValue() {
        return propValue !== null && propValue !== void 0 ? propValue : value;
    };
    var getIsOpen = function getIsOpen() {
        return isOpenProp !== null && isOpenProp !== void 0 ? isOpenProp : isOpen;
    };
    var onCalendarChange = function onCalendarChange(_ref) {
        var iso = _ref.iso;
        setCalendarValue((0, $74f7710237c74b20$export$38db26406d1a1ee2)({
            iso: iso
        }));
    };
    var onCalendarSelect = function onCalendarSelect(_ref2) {
        var iso = _ref2.iso;
        setSelectInputValue('');
        setIsOpen(false);
        setCalendarValue(iso);
        setValue(iso);
        setWasOpenedFromCalendarButton(false);
        onChangePropWithAnalytics(iso);
        // When using top-layer, PopupContent handles focus restoration automatically
        // on close based on the role. Only manually restore focus for the legacy path.
        if (!(0, $50U6m.fg)('platform-dst-top-layer')) {
            if (wasOpenedFromCalendarButton) {
                var _calendarButtonRef$cu;
                (_calendarButtonRef$cu = calendarButtonRef.current) === null || _calendarButtonRef$cu === void 0 || _calendarButtonRef$cu.focus();
            } else {
                var _containerRef$current;
                var innerCombobox = containerRef === null || containerRef === void 0 || (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.querySelector('[role="combobox"]');
                innerCombobox === null || innerCombobox === void 0 || innerCombobox.focus();
            }
        }
        setIsOpen(false);
    };
    var onInputClick = function onInputClick() {
        if (!isDisabled && !getIsOpen()) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
    };
    var onContainerBlur = function onContainerBlur(event) {
        var _containerRef$current2;
        var newlyFocusedElement = event.relatedTarget;
        isPointerInteractionRef.current = false;
        if (!(containerRef !== null && containerRef !== void 0 && (_containerRef$current2 = containerRef.current) !== null && _containerRef$current2 !== void 0 && _containerRef$current2.contains(newlyFocusedElement))) {
            setIsOpen(false);
            setShouldSetFocusOnCurrentDay(false);
            setWasOpenedFromCalendarButton(false);
            onBlur(event);
        }
    };
    var onContainerFocus = function onContainerFocus() {
        setShouldSetFocusOnCurrentDay(false);
    };
    var onSelectBlur = function onSelectBlur(event) {
        var _containerRef$current3;
        var newlyFocusedElement = event.relatedTarget;
        if (clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
        setClearingFromIcon(false);
        else if (!(containerRef !== null && containerRef !== void 0 && (_containerRef$current3 = containerRef.current) !== null && _containerRef$current3 !== void 0 && _containerRef$current3.contains(newlyFocusedElement))) {
            // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            setIsOpen(false);
            setIsFocused(false);
            setWasOpenedFromCalendarButton(false);
        }
    };
    var onSelectFocus = function onSelectFocus(event) {
        var value = getValue();
        if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
        setClearingFromIcon(false);
        else {
            // Opening an auto popover during pointer focus allows the matching pointerup
            // to immediately light-dismiss it. Let the subsequent click open it instead.
            if (!(0, $50U6m.fg)('platform-dst-top-layer') || !isPointerInteractionRef.current) // Don't open when focused into via keyboard if the calendar button is present
            setIsOpen(!shouldShowCalendarButton);
            setCalendarValue(value);
            setIsFocused(true);
            setWasOpenedFromCalendarButton(false);
        }
        onFocus(event);
    };
    var onTextInput = function onTextInput(event) {
        var inputValue = event.target.value;
        if (inputValue) {
            var parsed = (0, $c20435e8d34fc793$export$6b862160d295c8e)(inputValue, {
                parseInputValue: rest === null || rest === void 0 ? void 0 : rest.parseInputValue,
                dateFormat: rest === null || rest === void 0 ? void 0 : rest.dateFormat,
                l10n: l10n
            });
            // Only try to set the date if we have month & day
            if (parsed && (0, $4ddee9e0d8965130$export$2e2bcd8739ae039)(parsed)) // We format the parsed date to YYYY-MM-DD here because
            // this is the format expected by the @atlaskit/calendar component
            setCalendarValue((0, $7733e0da4d409b5f$export$77d5bc49fed7ef14)(parsed));
        }
        setIsOpen(true);
        setWasOpenedFromCalendarButton(false);
    };
    var onInputKeyDown = function onInputKeyDown(event) {
        var value = getValue();
        var keyPressed = event.key.toLowerCase();
        // If the input is focused and the calendar is not visible, handle space and enter clicks
        if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
        switch(keyPressed){
            case 'escape':
                // Restore focus because it may have moved from the input into the calendar.
                if (wasOpenedFromCalendarButton) {
                    var _calendarButtonRef$cu2;
                    (_calendarButtonRef$cu2 = calendarButtonRef.current) === null || _calendarButtonRef$cu2 === void 0 || _calendarButtonRef$cu2.focus();
                } else {
                    var _containerRef$current4;
                    var innerCombobox = containerRef === null || containerRef === void 0 || (_containerRef$current4 = containerRef.current) === null || _containerRef$current4 === void 0 ? void 0 : _containerRef$current4.querySelector('[role="combobox"]');
                    innerCombobox === null || innerCombobox === void 0 || innerCombobox.focus();
                }
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                break;
            case 'backspace':
            case 'delete':
                var inputCount = 0;
                if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                    // If being cleared from keyboard, don't change behaviour
                    setClearingFromIcon(false);
                    setValue('');
                }
                break;
            case 'enter':
                if (!isOpen) return;
                // Prevent form submission when a date is selected
                // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                // for more details.
                event.preventDefault();
                if (!(0, $e480236bb44c6c0d$export$d38e7e283938128c)(calendarValue, {
                    disabled: disabled
                })) {
                    // Get a safe `calendarValue` in case the value exceeds the maximum
                    // allowed by ISO 8601
                    var safeCalendarValue = (0, $3e132d6967265931$export$ff525416014fb67d)(calendarValue);
                    var valueChanged = safeCalendarValue !== value;
                    setSelectInputValue('');
                    setIsOpen(false);
                    setValue(safeCalendarValue);
                    setCalendarValue(safeCalendarValue);
                    setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                    if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                }
                break;
            case 'arrowdown':
            case 'arrowup':
                if (!shouldSetFocusOnCurrentDay) {
                    setIsOpen(true);
                    setShouldSetFocusOnCurrentDay(true);
                }
                break;
            default:
                break;
        }
    };
    var onCalendarButtonKeyDown = function onCalendarButtonKeyDown(e) {
        // Don't allow an arrow up or down to open the menu, since the input key
        // down handler is actually on the parent.
        if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
        // We want to stop this from triggering other keydown events, particularly
        // for space and enter presses. Otherwise, it opens and then closes
        // immediately.
        if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
            e.stopPropagation();
            setIsKeyDown(true);
            setWasOpenedFromCalendarButton(true);
        }
    };
    // This event handler is triggered from both keydown and click. It's weird.
    var onCalendarButtonClick = function onCalendarButtonClick(e) {
        if (!getIsOpen() && (0, $50U6m.fg)('platform-dst-top-layer')) setIsKeyDown(true);
        setIsOpen(function(isOpen) {
            if (isOpen) {
                var _props$selectProps2, _props$selectProps2$o;
                (_props$selectProps2 = props.selectProps) === null || _props$selectProps2 === void 0 || (_props$selectProps2$o = _props$selectProps2.onMenuClose) === null || _props$selectProps2$o === void 0 || _props$selectProps2$o.call(_props$selectProps2);
                return false;
            } else {
                var _props$selectProps3, _props$selectProps3$o;
                (_props$selectProps3 = props.selectProps) === null || _props$selectProps3 === void 0 || (_props$selectProps3$o = _props$selectProps3.onMenuOpen) === null || _props$selectProps3$o === void 0 || _props$selectProps3$o.call(_props$selectProps3);
                return true;
            }
        });
        setWasOpenedFromCalendarButton(true);
        e.stopPropagation();
    };
    var onClear = function onClear() {
        setValue('');
        setCalendarValue(defaultValue || (0, $7733e0da4d409b5f$export$77d5bc49fed7ef14)(new Date()));
        if (!hideIcon) setClearingFromIcon(true);
        onChangePropWithAnalytics('');
    };
    // `unknown` is used because `value` is unused so it does not matter.
    var onSelectChange = function onSelectChange(_value, action) {
        // Used for native clear event in React Select
        // Triggered when clicking ClearIndicator or backspace with no value
        if (action.action === 'clear') onClear();
    };
    var handleSelectInputChange = function handleSelectInputChange(selectInputValue, actionMeta) {
        if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
        setSelectInputValue(selectInputValue);
    };
    var getContainerRef = (0, $5FkrB.useCallback)(function(ref) {
        var oldRef = containerRef.current;
        containerRef.current = ref;
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef == null && ref != null) forceUpdate();
    }, [
        containerRef
    ]);
    var getterValue = getValue();
    var actualSelectInputValue;
    actualSelectInputValue = selectInputValue;
    var menuIsOpen = getIsOpen() && !isDisabled;
    var showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
    var clearIndicator = function clearIndicator(props) {
        return /*#__PURE__*/ $5FkrB.createElement((0, $auVZV.Box), {
            xcss: $e765debe27d2174e$var$styles.dropdownIndicatorStyles
        }, /*#__PURE__*/ $5FkrB.createElement(Icon, props));
    };
    var dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
    var valueId = (0, $h8qvJ.useId)();
    var SingleValue = (0, $0d2548309078df04$export$6e30bf8cb1347b56)({
        id: valueId,
        lang: propLocale
    });
    var selectComponents = $e765debe27d2174e$var$_objectSpread($e765debe27d2174e$var$_objectSpread($e765debe27d2174e$var$_objectSpread({}, selectProps.components), {}, {
        DropdownIndicator: shouldShowCalendarButton ? (0, $b3ed50813e899a91$export$5e30e9a24d6c1203) : dropDownIcon
    }, shouldShowCalendarButton ? {
        IndicatorsContainer: function IndicatorsContainer(props) {
            return /*#__PURE__*/ $5FkrB.createElement((0, $25d3d98af03b26d0$export$d0ffd7e649cab6f), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
                showClearIndicator: showClearIndicator
            }));
        }
    } : {}), {}, {
        Menu: (0, $50U6m.fg)('platform-dst-top-layer') ? (0, $a4f8a13db48a5dd1$export$11ed8c2ae184f5b3) : (0, $716374d333a5033e$export$d9b273488cd8ce6f),
        SingleValue: SingleValue
    }, !showClearIndicator && {
        ClearIndicator: (0, $b3ed50813e899a91$export$5e30e9a24d6c1203)
    });
    var _selectProps$styles = selectProps.styles, selectStyles = _selectProps$styles === void 0 ? {} : _selectProps$styles;
    var disabledStyle = isDisabled ? {
        pointerEvents: 'none',
        color: "var(--ds-icon-disabled, #080F214A)"
    } : {};
    var calendarProps = {
        calendarContainerRef: containerRef.current,
        calendarDisabled: disabled,
        calendarDisabledDateFilter: disabledDateFilter,
        calendarMaxDate: maxDate,
        calendarMinDate: minDate,
        calendarRef: calendarRef,
        calendarValue: getterValue && (0, $7733e0da4d409b5f$export$77d5bc49fed7ef14)((0, $af26a0dfda6128df$export$2e2bcd8739ae039)(getterValue)),
        calendarView: calendarValue,
        onCalendarChange: onCalendarChange,
        onCalendarSelect: onCalendarSelect,
        calendarLocale: locale,
        calendarWeekStartDay: weekStartDay !== null && weekStartDay !== void 0 ? weekStartDay : (0, $50U6m.fg)('platform-dst-locale-week-start-day') ? l10n.getFirstDayOfWeek() : undefined,
        shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay,
        /**
     * This overrides the inner wrapper the Calendar.
     * @private Please use this with extreme caution, this API may be changed in the future.
     */ menuInnerWrapper: props === null || props === void 0 ? void 0 : props.menuInnerWrapper
    };
    var mergedStyles = (0, $b3efbabdf341a1f6$export$e618dc39ac9ad607)(selectStyles, {
        control: function control(base) {
            return $e765debe27d2174e$var$_objectSpread($e765debe27d2174e$var$_objectSpread({}, base), disabledStyle);
        },
        indicatorsContainer: function indicatorsContainer(base) {
            return $e765debe27d2174e$var$_objectSpread($e765debe27d2174e$var$_objectSpread({}, base), {}, {
                paddingLeft: "var(--ds-space-025, 2px)",
                // ICON_PADDING = 2
                paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
            });
        }
    });
    var initialValue = getterValue ? {
        label: (0, $351584cf12c08523$export$3ae94a2503e890a1)(getterValue, {
            formatDisplayLabel: formatDisplayLabel,
            dateFormat: rest === null || rest === void 0 ? void 0 : rest.dateFormat,
            l10n: l10n
        }),
        value: getterValue
    } : null;
    // `label` takes precedence of the `inputLabel`
    var fullopenCalendarLabel = label || inputLabel ? "".concat(label || inputLabel, ", ").concat(openCalendarLabel) : openCalendarLabel;
    var openCalendarLabelId = "open-calendar-label--".concat((0, $h8qvJ.useId)());
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        "data-testid": testId && "".concat(testId, "--container"),
        onBlur: onContainerBlur,
        onClickCapture: function onClickCapture() {
            isPointerInteractionRef.current = false;
        },
        onFocus: onContainerFocus,
        onClick: onInputClick,
        onInput: onTextInput,
        onKeyDown: onInputKeyDown,
        onPointerCancelCapture: function onPointerCancelCapture() {
            isPointerInteractionRef.current = false;
        },
        onPointerDownCapture: function onPointerDownCapture() {
            isPointerInteractionRef.current = true;
        },
        ref: getContainerRef,
        role: "presentation",
        className: (0, $970q7.default)([
            $e765debe27d2174e$var$styles.pickerContainerStyle
        ])
    }), /*#__PURE__*/ $5FkrB.createElement("input", {
        name: name,
        type: "hidden",
        value: getterValue,
        "data-testid": testId && "".concat(testId, "--input")
    }), /*#__PURE__*/ $5FkrB.createElement((0, $78ORw.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        appearance: appearance,
        "aria-describedby": ariaDescribedBy ? "".concat(ariaDescribedBy, " ").concat(valueId) : valueId,
        label: label || undefined,
        autoFocus: autoFocus,
        clearControlLabel: clearControlLabel,
        closeMenuOnSelect: true,
        enableAnimation: false,
        inputId: id,
        inputValue: actualSelectInputValue,
        isDisabled: isDisabled,
        isRequired: isRequired,
        menuIsOpen: menuIsOpen,
        onBlur: onSelectBlur,
        onChange: onSelectChange,
        onFocus: onSelectFocus,
        onInputChange: handleSelectInputChange,
        placeholder: (0, $6199335cb0c628c1$export$d3f5c5e0a5023fa0)({
            placeholder: placeholder,
            l10n: l10n
        }),
        styles: mergedStyles,
        value: initialValue
    }, selectProps, {
        // For some reason, this and the below `styles` type error _only_ show
        // up when you alter some of the properties in the `selectComponents`
        // object. These errors are still present, and I suspect have always
        // been present, without changing the unrelated code. Ignoring as the
        // component still works as expected despite this error. And also
        // because the select refresh team may solve it later.
        components: selectComponents,
        isClearable: true,
        isInvalid: isInvalid,
        spacing: spacing,
        testId: testId,
        calendarContainerRef: calendarProps.calendarContainerRef,
        calendarDisabled: calendarProps.calendarDisabled,
        calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
        calendarLocale: calendarProps.calendarLocale,
        calendarMaxDate: calendarProps.calendarMaxDate,
        calendarMinDate: calendarProps.calendarMinDate,
        calendarRef: calendarProps.calendarRef,
        calendarValue: calendarProps.calendarValue,
        calendarView: calendarProps.calendarView,
        calendarWeekStartDay: calendarProps.calendarWeekStartDay,
        nextMonthLabel: nextMonthLabel,
        onCalendarChange: calendarProps.onCalendarChange,
        onCalendarSelect: calendarProps.onCalendarSelect,
        previousMonthLabel: previousMonthLabel,
        shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
        menuInnerWrapper: calendarProps.menuInnerWrapper
    })), shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ $5FkrB.createElement((0, $auVZV.Box), {
        xcss: (0, $hRJ5R.cx)($e765debe27d2174e$var$styles.iconContainerStyles, getterValue && !hideIcon ? $e765debe27d2174e$var$styles.iconSpacingWithClearButtonStyles : $e765debe27d2174e$var$styles.iconSpacingWithoutClearButtonStyles)
    }, /*#__PURE__*/ $5FkrB.createElement((0, $5yfDB.default), {
        appearance: "subtle",
        label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
        "aria-labelledby": inputLabelId ? "".concat(inputLabelId, " ").concat(openCalendarLabelId) : undefined,
        id: openCalendarLabelId,
        icon: function icon(iconProps) {
            return /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($j5dho))), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, iconProps, {
                color: "var(--ds-icon, #292A2E)"
            }));
        },
        onClick: onCalendarButtonClick,
        onKeyDown: onCalendarButtonKeyDown,
        ref: calendarButtonRef,
        testId: testId && "".concat(testId, "--open-calendar-button")
    })) : null);
});
var $e765debe27d2174e$export$2e2bcd8739ae039 = $e765debe27d2174e$var$DatePicker;



var $4Pn6z = parcelRequire("4Pn6z");
var $gDiFE = parcelRequire("gDiFE");


var $6bnW7 = parcelRequire("6bnW7");
var $043b65a36d0d2e9a$export$defe85febe8b728c = (0, $6bnW7.defineMessages)({
    and: {
        id: 'admin-hub-filter.between-dates.and',
        defaultMessage: 'and',
        description: 'Separator word displayed between the start date picker and the end date picker in the between-dates filter input.'
    },
    openStartDateLabel: {
        id: 'admin-hub-filter.between-dates.open-start-date-label',
        defaultMessage: 'Start date',
        description: 'Label for button that opens the start date picker'
    },
    openEndDateLabel: {
        id: 'admin-hub-filter.between-dates.open-end-date-label',
        defaultMessage: 'End date',
        description: 'Label for button that opens the end date picker'
    }
});


var $2cf06eea7c75218d$var$pickerWrapperStyles = (0, $gDiFE.xcss)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'center'
}, (0, $86b286ad5c089076$export$987d49ffe1b0900f).above.xs, {
    flexDirection: 'row',
    alignItems: 'center'
}));
var $2cf06eea7c75218d$var$datePickerWrapperStyles = (0, $gDiFE.xcss)({
    flex: 1,
    minWidth: 'max-content'
});
var $2cf06eea7c75218d$var$parseInputToDate = function parseInputToDate(value, inputDateFormat) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($kuWWJ)))(value, inputDateFormat).toDate();
};
var $2cf06eea7c75218d$var$ISODateFormat = 'YYYY-MM-DD';
var $2cf06eea7c75218d$var$convertFromEpochToDate = function convertFromEpochToDate(from) {
    return from ? (0, (/*@__PURE__*/$parcel$interopDefault($kuWWJ)))(parseInt(from, 10)).format($2cf06eea7c75218d$var$ISODateFormat) : '';
};
var $2cf06eea7c75218d$export$45538c79899052b = function BetweenDates(_ref) {
    var id = _ref.id, testId = _ref.testId, _ref$value = _ref.value, startDate = _ref$value.startDate, endDate = _ref$value.endDate, onChange = _ref.onChange, maxDate = _ref.maxDate, minDate = _ref.minDate, isStartDateCalendarOpen = _ref.isStartDateCalendarOpen, isEndDateCalendarOpen = _ref.isEndDateCalendarOpen, placeholder = _ref.placeholder;
    var _useIntl = (0, $hrVKU.default)(), locale = _useIntl.locale, formatMessage = _useIntl.formatMessage;
    // Send back date as Unix timestamp
    var onChangeStartDate = (0, $5FkrB.useCallback)(function(value) {
        var startDateAsEpoch = value ? "".concat((0, (/*@__PURE__*/$parcel$interopDefault($kuWWJ)))(value, $2cf06eea7c75218d$var$ISODateFormat).valueOf()) : undefined;
        onChange({
            startDate: startDateAsEpoch,
            endDate: endDate
        });
    }, [
        onChange,
        endDate
    ]);
    // Send back date as Unix timestamp
    var onChangeEndDate = (0, $5FkrB.useCallback)(function(value) {
        var endDateAsEpoch = value ? "".concat((0, (/*@__PURE__*/$parcel$interopDefault($kuWWJ)))(value, $2cf06eea7c75218d$var$ISODateFormat).endOf('day').valueOf()) : undefined;
        onChange({
            startDate: startDate,
            endDate: endDateAsEpoch
        });
    }, [
        onChange,
        startDate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), {
        xcss: $2cf06eea7c75218d$var$pickerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), {
        xcss: $2cf06eea7c75218d$var$datePickerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e765debe27d2174e$export$2e2bcd8739ae039), {
        id: "".concat(id, "-between-dates-start-date-value"),
        testId: "".concat(testId, "-between-dates-start-date-value"),
        onChange: onChangeStartDate,
        locale: locale,
        inputLabel: formatMessage((0, $043b65a36d0d2e9a$export$defe85febe8b728c).openStartDateLabel),
        name: formatMessage((0, $043b65a36d0d2e9a$export$defe85febe8b728c).openStartDateLabel),
        value: $2cf06eea7c75218d$var$convertFromEpochToDate(startDate),
        spacing: "compact",
        parseInputValue: $2cf06eea7c75218d$var$parseInputToDate,
        shouldShowCalendarButton: true,
        maxDate: maxDate,
        minDate: minDate,
        isOpen: isStartDateCalendarOpen,
        placeholder: placeholder === null || placeholder === void 0 ? void 0 : placeholder.startDate,
        label: formatMessage((0, $043b65a36d0d2e9a$export$defe85febe8b728c).openStartDateLabel)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), {
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, $043b65a36d0d2e9a$export$defe85febe8b728c).and)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), {
        xcss: $2cf06eea7c75218d$var$datePickerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e765debe27d2174e$export$2e2bcd8739ae039), {
        id: "".concat(id, "-between-dates-end-date-value"),
        testId: "".concat(testId, "-between-dates-end-date-value"),
        onChange: onChangeEndDate,
        locale: locale,
        inputLabel: formatMessage((0, $043b65a36d0d2e9a$export$defe85febe8b728c).openEndDateLabel),
        name: formatMessage((0, $043b65a36d0d2e9a$export$defe85febe8b728c).openEndDateLabel),
        value: $2cf06eea7c75218d$var$convertFromEpochToDate(endDate),
        spacing: "compact",
        parseInputValue: $2cf06eea7c75218d$var$parseInputToDate,
        shouldShowCalendarButton: true,
        maxDate: maxDate,
        minDate: minDate,
        isOpen: isEndDateCalendarOpen,
        placeholder: placeholder === null || placeholder === void 0 ? void 0 : placeholder.endDate,
        label: formatMessage((0, $043b65a36d0d2e9a$export$defe85febe8b728c).openEndDateLabel)
    })));
};

/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $25nEq = parcelRequire("25nEq");


var $5FkrB = parcelRequire("5FkrB");

var $bgNpv = parcelRequire("bgNpv");
var $hrVKU = parcelRequire("hrVKU");

var $4Pn6z = parcelRequire("4Pn6z");
var $gDiFE = parcelRequire("gDiFE");


var $6fyuV = parcelRequire("6fyuV");

var $6bnW7 = parcelRequire("6bnW7");
var $2811aecb0ee93c35$export$defe85febe8b728c = (0, $6bnW7.defineMessages)({
    to: {
        id: 'filter.in-time-range.to',
        defaultMessage: 'to',
        description: 'Separator word displayed between the start and end time period input fields in the in-time-range datetime filter.'
    },
    startLabel: {
        id: 'filter.in-time-range.start-label',
        defaultMessage: 'Enter start period time range value',
        description: 'Label for start period time range textfield input'
    },
    endLabel: {
        id: 'filter.in-time-range.end-label',
        defaultMessage: 'Enter end period time range value',
        description: 'Label for end period time range textfield input'
    }
});


var $a908c0470463ad55$var$PickerWrapper = (0, $gDiFE.xcss)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
}, (0, $86b286ad5c089076$export$987d49ffe1b0900f).above.xs, {
    flexDirection: 'row',
    alignItems: 'center'
}));
var $a908c0470463ad55$var$TextfieldWrapper = (0, $gDiFE.xcss)({
    flex: 1
});
var $a908c0470463ad55$var$TextWrapper = (0, $gDiFE.xcss)({
    flex: 0
});
var $a908c0470463ad55$export$2ef4c40bb6374452 = function InTimeRange(_ref) {
    var id = _ref.id, testId = _ref.testId, placeholder = _ref.placeholder, _ref$value = _ref.value, startPeriod = _ref$value.startPeriod, endPeriod = _ref$value.endPeriod, onChange = _ref.onChange, disableFutureTimeRanges = _ref.disableFutureTimeRanges;
    var _useIntl = (0, $hrVKU.default)(), formatMessage = _useIntl.formatMessage;
    var onStartPeriodChange = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function(e) {
        onChange({
            startPeriod: e.currentTarget.value,
            endPeriod: endPeriod
        });
    }, [
        onChange,
        endPeriod
    ]);
    var onEndPeriodChange = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function(e) {
        onChange({
            startPeriod: startPeriod,
            endPeriod: e.currentTarget.value
        });
    }, [
        onChange,
        startPeriod
    ]);
    var startPeriodPlaceholder = (placeholder === null || placeholder === void 0 ? void 0 : placeholder.startPeriod) || '-3w 4d 5h 6m';
    var endPeriodPlaceholder = (placeholder === null || placeholder === void 0 ? void 0 : placeholder.endPeriod) || (disableFutureTimeRanges ? '-3w 4d 5h 6m' : '3w 4d 5h 6m');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), {
        testId: "".concat(testId, "-in-time-range-container"),
        xcss: $a908c0470463ad55$var$PickerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), {
        xcss: $a908c0470463ad55$var$TextfieldWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6fyuV.default), {
        "aria-describedby": "invalidDateError",
        id: "".concat(id, "-in-time-range-start-period-value"),
        testId: "".concat(testId, "-in-time-range-start-period-value"),
        "aria-label": formatMessage((0, $2811aecb0ee93c35$export$defe85febe8b728c).startLabel),
        name: formatMessage((0, $2811aecb0ee93c35$export$defe85febe8b728c).startLabel),
        value: startPeriod,
        isCompact: true,
        autoComplete: "off",
        onChange: onStartPeriodChange,
        placeholder: startPeriodPlaceholder
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), {
        xcss: $a908c0470463ad55$var$TextWrapper,
        paddingInlineStart: "space.100",
        paddingInlineEnd: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, $2811aecb0ee93c35$export$defe85febe8b728c).to)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), {
        xcss: $a908c0470463ad55$var$TextfieldWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6fyuV.default), {
        "aria-describedby": "invalidDateError",
        id: "".concat(id, "-in-time-range-end-period-value"),
        testId: "".concat(testId, "-in-time-range-end-period-value"),
        "aria-label": formatMessage((0, $2811aecb0ee93c35$export$defe85febe8b728c).endLabel),
        name: formatMessage((0, $2811aecb0ee93c35$export$defe85febe8b728c).endLabel),
        value: endPeriod,
        isCompact: true,
        autoComplete: "off",
        onChange: onEndPeriodChange,
        placeholder: endPeriodPlaceholder
    })));
};

/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $25nEq = parcelRequire("25nEq");


var $5FkrB = parcelRequire("5FkrB");

var $hrVKU = parcelRequire("hrVKU");

var $4Pn6z = parcelRequire("4Pn6z");
var $gDiFE = parcelRequire("gDiFE");


var $78ORw = parcelRequire("78ORw");

var $6fyuV = parcelRequire("6fyuV");


var $6bnW7 = parcelRequire("6bnW7");
var $0f4753708d44efc5$export$defe85febe8b728c = {
    common: (0, $6bnW7.defineMessages)({
        timeUnitDurationValueLabel: {
            id: 'admin-hub-filter.time-input.timeunit-duration-value.non-final',
            defaultMessage: 'Enter duration value',
            description: 'Accessible label for the numeric text field where the user enters a duration value in the datetime filter time input.'
        },
        timeUnitLabel: {
            id: 'admin-hub-filter.time-input.timeunit.label.non-final',
            defaultMessage: 'Select time unit',
            description: 'Accessible label for the drop-down field where the user selects the time unit (e.g. minutes, hours, days) in the datetime filter time input.'
        }
    }),
    WITHIN_THE_LAST: (0, $6bnW7.defineMessages)({
        m: {
            id: 'admin-hub-filter.within-the-last.minutes',
            defaultMessage: 'minutes',
            description: 'Option for selection of unit of time to filter for'
        },
        h: {
            id: 'admin-hub-filter.within-the-last.hours',
            defaultMessage: 'hours',
            description: 'Option for selection of unit of time to filter for'
        },
        d: {
            id: 'admin-hub-filter.within-the-last.days',
            defaultMessage: 'days',
            description: 'Option for selection of unit of time to filter for'
        },
        w: {
            id: 'admin-hub-filter.within-the-last.weeks',
            defaultMessage: 'weeks',
            description: 'Option for selection of unit of time to filter for'
        }
    }),
    MORE_THAN: (0, $6bnW7.defineMessages)({
        m: {
            id: 'admin-hub-filter.more-than.minutes',
            defaultMessage: 'minutes ago',
            description: 'Option for selection of unit of time to filter for'
        },
        h: {
            id: 'admin-hub-filter.more-than.hours',
            defaultMessage: 'hours ago',
            description: 'Option for selection of unit of time to filter for'
        },
        d: {
            id: 'admin-hub-filter.more-than.days',
            defaultMessage: 'days ago',
            description: 'Option for selection of unit of time to filter for'
        },
        w: {
            id: 'admin-hub-filter.more-than.weeks',
            defaultMessage: 'weeks ago',
            description: 'Option for selection of unit of time to filter for'
        }
    })
};


var $e350ab34bac75eec$var$timeInputContainerStyles = (0, $gDiFE.xcss)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
}, (0, $86b286ad5c089076$export$987d49ffe1b0900f).above.xs, {
    flexDirection: 'row',
    alignItems: 'center',
    width: '240px'
}));
var $e350ab34bac75eec$var$durationContainerStyles = (0, $gDiFE.xcss)({
    flex: 1
});
var $e350ab34bac75eec$var$timeUnitContainerStyles = (0, $gDiFE.xcss)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    flex: 2
}, (0, $86b286ad5c089076$export$987d49ffe1b0900f).above.xs, {
    paddingInlineStart: 'space.050'
}));
var $e350ab34bac75eec$export$a1af6f79df847fac = function TimeInput(_ref) {
    var id = _ref.id, testId = _ref.testId, placeholder = _ref.placeholder, filterType = _ref.filterType, _ref$value = _ref.value, unitValue = _ref$value.unitValue, timeUnit = _ref$value.timeUnit, onChange = _ref.onChange;
    var _useIntl = (0, $hrVKU.default)(), formatMessage = _useIntl.formatMessage;
    var onUnitValueChange = (0, $5FkrB.useCallback)(function(e) {
        onChange({
            unitValue: e.currentTarget.value,
            timeUnit: timeUnit
        });
    }, [
        onChange,
        timeUnit
    ]);
    var onTimeUnitChange = (0, $5FkrB.useCallback)(function(option) {
        onChange({
            unitValue: unitValue,
            timeUnit: (0, $289eb4eab502a333$export$d9e59215631231e3)[option !== null ? option.value : (0, $289eb4eab502a333$export$d9e59215631231e3).m]
        });
    }, [
        onChange,
        unitValue
    ]);
    var unitOptions = Object.keys((0, $289eb4eab502a333$export$d9e59215631231e3)).map(function(key) {
        return {
            key: key,
            label: formatMessage((0, $0f4753708d44efc5$export$defe85febe8b728c)[filterType][(0, $289eb4eab502a333$export$d9e59215631231e3)[key]]),
            value: key
        };
    });
    var selectValue = {
        label: formatMessage((0, $0f4753708d44efc5$export$defe85febe8b728c)[filterType][(0, $289eb4eab502a333$export$d9e59215631231e3)[timeUnit]]),
        value: unitValue
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), {
        testId: "".concat(testId, "-").concat(filterType, "-time-input-container"),
        xcss: $e350ab34bac75eec$var$timeInputContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), {
        xcss: $e350ab34bac75eec$var$durationContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6fyuV.default), {
        "aria-describedby": "invalidDateError",
        id: "".concat(id, "-").concat(filterType, "-timeunit-duration-value"),
        testId: "".concat(testId, "-").concat(filterType, "-timeunit-duration-value"),
        "aria-label": formatMessage((0, $0f4753708d44efc5$export$defe85febe8b728c).common.timeUnitDurationValueLabel),
        name: "timeunit-value",
        value: unitValue,
        isCompact: true,
        autoComplete: "off",
        placeholder: placeholder,
        onChange: onUnitValueChange
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4Pn6z.Box), {
        xcss: $e350ab34bac75eec$var$timeUnitContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $78ORw.default), {
        id: "".concat(id, "-").concat(filterType, "-timeunit"),
        testId: "".concat(testId, "-").concat(filterType, "-timeunit"),
        label: formatMessage((0, $0f4753708d44efc5$export$defe85febe8b728c).common.timeUnitLabel),
        value: selectValue,
        name: "timeunit",
        options: unitOptions,
        spacing: "compact",
        onChange: onTimeUnitChange
    })));
};



var $6bnW7 = parcelRequire("6bnW7");
var $67c9381fa677d8e7$export$defe85febe8b728c = (0, $6bnW7.defineMessages)({
    BETWEEN_DATES: {
        id: 'admin-hub-filter.option.between-dates',
        defaultMessage: 'Between',
        description: 'Radio option for selecting a time range option between two dates'
    },
    WITHIN_THE_LAST: {
        id: 'admin-hub-filter.option.within-the-last',
        defaultMessage: 'Within the last',
        description: 'Radio option for filter to choose a time range within the last defined minute/hours/days, etc.'
    },
    MORE_THAN: {
        id: 'admin-hub-filter.option.more-than',
        defaultMessage: 'More than',
        description: 'Radio option for filter to choose a time range more than defined minute/hours/days, etc.'
    },
    IN_TIME_RANGE: {
        id: 'admin-hub-filter.option.in-time-range',
        defaultMessage: 'In the range',
        description: 'Radio option to input a time range between two relative time periods'
    },
    popUpLabel: {
        id: 'admin-hub-filter.popup.label',
        defaultMessage: 'Popup for date time filter"',
        description: 'Accessible label for the popup overlay that contains the date and time filter controls in the admin hub filter component.'
    },
    update: {
        id: 'admin-hub-filter.option.update',
        defaultMessage: 'Update',
        description: 'Label for the Update button inside the datetime filter popup that applies the selected date and time filter criteria.'
    },
    validationMessageBeforeGreaterThanAfter: {
        id: 'admin-hub-filter.utils.validation-message-before-greater-than-after',
        defaultMessage: "'Before' field cannot be later than 'After' field.",
        description: 'Message displayed to the user when the Before date used is greater than the after date while specifying dates'
    },
    validationMessageTimeRangeCannotIncludeFutureDate: {
        id: 'filter.utils.validation-message-time-range-cannot-include-future-date-nonfinal',
        defaultMessage: 'Time range cannot include a future date.',
        description: 'Message displayed to the user when the time range input includes a future date'
    },
    invalidPeriodFormat: {
        id: 'admin-hub-filter.utils.validation-message-invalid-period-format',
        defaultMessage: 'Enter a valid number',
        description: 'Message displayed to the user when an invalid unit value for the offset is provided.'
    },
    invalidPeriodRangeFormat: {
        id: 'filter.utils.validation-message-invalid-period-range-format',
        defaultMessage: 'Invalid period format. Please enter the period in the format "3w 4d 5h 6m".',
        description: 'Message displayed to the user when an invalid time period format.'
    },
    validationMessageDateOutOfRange: {
        id: 'admin-hub-filter.utils.validation-message-date-out-of-range',
        defaultMessage: 'Date is outside the allowed range.',
        description: 'Message displayed to the user when the resolved date from a relative input (Within the last, More than, or In the range) falls outside the permitted min/max date bounds.'
    }
});


/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");


var $hrVKU = parcelRequire("hrVKU");

var $4Pn6z = parcelRequire("4Pn6z");
var $gDiFE = parcelRequire("gDiFE");

var $6bnW7 = parcelRequire("6bnW7");
var $38a178e14e4efa20$export$defe85febe8b728c = (0, $6bnW7.defineMessages)({
    popupAriaLabel: {
        id: 'admin-hub-filter.popup.aria-label',
        defaultMessage: 'Popup for date time filter',
        description: 'Aria label for the date time filter popup'
    }
});


var $58756b982ff2ea0f$var$popupComponentContainerStyle = (0, $gDiFE.xcss)({
    borderRadius: 'radius.small',
    boxShadow: 'elevation.shadow.overlay',
    boxSizing: 'border-box',
    display: 'block',
    flex: '1 1 auto',
    overflow: 'visible',
    zIndex: 'layer'
});
// Mirroring DefaultPopupComponent from popper-wrapper.tsx
var $58756b982ff2ea0f$var$PopupComponent = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var _useIntl = (0, $hrVKU.default)(), formatMessage = _useIntl.formatMessage;
    return /*#__PURE__*/ $5FkrB.createElement((0, $4Pn6z.Box), {
        id: props.id ? "".concat(props.id, "-popup-component") : undefined,
        testId: props['data-testid'],
        role: "dialog",
        backgroundColor: "elevation.surface.overlay",
        xcss: $58756b982ff2ea0f$var$popupComponentContainerStyle,
        ref: ref,
        style: props.style,
        "aria-label": formatMessage((0, $38a178e14e4efa20$export$defe85febe8b728c).popupAriaLabel)
    }, props.children);
});
var $58756b982ff2ea0f$export$2e2bcd8739ae039 = $58756b982ff2ea0f$var$PopupComponent;



function $8d484fcd592fe46c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8d484fcd592fe46c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8d484fcd592fe46c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8d484fcd592fe46c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8d484fcd592fe46c$var$DateTimeFilterContainer = (0, $gDiFE.xcss)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    width: 'fit-content',
    minWidth: '0',
    maxWidth: '100vw'
}, (0, $86b286ad5c089076$export$987d49ffe1b0900f).above.xs, {
    minWidth: '388px'
}));
var $8d484fcd592fe46c$var$FilterOption = (0, $gDiFE.xcss)({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '26px'
});
var $8d484fcd592fe46c$var$RadioRow = (0, $gDiFE.xcss)({
    display: 'flex'
});
var $8d484fcd592fe46c$var$InputRow = (0, $gDiFE.xcss)({
    display: 'flex',
    flexDirection: 'column'
});
var $8d484fcd592fe46c$var$ActionButtonsContainer = (0, $gDiFE.xcss)({
    borderTop: "var(--ds-border-width, 1px)".concat(" solid ", "var(--ds-border, #0B120E24)")
});
var $8d484fcd592fe46c$var$InputWrapper = (0, $gDiFE.xcss)({
    flex: 1
});
var $8d484fcd592fe46c$var$ErrorContainer = (0, $gDiFE.xcss)({
    color: 'color.text.warning',
    display: 'flex',
    alignItems: 'center',
    font: 'font.body.small',
    gap: 'space.050'
});
var $8d484fcd592fe46c$var$getInitialSelectedDates = function getInitialSelectedDates(betweenDatesOptions) {
    if (betweenDatesOptions !== null && betweenDatesOptions !== void 0 && betweenDatesOptions.defaultStart && betweenDatesOptions !== null && betweenDatesOptions !== void 0 && betweenDatesOptions.defaultEnd) return {
        startDate: "".concat((0, (/*@__PURE__*/$parcel$interopDefault($kuWWJ)))(betweenDatesOptions === null || betweenDatesOptions === void 0 ? void 0 : betweenDatesOptions.defaultStart).valueOf()),
        endDate: "".concat((0, (/*@__PURE__*/$parcel$interopDefault($kuWWJ)))(betweenDatesOptions === null || betweenDatesOptions === void 0 ? void 0 : betweenDatesOptions.defaultEnd).valueOf())
    };
    return {
        startDate: "".concat((0, (/*@__PURE__*/$parcel$interopDefault($kuWWJ)))().endOf('D').subtract(2, 'days').valueOf()),
        endDate: "".concat((0, (/*@__PURE__*/$parcel$interopDefault($kuWWJ)))().endOf('D').valueOf())
    };
};
/**
 * Function that validates if the selected dates in unix time exist and if they make sense.
 * If valid, returns undefined, else, returns a string message about the error.
 *
 * @param {object} selectedDates Object that contains the start and end date that were just selected
 * @param {string | undefined} selectedDates.startDate String of start date in unix representation
 * @param {string | undefined} selectedDates.endDate String of end time in unix representation
 * @returns {React.JSX.Element | null} Returns a FormattedMessage error or a null value if no errors were found
 */ var $8d484fcd592fe46c$var$validateSelectedBetweenDates = function validateSelectedBetweenDates(selectedDates) {
    var startDate = selectedDates.startDate, endDate = selectedDates.endDate;
    if (startDate && endDate && endDate < startDate) return /*#__PURE__*/ $5FkrB.createElement((0, $bgNpv.default), (0, $67c9381fa677d8e7$export$defe85febe8b728c).validationMessageBeforeGreaterThanAfter);
    return null;
};
/**
 * Validates relative time inputs: within the last and more than values. If valid, returns null,
 * else, returns a string message about the error.
 *
 * @param {TimeInputValue} timeInput Object that contains the unit value and time unit
 * @returns {React.JSX.Element | null} Returns a FormattedMessage error or a null value if no errors were found
 */ var $8d484fcd592fe46c$var$validateTimeInput = function validateTimeInput(timeInput) {
    var unitValue = timeInput.unitValue;
    var parsedVal = Number(unitValue);
    var isDecimal = parsedVal % 1 !== 0 || unitValue.includes('.');
    if (isNaN(parsedVal) || parsedVal < 0 || isDecimal) return /*#__PURE__*/ $5FkrB.createElement((0, $bgNpv.default), (0, $67c9381fa677d8e7$export$defe85febe8b728c).invalidPeriodFormat);
    return null;
};
/**
 * Validates that the given between-dates range is fully contained within the
 * optional `minDate`/`maxDate` window. If either bound is violated, returns
 * the "Date is outside the allowed range." validation message; otherwise
 * returns null.
 *
 * `minDate`/`maxDate` [optional] are parsed with `moment` (local time), so `"YYYY-MM-DD"`
 * means the user's local start-of-day / end-of-day. The `startDate` / `endDate`
 * fields are absolute millisecond timestamps and are compared directly.
 */ var $8d484fcd592fe46c$var$validateBetweenDatesWithinBounds = function validateBetweenDatesWithinBounds(betweenDates, minDate, maxDate) {
    var startDate = betweenDates.startDate, endDate = betweenDates.endDate;
    if (minDate && startDate && Number(startDate) < (0, (/*@__PURE__*/$parcel$interopDefault($kuWWJ)))(minDate).startOf('D').valueOf() || maxDate && endDate && Number(endDate) > (0, (/*@__PURE__*/$parcel$interopDefault($kuWWJ)))(maxDate).endOf('D').valueOf()) return /*#__PURE__*/ $5FkrB.createElement((0, $bgNpv.default), (0, $67c9381fa677d8e7$export$defe85febe8b728c).validationMessageDateOutOfRange);
    return null;
};
/**
 * Validates a datetime range: checks the format of the time period strings and, if a range
 * exists, that it makes sense. If valid, returns null, else, returns a string message about
 * the error.
 *
 * @param {InTimeRangeValue} inTimeRangeValue A pair of time period strings for a time range
 * @param {string | undefined} inTimeRangeValue.startPeriod A time period string describing the beginning of a time range
 * @param {string | undefined} inTimeRangeValue.endPeriod A time period string describing the end of a time range
 * @returns {React.JSX.Element | null} Returns a FormattedMessage error or a null value if no errors were found
 */ var $8d484fcd592fe46c$var$validateTimeRange = function validateTimeRange(_ref) {
    var startPeriod = _ref.startPeriod, endPeriod = _ref.endPeriod;
    if (startPeriod === '' && endPeriod === '') return null;
    var workingBetweenDates = (0, $9159a798162ada16$export$27cc17b63a5387e5)({
        startPeriod: startPeriod,
        endPeriod: endPeriod
    });
    if (workingBetweenDates === null) return /*#__PURE__*/ $5FkrB.createElement((0, $bgNpv.default), (0, $67c9381fa677d8e7$export$defe85febe8b728c).invalidPeriodRangeFormat);
    return $8d484fcd592fe46c$var$validateSelectedBetweenDates(workingBetweenDates);
};
var $8d484fcd592fe46c$var$DatetimeFilter = function DatetimeFilter(_ref2) {
    var id = _ref2.id, testId = _ref2.testId, triggerLabel = _ref2.triggerLabel, betweenDatesOptions = _ref2.betweenDatesOptions, onSubmit = _ref2.onSubmit, submitOnChange = _ref2.submitOnChange, dateValues = _ref2.dateValues, maxDate = _ref2.maxDate, minDate = _ref2.minDate, isInitiallyOpened = _ref2.isInitiallyOpened, disableFutureTimeRanges = _ref2.disableFutureTimeRanges, placeholders = _ref2.placeholders, excludedFilterTypes = _ref2.excludedFilterTypes, shouldRenderToParent = _ref2.shouldRenderToParent;
    var visibleFilterTypes = (0, $5FkrB.useMemo)(function() {
        return excludedFilterTypes && excludedFilterTypes.length > 0 ? (0, $c013b3b4ee68e75f$export$18932e8706af151c).filter(function(filterType) {
            return !excludedFilterTypes.includes(filterType);
        }) : (0, $c013b3b4ee68e75f$export$18932e8706af151c);
    }, [
        excludedFilterTypes
    ]);
    var _useIntl = (0, $hrVKU.default)(), formatMessage = _useIntl.formatMessage;
    var _useState = (0, $5FkrB.useState)(!!isInitiallyOpened), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isPickerOpen = _useState2[0], setIsPickerOpen = _useState2[1];
    var initialFocusFilterTypeRef = (0, $5FkrB.useRef)(undefined);
    var wasPickerOpenRef = (0, $5FkrB.useRef)(false);
    var _useState3 = (0, $5FkrB.useState)(dateValues), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), activeDatesValues = _useState4[0], setActiveDatesValues = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)((dateValues === null || dateValues === void 0 ? void 0 : dateValues.filterType) || (0, $380570a298df429f$export$23a3939f30e96d0d)), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), selectedFilter = _useState6[0], setSelectedFilter = _useState6[1];
    var _useState7 = (0, $5FkrB.useState)((dateValues === null || dateValues === void 0 ? void 0 : dateValues.betweenDates) || $8d484fcd592fe46c$var$getInitialSelectedDates(betweenDatesOptions)), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState7, 2), selectedBetweenDatesValues = _useState8[0], setSelectedBetweenDatesValues = _useState8[1];
    var _useState9 = (0, $5FkrB.useState)((dateValues === null || dateValues === void 0 ? void 0 : dateValues.withinTheLast) || (0, $289eb4eab502a333$export$83c81c9b7b7a0a1f)), _useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState9, 2), withinTheLastValues = _useState0[0], setWithinTheLastValues = _useState0[1];
    var _useState1 = (0, $5FkrB.useState)((dateValues === null || dateValues === void 0 ? void 0 : dateValues.moreThan) || (0, $289eb4eab502a333$export$83c81c9b7b7a0a1f)), _useState10 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState1, 2), moreThanValues = _useState10[0], setMoreThanValues = _useState10[1];
    var _useState11 = (0, $5FkrB.useState)((dateValues === null || dateValues === void 0 ? void 0 : dateValues.inTimeRange) || (0, $4d293f787d49bb57$export$b6e2d38d788f819d)), _useState12 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState11, 2), inTimeRangeValues = _useState12[0], setInTimeRangeValues = _useState12[1];
    //  This controls what appears in the Dynamic label
    var _useState13 = (0, $5FkrB.useState)($8d484fcd592fe46c$var$validateSelectedBetweenDates(selectedBetweenDatesValues)), _useState14 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState13, 2), error = _useState14[0], setError = _useState14[1];
    // whenever the "dateValues" prop changes, update the internal state of the component
    (0, $5FkrB.useEffect)(function() {
        setActiveDatesValues(dateValues);
        setSelectedFilter((dateValues === null || dateValues === void 0 ? void 0 : dateValues.filterType) || (0, $380570a298df429f$export$23a3939f30e96d0d));
        setSelectedBetweenDatesValues((dateValues === null || dateValues === void 0 ? void 0 : dateValues.betweenDates) || $8d484fcd592fe46c$var$getInitialSelectedDates(betweenDatesOptions));
        setWithinTheLastValues((dateValues === null || dateValues === void 0 ? void 0 : dateValues.withinTheLast) || (0, $289eb4eab502a333$export$83c81c9b7b7a0a1f));
        setMoreThanValues((dateValues === null || dateValues === void 0 ? void 0 : dateValues.moreThan) || (0, $289eb4eab502a333$export$83c81c9b7b7a0a1f));
        setInTimeRangeValues((dateValues === null || dateValues === void 0 ? void 0 : dateValues.inTimeRange) || (0, $4d293f787d49bb57$export$b6e2d38d788f819d));
    }, [
        dateValues,
        betweenDatesOptions
    ]);
    var onPickerClose = function onPickerClose() {
        setIsPickerOpen(false);
    };
    var validateSelectedDateValues = function validateSelectedDateValues(filterType) {
        switch(filterType){
            case 0, $380570a298df429f$export$23a3939f30e96d0d:
                return $8d484fcd592fe46c$var$validateSelectedBetweenDates(selectedBetweenDatesValues);
            case 0, $289eb4eab502a333$export$3eb32c07c48a482:
                return $8d484fcd592fe46c$var$validateTimeInput(withinTheLastValues);
            case 0, $289eb4eab502a333$export$1d6ceeecb2c7a18d:
                return $8d484fcd592fe46c$var$validateTimeInput(moreThanValues);
            case 0, $4d293f787d49bb57$export$e54cb950486aac3c:
                return $8d484fcd592fe46c$var$validateTimeRange(inTimeRangeValues);
            default:
                return null;
        }
    };
    var handleFilterTypeChange = function handleFilterTypeChange(_ref3) {
        var value = _ref3.currentTarget.value;
        var errorMessage = validateSelectedDateValues(value);
        setSelectedFilter(value);
        setError(errorMessage);
        if (errorMessage || !submitOnChange) return;
        switch(value){
            case 0, $380570a298df429f$export$23a3939f30e96d0d:
                onBetweenDatesChange(selectedBetweenDatesValues);
                break;
            case 0, $289eb4eab502a333$export$3eb32c07c48a482:
                onWithinTheLastChange(withinTheLastValues);
                break;
            case 0, $289eb4eab502a333$export$1d6ceeecb2c7a18d:
                onMoreThanChange(moreThanValues);
                break;
            case 0, $4d293f787d49bb57$export$e54cb950486aac3c:
                onInTimeRangeChange(inTimeRangeValues);
                break;
            default:
                break;
        }
    };
    var handleOnChange = function handleOnChange(newValues) {
        if (!submitOnChange) return;
        var currentValues = {
            filterType: selectedFilter,
            betweenDates: selectedBetweenDatesValues,
            withinTheLast: withinTheLastValues,
            moreThan: moreThanValues,
            inTimeRange: inTimeRangeValues
        };
        var values = $8d484fcd592fe46c$var$_objectSpread($8d484fcd592fe46c$var$_objectSpread({}, currentValues), newValues);
        setActiveDatesValues(values);
        onSubmit(values);
    };
    var handleClearSelection = (0, $5FkrB.useCallback)(function() {
        var values = {
            filterType: (0, $380570a298df429f$export$23a3939f30e96d0d),
            betweenDates: undefined,
            withinTheLast: undefined,
            moreThan: undefined,
            inTimeRange: undefined
        };
        setActiveDatesValues(values);
        setSelectedBetweenDatesValues((0, $380570a298df429f$export$7fdef674d2870515));
        setWithinTheLastValues((0, $289eb4eab502a333$export$83c81c9b7b7a0a1f));
        setMoreThanValues((0, $289eb4eab502a333$export$83c81c9b7b7a0a1f));
        setInTimeRangeValues((0, $4d293f787d49bb57$export$b6e2d38d788f819d));
        setError(null);
        onSubmit(values);
    }, [
        onSubmit
    ]);
    var onBetweenDatesChange = function onBetweenDatesChange(newVal) {
        setSelectedBetweenDatesValues(newVal);
        // On every change of date selection, also do some validation on the new selected dates
        var errorMessage = $8d484fcd592fe46c$var$validateSelectedBetweenDates(newVal);
        setError(errorMessage);
        if (errorMessage) return;
        handleOnChange({
            filterType: (0, $380570a298df429f$export$23a3939f30e96d0d),
            betweenDates: newVal
        });
    };
    var onWithinTheLastChange = function onWithinTheLastChange(_ref4) {
        var unitValue = _ref4.unitValue, timeUnit = _ref4.timeUnit;
        // Allow updating with an empty string in order to "clear" the input field. No error ocurred, but we cannot
        // proceed with syncing the [SelectedBetweenDatesValues] because an empty string is not a number, but it
        // will be parsed as a "0".
        if (unitValue === '') {
            setError(null);
            setWithinTheLastValues({
                unitValue: unitValue,
                timeUnit: timeUnit
            });
            if (submitOnChange) {
                setSelectedBetweenDatesValues((0, $380570a298df429f$export$7fdef674d2870515));
                setMoreThanValues((0, $289eb4eab502a333$export$83c81c9b7b7a0a1f));
                setInTimeRangeValues((0, $4d293f787d49bb57$export$b6e2d38d788f819d));
            }
            // if user is manually clearing the datetime filter, also clear the between dates
            handleOnChange({
                filterType: (0, $289eb4eab502a333$export$3eb32c07c48a482),
                betweenDates: selectedBetweenDatesValues,
                withinTheLast: {
                    unitValue: unitValue,
                    timeUnit: timeUnit
                }
            });
            return;
        }
        var changedBetweenDates = (0, $9159a798162ada16$export$f1f2862ec6f674f7)({
            unitValue: unitValue,
            timeUnit: timeUnit
        });
        if (changedBetweenDates === null) {
            setWithinTheLastValues({
                unitValue: unitValue,
                timeUnit: timeUnit
            });
            setError(/*#__PURE__*/ $5FkrB.createElement((0, $bgNpv.default), (0, $67c9381fa677d8e7$export$defe85febe8b728c).invalidPeriodFormat));
            return;
        }
        var boundsError = $8d484fcd592fe46c$var$validateBetweenDatesWithinBounds(changedBetweenDates, minDate, maxDate);
        if (boundsError !== null) {
            setWithinTheLastValues({
                unitValue: unitValue,
                timeUnit: timeUnit
            });
            setError(boundsError);
            return;
        }
        setSelectedBetweenDatesValues(changedBetweenDates);
        setWithinTheLastValues({
            unitValue: unitValue,
            timeUnit: timeUnit
        });
        setError(null);
        handleOnChange({
            filterType: (0, $289eb4eab502a333$export$3eb32c07c48a482),
            betweenDates: changedBetweenDates,
            withinTheLast: {
                unitValue: unitValue,
                timeUnit: timeUnit
            }
        });
    };
    var onMoreThanChange = function onMoreThanChange(_ref5) {
        var unitValue = _ref5.unitValue, timeUnit = _ref5.timeUnit;
        // Allow updating with an empty string in order to "clear" the input field. No error ocurred, but we cannot
        // proceed with syncing the [SelectedBetweenDatesValues] because an empty string is not a number, but it
        // will be parsed as a "0".
        if (unitValue === '') {
            setError(null);
            setMoreThanValues({
                unitValue: unitValue,
                timeUnit: timeUnit
            });
            if (submitOnChange) {
                setSelectedBetweenDatesValues((0, $380570a298df429f$export$7fdef674d2870515));
                setWithinTheLastValues((0, $289eb4eab502a333$export$83c81c9b7b7a0a1f));
                setInTimeRangeValues((0, $4d293f787d49bb57$export$b6e2d38d788f819d));
            }
            handleOnChange({
                filterType: (0, $289eb4eab502a333$export$1d6ceeecb2c7a18d),
                betweenDates: selectedBetweenDatesValues,
                moreThan: {
                    unitValue: unitValue,
                    timeUnit: timeUnit
                }
            });
            return;
        }
        var changedBetweenDates = (0, $9159a798162ada16$export$f1f2862ec6f674f7)({
            unitValue: unitValue,
            timeUnit: timeUnit
        });
        if (changedBetweenDates === null) {
            setMoreThanValues({
                unitValue: unitValue,
                timeUnit: timeUnit
            });
            setError(/*#__PURE__*/ $5FkrB.createElement((0, $bgNpv.default), (0, $67c9381fa677d8e7$export$defe85febe8b728c).invalidPeriodFormat));
            return;
        }
        setSelectedBetweenDatesValues(changedBetweenDates);
        setMoreThanValues({
            unitValue: unitValue,
            timeUnit: timeUnit
        });
        setError(null);
        handleOnChange({
            filterType: (0, $289eb4eab502a333$export$1d6ceeecb2c7a18d),
            betweenDates: changedBetweenDates,
            moreThan: {
                unitValue: unitValue,
                timeUnit: timeUnit
            }
        });
    };
    var onInTimeRangeChange = function onInTimeRangeChange(_ref6) {
        var _changedBetweenDates$, _changedBetweenDates$2;
        var startPeriod = _ref6.startPeriod, endPeriod = _ref6.endPeriod;
        // Allow updating with an empty string in order to "clear" the input field. No error ocurred, but we cannot
        // proceed with syncing the [SelectedBetweenDatesValues] because an empty string is not a number, but it
        // will be parsed as a "0".
        if (startPeriod === '' && endPeriod === '') {
            setError(null);
            setInTimeRangeValues({
                startPeriod: startPeriod,
                endPeriod: endPeriod
            });
            // if user is manually clearing the datetime filter, also clear the between dates
            setSelectedBetweenDatesValues((0, $380570a298df429f$export$7fdef674d2870515));
            if (submitOnChange) {
                setWithinTheLastValues((0, $289eb4eab502a333$export$83c81c9b7b7a0a1f));
                setMoreThanValues((0, $289eb4eab502a333$export$83c81c9b7b7a0a1f));
            }
            handleOnChange({
                filterType: (0, $4d293f787d49bb57$export$e54cb950486aac3c),
                inTimeRange: {
                    startPeriod: startPeriod,
                    endPeriod: endPeriod
                }
            });
            return;
        }
        var changedBetweenDates = (0, $9159a798162ada16$export$27cc17b63a5387e5)({
            startPeriod: startPeriod,
            endPeriod: endPeriod
        });
        if (changedBetweenDates === null) {
            setInTimeRangeValues({
                startPeriod: startPeriod,
                endPeriod: endPeriod
            });
            setError(/*#__PURE__*/ $5FkrB.createElement((0, $bgNpv.default), (0, $67c9381fa677d8e7$export$defe85febe8b728c).invalidPeriodRangeFormat));
            return;
        }
        var now = (0, (/*@__PURE__*/$parcel$interopDefault($kuWWJ)))();
        var isStartPeriodFuture = (0, (/*@__PURE__*/$parcel$interopDefault($kuWWJ)))(parseInt((_changedBetweenDates$ = changedBetweenDates === null || changedBetweenDates === void 0 ? void 0 : changedBetweenDates.startDate) !== null && _changedBetweenDates$ !== void 0 ? _changedBetweenDates$ : '0')).isAfter(now);
        var isEndPeriodFuture = (0, (/*@__PURE__*/$parcel$interopDefault($kuWWJ)))(parseInt((_changedBetweenDates$2 = changedBetweenDates === null || changedBetweenDates === void 0 ? void 0 : changedBetweenDates.endDate) !== null && _changedBetweenDates$2 !== void 0 ? _changedBetweenDates$2 : '0')).isAfter(now);
        if (disableFutureTimeRanges && (isStartPeriodFuture || isEndPeriodFuture)) {
            setInTimeRangeValues({
                startPeriod: startPeriod,
                endPeriod: endPeriod
            });
            setError(/*#__PURE__*/ $5FkrB.createElement((0, $bgNpv.default), (0, $67c9381fa677d8e7$export$defe85febe8b728c).validationMessageTimeRangeCannotIncludeFutureDate));
            return;
        }
        var validationError = $8d484fcd592fe46c$var$validateSelectedBetweenDates(changedBetweenDates);
        if (validationError !== null) {
            setInTimeRangeValues({
                startPeriod: startPeriod,
                endPeriod: endPeriod
            });
            setError(validationError);
            return;
        }
        var boundsError = $8d484fcd592fe46c$var$validateBetweenDatesWithinBounds(changedBetweenDates, minDate, maxDate);
        if (boundsError !== null) {
            setInTimeRangeValues({
                startPeriod: startPeriod,
                endPeriod: endPeriod
            });
            setError(boundsError);
            return;
        }
        setSelectedBetweenDatesValues(changedBetweenDates);
        setInTimeRangeValues({
            startPeriod: startPeriod,
            endPeriod: endPeriod
        });
        setError(null);
        handleOnChange({
            filterType: (0, $4d293f787d49bb57$export$e54cb950486aac3c),
            betweenDates: changedBetweenDates,
            inTimeRange: {
                startPeriod: startPeriod,
                endPeriod: endPeriod
            }
        });
    };
    var handleSubmit = (0, $5FkrB.useCallback)(function() {
        onPickerClose();
        var values = {
            filterType: selectedFilter,
            betweenDates: selectedBetweenDatesValues,
            withinTheLast: withinTheLastValues,
            moreThan: moreThanValues,
            inTimeRange: inTimeRangeValues
        };
        setActiveDatesValues(values);
        onSubmit(values);
    }, [
        selectedFilter,
        selectedBetweenDatesValues,
        withinTheLastValues,
        moreThanValues,
        inTimeRangeValues,
        onSubmit
    ]);
    var hasAnActiveDateSet = (0, $5FkrB.useMemo)(function() {
        var _activeDatesValues$be, _activeDatesValues$be2, _activeDatesValues$in, _activeDatesValues$in2;
        if (!activeDatesValues || !activeDatesValues.filterType) return false;
        var hasActiveBetweenDates = activeDatesValues.filterType === (0, $380570a298df429f$export$23a3939f30e96d0d) && !!(activeDatesValues !== null && activeDatesValues !== void 0 && activeDatesValues.betweenDates) && (!!((_activeDatesValues$be = activeDatesValues.betweenDates) !== null && _activeDatesValues$be !== void 0 && _activeDatesValues$be.startDate) || !!((_activeDatesValues$be2 = activeDatesValues.betweenDates) !== null && _activeDatesValues$be2 !== void 0 && _activeDatesValues$be2.endDate));
        var hasActiveTimeInput = function hasActiveTimeInput(timeInputValue) {
            return (timeInputValue === null || timeInputValue === void 0 ? void 0 : timeInputValue.unitValue) !== '';
        };
        var hasActiveWithinTheLast = activeDatesValues.filterType === (0, $289eb4eab502a333$export$3eb32c07c48a482) && !!(activeDatesValues !== null && activeDatesValues !== void 0 && activeDatesValues.withinTheLast) && hasActiveTimeInput(activeDatesValues.withinTheLast);
        var hasActiveMoreThan = activeDatesValues.filterType === (0, $289eb4eab502a333$export$1d6ceeecb2c7a18d) && !!(activeDatesValues !== null && activeDatesValues !== void 0 && activeDatesValues.moreThan) && hasActiveTimeInput(activeDatesValues.moreThan);
        var hasActiveInTimeRange = activeDatesValues.filterType === (0, $4d293f787d49bb57$export$e54cb950486aac3c) && !!(activeDatesValues !== null && activeDatesValues !== void 0 && activeDatesValues.inTimeRange) && (activeDatesValues === null || activeDatesValues === void 0 || (_activeDatesValues$in = activeDatesValues.inTimeRange) === null || _activeDatesValues$in === void 0 ? void 0 : _activeDatesValues$in.startPeriod) !== '' && (activeDatesValues === null || activeDatesValues === void 0 || (_activeDatesValues$in2 = activeDatesValues.inTimeRange) === null || _activeDatesValues$in2 === void 0 ? void 0 : _activeDatesValues$in2.endPeriod) !== '';
        return hasActiveBetweenDates || hasActiveWithinTheLast || hasActiveMoreThan || hasActiveInTimeRange;
    }, [
        activeDatesValues
    ]);
    var renderTrigger = function renderTrigger(triggerProps) {
        var toggleOpen = function toggleOpen() {
            return setIsPickerOpen(!isPickerOpen);
        };
        return /*#__PURE__*/ $5FkrB.createElement((0, $dUWEU.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            id: "".concat(id, "-datetime-trigger"),
            testId: "".concat(testId, "-datetime-trigger"),
            onClick: toggleOpen
        }, triggerProps, {
            isSelected: isPickerOpen || hasAnActiveDateSet,
            iconAfter: function iconAfter(iconProps) {
                return /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($h19KG))), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, iconProps, {
                    size: "small"
                }));
            }
        }), /*#__PURE__*/ $5FkrB.createElement((0, $8e9a488dd3812b69$export$a0b4e36f606aa66f), {
            triggerLabel: triggerLabel,
            selectedDates: activeDatesValues,
            isPickerOpen: isPickerOpen
        }));
    };
    var getDateInput = function getDateInput(filterType) {
        switch(filterType){
            case 0, $380570a298df429f$export$23a3939f30e96d0d:
                return /*#__PURE__*/ $5FkrB.createElement((0, $2cf06eea7c75218d$export$45538c79899052b), {
                    id: id ? "".concat(id, "-between-dates") : undefined,
                    testId: testId,
                    placeholder: placeholders === null || placeholders === void 0 ? void 0 : placeholders.betweenDates,
                    value: selectedBetweenDatesValues,
                    onChange: onBetweenDatesChange,
                    maxDate: maxDate,
                    minDate: minDate
                });
            case 0, $289eb4eab502a333$export$3eb32c07c48a482:
                return /*#__PURE__*/ $5FkrB.createElement((0, $e350ab34bac75eec$export$a1af6f79df847fac), {
                    id: id ? "".concat(id, "-time-input") : undefined,
                    testId: testId,
                    placeholder: placeholders === null || placeholders === void 0 ? void 0 : placeholders.withinTheLast,
                    filterType: filterType,
                    value: withinTheLastValues,
                    onChange: onWithinTheLastChange
                });
            case 0, $289eb4eab502a333$export$1d6ceeecb2c7a18d:
                return /*#__PURE__*/ $5FkrB.createElement((0, $e350ab34bac75eec$export$a1af6f79df847fac), {
                    id: id ? "".concat(id, "-time-input") : undefined,
                    testId: testId,
                    placeholder: placeholders === null || placeholders === void 0 ? void 0 : placeholders.moreThan,
                    filterType: filterType,
                    value: moreThanValues,
                    onChange: onMoreThanChange
                });
            case 0, $4d293f787d49bb57$export$e54cb950486aac3c:
                return /*#__PURE__*/ $5FkrB.createElement((0, $a908c0470463ad55$export$2ef4c40bb6374452), {
                    id: id ? "".concat(id, "-in-time-range") : undefined,
                    testId: testId,
                    placeholder: placeholders === null || placeholders === void 0 ? void 0 : placeholders.inTimeRange,
                    value: inTimeRangeValues,
                    onChange: onInTimeRangeChange,
                    disableFutureTimeRanges: disableFutureTimeRanges
                });
            default:
                return null;
        }
    };
    // Focus on selected, else fallback to first visible if none
    if (isPickerOpen && !wasPickerOpenRef.current) initialFocusFilterTypeRef.current = visibleFilterTypes.includes(selectedFilter) ? selectedFilter : visibleFilterTypes[0];
    wasPickerOpenRef.current = isPickerOpen;
    var initialFocusFilterType = initialFocusFilterTypeRef.current;
    var renderContent = function renderContent(_ref7) {
        var setInitialFocusRef = _ref7.setInitialFocusRef;
        return /*#__PURE__*/ $5FkrB.createElement((0, $4Pn6z.Box), {
            xcss: $8d484fcd592fe46c$var$DateTimeFilterContainer
        }, /*#__PURE__*/ $5FkrB.createElement((0, $4Pn6z.Box), {
            paddingBlockStart: 'space.100',
            paddingBlockEnd: 'space.100',
            paddingInlineStart: 'space.100',
            paddingInlineEnd: 'space.200'
        }, visibleFilterTypes.map(function(filterType) {
            var isFilterSelected = filterType === selectedFilter;
            var showError = error && isFilterSelected;
            return /*#__PURE__*/ $5FkrB.createElement((0, $4Pn6z.Box), {
                paddingBlockEnd: 'space.200',
                xcss: $8d484fcd592fe46c$var$FilterOption,
                key: "".concat(filterType, "-filter-option")
            }, /*#__PURE__*/ $5FkrB.createElement((0, $4Pn6z.Box), {
                xcss: $8d484fcd592fe46c$var$RadioRow,
                key: "".concat(filterType, "-radio-row")
            }, /*#__PURE__*/ $5FkrB.createElement((0, $b59c286b12779831$export$2e2bcd8739ae039), {
                ref: filterType === initialFocusFilterType ? setInitialFocusRef : undefined,
                id: "".concat(id, "--radio-filter-").concat(filterType),
                isChecked: isFilterSelected,
                name: "mode",
                onChange: handleFilterTypeChange,
                label: /*#__PURE__*/ $5FkrB.createElement((0, $bgNpv.default), (0, $67c9381fa677d8e7$export$defe85febe8b728c)[filterType]),
                value: filterType,
                key: "".concat(filterType, "-radio-input")
            })), /*#__PURE__*/ $5FkrB.createElement((0, $4Pn6z.Box), {
                paddingBlockStart: 'space.025',
                paddingInlineStart: 'space.300',
                xcss: $8d484fcd592fe46c$var$InputRow,
                key: "".concat(filterType, "-input-row")
            }, /*#__PURE__*/ $5FkrB.createElement((0, $4Pn6z.Box), {
                xcss: $8d484fcd592fe46c$var$InputWrapper
            }, isFilterSelected && getDateInput(filterType)), showError && /*#__PURE__*/ $5FkrB.createElement((0, $4Pn6z.Box), {
                paddingInlineStart: 'space.025',
                xcss: $8d484fcd592fe46c$var$ErrorContainer
            }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cMVCI))), {
                label: "error",
                size: "small"
            }), /*#__PURE__*/ $5FkrB.createElement("span", {
                id: "invalidDateError",
                role: "alert",
                "aria-atomic": "true"
            }, error))));
        })), !submitOnChange && /*#__PURE__*/ $5FkrB.createElement((0, $4Pn6z.Box), {
            paddingBlockStart: 'space.100',
            paddingBlockEnd: 'space.100',
            paddingInlineStart: 'space.200',
            paddingInlineEnd: 'space.200',
            xcss: $8d484fcd592fe46c$var$ActionButtonsContainer
        }, /*#__PURE__*/ $5FkrB.createElement((0, $dUWEU.default), {
            onClick: handleSubmit,
            id: "".concat(id, "-update-button"),
            testId: "".concat(testId, "-update-button"),
            isDisabled: !!error
        }, /*#__PURE__*/ $5FkrB.createElement((0, $bgNpv.default), (0, $67c9381fa677d8e7$export$defe85febe8b728c).update))), submitOnChange && hasAnActiveDateSet && /*#__PURE__*/ $5FkrB.createElement((0, $4Pn6z.Box), {
            paddingBlockStart: 'space.100',
            paddingBlockEnd: 'space.100',
            paddingInlineStart: 'space.200',
            paddingInlineEnd: 'space.200',
            xcss: $8d484fcd592fe46c$var$ActionButtonsContainer
        }, /*#__PURE__*/ $5FkrB.createElement((0, $5900b3c7c8a85aa0$export$2e2bcd8739ae039), {
            id: id ? "".concat(id, "-clear-selection") : undefined,
            testId: testId,
            handleClearSelection: handleClearSelection
        })));
    };
    return /*#__PURE__*/ $5FkrB.createElement((0, $5tQm9.default), {
        defaultMessages: (0, $f71e7f1cc9464e0b$export$2e2bcd8739ae039),
        loaderFn: (0, $fd4467ba0d8a5a4a$export$2b153a2030b0feb2)
    }, /*#__PURE__*/ $5FkrB.createElement((0, $dY97G.Popup), {
        id: "".concat(id, "-datetime-popup"),
        testId: "".concat(testId, "-datetime-popup"),
        role: "dialog",
        label: formatMessage((0, $67c9381fa677d8e7$export$defe85febe8b728c).popUpLabel),
        placement: "bottom-start",
        isOpen: isPickerOpen,
        onClose: onPickerClose,
        popupComponent: (0, $58756b982ff2ea0f$export$2e2bcd8739ae039),
        shouldRenderToParent: shouldRenderToParent,
        trigger: renderTrigger,
        content: renderContent
    }));
};
var $8d484fcd592fe46c$export$2e2bcd8739ae039 = $8d484fcd592fe46c$var$DatetimeFilter;



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7WAD0 = parcelRequire("7WAD0");

var $7igKY = parcelRequire("7igKY");

var $auVZV = parcelRequire("auVZV");

var $64A04 = parcelRequire("64A04");

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $dY97G = parcelRequire("dY97G");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $9Pk7k = parcelRequire("9Pk7k");
var $hrVKU = parcelRequire("hrVKU");
var $698f956ac24d6ccf$exports = {};
$parcel$export($698f956ac24d6ccf$exports, "cs", () => $958971998ed7d134$export$2e2bcd8739ae039);
$parcel$export($698f956ac24d6ccf$exports, "da", () => $1e810be33cd5fd65$export$2e2bcd8739ae039);
$parcel$export($698f956ac24d6ccf$exports, "de", () => $c40d21710d41454f$export$2e2bcd8739ae039);
$parcel$export($698f956ac24d6ccf$exports, "en", () => $f7bff821faad5b2d$export$2e2bcd8739ae039);
$parcel$export($698f956ac24d6ccf$exports, "en_GB", () => $21b545089a595d91$export$2e2bcd8739ae039);
$parcel$export($698f956ac24d6ccf$exports, "en_ZZ", () => $80751496f558028d$export$2e2bcd8739ae039);
$parcel$export($698f956ac24d6ccf$exports, "es", () => $92848200565072ab$export$2e2bcd8739ae039);
$parcel$export($698f956ac24d6ccf$exports, "fi", () => $e4ebcc8435332fa5$export$2e2bcd8739ae039);
$parcel$export($698f956ac24d6ccf$exports, "fr", () => $c99185c40a6e25e8$export$2e2bcd8739ae039);
$parcel$export($698f956ac24d6ccf$exports, "hu", () => $1ad760108effdb07$export$2e2bcd8739ae039);
$parcel$export($698f956ac24d6ccf$exports, "it", () => $e70b3f39827a2833$export$2e2bcd8739ae039);
$parcel$export($698f956ac24d6ccf$exports, "ja", () => $8122a7a5470d0874$export$2e2bcd8739ae039);
$parcel$export($698f956ac24d6ccf$exports, "ko", () => $7bebfc79077e21ce$export$2e2bcd8739ae039);
$parcel$export($698f956ac24d6ccf$exports, "nb", () => $2a1d9d45a18bffb9$export$2e2bcd8739ae039);
$parcel$export($698f956ac24d6ccf$exports, "nl", () => $526a1f0196a3244a$export$2e2bcd8739ae039);
$parcel$export($698f956ac24d6ccf$exports, "pl", () => $0aaf7164e3826039$export$2e2bcd8739ae039);
$parcel$export($698f956ac24d6ccf$exports, "pt_BR", () => $70ce7c901c1e9d39$export$2e2bcd8739ae039);
$parcel$export($698f956ac24d6ccf$exports, "ru", () => $d0d890ceb3ea8092$export$2e2bcd8739ae039);
$parcel$export($698f956ac24d6ccf$exports, "sv", () => $1b3ca00268273473$export$2e2bcd8739ae039);
$parcel$export($698f956ac24d6ccf$exports, "th", () => $8bbaf056b1e25eda$export$2e2bcd8739ae039);
$parcel$export($698f956ac24d6ccf$exports, "tr", () => $7265057bd4c7a044$export$2e2bcd8739ae039);
$parcel$export($698f956ac24d6ccf$exports, "uk", () => $f903a258a8a78480$export$2e2bcd8739ae039);
$parcel$export($698f956ac24d6ccf$exports, "vi", () => $7472d3a06ae78ab6$export$2e2bcd8739ae039);
$parcel$export($698f956ac24d6ccf$exports, "zh", () => $ecd91fe6effa99af$export$2e2bcd8739ae039);
$parcel$export($698f956ac24d6ccf$exports, "zh_TW", () => $3bf13300a6f5d87e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $4672bf1808c68b64$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Zru\u0161it v\xfdb\u011Br",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Na\u010Dten\xed dat se nezda\u0159ilo.",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Kliknut\xedm opakovat",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Na\u010D\xedt\xe1n\xed\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Zobrazit v\xedce",
    'paginated-picker.async-select.pagination-details.of-total-count': "{itemsCount} z\xa0{totalCount}",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Nebyly nalezeny \u017E\xe1dn\xe9 shody",
    'paginated-picker.async-select.select.option.error-message': "Na\u010Dten\xed dat se nezda\u0159ilo.",
    'paginated-picker.async-select.select.option.retry-message': "Kliknut\xedm opakovat",
    'paginated-picker.async-select.select.search-placeholder': 'Vyhledat',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Zobrazit \xfapln\xfd seznam"
};


var $958971998ed7d134$export$2e2bcd8739ae039 = (0, $4672bf1808c68b64$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $d8fef0778e15d1d6$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Ryd valgte',
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Data kunne ikke hentes',
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Klik for at pr\xf8ve igen",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Indl\xe6ser ...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Vis mere',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} af {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Ingen match fundet',
    'paginated-picker.async-select.select.option.error-message': 'Data kunne ikke hentes',
    'paginated-picker.async-select.select.option.retry-message': "Klik for at pr\xf8ve igen",
    'paginated-picker.async-select.select.search-placeholder': "S\xf8g",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Vis hele listen'
};


var $1e810be33cd5fd65$export$2e2bcd8739ae039 = (0, $d8fef0778e15d1d6$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $daf8b42b91e86c10$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Auswahl l\xf6schen",
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Daten konnten nicht abgerufen werden.',
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Klicken, um es erneut zu versuchen',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "L\xe4dt\xa0...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Mehr anzeigen',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} von {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Keine Treffer gefunden',
    'paginated-picker.async-select.select.option.error-message': 'Daten konnten nicht abgerufen werden.',
    'paginated-picker.async-select.select.option.retry-message': 'Klicken, um es erneut zu versuchen',
    'paginated-picker.async-select.select.search-placeholder': 'Suchen',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Vollst\xe4ndige Liste anzeigen"
};


var $c40d21710d41454f$export$2e2bcd8739ae039 = (0, $daf8b42b91e86c10$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $37c30cb00c70704e$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Clear selection',
    'paginated-picker.async-select.menu-list.error-message.error-message': "Couldn't retrieve data",
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Click to retry',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Loading...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Show more',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} of {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'No matches found',
    'paginated-picker.async-select.select.option.error-message': "Couldn't retrieve data",
    'paginated-picker.async-select.select.option.retry-message': 'Click to retry',
    'paginated-picker.async-select.select.search-placeholder': 'Search',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Show full list'
};


var $f7bff821faad5b2d$export$2e2bcd8739ae039 = (0, $37c30cb00c70704e$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $2543f25c18640596$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Clear selection',
    'paginated-picker.async-select.menu-list.error-message.error-message': "Couldn't retrieve data",
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Click to retry',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Loading...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Show more',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} of {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'No matches found',
    'paginated-picker.async-select.select.option.error-message': "Couldn't retrieve data",
    'paginated-picker.async-select.select.option.retry-message': 'Click to retry',
    'paginated-picker.async-select.select.search-placeholder': 'Search',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Show full list'
};


var $21b545089a595d91$export$2e2bcd8739ae039 = (0, $2543f25c18640596$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $051b7696dac56d44$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u2063\u2062Clear selection\u206E\x9d\u206B\u2060\u206D\x8f\u206B\u200C\u200D\u206C\x9d\u206E\u200C\u206B\u206D\u200C\u206C\u206F\u206F\u206B\u206E\x81\u2060\u206F\u206A\u200D\x8d\u206D\u200C\x8d\u2060\u061C\u2063\u2064",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u2063\u2062Couldn't retrieve data\x81\u206A\u206D\u2060\u2061\u206F\x8d\u206E\u2060\x8d\u2060\u206C\u206E\u2061\u206E\x90\u206E\u200C\u200D\x81\u200D\u206F\u206C\u206D\x8d\u206B\x81\u206A\x8d\u200D\u206A\u200C\u2063\u2064",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u2063\u2062Click to retry\u206A\u200C\u206C\x8d\x9d\u206D\u2060\u200C\u206C\u206F\u206A\u206B\u206D\u206B\x8f\u206F\u206F\u206D\u206F\x8f\u206B\u206C\u2061\u061C\u206F\u061C\x8f\u206F\u200D\u2060\u206D\u206D\u2063\u2064",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u2063\u2062Loading...\u200D\u206C\u206E\x8f\u061C\u206D\u206D\u206B\u206D\x9d\u200D\x9d\u2061\x8f\u061C\u200C\x9d\u2060\x90\u2060\x90\u200C\u2061\u2061\x8d\x8f\x81\x8f\u2060\u206E\u206C\u200C\u2063\u2064",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u2063\u2062Show more\u206E\x81\x8f\u2060\x8d\u206A\u2061\u2060\x8d\x8d\x90\x8f\x8f\u200C\x90\u061C\x8f\u206A\x9d\u206C\u206F\x8d\u206D\u206D\u206F\u061C\x8d\x9d\u206C\u206B\u200D\u206D\u2063\u2064",
    'paginated-picker.async-select.pagination-details.of-total-count': "\u2063\u2062{itemsCount} of {totalCount}\u206D\u206B\u061C\u206C\x8f\u206F\u206F\x8d\x90\u061C\u2060\u061C\u206D\u206C\x8f\u200D\x9d\u2060\u206E\x8f\u200D\u200C\u200D\u206F\u206D\u206A\x8d\x8d\u206C\u2060\x81\x8d\u2063\u2064",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u2063\u2062No matches found\u061C\x9d\x81\u2060\u206E\u200C\u200D\u206E\u206F\x9d\x8f\u206F\u206A\u200C\u2061\u206A\u2060\u200C\u2060\x9d\u206E\x90\x8d\u206C\x8d\u206E\x9d\u200C\u206A\x81\x9d\u206C\u2063\u2064",
    'paginated-picker.async-select.select.option.error-message': "\u2063\u2062Couldn't retrieve data\u206C\u206E\x90\u2060\x8d\u200C\u061C\u2061\u2061\x90\u206F\u206B\u200D\u200D\x9d\u206C\u206E\u206D\u200D\x9d\u206B\u206D\u206B\u206D\u206E\u206F\x90\x81\u200C\u206A\u206C\u206D\u2063\u2064",
    'paginated-picker.async-select.select.option.retry-message': "\u2063\u2062Click to retry\x8f\u206C\u200C\x81\u061C\u206E\u061C\u206B\u206C\x9d\u206D\u206C\u206F\u206F\u206C\u206E\x8d\u200C\u200D\x90\u206D\x8d\u206F\u206B\x81\u2060\u206F\x8d\u206E\u206A\x90\u206A\u2063\u2064",
    'paginated-picker.async-select.select.search-placeholder': "\u2063\u2062Search\u200D\u206D\x90\u061C\u200D\u206A\u206E\x90\u206A\u206C\u206F\u061C\u200C\u206A\x90\u206D\x81\u206C\x9d\u061C\u200D\u200D\x8f\u206D\u206D\x8d\x8f\u206E\x9d\u2060\u206F\u2060\u2063\u2064",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u2063\u2062Show full list\x90\u206D\u2061\u206E\u206A\u206B\u061C\u206C\u206B\u206E\u206A\u206E\u206D\x9d\u2061\x8f\x9d\u206B\u2060\u200D\x9d\u2061\u206B\u206B\u206A\x90\x81\u206C\x81\u200C\u206D\u200D\u2063\u2064"
};


var $80751496f558028d$export$2e2bcd8739ae039 = (0, $051b7696dac56d44$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $9b16e9f3d1b81c88$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Borrar selecci\xf3n",
    'paginated-picker.async-select.menu-list.error-message.error-message': 'No se han podido recuperar los datos',
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Haz clic para intentarlo de nuevo',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Cargando\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Mostrar m\xe1s",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} de {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'No se han encontrado coincidencias',
    'paginated-picker.async-select.select.option.error-message': 'No se han podido recuperar los datos',
    'paginated-picker.async-select.select.option.retry-message': 'Haz clic para intentarlo de nuevo',
    'paginated-picker.async-select.select.search-placeholder': 'Buscar',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Mostrar lista completa'
};


var $92848200565072ab$export$2e2bcd8739ae039 = (0, $9b16e9f3d1b81c88$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Finnish
var $5f52fc96a507bb1a$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Tyhjenn\xe4 valinta",
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Tietoja ei voitu noutaa',
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Yrit\xe4 uudelleen napsauttamalla",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Ladataan...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "N\xe4yt\xe4 lis\xe4\xe4",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Ei hakutuloksia',
    'paginated-picker.async-select.select.option.error-message': 'Tietoja ei voitu noutaa',
    'paginated-picker.async-select.select.option.retry-message': "Yrit\xe4 uudelleen napsauttamalla",
    'paginated-picker.async-select.select.search-placeholder': 'Hae',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "N\xe4yt\xe4 koko luettelo"
};


var $e4ebcc8435332fa5$export$2e2bcd8739ae039 = (0, $5f52fc96a507bb1a$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $2d51f53e504b141a$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Effacer la s\xe9lection",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Impossible de r\xe9cup\xe9rer les donn\xe9es",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Cliquez pour r\xe9essayer",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Chargement en cours\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Afficher plus',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} sur {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "R\xe9sultats introuvables",
    'paginated-picker.async-select.select.option.error-message': "Impossible de r\xe9cup\xe9rer les donn\xe9es",
    'paginated-picker.async-select.select.option.retry-message': "Cliquez pour r\xe9essayer",
    'paginated-picker.async-select.select.search-placeholder': 'Rechercher',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Afficher toute la liste'
};


var $c99185c40a6e25e8$export$2e2bcd8739ae039 = (0, $2d51f53e504b141a$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Hungarian
var $d2e9b503a006f69b$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Kijel\xf6l\xe9s megsz\xfcntet\xe9se",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Nem siker\xfclt lek\xe9rni az adatokat",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Kattints az \xfajrapr\xf3b\xe1lkoz\xe1shoz",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Bet\xf6lt\xe9s\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "T\xf6bb",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Nincs egyez\xe9s",
    'paginated-picker.async-select.select.option.error-message': "Nem siker\xfclt lek\xe9rni az adatokat",
    'paginated-picker.async-select.select.option.retry-message': "Kattints az \xfajrapr\xf3b\xe1lkoz\xe1shoz",
    'paginated-picker.async-select.select.search-placeholder': "Keres\xe9s",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Teljes lista megjelen\xedt\xe9se"
};


var $1ad760108effdb07$export$2e2bcd8739ae039 = (0, $d2e9b503a006f69b$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $def3dfa3a7cdc286$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Cancella selezione',
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Impossibile recuperare i dati',
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Clicca per riprovare',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Caricamento in corso...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Mostra altro',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} di {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Nessuna corrispondenza trovata',
    'paginated-picker.async-select.select.option.error-message': 'Impossibile recuperare i dati',
    'paginated-picker.async-select.select.option.retry-message': 'Clicca per riprovare',
    'paginated-picker.async-select.select.search-placeholder': 'Ricerca',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Mostra l'elenco completo"
};


var $e70b3f39827a2833$export$2e2bcd8739ae039 = (0, $def3dfa3a7cdc286$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $e7171fbe3766ae77$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u9078\u629E\u3092\u89E3\u9664",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u30C7\u30FC\u30BF\u3092\u53D6\u5F97\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u518D\u8A66\u884C",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u8AAD\u307F\u8FBC\u307F\u4E2D\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u8868\u793A\u3092\u5897\u3084\u3059",
    'paginated-picker.async-select.pagination-details.of-total-count': "{totalCount} \u4EF6\u4E2D {itemsCount} \u4EF6",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u4E00\u81F4\u3059\u308B\u3082\u306E\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F",
    'paginated-picker.async-select.select.option.error-message': "\u30C7\u30FC\u30BF\u3092\u53D6\u5F97\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F",
    'paginated-picker.async-select.select.option.retry-message': "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u518D\u8A66\u884C",
    'paginated-picker.async-select.select.search-placeholder': "\u691C\u7D22",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u30EA\u30B9\u30C8\u5168\u4F53\u3092\u8868\u793A"
};


var $8122a7a5470d0874$export$2e2bcd8739ae039 = (0, $e7171fbe3766ae77$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $ca82c1416e813941$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\uC120\uD0DD \uD56D\uBAA9 \uC9C0\uC6B0\uAE30",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\uB370\uC774\uD130\uB97C \uAC80\uC0C9\uD560 \uC218 \uC5C6\uC74C",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\uD074\uB9AD\uD558\uC5EC \uB2E4\uC2DC \uC2DC\uB3C4",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\uB85C\uB4DC \uC911...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\uB354 \uBCF4\uAE30",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\uC77C\uCE58\uD558\uB294 \uD56D\uBAA9 \uC5C6\uC74C",
    'paginated-picker.async-select.select.option.error-message': "\uB370\uC774\uD130\uB97C \uAC80\uC0C9\uD560 \uC218 \uC5C6\uC74C",
    'paginated-picker.async-select.select.option.retry-message': "\uD074\uB9AD\uD558\uC5EC \uB2E4\uC2DC \uC2DC\uB3C4",
    'paginated-picker.async-select.select.search-placeholder': "\uAC80\uC0C9",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\uC804\uCCB4 \uBAA9\uB85D \uD45C\uC2DC"
};


var $7bebfc79077e21ce$export$2e2bcd8739ae039 = (0, $ca82c1416e813941$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Norwegian (Bokmål)
var $d79b90167a859e15$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Fjern valg',
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Kan ikke hente data',
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Klikk for \xe5 pr\xf8ve igjen",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Laster\xa0\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Vis mer',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} av {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Finner ingen treff',
    'paginated-picker.async-select.select.option.error-message': 'Kan ikke hente data',
    'paginated-picker.async-select.select.option.retry-message': "Klikk for \xe5 pr\xf8ve igjen",
    'paginated-picker.async-select.select.search-placeholder': "S\xf8k",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Vis fullstendig liste'
};


var $2a1d9d45a18bffb9$export$2e2bcd8739ae039 = (0, $d79b90167a859e15$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $76df351252d58f57$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Selectie wissen',
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Gegevens konden niet worden opgehaald',
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Klik om het opnieuw te proberen',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Laden...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Meer tonen',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} van {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Geen overeenkomsten gevonden',
    'paginated-picker.async-select.select.option.error-message': 'Gegevens konden niet worden opgehaald',
    'paginated-picker.async-select.select.option.retry-message': 'Klik om het opnieuw te proberen',
    'paginated-picker.async-select.select.search-placeholder': 'Zoeken',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Volledige lijst weergeven'
};


var $526a1f0196a3244a$export$2e2bcd8739ae039 = (0, $76df351252d58f57$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Polish (Poland)
var $19526a32e57df974$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Wyczy\u015B\u0107 wyb\xf3r",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Nie mo\u017Cna pobra\u0107 danych",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Kliknij, aby spr\xf3bowa\u0107 ponownie",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0141adowanie...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Poka\u017C wi\u0119cej",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} z {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Nie znaleziono dopasowa\u0144",
    'paginated-picker.async-select.select.option.error-message': "Nie mo\u017Cna pobra\u0107 danych",
    'paginated-picker.async-select.select.option.retry-message': "Kliknij, aby spr\xf3bowa\u0107 ponownie",
    'paginated-picker.async-select.select.search-placeholder': 'Szukaj',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Poka\u017C pe\u0142n\u0105 list\u0119"
};


var $0aaf7164e3826039$export$2e2bcd8739ae039 = (0, $19526a32e57df974$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $12269785a5c698e5$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Limpar sele\xe7\xe3o",
    'paginated-picker.async-select.menu-list.error-message.error-message': "N\xe3o foi poss\xedvel recuperar os dados",
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Clique para tentar de novo',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Carregando...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Ver mais',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} de {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Nenhuma correspond\xeancia encontrada",
    'paginated-picker.async-select.select.option.error-message': "N\xe3o foi poss\xedvel recuperar os dados",
    'paginated-picker.async-select.select.option.retry-message': 'Clique para tentar de novo',
    'paginated-picker.async-select.select.search-placeholder': 'Pesquisar',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Mostrar lista completa'
};


var $70ce7c901c1e9d39$export$2e2bcd8739ae039 = (0, $12269785a5c698e5$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $f44dd606d8f7c8f1$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u0421\u043D\u044F\u0442\u044C \u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u0435",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u043F\u044B\u0442\u043A\u0443",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u0420\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C",
    'paginated-picker.async-select.pagination-details.of-total-count': "{itemsCount} \u0438\u0437 {totalCount}",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u0421\u043E\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u044F \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B",
    'paginated-picker.async-select.select.option.error-message': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435",
    'paginated-picker.async-select.select.option.retry-message': "\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u043F\u044B\u0442\u043A\u0443",
    'paginated-picker.async-select.select.search-placeholder': "\u041F\u043E\u0438\u0441\u043A",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043F\u043E\u043B\u043D\u044B\u0439 \u0441\u043F\u0438\u0441\u043E\u043A"
};


var $d0d890ceb3ea8092$export$2e2bcd8739ae039 = (0, $f44dd606d8f7c8f1$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $fd9dfbf5aab9861b$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Rensa urval',
    'paginated-picker.async-select.menu-list.error-message.error-message': "Det gick inte att h\xe4mta data",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Klicka f\xf6r att f\xf6rs\xf6ka igen",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "L\xe4ser in ...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Visa mer',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} av {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Inga tr\xe4ffar hittades",
    'paginated-picker.async-select.select.option.error-message': "Det gick inte att h\xe4mta data",
    'paginated-picker.async-select.select.option.retry-message': "Klicka f\xf6r att f\xf6rs\xf6ka igen",
    'paginated-picker.async-select.select.search-placeholder': "S\xf6k",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Visa fullst\xe4ndig lista"
};


var $1b3ca00268273473$export$2e2bcd8739ae039 = (0, $fd9dfbf5aab9861b$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Thai (Thailand)
var $f540d690ae612fab$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u0E25\u0E49\u0E32\u0E07\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E23\u0E35\u0E22\u0E01\u0E14\u0E39\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E14\u0E49",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u0E04\u0E25\u0E34\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u0E41\u0E2A\u0E14\u0E07\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    'paginated-picker.async-select.pagination-details.of-total-count': "{itemsCount} \u0E08\u0E32\u0E01 {totalCount}",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19",
    'paginated-picker.async-select.select.option.error-message': "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E23\u0E35\u0E22\u0E01\u0E14\u0E39\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E14\u0E49",
    'paginated-picker.async-select.select.option.retry-message': "\u0E04\u0E25\u0E34\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    'paginated-picker.async-select.select.search-placeholder': "\u0E04\u0E49\u0E19\u0E2B\u0E32",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u0E41\u0E2A\u0E14\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14"
};


var $8bbaf056b1e25eda$export$2e2bcd8739ae039 = (0, $f540d690ae612fab$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Turkish (Turkey)
var $78593addc10c97f1$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Se\xe7imi temizle",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Veriler al\u0131namad\u0131",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Yeniden denemek i\xe7in t\u0131klay\u0131n",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Y\xfckleniyor...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Daha fazla g\xf6ster",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "E\u015Fle\u015Fme bulunamad\u0131",
    'paginated-picker.async-select.select.option.error-message': "Veriler al\u0131namad\u0131",
    'paginated-picker.async-select.select.option.retry-message': "Yeniden denemek i\xe7in t\u0131klay\u0131n",
    'paginated-picker.async-select.select.search-placeholder': 'Ara',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Tam listeyi g\xf6ster"
};


var $7265057bd4c7a044$export$2e2bcd8739ae039 = (0, $78593addc10c97f1$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Ukrainian (Ukraine)
var $e512b385403e4bbf$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0432\u0438\u0431\u0456\u0440",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u0434\u0430\u043D\u0456",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435",
    'paginated-picker.async-select.pagination-details.of-total-count': "{itemsCount} \u0437 {totalCount}",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u041D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    'paginated-picker.async-select.select.option.error-message': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u0434\u0430\u043D\u0456",
    'paginated-picker.async-select.select.option.retry-message': "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
    'paginated-picker.async-select.select.search-placeholder': "\u041F\u043E\u0448\u0443\u043A",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043F\u043E\u0432\u043D\u0438\u0439 \u0441\u043F\u0438\u0441\u043E\u043A"
};


var $f903a258a8a78480$export$2e2bcd8739ae039 = (0, $e512b385403e4bbf$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Vietnamese (Vietnam)
var $5f911a695ffa4182$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "X\xf3a m\u1EE5c \u0111\xe3 ch\u1ECDn",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Kh\xf4ng th\u1EC3 truy xu\u1EA5t d\u1EEF li\u1EC7u",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Nh\u1EA5p v\xe0o \u0111\u1EC3 th\u1EED l\u1EA1i",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0110ang t\u1EA3i...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Hi\u1EC3n th\u1ECB th\xeam",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Kh\xf4ng t\xecm th\u1EA5y k\u1EBFt qu\u1EA3 ph\xf9 h\u1EE3p n\xe0o",
    'paginated-picker.async-select.select.option.error-message': "Kh\xf4ng th\u1EC3 truy xu\u1EA5t d\u1EEF li\u1EC7u",
    'paginated-picker.async-select.select.option.retry-message': "Nh\u1EA5p v\xe0o \u0111\u1EC3 th\u1EED l\u1EA1i",
    'paginated-picker.async-select.select.search-placeholder': "T\xecm ki\u1EBFm",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Hi\u1EC3n th\u1ECB danh s\xe1ch \u0111\u1EA7y \u0111\u1EE7"
};


var $7472d3a06ae78ab6$export$2e2bcd8739ae039 = (0, $5f911a695ffa4182$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Simplified)
var $627df7a03880c013$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u6E05\u7A7A\u9009\u62E9",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u65E0\u6CD5\u68C0\u7D22\u6570\u636E",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u70B9\u51FB\u91CD\u8BD5",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u6B63\u5728\u52A0\u8F7D...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u663E\u793A\u66F4\u591A",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u672A\u627E\u5230\u5339\u914D\u9879",
    'paginated-picker.async-select.select.option.error-message': "\u65E0\u6CD5\u68C0\u7D22\u6570\u636E",
    'paginated-picker.async-select.select.option.retry-message': "\u70B9\u51FB\u91CD\u8BD5",
    'paginated-picker.async-select.select.search-placeholder': "\u641C\u7D22",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u663E\u793A\u5B8C\u6574\u5217\u8868"
};


var $ecd91fe6effa99af$export$2e2bcd8739ae039 = (0, $627df7a03880c013$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $349cff05777e10b4$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u6E05\u9664\u9078\u53D6\u5167\u5BB9",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u7121\u6CD5\u64F7\u53D6\u8CC7\u6599",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u6309\u4E00\u4E0B\u4EE5\u91CD\u8A66",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u6B63\u5728\u8F09\u5165...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u986F\u793A\u8F03\u591A",
    'paginated-picker.async-select.pagination-details.of-total-count': "\u7B2C {itemsCount} \u500B\uFF0C\u5171 {totalCount} \u500B",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u627E\u4E0D\u5230\u76F8\u7B26\u9805\u76EE",
    'paginated-picker.async-select.select.option.error-message': "\u7121\u6CD5\u64F7\u53D6\u8CC7\u6599",
    'paginated-picker.async-select.select.option.retry-message': "\u6309\u4E00\u4E0B\u4EE5\u91CD\u8A66",
    'paginated-picker.async-select.select.search-placeholder': "\u641C\u5C0B",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u986F\u793A\u5B8C\u6574\u6E05\u55AE"
};


var $3bf13300a6f5d87e$export$2e2bcd8739ae039 = (0, $349cff05777e10b4$export$2e2bcd8739ae039);




var $933b8fb1ecc9c28f$var$i18n = $698f956ac24d6ccf$exports;
var $933b8fb1ecc9c28f$var$getCodesFromLocale = function getCodesFromLocale(locale) {
    var match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale || '');
    if (!match) throw Error('Unable to get language and country from invalid Locale');
    var _match = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(match, 3), language = _match[1], country = _match[2];
    return {
        language: language.toLowerCase(),
        country: country.toUpperCase()
    };
};
var $933b8fb1ecc9c28f$export$b61655080b0a1f32 = function PaginatedPickerIntlProvider(_ref) {
    var children = _ref.children;
    var intl = (0, $hrVKU.default)();
    var _getCodesFromLocale = $933b8fb1ecc9c28f$var$getCodesFromLocale(intl.locale.toString()), language = _getCodesFromLocale.language, country = _getCodesFromLocale.country;
    var messages = $933b8fb1ecc9c28f$var$i18n["".concat(language, "_").concat(country)] || $933b8fb1ecc9c28f$var$i18n[language] || $933b8fb1ecc9c28f$var$i18n.en;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9Pk7k.default), {
        messages: messages,
        locale: intl.locale
    }, children);
};



var $iYJcE = parcelRequire("iYJcE");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");
var $1099937d2cc3db76$exports = {};
var $a2610537d9d155d0$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a2610537d9d155d0$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$a2610537d9d155d0$exports = $a2610537d9d155d0$var$baseFindIndex;



var $rM88w = parcelRequire("rM88w");

var $ll6bk = parcelRequire("ll6bk");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1099937d2cc3db76$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $1099937d2cc3db76$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $ll6bk(fromIndex);
    if (index < 0) index = $1099937d2cc3db76$var$nativeMax(length + index, 0);
    return $a2610537d9d155d0$exports(array, $rM88w(predicate, 3), index);
}
$1099937d2cc3db76$exports = $1099937d2cc3db76$var$findIndex;


var $3a70dcab3a7aadc2$exports = {};
var $dd16f1123f2f3099$exports = {};

var $rM88w = parcelRequire("rM88w");

var $8Ak9r = parcelRequire("8Ak9r");

var $8XuRV = parcelRequire("8XuRV");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $dd16f1123f2f3099$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$8Ak9r(collection)) {
            var iteratee = $rM88w(predicate, 3);
            collection = $8XuRV(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$dd16f1123f2f3099$exports = $dd16f1123f2f3099$var$createFind;


var $6544f0c1d2ee6d4e$exports = {};


var $rM88w = parcelRequire("rM88w");

var $ll6bk = parcelRequire("ll6bk");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6544f0c1d2ee6d4e$var$nativeMax = Math.max, $6544f0c1d2ee6d4e$var$nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function $6544f0c1d2ee6d4e$var$findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = $ll6bk(fromIndex);
        index = fromIndex < 0 ? $6544f0c1d2ee6d4e$var$nativeMax(length + index, 0) : $6544f0c1d2ee6d4e$var$nativeMin(index, length - 1);
    }
    return $a2610537d9d155d0$exports(array, $rM88w(predicate, 3), index, true);
}
$6544f0c1d2ee6d4e$exports = $6544f0c1d2ee6d4e$var$findLastIndex;


/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */ var $3a70dcab3a7aadc2$var$findLast = $dd16f1123f2f3099$exports($6544f0c1d2ee6d4e$exports);
$3a70dcab3a7aadc2$exports = $3a70dcab3a7aadc2$var$findLast;



var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
var $4df0abb36bdee3db$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $4df0abb36bdee3db$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4df0abb36bdee3db$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4df0abb36bdee3db$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4df0abb36bdee3db$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4df0abb36bdee3db$var$handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $4df0abb36bdee3db$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions, propsOptions = _ref.options, _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $4df0abb36bdee3db$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $5FkrB.useRef)(undefined);
    var mounted = (0, $5FkrB.useRef)(false);
    var _useState = (0, $5FkrB.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : ''), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(propsDefaultOptions === true), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $5FkrB.useState)(undefined), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $5FkrB.useState)([]), _useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState9, 2), loadedOptions = _useState0[0], setLoadedOptions = _useState0[1];
    var _useState1 = (0, $5FkrB.useState)(false), _useState10 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState1, 2), passEmptyOptions = _useState10[0], setPassEmptyOptions = _useState10[1];
    var _useState11 = (0, $5FkrB.useState)({}), _useState12 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState11, 2), optionsCache = _useState12[0], setOptionsCache = _useState12[1];
    var _useState13 = (0, $5FkrB.useState)(undefined), _useState14 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState13, 2), prevDefaultOptions = _useState14[0], setPrevDefaultOptions = _useState14[1];
    var _useState15 = (0, $5FkrB.useState)(undefined), _useState16 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState15, 2), prevCacheOptions = _useState16[0], setPrevCacheOptions = _useState16[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $5FkrB.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $5FkrB.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $5FkrB.useCallback)(function(newValue, actionMeta) {
        var inputValue = $4df0abb36bdee3db$var$handleInputChange(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? $4df0abb36bdee3db$var$_objectSpread($4df0abb36bdee3db$var$_objectSpread({}, optionsCache), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return $4df0abb36bdee3db$var$_objectSpread($4df0abb36bdee3db$var$_objectSpread({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}



var $5FkrB = parcelRequire("5FkrB");

var $bgNpv = parcelRequire("bgNpv");

var $jgNUw = parcelRequire("jgNUw");

var $6bnW7 = parcelRequire("6bnW7");
var $53a377dee1f046a4$var$message = (0, $6bnW7.defineMessages)({
    clearAllSelectedItemsButtonText: {
        id: 'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text',
        defaultMessage: 'Clear selection',
        description: 'Clicking this button will unselect all the selected items in the dropdown'
    }
});
var $53a377dee1f046a4$export$2e2bcd8739ae039 = $53a377dee1f046a4$var$message;


var $8a7a5bf0e77e5ab1$export$1d4b7cda9e589b53 = function ClearSelectedItemsButton(_ref) {
    var onClear = _ref.onClear;
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    var onClearSelectedItems = (0, $5FkrB.useCallback)(function() {
        // sendAnalytics({
        //   actionSubjectId: 'filterSearchClearSelectedItems',
        //   createAnalyticsEvent,
        //   type,
        // });
        onClear && onClear();
    }, [
        onClear
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jgNUw.default), {
        onClick: onClearSelectedItems,
        appearance: "subtle-link",
        testId: "paginated-picker.ui.async-select.clear-selection-button.clear-selected-items"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, $53a377dee1f046a4$export$2e2bcd8739ae039).clearAllSelectedItemsButtonText));
};
var $8a7a5bf0e77e5ab1$export$2e2bcd8739ae039 = $8a7a5bf0e77e5ab1$export$1d4b7cda9e589b53;



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $25nEq = parcelRequire("25nEq");
/* indicators-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");
var $76e70396aae85af8$export$26417cabd806a658 = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};


var $d9f4b3d2798ea813$var$indicatorContainerStyles = null;
var $d9f4b3d2798ea813$export$d0ffd7e649cab6f = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $76e70396aae85af8$export$26417cabd806a658)(props, 'indicatorsContainer', {
        indicators: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $hUFig.cx)(className, xcss, '-IndicatorsContainer')
        ])
    }, innerProps), children);
};


/* multi-value-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");
var $c2f1633ad2772e6a$var$multiValueStyles = {
    root: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _1e0c1txw _1ul9ze3t _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _bfhk1j9a _p12f1osq _syazi7uo _3yq3glyw",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk15s3 _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
var $c2f1633ad2772e6a$export$cf9cf2a30a59265c = function MultiValueContainer(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isFocused = _ref.isFocused, isDisabled = _ref.isDisabled, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $c2f1633ad2772e6a$var$multiValueStyles.root,
            isDisabled && $c2f1633ad2772e6a$var$multiValueStyles.disabled,
            isFocused && $c2f1633ad2772e6a$var$multiValueStyles.focused,
            (0, $hUFig.cx)(className, xcss, '-multiValue')
        ])
    }), children);
};


/* select-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $70e707911e054d35$var$containerStyles = {
    default: "_11c81d4k _kqswh2mm _lcxv1rj4 _1tn2fhey",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf"
};
var $70e707911e054d35$export$446eebadefe1123b = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl, xcss = props.xcss;
    var _getStyleProps = (0, $76e70396aae85af8$export$26417cabd806a658)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), className = _getStyleProps.className, css = _getStyleProps.css;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $70e707911e054d35$var$containerStyles.default,
            isRtl && $70e707911e054d35$var$containerStyles.rtl,
            isDisabled && $70e707911e054d35$var$containerStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-container')
        ]),
        style: css
    }, innerProps), children);
};


/* value-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $ISKn7 = parcelRequire("ISKn7");
var $5b58ec20922b577b$var$_process, $5b58ec20922b577b$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $5b58ec20922b577b$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($5b58ec20922b577b$var$_process = globalThis.process) === null || $5b58ec20922b577b$var$_process === void 0 || ($5b58ec20922b577b$var$_process = $5b58ec20922b577b$var$_process.env) === null || $5b58ec20922b577b$var$_process === void 0 ? void 0 : $5b58ec20922b577b$var$_process.JEST_WORKER_ID) !== undefined;
var $5b58ec20922b577b$var$DEBUG_MODE = !$5b58ec20922b577b$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($5b58ec20922b577b$var$_process2 = globalThis.process) === null || $5b58ec20922b577b$var$_process2 === void 0 || ($5b58ec20922b577b$var$_process2 = $5b58ec20922b577b$var$_process2.env) === null || $5b58ec20922b577b$var$_process2 === void 0 ? void 0 : $5b58ec20922b577b$var$_process2.NODE_ENV) !== 'production';
var $5b58ec20922b577b$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$5b58ec20922b577b$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $bc54239cf2af7c12$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $bc54239cf2af7c12$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
var $bc54239cf2af7c12$export$75f4a1454eff2805 = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';


var $500a2a8524aadc2d$export$b574c24e1e6490f5 = (0, $bc54239cf2af7c12$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $f8ef429894a4e90c$export$92f8b531feaeb23d = (0, $bc54239cf2af7c12$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $d54b57b729f6e1df$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $d54b57b729f6e1df$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$d54b57b729f6e1df$export$54ea85357b4e0159[0, $bc54239cf2af7c12$export$7e41b1b2bdee3f98] = $d54b57b729f6e1df$export$54ea85357b4e0159[0, $bc54239cf2af7c12$export$7e41b1b2bdee3f98] || $d54b57b729f6e1df$var$DEFAULT_PFF_GLOBAL;



var $9aaf6124a337faf7$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $500a2a8524aadc2d$export$b574c24e1e6490f5) || (0, $f8ef429894a4e90c$export$92f8b531feaeb23d);
function $9aaf6124a337faf7$export$6333b6aff9fc6275(flagKey) {
    if ($9aaf6124a337faf7$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $5b58ec20922b577b$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $bc54239cf2af7c12$export$407f05df8e3ce9f3), flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = (0, $d54b57b729f6e1df$export$54ea85357b4e0159)[0, $bc54239cf2af7c12$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = (0, $d54b57b729f6e1df$export$54ea85357b4e0159)[0, $bc54239cf2af7c12$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $ISKn7.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = (0, $d54b57b729f6e1df$export$54ea85357b4e0159)[0, $bc54239cf2af7c12$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $d1213b7f4495d0bd$export$b40ec24ac8275656(name) {
    return (0, $9aaf6124a337faf7$export$6333b6aff9fc6275)(name);
}



var $5cf75f7b33fdc344$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _y4ti12x7 _bozg12x7",
    verticalPaddingStandard: "_1q51v77o _85i5v77o",
    verticalPaddingTagUpliftMulti: "_1q511b66 _85i51b66",
    verticalPaddingTagUpliftCompactMulti: "_1q51v77o _85i5v77o",
    verticalPaddingCompactNonUplift: "_1q51ze3t _85i5ze3t",
    flex: "_1e0c1txw",
    flexWithGap: "_zulp1b66 _1e0c1txw _1n261g80"
};
var $5cf75f7b33fdc344$export$4dc9f58ad9a1a000 = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue, isCompact = props.isCompact, xcss = props.xcss, controlShouldRenderValue = props.selectProps.controlShouldRenderValue;
    var _getStyleProps = (0, $76e70396aae85af8$export$26417cabd806a658)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    var ffTagUplifts = (0, $d1213b7f4495d0bd$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts');
    var tagUpliftMultiVertical = ffTagUplifts && isMulti;
    var tagUpliftChipRow = ffTagUplifts && isMulti && hasValue && controlShouldRenderValue;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $5cf75f7b33fdc344$var$valueContainerStyles.default,
            tagUpliftMultiVertical && isCompact && $5cf75f7b33fdc344$var$valueContainerStyles.verticalPaddingTagUpliftCompactMulti,
            tagUpliftMultiVertical && !isCompact && $5cf75f7b33fdc344$var$valueContainerStyles.verticalPaddingTagUpliftMulti,
            !tagUpliftMultiVertical && !isCompact && $5cf75f7b33fdc344$var$valueContainerStyles.verticalPaddingStandard,
            !tagUpliftMultiVertical && isCompact && $5cf75f7b33fdc344$var$valueContainerStyles.verticalPaddingCompactNonUplift,
            isMulti && hasValue && controlShouldRenderValue && $5cf75f7b33fdc344$var$valueContainerStyles.flex,
            tagUpliftChipRow && $5cf75f7b33fdc344$var$valueContainerStyles.flexWithGap,
            (0, $hUFig.cx)(className, xcss, '-ValueContainer')
        ]),
        style: css
    }, innerProps), children);
};


/* control.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");


var $6a1e65b66738d982$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkofajl _v564r5cv _1h6drsbi _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _15peftgi _1ke8ftgi _jaboglyw _1u6luvb6 _4cvxrsbi _123byq51 _d0altlke _irr3l4ek _1ogl1caj",
    defaultT26Shape: "_2rko1qi0",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsvyy1",
    disabled: "_1h6d187o _lcxvglyw _bfhk187o _1u6lfrlt",
    focused: "_1h6d1v1w _bfhkr01l _16qsvyy1 _1u6lvyy1 _4cvx1v1w _irr3r01l",
    subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
var $6a1e65b66738d982$var$Control = function Control(props) {
    var children = props.children, appearance = props.appearance, isCompact = props.isCompact, isDisabled = props.isDisabled, isFocused = props.isFocused, isInvalid = props.isInvalid, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen, xcss = props.xcss;
    var _getStyleProps = (0, $76e70396aae85af8$export$26417cabd806a658)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: innerRef,
        className: (0, $970q7.default)([
            $6a1e65b66738d982$var$styles.default,
            (0, $d1213b7f4495d0bd$export$b40ec24ac8275656)('platform-dst-shape-theme-default') && $6a1e65b66738d982$var$styles.defaultT26Shape,
            isDisabled && $6a1e65b66738d982$var$styles.disabled,
            isInvalid && $6a1e65b66738d982$var$styles.invalid,
            isCompact && $6a1e65b66738d982$var$styles.compact,
            appearance === 'subtle' && $6a1e65b66738d982$var$styles.subtle,
            appearance === 'subtle' && isFocused && $6a1e65b66738d982$var$styles.subtleFocused,
            isFocused && $6a1e65b66738d982$var$styles.focused,
            appearance === 'none' && $6a1e65b66738d982$var$styles.none,
            (0, $hUFig.cx)(className, xcss, '-control')
        ]),
        style: css
    }, innerProps, {
        "aria-disabled": (0, $d1213b7f4495d0bd$export$b40ec24ac8275656)('platform_dst_select_disabled_a11y_fix') ? undefined : isDisabled || undefined
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6a1e65b66738d982$export$2e2bcd8739ae039 = $6a1e65b66738d982$var$Control;


/* group.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $e63a062a88191cfa$var$styles = {
    root: "_85i5u2gc _1q51u2gc"
};
var $e63a062a88191cfa$var$Group = function Group(props) {
    var children = props.children, builtinCX = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, selectProps = props.selectProps, xcss = props.xcss;
    var _getStyleProps = (0, $76e70396aae85af8$export$26417cabd806a658)(props, 'group', {
        group: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $e63a062a88191cfa$var$styles.root,
            (0, $hUFig.cx)(className, xcss, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className, '-Group')
        ])
    }), label && /*#__PURE__*/ $5FkrB.createElement(Heading, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, headingProps, {
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: builtinCX
    }), label), /*#__PURE__*/ $5FkrB.createElement("div", null, children));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e63a062a88191cfa$export$2e2bcd8739ae039 = $e63a062a88191cfa$var$Group;


/* group-heading.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");


var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");
var $6401628435a6105e$var$_excluded = [
    "className",
    "clearValue",
    "cx",
    "xcss",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue"
];
function $6401628435a6105e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6401628435a6105e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6401628435a6105e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6401628435a6105e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6401628435a6105e$export$8e9fd4287627890c = function cleanCommonProps(props) {
    //className
    var className = props.className, clearValue = props.clearValue, cx = props.cx, xcss = props.xcss, getStyles = props.getStyles, getClassNames = props.getClassNames, getValue = props.getValue, hasValue = props.hasValue, isMulti = props.isMulti, isRtl = props.isRtl, options = props.options, selectOption = props.selectOption, selectProps = props.selectProps, setValue = props.setValue, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $6401628435a6105e$var$_excluded);
    return $6401628435a6105e$var$_objectSpread({}, innerProps);
};


var $ee0143fff79640b8$var$_excluded = [
    "data"
];
var $ee0143fff79640b8$var$headingStyles = null;
var $ee0143fff79640b8$export$85c8b41a3cd87edc = function GroupHeading(props) {
    var xcss = props.xcss;
    var _cleanCommonProps = (0, $6401628435a6105e$export$8e9fd4287627890c)(props), data = _cleanCommonProps.data, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_cleanCommonProps, $ee0143fff79640b8$var$_excluded);
    var _getStyleProps = (0, $76e70396aae85af8$export$26417cabd806a658)(props, 'groupHeading', {
        'group-heading': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_11c8wadc _1e0c1ule _syazazsu _80om73ad _k48pwu06 _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $hUFig.cx)(className, xcss, '-group')
        ]),
        style: css
    }, innerProps));
};


/* clear-indicator.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $eNN4d = parcelRequire("eNN4d");

var $btdNC = parcelRequire("btdNC");

var $b828ad2fed7d06e1$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _1q51v77o _y4tiv77o _85i5v77o _bozgv77o"
};
var $b828ad2fed7d06e1$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1rpy _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf"
};
var $b828ad2fed7d06e1$export$ecf9cf59142dd54a = function ClearIndicator(props) {
    var innerProps = props.innerProps, _props$clearControlLa = props.clearControlLabel, clearControlLabel = _props$clearControlLa === void 0 ? 'clear' : _props$clearControlLa, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $76e70396aae85af8$export$26417cabd806a658)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $b828ad2fed7d06e1$var$clearIndicatorStyles.default,
            isCompact && $b828ad2fed7d06e1$var$clearIndicatorStyles.compact,
            (0, $hUFig.cx)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $btdNC.Pressable), {
        xcss: $b828ad2fed7d06e1$var$iconContainerStyles.root,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eNN4d))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
};


/* dropdown-indicator.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $h19KG = parcelRequire("h19KG");


var $m5IEn = parcelRequire("m5IEn");
var $btdNC = parcelRequire("btdNC");

var $a31f4390726d228d$var$_excluded = [
    "aria-hidden"
];
var $a31f4390726d228d$var$dropdownWrapperStyles = {
    root: "_1q5112x7 _y4ti12x7 _85i512x7 _bozg12x7"
};
// Reset styles for the voice-control <Pressable> so the chevron renders
// pixel-identical to the gate-off icon-in-a-div. Uses @atlaskit/css cssMap
// (aliased as strictCssMap) because Pressable's xcss prop requires that type.
var $a31f4390726d228d$var$voiceControlPressableStyles = {
    root: "_1rjcidpf _18zridpf _1mouidpf _195gidpf _bfhk1j28 _1e0c1txw _4cvr1h6o"
};
// Inline size reset applied as a last resort (see the `style` prop docs on
// @atlaskit/primitives). Consumers ship global element selectors such as
// `& button { min-width: 149px }` (e.g. Jira Plans' hierarchy filter — see
// https://hello.jira.atlassian.cloud/jira/browse/JPO-42328) whose (class +
// element) specificity outranks the atomic single-class styles above, stretching
// this button and pushing the chevron toward the middle of the control. Inline
// styles outrank any selector, so the button always hugs the chevron and stays
// right-aligned like the gate-off icon-in-a-div.
var $a31f4390726d228d$var$voiceControlPressableSizeReset = {
    minWidth: 0,
    width: 'auto'
};
var $a31f4390726d228d$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syazazsu _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf",
    disabled: "_syaz1gmx"
};
var $a31f4390726d228d$export$ec98719d3db7f2e4 = function DropdownIndicator(props) {
    var _props$innerProps = props.innerProps, innerProps = _props$innerProps === void 0 ? {} : _props$innerProps, children = props.children, isDisabled = props.isDisabled, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $76e70396aae85af8$export$26417cabd806a658)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    var ariaHidden = innerProps['aria-hidden'], restInnerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(innerProps, $a31f4390726d228d$var$_excluded);
    var isVoiceControlAccessible = (0, $d1213b7f4495d0bd$export$b40ec24ac8275656)('platform_dst_select_dropdown_voice_control');
    // Stable testid for the hoisted aria-hidden children wrapper (avoids parentElement in tests).
    var wrapperTestId = restInnerProps['data-testid'] ? "".concat(restInnerProps['data-testid'], "-children") : undefined;
    var voiceControlAccessibleIndicator = children ? /*#__PURE__*/ $5FkrB.createElement("div", {
        "aria-hidden": ariaHidden,
        "data-testid": wrapperTestId
    }, children) : /*#__PURE__*/ $5FkrB.createElement((0, $btdNC.Pressable), {
        tabIndex: -1,
        "aria-label": "toggle select menu",
        isDisabled: isDisabled,
        componentName: "DropdownIndicatorVoiceControl",
        xcss: $a31f4390726d228d$var$voiceControlPressableStyles.root,
        style: $a31f4390726d228d$var$voiceControlPressableSizeReset
    }, /*#__PURE__*/ $5FkrB.createElement((0, $m5IEn.Inline), {
        as: "span",
        xcss: $a31f4390726d228d$var$dropdownWrapperStyles.root
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($h19KG))), {
        color: "currentColor",
        label: "open",
        size: "small"
    })));
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $a31f4390726d228d$var$dropdownStyles.default,
            isDisabled && $a31f4390726d228d$var$dropdownStyles.disabled,
            isCompact && $a31f4390726d228d$var$dropdownStyles.compact,
            (0, $hUFig.cx)(className, xcss, '-indicatorContainer')
        ])
    }, restInnerProps, {
        "aria-hidden": isVoiceControlAccessible ? undefined : ariaHidden
    }), isVoiceControlAccessible ? voiceControlAccessibleIndicator : children !== null && children !== void 0 ? children : /*#__PURE__*/ $5FkrB.createElement((0, $m5IEn.Inline), {
        as: "span",
        xcss: $a31f4390726d228d$var$dropdownWrapperStyles.root
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($h19KG))), {
        color: "currentColor",
        label: "open",
        size: "small"
    })));
};


/* loading-indicator.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $9ztDu = parcelRequire("9ztDu");

var $25c4d3096610d4ff$var$_excluded = [
    "innerProps",
    "isRtl",
    "size",
    "isCompact",
    "xcss"
];
function $25c4d3096610d4ff$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $25c4d3096610d4ff$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $25c4d3096610d4ff$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $25c4d3096610d4ff$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $25c4d3096610d4ff$var$loadingIndicatorStyles = {
    default: "_1q5112x7 _y4tiu2gc _85i512x7 _bozgu2gc",
    compact: "_1q51idpf _85i5idpf"
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $25c4d3096610d4ff$export$7c20be4c1d342248 = function LoadingIndicator(_ref) {
    var innerProps = _ref.innerProps, isRtl = _ref.isRtl, _ref$size = _ref.size, size = _ref$size === void 0 ? 4 : _ref$size, isCompact = _ref.isCompact, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $25c4d3096610d4ff$var$_excluded);
    var _getStyleProps = (0, $76e70396aae85af8$export$26417cabd806a658)($25c4d3096610d4ff$var$_objectSpread($25c4d3096610d4ff$var$_objectSpread({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $25c4d3096610d4ff$var$loadingIndicatorStyles.default,
            isCompact && $25c4d3096610d4ff$var$loadingIndicatorStyles.compact,
            (0, $hUFig.cx)(className, xcss, '-loadingIndicator')
        ])
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $9ztDu.default), {
        size: "small"
    }));
};


/* input.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");



var $993713342c66b49b$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName",
    "testId"
];
var $993713342c66b49b$var$inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
var $993713342c66b49b$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
var $993713342c66b49b$var$nativeInputStylesOld = null;
var $993713342c66b49b$var$nativeInputStyles = null;
var $993713342c66b49b$var$hidden = null;
var $993713342c66b49b$var$Input = function Input(props) {
    var builtinCX = props.cx, value = props.value, xcss = props.xcss, isMulti = props.isMulti;
    var _cleanCommonProps = (0, $6401628435a6105e$export$8e9fd4287627890c)(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, testId = _cleanCommonProps.testId, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_cleanCommonProps, $993713342c66b49b$var$_excluded);
    var dataId = testId ? "".concat(testId, "-select--input") : null;
    var _getStyleProps = (0, $76e70396aae85af8$export$26417cabd806a658)(props, 'input', {
        'input-container': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    var ffTagUplifts = (0, $d1213b7f4495d0bd$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts');
    if ((0, $d1213b7f4495d0bd$export$b40ec24ac8275656)('platform_fix_input_component_styling')) return /*#__PURE__*/ $5FkrB.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $993713342c66b49b$var$inputStyles.root,
            isMulti && ffTagUplifts && $993713342c66b49b$var$inputStyles.labellingFFStyles,
            isDisabled && $993713342c66b49b$var$inputStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $993713342c66b49b$var$inputStylesOld.root,
            isMulti && ffTagUplifts && $993713342c66b49b$var$inputStylesOld.labellingFFStyles,
            isDisabled && $993713342c66b49b$var$inputStylesOld.disabled,
            (0, $hUFig.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$993713342c66b49b$export$2e2bcd8739ae039 = $993713342c66b49b$var$Input;


/* menu.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");


var $37bbdf43dab8a9d9$var$menuStyles = {
    root: "_2rko12b0 _kqswstnw _1bsb1osq _1pbykb7n _6rthu2gc _1pfhu2gc _bfhk1bhr _16qs130s",
    rootT26Shape: "_2rko1mok",
    bottom: "_152t1osq",
    top: "_u7co1osq"
};
var $37bbdf43dab8a9d9$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottom' : _props$placement, xcss = props.xcss;
    var _getStyleProps = (0, $76e70396aae85af8$export$26417cabd806a658)(props, 'menu', {
        menu: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $37bbdf43dab8a9d9$var$menuStyles.root,
            $37bbdf43dab8a9d9$var$menuStyles[placement],
            (0, $d1213b7f4495d0bd$export$b40ec24ac8275656)('platform-dst-shape-theme-default') && $37bbdf43dab8a9d9$var$menuStyles.rootT26Shape,
            (0, $hUFig.cx)(xcss, className, '-menu')
        ]),
        style: css,
        ref: innerRef
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$37bbdf43dab8a9d9$export$2e2bcd8739ae039 = $37bbdf43dab8a9d9$var$Menu;


/* menu-list.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

function $80a264b54c270603$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $80a264b54c270603$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $80a264b54c270603$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $80a264b54c270603$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $80a264b54c270603$var$menuListStyles = null;
var $80a264b54c270603$export$d4c4e98c5044dc8 = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti, maxHeight = props.maxHeight, xcss = props.xcss;
    var _getStyleProps = (0, $76e70396aae85af8$export$26417cabd806a658)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $hUFig.cx)(className, xcss, '-MenuList')
        ]),
        style: $80a264b54c270603$var$_objectSpread($80a264b54c270603$var$_objectSpread({}, css), {}, {
            maxHeight: maxHeight
        }),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};


/* menu-loading-message.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $72GAO = parcelRequire("72GAO");

var $7f1ff1462b42a93e$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
];
function $7f1ff1462b42a93e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7f1ff1462b42a93e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7f1ff1462b42a93e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7f1ff1462b42a93e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7f1ff1462b42a93e$var$noticeStyles = null;
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $7f1ff1462b42a93e$export$e928a71d039d3102 = function LoadingMessage(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? 'Loading...' : _ref$children, innerProps = _ref.innerProps, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $7f1ff1462b42a93e$var$_excluded);
    var _getStyleProps = (0, $76e70396aae85af8$export$26417cabd806a658)($7f1ff1462b42a93e$var$_objectSpread($7f1ff1462b42a93e$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $hUFig.cx)(className, xcss, '-LoadingMessage')
        ]),
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option"
    }), /*#__PURE__*/ $5FkrB.createElement((0, $72GAO.Text), {
        color: "color.text.subtle"
    }, children));
};


/* menu-no-options-message.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $72GAO = parcelRequire("72GAO");

var $0e378aef7f2103e6$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
];
function $0e378aef7f2103e6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0e378aef7f2103e6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0e378aef7f2103e6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0e378aef7f2103e6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0e378aef7f2103e6$var$noticeStyles = null;
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $0e378aef7f2103e6$export$d58b72b7d3c4072c = function NoOptionsMessage(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? 'No options' : _ref$children, innerProps = _ref.innerProps, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $0e378aef7f2103e6$var$_excluded);
    var _getStyleProps = (0, $76e70396aae85af8$export$26417cabd806a658)($0e378aef7f2103e6$var$_objectSpread($0e378aef7f2103e6$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $hUFig.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        style: css,
        role: "option"
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $72GAO.Text), {
        color: "color.text.subtle"
    }, children));
};


/* menu-portal.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $6I9SI = parcelRequire("6I9SI");

var $aLeHs = parcelRequire("aLeHs");



var $5FkrB = parcelRequire("5FkrB");
var $180da3fc31e4fc57$export$e001f626511a0ead = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


/* menu-portal-top-layer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $acb691cf3ae40c68$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $86c3974d161dec97$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $3bad323626904995$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $86c3974d161dec97$export$644a49f3b8c50fcd));
    return namespace;
}


function $24f12266f22221a5$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $acb691cf3ae40c68$export$5fbf4d7fae6cdc00));
    var namespace = (0, $3bad323626904995$export$1d57e79091cc3046)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}


/* popover.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $hUFig = parcelRequire("hUFig");

var $7QpUe = parcelRequire("7QpUe");

var $iO8GM = parcelRequire("iO8GM");

var $bvsoE = parcelRequire("bvsoE");

/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $b89672f49531a922$export$63b6b0ff65d84d47(_ref) {
    var value = _ref.value;
    if (typeof value === 'number') return "".concat(value, "px");
    return value;
}


/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ var $4489dfc85c3e3260$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $4489dfc85c3e3260$export$63044d21bc3d3fa2(_ref) {
    var _placement$offset, _placement$axis, _placement$edge, _placement$align, _placement$offset$cro, _placement$offset2, _placement$offset$cro2, _placement$offset3;
    var placement = _ref.placement;
    var consumerGap = (_placement$offset = placement.offset) === null || _placement$offset === void 0 ? void 0 : _placement$offset.gap;
    return {
        axis: (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block',
        edge: (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end',
        align: (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center',
        offset: {
            gap: consumerGap === undefined ? $4489dfc85c3e3260$var$DEFAULT_GAP : (0, $b89672f49531a922$export$63b6b0ff65d84d47)({
                value: consumerGap
            }),
            crossAxisShift: {
                value: (0, $b89672f49531a922$export$63b6b0ff65d84d47)({
                    value: (_placement$offset$cro = (_placement$offset2 = placement.offset) === null || _placement$offset2 === void 0 || (_placement$offset2 = _placement$offset2.crossAxisShift) === null || _placement$offset2 === void 0 ? void 0 : _placement$offset2.value) !== null && _placement$offset$cro !== void 0 ? _placement$offset$cro : 0
                }),
                direction: (_placement$offset$cro2 = (_placement$offset3 = placement.offset) === null || _placement$offset3 === void 0 || (_placement$offset3 = _placement$offset3.crossAxisShift) === null || _placement$offset3 === void 0 ? void 0 : _placement$offset3.direction) !== null && _placement$offset$cro2 !== void 0 ? _placement$offset$cro2 : 'forwards'
            }
        }
    };
}


var $7583abeb227bd8e5$var$rolesThatMoveFocus = new Set([
    'dialog',
    'alertdialog',
    'menu',
    'listbox',
    'tree',
    'grid'
]);
function $7583abeb227bd8e5$export$b12adccf56228c71(_ref) {
    var role = _ref.role;
    if (!role) return false;
    return $7583abeb227bd8e5$var$rolesThatMoveFocus.has(role);
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $bvsoE = parcelRequire("bvsoE");
var $63dfad70d9b5d375$export$ff7706047246b98b = (0, $bvsoE.default)(function() {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});


function $32fb2a53e29345b3$var$runCancellableSettlement(_ref) {
    var schedule = _ref.schedule, onSettled = _ref.onSettled;
    var isCancelled = false;
    schedule(function() {
        if (isCancelled) return;
        onSettled();
    });
    return function() {
        isCancelled = true;
    };
}
/**
 * Fires `onSettled` once all animations currently applied to `element`
 * finish or are cancelled. Returns a cleanup that prevents stale settlement.
 */ function $32fb2a53e29345b3$var$runOnAnimationsSettled(_ref2) {
    var element = _ref2.element, onSettled = _ref2.onSettled;
    return $32fb2a53e29345b3$var$runCancellableSettlement({
        onSettled: onSettled,
        schedule: function schedule(settle) {
            var _element$getAnimation, _element$getAnimation2;
            var animations = (_element$getAnimation = (_element$getAnimation2 = element.getAnimations) === null || _element$getAnimation2 === void 0 ? void 0 : _element$getAnimation2.call(element)) !== null && _element$getAnimation !== void 0 ? _element$getAnimation : [];
            Promise.allSettled(animations.map(function(animation) {
                return animation.finished;
            })).then(settle);
        }
    });
}
function $32fb2a53e29345b3$export$1bccb45daf07907f(_ref3) {
    var isOpen = _ref3.isOpen, shouldAnimate = _ref3.shouldAnimate, elementRef = _ref3.elementRef, onEnterFinish = _ref3.onEnterFinish, onExitFinish = _ref3.onExitFinish;
    var willAnimate = shouldAnimate && !(0, $63dfad70d9b5d375$export$ff7706047246b98b)();
    var isNativeClosedRef = (0, $5FkrB.useRef)(false);
    // Promote `closed → entering`/`closed → open` synchronously during
    // render so the host element mounts in the same commit as the open
    // intent. All other transitions are driven by phase-specific effects.
    var _useState = (0, $5FkrB.useState)(function() {
        if (!isOpen) return 'closed';
        return willAnimate ? 'entering' : 'open';
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), phase = _useState2[0], setPhase = _useState2[1];
    // Rearm only after controlled state and the native lifecycle have both
    // reached closed. Resetting as soon as `isOpen` becomes false can erase a
    // closing toggle that was handled in the same React batch.
    if (!isOpen && phase === 'closed') isNativeClosedRef.current = false;
    if (isOpen && phase === 'closed' && !isNativeClosedRef.current) setPhase(willAnimate ? 'entering' : 'open');
    if (!isOpen && (phase === 'open' || phase === 'entering')) // Close intent. Move to `exiting` to gate the unmount on either
    // the exit transition (animated) or the closing toggle event
    // (non-animated). Includes interrupted entry (`entering → exiting`).
    setPhase('exiting');
    if (isOpen && phase === 'exiting' && !isNativeClosedRef.current) // Reopen mid-exit. With animation, jump back to `entering` and let
    // the entry transition restart from current visual state. Without
    // animation, jump straight to `open` (the handshake we were waiting
    // for is no longer relevant; the consumer wants the host visible
    // again synchronously).
    setPhase(willAnimate ? 'entering' : 'open');
    // Keep stable refs to the latest callbacks so effects and promise callbacks
    // always call the current callback without needing them in dependency arrays.
    var onEnterFinishRef = (0, $5FkrB.useRef)(onEnterFinish);
    onEnterFinishRef.current = onEnterFinish;
    var onExitFinishRef = (0, $5FkrB.useRef)(onExitFinish);
    onExitFinishRef.current = onExitFinish;
    // Animated entry: wait for all active animations and move to `open`.
    (0, $5FkrB.useEffect)(function() {
        if (phase !== 'entering') return;
        var element = elementRef.current;
        if (!element) return;
        return $32fb2a53e29345b3$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                var _onEnterFinishRef$cur;
                // Fire the consumer callback before transitioning phase so any
                // state the consumer reads (refs, DOM nodes) is still attached
                // in the same synchronous tick, regardless of React batching
                // semantics.
                (_onEnterFinishRef$cur = onEnterFinishRef.current) === null || _onEnterFinishRef$cur === void 0 || _onEnterFinishRef$cur.call(onEnterFinishRef);
                setPhase(function(current) {
                    return current === 'entering' ? 'open' : current;
                });
            }
        });
    }, [
        phase,
        elementRef
    ]);
    // Non-animated entry callback. The lifecycle goes `closed → open`
    // directly with no `entering` phase; fire `onEnterFinish` on that jump.
    // A previous-phase ref avoids double-firing on the animated path.
    var prevPhaseForEntryRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForEntryRef.current;
        prevPhaseForEntryRef.current = phase;
        // Animated entry settle goes through `entering` and already fired
        // onEnterFinish above; only handle the non-animated direct jumps.
        if (prevPhase !== 'open' && phase === 'open' && prevPhase !== 'entering') {
            var _onEnterFinishRef$cur2;
            (_onEnterFinishRef$cur2 = onEnterFinishRef.current) === null || _onEnterFinishRef$cur2 === void 0 || _onEnterFinishRef$cur2.call(onEnterFinishRef);
        }
    }, [
        phase
    ]);
    // Animated exit: wait for all active animations, fire `onExitFinish`,
    // then move to `closed` to unmount the host.
    (0, $5FkrB.useEffect)(function() {
        if (phase !== 'exiting' || !willAnimate) return;
        var element = elementRef.current;
        if (!element) return;
        return $32fb2a53e29345b3$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                var _onExitFinishRef$curr;
                // Fire the consumer callback before transitioning phase to
                // `closed`. The phase change drives the host element unmount,
                // and consumers expect to be able to read the element (or a
                // forwarded ref to it) inside `onExitFinish`. Doing this in
                // the safe order avoids relying on React's automatic batching
                // to keep the element attached across the callback.
                (_onExitFinishRef$curr = onExitFinishRef.current) === null || _onExitFinishRef$curr === void 0 || _onExitFinishRef$curr.call(onExitFinishRef);
                setPhase(function(current) {
                    return current === 'exiting' ? 'closed' : current;
                });
            }
        });
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    // Native dismissal is authoritative. Its toggle can arrive while controlled
    // state still says open, so remember that native state and do not
    // reopen until `isOpen` has first moved to false.
    (0, $5FkrB.useLayoutEffect)(function() {
        if (phase === 'exiting' && !willAnimate && isNativeClosedRef.current) setPhase('closed');
    }, [
        phase,
        willAnimate
    ]);
    var onToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState === 'open') {
            isNativeClosedRef.current = false;
            return;
        }
        if (event.newState !== 'closed') return;
        isNativeClosedRef.current = true;
        setPhase(function(current) {
            if (current === 'open' || current === 'entering') return 'exiting';
            if (current === 'exiting' && !willAnimate) return 'closed';
            return current;
        });
    }, [
        willAnimate
    ]);
    // Non-animated exit callback. There are no animations to wait for, so fire
    // `onExitFinish` on the transition into `exiting` (the unmount itself
    // is gated by the closing toggle handshake above).
    var prevPhaseForExitRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForExitRef.current;
        prevPhaseForExitRef.current = phase;
        // Only fire on the non-animated transition into `exiting`. The
        // animated path's `exiting → closed` settle already fires
        // `onExitFinish` from `runOnAnimationsSettled`.
        if (prevPhase !== 'exiting' && phase === 'exiting' && !willAnimate) {
            var _onExitFinishRef$curr2;
            (_onExitFinishRef$curr2 = onExitFinishRef.current) === null || _onExitFinishRef$curr2 === void 0 || _onExitFinishRef$curr2.call(onExitFinishRef);
        }
    }, [
        phase,
        willAnimate
    ]);
    return {
        phase: phase,
        onToggle: onToggle
    };
}



var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
var $0d0aec48fc326d8c$var$topLayerSelector = '[popover], dialog, [role="dialog"], [role="alertdialog"]';
function $0d0aec48fc326d8c$export$df8c72c64edc7260(_ref) {
    var element = _ref.element, container = _ref.container;
    return element.closest($0d0aec48fc326d8c$var$topLayerSelector) === container.closest($0d0aec48fc326d8c$var$topLayerSelector);
}


var $a3969f38e6f95b2a$export$e1252723db1c541 = function() {
    // Common exclusion filter applied to every selector.
    var not = ':not([tabindex="-1"]):not([aria-disabled="true"]):not([aria-hidden="true"])';
    var notDisabled = ":not([disabled])".concat(not);
    var focusable = [
        "a[href]".concat(not),
        "area[href]".concat(not),
        "input".concat(notDisabled, ":not([type=\"hidden\"])"),
        "select".concat(notDisabled),
        "textarea".concat(notDisabled),
        "button".concat(notDisabled),
        "iframe".concat(not),
        "audio[controls]".concat(not),
        "video[controls]".concat(not),
        "[contenteditable]:not([contenteditable=\"false\"])".concat(not),
        "[tabindex]".concat(notDisabled)
    ];
    return {
        focusable: focusable.join(','),
        // Build the `:focus` selector
        focused: focusable.map(function(selector) {
            return "".concat(selector, ":focus");
        }).join(',')
    };
}();


function $ea16edca92302b33$export$f6768025e418420e(_ref) {
    var container = _ref.container, filter = _ref.filter;
    return Array.from(container.querySelectorAll((0, $a3969f38e6f95b2a$export$e1252723db1c541).focusable)).filter(function(element) {
        return element instanceof HTMLElement;
    }).filter(function(element) {
        return (0, $0d0aec48fc326d8c$export$df8c72c64edc7260)({
            element: element,
            container: container
        });
    }).filter(function(element) {
        return !filter || filter(element, container);
    });
}


function $01d78cb155c05276$export$748138f04a69bf21(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $ea16edca92302b33$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}



function $9f59995245ef1f7b$export$73e81fa65335a75b(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $ea16edca92302b33$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}


/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * Returns `null` if there is no focused element within the container or if
 * the focused element is not in the list of focusable elements.
 */ 

function $361532312f0d2e3e$export$a7db88e6d491b450(_ref) {
    var _all$nextIndex;
    var container = _ref.container, direction = _ref.direction, filter = _ref.filter;
    var all = (0, $ea16edca92302b33$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    var current = container.querySelector((0, $a3969f38e6f95b2a$export$e1252723db1c541).focused);
    if (!(current instanceof HTMLElement)) return null;
    var index = all.indexOf(current);
    if (index === -1) return null;
    var nextIndex = function() {
        if (direction === 'forwards') return (index + 1) % all.length;
        var proposed = index - 1;
        // if going into negative numbers, loop back to the last item
        return proposed < 0 ? all.length - 1 : proposed;
    }();
    return (_all$nextIndex = all[nextIndex]) !== null && _all$nextIndex !== void 0 ? _all$nextIndex : null;
}



var $lFhdZ = parcelRequire("lFhdZ");

function $d30c67121e4a8cab$export$b9590fdfeb5f722f(_ref) {
    var _getDocument;
    var container = _ref.container;
    var focused = (_getDocument = (0, $lFhdZ.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return !(0, $0d0aec48fc326d8c$export$df8c72c64edc7260)({
        element: focused,
        container: container
    });
}


/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/outputs/menu-keyboard-decision.md
 */ function $5d4740c3f5f36620$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $5d4740c3f5f36620$export$4f6462e86a70abe5(_ref) {
    var elementRef = _ref.elementRef, role = _ref.role, phase = _ref.phase;
    var isVisible = phase !== 'closed';
    (0, $5FkrB.useEffect)(function() {
        var element = elementRef.current;
        if (!element || !$5d4740c3f5f36620$var$roleRequiresFocusWrap(role) || !isVisible) return;
        var unbind = (0, $7QpUe.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $d30c67121e4a8cab$export$b9590fdfeb5f722f)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                var direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                var next = (0, $361532312f0d2e3e$export$a7db88e6d491b450)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                var fallback = direction === 'forwards' ? (0, $01d78cb155c05276$export$748138f04a69bf21)({
                    container: element
                }) : (0, $9f59995245ef1f7b$export$73e81fa65335a75b)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}



var $5FkrB = parcelRequire("5FkrB");

/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox regardless of role. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, or menu), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
var $64525b635f741aaf$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $64525b635f741aaf$var$isTextboxLikeElement(element) {
    var role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    var tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        var _element$getAttribute;
        var type = ((_element$getAttribute = element.getAttribute('type')) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : 'text').toLowerCase();
        return $64525b635f741aaf$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $64525b635f741aaf$var$isComboboxControllingPopup(_ref) {
    var _active$getAttribute;
    var container = _ref.container;
    var ownerDocument = container.ownerDocument;
    var active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$64525b635f741aaf$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    var idRefs = (_active$getAttribute = active.getAttribute('aria-controls')) !== null && _active$getAttribute !== void 0 ? _active$getAttribute : active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    var referencedIds = idRefs.split(/\s+/).filter(function(id) {
        return id !== '';
    });
    return referencedIds.some(function(id) {
        var referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function $64525b635f741aaf$var$getInitialFocusTarget(_ref2) {
    var container = _ref2.container, role = _ref2.role;
    if (role === 'dialog' || role === 'alertdialog') {
        // Prefer element with the native HTML autofocus attribute.
        var autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $01d78cb155c05276$export$748138f04a69bf21)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific (menu / listbox) rather
    // than hoisted. Hoisting it over-matched on dialog popups that contain
    // a nested combobox (e.g. datetime-picker's dialog hosts a react-select),
    // where the active combobox's `aria-controls` falsely matched the
    // container and suppressed the dialog's own focus contract.
    if (role === 'menu') {
        if ($64525b635f741aaf$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/outputs/menu-keyboard-decision.md
        return (0, $01d78cb155c05276$export$748138f04a69bf21)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($64525b635f741aaf$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        var selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        var firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $01d78cb155c05276$export$748138f04a69bf21)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $64525b635f741aaf$export$e992c40175757a22(_ref3) {
    var elementRef = _ref3.elementRef, phase = _ref3.phase, role = _ref3.role;
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    var prevPhaseRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var _getInitialFocusTarge;
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        var element = elementRef.current;
        if (!element) return;
        (_getInitialFocusTarge = $64525b635f741aaf$var$getInitialFocusTarget({
            container: element,
            role: role
        })) === null || _getInitialFocusTarge === void 0 || _getInitialFocusTarge.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}


/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ var $d8af52c6f4c391fd$var$supportsPopoverHint = (0, $bvsoE.default)(function() {
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    var element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
// Surface reset — neutralises inherited interaction and text-layout properties
// (e.g. `pointer-events: none` from an overlaid controls container and
// `white-space: nowrap` from an `@atlaskit/select` option) that leak into a
// top-layer element because, for CSS inheritance, it is still a DOM child of its
// trigger (top-layer promotion is paint/stacking only; the legacy portal path
// avoided this by rendering at `<body>`). Excludes `color`/`font` (theming) and
// `direction`/`unicode-bidi` (RTL must inherit).
//
// KEEP IN SYNC with the identical `surfaceResetStyles` in `dialog/dialog-content.tsx`.
// ADS forbids sharing styles across files (`no-exported-styles` /
// `no-imported-style-values` — Compiled styles are null at runtime), so the reset is
// co-located and duplicated deliberately.
var $d8af52c6f4c391fd$var$surfaceResetStyles = {
    root: "_lcxv1wug _o5724jg8 _1nmz4jg8 _1i4q4jg8 _y3gnv2br _azhwidpf _1p1dglyw"
};
var $d8af52c6f4c391fd$var$styles = {
    root: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r041wug _1reoewfl _18m9ewfl _bfhk1j28 _4t3i1wug",
    motion: "_k8m011k7 _1oecdn4k _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v179n",
    exit: "_y44vof1f"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
var $d8af52c6f4c391fd$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ var $d8af52c6f4c391fd$var$POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
var $d8af52c6f4c391fd$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function Popover(_ref, ref) {
    var children = _ref.children, _ref$mode = _ref.mode, modeProp = _ref$mode === void 0 ? 'auto' : _ref$mode, onClose = _ref.onClose, onEnterFinish = _ref.onEnterFinish, onExitFinish = _ref.onExitFinish, _ref$shouldAnimate = _ref.shouldAnimate, shouldAnimate = _ref$shouldAnimate === void 0 ? false : _ref$shouldAnimate, placement = _ref.placement, testId = _ref.testId, isOpen = _ref.isOpen, enteringAnimationXcss = _ref.enteringAnimationXcss, exitingAnimationXcss = _ref.exitingAnimationXcss, role = _ref.role, label = _ref.label, labelledBy = _ref.labelledBy, idProp = _ref.id;
    var autoId = (0, $5FkrB.useId)();
    var ownRef = (0, $5FkrB.useRef)(null);
    var combinedRef = (0, $iO8GM.default)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    var popoverId = idProp !== null && idProp !== void 0 ? idProp : "popover-".concat(autoId.replace(/:/g, ''));
    var _useAnimatedVisibilit = (0, $32fb2a53e29345b3$export$1bccb45daf07907f)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    }), phase = _useAnimatedVisibilit.phase, onToggle = _useAnimatedVisibilit.onToggle;
    // True while the host element is mounted (any phase except `closed`).
    // Used as a dep so listener-rebind effects re-attach after a remount.
    var isVisible = phase !== 'closed';
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // focus-capturing roles are handled below via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus-restoration.md.
    (0, $5d4740c3f5f36620$export$4f6462e86a70abe5)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    (0, $64525b635f741aaf$export$e992c40175757a22)({
        elementRef: ownRef,
        phase: phase,
        role: role
    });
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined.
    var handleObserverClose = (0, $5FkrB.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose({
            reason: 'programmatic'
        });
    }, [
        onClose
    ]);
    (0, $24f12266f22221a5$export$469bb693f11edc7f)({
        type: role && $d8af52c6f4c391fd$var$POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen: isOpen,
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    var mode = modeProp === 'hint' && !$d8af52c6f4c391fd$var$supportsPopoverHint() ? 'auto' : modeProp;
    var popupMotionStyle = (0, $5FkrB.useMemo)(function() {
        if (!placement || !shouldAnimate) return undefined;
        var _resolvePlacement = (0, $4489dfc85c3e3260$export$63044d21bc3d3fa2)({
            placement: placement
        }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge;
        return $d8af52c6f4c391fd$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]);
    // Prevents toggle handler from calling onClose for our own hidePopover() calls.
    var programmaticCloseRef = (0, $5FkrB.useRef)(false);
    // Set in capture-phase keydown so the toggle handler knows close reason.
    var closeReasonRef = (0, $5FkrB.useRef)('light-dismiss');
    // Snapshot of pre-open focus, used to restore focus for nested popovers
    // with focus-capturing roles (browser only restores the outermost).
    var previouslyFocusedElementRef = (0, $5FkrB.useRef)(null);
    var handleBeforeToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState !== 'open') return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- need active element snapshot
        var active = document.activeElement;
        previouslyFocusedElementRef.current = active instanceof HTMLElement ? active : null;
    }, []);
    var handleToggle = (0, $5FkrB.useCallback)(function(event) {
        var element = ownRef.current;
        if (event.newState === 'open') {
            onToggle(event);
            return;
        }
        if (event.newState === 'closed') {
            if (element) {
                // Nested-popover focus restoration fallback (browser only
                // restores outermost; Firefox skips nested entirely).
                // Restore only when the role moved focus in on open AND the
                // close was Escape/programmatic. For light dismiss, the
                // click target keeps focus per HTML spec
                // (`focusPreviousElement=false`).
                var previouslyFocused = previouslyFocusedElementRef.current;
                var reason = closeReasonRef.current;
                var isProgrammatic = programmaticCloseRef.current;
                var shouldRestore = previouslyFocused !== null && previouslyFocused.isConnected && (0, $7583abeb227bd8e5$export$b12adccf56228c71)({
                    role: role
                }) && (reason === 'escape' || isProgrammatic);
                if (shouldRestore && previouslyFocused) previouslyFocused.focus({
                    preventScroll: true
                });
                previouslyFocusedElementRef.current = null;
            }
            // Programmatic close: consumer already knows.
            if (programmaticCloseRef.current) // Reset reason so a stale 'escape' from a race with Escape keydown
            // does not corrupt the next browser-dismiss cycle.
            closeReasonRef.current = 'light-dismiss';
            else {
                // Browser dismiss (Escape/click-outside).
                var _reason = closeReasonRef.current;
                closeReasonRef.current = 'light-dismiss';
                // Optional: `manual` mode has no `onClose` in the forwarded type.
                onClose === null || onClose === void 0 || onClose({
                    reason: _reason
                });
            }
        }
        onToggle(event);
    }, [
        onClose,
        onToggle,
        role
    ]);
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `previouslyFocusedElementRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        var unbindEscape = (0, $7QpUe.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key === 'Escape') closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        var unbindToggle = (0, $7QpUe.bind)(element, {
            type: 'toggle',
            listener: handleToggle
        });
        // Snapshot `document.activeElement` before `useInitialFocus` moves it.
        var unbindBeforeToggle = (0, $7QpUe.bind)(element, {
            type: 'beforetoggle',
            listener: handleBeforeToggle
        });
        return function() {
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleToggle,
        handleBeforeToggle,
        isVisible
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            programmaticCloseRef.current = false;
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and the no-animation path unmounts before
            // `handleToggle` can reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch (_unused) {}
            return function() {
                programmaticCloseRef.current = true;
                try {
                    element.hidePopover();
                } catch (_unused2) {}
            };
        }
        programmaticCloseRef.current = true;
        try {
            element.hidePopover();
        } catch (_unused3) {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        ref: combinedRef,
        id: popoverId,
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        style: popupMotionStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $d8af52c6f4c391fd$var$styles.root,
            $d8af52c6f4c391fd$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $d8af52c6f4c391fd$var$styles.enter,
            shouldAnimate && phase === 'exiting' && $d8af52c6f4c391fd$var$styles.exit,
            shouldAnimate && $d8af52c6f4c391fd$var$styles.motion,
            (0, $hUFig.cx)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ])
    }, children);
});



var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $45Zis = parcelRequire("45Zis");

var $bvsoE = parcelRequire("bvsoE");

var $25nEq = parcelRequire("25nEq");
function $bef27024bcf1baf0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bef27024bcf1baf0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bef27024bcf1baf0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bef27024bcf1baf0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * JS fallback positioning math. Used only when the browser does not
 * support CSS Anchor Positioning (less than 6% of users).
 *
 * Consumer-supplied `offset.gap` and `offset.crossAxisShift` are
 * honored: the caller (`useAnchorPosition`) resolves CSS length strings
 * (tokens, calc, var, etc) to pixels via a DOM probe before passing them
 * in. The caller also keeps the popover hidden (`opacity: 0`) until the
 * first measurement completes, so the popover never paints at the wrong
 * position.
 */ /**
 * A viewport-relative position, in pixels. Physical rather than logical
 * because it is written straight to `top` / `left`.
 */ /**
 * The cross-axis shift with its length already resolved to pixels.
 *
 * Mirrors `TCrossAxisShiftOffset`, whose `value` is an unresolved CSS length
 * string. Only this module needs the pixel form, because only this module does
 * the arithmetic itself.
 */ /**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function $bef27024bcf1baf0$var$computeEdgePosition(_ref) {
    var axis = _ref.axis, edge = _ref.edge, triggerRect = _ref.triggerRect, popoverWidth = _ref.popoverWidth, popoverHeight = _ref.popoverHeight, viewport = _ref.viewport, gap = _ref.gap;
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        var spaceBelow = viewport.height - triggerRect.bottom;
        var spaceAbove = triggerRect.top;
        var fitsBelow = spaceBelow >= popoverHeight + gap;
        var useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        var _spaceAbove = triggerRect.top;
        var _spaceBelow = viewport.height - triggerRect.bottom;
        var fitsAbove = _spaceAbove >= popoverHeight + gap;
        var useAbove = fitsAbove || _spaceAbove >= _spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        var spaceRight = viewport.width - triggerRect.right;
        var spaceLeft = triggerRect.left;
        var fitsRight = spaceRight >= popoverWidth + gap;
        var useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        var _spaceLeft = triggerRect.left;
        var _spaceRight = viewport.width - triggerRect.right;
        var fitsLeft = _spaceLeft >= popoverWidth + gap;
        var useLeft = fitsLeft || _spaceLeft >= _spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function $bef27024bcf1baf0$var$applyAlignment(_ref2) {
    var position = _ref2.position, axis = _ref2.axis, align = _ref2.align, triggerRect = _ref2.triggerRect, popoverWidth = _ref2.popoverWidth, popoverHeight = _ref2.popoverHeight;
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return $bef27024bcf1baf0$var$_objectSpread($bef27024bcf1baf0$var$_objectSpread({}, position), {}, {
            left: triggerRect.left
        });
        // align === 'end'
        return $bef27024bcf1baf0$var$_objectSpread($bef27024bcf1baf0$var$_objectSpread({}, position), {}, {
            left: triggerRect.right - popoverWidth
        });
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return $bef27024bcf1baf0$var$_objectSpread($bef27024bcf1baf0$var$_objectSpread({}, position), {}, {
        top: triggerRect.top
    });
    // align === 'end'
    return $bef27024bcf1baf0$var$_objectSpread($bef27024bcf1baf0$var$_objectSpread({}, position), {}, {
        top: triggerRect.bottom - popoverHeight
    });
}
/**
 * Applies the cross-axis shift offset.
 *
 * `forwards` always moves the popover toward the cross-axis END and
 * `backwards` toward the START, for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 *
 * This is a coordinate, so the direction is the sign and nothing else. There
 * is deliberately no per-`align` sign inversion here: the CSS path inverts the
 * sign only because a margin on the END side pushes a box the opposite way to
 * a margin on the START side, which is a property of margins rather than of
 * the shift. Applying that inversion to a coordinate moved `align: 'end'`
 * popovers the wrong way.
 */ function $bef27024bcf1baf0$var$applyCrossAxisShift(_ref3) {
    var position = _ref3.position, axis = _ref3.axis, crossAxisShift = _ref3.crossAxisShift;
    if (crossAxisShift.value === 0) return position;
    var directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    var delta = crossAxisShift.value * directionSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return $bef27024bcf1baf0$var$_objectSpread($bef27024bcf1baf0$var$_objectSpread({}, position), {}, {
        left: position.left + delta
    });
    return $bef27024bcf1baf0$var$_objectSpread($bef27024bcf1baf0$var$_objectSpread({}, position), {}, {
        top: position.top + delta
    });
}
function $bef27024bcf1baf0$export$d5ef1dac02135664(_ref4) {
    var triggerRect = _ref4.triggerRect, popoverEl = _ref4.popoverEl, placement = _ref4.placement, viewport = _ref4.viewport, gap = _ref4.gap, crossAxisShift = _ref4.crossAxisShift;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    var popoverWidth = popoverEl.offsetWidth;
    var popoverHeight = popoverEl.offsetHeight;
    var basePosition = $bef27024bcf1baf0$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    var alignedPosition = $bef27024bcf1baf0$var$applyAlignment({
        position: basePosition,
        axis: axis,
        align: align,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    var shiftedPosition = $bef27024bcf1baf0$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        crossAxisShift: crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}


/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $4ead79cca5cd25ce$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, cleanupFns = new Array(_len), _key = 0; _key < _len; _key++)cleanupFns[_key] = arguments[_key];
    return function cleanup() {
        cleanupFns.forEach(function(callback) {
            return callback === null || callback === void 0 ? void 0 : callback();
        });
    };
}



function $4025e66b8865d0de$export$de49b61f233ddeb9(_ref) {
    var placement = _ref.placement;
    var _resolvePlacement = (0, $4489dfc85c3e3260$export$63044d21bc3d3fa2)({
        placement: placement
    }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge, align = _resolvePlacement.align;
    var edgeValue = "".concat(axis, "-").concat(edge);
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    var spanDir = align === 'start' ? 'end' : 'start';
    return "".concat(edgeValue, " span-").concat(crossAxis, "-").concat(spanDir);
}



/**
 * A `position-area` primary edge — the placement axis joined to its edge, e.g.
 * `block-end` or `inline-start`. These are the four edges a popover can sit on.
 */ function $d0b69e91de16ae9d$var$slideOnEdge(_ref) {
    var align = _ref.align, edgeKey = _ref.edgeKey, crossAxis = _ref.crossAxis;
    if (align === 'center') return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-end"),
        "".concat(edgeKey, " span-").concat(crossAxis, "-start")
    ];
    // For `align: 'start'` the popover expands toward `end`, so the "near"
    // span is `end` and the "far" span is `start`; `align: 'end'` mirrors
    // this. The bare `edgeKey` (re-centered) sits between them.
    var near = align === 'start' ? 'end' : 'start';
    var far = align === 'start' ? 'start' : 'end';
    return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(near),
        edgeKey,
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(far)
    ];
}
function $d0b69e91de16ae9d$var$flipDiagonally(_ref2) {
    var axis = _ref2.axis;
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    var flipToCrossAxis = axis === 'block' ? 'flip-inline' : 'flip-block';
    return "".concat(flipOnMainAxis, " ").concat(flipToCrossAxis);
}
function $d0b69e91de16ae9d$export$c4e16947a95d61f1(_ref3) {
    var placement = _ref3.placement;
    /**
   * **Build the fallback list**
   *
   * Each entry is a complete alternative position.
   * The browser tries them _in order_ and uses the _first_ one that fits.
   */ var resolved = (0, $4489dfc85c3e3260$export$63044d21bc3d3fa2)({
        placement: placement
    });
    var axis = resolved.axis, edge = resolved.edge, align = resolved.align;
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    var flippedEdge = edge === 'start' ? 'end' : 'start';
    var sameEdgeArea = "".concat(axis, "-").concat(edge);
    var oppositeEdgeArea = "".concat(axis, "-").concat(flippedEdge);
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    /**
   * **Fallback algorithm**
   *
   * We have two things we can do to keep something visible:
   *
   * 1. _Slide_ along edges
   * 2. _Flip_ to another edge
   *
   * _Centered popover_
   *
   * Desired: Sits in middle of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge (centered)
   *  3: _Slide_ along opposite edge on the cross axis
   *
   * _Start or end aligned popover_
   *
   * Desired: Sits at start / end of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge
   *  3: _Flip_ on the diagonal (flip main axis + flip cross axis) into the
   *     opposite corner. For start / end alignment, this is the clean escape
   *     when the popover would otherwise land offscreen on both axes (ie in a
   *     corner). Rule 4 gets the job done, but a slide drops the gap
   *     as named position-area values don't carry margins).
   *     The diagonal flip keeps the gap and the alignment.
   *  4: _Slide_ along opposite edge on the cross axis
   */ return [
        $d0b69e91de16ae9d$var$slideOnEdge({
            align: align,
            edgeKey: sameEdgeArea,
            crossAxis: crossAxis
        }),
        flipOnMainAxis,
        align !== 'center' ? $d0b69e91de16ae9d$var$flipDiagonally({
            axis: axis
        }) : null,
        $d0b69e91de16ae9d$var$slideOnEdge({
            align: align,
            edgeKey: oppositeEdgeArea,
            crossAxis: crossAxis
        })
    ].filter(Boolean).flat().join(', ');
}


var $be4d4c5cffc94314$var$elementCaches = new WeakMap();
function $be4d4c5cffc94314$var$canCacheResolvedLength(value) {
    // Custom-property values can be retargeted by inline overrides on the
    // consumer's wrapper, so we cannot prove a cached pixel value is still valid.
    return !value.includes('var(');
}
function $be4d4c5cffc94314$var$getCachedResolvedLength(_ref) {
    var _cacheForElement$get;
    var element = _ref.element, value = _ref.value;
    if (!$be4d4c5cffc94314$var$canCacheResolvedLength(value)) return null;
    var cacheForElement = $be4d4c5cffc94314$var$elementCaches.get(element);
    return (_cacheForElement$get = cacheForElement === null || cacheForElement === void 0 ? void 0 : cacheForElement.get(value)) !== null && _cacheForElement$get !== void 0 ? _cacheForElement$get : null;
}
function $be4d4c5cffc94314$var$cacheResolvedLength(_ref2) {
    var _elementCaches$get;
    var element = _ref2.element, value = _ref2.value, result = _ref2.result;
    if (!$be4d4c5cffc94314$var$canCacheResolvedLength(value)) return;
    var cacheForElement = (_elementCaches$get = $be4d4c5cffc94314$var$elementCaches.get(element)) !== null && _elementCaches$get !== void 0 ? _elementCaches$get : new Map();
    cacheForElement.set(value, result);
    $be4d4c5cffc94314$var$elementCaches.set(element, cacheForElement);
}
function $be4d4c5cffc94314$export$98721546d2816d9e(_ref3) {
    var value = _ref3.value, container = _ref3.container;
    if (typeof value === 'number') return value;
    // Fast path: unitless zero is universally zero pixels - accept `'0'` and
    // `'-0'` without a probe. (Consumers occasionally pass `'0'` instead of
    // the number `0`.)
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from the consumer normalisation
    // in `resolvePlacement`. Avoid a reflow when we can.
    var pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    var cached = $be4d4c5cffc94314$var$getCachedResolvedLength({
        element: container,
        value: value
    });
    if (cached !== null) return cached;
    var probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hide the probe from assistive tech and event targeting; defensive
    // against `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    container.appendChild(probe);
    var resolved = parseFloat(getComputedStyle(probe).marginLeft);
    container.removeChild(probe);
    var result = Number.isFinite(resolved) ? resolved : 0;
    $be4d4c5cffc94314$var$cacheResolvedLength({
        element: container,
        value: value,
        result: result
    });
    return result;
}



/**
 * A single inline style declaration.
 *
 * `TProperty` narrows the property name for callers that write a known, closed
 * set of properties. Narrowing it lets a record keyed on those same names be
 * checked for exhaustiveness at compile time, rather than silently resolving to
 * `undefined` for a name that was never mapped.
 */ /**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 */ function $2c10b34947cfb21a$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}


// `resolvePlacement` is intentionally NOT re-exported here - import it directly
// from `./resolve-placement` so search-and-jump lands at the source of truth.
/**
 * Module-scope no-op `ResizeObserver` used in non-DOM jest environments where
 * `ResizeObserver` is `undefined`. Hoisted out of the effect to avoid
 * allocating a new class declaration on every run.
 */ var $bfbafd58ce178888$var$NoopResizeObserver = /*#__PURE__*/ function() {
    function NoopResizeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoopResizeObserver);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoopResizeObserver, [
        {
            key: "observe",
            value: function observe() {}
        },
        {
            key: "unobserve",
            value: function unobserve() {}
        },
        {
            key: "disconnect",
            value: function disconnect() {}
        }
    ]);
}();
/**
 * Returns true when the popover is currently open. Wrapped because the
 * `:popover-open` pseudo-class is not implemented in some test environments
 * (e.g. jsdom), where `matches` throws on unknown selectors.
 */ function $bfbafd58ce178888$var$isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch (_unused) {
        return false;
    }
}
/**
 * Detects whether the browser supports CSS Anchor Positioning.
 * Uses `once()` for lazy evaluation: safe for SSR and avoids hydration mismatches.
 */ var $bfbafd58ce178888$var$supportsAnchorPositioning = (0, $bvsoE.default)(function() {
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('anchor-name', '--a');
});
/**
 * Every logical margin property this module can write: one per axis, per side.
 *
 * Deriving the union from `TPlacementAxis` and `TPlacementEdge` rather than
 * writing the four names out keeps it in step with the placement model, and
 * makes `CROSS_AXIS_SHIFT_CUSTOM_PROPERTY` below exhaustive by construction.
 */ /**
 * The custom property mirroring each cross-axis shift margin.
 *
 * These are written for the planned named arrow `@position-try` rules. Nothing
 * reads them yet, and the shift no longer depends on them: the antisymmetric
 * margins written by `crossAxisShiftMargins` survive a cross-axis slide on
 * their own.
 *
 * Keyed on `TLogicalMarginProperty` and not on `string`, so a margin property
 * that has no custom property (or a custom property whose margin no longer
 * exists) is a compile error rather than an `undefined` lookup that reaches
 * `setStyle` as `{ property: undefined, value }`.
 */ var $bfbafd58ce178888$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY = {
    'margin-inline-start': '--ds-cross-axis-shift-margin-start',
    'margin-inline-end': '--ds-cross-axis-shift-margin-end',
    'margin-block-start': '--ds-cross-axis-shift-margin-block-start',
    'margin-block-end': '--ds-cross-axis-shift-margin-block-end'
};
var $bfbafd58ce178888$var$ZEROED_CROSS_AXIS_SHIFT_CUSTOM_PROPERTIES = Object.values($bfbafd58ce178888$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY).map(function(property) {
    return {
        property: property,
        value: '0px'
    };
});
/**
 * Returns the CSS margin declaration that creates a gap between the
 * popover and its trigger on the side facing the anchor.
 *
 * For example, a `block-end` placement (popover below) gets
 * `margin-block-start: 8px` to push it away from the trigger's bottom edge.
 */ function $bfbafd58ce178888$var$edgeMargin(_ref) {
    var placement = _ref.placement, offset = _ref.offset;
    var axis = placement.axis, edge = placement.edge;
    // The gap sits on the side FACING the anchor, which is always the side
    // opposite the placement edge.
    var anchorFacingEdge = edge === 'end' ? 'start' : 'end';
    return {
        property: "margin-".concat(axis, "-").concat(anchorFacingEdge),
        value: offset
    };
}
/**
 * **The cross-axis shift margins.**
 *
 * The shift is written antisymmetrically on BOTH cross-axis sides
 * (`start: +value`, `end: -value`) rather than as a single margin on the side
 * picked from `align`. Two separate behaviours require it:
 *
 * 1. **`align: 'center'` is centered with `anchor-center`, which centers the
 *    popover's MARGIN box on the anchor.** A single-sided margin widens the
 *    margin box, so it displaces the border box by only half its value. An
 *    antisymmetric pair leaves the margin box width unchanged (`+value` and
 *    `-value` sum to zero) while moving its center by the full value.
 * 2. **`position-try-fallbacks` can slide the popover onto the opposite
 *    cross-axis side.** A `<position-area>` fallback keeps the base style's
 *    margins, and margin on the un-anchored side has no effect, so a
 *    single-sided margin is silently dropped once the browser slides across the
 *    cross axis. With both sides written, whichever side ends up anchored moves
 *    the popover the same physical direction.
 *
 * Leaving the margin box width unchanged also means the shift does not move
 * the point at which `position-try-fallbacks` decides the popover overflows.
 *
 * A `<try-tactic>` fallback (`flip-block`, `flip-inline`) behaves differently to
 * a `<position-area>` one: it SWAPS the start and end margins rather than
 * keeping them, which is what preserves the gap through a flip. So a flip across
 * the cross axis mirrors the shift along with the rest of the placement, rather
 * than preserving its physical direction. Only the diagonal fallback does that,
 * and only for `align: 'start' | 'end'`. See `placementToTryFallbacks`.
 *
 * A positive value always moves the popover toward the cross-axis END, so
 * `direction: 'forwards'` means the same thing for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 */ function $bfbafd58ce178888$var$crossAxisShiftMargins(_ref2) {
    var placement = _ref2.placement, crossAxisShiftCssValue = _ref2.crossAxisShiftCssValue, direction = _ref2.direction;
    var crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    // Wrap any string in calc() with the sign factor. CSS handles the math,
    // so opaque values such as design tokens negate correctly.
    var negated = "calc(-1 * ".concat(crossAxisShiftCssValue, ")");
    var isForwards = direction === 'forwards';
    return [
        {
            property: "margin-".concat(crossAxis, "-start"),
            value: isForwards ? crossAxisShiftCssValue : negated
        },
        {
            property: "margin-".concat(crossAxis, "-end"),
            value: isForwards ? negated : crossAxisShiftCssValue
        }
    ];
}
/**
 * Returns a referentially-stable, fully-resolved `TPlacement`. The memo is
 * keyed on the resolved primitive fields so a fresh inline `placement` object
 * (or undefined fields vs explicit defaults) does not produce a fresh result.
 */ function $bfbafd58ce178888$var$useStablePlacement(placement) {
    var resolved = (0, $4489dfc85c3e3260$export$63044d21bc3d3fa2)({
        placement: placement
    });
    var axis = resolved.axis;
    var edge = resolved.edge;
    var align = resolved.align;
    var gap = resolved.offset.gap;
    var shiftValue = resolved.offset.crossAxisShift.value;
    var shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuild inside the memo from primitive deps so the factory does not
    // close over the outer `resolved` reference and exhaustive-deps can verify.
    return (0, $5FkrB.useMemo)(function() {
        return {
            axis: axis,
            edge: edge,
            align: align,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        };
    }, [
        axis,
        edge,
        align,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $bfbafd58ce178888$export$56b02a1e583f953c(_ref3) {
    var anchorRef = _ref3.anchorRef, popoverRef = _ref3.popoverRef, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? {} : _ref3$placement, _ref3$forceFallbackPo = _ref3.forceFallbackPositioning, forceFallbackPositioning = _ref3$forceFallbackPo === void 0 ? false : _ref3$forceFallbackPo, _ref3$isEnabled = _ref3.isEnabled, isEnabled = _ref3$isEnabled === void 0 ? true : _ref3$isEnabled, isOpen = _ref3.isOpen;
    var id = (0, $5FkrB.useId)();
    var stablePlacement = $bfbafd58ce178888$var$useStablePlacement(placement);
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!isEnabled) return;
        var trigger = anchorRef.current;
        var popover = popoverRef.current;
        if (!trigger || !popover) return;
        var gapCssValue = stablePlacement.offset.gap;
        var crossAxisShiftCssValue = stablePlacement.offset.crossAxisShift.value;
        var shouldForceFallback = Boolean(forceFallbackPositioning);
        if ($bfbafd58ce178888$var$supportsAnchorPositioning() && !shouldForceFallback) {
            // Reuse an existing `anchor-name` if the element already has one.
            // Another popover might already be anchored to the old name.
            var anchorName = trigger.style.getPropertyValue('anchor-name') || "--anchor-".concat(id.replace(/:/g, ''));
            var gap = $bfbafd58ce178888$var$edgeMargin({
                placement: stablePlacement,
                offset: gapCssValue
            });
            // Computed once; also mirrored into the
            // `--ds-cross-axis-shift-margin-*` custom properties below.
            var crossAxisShift = $bfbafd58ce178888$var$crossAxisShiftMargins({
                placement: stablePlacement,
                crossAxisShiftCssValue: crossAxisShiftCssValue,
                direction: stablePlacement.offset.crossAxisShift.direction
            });
            var popoverStyles = [
                {
                    property: 'position-anchor',
                    value: anchorName
                },
                {
                    property: 'position-area',
                    value: (0, $4025e66b8865d0de$export$de49b61f233ddeb9)({
                        placement: stablePlacement
                    })
                },
                {
                    property: 'position-try-fallbacks',
                    value: (0, $d0b69e91de16ae9d$export$c4e16947a95d61f1)({
                        placement: stablePlacement
                    })
                },
                // Reset browser default popover positioning that conflicts
                // with anchor positioning (UA: `inset: 0; margin: auto;`)
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                },
                gap
            ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(crossAxisShift), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))($bfbafd58ce178888$var$ZEROED_CROSS_AXIS_SHIFT_CUSTOM_PROPERTIES), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(crossAxisShift.map(function(_ref4) {
                var property = _ref4.property, value = _ref4.value;
                return {
                    property: $bfbafd58ce178888$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY[property],
                    value: value
                };
            })));
            /**
       * **We are never cleaning up anchor names**
       *
       * _Rationale_
       *
       * - Multiple popovers can share the same anchor element.
       * - Sometimes the `useAnchorPosition` hook and `Popover`
       *   are not in the same component.
       * - There can be times when, even with reference counting, we
       *   could remove the anchor-name while it is still being used
       *   by something else - especially with async react updates
       *   which can cause tearing
       *
       * _More_
       *
       * See `notes/decisions/anchor-name-lifetime.md`
       */ trigger.style.setProperty('anchor-name', anchorName);
            return (0, $2c10b34947cfb21a$export$37a5fde709c1db82)({
                element: popover,
                styles: popoverStyles
            });
        }
        // JS fallback. The popover is already in the top layer via
        // popover="auto", so we only reset UA defaults and set top/left
        // based on measurements.
        var cleanupBaseStyles = (0, $2c10b34947cfb21a$export$37a5fde709c1db82)({
            element: popover,
            styles: [
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                }
            ]
        });
        // The popover can be consumer-owned (`@atlaskit/popper`'s `createPopper`),
        // so restore prior inline values rather than removing ours.
        var undoPosition;
        var undoHide;
        // `opacity: 0` not `visibility: hidden`: Firefox skips visibility-hidden
        // elements during `<dialog>` initial-focus traversal.
        function hideUntilPositioned() {
            // Keep the first snapshot, else we capture our own `opacity: 0`.
            // (`!popover` is for TS: narrowing does not reach nested functions.)
            if (!popover || undoHide) return;
            undoHide = (0, $2c10b34947cfb21a$export$37a5fde709c1db82)({
                element: popover,
                styles: [
                    {
                        property: 'opacity',
                        value: '0'
                    }
                ]
            });
        }
        function reveal() {
            var _undoHide;
            (_undoHide = undoHide) === null || _undoHide === void 0 || _undoHide();
            undoHide = undefined;
        }
        function restorePosition() {
            var _undoPosition;
            (_undoPosition = undoPosition) === null || _undoPosition === void 0 || _undoPosition();
            undoPosition = undefined;
        }
        function update() {
            if (!trigger || !popover) return;
            var triggerRect = trigger.getBoundingClientRect();
            var viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            // Resolve consumer-supplied CSS length strings (tokens, calc, var,
            // px, rem, etc) to pixels. The probe is mounted INSIDE the popover
            // itself so the resolved length matches the scope a token would
            // resolve against from inside the popover content. (The popover
            // lives in the top layer, not the trigger's DOM tree, so probing
            // at `popover.parentElement` would resolve in a different scope
            // than the consumer's token authoring expects.)
            var gapPx = (0, $be4d4c5cffc94314$export$98721546d2816d9e)({
                value: gapCssValue,
                container: popover
            });
            var crossAxisShiftPx = (0, $be4d4c5cffc94314$export$98721546d2816d9e)({
                value: crossAxisShiftCssValue,
                container: popover
            });
            var _computeFallbackPosit = (0, $bef27024bcf1baf0$export$d5ef1dac02135664)({
                triggerRect: triggerRect,
                popoverEl: popover,
                placement: stablePlacement,
                viewport: viewport,
                gap: gapPx,
                crossAxisShift: {
                    value: crossAxisShiftPx,
                    direction: stablePlacement.offset.crossAxisShift.direction
                }
            }), top = _computeFallbackPosit.top, left = _computeFallbackPosit.left;
            // Restore first so the snapshot stays the consumer's value.
            restorePosition();
            undoPosition = (0, $2c10b34947cfb21a$export$37a5fde709c1db82)({
                element: popover,
                styles: [
                    {
                        property: 'top',
                        value: "".concat(top, "px")
                    },
                    {
                        property: 'left',
                        value: "".concat(left, "px")
                    }
                ]
            });
            reveal();
        }
        // Throttle scroll/resize updates to one per animation frame
        var scheduledUpdate = (0, $45Zis.default)(update);
        // Wait for the FIRST valid layout before measuring: the popover
        // is `display: none` until `showPopover()`, and some browsers
        // fire `toggle` before layout, so RAF-after-toggle is unreliable.
        // ResizeObserver fires once the browser has real dimensions.
        // Self-disconnects after one valid measurement; ongoing
        // scroll/resize is handled by the window listeners below.
        // `ResizeObserver` is missing in some non-DOM jest environments
        // (e.g. post-office's `node` environment). Fall back to a no-op
        // observer there. The scroll/resize listeners below still keep
        // the popover positioned in the rare case the consumer also
        // polyfilled `showPopover` but not `ResizeObserver`. Real
        // browsers always have it. The `NoopResizeObserver` class is
        // hoisted to module scope (see top of file) so we do not allocate
        // a new constructor on every effect run.
        var ResizeObserverImpl = typeof ResizeObserver !== 'undefined' ? ResizeObserver : $bfbafd58ce178888$var$NoopResizeObserver;
        var resizeObserver = new ResizeObserverImpl(function() {
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                update();
                resizeObserver.disconnect();
            }
        });
        // If the popover is already open by the time this effect runs (for
        // example, the parent `useAnchorPosition` effect runs after the child
        // `Popover` effect that called `showPopover()`), the initial `toggle`
        // event has already fired and our listener below would miss it. Start
        // observing immediately so the first measurement still happens.
        if ($bfbafd58ce178888$var$isPopoverOpen(popover)) {
            hideUntilPositioned();
            resizeObserver.observe(popover);
        }
        var undoPositioning = (0, $4ead79cca5cd25ce$export$1be1fc439b849fdf)(cleanupBaseStyles, // Each open needs a fresh measurement, so hide and re-observe.
        (0, $7QpUe.bind)(popover, {
            type: 'toggle',
            listener: function listener(event) {
                var toggleEvent = event;
                if (toggleEvent.newState === 'open') {
                    hideUntilPositioned();
                    resizeObserver.observe(popover);
                }
            }
        }), function() {
            return resizeObserver.disconnect();
        }, (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: scheduledUpdate,
            options: {
                capture: true,
                passive: true
            }
        }), (0, $7QpUe.bind)(window, {
            type: 'resize',
            listener: scheduledUpdate,
            options: {
                passive: true
            }
        }), function() {
            scheduledUpdate.cancel();
            restorePosition();
            reveal();
        });
        return undoPositioning;
    }, [
        anchorRef,
        popoverRef,
        stablePlacement,
        forceFallbackPositioning,
        isEnabled,
        id,
        isOpen
    ]);
}



var $5FkrB = parcelRequire("5FkrB");

var $bvsoE = parcelRequire("bvsoE");

/**
 * Probes anchor SIZING, separately from `anchor-name` (see
 * `supportsAnchorPositioning`): some browsers have positioning but not sizing.
 * `once()` for SSR safety.
 */ var $157703ae54037ef1$var$supportsAnchorSize = (0, $bvsoE.default)(function() {
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('min-inline-size', 'anchor-size(self-inline)');
});
/**
 * The JS fallback's stand-in for `anchor-size(self-inline)`. `offsetWidth` / `offsetHeight` are
 * physical, so the axis is picked from the popover's `writing-mode`. Anything not horizontal is
 * treated as vertical, and an unknown or empty value falls back to `offsetWidth`.
 */ function $157703ae54037ef1$var$getFallbackAnchorInlineSize(_ref) {
    var anchor = _ref.anchor, popover = _ref.popover;
    // `String()` because not every test environment implements `writing-mode`.
    var writingMode = String(getComputedStyle(popover).writingMode);
    var isVertical = writingMode.startsWith('vertical') || writingMode.startsWith('sideways');
    return isVertical ? anchor.offsetHeight : anchor.offsetWidth;
}
function $157703ae54037ef1$export$7071d791a7b131ed(_ref2) {
    var mode = _ref2.mode, popoverRef = _ref2.popoverRef, anchorRef = _ref2.anchorRef, isOpen = _ref2.isOpen;
    (0, $5FkrB.useLayoutEffect)(function() {
        var node = popoverRef.current;
        if (!node) return;
        if (mode === 'match-anchor') {
            // No floor here: it would let the popover grow past the anchor.
            if ($157703ae54037ef1$var$supportsAnchorSize()) return (0, $2c10b34947cfb21a$export$37a5fde709c1db82)({
                element: node,
                styles: [
                    {
                        property: 'inline-size',
                        value: 'anchor-size(self-inline)'
                    }
                ]
            });
            var anchor = anchorRef.current;
            if (anchor) return (0, $2c10b34947cfb21a$export$37a5fde709c1db82)({
                element: node,
                styles: [
                    {
                        property: 'inline-size',
                        value: "".concat($157703ae54037ef1$var$getFallbackAnchorInlineSize({
                            anchor: anchor,
                            popover: node
                        }), "px")
                    }
                ]
            });
            return;
        }
        if (mode === 'min-anchor') {
            // One floor only. The content floor from mode 'none' deliberately does not also apply
            // here, and cannot: it would need this same property. See the decision note.
            if ($157703ae54037ef1$var$supportsAnchorSize()) return (0, $2c10b34947cfb21a$export$37a5fde709c1db82)({
                element: node,
                styles: [
                    {
                        property: 'min-inline-size',
                        value: 'anchor-size(self-inline)'
                    }
                ]
            });
            var _anchor = anchorRef.current;
            if (_anchor) return (0, $2c10b34947cfb21a$export$37a5fde709c1db82)({
                element: node,
                styles: [
                    {
                        property: 'min-inline-size',
                        value: "".concat($157703ae54037ef1$var$getFallbackAnchorInlineSize({
                            anchor: _anchor,
                            popover: node
                        }), "px")
                    }
                ]
            });
            // Nothing to measure, so no floor.
            return;
        }
        // Makes a too-narrow span overflow and drive `position-try-fallbacks` instead of wrapping.
        // `@atlaskit/popper` resets this exact property to `0` for its fit-to-viewport mode.
        return (0, $2c10b34947cfb21a$export$37a5fde709c1db82)({
            element: node,
            styles: [
                {
                    property: 'min-inline-size',
                    value: 'max-content'
                }
            ]
        });
    }, [
        mode,
        popoverRef,
        anchorRef,
        isOpen
    ]);
}




var $5FkrB = parcelRequire("5FkrB");
var $06b73473416379fe$export$a0d5b29fa9affc38 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);


function $dd8991b21c71137a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dd8991b21c71137a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dd8991b21c71137a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dd8991b21c71137a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// `'auto'` falls through to `'end'`; top-layer's `position-try-fallbacks` flips it if needed.
function $dd8991b21c71137a$var$reactSelectEdgeToTopLayerEdge(menuPlacement) {
    return menuPlacement === 'top' ? 'start' : 'end';
}
var $dd8991b21c71137a$var$menuPortalStyles = {
    root: "_ofie1496"
};
function $dd8991b21c71137a$export$1f5427c7f5364d0b(props) {
    var children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, xcss = props.xcss;
    // Select's "close the menu" callback, distinct from `Popover.onClose`.
    var closeSelect = (0, $5FkrB.useContext)((0, $06b73473416379fe$export$a0d5b29fa9affc38));
    var popoverRef = (0, $5FkrB.useRef)(null);
    // Top-layer hooks need a RefObject; in-render mutation keeps it in sync
    // with the prop without an effect. The hooks re-read `.current` from
    // `isOpen`-keyed layout effects, so a stable ref identity is fine.
    var anchorRef = (0, $5FkrB.useRef)(null);
    anchorRef.current = controlElement;
    // `controlElement` is null on initial mount / SSR until `Select` mirrors
    // its ref into state. While null, every hook below no-ops to avoid DOM
    // reads or registering an unpositioned popover.
    var isAnchored = controlElement !== null;
    // `gap: 0` matches the legacy MenuPortal (no trigger-to-menu gap; the
    // menu root already declares its own `marginBlockStart`). Without this
    // override `useAnchorPosition`'s default 8px gap would diverge visually
    // from the legacy path.
    (0, $bfbafd58ce178888$export$56b02a1e583f953c)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        placement: {
            axis: 'block',
            edge: $dd8991b21c71137a$var$reactSelectEdgeToTopLayerEdge(menuPlacement),
            offset: {
                gap: 0
            }
        },
        isOpen: isAnchored
    });
    (0, $157703ae54037ef1$export$7071d791a7b131ed)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        mode: 'match-anchor',
        isOpen: isAnchored
    });
    var handlePopoverClose = (0, $5FkrB.useCallback)(function() {
        if (closeSelect) closeSelect();
    }, [
        closeSelect
    ]);
    // Explicit observer registration: the outer Popover is intentionally
    // roleless (see Popover comment below), so Popover cannot auto-register
    // from its role. This lets `closeLayers()` (Modal / Drawer) dismiss us.
    (0, $24f12266f22221a5$export$469bb693f11edc7f)({
        type: 'popup',
        isOpen: isAnchored,
        onClose: handlePopoverClose
    });
    // Top-layer owns positioning; zero offset/rect preserves the consumer
    // styles call shape.
    var _getStyleProps = (0, $76e70396aae85af8$export$26417cabd806a658)($dd8991b21c71137a$var$_objectSpread($dd8991b21c71137a$var$_objectSpread({}, props), {}, {
        offset: 0,
        position: menuPosition,
        rect: {
            left: 0,
            width: 0
        }
    }), 'menuPortal', {
        'menu-portal': true
    }), className = _getStyleProps.className;
    // Popover stays mounted and is driven by `isOpen` so its layout-effect
    // teardown (`hidePopover`, observer cleanup, position-hook style reset)
    // runs against a live element. Conditional render would skip that path.
    //
    // `mode="auto"` delegates light-dismiss and Escape to the browser. The
    // `onClose` bridge then synchronizes react-select's `menuIsOpen` state after
    // native dismissal, keeping this popover available to consume the request.
    //
    // The Popover host is intentionally roleless: the inner `MenuList`
    // keeps `role="listbox"` and the id referenced by `aria-controls`.
    // Putting the role on the outer host caused Playwright `toBeVisible`
    // and some SR hit-testing to treat it as hidden (zero bounding rect
    // while `styles.root` opts out of UA `[popover]` positioning).
    //
    // TODO: add open / close animation. Select unmounts MenuPortalTopLayer
    // the moment `menuIsOpen` flips false, so Popover's `animate` exit
    // transition never gets a frame. Needs keeping the portal mounted
    // through the exit (`onExitFinish`) on the Select side.
    return /*#__PURE__*/ $5FkrB.createElement((0, $d8af52c6f4c391fd$export$5b6b19405a83ff9d), {
        ref: popoverRef,
        mode: "auto",
        isOpen: isAnchored,
        onClose: handlePopoverClose
    }, /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // `className` carries consumer `styles.menuPortal({...})` output,
        // `xcss` carries caller compiled atomic classes, and `-MenuPortal`
        // is a legacy selector hook kept for parity with MenuPortalLegacy.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss, @typescript-eslint/no-explicit-any
        className: (0, $970q7.default)([
            $dd8991b21c71137a$var$menuPortalStyles.root,
            (0, $hUFig.cx)(className, xcss, '-MenuPortal')
        ])
    }, innerProps), children));
}


function $6c86ba34c2a76faf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6c86ba34c2a76faf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6c86ba34c2a76faf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6c86ba34c2a76faf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6c86ba34c2a76faf$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
var $6c86ba34c2a76faf$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $6c86ba34c2a76faf$var$menuPortalStyles = {
    root: "_1pbykb7n _1e02a1vk _kqswcp1v _152t1nmo _1bsb1qxj"
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
function $6c86ba34c2a76faf$var$MenuPortalLegacy(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, xcss = props.xcss;
    var menuPortalRef = (0, $5FkrB.useRef)(null);
    var cleanupRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)($6c86ba34c2a76faf$var$coercePlacement(menuPlacement)), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), placement = _useState2[0], setPortalPlacement = _useState2[1];
    var portalPlacementContext = (0, $5FkrB.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState3 = (0, $5FkrB.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), computedPosition = _useState4[0], setComputedPosition = _useState4[1];
    var updateComputedPosition = (0, $5FkrB.useCallback)(function() {
        if (!controlElement) return;
        var rect = $6c86ba34c2a76faf$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $5FkrB.useLayoutEffect)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $5FkrB.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $6I9SI.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $5FkrB.useLayoutEffect)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $5FkrB.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // Legacy quirk: `computedPosition` is null until the layout effect runs,
    // so the first render returns null even with `defaultMenuIsOpen` set.
    // Synchronous observers (VR snapshots) see a one-frame "closed" state.
    // Left as-is; the top-layer path supersedes this and positions declaratively.
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    var _getStyleProps = (0, $76e70396aae85af8$export$26417cabd806a658)($6c86ba34c2a76faf$var$_objectSpread($6c86ba34c2a76faf$var$_objectSpread({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    // same wrapper element whether fixed or portalled
    var menuWrapper = /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $6c86ba34c2a76faf$var$menuPortalStyles.root,
            (0, $hUFig.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: $6c86ba34c2a76faf$var$_objectSpread({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': "".concat(computedPosition.rect.left, "px"),
            '--menu-position': menuPosition,
            '--menu-top': "".concat(computedPosition.offset, "px"),
            '--menu-width': "".concat(computedPosition.rect.width, "px")
        }, css)
    }, innerProps), children);
    return /*#__PURE__*/ $5FkrB.createElement((0, $180da3fc31e4fc57$export$e001f626511a0ead).Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $aLeHs.createPortal)(menuWrapper, appendTo) : menuWrapper);
}
var $6c86ba34c2a76faf$export$793392f970497feb = function MenuPortal(props) {
    if ((0, $d1213b7f4495d0bd$export$b40ec24ac8275656)('platform-dst-top-layer')) // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ $5FkrB.createElement((0, $dd8991b21c71137a$export$1f5427c7f5364d0b), props);
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ $5FkrB.createElement($6c86ba34c2a76faf$var$MenuPortalLegacy, props);
};


/* multi-value.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $25nEq = parcelRequire("25nEq");

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $iO8GM = parcelRequire("iO8GM");
var $84ab8a7b4c994752$export$75eee42ff540d8ae = function convertToMs(duration) {
    // Use regex to separate the number and the unit
    var matches = duration.match(/^(-?(?:\d+\.?\d*|\.\d+))(s|ms)$/);
    if (!matches) return 0; // Or return for invalid format
    var value = parseFloat(matches[1]);
    var unit = matches[2];
    if (unit === 's') return value * 1000; // Convert seconds to milliseconds
    else return value; // Already in milliseconds
};


var $e155209806dfe39f$var$cssTimePattern = /^-?(?:\d+\.?\d*|\.\d+)(?:ms|s)$/;
var $e155209806dfe39f$var$toCssList = function toCssList(value) {
    return value.split(',').map(function(item) {
        return item.trim();
    }).filter(Boolean);
};
var $e155209806dfe39f$var$toTimeList = function toTimeList(value) {
    return $e155209806dfe39f$var$toCssList(value).filter(function(time) {
        return $e155209806dfe39f$var$cssTimePattern.test(time);
    }).map((0, $84ab8a7b4c994752$export$75eee42ff540d8ae));
};
var $e155209806dfe39f$export$dd9b73a7482d05b6 = function getComputedAnimationDurationMs(animationName, animationDuration, animationDelay) {
    var names = $e155209806dfe39f$var$toCssList(animationName);
    var durations = $e155209806dfe39f$var$toTimeList(animationDuration);
    var delays = $e155209806dfe39f$var$toTimeList(animationDelay);
    if (names.length === 0 || durations.length === 0) return 0;
    var longestDuration = 0;
    for(var index = 0; index < names.length; index++){
        if (names[index] === 'none') continue;
        var duration = durations[index % durations.length];
        var delay = delays.length > 0 ? delays[index % delays.length] : 0;
        longestDuration = Math.max(longestDuration, duration + delay);
    }
    return longestDuration;
};



var $fC8ib = parcelRequire("fC8ib");
var $662e4aa5a36748e0$export$d0038b6e47881463 = function getDurationMs(animation) {
    var animations = animation.split(/,(?![^()]*\))/).map(function(value) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(value.trim().matchAll(/(-?\d*\.?\d+)(ms|s)\b/g));
    }).filter(function(matches) {
        return matches.length > 0;
    });
    if (animations.length === 0) return {
        duration: 0,
        delay: 0
    };
    return animations.reduce(function(longest, matches) {
        var toMilliseconds = function toMilliseconds(match) {
            var value = parseFloat(match[1]);
            return match[2] === 's' ? value * 1000 : value;
        };
        var timing = {
            duration: toMilliseconds(matches[0]),
            delay: matches[1] ? toMilliseconds(matches[1]) : 0
        };
        return timing.duration + timing.delay > longest.duration + longest.delay ? timing : longest;
    }, {
        duration: 0,
        delay: 0
    });
};


var $9d643134aa43b45f$export$c5406bd59b374abd = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};


var $93483474ccfd642b$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!(0, $9d643134aa43b45f$export$c5406bd59b374abd)()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};



var $lFhdZ = parcelRequire("lFhdZ");
var $94d6810711c949f0$export$82b92541889a035d = function resolveMotionToken(token) {
    var cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    var cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        var _getDocument;
        var documentElement = (_getDocument = (0, $lFhdZ.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};


/**
 * Supported reanimate values.
 * 'enter' will re-enter the animation.
 * 'exit-then-enter' will exit the animation and then enter it again.
 */ var $b8542b6fdf176d5c$export$569340a66b14e0dc = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    Reanimate["exit"] = "exit";
    return Reanimate;
}({});



var $5FkrB = parcelRequire("5FkrB");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $ISKn7 = parcelRequire("ISKn7");
var $cf50bd7e0ba5f92b$var$_process, $cf50bd7e0ba5f92b$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $cf50bd7e0ba5f92b$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($cf50bd7e0ba5f92b$var$_process = globalThis.process) === null || $cf50bd7e0ba5f92b$var$_process === void 0 || ($cf50bd7e0ba5f92b$var$_process = $cf50bd7e0ba5f92b$var$_process.env) === null || $cf50bd7e0ba5f92b$var$_process === void 0 ? void 0 : $cf50bd7e0ba5f92b$var$_process.JEST_WORKER_ID) !== undefined;
var $cf50bd7e0ba5f92b$var$DEBUG_MODE = !$cf50bd7e0ba5f92b$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($cf50bd7e0ba5f92b$var$_process2 = globalThis.process) === null || $cf50bd7e0ba5f92b$var$_process2 === void 0 || ($cf50bd7e0ba5f92b$var$_process2 = $cf50bd7e0ba5f92b$var$_process2.env) === null || $cf50bd7e0ba5f92b$var$_process2 === void 0 ? void 0 : $cf50bd7e0ba5f92b$var$_process2.NODE_ENV) !== 'production';
var $cf50bd7e0ba5f92b$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$cf50bd7e0ba5f92b$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $f73e3c1b82296114$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $f73e3c1b82296114$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
var $f73e3c1b82296114$export$75f4a1454eff2805 = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';


var $7fcc660b1c7cba9d$export$b574c24e1e6490f5 = (0, $f73e3c1b82296114$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $65b9bc6f349d9af7$export$92f8b531feaeb23d = (0, $f73e3c1b82296114$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $8591ef03d62319f4$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $8591ef03d62319f4$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$8591ef03d62319f4$export$54ea85357b4e0159[0, $f73e3c1b82296114$export$7e41b1b2bdee3f98] = $8591ef03d62319f4$export$54ea85357b4e0159[0, $f73e3c1b82296114$export$7e41b1b2bdee3f98] || $8591ef03d62319f4$var$DEFAULT_PFF_GLOBAL;



var $4c3a1b23f16fabf2$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $7fcc660b1c7cba9d$export$b574c24e1e6490f5) || (0, $65b9bc6f349d9af7$export$92f8b531feaeb23d);
function $4c3a1b23f16fabf2$export$6333b6aff9fc6275(flagKey) {
    if ($4c3a1b23f16fabf2$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $cf50bd7e0ba5f92b$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $f73e3c1b82296114$export$407f05df8e3ce9f3), flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = (0, $8591ef03d62319f4$export$54ea85357b4e0159)[0, $f73e3c1b82296114$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = (0, $8591ef03d62319f4$export$54ea85357b4e0159)[0, $f73e3c1b82296114$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $ISKn7.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = (0, $8591ef03d62319f4$export$54ea85357b4e0159)[0, $f73e3c1b82296114$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $141a81aefabb70a4$export$b40ec24ac8275656(name) {
    return (0, $4c3a1b23f16fabf2$export$6333b6aff9fc6275)(name);
}


/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $ed19d0339ebb4724$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isInsideExitingPersistence: false,
    isExiting: false
};
var $ed19d0339ebb4724$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $5FkrB.createContext)($ed19d0339ebb4724$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $ed19d0339ebb4724$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $ed19d0339ebb4724$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($ed19d0339ebb4724$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $ed19d0339ebb4724$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $ed19d0339ebb4724$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $ed19d0339ebb4724$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $ed19d0339ebb4724$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $ed19d0339ebb4724$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $ed19d0339ebb4724$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false,
            isInsideExitingPersistence: true
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false,
            isInsideExitingPersistence: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $ed19d0339ebb4724$var$childrenToArray(previousChildren);
    var current = $ed19d0339ebb4724$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var nextChildren = currentChildren !== children ? $ed19d0339ebb4724$var$childrenToArray(children) : current;
    var missingKeys = $ed19d0339ebb4724$var$getMissingKeys(nextChildren, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $ed19d0339ebb4724$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $141a81aefabb70a4$export$b40ec24ac8275656)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $ed19d0339ebb4724$var$wrapChildWithContextProvider(child, {
            appear: true,
            isInsideExitingPersistence: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $ed19d0339ebb4724$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$ed19d0339ebb4724$export$2e2bcd8739ae039 = $ed19d0339ebb4724$var$ExitingPersistence;
$ed19d0339ebb4724$var$ExitingPersistence.displayName = 'ExitingPersistence';


var $d5008e07cdf38957$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)((0, $ed19d0339ebb4724$export$b9c4904d7a6929e6));
};



var $5FkrB = parcelRequire("5FkrB");
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $40e66687e60043bd$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");

var $5FkrB = parcelRequire("5FkrB");
var $4fa5f8d27d6feaa3$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);


var $9e974ced8d5ef40d$export$5e65d7d58ae96ad8 = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $eVb4V.default)
    };
});
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $9e974ced8d5ef40d$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $4fa5f8d27d6feaa3$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($9e974ced8d5ef40d$export$5e65d7d58ae96ad8.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$9e974ced8d5ef40d$export$2e2bcd8739ae039 = $9e974ced8d5ef40d$var$StaggeredEntrance;


var $089b737bc62186c0$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var identifier = (0, $40e66687e60043bd$export$c485849f2e393253)();
    var context = (0, $5FkrB.useContext)((0, $9e974ced8d5ef40d$export$5e65d7d58ae96ad8));
    return context(identifier);
};


function $e06646f1bf60a3ed$export$2a51cfe9390d36ef() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, onFinishMotion = _ref.onFinish, initialState = _ref.initialState;
    var reducedMotion = (0, $93483474ccfd642b$export$b7baf7667a68d87c)();
    var staggered = (0, $089b737bc62186c0$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $d5008e07cdf38957$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var staggeredDelay = isExiting ? 0 : staggered.delay;
    var staggeredIsReady = staggered.isReady;
    var _useState = (0, $5FkrB.useState)(initialState !== null && initialState !== void 0 ? initialState : appear ? staggeredIsReady && !staggeredDelay ? 'entering' : 'init' : 'visible'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var elementRef = (0, $5FkrB.useRef)(null);
    var reanimateRef = (0, $5FkrB.useRef)();
    var animationRef = (0, $5FkrB.useRef)();
    var staggeredEntryRef = (0, $5FkrB.useRef)();
    (0, $5FkrB.useEffect)(function() {
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ var onAnimationEnd = (0, $5FkrB.useCallback)(function(currentState, cancelled) {
        // We are done animating, so we set the state to visible
        var newState = 'visible';
        if (currentState === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('exiting');
        }
        if (currentState === 'entering') onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('entering');
        if (reanimateRef.current === (0, $b8542b6fdf176d5c$export$569340a66b14e0dc).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $b8542b6fdf176d5c$export$569340a66b14e0dc).enter;
            newState = 'entering';
        } else if (reanimateRef.current === (0, $b8542b6fdf176d5c$export$569340a66b14e0dc).enter) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        else if (reanimateRef.current === (0, $b8542b6fdf176d5c$export$569340a66b14e0dc).exit) {
            // We are done reanimating, so we clear the reanimate state
            reanimateRef.current = undefined;
            newState = 'hidden';
        }
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    // Handles staggered entry
    (0, $5FkrB.useEffect)(function() {
        if (state !== 'init') return;
        if (reducedMotion) {
            onAnimationEnd('entering', false);
            return;
        }
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(function() {
            setState('entering');
        }, staggeredDelay);
        return function() {
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        onAnimationEnd,
        state,
        staggeredIsReady,
        staggeredDelay,
        reducedMotion
    ]);
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (!staggeredIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is visible, hidden or init, we don't need to do anything
        if (state === 'visible' || state === 'init' || state === 'hidden') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if (reducedMotion) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        var animationDuration = 0;
        if (state === 'entering' || state === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    var animationTimings = (0, $662e4aa5a36748e0$export$d0038b6e47881463)((0, $94d6810711c949f0$export$82b92541889a035d)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    var computedStyles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $e155209806dfe39f$export$dd9b73a7482d05b6)(computedStyles.animationName, computedStyles.animationDuration, computedStyles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting') animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration);
        else if (state === 'entering') animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration);
        return function() {
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        appear,
        staggeredDelay,
        staggeredIsReady,
        reducedMotion
    ]);
    var reanimate = (0, $5FkrB.useCallback)(function(value) {
        animationRef.current && clearTimeout(animationRef.current);
        reanimateRef.current = value;
        if (value === (0, $b8542b6fdf176d5c$export$569340a66b14e0dc).exit_then_enter) setState('exiting');
        else if (value === (0, $b8542b6fdf176d5c$export$569340a66b14e0dc).enter) setState('entering');
        else if (value === (0, $b8542b6fdf176d5c$export$569340a66b14e0dc).exit) setState('exiting');
    }, []);
    var ref = (0, $iO8GM.default)([
        staggered.ref,
        elementRef
    ]);
    return {
        ref: ref,
        reanimate: reanimate,
        state: state
    };
}



/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $25nEq = parcelRequire("25nEq");

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ISKn7 = parcelRequire("ISKn7");
var $0ffbdb99a9a3c1ac$var$_process, $0ffbdb99a9a3c1ac$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $0ffbdb99a9a3c1ac$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($0ffbdb99a9a3c1ac$var$_process = globalThis.process) === null || $0ffbdb99a9a3c1ac$var$_process === void 0 || ($0ffbdb99a9a3c1ac$var$_process = $0ffbdb99a9a3c1ac$var$_process.env) === null || $0ffbdb99a9a3c1ac$var$_process === void 0 ? void 0 : $0ffbdb99a9a3c1ac$var$_process.JEST_WORKER_ID) !== undefined;
var $0ffbdb99a9a3c1ac$var$DEBUG_MODE = !$0ffbdb99a9a3c1ac$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($0ffbdb99a9a3c1ac$var$_process2 = globalThis.process) === null || $0ffbdb99a9a3c1ac$var$_process2 === void 0 || ($0ffbdb99a9a3c1ac$var$_process2 = $0ffbdb99a9a3c1ac$var$_process2.env) === null || $0ffbdb99a9a3c1ac$var$_process2 === void 0 ? void 0 : $0ffbdb99a9a3c1ac$var$_process2.NODE_ENV) !== 'production';
var $0ffbdb99a9a3c1ac$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$0ffbdb99a9a3c1ac$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $a8e8e274a22539d5$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $a8e8e274a22539d5$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
var $a8e8e274a22539d5$export$75f4a1454eff2805 = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';


var $31165b398711390a$export$b574c24e1e6490f5 = (0, $a8e8e274a22539d5$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $7e8489f0df44418f$export$92f8b531feaeb23d = (0, $a8e8e274a22539d5$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $373cae7b164d5d45$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $373cae7b164d5d45$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$373cae7b164d5d45$export$54ea85357b4e0159[0, $a8e8e274a22539d5$export$7e41b1b2bdee3f98] = $373cae7b164d5d45$export$54ea85357b4e0159[0, $a8e8e274a22539d5$export$7e41b1b2bdee3f98] || $373cae7b164d5d45$var$DEFAULT_PFF_GLOBAL;



var $3f4be739283d3790$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $31165b398711390a$export$b574c24e1e6490f5) || (0, $7e8489f0df44418f$export$92f8b531feaeb23d);
function $3f4be739283d3790$export$6333b6aff9fc6275(flagKey) {
    if ($3f4be739283d3790$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $0ffbdb99a9a3c1ac$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $a8e8e274a22539d5$export$407f05df8e3ce9f3), flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = (0, $373cae7b164d5d45$export$54ea85357b4e0159)[0, $a8e8e274a22539d5$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = (0, $373cae7b164d5d45$export$54ea85357b4e0159)[0, $a8e8e274a22539d5$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $ISKn7.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = (0, $373cae7b164d5d45$export$54ea85357b4e0159)[0, $a8e8e274a22539d5$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $c418527da89031bf$export$b40ec24ac8275656(name) {
    return (0, $3f4be739283d3790$export$6333b6aff9fc6275)(name);
}



var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $664fafc3043e067a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $664fafc3043e067a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $664fafc3043e067a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $664fafc3043e067a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $664fafc3043e067a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $664fafc3043e067a$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $664fafc3043e067a$var$_objectSpread($664fafc3043e067a$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $dff2224ff41f79a7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dff2224ff41f79a7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dff2224ff41f79a7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dff2224ff41f79a7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dff2224ff41f79a7$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $dff2224ff41f79a7$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $dff2224ff41f79a7$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dff2224ff41f79a7$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $dff2224ff41f79a7$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $dff2224ff41f79a7$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $dff2224ff41f79a7$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            var payload = $dff2224ff41f79a7$var$clonePayload(_this.payload);
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $dff2224ff41f79a7$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $664fafc3043e067a$export$2e2bcd8739ae039));
var $dff2224ff41f79a7$var$clonePayload = function clonePayload(payload) {
    if ((0, $c418527da89031bf$export$b40ec24ac8275656)('platform-analytics-next-safe-clone')) try {
        return JSON.parse(JSON.stringify(payload));
    } catch (e) {
        // Shallow clone keeps the event usable without crashing the UI.
        return $dff2224ff41f79a7$var$_objectSpread({}, payload);
    }
    /**
   * A hacky "deep clone" of the object. This is limited in that it wont
   * support functions, regexs, Maps, Sets, etc, but none of those need to
   * be represented in our payload.
   */ return JSON.parse(JSON.stringify(payload));
};



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $9d785883869faef0$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $8439cf9a438f95d2$export$5bf35293e545f20c() {
    var analyticsContext = (0, $9d785883869faef0$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $dff2224ff41f79a7$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $18851e77d4fe9651$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


var $71149abdde46dc7d$export$53c2b9c37c40e0d8 = function useCallbackWithAnalytics(method, payload, channel) {
    var _useAnalyticsEvents = (0, $8439cf9a438f95d2$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var methodRef = (0, $18851e77d4fe9651$export$1d27a74659855e44)(method);
    var payloadRef = (0, $18851e77d4fe9651$export$1d27a74659855e44)(payload);
    return (0, $5FkrB.useCallback)(function() {
        var pload = typeof payloadRef.current === 'function' ? payloadRef.current.apply(payloadRef, arguments) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current.apply(methodRef, arguments);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};



var $iO8GM = parcelRequire("iO8GM");

var $eVb4V = parcelRequire("eVb4V");

var $5supy = parcelRequire("5supy");

var $iYJcE = parcelRequire("iYJcE");
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $0b0c02d8e78cd129$export$368bacef0dacbe05 = 25;
var $0b0c02d8e78cd129$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};




var $5FkrB = parcelRequire("5FkrB");
var $cb476eae2582014a$export$ff879f35a69d56b7 = function useElementRef() {
    var elementRef = (0, $5FkrB.useRef)(null);
    var setRef = (0, $5FkrB.useCallback)(function(ref) {
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};




var $5FkrB = parcelRequire("5FkrB");
var $1cc562c5e76627e9$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $1cc562c5e76627e9$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $1cc562c5e76627e9$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};



var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $2db9a0b6d80f86de$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $2db9a0b6d80f86de$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $2db9a0b6d80f86de$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};



/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $695d5afa5e5793f0$var$ShrinkOut = function ShrinkOut(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'small' : _ref$duration, onFinish = _ref.onFinish;
    var _useElementRef = (0, $cb476eae2582014a$export$ff879f35a69d56b7)(), _useElementRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useElementRef, 2), element = _useElementRef2[0], setElementRef = _useElementRef2[1];
    var exiting = (0, $d5008e07cdf38957$export$3b6f38abbdcbd000)();
    var requestAnimationFrame = (0, $1cc562c5e76627e9$export$1775f27e7c8051ca)();
    var setTimeout = (0, $2db9a0b6d80f86de$export$4f34107a2b00f39c)();
    var direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $4fa5f8d27d6feaa3$export$e5c5a5f917a5871c)(function() {
        if (exiting.isExiting && element) {
            if ((0, $93483474ccfd642b$export$b7baf7667a68d87c)()) {
                exiting.onFinish && exiting.onFinish();
                onFinish && onFinish('exiting');
                return;
            }
            var newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: "".concat(element.offsetWidth, "px"),
                height: "".concat(element.offsetHeight, "px"),
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    var newStyles = {
                        width: '0px',
                        margin: '0px',
                        // We animate margin down to zero so it doesn't take any space.
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $0b0c02d8e78cd129$export$38b928a7167ce124)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(function() {
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $0b0c02d8e78cd129$export$38b928a7167ce124)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $695d5afa5e5793f0$export$2e2bcd8739ae039 = $695d5afa5e5793f0$var$ShrinkOut;



/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // Color mapping from old color names to new color names
var $a69bed3d91b1030e$export$3351a8d90bcc13aa = {
    standard: 'gray',
    grey: 'gray',
    blue: 'blue',
    green: 'green',
    red: 'red',
    yellow: 'yellow',
    purple: 'purple',
    lime: 'lime',
    magenta: 'magenta',
    orange: 'orange',
    teal: 'teal',
    // Light variants map to same as their non-light counterparts
    greyLight: 'gray',
    blueLight: 'blue',
    greenLight: 'green',
    redLight: 'red',
    yellowLight: 'yellow',
    purpleLight: 'purple',
    limeLight: 'lime',
    magentaLight: 'magenta',
    orangeLight: 'orange',
    tealLight: 'teal'
};


// Intentionally scoped to the UI-uplifted TagNew implementation.
var $f087a33d0f3a259a$export$7d100de1166870f6 = function getTagText(text) {
    return Array.isArray(text) ? text.join('') : text;
};


/* tag-new.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $h19KG = parcelRequire("h19KG");


var $btdNC = parcelRequire("btdNC");

var $9ztDu = parcelRequire("9ztDu");



var $5FkrB = parcelRequire("5FkrB");
function $62b0adc16e7fe663$export$ce4b6a469c26f53f(_ref) {
    var isLink = _ref.isLink, href = _ref.href, LinkComponent = _ref.LinkComponent, testId = _ref.testId, children = _ref.children, onClick = _ref.onClick, linkHandlers = _ref.linkHandlers;
    if (isLink && href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LinkComponent, {
        href: href,
        testId: testId ? "".concat(testId, "--link") : undefined,
        onClick: onClick,
        onMouseEnter: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseEnter,
        onMouseLeave: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseLeave,
        onMouseDown: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseDown,
        onFocus: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onFocus,
        onBlur: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onBlur
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, children);
}


/* removable-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ /**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

// Tag status enum
var $f1a38fe45784338e$export$74452314b63acabc = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}({});


/**
 * Stable key so ExitingPersistence can match this child across the remove transition
 * (see ShrinkOut + ExitingPersistence docs in @atlaskit/motion).
 */ var $b012088b2f24c41a$var$removableShrinkOutChildKey = 'atlaskit-tag-removable-shrink-out';
var $b012088b2f24c41a$var$motionWrapperStyles = null;
function $b012088b2f24c41a$export$898a500849bb5cf4(_ref) {
    var isRemovable = _ref.isRemovable, status = _ref.status, onShrinkOutExitComplete = _ref.onShrinkOutExitComplete, children = _ref.children;
    if (isRemovable) return /*#__PURE__*/ $5FkrB.createElement((0, $ed19d0339ebb4724$export$2e2bcd8739ae039), null, !(status === (0, $f1a38fe45784338e$export$74452314b63acabc).Removed) && /*#__PURE__*/ $5FkrB.createElement((0, $695d5afa5e5793f0$export$2e2bcd8739ae039), {
        key: $b012088b2f24c41a$var$removableShrinkOutChildKey,
        onFinish: onShrinkOutExitComplete ? function(phase) {
            if (phase === 'exiting') onShrinkOutExitComplete();
        } : undefined
    }, function(motion) {
        return /*#__PURE__*/ $5FkrB.createElement("span", {
            ref: motion.ref,
            className: (0, $970q7.default)([
                "_1e0c116y"
            ])
        }, children);
    }));
    return children;
}


var $58757bd38e26f900$var$tagMotionCapability = Symbol.for('@atlaskit/tag/motion-capable');
function $58757bd38e26f900$export$88b132e52a65ec37(component) {
    Object.defineProperty(component, $58757bd38e26f900$var$tagMotionCapability, {
        value: true
    });
    return component;
}


/* swatch-before.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $7fa22b9389c08f5c$var$tagSwatchBeforeStyles = {
    swatch: "_2rkolb4i _1bsboqnp _4t3ioqnp _1o9zidpf"
};
var $7fa22b9389c08f5c$var$tagSwatchBeforeColorStyles = {
    gray: "_bfhk18j9",
    blue: "_bfhk115i",
    green: "_bfhk1rsu",
    red: "_bfhkkrt9",
    yellow: "_bfhk8y3s",
    purple: "_bfhk18ah",
    lime: "_bfhkbq5w",
    magenta: "_bfhk1mi6",
    orange: "_bfhk1kkj",
    teal: "_bfhktdv8"
};
function $7fa22b9389c08f5c$export$2e2bcd8739ae039(_ref) {
    var colorKey = _ref.colorKey, swatchBefore = _ref.swatchBefore, swatchBeforeLabel = _ref.swatchBeforeLabel, swatchBeforeRole = _ref.swatchBeforeRole;
    if (swatchBefore === undefined || swatchBefore === false) return null;
    if (swatchBefore === true) return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, swatchBeforeLabel && swatchBeforeRole ? {
        'aria-label': swatchBeforeLabel,
        role: swatchBeforeRole
    } : {}, {
        className: (0, $970q7.default)([
            $7fa22b9389c08f5c$var$tagSwatchBeforeStyles.swatch,
            $7fa22b9389c08f5c$var$tagSwatchBeforeColorStyles[colorKey]
        ])
    }));
    return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, swatchBeforeLabel && swatchBeforeRole ? {
        'aria-label': swatchBeforeLabel,
        role: swatchBeforeRole
    } : {}, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            backgroundColor: swatchBefore
        },
        className: (0, $970q7.default)([
            $7fa22b9389c08f5c$var$tagSwatchBeforeStyles.swatch
        ])
    }));
}


/* tag-motion.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");


var $iO8GM = parcelRequire("iO8GM");





var $9ce11187bd92fe0e$var$tagMotionKey = 'atlaskit-tag-motion';
function $9ce11187bd92fe0e$var$TagMotionContent(_ref) {
    var children = _ref.children, forwardedRef = _ref.forwardedRef, onExitComplete = _ref.onExitComplete;
    var _useMotion = (0, $e06646f1bf60a3ed$export$2a51cfe9390d36ef)({
        onFinish: function onFinish(phase) {
            if (phase === 'exiting') onExitComplete === null || onExitComplete === void 0 || onExitComplete();
        }
    }), motionRef = _useMotion.ref, state = _useMotion.state;
    var mergedRef = (0, $5FkrB.useMemo)(function() {
        return (0, $iO8GM.default)([
            forwardedRef,
            motionRef
        ]);
    }, [
        forwardedRef,
        motionRef
    ]);
    return children({
        isEntering: state === 'entering',
        isExiting: state === 'exiting',
        ref: mergedRef
    });
}
function $9ce11187bd92fe0e$export$6adae1772ccf137c(_ref2) {
    var children = _ref2.children, forwardedRef = _ref2.forwardedRef, onExitComplete = _ref2.onExitComplete, status = _ref2.status;
    var hasCompletedReducedMotionExit = (0, $5FkrB.useRef)(false);
    var outerPresence = (0, $d5008e07cdf38957$export$3b6f38abbdcbd000)();
    var isRemoved = status === (0, $f1a38fe45784338e$export$74452314b63acabc).Removed || outerPresence.isExiting;
    var shouldAppear = outerPresence.isInsideExitingPersistence && outerPresence.appear && !outerPresence.isExiting;
    var latestExitState = (0, $5FkrB.useRef)({
        onExitComplete: onExitComplete,
        outerPresence: outerPresence,
        status: status
    });
    latestExitState.current = {
        onExitComplete: onExitComplete,
        outerPresence: outerPresence,
        status: status
    };
    var onMotionExitComplete = (0, $5FkrB.useCallback)(function() {
        var latest = latestExitState.current;
        if (latest.outerPresence.isExiting) {
            var _latest$outerPresence, _latest$outerPresence2;
            (_latest$outerPresence = (_latest$outerPresence2 = latest.outerPresence).onFinish) === null || _latest$outerPresence === void 0 || _latest$outerPresence.call(_latest$outerPresence2);
        }
        if (latest.status === (0, $f1a38fe45784338e$export$74452314b63acabc).Removed) {
            var _latest$onExitComplet;
            (_latest$onExitComplet = latest.onExitComplete) === null || _latest$onExitComplet === void 0 || _latest$onExitComplet.call(latest);
        }
    }, []);
    (0, $5FkrB.useEffect)(function() {
        if (isRemoved && (0, $93483474ccfd642b$export$b7baf7667a68d87c)() && !hasCompletedReducedMotionExit.current) {
            hasCompletedReducedMotionExit.current = true;
            onMotionExitComplete();
        }
    }, [
        isRemoved,
        onMotionExitComplete
    ]);
    return /*#__PURE__*/ $5FkrB.createElement((0, $ed19d0339ebb4724$export$2e2bcd8739ae039), {
        appear: shouldAppear
    }, !isRemoved && /*#__PURE__*/ $5FkrB.createElement($9ce11187bd92fe0e$var$TagMotionContent, {
        key: $9ce11187bd92fe0e$var$tagMotionKey,
        forwardedRef: forwardedRef,
        onExitComplete: onMotionExitComplete
    }, children));
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $b12749e4c5953961$export$84acd183858d8235() {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isLinkHovered = _useState2[0], setIsLinkHovered = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), isOverButton = _useState4[0], setIsOverButton = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), isButtonFocused = _useState6[0], setIsButtonFocused = _useState6[1];
    var _useState7 = (0, $5FkrB.useState)(false), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState7, 2), isLinkFocused = _useState8[0], setIsLinkFocused = _useState8[1];
    // Track if last interaction was via mouse (to determine keyboard vs mouse focus)
    var hadMouseDownRef = (0, $5FkrB.useRef)(false);
    // Button handlers
    var buttonHandlers = (0, $5FkrB.useMemo)(function() {
        return {
            onMouseEnter: function onMouseEnter() {
                return setIsOverButton(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setIsOverButton(false);
            },
            onMouseDown: function onMouseDown(e) {
                // Prevent the browser from moving focus to the remove button on mousedown.
                // Without this, parent composite widgets (e.g. Select) lose input focus when
                // the user clicks remove, triggering unwanted blur side-effects.
                e === null || e === void 0 || e.preventDefault();
                hadMouseDownRef.current = true;
            },
            onFocus: function onFocus() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsButtonFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function onBlur() {
                return setIsButtonFocused(false);
            }
        };
    }, []);
    // Link handlers - includes hover tracking
    var linkHandlers = (0, $5FkrB.useMemo)(function() {
        return {
            onMouseEnter: function onMouseEnter() {
                return setIsLinkHovered(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setIsLinkHovered(false);
            },
            onMouseDown: function onMouseDown() {
                hadMouseDownRef.current = true;
            },
            onFocus: function onFocus() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsLinkFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function onBlur() {
                return setIsLinkFocused(false);
            }
        };
    }, []);
    return {
        isLinkHovered: isLinkHovered,
        isOverButton: isOverButton,
        isButtonFocused: isButtonFocused,
        isLinkFocused: isLinkFocused,
        buttonHandlers: buttonHandlers,
        linkHandlers: linkHandlers
    };
}



var $8F9hT = parcelRequire("8F9hT");
function $5b4b102190452ab7$export$dcf14c9974fe2767(href, linkComponent) {
    var isLink = Boolean(href);
    var LinkComponent = linkComponent !== null && linkComponent !== void 0 ? linkComponent : (0, $8F9hT.default);
    return {
        isLink: isLink,
        LinkComponent: LinkComponent
    };
}


/**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $5FkrB = parcelRequire("5FkrB");
/* remove-button.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");


var $hRJ5R = parcelRequire("hRJ5R");

var $ac8VW = parcelRequire("ac8VW");


var $btdNC = parcelRequire("btdNC");
var $13e920922a058ca2$var$removeButtonStyles = {
    root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i1j6v _1bsb1j6v _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah3idpf _irr31dpa _1di6fcek",
    circle: "_2rko1rr0 _1ah3idpf",
    focusRing: "_1ah3v77o",
    newIcon: "_rjxpv77o"
};
var $13e920922a058ca2$var$RemoveButton = function RemoveButton(_ref) {
    var ariaLabel = _ref['aria-label'], onClick = _ref.onClick, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onKeyPress = _ref.onKeyPress, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onMouseDown = _ref.onMouseDown, onMouseUp = _ref.onMouseUp, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, testId = _ref.testId, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? 'default' : _ref$shape;
    return /*#__PURE__*/ $5FkrB.createElement((0, $btdNC.Pressable), {
        xcss: (0, $hRJ5R.cx)($13e920922a058ca2$var$removeButtonStyles.root, shape === 'circle' && $13e920922a058ca2$var$removeButtonStyles.circle, $13e920922a058ca2$var$removeButtonStyles.newIcon, (0, $c418527da89031bf$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts') && $13e920922a058ca2$var$removeButtonStyles.focusRing),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: testId
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ac8VW))), {
        color: "currentColor",
        label: "",
        size: "small"
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$13e920922a058ca2$export$2e2bcd8739ae039 = $13e920922a058ca2$var$RemoveButton;


function $cf64d9e106756cc7$export$97d8be09cd53869b(_ref) {
    var isRemovable = _ref.isRemovable, tagText = _ref.tagText, removeButtonLabel = _ref.removeButtonLabel, testId = _ref.testId, handleRemoveRequest = _ref.handleRemoveRequest, removingTag = _ref.removingTag, showingTag = _ref.showingTag, onKeyPress = _ref.onKeyPress, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? 'default' : _ref$shape, buttonHandlers = _ref.buttonHandlers;
    var handleFocus = (0, $5FkrB.useCallback)(function() {
        removingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onFocus();
    }, [
        removingTag,
        buttonHandlers
    ]);
    var handleBlur = (0, $5FkrB.useCallback)(function() {
        showingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onBlur();
    }, [
        showingTag,
        buttonHandlers
    ]);
    return (0, $5FkrB.useMemo)(function() {
        if (!isRemovable) return undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $13e920922a058ca2$export$2e2bcd8739ae039), {
            "aria-label": "".concat(removeButtonLabel || 'Remove', " ").concat(tagText),
            onClick: handleRemoveRequest,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyPress: onKeyPress,
            onMouseEnter: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseEnter,
            onMouseLeave: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseLeave,
            onMouseDown: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseDown,
            testId: testId ? "close-button-".concat(testId) : undefined,
            shape: shape
        });
    }, [
        isRemovable,
        removeButtonLabel,
        tagText,
        handleRemoveRequest,
        handleFocus,
        handleBlur,
        onKeyPress,
        buttonHandlers,
        testId,
        shape
    ]);
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
var $fb74f8594d126a5e$export$279e7025ed114474 = function defaultBeforeRemoveAction() {
    return true;
};



function $fb6326a89dc5ca94$export$f26019543e9f862f(onBeforeRemoveAction) {
    var _useState = (0, $5FkrB.useState)((0, $f1a38fe45784338e$export$74452314b63acabc).Showing), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var handleRemoveRequest = (0, $5FkrB.useCallback)(function() {
        var beforeAction = onBeforeRemoveAction !== null && onBeforeRemoveAction !== void 0 ? onBeforeRemoveAction : (0, $fb74f8594d126a5e$export$279e7025ed114474);
        if (beforeAction()) // Defer onAfterRemoveAction until ShrinkOut's onFinish so ExitingPersistence can run
        // the exit animation (e.g. in multi-select and user pickers).
        setStatus((0, $f1a38fe45784338e$export$74452314b63acabc).Removed);
    }, [
        onBeforeRemoveAction
    ]);
    var onKeyPress = (0, $5FkrB.useCallback)(function(e) {
        var spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    var removingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus((0, $f1a38fe45784338e$export$74452314b63acabc).Removing);
    }, []);
    var showingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus((0, $f1a38fe45784338e$export$74452314b63acabc).Showing);
    }, []);
    return {
        status: status,
        handleRemoveRequest: handleRemoveRequest,
        onKeyPress: onKeyPress,
        removingTag: removingTag,
        showingTag: showingTag
    };
}


var $1c1839299defbb35$var$_excluded = [
    "color",
    "text",
    "elemBefore",
    "href",
    "linkComponent",
    "isRemovable",
    "removeButtonLabel",
    "onBeforeRemoveAction",
    "onAfterRemoveAction",
    "testId",
    "maxWidth",
    "hasMargin",
    "onClick",
    "swatchBefore",
    "swatchBeforeLabel",
    "swatchBeforeRole",
    "trailingMetric"
], $1c1839299defbb35$var$_excluded2 = [
    "color",
    "text",
    "elemBefore",
    "testId",
    "maxWidth",
    "hasMargin",
    "onClick",
    "isSelected",
    "isLoading",
    "analyticsContext",
    "hasChevron",
    "swatchBefore",
    "swatchBeforeLabel",
    "swatchBeforeRole",
    "trailingMetric"
];
var $1c1839299defbb35$var$styles = {
    baseStyles: "_zulp1b66 _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1rjcv77o _18zr1mie _1mou1b66 _195g1b66 _1e0c116y _vchhusvi _1ul9idpf _p12ff6dh _4t3i1k92 _kqswh2mm _4cvr1h6o _80om73ad _bfhksm61",
    noMarginStyles: "_1mouze3t _195gze3t",
    removableStyles: "_zulp1b66",
    beforeStyles: "_4bfu1snc _1hmsagmp _ajmmvv82 _1e0c116y _4cvr1h6o _1o9zidpf _syaz125o",
    beforeStylesSelected: "_syazxl6c",
    textStyles: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n _1ul9idpf _syazi7uo",
    textStylesSelected: "_syaz6x5g",
    afterStyles: "_1e0c1txw _4cvr1h6o _1o9zidpf _lcxv1wug _kqswh2mm",
    afterMotionStyles: "_1ul9utpp",
    trailingMetric: "_2rkolb4i _11c8wadc _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _4cvr1h6o _1o9zidpf _1kz6184x _bfhk1w9g _syazi7uo",
    trailingMetricEndPadding: "_y4ti303w",
    focusRingStyles: "_1ygbdfik _1ah3v77o",
    childFocusRingStyles: "_1a37dfik _1cwgv77o",
    interactiveBaseStyles: "_80omtlke _1all1b66 _qsdj1r31 _17ncglyw _15hpnqa1 _1rg815vq _1yoo15vq _j8j91snc _1afaagmp _gdbt10yn _h5vp116y _1qxz1h6o _8zx0idpf _1km4jdj5 _wc1fagmp _9408jdj5 _usew1snc _ebtnagmp _uvk910yn _10nj1r31 _1xq0glyw _18x1nqa1 _2mpsagmp",
    interactiveHoverStyles: "_17501r31 _qrsc8stv _1wodnqa1 _irr31dpa _rlyhjdj5 _1di6fcek",
    interactiveMotionStyles: "_v564k6bl _1ggl5xtf",
    activeMotionStyles: "_1reo15vq _18m915vq _8hrz1e5h",
    enteringMotionStyles: "_y44v1ukz _1bumglyw",
    exitingMotionStyles: "_y44v12ef _1bumglyw"
};
// For accent borders, we use the new color.border.accent.*.subtle tokens (Color300
// light / Color800 dark) which provide proper decorative-border colours
//
// Icons keep color.icon.accent.* in the default state (vibrant on the plain page
// background) and swap to color.text.accent.* in hovered/pressed states (where the
// Tag picks up a coloured background and needs guaranteed 3:1 icon contrast).
var $1c1839299defbb35$var$colorStyles = {
    gray: "_119bmsup _1ib21diz _egnk1sqi _17x31sqi _ih6z7qp0",
    blue: "_119b18hp _1ib26txe _egnk16jw _17x316jw _ih6z1dy8",
    green: "_119b5d2u _1ib217hp _egnkh55r _17x3h55r _ih6z1wnw",
    red: "_119bn9dc _1ib2nbxb _egnk9lu1 _17x39lu1 _ih6z1rtt",
    yellow: "_119b1s7j _1ib21oqg _egnkfb2s _17x3fb2s _ih6z1773",
    purple: "_119bluwt _1ib2uq3u _egnkqmo9 _17x3qmo9 _ih6z1nm4",
    lime: "_119b1m7d _1ib28645 _egnk1tco _17x31tco _ih6zz2ec",
    magenta: "_119b132u _1ib2v8hk _egnk1s8m _17x31s8m _ih6zv9ra",
    orange: "_119b1ip5 _1ib21j6y _egnkp1lv _17x3p1lv _ih6z165s",
    teal: "_119b131p _1ib28uof _egnk17qg _17x317qg _ih6z1a17"
};
// Border + icon filter styles - base state.
// Borders use the new color.border.accent.*.subtle tokens directly.
// Icons use the color.icon.accent.* tokens directly in the default state.
var $1c1839299defbb35$var$borderIconFilterStyles = {
    root: "_1h6dip4g _wi6h9ea2"
};
// Border + icon filter styles - interactive states (hover/pressed).
// Icons swap to the color.text.accent.* tokens for guaranteed 3:1 contrast
// against the coloured interactive backgrounds. Borders stay constant.
var $1c1839299defbb35$var$borderIconInteractiveFilterStyles = {
    root: "_4cvxip4g _zqoiipvw _q4ztip4g _ba35u0j8"
};
var $1c1839299defbb35$var$dropdownStyles = {
    interactive: "_irr31dpa _1di6fcek",
    selected: "_1h6dq98m _syaz6x5g _bfhk15s3 _irr3ufnl _1di6nozp",
    content: "_zulp1b66 _1reo15vq _18m915vq _1e0c116y _4cvr1h6o _16jlkb7n _1o9zkb7n _1ul9idpf",
    loadingMotion: "_k8m0brmi _1oec1ign _6fl4indk _sedtglyw",
    loadingOverlayMotion: "_j7hq1bym _5sag1ign _1pglindk _1bumglyw",
    loadingContent: "_tzy4idpf",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw"
};
/**
 * __TagNew__
 *
 * TagNew is the visual uplift implementation of Tag
 */ var $1c1839299defbb35$var$TagNewComponent = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TagNew(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'gray' : _ref$color, text = _ref.text, elemBefore = _ref.elemBefore, href = _ref.href, linkComponent = _ref.linkComponent, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, removeButtonLabel = _ref.removeButtonLabel, onBeforeRemoveAction = _ref.onBeforeRemoveAction, onAfterRemoveAction = _ref.onAfterRemoveAction, testId = _ref.testId, maxWidth = _ref.maxWidth, _ref$hasMargin = _ref.hasMargin, hasMargin = _ref$hasMargin === void 0 ? true : _ref$hasMargin, onClick = _ref.onClick, swatchBefore = _ref.swatchBefore, swatchBeforeLabel = _ref.swatchBeforeLabel, swatchBeforeRole = _ref.swatchBeforeRole, trailingMetric = _ref.trailingMetric, other = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $1c1839299defbb35$var$_excluded);
    var normalizedText = (0, $f087a33d0f3a259a$export$7d100de1166870f6)(text);
    var _useTagRemoval = (0, $fb6326a89dc5ca94$export$f26019543e9f862f)(onBeforeRemoveAction), status = _useTagRemoval.status, handleRemoveRequest = _useTagRemoval.handleRemoveRequest, onKeyPress = _useTagRemoval.onKeyPress, removingTag = _useTagRemoval.removingTag, showingTag = _useTagRemoval.showingTag;
    var onShrinkOutExitComplete = (0, $5FkrB.useCallback)(function() {
        onAfterRemoveAction === null || onAfterRemoveAction === void 0 || onAfterRemoveAction(normalizedText);
    }, [
        normalizedText,
        onAfterRemoveAction
    ]);
    var _useLink = (0, $5b4b102190452ab7$export$dcf14c9974fe2767)(href, linkComponent), isLink = _useLink.isLink, LinkComponent = _useLink.LinkComponent;
    var _useButtonInteraction = (0, $b12749e4c5953961$export$84acd183858d8235)(), isLinkHovered = _useButtonInteraction.isLinkHovered, isOverButton = _useButtonInteraction.isOverButton, isButtonFocused = _useButtonInteraction.isButtonFocused, isLinkFocused = _useButtonInteraction.isLinkFocused, buttonHandlers = _useButtonInteraction.buttonHandlers, linkHandlers = _useButtonInteraction.linkHandlers;
    var removeButton = (0, $cf64d9e106756cc7$export$97d8be09cd53869b)({
        isRemovable: isRemovable,
        tagText: normalizedText,
        removeButtonLabel: removeButtonLabel,
        testId: testId,
        handleRemoveRequest: handleRemoveRequest,
        removingTag: removingTag,
        showingTag: showingTag,
        onKeyPress: onKeyPress,
        buttonHandlers: buttonHandlers
    });
    var isMotionEnabled = (0, $c418527da89031bf$export$b40ec24ac8275656)('platform-dst-motion-uplift-labels');
    var renderTagContent = function renderTagContent(tagRef) {
        var isEntering = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var isExiting = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, other, {
            ref: tagRef,
            "data-testid": testId,
            style: maxWidth !== undefined ? {
                maxWidth: maxWidth
            } : undefined,
            className: (0, $970q7.default)([
                $1c1839299defbb35$var$styles.baseStyles,
                !hasMargin && $1c1839299defbb35$var$styles.noMarginStyles,
                $1c1839299defbb35$var$colorStyles[color],
                $1c1839299defbb35$var$borderIconFilterStyles.root,
                isLink && $1c1839299defbb35$var$styles.interactiveBaseStyles,
                isLink && $1c1839299defbb35$var$styles.focusRingStyles,
                isLink && isMotionEnabled && $1c1839299defbb35$var$styles.interactiveMotionStyles,
                (isEntering || isExiting) && $1c1839299defbb35$var$styles.activeMotionStyles,
                isEntering && $1c1839299defbb35$var$styles.enteringMotionStyles,
                isExiting && $1c1839299defbb35$var$styles.exitingMotionStyles,
                isLink && isLinkHovered && !isOverButton && $1c1839299defbb35$var$borderIconInteractiveFilterStyles.root,
                isLink && isLinkHovered && !isOverButton && $1c1839299defbb35$var$styles.interactiveHoverStyles,
                isRemovable && $1c1839299defbb35$var$styles.removableStyles,
                isLinkFocused && !isButtonFocused && $1c1839299defbb35$var$styles.childFocusRingStyles,
                !isRemovable && trailingMetric != null && trailingMetric !== '' && $1c1839299defbb35$var$styles.trailingMetricEndPadding
            ])
        }), /*#__PURE__*/ $5FkrB.createElement((0, $62b0adc16e7fe663$export$ce4b6a469c26f53f), {
            isLink: isLink,
            href: href,
            LinkComponent: LinkComponent,
            testId: testId,
            linkHandlers: linkHandlers,
            onClick: onClick
        }, /*#__PURE__*/ $5FkrB.createElement((0, $7fa22b9389c08f5c$export$2e2bcd8739ae039), {
            colorKey: color,
            swatchBefore: swatchBefore,
            swatchBeforeLabel: swatchBeforeLabel,
            swatchBeforeRole: swatchBeforeRole
        }), elemBefore && /*#__PURE__*/ $5FkrB.createElement("span", {
            className: (0, $970q7.default)([
                $1c1839299defbb35$var$styles.beforeStyles
            ])
        }, elemBefore), /*#__PURE__*/ $5FkrB.createElement("span", {
            "data-tag-text": true,
            className: (0, $970q7.default)([
                $1c1839299defbb35$var$styles.textStyles
            ])
        }, normalizedText), trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ $5FkrB.createElement("span", {
            "data-testid": testId && "".concat(testId, "--metric"),
            className: (0, $970q7.default)([
                $1c1839299defbb35$var$styles.trailingMetric
            ])
        }, trailingMetric)), removeButton && /*#__PURE__*/ $5FkrB.createElement("span", {
            className: (0, $970q7.default)([
                $1c1839299defbb35$var$styles.afterStyles,
                isMotionEnabled && $1c1839299defbb35$var$styles.afterMotionStyles
            ])
        }, !isExiting && removeButton));
    };
    if (isMotionEnabled) return /*#__PURE__*/ $5FkrB.createElement((0, $9ce11187bd92fe0e$export$6adae1772ccf137c), {
        forwardedRef: ref,
        onExitComplete: isRemovable ? onShrinkOutExitComplete : undefined,
        status: status
    }, function(_ref2) {
        var isEntering = _ref2.isEntering, isExiting = _ref2.isExiting, motionRef = _ref2.ref;
        return renderTagContent(motionRef, isEntering, isExiting);
    });
    return /*#__PURE__*/ $5FkrB.createElement((0, $b012088b2f24c41a$export$898a500849bb5cf4), {
        isRemovable: isRemovable,
        status: status,
        onShrinkOutExitComplete: isRemovable ? onShrinkOutExitComplete : undefined
    }, renderTagContent(ref));
});
var $1c1839299defbb35$export$aba6bd1190e79361 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TagDropdownTrigger(_ref3, ref) {
    var _ref3$color = _ref3.color, color = _ref3$color === void 0 ? 'gray' : _ref3$color, text = _ref3.text, elemBefore = _ref3.elemBefore, testId = _ref3.testId, maxWidth = _ref3.maxWidth, _ref3$hasMargin = _ref3.hasMargin, hasMargin = _ref3$hasMargin === void 0 ? true : _ref3$hasMargin, onClick = _ref3.onClick, _ref3$isSelected = _ref3.isSelected, isSelected = _ref3$isSelected === void 0 ? false : _ref3$isSelected, _ref3$isLoading = _ref3.isLoading, isLoading = _ref3$isLoading === void 0 ? false : _ref3$isLoading, _analyticsContext = _ref3.analyticsContext, _ref3$hasChevron = _ref3.hasChevron, hasChevron = _ref3$hasChevron === void 0 ? true : _ref3$hasChevron, swatchBefore = _ref3.swatchBefore, swatchBeforeLabel = _ref3.swatchBeforeLabel, swatchBeforeRole = _ref3.swatchBeforeRole, trailingMetric = _ref3.trailingMetric, other = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref3, $1c1839299defbb35$var$_excluded2);
    var resolvedColor = (0, $a69bed3d91b1030e$export$3351a8d90bcc13aa)[color] || 'gray';
    var isMotionEnabled = (0, $c418527da89031bf$export$b40ec24ac8275656)('platform-dst-motion-uplift-labels');
    return /*#__PURE__*/ $5FkrB.createElement((0, $btdNC.Pressable), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: ref,
        xcss: (0, $hUFig.cx)($1c1839299defbb35$var$styles.baseStyles, !hasMargin && $1c1839299defbb35$var$styles.noMarginStyles, $1c1839299defbb35$var$colorStyles[resolvedColor], $1c1839299defbb35$var$borderIconFilterStyles.root, $1c1839299defbb35$var$dropdownStyles.interactive, $1c1839299defbb35$var$styles.focusRingStyles, $1c1839299defbb35$var$borderIconInteractiveFilterStyles.root, isSelected && $1c1839299defbb35$var$dropdownStyles.selected, isMotionEnabled && $1c1839299defbb35$var$styles.interactiveMotionStyles, // Reduce end padding when trailing metric is the last element (no chevron)
        !hasChevron && trailingMetric != null && trailingMetric !== '' && $1c1839299defbb35$var$styles.trailingMetricEndPadding),
        onClick: isLoading ? undefined : onClick,
        style: {
            borderColor: isSelected ? "var(--ds-border-selected, #1868DB)" : undefined,
            cursor: isLoading ? 'progress' : 'pointer',
            maxWidth: maxWidth !== undefined ? maxWidth : undefined
        }
    }, isLoading && {
        'aria-busy': true,
        'aria-disabled': true,
        isDisabled: true
    }, {
        testId: testId
    }, other), /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            $1c1839299defbb35$var$dropdownStyles.content,
            isMotionEnabled && $1c1839299defbb35$var$dropdownStyles.loadingMotion,
            isLoading && $1c1839299defbb35$var$dropdownStyles.loadingContent
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $7fa22b9389c08f5c$export$2e2bcd8739ae039), {
        colorKey: resolvedColor,
        swatchBefore: swatchBefore,
        swatchBeforeLabel: swatchBeforeLabel,
        swatchBeforeRole: swatchBeforeRole
    }), elemBefore && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            $1c1839299defbb35$var$styles.beforeStyles,
            isSelected && $1c1839299defbb35$var$styles.beforeStylesSelected
        ])
    }, elemBefore), /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-tag-text": true,
        className: (0, $970q7.default)([
            $1c1839299defbb35$var$styles.textStyles,
            isSelected && $1c1839299defbb35$var$styles.textStylesSelected
        ])
    }, (0, $f087a33d0f3a259a$export$7d100de1166870f6)(text)), trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId && "".concat(testId, "--metric"),
        className: (0, $970q7.default)([
            $1c1839299defbb35$var$styles.trailingMetric
        ])
    }, trailingMetric), hasChevron && /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($h19KG))), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && "".concat(testId, "--chevron")
    })), isLoading && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            $1c1839299defbb35$var$dropdownStyles.loadingOverlay,
            isMotionEnabled && $1c1839299defbb35$var$dropdownStyles.loadingOverlayMotion
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $9ztDu.default), {
        size: 'xsmall',
        label: ", Loading",
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    })));
});
/**
 * __Tag new__
 */ var $1c1839299defbb35$var$TagNew = (0, $58757bd38e26f900$export$88b132e52a65ec37)(/*#__PURE__*/ (0, $5FkrB.memo)($1c1839299defbb35$var$TagNewComponent));
var $1c1839299defbb35$export$2e2bcd8739ae039 = $1c1839299defbb35$var$TagNew;



/* base.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $0c47d6c1f13ea9e3$var$_excluded = [
    "before",
    "contentElement",
    "after",
    "testId",
    "style",
    "color",
    "href",
    "className"
];
function $0c47d6c1f13ea9e3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0c47d6c1f13ea9e3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0c47d6c1f13ea9e3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0c47d6c1f13ea9e3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Border colors - Hardcoded for Visual Refresh - to be removed with labelling system work
var $0c47d6c1f13ea9e3$var$borderColors = {
    standard: "_1h6d14je",
    blue: "_1h6duisw",
    red: "_1h6da2c0",
    yellow: "_1h6deh2r",
    green: "_1h6d18uw",
    teal: "_1h6d1ug6",
    purple: "_1h6d157s",
    lime: "_1h6dn0nx",
    magenta: "_1h6d1lf6",
    orange: "_1h6dh727",
    grey: "_1h6d14je",
    standardLink: "_1h6d14je",
    blueLight: "_1h6duisw",
    redLight: "_1h6da2c0",
    yellowLight: "_1h6deh2r",
    greenLight: "_1h6d18uw",
    tealLight: "_1h6d1ug6",
    purpleLight: "_1h6d157s",
    limeLight: "_1h6dn0nx",
    magentaLight: "_1h6d1lf6",
    orangeLight: "_1h6dh727",
    greyLight: "_1h6d14je"
};
var $0c47d6c1f13ea9e3$var$baseStyles = null;
var $0c47d6c1f13ea9e3$var$interactiveStyles = null;
var $0c47d6c1f13ea9e3$var$focusRingStyles = null;
var $0c47d6c1f13ea9e3$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function BaseTag(_ref, ref) {
    var before = _ref.before, contentElement = _ref.contentElement, after = _ref.after, testId = _ref.testId, style = _ref.style, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, className = _ref.className, other = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $0c47d6c1f13ea9e3$var$_excluded);
    var isLink = Boolean(href);
    var isRemovable = Boolean(after);
    var isInteractive = isLink || isRemovable;
    if (color === 'gray') // internally we use 'grey' for gray color so that we can make migration easier behind the ff (gray will work with and without ff now)
    color = 'grey';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, other, {
        ref: ref,
        style: $0c47d6c1f13ea9e3$var$_objectSpread({}, style),
        className: (0, $970q7.default)([
            "_zulp1b66 _2rko12b0 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3i1k92 _kqswh2mm _4cvr1h6o _bfhksm61 _syazi7uo _80om73ad",
            isInteractive && "_1e38dfik _7glxv77o",
            isLink && "_irr31dpa _1di6fcek",
            $0c47d6c1f13ea9e3$var$borderColors[color],
            className
        ]),
        "data-testid": testId
    }), before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0c47d6c1f13ea9e3$export$2e2bcd8739ae039 = $0c47d6c1f13ea9e3$var$BaseTag;


/* before.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $92e99a6cc3fde11d$var$beforeElementStyles = null;
var $92e99a6cc3fde11d$var$Before = function Before(_ref) {
    var elemBefore = _ref.elemBefore;
    return elemBefore ? /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            "_1e0c1txw _4t3i1j6v _4cvr1h6o _1bah1h6o _152tze3t"
        ])
    }, elemBefore) : null;
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$92e99a6cc3fde11d$export$2e2bcd8739ae039 = $92e99a6cc3fde11d$var$Before;


/**
 * Maps Tag color values to Lozenge appearance values.
 * Used for migration_fallback rendering when feature flag is off.
 */ var $2dce5b626d9b95a9$var$colorToLozengeAppearanceMap = {
    gray: 'default',
    grey: 'default',
    lime: 'success',
    green: 'success',
    blue: 'inprogress',
    red: 'removed',
    purple: 'new',
    yellow: 'moved',
    orange: 'moved',
    magenta: 'new',
    teal: 'inprogress',
    grayLight: 'default',
    greyLight: 'default',
    limeLight: 'success',
    greenLight: 'success',
    blueLight: 'inprogress',
    redLight: 'removed',
    purpleLight: 'new',
    yellowLight: 'moved',
    orangeLight: 'moved',
    magentaLight: 'new',
    tealLight: 'inprogress'
};
function $2dce5b626d9b95a9$export$4d9e331cafeacb9d(color) {
    return $2dce5b626d9b95a9$var$colorToLozengeAppearanceMap[color || 'gray'] || 'default';
}


/* content.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $bb02a0bb3c485bf1$var$baseStyles = null;
var $bb02a0bb3c485bf1$var$linkStyles = null;
var $bb02a0bb3c485bf1$var$hasAfterStyles = null;
var $bb02a0bb3c485bf1$var$Content = function Content(_ref) {
    var _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? '' : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, linkComponent = _ref.linkComponent, testId = _ref.testId;
    var Link = linkComponent !== null && linkComponent !== void 0 ? linkComponent : 'a';
    var normalizedText = (0, $f087a33d0f3a259a$export$7d100de1166870f6)(text);
    if (href) return /*#__PURE__*/ $5FkrB.createElement(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? "".concat(testId, "--link") : undefined,
        className: (0, $970q7.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazi7uo _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3i7uo _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
            isRemovable && "_p12f1lit"
        ])
    }, normalizedText);
    else return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            isRemovable && "_p12f1lit"
        ])
    }, normalizedText);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bb02a0bb3c485bf1$export$2e2bcd8739ae039 = $bb02a0bb3c485bf1$var$Content;



var $d8d42cb8c9e7d7ea$var$_excluded = [
    "appearance",
    "elemBefore",
    "isRemovable",
    "text",
    "color",
    "href",
    "removeButtonLabel",
    "testId",
    "onBeforeRemoveAction",
    "onAfterRemoveAction",
    "linkComponent",
    "migration_fallback",
    "maxWidth",
    "hasMargin",
    "swatchBefore",
    "swatchBeforeLabel",
    "swatchBeforeRole"
];
var $d8d42cb8c9e7d7ea$var$textLinkCssVar = '--ds-ctl';
var $d8d42cb8c9e7d7ea$var$textDefaultCssVar = '--ds-ct';
var $d8d42cb8c9e7d7ea$var$textActiveCssVar = '--ds-ctp';
var $d8d42cb8c9e7d7ea$var$backgroundHoverCssVar = '--ds-cbh';
var $d8d42cb8c9e7d7ea$var$backgroundActiveCssVar = '--ds-cba';
var $d8d42cb8c9e7d7ea$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($d8d42cb8c9e7d7ea$var$TagStatus || {});
var $d8d42cb8c9e7d7ea$var$packageName = "@atlaskit/tag";
var $d8d42cb8c9e7d7ea$var$packageVersion = "15.7.2";
var $d8d42cb8c9e7d7ea$var$defaultBeforeRemoveAction = function defaultBeforeRemoveAction() {
    return true;
};
/**
 * These hide the focus ring for the tag when its remove button is focused,
 * preventing a double focus ring.
 */ var $d8d42cb8c9e7d7ea$var$removingStyles = null;
var $d8d42cb8c9e7d7ea$var$RemovableTagComponent = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var appearance = _ref.appearance, _ref$elemBefore = _ref.elemBefore, elemBefore = _ref$elemBefore === void 0 ? null : _ref$elemBefore, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? '' : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, removeButtonLabel = _ref.removeButtonLabel, testId = _ref.testId, _ref$onBeforeRemoveAc = _ref.onBeforeRemoveAction, onBeforeRemoveAction = _ref$onBeforeRemoveAc === void 0 ? $d8d42cb8c9e7d7ea$var$defaultBeforeRemoveAction : _ref$onBeforeRemoveAc, _ref$onAfterRemoveAct = _ref.onAfterRemoveAction, onAfterRemoveAction = _ref$onAfterRemoveAct === void 0 ? (0, $eVb4V.default) : _ref$onAfterRemoveAct, linkComponent = _ref.linkComponent, migration_fallback = _ref.migration_fallback, maxWidth = _ref.maxWidth, _ref$hasMargin = _ref.hasMargin, hasMargin = _ref$hasMargin === void 0 ? true : _ref$hasMargin, swatchBefore = _ref.swatchBefore, swatchBeforeLabel = _ref.swatchBeforeLabel, swatchBeforeRole = _ref.swatchBeforeRole, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $d8d42cb8c9e7d7ea$var$_excluded);
    var _useState = (0, $5FkrB.useState)($d8d42cb8c9e7d7ea$var$TagStatus.Showing), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), isHoverCloseButton = _useState4[0], setIsHoverCloseButton = _useState4[1];
    var normalizedText = (0, $f087a33d0f3a259a$export$7d100de1166870f6)(text);
    var onAfterRemoveActionWithAnalytics = (0, $71149abdde46dc7d$export$53c2b9c37c40e0d8)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $d8d42cb8c9e7d7ea$var$packageName,
            packageVersion: $d8d42cb8c9e7d7ea$var$packageVersion
        }
    }, 'atlaskit');
    var handleRemoveComplete = (0, $5FkrB.useCallback)(function() {
        setStatus($d8d42cb8c9e7d7ea$var$TagStatus.Removed);
    }, []);
    var handleRemoveRequest = (0, $5FkrB.useCallback)(function() {
        if (onBeforeRemoveAction && onBeforeRemoveAction()) {
            onAfterRemoveActionWithAnalytics(normalizedText);
            handleRemoveComplete();
        }
    }, [
        handleRemoveComplete,
        normalizedText,
        onBeforeRemoveAction,
        onAfterRemoveActionWithAnalytics
    ]);
    var onKeyPress = (0, $5FkrB.useCallback)(function(e) {
        var spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    var removingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus($d8d42cb8c9e7d7ea$var$TagStatus.Removing);
    }, []);
    var showingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus($d8d42cb8c9e7d7ea$var$TagStatus.Showing);
    }, []);
    var handleMouseOver = (0, $5FkrB.useCallback)(function() {
        return setIsHoverCloseButton(true);
    }, []);
    var handleMouseOut = (0, $5FkrB.useCallback)(function() {
        return setIsHoverCloseButton(false);
    }, []);
    var removeButton = isRemovable ? /*#__PURE__*/ $5FkrB.createElement((0, $13e920922a058ca2$export$2e2bcd8739ae039), {
        "aria-label": "".concat(removeButtonLabel || 'Remove', " ").concat(normalizedText),
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: "close-button-".concat(testId)
    }) : undefined;
    // Handle migration_fallback: render Lozenge when flag is off and migration_fallback is 'lozenge'
    if (migration_fallback === 'lozenge' && !(0, $c418527da89031bf$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        var lozengeAppearance = (0, $2dce5b626d9b95a9$export$4d9e331cafeacb9d)(color);
        return /*#__PURE__*/ $5FkrB.createElement((0, $5supy.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            appearance: lozengeAppearance,
            isBold: false,
            testId: testId
        }, rest), normalizedText);
    }
    // Use new TagNew component behind feature flag
    // TagNew handles its own animation internally via RemovableWrapper
    if ((0, $c418527da89031bf$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        var newColor = (0, $a69bed3d91b1030e$export$3351a8d90bcc13aa)[color || 'standard'];
        return /*#__PURE__*/ $5FkrB.createElement((0, $1c1839299defbb35$export$2e2bcd8739ae039), {
            ref: ref,
            color: newColor,
            text: normalizedText,
            elemBefore: elemBefore,
            href: href,
            testId: testId,
            isRemovable: isRemovable,
            removeButtonLabel: removeButtonLabel,
            onBeforeRemoveAction: onBeforeRemoveAction,
            onAfterRemoveAction: onAfterRemoveActionWithAnalytics,
            maxWidth: maxWidth,
            hasMargin: hasMargin,
            swatchBefore: swatchBefore,
            swatchBeforeLabel: swatchBeforeLabel,
            swatchBeforeRole: swatchBeforeRole
        });
    }
    // Original implementation
    var content = /*#__PURE__*/ $5FkrB.createElement((0, $bb02a0bb3c485bf1$export$2e2bcd8739ae039), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: normalizedText,
        color: color,
        href: href,
        linkComponent: linkComponent,
        testId: testId
    });
    var hoverCloseButtonColors = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
    }, $d8d42cb8c9e7d7ea$var$backgroundHoverCssVar, undefined), $d8d42cb8c9e7d7ea$var$backgroundActiveCssVar, undefined), $d8d42cb8c9e7d7ea$var$textDefaultCssVar, undefined), $d8d42cb8c9e7d7ea$var$textActiveCssVar, undefined), $d8d42cb8c9e7d7ea$var$textLinkCssVar, undefined);
    return /*#__PURE__*/ $5FkrB.createElement((0, $ed19d0339ebb4724$export$2e2bcd8739ae039), null, !(status === $d8d42cb8c9e7d7ea$var$TagStatus.Removed) && /*#__PURE__*/ $5FkrB.createElement((0, $695d5afa5e5793f0$export$2e2bcd8739ae039), {
        key: "atlaskit-removable-tag-legacy-shrink-out",
        onFinish: handleRemoveComplete
    }, function(motion) {
        return /*#__PURE__*/ $5FkrB.createElement((0, $0c47d6c1f13ea9e3$export$2e2bcd8739ae039), {
            ref: (0, $iO8GM.default)([
                motion.ref,
                ref
            ]),
            appearance: appearance,
            color: color,
            testId: testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
            "data-removable": true,
            "data-removing": status === $d8d42cb8c9e7d7ea$var$TagStatus.Removing,
            "data-ishoverclosebutton": isHoverCloseButton,
            href: href,
            before: /*#__PURE__*/ $5FkrB.createElement((0, $92e99a6cc3fde11d$export$2e2bcd8739ae039), {
                elemBefore: elemBefore
            }),
            contentElement: content,
            after: removeButton,
            className: (0, $970q7.default)([
                status === $d8d42cb8c9e7d7ea$var$TagStatus.Removing && "_z30c1r31 _twwiglyw _1pka1o36 _bqhtfiwo"
            ])
        });
    }));
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ var $d8d42cb8c9e7d7ea$var$RemovableTag = (0, $58757bd38e26f900$export$88b132e52a65ec37)(/*#__PURE__*/ (0, $5FkrB.memo)($d8d42cb8c9e7d7ea$var$RemovableTagComponent));
var $d8d42cb8c9e7d7ea$export$2e2bcd8739ae039 = $d8d42cb8c9e7d7ea$var$RemovableTag;



/**
 * Hook to consume the SelectGetStylesContext.
 *
 * @internal — not part of the public API
 */ 
var $5FkrB = parcelRequire("5FkrB");
/**
 * Internal context used to pass the original Select instance's getStyles function
 * down to components like MultiValue, without polluting the public CommonProps API.
 *
 * This allows MultiValue to detect whether getStyles has been overridden on a
 * component instance (e.g. via a custom component wrapper passing a different
 * getStyles prop), by comparing props.getStyles against the original.
 *
 * @internal — not part of the public API
 */ 
var $5FkrB = parcelRequire("5FkrB");
var $9ef423e9df16dfb6$export$50727c0a52da4015 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);


var $c89f9d0618fc24cf$export$2a533455c10aa11f = function useSelectGetStyles() {
    return (0, $5FkrB.useContext)((0, $9ef423e9df16dfb6$export$50727c0a52da4015));
};



/* multi-value-label.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");
var $707782499894b66e$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c8fhey _o5721q9c _y4tiv77o _bozg1b66 _syaz1kw7",
    disabled: "_syaz1gmx",
    ellipsis: "_1bto1l2s"
};
var $707782499894b66e$export$544aeea2a5ce08ee = function MultiValueLabel(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isDisabled = _ref.isDisabled, hasEllipsis = _ref.hasEllipsis, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $707782499894b66e$var$multiValueLabelStyles.root,
            isDisabled && $707782499894b66e$var$multiValueLabelStyles.disabled,
            hasEllipsis && $707782499894b66e$var$multiValueLabelStyles.ellipsis,
            (0, $hUFig.cx)(className, xcss, '-MultiValueLabel')
        ])
    }), children);
};


function $be3eb17ba37d5e9d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $be3eb17ba37d5e9d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $be3eb17ba37d5e9d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $be3eb17ba37d5e9d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $be3eb17ba37d5e9d$var$multiValueTagWrapperStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1mouze3t _195gze3t _4cvr1h6o _1e0c1txw _1ul9ze3t _zdxokb7n _v5ynkb7n _13lsf1ug _3pxh1h6o _d0dz1txw _1ouwze3t"
};
var $be3eb17ba37d5e9d$var$multiValueMotionStyles = {
    active: "_1reo15vq _18m915vq _8hrz1e5h",
    entering: "_y44v1ukz _1bumglyw",
    exiting: "_y44v12ef _1bumglyw"
};
// Tag-like color styles
var $be3eb17ba37d5e9d$var$tagLikeColorStyles = {
    gray: "_119bmsup",
    blue: "_119b18hp",
    green: "_119b5d2u",
    red: "_119bn9dc",
    yellow: "_119b1s7j",
    purple: "_119bluwt",
    lime: "_119b1m7d",
    magenta: "_119b132u",
    orange: "_119b1ip5",
    teal: "_119b131p"
};
var $be3eb17ba37d5e9d$var$tagLikeBorderFilterStyles = null;
// Tag-like styles for custom content values (not plain text) when FF is on.
// Mirrors the TagNew component's visual appearance (padding, margins, sizing, colors).
// The container uses tag-like styling while Label/Remove sub-components are preserved
// so custom overrides (e.g. custom aria-labels, rendering objects as data) continue to work.
var $be3eb17ba37d5e9d$var$multiValueTagLikeStyles = {
    root: "_1reo15vq _18m915vq _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1mouze3t _195gze3t _1e0c116y _vchhusvi _kqswh2mm _4cvr1h6o _1wpz1h6o _1ul9ze3t _1o9zkb7n _p12ff6dh _4t3i1k92 _bfhksm61 _syazi7uo _80om73ad _3yq3glyw",
    labelWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _11c8wadc _1e0c1txw _4cvr1h6o _1ul9ze3t _1tkeidpf _2a9v1kw7",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk1dpa _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
var $be3eb17ba37d5e9d$var$getMultiValueLabelText = function getMultiValueLabelText(children, data) {
    if (typeof children === 'string') return children;
    var label = data === null || data === void 0 ? void 0 : data.label;
    return typeof label === 'string' ? label : '';
};
var $be3eb17ba37d5e9d$var$MultiValueContent = function MultiValueContent(contentProps) {
    var props = contentProps.multiValueProps, motionRef = contentProps.motionRef, motionState = contentProps.motionState;
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, isFocused = props.isFocused, removeProps = props.removeProps, selectProps = props.selectProps, cropWithEllipsis = props.cropWithEllipsis;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    var labelText = $be3eb17ba37d5e9d$var$getMultiValueLabelText(children, data);
    var isPlainLabel = typeof children === 'string';
    var ffTagUplifts = (0, $d1213b7f4495d0bd$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts');
    var isEnteringWithMotion = motionState === 'entering';
    var isExitingWithMotion = motionState === 'exiting';
    var _getStyleProps = (0, $76e70396aae85af8$export$26417cabd806a658)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    }), containerCss = _getStyleProps.css, containerClassName = _getStyleProps.className;
    var _getStyleProps2 = (0, $76e70396aae85af8$export$26417cabd806a658)(props, 'multiValueLabel', {
        'multi-value__label': true
    }), labelCss = _getStyleProps2.css, labelClassName = _getStyleProps2.className;
    var _getStyleProps3 = (0, $76e70396aae85af8$export$26417cabd806a658)(props, 'multiValueRemove', {
        'multi-value__remove': true
    }), removeCss = _getStyleProps3.css, removeClassName = _getStyleProps3.className;
    var hasCustomLabel = Label !== (0, $707782499894b66e$export$544aeea2a5ce08ee);
    var hasCustomContainer = Container !== (0, $c2f1633ad2772e6a$export$cf9cf2a30a59265c);
    var selectStyles = selectProps.styles;
    var hasCustomMultiValueStyles = Boolean((selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValue) || (selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValueLabel) || (selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValueRemove));
    var selectClassNames = selectProps.classNames;
    var hasCustomMultiValueClassNames = Boolean((selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValue) || (selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValueLabel) || (selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValueRemove));
    // Detect if getStyles was overridden directly on this component instance (e.g. via the
    // components prop wrapper passing a custom getStyles). The context holds the original
    // Select instance's getStyles — a reference inequality means a custom override was passed.
    // When context is absent (e.g. in mocked/test contexts), assume no override.
    var selectGetStyles = (0, $c89f9d0618fc24cf$export$2a533455c10aa11f)();
    var hasOverriddenGetStyles = selectGetStyles !== undefined && props.getStyles !== selectGetStyles;
    var hasCustomContainerStyles = hasCustomMultiValueStyles || hasCustomMultiValueClassNames || hasOverriddenGetStyles;
    if (ffTagUplifts && isPlainLabel && !hasCustomLabel && !hasCustomContainer && !hasCustomContainerStyles) {
        var _ref = data !== null && data !== void 0 ? data : {}, elemBefore = _ref.elemBefore, tagColor = _ref.color;
        return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
            ref: motionRef,
            className: (0, $970q7.default)([
                $be3eb17ba37d5e9d$var$multiValueTagWrapperStyles.root,
                isExitingWithMotion && $be3eb17ba37d5e9d$var$multiValueMotionStyles.active,
                isExitingWithMotion && $be3eb17ba37d5e9d$var$multiValueMotionStyles.exiting,
                (0, $hUFig.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ])
        }), /*#__PURE__*/ $5FkrB.createElement((0, $d8d42cb8c9e7d7ea$export$2e2bcd8739ae039), {
            text: labelText,
            isRemovable: !isDisabled,
            removeButtonLabel: "".concat(labelText, ", remove"),
            onBeforeRemoveAction: function onBeforeRemoveAction() {
                var _removeProps$onClick;
                (_removeProps$onClick = removeProps.onClick) === null || _removeProps$onClick === void 0 || _removeProps$onClick.call(removeProps, {});
                return false;
            },
            color: tagColor !== null && tagColor !== void 0 ? tagColor : 'gray',
            elemBefore: elemBefore,
            hasMargin: false
        }));
    }
    // FF on + custom content → tag-like path
    if (ffTagUplifts && !hasCustomContainer) {
        var colorKey = data === null || data === void 0 ? void 0 : data.color;
        return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            "data-multi-value-tag-like": "true"
        }, innerProps, {
            ref: motionRef,
            style: containerCss,
            className: (0, $970q7.default)([
                $be3eb17ba37d5e9d$var$multiValueTagLikeStyles.root,
                $be3eb17ba37d5e9d$var$tagLikeColorStyles.gray,
                colorKey === 'blue' && $be3eb17ba37d5e9d$var$tagLikeColorStyles.blue,
                colorKey === 'green' && $be3eb17ba37d5e9d$var$tagLikeColorStyles.green,
                colorKey === 'red' && $be3eb17ba37d5e9d$var$tagLikeColorStyles.red,
                colorKey === 'yellow' && $be3eb17ba37d5e9d$var$tagLikeColorStyles.yellow,
                colorKey === 'purple' && $be3eb17ba37d5e9d$var$tagLikeColorStyles.purple,
                colorKey === 'lime' && $be3eb17ba37d5e9d$var$tagLikeColorStyles.lime,
                colorKey === 'magenta' && $be3eb17ba37d5e9d$var$tagLikeColorStyles.magenta,
                colorKey === 'orange' && $be3eb17ba37d5e9d$var$tagLikeColorStyles.orange,
                colorKey === 'teal' && $be3eb17ba37d5e9d$var$tagLikeColorStyles.teal,
                "_1h6dip4g",
                isDisabled && $be3eb17ba37d5e9d$var$multiValueTagLikeStyles.disabled,
                isFocused && $be3eb17ba37d5e9d$var$multiValueTagLikeStyles.focused,
                (isEnteringWithMotion || isExitingWithMotion) && $be3eb17ba37d5e9d$var$multiValueMotionStyles.active,
                isEnteringWithMotion && $be3eb17ba37d5e9d$var$multiValueMotionStyles.entering,
                isExitingWithMotion && $be3eb17ba37d5e9d$var$multiValueMotionStyles.exiting,
                (0, $hUFig.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ])
        }), /*#__PURE__*/ $5FkrB.createElement("div", {
            className: (0, $970q7.default)([
                $be3eb17ba37d5e9d$var$multiValueTagLikeStyles.labelWrapper
            ])
        }, /*#__PURE__*/ $5FkrB.createElement(Label, {
            data: data,
            innerProps: {
                style: labelCss,
                className: labelClassName
            },
            className: labelClassName,
            hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
            selectProps: selectProps
        }, children)), /*#__PURE__*/ $5FkrB.createElement(Remove, {
            data: data,
            innerProps: $be3eb17ba37d5e9d$var$_objectSpread({
                style: removeCss,
                className: removeClassName,
                role: 'button',
                tabIndex: -1,
                'aria-label': "".concat(labelText || 'option', ", remove")
            }, removeProps),
            className: removeClassName,
            isDisabled: isDisabled,
            selectProps: selectProps
        }));
    }
    // FF off → default styles
    return /*#__PURE__*/ $5FkrB.createElement(Container, {
        data: data,
        innerProps: $be3eb17ba37d5e9d$var$_objectSpread({
            style: containerCss,
            className: containerClassName
        }, innerProps),
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps
    }, /*#__PURE__*/ $5FkrB.createElement(Label, {
        data: data,
        innerProps: {
            style: labelCss,
            className: labelClassName
        },
        className: labelClassName,
        hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
        selectProps: selectProps
    }, children), /*#__PURE__*/ $5FkrB.createElement(Remove, {
        data: data,
        innerProps: $be3eb17ba37d5e9d$var$_objectSpread({
            style: removeCss,
            className: removeClassName,
            role: 'button',
            tabIndex: -1,
            'aria-label': "".concat(labelText || 'option', ", remove")
        }, removeProps),
        className: removeClassName,
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var $be3eb17ba37d5e9d$var$MotionMultiValue = function MotionMultiValue(props) {
    var multiValueProps = props.multiValueProps;
    var _useMotion = (0, $e06646f1bf60a3ed$export$2a51cfe9390d36ef)({
        onFinish: function onFinish(motionState) {
            if (motionState === 'exiting') {
                var _multiValueProps$onMo;
                (_multiValueProps$onMo = multiValueProps.onMotionFinish) === null || _multiValueProps$onMo === void 0 || _multiValueProps$onMo.call(multiValueProps);
            }
        }
    }), ref = _useMotion.ref, state = _useMotion.state;
    return /*#__PURE__*/ $5FkrB.createElement($be3eb17ba37d5e9d$var$MultiValueContent, {
        multiValueProps: multiValueProps,
        motionRef: ref,
        motionState: state
    });
};
var $be3eb17ba37d5e9d$var$MultiValue = function MultiValue(props) {
    if (props.isMotionEnabled) return /*#__PURE__*/ $5FkrB.createElement($be3eb17ba37d5e9d$var$MotionMultiValue, {
        multiValueProps: props
    });
    return /*#__PURE__*/ $5FkrB.createElement($be3eb17ba37d5e9d$var$MultiValueContent, {
        multiValueProps: props
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$be3eb17ba37d5e9d$export$2e2bcd8739ae039 = $be3eb17ba37d5e9d$var$MultiValue;



/* multi-value-remove.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $ac8VW = parcelRequire("ac8VW");
var $b674165a8e54924a$var$disabledStyles = null;
var $b674165a8e54924a$var$enabledStyles = null;
var $b674165a8e54924a$var$multiValueRemoveStyles = {
    focused: "_bfhkb1q9 _lswu6x5g",
    root: "_19itglyw _2rko12b0 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _1e0c1txw _lswui7uo _1q51v77o _y4tiv77o _85i5v77o _bozgv77o _12l2v77o _1ah312gs _irr31dpa _13br1tmw _1di6fcek _i5f81tmw"
};
function $b674165a8e54924a$export$8e1fd1a40e7a2f4a(_ref) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, innerProps = _ref.innerProps, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $b674165a8e54924a$var$multiValueRemoveStyles.root,
            isFocused && $b674165a8e54924a$var$multiValueRemoveStyles.focused,
            (0, $hUFig.cx)(className, xcss, '-MultiValueRemove')
        ])
    }), /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
        className: (0, $970q7.default)([
            isDisabled && "_1e0cglyw",
            !isDisabled && "_1e0c1kw7"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ac8VW))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
}


/* option.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");


var $4813e2ff380e566b$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syazi7uo _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di6fcek",
    disabled: "_syaz1gmx _80om13gf _bfhk1j28 _16qsglyw _1di61j28 _112eglyw",
    focused: "_bfhk1dpa _16qs1x9r _112e5u6v",
    selected: "_syaz6x5g _bfhk15s3 _16qs1x9r _1di6nozp _112e5u6v",
    focusedSelected: "_bfhkufnl",
    motion: "_v564hxmd _o7kshxmd _1ggl87vo",
    motionSelected: "_v5641rrn _o7kshxmd"
};
var $4813e2ff380e566b$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $76e70396aae85af8$export$26417cabd806a658)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $4813e2ff380e566b$var$optionStyles.root,
            !isDisabled && !isSelected && (0, $d1213b7f4495d0bd$export$b40ec24ac8275656)('platform-dst-motion-uplift-list-item') && $4813e2ff380e566b$var$optionStyles.motion,
            isFocused && $4813e2ff380e566b$var$optionStyles.focused,
            isSelected && $4813e2ff380e566b$var$optionStyles.selected,
            isFocused && isSelected && $4813e2ff380e566b$var$optionStyles.focusedSelected,
            !isDisabled && isSelected && (0, $d1213b7f4495d0bd$export$b40ec24ac8275656)('platform-dst-motion-uplift-list-item') && $4813e2ff380e566b$var$optionStyles.motionSelected,
            isDisabled && $4813e2ff380e566b$var$optionStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-option')
        ]),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4813e2ff380e566b$export$2e2bcd8739ae039 = $4813e2ff380e566b$var$Option;


/* placeholder.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $c3e42964cd6c9809$var$placeholderStyles = {
    root: "_nd5l1sux _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syaz1rpy",
    disabled: "_syaz1gmx"
};
var $c3e42964cd6c9809$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, xcss = props.xcss;
    var _getStyleProps = (0, $76e70396aae85af8$export$26417cabd806a658)(props, 'placeholder', {
        placeholder: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $c3e42964cd6c9809$var$placeholderStyles.root,
            isDisabled && $c3e42964cd6c9809$var$placeholderStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-placeholder')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c3e42964cd6c9809$export$2e2bcd8739ae039 = $c3e42964cd6c9809$var$Placeholder;


/* single-value.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $52a34b0e13e4ba5a$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syazi7uo",
    disalbed: "_syaz1gmx"
};
var $52a34b0e13e4ba5a$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $76e70396aae85af8$export$26417cabd806a658)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $52a34b0e13e4ba5a$var$styles.root,
            isDisabled && $52a34b0e13e4ba5a$var$styles.disalbed,
            (0, $hUFig.cx)(className, xcss, '-singleValue')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$52a34b0e13e4ba5a$export$2e2bcd8739ae039 = $52a34b0e13e4ba5a$var$SingleValue;


function $737117aed3aee31b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $737117aed3aee31b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $737117aed3aee31b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $737117aed3aee31b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $737117aed3aee31b$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $b828ad2fed7d06e1$export$ecf9cf59142dd54a),
    Control: (0, $6a1e65b66738d982$export$2e2bcd8739ae039),
    DropdownIndicator: (0, $a31f4390726d228d$export$ec98719d3db7f2e4),
    Group: (0, $e63a062a88191cfa$export$2e2bcd8739ae039),
    GroupHeading: (0, $ee0143fff79640b8$export$85c8b41a3cd87edc),
    IndicatorsContainer: (0, $d9f4b3d2798ea813$export$d0ffd7e649cab6f),
    Input: (0, $993713342c66b49b$export$2e2bcd8739ae039),
    LoadingIndicator: (0, $25c4d3096610d4ff$export$7c20be4c1d342248),
    Menu: (0, $37bbdf43dab8a9d9$export$2e2bcd8739ae039),
    MenuList: (0, $80a264b54c270603$export$d4c4e98c5044dc8),
    MenuPortal: (0, $6c86ba34c2a76faf$export$793392f970497feb),
    LoadingMessage: (0, $7f1ff1462b42a93e$export$e928a71d039d3102),
    NoOptionsMessage: (0, $0e378aef7f2103e6$export$d58b72b7d3c4072c),
    MultiValue: (0, $be3eb17ba37d5e9d$export$2e2bcd8739ae039),
    MultiValueContainer: (0, $c2f1633ad2772e6a$export$cf9cf2a30a59265c),
    MultiValueLabel: (0, $707782499894b66e$export$544aeea2a5ce08ee),
    MultiValueRemove: (0, $b674165a8e54924a$export$8e1fd1a40e7a2f4a),
    Option: (0, $4813e2ff380e566b$export$2e2bcd8739ae039),
    Placeholder: (0, $c3e42964cd6c9809$export$2e2bcd8739ae039),
    SelectContainer: (0, $70e707911e054d35$export$446eebadefe1123b),
    SingleValue: (0, $52a34b0e13e4ba5a$export$2e2bcd8739ae039),
    ValueContainer: (0, $5cf75f7b33fdc344$export$4dc9f58ad9a1a000)
};
var $737117aed3aee31b$export$71abc632aa29e6fe = function defaultComponents(props) {
    return $737117aed3aee31b$var$_objectSpread($737117aed3aee31b$var$_objectSpread({}, $737117aed3aee31b$export$9b5ac10f59f76296), props.components);
};



var $9ztDu = parcelRequire("9ztDu");

var $5FkrB = parcelRequire("5FkrB");

var $bgNpv = parcelRequire("bgNpv");

var $jgNUw = parcelRequire("jgNUw");

var $cMVCI = parcelRequire("cMVCI");
/* styled.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $25nEq = parcelRequire("25nEq");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $d04bc1c27b5aa0d1$var$_excluded = [
    "children"
], $d04bc1c27b5aa0d1$var$_excluded2 = [
    "height",
    "iconSize",
    "children",
    "style"
], $d04bc1c27b5aa0d1$var$_excluded3 = [
    "children"
], $d04bc1c27b5aa0d1$var$_excluded4 = [
    "children"
], $d04bc1c27b5aa0d1$var$_excluded5 = [
    "children"
], $d04bc1c27b5aa0d1$var$_excluded6 = [
    "displayFlag",
    "children"
], $d04bc1c27b5aa0d1$var$_excluded7 = [
    "children"
];
function $d04bc1c27b5aa0d1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d04bc1c27b5aa0d1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d04bc1c27b5aa0d1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d04bc1c27b5aa0d1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Uses @compiled/react because descendant/child selectors and !important are not supported by the strict @atlaskit/css API.
var $d04bc1c27b5aa0d1$var$styles = {
    dropdownIndicatorWrapper: "_2hwxv77o _y3gn1h6o _1bsbzwfg",
    text: "_11c81qyo _19pku2gc",
    control: "_16qs130s _1e0c1txw _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    closeIconWrapper: "_80omtlke _syaz1rpy _f8pjazsu _30l3azsu"
};
var $d04bc1c27b5aa0d1$var$displayWrapperStyles = {
    shown: "_1e0c1ule",
    hidden: "_1e0cglyw"
};
var $d04bc1c27b5aa0d1$var$styledBoxStyles = {
    box: "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i1f4z _1bah1h6o"
};
var $d04bc1c27b5aa0d1$var$styledBoxIconStyles = {
    boxIcon: "_w8l5achg _1752achg"
};
var $d04bc1c27b5aa0d1$var$styledInvalidCheckboxOptionStyles = {
    invalidCheckboxOption: "_bfhk1gly _1e0c1txw _2lx2vrvc _4cvr1h6o _u5f3u2gc _w1w3jdj5"
};
var $d04bc1c27b5aa0d1$export$30c615a45297e297 = function DropdownIndicatorWrapper(_ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $d04bc1c27b5aa0d1$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $d04bc1c27b5aa0d1$var$styles.dropdownIndicatorWrapper
        ])
    }), children);
};
var $d04bc1c27b5aa0d1$export$d675f139b342d51a = function StyledBox(_ref2) {
    var height = _ref2.height, iconSize = _ref2.iconSize, children = _ref2.children, style = _ref2.style, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $d04bc1c27b5aa0d1$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: $d04bc1c27b5aa0d1$var$_objectSpread($d04bc1c27b5aa0d1$var$_objectSpread({
            '--paginated-picker-box-height': "".concat(height || 128, "px")
        }, iconSize ? {
            '--paginated-picker-icon-size': "".concat(iconSize, "px")
        } : {}), style)
    }, props, {
        className: (0, $970q7.default)([
            $d04bc1c27b5aa0d1$var$styledBoxStyles.box,
            iconSize && ""
        ])
    }), children);
};
var $d04bc1c27b5aa0d1$export$31ea92f3997410dd = function StyledText(_ref3) {
    var children = _ref3.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref3, $d04bc1c27b5aa0d1$var$_excluded3);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $d04bc1c27b5aa0d1$var$styles.text
        ])
    }), children);
};
var $d04bc1c27b5aa0d1$export$5c7b7f0e517b89f8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(_ref4, ref) {
    var children = _ref4.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref4, $d04bc1c27b5aa0d1$var$_excluded4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: ref
    }, props, {
        className: (0, $970q7.default)([
            $d04bc1c27b5aa0d1$var$styles.control
        ])
    }), children);
});
var $d04bc1c27b5aa0d1$export$94756becb802e330 = function CloseIconWrapper(_ref5) {
    var children = _ref5.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref5, $d04bc1c27b5aa0d1$var$_excluded5);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $d04bc1c27b5aa0d1$var$styles.closeIconWrapper
        ])
    }), children);
};
var $d04bc1c27b5aa0d1$export$6833d6d22987ee7f = function DisplayWrapper(_ref6) {
    var displayFlag = _ref6.displayFlag, children = _ref6.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref6, $d04bc1c27b5aa0d1$var$_excluded6);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $d04bc1c27b5aa0d1$var$displayWrapperStyles[displayFlag ? 'shown' : 'hidden']
        ])
    }), children);
};
var $d04bc1c27b5aa0d1$export$e786733cafde97b9 = function StyledInvalidCheckboxOption(_ref7) {
    var children = _ref7.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref7, $d04bc1c27b5aa0d1$var$_excluded7);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $d04bc1c27b5aa0d1$var$styledInvalidCheckboxOptionStyles.invalidCheckboxOption
        ])
    }), children);
};



var $6bnW7 = parcelRequire("6bnW7");
var $1cf70dc6d76c28fc$var$message = (0, $6bnW7.defineMessages)({
    errorMessage: {
        id: 'paginated-picker.async-select.menu-list.error-message.error-message',
        defaultMessage: "Couldn't retrieve data",
        description: 'The text for when an error occurs when loading options'
    },
    retryMessage: {
        id: 'paginated-picker.async-select.menu-list.error-message.retry-message',
        defaultMessage: 'Click to retry',
        description: 'The text for button to reload options'
    }
});
var $1cf70dc6d76c28fc$export$2e2bcd8739ae039 = $1cf70dc6d76c28fc$var$message;


var $9375e5d21b7ec4d9$var$ErrorMessage = function ErrorMessage(_ref) {
    var onRetry = _ref.onRetry;
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    var onClick = (0, $5FkrB.useCallback)(function() {
        onRetry === null || onRetry === void 0 || onRetry();
    // fireOperationalAnalytics(
    //   createAnalyticsEvent({}),
    //   'refinementBarSelectRetry clicked',
    // );
    }, [
        onRetry
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d04bc1c27b5aa0d1$export$d675f139b342d51a), {
        height: 144
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d04bc1c27b5aa0d1$export$d675f139b342d51a), {
        height: 72,
        iconSize: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cMVCI))), {
        spacing: "spacious",
        color: "var(--ds-icon-subtle, #505258)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d04bc1c27b5aa0d1$export$31ea92f3997410dd), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, $1cf70dc6d76c28fc$export$2e2bcd8739ae039).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jgNUw.default), {
        onClick: onClick,
        appearance: "link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, $1cf70dc6d76c28fc$export$2e2bcd8739ae039).retryMessage)));
};
var $9375e5d21b7ec4d9$export$2e2bcd8739ae039 = $9375e5d21b7ec4d9$var$ErrorMessage;



var $5FkrB = parcelRequire("5FkrB");

var $bgNpv = parcelRequire("bgNpv");

var $9ztDu = parcelRequire("9ztDu");


var $6bnW7 = parcelRequire("6bnW7");
var $eddfaf2fab047259$var$message = (0, $6bnW7.defineMessages)({
    loadingMessage: {
        id: 'paginated-picker.async-select.menu-list.loading-message.loading-message',
        defaultMessage: 'Loading...',
        description: 'The text for when options are being loaded in dropdown'
    }
});
var $eddfaf2fab047259$export$2e2bcd8739ae039 = $eddfaf2fab047259$var$message;


var $de62ed4d5d3e39f9$export$e928a71d039d3102 = function LoadingMessage() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d04bc1c27b5aa0d1$export$d675f139b342d51a), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d04bc1c27b5aa0d1$export$d675f139b342d51a), {
        height: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9ztDu.default), {
        size: "large"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d04bc1c27b5aa0d1$export$31ea92f3997410dd), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, $eddfaf2fab047259$export$2e2bcd8739ae039).loadingMessage)));
};



var $5FkrB = parcelRequire("5FkrB");

var $bgNpv = parcelRequire("bgNpv");

var $jgNUw = parcelRequire("jgNUw");

var $6bnW7 = parcelRequire("6bnW7");
var $f1afc1a8b3c81584$var$message = (0, $6bnW7.defineMessages)({
    showMoreButtonText: {
        id: 'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text',
        defaultMessage: 'Show more',
        description: 'Clicking this button will load more items into the dropdown'
    }
});
var $f1afc1a8b3c81584$export$2e2bcd8739ae039 = $f1afc1a8b3c81584$var$message;


var $83c2428ad988cd38$var$ShowMoreButton = function ShowMoreButton(_ref) {
    var onShowMore = _ref.onShowMore;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jgNUw.default), {
        onClick: onShowMore,
        appearance: "link",
        testId: "paginated-picker.ui.async-select.menu-list.show-more-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, $f1afc1a8b3c81584$export$2e2bcd8739ae039).showMoreButtonText));
};
var $83c2428ad988cd38$export$2e2bcd8739ae039 = $83c2428ad988cd38$var$ShowMoreButton;


/* styled.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $1077123e969e878d$var$_excluded = [
    "children"
];
var $1077123e969e878d$var$styles = {
    loadingWrapper: "_1e0c1txw _1bah1h6o _19pk1b66 _otyr1b66"
};
var $1077123e969e878d$export$43a792a870d28db2 = function LoadingWrapper(_ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $1077123e969e878d$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $1077123e969e878d$var$styles.loadingWrapper
        ])
    }), children);
};


var $300359477b033719$export$d4c4e98c5044dc8 = function MenuList(props) {
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    var _useState = (0, $5FkrB.useState)(1), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), clickCount = _useState2[0], setClickCount = _useState2[1];
    var _props$selectProps$me = props.selectProps.menuListProps, _props$selectProps$me2 = _props$selectProps$me.error, isError = _props$selectProps$me2.isError, onRetry = _props$selectProps$me2.onRetry, handleShowMore = _props$selectProps$me.handleShowMore, isLoading = _props$selectProps$me.isLoading, isPaginationLoading = _props$selectProps$me.isPaginationLoading, showShowMoreButton = _props$selectProps$me.showShowMoreButton;
    var handleOnShowMore = (0, $5FkrB.useCallback)(function() {
        setClickCount(clickCount + 1);
        // sendAnalytics({
        //   actionSubjectId: 'filterSearchShowMore',
        //   createAnalyticsEvent,
        //   type,
        //   clickCount,
        // });
        handleShowMore();
    }, [
        clickCount,
        handleShowMore
    ]);
    if (isLoading && clickCount > 1) setClickCount(1);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $737117aed3aee31b$export$9b5ac10f59f76296).MenuList, props, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $de62ed4d5d3e39f9$export$e928a71d039d3102), null) : isError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9375e5d21b7ec4d9$export$2e2bcd8739ae039), {
        onRetry: onRetry
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, props.children, isPaginationLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1077123e969e878d$export$43a792a870d28db2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9ztDu.default), null)) : showShowMoreButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $83c2428ad988cd38$export$2e2bcd8739ae039), {
        onShowMore: handleOnShowMore
    })));
};
var $300359477b033719$export$2e2bcd8739ae039 = $300359477b033719$export$d4c4e98c5044dc8;



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $bgNpv = parcelRequire("bgNpv");

var $6bnW7 = parcelRequire("6bnW7");
var $560941f03606c790$var$message = (0, $6bnW7.defineMessages)({
    ofTotalCount: {
        id: 'paginated-picker.async-select.pagination-details.of-total-count',
        defaultMessage: '{itemsCount} of {totalCount}',
        description: 'Text shown in a paginated picker indicating how many items are currently loaded versus the total available. The placeholder {itemsCount} is the number of currently visible items and {totalCount} is the total number of items.'
    }
});
var $560941f03606c790$export$2e2bcd8739ae039 = $560941f03606c790$var$message;


/* styled.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $9d7ae9d302018f4c$var$_excluded = [
    "children"
];
var $9d7ae9d302018f4c$var$styles = {
    paginationDetails: "_16jlkb7n _1o9zkb7n _i0dlf1ug _11c8fhey _y3gnusic _19pku2gc _otyru2gc _18u0pxbi _2hwxpxbi _syaz1rpy"
};
var $9d7ae9d302018f4c$export$fff9218028c24180 = function PaginationDetailsStyled(_ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $9d7ae9d302018f4c$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $9d7ae9d302018f4c$var$styles.paginationDetails
        ])
    }), children);
};


var $ebc06b92dbad4ee4$export$33eb0288c0936a84 = function PaginationDetails(_ref) {
    var itemsCount = _ref.itemsCount, totalCount = _ref.totalCount;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9d7ae9d302018f4c$export$fff9218028c24180), {
        "data-testid": "paginated-picker.ui.async-select.pagination-details"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, (0, $560941f03606c790$export$2e2bcd8739ae039).ofTotalCount, {
        values: {
            itemsCount: itemsCount,
            totalCount: totalCount
        }
    })));
};
var $ebc06b92dbad4ee4$export$2e2bcd8739ae039 = $ebc06b92dbad4ee4$export$33eb0288c0936a84;



var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $bgNpv = parcelRequire("bgNpv");
var $hrVKU = parcelRequire("hrVKU");

var $78ORw = parcelRequire("78ORw");
var $7dbf0e5a9a6ef0ad$export$50531cf3046c5956 = {
    setValue: 'set-value',
    inputChange: 'input-change',
    inputBlur: 'input-blur',
    menuClose: 'menu-close',
    selectOption: 'select-option',
    deselectOption: 'deselect-option',
    removeValue: 'remove-value',
    popValue: 'pop-value',
    clear: 'clear',
    createOption: 'create-option',
    clearOptions: 'clear-options',
    add: 'add',
    remove: 'remove',
    update: 'update'
};



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $b318cb4477a183c2$export$7a7fa4424cb20976 = function Control(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, innerRef = _ref.innerRef;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d04bc1c27b5aa0d1$export$5c7b7f0e517b89f8), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        ref: innerRef
    }), children);
};



var $5FkrB = parcelRequire("5FkrB");

var $eNN4d = parcelRequire("eNN4d");

var $gAHKi = parcelRequire("gAHKi");


var $c1597d0d6ee92706$export$ec98719d3db7f2e4 = function DropdownIndicator(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $737117aed3aee31b$export$9b5ac10f59f76296).DropdownIndicator, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d04bc1c27b5aa0d1$export$30c615a45297e297), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d04bc1c27b5aa0d1$export$6833d6d22987ee7f), {
        displayFlag: !!props.selectProps.inputValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d04bc1c27b5aa0d1$export$94756becb802e330), {
        onClick: function onClick(event) {
            var _props$selectProps$on, _props$selectProps;
            event.preventDefault();
            (_props$selectProps$on = (_props$selectProps = props.selectProps).onInputChange) === null || _props$selectProps$on === void 0 || _props$selectProps$on.call(_props$selectProps, '', {
                action: 'input-change',
                prevInputValue: props.selectProps.inputValue
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eNN4d))), {
        color: "currentColor",
        label: "",
        size: "small"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d04bc1c27b5aa0d1$export$6833d6d22987ee7f), {
        displayFlag: !props.selectProps.inputValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gAHKi))), {
        color: "currentColor",
        label: ""
    }))));
};



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");
var $ae5dcb9d8b9eb75e$export$d9b273488cd8ce6f = function Menu(_ref) {
    var innerRef = _ref.innerRef, innerProps = _ref.innerProps, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-testid": "refinement-bar.common.ui.select.menu",
        ref: innerRef
    }, innerProps), children);
};



var $6bnW7 = parcelRequire("6bnW7");
var $e6dbc27532fc0919$var$message = (0, $6bnW7.defineMessages)({
    noOptionsMessage: {
        id: 'paginated-picker.async-select.select.no-options-message.no-options-message',
        defaultMessage: 'No matches found',
        description: 'The text for when no matches are found in dropdown'
    },
    searchPlaceholder: {
        id: 'paginated-picker.async-select.select.search-placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder text in search input indicating that the user can search'
    }
});
var $e6dbc27532fc0919$export$2e2bcd8739ae039 = $e6dbc27532fc0919$var$message;



var $5FkrB = parcelRequire("5FkrB");

var $cMVCI = parcelRequire("cMVCI");

var $aH7bq = parcelRequire("aH7bq");
/* radio-option.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $iNVbQ = parcelRequire("iNVbQ");
var $1ff7be765d7c84f2$var$svgStyles = null;
var $1ff7be765d7c84f2$var$RadioIcon = function RadioIcon(props) {
    var primaryColor = props.primaryColor, secondaryColor = props.secondaryColor, label = props.label;
    return /*#__PURE__*/ $5FkrB.createElement("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $970q7.default)([
            "_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $5FkrB.createElement("circle", {
        cx: "12",
        cy: "12",
        r: "6.75",
        fill: "currentColor",
        strokeWidth: "1.5"
    }), /*#__PURE__*/ $5FkrB.createElement("circle", {
        cx: "12",
        cy: "12",
        r: "3",
        fill: "inherit"
    })));
};
var $1ff7be765d7c84f2$export$82ab7168879267a7 = function RadioOption(props) {
    return(/*#__PURE__*/ // TODO https://product-fabric.atlassian.net/browse/DSP-20769
    $5FkrB.createElement((0, $iNVbQ.ControlOption), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        Icon: $1ff7be765d7c84f2$var$RadioIcon
    }, props)));
};



var $4mzlU = parcelRequire("4mzlU");

var $a63abcda3007a709$var$renderOption = function renderOption(props) {
    return props.isMulti ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aH7bq.CheckboxOption), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1ff7be765d7c84f2$export$82ab7168879267a7), props);
};
var $a63abcda3007a709$export$36d18380658d5d20 = function Option(props) {
    var _props$data;
    if ((_props$data = props.data) !== null && _props$data !== void 0 && _props$data.invalid) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d04bc1c27b5aa0d1$export$e786733cafde97b9), null, $a63abcda3007a709$var$renderOption(props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4mzlU.default), {
        content: props.selectProps.fieldInvalidLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cMVCI))), {
        label: "Test",
        color: "var(--ds-icon-danger, #C9372C)"
    })));
    return $a63abcda3007a709$var$renderOption(props);
};


var $7129d67ae13a23ad$var$_excluded = [
    "onFilterOption",
    "placeholder"
];
var $7129d67ae13a23ad$export$c34d65c0f5a1c617 = {
    Control: (0, $b318cb4477a183c2$export$7a7fa4424cb20976),
    DropdownIndicator: (0, $c1597d0d6ee92706$export$ec98719d3db7f2e4),
    LoadingIndicator: null,
    Menu: (0, $ae5dcb9d8b9eb75e$export$d9b273488cd8ce6f),
    Option: (0, $a63abcda3007a709$export$36d18380658d5d20)
};
var $7129d67ae13a23ad$var$onIsOptionDisabled = function onIsOptionDisabled(option) {
    return 'error' in option ? !!option.error : false;
};
var $7129d67ae13a23ad$export$51cc13ac81e51592 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(_ref, ref) {
    var _value$;
    var onFilterOption = _ref.onFilterOption, placeholder = _ref.placeholder, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $7129d67ae13a23ad$var$_excluded);
    var intl = (0, $hrVKU.default)();
    var ariaLabelProp = restProps.ariaLabel, _restProps$isMulti = restProps.isMulti, isMulti = _restProps$isMulti === void 0 ? true : _restProps$isMulti, onChangeProp = restProps.onChange, onInputChangeProp = restProps.onInputChange, inputValueProp = restProps.inputValue, value = restProps.value;
    var effectiveIsMulti = isMulti;
    var _useState = (0, $5FkrB.useState)(inputValueProp || ''), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), inputValue = _useState2[0], setInputValue = _useState2[1];
    var onInputChange = (0, $5FkrB.useCallback)(function(newValue, actionMeta) {
        /**
     * Do not clear the filter input value when an input is selected or blurred.
     * NOTE: We are also returning when 'menu-close' event are triggered,
     * which happens when the input is clicked for some reason, but not when we click outside of the dropdown
     * */ if ([
            (0, $7dbf0e5a9a6ef0ad$export$50531cf3046c5956).setValue,
            (0, $7dbf0e5a9a6ef0ad$export$50531cf3046c5956).inputBlur,
            (0, $7dbf0e5a9a6ef0ad$export$50531cf3046c5956).menuClose
        ].includes(actionMeta.action) && !newValue.length) return;
        onInputChangeProp === null || onInputChangeProp === void 0 || onInputChangeProp(newValue, actionMeta);
        setInputValue(newValue);
    }, [
        onInputChangeProp
    ]);
    var onChange = (0, $5FkrB.useCallback)(function(newValue, actionMeta) {
        // Keep this wrapper unconditional for both modes so hook creation stays stable.
        // In multiselect mode `newValue` is already an array, making this a no-op; in
        // single-select mode Atlaskit returns one option (or null), which we normalize
        // back to the array contract expected by the paginated-filter stack.
        var normalizedNewValue = Array.isArray(newValue) ? newValue : newValue ? [
            newValue
        ] : [];
        onChangeProp === null || onChangeProp === void 0 || onChangeProp(normalizedNewValue, actionMeta);
    }, [
        onChangeProp
    ]);
    var normalizedValue = effectiveIsMulti ? value : Array.isArray(value) ? (_value$ = value[0]) !== null && _value$ !== void 0 ? _value$ : null : value !== null && value !== void 0 ? value : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $78ORw.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, restProps, {
        // Typescript fix: SelectOption is not compatible with SingleOption from Select
        ref: ref,
        "aria-label": ariaLabelProp || intl.formatMessage((0, $e6dbc27532fc0919$export$2e2bcd8739ae039).searchPlaceholder),
        autoFocus: true,
        backspaceRemovesValue: false,
        blurInputOnSelect: false,
        closeMenuOnSelect: !effectiveIsMulti,
        controlShouldRenderValue: false,
        hideSelectedOptions: false,
        isClearable: false,
        isMulti: effectiveIsMulti,
        inputValue: inputValue,
        menuIsOpen: true,
        menuShouldScrollIntoView: false,
        tabSelectsValue: false,
        noOptionsMessage: function noOptionsMessage() {
            return intl.formatMessage((0, $e6dbc27532fc0919$export$2e2bcd8739ae039).noOptionsMessage);
        },
        onChange: onChange,
        onInputChange: onInputChange,
        isOptionDisabled: $7129d67ae13a23ad$var$onIsOptionDisabled // Typescript fix: SelectOption is not compatible with SingleOption from Select
        ,
        filterOption: onFilterOption,
        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, $e6dbc27532fc0919$export$2e2bcd8739ae039).searchPlaceholder),
        value: normalizedValue
    }));
});
$7129d67ae13a23ad$export$51cc13ac81e51592.displayName = 'LocalBaseSelect';



var $5FkrB = parcelRequire("5FkrB");

var $bgNpv = parcelRequire("bgNpv");

var $jgNUw = parcelRequire("jgNUw");

var $6bnW7 = parcelRequire("6bnW7");
var $ffee137cd27c043b$var$message = (0, $6bnW7.defineMessages)({
    showFullListButtonText: {
        id: 'paginated-picker.async-select.show-full-list-button.show-full-list-button-text',
        defaultMessage: 'Show full list',
        description: 'Initially we show the first few items on the list. Clicking this button will show the full list.'
    }
});
var $ffee137cd27c043b$export$2e2bcd8739ae039 = $ffee137cd27c043b$var$message;


var $4274c35478363962$export$bf0956d66cd7566b = function ShowFullListButton(_ref) {
    var onShowFullList = _ref.onShowFullList;
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    var handleShowFullList = (0, $5FkrB.useCallback)(function() {
        // const analyticsEvent = createAnalyticsEvent({
        //   eventType: 'UI',
        //   action: 'expanded',
        //   actionSubject: 'filterSearch',
        //   actionSubjectId: 'refinementBarFilterSearch',
        // });
        //
        // const attributes: Attributes = {
        //   fieldType: type,
        // };
        //
        // fireUIAnalytics(analyticsEvent, 'refinementBarFilterSearch', attributes);
        onShowFullList();
    }, [
        onShowFullList
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jgNUw.default), {
        onClick: handleShowFullList,
        appearance: "subtle-link",
        testId: "paginated-picker.ui.async-select.show-full-list-button.show-full-list-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, $ffee137cd27c043b$export$2e2bcd8739ae039).showFullListButtonText));
};
var $4274c35478363962$export$2e2bcd8739ae039 = $4274c35478363962$export$bf0956d66cd7566b;


/* styled.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $02ef5133f3ed6479$var$_excluded = [
    "children"
];
var $02ef5133f3ed6479$var$styles = {
    footer: "_uwhk1dm9 _15a5nqa1 _1i531l7x _ca0q1b66 _n3td1b66 _1e0c1txw _2lx2vrvc _4cvr1h6o"
};
var $02ef5133f3ed6479$export$a06f1c675e846f6f = function Footer(_ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $02ef5133f3ed6479$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $02ef5133f3ed6479$var$styles.footer
        ])
    }), children);
};


var $408415d215027ee6$var$_excluded = [
    "selectOptions"
], $408415d215027ee6$var$_excluded2 = [
    "ariaLabel",
    "field",
    "isMulti",
    "value",
    "onChange",
    "onClear",
    "hideClearSelection",
    "initiallyAddSelectedFirst",
    "showFooter"
];
function $408415d215027ee6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $408415d215027ee6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $408415d215027ee6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $408415d215027ee6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $408415d215027ee6$var$MAX_TOTAL_COUNT = 1000; // To be cleaned up in EM-3568
var $408415d215027ee6$var$paginatedComponents = $408415d215027ee6$var$_objectSpread($408415d215027ee6$var$_objectSpread({}, (0, $7129d67ae13a23ad$export$c34d65c0f5a1c617)), {}, {
    MenuList: (0, $300359477b033719$export$d4c4e98c5044dc8)
});
var $408415d215027ee6$var$ProxyBaseSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(_ref, ref) {
    var selectOptions = _ref.selectOptions, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $408415d215027ee6$var$_excluded);
    return selectOptions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7129d67ae13a23ad$export$51cc13ac81e51592), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        options: selectOptions,
        ref: ref
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7129d67ae13a23ad$export$51cc13ac81e51592), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        ref: ref
    }));
});
$408415d215027ee6$var$ProxyBaseSelect.displayName = 'ProxyBaseSelect';
var $408415d215027ee6$var$AsyncSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(props, ref) {
    var baseSelectProps = (0, $4df0abb36bdee3db$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($408415d215027ee6$var$ProxyBaseSelect, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, baseSelectProps, {
        ref: ref
    }));
});
$408415d215027ee6$var$AsyncSelect.displayName = 'AsyncSelect';
/**
 * Adds option to the list of options if its value isn't currently in the Set of keys
 */ var $408415d215027ee6$var$_addUniqueOptions = function addUniqueOptions(keys, options, option) {
    if (option.optionType === 'group') {
        var groupOptions = [];
        option.options.forEach(function(groupOption) {
            $408415d215027ee6$var$_addUniqueOptions(keys, groupOptions, groupOption);
        });
        options.push($408415d215027ee6$var$_objectSpread($408415d215027ee6$var$_objectSpread({}, option), {}, {
            options: groupOptions
        }));
        return;
    }
    // Add single options:
    if (!keys.has(option.value)) {
        keys.add(option.value);
        options.push(option);
    }
};
var $408415d215027ee6$var$generateOptions = function generateOptions(selectedValues, newOptions, addSelectedFirst, previousOptions) {
    var optionKeys = new Set();
    var options = [];
    if (addSelectedFirst) selectedValues.forEach(function(option) {
        $408415d215027ee6$var$_addUniqueOptions(optionKeys, options, option);
    });
    previousOptions === null || previousOptions === void 0 || previousOptions.forEach(function(option) {
        $408415d215027ee6$var$_addUniqueOptions(optionKeys, options, option);
    });
    newOptions.forEach(function(option) {
        $408415d215027ee6$var$_addUniqueOptions(optionKeys, options, option);
    });
    return options;
};
var $408415d215027ee6$var$getLastCursorOption = function getLastCursorOption(options) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3a70dcab3a7aadc2$exports)))(options, function(option) {
        return 'cursor' in option && !!option.cursor;
    });
};
// Needed to disable filtering from react-select
var $408415d215027ee6$var$noFilterOptions = function noFilterOptions() {
    return true;
};
var $408415d215027ee6$var$noLoadOptions = function noLoadOptions() {
    return Promise.resolve();
};
var $408415d215027ee6$export$54319cf8344f1691 = function countSingleOptions(options) {
    return options.map(function(option) {
        return option.optionType === 'group' ? option.options.length : 1;
    }).reduce(function(sumSoFar, count) {
        return sumSoFar + count;
    }, 0);
};
var $408415d215027ee6$export$fccf54b4cac6e0b3 = function PaginatedAsyncSelectView(_ref2) {
    var _field$pagination$ena, _field$pagination;
    var ariaLabel = _ref2.ariaLabel, field = _ref2.field, _ref2$isMulti = _ref2.isMulti, isMulti = _ref2$isMulti === void 0 ? true : _ref2$isMulti, value = _ref2.value, onChange = _ref2.onChange, onClear = _ref2.onClear, _ref2$hideClearSelect = _ref2.hideClearSelection, hideClearSelection = _ref2$hideClearSelect === void 0 ? false : _ref2$hideClearSelect, initiallyAddSelectedFirst = _ref2.initiallyAddSelectedFirst, showFooter = _ref2.showFooter, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $408415d215027ee6$var$_excluded2);
    var selectRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), page = _useState2[0], setPage = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(true), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), isLoading = _useState4[0], setIsLoading = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), isPaginationLoading = _useState6[0], setIsPaginationLoading = _useState6[1];
    var _useState7 = (0, $5FkrB.useState)(''), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState7, 2), inputValue = _useState8[0], setInputValue = _useState8[1];
    var _useState9 = (0, $5FkrB.useState)([]), _useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState9, 2), loadedOptions = _useState0[0], setLoadedOptions = _useState0[1];
    var _useState1 = (0, $5FkrB.useState)((_field$pagination$ena = (_field$pagination = field.pagination) === null || _field$pagination === void 0 ? void 0 : _field$pagination.enableFullList) !== null && _field$pagination$ena !== void 0 ? _field$pagination$ena : false), _useState10 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState1, 2), enableFullList = _useState10[0], setEnableFullList = _useState10[1];
    var _useState11 = (0, $5FkrB.useState)(null), _useState12 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState11, 2), totalCount = _useState12[0], setTotalCount = _useState12[1];
    var _useState13 = (0, $5FkrB.useState)({
        isError: false,
        error: null,
        onRetry: null
    }), _useState14 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState13, 2), error = _useState14[0], setError = _useState14[1];
    var getTotalCountWithFunctions = (0, $5FkrB.useCallback)(function(newTotalCount) {
        var _field$pagination2;
        if (newTotalCount === null || !((_field$pagination2 = field.pagination) !== null && _field$pagination2 !== void 0 && (_field$pagination2 = _field$pagination2.keywordValues) !== null && _field$pagination2 !== void 0 && _field$pagination2.length)) return newTotalCount;
        var keywordValues = field.pagination.keywordValues;
        var newTotalCountWithKeywords = newTotalCount + value.filter(function(option) {
            return keywordValues.includes(option.value);
        }).length;
        return newTotalCountWithKeywords < $408415d215027ee6$var$MAX_TOTAL_COUNT ? newTotalCountWithKeywords : $408415d215027ee6$var$MAX_TOTAL_COUNT;
    }, [
        field,
        value
    ]);
    var checkIfError = (0, $5FkrB.useCallback)(function(_search, options, onRetry) {
        if (options.some(function(option) {
            return option.optionType === 'error';
        })) {
            setError({
                isError: true,
                error: null,
                onRetry: onRetry
            });
            setIsLoading(false);
            return true;
        }
        setError({
            isError: false,
            error: null,
            onRetry: null
        });
        return false;
    }, []);
    var handleLoadOptions = (0, $5FkrB.useCallback)(function(search) {
        var loadOptions = field.loadOptions;
        if (!loadOptions) return;
        setIsLoading(true);
        loadOptions(search, enableFullList, false, false, undefined, function(_ref3) {
            var options = _ref3.options, newTotalCount = _ref3.totalCount;
            if (checkIfError(search, options, function() {
                return handleLoadOptions(search);
            })) return;
            setLoadedOptions($408415d215027ee6$var$generateOptions(value, options, initiallyAddSelectedFirst));
            setTotalCount(search ? newTotalCount : getTotalCountWithFunctions(newTotalCount));
            setIsLoading(false);
        });
    }, [
        field,
        enableFullList,
        checkIfError,
        value,
        initiallyAddSelectedFirst,
        getTotalCountWithFunctions
    ]);
    var handleShowMore = (0, $5FkrB.useCallback)(function() {
        var showFullList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var isRetry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var loadOptions = field.loadOptions;
        if (!loadOptions) return;
        var originalLoadedOptions;
        if (showFullList) {
            originalLoadedOptions = [];
            setIsLoading(true);
        } else {
            originalLoadedOptions = loadedOptions;
            if (isRetry) setIsLoading(true);
            else setIsPaginationLoading(true);
        }
        loadOptions(inputValue, false, showFullList, true, $408415d215027ee6$var$getLastCursorOption(loadedOptions), function(_ref4) {
            var options = _ref4.options, newTotalCount = _ref4.totalCount;
            if (checkIfError(inputValue, options, function() {
                handleShowMore(showFullList, true);
            })) return;
            setPage(page + 1);
            setEnableFullList(false);
            setLoadedOptions($408415d215027ee6$var$generateOptions(value, options, showFullList, originalLoadedOptions));
            setTotalCount(inputValue ? newTotalCount : getTotalCountWithFunctions(newTotalCount));
            setIsPaginationLoading(false);
            setIsLoading(false);
        });
    }, [
        field,
        loadedOptions,
        inputValue,
        checkIfError,
        value,
        page,
        getTotalCountWithFunctions
    ]);
    var handleShowFullList = (0, $5FkrB.useCallback)(function() {
        handleShowMore(true, false);
    }, [
        handleShowMore
    ]);
    var handleInputChange = (0, $5FkrB.useCallback)(function(newInputValue) {
        var onInputChange = field.onInputChange;
        setEnableFullList(false);
        setPage(0);
        setInputValue(newInputValue);
        setTotalCount(null);
        setLoadedOptions([]);
        handleLoadOptions(newInputValue);
        onInputChange && onInputChange();
    }, [
        field,
        handleLoadOptions
    ]);
    var handleOnChange = (0, $5FkrB.useCallback)(function(options, action) {
        var selectData;
        if ('option' in action) {
            var actionOption = action.option;
            if (actionOption && 'value' in actionOption) selectData = {
                selectedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($1099937d2cc3db76$exports)))(loadedOptions, function(option) {
                    return 'value' in option && option.value === actionOption.value;
                })
            };
        }
        onChange === null || onChange === void 0 || onChange(options, action, selectData);
    }, [
        onChange,
        loadedOptions
    ]);
    var handleClear = (0, $5FkrB.useCallback)(function() {
        onClear === null || onClear === void 0 || onClear();
        // Focus the search input after clearing
        setTimeout(function() {
            var _selectRef$current;
            (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 || _selectRef$current.focus();
        }, 0);
    }, [
        onClear
    ]);
    // We only want to call this on init, so it's ok to disable react-hooks/exhaustive-deps
    (0, $5FkrB.useEffect)(function() {
        handleLoadOptions('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var loadedOptionsCount = totalCount === null ? 0 : $408415d215027ee6$export$54319cf8344f1691(loadedOptions);
    var showClearSelection = !hideClearSelection && !!value.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($408415d215027ee6$var$AsyncSelect, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: selectRef,
        ariaLabel: ariaLabel,
        cacheOptions: field.cacheOptions,
        components: $408415d215027ee6$var$paginatedComponents,
        defaultOptions: field.defaultOptions,
        defaultOptionsLabel: field.defaultOptionsLabel,
        inputValue: inputValue,
        loadOptions: $408415d215027ee6$var$noLoadOptions,
        onInputChange: handleInputChange,
        onMenuScrollToBottom: field.onMenuScrollToBottom,
        onMenuScrollToTop: field.onMenuScrollToTop,
        placeholder: field.placeholder,
        fieldKey: field.key,
        fieldLabel: field.label,
        fieldInvalidLabel: field.invalidLabel,
        isMulti: isMulti,
        selectOptions: loadedOptions,
        onFilterOption: $408415d215027ee6$var$noFilterOptions,
        menuListProps: {
            error: error,
            type: field.key,
            handleShowMore: handleShowMore,
            isLoading: isLoading,
            isPaginationLoading: isPaginationLoading,
            showShowMoreButton: totalCount !== null && loadedOptionsCount < totalCount
        },
        onChange: handleOnChange,
        value: value
    }, restProps)), (showFooter || showClearSelection) && field.pagination && !isLoading && !!(loadedOptions !== null && loadedOptions !== void 0 && loadedOptions.length) && !error.isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $02ef5133f3ed6479$export$a06f1c675e846f6f), null, !value.length && enableFullList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4274c35478363962$export$bf0956d66cd7566b), {
        type: field.key,
        onShowFullList: handleShowFullList
    }), showClearSelection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8a7a5bf0e77e5ab1$export$1d4b7cda9e589b53), {
        onClear: handleClear,
        type: field.key
    }), showFooter && !enableFullList && totalCount !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ebc06b92dbad4ee4$export$33eb0288c0936a84), {
        itemsCount: loadedOptionsCount,
        totalCount: totalCount
    })));
};
var $408415d215027ee6$export$2e2bcd8739ae039 = $408415d215027ee6$export$fccf54b4cac6e0b3;



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
/* avatar.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $bDUuG = parcelRequire("bDUuG");

var $h8qvJ = parcelRequire("h8qvJ");

var $50U6m = parcelRequire("50U6m");
/* avatar-content.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $50U6m = parcelRequire("50U6m");

var $5FkrB = parcelRequire("5FkrB");
var $43eb4c3c88565f95$var$defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
var $43eb4c3c88565f95$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $5FkrB.createContext)($43eb4c3c88565f95$var$defaultAvatarContentProps);



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $424de23385e3364e$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $5FkrB.createContext)(false);


var $b3f4a54e026fe63d$export$7db5c57474082dd9 = function useEnsureIsInsideAvatar() {
    var context = (0, $5FkrB.useContext)((0, $424de23385e3364e$export$6b4cbd90d24955ad));
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};


var $ad69dc16118a4d8b$var$boxShadowCssVar = '--avatar-box-shadow';
var $ad69dc16118a4d8b$var$bgColorCssVar = '--avatar-bg-color';
var $ad69dc16118a4d8b$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw _1ejjglyw _mizu1v1w _1ah3v77o _ra3xnqa1 _128mdkaa _4dave4h9",
    circle: "_2rko1qll _14mj1qll",
    square: "_2rkol0p1",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peq2wxo"
};
var $ad69dc16118a4d8b$var$unboundStyles = {
    rootCustomBorder: "_11q7cxp3",
    root: "_vchh1ntv _bfhkcxp3 _16qs1nhn",
    hexagonFocusContainer: "_1rjc1wgn _18zr1dm9 _1mou5h37 _195g1ksc _bfhk1j28 _mkrz1k6g _1o9o1v1w",
    hexagonBorderContainerCustomBorder: "_11q7cxp3",
    hexagonBorderContainer: "_1rjcf6hp _18zruxly _1mou18m8 _195gzwb8 _bfhkcxp3 _mkrz1kw7 _1o9ovuon",
    hexagon: "_2rkoidpf _mkrz1kw7 _16qsn7od _14mjidpf _1ejjn7od _128midpf _4davidpf",
    interactive: "_80omtlke _4tpu1f0r _ez1ykb7n _gcm1jer9 _eeh8kb7n _jlxit94y",
    interactiveMotion: "_v5641krm _1llweo6y"
};
var $ad69dc16118a4d8b$var$hexagonBorderFixStyles = {
    hexagonBorderContainer: "_85i5pe44 _1q51pe44 _y4tipe44 _bozgpe44 _6rthn6b1 _1pfhn6b1 _12l2n6b1 _ahbqn6b1",
    hexagonFocusContainer: "_85i5i44o _1q51i44o _y4tii44o _bozgi44o _6rthnlpx _1pfhnlpx _12l2nlpx _ahbqnlpx"
};
var $ad69dc16118a4d8b$var$widthHeightMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz",
    xsmall: "_1bsb7vkz _4t3i7vkz",
    UNSAFE_xsmall: "_1bsbgktf _4t3igktf",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
var $ad69dc16118a4d8b$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children;
    (0, $b3f4a54e026fe63d$export$7db5c57474082dd9)();
    var _useContext = (0, $5FkrB.useContext)((0, $43eb4c3c88565f95$export$b983474ddd0b6d28)), Container = _useContext.as, appearance = _useContext.appearance, avatarImage = _useContext.avatarImage, _useContext$borderCol = _useContext.borderColor, borderColor = _useContext$borderCol === void 0 ? "var(--ds-surface, #FFFFFF)" : _useContext$borderCol, href = _useContext.href, isDisabled = _useContext.isDisabled, label = _useContext.label, onClick = _useContext.onClick, contextRef = _useContext.ref, tabIndex = _useContext.tabIndex, target = _useContext.target, testId = _useContext.testId, size = _useContext.size, stackIndex = _useContext.stackIndex, ariaControls = _useContext['aria-controls'], ariaExpanded = _useContext['aria-expanded'], ariaHasPopup = _useContext['aria-haspopup'];
    var isInteractive = Boolean(onClick || href || isDisabled || ariaHasPopup);
    var renderedContent = /*#__PURE__*/ $5FkrB.createElement(Container, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $ad69dc16118a4d8b$var$bgColorCssVar, borderColor), $ad69dc16118a4d8b$var$boxShadowCssVar, "0 0 0 2px ".concat(borderColor)),
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined
    }, href && {
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined
    }, {
        className: (0, $970q7.default)([
            $ad69dc16118a4d8b$var$unboundStyles.root,
            (0, $50U6m.fg)('avatar-custom-border') && $ad69dc16118a4d8b$var$unboundStyles.rootCustomBorder,
            $ad69dc16118a4d8b$var$styles.root,
            appearance === 'square' && $ad69dc16118a4d8b$var$styles.square,
            appearance === 'circle' && $ad69dc16118a4d8b$var$styles.circle,
            appearance === 'hexagon' && $ad69dc16118a4d8b$var$unboundStyles.hexagon,
            $ad69dc16118a4d8b$var$widthHeightMap[size],
            stackIndex !== undefined && $ad69dc16118a4d8b$var$styles.positionRelative,
            isInteractive && !isDisabled && $ad69dc16118a4d8b$var$unboundStyles.interactive,
            isInteractive && !isDisabled && appearance !== 'hexagon' && (0, $50U6m.fg)('platform-dst-motion-uplift') && $ad69dc16118a4d8b$var$unboundStyles.interactiveMotion,
            isDisabled && $ad69dc16118a4d8b$var$styles.disabled
        ])
    }), children || avatarImage);
    if (appearance !== 'hexagon') return renderedContent;
    // For a Hexagon Avatar in order to have hexagonal "border" and "outline", we have to
    // layer multiple elements and use their background colors to create the different layers.
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        style: (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $ad69dc16118a4d8b$var$bgColorCssVar, borderColor), $ad69dc16118a4d8b$var$boxShadowCssVar, "0 0 0 2px ".concat(borderColor)),
        "data-testid": testId ? "".concat(testId, "-hexagon-focus-container") : 'hexagon-focus-container',
        className: (0, $970q7.default)([
            $ad69dc16118a4d8b$var$unboundStyles.hexagonFocusContainer,
            isInteractive && !isDisabled && (0, $50U6m.fg)('platform-dst-motion-uplift') && $ad69dc16118a4d8b$var$unboundStyles.interactiveMotion,
            (0, $50U6m.fg)('platform_editor_agent_mentions_drop_one_fixes') && $ad69dc16118a4d8b$var$hexagonBorderFixStyles.hexagonFocusContainer
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": testId ? "".concat(testId, "-hexagon-border-container") : 'hexagon-border-container',
        className: (0, $970q7.default)([
            $ad69dc16118a4d8b$var$unboundStyles.hexagonBorderContainer,
            (0, $50U6m.fg)('avatar-custom-border') && $ad69dc16118a4d8b$var$unboundStyles.hexagonBorderContainerCustomBorder,
            (0, $50U6m.fg)('platform_editor_agent_mentions_drop_one_fixes') && $ad69dc16118a4d8b$var$hexagonBorderFixStyles.hexagonBorderContainer
        ])
    }, renderedContent));
});


/* avatar-image.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $59otM = parcelRequire("59otM");

var $a67qK = parcelRequire("a67qK");

var $aWVGs = parcelRequire("aWVGs");
var $975dbf966e660045$var$styles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
    icon: "_1e0c1txw _1bsb1osq _4t3i1osq _bfhk7qp0",
    circle: "_2rko1rr0",
    hexagon: "_mkrz1k6g"
};
var $975dbf966e660045$var$borderRadiusMap = {
    xxsmall: "_2rkolb4i",
    xsmall: "_2rkolb4i",
    UNSAFE_xsmall: "_2rkolb4i",
    small: "_2rkolb4i",
    medium: "_2rko12b0",
    large: "_2rko12b0",
    xlarge: "_2rko1qi0",
    xxlarge: "_2rkopb1k"
};
var $975dbf966e660045$var$nestedSvgStylesMap = {
    xxsmall: "_w8l57vkz _17527vkz",
    xsmall: "_w8l57vkz _17527vkz",
    UNSAFE_xsmall: "_w8l5gktf _1752gktf",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l516xz _175216xz",
    xxlarge: "_w8l51qr7 _17521qr7"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ var $975dbf966e660045$var$AvatarImage = function AvatarImage(_ref) {
    var _ref$alt = _ref.alt, alt = _ref$alt === void 0 ? '' : _ref$alt, src = _ref.src, appearance = _ref.appearance, size = _ref.size, testId = _ref.testId, imgLoading = _ref.imgLoading;
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    // If src changes, reset state
    (0, $5FkrB.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        var renderedIcon;
        switch(appearance){
            case 'circle':
                renderedIcon = /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a67qK))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && "".concat(testId, "--person"),
                    spacing: "spacious"
                });
                break;
            case 'hexagon':
                renderedIcon = /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($59otM))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && "".concat(testId, "--agent"),
                    spacing: "spacious"
                });
                break;
            default:
            case 'square':
                renderedIcon = /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWVGs))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && "".concat(testId, "--ship"),
                    spacing: "spacious"
                });
                break;
        }
        return /*#__PURE__*/ $5FkrB.createElement("span", {
            className: (0, $970q7.default)([
                $975dbf966e660045$var$styles.icon,
                $975dbf966e660045$var$nestedSvgStylesMap[size]
            ])
        }, renderedIcon);
    }
    return /*#__PURE__*/ $5FkrB.createElement("img", {
        loading: imgLoading,
        src: src,
        alt: alt,
        "data-testid": testId && "".concat(testId, "--image"),
        onError: function onError() {
            return setHasImageErrored(true);
        },
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? "".concat(testId, "--image") : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, $970q7.default)([
            $975dbf966e660045$var$styles.image,
            $975dbf966e660045$var$borderRadiusMap[size],
            appearance === 'circle' && $975dbf966e660045$var$styles.circle,
            appearance === 'hexagon' && $975dbf966e660045$var$styles.hexagon
        ])
    });
};
var $975dbf966e660045$export$2e2bcd8739ae039 = $975dbf966e660045$var$AvatarImage;




var $ba284450789dfd60$var$getCustomElement = function getCustomElement(isDisabled, href, onClick, ariaHasPopup) {
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled || ariaHasPopup) return 'button';
    return 'span';
};
var $ba284450789dfd60$export$2e2bcd8739ae039 = $ba284450789dfd60$var$getCustomElement;


/* presence-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
/* presence.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

/* icon-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $d02060a25b891711$var$styles = {
    root: "_2rko1qll _1reo15vq _18m915vq _189e1dm9 _1dqonqa1 _1e0c1txw _vchhusvi _1bsb1osq _4t3i1osq _4cvr1h6o _ae4v1h6o _bfhk1bhr"
};
var $d02060a25b891711$var$unboundStyles = {
    root: "_1h6d1bhr"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ var $d02060a25b891711$var$IconWrapper = function IconWrapper(_ref) {
    var bgColor = _ref.bgColor, children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $970q7.default)([
            $d02060a25b891711$var$styles.root,
            $d02060a25b891711$var$unboundStyles.root
        ])
    }, children);
};
var $d02060a25b891711$export$2e2bcd8739ae039 = $d02060a25b891711$var$IconWrapper;


var $2b159992ad4502e2$var$BusyIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("circle", {
    fill: "var(--ds-icon-danger, #C9372C)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
var $2b159992ad4502e2$var$FocusIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-icon-discovery, #AF59E1)",
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
var $2b159992ad4502e2$var$OfflineIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-text-subtlest, #6B6E76)",
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
var $2b159992ad4502e2$var$OnlineIndicator = /*#__PURE__*/ $5FkrB.createElement("circle", {
    fill: "var(--ds-icon-success, #6A9A23)",
    cx: "4",
    cy: "4",
    r: "4"
});
function $2b159992ad4502e2$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $2b159992ad4502e2$var$BusyIndicator;
        case 'focus':
            return $2b159992ad4502e2$var$FocusIndicator;
        case 'offline':
            return $2b159992ad4502e2$var$OfflineIndicator;
        case 'online':
            return $2b159992ad4502e2$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ var $2b159992ad4502e2$var$AvatarPresence = function AvatarPresence(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, presence = _ref.presence;
    return /*#__PURE__*/ $5FkrB.createElement((0, $d02060a25b891711$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ $5FkrB.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $2b159992ad4502e2$var$getPresence(presence)) : children);
};
var $2b159992ad4502e2$export$2e2bcd8739ae039 = $2b159992ad4502e2$var$AvatarPresence;


var $d8bdef7d5d7377a0$var$styles = {
    root: "_kqswstnw _lcxvglyw"
};
var $d8bdef7d5d7377a0$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
var $d8bdef7d5d7377a0$var$circleIconOffsetMap = {
    small: "_94n5idpf _1xi2idpf",
    medium: "_94n5idpf _1xi2idpf",
    large: "_94n5t94y _1xi2t94y",
    xlarge: "_94n51v6z _1xi21v6z"
};
var $d8bdef7d5d7377a0$var$squareIconOffsetMap = {
    root: "_94n5myb0 _1xi2myb0"
};
var $d8bdef7d5d7377a0$var$hexagonIconOffsetMap = {
    small: "_94n51n1a _1xi21n1a",
    medium: "_94n51n1a _1xi21n1a",
    large: "_94n51y44 _1xi2myb0",
    xlarge: "_94n5l52n _1xi21lpd"
};
/**
 * __Presence wrapper__
 *
 * A presence wrapper is used internally to position presence ontop of the avatar.
 */ var $d8bdef7d5d7377a0$var$PresenceWrapper = function PresenceWrapper(_ref) {
    var size = _ref.size, appearance = _ref.appearance, children = _ref.children, borderColor = _ref.borderColor, presence = _ref.presence, testId = _ref.testId;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--presence"),
        className: (0, $970q7.default)([
            $d8bdef7d5d7377a0$var$styles.root,
            $d8bdef7d5d7377a0$var$iconSizeMap[size],
            $d8bdef7d5d7377a0$var$circleIconOffsetMap[size],
            appearance === 'square' && $d8bdef7d5d7377a0$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $d8bdef7d5d7377a0$var$hexagonIconOffsetMap[size]
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $2b159992ad4502e2$export$2e2bcd8739ae039), {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};
var $d8bdef7d5d7377a0$export$2e2bcd8739ae039 = $d8bdef7d5d7377a0$var$PresenceWrapper;


/* status-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
/* status.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");


var $4d8d25261dd20cbc$var$ApprovedIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("circle", {
    fill: "var(--ds-icon-success, #6A9A23)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
var $4d8d25261dd20cbc$var$DeclinedIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("circle", {
    fill: "var(--ds-icon-danger, #C9372C)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
var $4d8d25261dd20cbc$var$LockedIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("circle", {
    fill: "var(--ds-text-subtlest, #6B6E76)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
var $4d8d25261dd20cbc$var$WarningIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("circle", {
    fill: "var(--ds-icon-warning, #E06C00)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4,1.33333333 C4.36918944,1.33333333 4.66666667,1.63081056 4.66666667,2 L4.66666667,4 C4.66666667,4.36918944 4.36918944,4.66666667 4,4.66666667 C3.63081056,4.66666667 3.33333333,4.36918944 3.33333333,4 L3.33333333,2 C3.33333333,1.63081056 3.63081056,1.33333333 4,1.33333333 Z M4,5.33333333 C4.36918944,5.33333333 4.66666667,5.63081056 4.66666667,6 C4.66666667,6.36918944 4.36918944,6.66666667 4,6.66666667 C3.63081056,6.66666667 3.33333333,6.36918944 3.33333333,6 C3.33333333,5.63081056 3.63081056,5.33333333 4,5.33333333 Z"
}));
function $4d8d25261dd20cbc$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $4d8d25261dd20cbc$var$ApprovedIndicator;
        case 'declined':
            return $4d8d25261dd20cbc$var$DeclinedIndicator;
        case 'locked':
            return $4d8d25261dd20cbc$var$LockedIndicator;
        case 'warning':
            return $4d8d25261dd20cbc$var$WarningIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ var $4d8d25261dd20cbc$var$AvatarStatus = function AvatarStatus(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, status = _ref.status;
    return /*#__PURE__*/ $5FkrB.createElement((0, $d02060a25b891711$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ $5FkrB.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $4d8d25261dd20cbc$var$getStatus(status)) : children);
};
var $4d8d25261dd20cbc$export$2e2bcd8739ae039 = $4d8d25261dd20cbc$var$AvatarStatus;


var $ef7f0d8405db056d$var$styles = {
    root: "_kqswstnw"
};
var $ef7f0d8405db056d$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
var $ef7f0d8405db056d$var$circleIconOffsetMap = {
    small: "_rjxpidpf _152tidpf",
    medium: "_rjxpidpf _152tidpf",
    large: "_rjxpt94y _152tt94y",
    xlarge: "_rjxp1v6z _152t1v6z"
};
var $ef7f0d8405db056d$var$squareIconOffsetMap = {
    root: "_rjxpidpf _152tidpf"
};
var $ef7f0d8405db056d$var$hexagonIconOffsetMap = {
    small: "_rjxp1n1a _152t1n1a",
    medium: "_rjxp1n1a _152t1n1a",
    large: "_rjxpmyb0 _152t1y44",
    xlarge: "_rjxp1lpd _152tl52n"
};
/**
 * __Status wrapper__
 *
 * A status wrapper is used internally to position status on top of the avatar.
 */ var $ef7f0d8405db056d$var$StatusWrapper = function StatusWrapper(_ref) {
    var size = _ref.size, status = _ref.status, appearance = _ref.appearance, borderColor = _ref.borderColor, children = _ref.children, testId = _ref.testId;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--status"),
        className: (0, $970q7.default)([
            $ef7f0d8405db056d$var$styles.root,
            $ef7f0d8405db056d$var$iconSizeMap[size],
            $ef7f0d8405db056d$var$circleIconOffsetMap[size],
            appearance === 'square' && $ef7f0d8405db056d$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $ef7f0d8405db056d$var$hexagonIconOffsetMap[size]
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $4d8d25261dd20cbc$export$2e2bcd8739ae039), {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};
var $ef7f0d8405db056d$export$2e2bcd8739ae039 = $ef7f0d8405db056d$var$StatusWrapper;



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $4971675f184073a3$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);


var $50f50166bd046ef3$export$b50b87a1c4086b23 = function useAvatarContext() {
    return (0, $5FkrB.useContext)((0, $4971675f184073a3$export$a20dad690e1279e2));
};


function $cd085f09f15000d9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cd085f09f15000d9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cd085f09f15000d9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cd085f09f15000d9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cd085f09f15000d9$var$packageName = "@atlaskit/avatar";
var $cd085f09f15000d9$var$packageVersion = "28.0.0";
var $cd085f09f15000d9$var$containerStyles = null;
var $cd085f09f15000d9$var$normalizeAvatarSize = function normalizeAvatarSize(size) {
    return size === 'xsmall' && !(0, $50U6m.fg)('platform_design-system-team_avatar-remove-xsmall') ? 'xxsmall' : size;
};
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ var $cd085f09f15000d9$var$Avatar = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'circle' : _ref$appearance, label = _ref.label, borderColor = _ref.borderColor, children = _ref.children, href = _ref.href, isDisabled = _ref.isDisabled, name = _ref.name, onClick = _ref.onClick, presence = _ref.presence, sizeProp = _ref.size, src = _ref.src, stackIndex = _ref.stackIndex, status = _ref.status, target = _ref.target, testId = _ref.testId, _ref$as = _ref.as, AvatarContainer = _ref$as === void 0 ? 'div' : _ref$as, imgLoading = _ref.imgLoading, ariaControls = _ref['aria-controls'], ariaExpanded = _ref['aria-expanded'], ariaHasPopup = _ref['aria-haspopup'];
    var _useAnalyticsEvents = (0, $bDUuG.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var context = (0, $50f50166bd046ef3$export$b50b87a1c4086b23)();
    var size = $cd085f09f15000d9$var$normalizeAvatarSize(sizeProp || (context === null || context === void 0 ? void 0 : context.size) || 'medium');
    var customPresenceNode = /*#__PURE__*/ (0, $5FkrB.isValidElement)(presence) ? presence : null;
    var customStatusNode = /*#__PURE__*/ (0, $5FkrB.isValidElement)(status) ? status : null;
    var isValidIconSize = size !== 'xxlarge' && size !== 'xxsmall' && size !== 'xsmall';
    // Presence/status indicators are only defined for `IndicatorSizeType`
    // (small, medium, large, xlarge). Compute `indicatorSize` only for sizes
    // that support an indicator (`isValidIconSize`), so the value is
    // structurally guaranteed to be a valid `IndicatorSizeType` rather than
    // relying on the guard at each call site. The `UNSAFE_xsmall` (20px) size
    // reuses the `small` indicator sizing as its nearest supported neighbor;
    // unsupported sizes (`xxsmall`/`xsmall`/`xxlarge`) fall back to `small` and are never
    // actually rendered because `isPresence`/`isStatus` also guard on
    // `isValidIconSize`.
    var indicatorSize = !isValidIconSize ? 'small' : size === 'UNSAFE_xsmall' ? 'small' : size;
    var lastAnalytics = (0, $5FkrB.useRef)(analyticsContext);
    var labelId = (0, $h8qvJ.useId)();
    (0, $5FkrB.useEffect)(function() {
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    var onClickHandler = (0, $5FkrB.useCallback)(function(event) {
        if (isDisabled || typeof onClick !== 'function') return;
        var analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $cd085f09f15000d9$var$packageName,
                packageVersion: $cd085f09f15000d9$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ var context = $cd085f09f15000d9$var$_objectSpread({
            componentName: 'avatar',
            packageName: $cd085f09f15000d9$var$packageName,
            packageVersion: $cd085f09f15000d9$var$packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    var isPresence = isValidIconSize && presence && !status;
    var isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    var defaultLabel = [
        name,
        isStatus && !customStatusNode && "(".concat(status, ")"),
        isPresence && !customPresenceNode && "(".concat(presence, ")")
    ].filter(Boolean).join(' ');
    var isInteractive = onClick || href || isDisabled || ariaHasPopup;
    var containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ $5FkrB.createElement((0, $424de23385e3364e$export$6b4cbd90d24955ad).Provider, {
        value: true
    }, /*#__PURE__*/ $5FkrB.createElement(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? 'img' : undefined,
        "aria-labelledby": containerShouldBeImage ? labelId : undefined,
        style: {
            zIndex: stackIndex
        },
        className: (0, $970q7.default)([
            "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $43eb4c3c88565f95$export$b983474ddd0b6d28).Provider, {
        value: {
            as: (0, $ba284450789dfd60$export$2e2bcd8739ae039)(isDisabled, href, onClick, ariaHasPopup),
            appearance: appearance,
            borderColor: borderColor,
            href: href,
            isDisabled: isDisabled,
            label: label || defaultLabel,
            onClick: isInteractive ? onClickHandler : undefined,
            ref: ref,
            size: size,
            stackIndex: stackIndex,
            target: target,
            testId: testId ? "".concat(testId, "--inner") : undefined,
            'aria-controls': ariaControls,
            'aria-expanded': ariaExpanded,
            'aria-haspopup': ariaHasPopup,
            avatarImage: /*#__PURE__*/ $5FkrB.createElement((0, $975dbf966e660045$export$2e2bcd8739ae039), {
                alt: !containerShouldBeImage && src ? name : undefined,
                src: src,
                appearance: appearance,
                size: size,
                testId: testId,
                imgLoading: imgLoading
            })
        }
    }, children || /*#__PURE__*/ $5FkrB.createElement((0, $ad69dc16118a4d8b$export$47fbc0b44cae5559), null)), isPresence && /*#__PURE__*/ $5FkrB.createElement((0, $d8bdef7d5d7377a0$export$2e2bcd8739ae039), {
        appearance: appearance,
        size: indicatorSize,
        presence: typeof presence === 'string' ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && /*#__PURE__*/ $5FkrB.createElement((0, $ef7f0d8405db056d$export$2e2bcd8739ae039), {
        appearance: appearance,
        size: indicatorSize,
        borderColor: borderColor,
        status: typeof status === 'string' ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId && "".concat(testId, "--label"),
        id: labelId,
        hidden: true
    }, defaultLabel) : undefined));
});
$cd085f09f15000d9$var$Avatar.displayName = 'Avatar';
var $cd085f09f15000d9$export$2e2bcd8739ae039 = $cd085f09f15000d9$var$Avatar;


/* styled.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $4bce3bb5fe635e93$var$_excluded = [
    "children"
], $4bce3bb5fe635e93$var$_excluded2 = [
    "children"
], $4bce3bb5fe635e93$var$_excluded3 = [
    "children"
], $4bce3bb5fe635e93$var$_excluded4 = [
    "children"
], $4bce3bb5fe635e93$var$_excluded5 = [
    "alt"
];
var $4bce3bb5fe635e93$var$styles = {
    child: "_19pk1b66 _2hwx1b66 _otyr1b66 _18u01b66 _1ul9idpf",
    option: "_4cvr1h6o _1e0c1txw",
    item: "_1e0c1txw",
    childIcon: "_18u0u2gc",
    optionIcon: "_2rko1rr0 _4t3i7vkz _1bsb7vkz _1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o"
};
var $4bce3bb5fe635e93$export$8133811dea85f484 = function StyledChild(_ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $4bce3bb5fe635e93$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $4bce3bb5fe635e93$var$styles.child
        ])
    }), children);
};
var $4bce3bb5fe635e93$export$844bee7de236d7ec = function StyledOption(_ref2) {
    var children = _ref2.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $4bce3bb5fe635e93$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $4bce3bb5fe635e93$var$styles.option
        ])
    }), children);
};
var $4bce3bb5fe635e93$export$7c16ae7705e422c4 = function StyledItem(_ref3) {
    var children = _ref3.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref3, $4bce3bb5fe635e93$var$_excluded3);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $4bce3bb5fe635e93$var$styles.item
        ])
    }), children);
};
var $4bce3bb5fe635e93$export$c23e66fb1706d7dd = function StyledChildIcon(_ref4) {
    var children = _ref4.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref4, $4bce3bb5fe635e93$var$_excluded4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $4bce3bb5fe635e93$var$styles.childIcon
        ])
    }), children);
};
var $4bce3bb5fe635e93$export$20da797b837461ca = function StyledOptionIcon(_ref5) {
    var _ref5$alt = _ref5.alt, alt = _ref5$alt === void 0 ? '' : _ref5$alt, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref5, $4bce3bb5fe635e93$var$_excluded5);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("img", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        alt: alt
    }, props, {
        className: (0, $970q7.default)([
            $4bce3bb5fe635e93$var$styles.optionIcon
        ])
    }));
};


var $c4004c0bb5ecb1c2$export$fe00f602c942368a = function AvatarOptionLabel(_ref) {
    var avatarOption = _ref.avatarOption;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4bce3bb5fe635e93$export$844bee7de236d7ec), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cd085f09f15000d9$export$2e2bcd8739ae039), {
        src: typeof avatarOption.avatar !== 'string' ? undefined : avatarOption.avatar,
        size: "xxsmall",
        appearance: typeof avatarOption.square === 'boolean' && avatarOption.square ? 'square' : 'circle'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4bce3bb5fe635e93$export$8133811dea85f484), null, avatarOption.label));
};



var $5FkrB = parcelRequire("5FkrB");

var $e5404634f13791e1$export$914fa095fc1e0a45 = function IconOptionLabel(_ref) {
    var option = _ref.option;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4bce3bb5fe635e93$export$844bee7de236d7ec), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4bce3bb5fe635e93$export$7c16ae7705e422c4), null, option.icon !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4bce3bb5fe635e93$export$20da797b837461ca), {
        src: option.icon,
        alt: option.label
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4bce3bb5fe635e93$export$c23e66fb1706d7dd), null, option.label)));
};



var $5FkrB = parcelRequire("5FkrB");

var $5supy = parcelRequire("5supy");

var $04b31c82d29a7e25$export$5f70fe304106fcb1 = function LozengeOptionLabel(_ref) {
    var lozengeOption = _ref.lozengeOption;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4bce3bb5fe635e93$export$844bee7de236d7ec), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4bce3bb5fe635e93$export$8133811dea85f484), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4bce3bb5fe635e93$export$7c16ae7705e422c4), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5supy.default), {
        appearance: lozengeOption.appearance,
        isBold: lozengeOption.isBold,
        maxWidth: lozengeOption.maxWidth
    }, lozengeOption.label))));
};


var $a380f220acf33d83$var$formatOptionLabel = function formatOptionLabel(option) {
    if (option.optionType === 'option') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5404634f13791e1$export$914fa095fc1e0a45), {
        option: option
    });
    if (option.optionType === 'avatar') return option.hideAvatar === true ? option.label : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c4004c0bb5ecb1c2$export$fe00f602c942368a), {
        avatarOption: option
    });
    if (option.optionType === 'lozenge') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $04b31c82d29a7e25$export$5f70fe304106fcb1), {
        lozengeOption: option
    });
    // eslint-disable-next-line no-console
    console.error('`formatOptionLabel` was passed an unsupported `SelectOption`:', option);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null);
};
var $a380f220acf33d83$export$2e2bcd8739ae039 = $a380f220acf33d83$var$formatOptionLabel;


/* styled.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $27c548bb54457f0f$var$_excluded = [
    "children"
];
var $27c548bb54457f0f$var$styles = {
    dialogInner: "_1reo15vq _18m915vq _1ul91wdt"
};
var $27c548bb54457f0f$export$999ca5bf223f627 = function DialogInner(_ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $27c548bb54457f0f$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $27c548bb54457f0f$var$styles.dialogInner
        ])
    }), children);
};


var $40e78ff6e2a4a381$export$ba25329847403e11 = function Picker(_ref) {
    var ariaLabel = _ref.ariaLabel, isOpen = _ref.isOpen, value = _ref.value, onClose = _ref.onClose, onClearValues = _ref.onClearValues, fieldId = _ref.fieldId, fieldLabel = _ref.fieldLabel, fieldInvalidLabel = _ref.fieldInvalidLabel, onChange = _ref.onChange, _ref$formatOptionLabe = _ref.formatOptionLabel, formatOptionLabel = _ref$formatOptionLabe === void 0 ? (0, $a380f220acf33d83$export$2e2bcd8739ae039) : _ref$formatOptionLabe, onLoadOptions = _ref.onLoadOptions, pagination = _ref.pagination, PopupComponent = _ref.PopupComponent, onTrigger = _ref.onTrigger, hideClearSelection = _ref.hideClearSelection, _ref$initiallyAddSele = _ref.initiallyAddSelectedFirst, initiallyAddSelectedFirst = _ref$initiallyAddSele === void 0 ? true : _ref$initiallyAddSele, _ref$isMulti = _ref.isMulti, isMulti = _ref$isMulti === void 0 ? true : _ref$isMulti, _ref$showFooter = _ref.showFooter, showFooter = _ref$showFooter === void 0 ? true : _ref$showFooter, popupProps = _ref.popupProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $933b8fb1ecc9c28f$export$b61655080b0a1f32), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dY97G.Popup), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        key: fieldId,
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        popupComponent: PopupComponent,
        shouldRenderToParent: true,
        trigger: onTrigger,
        autoFocus: false,
        content: function content() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $27c548bb54457f0f$export$999ca5bf223f627), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $408415d215027ee6$export$2e2bcd8739ae039), {
                field: {
                    isRemovable: false,
                    label: fieldLabel || '',
                    invalidLabel: fieldInvalidLabel,
                    type: 'Filter',
                    key: fieldId,
                    defaultOptionsLabel: 'defaultOptionsLabel',
                    defaultOptions: true,
                    cacheOptions: false,
                    inputValue: 'string',
                    enableShowMore: true,
                    pagination: pagination,
                    loadOptions: onLoadOptions
                },
                onChange: onChange,
                value: value,
                formatOptionLabel: formatOptionLabel,
                onClear: onClearValues,
                hideClearSelection: hideClearSelection,
                initiallyAddSelectedFirst: initiallyAddSelectedFirst,
                isMulti: isMulti,
                showFooter: showFooter,
                ariaLabel: ariaLabel
            }));
        }
    }, popupProps)));
};


var $2BL4q = parcelRequire("2BL4q");

var $5FkrB = parcelRequire("5FkrB");

var $jMKPI = parcelRequire("jMKPI");

var $72GAO = parcelRequire("72GAO");
/* styled.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $3262255dfca4577e$var$_excluded = [
    "children"
], $3262255dfca4577e$var$_excluded2 = [
    "children"
], $3262255dfca4577e$var$_excluded3 = [
    "children"
];
// Uses @compiled/react because fractional opacity (0.5) is not an allowed value in the strict @atlaskit/css types.
var $3262255dfca4577e$var$badgeWrapperStyles = {
    badge: "_1e0c116y _18u01b66 _tzy4105o"
};
var $3262255dfca4577e$var$styles = {
    container: "_1e0c116y _4cvr1h6o",
    labelValue: "_18u01b66 _1e0c116y _4cvr1h6o"
};
var $3262255dfca4577e$export$1a37a8b7ddf809ac = function BadgeWrapper(_ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $3262255dfca4577e$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $3262255dfca4577e$var$badgeWrapperStyles.badge
        ])
    }), children);
};
var $3262255dfca4577e$export$42a852a2b6b56249 = function Container(_ref2) {
    var children = _ref2.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $3262255dfca4577e$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $3262255dfca4577e$var$styles.container
        ])
    }), children);
};
var $3262255dfca4577e$export$8f3477ca2c4ba51a = function LabelValueWrapper(_ref3) {
    var children = _ref3.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref3, $3262255dfca4577e$var$_excluded3);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $3262255dfca4577e$var$styles.labelValue
        ])
    }), children);
};


function $a66e25a0480dd7ce$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $a66e25a0480dd7ce$export$96bdbc84526f3739 = function hasValue(value) {
    return Array.isArray(value) ? value.length > 0 : !!value;
};
var $a66e25a0480dd7ce$export$957d7daebd899f12 = function formatLabel() {
    var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var value = arguments.length > 1 ? arguments[1] : undefined;
    if (!value || !$a66e25a0480dd7ce$export$96bdbc84526f3739(value)) return label;
    var _value$map = value.map(function(v) {
        var _v$label;
        return (_v$label = v.label) !== null && _v$label !== void 0 ? _v$label : '';
    }), _value$map2 = (0, (/*@__PURE__*/$parcel$interopDefault($2BL4q)))(_value$map), firstValue = _value$map2[0], otherValues = $a66e25a0480dd7ce$var$_arrayLikeToArray(_value$map2).slice(1);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3262255dfca4577e$export$42a852a2b6b56249), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $72GAO.Text), {
        as: "strong",
        color: "inherit"
    }, label, ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3262255dfca4577e$export$8f3477ca2c4ba51a), null, firstValue, otherValues.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3262255dfca4577e$export$1a37a8b7ddf809ac), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jMKPI.default), null, "+".concat(otherValues.length)))));
};

/* main.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $5FkrB = parcelRequire("5FkrB");

var $dUWEU = parcelRequire("dUWEU");

var $h19KG = parcelRequire("h19KG");

var $auVZV = parcelRequire("auVZV");


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $ac8VW = parcelRequire("ac8VW");
/* styled.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $bc4ac4699a012ecb$var$_excluded = [
    "children"
];
// Uses @compiled/react because lineHeight and space-token width/height are not allowed by the strict @atlaskit/css types.
var $bc4ac4699a012ecb$var$styledClearButtonStyles = {
    clearButton: "_2rkolb4i _189eidpf _1dqoglyw _bfhk1j28 _syaz1rpy _80omtlke _4t3i1ejb _vwz4kb7n _12y3idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _18u0v77o _k8m01v7i _1oecfnf5 _1bsb1ejb _f8pjazsu _30l3azsu"
};
var $bc4ac4699a012ecb$export$969a0501aa28855a = function StyledClearButton(_ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $bc4ac4699a012ecb$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $bc4ac4699a012ecb$var$styledClearButtonStyles.clearButton
        ])
    }), children);
};


var $7b6b8b826eb2c2aa$var$_excluded = [
    "label",
    "isSelected"
];
var $7b6b8b826eb2c2aa$export$13ec83e50bf04290 = function ClearButton(_ref) {
    var label = _ref.label, isSelected = _ref.isSelected, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $7b6b8b826eb2c2aa$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bc4ac4699a012ecb$export$969a0501aa28855a), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        "data-testid": "paginated-picker.ui.clear-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ac8VW))), {
        color: "currentColor",
        label: label,
        size: "small"
    }));
};
$7b6b8b826eb2c2aa$export$13ec83e50bf04290.defaultProps = {
    isSelected: false,
    type: 'button'
};
var $7b6b8b826eb2c2aa$export$2e2bcd8739ae039 = $7b6b8b826eb2c2aa$export$13ec83e50bf04290;


/* styled.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $31da74042ec4ef60$var$_excluded = [
    "children"
];
// Uses @compiled/react because keyframes() is not available from @atlaskit/css.
var $31da74042ec4ef60$var$flickerAnimation = null;
var $31da74042ec4ef60$var$loadingStateAnimationWrapperStyles = {
    wrapper: "_kqswh2mm _j7hq3y00 _5sagymdr _tip812c5"
};
var $31da74042ec4ef60$export$c7a90a9f6120efb7 = function LoadingStateAnimationWrapper(_ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $31da74042ec4ef60$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $31da74042ec4ef60$var$loadingStateAnimationWrapperStyles.wrapper
        ])
    }), children);
};


/* styled.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $1c244c3d2b2e58d4$var$_excluded = [
    "children"
], $1c244c3d2b2e58d4$var$_excluded2 = [
    "children"
];
// Uses @compiled/react because lineHeight and space-token width/height are not allowed by the strict @atlaskit/css types.
var $1c244c3d2b2e58d4$var$styles = {
    buttonWrapper: "_kqswh2mm"
};
var $1c244c3d2b2e58d4$var$styledCloseStyles = {
    close: "_189eidpf _1dqoglyw _bfhk1j28 _4t3i1ejb _vwz4kb7n _12y3idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _1xi2r5cr _154i1ssb _19pkxmi2 _1bsb1ejb"
};
var $1c244c3d2b2e58d4$export$d53c836cccbb0d90 = function ButtonWrapper(_ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $1c244c3d2b2e58d4$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $1c244c3d2b2e58d4$var$styles.buttonWrapper
        ])
    }), children);
};
var $1c244c3d2b2e58d4$export$cd8104a6ec6bb897 = function StyledClose(_ref2) {
    var children = _ref2.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $1c244c3d2b2e58d4$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $1c244c3d2b2e58d4$var$styledCloseStyles.close
        ])
    }), children);
};


var $bd7df4e567703426$var$textPadding = {
    root: "_u5f3utpp"
};
var $bd7df4e567703426$export$d7b370c39c0de454 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isInvalid = _ref.isInvalid, isSelected = _ref.isSelected, hideSelectedIndicator = _ref.hideSelectedIndicator, triggerIcon = _ref.triggerIcon, isLoading = _ref.isLoading, hasValues = _ref.hasValues, onClick = _ref.onClick, onClear = _ref.onClear, testId = _ref.testId, isDisabled = _ref.isDisabled, ariaLabel = _ref.ariaLabel;
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $933b8fb1ecc9c28f$export$b61655080b0a1f32), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $31da74042ec4ef60$export$c7a90a9f6120efb7), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dUWEU.default), {
        isSelected: !hideSelectedIndicator && isSelected,
        iconBefore: triggerIcon,
        testId: testId
    }, children, ":")));
    var afterTriggerIcon = onClear ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1c244c3d2b2e58d4$export$cd8104a6ec6bb897), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7b6b8b826eb2c2aa$export$13ec83e50bf04290), {
        onClick: function onClick(e) {
            e.stopPropagation();
            onClear === null || onClear === void 0 || onClear();
        },
        label: "Remove criteria"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h19KG))), {
        color: "currentColor",
        label: "",
        size: "small"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $933b8fb1ecc9c28f$export$b61655080b0a1f32), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1c244c3d2b2e58d4$export$d53c836cccbb0d90), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dUWEU.default), {
        appearance: isInvalid ? 'danger' : 'default',
        isSelected: !hideSelectedIndicator && (isSelected || hasValues),
        iconBefore: triggerIcon,
        iconAfter: function iconAfter() {
            return afterTriggerIcon;
        },
        onClick: onClick,
        ref: ref,
        testId: testId,
        "aria-expanded": isSelected,
        isDisabled: isDisabled,
        "aria-label": ariaLabel && ariaLabel
    }, onClear ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $auVZV.Box), {
        xcss: $bd7df4e567703426$var$textPadding.root
    }, children) : children)));
});
var $bd7df4e567703426$export$2e2bcd8739ae039 = $bd7df4e567703426$export$d7b370c39c0de454;


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $6Qk7v = parcelRequire("6Qk7v");
var $8b7554b4758d7ba6$export$e74528b7a1d409c0 = (0, $6Qk7v.default).div({
    display: 'flex'
});


var $57e93f82e6ef5a0a$var$PaginatedFilter = function PaginatedFilter(props) {
    var _props$initiallyOpene = props.initiallyOpened, initiallyOpened = _props$initiallyOpene === void 0 ? false : _props$initiallyOpene, onOpen = props.onOpen, onClose = props.onClose, fieldId = props.fieldId, fieldLabel = props.fieldLabel, fieldLabelIcon = props.fieldLabelIcon, fieldInvalidLabel = props.fieldInvalidLabel, formatOptionLabel = props.formatOptionLabel, hideClearSelection = props.hideClearSelection, initiallyAddSelectedFirst = props.initiallyAddSelectedFirst, inModal = props.inModal, _props$isMulti = props.isMulti, isMulti = _props$isMulti === void 0 ? true : _props$isMulti, onChange = props.onChange, onLoadOptions = props.onLoadOptions, onClearValues = props.onClearValues, onPickerTriggerClick = props.onPickerTriggerClick, onPickerTriggerClear = props.onPickerTriggerClear, triggerRef = props.triggerRef, PopupComponent = props.PopupComponent, testId = props.testId, value = props.value, showFooter = props.showFooter, hideSelectedIndicator = props.hideSelectedIndicator, ariaLabel = props.ariaLabel, isLoading = props.isLoading, isDisabled = props.isDisabled;
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(initiallyOpened), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState, 2), isFilterOpen = _React$useState2[0], setIsFilterOpen = _React$useState2[1];
    var wrapperRef = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(null);
    var internalTriggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(null);
    var cancelPendingFocusRestore = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        return function() {
            var _cancelPendingFocusRe;
            return (_cancelPendingFocusRe = cancelPendingFocusRestore.current) === null || _cancelPendingFocusRe === void 0 ? void 0 : _cancelPendingFocusRe.call(cancelPendingFocusRestore);
        };
    }, []);
    var handlePickerTriggerClick = function handlePickerTriggerClick() {
        var newIsFilterOpen = !isFilterOpen;
        setIsFilterOpen(newIsFilterOpen);
        if (onPickerTriggerClick) onPickerTriggerClick();
        if (newIsFilterOpen && onOpen) onOpen();
        if (!newIsFilterOpen && onClose) onClose();
    };
    var handleClose = function handleClose() {
        var _wrapper$ownerDocumen, _cancelPendingFocusRe2;
        // While the popup is open `@atlaskit/popup` holds a focus trap that rejects focus
        // on anything outside it, so the trigger cannot be refocused until the popup leaves the DOM —
        // the popup's exit motion delays that further so we listen for a close before restoring focus.
        var wrapper = wrapperRef.current;
        var focusedOnClose = (_wrapper$ownerDocumen = wrapper === null || wrapper === void 0 ? void 0 : wrapper.ownerDocument.activeElement) !== null && _wrapper$ownerDocumen !== void 0 ? _wrapper$ownerDocumen : null;
        setIsFilterOpen(false);
        if (onClose) onClose();
        (_cancelPendingFocusRe2 = cancelPendingFocusRestore.current) === null || _cancelPendingFocusRe2 === void 0 || _cancelPendingFocusRe2.call(cancelPendingFocusRestore);
        // Focus already outside the filter means an outside-pointer dismissal - no-op
        if (!wrapper || !focusedOnClose || !wrapper.contains(focusedOnClose)) return;
        var restore = function restore() {
            var _internalTriggerRef$c;
            // Only reclaim focus that is unowned.
            var active = wrapper.ownerDocument.activeElement;
            if (active && active !== wrapper.ownerDocument.body) return;
            (_internalTriggerRef$c = internalTriggerRef.current) === null || _internalTriggerRef$c === void 0 || _internalTriggerRef$c.focus({
                focusVisible: true
            });
        };
        if (!focusedOnClose.isConnected) {
            restore();
            return;
        }
        var observer = new MutationObserver(function() {
            if (focusedOnClose.isConnected) return;
            observer.disconnect();
            cancelPendingFocusRestore.current = null;
            restore();
        });
        observer.observe(wrapper, {
            childList: true,
            subtree: true
        });
        cancelPendingFocusRestore.current = function() {
            return observer.disconnect();
        };
    };
    var handleChange = function handleChange(options, option, selectData) {
        if (onChange) onChange(options, option, selectData);
    };
    var handleClearValues = function handleClearValues() {
        if (onClearValues) onClearValues();
    };
    var handleTrigger = function handleTrigger(_ref) {
        var ref = _ref.ref;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $auVZV.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bd7df4e567703426$export$2e2bcd8739ae039), {
            hasValues: value.length > 0,
            onClick: handlePickerTriggerClick,
            isSelected: isFilterOpen,
            hideSelectedIndicator: hideSelectedIndicator,
            triggerIcon: fieldLabelIcon,
            isInvalid: value.some(function(val) {
                return val.invalid;
            }),
            ref: (0, $7igKY.mergeRefs)(triggerRef ? [
                ref,
                internalTriggerRef,
                triggerRef
            ] : [
                ref,
                internalTriggerRef
            ]),
            testId: testId,
            onClear: onPickerTriggerClear !== null && onPickerTriggerClear !== void 0 ? onPickerTriggerClear : undefined,
            isLoading: isLoading,
            isDisabled: isDisabled
        }, (0, $a66e25a0480dd7ce$export$957d7daebd899f12)(fieldLabel, value)));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8b7554b4758d7ba6$export$e74528b7a1d409c0), {
        ref: wrapperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $40e78ff6e2a4a381$export$ba25329847403e11), {
        isOpen: isFilterOpen,
        onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($7WAD0)) //this doesn't do anything in paginated-picker
        ),
        onClose: handleClose,
        value: value,
        pagination: {
            enableFullList: false
        },
        fieldId: fieldId,
        fieldLabel: fieldLabel,
        fieldInvalidLabel: fieldInvalidLabel,
        formatOptionLabel: formatOptionLabel,
        initiallyAddSelectedFirst: initiallyAddSelectedFirst,
        onChange: handleChange,
        onLoadOptions: onLoadOptions,
        onTrigger: handleTrigger,
        onClearValues: handleClearValues,
        hideClearSelection: hideClearSelection,
        PopupComponent: PopupComponent,
        showFooter: showFooter,
        popupProps: inModal ? {
            zIndex: (0, $64A04.layers).modal()
        } : undefined,
        ariaLabel: ariaLabel,
        isMulti: isMulti
    }));
};
var $57e93f82e6ef5a0a$export$2e2bcd8739ae039 = $57e93f82e6ef5a0a$var$PaginatedFilter;


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $dd9f22de5c4baa98$export$2e2bcd8739ae039 = {
    'admin-hub-filter-controller.button.apply.label': 'Apply',
    'admin-hub-filter-controller.button.more-options.aria-label': 'More options',
    'admin-hub-filter-controller.button.more.label': 'More',
    'admin-hub-filter-controller.button.reset.label': 'Reset',
    'admin-hub-filter-controller.button.reset.label-descriptive': 'Reset filters',
    'admin-hub-filter-controller.refresh.count.current': 'Showing {currentCount, plural, one {# result} other {# results}} out of {totalCount} {label}',
    'admin-hub-filter-controller.refresh.count.current.test': 'Displaying results',
    'admin-hub-filter-controller.refresh.count.total': 'Showing {totalCount} {label}',
    'admin-hub-filter-controller.refresh.count.total.test': 'Displaying results',
    'admin-hub-filter-controller.refresh.item.default.label': '{totalCount, plural, one {item} other {items}}',
    'admin-hub-filter-controller.refresh.item.default.label.test': '{totalCount, plural, one {users} other {users}}',
    'admin-hub-filter-controller.refresh.loading': 'Checking for updates',
    'admin-hub-filter-controller.refresh.loading.test': 'Calculating results...',
    'admin-hub-filter-controller.wrapper.legend': 'Filter options'
};


var $fbf7741e01f26dad$export$2e2bcd8739ae039 = (0, $dd9f22de5c4baa98$export$2e2bcd8739ae039);



var $6bnW7 = parcelRequire("6bnW7");
var $0f8ed274ac3f35bf$export$defe85febe8b728c = (0, $6bnW7.defineMessages)({
    count: {
        id: 'admin-hub-filter-controller.refresh.count.total',
        defaultMessage: 'Showing {totalCount} {label}',
        description: 'Table count. This will display count of total number of items in the table.'
    },
    currentCount: {
        id: 'admin-hub-filter-controller.refresh.count.current',
        defaultMessage: 'Showing {currentCount, plural, one {# result} other {# results}} out of {totalCount} {label}',
        description: 'Table count. This will display filtered count of items in the table.'
    },
    loading: {
        id: 'admin-hub-filter-controller.refresh.loading',
        defaultMessage: 'Checking for updates',
        description: 'Message to show next to table count while product results are loading'
    },
    defaultItemLabel: {
        id: 'admin-hub-filter-controller.refresh.item.default.label',
        defaultMessage: '{totalCount, plural, one {item} other {items}}',
        description: 'Fallback item label shown in the table count area. Uses ICU plural form: singular when {totalCount} is 1 (shows "item"), plural otherwise (shows "items").'
    },
    reset: {
        id: 'admin-hub-filter-controller.button.reset.label',
        defaultMessage: 'Reset',
        description: 'Short text shown on the reset button in the filter controller toolbar, which clears all active filters.'
    },
    resetDescriptiveLabel: {
        id: 'admin-hub-filter-controller.button.reset.label-descriptive',
        defaultMessage: 'Reset filters',
        description: 'Longer accessible text shown on the reset button in the filter controller toolbar when more context is needed; clears all active filters.'
    },
    apply: {
        id: 'admin-hub-filter-controller.button.apply.label',
        defaultMessage: 'Apply',
        description: 'Text shown on the apply button in the filter controller toolbar, which applies the currently selected filter options.'
    },
    moreButton: {
        id: 'admin-hub-filter-controller.button.more.label',
        defaultMessage: 'More',
        description: 'Text shown on the overflow button in the filter controller toolbar that reveals additional filter options not visible in the main toolbar.'
    },
    moreOptions: {
        id: 'admin-hub-filter-controller.button.more-options.aria-label',
        defaultMessage: 'More options',
        description: 'Accessible label for the overflow button in the filter controller toolbar used by screen readers to describe the button that opens additional filter options.'
    },
    filterOptions: {
        id: 'admin-hub-filter-controller.wrapper.legend',
        defaultMessage: 'Filter options',
        description: 'Legend for the fieldset wrapper that contains all filters'
    }
});



var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");
function $eb0e8352a1e077e8$var$_tsRewriteRelativeImportExtensions(t, e) {
    return "string" == typeof t && /^\.\.?\//.test(t) ? t.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+)?)\.([cm]?)ts$/i, function(t, s, r, n, o) {
        return s ? e ? ".jsx" : ".js" : !r || n && o ? r + n + "." + o.toLowerCase() + "js" : t;
    }) : t;
}
var $eb0e8352a1e077e8$export$2b153a2030b0feb2 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(locale) {
        var messages, parentLocale, _messages, _t, _t2;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.prev = 0;
                    _context.next = 1;
                    return import(/* webpackChunkName: "@atlaskit-internal_@atlassian/filter-controller-i18n-[request]" */ $eb0e8352a1e077e8$var$_tsRewriteRelativeImportExtensions($eb0e8352a1e077e8$var$_tsRewriteRelativeImportExtensions("../../i18n/".concat(locale))));
                case 1:
                    messages = _context.sent;
                    return _context.abrupt("return", messages.default);
                case 2:
                    _context.prev = 2;
                    _t = _context["catch"](0);
                    _context.prev = 3;
                    parentLocale = locale.split(/[-_]/)[0];
                    _context.next = 4;
                    return import(/* webpackChunkName: "@atlaskit-internal_@atlassian/filter-controller-i18n-[request]" */ $eb0e8352a1e077e8$var$_tsRewriteRelativeImportExtensions($eb0e8352a1e077e8$var$_tsRewriteRelativeImportExtensions("../../i18n/".concat(parentLocale))));
                case 4:
                    _messages = _context.sent;
                    return _context.abrupt("return", _messages.default);
                case 5:
                    _context.prev = 5;
                    _t2 = _context["catch"](3);
                case 6:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                0,
                2
            ],
            [
                3,
                5
            ]
        ]);
    }));
    return function fetchMessagesForLocale(_x) {
        return _ref.apply(this, arguments);
    };
}();



var $5FkrB = parcelRequire("5FkrB");

var $bgNpv = parcelRequire("bgNpv");

var $dUWEU = parcelRequire("dUWEU");

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6Qk7v = parcelRequire("6Qk7v");
var $a9e1ebae745b0baa$export$d53c836cccbb0d90 = (0, $6Qk7v.default).div({
    marginLeft: "var(--ds-space-100, 8px)"
});


var $a55a28ba7ccbda7c$export$b8d0691b40a57c25 = function ApplyButton(_ref) {
    var onApply = _ref.onApply, testId = _ref.testId, appearance = _ref.appearance;
    var handleApply = function handleApply() {
        if (onApply) onApply();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a9e1ebae745b0baa$export$d53c836cccbb0d90), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dUWEU.default), {
        appearance: appearance,
        onClick: handleApply,
        testId: "".concat(testId, "-apply-button")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, $0f8ed274ac3f35bf$export$defe85febe8b728c).apply)));
};



var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7WAD0 = parcelRequire("7WAD0");

var $bgNpv = parcelRequire("bgNpv");
var $hrVKU = parcelRequire("hrVKU");

var $dUWEU = parcelRequire("dUWEU");
var $d0f579dc1c758542$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::07ce97dc138cd4f55e8a1bb0a6f266b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($d0f579dc1c758542$exports, "__esModule", {
    value: true
});
$d0f579dc1c758542$exports.default = void 0;

var $d0f579dc1c758542$var$_react = $d0f579dc1c758542$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $d0f579dc1c758542$var$_iconNew = $d0f579dc1c758542$var$_interopRequireDefault((parcelRequire("gDzom")));
function $d0f579dc1c758542$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/add
 * Usage guidance:
 * Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d0f579dc1c758542$var$AddIcon = (props)=>/*#__PURE__*/ $d0f579dc1c758542$var$_react.default.createElement($d0f579dc1c758542$var$_iconNew.default, Object.assign({
        name: "AddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 1.5v5.75h5.75v1.5H8.75v5.75h-1.5V8.75H1.5v-1.5h5.75V1.5z"/>`
    }, props));
$d0f579dc1c758542$var$AddIcon.displayName = 'AddIcon';
var $d0f579dc1c758542$var$_default = $d0f579dc1c758542$exports.default = $d0f579dc1c758542$var$AddIcon;



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $dY97G = parcelRequire("dY97G");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $9Pk7k = parcelRequire("9Pk7k");
var $hrVKU = parcelRequire("hrVKU");
var $8ca421dd4dbc1531$exports = {};
$parcel$export($8ca421dd4dbc1531$exports, "cs", () => $5b41fd689b6d26ca$export$2e2bcd8739ae039);
$parcel$export($8ca421dd4dbc1531$exports, "da", () => $09d980c0a9620311$export$2e2bcd8739ae039);
$parcel$export($8ca421dd4dbc1531$exports, "de", () => $95ac2ef7d7034a0f$export$2e2bcd8739ae039);
$parcel$export($8ca421dd4dbc1531$exports, "en", () => $eb969e29d8b82542$export$2e2bcd8739ae039);
$parcel$export($8ca421dd4dbc1531$exports, "en_GB", () => $1a76dd774aa49069$export$2e2bcd8739ae039);
$parcel$export($8ca421dd4dbc1531$exports, "en_ZZ", () => $3a7c5ffbb91bf505$export$2e2bcd8739ae039);
$parcel$export($8ca421dd4dbc1531$exports, "es", () => $9b9526fd3692d44b$export$2e2bcd8739ae039);
$parcel$export($8ca421dd4dbc1531$exports, "fi", () => $346098a47a3c1f29$export$2e2bcd8739ae039);
$parcel$export($8ca421dd4dbc1531$exports, "fr", () => $a6ad39cdaf832d94$export$2e2bcd8739ae039);
$parcel$export($8ca421dd4dbc1531$exports, "hu", () => $a7d145f0ff90473f$export$2e2bcd8739ae039);
$parcel$export($8ca421dd4dbc1531$exports, "it", () => $088a0a998a979b85$export$2e2bcd8739ae039);
$parcel$export($8ca421dd4dbc1531$exports, "ja", () => $ad420123ea2235f8$export$2e2bcd8739ae039);
$parcel$export($8ca421dd4dbc1531$exports, "ko", () => $ae12673a622607c7$export$2e2bcd8739ae039);
$parcel$export($8ca421dd4dbc1531$exports, "nb", () => $a67e096cca88f53c$export$2e2bcd8739ae039);
$parcel$export($8ca421dd4dbc1531$exports, "nl", () => $12f7086ba92f9b74$export$2e2bcd8739ae039);
$parcel$export($8ca421dd4dbc1531$exports, "pl", () => $2637c6c7d186b7c6$export$2e2bcd8739ae039);
$parcel$export($8ca421dd4dbc1531$exports, "pt_BR", () => $f559a3837bacd503$export$2e2bcd8739ae039);
$parcel$export($8ca421dd4dbc1531$exports, "ru", () => $7ba7605a50038c90$export$2e2bcd8739ae039);
$parcel$export($8ca421dd4dbc1531$exports, "sv", () => $8172e761ce7ff5c2$export$2e2bcd8739ae039);
$parcel$export($8ca421dd4dbc1531$exports, "th", () => $6dc26a79bcc29440$export$2e2bcd8739ae039);
$parcel$export($8ca421dd4dbc1531$exports, "tr", () => $407e6121f1bc7b69$export$2e2bcd8739ae039);
$parcel$export($8ca421dd4dbc1531$exports, "uk", () => $30fb90931055ddde$export$2e2bcd8739ae039);
$parcel$export($8ca421dd4dbc1531$exports, "vi", () => $48d4a2e7a3726da2$export$2e2bcd8739ae039);
$parcel$export($8ca421dd4dbc1531$exports, "zh", () => $784d5071ec5cd520$export$2e2bcd8739ae039);
$parcel$export($8ca421dd4dbc1531$exports, "zh_TW", () => $fe930f15f4c8d11a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $5b41fd689b6d26ca$export$2e2bcd8739ae039 = (0, $4672bf1808c68b64$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $09d980c0a9620311$export$2e2bcd8739ae039 = (0, $d8fef0778e15d1d6$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $95ac2ef7d7034a0f$export$2e2bcd8739ae039 = (0, $daf8b42b91e86c10$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $eb969e29d8b82542$export$2e2bcd8739ae039 = (0, $37c30cb00c70704e$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $1a76dd774aa49069$export$2e2bcd8739ae039 = (0, $2543f25c18640596$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $3a7c5ffbb91bf505$export$2e2bcd8739ae039 = (0, $051b7696dac56d44$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $9b9526fd3692d44b$export$2e2bcd8739ae039 = (0, $9b16e9f3d1b81c88$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $346098a47a3c1f29$export$2e2bcd8739ae039 = (0, $5f52fc96a507bb1a$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $a6ad39cdaf832d94$export$2e2bcd8739ae039 = (0, $2d51f53e504b141a$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $a7d145f0ff90473f$export$2e2bcd8739ae039 = (0, $d2e9b503a006f69b$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $088a0a998a979b85$export$2e2bcd8739ae039 = (0, $def3dfa3a7cdc286$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $ad420123ea2235f8$export$2e2bcd8739ae039 = (0, $e7171fbe3766ae77$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $ae12673a622607c7$export$2e2bcd8739ae039 = (0, $ca82c1416e813941$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $a67e096cca88f53c$export$2e2bcd8739ae039 = (0, $d79b90167a859e15$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $12f7086ba92f9b74$export$2e2bcd8739ae039 = (0, $76df351252d58f57$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $2637c6c7d186b7c6$export$2e2bcd8739ae039 = (0, $19526a32e57df974$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $f559a3837bacd503$export$2e2bcd8739ae039 = (0, $12269785a5c698e5$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $7ba7605a50038c90$export$2e2bcd8739ae039 = (0, $f44dd606d8f7c8f1$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $8172e761ce7ff5c2$export$2e2bcd8739ae039 = (0, $fd9dfbf5aab9861b$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $6dc26a79bcc29440$export$2e2bcd8739ae039 = (0, $f540d690ae612fab$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $407e6121f1bc7b69$export$2e2bcd8739ae039 = (0, $78593addc10c97f1$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $30fb90931055ddde$export$2e2bcd8739ae039 = (0, $e512b385403e4bbf$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $48d4a2e7a3726da2$export$2e2bcd8739ae039 = (0, $5f911a695ffa4182$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $784d5071ec5cd520$export$2e2bcd8739ae039 = (0, $627df7a03880c013$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $fe930f15f4c8d11a$export$2e2bcd8739ae039 = (0, $349cff05777e10b4$export$2e2bcd8739ae039);




var $c1998dab09d78331$var$i18n = $8ca421dd4dbc1531$exports;
var $c1998dab09d78331$var$getCodesFromLocale = function getCodesFromLocale(locale) {
    var match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale || '');
    if (!match) throw Error('Unable to get language and country from invalid Locale');
    var _match = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(match, 3), language = _match[1], country = _match[2];
    return {
        language: language.toLowerCase(),
        country: country.toUpperCase()
    };
};
var $c1998dab09d78331$export$b61655080b0a1f32 = function PaginatedPickerIntlProvider(_ref) {
    var children = _ref.children;
    var intl = (0, $hrVKU.default)();
    var _getCodesFromLocale = $c1998dab09d78331$var$getCodesFromLocale(intl.locale.toString()), language = _getCodesFromLocale.language, country = _getCodesFromLocale.country;
    var messages = $c1998dab09d78331$var$i18n["".concat(language, "_").concat(country)] || $c1998dab09d78331$var$i18n[language] || $c1998dab09d78331$var$i18n.en;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9Pk7k.default), {
        messages: messages,
        locale: intl.locale
    }, children);
};



var $iYJcE = parcelRequire("iYJcE");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");



var $50U6m = parcelRequire("50U6m");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
var $1d703e93fcf166f5$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $1d703e93fcf166f5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1d703e93fcf166f5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1d703e93fcf166f5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1d703e93fcf166f5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1d703e93fcf166f5$var$handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $1d703e93fcf166f5$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions, propsOptions = _ref.options, _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $1d703e93fcf166f5$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $5FkrB.useRef)(undefined);
    var mounted = (0, $5FkrB.useRef)(false);
    var _useState = (0, $5FkrB.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : ''), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(propsDefaultOptions === true), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $5FkrB.useState)(undefined), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $5FkrB.useState)([]), _useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState9, 2), loadedOptions = _useState0[0], setLoadedOptions = _useState0[1];
    var _useState1 = (0, $5FkrB.useState)(false), _useState10 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState1, 2), passEmptyOptions = _useState10[0], setPassEmptyOptions = _useState10[1];
    var _useState11 = (0, $5FkrB.useState)({}), _useState12 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState11, 2), optionsCache = _useState12[0], setOptionsCache = _useState12[1];
    var _useState13 = (0, $5FkrB.useState)(undefined), _useState14 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState13, 2), prevDefaultOptions = _useState14[0], setPrevDefaultOptions = _useState14[1];
    var _useState15 = (0, $5FkrB.useState)(undefined), _useState16 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState15, 2), prevCacheOptions = _useState16[0], setPrevCacheOptions = _useState16[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $5FkrB.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $5FkrB.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $5FkrB.useCallback)(function(newValue, actionMeta) {
        var inputValue = $1d703e93fcf166f5$var$handleInputChange(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? $1d703e93fcf166f5$var$_objectSpread($1d703e93fcf166f5$var$_objectSpread({}, optionsCache), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return $1d703e93fcf166f5$var$_objectSpread($1d703e93fcf166f5$var$_objectSpread({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}



var $5FkrB = parcelRequire("5FkrB");

var $bgNpv = parcelRequire("bgNpv");

var $jgNUw = parcelRequire("jgNUw");

var $6bnW7 = parcelRequire("6bnW7");
var $3e0b05b0e448e56b$var$message = (0, $6bnW7.defineMessages)({
    clearAllSelectedItemsButtonText: {
        id: 'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text',
        defaultMessage: 'Clear selection',
        description: 'Clicking this button will unselect all the selected items in the dropdown'
    }
});
var $3e0b05b0e448e56b$export$2e2bcd8739ae039 = $3e0b05b0e448e56b$var$message;


var $2ee9fbcaa15edf1c$export$1d4b7cda9e589b53 = function ClearSelectedItemsButton(_ref) {
    var onClear = _ref.onClear;
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    var onClearSelectedItems = (0, $5FkrB.useCallback)(function() {
        // sendAnalytics({
        //   actionSubjectId: 'filterSearchClearSelectedItems',
        //   createAnalyticsEvent,
        //   type,
        // });
        onClear && onClear();
    }, [
        onClear
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jgNUw.default), {
        onClick: onClearSelectedItems,
        appearance: "subtle-link",
        testId: "paginated-picker.ui.async-select.clear-selection-button.clear-selected-items"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, $3e0b05b0e448e56b$export$2e2bcd8739ae039).clearAllSelectedItemsButtonText));
};
var $2ee9fbcaa15edf1c$export$2e2bcd8739ae039 = $2ee9fbcaa15edf1c$export$1d4b7cda9e589b53;



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $25nEq = parcelRequire("25nEq");
/* indicators-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");
var $966e339201715f57$export$26417cabd806a658 = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};


var $28cddc4c9d1f84b3$var$indicatorContainerStyles = null;
var $28cddc4c9d1f84b3$export$d0ffd7e649cab6f = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $966e339201715f57$export$26417cabd806a658)(props, 'indicatorsContainer', {
        indicators: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $hUFig.cx)(className, xcss, '-IndicatorsContainer')
        ])
    }, innerProps), children);
};


/* multi-value-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");
var $d83d9e99532d5b11$var$multiValueStyles = {
    root: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _1e0c1txw _1ul9ze3t _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _bfhk1j9a _p12f1osq _syazi7uo _3yq3glyw",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk15s3 _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
var $d83d9e99532d5b11$export$cf9cf2a30a59265c = function MultiValueContainer(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isFocused = _ref.isFocused, isDisabled = _ref.isDisabled, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $d83d9e99532d5b11$var$multiValueStyles.root,
            isDisabled && $d83d9e99532d5b11$var$multiValueStyles.disabled,
            isFocused && $d83d9e99532d5b11$var$multiValueStyles.focused,
            (0, $hUFig.cx)(className, xcss, '-multiValue')
        ])
    }), children);
};


/* select-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $f65534f2b9588afe$var$containerStyles = {
    default: "_11c81d4k _kqswh2mm _lcxv1rj4 _1tn2fhey",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf"
};
var $f65534f2b9588afe$export$446eebadefe1123b = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl, xcss = props.xcss;
    var _getStyleProps = (0, $966e339201715f57$export$26417cabd806a658)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), className = _getStyleProps.className, css = _getStyleProps.css;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $f65534f2b9588afe$var$containerStyles.default,
            isRtl && $f65534f2b9588afe$var$containerStyles.rtl,
            isDisabled && $f65534f2b9588afe$var$containerStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-container')
        ]),
        style: css
    }, innerProps), children);
};


/* value-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $ISKn7 = parcelRequire("ISKn7");
var $929bde0f84b6a560$var$_process, $929bde0f84b6a560$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $929bde0f84b6a560$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($929bde0f84b6a560$var$_process = globalThis.process) === null || $929bde0f84b6a560$var$_process === void 0 || ($929bde0f84b6a560$var$_process = $929bde0f84b6a560$var$_process.env) === null || $929bde0f84b6a560$var$_process === void 0 ? void 0 : $929bde0f84b6a560$var$_process.JEST_WORKER_ID) !== undefined;
var $929bde0f84b6a560$var$DEBUG_MODE = !$929bde0f84b6a560$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($929bde0f84b6a560$var$_process2 = globalThis.process) === null || $929bde0f84b6a560$var$_process2 === void 0 || ($929bde0f84b6a560$var$_process2 = $929bde0f84b6a560$var$_process2.env) === null || $929bde0f84b6a560$var$_process2 === void 0 ? void 0 : $929bde0f84b6a560$var$_process2.NODE_ENV) !== 'production';
var $929bde0f84b6a560$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$929bde0f84b6a560$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $dfd24f8d32492f00$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $dfd24f8d32492f00$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
var $dfd24f8d32492f00$export$75f4a1454eff2805 = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';


var $0d2ee846f780f5c8$export$b574c24e1e6490f5 = (0, $dfd24f8d32492f00$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $5bb307455b3832fb$export$92f8b531feaeb23d = (0, $dfd24f8d32492f00$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $72f475eb57fe4bb7$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $72f475eb57fe4bb7$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$72f475eb57fe4bb7$export$54ea85357b4e0159[0, $dfd24f8d32492f00$export$7e41b1b2bdee3f98] = $72f475eb57fe4bb7$export$54ea85357b4e0159[0, $dfd24f8d32492f00$export$7e41b1b2bdee3f98] || $72f475eb57fe4bb7$var$DEFAULT_PFF_GLOBAL;



var $0b458358e69c9177$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $0d2ee846f780f5c8$export$b574c24e1e6490f5) || (0, $5bb307455b3832fb$export$92f8b531feaeb23d);
function $0b458358e69c9177$export$6333b6aff9fc6275(flagKey) {
    if ($0b458358e69c9177$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $929bde0f84b6a560$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $dfd24f8d32492f00$export$407f05df8e3ce9f3), flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = (0, $72f475eb57fe4bb7$export$54ea85357b4e0159)[0, $dfd24f8d32492f00$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = (0, $72f475eb57fe4bb7$export$54ea85357b4e0159)[0, $dfd24f8d32492f00$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $ISKn7.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = (0, $72f475eb57fe4bb7$export$54ea85357b4e0159)[0, $dfd24f8d32492f00$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $0ac0b27860a1d4ae$export$b40ec24ac8275656(name) {
    return (0, $0b458358e69c9177$export$6333b6aff9fc6275)(name);
}



var $89630d123f8d2966$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _y4ti12x7 _bozg12x7",
    verticalPaddingStandard: "_1q51v77o _85i5v77o",
    verticalPaddingTagUpliftMulti: "_1q511b66 _85i51b66",
    verticalPaddingTagUpliftCompactMulti: "_1q51v77o _85i5v77o",
    verticalPaddingCompactNonUplift: "_1q51ze3t _85i5ze3t",
    flex: "_1e0c1txw",
    flexWithGap: "_zulp1b66 _1e0c1txw _1n261g80"
};
var $89630d123f8d2966$export$4dc9f58ad9a1a000 = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue, isCompact = props.isCompact, xcss = props.xcss, controlShouldRenderValue = props.selectProps.controlShouldRenderValue;
    var _getStyleProps = (0, $966e339201715f57$export$26417cabd806a658)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    var ffTagUplifts = (0, $0ac0b27860a1d4ae$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts');
    var tagUpliftMultiVertical = ffTagUplifts && isMulti;
    var tagUpliftChipRow = ffTagUplifts && isMulti && hasValue && controlShouldRenderValue;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $89630d123f8d2966$var$valueContainerStyles.default,
            tagUpliftMultiVertical && isCompact && $89630d123f8d2966$var$valueContainerStyles.verticalPaddingTagUpliftCompactMulti,
            tagUpliftMultiVertical && !isCompact && $89630d123f8d2966$var$valueContainerStyles.verticalPaddingTagUpliftMulti,
            !tagUpliftMultiVertical && !isCompact && $89630d123f8d2966$var$valueContainerStyles.verticalPaddingStandard,
            !tagUpliftMultiVertical && isCompact && $89630d123f8d2966$var$valueContainerStyles.verticalPaddingCompactNonUplift,
            isMulti && hasValue && controlShouldRenderValue && $89630d123f8d2966$var$valueContainerStyles.flex,
            tagUpliftChipRow && $89630d123f8d2966$var$valueContainerStyles.flexWithGap,
            (0, $hUFig.cx)(className, xcss, '-ValueContainer')
        ]),
        style: css
    }, innerProps), children);
};


/* control.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");


var $a311a5454302119b$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkofajl _v564r5cv _1h6drsbi _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _15peftgi _1ke8ftgi _jaboglyw _1u6luvb6 _4cvxrsbi _123byq51 _d0altlke _irr3l4ek _1ogl1caj",
    defaultT26Shape: "_2rko1qi0",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsvyy1",
    disabled: "_1h6d187o _lcxvglyw _bfhk187o _1u6lfrlt",
    focused: "_1h6d1v1w _bfhkr01l _16qsvyy1 _1u6lvyy1 _4cvx1v1w _irr3r01l",
    subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
var $a311a5454302119b$var$Control = function Control(props) {
    var children = props.children, appearance = props.appearance, isCompact = props.isCompact, isDisabled = props.isDisabled, isFocused = props.isFocused, isInvalid = props.isInvalid, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen, xcss = props.xcss;
    var _getStyleProps = (0, $966e339201715f57$export$26417cabd806a658)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: innerRef,
        className: (0, $970q7.default)([
            $a311a5454302119b$var$styles.default,
            (0, $0ac0b27860a1d4ae$export$b40ec24ac8275656)('platform-dst-shape-theme-default') && $a311a5454302119b$var$styles.defaultT26Shape,
            isDisabled && $a311a5454302119b$var$styles.disabled,
            isInvalid && $a311a5454302119b$var$styles.invalid,
            isCompact && $a311a5454302119b$var$styles.compact,
            appearance === 'subtle' && $a311a5454302119b$var$styles.subtle,
            appearance === 'subtle' && isFocused && $a311a5454302119b$var$styles.subtleFocused,
            isFocused && $a311a5454302119b$var$styles.focused,
            appearance === 'none' && $a311a5454302119b$var$styles.none,
            (0, $hUFig.cx)(className, xcss, '-control')
        ]),
        style: css
    }, innerProps, {
        "aria-disabled": (0, $0ac0b27860a1d4ae$export$b40ec24ac8275656)('platform_dst_select_disabled_a11y_fix') ? undefined : isDisabled || undefined
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a311a5454302119b$export$2e2bcd8739ae039 = $a311a5454302119b$var$Control;


/* group.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $0df35c2f916e37b9$var$styles = {
    root: "_85i5u2gc _1q51u2gc"
};
var $0df35c2f916e37b9$var$Group = function Group(props) {
    var children = props.children, builtinCX = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, selectProps = props.selectProps, xcss = props.xcss;
    var _getStyleProps = (0, $966e339201715f57$export$26417cabd806a658)(props, 'group', {
        group: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $0df35c2f916e37b9$var$styles.root,
            (0, $hUFig.cx)(className, xcss, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className, '-Group')
        ])
    }), label && /*#__PURE__*/ $5FkrB.createElement(Heading, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, headingProps, {
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: builtinCX
    }), label), /*#__PURE__*/ $5FkrB.createElement("div", null, children));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0df35c2f916e37b9$export$2e2bcd8739ae039 = $0df35c2f916e37b9$var$Group;


/* group-heading.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");


var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");
var $b50ae6de28207c1e$var$_excluded = [
    "className",
    "clearValue",
    "cx",
    "xcss",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue"
];
function $b50ae6de28207c1e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b50ae6de28207c1e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b50ae6de28207c1e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b50ae6de28207c1e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b50ae6de28207c1e$export$8e9fd4287627890c = function cleanCommonProps(props) {
    //className
    var className = props.className, clearValue = props.clearValue, cx = props.cx, xcss = props.xcss, getStyles = props.getStyles, getClassNames = props.getClassNames, getValue = props.getValue, hasValue = props.hasValue, isMulti = props.isMulti, isRtl = props.isRtl, options = props.options, selectOption = props.selectOption, selectProps = props.selectProps, setValue = props.setValue, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $b50ae6de28207c1e$var$_excluded);
    return $b50ae6de28207c1e$var$_objectSpread({}, innerProps);
};


var $d1862782734ed219$var$_excluded = [
    "data"
];
var $d1862782734ed219$var$headingStyles = null;
var $d1862782734ed219$export$85c8b41a3cd87edc = function GroupHeading(props) {
    var xcss = props.xcss;
    var _cleanCommonProps = (0, $b50ae6de28207c1e$export$8e9fd4287627890c)(props), data = _cleanCommonProps.data, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_cleanCommonProps, $d1862782734ed219$var$_excluded);
    var _getStyleProps = (0, $966e339201715f57$export$26417cabd806a658)(props, 'groupHeading', {
        'group-heading': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_11c8wadc _1e0c1ule _syazazsu _80om73ad _k48pwu06 _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $hUFig.cx)(className, xcss, '-group')
        ]),
        style: css
    }, innerProps));
};


/* clear-indicator.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $eNN4d = parcelRequire("eNN4d");

var $btdNC = parcelRequire("btdNC");

var $1e3518d74d68eed0$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _1q51v77o _y4tiv77o _85i5v77o _bozgv77o"
};
var $1e3518d74d68eed0$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1rpy _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf"
};
var $1e3518d74d68eed0$export$ecf9cf59142dd54a = function ClearIndicator(props) {
    var innerProps = props.innerProps, _props$clearControlLa = props.clearControlLabel, clearControlLabel = _props$clearControlLa === void 0 ? 'clear' : _props$clearControlLa, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $966e339201715f57$export$26417cabd806a658)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $1e3518d74d68eed0$var$clearIndicatorStyles.default,
            isCompact && $1e3518d74d68eed0$var$clearIndicatorStyles.compact,
            (0, $hUFig.cx)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $btdNC.Pressable), {
        xcss: $1e3518d74d68eed0$var$iconContainerStyles.root,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eNN4d))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
};


/* dropdown-indicator.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $h19KG = parcelRequire("h19KG");


var $m5IEn = parcelRequire("m5IEn");
var $btdNC = parcelRequire("btdNC");

var $552465232ad1e8b5$var$_excluded = [
    "aria-hidden"
];
var $552465232ad1e8b5$var$dropdownWrapperStyles = {
    root: "_1q5112x7 _y4ti12x7 _85i512x7 _bozg12x7"
};
// Reset styles for the voice-control <Pressable> so the chevron renders
// pixel-identical to the gate-off icon-in-a-div. Uses @atlaskit/css cssMap
// (aliased as strictCssMap) because Pressable's xcss prop requires that type.
var $552465232ad1e8b5$var$voiceControlPressableStyles = {
    root: "_1rjcidpf _18zridpf _1mouidpf _195gidpf _bfhk1j28 _1e0c1txw _4cvr1h6o"
};
// Inline size reset applied as a last resort (see the `style` prop docs on
// @atlaskit/primitives). Consumers ship global element selectors such as
// `& button { min-width: 149px }` (e.g. Jira Plans' hierarchy filter — see
// https://hello.jira.atlassian.cloud/jira/browse/JPO-42328) whose (class +
// element) specificity outranks the atomic single-class styles above, stretching
// this button and pushing the chevron toward the middle of the control. Inline
// styles outrank any selector, so the button always hugs the chevron and stays
// right-aligned like the gate-off icon-in-a-div.
var $552465232ad1e8b5$var$voiceControlPressableSizeReset = {
    minWidth: 0,
    width: 'auto'
};
var $552465232ad1e8b5$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syazazsu _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf",
    disabled: "_syaz1gmx"
};
var $552465232ad1e8b5$export$ec98719d3db7f2e4 = function DropdownIndicator(props) {
    var _props$innerProps = props.innerProps, innerProps = _props$innerProps === void 0 ? {} : _props$innerProps, children = props.children, isDisabled = props.isDisabled, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $966e339201715f57$export$26417cabd806a658)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    var ariaHidden = innerProps['aria-hidden'], restInnerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(innerProps, $552465232ad1e8b5$var$_excluded);
    var isVoiceControlAccessible = (0, $0ac0b27860a1d4ae$export$b40ec24ac8275656)('platform_dst_select_dropdown_voice_control');
    // Stable testid for the hoisted aria-hidden children wrapper (avoids parentElement in tests).
    var wrapperTestId = restInnerProps['data-testid'] ? "".concat(restInnerProps['data-testid'], "-children") : undefined;
    var voiceControlAccessibleIndicator = children ? /*#__PURE__*/ $5FkrB.createElement("div", {
        "aria-hidden": ariaHidden,
        "data-testid": wrapperTestId
    }, children) : /*#__PURE__*/ $5FkrB.createElement((0, $btdNC.Pressable), {
        tabIndex: -1,
        "aria-label": "toggle select menu",
        isDisabled: isDisabled,
        componentName: "DropdownIndicatorVoiceControl",
        xcss: $552465232ad1e8b5$var$voiceControlPressableStyles.root,
        style: $552465232ad1e8b5$var$voiceControlPressableSizeReset
    }, /*#__PURE__*/ $5FkrB.createElement((0, $m5IEn.Inline), {
        as: "span",
        xcss: $552465232ad1e8b5$var$dropdownWrapperStyles.root
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($h19KG))), {
        color: "currentColor",
        label: "open",
        size: "small"
    })));
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $552465232ad1e8b5$var$dropdownStyles.default,
            isDisabled && $552465232ad1e8b5$var$dropdownStyles.disabled,
            isCompact && $552465232ad1e8b5$var$dropdownStyles.compact,
            (0, $hUFig.cx)(className, xcss, '-indicatorContainer')
        ])
    }, restInnerProps, {
        "aria-hidden": isVoiceControlAccessible ? undefined : ariaHidden
    }), isVoiceControlAccessible ? voiceControlAccessibleIndicator : children !== null && children !== void 0 ? children : /*#__PURE__*/ $5FkrB.createElement((0, $m5IEn.Inline), {
        as: "span",
        xcss: $552465232ad1e8b5$var$dropdownWrapperStyles.root
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($h19KG))), {
        color: "currentColor",
        label: "open",
        size: "small"
    })));
};


/* loading-indicator.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $9ztDu = parcelRequire("9ztDu");

var $f5d9bbe5852971a9$var$_excluded = [
    "innerProps",
    "isRtl",
    "size",
    "isCompact",
    "xcss"
];
function $f5d9bbe5852971a9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f5d9bbe5852971a9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f5d9bbe5852971a9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f5d9bbe5852971a9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f5d9bbe5852971a9$var$loadingIndicatorStyles = {
    default: "_1q5112x7 _y4tiu2gc _85i512x7 _bozgu2gc",
    compact: "_1q51idpf _85i5idpf"
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $f5d9bbe5852971a9$export$7c20be4c1d342248 = function LoadingIndicator(_ref) {
    var innerProps = _ref.innerProps, isRtl = _ref.isRtl, _ref$size = _ref.size, size = _ref$size === void 0 ? 4 : _ref$size, isCompact = _ref.isCompact, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $f5d9bbe5852971a9$var$_excluded);
    var _getStyleProps = (0, $966e339201715f57$export$26417cabd806a658)($f5d9bbe5852971a9$var$_objectSpread($f5d9bbe5852971a9$var$_objectSpread({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $f5d9bbe5852971a9$var$loadingIndicatorStyles.default,
            isCompact && $f5d9bbe5852971a9$var$loadingIndicatorStyles.compact,
            (0, $hUFig.cx)(className, xcss, '-loadingIndicator')
        ])
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $9ztDu.default), {
        size: "small"
    }));
};


/* input.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");



var $19573245e907a875$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName",
    "testId"
];
var $19573245e907a875$var$inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
var $19573245e907a875$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
var $19573245e907a875$var$nativeInputStylesOld = null;
var $19573245e907a875$var$nativeInputStyles = null;
var $19573245e907a875$var$hidden = null;
var $19573245e907a875$var$Input = function Input(props) {
    var builtinCX = props.cx, value = props.value, xcss = props.xcss, isMulti = props.isMulti;
    var _cleanCommonProps = (0, $b50ae6de28207c1e$export$8e9fd4287627890c)(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, testId = _cleanCommonProps.testId, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_cleanCommonProps, $19573245e907a875$var$_excluded);
    var dataId = testId ? "".concat(testId, "-select--input") : null;
    var _getStyleProps = (0, $966e339201715f57$export$26417cabd806a658)(props, 'input', {
        'input-container': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    var ffTagUplifts = (0, $0ac0b27860a1d4ae$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts');
    if ((0, $0ac0b27860a1d4ae$export$b40ec24ac8275656)('platform_fix_input_component_styling')) return /*#__PURE__*/ $5FkrB.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $19573245e907a875$var$inputStyles.root,
            isMulti && ffTagUplifts && $19573245e907a875$var$inputStyles.labellingFFStyles,
            isDisabled && $19573245e907a875$var$inputStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $19573245e907a875$var$inputStylesOld.root,
            isMulti && ffTagUplifts && $19573245e907a875$var$inputStylesOld.labellingFFStyles,
            isDisabled && $19573245e907a875$var$inputStylesOld.disabled,
            (0, $hUFig.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$19573245e907a875$export$2e2bcd8739ae039 = $19573245e907a875$var$Input;


/* menu.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");


var $84714ffe32836da2$var$menuStyles = {
    root: "_2rko12b0 _kqswstnw _1bsb1osq _1pbykb7n _6rthu2gc _1pfhu2gc _bfhk1bhr _16qs130s",
    rootT26Shape: "_2rko1mok",
    bottom: "_152t1osq",
    top: "_u7co1osq"
};
var $84714ffe32836da2$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottom' : _props$placement, xcss = props.xcss;
    var _getStyleProps = (0, $966e339201715f57$export$26417cabd806a658)(props, 'menu', {
        menu: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $84714ffe32836da2$var$menuStyles.root,
            $84714ffe32836da2$var$menuStyles[placement],
            (0, $0ac0b27860a1d4ae$export$b40ec24ac8275656)('platform-dst-shape-theme-default') && $84714ffe32836da2$var$menuStyles.rootT26Shape,
            (0, $hUFig.cx)(xcss, className, '-menu')
        ]),
        style: css,
        ref: innerRef
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$84714ffe32836da2$export$2e2bcd8739ae039 = $84714ffe32836da2$var$Menu;


/* menu-list.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

function $058c6574b2e0d939$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $058c6574b2e0d939$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $058c6574b2e0d939$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $058c6574b2e0d939$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $058c6574b2e0d939$var$menuListStyles = null;
var $058c6574b2e0d939$export$d4c4e98c5044dc8 = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti, maxHeight = props.maxHeight, xcss = props.xcss;
    var _getStyleProps = (0, $966e339201715f57$export$26417cabd806a658)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $hUFig.cx)(className, xcss, '-MenuList')
        ]),
        style: $058c6574b2e0d939$var$_objectSpread($058c6574b2e0d939$var$_objectSpread({}, css), {}, {
            maxHeight: maxHeight
        }),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};


/* menu-loading-message.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $72GAO = parcelRequire("72GAO");

var $6849e93c7b73357c$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
];
function $6849e93c7b73357c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6849e93c7b73357c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6849e93c7b73357c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6849e93c7b73357c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6849e93c7b73357c$var$noticeStyles = null;
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $6849e93c7b73357c$export$e928a71d039d3102 = function LoadingMessage(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? 'Loading...' : _ref$children, innerProps = _ref.innerProps, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $6849e93c7b73357c$var$_excluded);
    var _getStyleProps = (0, $966e339201715f57$export$26417cabd806a658)($6849e93c7b73357c$var$_objectSpread($6849e93c7b73357c$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $hUFig.cx)(className, xcss, '-LoadingMessage')
        ]),
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option"
    }), /*#__PURE__*/ $5FkrB.createElement((0, $72GAO.Text), {
        color: "color.text.subtle"
    }, children));
};


/* menu-no-options-message.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $72GAO = parcelRequire("72GAO");

var $eb0ef5474bb099f4$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
];
function $eb0ef5474bb099f4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eb0ef5474bb099f4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eb0ef5474bb099f4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eb0ef5474bb099f4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $eb0ef5474bb099f4$var$noticeStyles = null;
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $eb0ef5474bb099f4$export$d58b72b7d3c4072c = function NoOptionsMessage(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? 'No options' : _ref$children, innerProps = _ref.innerProps, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $eb0ef5474bb099f4$var$_excluded);
    var _getStyleProps = (0, $966e339201715f57$export$26417cabd806a658)($eb0ef5474bb099f4$var$_objectSpread($eb0ef5474bb099f4$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $hUFig.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        style: css,
        role: "option"
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $72GAO.Text), {
        color: "color.text.subtle"
    }, children));
};


/* menu-portal.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $6I9SI = parcelRequire("6I9SI");

var $aLeHs = parcelRequire("aLeHs");



var $5FkrB = parcelRequire("5FkrB");
var $6ff04e2f40099fe8$export$e001f626511a0ead = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


/* menu-portal-top-layer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $09c23c89e2422c74$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $4c40d27a6cfec688$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $ebe9701ecbedd7bf$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $4c40d27a6cfec688$export$644a49f3b8c50fcd));
    return namespace;
}


function $07ec2c2d1f3d588d$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $09c23c89e2422c74$export$5fbf4d7fae6cdc00));
    var namespace = (0, $ebe9701ecbedd7bf$export$1d57e79091cc3046)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}


/* popover.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $hUFig = parcelRequire("hUFig");

var $7QpUe = parcelRequire("7QpUe");

var $iO8GM = parcelRequire("iO8GM");

var $bvsoE = parcelRequire("bvsoE");

/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $b040081f96b6f7cf$export$63b6b0ff65d84d47(_ref) {
    var value = _ref.value;
    if (typeof value === 'number') return "".concat(value, "px");
    return value;
}


/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ var $2608c403eb64c7cb$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $2608c403eb64c7cb$export$63044d21bc3d3fa2(_ref) {
    var _placement$offset, _placement$axis, _placement$edge, _placement$align, _placement$offset$cro, _placement$offset2, _placement$offset$cro2, _placement$offset3;
    var placement = _ref.placement;
    var consumerGap = (_placement$offset = placement.offset) === null || _placement$offset === void 0 ? void 0 : _placement$offset.gap;
    return {
        axis: (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block',
        edge: (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end',
        align: (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center',
        offset: {
            gap: consumerGap === undefined ? $2608c403eb64c7cb$var$DEFAULT_GAP : (0, $b040081f96b6f7cf$export$63b6b0ff65d84d47)({
                value: consumerGap
            }),
            crossAxisShift: {
                value: (0, $b040081f96b6f7cf$export$63b6b0ff65d84d47)({
                    value: (_placement$offset$cro = (_placement$offset2 = placement.offset) === null || _placement$offset2 === void 0 || (_placement$offset2 = _placement$offset2.crossAxisShift) === null || _placement$offset2 === void 0 ? void 0 : _placement$offset2.value) !== null && _placement$offset$cro !== void 0 ? _placement$offset$cro : 0
                }),
                direction: (_placement$offset$cro2 = (_placement$offset3 = placement.offset) === null || _placement$offset3 === void 0 || (_placement$offset3 = _placement$offset3.crossAxisShift) === null || _placement$offset3 === void 0 ? void 0 : _placement$offset3.direction) !== null && _placement$offset$cro2 !== void 0 ? _placement$offset$cro2 : 'forwards'
            }
        }
    };
}


var $84551687e3a0d7dd$var$rolesThatMoveFocus = new Set([
    'dialog',
    'alertdialog',
    'menu',
    'listbox',
    'tree',
    'grid'
]);
function $84551687e3a0d7dd$export$b12adccf56228c71(_ref) {
    var role = _ref.role;
    if (!role) return false;
    return $84551687e3a0d7dd$var$rolesThatMoveFocus.has(role);
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $bvsoE = parcelRequire("bvsoE");
var $b9acdeb9fd185346$export$ff7706047246b98b = (0, $bvsoE.default)(function() {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});


function $e7dc441a9c42eefc$var$runCancellableSettlement(_ref) {
    var schedule = _ref.schedule, onSettled = _ref.onSettled;
    var isCancelled = false;
    schedule(function() {
        if (isCancelled) return;
        onSettled();
    });
    return function() {
        isCancelled = true;
    };
}
/**
 * Fires `onSettled` once all animations currently applied to `element`
 * finish or are cancelled. Returns a cleanup that prevents stale settlement.
 */ function $e7dc441a9c42eefc$var$runOnAnimationsSettled(_ref2) {
    var element = _ref2.element, onSettled = _ref2.onSettled;
    return $e7dc441a9c42eefc$var$runCancellableSettlement({
        onSettled: onSettled,
        schedule: function schedule(settle) {
            var _element$getAnimation, _element$getAnimation2;
            var animations = (_element$getAnimation = (_element$getAnimation2 = element.getAnimations) === null || _element$getAnimation2 === void 0 ? void 0 : _element$getAnimation2.call(element)) !== null && _element$getAnimation !== void 0 ? _element$getAnimation : [];
            Promise.allSettled(animations.map(function(animation) {
                return animation.finished;
            })).then(settle);
        }
    });
}
function $e7dc441a9c42eefc$export$1bccb45daf07907f(_ref3) {
    var isOpen = _ref3.isOpen, shouldAnimate = _ref3.shouldAnimate, elementRef = _ref3.elementRef, onEnterFinish = _ref3.onEnterFinish, onExitFinish = _ref3.onExitFinish;
    var willAnimate = shouldAnimate && !(0, $b9acdeb9fd185346$export$ff7706047246b98b)();
    var isNativeClosedRef = (0, $5FkrB.useRef)(false);
    // Promote `closed → entering`/`closed → open` synchronously during
    // render so the host element mounts in the same commit as the open
    // intent. All other transitions are driven by phase-specific effects.
    var _useState = (0, $5FkrB.useState)(function() {
        if (!isOpen) return 'closed';
        return willAnimate ? 'entering' : 'open';
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), phase = _useState2[0], setPhase = _useState2[1];
    // Rearm only after controlled state and the native lifecycle have both
    // reached closed. Resetting as soon as `isOpen` becomes false can erase a
    // closing toggle that was handled in the same React batch.
    if (!isOpen && phase === 'closed') isNativeClosedRef.current = false;
    if (isOpen && phase === 'closed' && !isNativeClosedRef.current) setPhase(willAnimate ? 'entering' : 'open');
    if (!isOpen && (phase === 'open' || phase === 'entering')) // Close intent. Move to `exiting` to gate the unmount on either
    // the exit transition (animated) or the closing toggle event
    // (non-animated). Includes interrupted entry (`entering → exiting`).
    setPhase('exiting');
    if (isOpen && phase === 'exiting' && !isNativeClosedRef.current) // Reopen mid-exit. With animation, jump back to `entering` and let
    // the entry transition restart from current visual state. Without
    // animation, jump straight to `open` (the handshake we were waiting
    // for is no longer relevant; the consumer wants the host visible
    // again synchronously).
    setPhase(willAnimate ? 'entering' : 'open');
    // Keep stable refs to the latest callbacks so effects and promise callbacks
    // always call the current callback without needing them in dependency arrays.
    var onEnterFinishRef = (0, $5FkrB.useRef)(onEnterFinish);
    onEnterFinishRef.current = onEnterFinish;
    var onExitFinishRef = (0, $5FkrB.useRef)(onExitFinish);
    onExitFinishRef.current = onExitFinish;
    // Animated entry: wait for all active animations and move to `open`.
    (0, $5FkrB.useEffect)(function() {
        if (phase !== 'entering') return;
        var element = elementRef.current;
        if (!element) return;
        return $e7dc441a9c42eefc$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                var _onEnterFinishRef$cur;
                // Fire the consumer callback before transitioning phase so any
                // state the consumer reads (refs, DOM nodes) is still attached
                // in the same synchronous tick, regardless of React batching
                // semantics.
                (_onEnterFinishRef$cur = onEnterFinishRef.current) === null || _onEnterFinishRef$cur === void 0 || _onEnterFinishRef$cur.call(onEnterFinishRef);
                setPhase(function(current) {
                    return current === 'entering' ? 'open' : current;
                });
            }
        });
    }, [
        phase,
        elementRef
    ]);
    // Non-animated entry callback. The lifecycle goes `closed → open`
    // directly with no `entering` phase; fire `onEnterFinish` on that jump.
    // A previous-phase ref avoids double-firing on the animated path.
    var prevPhaseForEntryRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForEntryRef.current;
        prevPhaseForEntryRef.current = phase;
        // Animated entry settle goes through `entering` and already fired
        // onEnterFinish above; only handle the non-animated direct jumps.
        if (prevPhase !== 'open' && phase === 'open' && prevPhase !== 'entering') {
            var _onEnterFinishRef$cur2;
            (_onEnterFinishRef$cur2 = onEnterFinishRef.current) === null || _onEnterFinishRef$cur2 === void 0 || _onEnterFinishRef$cur2.call(onEnterFinishRef);
        }
    }, [
        phase
    ]);
    // Animated exit: wait for all active animations, fire `onExitFinish`,
    // then move to `closed` to unmount the host.
    (0, $5FkrB.useEffect)(function() {
        if (phase !== 'exiting' || !willAnimate) return;
        var element = elementRef.current;
        if (!element) return;
        return $e7dc441a9c42eefc$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                var _onExitFinishRef$curr;
                // Fire the consumer callback before transitioning phase to
                // `closed`. The phase change drives the host element unmount,
                // and consumers expect to be able to read the element (or a
                // forwarded ref to it) inside `onExitFinish`. Doing this in
                // the safe order avoids relying on React's automatic batching
                // to keep the element attached across the callback.
                (_onExitFinishRef$curr = onExitFinishRef.current) === null || _onExitFinishRef$curr === void 0 || _onExitFinishRef$curr.call(onExitFinishRef);
                setPhase(function(current) {
                    return current === 'exiting' ? 'closed' : current;
                });
            }
        });
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    // Native dismissal is authoritative. Its toggle can arrive while controlled
    // state still says open, so remember that native state and do not
    // reopen until `isOpen` has first moved to false.
    (0, $5FkrB.useLayoutEffect)(function() {
        if (phase === 'exiting' && !willAnimate && isNativeClosedRef.current) setPhase('closed');
    }, [
        phase,
        willAnimate
    ]);
    var onToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState === 'open') {
            isNativeClosedRef.current = false;
            return;
        }
        if (event.newState !== 'closed') return;
        isNativeClosedRef.current = true;
        setPhase(function(current) {
            if (current === 'open' || current === 'entering') return 'exiting';
            if (current === 'exiting' && !willAnimate) return 'closed';
            return current;
        });
    }, [
        willAnimate
    ]);
    // Non-animated exit callback. There are no animations to wait for, so fire
    // `onExitFinish` on the transition into `exiting` (the unmount itself
    // is gated by the closing toggle handshake above).
    var prevPhaseForExitRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForExitRef.current;
        prevPhaseForExitRef.current = phase;
        // Only fire on the non-animated transition into `exiting`. The
        // animated path's `exiting → closed` settle already fires
        // `onExitFinish` from `runOnAnimationsSettled`.
        if (prevPhase !== 'exiting' && phase === 'exiting' && !willAnimate) {
            var _onExitFinishRef$curr2;
            (_onExitFinishRef$curr2 = onExitFinishRef.current) === null || _onExitFinishRef$curr2 === void 0 || _onExitFinishRef$curr2.call(onExitFinishRef);
        }
    }, [
        phase,
        willAnimate
    ]);
    return {
        phase: phase,
        onToggle: onToggle
    };
}



var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
var $cb5126337c38cb4b$var$topLayerSelector = '[popover], dialog, [role="dialog"], [role="alertdialog"]';
function $cb5126337c38cb4b$export$df8c72c64edc7260(_ref) {
    var element = _ref.element, container = _ref.container;
    return element.closest($cb5126337c38cb4b$var$topLayerSelector) === container.closest($cb5126337c38cb4b$var$topLayerSelector);
}


var $88e33d412ee1f36d$export$e1252723db1c541 = function() {
    // Common exclusion filter applied to every selector.
    var not = ':not([tabindex="-1"]):not([aria-disabled="true"]):not([aria-hidden="true"])';
    var notDisabled = ":not([disabled])".concat(not);
    var focusable = [
        "a[href]".concat(not),
        "area[href]".concat(not),
        "input".concat(notDisabled, ":not([type=\"hidden\"])"),
        "select".concat(notDisabled),
        "textarea".concat(notDisabled),
        "button".concat(notDisabled),
        "iframe".concat(not),
        "audio[controls]".concat(not),
        "video[controls]".concat(not),
        "[contenteditable]:not([contenteditable=\"false\"])".concat(not),
        "[tabindex]".concat(notDisabled)
    ];
    return {
        focusable: focusable.join(','),
        // Build the `:focus` selector
        focused: focusable.map(function(selector) {
            return "".concat(selector, ":focus");
        }).join(',')
    };
}();


function $a11c1b1017cce01e$export$f6768025e418420e(_ref) {
    var container = _ref.container, filter = _ref.filter;
    return Array.from(container.querySelectorAll((0, $88e33d412ee1f36d$export$e1252723db1c541).focusable)).filter(function(element) {
        return element instanceof HTMLElement;
    }).filter(function(element) {
        return (0, $cb5126337c38cb4b$export$df8c72c64edc7260)({
            element: element,
            container: container
        });
    }).filter(function(element) {
        return !filter || filter(element, container);
    });
}


function $7132dc42b9456c14$export$748138f04a69bf21(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $a11c1b1017cce01e$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}



function $f68bff14eda20fc2$export$73e81fa65335a75b(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $a11c1b1017cce01e$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}


/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * Returns `null` if there is no focused element within the container or if
 * the focused element is not in the list of focusable elements.
 */ 

function $45f51c7429db09fc$export$a7db88e6d491b450(_ref) {
    var _all$nextIndex;
    var container = _ref.container, direction = _ref.direction, filter = _ref.filter;
    var all = (0, $a11c1b1017cce01e$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    var current = container.querySelector((0, $88e33d412ee1f36d$export$e1252723db1c541).focused);
    if (!(current instanceof HTMLElement)) return null;
    var index = all.indexOf(current);
    if (index === -1) return null;
    var nextIndex = function() {
        if (direction === 'forwards') return (index + 1) % all.length;
        var proposed = index - 1;
        // if going into negative numbers, loop back to the last item
        return proposed < 0 ? all.length - 1 : proposed;
    }();
    return (_all$nextIndex = all[nextIndex]) !== null && _all$nextIndex !== void 0 ? _all$nextIndex : null;
}



var $lFhdZ = parcelRequire("lFhdZ");

function $74736b7e8233e939$export$b9590fdfeb5f722f(_ref) {
    var _getDocument;
    var container = _ref.container;
    var focused = (_getDocument = (0, $lFhdZ.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return !(0, $cb5126337c38cb4b$export$df8c72c64edc7260)({
        element: focused,
        container: container
    });
}


/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/outputs/menu-keyboard-decision.md
 */ function $4113d3313cb95307$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $4113d3313cb95307$export$4f6462e86a70abe5(_ref) {
    var elementRef = _ref.elementRef, role = _ref.role, phase = _ref.phase;
    var isVisible = phase !== 'closed';
    (0, $5FkrB.useEffect)(function() {
        var element = elementRef.current;
        if (!element || !$4113d3313cb95307$var$roleRequiresFocusWrap(role) || !isVisible) return;
        var unbind = (0, $7QpUe.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $74736b7e8233e939$export$b9590fdfeb5f722f)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                var direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                var next = (0, $45f51c7429db09fc$export$a7db88e6d491b450)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                var fallback = direction === 'forwards' ? (0, $7132dc42b9456c14$export$748138f04a69bf21)({
                    container: element
                }) : (0, $f68bff14eda20fc2$export$73e81fa65335a75b)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}



var $5FkrB = parcelRequire("5FkrB");

/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox regardless of role. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, or menu), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
var $dd7b4dba1fc4fef9$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $dd7b4dba1fc4fef9$var$isTextboxLikeElement(element) {
    var role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    var tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        var _element$getAttribute;
        var type = ((_element$getAttribute = element.getAttribute('type')) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : 'text').toLowerCase();
        return $dd7b4dba1fc4fef9$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $dd7b4dba1fc4fef9$var$isComboboxControllingPopup(_ref) {
    var _active$getAttribute;
    var container = _ref.container;
    var ownerDocument = container.ownerDocument;
    var active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$dd7b4dba1fc4fef9$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    var idRefs = (_active$getAttribute = active.getAttribute('aria-controls')) !== null && _active$getAttribute !== void 0 ? _active$getAttribute : active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    var referencedIds = idRefs.split(/\s+/).filter(function(id) {
        return id !== '';
    });
    return referencedIds.some(function(id) {
        var referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function $dd7b4dba1fc4fef9$var$getInitialFocusTarget(_ref2) {
    var container = _ref2.container, role = _ref2.role;
    if (role === 'dialog' || role === 'alertdialog') {
        // Prefer element with the native HTML autofocus attribute.
        var autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $7132dc42b9456c14$export$748138f04a69bf21)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific (menu / listbox) rather
    // than hoisted. Hoisting it over-matched on dialog popups that contain
    // a nested combobox (e.g. datetime-picker's dialog hosts a react-select),
    // where the active combobox's `aria-controls` falsely matched the
    // container and suppressed the dialog's own focus contract.
    if (role === 'menu') {
        if ($dd7b4dba1fc4fef9$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/outputs/menu-keyboard-decision.md
        return (0, $7132dc42b9456c14$export$748138f04a69bf21)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($dd7b4dba1fc4fef9$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        var selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        var firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $7132dc42b9456c14$export$748138f04a69bf21)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $dd7b4dba1fc4fef9$export$e992c40175757a22(_ref3) {
    var elementRef = _ref3.elementRef, phase = _ref3.phase, role = _ref3.role;
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    var prevPhaseRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var _getInitialFocusTarge;
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        var element = elementRef.current;
        if (!element) return;
        (_getInitialFocusTarge = $dd7b4dba1fc4fef9$var$getInitialFocusTarget({
            container: element,
            role: role
        })) === null || _getInitialFocusTarge === void 0 || _getInitialFocusTarge.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}


/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ var $ccf7c19f9a6de16a$var$supportsPopoverHint = (0, $bvsoE.default)(function() {
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    var element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
// Surface reset — neutralises inherited interaction and text-layout properties
// (e.g. `pointer-events: none` from an overlaid controls container and
// `white-space: nowrap` from an `@atlaskit/select` option) that leak into a
// top-layer element because, for CSS inheritance, it is still a DOM child of its
// trigger (top-layer promotion is paint/stacking only; the legacy portal path
// avoided this by rendering at `<body>`). Excludes `color`/`font` (theming) and
// `direction`/`unicode-bidi` (RTL must inherit).
//
// KEEP IN SYNC with the identical `surfaceResetStyles` in `dialog/dialog-content.tsx`.
// ADS forbids sharing styles across files (`no-exported-styles` /
// `no-imported-style-values` — Compiled styles are null at runtime), so the reset is
// co-located and duplicated deliberately.
var $ccf7c19f9a6de16a$var$surfaceResetStyles = {
    root: "_lcxv1wug _o5724jg8 _1nmz4jg8 _1i4q4jg8 _y3gnv2br _azhwidpf _1p1dglyw"
};
var $ccf7c19f9a6de16a$var$styles = {
    root: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r041wug _1reoewfl _18m9ewfl _bfhk1j28 _4t3i1wug",
    motion: "_k8m011k7 _1oecdn4k _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v179n",
    exit: "_y44vof1f"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
var $ccf7c19f9a6de16a$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ var $ccf7c19f9a6de16a$var$POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
var $ccf7c19f9a6de16a$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function Popover(_ref, ref) {
    var children = _ref.children, _ref$mode = _ref.mode, modeProp = _ref$mode === void 0 ? 'auto' : _ref$mode, onClose = _ref.onClose, onEnterFinish = _ref.onEnterFinish, onExitFinish = _ref.onExitFinish, _ref$shouldAnimate = _ref.shouldAnimate, shouldAnimate = _ref$shouldAnimate === void 0 ? false : _ref$shouldAnimate, placement = _ref.placement, testId = _ref.testId, isOpen = _ref.isOpen, enteringAnimationXcss = _ref.enteringAnimationXcss, exitingAnimationXcss = _ref.exitingAnimationXcss, role = _ref.role, label = _ref.label, labelledBy = _ref.labelledBy, idProp = _ref.id;
    var autoId = (0, $5FkrB.useId)();
    var ownRef = (0, $5FkrB.useRef)(null);
    var combinedRef = (0, $iO8GM.default)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    var popoverId = idProp !== null && idProp !== void 0 ? idProp : "popover-".concat(autoId.replace(/:/g, ''));
    var _useAnimatedVisibilit = (0, $e7dc441a9c42eefc$export$1bccb45daf07907f)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    }), phase = _useAnimatedVisibilit.phase, onToggle = _useAnimatedVisibilit.onToggle;
    // True while the host element is mounted (any phase except `closed`).
    // Used as a dep so listener-rebind effects re-attach after a remount.
    var isVisible = phase !== 'closed';
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // focus-capturing roles are handled below via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus-restoration.md.
    (0, $4113d3313cb95307$export$4f6462e86a70abe5)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    (0, $dd7b4dba1fc4fef9$export$e992c40175757a22)({
        elementRef: ownRef,
        phase: phase,
        role: role
    });
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined.
    var handleObserverClose = (0, $5FkrB.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose({
            reason: 'programmatic'
        });
    }, [
        onClose
    ]);
    (0, $07ec2c2d1f3d588d$export$469bb693f11edc7f)({
        type: role && $ccf7c19f9a6de16a$var$POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen: isOpen,
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    var mode = modeProp === 'hint' && !$ccf7c19f9a6de16a$var$supportsPopoverHint() ? 'auto' : modeProp;
    var popupMotionStyle = (0, $5FkrB.useMemo)(function() {
        if (!placement || !shouldAnimate) return undefined;
        var _resolvePlacement = (0, $2608c403eb64c7cb$export$63044d21bc3d3fa2)({
            placement: placement
        }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge;
        return $ccf7c19f9a6de16a$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]);
    // Prevents toggle handler from calling onClose for our own hidePopover() calls.
    var programmaticCloseRef = (0, $5FkrB.useRef)(false);
    // Set in capture-phase keydown so the toggle handler knows close reason.
    var closeReasonRef = (0, $5FkrB.useRef)('light-dismiss');
    // Snapshot of pre-open focus, used to restore focus for nested popovers
    // with focus-capturing roles (browser only restores the outermost).
    var previouslyFocusedElementRef = (0, $5FkrB.useRef)(null);
    var handleBeforeToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState !== 'open') return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- need active element snapshot
        var active = document.activeElement;
        previouslyFocusedElementRef.current = active instanceof HTMLElement ? active : null;
    }, []);
    var handleToggle = (0, $5FkrB.useCallback)(function(event) {
        var element = ownRef.current;
        if (event.newState === 'open') {
            onToggle(event);
            return;
        }
        if (event.newState === 'closed') {
            if (element) {
                // Nested-popover focus restoration fallback (browser only
                // restores outermost; Firefox skips nested entirely).
                // Restore only when the role moved focus in on open AND the
                // close was Escape/programmatic. For light dismiss, the
                // click target keeps focus per HTML spec
                // (`focusPreviousElement=false`).
                var previouslyFocused = previouslyFocusedElementRef.current;
                var reason = closeReasonRef.current;
                var isProgrammatic = programmaticCloseRef.current;
                var shouldRestore = previouslyFocused !== null && previouslyFocused.isConnected && (0, $84551687e3a0d7dd$export$b12adccf56228c71)({
                    role: role
                }) && (reason === 'escape' || isProgrammatic);
                if (shouldRestore && previouslyFocused) previouslyFocused.focus({
                    preventScroll: true
                });
                previouslyFocusedElementRef.current = null;
            }
            // Programmatic close: consumer already knows.
            if (programmaticCloseRef.current) // Reset reason so a stale 'escape' from a race with Escape keydown
            // does not corrupt the next browser-dismiss cycle.
            closeReasonRef.current = 'light-dismiss';
            else {
                // Browser dismiss (Escape/click-outside).
                var _reason = closeReasonRef.current;
                closeReasonRef.current = 'light-dismiss';
                // Optional: `manual` mode has no `onClose` in the forwarded type.
                onClose === null || onClose === void 0 || onClose({
                    reason: _reason
                });
            }
        }
        onToggle(event);
    }, [
        onClose,
        onToggle,
        role
    ]);
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `previouslyFocusedElementRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        var unbindEscape = (0, $7QpUe.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key === 'Escape') closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        var unbindToggle = (0, $7QpUe.bind)(element, {
            type: 'toggle',
            listener: handleToggle
        });
        // Snapshot `document.activeElement` before `useInitialFocus` moves it.
        var unbindBeforeToggle = (0, $7QpUe.bind)(element, {
            type: 'beforetoggle',
            listener: handleBeforeToggle
        });
        return function() {
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleToggle,
        handleBeforeToggle,
        isVisible
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            programmaticCloseRef.current = false;
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and the no-animation path unmounts before
            // `handleToggle` can reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch (_unused) {}
            return function() {
                programmaticCloseRef.current = true;
                try {
                    element.hidePopover();
                } catch (_unused2) {}
            };
        }
        programmaticCloseRef.current = true;
        try {
            element.hidePopover();
        } catch (_unused3) {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        ref: combinedRef,
        id: popoverId,
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        style: popupMotionStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $ccf7c19f9a6de16a$var$styles.root,
            $ccf7c19f9a6de16a$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $ccf7c19f9a6de16a$var$styles.enter,
            shouldAnimate && phase === 'exiting' && $ccf7c19f9a6de16a$var$styles.exit,
            shouldAnimate && $ccf7c19f9a6de16a$var$styles.motion,
            (0, $hUFig.cx)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ])
    }, children);
});



var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $45Zis = parcelRequire("45Zis");

var $bvsoE = parcelRequire("bvsoE");

var $25nEq = parcelRequire("25nEq");
function $a18805323616c858$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a18805323616c858$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a18805323616c858$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a18805323616c858$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * JS fallback positioning math. Used only when the browser does not
 * support CSS Anchor Positioning (less than 6% of users).
 *
 * Consumer-supplied `offset.gap` and `offset.crossAxisShift` are
 * honored: the caller (`useAnchorPosition`) resolves CSS length strings
 * (tokens, calc, var, etc) to pixels via a DOM probe before passing them
 * in. The caller also keeps the popover hidden (`opacity: 0`) until the
 * first measurement completes, so the popover never paints at the wrong
 * position.
 */ /**
 * A viewport-relative position, in pixels. Physical rather than logical
 * because it is written straight to `top` / `left`.
 */ /**
 * The cross-axis shift with its length already resolved to pixels.
 *
 * Mirrors `TCrossAxisShiftOffset`, whose `value` is an unresolved CSS length
 * string. Only this module needs the pixel form, because only this module does
 * the arithmetic itself.
 */ /**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function $a18805323616c858$var$computeEdgePosition(_ref) {
    var axis = _ref.axis, edge = _ref.edge, triggerRect = _ref.triggerRect, popoverWidth = _ref.popoverWidth, popoverHeight = _ref.popoverHeight, viewport = _ref.viewport, gap = _ref.gap;
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        var spaceBelow = viewport.height - triggerRect.bottom;
        var spaceAbove = triggerRect.top;
        var fitsBelow = spaceBelow >= popoverHeight + gap;
        var useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        var _spaceAbove = triggerRect.top;
        var _spaceBelow = viewport.height - triggerRect.bottom;
        var fitsAbove = _spaceAbove >= popoverHeight + gap;
        var useAbove = fitsAbove || _spaceAbove >= _spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        var spaceRight = viewport.width - triggerRect.right;
        var spaceLeft = triggerRect.left;
        var fitsRight = spaceRight >= popoverWidth + gap;
        var useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        var _spaceLeft = triggerRect.left;
        var _spaceRight = viewport.width - triggerRect.right;
        var fitsLeft = _spaceLeft >= popoverWidth + gap;
        var useLeft = fitsLeft || _spaceLeft >= _spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function $a18805323616c858$var$applyAlignment(_ref2) {
    var position = _ref2.position, axis = _ref2.axis, align = _ref2.align, triggerRect = _ref2.triggerRect, popoverWidth = _ref2.popoverWidth, popoverHeight = _ref2.popoverHeight;
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return $a18805323616c858$var$_objectSpread($a18805323616c858$var$_objectSpread({}, position), {}, {
            left: triggerRect.left
        });
        // align === 'end'
        return $a18805323616c858$var$_objectSpread($a18805323616c858$var$_objectSpread({}, position), {}, {
            left: triggerRect.right - popoverWidth
        });
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return $a18805323616c858$var$_objectSpread($a18805323616c858$var$_objectSpread({}, position), {}, {
        top: triggerRect.top
    });
    // align === 'end'
    return $a18805323616c858$var$_objectSpread($a18805323616c858$var$_objectSpread({}, position), {}, {
        top: triggerRect.bottom - popoverHeight
    });
}
/**
 * Applies the cross-axis shift offset.
 *
 * `forwards` always moves the popover toward the cross-axis END and
 * `backwards` toward the START, for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 *
 * This is a coordinate, so the direction is the sign and nothing else. There
 * is deliberately no per-`align` sign inversion here: the CSS path inverts the
 * sign only because a margin on the END side pushes a box the opposite way to
 * a margin on the START side, which is a property of margins rather than of
 * the shift. Applying that inversion to a coordinate moved `align: 'end'`
 * popovers the wrong way.
 */ function $a18805323616c858$var$applyCrossAxisShift(_ref3) {
    var position = _ref3.position, axis = _ref3.axis, crossAxisShift = _ref3.crossAxisShift;
    if (crossAxisShift.value === 0) return position;
    var directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    var delta = crossAxisShift.value * directionSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return $a18805323616c858$var$_objectSpread($a18805323616c858$var$_objectSpread({}, position), {}, {
        left: position.left + delta
    });
    return $a18805323616c858$var$_objectSpread($a18805323616c858$var$_objectSpread({}, position), {}, {
        top: position.top + delta
    });
}
function $a18805323616c858$export$d5ef1dac02135664(_ref4) {
    var triggerRect = _ref4.triggerRect, popoverEl = _ref4.popoverEl, placement = _ref4.placement, viewport = _ref4.viewport, gap = _ref4.gap, crossAxisShift = _ref4.crossAxisShift;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    var popoverWidth = popoverEl.offsetWidth;
    var popoverHeight = popoverEl.offsetHeight;
    var basePosition = $a18805323616c858$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    var alignedPosition = $a18805323616c858$var$applyAlignment({
        position: basePosition,
        axis: axis,
        align: align,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    var shiftedPosition = $a18805323616c858$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        crossAxisShift: crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}


/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $3464a6ca53f06bfe$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, cleanupFns = new Array(_len), _key = 0; _key < _len; _key++)cleanupFns[_key] = arguments[_key];
    return function cleanup() {
        cleanupFns.forEach(function(callback) {
            return callback === null || callback === void 0 ? void 0 : callback();
        });
    };
}



function $83af1edd0f8c9656$export$de49b61f233ddeb9(_ref) {
    var placement = _ref.placement;
    var _resolvePlacement = (0, $2608c403eb64c7cb$export$63044d21bc3d3fa2)({
        placement: placement
    }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge, align = _resolvePlacement.align;
    var edgeValue = "".concat(axis, "-").concat(edge);
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    var spanDir = align === 'start' ? 'end' : 'start';
    return "".concat(edgeValue, " span-").concat(crossAxis, "-").concat(spanDir);
}



/**
 * A `position-area` primary edge — the placement axis joined to its edge, e.g.
 * `block-end` or `inline-start`. These are the four edges a popover can sit on.
 */ function $bd117f8d1d92fb8a$var$slideOnEdge(_ref) {
    var align = _ref.align, edgeKey = _ref.edgeKey, crossAxis = _ref.crossAxis;
    if (align === 'center') return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-end"),
        "".concat(edgeKey, " span-").concat(crossAxis, "-start")
    ];
    // For `align: 'start'` the popover expands toward `end`, so the "near"
    // span is `end` and the "far" span is `start`; `align: 'end'` mirrors
    // this. The bare `edgeKey` (re-centered) sits between them.
    var near = align === 'start' ? 'end' : 'start';
    var far = align === 'start' ? 'start' : 'end';
    return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(near),
        edgeKey,
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(far)
    ];
}
function $bd117f8d1d92fb8a$var$flipDiagonally(_ref2) {
    var axis = _ref2.axis;
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    var flipToCrossAxis = axis === 'block' ? 'flip-inline' : 'flip-block';
    return "".concat(flipOnMainAxis, " ").concat(flipToCrossAxis);
}
function $bd117f8d1d92fb8a$export$c4e16947a95d61f1(_ref3) {
    var placement = _ref3.placement;
    /**
   * **Build the fallback list**
   *
   * Each entry is a complete alternative position.
   * The browser tries them _in order_ and uses the _first_ one that fits.
   */ var resolved = (0, $2608c403eb64c7cb$export$63044d21bc3d3fa2)({
        placement: placement
    });
    var axis = resolved.axis, edge = resolved.edge, align = resolved.align;
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    var flippedEdge = edge === 'start' ? 'end' : 'start';
    var sameEdgeArea = "".concat(axis, "-").concat(edge);
    var oppositeEdgeArea = "".concat(axis, "-").concat(flippedEdge);
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    /**
   * **Fallback algorithm**
   *
   * We have two things we can do to keep something visible:
   *
   * 1. _Slide_ along edges
   * 2. _Flip_ to another edge
   *
   * _Centered popover_
   *
   * Desired: Sits in middle of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge (centered)
   *  3: _Slide_ along opposite edge on the cross axis
   *
   * _Start or end aligned popover_
   *
   * Desired: Sits at start / end of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge
   *  3: _Flip_ on the diagonal (flip main axis + flip cross axis) into the
   *     opposite corner. For start / end alignment, this is the clean escape
   *     when the popover would otherwise land offscreen on both axes (ie in a
   *     corner). Rule 4 gets the job done, but a slide drops the gap
   *     as named position-area values don't carry margins).
   *     The diagonal flip keeps the gap and the alignment.
   *  4: _Slide_ along opposite edge on the cross axis
   */ return [
        $bd117f8d1d92fb8a$var$slideOnEdge({
            align: align,
            edgeKey: sameEdgeArea,
            crossAxis: crossAxis
        }),
        flipOnMainAxis,
        align !== 'center' ? $bd117f8d1d92fb8a$var$flipDiagonally({
            axis: axis
        }) : null,
        $bd117f8d1d92fb8a$var$slideOnEdge({
            align: align,
            edgeKey: oppositeEdgeArea,
            crossAxis: crossAxis
        })
    ].filter(Boolean).flat().join(', ');
}


var $cc5b118fe24f8888$var$elementCaches = new WeakMap();
function $cc5b118fe24f8888$var$canCacheResolvedLength(value) {
    // Custom-property values can be retargeted by inline overrides on the
    // consumer's wrapper, so we cannot prove a cached pixel value is still valid.
    return !value.includes('var(');
}
function $cc5b118fe24f8888$var$getCachedResolvedLength(_ref) {
    var _cacheForElement$get;
    var element = _ref.element, value = _ref.value;
    if (!$cc5b118fe24f8888$var$canCacheResolvedLength(value)) return null;
    var cacheForElement = $cc5b118fe24f8888$var$elementCaches.get(element);
    return (_cacheForElement$get = cacheForElement === null || cacheForElement === void 0 ? void 0 : cacheForElement.get(value)) !== null && _cacheForElement$get !== void 0 ? _cacheForElement$get : null;
}
function $cc5b118fe24f8888$var$cacheResolvedLength(_ref2) {
    var _elementCaches$get;
    var element = _ref2.element, value = _ref2.value, result = _ref2.result;
    if (!$cc5b118fe24f8888$var$canCacheResolvedLength(value)) return;
    var cacheForElement = (_elementCaches$get = $cc5b118fe24f8888$var$elementCaches.get(element)) !== null && _elementCaches$get !== void 0 ? _elementCaches$get : new Map();
    cacheForElement.set(value, result);
    $cc5b118fe24f8888$var$elementCaches.set(element, cacheForElement);
}
function $cc5b118fe24f8888$export$98721546d2816d9e(_ref3) {
    var value = _ref3.value, container = _ref3.container;
    if (typeof value === 'number') return value;
    // Fast path: unitless zero is universally zero pixels - accept `'0'` and
    // `'-0'` without a probe. (Consumers occasionally pass `'0'` instead of
    // the number `0`.)
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from the consumer normalisation
    // in `resolvePlacement`. Avoid a reflow when we can.
    var pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    var cached = $cc5b118fe24f8888$var$getCachedResolvedLength({
        element: container,
        value: value
    });
    if (cached !== null) return cached;
    var probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hide the probe from assistive tech and event targeting; defensive
    // against `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    container.appendChild(probe);
    var resolved = parseFloat(getComputedStyle(probe).marginLeft);
    container.removeChild(probe);
    var result = Number.isFinite(resolved) ? resolved : 0;
    $cc5b118fe24f8888$var$cacheResolvedLength({
        element: container,
        value: value,
        result: result
    });
    return result;
}



/**
 * A single inline style declaration.
 *
 * `TProperty` narrows the property name for callers that write a known, closed
 * set of properties. Narrowing it lets a record keyed on those same names be
 * checked for exhaustiveness at compile time, rather than silently resolving to
 * `undefined` for a name that was never mapped.
 */ /**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 */ function $e2ec0551ddaddb0a$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}


// `resolvePlacement` is intentionally NOT re-exported here - import it directly
// from `./resolve-placement` so search-and-jump lands at the source of truth.
/**
 * Module-scope no-op `ResizeObserver` used in non-DOM jest environments where
 * `ResizeObserver` is `undefined`. Hoisted out of the effect to avoid
 * allocating a new class declaration on every run.
 */ var $67dd6d69e0eb8e80$var$NoopResizeObserver = /*#__PURE__*/ function() {
    function NoopResizeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoopResizeObserver);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoopResizeObserver, [
        {
            key: "observe",
            value: function observe() {}
        },
        {
            key: "unobserve",
            value: function unobserve() {}
        },
        {
            key: "disconnect",
            value: function disconnect() {}
        }
    ]);
}();
/**
 * Returns true when the popover is currently open. Wrapped because the
 * `:popover-open` pseudo-class is not implemented in some test environments
 * (e.g. jsdom), where `matches` throws on unknown selectors.
 */ function $67dd6d69e0eb8e80$var$isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch (_unused) {
        return false;
    }
}
/**
 * Detects whether the browser supports CSS Anchor Positioning.
 * Uses `once()` for lazy evaluation: safe for SSR and avoids hydration mismatches.
 */ var $67dd6d69e0eb8e80$var$supportsAnchorPositioning = (0, $bvsoE.default)(function() {
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('anchor-name', '--a');
});
/**
 * Every logical margin property this module can write: one per axis, per side.
 *
 * Deriving the union from `TPlacementAxis` and `TPlacementEdge` rather than
 * writing the four names out keeps it in step with the placement model, and
 * makes `CROSS_AXIS_SHIFT_CUSTOM_PROPERTY` below exhaustive by construction.
 */ /**
 * The custom property mirroring each cross-axis shift margin.
 *
 * These are written for the planned named arrow `@position-try` rules. Nothing
 * reads them yet, and the shift no longer depends on them: the antisymmetric
 * margins written by `crossAxisShiftMargins` survive a cross-axis slide on
 * their own.
 *
 * Keyed on `TLogicalMarginProperty` and not on `string`, so a margin property
 * that has no custom property (or a custom property whose margin no longer
 * exists) is a compile error rather than an `undefined` lookup that reaches
 * `setStyle` as `{ property: undefined, value }`.
 */ var $67dd6d69e0eb8e80$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY = {
    'margin-inline-start': '--ds-cross-axis-shift-margin-start',
    'margin-inline-end': '--ds-cross-axis-shift-margin-end',
    'margin-block-start': '--ds-cross-axis-shift-margin-block-start',
    'margin-block-end': '--ds-cross-axis-shift-margin-block-end'
};
var $67dd6d69e0eb8e80$var$ZEROED_CROSS_AXIS_SHIFT_CUSTOM_PROPERTIES = Object.values($67dd6d69e0eb8e80$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY).map(function(property) {
    return {
        property: property,
        value: '0px'
    };
});
/**
 * Returns the CSS margin declaration that creates a gap between the
 * popover and its trigger on the side facing the anchor.
 *
 * For example, a `block-end` placement (popover below) gets
 * `margin-block-start: 8px` to push it away from the trigger's bottom edge.
 */ function $67dd6d69e0eb8e80$var$edgeMargin(_ref) {
    var placement = _ref.placement, offset = _ref.offset;
    var axis = placement.axis, edge = placement.edge;
    // The gap sits on the side FACING the anchor, which is always the side
    // opposite the placement edge.
    var anchorFacingEdge = edge === 'end' ? 'start' : 'end';
    return {
        property: "margin-".concat(axis, "-").concat(anchorFacingEdge),
        value: offset
    };
}
/**
 * **The cross-axis shift margins.**
 *
 * The shift is written antisymmetrically on BOTH cross-axis sides
 * (`start: +value`, `end: -value`) rather than as a single margin on the side
 * picked from `align`. Two separate behaviours require it:
 *
 * 1. **`align: 'center'` is centered with `anchor-center`, which centers the
 *    popover's MARGIN box on the anchor.** A single-sided margin widens the
 *    margin box, so it displaces the border box by only half its value. An
 *    antisymmetric pair leaves the margin box width unchanged (`+value` and
 *    `-value` sum to zero) while moving its center by the full value.
 * 2. **`position-try-fallbacks` can slide the popover onto the opposite
 *    cross-axis side.** A `<position-area>` fallback keeps the base style's
 *    margins, and margin on the un-anchored side has no effect, so a
 *    single-sided margin is silently dropped once the browser slides across the
 *    cross axis. With both sides written, whichever side ends up anchored moves
 *    the popover the same physical direction.
 *
 * Leaving the margin box width unchanged also means the shift does not move
 * the point at which `position-try-fallbacks` decides the popover overflows.
 *
 * A `<try-tactic>` fallback (`flip-block`, `flip-inline`) behaves differently to
 * a `<position-area>` one: it SWAPS the start and end margins rather than
 * keeping them, which is what preserves the gap through a flip. So a flip across
 * the cross axis mirrors the shift along with the rest of the placement, rather
 * than preserving its physical direction. Only the diagonal fallback does that,
 * and only for `align: 'start' | 'end'`. See `placementToTryFallbacks`.
 *
 * A positive value always moves the popover toward the cross-axis END, so
 * `direction: 'forwards'` means the same thing for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 */ function $67dd6d69e0eb8e80$var$crossAxisShiftMargins(_ref2) {
    var placement = _ref2.placement, crossAxisShiftCssValue = _ref2.crossAxisShiftCssValue, direction = _ref2.direction;
    var crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    // Wrap any string in calc() with the sign factor. CSS handles the math,
    // so opaque values such as design tokens negate correctly.
    var negated = "calc(-1 * ".concat(crossAxisShiftCssValue, ")");
    var isForwards = direction === 'forwards';
    return [
        {
            property: "margin-".concat(crossAxis, "-start"),
            value: isForwards ? crossAxisShiftCssValue : negated
        },
        {
            property: "margin-".concat(crossAxis, "-end"),
            value: isForwards ? negated : crossAxisShiftCssValue
        }
    ];
}
/**
 * Returns a referentially-stable, fully-resolved `TPlacement`. The memo is
 * keyed on the resolved primitive fields so a fresh inline `placement` object
 * (or undefined fields vs explicit defaults) does not produce a fresh result.
 */ function $67dd6d69e0eb8e80$var$useStablePlacement(placement) {
    var resolved = (0, $2608c403eb64c7cb$export$63044d21bc3d3fa2)({
        placement: placement
    });
    var axis = resolved.axis;
    var edge = resolved.edge;
    var align = resolved.align;
    var gap = resolved.offset.gap;
    var shiftValue = resolved.offset.crossAxisShift.value;
    var shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuild inside the memo from primitive deps so the factory does not
    // close over the outer `resolved` reference and exhaustive-deps can verify.
    return (0, $5FkrB.useMemo)(function() {
        return {
            axis: axis,
            edge: edge,
            align: align,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        };
    }, [
        axis,
        edge,
        align,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $67dd6d69e0eb8e80$export$56b02a1e583f953c(_ref3) {
    var anchorRef = _ref3.anchorRef, popoverRef = _ref3.popoverRef, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? {} : _ref3$placement, _ref3$forceFallbackPo = _ref3.forceFallbackPositioning, forceFallbackPositioning = _ref3$forceFallbackPo === void 0 ? false : _ref3$forceFallbackPo, _ref3$isEnabled = _ref3.isEnabled, isEnabled = _ref3$isEnabled === void 0 ? true : _ref3$isEnabled, isOpen = _ref3.isOpen;
    var id = (0, $5FkrB.useId)();
    var stablePlacement = $67dd6d69e0eb8e80$var$useStablePlacement(placement);
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!isEnabled) return;
        var trigger = anchorRef.current;
        var popover = popoverRef.current;
        if (!trigger || !popover) return;
        var gapCssValue = stablePlacement.offset.gap;
        var crossAxisShiftCssValue = stablePlacement.offset.crossAxisShift.value;
        var shouldForceFallback = Boolean(forceFallbackPositioning);
        if ($67dd6d69e0eb8e80$var$supportsAnchorPositioning() && !shouldForceFallback) {
            // Reuse an existing `anchor-name` if the element already has one.
            // Another popover might already be anchored to the old name.
            var anchorName = trigger.style.getPropertyValue('anchor-name') || "--anchor-".concat(id.replace(/:/g, ''));
            var gap = $67dd6d69e0eb8e80$var$edgeMargin({
                placement: stablePlacement,
                offset: gapCssValue
            });
            // Computed once; also mirrored into the
            // `--ds-cross-axis-shift-margin-*` custom properties below.
            var crossAxisShift = $67dd6d69e0eb8e80$var$crossAxisShiftMargins({
                placement: stablePlacement,
                crossAxisShiftCssValue: crossAxisShiftCssValue,
                direction: stablePlacement.offset.crossAxisShift.direction
            });
            var popoverStyles = [
                {
                    property: 'position-anchor',
                    value: anchorName
                },
                {
                    property: 'position-area',
                    value: (0, $83af1edd0f8c9656$export$de49b61f233ddeb9)({
                        placement: stablePlacement
                    })
                },
                {
                    property: 'position-try-fallbacks',
                    value: (0, $bd117f8d1d92fb8a$export$c4e16947a95d61f1)({
                        placement: stablePlacement
                    })
                },
                // Reset browser default popover positioning that conflicts
                // with anchor positioning (UA: `inset: 0; margin: auto;`)
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                },
                gap
            ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(crossAxisShift), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))($67dd6d69e0eb8e80$var$ZEROED_CROSS_AXIS_SHIFT_CUSTOM_PROPERTIES), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(crossAxisShift.map(function(_ref4) {
                var property = _ref4.property, value = _ref4.value;
                return {
                    property: $67dd6d69e0eb8e80$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY[property],
                    value: value
                };
            })));
            /**
       * **We are never cleaning up anchor names**
       *
       * _Rationale_
       *
       * - Multiple popovers can share the same anchor element.
       * - Sometimes the `useAnchorPosition` hook and `Popover`
       *   are not in the same component.
       * - There can be times when, even with reference counting, we
       *   could remove the anchor-name while it is still being used
       *   by something else - especially with async react updates
       *   which can cause tearing
       *
       * _More_
       *
       * See `notes/decisions/anchor-name-lifetime.md`
       */ trigger.style.setProperty('anchor-name', anchorName);
            return (0, $e2ec0551ddaddb0a$export$37a5fde709c1db82)({
                element: popover,
                styles: popoverStyles
            });
        }
        // JS fallback. The popover is already in the top layer via
        // popover="auto", so we only reset UA defaults and set top/left
        // based on measurements.
        var cleanupBaseStyles = (0, $e2ec0551ddaddb0a$export$37a5fde709c1db82)({
            element: popover,
            styles: [
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                }
            ]
        });
        // The popover can be consumer-owned (`@atlaskit/popper`'s `createPopper`),
        // so restore prior inline values rather than removing ours.
        var undoPosition;
        var undoHide;
        // `opacity: 0` not `visibility: hidden`: Firefox skips visibility-hidden
        // elements during `<dialog>` initial-focus traversal.
        function hideUntilPositioned() {
            // Keep the first snapshot, else we capture our own `opacity: 0`.
            // (`!popover` is for TS: narrowing does not reach nested functions.)
            if (!popover || undoHide) return;
            undoHide = (0, $e2ec0551ddaddb0a$export$37a5fde709c1db82)({
                element: popover,
                styles: [
                    {
                        property: 'opacity',
                        value: '0'
                    }
                ]
            });
        }
        function reveal() {
            var _undoHide;
            (_undoHide = undoHide) === null || _undoHide === void 0 || _undoHide();
            undoHide = undefined;
        }
        function restorePosition() {
            var _undoPosition;
            (_undoPosition = undoPosition) === null || _undoPosition === void 0 || _undoPosition();
            undoPosition = undefined;
        }
        function update() {
            if (!trigger || !popover) return;
            var triggerRect = trigger.getBoundingClientRect();
            var viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            // Resolve consumer-supplied CSS length strings (tokens, calc, var,
            // px, rem, etc) to pixels. The probe is mounted INSIDE the popover
            // itself so the resolved length matches the scope a token would
            // resolve against from inside the popover content. (The popover
            // lives in the top layer, not the trigger's DOM tree, so probing
            // at `popover.parentElement` would resolve in a different scope
            // than the consumer's token authoring expects.)
            var gapPx = (0, $cc5b118fe24f8888$export$98721546d2816d9e)({
                value: gapCssValue,
                container: popover
            });
            var crossAxisShiftPx = (0, $cc5b118fe24f8888$export$98721546d2816d9e)({
                value: crossAxisShiftCssValue,
                container: popover
            });
            var _computeFallbackPosit = (0, $a18805323616c858$export$d5ef1dac02135664)({
                triggerRect: triggerRect,
                popoverEl: popover,
                placement: stablePlacement,
                viewport: viewport,
                gap: gapPx,
                crossAxisShift: {
                    value: crossAxisShiftPx,
                    direction: stablePlacement.offset.crossAxisShift.direction
                }
            }), top = _computeFallbackPosit.top, left = _computeFallbackPosit.left;
            // Restore first so the snapshot stays the consumer's value.
            restorePosition();
            undoPosition = (0, $e2ec0551ddaddb0a$export$37a5fde709c1db82)({
                element: popover,
                styles: [
                    {
                        property: 'top',
                        value: "".concat(top, "px")
                    },
                    {
                        property: 'left',
                        value: "".concat(left, "px")
                    }
                ]
            });
            reveal();
        }
        // Throttle scroll/resize updates to one per animation frame
        var scheduledUpdate = (0, $45Zis.default)(update);
        // Wait for the FIRST valid layout before measuring: the popover
        // is `display: none` until `showPopover()`, and some browsers
        // fire `toggle` before layout, so RAF-after-toggle is unreliable.
        // ResizeObserver fires once the browser has real dimensions.
        // Self-disconnects after one valid measurement; ongoing
        // scroll/resize is handled by the window listeners below.
        // `ResizeObserver` is missing in some non-DOM jest environments
        // (e.g. post-office's `node` environment). Fall back to a no-op
        // observer there. The scroll/resize listeners below still keep
        // the popover positioned in the rare case the consumer also
        // polyfilled `showPopover` but not `ResizeObserver`. Real
        // browsers always have it. The `NoopResizeObserver` class is
        // hoisted to module scope (see top of file) so we do not allocate
        // a new constructor on every effect run.
        var ResizeObserverImpl = typeof ResizeObserver !== 'undefined' ? ResizeObserver : $67dd6d69e0eb8e80$var$NoopResizeObserver;
        var resizeObserver = new ResizeObserverImpl(function() {
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                update();
                resizeObserver.disconnect();
            }
        });
        // If the popover is already open by the time this effect runs (for
        // example, the parent `useAnchorPosition` effect runs after the child
        // `Popover` effect that called `showPopover()`), the initial `toggle`
        // event has already fired and our listener below would miss it. Start
        // observing immediately so the first measurement still happens.
        if ($67dd6d69e0eb8e80$var$isPopoverOpen(popover)) {
            hideUntilPositioned();
            resizeObserver.observe(popover);
        }
        var undoPositioning = (0, $3464a6ca53f06bfe$export$1be1fc439b849fdf)(cleanupBaseStyles, // Each open needs a fresh measurement, so hide and re-observe.
        (0, $7QpUe.bind)(popover, {
            type: 'toggle',
            listener: function listener(event) {
                var toggleEvent = event;
                if (toggleEvent.newState === 'open') {
                    hideUntilPositioned();
                    resizeObserver.observe(popover);
                }
            }
        }), function() {
            return resizeObserver.disconnect();
        }, (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: scheduledUpdate,
            options: {
                capture: true,
                passive: true
            }
        }), (0, $7QpUe.bind)(window, {
            type: 'resize',
            listener: scheduledUpdate,
            options: {
                passive: true
            }
        }), function() {
            scheduledUpdate.cancel();
            restorePosition();
            reveal();
        });
        return undoPositioning;
    }, [
        anchorRef,
        popoverRef,
        stablePlacement,
        forceFallbackPositioning,
        isEnabled,
        id,
        isOpen
    ]);
}



var $5FkrB = parcelRequire("5FkrB");

var $bvsoE = parcelRequire("bvsoE");

/**
 * Probes anchor SIZING, separately from `anchor-name` (see
 * `supportsAnchorPositioning`): some browsers have positioning but not sizing.
 * `once()` for SSR safety.
 */ var $d641cb445a16e3c1$var$supportsAnchorSize = (0, $bvsoE.default)(function() {
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('min-inline-size', 'anchor-size(self-inline)');
});
/**
 * The JS fallback's stand-in for `anchor-size(self-inline)`. `offsetWidth` / `offsetHeight` are
 * physical, so the axis is picked from the popover's `writing-mode`. Anything not horizontal is
 * treated as vertical, and an unknown or empty value falls back to `offsetWidth`.
 */ function $d641cb445a16e3c1$var$getFallbackAnchorInlineSize(_ref) {
    var anchor = _ref.anchor, popover = _ref.popover;
    // `String()` because not every test environment implements `writing-mode`.
    var writingMode = String(getComputedStyle(popover).writingMode);
    var isVertical = writingMode.startsWith('vertical') || writingMode.startsWith('sideways');
    return isVertical ? anchor.offsetHeight : anchor.offsetWidth;
}
function $d641cb445a16e3c1$export$7071d791a7b131ed(_ref2) {
    var mode = _ref2.mode, popoverRef = _ref2.popoverRef, anchorRef = _ref2.anchorRef, isOpen = _ref2.isOpen;
    (0, $5FkrB.useLayoutEffect)(function() {
        var node = popoverRef.current;
        if (!node) return;
        if (mode === 'match-anchor') {
            // No floor here: it would let the popover grow past the anchor.
            if ($d641cb445a16e3c1$var$supportsAnchorSize()) return (0, $e2ec0551ddaddb0a$export$37a5fde709c1db82)({
                element: node,
                styles: [
                    {
                        property: 'inline-size',
                        value: 'anchor-size(self-inline)'
                    }
                ]
            });
            var anchor = anchorRef.current;
            if (anchor) return (0, $e2ec0551ddaddb0a$export$37a5fde709c1db82)({
                element: node,
                styles: [
                    {
                        property: 'inline-size',
                        value: "".concat($d641cb445a16e3c1$var$getFallbackAnchorInlineSize({
                            anchor: anchor,
                            popover: node
                        }), "px")
                    }
                ]
            });
            return;
        }
        if (mode === 'min-anchor') {
            // One floor only. The content floor from mode 'none' deliberately does not also apply
            // here, and cannot: it would need this same property. See the decision note.
            if ($d641cb445a16e3c1$var$supportsAnchorSize()) return (0, $e2ec0551ddaddb0a$export$37a5fde709c1db82)({
                element: node,
                styles: [
                    {
                        property: 'min-inline-size',
                        value: 'anchor-size(self-inline)'
                    }
                ]
            });
            var _anchor = anchorRef.current;
            if (_anchor) return (0, $e2ec0551ddaddb0a$export$37a5fde709c1db82)({
                element: node,
                styles: [
                    {
                        property: 'min-inline-size',
                        value: "".concat($d641cb445a16e3c1$var$getFallbackAnchorInlineSize({
                            anchor: _anchor,
                            popover: node
                        }), "px")
                    }
                ]
            });
            // Nothing to measure, so no floor.
            return;
        }
        // Makes a too-narrow span overflow and drive `position-try-fallbacks` instead of wrapping.
        // `@atlaskit/popper` resets this exact property to `0` for its fit-to-viewport mode.
        return (0, $e2ec0551ddaddb0a$export$37a5fde709c1db82)({
            element: node,
            styles: [
                {
                    property: 'min-inline-size',
                    value: 'max-content'
                }
            ]
        });
    }, [
        mode,
        popoverRef,
        anchorRef,
        isOpen
    ]);
}




var $5FkrB = parcelRequire("5FkrB");
var $869ffc589b24da81$export$a0d5b29fa9affc38 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);


function $a5df2e3ed5d1dd38$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a5df2e3ed5d1dd38$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a5df2e3ed5d1dd38$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a5df2e3ed5d1dd38$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// `'auto'` falls through to `'end'`; top-layer's `position-try-fallbacks` flips it if needed.
function $a5df2e3ed5d1dd38$var$reactSelectEdgeToTopLayerEdge(menuPlacement) {
    return menuPlacement === 'top' ? 'start' : 'end';
}
var $a5df2e3ed5d1dd38$var$menuPortalStyles = {
    root: "_ofie1496"
};
function $a5df2e3ed5d1dd38$export$1f5427c7f5364d0b(props) {
    var children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, xcss = props.xcss;
    // Select's "close the menu" callback, distinct from `Popover.onClose`.
    var closeSelect = (0, $5FkrB.useContext)((0, $869ffc589b24da81$export$a0d5b29fa9affc38));
    var popoverRef = (0, $5FkrB.useRef)(null);
    // Top-layer hooks need a RefObject; in-render mutation keeps it in sync
    // with the prop without an effect. The hooks re-read `.current` from
    // `isOpen`-keyed layout effects, so a stable ref identity is fine.
    var anchorRef = (0, $5FkrB.useRef)(null);
    anchorRef.current = controlElement;
    // `controlElement` is null on initial mount / SSR until `Select` mirrors
    // its ref into state. While null, every hook below no-ops to avoid DOM
    // reads or registering an unpositioned popover.
    var isAnchored = controlElement !== null;
    // `gap: 0` matches the legacy MenuPortal (no trigger-to-menu gap; the
    // menu root already declares its own `marginBlockStart`). Without this
    // override `useAnchorPosition`'s default 8px gap would diverge visually
    // from the legacy path.
    (0, $67dd6d69e0eb8e80$export$56b02a1e583f953c)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        placement: {
            axis: 'block',
            edge: $a5df2e3ed5d1dd38$var$reactSelectEdgeToTopLayerEdge(menuPlacement),
            offset: {
                gap: 0
            }
        },
        isOpen: isAnchored
    });
    (0, $d641cb445a16e3c1$export$7071d791a7b131ed)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        mode: 'match-anchor',
        isOpen: isAnchored
    });
    var handlePopoverClose = (0, $5FkrB.useCallback)(function() {
        if (closeSelect) closeSelect();
    }, [
        closeSelect
    ]);
    // Explicit observer registration: the outer Popover is intentionally
    // roleless (see Popover comment below), so Popover cannot auto-register
    // from its role. This lets `closeLayers()` (Modal / Drawer) dismiss us.
    (0, $07ec2c2d1f3d588d$export$469bb693f11edc7f)({
        type: 'popup',
        isOpen: isAnchored,
        onClose: handlePopoverClose
    });
    // Top-layer owns positioning; zero offset/rect preserves the consumer
    // styles call shape.
    var _getStyleProps = (0, $966e339201715f57$export$26417cabd806a658)($a5df2e3ed5d1dd38$var$_objectSpread($a5df2e3ed5d1dd38$var$_objectSpread({}, props), {}, {
        offset: 0,
        position: menuPosition,
        rect: {
            left: 0,
            width: 0
        }
    }), 'menuPortal', {
        'menu-portal': true
    }), className = _getStyleProps.className;
    // Popover stays mounted and is driven by `isOpen` so its layout-effect
    // teardown (`hidePopover`, observer cleanup, position-hook style reset)
    // runs against a live element. Conditional render would skip that path.
    //
    // `mode="auto"` delegates light-dismiss and Escape to the browser. The
    // `onClose` bridge then synchronizes react-select's `menuIsOpen` state after
    // native dismissal, keeping this popover available to consume the request.
    //
    // The Popover host is intentionally roleless: the inner `MenuList`
    // keeps `role="listbox"` and the id referenced by `aria-controls`.
    // Putting the role on the outer host caused Playwright `toBeVisible`
    // and some SR hit-testing to treat it as hidden (zero bounding rect
    // while `styles.root` opts out of UA `[popover]` positioning).
    //
    // TODO: add open / close animation. Select unmounts MenuPortalTopLayer
    // the moment `menuIsOpen` flips false, so Popover's `animate` exit
    // transition never gets a frame. Needs keeping the portal mounted
    // through the exit (`onExitFinish`) on the Select side.
    return /*#__PURE__*/ $5FkrB.createElement((0, $ccf7c19f9a6de16a$export$5b6b19405a83ff9d), {
        ref: popoverRef,
        mode: "auto",
        isOpen: isAnchored,
        onClose: handlePopoverClose
    }, /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // `className` carries consumer `styles.menuPortal({...})` output,
        // `xcss` carries caller compiled atomic classes, and `-MenuPortal`
        // is a legacy selector hook kept for parity with MenuPortalLegacy.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss, @typescript-eslint/no-explicit-any
        className: (0, $970q7.default)([
            $a5df2e3ed5d1dd38$var$menuPortalStyles.root,
            (0, $hUFig.cx)(className, xcss, '-MenuPortal')
        ])
    }, innerProps), children));
}


function $fce85f889c556f89$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fce85f889c556f89$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fce85f889c556f89$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fce85f889c556f89$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fce85f889c556f89$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
var $fce85f889c556f89$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $fce85f889c556f89$var$menuPortalStyles = {
    root: "_1pbykb7n _1e02a1vk _kqswcp1v _152t1nmo _1bsb1qxj"
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
function $fce85f889c556f89$var$MenuPortalLegacy(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, xcss = props.xcss;
    var menuPortalRef = (0, $5FkrB.useRef)(null);
    var cleanupRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)($fce85f889c556f89$var$coercePlacement(menuPlacement)), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), placement = _useState2[0], setPortalPlacement = _useState2[1];
    var portalPlacementContext = (0, $5FkrB.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState3 = (0, $5FkrB.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), computedPosition = _useState4[0], setComputedPosition = _useState4[1];
    var updateComputedPosition = (0, $5FkrB.useCallback)(function() {
        if (!controlElement) return;
        var rect = $fce85f889c556f89$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $5FkrB.useLayoutEffect)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $5FkrB.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $6I9SI.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $5FkrB.useLayoutEffect)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $5FkrB.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // Legacy quirk: `computedPosition` is null until the layout effect runs,
    // so the first render returns null even with `defaultMenuIsOpen` set.
    // Synchronous observers (VR snapshots) see a one-frame "closed" state.
    // Left as-is; the top-layer path supersedes this and positions declaratively.
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    var _getStyleProps = (0, $966e339201715f57$export$26417cabd806a658)($fce85f889c556f89$var$_objectSpread($fce85f889c556f89$var$_objectSpread({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    // same wrapper element whether fixed or portalled
    var menuWrapper = /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $fce85f889c556f89$var$menuPortalStyles.root,
            (0, $hUFig.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: $fce85f889c556f89$var$_objectSpread({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': "".concat(computedPosition.rect.left, "px"),
            '--menu-position': menuPosition,
            '--menu-top': "".concat(computedPosition.offset, "px"),
            '--menu-width': "".concat(computedPosition.rect.width, "px")
        }, css)
    }, innerProps), children);
    return /*#__PURE__*/ $5FkrB.createElement((0, $6ff04e2f40099fe8$export$e001f626511a0ead).Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $aLeHs.createPortal)(menuWrapper, appendTo) : menuWrapper);
}
var $fce85f889c556f89$export$793392f970497feb = function MenuPortal(props) {
    if ((0, $0ac0b27860a1d4ae$export$b40ec24ac8275656)('platform-dst-top-layer')) // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ $5FkrB.createElement((0, $a5df2e3ed5d1dd38$export$1f5427c7f5364d0b), props);
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ $5FkrB.createElement($fce85f889c556f89$var$MenuPortalLegacy, props);
};


/* multi-value.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $25nEq = parcelRequire("25nEq");

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $iO8GM = parcelRequire("iO8GM");
var $1faea3edef2fea9f$export$75eee42ff540d8ae = function convertToMs(duration) {
    // Use regex to separate the number and the unit
    var matches = duration.match(/^(-?(?:\d+\.?\d*|\.\d+))(s|ms)$/);
    if (!matches) return 0; // Or return for invalid format
    var value = parseFloat(matches[1]);
    var unit = matches[2];
    if (unit === 's') return value * 1000; // Convert seconds to milliseconds
    else return value; // Already in milliseconds
};


var $a7ea661484ce9901$var$cssTimePattern = /^-?(?:\d+\.?\d*|\.\d+)(?:ms|s)$/;
var $a7ea661484ce9901$var$toCssList = function toCssList(value) {
    return value.split(',').map(function(item) {
        return item.trim();
    }).filter(Boolean);
};
var $a7ea661484ce9901$var$toTimeList = function toTimeList(value) {
    return $a7ea661484ce9901$var$toCssList(value).filter(function(time) {
        return $a7ea661484ce9901$var$cssTimePattern.test(time);
    }).map((0, $1faea3edef2fea9f$export$75eee42ff540d8ae));
};
var $a7ea661484ce9901$export$dd9b73a7482d05b6 = function getComputedAnimationDurationMs(animationName, animationDuration, animationDelay) {
    var names = $a7ea661484ce9901$var$toCssList(animationName);
    var durations = $a7ea661484ce9901$var$toTimeList(animationDuration);
    var delays = $a7ea661484ce9901$var$toTimeList(animationDelay);
    if (names.length === 0 || durations.length === 0) return 0;
    var longestDuration = 0;
    for(var index = 0; index < names.length; index++){
        if (names[index] === 'none') continue;
        var duration = durations[index % durations.length];
        var delay = delays.length > 0 ? delays[index % delays.length] : 0;
        longestDuration = Math.max(longestDuration, duration + delay);
    }
    return longestDuration;
};



var $fC8ib = parcelRequire("fC8ib");
var $1de07684fd1b5c0b$export$d0038b6e47881463 = function getDurationMs(animation) {
    var animations = animation.split(/,(?![^()]*\))/).map(function(value) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(value.trim().matchAll(/(-?\d*\.?\d+)(ms|s)\b/g));
    }).filter(function(matches) {
        return matches.length > 0;
    });
    if (animations.length === 0) return {
        duration: 0,
        delay: 0
    };
    return animations.reduce(function(longest, matches) {
        var toMilliseconds = function toMilliseconds(match) {
            var value = parseFloat(match[1]);
            return match[2] === 's' ? value * 1000 : value;
        };
        var timing = {
            duration: toMilliseconds(matches[0]),
            delay: matches[1] ? toMilliseconds(matches[1]) : 0
        };
        return timing.duration + timing.delay > longest.duration + longest.delay ? timing : longest;
    }, {
        duration: 0,
        delay: 0
    });
};


var $23e02c3b640119e7$export$c5406bd59b374abd = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};


var $8d1b217f3672d39f$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!(0, $23e02c3b640119e7$export$c5406bd59b374abd)()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};



var $lFhdZ = parcelRequire("lFhdZ");
var $181234ce53d59006$export$82b92541889a035d = function resolveMotionToken(token) {
    var cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    var cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        var _getDocument;
        var documentElement = (_getDocument = (0, $lFhdZ.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};


/**
 * Supported reanimate values.
 * 'enter' will re-enter the animation.
 * 'exit-then-enter' will exit the animation and then enter it again.
 */ var $dee6884684b059a7$export$569340a66b14e0dc = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    Reanimate["exit"] = "exit";
    return Reanimate;
}({});



var $5FkrB = parcelRequire("5FkrB");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $ISKn7 = parcelRequire("ISKn7");
var $c4f1b61c72ba3041$var$_process, $c4f1b61c72ba3041$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $c4f1b61c72ba3041$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($c4f1b61c72ba3041$var$_process = globalThis.process) === null || $c4f1b61c72ba3041$var$_process === void 0 || ($c4f1b61c72ba3041$var$_process = $c4f1b61c72ba3041$var$_process.env) === null || $c4f1b61c72ba3041$var$_process === void 0 ? void 0 : $c4f1b61c72ba3041$var$_process.JEST_WORKER_ID) !== undefined;
var $c4f1b61c72ba3041$var$DEBUG_MODE = !$c4f1b61c72ba3041$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($c4f1b61c72ba3041$var$_process2 = globalThis.process) === null || $c4f1b61c72ba3041$var$_process2 === void 0 || ($c4f1b61c72ba3041$var$_process2 = $c4f1b61c72ba3041$var$_process2.env) === null || $c4f1b61c72ba3041$var$_process2 === void 0 ? void 0 : $c4f1b61c72ba3041$var$_process2.NODE_ENV) !== 'production';
var $c4f1b61c72ba3041$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$c4f1b61c72ba3041$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $6c99513b7cb9e204$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $6c99513b7cb9e204$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
var $6c99513b7cb9e204$export$75f4a1454eff2805 = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';


var $75f40df13a0218a7$export$b574c24e1e6490f5 = (0, $6c99513b7cb9e204$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $a25b88d95d5a2028$export$92f8b531feaeb23d = (0, $6c99513b7cb9e204$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $8fd23918f07ad698$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $8fd23918f07ad698$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$8fd23918f07ad698$export$54ea85357b4e0159[0, $6c99513b7cb9e204$export$7e41b1b2bdee3f98] = $8fd23918f07ad698$export$54ea85357b4e0159[0, $6c99513b7cb9e204$export$7e41b1b2bdee3f98] || $8fd23918f07ad698$var$DEFAULT_PFF_GLOBAL;



var $48c57a676fe3736b$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $75f40df13a0218a7$export$b574c24e1e6490f5) || (0, $a25b88d95d5a2028$export$92f8b531feaeb23d);
function $48c57a676fe3736b$export$6333b6aff9fc6275(flagKey) {
    if ($48c57a676fe3736b$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $c4f1b61c72ba3041$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $6c99513b7cb9e204$export$407f05df8e3ce9f3), flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = (0, $8fd23918f07ad698$export$54ea85357b4e0159)[0, $6c99513b7cb9e204$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = (0, $8fd23918f07ad698$export$54ea85357b4e0159)[0, $6c99513b7cb9e204$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $ISKn7.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = (0, $8fd23918f07ad698$export$54ea85357b4e0159)[0, $6c99513b7cb9e204$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $43fe1c06d2975763$export$b40ec24ac8275656(name) {
    return (0, $48c57a676fe3736b$export$6333b6aff9fc6275)(name);
}


/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $b6e492239adde5c3$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isInsideExitingPersistence: false,
    isExiting: false
};
var $b6e492239adde5c3$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $5FkrB.createContext)($b6e492239adde5c3$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $b6e492239adde5c3$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $b6e492239adde5c3$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($b6e492239adde5c3$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $b6e492239adde5c3$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $b6e492239adde5c3$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $b6e492239adde5c3$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $b6e492239adde5c3$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $b6e492239adde5c3$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $b6e492239adde5c3$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false,
            isInsideExitingPersistence: true
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false,
            isInsideExitingPersistence: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $b6e492239adde5c3$var$childrenToArray(previousChildren);
    var current = $b6e492239adde5c3$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var nextChildren = currentChildren !== children ? $b6e492239adde5c3$var$childrenToArray(children) : current;
    var missingKeys = $b6e492239adde5c3$var$getMissingKeys(nextChildren, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $b6e492239adde5c3$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $43fe1c06d2975763$export$b40ec24ac8275656)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $b6e492239adde5c3$var$wrapChildWithContextProvider(child, {
            appear: true,
            isInsideExitingPersistence: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $b6e492239adde5c3$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b6e492239adde5c3$export$2e2bcd8739ae039 = $b6e492239adde5c3$var$ExitingPersistence;
$b6e492239adde5c3$var$ExitingPersistence.displayName = 'ExitingPersistence';


var $1c6fc84fa2005a86$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)((0, $b6e492239adde5c3$export$b9c4904d7a6929e6));
};



var $5FkrB = parcelRequire("5FkrB");
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $f9e6bfc5dc9af249$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");

var $5FkrB = parcelRequire("5FkrB");
var $72913fe43cf7faa5$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);


var $f7d9ca3de8538432$export$5e65d7d58ae96ad8 = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $eVb4V.default)
    };
});
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $f7d9ca3de8538432$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $72913fe43cf7faa5$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($f7d9ca3de8538432$export$5e65d7d58ae96ad8.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$f7d9ca3de8538432$export$2e2bcd8739ae039 = $f7d9ca3de8538432$var$StaggeredEntrance;


var $69a957518e8d04ef$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var identifier = (0, $f9e6bfc5dc9af249$export$c485849f2e393253)();
    var context = (0, $5FkrB.useContext)((0, $f7d9ca3de8538432$export$5e65d7d58ae96ad8));
    return context(identifier);
};


function $20264b49c785ea19$export$2a51cfe9390d36ef() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, onFinishMotion = _ref.onFinish, initialState = _ref.initialState;
    var reducedMotion = (0, $8d1b217f3672d39f$export$b7baf7667a68d87c)();
    var staggered = (0, $69a957518e8d04ef$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $1c6fc84fa2005a86$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var staggeredDelay = isExiting ? 0 : staggered.delay;
    var staggeredIsReady = staggered.isReady;
    var _useState = (0, $5FkrB.useState)(initialState !== null && initialState !== void 0 ? initialState : appear ? staggeredIsReady && !staggeredDelay ? 'entering' : 'init' : 'visible'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var elementRef = (0, $5FkrB.useRef)(null);
    var reanimateRef = (0, $5FkrB.useRef)();
    var animationRef = (0, $5FkrB.useRef)();
    var staggeredEntryRef = (0, $5FkrB.useRef)();
    (0, $5FkrB.useEffect)(function() {
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ var onAnimationEnd = (0, $5FkrB.useCallback)(function(currentState, cancelled) {
        // We are done animating, so we set the state to visible
        var newState = 'visible';
        if (currentState === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('exiting');
        }
        if (currentState === 'entering') onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('entering');
        if (reanimateRef.current === (0, $dee6884684b059a7$export$569340a66b14e0dc).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $dee6884684b059a7$export$569340a66b14e0dc).enter;
            newState = 'entering';
        } else if (reanimateRef.current === (0, $dee6884684b059a7$export$569340a66b14e0dc).enter) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        else if (reanimateRef.current === (0, $dee6884684b059a7$export$569340a66b14e0dc).exit) {
            // We are done reanimating, so we clear the reanimate state
            reanimateRef.current = undefined;
            newState = 'hidden';
        }
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    // Handles staggered entry
    (0, $5FkrB.useEffect)(function() {
        if (state !== 'init') return;
        if (reducedMotion) {
            onAnimationEnd('entering', false);
            return;
        }
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(function() {
            setState('entering');
        }, staggeredDelay);
        return function() {
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        onAnimationEnd,
        state,
        staggeredIsReady,
        staggeredDelay,
        reducedMotion
    ]);
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (!staggeredIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is visible, hidden or init, we don't need to do anything
        if (state === 'visible' || state === 'init' || state === 'hidden') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if (reducedMotion) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        var animationDuration = 0;
        if (state === 'entering' || state === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    var animationTimings = (0, $1de07684fd1b5c0b$export$d0038b6e47881463)((0, $181234ce53d59006$export$82b92541889a035d)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    var computedStyles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $a7ea661484ce9901$export$dd9b73a7482d05b6)(computedStyles.animationName, computedStyles.animationDuration, computedStyles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting') animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration);
        else if (state === 'entering') animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration);
        return function() {
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        appear,
        staggeredDelay,
        staggeredIsReady,
        reducedMotion
    ]);
    var reanimate = (0, $5FkrB.useCallback)(function(value) {
        animationRef.current && clearTimeout(animationRef.current);
        reanimateRef.current = value;
        if (value === (0, $dee6884684b059a7$export$569340a66b14e0dc).exit_then_enter) setState('exiting');
        else if (value === (0, $dee6884684b059a7$export$569340a66b14e0dc).enter) setState('entering');
        else if (value === (0, $dee6884684b059a7$export$569340a66b14e0dc).exit) setState('exiting');
    }, []);
    var ref = (0, $iO8GM.default)([
        staggered.ref,
        elementRef
    ]);
    return {
        ref: ref,
        reanimate: reanimate,
        state: state
    };
}



/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $25nEq = parcelRequire("25nEq");

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ISKn7 = parcelRequire("ISKn7");
var $b834659a8cfd4b0c$var$_process, $b834659a8cfd4b0c$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $b834659a8cfd4b0c$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($b834659a8cfd4b0c$var$_process = globalThis.process) === null || $b834659a8cfd4b0c$var$_process === void 0 || ($b834659a8cfd4b0c$var$_process = $b834659a8cfd4b0c$var$_process.env) === null || $b834659a8cfd4b0c$var$_process === void 0 ? void 0 : $b834659a8cfd4b0c$var$_process.JEST_WORKER_ID) !== undefined;
var $b834659a8cfd4b0c$var$DEBUG_MODE = !$b834659a8cfd4b0c$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($b834659a8cfd4b0c$var$_process2 = globalThis.process) === null || $b834659a8cfd4b0c$var$_process2 === void 0 || ($b834659a8cfd4b0c$var$_process2 = $b834659a8cfd4b0c$var$_process2.env) === null || $b834659a8cfd4b0c$var$_process2 === void 0 ? void 0 : $b834659a8cfd4b0c$var$_process2.NODE_ENV) !== 'production';
var $b834659a8cfd4b0c$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$b834659a8cfd4b0c$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $705c0eb03550e650$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $705c0eb03550e650$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
var $705c0eb03550e650$export$75f4a1454eff2805 = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';


var $cd4c8901cc92291c$export$b574c24e1e6490f5 = (0, $705c0eb03550e650$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $0021c3c6157b6cfe$export$92f8b531feaeb23d = (0, $705c0eb03550e650$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $4992860c74b24405$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $4992860c74b24405$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$4992860c74b24405$export$54ea85357b4e0159[0, $705c0eb03550e650$export$7e41b1b2bdee3f98] = $4992860c74b24405$export$54ea85357b4e0159[0, $705c0eb03550e650$export$7e41b1b2bdee3f98] || $4992860c74b24405$var$DEFAULT_PFF_GLOBAL;



var $8b6e2b11568b7e35$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $cd4c8901cc92291c$export$b574c24e1e6490f5) || (0, $0021c3c6157b6cfe$export$92f8b531feaeb23d);
function $8b6e2b11568b7e35$export$6333b6aff9fc6275(flagKey) {
    if ($8b6e2b11568b7e35$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $b834659a8cfd4b0c$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $705c0eb03550e650$export$407f05df8e3ce9f3), flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = (0, $4992860c74b24405$export$54ea85357b4e0159)[0, $705c0eb03550e650$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = (0, $4992860c74b24405$export$54ea85357b4e0159)[0, $705c0eb03550e650$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $ISKn7.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = (0, $4992860c74b24405$export$54ea85357b4e0159)[0, $705c0eb03550e650$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $6e1be09e06cae8e8$export$b40ec24ac8275656(name) {
    return (0, $8b6e2b11568b7e35$export$6333b6aff9fc6275)(name);
}



var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $6e543104a9587967$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6e543104a9587967$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6e543104a9587967$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6e543104a9587967$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6e543104a9587967$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $6e543104a9587967$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $6e543104a9587967$var$_objectSpread($6e543104a9587967$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $339c93477bfe6f45$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $339c93477bfe6f45$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $339c93477bfe6f45$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $339c93477bfe6f45$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $339c93477bfe6f45$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $339c93477bfe6f45$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $339c93477bfe6f45$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($339c93477bfe6f45$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $339c93477bfe6f45$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $339c93477bfe6f45$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $339c93477bfe6f45$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            var payload = $339c93477bfe6f45$var$clonePayload(_this.payload);
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $339c93477bfe6f45$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $6e543104a9587967$export$2e2bcd8739ae039));
var $339c93477bfe6f45$var$clonePayload = function clonePayload(payload) {
    if ((0, $6e1be09e06cae8e8$export$b40ec24ac8275656)('platform-analytics-next-safe-clone')) try {
        return JSON.parse(JSON.stringify(payload));
    } catch (e) {
        // Shallow clone keeps the event usable without crashing the UI.
        return $339c93477bfe6f45$var$_objectSpread({}, payload);
    }
    /**
   * A hacky "deep clone" of the object. This is limited in that it wont
   * support functions, regexs, Maps, Sets, etc, but none of those need to
   * be represented in our payload.
   */ return JSON.parse(JSON.stringify(payload));
};



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $e81e266d780eebbd$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $8eadaad914aa8b29$export$5bf35293e545f20c() {
    var analyticsContext = (0, $e81e266d780eebbd$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $339c93477bfe6f45$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $a6b5e5d4f5ec21d7$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


var $8e76b91ff66695b3$export$53c2b9c37c40e0d8 = function useCallbackWithAnalytics(method, payload, channel) {
    var _useAnalyticsEvents = (0, $8eadaad914aa8b29$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var methodRef = (0, $a6b5e5d4f5ec21d7$export$1d27a74659855e44)(method);
    var payloadRef = (0, $a6b5e5d4f5ec21d7$export$1d27a74659855e44)(payload);
    return (0, $5FkrB.useCallback)(function() {
        var pload = typeof payloadRef.current === 'function' ? payloadRef.current.apply(payloadRef, arguments) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current.apply(methodRef, arguments);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};



var $iO8GM = parcelRequire("iO8GM");

var $eVb4V = parcelRequire("eVb4V");

var $5supy = parcelRequire("5supy");

var $iYJcE = parcelRequire("iYJcE");
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $0e53283a8525a6a9$export$368bacef0dacbe05 = 25;
var $0e53283a8525a6a9$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};




var $5FkrB = parcelRequire("5FkrB");
var $b16605f197400a9a$export$ff879f35a69d56b7 = function useElementRef() {
    var elementRef = (0, $5FkrB.useRef)(null);
    var setRef = (0, $5FkrB.useCallback)(function(ref) {
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};




var $5FkrB = parcelRequire("5FkrB");
var $984eccb917985087$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $984eccb917985087$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $984eccb917985087$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};



var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $9dbaa074b4961a9d$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $9dbaa074b4961a9d$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $9dbaa074b4961a9d$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};



/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $5bab7d8d6e231b32$var$ShrinkOut = function ShrinkOut(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'small' : _ref$duration, onFinish = _ref.onFinish;
    var _useElementRef = (0, $b16605f197400a9a$export$ff879f35a69d56b7)(), _useElementRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useElementRef, 2), element = _useElementRef2[0], setElementRef = _useElementRef2[1];
    var exiting = (0, $1c6fc84fa2005a86$export$3b6f38abbdcbd000)();
    var requestAnimationFrame = (0, $984eccb917985087$export$1775f27e7c8051ca)();
    var setTimeout = (0, $9dbaa074b4961a9d$export$4f34107a2b00f39c)();
    var direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $72913fe43cf7faa5$export$e5c5a5f917a5871c)(function() {
        if (exiting.isExiting && element) {
            if ((0, $8d1b217f3672d39f$export$b7baf7667a68d87c)()) {
                exiting.onFinish && exiting.onFinish();
                onFinish && onFinish('exiting');
                return;
            }
            var newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: "".concat(element.offsetWidth, "px"),
                height: "".concat(element.offsetHeight, "px"),
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    var newStyles = {
                        width: '0px',
                        margin: '0px',
                        // We animate margin down to zero so it doesn't take any space.
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $0e53283a8525a6a9$export$38b928a7167ce124)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(function() {
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $0e53283a8525a6a9$export$38b928a7167ce124)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $5bab7d8d6e231b32$export$2e2bcd8739ae039 = $5bab7d8d6e231b32$var$ShrinkOut;



/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // Color mapping from old color names to new color names
var $06a7bf290dc0e3f2$export$3351a8d90bcc13aa = {
    standard: 'gray',
    grey: 'gray',
    blue: 'blue',
    green: 'green',
    red: 'red',
    yellow: 'yellow',
    purple: 'purple',
    lime: 'lime',
    magenta: 'magenta',
    orange: 'orange',
    teal: 'teal',
    // Light variants map to same as their non-light counterparts
    greyLight: 'gray',
    blueLight: 'blue',
    greenLight: 'green',
    redLight: 'red',
    yellowLight: 'yellow',
    purpleLight: 'purple',
    limeLight: 'lime',
    magentaLight: 'magenta',
    orangeLight: 'orange',
    tealLight: 'teal'
};


// Intentionally scoped to the UI-uplifted TagNew implementation.
var $e9e19f0e43b7caa4$export$7d100de1166870f6 = function getTagText(text) {
    return Array.isArray(text) ? text.join('') : text;
};


/* tag-new.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $h19KG = parcelRequire("h19KG");


var $btdNC = parcelRequire("btdNC");

var $9ztDu = parcelRequire("9ztDu");



var $5FkrB = parcelRequire("5FkrB");
function $0ec7de8f00cd92fd$export$ce4b6a469c26f53f(_ref) {
    var isLink = _ref.isLink, href = _ref.href, LinkComponent = _ref.LinkComponent, testId = _ref.testId, children = _ref.children, onClick = _ref.onClick, linkHandlers = _ref.linkHandlers;
    if (isLink && href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LinkComponent, {
        href: href,
        testId: testId ? "".concat(testId, "--link") : undefined,
        onClick: onClick,
        onMouseEnter: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseEnter,
        onMouseLeave: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseLeave,
        onMouseDown: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseDown,
        onFocus: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onFocus,
        onBlur: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onBlur
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, children);
}


/* removable-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ /**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

// Tag status enum
var $24522fb0fe9a996c$export$74452314b63acabc = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}({});


/**
 * Stable key so ExitingPersistence can match this child across the remove transition
 * (see ShrinkOut + ExitingPersistence docs in @atlaskit/motion).
 */ var $6741191d181cc6ba$var$removableShrinkOutChildKey = 'atlaskit-tag-removable-shrink-out';
var $6741191d181cc6ba$var$motionWrapperStyles = null;
function $6741191d181cc6ba$export$898a500849bb5cf4(_ref) {
    var isRemovable = _ref.isRemovable, status = _ref.status, onShrinkOutExitComplete = _ref.onShrinkOutExitComplete, children = _ref.children;
    if (isRemovable) return /*#__PURE__*/ $5FkrB.createElement((0, $b6e492239adde5c3$export$2e2bcd8739ae039), null, !(status === (0, $24522fb0fe9a996c$export$74452314b63acabc).Removed) && /*#__PURE__*/ $5FkrB.createElement((0, $5bab7d8d6e231b32$export$2e2bcd8739ae039), {
        key: $6741191d181cc6ba$var$removableShrinkOutChildKey,
        onFinish: onShrinkOutExitComplete ? function(phase) {
            if (phase === 'exiting') onShrinkOutExitComplete();
        } : undefined
    }, function(motion) {
        return /*#__PURE__*/ $5FkrB.createElement("span", {
            ref: motion.ref,
            className: (0, $970q7.default)([
                "_1e0c116y"
            ])
        }, children);
    }));
    return children;
}


var $0d5f3029391d01b3$var$tagMotionCapability = Symbol.for('@atlaskit/tag/motion-capable');
function $0d5f3029391d01b3$export$88b132e52a65ec37(component) {
    Object.defineProperty(component, $0d5f3029391d01b3$var$tagMotionCapability, {
        value: true
    });
    return component;
}


/* swatch-before.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $c2bf90a79c64a2dc$var$tagSwatchBeforeStyles = {
    swatch: "_2rkolb4i _1bsboqnp _4t3ioqnp _1o9zidpf"
};
var $c2bf90a79c64a2dc$var$tagSwatchBeforeColorStyles = {
    gray: "_bfhk18j9",
    blue: "_bfhk115i",
    green: "_bfhk1rsu",
    red: "_bfhkkrt9",
    yellow: "_bfhk8y3s",
    purple: "_bfhk18ah",
    lime: "_bfhkbq5w",
    magenta: "_bfhk1mi6",
    orange: "_bfhk1kkj",
    teal: "_bfhktdv8"
};
function $c2bf90a79c64a2dc$export$2e2bcd8739ae039(_ref) {
    var colorKey = _ref.colorKey, swatchBefore = _ref.swatchBefore, swatchBeforeLabel = _ref.swatchBeforeLabel, swatchBeforeRole = _ref.swatchBeforeRole;
    if (swatchBefore === undefined || swatchBefore === false) return null;
    if (swatchBefore === true) return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, swatchBeforeLabel && swatchBeforeRole ? {
        'aria-label': swatchBeforeLabel,
        role: swatchBeforeRole
    } : {}, {
        className: (0, $970q7.default)([
            $c2bf90a79c64a2dc$var$tagSwatchBeforeStyles.swatch,
            $c2bf90a79c64a2dc$var$tagSwatchBeforeColorStyles[colorKey]
        ])
    }));
    return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, swatchBeforeLabel && swatchBeforeRole ? {
        'aria-label': swatchBeforeLabel,
        role: swatchBeforeRole
    } : {}, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            backgroundColor: swatchBefore
        },
        className: (0, $970q7.default)([
            $c2bf90a79c64a2dc$var$tagSwatchBeforeStyles.swatch
        ])
    }));
}


/* tag-motion.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");


var $iO8GM = parcelRequire("iO8GM");





var $ebf19abd5204e9ea$var$tagMotionKey = 'atlaskit-tag-motion';
function $ebf19abd5204e9ea$var$TagMotionContent(_ref) {
    var children = _ref.children, forwardedRef = _ref.forwardedRef, onExitComplete = _ref.onExitComplete;
    var _useMotion = (0, $20264b49c785ea19$export$2a51cfe9390d36ef)({
        onFinish: function onFinish(phase) {
            if (phase === 'exiting') onExitComplete === null || onExitComplete === void 0 || onExitComplete();
        }
    }), motionRef = _useMotion.ref, state = _useMotion.state;
    var mergedRef = (0, $5FkrB.useMemo)(function() {
        return (0, $iO8GM.default)([
            forwardedRef,
            motionRef
        ]);
    }, [
        forwardedRef,
        motionRef
    ]);
    return children({
        isEntering: state === 'entering',
        isExiting: state === 'exiting',
        ref: mergedRef
    });
}
function $ebf19abd5204e9ea$export$6adae1772ccf137c(_ref2) {
    var children = _ref2.children, forwardedRef = _ref2.forwardedRef, onExitComplete = _ref2.onExitComplete, status = _ref2.status;
    var hasCompletedReducedMotionExit = (0, $5FkrB.useRef)(false);
    var outerPresence = (0, $1c6fc84fa2005a86$export$3b6f38abbdcbd000)();
    var isRemoved = status === (0, $24522fb0fe9a996c$export$74452314b63acabc).Removed || outerPresence.isExiting;
    var shouldAppear = outerPresence.isInsideExitingPersistence && outerPresence.appear && !outerPresence.isExiting;
    var latestExitState = (0, $5FkrB.useRef)({
        onExitComplete: onExitComplete,
        outerPresence: outerPresence,
        status: status
    });
    latestExitState.current = {
        onExitComplete: onExitComplete,
        outerPresence: outerPresence,
        status: status
    };
    var onMotionExitComplete = (0, $5FkrB.useCallback)(function() {
        var latest = latestExitState.current;
        if (latest.outerPresence.isExiting) {
            var _latest$outerPresence, _latest$outerPresence2;
            (_latest$outerPresence = (_latest$outerPresence2 = latest.outerPresence).onFinish) === null || _latest$outerPresence === void 0 || _latest$outerPresence.call(_latest$outerPresence2);
        }
        if (latest.status === (0, $24522fb0fe9a996c$export$74452314b63acabc).Removed) {
            var _latest$onExitComplet;
            (_latest$onExitComplet = latest.onExitComplete) === null || _latest$onExitComplet === void 0 || _latest$onExitComplet.call(latest);
        }
    }, []);
    (0, $5FkrB.useEffect)(function() {
        if (isRemoved && (0, $8d1b217f3672d39f$export$b7baf7667a68d87c)() && !hasCompletedReducedMotionExit.current) {
            hasCompletedReducedMotionExit.current = true;
            onMotionExitComplete();
        }
    }, [
        isRemoved,
        onMotionExitComplete
    ]);
    return /*#__PURE__*/ $5FkrB.createElement((0, $b6e492239adde5c3$export$2e2bcd8739ae039), {
        appear: shouldAppear
    }, !isRemoved && /*#__PURE__*/ $5FkrB.createElement($ebf19abd5204e9ea$var$TagMotionContent, {
        key: $ebf19abd5204e9ea$var$tagMotionKey,
        forwardedRef: forwardedRef,
        onExitComplete: onMotionExitComplete
    }, children));
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $d0c38bcd1f5c799c$export$84acd183858d8235() {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isLinkHovered = _useState2[0], setIsLinkHovered = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), isOverButton = _useState4[0], setIsOverButton = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), isButtonFocused = _useState6[0], setIsButtonFocused = _useState6[1];
    var _useState7 = (0, $5FkrB.useState)(false), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState7, 2), isLinkFocused = _useState8[0], setIsLinkFocused = _useState8[1];
    // Track if last interaction was via mouse (to determine keyboard vs mouse focus)
    var hadMouseDownRef = (0, $5FkrB.useRef)(false);
    // Button handlers
    var buttonHandlers = (0, $5FkrB.useMemo)(function() {
        return {
            onMouseEnter: function onMouseEnter() {
                return setIsOverButton(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setIsOverButton(false);
            },
            onMouseDown: function onMouseDown(e) {
                // Prevent the browser from moving focus to the remove button on mousedown.
                // Without this, parent composite widgets (e.g. Select) lose input focus when
                // the user clicks remove, triggering unwanted blur side-effects.
                e === null || e === void 0 || e.preventDefault();
                hadMouseDownRef.current = true;
            },
            onFocus: function onFocus() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsButtonFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function onBlur() {
                return setIsButtonFocused(false);
            }
        };
    }, []);
    // Link handlers - includes hover tracking
    var linkHandlers = (0, $5FkrB.useMemo)(function() {
        return {
            onMouseEnter: function onMouseEnter() {
                return setIsLinkHovered(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setIsLinkHovered(false);
            },
            onMouseDown: function onMouseDown() {
                hadMouseDownRef.current = true;
            },
            onFocus: function onFocus() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsLinkFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function onBlur() {
                return setIsLinkFocused(false);
            }
        };
    }, []);
    return {
        isLinkHovered: isLinkHovered,
        isOverButton: isOverButton,
        isButtonFocused: isButtonFocused,
        isLinkFocused: isLinkFocused,
        buttonHandlers: buttonHandlers,
        linkHandlers: linkHandlers
    };
}



var $8F9hT = parcelRequire("8F9hT");
function $c3889064fb576791$export$dcf14c9974fe2767(href, linkComponent) {
    var isLink = Boolean(href);
    var LinkComponent = linkComponent !== null && linkComponent !== void 0 ? linkComponent : (0, $8F9hT.default);
    return {
        isLink: isLink,
        LinkComponent: LinkComponent
    };
}


/**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $5FkrB = parcelRequire("5FkrB");
/* remove-button.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");


var $hRJ5R = parcelRequire("hRJ5R");

var $ac8VW = parcelRequire("ac8VW");


var $btdNC = parcelRequire("btdNC");
var $1281187d78f7e2cd$var$removeButtonStyles = {
    root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i1j6v _1bsb1j6v _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah3idpf _irr31dpa _1di6fcek",
    circle: "_2rko1rr0 _1ah3idpf",
    focusRing: "_1ah3v77o",
    newIcon: "_rjxpv77o"
};
var $1281187d78f7e2cd$var$RemoveButton = function RemoveButton(_ref) {
    var ariaLabel = _ref['aria-label'], onClick = _ref.onClick, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onKeyPress = _ref.onKeyPress, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onMouseDown = _ref.onMouseDown, onMouseUp = _ref.onMouseUp, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, testId = _ref.testId, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? 'default' : _ref$shape;
    return /*#__PURE__*/ $5FkrB.createElement((0, $btdNC.Pressable), {
        xcss: (0, $hRJ5R.cx)($1281187d78f7e2cd$var$removeButtonStyles.root, shape === 'circle' && $1281187d78f7e2cd$var$removeButtonStyles.circle, $1281187d78f7e2cd$var$removeButtonStyles.newIcon, (0, $6e1be09e06cae8e8$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts') && $1281187d78f7e2cd$var$removeButtonStyles.focusRing),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: testId
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ac8VW))), {
        color: "currentColor",
        label: "",
        size: "small"
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1281187d78f7e2cd$export$2e2bcd8739ae039 = $1281187d78f7e2cd$var$RemoveButton;


function $b59aeb97158e4a74$export$97d8be09cd53869b(_ref) {
    var isRemovable = _ref.isRemovable, tagText = _ref.tagText, removeButtonLabel = _ref.removeButtonLabel, testId = _ref.testId, handleRemoveRequest = _ref.handleRemoveRequest, removingTag = _ref.removingTag, showingTag = _ref.showingTag, onKeyPress = _ref.onKeyPress, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? 'default' : _ref$shape, buttonHandlers = _ref.buttonHandlers;
    var handleFocus = (0, $5FkrB.useCallback)(function() {
        removingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onFocus();
    }, [
        removingTag,
        buttonHandlers
    ]);
    var handleBlur = (0, $5FkrB.useCallback)(function() {
        showingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onBlur();
    }, [
        showingTag,
        buttonHandlers
    ]);
    return (0, $5FkrB.useMemo)(function() {
        if (!isRemovable) return undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1281187d78f7e2cd$export$2e2bcd8739ae039), {
            "aria-label": "".concat(removeButtonLabel || 'Remove', " ").concat(tagText),
            onClick: handleRemoveRequest,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyPress: onKeyPress,
            onMouseEnter: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseEnter,
            onMouseLeave: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseLeave,
            onMouseDown: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseDown,
            testId: testId ? "close-button-".concat(testId) : undefined,
            shape: shape
        });
    }, [
        isRemovable,
        removeButtonLabel,
        tagText,
        handleRemoveRequest,
        handleFocus,
        handleBlur,
        onKeyPress,
        buttonHandlers,
        testId,
        shape
    ]);
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
var $8f538ea8efe0bf4d$export$279e7025ed114474 = function defaultBeforeRemoveAction() {
    return true;
};



function $0fa33945b2860764$export$f26019543e9f862f(onBeforeRemoveAction) {
    var _useState = (0, $5FkrB.useState)((0, $24522fb0fe9a996c$export$74452314b63acabc).Showing), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var handleRemoveRequest = (0, $5FkrB.useCallback)(function() {
        var beforeAction = onBeforeRemoveAction !== null && onBeforeRemoveAction !== void 0 ? onBeforeRemoveAction : (0, $8f538ea8efe0bf4d$export$279e7025ed114474);
        if (beforeAction()) // Defer onAfterRemoveAction until ShrinkOut's onFinish so ExitingPersistence can run
        // the exit animation (e.g. in multi-select and user pickers).
        setStatus((0, $24522fb0fe9a996c$export$74452314b63acabc).Removed);
    }, [
        onBeforeRemoveAction
    ]);
    var onKeyPress = (0, $5FkrB.useCallback)(function(e) {
        var spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    var removingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus((0, $24522fb0fe9a996c$export$74452314b63acabc).Removing);
    }, []);
    var showingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus((0, $24522fb0fe9a996c$export$74452314b63acabc).Showing);
    }, []);
    return {
        status: status,
        handleRemoveRequest: handleRemoveRequest,
        onKeyPress: onKeyPress,
        removingTag: removingTag,
        showingTag: showingTag
    };
}


var $5b26577286bded4d$var$_excluded = [
    "color",
    "text",
    "elemBefore",
    "href",
    "linkComponent",
    "isRemovable",
    "removeButtonLabel",
    "onBeforeRemoveAction",
    "onAfterRemoveAction",
    "testId",
    "maxWidth",
    "hasMargin",
    "onClick",
    "swatchBefore",
    "swatchBeforeLabel",
    "swatchBeforeRole",
    "trailingMetric"
], $5b26577286bded4d$var$_excluded2 = [
    "color",
    "text",
    "elemBefore",
    "testId",
    "maxWidth",
    "hasMargin",
    "onClick",
    "isSelected",
    "isLoading",
    "analyticsContext",
    "hasChevron",
    "swatchBefore",
    "swatchBeforeLabel",
    "swatchBeforeRole",
    "trailingMetric"
];
var $5b26577286bded4d$var$styles = {
    baseStyles: "_zulp1b66 _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1rjcv77o _18zr1mie _1mou1b66 _195g1b66 _1e0c116y _vchhusvi _1ul9idpf _p12ff6dh _4t3i1k92 _kqswh2mm _4cvr1h6o _80om73ad _bfhksm61",
    noMarginStyles: "_1mouze3t _195gze3t",
    removableStyles: "_zulp1b66",
    beforeStyles: "_4bfu1snc _1hmsagmp _ajmmvv82 _1e0c116y _4cvr1h6o _1o9zidpf _syaz125o",
    beforeStylesSelected: "_syazxl6c",
    textStyles: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n _1ul9idpf _syazi7uo",
    textStylesSelected: "_syaz6x5g",
    afterStyles: "_1e0c1txw _4cvr1h6o _1o9zidpf _lcxv1wug _kqswh2mm",
    afterMotionStyles: "_1ul9utpp",
    trailingMetric: "_2rkolb4i _11c8wadc _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _4cvr1h6o _1o9zidpf _1kz6184x _bfhk1w9g _syazi7uo",
    trailingMetricEndPadding: "_y4ti303w",
    focusRingStyles: "_1ygbdfik _1ah3v77o",
    childFocusRingStyles: "_1a37dfik _1cwgv77o",
    interactiveBaseStyles: "_80omtlke _1all1b66 _qsdj1r31 _17ncglyw _15hpnqa1 _1rg815vq _1yoo15vq _j8j91snc _1afaagmp _gdbt10yn _h5vp116y _1qxz1h6o _8zx0idpf _1km4jdj5 _wc1fagmp _9408jdj5 _usew1snc _ebtnagmp _uvk910yn _10nj1r31 _1xq0glyw _18x1nqa1 _2mpsagmp",
    interactiveHoverStyles: "_17501r31 _qrsc8stv _1wodnqa1 _irr31dpa _rlyhjdj5 _1di6fcek",
    interactiveMotionStyles: "_v564k6bl _1ggl5xtf",
    activeMotionStyles: "_1reo15vq _18m915vq _8hrz1e5h",
    enteringMotionStyles: "_y44v1ukz _1bumglyw",
    exitingMotionStyles: "_y44v12ef _1bumglyw"
};
// For accent borders, we use the new color.border.accent.*.subtle tokens (Color300
// light / Color800 dark) which provide proper decorative-border colours
//
// Icons keep color.icon.accent.* in the default state (vibrant on the plain page
// background) and swap to color.text.accent.* in hovered/pressed states (where the
// Tag picks up a coloured background and needs guaranteed 3:1 icon contrast).
var $5b26577286bded4d$var$colorStyles = {
    gray: "_119bmsup _1ib21diz _egnk1sqi _17x31sqi _ih6z7qp0",
    blue: "_119b18hp _1ib26txe _egnk16jw _17x316jw _ih6z1dy8",
    green: "_119b5d2u _1ib217hp _egnkh55r _17x3h55r _ih6z1wnw",
    red: "_119bn9dc _1ib2nbxb _egnk9lu1 _17x39lu1 _ih6z1rtt",
    yellow: "_119b1s7j _1ib21oqg _egnkfb2s _17x3fb2s _ih6z1773",
    purple: "_119bluwt _1ib2uq3u _egnkqmo9 _17x3qmo9 _ih6z1nm4",
    lime: "_119b1m7d _1ib28645 _egnk1tco _17x31tco _ih6zz2ec",
    magenta: "_119b132u _1ib2v8hk _egnk1s8m _17x31s8m _ih6zv9ra",
    orange: "_119b1ip5 _1ib21j6y _egnkp1lv _17x3p1lv _ih6z165s",
    teal: "_119b131p _1ib28uof _egnk17qg _17x317qg _ih6z1a17"
};
// Border + icon filter styles - base state.
// Borders use the new color.border.accent.*.subtle tokens directly.
// Icons use the color.icon.accent.* tokens directly in the default state.
var $5b26577286bded4d$var$borderIconFilterStyles = {
    root: "_1h6dip4g _wi6h9ea2"
};
// Border + icon filter styles - interactive states (hover/pressed).
// Icons swap to the color.text.accent.* tokens for guaranteed 3:1 contrast
// against the coloured interactive backgrounds. Borders stay constant.
var $5b26577286bded4d$var$borderIconInteractiveFilterStyles = {
    root: "_4cvxip4g _zqoiipvw _q4ztip4g _ba35u0j8"
};
var $5b26577286bded4d$var$dropdownStyles = {
    interactive: "_irr31dpa _1di6fcek",
    selected: "_1h6dq98m _syaz6x5g _bfhk15s3 _irr3ufnl _1di6nozp",
    content: "_zulp1b66 _1reo15vq _18m915vq _1e0c116y _4cvr1h6o _16jlkb7n _1o9zkb7n _1ul9idpf",
    loadingMotion: "_k8m0brmi _1oec1ign _6fl4indk _sedtglyw",
    loadingOverlayMotion: "_j7hq1bym _5sag1ign _1pglindk _1bumglyw",
    loadingContent: "_tzy4idpf",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw"
};
/**
 * __TagNew__
 *
 * TagNew is the visual uplift implementation of Tag
 */ var $5b26577286bded4d$var$TagNewComponent = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TagNew(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'gray' : _ref$color, text = _ref.text, elemBefore = _ref.elemBefore, href = _ref.href, linkComponent = _ref.linkComponent, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, removeButtonLabel = _ref.removeButtonLabel, onBeforeRemoveAction = _ref.onBeforeRemoveAction, onAfterRemoveAction = _ref.onAfterRemoveAction, testId = _ref.testId, maxWidth = _ref.maxWidth, _ref$hasMargin = _ref.hasMargin, hasMargin = _ref$hasMargin === void 0 ? true : _ref$hasMargin, onClick = _ref.onClick, swatchBefore = _ref.swatchBefore, swatchBeforeLabel = _ref.swatchBeforeLabel, swatchBeforeRole = _ref.swatchBeforeRole, trailingMetric = _ref.trailingMetric, other = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $5b26577286bded4d$var$_excluded);
    var normalizedText = (0, $e9e19f0e43b7caa4$export$7d100de1166870f6)(text);
    var _useTagRemoval = (0, $0fa33945b2860764$export$f26019543e9f862f)(onBeforeRemoveAction), status = _useTagRemoval.status, handleRemoveRequest = _useTagRemoval.handleRemoveRequest, onKeyPress = _useTagRemoval.onKeyPress, removingTag = _useTagRemoval.removingTag, showingTag = _useTagRemoval.showingTag;
    var onShrinkOutExitComplete = (0, $5FkrB.useCallback)(function() {
        onAfterRemoveAction === null || onAfterRemoveAction === void 0 || onAfterRemoveAction(normalizedText);
    }, [
        normalizedText,
        onAfterRemoveAction
    ]);
    var _useLink = (0, $c3889064fb576791$export$dcf14c9974fe2767)(href, linkComponent), isLink = _useLink.isLink, LinkComponent = _useLink.LinkComponent;
    var _useButtonInteraction = (0, $d0c38bcd1f5c799c$export$84acd183858d8235)(), isLinkHovered = _useButtonInteraction.isLinkHovered, isOverButton = _useButtonInteraction.isOverButton, isButtonFocused = _useButtonInteraction.isButtonFocused, isLinkFocused = _useButtonInteraction.isLinkFocused, buttonHandlers = _useButtonInteraction.buttonHandlers, linkHandlers = _useButtonInteraction.linkHandlers;
    var removeButton = (0, $b59aeb97158e4a74$export$97d8be09cd53869b)({
        isRemovable: isRemovable,
        tagText: normalizedText,
        removeButtonLabel: removeButtonLabel,
        testId: testId,
        handleRemoveRequest: handleRemoveRequest,
        removingTag: removingTag,
        showingTag: showingTag,
        onKeyPress: onKeyPress,
        buttonHandlers: buttonHandlers
    });
    var isMotionEnabled = (0, $6e1be09e06cae8e8$export$b40ec24ac8275656)('platform-dst-motion-uplift-labels');
    var renderTagContent = function renderTagContent(tagRef) {
        var isEntering = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var isExiting = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, other, {
            ref: tagRef,
            "data-testid": testId,
            style: maxWidth !== undefined ? {
                maxWidth: maxWidth
            } : undefined,
            className: (0, $970q7.default)([
                $5b26577286bded4d$var$styles.baseStyles,
                !hasMargin && $5b26577286bded4d$var$styles.noMarginStyles,
                $5b26577286bded4d$var$colorStyles[color],
                $5b26577286bded4d$var$borderIconFilterStyles.root,
                isLink && $5b26577286bded4d$var$styles.interactiveBaseStyles,
                isLink && $5b26577286bded4d$var$styles.focusRingStyles,
                isLink && isMotionEnabled && $5b26577286bded4d$var$styles.interactiveMotionStyles,
                (isEntering || isExiting) && $5b26577286bded4d$var$styles.activeMotionStyles,
                isEntering && $5b26577286bded4d$var$styles.enteringMotionStyles,
                isExiting && $5b26577286bded4d$var$styles.exitingMotionStyles,
                isLink && isLinkHovered && !isOverButton && $5b26577286bded4d$var$borderIconInteractiveFilterStyles.root,
                isLink && isLinkHovered && !isOverButton && $5b26577286bded4d$var$styles.interactiveHoverStyles,
                isRemovable && $5b26577286bded4d$var$styles.removableStyles,
                isLinkFocused && !isButtonFocused && $5b26577286bded4d$var$styles.childFocusRingStyles,
                !isRemovable && trailingMetric != null && trailingMetric !== '' && $5b26577286bded4d$var$styles.trailingMetricEndPadding
            ])
        }), /*#__PURE__*/ $5FkrB.createElement((0, $0ec7de8f00cd92fd$export$ce4b6a469c26f53f), {
            isLink: isLink,
            href: href,
            LinkComponent: LinkComponent,
            testId: testId,
            linkHandlers: linkHandlers,
            onClick: onClick
        }, /*#__PURE__*/ $5FkrB.createElement((0, $c2bf90a79c64a2dc$export$2e2bcd8739ae039), {
            colorKey: color,
            swatchBefore: swatchBefore,
            swatchBeforeLabel: swatchBeforeLabel,
            swatchBeforeRole: swatchBeforeRole
        }), elemBefore && /*#__PURE__*/ $5FkrB.createElement("span", {
            className: (0, $970q7.default)([
                $5b26577286bded4d$var$styles.beforeStyles
            ])
        }, elemBefore), /*#__PURE__*/ $5FkrB.createElement("span", {
            "data-tag-text": true,
            className: (0, $970q7.default)([
                $5b26577286bded4d$var$styles.textStyles
            ])
        }, normalizedText), trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ $5FkrB.createElement("span", {
            "data-testid": testId && "".concat(testId, "--metric"),
            className: (0, $970q7.default)([
                $5b26577286bded4d$var$styles.trailingMetric
            ])
        }, trailingMetric)), removeButton && /*#__PURE__*/ $5FkrB.createElement("span", {
            className: (0, $970q7.default)([
                $5b26577286bded4d$var$styles.afterStyles,
                isMotionEnabled && $5b26577286bded4d$var$styles.afterMotionStyles
            ])
        }, !isExiting && removeButton));
    };
    if (isMotionEnabled) return /*#__PURE__*/ $5FkrB.createElement((0, $ebf19abd5204e9ea$export$6adae1772ccf137c), {
        forwardedRef: ref,
        onExitComplete: isRemovable ? onShrinkOutExitComplete : undefined,
        status: status
    }, function(_ref2) {
        var isEntering = _ref2.isEntering, isExiting = _ref2.isExiting, motionRef = _ref2.ref;
        return renderTagContent(motionRef, isEntering, isExiting);
    });
    return /*#__PURE__*/ $5FkrB.createElement((0, $6741191d181cc6ba$export$898a500849bb5cf4), {
        isRemovable: isRemovable,
        status: status,
        onShrinkOutExitComplete: isRemovable ? onShrinkOutExitComplete : undefined
    }, renderTagContent(ref));
});
var $5b26577286bded4d$export$aba6bd1190e79361 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TagDropdownTrigger(_ref3, ref) {
    var _ref3$color = _ref3.color, color = _ref3$color === void 0 ? 'gray' : _ref3$color, text = _ref3.text, elemBefore = _ref3.elemBefore, testId = _ref3.testId, maxWidth = _ref3.maxWidth, _ref3$hasMargin = _ref3.hasMargin, hasMargin = _ref3$hasMargin === void 0 ? true : _ref3$hasMargin, onClick = _ref3.onClick, _ref3$isSelected = _ref3.isSelected, isSelected = _ref3$isSelected === void 0 ? false : _ref3$isSelected, _ref3$isLoading = _ref3.isLoading, isLoading = _ref3$isLoading === void 0 ? false : _ref3$isLoading, _analyticsContext = _ref3.analyticsContext, _ref3$hasChevron = _ref3.hasChevron, hasChevron = _ref3$hasChevron === void 0 ? true : _ref3$hasChevron, swatchBefore = _ref3.swatchBefore, swatchBeforeLabel = _ref3.swatchBeforeLabel, swatchBeforeRole = _ref3.swatchBeforeRole, trailingMetric = _ref3.trailingMetric, other = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref3, $5b26577286bded4d$var$_excluded2);
    var resolvedColor = (0, $06a7bf290dc0e3f2$export$3351a8d90bcc13aa)[color] || 'gray';
    var isMotionEnabled = (0, $6e1be09e06cae8e8$export$b40ec24ac8275656)('platform-dst-motion-uplift-labels');
    return /*#__PURE__*/ $5FkrB.createElement((0, $btdNC.Pressable), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: ref,
        xcss: (0, $hUFig.cx)($5b26577286bded4d$var$styles.baseStyles, !hasMargin && $5b26577286bded4d$var$styles.noMarginStyles, $5b26577286bded4d$var$colorStyles[resolvedColor], $5b26577286bded4d$var$borderIconFilterStyles.root, $5b26577286bded4d$var$dropdownStyles.interactive, $5b26577286bded4d$var$styles.focusRingStyles, $5b26577286bded4d$var$borderIconInteractiveFilterStyles.root, isSelected && $5b26577286bded4d$var$dropdownStyles.selected, isMotionEnabled && $5b26577286bded4d$var$styles.interactiveMotionStyles, // Reduce end padding when trailing metric is the last element (no chevron)
        !hasChevron && trailingMetric != null && trailingMetric !== '' && $5b26577286bded4d$var$styles.trailingMetricEndPadding),
        onClick: isLoading ? undefined : onClick,
        style: {
            borderColor: isSelected ? "var(--ds-border-selected, #1868DB)" : undefined,
            cursor: isLoading ? 'progress' : 'pointer',
            maxWidth: maxWidth !== undefined ? maxWidth : undefined
        }
    }, isLoading && {
        'aria-busy': true,
        'aria-disabled': true,
        isDisabled: true
    }, {
        testId: testId
    }, other), /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            $5b26577286bded4d$var$dropdownStyles.content,
            isMotionEnabled && $5b26577286bded4d$var$dropdownStyles.loadingMotion,
            isLoading && $5b26577286bded4d$var$dropdownStyles.loadingContent
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $c2bf90a79c64a2dc$export$2e2bcd8739ae039), {
        colorKey: resolvedColor,
        swatchBefore: swatchBefore,
        swatchBeforeLabel: swatchBeforeLabel,
        swatchBeforeRole: swatchBeforeRole
    }), elemBefore && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            $5b26577286bded4d$var$styles.beforeStyles,
            isSelected && $5b26577286bded4d$var$styles.beforeStylesSelected
        ])
    }, elemBefore), /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-tag-text": true,
        className: (0, $970q7.default)([
            $5b26577286bded4d$var$styles.textStyles,
            isSelected && $5b26577286bded4d$var$styles.textStylesSelected
        ])
    }, (0, $e9e19f0e43b7caa4$export$7d100de1166870f6)(text)), trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId && "".concat(testId, "--metric"),
        className: (0, $970q7.default)([
            $5b26577286bded4d$var$styles.trailingMetric
        ])
    }, trailingMetric), hasChevron && /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($h19KG))), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && "".concat(testId, "--chevron")
    })), isLoading && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            $5b26577286bded4d$var$dropdownStyles.loadingOverlay,
            isMotionEnabled && $5b26577286bded4d$var$dropdownStyles.loadingOverlayMotion
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $9ztDu.default), {
        size: 'xsmall',
        label: ", Loading",
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    })));
});
/**
 * __Tag new__
 */ var $5b26577286bded4d$var$TagNew = (0, $0d5f3029391d01b3$export$88b132e52a65ec37)(/*#__PURE__*/ (0, $5FkrB.memo)($5b26577286bded4d$var$TagNewComponent));
var $5b26577286bded4d$export$2e2bcd8739ae039 = $5b26577286bded4d$var$TagNew;



/* base.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $f1caffee2a4fa25b$var$_excluded = [
    "before",
    "contentElement",
    "after",
    "testId",
    "style",
    "color",
    "href",
    "className"
];
function $f1caffee2a4fa25b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f1caffee2a4fa25b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f1caffee2a4fa25b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f1caffee2a4fa25b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Border colors - Hardcoded for Visual Refresh - to be removed with labelling system work
var $f1caffee2a4fa25b$var$borderColors = {
    standard: "_1h6d14je",
    blue: "_1h6duisw",
    red: "_1h6da2c0",
    yellow: "_1h6deh2r",
    green: "_1h6d18uw",
    teal: "_1h6d1ug6",
    purple: "_1h6d157s",
    lime: "_1h6dn0nx",
    magenta: "_1h6d1lf6",
    orange: "_1h6dh727",
    grey: "_1h6d14je",
    standardLink: "_1h6d14je",
    blueLight: "_1h6duisw",
    redLight: "_1h6da2c0",
    yellowLight: "_1h6deh2r",
    greenLight: "_1h6d18uw",
    tealLight: "_1h6d1ug6",
    purpleLight: "_1h6d157s",
    limeLight: "_1h6dn0nx",
    magentaLight: "_1h6d1lf6",
    orangeLight: "_1h6dh727",
    greyLight: "_1h6d14je"
};
var $f1caffee2a4fa25b$var$baseStyles = null;
var $f1caffee2a4fa25b$var$interactiveStyles = null;
var $f1caffee2a4fa25b$var$focusRingStyles = null;
var $f1caffee2a4fa25b$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function BaseTag(_ref, ref) {
    var before = _ref.before, contentElement = _ref.contentElement, after = _ref.after, testId = _ref.testId, style = _ref.style, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, className = _ref.className, other = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $f1caffee2a4fa25b$var$_excluded);
    var isLink = Boolean(href);
    var isRemovable = Boolean(after);
    var isInteractive = isLink || isRemovable;
    if (color === 'gray') // internally we use 'grey' for gray color so that we can make migration easier behind the ff (gray will work with and without ff now)
    color = 'grey';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, other, {
        ref: ref,
        style: $f1caffee2a4fa25b$var$_objectSpread({}, style),
        className: (0, $970q7.default)([
            "_zulp1b66 _2rko12b0 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3i1k92 _kqswh2mm _4cvr1h6o _bfhksm61 _syazi7uo _80om73ad",
            isInteractive && "_1e38dfik _7glxv77o",
            isLink && "_irr31dpa _1di6fcek",
            $f1caffee2a4fa25b$var$borderColors[color],
            className
        ]),
        "data-testid": testId
    }), before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f1caffee2a4fa25b$export$2e2bcd8739ae039 = $f1caffee2a4fa25b$var$BaseTag;


/* before.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $6649cbcdfb4f4def$var$beforeElementStyles = null;
var $6649cbcdfb4f4def$var$Before = function Before(_ref) {
    var elemBefore = _ref.elemBefore;
    return elemBefore ? /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            "_1e0c1txw _4t3i1j6v _4cvr1h6o _1bah1h6o _152tze3t"
        ])
    }, elemBefore) : null;
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6649cbcdfb4f4def$export$2e2bcd8739ae039 = $6649cbcdfb4f4def$var$Before;


/**
 * Maps Tag color values to Lozenge appearance values.
 * Used for migration_fallback rendering when feature flag is off.
 */ var $2b28b48b1d494119$var$colorToLozengeAppearanceMap = {
    gray: 'default',
    grey: 'default',
    lime: 'success',
    green: 'success',
    blue: 'inprogress',
    red: 'removed',
    purple: 'new',
    yellow: 'moved',
    orange: 'moved',
    magenta: 'new',
    teal: 'inprogress',
    grayLight: 'default',
    greyLight: 'default',
    limeLight: 'success',
    greenLight: 'success',
    blueLight: 'inprogress',
    redLight: 'removed',
    purpleLight: 'new',
    yellowLight: 'moved',
    orangeLight: 'moved',
    magentaLight: 'new',
    tealLight: 'inprogress'
};
function $2b28b48b1d494119$export$4d9e331cafeacb9d(color) {
    return $2b28b48b1d494119$var$colorToLozengeAppearanceMap[color || 'gray'] || 'default';
}


/* content.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $dc0ee9d4da95af1d$var$baseStyles = null;
var $dc0ee9d4da95af1d$var$linkStyles = null;
var $dc0ee9d4da95af1d$var$hasAfterStyles = null;
var $dc0ee9d4da95af1d$var$Content = function Content(_ref) {
    var _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? '' : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, linkComponent = _ref.linkComponent, testId = _ref.testId;
    var Link = linkComponent !== null && linkComponent !== void 0 ? linkComponent : 'a';
    var normalizedText = (0, $e9e19f0e43b7caa4$export$7d100de1166870f6)(text);
    if (href) return /*#__PURE__*/ $5FkrB.createElement(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? "".concat(testId, "--link") : undefined,
        className: (0, $970q7.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazi7uo _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3i7uo _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
            isRemovable && "_p12f1lit"
        ])
    }, normalizedText);
    else return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            isRemovable && "_p12f1lit"
        ])
    }, normalizedText);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dc0ee9d4da95af1d$export$2e2bcd8739ae039 = $dc0ee9d4da95af1d$var$Content;



var $8d2954f88569af93$var$_excluded = [
    "appearance",
    "elemBefore",
    "isRemovable",
    "text",
    "color",
    "href",
    "removeButtonLabel",
    "testId",
    "onBeforeRemoveAction",
    "onAfterRemoveAction",
    "linkComponent",
    "migration_fallback",
    "maxWidth",
    "hasMargin",
    "swatchBefore",
    "swatchBeforeLabel",
    "swatchBeforeRole"
];
var $8d2954f88569af93$var$textLinkCssVar = '--ds-ctl';
var $8d2954f88569af93$var$textDefaultCssVar = '--ds-ct';
var $8d2954f88569af93$var$textActiveCssVar = '--ds-ctp';
var $8d2954f88569af93$var$backgroundHoverCssVar = '--ds-cbh';
var $8d2954f88569af93$var$backgroundActiveCssVar = '--ds-cba';
var $8d2954f88569af93$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($8d2954f88569af93$var$TagStatus || {});
var $8d2954f88569af93$var$packageName = "@atlaskit/tag";
var $8d2954f88569af93$var$packageVersion = "15.7.2";
var $8d2954f88569af93$var$defaultBeforeRemoveAction = function defaultBeforeRemoveAction() {
    return true;
};
/**
 * These hide the focus ring for the tag when its remove button is focused,
 * preventing a double focus ring.
 */ var $8d2954f88569af93$var$removingStyles = null;
var $8d2954f88569af93$var$RemovableTagComponent = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var appearance = _ref.appearance, _ref$elemBefore = _ref.elemBefore, elemBefore = _ref$elemBefore === void 0 ? null : _ref$elemBefore, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? '' : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, removeButtonLabel = _ref.removeButtonLabel, testId = _ref.testId, _ref$onBeforeRemoveAc = _ref.onBeforeRemoveAction, onBeforeRemoveAction = _ref$onBeforeRemoveAc === void 0 ? $8d2954f88569af93$var$defaultBeforeRemoveAction : _ref$onBeforeRemoveAc, _ref$onAfterRemoveAct = _ref.onAfterRemoveAction, onAfterRemoveAction = _ref$onAfterRemoveAct === void 0 ? (0, $eVb4V.default) : _ref$onAfterRemoveAct, linkComponent = _ref.linkComponent, migration_fallback = _ref.migration_fallback, maxWidth = _ref.maxWidth, _ref$hasMargin = _ref.hasMargin, hasMargin = _ref$hasMargin === void 0 ? true : _ref$hasMargin, swatchBefore = _ref.swatchBefore, swatchBeforeLabel = _ref.swatchBeforeLabel, swatchBeforeRole = _ref.swatchBeforeRole, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $8d2954f88569af93$var$_excluded);
    var _useState = (0, $5FkrB.useState)($8d2954f88569af93$var$TagStatus.Showing), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), isHoverCloseButton = _useState4[0], setIsHoverCloseButton = _useState4[1];
    var normalizedText = (0, $e9e19f0e43b7caa4$export$7d100de1166870f6)(text);
    var onAfterRemoveActionWithAnalytics = (0, $8e76b91ff66695b3$export$53c2b9c37c40e0d8)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $8d2954f88569af93$var$packageName,
            packageVersion: $8d2954f88569af93$var$packageVersion
        }
    }, 'atlaskit');
    var handleRemoveComplete = (0, $5FkrB.useCallback)(function() {
        setStatus($8d2954f88569af93$var$TagStatus.Removed);
    }, []);
    var handleRemoveRequest = (0, $5FkrB.useCallback)(function() {
        if (onBeforeRemoveAction && onBeforeRemoveAction()) {
            onAfterRemoveActionWithAnalytics(normalizedText);
            handleRemoveComplete();
        }
    }, [
        handleRemoveComplete,
        normalizedText,
        onBeforeRemoveAction,
        onAfterRemoveActionWithAnalytics
    ]);
    var onKeyPress = (0, $5FkrB.useCallback)(function(e) {
        var spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    var removingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus($8d2954f88569af93$var$TagStatus.Removing);
    }, []);
    var showingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus($8d2954f88569af93$var$TagStatus.Showing);
    }, []);
    var handleMouseOver = (0, $5FkrB.useCallback)(function() {
        return setIsHoverCloseButton(true);
    }, []);
    var handleMouseOut = (0, $5FkrB.useCallback)(function() {
        return setIsHoverCloseButton(false);
    }, []);
    var removeButton = isRemovable ? /*#__PURE__*/ $5FkrB.createElement((0, $1281187d78f7e2cd$export$2e2bcd8739ae039), {
        "aria-label": "".concat(removeButtonLabel || 'Remove', " ").concat(normalizedText),
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: "close-button-".concat(testId)
    }) : undefined;
    // Handle migration_fallback: render Lozenge when flag is off and migration_fallback is 'lozenge'
    if (migration_fallback === 'lozenge' && !(0, $6e1be09e06cae8e8$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        var lozengeAppearance = (0, $2b28b48b1d494119$export$4d9e331cafeacb9d)(color);
        return /*#__PURE__*/ $5FkrB.createElement((0, $5supy.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            appearance: lozengeAppearance,
            isBold: false,
            testId: testId
        }, rest), normalizedText);
    }
    // Use new TagNew component behind feature flag
    // TagNew handles its own animation internally via RemovableWrapper
    if ((0, $6e1be09e06cae8e8$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        var newColor = (0, $06a7bf290dc0e3f2$export$3351a8d90bcc13aa)[color || 'standard'];
        return /*#__PURE__*/ $5FkrB.createElement((0, $5b26577286bded4d$export$2e2bcd8739ae039), {
            ref: ref,
            color: newColor,
            text: normalizedText,
            elemBefore: elemBefore,
            href: href,
            testId: testId,
            isRemovable: isRemovable,
            removeButtonLabel: removeButtonLabel,
            onBeforeRemoveAction: onBeforeRemoveAction,
            onAfterRemoveAction: onAfterRemoveActionWithAnalytics,
            maxWidth: maxWidth,
            hasMargin: hasMargin,
            swatchBefore: swatchBefore,
            swatchBeforeLabel: swatchBeforeLabel,
            swatchBeforeRole: swatchBeforeRole
        });
    }
    // Original implementation
    var content = /*#__PURE__*/ $5FkrB.createElement((0, $dc0ee9d4da95af1d$export$2e2bcd8739ae039), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: normalizedText,
        color: color,
        href: href,
        linkComponent: linkComponent,
        testId: testId
    });
    var hoverCloseButtonColors = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
    }, $8d2954f88569af93$var$backgroundHoverCssVar, undefined), $8d2954f88569af93$var$backgroundActiveCssVar, undefined), $8d2954f88569af93$var$textDefaultCssVar, undefined), $8d2954f88569af93$var$textActiveCssVar, undefined), $8d2954f88569af93$var$textLinkCssVar, undefined);
    return /*#__PURE__*/ $5FkrB.createElement((0, $b6e492239adde5c3$export$2e2bcd8739ae039), null, !(status === $8d2954f88569af93$var$TagStatus.Removed) && /*#__PURE__*/ $5FkrB.createElement((0, $5bab7d8d6e231b32$export$2e2bcd8739ae039), {
        key: "atlaskit-removable-tag-legacy-shrink-out",
        onFinish: handleRemoveComplete
    }, function(motion) {
        return /*#__PURE__*/ $5FkrB.createElement((0, $f1caffee2a4fa25b$export$2e2bcd8739ae039), {
            ref: (0, $iO8GM.default)([
                motion.ref,
                ref
            ]),
            appearance: appearance,
            color: color,
            testId: testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
            "data-removable": true,
            "data-removing": status === $8d2954f88569af93$var$TagStatus.Removing,
            "data-ishoverclosebutton": isHoverCloseButton,
            href: href,
            before: /*#__PURE__*/ $5FkrB.createElement((0, $6649cbcdfb4f4def$export$2e2bcd8739ae039), {
                elemBefore: elemBefore
            }),
            contentElement: content,
            after: removeButton,
            className: (0, $970q7.default)([
                status === $8d2954f88569af93$var$TagStatus.Removing && "_z30c1r31 _twwiglyw _1pka1o36 _bqhtfiwo"
            ])
        });
    }));
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ var $8d2954f88569af93$var$RemovableTag = (0, $0d5f3029391d01b3$export$88b132e52a65ec37)(/*#__PURE__*/ (0, $5FkrB.memo)($8d2954f88569af93$var$RemovableTagComponent));
var $8d2954f88569af93$export$2e2bcd8739ae039 = $8d2954f88569af93$var$RemovableTag;



/**
 * Hook to consume the SelectGetStylesContext.
 *
 * @internal — not part of the public API
 */ 
var $5FkrB = parcelRequire("5FkrB");
/**
 * Internal context used to pass the original Select instance's getStyles function
 * down to components like MultiValue, without polluting the public CommonProps API.
 *
 * This allows MultiValue to detect whether getStyles has been overridden on a
 * component instance (e.g. via a custom component wrapper passing a different
 * getStyles prop), by comparing props.getStyles against the original.
 *
 * @internal — not part of the public API
 */ 
var $5FkrB = parcelRequire("5FkrB");
var $8b5b84a5646086a0$export$50727c0a52da4015 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);


var $4b2504294b79d69c$export$2a533455c10aa11f = function useSelectGetStyles() {
    return (0, $5FkrB.useContext)((0, $8b5b84a5646086a0$export$50727c0a52da4015));
};



/* multi-value-label.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");
var $d06677510f43e94f$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c8fhey _o5721q9c _y4tiv77o _bozg1b66 _syaz1kw7",
    disabled: "_syaz1gmx",
    ellipsis: "_1bto1l2s"
};
var $d06677510f43e94f$export$544aeea2a5ce08ee = function MultiValueLabel(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isDisabled = _ref.isDisabled, hasEllipsis = _ref.hasEllipsis, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $d06677510f43e94f$var$multiValueLabelStyles.root,
            isDisabled && $d06677510f43e94f$var$multiValueLabelStyles.disabled,
            hasEllipsis && $d06677510f43e94f$var$multiValueLabelStyles.ellipsis,
            (0, $hUFig.cx)(className, xcss, '-MultiValueLabel')
        ])
    }), children);
};


function $3f9f002d7b81ed4b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3f9f002d7b81ed4b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3f9f002d7b81ed4b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3f9f002d7b81ed4b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3f9f002d7b81ed4b$var$multiValueTagWrapperStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1mouze3t _195gze3t _4cvr1h6o _1e0c1txw _1ul9ze3t _zdxokb7n _v5ynkb7n _13lsf1ug _3pxh1h6o _d0dz1txw _1ouwze3t"
};
var $3f9f002d7b81ed4b$var$multiValueMotionStyles = {
    active: "_1reo15vq _18m915vq _8hrz1e5h",
    entering: "_y44v1ukz _1bumglyw",
    exiting: "_y44v12ef _1bumglyw"
};
// Tag-like color styles
var $3f9f002d7b81ed4b$var$tagLikeColorStyles = {
    gray: "_119bmsup",
    blue: "_119b18hp",
    green: "_119b5d2u",
    red: "_119bn9dc",
    yellow: "_119b1s7j",
    purple: "_119bluwt",
    lime: "_119b1m7d",
    magenta: "_119b132u",
    orange: "_119b1ip5",
    teal: "_119b131p"
};
var $3f9f002d7b81ed4b$var$tagLikeBorderFilterStyles = null;
// Tag-like styles for custom content values (not plain text) when FF is on.
// Mirrors the TagNew component's visual appearance (padding, margins, sizing, colors).
// The container uses tag-like styling while Label/Remove sub-components are preserved
// so custom overrides (e.g. custom aria-labels, rendering objects as data) continue to work.
var $3f9f002d7b81ed4b$var$multiValueTagLikeStyles = {
    root: "_1reo15vq _18m915vq _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1mouze3t _195gze3t _1e0c116y _vchhusvi _kqswh2mm _4cvr1h6o _1wpz1h6o _1ul9ze3t _1o9zkb7n _p12ff6dh _4t3i1k92 _bfhksm61 _syazi7uo _80om73ad _3yq3glyw",
    labelWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _11c8wadc _1e0c1txw _4cvr1h6o _1ul9ze3t _1tkeidpf _2a9v1kw7",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk1dpa _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
var $3f9f002d7b81ed4b$var$getMultiValueLabelText = function getMultiValueLabelText(children, data) {
    if (typeof children === 'string') return children;
    var label = data === null || data === void 0 ? void 0 : data.label;
    return typeof label === 'string' ? label : '';
};
var $3f9f002d7b81ed4b$var$MultiValueContent = function MultiValueContent(contentProps) {
    var props = contentProps.multiValueProps, motionRef = contentProps.motionRef, motionState = contentProps.motionState;
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, isFocused = props.isFocused, removeProps = props.removeProps, selectProps = props.selectProps, cropWithEllipsis = props.cropWithEllipsis;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    var labelText = $3f9f002d7b81ed4b$var$getMultiValueLabelText(children, data);
    var isPlainLabel = typeof children === 'string';
    var ffTagUplifts = (0, $0ac0b27860a1d4ae$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts');
    var isEnteringWithMotion = motionState === 'entering';
    var isExitingWithMotion = motionState === 'exiting';
    var _getStyleProps = (0, $966e339201715f57$export$26417cabd806a658)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    }), containerCss = _getStyleProps.css, containerClassName = _getStyleProps.className;
    var _getStyleProps2 = (0, $966e339201715f57$export$26417cabd806a658)(props, 'multiValueLabel', {
        'multi-value__label': true
    }), labelCss = _getStyleProps2.css, labelClassName = _getStyleProps2.className;
    var _getStyleProps3 = (0, $966e339201715f57$export$26417cabd806a658)(props, 'multiValueRemove', {
        'multi-value__remove': true
    }), removeCss = _getStyleProps3.css, removeClassName = _getStyleProps3.className;
    var hasCustomLabel = Label !== (0, $d06677510f43e94f$export$544aeea2a5ce08ee);
    var hasCustomContainer = Container !== (0, $d83d9e99532d5b11$export$cf9cf2a30a59265c);
    var selectStyles = selectProps.styles;
    var hasCustomMultiValueStyles = Boolean((selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValue) || (selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValueLabel) || (selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValueRemove));
    var selectClassNames = selectProps.classNames;
    var hasCustomMultiValueClassNames = Boolean((selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValue) || (selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValueLabel) || (selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValueRemove));
    // Detect if getStyles was overridden directly on this component instance (e.g. via the
    // components prop wrapper passing a custom getStyles). The context holds the original
    // Select instance's getStyles — a reference inequality means a custom override was passed.
    // When context is absent (e.g. in mocked/test contexts), assume no override.
    var selectGetStyles = (0, $4b2504294b79d69c$export$2a533455c10aa11f)();
    var hasOverriddenGetStyles = selectGetStyles !== undefined && props.getStyles !== selectGetStyles;
    var hasCustomContainerStyles = hasCustomMultiValueStyles || hasCustomMultiValueClassNames || hasOverriddenGetStyles;
    if (ffTagUplifts && isPlainLabel && !hasCustomLabel && !hasCustomContainer && !hasCustomContainerStyles) {
        var _ref = data !== null && data !== void 0 ? data : {}, elemBefore = _ref.elemBefore, tagColor = _ref.color;
        return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
            ref: motionRef,
            className: (0, $970q7.default)([
                $3f9f002d7b81ed4b$var$multiValueTagWrapperStyles.root,
                isExitingWithMotion && $3f9f002d7b81ed4b$var$multiValueMotionStyles.active,
                isExitingWithMotion && $3f9f002d7b81ed4b$var$multiValueMotionStyles.exiting,
                (0, $hUFig.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ])
        }), /*#__PURE__*/ $5FkrB.createElement((0, $8d2954f88569af93$export$2e2bcd8739ae039), {
            text: labelText,
            isRemovable: !isDisabled,
            removeButtonLabel: "".concat(labelText, ", remove"),
            onBeforeRemoveAction: function onBeforeRemoveAction() {
                var _removeProps$onClick;
                (_removeProps$onClick = removeProps.onClick) === null || _removeProps$onClick === void 0 || _removeProps$onClick.call(removeProps, {});
                return false;
            },
            color: tagColor !== null && tagColor !== void 0 ? tagColor : 'gray',
            elemBefore: elemBefore,
            hasMargin: false
        }));
    }
    // FF on + custom content → tag-like path
    if (ffTagUplifts && !hasCustomContainer) {
        var colorKey = data === null || data === void 0 ? void 0 : data.color;
        return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            "data-multi-value-tag-like": "true"
        }, innerProps, {
            ref: motionRef,
            style: containerCss,
            className: (0, $970q7.default)([
                $3f9f002d7b81ed4b$var$multiValueTagLikeStyles.root,
                $3f9f002d7b81ed4b$var$tagLikeColorStyles.gray,
                colorKey === 'blue' && $3f9f002d7b81ed4b$var$tagLikeColorStyles.blue,
                colorKey === 'green' && $3f9f002d7b81ed4b$var$tagLikeColorStyles.green,
                colorKey === 'red' && $3f9f002d7b81ed4b$var$tagLikeColorStyles.red,
                colorKey === 'yellow' && $3f9f002d7b81ed4b$var$tagLikeColorStyles.yellow,
                colorKey === 'purple' && $3f9f002d7b81ed4b$var$tagLikeColorStyles.purple,
                colorKey === 'lime' && $3f9f002d7b81ed4b$var$tagLikeColorStyles.lime,
                colorKey === 'magenta' && $3f9f002d7b81ed4b$var$tagLikeColorStyles.magenta,
                colorKey === 'orange' && $3f9f002d7b81ed4b$var$tagLikeColorStyles.orange,
                colorKey === 'teal' && $3f9f002d7b81ed4b$var$tagLikeColorStyles.teal,
                "_1h6dip4g",
                isDisabled && $3f9f002d7b81ed4b$var$multiValueTagLikeStyles.disabled,
                isFocused && $3f9f002d7b81ed4b$var$multiValueTagLikeStyles.focused,
                (isEnteringWithMotion || isExitingWithMotion) && $3f9f002d7b81ed4b$var$multiValueMotionStyles.active,
                isEnteringWithMotion && $3f9f002d7b81ed4b$var$multiValueMotionStyles.entering,
                isExitingWithMotion && $3f9f002d7b81ed4b$var$multiValueMotionStyles.exiting,
                (0, $hUFig.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ])
        }), /*#__PURE__*/ $5FkrB.createElement("div", {
            className: (0, $970q7.default)([
                $3f9f002d7b81ed4b$var$multiValueTagLikeStyles.labelWrapper
            ])
        }, /*#__PURE__*/ $5FkrB.createElement(Label, {
            data: data,
            innerProps: {
                style: labelCss,
                className: labelClassName
            },
            className: labelClassName,
            hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
            selectProps: selectProps
        }, children)), /*#__PURE__*/ $5FkrB.createElement(Remove, {
            data: data,
            innerProps: $3f9f002d7b81ed4b$var$_objectSpread({
                style: removeCss,
                className: removeClassName,
                role: 'button',
                tabIndex: -1,
                'aria-label': "".concat(labelText || 'option', ", remove")
            }, removeProps),
            className: removeClassName,
            isDisabled: isDisabled,
            selectProps: selectProps
        }));
    }
    // FF off → default styles
    return /*#__PURE__*/ $5FkrB.createElement(Container, {
        data: data,
        innerProps: $3f9f002d7b81ed4b$var$_objectSpread({
            style: containerCss,
            className: containerClassName
        }, innerProps),
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps
    }, /*#__PURE__*/ $5FkrB.createElement(Label, {
        data: data,
        innerProps: {
            style: labelCss,
            className: labelClassName
        },
        className: labelClassName,
        hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
        selectProps: selectProps
    }, children), /*#__PURE__*/ $5FkrB.createElement(Remove, {
        data: data,
        innerProps: $3f9f002d7b81ed4b$var$_objectSpread({
            style: removeCss,
            className: removeClassName,
            role: 'button',
            tabIndex: -1,
            'aria-label': "".concat(labelText || 'option', ", remove")
        }, removeProps),
        className: removeClassName,
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var $3f9f002d7b81ed4b$var$MotionMultiValue = function MotionMultiValue(props) {
    var multiValueProps = props.multiValueProps;
    var _useMotion = (0, $20264b49c785ea19$export$2a51cfe9390d36ef)({
        onFinish: function onFinish(motionState) {
            if (motionState === 'exiting') {
                var _multiValueProps$onMo;
                (_multiValueProps$onMo = multiValueProps.onMotionFinish) === null || _multiValueProps$onMo === void 0 || _multiValueProps$onMo.call(multiValueProps);
            }
        }
    }), ref = _useMotion.ref, state = _useMotion.state;
    return /*#__PURE__*/ $5FkrB.createElement($3f9f002d7b81ed4b$var$MultiValueContent, {
        multiValueProps: multiValueProps,
        motionRef: ref,
        motionState: state
    });
};
var $3f9f002d7b81ed4b$var$MultiValue = function MultiValue(props) {
    if (props.isMotionEnabled) return /*#__PURE__*/ $5FkrB.createElement($3f9f002d7b81ed4b$var$MotionMultiValue, {
        multiValueProps: props
    });
    return /*#__PURE__*/ $5FkrB.createElement($3f9f002d7b81ed4b$var$MultiValueContent, {
        multiValueProps: props
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3f9f002d7b81ed4b$export$2e2bcd8739ae039 = $3f9f002d7b81ed4b$var$MultiValue;



/* multi-value-remove.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $ac8VW = parcelRequire("ac8VW");
var $bdaca1bd84ac7453$var$disabledStyles = null;
var $bdaca1bd84ac7453$var$enabledStyles = null;
var $bdaca1bd84ac7453$var$multiValueRemoveStyles = {
    focused: "_bfhkb1q9 _lswu6x5g",
    root: "_19itglyw _2rko12b0 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _1e0c1txw _lswui7uo _1q51v77o _y4tiv77o _85i5v77o _bozgv77o _12l2v77o _1ah312gs _irr31dpa _13br1tmw _1di6fcek _i5f81tmw"
};
function $bdaca1bd84ac7453$export$8e1fd1a40e7a2f4a(_ref) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, innerProps = _ref.innerProps, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $bdaca1bd84ac7453$var$multiValueRemoveStyles.root,
            isFocused && $bdaca1bd84ac7453$var$multiValueRemoveStyles.focused,
            (0, $hUFig.cx)(className, xcss, '-MultiValueRemove')
        ])
    }), /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
        className: (0, $970q7.default)([
            isDisabled && "_1e0cglyw",
            !isDisabled && "_1e0c1kw7"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ac8VW))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
}


/* option.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");


var $63e02aa8d5217d78$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syazi7uo _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di6fcek",
    disabled: "_syaz1gmx _80om13gf _bfhk1j28 _16qsglyw _1di61j28 _112eglyw",
    focused: "_bfhk1dpa _16qs1x9r _112e5u6v",
    selected: "_syaz6x5g _bfhk15s3 _16qs1x9r _1di6nozp _112e5u6v",
    focusedSelected: "_bfhkufnl",
    motion: "_v564hxmd _o7kshxmd _1ggl87vo",
    motionSelected: "_v5641rrn _o7kshxmd"
};
var $63e02aa8d5217d78$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $966e339201715f57$export$26417cabd806a658)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $63e02aa8d5217d78$var$optionStyles.root,
            !isDisabled && !isSelected && (0, $0ac0b27860a1d4ae$export$b40ec24ac8275656)('platform-dst-motion-uplift-list-item') && $63e02aa8d5217d78$var$optionStyles.motion,
            isFocused && $63e02aa8d5217d78$var$optionStyles.focused,
            isSelected && $63e02aa8d5217d78$var$optionStyles.selected,
            isFocused && isSelected && $63e02aa8d5217d78$var$optionStyles.focusedSelected,
            !isDisabled && isSelected && (0, $0ac0b27860a1d4ae$export$b40ec24ac8275656)('platform-dst-motion-uplift-list-item') && $63e02aa8d5217d78$var$optionStyles.motionSelected,
            isDisabled && $63e02aa8d5217d78$var$optionStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-option')
        ]),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$63e02aa8d5217d78$export$2e2bcd8739ae039 = $63e02aa8d5217d78$var$Option;


/* placeholder.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $fb60751b27a42aca$var$placeholderStyles = {
    root: "_nd5l1sux _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syaz1rpy",
    disabled: "_syaz1gmx"
};
var $fb60751b27a42aca$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, xcss = props.xcss;
    var _getStyleProps = (0, $966e339201715f57$export$26417cabd806a658)(props, 'placeholder', {
        placeholder: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $fb60751b27a42aca$var$placeholderStyles.root,
            isDisabled && $fb60751b27a42aca$var$placeholderStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-placeholder')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fb60751b27a42aca$export$2e2bcd8739ae039 = $fb60751b27a42aca$var$Placeholder;


/* single-value.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $456a4a8d2f02081a$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syazi7uo",
    disalbed: "_syaz1gmx"
};
var $456a4a8d2f02081a$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $966e339201715f57$export$26417cabd806a658)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $456a4a8d2f02081a$var$styles.root,
            isDisabled && $456a4a8d2f02081a$var$styles.disalbed,
            (0, $hUFig.cx)(className, xcss, '-singleValue')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$456a4a8d2f02081a$export$2e2bcd8739ae039 = $456a4a8d2f02081a$var$SingleValue;


function $231d9b01d6df79fe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $231d9b01d6df79fe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $231d9b01d6df79fe$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $231d9b01d6df79fe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $231d9b01d6df79fe$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $1e3518d74d68eed0$export$ecf9cf59142dd54a),
    Control: (0, $a311a5454302119b$export$2e2bcd8739ae039),
    DropdownIndicator: (0, $552465232ad1e8b5$export$ec98719d3db7f2e4),
    Group: (0, $0df35c2f916e37b9$export$2e2bcd8739ae039),
    GroupHeading: (0, $d1862782734ed219$export$85c8b41a3cd87edc),
    IndicatorsContainer: (0, $28cddc4c9d1f84b3$export$d0ffd7e649cab6f),
    Input: (0, $19573245e907a875$export$2e2bcd8739ae039),
    LoadingIndicator: (0, $f5d9bbe5852971a9$export$7c20be4c1d342248),
    Menu: (0, $84714ffe32836da2$export$2e2bcd8739ae039),
    MenuList: (0, $058c6574b2e0d939$export$d4c4e98c5044dc8),
    MenuPortal: (0, $fce85f889c556f89$export$793392f970497feb),
    LoadingMessage: (0, $6849e93c7b73357c$export$e928a71d039d3102),
    NoOptionsMessage: (0, $eb0ef5474bb099f4$export$d58b72b7d3c4072c),
    MultiValue: (0, $3f9f002d7b81ed4b$export$2e2bcd8739ae039),
    MultiValueContainer: (0, $d83d9e99532d5b11$export$cf9cf2a30a59265c),
    MultiValueLabel: (0, $d06677510f43e94f$export$544aeea2a5ce08ee),
    MultiValueRemove: (0, $bdaca1bd84ac7453$export$8e1fd1a40e7a2f4a),
    Option: (0, $63e02aa8d5217d78$export$2e2bcd8739ae039),
    Placeholder: (0, $fb60751b27a42aca$export$2e2bcd8739ae039),
    SelectContainer: (0, $f65534f2b9588afe$export$446eebadefe1123b),
    SingleValue: (0, $456a4a8d2f02081a$export$2e2bcd8739ae039),
    ValueContainer: (0, $89630d123f8d2966$export$4dc9f58ad9a1a000)
};
var $231d9b01d6df79fe$export$71abc632aa29e6fe = function defaultComponents(props) {
    return $231d9b01d6df79fe$var$_objectSpread($231d9b01d6df79fe$var$_objectSpread({}, $231d9b01d6df79fe$export$9b5ac10f59f76296), props.components);
};



var $9ztDu = parcelRequire("9ztDu");

var $5FkrB = parcelRequire("5FkrB");

var $bgNpv = parcelRequire("bgNpv");

var $jgNUw = parcelRequire("jgNUw");

var $cMVCI = parcelRequire("cMVCI");
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $25nEq = parcelRequire("25nEq");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $59a1e43eea16dc3e$var$_excluded = [
    "children"
], $59a1e43eea16dc3e$var$_excluded2 = [
    "height",
    "iconSize",
    "children",
    "style"
], $59a1e43eea16dc3e$var$_excluded3 = [
    "children"
], $59a1e43eea16dc3e$var$_excluded4 = [
    "children"
], $59a1e43eea16dc3e$var$_excluded5 = [
    "children"
], $59a1e43eea16dc3e$var$_excluded6 = [
    "displayFlag",
    "children"
], $59a1e43eea16dc3e$var$_excluded7 = [
    "children"
];
function $59a1e43eea16dc3e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $59a1e43eea16dc3e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $59a1e43eea16dc3e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $59a1e43eea16dc3e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Uses @compiled/react because descendant/child selectors and !important are not supported by the strict @atlaskit/css API.
var $59a1e43eea16dc3e$var$styles = {
    dropdownIndicatorWrapper: "_2hwxv77o _y3gn1h6o _1bsbzwfg",
    text: "_11c81qyo _19pku2gc",
    control: "_16qs130s _1e0c1txw _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    closeIconWrapper: "_80omtlke _syaz1rpy _f8pjazsu _30l3azsu"
};
var $59a1e43eea16dc3e$var$displayWrapperStyles = {
    shown: "_1e0c1ule",
    hidden: "_1e0cglyw"
};
var $59a1e43eea16dc3e$var$styledBoxStyles = {
    box: "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i1f4z _1bah1h6o"
};
var $59a1e43eea16dc3e$var$styledBoxIconStyles = {
    boxIcon: "_w8l5achg _1752achg"
};
var $59a1e43eea16dc3e$var$styledInvalidCheckboxOptionStyles = {
    invalidCheckboxOption: "_bfhk1gly _1e0c1txw _2lx2vrvc _4cvr1h6o _u5f3u2gc _w1w3jdj5"
};
var $59a1e43eea16dc3e$export$30c615a45297e297 = function DropdownIndicatorWrapper(_ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $59a1e43eea16dc3e$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $59a1e43eea16dc3e$var$styles.dropdownIndicatorWrapper
        ])
    }), children);
};
var $59a1e43eea16dc3e$export$d675f139b342d51a = function StyledBox(_ref2) {
    var height = _ref2.height, iconSize = _ref2.iconSize, children = _ref2.children, style = _ref2.style, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $59a1e43eea16dc3e$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: $59a1e43eea16dc3e$var$_objectSpread($59a1e43eea16dc3e$var$_objectSpread({
            '--paginated-picker-box-height': "".concat(height || 128, "px")
        }, iconSize ? {
            '--paginated-picker-icon-size': "".concat(iconSize, "px")
        } : {}), style)
    }, props, {
        className: (0, $970q7.default)([
            $59a1e43eea16dc3e$var$styledBoxStyles.box,
            iconSize && ""
        ])
    }), children);
};
var $59a1e43eea16dc3e$export$31ea92f3997410dd = function StyledText(_ref3) {
    var children = _ref3.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref3, $59a1e43eea16dc3e$var$_excluded3);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $59a1e43eea16dc3e$var$styles.text
        ])
    }), children);
};
var $59a1e43eea16dc3e$export$5c7b7f0e517b89f8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(_ref4, ref) {
    var children = _ref4.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref4, $59a1e43eea16dc3e$var$_excluded4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: ref
    }, props, {
        className: (0, $970q7.default)([
            $59a1e43eea16dc3e$var$styles.control
        ])
    }), children);
});
var $59a1e43eea16dc3e$export$94756becb802e330 = function CloseIconWrapper(_ref5) {
    var children = _ref5.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref5, $59a1e43eea16dc3e$var$_excluded5);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $59a1e43eea16dc3e$var$styles.closeIconWrapper
        ])
    }), children);
};
var $59a1e43eea16dc3e$export$6833d6d22987ee7f = function DisplayWrapper(_ref6) {
    var displayFlag = _ref6.displayFlag, children = _ref6.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref6, $59a1e43eea16dc3e$var$_excluded6);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $59a1e43eea16dc3e$var$displayWrapperStyles[displayFlag ? 'shown' : 'hidden']
        ])
    }), children);
};
var $59a1e43eea16dc3e$export$e786733cafde97b9 = function StyledInvalidCheckboxOption(_ref7) {
    var children = _ref7.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref7, $59a1e43eea16dc3e$var$_excluded7);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $59a1e43eea16dc3e$var$styledInvalidCheckboxOptionStyles.invalidCheckboxOption
        ])
    }), children);
};



var $6bnW7 = parcelRequire("6bnW7");
var $245b2fbfdc995ec3$var$message = (0, $6bnW7.defineMessages)({
    errorMessage: {
        id: 'paginated-picker.async-select.menu-list.error-message.error-message',
        defaultMessage: "Couldn't retrieve data",
        description: 'The text for when an error occurs when loading options'
    },
    retryMessage: {
        id: 'paginated-picker.async-select.menu-list.error-message.retry-message',
        defaultMessage: 'Click to retry',
        description: 'The text for button to reload options'
    }
});
var $245b2fbfdc995ec3$export$2e2bcd8739ae039 = $245b2fbfdc995ec3$var$message;


var $3ba1c1fa870de651$var$ErrorMessage = function ErrorMessage(_ref) {
    var onRetry = _ref.onRetry;
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    var onClick = (0, $5FkrB.useCallback)(function() {
        onRetry === null || onRetry === void 0 || onRetry();
    // fireOperationalAnalytics(
    //   createAnalyticsEvent({}),
    //   'refinementBarSelectRetry clicked',
    // );
    }, [
        onRetry
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $59a1e43eea16dc3e$export$d675f139b342d51a), {
        height: 144
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $59a1e43eea16dc3e$export$d675f139b342d51a), {
        height: 72,
        iconSize: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cMVCI))), {
        spacing: "spacious",
        color: "var(--ds-icon-subtle, #505258)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $59a1e43eea16dc3e$export$31ea92f3997410dd), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, $245b2fbfdc995ec3$export$2e2bcd8739ae039).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jgNUw.default), {
        onClick: onClick,
        appearance: "link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, $245b2fbfdc995ec3$export$2e2bcd8739ae039).retryMessage)));
};
var $3ba1c1fa870de651$export$2e2bcd8739ae039 = $3ba1c1fa870de651$var$ErrorMessage;



var $5FkrB = parcelRequire("5FkrB");

var $bgNpv = parcelRequire("bgNpv");

var $9ztDu = parcelRequire("9ztDu");


var $6bnW7 = parcelRequire("6bnW7");
var $410ed5dd5dd05e0c$var$message = (0, $6bnW7.defineMessages)({
    loadingMessage: {
        id: 'paginated-picker.async-select.menu-list.loading-message.loading-message',
        defaultMessage: 'Loading...',
        description: 'The text for when options are being loaded in dropdown'
    }
});
var $410ed5dd5dd05e0c$export$2e2bcd8739ae039 = $410ed5dd5dd05e0c$var$message;


var $f9e04d50c6f4cf14$export$e928a71d039d3102 = function LoadingMessage() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $59a1e43eea16dc3e$export$d675f139b342d51a), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $59a1e43eea16dc3e$export$d675f139b342d51a), {
        height: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9ztDu.default), {
        size: "large"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $59a1e43eea16dc3e$export$31ea92f3997410dd), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, $410ed5dd5dd05e0c$export$2e2bcd8739ae039).loadingMessage)));
};



var $5FkrB = parcelRequire("5FkrB");

var $bgNpv = parcelRequire("bgNpv");

var $jgNUw = parcelRequire("jgNUw");

var $6bnW7 = parcelRequire("6bnW7");
var $9d43c6050cef85ce$var$message = (0, $6bnW7.defineMessages)({
    showMoreButtonText: {
        id: 'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text',
        defaultMessage: 'Show more',
        description: 'Clicking this button will load more items into the dropdown'
    }
});
var $9d43c6050cef85ce$export$2e2bcd8739ae039 = $9d43c6050cef85ce$var$message;


var $216c4568705a329e$var$ShowMoreButton = function ShowMoreButton(_ref) {
    var onShowMore = _ref.onShowMore;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jgNUw.default), {
        onClick: onShowMore,
        appearance: "link",
        testId: "paginated-picker.ui.async-select.menu-list.show-more-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, $9d43c6050cef85ce$export$2e2bcd8739ae039).showMoreButtonText));
};
var $216c4568705a329e$export$2e2bcd8739ae039 = $216c4568705a329e$var$ShowMoreButton;


/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $29b86b92e16060dc$var$_excluded = [
    "children"
];
var $29b86b92e16060dc$var$styles = {
    loadingWrapper: "_1e0c1txw _1bah1h6o _19pk1b66 _otyr1b66"
};
var $29b86b92e16060dc$export$43a792a870d28db2 = function LoadingWrapper(_ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $29b86b92e16060dc$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $29b86b92e16060dc$var$styles.loadingWrapper
        ])
    }), children);
};


var $a23356c0bbc96ba3$export$d4c4e98c5044dc8 = function MenuList(props) {
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    var _useState = (0, $5FkrB.useState)(1), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), clickCount = _useState2[0], setClickCount = _useState2[1];
    var _props$selectProps$me = props.selectProps.menuListProps, _props$selectProps$me2 = _props$selectProps$me.error, isError = _props$selectProps$me2.isError, onRetry = _props$selectProps$me2.onRetry, handleShowMore = _props$selectProps$me.handleShowMore, isLoading = _props$selectProps$me.isLoading, isPaginationLoading = _props$selectProps$me.isPaginationLoading, showShowMoreButton = _props$selectProps$me.showShowMoreButton;
    var handleOnShowMore = (0, $5FkrB.useCallback)(function() {
        setClickCount(clickCount + 1);
        // sendAnalytics({
        //   actionSubjectId: 'filterSearchShowMore',
        //   createAnalyticsEvent,
        //   type,
        //   clickCount,
        // });
        handleShowMore();
    }, [
        clickCount,
        handleShowMore
    ]);
    if (isLoading && clickCount > 1) setClickCount(1);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $231d9b01d6df79fe$export$9b5ac10f59f76296).MenuList, props, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f9e04d50c6f4cf14$export$e928a71d039d3102), null) : isError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3ba1c1fa870de651$export$2e2bcd8739ae039), {
        onRetry: onRetry
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, props.children, isPaginationLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $29b86b92e16060dc$export$43a792a870d28db2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9ztDu.default), null)) : showShowMoreButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $216c4568705a329e$export$2e2bcd8739ae039), {
        onShowMore: handleOnShowMore
    })));
};
var $a23356c0bbc96ba3$export$2e2bcd8739ae039 = $a23356c0bbc96ba3$export$d4c4e98c5044dc8;



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $bgNpv = parcelRequire("bgNpv");

var $6bnW7 = parcelRequire("6bnW7");
var $50b27c1e46a1b600$var$message = (0, $6bnW7.defineMessages)({
    ofTotalCount: {
        id: 'paginated-picker.async-select.pagination-details.of-total-count',
        defaultMessage: '{itemsCount} of {totalCount}',
        description: 'Text shown in a paginated picker indicating how many items are currently loaded versus the total available. The placeholder {itemsCount} is the number of currently visible items and {totalCount} is the total number of items.'
    }
});
var $50b27c1e46a1b600$export$2e2bcd8739ae039 = $50b27c1e46a1b600$var$message;


/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $b24488283626b5ca$var$_excluded = [
    "children"
];
var $b24488283626b5ca$var$styles = {
    paginationDetails: "_16jlkb7n _1o9zkb7n _i0dlf1ug _11c8fhey _y3gnusic _19pku2gc _otyru2gc _18u0pxbi _2hwxpxbi _syaz1rpy"
};
var $b24488283626b5ca$export$fff9218028c24180 = function PaginationDetailsStyled(_ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $b24488283626b5ca$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $b24488283626b5ca$var$styles.paginationDetails
        ])
    }), children);
};


var $558dfe062f037bdc$export$33eb0288c0936a84 = function PaginationDetails(_ref) {
    var itemsCount = _ref.itemsCount, totalCount = _ref.totalCount;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b24488283626b5ca$export$fff9218028c24180), {
        "data-testid": "paginated-picker.ui.async-select.pagination-details"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, (0, $50b27c1e46a1b600$export$2e2bcd8739ae039).ofTotalCount, {
        values: {
            itemsCount: itemsCount,
            totalCount: totalCount
        }
    })));
};
var $558dfe062f037bdc$export$2e2bcd8739ae039 = $558dfe062f037bdc$export$33eb0288c0936a84;



var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $bgNpv = parcelRequire("bgNpv");
var $hrVKU = parcelRequire("hrVKU");

var $78ORw = parcelRequire("78ORw");
var $ffd7647384afed14$export$50531cf3046c5956 = {
    setValue: 'set-value',
    inputChange: 'input-change',
    inputBlur: 'input-blur',
    menuClose: 'menu-close',
    selectOption: 'select-option',
    deselectOption: 'deselect-option',
    removeValue: 'remove-value',
    popValue: 'pop-value',
    clear: 'clear',
    createOption: 'create-option',
    clearOptions: 'clear-options',
    add: 'add',
    remove: 'remove',
    update: 'update'
};



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $937edc529a693bc8$export$7a7fa4424cb20976 = function Control(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, innerRef = _ref.innerRef;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $59a1e43eea16dc3e$export$5c7b7f0e517b89f8), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        ref: innerRef
    }), children);
};



var $5FkrB = parcelRequire("5FkrB");

var $eNN4d = parcelRequire("eNN4d");

var $gAHKi = parcelRequire("gAHKi");


var $730bbd5f4f62989f$export$ec98719d3db7f2e4 = function DropdownIndicator(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $231d9b01d6df79fe$export$9b5ac10f59f76296).DropdownIndicator, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $59a1e43eea16dc3e$export$30c615a45297e297), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $59a1e43eea16dc3e$export$6833d6d22987ee7f), {
        displayFlag: !!props.selectProps.inputValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $59a1e43eea16dc3e$export$94756becb802e330), {
        onClick: function onClick(event) {
            var _props$selectProps$on, _props$selectProps;
            event.preventDefault();
            (_props$selectProps$on = (_props$selectProps = props.selectProps).onInputChange) === null || _props$selectProps$on === void 0 || _props$selectProps$on.call(_props$selectProps, '', {
                action: 'input-change',
                prevInputValue: props.selectProps.inputValue
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eNN4d))), {
        color: "currentColor",
        label: "",
        size: "small"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $59a1e43eea16dc3e$export$6833d6d22987ee7f), {
        displayFlag: !props.selectProps.inputValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gAHKi))), {
        color: "currentColor",
        label: ""
    }))));
};



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");
var $6859823722fd5cb7$export$d9b273488cd8ce6f = function Menu(_ref) {
    var innerRef = _ref.innerRef, innerProps = _ref.innerProps, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-testid": "refinement-bar.common.ui.select.menu",
        ref: innerRef
    }, innerProps), children);
};



var $6bnW7 = parcelRequire("6bnW7");
var $ada78d8cf5b547b2$var$message = (0, $6bnW7.defineMessages)({
    noOptionsMessage: {
        id: 'paginated-picker.async-select.select.no-options-message.no-options-message',
        defaultMessage: 'No matches found',
        description: 'The text for when no matches are found in dropdown'
    },
    searchPlaceholder: {
        id: 'paginated-picker.async-select.select.search-placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder text in search input indicating that the user can search'
    }
});
var $ada78d8cf5b547b2$export$2e2bcd8739ae039 = $ada78d8cf5b547b2$var$message;



var $5FkrB = parcelRequire("5FkrB");

var $cMVCI = parcelRequire("cMVCI");

var $aH7bq = parcelRequire("aH7bq");


var $4mzlU = parcelRequire("4mzlU");

var $ca78c38e3eaa23e3$var$renderOption = function renderOption(props) {
    return props.isMulti ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aH7bq.CheckboxOption), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1ff7be765d7c84f2$export$82ab7168879267a7), props);
};
var $ca78c38e3eaa23e3$export$36d18380658d5d20 = function Option(props) {
    var _props$data;
    if ((_props$data = props.data) !== null && _props$data !== void 0 && _props$data.invalid) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $59a1e43eea16dc3e$export$e786733cafde97b9), null, $ca78c38e3eaa23e3$var$renderOption(props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4mzlU.default), {
        content: props.selectProps.fieldInvalidLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cMVCI))), {
        label: "Test",
        color: "var(--ds-icon-danger, #C9372C)"
    })));
    return $ca78c38e3eaa23e3$var$renderOption(props);
};


var $35670e621ad6fad2$var$_excluded = [
    "onFilterOption",
    "placeholder"
];
var $35670e621ad6fad2$export$c34d65c0f5a1c617 = {
    Control: (0, $937edc529a693bc8$export$7a7fa4424cb20976),
    DropdownIndicator: (0, $730bbd5f4f62989f$export$ec98719d3db7f2e4),
    LoadingIndicator: null,
    Menu: (0, $6859823722fd5cb7$export$d9b273488cd8ce6f),
    Option: (0, $ca78c38e3eaa23e3$export$36d18380658d5d20)
};
var $35670e621ad6fad2$var$onIsOptionDisabled = function onIsOptionDisabled(option) {
    return 'error' in option ? !!option.error : false;
};
var $35670e621ad6fad2$export$51cc13ac81e51592 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(_ref, ref) {
    var _value$;
    var onFilterOption = _ref.onFilterOption, placeholder = _ref.placeholder, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $35670e621ad6fad2$var$_excluded);
    var intl = (0, $hrVKU.default)();
    var ariaLabelProp = restProps.ariaLabel, _restProps$isMulti = restProps.isMulti, isMulti = _restProps$isMulti === void 0 ? true : _restProps$isMulti, onChangeProp = restProps.onChange, onInputChangeProp = restProps.onInputChange, inputValueProp = restProps.inputValue, value = restProps.value;
    var effectiveIsMulti = isMulti;
    var _useState = (0, $5FkrB.useState)(inputValueProp || ''), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), inputValue = _useState2[0], setInputValue = _useState2[1];
    var onInputChange = (0, $5FkrB.useCallback)(function(newValue, actionMeta) {
        /**
     * Do not clear the filter input value when an input is selected or blurred.
     * NOTE: We are also returning when 'menu-close' event are triggered,
     * which happens when the input is clicked for some reason, but not when we click outside of the dropdown
     * */ if ([
            (0, $ffd7647384afed14$export$50531cf3046c5956).setValue,
            (0, $ffd7647384afed14$export$50531cf3046c5956).inputBlur,
            (0, $ffd7647384afed14$export$50531cf3046c5956).menuClose
        ].includes(actionMeta.action) && !newValue.length) return;
        onInputChangeProp === null || onInputChangeProp === void 0 || onInputChangeProp(newValue, actionMeta);
        setInputValue(newValue);
    }, [
        onInputChangeProp
    ]);
    var onChange = (0, $5FkrB.useCallback)(function(newValue, actionMeta) {
        // Keep this wrapper unconditional for both modes so hook creation stays stable.
        // In multiselect mode `newValue` is already an array, making this a no-op; in
        // single-select mode Atlaskit returns one option (or null), which we normalize
        // back to the array contract expected by the paginated-filter stack.
        var normalizedNewValue = Array.isArray(newValue) ? newValue : newValue ? [
            newValue
        ] : [];
        onChangeProp === null || onChangeProp === void 0 || onChangeProp(normalizedNewValue, actionMeta);
    }, [
        onChangeProp
    ]);
    var normalizedValue = effectiveIsMulti ? value : Array.isArray(value) ? (_value$ = value[0]) !== null && _value$ !== void 0 ? _value$ : null : value !== null && value !== void 0 ? value : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $78ORw.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, restProps, {
        // Typescript fix: SelectOption is not compatible with SingleOption from Select
        ref: ref,
        "aria-label": ariaLabelProp || intl.formatMessage((0, $ada78d8cf5b547b2$export$2e2bcd8739ae039).searchPlaceholder),
        autoFocus: true,
        backspaceRemovesValue: false,
        blurInputOnSelect: false,
        closeMenuOnSelect: !effectiveIsMulti,
        controlShouldRenderValue: false,
        hideSelectedOptions: false,
        isClearable: false,
        isMulti: effectiveIsMulti,
        inputValue: inputValue,
        menuIsOpen: true,
        menuShouldScrollIntoView: false,
        tabSelectsValue: false,
        noOptionsMessage: function noOptionsMessage() {
            return intl.formatMessage((0, $ada78d8cf5b547b2$export$2e2bcd8739ae039).noOptionsMessage);
        },
        onChange: onChange,
        onInputChange: onInputChange,
        isOptionDisabled: $35670e621ad6fad2$var$onIsOptionDisabled // Typescript fix: SelectOption is not compatible with SingleOption from Select
        ,
        filterOption: onFilterOption,
        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, $ada78d8cf5b547b2$export$2e2bcd8739ae039).searchPlaceholder),
        value: normalizedValue
    }));
});
$35670e621ad6fad2$export$51cc13ac81e51592.displayName = 'LocalBaseSelect';



var $5FkrB = parcelRequire("5FkrB");

var $bgNpv = parcelRequire("bgNpv");

var $jgNUw = parcelRequire("jgNUw");

var $6bnW7 = parcelRequire("6bnW7");
var $1c4839dd7bdc1ac9$var$message = (0, $6bnW7.defineMessages)({
    showFullListButtonText: {
        id: 'paginated-picker.async-select.show-full-list-button.show-full-list-button-text',
        defaultMessage: 'Show full list',
        description: 'Initially we show the first few items on the list. Clicking this button will show the full list.'
    }
});
var $1c4839dd7bdc1ac9$export$2e2bcd8739ae039 = $1c4839dd7bdc1ac9$var$message;


var $e578141c40a585b3$export$bf0956d66cd7566b = function ShowFullListButton(_ref) {
    var onShowFullList = _ref.onShowFullList;
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    var handleShowFullList = (0, $5FkrB.useCallback)(function() {
        // const analyticsEvent = createAnalyticsEvent({
        //   eventType: 'UI',
        //   action: 'expanded',
        //   actionSubject: 'filterSearch',
        //   actionSubjectId: 'refinementBarFilterSearch',
        // });
        //
        // const attributes: Attributes = {
        //   fieldType: type,
        // };
        //
        // fireUIAnalytics(analyticsEvent, 'refinementBarFilterSearch', attributes);
        onShowFullList();
    }, [
        onShowFullList
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jgNUw.default), {
        onClick: handleShowFullList,
        appearance: "subtle-link",
        testId: "paginated-picker.ui.async-select.show-full-list-button.show-full-list-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, $1c4839dd7bdc1ac9$export$2e2bcd8739ae039).showFullListButtonText));
};
var $e578141c40a585b3$export$2e2bcd8739ae039 = $e578141c40a585b3$export$bf0956d66cd7566b;


/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $dd3dba32b8acd19c$var$_excluded = [
    "children"
];
var $dd3dba32b8acd19c$var$styles = {
    footer: "_uwhk1dm9 _15a5nqa1 _1i531l7x _ca0q1b66 _n3td1b66 _1e0c1txw _2lx2vrvc _4cvr1h6o"
};
var $dd3dba32b8acd19c$export$a06f1c675e846f6f = function Footer(_ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $dd3dba32b8acd19c$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $dd3dba32b8acd19c$var$styles.footer
        ])
    }), children);
};


var $9ef9fb0f9f2a565e$var$_excluded = [
    "selectOptions"
], $9ef9fb0f9f2a565e$var$_excluded2 = [
    "ariaLabel",
    "field",
    "isMulti",
    "value",
    "onChange",
    "onClear",
    "hideClearSelection",
    "initiallyAddSelectedFirst",
    "showFooter"
];
function $9ef9fb0f9f2a565e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9ef9fb0f9f2a565e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9ef9fb0f9f2a565e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9ef9fb0f9f2a565e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9ef9fb0f9f2a565e$var$MAX_TOTAL_COUNT = 1000; // To be cleaned up in EM-3568
var $9ef9fb0f9f2a565e$var$paginatedComponents = $9ef9fb0f9f2a565e$var$_objectSpread($9ef9fb0f9f2a565e$var$_objectSpread({}, (0, $35670e621ad6fad2$export$c34d65c0f5a1c617)), {}, {
    MenuList: (0, $a23356c0bbc96ba3$export$d4c4e98c5044dc8)
});
var $9ef9fb0f9f2a565e$var$ProxyBaseSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(_ref, ref) {
    var selectOptions = _ref.selectOptions, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $9ef9fb0f9f2a565e$var$_excluded);
    return selectOptions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $35670e621ad6fad2$export$51cc13ac81e51592), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        options: selectOptions,
        ref: ref
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $35670e621ad6fad2$export$51cc13ac81e51592), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        ref: ref
    }));
});
$9ef9fb0f9f2a565e$var$ProxyBaseSelect.displayName = 'ProxyBaseSelect';
var $9ef9fb0f9f2a565e$var$AsyncSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(props, ref) {
    var baseSelectProps = (0, $1d703e93fcf166f5$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($9ef9fb0f9f2a565e$var$ProxyBaseSelect, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, baseSelectProps, {
        ref: ref
    }));
});
$9ef9fb0f9f2a565e$var$AsyncSelect.displayName = 'AsyncSelect';
/**
 * Adds option to the list of options if its value isn't currently in the Set of keys
 */ var $9ef9fb0f9f2a565e$var$_addUniqueOptions = function addUniqueOptions(keys, options, option) {
    if (option.optionType === 'group') {
        var groupOptions = [];
        option.options.forEach(function(groupOption) {
            $9ef9fb0f9f2a565e$var$_addUniqueOptions(keys, groupOptions, groupOption);
        });
        options.push($9ef9fb0f9f2a565e$var$_objectSpread($9ef9fb0f9f2a565e$var$_objectSpread({}, option), {}, {
            options: groupOptions
        }));
        return;
    }
    // Add single options:
    if (!keys.has(option.value)) {
        keys.add(option.value);
        options.push(option);
    }
};
var $9ef9fb0f9f2a565e$var$generateOptions = function generateOptions(selectedValues, newOptions, addSelectedFirst, previousOptions) {
    var optionKeys = new Set();
    var options = [];
    if (addSelectedFirst) selectedValues.forEach(function(option) {
        $9ef9fb0f9f2a565e$var$_addUniqueOptions(optionKeys, options, option);
    });
    previousOptions === null || previousOptions === void 0 || previousOptions.forEach(function(option) {
        $9ef9fb0f9f2a565e$var$_addUniqueOptions(optionKeys, options, option);
    });
    newOptions.forEach(function(option) {
        $9ef9fb0f9f2a565e$var$_addUniqueOptions(optionKeys, options, option);
    });
    return options;
};
var $9ef9fb0f9f2a565e$var$getLastCursorOption = function getLastCursorOption(options) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3a70dcab3a7aadc2$exports)))(options, function(option) {
        return 'cursor' in option && !!option.cursor;
    });
};
// Needed to disable filtering from react-select
var $9ef9fb0f9f2a565e$var$noFilterOptions = function noFilterOptions() {
    return true;
};
var $9ef9fb0f9f2a565e$var$noLoadOptions = function noLoadOptions() {
    return Promise.resolve();
};
var $9ef9fb0f9f2a565e$export$54319cf8344f1691 = function countSingleOptions(options) {
    return options.map(function(option) {
        return option.optionType === 'group' ? option.options.length : 1;
    }).reduce(function(sumSoFar, count) {
        return sumSoFar + count;
    }, 0);
};
var $9ef9fb0f9f2a565e$export$fccf54b4cac6e0b3 = function PaginatedAsyncSelectView(_ref2) {
    var _field$pagination$ena, _field$pagination;
    var ariaLabel = _ref2.ariaLabel, field = _ref2.field, _ref2$isMulti = _ref2.isMulti, isMulti = _ref2$isMulti === void 0 ? true : _ref2$isMulti, value = _ref2.value, onChange = _ref2.onChange, onClear = _ref2.onClear, _ref2$hideClearSelect = _ref2.hideClearSelection, hideClearSelection = _ref2$hideClearSelect === void 0 ? false : _ref2$hideClearSelect, initiallyAddSelectedFirst = _ref2.initiallyAddSelectedFirst, showFooter = _ref2.showFooter, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $9ef9fb0f9f2a565e$var$_excluded2);
    var selectRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), page = _useState2[0], setPage = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(true), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), isLoading = _useState4[0], setIsLoading = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), isPaginationLoading = _useState6[0], setIsPaginationLoading = _useState6[1];
    var _useState7 = (0, $5FkrB.useState)(''), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState7, 2), inputValue = _useState8[0], setInputValue = _useState8[1];
    var _useState9 = (0, $5FkrB.useState)([]), _useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState9, 2), loadedOptions = _useState0[0], setLoadedOptions = _useState0[1];
    var _useState1 = (0, $5FkrB.useState)((_field$pagination$ena = (_field$pagination = field.pagination) === null || _field$pagination === void 0 ? void 0 : _field$pagination.enableFullList) !== null && _field$pagination$ena !== void 0 ? _field$pagination$ena : false), _useState10 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState1, 2), enableFullList = _useState10[0], setEnableFullList = _useState10[1];
    var _useState11 = (0, $5FkrB.useState)(null), _useState12 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState11, 2), totalCount = _useState12[0], setTotalCount = _useState12[1];
    var _useState13 = (0, $5FkrB.useState)(), _useState14 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState13, 2), hasMore = _useState14[0], setHasMore = _useState14[1];
    var _useState15 = (0, $5FkrB.useState)({
        isError: false,
        error: null,
        onRetry: null
    }), _useState16 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState15, 2), error = _useState16[0], setError = _useState16[1];
    var getTotalCountWithFunctions = (0, $5FkrB.useCallback)(function(newTotalCount) {
        var _field$pagination2;
        if (newTotalCount === null || !((_field$pagination2 = field.pagination) !== null && _field$pagination2 !== void 0 && (_field$pagination2 = _field$pagination2.keywordValues) !== null && _field$pagination2 !== void 0 && _field$pagination2.length)) return newTotalCount;
        var keywordValues = field.pagination.keywordValues;
        var newTotalCountWithKeywords = newTotalCount + value.filter(function(option) {
            return keywordValues.includes(option.value);
        }).length;
        return newTotalCountWithKeywords < $9ef9fb0f9f2a565e$var$MAX_TOTAL_COUNT ? newTotalCountWithKeywords : $9ef9fb0f9f2a565e$var$MAX_TOTAL_COUNT;
    }, [
        field,
        value
    ]);
    var checkIfError = (0, $5FkrB.useCallback)(function(_search, options, onRetry) {
        if (options.some(function(option) {
            return option.optionType === 'error';
        })) {
            setError({
                isError: true,
                error: null,
                onRetry: onRetry
            });
            setIsLoading(false);
            return true;
        }
        setError({
            isError: false,
            error: null,
            onRetry: null
        });
        return false;
    }, []);
    var handleLoadOptions = (0, $5FkrB.useCallback)(function(search) {
        var loadOptions = field.loadOptions;
        if (!loadOptions) return;
        setIsLoading(true);
        loadOptions(search, enableFullList, false, false, undefined, function(_ref3) {
            var options = _ref3.options, newTotalCount = _ref3.totalCount, newHasMore = _ref3.hasMore;
            if (checkIfError(search, options, function() {
                return handleLoadOptions(search);
            })) return;
            setLoadedOptions($9ef9fb0f9f2a565e$var$generateOptions(value, options, initiallyAddSelectedFirst));
            setHasMore(newHasMore);
            setTotalCount(search ? newTotalCount : getTotalCountWithFunctions(newTotalCount));
            setIsLoading(false);
        });
    }, [
        field,
        enableFullList,
        checkIfError,
        value,
        initiallyAddSelectedFirst,
        getTotalCountWithFunctions
    ]);
    var handleShowMore = (0, $5FkrB.useCallback)(function() {
        var showFullList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var isRetry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var loadOptions = field.loadOptions;
        if (!loadOptions) return;
        var originalLoadedOptions;
        if (showFullList) {
            originalLoadedOptions = [];
            setIsLoading(true);
        } else {
            originalLoadedOptions = loadedOptions;
            if (isRetry) setIsLoading(true);
            else setIsPaginationLoading(true);
        }
        loadOptions(inputValue, false, showFullList, true, $9ef9fb0f9f2a565e$var$getLastCursorOption(loadedOptions), function(_ref4) {
            var options = _ref4.options, newTotalCount = _ref4.totalCount, newHasMore = _ref4.hasMore;
            if (checkIfError(inputValue, options, function() {
                handleShowMore(showFullList, true);
            })) return;
            setPage(page + 1);
            setEnableFullList(false);
            setLoadedOptions($9ef9fb0f9f2a565e$var$generateOptions(value, options, showFullList, originalLoadedOptions));
            setHasMore(newHasMore);
            setTotalCount(inputValue ? newTotalCount : getTotalCountWithFunctions(newTotalCount));
            setIsPaginationLoading(false);
            setIsLoading(false);
        });
    }, [
        field,
        loadedOptions,
        inputValue,
        checkIfError,
        value,
        page,
        getTotalCountWithFunctions
    ]);
    var handleShowFullList = (0, $5FkrB.useCallback)(function() {
        handleShowMore(true, false);
    }, [
        handleShowMore
    ]);
    var handleInputChange = (0, $5FkrB.useCallback)(function(newInputValue) {
        var onInputChange = field.onInputChange;
        setEnableFullList(false);
        setPage(0);
        setInputValue(newInputValue);
        setTotalCount(null);
        setLoadedOptions([]);
        handleLoadOptions(newInputValue);
        onInputChange && onInputChange();
    }, [
        field,
        handleLoadOptions
    ]);
    var handleOnChange = (0, $5FkrB.useCallback)(function(options, action) {
        var selectData;
        if ('option' in action) {
            var actionOption = action.option;
            if (actionOption && 'value' in actionOption) selectData = {
                selectedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($1099937d2cc3db76$exports)))(loadedOptions, function(option) {
                    return 'value' in option && option.value === actionOption.value;
                })
            };
        }
        onChange === null || onChange === void 0 || onChange(options, action, selectData);
    }, [
        onChange,
        loadedOptions
    ]);
    var handleClear = (0, $5FkrB.useCallback)(function() {
        onClear === null || onClear === void 0 || onClear();
        // Focus the search input after clearing
        setTimeout(function() {
            var _selectRef$current;
            (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 || _selectRef$current.focus();
        }, 0);
    }, [
        onClear
    ]);
    // We only want to call this on init, so it's ok to disable react-hooks/exhaustive-deps
    (0, $5FkrB.useEffect)(function() {
        handleLoadOptions('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var loadedOptionsCount = totalCount === null ? 0 : $9ef9fb0f9f2a565e$export$54319cf8344f1691(loadedOptions);
    var showClearSelection = !hideClearSelection && !!value.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($9ef9fb0f9f2a565e$var$AsyncSelect, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: selectRef,
        ariaLabel: ariaLabel,
        cacheOptions: field.cacheOptions,
        components: $9ef9fb0f9f2a565e$var$paginatedComponents,
        defaultOptions: field.defaultOptions,
        defaultOptionsLabel: field.defaultOptionsLabel,
        inputValue: inputValue,
        loadOptions: $9ef9fb0f9f2a565e$var$noLoadOptions,
        onInputChange: handleInputChange,
        onMenuScrollToBottom: field.onMenuScrollToBottom,
        onMenuScrollToTop: field.onMenuScrollToTop,
        placeholder: field.placeholder,
        fieldKey: field.key,
        fieldLabel: field.label,
        fieldInvalidLabel: field.invalidLabel,
        isMulti: isMulti,
        selectOptions: loadedOptions,
        onFilterOption: $9ef9fb0f9f2a565e$var$noFilterOptions,
        menuListProps: {
            error: error,
            type: field.key,
            handleShowMore: handleShowMore,
            isLoading: isLoading,
            isPaginationLoading: isPaginationLoading,
            showShowMoreButton: (0, $50U6m.fg)('adminhub-filter-cursor-pagination') && hasMore !== undefined ? hasMore : totalCount !== null && loadedOptionsCount < totalCount
        },
        onChange: handleOnChange,
        value: value
    }, restProps)), (showFooter || showClearSelection) && field.pagination && !isLoading && !!(loadedOptions !== null && loadedOptions !== void 0 && loadedOptions.length) && !error.isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dd3dba32b8acd19c$export$a06f1c675e846f6f), null, !value.length && enableFullList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e578141c40a585b3$export$bf0956d66cd7566b), {
        type: field.key,
        onShowFullList: handleShowFullList
    }), showClearSelection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $2ee9fbcaa15edf1c$export$1d4b7cda9e589b53), {
        onClear: handleClear,
        type: field.key
    }), showFooter && !enableFullList && totalCount !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $558dfe062f037bdc$export$33eb0288c0936a84), {
        itemsCount: loadedOptionsCount,
        totalCount: totalCount
    })));
};
var $9ef9fb0f9f2a565e$export$2e2bcd8739ae039 = $9ef9fb0f9f2a565e$export$fccf54b4cac6e0b3;



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
/* avatar.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $bDUuG = parcelRequire("bDUuG");

var $h8qvJ = parcelRequire("h8qvJ");

var $50U6m = parcelRequire("50U6m");
/* avatar-content.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $50U6m = parcelRequire("50U6m");

var $5FkrB = parcelRequire("5FkrB");
var $4c9ddebdb0bdac2a$var$defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
var $4c9ddebdb0bdac2a$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $5FkrB.createContext)($4c9ddebdb0bdac2a$var$defaultAvatarContentProps);



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $4d44de6ced942b69$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $5FkrB.createContext)(false);


var $5a830d0cb6be316e$export$7db5c57474082dd9 = function useEnsureIsInsideAvatar() {
    var context = (0, $5FkrB.useContext)((0, $4d44de6ced942b69$export$6b4cbd90d24955ad));
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};


var $4c041832c37ced0c$var$boxShadowCssVar = '--avatar-box-shadow';
var $4c041832c37ced0c$var$bgColorCssVar = '--avatar-bg-color';
var $4c041832c37ced0c$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw _1ejjglyw _mizu1v1w _1ah3v77o _ra3xnqa1 _128mdkaa _4dave4h9",
    circle: "_2rko1qll _14mj1qll",
    square: "_2rkol0p1",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peq2wxo"
};
var $4c041832c37ced0c$var$unboundStyles = {
    rootCustomBorder: "_11q7cxp3",
    root: "_vchh1ntv _bfhkcxp3 _16qs1nhn",
    hexagonFocusContainer: "_1rjc1wgn _18zr1dm9 _1mou5h37 _195g1ksc _bfhk1j28 _mkrz1k6g _1o9o1v1w",
    hexagonBorderContainerCustomBorder: "_11q7cxp3",
    hexagonBorderContainer: "_1rjcf6hp _18zruxly _1mou18m8 _195gzwb8 _bfhkcxp3 _mkrz1kw7 _1o9ovuon",
    hexagon: "_2rkoidpf _mkrz1kw7 _16qsn7od _14mjidpf _1ejjn7od _128midpf _4davidpf",
    interactive: "_80omtlke _4tpu1f0r _ez1ykb7n _gcm1jer9 _eeh8kb7n _jlxit94y",
    interactiveMotion: "_v5641krm _1llweo6y"
};
var $4c041832c37ced0c$var$hexagonBorderFixStyles = {
    hexagonBorderContainer: "_85i5pe44 _1q51pe44 _y4tipe44 _bozgpe44 _6rthn6b1 _1pfhn6b1 _12l2n6b1 _ahbqn6b1",
    hexagonFocusContainer: "_85i5i44o _1q51i44o _y4tii44o _bozgi44o _6rthnlpx _1pfhnlpx _12l2nlpx _ahbqnlpx"
};
var $4c041832c37ced0c$var$widthHeightMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz",
    xsmall: "_1bsb7vkz _4t3i7vkz",
    UNSAFE_xsmall: "_1bsbgktf _4t3igktf",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
var $4c041832c37ced0c$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children;
    (0, $5a830d0cb6be316e$export$7db5c57474082dd9)();
    var _useContext = (0, $5FkrB.useContext)((0, $4c9ddebdb0bdac2a$export$b983474ddd0b6d28)), Container = _useContext.as, appearance = _useContext.appearance, avatarImage = _useContext.avatarImage, _useContext$borderCol = _useContext.borderColor, borderColor = _useContext$borderCol === void 0 ? "var(--ds-surface, #FFFFFF)" : _useContext$borderCol, href = _useContext.href, isDisabled = _useContext.isDisabled, label = _useContext.label, onClick = _useContext.onClick, contextRef = _useContext.ref, tabIndex = _useContext.tabIndex, target = _useContext.target, testId = _useContext.testId, size = _useContext.size, stackIndex = _useContext.stackIndex, ariaControls = _useContext['aria-controls'], ariaExpanded = _useContext['aria-expanded'], ariaHasPopup = _useContext['aria-haspopup'];
    var isInteractive = Boolean(onClick || href || isDisabled || ariaHasPopup);
    var renderedContent = /*#__PURE__*/ $5FkrB.createElement(Container, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $4c041832c37ced0c$var$bgColorCssVar, borderColor), $4c041832c37ced0c$var$boxShadowCssVar, "0 0 0 2px ".concat(borderColor)),
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined
    }, href && {
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined
    }, {
        className: (0, $970q7.default)([
            $4c041832c37ced0c$var$unboundStyles.root,
            (0, $50U6m.fg)('avatar-custom-border') && $4c041832c37ced0c$var$unboundStyles.rootCustomBorder,
            $4c041832c37ced0c$var$styles.root,
            appearance === 'square' && $4c041832c37ced0c$var$styles.square,
            appearance === 'circle' && $4c041832c37ced0c$var$styles.circle,
            appearance === 'hexagon' && $4c041832c37ced0c$var$unboundStyles.hexagon,
            $4c041832c37ced0c$var$widthHeightMap[size],
            stackIndex !== undefined && $4c041832c37ced0c$var$styles.positionRelative,
            isInteractive && !isDisabled && $4c041832c37ced0c$var$unboundStyles.interactive,
            isInteractive && !isDisabled && appearance !== 'hexagon' && (0, $50U6m.fg)('platform-dst-motion-uplift') && $4c041832c37ced0c$var$unboundStyles.interactiveMotion,
            isDisabled && $4c041832c37ced0c$var$styles.disabled
        ])
    }), children || avatarImage);
    if (appearance !== 'hexagon') return renderedContent;
    // For a Hexagon Avatar in order to have hexagonal "border" and "outline", we have to
    // layer multiple elements and use their background colors to create the different layers.
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        style: (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $4c041832c37ced0c$var$bgColorCssVar, borderColor), $4c041832c37ced0c$var$boxShadowCssVar, "0 0 0 2px ".concat(borderColor)),
        "data-testid": testId ? "".concat(testId, "-hexagon-focus-container") : 'hexagon-focus-container',
        className: (0, $970q7.default)([
            $4c041832c37ced0c$var$unboundStyles.hexagonFocusContainer,
            isInteractive && !isDisabled && (0, $50U6m.fg)('platform-dst-motion-uplift') && $4c041832c37ced0c$var$unboundStyles.interactiveMotion,
            (0, $50U6m.fg)('platform_editor_agent_mentions_drop_one_fixes') && $4c041832c37ced0c$var$hexagonBorderFixStyles.hexagonFocusContainer
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": testId ? "".concat(testId, "-hexagon-border-container") : 'hexagon-border-container',
        className: (0, $970q7.default)([
            $4c041832c37ced0c$var$unboundStyles.hexagonBorderContainer,
            (0, $50U6m.fg)('avatar-custom-border') && $4c041832c37ced0c$var$unboundStyles.hexagonBorderContainerCustomBorder,
            (0, $50U6m.fg)('platform_editor_agent_mentions_drop_one_fixes') && $4c041832c37ced0c$var$hexagonBorderFixStyles.hexagonBorderContainer
        ])
    }, renderedContent));
});


/* avatar-image.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $59otM = parcelRequire("59otM");

var $a67qK = parcelRequire("a67qK");

var $aWVGs = parcelRequire("aWVGs");
var $99211cea90637578$var$styles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
    icon: "_1e0c1txw _1bsb1osq _4t3i1osq _bfhk7qp0",
    circle: "_2rko1rr0",
    hexagon: "_mkrz1k6g"
};
var $99211cea90637578$var$borderRadiusMap = {
    xxsmall: "_2rkolb4i",
    xsmall: "_2rkolb4i",
    UNSAFE_xsmall: "_2rkolb4i",
    small: "_2rkolb4i",
    medium: "_2rko12b0",
    large: "_2rko12b0",
    xlarge: "_2rko1qi0",
    xxlarge: "_2rkopb1k"
};
var $99211cea90637578$var$nestedSvgStylesMap = {
    xxsmall: "_w8l57vkz _17527vkz",
    xsmall: "_w8l57vkz _17527vkz",
    UNSAFE_xsmall: "_w8l5gktf _1752gktf",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l516xz _175216xz",
    xxlarge: "_w8l51qr7 _17521qr7"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ var $99211cea90637578$var$AvatarImage = function AvatarImage(_ref) {
    var _ref$alt = _ref.alt, alt = _ref$alt === void 0 ? '' : _ref$alt, src = _ref.src, appearance = _ref.appearance, size = _ref.size, testId = _ref.testId, imgLoading = _ref.imgLoading;
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    // If src changes, reset state
    (0, $5FkrB.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        var renderedIcon;
        switch(appearance){
            case 'circle':
                renderedIcon = /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a67qK))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && "".concat(testId, "--person"),
                    spacing: "spacious"
                });
                break;
            case 'hexagon':
                renderedIcon = /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($59otM))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && "".concat(testId, "--agent"),
                    spacing: "spacious"
                });
                break;
            default:
            case 'square':
                renderedIcon = /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWVGs))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && "".concat(testId, "--ship"),
                    spacing: "spacious"
                });
                break;
        }
        return /*#__PURE__*/ $5FkrB.createElement("span", {
            className: (0, $970q7.default)([
                $99211cea90637578$var$styles.icon,
                $99211cea90637578$var$nestedSvgStylesMap[size]
            ])
        }, renderedIcon);
    }
    return /*#__PURE__*/ $5FkrB.createElement("img", {
        loading: imgLoading,
        src: src,
        alt: alt,
        "data-testid": testId && "".concat(testId, "--image"),
        onError: function onError() {
            return setHasImageErrored(true);
        },
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? "".concat(testId, "--image") : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, $970q7.default)([
            $99211cea90637578$var$styles.image,
            $99211cea90637578$var$borderRadiusMap[size],
            appearance === 'circle' && $99211cea90637578$var$styles.circle,
            appearance === 'hexagon' && $99211cea90637578$var$styles.hexagon
        ])
    });
};
var $99211cea90637578$export$2e2bcd8739ae039 = $99211cea90637578$var$AvatarImage;




var $2a41c0f14558b2c3$var$getCustomElement = function getCustomElement(isDisabled, href, onClick, ariaHasPopup) {
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled || ariaHasPopup) return 'button';
    return 'span';
};
var $2a41c0f14558b2c3$export$2e2bcd8739ae039 = $2a41c0f14558b2c3$var$getCustomElement;


/* presence-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
/* presence.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

/* icon-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $2acbca90b0739f09$var$styles = {
    root: "_2rko1qll _1reo15vq _18m915vq _189e1dm9 _1dqonqa1 _1e0c1txw _vchhusvi _1bsb1osq _4t3i1osq _4cvr1h6o _ae4v1h6o _bfhk1bhr"
};
var $2acbca90b0739f09$var$unboundStyles = {
    root: "_1h6d1bhr"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ var $2acbca90b0739f09$var$IconWrapper = function IconWrapper(_ref) {
    var bgColor = _ref.bgColor, children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $970q7.default)([
            $2acbca90b0739f09$var$styles.root,
            $2acbca90b0739f09$var$unboundStyles.root
        ])
    }, children);
};
var $2acbca90b0739f09$export$2e2bcd8739ae039 = $2acbca90b0739f09$var$IconWrapper;


var $646b9c4844b02e99$var$BusyIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("circle", {
    fill: "var(--ds-icon-danger, #C9372C)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
var $646b9c4844b02e99$var$FocusIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-icon-discovery, #AF59E1)",
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
var $646b9c4844b02e99$var$OfflineIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-text-subtlest, #6B6E76)",
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
var $646b9c4844b02e99$var$OnlineIndicator = /*#__PURE__*/ $5FkrB.createElement("circle", {
    fill: "var(--ds-icon-success, #6A9A23)",
    cx: "4",
    cy: "4",
    r: "4"
});
function $646b9c4844b02e99$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $646b9c4844b02e99$var$BusyIndicator;
        case 'focus':
            return $646b9c4844b02e99$var$FocusIndicator;
        case 'offline':
            return $646b9c4844b02e99$var$OfflineIndicator;
        case 'online':
            return $646b9c4844b02e99$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ var $646b9c4844b02e99$var$AvatarPresence = function AvatarPresence(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, presence = _ref.presence;
    return /*#__PURE__*/ $5FkrB.createElement((0, $2acbca90b0739f09$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ $5FkrB.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $646b9c4844b02e99$var$getPresence(presence)) : children);
};
var $646b9c4844b02e99$export$2e2bcd8739ae039 = $646b9c4844b02e99$var$AvatarPresence;


var $34241aebfba62b82$var$styles = {
    root: "_kqswstnw _lcxvglyw"
};
var $34241aebfba62b82$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
var $34241aebfba62b82$var$circleIconOffsetMap = {
    small: "_94n5idpf _1xi2idpf",
    medium: "_94n5idpf _1xi2idpf",
    large: "_94n5t94y _1xi2t94y",
    xlarge: "_94n51v6z _1xi21v6z"
};
var $34241aebfba62b82$var$squareIconOffsetMap = {
    root: "_94n5myb0 _1xi2myb0"
};
var $34241aebfba62b82$var$hexagonIconOffsetMap = {
    small: "_94n51n1a _1xi21n1a",
    medium: "_94n51n1a _1xi21n1a",
    large: "_94n51y44 _1xi2myb0",
    xlarge: "_94n5l52n _1xi21lpd"
};
/**
 * __Presence wrapper__
 *
 * A presence wrapper is used internally to position presence ontop of the avatar.
 */ var $34241aebfba62b82$var$PresenceWrapper = function PresenceWrapper(_ref) {
    var size = _ref.size, appearance = _ref.appearance, children = _ref.children, borderColor = _ref.borderColor, presence = _ref.presence, testId = _ref.testId;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--presence"),
        className: (0, $970q7.default)([
            $34241aebfba62b82$var$styles.root,
            $34241aebfba62b82$var$iconSizeMap[size],
            $34241aebfba62b82$var$circleIconOffsetMap[size],
            appearance === 'square' && $34241aebfba62b82$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $34241aebfba62b82$var$hexagonIconOffsetMap[size]
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $646b9c4844b02e99$export$2e2bcd8739ae039), {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};
var $34241aebfba62b82$export$2e2bcd8739ae039 = $34241aebfba62b82$var$PresenceWrapper;


/* status-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
/* status.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");


var $90a388dca829d063$var$ApprovedIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("circle", {
    fill: "var(--ds-icon-success, #6A9A23)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
var $90a388dca829d063$var$DeclinedIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("circle", {
    fill: "var(--ds-icon-danger, #C9372C)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
var $90a388dca829d063$var$LockedIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("circle", {
    fill: "var(--ds-text-subtlest, #6B6E76)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
var $90a388dca829d063$var$WarningIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("circle", {
    fill: "var(--ds-icon-warning, #E06C00)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4,1.33333333 C4.36918944,1.33333333 4.66666667,1.63081056 4.66666667,2 L4.66666667,4 C4.66666667,4.36918944 4.36918944,4.66666667 4,4.66666667 C3.63081056,4.66666667 3.33333333,4.36918944 3.33333333,4 L3.33333333,2 C3.33333333,1.63081056 3.63081056,1.33333333 4,1.33333333 Z M4,5.33333333 C4.36918944,5.33333333 4.66666667,5.63081056 4.66666667,6 C4.66666667,6.36918944 4.36918944,6.66666667 4,6.66666667 C3.63081056,6.66666667 3.33333333,6.36918944 3.33333333,6 C3.33333333,5.63081056 3.63081056,5.33333333 4,5.33333333 Z"
}));
function $90a388dca829d063$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $90a388dca829d063$var$ApprovedIndicator;
        case 'declined':
            return $90a388dca829d063$var$DeclinedIndicator;
        case 'locked':
            return $90a388dca829d063$var$LockedIndicator;
        case 'warning':
            return $90a388dca829d063$var$WarningIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ var $90a388dca829d063$var$AvatarStatus = function AvatarStatus(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, status = _ref.status;
    return /*#__PURE__*/ $5FkrB.createElement((0, $2acbca90b0739f09$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ $5FkrB.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $90a388dca829d063$var$getStatus(status)) : children);
};
var $90a388dca829d063$export$2e2bcd8739ae039 = $90a388dca829d063$var$AvatarStatus;


var $658f814ccac33220$var$styles = {
    root: "_kqswstnw"
};
var $658f814ccac33220$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
var $658f814ccac33220$var$circleIconOffsetMap = {
    small: "_rjxpidpf _152tidpf",
    medium: "_rjxpidpf _152tidpf",
    large: "_rjxpt94y _152tt94y",
    xlarge: "_rjxp1v6z _152t1v6z"
};
var $658f814ccac33220$var$squareIconOffsetMap = {
    root: "_rjxpidpf _152tidpf"
};
var $658f814ccac33220$var$hexagonIconOffsetMap = {
    small: "_rjxp1n1a _152t1n1a",
    medium: "_rjxp1n1a _152t1n1a",
    large: "_rjxpmyb0 _152t1y44",
    xlarge: "_rjxp1lpd _152tl52n"
};
/**
 * __Status wrapper__
 *
 * A status wrapper is used internally to position status on top of the avatar.
 */ var $658f814ccac33220$var$StatusWrapper = function StatusWrapper(_ref) {
    var size = _ref.size, status = _ref.status, appearance = _ref.appearance, borderColor = _ref.borderColor, children = _ref.children, testId = _ref.testId;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--status"),
        className: (0, $970q7.default)([
            $658f814ccac33220$var$styles.root,
            $658f814ccac33220$var$iconSizeMap[size],
            $658f814ccac33220$var$circleIconOffsetMap[size],
            appearance === 'square' && $658f814ccac33220$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $658f814ccac33220$var$hexagonIconOffsetMap[size]
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $90a388dca829d063$export$2e2bcd8739ae039), {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};
var $658f814ccac33220$export$2e2bcd8739ae039 = $658f814ccac33220$var$StatusWrapper;



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $31a70845175862c8$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);


var $df0d97b508d42bc2$export$b50b87a1c4086b23 = function useAvatarContext() {
    return (0, $5FkrB.useContext)((0, $31a70845175862c8$export$a20dad690e1279e2));
};


function $3f2d186115b5020e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3f2d186115b5020e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3f2d186115b5020e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3f2d186115b5020e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3f2d186115b5020e$var$packageName = "@atlaskit/avatar";
var $3f2d186115b5020e$var$packageVersion = "28.0.0";
var $3f2d186115b5020e$var$containerStyles = null;
var $3f2d186115b5020e$var$normalizeAvatarSize = function normalizeAvatarSize(size) {
    return size === 'xsmall' && !(0, $50U6m.fg)('platform_design-system-team_avatar-remove-xsmall') ? 'xxsmall' : size;
};
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ var $3f2d186115b5020e$var$Avatar = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'circle' : _ref$appearance, label = _ref.label, borderColor = _ref.borderColor, children = _ref.children, href = _ref.href, isDisabled = _ref.isDisabled, name = _ref.name, onClick = _ref.onClick, presence = _ref.presence, sizeProp = _ref.size, src = _ref.src, stackIndex = _ref.stackIndex, status = _ref.status, target = _ref.target, testId = _ref.testId, _ref$as = _ref.as, AvatarContainer = _ref$as === void 0 ? 'div' : _ref$as, imgLoading = _ref.imgLoading, ariaControls = _ref['aria-controls'], ariaExpanded = _ref['aria-expanded'], ariaHasPopup = _ref['aria-haspopup'];
    var _useAnalyticsEvents = (0, $bDUuG.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var context = (0, $df0d97b508d42bc2$export$b50b87a1c4086b23)();
    var size = $3f2d186115b5020e$var$normalizeAvatarSize(sizeProp || (context === null || context === void 0 ? void 0 : context.size) || 'medium');
    var customPresenceNode = /*#__PURE__*/ (0, $5FkrB.isValidElement)(presence) ? presence : null;
    var customStatusNode = /*#__PURE__*/ (0, $5FkrB.isValidElement)(status) ? status : null;
    var isValidIconSize = size !== 'xxlarge' && size !== 'xxsmall' && size !== 'xsmall';
    // Presence/status indicators are only defined for `IndicatorSizeType`
    // (small, medium, large, xlarge). Compute `indicatorSize` only for sizes
    // that support an indicator (`isValidIconSize`), so the value is
    // structurally guaranteed to be a valid `IndicatorSizeType` rather than
    // relying on the guard at each call site. The `UNSAFE_xsmall` (20px) size
    // reuses the `small` indicator sizing as its nearest supported neighbor;
    // unsupported sizes (`xxsmall`/`xsmall`/`xxlarge`) fall back to `small` and are never
    // actually rendered because `isPresence`/`isStatus` also guard on
    // `isValidIconSize`.
    var indicatorSize = !isValidIconSize ? 'small' : size === 'UNSAFE_xsmall' ? 'small' : size;
    var lastAnalytics = (0, $5FkrB.useRef)(analyticsContext);
    var labelId = (0, $h8qvJ.useId)();
    (0, $5FkrB.useEffect)(function() {
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    var onClickHandler = (0, $5FkrB.useCallback)(function(event) {
        if (isDisabled || typeof onClick !== 'function') return;
        var analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $3f2d186115b5020e$var$packageName,
                packageVersion: $3f2d186115b5020e$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ var context = $3f2d186115b5020e$var$_objectSpread({
            componentName: 'avatar',
            packageName: $3f2d186115b5020e$var$packageName,
            packageVersion: $3f2d186115b5020e$var$packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    var isPresence = isValidIconSize && presence && !status;
    var isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    var defaultLabel = [
        name,
        isStatus && !customStatusNode && "(".concat(status, ")"),
        isPresence && !customPresenceNode && "(".concat(presence, ")")
    ].filter(Boolean).join(' ');
    var isInteractive = onClick || href || isDisabled || ariaHasPopup;
    var containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ $5FkrB.createElement((0, $4d44de6ced942b69$export$6b4cbd90d24955ad).Provider, {
        value: true
    }, /*#__PURE__*/ $5FkrB.createElement(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? 'img' : undefined,
        "aria-labelledby": containerShouldBeImage ? labelId : undefined,
        style: {
            zIndex: stackIndex
        },
        className: (0, $970q7.default)([
            "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $4c9ddebdb0bdac2a$export$b983474ddd0b6d28).Provider, {
        value: {
            as: (0, $2a41c0f14558b2c3$export$2e2bcd8739ae039)(isDisabled, href, onClick, ariaHasPopup),
            appearance: appearance,
            borderColor: borderColor,
            href: href,
            isDisabled: isDisabled,
            label: label || defaultLabel,
            onClick: isInteractive ? onClickHandler : undefined,
            ref: ref,
            size: size,
            stackIndex: stackIndex,
            target: target,
            testId: testId ? "".concat(testId, "--inner") : undefined,
            'aria-controls': ariaControls,
            'aria-expanded': ariaExpanded,
            'aria-haspopup': ariaHasPopup,
            avatarImage: /*#__PURE__*/ $5FkrB.createElement((0, $99211cea90637578$export$2e2bcd8739ae039), {
                alt: !containerShouldBeImage && src ? name : undefined,
                src: src,
                appearance: appearance,
                size: size,
                testId: testId,
                imgLoading: imgLoading
            })
        }
    }, children || /*#__PURE__*/ $5FkrB.createElement((0, $4c041832c37ced0c$export$47fbc0b44cae5559), null)), isPresence && /*#__PURE__*/ $5FkrB.createElement((0, $34241aebfba62b82$export$2e2bcd8739ae039), {
        appearance: appearance,
        size: indicatorSize,
        presence: typeof presence === 'string' ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && /*#__PURE__*/ $5FkrB.createElement((0, $658f814ccac33220$export$2e2bcd8739ae039), {
        appearance: appearance,
        size: indicatorSize,
        borderColor: borderColor,
        status: typeof status === 'string' ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId && "".concat(testId, "--label"),
        id: labelId,
        hidden: true
    }, defaultLabel) : undefined));
});
$3f2d186115b5020e$var$Avatar.displayName = 'Avatar';
var $3f2d186115b5020e$export$2e2bcd8739ae039 = $3f2d186115b5020e$var$Avatar;


/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $6eff59b9a1c408dc$var$_excluded = [
    "children"
], $6eff59b9a1c408dc$var$_excluded2 = [
    "children"
], $6eff59b9a1c408dc$var$_excluded3 = [
    "children"
], $6eff59b9a1c408dc$var$_excluded4 = [
    "children"
], $6eff59b9a1c408dc$var$_excluded5 = [
    "alt"
];
var $6eff59b9a1c408dc$var$styles = {
    child: "_19pk1b66 _2hwx1b66 _otyr1b66 _18u01b66 _1ul9idpf",
    option: "_4cvr1h6o _1e0c1txw",
    item: "_1e0c1txw",
    childIcon: "_18u0u2gc",
    optionIcon: "_2rko1rr0 _4t3i7vkz _1bsb7vkz _1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o"
};
var $6eff59b9a1c408dc$export$8133811dea85f484 = function StyledChild(_ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $6eff59b9a1c408dc$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $6eff59b9a1c408dc$var$styles.child
        ])
    }), children);
};
var $6eff59b9a1c408dc$export$844bee7de236d7ec = function StyledOption(_ref2) {
    var children = _ref2.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $6eff59b9a1c408dc$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $6eff59b9a1c408dc$var$styles.option
        ])
    }), children);
};
var $6eff59b9a1c408dc$export$7c16ae7705e422c4 = function StyledItem(_ref3) {
    var children = _ref3.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref3, $6eff59b9a1c408dc$var$_excluded3);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $6eff59b9a1c408dc$var$styles.item
        ])
    }), children);
};
var $6eff59b9a1c408dc$export$c23e66fb1706d7dd = function StyledChildIcon(_ref4) {
    var children = _ref4.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref4, $6eff59b9a1c408dc$var$_excluded4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $6eff59b9a1c408dc$var$styles.childIcon
        ])
    }), children);
};
var $6eff59b9a1c408dc$export$20da797b837461ca = function StyledOptionIcon(_ref5) {
    var _ref5$alt = _ref5.alt, alt = _ref5$alt === void 0 ? '' : _ref5$alt, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref5, $6eff59b9a1c408dc$var$_excluded5);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("img", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        alt: alt
    }, props, {
        className: (0, $970q7.default)([
            $6eff59b9a1c408dc$var$styles.optionIcon
        ])
    }));
};


var $33d390c283577afc$export$fe00f602c942368a = function AvatarOptionLabel(_ref) {
    var avatarOption = _ref.avatarOption;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6eff59b9a1c408dc$export$844bee7de236d7ec), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3f2d186115b5020e$export$2e2bcd8739ae039), {
        src: typeof avatarOption.avatar !== 'string' ? undefined : avatarOption.avatar,
        size: "xxsmall",
        appearance: typeof avatarOption.square === 'boolean' && avatarOption.square ? 'square' : 'circle'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6eff59b9a1c408dc$export$8133811dea85f484), null, avatarOption.label));
};



var $5FkrB = parcelRequire("5FkrB");

var $0c10451a0971cc45$export$914fa095fc1e0a45 = function IconOptionLabel(_ref) {
    var option = _ref.option;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6eff59b9a1c408dc$export$844bee7de236d7ec), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6eff59b9a1c408dc$export$7c16ae7705e422c4), null, option.icon !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6eff59b9a1c408dc$export$20da797b837461ca), {
        src: option.icon,
        alt: option.label
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6eff59b9a1c408dc$export$c23e66fb1706d7dd), null, option.label)));
};



var $5FkrB = parcelRequire("5FkrB");

var $5supy = parcelRequire("5supy");

var $83d60256ba606822$export$5f70fe304106fcb1 = function LozengeOptionLabel(_ref) {
    var lozengeOption = _ref.lozengeOption;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6eff59b9a1c408dc$export$844bee7de236d7ec), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6eff59b9a1c408dc$export$8133811dea85f484), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6eff59b9a1c408dc$export$7c16ae7705e422c4), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5supy.default), {
        appearance: lozengeOption.appearance,
        isBold: lozengeOption.isBold,
        maxWidth: lozengeOption.maxWidth
    }, lozengeOption.label))));
};


var $ecf51b49a71f7b71$var$formatOptionLabel = function formatOptionLabel(option) {
    if (option.optionType === 'option') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0c10451a0971cc45$export$914fa095fc1e0a45), {
        option: option
    });
    if (option.optionType === 'avatar') return option.hideAvatar === true ? option.label : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $33d390c283577afc$export$fe00f602c942368a), {
        avatarOption: option
    });
    if (option.optionType === 'lozenge') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $83d60256ba606822$export$5f70fe304106fcb1), {
        lozengeOption: option
    });
    // eslint-disable-next-line no-console
    console.error('`formatOptionLabel` was passed an unsupported `SelectOption`:', option);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null);
};
var $ecf51b49a71f7b71$export$2e2bcd8739ae039 = $ecf51b49a71f7b71$var$formatOptionLabel;


/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $46475b1c4d0f0cd3$var$_excluded = [
    "children"
];
var $46475b1c4d0f0cd3$var$styles = {
    dialogInner: "_1reo15vq _18m915vq _1ul91wdt"
};
var $46475b1c4d0f0cd3$export$999ca5bf223f627 = function DialogInner(_ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $46475b1c4d0f0cd3$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            $46475b1c4d0f0cd3$var$styles.dialogInner
        ])
    }), children);
};


var $ec0da25f73e1701b$export$ba25329847403e11 = function Picker(_ref) {
    var ariaLabel = _ref.ariaLabel, isOpen = _ref.isOpen, value = _ref.value, onClose = _ref.onClose, onClearValues = _ref.onClearValues, fieldId = _ref.fieldId, fieldLabel = _ref.fieldLabel, fieldInvalidLabel = _ref.fieldInvalidLabel, onChange = _ref.onChange, _ref$formatOptionLabe = _ref.formatOptionLabel, formatOptionLabel = _ref$formatOptionLabe === void 0 ? (0, $ecf51b49a71f7b71$export$2e2bcd8739ae039) : _ref$formatOptionLabe, onLoadOptions = _ref.onLoadOptions, pagination = _ref.pagination, PopupComponent = _ref.PopupComponent, onTrigger = _ref.onTrigger, hideClearSelection = _ref.hideClearSelection, _ref$initiallyAddSele = _ref.initiallyAddSelectedFirst, initiallyAddSelectedFirst = _ref$initiallyAddSele === void 0 ? true : _ref$initiallyAddSele, _ref$isMulti = _ref.isMulti, isMulti = _ref$isMulti === void 0 ? true : _ref$isMulti, _ref$showFooter = _ref.showFooter, showFooter = _ref$showFooter === void 0 ? true : _ref$showFooter, popupProps = _ref.popupProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c1998dab09d78331$export$b61655080b0a1f32), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dY97G.Popup), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        key: fieldId,
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        popupComponent: PopupComponent,
        shouldRenderToParent: true,
        trigger: onTrigger,
        autoFocus: false,
        content: function content() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $46475b1c4d0f0cd3$export$999ca5bf223f627), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9ef9fb0f9f2a565e$export$2e2bcd8739ae039), {
                field: {
                    isRemovable: false,
                    label: fieldLabel || '',
                    invalidLabel: fieldInvalidLabel,
                    type: 'Filter',
                    key: fieldId,
                    defaultOptionsLabel: 'defaultOptionsLabel',
                    defaultOptions: true,
                    cacheOptions: false,
                    inputValue: 'string',
                    enableShowMore: true,
                    pagination: pagination,
                    loadOptions: onLoadOptions
                },
                onChange: onChange,
                value: value,
                formatOptionLabel: formatOptionLabel,
                onClear: onClearValues,
                hideClearSelection: hideClearSelection,
                initiallyAddSelectedFirst: initiallyAddSelectedFirst,
                isMulti: isMulti,
                showFooter: showFooter,
                ariaLabel: ariaLabel
            }));
        }
    }, popupProps)));
};



var $7dab147791499000$export$7f94856880993f27 = function MoreButton(_ref) {
    var triggerTestId = _ref.triggerTestId, options = _ref.options, selectedOptions = _ref.selectedOptions, onTriggerClick = _ref.onTriggerClick, onClose = _ref.onClose, onChange = _ref.onChange;
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), values = _useState4[0], setValues = _useState4[1];
    var intl = (0, $hrVKU.default)();
    var handlePickerTriggerClick = function handlePickerTriggerClick() {
        setIsOpen(!isOpen);
        if (onTriggerClick) onTriggerClick();
    };
    var handleClose = function handleClose() {
        setIsOpen(false);
        if (onClose) onClose();
    };
    var handleChange = function handleChange(options, option, selectData) {
        setValues(options);
        handleClose();
        if (onChange) onChange(options, option, selectData);
    };
    var handleTrigger = function handleTrigger(_ref2) {
        var ref = _ref2.ref;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dUWEU.default), {
            appearance: "default",
            "aria-expanded": isOpen,
            "aria-label": intl.formatMessage((0, $0f8ed274ac3f35bf$export$defe85febe8b728c).moreOptions),
            isSelected: false,
            iconAfter: function iconAfter(iconProps) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d0f579dc1c758542$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                    color: "currentColor"
                }, iconProps, {
                    size: "small"
                }));
            },
            onClick: handlePickerTriggerClick,
            ref: ref,
            testId: triggerTestId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, $0f8ed274ac3f35bf$export$defe85febe8b728c).moreButton));
    };
    var handleLoadOptions = function handleLoadOptions(search, _enableFullList, _showFullList, _showMore, _lastOption, cb) {
        cb({
            // This must be null in order to hide the "Show more" button
            totalCount: null,
            options: options.filter(function(option) {
                return option.type !== 'datetime';
            }).filter(function(option) {
                return option.filterLabel.toLowerCase().includes(search);
            }).map(function(option, i) {
                return {
                    optionType: 'option',
                    label: option.filterLabel,
                    value: option.filterLabel,
                    optionId: option.filterId,
                    isMoreFilter: option.isMoreFilter
                };
            })
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ec0da25f73e1701b$export$ba25329847403e11), {
        isOpen: isOpen,
        onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($7WAD0))),
        onClose: handleClose,
        value: selectedOptions ? selectedOptions : values,
        fieldId: "more",
        fieldLabel: intl.formatMessage((0, $0f8ed274ac3f35bf$export$defe85febe8b728c).moreButton),
        onChange: handleChange,
        onLoadOptions: handleLoadOptions,
        onTrigger: handleTrigger
    });
};



var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $5FkrB = parcelRequire("5FkrB");

var $bgNpv = parcelRequire("bgNpv");
var $hrVKU = parcelRequire("hrVKU");

var $5yfDB = parcelRequire("5yfDB");

var $f5vjV = parcelRequire("f5vjV");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
var $9c930f3da76ae648$var$IndeterminateLoad = (0, $74Zh5.keyframes)({
    '0%': {
        transform: 'translate(0,0)',
        width: 0
    },
    '40%': {
        transform: 'translate(0,0)',
        width: '100%'
    },
    '60%': {
        transform: 'translate(50%,0)',
        width: '50%'
    },
    '100%': {
        transform: 'translate(100%,0)',
        width: '0%'
    }
});
var $9c930f3da76ae648$var$barStylesBaseFullWidth = (0, $74Zh5.css)({
    width: '100%',
    marginTop: "var(--ds-space-250, 20px)",
    height: "var(--ds-space-200, 16px)"
});
var $9c930f3da76ae648$var$barContainerStyles = (0, $74Zh5.css)({
    flex: 1
});
var $9c930f3da76ae648$var$baseRectStyles = (0, $74Zh5.css)({
    height: "var(--ds-space-050, 4px)",
    rx: "var(--ds-space-025, 2px)",
    width: '100%',
    x: '0',
    y: '0'
});
var $9c930f3da76ae648$var$backgroundFill = (0, $74Zh5.css)({
    fill: "var(--ds-background-information, #E9F2FE)"
});
var $9c930f3da76ae648$var$foregroundFill = (0, $74Zh5.css)({
    fill: "var(--ds-background-information-bold, #1868DB)",
    animationName: $9c930f3da76ae648$var$IndeterminateLoad,
    animationDuration: '1.5s',
    animationTimingFunction: 'ease',
    animationIterationCount: 'infinite'
});
var $9c930f3da76ae648$export$6665614bc5d690f6 = function LoadingBar(_ref) {
    var testId = _ref.testId;
    return (0, $74Zh5.jsx)("span", {
        css: [
            $9c930f3da76ae648$var$barContainerStyles
        ],
        "data-testid": testId
    }, (0, $74Zh5.jsx)("svg", {
        css: [
            $9c930f3da76ae648$var$barStylesBaseFullWidth
        ]
    }, (0, $74Zh5.jsx)("rect", {
        name: "Background",
        css: [
            $9c930f3da76ae648$var$baseRectStyles,
            $9c930f3da76ae648$var$backgroundFill
        ]
    }), (0, $74Zh5.jsx)("rect", {
        name: "Foreground",
        css: [
            $9c930f3da76ae648$var$baseRectStyles,
            $9c930f3da76ae648$var$foregroundFill
        ]
    })));
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6Qk7v = parcelRequire("6Qk7v");
var $aa67ca21d7408075$export$8b4d6de46958900b = (0, $6Qk7v.default).div({
    margin: "var(--ds-space-200, 16px)".concat(" 0"),
    maxHeight: "var(--ds-space-200, 16px)",
    display: 'flex',
    alignItems: 'center',
    gap: "var(--ds-space-050, 4px)",
    whiteSpace: 'pre-wrap',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
var $aa67ca21d7408075$export$aeca85f3b00ff49e = (0, $6Qk7v.default).span({
    display: 'flex'
});
var $aa67ca21d7408075$export$525b4e7ba233b58f = (0, $6Qk7v.default).span({
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> p': {
        marginRight: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&::before': {
        content: "'\u2022'",
        marginLeft: "var(--ds-space-100, 8px)",
        marginRight: "var(--ds-space-100, 8px)",
        color: "var(--ds-text-subtlest, #6B6E76)"
    }
});


function $7081ad1e82adb48e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7081ad1e82adb48e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7081ad1e82adb48e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7081ad1e82adb48e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7081ad1e82adb48e$export$f93ec6528f706bfe = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(_ref, ref) {
    var totalCount = _ref.totalCount, currentCount = _ref.currentCount, onRefetch = _ref.onRefetch, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$testId = _ref.testId, testId = _ref$testId === void 0 ? 'refresh' : _ref$testId, messageOverrides = _ref.messageOverrides;
    var intl = (0, $hrVKU.default)();
    var loadingContainerRef = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(null);
    var refreshClickRef = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(false);
    var handleRefetch = /*#__PURE__*/ function() {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        refreshClickRef.current = true;
                        if (onRefetch) onRefetch();
                    case 1:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function handleRefetch() {
            return _ref2.apply(this, arguments);
        };
    }();
    var messages = $7081ad1e82adb48e$var$_objectSpread($7081ad1e82adb48e$var$_objectSpread({}, (0, $0f8ed274ac3f35bf$export$defe85febe8b728c)), messageOverrides);
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        if (isLoading && refreshClickRef.current && loadingContainerRef.current) {
            loadingContainerRef.current.focus();
            refreshClickRef.current = false;
        }
    }, [
        isLoading
    ]);
    if (totalCount === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aa67ca21d7408075$export$8b4d6de46958900b), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9c930f3da76ae648$export$6665614bc5d690f6), {
        testId: "".concat(testId, "-loading-bar")
    }));
    var itemLabel = intl.formatMessage(messages.defaultItemLabel, {
        totalCount: totalCount
    });
    var renderCountLabel = function renderCountLabel() {
        if (currentCount || currentCount === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, messages.currentCount, {
            values: {
                currentCount: currentCount,
                totalCount: totalCount,
                label: itemLabel
            }
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, messages.count, {
            values: {
                totalCount: totalCount,
                label: itemLabel
            }
        }));
    };
    var renderRefetchStatus = function renderRefetchStatus() {
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aa67ca21d7408075$export$525b4e7ba233b58f), {
            ref: loadingContainerRef,
            role: "status",
            "aria-label": intl.formatMessage(messages.loading),
            tabIndex: -1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            tagName: "p"
        }, messages.loading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9c930f3da76ae648$export$6665614bc5d690f6), {
            testId: "".concat(testId, "-refetch-loading-bar")
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aa67ca21d7408075$export$aeca85f3b00ff49e), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5yfDB.default), {
            ref: ref,
            testId: "".concat(testId, "-refetch-button"),
            appearance: "subtle",
            spacing: "compact",
            onClick: handleRefetch,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($f5vjV))),
            label: "refresh"
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aa67ca21d7408075$export$8b4d6de46958900b), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        role: "status",
        "aria-atomic": "true",
        "data-testid": "".concat(testId, "-count-status")
    }, renderCountLabel()), renderRefetchStatus());
});



var $5FkrB = parcelRequire("5FkrB");

var $bgNpv = parcelRequire("bgNpv");
var $hrVKU = parcelRequire("hrVKU");

var $jgNUw = parcelRequire("jgNUw");

var $22f7e1b4de735f19$export$2491f201e3dd9acf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(_ref, ref) {
    var onReset = _ref.onReset, testId = _ref.testId;
    var _useIntl = (0, $hrVKU.default)(), formatMessage = _useIntl.formatMessage;
    var handleReset = function handleReset() {
        if (onReset) onReset();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jgNUw.default), {
        ref: ref,
        appearance: "subtle-link",
        onClick: handleReset,
        testId: "".concat(testId, "-reset-button"),
        "aria-label": formatMessage((0, $0f8ed274ac3f35bf$export$defe85febe8b728c).resetDescriptiveLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, $0f8ed274ac3f35bf$export$defe85febe8b728c).reset));
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6Qk7v = parcelRequire("6Qk7v");
var $6ef99e2d246e28a1$export$11ad813d755b19a5 = (0, $6Qk7v.default).div({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> *': {
        margin: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-100, 8px)", " ", "var(--ds-space-050, 4px)", " ", "var(--ds-space-0, 0px)")
    }
});
var $6ef99e2d246e28a1$export$40a82817f6f242b3 = (0, $6Qk7v.default).fieldset({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    margin: '0',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> *': {
        margin: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-100, 8px)", " ", "var(--ds-space-050, 4px)", " ", "var(--ds-space-0, 0px)")
    }
});
var $6ef99e2d246e28a1$export$9f01179e650c3b8d = (0, $6Qk7v.default).legend({
    position: 'absolute',
    width: "var(--ds-space-025, 2px)",
    height: "var(--ds-space-025, 2px)",
    margin: "var(--ds-space-negative-025, -2px)",
    padding: "var(--ds-space-0, 0px)",
    border: "var(--ds-space-0, 0px)",
    clip: 'rect(0, 0, 0, 0)',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
var $6ef99e2d246e28a1$export$e5a6eea85be3e9b4 = (0, $6Qk7v.default).div({
    minWidth: '240px'
});
var $6ef99e2d246e28a1$export$485780b9c7e4c9c3 = (0, $6Qk7v.default).div({
    flexBasis: '100%',
    marginRight: 0
});
var $6ef99e2d246e28a1$export$2622d83931a09bf9 = (0, $6Qk7v.default).span({
    display: 'inline-block',
    width: 0,
    height: "var(--ds-space-200, 16px)",
    borderLeft: "var(--ds-border-width-selected, 2px)".concat(" solid ", "var(--ds-border, #0B120E24)")
});
var $6ef99e2d246e28a1$export$63bbad9bad03e9d8 = (0, $6Qk7v.default).div({
    display: 'flex',
    alignItems: 'center'
});
var $6ef99e2d246e28a1$export$c2789fc7f869d1e1 = (0, $6Qk7v.default).div(function(props) {
    return {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display: props.isHidden ? 'none' : 'block'
    };
});
var $6ef99e2d246e28a1$export$e2c7be47094d7291 = (0, $6Qk7v.default).div({
    display: 'flex'
});



var $5FkrB = parcelRequire("5FkrB");

var $dUWEU = parcelRequire("dUWEU");
var $96f0ecfa8ef0900b$export$d2b052e7b4be1756 = function ToggleButton(_ref) {
    var fieldLabel = _ref.fieldLabel, isSelected = _ref.isSelected, onToggle = _ref.onToggle, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dUWEU.default), {
        appearance: "default",
        "aria-pressed": isSelected,
        isSelected: isSelected,
        onClick: function onClick() {
            return onToggle(!isSelected);
        },
        testId: testId
    }, fieldLabel);
};


function $e264e74c775f2cfb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e264e74c775f2cfb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e264e74c775f2cfb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e264e74c775f2cfb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e264e74c775f2cfb$var$DEFAULT_FILTER_DISPLAY_LIMIT = 4;
var $e264e74c775f2cfb$var$searchTextId = 'searchText';
/**
 * Normalises the consumer supplied `maxVisibleFilters` into a value that always
 * produces a renderable filter row.
 *
 * - `undefined` and `NaN` fail open to the default rather than collapsing everything.
 * - `0`, negative and fractional values are clamped to a renderable integer.
 * - `Infinity` passes through untouched and acts as "never collapse".
 */ var $e264e74c775f2cfb$var$resolveFilterDisplayLimit = function resolveFilterDisplayLimit(value) {
    if (value === undefined || Number.isNaN(value)) return $e264e74c775f2cfb$var$DEFAULT_FILTER_DISPLAY_LIMIT;
    return Math.max(1, Math.floor(value));
};
var $e264e74c775f2cfb$export$9e85da355ec448f2 = function getInitialFilterState(filters, textInputField) {
    var initialFilterState = {
        searchText: textInputField !== null && textInputField !== void 0 ? textInputField : '',
        filters: {}
    };
    filters.forEach(function(filter) {
        if (initialFilterState.filters[filter.fieldId] !== undefined) throw new Error('Each filter must have a unique id. Check your `filters` prop to ensure each does.');
        if (filter.type === 'datetime') initialFilterState.filters[filter.fieldId] = $e264e74c775f2cfb$var$getDatetimeFilterObject(filter.defaultValues, filter.dateValues, filter.betweenDatesOptions);
        else if (filter.type === 'toggle') {
            var _filter$value;
            initialFilterState.filters[filter.fieldId] = (_filter$value = filter.value) !== null && _filter$value !== void 0 ? _filter$value : false;
        } else initialFilterState.filters[filter.fieldId] = filter.value ? filter.value : [];
    });
    return initialFilterState;
};
var $e264e74c775f2cfb$export$937e9e6b426f90d7 = function getDefaultFilterState(filters, textInputField) {
    var defaultFilterState = {
        searchText: textInputField !== null && textInputField !== void 0 ? textInputField : '',
        filters: {}
    };
    filters.forEach(function(filter) {
        if (filter.type === 'datetime') defaultFilterState.filters[filter.fieldId] = $e264e74c775f2cfb$var$getDatetimeFilterObject(filter.defaultValues, undefined, undefined);
        else if (filter.type === 'toggle') {
            var _filter$defaultValue;
            defaultFilterState.filters[filter.fieldId] = (_filter$defaultValue = filter.defaultValue) !== null && _filter$defaultValue !== void 0 ? _filter$defaultValue : false;
        } else defaultFilterState.filters[filter.fieldId] = filter.defaultValue ? filter.defaultValue : [];
    });
    return defaultFilterState;
};
var $e264e74c775f2cfb$var$getDatetimeFilterObject = function getDatetimeFilterObject(defaultValues, dateValues, defaultBetweenDates) {
    var _dateValues$withinThe, _ref;
    // convert Date(s) to Unix
    var startDate = defaultBetweenDates && defaultBetweenDates.defaultStart ? "".concat((0, (/*@__PURE__*/$parcel$interopDefault($kuWWJ)))(defaultBetweenDates === null || defaultBetweenDates === void 0 ? void 0 : defaultBetweenDates.defaultStart).valueOf()) : undefined;
    var endDate = defaultBetweenDates && defaultBetweenDates.defaultEnd ? "".concat((0, (/*@__PURE__*/$parcel$interopDefault($kuWWJ)))(defaultBetweenDates === null || defaultBetweenDates === void 0 ? void 0 : defaultBetweenDates.defaultEnd).valueOf()) : undefined;
    var datetimeFilterType = dateValues === null || dateValues === void 0 ? void 0 : dateValues.filterType;
    var timeUnit = dateValues === null || dateValues === void 0 || (_dateValues$withinThe = dateValues.withinTheLast) === null || _dateValues$withinThe === void 0 ? void 0 : _dateValues$withinThe.timeUnit;
    return (_ref = dateValues !== null && dateValues !== void 0 ? dateValues : defaultValues) !== null && _ref !== void 0 ? _ref : {
        betweenDates: {
            startDate: startDate,
            endDate: endDate
        },
        filterType: datetimeFilterType ? datetimeFilterType : 'BETWEEN_DATES',
        withinTheLast: {
            unitValue: '',
            // Default is minutes, set even if datetimeFilterType isn't WITHIN_THE_LAST
            timeUnit: timeUnit ? timeUnit : 'm'
        }
    };
};
/**
 * Checks if a datetime filter has selected options by radio button filter.
 */ var $e264e74c775f2cfb$var$isDatetimeFilterSelected = function isDatetimeFilterSelected(filter) {
    var datetimeFilterState = filter.dateValues;
    if (!datetimeFilterState) return false;
    switch(datetimeFilterState.filterType){
        case 'BETWEEN_DATES':
            return datetimeFilterState.betweenDates !== undefined;
        case 'WITHIN_THE_LAST':
            return datetimeFilterState.withinTheLast !== undefined && datetimeFilterState.withinTheLast.unitValue !== undefined;
        default:
            return false;
    }
};
var $e264e74c775f2cfb$var$getInitialDisplayedFilters = function getInitialDisplayedFilters(filters, filterDisplayLimit) {
    var displayedFilters = [];
    filters.forEach(function(filter, index) {
        var _filter$value2;
        /**
     * filters.length <= filterDisplayLimit: Accepts all the filters if the # of filters fits the limit
     * index < filterDisplayLimit - 1: Accepts the leading filters, leaving one slot for the More button
     * filter.type === "default" || filter.value?.length !== 0: Accepts the PaginatedFilter filters that have selected options
     * filter.type === "datetime" || isDatetimeFilterSelected(filter): Accepts the Datetime filters that have selected options
     */ if (filters.length <= filterDisplayLimit || index < filterDisplayLimit - 1 || filter.type === 'default' || !filter.type && ((_filter$value2 = filter.value) === null || _filter$value2 === void 0 ? void 0 : _filter$value2.length) !== 0 || filter.type === 'datetime' && $e264e74c775f2cfb$var$isDatetimeFilterSelected(filter)) {
            var _filter$fieldLabel;
            displayedFilters.push({
                type: filter.type ? filter.type : 'default',
                filterLabel: filter.type && filter.type === 'datetime' ? filter.triggerLabel : (_filter$fieldLabel = filter.fieldLabel) !== null && _filter$fieldLabel !== void 0 ? _filter$fieldLabel : '',
                filterId: filter.fieldId,
                isMoreFilter: index > filterDisplayLimit - 2 && filters.length > filterDisplayLimit
            });
        }
    });
    return displayedFilters;
};
var $e264e74c775f2cfb$var$createFilterMapping = function createFilterMapping(filters) {
    var filtersMapping = {
        filters: {}
    };
    filters.forEach(function(filter) {
        filtersMapping.filters[filter.fieldId] = filter;
    });
    return filtersMapping;
};
var $e264e74c775f2cfb$var$getMoreButtonOptions = function getMoreButtonOptions(filters, filterDisplayLimit) {
    var options = [];
    var filterCount = filters.length;
    if (filterCount > filterDisplayLimit) for(var i = filterDisplayLimit - 1; i < filterCount; i++){
        var filter = filters[i];
        if (filter.type === 'toggle') continue;
        options.push({
            filterLabel: filter.type !== 'datetime' ? filter.fieldLabel : '',
            filterId: filter.fieldId,
            isMoreFilter: true
        });
    }
    return options;
};
var $e264e74c775f2cfb$export$8d640e745b5fefe1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(_ref2, ref) {
    var onChange = _ref2.onChange, onReload = _ref2.onReload, onReset = _ref2.onReset, onApply = _ref2.onApply, isLoading = _ref2.isLoading, itemsCount = _ref2.itemsCount, itemsFilteredCount = _ref2.itemsFilteredCount, _ref2$testId = _ref2.testId, testId = _ref2$testId === void 0 ? 'filter-controller' : _ref2$testId, filters = _ref2.filters, searchPlaceholder = _ref2.searchPlaceholder, isManual = _ref2.isManual, showFooter = _ref2.showFooter, searchInput = _ref2.searchInput, searchInputAriaLabel = _ref2.searchInputAriaLabel, refreshMessageOverrides = _ref2.refreshMessageOverrides, additionalFilterContent = _ref2.additionalFilterContent, hideItemsCountFooter = _ref2.hideItemsCountFooter, maxVisibleFilters = _ref2.maxVisibleFilters;
    /**
   * Read once on mount, matching the existing behaviour of the `filters` prop.
   * See the `maxVisibleFilters` JSDoc for the documented limitation.
   */ var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(function() {
        return $e264e74c775f2cfb$var$resolveFilterDisplayLimit(maxVisibleFilters);
    }), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState, 1), filterDisplayLimit = _React$useState2[0];
    var _React$useState3 = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(searchInput ? searchInput : ''), _React$useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState3, 2), textFieldInputValue = _React$useState4[0], setTextFieldInputValue = _React$useState4[1];
    var _React$useState5 = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState($e264e74c775f2cfb$export$9e85da355ec448f2(filters, textFieldInputValue)), _React$useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState5, 2), filterState = _React$useState6[0], setFilterState = _React$useState6[1];
    // Ref for the Refresh button to focus after reload
    var refreshButtonRef = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(null);
    // Ref for the Reset button to restore focus after reset state updates.
    var resetButtonRef = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(null);
    // Ref for the search input to focus after reset
    var searchInputRef = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(null);
    // Flag to defer reset-button focus until after render updates complete.
    var shouldFocusResetButtonRef = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(false);
    // Update filterState when any value of any filter changes
    var filterValues = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        return JSON.stringify(filters.map(function(filter) {
            return filter.type === 'default' || !filter.type ? filter.value : null;
        }));
    }, [
        filters
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        setFilterState($e264e74c775f2cfb$export$9e85da355ec448f2(filters, textFieldInputValue));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filterValues
    ]);
    var _React$useState7 = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(filterState), _React$useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState7, 2), lastAppliedFilterState = _React$useState8[0], setLastAppliedFilterState = _React$useState8[1];
    var _React$useState9 = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState($e264e74c775f2cfb$export$937e9e6b426f90d7(filters, textFieldInputValue)), _React$useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState9, 1), storedInitialState = _React$useState0[0];
    var _React$useState1 = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState($e264e74c775f2cfb$var$getInitialDisplayedFilters(filters, filterDisplayLimit)), _React$useState10 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState1, 2), displayedFilters = _React$useState10[0], setDisplayedFilter = _React$useState10[1];
    var _React$useState11 = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState($e264e74c775f2cfb$var$getInitialDisplayedFilters(filters, filterDisplayLimit)), _React$useState12 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState11, 1), initialDisplayedFilters = _React$useState12[0];
    var _React$useState13 = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState($e264e74c775f2cfb$var$getMoreButtonOptions(filters, filterDisplayLimit)), _React$useState14 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState13, 1), moreButtonOptions = _React$useState14[0];
    var isRefreshClickedRef = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(false);
    var filtersMapping = $e264e74c775f2cfb$var$createFilterMapping(filters);
    var changeList = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef([]);
    var filterCount = filters.length;
    var hasFilterContent = displayedFilters.length > 0 || Boolean(additionalFilterContent) || filterCount > filterDisplayLimit;
    var handleReloadWithFocus = function handleReloadWithFocus() {
        isRefreshClickedRef.current = true;
        handleReload();
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        if (!isLoading && refreshButtonRef.current && isRefreshClickedRef.current) {
            isRefreshClickedRef.current = false;
            setTimeout(function() {
                var _refreshButtonRef$cur;
                (_refreshButtonRef$cur = refreshButtonRef.current) === null || _refreshButtonRef$cur === void 0 || _refreshButtonRef$cur.focus();
            }, 0);
        }
    }, [
        isLoading
    ]);
    // A11Y-36100: After reset, ResetButtonWrapper can become display:none which may
    // move focus away. Only restore focus to reset when the search input ref is not
    // available; otherwise search input remains the primary post-reset target.
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        if (shouldFocusResetButtonRef.current && !searchInputRef.current) {
            var _resetButtonRef$curre;
            shouldFocusResetButtonRef.current = false;
            (_resetButtonRef$curre = resetButtonRef.current) === null || _resetButtonRef$curre === void 0 || _resetButtonRef$curre.focus();
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        if (changeList.current.length) {
            if (onChange && !isManual) {
                onChange(filterState, changeList.current);
                changeList.current = [];
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filterState
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        if (changeList.current.includes($e264e74c775f2cfb$var$searchTextId)) handleDebounceSearchFilter(textFieldInputValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        textFieldInputValue
    ]);
    var handleSearchFilter = function handleSearchFilter(searchText) {
        //TODO: do we need to escape the search input or do we leave that to the consumers?
        setFilterState(function(prevState) {
            return $e264e74c775f2cfb$var$_objectSpread($e264e74c775f2cfb$var$_objectSpread({}, prevState), {}, {
                searchText: searchText
            });
        });
    };
    var handleDebounceSearchFilter = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eSyoe)))(handleSearchFilter, 500);
    }, []);
    var handleReload = function handleReload() {
        if (onReload) onReload(filterState);
    };
    var handleDatetimeFilterChange = function handleDatetimeFilterChange(filterId, dateValues) {
        changeList.current.push(filterId);
        setFilterState($e264e74c775f2cfb$var$_objectSpread($e264e74c775f2cfb$var$_objectSpread({}, filterState), {}, {
            filters: $e264e74c775f2cfb$var$_objectSpread($e264e74c775f2cfb$var$_objectSpread({}, filterState.filters), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, filterId, dateValues))
        }));
    };
    var handlePaginatedFilterChange = function handlePaginatedFilterChange(filterId, options) {
        changeList.current.push(filterId);
        setFilterState($e264e74c775f2cfb$var$_objectSpread($e264e74c775f2cfb$var$_objectSpread({}, filterState), {}, {
            filters: $e264e74c775f2cfb$var$_objectSpread($e264e74c775f2cfb$var$_objectSpread({}, filterState.filters), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, filterId, options))
        }));
    };
    var handlePaginatedFilterOnClearValues = function handlePaginatedFilterOnClearValues(filterId) {
        changeList.current.push(filterId);
        setFilterState($e264e74c775f2cfb$var$_objectSpread($e264e74c775f2cfb$var$_objectSpread({}, filterState), {}, {
            filters: $e264e74c775f2cfb$var$_objectSpread($e264e74c775f2cfb$var$_objectSpread({}, filterState.filters), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, filterId, []))
        }));
    };
    var handleToggleFilterChange = function handleToggleFilterChange(filterId, next) {
        changeList.current.push(filterId);
        setFilterState(function(prevState) {
            return $e264e74c775f2cfb$var$_objectSpread($e264e74c775f2cfb$var$_objectSpread({}, prevState), {}, {
                filters: $e264e74c775f2cfb$var$_objectSpread($e264e74c775f2cfb$var$_objectSpread({}, prevState.filters), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, filterId, next))
            });
        });
    };
    var handleReset = function handleReset() {
        // A11Y-36100: Only set fallback reset focus when search input ref isn't available.
        // Search input is the preferred post-reset focus target when present.
        shouldFocusResetButtonRef.current = !searchInputRef.current;
        handleDebounceSearchFilter.cancel();
        var newChangeList = [];
        if (storedInitialState.searchText !== filterState.searchText) newChangeList.push($e264e74c775f2cfb$var$searchTextId);
        Object.keys(storedInitialState.filters).forEach(function(filterId) {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($dcrmD)))(storedInitialState.filters[filterId], filterState.filters[filterId])) newChangeList.push(filterId);
        });
        if (onReset) onReset(storedInitialState);
        if (onApply) onApply(storedInitialState);
        changeList.current = newChangeList;
        setFilterState(storedInitialState);
        setLastAppliedFilterState(storedInitialState);
        setDisplayedFilter(initialDisplayedFilters);
        setTextFieldInputValue(''); //this has to be set after so that changelist is cleared;
        // Focus the search input directly after reset so focus is not lost to background
        if (searchInputRef.current) searchInputRef.current.focus();
    };
    var handleApply = function handleApply() {
        if (onApply) onApply(filterState);
        if (onChange) {
            onChange(filterState, changeList.current);
            changeList.current = [];
        }
        setLastAppliedFilterState(filterState);
    };
    var areDifferentStates = function areDifferentStates(stateA, stateB) {
        // show Reset button if user provides input value for search bar
        if (textFieldInputValue !== '' || stateA.searchText !== stateB.searchText) return true;
        var filterKeys = Object.keys(stateA.filters);
        for(var i = 0; i < filterKeys.length; i++){
            if (filterKeys[i] === 'datetime') {
                var datesA = stateA.filters[filterKeys[i]];
                var datesB = stateB.filters[filterKeys[i]];
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($dcrmD)))(datesA.betweenDates, datesB.betweenDates) || !(0, (/*@__PURE__*/$parcel$interopDefault($dcrmD)))(datesA.withinTheLast, datesB.withinTheLast)) return true;
            } else if (!(0, (/*@__PURE__*/$parcel$interopDefault($dcrmD)))(stateA.filters[filterKeys[i]], stateB.filters[filterKeys[i]])) return true;
        }
        return false;
    };
    var onTextFieldChange = function onTextFieldChange(next) {
        if (!changeList.current.includes($e264e74c775f2cfb$var$searchTextId)) changeList.current.push($e264e74c775f2cfb$var$searchTextId);
        setTextFieldInputValue(next);
    };
    var handleTextFieldChange = function handleTextFieldChange(e) {
        onTextFieldChange(e.target.value);
    };
    var getActions = function getActions() {
        var areFiltersSelected = areDifferentStates(storedInitialState, filterState);
        if (isManual) {
            var isCurrentFilterDifferent = areDifferentStates(filterState, lastAppliedFilterState);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6ef99e2d246e28a1$export$63bbad9bad03e9d8), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6ef99e2d246e28a1$export$2622d83931a09bf9), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a55a28ba7ccbda7c$export$b8d0691b40a57c25), {
                testId: "".concat(testId, "-apply"),
                onApply: handleApply,
                appearance: isCurrentFilterDifferent ? 'primary' : 'default'
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6ef99e2d246e28a1$export$c2789fc7f869d1e1), {
                "data-testid": "".concat(testId, "-reset-wrapper"),
                isHidden: !(areFiltersSelected || isCurrentFilterDifferent)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $22f7e1b4de735f19$export$2491f201e3dd9acf), {
                testId: "".concat(testId, "-reset"),
                onReset: handleReset,
                ref: resetButtonRef
            })));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6ef99e2d246e28a1$export$c2789fc7f869d1e1), {
            "data-testid": "".concat(testId, "-reset-wrapper"),
            isHidden: !areFiltersSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $22f7e1b4de735f19$export$2491f201e3dd9acf), {
            testId: "".concat(testId, "-reset"),
            onReset: handleReset,
            ref: resetButtonRef
        }));
    };
    var handleRemoveFilter = function handleRemoveFilter(filterId) {
        handlePaginatedFilterOnClearValues(filterId);
        setDisplayedFilter((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(displayedFilters.filter(function(displayedFilter) {
            return displayedFilter.filterId !== filterId;
        })));
    };
    var handleMoreFilterChange = function handleMoreFilterChange(_, option) {
        if ('option' in option) {
            var action = option.action;
            var affectedOption = option.option;
            if (action === 'select-option' && (affectedOption === null || affectedOption === void 0 ? void 0 : affectedOption.optionId) !== undefined && (affectedOption === null || affectedOption === void 0 ? void 0 : affectedOption.label) !== undefined && affectedOption !== null && affectedOption !== void 0 && affectedOption.isMoreFilter) setDisplayedFilter([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(displayedFilters), [
                {
                    type: 'default',
                    filterLabel: affectedOption.label,
                    filterId: affectedOption.optionId,
                    isMoreFilter: affectedOption.isMoreFilter
                }
            ]));
            else if (action === 'deselect-option' && (affectedOption === null || affectedOption === void 0 ? void 0 : affectedOption.optionId) !== undefined) handleRemoveFilter(affectedOption.optionId);
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useImperativeHandle(ref, function() {
        return {
            setSearchInputValue: function setSearchInputValue(next) {
                return onTextFieldChange(next);
            }
        };
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5tQm9.default), {
        defaultMessages: (0, $fbf7741e01f26dad$export$2e2bcd8739ae039),
        loaderFn: (0, $eb0e8352a1e077e8$export$2b153a2030b0feb2)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6ef99e2d246e28a1$export$11ad813d755b19a5), {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6ef99e2d246e28a1$export$e5a6eea85be3e9b4), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6fyuV.default), {
        testId: "".concat(testId, "-search-input"),
        name: "filter-search",
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gAHKi))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        }),
        onChange: handleTextFieldChange,
        isCompact: true,
        placeholder: searchPlaceholder,
        autoComplete: "off",
        type: "text",
        value: textFieldInputValue,
        "aria-label": searchInputAriaLabel,
        ref: searchInputRef
    })), hasFilterContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6ef99e2d246e28a1$export$40a82817f6f242b3), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6ef99e2d246e28a1$export$9f01179e650c3b8d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, $0f8ed274ac3f35bf$export$defe85febe8b728c).filterOptions)), displayedFilters.map(function(displayedFilter) {
        var _filterState$filters$, _filter$key3;
        var filterId = displayedFilter.filterId, isMoreFilter = displayedFilter.isMoreFilter;
        var filter = filtersMapping.filters[filterId];
        if (filter.type === 'datetime') {
            var _filter$key;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8d484fcd592fe46c$export$2e2bcd8739ae039), {
                key: (_filter$key = filter.key) !== null && _filter$key !== void 0 ? _filter$key : filter.fieldId,
                triggerLabel: filter.triggerLabel,
                betweenDatesOptions: filter.betweenDatesOptions,
                placeholders: filter.placeholders,
                onSubmit: function onSubmit(values) {
                    filter.onSubmit(values);
                    handleDatetimeFilterChange(filter.fieldId, values);
                },
                testId: filter.testId ? "".concat(testId, "-").concat(filter.testId) : "".concat(testId, "-").concat(filter.fieldId),
                dateValues: filterState.filters[filter.fieldId],
                disableFutureTimeRanges: filter.disableFutureTimeRanges,
                maxDate: filter.maxDate,
                isInitiallyOpened: filter.isInitiallyOpened
            });
        }
        if (filter.type === 'toggle') {
            var _filter$key2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96f0ecfa8ef0900b$export$d2b052e7b4be1756), {
                key: (_filter$key2 = filter.key) !== null && _filter$key2 !== void 0 ? _filter$key2 : filter.fieldId,
                fieldLabel: filter.fieldLabel,
                isSelected: filterState.filters[filter.fieldId] === true,
                onToggle: function onToggle(next) {
                    var _filter$onChange;
                    (_filter$onChange = filter.onChange) === null || _filter$onChange === void 0 || _filter$onChange.call(filter, next);
                    handleToggleFilterChange(filter.fieldId, next);
                },
                testId: filter.testId ? "".concat(testId, "-").concat(filter.testId) : "".concat(testId, "-").concat(filter.fieldId)
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $57e93f82e6ef5a0a$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            initiallyOpened: isMoreFilter && (filterState === null || filterState === void 0 || (_filterState$filters$ = filterState.filters[filter.fieldId]) === null || _filterState$filters$ === void 0 ? void 0 : _filterState$filters$.length) === 0 && filterId === displayedFilters[displayedFilters.length - 1].filterId
        }, filter, {
            key: (_filter$key3 = filter.key) !== null && _filter$key3 !== void 0 ? _filter$key3 : filter.fieldId,
            value: filterState.filters[filter.fieldId] || [],
            onChange: function onChange(options, option, selectData) {
                if (filter.onChange) filter.onChange(options, option, selectData);
                handlePaginatedFilterChange(filter.fieldId, options);
            },
            onClearValues: function onClearValues() {
                if (filter.onClearValues) filter.onClearValues();
                handlePaginatedFilterOnClearValues(filter.fieldId);
            },
            onLoadOptions: filter.onLoadOptions,
            testId: filter.testId ? "".concat(testId, "-").concat(filter.testId) : "".concat(testId, "-").concat(filter.fieldId),
            onPickerTriggerClear: isMoreFilter ? function() {
                return handleRemoveFilter(filter.fieldId);
            } : undefined,
            showFooter: showFooter
        }));
    }), additionalFilterContent ? additionalFilterContent : null, filterCount > filterDisplayLimit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6ef99e2d246e28a1$export$e2c7be47094d7291), {
        "data-testid": "".concat(testId, "-more-wrapper")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7dab147791499000$export$7f94856880993f27), {
        triggerTestId: "".concat(testId, "-more"),
        options: moreButtonOptions,
        onChange: handleMoreFilterChange,
        selectedOptions: displayedFilters.slice(filterDisplayLimit - 1).filter(function(value) {
            return value.type !== 'datetime' && value.type !== 'toggle';
        }).map(function(filter) {
            return {
                optionType: 'option',
                label: typeof filter.filterLabel === 'string' ? filter.filterLabel : '',
                value: typeof filter.filterLabel === 'string' ? filter.filterLabel : '',
                optionId: filter.filterId,
                isMoreFilter: filter.isMoreFilter
            };
        })
    }))), getActions(), !hideItemsCountFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6ef99e2d246e28a1$export$485780b9c7e4c9c3), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7081ad1e82adb48e$export$f93ec6528f706bfe), {
        testId: "".concat(testId, "-reload"),
        currentCount: itemsFilteredCount,
        totalCount: itemsCount !== null && itemsCount !== void 0 ? itemsCount : null,
        isLoading: isLoading,
        onRefetch: handleReloadWithFocus,
        messageOverrides: refreshMessageOverrides,
        ref: refreshButtonRef
    }))));
});
var $e264e74c775f2cfb$export$2e2bcd8739ae039 = $e264e74c775f2cfb$export$8d640e745b5fefe1;



// THIS FILE IS AUTO-GENERATED FROM dataportal.yml
// DO NOT EDIT MANUALLY - Run 'yarn analytics:generate' to regenerate
/* eslint-disable no-unused-vars */ // Import Atlassian analytics types for reference and potential future use
// These provide the strict typing for the actual analytics client
// Note: These imports are kept for reference and potential future use in type definitions
var $d3be6fee8a258747$export$e19cd5f9376f8cee = /*#__PURE__*/ function(Action) {
    Action["Cancelled"] = "cancelled";
    Action["Clicked"] = "clicked";
    Action["Submitted"] = "submitted";
    Action["Closed"] = "closed";
    Action["Typed"] = "typed";
    Action["Searched"] = "searched";
    Action["Created"] = "created";
    Action["Updated"] = "updated";
    Action["Deleted"] = "deleted";
    Action["Invited"] = "invited";
    Action["Selected"] = "selected";
    Action["Focused"] = "focused";
    Action["Blurred"] = "blurred";
    Action["Viewed"] = "viewed";
    Action["Shown"] = "shown";
    Action["Displayed"] = "displayed";
    Action["Hovered"] = "hovered";
    Action["Entered"] = "entered";
    Action["Switched"] = "switched";
    Action["Dwelled"] = "dwelled";
    Action["Toggled"] = "toggled";
    Action["Pressed"] = "pressed";
    Action["Pasted"] = "pasted";
    Action["Copy"] = "copy";
    Action["Changed"] = "changed";
    Action["Fetch"] = "fetch";
    Action["Cleared"] = "cleared";
    return Action;
}({});
var $d3be6fee8a258747$export$7f97440769de1377 = /*#__PURE__*/ function(ActionSubject) {
    ActionSubject["Table"] = "table";
    ActionSubject["Button"] = "button";
    ActionSubject["Form"] = "form";
    ActionSubject["Link"] = "link";
    ActionSubject["AppSwitcherDropdown"] = "appSwitcherDropdown";
    ActionSubject["AppSwitcherItem"] = "appSwitcherItem";
    ActionSubject["Organization"] = "organization";
    ActionSubject["OrganizationSelectorItem"] = "organizationSelectorItem";
    ActionSubject["BillingSelectorItem"] = "billingSelectorItem";
    ActionSubject["HelpSelectorItem"] = "helpSelectorItem";
    ActionSubject["Dialog"] = "dialog";
    ActionSubject["Datepicker"] = "datepicker";
    ActionSubject["Field"] = "field";
    ActionSubject["NavigationItem"] = "navigationItem";
    ActionSubject["Toggle"] = "toggle";
    ActionSubject["Checkbox"] = "checkbox";
    ActionSubject["DropListItem"] = "dropListItem";
    ActionSubject["DropListTrigger"] = "dropListTrigger";
    ActionSubject["RadioButton"] = "radioButton";
    ActionSubject["Radio"] = "radio";
    ActionSubject["TextField"] = "textField";
    ActionSubject["Text"] = "text";
    ActionSubject["Badge"] = "badge";
    ActionSubject["Dropdown"] = "dropdown";
    ActionSubject["DropdownItem"] = "dropdownItem";
    ActionSubject["SelectItem"] = "selectItem";
    ActionSubject["Error"] = "error";
    ActionSubject["Chart"] = "chart";
    ActionSubject["Page"] = "page";
    ActionSubject["Card"] = "card";
    ActionSubject["Tooltip"] = "tooltip";
    ActionSubject["Icon"] = "icon";
    ActionSubject["NotificationModal"] = "notificationModal";
    ActionSubject["Notification"] = "notification";
    ActionSubject["MenuItem"] = "menuItem";
    ActionSubject["UserPicker"] = "userPicker";
    ActionSubject["Accordion"] = "accordion";
    ActionSubject["Tab"] = "tab";
    ActionSubject["Modal"] = "modal";
    ActionSubject["Flag"] = "flag";
    ActionSubject["IphSideBar"] = "iphSideBar";
    ActionSubject["Input"] = "input";
    ActionSubject["SearchResult"] = "searchResult";
    ActionSubject["CallToAction"] = "callToAction";
    ActionSubject["ResendInvite"] = "resendInvite";
    ActionSubject["DisimssButton"] = "dismissButton";
    ActionSubject["EmptyTable"] = "emptyTable";
    ActionSubject["Row"] = "row";
    ActionSubject["Option"] = "option";
    ActionSubject["FilterController"] = "filterController";
    ActionSubject["Banner"] = "banner";
    ActionSubject["Spotlight"] = "spotlight";
    return ActionSubject;
}({});


const $3e8e9266fe04abe4$export$7a7a8c2474f854cd = {
    appUpdatesListScreen: 'appUpdatesListScreen',
    appUpdatesDetailsScreen: 'appUpdatesDetailsScreen'
};
const $3e8e9266fe04abe4$export$73f866ce8175509a = {
    screen: {
        /**
     * App Updates List Screen View
     */ appUpdatesListScreen: {
            data: {
                name: $3e8e9266fe04abe4$export$7a7a8c2474f854cd.appUpdatesListScreen
            }
        },
        /**
     * App Updates Details Screen View
     */ appUpdatesDetailsScreen: (changelogId, updatesAppTypes)=>({
                data: {
                    name: $3e8e9266fe04abe4$export$7a7a8c2474f854cd.appUpdatesDetailsScreen,
                    attributes: {
                        changelogId: changelogId,
                        ...updatesAppTypes && {
                            updatesAppTypes: updatesAppTypes
                        }
                    }
                }
            })
    },
    ui: {
        /**
     * User clicked the app filter on the app updates list screen
     */ appUpdatesAppFilterClicked: (data, updatesAppTypes)=>({
                data: {
                    action: (0, $d3be6fee8a258747$export$e19cd5f9376f8cee).Clicked,
                    actionSubject: (0, $d3be6fee8a258747$export$7f97440769de1377).Button,
                    actionSubjectId: 'appUpdatesAppFilter',
                    ...data,
                    attributes: {
                        ...updatesAppTypes && {
                            updatesAppTypes: updatesAppTypes
                        }
                    }
                }
            }),
        /**
     * User clicked the status filter on the app updates list screen
     */ appUpdatesStatusFilterClicked: (data, updatesStatusTypes)=>({
                data: {
                    action: (0, $d3be6fee8a258747$export$e19cd5f9376f8cee).Clicked,
                    actionSubject: (0, $d3be6fee8a258747$export$7f97440769de1377).Button,
                    actionSubjectId: 'appUpdatesStatusFilter',
                    ...data,
                    attributes: {
                        ...updatesStatusTypes && {
                            updatesStatusTypes: updatesStatusTypes
                        }
                    }
                }
            }),
        /**
     * User clicked the type filter on the app updates list screen
     */ appUpdatesTypeFilterClicked: (data, updatesChangeTypes)=>({
                data: {
                    action: (0, $d3be6fee8a258747$export$e19cd5f9376f8cee).Clicked,
                    actionSubject: (0, $d3be6fee8a258747$export$7f97440769de1377).Button,
                    actionSubjectId: 'appUpdatesTypeFilter',
                    ...data,
                    attributes: {
                        ...updatesChangeTypes && {
                            updatesChangeTypes: updatesChangeTypes
                        }
                    }
                }
            }),
        /**
     * User clicked the impact rating filter on the app updates list screen
     */ appUpdatesImpactRatingFilterClicked: (data, updatesImpactTypes)=>({
                data: {
                    action: (0, $d3be6fee8a258747$export$e19cd5f9376f8cee).Clicked,
                    actionSubject: (0, $d3be6fee8a258747$export$7f97440769de1377).Button,
                    actionSubjectId: 'appUpdatesImpactRatingFilter',
                    ...data,
                    attributes: {
                        ...updatesImpactTypes && {
                            updatesImpactTypes: updatesImpactTypes
                        }
                    }
                }
            }),
        /**
     * User clicked the contextual tag filter on the app updates list screen
     */ appUpdatesTagFilterClicked: (data, updatesTagTypes)=>({
                data: {
                    action: (0, $d3be6fee8a258747$export$e19cd5f9376f8cee).Clicked,
                    actionSubject: (0, $d3be6fee8a258747$export$7f97440769de1377).Button,
                    actionSubjectId: 'appUpdatesTagFilter',
                    ...data,
                    attributes: {
                        ...updatesTagTypes && {
                            updatesTagTypes: updatesTagTypes
                        }
                    }
                }
            }),
        /**
     * User clicked the apply button on the app updates list screen
     */ appUpdatesApplyClicked: (data, updatesAppTypes, updatesStatusTypes, updatesChangeTypes, updatesSearchContent)=>({
                data: {
                    action: (0, $d3be6fee8a258747$export$e19cd5f9376f8cee).Clicked,
                    actionSubject: (0, $d3be6fee8a258747$export$7f97440769de1377).Button,
                    actionSubjectId: 'appUpdatesApply',
                    ...data,
                    attributes: {
                        ...updatesAppTypes && {
                            updatesAppTypes: updatesAppTypes
                        },
                        ...updatesStatusTypes && {
                            updatesStatusTypes: updatesStatusTypes
                        },
                        ...updatesChangeTypes && {
                            updatesChangeTypes: updatesChangeTypes
                        },
                        ...updatesSearchContent && {
                            updatesSearchContent: updatesSearchContent
                        }
                    }
                }
            })
    },
    track: {},
    operational: {}
};


var $5FkrB = parcelRequire("5FkrB");

var $62KHl = parcelRequire("62KHl");
var $dpXUu = parcelRequire("dpXUu");

var $bDLqY = parcelRequire("bDLqY");
const $45964660615f0a60$var$mapEnvironmentToAnalyticsEnvType = ()=>{
    return (0, $dpXUu.envType).PROD;
};
const $45964660615f0a60$var$init = ()=>{
    const analyticsClient = new (0, $62KHl.default)({
        env: $45964660615f0a60$var$mapEnvironmentToAnalyticsEnvType(),
        product: 'appUpdates',
        version: '1.0.0',
        origin: (0, $dpXUu.originType).WEB
    }, {
        useLegacyUrl: true
    });
    const aaid = (0, (/*@__PURE__*/$parcel$interopDefault($bDLqY))).get('aaid');
    if (aaid) analyticsClient.setUserInfo((0, $dpXUu.userType).ATLASSIAN_ACCOUNT, aaid);
    return analyticsClient;
};
let $45964660615f0a60$var$analyticsClient = null;
const $45964660615f0a60$export$e9ba7ef9458d1a4a = ()=>{
    if ($45964660615f0a60$var$analyticsClient === null) $45964660615f0a60$var$analyticsClient = $45964660615f0a60$var$init();
    return $45964660615f0a60$var$analyticsClient;
};
const $45964660615f0a60$export$5e53520e517ec9ab = (client, eventType, event)=>{
    switch(eventType){
        case 'screen':
            client.sendScreenEvent(event);
            break;
        case 'track':
            client.sendTrackEvent(event);
            break;
        case 'ui':
            client.sendUIEvent(event);
            break;
        case 'operational':
            client.sendOperationalEvent(event);
            break;
        default:
            throw new Error(`Invalid event type: ${eventType}`);
    }
};




var $5FkrB = parcelRequire("5FkrB");
/**
 * OneTrust consent category ID for "Performance Cookies" (analytics/tracking).
 * OneTrust serializes active groups as a comma-delimited string, e.g. ",1,2,3,".
 * We wrap the ID in commas to avoid false-positive substring matches (e.g. ",12,"
 * accidentally matching a check for "2").
 *
 * If your OneTrust configuration uses a different category ID for analytics,
 * update this constant. Category IDs are found in your OneTrust admin console
 * under: Cookie Compliance > Categorizations.
 */ const $38056d680fac42ff$var$ONETRUST_ANALYTICS_CATEGORY = ',2,';
const $38056d680fac42ff$var$OneTrustContext = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
const $38056d680fac42ff$export$b224af886b957a5e = ()=>{
    const context = (0, $5FkrB.useContext)($38056d680fac42ff$var$OneTrustContext);
    if (context === null) throw new Error('calls to useOneTrustContext must be wrapped in <OneTrustProvider>');
    return context;
};
const $38056d680fac42ff$export$52310512b1bd7aec = ({ children: children })=>{
    const [analyticsOptOut, setAnalyticsOptOut] = (0, $5FkrB.useState)(true);
    const [onetrustActiveGroups, setOnetrustActiveGroups] = (0, $5FkrB.useState)(typeof window !== 'undefined' ? window.OnetrustActiveGroups : undefined);
    // Store the interval ID in a ref so it is always current inside the closure,
    // avoiding the stale-variable bug that occurred when reassigning a `let` that
    // the cleanup function had already captured.
    const intervalRef = (0, $5FkrB.useRef)(undefined);
    (0, $5FkrB.useEffect)(()=>{
        const checkOnetrustActiveGroups = ()=>{
            if (window.OnetrustActiveGroups === undefined) return;
            setOnetrustActiveGroups(window.OnetrustActiveGroups);
            // React batches identical state updates as a no-op, so no need to
            // compare before calling the setter.
            setAnalyticsOptOut(!window.OnetrustActiveGroups.includes($38056d680fac42ff$var$ONETRUST_ANALYTICS_CATEGORY));
            /**
       * Clear the interval once OneTrust has been initialized and only recheck
       * every 1 sec if the opt-out status is still the default (true).
       */ clearInterval(intervalRef.current);
            if (!window.OnetrustActiveGroups.includes($38056d680fac42ff$var$ONETRUST_ANALYTICS_CATEGORY)) intervalRef.current = setInterval(checkOnetrustActiveGroups, 1000);
        };
        // Start the initial 250ms poll. The effect runs once on mount only.
        intervalRef.current = setInterval(checkOnetrustActiveGroups, 250);
        return ()=>{
            clearInterval(intervalRef.current);
        };
    // Empty deps array is intentional: this effect sets up a one-time interval on
    // mount. State setters (setAnalyticsOptOut, setOnetrustActiveGroups) have
    // stable identities guaranteed by React, and intervalRef is a stable ref
    // container — so listing them would cause unnecessary re-subscriptions.
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($38056d680fac42ff$var$OneTrustContext.Provider, {
        value: {
            analyticsOptOut: analyticsOptOut,
            onetrustActiveGroups: onetrustActiveGroups
        },
        children: children
    });
};



parcelRequire("5FkrB");

const $8c48fdd8d5a3abf9$var$ONETRUST_SCRIPT_DOMAIN = "atl-onetrust-wrapper.atlassian.com";
const $8c48fdd8d5a3abf9$var$ONETRUST_GUID = "336ea4c3-54ae-40f0-9331-b4500ffed1ee";
const $8c48fdd8d5a3abf9$var$IS_NON_PROD = false;
const $8c48fdd8d5a3abf9$export$4719288a8f5f7e71 = ({ children: children })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $448e9b7b3295f6e4$export$4719288a8f5f7e71), {
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $448e9b7b3295f6e4$export$dcef8f9bb9a41431), {
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("script", {
                    src: `https://${$8c48fdd8d5a3abf9$var$ONETRUST_SCRIPT_DOMAIN}/assets/atl-onetrust-wrapper.min.js`,
                    type: "text/javascript",
                    "data-domain": $8c48fdd8d5a3abf9$var$ONETRUST_GUID,
                    "data-test": $8c48fdd8d5a3abf9$var$IS_NON_PROD,
                    "data-geofence": "false",
                    "data-sync": "true"
                })
            }),
            children
        ]
    });




const $a442bdf486731fcc$export$62b6ee20d27ead99 = ()=>{
    const { analyticsOptOut: analyticsOptOut } = (0, $38056d680fac42ff$export$b224af886b957a5e)();
    const sendScreenEvent = (0, $5FkrB.useCallback)((event)=>{
        if (analyticsOptOut) return;
        const client = (0, $45964660615f0a60$export$e9ba7ef9458d1a4a)();
        (0, $45964660615f0a60$export$5e53520e517ec9ab)(client, 'screen', event);
    }, [
        analyticsOptOut
    ]);
    const sendTrackEvent = (0, $5FkrB.useCallback)((event)=>{
        if (analyticsOptOut) return;
        const client = (0, $45964660615f0a60$export$e9ba7ef9458d1a4a)();
        (0, $45964660615f0a60$export$5e53520e517ec9ab)(client, 'track', event);
    }, [
        analyticsOptOut
    ]);
    const sendUIEvent = (0, $5FkrB.useCallback)((event)=>{
        if (analyticsOptOut) return;
        const client = (0, $45964660615f0a60$export$e9ba7ef9458d1a4a)();
        (0, $45964660615f0a60$export$5e53520e517ec9ab)(client, 'ui', event);
    }, [
        analyticsOptOut
    ]);
    const sendOperationalEvent = (0, $5FkrB.useCallback)((event)=>{
        if (analyticsOptOut) return;
        const client = (0, $45964660615f0a60$export$e9ba7ef9458d1a4a)();
        (0, $45964660615f0a60$export$5e53520e517ec9ab)(client, 'operational', event);
    }, [
        analyticsOptOut
    ]);
    return {
        sendScreenEvent: sendScreenEvent,
        sendTrackEvent: sendTrackEvent,
        sendUIEvent: sendUIEvent,
        sendOperationalEvent: sendOperationalEvent
    };
};


/**
 * Central registry of feature gate keys used in the application.
 * Add new feature gate keys here as string constants.
 */ const $86626a3c150b02ba$export$5fb62a9fe732a843 = {
    /**
   * PAU_CONTEXTUAL_TAGS_BETA
   * @link https://switcheroo.atlassian.com/ui/gates/40c3b4b3-4572-49cb-9572-f41a4038194a/key/pau_contextual_tags_beta
   * @description Controls visibility of AI-generated Contextual tags.
   * OFF by default while Contextual tags remain in beta.
   */ contextualTagsBeta: 'pau_contextual_tags_beta',
    /**
   * @deprecated A fake gate key used only in unit tests to exercise the fg() utility.
   * Not a real Switcheroo gate — do not use in production code.
   */ testOnly: 'test-gate-for-unit-tests'
};


var $ISKn7 = parcelRequire("ISKn7");


const $c78886f48293f91c$var$developmentFeatureGateOverrides = {
    [(0, $86626a3c150b02ba$export$5fb62a9fe732a843).contextualTagsBeta]: false
};
function $c78886f48293f91c$export$b40ec24ac8275656(key) {
    try {
        return (0, $ISKn7.default).checkGate(key) === true;
    } catch (e) {
        (0, $9654b596cdf679bc$export$2e2bcd8739ae039).warn(`[FeatureGates] Failed to check gate "${key}": ${e}`);
        return false;
    }
}



var $5FkrB = parcelRequire("5FkrB");


const $11c628b62cd1de28$export$20b4f4827168badb = ()=>{
    const { state: state } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const syncFiltersToUrl = (0, $5FkrB.useCallback)((overrides)=>{
        // eslint-disable-next-line no-unused-vars
        const { committedFiltersVersion: _committedFiltersVersion, ...filters } = state.updates.committedFilters;
        const currentFilters = {
            ...filters,
            cursor: state.updates.pagination.cursor,
            limit: state.updates.pagination.limit,
            ...overrides
        };
        const urlParams = (0, $ea567f1e5717897c$export$e582c11b604ddc57)(currentFilters);
        const searchString = (0, $ea567f1e5717897c$export$de85dd96eb599379)(urlParams);
        const newUrl = `${window.location.pathname}${searchString}`;
        if (window.history && window.history.replaceState) window.history.replaceState(null, '', newUrl);
    }, [
        state.updates.committedFilters,
        state.updates.pagination
    ]);
    const getFiltersFromUrlCallback = (0, $5FkrB.useCallback)(()=>(0, $ea567f1e5717897c$export$227523e113d14c22)(), []);
    return {
        syncFiltersToUrl: syncFiltersToUrl,
        getFiltersFromUrl: getFiltersFromUrlCallback
    };
};



var $5FkrB = parcelRequire("5FkrB");


const $8081251f610920d9$export$87ec4334ff1f5401 = ()=>{
    const { state: state } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const syncFiltersToUrl = (0, $5FkrB.useCallback)((overrides)=>{
        // eslint-disable-next-line no-unused-vars
        const { committedFiltersVersion: _committedFiltersVersion, ...filters } = state.bundles.committedFilters;
        const currentFilters = {
            ...filters,
            cursor: state.bundles.pagination.cursor,
            limit: state.bundles.pagination.limit,
            ...overrides
        };
        const urlParams = (0, $ea567f1e5717897c$export$e582c11b604ddc57)(currentFilters);
        const searchString = (0, $ea567f1e5717897c$export$de85dd96eb599379)(urlParams);
        const newUrl = `${window.location.pathname}${searchString}`;
        if (window.history && window.history.replaceState) window.history.replaceState(null, '', newUrl);
    }, [
        state.bundles.committedFilters,
        state.bundles.pagination
    ]);
    return {
        syncFiltersToUrl: syncFiltersToUrl
    };
};






const $a4311b03a11a743e$var$BUNDLE_DATES_ENDPOINT = '/gateway/api/public/app-updates/v1/bundle-dates';
const $a4311b03a11a743e$export$60bd082d9d0dd517 = (selectedProducts)=>{
    if (!selectedProducts || selectedProducts.length === 0) return undefined;
    const keys = selectedProducts.map(({ id: id })=>(0, $d3185276e14a4c2b$export$7524c8b3bd6ccb7f)(id)?.productKey).filter((key)=>key !== undefined);
    return keys.join(',') || undefined;
};
const $a4311b03a11a743e$export$9a76656633d800c0 = (selectedProducts)=>{
    const { api: api } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const productsParam = $a4311b03a11a743e$export$60bd082d9d0dd517(selectedProducts);
    const query = (0, $4b398c1589a0f1e2$export$dd0a697e1782aedd)({
        queryKey: [
            $a4311b03a11a743e$var$BUNDLE_DATES_ENDPOINT,
            productsParam ?? ''
        ],
        queryFn: async ()=>{
            try {
                const response = await api.get($a4311b03a11a743e$var$BUNDLE_DATES_ENDPOINT, {
                    params: productsParam ? {
                        products: productsParam
                    } : {}
                });
                return Array.isArray(response.data) ? response.data : [];
            } catch (error) {
                (0, $9654b596cdf679bc$export$2e2bcd8739ae039).error(error, {
                    extra: {
                        action: 'fetch-bundle-dates'
                    }
                });
                return [];
            }
        }
    });
    const allBundleDates = query.data ?? [];
    return {
        latestBundleDate: allBundleDates[0] ?? null,
        allBundleDates: allBundleDates,
        isLoading: query.isLoading,
        error: query.error
    };
};



var $5FkrB = parcelRequire("5FkrB");




const $2c8a3e2d136767dc$var$APPS_ENDPOINT = '/gateway/api/public/app-updates/v1/apps';
const $2c8a3e2d136767dc$var$EMPTY_PRODUCTS = [];
const $2c8a3e2d136767dc$export$141b75908cb447a9 = (capability)=>{
    const { api: api } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const query = (0, $4b398c1589a0f1e2$export$dd0a697e1782aedd)({
        queryKey: [
            $2c8a3e2d136767dc$var$APPS_ENDPOINT,
            capability
        ],
        queryFn: async ()=>{
            try {
                const response = await api.get($2c8a3e2d136767dc$var$APPS_ENDPOINT, {
                    params: {
                        capability: capability
                    }
                });
                const keys = Array.isArray(response.data) ? response.data : [];
                return keys.map((key)=>{
                    const config = (0, $d3185276e14a4c2b$export$a3ce53670861b599)(key);
                    const productType = (0, $d3185276e14a4c2b$export$27e53caf66bae1d)(key);
                    if (!config || !productType) {
                        // Log unknown keys so the team knows to update PRODUCT_LOGO_MAP
                        (0, $9654b596cdf679bc$export$2e2bcd8739ae039).warn(`Unknown product key from API: "${key}"`);
                        return null;
                    }
                    return {
                        id: productType.toUpperCase(),
                        name: config.displayName,
                        icon: config.icon
                    };
                }).filter((p)=>p !== null).sort((a, b)=>a.name.localeCompare(b.name));
            } catch (error) {
                (0, $9654b596cdf679bc$export$2e2bcd8739ae039).error(error, {
                    extra: {
                        action: 'fetch-available-apps'
                    }
                });
                throw error;
            }
        }
    });
    const products = query.data ?? $2c8a3e2d136767dc$var$EMPTY_PRODUCTS;
    const productOptions = (0, $5FkrB.useMemo)(()=>products.map((product)=>({
                label: product.name,
                value: product.id,
                optionType: 'option'
            })), [
        products
    ]);
    return {
        productOptions: productOptions,
        isLoading: query.isLoading,
        error: query.error
    };
};




const $3b930b34264f8f14$export$e4cfc23fa7ee5916 = (options)=>{
    if (!Array.isArray(options)) throw new TypeError('Expected paginated filter value to be an array');
    return options;
};



var $5FkrB = parcelRequire("5FkrB");



const $5f43c72173f3a108$export$ce41276cb1be92e5 = (0, $7e94896e68874ec2$export$1adfeb024f5185b)({
    improvement: {
        id: 'appUpdates.changeType.improvement',
        defaultMessage: 'Improvement',
        description: "App update is type 'Improvement'"
    },
    fix: {
        id: 'appUpdates.changeType.fix',
        defaultMessage: 'Fix',
        description: "App update is type 'Fix'"
    },
    experiment: {
        id: 'appUpdates.changeType.experiment',
        defaultMessage: 'Experiment',
        description: "App update is type 'Experiment'"
    },
    removed: {
        id: 'appUpdates.changeType.removed',
        defaultMessage: 'Removed',
        description: "App update is type 'Removed'"
    },
    announcement: {
        id: 'appUpdates.changeType.announcement',
        defaultMessage: 'Announcement',
        description: "App update is of type 'Announcement'"
    }
});
const $5f43c72173f3a108$export$58d8d249a6136224 = (changeTypeId)=>{
    switch(changeTypeId){
        case 'IMPROVEMENT':
            return $5f43c72173f3a108$export$ce41276cb1be92e5.improvement;
        case 'FIX':
            return $5f43c72173f3a108$export$ce41276cb1be92e5.fix;
        case 'EXPERIMENT':
            return $5f43c72173f3a108$export$ce41276cb1be92e5.experiment;
        case 'REMOVED':
            return $5f43c72173f3a108$export$ce41276cb1be92e5.removed;
        case 'ANNOUNCEMENT':
            return $5f43c72173f3a108$export$ce41276cb1be92e5.announcement;
        default:
            return $5f43c72173f3a108$export$ce41276cb1be92e5.improvement; // fallback
    }
};




const $97df1e5bc15c5140$export$defe85febe8b728c = (0, $7e94896e68874ec2$export$1adfeb024f5185b)({
    changeType: {
        id: 'appUpdates.filters.changeType.label',
        description: 'Label for the change type filter',
        defaultMessage: 'Change type'
    }
});
const $97df1e5bc15c5140$var$useChangeTypeOptions = ()=>{
    const { formatMessage: formatMessage } = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    return (0, $51e43113ed6c9475$export$94a5323e67ff7814).map((changeTypeId)=>({
            id: changeTypeId,
            name: formatMessage((0, $5f43c72173f3a108$export$58d8d249a6136224)(changeTypeId))
        }));
};
const $97df1e5bc15c5140$export$27eea02c1dddba97 = ()=>{
    const changeTypeOptions = $97df1e5bc15c5140$var$useChangeTypeOptions();
    return (0, $5FkrB.useCallback)((options)=>{
        const selectedChangeTypes = options.map((option)=>changeTypeOptions.find((candidate)=>candidate.id === option.value)).filter((changeType)=>changeType !== undefined);
        return selectedChangeTypes.length > 0 ? selectedChangeTypes : null;
    }, [
        changeTypeOptions
    ]);
};
const $97df1e5bc15c5140$export$95da0a36a388a53 = ()=>{
    const { formatMessage: formatMessage } = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    const { state: state, dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { sendUIEvent: sendUIEvent } = (0, $a442bdf486731fcc$export$62b6ee20d27ead99)();
    const changeTypeOptions = $97df1e5bc15c5140$var$useChangeTypeOptions();
    const getChangeTypesFromOptions = $97df1e5bc15c5140$export$27eea02c1dddba97();
    const selectedChangeTypes = state.updates.draftFilters.selectedChangeTypes || [];
    const changeTypeSelectOptions = selectedChangeTypes.map((changeType)=>({
            label: changeType.name,
            value: changeType.id,
            optionType: 'option'
        }));
    const onLoadOptions = (search, _enableFullList, _showFullList, _showMore, _lastOption, callback)=>{
        let options = changeTypeOptions.map((option)=>({
                label: option.name,
                value: option.id,
                optionType: 'option'
            }));
        if (search) {
            const searchText = search.toLowerCase();
            options = options.filter((option)=>option.label?.toLowerCase().includes(searchText));
        }
        callback({
            options: options,
            totalCount: options.length
        });
    };
    const handleChange = (0, $5FkrB.useCallback)((options)=>{
        const nextSelectedChangeTypes = getChangeTypesFromOptions(options) ?? [];
        dispatch({
            type: 'FILTER_CHANGE_TYPE_SELECT',
            payload: {
                selectedChangeTypes: nextSelectedChangeTypes.length > 0 ? nextSelectedChangeTypes : null
            }
        });
        // Send analytics event
        const nextSelectedChangeTypesString = nextSelectedChangeTypes.length > 0 ? nextSelectedChangeTypes.map((c)=>c.id).join(',') : undefined;
        sendUIEvent((0, $3e8e9266fe04abe4$export$73f866ce8175509a).ui.appUpdatesTypeFilterClicked({
            source: 'appUpdatesListScreen'
        }, nextSelectedChangeTypesString).data);
    }, [
        dispatch,
        getChangeTypesFromOptions,
        sendUIEvent
    ]);
    return {
        testId: 'app-updates-filter-change-type-testid',
        fieldLabel: formatMessage($97df1e5bc15c5140$export$defe85febe8b728c.changeType),
        fieldId: 'app-updates-table-change-type-filter',
        value: changeTypeSelectOptions,
        onLoadOptions: onLoadOptions,
        onChange: handleChange,
        onClearValues: ()=>handleChange([])
    };
};






const $03086a167d2bae2b$export$defe85febe8b728c = (0, $7e94896e68874ec2$export$1adfeb024f5185b)({
    impactRating: {
        id: 'appUpdates.filters.impactRating.label',
        description: 'Label for the impact rating filter',
        defaultMessage: 'Impact rating'
    }
});
// Keep option references stable across controller renders.
const $03086a167d2bae2b$var$impactRatingOptions = (0, $51e43113ed6c9475$export$aafe24a01710fa9a).map((id)=>({
        id: id,
        name: (0, $51e43113ed6c9475$export$5926fcb263ea10c4)[id]
    }));
const $03086a167d2bae2b$export$745a9101a774f6a4 = (options)=>{
    const selectedRatings = options.map((option)=>$03086a167d2bae2b$var$impactRatingOptions.find((candidate)=>candidate.id === option.value)).filter((rating)=>rating !== undefined);
    return selectedRatings.length > 0 ? selectedRatings : null;
};
const $03086a167d2bae2b$export$48a3c8af3e952f18 = ()=>{
    const { formatMessage: formatMessage } = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    const { state: state, dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { sendUIEvent: sendUIEvent } = (0, $a442bdf486731fcc$export$62b6ee20d27ead99)();
    const impactRatingSelectOptions = $03086a167d2bae2b$var$impactRatingOptions.map((rating)=>({
            label: rating.name,
            value: rating.id,
            optionType: 'option'
        }));
    const getSelectedRatings = ()=>{
        const selectedImpactRatings = state.updates.draftFilters.selectedImpactRatings;
        if (!selectedImpactRatings || selectedImpactRatings.length === 0) return [];
        return selectedImpactRatings.map((selectedRating)=>impactRatingSelectOptions.find((option)=>option.value === selectedRating.id)).filter((option)=>option !== undefined);
    };
    const onImpactRatingFilterChange = (options)=>{
        const selectedRatingValues = $03086a167d2bae2b$export$745a9101a774f6a4(options) ?? [];
        dispatch({
            type: 'FILTER_IMPACT_RATING_SELECT',
            payload: {
                selectedImpactRatings: selectedRatingValues.length > 0 ? selectedRatingValues : null
            }
        });
        // Send analytics event
        const updatesImpactTypes = selectedRatingValues.length > 0 ? selectedRatingValues.map((r)=>r.id).join(',') : undefined;
        sendUIEvent((0, $3e8e9266fe04abe4$export$73f866ce8175509a).ui.appUpdatesImpactRatingFilterClicked({
            source: 'appUpdatesListScreen'
        }, updatesImpactTypes).data);
    };
    const onLoadOptions = (search, _enableFullList, _showFullList, _showMore, _lastOption, callback)=>{
        let options = impactRatingSelectOptions.map((option)=>({
                label: option.label,
                value: option.value,
                optionType: 'option'
            }));
        if (search) {
            const searchText = search.toLowerCase();
            options = options.filter((option)=>option.label?.toLowerCase().includes(searchText));
        }
        callback({
            options: options,
            totalCount: options.length
        });
    };
    return {
        testId: 'app-updates-filter-impact-rating-testid',
        fieldLabel: formatMessage($03086a167d2bae2b$export$defe85febe8b728c.impactRating),
        fieldId: 'app-updates-table-impact-rating-filter',
        onLoadOptions: onLoadOptions,
        value: getSelectedRatings(),
        onChange: onImpactRatingFilterChange,
        onClearValues: ()=>onImpactRatingFilterChange([])
    };
};





var $4Pn6z = parcelRequire("4Pn6z");
var $gDiFE = parcelRequire("gDiFE");




const $0353f38be7f82b7e$var$messages = (0, $7e94896e68874ec2$export$1adfeb024f5185b)({
    product: {
        id: 'appUpdates.filters.product.label',
        description: 'Label for the product filter',
        defaultMessage: 'App'
    }
});
const $0353f38be7f82b7e$var$productOptionStyles = (0, $gDiFE.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100',
    minHeight: '24px',
    overflow: 'hidden'
});
const $0353f38be7f82b7e$export$aefc16b6a6a9a2d0 = (options)=>options.map((option)=>({
            id: String(option.value),
            name: option.label
        }));
const $0353f38be7f82b7e$export$f3a31e95d972a8e5 = ()=>{
    const { formatMessage: formatMessage } = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    const { state: state, dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { sendUIEvent: sendUIEvent } = (0, $a442bdf486731fcc$export$62b6ee20d27ead99)();
    const { productOptions: productOptions, isLoading: isLoading } = (0, $2c8a3e2d136767dc$export$141b75908cb447a9)('PUBLIC_APP_UPDATES');
    const getSelectedProducts = ()=>{
        const selectedProducts = state.updates.draftFilters.selectedProducts;
        if (!selectedProducts || selectedProducts.length === 0) return [];
        return selectedProducts.map((selectedProduct)=>productOptions.find((option)=>option.value === selectedProduct.id)).filter((option)=>option !== undefined);
    };
    const onProductFilterChange = (options)=>{
        const selectedProductValues = $0353f38be7f82b7e$export$aefc16b6a6a9a2d0(options) ?? [];
        dispatch({
            type: 'FILTER_APP_SELECT',
            payload: {
                selectedProducts: selectedProductValues.length > 0 ? selectedProductValues : null
            }
        });
        // Send analytics event
        const updatesAppTypes = selectedProductValues.length > 0 ? selectedProductValues.map((p)=>p.id).join(',') : undefined;
        sendUIEvent((0, $3e8e9266fe04abe4$export$73f866ce8175509a).ui.appUpdatesAppFilterClicked({
            source: 'appUpdatesListScreen'
        }, updatesAppTypes).data);
    };
    const formatProduct = (option)=>{
        return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $4Pn6z.Box), {
            as: "div",
            xcss: $0353f38be7f82b7e$var$productOptionStyles,
            testId: `app-filter-option-${option.value}`,
            children: [
                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $7397f708924e0bda$export$1a199e029d5e93d6), {
                    productType: option.value,
                    size: "xsmall",
                    testId: `app-icon-${option.value}`
                }),
                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                    as: "span",
                    children: option.label
                })
            ]
        });
    };
    const onLoadOptions = (search, _enableFullList, _showFullList, _showMore, _lastOption, callback)=>{
        let options = productOptions.map((option)=>({
                label: option.label,
                value: option.value,
                optionType: 'option'
            }));
        if (search) {
            const searchText = search.trim().toLowerCase();
            options = options.filter((option)=>option.label?.trim().toLowerCase().includes(searchText));
        }
        callback({
            options: options,
            totalCount: options.length
        });
    };
    return {
        testId: 'app-updates-filter-product-app-testid',
        fieldLabel: formatMessage($0353f38be7f82b7e$var$messages.product),
        fieldId: 'app-updates-table-app-filter',
        onLoadOptions: onLoadOptions,
        value: getSelectedProducts(),
        onChange: onProductFilterChange,
        onClearValues: ()=>onProductFilterChange([]),
        formatOptionLabel: formatProduct,
        isLoading: isLoading
    };
};





var $5supy = parcelRequire("5supy");


const $dafe8aa59b77d934$export$fc553d92d82f7a20 = (0, $7e94896e68874ec2$export$1adfeb024f5185b)({
    comingSoon: {
        id: 'appUpdates.status.comingSoon',
        defaultMessage: 'Coming Soon',
        description: 'Coming Soon status for app updates'
    },
    planned: {
        id: 'appUpdates.status.planned',
        defaultMessage: 'Planned',
        description: 'Planned status for app updates'
    },
    rollingOut: {
        id: 'appUpdates.status.rollingOut',
        defaultMessage: 'Rolling Out',
        description: 'Rolling Out status for app updates'
    },
    generallyAvailable: {
        id: 'appUpdates.status.generallyAvailable',
        defaultMessage: 'Generally Available',
        description: 'Generally Available status for app updates'
    },
    rolledBack: {
        id: 'appUpdates.status.rolledBack',
        defaultMessage: 'Rolled Back',
        description: 'Rolled Back status for app updates'
    }
});
const $dafe8aa59b77d934$export$b42e1e02ec743c13 = {
    COMING_SOON: 'inprogress',
    PLANNED: 'default',
    ROLLING_OUT: 'new',
    GENERALLY_AVAILABLE: 'success',
    ROLLED_BACK: 'removed'
};
const $dafe8aa59b77d934$export$e238a77ea3a8cd66 = (statusId)=>{
    switch(statusId){
        case 'COMING_SOON':
            return $dafe8aa59b77d934$export$fc553d92d82f7a20.comingSoon;
        case 'PLANNED':
            return $dafe8aa59b77d934$export$fc553d92d82f7a20.planned;
        case 'ROLLING_OUT':
            return $dafe8aa59b77d934$export$fc553d92d82f7a20.rollingOut;
        case 'GENERALLY_AVAILABLE':
            return $dafe8aa59b77d934$export$fc553d92d82f7a20.generallyAvailable;
        case 'ROLLED_BACK':
            return $dafe8aa59b77d934$export$fc553d92d82f7a20.rolledBack;
        default:
            return $dafe8aa59b77d934$export$fc553d92d82f7a20.planned; // fallback
    }
};
const $dafe8aa59b77d934$export$548966735f47dde3 = (statusId)=>{
    return $dafe8aa59b77d934$export$b42e1e02ec743c13[statusId];
};




const $06fb2ec62866f55e$export$defe85febe8b728c = (0, $7e94896e68874ec2$export$1adfeb024f5185b)({
    status: {
        id: 'appUpdates.filters.status.label',
        description: 'Label for the status filter',
        defaultMessage: 'Status'
    }
});
const $06fb2ec62866f55e$export$4d0ee99557dd065b = (options)=>options.map((option)=>({
            id: String(option.value),
            name: option.label
        }));
const $06fb2ec62866f55e$export$df18f74ac650c683 = ()=>{
    const { formatMessage: formatMessage } = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    const { state: state, dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { sendUIEvent: sendUIEvent } = (0, $a442bdf486731fcc$export$62b6ee20d27ead99)();
    const statusOptions = (0, $51e43113ed6c9475$export$c2352a34eb11a9e9).map((statusId)=>({
            id: statusId,
            name: formatMessage((0, $dafe8aa59b77d934$export$e238a77ea3a8cd66)(statusId))
        }));
    const formatOptionLabel = (option)=>{
        if (option.optionType === 'group') return option.label;
        return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $5supy.default), {
            appearance: (0, $dafe8aa59b77d934$export$548966735f47dde3)(option.value),
            children: option.label
        });
    };
    const statusSelectOptions = statusOptions.map((status)=>({
            label: status.name,
            value: status.id,
            optionType: 'option'
        })).sort((a, b)=>a.label.localeCompare(b.label));
    const getSelectedStatuses = ()=>{
        const selectedStatuses = state.updates.draftFilters.selectedStatuses;
        if (!selectedStatuses || selectedStatuses.length === 0) return [];
        return selectedStatuses.map((selectedStatus)=>statusSelectOptions.find((option)=>option.value === selectedStatus.id)).filter((option)=>option !== undefined);
    };
    const onStatusFilterChange = (options)=>{
        const selectedStatusValues = $06fb2ec62866f55e$export$4d0ee99557dd065b(options);
        dispatch({
            type: 'FILTER_STATUS_SELECT',
            payload: {
                selectedStatuses: selectedStatusValues.length > 0 ? selectedStatusValues : null
            }
        });
        // Send analytics event
        const updatesStatusTypes = selectedStatusValues.map(({ id: id })=>id).join(',') || undefined;
        sendUIEvent((0, $3e8e9266fe04abe4$export$73f866ce8175509a).ui.appUpdatesStatusFilterClicked({
            source: 'appUpdatesListScreen'
        }, updatesStatusTypes).data);
    };
    const onLoadOptions = (search, _enableFullList, _showFullList, _showMore, _lastOption, callback)=>{
        let options = statusSelectOptions.map((option)=>({
                label: option.label,
                value: option.value,
                optionType: 'option'
            }));
        if (search) {
            const searchText = search.toLowerCase();
            options = options.filter((option)=>option.label?.toLowerCase().includes(searchText));
        }
        callback({
            options: options,
            totalCount: options.length
        });
    };
    return {
        testId: 'app-updates-filter-status-testid',
        fieldLabel: formatMessage($06fb2ec62866f55e$export$defe85febe8b728c.status),
        fieldId: 'app-updates-table-status-filter',
        onLoadOptions: onLoadOptions,
        value: getSelectedStatuses(),
        onChange: onStatusFilterChange,
        onClearValues: ()=>onStatusFilterChange([]),
        formatOptionLabel: formatOptionLabel
    };
};






const $0a6763f4898e1dbe$export$defe85febe8b728c = (0, $7e94896e68874ec2$export$1adfeb024f5185b)({
    contextualTags: {
        id: 'appUpdates.filters.tags.label',
        description: 'Label for the AI-generated contextual tags filter',
        defaultMessage: 'Contextual tags'
    }
});
// Defined outside component to maintain stable references
const $0a6763f4898e1dbe$var$tagOptions = (0, $51e43113ed6c9475$export$f3e6ae23d6c89755).map((tagId)=>({
        id: tagId,
        name: (0, $51e43113ed6c9475$export$4bbe71e8edfbf0cd)(tagId)
    }));
const $0a6763f4898e1dbe$var$tagSelectOptions = $0a6763f4898e1dbe$var$tagOptions.map((tag)=>({
        label: tag.name,
        value: tag.id,
        optionType: 'option'
    }));
const $0a6763f4898e1dbe$export$8009508cf988d06b = (options)=>{
    const selectedTags = options.map((option)=>$0a6763f4898e1dbe$var$tagOptions.find((candidate)=>candidate.id === option.value)).filter((tag)=>tag !== undefined);
    return selectedTags.length > 0 ? selectedTags : null;
};
const $0a6763f4898e1dbe$export$f65a9db96a965347 = ()=>{
    const { formatMessage: formatMessage } = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    const { state: state, dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { sendUIEvent: sendUIEvent } = (0, $a442bdf486731fcc$export$62b6ee20d27ead99)();
    // Derive selected values by looking up from stable options list
    const getSelectedTags = ()=>{
        const selectedTags = state.updates.draftFilters.selectedTags;
        if (!selectedTags || selectedTags.length === 0) return [];
        return selectedTags.map((selected)=>$0a6763f4898e1dbe$var$tagSelectOptions.find((option)=>option.value === selected.id)).filter((option)=>option !== undefined);
    };
    const onLoadOptions = (search, _enableFullList, _showFullList, _showMore, _lastOption, callback)=>{
        let options = $0a6763f4898e1dbe$var$tagSelectOptions.map((option)=>({
                label: option.label,
                value: option.value,
                optionType: 'option'
            }));
        if (search) {
            const searchText = search.toLowerCase();
            options = options.filter((option)=>option.label?.toLowerCase().includes(searchText));
        }
        callback({
            options: options,
            totalCount: options.length
        });
    };
    const handleChange = (options)=>{
        const nextSelectedTags = $0a6763f4898e1dbe$export$8009508cf988d06b(options) ?? [];
        dispatch({
            type: 'FILTER_TAG_SELECT',
            payload: {
                selectedTags: nextSelectedTags.length > 0 ? nextSelectedTags : null
            }
        });
        // Send analytics event
        const nextSelectedTagsString = nextSelectedTags.length > 0 ? nextSelectedTags.map((t)=>t.id).join(',') : undefined;
        sendUIEvent((0, $3e8e9266fe04abe4$export$73f866ce8175509a).ui.appUpdatesTagFilterClicked({
            source: 'appUpdatesListScreen'
        }, nextSelectedTagsString).data);
    };
    return {
        testId: 'app-updates-filter-tag-testid',
        fieldLabel: formatMessage($0a6763f4898e1dbe$export$defe85febe8b728c.contextualTags),
        fieldId: 'app-updates-table-tag-filter',
        value: getSelectedTags(),
        onLoadOptions: onLoadOptions,
        onChange: handleChange,
        onClearValues: ()=>handleChange([])
    };
};


const $ac017e5cb269e227$var$messages = (0, $7e94896e68874ec2$export$1adfeb024f5185b)({
    searchLabel: {
        id: 'appUpdates.search.label',
        defaultMessage: 'Search release notes',
        description: 'Accessibility label for search input'
    },
    searchPlaceholder: {
        id: 'appUpdates.search.placeholder',
        defaultMessage: 'Search release notes',
        description: 'Placeholder text for search input'
    },
    recentlyPublished: {
        id: 'appUpdates.filters.recentlyPublished.label-nonfinal',
        description: 'Label for the new this week filter chip',
        defaultMessage: 'New this week'
    }
});
// Applied as local calendar days, so the resulting UTC boundary shifts by an
// hour across DST transitions. Close enough for a "recently published" filter.
const $ac017e5cb269e227$var$RECENTLY_PUBLISHED_WINDOW_DAYS = 7;
const $ac017e5cb269e227$export$45b86b24f7ea71e5 = 'app-updates-recently-published-filter';
const $ac017e5cb269e227$var$toBooleanFilter = (option)=>option === true;
const $ac017e5cb269e227$export$29b5614fa0522278 = ()=>{
    const { formatMessage: formatMessage } = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    const { state: state, dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { syncFiltersToUrl: syncFiltersToUrl } = (0, $11c628b62cd1de28$export$20b4f4827168badb)();
    const { sendUIEvent: sendUIEvent } = (0, $a442bdf486731fcc$export$62b6ee20d27ead99)();
    const [filterControllerKey, setFilterControllerKey] = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(0);
    const shouldIgnoreNextApplyRef = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(false);
    const productFilterConfig = (0, $0353f38be7f82b7e$export$f3a31e95d972a8e5)();
    const statusFilterConfig = (0, $06fb2ec62866f55e$export$df18f74ac650c683)();
    const changeTypeFilterConfig = (0, $97df1e5bc15c5140$export$95da0a36a388a53)();
    const impactRatingFilterConfig = (0, $03086a167d2bae2b$export$48a3c8af3e952f18)();
    const tagFilterConfig = (0, $0a6763f4898e1dbe$export$f65a9db96a965347)();
    const getChangeTypesFromOptions = (0, $97df1e5bc15c5140$export$27eea02c1dddba97)();
    const { draftFilters: draftFilters } = state.updates;
    const shouldShowTagFilter = (0, $c78886f48293f91c$export$b40ec24ac8275656)((0, $86626a3c150b02ba$export$5fb62a9fe732a843).contextualTagsBeta);
    const filters = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(()=>{
        const nextFilters = [
            {
                type: 'toggle',
                fieldId: $ac017e5cb269e227$export$45b86b24f7ea71e5,
                fieldLabel: formatMessage($ac017e5cb269e227$var$messages.recentlyPublished),
                value: Boolean(draftFilters.effectiveFrom),
                defaultValue: false,
                onChange: (isSelected)=>{
                    dispatch({
                        type: 'FILTER_EFFECTIVE_FROM_TOGGLE',
                        payload: {
                            effectiveFrom: isSelected ? (0, $c560af1483547aa3$export$70823084e2deb1ea)(new Date(), $ac017e5cb269e227$var$RECENTLY_PUBLISHED_WINDOW_DAYS).toISOString() : null
                        }
                    });
                },
                testId: $ac017e5cb269e227$export$45b86b24f7ea71e5
            },
            productFilterConfig,
            statusFilterConfig,
            changeTypeFilterConfig,
            impactRatingFilterConfig
        ];
        if (shouldShowTagFilter) nextFilters.push(tagFilterConfig);
        return nextFilters;
    }, [
        changeTypeFilterConfig,
        dispatch,
        draftFilters.effectiveFrom,
        formatMessage,
        impactRatingFilterConfig,
        productFilterConfig,
        shouldShowTagFilter,
        statusFilterConfig,
        tagFilterConfig
    ]);
    const handleApply = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback((values)=>{
        const effectiveFrom = $ac017e5cb269e227$var$toBooleanFilter(values.filters[$ac017e5cb269e227$export$45b86b24f7ea71e5]) ? draftFilters.effectiveFrom : null;
        const selectedProducts = (0, $0353f38be7f82b7e$export$aefc16b6a6a9a2d0)((0, $3b930b34264f8f14$export$e4cfc23fa7ee5916)(values.filters[productFilterConfig.fieldId]));
        const selectedStatuses = (0, $06fb2ec62866f55e$export$4d0ee99557dd065b)((0, $3b930b34264f8f14$export$e4cfc23fa7ee5916)(values.filters[statusFilterConfig.fieldId]));
        const selectedChangeTypes = getChangeTypesFromOptions((0, $3b930b34264f8f14$export$e4cfc23fa7ee5916)(values.filters[changeTypeFilterConfig.fieldId]));
        const selectedImpactRatings = (0, $03086a167d2bae2b$export$745a9101a774f6a4)((0, $3b930b34264f8f14$export$e4cfc23fa7ee5916)(values.filters[impactRatingFilterConfig.fieldId]));
        const selectedTags = shouldShowTagFilter ? (0, $0a6763f4898e1dbe$export$8009508cf988d06b)((0, $3b930b34264f8f14$export$e4cfc23fa7ee5916)(values.filters[tagFilterConfig.fieldId])) : null;
        const searchQuery = values.searchText || null;
        dispatch({
            type: 'FILTER_EFFECTIVE_FROM_TOGGLE',
            payload: {
                effectiveFrom: effectiveFrom
            }
        });
        dispatch({
            type: 'FILTER_APP_SELECT',
            payload: {
                selectedProducts: selectedProducts
            }
        });
        dispatch({
            type: 'FILTER_STATUS_SELECT',
            payload: {
                selectedStatuses: selectedStatuses
            }
        });
        dispatch({
            type: 'FILTER_CHANGE_TYPE_SELECT',
            payload: {
                selectedChangeTypes: selectedChangeTypes
            }
        });
        dispatch({
            type: 'FILTER_IMPACT_RATING_SELECT',
            payload: {
                selectedImpactRatings: selectedImpactRatings
            }
        });
        if (shouldShowTagFilter || draftFilters.selectedTags) dispatch({
            type: 'FILTER_TAG_SELECT',
            payload: {
                selectedTags: selectedTags
            }
        });
        dispatch({
            type: 'FILTER_SEARCH_SELECT',
            payload: {
                searchQuery: searchQuery
            }
        });
        syncFiltersToUrl({
            selectedProducts: selectedProducts,
            selectedStatuses: selectedStatuses,
            selectedChangeTypes: selectedChangeTypes,
            selectedImpactRatings: selectedImpactRatings,
            selectedTags: selectedTags,
            searchQuery: searchQuery,
            effectiveFrom: effectiveFrom,
            cursor: undefined
        });
        dispatch({
            type: 'UPDATES_FILTERS_APPLY'
        });
        sendUIEvent((0, $3e8e9266fe04abe4$export$73f866ce8175509a).ui.appUpdatesApplyClicked({
            source: 'appUpdatesListScreen'
        }, selectedProducts?.map((p)=>p.id).join(','), selectedStatuses?.map((s)=>s.id).join(','), selectedChangeTypes?.map((c)=>c.id).join(','), searchQuery ?? undefined).data);
    }, [
        changeTypeFilterConfig.fieldId,
        dispatch,
        draftFilters.effectiveFrom,
        draftFilters.selectedTags,
        getChangeTypesFromOptions,
        impactRatingFilterConfig.fieldId,
        productFilterConfig.fieldId,
        sendUIEvent,
        shouldShowTagFilter,
        statusFilterConfig.fieldId,
        syncFiltersToUrl,
        tagFilterConfig.fieldId
    ]);
    const handleReset = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(()=>{
        shouldIgnoreNextApplyRef.current = true;
        syncFiltersToUrl({
            selectedProducts: null,
            selectedStatuses: null,
            selectedChangeTypes: null,
            selectedImpactRatings: null,
            selectedTags: null,
            searchQuery: null,
            effectiveFrom: null,
            cursor: undefined
        });
        dispatch({
            type: 'UPDATES_FILTERS_RESET'
        });
        setFilterControllerKey((currentKey)=>currentKey + 1);
    }, [
        dispatch,
        syncFiltersToUrl
    ]);
    const handleFilterControllerApply = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback((values)=>{
        if (shouldIgnoreNextApplyRef.current) {
            shouldIgnoreNextApplyRef.current = false;
            return;
        }
        handleApply(values);
    }, [
        handleApply
    ]);
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $e264e74c775f2cfb$export$2e2bcd8739ae039), {
        testId: "app-updates-table-filters",
        filters: filters,
        isManual: true,
        hideItemsCountFooter: true,
        maxVisibleFilters: Infinity,
        itemsCount: state.updates.data.length,
        onApply: handleFilterControllerApply,
        onReset: handleReset,
        searchInput: draftFilters.searchQuery ?? '',
        searchInputAriaLabel: formatMessage($ac017e5cb269e227$var$messages.searchLabel),
        searchPlaceholder: formatMessage($ac017e5cb269e227$var$messages.searchPlaceholder)
    }, filterControllerKey);
};
var $ac017e5cb269e227$export$2e2bcd8739ae039 = $ac017e5cb269e227$export$29b5614fa0522278;




var $5FkrB = parcelRequire("5FkrB");








var $4Pn6z = parcelRequire("4Pn6z");
var $gDiFE = parcelRequire("gDiFE");



const $a090b4efeb4bbee0$var$messages = (0, $7e94896e68874ec2$export$1adfeb024f5185b)({
    product: {
        id: 'appUpdates.bundles.filters.product.label',
        description: 'Label for the bundled changes product filter',
        defaultMessage: 'App'
    }
});
const $a090b4efeb4bbee0$var$productOptionStyles = (0, $gDiFE.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100',
    minHeight: '24px',
    overflow: 'hidden'
});
const $a090b4efeb4bbee0$export$87b60c0f836dbed9 = (options)=>{
    const selectedProductValues = options.map((option)=>({
            id: String(option.value),
            name: option.label
        }));
    return selectedProductValues.length > 0 ? selectedProductValues : null;
};
const $a090b4efeb4bbee0$export$a0ef55cd39c58e31 = ()=>{
    const { formatMessage: formatMessage } = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    const { state: state, dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { productOptions: productOptions, isLoading: isLoading } = (0, $2c8a3e2d136767dc$export$141b75908cb447a9)('RELEASE_TRACK');
    const getSelectedProducts = ()=>{
        const selectedProducts = state.bundles.draftFilters.selectedProducts;
        if (!selectedProducts || selectedProducts.length === 0) return [];
        return selectedProducts.map((selectedProduct)=>productOptions.find((option)=>option.value === selectedProduct.id)).filter((option)=>option !== undefined);
    };
    const onProductFilterChange = (options)=>{
        const selectedProductValues = $a090b4efeb4bbee0$export$87b60c0f836dbed9(options);
        dispatch({
            type: 'BUNDLE_FILTER_APP_SELECT',
            payload: {
                selectedProducts: selectedProductValues
            }
        });
    // TODO: analytics — fire bundled-changes app filter event (specifics TBD).
    };
    const formatProduct = (option)=>{
        return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $4Pn6z.Box), {
            as: "div",
            xcss: $a090b4efeb4bbee0$var$productOptionStyles,
            testId: `bundle-app-filter-option-${option.value}`,
            children: [
                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $7397f708924e0bda$export$1a199e029d5e93d6), {
                    productType: option.value,
                    size: "xsmall",
                    testId: `bundle-app-icon-${option.value}`
                }),
                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                    as: "span",
                    children: option.label
                })
            ]
        });
    };
    const onLoadOptions = (search, _enableFullList, _showFullList, _showMore, _lastOption, callback)=>{
        let options = productOptions.map((option)=>({
                label: option.label,
                value: option.value,
                optionType: 'option'
            }));
        if (search) {
            const searchText = search.toLowerCase();
            options = options.filter((option)=>option.label?.toLowerCase().includes(searchText));
        }
        callback({
            options: options,
            totalCount: options.length
        });
    };
    return {
        testId: 'app-updates-bundle-filter-product-app-testid',
        fieldLabel: formatMessage($a090b4efeb4bbee0$var$messages.product),
        fieldId: 'app-updates-bundle-app-filter',
        onLoadOptions: onLoadOptions,
        value: getSelectedProducts(),
        onChange: onProductFilterChange,
        onClearValues: ()=>onProductFilterChange([]),
        formatOptionLabel: formatProduct,
        isLoading: isLoading
    };
};




/**
 * Utility functions for date formatting and manipulation using date-fns
 */ const $0c2978f9f2ea578c$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $0c2978f9f2ea578c$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $0c2978f9f2ea578c$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};


function $a64aa5765de2bf4d$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $c94070cd03a076f0$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $c94070cd03a076f0$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $c94070cd03a076f0$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $c94070cd03a076f0$export$cbf60ecb96cbb82f = {
    date: (0, $a64aa5765de2bf4d$export$38e44e97ce4dbb7d)({
        formats: $c94070cd03a076f0$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $a64aa5765de2bf4d$export$38e44e97ce4dbb7d)({
        formats: $c94070cd03a076f0$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $a64aa5765de2bf4d$export$38e44e97ce4dbb7d)({
        formats: $c94070cd03a076f0$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $6e790b9989824295$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $6e790b9989824295$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$6e790b9989824295$var$formatRelativeLocale[token];


/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $2d65a8ecd5b1f1a5$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $492182b1e9fcc149$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $492182b1e9fcc149$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $492182b1e9fcc149$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $492182b1e9fcc149$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $492182b1e9fcc149$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $492182b1e9fcc149$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $492182b1e9fcc149$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $492182b1e9fcc149$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $492182b1e9fcc149$var$ordinalNumber,
    era: (0, $2d65a8ecd5b1f1a5$export$63596d6ee8878b25)({
        values: $492182b1e9fcc149$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2d65a8ecd5b1f1a5$export$63596d6ee8878b25)({
        values: $492182b1e9fcc149$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $2d65a8ecd5b1f1a5$export$63596d6ee8878b25)({
        values: $492182b1e9fcc149$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2d65a8ecd5b1f1a5$export$63596d6ee8878b25)({
        values: $492182b1e9fcc149$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2d65a8ecd5b1f1a5$export$63596d6ee8878b25)({
        values: $492182b1e9fcc149$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $492182b1e9fcc149$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


function $0c4b48d8997fdd18$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $0c4b48d8997fdd18$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $0c4b48d8997fdd18$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $0c4b48d8997fdd18$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $0c4b48d8997fdd18$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $59cd200f0058c5b5$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $68d6cbd5078118e3$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $68d6cbd5078118e3$var$parseOrdinalNumberPattern = /\d+/i;
const $68d6cbd5078118e3$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $68d6cbd5078118e3$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $68d6cbd5078118e3$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $68d6cbd5078118e3$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $68d6cbd5078118e3$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $68d6cbd5078118e3$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $68d6cbd5078118e3$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $68d6cbd5078118e3$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $68d6cbd5078118e3$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $68d6cbd5078118e3$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $68d6cbd5078118e3$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $59cd200f0058c5b5$export$fdaf2fd6d7edde95)({
        matchPattern: $68d6cbd5078118e3$var$matchOrdinalNumberPattern,
        parsePattern: $68d6cbd5078118e3$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $0c4b48d8997fdd18$export$1430a0f35710914d)({
        matchPatterns: $68d6cbd5078118e3$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $68d6cbd5078118e3$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $0c4b48d8997fdd18$export$1430a0f35710914d)({
        matchPatterns: $68d6cbd5078118e3$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $68d6cbd5078118e3$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $0c4b48d8997fdd18$export$1430a0f35710914d)({
        matchPatterns: $68d6cbd5078118e3$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $68d6cbd5078118e3$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $0c4b48d8997fdd18$export$1430a0f35710914d)({
        matchPatterns: $68d6cbd5078118e3$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $68d6cbd5078118e3$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $0c4b48d8997fdd18$export$1430a0f35710914d)({
        matchPatterns: $68d6cbd5078118e3$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $68d6cbd5078118e3$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $3b57ff3c487df776$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $0c2978f9f2ea578c$export$2c14ff85d6318973),
    formatLong: (0, $c94070cd03a076f0$export$cbf60ecb96cbb82f),
    formatRelative: (0, $6e790b9989824295$export$8fbbfd65594f46a0),
    localize: (0, $492182b1e9fcc149$export$b3bd0bc58e36cd63),
    match: (0, $68d6cbd5078118e3$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$3b57ff3c487df776$export$2e2bcd8739ae039 = $3b57ff3c487df776$export$137380d9ce54f7f;


let $bf9c801acf3f0ebd$var$defaultOptions = {};
function $bf9c801acf3f0ebd$export$430a3269e24b912e() {
    return $bf9c801acf3f0ebd$var$defaultOptions;
}
function $bf9c801acf3f0ebd$export$95365be1b0704abc(newOptions) {
    $bf9c801acf3f0ebd$var$defaultOptions = newOptions;
}



function $09bb362b81ba08c3$export$113002b5eff6e430(date) {
    const _date = (0, $1c71cd1e0e1aa409$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}



function $7d237edc269994d1$export$9f53b88e82f64d8d(context, ...dates) {
    const normalize = (0, $0cb18d37664e0c78$export$ead8a1812b171991).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}




function $6f0525cfeb3e8cea$export$63fa379ae8a9ba2(date, options) {
    const _date = (0, $1c71cd1e0e1aa409$export$e67a095c620b86fe)(date, options?.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$6f0525cfeb3e8cea$export$2e2bcd8739ae039 = $6f0525cfeb3e8cea$export$63fa379ae8a9ba2;


function $2b2d7377da3d2a20$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $7d237edc269994d1$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const laterStartOfDay = (0, $6f0525cfeb3e8cea$export$63fa379ae8a9ba2)(laterDate_);
    const earlierStartOfDay = (0, $6f0525cfeb3e8cea$export$63fa379ae8a9ba2)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, $09bb362b81ba08c3$export$113002b5eff6e430)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, $09bb362b81ba08c3$export$113002b5eff6e430)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $fc9e4eeab8790eaa$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$2b2d7377da3d2a20$export$2e2bcd8739ae039 = $2b2d7377da3d2a20$export$4a02e9c37dab4871;



function $ef0ea45a0eaea4b6$export$f91e89d3d0406102(date, options) {
    const date_ = (0, $1c71cd1e0e1aa409$export$e67a095c620b86fe)(date, options?.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$ef0ea45a0eaea4b6$export$2e2bcd8739ae039 = $ef0ea45a0eaea4b6$export$f91e89d3d0406102;



function $e59c7c846ffb22f4$export$d3b42cd8452deec(date, options) {
    const _date = (0, $1c71cd1e0e1aa409$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $2b2d7377da3d2a20$export$4a02e9c37dab4871)(_date, (0, $ef0ea45a0eaea4b6$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$e59c7c846ffb22f4$export$2e2bcd8739ae039 = $e59c7c846ffb22f4$export$d3b42cd8452deec;





function $1648cf21917597fe$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $bf9c801acf3f0ebd$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $1c71cd1e0e1aa409$export$e67a095c620b86fe)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$1648cf21917597fe$export$2e2bcd8739ae039 = $1648cf21917597fe$export$42c81a444fbfb5d4;


function $ea552feffdd22be0$export$6173213f95a4431e(date, options) {
    return (0, $1648cf21917597fe$export$42c81a444fbfb5d4)(date, {
        ...options,
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$ea552feffdd22be0$export$2e2bcd8739ae039 = $ea552feffdd22be0$export$6173213f95a4431e;






function $a8118f42dfc4f71f$export$3dbc52535f6f8fcc(date, options) {
    const _date = (0, $1c71cd1e0e1aa409$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $0cb18d37664e0c78$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $ea552feffdd22be0$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $0cb18d37664e0c78$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $ea552feffdd22be0$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$a8118f42dfc4f71f$export$2e2bcd8739ae039 = $a8118f42dfc4f71f$export$3dbc52535f6f8fcc;



function $c0a55abcb800ff9f$export$236bdfa374eb69a9(date, options) {
    const year = (0, $a8118f42dfc4f71f$export$3dbc52535f6f8fcc)(date, options);
    const fourthOfJanuary = (0, $0cb18d37664e0c78$export$ead8a1812b171991)(options?.in || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $ea552feffdd22be0$export$6173213f95a4431e)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$c0a55abcb800ff9f$export$2e2bcd8739ae039 = $c0a55abcb800ff9f$export$236bdfa374eb69a9;



function $e7b0fdc031b86a97$export$7cabdc5698b63e2f(date, options) {
    const _date = (0, $1c71cd1e0e1aa409$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $ea552feffdd22be0$export$6173213f95a4431e)(_date) - +(0, $c0a55abcb800ff9f$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $fc9e4eeab8790eaa$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$e7b0fdc031b86a97$export$2e2bcd8739ae039 = $e7b0fdc031b86a97$export$7cabdc5698b63e2f;











function $1fbb1b0cc8c89d53$export$12d572480ceb6e58(date, options) {
    const _date = (0, $1c71cd1e0e1aa409$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, $bf9c801acf3f0ebd$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $0cb18d37664e0c78$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $1648cf21917597fe$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $0cb18d37664e0c78$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $1648cf21917597fe$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$1fbb1b0cc8c89d53$export$2e2bcd8739ae039 = $1fbb1b0cc8c89d53$export$12d572480ceb6e58;



function $2b1dea03bae045ce$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $bf9c801acf3f0ebd$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $1fbb1b0cc8c89d53$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $0cb18d37664e0c78$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $1648cf21917597fe$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$2b1dea03bae045ce$export$2e2bcd8739ae039 = $2b1dea03bae045ce$export$bb7b45bb8e74da0f;



function $fdd7bfa6325dbdff$export$efe19b760242b2fc(date, options) {
    const _date = (0, $1c71cd1e0e1aa409$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $1648cf21917597fe$export$42c81a444fbfb5d4)(_date, options) - +(0, $2b1dea03bae045ce$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $fc9e4eeab8790eaa$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$fdd7bfa6325dbdff$export$2e2bcd8739ae039 = $fdd7bfa6325dbdff$export$efe19b760242b2fc;



function $ec9a63bbb51bc78b$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}



const $547a0cf6f27ba407$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


const $b805d473183b3745$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $b805d473183b3745$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $547a0cf6f27ba407$export$b0d4b338e1516f13).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $1fbb1b0cc8c89d53$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $a8118f42dfc4f71f$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $547a0cf6f27ba407$export$b0d4b338e1516f13).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $fdd7bfa6325dbdff$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $e7b0fdc031b86a97$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $547a0cf6f27ba407$export$b0d4b338e1516f13).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $e59c7c846ffb22f4$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $b805d473183b3745$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $b805d473183b3745$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $b805d473183b3745$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $b805d473183b3745$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $b805d473183b3745$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $b805d473183b3745$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $547a0cf6f27ba407$export$b0d4b338e1516f13).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $547a0cf6f27ba407$export$b0d4b338e1516f13).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $547a0cf6f27ba407$export$b0d4b338e1516f13).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $547a0cf6f27ba407$export$b0d4b338e1516f13).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $547a0cf6f27ba407$export$b0d4b338e1516f13).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $b805d473183b3745$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $b805d473183b3745$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $b805d473183b3745$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $b805d473183b3745$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $b805d473183b3745$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $b805d473183b3745$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $b805d473183b3745$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $b805d473183b3745$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $b805d473183b3745$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $b805d473183b3745$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(+date, token.length);
    }
};
function $b805d473183b3745$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(minutes, 2);
}
function $b805d473183b3745$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $b805d473183b3745$var$formatTimezone(offset, delimiter);
}
function $b805d473183b3745$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $ec9a63bbb51bc78b$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


const $b1afff17bc1ad2c5$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $b1afff17bc1ad2c5$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $b1afff17bc1ad2c5$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $b1afff17bc1ad2c5$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $b1afff17bc1ad2c5$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $b1afff17bc1ad2c5$var$timeLongFormatter(timePattern, formatLong));
};
const $b1afff17bc1ad2c5$export$70cc8fd02856fd58 = {
    p: $b1afff17bc1ad2c5$var$timeLongFormatter,
    P: $b1afff17bc1ad2c5$var$dateTimeLongFormatter
};


const $f9941156379c229c$var$dayOfYearTokenRE = /^D+$/;
const $f9941156379c229c$var$weekYearTokenRE = /^Y+$/;
const $f9941156379c229c$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $f9941156379c229c$export$c6cc36aa33304772(token) {
    return $f9941156379c229c$var$dayOfYearTokenRE.test(token);
}
function $f9941156379c229c$export$c6b49d6dceb604a1(token) {
    return $f9941156379c229c$var$weekYearTokenRE.test(token);
}
function $f9941156379c229c$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $f9941156379c229c$var$message(token, format, input);
    console.warn(_message);
    if ($f9941156379c229c$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $f9941156379c229c$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $fed37e65d34cbfb1$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$fed37e65d34cbfb1$export$2e2bcd8739ae039 = $fed37e65d34cbfb1$export$871608497c498473;



function $d88837c3794387e6$export$1ea939691cdc45b8(date) {
    return !(!(0, $fed37e65d34cbfb1$export$871608497c498473)(date) && typeof date !== "number" || isNaN(+(0, $1c71cd1e0e1aa409$export$e67a095c620b86fe)(date)));
}
var // Fallback for modularized imports:
$d88837c3794387e6$export$2e2bcd8739ae039 = $d88837c3794387e6$export$1ea939691cdc45b8;



// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $45defc032b7e051e$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $45defc032b7e051e$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $45defc032b7e051e$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $45defc032b7e051e$var$doubleQuoteRegExp = /''/g;
const $45defc032b7e051e$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $45defc032b7e051e$export$d9468344d3651243(date, formatStr, options) {
    const defaultOptions = (0, $bf9c801acf3f0ebd$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $3b57ff3c487df776$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $1c71cd1e0e1aa409$export$e67a095c620b86fe)(date, options?.in);
    if (!(0, $d88837c3794387e6$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($45defc032b7e051e$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $b1afff17bc1ad2c5$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($45defc032b7e051e$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $45defc032b7e051e$var$cleanEscapedString(substring)
        };
        if ((0, $b805d473183b3745$export$fe98a034cfb96d55)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($45defc032b7e051e$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $f9941156379c229c$export$c6b49d6dceb604a1)(token) || !options?.useAdditionalDayOfYearTokens && (0, $f9941156379c229c$export$c6cc36aa33304772)(token)) (0, $f9941156379c229c$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        const formatter = (0, $b805d473183b3745$export$fe98a034cfb96d55)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $45defc032b7e051e$var$cleanEscapedString(input) {
    const matched = input.match($45defc032b7e051e$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($45defc032b7e051e$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$45defc032b7e051e$export$2e2bcd8739ae039 = $45defc032b7e051e$export$d9468344d3651243;


function $dc0b5cf0aeb86d21$export$eecd5dfd0530be5c(dateString) {
    const [year, month, day] = dateString.split('-').map(Number);
    if (!year || !month || !day) return dateString;
    return (0, $45defc032b7e051e$export$d9468344d3651243)(new Date(year, month - 1, day), 'MMM d, yyyy');
}



const $55bb354f4abea7c3$var$messages = (0, $7e94896e68874ec2$export$1adfeb024f5185b)({
    bundleDate: {
        id: 'appUpdates.bundles.filters.bundleDate.label',
        description: 'Label for the bundle date filter',
        defaultMessage: 'Preview release date'
    }
});
const $55bb354f4abea7c3$export$32ff78f53856055 = 'app-updates-bundle-date-filter';
const $55bb354f4abea7c3$export$f17cb979138ccc2b = (date)=>({
        label: (0, $dc0b5cf0aeb86d21$export$eecd5dfd0530be5c)(date),
        value: date,
        optionType: 'option'
    });
const $55bb354f4abea7c3$export$e2bced525e6d71bb = (options)=>{
    const latest = options.length > 0 ? options[options.length - 1] : null;
    return latest ? String(latest.value) : null;
};
const $55bb354f4abea7c3$export$cc08558562cb2c70 = ()=>{
    const { formatMessage: formatMessage } = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    const { state: state, dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const selectedBundleDate = state.bundles.draftFilters.selectedBundleDate;
    const selectedProducts = state.bundles.draftFilters.selectedProducts;
    const { allBundleDates: bundleDates, isLoading: isLoading } = (0, $a4311b03a11a743e$export$9a76656633d800c0)(selectedProducts);
    const getSelectedValue = ()=>selectedBundleDate ? [
            $55bb354f4abea7c3$export$f17cb979138ccc2b(selectedBundleDate)
        ] : [];
    // PaginatedFilter is inherently multi-select; enforce single-select by keeping
    // only the most recently chosen option.
    const onBundleDateChange = (options)=>{
        dispatch({
            type: 'BUNDLE_FILTER_DATE_SELECT',
            payload: {
                selectedBundleDate: $55bb354f4abea7c3$export$e2bced525e6d71bb(options)
            }
        });
    };
    const onLoadOptions = (search, _enableFullList, _showFullList, _showMore, _lastOption, callback)=>{
        let options = bundleDates.map($55bb354f4abea7c3$export$f17cb979138ccc2b);
        if (search) {
            const searchText = search.toLowerCase();
            options = options.filter((option)=>option.label?.toLowerCase().includes(searchText));
        }
        callback({
            options: options,
            totalCount: options.length
        });
    };
    return {
        testId: 'app-updates-bundle-filter-date-testid',
        fieldId: $55bb354f4abea7c3$export$32ff78f53856055,
        fieldLabel: formatMessage($55bb354f4abea7c3$var$messages.bundleDate),
        onLoadOptions: onLoadOptions,
        value: getSelectedValue(),
        onChange: onBundleDateChange,
        onClearValues: ()=>onBundleDateChange([]),
        isLoading: isLoading
    };
};


const $fb27fbb16aa94537$var$messages = (0, $7e94896e68874ec2$export$1adfeb024f5185b)({
    searchLabel: {
        id: 'appUpdates.bundles.search.label',
        defaultMessage: 'Search release notes',
        description: 'Accessibility label for bundled changes search input'
    },
    searchPlaceholder: {
        id: 'appUpdates.bundles.search.placeholder',
        defaultMessage: 'Search release notes',
        description: 'Placeholder text for bundled changes search input'
    }
});
const $fb27fbb16aa94537$export$ac34063c51bd3598 = ()=>{
    const { formatMessage: formatMessage } = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    const { state: state, dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { syncFiltersToUrl: syncFiltersToUrl } = (0, $8081251f610920d9$export$87ec4334ff1f5401)();
    const { latestBundleDate: latestBundleDate } = (0, $a4311b03a11a743e$export$9a76656633d800c0)(null);
    const [filterControllerKey, setFilterControllerKey] = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(0);
    const shouldIgnoreNextApplyRef = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(false);
    const productFilterConfig = (0, $a090b4efeb4bbee0$export$a0ef55cd39c58e31)();
    const dateFilterConfig = (0, $55bb354f4abea7c3$export$cc08558562cb2c70)();
    const { draftFilters: draftFilters } = state.bundles;
    const filters = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(()=>[
            productFilterConfig,
            {
                ...dateFilterConfig,
                isMulti: false,
                defaultValue: latestBundleDate ? [
                    (0, $55bb354f4abea7c3$export$f17cb979138ccc2b)(latestBundleDate)
                ] : []
            }
        ], [
        dateFilterConfig,
        latestBundleDate,
        productFilterConfig
    ]);
    const handleApply = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback((values)=>{
        const selectedProducts = (0, $a090b4efeb4bbee0$export$87b60c0f836dbed9)((0, $3b930b34264f8f14$export$e4cfc23fa7ee5916)(values.filters[productFilterConfig.fieldId]));
        const selectedBundleDate = (0, $55bb354f4abea7c3$export$e2bced525e6d71bb)((0, $3b930b34264f8f14$export$e4cfc23fa7ee5916)(values.filters[dateFilterConfig.fieldId]));
        const searchQuery = values.searchText || null;
        dispatch({
            type: 'BUNDLE_FILTER_APP_SELECT',
            payload: {
                selectedProducts: selectedProducts
            }
        });
        dispatch({
            type: 'BUNDLE_FILTER_DATE_SELECT',
            payload: {
                selectedBundleDate: selectedBundleDate
            }
        });
        dispatch({
            type: 'BUNDLE_FILTER_SEARCH_SELECT',
            payload: {
                searchQuery: searchQuery
            }
        });
        syncFiltersToUrl({
            selectedProducts: selectedProducts,
            selectedBundleDate: selectedBundleDate,
            searchQuery: searchQuery,
            cursor: undefined
        });
        dispatch({
            type: 'BUNDLES_FILTERS_APPLY'
        });
    }, [
        dateFilterConfig.fieldId,
        dispatch,
        productFilterConfig.fieldId,
        syncFiltersToUrl
    ]);
    const handleReset = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(()=>{
        shouldIgnoreNextApplyRef.current = true;
        syncFiltersToUrl({
            selectedProducts: null,
            selectedBundleDate: latestBundleDate,
            searchQuery: null,
            cursor: undefined
        });
        dispatch({
            type: 'BUNDLES_FILTERS_RESET',
            payload: {
                selectedBundleDate: latestBundleDate
            }
        });
        setFilterControllerKey((currentKey)=>currentKey + 1);
    }, [
        dispatch,
        latestBundleDate,
        syncFiltersToUrl
    ]);
    const handleFilterControllerApply = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback((values)=>{
        if (shouldIgnoreNextApplyRef.current) {
            shouldIgnoreNextApplyRef.current = false;
            return;
        }
        handleApply(values);
    }, [
        handleApply
    ]);
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $e264e74c775f2cfb$export$2e2bcd8739ae039), {
        testId: "app-updates-bundle-filters",
        filters: filters,
        isManual: true,
        hideItemsCountFooter: true,
        maxVisibleFilters: Infinity,
        itemsCount: state.bundles.data.length,
        onApply: handleFilterControllerApply,
        onReset: handleReset,
        searchInput: draftFilters.searchQuery ?? '',
        searchInputAriaLabel: formatMessage($fb27fbb16aa94537$var$messages.searchLabel),
        searchPlaceholder: formatMessage($fb27fbb16aa94537$var$messages.searchPlaceholder)
    }, filterControllerKey);
};





const $4981744843bb0981$export$f80c710216eae131 = ()=>{
    const { dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { syncFiltersToUrl: syncFiltersToUrl } = (0, $11c628b62cd1de28$export$20b4f4827168badb)();
    const setCursor = (0, $5FkrB.useCallback)((cursor)=>{
        dispatch({
            type: 'UPDATES_CURSOR_SET',
            payload: {
                cursor: cursor
            }
        });
        syncFiltersToUrl({
            cursor: cursor
        });
    }, [
        dispatch,
        syncFiltersToUrl
    ]);
    const setLimit = (0, $5FkrB.useCallback)((limit)=>{
        dispatch({
            type: 'UPDATES_LIMIT_SET',
            payload: {
                limit: limit
            }
        });
        syncFiltersToUrl({
            cursor: undefined,
            limit: limit
        });
    }, [
        dispatch,
        syncFiltersToUrl
    ]);
    return {
        setCursor: setCursor,
        setLimit: setLimit
    };
};





function $4dc43cb823211d24$export$a18c89cbd24170ff(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $7d237edc269994d1$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return laterDate_.getFullYear() === earlierDate_.getFullYear() && laterDate_.getMonth() === earlierDate_.getMonth();
}
var // Fallback for modularized imports:
$4dc43cb823211d24$export$2e2bcd8739ae039 = $4dc43cb823211d24$export$a18c89cbd24170ff;


function $69f51c59f68ab505$export$5841f9eb9773f25f(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $7d237edc269994d1$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return laterDate_.getFullYear() === earlierDate_.getFullYear();
}
var // Fallback for modularized imports:
$69f51c59f68ab505$export$2e2bcd8739ae039 = $69f51c59f68ab505$export$5841f9eb9773f25f;



var $ifpPH = parcelRequire("ifpPH");
const $373b864dc2406021$var$messages = (0, $7e94896e68874ec2$export$1adfeb024f5185b)({
    nullReleaseDate: {
        id: 'appUpdates.dateRangeInfo.noTimeframe',
        defaultMessage: 'No timeframe yet',
        description: 'Text shown when no release dates are defined'
    },
    startingIn: {
        id: 'appUpdates.dateRangeInfo.startingIn',
        defaultMessage: 'Starting in {startingDate}',
        description: 'Release window when only a start date is known, no day shown'
    },
    dateRange: {
        id: 'appUpdates.dateRangeInfo.dateRange',
        defaultMessage: '{dateStart} - {dateEnd}',
        description: 'Release window date range, e.g. "Mar - Apr 2024"'
    }
});
const $373b864dc2406021$export$c119e7a38ceabb6b = ({ startDate: startDate, endDate: endDate, status: status })=>{
    // For Generally Available status, show only the end date
    if (status === 'GENERALLY_AVAILABLE' && endDate) return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
        as: "span",
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $7e94896e68874ec2$export$40ae3194919d16b), {
            value: endDate,
            month: "long",
            year: "numeric"
        })
    });
    if (!startDate) return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
        as: "span",
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d8c258b384a9ab14$export$2e2bcd8739ae039), {
            ...$373b864dc2406021$var$messages.nullReleaseDate
        })
    });
    // Start date only — no end date known yet
    if (!endDate) return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
        as: "span",
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d8c258b384a9ab14$export$2e2bcd8739ae039), {
            ...$373b864dc2406021$var$messages.startingIn,
            values: {
                startingDate: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $7e94896e68874ec2$export$40ae3194919d16b), {
                    value: startDate,
                    month: "long",
                    year: "numeric"
                })
            }
        })
    });
    const start = new Date(startDate);
    const end = new Date(endDate);
    // Start + end in the same month — show just the month and year
    if ((0, $4dc43cb823211d24$export$a18c89cbd24170ff)(start, end)) return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
        as: "span",
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $7e94896e68874ec2$export$40ae3194919d16b), {
            value: startDate,
            month: "long",
            year: "numeric"
        })
    });
    // Different months — show a range; omit year from start if both are in the same year
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
        as: "span",
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d8c258b384a9ab14$export$2e2bcd8739ae039), {
            ...$373b864dc2406021$var$messages.dateRange,
            values: {
                dateStart: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $7e94896e68874ec2$export$40ae3194919d16b), {
                    value: startDate,
                    month: "short",
                    year: (0, $69f51c59f68ab505$export$5841f9eb9773f25f)(start, end) ? undefined : 'numeric'
                }),
                dateEnd: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $7e94896e68874ec2$export$40ae3194919d16b), {
                    value: endDate,
                    month: "short",
                    year: "numeric"
                })
            }
        })
    });
};
var $373b864dc2406021$export$2e2bcd8739ae039 = $373b864dc2406021$export$c119e7a38ceabb6b;




var $5FkrB = parcelRequire("5FkrB");


var $4Pn6z = parcelRequire("4Pn6z");
var $2kuK2 = parcelRequire("2kuK2");
var $ifX9g = parcelRequire("ifX9g");
var $ifpPH = parcelRequire("ifpPH");
var $gDiFE = parcelRequire("gDiFE");

var $jMKPI = parcelRequire("jMKPI");

var $dY97G = parcelRequire("dY97G");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e1c154d3dc3a0528$export$2e2bcd8739ae039 = (0, $dY97G.Popup);



const $04e2ab9a71aec03a$var$messages = (0, $7e94896e68874ec2$export$1adfeb024f5185b)({
    noProducts: {
        id: 'appUpdates.productList.noProducts',
        defaultMessage: 'No apps',
        description: 'Text displayed when no apps are associated with the update'
    },
    additionalProducts: {
        id: 'appUpdates.productList.additionalProducts',
        defaultMessage: '+{count}',
        description: 'Text for badge showing additional apps count'
    },
    additionalProductsAriaLabel: {
        id: 'appUpdates.productList.additionalProducts.ariaLabel',
        defaultMessage: 'Show {count} more products',
        description: 'Aria label for the additional products badge button'
    },
    additionalProductsTooltip: {
        id: 'appUpdates.productList.additionalProductsTooltip',
        defaultMessage: 'Additional apps',
        description: 'Tooltip title for additional apps'
    }
});
const $04e2ab9a71aec03a$var$styles = {
    container: (0, $gDiFE.xcss)({
        display: 'flex',
        alignItems: 'center',
        gap: 'space.100'
    }),
    additionalProductsBadge: (0, $gDiFE.xcss)({
        marginLeft: 'space.075'
    }),
    popupProduct: (0, $gDiFE.xcss)({
        display: 'flex',
        alignItems: 'center',
        gap: 'space.075',
        padding: 'space.025'
    }),
    popupContainer: (0, $gDiFE.xcss)({
        display: 'flex',
        flexDirection: 'column',
        gap: 'space.050',
        padding: 'space.100'
    }),
    popupTrigger: (0, $gDiFE.xcss)({
        backgroundColor: 'color.background.neutral.subtle',
        padding: 'space.0'
    })
};
const $04e2ab9a71aec03a$export$831fdf77aa2a6a18 = ({ productTypes: productTypes })=>{
    const { formatMessage: formatMessage } = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    const [isPopupOpen, setIsPopupOpen] = (0, $5FkrB.useState)(false);
    const closeTimeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(null);
    if (!productTypes || productTypes.length === 0) return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
        color: "color.text.subtlest",
        size: "small",
        children: formatMessage($04e2ab9a71aec03a$var$messages.noProducts)
    });
    // Sort products by priority so key products (e.g. Jira) are shown first
    const sortedProductTypes = (0, $ace4c485fd808422$export$e3760658a711f2d3)(productTypes);
    if (sortedProductTypes.length === 1) return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $2kuK2.Flex), {
        xcss: $04e2ab9a71aec03a$var$styles.container,
        testId: "product-list-single",
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $7397f708924e0bda$export$1a199e029d5e93d6), {
                productType: sortedProductTypes[0],
                size: "small",
                testId: "product-list-icon"
            }),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
                weight: "medium",
                color: "color.text",
                children: (0, $d3185276e14a4c2b$export$44fea6589b7ddc92)(sortedProductTypes[0])
            })
        ]
    });
    // For multiple products, show first product with icon + count badge with popup
    const [firstProductType, ...remainingProductTypes] = sortedProductTypes;
    const openPopup = ()=>{
        if (closeTimeoutRef.current) clearTimeout(closeTimeoutRef.current);
        setIsPopupOpen(true);
    };
    const closePopup = ()=>{
        closeTimeoutRef.current = setTimeout(()=>setIsPopupOpen(false), 150);
    };
    const getPopupContent = ()=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
            xcss: $04e2ab9a71aec03a$var$styles.popupContainer,
            testId: "additional-products-popup",
            onMouseEnter: openPopup,
            onMouseLeave: closePopup,
            children: remainingProductTypes.map((productType, index)=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $4Pn6z.Box), {
                    xcss: $04e2ab9a71aec03a$var$styles.popupProduct,
                    children: [
                        /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $7397f708924e0bda$export$1a199e029d5e93d6), {
                            productType: productType,
                            size: "small",
                            testId: `popup-product-icon-${index}`
                        }),
                        /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
                            color: "color.text",
                            children: (0, $d3185276e14a4c2b$export$44fea6589b7ddc92)(productType)
                        })
                    ]
                }, `${productType}-${index}`))
        });
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $2kuK2.Flex), {
        xcss: $04e2ab9a71aec03a$var$styles.container,
        testId: "product-list-multiple",
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $7397f708924e0bda$export$1a199e029d5e93d6), {
                productType: firstProductType,
                size: "small",
                testId: "product-list-primary-icon"
            }),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
                weight: "medium",
                color: "color.text",
                children: (0, $d3185276e14a4c2b$export$44fea6589b7ddc92)(firstProductType)
            }),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                xcss: $04e2ab9a71aec03a$var$styles.additionalProductsBadge,
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $e1c154d3dc3a0528$export$2e2bcd8739ae039), {
                    isOpen: isPopupOpen,
                    onClose: closePopup,
                    placement: "bottom-start",
                    content: getPopupContent,
                    testId: "additional-products-popup-trigger",
                    trigger: (triggerProps)=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifX9g.Pressable), {
                            ...triggerProps,
                            onMouseEnter: openPopup,
                            onMouseLeave: closePopup,
                            testId: "additional-products-badge-wrapper",
                            xcss: $04e2ab9a71aec03a$var$styles.popupTrigger,
                            "aria-label": formatMessage($04e2ab9a71aec03a$var$messages.additionalProductsAriaLabel, {
                                count: remainingProductTypes.length
                            }),
                            children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $jMKPI.default), {
                                appearance: "default",
                                testId: "additional-products-badge",
                                children: formatMessage($04e2ab9a71aec03a$var$messages.additionalProducts, {
                                    count: remainingProductTypes.length
                                })
                            })
                        })
                })
            })
        ]
    });
};




var $5FkrB = parcelRequire("5FkrB");


var $5supy = parcelRequire("5supy");

const $fe4fcc4b7b323fa4$var$getStatusDisplay = (status)=>{
    // Check if the status is a known StatusId
    const knownStatuses = [
        'COMING_SOON',
        'PLANNED',
        'ROLLING_OUT',
        'GENERALLY_AVAILABLE',
        'ROLLED_BACK'
    ];
    if (knownStatuses.includes(status)) {
        const statusId = status;
        const messageDescriptor = (0, $dafe8aa59b77d934$export$e238a77ea3a8cd66)(statusId);
        const appearance = (0, $dafe8aa59b77d934$export$548966735f47dde3)(statusId);
        return [
            /*#__PURE__*/ (0, $5FkrB.createElement)((0, $d8c258b384a9ab14$export$2e2bcd8739ae039), {
                ...messageDescriptor,
                key: messageDescriptor.id
            }),
            appearance
        ];
    }
    // Fallback for unknown statuses
    return [
        status,
        'default'
    ];
};
const $fe4fcc4b7b323fa4$export$330c774339d320ad = ({ status: status })=>{
    if (!status) return null;
    const [statusMsg, appearance] = $fe4fcc4b7b323fa4$var$getStatusDisplay(status);
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $5supy.default), {
        appearance: appearance,
        children: statusMsg
    });
};



parcelRequire("5FkrB");


var $4Pn6z = parcelRequire("4Pn6z");
var $gDiFE = parcelRequire("gDiFE");

var $5supy = parcelRequire("5supy");
const $d26747ad8d2a0268$var$lozengeWrapperStyles = (0, $gDiFE.xcss)({
    display: 'inline-flex'
});
const $d26747ad8d2a0268$var$messages = (0, $7e94896e68874ec2$export$1adfeb024f5185b)({
    high: {
        id: 'appUpdatesTable.impactRating.high',
        defaultMessage: 'High',
        description: 'High impact rating label'
    },
    medium: {
        id: 'appUpdatesTable.impactRating.medium',
        defaultMessage: 'Medium',
        description: 'Medium impact rating label'
    },
    low: {
        id: 'appUpdatesTable.impactRating.low',
        defaultMessage: 'Low',
        description: 'Low impact rating label'
    }
});
const $d26747ad8d2a0268$export$2a5158d64a074be2 = ({ impactRating: impactRating })=>{
    const { formatMessage: formatMessage } = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    if (!impactRating) return null;
    switch(impactRating){
        case 'HIGH':
            return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                xcss: $d26747ad8d2a0268$var$lozengeWrapperStyles,
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $5supy.default), {
                    appearance: "removed",
                    isBold: true,
                    children: formatMessage($d26747ad8d2a0268$var$messages.high)
                })
            });
        case 'MEDIUM':
            return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                xcss: $d26747ad8d2a0268$var$lozengeWrapperStyles,
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $5supy.default), {
                    appearance: "moved",
                    isBold: true,
                    children: formatMessage($d26747ad8d2a0268$var$messages.medium)
                })
            });
        case 'LOW':
            return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                xcss: $d26747ad8d2a0268$var$lozengeWrapperStyles,
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $5supy.default), {
                    appearance: "success",
                    isBold: true,
                    children: formatMessage($d26747ad8d2a0268$var$messages.low)
                })
            });
        default:
            return null;
    }
};



parcelRequire("5FkrB");

var $4Pn6z = parcelRequire("4Pn6z");
var $1qQas = parcelRequire("1qQas");
var $gDiFE = parcelRequire("gDiFE");

var $288ej = parcelRequire("288ej");

const $fbecf69dc9e04116$var$tagsContainerStyles = (0, $gDiFE.xcss)({
    maxWidth: '160px'
});
const $fbecf69dc9e04116$export$3c86caed05f80ae7 = ({ tags: tags })=>{
    if (!tags || tags.length === 0) return null;
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
        xcss: $fbecf69dc9e04116$var$tagsContainerStyles,
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $1qQas.Inline), {
            space: "space.050",
            shouldWrap: true,
            children: tags.map((tag)=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $288ej.default), {
                    text: (0, $51e43113ed6c9475$export$4bbe71e8edfbf0cd)(tag),
                    color: "standard",
                    isRemovable: false
                }, tag))
        })
    });
};




var $5FkrB = parcelRequire("5FkrB");


var $ifpPH = parcelRequire("ifpPH");

const $10eaae4bdfb59f21$export$1abc4eff6ef230bd = ({ type: type })=>{
    if (!type) return null;
    // Check if the type is a known ChangeTypeId
    const knownChangeTypes = [
        'IMPROVEMENT',
        'FIX',
        'EXPERIMENT',
        'REMOVED',
        'ANNOUNCEMENT'
    ];
    if (knownChangeTypes.includes(type)) {
        const changeTypeId = type;
        const messageDescriptor = (0, $5f43c72173f3a108$export$58d8d249a6136224)(changeTypeId);
        return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
            children: /*#__PURE__*/ (0, $5FkrB.createElement)((0, $d8c258b384a9ab14$export$2e2bcd8739ae039), {
                ...messageDescriptor,
                key: messageDescriptor.id
            })
        });
    }
    // Fallback for unknown change types
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
        children: type
    });
};





parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");

const $482ba924d5ad5f3a$export$c0feb0112f86aefc = 7;
const $482ba924d5ad5f3a$export$502a1fb2342439ae = 3000; // 3s
const $482ba924d5ad5f3a$export$d89e39edaf3286a8 = 'appUpdatesReadItems';
const $482ba924d5ad5f3a$export$6a9f7378365a81d = 'appUpdatesLastPruned';



const $15b90d5900f709a5$var$getStorage = ()=>{
    if (typeof window === 'undefined') return null;
    try {
        return window.localStorage;
    } catch  {
        return null;
    }
};
const $15b90d5900f709a5$var$readStorageItem = (key)=>{
    try {
        return $15b90d5900f709a5$var$getStorage()?.getItem(key) ?? null;
    } catch  {
        return null;
    }
};
const $15b90d5900f709a5$var$writeStorageItem = (key, value)=>{
    try {
        $15b90d5900f709a5$var$getStorage()?.setItem(key, value);
    } catch  {
    // localStorage may be unavailable or full; read state should never break UI.
    }
};
const $15b90d5900f709a5$export$d7e8c0a596a66888 = (date)=>{
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
/**
 * Convert a backend-supplied ISO 8601 timestamp into a canonical YYYY-MM-DD key
 * in the user's local timezone, so the unread window matches the calendar the
 * user actually sees.
 *
 * Returns null if the timestamp is not parseable.
 */ const $15b90d5900f709a5$var$parsePostDateKey = (postDate)=>{
    const date = new Date(postDate);
    if (Number.isNaN(date.getTime())) return null;
    return $15b90d5900f709a5$export$d7e8c0a596a66888(date);
};
const $15b90d5900f709a5$var$getUnreadBoundaryKey = ()=>{
    const today = new Date();
    return $15b90d5900f709a5$export$d7e8c0a596a66888(new Date(today.getFullYear(), today.getMonth(), today.getDate() - (0, $482ba924d5ad5f3a$export$c0feb0112f86aefc)));
};
const $15b90d5900f709a5$export$18302c496e8cdf66 = (firstPublishedAt)=>{
    const firstPublishedAtKey = $15b90d5900f709a5$var$parsePostDateKey(firstPublishedAt);
    if (firstPublishedAtKey === null) return false;
    return firstPublishedAtKey >= $15b90d5900f709a5$var$getUnreadBoundaryKey() && firstPublishedAtKey <= $15b90d5900f709a5$export$d7e8c0a596a66888(new Date());
};
const $15b90d5900f709a5$var$isReadEntry = (value)=>typeof value === 'object' && value !== null && typeof value.id === 'string' && typeof value.firstPublishedAt === 'string';
// Cache the parsed ids so the snapshot returns a stable reference until the raw
// string changes — required by useSyncExternalStore and keeps tearing protection.
let $15b90d5900f709a5$var$cachedRawValue = null;
let $15b90d5900f709a5$var$cachedReadIds = [];
const $15b90d5900f709a5$export$74893074ee6d7252 = ()=>{
    const rawValue = $15b90d5900f709a5$var$readStorageItem((0, $482ba924d5ad5f3a$export$d89e39edaf3286a8));
    if (rawValue !== $15b90d5900f709a5$var$cachedRawValue) {
        $15b90d5900f709a5$var$cachedRawValue = rawValue;
        $15b90d5900f709a5$var$cachedReadIds = $15b90d5900f709a5$export$36103693c78e100c();
    }
    return $15b90d5900f709a5$var$cachedReadIds;
};
const $15b90d5900f709a5$export$a5ef48a7b09fdcbd = ()=>{
    const storedValue = $15b90d5900f709a5$var$readStorageItem((0, $482ba924d5ad5f3a$export$d89e39edaf3286a8));
    if (storedValue === null) return [];
    try {
        const parsedValue = JSON.parse(storedValue);
        if (!Array.isArray(parsedValue)) return [];
        const seenIds = new Set();
        const entries = [];
        parsedValue.forEach((item)=>{
            if (!$15b90d5900f709a5$var$isReadEntry(item) || seenIds.has(item.id)) return;
            seenIds.add(item.id);
            entries.push({
                id: item.id,
                firstPublishedAt: item.firstPublishedAt
            });
        });
        return entries;
    } catch  {
        return [];
    }
};
const $15b90d5900f709a5$export$36103693c78e100c = ()=>$15b90d5900f709a5$export$a5ef48a7b09fdcbd().map((entry)=>entry.id);
const $15b90d5900f709a5$export$dc76bba8c4f0075f = ({ id: id, firstPublishedAt: firstPublishedAt })=>{
    const normalizedId = id.trim();
    // Don't persist invalid entries — a ReadEntry must have a usable date.
    if (normalizedId.length === 0 || $15b90d5900f709a5$var$parsePostDateKey(firstPublishedAt) === null) return;
    const entries = $15b90d5900f709a5$export$a5ef48a7b09fdcbd();
    if (entries.some((entry)=>entry.id === normalizedId)) return;
    $15b90d5900f709a5$var$writeStorageItem((0, $482ba924d5ad5f3a$export$d89e39edaf3286a8), JSON.stringify([
        ...entries,
        {
            id: normalizedId,
            firstPublishedAt: firstPublishedAt
        }
    ]));
    // The browser does not fire the 'storage' event for same-window writes, so
    // dispatch our own custom event to notify same-tab subscribers.
    try {
        window.dispatchEvent(new Event('unread-indicator-changed'));
    } catch  {
    // window may not be available in SSR — safe to skip.
    }
};
const $15b90d5900f709a5$export$504fbc0ef5c94afa = ()=>{
    const todayKey = $15b90d5900f709a5$export$d7e8c0a596a66888(new Date());
    // Short-circuit: already pruned today (cheap YYYY-MM-DD string compare).
    if ($15b90d5900f709a5$var$readStorageItem((0, $482ba924d5ad5f3a$export$6a9f7378365a81d)) === todayKey) return;
    const prunedEntries = $15b90d5900f709a5$export$a5ef48a7b09fdcbd().filter((entry)=>$15b90d5900f709a5$export$18302c496e8cdf66(entry.firstPublishedAt));
    $15b90d5900f709a5$var$writeStorageItem((0, $482ba924d5ad5f3a$export$d89e39edaf3286a8), JSON.stringify(prunedEntries));
    $15b90d5900f709a5$var$writeStorageItem((0, $482ba924d5ad5f3a$export$6a9f7378365a81d), todayKey);
};


// ---------------------------------------------------------------------------
// Subscription — wires useSyncExternalStore to localStorage changes.
//
// Two event sources are needed:
//   - 'storage': fired by the browser on all OTHER tabs when localStorage
//     changes. Gives us cross-tab sync for free. We filter by key so that
//     unrelated cross-tab writes (any other localStorage key) don't trigger
//     re-renders in every component using this hook.
//   - 'unread-indicator-changed': a custom event dispatched by addReadEntry()
//     after it writes. The browser does NOT fire 'storage' for same-window
//     writes, so we emit our own event to keep same-tab components in sync.
// ---------------------------------------------------------------------------
const $9aabdc1903d96d41$var$subscribe = (onStoreChange)=>{
    // Filter the cross-tab 'storage' event to only fire for our key. Note that
    // event.key is null when localStorage.clear() is called — we treat that as
    // a relevant change too, since it wipes our read set.
    const handleStorage = (event)=>{
        if (event.key === null || event.key === (0, $482ba924d5ad5f3a$export$d89e39edaf3286a8)) onStoreChange();
    };
    window.addEventListener('storage', handleStorage);
    window.addEventListener('unread-indicator-changed', onStoreChange);
    return ()=>{
        window.removeEventListener('storage', handleStorage);
        window.removeEventListener('unread-indicator-changed', onStoreChange);
    };
};
const $9aabdc1903d96d41$export$86ce72459a4312fa = ({ id: id, firstPublishedAt: firstPublishedAt })=>{
    const { analyticsOptOut: analyticsOptOut } = (0, $38056d680fac42ff$export$b224af886b957a5e)();
    // Subscribe to the external read-set store.
    const readIds = (0, $5FkrB.useSyncExternalStore)($9aabdc1903d96d41$var$subscribe, (0, $15b90d5900f709a5$export$74893074ee6d7252));
    const isUnread = !analyticsOptOut && (0, $15b90d5900f709a5$export$18302c496e8cdf66)(firstPublishedAt) && !readIds.includes(id);
    const markSeen = (0, $5FkrB.useCallback)(()=>{
        if (analyticsOptOut) return;
        (0, $15b90d5900f709a5$export$dc76bba8c4f0075f)({
            id: id,
            firstPublishedAt: firstPublishedAt
        });
    }, [
        analyticsOptOut,
        id,
        firstPublishedAt
    ]);
    return {
        isUnread: isUnread,
        markSeen: markSeen
    };
};



parcelRequire("5FkrB");


var $4mzlU = parcelRequire("4mzlU");

var $4Pn6z = parcelRequire("4Pn6z");
var $gDiFE = parcelRequire("gDiFE");

var $5yfDB = parcelRequire("5yfDB");


var $bNmp1 = parcelRequire("bNmp1");

var $9AP5g = parcelRequire("9AP5g");

var $3ZMUU = parcelRequire("3ZMUU");
function $37190500189da037$export$9e1725a4cfeada27(path, fallback) {
    var token = (0, $bNmp1.default)[path];
    typeof $3ZMUU;
    // if the token is not found - replacing it with variable name without any value, to avoid it being undefined which would result in invalid css
    if (!token) token = (0, $9AP5g.TOKEN_NOT_FOUND_CSS_VAR);
    var tokenCall = fallback ? "var(".concat(token, ", ").concat(fallback, ")") : "var(".concat(token, ")");
    return tokenCall;
}


const $55c2d94220e7f4ae$var$messages = (0, $7e94896e68874ec2$export$1adfeb024f5185b)({
    markAsRead: {
        id: 'app-updates-table.unread-dot.mark-as-read',
        defaultMessage: 'Mark as read'
    }
});
const $55c2d94220e7f4ae$var$styles = {
    dot: (0, $gDiFE.xcss)({
        width: (0, $37190500189da037$export$9e1725a4cfeada27)('space.100'),
        height: (0, $37190500189da037$export$9e1725a4cfeada27)('space.100'),
        borderRadius: 'radius.full',
        backgroundColor: 'color.background.accent.blue.bolder',
        display: 'block'
    })
};
const $55c2d94220e7f4ae$export$45b5aabab39395b1 = ({ onClick: onClick, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4mzlU.default), {
        content: formatMessage($55c2d94220e7f4ae$var$messages.markAsRead),
        position: "top",
        children: (tooltipProps)=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $5yfDB.default), {
                ...tooltipProps,
                testId: testId,
                appearance: "subtle",
                icon: (props)=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                        ...props,
                        xcss: $55c2d94220e7f4ae$var$styles.dot
                    }),
                spacing: "compact",
                onClick: onClick,
                label: formatMessage($55c2d94220e7f4ae$var$messages.markAsRead)
            })
    });
};


const $66d7da6dce257b40$export$8c779258b936559c = ({ id: id, firstPublishedAt: firstPublishedAt })=>{
    const { isUnread: isUnread, markSeen: markSeen } = (0, $9aabdc1903d96d41$export$86ce72459a4312fa)({
        id: id,
        firstPublishedAt: firstPublishedAt
    });
    if (!isUnread) return null;
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $55c2d94220e7f4ae$export$45b5aabab39395b1), {
        onClick: markSeen,
        testId: `unread-dot-${id}`
    });
};
var $66d7da6dce257b40$export$2e2bcd8739ae039 = $66d7da6dce257b40$export$8c779258b936559c;




var $5FkrB = parcelRequire("5FkrB");


var $4Pn6z = parcelRequire("4Pn6z");
var $1qQas = parcelRequire("1qQas");
var $ifX9g = parcelRequire("ifX9g");
var $ifpPH = parcelRequire("ifpPH");
var $gDiFE = parcelRequire("gDiFE");

var $5supy = parcelRequire("5supy");

var $cbf86129106492cc$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::388d023551f95beca5a809a51c9e3120>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($cbf86129106492cc$exports, "__esModule", {
    value: true
});
$cbf86129106492cc$exports.default = void 0;

var $cbf86129106492cc$var$_react = $cbf86129106492cc$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $cbf86129106492cc$var$_iconNew = $cbf86129106492cc$var$_interopRequireDefault((parcelRequire("gDzom")));
function $cbf86129106492cc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/atlassian-intelligence
 * Usage guidance:
 * Single purpose - Reserved for Atlassian Intelligence apps or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cbf86129106492cc$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $cbf86129106492cc$var$_react.default.createElement($cbf86129106492cc$var$_iconNew.default, Object.assign({
        name: "AtlassianIntelligenceIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 12v3h-1.5v-3zm-2.22-1.47-4 4-1.06-1.06 4-4zm8 2.94-1.06 1.06-4-4 1.06-1.06zM4 7.25v1.5H1v-1.5zm11 0v1.5h-3v-1.5zM6.53 5.47 5.47 6.53l-4-4 1.06-1.06zm8-2.94-4 4-1.06-1.06 4-4zM8.75 1v3h-1.5V1z"/>`
    }, props));
$cbf86129106492cc$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $cbf86129106492cc$var$_default = $cbf86129106492cc$exports.default = $cbf86129106492cc$var$AtlassianIntelligenceIcon;



const $9d0c6ca2818366fa$var$messages = (0, $7e94896e68874ec2$export$1adfeb024f5185b)({
    betaLabel: {
        id: 'appUpdates.aiDisclaimer.beta',
        defaultMessage: 'Beta',
        description: 'Beta label shown next to AI-generated content'
    },
    tooltipText: {
        id: 'appUpdates.aiDisclaimer.tooltipText',
        defaultMessage: 'Uses AI. Verify results.',
        description: 'Disclaimer body text shown in the tooltip next to AI-generated content (Beta lozenge prepended visually)'
    }
});
const $9d0c6ca2818366fa$var$wrapperStyles = (0, $gDiFE.xcss)({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 'space.050'
});
const $9d0c6ca2818366fa$var$triggerStyles = (0, $gDiFE.xcss)({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 'space.050',
    cursor: 'default',
    color: 'color.text',
    backgroundColor: 'color.background.neutral.subtle',
    padding: 'space.0',
    borderStyle: 'none'
});
const $9d0c6ca2818366fa$export$e0542ba0c737fe5c = ({ label: label })=>{
    const { formatMessage: formatMessage } = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    const betaLabel = formatMessage($9d0c6ca2818366fa$var$messages.betaLabel);
    const tooltipBody = formatMessage($9d0c6ca2818366fa$var$messages.tooltipText);
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const closeTimeoutRef = (0, $5FkrB.useRef)(null);
    const handleMouseEnter = (0, $5FkrB.useCallback)(()=>{
        if (closeTimeoutRef.current) {
            clearTimeout(closeTimeoutRef.current);
            closeTimeoutRef.current = null;
        }
        setIsOpen(true);
    }, []);
    const handleMouseLeave = (0, $5FkrB.useCallback)(()=>{
        closeTimeoutRef.current = setTimeout(()=>setIsOpen(false), 150);
    }, []);
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $1qQas.Inline), {
        xcss: $9d0c6ca2818366fa$var$wrapperStyles,
        testId: "ai-disclaimer",
        children: [
            label,
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $e1c154d3dc3a0528$export$2e2bcd8739ae039), {
                isOpen: isOpen,
                onClose: ()=>setIsOpen(false),
                placement: "top",
                content: ()=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                        padding: "space.100",
                        onMouseEnter: handleMouseEnter,
                        onMouseLeave: handleMouseLeave,
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $1qQas.Inline), {
                            space: "space.075",
                            alignBlock: "center",
                            children: [
                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $5supy.default), {
                                    appearance: "default",
                                    isBold: false,
                                    children: betaLabel
                                }),
                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
                                    size: "small",
                                    children: tooltipBody
                                })
                            ]
                        })
                    }),
                trigger: (triggerProps)=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $ifX9g.Pressable), {
                        ...triggerProps,
                        testId: "ai-disclaimer-trigger",
                        onMouseEnter: handleMouseEnter,
                        onMouseLeave: handleMouseLeave,
                        onClick: ()=>setIsOpen((prev)=>!prev),
                        xcss: $9d0c6ca2818366fa$var$triggerStyles,
                        children: [
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cbf86129106492cc$exports))), {
                                label: `${betaLabel}. ${tooltipBody}`,
                                color: (0, $37190500189da037$export$9e1725a4cfeada27)('color.icon.subtle'),
                                spacing: "spacious"
                            }),
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $5supy.default), {
                                appearance: "default",
                                isBold: false,
                                children: betaLabel
                            })
                        ]
                    })
            })
        ]
    });
};
var $9d0c6ca2818366fa$export$2e2bcd8739ae039 = $9d0c6ca2818366fa$export$e0542ba0c737fe5c;



const $cd51792b00d955d5$var$messages = (0, $7e94896e68874ec2$export$1adfeb024f5185b)({
    emptyStateHeader: {
        id: 'appUpdatesTable.emptyState.header',
        defaultMessage: 'No release notes found',
        description: 'Header text for empty app updates table state'
    },
    emptyStateDescription: {
        id: 'appUpdatesTable.emptyState.description',
        defaultMessage: 'No release notes match your filters. Adjust or clear your filters and try again.',
        description: 'Description text for empty app updates table state'
    },
    errorStateHeader: {
        id: 'appUpdatesTable.errorState.header',
        defaultMessage: 'Unable to load release notes',
        description: 'Header text for error app updates table state'
    },
    errorStateDescription: {
        id: 'appUpdatesTable.errorState.description',
        defaultMessage: "We couldn't load your release notes. Refresh the page to try again.",
        description: 'Description text for error app updates table state'
    },
    productHeader: {
        id: 'appUpdatesTable.column.product',
        defaultMessage: 'App',
        description: 'Column header for product/app name'
    },
    releaseNoteHeader: {
        id: 'appUpdatesTable.column.releaseNote',
        defaultMessage: 'Release note',
        description: 'Column header for release note'
    },
    statusHeader: {
        id: 'appUpdatesTable.column.status',
        defaultMessage: 'Status',
        description: 'Column header for status'
    },
    impactRatingHeader: {
        id: 'appUpdatesTable.column.impactRating',
        defaultMessage: 'Impact',
        description: 'Column header for AI-generated impact rating'
    },
    changeTypeHeader: {
        id: 'appUpdatesTable.column.changeType',
        defaultMessage: 'Change type',
        description: 'Column header for original (non-AI) change type'
    },
    contextualTagsHeader: {
        id: 'appUpdatesTable.column.contextualTags',
        defaultMessage: 'Contextual tags',
        description: 'Column header for AI-generated contextual tags'
    },
    rolloutScheduleHeader: {
        id: 'appUpdatesTable.column.rolloutSchedule',
        defaultMessage: 'Rollout schedule',
        description: 'Column header for rollout schedule date range'
    },
    adminCalloutText: {
        id: 'appUpdatesTable.adminCallout.text',
        defaultMessage: 'For rollout schedules specific to your organization, visit <appUpdatesLink>App updates</appUpdatesLink> in <adminLink>Atlassian Administration</adminLink>. Organization admin access required.',
        description: 'Callout below the table encouraging org admins to visit Atlassian Administration for org-specific rollout schedules. The text inside <appUpdatesLink> and <adminLink> tags are the visible link labels.'
    }
});
const $cd51792b00d955d5$var$rolloutScheduleContentStyles = (0, $gDiFE.xcss)({
    width: '100%',
    textAlign: 'right',
    paddingInlineEnd: 'space.200'
});
const $cd51792b00d955d5$var$titleStyles = (0, $gDiFE.xcss)({
    whiteSpace: 'normal'
});
const $cd51792b00d955d5$var$adminCalloutStyles = (0, $gDiFE.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.small',
    paddingBlock: 'space.150',
    paddingInline: 'space.150'
});
const $cd51792b00d955d5$export$43e60dbd29b5bdea = ()=>{
    const { formatMessage: formatMessage } = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    const { state: state } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { setCursor: setCursor, setLimit: setLimit } = (0, $4981744843bb0981$export$f80c710216eae131)();
    const { analyticsOptOut: analyticsOptOut } = (0, $38056d680fac42ff$export$b224af886b957a5e)();
    const shouldShowContextualTags = (0, $c78886f48293f91c$export$b40ec24ac8275656)((0, $86626a3c150b02ba$export$5fb62a9fe732a843).contextualTagsBeta);
    const onNextPageClicked = ()=>{
        // pagination component ensures button is disabled if no next page
        // but ts makes us do an extra check here
        if (state.updates.links.next) setCursor(state.updates.links.next);
    };
    const onPreviousPageClicked = ()=>{
        // pagination component ensures button is disabled if no previous page
        // but ts makes us do an extra check here
        if (state.updates.links.prev) setCursor(state.updates.links.prev);
    };
    const onPageSizeChange = (value)=>{
        setLimit(value.value);
    };
    const unreadIndicatorColumn = {
        id: 'unreadDot',
        header: '',
        accessorKey: 'id',
        size: 24,
        enableSorting: false,
        cell: ({ row: row })=>{
            if (analyticsOptOut || !row.original.firstPublishedAt) return null;
            return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $66d7da6dce257b40$export$8c779258b936559c), {
                id: row.original.id,
                firstPublishedAt: row.original.firstPublishedAt
            });
        }
    };
    const columnDefs = [
        unreadIndicatorColumn,
        {
            id: 'product',
            header: formatMessage($cd51792b00d955d5$var$messages.productHeader),
            accessorKey: 'productTypes',
            size: 150,
            enableSorting: false,
            cell: ({ row: row })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $04e2ab9a71aec03a$export$831fdf77aa2a6a18), {
                    productTypes: row.original.productTypes
                })
        },
        {
            id: 'title',
            header: formatMessage($cd51792b00d955d5$var$messages.releaseNoteHeader),
            accessorKey: 'title',
            size: 400,
            enableSorting: false,
            cell: ({ row: row })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                    xcss: $cd51792b00d955d5$var$titleStyles,
                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $dba17dfd00ae7d8f$export$2e2bcd8739ae039), {
                        to: (0, $749a6437bd4ec017$export$cd891b82501bb412).RELEASE_NOTE_DETAILS(row.original.id),
                        onClick: ()=>{
                            // TODO: - Temp fix for TC-10499: the GET /changes/id endpoint does not return
                            // firstPublishedAt, so the details page cannot mark the item as read.
                            // We mark it here in the list view where firstPublishedAt is available.
                            if (!analyticsOptOut && row.original.firstPublishedAt) (0, $15b90d5900f709a5$export$dc76bba8c4f0075f)({
                                id: row.original.id,
                                firstPublishedAt: row.original.firstPublishedAt
                            });
                        },
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
                            color: "color.link",
                            weight: "regular",
                            children: row.original.title
                        })
                    })
                })
        },
        {
            id: 'status',
            header: formatMessage($cd51792b00d955d5$var$messages.statusHeader),
            accessorKey: 'status',
            size: 150,
            enableSorting: false,
            cell: ({ row: row })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $fe4fcc4b7b323fa4$export$330c774339d320ad), {
                    status: row.original.status
                })
        },
        {
            id: 'changeType',
            header: formatMessage($cd51792b00d955d5$var$messages.changeTypeHeader),
            accessorKey: 'type',
            size: 130,
            enableSorting: false,
            cell: ({ row: row })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $10eaae4bdfb59f21$export$1abc4eff6ef230bd), {
                    type: row.original.type
                })
        },
        {
            id: 'impactRating',
            header: ()=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9d0c6ca2818366fa$export$e0542ba0c737fe5c), {
                    label: formatMessage($cd51792b00d955d5$var$messages.impactRatingHeader)
                }),
            accessorKey: 'impactRating',
            enableSorting: false,
            cell: ({ row: row })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d26747ad8d2a0268$export$2a5158d64a074be2), {
                    impactRating: row.original.impactRating
                })
        },
        ...shouldShowContextualTags ? [
            {
                id: 'contextualTags',
                header: ()=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9d0c6ca2818366fa$export$e0542ba0c737fe5c), {
                        label: formatMessage($cd51792b00d955d5$var$messages.contextualTagsHeader)
                    }),
                accessorKey: 'tags',
                size: 200,
                maxSize: 200,
                enableSorting: false,
                cell: ({ row: row })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $fbecf69dc9e04116$export$3c86caed05f80ae7), {
                        tags: row.original.tags
                    })
            }
        ] : [],
        {
            id: 'rolloutSchedule',
            header: ()=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                    xcss: $cd51792b00d955d5$var$rolloutScheduleContentStyles,
                    children: formatMessage($cd51792b00d955d5$var$messages.rolloutScheduleHeader)
                }),
            accessorKey: 'releaseStartDate',
            size: 180,
            enableSorting: false,
            minSize: 180,
            cell: ({ row: row })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                    xcss: $cd51792b00d955d5$var$rolloutScheduleContentStyles,
                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $373b864dc2406021$export$c119e7a38ceabb6b), {
                        startDate: row.original.releaseStartDate,
                        endDate: row.original.releaseEndDate,
                        status: row.original.status
                    })
                })
        }
    ];
    const tableState = state.updates.error ? (0, $9TAkY.TableState).error : state.updates.isLoading ? (0, $9TAkY.TableState).loading : (0, $9TAkY.TableState).loaded;
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
        space: "space.200",
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9TAkY.CharlieTable), {
                data: state.updates.data,
                columnDefs: columnDefs,
                manualSorting: false,
                tableState: tableState,
                emptyTableView: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9a28bb334efe6ee5$export$2e2bcd8739ae039), {
                    header: formatMessage($cd51792b00d955d5$var$messages.emptyStateHeader),
                    description: formatMessage($cd51792b00d955d5$var$messages.emptyStateDescription)
                }),
                errorView: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9a28bb334efe6ee5$export$2e2bcd8739ae039), {
                    header: formatMessage($cd51792b00d955d5$var$messages.errorStateHeader),
                    description: formatMessage($cd51792b00d955d5$var$messages.errorStateDescription)
                }),
                tableType: "INVENTORY",
                manualPagination: true
            }, !analyticsOptOut ? 'unread-indicator-visible' : 'unread-indicator-hidden'),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $de3e24ee9809fb70$export$2e2bcd8739ae039), {
                hasPreviousPage: !!state.updates?.links?.prev,
                hasNextPage: !!state.updates?.links?.next,
                onNextPageClicked: onNextPageClicked,
                onPreviousPageClicked: onPreviousPageClicked,
                onPageSizeChange: onPageSizeChange
            }),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $2kuK2.Flex), {
                justifyContent: "center",
                xcss: $cd51792b00d955d5$var$adminCalloutStyles,
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
                    size: "small",
                    color: "color.text.subtle",
                    children: formatMessage($cd51792b00d955d5$var$messages.adminCalloutText, {
                        appUpdatesLink: (chunks)=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $8F9hT.default), {
                                href: "https://support.atlassian.com/organization-administration/docs/view-all-changes-to-an-atlassian-app/",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: chunks
                            }),
                        adminLink: (chunks)=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $8F9hT.default), {
                                href: "https://admin.atlassian.com",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: chunks
                            })
                    })
                })
            })
        ]
    });
};
var $cd51792b00d955d5$export$2e2bcd8739ae039 = $cd51792b00d955d5$export$43e60dbd29b5bdea;







var $9TAkY = parcelRequire("9TAkY");

var $4Pn6z = parcelRequire("4Pn6z");
var $ifpPH = parcelRequire("ifpPH");
var $gDiFE = parcelRequire("gDiFE");









var $5FkrB = parcelRequire("5FkrB");

const $0ae5c4deaafff0f7$export$832f7aa7b8c34acc = ()=>{
    const { dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const setCursor = (0, $5FkrB.useCallback)((cursor)=>{
        dispatch({
            type: 'BUNDLES_CURSOR_SET',
            payload: {
                cursor: cursor
            }
        });
    }, [
        dispatch
    ]);
    const setLimit = (0, $5FkrB.useCallback)((limit)=>{
        dispatch({
            type: 'BUNDLES_LIMIT_SET',
            payload: {
                limit: limit
            }
        });
    }, [
        dispatch
    ]);
    return {
        setCursor: setCursor,
        setLimit: setLimit
    };
};


const $2a8cd52f0324fffc$var$messages = (0, $7e94896e68874ec2$export$1adfeb024f5185b)({
    emptyStateHeader: {
        id: 'bundledChangesTable.emptyState.header',
        defaultMessage: 'No bundled changes found',
        description: 'Header text for empty bundled changes table state'
    },
    emptyStateDescription: {
        id: 'bundledChangesTable.emptyState.description',
        defaultMessage: 'No bundled changes match your filters. Adjust or clear your filters and try again.',
        description: 'Description text for empty bundled changes table state'
    },
    errorStateHeader: {
        id: 'bundledChangesTable.errorState.header',
        defaultMessage: 'Unable to load bundled changes',
        description: 'Header text for error bundled changes table state'
    },
    errorStateDescription: {
        id: 'bundledChangesTable.errorState.description',
        defaultMessage: "We couldn't load bundled changes. Refresh the page to try again.",
        description: 'Description text for error bundled changes table state'
    },
    productHeader: {
        id: 'bundledChangesTable.column.product',
        defaultMessage: 'App',
        description: 'Column header for product/app name'
    },
    releaseNoteHeader: {
        id: 'bundledChangesTable.column.releaseNote',
        defaultMessage: 'Release note',
        description: 'Column header for release note'
    },
    changeTypeHeader: {
        id: 'bundledChangesTable.column.changeType',
        defaultMessage: 'Change type',
        description: 'Column header for change type'
    },
    previewTrackHeader: {
        id: 'bundledChangesTable.column.previewTrack',
        defaultMessage: 'Preview release date',
        description: 'Column header for preview track release date'
    },
    bundledTrackHeader: {
        id: 'bundledChangesTable.column.bundledTrack',
        defaultMessage: 'Bundled release date',
        description: 'Column header for bundled track release date'
    }
});
const $2a8cd52f0324fffc$var$titleStyles = (0, $gDiFE.xcss)({
    whiteSpace: 'normal'
});
const $2a8cd52f0324fffc$export$7d9f68d95131377e = ()=>{
    const { formatMessage: formatMessage } = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    const { state: state } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { analyticsOptOut: analyticsOptOut } = (0, $38056d680fac42ff$export$b224af886b957a5e)();
    const { setCursor: setCursor, setLimit: setLimit } = (0, $0ae5c4deaafff0f7$export$832f7aa7b8c34acc)();
    const onNextPageClicked = ()=>{
        if (state.bundles.links.next) setCursor(state.bundles.links.next);
    };
    const onPreviousPageClicked = ()=>{
        if (state.bundles.links.prev) setCursor(state.bundles.links.prev);
    };
    const onPageSizeChange = (value)=>{
        setLimit(value.value);
    };
    const unreadIndicatorColumn = {
        id: 'unreadDot',
        header: '',
        accessorKey: 'id',
        size: 24,
        enableSorting: false,
        cell: ({ row: row })=>{
            if (analyticsOptOut || !row.original.firstPublishedAt) return null;
            return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $66d7da6dce257b40$export$8c779258b936559c), {
                id: row.original.id,
                firstPublishedAt: row.original.firstPublishedAt
            });
        }
    };
    const columnDefs = [
        unreadIndicatorColumn,
        {
            id: 'product',
            header: formatMessage($2a8cd52f0324fffc$var$messages.productHeader),
            accessorKey: 'productTypes',
            size: 150,
            enableSorting: false,
            cell: ({ row: row })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $04e2ab9a71aec03a$export$831fdf77aa2a6a18), {
                    productTypes: row.original.productTypes
                })
        },
        {
            id: 'title',
            header: formatMessage($2a8cd52f0324fffc$var$messages.releaseNoteHeader),
            accessorKey: 'title',
            size: 400,
            enableSorting: false,
            cell: ({ row: row })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                    xcss: $2a8cd52f0324fffc$var$titleStyles,
                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $dba17dfd00ae7d8f$export$2e2bcd8739ae039), {
                        to: (0, $749a6437bd4ec017$export$cd891b82501bb412).RELEASE_NOTE_DETAILS(row.original.id),
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
                            color: "color.link",
                            weight: "regular",
                            children: row.original.title
                        })
                    })
                })
        },
        {
            id: 'changeType',
            header: formatMessage($2a8cd52f0324fffc$var$messages.changeTypeHeader),
            accessorKey: 'type',
            size: 130,
            enableSorting: false,
            cell: ({ row: row })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $10eaae4bdfb59f21$export$1abc4eff6ef230bd), {
                    type: row.original.type
                })
        },
        {
            id: 'previewTrackReleaseDate',
            header: formatMessage($2a8cd52f0324fffc$var$messages.previewTrackHeader),
            accessorKey: 'previewTrackReleaseDate',
            size: 160,
            enableSorting: false,
            cell: ({ row: row })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
                    children: row.original.previewTrackReleaseDate ? (0, $dc0b5cf0aeb86d21$export$eecd5dfd0530be5c)(row.original.previewTrackReleaseDate) : "\u2014"
                })
        },
        {
            id: 'bundledTrackReleaseDate',
            header: formatMessage($2a8cd52f0324fffc$var$messages.bundledTrackHeader),
            accessorKey: 'bundledTrackReleaseDate',
            size: 160,
            enableSorting: false,
            cell: ({ row: row })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
                    children: row.original.bundledTrackReleaseDate ? (0, $dc0b5cf0aeb86d21$export$eecd5dfd0530be5c)(row.original.bundledTrackReleaseDate) : "\u2014"
                })
        }
    ];
    const tableState = state.bundles.error ? (0, $9TAkY.TableState).error : state.bundles.isLoading ? (0, $9TAkY.TableState).loading : (0, $9TAkY.TableState).loaded;
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
        space: "space.200",
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9TAkY.CharlieTable), {
                data: state.bundles.data,
                columnDefs: columnDefs,
                manualSorting: false,
                tableState: tableState,
                emptyTableView: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9a28bb334efe6ee5$export$2e2bcd8739ae039), {
                    header: formatMessage($2a8cd52f0324fffc$var$messages.emptyStateHeader),
                    description: formatMessage($2a8cd52f0324fffc$var$messages.emptyStateDescription)
                }),
                errorView: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9a28bb334efe6ee5$export$2e2bcd8739ae039), {
                    header: formatMessage($2a8cd52f0324fffc$var$messages.errorStateHeader),
                    description: formatMessage($2a8cd52f0324fffc$var$messages.errorStateDescription)
                }),
                tableType: "INVENTORY",
                manualPagination: true
            }, !analyticsOptOut ? 'unread-indicator-visible' : 'unread-indicator-hidden'),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $de3e24ee9809fb70$export$2e2bcd8739ae039), {
                hasPreviousPage: !!state.bundles?.links?.prev,
                hasNextPage: !!state.bundles?.links?.next,
                onNextPageClicked: onNextPageClicked,
                onPreviousPageClicked: onPreviousPageClicked,
                onPageSizeChange: onPageSizeChange
            })
        ]
    });
};












var $kgDEK = parcelRequire("kgDEK");
const $5980852fab81bf32$export$50459aae8e896057 = $kgDEK.object({
    aaid: $kgDEK.string(),
    staffId: $kgDEK.string(),
    name: $kgDEK.string()
});
const $5980852fab81bf32$export$26933d974c970670 = $kgDEK.enum([
    'READY',
    'DONE',
    'COMPLETE',
    'IN_PROGRESS',
    'BLOCKED'
]);
const $5980852fab81bf32$export$cd2da33297e70f42 = $kgDEK.enum([
    'access',
    'assets',
    'automation',
    'cmdb',
    'atlassian-together',
    'avocado',
    'avp',
    'beacon',
    'bitbucket',
    'canvas',
    'cloud-admin',
    'compass',
    'confluence',
    'devai',
    'feedback',
    'goal',
    'guard',
    'hipchat.cloud',
    'jira-admin',
    'jira-align',
    'jira-core',
    'jira-customer-service',
    'jira-family',
    'jira-incident-manager',
    'jira-product-discovery',
    'jira-servicedesk',
    'jira-servicedesk.ondemand',
    'jira-software',
    'jira-work-management',
    'loom',
    'loom-attribution',
    'mercury',
    'opsgenie',
    'passionfruit',
    'project',
    'radar',
    'refapp',
    'rovo',
    'statuspage',
    'studio',
    'teams',
    'townsquare',
    'trello',
    'unknown-atlassian'
]);
const $5980852fab81bf32$export$fc2f2bb38e071f9f = $kgDEK.object({
    url: $kgDEK.string(),
    altTag: $kgDEK.string(),
    title: $kgDEK.string(),
    width: $kgDEK.number(),
    height: $kgDEK.number()
});
const $5980852fab81bf32$export$8f438f2e2f3b5ab6 = $kgDEK.object({
    id: $kgDEK.string(),
    title: $kgDEK.string(),
    products: $kgDEK.array($5980852fab81bf32$export$cd2da33297e70f42).optional().nullable(),
    status: $kgDEK.enum([
        'COMING_SOON',
        'PLANNED',
        'ROLLING_OUT',
        'GENERALLY_AVAILABLE',
        'ROLLED_BACK'
    ]).optional().nullable(),
    type: $kgDEK.enum([
        'IMPROVEMENT',
        'FIX',
        'EXPERIMENT',
        'REMOVED',
        'ANNOUNCEMENT'
    ]).optional().nullable(),
    // AI-generated impact rating for the update
    impactRating: $kgDEK.enum([
        'HIGH',
        'MEDIUM',
        'LOW'
    ]).optional().nullable(),
    // AI-generated contextual tags replacing change type
    tags: $kgDEK.array($kgDEK.string()).optional().nullable(),
    // List and details page fields
    summary: $kgDEK.string().optional().nullable(),
    releaseStartDate: $kgDEK.string().optional().nullable(),
    releaseEndDate: $kgDEK.string().optional().nullable(),
    firstPublishedAt: $kgDEK.string().optional().nullable(),
    // Details page fields
    getStarted: $kgDEK.string().optional().nullable(),
    keyChanges: $kgDEK.string().optional().nullable(),
    benefitsList: $kgDEK.string().optional().nullable(),
    reasonForChange: $kgDEK.string().optional().nullable(),
    prepareForChange: $kgDEK.string().optional().nullable(),
    featuredImage: $5980852fab81bf32$export$fc2f2bb38e071f9f.optional().nullable()
});
const $5980852fab81bf32$export$c87d4a255d390b42 = $kgDEK.object({
    prev: $kgDEK.string().nullable(),
    self: $kgDEK.string(),
    next: $kgDEK.string().nullable()
});
// Hides items that fail validation, so one unsupported change can't fail the
// whole list (TC-11238).
// TODO: TC-11240 — render them instead. Hidden items aren't reported anywhere
// and still count towards meta.total.
const $5980852fab81bf32$var$hidingUnsupportedItems = (itemSchema)=>$kgDEK.array(itemSchema.nullable().catch(null)).transform((items)=>items.filter((item)=>item !== null));
const $5980852fab81bf32$export$858ba830f18930de = $5980852fab81bf32$var$hidingUnsupportedItems($5980852fab81bf32$export$8f438f2e2f3b5ab6);
const $5980852fab81bf32$export$cc5d40c0c68901df = $kgDEK.object({
    data: $5980852fab81bf32$export$858ba830f18930de,
    links: $5980852fab81bf32$export$c87d4a255d390b42,
    meta: $kgDEK.object({
        total: $kgDEK.number()
    }).optional().nullable()
});
const $5980852fab81bf32$export$c857e1b94e9f9b3e = $5980852fab81bf32$export$8f438f2e2f3b5ab6.extend({
    previewTrackReleaseDate: $kgDEK.string().optional().nullable(),
    bundledTrackReleaseDate: $kgDEK.string().optional().nullable()
});
const $5980852fab81bf32$export$70d05b2dcce6090f = $5980852fab81bf32$var$hidingUnsupportedItems($5980852fab81bf32$export$c857e1b94e9f9b3e);
const $5980852fab81bf32$export$d03cdea9c9f8dd87 = $kgDEK.object({
    data: $5980852fab81bf32$export$70d05b2dcce6090f,
    links: $5980852fab81bf32$export$c87d4a255d390b42,
    meta: $kgDEK.object({
        total: $kgDEK.number()
    }).optional().nullable()
});
const $5980852fab81bf32$export$98d9a00f2a6d4f51 = $kgDEK.object({
    currentValue: $kgDEK.number().nullable(),
    percentageChange: $kgDEK.number().nullable()
});
const $5980852fab81bf32$export$d56e026ea8343f5d = $kgDEK.object({
    totalActiveUpdates: $5980852fab81bf32$export$98d9a00f2a6d4f51,
    awaitingApproval: $5980852fab81bf32$export$98d9a00f2a6d4f51,
    approvedForUpdate: $5980852fab81bf32$export$98d9a00f2a6d4f51,
    averageApprovalTimeHours: $5980852fab81bf32$export$98d9a00f2a6d4f51
});



var $k7fIB = parcelRequire("k7fIB");
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $3hvsM = parcelRequire("3hvsM");

var $6JfQX = parcelRequire("6JfQX");

var $4iVTn = parcelRequire("4iVTn");

var $DtLwq = parcelRequire("DtLwq");

var $bYaqG = parcelRequire("bYaqG");

var $5OMCI = parcelRequire("5OMCI");
// DO NOT CALL THIS FUNCTION DIRECTLY!!!!
// It is only to be called by React UFO libraries for the automatic handling of trace context for experiences.
// Calling this may cause trace context to be broken
function $e50c446e101168c7$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), function() {
        return Math.floor(Math.random() * 16).toString(16);
    }).join('');
}



var $eRfZr = parcelRequire("eRfZr");

var $50U6m = parcelRequire("50U6m");

var $b49n7 = parcelRequire("b49n7");

var $2oi3V = parcelRequire("2oi3V");

var $k0Cxu = parcelRequire("k0Cxu");

var $5Y1AV = parcelRequire("5Y1AV");

var $dZ6Fb = parcelRequire("dZ6Fb");
function $2851c68052d6553a$export$a1002be327997103(traceId, spanId, type) {
    if ((0, $50U6m.fg)('platform_ufo_enable_otel_context_manager')) {
        var activeTraceContext = (0, $eRfZr.ROOT_CONTEXT).setValue((0, $dZ6Fb.traceIdKey), traceId).setValue((0, $k0Cxu.spanIdKey), spanId).setValue((0, $2oi3V.experienceTypeKey), type);
        // Now we need to get the global Context Manager and set the active context
        // Using type assertion because we've "extended" the ContextManager type
        if ((0, $b49n7.getContextManager)() instanceof (0, $b49n7.UFOContextManager)) {
            var contextManager = (0, $b49n7.getContextManager)();
            contextManager.setActive(activeTraceContext);
        }
    } else (0, $5Y1AV.state).context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
}


function $eb5fb257e761d120$export$f2e521e495a88544(interactionId, experienceType) {
    (0, $2851c68052d6553a$export$a1002be327997103)(interactionId.replace(/-/g, ''), (0, $e50c446e101168c7$export$295213bc4d0c54ad)(), experienceType);
}



var $bLIMX = parcelRequire("bLIMX");

var $gITbN = parcelRequire("gITbN");

var $iGolp = parcelRequire("iGolp");
// The UFORouteName object is a global singleton
var $502a1d7bcb430ca7$var$UFORouteName = {
    current: null
};
var $502a1d7bcb430ca7$export$2e2bcd8739ae039 = $502a1d7bcb430ca7$var$UFORouteName;


function $135ab2cf931f05a8$var$generateId() {
    var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7;
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var result = '';
    for(var i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
    return result;
}
var $135ab2cf931f05a8$export$2e2bcd8739ae039 = $135ab2cf931f05a8$var$generateId;



var $3ZMUU = parcelRequire("3ZMUU");
function $2b887b82eb4e13cf$var$scheduleOnPaint(callback) {
    var _process, _globalThis$document;
    var isSSR = typeof window === 'undefined' || Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__SERVER__) || typeof $3ZMUU !== 'undefined' && Boolean((_process = $3ZMUU) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 ? void 0 : _process.REACT_SSR);
    if (isSSR) {
        // In SSR, execute callback immediately (no paint event exists)
        callback();
        return;
    }
    if (((_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.visibilityState) !== 'visible') {
        // last resort fallback
        setTimeout(callback, 100);
        return;
    }
    // Check if the Scheduler API is available
    if (typeof window.scheduler !== 'undefined' && typeof window.scheduler.postTask === 'function') // Use scheduler.postTask if available
    // https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
    // Make sure we are scheduling this task before the browser paint the next frame
    requestAnimationFrame(function() {
        window.scheduler.postTask(callback, {
            priority: 'user-visible'
        });
    });
    else if (typeof requestAnimationFrame !== 'undefined') // Fallback to using double requestAnimationFrame
    requestAnimationFrame(function() {
        requestAnimationFrame(function() {
            callback();
        });
    });
}
var $2b887b82eb4e13cf$export$2e2bcd8739ae039 = $2b887b82eb4e13cf$var$scheduleOnPaint;



var $5FkrB = parcelRequire("5FkrB");
var $0beac055ed70ff9c$export$18d523e2a9aac2d9 = function ProfilerMarker(_ref) {
    var onRender = _ref.onRender;
    onRender === null || onRender === void 0 || onRender();
    return null;
};



var $5FkrB = parcelRequire("5FkrB");

var $DtLwq = parcelRequire("DtLwq");

var $bYaqG = parcelRequire("bYaqG");

var $iGolp = parcelRequire("iGolp");

var $jIBBJ = parcelRequire("jIBBJ");
var $b9a86e984d058b5f$export$cf4e4023c0a34c8d = function clearState() {
    (0, $jIBBJ.default).startTimes.clear();
    (0, $jIBBJ.default).spanStates.clear();
};




var $jIBBJ = parcelRequire("jIBBJ");
function $659ff7104959f5ce$var$checkActiveInteractionAndResetStartMarksIfSet() {
    var _getActiveInteraction;
    var activeInteractionId = (_getActiveInteraction = (0, $iGolp.getActiveInteraction)()) === null || _getActiveInteraction === void 0 ? void 0 : _getActiveInteraction.id;
    if (!!(0, $jIBBJ.default).lastActiveInteraction && (0, $jIBBJ.default).lastActiveInteraction !== activeInteractionId) (0, $b9a86e984d058b5f$export$cf4e4023c0a34c8d)();
    (0, $jIBBJ.default).lastActiveInteraction = activeInteractionId;
}
var $659ff7104959f5ce$var$getIsNativeTracingEnabled = function getIsNativeTracingEnabled() {
    var _getConfig$ssr$enable, _getConfig;
    return (_getConfig$ssr$enable = (_getConfig = (0, $DtLwq.getConfig)()) === null || _getConfig === void 0 || (_getConfig = _getConfig.ssr) === null || _getConfig === void 0 ? void 0 : _getConfig.enableNativeTracing) !== null && _getConfig$ssr$enable !== void 0 ? _getConfig$ssr$enable : false;
};
var $659ff7104959f5ce$var$onStartRender = function onStartRender(id, currentSegmentName, parentContext) {
    var _state$startTimes$get, _vm_internals__, _state$spanStates$get;
    if (!(0, $jIBBJ.default).startTimes.has(id)) (0, $jIBBJ.default).startTimes.set(id, []);
    (_state$startTimes$get = (0, $jIBBJ.default).startTimes.get(id)) === null || _state$startTimes$get === void 0 || _state$startTimes$get.push(performance.now());
    if (!$659ff7104959f5ce$var$getIsNativeTracingEnabled()) return null;
    var startSpan = (_vm_internals__ = globalThis.__vm_internals__) === null || _vm_internals__ === void 0 || (_vm_internals__ = _vm_internals__.telemetry) === null || _vm_internals__ === void 0 ? void 0 : _vm_internals__.startSpan;
    var spanState = (_state$spanStates$get = (0, $jIBBJ.default).spanStates.get(id)) !== null && _state$spanStates$get !== void 0 ? _state$spanStates$get : null;
    if (!spanState && startSpan) {
        var span = startSpan(currentSegmentName, {
            parentSpanId: parentContext === null || parentContext === void 0 ? void 0 : parentContext.spanId
        });
        spanState = {
            span: span
        };
        (0, $jIBBJ.default).spanStates.set(id, spanState);
    }
    return spanState;
};
var $659ff7104959f5ce$var$ParentSpanContext = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $659ff7104959f5ce$export$b8bd105b650b1c1e = function SsrRenderProfilerInner(_ref) {
    var _currentSpanState$spa;
    var children = _ref.children, labelStack = _ref.labelStack, _onRender = _ref.onRender;
    var reactProfilerId = (0, $5FkrB.useMemo)(function() {
        return labelStack.map(function(l) {
            return (0, $bYaqG.sanitizeLabelStackName)(l.name);
        }).join('/');
    }, [
        labelStack
    ]);
    $659ff7104959f5ce$var$checkActiveInteractionAndResetStartMarksIfSet();
    var parentSpan = (0, $5FkrB.useContext)($659ff7104959f5ce$var$ParentSpanContext);
    var currentSpanState = $659ff7104959f5ce$var$onStartRender(reactProfilerId, (0, $bYaqG.sanitizeLabelStackName)(labelStack[labelStack.length - 1].name), parentSpan);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($659ff7104959f5ce$var$ParentSpanContext.Provider, {
        value: (_currentSpanState$spa = currentSpanState === null || currentSpanState === void 0 ? void 0 : currentSpanState.span.getSpanContext()) !== null && _currentSpanState$spa !== void 0 ? _currentSpanState$spa : null
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0beac055ed70ff9c$export$18d523e2a9aac2d9), {
        onRender: function onRender() {
            var startTimesForId = (0, $jIBBJ.default).startTimes.get(reactProfilerId);
            if (startTimesForId !== null && startTimesForId !== void 0 && startTimesForId.length) {
                var endTime = performance.now();
                var firstStartTime = startTimesForId[0];
                var lastStartTime = startTimesForId[startTimesForId.length - 1];
                var baseDuration = endTime - lastStartTime;
                var actualDuration = endTime - firstStartTime;
                _onRender('mount', // this is incorrect, but on the server there is no mount phase
                actualDuration, baseDuration, firstStartTime, endTime);
            }
            var spanState = (0, $jIBBJ.default).spanStates.get(reactProfilerId);
            if (spanState) spanState.latestEndTime = performance.now();
        }
    })));
};



var $3ZMUU = parcelRequire("3ZMUU");
var $41247975021260d3$var$_process;
var $41247975021260d3$var$isInSSR = typeof __SERVER__ !== 'undefined' && __SERVER__ || typeof $3ZMUU !== 'undefined' && Boolean((($41247975021260d3$var$_process = $3ZMUU) === null || $41247975021260d3$var$_process === void 0 || ($41247975021260d3$var$_process = $41247975021260d3$var$_process.env) === null || $41247975021260d3$var$_process === void 0 ? void 0 : $41247975021260d3$var$_process.REACT_SSR) || false);
var $41247975021260d3$var$SsrRenderProfiler = function SsrRenderProfiler(props) {
    if ($41247975021260d3$var$isInSSR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $659ff7104959f5ce$export$b8bd105b650b1c1e), props);
    // ensure structure similar to SSR implementation
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0beac055ed70ff9c$export$18d523e2a9aac2d9), null), props.children);
};
var $41247975021260d3$export$2e2bcd8739ae039 = $41247975021260d3$var$SsrRenderProfiler;


function $7ee2d474f4b84c7a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7ee2d474f4b84c7a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7ee2d474f4b84c7a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7ee2d474f4b84c7a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7ee2d474f4b84c7a$var$tryCompleteHandle;
/** A portion of the page we apply measurement to */ var $7ee2d474f4b84c7a$var$UFOSegment = function UFOSegment(_ref) {
    var segmentName = _ref.name, children = _ref.children, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? 'single' : _ref$mode, _ref$type = _ref.type, type = _ref$type === void 0 ? 'first-party' : _ref$type, _ref$excludeFromMetri = _ref.excludeFromMetrics, excludeFromMetrics = _ref$excludeFromMetri === void 0 ? false : _ref$excludeFromMetri;
    // If UFO is disabled, render children without any tracking overhead
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    var ufoEnabled = (0, $DtLwq.isUFOEnabled)();
    var parentContext = (0, $5FkrB.useContext)((0, $bLIMX.default));
    var segmentIdMap = (0, $5FkrB.useMemo)(function() {
        if (!(parentContext !== null && parentContext !== void 0 && parentContext.segmentIdMap)) return new Map();
        return parentContext.segmentIdMap;
    }, [
        parentContext
    ]);
    var segmentId = (0, $5FkrB.useMemo)(function() {
        if (mode === 'single') return (0, $135ab2cf931f05a8$export$2e2bcd8739ae039)();
        if (segmentIdMap.has(segmentName)) return segmentIdMap.get(segmentName);
        var newSegmentId = (0, $135ab2cf931f05a8$export$2e2bcd8739ae039)();
        segmentIdMap.set(segmentName, newSegmentId);
        return newSegmentId;
    }, [
        mode,
        segmentName,
        segmentIdMap
    ]);
    var labelStack = (0, $5FkrB.useMemo)(function() {
        // Only stamp `excludeFromMetrics` alongside a third-party type.
        // So it can never remove first-party work from metrics.
        var label = $7ee2d474f4b84c7a$var$_objectSpread($7ee2d474f4b84c7a$var$_objectSpread({
            name: segmentName,
            segmentId: segmentId
        }, type !== 'first-party' ? {
            type: type
        } : {}), excludeFromMetrics && type === 'third-party' ? {
            excludeFromMetrics: true
        } : {});
        return parentContext !== null && parentContext !== void 0 && parentContext.labelStack ? [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(parentContext.labelStack), [
            label
        ]) : [
            label
        ];
    }, [
        parentContext,
        segmentName,
        segmentId,
        type,
        excludeFromMetrics
    ]);
    var interactionId = (0, $5FkrB.useContext)((0, $gITbN.default));
    var interactionContext = (0, $5FkrB.useMemo)(function() {
        var lastCompleteEndTime = 0;
        function complete() {
            var endTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
            if (interactionId.current) {
                if (parentContext) parentContext.complete();
                else {
                    var capturedInteractionId = interactionId.current;
                    if (endTime > lastCompleteEndTime) lastCompleteEndTime = endTime;
                    if ($7ee2d474f4b84c7a$var$tryCompleteHandle) {
                        var _cancelAnimationFrame;
                        (_cancelAnimationFrame = cancelAnimationFrame) === null || _cancelAnimationFrame === void 0 || _cancelAnimationFrame($7ee2d474f4b84c7a$var$tryCompleteHandle);
                    }
                    var onComplete = function onComplete() {
                        if (capturedInteractionId === interactionId.current) {
                            var _globalThis$document;
                            var isPageVisible = (globalThis === null || globalThis === void 0 || (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.visibilityState) === 'visible';
                            var canDoRAF = typeof requestAnimationFrame !== 'undefined';
                            if (isPageVisible && canDoRAF) $7ee2d474f4b84c7a$var$tryCompleteHandle = requestAnimationFrame(function() {
                                $7ee2d474f4b84c7a$var$tryCompleteHandle = requestAnimationFrame(function() {
                                    if (capturedInteractionId === interactionId.current) (0, $iGolp.tryComplete)(interactionId.current, lastCompleteEndTime);
                                });
                            });
                            else (0, $iGolp.tryComplete)(interactionId.current, lastCompleteEndTime);
                        }
                    };
                    (0, $3hvsM.unstable_scheduleCallback)((0, $3hvsM.unstable_NormalPriority), onComplete);
                }
            }
        }
        function _internalHold(labelStack, name) {
            if (interactionId.current != null) {
                if (parentContext) return parentContext._internalHold(labelStack, name);
                else {
                    var capturedInteractionId = interactionId.current;
                    var disposeHold = (0, $iGolp.addHold)(interactionId.current, labelStack, name, false);
                    return function() {
                        if (capturedInteractionId === interactionId.current) disposeHold();
                    };
                }
            }
        }
        function _internalHoldByID(labelStack, id, name, remove) {
            if (interactionId.current != null) {
                if (parentContext) {
                    parentContext._internalHoldByID(labelStack, name, id, remove);
                    return;
                }
                if (!remove) (0, $iGolp.addHoldByID)(interactionId.current, labelStack, name, id);
                else (0, $iGolp.removeHoldByID)(interactionId.current, id);
            }
        }
        if (parentContext) return $7ee2d474f4b84c7a$var$_objectSpread($7ee2d474f4b84c7a$var$_objectSpread({}, parentContext), {}, {
            labelStack: labelStack,
            complete: complete
        });
        return {
            labelStack: labelStack,
            segmentIdMap: segmentIdMap,
            hold: function hold() {
                var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unknown';
                return this._internalHold(this.labelStack, name);
            },
            addHoldByID: function addHoldByID(labelStack, id) {
                var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'unknown';
                this._internalHoldByID(labelStack, id, name, false);
            },
            removeHoldByID: function removeHoldByID(labelStack, id) {
                var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'unknown';
                this._internalHoldByID(labelStack, id, name, true);
            },
            tracePress: function tracePress() {
                var _getDoNotAbortActiveP, _getMinorInteractions;
                var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unknown';
                var timestamp = arguments.length > 1 ? arguments[1] : undefined;
                var minorInteractions = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((_getDoNotAbortActiveP = (0, $DtLwq.getDoNotAbortActivePressInteraction)()) !== null && _getDoNotAbortActiveP !== void 0 ? _getDoNotAbortActiveP : []), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((_getMinorInteractions = (0, $DtLwq.getMinorInteractions)()) !== null && _getMinorInteractions !== void 0 ? _getMinorInteractions : []));
                if (minorInteractions.includes(name)) {
                    var _activeInteraction$mi;
                    var activeInteraction = (0, $iGolp.getActiveInteraction)();
                    activeInteraction === null || activeInteraction === void 0 || (_activeInteraction$mi = activeInteraction.minorInteractions) === null || _activeInteraction$mi === void 0 || _activeInteraction$mi.push({
                        name: name,
                        startTime: timestamp !== null && timestamp !== void 0 ? timestamp : performance.now()
                    });
                    return;
                } else if (interactionId.current != null) (0, $iGolp.abortByNewInteraction)(interactionId.current, name);
                var rate = (0, $DtLwq.getInteractionRate)(name, 'press');
                if ((0, $4iVTn.default)(rate)) {
                    var startTimestamp = timestamp !== null && timestamp !== void 0 ? timestamp : performance.now();
                    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                    var newId = (0, $6JfQX.default)();
                    interactionId.current = newId;
                    // covered experiences with tracing instrumentation:
                    // inline-result.global-issue.create-modal.submit
                    // inline-result.global-issue.create-modal-subsequent
                    (0, $eb5fb257e761d120$export$f2e521e495a88544)(newId, 'press');
                    (0, $iGolp.addNewInteraction)(newId, name, 'press', startTimestamp, rate, this.labelStack, (0, $502a1d7bcb430ca7$export$2e2bcd8739ae039).current, (0, $5OMCI.getActiveTrace)());
                }
            },
            retainQuery: function retainQuery(info) {
                if (interactionId.current != null) (0, $iGolp.addRequestInfo)(interactionId.current, this.labelStack, info);
            },
            addPreload: function addPreload(moduleId, timestamp) {
                if (interactionId.current != null) (0, $iGolp.addMark)(interactionId.current, 'bundle_preload', moduleId, this.labelStack, timestamp);
            },
            addLoad: function addLoad(identifier, start, end) {
                if (interactionId.current != null) {
                    var _this$labelStack = this.labelStack, _labelStack = _this$labelStack === void 0 ? [] : _this$labelStack;
                    (0, $iGolp.addSpan)(interactionId.current, 'bundle_load', identifier, _labelStack, start, end);
                }
            },
            addMark: function addMark(name, timestamp) {
                if (interactionId.current != null) {
                    var time = timestamp !== null && timestamp !== void 0 ? timestamp : performance.now();
                    (0, $iGolp.addMark)(interactionId.current, 'custom', name, this.labelStack, time);
                }
            },
            addCustomData: function addCustomData(customData) {
                if (interactionId.current != null) (0, $iGolp.addCustomData)(interactionId.current, this.labelStack, customData);
            },
            addCustomTimings: function addCustomTimings(customTimings) {
                if (interactionId.current != null) (0, $iGolp.addCustomTiming)(interactionId.current, this.labelStack, customTimings);
            },
            addApdex: function addApdex(apdexInfo) {
                if (interactionId.current != null) {
                    var key = apdexInfo.key, stopTime = apdexInfo.stopTime, startTime = apdexInfo.startTime;
                    (0, $iGolp.addApdex)(interactionId.current, {
                        key: key,
                        stopTime: stopTime,
                        startTime: startTime,
                        labelStack: this.labelStack
                    });
                }
            },
            onRender: function onRender(phase, actualDuration, baseDuration, startTime, commitTime) {
                var _this = this;
                if (interactionId.current !== null) {
                    (0, $iGolp.addProfilerTimings)(interactionId.current, this.labelStack, phase, actualDuration, baseDuration, startTime, commitTime);
                    (0, $2b887b82eb4e13cf$export$2e2bcd8739ae039)(function() {
                        var paintedTime = performance.now();
                        _this.complete(paintedTime);
                    });
                }
            },
            _internalHold: _internalHold,
            _internalHoldByID: _internalHoldByID,
            complete: complete
        };
    }, [
        parentContext,
        labelStack,
        segmentIdMap,
        interactionId
    ]);
    var hasMounted = (0, $5FkrB.useRef)(false);
    var onRender = (0, $5FkrB.useCallback)(function(_id, phase, actualDuration, baseDuration, startTime, commitTime) {
        var _getConfig;
        // Manually keep track of mount-phase, and ensure that every segment is always mounted at least once
        if ((_getConfig = (0, $DtLwq.getConfig)()) !== null && _getConfig !== void 0 && _getConfig.manuallyTrackReactProfilerMounts && !hasMounted.current) {
            interactionContext.onRender('mount', actualDuration, baseDuration, startTime, commitTime);
            hasMounted.current = true;
        } else interactionContext.onRender(phase, actualDuration, baseDuration, startTime, commitTime);
    }, [
        interactionContext
    ]);
    (0, $5FkrB.useEffect)(function() {
        (0, $iGolp.addSegment)(labelStack);
        return function() {
            (0, $iGolp.removeSegment)(labelStack);
        };
    }, [
        interactionId,
        parentContext,
        interactionContext,
        labelStack
    ]);
    var reactProfilerId = (0, $5FkrB.useMemo)(function() {
        return labelStack.map(function(l) {
            return (0, $bYaqG.sanitizeLabelStackName)(l.name);
        }).join('/');
    }, [
        labelStack
    ]);
    // If UFO is disabled, just render children without tracking overhead
    if (!ufoEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children);
    var ufoSegment = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bLIMX.default).Provider, {
        value: interactionContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Profiler), {
        id: reactProfilerId,
        onRender: onRender
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $41247975021260d3$export$2e2bcd8739ae039), {
        labelStack: labelStack,
        onRender: function onRender() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return interactionContext.onRender.apply(interactionContext, args);
        }
    }, ufoSegment);
};
$7ee2d474f4b84c7a$var$UFOSegment.displayName = 'UFOSegment';
var $7ee2d474f4b84c7a$export$2e2bcd8739ae039 = $7ee2d474f4b84c7a$var$UFOSegment;




var $0a97231e197d3e09$export$2e2bcd8739ae039 = (0, $7ee2d474f4b84c7a$export$2e2bcd8739ae039);



const $962eaad69e29ec03$export$b0b91c85f99f8402 = ()=>{
    const { api: api, dispatch: dispatch, state: state } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { sendScreenEvent: sendScreenEvent } = (0, $a442bdf486731fcc$export$62b6ee20d27ead99)();
    const shouldUseContextualTags = (0, $c78886f48293f91c$export$b40ec24ac8275656)((0, $86626a3c150b02ba$export$5fb62a9fe732a843).contextualTagsBeta);
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(()=>{
        sendScreenEvent((0, $3e8e9266fe04abe4$export$73f866ce8175509a).screen.appUpdatesListScreen.data);
    }, [
        sendScreenEvent
    ]);
    const { committedFilters: committedFilters, pagination: pagination } = state.updates;
    const { selectedProducts: committedProducts, selectedStatuses: committedStatuses, selectedChangeTypes: committedChangeTypes, selectedImpactRatings: committedImpactRatings, selectedTags: committedTags, searchQuery: committedSearchQuery, effectiveFrom: committedEffectiveFrom, committedFiltersVersion: committedFiltersVersion } = committedFilters;
    // Convert UiProductType ids (e.g. 'JIRA_SOFTWARE') to ProductKey (e.g. 'jira-software')
    // for the backend API, which expects kebab-case ProductKey format.
    const selectedProducts = committedProducts?.map(({ id: id })=>(0, $d3185276e14a4c2b$export$7524c8b3bd6ccb7f)(id)?.productKey).filter((key)=>key !== undefined).join(',') || undefined;
    const selectedStatuses = committedStatuses?.map(({ id: id })=>id).join(',') || undefined;
    const selectedChangeTypes = committedChangeTypes?.map(({ id: id })=>id).join(',') || undefined;
    const selectedImpactRatings = committedImpactRatings?.map(({ id: id })=>id).join(',') || undefined;
    const selectedTags = shouldUseContextualTags && committedTags ? committedTags.map(({ id: id })=>id).join(',') || undefined : undefined;
    const searchQuery = committedSearchQuery || undefined;
    const updatesQuery = (0, $4b398c1589a0f1e2$export$dd0a697e1782aedd)({
        queryKey: [
            '/gateway/api/public/app-updates/v1/changes',
            pagination.cursor ?? null,
            pagination.limit,
            searchQuery ?? null,
            selectedProducts ?? null,
            selectedStatuses ?? null,
            selectedChangeTypes ?? null,
            selectedImpactRatings ?? null,
            selectedTags ?? null,
            committedEffectiveFrom ?? null,
            // This fixes scenario where user clicks on Apply but do not change filters,
            // in which case the query would not refetch because queryKey did not change.
            // With this, even if filters did not change, the query will refetch because
            // committedFiltersVersion increments on every Apply click.
            committedFiltersVersion
        ],
        // Shows old data while fetching new data, to prevent showing empty state with spinner
        // on every filter change.
        placeholderData: (previousData)=>previousData,
        queryFn: async ()=>{
            try {
                if (typeof window !== 'undefined' && typeof window.scrollTo === 'function') window.scrollTo({
                    top: 0,
                    left: 0
                });
                const params = pagination.cursor ? {
                    cursor: pagination.cursor
                } : {
                    limit: pagination.limit,
                    search: searchQuery,
                    products: selectedProducts,
                    statuses: selectedStatuses,
                    types: selectedChangeTypes,
                    impactRatings: selectedImpactRatings,
                    tags: selectedTags,
                    effectiveFrom: committedEffectiveFrom ?? undefined
                };
                const response = await api.get('/gateway/api/public/app-updates/v1/changes', {
                    params: params
                });
                const parsedResponse = (0, $5980852fab81bf32$export$cc5d40c0c68901df).parse(response.data);
                return {
                    updates: [
                        ...parsedResponse?.data.map((update)=>({
                                ...update,
                                productTypes: update.products?.map((product)=>(0, $d3185276e14a4c2b$export$27e53caf66bae1d)(product)).filter((product)=>product != null) || []
                            })) || []
                    ],
                    links: parsedResponse?.links
                };
            } catch (error) {
                // Distinguish Zod schema parse failures (malformed API response) from
                // network/HTTP errors so Sentry gives clearer diagnostics.
                const isParseError = error instanceof Error && error.name === 'ZodError';
                (0, $9654b596cdf679bc$export$2e2bcd8739ae039).error(error, {
                    extra: {
                        action: isParseError ? 'parse-updates-list-response' : 'fetch-updates-list'
                    }
                });
                throw error;
            }
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(()=>{
        dispatch({
            type: 'UPDATES_LOADING_SET',
            payload: {
                isLoading: updatesQuery.isFetching
            }
        });
    }, [
        dispatch,
        updatesQuery.isFetching
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(()=>{
        dispatch({
            type: 'UPDATES_ERROR_SET',
            payload: {
                error: updatesQuery.error?.message || null
            }
        });
    }, [
        dispatch,
        updatesQuery.error
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(()=>{
        dispatch({
            type: 'UPDATES_DATA_LINKS_SET',
            payload: {
                updates: updatesQuery.data?.updates || [],
                links: updatesQuery.data?.links ? updatesQuery.data.links : {
                    self: '',
                    next: null,
                    prev: null
                }
            }
        });
    }, [
        dispatch,
        updatesQuery.data,
        updatesQuery.isLoading
    ]);
    // UFOSegment provides the interaction context required by UFOLoadHold.
    // UFOLoadHold holds the page-load interaction open while data is fetching;
    // when isFetching becomes false, react-ufo automatically completes and
    // sends the operational event to the analytics pipeline.
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $0a97231e197d3e09$export$2e2bcd8739ae039), {
        name: "app-updates",
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $k7fIB.default), {
                name: "updates-data",
                hold: updatesQuery.isFetching
            }),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                space: "space.400",
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ac017e5cb269e227$export$29b5614fa0522278), {}),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $cd51792b00d955d5$export$43e60dbd29b5bdea), {})
                ]
            })
        ]
    });
};




var $5FkrB = parcelRequire("5FkrB");


var $4Pn6z = parcelRequire("4Pn6z");
var $2kuK2 = parcelRequire("2kuK2");

var $9ztDu = parcelRequire("9ztDu");









var $8F9hT = parcelRequire("8F9hT");

var $2kuK2 = parcelRequire("2kuK2");
var $ifpPH = parcelRequire("ifpPH");
var $gDiFE = parcelRequire("gDiFE");
const $eb4ca328ce2b1810$var$messages = (0, $7e94896e68874ec2$export$1adfeb024f5185b)({
    adminCalloutText: {
        id: 'appUpdates.rolloutScheduleCallout.text',
        defaultMessage: 'For rollout schedules specific to your organization, visit <appUpdatesLink>App updates</appUpdatesLink> in <adminLink>Atlassian Administration</adminLink>. Organization admin access required.',
        description: 'Callout encouraging org admins to visit Atlassian Administration for org-specific rollout schedules. The text inside <appUpdatesLink> and <adminLink> tags are the visible link labels.'
    }
});
const $eb4ca328ce2b1810$var$calloutStyles = (0, $gDiFE.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.small',
    paddingBlock: 'space.150',
    paddingInline: 'space.150'
});
const $eb4ca328ce2b1810$export$986e8be29c8a24b3 = ()=>{
    const { formatMessage: formatMessage } = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $2kuK2.Flex), {
        justifyContent: "center",
        xcss: $eb4ca328ce2b1810$var$calloutStyles,
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
            size: "small",
            color: "color.text.subtle",
            children: formatMessage($eb4ca328ce2b1810$var$messages.adminCalloutText, {
                appUpdatesLink: (chunks)=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $8F9hT.default), {
                        href: "https://support.atlassian.com/organization-administration/docs/view-all-changes-to-an-atlassian-app/",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: chunks
                    }),
                adminLink: (chunks)=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $8F9hT.default), {
                        href: "https://admin.atlassian.com",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: chunks
                    })
            })
        })
    });
};



var $k7fIB = parcelRequire("k7fIB");

const $0ee532bd9ceb4b0a$export$d080aaafe13b8512 = ()=>{
    const { api: api, dispatch: dispatch, state: state } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { committedFilters: committedFilters, pagination: pagination } = state.bundles;
    const { selectedProducts: committedProducts, selectedBundleDate: committedBundleDate, searchQuery: committedSearchQuery, committedFiltersVersion: committedFiltersVersion } = committedFilters;
    const selectedProducts = committedProducts?.map(({ id: id })=>(0, $d3185276e14a4c2b$export$7524c8b3bd6ccb7f)(id)?.productKey).filter((key)=>key !== undefined).join(',') || undefined;
    // Prefetch available bundle dates for the currently selected app(s) so the
    // most recent date can be auto-applied before we render the table.
    const datesQuery = (0, $4b398c1589a0f1e2$export$dd0a697e1782aedd)({
        queryKey: [
            '/gateway/api/public/app-updates/v1/bundle-dates',
            selectedProducts ?? null
        ],
        queryFn: async ()=>{
            const response = await api.get('/gateway/api/public/app-updates/v1/bundle-dates', {
                params: {
                    products: selectedProducts
                }
            });
            return response.data ?? [];
        }
    });
    const hasInitialisedDefaultDateRef = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(false);
    const hasUserSelectedDate = committedBundleDate !== null;
    const isReadyToRender = hasInitialisedDefaultDateRef.current || hasUserSelectedDate;
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(()=>{
        if (hasInitialisedDefaultDateRef.current || hasUserSelectedDate) return;
        if (datesQuery.isSuccess) {
            const mostRecentDate = datesQuery.data[0] ?? null;
            hasInitialisedDefaultDateRef.current = true;
            if (mostRecentDate) {
                dispatch({
                    type: 'BUNDLE_FILTER_DATE_SELECT',
                    payload: {
                        selectedBundleDate: mostRecentDate
                    }
                });
                dispatch({
                    type: 'BUNDLES_FILTERS_APPLY'
                });
            }
        }
    }, [
        datesQuery.isSuccess,
        datesQuery.data,
        hasUserSelectedDate,
        dispatch
    ]);
    const searchQuery = committedSearchQuery || undefined;
    const inputDate = committedBundleDate || undefined;
    const bundlesQuery = (0, $4b398c1589a0f1e2$export$dd0a697e1782aedd)({
        enabled: isReadyToRender,
        queryKey: [
            '/gateway/api/public/app-updates/v1/bundle-changes',
            pagination.cursor ?? null,
            pagination.limit,
            searchQuery ?? null,
            selectedProducts ?? null,
            inputDate ?? null,
            committedFiltersVersion
        ],
        placeholderData: (previousData)=>previousData,
        queryFn: async ()=>{
            try {
                const params = pagination.cursor ? {
                    cursor: pagination.cursor
                } : {
                    limit: pagination.limit,
                    search: searchQuery,
                    products: selectedProducts,
                    inputDate: inputDate
                };
                const response = await api.get('/gateway/api/public/app-updates/v1/bundle-changes', {
                    params: params
                });
                const parsedResponse = (0, $5980852fab81bf32$export$d03cdea9c9f8dd87).parse(response.data);
                return {
                    bundles: [
                        ...parsedResponse?.data.map((bundle)=>({
                                ...bundle,
                                productTypes: bundle.products?.map((product)=>(0, $d3185276e14a4c2b$export$27e53caf66bae1d)(product)).filter((product)=>product != null) || []
                            })) || []
                    ],
                    links: parsedResponse?.links
                };
            } catch (error) {
                const isParseError = error instanceof Error && error.name === 'ZodError';
                (0, $9654b596cdf679bc$export$2e2bcd8739ae039).error(error, {
                    extra: {
                        action: isParseError ? 'parse-bundle-changes-response' : 'fetch-bundle-changes'
                    }
                });
                throw error;
            }
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(()=>{
        dispatch({
            type: 'BUNDLES_LOADING_SET',
            payload: {
                isLoading: bundlesQuery.isFetching
            }
        });
    }, [
        dispatch,
        bundlesQuery.isFetching
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(()=>{
        dispatch({
            type: 'BUNDLES_ERROR_SET',
            payload: {
                error: bundlesQuery.error?.message || null
            }
        });
    }, [
        dispatch,
        bundlesQuery.error
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(()=>{
        dispatch({
            type: 'BUNDLES_DATA_LINKS_SET',
            payload: {
                data: bundlesQuery.data?.bundles || [],
                links: bundlesQuery.data?.links ? bundlesQuery.data.links : {
                    self: '',
                    next: null,
                    prev: null
                }
            }
        });
    }, [
        dispatch,
        bundlesQuery.data
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(()=>{
        if (typeof window === 'undefined' || typeof window.scrollTo !== 'function') return;
        window.scrollTo({
            top: 0,
            left: 0
        });
    }, [
        pagination.cursor
    ]);
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $0a97231e197d3e09$export$2e2bcd8739ae039), {
        name: "bundled-changes",
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $k7fIB.default), {
                name: "bundles-data",
                hold: !isReadyToRender || bundlesQuery.isFetching
            }),
            isReadyToRender ? /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                space: "space.400",
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $fb27fbb16aa94537$export$ac34063c51bd3598), {}),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $2a8cd52f0324fffc$export$7d9f68d95131377e), {}),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $eb4ca328ce2b1810$export$986e8be29c8a24b3), {})
                ]
            }) : /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $2kuK2.Flex), {
                justifyContent: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                    padding: "space.400",
                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9ztDu.default), {
                        size: "large"
                    })
                })
            })
        ]
    });
};


const $5be66ddef5c7b610$var$ALL_CHANGES_TAB_INDEX = 0;
const $5be66ddef5c7b610$var$BUNDLED_CHANGES_TAB_INDEX = 1;
const $5be66ddef5c7b610$var$tabPanelContentStyles = (0, $gDiFE.xcss)({
    width: '100%'
});
const $5be66ddef5c7b610$var$messages = (0, $7e94896e68874ec2$export$1adfeb024f5185b)({
    listPageTitle: {
        id: 'app.updates.title',
        defaultMessage: "What's new across Atlassian",
        description: 'Title for the app updates list page'
    },
    listPageSubtitle: {
        id: 'app.updates.subtitle',
        defaultMessage: "Discover new cloud features designed to unleash your team's potential and see how our latest updates can power your work today.",
        description: 'Subtitle describing the app updates list page content'
    },
    browserTabTitle: {
        id: 'app.updates.browserTabTitle',
        defaultMessage: 'Release Notes | Atlassian Community',
        description: 'Browser tab title for the release notes list page'
    },
    allChangesTab: {
        id: 'app.updates.tabs.allChanges',
        defaultMessage: 'All changes',
        description: 'Label for the "All changes" tab on the app updates list page'
    },
    bundledChangesTab: {
        id: 'app.updates.tabs.bundledChanges',
        defaultMessage: 'Release tracks changes',
        description: 'Label for the "Bundled changes" tab on the app updates list page'
    }
});
const $5be66ddef5c7b610$export$617fd60bbdea4ae5 = ()=>{
    const { formatMessage: formatMessage } = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    const [routerState, routerActions] = (0, $b421c015f5018cd0$export$9a302a45f65d0572)();
    const isOnBundledChangesPath = routerState.location.pathname === (0, $749a6437bd4ec017$export$cd891b82501bb412).RELEASE_TRACKS_CHANGES;
    const getActiveTabIndex = ()=>{
        if (isOnBundledChangesPath) return $5be66ddef5c7b610$var$BUNDLED_CHANGES_TAB_INDEX;
        return $5be66ddef5c7b610$var$ALL_CHANGES_TAB_INDEX;
    };
    const handleTabChange = (index)=>{
        // TODO: analytics — fire a tab-switch UI event here (specifics TBD).
        const nextPath = index === $5be66ddef5c7b610$var$BUNDLED_CHANGES_TAB_INDEX ? (0, $749a6437bd4ec017$export$cd891b82501bb412).RELEASE_TRACKS_CHANGES : (0, $749a6437bd4ec017$export$cd891b82501bb412).RELEASE_NOTES;
        if (nextPath !== routerState.location.pathname) routerActions.push(nextPath);
    };
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $4Pn6z.Box), {
        as: "main",
        paddingBlockStart: "space.300",
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $448e9b7b3295f6e4$export$dcef8f9bb9a41431), {
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("title", {
                    children: formatMessage($5be66ddef5c7b610$var$messages.browserTabTitle)
                })
            }),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                space: "space.400",
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                        space: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $bb0Oq.default), {
                                size: "xxlarge",
                                children: formatMessage($5be66ddef5c7b610$var$messages.listPageTitle)
                            }),
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
                                color: "color.text.subtlest",
                                children: formatMessage($5be66ddef5c7b610$var$messages.listPageSubtitle)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $010bee42faeab737$export$92843d20b8ec0118), {}),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $f4929bb9d46c4aaa$export$2e2bcd8739ae039), {
                        id: "app-updates-tabs",
                        selected: getActiveTabIndex(),
                        onChange: handleTabChange,
                        children: [
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $62b7beffa12a0bc3$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $e23e17c0c75104db$export$2e2bcd8739ae039), {
                                        children: formatMessage($5be66ddef5c7b610$var$messages.allChangesTab)
                                    }),
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $e23e17c0c75104db$export$2e2bcd8739ae039), {
                                        children: formatMessage($5be66ddef5c7b610$var$messages.bundledChangesTab)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9620d31b6d3b6773$export$2e2bcd8739ae039), {
                                testId: "all-changes-panel",
                                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                                    paddingBlockStart: "space.400",
                                    xcss: $5be66ddef5c7b610$var$tabPanelContentStyles,
                                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $962eaad69e29ec03$export$b0b91c85f99f8402), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9620d31b6d3b6773$export$2e2bcd8739ae039), {
                                testId: "bundled-changes-panel",
                                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                                    paddingBlockStart: "space.400",
                                    xcss: $5be66ddef5c7b610$var$tabPanelContentStyles,
                                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $0ee532bd9ceb4b0a$export$d080aaafe13b8512), {})
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};








var $4Pn6z = parcelRequire("4Pn6z");
var $2kuK2 = parcelRequire("2kuK2");
var $ifpPH = parcelRequire("ifpPH");
var $gDiFE = parcelRequire("gDiFE");

var $bb0Oq = parcelRequire("bb0Oq");

var $dUWEU = parcelRequire("dUWEU");

var $fiGqm = parcelRequire("fiGqm");

var $9ztDu = parcelRequire("9ztDu");
/* divider.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $2ab0bce1a46aed9c$var$styles = null;
var $2ab0bce1a46aed9c$export$2e0a83ec2e27ecbb = function Divider() {
    return /*#__PURE__*/ $5FkrB.createElement("hr", {
        /**
     * The existing usage of these dividers is presentational,
     * so we are removing the separator semantics by default.
     *
     * In the future we may consider allowing opt-in separator semantics,
     * but it probably isn't necessary.
     */ role: "none",
        className: (0, $970q7.default)([
            "_h7alglyw _179rglyw _mqm2ia51 _1bsb1osq"
        ])
    });
};



var $5FkrB = parcelRequire("5FkrB");
/* eslint-disable no-unused-vars */ 




const $aae63e431edf6a1c$export$d1b34fec48b30a4f = (updateId)=>{
    const { api: api } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    // Helper function to handle updateId in query functions
    const createQueryFn = (fn)=>{
        return updateId ? ()=>fn(updateId) : undefined;
    };
    // Update data query
    const updateQuery = (0, $4b398c1589a0f1e2$export$dd0a697e1782aedd)({
        queryKey: [
            `/gateway/api/public/app-updates/v1/change-details/${updateId}`
        ],
        queryFn: createQueryFn(async (id)=>{
            try {
                const response = await api.get(`/gateway/api/public/app-updates/v1/change-details/${id}`);
                const updateDetails = (0, $5980852fab81bf32$export$8f438f2e2f3b5ab6).parse(response.data);
                return {
                    ...updateDetails,
                    // Map product key to display name for easier UI rendering
                    productTypes: updateDetails.products?.map((product)=>(0, $d3185276e14a4c2b$export$27e53caf66bae1d)(product)).filter((product)=>product != null)
                };
            } catch (error) {
                // Distinguish Zod schema parse failures (malformed API response) from
                // network/HTTP errors so Sentry gives clearer diagnostics.
                const isParseError = error instanceof Error && error.name === 'ZodError';
                (0, $9654b596cdf679bc$export$2e2bcd8739ae039).error(error, {
                    extra: {
                        updateId: id,
                        action: isParseError ? 'parse-update-details-response' : 'fetch-update-details'
                    }
                });
                throw error;
            }
        }),
        enabled: !!updateId
    });
    return {
        // Data
        update: updateQuery.data,
        isUpdateLoading: updateQuery.isLoading,
        // Error states
        updateError: updateQuery.error,
        hasErrors: !!updateQuery.error
    };
};







var $4Pn6z = parcelRequire("4Pn6z");
var $ifpPH = parcelRequire("ifpPH");

var $bb0Oq = parcelRequire("bb0Oq");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $6JfQX = parcelRequire("6JfQX");

var $kYLlQ = parcelRequire("kYLlQ");

var $6EZ2P = parcelRequire("6EZ2P");

var $gA3qV = parcelRequire("gA3qV");
var $f127cdcabdc66218$export$8c8f6d8f1fa796f0 = 'fabricEditorCtx';
var $f127cdcabdc66218$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    EDITOR_APPEARANCE_CONTEXT["MAX"] = "max";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
var $f127cdcabdc66218$export$629cada6c5e621e1 = (0, $gA3qV.default)($f127cdcabdc66218$export$8c8f6d8f1fa796f0, 'FabricEditorAnalyticsContext');



var $jJH6F = parcelRequire("jJH6F");

var $4vXmi = parcelRequire("4vXmi");

var $3tz1M = parcelRequire("3tz1M");
var $9ab1e55a80cda9a2$export$da873e3c90937d2a = function isPanelNestingTableSupported(schema) {
    var _panel_c1$contentMatc;
    var _schema$nodes = schema.nodes, table = _schema$nodes.table, panel_c1 = _schema$nodes.panel_c1;
    if (!table || !panel_c1) return false;
    // Confirm the PM schema actually allows table inside panel_c1
    var panelC1CanContainTable = ((_panel_c1$contentMatc = panel_c1.contentMatch.matchType(table)) === null || _panel_c1$contentMatc === void 0 ? void 0 : _panel_c1$contentMatc.validEnd) === true;
    return panelC1CanContainTable && (0, $3tz1M.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true);
};



var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");
var $e07a6647be522254$exports = {};
var $31ae822182fad2a0$exports = {};

var $duo48 = parcelRequire("duo48");
var $c7f6974ab15fcc4d$exports = {};
var $9362cde0037d9446$exports = {};

var $5rVTQ = parcelRequire("5rVTQ");

var $3gUX4 = parcelRequire("3gUX4");

var $aqMZB = parcelRequire("aqMZB");

var $duo48 = parcelRequire("duo48");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $9362cde0037d9446$var$createCaseFirst(methodName) {
    return function(string) {
        string = $duo48(string);
        var strSymbols = $3gUX4(string) ? $aqMZB(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $5rVTQ(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$9362cde0037d9446$exports = $9362cde0037d9446$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $c7f6974ab15fcc4d$var$upperFirst = $9362cde0037d9446$exports('toUpperCase');
$c7f6974ab15fcc4d$exports = $c7f6974ab15fcc4d$var$upperFirst;


/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $31ae822182fad2a0$var$capitalize(string) {
    return $c7f6974ab15fcc4d$exports($duo48(string).toLowerCase());
}
$31ae822182fad2a0$exports = $31ae822182fad2a0$var$capitalize;


var $ae50d2e87a5da0cc$exports = {};
var $62a63c1eb65a1440$exports = {};
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $62a63c1eb65a1440$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
$62a63c1eb65a1440$exports = $62a63c1eb65a1440$var$arrayReduce;



var $l75Tm = parcelRequire("l75Tm");
var $e7dc26b72a5cbbb7$exports = {};
var $14f580510cd13668$exports = {};
/** Used to match words composed of alphanumeric characters. */ var $14f580510cd13668$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $14f580510cd13668$var$asciiWords(string) {
    return string.match($14f580510cd13668$var$reAsciiWord) || [];
}
$14f580510cd13668$exports = $14f580510cd13668$var$asciiWords;


var $9f5ddde4b9906afb$exports = {};
/** Used to detect strings that need a more robust regexp to match words. */ var $9f5ddde4b9906afb$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $9f5ddde4b9906afb$var$hasUnicodeWord(string) {
    return $9f5ddde4b9906afb$var$reHasUnicodeWord.test(string);
}
$9f5ddde4b9906afb$exports = $9f5ddde4b9906afb$var$hasUnicodeWord;



var $duo48 = parcelRequire("duo48");
var $aa870181a19f30d4$exports = {};
/** Used to compose unicode character classes. */ var $aa870181a19f30d4$var$rsAstralRange = '\\ud800-\\udfff', $aa870181a19f30d4$var$rsComboMarksRange = '\\u0300-\\u036f', $aa870181a19f30d4$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $aa870181a19f30d4$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $aa870181a19f30d4$var$rsComboRange = $aa870181a19f30d4$var$rsComboMarksRange + $aa870181a19f30d4$var$reComboHalfMarksRange + $aa870181a19f30d4$var$rsComboSymbolsRange, $aa870181a19f30d4$var$rsDingbatRange = '\\u2700-\\u27bf', $aa870181a19f30d4$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $aa870181a19f30d4$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $aa870181a19f30d4$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $aa870181a19f30d4$var$rsPunctuationRange = '\\u2000-\\u206f', $aa870181a19f30d4$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $aa870181a19f30d4$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $aa870181a19f30d4$var$rsVarRange = '\\ufe0e\\ufe0f', $aa870181a19f30d4$var$rsBreakRange = $aa870181a19f30d4$var$rsMathOpRange + $aa870181a19f30d4$var$rsNonCharRange + $aa870181a19f30d4$var$rsPunctuationRange + $aa870181a19f30d4$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $aa870181a19f30d4$var$rsApos = "['\u2019]", $aa870181a19f30d4$var$rsBreak = '[' + $aa870181a19f30d4$var$rsBreakRange + ']', $aa870181a19f30d4$var$rsCombo = '[' + $aa870181a19f30d4$var$rsComboRange + ']', $aa870181a19f30d4$var$rsDigits = '\\d+', $aa870181a19f30d4$var$rsDingbat = '[' + $aa870181a19f30d4$var$rsDingbatRange + ']', $aa870181a19f30d4$var$rsLower = '[' + $aa870181a19f30d4$var$rsLowerRange + ']', $aa870181a19f30d4$var$rsMisc = '[^' + $aa870181a19f30d4$var$rsAstralRange + $aa870181a19f30d4$var$rsBreakRange + $aa870181a19f30d4$var$rsDigits + $aa870181a19f30d4$var$rsDingbatRange + $aa870181a19f30d4$var$rsLowerRange + $aa870181a19f30d4$var$rsUpperRange + ']', $aa870181a19f30d4$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $aa870181a19f30d4$var$rsModifier = '(?:' + $aa870181a19f30d4$var$rsCombo + '|' + $aa870181a19f30d4$var$rsFitz + ')', $aa870181a19f30d4$var$rsNonAstral = '[^' + $aa870181a19f30d4$var$rsAstralRange + ']', $aa870181a19f30d4$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $aa870181a19f30d4$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $aa870181a19f30d4$var$rsUpper = '[' + $aa870181a19f30d4$var$rsUpperRange + ']', $aa870181a19f30d4$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $aa870181a19f30d4$var$rsMiscLower = '(?:' + $aa870181a19f30d4$var$rsLower + '|' + $aa870181a19f30d4$var$rsMisc + ')', $aa870181a19f30d4$var$rsMiscUpper = '(?:' + $aa870181a19f30d4$var$rsUpper + '|' + $aa870181a19f30d4$var$rsMisc + ')', $aa870181a19f30d4$var$rsOptContrLower = '(?:' + $aa870181a19f30d4$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $aa870181a19f30d4$var$rsOptContrUpper = '(?:' + $aa870181a19f30d4$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $aa870181a19f30d4$var$reOptMod = $aa870181a19f30d4$var$rsModifier + '?', $aa870181a19f30d4$var$rsOptVar = '[' + $aa870181a19f30d4$var$rsVarRange + ']?', $aa870181a19f30d4$var$rsOptJoin = '(?:' + $aa870181a19f30d4$var$rsZWJ + '(?:' + [
    $aa870181a19f30d4$var$rsNonAstral,
    $aa870181a19f30d4$var$rsRegional,
    $aa870181a19f30d4$var$rsSurrPair
].join('|') + ')' + $aa870181a19f30d4$var$rsOptVar + $aa870181a19f30d4$var$reOptMod + ')*', $aa870181a19f30d4$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $aa870181a19f30d4$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $aa870181a19f30d4$var$rsSeq = $aa870181a19f30d4$var$rsOptVar + $aa870181a19f30d4$var$reOptMod + $aa870181a19f30d4$var$rsOptJoin, $aa870181a19f30d4$var$rsEmoji = '(?:' + [
    $aa870181a19f30d4$var$rsDingbat,
    $aa870181a19f30d4$var$rsRegional,
    $aa870181a19f30d4$var$rsSurrPair
].join('|') + ')' + $aa870181a19f30d4$var$rsSeq;
/** Used to match complex or compound words. */ var $aa870181a19f30d4$var$reUnicodeWord = RegExp([
    $aa870181a19f30d4$var$rsUpper + '?' + $aa870181a19f30d4$var$rsLower + '+' + $aa870181a19f30d4$var$rsOptContrLower + '(?=' + [
        $aa870181a19f30d4$var$rsBreak,
        $aa870181a19f30d4$var$rsUpper,
        '$'
    ].join('|') + ')',
    $aa870181a19f30d4$var$rsMiscUpper + '+' + $aa870181a19f30d4$var$rsOptContrUpper + '(?=' + [
        $aa870181a19f30d4$var$rsBreak,
        $aa870181a19f30d4$var$rsUpper + $aa870181a19f30d4$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $aa870181a19f30d4$var$rsUpper + '?' + $aa870181a19f30d4$var$rsMiscLower + '+' + $aa870181a19f30d4$var$rsOptContrLower,
    $aa870181a19f30d4$var$rsUpper + '+' + $aa870181a19f30d4$var$rsOptContrUpper,
    $aa870181a19f30d4$var$rsOrdUpper,
    $aa870181a19f30d4$var$rsOrdLower,
    $aa870181a19f30d4$var$rsDigits,
    $aa870181a19f30d4$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $aa870181a19f30d4$var$unicodeWords(string) {
    return string.match($aa870181a19f30d4$var$reUnicodeWord) || [];
}
$aa870181a19f30d4$exports = $aa870181a19f30d4$var$unicodeWords;


/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $e7dc26b72a5cbbb7$var$words(string, pattern, guard) {
    string = $duo48(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $9f5ddde4b9906afb$exports(string) ? $aa870181a19f30d4$exports(string) : $14f580510cd13668$exports(string);
    return string.match(pattern) || [];
}
$e7dc26b72a5cbbb7$exports = $e7dc26b72a5cbbb7$var$words;


/** Used to compose unicode capture groups. */ var $ae50d2e87a5da0cc$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $ae50d2e87a5da0cc$var$reApos = RegExp($ae50d2e87a5da0cc$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $ae50d2e87a5da0cc$var$createCompounder(callback) {
    return function(string) {
        return $62a63c1eb65a1440$exports($e7dc26b72a5cbbb7$exports($l75Tm(string).replace($ae50d2e87a5da0cc$var$reApos, '')), callback, '');
    };
}
$ae50d2e87a5da0cc$exports = $ae50d2e87a5da0cc$var$createCompounder;


/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $e07a6647be522254$var$camelCase = $ae50d2e87a5da0cc$exports(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $31ae822182fad2a0$exports(word) : word);
});
$e07a6647be522254$exports = $e07a6647be522254$var$camelCase;


var $6e1a6a485b4d6431$exports = {};

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $6e1a6a485b4d6431$var$kebabCase = $ae50d2e87a5da0cc$exports(function(result, word, index) {
    return result + (index ? '-' : '') + word.toLowerCase();
});
$6e1a6a485b4d6431$exports = $6e1a6a485b4d6431$var$kebabCase;



var $e3d31a87077225d6$var$EMPTY = {};
function $e3d31a87077225d6$var$isObjectFlagKey(key, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value, objectFlagKeys) {
    return Boolean(typeof value === 'string' && (objectFlagKeys === null || objectFlagKeys === void 0 ? void 0 : objectFlagKeys.includes(key)));
}
function $e3d31a87077225d6$var$isValidJSONObject(value) {
    try {
        var result = JSON.parse(value);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(result) === 'object' && result !== null) return true;
        return false;
    } catch (err) {
        return false;
    }
}
function $e3d31a87077225d6$export$f1485fc4974593c0(rawFeatureFlags, options) {
    if (!rawFeatureFlags) return $e3d31a87077225d6$var$EMPTY;
    return Object.entries(rawFeatureFlags).filter(function(e) {
        if (typeof e[1] === 'boolean') return true;
        if ($e3d31a87077225d6$var$isObjectFlagKey((0, (/*@__PURE__*/$parcel$interopDefault($e07a6647be522254$exports)))(e[0]), e[1], options === null || options === void 0 ? void 0 : options.objectFlagKeys) && $e3d31a87077225d6$var$isValidJSONObject(e[1])) return true;
        return false;
    }).filter(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key = _ref2[0];
        return (0, (/*@__PURE__*/$parcel$interopDefault($6e1a6a485b4d6431$exports)))(key) === key;
    }).map(function(_ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), key = _ref4[0], value = _ref4[1];
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($e07a6647be522254$exports)))(key),
            value
        ];
    }).reduce(function(flags, _ref5) {
        var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
        if ($e3d31a87077225d6$var$isObjectFlagKey(key, value, options === null || options === void 0 ? void 0 : options.objectFlagKeys)) flags[key] = JSON.parse(value);
        if (typeof value === 'boolean') flags[key] = value;
        return flags;
    }, {});
}


function $c36e43bb0ca44327$export$48995af1e77d8643() {
    return !!(typeof window !== 'undefined' && 'PerformanceObserver' in window);
}


var $3be21b4824eb4ce4$var$hasRequiredPerformanceAPIs;
function $3be21b4824eb4ce4$export$b5717a625dd4a3eb() {
    if ($3be21b4824eb4ce4$var$hasRequiredPerformanceAPIs === undefined) $3be21b4824eb4ce4$var$hasRequiredPerformanceAPIs = typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType',
        'now'
    ].every(function(api) {
        return !!performance[api];
    });
    return $3be21b4824eb4ce4$var$hasRequiredPerformanceAPIs;
}
function $3be21b4824eb4ce4$export$4370ec0f52022f66() {
    return (0, $c36e43bb0ca44327$export$48995af1e77d8643)() && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
}


var $f3813def174ce227$var$measureMap = new Map();
function $f3813def174ce227$export$b62aa2130c86b59b(measureName) {
    if (!(0, $3be21b4824eb4ce4$export$b5717a625dd4a3eb)()) return;
    performance.mark("".concat(measureName, "::start"));
    $f3813def174ce227$var$measureMap.set(measureName, performance.now());
}
function $f3813def174ce227$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!(0, $3be21b4824eb4ce4$export$b5717a625dd4a3eb)()) return;
    performance.mark("".concat(measureName, "::end"));
    var start = onMeasureComplete ? $f3813def174ce227$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, "".concat(measureName, "::start"), "".concat(measureName, "::end"));
    } catch (error) {} finally{
        if (onMeasureComplete) {
            var entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $f3813def174ce227$export$6f766653554dac02(measureName);
    }
}
function $f3813def174ce227$export$6f766653554dac02(measureName) {
    if (!(0, $3be21b4824eb4ce4$export$b5717a625dd4a3eb)()) return;
    $f3813def174ce227$var$measureMap.delete(measureName);
    performance.clearMarks("".concat(measureName, "::start"));
    performance.clearMarks("".concat(measureName, "::end"));
    performance.clearMeasures(measureName);
}
function $f3813def174ce227$export$b0a51f9f0047ea32(measureName) {
    if (!(0, $3be21b4824eb4ce4$export$b5717a625dd4a3eb)()) return false;
    return $f3813def174ce227$var$measureMap.get(measureName) !== undefined;
}



var $6f06f484c7500059$export$70f7d127254a90c = function getDistortedDurationMonitor() {
    if (typeof document === 'undefined') return {
        distortedDuration: false,
        cleanup: function cleanup() {}
    };
    // If an editor is rendered when the document is not visible -- the callback passed to
    // requestAnimationFrame will not fire until the document becomes visible again.
    //
    // For the purposes of using performance measurement -- this behaviour means the events
    // which have been fired in the background are not useful -- and lead to other events
    // being hard to draw conclusions from.
    //
    // To mitigate this -- we detect this state -- and fire a separate callback when the
    // measurement has occurred when the render was in the background
    var distortedDuration = document.visibilityState !== 'visible';
    function handleVisibilityChange() {
        if (document.visibilityState !== 'visible') distortedDuration = true;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return {
        distortedDuration: distortedDuration,
        /**
     * Cleans up the document visibility event listener
     */ cleanup: function cleanup() {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
    };
};
function $6f06f484c7500059$export$267ed650a5d21ae6(/**
 * Unique name for the measurement
 *
 * Important: if multiple measureRender events are fired at the same time
 * with the same measure name -- the result will not be correct.
 */ measureName, /**
 * Call back fired when the measurement completes.
 *
 * Note: when this function is called when the Document.visibilityState is not
 * visible -- the duration is likely to be misleading/inaccurate. This is due
 * to the measurements use of the `requestAnimationFrame` api which only fires
 * when the Document.visibilityState is visible.
 */ onMeasureComplete) {
    if (!(0, $3be21b4824eb4ce4$export$b5717a625dd4a3eb)()) return;
    var startMark = "[START]: ".concat(measureName);
    var endMark = "[END]: ".concat(measureName);
    var startTime = performance.now();
    performance.mark(startMark);
    var distortedDurationMonitor = $6f06f484c7500059$export$70f7d127254a90c();
    requestAnimationFrame(function() {
        requestAnimationFrame(function() {
            performance.mark(endMark);
            distortedDurationMonitor.cleanup();
            var duration = performance.now() - startTime;
            try {
                performance.measure(measureName, startMark, endMark);
                var entry = performance.getEntriesByName(measureName).pop();
                if (!entry) onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
                else onMeasureComplete({
                    duration: entry.duration,
                    startTime: entry.startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            } catch (e) {
                onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            }
            performance.clearMeasures(measureName);
            performance.clearMarks(startMark);
            performance.clearMarks(endMark);
        });
    });
}



function $9e179070c6de461e$export$92d097a1155bbe27() {
    if (!(0, $3be21b4824eb4ce4$export$b5717a625dd4a3eb)()) return;
    var nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd;
    return;
}



var $fBC68 = parcelRequire("fBC68");
var $d0n7Z = parcelRequire("d0n7Z");

var $kMHA5 = parcelRequire("kMHA5");
var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $9Pk7k = parcelRequire("9Pk7k");
function $de1783a2fb838cfd$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $de1783a2fb838cfd$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $de1783a2fb838cfd$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($de1783a2fb838cfd$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $de1783a2fb838cfd$export$c7ef921528e1d279 = '<IntlProvider> needs to exist in the component ancestry';
var $de1783a2fb838cfd$var$isMissingIntlProviderInAncestryError = function isMissingIntlProviderInAncestryError(err) {
    var _err$toString;
    return err === null || err === void 0 || (_err$toString = err.toString()) === null || _err$toString === void 0 ? void 0 : _err$toString.includes('<IntlProvider> needs to exist in the component ancestry');
};
var $de1783a2fb838cfd$export$7df0749115d18d19 = /*#__PURE__*/ function(_React$Component) {
    function IntlErrorBoundary() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, IntlErrorBoundary);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $de1783a2fb838cfd$var$_callSuper(this, IntlErrorBoundary, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "state", {
            missingIntlProviderInAncestry: false
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(IntlErrorBoundary, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(IntlErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, _errorInfo) {
                // if missing IntlProvider in ancestry, we setup a fallback IntlProvider ourselves
                if ($de1783a2fb838cfd$var$isMissingIntlProviderInAncestryError(error)) this.setState({
                    missingIntlProviderInAncestry: true
                });
                else // else we re-propagate the non-react-intl error
                throw error;
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.missingIntlProviderInAncestry) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9Pk7k.default), {
                    locale: "en"
                }, this.props.children);
                return this.props.children;
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component);


var $5dFQJ = parcelRequire("5dFQJ");
var $01HkO = parcelRequire("01HkO");parcelRequire("dujqE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $5FkrB = parcelRequire("5FkrB");

var $fbEFz = parcelRequire("fbEFz");
function $8d472cee2b63d31a$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $8d472cee2b63d31a$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $8d472cee2b63d31a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($8d472cee2b63d31a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $8d472cee2b63d31a$export$9ac3d19711324187 = (0, $fbEFz.default)()(/*#__PURE__*/ function(_React$Component) {
    function WithCreateAnalyticsEvent() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, WithCreateAnalyticsEvent);
        return $8d472cee2b63d31a$var$_callSuper(this, WithCreateAnalyticsEvent, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(WithCreateAnalyticsEvent, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(WithCreateAnalyticsEvent, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, render = _this$props.render, createAnalyticsEvent = _this$props.createAnalyticsEvent;
                return render(createAnalyticsEvent);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component));



var $ee2b8b656f6cf8d3$export$be87849653b93e6b = function getAnalyticsAppearance(appearance) {
    switch(appearance){
        case 'full-page':
            return (0, $f127cdcabdc66218$export$9eb2b47430ed3f7c).FIXED_WIDTH;
        case 'full-width':
            return (0, $f127cdcabdc66218$export$9eb2b47430ed3f7c).FULL_WIDTH;
        case 'comment':
            return (0, $f127cdcabdc66218$export$9eb2b47430ed3f7c).COMMENT;
        case 'chromeless':
            return (0, $f127cdcabdc66218$export$9eb2b47430ed3f7c).CHROMELESS;
        case 'mobile':
            return (0, $f127cdcabdc66218$export$9eb2b47430ed3f7c).MOBILE;
        case 'max':
            return (0, $f127cdcabdc66218$export$9eb2b47430ed3f7c).MAX;
    }
};


var $8dd23b27bccc895e$export$6a6bef12562cd865 = /*#__PURE__*/ function(SEVERITY) {
    SEVERITY["NORMAL"] = "normal";
    SEVERITY["DEGRADED"] = "degraded";
    SEVERITY["BLOCKING"] = "blocking";
    return SEVERITY;
}({});



var $577d48613d9afb24$export$31ae53e002edded0 = function getAnalyticsEditorAppearance(editorAppearance) {
    return editorAppearance ? "editor_".concat((0, $ee2b8b656f6cf8d3$export$be87849653b93e6b)(editorAppearance)) : '_unknown';
};
var $577d48613d9afb24$export$f8edd689e8b20f3a = function getAnalyticsEventSeverity(duration, normalThreshold, degradedThreshold) {
    if (duration > normalThreshold && duration <= degradedThreshold) return (0, $8dd23b27bccc895e$export$6a6bef12562cd865).DEGRADED;
    if (duration > degradedThreshold) return (0, $8dd23b27bccc895e$export$6a6bef12562cd865).BLOCKING;
    return (0, $8dd23b27bccc895e$export$6a6bef12562cd865).NORMAL;
};
var $577d48613d9afb24$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';
var $577d48613d9afb24$var$EDITOR_BREAKPOINT_WIDTH = {
    S: 760,
    M: 1600,
    L: Infinity
};
var $577d48613d9afb24$var$TABLE_BREAKPOINT_KEYS = Object.keys($577d48613d9afb24$var$EDITOR_BREAKPOINT_WIDTH);
var $577d48613d9afb24$export$afdcbbd112676ca8 = function getBreakpointKey(width) {
    return $577d48613d9afb24$var$TABLE_BREAKPOINT_KEYS.find(function(key) {
        return width <= $577d48613d9afb24$var$EDITOR_BREAKPOINT_WIDTH[key];
    }) || 'L';
};

// START: temporary code https://product-fabric.atlassian.net/browse/ED-10260
var $52c73f50bcd8b255$export$5b59d3e9e22dbdc6 = function shouldForceTracking() {
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var _ref = window.__buildInfo || {}, _ref$FRONTEND_VERSION = _ref.FRONTEND_VERSION, FRONTEND_VERSION = _ref$FRONTEND_VERSION === void 0 ? '' : _ref$FRONTEND_VERSION;
        return window.location.hostname === 'product-fabric.atlassian.net' && FRONTEND_VERSION.includes('branch-deploy');
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
        return false;
    }
}; // END:  temporary code  https://product-fabric.atlassian.net/browse/ED-10260



var $jkJfI = parcelRequire("jkJfI");

var $j3BGx = parcelRequire("j3BGx");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $fC8ib = parcelRequire("fC8ib");



function $d59df72c0fedc43c$export$e54c9225ca52acc(node) {
    var tableColumnWidths = [];
    node.forEach(function(row) {
        var currentTableWidth = [];
        row.forEach(function(cell) {
            var _ref = cell.attrs, colspan = _ref.colspan, colwidth = _ref.colwidth;
            // column has been resized, colWidth will be an array, can safely take values even if cell is merged
            if (Array.isArray(colwidth)) currentTableWidth.push.apply(currentTableWidth, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(colwidth));
            else if (colspan !== undefined && colspan > 1) currentTableWidth.push.apply(currentTableWidth, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array(colspan).fill(0)));
            else currentTableWidth.push(0);
        });
        if (currentTableWidth.length > tableColumnWidths.length) tableColumnWidths = currentTableWidth;
    });
    return tableColumnWidths;
}
function $d59df72c0fedc43c$export$98951d3cdcfd364b(node) {
    var firstRow = node.firstChild;
    var tableColumnWidths = [];
    if (firstRow) firstRow.forEach(function(cell) {
        var _cell$attrs = cell.attrs, colspan = _cell$attrs.colspan, colwidth = _cell$attrs.colwidth;
        // column has been resized, colWidth will be an array, can safely take values even if cell is merged
        if (Array.isArray(colwidth)) tableColumnWidths.push.apply(tableColumnWidths, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(colwidth));
        else if (colspan > 1) tableColumnWidths.push.apply(tableColumnWidths, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array(colspan).fill(0)));
        else tableColumnWidths.push(0);
    });
    return tableColumnWidths;
}



var $25nEq = parcelRequire("25nEq");

var $fC8ib = parcelRequire("fC8ib");
// eslint-disable-next-line import/no-namespace
var $ca34ec1511716185$exports = {};
$parcel$export($ca34ec1511716185$exports, "expandWithNestedExpand", () => (parcelRequire("4eHHu")).expandWithNestedExpand);
$parcel$export($ca34ec1511716185$exports, "expandWithNestedExpandLocalId", () => (parcelRequire("4eHHu")).expandWithNestedExpandLocalId);
$parcel$export($ca34ec1511716185$exports, "expandToJSON", () => (parcelRequire("4eHHu")).toJSON);
$parcel$export($ca34ec1511716185$exports, "confluenceJiraIssue", () => (parcelRequire("ds6FG")).confluenceJiraIssue);
$parcel$export($ca34ec1511716185$exports, "confluenceUnsupportedBlock", () => (parcelRequire("28jyL")).confluenceUnsupportedBlock);
$parcel$export($ca34ec1511716185$exports, "confluenceUnsupportedInline", () => (parcelRequire("h4Vhg")).confluenceUnsupportedInline);
$parcel$export($ca34ec1511716185$exports, "doc", () => (parcelRequire("cO5dd")).doc);
$parcel$export($ca34ec1511716185$exports, "blockquote", () => (parcelRequire("kUp6y")).blockquote);
$parcel$export($ca34ec1511716185$exports, "extendedBlockquote", () => (parcelRequire("kUp6y")).extendedBlockquote);
$parcel$export($ca34ec1511716185$exports, "extendedBlockquoteWithLocalId", () => (parcelRequire("kUp6y")).extendedBlockquoteWithLocalId);
$parcel$export($ca34ec1511716185$exports, "bulletList", () => (parcelRequire("gBea6")).bulletList);
$parcel$export($ca34ec1511716185$exports, "bulletListSelector", () => (parcelRequire("gBea6")).bulletListSelector);
$parcel$export($ca34ec1511716185$exports, "bulletListWithLocalId", () => (parcelRequire("gBea6")).bulletListWithLocalId);
$parcel$export($ca34ec1511716185$exports, "codeBlock", () => (parcelRequire("enrSO")).codeBlock);
$parcel$export($ca34ec1511716185$exports, "codeBlockWithLocalId", () => (parcelRequire("enrSO")).codeBlockWithLocalId);
$parcel$export($ca34ec1511716185$exports, "codeBlockToJSON", () => (parcelRequire("enrSO")).toJSON);
$parcel$export($ca34ec1511716185$exports, "hardBreak", () => (parcelRequire("blZvD")).hardBreak);
$parcel$export($ca34ec1511716185$exports, "heading", () => (parcelRequire("lta2M")).heading);
$parcel$export($ca34ec1511716185$exports, "rule", () => (parcelRequire("e29IV")).rule);
$parcel$export($ca34ec1511716185$exports, "ruleWithLocalId", () => (parcelRequire("e29IV")).ruleWithLocalId);
$parcel$export($ca34ec1511716185$exports, "ruleRootOnlyStage0", () => (parcelRequire("e29IV")).ruleRootOnlyStage0);
$parcel$export($ca34ec1511716185$exports, "orderedList", () => (parcelRequire("5MY3X")).orderedList);
$parcel$export($ca34ec1511716185$exports, "orderedListSelector", () => (parcelRequire("5MY3X")).orderedListSelector);
$parcel$export($ca34ec1511716185$exports, "orderedListWithLocalId", () => (parcelRequire("5MY3X")).orderedListWithLocalId);
$parcel$export($ca34ec1511716185$exports, "orderedListWithOrder", () => (parcelRequire("5MY3X")).orderedListWithOrder);
$parcel$export($ca34ec1511716185$exports, "orderedListWithOrderAndLocalId", () => (parcelRequire("5MY3X")).orderedListWithOrderAndLocalId);
$parcel$export($ca34ec1511716185$exports, "paragraph", () => (parcelRequire("91Dmj")).paragraph);
$parcel$export($ca34ec1511716185$exports, "emoji", () => (parcelRequire("r9xZG")).emoji);
$parcel$export($ca34ec1511716185$exports, "emojiWithLocalId", () => (parcelRequire("r9xZG")).emojiWithLocalId);
$parcel$export($ca34ec1511716185$exports, "image", () => (parcelRequire("7S1Am")).image);
$parcel$export($ca34ec1511716185$exports, "mention", () => (parcelRequire("kZNkK")).mention);
$parcel$export($ca34ec1511716185$exports, "mentionToJSON", () => (parcelRequire("kZNkK")).toJSON);
$parcel$export($ca34ec1511716185$exports, "listItem", () => (parcelRequire("2Ji8g")).listItem);
$parcel$export($ca34ec1511716185$exports, "listItemWithLocalId", () => (parcelRequire("2Ji8g")).listItemWithLocalId);
$parcel$export($ca34ec1511716185$exports, "extendedPanelC1RootOnlyStage0", () => (parcelRequire("NggDw")).extendedPanelC1RootOnlyStage0);
$parcel$export($ca34ec1511716185$exports, "extendedPanelC1WithLocalId", () => (parcelRequire("bPF1d")).extendedPanelC1WithLocalId);
$parcel$export($ca34ec1511716185$exports, "extendedPanelC1", () => (parcelRequire("eswVP")).extendedPanelC1);
$parcel$export($ca34ec1511716185$exports, "extendedPanelRootOnlyStage0", () => (parcelRequire("gXBJA")).extendedPanelRootOnlyStage0);
$parcel$export($ca34ec1511716185$exports, "extendedPanelWithLocalId", () => (parcelRequire("6DMV8")).extendedPanelWithLocalId);
$parcel$export($ca34ec1511716185$exports, "extendedPanel", () => (parcelRequire("js3fs")).extendedPanel);
$parcel$export($ca34ec1511716185$exports, "PanelType", () => (parcelRequire("18mVh")).PanelType);
$parcel$export($ca34ec1511716185$exports, "text", () => (parcelRequire("lPSeS")).text);
$parcel$export($ca34ec1511716185$exports, "unknownBlock", () => (parcelRequire("zEe3b")).default);
$parcel$export($ca34ec1511716185$exports, "caption", () => (parcelRequire("gBtp4")).caption);
$parcel$export($ca34ec1511716185$exports, "captionWithLocalId", () => (parcelRequire("gBtp4")).captionWithLocalId);
$parcel$export($ca34ec1511716185$exports, "copyPrivateMediaAttributes", () => (parcelRequire("ajKZr")).copyPrivateAttributes);
$parcel$export($ca34ec1511716185$exports, "media", () => (parcelRequire("6wWv8")).media);
$parcel$export($ca34ec1511716185$exports, "mediaToJSON", () => (parcelRequire("69D6c")).toJSON);
$parcel$export($ca34ec1511716185$exports, "mediaGroup", () => (parcelRequire("21g1t")).mediaGroup);
$parcel$export($ca34ec1511716185$exports, "mediaInline", () => (parcelRequire("jzlkh")).mediaInline);
$parcel$export($ca34ec1511716185$exports, "mediaSingleSpec", () => (parcelRequire("5HFOg")).mediaSingleSpec);
$parcel$export($ca34ec1511716185$exports, "mediaSingle", () => (parcelRequire("8JhSw")).mediaSingle);
$parcel$export($ca34ec1511716185$exports, "mediaSingleFull", () => (parcelRequire("8JhSw")).mediaSingleFull);
$parcel$export($ca34ec1511716185$exports, "mediaSingleFullWithLocalId", () => (parcelRequire("8JhSw")).mediaSingleFullWithLocalId);
$parcel$export($ca34ec1511716185$exports, "mediaSingleWithCaption", () => (parcelRequire("8JhSw")).mediaSingleWithCaption);
$parcel$export($ca34ec1511716185$exports, "mediaSingleWithWidthType", () => (parcelRequire("8JhSw")).mediaSingleWithWidthType);
$parcel$export($ca34ec1511716185$exports, "mediaSingleToJSON", () => (parcelRequire("eQlOO")).toJSON);
$parcel$export($ca34ec1511716185$exports, "table", () => (parcelRequire("gc8Zd")).table);
$parcel$export($ca34ec1511716185$exports, "tableWithNestedTable", () => (parcelRequire("gc8Zd")).tableWithNestedTable);
$parcel$export($ca34ec1511716185$exports, "tableRowWithNestedTable", () => (parcelRequire("gc8Zd")).tableRowWithNestedTable);
$parcel$export($ca34ec1511716185$exports, "tableCellWithNestedTable", () => (parcelRequire("gc8Zd")).tableCellWithNestedTable);
$parcel$export($ca34ec1511716185$exports, "tableHeaderWithNestedTable", () => (parcelRequire("gc8Zd")).tableHeaderWithNestedTable);
$parcel$export($ca34ec1511716185$exports, "tableCellStage0", () => (parcelRequire("gc8Zd")).tableCellStage0);
$parcel$export($ca34ec1511716185$exports, "tableHeaderStage0", () => (parcelRequire("gc8Zd")).tableHeaderStage0);
$parcel$export($ca34ec1511716185$exports, "tableCellWithNestedTableStage0", () => (parcelRequire("gc8Zd")).tableCellWithNestedTableStage0);
$parcel$export($ca34ec1511716185$exports, "tableHeaderWithNestedTableStage0", () => (parcelRequire("gc8Zd")).tableHeaderWithNestedTableStage0);
$parcel$export($ca34ec1511716185$exports, "tableRowWithLocalId", () => (parcelRequire("gc8Zd")).tableRowWithLocalId);
$parcel$export($ca34ec1511716185$exports, "tableCellWithLocalId", () => (parcelRequire("gc8Zd")).tableCellWithLocalId);
$parcel$export($ca34ec1511716185$exports, "tableHeaderWithLocalId", () => (parcelRequire("gc8Zd")).tableHeaderWithLocalId);
$parcel$export($ca34ec1511716185$exports, "tableRowWithNestedTableWithLocalId", () => (parcelRequire("gc8Zd")).tableRowWithNestedTableWithLocalId);
$parcel$export($ca34ec1511716185$exports, "tableCellWithNestedTableWithLocalId", () => (parcelRequire("gc8Zd")).tableCellWithNestedTableWithLocalId);
$parcel$export($ca34ec1511716185$exports, "tableHeaderWithNestedTableWithLocalId", () => (parcelRequire("gc8Zd")).tableHeaderWithNestedTableWithLocalId);
$parcel$export($ca34ec1511716185$exports, "tableStage0", () => (parcelRequire("gc8Zd")).tableStage0);
$parcel$export($ca34ec1511716185$exports, "tableWithCustomWidth", () => (parcelRequire("gc8Zd")).tableWithCustomWidth);
$parcel$export($ca34ec1511716185$exports, "tableToJSON", () => (parcelRequire("gc8Zd")).tableToJSON);
$parcel$export($ca34ec1511716185$exports, "tableCell", () => (parcelRequire("gc8Zd")).tableCell);
$parcel$export($ca34ec1511716185$exports, "toJSONTableCell", () => (parcelRequire("gc8Zd")).toJSONTableCell);
$parcel$export($ca34ec1511716185$exports, "tableHeader", () => (parcelRequire("gc8Zd")).tableHeader);
$parcel$export($ca34ec1511716185$exports, "toJSONTableHeader", () => (parcelRequire("gc8Zd")).toJSONTableHeader);
$parcel$export($ca34ec1511716185$exports, "tableRow", () => (parcelRequire("gc8Zd")).tableRow);
$parcel$export($ca34ec1511716185$exports, "tableBackgroundColorPalette", () => (parcelRequire("gc8Zd")).tableBackgroundColorPalette);
$parcel$export($ca34ec1511716185$exports, "tableBackgroundColorPaletteNew", () => (parcelRequire("gc8Zd")).tableBackgroundColorPaletteNew);
$parcel$export($ca34ec1511716185$exports, "tableBackgroundBorderColor", () => (parcelRequire("gc8Zd")).tableBackgroundBorderColor);
$parcel$export($ca34ec1511716185$exports, "tableBackgroundColorNames", () => (parcelRequire("gc8Zd")).tableBackgroundColorNames);
$parcel$export($ca34ec1511716185$exports, "getCellAttrs", () => (parcelRequire("gc8Zd")).getCellAttrs);
$parcel$export($ca34ec1511716185$exports, "getCellDomAttrs", () => (parcelRequire("gc8Zd")).getCellDomAttrs);
$parcel$export($ca34ec1511716185$exports, "tablePrefixSelector", () => (parcelRequire("gc8Zd")).tablePrefixSelector);
$parcel$export($ca34ec1511716185$exports, "tableCellSelector", () => (parcelRequire("gc8Zd")).tableCellSelector);
$parcel$export($ca34ec1511716185$exports, "tableHeaderSelector", () => (parcelRequire("gc8Zd")).tableHeaderSelector);
$parcel$export($ca34ec1511716185$exports, "tableCellContentWrapperSelector", () => (parcelRequire("gc8Zd")).tableCellContentWrapperSelector);
$parcel$export($ca34ec1511716185$exports, "tableCellContentDomSelector", () => (parcelRequire("gc8Zd")).tableCellContentDomSelector);
$parcel$export($ca34ec1511716185$exports, "decisionList", () => (parcelRequire("6e7am")).decisionList);
$parcel$export($ca34ec1511716185$exports, "decisionListSelector", () => (parcelRequire("6e7am")).decisionListSelector);
$parcel$export($ca34ec1511716185$exports, "decisionItem", () => (parcelRequire("Mas9e")).decisionItem);
$parcel$export($ca34ec1511716185$exports, "taskList", () => (parcelRequire("4VFl9")).taskList);
$parcel$export($ca34ec1511716185$exports, "taskListSelector", () => (parcelRequire("4VFl9")).taskListSelector);
$parcel$export($ca34ec1511716185$exports, "taskItem", () => (parcelRequire("1aipV")).taskItem);
$parcel$export($ca34ec1511716185$exports, "blockTaskItem", () => (parcelRequire("1aipV")).blockTaskItem);
$parcel$export($ca34ec1511716185$exports, "date", () => (parcelRequire("gTQzU")).date);
$parcel$export($ca34ec1511716185$exports, "dateWithLocalId", () => (parcelRequire("gTQzU")).dateWithLocalId);
$parcel$export($ca34ec1511716185$exports, "placeholder", () => (parcelRequire("gAmJ3")).placeholder);
$parcel$export($ca34ec1511716185$exports, "placeholderWithLocalId", () => (parcelRequire("gAmJ3")).placeholderWithLocalId);
$parcel$export($ca34ec1511716185$exports, "layoutSection", () => (parcelRequire("d79nc")).layoutSection);
$parcel$export($ca34ec1511716185$exports, "layoutSectionWithLocalId", () => (parcelRequire("d79nc")).layoutSectionWithLocalId);
$parcel$export($ca34ec1511716185$exports, "layoutSectionWithSingleColumn", () => (parcelRequire("d79nc")).layoutSectionWithSingleColumn);
$parcel$export($ca34ec1511716185$exports, "layoutSectionWithSingleColumnLocalId", () => (parcelRequire("d79nc")).layoutSectionWithSingleColumnLocalId);
$parcel$export($ca34ec1511716185$exports, "layoutColumn", () => (parcelRequire("iXSQk")).layoutColumn);
$parcel$export($ca34ec1511716185$exports, "layoutColumnStage0", () => (parcelRequire("iXSQk")).layoutColumnStage0);
$parcel$export($ca34ec1511716185$exports, "layoutColumnWithLocalId", () => (parcelRequire("iXSQk")).layoutColumnWithLocalId);
$parcel$export($ca34ec1511716185$exports, "inlineCard", () => (parcelRequire("7YGzk")).inlineCard);
$parcel$export($ca34ec1511716185$exports, "inlineCardWithLocalId", () => (parcelRequire("7YGzk")).inlineCardWithLocalId);
$parcel$export($ca34ec1511716185$exports, "blockCard", () => (parcelRequire("TWIcC")).blockCard);
$parcel$export($ca34ec1511716185$exports, "blockCardWithLocalId", () => (parcelRequire("TWIcC")).blockCardWithLocalId);
$parcel$export($ca34ec1511716185$exports, "unsupportedBlock", () => (parcelRequire("hAyYk")).unsupportedBlock);
$parcel$export($ca34ec1511716185$exports, "unsupportedInline", () => (parcelRequire("40acJ")).unsupportedInline);
$parcel$export($ca34ec1511716185$exports, "status", () => (parcelRequire("9IIBj")).status);
$parcel$export($ca34ec1511716185$exports, "nestedExpand", () => (parcelRequire("jOBJC")).nestedExpand);
$parcel$export($ca34ec1511716185$exports, "nestedExpandWithLocalId", () => (parcelRequire("jOBJC")).nestedExpandWithLocalId);
$parcel$export($ca34ec1511716185$exports, "embedCard", () => (parcelRequire("ixGXu")).embedCard);
$parcel$export($ca34ec1511716185$exports, "embedCardWithLocalId", () => (parcelRequire("ixGXu")).embedCardWithLocalId);
$parcel$export($ca34ec1511716185$exports, "extension", () => (parcelRequire("cnShX")).extension);
$parcel$export($ca34ec1511716185$exports, "extensionRootOnlyStage0", () => (parcelRequire("cnShX")).extensionRootOnlyStage0);
$parcel$export($ca34ec1511716185$exports, "inlineExtension", () => (parcelRequire("kuUB8")).inlineExtension);
$parcel$export($ca34ec1511716185$exports, "bodiedExtension", () => (parcelRequire("7wC9F")).bodiedExtension);
$parcel$export($ca34ec1511716185$exports, "bodiedExtensionRootOnlyStage0", () => (parcelRequire("7wC9F")).bodiedExtensionRootOnlyStage0);
$parcel$export($ca34ec1511716185$exports, "extensionFrame", () => (parcelRequire("5vwuc")).extensionFrame);
$parcel$export($ca34ec1511716185$exports, "multiBodiedExtension", () => (parcelRequire("5vwuc")).multiBodiedExtension);
$parcel$export($ca34ec1511716185$exports, "multiBodiedExtensionRootOnlyStage0", () => (parcelRequire("5vwuc")).multiBodiedExtensionRootOnlyStage0);
$parcel$export($ca34ec1511716185$exports, "syncBlock", () => (parcelRequire("hG501")).syncBlock);
$parcel$export($ca34ec1511716185$exports, "bodiedSyncBlock", () => (parcelRequire("aUdhc")).bodiedSyncBlock);
/* eslint-disable @atlaskit/editor/no-re-export */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-re-exports -- Public compatibility re-export.

var $4eHHu = parcelRequire("4eHHu");

var $ds6FG = parcelRequire("ds6FG");

var $28jyL = parcelRequire("28jyL");

var $h4Vhg = parcelRequire("h4Vhg");

var $cO5dd = parcelRequire("cO5dd");

var $kUp6y = parcelRequire("kUp6y");

var $gBea6 = parcelRequire("gBea6");

var $enrSO = parcelRequire("enrSO");

var $blZvD = parcelRequire("blZvD");

var $lta2M = parcelRequire("lta2M");

var $e29IV = parcelRequire("e29IV");

var $5MY3X = parcelRequire("5MY3X");

var $91Dmj = parcelRequire("91Dmj");

var $r9xZG = parcelRequire("r9xZG");

var $7S1Am = parcelRequire("7S1Am");

var $kZNkK = parcelRequire("kZNkK");

var $2Ji8g = parcelRequire("2Ji8g");

var $NggDw = parcelRequire("NggDw");

var $bPF1d = parcelRequire("bPF1d");

var $eswVP = parcelRequire("eswVP");

var $gXBJA = parcelRequire("gXBJA");

var $6DMV8 = parcelRequire("6DMV8");

var $js3fs = parcelRequire("js3fs");

var $18mVh = parcelRequire("18mVh");

var $lPSeS = parcelRequire("lPSeS");

var $zEe3b = parcelRequire("zEe3b");

var $gBtp4 = parcelRequire("gBtp4");

var $ajKZr = parcelRequire("ajKZr");

var $6wWv8 = parcelRequire("6wWv8");

var $69D6c = parcelRequire("69D6c");

var $21g1t = parcelRequire("21g1t");

var $jzlkh = parcelRequire("jzlkh");

var $5HFOg = parcelRequire("5HFOg");

var $8JhSw = parcelRequire("8JhSw");

var $eQlOO = parcelRequire("eQlOO");

var $gc8Zd = parcelRequire("gc8Zd");

var $6e7am = parcelRequire("6e7am");

var $Mas9e = parcelRequire("Mas9e");

var $4VFl9 = parcelRequire("4VFl9");

var $1aipV = parcelRequire("1aipV");

var $gTQzU = parcelRequire("gTQzU");

var $gAmJ3 = parcelRequire("gAmJ3");

var $d79nc = parcelRequire("d79nc");

var $iXSQk = parcelRequire("iXSQk");

var $7YGzk = parcelRequire("7YGzk");

var $TWIcC = parcelRequire("TWIcC");

var $hAyYk = parcelRequire("hAyYk");

var $40acJ = parcelRequire("40acJ");

var $9IIBj = parcelRequire("9IIBj");

var $jOBJC = parcelRequire("jOBJC");

var $ixGXu = parcelRequire("ixGXu");

var $cnShX = parcelRequire("cnShX");

var $kuUB8 = parcelRequire("kuUB8");

var $7wC9F = parcelRequire("7wC9F");

var $5vwuc = parcelRequire("5vwuc");

var $hG501 = parcelRequire("hG501");

var $aUdhc = parcelRequire("aUdhc");
 // eslint-disable-next-line @atlaskit/volt-strict-mode/no-re-exports -- Public compatibility re-export.


// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $1409d8bb605c626a$var$typedNodes = $ca34ec1511716185$exports;
var $1409d8bb605c626a$export$b1f729c6af6f2a6e = new Set(Object.keys($1409d8bb605c626a$var$typedNodes).filter(function(key) {
    return $1409d8bb605c626a$var$typedNodes[key] && $1409d8bb605c626a$var$typedNodes[key].group === 'inline';
}));



var $7JWGN = parcelRequire("7JWGN");

var $18mVh = parcelRequire("18mVh");

var $kYLlQ = parcelRequire("kYLlQ");

var $l4823 = parcelRequire("l4823");

var $50U6m = parcelRequire("50U6m");
var $56aa5c9c50b5698f$export$30f8aa4cc1f8c1cb = function isSubSupType(type) {
    return type === 'sub' || type === 'sup';
};


/*
 * It's important that this order follows the marks rank defined here:
 * https://product-fabric.atlassian.net/wiki/spaces/ETEMP/pages/11174043/Atlassian+Document+Format+-+Internal+documentation#Rank
 */ var $5796c58e5666c0b4$export$62d5811a2955c1d8 = [
    'fragment',
    'link',
    'em',
    'strong',
    'textColor',
    'backgroundColor',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'annotation',
    'dataConsumer'
];




function $5558251c256ad6af$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5558251c256ad6af$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5558251c256ad6af$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5558251c256ad6af$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5558251c256ad6af$export$99a33ed044c278ae = function getMarksByOrder(marks) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(marks).sort(function(a, b) {
        return (0, $5796c58e5666c0b4$export$62d5811a2955c1d8).indexOf(a.type.name) - (0, $5796c58e5666c0b4$export$62d5811a2955c1d8).indexOf(b.type.name);
    });
};
var $5558251c256ad6af$export$fb80336a7e408cb3 = function getValidDocument(doc) {
    var schema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $kYLlQ.defaultSchema);
    var adfStage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'final';
    var node = $5558251c256ad6af$export$81b20b6c83a56bd(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = $5558251c256ad6af$var$wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
var $5558251c256ad6af$var$wrapInlineNodes = function wrapInlineNodes() {
    var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return nodes.map(function(node) {
        return (0, $1409d8bb605c626a$export$b1f729c6af6f2a6e).has(node.type) ? {
            type: 'paragraph',
            content: [
                node
            ]
        } : node;
    });
};
var $5558251c256ad6af$export$fafd4f799ee68da0 = function getValidContent(content) {
    var schema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $kYLlQ.defaultSchema);
    var adfStage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'final';
    return content.map(function(node) {
        return $5558251c256ad6af$export$81b20b6c83a56bd(node, schema, adfStage);
    });
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $5558251c256ad6af$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $5558251c256ad6af$var$RELATIVE_LINK = /^\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $5558251c256ad6af$var$ANCHOR_LINK = /^#/;
var $5558251c256ad6af$var$_flattenUnknownBlockTree = function flattenUnknownBlockTree(node) {
    var schema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $kYLlQ.defaultSchema);
    var adfStage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'final';
    var output = [];
    var isPrevLeafNode = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    for(var i = 0; i < node.content.length; i++){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var childNode = node.content[i];
        var isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) output.push({
                type: 'text',
                text: ' '
            });
            else output.push({
                type: 'hardBreak'
            });
        }
        if (isLeafNode) output.push($5558251c256ad6af$export$81b20b6c83a56bd(childNode, schema, adfStage));
        else output.push.apply(output, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))($5558251c256ad6af$var$_flattenUnknownBlockTree(childNode, schema, adfStage)));
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
var $5558251c256ad6af$export$b9908ef75cad1e0e = function getValidUnknownNode(node) {
    var _node$attrs = node.attrs, attrs = _node$attrs === void 0 ? {} : _node$attrs, content = node.content, text = node.text, type = node.type;
    if (!content || !content.length) {
        var unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || "[".concat(type, "]")
        };
        var textUrl = attrs.textUrl;
        if (textUrl && (0, $7JWGN.isSafeUrl)(textUrl)) unknownInlineNode.marks = [
            {
                type: 'link',
                attrs: {
                    href: textUrl
                }
            }
        ];
        return unknownInlineNode;
    }
    /*
   * Find leaf nodes and join them. If leaf nodes' parent node is the same node
   * join with a blank space, otherwise they are children of different branches, i.e.
   * we need to join them with a hardBreak node
   */ return {
        type: 'unknownBlock',
        content: $5558251c256ad6af$var$_flattenUnknownBlockTree(node)
    };
};
var $5558251c256ad6af$var$getValidMarks = function getValidMarks(marks) {
    var adfStage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'final';
    if (marks && marks.length > 0) return marks.reduce(function(acc, mark) {
        var validMark = $5558251c256ad6af$export$87c6d4a6ebb7d9e9(mark, adfStage);
        if (validMark) acc.push(validMark);
        return acc;
    }, []);
    return marks;
};
var $5558251c256ad6af$export$81b20b6c83a56bd = function getValidNode(originalNode) {
    var schema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $kYLlQ.defaultSchema);
    var adfStage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'final';
    var attrs = originalNode.attrs, marks = originalNode.marks, text = originalNode.text, type = originalNode.type;
    var content = originalNode.content;
    var node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type
    };
    if (content) node.content = content = $5558251c256ad6af$export$fafd4f799ee68da0(content, schema, adfStage);
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) return $5558251c256ad6af$export$b9908ef75cad1e0e(node);
    if (type) switch(type){
        case 'doc':
            var _ref = originalNode, version = _ref.version;
            if (version && content && content.length) return {
                type: type,
                content: content
            };
            break;
        case 'codeBlock':
            if (content) content = content.reduce(function(acc, val) {
                if (val.type === 'text') acc.push({
                    type: val.type,
                    text: val.text
                });
                return acc;
            }, []);
            if (attrs && attrs.language) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
            return {
                type: type,
                content: content,
                marks: marks
            };
        case 'date':
            if (attrs && attrs.timestamp) return $5558251c256ad6af$var$_objectSpread({
                type: type,
                attrs: attrs
            }, (0, $50U6m.fg)('editor_inline_comments_on_inline_nodes') ? {
                marks: marks
            } : {});
            break;
        case 'status':
            if (attrs && attrs.text && attrs.color) return $5558251c256ad6af$var$_objectSpread({
                type: type,
                attrs: attrs
            }, (0, $50U6m.fg)('editor_inline_comments_on_inline_nodes') ? {
                marks: marks
            } : {});
            break;
        case 'emoji':
            if (attrs && attrs.shortName) return $5558251c256ad6af$var$_objectSpread({
                type: type,
                attrs: attrs
            }, (0, $50U6m.fg)('editor_inline_comments_on_inline_nodes') ? {
                marks: marks
            } : {});
            break;
        case 'inlineExtension':
        case 'extension':
            if (attrs && attrs.extensionType && attrs.extensionKey) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'inlineCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $7JWGN.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $7JWGN.isSafeUrl)(attrs.data.url))) return $5558251c256ad6af$var$_objectSpread({
                type: type,
                attrs: attrs
            }, (0, $50U6m.fg)('editor_inline_comments_on_inline_nodes') ? {
                marks: marks
            } : {});
            break;
        case 'blockCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $7JWGN.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $7JWGN.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'embedCard':
            if (attrs && (attrs.url && (0, $7JWGN.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $7JWGN.isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'bodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'multiBodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'extensionFrame':
            if (content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'hardBreak':
            return {
                type: type
            };
        case 'caption':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'mediaInline':
            var mediaId = '';
            var mediaCollection = [];
            if (attrs) {
                var id = attrs.id, collection = attrs.collection;
                mediaId = id;
                mediaCollection = collection;
            }
            if (mediaId && mediaCollection) return {
                type: type,
                attrs: attrs,
                marks: marks
            };
            break;
        case 'media':
            var _mediaId = '';
            var mediaType = '';
            var _mediaCollection = [];
            var mediaUrl = '';
            if (attrs) {
                var _id = attrs.id, _collection = attrs.collection, _type = attrs.type, url = attrs.url;
                _mediaId = _id;
                mediaType = _type;
                _mediaCollection = _collection;
                mediaUrl = url;
            }
            if (mediaType === 'external' && !!mediaUrl) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var mediaAttrs = {
                    type: mediaType,
                    url: mediaUrl,
                    width: attrs.width,
                    height: attrs.height
                };
                if (attrs.alt) mediaAttrs.alt = attrs.alt;
                var getMarks = $5558251c256ad6af$var$getValidMarks(marks, adfStage);
                return getMarks ? {
                    type: type,
                    attrs: mediaAttrs,
                    marks: getMarks
                } : {
                    type: type,
                    attrs: mediaAttrs
                };
            } else if (_mediaId && mediaType) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var _mediaAttrs = {
                    type: mediaType,
                    id: _mediaId,
                    collection: _mediaCollection
                };
                if (attrs.width) _mediaAttrs.width = attrs.width;
                if (attrs.height) _mediaAttrs.height = attrs.height;
                if (attrs.alt) _mediaAttrs.alt = attrs.alt;
                var _getMarks = $5558251c256ad6af$var$getValidMarks(marks, adfStage);
                return _getMarks ? {
                    type: type,
                    attrs: _mediaAttrs,
                    marks: _getMarks
                } : {
                    type: type,
                    attrs: _mediaAttrs
                };
            }
            break;
        case 'mediaGroup':
            if (Array.isArray(content) && !content.some(function(e) {
                return e.type !== 'media';
            })) return {
                type: type,
                content: content
            };
            break;
        case 'mediaSingle':
            var containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
            var containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
            if (containsJustMedia || containsMediaAndCaption) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: $5558251c256ad6af$var$getValidMarks(marks, adfStage)
            };
            break;
        case 'mention':
            var mentionText = '';
            var mentionId;
            var mentionAccess;
            var localId;
            if (attrs) {
                var _text = attrs.text, displayName = attrs.displayName, _id2 = attrs.id, accessLevel = attrs.accessLevel;
                mentionText = _text || displayName;
                mentionId = _id2;
                mentionAccess = accessLevel;
                localId = attrs.localId;
            }
            if (!mentionText) mentionText = text || '@unknown';
            if (mentionText && mentionId) {
                var mentionNode = $5558251c256ad6af$var$_objectSpread({
                    type: type,
                    attrs: $5558251c256ad6af$var$_objectSpread({
                        id: mentionId,
                        text: mentionText,
                        accessLevel: ''
                    }, localId ? {
                        localId: localId
                    } : {})
                }, (0, $50U6m.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {});
                if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                return mentionNode;
            }
            break;
        case 'paragraph':
            if (adfStage === 'stage0') {
                var paragraphNode = {
                    type: type,
                    content: content || []
                };
                if (attrs && attrs.localId) paragraphNode.attrs = {
                    localId: attrs.localId
                };
                if (marks) paragraphNode.marks = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(marks);
                return paragraphNode;
            }
            return marks ? {
                type: type,
                content: content || [],
                marks: marks
            } : {
                type: type,
                content: content || []
            };
        case 'rule':
            return {
                type: type
            };
        case 'text':
            var _marks = node.marks;
            if (text) return _marks ? {
                type: type,
                text: text,
                marks: $5558251c256ad6af$var$getValidMarks(_marks, adfStage)
            } : {
                type: type,
                text: text
            };
            break;
        case 'heading':
            if (attrs) {
                var level = attrs.level;
                var between = function between(x, a, b) {
                    return x >= a && x <= b;
                };
                if (level && between(level, 1, 6)) {
                    if (adfStage === 'stage0') {
                        var headingNode = {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                        if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                        if (marks) headingNode.marks = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(marks);
                        return headingNode;
                    }
                    return marks ? {
                        type: type,
                        content: content,
                        marks: marks,
                        attrs: {
                            level: level
                        }
                    } : {
                        type: type,
                        content: content,
                        attrs: {
                            level: level
                        }
                    };
                }
            }
            break;
        case 'bulletList':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'orderedList':
            if (content) return {
                type: type,
                content: content,
                attrs: {
                    order: attrs && attrs.order
                }
            };
            break;
        case 'listItem':
            if (content) return {
                type: type,
                content: $5558251c256ad6af$var$wrapInlineNodes(content)
            };
            break;
        case 'blockquote':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'panel':
            if (attrs && content) {
                var panelType = attrs.panelType;
                if (Object.values((0, $18mVh.PanelType)).includes(panelType)) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
            }
            break;
        case 'layoutSection':
            if (content) return {
                type: type,
                marks: marks,
                content: content
            };
            break;
        case 'layoutColumn':
            if (attrs && content) {
                if (attrs.width > 0 && attrs.width <= 100) return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'decisionList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $l4823.generateUuid)()
                }
            };
        case 'decisionItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $l4823.generateUuid)(),
                    state: attrs && attrs.state || 'DECIDED'
                }
            };
        case 'taskList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $l4823.generateUuid)()
                }
            };
        case 'taskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $l4823.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'blockTaskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $l4823.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'table':
            if (Array.isArray(content) && content.length > 0 && !content.some(function(e) {
                return e.type !== 'tableRow';
            })) {
                if (adfStage === 'stage0') return {
                    type: type,
                    content: content,
                    attrs: $5558251c256ad6af$var$_objectSpread($5558251c256ad6af$var$_objectSpread({}, attrs), {}, {
                        localId: (attrs === null || attrs === void 0 ? void 0 : attrs.localId) || (0, $l4823.generateUuid)(),
                        width: (attrs === null || attrs === void 0 ? void 0 : attrs.width) || null
                    })
                };
                return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'tableRow':
            if (Array.isArray(content) && content.length > 0 && !content.some(function(e) {
                return e.type !== 'tableCell' && e.type !== 'tableHeader';
            })) return {
                type: type,
                content: content
            };
            break;
        case 'tableCell':
        case 'tableHeader':
            if (content) {
                var cellAttrs = {};
                if (attrs) {
                    if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                    if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                    if (attrs.background) cellAttrs.background = attrs.background;
                    if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                }
                return {
                    type: type,
                    content: $5558251c256ad6af$var$wrapInlineNodes(content),
                    attrs: attrs ? cellAttrs : undefined
                };
            }
            break;
        case 'image':
            if (attrs && attrs.src) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'placeholder':
            if (attrs && typeof attrs.text !== 'undefined') return {
                type: type,
                attrs: attrs
            };
            break;
        case 'expand':
        case 'nestedExpand':
            return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
        case 'syncBlock':
            if (attrs && attrs.resourceId) return {
                type: type,
                attrs: {
                    resourceId: attrs.resourceId,
                    localId: attrs.localId || (0, $l4823.generateUuid)()
                },
                marks: marks
            };
            return $5558251c256ad6af$export$b9908ef75cad1e0e(node);
        case 'bodiedSyncBlock':
            if (attrs && attrs.resourceId && Array.isArray(content) && content.length > 0) return {
                type: type,
                attrs: {
                    resourceId: attrs.resourceId,
                    localId: attrs.localId || (0, $l4823.generateUuid)()
                },
                marks: marks,
                content: content
            };
            return $5558251c256ad6af$export$b9908ef75cad1e0e(node);
    }
    return $5558251c256ad6af$export$b9908ef75cad1e0e(node);
};
var $5558251c256ad6af$export$87c6d4a6ebb7d9e9 = function getValidMark(mark) {
    var adfStage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'final';
    var attrs = mark.attrs, type = mark.type;
    if (type) switch(type){
        case 'code':
            return {
                type: type
            };
        case 'em':
            return {
                type: type
            };
        case 'link':
            if (attrs) {
                var href = attrs.href, url = attrs.url, __confluenceMetadata = attrs.__confluenceMetadata;
                var linkHref = href || url;
                if (linkHref && linkHref.indexOf(':') === -1 && !$5558251c256ad6af$var$RELATIVE_LINK.test(linkHref) && !$5558251c256ad6af$var$ANCHOR_LINK.test(linkHref)) linkHref = "http://".concat(linkHref);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var linkAttrs = {
                    href: linkHref
                };
                if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                if (linkHref && (0, $7JWGN.isSafeUrl)(linkHref)) return {
                    type: type,
                    attrs: linkAttrs
                };
            }
            break;
        case 'strike':
            return {
                type: type
            };
        case 'strong':
            return {
                type: type
            };
        case 'subsup':
            if (attrs && attrs['type']) {
                var subSupType = attrs['type'];
                if ((0, $56aa5c9c50b5698f$export$30f8aa4cc1f8c1cb)(subSupType)) return {
                    type: type,
                    attrs: {
                        type: subSupType
                    }
                };
            }
            break;
        case 'textColor':
            if (attrs && $5558251c256ad6af$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'underline':
            return {
                type: type
            };
        case 'annotation':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
        case 'backgroundColor':
            if (attrs && $5558251c256ad6af$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
    }
    if (adfStage === 'stage0') switch(type){
        case 'confluenceInlineComment':
            return {
                type: type,
                attrs: attrs
            };
        case 'dataConsumer':
            return {
                type: type,
                attrs: attrs
            };
        case 'fragment':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
    }
    return null;
};

/*
 * Check if two marks are the same by comparing type and attrs
 */ var $5529a08af71d59f5$export$b1304404bdc42b7a = function isSameMark(mark, otherMark) {
    if (!mark || !otherMark) return false;
    return mark.eq(otherMark);
};



var $9Jwkl = parcelRequire("9Jwkl");

var $4inI8 = parcelRequire("4inI8");

var $jkJfI = parcelRequire("jkJfI");

var $50U6m = parcelRequire("50U6m");

var $drUcN = parcelRequire("drUcN");

var $hOwF6 = parcelRequire("hOwF6");

var $9F9pG = parcelRequire("9F9pG");

var $w2fDc = parcelRequire("w2fDc");/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $kqp0i = parcelRequire("kqp0i");
parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $5fbqs = parcelRequire("5fbqs");
var $cc7b02ff90190344$var$MarkWrapper = function MarkWrapper(props) {
    var dataAlign = props['data-align'] ? (0, $5fbqs.alignmentPositionMap)[props['data-align']] : undefined;
    return (0, $74Zh5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: {
            textAlign: dataAlign
        }
    }, props), props.children);
};
function $cc7b02ff90190344$export$2e2bcd8739ae039(props) {
    return (0, $74Zh5.jsx)($cc7b02ff90190344$var$MarkWrapper, {
        className: "fabric-editor-block-mark fabric-editor-alignment",
        "data-align": props.align
    }, props.children);
}



var $w2fDc = parcelRequire("w2fDc");

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $cQBqP = parcelRequire("cQBqP");

var $25nEq = parcelRequire("25nEq");
var $691a01f0c2a721b6$export$12a518ff137dd389 = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, '#DCDFE4', "var(--ds-background-accent-gray-subtler, #DDDEE1)"), '#C6EDFB', "var(--ds-background-accent-teal-subtler, #C6EDFB)"), '#D3F1A7', "var(--ds-background-accent-lime-subtler, #D3F1A7)"), '#F8E6A0', "var(--ds-background-accent-yellow-subtler, #F5E989)"), '#FEDEC8', "var(--ds-background-accent-orange-subtler, #FCE4A6)"), '#FFD5D2', "var(--ds-background-accent-red-subtler, #FFD5D2)"), '#FDD0EC', "var(--ds-background-accent-magenta-subtler, #FDD0EC)"), '#DFD8FD', "var(--ds-background-accent-purple-subtler, #EED7FC)"), '#B3D4FF', "var(--ds-background-accent-blue-subtler, #CFE1FD)"), '#ABF5D1', "var(--ds-background-accent-green-subtler, #BAF3DB)");
function $691a01f0c2a721b6$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-ignore
    return $691a01f0c2a721b6$export$12a518ff137dd389[hexColor.toUpperCase()];
}



var $jLsC1 = parcelRequire("jLsC1");
function $7eff8bb2e3b8a318$export$2e2bcd8739ae039(props) {
    var _useThemeObserver = (0, $jLsC1.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    var paletteColorValue;
    /**
   * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text background colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text background colors copied from external editor sources. Where we load the background color from a
   * separate attribute (data-background-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ var tokenColor = (0, $691a01f0c2a721b6$export$8b58ff1b36bb75e0)(props.color);
    if (tokenColor) paletteColorValue = tokenColor;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $cQBqP.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    var style = (0, $5FkrB.useMemo)(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, '--custom-palette-color', paletteColorValue);
    }, [
        paletteColorValue
    ]);
    if (props.isStandalone) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-block-mark": props.dataAttributes['data-block-mark'],
        "data-renderer-mark": props.dataAttributes['data-renderer-mark'],
        "data-background-custom-color": props.color,
        className: "fabric-background-color-mark",
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "background-color-padding-left background-color-padding-right"
    }, props.children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props.dataAttributes, {
        "data-background-custom-color": props.color,
        className: "fabric-background-color-mark",
        style: style
    }), props.children);
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $74Zh5 = parcelRequire("74Zh5");
function $b6e959fc4dd558ff$export$2e2bcd8739ae039(props) {
    var _props$color, _props$size;
    var borderColor = (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : '';
    var borderSize = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : 0;
    return (0, $74Zh5.jsx)("span", {
        "data-color": borderColor,
        "data-size": borderSize,
        "data-mark-type": "border"
    }, props.children);
}



var $kqp0i = parcelRequire("kqp0i");

var $74Zh5 = parcelRequire("74Zh5");

var $1LBcl = parcelRequire("1LBcl");

var $j3BGx = parcelRequire("j3BGx");

var $53SBn = parcelRequire("53SBn");
var $c0e50d9529b2a755$var$flexWrapperStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: "".concat((0, $1LBcl.blockNodesVerticalMargin), " 0")
});
// Flex item: no vertical margin so flex container height = content height (matches legacy single-wrapper height).
// flexShrink: 0 so the inner div keeps its width (matches legacy behaviour; flex items default to flex-shrink: 1).
var $c0e50d9529b2a755$var$innerWrapperStyles = (0, $74Zh5.css)({
    flexShrink: 0
});
var $c0e50d9529b2a755$var$getWidth = function getWidth(width, mode) {
    if ((0, $j3BGx.editorExperiment)('advanced_layouts', true) && width) return "min(".concat(width, "px, var(--ak-editor--breakout-container-without-gutter-width))");
    else {
        if (mode === 'max' || typeof width === 'number' && width >= (0, $1LBcl.akEditorFullWidthLayoutWidth)) return "min(".concat((0, $1LBcl.akEditorMaxLayoutWidth), "px, var(--ak-editor--breakout-container-without-gutter-width))");
        if (mode === 'full-width') return "min(".concat((0, $1LBcl.akEditorFullWidthLayoutWidth), "px, var(--ak-editor--breakout-container-without-gutter-width))");
        if (mode === 'wide') return "min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor--breakout-container-without-gutter-width))";
    }
};
function $c0e50d9529b2a755$export$2e2bcd8739ae039(props) {
    var _props$width;
    var breakoutWidth = (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : null;
    var width = $c0e50d9529b2a755$var$getWidth(breakoutWidth, props.mode);
    return (0, $74Zh5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $53SBn.RendererCssClassName).STICKY_SAFE_BREAKOUT_WRAPPER + ' ' + (0, $53SBn.RendererCssClassName).FLEX_CENTER_WRAPPER,
        css: $c0e50d9529b2a755$var$flexWrapperStyles
    }, (0, $74Zh5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        css: $c0e50d9529b2a755$var$innerWrapperStyles,
        className: "".concat((0, $53SBn.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER, " fabric-editor-breakout-mark fabric-editor-block-mark"),
        "data-mode": props.mode
    }, (0, $j3BGx.editorExperiment)('advanced_layouts', true) && {
        'data-has-width': !!props.width,
        'data-width': props.width
    }, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: width
        }
    }), props.children));
}



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $ach6K = parcelRequire("ach6K");
/* code.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $j6Z9H = parcelRequire("j6Z9H");

var $7BUTc = parcelRequire("7BUTc");
var $32861399685ae06e$var$_excluded = [
    "testId"
], $32861399685ae06e$var$_excluded2 = [
    "children",
    "codeBidiWarnings",
    "hasBidiWarnings",
    "codeBidiWarningLabel",
    "codeBidiWarningTooltipEnabled",
    "isBidiWarningTooltipEnabled"
];
var $32861399685ae06e$var$styles = {
    base: "_ca0qyh40 _u5f3m5ip _n3tdyh40 _19bvm5ip _2rkofajl _11c819w5 _1reo1wug _18m91wug _1dqoglyw _1e0c1nu9 _bfhk187e _16d9qvcn _syazi7uo _vwz41kw7 _1i4q1hna _o5721jtm"
};
/**
 * __Code__
 *
 * Code highlights short strings of code snippets inline with body text.
 *
 * - [Examples](https://atlassian.design/components/code/examples)
 * - [Code](https://atlassian.design/components/code/code)
 * - [Usage](https://atlassian.design/components/code/usage)
 */ var $32861399685ae06e$var$Code = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function Code(_ref, ref) {
    var testId = _ref.testId, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $32861399685ae06e$var$_excluded);
    var children = props.children, _props$codeBidiWarnin = props.codeBidiWarnings, codeBidiWarnings = _props$codeBidiWarnin === void 0 ? true : _props$codeBidiWarnin, hasBidiWarnings = props.hasBidiWarnings, codeBidiWarningLabel = props.codeBidiWarningLabel, _props$codeBidiWarnin2 = props.codeBidiWarningTooltipEnabled, codeBidiWarningTooltipEnabled = _props$codeBidiWarnin2 === void 0 ? true : _props$codeBidiWarnin2, isBidiWarningTooltipEnabled = props.isBidiWarningTooltipEnabled, otherProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $32861399685ae06e$var$_excluded2);
    // Use new props if provided, otherwise fall back to deprecated props
    var shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    var shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    var decoratedChildren = shouldShowBidiWarnings ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($32861399685ae06e$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip
    }, children) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("code", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: ref,
        "data-testid": testId
    }, otherProps, {
        className: (0, $970q7.default)([
            $32861399685ae06e$var$styles.base
        ])
    }), decoratedChildren);
}));
function $32861399685ae06e$var$RenderCodeChildrenWithBidiWarnings(_ref2) {
    var children = _ref2.children, codeBidiWarningLabel = _ref2.codeBidiWarningLabel, codeBidiWarningTooltipEnabled = _ref2.codeBidiWarningTooltipEnabled;
    var replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.map(children, function(childNode) {
        if (typeof childNode === 'string') {
            var decorated = (0, $j6Z9H.default)(childNode, function(_ref3) {
                var bidiCharacter = _ref3.bidiCharacter, index = _ref3.index;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7BUTc.default), {
                    bidiCharacter: bidiCharacter,
                    key: index,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                });
            });
            return decorated;
        }
        if ($32861399685ae06e$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            var newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($32861399685ae06e$var$RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
                }, childNode.props.children)
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, replacedChildren);
}
function $32861399685ae06e$var$isReactElement(child) {
    return !!child.type;
}
$32861399685ae06e$var$Code.displayName = 'Code';
var $32861399685ae06e$export$2e2bcd8739ae039 = $32861399685ae06e$var$Code;



var $6bnW7 = parcelRequire("6bnW7");
var $4ae110edca90b5da$export$42bb270d1224182 = (0, $6bnW7.defineMessages)({
    /**
   * Message taken from
   * https://hello.atlassian.net/wiki/spaces/~tswan/pages/1366555782/PSHELP-2943+Investigate+Trojan+Source+Attack+Vulnerability+design
   */ label: {
        id: 'fabric.editor.codeBidiWarningLabel',
        defaultMessage: 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.',
        description: 'Tooltip message to present to users when a bidirectional character is encountered in code.'
    }
});


var $7b2d933bcff57ef4$export$86390c02c110ec2f = function isCodeMark(mark) {
    return mark && mark.type && mark.type.name === 'code';
};
function $7b2d933bcff57ef4$export$7cea6ffa7022e85f(props) {
    var codeBidiWarningLabel = props.intl.formatMessage((0, $4ae110edca90b5da$export$42bb270d1224182).label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $32861399685ae06e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        className: "code",
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: props.codeBidiWarningTooltipEnabled
    }, props.dataAttributes), props.children);
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
var $7b2d933bcff57ef4$var$_default_1 = (0, $ach6K.default)($7b2d933bcff57ef4$export$7cea6ffa7022e85f);
var $7b2d933bcff57ef4$export$2e2bcd8739ae039 = $7b2d933bcff57ef4$var$_default_1;



var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $5FkrB = parcelRequire("5FkrB");
function $e558e5bbc09a7442$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $e558e5bbc09a7442$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $e558e5bbc09a7442$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e558e5bbc09a7442$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components, react/prefer-stateless-function
var $e558e5bbc09a7442$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    function ConfluenceInlineComment() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ConfluenceInlineComment);
        return $e558e5bbc09a7442$var$_callSuper(this, ConfluenceInlineComment, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ConfluenceInlineComment, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ConfluenceInlineComment, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, reference = _this$props.reference, children = _this$props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
                    "data-mark-type": "confluenceInlineComment",
                    "data-reference": reference
                }, children);
            }
        }
    ]);
}((0, $5FkrB.Component));



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");
function $f3bfc2c67e24dc3e$export$2e2bcd8739ae039(props) {
    var WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrapperElement, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-source": props.sources ? JSON.stringify(props.sources) : undefined,
        "data-mark-type": "dataConsumer"
    }, props.dataAttributes), props.children);
}



var $5FkrB = parcelRequire("5FkrB");
function $8ba2e00755bbf395$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("em", props.dataAttributes, props.children);
}



var $5FkrB = parcelRequire("5FkrB");
function $6f2c0f83ad3cc28c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-font-size",
        "data-font-size": props.fontSize
    }, props.children);
}



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");
function $298953afb828ae9b$export$2e2bcd8739ae039(props) {
    var WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrapperElement, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-localId": props.localId,
        "data-name": props.name,
        "data-mark-type": "fragment"
    }, props.dataAttributes), props.children);
}



var $5FkrB = parcelRequire("5FkrB");
function $e980729e1759a63a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-indentation-mark",
        "data-level": props.level
    }, props.children);
}



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $l9NcB = parcelRequire("l9NcB");

var $jJH6F = parcelRequire("jJH6F");

var $jkJfI = parcelRequire("jkJfI");

var $h0il1 = parcelRequire("h0il1");

var $aP6HU = parcelRequire("aP6HU");

var $9F9pG = parcelRequire("9F9pG");
/* link-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $cLkP4 = parcelRequire("cLkP4");
var $d1960776bfb84e83$var$anchorStyles = null;
var $d1960776bfb84e83$export$10ae7cf734c9da69 = function LinkUrlCompiled(props) {
    return /*#__PURE__*/ $5FkrB.createElement((0, $cLkP4.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        className: (0, $970q7.default)([
            "_syaz13af _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz"
        ])
    }));
};



var $kqp0i = parcelRequire("kqp0i");

var $74Zh5 = parcelRequire("74Zh5");

var $cLkP4 = parcelRequire("cLkP4");
var $9b789f1578f3d328$var$anchorStyles = (0, $74Zh5.css)({
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)"
    }
});
var $9b789f1578f3d328$export$bcc8540ceca8fa1c = function LinkUrlEmotion(props) {
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    (0, $74Zh5.jsx)((0, $cLkP4.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        css: $9b789f1578f3d328$var$anchorStyles
    }, props)));
};


var $34deba354526914d$var$LinkUrlMigration = (0, $h0il1.componentWithCondition)(function() {
    return (0, $jkJfI.isExperimentEnabled)('platform_editor_renderer_static_css');
}, (0, $d1960776bfb84e83$export$10ae7cf734c9da69), (0, $9b789f1578f3d328$export$bcc8540ceca8fa1c));
function $34deba354526914d$export$2e2bcd8739ae039(props) {
    var href = props.href, target = props.target, onSetLinkTarget = props.onSetLinkTarget, eventHandlers = props.eventHandlers, fireAnalyticsEvent = props.fireAnalyticsEvent, isMediaLink = props.isMediaLink, dataAttributes = props.dataAttributes;
    var actualTarget = target;
    if (onSetLinkTarget && href) try {
        var _onSetLinkTarget;
        actualTarget = (_onSetLinkTarget = onSetLinkTarget(href)) !== null && _onSetLinkTarget !== void 0 ? _onSetLinkTarget : actualTarget;
    } catch (error) {
    // eslint-disable-line no-unused-vars
    // If URL parsing fails, use the original target
    }
    var anchorProps = {
        href: href,
        target: actualTarget,
        title: href
    };
    if (actualTarget === '_blank') anchorProps.rel = 'noreferrer noopener';
    var handler = (0, $9F9pG.getEventHandler)(eventHandlers, 'link');
    if (isMediaLink) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, props.children);
    var analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $l9NcB.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($34deba354526914d$var$LinkUrlMigration, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        onClick: function onClick(e) {
            if (fireAnalyticsEvent) fireAnalyticsEvent({
                action: (0, $jJH6F.ACTION).VISITED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).LINK,
                eventType: (0, $jJH6F.EVENT_TYPE).TRACK,
                attributes: {
                    platform: (0, $aP6HU.PLATFORM).WEB,
                    mode: (0, $aP6HU.MODE).RENDERER
                }
            });
            if (handler) handler(e, href);
        }
    }, anchorProps, dataAttributes, {
        isLinkComponent: true,
        enableResolve: true
    }), props.children));
}



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");
function $4f2072525bb46916$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props.dataAttributes, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            textDecoration: 'line-through'
        }
    }), props.children);
}



var $5FkrB = parcelRequire("5FkrB");
function $bf141d5161e77678$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("strong", props.dataAttributes, props.children);
}



var $5FkrB = parcelRequire("5FkrB");
var $12c13372ddda400f$var$isSub = function isSub(type) {
    return type === 'sub';
};
function $12c13372ddda400f$export$2e2bcd8739ae039(props) {
    if ($12c13372ddda400f$var$isSub(props.type)) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("sub", props.dataAttributes, props.children);
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("sup", props.dataAttributes, props.children);
}



var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $cQBqP = parcelRequire("cQBqP");

var $25nEq = parcelRequire("25nEq");

var $50U6m = parcelRequire("50U6m");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $hLfKH = parcelRequire("hLfKH");
function $8e14ff35252fa9f0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8e14ff35252fa9f0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8e14ff35252fa9f0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8e14ff35252fa9f0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8e14ff35252fa9f0$export$a66cbd9b2289cd78 = '@all-features';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $8e14ff35252fa9f0$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $8e14ff35252fa9f0$var$_objectSpread($8e14ff35252fa9f0$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $8e14ff35252fa9f0$var$_objectSpread($8e14ff35252fa9f0$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $8e14ff35252fa9f0$var$_objectSpread($8e14ff35252fa9f0$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $8e14ff35252fa9f0$var$_objectSpread($8e14ff35252fa9f0$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($8e14ff35252fa9f0$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($8e14ff35252fa9f0$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($8e14ff35252fa9f0$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $8e14ff35252fa9f0$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();



var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $iYJcE = parcelRequire("iYJcE");
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $efb69d3109c59e7b$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
}; // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts


var $58dabbee66007ebf$var$evaluationReasonMappings = Object.entries((0, $efb69d3109c59e7b$export$c62558b199e46828)).map(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $58dabbee66007ebf$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $58dabbee66007ebf$var$evaluationReasonMappings.find(function(_ref3) {
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 1), key = _ref4[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $efb69d3109c59e7b$export$c62558b199e46828).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};


var $c33bd9ba9b92e105$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};


var $31e4b2b84c540613$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $58dabbee66007ebf$export$18ad168d3dbac899)(experiment.details), (0, $c33bd9ba9b92e105$export$55fd683752d01e67)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();



var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");


var $ba2aa0b6a9aa9cb1$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $58dabbee66007ebf$export$18ad168d3dbac899)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $c33bd9ba9b92e105$export$55fd683752d01e67)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $c33bd9ba9b92e105$export$55fd683752d01e67)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();




var $ekGgq = parcelRequire("ekGgq");

var $iYJcE = parcelRequire("iYJcE");

var $fC8ib = parcelRequire("fC8ib");
function $e78ba71171cd1869$export$1148cb79ceecd5fa(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return $e78ba71171cd1869$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sources)));
    for(var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], src = _Object$entries$_i[1];
        var dst = target[key];
        var srcIsObj = src && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(src) === 'object' && !Array.isArray(src);
        var dstIsObj = dst && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(dst) === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $e78ba71171cd1869$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $e78ba71171cd1869$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sources)));
}



var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $9cc743b88fc2afa4$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
var $9cc743b88fc2afa4$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
var $9cc743b88fc2afa4$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical


/// <reference types="node" />
var $51bb5732914b7a49$export$a59f8d67326bd1cb = "6.0.2";



var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $896922affdb37a42$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $896922affdb37a42$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $896922affdb37a42$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($896922affdb37a42$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $896922affdb37a42$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ResponseError);
        return $896922affdb37a42$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));


function $ef06eed36f62c0a5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ef06eed36f62c0a5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ef06eed36f62c0a5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ef06eed36f62c0a5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ef06eed36f62c0a5$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $ef06eed36f62c0a5$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $ef06eed36f62c0a5$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $ef06eed36f62c0a5$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $ef06eed36f62c0a5$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $ef06eed36f62c0a5$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $ef06eed36f62c0a5$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $ef06eed36f62c0a5$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $ef06eed36f62c0a5$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $ef06eed36f62c0a5$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $ef06eed36f62c0a5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(fetcherOptions) {
                    var targetApp, url, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 1;
                                _context.next = 2;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                                _context.prev = 3;
                                _t = _context["catch"](1);
                                if (!(_t instanceof Error)) {
                                    _context.next = 4;
                                    break;
                                }
                                throw _t;
                            case 4:
                                throw Error('Failed to retrieve client sdk key');
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 2;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                                _context2.prev = 3;
                                _t2 = _context2["catch"](1);
                                if (!(_t2 instanceof Error)) {
                                    _context2.next = 4;
                                    break;
                                }
                                throw _t2;
                            case 4:
                                throw Error('Failed to retrieve experiment values');
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 2;
                                    break;
                                }
                                _context3.next = 1;
                                return response.text();
                            case 1:
                                body = _context3.sent;
                                throw new (0, $896922affdb37a42$export$286baf652d0b1206)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 2:
                                if (!(response.status === 204)) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new (0, $896922affdb37a42$export$286baf652d0b1206)('Unexpected 204 response');
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return response.text();
                            case 1:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $ef06eed36f62c0a5$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $9cc743b88fc2afa4$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $9cc743b88fc2afa4$export$479e7351a733299).Production:
                        return $ef06eed36f62c0a5$export$18c93900db9358a4;
                    case (0, $9cc743b88fc2afa4$export$479e7351a733299).Staging:
                        return $ef06eed36f62c0a5$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $9cc743b88fc2afa4$export$c42b7bbc5e7ba555).COMMERCIAL) switch(serviceEnv){
                    case (0, $9cc743b88fc2afa4$export$479e7351a733299).Development:
                        return $ef06eed36f62c0a5$export$f058dbf75c3bc647;
                    case (0, $9cc743b88fc2afa4$export$479e7351a733299).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $ef06eed36f62c0a5$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $ef06eed36f62c0a5$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $ef06eed36f62c0a5$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 1;
                                return fetch("".concat(baseUrl).concat(path), $ef06eed36f62c0a5$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $51bb5732914b7a49$export$a59f8d67326bd1cb),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 1:
                                response = _context5.sent;
                                _context5.next = 2;
                                return this.handleResponseError(response);
                            case 2:
                                _context5.next = 3;
                                return this.extractResponseBody(response);
                            case 3:
                                return _context5.abrupt("return", _context5.sent);
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $ef06eed36f62c0a5$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($ef06eed36f62c0a5$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($ef06eed36f62c0a5$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();



var $25nEq = parcelRequire("25nEq");

var $ygbGG = parcelRequire("ygbGG");

function $af81a8ec3f353326$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $af81a8ec3f353326$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $af81a8ec3f353326$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $af81a8ec3f353326$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $af81a8ec3f353326$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $af81a8ec3f353326$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $ygbGG.isFedRamp)() ? (0, $9cc743b88fc2afa4$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE : (0, $9cc743b88fc2afa4$export$c42b7bbc5e7ba555).COMMERCIAL
    }, options);
};



var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");
var $7ee5ec8955e1f3f7$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $7ee5ec8955e1f3f7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7ee5ec8955e1f3f7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7ee5ec8955e1f3f7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7ee5ec8955e1f3f7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7ee5ec8955e1f3f7$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(options, $7ee5ec8955e1f3f7$var$_excluded);
    return $7ee5ec8955e1f3f7$var$_objectSpread($7ee5ec8955e1f3f7$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};



var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");
function $0c612007e59d374a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0c612007e59d374a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0c612007e59d374a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0c612007e59d374a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0c612007e59d374a$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $0c612007e59d374a$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $0c612007e59d374a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0c612007e59d374a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $0c612007e59d374a$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $0c612007e59d374a$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoFetchDataAdapter);
        _this = $0c612007e59d374a$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $0c612007e59d374a$var$_objectSpread($0c612007e59d374a$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $0c612007e59d374a$var$_objectSpread($0c612007e59d374a$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $0c612007e59d374a$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $0c612007e59d374a$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));



var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $dtn6l = parcelRequire("dtn6l");
function $1aba1b1eabd89cc6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1aba1b1eabd89cc6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1aba1b1eabd89cc6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1aba1b1eabd89cc6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1aba1b1eabd89cc6$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $1aba1b1eabd89cc6$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $1aba1b1eabd89cc6$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $1aba1b1eabd89cc6$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1aba1b1eabd89cc6$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $1aba1b1eabd89cc6$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $1aba1b1eabd89cc6$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $1aba1b1eabd89cc6$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $1aba1b1eabd89cc6$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $1aba1b1eabd89cc6$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $1aba1b1eabd89cc6$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $1aba1b1eabd89cc6$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PersistentOverrideAdapter);
        this._overrides = $1aba1b1eabd89cc6$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $1aba1b1eabd89cc6$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $1aba1b1eabd89cc6$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $1aba1b1eabd89cc6$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($1aba1b1eabd89cc6$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.removeItem($1aba1b1eabd89cc6$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $1aba1b1eabd89cc6$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $1aba1b1eabd89cc6$var$_objectSpread($1aba1b1eabd89cc6$var$_objectSpread({}, $1aba1b1eabd89cc6$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($1aba1b1eabd89cc6$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($1aba1b1eabd89cc6$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($1aba1b1eabd89cc6$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($1aba1b1eabd89cc6$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $1aba1b1eabd89cc6$var$_objectSpread($1aba1b1eabd89cc6$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $1aba1b1eabd89cc6$var$_objectSpread($1aba1b1eabd89cc6$var$_objectSpread({}, current.details), {}, {
                        reason: $1aba1b1eabd89cc6$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($1aba1b1eabd89cc6$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($1aba1b1eabd89cc6$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($1aba1b1eabd89cc6$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($1aba1b1eabd89cc6$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($1aba1b1eabd89cc6$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($1aba1b1eabd89cc6$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $1aba1b1eabd89cc6$var$makeEmptyStore();
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($1aba1b1eabd89cc6$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $1aba1b1eabd89cc6$var$_objectSpread($1aba1b1eabd89cc6$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $1aba1b1eabd89cc6$var$_objectSpread($1aba1b1eabd89cc6$var$_objectSpread({}, current.details), {}, {
                        reason: $1aba1b1eabd89cc6$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($1aba1b1eabd89cc6$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $1aba1b1eabd89cc6$var$_objectSpread($1aba1b1eabd89cc6$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $1aba1b1eabd89cc6$var$_objectSpread($1aba1b1eabd89cc6$var$_objectSpread({}, current.details), {}, {
                        reason: $1aba1b1eabd89cc6$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();



var $iYJcE = parcelRequire("iYJcE");
var $639b1a56210710f9$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};



var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");
var $1b46b62bbfdd5d84$var$_excluded = [
    "stableId"
];
function $1b46b62bbfdd5d84$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1b46b62bbfdd5d84$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1b46b62bbfdd5d84$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1b46b62bbfdd5d84$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1b46b62bbfdd5d84$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    var stableId = identifiers.stableId, otherIdentifiers = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(identifiers, $1b46b62bbfdd5d84$var$_excluded);
    var user = {
        customIDs: $1b46b62bbfdd5d84$var$_objectSpread($1b46b62bbfdd5d84$var$_objectSpread({}, otherIdentifiers), stableId !== undefined ? {
            stableID: stableId
        } : {}),
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};




var $cbed893bd7829229$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $cbed893bd7829229$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cbed893bd7829229$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cbed893bd7829229$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cbed893bd7829229$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cbed893bd7829229$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $cbed893bd7829229$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $cbed893bd7829229$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $1aba1b1eabd89cc6$export$d8474cff104280f3) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscriptions", new (0, $8e14ff35252fa9f0$export$2e2bcd8739ae039)());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "dataAdapter", new (0, $0c612007e59d374a$export$55fffef3474104af)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $1aba1b1eabd89cc6$export$bcb28fbac1def494)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $af81a8ec3f353326$export$d119b37e5f788b43)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 1;
                                    break;
                                }
                                if (!(0, $639b1a56210710f9$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $af81a8ec3f353326$export$d119b37e5f788b43)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 1;
                                    break;
                                }
                                if (!(0, $639b1a56210710f9$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $51bb5732914b7a49$export$a59f8d67326bd1cb));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $cbed893bd7829229$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $51bb5732914b7a49$export$a59f8d67326bd1cb),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $9cc743b88fc2afa4$export$479e7351a733299).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $af81a8ec3f353326$export$d119b37e5f788b43)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 1;
                                    break;
                                }
                                if (!(0, $639b1a56210710f9$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 1:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $af81a8ec3f353326$export$d119b37e5f788b43)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $ef06eed36f62c0a5$export$2e2bcd8739ae039).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 1;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 1:
                                _context5.next = 2;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 2:
                                _context5.next = 3;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 1:
                                if (!this.initCompleted) {
                                    _context7.next = 2;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 2:
                                _context7.next = 3;
                                return this.initPromise;
                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $31e4b2b84c540613$export$6dc24881a3d96325).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $31e4b2b84c540613$export$6dc24881a3d96325)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $efb69d3109c59e7b$export$c62558b199e46828).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $639b1a56210710f9$export$fa1c2bbf4100b8bc)(this.currentIdentifiers, identifiers) && (0, $639b1a56210710f9$export$fa1c2bbf4100b8bc)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $cbed893bd7829229$var$_objectSpread({}, clientOptions);
                                if (!clientOptions.localMode) {
                                    _context8.next = 2;
                                    break;
                                }
                                _context8.next = 1;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 1:
                                return _context8.abrupt("return");
                            case 2:
                                _context8.prev = 2;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $ef06eed36f62c0a5$export$2e2bcd8739ae039).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $ef06eed36f62c0a5$export$2e2bcd8739ae039).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 6;
                                break;
                            case 4:
                                _context8.prev = 4;
                                _t = _context8["catch"](2);
                                if (_t instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t === null || _t === void 0 ? void 0 : _t.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t;
                            case 6:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            2,
                            4
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $cbed893bd7829229$var$_objectSpread($cbed893bd7829229$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 2;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 2:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 6;
                                break;
                            case 4:
                                _context9.prev = 4;
                                _t2 = _context9["catch"](1);
                                if (_t2 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t2 === null || _t2 === void 0 ? void 0 : _t2.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t2;
                            case 6:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            4
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, _args0 = arguments, _t3;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $7ee5ec8955e1f3f7$export$202946b690d26d22)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $cbed893bd7829229$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $cbed893bd7829229$var$_objectSpread($cbed893bd7829229$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $cbed893bd7829229$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $9cc743b88fc2afa4$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(newClientOptions, $cbed893bd7829229$var$_excluded);
                                frontendUser = (0, $1b46b62bbfdd5d84$export$3dad1db244472f32)(identifiers, customAttributes);
                                this.user = (0, $e78ba71171cd1869$export$1148cb79ceecd5fa)({}, initializeValues.user, frontendUser);
                                statsigOptions = $cbed893bd7829229$var$_objectSpread($cbed893bd7829229$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 1;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 2;
                                return this.statsigClient.initializeAsync();
                            case 2:
                                _context0.next = 5;
                                break;
                            case 3:
                                _context0.prev = 3;
                                _t3 = _context0["catch"](1);
                                if (_t3 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_t3 === null || _t3 === void 0 ? void 0 : _t3.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($cbed893bd7829229$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 4;
                                return this.statsigClient.initializeAsync();
                            case 4:
                                this.initWithDefaults = true;
                                throw _t3;
                            case 5:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise, _t4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 1:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 2;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 2:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 3;
                                _context10.next = 4;
                                return this.initPromise;
                            case 4:
                                _context10.next = 6;
                                break;
                            case 5:
                                _context10.prev = 5;
                                _t4 = _context10["catch"](3);
                            case 6:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 1;
                                                    break;
                                                }
                                                _context1.next = 1;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 1:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 7:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            3,
                            5
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, frontendUser, _updateUserCompletion, _ref4, errMsg, success, errorMessage, _t5, _t6;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 2;
                                return initializeValuesPromise;
                            case 2:
                                initializeValues = _context11.sent;
                                frontendUser = (0, $1b46b62bbfdd5d84$export$3dad1db244472f32)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, $e78ba71171cd1869$export$1148cb79ceecd5fa)({}, initializeValues.experimentValues.user, frontendUser);
                                _context11.next = 4;
                                break;
                            case 3:
                                _context11.prev = 3;
                                _t5 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _t5 instanceof Error ? _t5.message : JSON.stringify(_t5);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _t5;
                            case 4:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 5;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 6;
                                    break;
                                }
                                _context11.next = 6;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 6:
                                _context11.next = 8;
                                break;
                            case 7:
                                _context11.prev = 7;
                                _t6 = _context11["catch"](5);
                                success = false;
                                errorMessage = String(_t6);
                            case 8:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 9;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 10;
                                break;
                            case 9:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 10:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            3
                        ],
                        [
                            5,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $51bb5732914b7a49$export$a59f8d67326bd1cb;
            }
        },
        {
            key: "getTargetApp",
            value: function getTargetApp() {
                var _this$initOptions2;
                return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $ba2aa0b6a9aa9cb1$export$936d0764594b6eb3).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $ba2aa0b6a9aa9cb1$export$936d0764594b6eb3).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();






var $7f069327a0ab9221$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $7f069327a0ab9221$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$7f069327a0ab9221$var$_FeatureGates = $7f069327a0ab9221$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "client", new (0, $cbed893bd7829229$export$1f2bb630327ac4b6)());
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$7f069327a0ab9221$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $7f069327a0ab9221$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $7f069327a0ab9221$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$7f069327a0ab9221$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $7f069327a0ab9221$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $7f069327a0ab9221$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "initializeCalled", $7f069327a0ab9221$var$_FeatureGates.client.initializeCalled.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "initializeCompleted", $7f069327a0ab9221$var$_FeatureGates.client.initializeCompleted.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "waitUntilInitializeCompleted", $7f069327a0ab9221$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "initialize", $7f069327a0ab9221$var$_FeatureGates.client.initialize.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "initializeWithProvider", $7f069327a0ab9221$var$_FeatureGates.client.initializeWithProvider.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "initializeFromValues", $7f069327a0ab9221$var$_FeatureGates.client.initializeFromValues.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "manuallyLogGateExposure", $7f069327a0ab9221$var$_FeatureGates.client.manuallyLogGateExposure.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "getExperiment", $7f069327a0ab9221$var$_FeatureGates.client.getExperiment.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "manuallyLogExperimentExposure", $7f069327a0ab9221$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "manuallyLogLayerExposure", $7f069327a0ab9221$var$_FeatureGates.client.manuallyLogLayerExposure.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "shutdownStatsig", $7f069327a0ab9221$var$_FeatureGates.client.shutdownStatsig.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "overrideGate", $7f069327a0ab9221$var$_FeatureGates.client.overrideGate.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "clearGateOverride", $7f069327a0ab9221$var$_FeatureGates.client.clearGateOverride.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "overrideConfig", $7f069327a0ab9221$var$_FeatureGates.client.overrideConfig.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "clearConfigOverride", $7f069327a0ab9221$var$_FeatureGates.client.clearConfigOverride.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "setOverrides", $7f069327a0ab9221$var$_FeatureGates.client.setOverrides.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "getOverrides", $7f069327a0ab9221$var$_FeatureGates.client.getOverrides.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "clearAllOverrides", $7f069327a0ab9221$var$_FeatureGates.client.clearAllOverrides.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "isCurrentUser", $7f069327a0ab9221$var$_FeatureGates.client.isCurrentUser.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "onGateUpdated", $7f069327a0ab9221$var$_FeatureGates.client.onGateUpdated.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "onExperimentValueUpdated", $7f069327a0ab9221$var$_FeatureGates.client.onExperimentValueUpdated.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "onAnyUpdated", $7f069327a0ab9221$var$_FeatureGates.client.onAnyUpdated.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "updateUser", $7f069327a0ab9221$var$_FeatureGates.client.updateUser.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "updateUserWithProvider", $7f069327a0ab9221$var$_FeatureGates.client.updateUserWithProvider.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "updateUserWithValues", $7f069327a0ab9221$var$_FeatureGates.client.updateUserWithValues.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "getPackageVersion", $7f069327a0ab9221$var$_FeatureGates.client.getPackageVersion.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "getTargetApp", $7f069327a0ab9221$var$_FeatureGates.client.getTargetApp.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "getLayer", $7f069327a0ab9221$var$_FeatureGates.client.getLayer.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "getLayerValue", $7f069327a0ab9221$var$_FeatureGates.client.getLayerValue.bind($7f069327a0ab9221$var$_FeatureGates.client));
var $7f069327a0ab9221$var$boundFGJS = $7f069327a0ab9221$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $7f069327a0ab9221$var$FeatureGates;
    else {
        var $7f069327a0ab9221$var$_boundFGJS, $7f069327a0ab9221$var$_boundFGJS$getPackage;
        $7f069327a0ab9221$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $7f069327a0ab9221$var$boundVersion = (($7f069327a0ab9221$var$_boundFGJS = $7f069327a0ab9221$var$boundFGJS) === null || $7f069327a0ab9221$var$_boundFGJS === void 0 || ($7f069327a0ab9221$var$_boundFGJS$getPackage = $7f069327a0ab9221$var$_boundFGJS.getPackageVersion) === null || $7f069327a0ab9221$var$_boundFGJS$getPackage === void 0 ? void 0 : $7f069327a0ab9221$var$_boundFGJS$getPackage.call($7f069327a0ab9221$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($7f069327a0ab9221$var$boundVersion !== (0, $51bb5732914b7a49$export$a59f8d67326bd1cb)) {
            var $7f069327a0ab9221$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($7f069327a0ab9221$var$boundVersion, " when module version ").concat((0, $51bb5732914b7a49$export$a59f8d67326bd1cb), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($7f069327a0ab9221$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $7f069327a0ab9221$export$2e2bcd8739ae039 = $7f069327a0ab9221$var$boundFGJS;



var $8qy01 = parcelRequire("8qy01");
/* eslint-disable perfectionist/sort-object-types */ /* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $25nEq = parcelRequire("25nEq");
function $ded5db6123fd3c39$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}


function $7baf39fa4861eac2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7baf39fa4861eac2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7baf39fa4861eac2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7baf39fa4861eac2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7baf39fa4861eac2$export$456f1587c9c92021(config) {
    return $7baf39fa4861eac2$var$_objectSpread($7baf39fa4861eac2$var$_objectSpread({}, config), {}, {
        typeGuard: (0, $ded5db6123fd3c39$export$f9ce7b637dfbe238),
        defaultValue: config.defaultValue
    });
}



var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $3ZMUU = parcelRequire("3ZMUU");
var $87e91a16ebe4888a$var$_process, $87e91a16ebe4888a$var$_process2;
var $87e91a16ebe4888a$var$IS_TESTING_ENV = typeof $3ZMUU !== 'undefined' && ((($87e91a16ebe4888a$var$_process = $3ZMUU) === null || $87e91a16ebe4888a$var$_process === void 0 || ($87e91a16ebe4888a$var$_process = $87e91a16ebe4888a$var$_process.env) === null || $87e91a16ebe4888a$var$_process === void 0 ? void 0 : $87e91a16ebe4888a$var$_process.NODE_ENV) === 'test' || (($87e91a16ebe4888a$var$_process2 = $3ZMUU) === null || $87e91a16ebe4888a$var$_process2 === void 0 || ($87e91a16ebe4888a$var$_process2 = $87e91a16ebe4888a$var$_process2.env) === null || $87e91a16ebe4888a$var$_process2 === void 0 ? void 0 : $87e91a16ebe4888a$var$_process2.JEST_WORKER_ID) !== undefined);
function $87e91a16ebe4888a$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
   * This is used by test utils to get the variants when running describe.each
   */ if ($87e91a16ebe4888a$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}


function $a17a420c10a9979a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a17a420c10a9979a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a17a420c10a9979a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a17a420c10a9979a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a17a420c10a9979a$export$fb89e8a786694d1(config) {
    var values = config.values;
    return $a17a420c10a9979a$var$_objectSpread($a17a420c10a9979a$var$_objectSpread({}, config), {}, {
        values: (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(values),
        // Maintains the tuple
        typeGuard: (0, $87e91a16ebe4888a$export$a9a18ae5ba42aeab)(config.values),
        defaultValue: config.defaultValue
    });
}


var $1ac22aed74317d57$export$5c897d5297c5b7fd = [
    'platform_editor_blocks',
    'platform_editor_controls',
    'advanced_layouts',
    'single_column_layouts',
    'platform_editor_preview_panel_responsiveness',
    'platform_editor_toolbar_aifc'
];
var $1ac22aed74317d57$export$6cbb856f286b07ef = {
    // new format to avoid collisions with other users when updating the file
    // Added 2026-07-18
    cc_maui_remix_button_hover_corridor: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_maui_remix_button_hover_corridor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-24
    platform_editor_layout_column_delete_shortcut_fix: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_layout_column_delete_shortcut_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-21
    // `isEnabled` is the gating param; the experiment's dynamic config also carries the numeric
    // `shimmerDurationMs` (skeleton) and `highlightDurationMs` (purple highlight) durations, read at
    // runtime via `expVal`.
    platform_editor_agent_be_streaming: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_agent_be_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Editor Platform experiments
    // lwoollard experiments
    // Added 2026-04-21
    cwr_page_tree_auto_finalize: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cwr_page_tree_auto_finalize'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 02-12-2025
    cc_fix_hydration_ttvc: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_fix_hydration_ttvc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    'editor_a11y__enghealth-46814_fy26': (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor_a11y__enghealth-46814_fy26'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19
    'enghealth-53346_fix_redaction_marker_editor': (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            jira: 'enghealth-53346_fix_redaction_marker_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-16
    platform_editor_remove_important_in_render_ext: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_remove_important_in_render_ext'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-06
    confluence_comment_nudgebar_improvement: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_comment_nudgebar_improvement'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_quick_insert_embeds: (0, $a17a420c10a9979a$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_quick_insert_embeds'
        },
        param: 'cohort',
        values: [
            'control',
            'prioritizeLinkInQIM',
            'prioritizeEmbedInQIM'
        ],
        defaultValue: 'control'
    }),
    confluence_remix_icon_right_side: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_remix_icon_right_side'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_editor_insm_doc_size_stats: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_insm_doc_size_stats'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-26
    cc_editor_fix_insm_inp_buffer: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_fix_insm_inp_buffer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    cwr_blank_object_experiment: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cwr_blank_object_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-08
    confluence_inline_comments_fix_stale_selection: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_inline_comments_fix_stale_selection'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    rovo_remix_experience_context: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'rovo_remix_experience_context'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-05
    'databases-native-embeds-v2': (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'databases-native-embeds-v2'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    cc_editor_insm_outlier_events: (0, $a17a420c10a9979a$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'cc_editor_insm_outlier_events'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-17
    platform_editor_renderer_extension_width_fix: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_renderer_extension_width_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-24
    platform_editor_media_external_badge_bbc_fix: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_media_external_badge_bbc_fix',
            bitbucket: 'platform_editor_media_external_badge_bbc_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-20
    platform_editor_annotations_sync_on_docchange: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_annotations_sync_on_docchange'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $a17a420c10a9979a$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_per_plugin_error_boundary: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_per_plugin_error_boundary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-05
    'company_hub_carousel_thumbnails-refactor': (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'company_hub_carousel_thumbnails-refactor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $a17a420c10a9979a$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_paste_actions_menu: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-19
    platform_editor_controls_reliable_anchor: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_controls_reliable_anchor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $a17a420c10a9979a$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_controls',
            jira: 'platform_editor_controls_jira'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-07-21
    confluence_cwr_3p_connection_suggested_prompts: (0, $a17a420c10a9979a$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_cwr_3p_connection_suggested_prompts'
        },
        param: 'cohort',
        values: [
            'control',
            'variant_a',
            'variant_b'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-05-26
    platform_editor_agent_mentions: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_agent_mentions',
            jira: 'platform_editor_agent_mentions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    platform_editor_reduced_agent_profile_cards: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_reduced_agent_profile_cards',
            jira: 'platform_editor_reduced_agent_profile_cards'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-30
    platform_editor_fix_link_paste_menu: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_link_paste_menu',
            jira: 'platform_editor_fix_link_paste_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_code_block_q4_lovability: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_code_block_q4_lovability',
            jira: 'platform_editor_code_block_q4_lovability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-16
    platform_editor_enable_single_player_step_merging: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_enable_single_player_step_merging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_hide_overflow_menu: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_hide_overflow_menu',
            jira: 'platform_editor_toolbar_hide_overflow_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_responsiveness'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $a17a420c10a9979a$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-06-25
    jira_editor_a11y_toolbar_fixes: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'jira_editor_a11y_toolbar_fixes',
            jira: 'jira_editor_a11y_toolbar_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-09
    platform_editor_blocks: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_blocks_conf',
            jira: 'platform_editor_blocks_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-23
    //Added 2025-07-16
    platform_editor_toolbar_aifc: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_confluence'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_breakout_interaction_rerender: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_breakout_interaction_rerender'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_blocktaskitem_node_tenantid: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_node_tenantid'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_with_dnd: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_with_dnd'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    'editor-a11y-fy26-keyboard-move-row-column': (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor-a11y-fy26-keyboard-move-row-column',
            jira: 'editor-a11y-fy26-keyboard-move-row-column'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-28
    editor_enable_image_alignment_in_expand: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor_enable_image_alignment_in_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_august_a11y: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_august_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-01
    cc_editor_ai_content_mode: (0, $a17a420c10a9979a$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'cc_editor_ai_content_mode'
        },
        param: 'variant',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-01-09
    platform_editor_render_bodied_extension_as_inline: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_render_bodied_extension_as_inline'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-03
    platform_editor_ai_quick_prompt_iw_cc: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_quick_prompt_iw_cc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_use_llm_space_recommendations: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_use_llm_space_recommendations'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-01
    // Added 2025-10-13
    platform_editor_media_error_analytics: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_media_error_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-27
    platform_editor_table_sticky_header_improvements: (0, $a17a420c10a9979a$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_improvements'
        },
        param: 'cohort',
        values: [
            'control',
            'test_with_overflow',
            'test_without_overflow'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-29
    platform_editor_lovability_inline_code: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_inline_code'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_lovability_emoji_scaling: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_emoji_scaling'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-18
    editor_a11y_7152_profile_card_tab_order: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor_a11y_7152_profile_card_tab_order'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-19
    platform_editor_lovability_navigation_fixes: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_navigation_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-27 — Pre-auth unauthorised inline hover card UX
    platform_sl_3p_preauth_better_hovercard: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_sl_3p_preauth_better_hovercard',
            jira: 'platform_sl_3p_preauth_better_hovercard'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-21 — Post-auth GDrive Smart Link to Rovo Chat auto-open
    platform_sl_3p_post_auth_chat_open_exp: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_sl_3p_post_auth_chat_open_exp',
            jira: 'platform_sl_3p_post_auth_chat_open_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-29 — Social proof inline CTA for unauthorised 3P inline smart links
    platform_sl_3p_preauth_social_proof_inline_cta: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_sl_3p_preauth_social_proof_inline_cta',
            jira: 'platform_sl_3p_preauth_social_proof_inline_cta'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15 — Embed card footer rovo action for resolved 3P smart links in confluence
    platform_sl_3p_auth_rovo_embed_footer_exp: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_sl_3p_auth_rovo_embed_footer_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_submenu_open_click: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_submenu_open_click'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-13
    platform_editor_hide_extension_renderer_support: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_hide_extension_renderer_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-23
    platform_editor_fix_new_line_after_heading: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_new_line_after_heading',
            jira: 'platform_editor_fix_new_line_after_heading'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-21
    platform_editor_copy_link_a11y_inconsistency_fix: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_copy_link_a11y_inconsistency_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_editor_fix_lagging_embed_resize_handle: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_lagging_embed_resize_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-30
    platform_editor_fix_cross_origin_editor_focus: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_cross_origin_editor_focus'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_ttvc_inline_extensions: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_ttvc_inline_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-03
    platform_editor_enghealth_a11y_jan_fixes: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_enghealth_a11y_jan_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    cc_fd_db_top_editor_toolbar: (0, $a17a420c10a9979a$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'cc_fd_db_top_editor_toolbar'
        },
        param: 'cohort',
        values: [
            'control',
            'new-description',
            'orig-description'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-04-01
    cc_page_experiences_editor_image_generation: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_page_experiences_editor_image_generation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-23
    'cc-maui-experiment': (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc-maui-experiment',
            jira: 'jira_maui_remix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_maui_create_keyword: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_maui_create_keyword'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // A/A experiment paired with cc_maui_create_keyword, used only to balance exposures.
    cc_maui_create_keyword_aa: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_maui_create_keyword_aa'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-13
    confluence_native_tabs_experiment: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_native_tabs_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-29
    cc_maui_polish_changes_batch_4: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_maui_polish_changes_batch_4'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    'cc-mui-slides-experiment': (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc-mui-slides-experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-27
    confluence_frontend_cwr_outcome_type_picker: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_frontend_cwr_outcome_type_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    cfe_cwr_outcome_picker_respect_site_settings: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cfe_cwr_outcome_picker_respect_site_settings'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-12
    prompt_tile_content_type_localizaiton: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'prompt_tile_content_type_localizaiton'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-24
    'cwr-modal-ui-refresh': (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cwr-modal-ui-refresh'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-08
    'cc-disambiguation-in-cwr': (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc-disambiguation-in-cwr'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    'cwr-reduce-prompt-suggestion-max-chars': (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cwr-reduce-prompt-suggestion-max-chars'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15
    'cwr-staging-area-close-as-minimize-button': (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cwr-staging-area-close-as-minimize-button'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-08
    cc_cwr_prompt_strength_indicator: (0, $a17a420c10a9979a$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'cc_cwr_prompt_strength_indicator'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1',
            'variant2'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-02-12
    platform_editor_a11y_escape_link_dialog: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_a11y_escape_link_dialog',
            jira: 'platform_editor_a11y_escape_link_dialog'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_vc90_transition_panel_icon: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_vc90_transition_panel_icon'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_emoji_default_scale: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_emoji_default_scale',
            jira: 'platform_editor_emoji_default_scale'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-17
    platform_editor_emoji_hover_show_tooltip: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_emoji_hover_show_tooltip',
            jira: 'platform_editor_emoji_hover_show_tooltip'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    platform_teamoji_26_refresh_emoji_picker: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_teamoji_26_refresh_emoji_picker',
            jira: 'platform_teamoji_26_refresh_emoji_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-16
    platform_use_unicode_emojis: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_use_unicode_emojis_confluence',
            jira: 'platform_use_unicode_emojis_jira',
            bitbucket: 'platform_use_unicode_emojis_bitbucket'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-26
    platform_editor_toolbar_update_jira_config: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            jira: 'platform_editor_toolbar_update_jira_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_ai_blockmenu_integration: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_blockmenu_integration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-26
    platform_editor_remix_in_block_menu: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_remix_in_block_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19 — fix table text length calculation for Remix/Improve Writing hero prompts
    remix_iw_block_menu_table_calc_fix: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'remix_iw_block_menu_table_calc_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_rovobutton_smartlink_toolbar_exp: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_rovobutton_smartlink_toolbar_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    confluence_fe_renderer_inline_node_mark_color_fix: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_fe_renderer_inline_node_mark_color_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_diff_plugin_extended: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_diff_plugin_extended'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_fix_media_toolbar_border_dropdown: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_media_toolbar_border_dropdown'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-06
    platform_editor_single_player_expand: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_single_player_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_fit_to_content_on_demand: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_table_fit_to_content_on_demand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-09
    platform_editor_remove_collab_step_metrics: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_remove_collab_step_metrics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    platform_editor_ai_normalized_telemetry: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_normalized_telemetry'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-15
    platform_editor_sync_block_ssr_config: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_sync_block_ssr_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-06
    confluence_fe_create_page_suggestion: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_fe_create_page_suggestion'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-18
    platform_editor_selection_toolbar_block_handle: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_selection_toolbar_block_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    platform_editor_improve_preset_builder_logging: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_improve_preset_builder_logging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-23
    'cc-markdown-mode': (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc-markdown-mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_ai_xstate_migration: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_xstate_migration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-31
    platform_editor_dnd_accessibility_fixes_expand: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_dnd_accessibility_fixes_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-15
    platform_editor_ai_no_stream_skip_pacer: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_no_stream_skip_pacer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-07
    platform_editor_layout_column_menu: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_layout_column_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-29
    platform_editor_layout_column_selection_fix: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_layout_column_selection_fix',
            jira: 'platform_editor_layout_column_selection_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15
    platform_editor_layout_column_valign_rendering: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_layout_column_valign_rendering'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    platform_editor_external_embed_grid_fix: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_external_embed_grid_fix',
            jira: 'platform_editor_external_embed_grid_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-08
    cc_fd_wb_jira_quick_insert_experiment: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            jira: 'cc_fd_wb_jira_quick_insert_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-30
    cc_fix_editor_context_on_cwr_followups: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_fix_editor_context_on_cwr_followups'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    cc_fix_ephemeral_preview_staging_area_registration: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_fix_ephemeral_preview_staging_area_registration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    platform_editor_hydration_skip_react_portal: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_hydration_skip_react_portal'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-28
    platform_editor_use_markdown_plus_parser: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_use_markdown_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_use_html_plus_parser: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_use_html_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    platform_editor_core_static_css: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_core_static_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_core_non_ecc_static_css: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_core_non_ecc_static_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_q4_loveability: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_table_q4_loveability',
            jira: 'platform_editor_table_q4_loveability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    platform_editor_table_menu_updates: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_table_menu_updates',
            jira: 'platform_editor_table_menu_updates'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-06
    confluence_live_doc_table_sort_bugfix: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_live_doc_table_sort_bugfix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    confluence_fe_disable_comment_if_offline_fix: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_fe_disable_comment_if_offline_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    platform_editor_sync_block_activation: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_sync_block_activation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_paste_actions_menu_v2: (0, $a17a420c10a9979a$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu_v2',
            jira: 'platform_editor_paste_actions_menu_v2'
        },
        param: 'variant',
        values: [
            'control',
            'hasSpellingAndGrammar',
            'hasAltAiActions'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-05-01 — Social proof experiment for unauthorized 3P block cards
    social_proof_3p_unauth_block_exp: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'social_proof_3p_unauth_block_exp',
            jira: 'social_proof_3p_unauth_block_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_replace_doc/setup
    platform_editor_ai_replace_doc: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_replace_doc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-18
    platform_editor_nest_table_in_panel: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_nest_table_in_panel'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_rovo_support_create_inline_comment: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_rovo_support_create_inline_comment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_fix_sticky_header_malfunction: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_sticky_header_malfunction'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-17
    platform_editor_fix_sticky_header_row: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_sticky_header_row'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-10
    confluence_editor_paste_3p_link_actions_menu: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_editor_paste_3p_link_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-29
    'a11y-fixes-week3-may-2026': (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'a11y-fixes-week3-may-2026',
            jira: 'a11y-fixes-week3-may-2026'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_reactions_selector_list: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_a11y_fixes_reactions_selector_list',
            jira: 'platform_a11y_fixes_reactions_selector_list'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_emoji_picker_list: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_a11y_fixes_emoji_picker_list',
            jira: 'platform_a11y_fixes_emoji_picker_list'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_emoji_title_shortname: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_a11y_fixes_emoji_title_shortname',
            jira: 'platform_a11y_fixes_emoji_title_shortname'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-25
    // HTML+ v2 incremental tool-call streaming contract — gates the new
    // PartialStreamParserV2 / ToolCallProcessorV2 / AdfChunkStrategyV2 stack
    // in `@atlassian/editor-rovo-bridge`, the `replaceValue` orchestrator
    // action, and the `toolCallsStreaming.supportsProvisionalToolCalls`
    // capability advert on `PageContentCommandResult`.
    platform_editor_use_html_plus_streaming_parser: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_use_html_plus_streaming_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_wide_slash_trigger: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_wide_slash_trigger'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11 — [CCI-15904] New AIFC Editor Experience (Full Page Staging Area + Post Stream Review Toolbar)
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_new_aifc_editor_experience/setup
    platform_editor_ai_new_aifc_editor_experience: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_new_aifc_editor_experience'
        },
        param: 'isBackendReviewMomentEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    // Gates the `GhostIconWave` animation primitive in
    // `@atlassian/rovo-platform-ui-components` — rendered as a loading cue on
    // Confluence's 3p-in-CWR (Rovo) surfaces. When off the primitive renders
    // nothing.
    confluence_3p_in_cwr_ghost_icons: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_3p_in_cwr_ghost_icons'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    platform_editor_lovability_text_bg_color: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_text_bg_color',
            jira: 'platform_editor_lovability_text_bg_color'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-20
    platform_editor_ssr_toolbar_optimistic: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ssr_toolbar_optimistic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19
    platform_editor_lovability_resize_dividers_panels: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_resize_dividers_panels'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_editor_add_breakout_marks_on_page_load: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_add_breakout_marks_on_page_load'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-23
    'aifc-confluence-editor-csp-fix': (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'aifc-confluence-editor-csp-fix',
            jira: 'aifc-confluence-editor-csp-fix'
        },
        param: 'value',
        defaultValue: false
    }),
    // Added 2026-07-01
    platform_editor_remove_pause_streaming: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_remove_pause_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-17
    revert_remix_ephemeral_iframe_sizing_fix: (0, $7baf39fa4861eac2$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'revert_remix_ephemeral_iframe_sizing_fix',
            jira: 'revert_remix_ephemeral_iframe_sizing_fix'
        },
        param: 'value',
        defaultValue: false
    }),
    // Added 2026-07-28
    cwr_publish_flow_live_doc_toggle_exp: (0, $a17a420c10a9979a$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'cwr_publish_flow_live_doc_toggle_exp'
        },
        param: 'cohort',
        defaultValue: 'control',
        values: [
            'control',
            'variantA',
            'variantB',
            'variantC'
        ]
    })
};



var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");
var $4308dc3dd5bb19c3$export$7e849a84a00ffd1c = {
    cwr_publish_flow_live_doc_toggle_exp: 'control',
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_controls: 'control',
    cc_editor_ai_content_mode: 'control',
    platform_hover_card_preview_panel: 'control',
    cc_editor_insm_outlier_events: 'test',
    platform_editor_table_sticky_header_improvements: 'test_with_overflow',
    cc_fd_db_top_editor_toolbar: 'control',
    platform_editor_paste_actions_menu_v2: 'control',
    confluence_quick_insert_embeds: 'control',
    cc_cwr_prompt_strength_indicator: 'control',
    confluence_cwr_3p_connection_suggested_prompts: 'control'
};
var $4308dc3dd5bb19c3$export$54960937bb713f97 = {
    cc_maui_polish_changes_batch_4: false,
    social_proof_3p_unauth_block_exp: false,
    platform_sl_3p_preauth_better_hovercard: true,
    cwr_blank_object_experiment: false,
    platform_editor_preview_panel_responsiveness: false,
    'enghealth-53346_fix_redaction_marker_editor': false,
    platform_editor_toolbar_aifc: false,
    'test-new-experiments-package': false,
    platform_renderer_table_sticky_scrollbar: false,
    advanced_layouts: false,
    single_column_layouts: false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_editor_tables_table_selector: false,
    platform_renderer_fix_analytics_memo_callback: false,
    'jira-work-sync-desc-comment-summary': false,
    platform_editor_breakout_resizing: false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_enable_single_player_step_merging: false,
    platform_editor_paste_actions_menu: false,
    platform_editor_table_fit_to_content_on_demand: false,
    platform_editor_table_q4_loveability: false,
    platform_editor_table_menu_updates: false,
    'cwr-modal-ui-refresh': false,
    'cc-disambiguation-in-cwr': false,
    'cwr-reduce-prompt-suggestion-max-chars': false,
    'cwr-staging-area-close-as-minimize-button': false,
    prompt_tile_content_type_localizaiton: false,
    // [CCI-15904] New AIFC Editor Experience — read by the inline chat prompt view
    // in `conversation-assistant-chat-prompt-input`. Review moment eligibility is a
    // separate check (`editor-plugin-ai/src/ui/utils/review-moment-enabled.ts`) and
    // does not read this key.
    platform_editor_ai_new_aifc_editor_experience: false,
    cc_page_experiences_editor_image_generation: false,
    platform_use_unicode_emojis: false,
    platform_editor_emoji_hover_show_tooltip: false,
    'aifc-confluence-editor-csp-fix': false
};



function $9ee46fa0dbaa7578$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9ee46fa0dbaa7578$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9ee46fa0dbaa7578$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9ee46fa0dbaa7578$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9ee46fa0dbaa7578$export$e5d73bf4f8e2ae96 = {};
var $9ee46fa0dbaa7578$export$4e849416bb5c5b52 = {};
var $9ee46fa0dbaa7578$export$cf7305fc65acbf0d;
function $9ee46fa0dbaa7578$export$1c2b6dbf79eb3560(product, /**
 * Overrides are used to set the group of an experiment for testing purposes.
 * This is useful when you want to test a specific experiment group.
 */ groupOverrides, /**
 * Param overrides are used to set the experiment parameters for testing purposes.
 * This is useful when you want to tweak the experiment parameters for testing.
 */ paramOverrides, options) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        groupOverrides = Object.entries(groupOverrides).reduce(function(acc, _ref) {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
            var config = (0, $1ac22aed74317d57$export$6cbb856f286b07ef)[key];
            if (config) acc = $9ee46fa0dbaa7578$var$_objectSpread($9ee46fa0dbaa7578$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, config.typeGuard(value) ? value : config.defaultValue));
            return acc;
        }, {});
        $9ee46fa0dbaa7578$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test' && !(options !== null && options !== void 0 && options.disableTestOverrides)) {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        var testOverrides = Object.fromEntries(Object.entries((0, $1ac22aed74317d57$export$6cbb856f286b07ef)).map(function(_ref3) {
            var _ref5, _ref6, _groupOverrides, _groupOverrides2;
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), key = _ref4[0], value = _ref4[1];
            var defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                (_ref5 = (_ref6 = (_groupOverrides = (_groupOverrides2 = groupOverrides) === null || _groupOverrides2 === void 0 ? void 0 : _groupOverrides2[key]) !== null && _groupOverrides !== void 0 ? _groupOverrides : (0, $4308dc3dd5bb19c3$export$7e849a84a00ffd1c)[key]) !== null && _ref6 !== void 0 ? _ref6 : (0, $4308dc3dd5bb19c3$export$54960937bb713f97)[key]) !== null && _ref5 !== void 0 ? _ref5 : defaultValue
            ];
        }));
        $9ee46fa0dbaa7578$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $9ee46fa0dbaa7578$export$cf7305fc65acbf0d = product;
    $9ee46fa0dbaa7578$export$4e849416bb5c5b52 = paramOverrides || {};
}


// This internal representation doesn't currently support productKeys
// the way expVal(...) does, this adds temporary support for some keys while
// we determine our preferred approach forward
var $d1e7bb1fad29e0f0$var$allowsProductKeys = [
    'cc-maui-experiment',
    'cc_maui_create_keyword',
    'cc_maui_create_keyword_aa',
    'platform_use_unicode_emojis'
];
function $d1e7bb1fad29e0f0$export$58e581060588c6bb(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, experimentExposure) {
    var _editorExperimentsCon, _editorExperimentsCon2;
    if ((0, $9ee46fa0dbaa7578$export$e5d73bf4f8e2ae96)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $9ee46fa0dbaa7578$export$e5d73bf4f8e2ae96)[experimentName] === experimentExpectedValue;
    // If client is not initialized, we compare with the default value
    if (!(0, $7f069327a0ab9221$export$2e2bcd8739ae039).initializeCompleted()) return experimentDefaultValue === experimentExpectedValue;
    // Typescript is complaining here about accessing the productKeys property
    var experimentKeyName = $d1e7bb1fad29e0f0$var$allowsProductKeys.includes(experimentName) ? (_editorExperimentsCon = (_editorExperimentsCon2 = (0, $1ac22aed74317d57$export$6cbb856f286b07ef)[experimentName]) === null || _editorExperimentsCon2 === void 0 || (_editorExperimentsCon2 = _editorExperimentsCon2.productKeys) === null || _editorExperimentsCon2 === void 0 ? void 0 : _editorExperimentsCon2[0, $9ee46fa0dbaa7578$export$cf7305fc65acbf0d]) !== null && _editorExperimentsCon !== void 0 ? _editorExperimentsCon : experimentName : experimentName;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $7f069327a0ab9221$export$2e2bcd8739ae039).getExperimentValue(experimentKeyName, experimentParam, experimentDefaultValue, {
        fireExperimentExposure: experimentExposure
    });
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $7f069327a0ab9221$export$2e2bcd8739ae039).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $8qy01.addFeatureFlagAccessed)("".concat(experimentKeyName, ":").concat(experimentParam), experimentValue);
    return experimentValue === experimentExpectedValue;
}


function $5d4a37b41710bdea$export$63eebf86443a0a61(experimentName, experimentParam, experimentExpectedValue) {
    var experimentDefaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return (0, $d1e7bb1fad29e0f0$export$58e581060588c6bb)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, false);
}


var $583caa1295a28541$var$_editorTextPalette;
function $583caa1295a28541$var$_defineAccessor(e, r, n, t) {
    var c = {
        configurable: !0,
        enumerable: !0
    };
    return c[e] = t, Object.defineProperty(r, n, c);
}
function $583caa1295a28541$export$9c2f408d391feb93(hexColor) {
    var normalizedHexColor = hexColor ? hexColor.toUpperCase() : undefined;
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return normalizedHexColor ? $583caa1295a28541$export$57fa5089caad992[normalizedHexColor] : undefined;
}
var $583caa1295a28541$export$57fa5089caad992 = ($583caa1295a28541$var$_editorTextPalette = {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($583caa1295a28541$var$_editorTextPalette, '#B3D4FF', "var(--ds-background-accent-blue-subtler, #CFE1FD)"), '#4C9AFF', "var(--ds-icon-accent-blue, #357DE8)"), '#0747A6', "var(--ds-text-accent-blue, #1558BC)"), '#B3F5FF', "var(--ds-background-accent-teal-subtler, #C6EDFB)"), '#00B8D9', "var(--ds-icon-accent-teal, #2898BD)"), '#008DA6', "var(--ds-text-accent-teal, #206A83)"), '#ABF5D1', "var(--ds-background-accent-green-subtler, #BAF3DB)"), '#36B37E', "var(--ds-icon-accent-green, #22A06B)"), '#006644', "var(--ds-text-accent-green, #216E4E)"), '#FFF0B3', "var(--ds-background-accent-yellow-subtler, #F5E989)"), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($583caa1295a28541$var$_editorTextPalette, '#FFC400', "var(--ds-background-accent-orange-subtle, #FCA700)"), '#FF991F', "var(--ds-icon-accent-orange, #E06C00)"), '#FFBDAD', "var(--ds-background-accent-red-subtler, #FFD5D2)"), '#FF5630', "var(--ds-icon-accent-red, #C9372C)"), '#BF2600', "var(--ds-text-accent-red, #AE2E24)"), '#EAE6FF', "var(--ds-background-accent-purple-subtler, #EED7FC)"), '#6554C0', "var(--ds-icon-accent-purple, #AF59E1)"), '#403294', "var(--ds-text-accent-purple, #803FA5)"), '#FFFFFF', "var(--ds-text-inverse, #FFFFFF)"), '#97A0AF', "var(--ds-icon-accent-gray, #7D818A)"), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($583caa1295a28541$var$_editorTextPalette, '#172B4D', "var(--ds-text, #292A2E)"), '#D3F1A7', "var(--ds-background-accent-lime-subtler, #D3F1A7)"), '#6A9A23', "var(--ds-icon-accent-lime, #6A9A23)"), '#4C6B1F', "var(--ds-text-accent-lime, #4C6B1F)"), '#FCE4A6', "var(--ds-background-accent-orange-subtler, #FCE4A6)"), '#E06C00', "var(--ds-icon-accent-orange, #E06C00)"), '#9E4C00', "var(--ds-text-accent-orange, #9E4C00)"), '#FDD0EC', "var(--ds-background-accent-magenta-subtler, #FDD0EC)"), '#CD519D', "var(--ds-icon-accent-magenta, #CD519D)"), '#943D73', "var(--ds-text-accent-magenta, #943D73)"), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($583caa1295a28541$var$_defineAccessor("get", $583caa1295a28541$var$_editorTextPalette, '#B38600', function() {
    return (0, $5d4a37b41710bdea$export$63eebf86443a0a61)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && (0, $50U6m.fg)('platform_editor_lovability_text_bg_color_patch_1') ? "var(--ds-border-accent-yellow, #B38600)" : "var(--ds-icon-accent-yellow, #B38600)";
}), '#7F5F01', "var(--ds-text-accent-yellow, #7F5F01)"));



var $jLsC1 = parcelRequire("jLsC1");
function $c16c5e74cb7ad188$export$2e2bcd8739ae039(props) {
    var _useThemeObserver = (0, $jLsC1.useThemeObserver)(), colorMode = _useThemeObserver.colorMode;
    // Note -- while there is no way to create custom colors using default tooling
    // the editor does supported ad hoc color values -- and there may be content
    // which has been migrated or created via apis which use such values.
    var paletteColorValue;
    /**
   * The Editor persists custom text colors when content has been migrated from the old editor, or created via
   * apis.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text colors copied from external editor sources. Where we load the background color from a
   * seperate attribute (data-text-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ var tokenColor = (0, $583caa1295a28541$export$9c2f408d391feb93)(props.color);
    if (tokenColor) paletteColorValue = (0, $583caa1295a28541$export$9c2f408d391feb93)(props.color) || props.color;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $cQBqP.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    var style = (0, $5FkrB.useMemo)(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, '--custom-palette-color', paletteColorValue);
    }, [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props.dataAttributes, {
        "data-text-custom-color": props.color,
        className: "fabric-text-color-mark",
        style: style
    }), props.children);
}



var $5FkrB = parcelRequire("5FkrB");
function $a43077aec2438448$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("u", props.dataAttributes, props.children);
}



var $5FkrB = parcelRequire("5FkrB");
function $c58e089383781168$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", props.dataAttributes, props.children);
}



var $5FkrB = parcelRequire("5FkrB");
function $0d40a60c16b721e3$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", props.dataAttributes, props.children);
}


var $6ea97fdfef30088f$export$c00d967a0f56fdb7 = {
    code: (0, $7b2d933bcff57ef4$export$2e2bcd8739ae039),
    em: (0, $8ba2e00755bbf395$export$2e2bcd8739ae039),
    link: (0, $34deba354526914d$export$2e2bcd8739ae039),
    strike: (0, $4f2072525bb46916$export$2e2bcd8739ae039),
    strong: (0, $bf141d5161e77678$export$2e2bcd8739ae039),
    subsup: (0, $12c13372ddda400f$export$2e2bcd8739ae039),
    textColor: (0, $c16c5e74cb7ad188$export$2e2bcd8739ae039),
    backgroundColor: (0, $7eff8bb2e3b8a318$export$2e2bcd8739ae039),
    underline: (0, $a43077aec2438448$export$2e2bcd8739ae039),
    annotation: (0, $w2fDc.default),
    border: (0, $b6e959fc4dd558ff$export$2e2bcd8739ae039),
    fontSize: (0, $6f2c0f83ad3cc28c$export$2e2bcd8739ae039),
    // Stage0
    confluenceInlineComment: (0, $e558e5bbc09a7442$export$2e2bcd8739ae039),
    breakout: (0, $c0e50d9529b2a755$export$2e2bcd8739ae039),
    alignment: (0, $cc7b02ff90190344$export$2e2bcd8739ae039),
    indentation: (0, $e980729e1759a63a$export$2e2bcd8739ae039),
    unsupportedMark: (0, $c58e089383781168$export$2e2bcd8739ae039),
    unsupportedNodeAttribute: (0, $0d40a60c16b721e3$export$2e2bcd8739ae039),
    dataConsumer: (0, $f3bfc2c67e24dc3e$export$2e2bcd8739ae039),
    fragment: (0, $298953afb828ae9b$export$2e2bcd8739ae039)
};
var $6ea97fdfef30088f$export$d4334b129116aad7 = function toReact(mark) {
    return $6ea97fdfef30088f$export$c00d967a0f56fdb7[mark.type.name];
};



parcelRequire("9M0Oh");
var $ac0Rs = parcelRequire("ac0Rs");
var $9M0Oh = parcelRequire("9M0Oh");

var $5FkrB = parcelRequire("5FkrB");

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $5FkrB = parcelRequire("5FkrB");
function $00533252bf4c5c68$export$8a20fd0614851c5f(segments, textHighlighter, marksList, startPos) {
    var Component = textHighlighter === null || textHighlighter === void 0 ? void 0 : textHighlighter.component;
    var marks = new Set(marksList.map(function(m) {
        return m.type.name;
    }));
    function renderSegment(segment) {
        var idx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        if (segment.type === 'plain' || !Component) return segment.text;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
            "data-highlighted": true,
            "data-vc": "highlighted-text",
            key: "".concat(segment.text, "_").concat(startPos, "_").concat(idx)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Component, {
            match: segment.text,
            groups: segment.groups,
            marks: marks,
            startPos: startPos + idx
        }, segment.text));
    }
    if (segments.length === 1) return renderSegment(segments[0]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, {
        key: "text-wrapper_".concat(startPos)
    }, segments.map(renderSegment));
}


function $da823e371d629bd7$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $da823e371d629bd7$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $da823e371d629bd7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $da823e371d629bd7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $da823e371d629bd7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $da823e371d629bd7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $da823e371d629bd7$export$93301b6f1ff0b0c3(text, highlighter) {
    if (!highlighter || !text) return [
        {
            type: 'plain',
            text: text !== null && text !== void 0 ? text : ''
        }
    ];
    var segments = [];
    var pos = 0;
    try {
        var markTextSegmentMatches = text.matchAll(highlighter.pattern);
        var _iterator = $da823e371d629bd7$var$_createForOfIteratorHelper(markTextSegmentMatches), _step;
        try {
            var _loop = function _loop() {
                var markTextMatch = _step.value;
                if (markTextMatch.index !== 0) segments.push({
                    type: 'plain',
                    text: text.substring(pos, markTextMatch.index)
                });
                segments.push({
                    type: 'match',
                    text: markTextMatch[0],
                    groups: markTextMatch.groups && // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    Object.keys(markTextMatch.groups).filter(function(key) {
                        return markTextMatch.groups[key];
                    })
                });
                pos = markTextMatch.index + markTextMatch[0].length;
            };
            for(_iterator.s(); !(_step = _iterator.n()).done;)_loop();
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        if (pos < text.length) segments.push({
            type: 'plain',
            text: text.substring(pos)
        });
        return segments;
    } catch (_e) {}
    return [
        {
            type: 'plain',
            text: text
        }
    ];
}



var $fDwDe = parcelRequire("fDwDe");

var $38vNc = parcelRequire("38vNc");
var $e6e266389a291656$export$c1bd4813440b4505 = /*#__PURE__*/ function(InsertDraftPosition) {
    InsertDraftPosition["AROUND_TEXT"] = "AROUND_TEXT";
    InsertDraftPosition["START"] = "START";
    InsertDraftPosition["END"] = "END";
    InsertDraftPosition["INSIDE"] = "INSIDE";
    return InsertDraftPosition;
}({});



var $eyRpM = parcelRequire("eyRpM");

var $3aff10c8472757a3$export$b1baddbd5f289877 = function calcInsertDraftPositionOnText(_ref, position) {
    var startTextPosition = _ref.start, endTextPosition = _ref.end;
    var isRangePositionAroundText = position.from <= startTextPosition && position.to >= endTextPosition;
    if (isRangePositionAroundText) return (0, $e6e266389a291656$export$c1bd4813440b4505).AROUND_TEXT;
    var isRangePositionInsideText = position.from > startTextPosition && position.from < endTextPosition && position.to < endTextPosition && position.to > startTextPosition;
    if (isRangePositionInsideText) return (0, $e6e266389a291656$export$c1bd4813440b4505).INSIDE;
    var isRangePositionStartingAtText = position.from >= startTextPosition && position.from <= endTextPosition && position.to >= endTextPosition;
    if (isRangePositionStartingAtText) return (0, $e6e266389a291656$export$c1bd4813440b4505).END;
    var isRangePositionEndingAtText = position.from <= startTextPosition && position.to >= startTextPosition && position.to <= endTextPosition;
    if (isRangePositionEndingAtText) return (0, $e6e266389a291656$export$c1bd4813440b4505).START;
    return false;
};



var $5FkrB = parcelRequire("5FkrB");
function $b44ac14cc36cbe03$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $b44ac14cc36cbe03$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $b44ac14cc36cbe03$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b44ac14cc36cbe03$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b44ac14cc36cbe03$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b44ac14cc36cbe03$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $b44ac14cc36cbe03$export$a9795c84b22a1f06 = function findTextString(reactNode) {
    var result = null;
    var children = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.toArray(reactNode);
    var _iterator = $b44ac14cc36cbe03$var$_createForOfIteratorHelper(children), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var childNode = _step.value;
            if (result) break;
            else if (typeof childNode === 'string') result = childNode;
            else if ($b44ac14cc36cbe03$var$isReactElement(childNode) && childNode.props.children) result = $b44ac14cc36cbe03$export$a9795c84b22a1f06(childNode.props.children);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return result;
};
function $b44ac14cc36cbe03$var$isReactElement(child) {
    return !!child.type;
}
var $b44ac14cc36cbe03$export$2878cc467c8be8fe = function splitText(text, _ref) {
    var startOffset = _ref.startOffset, endOffset = _ref.endOffset;
    if (endOffset > text.length || endOffset - startOffset <= 0) return null;
    return [
        text.slice(0, startOffset),
        text.slice(startOffset, endOffset),
        text.slice(endOffset)
    ].filter(Boolean);
};
var $b44ac14cc36cbe03$export$1059bfc467f4f55d = function calcTextSplitOffset(position, textPosition, text) {
    var start = textPosition.start, end = textPosition.end;
    var startOffset = Math.max(position.from - start, 0);
    var endOffset = Math.min(Math.abs(end - position.to - text.length), text.length);
    return {
        startOffset: startOffset,
        endOffset: endOffset
    };
};


// Localized AnnotationSharedCSSByState().common and AnnotationSharedCSSByState().focus
var $cd97ba6fc7bf5abf$var$markStyles = (0, $74Zh5.css)({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent',
    borderBottom: "var(--ds-border-width-selected, 2px)".concat(" solid transparent"),
    cursor: 'pointer',
    padding: '1px 0 2px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.card), &:has([data-inline-card])': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.date-lozenger-container)': {
        paddingTop: "var(--ds-space-025, 2px)"
    },
    background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
});
var $cd97ba6fc7bf5abf$export$8062d68eccdfa39c = function AnnotationDraft(_ref) {
    var draftPosition = _ref.draftPosition, children = _ref.children;
    var _useAnnotationManager = (0, $fDwDe.useAnnotationManagerDispatch)(), dispatch = _useAnnotationManager.dispatch;
    var markRef = (0, $5FkrB.useCallback)(function(node) {
        dispatch({
            type: 'setDraftMarkRef',
            data: {
                draftMarkRef: node !== null && node !== void 0 ? node : undefined
            }
        });
    }, [
        dispatch
    ]);
    return (0, $74Zh5.jsx)("mark", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-renderer-mark": true
    }, (0, $eyRpM.dataAttributes)(draftPosition), {
        css: $cd97ba6fc7bf5abf$var$markStyles,
        ref: markRef
    }), children);
};
var $cd97ba6fc7bf5abf$export$846ef6158669db08 = function getAnnotationIndex(annotationPosition, fragmentCount) {
    if (annotationPosition === (0, $e6e266389a291656$export$c1bd4813440b4505).START) return 0;
    if (annotationPosition === (0, $e6e266389a291656$export$c1bd4813440b4505).END) return fragmentCount - 1;
    if (annotationPosition === (0, $e6e266389a291656$export$c1bd4813440b4505).INSIDE && fragmentCount === 3) return 1;
    return -1;
};
var $cd97ba6fc7bf5abf$export$b756d37afc321d72 = function applyAnnotationOnText(_ref2) {
    var texts = _ref2.texts, shouldApplyAnnotationAt = _ref2.shouldApplyAnnotationAt, draftPosition = _ref2.draftPosition, textHighlighter = _ref2.textHighlighter, marks = _ref2.marks;
    var annotateIndex = $cd97ba6fc7bf5abf$export$846ef6158669db08(shouldApplyAnnotationAt, texts.length);
    return texts.map(function(value, index) {
        var segments = (0, $da823e371d629bd7$export$93301b6f1ff0b0c3)(value, textHighlighter);
        if (annotateIndex === index) return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        (0, $74Zh5.jsx)($cd97ba6fc7bf5abf$export$8062d68eccdfa39c, {
            key: index,
            draftPosition: draftPosition
        }, (0, $00533252bf4c5c68$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], draftPosition.from)));
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, {
            key: index
        }, (0, $00533252bf4c5c68$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], draftPosition.from)));
    });
};
var $cd97ba6fc7bf5abf$export$69a4e0ac39aaf9b7 = function TextWithAnnotationDraft(_ref3) {
    var startPos = _ref3.startPos, endPos = _ref3.endPos, children = _ref3.children, textHighlighter = _ref3.textHighlighter, marks = _ref3.marks;
    var textPosition = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        return {
            start: startPos,
            end: endPos
        };
    }, [
        endPos,
        startPos
    ]);
    var _useAnnotationRangeSt = (0, $38vNc.useAnnotationRangeState)(), nextDraftPosition = _useAnnotationRangeSt.selectionDraftDocumentPosition;
    var shouldApplyAnnotationAt = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        if (!nextDraftPosition) return false;
        return (0, $3aff10c8472757a3$export$b1baddbd5f289877)(textPosition, nextDraftPosition);
    }, [
        nextDraftPosition,
        textPosition
    ]);
    var textString = (0, $b44ac14cc36cbe03$export$a9795c84b22a1f06)(children);
    if (!textString) return (0, $74Zh5.jsx)((0, $5FkrB.Fragment), null, children);
    if (shouldApplyAnnotationAt === false || !nextDraftPosition) {
        var segments = (0, $da823e371d629bd7$export$93301b6f1ff0b0c3)(textString, textHighlighter);
        return (0, $74Zh5.jsx)((0, $5FkrB.Fragment), null, (0, $00533252bf4c5c68$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], startPos));
    }
    if (shouldApplyAnnotationAt === (0, $e6e266389a291656$export$c1bd4813440b4505).AROUND_TEXT) {
        var _segments = (0, $da823e371d629bd7$export$93301b6f1ff0b0c3)(textString, textHighlighter);
        return (0, $74Zh5.jsx)($cd97ba6fc7bf5abf$export$8062d68eccdfa39c, {
            key: 0,
            draftPosition: nextDraftPosition
        }, (0, $00533252bf4c5c68$export$8a20fd0614851c5f)(_segments, textHighlighter, marks || [], startPos));
    }
    var offsets = (0, $b44ac14cc36cbe03$export$1059bfc467f4f55d)(nextDraftPosition, textPosition, textString);
    var texts = (0, $b44ac14cc36cbe03$export$2878cc467c8be8fe)(textString, offsets);
    if (!texts) {
        var _segments2 = (0, $da823e371d629bd7$export$93301b6f1ff0b0c3)(textString, textHighlighter);
        return (0, $74Zh5.jsx)((0, $5FkrB.Fragment), null, (0, $00533252bf4c5c68$export$8a20fd0614851c5f)(_segments2, textHighlighter, marks || [], startPos));
    }
    var components = $cd97ba6fc7bf5abf$export$b756d37afc321d72({
        texts: texts,
        shouldApplyAnnotationAt: shouldApplyAnnotationAt,
        draftPosition: nextDraftPosition,
        textHighlighter: textHighlighter,
        marks: marks
    });
    return (0, $74Zh5.jsx)((0, $5FkrB.Fragment), null, components);
};


var $0add6e4a2440403c$var$TextWrapper = function TextWrapper(props) {
    var startPos = props.startPos, endPos = props.endPos;
    var children = props.children;
    if (!children) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cd97ba6fc7bf5abf$export$69a4e0ac39aaf9b7), {
        startPos: startPos,
        endPos: endPos,
        textHighlighter: props.textHighlighter,
        marks: props.marks
    }, children);
};
var $0add6e4a2440403c$export$2e2bcd8739ae039 = $0add6e4a2440403c$var$TextWrapper;


function $0b366d21bf0dee21$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $0b366d21bf0dee21$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $0b366d21bf0dee21$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $0b366d21bf0dee21$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $0b366d21bf0dee21$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $0b366d21bf0dee21$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $0b366d21bf0dee21$var$isLayoutNode = function isLayoutNode(node) {
    return node.type.name === 'layoutSection';
};
var $0b366d21bf0dee21$var$isExpandNode = function isExpandNode(node) {
    return node.type.name === 'expand';
};
var $0b366d21bf0dee21$var$hasBreakOutMark = function hasBreakOutMark(node) {
    return node.marks.some(function(m) {
        return m.type.name === 'breakout';
    });
};
var $0b366d21bf0dee21$export$d7bc71cca336a3b = function insideBreakoutLayout(path) {
    return path.some(function(item) {
        return $0b366d21bf0dee21$var$isLayoutNode(item) && $0b366d21bf0dee21$var$hasBreakOutMark(item);
    });
};
var $0b366d21bf0dee21$export$3e763fd7277c58c5 = function insideBreakoutExpand(path) {
    return path.some(function(item) {
        return $0b366d21bf0dee21$var$isExpandNode(item) && $0b366d21bf0dee21$var$hasBreakOutMark(item);
    });
};
var $0b366d21bf0dee21$export$42ddc573eb5a7b43 = function insideBlockNode(path, schema) {
    var _schema$nodes = schema.nodes, expand = _schema$nodes.expand, nestedExpand = _schema$nodes.nestedExpand, layoutColumn = _schema$nodes.layoutColumn;
    var blockNodeNames = [
        expand,
        nestedExpand,
        layoutColumn
    ].filter(function(node) {
        return Boolean(node);
    }).map(function(node) {
        return node.name;
    });
    return path && path.some(function(n) {
        return n.type && blockNodeNames.indexOf(n.type.name) > -1;
    });
};
var $0b366d21bf0dee21$export$9f1e9347b0411934 = function insideMultiBodiedExtension(path, schema) {
    var multiBodiedExtension = schema.nodes.multiBodiedExtension;
    return path.some(function(n) {
        return n.type === multiBodiedExtension;
    });
};
var $0b366d21bf0dee21$export$244bf4b32387ef62 = function insideTable(path, schema) {
    var table = schema.nodes.table;
    return path.some(function(n) {
        return n.type === table;
    });
};
var $0b366d21bf0dee21$export$a8df1f99c673fa27 = function getNestedUnderNodes(path, nodeTypeNames) {
    var _iterator = $0b366d21bf0dee21$var$_createForOfIteratorHelper(path), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var node = _step.value;
            if (nodeTypeNames.includes(node.type.name)) return node.type.name;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return undefined;
};


/**
 * Builds the `getContent` node prop: `fragment.toJSON()` computed on first call and memoized for
 * the lifetime of the props object it is attached to.
 *
 * A prop getter cannot achieve the same deferral: `getProps`' callers spread its result and React
 * copies props again on element creation, so a getter would run before any component reads it.
 */ var $0c13a258c85ceb73$export$18a05b40f8bf404f = function createContentGetter(fragment) {
    var serialized;
    var materialized = false;
    return function() {
        if (!materialized) {
            serialized = fragment ? fragment.toJSON() : undefined;
            // Set last: if `toJSON()` throws, the error propagates and a retry re-attempts instead of
            // caching a partial result.
            materialized = true;
        }
        return serialized;
    };
};



var $6af2eee65b21fc1b$export$eeb66772b38d7581 = function getStandaloneBackgroundColorMarks(content) {
    var standaloneMarks = [];
    // keep track of the previous node's state
    var prev = {
        selfSpaceOnTheRight: true // initial value to handle leading BackgroundColor
    };
    var prevNode = null;
    // Iterates through each node in the content array.
    // Tracks if the previous node had a backgroundColor mark and if it ended with a space.
    // If a backgroundColor mark is followed by a text node that starts with a space,
    // and the previous node ended with a space, the previous backgroundColor mark is considered standalone.
    // At the end, flushes any remaining node that meets the standalone criteria.
    for(var i = 0; i < content.length; i++){
        var node = content[i];
        var nodeMarks = (0, $412c6966035531bf$export$2e2bcd8739ae039).getMarks(node);
        var isBackgroundColor = nodeMarks.some(function(m) {
            return m.type.name === 'backgroundColor';
        });
        var selfSpaceOnTheLeft = false;
        var selfSpaceOnTheRight = false;
        if (node.text) {
            selfSpaceOnTheLeft = node.text.startsWith(' ');
            selfSpaceOnTheRight = node.text.endsWith(' ');
        }
        if (isBackgroundColor) {
            prevNode = node;
            prev = {
                selfSpaceOnTheRight: false,
                hasBackgroundColor: true,
                spaceToTheLeft: prev !== null && prev.selfSpaceOnTheRight
            };
        } else {
            // If prev exists, check for standalone logic
            if (prev && prev.hasBackgroundColor && prevNode) // If prev had space on the left and current is a TextNode and has space on the left
            {
                if (prev.spaceToTheLeft && selfSpaceOnTheLeft) {
                    var mark = (0, $412c6966035531bf$export$2e2bcd8739ae039).getMarks(prevNode).find(function(m) {
                        return m.type.name === 'backgroundColor';
                    });
                    if (mark) standaloneMarks.push(mark);
                }
            }
            prevNode = null;
            prev = {
                selfSpaceOnTheRight: selfSpaceOnTheRight,
                hasBackgroundColor: false
            };
        }
    }
    if (prevNode) {
        if (prev && prev.hasBackgroundColor && prev.spaceToTheLeft) {
            var _mark = (0, $412c6966035531bf$export$2e2bcd8739ae039).getMarks(prevNode).find(function(m) {
                return m.type.name === 'backgroundColor';
            });
            if (_mark) standaloneMarks.push(_mark);
        }
    }
    return standaloneMarks;
};


function $e382f311073cdba5$export$7aa7587d1ce9583c(allowHeadingAnchorLinks) {
    // If it's a boolean or undefined, then we don't support nesting.
    if (!allowHeadingAnchorLinks || typeof allowHeadingAnchorLinks === 'boolean') return false;
    var allowNestedHeaderLinks = allowHeadingAnchorLinks.allowNestedHeaderLinks;
    // Explicit cast to a boolean to cover scenario where it's undefined.
    return !!allowNestedHeaderLinks;
}
function $e382f311073cdba5$export$acb253d79d72af92(allowHeadingAnchorLinks) {
    if (!$e382f311073cdba5$export$7aa7587d1ce9583c(allowHeadingAnchorLinks)) return undefined;
    return allowHeadingAnchorLinks.activeHeadingId;
}



var $iYJcE = parcelRequire("iYJcE");

var $50U6m = parcelRequire("50U6m");
function $df882574d3dae886$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $df882574d3dae886$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $df882574d3dae886$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $df882574d3dae886$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $df882574d3dae886$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $df882574d3dae886$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $df882574d3dae886$export$3a88c97d9b0d8d1c(_ref) {
    var nodes = _ref.nodes, onMark = _ref.onMark, parentPos = _ref.parentPos, shouldDisplayExtensionAsInline = _ref.shouldDisplayExtensionAsInline, _ref$isTopLevel = _ref.isTopLevel, isTopLevel = _ref$isTopLevel === void 0 ? true : _ref$isTopLevel;
    if (!nodes || nodes.length === 0 || nodes[0].isInline) return;
    function isInlineBodiedExtension(node) {
        var _node$attrs, _node$attrs2, _node$attrs3, _node$attrs4, _node$attrs5, _node$attrs6;
        if (!isTopLevel && (node === null || node === void 0 ? void 0 : node.type.name) === 'bodiedExtension' && ((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.extensionType) === 'com.atlassian.ecosystem' && ((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 || (_node$attrs2 = _node$attrs2.parameters) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.layout) === 'inline-bodied' && (0, $50U6m.fg)('platform_forge_inline_bodied_layout_switch') && (0, $50U6m.fg)('platform_forge_inline_bodied_macro')) return false;
        return Boolean((node === null || node === void 0 ? void 0 : node.type.name) === 'bodiedExtension' && shouldDisplayExtensionAsInline({
            type: node.type.name,
            extensionKey: (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.extensionKey,
            extensionType: (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.extensionType,
            parameters: (_node$attrs5 = node.attrs) === null || _node$attrs5 === void 0 ? void 0 : _node$attrs5.parameters,
            content: node.content,
            localId: (_node$attrs6 = node.attrs) === null || _node$attrs6 === void 0 ? void 0 : _node$attrs6.localId
        }));
    }
    try {
        var prevPos = parentPos;
        var pos = parentPos;
        var prevTextBlockType;
        var _iterator = $df882574d3dae886$var$_createForOfIteratorHelper(nodes.entries()), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_step.value, 2), index = _step$value[0], node = _step$value[1];
                var prevNode = nodes[index - 1];
                // textblock + inlinedBodiedExtension
                if (prevNode !== null && prevNode !== void 0 && prevNode.isTextblock && isInlineBodiedExtension(node)) onMark({
                    pos: prevPos
                });
                else if (isInlineBodiedExtension(prevNode) && node.isTextblock && (!prevTextBlockType || node.type === prevTextBlockType)) onMark({
                    pos: pos
                });
                if (!isInlineBodiedExtension(node)) prevTextBlockType = node.isTextblock ? node.type : undefined;
                prevPos = pos;
                pos += node.nodeSize;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    } catch (_unused) {}
}




var $412c6966035531bf$var$_excluded = [
    "key"
];
function $412c6966035531bf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $412c6966035531bf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $412c6966035531bf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $412c6966035531bf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $412c6966035531bf$var$mergeMarks(marksAndNodes) {
    return marksAndNodes.reduce(function(acc, markOrNode) {
        var prev = acc.length && acc[acc.length - 1] || null;
        if (markOrNode.type instanceof (0, $9Jwkl.MarkType) && prev && prev.type instanceof (0, $9Jwkl.MarkType) && Array.isArray(prev.content) && (0, $5529a08af71d59f5$export$b1304404bdc42b7a)(prev, markOrNode)) prev.content = $412c6966035531bf$var$mergeMarks(prev.content.concat(markOrNode.content));
        else acc.push(markOrNode);
        return acc;
    }, []);
}
var $412c6966035531bf$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ReactSerializer(init) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ReactSerializer);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "headingIds", []);
        /**
     * The reason we have this extra array here is because we need to generate the same unique
     * heading id for 2 different nodes: headers and expands (check the implementation of
     * `getUniqueHeadingId` for more info).
     *
     * We will eventually need to refactor the current approach to generate unique ids
     * for headers under this ticket -> https://product-fabric.atlassian.net/browse/ED-9668
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "expandHeadingIds", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "allowCopyToClipboard", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "allowDownloadCodeBlock", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "allowWrapCodeBlock", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "allowPlaceholderText", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "allowCustomPanels", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "surroundTextNodesWithTextWrapper", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "allowAnnotations", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "standaloneBackgroundColorMarks", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "inlinePositions", new Set());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "serializeFragmentChild", function(node, _ref) {
            var index = _ref.index, parentInfo = _ref.parentInfo;
            var pos = _this.startPos;
            var currentPath = parentInfo && parentInfo.path || [];
            var parentIsIncompleteTask = (node.type.name === 'taskItem' || node.type.name === 'blockTaskItem' && (0, $drUcN.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true)) && node.attrs.state !== 'DONE' || // If blockTaskItem is in the schema, check if the parent of the current node
            // is an incomplete task item, because blockTaskItems can have nested nodes
            node.type.schema.nodes.blockTaskItem && (parentInfo === null || parentInfo === void 0 ? void 0 : parentInfo.parentIsIncompleteTask) === true && (0, $drUcN.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true);
            var nodeKey = "".concat(node.type.name, "__").concat(_this.startPos);
            var serializedContent = _this.serializeFragment(node.content, _this.getNodeProps(node, parentInfo), (0, $9M0Oh.toReact)(node, {
                allowSelectAllTrap: _this.allowSelectAllTrap,
                allowWindowedCodeBlock: _this.allowWindowedCodeBlock
            }, _this.nodeComponents), nodeKey, {
                parentIsIncompleteTask: parentIsIncompleteTask,
                path: [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(currentPath), [
                    node
                ]),
                pos: _this.startPos
            });
            _this.startPos = pos + node.nodeSize;
            var marks = node.marks ? (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(node.marks) : [];
            var isMedia = node.type.name === 'media';
            var shouldSkipBorderMark = function shouldSkipBorderMark(mark) {
                return currentPath.some(function(n) {
                    var _n$type;
                    return ((_n$type = n.type) === null || _n$type === void 0 ? void 0 : _n$type.name) !== 'mediaSingle';
                }) && isMedia && mark.type.name === 'border';
            };
            var shouldSkipLinkMark = function shouldSkipLinkMark(mark) {
                return _this.allowMediaLinking !== true && isMedia && mark.type.name === 'link';
            };
            var serialized = marks.reduceRight(function(content, mark) {
                if (shouldSkipLinkMark(mark) || shouldSkipBorderMark(mark)) return content;
                return _this.renderMark((0, $6ea97fdfef30088f$export$d4334b129116aad7)(mark), _this.withMediaMarkProps(node, mark, _this.getMarkProps(mark, [], node)), "".concat(mark.type.name, "-").concat(index), content);
            }, serializedContent);
            return (0, $hOwF6.withExpandBodyBlock)(node, currentPath, index, serialized);
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "withMediaMarkProps", function(node, mark, defaultProps) {
            if (mark.type.name === 'link' && node.type.name === 'media') return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, defaultProps), {}, {
                isMediaLink: true
            });
            if (node.type.name === 'mediaInline' && mark.type.name === 'annotation') return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, defaultProps), {}, {
                isMediaInline: true
            });
            return defaultProps;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getUnsupportedContentProps", function(node) {
            return {
                node: node,
                dispatchAnalyticsEvent: _this.fireAnalyticsEvent
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getAnnotationMarkProps", function(mark, marksParentPath) {
            var annotationParentIds = (marksParentPath || []).reduce(function(acc, parent) {
                if ((0, $w2fDc.isAnnotationMark)(parent)) return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(acc), [
                    parent.attrs.id
                ]);
                return acc;
            }, []);
            return {
                id: mark.attrs.id,
                annotationType: mark.attrs.annotationType,
                annotationParentIds: annotationParentIds,
                allowAnnotations: _this.allowAnnotations,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getMarkProps", function(mark, marksParentPath, node) {
            if ((0, $w2fDc.isAnnotationMark)(mark)) return _this.getAnnotationMarkProps(mark, marksParentPath);
            var _mark$attrs = mark.attrs, key = _mark$attrs.key, otherAttrs = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_mark$attrs, $412c6966035531bf$var$_excluded);
            var extraProps = {
                isInline: node === null || node === void 0 ? void 0 : node.isInline
            };
            // currently the only mark which has custom props is the code mark
            var markSpecificProps = (0, $7b2d933bcff57ef4$export$86390c02c110ec2f)(mark) ? {
                // The appearance being mobile indicates we are in an renderer being
                // rendered by mobile bridge in a web view.
                // The tooltip is likely to have unexpected behaviour there, with being cut
                // off, so we disable it. This is also to keep the behaviour consistent with
                // the rendering in the mobile Native Renderer.
                codeBidiWarningTooltipEnabled: false
            } : {};
            // Add deepLinkTarget for link marks
            var linkSpecificProps = mark.type.name === 'link' ? {
                onSetLinkTarget: _this.onSetLinkTarget
            } : {};
            var props = $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({
                eventHandlers: _this.eventHandlers,
                fireAnalyticsEvent: _this.fireAnalyticsEvent,
                markKey: key
            }, otherAttrs), extraProps), markSpecificProps), linkSpecificProps), {}, {
                dataAttributes: {
                    'data-renderer-mark': true
                }
            });
            return props;
        });
        this.initStartPos = init.startPos || 1;
        this.startPos = init.startPos || 1;
        this.providers = init.providers;
        this.eventHandlers = init.eventHandlers;
        this.extensionHandlers = init.extensionHandlers;
        this.portal = init.portal;
        this.rendererContext = init.objectContext;
        this.appearance = init.appearance;
        this.contentMode = init.contentMode;
        this.disableHeadingIDs = init.disableHeadingIDs;
        this.headingIdPrefix = init.headingIdPrefix;
        this.disableActions = init.disableActions;
        this.allowHeadingAnchorLinks = init.allowHeadingAnchorLinks;
        this.allowCopyToClipboard = init.allowCopyToClipboard;
        this.allowDownloadCodeBlock = init.allowDownloadCodeBlock;
        this.allowWrapCodeBlock = init.allowWrapCodeBlock;
        this.allowPlaceholderText = init.allowPlaceholderText;
        this.allowCustomPanels = init.allowCustomPanels;
        this.allowColumnSorting = init.allowColumnSorting;
        this.fireAnalyticsEvent = init.fireAnalyticsEvent;
        this.shouldOpenMediaViewer = init.shouldOpenMediaViewer;
        this.allowAltTextOnImages = init.allowAltTextOnImages;
        this.stickyHeaders = init.stickyHeaders;
        this.allowMediaLinking = init.allowMediaLinking;
        this.allowAnnotations = Boolean(init.allowAnnotations);
        this.surroundTextNodesWithTextWrapper = Boolean(init.surroundTextNodesWithTextWrapper);
        this.media = init.media;
        this.mentionNodeDataProvider = init.mentionNodeDataProvider;
        this.emojiProviderLookupOrder = init.emojiProviderLookupOrder;
        this.emojiResourceConfig = init.emojiResourceConfig;
        this.smartLinks = init.smartLinks;
        this.extensionViewportSizes = init.extensionViewportSizes;
        this.hideExtensionKeysWhilePending = init.hideExtensionKeysWhilePending;
        this.getExtensionHeight = init.getExtensionHeight;
        this.allowSelectAllTrap = init.allowSelectAllTrap;
        this.nodeComponents = init.nodeComponents;
        this.allowWindowedCodeBlock = init.allowWindowedCodeBlock;
        this.isInsideOfInlineExtension = init.isInsideOfInlineExtension;
        this.textHighlighter = init.textHighlighter;
        this.allowTableAlignment = init.allowTableAlignment;
        this.allowTableResizing = init.allowTableResizing;
        this.allowFixedColumnWidthOption = init.allowFixedColumnWidthOption;
        this.isPresentational = init.isPresentational;
        this.disableTableOverflowShadow = init.disableTableOverflowShadow;
        this.onSetLinkTarget = init.onSetLinkTarget;
        this.shouldDisplayExtensionAsInline = init.shouldDisplayExtensionAsInline;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ReactSerializer, [
        {
            key: "resetState",
            value: function resetState() {
                this.headingIds = [];
                this.expandHeadingIds = [];
                this.startPos = this.initStartPos;
            }
        },
        {
            key: "getNodeProps",
            value: function getNodeProps(node, parentInfo) {
                var path = parentInfo ? parentInfo.path : undefined;
                switch(node.type.name){
                    case 'date':
                        return this.getDateProps(node, parentInfo, path);
                    case 'hardBreak':
                        return this.getHardBreakProps(node, path);
                    case 'heading':
                        return this.getHeadingProps(node, path);
                    case 'media':
                        return this.getMediaProps(node, path);
                    case 'emoji':
                        return this.getEmojiProps(node, path);
                    case 'mention':
                        return this.getMentionProps(node, path);
                    case 'extension':
                    case 'bodiedExtension':
                        return this.getExtensionProps(node, path);
                    case 'mediaGroup':
                        return this.getMediaGroupProps(node);
                    case 'mediaInline':
                        return this.getMediaInlineProps(node);
                    case 'mediaSingle':
                        return this.getMediaSingleProps(node, path);
                    case 'table':
                        return this.getTableProps(node, path);
                    case 'tableHeader':
                    case 'tableRow':
                        return this.getTableChildrenProps(node);
                    case 'taskItem':
                        return this.getTaskItemProps(node, path);
                    case 'embedCard':
                        return this.getEmbedCardProps(node, path);
                    case 'blockCard':
                        return this.getBlockCardProps(node, path);
                    case 'inlineCard':
                        return this.getInlineCardProps(node, path);
                    case 'expand':
                        return this.getExpandProps(node, path);
                    case 'nestedExpand':
                        if ((0, $jkJfI.isExperimentEnabled)('platform_editor_defer_collapsed_expand_body')) return this.getExpandProps(node, path);
                        return this.getProps(node, path);
                    case 'unsupportedBlock':
                    case 'unsupportedInline':
                        return this.getUnsupportedContentProps(node);
                    case 'codeBlock':
                        return this.getCodeBlockProps(node);
                    case 'panel':
                        return this.getPanelProps(node);
                    case 'panel_c1':
                        if ((0, $drUcN.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) return this.getPanelProps(node);
                        return this.getProps(node, path);
                    default:
                        return this.getProps(node, path);
                }
            }
        },
        {
            key: "serializeFragment",
            value: function serializeFragment(fragment) {
                var _this2 = this;
                var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.allowSelectAllTrap ? (0, $ac0Rs.DocWithSelectAllTrap) : (0, $ac0Rs.default);
                var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'root-0';
                var parentInfo = arguments.length > 4 ? arguments[4] : undefined;
                // This makes sure that we reset internal state on re-render.
                if (key === 'root-0') this.resetState();
                return this.renderNode(target, props, key, (0, $hOwF6.mergeExpandBodyText)(this.getChildNodes(fragment, !(parentInfo !== null && parentInfo !== void 0 && parentInfo.path.length)).map(function(node, index) {
                    if ((0, $9M0Oh.isTextWrapper)(node)) return _this2.serializeTextWrapper(node.content, {
                        index: index,
                        parentInfo: parentInfo
                    });
                    return _this2.serializeFragmentChild(node, {
                        index: index,
                        parentInfo: parentInfo
                    });
                })));
            }
        },
        {
            key: "serializeTextWrapper",
            value: function serializeTextWrapper(content, _ref2) {
                var _this$standaloneBackg, _this3 = this;
                var parentInfo = _ref2.parentInfo;
                var currentPath = parentInfo && parentInfo.path || [];
                var nodePosition = parentInfo && parentInfo.pos || 1;
                (_this$standaloneBackg = this.standaloneBackgroundColorMarks).push.apply(_this$standaloneBackg, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((0, $6af2eee65b21fc1b$export$eeb66772b38d7581)(content)));
                return ReactSerializer.buildMarkStructure(content).map(function(mark, _index) {
                    return _this3.serializeMark({
                        mark: mark,
                        parentNode: {
                            path: currentPath,
                            pos: nodePosition
                        },
                        parentMark: {
                            path: [
                                mark
                            ]
                        }
                    });
                });
            }
        },
        {
            key: "serializeMark",
            value: function serializeMark(_ref3) {
                var _this4 = this;
                var mark = _ref3.mark, parentNode = _ref3.parentNode, parentMark = _ref3.parentMark;
                if (!(0, $9M0Oh.isTextNode)(mark)) {
                    var serializeContent = function serializeContent(childMark, _index) {
                        return _this4.serializeMark({
                            mark: childMark,
                            parentNode: parentNode,
                            parentMark: {
                                path: [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(parentMark.path), [
                                    childMark
                                ])
                            }
                        });
                    };
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    var content = (mark.content || []).map(serializeContent);
                    var markKey = "".concat(mark.type.name, "-component__").concat(this.startPos, "__").concat(parentMark.path.length);
                    var isStandalone = this.standaloneBackgroundColorMarks.some(function(m) {
                        return mark.eq(m);
                    });
                    return this.renderMark((0, $6ea97fdfef30088f$export$d4334b129116aad7)(mark), $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getMarkProps(mark, parentMark.path)), {}, {
                        isStandalone: isStandalone
                    }), markKey, content);
                }
                var startPos = this.startPos;
                var endPos = startPos + mark.nodeSize;
                this.startPos = endPos;
                var textKey = "text-wrapper_".concat(this.startPos);
                if (this.surroundTextNodesWithTextWrapper) {
                    var parentDepth = Math.max(parentNode.path.length - 1, 0);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0add6e4a2440403c$export$2e2bcd8739ae039), {
                        key: textKey,
                        startPos: startPos + parentDepth,
                        endPos: endPos + parentDepth,
                        textHighlighter: this.textHighlighter,
                        marks: mark.marks
                    }, mark.text);
                }
                var segments = (0, $da823e371d629bd7$export$93301b6f1ff0b0c3)(mark.text, this.textHighlighter);
                return (0, $00533252bf4c5c68$export$8a20fd0614851c5f)(segments, this.textHighlighter, mark.marks, startPos);
            }
        },
        {
            key: "renderNode",
            value: function renderNode(// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            NodeComponent, // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            props, key, // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            content) {
                return(/*#__PURE__*/ // Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading
                (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NodeComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                    key: key
                }, props), content));
            }
        },
        {
            key: "renderMark",
            value: function renderMark(// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            MarkComponent, props, key, // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            content) {
                return(/*#__PURE__*/ // Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading
                (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(MarkComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                    key: key
                }, props), content));
            }
        },
        {
            key: "getTableChildrenProps",
            value: function getTableChildrenProps(node) {
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node)), {}, {
                    allowColumnSorting: this.allowColumnSorting
                });
            }
        },
        {
            key: "getTableProps",
            value: function getTableProps(node) {
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var isInsideOfBlockNode = (0, $0b366d21bf0dee21$export$42ddc573eb5a7b43)(path, node.type.schema);
                var isInsideMultiBodiedExtension = (0, $0b366d21bf0dee21$export$9f1e9347b0411934)(path, node.type.schema);
                var isInsideOfTable = (0, $0b366d21bf0dee21$export$244bf4b32387ef62)(path, node.type.schema);
                var stickyHeaders = !isInsideOfTable ? this.stickyHeaders : undefined;
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node)), {}, {
                    allowColumnSorting: this.allowColumnSorting,
                    columnWidths: (0, $d59df72c0fedc43c$export$e54c9225ca52acc)(node),
                    tableNode: node,
                    stickyHeaders: stickyHeaders,
                    isInsideOfBlockNode: isInsideOfBlockNode,
                    isInsideOfTable: isInsideOfTable,
                    isInsideMultiBodiedExtension: isInsideMultiBodiedExtension,
                    allowTableAlignment: this.allowTableAlignment,
                    allowTableResizing: this.allowTableResizing,
                    // eslint-disable-next-line @atlaskit/platform/valid-gate-name
                    isPresentational: (0, $50U6m.fg)('platform_renderer_isPresentational') ? this.isPresentational : false,
                    disableTableOverflowShadow: this.disableTableOverflowShadow,
                    allowFixedColumnWidthOption: this.allowFixedColumnWidthOption
                });
            }
        },
        {
            key: "getDateProps",
            value: function getDateProps(node, parentInfo) {
                var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
                return {
                    timestamp: node.attrs && node.attrs.timestamp,
                    parentIsIncompleteTask: parentInfo && parentInfo.parentIsIncompleteTask,
                    dataAttributes: {
                        // We need to account for depth (path.length gives up depth) here
                        // but depth doesnt increment the pos, only accounted for.
                        'data-renderer-start-pos': this.startPos + path.length
                    }
                };
            }
        },
        {
            key: "getMediaSingleProps",
            value: function getMediaSingleProps(node) {
                var _this5 = this;
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var link = node.type.schema.marks.link;
                var isInsideOfBlockNode = (0, $0b366d21bf0dee21$export$42ddc573eb5a7b43)(path, node.type.schema);
                var isLinkMark = function isLinkMark(mark) {
                    return mark.type === link;
                };
                var childHasLink = node.firstChild && node.firstChild.marks.filter(function(m) {
                    return isLinkMark(m) || _this5.allowMediaLinking === true;
                }).length;
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node, path)), {}, {
                    isInsideOfBlockNode: isInsideOfBlockNode,
                    childHasLink: childHasLink,
                    allowCaptions: this.media && this.media.allowCaptions,
                    featureFlags: this.media && this.media.featureFlags
                });
            }
        },
        {
            key: "getMediaProps",
            value: function getMediaProps(node) {
                var _this6 = this, _this$media, _this$media2, _this$media3, _this$media4, _this$media5;
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var _node$type$schema$mar = node.type.schema.marks, annotation = _node$type$schema$mar.annotation, link = _node$type$schema$mar.link, border = _node$type$schema$mar.border;
                var isChildOfMediaSingle = path.some(function(n) {
                    var _n$type2;
                    return ((_n$type2 = n.type) === null || _n$type2 === void 0 ? void 0 : _n$type2.name) === 'mediaSingle';
                });
                // Only check path for bodiedSyncBlock; syncBlock uses RendererContext
                var nestedUnder = (0, $0b366d21bf0dee21$export$a8df1f99c673fa27)(path, [
                    'bodiedSyncBlock'
                ]);
                var isAnnotationMark = function isAnnotationMark(mark) {
                    return mark.type === annotation;
                };
                var isLinkMark = function isLinkMark(mark) {
                    return mark.type === link;
                };
                var isBorderMark = function isBorderMark(mark) {
                    return isChildOfMediaSingle && mark.type === border;
                };
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node, path)), {}, {
                    marks: node.marks.filter(function(m) {
                        return !isLinkMark(m) || _this6.allowMediaLinking === true;
                    }),
                    isLinkMark: isLinkMark,
                    isBorderMark: isBorderMark,
                    isAnnotationMark: isAnnotationMark,
                    allowAltTextOnImages: this.allowAltTextOnImages,
                    featureFlags: this.media && this.media.featureFlags,
                    shouldOpenMediaViewer: this.shouldOpenMediaViewer,
                    ssr: (_this$media = this.media) === null || _this$media === void 0 ? void 0 : _this$media.ssr,
                    // surroundTextNodesWithTextWrapper checks inlineComment.allowDraftMode
                    allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper,
                    enableSyncMediaCard: (_this$media2 = this.media) === null || _this$media2 === void 0 ? void 0 : _this$media2.enableSyncMediaCard,
                    mediaViewerExtensions: (_this$media3 = this.media) === null || _this$media3 === void 0 ? void 0 : _this$media3.mediaViewerExtensions,
                    fallbackMediaNameFetcher: (_this$media4 = this.media) === null || _this$media4 === void 0 ? void 0 : _this$media4.fallbackMediaNameFetcher,
                    onMediaRenderEvent: (_this$media5 = this.media) === null || _this$media5 === void 0 ? void 0 : _this$media5.onMediaRenderEvent,
                    nestedUnder: nestedUnder
                });
            }
        },
        {
            key: "getExtensionProps",
            value: function getExtensionProps(node) {
                var _this$getExtensionHei;
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node, path)), {}, {
                    extensionViewportSizes: this.extensionViewportSizes,
                    hideExtensionKeysWhilePending: this.hideExtensionKeysWhilePending,
                    nodeHeight: (_this$getExtensionHei = this.getExtensionHeight) === null || _this$getExtensionHei === void 0 ? void 0 : _this$getExtensionHei.call(this, node),
                    shouldDisplayExtensionAsInline: this.shouldDisplayExtensionAsInline
                });
            }
        },
        {
            key: "getEmojiProps",
            value: function getEmojiProps(node) {
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node, path)), {}, {
                    emojiProviderLookupOrder: (0, $50U6m.fg)('platform_bitbucket_fix_shortname_and_ordering') ? this.emojiProviderLookupOrder : undefined,
                    resourceConfig: this.emojiResourceConfig
                });
            }
        },
        {
            key: "getMentionProps",
            value: function getMentionProps(node) {
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node, path)), {}, {
                    mentionNodeDataProvider: this.mentionNodeDataProvider
                });
            }
        },
        {
            key: "getEmbedCardProps",
            value: function getEmbedCardProps(node) {
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var isInsideOfBlockNode = (0, $0b366d21bf0dee21$export$42ddc573eb5a7b43)(path, node.type.schema);
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node)), {}, {
                    isInsideOfBlockNode: isInsideOfBlockNode,
                    onSetLinkTarget: this.onSetLinkTarget
                });
            }
        },
        {
            key: "getBlockCardProps",
            value: function getBlockCardProps(node) {
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node)), {}, {
                    isNodeNested: path.length > 0,
                    onSetLinkTarget: this.onSetLinkTarget
                });
            }
        },
        {
            key: "getInlineCardProps",
            value: function getInlineCardProps(node) {
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node, path)), {}, {
                    onSetLinkTarget: this.onSetLinkTarget
                });
            }
        },
        {
            key: "getMediaGroupProps",
            value: function getMediaGroupProps(node) {
                var _this$media6, _this$media7;
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node)), {}, {
                    shouldOpenMediaViewer: this.shouldOpenMediaViewer,
                    allowAltTextOnImages: this.allowAltTextOnImages,
                    featureFlags: this.media && this.media.featureFlags,
                    enableDownloadButton: (_this$media6 = this.media) === null || _this$media6 === void 0 ? void 0 : _this$media6.enableDownloadButton,
                    ssr: (_this$media7 = this.media) === null || _this$media7 === void 0 ? void 0 : _this$media7.ssr
                });
            }
        },
        {
            key: "getMediaInlineProps",
            value: function getMediaInlineProps(node) {
                var _this$media8, _this$media9;
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node)), {}, {
                    ssr: (_this$media8 = this.media) === null || _this$media8 === void 0 ? void 0 : _this$media8.ssr,
                    fallbackMediaNameFetcher: (_this$media9 = this.media) === null || _this$media9 === void 0 ? void 0 : _this$media9.fallbackMediaNameFetcher
                });
            }
        },
        {
            key: "getTaskItemProps",
            value: function getTaskItemProps(node) {
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node, path)), {}, {
                    disabled: this.disableActions
                });
            }
        },
        {
            key: "getHardBreakProps",
            value: function getHardBreakProps(node) {
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var forceNewLine = false;
                var parentNode = path.length > 0 ? path[path.length - 1] : null;
                if (parentNode && parentNode.lastChild === node) forceNewLine = true;
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node)), {}, {
                    forceNewLine: forceNewLine
                });
            }
        },
        {
            key: "getCodeBlockProps",
            value: function getCodeBlockProps(node) {
                // The appearance being mobile indicates we are in an renderer being
                // rendered by mobile bridge in a web view.
                // The tooltip is likely to have unexpected behaviour there, with being cut
                // off, so we disable it. This is also to keep the behaviour consistent with
                // the rendering in the mobile Native Renderer.
                var codeBidiWarningTooltipEnabled = false;
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node)), {}, {
                    text: node.textContent,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
                });
            }
        },
        {
            key: "getPanelProps",
            value: function getPanelProps(node) {
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node)), {}, {
                    allowCustomPanels: this.allowCustomPanels
                });
            }
        },
        {
            key: "getProps",
            value: function getProps(node) {
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var startPos = this.startPos + path.length;
                return $412c6966035531bf$var$_objectSpread({
                    asInline: this.inlinePositions.has(startPos) ? 'on' : undefined,
                    text: node.text,
                    providers: this.providers,
                    eventHandlers: this.eventHandlers,
                    extensionHandlers: this.extensionHandlers,
                    portal: this.portal,
                    rendererContext: this.rendererContext,
                    serializer: this,
                    getContent: (0, $0c13a258c85ceb73$export$18a05b40f8bf404f)(node.content),
                    allowHeadingAnchorLinks: this.allowHeadingAnchorLinks,
                    allowCopyToClipboard: this.allowCopyToClipboard,
                    allowDownloadCodeBlock: this.allowDownloadCodeBlock,
                    allowWrapCodeBlock: this.allowWrapCodeBlock,
                    allowPlaceholderText: this.allowPlaceholderText,
                    rendererAppearance: this.appearance,
                    rendererContentMode: this.contentMode,
                    fireAnalyticsEvent: this.fireAnalyticsEvent,
                    nodeType: node.type.name,
                    marks: node.marks,
                    smartLinks: this.smartLinks,
                    isInsideOfInlineExtension: this.isInsideOfInlineExtension,
                    dataAttributes: {
                        // We need to account for depth (path.length gives up depth) here
                        // but depth doesnt increment the pos, only accounted for.
                        'data-renderer-start-pos': startPos
                    },
                    startPos: startPos,
                    path: path
                }, node.attrs);
            }
        },
        {
            key: "headingAnchorSupported",
            value: function headingAnchorSupported() {
                var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var isImmediateParent = function isImmediateParent(path, nodeName) {
                    return path.length > 0 && path[path.length - 1].type.name === nodeName;
                };
                return (0, $e382f311073cdba5$export$7aa7587d1ce9583c)(this.allowHeadingAnchorLinks) || path.length === 0 || isImmediateParent(path, 'layoutColumn');
            }
        },
        {
            key: "getHeadingProps",
            value: function getHeadingProps(node) {
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node, path)), {}, {
                    headingId: this.getHeadingId(node, this.headingIds),
                    showAnchorLink: this.appearance !== 'comment' && this.allowHeadingAnchorLinks && !this.disableHeadingIDs && this.headingAnchorSupported(path)
                });
            }
        },
        {
            key: "getExpandProps",
            value: function getExpandProps(node) {
                var _this7 = this;
                var _path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                // Expand is given the node so it can tell whether it opted into lazy body loading at all. The
                // text each block shows is attached to the block itself, by `withExpandBodyBlock`.
                if (!(0, $e382f311073cdba5$export$7aa7587d1ce9583c)(this.allowHeadingAnchorLinks)) return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node)), {}, {
                    node: node
                });
                var nestedHeaderIds = (0, $4inI8.findChildrenByType)(node, node.type.schema.nodes.heading).map(function(_ref4) {
                    var node = _ref4.node;
                    return _this7.getHeadingId(node, _this7.expandHeadingIds);
                });
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node)), {}, {
                    nestedHeaderIds: nestedHeaderIds,
                    node: node
                });
            }
        },
        {
            key: "getHeadingId",
            value: function getHeadingId(node, headingIds) {
                if (this.disableHeadingIDs || !node.content.size) return;
                // We are not use node.textContent here, because we would like to handle cases where
                // headings only contain inline blocks like emoji, status and date.
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var nodeContent = node.content.toJSON()// Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .reduce(function(acc, node) {
                    return acc.concat((0, $9F9pG.getText)(node) || '');
                }, '').trim()// Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                .replace(/\s/g, '-');
                if (!nodeContent) return;
                var uniqueId = this.getUniqueHeadingId(nodeContent, headingIds);
                return this.headingIdPrefix ? "".concat(this.headingIdPrefix, "-").concat(uniqueId) : uniqueId;
            }
        },
        {
            key: "getUniqueHeadingId",
            value: function getUniqueHeadingId(baseId, headingIds) {
                var counter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                if (counter === 0 && headingIds.indexOf(baseId) === -1) {
                    headingIds.push(baseId);
                    return baseId;
                } else if (counter !== 0) {
                    var headingId = "".concat(baseId, ".").concat(counter);
                    if (headingIds.indexOf(headingId) === -1) {
                        headingIds.push(headingId);
                        return headingId;
                    }
                }
                return this.getUniqueHeadingId(baseId, headingIds, ++counter);
            }
        },
        {
            key: "getChildNodes",
            value: function getChildNodes(fragment) {
                var _this8 = this;
                var isTopLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                var children = [];
                fragment.forEach(function(node) {
                    children.push(node);
                });
                children = (0, $9M0Oh.mergeTextNodes)(children);
                if (!!this.shouldDisplayExtensionAsInline && (0, $drUcN.expValEquals)('platform_editor_render_bodied_extension_as_inline', 'isEnabled', true)) (0, $df882574d3dae886$export$3a88c97d9b0d8d1c)({
                    nodes: children,
                    onMark: function onMark(_ref5) {
                        var pos = _ref5.pos;
                        _this8.inlinePositions.add(pos);
                    },
                    parentPos: this.startPos,
                    isTopLevel: isTopLevel,
                    shouldDisplayExtensionAsInline: this.shouldDisplayExtensionAsInline
                });
                return children;
            }
        }
    ], [
        {
            key: "getMarks",
            value: function getMarks(node) {
                if (!node.marks || node.marks.length === 0) return [];
                return (0, $5558251c256ad6af$export$99a33ed044c278ae)(node.marks);
            }
        },
        {
            key: "buildMarkStructure",
            value: function buildMarkStructure(content) {
                var _this9 = this;
                return $412c6966035531bf$var$mergeMarks(content.map(function(node) {
                    var nodeMarks = _this9.getMarks(node);
                    if (nodeMarks.length === 0) return node;
                    return nodeMarks.reverse().reduce(function(acc, mark) {
                        var eq = mark.eq;
                        return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, mark), {}, {
                            eq: eq,
                            content: [
                                acc
                            ]
                        });
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    }, node);
                }));
            }
        }
    ]);
}();


var $iYJcE = parcelRequire("iYJcE");

var $cvlyC = parcelRequire("cvlyC");

var $kYLlQ = parcelRequire("kYLlQ");

var $kbnxS = parcelRequire("kbnxS");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $50U6m = parcelRequire("50U6m");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $8abd2a78619ba16a$export$784d13d8ee351f07 = function copy(source, dest, key) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dest[key] = source[key];
    return dest;
};



var $ekGgq = parcelRequire("ekGgq");

var $iYJcE = parcelRequire("iYJcE");
function $a265986427be6a21$export$7d2123bc001cdbf8(validatorSpecs, entity) {
    // Filter out content type + irrelevant nodes
    var potentialAllowedContent = Object.entries(validatorSpecs).filter(function(item) {
        var _item = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(item, 2), node = _item[0], value = _item[1];
        if ($a265986427be6a21$var$isValidatorSpec(value)) return node === entity.type;
        var _ref = [
            value[0],
            value[1]
        ], nodeName = _ref[0], spec = _ref[1];
        if (typeof spec === 'string' || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(spec) !== 'object') return false;
        return nodeName === entity.type;
    });
    // Keep types such as `mediaSingle_full` which contain additional spec information
    var contentArray = potentialAllowedContent.map(function(allowedContent) {
        if ($a265986427be6a21$var$isValidatorSpec(allowedContent)) return undefined;
        var value = allowedContent[1];
        return !$a265986427be6a21$var$isValidatorSpec(value) ? [
            [
                value[0],
                value[1]
            ]
        ] : undefined;
    });
    return contentArray.filter(function(x) {
        return !!x;
    });
}
function $a265986427be6a21$var$isValidatorSpec(spec) {
    return spec.props !== undefined || spec.required !== undefined || spec.maxItems !== undefined || spec.minItems !== undefined;
}


var $87916065a395f778$export$f9ce7b637dfbe238 = function isBoolean(x) {
    return x === true || x === false || toString.call(x) === '[object Boolean]';
};


var $b6547681adadee84$export$4e62c701997796c1 = function isDefined(x) {
    return x != null;
};


var $ebc728fb4f4fa794$export$a287f47fed4544b8 = function isInteger(x) {
    return typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
};


var $7c1b5fa3f5d6e3a8$export$7e4aa119212bc614 = function isNumber(x) {
    return typeof x === 'number' && !isNaN(x) && isFinite(x);
};



var $ekGgq = parcelRequire("ekGgq");
var $f607840467d96991$export$53b83ca8eaab0383 = function isPlainObject(x) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(x) === 'object' && x !== null && !Array.isArray(x);
};


// This is a kludge, might replace with something like _.isString in future
var $e907d3774bffa6b3$export$844ec244b1367d54 = function isString(s) {
    return typeof s === 'string' || s instanceof String;
};


// Helpers
var $cff1eaad54dae4e3$export$7b85fd78dd236198 = function makeArray(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
};



var $7JWGN = parcelRequire("7JWGN");
var $f0f3f0f3bbc98098$export$d1b377ca77ac267d = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    safeUrl: (0, $7JWGN.isSafeUrl)
};


// This is a lookup map consumed by `createSpec`, not an entry point re-exporting the schema
/* eslint-disable @atlaskit/editor/no-re-export */ var $91f47b6c1193565f$export$8e53000a4ec837 = {
    props: {
        attrs: {
            props: {
                align: {
                    type: 'enum',
                    values: [
                        'center',
                        'end'
                    ]
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'alignment'
            ]
        }
    }
};
var $91f47b6c1193565f$export$8512c9afa7b24c3b = {
    props: {
        attrs: {
            props: {
                annotationType: {
                    type: 'enum',
                    values: [
                        'inlineComment'
                    ]
                },
                id: {
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'annotation'
            ]
        }
    }
};
var $91f47b6c1193565f$export$8c5a050822fd698c = {
    props: {
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'backgroundColor'
            ]
        }
    }
};
var $91f47b6c1193565f$export$a31afb40076fa18b = [
    'blockCard',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'mediaGroup',
    'decisionList',
    'rule',
    'rule_with_attrs',
    'bodiedRule',
    'panel',
    'blockquote',
    'extension_with_marks',
    'extension_with_annotation',
    'embedCard',
    'table',
    'expand',
    'bodiedExtension_with_marks'
];
var $91f47b6c1193565f$export$c4c2f833baaebdb8 = {
    props: {
        attrs: [
            {
                props: {
                    datasource: {
                        props: {
                            id: {
                                type: 'string'
                            },
                            parameters: {
                                type: 'object'
                            },
                            views: {
                                items: [
                                    {
                                        props: {
                                            properties: {
                                                optional: true,
                                                type: 'object'
                                            },
                                            type: {
                                                type: 'string'
                                            }
                                        }
                                    }
                                ],
                                minItems: 1,
                                type: 'array'
                            }
                        }
                    },
                    layout: {
                        optional: true,
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    url: {
                        optional: true,
                        type: 'string',
                        validatorFn: 'safeUrl'
                    },
                    width: {
                        optional: true,
                        type: 'number'
                    }
                }
            },
            {
                props: {
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    }
                }
            }
        ],
        type: {
            type: 'enum',
            values: [
                'blockCard'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
var $91f47b6c1193565f$export$67dc04e652a298ca = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'orderedList',
                    'bulletList',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'extension_with_marks',
                    'extension_with_annotation'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'blockquote'
            ]
        }
    }
};
var $91f47b6c1193565f$export$ebb5393736e9ba23 = [
    'multiBodiedExtension'
];
var $91f47b6c1193565f$export$16018c61064a18df = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'extension_with_marks',
                    'extension_with_annotation'
                ],
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'extension_with_marks',
                    'extension_with_annotation'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'blockTaskItem'
            ]
        }
    }
};
var $91f47b6c1193565f$export$27903d543b563e39 = {
    props: {
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                layout: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ]
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                parameters: {
                    optional: true,
                    type: 'object'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'bodiedExtension'
            ]
        }
    }
};
var $91f47b6c1193565f$export$b7a532f6e202d8ea = [
    'bodiedExtension',
    {
        meta: {
            stage0: true
        },
        props: {
            marks: {
                items: [
                    [
                        'breakout',
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$ee052cc5b2356e83 = [
    'bodiedExtension',
    {
        props: {
            marks: {
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$2069efcbff2f0292 = {
    meta: {
        stage0: true
    },
    props: {
        attrs: {
            props: {
                alignment: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'start',
                        'center',
                        'end'
                    ]
                },
                color: {
                    optional: true,
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                },
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                style: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'solid',
                        'dashed',
                        'dotted',
                        'sketch',
                        'fade'
                    ]
                },
                weight: {
                    maximum: 3,
                    minimum: 1,
                    optional: true,
                    type: 'number'
                }
            }
        },
        content: {
            items: [
                [
                    'paragraph_with_no_marks',
                    'heading_with_no_marks'
                ]
            ],
            maxItems: 1,
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'bodiedRule'
            ]
        }
    }
};
var $91f47b6c1193565f$export$ab41d73148acae83 = [
    'bodiedRule',
    {
        meta: {
            stage0: true
        },
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$e92c7e4302dd4371 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                resourceId: {
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'paragraph_with_no_marks',
                    'blockCard',
                    'blockquote',
                    'bulletList',
                    'codeBlock',
                    'decisionList',
                    'embedCard',
                    'expand',
                    'heading',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'heading_with_no_marks',
                    'layoutSection',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'mediaGroup',
                    'mediaSingle',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaSingle_width_type',
                    'orderedList',
                    'panel_c1',
                    'panel',
                    'rule',
                    'rule_with_attrs',
                    'bodiedRule',
                    'table',
                    'taskList'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [
                'breakout'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'bodiedSyncBlock'
            ]
        }
    }
};
var $91f47b6c1193565f$export$1edee58a52776cd9 = {
    props: {
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                    type: 'string'
                },
                size: {
                    maximum: 3,
                    minimum: 1,
                    type: 'number'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'border'
            ]
        }
    }
};
var $91f47b6c1193565f$export$89015c65f1c75e3f = {
    props: {
        attrs: {
            props: {
                mode: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width'
                    ]
                },
                width: {
                    optional: true,
                    type: 'number'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'breakout'
            ]
        }
    }
};
var $91f47b6c1193565f$export$a140c94e5ea26bee = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            items: [
                'listItem'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'bulletList'
            ]
        }
    }
};
var $91f47b6c1193565f$export$8e3c2dfdc4f0453d = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                [
                    'hardBreak',
                    'mention',
                    'emoji',
                    'date',
                    'placeholder',
                    'inlineCard',
                    'status',
                    'text_formatted',
                    'text_code_inline'
                ]
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'caption'
            ]
        }
    }
};
var $91f47b6c1193565f$export$6565f9f03506010b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'code'
            ]
        }
    }
};
var $91f47b6c1193565f$export$7bb0d5c671655cc4 = {
    props: {
        attrs: {
            optional: true,
            props: {
                hideLineNumbers: {
                    optional: true,
                    type: 'boolean'
                },
                language: {
                    optional: true,
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                uniqueId: {
                    optional: true,
                    type: 'string'
                },
                wrap: {
                    optional: true,
                    type: 'boolean'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'text_with_no_marks'
            ],
            optional: true,
            type: 'array'
        },
        marks: {
            items: [],
            maxItems: 0,
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'codeBlock'
            ]
        }
    }
};
var $91f47b6c1193565f$export$38d90d1aac6883a3 = [
    'codeBlock',
    {
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$f3b72f8fc4684ecd = {
    props: {
        attrs: {
            props: {
                reference: {
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'confluenceInlineComment'
            ]
        }
    }
};
var $91f47b6c1193565f$export$3024f02c495408d6 = {
    props: {
        attrs: {
            props: {
                sources: {
                    items: [
                        {
                            type: 'string'
                        }
                    ],
                    minItems: 1,
                    type: 'array'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'dataConsumer'
            ]
        }
    }
};
var $91f47b6c1193565f$export$324d90190a8b822a = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                timestamp: {
                    minLength: 1,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'date'
            ]
        }
    }
};
var $91f47b6c1193565f$export$6959e16eeff859b4 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'inline_content'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'decisionItem'
            ]
        }
    }
};
var $91f47b6c1193565f$export$62d45a65fb43d95e = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                'decisionItem'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'decisionList'
            ]
        }
    }
};
var $91f47b6c1193565f$export$2a111da947c407d2 = {
    props: {
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'panel_c1',
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'rule_with_attrs',
                    'bodiedRule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'extension_with_annotation',
                    'embedCard',
                    'table',
                    'expand',
                    'bodiedExtension_with_marks',
                    'codeBlock_root_only',
                    'panel_root_only',
                    'panel_c1_root_only',
                    'rule_root_only',
                    'rule_with_attrs_root_only',
                    'bodiedRule_root_only',
                    'extension_root_only',
                    'extension_root_only_with_annotation',
                    'bodiedExtension_root_only',
                    'multiBodiedExtension_root_only',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'multiBodiedExtension',
                    'expand_root_only',
                    'syncBlock',
                    'bodiedSyncBlock'
                ]
            ],
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'doc'
            ]
        },
        version: {
            type: 'enum',
            values: [
                1
            ]
        }
    }
};
var $91f47b6c1193565f$export$c63c6f932822f543 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'em'
            ]
        }
    }
};
var $91f47b6c1193565f$export$be4283d9a1cb1ff6 = {
    props: {
        attrs: {
            props: {
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'wrap-right',
                        'wrap-left',
                        'align-end',
                        'align-start'
                    ]
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                originalHeight: {
                    optional: true,
                    type: 'number'
                },
                originalWidth: {
                    optional: true,
                    type: 'number'
                },
                url: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                width: {
                    maximum: 100,
                    minimum: 0,
                    optional: true,
                    type: 'number'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'embedCard'
            ]
        }
    }
};
var $91f47b6c1193565f$export$a19185d1233fc4b2 = {
    props: {
        attrs: {
            props: {
                id: {
                    optional: true,
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                shortName: {
                    type: 'string'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'emoji'
            ]
        }
    }
};
var $91f47b6c1193565f$export$9f77e0932fb78f72 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                title: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'rule_with_attrs',
                    'bodiedRule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'decisionList',
                    'taskList',
                    'table',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'extension_with_annotation',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [],
            maxItems: 0,
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'expand'
            ]
        }
    }
};
var $91f47b6c1193565f$export$b2817c6954dd6d2c = [
    'expand',
    {
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$1b45514b112dd749 = {
    props: {
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                layout: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ]
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                parameters: {
                    optional: true,
                    type: 'object'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'extension'
            ]
        }
    }
};
var $91f47b6c1193565f$export$8eba3df128e25335 = [
    'extension',
    {
        meta: {
            stage0: true
        },
        props: {
            marks: {
                items: [
                    [
                        'breakout',
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$9dccb771264f1ee3 = [
    'extension',
    {
        meta: {
            stage0: true
        },
        props: {
            marks: {
                items: [
                    [
                        'annotation',
                        'breakout',
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$a3b88288627564ec = [
    'extension',
    {
        meta: {
            stage0: true
        },
        props: {
            marks: {
                items: [
                    [
                        'annotation',
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$15be7c145cec614a = [
    'extension',
    {
        props: {
            marks: {
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$4fdcae991fd743e7 = {
    meta: {
        stage0: true
    },
    props: {
        content: {
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'rule_with_attrs',
                    'bodiedRule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_full',
                    'mediaSingle_caption',
                    'decisionList',
                    'taskList',
                    'table',
                    'extension_with_marks',
                    'bodiedExtension_with_marks',
                    'blockCard',
                    'embedCard'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [
                [
                    'dataConsumer',
                    'fragment'
                ]
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'extensionFrame'
            ]
        }
    }
};
var $91f47b6c1193565f$export$85e3c3ca0c6fb93 = {
    props: {
        attrs: {
            props: {
                fontSize: {
                    type: 'enum',
                    values: [
                        'small'
                    ]
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'fontSize'
            ]
        }
    }
};
var $91f47b6c1193565f$export$f00aeb236b6f05af = {
    props: {
        attrs: {
            props: {
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                name: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'fragment'
            ]
        }
    }
};
var $91f47b6c1193565f$export$371da9dd35aba193 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                text: {
                    optional: true,
                    type: 'enum',
                    values: [
                        '\n'
                    ]
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'hardBreak'
            ]
        }
    }
};
var $91f47b6c1193565f$export$46e4a324ac90507f = {
    props: {
        attrs: {
            props: {
                level: {
                    maximum: 6,
                    minimum: 1,
                    type: 'number'
                },
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'inline_content'
            ],
            optional: true,
            type: 'array'
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'heading'
            ]
        }
    }
};
var $91f47b6c1193565f$export$c17edf9af655deaf = [
    'heading',
    {
        props: {
            marks: {
                items: [
                    'alignment'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$1902f9737466a0dc = [
    'heading',
    {
        props: {
            marks: {
                items: [
                    'indentation'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$7b491e75f1be9278 = [
    'heading',
    {
        props: {
            marks: {
                items: [],
                maxItems: 0,
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$480c699bd4ec0d86 = {
    props: {
        attrs: {
            props: {
                level: {
                    maximum: 6,
                    minimum: 1,
                    type: 'number'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'indentation'
            ]
        }
    }
};
var $91f47b6c1193565f$export$e23e6162adaa368d = [
    'text_formatted',
    'text_code_inline',
    'date',
    'emoji',
    'hardBreak',
    'inlineCard',
    'mention',
    'placeholder',
    'status',
    'inlineExtension_with_marks',
    'mediaInline'
];
var $91f47b6c1193565f$export$cbf8224b64e0d942 = {
    props: {
        attrs: [
            {
                props: {
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    }
                }
            }
        ],
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
var $91f47b6c1193565f$export$16b353b2649bd8d9 = {
    props: {
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                parameters: {
                    optional: true,
                    type: 'object'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'inlineExtension'
            ]
        }
    }
};
var $91f47b6c1193565f$export$e37f10815f36843d = [
    'inlineExtension',
    {
        props: {
            marks: {
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$ab76e7c03cd6f650 = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                valign: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'top',
                        'middle',
                        'bottom'
                    ]
                },
                width: {
                    maximum: 100,
                    minimum: 0,
                    type: 'number'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'panel_c1',
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'rule_with_attrs',
                    'bodiedRule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'extension_with_annotation',
                    'embedCard',
                    'table',
                    'expand',
                    'bodiedExtension_with_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'layoutColumn'
            ]
        }
    }
};
var $91f47b6c1193565f$export$b3b6a70a7fa4a5be = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                'layoutColumn'
            ],
            maxItems: 3,
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [
                'breakout'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'layoutSection'
            ]
        }
    }
};
var $91f47b6c1193565f$export$941b63fbd931e449 = [
    'layoutSection',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    'layoutColumn'
                ],
                maxItems: 3,
                minItems: 2,
                type: 'array'
            },
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$e0e9834198e8601d = [
    'layoutSection',
    {
        meta: {
            stage0: true
        },
        props: {
            attrs: {
                optional: true,
                props: {
                    columnRuleStyle: {
                        optional: true,
                        type: 'enum',
                        values: [
                            'solid'
                        ]
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    }
                }
            },
            content: {
                allowUnsupportedBlock: true,
                items: [
                    'layoutColumn'
                ],
                maxItems: 5,
                minItems: 1,
                type: 'array'
            },
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$9c30223ca0a664fb = {
    props: {
        attrs: {
            props: {
                collection: {
                    optional: true,
                    type: 'string'
                },
                href: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                id: {
                    optional: true,
                    type: 'string'
                },
                occurrenceKey: {
                    optional: true,
                    type: 'string'
                },
                title: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'link'
            ]
        }
    }
};
var $91f47b6c1193565f$export$76c7e83ecc9cdf05 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_font_size',
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'taskList',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks',
                    'extension_with_annotation'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'listItem'
            ]
        }
    }
};
var $91f47b6c1193565f$export$987d49ffe1b0900f = {
    props: {
        attrs: [
            {
                props: {
                    alt: {
                        optional: true,
                        type: 'string'
                    },
                    collection: {
                        type: 'string'
                    },
                    height: {
                        optional: true,
                        type: 'number'
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    occurrenceKey: {
                        minLength: 1,
                        optional: true,
                        type: 'string'
                    },
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file'
                        ]
                    },
                    width: {
                        optional: true,
                        type: 'number'
                    }
                }
            },
            {
                props: {
                    alt: {
                        optional: true,
                        type: 'string'
                    },
                    height: {
                        optional: true,
                        type: 'number'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    type: {
                        type: 'enum',
                        values: [
                            'external'
                        ]
                    },
                    url: {
                        type: 'string'
                    },
                    width: {
                        optional: true,
                        type: 'number'
                    }
                }
            }
        ],
        marks: {
            items: [
                [
                    'dataConsumer',
                    'link',
                    'annotation',
                    'border'
                ]
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'media'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
var $91f47b6c1193565f$export$2855e964765eac9 = {
    props: {
        content: {
            allowUnsupportedBlock: true,
            items: [
                'media'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'mediaGroup'
            ]
        }
    }
};
var $91f47b6c1193565f$export$38bab695e3f720f1 = {
    props: {
        attrs: {
            props: {
                alt: {
                    optional: true,
                    type: 'string'
                },
                collection: {
                    type: 'string'
                },
                data: {
                    optional: true,
                    type: 'object'
                },
                height: {
                    optional: true,
                    type: 'number'
                },
                id: {
                    minLength: 1,
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                occurrenceKey: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                type: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'link',
                        'file',
                        'image'
                    ]
                },
                url: {
                    optional: true,
                    type: 'string'
                },
                width: {
                    optional: true,
                    type: 'number'
                }
            }
        },
        marks: {
            items: [
                [
                    'dataConsumer',
                    'link',
                    'annotation',
                    'border'
                ]
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'mediaInline'
            ]
        }
    }
};
var $91f47b6c1193565f$export$969fe3781ca15058 = {
    props: {
        attrs: [
            {
                props: {
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    width: {
                        maximum: 100,
                        minimum: 0,
                        optional: true,
                        type: 'number'
                    },
                    widthType: {
                        optional: true,
                        type: 'enum',
                        values: [
                            'percentage'
                        ]
                    }
                }
            },
            {
                props: {
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    width: {
                        minimum: 0,
                        type: 'number'
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'pixel'
                        ]
                    }
                }
            }
        ],
        marks: {
            items: [
                'link'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'mediaSingle'
            ]
        }
    }
};
var $91f47b6c1193565f$export$68b0ead306f9670f = [
    'mediaSingle',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                isTupleLike: true,
                items: [
                    'media',
                    'caption'
                ],
                maxItems: 2,
                minItems: 1,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$f7fd577406abd5f8 = [
    'mediaSingle',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    'media'
                ],
                maxItems: 1,
                minItems: 1,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$af10954ff7b86f88 = [
    'mediaSingle',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    'media'
                ],
                maxItems: 1,
                minItems: 1,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$db83999c14438df4 = {
    props: {
        attrs: {
            props: {
                accessLevel: {
                    optional: true,
                    type: 'string'
                },
                id: {
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                text: {
                    optional: true,
                    type: 'string'
                },
                userType: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'DEFAULT',
                        'SPECIAL',
                        'APP'
                    ]
                }
            }
        },
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'mention'
            ]
        }
    }
};
var $91f47b6c1193565f$export$c3c04d555a8b9013 = {
    meta: {
        stage0: true
    },
    props: {
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                layout: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'default',
                        'wide',
                        'full-width'
                    ]
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                parameters: {
                    optional: true,
                    type: 'object'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            items: [
                'extensionFrame'
            ],
            type: 'array'
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'multiBodiedExtension'
            ]
        }
    }
};
var $91f47b6c1193565f$export$78421d8497ebdea6 = [
    'multiBodiedExtension',
    {
        meta: {
            stage0: true
        },
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$63cadbf5f4296627 = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                title: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: 'nestedExpand_content',
        type: {
            type: 'enum',
            values: [
                'nestedExpand'
            ]
        }
    },
    required: [
        'content'
    ]
};
var $91f47b6c1193565f$export$9584f52f3ebd5d7e = {
    allowUnsupportedBlock: true,
    items: [
        [
            'paragraph_with_no_marks',
            'paragraph_with_font_size',
            'heading_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'codeBlock',
            'bulletList',
            'orderedList',
            'taskList',
            'decisionList',
            'rule',
            'rule_with_attrs',
            'bodiedRule',
            'panel',
            'blockquote',
            'extension_with_marks',
            'extension_with_annotation'
        ]
    ],
    minItems: 1,
    type: 'array'
};
var $91f47b6c1193565f$export$b756fc994eb0bc4f = [
    'nestedExpand',
    {
        props: {
            marks: {
                items: [],
                maxItems: 0,
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$ed866000601e7fa5 = [
    'paragraph_with_no_marks',
    'paragraph_with_font_size',
    'panel',
    'blockquote',
    'orderedList',
    'bulletList',
    'rule',
    'rule_with_attrs',
    'bodiedRule',
    'heading_with_no_marks',
    'codeBlock',
    'mediaGroup',
    'mediaSingle_caption',
    'mediaSingle_full',
    'decisionList',
    'taskList',
    'table',
    'blockCard',
    'embedCard',
    'extension_with_marks'
];
var $91f47b6c1193565f$export$a5dc81035676e7a = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                order: {
                    minimum: 0,
                    optional: true,
                    type: 'number'
                }
            }
        },
        content: {
            items: [
                'listItem'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'orderedList'
            ]
        }
    }
};
var $91f47b6c1193565f$export$21f42ab9b6679f44 = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                panelColor: {
                    optional: true,
                    type: 'string'
                },
                panelIcon: {
                    optional: true,
                    type: 'string'
                },
                panelIconId: {
                    optional: true,
                    type: 'string'
                },
                panelIconText: {
                    optional: true,
                    type: 'string'
                },
                panelType: {
                    type: 'enum',
                    values: [
                        'info',
                        'note',
                        'tip',
                        'warning',
                        'error',
                        'success',
                        'custom'
                    ]
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'heading_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'blockCard',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'rule',
                    'rule_with_attrs',
                    'bodiedRule',
                    'decisionList',
                    'extension_with_marks',
                    'extension_with_annotation'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'panel'
            ]
        }
    }
};
var $91f47b6c1193565f$export$a08c7bcc7e61d424 = [
    'panel',
    {
        meta: {
            stage0: true
        },
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'paragraph_with_font_size',
                        'heading_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'blockCard',
                        'mediaGroup',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'taskList',
                        'rule',
                        'rule_with_attrs',
                        'bodiedRule',
                        'decisionList',
                        'extension_with_marks',
                        'extension_with_annotation',
                        'table'
                    ]
                ],
                minItems: 1,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$76e58fb94da2bf88 = [
    'panel',
    {
        meta: {
            stage0: true
        },
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'paragraph_with_font_size',
                        'heading_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'blockCard',
                        'mediaGroup',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'taskList',
                        'rule',
                        'rule_with_attrs',
                        'bodiedRule',
                        'decisionList',
                        'extension_with_marks',
                        'extension_with_annotation',
                        'table'
                    ]
                ],
                minItems: 1,
                type: 'array'
            },
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$9388c8efa26ea154 = [
    'panel',
    {
        meta: {
            stage0: true
        },
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$9c206ddddb32a9b = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'inline_content'
            ],
            optional: true,
            type: 'array'
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'paragraph'
            ]
        }
    }
};
var $91f47b6c1193565f$export$9ca11c06877e5c64 = [
    'paragraph',
    {
        props: {
            marks: {
                items: [
                    [
                        'fontSize',
                        'alignment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$f745a1f9fa5e1ca8 = [
    'paragraph',
    {
        props: {
            marks: {
                items: [
                    'fontSize'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$a3bd66932996fb7d = [
    'paragraph',
    {
        props: {
            marks: {
                items: [
                    [
                        'fontSize',
                        'indentation'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$f06f75eb1e56b0c5 = [
    'paragraph',
    {
        props: {
            marks: {
                items: [],
                maxItems: 0,
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$c7187bbd1a7a9244 = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                text: {
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'placeholder'
            ]
        }
    }
};
var $91f47b6c1193565f$export$fbeb3a3956e8a3c7 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'rule'
            ]
        }
    }
};
var $91f47b6c1193565f$export$5bc14ade5ae67510 = [
    'rule',
    {
        meta: {
            stage0: true
        },
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$74942eaebdd7ffe = [
    'rule',
    {
        meta: {
            stage0: true
        },
        props: {
            attrs: {
                optional: true,
                props: {
                    color: {
                        optional: true,
                        pattern: '^#[0-9a-fA-F]{6}$',
                        type: 'string'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    style: {
                        optional: true,
                        type: 'enum',
                        values: [
                            'solid',
                            'dashed',
                            'dotted',
                            'sketch',
                            'fade'
                        ]
                    },
                    weight: {
                        maximum: 3,
                        minimum: 1,
                        optional: true,
                        type: 'number'
                    }
                }
            }
        }
    }
];
var $91f47b6c1193565f$export$b64c73d0ec95c7d3 = [
    'rule',
    {
        meta: {
            stage0: true
        },
        props: {
            attrs: {
                optional: true,
                props: {
                    color: {
                        optional: true,
                        pattern: '^#[0-9a-fA-F]{6}$',
                        type: 'string'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    style: {
                        optional: true,
                        type: 'enum',
                        values: [
                            'solid',
                            'dashed',
                            'dotted',
                            'sketch',
                            'fade'
                        ]
                    },
                    weight: {
                        maximum: 3,
                        minimum: 1,
                        optional: true,
                        type: 'number'
                    }
                }
            },
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$471f7ae5c4103ae1 = {
    props: {
        attrs: {
            props: {
                color: {
                    pattern: '^(neutral|purple|blue|red|yellow|green|#[0-9a-fA-F]{6})$',
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                style: {
                    optional: true,
                    type: 'string'
                },
                text: {
                    minLength: 1,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'status'
            ]
        }
    }
};
var $91f47b6c1193565f$export$4899a95d70ec5056 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strike'
            ]
        }
    }
};
var $91f47b6c1193565f$export$59ae2c325a998f89 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strong'
            ]
        }
    }
};
var $91f47b6c1193565f$export$b3401ee80eb31041 = {
    props: {
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'sub',
                        'sup'
                    ]
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'subsup'
            ]
        }
    }
};
var $91f47b6c1193565f$export$faab0ca9701d7048 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                resourceId: {
                    type: 'string'
                }
            }
        },
        marks: {
            items: [
                'breakout'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'syncBlock'
            ]
        }
    }
};
var $91f47b6c1193565f$export$9852986a3ec5f6a0 = {
    props: {
        attrs: {
            optional: true,
            props: {
                displayMode: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'default',
                        'fixed'
                    ]
                },
                isNumberColumnEnabled: {
                    optional: true,
                    type: 'boolean'
                },
                layout: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'align-end',
                        'align-start',
                        'default'
                    ]
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                width: {
                    optional: true,
                    type: 'number'
                }
            }
        },
        content: {
            items: [
                'tableRow'
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [
                'fragment'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'table'
            ]
        }
    }
};
var $91f47b6c1193565f$export$e1e720e5f4603e6a = {
    props: {
        attrs: {
            optional: true,
            props: {
                background: {
                    optional: true,
                    type: 'string'
                },
                colspan: {
                    optional: true,
                    type: 'number'
                },
                colwidth: {
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true,
                    type: 'array'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                rowspan: {
                    optional: true,
                    type: 'number'
                },
                valign: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'top',
                        'middle',
                        'bottom'
                    ]
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'rule_with_attrs',
                    'bodiedRule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'extension_with_annotation',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'tableCell'
            ]
        }
    },
    required: [
        'content'
    ]
};
var $91f47b6c1193565f$export$48884d2a5190dc73 = {
    props: {
        attrs: {
            optional: true,
            props: {
                background: {
                    optional: true,
                    type: 'string'
                },
                colspan: {
                    optional: true,
                    type: 'number'
                },
                colwidth: {
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true,
                    type: 'array'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                rowspan: {
                    optional: true,
                    type: 'number'
                },
                valign: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'top',
                        'middle',
                        'bottom'
                    ]
                }
            }
        },
        content: {
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'rule_with_attrs',
                    'bodiedRule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'extension_with_annotation',
                    'nestedExpand_with_no_marks',
                    'nestedExpand'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'tableHeader'
            ]
        }
    },
    required: [
        'content'
    ]
};
var $91f47b6c1193565f$export$ce666bf02318c957 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            items: [
                [
                    'tableCell',
                    'tableHeader'
                ]
            ],
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'tableRow'
            ]
        }
    }
};
var $91f47b6c1193565f$export$6d8b0ef52e2e6390 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'inline_content'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'taskItem'
            ]
        }
    }
};
var $91f47b6c1193565f$export$375b6afcc5f4d291 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'taskItem',
                    'taskList',
                    'blockTaskItem'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'taskList'
            ]
        }
    }
};
var $91f47b6c1193565f$export$6f093cfa640b7166 = {
    props: {
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        text: {
            minLength: 1,
            type: 'string'
        },
        type: {
            type: 'enum',
            values: [
                'text'
            ]
        }
    }
};
var $91f47b6c1193565f$export$5008c13f04d544f6 = [
    'text',
    {
        props: {
            marks: {
                items: [
                    [
                        'code',
                        'link',
                        'annotation'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$d24a7becb4e0da7c = [
    'text',
    {
        props: {
            marks: {
                items: [
                    [
                        'link',
                        'em',
                        'strong',
                        'strike',
                        'subsup',
                        'underline',
                        'textColor',
                        'annotation',
                        'backgroundColor'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$2a9d18d5b3064e6c = [
    'text',
    {
        props: {
            marks: {
                items: [
                    'link'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$437a3d96346717e0 = [
    'text',
    {
        props: {
            marks: {
                items: [],
                maxItems: 0,
                optional: true,
                type: 'array'
            }
        }
    }
];
var $91f47b6c1193565f$export$32f78bffcd82ff28 = {
    props: {
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'textColor'
            ]
        }
    }
};
var $91f47b6c1193565f$export$425327af25286e5e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'underline'
            ]
        }
    }
};


var $516705420bff361b$export$13afbb83a3ae2576 = {
    alignment: (0, $91f47b6c1193565f$export$8e53000a4ec837),
    annotation: (0, $91f47b6c1193565f$export$8512c9afa7b24c3b),
    backgroundColor: (0, $91f47b6c1193565f$export$8c5a050822fd698c),
    blockCard: (0, $91f47b6c1193565f$export$c4c2f833baaebdb8),
    blockRootOnly: (0, $91f47b6c1193565f$export$ebb5393736e9ba23),
    blockTaskItem: (0, $91f47b6c1193565f$export$16018c61064a18df),
    block_content: (0, $91f47b6c1193565f$export$a31afb40076fa18b),
    blockquote: (0, $91f47b6c1193565f$export$67dc04e652a298ca),
    bodiedExtension: (0, $91f47b6c1193565f$export$27903d543b563e39),
    bodiedExtension_root_only: (0, $91f47b6c1193565f$export$b7a532f6e202d8ea),
    bodiedExtension_with_marks: (0, $91f47b6c1193565f$export$ee052cc5b2356e83),
    bodiedRule: (0, $91f47b6c1193565f$export$2069efcbff2f0292),
    bodiedRule_root_only: (0, $91f47b6c1193565f$export$ab41d73148acae83),
    bodiedSyncBlock: (0, $91f47b6c1193565f$export$e92c7e4302dd4371),
    border: (0, $91f47b6c1193565f$export$1edee58a52776cd9),
    breakout: (0, $91f47b6c1193565f$export$89015c65f1c75e3f),
    bulletList: (0, $91f47b6c1193565f$export$a140c94e5ea26bee),
    caption: (0, $91f47b6c1193565f$export$8e3c2dfdc4f0453d),
    code: (0, $91f47b6c1193565f$export$6565f9f03506010b),
    codeBlock: (0, $91f47b6c1193565f$export$7bb0d5c671655cc4),
    codeBlock_root_only: (0, $91f47b6c1193565f$export$38d90d1aac6883a3),
    confluenceInlineComment: (0, $91f47b6c1193565f$export$f3b72f8fc4684ecd),
    dataConsumer: (0, $91f47b6c1193565f$export$3024f02c495408d6),
    date: (0, $91f47b6c1193565f$export$324d90190a8b822a),
    decisionItem: (0, $91f47b6c1193565f$export$6959e16eeff859b4),
    decisionList: (0, $91f47b6c1193565f$export$62d45a65fb43d95e),
    doc: (0, $91f47b6c1193565f$export$2a111da947c407d2),
    em: (0, $91f47b6c1193565f$export$c63c6f932822f543),
    embedCard: (0, $91f47b6c1193565f$export$be4283d9a1cb1ff6),
    emoji: (0, $91f47b6c1193565f$export$a19185d1233fc4b2),
    expand: (0, $91f47b6c1193565f$export$9f77e0932fb78f72),
    expand_root_only: (0, $91f47b6c1193565f$export$b2817c6954dd6d2c),
    extension: (0, $91f47b6c1193565f$export$1b45514b112dd749),
    extensionFrame: (0, $91f47b6c1193565f$export$4fdcae991fd743e7),
    extension_root_only: (0, $91f47b6c1193565f$export$8eba3df128e25335),
    extension_root_only_with_annotation: (0, $91f47b6c1193565f$export$9dccb771264f1ee3),
    extension_with_annotation: (0, $91f47b6c1193565f$export$a3b88288627564ec),
    extension_with_marks: (0, $91f47b6c1193565f$export$15be7c145cec614a),
    fontSize: (0, $91f47b6c1193565f$export$85e3c3ca0c6fb93),
    fragment: (0, $91f47b6c1193565f$export$f00aeb236b6f05af),
    hardBreak: (0, $91f47b6c1193565f$export$371da9dd35aba193),
    heading: (0, $91f47b6c1193565f$export$46e4a324ac90507f),
    heading_with_alignment: (0, $91f47b6c1193565f$export$c17edf9af655deaf),
    heading_with_indentation: (0, $91f47b6c1193565f$export$1902f9737466a0dc),
    heading_with_no_marks: (0, $91f47b6c1193565f$export$7b491e75f1be9278),
    indentation: (0, $91f47b6c1193565f$export$480c699bd4ec0d86),
    inlineCard: (0, $91f47b6c1193565f$export$cbf8224b64e0d942),
    inlineExtension: (0, $91f47b6c1193565f$export$16b353b2649bd8d9),
    inlineExtension_with_marks: (0, $91f47b6c1193565f$export$e37f10815f36843d),
    inline_content: (0, $91f47b6c1193565f$export$e23e6162adaa368d),
    layoutColumn: (0, $91f47b6c1193565f$export$ab76e7c03cd6f650),
    layoutSection: (0, $91f47b6c1193565f$export$b3b6a70a7fa4a5be),
    layoutSection_full: (0, $91f47b6c1193565f$export$941b63fbd931e449),
    layoutSection_with_single_column: (0, $91f47b6c1193565f$export$e0e9834198e8601d),
    link: (0, $91f47b6c1193565f$export$9c30223ca0a664fb),
    listItem: (0, $91f47b6c1193565f$export$76c7e83ecc9cdf05),
    media: (0, $91f47b6c1193565f$export$987d49ffe1b0900f),
    mediaGroup: (0, $91f47b6c1193565f$export$2855e964765eac9),
    mediaInline: (0, $91f47b6c1193565f$export$38bab695e3f720f1),
    mediaSingle: (0, $91f47b6c1193565f$export$969fe3781ca15058),
    mediaSingle_caption: (0, $91f47b6c1193565f$export$68b0ead306f9670f),
    mediaSingle_full: (0, $91f47b6c1193565f$export$f7fd577406abd5f8),
    mention: (0, $91f47b6c1193565f$export$db83999c14438df4),
    multiBodiedExtension: (0, $91f47b6c1193565f$export$c3c04d555a8b9013),
    multiBodiedExtension_root_only: (0, $91f47b6c1193565f$export$78421d8497ebdea6),
    nestedExpand: (0, $91f47b6c1193565f$export$63cadbf5f4296627),
    nestedExpand_content: (0, $91f47b6c1193565f$export$9584f52f3ebd5d7e),
    nestedExpand_with_no_marks: (0, $91f47b6c1193565f$export$b756fc994eb0bc4f),
    non_nestable_block_content: (0, $91f47b6c1193565f$export$ed866000601e7fa5),
    orderedList: (0, $91f47b6c1193565f$export$a5dc81035676e7a),
    panel: (0, $91f47b6c1193565f$export$21f42ab9b6679f44),
    panel_c1: (0, $91f47b6c1193565f$export$a08c7bcc7e61d424),
    panel_c1_root_only: (0, $91f47b6c1193565f$export$76e58fb94da2bf88),
    panel_root_only: (0, $91f47b6c1193565f$export$9388c8efa26ea154),
    paragraph: (0, $91f47b6c1193565f$export$9c206ddddb32a9b),
    paragraph_with_alignment: (0, $91f47b6c1193565f$export$9ca11c06877e5c64),
    paragraph_with_font_size: (0, $91f47b6c1193565f$export$f745a1f9fa5e1ca8),
    paragraph_with_indentation: (0, $91f47b6c1193565f$export$a3bd66932996fb7d),
    paragraph_with_no_marks: (0, $91f47b6c1193565f$export$f06f75eb1e56b0c5),
    placeholder: (0, $91f47b6c1193565f$export$c7187bbd1a7a9244),
    rule: (0, $91f47b6c1193565f$export$fbeb3a3956e8a3c7),
    rule_root_only: (0, $91f47b6c1193565f$export$5bc14ade5ae67510),
    rule_with_attrs: (0, $91f47b6c1193565f$export$74942eaebdd7ffe),
    rule_with_attrs_root_only: (0, $91f47b6c1193565f$export$b64c73d0ec95c7d3),
    status: (0, $91f47b6c1193565f$export$471f7ae5c4103ae1),
    strike: (0, $91f47b6c1193565f$export$4899a95d70ec5056),
    strong: (0, $91f47b6c1193565f$export$59ae2c325a998f89),
    subsup: (0, $91f47b6c1193565f$export$b3401ee80eb31041),
    syncBlock: (0, $91f47b6c1193565f$export$faab0ca9701d7048),
    table: (0, $91f47b6c1193565f$export$9852986a3ec5f6a0),
    tableCell: (0, $91f47b6c1193565f$export$e1e720e5f4603e6a),
    tableHeader: (0, $91f47b6c1193565f$export$48884d2a5190dc73),
    tableRow: (0, $91f47b6c1193565f$export$ce666bf02318c957),
    taskItem: (0, $91f47b6c1193565f$export$6d8b0ef52e2e6390),
    taskList: (0, $91f47b6c1193565f$export$375b6afcc5f4d291),
    text: (0, $91f47b6c1193565f$export$6f093cfa640b7166),
    textColor: (0, $91f47b6c1193565f$export$32f78bffcd82ff28),
    text_code_inline: (0, $91f47b6c1193565f$export$5008c13f04d544f6),
    text_formatted: (0, $91f47b6c1193565f$export$d24a7becb4e0da7c),
    text_link_inline: (0, $91f47b6c1193565f$export$2a9d18d5b3064e6c),
    text_with_no_marks: (0, $91f47b6c1193565f$export$437a3d96346717e0),
    underline: (0, $91f47b6c1193565f$export$425327af25286e5e)
};


var $7dc088a1efcddf18$var$_excluded = [
    "items"
];
function $7dc088a1efcddf18$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $7dc088a1efcddf18$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $7dc088a1efcddf18$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7dc088a1efcddf18$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7dc088a1efcddf18$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $7dc088a1efcddf18$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $7dc088a1efcddf18$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7dc088a1efcddf18$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7dc088a1efcddf18$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7dc088a1efcddf18$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7dc088a1efcddf18$var$mapMarksItems(spec) {
    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function(x) {
        return x;
    };
    if (spec.props && spec.props.marks) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var _ref = spec.props.marks, items = _ref.items, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $7dc088a1efcddf18$var$_excluded);
        return $7dc088a1efcddf18$var$_objectSpread($7dc088a1efcddf18$var$_objectSpread({}, spec), {}, {
            props: $7dc088a1efcddf18$var$_objectSpread($7dc088a1efcddf18$var$_objectSpread({}, spec.props), {}, {
                marks: $7dc088a1efcddf18$var$_objectSpread($7dc088a1efcddf18$var$_objectSpread({}, rest), {}, {
                    /**
           * `Text & MarksObject<Mark-1>` produces `items: ['mark-1']`
           * `Text & MarksObject<Mark-1 | Mark-2>` produces `items: [['mark-1', 'mark-2']]`
           */ items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                        fn(items)
                    ] : [
                        []
                    ]
                })
            })
        });
    } else return spec;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $7dc088a1efcddf18$var$partitionObject = function partitionObject(obj, predicate) {
    return Object.keys(obj).reduce(function(acc, key) {
        var result = predicate(key, obj[key], obj);
        acc[result ? 0 : 1].push(key);
        return acc;
    }, [
        [],
        []
    ]);
};
/**
 * Checks if a spec is a variant spec.
 * A variant spec is an array where the first element is a string (base spec name)
 * and the second element is a ValidatorSpec object { props: { ... } }
 */ var $7dc088a1efcddf18$var$isVariant = function isVariant(spec) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(spec) === 'object' && !!spec && 0 in spec && 1 in spec && typeof spec[0] === 'string' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(spec[1]) === 'object';
};
/**
 * Resolve one content-item name against `specs`. Variant specs are stored as tuples (arrays), so a
 * name that refers to one (e.g. `paragraph_with_no_marks`) resolves to that tuple. A plain node
 * name (e.g. `table`) has no tuple in `specs` and is returned unchanged for the matcher to handle
 * by name.
 */ var $7dc088a1efcddf18$var$resolveContentItemName = function resolveContentItemName(name) {
    var referencedSpec = (0, $516705420bff361b$export$13afbb83a3ae2576)[name];
    return Array.isArray(referencedSpec) ? referencedSpec : name;
};
/**
 * Expand the content item NAMES inside a variant tuple's override so they resolve the same way a
 * base spec's content does. A variant such as `panel_c1` is `['panel', { props: { content: { items:
 * [['paragraph_with_no_marks', ..., 'table']] } } }]`; those inner names are validator variant
 * names. Unlike a base spec's content (which `createSpec` resolves), the override names are left
 * raw, so the variant branch matches only plainly-named children (e.g. `table`) and rejects
 * variant-named ones (e.g. a normal `paragraph`). Resolve each name one level, leaving plain node
 * names untouched.
 */ var $7dc088a1efcddf18$var$resolveVariantOverrideContentItems = function resolveVariantOverrideContentItems(variantTuple) {
    var _variantSpec$props;
    var _variantTuple = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(variantTuple, 2), baseNodeType = _variantTuple[0], variantSpec = _variantTuple[1];
    var content = variantSpec === null || variantSpec === void 0 || (_variantSpec$props = variantSpec.props) === null || _variantSpec$props === void 0 ? void 0 : _variantSpec$props.content;
    if (!content || !Array.isArray(content.items)) return variantTuple;
    // Each entry in `content.items` is either a single name or an `$or` group (a list of
    // alternative names). Resolve the names inside each `$or` group; pass single names through.
    var resolvedItems = content.items.map(function(entry) {
        return Array.isArray(entry) ? entry.map($7dc088a1efcddf18$var$resolveContentItemName) : entry;
    });
    return [
        baseNodeType,
        $7dc088a1efcddf18$var$_objectSpread($7dc088a1efcddf18$var$_objectSpread({}, variantSpec), {}, {
            props: $7dc088a1efcddf18$var$_objectSpread($7dc088a1efcddf18$var$_objectSpread({}, variantSpec.props), {}, {
                content: $7dc088a1efcddf18$var$_objectSpread($7dc088a1efcddf18$var$_objectSpread({}, content), {}, {
                    items: resolvedItems
                })
            })
        })
    ];
};
function $7dc088a1efcddf18$export$a49afc9edc88765c(nodes, marks) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys((0, $516705420bff361b$export$13afbb83a3ae2576)).reduce(function(newSpecs, k) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var spec = $7dc088a1efcddf18$var$_objectSpread({}, (0, $516705420bff361b$export$13afbb83a3ae2576)[k]);
        if ($7dc088a1efcddf18$var$isVariant(spec)) {
            // Their override content items are variant names, which match no child by type, so resolve
            // them one level or valid content gets wrapped as `unsupportedBlock`. For non-panel variants
            // like `mediaSingle_full` the names are already plain, so this is a no-op.
            var resolved = $7dc088a1efcddf18$var$resolveVariantOverrideContentItems([
                spec[0],
                spec[1]
            ]);
            spec = $7dc088a1efcddf18$var$_objectSpread($7dc088a1efcddf18$var$_objectSpread({}, spec), {}, {
                1: resolved[1]
            });
        }
        if (spec.props) {
            spec.props = $7dc088a1efcddf18$var$_objectSpread({}, spec.props);
            if (spec.props.content) {
                // 'tableCell_content' => { type: 'array', items: [ ... ] }
                if ((0, $e907d3774bffa6b3$export$844ec244b1367d54)(spec.props.content)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                spec.props.content = (0, $516705420bff361b$export$13afbb83a3ae2576)[spec.props.content];
                // ['inline', 'emoji']
                if (Array.isArray(spec.props.content)) /**
           * Flatten
           *
           * Input:
           * [ { type: 'array', items: [ 'tableHeader' ] }, { type: 'array', items: [ 'tableCell' ] } ]
           *
           * Output:
           * { type: 'array', items: [ [ 'tableHeader' ], [ 'tableCell' ] ] }
           */ spec.props.content = {
                    type: 'array',
                    items: (spec.props.content || []).map(function(arr) {
                        return arr.items;
                    })
                };
                else spec.props.content = $7dc088a1efcddf18$var$_objectSpread({}, spec.props.content);
                spec.props.content.items = spec.props.content.items// ['inline'] => [['emoji', 'hr', ...]]
                // ['media'] => [['media']]
                .map(function(item) {
                    return (0, $e907d3774bffa6b3$export$844ec244b1367d54)(item) ? // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Array.isArray((0, $516705420bff361b$export$13afbb83a3ae2576)[item]) ? // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (0, $516705420bff361b$export$13afbb83a3ae2576)[item] : [
                        item
                    ] : item;
                })// [['emoji', 'hr', 'inline_code']] => [['emoji', 'hr', ['text', { marks: {} }]]]
                .map(function(item) {
                    return item.map(function(subItem) {
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        var resolved = (0, $516705420bff361b$export$13afbb83a3ae2576)[subItem];
                        if (Array.isArray(resolved)) // Resolve the variant tuple's own override content names so a nested match works.
                        return $7dc088a1efcddf18$var$resolveVariantOverrideContentItems(resolved);
                        // Now `NoMark` produces `items: []`, should be fixed in generator
                        return (0, $e907d3774bffa6b3$export$844ec244b1367d54)(subItem) ? subItem : [
                            'text',
                            subItem
                        ];
                    })// Remove unsupported nodes & marks
                    // Filter nodes
                    .filter(function(subItem) {
                        if (nodes) {
                            // Node with overrides
                            // ['mediaSingle', { props: { content: { items: [ 'media', 'caption' ] } }}]
                            if (Array.isArray(subItem)) {
                                var _subItem$1$props;
                                var isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                // Only a variant tuple carries an override spec to read; `['text', spec]` above
                                // builds the same shape, so both are covered.
                                var overrideItems = $7dc088a1efcddf18$var$isVariant(subItem) ? (_subItem$1$props = subItem[1].props) === null || _subItem$1$props === void 0 || (_subItem$1$props = _subItem$1$props.content) === null || _subItem$1$props === void 0 ? void 0 : _subItem$1$props.items : undefined;
                                // The node-list check below only holds when the override lists child node names. A
                                // nested `$or` list (`string[][]`, as `panel_c1` has) never matches, which would
                                // drop the variant entirely, so keep it and validate its children recursively.
                                var overrideListsChildNodeNames = Array.isArray(overrideItems) && overrideItems.every(function(item) {
                                    return typeof item === 'string';
                                });
                                if (isMainNodeSupported && overrideListsChildNodeNames) return overrideItems.every(function(item) {
                                    return nodes.indexOf(item) > -1;
                                });
                                return isMainNodeSupported;
                            }
                            return nodes.indexOf(subItem) > -1;
                        }
                        return true;
                    })// Filter marks
                    .map(function(subItem) {
                        return Array.isArray(subItem) && marks ? /**
            * TODO: Probably try something like immer, but it's 3.3kb gzipped.
            * Not worth it just for this.
            */ [
                            subItem[0],
                            $7dc088a1efcddf18$var$mapMarksItems(subItem[1])
                        ] : subItem;
                    });
                });
            }
        }
        newSpecs[k] = spec;
        return newSpecs;
    }, {});
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7dc088a1efcddf18$var$getOptionsForType(type, list) {
    if (!list) return {};
    for(var i = 0, len = list.length; i < len; i++){
        var spec = list[i];
        var name = spec;
        var options = {};
        if (Array.isArray(spec)) {
            var _spec = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(spec, 2);
            name = _spec[0];
            options = _spec[1];
        }
        if (name === type) return options;
    }
    return false;
}
var $7dc088a1efcddf18$var$isValidatorSpecAttrs = function isValidatorSpecAttrs(spec) {
    return !!spec.props;
};
function $7dc088a1efcddf18$export$66c739158ef99a42(spec, value) {
    if (!(0, $b6547681adadee84$export$4e62c701997796c1)(value)) return !!spec.optional;
    if ($7dc088a1efcddf18$var$isValidatorSpecAttrs(spec)) {
        // If spec has ".props" it is ValidatorSpecAttrs and need to pipe back in recursively
        var _partitionObject = $7dc088a1efcddf18$var$partitionObject(spec.props, function(key, subSpec) {
            return(// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            $7dc088a1efcddf18$export$66c739158ef99a42(subSpec, value[key]));
        }), _partitionObject2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_partitionObject, 2), _ = _partitionObject2[0], invalidKeys = _partitionObject2[1];
        return invalidKeys.length === 0;
    }
    // extension_node parameters has no type
    if (!(0, $b6547681adadee84$export$4e62c701997796c1)(spec.type)) return !!spec.optional;
    switch(spec.type){
        case 'boolean':
            return (0, $87916065a395f778$export$f9ce7b637dfbe238)(value);
        case 'number':
            return (0, $7c1b5fa3f5d6e3a8$export$7e4aa119212bc614)(value) && ((0, $b6547681adadee84$export$4e62c701997796c1)(spec.minimum) ? spec.minimum <= value : true) && ((0, $b6547681adadee84$export$4e62c701997796c1)(spec.maximum) ? spec.maximum >= value : true);
        case 'integer':
            return (0, $ebc728fb4f4fa794$export$a287f47fed4544b8)(value) && ((0, $b6547681adadee84$export$4e62c701997796c1)(spec.minimum) ? spec.minimum <= value : true) && ((0, $b6547681adadee84$export$4e62c701997796c1)(spec.maximum) ? spec.maximum >= value : true);
        case 'string':
            var validatorFnPassed = function validatorFnPassed(rule) {
                return typeof value === 'string' && (0, $b6547681adadee84$export$4e62c701997796c1)((0, $f0f3f0f3bbc98098$export$d1b377ca77ac267d)[rule]) && (0, $f0f3f0f3bbc98098$export$d1b377ca77ac267d)[rule](value);
            };
            return (0, $e907d3774bffa6b3$export$844ec244b1367d54)(value) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ((0, $b6547681adadee84$export$4e62c701997796c1)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, $b6547681adadee84$export$4e62c701997796c1)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
        case 'object':
            return (0, $f607840467d96991$export$53b83ca8eaab0383)(value);
        case 'array':
            if (Array.isArray(value)) {
                var isTuple = !!spec.isTupleLike;
                var minItems = spec.minItems, maxItems = spec.maxItems;
                if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                if (isTuple) {
                    // If value has fewer items than tuple has specs - we are fine with that.
                    var numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                    return Array(numberOfItemsToCheck).fill(null).every(function(_, i) {
                        return $7dc088a1efcddf18$export$66c739158ef99a42(spec.items[i], value[i]);
                    });
                } else return value.every(function(valueItem) {
                    return(// We check that at least one of the specs in the list (spec.items) matches each value from
                    spec.items.some(function(itemSpec) {
                        return $7dc088a1efcddf18$export$66c739158ef99a42(itemSpec, valueItem);
                    }));
                });
            }
            return false;
        case 'enum':
            return (0, $e907d3774bffa6b3$export$844ec244b1367d54)(value) && spec.values.indexOf(value) > -1;
    }
}
var $7dc088a1efcddf18$var$errorMessageFor = function errorMessageFor(type, message) {
    return "".concat(type, ": ").concat(message, ".");
};
var $7dc088a1efcddf18$var$getUnsupportedOptions = function getUnsupportedOptions(spec) {
    if (spec && spec.props && spec.props.content) {
        var _spec$props$content = spec.props.content, allowUnsupportedBlock = _spec$props$content.allowUnsupportedBlock, allowUnsupportedInline = _spec$props$content.allowUnsupportedInline;
        return {
            allowUnsupportedBlock: allowUnsupportedBlock,
            allowUnsupportedInline: allowUnsupportedInline
        };
    }
    return {};
};
var $7dc088a1efcddf18$var$invalidChildContent = function invalidChildContent(child, errorCallback, parentSpec) {
    var message = $7dc088a1efcddf18$var$errorMessageFor(child.type, 'invalid content');
    if (!errorCallback) throw new Error(message);
    else {
        var _parentSpec$props;
        return errorCallback($7dc088a1efcddf18$var$_objectSpread({}, child), {
            code: 'INVALID_CONTENT',
            message: message,
            meta: {
                parentType: parentSpec === null || parentSpec === void 0 || (_parentSpec$props = parentSpec.props) === null || _parentSpec$props === void 0 || (_parentSpec$props = _parentSpec$props.type) === null || _parentSpec$props === void 0 ? void 0 : _parentSpec$props.values[0]
            }
        }, $7dc088a1efcddf18$var$getUnsupportedOptions(parentSpec));
    }
};
var $7dc088a1efcddf18$var$unsupportedMarkContent = function unsupportedMarkContent(errorCode, mark, errorCallback, errorMessage) {
    var message = errorMessage || $7dc088a1efcddf18$var$errorMessageFor(mark.type, 'unsupported mark');
    if (!errorCallback) throw new Error(message);
    else return errorCallback($7dc088a1efcddf18$var$_objectSpread({}, mark), {
        code: errorCode,
        message: message,
        meta: mark
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: true
    });
};
var $7dc088a1efcddf18$var$unsupportedNodeAttributesContent = function unsupportedNodeAttributesContent(entity, errorCode, invalidAttributes, message, errorCallback) {
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        type: entity.type
    }, {
        code: errorCode,
        message: message,
        meta: invalidAttributes
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: false,
        isNodeAttribute: true
    });
};
/**
 * Copies the containers that validation writes to, keeping the caller's document read-only.
 *
 * Repairing unsupported content mutates the entity in place: `wrapUnSupportedNodeAttributes` deletes
 * keys from `attrs` and appends an `unsupportedNodeAttribute` mark to `marks`. A plain spread shares
 * both containers with the input, so those writes would escape into the caller's document and the
 * candidate-spec retry would re-validate an already-emptied `attrs`.
 *
 * Only `attrs` and `marks` need copying; nothing writes below that level.
 */ var $7dc088a1efcddf18$var$cloneEntityForValidation = function cloneEntityForValidation(entity) {
    var clone = $7dc088a1efcddf18$var$_objectSpread({}, entity);
    if (entity.attrs) clone.attrs = $7dc088a1efcddf18$var$_objectSpread({}, entity.attrs);
    if (entity.marks) clone.marks = entity.marks.map(function(mark) {
        return $7dc088a1efcddf18$var$_objectSpread({}, mark);
    });
    return clone;
};
function $7dc088a1efcddf18$export$956325f45c5d174a(nodes, marks) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var allowPrivateAttributes = options.allowPrivateAttributes, _options$mode = options.mode, mode = _options$mode === void 0 ? 'strict' : _options$mode, stage0 = options.stage0;
    // Whether specs that only exist in the stage-0 schema are declined for this caller.
    var rejectStage0Specs = !stage0;
    // Whether an empty `marks` array is dropped from a node that only ever takes an empty one. Resolved
    // once for the same reasons as above. Gate off keeps such a node rejected.
    var acceptEmptyMarks = (0, $50U6m.fg)('platform_editor_adf_validator_empty_marks');
    var validatorSpecs = $7dc088a1efcddf18$export$a49afc9edc88765c(nodes, marks);
    // `extractAllowedContent` scans all of `validatorSpecs` for one node type's candidates, and
    // `validate` calls it per node. It depends only on `validatorSpecs` — fixed once
    // `applyVariantSpecOverrides` has run — and `entity.type`, so it caches per type. Sharing one array
    // across nodes of a type is safe: `getOptionsForType` only iterates it, and the specs inside were
    // already shared via `validatorSpecs`.
    var allowedContentByType = new Map();
    var getAllowedContent = function getAllowedContent(entity) {
        var type = entity.type;
        if (typeof type !== 'string') return (0, $a265986427be6a21$export$7d2123bc001cdbf8)(validatorSpecs, entity);
        var allowedContent = allowedContentByType.get(type);
        if (allowedContent === undefined) {
            allowedContent = (0, $a265986427be6a21$export$7d2123bc001cdbf8)(validatorSpecs, entity);
            allowedContentByType.set(type, allowedContent);
        }
        return allowedContent;
    };
    var validate = function validate(entity, errorCallback, allowed, parentSpec) {
        if (!allowed) {
            var _iterator = $7dc088a1efcddf18$var$_createForOfIteratorHelper(getAllowedContent(entity)), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var _allowed = _step.value;
                    var _validationResult = validateNode(entity, errorCallback, _allowed, parentSpec);
                    if (_validationResult.valid) return {
                        entity: _validationResult.entity,
                        valid: _validationResult.valid
                    };
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
        // If `allowed` was provided or we haven't passed yet, return the initial result
        var validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
        return {
            entity: validationResult.entity,
            valid: validationResult.valid
        };
    };
    var validateNode = function validateNode(entity, errorCallback, allowed, parentSpec) {
        var isMark = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        var type = entity.type;
        var newEntity = $7dc088a1efcddf18$var$cloneEntityForValidation(entity);
        var err = function err(code, msg, meta) {
            var message = $7dc088a1efcddf18$var$errorMessageFor(type, msg);
            if (errorCallback) return {
                valid: false,
                entity: errorCallback(newEntity, {
                    code: code,
                    message: message,
                    meta: meta
                }, $7dc088a1efcddf18$var$getUnsupportedOptions(parentSpec))
            };
            else throw new Error(message);
        };
        if (type) {
            var _typeOptions$meta;
            var typeOptions = $7dc088a1efcddf18$var$getOptionsForType(type, allowed);
            if (typeOptions === false) return isMark ? {
                valid: false
            } : err('INVALID_TYPE', 'type not allowed here');
            var spec = validatorSpecs[type];
            if (!spec) return err('INVALID_TYPE', "".concat(type, ": No validation spec found for type!"));
            // A spec carrying `meta.stage0` exists only in the stage-0 schema. It reaches here as the
            // candidate the parent offers for this entity, so declining the candidate lets the caller's
            // candidate loop fall through to the next spec, normally the base one. Reading the flag from
            // `parentSpec` would reject the entity's own children and marks instead, emptying a node that
            // matches a stage-0 variant.
            //
            // The rule is partial, and errs towards accepting: `typeOptions` carries variant
            // candidates only, so a stage-0-only base node such as `extensionFrame` reaches here with
            // `{}` and is accepted; `applyVariantSpecOverrides` copies a variant's `props` onto its base
            // without `meta`; and `withoutStage0Meta` clears the flag from variants that also carry
            // `breakout`. Also reading `validatorSpecs[type].meta` would cover the base-node case, but
            // only holds while the generator flags stage-0-only specs and nothing else.
            if (rejectStage0Specs && (_typeOptions$meta = typeOptions.meta) !== null && _typeOptions$meta !== void 0 && _typeOptions$meta.stage0) return {
                valid: false
            };
            var specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
            if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
        } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
        return {
            valid: true,
            entity: newEntity
        };
    };
    return validate;
    function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
        var validationResult;
        if (validator.props && validator.props.marks) {
            var marksSet = allowedMarksFor(validator);
            var marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
            validationResult = {
                valid: true,
                entity: newEntity,
                marksValidationOutput: marksValidationResult
            };
        } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
        return validationResult;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function validatorFor(spec, typeOptions) {
        return $7dc088a1efcddf18$var$_objectSpread($7dc088a1efcddf18$var$_objectSpread($7dc088a1efcddf18$var$_objectSpread({}, spec), typeOptions), spec.props ? {
            props: $7dc088a1efcddf18$var$_objectSpread($7dc088a1efcddf18$var$_objectSpread({}, spec.props), typeOptions['props'] || {})
        } : {});
    }
    function marksAfterValidation(entity, errorCallback, marksSet, validator) {
        return entity.marks ? entity.marks.map(function(mark) {
            var isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
            if (mode === 'strict' && isAKnownMark) {
                var finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                var finalMark = finalResult.entity;
                if (finalMark) return {
                    valid: true,
                    originalMark: mark,
                    newMark: finalMark
                };
                else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                    valid: false,
                    originalMark: mark,
                    errorCode: finalResult.marksValidationOutput[0].errorCode,
                    message: finalResult.marksValidationOutput[0].message
                };
                else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_TYPE'
                };
            } else return {
                valid: false,
                originalMark: mark,
                errorCode: 'INVALID_CONTENT'
            };
        }) : [];
    }
    function allowedMarksFor(validator) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var _ref2 = validator.props.marks, items = _ref2.items;
        var marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
        return marksSet;
    }
    /**
   * Whether the node declares a `marks` property that no mark type may go into, which ADF spells as
   * `marks: { type: 'array', maxItems: 0 }` — `paragraph`, `heading`, `extension` and `codeBlock` all
   * do. An empty array is then the property's only legal value, so it says nothing about the node and
   * carries nothing to reject.
   *
   * The declaration is read off the BASE spec, not the candidate the parent offered. A variant only
   * ever widens the mark types (`extension_with_marks` adds `dataConsumer` and `fragment`), which
   * cannot make the empty list illegal. Reading the candidate instead would leave a root `extension`
   * out, since `doc` offers it as `extension_with_marks`.
   *
   * A node with no `marks` property at all (`rule`, `panel`, `mediaGroup`) is excluded: for those,
   * `marks` is a property ADF does not define, so an empty array is still redundant.
   */ function declaresEmptyMarksOnly(baseSpec) {
        var _baseSpec$props;
        return !!((_baseSpec$props = baseSpec.props) !== null && _baseSpec$props !== void 0 && _baseSpec$props.marks) && allowedMarksFor(baseSpec).length === 0;
    }
    function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
        var _newEntity$marks;
        var errorCode = 'REDUNDANT_MARKS';
        var currentMarks = prevEntity.marks || [];
        var newMarks = currentMarks.map(function(mark) {
            var isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
            if (isUnsupportedNodeAttributeMark) return mark;
            return $7dc088a1efcddf18$var$unsupportedMarkContent(errorCode, mark, errorCallback);
        });
        // Attribute validation may have already put an `unsupportedNodeAttribute` mark on `newEntity`.
        // It is not in `prevEntity.marks`, so rebuilding from those alone loses the only record of the
        // unknown attribute. The check above only covers the mark being on the original entity, which
        // held while the validated entity still aliased the caller's marks array.
        var prevMarkTypes = new Set(currentMarks.map(function(mark) {
            return mark.type;
        }));
        var synthesizedMarks = ((_newEntity$marks = newEntity.marks) !== null && _newEntity$marks !== void 0 ? _newEntity$marks : []).filter(function(mark) {
            return !prevMarkTypes.has(mark.type);
        });
        var allMarks = newMarks.concat(synthesizedMarks);
        if (allMarks.length) {
            newEntity.marks = allMarks;
            return {
                valid: true,
                entity: newEntity
            };
        } else return err('REDUNDANT_MARKS', 'redundant marks', {
            marks: Object.keys(currentMarks)
        });
    }
    function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
        var result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.required) {
            if (!validatorSpec.required.every(function(prop) {
                return (0, $b6547681adadee84$export$4e62c701997796c1)(prevEntity[prop]);
            })) result = err('MISSING_PROPERTIES', 'required prop missing');
        }
        return result;
    }
    function textPropertyValidationFor(validatorSpec, prevEntity, err) {
        var result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.text) {
            if ((0, $b6547681adadee84$export$4e62c701997796c1)(prevEntity.text) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            !$7dc088a1efcddf18$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', "'text' validation failed");
        }
        return result;
    }
    function contentLengthValidationFor(validatorSpec, prevEntity, err) {
        var result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.content && prevEntity.content) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            var _content = validatorSpec.props.content, minItems = _content.minItems, maxItems = _content.maxItems;
            var length = prevEntity.content.length;
            if ((0, $b6547681adadee84$export$4e62c701997796c1)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', "'content' should have more than ".concat(minItems, " child"), {
                length: length,
                requiredLength: minItems,
                type: 'minimum'
            });
            else if ((0, $b6547681adadee84$export$4e62c701997796c1)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', "'content' should have less than ".concat(maxItems, " child"), {
                length: length,
                requiredLength: maxItems,
                type: 'maximum'
            });
        }
        return result;
    }
    function invalidAttributesFor(validatorSpec, prevEntity) {
        var invalidAttrs = [];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var validatorAttrs = {};
        if (validatorSpec.props && validatorSpec.props.attrs) {
            var attrOptions = (0, $cff1eaad54dae4e3$export$7b85fd78dd236198)(validatorSpec.props.attrs);
            /**
       * Attrs can be union type so try each path
       * attrs: [{ props: { url: { type: 'string' } } }, { props: { data: {} } }],
       * Gotcha: It will always report the last failure.
       */ for(var i = 0, length = attrOptions.length; i < length; ++i){
                var attrOption = attrOptions[i];
                if (attrOption && attrOption.props) {
                    var _partitionObject3 = $7dc088a1efcddf18$var$partitionObject(attrOption.props, function(key, spec) {
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        var valueToValidate = prevEntity.attrs[key];
                        return $7dc088a1efcddf18$export$66c739158ef99a42(spec, valueToValidate);
                    });
                    var _partitionObject4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_partitionObject3, 2);
                    invalidAttrs = _partitionObject4[1];
                }
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                validatorAttrs = attrOption;
                if (!invalidAttrs.length) break;
            }
        }
        return {
            invalidAttrs: invalidAttrs,
            validatorAttrs: validatorAttrs
        };
    }
    function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
        var validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
        if (prevEntity.attrs) {
            if (!validatorSpecAllowsAttributes) {
                if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                var attrs = Object.keys(prevEntity.attrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
            }
            var _validateAttributes = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs), hasUnsupportedAttrs = _validateAttributes.hasUnsupportedAttrs, redundantAttrs = _validateAttributes.redundantAttrs, invalidAttrs = _validateAttributes.invalidAttrs;
            if (hasUnsupportedAttrs) {
                if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
            }
        }
        return {
            valid: true,
            entity: prevEntity
        };
    }
    function validateAttributes(validatorSpec, prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        var invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
        var invalidAttrs = invalidAttributesResult.invalidAttrs;
        var validatorAttrs = invalidAttributesResult.validatorAttrs;
        var attrs = Object.keys(attributes).filter(function(k) {
            return !(allowPrivateAttributes && k.startsWith('__'));
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var redundantAttrs = attrs.filter(function(a) {
            return !validatorAttrs.props[a];
        });
        var hasRedundantAttrs = redundantAttrs.length > 0;
        var hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
        return {
            hasUnsupportedAttrs: hasUnsupportedAttrs,
            invalidAttrs: invalidAttrs,
            redundantAttrs: redundantAttrs
        };
    }
    function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
        var attr = invalidAttrs.concat(redundantAttrs);
        var result = {
            valid: true,
            entity: prevEntity
        };
        var message = $7dc088a1efcddf18$var$errorMessageFor(prevEntity.type, "'attrs' validation failed");
        var errorCode = 'UNSUPPORTED_ATTRIBUTES';
        newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
        result = {
            valid: true,
            entity: newEntity
        };
        return result;
    }
    function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
        var errorCode = 'INVALID_ATTRIBUTES';
        var message = $7dc088a1efcddf18$var$errorMessageFor(prevEntity.type, "'attrs' validation failed");
        var hasRedundantAttrs = redundantAttrs.length;
        var hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
        if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
            errorCode = 'REDUNDANT_ATTRIBUTES';
            message = $7dc088a1efcddf18$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
        }
        var markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function handleNoAttibutesAllowedInSpecForMark(prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        var message = $7dc088a1efcddf18$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
        var errorCode = 'REDUNDANT_ATTRIBUTES';
        var markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
        var invalidValues = {};
        // eslint-disable-next-line guard-for-in
        for(var invalidAttr in invalidAttrs){
            invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
            if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
        }
        var unsupportedNodeAttributeValues = $7dc088a1efcddf18$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
        var finalEntity = $7dc088a1efcddf18$var$_objectSpread({}, newEntity);
        if (finalEntity.marks) {
            if (!unsupportedNodeAttributeValues) return finalEntity.marks;
            // If there is an existing unsupported node attribute mark, overwrite it to avoid duplicate marks
            var existingMark = finalEntity.marks.find(function(mark) {
                return mark.type === unsupportedNodeAttributeValues.type;
            });
            if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
            else finalEntity.marks.push(unsupportedNodeAttributeValues);
            return finalEntity.marks;
        } else return [
            unsupportedNodeAttributeValues
        ];
    }
    function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
        var result = {
            valid: true,
            entity: prevEntity
        };
        var _partitionObject5 = $7dc088a1efcddf18$var$partitionObject(prevEntity, function(k) {
            return(// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $b6547681adadee84$export$4e62c701997796c1)(validatorSpec.props[k]));
        }), _partitionObject6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_partitionObject5, 2), requiredProps = _partitionObject6[0], redundantProps = _partitionObject6[1];
        if (redundantProps.length) {
            if (mode === 'loose') {
                newEntity = {
                    type: type
                };
                requiredProps.reduce(function(acc, p) {
                    return (0, $8abd2a78619ba16a$export$784d13d8ee351f07)(prevEntity, acc, p);
                }, newEntity);
            } else {
                if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', "redundant props found: ".concat(redundantProps.join(', ')), {
                    props: redundantProps
                });
            }
        }
        return result;
    }
    function specBasedValidationFor(spec, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
        var specBasedValidationResult = {
            hasValidated: false
        };
        var validatorSpec = validatorFor(spec, typeOptions);
        if (!validatorSpec) return specBasedValidationResult;
        // Required Props
        // For array format where `required` is an array
        var requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!requiredPropertyValidatonResult.valid) return {
            hasValidated: true,
            result: requiredPropertyValidatonResult
        };
        if (!validatorSpec.props) {
            var props = Object.keys(prevEntity);
            // If there's no validator.props then there shouldn't be any key except `type`
            if (props.length > 1) return {
                hasValidated: true,
                result: err('REDUNDANT_PROPERTIES', "redundant props found: ".concat(Object.keys(prevEntity).join(', ')), {
                    props: props
                })
            };
            return specBasedValidationResult;
        }
        // Check text
        var textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!textPropertyValidationResult.valid) return {
            hasValidated: true,
            result: textPropertyValidationResult
        };
        // Content Length
        var contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
        if (!contentLengthValidationResult.valid) return {
            hasValidated: true,
            result: contentLengthValidationResult
        };
        // Required Props
        // For object format based on `optional` property
        var _partitionObject7 = $7dc088a1efcddf18$var$partitionObject(validatorSpec.props, function(k, v) {
            var _validatorSpec$requir;
            // if the validator is an array, then check
            // if the `required` field contains the key.
            var isOptional = Array.isArray(v) ? !((_validatorSpec$requir = validatorSpec.required) !== null && _validatorSpec$requir !== void 0 && _validatorSpec$requir.includes(k)) : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(v) === 'object' && v !== null && 'optional' in v ? v.optional : false;
            return isOptional || (0, $b6547681adadee84$export$4e62c701997796c1)(prevEntity[k]);
        }), _partitionObject8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_partitionObject7, 2), missingProps = _partitionObject8[1];
        if (missingProps.length) return {
            hasValidated: true,
            result: err('MISSING_PROPERTIES', 'required prop missing', {
                props: missingProps
            })
        };
        var attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
        if (!attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        if (isMark && attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        var extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
        if (!extraPropsValidationResult.valid) return {
            hasValidated: true,
            result: extraPropsValidationResult
        };
        // Children
        if (validatorSpec.props.content) {
            var contentValidatorSpec = validatorSpec.props.content;
            if (prevEntity.content) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var validateChildNode = function validateChildNode(child, index) {
                    if (child === undefined) return child;
                    var validateChildMarks = function validateChildMarks(childEntity, marksValidationOutput, errorCallback, isLastValidationSpec) {
                        var isParentTupleLike = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
                        var marksAreValid = true;
                        if (childEntity && childEntity.marks && marksValidationOutput) {
                            var validMarks = marksValidationOutput.filter(function(mark) {
                                return mark.valid;
                            });
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            var finalMarks = marksValidationOutput.map(function(mr) {
                                if (mr.valid) return mr.newMark;
                                else {
                                    if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $7dc088a1efcddf18$var$unsupportedMarkContent(// Ignored via go/ees005
                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                    return;
                                }
                            }).filter(Boolean);
                            // `marksValidationOutput` is derived from the ORIGINAL marks, so it omits marks
                            // synthesized during validation. The `unsupportedNodeAttribute` mark is one of those
                            // and is the only record of an unknown attribute, so rebuilding from the output alone
                            // destroys it. This survived by accident before entities were deep-cloned.
                            var validatedMarkTypes = new Set(marksValidationOutput.map(function(markResult) {
                                var _markResult$originalM;
                                return (_markResult$originalM = markResult.originalMark) === null || _markResult$originalM === void 0 ? void 0 : _markResult$originalM.type;
                            }));
                            var synthesizedMarks = childEntity.marks.filter(function(mark) {
                                return !validatedMarkTypes.has(mark.type);
                            });
                            var allMarks = finalMarks.concat(synthesizedMarks);
                            if (allMarks.length) childEntity.marks = allMarks;
                            else {
                                delete childEntity.marks;
                                marksAreValid = false;
                            }
                        }
                        return {
                            valid: marksAreValid,
                            entity: childEntity
                        };
                    };
                    var hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                    if (hasMultipleCombinationOfContentAllowed) {
                        var _validateNode = validateNode(child, errorCallback, (0, $cff1eaad54dae4e3$export$7b85fd78dd236198)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec), newChildEntity = _validateNode.entity, marksValidationOutput = _validateNode.marksValidationOutput;
                        var _validateChildMarks = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true), entity = _validateChildMarks.entity;
                        return entity;
                    }
                    // Only go inside valid branch
                    var allowedSpecsForEntity = contentValidatorSpec.items.filter(function(item) {
                        return Array.isArray(item) ? item.some(// [p, hr, ...] or [p, [text, {}], ...]
                        function(spec) {
                            return (Array.isArray(spec) ? spec[0] : spec) === child.type;
                        }) : true;
                    });
                    if (allowedSpecsForEntity.length) {
                        if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                        var maybeArray = (0, $cff1eaad54dae4e3$export$7b85fd78dd236198)(allowedSpecsForEntity[0]);
                        var allowedSpecsForChild = maybeArray.filter(function(item) {
                            return (Array.isArray(item) ? item[0] : item) === child.type;
                        });
                        if (allowedSpecsForChild.length === 0) return $7dc088a1efcddf18$var$invalidChildContent(child, errorCallback, validatorSpec);
                        /**
             * When there's multiple possible branches try all of them.
             * If all of them fails, throw the first one.
             * e.g.- [['text', { marks: ['a'] }], ['text', { marks: ['b'] }]]
             */ var firstError;
                        var firstChild;
                        for(var i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                            var allowedValueForCurrentSpec = [
                                allowedSpecsForChild[i]
                            ];
                            var _validateNode2 = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec), valid = _validateNode2.valid, _newChildEntity = _validateNode2.entity, _marksValidationOutput = _validateNode2.marksValidationOutput;
                            if (valid) {
                                var isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                var _validateChildMarks2 = validateChildMarks(_newChildEntity, _marksValidationOutput, errorCallback, isLastValidationSpec), marksAreValid = _validateChildMarks2.valid, _entity = _validateChildMarks2.entity;
                                var unsupportedMarks = _entity && _entity.marks && _entity.marks.filter(function(mark) {
                                    return mark.type === 'unsupportedMark';
                                }) || [];
                                if (marksAreValid && !unsupportedMarks.length) return _entity;
                                else firstChild = firstChild || _newChildEntity;
                            } else firstChild = firstChild || _newChildEntity;
                        } catch (error) {
                            firstError = firstError || error;
                        }
                        if (!errorCallback) throw firstError;
                        else return firstChild;
                    } else return $7dc088a1efcddf18$var$invalidChildContent(child, errorCallback, validatorSpec);
                };
                newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
            } else if (!contentValidatorSpec.optional) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'missing `content` prop')
            };
        }
        // Marks
        if (prevEntity.marks) {
            // An empty array on a node that only ever takes an empty array is dropped rather than
            // validated. Mark validation has nothing to reject in it, so it reports the node valid with an
            // empty `marksValidationOutput`, which reads to the parent's `validateChildMarks` as every
            // mark on the child having been rejected, and the candidate spec gets declined.
            if (acceptEmptyMarks && prevEntity.marks.length === 0 && declaresEmptyMarksOnly(spec)) {
                delete newEntity.marks;
                return specBasedValidationResult;
            }
            return {
                hasValidated: true,
                result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
            };
        }
        return specBasedValidationResult;
    }
}


var $deeb22b4f1f896f6$var$NATIVE_EMBED_EXTENSION_KEY = 'native-embed';
/**
 * Returns the set of parent node names whose content expression in the
 * supplied schema allows an `embedCard` child. Returns an empty set if the
 * schema does not declare an `embedCard` node.
 */ var $deeb22b4f1f896f6$var$getEmbedCardAllowedParentTypes = function getEmbedCardAllowedParentTypes(schema) {
    var embedCardType = schema.nodes.embedCard;
    if (!embedCardType) return new Set();
    var allowed = new Set();
    for(var _i = 0, _Object$values = Object.values(schema.nodes); _i < _Object$values.length; _i++){
        var _nodeType$contentMatc;
        var nodeType = _Object$values[_i];
        if ((_nodeType$contentMatc = nodeType.contentMatch) !== null && _nodeType$contentMatc !== void 0 && _nodeType$contentMatc.matchType(embedCardType)) allowed.add(nodeType.name);
    }
    return allowed;
};
var $deeb22b4f1f896f6$export$fdee1e5f1664414c = function nativeEmbedsFallbackTransform(adf, schema) {
    var embedCardAllowedParentTypes = $deeb22b4f1f896f6$var$getEmbedCardAllowedParentTypes(schema);
    var isEmbedCardAllowedInParent = function isEmbedCardAllowedInParent(parent) {
        var _parent$node;
        var parentType = parent === null || parent === void 0 || (_parent$node = parent.node) === null || _parent$node === void 0 ? void 0 : _parent$node.type;
        return parentType ? embedCardAllowedParentTypes.has(parentType) : false;
    };
    var didTransform = false;
    var transformedAdf = (0, $kbnxS.traverse)(adf, {
        extension: function extension(node, parent) {
            var _node$attrs, _node$attrs2;
            if (((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs['extensionKey'].split(':')[0]) !== $deeb22b4f1f896f6$var$NATIVE_EMBED_EXTENSION_KEY) return node;
            var url = (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 || (_node$attrs2 = _node$attrs2['parameters']) === null || _node$attrs2 === void 0 || (_node$attrs2 = _node$attrs2.macroParams) === null || _node$attrs2 === void 0 || (_node$attrs2 = _node$attrs2.url) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.value;
            if (!url) {
                didTransform = true;
                return false;
            }
            didTransform = true;
            if (isEmbedCardAllowedInParent(parent)) return {
                type: 'embedCard',
                attrs: {
                    url: url,
                    layout: 'center'
                }
            };
            return {
                type: 'paragraph',
                content: [
                    {
                        type: 'inlineCard',
                        attrs: {
                            url: url
                        }
                    }
                ]
            };
        }
    });
    if (didTransform && transformedAdf) try {
        var validate = (0, $7dc088a1efcddf18$export$956325f45c5d174a)();
        var _validate = validate(transformedAdf), valid = _validate.valid;
        if (!valid) // Transformed ADF is invalid – fall back to the original document
        return {
            transformedAdf: adf,
            hasValidTransform: false
        };
    } catch (_unused) {
        // Validation threw – fall back to the original document
        return {
            transformedAdf: adf,
            hasValidTransform: false
        };
    }
    return {
        transformedAdf: transformedAdf,
        hasValidTransform: didTransform
    };
};


var $25nEq = parcelRequire("25nEq");

var $jkJfI = parcelRequire("jkJfI");

var $kbnxS = parcelRequire("kbnxS");

var $25nEq = parcelRequire("25nEq");

var $kbnxS = parcelRequire("kbnxS");
function $6149ad09cd818609$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6149ad09cd818609$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6149ad09cd818609$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6149ad09cd818609$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// A Legacy Content Macro (LCM) is a Confluence macro stored as an ADF `extension`.
// Its handler renders an editable nested editor, so wrapping a table in an LCM keeps
// it visible/editable inside a plain `panel` (which permits `extension` children) —
// unlike `unsupportedBlock`, which only shows a placeholder.
// @see confluence/next/packages/experiment-legacy-content-macro
var $6149ad09cd818609$var$LCM_EXTENSION_TYPE = 'com.atlassian.confluence.migration';
var $6149ad09cd818609$var$LCM_EXTENSION_KEY = 'legacy-content';
var $6149ad09cd818609$var$PANEL_C1_FALLBACK_MARKER = '__platformEditorPanelC1Fallback';
// Parents a wrapped table may be restored into. A plain `panel` doesn't yet allow a
// `table`, but it's the pre-promotion wrapper this transform emits: the shared
// container transform restores the table here, then promotes `panel` -> `panel_c1`.
// Restricting to panel-family parents avoids unwrapping tables wrapped elsewhere.
var $6149ad09cd818609$var$TABLE_RESTORE_PARENT_TYPES = new Set([
    'panel',
    'panel_c1'
]);
var $6149ad09cd818609$var$safeParseAdf = function safeParseAdf(adf) {
    if (typeof adf !== 'string') return undefined;
    try {
        return JSON.parse(adf);
    } catch (_unused) {
        return undefined;
    }
};
var $6149ad09cd818609$var$wrapAsLcm = function wrapAsLcm(node) {
    var nestedContent = {
        version: 1,
        type: 'doc',
        content: [
            node
        ]
    };
    return {
        type: 'extension',
        attrs: {
            extensionType: $6149ad09cd818609$var$LCM_EXTENSION_TYPE,
            extensionKey: $6149ad09cd818609$var$LCM_EXTENSION_KEY,
            layout: 'default',
            parameters: (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
                nestedContent: nestedContent,
                adf: JSON.stringify(nestedContent)
            }, $6149ad09cd818609$var$PANEL_C1_FALLBACK_MARKER, true)
        }
    };
};
var $6149ad09cd818609$var$isLcm = function isLcm(node) {
    var _node$attrs, _node$attrs2, _node$attrs3;
    return node.type === 'extension' && ((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.extensionType) === $6149ad09cd818609$var$LCM_EXTENSION_TYPE && ((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.extensionKey) === $6149ad09cd818609$var$LCM_EXTENSION_KEY && ((_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 || (_node$attrs3 = _node$attrs3.parameters) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3[$6149ad09cd818609$var$PANEL_C1_FALLBACK_MARKER]) === true;
};
/** Single wrapped block from an LCM, preferring `nestedContent` then parsed `adf`. */ var $6149ad09cd818609$var$getLcmWrappedNode = function getLcmWrappedNode(node) {
    var _node$attrs4, _params$nestedContent, _nested$content;
    var params = (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.parameters;
    var nested = (_params$nestedContent = params === null || params === void 0 ? void 0 : params.nestedContent) !== null && _params$nestedContent !== void 0 ? _params$nestedContent : $6149ad09cd818609$var$safeParseAdf(params === null || params === void 0 ? void 0 : params.adf);
    return (nested === null || nested === void 0 || (_nested$content = nested.content) === null || _nested$content === void 0 ? void 0 : _nested$content.length) === 1 ? nested.content[0] : undefined;
};
var $6149ad09cd818609$var$wrappedNodeIsTable = function wrappedNodeIsTable(node) {
    var _getLcmWrappedNode, _node$attrs5;
    return $6149ad09cd818609$var$isLcm(node) && ((_getLcmWrappedNode = $6149ad09cd818609$var$getLcmWrappedNode(node)) === null || _getLcmWrappedNode === void 0 ? void 0 : _getLcmWrappedNode.type) === 'table' || node.type === 'unsupportedBlock' && ((_node$attrs5 = node.attrs) === null || _node$attrs5 === void 0 || (_node$attrs5 = _node$attrs5.originalValue) === null || _node$attrs5 === void 0 ? void 0 : _node$attrs5.type) === 'table';
};
var $6149ad09cd818609$var$isTableInPanelSupported = function isTableInPanelSupported(schema) {
    var _schema$nodes = schema.nodes, table = _schema$nodes.table, panel_c1 = _schema$nodes.panel_c1;
    if (!table || !panel_c1) return false;
    return true;
};
var $6149ad09cd818609$export$9a4ff29f7abd9bcd = function panelC1FallbackTransform(schema, adf) {
    var isTransformed = false;
    var _schema$nodes2 = schema.nodes, extension = _schema$nodes2.extension, unsupportedBlock = _schema$nodes2.unsupportedBlock;
    var tableInPanelSupported = $6149ad09cd818609$var$isTableInPanelSupported(schema);
    var shouldDowngrade = !tableInPanelSupported;
    var shouldRestore = tableInPanelSupported;
    var _hasRelevantNode = function hasRelevantNode(node) {
        return shouldDowngrade && node.type === 'panel_c1' || shouldRestore && $6149ad09cd818609$var$wrappedNodeIsTable(node) || Array.isArray(node.content) && node.content.some(function(c) {
            return !!c && _hasRelevantNode(c);
        });
    };
    if (!_hasRelevantNode(adf)) return {
        isTransformed: isTransformed,
        transformedAdf: adf
    };
    // Prefer the LCM (visible/editable); fall back to a preserved-but-hidden unsupportedBlock.
    var wrapTable = function wrapTable(tableNode) {
        return extension ? $6149ad09cd818609$var$wrapAsLcm(tableNode) : unsupportedBlock.createChecked({
            originalValue: tableNode
        }).toJSON();
    };
    var downgradePanel = function downgradePanel(node) {
        if (!Array.isArray(node.content)) return node;
        var hasTableChild = node.content.some(function(child) {
            return (child === null || child === void 0 ? void 0 : child.type) === 'table';
        });
        if (hasTableChild && !extension && !unsupportedBlock) return node;
        var content = node.content.map(function(child) {
            if ((child === null || child === void 0 ? void 0 : child.type) === 'table') {
                isTransformed = true;
                return wrapTable(child);
            }
            return child;
        });
        isTransformed = true;
        return $6149ad09cd818609$var$_objectSpread($6149ad09cd818609$var$_objectSpread({}, node), {}, {
            type: 'panel',
            content: content
        });
    };
    var restoreWrappedTable = function restoreWrappedTable(node, parent) {
        var _parent$node$type, _parent$node, _node$attrs6;
        if (!$6149ad09cd818609$var$TABLE_RESTORE_PARENT_TYPES.has((_parent$node$type = parent === null || parent === void 0 || (_parent$node = parent.node) === null || _parent$node === void 0 ? void 0 : _parent$node.type) !== null && _parent$node$type !== void 0 ? _parent$node$type : '')) return node;
        var restored = $6149ad09cd818609$var$isLcm(node) ? $6149ad09cd818609$var$getLcmWrappedNode(node) : (_node$attrs6 = node.attrs) === null || _node$attrs6 === void 0 ? void 0 : _node$attrs6.originalValue;
        if ((restored === null || restored === void 0 ? void 0 : restored.type) === 'table') {
            isTransformed = true;
            return restored;
        }
        return node;
    };
    var transformedAdf = (0, $kbnxS.traverse)(adf, {
        // Unsupported schema: downgrade to a plain `panel`, wrapping table children.
        panel_c1: function panel_c1(node) {
            return shouldDowngrade ? downgradePanel(node) : node;
        },
        // Supported schema: restore tables wrapped as an LCM / unsupportedBlock.
        extension: function extension(node, parent) {
            return shouldRestore ? restoreWrappedTable(node, parent) : node;
        },
        unsupportedBlock: function unsupportedBlock(node, parent) {
            return shouldRestore ? restoreWrappedTable(node, parent) : node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};



var $25nEq = parcelRequire("25nEq");

var $kbnxS = parcelRequire("kbnxS");
function $31126eb22654c64b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $31126eb22654c64b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $31126eb22654c64b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $31126eb22654c64b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// A Legacy Content Macro (LCM) is a Confluence macro stored as an ADF `extension`.
// Its handler renders an editable nested editor, so wrapping an extended child (table,
// expand) in an LCM keeps it visible/editable inside a plain `panel` (which permits
// `extension` children) — unlike `unsupportedBlock`, which only shows a placeholder.
// @see confluence/next/packages/experiment-legacy-content-macro
var $31126eb22654c64b$var$LCM_EXTENSION_TYPE = 'com.atlassian.confluence.migration';
var $31126eb22654c64b$var$LCM_EXTENSION_KEY = 'legacy-content';
var $31126eb22654c64b$var$PANEL_C1_FALLBACK_MARKER = '__platformEditorPanelC1Fallback';
// Parents a wrapped child may be restored into. A plain `panel` doesn't yet allow the
// extended children, but it's the pre-promotion wrapper this transform emits: the shared
// container transform restores the child here, then promotes `panel` -> `panel_c1`.
// Restricting to panel-family parents avoids unwrapping children wrapped elsewhere.
var $31126eb22654c64b$var$RESTORE_PARENT_TYPES = new Set([
    'panel',
    'panel_c1'
]);
// The extended block children unlocked on `panel_c1` over successive nesting scenarios.
// Each is a plain-`panel`-incompatible child that must be LCM-wrapped when the schema
// doesn't support `panel_c1`, and restored when it does.
// - table  (platform_editor_nest_table_in_panel)
// - expand (platform_editor_nest_expand_in_panel)
var $31126eb22654c64b$var$PANEL_C1_EXTENDED_CHILD_TYPES = new Set([
    'table',
    'expand'
]);
var $31126eb22654c64b$var$safeParseAdf = function safeParseAdf(adf) {
    if (typeof adf !== 'string') return undefined;
    try {
        return JSON.parse(adf);
    } catch (_unused) {
        return undefined;
    }
};
var $31126eb22654c64b$var$wrapAsLcm = function wrapAsLcm(node) {
    var nestedContent = {
        version: 1,
        type: 'doc',
        content: [
            node
        ]
    };
    return {
        type: 'extension',
        attrs: {
            extensionType: $31126eb22654c64b$var$LCM_EXTENSION_TYPE,
            extensionKey: $31126eb22654c64b$var$LCM_EXTENSION_KEY,
            layout: 'default',
            parameters: (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
                nestedContent: nestedContent,
                adf: JSON.stringify(nestedContent)
            }, $31126eb22654c64b$var$PANEL_C1_FALLBACK_MARKER, true)
        }
    };
};
var $31126eb22654c64b$var$isLcm = function isLcm(node) {
    var _node$attrs, _node$attrs2, _node$attrs3;
    return node.type === 'extension' && ((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.extensionType) === $31126eb22654c64b$var$LCM_EXTENSION_TYPE && ((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.extensionKey) === $31126eb22654c64b$var$LCM_EXTENSION_KEY && ((_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 || (_node$attrs3 = _node$attrs3.parameters) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3[$31126eb22654c64b$var$PANEL_C1_FALLBACK_MARKER]) === true;
};
/** Single wrapped block from an LCM, preferring `nestedContent` then parsed `adf`. */ var $31126eb22654c64b$var$getLcmWrappedNode = function getLcmWrappedNode(node) {
    var _node$attrs4, _params$nestedContent, _nested$content;
    var params = (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.parameters;
    var nested = (_params$nestedContent = params === null || params === void 0 ? void 0 : params.nestedContent) !== null && _params$nestedContent !== void 0 ? _params$nestedContent : $31126eb22654c64b$var$safeParseAdf(params === null || params === void 0 ? void 0 : params.adf);
    return (nested === null || nested === void 0 || (_nested$content = nested.content) === null || _nested$content === void 0 ? void 0 : _nested$content.length) === 1 ? nested.content[0] : undefined;
};
// Type guard: true when the node is a defined extended child of panel_c1 (table, expand, ...).
// Narrows `node` to `ADFEntity` so callers can safely operate on it.
var $31126eb22654c64b$var$isExtendedChild = function isExtendedChild(node) {
    return !!(node !== null && node !== void 0 && node.type) && $31126eb22654c64b$var$PANEL_C1_EXTENDED_CHILD_TYPES.has(node.type);
};
var $31126eb22654c64b$var$wrappedNodeIsExtendedChild = function wrappedNodeIsExtendedChild(node) {
    var _node$attrs5;
    return $31126eb22654c64b$var$isLcm(node) && $31126eb22654c64b$var$isExtendedChild($31126eb22654c64b$var$getLcmWrappedNode(node)) || node.type === 'unsupportedBlock' && $31126eb22654c64b$var$isExtendedChild((_node$attrs5 = node.attrs) === null || _node$attrs5 === void 0 ? void 0 : _node$attrs5.originalValue);
};
var $31126eb22654c64b$var$isPanelC1Supported = function isPanelC1Supported(schema) {
    if (!schema.nodes.panel_c1) return false;
    // The schema must also declare at least one of the extended child node types, otherwise
    // there's nothing to wrap/restore.
    return Array.from($31126eb22654c64b$var$PANEL_C1_EXTENDED_CHILD_TYPES).some(function(type) {
        return !!schema.nodes[type];
    });
};
var $31126eb22654c64b$export$b8c073a615247b65 = function panelC1FallbackTransformV2(schema, adf) {
    var isTransformed = false;
    var _schema$nodes = schema.nodes, extension = _schema$nodes.extension, unsupportedBlock = _schema$nodes.unsupportedBlock;
    var panelC1Supported = $31126eb22654c64b$var$isPanelC1Supported(schema);
    var shouldDowngrade = !panelC1Supported;
    var shouldRestore = panelC1Supported;
    var _hasRelevantNode = function hasRelevantNode(node) {
        return shouldDowngrade && node.type === 'panel_c1' || shouldRestore && $31126eb22654c64b$var$wrappedNodeIsExtendedChild(node) || Array.isArray(node.content) && node.content.some(function(c) {
            return !!c && _hasRelevantNode(c);
        });
    };
    if (!_hasRelevantNode(adf)) return {
        isTransformed: isTransformed,
        transformedAdf: adf
    };
    // Prefer the LCM (visible/editable); fall back to a preserved-but-hidden unsupportedBlock.
    var wrapChild = function wrapChild(childNode) {
        return extension ? $31126eb22654c64b$var$wrapAsLcm(childNode) : unsupportedBlock.createChecked({
            originalValue: childNode
        }).toJSON();
    };
    var downgradePanel = function downgradePanel(node) {
        if (!Array.isArray(node.content)) return node;
        var hasExtendedChild = node.content.some(function(child) {
            return $31126eb22654c64b$var$isExtendedChild(child);
        });
        if (hasExtendedChild && !extension && !unsupportedBlock) return node;
        var content = node.content.map(function(child) {
            if ($31126eb22654c64b$var$isExtendedChild(child)) {
                isTransformed = true;
                return wrapChild(child);
            }
            return child;
        });
        isTransformed = true;
        return $31126eb22654c64b$var$_objectSpread($31126eb22654c64b$var$_objectSpread({}, node), {}, {
            type: 'panel',
            content: content
        });
    };
    var restoreWrappedChild = function restoreWrappedChild(node, parent) {
        var _parent$node$type, _parent$node, _node$attrs6;
        if (!$31126eb22654c64b$var$RESTORE_PARENT_TYPES.has((_parent$node$type = parent === null || parent === void 0 || (_parent$node = parent.node) === null || _parent$node === void 0 ? void 0 : _parent$node.type) !== null && _parent$node$type !== void 0 ? _parent$node$type : '')) return node;
        var restored = $31126eb22654c64b$var$isLcm(node) ? $31126eb22654c64b$var$getLcmWrappedNode(node) : (_node$attrs6 = node.attrs) === null || _node$attrs6 === void 0 ? void 0 : _node$attrs6.originalValue;
        if ($31126eb22654c64b$var$isExtendedChild(restored)) {
            isTransformed = true;
            return restored;
        }
        return node;
    };
    var transformedAdf = (0, $kbnxS.traverse)(adf, {
        // Unsupported schema: downgrade to a plain `panel`, wrapping extended children.
        panel_c1: function panel_c1(node) {
            return shouldDowngrade ? downgradePanel(node) : node;
        },
        // Supported schema: restore children wrapped as an LCM / unsupportedBlock.
        extension: function extension(node, parent) {
            return shouldRestore ? restoreWrappedChild(node, parent) : node;
        },
        unsupportedBlock: function unsupportedBlock(node, parent) {
            return shouldRestore ? restoreWrappedChild(node, parent) : node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};


function $2269441de86bea4c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2269441de86bea4c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2269441de86bea4c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2269441de86bea4c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * Returns the set of parent node names whose content expression in the
 * supplied schema allows a `panel_c1` child. Returns an empty set if the
 * schema does not declare a `panel_c1` node.
 */ var $2269441de86bea4c$var$getPanelC1AllowedParentTypes = function getPanelC1AllowedParentTypes(schema) {
    var panelC1Type = schema.nodes['panel_c1'];
    if (!panelC1Type) return new Set();
    var allowed = new Set();
    for(var _i = 0, _Object$values = Object.values(schema.nodes); _i < _Object$values.length; _i++){
        var _nodeType$contentMatc;
        var nodeType = _Object$values[_i];
        if ((_nodeType$contentMatc = nodeType.contentMatch) !== null && _nodeType$contentMatc !== void 0 && _nodeType$contentMatc.matchType(panelC1Type)) allowed.add(nodeType.name);
    }
    return allowed;
};
var $2269441de86bea4c$export$fe0c97d482910ea = function upgradeContainerNodes(adf, schema) {
    var panelC1AllowedParents = $2269441de86bea4c$var$getPanelC1AllowedParentTypes(schema);
    if (panelC1AllowedParents.size === 0) return {
        isTransformed: false,
        transformedAdf: adf
    };
    var isTransformed = false;
    var transformedAdf = (0, $kbnxS.traverse)(adf, {
        panel: function panel(node, parent) {
            var _parent$node;
            var parentType = (_parent$node = parent.node) === null || _parent$node === void 0 ? void 0 : _parent$node.type;
            if (parentType && panelC1AllowedParents.has(parentType)) {
                isTransformed = true;
                return $2269441de86bea4c$var$_objectSpread($2269441de86bea4c$var$_objectSpread({}, node), {}, {
                    type: 'panel_c1'
                });
            }
            return;
        }
    });
    return {
        isTransformed: isTransformed,
        transformedAdf: transformedAdf
    };
};
var $2269441de86bea4c$export$62836639b6ded12a = function transformContainerNodes(adf, schema) {
    var isTransformed = false;
    var transformedNodeTypes = new Set();
    var transformedAdf = adf;
    // Gate the generalised (table + expand + panel + blockquote + bodiedExtension) transform
    // behind the consolidated container-in-panel experiment; the in-production table-in-panel
    // path continues to use the deprecated table-only transform.
    var panelC1FallbackResult = (0, $jkJfI.isExperimentEnabled)('platform_editor_nest_container_in_panel') ? (0, $31126eb22654c64b$export$b8c073a615247b65)(schema, transformedAdf) : (0, $6149ad09cd818609$export$9a4ff29f7abd9bcd)(schema, transformedAdf);
    if (panelC1FallbackResult.isTransformed && panelC1FallbackResult.transformedAdf) {
        isTransformed = true;
        transformedNodeTypes.add('panel_c1');
        transformedAdf = panelC1FallbackResult.transformedAdf;
    }
    var promotionResult = $2269441de86bea4c$export$fe0c97d482910ea(transformedAdf, schema);
    if (promotionResult.isTransformed) {
        isTransformed = true;
        transformedNodeTypes.add('panel_c1');
    }
    return {
        transformedAdf: promotionResult.transformedAdf,
        isTransformed: isTransformed,
        transformedNodeTypes: Array.from(transformedNodeTypes)
    };
};


var $kbnxS = parcelRequire("kbnxS");
var $9f4415183ed6ce73$export$6528700f3fa2fe2a = function transformMediaLinkMarks(adf) {
    var isTransformed = false;
    var transformedAdf = (0, $kbnxS.traverse)(adf, {
        mediaSingle: function mediaSingle(node) {
            var _node$content$;
            if (!node.marks || !node.content || ((_node$content$ = node.content[0]) === null || _node$content$ === void 0 ? void 0 : _node$content$.type) !== 'media') return node;
            var linkMark = null;
            node.marks.forEach(function(mark, i) {
                if (mark.type === 'link') {
                    var _node$marks;
                    linkMark = mark;
                    (_node$marks = node.marks) === null || _node$marks === void 0 || _node$marks.splice(i, 1);
                    isTransformed = true;
                }
            });
            if (node.marks.length === 0) delete node.marks;
            if (linkMark) {
                var _mediaNode$marks;
                var mediaNode = node.content[0];
                // only add link mark if media node doesnt already have one
                if ((_mediaNode$marks = mediaNode.marks) !== null && _mediaNode$marks !== void 0 && _mediaNode$marks.every(function(mark) {
                    return mark.type !== 'link';
                })) mediaNode.marks.push(linkMark);
                else if (!mediaNode.marks) mediaNode.marks = [
                    linkMark
                ];
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};


var $jiQPK = parcelRequire("jiQPK");

var $jJH6F = parcelRequire("jJH6F");

var $fpooh = parcelRequire("fpooh");
var $25nEq = parcelRequire("25nEq");


var $jJH6F = parcelRequire("jJH6F");
var $25f76d4de44c0f34$export$3b94ef2190b2d585 = {
    FINAL: 'final',
    STAGE_0: 'stage0'
};



var $fpooh = parcelRequire("fpooh");
function $7bf2d70c55d3c3c3$export$87b732fa69cdf16e(originalValue) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'block';
    var unsupportedNodeType;
    switch(type){
        case 'inline':
            unsupportedNodeType = 'unsupportedInline';
            break;
        case 'mark':
            unsupportedNodeType = 'unsupportedMark';
            break;
        default:
            unsupportedNodeType = 'unsupportedBlock';
    }
    return {
        type: unsupportedNodeType,
        attrs: {
            originalValue: originalValue
        }
    };
}


function $0f386b4740d7d561$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0f386b4740d7d561$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0f386b4740d7d561$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0f386b4740d7d561$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0f386b4740d7d561$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
var $0f386b4740d7d561$var$errorCallbackFor = function errorCallbackFor(marks, validate, dispatchAnalyticsEvent, validationOverrides) {
    return function(entity, error, options) {
        return $0f386b4740d7d561$export$468b008419c9a974(entity, error, $0f386b4740d7d561$var$_objectSpread($0f386b4740d7d561$var$_objectSpread({}, options), {}, {
            allowNestedTables: validationOverrides === null || validationOverrides === void 0 ? void 0 : validationOverrides.allowNestedTables,
            allowTableInPanel: validationOverrides === null || validationOverrides === void 0 ? void 0 : validationOverrides.allowTableInPanel,
            allowContainerInPanel: validationOverrides === null || validationOverrides === void 0 ? void 0 : validationOverrides.allowContainerInPanel
        }), marks, validate, dispatchAnalyticsEvent);
    };
};
var $0f386b4740d7d561$export$468b008419c9a974 = function validationErrorHandler(entity, error, options, marks, validate, dispatchAnalyticsEvent) {
    if (entity && entity.type === $0f386b4740d7d561$export$8e7fd962b4d3895d) return entity;
    if (options.isMark) return (0, $7bf2d70c55d3c3c3$export$87b732fa69cdf16e)(error.meta, 'mark');
    if (options.isNodeAttribute) {
        var entityType = entity && entity.type ? entity.type : undefined;
        return {
            type: $0f386b4740d7d561$export$8e7fd962b4d3895d,
            attrs: {
                type: {
                    nodeType: entityType
                },
                unsupported: error.meta
            }
        };
    }
    if (entity && marks.indexOf(entity.type) > -1) return;
    /**
   * There's a inconsistency between ProseMirror and ADF.
   * `content` is actually optional in ProseMirror.
   * And, also empty `text` node is not valid.
   */ if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
        type: 'paragraph',
        content: []
    };
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: We can repair missing content like `panel` without a `paragraph`.
    if (error.code === 'INVALID_CONTENT_LENGTH') {
        if (error.meta && options.allowUnsupportedBlock && entity.content) return $0f386b4740d7d561$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
        else // Can't fix it by wrapping
        if (dispatchAnalyticsEvent) $0f386b4740d7d561$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    }
    // Nested tables don't actually exist in ADF. In ADF they are stored as an `extension` node with the nested table content serialized in a property of that extension.
    // Usually when we validate ADF we are validating this `extension` and then later transforming it into nested tables for usage by ProseMirror.
    // Under certain circumstances however, ADF validation is performed on this already transformed extension and since nested tables aren't allowed by ADF this
    // produces an error. For example, nested renderers in Confluence `bodiedExtension`'s. The nested renderer receives the already transformed nested tables that originated from the
    // `extension` node and validates it. This is invalid ADF so an error is thrown.
    // This override allows an exception to be made for nested tables in the validator in this circumstance.
    if (options.allowNestedTables) {
        var meta = error.meta;
        if (options.allowNestedTables && meta !== null && meta !== void 0 && meta.parentType && [
            'tableCell',
            'tableHeader'
        ].includes(meta === null || meta === void 0 ? void 0 : meta.parentType) && error.code === 'INVALID_CONTENT' && entity.type === 'table') return entity;
    }
    // panel_c1 is a ProseMirror-only variant: on save, expand-in-panel documents are stored as
    // plain ADF `panel` nodes containing an `expand`. The base validator-spec does not permit
    // `expand` inside `panel` (it's gated behind the consolidated container-in-panel experiment,
    // see `isPanelNestingContainerSupported`), so we suppress the INVALID_CONTENT error when
    // `allowContainerInPanel` is set.
    if (options.allowContainerInPanel) {
        var _meta = error.meta;
        if ((_meta === null || _meta === void 0 ? void 0 : _meta.parentType) === 'panel' && error.code === 'INVALID_CONTENT' && entity.type === 'expand') return entity;
    }
    if (options.allowUnsupportedBlock) return (0, $7bf2d70c55d3c3c3$export$87b732fa69cdf16e)(entity);
    if (options.allowUnsupportedInline) return (0, $7bf2d70c55d3c3c3$export$87b732fa69cdf16e)(entity, 'inline');
    if (dispatchAnalyticsEvent) $0f386b4740d7d561$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    return entity;
};
function $0f386b4740d7d561$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
    var meta = error.meta;
    if (meta.type === 'maximum') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    entity.content = entity.content.filter(function(x) {
        return !!x;
    }).map(function(child, index) {
        return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? (0, $7bf2d70c55d3c3c3$export$87b732fa69cdf16e)(child) : validate(child, $0f386b4740d7d561$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
    });
    if (meta.type === 'minimum') {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (entity.content.length === 0) return (0, $7bf2d70c55d3c3c3$export$87b732fa69cdf16e)(entity);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        entity.content = entity.content.filter(function(x) {
            return !!x;
        }).map(function(child) {
            return child.type !== 'unsupportedBlock' ? (0, $7bf2d70c55d3c3c3$export$87b732fa69cdf16e)(child) : child;
        });
    }
    return entity;
}
function $0f386b4740d7d561$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
    if (!dispatchAnalyticsEvent) return;
    (0, $fpooh.fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, $jJH6F.ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
        type: entity.type || '',
        ancestry: entity.ancestorHierarchy || '',
        parentType: entity.parentType || '',
        marks: entity.marks || [],
        attrs: entity.attrs || {}
    }, error.code);
}
var $0f386b4740d7d561$export$884cfad20dece33e = function validateADFEntity(schema, node, dispatchAnalyticsEvent, validationOverrides, adfStage) {
    var nodes = Object.keys(schema.nodes);
    var marks = Object.keys(schema.marks);
    // Full-ADF strictness is opt-in: only a caller that names `final` gets it, and omitting `adfStage`
    // keeps stage-0 specs acceptable. Strictness has to be asked for rather than defaulted into,
    // because a document holding a stage-0-only construct, such as a `layoutSection` with one column,
    // otherwise has that content wrapped as unsupported. Editors carry such constructs by design,
    // since the editor's own schema enables them, and renderers meet them in stored documents.
    var validate = (0, $7dc088a1efcddf18$export$956325f45c5d174a)(nodes, marks, {
        allowPrivateAttributes: true,
        stage0: adfStage !== (0, $25f76d4de44c0f34$export$3b94ef2190b2d585).FINAL
    });
    var emptyDoc = {
        type: 'doc',
        content: []
    };
    var _validate = validate(node, $0f386b4740d7d561$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent, validationOverrides)), _validate$entity = _validate.entity, entity = _validate$entity === void 0 ? emptyDoc : _validate$entity;
    return entity;
};



var $50U6m = parcelRequire("50U6m");

var $drUcN = parcelRequire("drUcN");

var $aP6HU = parcelRequire("aP6HU");

var $jJH6F = parcelRequire("jJH6F");

var $kbnxS = parcelRequire("kbnxS");
var $d9bbd3cccd3bbd25$export$6632e71a22d31bf1 = /*#__PURE__*/ function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
    return UNSUPPORTED_CONTENT_LEVEL_SEVERITY;
}({});


var $a2e71885271481cd$export$f9f8a29778652c3e = {
    DEGRADED: 10,
    BLOCKING: 25
};


var $89d8778c7b3d3918$var$buildUnsupportedContentLevelThresholds = function buildUnsupportedContentLevelThresholds(customThresholds) {
    return {
        degraded: (customThresholds === null || customThresholds === void 0 ? void 0 : customThresholds.degraded) || (0, $a2e71885271481cd$export$f9f8a29778652c3e).DEGRADED,
        blocking: (customThresholds === null || customThresholds === void 0 ? void 0 : customThresholds.blocking) || (0, $a2e71885271481cd$export$f9f8a29778652c3e).BLOCKING
    };
};
var $89d8778c7b3d3918$var$countSupportedUnsupportedNodes = function countSupportedUnsupportedNodes(validDocument) {
    var unsupportedNodes = 0;
    var supportedNodes = 0;
    var unsupportedNodeTypeCount = {};
    var unsupportedNodeTypes = [
        'unsupportedInline',
        'unsupportedBlock',
        'confluenceUnsupportedInline',
        'confluenceUnsupportedBlock'
    ];
    (0, $kbnxS.traverse)(validDocument, {
        any: function any(node) {
            if (unsupportedNodeTypes.includes(node.type)) {
                var _node$attrs;
                var originalNode = (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.originalValue;
                if (originalNode) // start an independent traversal for the purpose of counting
                // unsupported content nodes (with nested children contributing towards
                // that count)
                (0, $kbnxS.traverse)(originalNode, {
                    any: function any(unsupportedNode, parent) {
                        var _parent$parent$node$t, _parent$parent, _unsupportedNode$type, _unsupportedNodeTypeC;
                        unsupportedNodes++;
                        // Count the types of unsupported nodes
                        var parentType = (_parent$parent$node$t = (_parent$parent = parent.parent) === null || _parent$parent === void 0 || (_parent$parent = _parent$parent.node) === null || _parent$parent === void 0 ? void 0 : _parent$parent.type) !== null && _parent$parent$node$t !== void 0 ? _parent$parent$node$t : 'unknown';
                        var type = "".concat(parentType, "/").concat((_unsupportedNode$type = unsupportedNode === null || unsupportedNode === void 0 ? void 0 : unsupportedNode.type) !== null && _unsupportedNode$type !== void 0 ? _unsupportedNode$type : 'unknown');
                        unsupportedNodeTypeCount[type] = ((_unsupportedNodeTypeC = unsupportedNodeTypeCount === null || unsupportedNodeTypeCount === void 0 ? void 0 : unsupportedNodeTypeCount[type]) !== null && _unsupportedNodeTypeC !== void 0 ? _unsupportedNodeTypeC : 0) + 1;
                    }
                });
                // force the parent traversal (which is counting supported content nodes)
                // to skip traversal/counting of nested children of the unsupported nodes
                return false;
            } else supportedNodes++;
        }
    });
    return {
        unsupportedNodes: unsupportedNodes,
        supportedNodes: supportedNodes,
        unsupportedNodeTypeCount: unsupportedNodeTypeCount
    };
};
var $89d8778c7b3d3918$var$mapUnsupportedContentLevelToSeverity = function mapUnsupportedContentLevelToSeverity(unsupportedContentLevelPercent, thresholds) {
    if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return (0, $d9bbd3cccd3bbd25$export$6632e71a22d31bf1).DEGRADED;
    if (thresholds.blocking <= unsupportedContentLevelPercent) return (0, $d9bbd3cccd3bbd25$export$6632e71a22d31bf1).BLOCKING;
    return (0, $d9bbd3cccd3bbd25$export$6632e71a22d31bf1).NORMAL;
};
var $89d8778c7b3d3918$export$484b83e0462998d = function getUnsupportedContentLevelData(validDocument, customThresholds) {
    var _countSupportedUnsupp = $89d8778c7b3d3918$var$countSupportedUnsupportedNodes(validDocument), unsupportedNodes = _countSupportedUnsupp.unsupportedNodes, supportedNodes = _countSupportedUnsupp.supportedNodes, unsupportedNodeTypeCount = _countSupportedUnsupp.unsupportedNodeTypeCount;
    var thresholds = $89d8778c7b3d3918$var$buildUnsupportedContentLevelThresholds(customThresholds);
    var percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
    var severity = $89d8778c7b3d3918$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
    return {
        severity: severity,
        percentage: percentage,
        counts: {
            supportedNodes: supportedNodes,
            unsupportedNodes: unsupportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        }
    };
};



var $aP6HU = parcelRequire("aP6HU");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $588355632ca7aaa5$var$rendersMap = {};
var $588355632ca7aaa5$var$processLevelsAndTrack = function processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent) {
    try {
        var _getUnsupportedConten = (0, $89d8778c7b3d3918$export$484b83e0462998d)(item.doc, thresholds), severity = _getUnsupportedConten.severity, percentage = _getUnsupportedConten.percentage, _getUnsupportedConten2 = _getUnsupportedConten.counts, supportedNodes = _getUnsupportedConten2.supportedNodes, unsupportedNodes = _getUnsupportedConten2.unsupportedNodes, unsupportedNodeTypeCount = _getUnsupportedConten2.unsupportedNodeTypeCount;
        dispatchAnalyticsEvent({
            action: (0, $jJH6F.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
            actionSubject: (0, $jJH6F.ACTION_SUBJECT).RENDERER,
            attributes: {
                appearance: (0, $ee2b8b656f6cf8d3$export$be87849653b93e6b)(item.appearance),
                platform: (0, $aP6HU.PLATFORM).WEB,
                unsupportedContentLevelSeverity: severity,
                unsupportedContentLevelPercentage: percentage,
                unsupportedNodesCount: unsupportedNodes,
                supportedNodesCount: supportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            },
            eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL
        });
    } catch (err) {
        dispatchAnalyticsEvent({
            action: (0, $jJH6F.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
            actionSubject: (0, $jJH6F.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $aP6HU.PLATFORM).WEB,
                error: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL
        });
    }
};
var $588355632ca7aaa5$var$schedule = function schedule(fn) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn);
    else setTimeout(fn, 0);
};
var $588355632ca7aaa5$var$DEFAULT_SAMPLING_RATE = 100;
var $588355632ca7aaa5$export$a43de96edd8d0a0 = function trackUnsupportedContentLevels(item, trackingOptions, dispatchAnalyticsEvent) {
    var _item$appearance;
    var thresholds = trackingOptions.thresholds, samplingRates = trackingOptions.samplingRates;
    var appearance = (_item$appearance = item.appearance) !== null && _item$appearance !== void 0 ? _item$appearance : 'unknown';
    if (!$588355632ca7aaa5$var$rendersMap[appearance]) $588355632ca7aaa5$var$rendersMap[appearance] = new Set();
    // bail out if already processed a render from a given renderer instance
    var didProcessRenderer = $588355632ca7aaa5$var$rendersMap[appearance].has(item.rendererId);
    if (didProcessRenderer) return;
    // otherwise track the render
    $588355632ca7aaa5$var$rendersMap[appearance].add(item.rendererId);
    var sampleRate = samplingRates && samplingRates[appearance] || $588355632ca7aaa5$var$DEFAULT_SAMPLING_RATE;
    // sample from the first available tracked render
    if ($588355632ca7aaa5$var$rendersMap[appearance].size === 1) $588355632ca7aaa5$var$schedule(function() {
        return $588355632ca7aaa5$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent);
    });
    // cleanup/refresh tracked renders at the sampling rate
    if ($588355632ca7aaa5$var$rendersMap[appearance].size % sampleRate === 0) $588355632ca7aaa5$var$rendersMap[appearance] = new Set();
};


/* eslint-disable jsdoc/require-jsdoc */ 
var $kbnxS = parcelRequire("kbnxS");
function $b12b39e2ea6c10c3$export$533b26079ad0b4b(adf, callback, initial) {
    var result = initial;
    (0, $kbnxS.traverse)(adf, {
        any: function any(node) {
            result = callback(result, node);
        }
    });
    return result;
}


function $85fdf1d409f20456$export$1daf15cbaf649dad(adfDocument) {
    return (0, $b12b39e2ea6c10c3$export$533b26079ad0b4b)(adfDocument, function(acc, node) {
        acc[node.type] = (acc[node.type] || 0) + 1;
        return acc;
    }, {});
}


var $2071b3d80d22d00f$var$SUPPORTS_HIRES_TIMER_API = !!(typeof window !== 'undefined' && window.performance && performance.now);
var $2071b3d80d22d00f$var$withStopwatch = function withStopwatch(cb) {
    var startTime = $2071b3d80d22d00f$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    var output = cb();
    var endTime = $2071b3d80d22d00f$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    var time = endTime - startTime;
    return {
        output: output,
        time: time
    };
};
/** Schema-variant escape hatches handed to the ADF validator. */ var $2071b3d80d22d00f$var$_validation = function _validation(doc, schema, adfStage, dispatchAnalyticsEvent, skipValidation, validationOverrides) {
    // link mark on mediaSingle is deprecated, need to move link mark to child media node
    // https://product-fabric.atlassian.net/browse/ED-14043
    var _transformMediaLinkMa = (0, $9f4415183ed6ce73$export$6528700f3fa2fe2a)(doc), transformedAdf = _transformMediaLinkMa.transformedAdf, isTransformed = _transformMediaLinkMa.isTransformed;
    if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
        action: (0, $jJH6F.ACTION).MEDIA_LINK_TRANSFORMED,
        actionSubject: (0, $jJH6F.ACTION_SUBJECT).RENDERER,
        eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL
    });
    // Forward `adfStage` only when a caller names one. Omitting it keeps stage-0 specs acceptable,
    // which is what a renderer wants: stored documents can contain them, and wrapping such content
    // as unsupported is worse than rendering it. A caller that declares `final` asks for full-ADF
    // strictness and gets it.
    var result = skipValidation ? transformedAdf || doc : (0, $0f386b4740d7d561$export$884cfad20dece33e)(schema, transformedAdf || doc, dispatchAnalyticsEvent, validationOverrides, adfStage);
    // The spec validator can return the original root object when malformed JSON has no node type.
    // Reject it here, matching the legacy validator, before ProseMirror attempts to deserialize it.
    if (!result || typeof result.type !== 'string' || result.type.length === 0) return null;
    // ProseMirror always require a child under doc
    if (result.type === 'doc') {
        if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
            type: 'paragraph',
            content: []
        });
        // Just making sure doc is always valid
        if (!result.version) result.version = 1;
    }
    // Convert nested-table extensions into nested tables
    try {
        var _transformNestedTable = (0, $jiQPK.transformNestedTablesIncomingDocument)(result), _transformedAdf = _transformNestedTable.transformedAdf, _isTransformed = _transformNestedTable.isTransformed;
        if (_isTransformed) {
            dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
                action: (0, $jJH6F.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).RENDERER,
                eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL
            });
            result = _transformedAdf;
        }
    } catch (e) {
        dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
            action: (0, $jJH6F.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $jJH6F.ACTION_SUBJECT).RENDERER,
            eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $aP6HU.PLATFORM).WEB,
                errorStack: "".concat(e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined)
            }
        });
    }
    // Upgrade panel → panel_c1 where the schema allows it
    if (result && (0, $drUcN.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) try {
        var _transformContainerNo = (0, $2269441de86bea4c$export$62836639b6ded12a)(result, schema), _transformedAdf2 = _transformContainerNo.transformedAdf, _isTransformed2 = _transformContainerNo.isTransformed, transformedNodeTypes = _transformContainerNo.transformedNodeTypes;
        if (_isTransformed2 && _transformedAdf2) {
            dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
                action: (0, $jJH6F.ACTION).CONTAINER_NODE_TRANSFORMED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).RENDERER,
                eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    transformedNodeTypes: transformedNodeTypes
                }
            });
            result = _transformedAdf2;
        }
    } catch (e) {
        dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
            action: (0, $jJH6F.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $jJH6F.ACTION_SUBJECT).RENDERER,
            eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $aP6HU.PLATFORM).WEB,
                errorStack: "".concat(e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform panel to panel_c1' : undefined)
            }
        });
    }
    if (result && !(0, $drUcN.expValEquals)('cc-maui-experiment', 'isEnabled', true) && !(0, $50U6m.fg)('platform_native_embeds_rollout_non_maui_experience') && (0, $50U6m.fg)('platform_editor_native_embeds_fallback_transform')) {
        var _nativeEmbedsFallback = (0, $deeb22b4f1f896f6$export$fdee1e5f1664414c)(result, schema), _transformedAdf3 = _nativeEmbedsFallback.transformedAdf, hasValidTransform = _nativeEmbedsFallback.hasValidTransform;
        if (hasValidTransform && _transformedAdf3) {
            dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
                action: (0, $jJH6F.ACTION).NATIVE_EMBEDS_TRANSFORMED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).RENDERER,
                eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL
            });
            result = _transformedAdf3;
        }
    }
    return result;
};
var $2071b3d80d22d00f$var$memoValidation = (0, $cvlyC.default)($2071b3d80d22d00f$var$_validation, function(newArgs, lastArgs) {
    var _newArgs = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(newArgs, 6), newDoc = _newArgs[0], newSchema = _newArgs[1], newADFStage = _newArgs[2], /* ignoring dispatchAnalyticsEvent */ newSkipValidation = _newArgs[4], newValidationOverrides = _newArgs[5];
    var _lastArgs = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(lastArgs, 6), oldDoc = _lastArgs[0], oldSchema = _lastArgs[1], oldADFStage = _lastArgs[2], /* ignoring dispatchAnalyticsEvent */ oldSkipValidation = _lastArgs[4], oldValidationOverrides = _lastArgs[5];
    // `areDocsEqual` may stringify the whole document, so it goes last and only runs once everything
    // cheaper has matched.
    return newSchema === oldSchema && newADFStage === oldADFStage && newSkipValidation === oldSkipValidation && $2071b3d80d22d00f$var$areValidationOverridesEqual(newValidationOverrides, oldValidationOverrides) && $2071b3d80d22d00f$var$areDocsEqual(newDoc, oldDoc);
});
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $2071b3d80d22d00f$var$areDocsEqual = function areDocsEqual(docA, docB) {
    if (docA === docB) return true;
    if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
    // PMNode
    if (docA.type && docA.toJSON && docB.type && docB.toJSON) {
        // `Node.eq` compares markup and content directly; stringifying both `toJSON` trees gives the
        // same answer ~14x slower on a 5k-node document.
        if (typeof docA.eq === 'function' && typeof docB.eq === 'function') return docA.eq(docB);
        return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
    }
    // Object
    return JSON.stringify(docA) === JSON.stringify(docB);
};
/**
 * `Renderer` rebuilds this object in its render body, so a reference check never matches and the memo
 * re-validates (and re-transforms) an unchanged document every render. A flat bag of optional
 * booleans, so a shallow key/value comparison is exact and free next to what it protects.
 */ var $2071b3d80d22d00f$var$areValidationOverridesEqual = function areValidationOverridesEqual(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    var aEntries = Object.entries(a);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var bRecord = b;
    return aEntries.length === Object.keys(b).length && aEntries.every(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        return bRecord[key] === value;
    });
};
var $2071b3d80d22d00f$var$_serializeFragment = function _serializeFragment(serializer, doc) {
    return serializer.serializeFragment(doc.content);
};
var $2071b3d80d22d00f$var$memoSerializeFragment = (0, $cvlyC.default)($2071b3d80d22d00f$var$_serializeFragment, function(newArgs, lastArgs) {
    var _newArgs2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(newArgs, 2), newSerializer = _newArgs2[0], newDoc = _newArgs2[1];
    var _lastArgs2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(lastArgs, 2), oldSerializer = _lastArgs2[0], oldDoc = _lastArgs2[1];
    return newSerializer === oldSerializer && $2071b3d80d22d00f$var$areDocsEqual(newDoc, oldDoc);
});
var $2071b3d80d22d00f$var$_createNodeAndCheck = function _createNodeAndCheck(schema, doc, dispatchAnalyticsEvent) {
    var pmNode = schema.nodeFromJSON(doc);
    try {
        pmNode.check();
    } catch (err) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $jJH6F.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $jJH6F.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $aP6HU.PLATFORM).WEB,
                errorStack: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL
        });
    }
    return pmNode;
};
var $2071b3d80d22d00f$var$memoCreateNodeAndCheck = (0, $cvlyC.default)($2071b3d80d22d00f$var$_createNodeAndCheck, function(newArgs, lastArgs) {
    // ignore dispatchAnalyticsEvent
    var _newArgs3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(newArgs, 2), newSchema = _newArgs3[0], newDoc = _newArgs3[1];
    var _lastArgs3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(lastArgs, 2), oldSchema = _lastArgs3[0], oldDoc = _lastArgs3[1];
    return newSchema === oldSchema && $2071b3d80d22d00f$var$areDocsEqual(newDoc, oldDoc);
});
var $2071b3d80d22d00f$export$59a54f98b9753d5c = function renderDocument(doc, serializer) {
    var schema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $kYLlQ.defaultSchema);
    var adfStage = arguments.length > 3 ? arguments[3] : undefined;
    var rendererId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'noid';
    var dispatchAnalyticsEvent = arguments.length > 5 ? arguments[5] : undefined;
    var unsupportedContentLevelsTracking = arguments.length > 6 ? arguments[6] : undefined;
    var appearance = arguments.length > 7 ? arguments[7] : undefined;
    var includeNodesCountInStats = arguments.length > 8 ? arguments[8] : undefined;
    var skipValidation = arguments.length > 9 ? arguments[9] : undefined;
    var validationOverrides = arguments.length > 10 ? arguments[10] : undefined;
    var stat = {
        sanitizeTime: 0
    };
    var _withStopwatch = $2071b3d80d22d00f$var$withStopwatch(function() {
        return $2071b3d80d22d00f$var$memoValidation(doc, schema, adfStage, dispatchAnalyticsEvent, skipValidation, validationOverrides);
    }), validDoc = _withStopwatch.output, sanitizeTime = _withStopwatch.time;
    // save sanitize time to stats
    stat.sanitizeTime = sanitizeTime;
    if (!validDoc) return {
        stat: stat,
        result: null
    };
    var _withStopwatch2 = $2071b3d80d22d00f$var$withStopwatch(function() {
        return $2071b3d80d22d00f$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
    }), node = _withStopwatch2.output, buildTreeTime = _withStopwatch2.time;
    // save build tree time to stats
    stat.buildTreeTime = buildTreeTime;
    var _withStopwatch3 = $2071b3d80d22d00f$var$withStopwatch(function() {
        return $2071b3d80d22d00f$var$memoSerializeFragment(serializer, node);
    }), result = _withStopwatch3.output, serializeTime = _withStopwatch3.time;
    // save serialize tree time to stats
    stat.serializeTime = serializeTime;
    if (dispatchAnalyticsEvent) {
        (0, $fpooh.findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
        if (unsupportedContentLevelsTracking !== null && unsupportedContentLevelsTracking !== void 0 && unsupportedContentLevelsTracking.enabled) {
            var documentData = {
                doc: validDoc,
                appearance: appearance,
                rendererId: rendererId
            };
            (0, $588355632ca7aaa5$export$a43de96edd8d0a0)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
        }
    }
    if (includeNodesCountInStats) stat.nodesCount = (0, $85fdf1d409f20456$export$1daf15cbaf649dad)(doc);
    return {
        result: result,
        stat: stat,
        pmDoc: node
    };
};



var $gPdZj = parcelRequire("gPdZj");

var $aP6HU = parcelRequire("aP6HU");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $d0n7Z = parcelRequire("d0n7Z");

var $lknPo = parcelRequire("lknPo");

var $3cF57 = parcelRequire("3cF57");

var $jkJfI = parcelRequire("jkJfI");

var $50U6m = parcelRequire("50U6m");
var $cffc3bdc16b16678$var$getMediaClientConfigForRenderer = function getMediaClientConfigForRenderer(provider) {
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    return provider.viewAndUploadMediaClientConfig && (0, $50U6m.fg)('platform_media_video_captions') ? provider.viewAndUploadMediaClientConfig : provider.viewMediaClientConfig;
};
var $cffc3bdc16b16678$export$77218b6ff680865f = function EditorMediaClientProvider(_ref) {
    var children = _ref.children, ssr = _ref.ssr;
    var _useState = (0, $5FkrB.useState)(function() {
        return (0, $jkJfI.isExperimentEnabled)('platform_editor_media_reliability_enhancements') ? ssr === null || ssr === void 0 ? void 0 : ssr.config : undefined;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), mediaClientConfig = _useState2[0], setMediaClientConfig = _useState2[1];
    var providerFactory = (0, $d0n7Z.useProviderFactory)();
    var mediaProvider = (0, $d0n7Z.useProviderLayout)('mediaProvider');
    /**
   * Whether this renderer has its own media provider and should never inherit
   * the mediaClient from a parent renderer's context.
   *
   * We use providerFactory.hasProvider() rather and checking the mediaProvider
   * state value, because useProviderLayout subscribes via useLayoutEffect —
   * meaning mediaProvider state is always undefined on the first render, even
   * if the ProviderFactory already has a provider registered. This would cause
   * shouldSkipContext to be false on the first render, incorrectly allowing the
   * inner renderer to inherit the outer renderer's MediaClientContext (which
   * carries the wrong media token for this page).
   *
   * hasProvider() is synchronous and correct from render 1, closing that window.
   */ var shouldSkipContext = (0, $jkJfI.isExperimentEnabled)('platform_editor_media_reliability_enhancements') ? Boolean((ssr === null || ssr === void 0 ? void 0 : ssr.config) || providerFactory.hasProvider('mediaProvider') || mediaProvider) : Boolean((ssr === null || ssr === void 0 ? void 0 : ssr.config) || mediaProvider);
    var contextMediaClient = (0, $5FkrB.useContext)((0, $3cF57.MediaClientContext));
    // MediaClientProvider currently requires a mediaClientConfig
    // And inserting the MediaClientProvider will cause a re-render
    // We should use MediaClientProvider once it no longer requires a config
    var mediaClient = (0, $5FkrB.useMemo)(function() {
        return mediaClientConfig ? (0, $lknPo.getMediaClient)(mediaClientConfig) : undefined;
    }, [
        mediaClientConfig
    ]);
    // Consumers can override the mediaClient for renderer,
    // by not providing both SSR config and mediaProvider,
    // and provide a top level mediaClient context
    // This is useful for testing and creating examples.
    // When the experiment is enabled, use useEffect instead of useLayoutEffect because:
    // - For the ssr.config branch: useState is already initialised with ssr.config, so this
    //   effect is a no-op on first render — the "before paint" guarantee is irrelevant.
    // - For the mediaProvider branch: the actual work happens inside a Promise callback which
    //   resolves asynchronously, so it can never run before paint regardless of which hook
    //   schedules it — useLayoutEffect's guarantee is equally irrelevant here.
    // The legacy path keeps useLayoutEffect to preserve existing behaviour when the experiment is off.
    //
    // The two hooks below are mutually exclusive — only one runs per render — so there is no
    // actual chaining of state updates at runtime. The lint rule cannot statically prove this.
    (0, $5FkrB.useEffect)(function() {
        if (!(0, $jkJfI.isExperimentEnabled)('platform_editor_media_reliability_enhancements')) return;
        if (ssr !== null && ssr !== void 0 && ssr.config) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        setMediaClientConfig(ssr.config);
        else if (mediaProvider) {
            var cancelled = false;
            // Cancellation flag prevents setMediaClientConfig from being called after
            // unmount or when mediaProvider changes mid-flight (stale promise fix).
            // No .catch() is needed — the media provider is not expected to reject,
            // and a catch handler would be a no-op anyway.
            mediaProvider.then(function(provider) {
                if (!cancelled) setMediaClientConfig($cffc3bdc16b16678$var$getMediaClientConfigForRenderer(provider));
            });
            return function() {
                cancelled = true;
            };
        }
    }, [
        mediaProvider,
        ssr === null || ssr === void 0 ? void 0 : ssr.config
    ]);
    // Legacy path (experiment off): keep useLayoutEffect to preserve existing behaviour.
    // remove this when clean up platform_editor_media_reliability_enhancements
    (0, $5FkrB.useLayoutEffect)(function() {
        if ((0, $jkJfI.isExperimentEnabled)('platform_editor_media_reliability_enhancements')) return;
        if (ssr !== null && ssr !== void 0 && ssr.config) setMediaClientConfig(ssr.config);
        else if (mediaProvider) mediaProvider.then(function(provider) {
            setMediaClientConfig($cffc3bdc16b16678$var$getMediaClientConfigForRenderer(provider));
        });
    }, [
        mediaProvider,
        ssr === null || ssr === void 0 ? void 0 : ssr.config
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3cF57.MediaClientContext).Provider, {
        value: shouldSkipContext ? mediaClient : contextMediaClient
    }, children);
};




var $ky5Ao = parcelRequire("ky5Ao");

var $9F9pG = parcelRequire("9F9pG");

var $lVo0h = parcelRequire("lVo0h");

var $nOuq8 = parcelRequire("nOuq8");

var $9fs6o = parcelRequire("9fs6o");

var $5FkrB = parcelRequire("5FkrB");

var $lFhdZ = parcelRequire("lFhdZ");
var $509fb8fcbca1dd31$export$18a71eb9fe4307bc = 'block-';
var $509fb8fcbca1dd31$export$d7e471f6502a69e2 = function isBlockLinkHash(hash) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $509fb8fcbca1dd31$export$18a71eb9fe4307bc;
    if (!hash || !prefix) return false;
    // Match either UUID format (8-4-4-4-12) or short hex ID format (exactly 12 hex chars without dashes).
    // Ignored via go/ees019
    var uuidRegex = new RegExp("^#?".concat(prefix, "[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$"), 'iu');
    // Ignored via go/ees019
    var shortIdRegex = new RegExp("^#?".concat(prefix, "[0-9a-f]{12}$"), 'iu');
    return uuidRegex.test(hash) || shortIdRegex.test(hash);
};
var $509fb8fcbca1dd31$export$c95c8d5e0fd74b32 = function extractBlockIdFromLinkHash(hash) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $509fb8fcbca1dd31$export$18a71eb9fe4307bc;
    if (!$509fb8fcbca1dd31$export$d7e471f6502a69e2(hash, prefix)) return null;
    // Remove leading # if present, then remove the prefix.
    var normalized = hash.startsWith('#') ? hash.slice(1) : hash;
    return normalized.slice(prefix.length);
};
var $509fb8fcbca1dd31$export$7d28ccc9eddf2197 = function createBlockLinkHashValue(blockId) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $509fb8fcbca1dd31$export$18a71eb9fe4307bc;
    return "".concat(prefix).concat(blockId);
};


var $fC8ib = parcelRequire("fC8ib");
/**
 * Expand a collapsed expand node by clicking its toggle button.
 *
 * This function finds the toggle button with aria-expanded="false" and programmatically
 * clicks it to expand the node. It does not wait for the expansion to complete.
 *
 * @param expandContainer - The expand container element.
 * @returns True if the toggle button was found and clicked, false otherwise.
 */ var $8f712c403e1fdd6c$export$280ec17414a50cdd = function expandElement(expandContainer) {
    // Find and click the toggle button
    var toggleButton = expandContainer.querySelector('[aria-expanded="false"]');
    if (toggleButton && toggleButton instanceof HTMLElement) {
        toggleButton.click();
        return true;
    }
    return false;
};


/**
 * Check if an expand node is currently collapsed.
 *
 * Uses two methods to determine collapse state:
 * 1. First checks aria-expanded attribute on the toggle button (most reliable).
 * 2. Falls back to checking content div visibility via computed styles.
 *
 * @param expandContainer - The expand container element.
 * @returns True if the expand is collapsed, false if expanded or state cannot be determined.
 */ var $971d8b7f8da58fb1$export$785b8bfd794fa7b6 = function isExpandCollapsed(expandContainer) {
    // Check for aria-expanded attribute on the toggle button
    var toggleButton = expandContainer.querySelector('[aria-expanded]');
    if (toggleButton && toggleButton instanceof HTMLElement) return toggleButton.getAttribute('aria-expanded') === 'false';
    // Fallback: check if content div is hidden using the actual class name
    var contentDiv = expandContainer.querySelector('.ak-editor-expand__content');
    if (contentDiv && contentDiv instanceof HTMLElement) {
        var computedStyle = window.getComputedStyle(contentDiv);
        return computedStyle.display === 'none' || computedStyle.visibility === 'hidden' || Boolean(contentDiv.hidden);
    }
    return false;
};


/**
 * Timing constants for expand animation and DOM update delays.
 * These values are tuned for the expand component's behavior and React's update cycle.
 */ var $e14dea792ed1dd32$export$7f8747c9df4cadcb = {
    /** Minimal delay for DOM/React updates after expanding (no animation in expand component). */ DOM_UPDATE_DELAY: 50,
    /** Delay when expand operation fails and needs retry. */ RETRY_DELAY: 100,
    /** Maximum number of retry attempts before giving up and scrolling anyway. */ MAX_ATTEMPTS: 5,
    /** Maximum depth of nested expands to search (prevents infinite loops). */ MAX_EXPAND_DEPTH: 2
};



function $0420ab38d9c5ef6f$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $0420ab38d9c5ef6f$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $0420ab38d9c5ef6f$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $0420ab38d9c5ef6f$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $0420ab38d9c5ef6f$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $0420ab38d9c5ef6f$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $0420ab38d9c5ef6f$export$e070f925e0e65bbc(adfDoc, targetLocalId) {
    var result;
    /**
   * Recursive helper to traverse the ADF document and track expand ancestors.
   * We use recursion to properly maintain the expand ancestor stack.
   */ var _traverse = function traverse(node, expandAncestors) {
        var _node$attrs, _node$attrs2;
        // If we already found the target, stop traversing
        if (result) return false;
        // Check if this is the target node by localId
        if ((node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) === targetLocalId) {
            result = {
                expandParentLocalIds: (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(expandAncestors) // Copy the array
            };
            return false; // Stop traversing
        }
        // Check if this node is an expand or nestedExpand
        var isExpand = (node === null || node === void 0 ? void 0 : node.type) === 'expand' || (node === null || node === void 0 ? void 0 : node.type) === 'nestedExpand';
        var newExpandAncestors = isExpand && node !== null && node !== void 0 && (_node$attrs2 = node.attrs) !== null && _node$attrs2 !== void 0 && _node$attrs2.localId ? [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(expandAncestors), [
            node.attrs.localId
        ]) : expandAncestors;
        // Traverse children if they exist
        if (node !== null && node !== void 0 && node.content && Array.isArray(node.content)) {
            var _iterator = $0420ab38d9c5ef6f$var$_createForOfIteratorHelper(node.content), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var child = _step.value;
                    if (result || !child) break;
                    _traverse(child, newExpandAncestors);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
        return !result; // Continue if we haven't found it yet
    };
    // Start traversal from the root
    _traverse(adfDoc, []);
    return result;
}
var $0420ab38d9c5ef6f$export$4fc3b03d60a46096 = function findParentExpands(element) {
    var maxDepth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $e14dea792ed1dd32$export$7f8747c9df4cadcb).MAX_EXPAND_DEPTH;
    var expands = [];
    var currentElement = element;
    var depth = 0;
    while(currentElement && depth < maxDepth){
        // Look for expand container - handles both "expand" and "nestedExpand" types
        var expandContainer = currentElement.closest('[data-node-type="expand"], [data-node-type="nestedExpand"]');
        if (!expandContainer || expands.includes(expandContainer)) break;
        expands.push(expandContainer);
        currentElement = expandContainer.parentElement;
        depth++;
    }
    // Return in reverse order so we expand from outermost to innermost
    return expands.reverse();
};
/**
 * Expand all parent expands then scroll to the element.
 *
 * This is the main entry point for scrolling to elements that may be hidden inside collapsed expands.
 * It handles nested expands by expanding them one at a time from outermost to innermost,
 * waiting for DOM updates between each expansion.
 *
 * The function uses a recursive approach with retry logic to handle:
 * - Nested expands that need sequential expansion
 * - DOM updates that may take time to reflect
 * - Failed expand operations (e.g., if toggle button is temporarily unavailable)
 * - Disconnected elements (removed from DOM)
 *
 * After all parent expands are open (or max attempts reached), scrolls the element into view
 * with smooth behavior and centered in the viewport.
 *
 * @param element - The target element to scroll to.
 * @param attempt - Current attempt number (used internally for retry logic, starts at 0).
 * @returns A cleanup function that cancels any pending timeouts. Call this when the operation
 *          should be aborted (e.g., component unmount, navigation, or new scroll request).
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $0420ab38d9c5ef6f$export$9d8f3695c9ce7da0 = function expandAllParentsThenScroll(element) {
    var attempt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var scrollFn = arguments.length > 2 ? arguments[2] : undefined;
    var MAX_EXPAND_DEPTH = (0, $e14dea792ed1dd32$export$7f8747c9df4cadcb).MAX_EXPAND_DEPTH, MAX_ATTEMPTS = (0, $e14dea792ed1dd32$export$7f8747c9df4cadcb).MAX_ATTEMPTS, DOM_UPDATE_DELAY = (0, $e14dea792ed1dd32$export$7f8747c9df4cadcb).DOM_UPDATE_DELAY, RETRY_DELAY = (0, $e14dea792ed1dd32$export$7f8747c9df4cadcb).RETRY_DELAY;
    var doScroll = scrollFn !== null && scrollFn !== void 0 ? scrollFn : function(el) {
        return el.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    };
    // Store timeout ID and nested cleanup function so they can be cancelled.
    var timeoutId = null;
    var nestedCleanup = null;
    // Cleanup function that cancels pending timeout and any nested operations.
    var cleanup = function cleanup() {
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
        if (nestedCleanup) {
            nestedCleanup();
            nestedCleanup = null;
        }
    };
    // Guard against element being disconnected from DOM or exceeding max attempts.
    if (attempt >= MAX_ATTEMPTS || !element.isConnected) {
        // Max attempts reached or element disconnected, scroll anyway.
        if (element.isConnected) doScroll(element);
        return cleanup;
    }
    try {
        // Step 1: Find all parent expands (outermost to innermost).
        var parentExpands = $0420ab38d9c5ef6f$export$4fc3b03d60a46096(element, MAX_EXPAND_DEPTH);
        // Step 2: Find any collapsed expands (filter out disconnected elements).
        var collapsedExpands = parentExpands.filter(function(expandContainer) {
            return expandContainer.isConnected && (0, $971d8b7f8da58fb1$export$785b8bfd794fa7b6)(expandContainer);
        });
        if (collapsedExpands.length === 0) {
            // All expands are open (or there are no expands), scroll to element.
            doScroll(element);
            return cleanup;
        }
        // Step 3: Expand ONLY the outermost collapsed expand first.
        // This is critical for nested expands - we must expand parent before child.
        var outermostCollapsed = collapsedExpands[0];
        try {
            var expanded = (0, $8f712c403e1fdd6c$export$280ec17414a50cdd)(outermostCollapsed);
            if (expanded) // Successfully expanded, wait briefly for DOM update then recurse to handle any nested expands.
            // Note: There's no animation, but we need a minimal delay for DOM/React updates.
            timeoutId = setTimeout(function() {
                try {
                    // Verify element is still connected before proceeding.
                    if (!element.isConnected) return;
                    // Recurse to handle any nested collapsed expands or retry if still collapsed.
                    nestedCleanup = $0420ab38d9c5ef6f$export$9d8f3695c9ce7da0(element, attempt + 1, scrollFn);
                } catch (_unused) {
                    // Fallback to simple scroll on error.
                    if (element.isConnected) doScroll(element);
                }
            }, DOM_UPDATE_DELAY);
            else // Failed to expand, retry with longer delay.
            timeoutId = setTimeout(function() {
                if (element.isConnected) nestedCleanup = $0420ab38d9c5ef6f$export$9d8f3695c9ce7da0(element, attempt + 1, scrollFn);
            }, RETRY_DELAY);
        } catch (_unused2) {
            // Retry on error.
            timeoutId = setTimeout(function() {
                if (element.isConnected) nestedCleanup = $0420ab38d9c5ef6f$export$9d8f3695c9ce7da0(element, attempt + 1, scrollFn);
            }, RETRY_DELAY);
        }
    } catch (_unused3) {
        // Fallback to simple scroll on error.
        if (element.isConnected) doScroll(element);
    }
    return cleanup;
};

var $5b22c225ba147dbf$export$94a68fcf7c5634d2 = function getLocalIdSelector(localId, container) {
    // Check if the element with data-local-id exists
    var element = container.querySelector("[data-local-id=\"".concat(localId, "\"]"));
    if (element) return element;
    // Special case for decision lists and task lists which already have localId
    element = container.querySelector("[data-decision-list-local-id=\"".concat(localId, "\"]"));
    if (element) return element;
    element = container.querySelector("[data-task-list-local-id=\"".concat(localId, "\"]"));
    if (element) return element;
    // Special case for tables which use data-table-local-id
    element = container.querySelector("[data-table-local-id=\"".concat(localId, "\"]"));
    if (element) // return table wrapper instead of table div, so the height calculation is correct
    return element.parentElement;
    // Special case for extension, smart cards and media which use lowercase localid
    element = container.querySelector("[localid=\"".concat(localId, "\"]"));
    if (element) return element;
    return null;
};



var $5FkrB = parcelRequire("5FkrB");
var $0077a2ce3cdc58f3$export$3325eba9424d3c32 = function useStableScroll() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$stabilityWai = options.stabilityWaitTime, stabilityWaitTime = _options$stabilityWai === void 0 ? 200 : _options$stabilityWai, _options$maxStability = options.maxStabilityWaitTime, maxStabilityWaitTime = _options$maxStability === void 0 ? 10000 : _options$maxStability;
    var stabilityTimeoutRef = (0, $5FkrB.useRef)(null);
    var resizeObserverRef = (0, $5FkrB.useRef)(null);
    var lastStableTimeRef = (0, $5FkrB.useRef)(0);
    var onStableCallbackRef = (0, $5FkrB.useRef)(null);
    var cleanup = (0, $5FkrB.useCallback)(function() {
        if (stabilityTimeoutRef.current) {
            clearTimeout(stabilityTimeoutRef.current);
            stabilityTimeoutRef.current = null;
        }
        if (resizeObserverRef.current) {
            resizeObserverRef.current.disconnect();
            resizeObserverRef.current = null;
        }
        onStableCallbackRef.current = null;
        lastStableTimeRef.current = 0;
    }, []);
    var scheduleStabilityCheck = (0, $5FkrB.useCallback)(function() {
        // Clear any existing stability timeout.
        if (stabilityTimeoutRef.current) {
            clearTimeout(stabilityTimeoutRef.current);
            stabilityTimeoutRef.current = null;
        }
        // Check if we've exceeded the maximum stability wait time.
        var now = Date.now();
        if (lastStableTimeRef.current === 0) lastStableTimeRef.current = now;
        else if (now - lastStableTimeRef.current > maxStabilityWaitTime) {
            // We've waited too long for stability, call the callback now.
            if (onStableCallbackRef.current) {
                onStableCallbackRef.current();
                cleanup();
            }
            return;
        }
        // Set a timeout to call the callback after the stability wait time.
        stabilityTimeoutRef.current = setTimeout(function() {
            if (onStableCallbackRef.current) {
                onStableCallbackRef.current();
                cleanup();
            }
        }, stabilityWaitTime);
    }, [
        stabilityWaitTime,
        maxStabilityWaitTime,
        cleanup
    ]);
    var waitForStability = (0, $5FkrB.useCallback)(function(container, onStable) {
        // Clean up any existing observer
        cleanup();
        // Store the callback
        onStableCallbackRef.current = onStable;
        // Check if ResizeObserver is available
        if (typeof ResizeObserver === 'undefined') {
            // Fallback: just call the callback after the stability wait time
            stabilityTimeoutRef.current = setTimeout(function() {
                if (onStableCallbackRef.current) {
                    onStableCallbackRef.current();
                    cleanup();
                }
            }, stabilityWaitTime);
            return;
        }
        // Create a ResizeObserver to monitor the container for size changes.
        resizeObserverRef.current = new ResizeObserver(function() {
            // Container size changed, reset stability timer.
            scheduleStabilityCheck();
        });
        resizeObserverRef.current.observe(container);
        // Start the initial stability check
        scheduleStabilityCheck();
    }, [
        stabilityWaitTime,
        scheduleStabilityCheck,
        cleanup
    ]);
    return {
        waitForStability: waitForStability,
        cleanup: cleanup
    };
};


function $dea3a35de38d7103$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $dea3a35de38d7103$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $dea3a35de38d7103$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $dea3a35de38d7103$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $dea3a35de38d7103$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $dea3a35de38d7103$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $dea3a35de38d7103$export$81bdbc2b3f1c95ef = function useScrollToBlock(containerRef, adfDoc, scrollToBlock) {
    var _useStableScroll = (0, $0077a2ce3cdc58f3$export$3325eba9424d3c32)({
        stabilityWaitTime: 750,
        maxStabilityWaitTime: 10000
    }), waitForStability = _useStableScroll.waitForStability, cleanupStability = _useStableScroll.cleanup;
    (0, $5FkrB.useEffect)(function() {
        var _getDocument;
        // Only run in browser environment.
        if (typeof window === 'undefined' || !(containerRef !== null && containerRef !== void 0 && containerRef.current)) return;
        // Parse hash fragment for block ID (format: #block-{localId}).
        var hash = window.location.hash;
        var defaultPrefixWithHash = "#".concat((0, $509fb8fcbca1dd31$export$18a71eb9fe4307bc));
        var blockId = hash && hash.startsWith(defaultPrefixWithHash) ? hash.slice(defaultPrefixWithHash.length) : null;
        if (!blockId) return;
        var retryCount = 0;
        var maxRetries = 40;
        var retryInterval = 250;
        var intervalId = null;
        var hasScrolled = false;
        var cancelExpandAndScroll = null;
        var scrollToElement = function scrollToElement() {
            // Step 1: Search the ADF document for the node with the given blockId.
            // This works even if the node is hidden inside a collapsed expand.
            if (!adfDoc || !(containerRef !== null && containerRef !== void 0 && containerRef.current)) return false;
            var nodeWithExpandParents = (0, $0420ab38d9c5ef6f$export$e070f925e0e65bbc)(adfDoc, blockId);
            if (!nodeWithExpandParents) // Node not found in ADF document.
            return false;
            var expandParentLocalIds = nodeWithExpandParents.expandParentLocalIds;
            // Step 2: If the node has expand parents, we need to expand them first.
            if (expandParentLocalIds.length > 0) {
                // Find the expand elements in the DOM using their localIds.
                // Note: We need to expand from outermost to innermost.
                var allExpandsFound = true;
                var anyExpandsCollapsed = false;
                var _iterator = $dea3a35de38d7103$var$_createForOfIteratorHelper(expandParentLocalIds), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var expandLocalId = _step.value;
                        var expandContainer = containerRef.current.querySelector("[data-local-id=\"".concat(expandLocalId, "\"]"));
                        if (!expandContainer) {
                            // Expand not found in DOM yet (shouldn't happen but handle it).
                            allExpandsFound = false;
                            break;
                        }
                        // Check if this expand is collapsed.
                        if ((0, $971d8b7f8da58fb1$export$785b8bfd794fa7b6)(expandContainer)) {
                            anyExpandsCollapsed = true;
                            // Expand it.
                            (0, $8f712c403e1fdd6c$export$280ec17414a50cdd)(expandContainer);
                            // After expanding, we need to retry to handle nested expands.
                            // The DOM needs time to update.
                            return false; // Will retry after interval.
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                if (!allExpandsFound) // Retry later when expands are in DOM.
                return false;
                // All parent expands are now open (or we just expanded one and need to wait).
                if (anyExpandsCollapsed) // Just expanded something, wait for DOM update.
                return false;
            }
            // Step 3: Now the target element should be visible in the DOM, find it and scroll.
            var element = (0, $5b22c225ba147dbf$export$94a68fcf7c5634d2)(blockId, containerRef.current);
            if (!element) // Element still not in DOM, retry.
            return false;
            // Element found and all parent expands are open! Use the utility to scroll.
            // (This will handle any final edge cases and do the actual scrolling).
            // Capture cleanup function to cancel pending timeouts.
            cancelExpandAndScroll = (0, $0420ab38d9c5ef6f$export$9d8f3695c9ce7da0)(element, 0, function(el) {
                if (scrollToBlock) scrollToBlock(el);
                else el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            });
            return true;
        };
        var performScroll = function performScroll() {
            if (hasScrolled) return;
            // Try to scroll to element.
            if (scrollToElement()) {
                hasScrolled = true;
                cleanup();
            }
        };
        var attemptScroll = function attemptScroll() {
            retryCount++;
            // Try to find the element first.
            if (!adfDoc || !(containerRef !== null && containerRef !== void 0 && containerRef.current)) return false;
            var nodeWithExpandParents = (0, $0420ab38d9c5ef6f$export$e070f925e0e65bbc)(adfDoc, blockId);
            if (!nodeWithExpandParents) return false;
            var expandParentLocalIds = nodeWithExpandParents.expandParentLocalIds;
            // Check if all expands are expanded and element exists.
            var allReady = true;
            if (expandParentLocalIds.length > 0) {
                var _iterator2 = $dea3a35de38d7103$var$_createForOfIteratorHelper(expandParentLocalIds), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var expandLocalId = _step2.value;
                        var expandContainer = containerRef.current.querySelector("[data-local-id=\"".concat(expandLocalId, "\"]"));
                        if (!expandContainer) {
                            allReady = false;
                            break;
                        }
                        if ((0, $971d8b7f8da58fb1$export$785b8bfd794fa7b6)(expandContainer)) {
                            (0, $8f712c403e1fdd6c$export$280ec17414a50cdd)(expandContainer);
                            allReady = false;
                            break;
                        }
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
            }
            var element = (0, $5b22c225ba147dbf$export$94a68fcf7c5634d2)(blockId, containerRef.current);
            if (!element) allReady = false;
            // If everything is ready, start monitoring for stability.
            if (allReady) {
                if (intervalId) {
                    clearInterval(intervalId);
                    intervalId = null;
                }
                waitForStability(containerRef.current, performScroll);
                return true;
            }
            // Stop retrying if we've exceeded max retries.
            if (retryCount >= maxRetries) {
                cleanup();
                return false;
            }
            return false;
        };
        var cleanup = function cleanup() {
            if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
            }
            cleanupStability();
            // Cancel any pending expand and scroll operations.
            if (cancelExpandAndScroll) {
                cancelExpandAndScroll();
                cancelExpandAndScroll = null;
            }
        };
        // Try to scroll immediately.
        if (attemptScroll()) return cleanup;
        if (((_getDocument = (0, $lFhdZ.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.readyState) === 'complete') // Document is already ready, try a few more times with delays.
        // This handles cases where elements are added after document ready.
        intervalId = setInterval(function() {
            attemptScroll();
        }, retryInterval);
        else // Document not ready yet, wait for it and then retry.
        intervalId = setInterval(function() {
            var _getDocument2;
            if (((_getDocument2 = (0, $lFhdZ.getDocument)()) === null || _getDocument2 === void 0 ? void 0 : _getDocument2.readyState) === 'complete') attemptScroll();
            else if (retryCount >= maxRetries) cleanup();
            else retryCount++;
        }, retryInterval);
        // Cleanup function.
        return cleanup;
    // Intentionally not including adfDoc in the dependency array to avoid unnecessary re-renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        containerRef,
        waitForStability,
        cleanupStability,
        scrollToBlock
    ]);
};



var $lMzAH = parcelRequire("lMzAH");

var $4qXRD = parcelRequire("4qXRD");

var $fC8ib = parcelRequire("fC8ib");

var $jJH6F = parcelRequire("jJH6F");var $cde71ec685ce28c3$export$a8d23193462f2b63 = /*#__PURE__*/ function(PLATFORMS) {
    PLATFORMS["NATIVE"] = "mobileNative";
    PLATFORMS["HYBRID"] = "mobileHybrid";
    PLATFORMS["WEB"] = "web";
    return PLATFORMS;
}({});
var $cde71ec685ce28c3$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $cde71ec685ce28c3$export$57453495b81e2dde = /*#__PURE__*/ function(FULL_WIDTH_MODE) {
    FULL_WIDTH_MODE["FIXED_WIDTH"] = "fixedWidth";
    FULL_WIDTH_MODE["FULL_WIDTH"] = "fullWidth";
    return FULL_WIDTH_MODE;
}({});
var $cde71ec685ce28c3$export$60a219cfaef9722 = /*#__PURE__*/ function(BROWSER_FREEZE_INTERACTION_TYPE) {
    BROWSER_FREEZE_INTERACTION_TYPE["LOADING"] = "loading";
    BROWSER_FREEZE_INTERACTION_TYPE["TYPING"] = "typing";
    BROWSER_FREEZE_INTERACTION_TYPE["CLICKING"] = "clicking";
    BROWSER_FREEZE_INTERACTION_TYPE["PASTING"] = "pasting";
    return BROWSER_FREEZE_INTERACTION_TYPE;
}({}); /**
 * Fired when the runtime performance detector decides the device is struggling badly enough to
 * warrant limited mode.
 */ 

var $f850a3c9ea50a5db$export$1627223e090990cf = /*#__PURE__*/ function(TABLE_ACTION) {
    TABLE_ACTION["DELETED"] = "deleted";
    TABLE_ACTION["CLEARED"] = "cleared";
    TABLE_ACTION["COLLAPSED"] = "collapsed";
    TABLE_ACTION["MERGED"] = "merged";
    TABLE_ACTION["SPLIT"] = "split";
    TABLE_ACTION["COLORED"] = "colored";
    TABLE_ACTION["TOGGLED_HEADER_COLUMN"] = "toggledHeaderColumn";
    TABLE_ACTION["TOGGLED_HEADER_ROW"] = "toggledHeaderRow";
    TABLE_ACTION["TOGGLED_NUMBER_COLUMN"] = "toggledNumberColumn";
    TABLE_ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    TABLE_ACTION["CUT"] = "cut";
    TABLE_ACTION["COPIED"] = "copied";
    TABLE_ACTION["ADDED_ROW"] = "addedRow";
    TABLE_ACTION["ADDED_COLUMN"] = "addedColumn";
    TABLE_ACTION["DELETED_ROW"] = "deletedRow";
    TABLE_ACTION["DELETED_COLUMN"] = "deletedColumn";
    TABLE_ACTION["SORTED_COLUMN"] = "sortedColumn";
    TABLE_ACTION["REPLACED"] = "replaced";
    TABLE_ACTION["ATTEMPTED_TABLE_WIDTH_CHANGE"] = "attemptedTableWidthChange";
    TABLE_ACTION["DISTRIBUTED_COLUMNS_WIDTHS"] = "distributedColumnsWidths";
    TABLE_ACTION["FIXED"] = "fixed";
    TABLE_ACTION["RESIZED"] = "resized";
    TABLE_ACTION["RESIZE_PERF_SAMPLING"] = "resizePerfSampling";
    TABLE_ACTION["COLUMN_RESIZED"] = "columnResized";
    TABLE_ACTION["OVERFLOW_CHANGED"] = "overflowChanged";
    TABLE_ACTION["INITIAL_OVERFLOW_CAPTURED"] = "initialOverflowCaptured";
    TABLE_ACTION["MOVED_ROW"] = "movedRow";
    TABLE_ACTION["MOVED_COLUMN"] = "movedColumn";
    TABLE_ACTION["CLONED_ROW"] = "clonedRow";
    TABLE_ACTION["CLONED_COLUMN"] = "clonedColumn";
    TABLE_ACTION["DRAG_MENU_OPENED"] = "dragMenuOpened";
    /**
   * This is a unique action that's used to track legacy table move behaviour flow of insert+copy+paste. Please use
   * the MOVED_ROW | MOVED_COLUMN actions if you want to track events which move row/cols in a single step.
   */ TABLE_ACTION["ROW_OR_COLUMN_MOVED"] = "rowOrColumnMoved";
    TABLE_ACTION["CHANGED_DISPLAY_MODE"] = "changedDisplayMode";
    TABLE_ACTION["CHANGED_ALIGNMENT"] = "changedAlignment";
    TABLE_ACTION["CHANGED_CELL_VERTICAL_ALIGNMENT"] = "changedVerticalAlignment";
    // Temporary to track usage of CONFCLOUD-78239 bug
    TABLE_ACTION["TABLE_CELL_BACKGROUND_FIXED"] = "tableCellBackgroundFixed";
    TABLE_ACTION["TABLE_WIDTH_INFO"] = "tableWidthInformation";
    TABLE_ACTION["TABLE_EDITOR_HEIGHT_INFO"] = "tableEditorHeightInformation";
    TABLE_ACTION["TABLE_RENDERER_HEIGHT_INFO"] = "tableRendererHeightInformation";
    TABLE_ACTION["STICKY_HEADER_METHOD_TOGGLED"] = "stickyHeaderMethodToggled";
    TABLE_ACTION["FIT_TO_CONTENT_AUTO_CONVERTED"] = "fitToContentAutoConverted";
    TABLE_ACTION["FIT_TO_CONTENT_ON_DEMAND"] = "fitToContentOnDemand";
    return TABLE_ACTION;
}({});
var $f850a3c9ea50a5db$export$6b0804bad09b61c6 = /*#__PURE__*/ function(TABLE_BREAKOUT) {
    TABLE_BREAKOUT["WIDE"] = "wide";
    TABLE_BREAKOUT["FULL_WIDTH"] = "fullWidth";
    TABLE_BREAKOUT["NORMAL"] = "normal";
    return TABLE_BREAKOUT;
}({});
var $f850a3c9ea50a5db$export$e0b2ad636c1c8ab4 = /*#__PURE__*/ function(TABLE_OVERFLOW_CHANGE_TRIGGER) {
    TABLE_OVERFLOW_CHANGE_TRIGGER["EXTERNAL"] = "external";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ADDED_COLUMN"] = "addedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DELETED_COLUMN"] = "deletedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED_COLUMN"] = "resizedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ENABLED_NUMBERED_COLUMN"] = "enabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISABLED_NUMBERED_COLUMN"] = "disabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISTRIBUTED_COLUMNS"] = "distributedColumnsWidths";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED"] = "resizedTable";
    return TABLE_OVERFLOW_CHANGE_TRIGGER;
}({});
var $f850a3c9ea50a5db$export$90dde066fa32cf2f = /*#__PURE__*/ function(TABLE_STATUS) {
    TABLE_STATUS["SUCCESS"] = "success";
    TABLE_STATUS["CANCELLED"] = "cancelled";
    TABLE_STATUS["INVALID"] = "invalid";
    return TABLE_STATUS;
}({});
var $f850a3c9ea50a5db$export$a62a68f32aa71693 = /*#__PURE__*/ function(TABLE_DISPLAY_MODE) {
    TABLE_DISPLAY_MODE["FIXED"] = "fixed";
    TABLE_DISPLAY_MODE["DEFAULT"] = "default";
    TABLE_DISPLAY_MODE["INITIAL"] = "initial";
    return TABLE_DISPLAY_MODE;
}({});
var $f850a3c9ea50a5db$export$ba2dfc055a59d951 = /*#__PURE__*/ function(CHANGE_ALIGNMENT_REASON) {
    CHANGE_ALIGNMENT_REASON["TABLE_RESIZING"] = "tableResizing";
    CHANGE_ALIGNMENT_REASON["TABLE_COLUMN_RESIZED"] = "tableColumnResized";
    CHANGE_ALIGNMENT_REASON["EDITOR_APPEARANCE_CHANGED"] = "editorAppearanceChanged";
    CHANGE_ALIGNMENT_REASON["TOOLBAR_OPTION_CHANGED"] = "toolbarOptionChanged";
    return CHANGE_ALIGNMENT_REASON;
}({});



var $6daa18ee83e5c8bd$export$208d2421b73f3f86 = function getWidthInfoPayload(renderer) {
    var tablesInfo = [];
    var tableWrappers = renderer.querySelectorAll('.pm-table-wrapper');
    // only send the event if there are tables on the page
    if (tableWrappers.length === 0) return undefined;
    tableWrappers.forEach(function(tableWrapper) {
        var table = tableWrapper.querySelector(':scope > table');
        if (table) {
            var isNestedTable = Boolean(table.closest('td, th'));
            tablesInfo.push({
                tableWidth: table.scrollWidth,
                hasScrollbar: tableWrapper.clientWidth < table.scrollWidth,
                isNestedTable: isNestedTable
            });
        }
    });
    var maxTableWidth = Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(tablesInfo.map(function(table) {
        return table.tableWidth;
    })));
    var editorWidth = renderer.scrollWidth;
    return {
        action: (0, $f850a3c9ea50a5db$export$1627223e090990cf).TABLE_WIDTH_INFO,
        actionSubject: (0, $jJH6F.ACTION_SUBJECT).TABLE,
        attributes: {
            editorWidth: editorWidth,
            editorWidthBreakpoint: (0, $577d48613d9afb24$export$afdcbbd112676ca8)(editorWidth),
            tableWidthInfo: tablesInfo,
            maxTableWidthBreakpoint: (0, $577d48613d9afb24$export$afdcbbd112676ca8)(maxTableWidth),
            hasTableWiderThanEditor: maxTableWidth > editorWidth,
            hasTableWithScrollbar: tablesInfo.some(function(table) {
                return table.hasScrollbar;
            }),
            mode: (0, $cde71ec685ce28c3$export$e48589d9e4824227).RENDERER
        },
        eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL
    };
};
var $6daa18ee83e5c8bd$export$34e5b28c67455a81 = function getHeightInfoPayload(renderer) {
    var tablesInfo = [];
    var tableWrappers = renderer.querySelectorAll('.pm-table-wrapper');
    // only send the event if there are tables on the page
    if (tableWrappers.length === 0) return undefined;
    tableWrappers.forEach(function(tableWrapper) {
        var table = tableWrapper.querySelector(':scope > table');
        if (table) {
            var isNestedTable = Boolean(table.closest('td, th'));
            tablesInfo.push({
                tableHeight: table.scrollHeight,
                isNestedTable: isNestedTable
            });
        }
    });
    var maxTableHeight = Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(tablesInfo.map(function(table) {
        return table.tableHeight;
    })));
    /** NOTE: Renderer is not scrollable, so this height represents the height of the content */ var rendererClientHeight = renderer.clientHeight;
    var viewportHeight = window.innerHeight;
    if (!viewportHeight) return undefined;
    return {
        action: (0, $f850a3c9ea50a5db$export$1627223e090990cf).TABLE_RENDERER_HEIGHT_INFO,
        actionSubject: (0, $jJH6F.ACTION_SUBJECT).TABLE,
        attributes: {
            viewportHeight: viewportHeight,
            rendererHeight: rendererClientHeight,
            maxTableHeight: maxTableHeight,
            maxTableToViewportHeightRatio: maxTableHeight / viewportHeight,
            tableHeightInfo: tablesInfo
        },
        eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL
    };
};


/* eslint-disable jsdoc/require-jsdoc -- SSR inline script helpers */ 
var $5FkrB = parcelRequire("5FkrB");

var $2XMn4 = parcelRequire("2XMn4");

var $drUcN = parcelRequire("drUcN");

var $13ECD = parcelRequire("13ECD");
function $e2e772a0c175af19$export$cfc1361be0de4203(_ref) {
    var noOpSSRInlineScript = _ref.noOpSSRInlineScript;
    /**
   * Should only inline this script while SSR,
   * not needed on the client side.
   */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    var id = Math.floor(Math.random() * 9999990001) + 9999;
    var shouldSkipScript = {
        table: true
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("script", {
        "data-breakout-script-id": id,
        dangerouslySetInnerHTML: {
            __html: $e2e772a0c175af19$export$92859d13f30c883e(id, shouldSkipScript)
        },
        "data-testid": "breakout-ssr-inline-script"
    });
}
function $e2e772a0c175af19$export$92859d13f30c883e(id, shouldSkipScript) {
    var flags = {
        platform_editor_renderer_extension_width_fix: (0, $drUcN.expValEquals)('platform_editor_renderer_extension_width_fix', 'isEnabled', true)
    };
    return "(function(window){\nif(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) { return; }\n".concat($e2e772a0c175af19$export$47813c4121c8b4b3, ";\n(").concat($e2e772a0c175af19$var$applyBreakoutAfterSSR.toString(), ")(\"").concat(id, "\", breakoutConsts, ").concat(JSON.stringify(shouldSkipScript), ", ").concat(JSON.stringify(flags), ");\n})(window);\n");
}
var $e2e772a0c175af19$export$47813c4121c8b4b3 = "\n  var breakoutConsts = ".concat(JSON.stringify((0, $2XMn4.breakoutConsts)), ";\n  breakoutConsts.mapBreakpointToLayoutMaxWidth = ").concat((0, $2XMn4.breakoutConsts).mapBreakpointToLayoutMaxWidth.toString(), ";\n  breakoutConsts.getBreakpoint = ").concat((0, $2XMn4.breakoutConsts).getBreakpoint.toString(), ";\n  breakoutConsts.calcBreakoutWidth = ").concat((0, $2XMn4.breakoutConsts).calcBreakoutWidth.toString(), ";\n  breakoutConsts.calcLineLength = ").concat((0, $2XMn4.breakoutConsts).calcLineLength.toString(), ";\n  breakoutConsts.calcWideWidth = ").concat((0, $2XMn4.breakoutConsts).calcWideWidth.toString(), ";\n  breakoutConsts.FullPagePadding = ").concat((0, $13ECD.FullPagePadding).toString(), ";\n");
/**
 * WARNING: NO EXTERNAL FUNCTION CALL IN THIS FUNCTION
 * This function will be put to DOM as an inline script.
 * It can not have any external function dependency.
 * All required data must be passed in as serializable parameters.
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e2e772a0c175af19$var$applyBreakoutAfterSSR(id, breakoutConsts, shouldSkipBreakoutScript, flags) {
    var MEDIA_NODE_TYPE = 'mediaSingle';
    var WIDE_LAYOUT_MODES = [
        'full-width',
        'wide',
        'custom'
    ];
    function findUp(element, condition) {
        if (!element) return;
        while(element.parentElement){
            if (condition(element)) return element.parentElement;
            element = element.parentElement;
        }
    }
    var renderer = findUp(// eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- inline script runs in browser document context
    document.querySelector("[data-breakout-script-id=\"".concat(id, "\"]")), function(elem) {
        var _elem$parentElement;
        return !!((_elem$parentElement = elem.parentElement) !== null && _elem$parentElement !== void 0 && _elem$parentElement.classList.contains('ak-renderer-wrapper'));
    });
    if (!renderer) return;
    var observer = new MutationObserver(function(mutationsList) {
        mutationsList.forEach(function(item) {
            if (item.target.nodeType !== Node.ELEMENT_NODE) return;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (item.target.classList.contains('ak-renderer-document')) item.addedNodes.forEach(function(maybeNode) {
                // maybeNode may contain comments which doesn't have a dataset property
                if (maybeNode.nodeType !== Node.ELEMENT_NODE) return;
                var width;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var node = maybeNode;
                var mode = node.dataset.mode || node.dataset.layout || '';
                var nodeType = node.dataset.nodeType;
                var widthType = node.dataset.widthType;
                var isMediaSingleWithPixelWidth = nodeType === 'mediaSingle' && widthType === 'pixel';
                var isExtension = nodeType === 'extension' || nodeType === 'bodiedExtension';
                if (!mode || !WIDE_LAYOUT_MODES.includes(mode) || // skip apply width styling to mediaSingle node with pixel width to avoid image size changing
                isMediaSingleWithPixelWidth || isExtension && flags['platform_editor_renderer_extension_width_fix']) return;
                // When flag is on we are using CSS to calculate the table width thus don't need logic below to set the width and left.
                if (shouldSkipBreakoutScript.table && node.classList.contains('pm-table-container')) return;
                if (node.classList.contains('fabric-editor-breakout-mark')) return;
                // use breakout script for all other types of nodes
                if (node.classList.contains('pm-table-container') && mode === 'custom') {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    var rendererWidth = renderer.offsetWidth;
                    var effectiveWidth = rendererWidth - breakoutConsts.padding;
                    width = "".concat(Math.min(parseInt(node.style.width), effectiveWidth), "px");
                } else // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                width = breakoutConsts.calcBreakoutWidth(breakoutConsts)(mode, renderer.offsetWidth);
                if (node.style.width === width) return;
                node.style.width = width;
                // Tables require some special logic, as they are not using common css transform approach,
                // because it breaks with sticky headers. This logic is copied from a table node:
                // https://bitbucket.org/atlassian/atlassian-frontend/src/77938aee0c140d02ff99b98a03849be1236865b4/packages/editor/renderer/src/react/nodes/table.tsx#table.tsx-235:245
                if (node.classList.contains('pm-table-container') && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                !renderer.classList.contains('is-full-width')) {
                    var lineLength = breakoutConsts.calcLineLength(breakoutConsts)();
                    var left = lineLength / 2 - parseInt(width) / 2;
                    if (left < 0 && parseInt(width) > lineLength) node.style.left = left + 'px';
                    else node.style.left = '';
                }
            });
            else if (/**
       * The mutation observer is only called once per added node.
       * The above condition only deals with direct children of <div class="ak-renderer-document" />
       * When it is initially called on the direct children, not all the sub children have loaded.
       * So nested media elements which are not immediately loaded as sub children are not available in the above conditional.
       * Thus adding this conditional to deal with all media elements directly.
       */ // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            item.target.dataset.nodeType === MEDIA_NODE_TYPE) // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            applyMediaBreakout(item.target, flags);
        });
    });
    var applyMediaBreakout = function applyMediaBreakout(card, flags) {
        // width was already set by another breakout script
        if (card.style.width) return;
        var tableParent = findUp(card, function(elem) {
            return elem instanceof HTMLTableCellElement;
        });
        // only apply the breakout to media elements not nested inside table
        // table sizing is not based on percentage width
        if (tableParent) return;
        var mode = card.dataset.mode || card.dataset.layout || '';
        var width = card.dataset.width;
        var isPixelBasedResizing = card.dataset.widthType === 'pixel';
        // Pixel based resizing has width set in pixels based on its width attribute
        // Thus, no need to override width
        if (isPixelBasedResizing) return;
        if (WIDE_LAYOUT_MODES.includes(mode)) card.style.width = '100%';
        else if (width) card.style.width = "".concat(width, "%");
    };
    observer.observe(renderer, {
        childList: true,
        subtree: true
    });
    /**
   * Using window load event to unsubscribe from mutation observer, as at this stage document is fully rendered.
   * Experiment with DOMContentLoaded showed that some of the blocks were not processed at all.
   * That's why window load is necessary.
   *
   * More info:
   * – https://html.spec.whatwg.org/multipage/parsing.html#the-end
   * – https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
   * – https://developer.mozilla.org/en-US/docs/Web/API/Document/DOMContentLoaded_event
   */ var _disconnect = function disconnect() {
        observer.disconnect();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('load', _disconnect);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('load', _disconnect);
}
var $e2e772a0c175af19$export$2a0b3eeee3f2ea40 = (0, $2XMn4.breakoutConsts).calcLineLength((0, $2XMn4.breakoutConsts));



var $a4VNM = parcelRequire("a4VNM");

var $eTqtO = parcelRequire("eTqtO");
function $06b5438107d56029$export$3dee5e4542c672d9(element) {
    if ('href' in element && element.href != null) return true;
    if (element.classList.contains((0, $eTqtO.mediaViewerPopupClass))) return true;
    if (element.classList.contains((0, $a4VNM.fileCardImageViewSelector))) return true;
    return false;
}




var $enqEB = parcelRequire("enqEB");

var $1LBcl = parcelRequire("1LBcl");
var $cc8a699f38d2ae23$export$8e2864079bc476bd = function getBaseFontSize(appearance, contentMode) {
    if (contentMode === 'compact') return 0, $1LBcl.akEditorFullPageDenseFontSize;
    return appearance && appearance !== 'comment' ? (0, $1LBcl.akEditorFullPageDefaultFontSize) : 14;
};



var $aOpeL = parcelRequire("aOpeL");

var $25nEq = parcelRequire("25nEq");
function $2cbb530e7605fa73$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2cbb530e7605fa73$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2cbb530e7605fa73$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2cbb530e7605fa73$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2cbb530e7605fa73$export$c94cfc0c675062a1 = function removeEmptySpaceAroundContent(document) {
    // Check if the document is valid
    if (!document || !document.content || !Array.isArray(document.content)) return document;
    // Check if the node is a meaningful content node meaning it is not an empty paragraph or a paragraph with only whitespace
    var isMeaningfulContentNode = function isMeaningfulContentNode(node) {
        // Check if the node is a non-empty paragraph or a non-paragraph node
        if (node.type !== 'paragraph') return true;
        // If the paragraph is empty, return false
        if (!node.content || node.content.length === 0) return false;
        // Check if paragraph has any content other than `hardBreak` or whitespace text nodes
        return node.content.some(function(child) {
            return !((child === null || child === void 0 ? void 0 : child.type) === 'hardBreak' || (child === null || child === void 0 ? void 0 : child.type) === 'text' && typeof child.text === 'string' && child.text.trim() === '');
        });
    };
    var content = document.content;
    var firstContentIndex = -1;
    var lastContentIndex = -1;
    // Find the first and last paragraphs with content and check if they are meaningful
    for(var i = 0; i < content.length; i++)if (isMeaningfulContentNode(content[i])) {
        if (firstContentIndex === -1) firstContentIndex = i;
        lastContentIndex = i;
    }
    // If no content was found, return an empty document
    if (firstContentIndex === -1) return $2cbb530e7605fa73$var$_objectSpread($2cbb530e7605fa73$var$_objectSpread({}, document), {}, {
        content: []
    });
    // Slice the content array to include only paragraphs between the first and last content
    var trimmedContent = content.slice(firstContentIndex, lastContentIndex + 1);
    // Return a new document with the trimmed content
    return $2cbb530e7605fa73$var$_objectSpread($2cbb530e7605fa73$var$_objectSpread({}, document), {}, {
        content: trimmedContent
    });
};



var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $gBea6 = parcelRequire("gBea6");

var $5MY3X = parcelRequire("5MY3X");

var $4vXmi = parcelRequire("4vXmi");

var $9DPK6 = parcelRequire("9DPK6");
var $8Upo7 = parcelRequire("8Upo7");
var $ab7eec81c4bc28d0$export$ee47248f9a998789 = {
    EMOJI_CONTAINER: 'emojiView-content-wrap',
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_NODE: (0, $8Upo7.emojiNodeStyles),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_SPRITE: (0, $8Upo7.emojiSprite),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_IMAGE: (0, $8Upo7.emojiImage),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_PLACEHOLDER: (0, $8Upo7.placeholder),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_UNICODE: 'emoji-common-emoji-unicode'
};



var $5qFVM = parcelRequire("5qFVM");

var $knSf2 = parcelRequire("knSf2");
var $hyfkz = parcelRequire("hyfkz");
var $14WDN = parcelRequire("14WDN");
var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $1LBcl = parcelRequire("1LBcl");
var $7269fd760c5a40ab$export$cfe6da7d522d87bb = 'rich-media-item';
var $7269fd760c5a40ab$var$wrappedMediaBreakoutPoint = 410;
var $7269fd760c5a40ab$export$d031611b96ba4cf0 = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "li .".concat($7269fd760c5a40ab$export$cfe6da7d522d87bb), {
    margin: 0
}), '&.ua-chrome li > .mediaSingleView-content-wrap::before', {
    content: "''",
    display: 'block',
    height: 0
}), '&.ua-firefox', {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.mediaSingleView-content-wrap': {
        userSelect: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.captionView-content-wrap': {
        userSelect: 'text'
    }
}), ".mediaSingleView-content-wrap[layout='center']", {
    clear: 'both'
}), "table .".concat($7269fd760c5a40ab$export$cfe6da7d522d87bb), {
    marginTop: "var(--ds-space-150, 12px)",
    marginBottom: "var(--ds-space-150, 12px)",
    clear: 'both',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
        clear: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: "var(--ds-space-150, 12px)"
        }
    }
}), ".".concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-right + .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-left"), {
    clear: 'both'
}), ".".concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-left + .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-right, .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-right + .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-left, .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-left + .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-left, .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-right + .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-right"), {
    marginRight: 0,
    marginLeft: 0
}), "@media all and (max-width: ".concat($7269fd760c5a40ab$var$wrappedMediaBreakoutPoint, "px)"), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
        float: 'none',
        overflow: 'auto',
        margin: "var(--ds-space-150, 12px)".concat(" 0")
    }
}));
var $7269fd760c5a40ab$export$b51dea84d928a378 = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "li .".concat($7269fd760c5a40ab$export$cfe6da7d522d87bb), {
    margin: 0
}), '&.ua-chrome li > .mediaSingleView-content-wrap::before', {
    content: "''",
    display: 'block',
    height: 0
}), '&.ua-firefox', {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.mediaSingleView-content-wrap': {
        userSelect: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.captionView-content-wrap': {
        userSelect: 'text'
    }
}), ".mediaSingleView-content-wrap[layout^='wrap-']", {
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    zIndex: (0, $1LBcl.akEditorWrappedNodeZIndex)
}), ".mediaSingleView-content-wrap[layout='center']", {
    clear: 'both'
}), "table .".concat($7269fd760c5a40ab$export$cfe6da7d522d87bb), {
    marginTop: "var(--ds-space-150, 12px)",
    marginBottom: "var(--ds-space-150, 12px)",
    clear: 'both',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
        clear: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: "var(--ds-space-150, 12px)"
        }
    }
}), ".".concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-right + .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-left"), {
    clear: 'both'
}), ".".concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-left + .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-right, .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-right + .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-left, .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-left + .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-left, .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-right + .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-right"), {
    marginRight: 0,
    marginLeft: 0
}), "@media all and (max-width: ".concat($7269fd760c5a40ab$var$wrappedMediaBreakoutPoint, "px)"), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
        float: 'none',
        overflow: 'auto',
        margin: "var(--ds-space-150, 12px)".concat(" 0")
    }
}));

// Constant variables here has been inlined in css from EditorContentContainer, if you need to make
// update here, please also update packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
var $23e6e5ff8dd7ee19$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};


var $fMtrl = parcelRequire("fMtrl");
var $7NyDw = parcelRequire("7NyDw");// Constant variables here has been inlined in css from EditorContentContainer, if you need to make
// update here, please also update packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
var $ff7834a81ceb151c$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    //NOTE: value is a selector (data attribute), not a class name
    TASK_LIST_CONTAINER: '[data-node-type="actionList"]',
    TASK_ITEM: 'task-item',
    TASK_CHECKBOX_CONTAINER: 'task-item-checkbox-wrap'
};



var $cFTJ2 = parcelRequire("cFTJ2");

var $4VBpm = parcelRequire("4VBpm");
/**
 * These styles are duplicated in packages/editor/editor-plugin-block-type/src/pm-plugins/ui/ToolbarBlockType/HeadingButton.tsx
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $789a6b614b844e25$export$63adc0ebe3278d31 = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body.small': 'normal 400 0.875em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};



var $c6bEO = parcelRequire("c6bEO");
var $fcr5B = parcelRequire("fcr5B");

var $1LBcl = parcelRequire("1LBcl");

var $jkJfI = parcelRequire("jkJfI");

var $50U6m = parcelRequire("50U6m");

var $j3BGx = parcelRequire("j3BGx");

var $drUcN = parcelRequire("drUcN");

var $eqmEx = parcelRequire("eqmEx");

var $53SBn = parcelRequire("53SBn");

var $7J4nJ = parcelRequire("7J4nJ");

var $fq8Dd = parcelRequire("fq8Dd");

var $8tCqL = parcelRequire("8tCqL");

var $ki7NT = parcelRequire("ki7NT");


var $13ECD = parcelRequire("13ECD");
var $df014fe6e70c2dc0$var$_css0, $df014fe6e70c2dc0$var$_$concat3, $df014fe6e70c2dc0$var$_$concat5;
var $df014fe6e70c2dc0$var$wrappedMediaBreakoutPoint = 410;
var $df014fe6e70c2dc0$var$TELEPOINTER_ID = 'ai-streaming-telepointer';
var $df014fe6e70c2dc0$var$tableShadowWidth = 32;
var $df014fe6e70c2dc0$var$LAYOUT_BREAKPOINT_RENDERER = 629;
var $df014fe6e70c2dc0$var$REMIX_BLOCK_HIGHLIGHT_CLASS_NAME = 'remix-block-highlight';
// originally defined from packages/editor/editor-plugin-table/src/ui/common-styles.ts
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: tableRowHeight can be moved into `@atlaskit/editor-common/table`
var $df014fe6e70c2dc0$var$tableRowHeight = 44;
var $df014fe6e70c2dc0$var$isBackgroundClipBrowserFixNeeded = function isBackgroundClipBrowserFixNeeded() {
    var browser = (0, $4vXmi.getBrowserInfo)();
    return browser.isGecko || browser.isIE || browser.isMac && browser.isChrome;
};
var $df014fe6e70c2dc0$var$baseFontStyle = (0, $74Zh5.css)({
    font: (0, $789a6b614b844e25$export$63adc0ebe3278d31)['editor.font.body']
});
var $df014fe6e70c2dc0$var$fontSizeStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.fabric-editor-font-size': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "&[data-font-size='small']": {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            font: 'var(--ak-renderer-editor-font-small-text)'
        }
    },
    // Apply font-size to the ::marker pseudo-element of list items that have a font-size mark.
    // Targeting ::marker directly avoids setting font on the <li> itself, which would cascade
    // into nested lists and compound the sizing at each nesting level.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    "li:has(> .fabric-editor-font-size[data-font-size='small'])::marker": {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: 'var(--ak-renderer-editor-font-small-text)'
    }
});
var $df014fe6e70c2dc0$var$originalBaseFontLineHeight = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '1.5rem'
});
// styles are copied from ./style.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage
var $df014fe6e70c2dc0$var$baseStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'var(--ak-renderer-base-font-size)',
    color: "var(--ds-text, #292A2E)",
    '--ak-editor--full-width-layout-width': "".concat((0, $1LBcl.akEditorFullWidthLayoutWidth), "px")
}, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, "::after"), {
    // we add a clearfix after ak-renderer-document in order to
    // contain internal floats (such as media images that are "wrap-left")
    // to just the renderer (and not spill outside of it)
    content: '""',
    visibility: 'hidden',
    display: 'block',
    height: 0,
    clear: 'both'
}), ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "> [".concat((0, $ki7NT.COLLAPSED_CONTENT_OWNERS_ATTRIBUTE), "][hidden='until-found']"), {
    display: 'block',
    // `hidden='until-found'` maps to `content-visibility: hidden`, which skips the element's
    // contents but keeps its own box, sized by its own specified sizes. Everything below
    // needs `!important` because extension nodes are sized and spaced by declarations that
    // would otherwise win: an inline `height`/`min-height` reserving macro height (see
    // `react/nodes/extension.tsx`), and `!important` alignment margins from
    // `@atlaskit/native-embeds-common`. Without it the collapsed section keeps a visible gap.
    blockSize: '0 !important',
    minBlockSize: '0 !important',
    marginBlock: '0 !important',
    paddingBlock: '0 !important',
    borderBlockWidth: '0 !important'
}), ".".concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME)), {
    height: '22px',
    transform: "translateY(-2px)"
}), "h1", (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "> .mediaInlineView-content-wrap > .".concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > :is(a, span[data-mark-type='border']) .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME)), {
    height: '36px',
    transform: "translateY(-3px)"
})), "h2", (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "> .mediaInlineView-content-wrap > .".concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > :is(a, span[data-mark-type='border']) .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME)), {
    height: '31px',
    transform: "translateY(-3px)"
})), "h3", (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "> .mediaInlineView-content-wrap > .".concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > :is(a, span[data-mark-type='border']) .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME)), {
    height: '25px',
    transform: "translateY(-2px)"
})), "h4", (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "> .mediaInlineView-content-wrap > .".concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > :is(a, span[data-mark-type='border']) .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME)), {
    height: '23px',
    transform: "translateY(-2px)"
})), "h5", (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "> .mediaInlineView-content-wrap > .".concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > :is(a, span[data-mark-type='border']) .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME)), {
    height: '20px',
    transform: "translateY(-2px)"
})), "h6", (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "> .mediaInlineView-content-wrap > .".concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > :is(a, span[data-mark-type='border']) .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME)), {
    height: '18px',
    transform: "translateY(-2px)"
}))), "& span.akActionMark", {
    color: "var(--ds-link, #1868DB)",
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)"
    }
}), '& span[data-placeholder]', {
    color: "var(--ds-text-subtlest, #6B6E76)"
}));
var $df014fe6e70c2dc0$var$headingAnchorStylesDuplicateAnchor = (0, $74Zh5.css)({
    '& h1, & h2, & h3, & h4, & h5, & h6': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        position: 'absolute',
        marginLeft: "var(--ds-space-075, 6px)",
        button: {
            paddingLeft: 0,
            paddingRight: 0
        },
        /**
     * Adds the visibility of the button when in focus through keyboard navigation.
     */ 'button:focus': {
            opacity: 1,
            transform: 'none !important'
        }
    }), "@media (hover: hover) and (pointer: fine)", (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        '> button': {
            opacity: 0,
            transform: 'translate(-8px, 0px)',
            transitionProperty: 'opacity, transform',
            transitionDuration: "var(--ds-duration-medium, 0.2s)".concat(", ", "var(--ds-duration-medium, 0.2s)"),
            transitionTimingFunction: "var(--ds-easing-out-practical, ease)".concat(", ", "var(--ds-easing-out-practical, ease)"),
            transitionDelay: '0s, 0s'
        }
    }), '&:hover', (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName), " > button"), {
        opacity: 1,
        transform: 'none !important'
    }))),
    '& h1': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: "".concat(28 / 24, "em")
    }),
    '& h2': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: "".concat(1.2, "em")
    }),
    '& h3': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: "".concat(1.25, "em")
    }),
    '& h4': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: "".concat(16 / 14, "em")
    }),
    '& h5': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: "".concat(16 / 12, "em")
    }),
    '& h6': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: "".concat(16 / 11, "em")
    })
});
var $df014fe6e70c2dc0$var$headingAnchorStyles = (0, $74Zh5.css)({
    '& .renderer-heading-wrapper': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        marginLeft: "var(--ds-space-075, 6px)",
        button: {
            paddingLeft: 0,
            paddingRight: 0
        },
        /**
     * Adds the visibility of the button when in focus through keyboard navigation.
     */ 'button:focus': {
            opacity: 1,
            transform: 'none !important'
        }
    }), "@media (hover: hover) and (pointer: fine)", (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        '> button': {
            opacity: 0,
            transform: "translate(-8px, 0px)",
            transition: "opacity 0.2s ease 0s, transform 0.2s ease 0s"
        }
    }), '&:hover', (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName), " > button"), {
        opacity: 1,
        transform: 'none !important'
    }))),
    // Line-height for heading anchor based on heading level (via data-level attribute on .renderer-heading-wrapper)
    '& .renderer-heading-wrapper[data-level="1"]': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: "".concat(28 / 24, "em")
    }),
    '& .renderer-heading-wrapper[data-level="2"]': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: "".concat(1.2, "em")
    }),
    '& .renderer-heading-wrapper[data-level="3"]': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: "".concat(1.25, "em")
    }),
    '& .renderer-heading-wrapper[data-level="4"]': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: "".concat(16 / 14, "em")
    }),
    '& .renderer-heading-wrapper[data-level="5"]': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: "".concat(16 / 12, "em")
    }),
    '& .renderer-heading-wrapper[data-level="6"]': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: "".concat(16 / 11, "em")
    })
});
var $df014fe6e70c2dc0$var$headingAnchorButtonFocusVisibleStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
    'button:focus-visible': {
        outline: "2px solid ".concat("var(--ds-border-focused, #4688EC)"),
        borderRadius: "var(--ds-radius-small, 3px)"
    }
}));
var $df014fe6e70c2dc0$var$akEditorBreakpointForSmallDevice = '1266px';
var $df014fe6e70c2dc0$var$responsiveBreakoutWidth = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    '--ak-editor--breakout-container-without-gutter-width': "calc(100cqw - ".concat((0, $1LBcl.akEditorGutterPadding), "px * 2)"),
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': "".concat((0, $1LBcl.akEditorCalculatedWideLayoutWidthSmallViewport), "px")
}, "@media (min-width: ".concat($df014fe6e70c2dc0$var$akEditorBreakpointForSmallDevice, ")"), {
    '--ak-editor--breakout-wide-layout-width': "".concat((0, $1LBcl.akEditorCalculatedWideLayoutWidth), "px")
}));
var $df014fe6e70c2dc0$var$responsiveBreakoutWidthFullWidth = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    '--ak-editor--breakout-container-without-gutter-width': '100cqw',
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': "".concat((0, $1LBcl.akEditorCalculatedWideLayoutWidthSmallViewport), "px")
}, "@media (min-width: ".concat($df014fe6e70c2dc0$var$akEditorBreakpointForSmallDevice, ")"), {
    '--ak-editor--breakout-wide-layout-width': "".concat((0, $1LBcl.akEditorCalculatedWideLayoutWidth), "px")
}));
var $df014fe6e70c2dc0$var$responsiveBreakoutWidthWithReducedPadding = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    '--ak-editor--breakout-container-without-gutter-width': "calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)",
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': "".concat((0, $1LBcl.akEditorCalculatedWideLayoutWidthSmallViewport), "px")
}, "@media (min-width: ".concat($df014fe6e70c2dc0$var$akEditorBreakpointForSmallDevice, ")"), {
    '--ak-editor--breakout-wide-layout-width': "".concat((0, $1LBcl.akEditorCalculatedWideLayoutWidth), "px")
}), "@media (max-width: ".concat((0, $1LBcl.akEditorFullPageNarrowBreakout), "px)"), {
    '--ak-editor--breakout-container-without-gutter-width': "calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)"
}));
var $df014fe6e70c2dc0$var$hideHeadingCopyLinkWrapperStylesDuplicateAnchor = (0, $74Zh5.css)({
    '& h1, & h2, & h3, & h4, & h5, & h6': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        '&:focus-within': {
            opacity: 1
        }
    }), "@media (hover: hover) and (pointer: fine)", (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        opacity: 0,
        transition: "opacity 0.2s ease 0s"
    }), '&:hover', (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        opacity: 1
    })))
});
var $df014fe6e70c2dc0$var$hideHeadingCopyLinkWrapperStyles = (0, $74Zh5.css)({
    '& .renderer-heading-wrapper': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        '&:focus-within': {
            opacity: 1
        }
    }), "@media (hover: hover) and (pointer: fine)", (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        opacity: 0,
        transition: "opacity 0.2s ease 0s"
    }), '&:hover', (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        opacity: 1
    })))
});
var $df014fe6e70c2dc0$var$rendererFullPageStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: "".concat((0, $1LBcl.akEditorDefaultLayoutWidth), "px"),
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: "0 ".concat((0, $13ECD.FullPagePadding), "px")
});
var $df014fe6e70c2dc0$var$rendererFullPageStylesWithReducedPadding = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    '--ak-renderer--full-page-gutter': "".concat((0, $13ECD.FullPagePadding), "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: "".concat((0, $1LBcl.akEditorDefaultLayoutWidth), "px"),
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: "0 var(--ak-renderer--full-page-gutter)"
}, "@media (max-width: ".concat((0, $1LBcl.akEditorFullPageNarrowBreakout), "px)"), {
    '--ak-renderer--full-page-gutter': "".concat((0, $1LBcl.akEditorGutterPaddingReduced), "px")
}));
var $df014fe6e70c2dc0$var$oldRendererFullWidthStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: "".concat((0, $1LBcl.akEditorFullWidthLayoutWidth), "px"),
    margin: "0 auto",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"]), .ak-renderer-extension': {
        width: '100% !important'
    }
});
var $df014fe6e70c2dc0$var$rendererFullWidthStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: "".concat((0, $1LBcl.akEditorFullWidthLayoutWidth), "px"),
    margin: "0 auto",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"])': {
        width: '100% !important'
    }
});
var $df014fe6e70c2dc0$var$oldRendererMaxWidthStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: "".concat((0, $1LBcl.akEditorMaxWidthLayoutWidth), "px"),
    margin: "0 auto",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"]), .ak-renderer-extension': {
        width: '100% !important'
    }
});
var $df014fe6e70c2dc0$var$rendererMaxWidthStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: "".concat((0, $1LBcl.akEditorMaxWidthLayoutWidth), "px"),
    margin: "0 auto",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"])': {
        width: '100% !important'
    }
});
var $df014fe6e70c2dc0$var$rendererFullWidthStylesForTableResizing = (0, $74Zh5.css)({
    '.pm-table-container': {
        width: '100% !important'
    }
});
var $df014fe6e70c2dc0$var$rovoTelepointerStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "#".concat($df014fe6e70c2dc0$var$TELEPOINTER_ID), {
    display: 'inline-block',
    position: 'relative',
    width: '1.5px',
    height: '24px',
    backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
    marginLeft: "var(--ds-space-025, 2px)",
    '&::after': {
        content: '""',
        position: 'absolute',
        display: 'block',
        top: 0,
        left: 0,
        width: '31.5px',
        height: '15.5px',
        borderRadius: "0px ".concat("var(--ds-space-050, 4px)", " ", "var(--ds-space-050, 4px)", " 0px"),
        background: // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/design-system/ensure-design-token-usage
        'linear-gradient(to right, #1868db 0px, #1868db 1.5px, transparent 1.5px) 0 0 / 100% 100% no-repeat, conic-gradient(from 270deg at 50% 50%, #1868db 0deg, #1868db 115deg, #fca700 115deg, #fca700 180deg, #bf63f3 180deg, #bf63f3 310deg, #82b536 310deg, #82b536 359.96deg, #1868db 360deg)'
    },
    '&::before': {
        content: '"Rovo"',
        position: 'absolute',
        fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-text, #292A2E)",
        top: 1,
        left: 1,
        borderRadius: "0px ".concat("var(--ds-space-050, 4px)", " ", "var(--ds-space-050, 4px)", " 0px"),
        zIndex: 1,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '10px',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        padding: '0.5px 2.5px',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 'initial'
    }
}));
var $df014fe6e70c2dc0$var$whitespaceSharedStyles = (0, $74Zh5.css)({
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap'
});
var $df014fe6e70c2dc0$var$blockquoteSharedStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: "var(--ds-border-width-selected, 2px)".concat(" solid ", "var(--ds-border, #0B120E24)"),
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: "".concat((0, $1LBcl.blockNodesVerticalMargin), " 0 0 0"),
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> .extensionView-content-wrap:last-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: 'block'
        }
    }
});
var $df014fe6e70c2dc0$var$headingsSharedStyles = (0, $74Zh5.css)({
    '& h1': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: "var(--ak-renderer-editor-font-heading-h1)",
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as the refreshed typography tokens use font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        },
        '&::before': {}
    },
    '& h2': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: "var(--ak-renderer-editor-font-heading-h2)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.4em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as the refreshed typography tokens use font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h3': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: "var(--ak-renderer-editor-font-heading-h3)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.31249em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as the refreshed typography tokens use font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h4': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: "var(--ak-renderer-editor-font-heading-h4)",
        marginTop: "var(--ds-space-250, 20px)",
        '& strong': {
            // set all heading bold style to token font.weight.bold, as the refreshed typography tokens use font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h5': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: "var(--ak-renderer-editor-font-heading-h5)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as the refreshed typography tokens use font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: "var(--ak-renderer-editor-font-heading-h6)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.59091em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as the refreshed typography tokens use font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    }
});
/**
 * When the copy-link a11y fix is enabled, the heading copy-link button is a sibling of the heading
 * text within `.renderer-heading-wrapper`. To ensure the button sits immediately after the last
 * rendered character (including when the heading wraps), the heading itself needs to participate in
 * inline layout.
 *
 * Since inline elements don't support vertical margins in normal flow, we migrate the UGC heading
 * `marginTop` values (from `headingsSharedStyles`) onto the wrapper.
 */ var $df014fe6e70c2dc0$var$headingWrapperInlineFlowStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    // Ensure heading and copy-link button participate in inline flow so the button sits after the final wrapped line of text.
    '& .renderer-heading-wrapper > h1, & .renderer-heading-wrapper > h2, & .renderer-heading-wrapper > h3, & .renderer-heading-wrapper > h4, & .renderer-heading-wrapper > h5, & .renderer-heading-wrapper > h6': {
        display: 'inline'
    }
}, "& .renderer-heading-wrapper > .".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
    display: 'inline',
    verticalAlign: 'baseline'
}), '& .renderer-heading-wrapper[data-level="1"]', {
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginTop: '1.45833em'
}), '& .renderer-heading-wrapper[data-level="2"]', {
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginTop: '1.4em'
}), '& .renderer-heading-wrapper[data-level="3"]', {
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginTop: '1.31249em'
}), '& .renderer-heading-wrapper[data-level="4"]', {
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginTop: '1.25em'
}), '& .renderer-heading-wrapper[data-level="5"]', {
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginTop: '1.45833em'
}), '& .renderer-heading-wrapper[data-level="6"]', {
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginTop: '1.59091em'
}));
var $df014fe6e70c2dc0$var$headingAnchorWrapperTargetSizeStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    '& .renderer-heading-wrapper > h1, & .renderer-heading-wrapper > h2, & .renderer-heading-wrapper > h3, & .renderer-heading-wrapper > h4, & .renderer-heading-wrapper > h5, & .renderer-heading-wrapper > h6': {
        verticalAlign: 'middle'
    }
}, "& .renderer-heading-wrapper > .".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    verticalAlign: 'middle'
}));
var $df014fe6e70c2dc0$var$headingWithAlignmentStylesDuplicateAnchor = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark.fabric-editor-alignment:not(:first-child)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> h1:first-child': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.667em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        ' > h2:first-child': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.8em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> h3:first-child': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '2em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> h4:first-child': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.357em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> h5:first-child': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.667em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> h6:first-child': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.455em'
        }
    },
    // Set marginTop: 0 if alignment block is next to a gap cursor or widget that is first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> :is(h1, h2, h3, h4, h5, h6):first-child': {
            marginTop: '0'
        }
    }
});
var $df014fe6e70c2dc0$var$headingWithAlignmentStyles = (0, $74Zh5.css)({
    // Center alignment for heading wrapper - flex container needs justify-content instead of text-align
    '.fabric-editor-block-mark[data-align="center"] > .renderer-heading-wrapper': {
        justifyContent: 'center'
    },
    // Right/end alignment for heading wrapper - flex container needs justify-content instead of text-align
    '.fabric-editor-block-mark[data-align="end"] > .renderer-heading-wrapper': {
        justifyContent: 'flex-end'
    },
    // Set marginTop: 0 if alignment block is next to a gap cursor or widget that is first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment': {
        // With inline headings, apply marginTop to the wrapper (not the h1-h6).
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .renderer-heading-wrapper:first-child': {
            marginTop: 0
        }
    }
});
var $df014fe6e70c2dc0$var$ruleSharedStyles = (0, $74Zh5.css)({
    '& hr': {
        border: 'none',
        backgroundColor: "var(--ds-border, #0B120E24)",
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: "".concat((0, $1LBcl.akEditorLineHeight), "em 0"),
        height: '2px',
        borderRadius: "var(--ds-radius-full, 9999px)"
    }
});
// When cleaning up `platform_editor_content_mode_button_mvp` simplify the name/ use the other paragraph style name
var $df014fe6e70c2dc0$var$paragraphSharedStylesWithEditorUGC = (0, $74Zh5.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: "var(--ak-renderer-editor-font-normal-text)",
        marginTop: (0, $1LBcl.blockNodesVerticalMargin),
        marginBottom: 0
    }
});
var $df014fe6e70c2dc0$var$paragraphStylesUGCScaledMargin = (0, $74Zh5.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: "var(--ak-renderer-editor-font-normal-text)",
        marginTop: (0, $1LBcl.scaledBlockNodesVerticalMargin),
        marginBottom: 0
    }
});
var $df014fe6e70c2dc0$var$listsSharedStyles = (0, $74Zh5.css)(($df014fe6e70c2dc0$var$_css0 = {
    /* =============== INDENTATION SPACING ========= */ 'ul, ol': {
        boxSizing: 'border-box',
        paddingLeft: "var(--ed--list--item-counter--padding, ".concat((0, $14WDN.listItemCounterPadding), "px)")
    }
}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($df014fe6e70c2dc0$var$_css0, "".concat((0, $5MY3X.orderedListSelector), ", ").concat((0, $gBea6.bulletListSelector)), {
    /*
  Ensures list item content adheres to the list's margin instead
  of filling the entire block row. This is important to allow
  clicking interactive elements which are floated next to a list.
  	For some history and context on this block, see PRs related to tickets.:
  @see ED-6551 - original issue.
  @see ED-7015 - follow up issue.
  @see ED-7447 - flow-root change.
  	used to have display: 'table' in tag template style but not supported in object styles
  removed display: 'table' as 'flow-root' is supported in latest browsers
  	@see https://css-tricks.com/display-flow-root/
  */ display: 'flow-root'
}), 'ul, ul ul ul ul', {
    listStyleType: 'disc'
}), 'ul ul, ul ul ul ul ul', {
    listStyleType: 'circle'
}), 'ul ul ul, ul ul ul ul ul ul', {
    listStyleType: 'square'
}), 'ol, ol ol ol ol', {
    listStyleType: 'decimal'
}), 'ol ol, ol ol ol ol ol', {
    listStyleType: 'lower-alpha'
}), 'ol ol ol, ol ol ol ol ol ol', {
    listStyleType: 'lower-roman'
}), 'ol[data-indent-level="1"], ol[data-indent-level="4"]', {
    listStyleType: 'decimal'
}), 'ol[data-indent-level="2"], ol[data-indent-level="5"]', {
    listStyleType: 'lower-alpha'
}), 'ol[data-indent-level="3"], ol[data-indent-level="6"]', {
    listStyleType: 'lower-roman'
}), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($df014fe6e70c2dc0$var$_css0, 'ul[data-indent-level="1"], ul[data-indent-level="4"]', {
    listStyleType: 'disc'
}), 'ul[data-indent-level="2"], ul[data-indent-level="5"]', {
    listStyleType: 'circle'
}), 'ul[data-indent-level="3"], ul[data-indent-level="6"]', {
    listStyleType: 'square'
})));
/*
	Firefox does not handle empty block element inside li tag.
	If there is not block element inside li tag,
	then firefox sets inherited height to li
	However, if there is any block element and if it's empty
	(or has empty inline element) then
	firefox sets li tag height to zero.
	More details at
	https://product-fabric.atlassian.net/wiki/spaces/~455502413/pages/3149365890/ED-14110+Investigation
*/ var $df014fe6e70c2dc0$var$listsSharedStylesForGekko = (0, $74Zh5.css)({
    'ul, ol': {
        'li p:empty, li p > span:empty': {
            display: 'inline-block'
        }
    }
});
/**
 * Hides list markers for "wrapper items" - list items that only contain nested lists with no other content.
 * These wrapper items have no meaningful content themselves, only nested lists below.
 */ var $df014fe6e70c2dc0$var$listItemHiddenMarkerStyles = (0, $74Zh5.css)({
    // Hide markers and remove spacing for wrapper list items (items containing only nested lists)
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    'li:has(> ul:only-child), li:has(> ol:only-child)': {
        listStyleType: 'none',
        marginTop: 0,
        marginBottom: 0
    },
    // Remove margin from nested lists inside wrapper list items to avoid double spacing
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    'li:has(> ul:only-child) > ul, li:has(> ol:only-child) > ol': {
        marginTop: 0
    },
    // Remove top margin from nested taskLists not preceded by a sibling taskItem
    'div[data-task-list-local-id] > div[data-task-list-local-id]': {
        marginTop: 0
    },
    // Restore margin when a nested taskList follows a taskItem
    'div[data-task-local-id] + div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-050, 4px)"
    }
});
var $df014fe6e70c2dc0$var$indentationSharedStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-editor-indentation-mark': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&[data-level='1']": {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '30px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&[data-level='2']": {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '60px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&[data-level='3']": {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '90px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&[data-level='4']": {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '120px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&[data-level='5']": {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '150px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&[data-level='6']": {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '180px'
        }
    }
});
var $df014fe6e70c2dc0$var$indentationSharedStylesWithMarginFix = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-editor-indentation-mark': {
        // Prevent marginTop of p:first-child overrode by batch.css
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        'p:first-child': {
            marginTop: (0, $1LBcl.blockNodesVerticalMargin)
        }
    }
});
var $df014fe6e70c2dc0$var$blockMarksSharedStylesDuplicateAnchor = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "*:not(.fabric-editor-block-mark) >,\n  \t*:not(.fabric-editor-block-mark) >\n    div.fabric-editor-block-mark:first-of-type\n\t:not(.fabric-editor-indentation-mark)\n\t:not(.fabric-editor-alignment),\n  \t.fabric-editor-alignment:first-of-type:first-child,\n  \t.fabric-editor-font-size:first-of-type:first-child,\n  \t.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child", {
    'p, h1, h2, h3, h4, h5, h6, .heading-wrapper': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        ':first-child:not(style), style:first-child + *': {
            marginTop: 0
        }
    }
}));
var $df014fe6e70c2dc0$var$blockMarksSharedStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "*:not(.fabric-editor-block-mark) >,\n  \t*:not(.fabric-editor-block-mark) >\n    div.fabric-editor-block-mark:first-of-type\n\t:not(.fabric-editor-indentation-mark)\n\t:not(.fabric-editor-alignment),\n  \t.fabric-editor-alignment:first-of-type:first-child,\n  \t.fabric-editor-font-size:first-of-type:first-child,\n  \t.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child", {
    'p, .heading-wrapper': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        ':first-child:not(style), style:first-child + *': {
            marginTop: 0
        }
    },
    '.renderer-heading-wrapper': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        ':first-child:not(style), style:first-child + *': {
            'h1, h2, h3, h4, h5, h6': {
                marginTop: 0
            }
        }
    }
}));
var $df014fe6e70c2dc0$var$codeMarkSharedStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.code': {
        '--ds--code--bg-color': "var(--ds-background-neutral, #0515240F)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        fontWeight: "var(--ds-font-weight-regular, 400)",
        backgroundColor: "var(--ds--code--bg-color,".concat("var(--ds-background-neutral, #0515240F)", ")"),
        color: "var(--ds-text, #292A2E)",
        borderStyle: 'none',
        borderRadius: "var(--ds-radius-small, 3px)",
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    }
});
var $df014fe6e70c2dc0$var$extensionStyle = (0, $74Zh5.css)({
    // Sets fontSize of extensions to match base font size which scales with the renderer contentMode prop
    // exceptions:
    // - nested renderers - bodied extensions have nested renderers adopt the contentMode prop themselves so should not be touched
    // - legacy status lozenge - some extensions use the .aui-lozenge class for a legacy status lozenge and is not designed to scale
    // - .ak-renderer-extension .ak-renderer-document .ak-renderer-extension:not(:has(.ak-renderer-document)) :not(.aui-lozenge, .status-lozenge-span *)
    //	 extensions inside extension documents (like ones with their own renderer) will need the font size to be applied again (e.g. TOC inside Excerpt, or TOC inside Page Properties inside LCM inside table)
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ak-renderer-extension :not(.ak-renderer-extension .ak-renderer-document *, .aui-lozenge, .status-lozenge-span *), .ak-renderer-extension .ak-renderer-document .ak-renderer-extension:not(:has(.ak-renderer-document)) :not(.aui-lozenge, .status-lozenge-span *)': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'var(--ak-renderer-base-font-size)'
    }
});
var $df014fe6e70c2dc0$var$oldExtensionAsInlineStyle = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " [data-as-inline=\"on\"]"), {
    display: 'inline-block'
}), ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " .").concat((0, $53SBn.RendererCssClassName).EXTENSION_AS_INLINE), {
    display: 'inline-block',
    // use !important here because the current width has !important applied to it and it's not working when used in React style prop
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    width: 'auto !important',
    marginTop: 0
}), ".".concat((0, $53SBn.RendererCssClassName).EXTENSION_AS_INLINE, " .").concat((0, $53SBn.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER), {
    display: 'inline-block',
    overflowX: 'visible',
    containerType: 'normal'
}), ".".concat((0, $53SBn.RendererCssClassName).EXTENSION_AS_INLINE, " .").concat((0, $53SBn.RendererCssClassName).EXTENSION_INNER_WRAPPER), {
    display: 'inline-block'
}));
var $df014fe6e70c2dc0$var$extensionAsInlineStyle = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " [data-as-inline=\"on\"]"), {
    display: 'inline-block'
}), ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " .").concat((0, $53SBn.RendererCssClassName).EXTENSION_AS_INLINE), {
    display: 'inline-block',
    width: 'auto',
    marginTop: 0
}), ".".concat((0, $53SBn.RendererCssClassName).EXTENSION_AS_INLINE, " .").concat((0, $53SBn.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER), {
    display: 'inline-block',
    overflowX: 'visible',
    containerType: 'normal'
}), ".".concat((0, $53SBn.RendererCssClassName).EXTENSION_AS_INLINE, " .").concat((0, $53SBn.RendererCssClassName).EXTENSION_INNER_WRAPPER), {
    display: 'inline-block'
}));
var $df014fe6e70c2dc0$var$migratedInlineBodiedFlowStyle = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, [
    ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " [data-migrated-inline] + [data-as-inline=\"on\"]"),
    ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " [data-as-inline=\"on\"]:has(+ [data-migrated-inline])")
].join(', '), {
    display: 'inline'
}));
var $df014fe6e70c2dc0$var$forgeInlineBodiedSpacingStyle = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " .").concat((0, $53SBn.RendererCssClassName).EXTENSION_AS_INLINE, "[data-forge-inline]"), {
    marginBottom: 0,
    verticalAlign: 'baseline',
    maxWidth: '100%'
}), [
    ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " [data-forge-inline] + [data-as-inline=\"on\"]"),
    ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " [data-as-inline=\"on\"]:has(+ [data-forge-inline])")
].join(', '), {
    display: 'inline'
}), ".".concat((0, $53SBn.RendererCssClassName).EXTENSION_AS_INLINE, "[data-forge-inline] *"), {
    maxWidth: '100%'
}), ".".concat((0, $53SBn.RendererCssClassName).EXTENSION_AS_INLINE, "[data-forge-inline] .").concat((0, $53SBn.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER), {
    overflowX: 'auto'
}), ".".concat((0, $53SBn.RendererCssClassName).EXTENSION_AS_INLINE, "[data-forge-inline] .").concat((0, $53SBn.RendererCssClassName).DOCUMENT, " > p"), {
    display: 'inline',
    margin: 0
}));
// Removes the blockNodesVerticalMargin styling for inline extensions, i.e. borderless excerpt-include
var $df014fe6e70c2dc0$var$inlineExtensionRendererMarginFix = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-renderer-document .inline-extension-renderer .ak-renderer-extension': {
        marginTop: 0
    }
});
var $df014fe6e70c2dc0$var$shadowSharedStyle = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "& .".concat((0, $c6bEO.shadowClassNames).RIGHT_SHADOW, "::before, .").concat((0, $c6bEO.shadowClassNames).RIGHT_SHADOW, "::after, .").concat((0, $c6bEO.shadowClassNames).LEFT_SHADOW, "::before, .").concat((0, $c6bEO.shadowClassNames).LEFT_SHADOW, "::after"), {
    display: 'none',
    position: 'absolute',
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $1LBcl.akEditorShadowZIndex),
    width: '8px',
    content: "''",
    height: 'calc(100%)'
}), "& .".concat((0, $c6bEO.shadowClassNames).RIGHT_SHADOW, ", .").concat((0, $c6bEO.shadowClassNames).LEFT_SHADOW), {
    position: 'relative'
}), "& .".concat((0, $c6bEO.shadowClassNames).LEFT_SHADOW, "::before"), {
    background: "linear-gradient( to left, transparent 0, ".concat("var(--ds-shadow-overflow-spread, #1E1F2129)", " 140% ), linear-gradient( to right, ", "var(--ds-shadow-overflow-perimeter, #1E1F211f)", " 0px, transparent 1px )"),
    top: '0px',
    left: 0,
    display: 'block'
}), "& .".concat((0, $c6bEO.shadowClassNames).RIGHT_SHADOW, "::after"), {
    background: "linear-gradient( to right, transparent 0, ".concat("var(--ds-shadow-overflow-spread, #1E1F2129)", " 140% ), linear-gradient( to left, ", "var(--ds-shadow-overflow-perimeter, #1E1F211f)", " 0px, transparent 1px )"),
    right: '0px',
    top: '0px',
    display: 'block'
}), "& .".concat((0, $fcr5B.shadowObserverClassNames).SENTINEL_LEFT), {
    height: '100%',
    width: '0px',
    minWidth: '0px'
}), "& .".concat((0, $fcr5B.shadowObserverClassNames).SENTINEL_RIGHT), {
    height: '100%',
    width: '0px',
    minWidth: '0px'
}));
var $df014fe6e70c2dc0$var$dateSharedStyle = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $hyfkz.DateSharedCssClassName).DATE_WRAPPER, " span"), {
    whiteSpace: 'unset'
}));
var $df014fe6e70c2dc0$var$textColorStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-text-color-mark': {
        color: 'var(--custom-palette-color, inherit)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    'a .fabric-text-color-mark': {
        color: 'unset'
    }
});
var $df014fe6e70c2dc0$var$backgroundColorStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-background-color-mark': {
        backgroundColor: 'var(--custom-palette-color, inherit)',
        borderRadius: "var(--ds-radius-xsmall, 2px)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        paddingTop: '1px',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        paddingBottom: '2px',
        boxDecorationBreak: 'clone'
    },
    // Don't show text highlight styling when there is an inline comment
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-background-color-mark .ak-editor-annotation': {
        backgroundColor: 'unset'
    }
});
// Don't show text highlight styling when there is a hyperlink.
// Conditionally applied when the highlight-on-links experiment is off.
var $df014fe6e70c2dc0$var$highlightLinksUnsetStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    'a .fabric-background-color-mark': {
        backgroundColor: 'unset'
    }
});
var $df014fe6e70c2dc0$export$a365082c2a191514 = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '.fabric-background-color-mark:has(.background-color-padding-left)': {
        paddingLeft: "var(--ds-space-025, 2px)",
        marginLeft: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '.fabric-background-color-mark:has(.background-color-padding-right)': {
        paddingRight: "var(--ds-space-025, 2px)",
        marginRight: "var(--ds-space-negative-025, -2px)"
    }
});
var $df014fe6e70c2dc0$var$tasksAndDecisionsStyles = (0, $74Zh5.css)({
    '.ProseMirror': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".taskItemView-content-wrap,\n\t\t.".concat((0, $ff7834a81ceb151c$export$a7172b75d403a0e4).DECISION_CONTAINER), {
        position: 'relative',
        minWidth: "".concat((0, $1LBcl.akEditorTableCellMinWidth), "px")
    }), ".".concat((0, $ff7834a81ceb151c$export$a7172b75d403a0e4).DECISION_CONTAINER), {
        marginTop: 0
    }), ".".concat((0, $ff7834a81ceb151c$export$a7172b75d403a0e4).TASK_CONTAINER), {
        'span[contenteditable="false"]': {
            height: "".concat((0, $1LBcl.akEditorLineHeight), "em")
        }
    }), ".".concat((0, $ff7834a81ceb151c$export$a7172b75d403a0e4).TASK_ITEM), {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: (0, $1LBcl.akEditorLineHeight)
    }),
    'div[data-task-local-id]': {
        'span[contenteditable="false"]': {
            height: "".concat((0, $1LBcl.akEditorLineHeight), "em")
        },
        'span[contenteditable="false"] + div': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: "".concat((0, $1LBcl.akEditorLineHeight), "em")
        }
    },
    'div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-150, 12px)",
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        // If task item is not first in the list then set margin top to 4px.
        'div + div': {
            marginTop: "var(--ds-space-050, 4px)"
        }
    },
    // If task list is not first in the document then set margin top to 4px.
    'div[data-task-list-local-id] div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-050, 4px)",
        marginLeft: "var(--ds-space-300, 24px)"
    },
    /* When action list is inside panel */ '.ak-editor-panel__content': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div[data-task-list-local-id]:first-child': {
            margin: '0 0 0 0 !important'
        }
    }
});
var $df014fe6e70c2dc0$var$headingPanelStyles = (0, $74Zh5.css)({
    // Removes the margin top from the first heading in a panel
    '.ak-editor-panel__content': {
        '> .renderer-heading-wrapper:first-child': {
            marginTop: 0
        }
    }
});
var $df014fe6e70c2dc0$var$smartCardStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $23e6e5ff8dd7ee19$export$4ccd31bf665a88f6).BLOCK_CARD_CONTAINER), {
    display: 'block',
    margin: "".concat((0, $1LBcl.blockNodesVerticalMargin), " 0 0"),
    maxWidth: "".concat(760, "px")
}));
var $df014fe6e70c2dc0$var$smartCardStylesAvatarFix = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $23e6e5ff8dd7ee19$export$4ccd31bf665a88f6).BLOCK_CARD_CONTAINER, ":not(.").concat((0, $23e6e5ff8dd7ee19$export$4ccd31bf665a88f6).DATASOURCE_CONTAINER, ")"), {
    /* EDM-11991: Fix list plugin adding padding to ADS AvatarGroup start */ 'ul, ol': {
        paddingLeft: 'inherit'
    }
}));
var $df014fe6e70c2dc0$var$smartCardStylesAvatarMarginFix = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $23e6e5ff8dd7ee19$export$4ccd31bf665a88f6).BLOCK_CARD_CONTAINER, ":not(.").concat((0, $23e6e5ff8dd7ee19$export$4ccd31bf665a88f6).DATASOURCE_CONTAINER, ")"), {
    'ul, ol': {
        marginRight: 'inherit'
    }
}));
var $df014fe6e70c2dc0$var$smartCardStylesAvatarListZeroMarginTop = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $23e6e5ff8dd7ee19$export$4ccd31bf665a88f6).BLOCK_CARD_CONTAINER, ":not(.").concat((0, $23e6e5ff8dd7ee19$export$4ccd31bf665a88f6).DATASOURCE_CONTAINER, ")"), {
    'ul, ol': {
        marginTop: 0
    }
}));
// In Renderer in Jira there is no SmartCardSharedCssClassName.INLINE_CARD_CONTAINER, so using data-inline-cart="true"
var $df014fe6e70c2dc0$var$headerSmartCardStyles = (0, $74Zh5.css)({
    '[data-inline-card="true"]': {
        '[data-inlinecard-button-overlay="icon-wrapper-line-height"] span': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 0
        }
    }
});
// Flex wrapper for centering without transform.
// flex: 1 1 0% + minWidth: 0 so the wrapper takes full width when it's a flex item (full-width nodes otherwise render narrow).
// flexShrink: 0 on child so the node keeps size.
var $df014fe6e70c2dc0$var$centerWrapperStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).FLEX_CENTER_WRAPPER), {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    width: '100%',
    flex: '1 1 0%',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& > *': {
        flexShrink: 0
    }
}));
// Reset only Expands with no preceding content sibling. Streaming SSR style/script siblings
// are ignored so moving them to the head on the client does not change the top margin.
var $df014fe6e70c2dc0$var$expandSsrMarginStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " .").concat((0, $53SBn.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER, " > [data-node-type='expand']:not(:not(style, script) ~ *)"), {
    marginTop: 0
}));
var $df014fe6e70c2dc0$var$baseOtherStylesDuplicateAnchor = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    '& .UnknownBlock': {
        fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: "".concat(0.875, "rem"),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    },
    '& span.date-node': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        borderRadius: "var(--ds-radius-small, 3px)",
        color: "var(--ds-text, #292A2E)",
        paddingTop: "var(--ds-space-025, 2px)",
        paddingRight: "var(--ds-space-050, 4px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: "var(--ds-space-050, 4px)",
        margin: "0 1px",
        transition: "background 0.3s"
    },
    '& span.date-node-highlighted': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        color: "var(--ds-text-danger, #AE2E24)"
    },
    '& .renderer-image': {
        maxWidth: '100%',
        display: 'block',
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: 0,
        marginBottom: "var(--ds-space-300, 24px)",
        marginLeft: 0
    }
}, ".".concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".rich-media-wrapped + .").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ":not(.rich-media-wrapped)"), {
    clear: 'both'
}), "& .code-block,\n\t& blockquote,\n\t& hr,\n\t& > div > div:not(.rich-media-wrapped),\n\t.".concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".rich-media-wrapped + .rich-media-wrapped + *:not(.rich-media-wrapped),\n\t.").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".rich-media-wrapped + div:not(.rich-media-wrapped),\n\t.").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-align-start,\n\t\t.").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-center,\n\t\t.").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-align-end"), {
    clear: 'both'
}), '& .rich-media-wrapped', {
    '& + .renderer-heading-wrapper': {
        'h1, h2, h3, h4, h5, h6': {
            marginTop: "var(--ds-space-100, 8px)"
        }
    }
}), 'div[class^="image-wrap-"] + div[class^="image-wrap-"]', {
    marginLeft: 0,
    marginRight: 0
}), ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " >"), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "*:not([data-mark-type='fragment']) .".concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER), {
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO - improve inline style logic on table container so important styles aren't required here
    width: '100% !important',
    left: '0 !important'
}), "[data-mark-type='fragment'] * .".concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER), {
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO - improve inline style logic on table container so important styles aren't required here
    width: '100% !important',
    left: '0 !important'
}), "* .".concat((0, $53SBn.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER), {
    overflowX: 'auto'
}), "& .".concat((0, $53SBn.RendererCssClassName).EXTENSION, ":first-child"), {
    marginTop: 0
})), ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT), ($df014fe6e70c2dc0$var$_$concat3 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($df014fe6e70c2dc0$var$_$concat3, ".".concat((0, $53SBn.RendererCssClassName).EXTENSION), {
    marginTop: "".concat((0, $1LBcl.blockNodesVerticalMargin))
}), ".".concat((0, $53SBn.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER, " .").concat((0, $53SBn.RendererCssClassName).EXTENSION), {
    marginBottom: 0
}), ".".concat((0, $53SBn.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER, " .mediaSingleView-content-wrap"), {
    marginTop: 0,
    marginBottom: 0
}), ".".concat((0, $53SBn.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER, " > *:first-child"), {
    marginTop: 0
}), ".".concat((0, $53SBn.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER, " > *:last-child"), {
    marginBottom: 0
}), ".".concat((0, $53SBn.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER, " > .mediaSingleView-content-wrap > *:first-child"), {
    marginTop: 0
}), ".".concat((0, $53SBn.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER, " > .mediaSingleView-content-wrap > *:last-child"), {
    marginBottom: 0
}), ".".concat((0, $53SBn.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER, " > div > *:first-child"), {
    marginTop: 0
}), ".".concat((0, $53SBn.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER, " > div > *:last-child"), {
    marginBottom: 0
}), ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER), {
    overflowX: 'auto'
}), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($df014fe6e70c2dc0$var$_$concat3, ".".concat((0, $fcr5B.shadowObserverClassNames).SHADOW_CONTAINER, " .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER), {
    display: 'flex'
}))));
var $df014fe6e70c2dc0$var$hideExtensionStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).EXTENSION, ":has([data-extension-key='hide'])"), {
    marginTop: 0
}));
var $df014fe6e70c2dc0$var$baseOtherStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    '& .UnknownBlock': {
        fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: "".concat(0.875, "rem"),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    },
    '& span.date-node': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        borderRadius: "var(--ds-radius-small, 3px)",
        color: "var(--ds-text, #292A2E)",
        paddingTop: "var(--ds-space-025, 2px)",
        paddingRight: "var(--ds-space-050, 4px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: "var(--ds-space-050, 4px)",
        margin: "0 1px",
        transition: "background 0.3s"
    },
    '& span.date-node-highlighted': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        color: "var(--ds-text-danger, #AE2E24)"
    },
    '& .renderer-image': {
        maxWidth: '100%',
        display: 'block',
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: 0,
        marginBottom: "var(--ds-space-300, 24px)",
        marginLeft: 0
    }
}, ".".concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".rich-media-wrapped + .").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ":not(.rich-media-wrapped)"), {
    clear: 'both'
}), "& .code-block,\n\t& blockquote,\n\t& hr,\n\t& > div > div:not(.rich-media-wrapped),\n\t.".concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".rich-media-wrapped + .rich-media-wrapped + *:not(.rich-media-wrapped),\n\t.").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".rich-media-wrapped + div:not(.rich-media-wrapped),\n\t.").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-align-start,\n\t\t.").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-center,\n\t\t.").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-align-end"), {
    clear: 'both'
}), '& .rich-media-wrapped', {
    '& + .renderer-heading-wrapper': {
        'h1, h2, h3, h4, h5, h6': {
            marginTop: "var(--ds-space-100, 8px)"
        }
    }
}), 'div[class^="image-wrap-"] + div[class^="image-wrap-"]', {
    marginLeft: 0,
    marginRight: 0
}), ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " >"), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "*:not([data-mark-type='fragment']) .".concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER), {
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO - improve inline style logic on table container so important styles aren't required here
    width: '100% !important',
    left: '0 !important'
}), "[data-mark-type='fragment'] * .".concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER), {
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO - improve inline style logic on table container so important styles aren't required here
    width: '100% !important',
    left: '0 !important'
}), "* .".concat((0, $53SBn.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER), {
    overflowX: 'auto'
}), "& .".concat((0, $53SBn.RendererCssClassName).EXTENSION, ":first-child"), {
    marginTop: 0
})), ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT), ($df014fe6e70c2dc0$var$_$concat5 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($df014fe6e70c2dc0$var$_$concat5, ".".concat((0, $53SBn.RendererCssClassName).EXTENSION), {
    marginTop: "".concat((0, $1LBcl.blockNodesVerticalMargin))
}), ".".concat((0, $53SBn.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER, " .").concat((0, $53SBn.RendererCssClassName).EXTENSION), {
    marginBottom: 0
}), ".".concat((0, $53SBn.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER, " .mediaSingleView-content-wrap"), {
    marginTop: 0,
    marginBottom: 0
}), ".".concat((0, $53SBn.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER, " > *:first-child"), {
    marginTop: 0
}), ".".concat((0, $53SBn.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER, " > *:last-child"), {
    marginBottom: 0
}), ".".concat((0, $53SBn.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER, " > .mediaSingleView-content-wrap > *:first-child"), {
    marginTop: 0
}), ".".concat((0, $53SBn.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER, " > .mediaSingleView-content-wrap > *:last-child"), {
    marginBottom: 0
}), ".".concat((0, $53SBn.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER, " > div > *:first-child"), {
    marginTop: 0
}), ".".concat((0, $53SBn.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER, " > div > *:last-child"), {
    marginBottom: 0
}), ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER), {
    overflowX: 'auto'
}), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($df014fe6e70c2dc0$var$_$concat5, ".".concat((0, $fcr5B.shadowObserverClassNames).SHADOW_CONTAINER, " .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER), {
    display: 'flex'
}))));
var $df014fe6e70c2dc0$var$alignedHeadingAnchorStyleDuplicateAnchor = (0, $74Zh5.css)({
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    '.fabric-editor-block-mark[data-align] >': {
        'h1, h2, h3, h4, h5, h6': {
            position: 'relative'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark:not([data-align="center"])[data-align]': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        marginTop: 0,
        marginRight: "var(--ds-space-075, 6px)",
        marginBottom: 0,
        marginLeft: 0,
        // If the anchor is right aligned then the left side of the heading
        // is aligned with the left side of the anchor.
        // In order to align as expected we transform it the width of the element (plus our expected 6px)
        // to the left
        transform: "translateX(calc(-100% - ".concat("var(--ds-space-075, 6px)", "))")
    }), '@media (hover: hover) and (pointer: fine)', (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName), " > button"), {
        transform: "translate(8px, 0px)"
    }))
});
var $df014fe6e70c2dc0$var$alignedHeadingAnchorStyle = (0, $74Zh5.css)({
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    '.fabric-editor-block-mark[data-align] >': {
        '.renderer-heading-wrapper': {
            'h1, h2, h3, h4, h5, h6': {
                position: 'relative'
            }
        }
    },
    // Center alignment for heading wrapper - flex container needs justify-content instead of text-align
    '.fabric-editor-block-mark[data-align="center"] > .renderer-heading-wrapper': {
        justifyContent: 'center'
    },
    // Right/end alignment for heading wrapper - flex container needs justify-content instead of text-align
    '.fabric-editor-block-mark[data-align="end"] > .renderer-heading-wrapper': {
        justifyContent: 'flex-end'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark:not([data-align="center"])[data-align]': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        marginTop: 0,
        marginRight: "var(--ds-space-075, 6px)",
        marginBottom: 0,
        marginLeft: 0,
        // If the anchor is right aligned then the left side of the heading
        // is aligned with the left side of the anchor.
        // In order to align as expected we transform it the width of the element (plus our expected 6px)
        // to the left
        transform: "translateX(calc(-100% - ".concat("var(--ds-space-075, 6px)", "))")
    }), '@media (hover: hover) and (pointer: fine)', (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName), " > button"), {
        transform: "translate(8px, 0px)"
    }))
});
var $df014fe6e70c2dc0$var$firstWrappedMediaStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), "[class*=\"image-wrap-\"]:has(+ .").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), "[class*=\"image-wrap-\"])"), {
    marginRight: 0,
    marginLeft: 0
}));
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: emotion refactor - there's a mediaSingleSharedNewStyle, but not originally used in the renderer.
var $df014fe6e70c2dc0$var$mediaSingleSharedStyle = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "li .".concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb)), {
    margin: 0
}), '&.ua-chrome li > .mediaSingleView-content-wrap::before', {
    content: "''",
    display: 'block',
    height: 0
}), '&.ua-firefox', {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.mediaSingleView-content-wrap': {
        userSelect: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.captionView-content-wrap': {
        userSelect: 'text'
    }
}), ".mediaSingleView-content-wrap[layout='center']", {
    clear: 'both'
}), "table .".concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb)), {
    marginTop: "var(--ds-space-150, 12px)",
    marginBottom: "var(--ds-space-150, 12px)",
    clear: 'both',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
        clear: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: "var(--ds-space-150, 12px)"
        }
    }
}), ".".concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-wrap-right + .").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-wrap-left"), {
    clear: 'both'
}), ".".concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-wrap-left + .").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-wrap-right, .").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-wrap-right + .").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-wrap-left, .").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-wrap-left + .").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-wrap-left, .").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-wrap-right + .").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-wrap-right"), {
    marginRight: 0,
    marginLeft: 0
}), "@media all and (max-width: ".concat($df014fe6e70c2dc0$var$wrappedMediaBreakoutPoint, "px)"), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
        float: 'none',
        overflow: 'auto',
        marginTop: "var(--ds-space-150, 12px)",
        marginRight: 0,
        marginBottom: "var(--ds-space-150, 12px)",
        marginLeft: 0
    }
}));
// was shared between editor-core and renderer
var $df014fe6e70c2dc0$var$tableSharedStyle = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    // originally from packages/editor/editor-common/src/styles/shared/tableCell.ts
    // Hardcoding the background color for the table cells to avoid the use of inline styles
    'td[colorname="white" i], th[colorname="white" i]': {
        backgroundColor: "var(--ds-surface, #FFFFFF)".concat(" !important")
    },
    'td[colorname="light blue" i], th[colorname="light blue" i]': {
        backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)".concat(" !important")
    },
    'td[colorname="light teal" i], th[colorname="light teal" i]': {
        backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)".concat(" !important")
    },
    'td[colorname="light green" i], th[colorname="light green" i]': {
        backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)".concat(" !important")
    },
    'td[colorname="light yellow" i], th[colorname="light yellow" i]': {
        backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)".concat(" !important")
    },
    'td[colorname="light red" i], th[colorname="light red" i]': {
        backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)".concat(" !important")
    },
    'td[colorname="light purple" i], th[colorname="light purple" i]': {
        backgroundColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)".concat(" !important")
    },
    'td[colorname="light gray" i], th[colorname="light gray" i]': {
        backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)".concat(" !important")
    },
    'td[colorname="blue" i], th[colorname="blue" i]': {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)".concat(" !important")
    },
    'td[colorname="teal" i], th[colorname="teal" i]': {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)".concat(" !important")
    },
    'td[colorname="green" i], th[colorname="green" i]': {
        backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)".concat(" !important")
    },
    'td[colorname="yellow" i], th[colorname="yellow" i]': {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)".concat(" !important")
    },
    'td[colorname="red" i], th[colorname="red" i]': {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)".concat(" !important")
    },
    'td[colorname="purple" i], th[colorname="purple" i]': {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)".concat(" !important")
    },
    'td[colorname="gray" i], th[colorname="gray" i]': {
        backgroundColor: "var(--ds-background-accent-gray-subtle, #8C8F97)".concat(" !important")
    },
    'td[colorname="dark blue" i], th[colorname="dark blue" i]': {
        backgroundColor: "var(--ds-background-accent-blue-subtle, #669DF1)".concat(" !important")
    },
    'td[colorname="dark teal" i], th[colorname="dark teal" i]': {
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)".concat(" !important")
    },
    'td[colorname="dark green" i], th[colorname="dark green" i]': {
        backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)".concat(" !important")
    },
    'td[colorname="dark yellow" i], th[colorname="dark yellow" i]': {
        backgroundColor: "var(--ds-background-accent-orange-subtle, #FCA700)".concat(" !important")
    },
    'td[colorname="dark red" i], th[colorname="dark red" i]': {
        backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)".concat(" !important")
    },
    'td[colorname="dark purple" i], th[colorname="dark purple" i]': {
        backgroundColor: "var(--ds-background-accent-purple-subtle, #C97CF4)".concat(" !important")
    },
    'td[colorname="subtle lime" i], th[colorname="subtle lime" i]': {
        backgroundColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)".concat(" !important")
    },
    'td[colorname="subtle orange" i], th[colorname="subtle orange" i]': {
        backgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF5DB)".concat(" !important")
    },
    'td[colorname="subtle magenta" i], th[colorname="subtle magenta" i]': {
        backgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)".concat(" !important")
    },
    'td[colorname="lime" i], th[colorname="lime" i]': {
        backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)".concat(" !important")
    },
    'td[colorname="orange" i], th[colorname="orange" i]': {
        backgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)".concat(" !important")
    },
    'td[colorname="magenta" i], th[colorname="magenta" i]': {
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)".concat(" !important")
    },
    'td[colorname="bold gray" i], th[colorname="bold gray" i]': {
        backgroundColor: "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)".concat(" !important")
    },
    'td[colorname="bold blue" i], th[colorname="bold blue" i]': {
        backgroundColor: "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)".concat(" !important")
    },
    'td[colorname="bold teal" i], th[colorname="bold teal" i]': {
        backgroundColor: "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)".concat(" !important")
    },
    'td[colorname="bold green" i], th[colorname="bold green" i]': {
        backgroundColor: "var(--ds-background-accent-green-subtler-hovered, #97EDC9)".concat(" !important")
    },
    'td[colorname="bold lime" i], th[colorname="bold lime" i]': {
        backgroundColor: "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)".concat(" !important")
    },
    'td[colorname="bold yellow" i], th[colorname="bold yellow" i]': {
        backgroundColor: "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)".concat(" !important")
    },
    'td[colorname="bold orange" i], th[colorname="bold orange" i]': {
        backgroundColor: "var(--ds-background-accent-orange-subtler-hovered, #FBD779)".concat(" !important")
    },
    'td[colorname="bold red" i], th[colorname="bold red" i]': {
        backgroundColor: "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)".concat(" !important")
    },
    'td[colorname="bold magenta" i], th[colorname="bold magenta" i]': {
        backgroundColor: "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)".concat(" !important")
    },
    'td[colorname="bold purple" i], th[colorname="bold purple" i]': {
        backgroundColor: "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)".concat(" !important")
    }
}, ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER), {
    position: 'relative',
    marginTop: 0,
    marginRight: 'auto',
    marginBottom: "var(--ds-space-200, 16px)",
    marginLeft: 'auto',
    boxSizing: 'border-box',
    /**
   * Fix block top alignment inside table cells.
   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.decisionItemView-content-wrap:first-of-type > div': {
        marginTop: 0
    }
}), ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, "[data-number-column='true']"), {
    paddingLeft: "".concat((0, $1LBcl.akEditorTableNumberColumnWidth) - 1, "px"),
    clear: 'both'
}), ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_RESIZER_CONTAINER), {
    willChange: 'width, margin-left'
}), ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_RESIZER_CONTAINER, " table"), {
    willChange: 'width'
}), ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table"), {
    marginTop: "var(--ds-space-300, 24px)",
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0
}), ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, " > table,\n\t.").concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), {
    marginTop: "var(--ds-space-300, 24px)",
    marginRight: "var(--ds-space-100, 8px)",
    marginBottom: 0,
    marginLeft: 0
}), ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, " > table,\n\t.").concat((0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table,\n\t.").concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), {
    borderCollapse: 'collapse',
    border: "".concat((0, $fMtrl.tableCellBorderWidth), "px solid ", "var(--ds-background-accent-gray-subtler, #DDDEE1)"),
    tableLayout: 'fixed',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '1em',
    width: '100%',
    '&[data-autosize="true"]': {
        tableLayout: 'auto'
    },
    '&[data-initial-width-mode="content"]': {
        tableLayout: 'auto',
        width: 'auto'
    },
    '*': {
        boxSizing: 'border-box'
    },
    hr: {
        boxSizing: 'content-box'
    },
    tbody: {
        borderBottom: 'none'
    },
    'th td': {
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '> tbody > tr > td': {
        backgroundColor: "var(--ds-surface, #FFFFFF)"
    },
    th: {
        backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
        textAlign: 'left',
        /* only apply this styling to codeblocks in default background headercells */ /* TODO this needs to be overhauled as it relies on unsafe selectors */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not([style]):not(.danger)': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ":not(.danger)"), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
            backgroundColor: "var(--ds-surface-raised, #FFFFFF)"
        }, "&:not(.".concat((0, $1LBcl.akEditorSelectedNodeClassName), ")"), {
            boxShadow: "0px 0px 0px 1px ".concat("var(--ds-border, #0B120E24)")
        }), ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER), {
            // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
            backgroundImage: "linear-gradient(\n\t\t\t\t\t\t\tto right,\n\t\t\t\t\t\t\t".concat("var(--ds-background-neutral, #0515240F)", " ", "var(--ds-space-300, 24px)", ",\n\t\t\t\t\t\t\ttransparent ", "var(--ds-space-300, 24px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto right,\n\t\t\t\t\t\t\t", "var(--ds-surface-raised, #FFFFFF)", " ", "var(--ds-space-300, 24px)", ",\n\t\t\t\t\t\t\ttransparent ", "var(--ds-space-300, 24px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto left,\n\t\t\t\t\t\t\t", "var(--ds-background-neutral, #0515240F)", " ", "var(--ds-space-100, 8px)", ",\n\t\t\t\t\t\t\ttransparent ", "var(--ds-space-100, 8px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto left,\n\t\t\t\t\t\t\t", "var(--ds-surface-raised, #FFFFFF)", " ", "var(--ds-space-100, 8px)", ",\n\t\t\t\t\t\t\ttransparent ", "var(--ds-space-100, 8px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto left,\n\t\t\t\t\t\t\t", "var(--ds-shadow-overflow-spread, #1E1F2129)", " 0,\n\t\t\t\t\t\t\t", "var(--ds-UNSAFE-transparent, transparent)", "  ", "var(--ds-space-100, 8px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto left,\n\t\t\t\t\t\t\t", "var(--ds-shadow-overflow-perimeter, #1E1F211f)", " 0,\n\t\t\t\t\t\t\t", "var(--ds-UNSAFE-transparent, transparent)", "  ", "var(--ds-space-100, 8px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto right,\n\t\t\t\t\t\t\t", "var(--ds-shadow-overflow-spread, #1E1F2129)", " 0,\n\t\t\t\t\t\t\t", "var(--ds-UNSAFE-transparent, transparent)", "  ", "var(--ds-space-100, 8px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto right,\n\t\t\t\t\t\t\t", "var(--ds-shadow-overflow-perimeter, #1E1F211f)", " 0,\n\t\t\t\t\t\t\t", "var(--ds-UNSAFE-transparent, transparent)", "  ", "var(--ds-space-100, 8px)", "\n\t\t\t\t\t\t  )"),
            backgroundColor: "var(--ds-background-neutral, #0515240F)"
        }), ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER), {
            backgroundColor: "var(--ds-background-neutral, #0515240F)"
        }), '> [data-ds--code--code-block]', {
            // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
            backgroundImage: "linear-gradient(\n\t\t\t\t\t\t\tto right,\n\t\t\t\t\t\t\t".concat("var(--ds-background-neutral, #0515240F)", " ", "var(--ds-space-300, 24px)", ",\n\t\t\t\t\t\t\ttransparent ", "var(--ds-space-300, 24px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto right,\n\t\t\t\t\t\t\t", "var(--ds-surface-raised, #FFFFFF)", " ", "var(--ds-space-300, 24px)", ",\n\t\t\t\t\t\t\ttransparent ", "var(--ds-space-300, 24px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto left,\n\t\t\t\t\t\t\t", "var(--ds-background-neutral, #0515240F)", " ", "var(--ds-space-100, 8px)", ",\n\t\t\t\t\t\t\ttransparent ", "var(--ds-space-100, 8px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto left,\n\t\t\t\t\t\t\t", "var(--ds-surface-raised, #FFFFFF)", " ", "var(--ds-space-100, 8px)", ",\n\t\t\t\t\t\t\ttransparent ", "var(--ds-space-100, 8px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto left,\n\t\t\t\t\t\t\t", "var(--ds-shadow-overflow-spread, #1E1F2129)", " 0,\n\t\t\t\t\t\t\t", "var(--ds-UNSAFE-transparent, transparent)", "  ", "var(--ds-space-100, 8px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto left,\n\t\t\t\t\t\t\t", "var(--ds-shadow-overflow-perimeter, #1E1F211f)", " 0,\n\t\t\t\t\t\t\t", "var(--ds-UNSAFE-transparent, transparent)", "  ", "var(--ds-space-100, 8px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto right,\n\t\t\t\t\t\t\t", "var(--ds-shadow-overflow-spread, #1E1F2129)", " 0,\n\t\t\t\t\t\t\t", "var(--ds-UNSAFE-transparent, transparent)", "  ", "var(--ds-space-100, 8px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto right,\n\t\t\t\t\t\t\t", "var(--ds-shadow-overflow-perimeter, #1E1F211f)", " 0,\n\t\t\t\t\t\t\t", "var(--ds-UNSAFE-transparent, transparent)", "  ", "var(--ds-space-100, 8px)", "\n\t\t\t\t\t\t  )"),
            backgroundColor: "var(--ds-background-neutral, #0515240F)".concat("!important"),
            // selector lives inside @atlaskit/code
            '--ds--code--line-number-bg-color': "var(--ds-background-neutral, #0515240F)"
        }))
    }
}));
var $df014fe6e70c2dc0$var$roundedTableRemixBlockHighlightStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, ".").concat($df014fe6e70c2dc0$var$REMIX_BLOCK_HIGHLIGHT_CLASS_NAME, " > table,\n\t.").concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, ".").concat($df014fe6e70c2dc0$var$REMIX_BLOCK_HIGHLIGHT_CLASS_NAME, " > .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table,\n\t.").concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, ".").concat($df014fe6e70c2dc0$var$REMIX_BLOCK_HIGHLIGHT_CLASS_NAME, " > .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), {
    '&::after': {
        borderColor: "var(--ds-border-selected, #1868DB)"
    }
}));
var $df014fe6e70c2dc0$var$roundedTableOuterBorderOverlayStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, " > table,\n\t.").concat((0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table,\n\t.").concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), {
    borderColor: 'transparent',
    position: 'relative',
    '&::after': {
        content: "''",
        position: 'absolute',
        inset: '-0.5px',
        border: "".concat((0, $fMtrl.tableCellBorderWidth), "px solid ", "var(--ds-background-accent-gray-subtler, #DDDEE1)"),
        borderRadius: "var(--ds-radius-xlarge, 12px)",
        pointerEvents: 'none',
        zIndex: 1
    },
    '> tbody > tr > th[data-reaches-top], > tbody > tr > td[data-reaches-top]': {
        borderTopColor: 'transparent'
    },
    '> tbody > tr > th[data-reaches-bottom], > tbody > tr > td[data-reaches-bottom]': {
        borderBottomColor: 'transparent'
    },
    '> tbody > tr > th[data-reaches-left], > tbody > tr > td[data-reaches-left]': {
        borderLeftColor: 'transparent'
    },
    '> tbody > tr > th[data-reaches-right], > tbody > tr > td[data-reaches-right]': {
        borderRightColor: 'transparent'
    },
    '> tbody > tr > th[data-reaches-top][data-reaches-left], > tbody > tr > td[data-reaches-top][data-reaches-left]': {
        borderTopLeftRadius: "var(--ds-radius-xlarge, 12px)",
        backgroundClip: 'border-box'
    },
    '> tbody > tr > th[data-reaches-top][data-reaches-right], > tbody > tr > td[data-reaches-top][data-reaches-right]': {
        borderTopRightRadius: "var(--ds-radius-xlarge, 12px)",
        backgroundClip: 'border-box'
    },
    '> tbody > tr > th[data-reaches-bottom][data-reaches-left], > tbody > tr > td[data-reaches-bottom][data-reaches-left]': {
        borderBottomLeftRadius: "var(--ds-radius-xlarge, 12px)",
        backgroundClip: 'border-box'
    },
    '> tbody > tr > th[data-reaches-bottom][data-reaches-right], > tbody > tr > td[data-reaches-bottom][data-reaches-right]': {
        borderBottomRightRadius: "var(--ds-radius-xlarge, 12px)",
        backgroundClip: 'border-box'
    }
}), ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, ".is-sticky > .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_WRAPPER), {
    borderTopLeftRadius: "var(--ds-radius-xlarge, 12px)",
    borderTopRightRadius: "var(--ds-radius-xlarge, 12px)",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
}), ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, ".is-sticky > .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), {
    '&::after': {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
    },
    '> tbody > tr': {
        // The sticky table clone sets a row background locally; force it off so
        // the rounded header cells, not a square row box, own the visible fill.
        background: 'transparent !important'
    },
    '> tbody > tr > th, > tbody > tr > td': {
        backgroundClip: 'border-box'
    },
    '> tbody > tr > th[data-reaches-left], > tbody > tr > td[data-reaches-left]': {
        borderTopLeftRadius: "var(--ds-radius-xlarge, 12px)",
        borderBottomLeftRadius: 0
    },
    '> tbody > tr > th[data-reaches-right], > tbody > tr > td[data-reaches-right]': {
        borderTopRightRadius: "var(--ds-radius-xlarge, 12px)",
        borderBottomRightRadius: 0
    },
    '> tbody > tr > th[data-reaches-left][data-reaches-bottom], > tbody > tr > td[data-reaches-left][data-reaches-bottom]': {
        borderBottomLeftRadius: 0
    },
    '> tbody > tr > th[data-reaches-right][data-reaches-bottom], > tbody > tr > td[data-reaches-right][data-reaches-bottom]': {
        borderBottomRightRadius: 0
    },
    '> tbody > tr > th[data-reaches-left]::after, > tbody > tr > td[data-reaches-left]::after': {
        borderBottomLeftRadius: 0
    },
    '> tbody > tr > th[data-reaches-right]::after, > tbody > tr > td[data-reaches-right]::after': {
        borderBottomRightRadius: 0
    }
}));
var $df014fe6e70c2dc0$var$tableContentModeScopedStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, ":has(> table[data-initial-width-mode=\"content\"]),\n\t.").concat((0, $53SBn.RendererCssClassName).DOCUMENT, " .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, ":has(> .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table[data-initial-width-mode=\"content\"]),\n\t.").concat((0, $53SBn.RendererCssClassName).DOCUMENT, " .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, ":has(> .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table[data-initial-width-mode=\"content\"])"), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    width: 'max-content !important',
    maxWidth: 'var(--renderer-table-max-width)'
}), ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " table[data-initial-width-mode=\"content\"] > colgroup > col"), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    width: 'unset !important'
}));
var $df014fe6e70c2dc0$var$tableContentModeExtensionContainmentStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " table[data-initial-width-mode=\"content\"] .").concat((0, $53SBn.RendererCssClassName).EXTENSION_INNER_WRAPPER), {
    containerType: 'normal'
}));
var $df014fe6e70c2dc0$var$tableContentModeNestedTableStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " table[data-initial-width-mode=\"content\"] > tbody > tr > :is(th, td) .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, " > table,\n\t\t.").concat((0, $53SBn.RendererCssClassName).DOCUMENT, " table[data-initial-width-mode=\"content\"] > tbody > tr > :is(th, td) .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, " > .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table,\n\t\t.").concat((0, $53SBn.RendererCssClassName).DOCUMENT, " table[data-initial-width-mode=\"content\"] > tbody > tr > :is(th, td) .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, " > .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), {
    width: 'max-content !important',
    maxWidth: '100%'
}));
var $df014fe6e70c2dc0$var$tableRendererHeaderStylesForTableCellOnly = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, " > table,\n\t\t.").concat((0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table,\n\t\t.").concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), {
    '> tbody > tr > th, > tbody > tr > td': {
        minWidth: "".concat((0, $fMtrl.tableCellMinWidth), "px"),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        verticalAlign: 'top',
        border: "var(--ds-border-width, 1px)".concat(" solid ", "var(--ds-background-accent-gray-subtler, #DDDEE1)"),
        borderRightWidth: 0,
        borderBottomWidth: 0,
        paddingTop: "var(--ds-space-100, 8px)",
        paddingRight: "var(--ds-space-100, 8px)",
        paddingBottom: "var(--ds-space-100, 8px)",
        paddingLeft: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        'th p:not(:first-of-type), td p:not(:first-of-type)': {
            marginTop: "var(--ds-space-150, 12px)"
        }
    }
}));
var $df014fe6e70c2dc0$var$tableRendererNestedPanelStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, " .ak-editor-panel"), {
    border: "var(--ds-border-width, 1px)".concat(" solid ", "var(--ds-border, #0B120E24)")
}));
var $df014fe6e70c2dc0$var$tableStylesBackGroundClipForGeckoForTableCellOnly = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, " > table,\n\t\t.").concat((0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table,\n\t\t.").concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '> tbody > tr > th, > tbody > tr > td': {
        backgroundClip: 'padding-box'
    }
}));
var $df014fe6e70c2dc0$var$firstNodeWithNotMarginTopWithNestedDnD = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER, " > table,\n\t\t.").concat((0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table,\n\t\t.").concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), {
    '> tbody > tr > th, > tbody > tr > td': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span))': {
            marginTop: 0
        }
    }
}));
var $df014fe6e70c2dc0$var$rendererTableStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    zIndex: 0,
    transition: "all 0.1s linear",
    display: 'flex' /* needed to avoid position: fixed jumpiness in Chrome */ 
}, "&.".concat((0, $c6bEO.shadowClassNames).RIGHT_SHADOW, "::after, &.").concat((0, $c6bEO.shadowClassNames).LEFT_SHADOW, "::before"), {
    top: "".concat((0, $fMtrl.tableMarginTop) - 1, "px"),
    height: "calc(100% - ".concat((0, $fMtrl.tableMarginTop), "px)"),
    zIndex: "".concat((0, $1LBcl.akEditorStickyHeaderZIndex)),
    width: "".concat($df014fe6e70c2dc0$var$tableShadowWidth, "px"),
    background: "linear-gradient(\n\t\t\t\t\tto left,\n\t\t\t\t\ttransparent 0,\n\t\t\t\t\t".concat("var(--ds-shadow-overflow-spread, #1E1F2129)", " 140%\n\t\t\t\t),\n\t\t\t\tlinear-gradient(\n\t\t\t\t\tto right,\n\t\t\t\t\t", "var(--ds-shadow-overflow-perimeter, #1E1F211f)", " 0px,\n\t\t\t\t\ttransparent 1px\n\t\t\t\t)")
}), "&.".concat((0, $c6bEO.shadowClassNames).RIGHT_SHADOW, "::after"), {
    background: "linear-gradient(\n\t\t\t\t\tto right,\n\t\t\t\t\ttransparent 0,\n\t\t\t\t\t".concat("var(--ds-shadow-overflow-spread, #1E1F2129)", " 140%\n\t\t\t\t),\n\t\t\t\tlinear-gradient(\n\t\t\t\t\tto left,\n\t\t\t\t\t", "var(--ds-shadow-overflow-perimeter, #1E1F211f)", " 0px,\n\t\t\t\t\ttransparent 1px\n\t\t\t\t)"),
    right: "0px"
}), "&\n          .".concat((0, $fcr5B.shadowObserverClassNames).SENTINEL_LEFT, ",\n          &\n          .").concat((0, $fcr5B.shadowObserverClassNames).SENTINEL_RIGHT), {
    height: "calc(100% - ".concat((0, $fMtrl.tableMarginTop), "px)")
})));
var $df014fe6e70c2dc0$var$stickyScrollbarStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    position: 'relative',
    flexDirection: 'column'
}, "> .".concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER), {
    width: '100%',
    display: 'block',
    visibility: 'hidden',
    overflowX: 'auto',
    position: 'sticky',
    bottom: "var(--ds-space-0, 0px)",
    zIndex: 1
}), "> .".concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM, ",\n\t\t> .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP), {
    position: 'absolute',
    width: '100%',
    height: '1px',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginTop: '-1px',
    // need this to avoid sentinel being focused via keyboard
    // this still allows it to be detected by intersection observer
    visibility: 'hidden'
}), "> .".concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP), {
    top: "".concat($df014fe6e70c2dc0$var$tableRowHeight * 3, "px")
}), "> .".concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM), {
    bottom: "var(--ds-space-250, 20px)" // MAX_BROWSER_SCROLLBAR_HEIGHT = 20;
})));
var $df014fe6e70c2dc0$var$stickyScrollbarOverflowShadowFixStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "&.".concat((0, $c6bEO.shadowClassNames).RIGHT_SHADOW, "::after, &.").concat((0, $c6bEO.shadowClassNames).LEFT_SHADOW, "::before"), {
    // The sticky scrollbar retains this space in the table container's layout even while hidden.
    bottom: "var(--ds-space-250, 20px)",
    height: 'auto'
})));
var $df014fe6e70c2dc0$var$rendererTableHeaderEqualHeightStylesForTableCellOnly = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table, .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), {
    height: '1px' /* will be ignored */ ,
    marginLeft: 0,
    marginRight: 0
})), ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table > tbody > tr:first-of-type, .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table > tbody > tr:first-of-type"), {
    height: '100%',
    'td, th': {
        position: 'relative'
    }
}));
var $df014fe6e70c2dc0$var$rendererTableSortableColumnStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table, .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN_WRAPPER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    padding: 0
}, ".".concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN), {
    width: '100%',
    height: '100%',
    padding: "".concat((0, $fMtrl.tableCellPadding), "px"),
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-shape
    borderWidth: '1.5px',
    borderStyle: 'solid',
    borderColor: "transparent",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '> *:first-child': {
        marginTop: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
        marginTop: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
        marginTop: 0
    },
    '@supports selector(:focus-visible)': {
        '&:focus': {
            outline: 'unset'
        },
        '&:focus-visible': {
            borderColor: "var(--ds-border-focused, #4688EC)"
        }
    }
}), "> .".concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN, " > .").concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    margin: 0
}, ".".concat((0, $4VBpm.SORTABLE_COLUMN_ICON_CLASSNAME)), {
    opacity: 1,
    transition: "opacity 0.2s ease-in-out"
})), "> .".concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN, "\n\t\t\t\t\t\t> .").concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $4VBpm.SORTABLE_COLUMN_ICON_CLASSNAME)), {
    opacity: 0,
    '&:focus': {
        opacity: 1
    }
})), "&:hover:not(\n\t\t\t\t\t\t\t:has(\n\t\t\t\t\t\t\t\t\t.".concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN_WRAPPER, "\n\t\t\t\t\t\t\t\t\t\t.").concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN, ":hover\n\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t)\n\t\t\t\t\t\t> .").concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN, "\n\t\t\t\t\t\t> .").concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $4VBpm.SORTABLE_COLUMN_ICON_CLASSNAME)), {
    opacity: 1
}))))));
// Sortable header cells render content inside an extra div, so mirror the th alignment there.
var $df014fe6e70c2dc0$var$rendererTableSortableColumnValignStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table, .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "th[data-valign='middle'].".concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN_WRAPPER, " > .").concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN), {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
}), "th[data-valign='bottom'].".concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN_WRAPPER, " > .").concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN), {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end'
}))));
var $df014fe6e70c2dc0$var$rendererTableColumnStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER), {
    'table[data-number-column="true"]': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).NUMBER_COLUMN), {
        backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
        borderRight: "var(--ds-border-width, 1px)".concat(" solid\n\t\t\t\t\t\t\t\t", "var(--ds-background-accent-gray-subtler, #DDDEE1)"),
        width: "".concat((0, $1LBcl.akEditorTableNumberColumnWidth), "px"),
        textAlign: 'center',
        color: "var(--ds-text-subtlest, #6B6E76)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: "".concat(0.875, " rem")
    }), ".fixed .".concat((0, $53SBn.RendererCssClassName).NUMBER_COLUMN), {
        borderRight: "0px none"
    })
}));
var $df014fe6e70c2dc0$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinksDuplicateAnchor = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table, .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN_WRAPPER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
    position: 'unset'
}), '>', {
    'h1, h2, h3, h4, h5, h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginRight: '30px'
    }
}))))));
var $df014fe6e70c2dc0$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table, .").concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN_WRAPPER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
    position: 'unset'
}), '> .renderer-heading-wrapper', {
    // Reserve space for the sortable-column icon so the heading+anchor wrapper never overlaps it.
    // Use padding (instead of margin on the heading) so we don't create a gap between the heading
    // text and the copy-link anchor button
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    paddingRight: '30px'
}))))));
// @ts-expect-error - throw TS error when use !import in position.
var $df014fe6e70c2dc0$var$stickyHeaderStyles = (0, $74Zh5.css)({
    'tr[data-header-row].fixed': {
        position: 'fixed !important',
        display: 'flex',
        overflow: 'hidden',
        zIndex: "".concat((0, $1LBcl.akEditorStickyHeaderZIndex)),
        borderRight: "var(--ds-border-width, 1px)".concat(" solid ", "var(--ds-background-accent-gray-subtler, #DDDEE1)"),
        borderBottom: "var(--ds-border-width, 1px)".concat(" solid ", "var(--ds-background-accent-gray-subtler, #DDDEE1)"),
        /* this is to compensate for the table border */ transform: 'translateX(-1px)'
    },
    '.sticky > th': {
        zIndex: "".concat((0, $1LBcl.akEditorStickyHeaderZIndex)),
        position: 'fixed !important',
        top: 0
    },
    /* Make the number column header sticky */ '.sticky > td': {
        position: 'fixed !important',
        top: 0
    },
    /* add border for position: sticky
  and work around background-clip: padding-box
  bug for FF causing box-shadow bug in Chrome */ '.sticky th, .sticky td': {
        boxShadow: "0px 1px ".concat("var(--ds-background-accent-gray-subtler, #DDDEE1)", ",\n\t\t\t0px -0.5px ", "var(--ds-background-accent-gray-subtler, #DDDEE1)", ",\n\t\t\tinset -1px 0px ", "var(--ds-background-accent-gray-subtler, #DDDEE1)", ",\n\t\t\t0px -1px ", "var(--ds-background-accent-gray-subtler, #DDDEE1)")
    },
    /* this will remove jumpiness caused in Chrome for sticky headers */ '.fixed + tr': {
        minHeight: '0px'
    }
});
var $df014fe6e70c2dc0$var$codeBlockAndLayoutStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    /*
   * We wrap CodeBlock in a grid to prevent it from overflowing the container of the renderer.
   * See ED-4159.
   */ '& .code-block': {
        maxWidth: '100%',
        display: 'block',
        position: 'relative',
        borderRadius: "var(--ds-radius-small, 3px)",
        /*
     * The overall renderer has word-wrap: break; which causes issues with
     * code block line numbers in Safari / iOS.
     */ wordWrap: 'normal'
    },
    '& .MediaGroup, & .code-block': {
        marginTop: "".concat((0, $1LBcl.blockNodesVerticalMargin)),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:first-child': {
            marginTop: 0
        }
    }
}, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, "\n\t\t> .").concat((0, $7J4nJ.LightWeightCodeBlockCssClassName).CONTAINER, "\n\t\t.").concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER), {
    marginTop: (0, $1LBcl.blockNodesVerticalMargin)
}), '& [data-layout-section]', (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    marginTop: "var(--ds-space-250, 20px)",
    '& > div + div': {
        marginLeft: "var(--ds-space-400, 32px)"
    }
}, "@media screen and (max-width: ".concat((0, $1LBcl.gridMediumMaxWidth), "px)"), {
    '& > div + div': {
        marginLeft: 0
    }
}), '& .MediaGroup, & .code-block', {
    marginTop: (0, $1LBcl.blockNodesVerticalMargin),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:first-child': {
        marginTop: 0
    }
})), '& li', {
    '> .code-block': {
        margin: "".concat((0, $1LBcl.blockNodesVerticalMargin), " 0 0 0")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '> .code-block:first-child': {
        marginTop: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '> div:last-of-type.code-block': {
        marginBottom: (0, $1LBcl.blockNodesVerticalMargin)
    }
}));
// Match the first content sibling throughout streaming SSR and hydration. Emotion moves
// style elements to the head, which must not change code block or media group spacing.
// Keep these selectors less specific than the top-level lightweight code block override.
var $df014fe6e70c2dc0$var$blockSsrMarginStyles = (0, $74Zh5.css)({
    '& .MediaGroup:not(:not(style, script) ~ *), & .code-block:not(:not(style, script) ~ *)': {
        marginTop: 0
    },
    '& [data-layout-section] .MediaGroup:not(:not(style, script) ~ *), & [data-layout-section] .code-block:not(:not(style, script) ~ *), & li > .code-block:not(:not(style, script) ~ *)': {
        marginTop: 0
    }
});
// Layout columns start with an empty margin-reset element. Ignore only streamed siblings
// between that element and the first code block/media group, preserving later block spacing.
var $df014fe6e70c2dc0$var$layoutBlockSsrMarginStyles = (0, $74Zh5.css)({
    '& [data-layout-column-start] ~ .code-block:not([data-layout-column-start] ~ :not(style, script) ~ *), & [data-layout-column-start] ~ .MediaGroup:not([data-layout-column-start] ~ :not(style, script) ~ *)': {
        marginTop: 0
    }
});
var $df014fe6e70c2dc0$var$codeBlockInListSsrMarginSafariFixStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "&:not([data-node-type='decisionList']) > li,\n\t\t&:not(.".concat((0, $23e6e5ff8dd7ee19$export$4ccd31bf665a88f6).BLOCK_CARD_CONTAINER, ") > li"), {
    '> .code-block:not(:not(style, script) ~ *)': {
        marginTop: "-".concat((0, $1LBcl.akEditorLineHeight), "em !important")
    }
}));
var $df014fe6e70c2dc0$var$layoutSectionForAdvancedLayoutsStyles = (0, $74Zh5.css)({
    '& [data-layout-section]': {
        '& > div + div': {
            marginLeft: 0
        }
    }
});
var $df014fe6e70c2dc0$var$gridRenderForCodeBlockStyles = (0, $74Zh5.css)({
    '& .code-block': {
        // removed old -ms- prefix, as grid is well supported for MS Edge
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1fr)',
        '& > span': {
            gridColumn: 1
        }
    }
});
// This prevents https://product-fabric.atlassian.net/browse/ED-20924
var $df014fe6e70c2dc0$var$codeBlockInListSafariFixStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "&:not([data-node-type='decisionList']) > li,\n\t\t&:not(.".concat((0, $23e6e5ff8dd7ee19$export$4ccd31bf665a88f6).BLOCK_CARD_CONTAINER, ") > li"), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    '&::before': {
        content: '" "',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: (0, $1LBcl.akEditorLineHeight)
    }
}, "> p:first-child,\n\t\t\t> .code-block:first-child,\n\t\t\t> .ProseMirror-gapcursor:first-child + .code-block", {
    marginTop: "-".concat((0, $1LBcl.akEditorLineHeight), "em !important")
})));
var $df014fe6e70c2dc0$var$columnLayoutSharedStyle = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        }
    }, "@media screen and (max-width: ".concat((0, $1LBcl.gridMediumMaxWidth), "px)"), {
        flexDirection: 'column'
    })
});
var $df014fe6e70c2dc0$var$columnLayoutResponsiveSharedStyle = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-layout-section]': {
        display: 'flex',
        flexDirection: 'row',
        gap: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.layout-section-container': {
        containerType: 'inline-size',
        containerName: 'layout-area'
    }
});
var $df014fe6e70c2dc0$var$columnLayoutResponsiveRendererStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.layout-section-container [data-layout-section]': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
        gap: "var(--ds-space-600, 48px)"
    }, "@container layout-area (max-width: ".concat($df014fe6e70c2dc0$var$LAYOUT_BREAKPOINT_RENDERER, "px)"), {
        flexDirection: 'column',
        gap: "var(--ds-space-400, 32px)"
    })
});
var $df014fe6e70c2dc0$var$rendererAnnotationStylesOld = (0, $74Zh5.css)({
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark], & [data-annotation-draft-mark][data-annotation-inline-node]": {
        background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        borderBottom: "var(--ds-border-width-selected, 2px)".concat(" solid ", "var(--ds-border-accent-yellow, #B38600)"),
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
        cursor: 'pointer',
        paddingTop: "var(--ds-space-050, 4px)",
        paddingRight: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-025, 2px)"
    }
});
var $df014fe6e70c2dc0$var$rendererAnnotationStyles = (0, $74Zh5.css)({
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark]": {
        background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        borderBottom: "var(--ds-border-width-selected, 2px)".concat(" solid ", "var(--ds-border-accent-yellow, #B38600)"),
        cursor: 'pointer',
        paddingTop: "var(--ds-space-050, 4px)",
        paddingRight: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-025, 2px)"
    },
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'][data-has-focus='true'] [data-annotation-mark]": {
        background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
    }
});
var $df014fe6e70c2dc0$var$rendererAnnotationStylesCommentHeightFix = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node]': {
        borderBottom: "var(--ds-border-width-selected, 2px)".concat(" solid transparent"),
        cursor: 'pointer',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        paddingTop: '1px',
        paddingRight: 0,
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: 0,
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node][data-inline-card]': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node].date-lozenger-container': {
        paddingTop: "var(--ds-space-025, 2px)"
    }
});
var $df014fe6e70c2dc0$var$RENDERER_LIST_DENSE_GAP = "max(0px,calc((var(--ak-renderer-base-font-size) - ".concat((0, $1LBcl.akEditorFullPageDenseFontSize), "px)* (4/3)))");
var $df014fe6e70c2dc0$var$TASKLIST_CONTAINER_DENSE_MARGIN = "max(calc(10px + (var(--ak-renderer-base-font-size) - ".concat((0, $1LBcl.akEditorFullPageDenseFontSize), "px) *( 2 / 3)))");
var $df014fe6e70c2dc0$var$scaledDenseEmojiStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE), {
    height: "".concat((0, $9DPK6.defaultDenseEmojiHeight), "px"),
    minHeight: "".concat((0, $9DPK6.defaultDenseEmojiHeight), "px"),
    minWidth: "".concat((0, $9DPK6.defaultDenseEmojiHeight), "px"),
    maxHeight: "".concat((0, $9DPK6.denseEmojiHeightH1), "px"),
    maxWidth: "".concat((0, $9DPK6.denseEmojiHeightH1), "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    img: {
        width: '100%',
        height: '100%',
        objectFit: 'contain'
    }
}), "h1 :is(.".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_SPRITE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_PLACEHOLDER, ")"), {
    height: "".concat((0, $9DPK6.denseEmojiHeightH1), "px"),
    width: "".concat((0, $9DPK6.denseEmojiHeightH1), "px")
}), "h2 :is(.".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_SPRITE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_PLACEHOLDER, ")"), {
    height: "".concat((0, $9DPK6.denseEmojiHeightH2), "px"),
    width: "".concat((0, $9DPK6.denseEmojiHeightH2), "px")
}), "h3 :is(.".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_SPRITE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_PLACEHOLDER, ")"), {
    height: "".concat((0, $9DPK6.denseEmojiHeightH3), "px"),
    width: "".concat((0, $9DPK6.denseEmojiHeightH3), "px")
}), "h4 :is(.".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_SPRITE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_PLACEHOLDER, ")"), {
    height: "".concat((0, $9DPK6.denseEmojiHeightH4), "px"),
    width: "".concat((0, $9DPK6.denseEmojiHeightH4), "px")
}), ":is(h5, h6, p) :is(.".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_SPRITE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_PLACEHOLDER, ")"), {
    height: "".concat((0, $9DPK6.defaultDenseEmojiHeight), "px"),
    width: "".concat((0, $9DPK6.defaultDenseEmojiHeight), "px")
}), "[data-testid=\"icon-wrapper\"] :is(.".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_SPRITE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_PLACEHOLDER, ")"), {
    minHeight: "".concat((0, $9DPK6.defaultInlineEmojiHeight), "px"),
    minWidth: "".concat((0, $9DPK6.defaultInlineEmojiHeight), "px"),
    height: "".concat((0, $9DPK6.defaultInlineEmojiHeight), "px"),
    width: "".concat((0, $9DPK6.defaultInlineEmojiHeight), "px")
}));
var $df014fe6e70c2dc0$var$scaledDenseUnicodeEmojiStylesNew = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "[data-emoji-type=\"unicode\"]", {
    '--emoji-common-unicode-size': "".concat((0, $9DPK6.defaultDenseEmojiHeight), "px")
}), "h1 [data-emoji-type=\"unicode\"]", {
    '--emoji-common-unicode-size': "".concat((0, $9DPK6.denseEmojiHeightH1), "px")
}), "h2 [data-emoji-type=\"unicode\"]", {
    '--emoji-common-unicode-size': "".concat((0, $9DPK6.denseEmojiHeightH2), "px")
}), "h3 [data-emoji-type=\"unicode\"]", {
    '--emoji-common-unicode-size': "".concat((0, $9DPK6.denseEmojiHeightH3), "px")
}), "h4 [data-emoji-type=\"unicode\"]", {
    '--emoji-common-unicode-size': "".concat((0, $9DPK6.denseEmojiHeightH4), "px")
}), ":is(h5, h6, p) [data-emoji-type=\"unicode\"]", {
    '--emoji-common-unicode-size': "".concat((0, $9DPK6.defaultDenseEmojiHeight), "px")
}));
var $df014fe6e70c2dc0$var$scaledEmojiStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE), {
    height: "".concat((0, $9DPK6.defaultEmojiHeight), "px"),
    minHeight: "".concat((0, $9DPK6.defaultEmojiHeight), "px"),
    minWidth: "".concat((0, $9DPK6.defaultEmojiHeight), "px"),
    maxHeight: "".concat((0, $9DPK6.scaledEmojiHeightH1), "px"),
    maxWidth: "".concat((0, $9DPK6.scaledEmojiHeightH1), "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    img: {
        width: '100%',
        height: '100%',
        objectFit: 'contain'
    }
}), "h1 :is(.".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_SPRITE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_PLACEHOLDER, ")"), {
    height: "".concat((0, $9DPK6.scaledEmojiHeightH1), "px"),
    width: "".concat((0, $9DPK6.scaledEmojiHeightH1), "px")
}), "h2 :is(.".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_SPRITE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_PLACEHOLDER, ")"), {
    height: "".concat((0, $9DPK6.scaledEmojiHeightH2), "px"),
    width: "".concat((0, $9DPK6.scaledEmojiHeightH2), "px")
}), "h3 :is(.".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_SPRITE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_PLACEHOLDER, ")"), {
    height: "".concat((0, $9DPK6.scaledEmojiHeightH3), "px"),
    width: "".concat((0, $9DPK6.scaledEmojiHeightH3), "px")
}), "h4 :is(.".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_SPRITE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_PLACEHOLDER, ")"), {
    height: "".concat((0, $9DPK6.scaledEmojiHeightH4), "px"),
    width: "".concat((0, $9DPK6.scaledEmojiHeightH4), "px")
}), ":is(h5, h6, p) :is(.".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_SPRITE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_PLACEHOLDER, ")"), {
    height: "".concat((0, $9DPK6.defaultEmojiHeight), "px"),
    width: "".concat((0, $9DPK6.defaultEmojiHeight), "px")
}), "[data-testid=\"icon-wrapper\"] :is(.".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_SPRITE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_PLACEHOLDER, ")"), {
    minHeight: "".concat((0, $9DPK6.defaultInlineEmojiHeight), "px"),
    minWidth: "".concat((0, $9DPK6.defaultInlineEmojiHeight), "px"),
    height: "".concat((0, $9DPK6.defaultInlineEmojiHeight), "px"),
    width: "".concat((0, $9DPK6.defaultInlineEmojiHeight), "px")
}));
var $df014fe6e70c2dc0$var$scaledUnicodeEmojiStylesNew = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "[data-emoji-type=\"unicode\"]", {
    '--emoji-common-unicode-size': "".concat((0, $9DPK6.defaultEmojiHeight), "px")
}), "h1 [data-emoji-type=\"unicode\"]", {
    '--emoji-common-unicode-size': "".concat((0, $9DPK6.scaledEmojiHeightH1), "px")
}), "h2 [data-emoji-type=\"unicode\"]", {
    '--emoji-common-unicode-size': "".concat((0, $9DPK6.scaledEmojiHeightH2), "px")
}), "h3 [data-emoji-type=\"unicode\"]", {
    '--emoji-common-unicode-size': "".concat((0, $9DPK6.scaledEmojiHeightH3), "px")
}), "h4 [data-emoji-type=\"unicode\"]", {
    '--emoji-common-unicode-size': "".concat((0, $9DPK6.scaledEmojiHeightH4), "px")
}), ":is(h5, h6, p) [data-emoji-type=\"unicode\"]", {
    '--emoji-common-unicode-size': "".concat((0, $9DPK6.defaultEmojiHeight), "px")
}));
var $df014fe6e70c2dc0$var$denseStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE), {
    height: "calc(".concat((0, $9DPK6.defaultEmojiHeight), " * var(--ak-renderer-base-font-size) / ").concat((0, $1LBcl.akEditorFullPageDefaultFontSize), ")"),
    width: "calc(".concat((0, $9DPK6.defaultEmojiHeight), " * var(--ak-renderer-base-font-size) / ").concat((0, $1LBcl.akEditorFullPageDefaultFontSize), ")"),
    maxHeight: "calc(".concat((0, $9DPK6.defaultEmojiHeight), " * var(--ak-renderer-base-font-size) / ").concat((0, $1LBcl.akEditorFullPageDefaultFontSize), ")"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    img: {
        width: '100%',
        height: '100%',
        objectFit: 'contain'
    }
}), ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " .ak-editor-panel .ak-editor-panel__icon"), {
    height: "var(--ds-space-250, 20px)",
    width: "var(--ds-space-250, 20px)"
}), ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT), {
    // Adjacent list items
    'li + li': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        marginTop: $df014fe6e70c2dc0$var$RENDERER_LIST_DENSE_GAP
    },
    // Nested lists directly under an li (unordered and ordered)
    'li > ul, li > ol, .ak-ul li > ul, .ak-ul li > ol, .ak-ol li > ul, .ak-ol li > ol': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        marginTop: $df014fe6e70c2dc0$var$RENDERER_LIST_DENSE_GAP
    },
    // Task lists
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-task-list-local-id]': {
        // Task lists: container top margin
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        marginTop: $df014fe6e70c2dc0$var$TASKLIST_CONTAINER_DENSE_MARGIN
    },
    // Task lists: sibling items and nested lists
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-task-list-local-id] > * + *': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        marginTop: $df014fe6e70c2dc0$var$RENDERER_LIST_DENSE_GAP
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-task-list-local-id] [data-task-list-local-id], [data-task-local-id] [data-task-local-id]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        marginTop: $df014fe6e70c2dc0$var$RENDERER_LIST_DENSE_GAP
    }
}));
var $df014fe6e70c2dc0$var$syncBlockRendererStyles = (0, $74Zh5.css)({
    margin: 0,
    maxWidth: 'none',
    padding: 0
});
/**
 * Fake left/right table borders.
 *
 * Adapted from the editor-plugin-table behavior (see editor-common's
 * `tableSharedStyle()` in `editor-common/src/styles/shared/table.ts`). The
 * visible vertical edges of the table are painted by these absolutely-positioned
 * 1px divs that live inside the (non-scrolling) TABLE_CONTAINER, while the real
 * <table> left/right borders are made `transparent`. Because the divs are not
 * inside the horizontally scrolling TABLE_NODE_WRAPPER, they remain visible
 * regardless of scroll position — fixing the missing right border when an
 * overflowing table inside a reference synced block is scrolled all the way to
 * the left.
 *
 * The `height` formula adjusted for table in renderer
 */ var $df014fe6e70c2dc0$var$tableFakeBorderStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_RIGHT_BORDER, ",\n\t\t.").concat((0, $7NyDw.TableSharedCssClassName).TABLE_LEFT_BORDER), {
    display: 'block',
    width: '1px',
    height: "calc(100% - ".concat("var(--ds-space-300, 24px)", " - ", "var(--ds-space-250, 20px)", ")"),
    background: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    position: 'absolute',
    top: "var(--ds-space-300, 24px)"
}), ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_RIGHT_BORDER), {
    right: 0
}), ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_LEFT_BORDER, ",\n\t\t.").concat((0, $7NyDw.TableSharedCssClassName).TABLE_LEFT_BORDER, "[data-with-numbered-table='true']"), {
    left: 0
})), ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table,\n\t.").concat((0, $7NyDw.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), {
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent'
}));
var $df014fe6e70c2dc0$var$roundedTableFakeBorderOverlayStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_CONTAINER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $7NyDw.TableSharedCssClassName).TABLE_RIGHT_BORDER, ",\n\t\t.").concat((0, $7NyDw.TableSharedCssClassName).TABLE_LEFT_BORDER), {
    display: 'none'
})));
var $df014fe6e70c2dc0$var$syncBlockStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $cFTJ2.SyncBlockSharedCssClassName).renderer, ", .").concat((0, $cFTJ2.BodiedSyncBlockSharedCssClassName).renderer, ", .").concat((0, $cFTJ2.SyncBlockSharedCssClassName).error, ", .").concat((0, $cFTJ2.SyncBlockSharedCssClassName).loading), {
    borderRadius: "var(--ds-radius-small, 3px)",
    marginTop: "var(--ds-space-075, 6px)",
    paddingBlock: "var(--ds-space-150, 12px)",
    overflow: 'visible'
}), ".".concat((0, $cFTJ2.SyncBlockSharedCssClassName).renderer), {
    // First child node in syncBlock in editor is overridden with marginTop: 0, hence apply the same style in renderer for consistency
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-renderer-document > :first-child': {
        marginTop: 0
    }
}), ".".concat((0, $cFTJ2.BodiedSyncBlockSharedCssClassName).renderer), {
    // First child node in bodiedSyncBlock in editor is overridden with marginTop: 0, hence apply the same style in renderer for consistency
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    '> :first-child': {
        marginTop: 0
    }
}), ".".concat((0, $cFTJ2.SyncBlockSharedCssClassName).error), {
    backgroundColor: "var(--ds-background-disabled, #0515240F)"
}), ".".concat((0, $cFTJ2.SyncBlockSharedCssClassName).loading), {
    boxShadow: "0 0 0 1px ".concat("var(--ds-border, #0B120E24)")
}));
var $df014fe6e70c2dc0$export$8f0929e72efe521f = function RendererStyleContainer(props) {
    var onClick = props.onClick, onMouseDown = props.onMouseDown, appearance = props.appearance, contentMode = props.contentMode, allowNestedHeaderLinks = props.allowNestedHeaderLinks, allowColumnSorting = props.allowColumnSorting, useBlockRenderForCodeBlock = props.useBlockRenderForCodeBlock, children = props.children, innerRef = props.innerRef, testId = props.testId, isInsideSyncBlock = props.isInsideSyncBlock;
    var isAdvancedLayoutsOn = (0, $j3BGx.editorExperiment)('advanced_layouts', true);
    var isPreviewPanelResponsivenessOn = (0, $j3BGx.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    });
    var isStickyScrollbarOn = (0, $8tCqL.isStickyScrollbarEnabled)(appearance);
    var baseFontSize = (0, $cc8a699f38d2ae23$export$8e2864079bc476bd)(appearance, contentMode);
    var browser = (0, $4vXmi.getBrowserInfo)();
    return (0, $74Zh5.jsx)("div", {
        role: "none",
        ref: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        style: {
            '--ak-renderer-base-font-size': "".concat(baseFontSize, "px"),
            '--ak-renderer-editor-font-heading-h1': "".concat((0, $789a6b614b844e25$export$63adc0ebe3278d31)['editor.font.heading.h1']),
            '--ak-renderer-editor-font-heading-h2': "".concat((0, $789a6b614b844e25$export$63adc0ebe3278d31)['editor.font.heading.h2']),
            '--ak-renderer-editor-font-heading-h3': "".concat((0, $789a6b614b844e25$export$63adc0ebe3278d31)['editor.font.heading.h3']),
            '--ak-renderer-editor-font-heading-h4': "".concat((0, $789a6b614b844e25$export$63adc0ebe3278d31)['editor.font.heading.h4']),
            '--ak-renderer-editor-font-heading-h5': "".concat((0, $789a6b614b844e25$export$63adc0ebe3278d31)['editor.font.heading.h5']),
            '--ak-renderer-editor-font-heading-h6': "".concat((0, $789a6b614b844e25$export$63adc0ebe3278d31)['editor.font.heading.h6']),
            '--ak-renderer-editor-font-normal-text': "".concat((0, $789a6b614b844e25$export$63adc0ebe3278d31)['editor.font.body']),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- CSS custom properties for UGC font tokens
            '--ak-renderer-editor-font-small-text': (0, $789a6b614b844e25$export$63adc0ebe3278d31)['editor.font.body.small']
        },
        css: [
            (0, $drUcN.expValEquals)('confluence_ttvc_inline_extensions', 'isEnabled', true) ? $df014fe6e70c2dc0$var$baseFontStyle : $df014fe6e70c2dc0$var$originalBaseFontLineHeight,
            $df014fe6e70c2dc0$var$baseStyles,
            $df014fe6e70c2dc0$var$fontSizeStyles,
            (0, $drUcN.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $df014fe6e70c2dc0$var$headingAnchorStyles : $df014fe6e70c2dc0$var$headingAnchorStylesDuplicateAnchor,
            $df014fe6e70c2dc0$var$headingAnchorButtonFocusVisibleStyles,
            (0, $drUcN.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $df014fe6e70c2dc0$var$hideHeadingCopyLinkWrapperStyles : $df014fe6e70c2dc0$var$hideHeadingCopyLinkWrapperStylesDuplicateAnchor,
            appearance === 'full-page' && isPreviewPanelResponsivenessOn && $df014fe6e70c2dc0$var$rendererFullPageStylesWithReducedPadding,
            appearance === 'full-page' && !isPreviewPanelResponsivenessOn && $df014fe6e70c2dc0$var$rendererFullPageStyles,
            appearance === 'full-width' && ((0, $drUcN.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? $df014fe6e70c2dc0$var$rendererFullWidthStyles : $df014fe6e70c2dc0$var$oldRendererFullWidthStyles),
            (appearance === 'full-width' || appearance === 'max') && !(0, $8tCqL.isTableResizingEnabled)(appearance) && $df014fe6e70c2dc0$var$rendererFullWidthStylesForTableResizing,
            appearance === 'max' && ((0, $drUcN.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? $df014fe6e70c2dc0$var$rendererMaxWidthStyles : $df014fe6e70c2dc0$var$oldRendererMaxWidthStyles),
            $df014fe6e70c2dc0$var$rovoTelepointerStyles,
            $df014fe6e70c2dc0$var$whitespaceSharedStyles,
            $df014fe6e70c2dc0$var$blockquoteSharedStyles,
            $df014fe6e70c2dc0$var$headingsSharedStyles,
            (0, $drUcN.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) && $df014fe6e70c2dc0$var$headingWrapperInlineFlowStyles,
            (0, $jkJfI.isExperimentEnabled)('platform_editor_heading_link_target_size') && $df014fe6e70c2dc0$var$headingAnchorWrapperTargetSizeStyles,
            (0, $drUcN.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $df014fe6e70c2dc0$var$headingWithAlignmentStyles : $df014fe6e70c2dc0$var$headingWithAlignmentStylesDuplicateAnchor,
            $df014fe6e70c2dc0$var$ruleSharedStyles,
            contentMode === 'compact' && $df014fe6e70c2dc0$var$extensionStyle,
            contentMode === 'compact' ? $df014fe6e70c2dc0$var$paragraphStylesUGCScaledMargin : $df014fe6e70c2dc0$var$paragraphSharedStylesWithEditorUGC,
            $df014fe6e70c2dc0$var$listsSharedStyles,
            browser.gecko && $df014fe6e70c2dc0$var$listsSharedStylesForGekko,
            $df014fe6e70c2dc0$var$listItemHiddenMarkerStyles,
            $df014fe6e70c2dc0$var$indentationSharedStyles,
            $df014fe6e70c2dc0$var$indentationSharedStylesWithMarginFix,
            (0, $drUcN.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $df014fe6e70c2dc0$var$blockMarksSharedStyles : $df014fe6e70c2dc0$var$blockMarksSharedStylesDuplicateAnchor,
            $df014fe6e70c2dc0$var$codeMarkSharedStyles,
            $df014fe6e70c2dc0$var$shadowSharedStyle,
            $df014fe6e70c2dc0$var$dateSharedStyle,
            $df014fe6e70c2dc0$var$textColorStyles,
            $df014fe6e70c2dc0$var$backgroundColorStyles,
            !(0, $drUcN.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && $df014fe6e70c2dc0$var$highlightLinksUnsetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            $df014fe6e70c2dc0$export$a365082c2a191514,
            $df014fe6e70c2dc0$var$tasksAndDecisionsStyles,
            (0, $drUcN.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) && $df014fe6e70c2dc0$var$headingPanelStyles,
            $df014fe6e70c2dc0$var$smartCardStyles,
            $df014fe6e70c2dc0$var$smartCardStylesAvatarFix,
            $df014fe6e70c2dc0$var$headerSmartCardStyles,
            $df014fe6e70c2dc0$var$smartCardStylesAvatarMarginFix,
            $df014fe6e70c2dc0$var$smartCardStylesAvatarListZeroMarginTop,
            (0, $50U6m.fg)('editor_inline_comments_on_inline_nodes') && ((0, $drUcN.expValEquals)('confluence_fe_renderer_inline_node_mark_color_fix', 'isEnabled', true) ? $df014fe6e70c2dc0$var$rendererAnnotationStyles : $df014fe6e70c2dc0$var$rendererAnnotationStylesOld),
            // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $50U6m.fg)('editor_inline_comments_on_inline_nodes') && $df014fe6e70c2dc0$var$rendererAnnotationStylesCommentHeightFix,
            (0, $drUcN.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $df014fe6e70c2dc0$var$baseOtherStyles : $df014fe6e70c2dc0$var$baseOtherStylesDuplicateAnchor,
            $df014fe6e70c2dc0$var$expandSsrMarginStyles,
            // this should be placed after baseOtherStyles
            (0, $drUcN.expValEquals)('platform_editor_render_bodied_extension_as_inline', 'isEnabled', true) && ((0, $drUcN.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? $df014fe6e70c2dc0$var$extensionAsInlineStyle : $df014fe6e70c2dc0$var$oldExtensionAsInlineStyle),
            (0, $50U6m.fg)('platform_forge_inline_bodied_macro') && [
                $df014fe6e70c2dc0$var$migratedInlineBodiedFlowStyle,
                $df014fe6e70c2dc0$var$forgeInlineBodiedSpacingStyle
            ],
            $df014fe6e70c2dc0$var$inlineExtensionRendererMarginFix,
            allowNestedHeaderLinks && ((0, $drUcN.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $df014fe6e70c2dc0$var$alignedHeadingAnchorStyle : $df014fe6e70c2dc0$var$alignedHeadingAnchorStyleDuplicateAnchor),
            $df014fe6e70c2dc0$var$mediaSingleSharedStyle,
            $df014fe6e70c2dc0$var$firstWrappedMediaStyles,
            $df014fe6e70c2dc0$var$tableSharedStyle,
            (0, $drUcN.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && $df014fe6e70c2dc0$var$roundedTableOuterBorderOverlayStyles,
            (0, $drUcN.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && $df014fe6e70c2dc0$var$roundedTableRemixBlockHighlightStyles,
            $df014fe6e70c2dc0$var$tableContentModeScopedStyles,
            $df014fe6e70c2dc0$var$tableContentModeExtensionContainmentStyles,
            $df014fe6e70c2dc0$var$tableContentModeNestedTableStyles,
            $df014fe6e70c2dc0$var$tableRendererHeaderStylesForTableCellOnly,
            (0, $50U6m.fg)('platform_editor_bordered_panel_nested_in_table') && $df014fe6e70c2dc0$var$tableRendererNestedPanelStyles,
            $df014fe6e70c2dc0$var$isBackgroundClipBrowserFixNeeded() && $df014fe6e70c2dc0$var$tableStylesBackGroundClipForGeckoForTableCellOnly,
            $df014fe6e70c2dc0$var$firstNodeWithNotMarginTopWithNestedDnD,
            $df014fe6e70c2dc0$var$rendererTableStyles,
            isStickyScrollbarOn && $df014fe6e70c2dc0$var$stickyScrollbarStyles,
            isStickyScrollbarOn && (0, $jkJfI.isExperimentEnabled)('platform_editor_table_css_overflow_shadow') && $df014fe6e70c2dc0$var$stickyScrollbarOverflowShadowFixStyles,
            $df014fe6e70c2dc0$var$rendererTableHeaderEqualHeightStylesForTableCellOnly,
            allowColumnSorting && $df014fe6e70c2dc0$var$rendererTableSortableColumnStyles,
            allowColumnSorting && (0, $eqmEx.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true) && $df014fe6e70c2dc0$var$rendererTableSortableColumnValignStyles,
            allowColumnSorting && allowNestedHeaderLinks && ((0, $drUcN.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $df014fe6e70c2dc0$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks : $df014fe6e70c2dc0$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinksDuplicateAnchor),
            $df014fe6e70c2dc0$var$rendererTableColumnStyles,
            $df014fe6e70c2dc0$var$stickyHeaderStyles,
            $df014fe6e70c2dc0$var$codeBlockAndLayoutStyles,
            $df014fe6e70c2dc0$var$columnLayoutSharedStyle,
            isAdvancedLayoutsOn && $df014fe6e70c2dc0$var$columnLayoutResponsiveSharedStyle,
            isAdvancedLayoutsOn && $df014fe6e70c2dc0$var$columnLayoutResponsiveRendererStyles,
            isAdvancedLayoutsOn && $df014fe6e70c2dc0$var$layoutSectionForAdvancedLayoutsStyles,
            !useBlockRenderForCodeBlock && $df014fe6e70c2dc0$var$gridRenderForCodeBlockStyles,
            browser.safari && $df014fe6e70c2dc0$var$codeBlockInListSafariFixStyles,
            (0, $50U6m.fg)('platform_renderer_ssr_block_margin_fix') && [
                $df014fe6e70c2dc0$var$blockSsrMarginStyles,
                $df014fe6e70c2dc0$var$layoutBlockSsrMarginStyles,
                browser.safari && $df014fe6e70c2dc0$var$codeBlockInListSsrMarginSafariFixStyles
            ],
            appearance === 'full-page' && !isPreviewPanelResponsivenessOn && $df014fe6e70c2dc0$var$responsiveBreakoutWidth,
            appearance === 'full-page' && isPreviewPanelResponsivenessOn && $df014fe6e70c2dc0$var$responsiveBreakoutWidthWithReducedPadding,
            (appearance === 'full-width' || appearance === 'max') && $df014fe6e70c2dc0$var$responsiveBreakoutWidthFullWidth,
            (0, $drUcN.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) ? contentMode === 'compact' ? $df014fe6e70c2dc0$var$scaledDenseEmojiStyles : $df014fe6e70c2dc0$var$scaledEmojiStyles : contentMode === 'compact' ? $df014fe6e70c2dc0$var$denseStyles : undefined,
            contentMode === 'compact' ? $df014fe6e70c2dc0$var$scaledDenseUnicodeEmojiStylesNew : $df014fe6e70c2dc0$var$scaledUnicodeEmojiStylesNew,
            $df014fe6e70c2dc0$var$syncBlockStyles,
            $df014fe6e70c2dc0$var$centerWrapperStyles,
            isInsideSyncBlock ? $df014fe6e70c2dc0$var$syncBlockRendererStyles : null,
            isInsideSyncBlock && $df014fe6e70c2dc0$var$tableFakeBorderStyles,
            isInsideSyncBlock && (0, $drUcN.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? $df014fe6e70c2dc0$var$roundedTableFakeBorderOverlayStyles : null,
            (0, $drUcN.expValEquals)('platform_editor_hide_extension_renderer_support', 'isEnabled', true) && $df014fe6e70c2dc0$var$hideExtensionStyles
        ],
        "data-testid": testId
    }, children);
};



var $13ECD = parcelRequire("13ECD");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
function $68ff72c25ae09c72$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $68ff72c25ae09c72$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $68ff72c25ae09c72$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($68ff72c25ae09c72$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
// oxlint-ignore @typescript-eslint/consistent-type-imports -- classic @jsx jsx factory + jsx.JSX.Element types
var $68ff72c25ae09c72$var$fadeOutStyles = function fadeOutStyles(maxHeight, top, backgroundColor) {
    return (0, $74Zh5.css)({
        position: 'relative',
        overflowY: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: "".concat(maxHeight, "px"),
        '&::after': {
            content: "''",
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: "".concat(top, "px"),
            bottom: 0,
            left: 0,
            right: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundImage: "linear-gradient( ".concat("var(--ds-background-neutral-subtle, #00000000)", ", ", backgroundColor, " )")
        }
    });
};
var $68ff72c25ae09c72$var$FadeOut = function FadeOut(props) {
    var children = props.children, backgroundColor = props.backgroundColor, fadeHeight = props.fadeHeight, height = props.height;
    var top = height - fadeHeight;
    var styles = $68ff72c25ae09c72$var$fadeOutStyles(height, top, backgroundColor);
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return (0, $74Zh5.jsx)("div", {
        css: styles
    }, children);
};
var $68ff72c25ae09c72$export$79ad592494094f07 = /*#__PURE__*/ function(_Component) {
    function TruncatedWrapper(props) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, TruncatedWrapper);
        return $68ff72c25ae09c72$var$_callSuper(this, TruncatedWrapper, [
            props
        ]);
    }
    // TODO: DSP-4123 - Quality ticket as elevation.surface will be issue when sits top of modal.
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(TruncatedWrapper, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(TruncatedWrapper, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, _this$props$height = _this$props.height, height = _this$props$height === void 0 ? 95 : _this$props$height, _this$props$fadeHeigh = _this$props.fadeHeight, fadeHeight = _this$props$fadeHeigh === void 0 ? 24 : _this$props$fadeHeigh, _this$props$backgroun = _this$props.backgroundColor, backgroundColor = _this$props$backgroun === void 0 ? "var(--ds-surface, #FFFFFF)" : _this$props$backgroun, children = _this$props.children;
                return (0, $74Zh5.jsx)($68ff72c25ae09c72$var$FadeOut, {
                    height: height,
                    fadeHeight: fadeHeight,
                    backgroundColor: backgroundColor
                }, children);
            }
        }
    ]);
}((0, $5FkrB.Component));



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $7c9845e1179c85a2$export$80ffe7e3c6bf25c3(factory, propsDerivator, props) {
    // cache the last set of props
    var prev = (0, $5FkrB.useRef)(props);
    var prevFactory = (0, $5FkrB.useRef)(null);
    return (0, $5FkrB.useMemo)(function() {
        // check if the serializer is already created
        var shouldCreate = !prevFactory.current;
        // check each prop to see if value has changed and also check if the number of props has changed
        if (prev.current !== props) {
            var propsEntries = Object.entries(props);
            shouldCreate = propsEntries.length !== Object.keys(prev.current).length || propsEntries.some(function(_ref) {
                var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], prop = _ref2[1];
                return prev.current[key] !== prop;
            });
        }
        prev.current = props;
        // If first time or any prop value has changed, create a new serializer
        if (shouldCreate) prevFactory.current = factory(propsDerivator(props));
        return prevFactory.current;
    }, // To keep deps consistent, here disable the exhaustive-deps rule to drop factory from the deps array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        propsDerivator,
        props
    ]);
}



var $caYHb = parcelRequire("caYHb");
var $303ba37d2d9486ca$var$_excluded = [
    "portal"
];
function $303ba37d2d9486ca$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $303ba37d2d9486ca$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $303ba37d2d9486ca$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $303ba37d2d9486ca$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $303ba37d2d9486ca$export$47b2879ca9bbf67a = 2000;
var $303ba37d2d9486ca$export$1b622068be977101 = 3000;
// we want to calculate all the table widths (which causes reflows) after the renderer has finished loading to mitigate performance impact
var $303ba37d2d9486ca$var$TABLE_INFO_TIMEOUT = 10000;
var $303ba37d2d9486ca$var$RENDER_EVENT_SAMPLE_RATE = 0.1;
var $303ba37d2d9486ca$var$packageName = "@atlaskit/renderer";
var $303ba37d2d9486ca$var$packageVersion = "142.1.3";
var $303ba37d2d9486ca$var$setAsQueryContainerStyles = (0, $74Zh5.css)({
    containerName: 'ak-renderer-wrapper',
    containerType: 'inline-size'
});
var $303ba37d2d9486ca$var$handleMouseTripleClickInTables = function handleMouseTripleClickInTables(event) {
    var _parentElement, _parentElement2;
    var browser = (0, $4vXmi.getBrowserInfo)();
    if (browser.ios || browser.android) return;
    var badBrowser = browser.chrome || browser.safari;
    var tripleClick = event.detail >= 3;
    if (!(badBrowser && tripleClick)) return;
    var selection = window.getSelection();
    if (!selection) return;
    var type = selection.type, anchorNode = selection.anchorNode, focusNode = selection.focusNode;
    var rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
    if (!rangeSelection) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    var target = event.target;
    var tableCell = target.closest('td,th');
    var clickedInCell = Boolean(tableCell);
    if (!clickedInCell) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var anchorInCell = tableCell.contains(anchorNode);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var focusInCell = tableCell.contains(focusNode);
    var selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
    if (!selectionStartsOrEndsOutsideClickedCell) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    var elementToSelect = anchorInCell ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (_parentElement = anchorNode.parentElement) === null || _parentElement === void 0 ? void 0 : _parentElement.closest('div,p') : focusInCell ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (_parentElement2 = focusNode.parentElement) === null || _parentElement2 === void 0 ? void 0 : _parentElement2.closest('div,p') : tableCell;
    if (elementToSelect) selection.selectAllChildren(elementToSelect);
};
/**
 * Handle clicks inside renderer. If the click isn't on media, in the media picker, or on a
 * link, call the onUnhandledClick eventHandler (which in Jira for example, may switch the
 * renderer out for the editor).
 * @param event Click event anywhere inside renderer
 * @param props
 * @param mouseDownSelection
 * @example
 */ var $303ba37d2d9486ca$var$handleWrapperOnClick = function handleWrapperOnClick(event, props, mouseDownSelection) {
    var _props$eventHandlers;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    var targetElement = event.target;
    $303ba37d2d9486ca$var$handleMouseTripleClickInTables(event);
    // ED-14862: When a user triple clicks to select a line of content inside a
    // a table cell, but the browser incorrectly moves the selection start or end into
    // a different table cell, we manually set the selection back to within the original
    // table cell the user intended to target
    if (!((_props$eventHandlers = props.eventHandlers) !== null && _props$eventHandlers !== void 0 && _props$eventHandlers.onUnhandledClick)) return;
    if (!(targetElement instanceof window.Element)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    var rendererWrapper = event.currentTarget;
    var isInteractiveElementInTree = (0, $9F9pG.findInTree)(targetElement, rendererWrapper, (0, $06b5438107d56029$export$3dee5e4542c672d9));
    if (isInteractiveElementInTree) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    var windowSelection = window.getSelection();
    var selection = windowSelection !== null ? windowSelection.toString() : undefined;
    var hasSelection = selection && selection.length !== 0;
    var hasSelectionMouseDown = mouseDownSelection.current && mouseDownSelection.current.length !== 0;
    var allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
    if (allowEditBasedOnSelection) props.eventHandlers.onUnhandledClick(event);
};
var $303ba37d2d9486ca$export$c49fe2316038f3c2 = function RendererFunctionalComponent(props) {
    var createAnalyticsEvent = props.createAnalyticsEvent;
    var mouseDownSelection = (0, $5FkrB.useRef)(undefined);
    var providerFactory = (0, $5FkrB.useMemo)(function() {
        return props.dataProviders || new (0, $fBC68.default)();
    }, [
        props.dataProviders
    ]);
    var _useRendererContext = (0, $ky5Ao.useRendererContext)(), nestedRendererType = _useRendererContext.nestedRendererType;
    var createRendererContext = (0, $5FkrB.useMemo)(function() {
        return function(featureFlags, isTopLevelRenderer) {
            var normalizedFeatureFlags = (0, $e3d31a87077225d6$export$f1485fc4974593c0)(featureFlags);
            return {
                featureFlags: normalizedFeatureFlags,
                isTopLevelRenderer: isTopLevelRenderer === undefined,
                // Propagate nestedRendererType into the inner RendererContextProvider so that
                // React components inside the renderer (e.g. Colgroup) can read it via
                // useRendererContext(). Without this, the inner provider overwrites the outer
                // AKRendererWrapper context and nestedRendererType becomes undefined.
                nestedRendererType: nestedRendererType
            };
        };
    }, [
        nestedRendererType
    ]);
    var fireAnalyticsEventOld = (0, $5FkrB.useCallback)(function(event) {
        var createAnalyticsEvent = props.createAnalyticsEvent;
        if (createAnalyticsEvent) {
            var channel = (0, $6EZ2P.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        props
    ]);
    var fireAnalyticsEventNew = (0, $5FkrB.useCallback)(function(event) {
        if (createAnalyticsEvent) {
            var channel = (0, $6EZ2P.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        createAnalyticsEvent
    ]);
    var _fireAnalyticsEvent = (0, $j3BGx.editorExperiment)('platform_renderer_fix_analytics_memo_callback', true, {
        exposure: true
    }) ? fireAnalyticsEventNew : fireAnalyticsEventOld;
    var deriveSerializerProps = (0, $5FkrB.useCallback)(function(props) {
        var _props$startPos;
        var stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
        var annotationProvider = props.annotationProvider;
        var allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
        var _createRendererContex = createRendererContext(props.featureFlags, props.isTopLevelRenderer), featureFlags = _createRendererContex.featureFlags;
        return {
            startPos: (_props$startPos = props.startPos) !== null && _props$startPos !== void 0 ? _props$startPos : 0,
            providers: providerFactory,
            eventHandlers: props.eventHandlers,
            extensionHandlers: props.extensionHandlers,
            hideExtensionKeysWhilePending: props.hideExtensionKeysWhilePending,
            portal: props.portal,
            objectContext: $303ba37d2d9486ca$var$_objectSpread($303ba37d2d9486ca$var$_objectSpread({
                adDoc: props.shouldRemoveEmptySpaceAroundContent ? (0, $2cbb530e7605fa73$export$c94cfc0c675062a1)(props.document) : props.document,
                schema: props.schema
            }, props.rendererContext), {}, {
                nestedRendererType: nestedRendererType
            }),
            appearance: props.appearance,
            contentMode: props.contentMode,
            onSetLinkTarget: props.onSetLinkTarget,
            disableHeadingIDs: props.disableHeadingIDs,
            headingIdPrefix: props.headingIdPrefix,
            disableActions: props.disableActions,
            allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
            allowColumnSorting: props.allowColumnSorting,
            fireAnalyticsEvent: _fireAnalyticsEvent,
            shouldOpenMediaViewer: props.shouldOpenMediaViewer,
            allowAltTextOnImages: props.allowAltTextOnImages,
            stickyHeaders: stickyHeaders,
            allowMediaLinking: props.media && props.media.allowLinking,
            surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
            media: props.media,
            mentionNodeDataProvider: props.mentionNodeDataProvider,
            emojiProviderLookupOrder: props.emojiProviderLookupOrder,
            emojiResourceConfig: props.emojiResourceConfig,
            smartLinks: props.smartLinks,
            extensionViewportSizes: props.extensionViewportSizes,
            getExtensionHeight: props.getExtensionHeight,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowDownloadCodeBlock: props.allowDownloadCodeBlock,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowAnnotations: props.allowAnnotations,
            allowSelectAllTrap: props.allowSelectAllTrap,
            allowPlaceholderText: props.allowPlaceholderText,
            nodeComponents: props.nodeComponents,
            allowWindowedCodeBlock: featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.allowWindowedCodeBlock,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isPresentational: props.UNSTABLE_isPresentational,
            textHighlighter: props.textHighlighter || props.UNSTABLE_textHighlighter,
            allowTableAlignment: props.UNSTABLE_allowTableAlignment,
            allowTableResizing: props.UNSTABLE_allowTableResizing,
            disableTableOverflowShadow: props.disableTableOverflowShadow,
            allowFixedColumnWidthOption: props.allowFixedColumnWidthOption,
            shouldDisplayExtensionAsInline: props.shouldDisplayExtensionAsInline
        };
    }, [
        createRendererContext,
        providerFactory,
        _fireAnalyticsEvent,
        nestedRendererType
    ]);
    var serializer = (0, $7c9845e1179c85a2$export$80ffe7e3c6bf25c3)(function(serializerProps) {
        var _props$createSerializ, _props$createSerializ2;
        return (_props$createSerializ = (_props$createSerializ2 = props.createSerializer) === null || _props$createSerializ2 === void 0 ? void 0 : _props$createSerializ2.call(props, serializerProps)) !== null && _props$createSerializ !== void 0 ? _props$createSerializ : new (0, $412c6966035531bf$export$2e2bcd8739ae039)(serializerProps);
    }, deriveSerializerProps, props);
    var localRef = (0, $5FkrB.useRef)(null);
    var editorRef = props.innerRef || localRef;
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    var id = (0, $5FkrB.useMemo)(function() {
        return (0, $6JfQX.default)();
    }, []);
    var renderedMeasurementDistortedDurationMonitor = (0, $5FkrB.useMemo)(function() {
        return (0, $6f06f484c7500059$export$70f7d127254a90c)();
    }, []);
    // we are doing this to ensure it runs as
    // early as possible in the React lifecycle
    // to avoid any other side effects
    var measureStarted = (0, $5FkrB.useRef)(false);
    var startAnalyticsMeasure = function startAnalyticsMeasure() {
        (0, $f3813def174ce227$export$b62aa2130c86b59b)("Renderer Render Time: ".concat(id));
    };
    if (!measureStarted.current) {
        startAnalyticsMeasure();
        measureStarted.current = true;
    }
    var anchorLinkAnalytics = (0, $5FkrB.useCallback)(function() {
        var hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
        var disableHeadingIDs = props.disableHeadingIDs;
        if (!disableHeadingIDs && hash && editorRef && editorRef.current instanceof HTMLElement) {
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- anchor navigation uses document.getElementById for hash targets
            var anchorLinkElement = document.getElementById(hash);
            if (anchorLinkElement && editorRef.current.contains(anchorLinkElement)) _fireAnalyticsEvent({
                action: (0, $jJH6F.ACTION).VIEWED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANCHOR_LINK,
                attributes: {
                    platform: (0, $aP6HU.PLATFORM).WEB,
                    mode: (0, $aP6HU.MODE).RENDERER
                },
                eventType: (0, $jJH6F.EVENT_TYPE).UI
            });
        }
    }, [
        props.disableHeadingIDs,
        editorRef,
        _fireAnalyticsEvent
    ]);
    var getSchema = (0, $5FkrB.useMemo)(function() {
        return function(schema, adfStage) {
            if (schema) return schema;
            return (0, $kYLlQ.getSchemaBasedOnStage)(adfStage);
        };
    }, []);
    var onMouseDownEditView = function onMouseDownEditView() {
        var windowSelection = window.getSelection();
        mouseDownSelection.current = windowSelection !== null ? windowSelection.toString() : undefined;
    };
    var dataProviders = props.dataProviders, analyticsEventSeverityTracking = props.analyticsEventSeverityTracking;
    (0, $5FkrB.useEffect)(function() {
        var rafID;
        var heightWidthAnalyticsSetTimeoutID;
        var heightWidthAnalyticsRicID;
        var heightWidthAnalyticsRafID;
        var handleAnalytics = function handleAnalytics() {
            if (Math.random() < $303ba37d2d9486ca$var$RENDER_EVENT_SAMPLE_RATE) _fireAnalyticsEvent({
                action: (0, $jJH6F.ACTION).STARTED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, $aP6HU.PLATFORM).WEB,
                    sampleRate: $303ba37d2d9486ca$var$RENDER_EVENT_SAMPLE_RATE
                },
                eventType: (0, $jJH6F.EVENT_TYPE).UI
            });
            rafID = requestAnimationFrame(function() {
                (0, $f3813def174ce227$export$37c25be427bec097)("Renderer Render Time: ".concat(id), function(duration) {
                    var _analyticsEventSeveri, _analyticsEventSeveri2;
                    var forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, $52c73f50bcd8b255$export$5b59d3e9e22dbdc6)();
                    var severity = !!forceSeverityTracking || analyticsEventSeverityTracking !== null && analyticsEventSeverityTracking !== void 0 && analyticsEventSeverityTracking.enabled ? (0, $577d48613d9afb24$export$f8edd689e8b20f3a)(duration, (_analyticsEventSeveri = analyticsEventSeverityTracking === null || analyticsEventSeverityTracking === void 0 ? void 0 : analyticsEventSeverityTracking.severityNormalThreshold) !== null && _analyticsEventSeveri !== void 0 ? _analyticsEventSeveri : $303ba37d2d9486ca$export$47b2879ca9bbf67a, (_analyticsEventSeveri2 = analyticsEventSeverityTracking === null || analyticsEventSeverityTracking === void 0 ? void 0 : analyticsEventSeverityTracking.severityDegradedThreshold) !== null && _analyticsEventSeveri2 !== void 0 ? _analyticsEventSeveri2 : $303ba37d2d9486ca$export$1b622068be977101) : undefined;
                    var isTTRTrackingExplicitlyDisabled = (analyticsEventSeverityTracking === null || analyticsEventSeverityTracking === void 0 ? void 0 : analyticsEventSeverityTracking.enabled) === false;
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    var distortedDuration = renderedMeasurementDistortedDurationMonitor.distortedDuration;
                    var ttfb = (0, $9e179070c6de461e$export$92d097a1155bbe27)();
                    var nodes = (0, $85fdf1d409f20456$export$1daf15cbaf649dad)(props.document);
                    // Always signal that the renderer has finished rendering, regardless of analytics
                    // sampling or TTR tracking config. This is a reliable, unsampled lifecycle hook
                    // (e.g. used to release a UFO load hold) and must not be coupled to the sampled
                    // `rendered` analytics event below, which only fires for a fraction of renders.
                    if (props.onRendered) props.onRendered({
                        duration: duration,
                        distortedDuration: distortedDuration,
                        nodes: nodes,
                        ttfb: ttfb
                    });
                    if (!isTTRTrackingExplicitlyDisabled) {
                        var event = {
                            action: (0, $jJH6F.ACTION).RENDERED,
                            actionSubject: (0, $jJH6F.ACTION_SUBJECT).RENDERER,
                            attributes: {
                                platform: (0, $aP6HU.PLATFORM).WEB,
                                duration: duration,
                                distortedDuration: distortedDuration,
                                ttfb: ttfb,
                                nodes: nodes,
                                nestedRendererType: nestedRendererType,
                                severity: severity,
                                sampleRate: $303ba37d2d9486ca$var$RENDER_EVENT_SAMPLE_RATE
                            },
                            eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL
                        };
                        if (Math.random() < $303ba37d2d9486ca$var$RENDER_EVENT_SAMPLE_RATE) _fireAnalyticsEvent(event);
                    }
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    renderedMeasurementDistortedDurationMonitor.cleanup();
                });
                anchorLinkAnalytics();
            });
            // send statistics about the heights/widths of the tables on the page for alerting
            heightWidthAnalyticsSetTimeoutID = setTimeout(function() {
                var requestIdleCallbackFn = function requestIdleCallbackFn() {
                    var _props$innerRef;
                    var renderer = (_props$innerRef = props.innerRef) === null || _props$innerRef === void 0 || (_props$innerRef = _props$innerRef.current) === null || _props$innerRef === void 0 ? void 0 : _props$innerRef.querySelector('.ak-renderer-document');
                    if (renderer) {
                        var payload = (0, $6daa18ee83e5c8bd$export$208d2421b73f3f86)(renderer);
                        if (payload) _fireAnalyticsEvent(payload);
                        var payloadHeight = (0, $6daa18ee83e5c8bd$export$34e5b28c67455a81)(renderer);
                        if (payloadHeight) _fireAnalyticsEvent(payloadHeight);
                    }
                };
                if (window && typeof window.requestIdleCallback === 'function') heightWidthAnalyticsRicID = window.requestIdleCallback(requestIdleCallbackFn);
                else if (window && typeof window.requestAnimationFrame === 'function') // requestIdleCallback is not supported in safari, fallback to requestAnimationFrame
                heightWidthAnalyticsRafID = window.requestAnimationFrame(requestIdleCallbackFn);
            }, $303ba37d2d9486ca$var$TABLE_INFO_TIMEOUT);
        };
        handleAnalytics();
        return function() {
            if (rafID) window.cancelAnimationFrame(rafID);
            if (heightWidthAnalyticsSetTimeoutID) window.clearTimeout(heightWidthAnalyticsSetTimeoutID);
            if (heightWidthAnalyticsRafID) window.cancelAnimationFrame(heightWidthAnalyticsRafID);
            if (heightWidthAnalyticsRicID) window.cancelIdleCallback(heightWidthAnalyticsRicID);
            // if this is the ProviderFactory which was created in constructor
            // it's safe to destroy it on Renderer unmount
            // updated to match existing class component
            if (!dataProviders) providerFactory.destroy();
        };
    // we are going to ignore this because I'm doing this on purpose
    // having a dependency array means we run stopMeasure twice per render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var rendererContext = (0, $5FkrB.useMemo)(function() {
        return $303ba37d2d9486ca$var$_objectSpread($303ba37d2d9486ca$var$_objectSpread({}, createRendererContext(props.featureFlags, props.isTopLevelRenderer)), {}, {
            timeZone: props.timeZone
        });
    }, [
        props.featureFlags,
        props.isTopLevelRenderer,
        createRendererContext,
        props.timeZone
    ]);
    var isCollapsibleHeadingsEnabled = props.allowCollapsibleHeadings === true && [
        'full-page',
        'full-width',
        'max'
    ].includes(props.appearance || '') && rendererContext.isTopLevelRenderer && (0, $jkJfI.isExperimentEnabled)('platform_renderer_collapsible_headings');
    (0, $dea3a35de38d7103$export$81bdbc2b3f1c95ef)(editorRef, props.document, props.scrollToBlock);
    var allowNestedTables = props.allowNestedTables;
    // Memoised so `renderDocument`'s validation memo can match by reference across re-renders.
    var validationOverrides = (0, $5FkrB.useMemo)(function() {
        var schema = getSchema(props.schema, props.adfStage);
        return (0, $9ab1e55a80cda9a2$export$da873e3c90937d2a)(schema) ? {
            allowNestedTables: allowNestedTables,
            allowTableInPanel: true
        } : {
            allowNestedTables: allowNestedTables
        };
    }, [
        allowNestedTables,
        getSchema,
        props.schema,
        props.adfStage
    ]);
    // Invoking `onComplete` during render lets consumers set state on other components mid-render,
    // so the stat is parked here and delivered once the rendered document has been committed.
    // No dependency array: `renderDocument` produces a new stat on every render, so the callback
    // must run after every commit to keep its historical once-per-render cadence.
    var pendingOnCompleteStatRef = (0, $5FkrB.useRef)(null);
    var onComplete = props.onComplete;
    (0, $5FkrB.useEffect)(function() {
        var stat = pendingOnCompleteStatRef.current;
        if (stat === null || !onComplete) return;
        pendingOnCompleteStatRef.current = null;
        onComplete(stat);
    });
    try {
        var _rendererContext$feat, _props$media;
        var schema = getSchema(props.schema, props.adfStage);
        var _renderDocument = (0, $2071b3d80d22d00f$export$59a54f98b9753d5c)(props.shouldRemoveEmptySpaceAroundContent ? (0, $2cbb530e7605fa73$export$c94cfc0c675062a1)(props.document) : props.document, serializer, schema, props.adfStage, id, _fireAnalyticsEvent, props.unsupportedContentLevelsTracking, props.appearance, props.includeNodesCountInStats, props.skipValidation, validationOverrides), result = _renderDocument.result, stat = _renderDocument.stat, pmDoc = _renderDocument.pmDoc;
        if (props.onComplete) pendingOnCompleteStatRef.current = stat;
        var rendererOutput = (0, $74Zh5.jsx)((0, $ky5Ao.RendererContextProvider), {
            value: rendererContext
        }, (0, $74Zh5.jsx)((0, $lVo0h.ActiveHeaderIdProvider), {
            value: (0, $e382f311073cdba5$export$acb253d79d72af92)(props.allowHeadingAnchorLinks)
        }, (0, $74Zh5.jsx)((0, $gPdZj.default).Provider, {
            // eslint-disable-next-line @atlassian/perf-linting/no-inline-context-value, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            value: {
                fireAnalyticsEvent: function fireAnalyticsEvent(event) {
                    return _fireAnalyticsEvent(event);
                }
            }
        }, (0, $74Zh5.jsx)((0, $4qXRD.Provider), null, (0, $74Zh5.jsx)((0, $d0n7Z.ProviderFactoryProvider), {
            value: providerFactory
        }, (0, $74Zh5.jsx)($303ba37d2d9486ca$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            contentMode: props.contentMode || 'standard',
            allowNestedHeaderLinks: (0, $e382f311073cdba5$export$7aa7587d1ce9583c)(props.allowHeadingAnchorLinks),
            allowColumnSorting: props.allowColumnSorting,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowDownloadCodeBlock: props.allowDownloadCodeBlock,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowPlaceholderText: props.allowPlaceholderText,
            useBlockRenderForCodeBlock: (_rendererContext$feat = rendererContext.featureFlags.useBlockRenderForCodeBlock) !== null && _rendererContext$feat !== void 0 ? _rendererContext$feat : true,
            addTelepointer: props.addTelepointer,
            innerRef: editorRef,
            onClick: function onClick(event) {
                return $303ba37d2d9486ca$var$handleWrapperOnClick(event, props, mouseDownSelection);
            },
            onMouseDown: onMouseDownEditView,
            ssr: (_props$media = props.media) === null || _props$media === void 0 ? void 0 : _props$media.ssr,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            shouldRemoveEmptySpaceAroundContent: props.shouldRemoveEmptySpaceAroundContent,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, props.enableSsrInlineScripts || props.noOpSSRInlineScript ? (0, $74Zh5.jsx)((0, $e2e772a0c175af19$export$cfc1361be0de4203), {
            noOpSSRInlineScript: Boolean(props.noOpSSRInlineScript)
        }) : null, (0, $74Zh5.jsx)($303ba37d2d9486ca$var$RendererActionsInternalUpdater, {
            doc: pmDoc,
            schema: schema,
            onAnalyticsEvent: _fireAnalyticsEvent
        }, (0, $74Zh5.jsx)((0, $9fs6o.CollapsibleHeadingsProvider), {
            pmDocument: pmDoc,
            rendererRef: editorRef,
            isEnabled: isCollapsibleHeadingsEnabled
        }, result))))))));
        var rendererResult = props.truncated ? (0, $74Zh5.jsx)((0, $68ff72c25ae09c72$export$79ad592494094f07), {
            height: props.maxHeight,
            fadeHeight: props.fadeOutHeight
        }, rendererOutput) : rendererOutput;
        return (0, $74Zh5.jsx)((0, $5FkrB.Fragment), null, rendererResult);
    } catch (e) {
        var _rendererContext$feat2;
        if (props.onError) props.onError(e);
        return (0, $74Zh5.jsx)($303ba37d2d9486ca$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            contentMode: props.contentMode || 'standard',
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowDownloadCodeBlock: props.allowDownloadCodeBlock,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowPlaceholderText: props.allowPlaceholderText,
            allowColumnSorting: props.allowColumnSorting,
            allowNestedHeaderLinks: (0, $e382f311073cdba5$export$7aa7587d1ce9583c)(props.allowHeadingAnchorLinks),
            useBlockRenderForCodeBlock: (_rendererContext$feat2 = rendererContext.featureFlags.useBlockRenderForCodeBlock) !== null && _rendererContext$feat2 !== void 0 ? _rendererContext$feat2 : true,
            addTelepointer: props.addTelepointer,
            onClick: function onClick(event) {
                return $303ba37d2d9486ca$var$handleWrapperOnClick(event, props, mouseDownSelection);
            },
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, (0, $74Zh5.jsx)((0, $5dFQJ.default), null));
    }
};
var $303ba37d2d9486ca$var$RendererFunctionalComponentMemoized = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo($303ba37d2d9486ca$export$c49fe2316038f3c2);
var $303ba37d2d9486ca$var$RendererFunctionalComponentWithPortalContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(function(props) {
    // If nodeComponents are provided, we don't remove portal from props and use context instead,
    // because we can't guarantee compatibility with existing Atlaskit Renderer consumers.
    if (props.nodeComponents) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($303ba37d2d9486ca$var$RendererFunctionalComponentMemoized, props);
    var portal = props.portal, propsWithoutPortal = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $303ba37d2d9486ca$var$_excluded);
    return (0, $74Zh5.jsx)((0, $aOpeL.PortalContext).Provider, {
        value: portal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($303ba37d2d9486ca$export$c49fe2316038f3c2, propsWithoutPortal));
});
function $303ba37d2d9486ca$export$88530751e3977073(props) {
    var _props$isTopLevelRend;
    var _React$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useContext((0, $nOuq8.AnnotationsPositionContext)), startPos = _React$useContext.startPos;
    var _useRendererContext2 = (0, $ky5Ao.useRendererContext)(), isTopLevelRenderer = _useRendererContext2.isTopLevelRenderer;
    var _ref = (0, $5FkrB.useContext)((0, $caYHb.ValidationContext)) || {}, skipValidation = _ref.skipValidation, allowNestedTables = _ref.allowNestedTables;
    return (0, $74Zh5.jsx)($303ba37d2d9486ca$var$RendererFunctionalComponentWithPortalContext, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        startPos: startPos,
        isTopLevelRenderer: (_props$isTopLevelRend = props.isTopLevelRenderer) !== null && _props$isTopLevelRend !== void 0 ? _props$isTopLevelRend : isTopLevelRenderer,
        skipValidation: skipValidation,
        allowNestedTables: allowNestedTables
    }));
}
var $303ba37d2d9486ca$export$af81ffb59b6ef0dd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(function(props) {
    return (0, $74Zh5.jsx)((0, $f127cdcabdc66218$export$629cada6c5e621e1), {
        data: {
            appearance: (0, $ee2b8b656f6cf8d3$export$be87849653b93e6b)(props.appearance),
            packageName: $303ba37d2d9486ca$var$packageName,
            packageVersion: $303ba37d2d9486ca$var$packageVersion,
            componentName: 'renderer',
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            editorSessionId: (0, $6JfQX.default)()
        }
    }, (0, $74Zh5.jsx)((0, $8d472cee2b63d31a$export$9ac3d19711324187), {
        render: function render(createAnalyticsEvent) {
            // `IntlErrorBoundary` only captures Internationalisation errors, leaving others for `ErrorBoundary`.
            return (0, $74Zh5.jsx)((0, $enqEB.ErrorBoundary), {
                component: (0, $jJH6F.ACTION_SUBJECT).RENDERER,
                rethrowError: true,
                fallbackComponent: null,
                createAnalyticsEvent: createAnalyticsEvent
            }, (0, $74Zh5.jsx)((0, $de1783a2fb838cfd$export$7df0749115d18d19), null, (0, $74Zh5.jsx)($303ba37d2d9486ca$export$88530751e3977073, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
                createAnalyticsEvent: createAnalyticsEvent
            }))));
        }
    }));
});
var $303ba37d2d9486ca$var$RendererWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(function(props) {
    var allowColumnSorting = props.allowColumnSorting, allowNestedHeaderLinks = props.allowNestedHeaderLinks, innerRef = props.innerRef, appearance = props.appearance, contentMode = props.contentMode, children = props.children, onClick = props.onClick, onMouseDown = props.onMouseDown, useBlockRenderForCodeBlock = props.useBlockRenderForCodeBlock, addTelepointer = props.addTelepointer, ssr = props.ssr, isInsideOfInlineExtension = props.isInsideOfInlineExtension, allowTableResizing = props.allowTableResizing, isTopLevelRenderer = props.isTopLevelRenderer, allowRendererContainerStyles = props.allowRendererContainerStyles;
    var createTelepointer = function createTelepointer() {
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- telepointer span for collaborative presence
        var telepointer = document.createElement('span');
        telepointer.textContent = "\u200B";
        telepointer.id = (0, $13ECD.TELEPOINTER_ID);
        return telepointer;
    };
    var initialUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(true);
    var _useRendererContext3 = (0, $ky5Ao.useRendererContext)(), nestedRendererType = _useRendererContext3.nestedRendererType;
    (0, $5FkrB.useEffect)(function() {
        // We must check if window is defined, if it isn't we are in a SSR environment
        // and we don't want to add the telepointer
        if (typeof window !== 'undefined' && addTelepointer && innerRef !== null && innerRef !== void 0 && innerRef.current) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            var _renderer = innerRef.current.querySelector('.ak-renderer-document');
            if (initialUpdate.current) {
                var lastChild = _renderer.lastChild;
                lastChild && lastChild.appendChild(createTelepointer());
            }
            var mutateTelepointer = function mutateTelepointer(mutations) {
                mutations.forEach(function(mutation, _index) {
                    var _mutation$addedNodes$, _mutation$removedNode;
                    if (initialUpdate.current) {
                        var oldTelepointer = _renderer.querySelector("#".concat((0, $13ECD.TELEPOINTER_ID)));
                        if (oldTelepointer) oldTelepointer.remove();
                        var _lastChild = _renderer.lastChild;
                        _lastChild && _lastChild.appendChild(createTelepointer());
                        initialUpdate.current = false;
                    }
                    if (mutation.type === 'characterData') {
                        var parentNode = mutation.target.parentElement;
                        if (parentNode) {
                            var _oldTelepointer = _renderer.querySelector("#".concat((0, $13ECD.TELEPOINTER_ID)));
                            if (_oldTelepointer) _oldTelepointer.remove();
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            parentNode.appendChild(createTelepointer());
                        }
                    }
                    /**
           * When streaming ADF content, we may receive mutations where nodes get
           * replaced, rather than have characterData updated.
           *
           * Telepointer changes will also cause a childList mutation, so we manually ignore it.
           * Telepointer changes are always a singular node-adds or node-removes.
           */ if (mutation.type === 'childList' && !(mutation.addedNodes.length === 1 && ((_mutation$addedNodes$ = mutation.addedNodes[0]) === null || _mutation$addedNodes$ === void 0 ? void 0 : _mutation$addedNodes$.id) === (0, $13ECD.TELEPOINTER_ID) || mutation.removedNodes.length === 1 && ((_mutation$removedNode = mutation.removedNodes[0]) === null || _mutation$removedNode === void 0 ? void 0 : _mutation$removedNode.id) === (0, $13ECD.TELEPOINTER_ID))) {
                        var _lastChild2 = _renderer.lastChild;
                        if (_lastChild2) {
                            /**
               * We want to place telepointer inside content (which has data-renderer-start-pos) and
               * inside lines in codeblocks (which have data-ds--code--row).
               */ var contentElements = _lastChild2.querySelectorAll('[data-renderer-start-pos],[data-ds--code--row]');
                            var lastElement = contentElements[contentElements.length - 1];
                            var _oldTelepointer2 = _renderer.querySelector("#".concat((0, $13ECD.TELEPOINTER_ID)));
                            if (lastElement) {
                                _oldTelepointer2 === null || _oldTelepointer2 === void 0 || _oldTelepointer2.remove();
                                lastElement === null || lastElement === void 0 || lastElement.appendChild(createTelepointer());
                            } else {
                                _oldTelepointer2 === null || _oldTelepointer2 === void 0 || _oldTelepointer2.remove();
                                _lastChild2 === null || _lastChild2 === void 0 || _lastChild2.appendChild(createTelepointer());
                            }
                        }
                    }
                });
            };
            var observer = new MutationObserver(mutateTelepointer);
            observer.observe(innerRef.current, {
                characterData: true,
                attributes: false,
                childList: true,
                subtree: true
            });
            return function() {
                return observer.disconnect();
            };
        }
    }, [
        innerRef,
        addTelepointer
    ]);
    var renderer = (0, $74Zh5.jsx)((0, $01HkO.WidthProvider), {
        className: "ak-renderer-wrapper is-".concat(appearance),
        "data-appearance": appearance,
        shouldCheckExistingValue: isInsideOfInlineExtension
    }, (0, $74Zh5.jsx)((0, $kMHA5.BaseTheme), {
        baseFontSize: (0, $cc8a699f38d2ae23$export$8e2864079bc476bd)(appearance, contentMode)
    }, (0, $74Zh5.jsx)((0, $cffc3bdc16b16678$export$77218b6ff680865f), {
        ssr: ssr
    }, (0, $74Zh5.jsx)((0, $df014fe6e70c2dc0$export$8f0929e72efe521f), {
        innerRef: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        appearance: appearance,
        contentMode: contentMode,
        allowNestedHeaderLinks: allowNestedHeaderLinks,
        allowColumnSorting: !!allowColumnSorting,
        useBlockRenderForCodeBlock: useBlockRenderForCodeBlock,
        allowAnnotations: props.allowAnnotations,
        allowTableResizing: allowTableResizing,
        allowRendererContainerStyles: allowRendererContainerStyles,
        isInsideSyncBlock: nestedRendererType === 'syncedBlock'
    }, children))));
    // We can only make the wrapper div query container when we have a known width.
    // This is also required for SSR to work correctly. As WidthProvider/WithConsumer will not have the correct width during SSR.
    //
    // allowRendererContainerStyles is not needed for comment container styling as container should always be set for comments
    if (appearance === 'comment' && isTopLevelRenderer) return (0, $74Zh5.jsx)("div", {
        css: $303ba37d2d9486ca$var$setAsQueryContainerStyles
    }, renderer);
    // We are setting this wrapper div as query container conditionally.
    // Only apply container-type = inline-size when having a known width in full-page/full-width/comment mode.
    // Otherwise when appearance is unspecified the renderer size is decided by the content.
    // In this case we can't set the container-type = inline-size as it will collapse width to 0.
    return (appearance === 'full-page' || appearance === 'full-width' || appearance === 'max') && // In case of having excerpt-include on page there are multiple renderers nested.
    // Make sure only the root renderer is set to be query container.
    isTopLevelRenderer && allowRendererContainerStyles ? (0, $74Zh5.jsx)("div", {
        css: $303ba37d2d9486ca$var$setAsQueryContainerStyles
    }, renderer) : renderer;
});
var $303ba37d2d9486ca$var$RootRendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext(null);
function $303ba37d2d9486ca$var$RendererActionsInternalUpdater(_ref2) {
    var children = _ref2.children, doc = _ref2.doc, schema = _ref2.schema, onAnalyticsEvent = _ref2.onAnalyticsEvent;
    var rootRendererContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useContext($303ba37d2d9486ca$var$RootRendererContext);
    var actions = (0, $5FkrB.useContext)((0, $lMzAH.RendererContext));
    var rendererRef = (0, $5FkrB.useRef)(null);
    // This doc is used by the renderer actions when applying comments to the document.
    // (via hand crafted steps based on non prosemirror based position calculations)
    // It is set to the root renderer's doc as otherwise the resulting document will
    // be incorrect (nested renderers use a fake document which represents a subset
    // of the actual document).
    // If rootRendererContextValue is set -- we are inside a nested renderer
    // and should always use the doc from the root renderer.
    // Otherwise we are in the root renderer and set the doc to the current doc.
    var _doc = rootRendererContextValue ? rootRendererContextValue.doc : doc;
    (0, $5FkrB.useLayoutEffect)(function() {
        if (_doc) actions._privateRegisterRenderer(rendererRef, _doc, schema, onAnalyticsEvent);
        else actions._privateUnregisterRenderer();
        return function() {
            return actions._privateUnregisterRenderer();
        };
    }, [
        actions,
        schema,
        _doc,
        onAnalyticsEvent
    ]);
    // Memoised so nested renderers don't re-render on every root renderer render
    // when the doc itself is unchanged.
    var rootRendererValue = (0, $5FkrB.useMemo)(function() {
        return {
            doc: _doc
        };
    }, [
        _doc
    ]);
    return (0, $74Zh5.jsx)($303ba37d2d9486ca$var$RootRendererContext.Provider, {
        value: rootRendererValue
    }, children);
}
// Usage notes:
// Used by Confluence for nested renderers
// For the View page renderer - see RendererWithAnalytics
var $303ba37d2d9486ca$var$RendererWithAnnotationSelection = function RendererWithAnnotationSelection(props) {
    var allowAnnotations = props.allowAnnotations, adfDocument = props.document;
    var localRef = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(null);
    var innerRef = props.innerRef || localRef;
    if (!allowAnnotations) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return (0, $74Zh5.jsx)($303ba37d2d9486ca$export$af81ffb59b6ef0dd, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        innerRef: innerRef
    }, props));
    return (0, $74Zh5.jsx)((0, $lMzAH.RendererActionsContext), null, (0, $74Zh5.jsx)((0, $nOuq8.AnnotationsWrapper), {
        rendererRef: innerRef,
        adfDocument: adfDocument,
        annotationProvider: props.annotationProvider,
        isNestedRender: true
    }, (0, $74Zh5.jsx)($303ba37d2d9486ca$export$af81ffb59b6ef0dd, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        innerRef: innerRef
    }, props, {
        featureFlags: props.featureFlags
    }))));
};
var // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/* @deprecated using this version of the renderer causes the RendererActions to inaccessible from any consumers */ $303ba37d2d9486ca$export$2e2bcd8739ae039 = $303ba37d2d9486ca$var$RendererWithAnnotationSelection;




const $b1e0b601f9d37334$var$messages = {
    contentDisplayErrorTItle: {
        id: 'adfContentSection.contentDisplayError',
        defaultMessage: 'Content Display Error',
        description: 'Title for error message when ADF content cannot be displayed'
    },
    contentDisplayErrorDescription: {
        id: 'adfContentSection.contentDisplayErrorDescription',
        defaultMessage: 'The content for this section could not be displayed due to a formatting issue.',
        description: 'Description for error message when ADF content cannot be displayed'
    }
};
const $b1e0b601f9d37334$export$56108d98a201729 = ({ content: content, title: title })=>{
    const { formatMessage: formatMessage } = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    if (!content) return null;
    let parsedDocument;
    try {
        parsedDocument = JSON.parse(content);
    } catch (error) {
        // Log the error for debugging purposes
        console.error('Failed to parse ADF content:', error);
        return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $4Pn6z.Box), {
            paddingBlockEnd: "space.400",
            children: [
                title && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                    paddingBlockEnd: "space.100",
                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $bb0Oq.default), {
                        as: "h2",
                        size: "small",
                        children: title
                    })
                }),
                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ac2404b057b8688e$export$2e2bcd8739ae039), {
                    appearance: "warning",
                    title: formatMessage($b1e0b601f9d37334$var$messages.contentDisplayErrorTItle),
                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
                        children: formatMessage($b1e0b601f9d37334$var$messages.contentDisplayErrorDescription)
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $4Pn6z.Box), {
        paddingBlockEnd: "space.400",
        children: [
            title && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                paddingBlockEnd: "space.100",
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $bb0Oq.default), {
                    as: "h2",
                    size: "small",
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $303ba37d2d9486ca$export$2e2bcd8739ae039), {
                document: parsedDocument
            })
        ]
    });
};
var $b1e0b601f9d37334$export$2e2bcd8739ae039 = $b1e0b601f9d37334$export$56108d98a201729;




var $4Pn6z = parcelRequire("4Pn6z");
var $ifpPH = parcelRequire("ifpPH");
var $gDiFE = parcelRequire("gDiFE");

var $bb0Oq = parcelRequire("bb0Oq");




const $f521c9d158c3d71f$var$messages = (0, $7e94896e68874ec2$export$1adfeb024f5185b)({
    appsImpactedTitle: {
        id: 'appUpdatesDetails.sidebar.appsImpactedTitle',
        defaultMessage: 'Apps impacted',
        description: 'Title for the section displaying apps impacted by the update'
    },
    impactRatingTitle: {
        id: 'appUpdatesDetails.sidebar.impactRatingTitle',
        defaultMessage: 'Change impact',
        description: 'Title for the impact rating section in the sidebar'
    },
    changeTypeTitle: {
        id: 'appUpdatesDetails.sidebar.changeTypeTitle',
        defaultMessage: 'Contextual tags',
        description: 'Title for the change type (tags) section in the sidebar'
    }
});
const $f521c9d158c3d71f$var$titleStyles = (0, $gDiFE.xcss)({
    marginBlockEnd: 'space.100'
});
const $f521c9d158c3d71f$var$contentStyles = (0, $gDiFE.xcss)({
    fontWeight: 'font.weight.regular',
    color: 'color.text.subtlest',
    marginBlockStart: 'space.150',
    gap: 'space.100'
});
const $f521c9d158c3d71f$var$productItemStyles = (0, $gDiFE.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100'
});
const $f521c9d158c3d71f$export$da96d30cc2e733ab = ({ products: products, impactRating: impactRating, tags: tags })=>{
    const { formatMessage: formatMessage } = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    const hasProducts = products && products.length > 0;
    const hasTags = tags && tags.length > 0;
    const shouldShowContextualTags = (0, $c78886f48293f91c$export$b40ec24ac8275656)((0, $86626a3c150b02ba$export$5fb62a9fe732a843).contextualTagsBeta);
    const hasVisibleImpactRating = Boolean(impactRating);
    const hasVisibleTags = shouldShowContextualTags && hasTags;
    // Don't render if nothing to show
    if (!hasProducts && !hasVisibleImpactRating && !hasVisibleTags) return null;
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
        space: "space.300",
        children: [
            hasVisibleImpactRating && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("section", {
                "data-testid": "app-impacted-sidebar-impact-rating",
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                        xcss: $f521c9d158c3d71f$var$titleStyles,
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $bb0Oq.default), {
                            as: "div",
                            size: "small",
                            children: formatMessage($f521c9d158c3d71f$var$messages.impactRatingTitle)
                        })
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                        xcss: $f521c9d158c3d71f$var$contentStyles,
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d26747ad8d2a0268$export$2a5158d64a074be2), {
                            impactRating: impactRating
                        })
                    })
                ]
            }),
            hasVisibleTags && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("section", {
                "data-testid": "app-impacted-sidebar-tags",
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                        xcss: $f521c9d158c3d71f$var$titleStyles,
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $bb0Oq.default), {
                            as: "div",
                            size: "small",
                            children: formatMessage($f521c9d158c3d71f$var$messages.changeTypeTitle)
                        })
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                        xcss: $f521c9d158c3d71f$var$contentStyles,
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $fbecf69dc9e04116$export$3c86caed05f80ae7), {
                            tags: tags
                        })
                    })
                ]
            }),
            hasProducts && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("section", {
                "data-testid": "app-impacted-sidebar-products",
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                        xcss: $f521c9d158c3d71f$var$titleStyles,
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $bb0Oq.default), {
                            as: "div",
                            size: "small",
                            children: formatMessage($f521c9d158c3d71f$var$messages.appsImpactedTitle)
                        })
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                        xcss: $f521c9d158c3d71f$var$contentStyles,
                        children: (0, $ace4c485fd808422$export$e3760658a711f2d3)(products).map((productType)=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $4Pn6z.Box), {
                                xcss: $f521c9d158c3d71f$var$productItemStyles,
                                testId: `app-display-${productType}`,
                                children: [
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $7397f708924e0bda$export$1a199e029d5e93d6), {
                                        productType: productType,
                                        size: "small",
                                        testId: "product-list-primary-icon"
                                    }),
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
                                        children: (0, $d3185276e14a4c2b$export$44fea6589b7ddc92)(productType)
                                    })
                                ]
                            }, productType))
                    })
                ]
            })
        ]
    });
};
var $f521c9d158c3d71f$export$2e2bcd8739ae039 = $f521c9d158c3d71f$export$da96d30cc2e733ab;




var $4Pn6z = parcelRequire("4Pn6z");
var $1qQas = parcelRequire("1qQas");
var $ifpPH = parcelRequire("ifpPH");
var $gDiFE = parcelRequire("gDiFE");







const $bb106d656d239203$var$summaryItemStyles = (0, $gDiFE.xcss)({
    minWidth: '0',
    alignItems: 'flex-start'
});
// Ensures all header labels align on the same baseline,
// even when some headers include the AIDisclaimer (icon + lozenge).
const $bb106d656d239203$var$headerStyles = (0, $gDiFE.xcss)({
    minHeight: '24px',
    display: 'flex',
    alignItems: 'center'
});
const $bb106d656d239203$var$tagsStyles = (0, $gDiFE.xcss)({
    marginInlineStart: 'space.negative.050'
});
const $bb106d656d239203$var$messages = (0, $7e94896e68874ec2$export$1adfeb024f5185b)({
    rolloutSchedule: {
        id: 'appUpdatesDetails.changelog.rolloutSchedule',
        defaultMessage: 'Rollout schedule',
        description: 'Label for rollout schedule information'
    },
    status: {
        id: 'appUpdatesDetails.changelog.status',
        defaultMessage: 'Status',
        description: 'Label for update status information'
    },
    changeType: {
        id: 'appUpdatesDetails.changelog.changeType',
        defaultMessage: 'Change type',
        description: 'Label for original (non-AI) change type'
    },
    changeImpact: {
        id: 'appUpdatesDetails.changelog.changeImpact',
        defaultMessage: 'Change impact',
        description: 'Label for AI-generated impact rating'
    },
    contextualTags: {
        id: 'appUpdatesDetails.changelog.contextualTags',
        defaultMessage: 'Contextual tags',
        description: 'Label for AI-generated contextual tags'
    }
});
const $bb106d656d239203$export$ab8b745e030c7e6f = ({ status: status, type: type, releaseStartDate: releaseStartDate, releaseEndDate: releaseEndDate, impactRating: impactRating, tags: tags })=>{
    const { formatMessage: formatMessage } = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    const shouldShowContextualTags = (0, $c78886f48293f91c$export$b40ec24ac8275656)((0, $86626a3c150b02ba$export$5fb62a9fe732a843).contextualTagsBeta);
    const hasBaseMetadata = Boolean(status || type || releaseStartDate || releaseEndDate);
    const hasImpactRating = Boolean(impactRating);
    const hasContextualTags = Boolean(tags?.length);
    const shouldRenderImpactMetadata = hasBaseMetadata || hasImpactRating;
    const shouldRenderContextualTagsMetadata = shouldShowContextualTags && (hasBaseMetadata || hasContextualTags);
    // Don't render if no visible metadata is available.
    if (!hasBaseMetadata && !hasImpactRating && !(shouldShowContextualTags && hasContextualTags)) return null;
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $1qQas.Inline), {
        space: "space.400",
        alignBlock: "start",
        shouldWrap: true,
        children: [
            status && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                space: "space.100",
                xcss: $bb106d656d239203$var$summaryItemStyles,
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                        xcss: $bb106d656d239203$var$headerStyles,
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
                            size: "small",
                            weight: "bold",
                            children: formatMessage($bb106d656d239203$var$messages.status)
                        })
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $fe4fcc4b7b323fa4$export$330c774339d320ad), {
                        status: status
                    })
                ]
            }),
            type && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                space: "space.100",
                xcss: $bb106d656d239203$var$summaryItemStyles,
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                        xcss: $bb106d656d239203$var$headerStyles,
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
                            size: "small",
                            weight: "bold",
                            children: formatMessage($bb106d656d239203$var$messages.changeType)
                        })
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $10eaae4bdfb59f21$export$1abc4eff6ef230bd), {
                        type: type
                    })
                ]
            }),
            (releaseStartDate || releaseEndDate) && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                space: "space.100",
                xcss: $bb106d656d239203$var$summaryItemStyles,
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                        xcss: $bb106d656d239203$var$headerStyles,
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
                            size: "small",
                            weight: "bold",
                            children: formatMessage($bb106d656d239203$var$messages.rolloutSchedule)
                        })
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $373b864dc2406021$export$c119e7a38ceabb6b), {
                        startDate: releaseStartDate,
                        endDate: releaseEndDate,
                        status: status
                    })
                ]
            }),
            shouldRenderImpactMetadata && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                space: "space.100",
                xcss: $bb106d656d239203$var$summaryItemStyles,
                alignInline: "start",
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                        xcss: $bb106d656d239203$var$headerStyles,
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9d0c6ca2818366fa$export$e0542ba0c737fe5c), {
                            label: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
                                size: "small",
                                weight: "bold",
                                children: formatMessage($bb106d656d239203$var$messages.changeImpact)
                            })
                        })
                    }),
                    impactRating && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d26747ad8d2a0268$export$2a5158d64a074be2), {
                        impactRating: impactRating
                    })
                ]
            }),
            shouldRenderContextualTagsMetadata && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                space: "space.0",
                xcss: $bb106d656d239203$var$summaryItemStyles,
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                        xcss: $bb106d656d239203$var$headerStyles,
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9d0c6ca2818366fa$export$e0542ba0c737fe5c), {
                            label: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
                                size: "small",
                                weight: "bold",
                                children: formatMessage($bb106d656d239203$var$messages.contextualTags)
                            })
                        })
                    }),
                    tags && tags.length > 0 && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                        xcss: $bb106d656d239203$var$tagsStyles,
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $fbecf69dc9e04116$export$3c86caed05f80ae7), {
                            tags: tags
                        })
                    })
                ]
            })
        ]
    });
};
var $bb106d656d239203$export$2e2bcd8739ae039 = $bb106d656d239203$export$ab8b745e030c7e6f;



var $5FkrB = parcelRequire("5FkrB");

var $4Pn6z = parcelRequire("4Pn6z");
var $gDiFE = parcelRequire("gDiFE");

var $9ztDu = parcelRequire("9ztDu");
const $43a52dbdb7ebc3db$var$wrapperStyles = (0, $gDiFE.xcss)({
    width: '100%',
    overflow: 'hidden',
    lineHeight: '0'
});
const $43a52dbdb7ebc3db$var$spinnerContainerStyles = (0, $gDiFE.xcss)({
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute'
});
const $43a52dbdb7ebc3db$var$imageContainerStyles = (0, $gDiFE.xcss)({
    position: 'relative',
    width: '100%'
});
/**
 * Validates that the URL is safe to load (not a javascript: URL)
 */ const $43a52dbdb7ebc3db$var$isValidImageUrl = (url)=>{
    try {
        // Check for javascript: protocol
        if (url.toLowerCase().startsWith('javascript:')) return false;
        // Check for data: URLs that might contain script
        if (url.toLowerCase().startsWith('data:')) return false;
        return true;
    } catch  {
        return false;
    }
};
const $43a52dbdb7ebc3db$export$4935cefa9e8adac4 = ({ src: src, altTag: altTag, title: title, width: width, height: height, testId: testId, onLoadError: onLoadError, aspectRatio: aspectRatio })=>{
    const [isLoading, setIsLoading] = (0, $5FkrB.useState)(true);
    const [hasError, setHasError] = (0, $5FkrB.useState)(false);
    // Validate URL on mount/src change
    const isValidUrl = $43a52dbdb7ebc3db$var$isValidImageUrl(src);
    const handleImageLoad = (0, $5FkrB.useCallback)(()=>{
        setIsLoading(false);
    }, []);
    const handleImageError = (0, $5FkrB.useCallback)(()=>{
        setHasError(true);
        setIsLoading(false);
        onLoadError?.();
    }, [
        onLoadError
    ]);
    // Return null if URL is invalid
    if (!isValidUrl) return null;
    // Return null if image failed to load
    if (hasError) return null;
    const imgStyles = {
        width: width ? typeof width === 'number' ? `${width}px` : width : '100%',
        height: height ? typeof height === 'number' ? `${height}px` : height : 'auto',
        objectFit: 'cover',
        objectPosition: 'center',
        transition: 'opacity 200ms ease-in-out',
        opacity: isLoading ? 0 : 1,
        display: 'block',
        aspectRatio: aspectRatio
    };
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
        xcss: $43a52dbdb7ebc3db$var$wrapperStyles,
        testId: testId,
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $4Pn6z.Box), {
            xcss: $43a52dbdb7ebc3db$var$imageContainerStyles,
            children: [
                isLoading && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                    xcss: $43a52dbdb7ebc3db$var$spinnerContainerStyles,
                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9ztDu.default), {
                        interactionName: "content-image-loading"
                    })
                }),
                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("img", {
                    src: src,
                    alt: altTag,
                    title: title,
                    onLoad: handleImageLoad,
                    onError: handleImageError,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    style: imgStyles
                })
            ]
        })
    });
};
var $43a52dbdb7ebc3db$export$2e2bcd8739ae039 = $43a52dbdb7ebc3db$export$4935cefa9e8adac4;



var $k7fIB = parcelRequire("k7fIB");

const $835ddb2f29e7ae63$var$messages = (0, $7e94896e68874ec2$export$1adfeb024f5185b)({
    backAction: {
        id: 'appUpdatesDetails.backAction',
        defaultMessage: 'Back to release notes',
        description: 'Button text to navigate back to the updates list'
    },
    notFound: {
        id: 'appUpdatesDetails.notFound',
        defaultMessage: 'This release note could not be found. Use the back button to return to release notes.',
        description: 'Error message displayed when an update cannot be found'
    },
    error: {
        id: 'appUpdatesDetails.error',
        defaultMessage: 'Unable to load this release note. Use the back button to return and try again.',
        description: 'Error message displayed when update fails to load'
    },
    loading: {
        id: 'appUpdatesDetails.loading',
        defaultMessage: 'Loading release note\u2026',
        description: 'Loading message while fetching update details'
    },
    keyChanges: {
        id: 'appUpdatesDetails.keyChanges',
        defaultMessage: 'Key changes',
        description: 'Section title for key changes'
    },
    benefits: {
        id: 'appUpdatesDetails.benefits',
        defaultMessage: 'Benefits',
        description: 'Section title for benefits'
    },
    reasonForChange: {
        id: 'appUpdatesDetails.reasonForChange',
        defaultMessage: 'Reason for the change',
        description: 'Section title for reason for change'
    },
    prepareForChange: {
        id: 'appUpdatesDetails.prepareForChange',
        defaultMessage: 'How to prepare for the change',
        description: 'Section title for prepare for change'
    },
    getStarted: {
        id: 'appUpdatesDetails.getStarted',
        defaultMessage: 'Getting started',
        description: 'Section title for getting started'
    },
    browserTabTitleSuffix: {
        id: 'appUpdatesDetails.browserTabTitleSuffix',
        defaultMessage: 'Release Notes | Atlassian Community',
        description: 'Browser tab title for the release note details page'
    }
});
const $835ddb2f29e7ae63$var$titleContainerStyles = (0, $gDiFE.xcss)({
    marginBlockStart: 'space.300'
});
const $835ddb2f29e7ae63$var$mainSectionStyles = (0, $gDiFE.xcss)({
    flex: 2
});
const $835ddb2f29e7ae63$var$sideSectionStyles = (0, $gDiFE.xcss)({
    flex: 1,
    marginBlockStart: 'space.500'
});
const $835ddb2f29e7ae63$var$imageContainerStyles = (0, $gDiFE.xcss)({
    marginBlockEnd: 'space.400',
    overflow: 'hidden',
    lineHeight: 'space.0',
    maxWidth: '800px'
});
const $835ddb2f29e7ae63$var$contentSectionStyles = (0, $gDiFE.xcss)({
    marginBlockStart: 'space.300'
});
const $835ddb2f29e7ae63$var$renderImage = (update)=>{
    if (!update?.featuredImage) return null;
    const { url: url, altTag: altTag, title: title, width: width, height: height } = update.featuredImage;
    const isHorizontal = width >= height;
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
        xcss: $835ddb2f29e7ae63$var$imageContainerStyles,
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $43a52dbdb7ebc3db$export$4935cefa9e8adac4), {
            src: url,
            altTag: altTag,
            title: title,
            width: isHorizontal ? '100%' : width,
            height: isHorizontal ? 'auto' : height,
            aspectRatio: isHorizontal ? 'unset' : '4 / 3'
        })
    });
};
const $835ddb2f29e7ae63$export$b1cf0b871d8be4ff = ()=>{
    const { formatMessage: formatMessage } = (0, $50e1cdc87cad912e$export$2e2bcd8739ae039)();
    const [routerState] = (0, $b421c015f5018cd0$export$9a302a45f65d0572)();
    const { sendScreenEvent: sendScreenEvent } = (0, $a442bdf486731fcc$export$62b6ee20d27ead99)();
    const { analyticsOptOut: analyticsOptOut } = (0, $38056d680fac42ff$export$b224af886b957a5e)();
    // TODO: - Fix bug: If the details page was opened in a new tab this doesn't do anything.
    // If it says "go back to release notes page" and you click it, user expects it to work.
    const handleBackClick = ()=>window.history.back();
    const updateId = routerState.match.params.id || null;
    const { update: update, isUpdateLoading: isUpdateLoading, hasErrors: hasErrors } = (0, $aae63e431edf6a1c$export$d1b34fec48b30a4f)(updateId);
    // Mark the update as read after the user has spent READ_TIME_THRESHOLD_MS on the page.
    // Only runs when: user has not opted out of analytics, and data has loaded.
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(()=>{
        if (analyticsOptOut || !update || !updateId || !update.firstPublishedAt) return;
        const timerId = setTimeout(()=>{
            (0, $15b90d5900f709a5$export$dc76bba8c4f0075f)({
                id: updateId,
                firstPublishedAt: update.firstPublishedAt
            });
        }, (0, $482ba924d5ad5f3a$export$502a1fb2342439ae));
        return ()=>clearTimeout(timerId);
    }, [
        analyticsOptOut,
        update,
        updateId
    ]);
    // Fire screen event after data loads so we can include changelogId and updatesAppTypes attributes
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(()=>{
        if (update && updateId) {
            const appTypes = update.productTypes?.join(',');
            sendScreenEvent((0, $3e8e9266fe04abe4$export$73f866ce8175509a).screen.appUpdatesDetailsScreen(updateId, appTypes).data);
        }
    }, [
        sendScreenEvent,
        update,
        updateId
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(()=>{
        if (typeof window.scrollTo === 'function') window.scrollTo({
            top: 0,
            left: 0
        });
    }, [
        updateId
    ]);
    // UFOSegment provides interaction context for UFOLoadHold.
    // UFOLoadHold holds the page-load interaction open while data is loading;
    // react-ufo auto-completes and sends the event when isUpdateLoading becomes false.
    // It is rendered in all states (loading, error, success) so the hold is always released.
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $0a97231e197d3e09$export$2e2bcd8739ae039), {
        name: "app-updates-details",
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $k7fIB.default), {
                name: "update-data",
                hold: isUpdateLoading
            }),
            isUpdateLoading && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                padding: "space.300",
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                    space: "space.300",
                    alignInline: "center",
                    children: [
                        /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9ztDu.default), {
                            label: formatMessage($835ddb2f29e7ae63$var$messages.loading)
                        }),
                        /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
                            children: formatMessage($835ddb2f29e7ae63$var$messages.loading)
                        })
                    ]
                })
            }),
            !isUpdateLoading && (!update || hasErrors) && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                as: "main",
                padding: "space.300",
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                    space: "space.300",
                    children: [
                        /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $dUWEU.default), {
                            appearance: "primary",
                            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($fiGqm))),
                            onClick: handleBackClick,
                            children: formatMessage($835ddb2f29e7ae63$var$messages.backAction)
                        }),
                        /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ifpPH.Text), {
                            color: "color.text.danger",
                            children: formatMessage(hasErrors ? $835ddb2f29e7ae63$var$messages.error : $835ddb2f29e7ae63$var$messages.notFound)
                        })
                    ]
                })
            }),
            !isUpdateLoading && update && !hasErrors && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $4Pn6z.Box), {
                as: "main",
                paddingBlockStart: "space.300",
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $448e9b7b3295f6e4$export$dcef8f9bb9a41431), {
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("title", {
                            children: formatMessage($835ddb2f29e7ae63$var$messages.browserTabTitleSuffix)
                        })
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $dUWEU.default), {
                            appearance: "subtle",
                            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($fiGqm))),
                            onClick: handleBackClick,
                            children: formatMessage($835ddb2f29e7ae63$var$messages.backAction)
                        })
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $2kuK2.Flex), {
                        gap: "space.150",
                        children: [
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                                xcss: $835ddb2f29e7ae63$var$mainSectionStyles,
                                space: "space.400",
                                children: [
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                                        xcss: $835ddb2f29e7ae63$var$titleContainerStyles,
                                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $bb0Oq.default), {
                                            as: "h1",
                                            size: "xxlarge",
                                            children: update.title
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $bb106d656d239203$export$ab8b745e030c7e6f), {
                                        status: update.status,
                                        type: update.type,
                                        releaseStartDate: update.releaseStartDate,
                                        releaseEndDate: update.releaseEndDate,
                                        impactRating: update.impactRating,
                                        tags: update.tags
                                    }),
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $2ab0bce1a46aed9c$export$2e0a83ec2e27ecbb), {}),
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $4Pn6z.Box), {
                                        xcss: $835ddb2f29e7ae63$var$contentSectionStyles,
                                        children: [
                                            update.summary && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $b1e0b601f9d37334$export$56108d98a201729), {
                                                content: update.summary
                                            }),
                                            $835ddb2f29e7ae63$var$renderImage(update),
                                            update.keyChanges && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $b1e0b601f9d37334$export$56108d98a201729), {
                                                content: update.keyChanges,
                                                title: formatMessage($835ddb2f29e7ae63$var$messages.keyChanges)
                                            }),
                                            update.benefitsList && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $b1e0b601f9d37334$export$56108d98a201729), {
                                                content: update.benefitsList,
                                                title: formatMessage($835ddb2f29e7ae63$var$messages.benefits)
                                            }),
                                            update.reasonForChange && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $b1e0b601f9d37334$export$56108d98a201729), {
                                                content: update.reasonForChange,
                                                title: formatMessage($835ddb2f29e7ae63$var$messages.reasonForChange)
                                            }),
                                            update.prepareForChange && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $b1e0b601f9d37334$export$56108d98a201729), {
                                                content: update.prepareForChange,
                                                title: formatMessage($835ddb2f29e7ae63$var$messages.prepareForChange)
                                            }),
                                            update.getStarted && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $b1e0b601f9d37334$export$56108d98a201729), {
                                                content: update.getStarted,
                                                title: formatMessage($835ddb2f29e7ae63$var$messages.getStarted)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            update.products && update.products.length > 0 && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                                xcss: $835ddb2f29e7ae63$var$sideSectionStyles,
                                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $f521c9d158c3d71f$export$da96d30cc2e733ab), {
                                    products: update.productTypes
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $835ddb2f29e7ae63$export$2e2bcd8739ae039 = $835ddb2f29e7ae63$export$b1cf0b871d8be4ff;


const $822a62c8758b6be8$export$352552ab999c9092 = {
    name: 'app-updates',
    path: '/release-notes',
    exact: true,
    component: (0, $5be66ddef5c7b610$export$617fd60bbdea4ae5),
    resources: []
};
const $822a62c8758b6be8$export$77c38a6734b02710 = {
    name: 'app-updates-bundled-changes',
    path: (0, $749a6437bd4ec017$export$cd891b82501bb412).RELEASE_TRACKS_CHANGES,
    exact: true,
    component: (0, $5be66ddef5c7b610$export$617fd60bbdea4ae5),
    resources: []
};
const $822a62c8758b6be8$export$3ad0ba51c296adcf = {
    name: 'app-updates-legacy-bundled-changes',
    path: (0, $749a6437bd4ec017$export$cd891b82501bb412).LEGACY_BUNDLED_CHANGES,
    exact: true,
    component: ()=>(0, $5FkrB.createElement)((0, $d60bad8df7964b6c$export$2d8d895a0a0f636e), {
            to: (0, $749a6437bd4ec017$export$cd891b82501bb412).RELEASE_TRACKS_CHANGES
        }),
    resources: []
};
const $822a62c8758b6be8$export$527547b9491d1b85 = {
    name: 'app-updates-details',
    path: '/release-notes/:id',
    exact: true,
    component: (0, $835ddb2f29e7ae63$export$b1cf0b871d8be4ff),
    resources: []
};



'use strict';
function $9bb29d85db6f995e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}



var $3ZMUU = parcelRequire("3ZMUU");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $cb898722622e1bbe$var$toString } = Object.prototype;
const { getPrototypeOf: $cb898722622e1bbe$var$getPrototypeOf } = Object;
const { iterator: $cb898722622e1bbe$var$iterator, toStringTag: $cb898722622e1bbe$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $cb898722622e1bbe$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
const $cb898722622e1bbe$var$isUnsafeObjectKey = (prop)=>typeof prop === 'string' && (prop === '__proto__' || prop === 'constructor' || prop === 'prototype');
/**
 * Determine whether an inherited object must be treated as a shared-prototype
 * boundary. Cross-realm Object.prototype objects cannot be distinguished
 * reliably from application-created null-prototype objects because their
 * properties are mutable, so all inherited terminal prototypes are excluded
 * as a fail-closed boundary. A null-prototype source still keeps its own
 * properties, as produced by mergeConfig and other safe materialization paths.
 *
 * @param {*} obj The object to inspect
 * @param {*} prototype The object's prototype
 * @param {boolean} source Whether obj is the original traversal source
 *
 * @returns {boolean} True when obj is a safe prototype traversal boundary
 */ const $cb898722622e1bbe$var$isPrototypeBoundary = (obj, prototype, source)=>obj === Object.prototype || !source && prototype === null;
/**
 * Determine whether an object can retain its identity through code paths that
 * add, replace, and remove config properties without bypassing unsafe-key
 * filtering. Immutable objects, unsafe-key-bearing objects, and objects with
 * accessor or restricted data properties must be materialized instead.
 *
 * @param {*} obj The object to inspect
 *
 * @returns {boolean} True when every own property is safe and fully mutable
 */ const $cb898722622e1bbe$var$isSafeAndFullyMutable = (obj)=>{
    if (!Object.isExtensible(obj)) return false;
    const props = Object.getOwnPropertyNames(obj);
    if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(obj));
    return props.every((prop)=>{
        if ($cb898722622e1bbe$var$isUnsafeObjectKey(prop)) return false;
        const descriptor = Object.getOwnPropertyDescriptor(obj, prop);
        return !!descriptor && descriptor.configurable && descriptor.writable === true;
    });
};
/**
 * Walk the prototype chain (excluding the source realm's Object.prototype)
 * looking for an own `prop`. This distinguishes genuine own/inherited members
 * — including class accessors and template prototypes — from members injected
 * via Object.prototype pollution (e.g. `Object.prototype.username = '...'`),
 * which live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $cb898722622e1bbe$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        const prototype = $cb898722622e1bbe$var$getPrototypeOf(obj);
        if ($cb898722622e1bbe$var$isPrototypeBoundary(obj, prototype, obj === thing)) return false;
        if ($cb898722622e1bbe$var$hasOwnProperty(obj, prop)) return true;
        obj = prototype;
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $cb898722622e1bbe$var$getSafeProp = (obj, prop)=>obj != null && $cb898722622e1bbe$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
/**
 * Flatten an object and its application-defined prototype chain into a
 * null-prototype object. Members inherited only from the source realm's
 * Object.prototype are deliberately excluded, while class/template members
 * below that boundary are preserved.
 *
 * @param {*} thing The value to flatten
 *
 * @returns {*} A null-prototype copy, or the original value when it is already
 * structurally safe or is not an object
 */ const $cb898722622e1bbe$var$toSafeFlatObject = (thing)=>{
    if (thing == null || typeof thing !== 'object' && typeof thing !== 'function') return thing;
    const sourcePrototype = $cb898722622e1bbe$var$getPrototypeOf(thing);
    if (sourcePrototype === null && $cb898722622e1bbe$var$isSafeAndFullyMutable(thing)) return thing;
    const result = Object.create(null);
    const merged = Object.create(null);
    const seen = [];
    let current = thing;
    while(current != null){
        if (seen.indexOf(current) !== -1) break;
        seen.push(current);
        const prototype = current === thing ? sourcePrototype : $cb898722622e1bbe$var$getPrototypeOf(current);
        if ($cb898722622e1bbe$var$isPrototypeBoundary(current, prototype, current === thing)) break;
        const props = Object.getOwnPropertyNames(current);
        if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(current));
        for (const prop of props){
            if ($cb898722622e1bbe$var$isUnsafeObjectKey(prop)) continue;
            if (!$cb898722622e1bbe$var$hasOwnProperty(merged, prop)) {
                result[prop] = thing[prop];
                merged[prop] = true;
            }
        }
        current = prototype;
    }
    return result;
};
const $cb898722622e1bbe$var$kindOf = ((cache)=>(thing)=>{
        const str = $cb898722622e1bbe$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $cb898722622e1bbe$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$cb898722622e1bbe$var$kindOf(thing) === type;
};
const $cb898722622e1bbe$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $cb898722622e1bbe$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $cb898722622e1bbe$var$isUndefined = $cb898722622e1bbe$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $cb898722622e1bbe$var$isBuffer(val) {
    return val !== null && !$cb898722622e1bbe$var$isUndefined(val) && val.constructor !== null && !$cb898722622e1bbe$var$isUndefined(val.constructor) && $cb898722622e1bbe$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $cb898722622e1bbe$var$isArrayBuffer = $cb898722622e1bbe$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $cb898722622e1bbe$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $cb898722622e1bbe$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $cb898722622e1bbe$var$isString = $cb898722622e1bbe$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $cb898722622e1bbe$var$isFunction = $cb898722622e1bbe$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $cb898722622e1bbe$var$isNumber = $cb898722622e1bbe$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $cb898722622e1bbe$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $cb898722622e1bbe$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $cb898722622e1bbe$var$isPlainObject = (val)=>{
    if (!$cb898722622e1bbe$var$isObject(val)) return false;
    const prototype = $cb898722622e1bbe$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $cb898722622e1bbe$var$getPrototypeOf(prototype) === null) && // Treat safe own/inherited Symbol.toStringTag or Symbol.iterator members as
    // evidence the value is tagged/iterable, while ignoring members reachable
    // only through shared or terminal prototype boundaries.
    !$cb898722622e1bbe$var$hasOwnInPrototypeChain(val, $cb898722622e1bbe$var$toStringTag) && !$cb898722622e1bbe$var$hasOwnInPrototypeChain(val, $cb898722622e1bbe$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $cb898722622e1bbe$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$cb898722622e1bbe$var$isObject(val) || $cb898722622e1bbe$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $cb898722622e1bbe$var$isDate = $cb898722622e1bbe$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $cb898722622e1bbe$var$isFile = $cb898722622e1bbe$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $cb898722622e1bbe$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $cb898722622e1bbe$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $cb898722622e1bbe$var$isBlob = $cb898722622e1bbe$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $cb898722622e1bbe$var$isFileList = $cb898722622e1bbe$var$kindOfTest('FileList');
const $cb898722622e1bbe$var$isSet = $cb898722622e1bbe$var$kindOfTest('Set');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $cb898722622e1bbe$var$isStream = (val)=>$cb898722622e1bbe$var$isObject(val) && $cb898722622e1bbe$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $cb898722622e1bbe$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $cb898722622e1bbe$var$G = $cb898722622e1bbe$var$getGlobal();
const $cb898722622e1bbe$var$FormDataCtor = typeof $cb898722622e1bbe$var$G.FormData !== 'undefined' ? $cb898722622e1bbe$var$G.FormData : undefined;
const $cb898722622e1bbe$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($cb898722622e1bbe$var$FormDataCtor && thing instanceof $cb898722622e1bbe$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $cb898722622e1bbe$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$cb898722622e1bbe$var$isFunction(thing.append)) return false;
    const kind = $cb898722622e1bbe$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $cb898722622e1bbe$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $cb898722622e1bbe$var$isURLSearchParams = $cb898722622e1bbe$var$kindOfTest('URLSearchParams');
const [$cb898722622e1bbe$var$isReadableStream, $cb898722622e1bbe$var$isRequest, $cb898722622e1bbe$var$isResponse, $cb898722622e1bbe$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($cb898722622e1bbe$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $cb898722622e1bbe$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $cb898722622e1bbe$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($cb898722622e1bbe$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($cb898722622e1bbe$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $cb898722622e1bbe$var$findKey(obj, key) {
    if ($cb898722622e1bbe$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $cb898722622e1bbe$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $cb898722622e1bbe$var$isContextDefined = (context)=>!$cb898722622e1bbe$var$isUndefined(context) && context !== $cb898722622e1bbe$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $cb898722622e1bbe$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $cb898722622e1bbe$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $cb898722622e1bbe$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $cb898722622e1bbe$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($cb898722622e1bbe$var$isPlainObject(existing) && $cb898722622e1bbe$var$isPlainObject(val)) result[targetKey] = $cb898722622e1bbe$var$merge(existing, val);
        else if ($cb898722622e1bbe$var$isPlainObject(val)) result[targetKey] = $cb898722622e1bbe$var$merge({}, val);
        else if ($cb898722622e1bbe$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$cb898722622e1bbe$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $cb898722622e1bbe$var$isBuffer(source)) continue;
        $cb898722622e1bbe$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $cb898722622e1bbe$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($cb898722622e1bbe$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $cb898722622e1bbe$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $cb898722622e1bbe$var$forEach(b, (val, key)=>{
        if (thisArg && $cb898722622e1bbe$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $9bb29d85db6f995e$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $cb898722622e1bbe$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $cb898722622e1bbe$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $cb898722622e1bbe$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $cb898722622e1bbe$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $cb898722622e1bbe$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $cb898722622e1bbe$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($cb898722622e1bbe$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$cb898722622e1bbe$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $cb898722622e1bbe$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $cb898722622e1bbe$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $cb898722622e1bbe$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$cb898722622e1bbe$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $cb898722622e1bbe$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $cb898722622e1bbe$var$isHTMLForm = $cb898722622e1bbe$var$kindOfTest('HTMLFormElement');
const $cb898722622e1bbe$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $cb898722622e1bbe$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $cb898722622e1bbe$var$isRegExp = $cb898722622e1bbe$var$kindOfTest('RegExp');
const $cb898722622e1bbe$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $cb898722622e1bbe$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $cb898722622e1bbe$var$freezeMethods = (obj)=>{
    $cb898722622e1bbe$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($cb898722622e1bbe$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$cb898722622e1bbe$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $cb898722622e1bbe$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $cb898722622e1bbe$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $cb898722622e1bbe$var$noop = ()=>{};
const $cb898722622e1bbe$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $cb898722622e1bbe$var$isSpecCompliantForm(thing) {
    return !!(thing && $cb898722622e1bbe$var$isFunction(thing.append) && thing[$cb898722622e1bbe$var$toStringTag] === 'FormData' && thing[$cb898722622e1bbe$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $cb898722622e1bbe$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($cb898722622e1bbe$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($cb898722622e1bbe$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                let target;
                if ($cb898722622e1bbe$var$isSet(source)) {
                    target = [];
                    for (const value of source){
                        const reducedValue = visit(value);
                        !$cb898722622e1bbe$var$isUndefined(reducedValue) && target.push(reducedValue);
                    }
                } else {
                    target = $cb898722622e1bbe$var$isArray(source) ? [] : {};
                    $cb898722622e1bbe$var$forEach(source, (value, key)=>{
                        const reducedValue = visit(value);
                        !$cb898722622e1bbe$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                    });
                }
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $cb898722622e1bbe$var$isAsyncFn = $cb898722622e1bbe$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $cb898722622e1bbe$var$isThenable = (thing)=>thing && ($cb898722622e1bbe$var$isObject(thing) || $cb898722622e1bbe$var$isFunction(thing)) && $cb898722622e1bbe$var$isFunction(thing.then) && $cb898722622e1bbe$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $cb898722622e1bbe$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $cb898722622e1bbe$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $cb898722622e1bbe$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $cb898722622e1bbe$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $cb898722622e1bbe$var$isFunction($cb898722622e1bbe$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $cb898722622e1bbe$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($cb898722622e1bbe$var$_global) : typeof $3ZMUU !== 'undefined' && $3ZMUU.nextTick || $cb898722622e1bbe$var$_setImmediate;
// *********************
const $cb898722622e1bbe$var$isIterable = (thing)=>thing != null && $cb898722622e1bbe$var$isFunction(thing[$cb898722622e1bbe$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $cb898722622e1bbe$var$isSafeIterable = (thing)=>thing != null && $cb898722622e1bbe$var$hasOwnInPrototypeChain(thing, $cb898722622e1bbe$var$iterator) && $cb898722622e1bbe$var$isIterable(thing);
var $cb898722622e1bbe$export$2e2bcd8739ae039 = {
    isArray: $cb898722622e1bbe$var$isArray,
    isArrayBuffer: $cb898722622e1bbe$var$isArrayBuffer,
    isBuffer: $cb898722622e1bbe$var$isBuffer,
    isFormData: $cb898722622e1bbe$var$isFormData,
    isArrayBufferView: $cb898722622e1bbe$var$isArrayBufferView,
    isString: $cb898722622e1bbe$var$isString,
    isNumber: $cb898722622e1bbe$var$isNumber,
    isBoolean: $cb898722622e1bbe$var$isBoolean,
    isObject: $cb898722622e1bbe$var$isObject,
    isPlainObject: $cb898722622e1bbe$var$isPlainObject,
    isEmptyObject: $cb898722622e1bbe$var$isEmptyObject,
    isReadableStream: $cb898722622e1bbe$var$isReadableStream,
    isRequest: $cb898722622e1bbe$var$isRequest,
    isResponse: $cb898722622e1bbe$var$isResponse,
    isHeaders: $cb898722622e1bbe$var$isHeaders,
    isUndefined: $cb898722622e1bbe$var$isUndefined,
    isDate: $cb898722622e1bbe$var$isDate,
    isFile: $cb898722622e1bbe$var$isFile,
    isReactNativeBlob: $cb898722622e1bbe$var$isReactNativeBlob,
    isReactNative: $cb898722622e1bbe$var$isReactNative,
    isBlob: $cb898722622e1bbe$var$isBlob,
    isRegExp: $cb898722622e1bbe$var$isRegExp,
    isFunction: $cb898722622e1bbe$var$isFunction,
    isStream: $cb898722622e1bbe$var$isStream,
    isURLSearchParams: $cb898722622e1bbe$var$isURLSearchParams,
    isTypedArray: $cb898722622e1bbe$var$isTypedArray,
    isFileList: $cb898722622e1bbe$var$isFileList,
    forEach: $cb898722622e1bbe$var$forEach,
    merge: $cb898722622e1bbe$var$merge,
    extend: $cb898722622e1bbe$var$extend,
    trim: $cb898722622e1bbe$var$trim,
    stripBOM: $cb898722622e1bbe$var$stripBOM,
    inherits: $cb898722622e1bbe$var$inherits,
    toFlatObject: $cb898722622e1bbe$var$toFlatObject,
    kindOf: $cb898722622e1bbe$var$kindOf,
    kindOfTest: $cb898722622e1bbe$var$kindOfTest,
    endsWith: $cb898722622e1bbe$var$endsWith,
    toArray: $cb898722622e1bbe$var$toArray,
    forEachEntry: $cb898722622e1bbe$var$forEachEntry,
    matchAll: $cb898722622e1bbe$var$matchAll,
    isHTMLForm: $cb898722622e1bbe$var$isHTMLForm,
    hasOwnProperty: $cb898722622e1bbe$var$hasOwnProperty,
    hasOwnProp: $cb898722622e1bbe$var$hasOwnProperty,
    hasOwnInPrototypeChain: $cb898722622e1bbe$var$hasOwnInPrototypeChain,
    getSafeProp: $cb898722622e1bbe$var$getSafeProp,
    toSafeFlatObject: $cb898722622e1bbe$var$toSafeFlatObject,
    reduceDescriptors: $cb898722622e1bbe$var$reduceDescriptors,
    freezeMethods: $cb898722622e1bbe$var$freezeMethods,
    toObjectSet: $cb898722622e1bbe$var$toObjectSet,
    toCamelCase: $cb898722622e1bbe$var$toCamelCase,
    noop: $cb898722622e1bbe$var$noop,
    toFiniteNumber: $cb898722622e1bbe$var$toFiniteNumber,
    findKey: $cb898722622e1bbe$var$findKey,
    global: $cb898722622e1bbe$var$_global,
    isContextDefined: $cb898722622e1bbe$var$isContextDefined,
    isSpecCompliantForm: $cb898722622e1bbe$var$isSpecCompliantForm,
    toJSONObject: $cb898722622e1bbe$var$toJSONObject,
    isAsyncFn: $cb898722622e1bbe$var$isAsyncFn,
    isThenable: $cb898722622e1bbe$var$isThenable,
    setImmediate: $cb898722622e1bbe$var$_setImmediate,
    asap: $cb898722622e1bbe$var$asap,
    isIterable: $cb898722622e1bbe$var$isIterable,
    isSafeIterable: $cb898722622e1bbe$var$isSafeIterable
};









'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $6e51a7800d926fe5$var$ignoreDuplicateOf = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $6e51a7800d926fe5$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        const hasKey = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(parsed, key);
        if (!key || hasKey && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp($6e51a7800d926fe5$var$ignoreDuplicateOf, key)) return;
        if (key === 'set-cookie') {
            if (hasKey) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = hasKey ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};



'use strict';
function $b4b7fdb921feec02$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $b4b7fdb921feec02$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $b4b7fdb921feec02$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $b4b7fdb921feec02$var$sanitizeValue(value, invalidChars) {
    if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(value)) return value.map((item)=>$b4b7fdb921feec02$var$sanitizeValue(item, invalidChars));
    return $b4b7fdb921feec02$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $b4b7fdb921feec02$export$9e344cffce061a22 = (value)=>$b4b7fdb921feec02$var$sanitizeValue(value, $b4b7fdb921feec02$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $b4b7fdb921feec02$export$59dd66c2a12d8f62 = (value)=>$b4b7fdb921feec02$var$sanitizeValue(value, $b4b7fdb921feec02$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $b4b7fdb921feec02$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $b4b7fdb921feec02$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


'use strict';
const $a107ecb812e3a6a9$var$$internals = Symbol('internals');
function $a107ecb812e3a6a9$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $a107ecb812e3a6a9$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(value) ? value.map($a107ecb812e3a6a9$var$normalizeValue) : (0, $b4b7fdb921feec02$export$9e344cffce061a22)(String(value));
}
function $a107ecb812e3a6a9$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $a107ecb812e3a6a9$var$parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function $a107ecb812e3a6a9$var$trimOWS(value) {
    let start = 0;
    let end = value.length;
    while(start < end){
        const code = value.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = value.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
}
function $a107ecb812e3a6a9$var$decodeQuotedString(value) {
    const last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 0x22 || value.charCodeAt(last) !== 0x22) return value;
    let decoded = '';
    for(let i = 1; i < last; i++){
        const code = value.charCodeAt(i);
        if (code === 0x22) return value;
        if (code === 0x5c) {
            i += 1;
            if (i >= last) return value;
        }
        decoded += value[i];
    }
    return decoded;
}
function $a107ecb812e3a6a9$var$parseParameters(value) {
    const parameters = Object.create(null);
    const str = String(value);
    let start = 0;
    let quoted = false;
    let escaped = false;
    function parseParameter(end) {
        const part = $a107ecb812e3a6a9$var$trimOWS(str.slice(start, end));
        const equals = part.indexOf('=');
        if (equals < 1) return;
        const name = $a107ecb812e3a6a9$var$trimOWS(part.slice(0, equals));
        if (!$a107ecb812e3a6a9$var$parameterNameRE.test(name)) return;
        const normalizedName = name.toLowerCase();
        if (normalizedName === '__proto__' || normalizedName === 'constructor' || normalizedName === 'prototype') return;
        const parameterValue = $a107ecb812e3a6a9$var$trimOWS(part.slice(equals + 1));
        parameters[normalizedName] = $a107ecb812e3a6a9$var$decodeQuotedString(parameterValue);
    }
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        if (quoted) {
            if (escaped) escaped = false;
            else if (code === 0x5c) escaped = true;
            else if (code === 0x22) quoted = false;
        } else if (code === 0x22) quoted = true;
        else if (code === 0x2c || code === 0x3b) {
            parseParameter(i);
            start = i + 1;
        }
    }
    parseParameter(str.length);
    return parameters;
}
const $a107ecb812e3a6a9$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $a107ecb812e3a6a9$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $a107ecb812e3a6a9$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $a107ecb812e3a6a9$var$buildAccessors(obj, header) {
    const accessorName = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $a107ecb812e3a6a9$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $a107ecb812e3a6a9$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $a107ecb812e3a6a9$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$a107ecb812e3a6a9$var$isValidHeaderName(header)) setHeaders((0, $6e51a7800d926fe5$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isObject(header) && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $a107ecb812e3a6a9$var$normalizeHeader(header);
        if (header) {
            const key = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $a107ecb812e3a6a9$var$parseTokens(value);
                if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $a107ecb812e3a6a9$var$normalizeHeader(header);
        if (header) {
            const key = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $a107ecb812e3a6a9$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $a107ecb812e3a6a9$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $a107ecb812e3a6a9$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $a107ecb812e3a6a9$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $a107ecb812e3a6a9$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $a107ecb812e3a6a9$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $a107ecb812e3a6a9$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        const value = this.get('set-cookie');
        return (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(value) ? value : value == null || value === false ? [] : [
            value
        ];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static parseParameters(value) {
        return $a107ecb812e3a6a9$var$parseParameters(value);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$a107ecb812e3a6a9$var$$internals] = this[$a107ecb812e3a6a9$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $a107ecb812e3a6a9$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $a107ecb812e3a6a9$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$a107ecb812e3a6a9$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $cb898722622e1bbe$export$2e2bcd8739ae039).reduceDescriptors($a107ecb812e3a6a9$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $cb898722622e1bbe$export$2e2bcd8739ae039).freezeMethods($a107ecb812e3a6a9$var$AxiosHeaders);
var $a107ecb812e3a6a9$export$2e2bcd8739ae039 = $a107ecb812e3a6a9$var$AxiosHeaders;


'use strict';
const $f9b1affb0498ba1f$export$6acd2efa8ac62a1b = '[REDACTED ****]';
function $f9b1affb0498ba1f$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $f9b1affb0498ba1f$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $a107ecb812e3a6a9$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isPlainObject(source) && $f9b1affb0498ba1f$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $f9b1affb0498ba1f$export$6acd2efa8ac62a1b : visit(value);
                if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
function $f9b1affb0498ba1f$var$stringifySafely(value) {
    try {
        return String(value);
    } catch (err) {
        return '';
    }
}
function $f9b1affb0498ba1f$var$aggregateErrorMessage(error) {
    const message = error.errors.map((entry)=>{
        try {
            return entry && entry.message ? $f9b1affb0498ba1f$var$stringifySafely(entry.message) : $f9b1affb0498ba1f$var$stringifySafely(entry);
        } catch (err) {
            return '';
        }
    }).filter(Boolean).join('; ');
    return message || error.name || 'AggregateError';
}
class $f9b1affb0498ba1f$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        // `AggregateError` (thrown by Node on dual-stack/Happy-Eyeballs connection
        // failures) has an empty `message`; its detail lives in `errors[]`. Without
        // this, the wrapped error surfaces with a blank message (see #6721).
        let message = error.message;
        if (!message && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(error.errors) && error.errors.length) message = $f9b1affb0498ba1f$var$aggregateErrorMessage(error);
        const axiosError = new $f9b1affb0498ba1f$var$AxiosError(message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $f9b1affb0498ba1f$var$redactConfig(config, redactKeys) : (0, $cb898722622e1bbe$export$2e2bcd8739ae039).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$f9b1affb0498ba1f$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$f9b1affb0498ba1f$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$f9b1affb0498ba1f$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$f9b1affb0498ba1f$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$f9b1affb0498ba1f$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$f9b1affb0498ba1f$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$f9b1affb0498ba1f$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$f9b1affb0498ba1f$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$f9b1affb0498ba1f$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$f9b1affb0498ba1f$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$f9b1affb0498ba1f$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$f9b1affb0498ba1f$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$f9b1affb0498ba1f$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$f9b1affb0498ba1f$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $f9b1affb0498ba1f$export$2e2bcd8739ae039 = $f9b1affb0498ba1f$var$AxiosError;


// eslint-disable-next-line strict
var $243db4f4ede3c5cf$export$2e2bcd8739ae039 = null;



'use strict';
const $ec2d6980f48e9528$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $ec2d6980f48e9528$var$isVisitable(thing) {
    return (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $ec2d6980f48e9528$var$removeBrackets(key) {
    return (0, $cb898722622e1bbe$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $ec2d6980f48e9528$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $ec2d6980f48e9528$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $ec2d6980f48e9528$var$isFlatArray(arr) {
    return (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(arr) && !arr.some($ec2d6980f48e9528$var$isVisitable);
}
const $ec2d6980f48e9528$var$predicates = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).toFlatObject((0, $cb898722622e1bbe$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $ec2d6980f48e9528$var$toFormData(obj, formData, options) {
    if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $243db4f4ede3c5cf$export$2e2bcd8739ae039) || FormData)();
    const option = (name, fallback)=>{
        const value = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).getSafeProp(options, name);
        return (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(value) ? fallback : value;
    };
    const metaTokens = option('metaTokens', true);
    // eslint-disable-next-line no-use-before-define
    const visitor = option('visitor') || defaultVisitor;
    const dots = option('dots', false);
    const indexes = option('indexes', false);
    const _Blob = option('Blob') || typeof Blob !== 'undefined' && Blob;
    const maxDepth = option('maxDepth', $ec2d6980f48e9528$export$659081b45d03227d);
    const useBlob = _Blob && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if ((0, $243db4f4ede3c5cf$export$2e2bcd8739ae039) && (0, $243db4f4ede3c5cf$export$2e2bcd8739ae039).isBufferAvailable()) return (0, $243db4f4ede3c5cf$export$2e2bcd8739ae039).from(value);
            throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.', (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isReactNative(formData) && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($ec2d6980f48e9528$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(value) && $ec2d6980f48e9528$var$isFlatArray(value) || ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFileList(value) || (0, $cb898722622e1bbe$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $ec2d6980f48e9528$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $ec2d6980f48e9528$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($ec2d6980f48e9528$var$isVisitable(value)) return true;
        formData.append($ec2d6980f48e9528$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($ec2d6980f48e9528$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $ec2d6980f48e9528$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $ec2d6980f48e9528$export$2e2bcd8739ae039 = $ec2d6980f48e9528$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $394be5798fbcf19f$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $394be5798fbcf19f$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $ec2d6980f48e9528$export$2e2bcd8739ae039)(params, this, options);
}
const $394be5798fbcf19f$var$prototype = $394be5798fbcf19f$var$AxiosURLSearchParams.prototype;
$394be5798fbcf19f$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$394be5798fbcf19f$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $394be5798fbcf19f$var$encode) : $394be5798fbcf19f$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $394be5798fbcf19f$export$2e2bcd8739ae039 = $394be5798fbcf19f$var$AxiosURLSearchParams;


'use strict';
function $09cc5760c042eaec$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $09cc5760c042eaec$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || '';
    const _options = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).getSafeProp(_options, 'encode') || $09cc5760c042eaec$export$c564cdbbe6da493;
    const serializeFn = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $394be5798fbcf19f$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
const $95dc0c3cfa5e38d6$var$$internals = Symbol('internals');
// `handlers` is public and may be replaced with a nullish value by user code;
// `clear()` has always tolerated that. Treat it as an empty stack rather than
// dereferencing it.
function $95dc0c3cfa5e38d6$var$countHandlers(handlers) {
    return handlers ? handlers.length : 0;
}
function $95dc0c3cfa5e38d6$var$trimHandlers(handlers) {
    if (!handlers) return;
    while(handlers.length && handlers[handlers.length - 1] === null)handlers.pop();
}
function $95dc0c3cfa5e38d6$var$syncHandlerEntries(manager, internals) {
    const handlers = manager.handlers;
    const length = $95dc0c3cfa5e38d6$var$countHandlers(handlers);
    if (handlers !== internals.handlersRef) {
        internals.handlersRef = handlers;
        internals.handlerEntries.clear();
    } else if (length !== internals.handlersLength) {
        if (!length) internals.handlerEntries.clear();
        else internals.handlerEntries.forEach(function removeStaleEntry(entry, id) {
            if (handlers[entry.index] !== entry.handler) internals.handlerEntries.delete(id);
        });
    }
    internals.handlersLength = length;
}
class $95dc0c3cfa5e38d6$var$InterceptorManager {
    constructor(){
        this.handlers = [];
        this[$95dc0c3cfa5e38d6$var$$internals] = {
            handlersRef: this.handlers,
            handlersLength: this.handlers.length,
            handlerEntries: new Map(),
            iterationDepth: 0,
            nextId: 0
        };
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        const handler = {
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        };
        const internals = this[$95dc0c3cfa5e38d6$var$$internals];
        if (this.handlers == null) this.handlers = [];
        $95dc0c3cfa5e38d6$var$syncHandlerEntries(this, internals);
        const id = internals.nextId++;
        this.handlers.push(handler);
        internals.handlerEntries.set(id, {
            handler: handler,
            index: this.handlers.length - 1
        });
        internals.handlersLength = this.handlers.length;
        return id;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        const internals = this[$95dc0c3cfa5e38d6$var$$internals];
        $95dc0c3cfa5e38d6$var$syncHandlerEntries(this, internals);
        const entry = internals.handlerEntries.get(id);
        if (entry) {
            internals.handlerEntries.delete(id);
            // Ignore IDs invalidated by clear or direct replacement of handlers.
            if (this.handlers[entry.index] !== entry.handler) return;
            this.handlers[entry.index] = null;
            // Do not reuse an index while forEach is walking its length snapshot.
            if (!internals.iterationDepth) {
                $95dc0c3cfa5e38d6$var$trimHandlers(this.handlers);
                internals.handlersLength = this.handlers.length;
            }
        }
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) {
            this.handlers = [];
            $95dc0c3cfa5e38d6$var$syncHandlerEntries(this, this[$95dc0c3cfa5e38d6$var$$internals]);
        }
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        const internals = this[$95dc0c3cfa5e38d6$var$$internals];
        $95dc0c3cfa5e38d6$var$syncHandlerEntries(this, internals);
        internals.iterationDepth++;
        try {
            (0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
                if (h !== null) fn(h);
            });
        } finally{
            if (!--internals.iterationDepth) {
                $95dc0c3cfa5e38d6$var$syncHandlerEntries(this, internals);
                $95dc0c3cfa5e38d6$var$trimHandlers(this.handlers);
                internals.handlersLength = $95dc0c3cfa5e38d6$var$countHandlers(this.handlers);
            }
        }
    }
}
var $95dc0c3cfa5e38d6$export$2e2bcd8739ae039 = $95dc0c3cfa5e38d6$var$InterceptorManager;





'use strict';
var $f10e0d1daedbcc26$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};






'use strict';
var $85d256adaf990c55$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $394be5798fbcf19f$export$2e2bcd8739ae039);


'use strict';
var $397fc345476ebefa$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $1ba8abde1bdba5ab$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $fd7572cf8dc78389$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $85d256adaf990c55$export$2e2bcd8739ae039,
        FormData: $397fc345476ebefa$export$2e2bcd8739ae039,
        Blob: $1ba8abde1bdba5ab$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $23b70ea44eade3d0$exports = {};
$parcel$export($23b70ea44eade3d0$exports, "hasBrowserEnv", () => $23b70ea44eade3d0$export$c4996c4b7b93b0bf);
$parcel$export($23b70ea44eade3d0$exports, "navigator", () => $23b70ea44eade3d0$export$ec7c8efa7f5790ae);
$parcel$export($23b70ea44eade3d0$exports, "hasStandardBrowserEnv", () => $23b70ea44eade3d0$export$c0bcc9250309d66);
$parcel$export($23b70ea44eade3d0$exports, "hasStandardBrowserWebWorkerEnv", () => $23b70ea44eade3d0$export$c81692cf5af97dac);
$parcel$export($23b70ea44eade3d0$exports, "origin", () => $23b70ea44eade3d0$export$f710a83a91838a36);
const $23b70ea44eade3d0$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $23b70ea44eade3d0$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $23b70ea44eade3d0$export$c0bcc9250309d66 = $23b70ea44eade3d0$export$c4996c4b7b93b0bf && (!$23b70ea44eade3d0$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($23b70ea44eade3d0$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $23b70ea44eade3d0$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $23b70ea44eade3d0$export$f710a83a91838a36 = $23b70ea44eade3d0$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $dd4365a6b7ba12cc$export$2e2bcd8739ae039 = {
    ...$23b70ea44eade3d0$exports,
    ...(0, $fd7572cf8dc78389$export$2e2bcd8739ae039)
};


'use strict';
function $46a1c96d89d8a991$export$2e2bcd8739ae039(data, options) {
    return (0, $ec2d6980f48e9528$export$2e2bcd8739ae039)(data, new (0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).isNode && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}






'use strict';
const $372f04b133c1df53$var$MAX_DEPTH = (0, $ec2d6980f48e9528$export$659081b45d03227d);
function $372f04b133c1df53$var$throwIfDepthExceeded(index) {
    if (index > $372f04b133c1df53$var$MAX_DEPTH) throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $372f04b133c1df53$var$MAX_DEPTH, (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $372f04b133c1df53$var$parsePropPath(name) {
    // foo[x][y][z] -> ['foo', 'x', 'y', 'z']
    // foo.x.y.z    -> ['foo', 'x', 'y', 'z']
    // A path is split on `.` and on `[...]` groups. A segment — whether written
    // in dot notation or captured inside brackets — may contain any character
    // except `.`, `[` and `]`, so a key like `user-name` or `user name` is kept
    // literal instead of being split (#5402). `.`, `[` and `]` keep their existing
    // meaning, e.g. `foo[bar.baz]` -> ['foo', 'bar', 'baz'] and `[]` is an array push.
    // Excluding `[` from the bracket group also makes the match fail fast at the
    // next `[`, so a malformed name cannot rescan to the end of the string from
    // every unmatched `[` — parsing stays linear in the length of the name.
    const path = [];
    const pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $372f04b133c1df53$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $372f04b133c1df53$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $372f04b133c1df53$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $372f04b133c1df53$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $372f04b133c1df53$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFormData(formData) && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($372f04b133c1df53$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $372f04b133c1df53$export$2e2bcd8739ae039 = $372f04b133c1df53$var$formDataToJSON;


'use strict';
const $ae2db60d463a4b2e$var$methodList = Object.freeze([
    'get',
    'delete',
    'head',
    'options',
    'post',
    'put',
    'patch',
    'purge',
    'link',
    'unlink',
    'query'
]);
var $ae2db60d463a4b2e$export$2e2bcd8739ae039 = $ae2db60d463a4b2e$var$methodList;


'use strict';
const $e1c9a57ef3ebea92$var$own = (obj, key)=>obj != null && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $e1c9a57ef3ebea92$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $cb898722622e1bbe$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $e1c9a57ef3ebea92$var$defaults = {
    transitional: (0, $f10e0d1daedbcc26$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $372f04b133c1df53$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isBuffer(data) || (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isStream(data) || (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFile(data) || (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isBlob(data) || (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $e1c9a57ef3ebea92$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $46a1c96d89d8a991$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $e1c9a57ef3ebea92$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $ec2d6980f48e9528$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $e1c9a57ef3ebea92$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $e1c9a57ef3ebea92$var$own(this, 'transitional') || $e1c9a57ef3ebea92$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $e1c9a57ef3ebea92$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isResponse(data) || (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $e1c9a57ef3ebea92$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).from(e, (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $e1c9a57ef3ebea92$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach((0, $ae2db60d463a4b2e$export$2e2bcd8739ae039), (method)=>{
    $e1c9a57ef3ebea92$var$defaults.headers[method] = {};
});
var $e1c9a57ef3ebea92$export$2e2bcd8739ae039 = $e1c9a57ef3ebea92$var$defaults;



'use strict';
function $cbed29dc306d3656$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $e1c9a57ef3ebea92$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $a107ecb812e3a6a9$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $7ccf50e37e313489$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $d2353333ffc17c53$var$CanceledError extends (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $d2353333ffc17c53$export$2e2bcd8739ae039 = $d2353333ffc17c53$var$CanceledError;







'use strict';
function $65b761545c1367d7$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





'use strict';
const $05806a2a873071f0$var$urlParserControlCharacters = /[\t\n\r]/g;
function $05806a2a873071f0$export$2e2bcd8739ae039(url) {
    if (typeof url !== 'string') return url;
    let start = 0;
    while(start < url.length && url.charCodeAt(start) <= 0x20)start++;
    return url.slice(start).replace($05806a2a873071f0$var$urlParserControlCharacters, '');
}


'use strict';
function $74d7823de4940a99$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $e8ab64df6f629ac9$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $e8ab64df6f629ac9$export$2e2bcd8739ae039 = $e8ab64df6f629ac9$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Array<Function>}
 */ function $a21ca0c8397b2970$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    const flushWith = (...args)=>invoke(args);
    return [
        throttled,
        flush,
        flushWith
    ];
}
var $a21ca0c8397b2970$export$2e2bcd8739ae039 = $a21ca0c8397b2970$var$throttle;



const $347f6d773d0c9353$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $e8ab64df6f629ac9$export$2e2bcd8739ae039)(50, 250);
    return (0, $a21ca0c8397b2970$export$2e2bcd8739ae039)((e)=>{
        if (!e || !(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isNumber(e.loaded)) return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $347f6d773d0c9353$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $347f6d773d0c9353$export$5d35863c355a22a9 = (fn, scheduler = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).asap)=>(...args)=>scheduler(()=>fn(...args));






var $d81aa7444d42d05f$export$2e2bcd8739ae039 = (0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).origin), (0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $c1785cd19fee110a$export$2e2bcd8739ae039 = (0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};



'use strict';
function $88d29e2784134738$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $1553d45bd639ed27$export$2e2bcd8739ae039(baseURL, relativeURL) {
    if (!relativeURL) return baseURL;
    let end = baseURL.length;
    while(end > 0 && baseURL.charCodeAt(end - 1) === 47)end--;
    return baseURL.slice(0, end) + '/' + relativeURL.replace(/^\/+/, '');
}



'use strict';
const $fc4436884ed94f0b$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
// Redact the parts of a URL that can carry secrets before it is embedded in an
// error message. AxiosError.toJSON() serializes `message` verbatim and errors
// are commonly logged, while the opt-in `config.redact` model only cleans
// config keys — it cannot reach the message. Redact only the genuinely
// sensitive substrings — userinfo (credentials), query parameter values and
// fragment contents — with the same REDACTED marker the config redaction uses,
// while keeping the scheme, host, path and parameter names so the offending
// request stays accurately identifiable.
function $fc4436884ed94f0b$var$redactFragment(fragment) {
    if (!fragment) return fragment;
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, (match, separator, parameterName = '')=>{
        return `${separator}${parameterName}${0, $f9b1affb0498ba1f$export$6acd2efa8ac62a1b}`;
    });
}
function $fc4436884ed94f0b$var$redactSensitiveURLParts(url) {
    const redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${(0, $f9b1affb0498ba1f$export$6acd2efa8ac62a1b)}@`);
    const fragmentIndex = redactedURL.indexOf('#');
    const urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    const redactedURLWithoutFragment = urlWithoutFragment.replace(/([?&][^=&#]*=)[^&#]*/g, `$1${(0, $f9b1affb0498ba1f$export$6acd2efa8ac62a1b)}`);
    if (fragmentIndex === -1) return redactedURLWithoutFragment;
    return `${redactedURLWithoutFragment}#${$fc4436884ed94f0b$var$redactFragment(redactedURL.slice(fragmentIndex + 1))}`;
}
function $fc4436884ed94f0b$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string') {
        const normalizedURL = (0, $05806a2a873071f0$export$2e2bcd8739ae039)(url);
        if ($fc4436884ed94f0b$var$malformedHttpProtocol.test(normalizedURL)) throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)(`Invalid URL ${JSON.stringify($fc4436884ed94f0b$var$redactSensitiveURLParts(normalizedURL))}: missing "//" after protocol`, (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_INVALID_URL, config);
    }
}
function $fc4436884ed94f0b$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $fc4436884ed94f0b$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $88d29e2784134738$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $fc4436884ed94f0b$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $1553d45bd639ed27$export$2e2bcd8739ae039)(baseURL, requestedURL);
    }
    return requestedURL;
}




'use strict';
const $df9d9d057b970962$var$headersToObject = (thing)=>thing instanceof (0, $a107ecb812e3a6a9$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
const $df9d9d057b970962$var$ownEnumerableKeys = (thing)=>{
    if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) return Object.keys(thing).concat(Object.getOwnPropertySymbols(thing).filter((symbol)=>Object.getOwnPropertyDescriptor(thing, symbol).enumerable));
    return Object.keys(thing);
};
function $df9d9d057b970962$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isPlainObject(target) && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $cb898722622e1bbe$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $cb898722622e1bbe$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(transitional2)) {
            if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isPlainObject(transitional2)) {
                if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isPlainObject(transitional1) && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutErrorMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($df9d9d057b970962$var$headersToObject(a), $df9d9d057b970962$var$headersToObject(b), prop, true)
    };
    (0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach($df9d9d057b970962$var$ownEnumerableKeys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(config2, 'validateStatus') && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}



'use strict';
const $c6475afbfa012388$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $c6475afbfa012388$export$2e2bcd8739ae039(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($c6475afbfa012388$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}



/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $bcfc1ef472e4bbd0$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $bcfc1ef472e4bbd0$var$resolveConfig(config) {
    const newConfig = (0, $df9d9d057b970962$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $a107ecb812e3a6a9$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $09cc5760c042eaec$export$2e2bcd8739ae039)((0, $fc4436884ed94f0b$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).getSafeProp(auth, 'username') || '';
        const password = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).getSafeProp(auth, 'password') || '';
        try {
            headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? $bcfc1ef472e4bbd0$var$encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).from(e, (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFormData(data)) {
        const getHeaders = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).getSafeProp(data, 'getHeaders');
        if ((0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv || (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFunction(getHeaders)) // Node.js FormData (like form-data package)
        (0, $c6475afbfa012388$export$2e2bcd8739ae039)(headers, getHeaders.call(data), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $d81aa7444d42d05f$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $c1785cd19fee110a$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $bcfc1ef472e4bbd0$export$2e2bcd8739ae039 = $bcfc1ef472e4bbd0$var$resolveConfig;



const $a896e51633600c95$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $a896e51633600c95$export$2e2bcd8739ae039 = $a896e51633600c95$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $bcfc1ef472e4bbd0$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $a107ecb812e3a6a9$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload, flushDownloadWithEvent;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend(event) {
            if (!request) return;
            // Status 0 means no response was received, which onerror and onabort normally
            // reject before this runs. Firefox 152 fires only readystatechange and loadend for
            // navigation-canceled requests (https://bugzilla.mozilla.org/show_bug.cgi?id=1505389),
            // leaving settle() to resolve them as an empty success. ECONNABORTED is the error
            // onabort raised on Firefox 151. Reads over file:, which some environments report as
            // status 0 on success, are excluded by the request URL's scheme after browser-style
            // preprocessing, by the page origin's scheme for relative URLs (which inherit it), or
            // by responseURL where implemented.
            if (request.status === 0 && ((0, $74d7823de4940a99$export$2e2bcd8739ae039)((0, $05806a2a873071f0$export$2e2bcd8739ae039)(_config.url)) || (0, $74d7823de4940a99$export$2e2bcd8739ae039)((0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).origin)) !== 'file' && !(request.responseURL && request.responseURL.startsWith('file:'))) {
                reject(new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('Request aborted', (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ECONNABORTED, config, request));
                done();
                // Clean up request
                request = null;
                return;
            }
            // When loadend is still dispatching, flushing with it gives progress
            // listeners a final delivery whose event has a live target. The legacy
            // ready-state fallback has no event, so replay its pending progress.
            // A throwing listener must not block settlement; rethrow asynchronously,
            // matching how listener errors surface on the throttle timer path.
            try {
                if (event) flushDownloadWithEvent && flushDownloadWithEvent(event);
                else flushDownload && flushDownload();
            } catch (err) {
                setTimeout(()=>{
                    throw err;
                });
            }
            // A final progress callback can cancel the request synchronously.
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $a107ecb812e3a6a9$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $65b761545c1367d7$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('Request aborted', (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)(msg, (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $f10e0d1daedbcc26$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ETIMEDOUT : (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach((0, $b4b7fdb921feec02$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload, flushDownloadWithEvent] = (0, $347f6d773d0c9353$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $347f6d773d0c9353$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $d2353333ffc17c53$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $74d7823de4940a99$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $44f58441f577bc02$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039) ? err : new (0, $d2353333ffc17c53$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>{
        if (aborted) return;
        if (signal.aborted) {
            onabort.call(signal);
            return;
        }
        signal.addEventListener('abort', onabort, {
            once: true
        });
    });
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $cb898722622e1bbe$export$2e2bcd8739ae039).asap(unsubscribe);
    return signal;
};
var $44f58441f577bc02$export$2e2bcd8739ae039 = $44f58441f577bc02$var$composeSignals;


const $b97d47e9dccdea70$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $b97d47e9dccdea70$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $b97d47e9dccdea70$var$readStream(iterable))yield* $b97d47e9dccdea70$export$71b051935044bd5d(chunk, chunkSize);
};
const $b97d47e9dccdea70$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $b97d47e9dccdea70$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $b97d47e9dccdea70$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate data: URL byte lengths *without* allocating large buffers.
 * - Fetch percent-decodes a base64 body before decoding it.
 * - Node's Buffer.from(body, 'base64') sizes its backing allocation from the
 *   raw body, including ignored characters and content after padding.
 * - Non-base64 data is percent-decoded and then encoded as UTF-8.
 */ const $d594c5c87e2cd645$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $d594c5c87e2cd645$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $d594c5c87e2cd645$var$isHexDigit(str.charCodeAt(i + 1)) && $d594c5c87e2cd645$var$isHexDigit(str.charCodeAt(i + 2));
const $d594c5c87e2cd645$var$hexValue = (charCode)=>charCode <= 57 ? charCode - 48 : (charCode & 0xdf) - 55;
const $d594c5c87e2cd645$var$isBase64Char = (charCode)=>charCode >= 65 && charCode <= 90 || // A-Z
    charCode >= 97 && charCode <= 122 || // a-z
    charCode >= 48 && charCode <= 57 || // 0-9
    charCode === 43 || // +
    charCode === 47 || // /
    charCode === 45 || // - (base64url)
    charCode === 95; // _ (base64url)
const $d594c5c87e2cd645$var$isBase64Whitespace = (charCode)=>charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
const $d594c5c87e2cd645$var$base64Bytes = (significant)=>{
    const groups = Math.floor(significant / 4);
    const remainder = significant % 4;
    return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
};
// Buffer.byteLength(body, 'base64') uses the raw string length as an allocation
// upper bound even when Buffer.from later ignores characters or stops at '='.
const $d594c5c87e2cd645$var$estimateBase64BufferAllocation = (body)=>{
    const len = body.length;
    let padding = 0;
    if (len > 0 && body.charCodeAt(len - 1) === 61 /* '=' */ ) {
        padding++;
        if (len > 1 && body.charCodeAt(len - 2) === 61 /* '=' */ ) padding++;
    }
    return Math.floor((len - padding) * 3 / 4);
};
const $d594c5c87e2cd645$var$estimatePercentDecodedBase64Bytes = (body)=>{
    const len = body.length;
    let significant = 0;
    let padding = 0;
    let invalid = false;
    for(let i = 0; i < len; i++){
        let code = body.charCodeAt(i);
        if (code === 37 /* '%' */  && $d594c5c87e2cd645$var$isPercentEncodedByte(body, i, len)) {
            code = $d594c5c87e2cd645$var$hexValue(body.charCodeAt(i + 1)) * 16 + $d594c5c87e2cd645$var$hexValue(body.charCodeAt(i + 2));
            i += 2;
        }
        if ($d594c5c87e2cd645$var$isBase64Whitespace(code)) continue;
        if (code === 61 /* '=' */ ) {
            padding++;
            continue;
        }
        if (!$d594c5c87e2cd645$var$isBase64Char(code) || padding > 0) {
            invalid = true;
            continue;
        }
        significant++;
    }
    // Fetch rejects malformed forgiving-base64 input. Returning the raw-size
    // allocation bound keeps that invalid input from becoming a pre-check bypass.
    if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) return $d594c5c87e2cd645$var$estimateBase64BufferAllocation(body);
    return $d594c5c87e2cd645$var$base64Bytes(significant);
};
const $d594c5c87e2cd645$var$estimateDataURLBytes = (url, estimateBase64)=>{
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) return estimateBase64(body);
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $d594c5c87e2cd645$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
};
function $d594c5c87e2cd645$export$2e2bcd8739ae039(url) {
    // Fetch removes URL fragments before processing a data: URL.
    const fragmentIndex = typeof url === 'string' ? url.indexOf('#') : -1;
    return $d594c5c87e2cd645$var$estimateDataURLBytes(fragmentIndex === -1 ? url : url.slice(0, fragmentIndex), $d594c5c87e2cd645$var$estimatePercentDecodedBase64Bytes);
}
function $d594c5c87e2cd645$export$1f39e64b554a246f(url) {
    return $d594c5c87e2cd645$var$estimateDataURLBytes(url, $d594c5c87e2cd645$var$estimateBase64BufferAllocation);
}


const $50ed237574169459$export$a4ad2735b021c132 = "1.20.0";



const $08bbc66245da04da$var$DEFAULT_CHUNK_SIZE = 65536;
const $08bbc66245da04da$var$DEFAULT_REQUEST_OPTIONS = {
    cache: 'default',
    redirect: 'follow',
    referrer: 'about:client',
    referrerPolicy: '',
    mode: 'cors',
    integrity: '',
    keepalive: false,
    priority: 'auto',
    window: null
};
const { isFunction: $08bbc66245da04da$var$isFunction } = (0, $cb898722622e1bbe$export$2e2bcd8739ae039);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $08bbc66245da04da$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $08bbc66245da04da$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $08bbc66245da04da$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $08bbc66245da04da$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $08bbc66245da04da$var$factory = (env)=>{
    const globalObject = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).global !== undefined && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).global !== null ? (0, $cb898722622e1bbe$export$2e2bcd8739ae039).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $08bbc66245da04da$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $08bbc66245da04da$var$isFunction(Request);
    const isResponseSupported = $08bbc66245da04da$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $08bbc66245da04da$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $08bbc66245da04da$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $08bbc66245da04da$var$test(()=>(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength, maxRedirects: maxRedirects } = (0, $bcfc1ef472e4bbd0$export$2e2bcd8739ae039)(config);
        const hasMaxContentLength = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $44f58441f577bc02$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('Request body larger than maxBodyLength limit', (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).getSafeProp(configAuth, 'username') || '';
                const password = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($08bbc66245da04da$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $08bbc66245da04da$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $08bbc66245da04da$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($08bbc66245da04da$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $d594c5c87e2cd645$export$2e2bcd8739ae039)(url);
                if (estimated > maxContentLength) throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isReadableStream(data) || (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $b97d47e9dccdea70$export$b0119225647bd83)(stream, $08bbc66245da04da$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $347f6d773d0c9353$export$d9fadd12586c18d6)(requestContentLength, (0, $347f6d773d0c9353$export$c1b28109d46c3592)((0, $347f6d773d0c9353$export$5d35863c355a22a9)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('Stream request bodies are not supported by the current fetch implementation', (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config, request);
            if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $50ed237574169459$export$a4ad2735b021c132), false);
            const safeFetchOptions = fetchOptions == null ? fetchOptions : Object.assign(Object.create(null), fetchOptions);
            if (safeFetchOptions) {
                // These options are owned by Axios and are already reflected in the
                // resolved Request passed to fetch.
                delete safeFetchOptions.body;
                delete safeFetchOptions.headers;
                delete safeFetchOptions.method;
                delete safeFetchOptions.signal;
                delete safeFetchOptions.duplex;
                delete safeFetchOptions.credentials;
            }
            const resolvedOptions = Object.assign(Object.create(null), safeFetchOptions, {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $b4b7fdb921feec02$export$c30c72bb7e677d54)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            });
            if (isRequestSupported) {
                (0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach($08bbc66245da04da$var$DEFAULT_REQUEST_OPTIONS, (value, key)=>{
                    if (resolvedOptions[key] === undefined) resolvedOptions[key] = value;
                });
                if (resolvedOptions.signal === undefined) resolvedOptions.signal = null;
                if (resolvedOptions.body === undefined) resolvedOptions.body = null;
            }
            if (maxRedirects === 0) {
                resolvedOptions.redirect = 'manual';
                if (safeFetchOptions) safeFetchOptions.redirect = 'manual';
            }
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, safeFetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $a107ecb812e3a6a9$export$2e2bcd8739ae039).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $347f6d773d0c9353$export$d9fadd12586c18d6)(responseContentLength, (0, $347f6d773d0c9353$export$c1b28109d46c3592)((0, $347f6d773d0c9353$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $b97d47e9dccdea70$export$b0119225647bd83)(response.body, $08bbc66245da04da$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $cb898722622e1bbe$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $65b761545c1367d7$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $a107ecb812e3a6a9$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('Network Error', (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, 'cause', {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $08bbc66245da04da$var$seedCache = new Map();
const $08bbc66245da04da$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $08bbc66245da04da$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $08bbc66245da04da$var$factory(env));
        map = target;
    }
    return target;
};
const $08bbc66245da04da$var$adapter = $08bbc66245da04da$export$3105c6651375d4fa();
var $08bbc66245da04da$export$2e2bcd8739ae039 = $08bbc66245da04da$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $7e2e3476ae4147c4$var$knownAdapters = {
    http: (0, $243db4f4ede3c5cf$export$2e2bcd8739ae039),
    xhr: (0, $a896e51633600c95$export$2e2bcd8739ae039),
    fetch: {
        get: $08bbc66245da04da$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach($7e2e3476ae4147c4$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $7e2e3476ae4147c4$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $7e2e3476ae4147c4$var$isResolvedHandle = (adapter)=>(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $7e2e3476ae4147c4$var$getAdapter(adapters, config) {
    adapters = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$7e2e3476ae4147c4$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $7e2e3476ae4147c4$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($7e2e3476ae4147c4$var$renderReason).join('\n') : ' ' + $7e2e3476ae4147c4$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $7e2e3476ae4147c4$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $7e2e3476ae4147c4$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $7e2e3476ae4147c4$var$knownAdapters
};



'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $ad4477c883aa8b31$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $d2353333ffc17c53$export$2e2bcd8739ae039)(null, config);
}
function $ad4477c883aa8b31$export$2e2bcd8739ae039(_config) {
    // Interceptors may replace the merged config with an ordinary object. Flatten
    // it at the dispatch boundary so shared prototype members cannot become
    // request behavior, while preserving intentional template/class members.
    const config = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).toSafeFlatObject(_config);
    $ad4477c883aa8b31$var$throwIfCancellationRequested(config);
    config.headers = (0, $a107ecb812e3a6a9$export$2e2bcd8739ae039).from((0, $cb898722622e1bbe$export$2e2bcd8739ae039).getSafeProp(config, 'headers'));
    // Transform request data
    config.data = (0, $cbed29dc306d3656$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $7e2e3476ae4147c4$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $e1c9a57ef3ebea92$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $ad4477c883aa8b31$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $cbed29dc306d3656$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $a107ecb812e3a6a9$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $7ccf50e37e313489$export$2e2bcd8739ae039)(reason)) {
            $ad4477c883aa8b31$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $cbed29dc306d3656$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $a107ecb812e3a6a9$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}







'use strict';
const $130adcb876facb14$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $130adcb876facb14$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $130adcb876facb14$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $130adcb876facb14$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $50ed237574169459$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$130adcb876facb14$var$deprecatedWarnings[opt]) {
            $130adcb876facb14$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$130adcb876facb14$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $130adcb876facb14$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object' || options === null) throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('options must be an object', (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $130adcb876facb14$export$2e2bcd8739ae039 = {
    assertOptions: $130adcb876facb14$var$assertOptions,
    validators: $130adcb876facb14$var$validators
};




'use strict';
const $1e2450381b7b932c$var$validators = (0, $130adcb876facb14$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $1e2450381b7b932c$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $95dc0c3cfa5e38d6$export$2e2bcd8739ae039)(),
            response: new (0, $95dc0c3cfa5e38d6$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) try {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                const dummyStack = dummy.stack;
                let stack = '';
                // slice off the Error: ... line
                if (typeof dummyStack === 'string') {
                    const firstNewlineIndex = dummyStack.indexOf('\n');
                    stack = firstNewlineIndex === -1 ? '' : dummyStack.slice(firstNewlineIndex + 1);
                }
                if (!err.stack) err.stack = stack;
                else if (stack) {
                    const firstNewlineIndex = stack.indexOf('\n');
                    const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                    const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                    if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                }
            } catch (e) {
            // Ignore failures from custom stack hooks or un-writable stack properties.
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $df9d9d057b970962$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $130adcb876facb14$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $1e2450381b7b932c$var$validators.transitional($1e2450381b7b932c$var$validators.boolean),
            forcedJSONParsing: $1e2450381b7b932c$var$validators.transitional($1e2450381b7b932c$var$validators.boolean),
            clarifyTimeoutError: $1e2450381b7b932c$var$validators.transitional($1e2450381b7b932c$var$validators.boolean),
            legacyInterceptorReqResOrdering: $1e2450381b7b932c$var$validators.transitional($1e2450381b7b932c$var$validators.boolean),
            advertiseZstdAcceptEncoding: $1e2450381b7b932c$var$validators.transitional($1e2450381b7b932c$var$validators.boolean),
            validateStatusUndefinedResolves: $1e2450381b7b932c$var$validators.transitional($1e2450381b7b932c$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $130adcb876facb14$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $1e2450381b7b932c$var$validators.function,
                serialize: $1e2450381b7b932c$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $130adcb876facb14$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $1e2450381b7b932c$var$validators.spelling('baseURL'),
            withXsrfToken: $1e2450381b7b932c$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).getSafeProp(config, 'method') || (0, $cb898722622e1bbe$export$2e2bcd8739ae039).getSafeProp(this.defaults, 'method') || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach((0, $ae2db60d463a4b2e$export$2e2bcd8739ae039).concat('common'), (method)=>{
            delete headers[method];
        });
        config.headers = (0, $a107ecb812e3a6a9$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $f10e0d1daedbcc26$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $ad4477c883aa8b31$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
            } catch (error) {
                if (!onRejected) {
                    promise = Promise.reject(error);
                    break;
                }
                try {
                    const rejectedResult = onRejected.call(this, error);
                    if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isThenable(rejectedResult)) promise = Promise.resolve(rejectedResult).then(()=>(0, $ad4477c883aa8b31$export$2e2bcd8739ae039).call(this, newConfig));
                } catch (rejectedError) {
                    promise = Promise.reject(rejectedError);
                }
                break;
            }
        }
        if (!promise) try {
            promise = (0, $ad4477c883aa8b31$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            promise = Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $df9d9d057b970962$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $fc4436884ed94f0b$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $09cc5760c042eaec$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $1e2450381b7b932c$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $df9d9d057b970962$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $df9d9d057b970962$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $1e2450381b7b932c$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $1e2450381b7b932c$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $1e2450381b7b932c$export$2e2bcd8739ae039 = $1e2450381b7b932c$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $6b31aeb513694a91$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $d2353333ffc17c53$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $6b31aeb513694a91$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $6b31aeb513694a91$export$2e2bcd8739ae039 = $6b31aeb513694a91$var$CancelToken;






'use strict';
function $3c9d2466bb005877$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $0747345d83b28a29$export$2e2bcd8739ae039(payload) {
    return (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $7cfa68ccb196e159$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    /**
   * @deprecated Use `ContentTooLarge` instead.
   */ PayloadTooLarge: 413,
    ContentTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    /**
   * @deprecated Use `UnprocessableContent` instead.
   */ UnprocessableEntity: 422,
    UnprocessableContent: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerReturnsAnUnknownError: 520,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($7cfa68ccb196e159$var$HttpStatusCode).forEach(([key, value])=>{
    if ($7cfa68ccb196e159$var$HttpStatusCode[value] === undefined) $7cfa68ccb196e159$var$HttpStatusCode[value] = key;
});
var $7cfa68ccb196e159$export$2e2bcd8739ae039 = $7cfa68ccb196e159$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $782a7beaab0195f3$var$createInstance(defaultConfig) {
    const context = new (0, $1e2450381b7b932c$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $9bb29d85db6f995e$export$2e2bcd8739ae039)((0, $1e2450381b7b932c$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $cb898722622e1bbe$export$2e2bcd8739ae039).extend(instance, (0, $1e2450381b7b932c$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $cb898722622e1bbe$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $782a7beaab0195f3$var$createInstance((0, $df9d9d057b970962$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $782a7beaab0195f3$var$axios = $782a7beaab0195f3$var$createInstance((0, $e1c9a57ef3ebea92$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$782a7beaab0195f3$var$axios.Axios = (0, $1e2450381b7b932c$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$782a7beaab0195f3$var$axios.CanceledError = (0, $d2353333ffc17c53$export$2e2bcd8739ae039);
$782a7beaab0195f3$var$axios.CancelToken = (0, $6b31aeb513694a91$export$2e2bcd8739ae039);
$782a7beaab0195f3$var$axios.isCancel = (0, $7ccf50e37e313489$export$2e2bcd8739ae039);
$782a7beaab0195f3$var$axios.VERSION = (0, $50ed237574169459$export$a4ad2735b021c132);
$782a7beaab0195f3$var$axios.toFormData = (0, $ec2d6980f48e9528$export$2e2bcd8739ae039);
// Expose AxiosError class
$782a7beaab0195f3$var$axios.AxiosError = (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$782a7beaab0195f3$var$axios.Cancel = $782a7beaab0195f3$var$axios.CanceledError;
// Expose all/spread
$782a7beaab0195f3$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$782a7beaab0195f3$var$axios.spread = (0, $3c9d2466bb005877$export$2e2bcd8739ae039);
// Expose isAxiosError
$782a7beaab0195f3$var$axios.isAxiosError = (0, $0747345d83b28a29$export$2e2bcd8739ae039);
// Expose mergeConfig
$782a7beaab0195f3$var$axios.mergeConfig = (0, $df9d9d057b970962$export$2e2bcd8739ae039);
$782a7beaab0195f3$var$axios.AxiosHeaders = (0, $a107ecb812e3a6a9$export$2e2bcd8739ae039);
$782a7beaab0195f3$var$axios.formToJSON = (thing)=>(0, $372f04b133c1df53$export$2e2bcd8739ae039)((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$782a7beaab0195f3$var$axios.getAdapter = (0, $7e2e3476ae4147c4$export$2e2bcd8739ae039).getAdapter;
$782a7beaab0195f3$var$axios.HttpStatusCode = (0, $7cfa68ccb196e159$export$2e2bcd8739ae039);
$782a7beaab0195f3$var$axios.default = $782a7beaab0195f3$var$axios;
var // this module should only have a default export
$782a7beaab0195f3$export$2e2bcd8739ae039 = $782a7beaab0195f3$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $f6169e2f48b1aaca$export$1c00760e9e5a4e95, AxiosError: $f6169e2f48b1aaca$export$c1fbed17c2f6a328, CanceledError: $f6169e2f48b1aaca$export$1ab0c6b20d94fa14, isCancel: $f6169e2f48b1aaca$export$3b22524397b493c6, CancelToken: $f6169e2f48b1aaca$export$fd08e3cb425f0d61, VERSION: $f6169e2f48b1aaca$export$a4ad2735b021c132, all: $f6169e2f48b1aaca$export$84bf76cd7afc7469, Cancel: $f6169e2f48b1aaca$export$848c9b7ead0df967, isAxiosError: $f6169e2f48b1aaca$export$fbafdbe06a5b5a9a, spread: $f6169e2f48b1aaca$export$3ae0fd4797ed47c8, toFormData: $f6169e2f48b1aaca$export$10ae0d317ea97f8b, AxiosHeaders: $f6169e2f48b1aaca$export$4e7d6ff0f3e6520, HttpStatusCode: $f6169e2f48b1aaca$export$a972f69c851492b3, formToJSON: $f6169e2f48b1aaca$export$86d7c59254d6a2c9, getAdapter: $f6169e2f48b1aaca$export$17ddc20a97d669e2, mergeConfig: $f6169e2f48b1aaca$export$7ec1ebcfa9d8bd6a, create: $f6169e2f48b1aaca$export$185802fd694ee1f5 } = (0, $782a7beaab0195f3$export$2e2bcd8739ae039);







//#region src/queryCache.ts
var $7658ab69ad25d4be$var$_queries = /* @__PURE__ */ new WeakMap();
/**
* The `QueryCache` is the storage mechanism for TanStack Query. It stores all the data, meta
* information, and state of the queries it contains.
*
* Normally, you will not interact with the `QueryCache` directly and instead use a `QueryClient`
* for a specific cache. You can subscribe to it (inherited from `Subscribable`) to be informed of
* safe/known updates to the cache, such as queries being added, removed, or updated — updates made
* outside of the cache's own tracked mechanisms (e.g. mutating a query's state object directly) do
* not notify subscribers.
*
* @example
* ```ts
* const unsubscribe = queryCache.subscribe((event) => {
*   console.log(event.type, event.query)
* })
* ```
*/ var $7658ab69ad25d4be$export$5dde0cd941da8468 = class extends (0, $78d76f0c1d823036$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $7658ab69ad25d4be$var$_queries, void 0);
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($7658ab69ad25d4be$var$_queries, this, /* @__PURE__ */ new Map());
    }
    /**
	* Returns the existing `Query` instance for the given options' `queryKey`/`queryHash`, or
	* builds and adds a new one to the cache if none exists yet. Used by framework adapters and
	* plugins (e.g. broadcast/persistence) that need to get-or-create a `Query` directly, bypassing
	* the reactive `QueryObserver` machinery.
	*
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	*
	* const query = queryCache.build(queryClient, {
	*   queryKey: ['posts'],
	*   queryFn: fetchPosts,
	* })
	* ```
	*/ build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $e9d6dc959f196f70$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $d3cc80c94d2af732$export$62297b13309008b2)({
                client: client,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    /** @internal */ add(query) {
        if (!(0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($7658ab69ad25d4be$var$_queries, this).has(query.queryHash)) {
            (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($7658ab69ad25d4be$var$_queries, this).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    /**
	* Destroys the given `Query` and removes it from the cache, notifying subscribers with a
	* `'removed'` event. A no-op if the query is no longer the one currently stored under its hash
	* (e.g. it was already replaced). Used by plugins (e.g. the broadcast client) that mirror
	* removals across `QueryCache` instances.
	*
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	* const query = queryCache.find({ queryKey: ['posts'] })
	*
	* if (query) {
	*   queryCache.remove(query)
	* }
	* ```
	*/ remove(query) {
        if ((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($7658ab69ad25d4be$var$_queries, this).get(query.queryHash) === query) {
            query.destroy();
            (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($7658ab69ad25d4be$var$_queries, this).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    /**
	* Removes all queries from the cache.
	*
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	*
	* queryCache.clear()
	* ```
	*/ clear() {
        (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    /**
	* Returns the `Query` instance stored under the given `queryHash`, or `undefined` if none
	* exists. Unlike {@link QueryCache#find}, this looks up by the already-computed hash rather
	* than by `QueryFilters`. Used by plugins (e.g. broadcast/hydration) that already have a hash
	* to look up directly.
	*
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	* const queryHash = hashKey(['posts'])
	*
	* const query = queryCache.get(queryHash)
	* ```
	*/ get(queryHash) {
        return (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($7658ab69ad25d4be$var$_queries, this).get(queryHash);
    }
    /**
	* Returns all queries within the cache.
	*
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	*
	* const queries = queryCache.getAll()
	* ```
	*/ getAll() {
        return [
            ...(0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($7658ab69ad25d4be$var$_queries, this).values()
        ];
    }
    /**
	* A slightly more advanced method that can be used to get an existing query instance from the
	* cache. This instance not only contains all the state for the query, but all of the instances,
	* and underlying guts of the query as well. If the query does not exist, `undefined` is
	* returned.
	*
	* This is not typically needed for most applications, but can come in handy when needing more
	* information about a query in rare scenarios (e.g. looking at `query.state.dataUpdatedAt` to
	* decide whether a query is fresh enough to be used as an initial value).
	*
	* @see {@link QueryCache#findAll}
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	*
	* const query = queryCache.find({ queryKey: ['posts'] })
	* ```
	*/ find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $e9d6dc959f196f70$export$c5d1efe363797780)(defaultedFilters, query));
    }
    /**
	* An even more advanced method that can be used to get existing query instances from the cache
	* that partially match a query key. If no queries match, an empty array is returned.
	*
	* This is not typically needed for most applications, but can come in handy when needing more
	* information about queries in rare scenarios.
	*
	* @see {@link QueryCache#find}
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	*
	* const queries = queryCache.findAll({ queryKey: ['posts'] })
	* ```
	*/ findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $e9d6dc959f196f70$export$c5d1efe363797780)(filters, query)) : queries;
    }
    /** @internal */ notify(event) {
        (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    /** @internal */ onFocus() {
        (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    /** @internal */ onOnline() {
        (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};















//#region src/mutation.ts
var $969142c0f0e104ca$var$_client = /* @__PURE__ */ new WeakMap();
var $969142c0f0e104ca$var$_observers = /* @__PURE__ */ new WeakMap();
var $969142c0f0e104ca$var$_mutationCache = /* @__PURE__ */ new WeakMap();
var $969142c0f0e104ca$var$_retryer = /* @__PURE__ */ new WeakMap();
var $969142c0f0e104ca$var$_Mutation_brand = /* @__PURE__ */ new WeakSet();
/**
* Represents a single mutation attempt. A `Mutation` holds the mutation's
* options, state (data/error/status), and the `MutationObserver`s currently
* subscribed to it.
*
* Instances are created and managed internally by `MutationCache`; application
* code typically interacts with mutations indirectly through `QueryClient` or
* a framework hook like `useMutation`. Direct access to a `Mutation` instance
* is possible via `mutationCache.find()`/`getAll()` for inspecting cache state.
*
* @example
* ```ts
* const mutationCache = queryClient.getMutationCache()
*
* const mutation = mutationCache.find({ mutationKey: ['addPost'] })
* ```
*/ var $969142c0f0e104ca$export$17b8b19c814bcf56 = class extends (0, $b5f33a596cb9c395$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $319cb07e0a96d91d$export$625550452a3fa3ec)(this, $969142c0f0e104ca$var$_Mutation_brand);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $969142c0f0e104ca$var$_client, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $969142c0f0e104ca$var$_observers, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $969142c0f0e104ca$var$_mutationCache, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $969142c0f0e104ca$var$_retryer, void 0);
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($969142c0f0e104ca$var$_client, this, config.client);
        this.mutationId = config.mutationId;
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($969142c0f0e104ca$var$_mutationCache, this, config.mutationCache);
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($969142c0f0e104ca$var$_observers, this, []);
        this.state = config.state || $969142c0f0e104ca$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    /** @internal */ setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    /**
	* The `meta` object passed in the mutation's options, if any.
	*/ get meta() {
        return this.options.meta;
    }
    /** @internal */ addObserver(observer) {
        if (!(0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($969142c0f0e104ca$var$_observers, this).includes(observer)) {
            (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($969142c0f0e104ca$var$_observers, this).push(observer);
            this.clearGcTimeout();
            (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($969142c0f0e104ca$var$_mutationCache, this).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    /** @internal */ removeObserver(observer) {
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($969142c0f0e104ca$var$_observers, this, (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($969142c0f0e104ca$var$_observers, this).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($969142c0f0e104ca$var$_mutationCache, this).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($969142c0f0e104ca$var$_observers, this).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($969142c0f0e104ca$var$_mutationCache, this).remove(this);
        }
    }
    /**
	* Resumes a mutation that is currently paused or was restored from a
	* dehydrated, still-`pending` state.
	*
	* - If this mutation has an active retryer (it paused mid-attempt, e.g. due
	*   to the network mode or scope-based queuing), its retryer is resumed.
	* - Otherwise, if the mutation's status is still `pending` (e.g. it was
	*   dehydrated while an attempt was in flight and never got a retryer in
	*   this instance), `execute` is called again with the last known variables.
	* - Otherwise the mutation has already settled and this resolves immediately
	*   without running anything again.
	*
	* @example
	* ```ts
	* // typically driven by reconnect handling, e.g. queryClient.resumePausedMutations()
	* const mutation = mutationCache.find({ mutationKey: ['addPost'] })
	* await mutation?.continue()
	* ```
	*
	* @see {@link Mutation#execute}
	*/ continue() {
        var _classPrivateFieldGet2$1;
        return ((_classPrivateFieldGet2$1 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($969142c0f0e104ca$var$_retryer, this)) === null || _classPrivateFieldGet2$1 === void 0 ? void 0 : _classPrivateFieldGet2$1.continue()) ?? (this.state.status === "pending" ? this.execute(this.state.variables) : Promise.resolve());
    }
    /**
	* Runs the mutation function for the given variables through a retryer, and
	* drives the mutation's state and lifecycle callbacks through to settlement.
	*
	* If this mutation's state is already `pending` when `execute` is called
	* (i.e. it was restored, still in-flight, from a dehydrated state), the
	* `onMutate` step is skipped and a `continue` action is dispatched to
	* unpause it; otherwise a `pending` action is dispatched first, then the
	* mutation cache's `onMutate` and the mutation's own `onMutate` option are
	* awaited in that order, and the resulting context is stored.
	*
	* The mutation function is then run (subject to `retry`/`retryDelay`/
	* `networkMode`, and to the mutation cache's scope-based serialization).
	* On success, the cache's `onSuccess`/`onSettled` callbacks run before the
	* mutation's own `onSuccess`/`onSettled` options, a `success` action is
	* dispatched, and the resolved data is returned. On failure, the same
	* cache-then-option ordering is used for `onError`/`onSettled`, but each of
	* those four callbacks is individually caught so that a throwing callback
	* cannot mask the original error; an `error` action is then dispatched and
	* the original error is re-thrown.
	*
	* @example
	* ```ts
	* // Called internally by `MutationObserver.mutate` and `Mutation.continue` —
	* // applications normally trigger mutations through those, not this method.
	* const data = await mutation.execute(variables)
	* ```
	*
	* @see {@link Mutation#continue}
	*/ async execute(variables) {
        const onContinue = ()=>{
            (0, $2a8ed1c9c5679810$export$43caf9889c228507)($969142c0f0e104ca$var$_Mutation_brand, this, $969142c0f0e104ca$var$_dispatch).call(this, {
                type: "continue"
            });
        };
        const mutationFnContext = {
            client: (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($969142c0f0e104ca$var$_client, this),
            meta: this.options.meta,
            mutationKey: this.options.mutationKey
        };
        const retryer = (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($969142c0f0e104ca$var$_retryer, this, (0, $c0d8ccc060892ed3$export$2cbd00fe8a2c8d85)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(/* @__PURE__ */ new Error("No mutationFn found"));
                return this.options.mutationFn(variables, mutationFnContext);
            },
            onFail: (failureCount, error)=>{
                (0, $2a8ed1c9c5679810$export$43caf9889c228507)($969142c0f0e104ca$var$_Mutation_brand, this, $969142c0f0e104ca$var$_dispatch).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $2a8ed1c9c5679810$export$43caf9889c228507)($969142c0f0e104ca$var$_Mutation_brand, this, $969142c0f0e104ca$var$_dispatch).call(this, {
                    type: "pause"
                });
            },
            onContinue: onContinue,
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>(0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($969142c0f0e104ca$var$_mutationCache, this).canRun(this)
        }));
        const restored = this.state.status === "pending";
        const isPaused = !retryer.canStart();
        try {
            var _classPrivateFieldGet3, _classPrivateFieldGet4, _this$options$onSucce, _this$options2, _classPrivateFieldGet5, _classPrivateFieldGet6, _this$options$onSettl, _this$options3;
            if (restored) onContinue();
            else {
                var _this$options$onMutat, _this$options;
                (0, $2a8ed1c9c5679810$export$43caf9889c228507)($969142c0f0e104ca$var$_Mutation_brand, this, $969142c0f0e104ca$var$_dispatch).call(this, {
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                if ((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($969142c0f0e104ca$var$_mutationCache, this).config.onMutate) await (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($969142c0f0e104ca$var$_mutationCache, this).config.onMutate(variables, this, mutationFnContext);
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) === null || _this$options$onMutat === void 0 ? void 0 : _this$options$onMutat.call(_this$options, variables, mutationFnContext));
                if (context !== this.state.context) (0, $2a8ed1c9c5679810$export$43caf9889c228507)($969142c0f0e104ca$var$_Mutation_brand, this, $969142c0f0e104ca$var$_dispatch).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await retryer.start();
            await ((_classPrivateFieldGet3 = (_classPrivateFieldGet4 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($969142c0f0e104ca$var$_mutationCache, this).config).onSuccess) === null || _classPrivateFieldGet3 === void 0 ? void 0 : _classPrivateFieldGet3.call(_classPrivateFieldGet4, data, variables, this.state.context, this, mutationFnContext));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) === null || _this$options$onSucce === void 0 ? void 0 : _this$options$onSucce.call(_this$options2, data, variables, this.state.context, mutationFnContext));
            await ((_classPrivateFieldGet5 = (_classPrivateFieldGet6 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($969142c0f0e104ca$var$_mutationCache, this).config).onSettled) === null || _classPrivateFieldGet5 === void 0 ? void 0 : _classPrivateFieldGet5.call(_classPrivateFieldGet6, data, null, this.state.variables, this.state.context, this, mutationFnContext));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) === null || _this$options$onSettl === void 0 ? void 0 : _this$options$onSettl.call(_this$options3, data, null, variables, this.state.context, mutationFnContext));
            (0, $2a8ed1c9c5679810$export$43caf9889c228507)($969142c0f0e104ca$var$_Mutation_brand, this, $969142c0f0e104ca$var$_dispatch).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                var _classPrivateFieldGet7, _classPrivateFieldGet8;
                await ((_classPrivateFieldGet7 = (_classPrivateFieldGet8 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($969142c0f0e104ca$var$_mutationCache, this).config).onError) === null || _classPrivateFieldGet7 === void 0 ? void 0 : _classPrivateFieldGet7.call(_classPrivateFieldGet8, error, variables, this.state.context, this, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            try {
                var _this$options$onError, _this$options4;
                await ((_this$options$onError = (_this$options4 = this.options).onError) === null || _this$options$onError === void 0 ? void 0 : _this$options$onError.call(_this$options4, error, variables, this.state.context, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            try {
                var _classPrivateFieldGet9, _classPrivateFieldGet10;
                await ((_classPrivateFieldGet9 = (_classPrivateFieldGet10 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($969142c0f0e104ca$var$_mutationCache, this).config).onSettled) === null || _classPrivateFieldGet9 === void 0 ? void 0 : _classPrivateFieldGet9.call(_classPrivateFieldGet10, void 0, error, this.state.variables, this.state.context, this, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            try {
                var _this$options$onSettl2, _this$options5;
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) === null || _this$options$onSettl2 === void 0 ? void 0 : _this$options$onSettl2.call(_this$options5, void 0, error, variables, this.state.context, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            (0, $2a8ed1c9c5679810$export$43caf9889c228507)($969142c0f0e104ca$var$_Mutation_brand, this, $969142c0f0e104ca$var$_dispatch).call(this, {
                type: "error",
                error: error
            });
            throw error;
        } finally{
            if ((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($969142c0f0e104ca$var$_retryer, this) === retryer) (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($969142c0f0e104ca$var$_retryer, this, void 0);
            (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($969142c0f0e104ca$var$_mutationCache, this).runNext(this);
        }
    }
};
function $969142c0f0e104ca$var$_dispatch(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: action.isPaused,
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>{
        (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($969142c0f0e104ca$var$_observers, this).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($969142c0f0e104ca$var$_mutationCache, this).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
}
function $969142c0f0e104ca$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}


//#region src/mutationCache.ts
var $6b281d51985145ae$var$_mutations = /* @__PURE__ */ new WeakMap();
var $6b281d51985145ae$var$_scopes = /* @__PURE__ */ new WeakMap();
var $6b281d51985145ae$var$_mutationId = /* @__PURE__ */ new WeakMap();
/**
* The `MutationCache` is the storage for mutations.
*
* Normally, you will not interact with the `MutationCache` directly and instead use a
* `QueryClient`. You can subscribe to it (inherited from `Subscribable`) to be informed of
* safe/known updates to the cache, such as mutations being added, removed, or updated.
*
* @example
* ```ts
* const unsubscribe = mutationCache.subscribe((event) => {
*   console.log(event.type, event.mutation)
* })
* ```
*/ var $6b281d51985145ae$export$1fcfd9a244434844 = class extends (0, $78d76f0c1d823036$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $6b281d51985145ae$var$_mutations, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $6b281d51985145ae$var$_scopes, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $6b281d51985145ae$var$_mutationId, void 0);
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($6b281d51985145ae$var$_mutations, this, /* @__PURE__ */ new Set());
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($6b281d51985145ae$var$_scopes, this, /* @__PURE__ */ new Map());
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($6b281d51985145ae$var$_mutationId, this, 0);
    }
    /** @internal */ build(client, options, state) {
        var _this$mutationId;
        const mutation = new (0, $969142c0f0e104ca$export$17b8b19c814bcf56)({
            client: client,
            mutationCache: this,
            mutationId: (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($6b281d51985145ae$var$_mutationId, this, (_this$mutationId = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($6b281d51985145ae$var$_mutationId, this), ++_this$mutationId)),
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    /** @internal */ add(mutation) {
        (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($6b281d51985145ae$var$_mutations, this).add(mutation);
        const scope = $6b281d51985145ae$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($6b281d51985145ae$var$_scopes, this).get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($6b281d51985145ae$var$_scopes, this).set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    /** @internal */ remove(mutation) {
        if ((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($6b281d51985145ae$var$_mutations, this).delete(mutation)) {
            const scope = $6b281d51985145ae$var$scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($6b281d51985145ae$var$_scopes, this).get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($6b281d51985145ae$var$_scopes, this).delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    /** @internal */ canRun(mutation) {
        const scope = $6b281d51985145ae$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const mutationsWithSameScope = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($6b281d51985145ae$var$_scopes, this).get(scope);
            const firstPendingMutation = mutationsWithSameScope === null || mutationsWithSameScope === void 0 ? void 0 : mutationsWithSameScope.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    /** @internal */ runNext(mutation) {
        const scope = $6b281d51985145ae$var$scopeFor(mutation);
        if (typeof scope === "string") {
            var _classPrivateFieldGet2$1;
            const foundMutation = (_classPrivateFieldGet2$1 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($6b281d51985145ae$var$_scopes, this).get(scope)) === null || _classPrivateFieldGet2$1 === void 0 ? void 0 : _classPrivateFieldGet2$1.find((m)=>m !== mutation && m.state.isPaused);
            return (foundMutation === null || foundMutation === void 0 ? void 0 : foundMutation.continue()) ?? Promise.resolve();
        } else return Promise.resolve();
    }
    /**
	* Removes all mutations from the cache.
	*
	* @example
	* ```ts
	* const mutationCache = queryClient.getMutationCache()
	*
	* mutationCache.clear()
	* ```
	*/ clear() {
        (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>{
            (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($6b281d51985145ae$var$_mutations, this).forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation: mutation
                });
            });
            (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($6b281d51985145ae$var$_mutations, this).clear();
            (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($6b281d51985145ae$var$_scopes, this).clear();
        });
    }
    /**
	* Returns all mutations within the cache.
	*
	* This is not typically needed for most applications, but can come in handy when needing more
	* information about a mutation in rare scenarios.
	*
	* @example
	* ```ts
	* const mutationCache = queryClient.getMutationCache()
	*
	* const mutations = mutationCache.getAll()
	* ```
	*/ getAll() {
        return Array.from((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($6b281d51985145ae$var$_mutations, this));
    }
    /**
	* A slightly more advanced method that can be used to get an existing mutation instance from
	* the cache. If the mutation does not exist, `undefined` is returned.
	*
	* This is not typically needed for most applications, but can come in handy when needing more
	* information about a mutation in rare scenarios.
	*
	* @see {@link MutationCache#findAll}
	* @example
	* ```ts
	* const mutationCache = queryClient.getMutationCache()
	*
	* const mutation = mutationCache.find({ mutationKey: ['addPost'] })
	* ```
	*/ find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $e9d6dc959f196f70$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    /**
	* An even more advanced method that can be used to get existing mutation instances from the
	* cache that match the given filters. If no mutations match, an empty array is returned.
	*
	* This is not typically needed for most applications, but can come in handy when needing more
	* information about mutations in rare scenarios.
	*
	* @see {@link MutationCache#find}
	* @example
	* ```ts
	* const mutationCache = queryClient.getMutationCache()
	*
	* const mutations = mutationCache.findAll({ mutationKey: ['addPost'] })
	* ```
	*/ findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $e9d6dc959f196f70$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    /** @internal */ notify(event) {
        (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    /** @internal */ resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $e9d6dc959f196f70$export$8793edee2d425525)))));
    }
};
function $6b281d51985145ae$var$scopeFor(mutation) {
    var _mutation$options$sco;
    return (_mutation$options$sco = mutation.options.scope) === null || _mutation$options$sco === void 0 ? void 0 : _mutation$options$sco.id;
}



//#region src/queryClient.ts
var $c0446aa2125f8e36$var$_queryCache = /* @__PURE__ */ new WeakMap();
var $c0446aa2125f8e36$var$_mutationCache = /* @__PURE__ */ new WeakMap();
var $c0446aa2125f8e36$var$_defaultOptions = /* @__PURE__ */ new WeakMap();
var $c0446aa2125f8e36$var$_queryDefaults = /* @__PURE__ */ new WeakMap();
var $c0446aa2125f8e36$var$_mutationDefaults = /* @__PURE__ */ new WeakMap();
var $c0446aa2125f8e36$var$_mountCount = /* @__PURE__ */ new WeakMap();
var $c0446aa2125f8e36$var$_unsubscribeFocus = /* @__PURE__ */ new WeakMap();
var $c0446aa2125f8e36$var$_unsubscribeOnline = /* @__PURE__ */ new WeakMap();
/**
* `QueryClient` is used to interact with a cache of queries and mutations. It owns a
* `QueryCache` and a `MutationCache` (creating default ones if none are passed in) and holds
* the default options that are applied to queries and mutations created through it.
*
* @example
* ```ts
* const queryClient = new QueryClient({
*   defaultOptions: {
*     queries: {
*       staleTime: Infinity,
*     },
*   },
* })
*
* await queryClient.query({ queryKey: ['posts'], queryFn: fetchPosts })
* ```
*/ var $c0446aa2125f8e36$export$405d0624ed55a03f = class {
    constructor(config = {}){
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $c0446aa2125f8e36$var$_queryCache, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $c0446aa2125f8e36$var$_mutationCache, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $c0446aa2125f8e36$var$_defaultOptions, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $c0446aa2125f8e36$var$_queryDefaults, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $c0446aa2125f8e36$var$_mutationDefaults, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $c0446aa2125f8e36$var$_mountCount, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $c0446aa2125f8e36$var$_unsubscribeFocus, void 0);
        (0, $2a8ed1c9c5679810$export$23f2a1d2818174ef)(this, $c0446aa2125f8e36$var$_unsubscribeOnline, void 0);
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($c0446aa2125f8e36$var$_queryCache, this, config.queryCache || new (0, $7658ab69ad25d4be$export$5dde0cd941da8468)());
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($c0446aa2125f8e36$var$_mutationCache, this, config.mutationCache || new (0, $6b281d51985145ae$export$1fcfd9a244434844)());
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($c0446aa2125f8e36$var$_defaultOptions, this, config.defaultOptions || {});
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($c0446aa2125f8e36$var$_queryDefaults, this, /* @__PURE__ */ new Map());
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($c0446aa2125f8e36$var$_mutationDefaults, this, /* @__PURE__ */ new Map());
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($c0446aa2125f8e36$var$_mountCount, this, 0);
    }
    /**
	* Called by a framework adapter's `QueryClientProvider`-equivalent when it mounts, to start
	* listening for focus/online events and resume paused mutations. Ref-counted via an internal
	* mount count, so nested or multiple providers sharing the same `QueryClient` don't tear down
	* the shared listeners until the last one unmounts.
	*/ mount() {
        var _this$mountCount;
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($c0446aa2125f8e36$var$_mountCount, this, (_this$mountCount = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_mountCount, this), _this$mountCount++, _this$mountCount));
        if ((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_mountCount, this) !== 1) return;
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($c0446aa2125f8e36$var$_unsubscribeFocus, this, (0, $780e8903dcf2df97$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_queryCache, this).onFocus();
            }
        }));
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($c0446aa2125f8e36$var$_unsubscribeOnline, this, (0, $3b7c5eeebfe845db$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_queryCache, this).onOnline();
            }
        }));
    }
    /**
	* The inverse of {@link QueryClient#mount} — called by a framework adapter's
	* `QueryClientProvider`-equivalent when it unmounts. Only tears down the focus/online
	* listeners once the mount count returns to `0`.
	*/ unmount() {
        var _this$mountCount3, _classPrivateFieldGet2$1, _classPrivateFieldGet3;
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($c0446aa2125f8e36$var$_mountCount, this, (_this$mountCount3 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_mountCount, this), _this$mountCount3--, _this$mountCount3));
        if ((0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_mountCount, this) !== 0) return;
        (_classPrivateFieldGet2$1 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_unsubscribeFocus, this)) === null || _classPrivateFieldGet2$1 === void 0 || _classPrivateFieldGet2$1.call(this);
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($c0446aa2125f8e36$var$_unsubscribeFocus, this, void 0);
        (_classPrivateFieldGet3 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_unsubscribeOnline, this)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.call(this);
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($c0446aa2125f8e36$var$_unsubscribeOnline, this, void 0);
    }
    /**
	* Returns the number of queries in the cache that are currently fetching, optionally
	* matching a set of filters. This includes background-fetching, loading new pages, and
	* loading more infinite query results.
	*
	* @example
	* ```ts
	* if (queryClient.isFetching()) {
	*   console.log('At least one query is fetching!')
	* }
	* ```
	*/ isFetching(filters) {
        return (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_queryCache, this).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    /**
	* Returns the number of mutations in the cache that are currently pending, optionally
	* matching a set of filters.
	*
	* @example
	* ```ts
	* if (queryClient.isMutating()) {
	*   console.log('At least one mutation is pending!')
	* }
	* ```
	*/ isMutating(filters) {
        return (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_mutationCache, this).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    /**
	* Imperative (non-reactive) way to retrieve data for a QueryKey.
	* Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
	*
	* Hint: Do not use this function inside a component, because it won't receive updates.
	* Use `useQuery` to create a `QueryObserver` that subscribes to changes.
	*
	* @see {@link QueryClient#getQueriesData}
	*/ getQueryData(queryKey) {
        var _classPrivateFieldGet4;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_classPrivateFieldGet4 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_queryCache, this).get(options.queryHash)) === null || _classPrivateFieldGet4 === void 0 ? void 0 : _classPrivateFieldGet4.state.data;
    }
    /**
	* @deprecated Use queryClient.query({ ...options, staleTime: 'static' }) instead. This method will be removed in the next major version.
	*/ ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_queryCache, this).build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, $e9d6dc959f196f70$export$e36731f6aa6a4362)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    /**
	* Imperative (non-reactive) way to retrieve the cached data of multiple queries at once.
	* Only queries matching the given filters are returned; if none match, an empty array is
	* returned.
	*
	* Because the matched queries can hold data of different shapes (e.g. a broad filter can match
	* queries with unrelated data types), the `TQueryFnData` generic defaults to `unknown` rather
	* than being inferred. Passing a more specific type is a convenience for call sites that know
	* every matched query holds the same shape — it is not checked against the actual cache
	* contents.
	*
	* @see {@link QueryClient#getQueryData}
	* @example
	* ```ts
	* const data = queryClient.getQueriesData({ queryKey: ['posts'] })
	* ```
	*/ getQueriesData(filters) {
        return (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_queryCache, this).findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            return [
                queryKey,
                state.data
            ];
        });
    }
    /**
	* Synchronous way to immediately update a query's cached data. If the updater (or the value
	* passed) resolves to `undefined`, the cache is left untouched and no query is created;
	* otherwise, if the query does not exist yet, it will be created. To update multiple queries
	* at once by partially matching query keys, use {@link QueryClient#setQueriesData} instead.
	*
	* Updates must be performed immutably: do not mutate `oldData`, or data previously retrieved
	* via {@link QueryClient#getQueryData}, in place.
	*
	* @param queryKey - The query key to set data for.
	* @param updater - Either the new data, or a function that receives the current data (which
	* may be `undefined`) and returns the new data.
	*
	* @example
	* ```ts
	* queryClient.setQueryData(['posts'], newPosts)
	*
	* // Or, using an updater function that receives the current data:
	* queryClient.setQueryData(['posts'], (oldPosts) => [...oldPosts, newPost])
	* ```
	*/ setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_queryCache, this).get(defaultedOptions.queryHash);
        const prevData = query === null || query === void 0 ? void 0 : query.state.data;
        const data = (0, $e9d6dc959f196f70$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return;
        return (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_queryCache, this).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    /**
	* Synchronous way to immediately update the cached data of multiple queries at once, using
	* filters or partial query key matching. Only queries that already exist and match the given
	* filters are updated; no new cache entries are created. Internally this calls
	* {@link QueryClient#setQueryData} for each matching query.
	*
	* @example
	* ```ts
	* queryClient.setQueriesData({ queryKey: ['posts'] }, (oldPosts) =>
	*   oldPosts ? oldPosts.filter((post) => post.id !== deletedId) : oldPosts,
	* )
	* ```
	*/ setQueriesData(filters, updater, options) {
        return (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>(0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_queryCache, this).findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    /**
	* Imperative (non-reactive) way to retrieve an existing query's state. If the query does not
	* exist, `undefined` is returned.
	*
	* @example
	* ```ts
	* const state = queryClient.getQueryState(['posts'])
	* console.log(state?.dataUpdatedAt)
	* ```
	*/ getQueryState(queryKey) {
        var _classPrivateFieldGet5;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_classPrivateFieldGet5 = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_queryCache, this).get(options.queryHash)) === null || _classPrivateFieldGet5 === void 0 ? void 0 : _classPrivateFieldGet5.state;
    }
    /**
	* Removes queries from the cache that match the given filters. Unlike
	* {@link QueryClient#invalidateQueries} or {@link QueryClient#refetchQueries}, this removes
	* matching queries from the cache instead of refetching them. Without filters, every query in
	* the cache is removed.
	*
	* @example
	* ```ts
	* queryClient.removeQueries({ queryKey: ['posts'], exact: true })
	* ```
	*/ removeQueries(filters) {
        const queryCache = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_queryCache, this);
        (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    /**
	* Resets queries matching the given filters back to their initial state (e.g. any
	* `initialData`), notifying subscribers rather than removing them. Active queries among the
	* matched set are then refetched, and the returned promise resolves once that refetch settles.
	*
	* @example
	* ```ts
	* await queryClient.resetQueries({ queryKey: ['posts'], exact: true })
	* ```
	*/ resetQueries(filters, options) {
        const queryCache = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_queryCache, this);
        return (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>{
            const matched = queryCache.findAll(filters);
            const queriesToRefetch = new Set(matched);
            matched.forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries({
                type: "active",
                predicate: (query)=>queriesToRefetch.has(query)
            }, options);
        });
    }
    /**
	* Cancels outgoing fetches for queries matching the given filters. Most useful when performing
	* optimistic updates, since any outgoing refetch that resolves afterwards would otherwise
	* overwrite the optimistic update. By default (`revert: true`), a cancelled query's data is
	* reverted to its state before the outgoing fetch started.
	*
	* The returned promise never rejects, even if individual cancellations fail.
	*
	* @example
	* ```ts
	* await queryClient.cancelQueries({ queryKey: ['posts'], exact: true })
	* ```
	*/ cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>(0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_queryCache, this).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $e9d6dc959f196f70$export$8793edee2d425525)).catch((0, $e9d6dc959f196f70$export$8793edee2d425525));
    }
    /**
	* Marks queries matching the given filters as invalidated. Unlike
	* {@link QueryClient#removeQueries}, invalidated queries stay in the cache.
	*
	* Unless `filters.refetchType` is `'none'`, matching queries are then refetched via
	* {@link QueryClient#refetchQueries}, using `filters.refetchType` if set, otherwise
	* `filters.type`, otherwise `'active'`.
	*
	* @example
	* ```ts
	* await queryClient.invalidateQueries({ queryKey: ['posts'], refetchType: 'active' })
	* ```
	*/ invalidateQueries(filters, options = {}) {
        return (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>{
            (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_queryCache, this).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if ((filters === null || filters === void 0 ? void 0 : filters.refetchType) === "none") return Promise.resolve();
            return this.refetchQueries({
                ...filters,
                type: (filters === null || filters === void 0 ? void 0 : filters.refetchType) ?? (filters === null || filters === void 0 ? void 0 : filters.type) ?? "active"
            }, options);
        });
    }
    /**
	* Refetches queries matching the given filters, regardless of whether they are stale. Without
	* filters, every query in the cache is refetched. Queries that are disabled, or static (only
	* have observers with a static `staleTime`), are never refetched.
	*
	* By default (`cancelRefetch: true`), a currently running fetch is cancelled before the new
	* one starts. The returned promise resolves once all matching queries have settled; it does
	* not reject on individual query failures unless `throwOnError` is set.
	*
	* @example
	* ```ts
	* // refetch all active queries partially matching a query key:
	* await queryClient.refetchQueries({ queryKey: ['posts'], type: 'active' })
	* ```
	*/ refetchQueries(filters, options = {}) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options.cancelRefetch ?? true
        };
        const promises = (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>(0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_queryCache, this).findAll(filters).filter((query)=>!query.isDisabled() && !query.isStatic()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $e9d6dc959f196f70$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $e9d6dc959f196f70$export$8793edee2d425525));
    }
    /**
	* Asynchronous method to fetch and cache a query, resolving with the data or throwing with
	* the error.
	*
	* If the query already exists in the cache and its data is not stale (per the given
	* `staleTime`), the cached data is returned without fetching. Otherwise, the query is fetched
	* and the promise resolves once the fetch settles. If a `select` function is provided, it is
	* applied to the data in both cases (cached or freshly fetched) before it is returned.
	*
	* Unlike a reactive observer, retries are disabled by default here (`retry: false`) unless
	* explicitly configured, since there is no component to catch a thrown error and retry through
	* re-render.
	*
	* The accepted options are `QueryObserverOptions` minus the fields that only make sense for a
	* reactive observer — `enabled`, `refetchInterval`, `refetchIntervalInBackground`,
	* `refetchOnWindowFocus`, `refetchOnReconnect`, `refetchOnMount`, `retryOnMount`,
	* `notifyOnChangeProps`, `throwOnError`, `suspense`, and `placeholderData` are not part of this
	* method's options.
	*
	* This method replaces the deprecated `fetchQuery`, and — combined with
	* `{ staleTime: 'static' }` — the deprecated `ensureQueryData`.
	*
	* @example
	* ```ts
	* try {
	*   const data = await queryClient.query({ queryKey, queryFn, staleTime: 10000 })
	* } catch (error) {
	*   console.log(error)
	* }
	* ```
	*/ async query(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_queryCache, this).build(this, defaultedOptions);
        const queryData = query.isStaleByTime((0, $e9d6dc959f196f70$export$e36731f6aa6a4362)(defaultedOptions.staleTime, query)) ? await query.fetch(defaultedOptions) : query.state.data;
        const select = defaultedOptions.select;
        if (select) return select(queryData);
        return queryData;
    }
    /**
	* @deprecated Use queryClient.query(options) instead. This method will be removed in the next major version.
	*/ fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_queryCache, this).build(this, defaultedOptions);
        return query.isStaleByTime((0, $e9d6dc959f196f70$export$e36731f6aa6a4362)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    /**
	* @deprecated Use queryClient.query(options) instead. You can swallow errors with `.catch(noop)`. This method will be removed in the next major version.
	*/ prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $e9d6dc959f196f70$export$8793edee2d425525)).catch((0, $e9d6dc959f196f70$export$8793edee2d425525));
    }
    /**
	* Asynchronous method to fetch and cache an infinite query, resolving with an
	* {@link InfiniteData} object or throwing with the error.
	*
	* Behaves like {@link QueryClient#query}, accepting the same options (minus
	* `initialPageParam`), plus the required `initialPageParam`, and an optional `pages` /
	* `getNextPageParam` pair used to refetch a fixed number of pages from the start.
	*
	* This method replaces the deprecated `fetchInfiniteQuery`, and — combined with
	* `{ staleTime: 'static' }` — the deprecated `ensureInfiniteQueryData`.
	*
	* @example
	* ```ts
	* try {
	*   const data = await queryClient.infiniteQuery({ queryKey, queryFn, initialPageParam: 0 })
	*   console.log(data.pages)
	* } catch (error) {
	*   console.log(error)
	* }
	* ```
	*/ infiniteQuery(options) {
        options._type = "infinite";
        return this.query(options);
    }
    /**
	* @deprecated Use queryClient.infiniteQuery(options) instead. This method will be removed in the next major version.
	*/ fetchInfiniteQuery(options) {
        options._type = "infinite";
        return this.fetchQuery(options);
    }
    /**
	* @deprecated Use queryClient.infiniteQuery(options) instead. You can swallow errors with `.catch(noop)`. This method will be removed in the next major version.
	*/ prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $e9d6dc959f196f70$export$8793edee2d425525)).catch((0, $e9d6dc959f196f70$export$8793edee2d425525));
    }
    /**
	* @deprecated Use queryClient.infiniteQuery({ ...options, staleTime: 'static' }) instead. This method will be removed in the next major version.
	*/ ensureInfiniteQueryData(options) {
        options._type = "infinite";
        return this.ensureQueryData(options);
    }
    /**
	* Resumes mutations that were paused because there was no network connection. Does nothing
	* (resolving immediately) if the client is currently offline.
	*
	* @example
	* ```ts
	* import { QueryClient } from '@tanstack/query-core'
	*
	* const queryClient = new QueryClient()
	* await queryClient.resumePausedMutations()
	* ```
	*/ resumePausedMutations() {
        if ((0, $3b7c5eeebfe845db$export$b113e788b2dd3fdc).isOnline()) return (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_mutationCache, this).resumePausedMutations();
        return Promise.resolve();
    }
    /**
	* Returns the query cache this client is connected to.
	*
	* @example
	* ```ts
	* import { QueryClient } from '@tanstack/query-core'
	*
	* const queryClient = new QueryClient()
	* const queryCache = queryClient.getQueryCache()
	* const queries = queryCache.findAll({ queryKey: ['posts'] })
	* ```
	*/ getQueryCache() {
        return (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_queryCache, this);
    }
    /**
	* Returns the mutation cache this client is connected to.
	*
	* @example
	* ```ts
	* import { QueryClient } from '@tanstack/query-core'
	*
	* const queryClient = new QueryClient()
	* const mutationCache = queryClient.getMutationCache()
	* const mutations = mutationCache.findAll({ status: 'pending' })
	* ```
	*/ getMutationCache() {
        return (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_mutationCache, this);
    }
    /**
	* Returns the default options that were set when creating the client, or via
	* {@link QueryClient#setDefaultOptions}.
	*
	* @example
	* ```ts
	* import { QueryClient } from '@tanstack/query-core'
	*
	* const queryClient = new QueryClient()
	* const defaultOptions = queryClient.getDefaultOptions()
	* ```
	*/ getDefaultOptions() {
        return (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_defaultOptions, this);
    }
    /**
	* Dynamically sets the default options for this client, overwriting any previously defined
	* default options.
	*
	* @see {@link QueryClient#getDefaultOptions}
	* @example
	* ```ts
	* import { QueryClient } from '@tanstack/query-core'
	*
	* const queryClient = new QueryClient()
	* queryClient.setDefaultOptions({
	*   queries: {
	*     staleTime: Infinity,
	*   },
	* })
	* ```
	*/ setDefaultOptions(options) {
        (0, $2a8ed1c9c5679810$export$625550452a3fa3ec)($c0446aa2125f8e36$var$_defaultOptions, this, options);
    }
    /**
	* Sets default options for queries whose query key partially matches the given `queryKey`.
	*
	* If several registered query defaults match a given query key, they are merged together in
	* registration order by {@link QueryClient#getQueryDefaults}, so register defaults from the
	* most generic key to the least generic one — more specific defaults should be registered
	* after more generic ones so they take precedence.
	*
	* @example
	* ```ts
	* queryClient.setQueryDefaults(['posts'], { queryFn: fetchPosts })
	*
	* await queryClient.query({ queryKey: ['posts'] })
	* ```
	*/ setQueryDefaults(queryKey, options) {
        (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_queryDefaults, this).set((0, $e9d6dc959f196f70$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    /**
	* Returns the default options registered for queries whose query key partially matches the
	* given `queryKey`, via {@link QueryClient#setQueryDefaults}. If multiple registered defaults
	* match, they are merged together in registration order.
	*
	* @example
	* ```ts
	* const defaultOptions = queryClient.getQueryDefaults(['posts'])
	* ```
	*/ getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_queryDefaults, this).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $e9d6dc959f196f70$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    /**
	* Sets default options for mutations whose mutation key partially matches the given
	* `mutationKey`. As with {@link QueryClient#setQueryDefaults}, the order of registration
	* matters when several registered defaults match the same mutation key.
	*
	* @see {@link QueryClient#getMutationDefaults}
	* @example
	* ```ts
	* queryClient.setMutationDefaults(['addPost'], { mutationFn: addPost })
	* ```
	*/ setMutationDefaults(mutationKey, options) {
        (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_mutationDefaults, this).set((0, $e9d6dc959f196f70$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    /**
	* Returns the default options registered for mutations whose mutation key partially matches
	* the given `mutationKey`, via {@link QueryClient#setMutationDefaults}. If multiple registered
	* defaults match, they are merged together in registration order.
	*
	* @example
	* ```ts
	* const defaultOptions = queryClient.getMutationDefaults(['addPost'])
	* ```
	*/ getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_mutationDefaults, this).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $e9d6dc959f196f70$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    /**
	* Called by framework adapters (e.g. inside `useQuery`) to resolve the options passed by the
	* caller into their final, defaulted form: merging `queryClient.setQueryDefaults` for the
	* given `queryKey`, then the client's own `defaultOptions.queries`, then the caller's options
	* on top. A no-op if the options are already defaulted (`_defaulted: true`).
	*/ defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...(0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_defaultOptions, this).queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $e9d6dc959f196f70$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, $e9d6dc959f196f70$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    /**
	* The mutation counterpart of {@link QueryClient#defaultQueryOptions}. Called by framework
	* adapters (e.g. inside `useMutation`) to merge `queryClient.setMutationDefaults` for the
	* given `mutationKey`, then the client's `defaultOptions.mutations`, then the caller's options
	* on top. A no-op if the options are already defaulted (`_defaulted: true`).
	*/ defaultMutationOptions(options) {
        if (options === null || options === void 0 ? void 0 : options._defaulted) return options;
        return {
            ...(0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_defaultOptions, this).mutations,
            ...(options === null || options === void 0 ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    /**
	* Clears both the query cache and the mutation cache this client is connected to.
	*
	* @example
	* ```ts
	* import { QueryClient } from '@tanstack/query-core'
	*
	* const queryClient = new QueryClient()
	* queryClient.clear()
	* ```
	*/ clear() {
        (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_queryCache, this).clear();
        (0, $2a8ed1c9c5679810$export$7ccc53e8f1e7dfc5)($c0446aa2125f8e36$var$_mutationCache, this).clear();
    }
};


/**
 * Backend API Configuration
 *
 * Manages different backend environments for local development.
 * Use environment variable REACT_APP_BACKEND_ENV to switch between:
 * - 'mock': Uses .proxyrc.cjs with mock responses (default)
 * - 'local-docker': Proxies to local Docker container
 * - 'staging': Points to staging environment (future)
 */ const $ffafe62ab6b0f968$var$backendConfigs = {
    mock: {
        baseURL: '',
        timeout: 10000
    },
    'local-docker': {
        baseURL: '',
        timeout: 10000,
        withCredentials: false
    },
    staging: {
        baseURL: '',
        timeout: 10000,
        withCredentials: true
    }
};
function $ffafe62ab6b0f968$export$6cf71c61ed0e83bb() {
    const backendEnv = undefined;
    if (backendEnv && backendEnv in $ffafe62ab6b0f968$var$backendConfigs) return backendEnv;
    // Default to mock for local development
    return 'mock';
}
function $ffafe62ab6b0f968$export$2f4db9c29007a800() {
    const env = $ffafe62ab6b0f968$export$6cf71c61ed0e83bb();
    const config = $ffafe62ab6b0f968$var$backendConfigs[env];
    if (typeof window !== 'undefined') {
        console.log(`\u{1F527} Backend Environment: ${env}`);
        console.log(`\u{1F527} Backend URL: ${config.baseURL || 'Using local proxy'}`);
    }
    return config;
}



const $20b06ac8b5e61eaa$export$8a94cb4f54be52a3 = ()=>new (0, $c0446aa2125f8e36$export$405d0624ed55a03f)({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false,
                refetchIntervalInBackground: false,
                retry: false,
                refetchOnMount: false,
                refetchOnReconnect: false
            }
        },
        queryCache: new (0, $7658ab69ad25d4be$export$5dde0cd941da8468)({
            onError: (error, query)=>{
                // Pass the error itself as the exception: SentryLogger.error forwards
                // its arguments to Sentry.captureException(exception, hint), so a
                // string here would capture a message with no stack and drop the error.
                (0, $9654b596cdf679bc$export$2e2bcd8739ae039).error(error, {
                    extra: {
                        action: 'react-query-query-error',
                        queryKey: query.queryKey
                    }
                });
            }
        })
    });
const $20b06ac8b5e61eaa$export$7c07b633a151f9c5 = $20b06ac8b5e61eaa$export$8a94cb4f54be52a3();
const $20b06ac8b5e61eaa$export$644d8ea042df96a6 = (0, $782a7beaab0195f3$export$2e2bcd8739ae039).create((0, $ffafe62ab6b0f968$export$2f4db9c29007a800)());



var $5FkrB = parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");
const $f5e234f6c33e6e6b$var$UNAUTHENTICATED_STATUS_CODES = [
    401,
    402
];
const $f5e234f6c33e6e6b$export$d3dd4b610d39290a = async (api)=>{
    try {
        const response = await api.get('/gateway/api/me');
        return response.data;
    } catch (error) {
        const status = error?.response?.status;
        // Silently ignore 401/402 — user is simply not authenticated
        if (status !== undefined && $f5e234f6c33e6e6b$var$UNAUTHENTICATED_STATUS_CODES.includes(status)) return null;
        // Re-throw all other errors so callers can handle/log them
        throw error;
    }
};



const $f6c3dce408db50e2$var$UserContext = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
const $f6c3dce408db50e2$export$88f24fd8fcfab6ca = ({ api: api, children: children })=>{
    const [user, setUser] = (0, $5FkrB.useState)(null);
    const [isSettled, setIsSettled] = (0, $5FkrB.useState)(false);
    (0, $5FkrB.useEffect)(()=>{
        (0, $f5e234f6c33e6e6b$export$d3dd4b610d39290a)(api).then((fetchedUser)=>{
            setUser(fetchedUser);
        }).catch((error)=>{
            // Non-401/402 errors are unexpected — log them to Sentry for visibility
            (0, $9654b596cdf679bc$export$2e2bcd8739ae039).error(error);
        }).finally(()=>{
            setIsSettled(true);
        });
    // Run once on mount — we only need to fetch the user once when the app loads.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const value = (0, $5FkrB.useMemo)(()=>({
            user: user,
            isSettled: isSettled
        }), [
        user,
        isSettled
    ]);
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($f6c3dce408db50e2$var$UserContext.Provider, {
        value: value,
        children: children
    });
};
const $f6c3dce408db50e2$export$87c54b525b914dab = ()=>{
    const ctx = (0, $5FkrB.useContext)($f6c3dce408db50e2$var$UserContext);
    if (!ctx) throw new Error('useUserContext must be used within <UserProvider>');
    return ctx;
};


const $ffae71f140f0c685$export$1d39dc5b47e56ff0 = ()=>{
    const { state: state, dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { user: user } = (0, $f6c3dce408db50e2$export$87c54b525b914dab)();
    (0, $5FkrB.useEffect)(()=>{
        // User is pre-seeded into AppUpdatesContext via initialState in App.tsx,
        // but dispatch here as a safety net in case it wasn't available at init time.
        if (state.user || !user) return;
        dispatch({
            type: 'AUTHENTICATE',
            payload: {
                user: user
            }
        });
    }, [
        user,
        state.user,
        dispatch
    ]);
};




var $5FkrB = parcelRequire("5FkrB");

var $hiARP = parcelRequire("hiARP");
var $1a5e9ce6b94f06da$exports = {};
"use strict";
var $1a5e9ce6b94f06da$var$__createBinding = $1a5e9ce6b94f06da$exports && $1a5e9ce6b94f06da$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1a5e9ce6b94f06da$var$__exportStar = $1a5e9ce6b94f06da$exports && $1a5e9ce6b94f06da$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1a5e9ce6b94f06da$var$__createBinding(exports1, m, p);
};
Object.defineProperty($1a5e9ce6b94f06da$exports, "__esModule", {
    value: true
});

$1a5e9ce6b94f06da$var$__exportStar((parcelRequire("c4Up0")), $1a5e9ce6b94f06da$exports);

$1a5e9ce6b94f06da$var$__exportStar((parcelRequire("fb6VX")), $1a5e9ce6b94f06da$exports);

$1a5e9ce6b94f06da$var$__exportStar((parcelRequire("jlxKU")), $1a5e9ce6b94f06da$exports);

$1a5e9ce6b94f06da$var$__exportStar((parcelRequire("glblS")), $1a5e9ce6b94f06da$exports);

$1a5e9ce6b94f06da$var$__exportStar((parcelRequire("hn1YZ")), $1a5e9ce6b94f06da$exports);



var $bDLqY = parcelRequire("bDLqY");



const $8efc6877f826f30c$var$FeatureGatesReadyContext = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
function $8efc6877f826f30c$export$565f843eab5aeb55() {
    return (0, $5FkrB.useContext)($8efc6877f826f30c$var$FeatureGatesReadyContext);
}
const $8efc6877f826f30c$var$FEATURE_GATE_TARGET_APP = 'community-core_web';
function $8efc6877f826f30c$export$51d679bd9933520f() {
    const env = (0, $09e3b90497c94454$export$57570b1603cf6adb)();
    switch(env){
        case 'production':
            return (0, $hiARP.FeatureGateEnvironment).Production;
        case 'staging':
            return (0, $hiARP.FeatureGateEnvironment).Staging;
        case 'development':
        default:
            return (0, $hiARP.FeatureGateEnvironment).Development;
    }
}
function $8efc6877f826f30c$export$d9e6d91f1f7e3282({ children: children }) {
    const [isReady, setIsReady] = (0, $5FkrB.useState)(false);
    const { user: user, isSettled: isSettled } = (0, $f6c3dce408db50e2$export$87c54b525b914dab)();
    const identifiers = (0, $5FkrB.useMemo)(()=>({
            analyticsAnonymousId: (0, (/*@__PURE__*/$parcel$interopDefault($bDLqY))).get((0, $09e3b90497c94454$export$f7fd74025a8bcdc1)),
            atlassianAccountId: user?.account_id
        }), [
        user
    ]);
    // Don't mount FeatureGatesInitialization until the user fetch has settled.
    // Mounting it before the user is known causes a double-init that throws
    // "Client must be initialized before using this method" and makes checkGate()
    // return false, incorrectly triggering a redirect.
    if (!isSettled) return null;
    function handleReady(err) {
        if (err) (0, $9654b596cdf679bc$export$2e2bcd8739ae039).error(err, {
            extra: {
                message: '[FeatureGates] Initialization failed'
            }
        });
        // Mark gates as ready even on error so the app can proceed
        // (fg() returns false on error, which is the safe default)
        setIsReady(true);
    }
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($8efc6877f826f30c$var$FeatureGatesReadyContext.Provider, {
        value: isReady,
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $1a5e9ce6b94f06da$exports.FeatureGatesInitialization), {
            identifiers: identifiers,
            options: {
                apiKey: "41b0854a-40e8-4d53-944c-093616393a0f" ?? '',
                environment: $8efc6877f826f30c$export$51d679bd9933520f(),
                targetApp: $8efc6877f826f30c$var$FEATURE_GATE_TARGET_APP
            },
            onReady: handleReady,
            children: children
        })
    });
}


/**
 * React UFO (Unified Frontend Observability) performance monitoring setup.
 *
 * UFO tracks page load times and reports them as operational events via
 * the analytics web client. Interactions are tracked using @atlaskit/react-ufo:
 *   - traceUFOPageLoad() / traceUFOTransition() are called via useReactUFOWatcher (central, in App.tsx)
 *   - <UFOSegment> provides interaction context to child components
 *   - <UFOLoadHold> holds the interaction open while data is loading; removing
 *     the hold (hold={false}) automatically completes and sends the event.
 *
 * See: https://developer.atlassian.com/platform/ufo/
 */ 
var $iYJcE = parcelRequire("iYJcE");
parcelRequire("gQVPx");
var $kuxjd = parcelRequire("kuxjd");

var $50U6m = parcelRequire("50U6m");

var $6ldPa = parcelRequire("6ldPa");

var $6ldPa = parcelRequire("6ldPa");

var $cIS95 = parcelRequire("cIS95");
var $d0eccf44c2ba632b$var$pe = null;
function $d0eccf44c2ba632b$export$619cdeadfd90f3e4() {
    if (typeof PerformanceObserver !== 'function') // Only instantiate the IntersectionObserver if it's supported
    return null;
    if ($d0eccf44c2ba632b$var$pe !== null) return $d0eccf44c2ba632b$var$pe;
    var performanceObserverCallback = function performanceObserverCallback(list) {
        list.getEntries().forEach(function(entry) {
            if (entry.entryType === (0, $6ldPa.PerformanceObserverEntryTypes).LayoutShift) (0, $cIS95.EntriesBuffer)[(0, $6ldPa.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $6ldPa.PerformanceObserverEntryTypes).LongTask) (0, $cIS95.EntriesBuffer)[(0, $6ldPa.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    };
    $d0eccf44c2ba632b$var$pe = new PerformanceObserver(performanceObserverCallback);
    return $d0eccf44c2ba632b$var$pe;
}


function $9b073a72196e02ee$export$768ccc3ab7bac3ea() {
    var _getObserver;
    (_getObserver = (0, $d0eccf44c2ba632b$export$619cdeadfd90f3e4)()) === null || _getObserver === void 0 || _getObserver.observe({
        type: (0, $6ldPa.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
}



var $6ldPa = parcelRequire("6ldPa");

function $a5836bf3b5f00e31$export$54fb8b6aaf70ec9c() {
    var _getObserver;
    (_getObserver = (0, $d0eccf44c2ba632b$export$619cdeadfd90f3e4)()) === null || _getObserver === void 0 || _getObserver.observe({
        type: (0, $6ldPa.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
}


function $c8ab0fbe311e6ffe$export$5ecf2aafafee3e0() {
    (0, $9b073a72196e02ee$export$768ccc3ab7bac3ea)();
    (0, $a5836bf3b5f00e31$export$54fb8b6aaf70ec9c)();
}



var $DtLwq = parcelRequire("DtLwq");

var $5O2so = parcelRequire("5O2so");
function $fa8ce7524d09ef6a$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $fa8ce7524d09ef6a$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $fa8ce7524d09ef6a$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $fa8ce7524d09ef6a$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $fa8ce7524d09ef6a$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $fa8ce7524d09ef6a$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $fa8ce7524d09ef6a$export$e6a07a94f3e112d4(sinkFn) {
    var _iterator = $fa8ce7524d09ef6a$var$_createForOfIteratorHelper((0, $5O2so.interactionBufferState).interactionBuffer), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, interactionId = _step$value.interactionId, data = _step$value.data;
            sinkFn(interactionId, data);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    (0, $5O2so.interactionBufferState).interactionBuffer.length = 0;
    (0, $5O2so.interactionBufferState).bufferInteractionData = sinkFn;
}



var $b49n7 = parcelRequire("b49n7");

var $h9fNq = parcelRequire("h9fNq");

var $iGolp = parcelRequire("iGolp");

var $25nEq = parcelRequire("25nEq");

var $DtLwq = parcelRequire("DtLwq");

var $iGolp = parcelRequire("iGolp");
var $46766faed9eb6bde$var$nameCache = new WeakMap();
function $46766faed9eb6bde$var$getAttributeSelector(element, attributeName) {
    var attrValue = element.getAttribute(attributeName);
    if (!attrValue) return '';
    return "[".concat(attributeName, "=\"").concat(attrValue, "\"]");
}
function $46766faed9eb6bde$var$isValidSelector(selector) {
    try {
        document.querySelector(selector);
        return true;
    } catch (_unused) {
        return false;
    }
}
function $46766faed9eb6bde$var$isSelectorUnique(selector) {
    return document.querySelectorAll(selector).length === 1;
}
function $46766faed9eb6bde$var$getUniqueSelector(selectorConfig, element) {
    var currentElement = element;
    var parts = [];
    var MAX_DEPTH = 3;
    var currentDepth = 0;
    while(currentElement && currentElement.localName !== 'body' && currentDepth <= MAX_DEPTH){
        var tagName = currentElement.localName;
        var selectorPart = tagName;
        if (selectorConfig.id && currentElement.id && $46766faed9eb6bde$var$isValidSelector("#".concat(currentElement.id))) selectorPart += "#".concat(currentElement.id);
        else if (selectorConfig.dataVC) selectorPart += $46766faed9eb6bde$var$getAttributeSelector(currentElement, 'data-vc');
        else if (selectorConfig.testId) selectorPart += $46766faed9eb6bde$var$getAttributeSelector(currentElement, 'data-testid') || $46766faed9eb6bde$var$getAttributeSelector(currentElement, 'data-test-id');
        else if (selectorConfig.role) selectorPart += $46766faed9eb6bde$var$getAttributeSelector(currentElement, 'role');
        else if (selectorConfig.className && currentElement.className) {
            var classNames = Array.from(currentElement.classList).join('.');
            if (classNames) {
                if ($46766faed9eb6bde$var$isValidSelector(".".concat(classNames))) selectorPart += ".".concat(classNames);
            }
        }
        parts.unshift(selectorPart);
        var _potentialSelector = parts.join(' > ').trim();
        if (_potentialSelector && $46766faed9eb6bde$var$isSelectorUnique(_potentialSelector)) return _potentialSelector;
        currentElement = currentElement.parentElement;
        currentDepth++;
    }
    var potentialSelector = parts.join(' > ').trim();
    if (!potentialSelector) return 'unknown';
    else if (!$46766faed9eb6bde$var$isSelectorUnique(potentialSelector)) {
        var parentElement = element.parentElement;
        if (parentElement) return "".concat(potentialSelector, ":nth-child"); // NOTE: invalid DOM selector, but enough information for VC
    }
    return potentialSelector;
}
function $46766faed9eb6bde$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    var cachedName = $46766faed9eb6bde$var$nameCache.get(element);
    if (cachedName) return cachedName;
    var uniqueSelector = $46766faed9eb6bde$var$getUniqueSelector(selectorConfig, element);
    $46766faed9eb6bde$var$nameCache.set(element, uniqueSelector);
    return uniqueSelector;
}
var $46766faed9eb6bde$export$2e2bcd8739ae039 = $46766faed9eb6bde$var$getElementName;


function $798370df6f46e013$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $798370df6f46e013$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $798370df6f46e013$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $798370df6f46e013$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $798370df6f46e013$var$DEFAULT_SELECTOR_CONFIG = {
    id: true,
    testId: true,
    role: true,
    className: true
};
function $798370df6f46e013$var$resolveSelectorConfig() {
    var _getSelectorConfig;
    return (_getSelectorConfig = (0, $DtLwq.getSelectorConfig)()) !== null && _getSelectorConfig !== void 0 ? _getSelectorConfig : $798370df6f46e013$var$DEFAULT_SELECTOR_CONFIG;
}
function $798370df6f46e013$var$getTestIdName(memoizedProps) {
    if (memoizedProps['data-testid']) return "[data-testid=".concat(memoizedProps['data-testid'], "]");
    else if (memoizedProps['data-test-id']) return "[data-test-id=".concat(memoizedProps['data-testid'], "]");
    else if (memoizedProps['data-vc']) return "[data-vc=".concat(memoizedProps['data-vc'], "]");
    return null;
}
function $798370df6f46e013$var$getUFOSegmentName(componentName, memoizedProps) {
    if (memoizedProps && memoizedProps['name']) return "UFOSegment[name=".concat(memoizedProps['name'], "]");
    return componentName;
}
function $798370df6f46e013$var$getReactComponentHierarchy(element) {
    var componentHierarchy = [];
    function traverseFiber(fiber) {
        var currentFiber = fiber;
        while(currentFiber){
            if (currentFiber.type) {
                var componentName = currentFiber.type.displayName || currentFiber.type.name;
                if (componentName && componentName.length > 2 && !componentName.includes('Listener') && !componentName.includes('Provider')) {
                    if (componentName === 'UFOSegment') {
                        componentHierarchy.push($798370df6f46e013$var$getUFOSegmentName(componentName, currentFiber.memoizedProps));
                        break;
                    }
                    componentHierarchy.push(componentName);
                }
            }
            if (currentFiber.memoizedProps) {
                var dataIdInfo = $798370df6f46e013$var$getTestIdName(currentFiber.memoizedProps);
                if (dataIdInfo) {
                    componentHierarchy.push(dataIdInfo);
                    currentFiber = null;
                    continue;
                }
            }
            currentFiber = currentFiber.return;
        }
    }
    var reactFiberKey = Object.keys(element).find(function(key) {
        return key.startsWith('__reactFiber$');
    });
    if (reactFiberKey) {
        var fiber = element[reactFiberKey];
        traverseFiber(fiber);
    }
    return componentHierarchy.reverse().join(' > ');
}
var $798370df6f46e013$export$e6be05b411ce21a6 = function setInteractionPerformanceEvent(entry) {
    var interaction = (0, $iGolp.getActiveInteraction)();
    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') {
        var _interaction$responsi;
        if (!((_interaction$responsi = interaction.responsiveness) !== null && _interaction$responsi !== void 0 && _interaction$responsi.experimentalInputToNextPaint)) {
            var _interaction$responsi2, _interaction$responsi3;
            interaction.responsiveness = $798370df6f46e013$var$_objectSpread($798370df6f46e013$var$_objectSpread({}, interaction.responsiveness), {}, {
                experimentalInputToNextPaint: ((_interaction$responsi2 = interaction.responsiveness) === null || _interaction$responsi2 === void 0 ? void 0 : _interaction$responsi2.experimentalInputToNextPaint) || entry.duration,
                inputDelay: ((_interaction$responsi3 = interaction.responsiveness) === null || _interaction$responsi3 === void 0 ? void 0 : _interaction$responsi3.inputDelay) || entry.processingStart - entry.startTime
            });
            if (interaction.ufoName === 'unknown') {
                if (entry.target) interaction.unknownElementHierarchy = $798370df6f46e013$var$getReactComponentHierarchy(entry.target);
                interaction.unknownElementName = (0, $46766faed9eb6bde$export$2e2bcd8739ae039)($798370df6f46e013$var$resolveSelectorConfig(), entry.target);
            }
        }
    }
};


function $728882f10ff6ab3c$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $728882f10ff6ab3c$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $728882f10ff6ab3c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $728882f10ff6ab3c$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $728882f10ff6ab3c$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $728882f10ff6ab3c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $728882f10ff6ab3c$var$performanceEventObserver;
var $728882f10ff6ab3c$export$17afbba0f16b4b19 = function getPerformanceObserver() {
    $728882f10ff6ab3c$var$performanceEventObserver = $728882f10ff6ab3c$var$performanceEventObserver || new PerformanceObserver(function(entries) {
        var list = entries.getEntries();
        var _iterator = $728882f10ff6ab3c$var$_createForOfIteratorHelper(list), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var entry = _step.value;
                if (entry.name === 'click') (0, $798370df6f46e013$export$e6be05b411ce21a6)(entry);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    });
    return $728882f10ff6ab3c$var$performanceEventObserver;
};



var $1gQdg = parcelRequire("1gQdg");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $5OMCI = parcelRequire("5OMCI");

var $8lACD = parcelRequire("8lACD");

var $iGolp = parcelRequire("iGolp");


var $ekGgq = parcelRequire("ekGgq");
var $a4db086d6d076eae$var$ABORT_ERROR_NAMES = new Set([
    'AbortError'
]);
var $a4db086d6d076eae$var$ABORT_ERROR_MESSAGES = [
    'The operation was aborted',
    'auth_window_closed'
];
// Only treated as abort when combined with AuthError name — the same string
// can appear in other error messages (e.g. 403 response bodies) where it
// should not be classified as abort.
var $a4db086d6d076eae$var$AUTH_ERROR_ABORT_MESSAGES = [
    'access_denied'
];
// AuthError is thrown by @atlaskit/outbound-auth-flow-client during OAuth flows
// (e.g. connecting third-party apps like GitHub or Bitbucket to Jira).
// User-initiated outcomes (closing the popup, denying consent) are classified
// as abort; server/config failures are classified as auth.
var $a4db086d6d076eae$var$AUTH_ERROR_NAMES = new Set([
    'AuthError'
]);
var $a4db086d6d076eae$var$CHUNK_LOAD_ERROR_NAMES = new Set([
    'ChunkLoadError'
]);
var $a4db086d6d076eae$var$CHUNK_LOAD_ERROR_MESSAGES = [
    'Unable to fetch manifest',
    'dynamically imported module',
    'Importing a module script failed'
];
var $a4db086d6d076eae$var$NETWORK_CLIENT_ERROR_NAMES = new Set([
    'NetworkError',
    'Network error'
]);
var $a4db086d6d076eae$var$NETWORK_CLIENT_ERROR_MESSAGES = [
    'Failed to fetch',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'server with the specified hostname could not be found',
    'The network connection was lost',
    'The request timed out',
    'connection failure',
    'CloseEvent: Ping timeout',
    'Curl Error: Failure when receiving data from the peer'
];
var $a4db086d6d076eae$var$NETWORK_SERVER_ERROR_MESSAGES = [
    '... is not valid JSON',
    'in JSON at position 0',
    'JSON.parse: unexpected character',
    'JSON.parse: unexpected end of data',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'cannot parse response',
    'Syntax or http error'
];
function $a4db086d6d076eae$var$matchesCategory(error) {
    var _error$name, _error$message;
    var name = (_error$name = error.name) !== null && _error$name !== void 0 ? _error$name : '';
    var message = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : '';
    if ($a4db086d6d076eae$var$ABORT_ERROR_NAMES.has(name) || $a4db086d6d076eae$var$ABORT_ERROR_MESSAGES.some(function(pattern) {
        return message.includes(pattern);
    }) || // OAuth Abort errors
    $a4db086d6d076eae$var$AUTH_ERROR_NAMES.has(name) && $a4db086d6d076eae$var$AUTH_ERROR_ABORT_MESSAGES.some(function(pattern) {
        return message.includes(pattern);
    })) return 'abort';
    if ($a4db086d6d076eae$var$AUTH_ERROR_NAMES.has(name)) return 'auth';
    if ($a4db086d6d076eae$var$CHUNK_LOAD_ERROR_NAMES.has(name) || $a4db086d6d076eae$var$CHUNK_LOAD_ERROR_MESSAGES.some(function(pattern) {
        return message.includes(pattern);
    })) return 'chunk-load';
    if ($a4db086d6d076eae$var$NETWORK_CLIENT_ERROR_NAMES.has(name) || $a4db086d6d076eae$var$NETWORK_CLIENT_ERROR_MESSAGES.some(function(pattern) {
        return message.includes(pattern);
    })) return 'network-client';
    if ($a4db086d6d076eae$var$NETWORK_SERVER_ERROR_MESSAGES.some(function(pattern) {
        return message.includes(pattern);
    })) return 'network-server';
    return null;
}
function $a4db086d6d076eae$export$17e837b2daecf805(error) {
    var directMatch = $a4db086d6d076eae$var$matchesCategory(error);
    if (directMatch) return directMatch;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(error) === 'object' && error !== null && 'cause' in error && error.cause instanceof Error) {
        var cause = error.cause;
        var causeMatch = $a4db086d6d076eae$var$matchesCategory(cause);
        if (causeMatch) return causeMatch;
    }
    return 'product';
}


function $ccef19756332ee5c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ccef19756332ee5c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ccef19756332ee5c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ccef19756332ee5c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ccef19756332ee5c$var$sinkHandlerFn = function sinkHandlerFn() {};
function $ccef19756332ee5c$export$e5fa3ac6dc44efff(fn) {
    $ccef19756332ee5c$var$sinkHandlerFn = fn;
}
var $ccef19756332ee5c$var$RELAY_NETWORK_ERRORS_NAME = 'RelayNetwork';
var $ccef19756332ee5c$export$1a949ef92fd30eca = function isRelayNetworkError(error) {
    return error.name === $ccef19756332ee5c$var$RELAY_NETWORK_ERRORS_NAME;
};
var $ccef19756332ee5c$var$isErrorObject = function isErrorObject(error) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(error) === 'object' && error !== null;
};
var $ccef19756332ee5c$var$getErrorStatusCode = function getErrorStatusCode(error) {
    if (!$ccef19756332ee5c$var$isErrorObject(error)) return undefined;
    if ($ccef19756332ee5c$export$1a949ef92fd30eca(error)) {
        var _error$source;
        return (_error$source = error.source) === null || _error$source === void 0 || (_error$source = _error$source.errors) === null || _error$source === void 0 || (_error$source = _error$source[0]) === null || _error$source === void 0 || (_error$source = _error$source.extensions) === null || _error$source === void 0 ? void 0 : _error$source.statusCode;
    }
    if ('statusCode' in error && typeof error.statusCode === 'number') return error.statusCode;
    return undefined;
};
var $ccef19756332ee5c$var$getErrorTraceId = function getErrorTraceId(error) {
    return $ccef19756332ee5c$var$isErrorObject(error) && 'traceId' in error && typeof error.traceId === 'string' ? error.traceId : undefined;
};
function $ccef19756332ee5c$export$3e4fb24086cfb97a(error, additionalAttributes, labelStack) {
    var _error$message, _additionalAttributes, _getActiveTrace$trace, _getActiveTrace, _activeInteraction$uf, _activeInteraction$id, _activeInteraction$ty, _PreviousInteractionL, _PreviousInteractionL2, _PreviousInteractionL3, _UFORouteName$current;
    var activeInteraction = (0, $iGolp.getActiveInteraction)();
    var currentTime = performance.now();
    var baseErrorData = {
        errorType: error.name || 'Error',
        errorMessage: ((_error$message = error.message) === null || _error$message === void 0 ? void 0 : _error$message.slice(0, 100)) || 'Unknown error',
        timestamp: currentTime,
        errorCategory: (0, $a4db086d6d076eae$export$17e837b2daecf805)(error)
    };
    var errorData = $ccef19756332ee5c$var$_objectSpread($ccef19756332ee5c$var$_objectSpread({}, baseErrorData), {}, {
        statusCode: (_additionalAttributes = additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.statusCode) !== null && _additionalAttributes !== void 0 ? _additionalAttributes : $ccef19756332ee5c$var$getErrorStatusCode(error),
        // Fallback to traceId from error object if it exists (e.g. FetchError)
        traceId: (_getActiveTrace$trace = (_getActiveTrace = (0, $5OMCI.getActiveTrace)()) === null || _getActiveTrace === void 0 ? void 0 : _getActiveTrace.traceId) !== null && _getActiveTrace$trace !== void 0 ? _getActiveTrace$trace : $ccef19756332ee5c$var$getErrorTraceId(error),
        teamName: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.teamName,
        packageName: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.packageName,
        errorBoundaryId: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.errorBoundaryId,
        errorHash: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.errorHash,
        fallbackType: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.fallbackType
    });
    // Calculate time since previous interaction
    var timeSincePreviousInteraction = (0, $iGolp.PreviousInteractionLog).timestamp != null ? currentTime - (0, $iGolp.PreviousInteractionLog).timestamp : null;
    var context = {
        labelStack: labelStack !== null && labelStack !== void 0 ? labelStack : null,
        activeInteractionName: (_activeInteraction$uf = activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.ufoName) !== null && _activeInteraction$uf !== void 0 ? _activeInteraction$uf : null,
        activeInteractionId: (_activeInteraction$id = activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.id) !== null && _activeInteraction$id !== void 0 ? _activeInteraction$id : null,
        activeInteractionType: (_activeInteraction$ty = activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.type) !== null && _activeInteraction$ty !== void 0 ? _activeInteraction$ty : null,
        previousInteractionId: (_PreviousInteractionL = (0, $iGolp.PreviousInteractionLog).id) !== null && _PreviousInteractionL !== void 0 ? _PreviousInteractionL : null,
        previousInteractionName: (_PreviousInteractionL2 = (0, $iGolp.PreviousInteractionLog).name) !== null && _PreviousInteractionL2 !== void 0 ? _PreviousInteractionL2 : null,
        previousInteractionType: (_PreviousInteractionL3 = (0, $iGolp.PreviousInteractionLog).type) !== null && _PreviousInteractionL3 !== void 0 ? _PreviousInteractionL3 : null,
        timeSincePreviousInteraction: timeSincePreviousInteraction,
        routeName: (_UFORouteName$current = (0, $502a1d7bcb430ca7$export$2e2bcd8739ae039).current) !== null && _UFORouteName$current !== void 0 ? _UFORouteName$current : null
    };
    $ccef19756332ee5c$var$sinkHandlerFn(errorData, context);
}
function $ccef19756332ee5c$export$79ee0f0d40355053(error, additionalAttributes) {
    var interactionContext = (0, $8lACD.useInteractionContext)();
    var hasReportedRef = (0, $5FkrB.useRef)(false);
    (0, $5FkrB.useEffect)(function() {
        if (error && !hasReportedRef.current) {
            hasReportedRef.current = true;
            $ccef19756332ee5c$export$3e4fb24086cfb97a(error, additionalAttributes, interactionContext === null || interactionContext === void 0 ? void 0 : interactionContext.labelStack);
        }
    }, [
        error,
        additionalAttributes,
        interactionContext === null || interactionContext === void 0 ? void 0 : interactionContext.labelStack
    ]);
}



var $3hvsM = parcelRequire("3hvsM");

var $50U6m = parcelRequire("50U6m");
function $20510629fa7f7e26$var$scheduleIdleCallback(work) {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function' && (0, $50U6m.fg)('ufo_payload_use_idle_callback')) window.requestIdleCallback(work);
    else (0, $3hvsM.unstable_scheduleCallback)((0, $3hvsM.unstable_IdlePriority), work);
}
var $20510629fa7f7e26$export$2e2bcd8739ae039 = $20510629fa7f7e26$var$scheduleIdleCallback;


var $b5d959f5f0c4d4a3$var$initialized = false;
function $b5d959f5f0c4d4a3$var$sinkInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createPayloads(interactionId, interaction).then(function(payloads) {
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                var devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads === null || payloads === void 0 || payloads.forEach(function(payload) {
                    if (typeof devToolObserver === 'function') devToolObserver === null || devToolObserver === void 0 || devToolObserver(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch(function(error) {
                throw error;
            });
        }
        (0, $20510629fa7f7e26$export$2e2bcd8739ae039)(onIdle);
    }
    (0, $iGolp.sinkInteractionHandler)(sinkFn);
}
function $b5d959f5f0c4d4a3$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, $iGolp.sinkPostInteractionLogHandler)(function(logOutput) {
        (0, $20510629fa7f7e26$export$2e2bcd8739ae039)(function() {
            var payload = createPostInteractionLogPayload(logOutput);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $b5d959f5f0c4d4a3$var$sinkTerminalErrors(instance, createTerminalErrorPayload) {
    (0, $ccef19756332ee5c$export$e5fa3ac6dc44efff)(function(errorData, context) {
        (0, $20510629fa7f7e26$export$2e2bcd8739ae039)(function() {
            var payload = createTerminalErrorPayload(errorData, context);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $b5d959f5f0c4d4a3$var$sinkExtraSearchPageInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createExtraSearchPageInteractionPayload(interactionId, interaction).then(function(payloads) {
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                var devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads === null || payloads === void 0 || payloads.forEach(function(payload) {
                    if (typeof devToolObserver === 'function') devToolObserver === null || devToolObserver === void 0 || devToolObserver(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch(function(error) {
                throw error;
            });
        }
        (0, $20510629fa7f7e26$export$2e2bcd8739ae039)(onIdle);
    }
    (0, $fa8ce7524d09ef6a$export$e6a07a94f3e112d4)(sinkFn);
}




function $b5d959f5f0c4d4a3$export$2cd8252107eb640b(analyticsWebClientAsync, config) {
    var _config$vc;
    if ($b5d959f5f0c4d4a3$var$initialized) return;
    // Always set config first so isUFOEnabled() can check config.enabled
    (0, $DtLwq.setUFOConfig)(config);
    // If UFO is disabled via config, skip all initialization
    if (!(0, $DtLwq.isUFOEnabled)()) {
        $b5d959f5f0c4d4a3$var$initialized = true;
        return;
    }
    // Initialize pressure observer for CPU usage monitoring
    (0, $1gQdg.initialisePressureObserver)();
    (0, $1gQdg.initialiseMemoryObserver)();
    if ((0, $50U6m.fg)('platform_ufo_enable_otel_context_manager')) {
        // Configure global OTel context manager
        var contextManager = new (0, $b49n7.UFOContextManager)();
        // set the contextmanager somewhere we can reference it later
        (0, $b49n7.setContextManager)(contextManager);
        // Register the context manager with the global OTel API
        contextManager.enable();
        (0, $kuxjd.context).setGlobalContextManager(contextManager);
    }
    if ((_config$vc = config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled) {
        var vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, $DtLwq.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders
        };
        (0, $iGolp.postInteractionLog).initializeVCObserver(vcOptions);
    }
    (0, $h9fNq.setupHiddenTimingCapture)();
    (0, $c8ab0fbe311e6ffe$export$5ecf2aafafee3e0)();
    (0, $h9fNq.setupThrottleDetection)();
    $b5d959f5f0c4d4a3$var$initialized = true;
    if (typeof PerformanceObserver !== 'undefined') {
        var observer = (0, $728882f10ff6ab3c$export$17afbba0f16b4b19)();
        observer.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 16
        });
    }
    Promise.all([
        analyticsWebClientAsync,
        (parcelRequire("jFDZt")),
        (parcelRequire("kPRfH")),
        (parcelRequire("gyFaN")),
        (parcelRequire("2HSTn"))
    ]).then(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 5), awc = _ref2[0], payloadPackage = _ref2[1], extraPayloadPackage = _ref2[2], createPostInteractionLogPayloadPackage = _ref2[3], createTerminalErrorPayloadPackage = _ref2[4];
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then(function(client) {
            var _config$terminalError, _config$postInteracti, _config$extraSearchPa;
            var instance = client.getInstance();
            $b5d959f5f0c4d4a3$var$sinkInteraction(instance, payloadPackage);
            if (config !== null && config !== void 0 && (_config$terminalError = config.terminalErrors) !== null && _config$terminalError !== void 0 && _config$terminalError.enabled) $b5d959f5f0c4d4a3$var$sinkTerminalErrors(instance, createTerminalErrorPayloadPackage.default);
            if ((_config$postInteracti = config.postInteractionLog) !== null && _config$postInteracti !== void 0 && _config$postInteracti.enabled) $b5d959f5f0c4d4a3$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$extraSearchPa = config.extraSearchPageInteraction) !== null && _config$extraSearchPa !== void 0 && _config$extraSearchPa.enabled) $b5d959f5f0c4d4a3$var$sinkExtraSearchPageInteraction(instance, extraPayloadPackage);
        });
        else if (awc.sendOperationalEvent) {
            var _config$terminalError2, _config$postInteracti2, _config$extraSearchPa2;
            $b5d959f5f0c4d4a3$var$sinkInteraction(awc, payloadPackage);
            if (config !== null && config !== void 0 && (_config$terminalError2 = config.terminalErrors) !== null && _config$terminalError2 !== void 0 && _config$terminalError2.enabled) $b5d959f5f0c4d4a3$var$sinkTerminalErrors(awc, createTerminalErrorPayloadPackage.default);
            if ((_config$postInteracti2 = config.postInteractionLog) !== null && _config$postInteracti2 !== void 0 && _config$postInteracti2.enabled) $b5d959f5f0c4d4a3$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$extraSearchPa2 = config.extraSearchPageInteraction) !== null && _config$extraSearchPa2 !== void 0 && _config$extraSearchPa2.enabled) $b5d959f5f0c4d4a3$var$sinkExtraSearchPageInteraction(awc, extraPayloadPackage);
        }
    });
}



const $41268bd829e2a570$export$af995ee1d7017fea = ()=>{
    const analyticsClientPromise = Promise.resolve({
        getAnalyticsWebClientPromise: ()=>Promise.resolve({
                getInstance: ()=>(0, $45964660615f0a60$export$e9ba7ef9458d1a4a)()
            })
    });
    (0, $b5d959f5f0c4d4a3$export$2cd8252107eb640b)(analyticsClientPromise, {
        // 'learning' is the registered UFO product name for the community platform
        // that hosts App Updates. Glance experience IDs will be:
        //   learning.fe.page-load.ufo-app-updates
        //   learning.fe.page-load.ufo-app-updates-details
        product: 'learning',
        // region is the geographic deployment region (not environment).
        // Defaults to 'us-east-1' — the primary Atlassian region.
        region: undefined ?? 'us-east-1',
        vc: {
            enabled: true,
            heatmapSize: 200,
            oldDomUpdates: false,
            devToolsEnabled: true,
            enabledVCRevisions: {
                all: [
                    'fy25.02',
                    'fy25.03'
                ]
            },
            // Account for possible UGC/PII in DOM attributes:
            // id: false — element IDs may contain user-generated content (e.g. update IDs)
            selectorConfig: {
                id: false,
                role: true,
                className: true,
                testId: true
            }
        },
        // Prefix aligns experience keys with the platform naming convention
        // used by Performance Portal (e.g. 'ufo-app-updates').
        namePrefix: 'ufo-',
        // Only track page_load, transition and press interactions.
        kind: {
            page_load: 1,
            transition: 1,
            hover: 0,
            legacy: 0,
            typing: 0,
            press: 1
        }
    });
};


var $5FkrB = parcelRequire("5FkrB");
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Preserves the existing UUID implementation.

var $6JfQX = parcelRequire("6JfQX");

var $4iVTn = parcelRequire("4iVTn");

var $DtLwq = parcelRequire("DtLwq");

var $5OMCI = parcelRequire("5OMCI");

var $6aILb = parcelRequire("6aILb");

var $iGolp = parcelRequire("iGolp");


var $f66e8cd8df206c10$export$8851ca06c4e629aa = 'awaiting_pageload_name';
function $f66e8cd8df206c10$var$traceUFOPageLoad(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    if (!(0, $DtLwq.isUFOEnabled)()) return;
    var activeInteraction = (0, $iGolp.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, $502a1d7bcb430ca7$export$2e2bcd8739ae039).current = routeName || null;
    var rate = ufoName ? (0, $DtLwq.getInteractionRate)(ufoName, 'page_load') : 1;
    var enabledBySamplingRate = (0, $4iVTn.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        var newId = (0, $6JfQX.default)();
        (0, $6aILb.default).current = newId;
        (0, $iGolp.addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, $5OMCI.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $iGolp.addHoldByID)(newId, [], $f66e8cd8df206c10$export$8851ca06c4e629aa, $f66e8cd8df206c10$export$8851ca06c4e629aa, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $iGolp.abort)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, $iGolp.updatePageLoadInteractionName)(ufoName, routeName);
        (0, $iGolp.removeHoldByID)(activeInteraction.id, $f66e8cd8df206c10$export$8851ca06c4e629aa);
    }
}
var $f66e8cd8df206c10$export$2e2bcd8739ae039 = $f66e8cd8df206c10$var$traceUFOPageLoad;


// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Preserves the existing UUID implementation.

var $6JfQX = parcelRequire("6JfQX");

var $4iVTn = parcelRequire("4iVTn");

var $DtLwq = parcelRequire("DtLwq");

var $5OMCI = parcelRequire("5OMCI");

var $6aILb = parcelRequire("6aILb");

var $iGolp = parcelRequire("iGolp");


function $19b4a06296635e75$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), function() {
        return Math.floor(Math.random() * 16).toString(16);
    }).join('');
}


function $35cd9ec52fa2080b$export$f2e521e495a88544(newId) {
    (0, $2851c68052d6553a$export$a1002be327997103)(newId.replace(/-/g, ''), (0, $19b4a06296635e75$export$295213bc4d0c54ad)(), 'transition');
}


function $ac2d8686bb191ca9$var$traceUFOTransition(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    var preloadKey = arguments.length > 2 ? arguments[2] : undefined;
    if (!(0, $DtLwq.isUFOEnabled)()) return;
    var pressInteractionsList = (0, $DtLwq.getDoNotAbortActivePressInteractionOnTransition)();
    var interaction = (0, $iGolp.getActiveInteraction)();
    if (pressInteractionsList && interaction) {
        if (pressInteractionsList.includes(interaction.ufoName)) return;
    }
    (0, $iGolp.abortAll)('transition', ufoName !== null && ufoName !== void 0 ? ufoName : undefined);
    if (ufoName) {
        (0, $502a1d7bcb430ca7$export$2e2bcd8739ae039).current = ufoName;
        var rate = (0, $DtLwq.getInteractionRate)(ufoName, 'transition');
        if ((0, $4iVTn.default)(rate)) {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            var newId = (0, $6JfQX.default)();
            (0, $35cd9ec52fa2080b$export$f2e521e495a88544)(newId);
            (0, $6aILb.default).current = newId;
            (0, $iGolp.addNewInteraction)(newId, ufoName, 'transition', performance.now(), rate, null, routeName, (0, $5OMCI.getActiveTrace)(), preloadKey);
        }
    }
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$ac2d8686bb191ca9$export$2e2bcd8739ae039 = $ac2d8686bb191ca9$var$traceUFOTransition;



var $iGolp = parcelRequire("iGolp");


const $53db48ba8bac8e3a$export$c1a838a491a42b2 = (routeContext)=>{
    const { analyticsOptOut: analyticsOptOut } = (0, $38056d680fac42ff$export$b224af886b957a5e)();
    (0, $5FkrB.useEffect)(()=>{
        if (analyticsOptOut || !routeContext.route) return;
        const experienceName = routeContext.route.name.toLowerCase();
        // Decide from UFO's live state, not routeContext.action.
        const activeInteraction = (0, $iGolp.getActiveInteraction)();
        let decision;
        if (!activeInteraction) {
            decision = 'page_load';
            (0, $f66e8cd8df206c10$export$2e2bcd8739ae039)(experienceName);
        } else {
            decision = 'transition';
            (0, $ac2d8686bb191ca9$export$2e2bcd8739ae039)(experienceName);
        }
        // TEMPORARY DEBUG: breadcrumb what we reported vs. the actual navigation
        // target so we can confirm behaviour in prod. Remove once verified.
        // eslint-disable-next-line no-restricted-syntax
        (0, $033860fe7bfd25af$exports).addBreadcrumb({
            category: 'ufo-watcher',
            level: 'info',
            message: `ufo-watcher: ${decision} -> ${experienceName}`,
            data: {
                experienceName: experienceName,
                decision: decision,
                locationPathname: routeContext.location?.pathname ?? null,
                matchedRoutePath: routeContext.route?.path ?? null,
                routeName: routeContext.route?.name ?? null,
                routerAction: routeContext.action,
                activeInteractionType: activeInteraction?.type ?? null,
                activeInteractionName: activeInteraction?.ufoName ?? null
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        routeContext.route,
        routeContext.action,
        analyticsOptOut
    ]);
};



var $5FkrB = parcelRequire("5FkrB");


const $93ef5b82f3a99b71$export$f1f8325c2f4f8721 = ()=>{
    const { analyticsOptOut: analyticsOptOut } = (0, $38056d680fac42ff$export$b224af886b957a5e)();
    (0, $5FkrB.useEffect)(()=>{
        if (analyticsOptOut) return;
        (0, $15b90d5900f709a5$export$504fbc0ef5c94afa)();
    }, [
        analyticsOptOut
    ]);
};


// Initialize Sentry for error tracking
(0, $9654b596cdf679bc$export$f5ae3c4820871661)();
// Initialize UFO performance monitoring
(0, $41268bd829e2a570$export$af995ee1d7017fea)();
// Release tracks routes must precede the dynamic ':id' route so they aren't
// matched as release note ids.
const $6c337d21896291b4$var$appRoutes = [
    (0, $822a62c8758b6be8$export$352552ab999c9092),
    (0, $822a62c8758b6be8$export$3ad0ba51c296adcf),
    (0, $822a62c8758b6be8$export$77c38a6734b02710),
    (0, $822a62c8758b6be8$export$527547b9491d1b85)
];
// TODO: keeping for now, will remove once OneTrust is done
// console.log(process.env.REACT_APP_ONETRUST_SCRIPT_DOMAIN);
const $6c337d21896291b4$var$fullHeightStyles = (0, $gDiFE.xcss)({
    height: '100vh'
});
// Preserves the old page-layout Content slot behavior without its deprecated layout dependency.
const $6c337d21896291b4$var$contentStyles = (0, $gDiFE.xcss)({
    display: 'flex',
    height: '100%',
    position: 'relative'
});
const $6c337d21896291b4$var$mainStyles = (0, $gDiFE.xcss)({
    display: 'flex',
    flexDirection: 'column',
    // @ts-ignore - need to fix styles
    gap: '112px',
    margin: '0 auto',
    width: '1232px',
    '@media (max-width: 1279px)': {
        gap: '72px',
        width: '100%',
        paddingInline: 'space.300'
    },
    '@media (max-width: 767px)': {
        gap: '64px',
        width: '100%',
        paddingInline: 'space.200'
    }
});
const $6c337d21896291b4$var$AppContents = ()=>{
    (0, $ffae71f140f0c685$export$1d39dc5b47e56ff0)();
    const { state: state } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const [routerState] = (0, $b421c015f5018cd0$export$9a302a45f65d0572)();
    // Trigger a one-time, self-throttled prune of the unread read set on app load.
    (0, $93ef5b82f3a99b71$export$f1f8325c2f4f8721)();
    // Central UFO watcher — tracks page-load on initial load and transitions on
    // subsequent route changes. Called here (inside <Router>) so useRouter() works.
    // Individual pages should use <UFOSegment> and <UFOLoadHold> only.
    (0, $53db48ba8bac8e3a$export$c1a838a491a42b2)(routerState);
    const { isLoggedIn: isLoggedIn, loggedInUser: loggedInUser } = state;
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $faf30355a80342e4$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $12fc361ebcaf5b04$export$3151da8f6716d1a2), {
                isLoggedIn: isLoggedIn,
                loggedInUser: loggedInUser
            }),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("div", {
                id: "core-root",
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                    xcss: $6c337d21896291b4$var$contentStyles,
                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4Pn6z.Box), {
                        xcss: $6c337d21896291b4$var$mainStyles,
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $56c1ff970910c658$export$7903e4b73fc7d6c3), {})
                    })
                })
            }),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("footer", {
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $6cf738ba21080f36$export$a06f1c675e846f6f), {
                    isLoggedIn: isLoggedIn,
                    loggedInUser: loggedInUser
                })
            })
        ]
    });
};
const $6c337d21896291b4$export$86fbec116b87613f = ()=>{
    const history = (0, $5FkrB.useMemo)(()=>(0, $c29d101a2cf08ade$export$719fc203c4e16dee)(), []);
    const isFeatureGatesReady = (0, $8efc6877f826f30c$export$565f843eab5aeb55)();
    const { user: user } = (0, $f6c3dce408db50e2$export$87c54b525b914dab)();
    // Wait for Statsig to finish initializing before evaluating gates.
    // Without this guard, checkGate() returns false during async init,
    // which would incorrectly redirect users away from /release-notes.
    if (!isFeatureGatesReady) return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $2kuK2.Flex), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $6c337d21896291b4$var$fullHeightStyles,
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9ztDu.default), {
            size: "large",
            interactionName: "feature-gates-initializing"
        })
    });
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $1ec054bf15c60dc8$export$2e2bcd8739ae039), {
        locale: (0, $9bc4aff2ff299440$export$d7f512c98c859244),
        messages: (0, (/*@__PURE__*/$parcel$interopDefault($eeccb061c66729e2$exports))),
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4933e76bd0ca959e$export$5d107a7783183624), {
            api: (0, $20b06ac8b5e61eaa$export$644d8ea042df96a6),
            initialState: {
                user: user
            },
            children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $a0fe68b284b4365c$export$45604f0cc8ae667b), {
                client: (0, $20b06ac8b5e61eaa$export$7c07b633a151f9c5),
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ddc1dbf2b1f7581e$export$55185c17a0fcbe46), {
                    routes: $6c337d21896291b4$var$appRoutes,
                    history: history,
                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($6c337d21896291b4$var$AppContents, {})
                })
            })
        })
    });
};









const $c4c47b0e78c26f17$var$THEME_CONFIG = {
    colorMode: 'light',
    light: 'light',
    dark: 'dark',
    spacing: 'spacing'
};
// Load and inject theme styles
(0, $9e4e6a70439714f4$export$a3fc04b8551e006a)($c4c47b0e78c26f17$var$THEME_CONFIG).then((themeStyles)=>{
    themeStyles.forEach(({ css: css, attrs: attrs })=>{
        const style = document.createElement('style');
        style.textContent = css;
        Object.entries(attrs).forEach(([key, value])=>{
            style.setAttribute(key, value);
        });
        document.head.appendChild(style);
    });
});
// Initialize global theme for runtime theme switching
(0, $f17f0f6b501ed4b1$export$b11e9bebbf62b20e)($c4c47b0e78c26f17$var$THEME_CONFIG);
const $c4c47b0e78c26f17$var$container = document.getElementById('root');
if ($c4c47b0e78c26f17$var$container) {
    const root = (0, $cITiu.createRoot)($c4c47b0e78c26f17$var$container);
    root.render(/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $38056d680fac42ff$export$52310512b1bd7aec), {
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $8c48fdd8d5a3abf9$export$4719288a8f5f7e71), {
            children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $f6c3dce408db50e2$export$88f24fd8fcfab6ca), {
                api: (0, $20b06ac8b5e61eaa$export$644d8ea042df96a6),
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $8efc6877f826f30c$export$d9e6d91f1f7e3282), {
                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $6c337d21896291b4$export$86fbec116b87613f), {})
                })
            })
        })
    }));
}


//# sourceMappingURL=index.5fa6bb0a.js.map
